
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4a60"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4a60"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6G2cC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4dc85fad6be49d6b$export$2e2bcd8739ae039);
parcelRequire("giao7");
var $4mYx6 = parcelRequire("4mYx6");
var $9K9BQ = parcelRequire("9K9BQ");

var $4rgor = parcelRequire("4rgor");

var $hOC41 = parcelRequire("hOC41");

var $lskpI = parcelRequire("lskpI");

var $hL1qx = parcelRequire("hL1qx");

var $32U48 = parcelRequire("32U48");

var $71wOy = parcelRequire("71wOy");

var $88SvS = parcelRequire("88SvS");

var $3EL52 = parcelRequire("3EL52");

var $9PMCX = parcelRequire("9PMCX");

var $gP4YB = parcelRequire("gP4YB");

var $aif9a = parcelRequire("aif9a");

var $aCMDZ = parcelRequire("aCMDZ");

var $4srbL = parcelRequire("4srbL");
var $4dc85fad6be49d6b$export$2e2bcd8739ae039 = {
    __name: "App",
    setup (__props, { expose: __expose }) {
        __expose();
        const notifications = new (0, $hL1qx.default)();
        (0, $4mYx6.provide)("notifications", notifications);
        const isAddSeriesBoxVisible = (0, $9K9BQ.ref)(true);
        const updateAddSeriesBoxVisibility = (value)=>{
            console.log("Update add series box visibility to", value);
            isAddSeriesBoxVisible.value = value;
        };
        const fileURLs = (0, $9K9BQ.reactive)((0, $4srbL.default)("file-url"));
        // If there's an file passed through the URL, hide the add series box
        if (fileURLs.length) isAddSeriesBoxVisible.value = false;
        const handleFileURLAdded = (url)=>{
            updateAddSeriesBoxVisibility(false);
            fileURLs.push(url);
        };
        const fromDate = (0, $9K9BQ.ref)((0, $4srbL.default)("from"));
        const toDate = (0, $9K9BQ.ref)((0, $4srbL.default)("to"));
        // Updates model from URL
        const updateDatesFromURL = ()=>{
            toDate.value = (0, $4srbL.default)("to")[0] ?? null;
            fromDate.value = (0, $4srbL.default)("from")[0] ?? null;
        };
        const updateDate = (type, value)=>{
            // Propagate values to URL
            (0, $aCMDZ.default)(type, value, true);
            // Then update values from URL (DRY; we need this function in other places as well)
            updateDatesFromURL();
        };
        const handleUpdateToDate = (value)=>updateDate("to", value);
        const handleUpdateFromDate = (value)=>updateDate("from", value);
        const timeSeriesCollection = new (0, $4rgor.default)({
            fromDateReference: fromDate,
            toDateReference: toDate
        });
        const currentModalContent = (0, $9K9BQ.ref)(null);
        const setModalContent = (content)=>{
            console.log("close");
            currentModalContent.value = content;
        };
        // Update date values when a user navigates back/forward
        window.addEventListener("popstate", updateDatesFromURL);
        // Update date values on looad
        updateDatesFromURL();
        const __returned__ = {
            notifications: notifications,
            isAddSeriesBoxVisible: isAddSeriesBoxVisible,
            updateAddSeriesBoxVisibility: updateAddSeriesBoxVisibility,
            fileURLs: fileURLs,
            handleFileURLAdded: handleFileURLAdded,
            fromDate: fromDate,
            toDate: toDate,
            updateDatesFromURL: updateDatesFromURL,
            updateDate: updateDate,
            handleUpdateToDate: handleUpdateToDate,
            handleUpdateFromDate: handleUpdateFromDate,
            timeSeriesCollection: timeSeriesCollection,
            currentModalContent: currentModalContent,
            setModalContent: setModalContent,
            provide: $4mYx6.provide,
            ref: $9K9BQ.ref,
            reactive: $9K9BQ.reactive,
            get TimeSeriesCollection () {
                return 0, $4rgor.default;
            },
            Notifications: $hOC41.default,
            Disclaimer: $lskpI.default,
            get NotificationCollection () {
                return 0, $hL1qx.default;
            },
            AddSeriesBox: $32U48.default,
            FileDropHandler: $71wOy.default,
            HeatMap: $88SvS.default,
            DataFetcher: $3EL52.default,
            TimeSeriesList: $9PMCX.default,
            PerformanceChart: $gP4YB.default,
            PerformanceTable: $aif9a.default,
            get modifySearchParams () {
                return 0, $aCMDZ.default;
            },
            get readSearchParams () {
                return 0, $4srbL.default;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("giao7", function(module, exports) {
$parcel$export(module.exports, "computed", () => (parcelRequire("4mYx6")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("4mYx6")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("4mYx6")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("4mYx6")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("4mYx6")).createElementVNode);
$parcel$export(module.exports, "createStaticVNode", () => (parcelRequire("4mYx6")).createStaticVNode);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("4mYx6")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("4mYx6")).createVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("4mYx6")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("4mYx6")).Fragment);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("4mYx6")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("4mYx6")).inject);
$parcel$export(module.exports, "mergeProps", () => (parcelRequire("4mYx6")).mergeProps);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("a5gC8")).normalizeClass);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("4mYx6")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("4mYx6")).provide);
$parcel$export(module.exports, "reactive", () => (parcelRequire("9K9BQ")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("9K9BQ")).ref);
$parcel$export(module.exports, "registerRuntimeCompiler", () => (parcelRequire("4mYx6")).registerRuntimeCompiler);
$parcel$export(module.exports, "renderList", () => (parcelRequire("4mYx6")).renderList);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("4mYx6")).renderSlot);
$parcel$export(module.exports, "warn", () => (parcelRequire("4mYx6")).warn);
$parcel$export(module.exports, "watch", () => (parcelRequire("4mYx6")).watch);
$parcel$export(module.exports, "watchEffect", () => (parcelRequire("4mYx6")).watchEffect);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("4mYx6")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("4mYx6")).withDirectives);
$parcel$export(module.exports, "createApp", () => (parcelRequire("5on3n")).createApp);
$parcel$export(module.exports, "vModelCheckbox", () => (parcelRequire("5on3n")).vModelCheckbox);
$parcel$export(module.exports, "vModelSelect", () => (parcelRequire("5on3n")).vModelSelect);
$parcel$export(module.exports, "withModifiers", () => (parcelRequire("5on3n")).withModifiers);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("a5gC8")).toDisplayString);
$parcel$export(module.exports, "unref", () => (parcelRequire("9K9BQ")).unref);
/**
* vue v3.5.12
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $4mYx6 = parcelRequire("4mYx6");parcelRequire("5on3n");parcelRequire("a5gC8");parcelRequire("9K9BQ");

var $dFjgj = parcelRequire("dFjgj");

var $a5gC8 = parcelRequire("a5gC8");
function $bdc6629bf676a2f9$var$initDev() {
    (0, $4mYx6.initCustomFormatter)();
}
const $bdc6629bf676a2f9$var$compileCache = /* @__PURE__ */ Object.create(null);
function $bdc6629bf676a2f9$export$ef7acd7185315e22(template, options) {
    if (!(0, $a5gC8.isString)(template)) {
        if (template.nodeType) template = template.innerHTML;
        else return 0, $a5gC8.NOOP;
    }
    const key = (0, $a5gC8.genCacheKey)(template, options);
    const cached = $bdc6629bf676a2f9$var$compileCache[key];
    if (cached) return cached;
    if (template[0] === "#") {
        const el = document.querySelector(template);
        template = el ? el.innerHTML : ``;
    }
    const opts = (0, $a5gC8.extend)({
        hoistStatic: true,
        onError: void 0,
        onWarn: (0, $a5gC8.NOOP)
    }, options);
    if (!opts.isCustomElement && typeof customElements !== "undefined") opts.isCustomElement = (tag)=>!!customElements.get(tag);
    const { code: code } = (0, $dFjgj.compile)(template, opts);
    function onError(err, asWarning = false) {
        const message = asWarning ? err.message : `Template compilation error: ${err.message}`;
        const codeFrame = err.loc && (0, $a5gC8.generateCodeFrame)(template, err.loc.start.offset, err.loc.end.offset);
        (0, $4mYx6.warn)(codeFrame ? `${message}
${codeFrame}` : message);
    }
    const render = new Function("Vue", code)($bdc6629bf676a2f9$import$4f81359071792c76);
    render._rc = true;
    return $bdc6629bf676a2f9$var$compileCache[key] = render;
}
(0, $4mYx6.registerRuntimeCompiler)($bdc6629bf676a2f9$export$ef7acd7185315e22);

});
parcelRegister("4mYx6", function(module, exports) {

$parcel$export(module.exports, "callWithAsyncErrorHandling", () => $32e82c0f34a0cb76$export$dae85862a8d94378);
$parcel$export(module.exports, "nextTick", () => $32e82c0f34a0cb76$export$bdd553fddd433dcb);
$parcel$export(module.exports, "Fragment", () => $32e82c0f34a0cb76$export$ffb0004e005737fa);
$parcel$export(module.exports, "Static", () => $32e82c0f34a0cb76$export$c1b9a1d3af45b7b6);
$parcel$export(module.exports, "withCtx", () => $32e82c0f34a0cb76$export$694b237e827a3d23);
$parcel$export(module.exports, "withDirectives", () => $32e82c0f34a0cb76$export$49729353e7c1e6c5);
$parcel$export(module.exports, "useTransitionState", () => $32e82c0f34a0cb76$export$d2a0a1bc267c90f6);
$parcel$export(module.exports, "onMounted", () => $32e82c0f34a0cb76$export$6d1641039221b5cb);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => $32e82c0f34a0cb76$export$b876c99684f8cf3b);
$parcel$export(module.exports, "getCurrentInstance", () => $32e82c0f34a0cb76$export$f13e630aa3915748);
$parcel$export(module.exports, "getTransitionRawChildren", () => $32e82c0f34a0cb76$export$a67f9b1229c7c97a);
$parcel$export(module.exports, "resolveTransitionHooks", () => $32e82c0f34a0cb76$export$76ac1779589cd824);
$parcel$export(module.exports, "setTransitionHooks", () => $32e82c0f34a0cb76$export$7770a22486565649);
$parcel$export(module.exports, "BaseTransition", () => $32e82c0f34a0cb76$export$abd95b5f5e8a8837);
$parcel$export(module.exports, "defineComponent", () => $32e82c0f34a0cb76$export$afa64b67e5a01c3b);
$parcel$export(module.exports, "createVNode", () => $32e82c0f34a0cb76$export$bf5c4cf060303d58);
$parcel$export(module.exports, "createTextVNode", () => $32e82c0f34a0cb76$export$22f9b5ffd89dac9);
$parcel$export(module.exports, "watch", () => $32e82c0f34a0cb76$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "onUpdated", () => $32e82c0f34a0cb76$export$5876c47052fb88b1);
$parcel$export(module.exports, "onUnmounted", () => $32e82c0f34a0cb76$export$13348a43ccacfe58);
$parcel$export(module.exports, "onBeforeMount", () => $32e82c0f34a0cb76$export$23b7aeb0d671f804);
$parcel$export(module.exports, "renderList", () => $32e82c0f34a0cb76$export$4bf387f59bfc6d67);
$parcel$export(module.exports, "renderSlot", () => $32e82c0f34a0cb76$export$4abee4c34694ada1);
$parcel$export(module.exports, "openBlock", () => $32e82c0f34a0cb76$export$e7eaa45e502fe5cc);
$parcel$export(module.exports, "createBlock", () => $32e82c0f34a0cb76$export$9f2dfe8048dfb22b);
$parcel$export(module.exports, "computed", () => $32e82c0f34a0cb76$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "provide", () => $32e82c0f34a0cb76$export$abe1e183e22e10ad);
$parcel$export(module.exports, "inject", () => $32e82c0f34a0cb76$export$a976684a0efeb93f);
$parcel$export(module.exports, "createRenderer", () => $32e82c0f34a0cb76$export$53ae2f996c64e9a);
$parcel$export(module.exports, "createHydrationRenderer", () => $32e82c0f34a0cb76$export$200524cf0d997ff0);
$parcel$export(module.exports, "watchEffect", () => $32e82c0f34a0cb76$export$ede35fc0e5500309);
$parcel$export(module.exports, "watchPostEffect", () => $32e82c0f34a0cb76$export$b7f27ea67102d543);
$parcel$export(module.exports, "createElementBlock", () => $32e82c0f34a0cb76$export$167055419fc69ec1);
$parcel$export(module.exports, "createElementVNode", () => $32e82c0f34a0cb76$export$42098e0eaa15c48e);
$parcel$export(module.exports, "mergeProps", () => $32e82c0f34a0cb76$export$9d1611c77c2fe928);
$parcel$export(module.exports, "createStaticVNode", () => $32e82c0f34a0cb76$export$33a9f6dd2840e6bb);
$parcel$export(module.exports, "createCommentVNode", () => $32e82c0f34a0cb76$export$49553837c7236d3c);
$parcel$export(module.exports, "registerRuntimeCompiler", () => $32e82c0f34a0cb76$export$667bb5a67822b941);
$parcel$export(module.exports, "isRuntimeOnly", () => $32e82c0f34a0cb76$export$c93a9c496c5211fa);
$parcel$export(module.exports, "h", () => $32e82c0f34a0cb76$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "initCustomFormatter", () => $32e82c0f34a0cb76$export$aed4979be6a60047);
$parcel$export(module.exports, "warn", () => $32e82c0f34a0cb76$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "reactive", () => (parcelRequire("9K9BQ")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("9K9BQ")).ref);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("9K9BQ")).toRaw);
$parcel$export(module.exports, "camelize", () => (parcelRequire("a5gC8")).camelize);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("a5gC8")).normalizeClass);
/**
* @vue/runtime-core v3.5.12
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $9K9BQ = parcelRequire("9K9BQ");

var $a5gC8 = parcelRequire("a5gC8");
const $32e82c0f34a0cb76$var$stack = [];
function $32e82c0f34a0cb76$var$pushWarningContext(vnode) {
    $32e82c0f34a0cb76$var$stack.push(vnode);
}
function $32e82c0f34a0cb76$var$popWarningContext() {
    $32e82c0f34a0cb76$var$stack.pop();
}
let $32e82c0f34a0cb76$var$isWarning = false;
function $32e82c0f34a0cb76$var$warn$1(msg, ...args) {
    if ($32e82c0f34a0cb76$var$isWarning) return;
    $32e82c0f34a0cb76$var$isWarning = true;
    (0, $9K9BQ.pauseTracking)();
    const instance = $32e82c0f34a0cb76$var$stack.length ? $32e82c0f34a0cb76$var$stack[$32e82c0f34a0cb76$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $32e82c0f34a0cb76$var$getComponentTrace();
    if (appWarnHandler) $32e82c0f34a0cb76$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$32e82c0f34a0cb76$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...$32e82c0f34a0cb76$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $9K9BQ.resetTracking)();
    $32e82c0f34a0cb76$var$isWarning = false;
}
function $32e82c0f34a0cb76$var$getComponentTrace() {
    let currentVNode = $32e82c0f34a0cb76$var$stack[$32e82c0f34a0cb76$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $32e82c0f34a0cb76$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$32e82c0f34a0cb76$var$formatTraceEntry(entry));
    });
    return logs;
}
function $32e82c0f34a0cb76$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$32e82c0f34a0cb76$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$32e82c0f34a0cb76$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $32e82c0f34a0cb76$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$32e82c0f34a0cb76$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $32e82c0f34a0cb76$var$formatProp(key, value, raw) {
    if ((0, $a5gC8.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $9K9BQ.isRef)(value)) {
        value = $32e82c0f34a0cb76$var$formatProp(key, (0, $9K9BQ.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $a5gC8.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $9K9BQ.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function $32e82c0f34a0cb76$export$dfbcecb440255e4a(val, type) {
    return;
}
const $32e82c0f34a0cb76$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER",
    "COMPONENT_UPDATE": 15,
    "15": "COMPONENT_UPDATE",
    "APP_UNMOUNT_CLEANUP": 16,
    "16": "APP_UNMOUNT_CLEANUP"
};
const $32e82c0f34a0cb76$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush",
    [15]: "component update",
    [16]: "app unmount cleanup function"
};
function $32e82c0f34a0cb76$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        $32e82c0f34a0cb76$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $32e82c0f34a0cb76$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $a5gC8.isFunction)(fn)) {
        const res = $32e82c0f34a0cb76$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $a5gC8.isPromise)(res)) res.catch((err)=>{
            $32e82c0f34a0cb76$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $a5gC8.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push($32e82c0f34a0cb76$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $32e82c0f34a0cb76$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    const { errorHandler: errorHandler, throwUnhandledErrorInProduction: throwUnhandledErrorInProduction } = instance && instance.appContext.config || (0, $a5gC8.EMPTY_OBJ);
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        if (errorHandler) {
            (0, $9K9BQ.pauseTracking)();
            $32e82c0f34a0cb76$export$b22fcaf88446e9bf(errorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $9K9BQ.resetTracking)();
            return;
        }
    }
    $32e82c0f34a0cb76$var$logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
function $32e82c0f34a0cb76$var$logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
    if (throwInProd) throw err;
    else console.error(err);
}
const $32e82c0f34a0cb76$var$queue = [];
let $32e82c0f34a0cb76$var$flushIndex = -1;
const $32e82c0f34a0cb76$var$pendingPostFlushCbs = [];
let $32e82c0f34a0cb76$var$activePostFlushCbs = null;
let $32e82c0f34a0cb76$var$postFlushIndex = 0;
const $32e82c0f34a0cb76$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $32e82c0f34a0cb76$var$currentFlushPromise = null;
const $32e82c0f34a0cb76$var$RECURSION_LIMIT = 100;
function $32e82c0f34a0cb76$export$bdd553fddd433dcb(fn) {
    const p = $32e82c0f34a0cb76$var$currentFlushPromise || $32e82c0f34a0cb76$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $32e82c0f34a0cb76$var$findInsertionIndex(id) {
    let start = $32e82c0f34a0cb76$var$flushIndex + 1;
    let end = $32e82c0f34a0cb76$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $32e82c0f34a0cb76$var$queue[middle];
        const middleJobId = $32e82c0f34a0cb76$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.flags & 2) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $32e82c0f34a0cb76$var$queueJob(job) {
    if (!(job.flags & 1)) {
        const jobId = $32e82c0f34a0cb76$var$getId(job);
        const lastJob = $32e82c0f34a0cb76$var$queue[$32e82c0f34a0cb76$var$queue.length - 1];
        if (!lastJob || // fast path when the job id is larger than the tail
        !(job.flags & 2) && jobId >= $32e82c0f34a0cb76$var$getId(lastJob)) $32e82c0f34a0cb76$var$queue.push(job);
        else $32e82c0f34a0cb76$var$queue.splice($32e82c0f34a0cb76$var$findInsertionIndex(jobId), 0, job);
        job.flags |= 1;
        $32e82c0f34a0cb76$var$queueFlush();
    }
}
function $32e82c0f34a0cb76$var$queueFlush() {
    if (!$32e82c0f34a0cb76$var$currentFlushPromise) $32e82c0f34a0cb76$var$currentFlushPromise = $32e82c0f34a0cb76$var$resolvedPromise.then($32e82c0f34a0cb76$var$flushJobs);
}
function $32e82c0f34a0cb76$export$59536a0199721cab(cb) {
    if (!(0, $a5gC8.isArray)(cb)) {
        if ($32e82c0f34a0cb76$var$activePostFlushCbs && cb.id === -1) $32e82c0f34a0cb76$var$activePostFlushCbs.splice($32e82c0f34a0cb76$var$postFlushIndex + 1, 0, cb);
        else if (!(cb.flags & 1)) {
            $32e82c0f34a0cb76$var$pendingPostFlushCbs.push(cb);
            cb.flags |= 1;
        }
    } else $32e82c0f34a0cb76$var$pendingPostFlushCbs.push(...cb);
    $32e82c0f34a0cb76$var$queueFlush();
}
function $32e82c0f34a0cb76$var$flushPreFlushCbs(instance, seen, i = $32e82c0f34a0cb76$var$flushIndex + 1) {
    for(; i < $32e82c0f34a0cb76$var$queue.length; i++){
        const cb = $32e82c0f34a0cb76$var$queue[i];
        if (cb && cb.flags & 2) {
            if (instance && cb.id !== instance.uid) continue;
            $32e82c0f34a0cb76$var$queue.splice(i, 1);
            i--;
            if (cb.flags & 4) cb.flags &= -2;
            cb();
            if (!(cb.flags & 4)) cb.flags &= -2;
        }
    }
}
function $32e82c0f34a0cb76$var$flushPostFlushCbs(seen) {
    if ($32e82c0f34a0cb76$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($32e82c0f34a0cb76$var$pendingPostFlushCbs)
        ].sort((a, b)=>$32e82c0f34a0cb76$var$getId(a) - $32e82c0f34a0cb76$var$getId(b));
        $32e82c0f34a0cb76$var$pendingPostFlushCbs.length = 0;
        if ($32e82c0f34a0cb76$var$activePostFlushCbs) {
            $32e82c0f34a0cb76$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $32e82c0f34a0cb76$var$activePostFlushCbs = deduped;
        for($32e82c0f34a0cb76$var$postFlushIndex = 0; $32e82c0f34a0cb76$var$postFlushIndex < $32e82c0f34a0cb76$var$activePostFlushCbs.length; $32e82c0f34a0cb76$var$postFlushIndex++){
            const cb = $32e82c0f34a0cb76$var$activePostFlushCbs[$32e82c0f34a0cb76$var$postFlushIndex];
            if (cb.flags & 4) cb.flags &= -2;
            if (!(cb.flags & 8)) cb();
            cb.flags &= -2;
        }
        $32e82c0f34a0cb76$var$activePostFlushCbs = null;
        $32e82c0f34a0cb76$var$postFlushIndex = 0;
    }
}
const $32e82c0f34a0cb76$var$getId = (job)=>job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
function $32e82c0f34a0cb76$var$flushJobs(seen) {
    const check = (0, $a5gC8.NOOP);
    try {
        for($32e82c0f34a0cb76$var$flushIndex = 0; $32e82c0f34a0cb76$var$flushIndex < $32e82c0f34a0cb76$var$queue.length; $32e82c0f34a0cb76$var$flushIndex++){
            const job = $32e82c0f34a0cb76$var$queue[$32e82c0f34a0cb76$var$flushIndex];
            if (job && !(job.flags & 8)) {
                if (job.flags & 4) job.flags &= -2;
                $32e82c0f34a0cb76$export$b22fcaf88446e9bf(job, job.i, job.i ? 15 : 14);
                if (!(job.flags & 4)) job.flags &= -2;
            }
        }
    } finally{
        for(; $32e82c0f34a0cb76$var$flushIndex < $32e82c0f34a0cb76$var$queue.length; $32e82c0f34a0cb76$var$flushIndex++){
            const job = $32e82c0f34a0cb76$var$queue[$32e82c0f34a0cb76$var$flushIndex];
            if (job) job.flags &= -2;
        }
        $32e82c0f34a0cb76$var$flushIndex = -1;
        $32e82c0f34a0cb76$var$queue.length = 0;
        $32e82c0f34a0cb76$var$flushPostFlushCbs(seen);
        $32e82c0f34a0cb76$var$currentFlushPromise = null;
        if ($32e82c0f34a0cb76$var$queue.length || $32e82c0f34a0cb76$var$pendingPostFlushCbs.length) $32e82c0f34a0cb76$var$flushJobs(seen);
    }
}
function $32e82c0f34a0cb76$var$checkRecursiveUpdates(seen, fn) {
    const count = seen.get(fn) || 0;
    if (count > $32e82c0f34a0cb76$var$RECURSION_LIMIT) {
        const instance = fn.i;
        const componentName = instance && $32e82c0f34a0cb76$var$getComponentName(instance.type);
        $32e82c0f34a0cb76$export$d3da1ecaf1206c58(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
        return true;
    }
    seen.set(fn, count + 1);
    return false;
}
let $32e82c0f34a0cb76$var$isHmrUpdating = false;
const $32e82c0f34a0cb76$var$hmrDirtyComponents = /* @__PURE__ */ new Map();
const $32e82c0f34a0cb76$var$map = /* @__PURE__ */ new Map();
function $32e82c0f34a0cb76$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $32e82c0f34a0cb76$var$map.get(id);
    if (!record) {
        $32e82c0f34a0cb76$var$createRecord(id, instance.type);
        record = $32e82c0f34a0cb76$var$map.get(id);
    }
    record.instances.add(instance);
}
function $32e82c0f34a0cb76$var$unregisterHMR(instance) {
    $32e82c0f34a0cb76$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $32e82c0f34a0cb76$var$createRecord(id, initialDef) {
    if ($32e82c0f34a0cb76$var$map.has(id)) return false;
    $32e82c0f34a0cb76$var$map.set(id, {
        initialDef: $32e82c0f34a0cb76$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $32e82c0f34a0cb76$var$normalizeClassComponent(component) {
    return $32e82c0f34a0cb76$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $32e82c0f34a0cb76$var$rerender(id, newRender) {
    const record = $32e82c0f34a0cb76$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $32e82c0f34a0cb76$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $32e82c0f34a0cb76$var$isHmrUpdating = true;
        instance.update();
        $32e82c0f34a0cb76$var$isHmrUpdating = false;
    });
}
function $32e82c0f34a0cb76$var$reload(id, newComp) {
    const record = $32e82c0f34a0cb76$var$map.get(id);
    if (!record) return;
    newComp = $32e82c0f34a0cb76$var$normalizeClassComponent(newComp);
    $32e82c0f34a0cb76$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for(let i = 0; i < instances.length; i++){
        const instance = instances[i];
        const oldComp = $32e82c0f34a0cb76$var$normalizeClassComponent(instance.type);
        let dirtyInstances = $32e82c0f34a0cb76$var$hmrDirtyComponents.get(oldComp);
        if (!dirtyInstances) {
            if (oldComp !== record.initialDef) $32e82c0f34a0cb76$var$updateComponentDef(oldComp, newComp);
            $32e82c0f34a0cb76$var$hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
        }
        dirtyInstances.add(instance);
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            dirtyInstances.add(instance);
            instance.ceReload(newComp.styles);
            dirtyInstances.delete(instance);
        } else if (instance.parent) $32e82c0f34a0cb76$var$queueJob(()=>{
            $32e82c0f34a0cb76$var$isHmrUpdating = true;
            instance.parent.update();
            $32e82c0f34a0cb76$var$isHmrUpdating = false;
            dirtyInstances.delete(instance);
        });
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
        if (instance.root.ce && instance !== instance.root) instance.root.ce._removeChildStyle(oldComp);
    }
    $32e82c0f34a0cb76$export$59536a0199721cab(()=>{
        $32e82c0f34a0cb76$var$hmrDirtyComponents.clear();
    });
}
function $32e82c0f34a0cb76$var$updateComponentDef(oldComp, newComp) {
    (0, $a5gC8.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $32e82c0f34a0cb76$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $32e82c0f34a0cb76$var$devtools$1;
let $32e82c0f34a0cb76$var$buffer = [];
let $32e82c0f34a0cb76$var$devtoolsNotInstalled = false;
function $32e82c0f34a0cb76$var$emit$1(event, ...args) {
    if ($32e82c0f34a0cb76$var$devtools$1) $32e82c0f34a0cb76$var$devtools$1.emit(event, ...args);
    else if (!$32e82c0f34a0cb76$var$devtoolsNotInstalled) $32e82c0f34a0cb76$var$buffer.push({
        event: event,
        args: args
    });
}
function $32e82c0f34a0cb76$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $32e82c0f34a0cb76$var$devtools$1 = hook;
    if ($32e82c0f34a0cb76$var$devtools$1) {
        $32e82c0f34a0cb76$var$devtools$1.enabled = true;
        $32e82c0f34a0cb76$var$buffer.forEach(({ event: event, args: args })=>$32e82c0f34a0cb76$var$devtools$1.emit(event, ...args));
        $32e82c0f34a0cb76$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    // eslint-disable-next-line no-restricted-syntax
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $32e82c0f34a0cb76$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!$32e82c0f34a0cb76$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $32e82c0f34a0cb76$var$devtoolsNotInstalled = true;
                $32e82c0f34a0cb76$var$buffer = [];
            }
        }, 3e3);
    } else {
        $32e82c0f34a0cb76$var$devtoolsNotInstalled = true;
        $32e82c0f34a0cb76$var$buffer = [];
    }
}
function $32e82c0f34a0cb76$var$devtoolsInitApp(app, version) {
    $32e82c0f34a0cb76$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $32e82c0f34a0cb76$export$ffb0004e005737fa,
        Text: $32e82c0f34a0cb76$export$5f1af8db9871e1d6,
        Comment: $32e82c0f34a0cb76$export$4d299b491347818a,
        Static: $32e82c0f34a0cb76$export$c1b9a1d3af45b7b6
    });
}
function $32e82c0f34a0cb76$var$devtoolsUnmountApp(app) {
    $32e82c0f34a0cb76$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $32e82c0f34a0cb76$var$devtoolsComponentAdded = /* @__PURE__ */ $32e82c0f34a0cb76$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $32e82c0f34a0cb76$var$devtoolsComponentUpdated = /* @__PURE__ */ $32e82c0f34a0cb76$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $32e82c0f34a0cb76$var$_devtoolsComponentRemoved = /* @__PURE__ */ $32e82c0f34a0cb76$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $32e82c0f34a0cb76$var$devtoolsComponentRemoved = (component)=>{
    if ($32e82c0f34a0cb76$var$devtools$1 && typeof $32e82c0f34a0cb76$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$32e82c0f34a0cb76$var$devtools$1.cleanupBuffer(component)) $32e82c0f34a0cb76$var$_devtoolsComponentRemoved(component);
};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $32e82c0f34a0cb76$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $32e82c0f34a0cb76$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $32e82c0f34a0cb76$var$devtoolsPerfStart = /* @__PURE__ */ $32e82c0f34a0cb76$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $32e82c0f34a0cb76$var$devtoolsPerfEnd = /* @__PURE__ */ $32e82c0f34a0cb76$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $32e82c0f34a0cb76$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $32e82c0f34a0cb76$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $32e82c0f34a0cb76$var$devtoolsComponentEmit(component, event, params) {
    $32e82c0f34a0cb76$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
let $32e82c0f34a0cb76$var$currentRenderingInstance = null;
let $32e82c0f34a0cb76$var$currentScopeId = null;
function $32e82c0f34a0cb76$var$setCurrentRenderingInstance(instance) {
    const prev = $32e82c0f34a0cb76$var$currentRenderingInstance;
    $32e82c0f34a0cb76$var$currentRenderingInstance = instance;
    $32e82c0f34a0cb76$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $32e82c0f34a0cb76$export$ac020265ca2cc4cd(id) {
    $32e82c0f34a0cb76$var$currentScopeId = id;
}
function $32e82c0f34a0cb76$export$f2dc6805dc11834e() {
    $32e82c0f34a0cb76$var$currentScopeId = null;
}
const $32e82c0f34a0cb76$export$15ba313e13f3dd04 = (_id)=>$32e82c0f34a0cb76$export$694b237e827a3d23;
function $32e82c0f34a0cb76$export$694b237e827a3d23(fn, ctx = $32e82c0f34a0cb76$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $32e82c0f34a0cb76$export$c20bee82f26f1e27(-1);
        const prevInstance = $32e82c0f34a0cb76$var$setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            $32e82c0f34a0cb76$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $32e82c0f34a0cb76$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $32e82c0f34a0cb76$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
function $32e82c0f34a0cb76$var$validateDirectiveName(name) {
    if ((0, $a5gC8.isBuiltInDirective)(name)) $32e82c0f34a0cb76$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $32e82c0f34a0cb76$export$49729353e7c1e6c5(vnode, directives) {
    if ($32e82c0f34a0cb76$var$currentRenderingInstance === null) return vnode;
    const instance = $32e82c0f34a0cb76$var$getComponentPublicInstance($32e82c0f34a0cb76$var$currentRenderingInstance);
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $a5gC8.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $a5gC8.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) (0, $9K9BQ.traverse)(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $32e82c0f34a0cb76$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $9K9BQ.pauseTracking)();
            $32e82c0f34a0cb76$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $9K9BQ.resetTracking)();
        }
    }
}
const $32e82c0f34a0cb76$var$TeleportEndKey = Symbol("_vte");
const $32e82c0f34a0cb76$var$isTeleport = (type)=>type.__isTeleport;
const $32e82c0f34a0cb76$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $32e82c0f34a0cb76$var$isTeleportDeferred = (props)=>props && (props.defer || props.defer === "");
const $32e82c0f34a0cb76$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $32e82c0f34a0cb76$var$isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const $32e82c0f34a0cb76$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $a5gC8.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            return target;
        }
    } else return targetSelector;
};
const $32e82c0f34a0cb76$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $32e82c0f34a0cb76$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const mount = (container2, anchor2)=>{
                if (shapeFlag & 16) {
                    if (parentComponent && parentComponent.isCE) parentComponent.ce._teleportTarget = container2;
                    mountChildren(children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                }
            };
            const mountToTarget = ()=>{
                const target = n2.target = $32e82c0f34a0cb76$var$resolveTarget(n2.props, querySelector);
                const targetAnchor = $32e82c0f34a0cb76$var$prepareAnchor(target, n2, createText, insert);
                if (target) {
                    if (namespace !== "svg" && $32e82c0f34a0cb76$var$isTargetSVG(target)) namespace = "svg";
                    else if (namespace !== "mathml" && $32e82c0f34a0cb76$var$isTargetMathML(target)) namespace = "mathml";
                    if (!disabled) {
                        mount(target, targetAnchor);
                        $32e82c0f34a0cb76$var$updateCssVars(n2, false);
                    }
                }
            };
            if (disabled) {
                mount(container, mainAnchor);
                $32e82c0f34a0cb76$var$updateCssVars(n2, true);
            }
            if ($32e82c0f34a0cb76$var$isTeleportDeferred(n2.props)) $32e82c0f34a0cb76$var$queuePostRenderEffect(mountToTarget, parentSuspense);
            else mountToTarget();
        } else {
            n2.el = n1.el;
            n2.targetStart = n1.targetStart;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $32e82c0f34a0cb76$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || $32e82c0f34a0cb76$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $32e82c0f34a0cb76$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $32e82c0f34a0cb76$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $32e82c0f34a0cb76$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $32e82c0f34a0cb76$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $32e82c0f34a0cb76$var$moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) $32e82c0f34a0cb76$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
            $32e82c0f34a0cb76$var$updateCssVars(n2, disabled);
        }
    },
    remove (vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetStart: targetStart, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) {
            hostRemove(targetStart);
            hostRemove(targetAnchor);
        }
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) {
            const shouldRemove = doRemove || !$32e82c0f34a0cb76$var$isTeleportDisabled(props);
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
            }
        }
    },
    move: $32e82c0f34a0cb76$var$moveTeleport,
    hydrate: $32e82c0f34a0cb76$var$hydrateTeleport
};
function $32e82c0f34a0cb76$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $32e82c0f34a0cb76$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $32e82c0f34a0cb76$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector, insert: insert, createText: createText } }, hydrateChildren) {
    const target = vnode.target = $32e82c0f34a0cb76$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        const disabled = $32e82c0f34a0cb76$var$isTeleportDisabled(vnode.props);
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if (disabled) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetStart = targetNode;
                vnode.targetAnchor = targetNode && nextSibling(targetNode);
            } else {
                vnode.anchor = nextSibling(node);
                let targetAnchor = targetNode;
                while(targetAnchor){
                    if (targetAnchor && targetAnchor.nodeType === 8) {
                        if (targetAnchor.data === "teleport start anchor") vnode.targetStart = targetAnchor;
                        else if (targetAnchor.data === "teleport anchor") {
                            vnode.targetAnchor = targetAnchor;
                            target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                            break;
                        }
                    }
                    targetAnchor = nextSibling(targetAnchor);
                }
                if (!vnode.targetAnchor) $32e82c0f34a0cb76$var$prepareAnchor(target, vnode, createText, insert);
                hydrateChildren(targetNode && nextSibling(targetNode), vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $32e82c0f34a0cb76$var$updateCssVars(vnode, disabled);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $32e82c0f34a0cb76$export$76d55a0304a371f4 = $32e82c0f34a0cb76$var$TeleportImpl;
function $32e82c0f34a0cb76$var$updateCssVars(vnode, isDisabled) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node, anchor;
        if (isDisabled) {
            node = vnode.el;
            anchor = vnode.anchor;
        } else {
            node = vnode.targetStart;
            anchor = vnode.targetAnchor;
        }
        while(node && node !== anchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
function $32e82c0f34a0cb76$var$prepareAnchor(target, vnode, createText, insert) {
    const targetStart = vnode.targetStart = createText("");
    const targetAnchor = vnode.targetAnchor = createText("");
    targetStart[$32e82c0f34a0cb76$var$TeleportEndKey] = targetAnchor;
    if (target) {
        insert(targetStart, target);
        insert(targetAnchor, target);
    }
    return targetAnchor;
}
const $32e82c0f34a0cb76$var$leaveCbKey = Symbol("_leaveCb");
const $32e82c0f34a0cb76$var$enterCbKey = Symbol("_enterCb");
function $32e82c0f34a0cb76$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $32e82c0f34a0cb76$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $32e82c0f34a0cb76$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $32e82c0f34a0cb76$var$TransitionHookValidator = [
    Function,
    Array
];
const $32e82c0f34a0cb76$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $32e82c0f34a0cb76$var$TransitionHookValidator,
    onEnter: $32e82c0f34a0cb76$var$TransitionHookValidator,
    onAfterEnter: $32e82c0f34a0cb76$var$TransitionHookValidator,
    onEnterCancelled: $32e82c0f34a0cb76$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $32e82c0f34a0cb76$var$TransitionHookValidator,
    onLeave: $32e82c0f34a0cb76$var$TransitionHookValidator,
    onAfterLeave: $32e82c0f34a0cb76$var$TransitionHookValidator,
    onLeaveCancelled: $32e82c0f34a0cb76$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $32e82c0f34a0cb76$var$TransitionHookValidator,
    onAppear: $32e82c0f34a0cb76$var$TransitionHookValidator,
    onAfterAppear: $32e82c0f34a0cb76$var$TransitionHookValidator,
    onAppearCancelled: $32e82c0f34a0cb76$var$TransitionHookValidator
};
const $32e82c0f34a0cb76$var$recursiveGetSubtree = (instance)=>{
    const subTree = instance.subTree;
    return subTree.component ? $32e82c0f34a0cb76$var$recursiveGetSubtree(subTree.component) : subTree;
};
const $32e82c0f34a0cb76$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $32e82c0f34a0cb76$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $32e82c0f34a0cb76$export$f13e630aa3915748();
        const state = $32e82c0f34a0cb76$export$d2a0a1bc267c90f6();
        return ()=>{
            const children = slots.default && $32e82c0f34a0cb76$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            const child = $32e82c0f34a0cb76$var$findNonCommentChild(children);
            const rawProps = (0, $9K9BQ.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $32e82c0f34a0cb76$var$emptyPlaceholder(child);
            const innerChild = $32e82c0f34a0cb76$var$getInnerChild$1(child);
            if (!innerChild) return $32e82c0f34a0cb76$var$emptyPlaceholder(child);
            let enterHooks = $32e82c0f34a0cb76$export$76ac1779589cd824(innerChild, rawProps, state, instance, // #11061, ensure enterHooks is fresh after clone
            (hooks)=>enterHooks = hooks);
            if (innerChild.type !== $32e82c0f34a0cb76$export$4d299b491347818a) $32e82c0f34a0cb76$export$7770a22486565649(innerChild, enterHooks);
            const oldChild = instance.subTree;
            const oldInnerChild = oldChild && $32e82c0f34a0cb76$var$getInnerChild$1(oldChild);
            if (oldInnerChild && oldInnerChild.type !== $32e82c0f34a0cb76$export$4d299b491347818a && !$32e82c0f34a0cb76$var$isSameVNodeType(innerChild, oldInnerChild) && $32e82c0f34a0cb76$var$recursiveGetSubtree(instance).type !== $32e82c0f34a0cb76$export$4d299b491347818a) {
                const leavingHooks = $32e82c0f34a0cb76$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $32e82c0f34a0cb76$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== $32e82c0f34a0cb76$export$4d299b491347818a) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (!(instance.job.flags & 8)) instance.update();
                        delete leavingHooks.afterLeave;
                    };
                    return $32e82c0f34a0cb76$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $32e82c0f34a0cb76$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $32e82c0f34a0cb76$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$32e82c0f34a0cb76$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$32e82c0f34a0cb76$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                    };
                    enterHooks.delayedLeave = delayedLeave;
                };
            }
            return child;
        };
    }
};
function $32e82c0f34a0cb76$var$findNonCommentChild(children) {
    let child = children[0];
    if (children.length > 1) {
        let hasFound = false;
        for (const c of children)if (c.type !== $32e82c0f34a0cb76$export$4d299b491347818a) {
            child = c;
            hasFound = true;
            break;
        }
    }
    return child;
}
const $32e82c0f34a0cb76$export$abd95b5f5e8a8837 = $32e82c0f34a0cb76$var$BaseTransitionImpl;
function $32e82c0f34a0cb76$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $32e82c0f34a0cb76$export$76ac1779589cd824(vnode, props, state, instance, postClone) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $32e82c0f34a0cb76$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $32e82c0f34a0cb76$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $a5gC8.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$32e82c0f34a0cb76$var$leaveCbKey]) el[$32e82c0f34a0cb76$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $32e82c0f34a0cb76$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$32e82c0f34a0cb76$var$leaveCbKey]) leavingVNode.el[$32e82c0f34a0cb76$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el[$32e82c0f34a0cb76$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$32e82c0f34a0cb76$var$enterCbKey] = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$32e82c0f34a0cb76$var$enterCbKey]) el[$32e82c0f34a0cb76$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el[$32e82c0f34a0cb76$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$32e82c0f34a0cb76$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            const hooks2 = $32e82c0f34a0cb76$export$76ac1779589cd824(vnode2, props, state, instance, postClone);
            if (postClone) postClone(hooks2);
            return hooks2;
        }
    };
    return hooks;
}
function $32e82c0f34a0cb76$var$emptyPlaceholder(vnode) {
    if ($32e82c0f34a0cb76$var$isKeepAlive(vnode)) {
        vnode = $32e82c0f34a0cb76$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $32e82c0f34a0cb76$var$getInnerChild$1(vnode) {
    if (!$32e82c0f34a0cb76$var$isKeepAlive(vnode)) {
        if ($32e82c0f34a0cb76$var$isTeleport(vnode.type) && vnode.children) return $32e82c0f34a0cb76$var$findNonCommentChild(vnode.children);
        return vnode;
    }
    const { shapeFlag: shapeFlag, children: children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $a5gC8.isFunction)(children.default)) return children.default();
    }
}
function $32e82c0f34a0cb76$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
        vnode.transition = hooks;
        $32e82c0f34a0cb76$export$7770a22486565649(vnode.component.subTree, hooks);
    } else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $32e82c0f34a0cb76$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $32e82c0f34a0cb76$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($32e82c0f34a0cb76$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $32e82c0f34a0cb76$export$4d299b491347818a) ret.push(key != null ? $32e82c0f34a0cb76$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $32e82c0f34a0cb76$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $a5gC8.isFunction)(options) ? // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $a5gC8.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
function $32e82c0f34a0cb76$export$f680877a34711e37() {
    const i = $32e82c0f34a0cb76$export$f13e630aa3915748();
    if (i) return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
    return "";
}
function $32e82c0f34a0cb76$var$markAsyncBoundary(instance) {
    instance.ids = [
        instance.ids[0] + instance.ids[2]++ + "-",
        0,
        0
    ];
}
const $32e82c0f34a0cb76$var$knownTemplateRefs = /* @__PURE__ */ new WeakSet();
function $32e82c0f34a0cb76$export$83a5dbc1f35517ca(key) {
    const i = $32e82c0f34a0cb76$export$f13e630aa3915748();
    const r = (0, $9K9BQ.shallowRef)(null);
    if (i) {
        const refs = i.refs === (0, $a5gC8.EMPTY_OBJ) ? i.refs = {} : i.refs;
        let desc;
        Object.defineProperty(refs, key, {
            enumerable: true,
            get: ()=>r.value,
            set: (val)=>r.value = val
        });
    }
    const ret = r;
    return ret;
}
function $32e82c0f34a0cb76$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $a5gC8.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$32e82c0f34a0cb76$var$setRef(r, oldRawRef && ((0, $a5gC8.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($32e82c0f34a0cb76$var$isAsyncWrapper(vnode) && !isUnmount) return;
    const refValue = vnode.shapeFlag & 4 ? $32e82c0f34a0cb76$var$getComponentPublicInstance(vnode.component) : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $a5gC8.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    const rawSetupState = (0, $9K9BQ.toRaw)(setupState);
    const canSetSetupRef = setupState === (0, $a5gC8.EMPTY_OBJ) ? ()=>false : (key)=>{
        return (0, $a5gC8.hasOwn)(rawSetupState, key);
    };
    if (oldRef != null && oldRef !== ref) {
        if ((0, $a5gC8.isString)(oldRef)) {
            refs[oldRef] = null;
            if (canSetSetupRef(oldRef)) setupState[oldRef] = null;
        } else if ((0, $9K9BQ.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $a5gC8.isFunction)(ref)) $32e82c0f34a0cb76$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, $a5gC8.isString)(ref);
        const _isRef = (0, $9K9BQ.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? canSetSetupRef(ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, $a5gC8.isArray)(existing) && (0, $a5gC8.remove)(existing, refValue);
                    else {
                        if (!(0, $a5gC8.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if (canSetSetupRef(ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if (canSetSetupRef(ref)) setupState[ref] = value;
                } else if (_isRef) {
                    ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                doSet.id = -1;
                $32e82c0f34a0cb76$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let $32e82c0f34a0cb76$var$hasLoggedMismatchError = false;
const $32e82c0f34a0cb76$var$logMismatchError = ()=>{
    if ($32e82c0f34a0cb76$var$hasLoggedMismatchError) return;
    console.error("Hydration completed but contains mismatches.");
    $32e82c0f34a0cb76$var$hasLoggedMismatchError = true;
};
const $32e82c0f34a0cb76$var$isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const $32e82c0f34a0cb76$var$isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const $32e82c0f34a0cb76$var$getContainerType = (container)=>{
    if (container.nodeType !== 1) return void 0;
    if ($32e82c0f34a0cb76$var$isSVGContainer(container)) return "svg";
    if ($32e82c0f34a0cb76$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
const $32e82c0f34a0cb76$var$isComment = (node)=>node.nodeType === 8;
function $32e82c0f34a0cb76$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $32e82c0f34a0cb76$var$warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            $32e82c0f34a0cb76$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        hydrateNode(container.firstChild, vnode, null, null, null);
        $32e82c0f34a0cb76$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = $32e82c0f34a0cb76$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $a5gC8.def)(node, "__vnode", vnode, true);
            (0, $a5gC8.def)(node, "__vueParentComponent", parentComponent, true);
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $32e82c0f34a0cb76$export$5f1af8db9871e1d6:
                if (domType !== 3) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $32e82c0f34a0cb76$var$warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        $32e82c0f34a0cb76$var$logMismatchError();
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $32e82c0f34a0cb76$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $32e82c0f34a0cb76$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 || domType === 3) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $32e82c0f34a0cb76$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($32e82c0f34a0cb76$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $32e82c0f34a0cb76$var$getContainerType(container), optimized);
                    if ($32e82c0f34a0cb76$var$isAsyncWrapper(vnode)) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $32e82c0f34a0cb76$export$bf5c4cf060303d58($32e82c0f34a0cb76$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $32e82c0f34a0cb76$export$22f9b5ffd89dac9("") : $32e82c0f34a0cb76$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $32e82c0f34a0cb76$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $32e82c0f34a0cb76$var$warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) $32e82c0f34a0cb76$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        if (forcePatch || patchFlag !== -1) {
            if (dirs) $32e82c0f34a0cb76$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $32e82c0f34a0cb76$var$needTransition(null, // no need check parentSuspense in hydration
                transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) transition.beforeEnter(content);
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    if (!$32e82c0f34a0cb76$var$isMismatchAllowed(el, 1 /* CHILDREN */ )) {
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                            $32e82c0f34a0cb76$var$warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                            hasWarned = true;
                        }
                        $32e82c0f34a0cb76$var$logMismatchError();
                    }
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                let clientText = vnode.children;
                if (clientText[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) clientText = clientText.slice(1);
                if (el.textContent !== clientText) {
                    if (!$32e82c0f34a0cb76$var$isMismatchAllowed(el, 0 /* TEXT */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $32e82c0f34a0cb76$var$warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${el.textContent}
  - expected on client: ${vnode.children}`);
                        $32e82c0f34a0cb76$var$logMismatchError();
                    }
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || !optimized || patchFlag & 48) {
                    const isCustomElement = el.tagName.includes("-");
                    for(const key in props){
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && // #11189 skip if this node has directives that have created hooks
                        // as it could have mutated the DOM in any possible way
                        !(dirs && dirs.some((d)=>d.dir.created)) && $32e82c0f34a0cb76$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $32e82c0f34a0cb76$var$logMismatchError();
                        if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $a5gC8.isOn)(key) && !(0, $a5gC8.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                        key[0] === "." || isCustomElement) patchProp(el, key, null, props[key], void 0, parentComponent);
                    }
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, parentComponent);
                else if (patchFlag & 4 && (0, $9K9BQ.isReactive)(props.style)) for(const key in props.style)props.style[key];
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $32e82c0f34a0cb76$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $32e82c0f34a0cb76$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $32e82c0f34a0cb76$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $32e82c0f34a0cb76$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $32e82c0f34a0cb76$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $32e82c0f34a0cb76$var$normalizeVNode(children[i]);
            const isText = vnode.type === $32e82c0f34a0cb76$export$5f1af8db9871e1d6;
            if (node) {
                if (isText && !optimized) {
                    if (i + 1 < l && $32e82c0f34a0cb76$var$normalizeVNode(children[i + 1]).type === $32e82c0f34a0cb76$export$5f1af8db9871e1d6) {
                        insert(createText(node.data.slice(vnode.children.length)), container, nextSibling(node));
                        node.data = vnode.children;
                    }
                }
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            } else if (isText && !vnode.children) insert(vnode.el = createText(""), container);
            else {
                if (!$32e82c0f34a0cb76$var$isMismatchAllowed(container, 1 /* CHILDREN */ )) {
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                        $32e82c0f34a0cb76$var$warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                        hasWarned = true;
                    }
                    $32e82c0f34a0cb76$var$logMismatchError();
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $32e82c0f34a0cb76$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $32e82c0f34a0cb76$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $32e82c0f34a0cb76$var$logMismatchError();
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        if (!$32e82c0f34a0cb76$var$isMismatchAllowed(node.parentElement, 1 /* CHILDREN */ )) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $32e82c0f34a0cb76$var$warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 ? `(text)` : $32e82c0f34a0cb76$var$isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
            $32e82c0f34a0cb76$var$logMismatchError();
        }
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $32e82c0f34a0cb76$var$getContainerType(container), slotScopeIds);
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $32e82c0f34a0cb76$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 && node.tagName === "TEMPLATE";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
function $32e82c0f34a0cb76$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        actual = el.getAttribute("class");
        expected = (0, $a5gC8.normalizeClass)(clientValue);
        if (!$32e82c0f34a0cb76$var$isSetEqual($32e82c0f34a0cb76$var$toClassSet(actual || ""), $32e82c0f34a0cb76$var$toClassSet(expected))) {
            mismatchType = 2 /* CLASS */ ;
            mismatchKey = `class`;
        }
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, $a5gC8.isString)(clientValue) ? clientValue : (0, $a5gC8.stringifyStyle)((0, $a5gC8.normalizeStyle)(clientValue));
        const actualMap = $32e82c0f34a0cb76$var$toStyleMap(actual);
        const expectedMap = $32e82c0f34a0cb76$var$toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir: dir, value: value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        if (instance) $32e82c0f34a0cb76$var$resolveCssVars(instance, vnode, expectedMap);
        if (!$32e82c0f34a0cb76$var$isMapEqual(actualMap, expectedMap)) {
            mismatchType = 3 /* STYLE */ ;
            mismatchKey = "style";
        }
    } else if (el instanceof SVGElement && (0, $a5gC8.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $a5gC8.isBooleanAttr)(key) || (0, $a5gC8.isKnownHtmlAttr)(key))) {
        if ((0, $a5gC8.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $a5gC8.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $a5gC8.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = 4 /* ATTRIBUTE */ ;
            mismatchKey = key;
        }
    }
    if (mismatchType != null && !$32e82c0f34a0cb76$var$isMismatchAllowed(el, mismatchType)) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${$32e82c0f34a0cb76$var$MismatchTypeString[mismatchType]} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        $32e82c0f34a0cb76$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $32e82c0f34a0cb76$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $32e82c0f34a0cb76$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function $32e82c0f34a0cb76$var$toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key.trim();
        value = value && value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function $32e82c0f34a0cb76$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
function $32e82c0f34a0cb76$var$resolveCssVars(instance, vnode, expectedMap) {
    const root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === $32e82c0f34a0cb76$export$ffb0004e005737fa && root.children.includes(vnode))) {
        const cssVars = instance.getCssVars();
        for(const key in cssVars)expectedMap.set(`--${(0, $a5gC8.getEscapedCssVarName)(key, false)}`, String(cssVars[key]));
    }
    if (vnode === root && instance.parent) $32e82c0f34a0cb76$var$resolveCssVars(instance.parent, instance.vnode, expectedMap);
}
const $32e82c0f34a0cb76$var$allowMismatchAttr = "data-allow-mismatch";
const $32e82c0f34a0cb76$var$MismatchTypeString = {
    [0 /* TEXT */ ]: "text",
    [1 /* CHILDREN */ ]: "children",
    [2 /* CLASS */ ]: "class",
    [3 /* STYLE */ ]: "style",
    [4 /* ATTRIBUTE */ ]: "attribute"
};
function $32e82c0f34a0cb76$var$isMismatchAllowed(el, allowedType) {
    if (allowedType === 0 /* TEXT */  || allowedType === 1 /* CHILDREN */ ) while(el && !el.hasAttribute($32e82c0f34a0cb76$var$allowMismatchAttr))el = el.parentElement;
    const allowedAttr = el && el.getAttribute($32e82c0f34a0cb76$var$allowMismatchAttr);
    if (allowedAttr == null) return false;
    else if (allowedAttr === "") return true;
    else {
        const list = allowedAttr.split(",");
        if (allowedType === 0 /* TEXT */  && list.includes("children")) return true;
        return allowedAttr.split(",").includes($32e82c0f34a0cb76$var$MismatchTypeString[allowedType]);
    }
}
const $32e82c0f34a0cb76$var$requestIdleCallback = (0, $a5gC8.getGlobalThis)().requestIdleCallback || ((cb)=>setTimeout(cb, 1));
const $32e82c0f34a0cb76$var$cancelIdleCallback = (0, $a5gC8.getGlobalThis)().cancelIdleCallback || ((id)=>clearTimeout(id));
const $32e82c0f34a0cb76$export$8bfca283fd254627 = (timeout = 1e4)=>(hydrate)=>{
        const id = $32e82c0f34a0cb76$var$requestIdleCallback(hydrate, {
            timeout: timeout
        });
        return ()=>$32e82c0f34a0cb76$var$cancelIdleCallback(id);
    };
function $32e82c0f34a0cb76$var$elementIsVisibleInViewport(el) {
    const { top: top, left: left, bottom: bottom, right: right } = el.getBoundingClientRect();
    const { innerHeight: innerHeight, innerWidth: innerWidth } = window;
    return (top > 0 && top < innerHeight || bottom > 0 && bottom < innerHeight) && (left > 0 && left < innerWidth || right > 0 && right < innerWidth);
}
const $32e82c0f34a0cb76$export$2b04cd335e660930 = (opts)=>(hydrate, forEach)=>{
        const ob = new IntersectionObserver((entries)=>{
            for (const e of entries){
                if (!e.isIntersecting) continue;
                ob.disconnect();
                hydrate();
                break;
            }
        }, opts);
        forEach((el)=>{
            if (!(el instanceof Element)) return;
            if ($32e82c0f34a0cb76$var$elementIsVisibleInViewport(el)) {
                hydrate();
                ob.disconnect();
                return false;
            }
            ob.observe(el);
        });
        return ()=>ob.disconnect();
    };
const $32e82c0f34a0cb76$export$804dbb6002787b74 = (query)=>(hydrate)=>{
        if (query) {
            const mql = matchMedia(query);
            if (mql.matches) hydrate();
            else {
                mql.addEventListener("change", hydrate, {
                    once: true
                });
                return ()=>mql.removeEventListener("change", hydrate);
            }
        }
    };
const $32e82c0f34a0cb76$export$288f5a9b4248e114 = (interactions = [])=>(hydrate, forEach)=>{
        if ((0, $a5gC8.isString)(interactions)) interactions = [
            interactions
        ];
        let hasHydrated = false;
        const doHydrate = (e)=>{
            if (!hasHydrated) {
                hasHydrated = true;
                teardown();
                hydrate();
                e.target.dispatchEvent(new e.constructor(e.type, e));
            }
        };
        const teardown = ()=>{
            forEach((el)=>{
                for (const i of interactions)el.removeEventListener(i, doHydrate);
            });
        };
        forEach((el)=>{
            for (const i of interactions)el.addEventListener(i, doHydrate, {
                once: true
            });
        });
        return teardown;
    };
function $32e82c0f34a0cb76$var$forEachElement(node, cb) {
    if ($32e82c0f34a0cb76$var$isComment(node) && node.data === "[") {
        let depth = 1;
        let next = node.nextSibling;
        while(next){
            if (next.nodeType === 1) {
                const result = cb(next);
                if (result === false) break;
            } else if ($32e82c0f34a0cb76$var$isComment(next)) {
                if (next.data === "]") {
                    if (--depth === 0) break;
                } else if (next.data === "[") depth++;
            }
            next = next.nextSibling;
        }
    } else cb(node);
}
const $32e82c0f34a0cb76$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $32e82c0f34a0cb76$export$d75d499b4c16cf21(source) {
    if ((0, $a5gC8.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, hydrate: hydrateStrategy, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $32e82c0f34a0cb76$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        __asyncHydrate (el, instance, hydrate) {
            const doHydrate = hydrateStrategy ? ()=>{
                const teardown = hydrateStrategy(hydrate, (cb)=>$32e82c0f34a0cb76$var$forEachElement(el, cb));
                if (teardown) (instance.bum || (instance.bum = [])).push(teardown);
            } : hydrate;
            if (resolvedComp) doHydrate();
            else load().then(()=>!instance.isUnmounted && doHydrate());
        },
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $32e82c0f34a0cb76$var$currentInstance;
            $32e82c0f34a0cb76$var$markAsyncBoundary(instance);
            if (resolvedComp) return ()=>$32e82c0f34a0cb76$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $32e82c0f34a0cb76$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $32e82c0f34a0cb76$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$32e82c0f34a0cb76$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $32e82c0f34a0cb76$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $9K9BQ.ref)(false);
            const error = (0, $9K9BQ.ref)();
            const delayed = (0, $9K9BQ.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $32e82c0f34a0cb76$var$isKeepAlive(instance.parent.vnode)) instance.parent.update();
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $32e82c0f34a0cb76$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $32e82c0f34a0cb76$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $32e82c0f34a0cb76$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $32e82c0f34a0cb76$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $32e82c0f34a0cb76$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $32e82c0f34a0cb76$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $32e82c0f34a0cb76$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $32e82c0f34a0cb76$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $32e82c0f34a0cb76$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $a5gC8.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $32e82c0f34a0cb76$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $32e82c0f34a0cb76$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            $32e82c0f34a0cb76$var$invalidateMount(instance2.m);
            $32e82c0f34a0cb76$var$invalidateMount(instance2.a);
            move(vnode, storageContainer, null, 1, parentSuspense);
            $32e82c0f34a0cb76$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $a5gC8.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $32e82c0f34a0cb76$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $32e82c0f34a0cb76$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $32e82c0f34a0cb76$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $32e82c0f34a0cb76$var$getComponentName(vnode.type);
                if (name && !filter(name)) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (cached && (!current || !$32e82c0f34a0cb76$var$isSameVNodeType(cached, current))) unmount(cached);
            else if (current) $32e82c0f34a0cb76$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $32e82c0f34a0cb76$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$32e82c0f34a0cb76$var$matches(include, name));
            exclude && pruneCache((name)=>!$32e82c0f34a0cb76$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) {
                if ($32e82c0f34a0cb76$var$isSuspense(instance.subTree.type)) $32e82c0f34a0cb76$var$queuePostRenderEffect(()=>{
                    cache.set(pendingCacheKey, $32e82c0f34a0cb76$var$getInnerChild(instance.subTree));
                }, instance.subTree.suspense);
                else cache.set(pendingCacheKey, $32e82c0f34a0cb76$var$getInnerChild(instance.subTree));
            }
        };
        $32e82c0f34a0cb76$export$6d1641039221b5cb(cacheSubtree);
        $32e82c0f34a0cb76$export$5876c47052fb88b1(cacheSubtree);
        $32e82c0f34a0cb76$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $32e82c0f34a0cb76$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $32e82c0f34a0cb76$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $32e82c0f34a0cb76$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return current = null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$32e82c0f34a0cb76$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $32e82c0f34a0cb76$var$getInnerChild(rawVNode);
            if (vnode.type === $32e82c0f34a0cb76$export$4d299b491347818a) {
                current = null;
                return vnode;
            }
            const comp = vnode.type;
            const name = $32e82c0f34a0cb76$var$getComponentName($32e82c0f34a0cb76$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$32e82c0f34a0cb76$var$matches(include, name)) || exclude && name && $32e82c0f34a0cb76$var$matches(exclude, name)) {
                vnode.shapeFlag &= -257;
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $32e82c0f34a0cb76$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $32e82c0f34a0cb76$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $32e82c0f34a0cb76$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $32e82c0f34a0cb76$export$70eb8a58709972df = $32e82c0f34a0cb76$var$KeepAliveImpl;
function $32e82c0f34a0cb76$var$matches(pattern, name) {
    if ((0, $a5gC8.isArray)(pattern)) return pattern.some((p)=>$32e82c0f34a0cb76$var$matches(p, name));
    else if ((0, $a5gC8.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $a5gC8.isRegExp)(pattern)) {
        pattern.lastIndex = 0;
        return pattern.test(name);
    }
    return false;
}
function $32e82c0f34a0cb76$export$ba52d824b95a2154(hook, target) {
    $32e82c0f34a0cb76$var$registerKeepAliveHook(hook, "a", target);
}
function $32e82c0f34a0cb76$export$bf1440eeaf5fa709(hook, target) {
    $32e82c0f34a0cb76$var$registerKeepAliveHook(hook, "da", target);
}
function $32e82c0f34a0cb76$var$registerKeepAliveHook(hook, type, target = $32e82c0f34a0cb76$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $32e82c0f34a0cb76$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($32e82c0f34a0cb76$var$isKeepAlive(current.parent.vnode)) $32e82c0f34a0cb76$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $32e82c0f34a0cb76$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $32e82c0f34a0cb76$var$injectHook(type, hook, keepAliveRoot, true);
    $32e82c0f34a0cb76$export$13348a43ccacfe58(()=>{
        (0, $a5gC8.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $32e82c0f34a0cb76$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $32e82c0f34a0cb76$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $32e82c0f34a0cb76$var$injectHook(type, hook, target = $32e82c0f34a0cb76$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            (0, $9K9BQ.pauseTracking)();
            const reset = $32e82c0f34a0cb76$var$setCurrentInstance(target);
            const res = $32e82c0f34a0cb76$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $9K9BQ.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $32e82c0f34a0cb76$var$createHook = (lifecycle)=>(hook, target = $32e82c0f34a0cb76$var$currentInstance)=>{
        if (!$32e82c0f34a0cb76$var$isInSSRComponentSetup || lifecycle === "sp") $32e82c0f34a0cb76$var$injectHook(lifecycle, (...args)=>hook(...args), target);
    };
const $32e82c0f34a0cb76$export$23b7aeb0d671f804 = $32e82c0f34a0cb76$var$createHook("bm");
const $32e82c0f34a0cb76$export$6d1641039221b5cb = $32e82c0f34a0cb76$var$createHook("m");
const $32e82c0f34a0cb76$export$ab91988a13872e4c = $32e82c0f34a0cb76$var$createHook("bu");
const $32e82c0f34a0cb76$export$5876c47052fb88b1 = $32e82c0f34a0cb76$var$createHook("u");
const $32e82c0f34a0cb76$export$40c420df62d2614 = $32e82c0f34a0cb76$var$createHook("bum");
const $32e82c0f34a0cb76$export$13348a43ccacfe58 = $32e82c0f34a0cb76$var$createHook("um");
const $32e82c0f34a0cb76$export$ebf0c601f267bceb = $32e82c0f34a0cb76$var$createHook("sp");
const $32e82c0f34a0cb76$export$898295a813d662eb = $32e82c0f34a0cb76$var$createHook("rtg");
const $32e82c0f34a0cb76$export$2b41f4235363e921 = $32e82c0f34a0cb76$var$createHook("rtc");
function $32e82c0f34a0cb76$export$6a3a15856e50ad19(hook, target = $32e82c0f34a0cb76$var$currentInstance) {
    $32e82c0f34a0cb76$var$injectHook("ec", hook, target);
}
const $32e82c0f34a0cb76$var$COMPONENTS = "components";
const $32e82c0f34a0cb76$var$DIRECTIVES = "directives";
function $32e82c0f34a0cb76$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $32e82c0f34a0cb76$var$resolveAsset($32e82c0f34a0cb76$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $32e82c0f34a0cb76$var$NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function $32e82c0f34a0cb76$export$b44c564a05ca975(component) {
    if ((0, $a5gC8.isString)(component)) return $32e82c0f34a0cb76$var$resolveAsset($32e82c0f34a0cb76$var$COMPONENTS, component, false) || component;
    else return component || $32e82c0f34a0cb76$var$NULL_DYNAMIC_COMPONENT;
}
function $32e82c0f34a0cb76$export$a1989e995cd481be(name) {
    return $32e82c0f34a0cb76$var$resolveAsset($32e82c0f34a0cb76$var$DIRECTIVES, name);
}
function $32e82c0f34a0cb76$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $32e82c0f34a0cb76$var$currentRenderingInstance || $32e82c0f34a0cb76$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $32e82c0f34a0cb76$var$COMPONENTS) {
            const selfName = $32e82c0f34a0cb76$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $a5gC8.camelize)(name) || selfName === (0, $a5gC8.capitalize)((0, $a5gC8.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $32e82c0f34a0cb76$var$resolve(instance[type] || Component[type], name) || // global registration
        $32e82c0f34a0cb76$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $32e82c0f34a0cb76$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $a5gC8.camelize)(name)] || registry[(0, $a5gC8.capitalize)((0, $a5gC8.camelize)(name))]);
}
function $32e82c0f34a0cb76$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    const sourceIsArray = (0, $a5gC8.isArray)(source);
    if (sourceIsArray || (0, $a5gC8.isString)(source)) {
        const sourceIsReactiveArray = sourceIsArray && (0, $9K9BQ.isReactive)(source);
        let needsWrap = false;
        if (sourceIsReactiveArray) {
            needsWrap = !(0, $9K9BQ.isShallow)(source);
            source = (0, $9K9BQ.shallowReadArray)(source);
        }
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(needsWrap ? (0, $9K9BQ.toReactive)(source[i]) : source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $a5gC8.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $32e82c0f34a0cb76$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $a5gC8.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $32e82c0f34a0cb76$export$4abee4c34694ada1(slots, name, props = {}, fallback, noSlotted) {
    if ($32e82c0f34a0cb76$var$currentRenderingInstance.ce || $32e82c0f34a0cb76$var$currentRenderingInstance.parent && $32e82c0f34a0cb76$var$isAsyncWrapper($32e82c0f34a0cb76$var$currentRenderingInstance.parent) && $32e82c0f34a0cb76$var$currentRenderingInstance.parent.ce) {
        if (name !== "default") props.name = name;
        return $32e82c0f34a0cb76$export$e7eaa45e502fe5cc(), $32e82c0f34a0cb76$export$9f2dfe8048dfb22b($32e82c0f34a0cb76$export$ffb0004e005737fa, null, [
            $32e82c0f34a0cb76$export$bf5c4cf060303d58("slot", props, fallback && fallback())
        ], 64);
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    $32e82c0f34a0cb76$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $32e82c0f34a0cb76$var$ensureValidVNode(slot(props));
    const slotKey = props.key || // slot content array of a dynamic conditional slot may have a branch
    // key attached in the `createSlots` helper, respect that
    validSlotContent && validSlotContent.key;
    const rendered = $32e82c0f34a0cb76$export$9f2dfe8048dfb22b($32e82c0f34a0cb76$export$ffb0004e005737fa, {
        key: (slotKey && !(0, $a5gC8.isSymbol)(slotKey) ? slotKey : `_${name}`) + // #7256 force differentiate fallback content from actual content
        (!validSlotContent && fallback ? "_fb" : "")
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $32e82c0f34a0cb76$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$32e82c0f34a0cb76$export$3868d13f8734ae81(child)) return true;
        if (child.type === $32e82c0f34a0cb76$export$4d299b491347818a) return false;
        if (child.type === $32e82c0f34a0cb76$export$ffb0004e005737fa && !$32e82c0f34a0cb76$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $32e82c0f34a0cb76$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $a5gC8.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $32e82c0f34a0cb76$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($32e82c0f34a0cb76$var$isStatefulComponent(i)) return $32e82c0f34a0cb76$var$getComponentPublicInstance(i);
    return $32e82c0f34a0cb76$var$getPublicInstance(i.parent);
};
const $32e82c0f34a0cb76$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $a5gC8.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$32e82c0f34a0cb76$var$getPublicInstance(i.parent),
    $root: (i)=>$32e82c0f34a0cb76$var$getPublicInstance(i.root),
    $host: (i)=>i.ce,
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $32e82c0f34a0cb76$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            $32e82c0f34a0cb76$var$queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = $32e82c0f34a0cb76$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $32e82c0f34a0cb76$var$instanceWatch.bind(i) : (0, $a5gC8.NOOP)
});
const $32e82c0f34a0cb76$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $32e82c0f34a0cb76$var$hasSetupBinding = (state, key)=>state !== (0, $a5gC8.EMPTY_OBJ) && !state.__isScriptSetup && (0, $a5gC8.hasOwn)(state, key);
const $32e82c0f34a0cb76$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($32e82c0f34a0cb76$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $a5gC8.EMPTY_OBJ) && (0, $a5gC8.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $a5gC8.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $a5gC8.EMPTY_OBJ) && (0, $a5gC8.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $32e82c0f34a0cb76$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $32e82c0f34a0cb76$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $9K9BQ.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $a5gC8.EMPTY_OBJ) && (0, $a5gC8.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $a5gC8.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($32e82c0f34a0cb76$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (data !== (0, $a5gC8.EMPTY_OBJ) && (0, $a5gC8.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $a5gC8.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, propsOptions: propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, $a5gC8.EMPTY_OBJ) && (0, $a5gC8.hasOwn)(data, key) || $32e82c0f34a0cb76$var$hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $a5gC8.hasOwn)(normalizedProps, key) || (0, $a5gC8.hasOwn)(ctx, key) || (0, $a5gC8.hasOwn)($32e82c0f34a0cb76$var$publicPropertiesMap, key) || (0, $a5gC8.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $a5gC8.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $32e82c0f34a0cb76$var$target;
const $32e82c0f34a0cb76$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $a5gC8.extend)({}, $32e82c0f34a0cb76$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $32e82c0f34a0cb76$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $a5gC8.isGloballyAllowed)(key);
        return has;
    }
});
function $32e82c0f34a0cb76$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($32e82c0f34a0cb76$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$32e82c0f34a0cb76$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $a5gC8.NOOP)
        });
    });
    return target;
}
function $32e82c0f34a0cb76$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $a5gC8.NOOP)
        });
    });
}
function $32e82c0f34a0cb76$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $9K9BQ.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($32e82c0f34a0cb76$var$isReservedPrefix(key[0])) {
                $32e82c0f34a0cb76$var$warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $a5gC8.NOOP)
            });
        }
    });
}
const $32e82c0f34a0cb76$var$warnRuntimeUsage = (method)=>$32e82c0f34a0cb76$var$warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $32e82c0f34a0cb76$export$80b33eababae110e() {
    return null;
}
function $32e82c0f34a0cb76$export$51ecece22fc17ddc() {
    return null;
}
function $32e82c0f34a0cb76$export$da25b65ca24b518a(exposed) {}
function $32e82c0f34a0cb76$export$77e79129327f3d0d(options) {}
function $32e82c0f34a0cb76$export$1b3acd4bb805b712() {
    return null;
}
function $32e82c0f34a0cb76$export$acd55aa037e791bb() {}
function $32e82c0f34a0cb76$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $32e82c0f34a0cb76$export$9203a8e84125433c() {
    return $32e82c0f34a0cb76$var$getContext().slots;
}
function $32e82c0f34a0cb76$export$75e29435042cd2ea() {
    return $32e82c0f34a0cb76$var$getContext().attrs;
}
function $32e82c0f34a0cb76$var$getContext() {
    const i = $32e82c0f34a0cb76$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $32e82c0f34a0cb76$var$createSetupContext(i));
}
function $32e82c0f34a0cb76$var$normalizePropsOrEmits(props) {
    return (0, $a5gC8.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $32e82c0f34a0cb76$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $32e82c0f34a0cb76$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $a5gC8.isArray)(opt) || (0, $a5gC8.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $32e82c0f34a0cb76$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $a5gC8.isArray)(a) && (0, $a5gC8.isArray)(b)) return a.concat(b);
    return (0, $a5gC8.extend)({}, $32e82c0f34a0cb76$var$normalizePropsOrEmits(a), $32e82c0f34a0cb76$var$normalizePropsOrEmits(b));
}
function $32e82c0f34a0cb76$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $32e82c0f34a0cb76$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $32e82c0f34a0cb76$export$f13e630aa3915748();
    let awaitable = getAwaitable();
    $32e82c0f34a0cb76$var$unsetCurrentInstance();
    if ((0, $a5gC8.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $32e82c0f34a0cb76$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$32e82c0f34a0cb76$var$setCurrentInstance(ctx)
    ];
}
function $32e82c0f34a0cb76$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $32e82c0f34a0cb76$var$warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $32e82c0f34a0cb76$var$shouldCacheAccess = true;
function $32e82c0f34a0cb76$var$applyOptions(instance) {
    const options = $32e82c0f34a0cb76$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $32e82c0f34a0cb76$var$shouldCacheAccess = false;
    if (options.beforeCreate) $32e82c0f34a0cb76$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $32e82c0f34a0cb76$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $a5gC8.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $a5gC8.isObject)(data)) ;
        else instance.data = (0, $9K9BQ.reactive)(data);
    }
    $32e82c0f34a0cb76$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $a5gC8.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $a5gC8.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $a5gC8.NOOP);
        const set = !(0, $a5gC8.isFunction)(opt) && (0, $a5gC8.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $a5gC8.NOOP);
        const c = $32e82c0f34a0cb76$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$32e82c0f34a0cb76$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $a5gC8.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $32e82c0f34a0cb76$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $32e82c0f34a0cb76$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $a5gC8.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($32e82c0f34a0cb76$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($32e82c0f34a0cb76$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($32e82c0f34a0cb76$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($32e82c0f34a0cb76$export$5876c47052fb88b1, updated);
    registerLifecycleHook($32e82c0f34a0cb76$export$ba52d824b95a2154, activated);
    registerLifecycleHook($32e82c0f34a0cb76$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($32e82c0f34a0cb76$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($32e82c0f34a0cb76$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($32e82c0f34a0cb76$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($32e82c0f34a0cb76$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($32e82c0f34a0cb76$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($32e82c0f34a0cb76$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $a5gC8.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $a5gC8.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) $32e82c0f34a0cb76$var$markAsyncBoundary(instance);
}
function $32e82c0f34a0cb76$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $a5gC8.NOOP)) {
    if ((0, $a5gC8.isArray)(injectOptions)) injectOptions = $32e82c0f34a0cb76$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $a5gC8.isObject)(opt)) {
            if ("default" in opt) injected = $32e82c0f34a0cb76$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $32e82c0f34a0cb76$export$a976684a0efeb93f(opt.from || key);
        } else injected = $32e82c0f34a0cb76$export$a976684a0efeb93f(opt);
        if ((0, $9K9BQ.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $32e82c0f34a0cb76$var$callHook(hook, instance, type) {
    $32e82c0f34a0cb76$export$dae85862a8d94378((0, $a5gC8.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $32e82c0f34a0cb76$var$createWatcher(raw, ctx, publicThis, key) {
    let getter = key.includes(".") ? $32e82c0f34a0cb76$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $a5gC8.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $a5gC8.isFunction)(handler)) $32e82c0f34a0cb76$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $a5gC8.isFunction)(raw)) $32e82c0f34a0cb76$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $a5gC8.isObject)(raw)) {
        if ((0, $a5gC8.isArray)(raw)) raw.forEach((r)=>$32e82c0f34a0cb76$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $a5gC8.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $a5gC8.isFunction)(handler)) $32e82c0f34a0cb76$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $32e82c0f34a0cb76$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$32e82c0f34a0cb76$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $32e82c0f34a0cb76$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $a5gC8.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $32e82c0f34a0cb76$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $32e82c0f34a0cb76$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$32e82c0f34a0cb76$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $32e82c0f34a0cb76$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $32e82c0f34a0cb76$var$internalOptionMergeStrats = {
    data: $32e82c0f34a0cb76$var$mergeDataFn,
    props: $32e82c0f34a0cb76$var$mergeEmitsOrPropsOptions,
    emits: $32e82c0f34a0cb76$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $32e82c0f34a0cb76$var$mergeObjectOptions,
    computed: $32e82c0f34a0cb76$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $32e82c0f34a0cb76$var$mergeAsArray,
    created: $32e82c0f34a0cb76$var$mergeAsArray,
    beforeMount: $32e82c0f34a0cb76$var$mergeAsArray,
    mounted: $32e82c0f34a0cb76$var$mergeAsArray,
    beforeUpdate: $32e82c0f34a0cb76$var$mergeAsArray,
    updated: $32e82c0f34a0cb76$var$mergeAsArray,
    beforeDestroy: $32e82c0f34a0cb76$var$mergeAsArray,
    beforeUnmount: $32e82c0f34a0cb76$var$mergeAsArray,
    destroyed: $32e82c0f34a0cb76$var$mergeAsArray,
    unmounted: $32e82c0f34a0cb76$var$mergeAsArray,
    activated: $32e82c0f34a0cb76$var$mergeAsArray,
    deactivated: $32e82c0f34a0cb76$var$mergeAsArray,
    errorCaptured: $32e82c0f34a0cb76$var$mergeAsArray,
    serverPrefetch: $32e82c0f34a0cb76$var$mergeAsArray,
    // assets
    components: $32e82c0f34a0cb76$var$mergeObjectOptions,
    directives: $32e82c0f34a0cb76$var$mergeObjectOptions,
    // watch
    watch: $32e82c0f34a0cb76$var$mergeWatchOptions,
    // provide / inject
    provide: $32e82c0f34a0cb76$var$mergeDataFn,
    inject: $32e82c0f34a0cb76$var$mergeInject
};
function $32e82c0f34a0cb76$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $a5gC8.extend)((0, $a5gC8.isFunction)(to) ? to.call(this, this) : to, (0, $a5gC8.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $32e82c0f34a0cb76$var$mergeInject(to, from) {
    return $32e82c0f34a0cb76$var$mergeObjectOptions($32e82c0f34a0cb76$var$normalizeInject(to), $32e82c0f34a0cb76$var$normalizeInject(from));
}
function $32e82c0f34a0cb76$var$normalizeInject(raw) {
    if ((0, $a5gC8.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $32e82c0f34a0cb76$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $32e82c0f34a0cb76$var$mergeObjectOptions(to, from) {
    return to ? (0, $a5gC8.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $32e82c0f34a0cb76$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $a5gC8.isArray)(to) && (0, $a5gC8.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $a5gC8.extend)(/* @__PURE__ */ Object.create(null), $32e82c0f34a0cb76$var$normalizePropsOrEmits(to), $32e82c0f34a0cb76$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $32e82c0f34a0cb76$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $a5gC8.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $32e82c0f34a0cb76$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $32e82c0f34a0cb76$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $a5gC8.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $32e82c0f34a0cb76$var$uid$1 = 0;
function $32e82c0f34a0cb76$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $a5gC8.isFunction)(rootComponent)) rootComponent = (0, $a5gC8.extend)({}, rootComponent);
        if (rootProps != null && !(0, $a5gC8.isObject)(rootProps)) rootProps = null;
        const context = $32e82c0f34a0cb76$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        const pluginCleanupFns = [];
        let isMounted = false;
        const app = context.app = {
            _uid: $32e82c0f34a0cb76$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $32e82c0f34a0cb76$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $a5gC8.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $a5gC8.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = app._ceVNode || $32e82c0f34a0cb76$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $32e82c0f34a0cb76$var$devtoolsInitApp(app, $32e82c0f34a0cb76$export$83d89fbfd8236492);
                    }
                    return $32e82c0f34a0cb76$var$getComponentPublicInstance(vnode.component);
                }
            },
            onUnmount (cleanupFn) {
                pluginCleanupFns.push(cleanupFn);
            },
            unmount () {
                if (isMounted) {
                    $32e82c0f34a0cb76$export$dae85862a8d94378(pluginCleanupFns, app._instance, 16);
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $32e82c0f34a0cb76$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = $32e82c0f34a0cb76$var$currentApp;
                $32e82c0f34a0cb76$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $32e82c0f34a0cb76$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let $32e82c0f34a0cb76$var$currentApp = null;
function $32e82c0f34a0cb76$export$abe1e183e22e10ad(key, value) {
    if (!$32e82c0f34a0cb76$var$currentInstance) ;
    else {
        let provides = $32e82c0f34a0cb76$var$currentInstance.provides;
        const parentProvides = $32e82c0f34a0cb76$var$currentInstance.parent && $32e82c0f34a0cb76$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $32e82c0f34a0cb76$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $32e82c0f34a0cb76$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $32e82c0f34a0cb76$var$currentInstance || $32e82c0f34a0cb76$var$currentRenderingInstance;
    if (instance || $32e82c0f34a0cb76$var$currentApp) {
        const provides = $32e82c0f34a0cb76$var$currentApp ? $32e82c0f34a0cb76$var$currentApp._context.provides : instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $a5gC8.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $32e82c0f34a0cb76$export$caf6761f24fc571a() {
    return !!($32e82c0f34a0cb76$var$currentInstance || $32e82c0f34a0cb76$var$currentRenderingInstance || $32e82c0f34a0cb76$var$currentApp);
}
const $32e82c0f34a0cb76$var$internalObjectProto = {};
const $32e82c0f34a0cb76$var$createInternalObject = ()=>Object.create($32e82c0f34a0cb76$var$internalObjectProto);
const $32e82c0f34a0cb76$var$isInternalObject = (obj)=>Object.getPrototypeOf(obj) === $32e82c0f34a0cb76$var$internalObjectProto;
function $32e82c0f34a0cb76$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = $32e82c0f34a0cb76$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $32e82c0f34a0cb76$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $9K9BQ.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $32e82c0f34a0cb76$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $32e82c0f34a0cb76$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $9K9BQ.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($32e82c0f34a0cb76$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, $a5gC8.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $a5gC8.camelize)(key);
                        props[camelizedKey] = $32e82c0f34a0cb76$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($32e82c0f34a0cb76$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $a5gC8.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $a5gC8.hyphenate)(key)) === key || !(0, $a5gC8.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $32e82c0f34a0cb76$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $a5gC8.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $9K9BQ.trigger)(instance.attrs, "set", "");
}
function $32e82c0f34a0cb76$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $a5gC8.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, $a5gC8.hasOwn)(options, camelKey = (0, $a5gC8.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$32e82c0f34a0cb76$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $9K9BQ.toRaw)(props);
        const castValues = rawCastValues || (0, $a5gC8.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $32e82c0f34a0cb76$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $a5gC8.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $32e82c0f34a0cb76$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $a5gC8.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $a5gC8.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = $32e82c0f34a0cb76$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
            if (instance.ce) instance.ce._setProp(key, value);
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $a5gC8.hyphenate)(key))) value = true;
        }
    }
    return value;
}
const $32e82c0f34a0cb76$var$mixinPropsCache = /* @__PURE__ */ new WeakMap();
function $32e82c0f34a0cb76$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $32e82c0f34a0cb76$var$mixinPropsCache : appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $a5gC8.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $32e82c0f34a0cb76$var$normalizePropsOptions(raw2, appContext, true);
            (0, $a5gC8.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $a5gC8.isObject)(comp)) cache.set(comp, (0, $a5gC8.EMPTY_ARR));
        return 0, $a5gC8.EMPTY_ARR;
    }
    if ((0, $a5gC8.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $a5gC8.camelize)(raw[i]);
        if ($32e82c0f34a0cb76$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $a5gC8.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $a5gC8.camelize)(key);
        if ($32e82c0f34a0cb76$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $a5gC8.isArray)(opt) || (0, $a5gC8.isFunction)(opt) ? {
                type: opt
            } : (0, $a5gC8.extend)({}, opt);
            const propType = prop.type;
            let shouldCast = false;
            let shouldCastTrue = true;
            if ((0, $a5gC8.isArray)(propType)) for(let index = 0; index < propType.length; ++index){
                const type = propType[index];
                const typeName = (0, $a5gC8.isFunction)(type) && type.name;
                if (typeName === "Boolean") {
                    shouldCast = true;
                    break;
                } else if (typeName === "String") shouldCastTrue = false;
            }
            else shouldCast = (0, $a5gC8.isFunction)(propType) && propType.name === "Boolean";
            prop[0 /* shouldCast */ ] = shouldCast;
            prop[1 /* shouldCastTrue */ ] = shouldCastTrue;
            if (shouldCast || (0, $a5gC8.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $a5gC8.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $32e82c0f34a0cb76$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $a5gC8.isReservedProp)(key)) return true;
    return false;
}
function $32e82c0f34a0cb76$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $32e82c0f34a0cb76$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $9K9BQ.toRaw)(props);
    const options = instance.propsOptions[0];
    const camelizePropsKey = Object.keys(rawProps).map((key)=>(0, $a5gC8.camelize)(key));
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $32e82c0f34a0cb76$var$validateProp(key, resolvedValues[key], opt, resolvedValues, !camelizePropsKey.includes(key));
    }
}
function $32e82c0f34a0cb76$var$validateProp(name, value, prop, props, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $32e82c0f34a0cb76$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $a5gC8.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $32e82c0f34a0cb76$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $32e82c0f34a0cb76$var$warn$1($32e82c0f34a0cb76$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $32e82c0f34a0cb76$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $32e82c0f34a0cb76$var$isSimpleType = /* @__PURE__ */ (0, $a5gC8.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $32e82c0f34a0cb76$var$assertType(value, type) {
    let valid;
    const expectedType = $32e82c0f34a0cb76$var$getType(type);
    if (expectedType === "null") valid = value === null;
    else if ($32e82c0f34a0cb76$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $a5gC8.isObject)(value);
    else if (expectedType === "Array") valid = (0, $a5gC8.isArray)(value);
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $32e82c0f34a0cb76$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $a5gC8.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $a5gC8.toRawType)(value);
    const expectedValue = $32e82c0f34a0cb76$var$styleValue(value, expectedType);
    const receivedValue = $32e82c0f34a0cb76$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $32e82c0f34a0cb76$var$isExplicable(expectedType) && !$32e82c0f34a0cb76$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($32e82c0f34a0cb76$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $32e82c0f34a0cb76$var$styleValue(value, type) {
    if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function $32e82c0f34a0cb76$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $32e82c0f34a0cb76$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $32e82c0f34a0cb76$var$isInternalKey = (key)=>key[0] === "_" || key === "$stable";
const $32e82c0f34a0cb76$var$normalizeSlotValue = (value)=>(0, $a5gC8.isArray)(value) ? value.map($32e82c0f34a0cb76$var$normalizeVNode) : [
        $32e82c0f34a0cb76$var$normalizeVNode(value)
    ];
const $32e82c0f34a0cb76$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $32e82c0f34a0cb76$export$694b237e827a3d23((...args)=>{
        return $32e82c0f34a0cb76$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $32e82c0f34a0cb76$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($32e82c0f34a0cb76$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $a5gC8.isFunction)(value)) slots[key] = $32e82c0f34a0cb76$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $32e82c0f34a0cb76$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $32e82c0f34a0cb76$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $32e82c0f34a0cb76$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $32e82c0f34a0cb76$var$assignSlots = (slots, children, optimized)=>{
    for(const key in children)if (optimized || key !== "_") slots[key] = children[key];
};
const $32e82c0f34a0cb76$var$initSlots = (instance, children, optimized)=>{
    const slots = instance.slots = $32e82c0f34a0cb76$var$createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            $32e82c0f34a0cb76$var$assignSlots(slots, children, optimized);
            if (optimized) (0, $a5gC8.def)(slots, "_", type, true);
        } else $32e82c0f34a0cb76$var$normalizeObjectSlots(children, slots);
    } else if (children) $32e82c0f34a0cb76$var$normalizeVNodeSlots(instance, children);
};
const $32e82c0f34a0cb76$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $a5gC8.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else $32e82c0f34a0cb76$var$assignSlots(slots, children, optimized);
        } else {
            needDeletionCheck = !children.$stable;
            $32e82c0f34a0cb76$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $32e82c0f34a0cb76$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$32e82c0f34a0cb76$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
let $32e82c0f34a0cb76$var$supported;
let $32e82c0f34a0cb76$var$perf;
function $32e82c0f34a0cb76$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $32e82c0f34a0cb76$var$isSupported()) $32e82c0f34a0cb76$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $32e82c0f34a0cb76$var$devtoolsPerfStart(instance, type, $32e82c0f34a0cb76$var$isSupported() ? $32e82c0f34a0cb76$var$perf.now() : Date.now());
}
function $32e82c0f34a0cb76$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $32e82c0f34a0cb76$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        $32e82c0f34a0cb76$var$perf.mark(endTag);
        $32e82c0f34a0cb76$var$perf.measure(`<${$32e82c0f34a0cb76$var$formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        $32e82c0f34a0cb76$var$perf.clearMarks(startTag);
        $32e82c0f34a0cb76$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $32e82c0f34a0cb76$var$devtoolsPerfEnd(instance, type, $32e82c0f34a0cb76$var$isSupported() ? $32e82c0f34a0cb76$var$perf.now() : Date.now());
}
function $32e82c0f34a0cb76$var$isSupported() {
    if ($32e82c0f34a0cb76$var$supported !== void 0) return $32e82c0f34a0cb76$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $32e82c0f34a0cb76$var$supported = true;
        $32e82c0f34a0cb76$var$perf = window.performance;
    } else $32e82c0f34a0cb76$var$supported = false;
    return $32e82c0f34a0cb76$var$supported;
}
function $32e82c0f34a0cb76$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $a5gC8.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $a5gC8.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $a5gC8.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const $32e82c0f34a0cb76$var$queuePostRenderEffect = $32e82c0f34a0cb76$var$queueEffectWithSuspense;
function $32e82c0f34a0cb76$export$53ae2f996c64e9a(options) {
    return $32e82c0f34a0cb76$var$baseCreateRenderer(options);
}
function $32e82c0f34a0cb76$export$200524cf0d997ff0(options) {
    return $32e82c0f34a0cb76$var$baseCreateRenderer(options, $32e82c0f34a0cb76$var$createHydrationFunctions);
}
function $32e82c0f34a0cb76$var$baseCreateRenderer(options, createHydrationFns) {
    $32e82c0f34a0cb76$var$initFeatureFlags();
    const target = (0, $a5gC8.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $32e82c0f34a0cb76$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $a5gC8.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$32e82c0f34a0cb76$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $32e82c0f34a0cb76$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $32e82c0f34a0cb76$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $32e82c0f34a0cb76$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $32e82c0f34a0cb76$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $32e82c0f34a0cb76$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $32e82c0f34a0cb76$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $32e82c0f34a0cb76$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $a5gC8.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, parentComponent);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $32e82c0f34a0cb76$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $a5gC8.def)(el, "__vnode", vnode, true);
            (0, $a5gC8.def)(el, "__vueParentComponent", parentComponent, true);
        }
        if (dirs) $32e82c0f34a0cb76$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $32e82c0f34a0cb76$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $32e82c0f34a0cb76$var$queuePostRenderEffect(()=>{
            vnodeHook && $32e82c0f34a0cb76$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $32e82c0f34a0cb76$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree || $32e82c0f34a0cb76$var$isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $32e82c0f34a0cb76$var$cloneIfMounted(children[i]) : $32e82c0f34a0cb76$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        if (__VUE_PROD_DEVTOOLS__) el.__vnode = n2;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $a5gC8.EMPTY_OBJ);
        const newProps = n2.props || (0, $a5gC8.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $32e82c0f34a0cb76$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $32e82c0f34a0cb76$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $32e82c0f34a0cb76$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $32e82c0f34a0cb76$var$toggleRecurse(parentComponent, true);
        if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) hostSetElementText(el, "");
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $32e82c0f34a0cb76$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $32e82c0f34a0cb76$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, oldProps, newProps, parentComponent, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, oldProps, newProps, parentComponent, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $32e82c0f34a0cb76$var$queuePostRenderEffect(()=>{
            vnodeHook && $32e82c0f34a0cb76$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $32e82c0f34a0cb76$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $32e82c0f34a0cb76$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$32e82c0f34a0cb76$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, oldProps, newProps, parentComponent, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $a5gC8.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $a5gC8.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, parentComponent);
            }
            for(const key in newProps){
                if ((0, $a5gC8.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $32e82c0f34a0cb76$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = $32e82c0f34a0cb76$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($32e82c0f34a0cb76$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $32e82c0f34a0cb76$var$setupComponent(instance, false, optimized);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $32e82c0f34a0cb76$export$bf5c4cf060303d58($32e82c0f34a0cb76$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($32e82c0f34a0cb76$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent, root: root, type: type } = instance;
                const isAsyncWrapperVNode = $32e82c0f34a0cb76$var$isAsyncWrapper(initialVNode);
                $32e82c0f34a0cb76$var$toggleRecurse(instance, false);
                if (bm) (0, $a5gC8.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $32e82c0f34a0cb76$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $32e82c0f34a0cb76$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $32e82c0f34a0cb76$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode && type.__asyncHydrate) type.__asyncHydrate(el, instance, hydrateSubTree);
                    else hydrateSubTree();
                } else {
                    if (root.ce) root.ce._injectChildStyle(type);
                    const subTree = instance.subTree = $32e82c0f34a0cb76$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) $32e82c0f34a0cb76$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $32e82c0f34a0cb76$var$queuePostRenderEffect(()=>$32e82c0f34a0cb76$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $32e82c0f34a0cb76$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $32e82c0f34a0cb76$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $32e82c0f34a0cb76$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                {
                    const nonHydratedAsyncRoot = $32e82c0f34a0cb76$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            if (!instance.isUnmounted) componentUpdateFn();
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                $32e82c0f34a0cb76$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $a5gC8.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $32e82c0f34a0cb76$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $32e82c0f34a0cb76$var$toggleRecurse(instance, true);
                const nextTree = $32e82c0f34a0cb76$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $32e82c0f34a0cb76$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $32e82c0f34a0cb76$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $32e82c0f34a0cb76$var$queuePostRenderEffect(()=>$32e82c0f34a0cb76$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $32e82c0f34a0cb76$var$devtoolsComponentUpdated(instance);
            }
        };
        instance.scope.on();
        const effect = instance.effect = new (0, $9K9BQ.ReactiveEffect)(componentUpdateFn);
        instance.scope.off();
        const update = instance.update = effect.run.bind(effect);
        const job = instance.job = effect.runIfDirty.bind(effect);
        job.i = instance;
        job.id = instance.uid;
        effect.scheduler = ()=>$32e82c0f34a0cb76$var$queueJob(job);
        $32e82c0f34a0cb76$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $32e82c0f34a0cb76$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $32e82c0f34a0cb76$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $9K9BQ.pauseTracking)();
        $32e82c0f34a0cb76$var$flushPreFlushCbs(instance);
        (0, $9K9BQ.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $a5gC8.EMPTY_ARR);
        c2 = c2 || (0, $a5gC8.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $32e82c0f34a0cb76$var$cloneIfMounted(c2[i]) : $32e82c0f34a0cb76$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $32e82c0f34a0cb76$var$cloneIfMounted(c2[i]) : $32e82c0f34a0cb76$var$normalizeVNode(c2[i]);
            if ($32e82c0f34a0cb76$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $32e82c0f34a0cb76$var$cloneIfMounted(c2[e2]) : $32e82c0f34a0cb76$var$normalizeVNode(c2[e2]);
            if ($32e82c0f34a0cb76$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $32e82c0f34a0cb76$var$cloneIfMounted(c2[i]) : $32e82c0f34a0cb76$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $32e82c0f34a0cb76$var$cloneIfMounted(c2[i]) : $32e82c0f34a0cb76$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $32e82c0f34a0cb76$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $32e82c0f34a0cb76$var$getSequence(newIndexToOldIndexMap) : (0, $a5gC8.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $32e82c0f34a0cb76$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $32e82c0f34a0cb76$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $32e82c0f34a0cb76$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>hostInsert(el, container, anchor);
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs, cacheIndex: cacheIndex } = vnode;
        if (patchFlag === -2) optimized = false;
        if (ref != null) $32e82c0f34a0cb76$var$setRef(ref, null, parentSuspense, vnode, true);
        if (cacheIndex != null) parentComponent.renderCache[cacheIndex] = void 0;
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$32e82c0f34a0cb76$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $32e82c0f34a0cb76$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $32e82c0f34a0cb76$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
            else if (dynamicChildren && // #5154
            // when v-once is used inside a block, setBlockTracking(-1) marks the
            // parent block with hasOnce: true
            // so that it doesn't take the fast path during unmount - otherwise
            // components nested in v-once are never unmounted.
            !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $32e82c0f34a0cb76$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $32e82c0f34a0cb76$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $32e82c0f34a0cb76$var$queuePostRenderEffect(()=>{
            vnodeHook && $32e82c0f34a0cb76$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $32e82c0f34a0cb76$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $32e82c0f34a0cb76$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $32e82c0f34a0cb76$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, job: job, subTree: subTree, um: um, m: m, a: a } = instance;
        $32e82c0f34a0cb76$var$invalidateMount(m);
        $32e82c0f34a0cb76$var$invalidateMount(a);
        if (bum) (0, $a5gC8.invokeArrayFns)(bum);
        scope.stop();
        if (job) {
            job.flags |= 8;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $32e82c0f34a0cb76$var$queuePostRenderEffect(um, parentSuspense);
        $32e82c0f34a0cb76$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $32e82c0f34a0cb76$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        const el = hostNextSibling(vnode.anchor || vnode.el);
        const teleportEnd = el && el[$32e82c0f34a0cb76$var$TeleportEndKey];
        return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        container._vnode = vnode;
        if (!isFlushing) {
            isFlushing = true;
            $32e82c0f34a0cb76$var$flushPreFlushCbs();
            $32e82c0f34a0cb76$var$flushPostFlushCbs();
            isFlushing = false;
        }
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $32e82c0f34a0cb76$var$createAppAPI(render, hydrate)
    };
}
function $32e82c0f34a0cb76$var$resolveChildrenNamespace({ type: type, props: props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $32e82c0f34a0cb76$var$toggleRecurse({ effect: effect, job: job }, allowed) {
    if (allowed) {
        effect.flags |= 32;
        job.flags |= 4;
    } else {
        effect.flags &= -33;
        job.flags &= -5;
    }
}
function $32e82c0f34a0cb76$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $32e82c0f34a0cb76$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $a5gC8.isArray)(ch1) && (0, $a5gC8.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $32e82c0f34a0cb76$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow && c2.patchFlag !== -2) $32e82c0f34a0cb76$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $32e82c0f34a0cb76$export$5f1af8db9871e1d6) c2.el = c1.el;
    }
}
function $32e82c0f34a0cb76$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $32e82c0f34a0cb76$var$locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $32e82c0f34a0cb76$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
function $32e82c0f34a0cb76$var$invalidateMount(hooks) {
    if (hooks) for(let i = 0; i < hooks.length; i++)hooks[i].flags |= 8;
}
const $32e82c0f34a0cb76$export$f2549a27e18acf2d = Symbol.for("v-scx");
const $32e82c0f34a0cb76$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $32e82c0f34a0cb76$export$a976684a0efeb93f($32e82c0f34a0cb76$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $32e82c0f34a0cb76$export$ede35fc0e5500309(effect, options) {
    return $32e82c0f34a0cb76$var$doWatch(effect, null, options);
}
function $32e82c0f34a0cb76$export$b7f27ea67102d543(effect, options) {
    return $32e82c0f34a0cb76$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $32e82c0f34a0cb76$export$2035654f31b0e555(effect, options) {
    return $32e82c0f34a0cb76$var$doWatch(effect, null, {
        flush: "sync"
    });
}
function $32e82c0f34a0cb76$export$3db5d71bdb2d5499(source, cb, options) {
    return $32e82c0f34a0cb76$var$doWatch(source, cb, options);
}
function $32e82c0f34a0cb76$var$doWatch(source, cb, options = (0, $a5gC8.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, flush: flush, once: once } = options;
    const baseWatchOptions = (0, $a5gC8.extend)({}, options);
    const runsImmediately = cb && immediate || !cb && flush !== "post";
    let ssrCleanup;
    if ($32e82c0f34a0cb76$var$isInSSRComponentSetup) {
        if (flush === "sync") {
            const ctx = $32e82c0f34a0cb76$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else if (!runsImmediately) {
            const watchStopHandle = ()=>{};
            watchStopHandle.stop = (0, $a5gC8.NOOP);
            watchStopHandle.resume = (0, $a5gC8.NOOP);
            watchStopHandle.pause = (0, $a5gC8.NOOP);
            return watchStopHandle;
        }
    }
    const instance = $32e82c0f34a0cb76$var$currentInstance;
    baseWatchOptions.call = (fn, type, args)=>$32e82c0f34a0cb76$export$dae85862a8d94378(fn, instance, type, args);
    let isPre = false;
    if (flush === "post") baseWatchOptions.scheduler = (job)=>{
        $32e82c0f34a0cb76$var$queuePostRenderEffect(job, instance && instance.suspense);
    };
    else if (flush !== "sync") {
        isPre = true;
        baseWatchOptions.scheduler = (job, isFirstRun)=>{
            if (isFirstRun) job();
            else $32e82c0f34a0cb76$var$queueJob(job);
        };
    }
    baseWatchOptions.augmentJob = (job)=>{
        if (cb) job.flags |= 4;
        if (isPre) {
            job.flags |= 2;
            if (instance) {
                job.id = instance.uid;
                job.i = instance;
            }
        }
    };
    const watchHandle = (0, $9K9BQ.watch)(source, cb, baseWatchOptions);
    if ($32e82c0f34a0cb76$var$isInSSRComponentSetup) {
        if (ssrCleanup) ssrCleanup.push(watchHandle);
        else if (runsImmediately) watchHandle();
    }
    return watchHandle;
}
function $32e82c0f34a0cb76$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $a5gC8.isString)(source) ? source.includes(".") ? $32e82c0f34a0cb76$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $a5gC8.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = $32e82c0f34a0cb76$var$setCurrentInstance(this);
    const res = $32e82c0f34a0cb76$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $32e82c0f34a0cb76$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $32e82c0f34a0cb76$export$fb78bd113157f1a1(props, name, options = (0, $a5gC8.EMPTY_OBJ)) {
    const i = $32e82c0f34a0cb76$export$f13e630aa3915748();
    const camelizedName = (0, $a5gC8.camelize)(name);
    const hyphenatedName = (0, $a5gC8.hyphenate)(name);
    const modifiers = $32e82c0f34a0cb76$var$getModelModifiers(props, camelizedName);
    const res = (0, $9K9BQ.customRef)((track, trigger)=>{
        let localValue;
        let prevSetValue = (0, $a5gC8.EMPTY_OBJ);
        let prevEmittedValue;
        $32e82c0f34a0cb76$export$2035654f31b0e555(()=>{
            const propValue = props[camelizedName];
            if ((0, $a5gC8.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const emittedValue = options.set ? options.set(value) : value;
                if (!(0, $a5gC8.hasChanged)(emittedValue, localValue) && !(prevSetValue !== (0, $a5gC8.EMPTY_OBJ) && (0, $a5gC8.hasChanged)(value, prevSetValue))) return;
                const rawProps = i.vnode.props;
                if (!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps))) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, emittedValue);
                if ((0, $a5gC8.hasChanged)(value, emittedValue) && (0, $a5gC8.hasChanged)(value, prevSetValue) && !(0, $a5gC8.hasChanged)(emittedValue, prevEmittedValue)) trigger();
                prevSetValue = value;
                prevEmittedValue = emittedValue;
            }
        };
    });
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? modifiers || (0, $a5gC8.EMPTY_OBJ) : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
const $32e82c0f34a0cb76$var$getModelModifiers = (props, modelName)=>{
    return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${(0, $a5gC8.camelize)(modelName)}Modifiers`] || props[`${(0, $a5gC8.hyphenate)(modelName)}Modifiers`];
};
function $32e82c0f34a0cb76$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $a5gC8.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modifiers = isModelListener && $32e82c0f34a0cb76$var$getModelModifiers(props, event.slice(7));
    if (modifiers) {
        if (modifiers.trim) args = rawArgs.map((a)=>(0, $a5gC8.isString)(a) ? a.trim() : a);
        if (modifiers.number) args = rawArgs.map((0, $a5gC8.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $32e82c0f34a0cb76$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $a5gC8.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $a5gC8.toHandlerKey)((0, $a5gC8.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $a5gC8.toHandlerKey)((0, $a5gC8.hyphenate)(event))];
    if (handler) $32e82c0f34a0cb76$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $32e82c0f34a0cb76$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
function $32e82c0f34a0cb76$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $a5gC8.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $32e82c0f34a0cb76$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $a5gC8.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $a5gC8.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $a5gC8.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $a5gC8.extend)(normalized, raw);
    if ((0, $a5gC8.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $32e82c0f34a0cb76$var$isEmitListener(options, key) {
    if (!options || !(0, $a5gC8.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $a5gC8.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $a5gC8.hasOwn)(options, (0, $a5gC8.hyphenate)(key)) || (0, $a5gC8.hasOwn)(options, key);
}
let $32e82c0f34a0cb76$var$accessedAttrs = false;
function $32e82c0f34a0cb76$var$markAttrsAccessed() {
    $32e82c0f34a0cb76$var$accessedAttrs = true;
}
function $32e82c0f34a0cb76$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, props: props, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    const prev = $32e82c0f34a0cb76$var$setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = $32e82c0f34a0cb76$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $32e82c0f34a0cb76$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $32e82c0f34a0cb76$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $32e82c0f34a0cb76$var$blockStack.length = 0;
        $32e82c0f34a0cb76$export$d3da1ecaf1206c58(err, instance, 1);
        result = $32e82c0f34a0cb76$export$bf5c4cf060303d58($32e82c0f34a0cb76$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $a5gC8.isModelListener))) fallthroughAttrs = $32e82c0f34a0cb76$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $32e82c0f34a0cb76$export$ee4f9e12c0a92a1a(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = $32e82c0f34a0cb76$export$ee4f9e12c0a92a1a(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) $32e82c0f34a0cb76$export$7770a22486565649(root, vnode.transition);
    result = root;
    $32e82c0f34a0cb76$var$setCurrentRenderingInstance(prev);
    return result;
}
const $32e82c0f34a0cb76$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $32e82c0f34a0cb76$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $32e82c0f34a0cb76$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $32e82c0f34a0cb76$var$filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($32e82c0f34a0cb76$export$3868d13f8734ae81(child)) {
            if (child.type !== $32e82c0f34a0cb76$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $32e82c0f34a0cb76$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $a5gC8.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $32e82c0f34a0cb76$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $a5gC8.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $32e82c0f34a0cb76$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $32e82c0f34a0cb76$export$4d299b491347818a;
};
function $32e82c0f34a0cb76$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $32e82c0f34a0cb76$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$32e82c0f34a0cb76$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $32e82c0f34a0cb76$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $32e82c0f34a0cb76$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$32e82c0f34a0cb76$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $32e82c0f34a0cb76$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) root.el = vnode.el;
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
}
const $32e82c0f34a0cb76$var$isSuspense = (type)=>type.__isSuspense;
let $32e82c0f34a0cb76$var$suspenseId = 0;
const $32e82c0f34a0cb76$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $32e82c0f34a0cb76$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $32e82c0f34a0cb76$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $32e82c0f34a0cb76$var$hydrateSuspense,
    normalize: $32e82c0f34a0cb76$var$normalizeSuspenseChildren
};
const $32e82c0f34a0cb76$export$74bf444e3cd11ea5 = $32e82c0f34a0cb76$var$SuspenseImpl;
function $32e82c0f34a0cb76$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $a5gC8.isFunction)(eventListener)) eventListener();
}
function $32e82c0f34a0cb76$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $32e82c0f34a0cb76$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $32e82c0f34a0cb76$var$triggerEvent(vnode, "onPending");
        $32e82c0f34a0cb76$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $32e82c0f34a0cb76$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $32e82c0f34a0cb76$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($32e82c0f34a0cb76$var$isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $32e82c0f34a0cb76$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $32e82c0f34a0cb76$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $32e82c0f34a0cb76$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $32e82c0f34a0cb76$var$isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $32e82c0f34a0cb76$var$isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $32e82c0f34a0cb76$var$setActiveBranch(suspense, newBranch);
    } else {
        $32e82c0f34a0cb76$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $32e82c0f34a0cb76$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $32e82c0f34a0cb76$var$hasWarned = false;
function $32e82c0f34a0cb76$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $32e82c0f34a0cb76$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $a5gC8.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $32e82c0f34a0cb76$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2 } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor ? next(activeBranch) : anchor, 0);
                        $32e82c0f34a0cb76$export$59536a0199721cab(effects);
                    }
                };
                if (activeBranch) {
                    if (parentNode(activeBranch.el) === container2) anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            $32e82c0f34a0cb76$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $32e82c0f34a0cb76$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $32e82c0f34a0cb76$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            $32e82c0f34a0cb76$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $32e82c0f34a0cb76$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect, optimized2) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $32e82c0f34a0cb76$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $32e82c0f34a0cb76$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized2);
                if (placeholder) remove(placeholder);
                $32e82c0f34a0cb76$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $32e82c0f34a0cb76$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $32e82c0f34a0cb76$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $32e82c0f34a0cb76$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $32e82c0f34a0cb76$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $32e82c0f34a0cb76$var$normalizeSuspenseSlot(children.fallback) : $32e82c0f34a0cb76$export$bf5c4cf060303d58($32e82c0f34a0cb76$export$4d299b491347818a);
}
function $32e82c0f34a0cb76$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $a5gC8.isFunction)(s)) {
        const trackBlock = $32e82c0f34a0cb76$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $32e82c0f34a0cb76$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $32e82c0f34a0cb76$var$currentBlock;
            $32e82c0f34a0cb76$var$closeBlock();
        }
    }
    if ((0, $a5gC8.isArray)(s)) {
        const singleChild = $32e82c0f34a0cb76$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $32e82c0f34a0cb76$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $32e82c0f34a0cb76$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $a5gC8.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $32e82c0f34a0cb76$export$59536a0199721cab(fn);
}
function $32e82c0f34a0cb76$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $32e82c0f34a0cb76$var$updateHOCHostEl(parentComponent, el);
    }
}
function $32e82c0f34a0cb76$var$isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
const $32e82c0f34a0cb76$export$ffb0004e005737fa = Symbol.for("v-fgt");
const $32e82c0f34a0cb76$export$5f1af8db9871e1d6 = Symbol.for("v-txt");
const $32e82c0f34a0cb76$export$4d299b491347818a = Symbol.for("v-cmt");
const $32e82c0f34a0cb76$export$c1b9a1d3af45b7b6 = Symbol.for("v-stc");
const $32e82c0f34a0cb76$var$blockStack = [];
let $32e82c0f34a0cb76$var$currentBlock = null;
function $32e82c0f34a0cb76$export$e7eaa45e502fe5cc(disableTracking = false) {
    $32e82c0f34a0cb76$var$blockStack.push($32e82c0f34a0cb76$var$currentBlock = disableTracking ? null : []);
}
function $32e82c0f34a0cb76$var$closeBlock() {
    $32e82c0f34a0cb76$var$blockStack.pop();
    $32e82c0f34a0cb76$var$currentBlock = $32e82c0f34a0cb76$var$blockStack[$32e82c0f34a0cb76$var$blockStack.length - 1] || null;
}
let $32e82c0f34a0cb76$var$isBlockTreeEnabled = 1;
function $32e82c0f34a0cb76$export$c20bee82f26f1e27(value) {
    $32e82c0f34a0cb76$var$isBlockTreeEnabled += value;
    if (value < 0 && $32e82c0f34a0cb76$var$currentBlock) $32e82c0f34a0cb76$var$currentBlock.hasOnce = true;
}
function $32e82c0f34a0cb76$var$setupBlock(vnode) {
    vnode.dynamicChildren = $32e82c0f34a0cb76$var$isBlockTreeEnabled > 0 ? $32e82c0f34a0cb76$var$currentBlock || (0, $a5gC8.EMPTY_ARR) : null;
    $32e82c0f34a0cb76$var$closeBlock();
    if ($32e82c0f34a0cb76$var$isBlockTreeEnabled > 0 && $32e82c0f34a0cb76$var$currentBlock) $32e82c0f34a0cb76$var$currentBlock.push(vnode);
    return vnode;
}
function $32e82c0f34a0cb76$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $32e82c0f34a0cb76$var$setupBlock($32e82c0f34a0cb76$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $32e82c0f34a0cb76$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $32e82c0f34a0cb76$var$setupBlock($32e82c0f34a0cb76$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $32e82c0f34a0cb76$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $32e82c0f34a0cb76$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $32e82c0f34a0cb76$var$vnodeArgsTransformer;
function $32e82c0f34a0cb76$export$83beccd3afeeb809(transformer) {
    $32e82c0f34a0cb76$var$vnodeArgsTransformer = transformer;
}
const $32e82c0f34a0cb76$var$createVNodeWithArgsTransform = (...args)=>{
    return $32e82c0f34a0cb76$var$_createVNode(...$32e82c0f34a0cb76$var$vnodeArgsTransformer ? $32e82c0f34a0cb76$var$vnodeArgsTransformer(args, $32e82c0f34a0cb76$var$currentRenderingInstance) : args);
};
const $32e82c0f34a0cb76$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $32e82c0f34a0cb76$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $a5gC8.isString)(ref) || (0, $9K9BQ.isRef)(ref) || (0, $a5gC8.isFunction)(ref) ? {
        i: $32e82c0f34a0cb76$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $32e82c0f34a0cb76$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $32e82c0f34a0cb76$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $32e82c0f34a0cb76$var$normalizeKey(props),
        ref: props && $32e82c0f34a0cb76$var$normalizeRef(props),
        scopeId: $32e82c0f34a0cb76$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetStart: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $32e82c0f34a0cb76$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $32e82c0f34a0cb76$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $a5gC8.isString)(children) ? 8 : 16;
    if ($32e82c0f34a0cb76$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $32e82c0f34a0cb76$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $32e82c0f34a0cb76$var$currentBlock.push(vnode);
    return vnode;
}
const $32e82c0f34a0cb76$export$bf5c4cf060303d58 = $32e82c0f34a0cb76$var$_createVNode;
function $32e82c0f34a0cb76$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $32e82c0f34a0cb76$var$NULL_DYNAMIC_COMPONENT) type = $32e82c0f34a0cb76$export$4d299b491347818a;
    if ($32e82c0f34a0cb76$export$3868d13f8734ae81(type)) {
        const cloned = $32e82c0f34a0cb76$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $32e82c0f34a0cb76$var$normalizeChildren(cloned, children);
        if ($32e82c0f34a0cb76$var$isBlockTreeEnabled > 0 && !isBlockNode && $32e82c0f34a0cb76$var$currentBlock) {
            if (cloned.shapeFlag & 6) $32e82c0f34a0cb76$var$currentBlock[$32e82c0f34a0cb76$var$currentBlock.indexOf(type)] = cloned;
            else $32e82c0f34a0cb76$var$currentBlock.push(cloned);
        }
        cloned.patchFlag = -2;
        return cloned;
    }
    if ($32e82c0f34a0cb76$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $32e82c0f34a0cb76$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $a5gC8.isString)(klass)) props.class = (0, $a5gC8.normalizeClass)(klass);
        if ((0, $a5gC8.isObject)(style)) {
            if ((0, $9K9BQ.isProxy)(style) && !(0, $a5gC8.isArray)(style)) style = (0, $a5gC8.extend)({}, style);
            props.style = (0, $a5gC8.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $a5gC8.isString)(type) ? 1 : $32e82c0f34a0cb76$var$isSuspense(type) ? 128 : $32e82c0f34a0cb76$var$isTeleport(type) ? 64 : (0, $a5gC8.isObject)(type) ? 4 : (0, $a5gC8.isFunction)(type) ? 2 : 0;
    return $32e82c0f34a0cb76$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $32e82c0f34a0cb76$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $9K9BQ.isProxy)(props) || $32e82c0f34a0cb76$var$isInternalObject(props) ? (0, $a5gC8.extend)({}, props) : props;
}
function $32e82c0f34a0cb76$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children, transition: transition } = vnode;
    const mergedProps = extraProps ? $32e82c0f34a0cb76$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $32e82c0f34a0cb76$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $a5gC8.isArray)(ref) ? ref.concat($32e82c0f34a0cb76$var$normalizeRef(extraProps)) : [
            ref,
            $32e82c0f34a0cb76$var$normalizeRef(extraProps)
        ] : $32e82c0f34a0cb76$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetStart: vnode.targetStart,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $32e82c0f34a0cb76$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $32e82c0f34a0cb76$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $32e82c0f34a0cb76$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) $32e82c0f34a0cb76$export$7770a22486565649(cloned, transition.clone(cloned));
    return cloned;
}
function $32e82c0f34a0cb76$var$deepCloneVNode(vnode) {
    const cloned = $32e82c0f34a0cb76$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $a5gC8.isArray)(vnode.children)) cloned.children = vnode.children.map($32e82c0f34a0cb76$var$deepCloneVNode);
    return cloned;
}
function $32e82c0f34a0cb76$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $32e82c0f34a0cb76$export$bf5c4cf060303d58($32e82c0f34a0cb76$export$5f1af8db9871e1d6, null, text, flag);
}
function $32e82c0f34a0cb76$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $32e82c0f34a0cb76$export$bf5c4cf060303d58($32e82c0f34a0cb76$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $32e82c0f34a0cb76$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($32e82c0f34a0cb76$export$e7eaa45e502fe5cc(), $32e82c0f34a0cb76$export$9f2dfe8048dfb22b($32e82c0f34a0cb76$export$4d299b491347818a, null, text)) : $32e82c0f34a0cb76$export$bf5c4cf060303d58($32e82c0f34a0cb76$export$4d299b491347818a, null, text);
}
function $32e82c0f34a0cb76$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $32e82c0f34a0cb76$export$bf5c4cf060303d58($32e82c0f34a0cb76$export$4d299b491347818a);
    else if ((0, $a5gC8.isArray)(child)) return $32e82c0f34a0cb76$export$bf5c4cf060303d58($32e82c0f34a0cb76$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if ($32e82c0f34a0cb76$export$3868d13f8734ae81(child)) return $32e82c0f34a0cb76$var$cloneIfMounted(child);
    else return $32e82c0f34a0cb76$export$bf5c4cf060303d58($32e82c0f34a0cb76$export$5f1af8db9871e1d6, null, String(child));
}
function $32e82c0f34a0cb76$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $32e82c0f34a0cb76$export$ee4f9e12c0a92a1a(child);
}
function $32e82c0f34a0cb76$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $a5gC8.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $32e82c0f34a0cb76$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !$32e82c0f34a0cb76$var$isInternalObject(children)) children._ctx = $32e82c0f34a0cb76$var$currentRenderingInstance;
            else if (slotFlag === 3 && $32e82c0f34a0cb76$var$currentRenderingInstance) {
                if ($32e82c0f34a0cb76$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $a5gC8.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $32e82c0f34a0cb76$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $32e82c0f34a0cb76$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $32e82c0f34a0cb76$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $a5gC8.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $a5gC8.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $a5gC8.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $a5gC8.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $32e82c0f34a0cb76$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $32e82c0f34a0cb76$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $32e82c0f34a0cb76$var$emptyAppContext = $32e82c0f34a0cb76$var$createAppContext();
let $32e82c0f34a0cb76$var$uid = 0;
function $32e82c0f34a0cb76$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $32e82c0f34a0cb76$var$emptyAppContext;
    const instance = {
        uid: $32e82c0f34a0cb76$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        job: null,
        scope: new (0, $9K9BQ.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        ids: parent ? parent.ids : [
            "",
            0,
            0
        ],
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $32e82c0f34a0cb76$var$normalizePropsOptions(type, appContext),
        emitsOptions: $32e82c0f34a0cb76$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $a5gC8.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $a5gC8.EMPTY_OBJ),
        data: (0, $a5gC8.EMPTY_OBJ),
        props: (0, $a5gC8.EMPTY_OBJ),
        attrs: (0, $a5gC8.EMPTY_OBJ),
        slots: (0, $a5gC8.EMPTY_OBJ),
        refs: (0, $a5gC8.EMPTY_OBJ),
        setupState: (0, $a5gC8.EMPTY_OBJ),
        setupContext: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $32e82c0f34a0cb76$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $32e82c0f34a0cb76$var$currentInstance = null;
const $32e82c0f34a0cb76$export$f13e630aa3915748 = ()=>$32e82c0f34a0cb76$var$currentInstance || $32e82c0f34a0cb76$var$currentRenderingInstance;
let $32e82c0f34a0cb76$var$internalSetCurrentInstance;
let $32e82c0f34a0cb76$var$setInSSRSetupState;
{
    const g = (0, $a5gC8.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    $32e82c0f34a0cb76$var$internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>$32e82c0f34a0cb76$var$currentInstance = v1);
    $32e82c0f34a0cb76$var$setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>$32e82c0f34a0cb76$var$isInSSRComponentSetup = v1);
}const $32e82c0f34a0cb76$var$setCurrentInstance = (instance)=>{
    const prev = $32e82c0f34a0cb76$var$currentInstance;
    $32e82c0f34a0cb76$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        $32e82c0f34a0cb76$var$internalSetCurrentInstance(prev);
    };
};
const $32e82c0f34a0cb76$var$unsetCurrentInstance = ()=>{
    $32e82c0f34a0cb76$var$currentInstance && $32e82c0f34a0cb76$var$currentInstance.scope.off();
    $32e82c0f34a0cb76$var$internalSetCurrentInstance(null);
};
const $32e82c0f34a0cb76$var$isBuiltInTag = /* @__PURE__ */ (0, $a5gC8.makeMap)("slot,component");
function $32e82c0f34a0cb76$var$validateComponentName(name, { isNativeTag: isNativeTag }) {
    if ($32e82c0f34a0cb76$var$isBuiltInTag(name) || isNativeTag(name)) $32e82c0f34a0cb76$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $32e82c0f34a0cb76$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $32e82c0f34a0cb76$var$isInSSRComponentSetup = false;
function $32e82c0f34a0cb76$var$setupComponent(instance, isSSR = false, optimized = false) {
    isSSR && $32e82c0f34a0cb76$var$setInSSRSetupState(isSSR);
    const { props: props, children: children } = instance.vnode;
    const isStateful = $32e82c0f34a0cb76$var$isStatefulComponent(instance);
    $32e82c0f34a0cb76$var$initProps(instance, props, isStateful, isSSR);
    $32e82c0f34a0cb76$var$initSlots(instance, children, optimized);
    const setupResult = isStateful ? $32e82c0f34a0cb76$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $32e82c0f34a0cb76$var$setInSSRSetupState(false);
    return setupResult;
}
function $32e82c0f34a0cb76$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $32e82c0f34a0cb76$var$PublicInstanceProxyHandlers);
    const { setup: setup } = Component;
    if (setup) {
        (0, $9K9BQ.pauseTracking)();
        const setupContext = instance.setupContext = setup.length > 1 ? $32e82c0f34a0cb76$var$createSetupContext(instance) : null;
        const reset = $32e82c0f34a0cb76$var$setCurrentInstance(instance);
        const setupResult = $32e82c0f34a0cb76$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        const isAsyncSetup = (0, $a5gC8.isPromise)(setupResult);
        (0, $9K9BQ.resetTracking)();
        reset();
        if ((isAsyncSetup || instance.sp) && !$32e82c0f34a0cb76$var$isAsyncWrapper(instance)) $32e82c0f34a0cb76$var$markAsyncBoundary(instance);
        if (isAsyncSetup) {
            setupResult.then($32e82c0f34a0cb76$var$unsetCurrentInstance, $32e82c0f34a0cb76$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $32e82c0f34a0cb76$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $32e82c0f34a0cb76$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $32e82c0f34a0cb76$var$handleSetupResult(instance, setupResult, isSSR);
    } else $32e82c0f34a0cb76$var$finishComponentSetup(instance, isSSR);
}
function $32e82c0f34a0cb76$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $a5gC8.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $a5gC8.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $9K9BQ.proxyRefs)(setupResult);
    }
    $32e82c0f34a0cb76$var$finishComponentSetup(instance, isSSR);
}
let $32e82c0f34a0cb76$var$compile;
let $32e82c0f34a0cb76$var$installWithProxy;
function $32e82c0f34a0cb76$export$667bb5a67822b941(_compile) {
    $32e82c0f34a0cb76$var$compile = _compile;
    $32e82c0f34a0cb76$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $32e82c0f34a0cb76$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $32e82c0f34a0cb76$export$c93a9c496c5211fa = ()=>!$32e82c0f34a0cb76$var$compile;
function $32e82c0f34a0cb76$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $32e82c0f34a0cb76$var$compile && !Component.render) {
            const template = Component.template || $32e82c0f34a0cb76$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $a5gC8.extend)((0, $a5gC8.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $32e82c0f34a0cb76$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $a5gC8.NOOP);
        if ($32e82c0f34a0cb76$var$installWithProxy) $32e82c0f34a0cb76$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = $32e82c0f34a0cb76$var$setCurrentInstance(instance);
        (0, $9K9BQ.pauseTracking)();
        try {
            $32e82c0f34a0cb76$var$applyOptions(instance);
        } finally{
            (0, $9K9BQ.resetTracking)();
            reset();
        }
    }
}
const $32e82c0f34a0cb76$var$attrsProxyHandlers = {
    get (target, key) {
        (0, $9K9BQ.track)(target, "get", "");
        return target[key];
    }
};
function $32e82c0f34a0cb76$var$getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
        get (target, key) {
            (0, $9K9BQ.track)(instance, "get", "$slots");
            return target[key];
        }
    });
}
function $32e82c0f34a0cb76$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, $32e82c0f34a0cb76$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $32e82c0f34a0cb76$var$getComponentPublicInstance(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $9K9BQ.proxyRefs)((0, $9K9BQ.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $32e82c0f34a0cb76$var$publicPropertiesMap) return $32e82c0f34a0cb76$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $32e82c0f34a0cb76$var$publicPropertiesMap;
        }
    }));
    else return instance.proxy;
}
const $32e82c0f34a0cb76$var$classifyRE = /(?:^|[-_])(\w)/g;
const $32e82c0f34a0cb76$var$classify = (str)=>str.replace($32e82c0f34a0cb76$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $32e82c0f34a0cb76$var$getComponentName(Component, includeInferred = true) {
    return (0, $a5gC8.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $32e82c0f34a0cb76$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $32e82c0f34a0cb76$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $32e82c0f34a0cb76$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $32e82c0f34a0cb76$var$isClassComponent(value) {
    return (0, $a5gC8.isFunction)(value) && "__vccOpts" in value;
}
const $32e82c0f34a0cb76$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    const c = (0, $9K9BQ.computed)(getterOrOptions, debugOptions, $32e82c0f34a0cb76$var$isInSSRComponentSetup);
    return c;
};
function $32e82c0f34a0cb76$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, $a5gC8.isObject)(propsOrChildren) && !(0, $a5gC8.isArray)(propsOrChildren)) {
            if ($32e82c0f34a0cb76$export$3868d13f8734ae81(propsOrChildren)) return $32e82c0f34a0cb76$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            return $32e82c0f34a0cb76$export$bf5c4cf060303d58(type, propsOrChildren);
        } else return $32e82c0f34a0cb76$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $32e82c0f34a0cb76$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $32e82c0f34a0cb76$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
function $32e82c0f34a0cb76$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $9K9BQ.toRaw)(instance.props)));
        if (instance.setupState !== (0, $a5gC8.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $a5gC8.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $9K9BQ.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $a5gC8.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $a5gC8.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $9K9BQ.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $a5gC8.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $a5gC8.isArray)(opts) && opts.includes(key) || (0, $a5gC8.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, $9K9BQ.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $32e82c0f34a0cb76$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $32e82c0f34a0cb76$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
}
function $32e82c0f34a0cb76$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $a5gC8.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($32e82c0f34a0cb76$var$isBlockTreeEnabled > 0 && $32e82c0f34a0cb76$var$currentBlock) $32e82c0f34a0cb76$var$currentBlock.push(cached);
    return true;
}
const $32e82c0f34a0cb76$export$83d89fbfd8236492 = "3.5.12";
const $32e82c0f34a0cb76$export$c106dd0671a0fc2d = (0, $a5gC8.NOOP);
const $32e82c0f34a0cb76$export$795e0ad4a0e2ed30 = $32e82c0f34a0cb76$var$ErrorTypeStrings$1;
const $32e82c0f34a0cb76$export$6922d3b3a607469e = $32e82c0f34a0cb76$var$devtools$1;
const $32e82c0f34a0cb76$export$b0c258b32c26c785 = $32e82c0f34a0cb76$var$setDevtoolsHook$1;
const $32e82c0f34a0cb76$var$_ssrUtils = {
    createComponentInstance: $32e82c0f34a0cb76$var$createComponentInstance,
    setupComponent: $32e82c0f34a0cb76$var$setupComponent,
    renderComponentRoot: $32e82c0f34a0cb76$var$renderComponentRoot,
    setCurrentRenderingInstance: $32e82c0f34a0cb76$var$setCurrentRenderingInstance,
    isVNode: $32e82c0f34a0cb76$export$3868d13f8734ae81,
    normalizeVNode: $32e82c0f34a0cb76$var$normalizeVNode,
    getComponentPublicInstance: $32e82c0f34a0cb76$var$getComponentPublicInstance,
    ensureValidVNode: $32e82c0f34a0cb76$var$ensureValidVNode,
    pushWarningContext: $32e82c0f34a0cb76$var$pushWarningContext,
    popWarningContext: $32e82c0f34a0cb76$var$popWarningContext
};
const $32e82c0f34a0cb76$export$a9679033567b336d = $32e82c0f34a0cb76$var$_ssrUtils;
const $32e82c0f34a0cb76$export$83cf26e06ea620e1 = null;
const $32e82c0f34a0cb76$export$dc678eddf276286e = null;
const $32e82c0f34a0cb76$export$22072a82865312f6 = null;

});
parcelRegister("9K9BQ", function(module, exports) {

$parcel$export(module.exports, "EffectScope", () => $717fdd2b58934d92$export$1168ed9dbc71ddbd);
$parcel$export(module.exports, "ReactiveEffect", () => $717fdd2b58934d92$export$28352bb4dd362521);
$parcel$export(module.exports, "pauseTracking", () => $717fdd2b58934d92$export$938a971395fef855);
$parcel$export(module.exports, "resetTracking", () => $717fdd2b58934d92$export$c39176b1babaa8b8);
$parcel$export(module.exports, "track", () => $717fdd2b58934d92$export$6b2a7d5132615086);
$parcel$export(module.exports, "trigger", () => $717fdd2b58934d92$export$e614dc9140f7ae71);
$parcel$export(module.exports, "toRaw", () => $717fdd2b58934d92$export$ab18938b9fc5f28e);
$parcel$export(module.exports, "isShallow", () => $717fdd2b58934d92$export$7f3fe6025abfa26e);
$parcel$export(module.exports, "toReactive", () => $717fdd2b58934d92$export$45c769cf449a508c);
$parcel$export(module.exports, "shallowReadArray", () => $717fdd2b58934d92$export$5eb48af14254449e);
$parcel$export(module.exports, "isProxy", () => $717fdd2b58934d92$export$5f3ca29d057519b3);
$parcel$export(module.exports, "isRef", () => $717fdd2b58934d92$export$4f9f5282de18fc69);
$parcel$export(module.exports, "reactive", () => $717fdd2b58934d92$export$90a44edba14e47be);
$parcel$export(module.exports, "shallowReactive", () => $717fdd2b58934d92$export$8d81cefd22d22260);
$parcel$export(module.exports, "isReactive", () => $717fdd2b58934d92$export$352205f445242f02);
$parcel$export(module.exports, "markRaw", () => $717fdd2b58934d92$export$995ab8b13ad7a9d0);
$parcel$export(module.exports, "ref", () => $717fdd2b58934d92$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "shallowRef", () => $717fdd2b58934d92$export$9b7bc5fe3b17c8b3);
$parcel$export(module.exports, "unref", () => $717fdd2b58934d92$export$a239a76781616204);
$parcel$export(module.exports, "proxyRefs", () => $717fdd2b58934d92$export$f353fd1b97db3fa0);
$parcel$export(module.exports, "customRef", () => $717fdd2b58934d92$export$a20c2dd6199824cb);
$parcel$export(module.exports, "computed", () => $717fdd2b58934d92$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "watch", () => $717fdd2b58934d92$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "traverse", () => $717fdd2b58934d92$export$df3f009e3d155b20);
/**
* @vue/reactivity v3.5.12
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $a5gC8 = parcelRequire("a5gC8");
function $717fdd2b58934d92$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $717fdd2b58934d92$var$activeEffectScope;
class $717fdd2b58934d92$export$1168ed9dbc71ddbd {
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this._isPaused = false;
        this.parent = $717fdd2b58934d92$var$activeEffectScope;
        if (!detached && $717fdd2b58934d92$var$activeEffectScope) this.index = ($717fdd2b58934d92$var$activeEffectScope.scopes || ($717fdd2b58934d92$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
    get active() {
        return this._active;
    }
    pause() {
        if (this._active) {
            this._isPaused = true;
            let i, l;
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].pause();
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].pause();
        }
    }
    /**
   * Resumes the effect scope, including all child scopes and effects.
   */ resume() {
        if (this._active) {
            if (this._isPaused) {
                this._isPaused = false;
                let i, l;
                if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].resume();
                for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].resume();
            }
        }
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $717fdd2b58934d92$var$activeEffectScope;
            try {
                $717fdd2b58934d92$var$activeEffectScope = this;
                return fn();
            } finally{
                $717fdd2b58934d92$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        $717fdd2b58934d92$var$activeEffectScope = this;
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        $717fdd2b58934d92$var$activeEffectScope = this.parent;
    }
    stop(fromParent) {
        if (this._active) {
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
            this._active = false;
        }
    }
}
function $717fdd2b58934d92$export$7056603ea81600be(detached) {
    return new $717fdd2b58934d92$export$1168ed9dbc71ddbd(detached);
}
function $717fdd2b58934d92$export$c7be4b0125a10cba() {
    return $717fdd2b58934d92$var$activeEffectScope;
}
function $717fdd2b58934d92$export$a780418acd4762da(fn, failSilently = false) {
    if ($717fdd2b58934d92$var$activeEffectScope) $717fdd2b58934d92$var$activeEffectScope.cleanups.push(fn);
}
let $717fdd2b58934d92$var$activeSub;
const $717fdd2b58934d92$export$37ee493b2f34ee54 = {
    "ACTIVE": 1,
    "1": "ACTIVE",
    "RUNNING": 2,
    "2": "RUNNING",
    "TRACKING": 4,
    "4": "TRACKING",
    "NOTIFIED": 8,
    "8": "NOTIFIED",
    "DIRTY": 16,
    "16": "DIRTY",
    "ALLOW_RECURSE": 32,
    "32": "ALLOW_RECURSE",
    "PAUSED": 64,
    "64": "PAUSED"
};
const $717fdd2b58934d92$var$pausedQueueEffects = /* @__PURE__ */ new WeakSet();
class $717fdd2b58934d92$export$28352bb4dd362521 {
    constructor(fn){
        this.fn = fn;
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 5;
        /**
     * @internal
     */ this.next = void 0;
        /**
     * @internal
     */ this.cleanup = void 0;
        this.scheduler = void 0;
        if ($717fdd2b58934d92$var$activeEffectScope && $717fdd2b58934d92$var$activeEffectScope.active) $717fdd2b58934d92$var$activeEffectScope.effects.push(this);
    }
    pause() {
        this.flags |= 64;
    }
    resume() {
        if (this.flags & 64) {
            this.flags &= -65;
            if ($717fdd2b58934d92$var$pausedQueueEffects.has(this)) {
                $717fdd2b58934d92$var$pausedQueueEffects.delete(this);
                this.trigger();
            }
        }
    }
    /**
   * @internal
   */ notify() {
        if (this.flags & 2 && !(this.flags & 32)) return;
        if (!(this.flags & 8)) $717fdd2b58934d92$var$batch(this);
    }
    run() {
        if (!(this.flags & 1)) return this.fn();
        this.flags |= 2;
        $717fdd2b58934d92$var$cleanupEffect(this);
        $717fdd2b58934d92$var$prepareDeps(this);
        const prevEffect = $717fdd2b58934d92$var$activeSub;
        const prevShouldTrack = $717fdd2b58934d92$var$shouldTrack;
        $717fdd2b58934d92$var$activeSub = this;
        $717fdd2b58934d92$var$shouldTrack = true;
        try {
            return this.fn();
        } finally{
            $717fdd2b58934d92$var$cleanupDeps(this);
            $717fdd2b58934d92$var$activeSub = prevEffect;
            $717fdd2b58934d92$var$shouldTrack = prevShouldTrack;
            this.flags &= -3;
        }
    }
    stop() {
        if (this.flags & 1) {
            for(let link = this.deps; link; link = link.nextDep)$717fdd2b58934d92$var$removeSub(link);
            this.deps = this.depsTail = void 0;
            $717fdd2b58934d92$var$cleanupEffect(this);
            this.onStop && this.onStop();
            this.flags &= -2;
        }
    }
    trigger() {
        if (this.flags & 64) $717fdd2b58934d92$var$pausedQueueEffects.add(this);
        else if (this.scheduler) this.scheduler();
        else this.runIfDirty();
    }
    /**
   * @internal
   */ runIfDirty() {
        if ($717fdd2b58934d92$var$isDirty(this)) this.run();
    }
    get dirty() {
        return $717fdd2b58934d92$var$isDirty(this);
    }
}
let $717fdd2b58934d92$var$batchDepth = 0;
let $717fdd2b58934d92$var$batchedSub;
let $717fdd2b58934d92$var$batchedComputed;
function $717fdd2b58934d92$var$batch(sub, isComputed = false) {
    sub.flags |= 8;
    if (isComputed) {
        sub.next = $717fdd2b58934d92$var$batchedComputed;
        $717fdd2b58934d92$var$batchedComputed = sub;
        return;
    }
    sub.next = $717fdd2b58934d92$var$batchedSub;
    $717fdd2b58934d92$var$batchedSub = sub;
}
function $717fdd2b58934d92$var$startBatch() {
    $717fdd2b58934d92$var$batchDepth++;
}
function $717fdd2b58934d92$var$endBatch() {
    if (--$717fdd2b58934d92$var$batchDepth > 0) return;
    if ($717fdd2b58934d92$var$batchedComputed) {
        let e = $717fdd2b58934d92$var$batchedComputed;
        $717fdd2b58934d92$var$batchedComputed = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            e = next;
        }
    }
    let error;
    while($717fdd2b58934d92$var$batchedSub){
        let e = $717fdd2b58934d92$var$batchedSub;
        $717fdd2b58934d92$var$batchedSub = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            if (e.flags & 1) try {
                e.trigger();
            } catch (err) {
                if (!error) error = err;
            }
            e = next;
        }
    }
    if (error) throw error;
}
function $717fdd2b58934d92$var$prepareDeps(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        link.version = -1;
        link.prevActiveLink = link.dep.activeLink;
        link.dep.activeLink = link;
    }
}
function $717fdd2b58934d92$var$cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while(link){
        const prev = link.prevDep;
        if (link.version === -1) {
            if (link === tail) tail = prev;
            $717fdd2b58934d92$var$removeSub(link);
            $717fdd2b58934d92$var$removeDep(link);
        } else head = link;
        link.dep.activeLink = link.prevActiveLink;
        link.prevActiveLink = void 0;
        link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
}
function $717fdd2b58934d92$var$isDirty(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        if (link.dep.version !== link.version || link.dep.computed && ($717fdd2b58934d92$var$refreshComputed(link.dep.computed) || link.dep.version !== link.version)) return true;
    }
    if (sub._dirty) return true;
    return false;
}
function $717fdd2b58934d92$var$refreshComputed(computed) {
    if (computed.flags & 4 && !(computed.flags & 16)) return;
    computed.flags &= -17;
    if (computed.globalVersion === $717fdd2b58934d92$var$globalVersion) return;
    computed.globalVersion = $717fdd2b58934d92$var$globalVersion;
    const dep = computed.dep;
    computed.flags |= 2;
    if (dep.version > 0 && !computed.isSSR && computed.deps && !$717fdd2b58934d92$var$isDirty(computed)) {
        computed.flags &= -3;
        return;
    }
    const prevSub = $717fdd2b58934d92$var$activeSub;
    const prevShouldTrack = $717fdd2b58934d92$var$shouldTrack;
    $717fdd2b58934d92$var$activeSub = computed;
    $717fdd2b58934d92$var$shouldTrack = true;
    try {
        $717fdd2b58934d92$var$prepareDeps(computed);
        const value = computed.fn(computed._value);
        if (dep.version === 0 || (0, $a5gC8.hasChanged)(value, computed._value)) {
            computed._value = value;
            dep.version++;
        }
    } catch (err) {
        dep.version++;
        throw err;
    } finally{
        $717fdd2b58934d92$var$activeSub = prevSub;
        $717fdd2b58934d92$var$shouldTrack = prevShouldTrack;
        $717fdd2b58934d92$var$cleanupDeps(computed);
        computed.flags &= -3;
    }
}
function $717fdd2b58934d92$var$removeSub(link, soft = false) {
    const { dep: dep, prevSub: prevSub, nextSub: nextSub } = link;
    if (prevSub) {
        prevSub.nextSub = nextSub;
        link.prevSub = void 0;
    }
    if (nextSub) {
        nextSub.prevSub = prevSub;
        link.nextSub = void 0;
    }
    if (dep.subs === link) {
        dep.subs = prevSub;
        if (!prevSub && dep.computed) {
            dep.computed.flags &= -5;
            for(let l = dep.computed.deps; l; l = l.nextDep)$717fdd2b58934d92$var$removeSub(l, true);
        }
    }
    if (!soft && !--dep.sc && dep.map) dep.map.delete(dep.key);
}
function $717fdd2b58934d92$var$removeDep(link) {
    const { prevDep: prevDep, nextDep: nextDep } = link;
    if (prevDep) {
        prevDep.nextDep = nextDep;
        link.prevDep = void 0;
    }
    if (nextDep) {
        nextDep.prevDep = prevDep;
        link.nextDep = void 0;
    }
}
function $717fdd2b58934d92$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $717fdd2b58934d92$export$28352bb4dd362521) fn = fn.effect.fn;
    const e = new $717fdd2b58934d92$export$28352bb4dd362521(fn);
    if (options) (0, $a5gC8.extend)(e, options);
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
function $717fdd2b58934d92$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $717fdd2b58934d92$var$shouldTrack = true;
const $717fdd2b58934d92$var$trackStack = [];
function $717fdd2b58934d92$export$938a971395fef855() {
    $717fdd2b58934d92$var$trackStack.push($717fdd2b58934d92$var$shouldTrack);
    $717fdd2b58934d92$var$shouldTrack = false;
}
function $717fdd2b58934d92$export$1f8ffc6fd33b1d16() {
    $717fdd2b58934d92$var$trackStack.push($717fdd2b58934d92$var$shouldTrack);
    $717fdd2b58934d92$var$shouldTrack = true;
}
function $717fdd2b58934d92$export$c39176b1babaa8b8() {
    const last = $717fdd2b58934d92$var$trackStack.pop();
    $717fdd2b58934d92$var$shouldTrack = last === void 0 ? true : last;
}
function $717fdd2b58934d92$export$92b6a62b33d94031(fn, failSilently = false) {
    if ($717fdd2b58934d92$var$activeSub instanceof $717fdd2b58934d92$export$28352bb4dd362521) $717fdd2b58934d92$var$activeSub.cleanup = fn;
}
function $717fdd2b58934d92$var$cleanupEffect(e) {
    const { cleanup: cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
        const prevSub = $717fdd2b58934d92$var$activeSub;
        $717fdd2b58934d92$var$activeSub = void 0;
        try {
            cleanup();
        } finally{
            $717fdd2b58934d92$var$activeSub = prevSub;
        }
    }
}
let $717fdd2b58934d92$var$globalVersion = 0;
class $717fdd2b58934d92$var$Link {
    constructor(sub, dep){
        this.sub = sub;
        this.dep = dep;
        this.version = dep.version;
        this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
}
class $717fdd2b58934d92$var$Dep {
    constructor(computed){
        this.computed = computed;
        this.version = 0;
        /**
     * Link between this dep and the current active effect
     */ this.activeLink = void 0;
        /**
     * Doubly linked list representing the subscribing effects (tail)
     */ this.subs = void 0;
        /**
     * For object property deps cleanup
     */ this.map = void 0;
        this.key = void 0;
        /**
     * Subscriber counter
     */ this.sc = 0;
    }
    track(debugInfo) {
        if (!$717fdd2b58934d92$var$activeSub || !$717fdd2b58934d92$var$shouldTrack || $717fdd2b58934d92$var$activeSub === this.computed) return;
        let link = this.activeLink;
        if (link === void 0 || link.sub !== $717fdd2b58934d92$var$activeSub) {
            link = this.activeLink = new $717fdd2b58934d92$var$Link($717fdd2b58934d92$var$activeSub, this);
            if (!$717fdd2b58934d92$var$activeSub.deps) $717fdd2b58934d92$var$activeSub.deps = $717fdd2b58934d92$var$activeSub.depsTail = link;
            else {
                link.prevDep = $717fdd2b58934d92$var$activeSub.depsTail;
                $717fdd2b58934d92$var$activeSub.depsTail.nextDep = link;
                $717fdd2b58934d92$var$activeSub.depsTail = link;
            }
            $717fdd2b58934d92$var$addSub(link);
        } else if (link.version === -1) {
            link.version = this.version;
            if (link.nextDep) {
                const next = link.nextDep;
                next.prevDep = link.prevDep;
                if (link.prevDep) link.prevDep.nextDep = next;
                link.prevDep = $717fdd2b58934d92$var$activeSub.depsTail;
                link.nextDep = void 0;
                $717fdd2b58934d92$var$activeSub.depsTail.nextDep = link;
                $717fdd2b58934d92$var$activeSub.depsTail = link;
                if ($717fdd2b58934d92$var$activeSub.deps === link) $717fdd2b58934d92$var$activeSub.deps = next;
            }
        }
        return link;
    }
    trigger(debugInfo) {
        this.version++;
        $717fdd2b58934d92$var$globalVersion++;
        this.notify(debugInfo);
    }
    notify(debugInfo) {
        $717fdd2b58934d92$var$startBatch();
        try {
            for(let link = this.subs; link; link = link.prevSub)if (link.sub.notify()) link.sub.dep.notify();
        } finally{
            $717fdd2b58934d92$var$endBatch();
        }
    }
}
function $717fdd2b58934d92$var$addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
        const computed = link.dep.computed;
        if (computed && !link.dep.subs) {
            computed.flags |= 20;
            for(let l = computed.deps; l; l = l.nextDep)$717fdd2b58934d92$var$addSub(l);
        }
        const currentTail = link.dep.subs;
        if (currentTail !== link) {
            link.prevSub = currentTail;
            if (currentTail) currentTail.nextSub = link;
        }
        link.dep.subs = link;
    }
}
const $717fdd2b58934d92$var$targetMap = /* @__PURE__ */ new WeakMap();
const $717fdd2b58934d92$export$3c41b1a4e06acc14 = Symbol("");
const $717fdd2b58934d92$export$49093fa1cddcb78d = Symbol("");
const $717fdd2b58934d92$export$4f926f0baab682cd = Symbol("");
function $717fdd2b58934d92$export$6b2a7d5132615086(target, type, key) {
    if ($717fdd2b58934d92$var$shouldTrack && $717fdd2b58934d92$var$activeSub) {
        let depsMap = $717fdd2b58934d92$var$targetMap.get(target);
        if (!depsMap) $717fdd2b58934d92$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) {
            depsMap.set(key, dep = new $717fdd2b58934d92$var$Dep());
            dep.map = depsMap;
            dep.key = key;
        }
        dep.track();
    }
}
function $717fdd2b58934d92$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $717fdd2b58934d92$var$targetMap.get(target);
    if (!depsMap) {
        $717fdd2b58934d92$var$globalVersion++;
        return;
    }
    const run = (dep)=>{
        if (dep) dep.trigger();
    };
    $717fdd2b58934d92$var$startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        const targetIsArray = (0, $a5gC8.isArray)(target);
        const isArrayIndex = targetIsArray && (0, $a5gC8.isIntegerKey)(key);
        if (targetIsArray && key === "length") {
            const newLength = Number(newValue);
            depsMap.forEach((dep, key2)=>{
                if (key2 === "length" || key2 === $717fdd2b58934d92$export$4f926f0baab682cd || !(0, $a5gC8.isSymbol)(key2) && key2 >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get($717fdd2b58934d92$export$4f926f0baab682cd));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get($717fdd2b58934d92$export$3c41b1a4e06acc14));
                        if ((0, $a5gC8.isMap)(target)) run(depsMap.get($717fdd2b58934d92$export$49093fa1cddcb78d));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get($717fdd2b58934d92$export$3c41b1a4e06acc14));
                        if ((0, $a5gC8.isMap)(target)) run(depsMap.get($717fdd2b58934d92$export$49093fa1cddcb78d));
                    }
                    break;
                case "set":
                    if ((0, $a5gC8.isMap)(target)) run(depsMap.get($717fdd2b58934d92$export$3c41b1a4e06acc14));
                    break;
            }
        }
    }
    $717fdd2b58934d92$var$endBatch();
}
function $717fdd2b58934d92$var$getDepFromReactive(object, key) {
    const depMap = $717fdd2b58934d92$var$targetMap.get(object);
    return depMap && depMap.get(key);
}
function $717fdd2b58934d92$export$1544eab4943788e4(array) {
    const raw = $717fdd2b58934d92$export$ab18938b9fc5f28e(array);
    if (raw === array) return raw;
    $717fdd2b58934d92$export$6b2a7d5132615086(raw, "iterate", $717fdd2b58934d92$export$4f926f0baab682cd);
    return $717fdd2b58934d92$export$7f3fe6025abfa26e(array) ? raw : raw.map($717fdd2b58934d92$export$45c769cf449a508c);
}
function $717fdd2b58934d92$export$5eb48af14254449e(arr) {
    $717fdd2b58934d92$export$6b2a7d5132615086(arr = $717fdd2b58934d92$export$ab18938b9fc5f28e(arr), "iterate", $717fdd2b58934d92$export$4f926f0baab682cd);
    return arr;
}
const $717fdd2b58934d92$var$arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator] () {
        return $717fdd2b58934d92$var$iterator(this, Symbol.iterator, $717fdd2b58934d92$export$45c769cf449a508c);
    },
    concat (...args) {
        return $717fdd2b58934d92$export$1544eab4943788e4(this).concat(...args.map((x)=>(0, $a5gC8.isArray)(x) ? $717fdd2b58934d92$export$1544eab4943788e4(x) : x));
    },
    entries () {
        return $717fdd2b58934d92$var$iterator(this, "entries", (value)=>{
            value[1] = $717fdd2b58934d92$export$45c769cf449a508c(value[1]);
            return value;
        });
    },
    every (fn, thisArg) {
        return $717fdd2b58934d92$var$apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter (fn, thisArg) {
        return $717fdd2b58934d92$var$apply(this, "filter", fn, thisArg, (v)=>v.map($717fdd2b58934d92$export$45c769cf449a508c), arguments);
    },
    find (fn, thisArg) {
        return $717fdd2b58934d92$var$apply(this, "find", fn, thisArg, $717fdd2b58934d92$export$45c769cf449a508c, arguments);
    },
    findIndex (fn, thisArg) {
        return $717fdd2b58934d92$var$apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast (fn, thisArg) {
        return $717fdd2b58934d92$var$apply(this, "findLast", fn, thisArg, $717fdd2b58934d92$export$45c769cf449a508c, arguments);
    },
    findLastIndex (fn, thisArg) {
        return $717fdd2b58934d92$var$apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
    forEach (fn, thisArg) {
        return $717fdd2b58934d92$var$apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes (...args) {
        return $717fdd2b58934d92$var$searchProxy(this, "includes", args);
    },
    indexOf (...args) {
        return $717fdd2b58934d92$var$searchProxy(this, "indexOf", args);
    },
    join (separator) {
        return $717fdd2b58934d92$export$1544eab4943788e4(this).join(separator);
    },
    // keys() iterator only reads `length`, no optimisation required
    lastIndexOf (...args) {
        return $717fdd2b58934d92$var$searchProxy(this, "lastIndexOf", args);
    },
    map (fn, thisArg) {
        return $717fdd2b58934d92$var$apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop () {
        return $717fdd2b58934d92$var$noTracking(this, "pop");
    },
    push (...args) {
        return $717fdd2b58934d92$var$noTracking(this, "push", args);
    },
    reduce (fn, ...args) {
        return $717fdd2b58934d92$var$reduce(this, "reduce", fn, args);
    },
    reduceRight (fn, ...args) {
        return $717fdd2b58934d92$var$reduce(this, "reduceRight", fn, args);
    },
    shift () {
        return $717fdd2b58934d92$var$noTracking(this, "shift");
    },
    // slice could use ARRAY_ITERATE but also seems to beg for range tracking
    some (fn, thisArg) {
        return $717fdd2b58934d92$var$apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice (...args) {
        return $717fdd2b58934d92$var$noTracking(this, "splice", args);
    },
    toReversed () {
        return $717fdd2b58934d92$export$1544eab4943788e4(this).toReversed();
    },
    toSorted (comparer) {
        return $717fdd2b58934d92$export$1544eab4943788e4(this).toSorted(comparer);
    },
    toSpliced (...args) {
        return $717fdd2b58934d92$export$1544eab4943788e4(this).toSpliced(...args);
    },
    unshift (...args) {
        return $717fdd2b58934d92$var$noTracking(this, "unshift", args);
    },
    values () {
        return $717fdd2b58934d92$var$iterator(this, "values", $717fdd2b58934d92$export$45c769cf449a508c);
    }
};
function $717fdd2b58934d92$var$iterator(self, method, wrapValue) {
    const arr = $717fdd2b58934d92$export$5eb48af14254449e(self);
    const iter = arr[method]();
    if (arr !== self && !$717fdd2b58934d92$export$7f3fe6025abfa26e(self)) {
        iter._next = iter.next;
        iter.next = ()=>{
            const result = iter._next();
            if (result.value) result.value = wrapValue(result.value);
            return result;
        };
    }
    return iter;
}
const $717fdd2b58934d92$var$arrayProto = Array.prototype;
function $717fdd2b58934d92$var$apply(self, method, fn, thisArg, wrappedRetFn, args) {
    const arr = $717fdd2b58934d92$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !$717fdd2b58934d92$export$7f3fe6025abfa26e(self);
    const methodFn = arr[method];
    if (methodFn !== $717fdd2b58934d92$var$arrayProto[method]) {
        const result2 = methodFn.apply(self, args);
        return needsWrap ? $717fdd2b58934d92$export$45c769cf449a508c(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self) {
        if (needsWrap) wrappedFn = function(item, index) {
            return fn.call(this, $717fdd2b58934d92$export$45c769cf449a508c(item), index, self);
        };
        else if (fn.length > 2) wrappedFn = function(item, index) {
            return fn.call(this, item, index, self);
        };
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function $717fdd2b58934d92$var$reduce(self, method, fn, args) {
    const arr = $717fdd2b58934d92$export$5eb48af14254449e(self);
    let wrappedFn = fn;
    if (arr !== self) {
        if (!$717fdd2b58934d92$export$7f3fe6025abfa26e(self)) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, $717fdd2b58934d92$export$45c769cf449a508c(item), index, self);
        };
        else if (fn.length > 3) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, item, index, self);
        };
    }
    return arr[method](wrappedFn, ...args);
}
function $717fdd2b58934d92$var$searchProxy(self, method, args) {
    const arr = $717fdd2b58934d92$export$ab18938b9fc5f28e(self);
    $717fdd2b58934d92$export$6b2a7d5132615086(arr, "iterate", $717fdd2b58934d92$export$4f926f0baab682cd);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && $717fdd2b58934d92$export$5f3ca29d057519b3(args[0])) {
        args[0] = $717fdd2b58934d92$export$ab18938b9fc5f28e(args[0]);
        return arr[method](...args);
    }
    return res;
}
function $717fdd2b58934d92$var$noTracking(self, method, args = []) {
    $717fdd2b58934d92$export$938a971395fef855();
    $717fdd2b58934d92$var$startBatch();
    const res = $717fdd2b58934d92$export$ab18938b9fc5f28e(self)[method].apply(self, args);
    $717fdd2b58934d92$var$endBatch();
    $717fdd2b58934d92$export$c39176b1babaa8b8();
    return res;
}
const $717fdd2b58934d92$var$isNonTrackableKeys = /* @__PURE__ */ (0, $a5gC8.makeMap)(`__proto__,__v_isRef,__isVue`);
const $717fdd2b58934d92$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $a5gC8.isSymbol)));
function $717fdd2b58934d92$var$hasOwnProperty(key) {
    if (!(0, $a5gC8.isSymbol)(key)) key = String(key);
    const obj = $717fdd2b58934d92$export$ab18938b9fc5f28e(this);
    $717fdd2b58934d92$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $717fdd2b58934d92$var$BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $717fdd2b58934d92$var$shallowReadonlyMap : $717fdd2b58934d92$var$readonlyMap : isShallow2 ? $717fdd2b58934d92$var$shallowReactiveMap : $717fdd2b58934d92$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the receiver is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, $a5gC8.isArray)(target);
        if (!isReadonly2) {
            let fn;
            if (targetIsArray && (fn = $717fdd2b58934d92$var$arrayInstrumentations[key])) return fn;
            if (key === "hasOwnProperty") return $717fdd2b58934d92$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, // if this is a proxy wrapping a ref, return methods using the raw ref
        // as receiver so that we don't have to call `toRaw` on the ref in all
        // its class methods
        $717fdd2b58934d92$export$4f9f5282de18fc69(target) ? target : receiver);
        if ((0, $a5gC8.isSymbol)(key) ? $717fdd2b58934d92$var$builtInSymbols.has(key) : $717fdd2b58934d92$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $717fdd2b58934d92$export$6b2a7d5132615086(target, "get", key);
        if (isShallow2) return res;
        if ($717fdd2b58934d92$export$4f9f5282de18fc69(res)) return targetIsArray && (0, $a5gC8.isIntegerKey)(key) ? res : res.value;
        if ((0, $a5gC8.isObject)(res)) return isReadonly2 ? $717fdd2b58934d92$export$6ec456bd5b7b3c51(res) : $717fdd2b58934d92$export$90a44edba14e47be(res);
        return res;
    }
}
class $717fdd2b58934d92$var$MutableReactiveHandler extends $717fdd2b58934d92$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        if (!this._isShallow) {
            const isOldValueReadonly = $717fdd2b58934d92$export$92d09b48637741e7(oldValue);
            if (!$717fdd2b58934d92$export$7f3fe6025abfa26e(value) && !$717fdd2b58934d92$export$92d09b48637741e7(value)) {
                oldValue = $717fdd2b58934d92$export$ab18938b9fc5f28e(oldValue);
                value = $717fdd2b58934d92$export$ab18938b9fc5f28e(value);
            }
            if (!(0, $a5gC8.isArray)(target) && $717fdd2b58934d92$export$4f9f5282de18fc69(oldValue) && !$717fdd2b58934d92$export$4f9f5282de18fc69(value)) {
                if (isOldValueReadonly) return false;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = (0, $a5gC8.isArray)(target) && (0, $a5gC8.isIntegerKey)(key) ? Number(key) < target.length : (0, $a5gC8.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, $717fdd2b58934d92$export$4f9f5282de18fc69(target) ? target : receiver);
        if (target === $717fdd2b58934d92$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $717fdd2b58934d92$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $a5gC8.hasChanged)(value, oldValue)) $717fdd2b58934d92$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $a5gC8.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $717fdd2b58934d92$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $a5gC8.isSymbol)(key) || !$717fdd2b58934d92$var$builtInSymbols.has(key)) $717fdd2b58934d92$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $717fdd2b58934d92$export$6b2a7d5132615086(target, "iterate", (0, $a5gC8.isArray)(target) ? "length" : $717fdd2b58934d92$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
}
class $717fdd2b58934d92$var$ReadonlyReactiveHandler extends $717fdd2b58934d92$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const $717fdd2b58934d92$var$mutableHandlers = /* @__PURE__ */ new $717fdd2b58934d92$var$MutableReactiveHandler();
const $717fdd2b58934d92$var$readonlyHandlers = /* @__PURE__ */ new $717fdd2b58934d92$var$ReadonlyReactiveHandler();
const $717fdd2b58934d92$var$shallowReactiveHandlers = /* @__PURE__ */ new $717fdd2b58934d92$var$MutableReactiveHandler(true);
const $717fdd2b58934d92$var$shallowReadonlyHandlers = /* @__PURE__ */ new $717fdd2b58934d92$var$ReadonlyReactiveHandler(true);
const $717fdd2b58934d92$var$toShallow = (value)=>value;
const $717fdd2b58934d92$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $717fdd2b58934d92$var$createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $717fdd2b58934d92$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $a5gC8.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow2 ? $717fdd2b58934d92$var$toShallow : isReadonly2 ? $717fdd2b58934d92$export$4a78e7a2a4fb689f : $717fdd2b58934d92$export$45c769cf449a508c;
        !isReadonly2 && $717fdd2b58934d92$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $717fdd2b58934d92$export$49093fa1cddcb78d : $717fdd2b58934d92$export$3c41b1a4e06acc14);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $717fdd2b58934d92$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $717fdd2b58934d92$var$createInstrumentations(readonly, shallow) {
    const instrumentations = {
        get (key) {
            const target = this["__v_raw"];
            const rawTarget = $717fdd2b58934d92$export$ab18938b9fc5f28e(target);
            const rawKey = $717fdd2b58934d92$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $a5gC8.hasChanged)(key, rawKey)) $717fdd2b58934d92$export$6b2a7d5132615086(rawTarget, "get", key);
                $717fdd2b58934d92$export$6b2a7d5132615086(rawTarget, "get", rawKey);
            }
            const { has: has } = $717fdd2b58934d92$var$getProto(rawTarget);
            const wrap = shallow ? $717fdd2b58934d92$var$toShallow : readonly ? $717fdd2b58934d92$export$4a78e7a2a4fb689f : $717fdd2b58934d92$export$45c769cf449a508c;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            const target = this["__v_raw"];
            !readonly && $717fdd2b58934d92$export$6b2a7d5132615086($717fdd2b58934d92$export$ab18938b9fc5f28e(target), "iterate", $717fdd2b58934d92$export$3c41b1a4e06acc14);
            return Reflect.get(target, "size", target);
        },
        has (key) {
            const target = this["__v_raw"];
            const rawTarget = $717fdd2b58934d92$export$ab18938b9fc5f28e(target);
            const rawKey = $717fdd2b58934d92$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $a5gC8.hasChanged)(key, rawKey)) $717fdd2b58934d92$export$6b2a7d5132615086(rawTarget, "has", key);
                $717fdd2b58934d92$export$6b2a7d5132615086(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach (callback, thisArg) {
            const observed = this;
            const target = observed["__v_raw"];
            const rawTarget = $717fdd2b58934d92$export$ab18938b9fc5f28e(target);
            const wrap = shallow ? $717fdd2b58934d92$var$toShallow : readonly ? $717fdd2b58934d92$export$4a78e7a2a4fb689f : $717fdd2b58934d92$export$45c769cf449a508c;
            !readonly && $717fdd2b58934d92$export$6b2a7d5132615086(rawTarget, "iterate", $717fdd2b58934d92$export$3c41b1a4e06acc14);
            return target.forEach((value, key)=>{
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    (0, $a5gC8.extend)(instrumentations, readonly ? {
        add: $717fdd2b58934d92$var$createReadonlyMethod("add"),
        set: $717fdd2b58934d92$var$createReadonlyMethod("set"),
        delete: $717fdd2b58934d92$var$createReadonlyMethod("delete"),
        clear: $717fdd2b58934d92$var$createReadonlyMethod("clear")
    } : {
        add (value) {
            if (!shallow && !$717fdd2b58934d92$export$7f3fe6025abfa26e(value) && !$717fdd2b58934d92$export$92d09b48637741e7(value)) value = $717fdd2b58934d92$export$ab18938b9fc5f28e(value);
            const target = $717fdd2b58934d92$export$ab18938b9fc5f28e(this);
            const proto = $717fdd2b58934d92$var$getProto(target);
            const hadKey = proto.has.call(target, value);
            if (!hadKey) {
                target.add(value);
                $717fdd2b58934d92$export$e614dc9140f7ae71(target, "add", value, value);
            }
            return this;
        },
        set (key, value) {
            if (!shallow && !$717fdd2b58934d92$export$7f3fe6025abfa26e(value) && !$717fdd2b58934d92$export$92d09b48637741e7(value)) value = $717fdd2b58934d92$export$ab18938b9fc5f28e(value);
            const target = $717fdd2b58934d92$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $717fdd2b58934d92$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $717fdd2b58934d92$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get.call(target, key);
            target.set(key, value);
            if (!hadKey) $717fdd2b58934d92$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $a5gC8.hasChanged)(value, oldValue)) $717fdd2b58934d92$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
            return this;
        },
        delete (key) {
            const target = $717fdd2b58934d92$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $717fdd2b58934d92$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $717fdd2b58934d92$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get ? get.call(target, key) : void 0;
            const result = target.delete(key);
            if (hadKey) $717fdd2b58934d92$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear () {
            const target = $717fdd2b58934d92$export$ab18938b9fc5f28e(this);
            const hadItems = target.size !== 0;
            const oldTarget = void 0;
            const result = target.clear();
            if (hadItems) $717fdd2b58934d92$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        instrumentations[method] = $717fdd2b58934d92$var$createIterableMethod(method, readonly, shallow);
    });
    return instrumentations;
}
function $717fdd2b58934d92$var$createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = $717fdd2b58934d92$var$createInstrumentations(isReadonly2, shallow);
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $a5gC8.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $717fdd2b58934d92$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $717fdd2b58934d92$var$createInstrumentationGetter(false, false)
};
const $717fdd2b58934d92$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $717fdd2b58934d92$var$createInstrumentationGetter(false, true)
};
const $717fdd2b58934d92$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $717fdd2b58934d92$var$createInstrumentationGetter(true, false)
};
const $717fdd2b58934d92$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $717fdd2b58934d92$var$createInstrumentationGetter(true, true)
};
function $717fdd2b58934d92$var$checkIdentityKeys(target, has, key) {
    const rawKey = $717fdd2b58934d92$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = (0, $a5gC8.toRawType)(target);
        $717fdd2b58934d92$var$warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $717fdd2b58934d92$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $717fdd2b58934d92$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $717fdd2b58934d92$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $717fdd2b58934d92$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $717fdd2b58934d92$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $717fdd2b58934d92$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : $717fdd2b58934d92$var$targetTypeMap((0, $a5gC8.toRawType)(value));
}
function $717fdd2b58934d92$export$90a44edba14e47be(target) {
    if ($717fdd2b58934d92$export$92d09b48637741e7(target)) return target;
    return $717fdd2b58934d92$var$createReactiveObject(target, false, $717fdd2b58934d92$var$mutableHandlers, $717fdd2b58934d92$var$mutableCollectionHandlers, $717fdd2b58934d92$var$reactiveMap);
}
function $717fdd2b58934d92$export$8d81cefd22d22260(target) {
    return $717fdd2b58934d92$var$createReactiveObject(target, false, $717fdd2b58934d92$var$shallowReactiveHandlers, $717fdd2b58934d92$var$shallowCollectionHandlers, $717fdd2b58934d92$var$shallowReactiveMap);
}
function $717fdd2b58934d92$export$6ec456bd5b7b3c51(target) {
    return $717fdd2b58934d92$var$createReactiveObject(target, true, $717fdd2b58934d92$var$readonlyHandlers, $717fdd2b58934d92$var$readonlyCollectionHandlers, $717fdd2b58934d92$var$readonlyMap);
}
function $717fdd2b58934d92$export$7c4b5f2b50f09f6b(target) {
    return $717fdd2b58934d92$var$createReactiveObject(target, true, $717fdd2b58934d92$var$shallowReadonlyHandlers, $717fdd2b58934d92$var$shallowReadonlyCollectionHandlers, $717fdd2b58934d92$var$shallowReadonlyMap);
}
function $717fdd2b58934d92$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $a5gC8.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $717fdd2b58934d92$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $717fdd2b58934d92$export$352205f445242f02(value) {
    if ($717fdd2b58934d92$export$92d09b48637741e7(value)) return $717fdd2b58934d92$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function $717fdd2b58934d92$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
function $717fdd2b58934d92$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
function $717fdd2b58934d92$export$5f3ca29d057519b3(value) {
    return value ? !!value["__v_raw"] : false;
}
function $717fdd2b58934d92$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? $717fdd2b58934d92$export$ab18938b9fc5f28e(raw) : observed;
}
function $717fdd2b58934d92$export$995ab8b13ad7a9d0(value) {
    if (!(0, $a5gC8.hasOwn)(value, "__v_skip") && Object.isExtensible(value)) (0, $a5gC8.def)(value, "__v_skip", true);
    return value;
}
const $717fdd2b58934d92$export$45c769cf449a508c = (value)=>(0, $a5gC8.isObject)(value) ? $717fdd2b58934d92$export$90a44edba14e47be(value) : value;
const $717fdd2b58934d92$export$4a78e7a2a4fb689f = (value)=>(0, $a5gC8.isObject)(value) ? $717fdd2b58934d92$export$6ec456bd5b7b3c51(value) : value;
function $717fdd2b58934d92$export$4f9f5282de18fc69(r) {
    return r ? r["__v_isRef"] === true : false;
}
function $717fdd2b58934d92$export$eff4d24c3ff7876e(value) {
    return $717fdd2b58934d92$var$createRef(value, false);
}
function $717fdd2b58934d92$export$9b7bc5fe3b17c8b3(value) {
    return $717fdd2b58934d92$var$createRef(value, true);
}
function $717fdd2b58934d92$var$createRef(rawValue, shallow) {
    if ($717fdd2b58934d92$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $717fdd2b58934d92$var$RefImpl(rawValue, shallow);
}
class $717fdd2b58934d92$var$RefImpl {
    constructor(value, isShallow2){
        this.dep = new $717fdd2b58934d92$var$Dep();
        this["__v_isRef"] = true;
        this["__v_isShallow"] = false;
        this._rawValue = isShallow2 ? value : $717fdd2b58934d92$export$ab18938b9fc5f28e(value);
        this._value = isShallow2 ? value : $717fdd2b58934d92$export$45c769cf449a508c(value);
        this["__v_isShallow"] = isShallow2;
    }
    get value() {
        this.dep.track();
        return this._value;
    }
    set value(newValue) {
        const oldValue = this._rawValue;
        const useDirectValue = this["__v_isShallow"] || $717fdd2b58934d92$export$7f3fe6025abfa26e(newValue) || $717fdd2b58934d92$export$92d09b48637741e7(newValue);
        newValue = useDirectValue ? newValue : $717fdd2b58934d92$export$ab18938b9fc5f28e(newValue);
        if ((0, $a5gC8.hasChanged)(newValue, oldValue)) {
            this._rawValue = newValue;
            this._value = useDirectValue ? newValue : $717fdd2b58934d92$export$45c769cf449a508c(newValue);
            this.dep.trigger();
        }
    }
}
function $717fdd2b58934d92$export$f402f86588575ccc(ref2) {
    if (ref2.dep) ref2.dep.trigger();
}
function $717fdd2b58934d92$export$a239a76781616204(ref2) {
    return $717fdd2b58934d92$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $717fdd2b58934d92$export$30bdcc2218aa9458(source) {
    return (0, $a5gC8.isFunction)(source) ? source() : $717fdd2b58934d92$export$a239a76781616204(source);
}
const $717fdd2b58934d92$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>key === "__v_raw" ? target : $717fdd2b58934d92$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if ($717fdd2b58934d92$export$4f9f5282de18fc69(oldValue) && !$717fdd2b58934d92$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $717fdd2b58934d92$export$f353fd1b97db3fa0(objectWithRefs) {
    return $717fdd2b58934d92$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $717fdd2b58934d92$var$shallowUnwrapHandlers);
}
class $717fdd2b58934d92$var$CustomRefImpl {
    constructor(factory){
        this["__v_isRef"] = true;
        this._value = void 0;
        const dep = this.dep = new $717fdd2b58934d92$var$Dep();
        const { get: get, set: set } = factory(dep.track.bind(dep), dep.trigger.bind(dep));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._value = this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $717fdd2b58934d92$export$a20c2dd6199824cb(factory) {
    return new $717fdd2b58934d92$var$CustomRefImpl(factory);
}
function $717fdd2b58934d92$export$2e9533675e5e70e0(object) {
    const ret = (0, $a5gC8.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $717fdd2b58934d92$var$propertyToRef(object, key);
    return ret;
}
class $717fdd2b58934d92$var$ObjectRefImpl {
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this["__v_isRef"] = true;
        this._value = void 0;
    }
    get value() {
        const val = this._object[this._key];
        return this._value = val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    get dep() {
        return $717fdd2b58934d92$var$getDepFromReactive($717fdd2b58934d92$export$ab18938b9fc5f28e(this._object), this._key);
    }
}
class $717fdd2b58934d92$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this["__v_isRef"] = true;
        this["__v_isReadonly"] = true;
        this._value = void 0;
    }
    get value() {
        return this._value = this._getter();
    }
}
function $717fdd2b58934d92$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if ($717fdd2b58934d92$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $a5gC8.isFunction)(source)) return new $717fdd2b58934d92$var$GetterRefImpl(source);
    else if ((0, $a5gC8.isObject)(source) && arguments.length > 1) return $717fdd2b58934d92$var$propertyToRef(source, key, defaultValue);
    else return $717fdd2b58934d92$export$eff4d24c3ff7876e(source);
}
function $717fdd2b58934d92$var$propertyToRef(source, key, defaultValue) {
    const val = source[key];
    return $717fdd2b58934d92$export$4f9f5282de18fc69(val) ? val : new $717fdd2b58934d92$var$ObjectRefImpl(source, key, defaultValue);
}
class $717fdd2b58934d92$var$ComputedRefImpl {
    constructor(fn, setter, isSSR){
        this.fn = fn;
        this.setter = setter;
        /**
     * @internal
     */ this._value = void 0;
        /**
     * @internal
     */ this.dep = new $717fdd2b58934d92$var$Dep(this);
        /**
     * @internal
     */ this.__v_isRef = true;
        // TODO isolatedDeclarations "__v_isReadonly"
        // A computed is also a subscriber that tracks other deps
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 16;
        /**
     * @internal
     */ this.globalVersion = $717fdd2b58934d92$var$globalVersion - 1;
        /**
     * @internal
     */ this.next = void 0;
        // for backwards compat
        this.effect = this;
        this["__v_isReadonly"] = !setter;
        this.isSSR = isSSR;
    }
    /**
   * @internal
   */ notify() {
        this.flags |= 16;
        if (!(this.flags & 8) && // avoid infinite self recursion
        $717fdd2b58934d92$var$activeSub !== this) {
            $717fdd2b58934d92$var$batch(this, true);
            return true;
        }
    }
    get value() {
        const link = this.dep.track();
        $717fdd2b58934d92$var$refreshComputed(this);
        if (link) link.version = this.dep.version;
        return this._value;
    }
    set value(newValue) {
        if (this.setter) this.setter(newValue);
    }
}
function $717fdd2b58934d92$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    if ((0, $a5gC8.isFunction)(getterOrOptions)) getter = getterOrOptions;
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $717fdd2b58934d92$var$ComputedRefImpl(getter, setter, isSSR);
    return cRef;
}
const $717fdd2b58934d92$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const $717fdd2b58934d92$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const $717fdd2b58934d92$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw",
    "IS_REF": "__v_isRef"
};
const $717fdd2b58934d92$export$c54ef203cb79e75f = {
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP"
};
const $717fdd2b58934d92$var$INITIAL_WATCHER_VALUE = {};
const $717fdd2b58934d92$var$cleanupMap = /* @__PURE__ */ new WeakMap();
let $717fdd2b58934d92$var$activeWatcher = void 0;
function $717fdd2b58934d92$export$2532f7acfca7c82d() {
    return $717fdd2b58934d92$var$activeWatcher;
}
function $717fdd2b58934d92$export$8ddeeb083684a9d0(cleanupFn, failSilently = false, owner = $717fdd2b58934d92$var$activeWatcher) {
    if (owner) {
        let cleanups = $717fdd2b58934d92$var$cleanupMap.get(owner);
        if (!cleanups) $717fdd2b58934d92$var$cleanupMap.set(owner, cleanups = []);
        cleanups.push(cleanupFn);
    }
}
function $717fdd2b58934d92$export$3db5d71bdb2d5499(source, cb, options = (0, $a5gC8.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, once: once, scheduler: scheduler, augmentJob: augmentJob, call: call } = options;
    const warnInvalidSource = (s)=>{
        (options.onWarn || $717fdd2b58934d92$var$warn)(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const reactiveGetter = (source2)=>{
        if (deep) return source2;
        if ($717fdd2b58934d92$export$7f3fe6025abfa26e(source2) || deep === false || deep === 0) return $717fdd2b58934d92$export$df3f009e3d155b20(source2, 1);
        return $717fdd2b58934d92$export$df3f009e3d155b20(source2);
    };
    let effect;
    let getter;
    let cleanup;
    let boundCleanup;
    let forceTrigger = false;
    let isMultiSource = false;
    if ($717fdd2b58934d92$export$4f9f5282de18fc69(source)) {
        getter = ()=>source.value;
        forceTrigger = $717fdd2b58934d92$export$7f3fe6025abfa26e(source);
    } else if ($717fdd2b58934d92$export$352205f445242f02(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, $a5gC8.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>$717fdd2b58934d92$export$352205f445242f02(s) || $717fdd2b58934d92$export$7f3fe6025abfa26e(s));
        getter = ()=>source.map((s)=>{
                if ($717fdd2b58934d92$export$4f9f5282de18fc69(s)) return s.value;
                else if ($717fdd2b58934d92$export$352205f445242f02(s)) return reactiveGetter(s);
                else if ((0, $a5gC8.isFunction)(s)) return call ? call(s, 2) : s();
            });
    } else if ((0, $a5gC8.isFunction)(source)) {
        if (cb) getter = call ? ()=>call(source, 2) : source;
        else getter = ()=>{
            if (cleanup) {
                $717fdd2b58934d92$export$938a971395fef855();
                try {
                    cleanup();
                } finally{
                    $717fdd2b58934d92$export$c39176b1babaa8b8();
                }
            }
            const currentEffect = $717fdd2b58934d92$var$activeWatcher;
            $717fdd2b58934d92$var$activeWatcher = effect;
            try {
                return call ? call(source, 3, [
                    boundCleanup
                ]) : source(boundCleanup);
            } finally{
                $717fdd2b58934d92$var$activeWatcher = currentEffect;
            }
        };
    } else getter = (0, $a5gC8.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        const depth = deep === true ? Infinity : deep;
        getter = ()=>$717fdd2b58934d92$export$df3f009e3d155b20(baseGetter(), depth);
    }
    const scope = $717fdd2b58934d92$export$c7be4b0125a10cba();
    const watchHandle = ()=>{
        effect.stop();
        if (scope) (0, $a5gC8.remove)(scope.effects, effect);
    };
    if (once && cb) {
        const _cb = cb;
        cb = (...args)=>{
            _cb(...args);
            watchHandle();
        };
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($717fdd2b58934d92$var$INITIAL_WATCHER_VALUE) : $717fdd2b58934d92$var$INITIAL_WATCHER_VALUE;
    const job = (immediateFirstRun)=>{
        if (!(effect.flags & 1) || !effect.dirty && !immediateFirstRun) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v, i)=>(0, $a5gC8.hasChanged)(v, oldValue[i])) : (0, $a5gC8.hasChanged)(newValue, oldValue))) {
                if (cleanup) cleanup();
                const currentWatcher = $717fdd2b58934d92$var$activeWatcher;
                $717fdd2b58934d92$var$activeWatcher = effect;
                try {
                    const args = [
                        newValue,
                        // pass undefined as the old value when it's changed for the first time
                        oldValue === $717fdd2b58934d92$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $717fdd2b58934d92$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                        boundCleanup
                    ];
                    call ? call(cb, 3, args) : // @ts-expect-error
                    cb(...args);
                    oldValue = newValue;
                } finally{
                    $717fdd2b58934d92$var$activeWatcher = currentWatcher;
                }
            }
        } else effect.run();
    };
    if (augmentJob) augmentJob(job);
    effect = new $717fdd2b58934d92$export$28352bb4dd362521(getter);
    effect.scheduler = scheduler ? ()=>scheduler(job, false) : job;
    boundCleanup = (fn)=>$717fdd2b58934d92$export$8ddeeb083684a9d0(fn, false, effect);
    cleanup = effect.onStop = ()=>{
        const cleanups = $717fdd2b58934d92$var$cleanupMap.get(effect);
        if (cleanups) {
            if (call) call(cleanups, 4);
            else for (const cleanup2 of cleanups)cleanup2();
            $717fdd2b58934d92$var$cleanupMap.delete(effect);
        }
    };
    if (cb) {
        if (immediate) job(true);
        else oldValue = effect.run();
    } else if (scheduler) scheduler(job.bind(null, true), true);
    else effect.run();
    watchHandle.pause = effect.pause.bind(effect);
    watchHandle.resume = effect.resume.bind(effect);
    watchHandle.stop = watchHandle;
    return watchHandle;
}
function $717fdd2b58934d92$export$df3f009e3d155b20(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, $a5gC8.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value)) return value;
    seen.add(value);
    depth--;
    if ($717fdd2b58934d92$export$4f9f5282de18fc69(value)) $717fdd2b58934d92$export$df3f009e3d155b20(value.value, depth, seen);
    else if ((0, $a5gC8.isArray)(value)) for(let i = 0; i < value.length; i++)$717fdd2b58934d92$export$df3f009e3d155b20(value[i], depth, seen);
    else if ((0, $a5gC8.isSet)(value) || (0, $a5gC8.isMap)(value)) value.forEach((v)=>{
        $717fdd2b58934d92$export$df3f009e3d155b20(v, depth, seen);
    });
    else if ((0, $a5gC8.isPlainObject)(value)) {
        for(const key in value)$717fdd2b58934d92$export$df3f009e3d155b20(value[key], depth, seen);
        for (const key of Object.getOwnPropertySymbols(value))if (Object.prototype.propertyIsEnumerable.call(value, key)) $717fdd2b58934d92$export$df3f009e3d155b20(value[key], depth, seen);
    }
    return value;
}

});
parcelRegister("a5gC8", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $757742339cc56dac$export$b41394a5437791c8);
$parcel$export(module.exports, "EMPTY_OBJ", () => $757742339cc56dac$export$cf583d23ab39677c);
$parcel$export(module.exports, "EMPTY_ARR", () => $757742339cc56dac$export$6bd8558f433f1cc1);
$parcel$export(module.exports, "NOOP", () => $757742339cc56dac$export$5702a91a6f42969f);
$parcel$export(module.exports, "NO", () => $757742339cc56dac$export$c01351c0af048e39);
$parcel$export(module.exports, "isOn", () => $757742339cc56dac$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $757742339cc56dac$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $757742339cc56dac$export$8b58be045bf06082);
$parcel$export(module.exports, "remove", () => $757742339cc56dac$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "hasOwn", () => $757742339cc56dac$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $757742339cc56dac$export$43bee75e5e14138e);
$parcel$export(module.exports, "isMap", () => $757742339cc56dac$export$5c90113a285f2241);
$parcel$export(module.exports, "isSet", () => $757742339cc56dac$export$6750766a7c7ec627);
$parcel$export(module.exports, "isRegExp", () => $757742339cc56dac$export$49841c62b9eff15);
$parcel$export(module.exports, "isFunction", () => $757742339cc56dac$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $757742339cc56dac$export$844ec244b1367d54);
$parcel$export(module.exports, "isSymbol", () => $757742339cc56dac$export$a244864fd9645c7f);
$parcel$export(module.exports, "isObject", () => $757742339cc56dac$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isPromise", () => $757742339cc56dac$export$4369c812aac99591);
$parcel$export(module.exports, "toRawType", () => $757742339cc56dac$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isPlainObject", () => $757742339cc56dac$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isIntegerKey", () => $757742339cc56dac$export$e2a2b93446ec9fe);
$parcel$export(module.exports, "isReservedProp", () => $757742339cc56dac$export$bf7d3c0236f0aa85);
$parcel$export(module.exports, "isBuiltInDirective", () => $757742339cc56dac$export$a9c1fdb3030c2a6b);
$parcel$export(module.exports, "camelize", () => $757742339cc56dac$export$161d051f5dd25de7);
$parcel$export(module.exports, "hyphenate", () => $757742339cc56dac$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "capitalize", () => $757742339cc56dac$export$9a00dee1beb8f576);
$parcel$export(module.exports, "toHandlerKey", () => $757742339cc56dac$export$8c022799eeaaefcd);
$parcel$export(module.exports, "hasChanged", () => $757742339cc56dac$export$f619eb8b89076d23);
$parcel$export(module.exports, "invokeArrayFns", () => $757742339cc56dac$export$39951422d618a9d3);
$parcel$export(module.exports, "def", () => $757742339cc56dac$export$8afb76124cf08683);
$parcel$export(module.exports, "looseToNumber", () => $757742339cc56dac$export$d3be7195bcc2f31b);
$parcel$export(module.exports, "toNumber", () => $757742339cc56dac$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "getGlobalThis", () => $757742339cc56dac$export$ff5f2eeb11fc7e14);
$parcel$export(module.exports, "genCacheKey", () => $757742339cc56dac$export$abc5374c10a73a04);
$parcel$export(module.exports, "isGloballyAllowed", () => $757742339cc56dac$export$f73b8c13b7f97ebf);
$parcel$export(module.exports, "generateCodeFrame", () => $757742339cc56dac$export$f9c0d8b6684a279b);
$parcel$export(module.exports, "normalizeStyle", () => $757742339cc56dac$export$8756898546458274);
$parcel$export(module.exports, "parseStringStyle", () => $757742339cc56dac$export$76a205ce979d066a);
$parcel$export(module.exports, "stringifyStyle", () => $757742339cc56dac$export$9466a5a0ee6f1479);
$parcel$export(module.exports, "normalizeClass", () => $757742339cc56dac$export$4f7022d2d68e2c5a);
$parcel$export(module.exports, "isHTMLTag", () => $757742339cc56dac$export$1ccf854a0984f890);
$parcel$export(module.exports, "isSVGTag", () => $757742339cc56dac$export$6328ce7565ea1049);
$parcel$export(module.exports, "isMathMLTag", () => $757742339cc56dac$export$4a46ca4c5be17b20);
$parcel$export(module.exports, "isVoidTag", () => $757742339cc56dac$export$e5f2d3d97d9367a4);
$parcel$export(module.exports, "isSpecialBooleanAttr", () => $757742339cc56dac$export$d186f5eb2e810715);
$parcel$export(module.exports, "isBooleanAttr", () => $757742339cc56dac$export$f763ba3b84e9cd8c);
$parcel$export(module.exports, "includeBooleanAttr", () => $757742339cc56dac$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "isKnownHtmlAttr", () => $757742339cc56dac$export$f7e7a1cc7da8d5e9);
$parcel$export(module.exports, "isKnownSvgAttr", () => $757742339cc56dac$export$80da416f43933831);
$parcel$export(module.exports, "isRenderableAttrValue", () => $757742339cc56dac$export$921dd2acf0d386a3);
$parcel$export(module.exports, "getEscapedCssVarName", () => $757742339cc56dac$export$ad9a320bfb7ba440);
$parcel$export(module.exports, "looseEqual", () => $757742339cc56dac$export$ae8015769846262c);
$parcel$export(module.exports, "looseIndexOf", () => $757742339cc56dac$export$42912a80cedb8bd4);
$parcel$export(module.exports, "toDisplayString", () => $757742339cc56dac$export$b5b1545233b45293);
/**
* @vue/shared v3.5.12
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ /*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $757742339cc56dac$export$b41394a5437791c8(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
const $757742339cc56dac$export$cf583d23ab39677c = {};
const $757742339cc56dac$export$6bd8558f433f1cc1 = [];
const $757742339cc56dac$export$5702a91a6f42969f = ()=>{};
const $757742339cc56dac$export$c01351c0af048e39 = ()=>false;
const $757742339cc56dac$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $757742339cc56dac$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $757742339cc56dac$export$8b58be045bf06082 = Object.assign;
const $757742339cc56dac$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $757742339cc56dac$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $757742339cc56dac$export$b5a638e9b3fff9f3 = (val, key)=>$757742339cc56dac$var$hasOwnProperty.call(val, key);
const $757742339cc56dac$export$43bee75e5e14138e = Array.isArray;
const $757742339cc56dac$export$5c90113a285f2241 = (val)=>$757742339cc56dac$export$1dccc787cc36538b(val) === "[object Map]";
const $757742339cc56dac$export$6750766a7c7ec627 = (val)=>$757742339cc56dac$export$1dccc787cc36538b(val) === "[object Set]";
const $757742339cc56dac$export$871608497c498473 = (val)=>$757742339cc56dac$export$1dccc787cc36538b(val) === "[object Date]";
const $757742339cc56dac$export$49841c62b9eff15 = (val)=>$757742339cc56dac$export$1dccc787cc36538b(val) === "[object RegExp]";
const $757742339cc56dac$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $757742339cc56dac$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $757742339cc56dac$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $757742339cc56dac$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $757742339cc56dac$export$4369c812aac99591 = (val)=>{
    return ($757742339cc56dac$export$a6cdc56e425d0d0a(val) || $757742339cc56dac$export$f6e2535fb5126e54(val)) && $757742339cc56dac$export$f6e2535fb5126e54(val.then) && $757742339cc56dac$export$f6e2535fb5126e54(val.catch);
};
const $757742339cc56dac$export$830c053460e5ddf6 = Object.prototype.toString;
const $757742339cc56dac$export$1dccc787cc36538b = (value)=>$757742339cc56dac$export$830c053460e5ddf6.call(value);
const $757742339cc56dac$export$5ad0a3c360b8fbb5 = (value)=>{
    return $757742339cc56dac$export$1dccc787cc36538b(value).slice(8, -1);
};
const $757742339cc56dac$export$53b83ca8eaab0383 = (val)=>$757742339cc56dac$export$1dccc787cc36538b(val) === "[object Object]";
const $757742339cc56dac$export$e2a2b93446ec9fe = (key)=>$757742339cc56dac$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $757742339cc56dac$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $757742339cc56dac$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $757742339cc56dac$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $757742339cc56dac$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $757742339cc56dac$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $757742339cc56dac$var$camelizeRE = /-(\w)/g;
const $757742339cc56dac$export$161d051f5dd25de7 = $757742339cc56dac$var$cacheStringFunction((str)=>{
    return str.replace($757742339cc56dac$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $757742339cc56dac$var$hyphenateRE = /\B([A-Z])/g;
const $757742339cc56dac$export$6e6a0a3676c4b8bb = $757742339cc56dac$var$cacheStringFunction((str)=>str.replace($757742339cc56dac$var$hyphenateRE, "-$1").toLowerCase());
const $757742339cc56dac$export$9a00dee1beb8f576 = $757742339cc56dac$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $757742339cc56dac$export$8c022799eeaaefcd = $757742339cc56dac$var$cacheStringFunction((str)=>{
    const s = str ? `on${$757742339cc56dac$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $757742339cc56dac$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $757742339cc56dac$export$39951422d618a9d3 = (fns, ...arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](...arg);
};
const $757742339cc56dac$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $757742339cc56dac$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $757742339cc56dac$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $757742339cc56dac$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $757742339cc56dac$var$_globalThis;
const $757742339cc56dac$export$ff5f2eeb11fc7e14 = ()=>{
    return $757742339cc56dac$var$_globalThis || ($757742339cc56dac$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $757742339cc56dac$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $757742339cc56dac$export$53d5e12f9a1d3cde(name) {
    return $757742339cc56dac$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
function $757742339cc56dac$export$abc5374c10a73a04(source, options) {
    return source + JSON.stringify(options, (_, val)=>typeof val === "function" ? val.toString() : val);
}
const $757742339cc56dac$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "CACHED": -1,
    "-1": "CACHED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $757742339cc56dac$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const $757742339cc56dac$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $757742339cc56dac$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $757742339cc56dac$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $757742339cc56dac$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
const $757742339cc56dac$export$f73b8c13b7f97ebf = /* @__PURE__ */ $757742339cc56dac$export$b41394a5437791c8($757742339cc56dac$var$GLOBALS_ALLOWED);
const $757742339cc56dac$export$d6571a1911e4f27e = $757742339cc56dac$export$f73b8c13b7f97ebf;
const $757742339cc56dac$var$range = 2;
function $757742339cc56dac$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $757742339cc56dac$var$range; j <= i + $757742339cc56dac$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $757742339cc56dac$export$8756898546458274(value) {
    if ($757742339cc56dac$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $757742339cc56dac$export$844ec244b1367d54(item) ? $757742339cc56dac$export$76a205ce979d066a(item) : $757742339cc56dac$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($757742339cc56dac$export$844ec244b1367d54(value) || $757742339cc56dac$export$a6cdc56e425d0d0a(value)) return value;
}
const $757742339cc56dac$var$listDelimiterRE = /;(?![^(]*\))/g;
const $757742339cc56dac$var$propertyDelimiterRE = /:([^]+)/;
const $757742339cc56dac$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $757742339cc56dac$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($757742339cc56dac$var$styleCommentRE, "").split($757742339cc56dac$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($757742339cc56dac$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $757742339cc56dac$export$9466a5a0ee6f1479(styles) {
    let ret = "";
    if (!styles || $757742339cc56dac$export$844ec244b1367d54(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        if ($757742339cc56dac$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $757742339cc56dac$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $757742339cc56dac$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($757742339cc56dac$export$844ec244b1367d54(value)) res = value;
    else if ($757742339cc56dac$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $757742339cc56dac$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($757742339cc56dac$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $757742339cc56dac$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$757742339cc56dac$export$844ec244b1367d54(klass)) props.class = $757742339cc56dac$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $757742339cc56dac$export$8756898546458274(style);
    return props;
}
const $757742339cc56dac$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $757742339cc56dac$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $757742339cc56dac$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $757742339cc56dac$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $757742339cc56dac$export$1ccf854a0984f890 = /* @__PURE__ */ $757742339cc56dac$export$b41394a5437791c8($757742339cc56dac$var$HTML_TAGS);
const $757742339cc56dac$export$6328ce7565ea1049 = /* @__PURE__ */ $757742339cc56dac$export$b41394a5437791c8($757742339cc56dac$var$SVG_TAGS);
const $757742339cc56dac$export$4a46ca4c5be17b20 = /* @__PURE__ */ $757742339cc56dac$export$b41394a5437791c8($757742339cc56dac$var$MATH_TAGS);
const $757742339cc56dac$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $757742339cc56dac$export$b41394a5437791c8($757742339cc56dac$var$VOID_TAGS);
const $757742339cc56dac$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $757742339cc56dac$export$d186f5eb2e810715 = /* @__PURE__ */ $757742339cc56dac$export$b41394a5437791c8($757742339cc56dac$var$specialBooleanAttrs);
const $757742339cc56dac$export$f763ba3b84e9cd8c = /* @__PURE__ */ $757742339cc56dac$export$b41394a5437791c8($757742339cc56dac$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $757742339cc56dac$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $757742339cc56dac$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $757742339cc56dac$var$attrValidationCache = {};
function $757742339cc56dac$export$d55ef77660f30d12(name) {
    if ($757742339cc56dac$var$attrValidationCache.hasOwnProperty(name)) return $757742339cc56dac$var$attrValidationCache[name];
    const isUnsafe = $757742339cc56dac$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $757742339cc56dac$var$attrValidationCache[name] = !isUnsafe;
}
const $757742339cc56dac$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $757742339cc56dac$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $757742339cc56dac$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $757742339cc56dac$export$80da416f43933831 = /* @__PURE__ */ $757742339cc56dac$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $757742339cc56dac$export$fc0748a8e0014066 = /* @__PURE__ */ $757742339cc56dac$export$b41394a5437791c8(`accent,accentunder,actiontype,align,alignmentscope,altimg,altimg-height,altimg-valign,altimg-width,alttext,bevelled,close,columnsalign,columnlines,columnspan,denomalign,depth,dir,display,displaystyle,encoding,equalcolumns,equalrows,fence,fontstyle,fontweight,form,frame,framespacing,groupalign,height,href,id,indentalign,indentalignfirst,indentalignlast,indentshift,indentshiftfirst,indentshiftlast,indextype,justify,largetop,largeop,lquote,lspace,mathbackground,mathcolor,mathsize,mathvariant,maxsize,minlabelspacing,mode,other,overflow,position,rowalign,rowlines,rowspan,rquote,rspace,scriptlevel,scriptminsize,scriptsizemultiplier,selection,separator,separators,shift,side,src,stackalign,stretchy,subscriptshift,superscriptshift,symmetric,voffset,width,widths,xlink:href,xlink:show,xlink:type,xmlns`);
function $757742339cc56dac$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $757742339cc56dac$var$escapeRE = /["'&<>]/;
function $757742339cc56dac$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $757742339cc56dac$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $757742339cc56dac$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $757742339cc56dac$export$7b105034a53bde5f(src) {
    return src.replace($757742339cc56dac$var$commentStripRE, "");
}
const $757742339cc56dac$export$9320a7246b331080 = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function $757742339cc56dac$export$ad9a320bfb7ba440(key, doubleEscape) {
    return key.replace($757742339cc56dac$export$9320a7246b331080, (s)=>doubleEscape ? s === '"' ? '\\\\\\"' : `\\\\${s}` : `\\${s}`);
}
function $757742339cc56dac$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $757742339cc56dac$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $757742339cc56dac$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $757742339cc56dac$export$871608497c498473(a);
    let bValidType = $757742339cc56dac$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $757742339cc56dac$export$a244864fd9645c7f(a);
    bValidType = $757742339cc56dac$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $757742339cc56dac$export$43bee75e5e14138e(a);
    bValidType = $757742339cc56dac$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $757742339cc56dac$var$looseCompareArrays(a, b) : false;
    aValidType = $757742339cc56dac$export$a6cdc56e425d0d0a(a);
    bValidType = $757742339cc56dac$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$757742339cc56dac$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $757742339cc56dac$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$757742339cc56dac$export$ae8015769846262c(item, val));
}
const $757742339cc56dac$var$isRef = (val)=>{
    return !!(val && val["__v_isRef"] === true);
};
const $757742339cc56dac$export$b5b1545233b45293 = (val)=>{
    return $757742339cc56dac$export$844ec244b1367d54(val) ? val : val == null ? "" : $757742339cc56dac$export$43bee75e5e14138e(val) || $757742339cc56dac$export$a6cdc56e425d0d0a(val) && (val.toString === $757742339cc56dac$export$830c053460e5ddf6 || !$757742339cc56dac$export$f6e2535fb5126e54(val.toString)) ? $757742339cc56dac$var$isRef(val) ? $757742339cc56dac$export$b5b1545233b45293(val.value) : JSON.stringify(val, $757742339cc56dac$var$replacer, 2) : String(val);
};
const $757742339cc56dac$var$replacer = (_key, val)=>{
    if ($757742339cc56dac$var$isRef(val)) return $757742339cc56dac$var$replacer(_key, val.value);
    else if ($757742339cc56dac$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$757742339cc56dac$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($757742339cc56dac$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$757742339cc56dac$var$stringifySymbol(v))
    };
    else if ($757742339cc56dac$export$a244864fd9645c7f(val)) return $757742339cc56dac$var$stringifySymbol(val);
    else if ($757742339cc56dac$export$a6cdc56e425d0d0a(val) && !$757742339cc56dac$export$43bee75e5e14138e(val) && !$757742339cc56dac$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $757742339cc56dac$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $757742339cc56dac$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};

});



parcelRegister("5on3n", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", () => (parcelRequire("4mYx6")).BaseTransition);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => (parcelRequire("4mYx6")).BaseTransitionPropsValidators);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => (parcelRequire("4mYx6")).callWithAsyncErrorHandling);
$parcel$export(module.exports, "camelize", () => (parcelRequire("a5gC8")).camelize);
$parcel$export(module.exports, "computed", () => (parcelRequire("4mYx6")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("4mYx6")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("4mYx6")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("4mYx6")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("4mYx6")).createElementVNode);
$parcel$export(module.exports, "createHydrationRenderer", () => (parcelRequire("4mYx6")).createHydrationRenderer);
$parcel$export(module.exports, "createRenderer", () => (parcelRequire("4mYx6")).createRenderer);
$parcel$export(module.exports, "createStaticVNode", () => (parcelRequire("4mYx6")).createStaticVNode);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("4mYx6")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("4mYx6")).createVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("4mYx6")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("4mYx6")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("4mYx6")).getCurrentInstance);
$parcel$export(module.exports, "getTransitionRawChildren", () => (parcelRequire("4mYx6")).getTransitionRawChildren);
$parcel$export(module.exports, "h", () => (parcelRequire("4mYx6")).h);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("4mYx6")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("4mYx6")).inject);
$parcel$export(module.exports, "isRuntimeOnly", () => (parcelRequire("4mYx6")).isRuntimeOnly);
$parcel$export(module.exports, "mergeProps", () => (parcelRequire("4mYx6")).mergeProps);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("4mYx6")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("a5gC8")).normalizeClass);
$parcel$export(module.exports, "onBeforeMount", () => (parcelRequire("4mYx6")).onBeforeMount);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("4mYx6")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("4mYx6")).onUnmounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("4mYx6")).onUpdated);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("4mYx6")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("4mYx6")).provide);
$parcel$export(module.exports, "reactive", () => (parcelRequire("9K9BQ")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("9K9BQ")).ref);
$parcel$export(module.exports, "registerRuntimeCompiler", () => (parcelRequire("4mYx6")).registerRuntimeCompiler);
$parcel$export(module.exports, "renderList", () => (parcelRequire("4mYx6")).renderList);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("4mYx6")).renderSlot);
$parcel$export(module.exports, "resolveTransitionHooks", () => (parcelRequire("4mYx6")).resolveTransitionHooks);
$parcel$export(module.exports, "setTransitionHooks", () => (parcelRequire("4mYx6")).setTransitionHooks);
$parcel$export(module.exports, "Static", () => (parcelRequire("4mYx6")).Static);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("9K9BQ")).toRaw);
$parcel$export(module.exports, "useTransitionState", () => (parcelRequire("4mYx6")).useTransitionState);
$parcel$export(module.exports, "warn", () => (parcelRequire("4mYx6")).warn);
$parcel$export(module.exports, "watch", () => (parcelRequire("4mYx6")).watch);
$parcel$export(module.exports, "watchEffect", () => (parcelRequire("4mYx6")).watchEffect);
$parcel$export(module.exports, "watchPostEffect", () => (parcelRequire("4mYx6")).watchPostEffect);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("4mYx6")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("4mYx6")).withDirectives);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("a5gC8")).toDisplayString);

$parcel$export(module.exports, "createApp", () => $3ed113924ee47013$export$4e373c34abfa8c68);
$parcel$export(module.exports, "vModelCheckbox", () => $3ed113924ee47013$export$8847c2e532b35714);
$parcel$export(module.exports, "vModelSelect", () => $3ed113924ee47013$export$87d227567b51ca39);
$parcel$export(module.exports, "withModifiers", () => $3ed113924ee47013$export$26bd3b8e29e6f273);
/**
* @vue/runtime-dom v3.5.12
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $4mYx6 = parcelRequire("4mYx6");
var $a5gC8 = parcelRequire("a5gC8");
var $9K9BQ = parcelRequire("9K9BQ");parcelRequire("a5gC8");
var $9K9BQ = parcelRequire("9K9BQ");

var $a5gC8 = parcelRequire("a5gC8");
let $3ed113924ee47013$var$policy = void 0;
const $3ed113924ee47013$var$tt = typeof window !== "undefined" && window.trustedTypes;
if ($3ed113924ee47013$var$tt) try {
    $3ed113924ee47013$var$policy = /* @__PURE__ */ $3ed113924ee47013$var$tt.createPolicy("vue", {
        createHTML: (val)=>val
    });
} catch (e) {}
const $3ed113924ee47013$var$unsafeToTrustedHTML = $3ed113924ee47013$var$policy ? (val)=>$3ed113924ee47013$var$policy.createHTML(val) : (val)=>val;
const $3ed113924ee47013$var$svgNS = "http://www.w3.org/2000/svg";
const $3ed113924ee47013$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
const $3ed113924ee47013$var$doc = typeof document !== "undefined" ? document : null;
const $3ed113924ee47013$var$templateContainer = $3ed113924ee47013$var$doc && /* @__PURE__ */ $3ed113924ee47013$var$doc.createElement("template");
const $3ed113924ee47013$var$nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? $3ed113924ee47013$var$doc.createElementNS($3ed113924ee47013$var$svgNS, tag) : namespace === "mathml" ? $3ed113924ee47013$var$doc.createElementNS($3ed113924ee47013$var$mathmlNS, tag) : is ? $3ed113924ee47013$var$doc.createElement(tag, {
            is: is
        }) : $3ed113924ee47013$var$doc.createElement(tag);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$3ed113924ee47013$var$doc.createTextNode(text),
    createComment: (text)=>$3ed113924ee47013$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$3ed113924ee47013$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $3ed113924ee47013$var$templateContainer.innerHTML = $3ed113924ee47013$var$unsafeToTrustedHTML(namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content);
            const template = $3ed113924ee47013$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $3ed113924ee47013$var$TRANSITION = "transition";
const $3ed113924ee47013$var$ANIMATION = "animation";
const $3ed113924ee47013$var$vtcKey = Symbol("_vtc");
const $3ed113924ee47013$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $3ed113924ee47013$var$TransitionPropsValidators = /* @__PURE__ */ (0, $a5gC8.extend)({}, (0, $4mYx6.BaseTransitionPropsValidators), $3ed113924ee47013$var$DOMTransitionPropsValidators);
const $3ed113924ee47013$var$decorate$1 = (t)=>{
    t.displayName = "Transition";
    t.props = $3ed113924ee47013$var$TransitionPropsValidators;
    return t;
};
const $3ed113924ee47013$export$be58926105124dd4 = /* @__PURE__ */ $3ed113924ee47013$var$decorate$1((props, { slots: slots })=>(0, $4mYx6.h)((0, $4mYx6.BaseTransition), $3ed113924ee47013$var$resolveTransitionProps(props), slots));
const $3ed113924ee47013$var$callHook = (hook, args = [])=>{
    if ((0, $a5gC8.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $3ed113924ee47013$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $a5gC8.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $3ed113924ee47013$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $3ed113924ee47013$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $3ed113924ee47013$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done)=>{
        $3ed113924ee47013$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $3ed113924ee47013$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $3ed113924ee47013$var$removeTransitionClass(el, leaveFromClass);
        $3ed113924ee47013$var$removeTransitionClass(el, leaveToClass);
        $3ed113924ee47013$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $3ed113924ee47013$var$callHook(hook, [
                el,
                resolve
            ]);
            $3ed113924ee47013$var$nextFrame(()=>{
                $3ed113924ee47013$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $3ed113924ee47013$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$3ed113924ee47013$var$hasExplicitCallback(hook)) $3ed113924ee47013$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $a5gC8.extend)(baseProps, {
        onBeforeEnter (el) {
            $3ed113924ee47013$var$callHook(onBeforeEnter, [
                el
            ]);
            $3ed113924ee47013$var$addTransitionClass(el, enterFromClass);
            $3ed113924ee47013$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $3ed113924ee47013$var$callHook(onBeforeAppear, [
                el
            ]);
            $3ed113924ee47013$var$addTransitionClass(el, appearFromClass);
            $3ed113924ee47013$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $3ed113924ee47013$var$addTransitionClass(el, leaveFromClass);
            $3ed113924ee47013$var$addTransitionClass(el, leaveActiveClass);
            $3ed113924ee47013$var$forceReflow();
            $3ed113924ee47013$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $3ed113924ee47013$var$removeTransitionClass(el, leaveFromClass);
                $3ed113924ee47013$var$addTransitionClass(el, leaveToClass);
                if (!$3ed113924ee47013$var$hasExplicitCallback(onLeave)) $3ed113924ee47013$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $3ed113924ee47013$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false);
            $3ed113924ee47013$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true);
            $3ed113924ee47013$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $3ed113924ee47013$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $3ed113924ee47013$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $a5gC8.isObject)(duration)) return [
        $3ed113924ee47013$var$NumberOf(duration.enter),
        $3ed113924ee47013$var$NumberOf(duration.leave)
    ];
    else {
        const n = $3ed113924ee47013$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $3ed113924ee47013$var$NumberOf(val) {
    const res = (0, $a5gC8.toNumber)(val);
    return res;
}
function $3ed113924ee47013$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$3ed113924ee47013$var$vtcKey] || (el[$3ed113924ee47013$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $3ed113924ee47013$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$3ed113924ee47013$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$3ed113924ee47013$var$vtcKey] = void 0;
    }
}
function $3ed113924ee47013$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $3ed113924ee47013$var$endId = 0;
function $3ed113924ee47013$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$3ed113924ee47013$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout != null) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $3ed113924ee47013$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $3ed113924ee47013$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$3ed113924ee47013$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$3ed113924ee47013$var$TRANSITION}Duration`);
    const transitionTimeout = $3ed113924ee47013$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$3ed113924ee47013$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$3ed113924ee47013$var$ANIMATION}Duration`);
    const animationTimeout = $3ed113924ee47013$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $3ed113924ee47013$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $3ed113924ee47013$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $3ed113924ee47013$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $3ed113924ee47013$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $3ed113924ee47013$var$TRANSITION : $3ed113924ee47013$var$ANIMATION : null;
        propCount = type ? type === $3ed113924ee47013$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $3ed113924ee47013$var$TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties(`${$3ed113924ee47013$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $3ed113924ee47013$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$3ed113924ee47013$var$toMs(d) + $3ed113924ee47013$var$toMs(delays[i])));
}
function $3ed113924ee47013$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $3ed113924ee47013$var$forceReflow() {
    return document.body.offsetHeight;
}
function $3ed113924ee47013$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$3ed113924ee47013$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $3ed113924ee47013$var$vShowOriginalDisplay = Symbol("_vod");
const $3ed113924ee47013$var$vShowHidden = Symbol("_vsh");
const $3ed113924ee47013$export$5cb4fcdc6937d7e1 = {
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$3ed113924ee47013$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $3ed113924ee47013$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $3ed113924ee47013$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $3ed113924ee47013$var$setDisplay(el, false);
            });
        } else $3ed113924ee47013$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $3ed113924ee47013$var$setDisplay(el, value);
    }
};
function $3ed113924ee47013$var$setDisplay(el, value) {
    el.style.display = value ? el[$3ed113924ee47013$var$vShowOriginalDisplay] : "none";
    el[$3ed113924ee47013$var$vShowHidden] = !value;
}
function $3ed113924ee47013$var$initVShowForSSR() {
    $3ed113924ee47013$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $3ed113924ee47013$var$CSS_VAR_TEXT = Symbol("");
function $3ed113924ee47013$export$ef28b76f07940108(getter) {
    const instance = (0, $4mYx6.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$3ed113924ee47013$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        if (instance.ce) $3ed113924ee47013$var$setVarsOnNode(instance.ce, vars);
        else $3ed113924ee47013$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $4mYx6.onBeforeMount)(()=>{
        (0, $4mYx6.watchPostEffect)(setVars);
    });
    (0, $4mYx6.onMounted)(()=>{
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $4mYx6.onUnmounted)(()=>ob.disconnect());
    });
}
function $3ed113924ee47013$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $3ed113924ee47013$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $3ed113924ee47013$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $4mYx6.Fragment)) vnode.children.forEach((c)=>$3ed113924ee47013$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $4mYx6.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $3ed113924ee47013$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $3ed113924ee47013$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            style.setProperty(`--${key}`, vars[key]);
            cssText += `--${key}: ${vars[key]};`;
        }
        style[$3ed113924ee47013$var$CSS_VAR_TEXT] = cssText;
    }
}
const $3ed113924ee47013$var$displayRE = /(^|;)\s*display\s*:/;
function $3ed113924ee47013$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $a5gC8.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, $a5gC8.isString)(prev)) {
                for(const key in prev)if (next[key] == null) $3ed113924ee47013$var$setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) $3ed113924ee47013$var$setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            $3ed113924ee47013$var$setStyle(style, key, next[key]);
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[$3ed113924ee47013$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $3ed113924ee47013$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($3ed113924ee47013$var$vShowOriginalDisplay in el) {
        el[$3ed113924ee47013$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$3ed113924ee47013$var$vShowHidden]) style.display = "none";
    }
}
const $3ed113924ee47013$var$semicolonRE = /[^\\];\s*$/;
const $3ed113924ee47013$var$importantRE = /\s*!important$/;
function $3ed113924ee47013$var$setStyle(style, name, val) {
    if ((0, $a5gC8.isArray)(val)) val.forEach((v)=>$3ed113924ee47013$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $3ed113924ee47013$var$autoPrefix(style, name);
            if ($3ed113924ee47013$var$importantRE.test(val)) style.setProperty((0, $a5gC8.hyphenate)(prefixed), val.replace($3ed113924ee47013$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $3ed113924ee47013$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $3ed113924ee47013$var$prefixCache = {};
function $3ed113924ee47013$var$autoPrefix(style, rawName) {
    const cached = $3ed113924ee47013$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $a5gC8.camelize)(rawName);
    if (name !== "filter" && name in style) return $3ed113924ee47013$var$prefixCache[rawName] = name;
    name = (0, $a5gC8.capitalize)(name);
    for(let i = 0; i < $3ed113924ee47013$var$prefixes.length; i++){
        const prefixed = $3ed113924ee47013$var$prefixes[i] + name;
        if (prefixed in style) return $3ed113924ee47013$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $3ed113924ee47013$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $3ed113924ee47013$var$patchAttr(el, key, value, isSVG, instance, isBoolean = (0, $a5gC8.isSpecialBooleanAttr)(key)) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($3ed113924ee47013$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($3ed113924ee47013$var$xlinkNS, key, value);
    } else if (value == null || isBoolean && !(0, $a5gC8.includeBooleanAttr)(value)) el.removeAttribute(key);
    else el.setAttribute(key, isBoolean ? "" : (0, $a5gC8.isSymbol)(value) ? String(value) : value);
}
function $3ed113924ee47013$var$patchDOMProp(el, key, value, parentComponent, attrName) {
    if (key === "innerHTML" || key === "textContent") {
        if (value != null) el[key] = key === "innerHTML" ? $3ed113924ee47013$var$unsafeToTrustedHTML(value) : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? // #11647: value should be set as empty string for null and undefined,
        // but <input type="checkbox"> should be set as 'on'.
        el.type === "checkbox" ? "on" : "" : String(value);
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $a5gC8.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(attrName || key);
}
function $3ed113924ee47013$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $3ed113924ee47013$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $3ed113924ee47013$var$veiKey = Symbol("_vei");
function $3ed113924ee47013$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$3ed113924ee47013$var$veiKey] || (el[$3ed113924ee47013$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $3ed113924ee47013$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $3ed113924ee47013$var$createInvoker(nextValue, instance);
            $3ed113924ee47013$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $3ed113924ee47013$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $3ed113924ee47013$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $3ed113924ee47013$var$parseName(name) {
    let options;
    if ($3ed113924ee47013$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($3ed113924ee47013$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $a5gC8.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $3ed113924ee47013$var$cachedNow = 0;
const $3ed113924ee47013$var$p = /* @__PURE__ */ Promise.resolve();
const $3ed113924ee47013$var$getNow = ()=>$3ed113924ee47013$var$cachedNow || ($3ed113924ee47013$var$p.then(()=>$3ed113924ee47013$var$cachedNow = 0), $3ed113924ee47013$var$cachedNow = Date.now());
function $3ed113924ee47013$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $4mYx6.callWithAsyncErrorHandling)($3ed113924ee47013$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $3ed113924ee47013$var$getNow();
    return invoker;
}
function $3ed113924ee47013$var$sanitizeEventValue(value, propName) {
    if ((0, $a5gC8.isFunction)(value) || (0, $a5gC8.isArray)(value)) return value;
    (0, $4mYx6.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, $a5gC8.NOOP;
}
function $3ed113924ee47013$var$patchStopImmediatePropagation(e, value) {
    if ((0, $a5gC8.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const $3ed113924ee47013$var$isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const $3ed113924ee47013$var$patchProp = (el, key, prevValue, nextValue, namespace, parentComponent)=>{
    const isSVG = namespace === "svg";
    if (key === "class") $3ed113924ee47013$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $3ed113924ee47013$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $a5gC8.isOn)(key)) {
        if (!(0, $a5gC8.isModelListener)(key)) $3ed113924ee47013$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $3ed113924ee47013$var$shouldSetAsProp(el, key, nextValue, isSVG)) {
        $3ed113924ee47013$var$patchDOMProp(el, key, nextValue);
        if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) $3ed113924ee47013$var$patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    } else if (// #11081 force set props for possible async custom element
    el._isVueCE && (/[A-Z]/.test(key) || !(0, $a5gC8.isString)(nextValue))) $3ed113924ee47013$var$patchDOMProp(el, (0, $a5gC8.camelize)(key), nextValue, parentComponent, key);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $3ed113924ee47013$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $3ed113924ee47013$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $3ed113924ee47013$var$isNativeOn(key) && (0, $a5gC8.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($3ed113924ee47013$var$isNativeOn(key) && (0, $a5gC8.isString)(value)) return false;
    return key in el;
}
const $3ed113924ee47013$var$REMOVAL = {};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $3ed113924ee47013$export$a00e2346eabbdbef(options, extraOptions, _createApp) {
    const Comp = (0, $4mYx6.defineComponent)(options, extraOptions);
    if ((0, $a5gC8.isPlainObject)(Comp)) (0, $a5gC8.extend)(Comp, extraOptions);
    class VueCustomElement extends $3ed113924ee47013$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, _createApp);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
/*! #__NO_SIDE_EFFECTS__ */ const $3ed113924ee47013$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options, extraOptions)=>{
    return /* @__PURE__ */ $3ed113924ee47013$export$a00e2346eabbdbef(options, extraOptions, $3ed113924ee47013$export$35800275c0037383);
};
const $3ed113924ee47013$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $3ed113924ee47013$export$b337c1a55163dbe3 extends $3ed113924ee47013$var$BaseClass {
    constructor(_def, _props = {}, _createApp = $3ed113924ee47013$export$4e373c34abfa8c68){
        super();
        this._def = _def;
        this._props = _props;
        this._createApp = _createApp;
        this._isVueCE = true;
        /**
     * @internal
     */ this._instance = null;
        /**
     * @internal
     */ this._app = null;
        /**
     * @internal
     */ this._nonce = this._def.nonce;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        this._styleChildren = /* @__PURE__ */ new WeakSet();
        this._ob = null;
        if (this.shadowRoot && _createApp !== $3ed113924ee47013$export$4e373c34abfa8c68) this._root = this.shadowRoot;
        else if (_def.shadowRoot !== false) {
            this.attachShadow({
                mode: "open"
            });
            this._root = this.shadowRoot;
        } else this._root = this;
        if (!this._def.__asyncLoader) this._resolveProps(this._def);
    }
    connectedCallback() {
        if (!this.isConnected) return;
        if (!this.shadowRoot) this._parseSlots();
        this._connected = true;
        let parent = this;
        while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $3ed113924ee47013$export$b337c1a55163dbe3) {
            this._parent = parent;
            break;
        }
        if (!this._instance) {
            if (this._resolved) {
                this._setParent();
                this._update();
            } else if (parent && parent._pendingResolve) this._pendingResolve = parent._pendingResolve.then(()=>{
                this._pendingResolve = void 0;
                this._resolveDef();
            });
            else this._resolveDef();
        }
    }
    _setParent(parent = this._parent) {
        if (parent) {
            this._instance.parent = parent._instance;
            this._instance.provides = parent._instance.provides;
        }
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $4mYx6.nextTick)(()=>{
            if (!this._connected) {
                if (this._ob) {
                    this._ob.disconnect();
                    this._ob = null;
                }
                this._app && this._app.unmount();
                if (this._instance) this._instance.ce = void 0;
                this._app = this._instance = null;
            }
        });
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        if (this._pendingResolve) return;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        });
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            this._resolved = true;
            this._pendingResolve = void 0;
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $a5gC8.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $a5gC8.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $a5gC8.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            if (isAsync) this._resolveProps(def);
            if (this.shadowRoot) this._applyStyles(styles);
            this._mount(def);
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) this._pendingResolve = asyncDef().then((def)=>resolve(this._def = def, true));
        else resolve(this._def);
    }
    _mount(def) {
        if (__VUE_PROD_DEVTOOLS__ && !def.name) def.name = "VueElement";
        this._app = this._createApp(def);
        if (def.configureApp) def.configureApp(this._app);
        this._app._ceVNode = this._createVNode();
        this._app.mount(this._root);
        const exposed = this._instance && this._instance.exposed;
        if (!exposed) return;
        for(const key in exposed)if (!(0, $a5gC8.hasOwn)(this, key)) Object.defineProperty(this, key, {
            // unwrap ref to be consistent with public instance behavior
            get: ()=>(0, $9K9BQ.unref)(exposed[key])
        });
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $a5gC8.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key]);
        for (const key of declaredPropKeys.map((0, $a5gC8.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val, true, true);
            }
        });
    }
    _setAttr(key) {
        if (key.startsWith("data-v-")) return;
        const has = this.hasAttribute(key);
        let value = has ? this.getAttribute(key) : $3ed113924ee47013$var$REMOVAL;
        const camelKey = (0, $a5gC8.camelize)(key);
        if (has && this._numberProps && this._numberProps[camelKey]) value = (0, $a5gC8.toNumber)(value);
        this._setProp(camelKey, value, false, true);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = false) {
        if (val !== this._props[key]) {
            if (val === $3ed113924ee47013$var$REMOVAL) delete this._props[key];
            else {
                this._props[key] = val;
                if (key === "key" && this._app) this._app._ceVNode.key = val;
            }
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                if (val === true) this.setAttribute((0, $a5gC8.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $a5gC8.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $a5gC8.hyphenate)(key));
            }
        }
    }
    _update() {
        $3ed113924ee47013$export$b3890eb0ae9dca99(this._createVNode(), this._root);
    }
    _createVNode() {
        const baseProps = {};
        if (!this.shadowRoot) baseProps.onVnodeMounted = baseProps.onVnodeUpdated = this._renderSlots.bind(this);
        const vnode = (0, $4mYx6.createVNode)(this._def, (0, $a5gC8.extend)(baseProps, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.ce = this;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, (0, $a5gC8.isPlainObject)(args[0]) ? (0, $a5gC8.extend)({
                    detail: args
                }, args[0]) : {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $a5gC8.hyphenate)(event) !== event) dispatch((0, $a5gC8.hyphenate)(event), args);
            };
            this._setParent();
        };
        return vnode;
    }
    _applyStyles(styles, owner) {
        if (!styles) return;
        if (owner) {
            if (owner === this._def || this._styleChildren.has(owner)) return;
            this._styleChildren.add(owner);
        }
        const nonce = this._nonce;
        for(let i = styles.length - 1; i >= 0; i--){
            const s = document.createElement("style");
            if (nonce) s.setAttribute("nonce", nonce);
            s.textContent = styles[i];
            this.shadowRoot.prepend(s);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _parseSlots() {
        const slots = this._slots = {};
        let n;
        while(n = this.firstChild){
            const slotName = n.nodeType === 1 && n.getAttribute("slot") || "default";
            (slots[slotName] || (slots[slotName] = [])).push(n);
            this.removeChild(n);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _renderSlots() {
        const outlets = (this._teleportTarget || this).querySelectorAll("slot");
        const scopeId = this._instance.type.__scopeId;
        for(let i = 0; i < outlets.length; i++){
            const o = outlets[i];
            const slotName = o.getAttribute("name") || "default";
            const content = this._slots[slotName];
            const parent = o.parentNode;
            if (content) for (const n of content){
                if (scopeId && n.nodeType === 1) {
                    const id = scopeId + "-s";
                    const walker = document.createTreeWalker(n, 1);
                    n.setAttribute(id, "");
                    let child;
                    while(child = walker.nextNode())child.setAttribute(id, "");
                }
                parent.insertBefore(n, o);
            }
            else while(o.firstChild)parent.insertBefore(o.firstChild, o);
            parent.removeChild(o);
        }
    }
    /**
   * @internal
   */ _injectChildStyle(comp) {
        this._applyStyles(comp.styles, comp);
    }
    /**
   * @internal
   */ _removeChildStyle(comp) {
        var s;
    }
}
function $3ed113924ee47013$export$da5acfe93a94e37d(caller) {
    const instance = (0, $4mYx6.getCurrentInstance)();
    const el = instance && instance.ce;
    if (el) return el;
    else if (false) {
        if (!instance) (0, $4mYx6.warn)(`${caller || "useHost"} called without an active component instance.`);
        else (0, $4mYx6.warn)(`${caller || "useHost"} can only be used in components defined via defineCustomElement.`);
    }
    return null;
}
function $3ed113924ee47013$export$64d45095031fa749() {
    const el = $3ed113924ee47013$export$da5acfe93a94e37d();
    return el && el.shadowRoot;
}
function $3ed113924ee47013$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $4mYx6.getCurrentInstance)();
        if (!instance) return 0, $a5gC8.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $a5gC8.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $a5gC8.EMPTY_OBJ;
        return mod;
    }
}
const $3ed113924ee47013$var$positionMap = /* @__PURE__ */ new WeakMap();
const $3ed113924ee47013$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $3ed113924ee47013$var$moveCbKey = Symbol("_moveCb");
const $3ed113924ee47013$var$enterCbKey = Symbol("_enterCb");
const $3ed113924ee47013$var$decorate = (t)=>{
    delete t.props.mode;
    return t;
};
const $3ed113924ee47013$var$TransitionGroupImpl = /* @__PURE__ */ $3ed113924ee47013$var$decorate({
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $a5gC8.extend)({}, $3ed113924ee47013$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $4mYx6.getCurrentInstance)();
        const state = (0, $4mYx6.useTransitionState)();
        let prevChildren;
        let children;
        (0, $4mYx6.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$3ed113924ee47013$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            prevChildren.forEach($3ed113924ee47013$var$callPendingCbs);
            prevChildren.forEach($3ed113924ee47013$var$recordPosition);
            const movedChildren = prevChildren.filter($3ed113924ee47013$var$applyTranslation);
            $3ed113924ee47013$var$forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $3ed113924ee47013$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$3ed113924ee47013$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el[$3ed113924ee47013$var$moveCbKey] = null;
                        $3ed113924ee47013$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return ()=>{
            const rawProps = (0, $9K9BQ.toRaw)(props);
            const cssTransitionProps = $3ed113924ee47013$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $4mYx6.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element) {
                    prevChildren.push(child);
                    (0, $4mYx6.setTransitionHooks)(child, (0, $4mYx6.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $3ed113924ee47013$var$positionMap.set(child, child.el.getBoundingClientRect());
                }
            }
            children = slots.default ? (0, $4mYx6.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $4mYx6.setTransitionHooks)(child, (0, $4mYx6.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            return (0, $4mYx6.createVNode)(tag, null, children);
        };
    }
});
const $3ed113924ee47013$export$19ffa8f511f7bc2e = $3ed113924ee47013$var$TransitionGroupImpl;
function $3ed113924ee47013$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$3ed113924ee47013$var$moveCbKey]) el[$3ed113924ee47013$var$moveCbKey]();
    if (el[$3ed113924ee47013$var$enterCbKey]) el[$3ed113924ee47013$var$enterCbKey]();
}
function $3ed113924ee47013$var$recordPosition(c) {
    $3ed113924ee47013$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $3ed113924ee47013$var$applyTranslation(c) {
    const oldPos = $3ed113924ee47013$var$positionMap.get(c);
    const newPos = $3ed113924ee47013$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $3ed113924ee47013$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$3ed113924ee47013$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $3ed113924ee47013$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $3ed113924ee47013$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $a5gC8.isArray)(fn) ? (value)=>(0, $a5gC8.invokeArrayFns)(fn, value) : fn;
};
function $3ed113924ee47013$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $3ed113924ee47013$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $3ed113924ee47013$var$assignKey = Symbol("_assign");
const $3ed113924ee47013$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$3ed113924ee47013$var$assignKey] = $3ed113924ee47013$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $3ed113924ee47013$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $a5gC8.looseToNumber)(domValue);
            el[$3ed113924ee47013$var$assignKey](domValue);
        });
        if (trim) $3ed113924ee47013$var$addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            $3ed113924ee47013$var$addEventListener(el, "compositionstart", $3ed113924ee47013$var$onCompositionStart);
            $3ed113924ee47013$var$addEventListener(el, "compositionend", $3ed113924ee47013$var$onCompositionEnd);
            $3ed113924ee47013$var$addEventListener(el, "change", $3ed113924ee47013$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, oldValue: oldValue, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$3ed113924ee47013$var$assignKey] = $3ed113924ee47013$var$getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $a5gC8.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy && value === oldValue) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const $3ed113924ee47013$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$3ed113924ee47013$var$assignKey] = $3ed113924ee47013$var$getModelAssigner(vnode);
        $3ed113924ee47013$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $3ed113924ee47013$var$getValue(el);
            const checked = el.checked;
            const assign = el[$3ed113924ee47013$var$assignKey];
            if ((0, $a5gC8.isArray)(modelValue)) {
                const index = (0, $a5gC8.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $a5gC8.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($3ed113924ee47013$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $3ed113924ee47013$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$3ed113924ee47013$var$assignKey] = $3ed113924ee47013$var$getModelAssigner(vnode);
        $3ed113924ee47013$var$setChecked(el, binding, vnode);
    }
};
function $3ed113924ee47013$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    let checked;
    if ((0, $a5gC8.isArray)(value)) checked = (0, $a5gC8.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $a5gC8.isSet)(value)) checked = value.has(vnode.props.value);
    else {
        if (value === oldValue) return;
        checked = (0, $a5gC8.looseEqual)(value, $3ed113924ee47013$var$getCheckboxValue(el, true));
    }
    if (el.checked !== checked) el.checked = checked;
}
const $3ed113924ee47013$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $a5gC8.looseEqual)(value, vnode.props.value);
        el[$3ed113924ee47013$var$assignKey] = $3ed113924ee47013$var$getModelAssigner(vnode);
        $3ed113924ee47013$var$addEventListener(el, "change", ()=>{
            el[$3ed113924ee47013$var$assignKey]($3ed113924ee47013$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$3ed113924ee47013$var$assignKey] = $3ed113924ee47013$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $a5gC8.looseEqual)(value, vnode.props.value);
    }
};
const $3ed113924ee47013$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $a5gC8.isSet)(value);
        $3ed113924ee47013$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $a5gC8.looseToNumber)($3ed113924ee47013$var$getValue(o)) : $3ed113924ee47013$var$getValue(o));
            el[$3ed113924ee47013$var$assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, $4mYx6.nextTick)(()=>{
                el._assigning = false;
            });
        });
        el[$3ed113924ee47013$var$assignKey] = $3ed113924ee47013$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $3ed113924ee47013$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el[$3ed113924ee47013$var$assignKey] = $3ed113924ee47013$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        if (!el._assigning) $3ed113924ee47013$var$setSelected(el, value);
    }
};
function $3ed113924ee47013$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, $a5gC8.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $a5gC8.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $3ed113924ee47013$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, $a5gC8.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $a5gC8.looseEqual)($3ed113924ee47013$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $3ed113924ee47013$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $3ed113924ee47013$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $3ed113924ee47013$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $3ed113924ee47013$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $3ed113924ee47013$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $3ed113924ee47013$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $3ed113924ee47013$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $3ed113924ee47013$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $3ed113924ee47013$export$87d227567b51ca39;
        case "TEXTAREA":
            return $3ed113924ee47013$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $3ed113924ee47013$export$8847c2e532b35714;
                case "radio":
                    return $3ed113924ee47013$export$b4356c59b38b7aa9;
                default:
                    return $3ed113924ee47013$export$f1f88689f5728478;
            }
    }
}
function $3ed113924ee47013$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $3ed113924ee47013$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $3ed113924ee47013$var$initVModelForSSR() {
    $3ed113924ee47013$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $3ed113924ee47013$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $a5gC8.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $3ed113924ee47013$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $a5gC8.isArray)(value)) {
            if (vnode.props && (0, $a5gC8.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $a5gC8.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $3ed113924ee47013$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $3ed113924ee47013$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $3ed113924ee47013$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $3ed113924ee47013$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$3ed113924ee47013$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $3ed113924ee47013$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $3ed113924ee47013$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const $3ed113924ee47013$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $3ed113924ee47013$export$f691a8759658f782 = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $a5gC8.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $3ed113924ee47013$var$keyNames[k] === eventKey)) return fn(event);
    });
};
const $3ed113924ee47013$var$rendererOptions = /* @__PURE__ */ (0, $a5gC8.extend)({
    patchProp: $3ed113924ee47013$var$patchProp
}, $3ed113924ee47013$var$nodeOps);
let $3ed113924ee47013$var$renderer;
let $3ed113924ee47013$var$enabledHydration = false;
function $3ed113924ee47013$var$ensureRenderer() {
    return $3ed113924ee47013$var$renderer || ($3ed113924ee47013$var$renderer = (0, $4mYx6.createRenderer)($3ed113924ee47013$var$rendererOptions));
}
function $3ed113924ee47013$var$ensureHydrationRenderer() {
    $3ed113924ee47013$var$renderer = $3ed113924ee47013$var$enabledHydration ? $3ed113924ee47013$var$renderer : (0, $4mYx6.createHydrationRenderer)($3ed113924ee47013$var$rendererOptions);
    $3ed113924ee47013$var$enabledHydration = true;
    return $3ed113924ee47013$var$renderer;
}
const $3ed113924ee47013$export$b3890eb0ae9dca99 = (...args)=>{
    $3ed113924ee47013$var$ensureRenderer().render(...args);
};
const $3ed113924ee47013$export$fa8d919ba61d84db = (...args)=>{
    $3ed113924ee47013$var$ensureHydrationRenderer().hydrate(...args);
};
const $3ed113924ee47013$export$4e373c34abfa8c68 = (...args)=>{
    const app = $3ed113924ee47013$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $3ed113924ee47013$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $a5gC8.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        if (container.nodeType === 1) container.textContent = "";
        const proxy = mount(container, false, $3ed113924ee47013$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $3ed113924ee47013$export$35800275c0037383 = (...args)=>{
    const app = $3ed113924ee47013$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $3ed113924ee47013$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $3ed113924ee47013$var$resolveRootNamespace(container));
    };
    return app;
};
function $3ed113924ee47013$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $3ed113924ee47013$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $a5gC8.isHTMLTag)(tag) || (0, $a5gC8.isSVGTag)(tag) || (0, $a5gC8.isMathMLTag)(tag),
        writable: false
    });
}
function $3ed113924ee47013$var$injectCompilerOptionsCheck(app) {
    if ((0, $4mYx6.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $4mYx6.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $4mYx6.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $4mYx6.warn)(msg);
            }
        });
    }
}
function $3ed113924ee47013$var$normalizeContainer(container) {
    if ((0, $a5gC8.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $3ed113924ee47013$var$ssrDirectiveInitialized = false;
const $3ed113924ee47013$export$800b28255aa678d9 = ()=>{
    if (!$3ed113924ee47013$var$ssrDirectiveInitialized) {
        $3ed113924ee47013$var$ssrDirectiveInitialized = true;
        $3ed113924ee47013$var$initVModelForSSR();
        $3ed113924ee47013$var$initVShowForSSR();
    }
};

});

parcelRegister("dFjgj", function(module, exports) {

$parcel$export(module.exports, "compile", () => $9f2e0bc3f9800aaa$export$ef7acd7185315e22);
/**
* @vue/compiler-dom v3.5.12
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $RK9so = parcelRequire("RK9so");

var $a5gC8 = parcelRequire("a5gC8");
const $9f2e0bc3f9800aaa$export$840cf4d687fa64bf = Symbol(``);
const $9f2e0bc3f9800aaa$export$228d0b64761291c1 = Symbol(``);
const $9f2e0bc3f9800aaa$export$9f97e65b6f78b584 = Symbol(``);
const $9f2e0bc3f9800aaa$export$19eac69b46d09cfc = Symbol(``);
const $9f2e0bc3f9800aaa$export$334590174a9e57a1 = Symbol(``);
const $9f2e0bc3f9800aaa$export$5c621dc1b9e655a = Symbol(``);
const $9f2e0bc3f9800aaa$export$94febfb27c95c3cd = Symbol(``);
const $9f2e0bc3f9800aaa$export$be7d85494bd6f37b = Symbol(``);
const $9f2e0bc3f9800aaa$export$f2127cf693ff3edc = Symbol(``);
const $9f2e0bc3f9800aaa$export$bb9790ed494aa172 = Symbol(``);
(0, $RK9so.registerRuntimeHelpers)({
    [$9f2e0bc3f9800aaa$export$840cf4d687fa64bf]: `vModelRadio`,
    [$9f2e0bc3f9800aaa$export$228d0b64761291c1]: `vModelCheckbox`,
    [$9f2e0bc3f9800aaa$export$9f97e65b6f78b584]: `vModelText`,
    [$9f2e0bc3f9800aaa$export$19eac69b46d09cfc]: `vModelSelect`,
    [$9f2e0bc3f9800aaa$export$334590174a9e57a1]: `vModelDynamic`,
    [$9f2e0bc3f9800aaa$export$5c621dc1b9e655a]: `withModifiers`,
    [$9f2e0bc3f9800aaa$export$94febfb27c95c3cd]: `withKeys`,
    [$9f2e0bc3f9800aaa$export$be7d85494bd6f37b]: `vShow`,
    [$9f2e0bc3f9800aaa$export$f2127cf693ff3edc]: `Transition`,
    [$9f2e0bc3f9800aaa$export$bb9790ed494aa172]: `TransitionGroup`
});
let $9f2e0bc3f9800aaa$var$decoder;
function $9f2e0bc3f9800aaa$var$decodeHtmlBrowser(raw, asAttr = false) {
    if (!$9f2e0bc3f9800aaa$var$decoder) $9f2e0bc3f9800aaa$var$decoder = document.createElement("div");
    if (asAttr) {
        $9f2e0bc3f9800aaa$var$decoder.innerHTML = `<div foo="${raw.replace(/"/g, "&quot;")}">`;
        return $9f2e0bc3f9800aaa$var$decoder.children[0].getAttribute("foo");
    } else {
        $9f2e0bc3f9800aaa$var$decoder.innerHTML = raw;
        return $9f2e0bc3f9800aaa$var$decoder.textContent;
    }
}
const $9f2e0bc3f9800aaa$export$f3377f1c03a3aebd = {
    parseMode: "html",
    isVoidTag: $a5gC8.isVoidTag,
    isNativeTag: (tag)=>(0, $a5gC8.isHTMLTag)(tag) || (0, $a5gC8.isSVGTag)(tag) || (0, $a5gC8.isMathMLTag)(tag),
    isPreTag: (tag)=>tag === "pre",
    isIgnoreNewlineTag: (tag)=>tag === "pre" || tag === "textarea",
    decodeEntities: $9f2e0bc3f9800aaa$var$decodeHtmlBrowser,
    isBuiltInComponent: (tag)=>{
        if (tag === "Transition" || tag === "transition") return $9f2e0bc3f9800aaa$export$f2127cf693ff3edc;
        else if (tag === "TransitionGroup" || tag === "transition-group") return $9f2e0bc3f9800aaa$export$bb9790ed494aa172;
    },
    // https://html.spec.whatwg.org/multipage/parsing.html#tree-construction-dispatcher
    getNamespace (tag, parent, rootNamespace) {
        let ns = parent ? parent.ns : rootNamespace;
        if (parent && ns === 2) {
            if (parent.tag === "annotation-xml") {
                if (tag === "svg") return 1;
                if (parent.props.some((a)=>a.type === 6 && a.name === "encoding" && a.value != null && (a.value.content === "text/html" || a.value.content === "application/xhtml+xml"))) ns = 0;
            } else if (/^m(?:[ions]|text)$/.test(parent.tag) && tag !== "mglyph" && tag !== "malignmark") ns = 0;
        } else if (parent && ns === 1) {
            if (parent.tag === "foreignObject" || parent.tag === "desc" || parent.tag === "title") ns = 0;
        }
        if (ns === 0) {
            if (tag === "svg") return 1;
            if (tag === "math") return 2;
        }
        return ns;
    }
};
const $9f2e0bc3f9800aaa$export$8dfeb887a12dd97a = (node)=>{
    if (node.type === 1) node.props.forEach((p, i)=>{
        if (p.type === 6 && p.name === "style" && p.value) node.props[i] = {
            type: 7,
            name: `bind`,
            arg: (0, $RK9so.createSimpleExpression)(`style`, true, p.loc),
            exp: $9f2e0bc3f9800aaa$var$parseInlineCSS(p.value.content, p.loc),
            modifiers: [],
            loc: p.loc
        };
    });
};
const $9f2e0bc3f9800aaa$var$parseInlineCSS = (cssText, loc)=>{
    const normalized = (0, $a5gC8.parseStringStyle)(cssText);
    return (0, $RK9so.createSimpleExpression)(JSON.stringify(normalized), false, loc, 3);
};
function $9f2e0bc3f9800aaa$export$c2fa14fc707a7d94(code, loc) {
    return (0, $RK9so.createCompilerError)(code, loc, void 0);
}
const $9f2e0bc3f9800aaa$export$3f0f75fff33734b3 = {
    "X_V_HTML_NO_EXPRESSION": 53,
    "53": "X_V_HTML_NO_EXPRESSION",
    "X_V_HTML_WITH_CHILDREN": 54,
    "54": "X_V_HTML_WITH_CHILDREN",
    "X_V_TEXT_NO_EXPRESSION": 55,
    "55": "X_V_TEXT_NO_EXPRESSION",
    "X_V_TEXT_WITH_CHILDREN": 56,
    "56": "X_V_TEXT_WITH_CHILDREN",
    "X_V_MODEL_ON_INVALID_ELEMENT": 57,
    "57": "X_V_MODEL_ON_INVALID_ELEMENT",
    "X_V_MODEL_ARG_ON_ELEMENT": 58,
    "58": "X_V_MODEL_ARG_ON_ELEMENT",
    "X_V_MODEL_ON_FILE_INPUT_ELEMENT": 59,
    "59": "X_V_MODEL_ON_FILE_INPUT_ELEMENT",
    "X_V_MODEL_UNNECESSARY_VALUE": 60,
    "60": "X_V_MODEL_UNNECESSARY_VALUE",
    "X_V_SHOW_NO_EXPRESSION": 61,
    "61": "X_V_SHOW_NO_EXPRESSION",
    "X_TRANSITION_INVALID_CHILDREN": 62,
    "62": "X_TRANSITION_INVALID_CHILDREN",
    "X_IGNORED_SIDE_EFFECT_TAG": 63,
    "63": "X_IGNORED_SIDE_EFFECT_TAG",
    "__EXTEND_POINT__": 64,
    "64": "__EXTEND_POINT__"
};
const $9f2e0bc3f9800aaa$export$b1db1c803eda55f9 = {
    [53]: `v-html is missing expression.`,
    [54]: `v-html will override element children.`,
    [55]: `v-text is missing expression.`,
    [56]: `v-text will override element children.`,
    [57]: `v-model can only be used on <input>, <textarea> and <select> elements.`,
    [58]: `v-model argument is not supported on plain elements.`,
    [59]: `v-model cannot be used on file inputs since they are read-only. Use a v-on:change listener instead.`,
    [60]: `Unnecessary value binding used alongside v-model. It will interfere with v-model's behavior.`,
    [61]: `v-show is missing expression.`,
    [62]: `<Transition> expects exactly one child element or component.`,
    [63]: `Tags with side effect (<script> and <style>) are ignored in client component templates.`
};
const $9f2e0bc3f9800aaa$var$transformVHtml = (dir, node, context)=>{
    const { exp: exp, loc: loc } = dir;
    if (!exp) context.onError($9f2e0bc3f9800aaa$export$c2fa14fc707a7d94(53, loc));
    if (node.children.length) {
        context.onError($9f2e0bc3f9800aaa$export$c2fa14fc707a7d94(54, loc));
        node.children.length = 0;
    }
    return {
        props: [
            (0, $RK9so.createObjectProperty)((0, $RK9so.createSimpleExpression)(`innerHTML`, true, loc), exp || (0, $RK9so.createSimpleExpression)("", true))
        ]
    };
};
const $9f2e0bc3f9800aaa$var$transformVText = (dir, node, context)=>{
    const { exp: exp, loc: loc } = dir;
    if (!exp) context.onError($9f2e0bc3f9800aaa$export$c2fa14fc707a7d94(55, loc));
    if (node.children.length) {
        context.onError($9f2e0bc3f9800aaa$export$c2fa14fc707a7d94(56, loc));
        node.children.length = 0;
    }
    return {
        props: [
            (0, $RK9so.createObjectProperty)((0, $RK9so.createSimpleExpression)(`textContent`, true), exp ? (0, $RK9so.getConstantType)(exp, context) > 0 ? exp : (0, $RK9so.createCallExpression)(context.helperString((0, $RK9so.TO_DISPLAY_STRING)), [
                exp
            ], loc) : (0, $RK9so.createSimpleExpression)("", true))
        ]
    };
};
const $9f2e0bc3f9800aaa$var$transformModel = (dir, node, context)=>{
    const baseResult = (0, $RK9so.transformModel)(dir, node, context);
    if (!baseResult.props.length || node.tagType === 1) return baseResult;
    if (dir.arg) context.onError($9f2e0bc3f9800aaa$export$c2fa14fc707a7d94(58, dir.arg.loc));
    function checkDuplicatedValue() {
        const value = (0, $RK9so.findDir)(node, "bind");
        if (value && (0, $RK9so.isStaticArgOf)(value.arg, "value")) context.onError($9f2e0bc3f9800aaa$export$c2fa14fc707a7d94(60, value.loc));
    }
    const { tag: tag } = node;
    const isCustomElement = context.isCustomElement(tag);
    if (tag === "input" || tag === "textarea" || tag === "select" || isCustomElement) {
        let directiveToUse = $9f2e0bc3f9800aaa$export$9f97e65b6f78b584;
        let isInvalidType = false;
        if (tag === "input" || isCustomElement) {
            const type = (0, $RK9so.findProp)(node, `type`);
            if (type) {
                if (type.type === 7) directiveToUse = $9f2e0bc3f9800aaa$export$334590174a9e57a1;
                else if (type.value) switch(type.value.content){
                    case "radio":
                        directiveToUse = $9f2e0bc3f9800aaa$export$840cf4d687fa64bf;
                        break;
                    case "checkbox":
                        directiveToUse = $9f2e0bc3f9800aaa$export$228d0b64761291c1;
                        break;
                    case "file":
                        isInvalidType = true;
                        context.onError($9f2e0bc3f9800aaa$export$c2fa14fc707a7d94(59, dir.loc));
                        break;
                    default:
                        break;
                }
            } else if ((0, $RK9so.hasDynamicKeyVBind)(node)) directiveToUse = $9f2e0bc3f9800aaa$export$334590174a9e57a1;
        } else if (tag === "select") directiveToUse = $9f2e0bc3f9800aaa$export$19eac69b46d09cfc;
        if (!isInvalidType) baseResult.needRuntime = context.helper(directiveToUse);
    } else context.onError($9f2e0bc3f9800aaa$export$c2fa14fc707a7d94(57, dir.loc));
    baseResult.props = baseResult.props.filter((p)=>!(p.key.type === 4 && p.key.content === "modelValue"));
    return baseResult;
};
const $9f2e0bc3f9800aaa$var$isEventOptionModifier = /* @__PURE__ */ (0, $a5gC8.makeMap)(`passive,once,capture`);
const $9f2e0bc3f9800aaa$var$isNonKeyModifier = /* @__PURE__ */ (0, $a5gC8.makeMap)(// event propagation management
`stop,prevent,self,ctrl,shift,alt,meta,exact,middle`);
const $9f2e0bc3f9800aaa$var$maybeKeyModifier = /* @__PURE__ */ (0, $a5gC8.makeMap)("left,right");
const $9f2e0bc3f9800aaa$var$isKeyboardEvent = /* @__PURE__ */ (0, $a5gC8.makeMap)(`onkeyup,onkeydown,onkeypress`);
const $9f2e0bc3f9800aaa$var$resolveModifiers = (key, modifiers, context, loc)=>{
    const keyModifiers = [];
    const nonKeyModifiers = [];
    const eventOptionModifiers = [];
    for(let i = 0; i < modifiers.length; i++){
        const modifier = modifiers[i].content;
        if (modifier === "native" && (0, $RK9so.checkCompatEnabled)("COMPILER_V_ON_NATIVE", context, loc)) eventOptionModifiers.push(modifier);
        else if ($9f2e0bc3f9800aaa$var$isEventOptionModifier(modifier)) eventOptionModifiers.push(modifier);
        else {
            if ($9f2e0bc3f9800aaa$var$maybeKeyModifier(modifier)) {
                if ((0, $RK9so.isStaticExp)(key)) {
                    if ($9f2e0bc3f9800aaa$var$isKeyboardEvent(key.content.toLowerCase())) keyModifiers.push(modifier);
                    else nonKeyModifiers.push(modifier);
                } else {
                    keyModifiers.push(modifier);
                    nonKeyModifiers.push(modifier);
                }
            } else if ($9f2e0bc3f9800aaa$var$isNonKeyModifier(modifier)) nonKeyModifiers.push(modifier);
            else keyModifiers.push(modifier);
        }
    }
    return {
        keyModifiers: keyModifiers,
        nonKeyModifiers: nonKeyModifiers,
        eventOptionModifiers: eventOptionModifiers
    };
};
const $9f2e0bc3f9800aaa$var$transformClick = (key, event)=>{
    const isStaticClick = (0, $RK9so.isStaticExp)(key) && key.content.toLowerCase() === "onclick";
    return isStaticClick ? (0, $RK9so.createSimpleExpression)(event, true) : key.type !== 4 ? (0, $RK9so.createCompoundExpression)([
        `(`,
        key,
        `) === "onClick" ? "${event}" : (`,
        key,
        `)`
    ]) : key;
};
const $9f2e0bc3f9800aaa$var$transformOn = (dir, node, context)=>{
    return (0, $RK9so.transformOn)(dir, node, context, (baseResult)=>{
        const { modifiers: modifiers } = dir;
        if (!modifiers.length) return baseResult;
        let { key: key, value: handlerExp } = baseResult.props[0];
        const { keyModifiers: keyModifiers, nonKeyModifiers: nonKeyModifiers, eventOptionModifiers: eventOptionModifiers } = $9f2e0bc3f9800aaa$var$resolveModifiers(key, modifiers, context, dir.loc);
        if (nonKeyModifiers.includes("right")) key = $9f2e0bc3f9800aaa$var$transformClick(key, `onContextmenu`);
        if (nonKeyModifiers.includes("middle")) key = $9f2e0bc3f9800aaa$var$transformClick(key, `onMouseup`);
        if (nonKeyModifiers.length) handlerExp = (0, $RK9so.createCallExpression)(context.helper($9f2e0bc3f9800aaa$export$5c621dc1b9e655a), [
            handlerExp,
            JSON.stringify(nonKeyModifiers)
        ]);
        if (keyModifiers.length && // if event name is dynamic, always wrap with keys guard
        (!(0, $RK9so.isStaticExp)(key) || $9f2e0bc3f9800aaa$var$isKeyboardEvent(key.content.toLowerCase()))) handlerExp = (0, $RK9so.createCallExpression)(context.helper($9f2e0bc3f9800aaa$export$94febfb27c95c3cd), [
            handlerExp,
            JSON.stringify(keyModifiers)
        ]);
        if (eventOptionModifiers.length) {
            const modifierPostfix = eventOptionModifiers.map((0, $a5gC8.capitalize)).join("");
            key = (0, $RK9so.isStaticExp)(key) ? (0, $RK9so.createSimpleExpression)(`${key.content}${modifierPostfix}`, true) : (0, $RK9so.createCompoundExpression)([
                `(`,
                key,
                `) + "${modifierPostfix}"`
            ]);
        }
        return {
            props: [
                (0, $RK9so.createObjectProperty)(key, handlerExp)
            ]
        };
    });
};
const $9f2e0bc3f9800aaa$var$transformShow = (dir, node, context)=>{
    const { exp: exp, loc: loc } = dir;
    if (!exp) context.onError($9f2e0bc3f9800aaa$export$c2fa14fc707a7d94(61, loc));
    return {
        props: [],
        needRuntime: context.helper($9f2e0bc3f9800aaa$export$be7d85494bd6f37b)
    };
};
const $9f2e0bc3f9800aaa$var$transformTransition = (node, context)=>{
    if (node.type === 1 && node.tagType === 1) {
        const component = context.isBuiltInComponent(node.tag);
        if (component === $9f2e0bc3f9800aaa$export$f2127cf693ff3edc) return ()=>{
            if (!node.children.length) return;
            if ($9f2e0bc3f9800aaa$var$hasMultipleChildren(node)) context.onError($9f2e0bc3f9800aaa$export$c2fa14fc707a7d94(62, {
                start: node.children[0].loc.start,
                end: node.children[node.children.length - 1].loc.end,
                source: ""
            }));
            const child = node.children[0];
            if (child.type === 1) {
                for (const p of child.props)if (p.type === 7 && p.name === "show") node.props.push({
                    type: 6,
                    name: "persisted",
                    nameLoc: node.loc,
                    value: void 0,
                    loc: node.loc
                });
            }
        };
    }
};
function $9f2e0bc3f9800aaa$var$hasMultipleChildren(node) {
    const children = node.children = node.children.filter((c)=>c.type !== 3 && !(c.type === 2 && !c.content.trim()));
    const child = children[0];
    return children.length !== 1 || child.type === 11 || child.type === 9 && child.branches.some($9f2e0bc3f9800aaa$var$hasMultipleChildren);
}
const $9f2e0bc3f9800aaa$var$ignoreSideEffectTags = (node, context)=>{
    if (node.type === 1 && node.tagType === 0 && (node.tag === "script" || node.tag === "style")) context.removeNode();
};
function $9f2e0bc3f9800aaa$var$isValidHTMLNesting(parent, child) {
    if (parent in $9f2e0bc3f9800aaa$var$onlyValidChildren) return $9f2e0bc3f9800aaa$var$onlyValidChildren[parent].has(child);
    if (child in $9f2e0bc3f9800aaa$var$onlyValidParents) return $9f2e0bc3f9800aaa$var$onlyValidParents[child].has(parent);
    if (parent in $9f2e0bc3f9800aaa$var$knownInvalidChildren) {
        if ($9f2e0bc3f9800aaa$var$knownInvalidChildren[parent].has(child)) return false;
    }
    if (child in $9f2e0bc3f9800aaa$var$knownInvalidParents) {
        if ($9f2e0bc3f9800aaa$var$knownInvalidParents[child].has(parent)) return false;
    }
    return true;
}
const $9f2e0bc3f9800aaa$var$headings = /* @__PURE__ */ new Set([
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6"
]);
const $9f2e0bc3f9800aaa$var$emptySet = /* @__PURE__ */ new Set([]);
const $9f2e0bc3f9800aaa$var$onlyValidChildren = {
    head: /* @__PURE__ */ new Set([
        "base",
        "basefront",
        "bgsound",
        "link",
        "meta",
        "title",
        "noscript",
        "noframes",
        "style",
        "script",
        "template"
    ]),
    optgroup: /* @__PURE__ */ new Set([
        "option"
    ]),
    select: /* @__PURE__ */ new Set([
        "optgroup",
        "option",
        "hr"
    ]),
    // table
    table: /* @__PURE__ */ new Set([
        "caption",
        "colgroup",
        "tbody",
        "tfoot",
        "thead"
    ]),
    tr: /* @__PURE__ */ new Set([
        "td",
        "th"
    ]),
    colgroup: /* @__PURE__ */ new Set([
        "col"
    ]),
    tbody: /* @__PURE__ */ new Set([
        "tr"
    ]),
    thead: /* @__PURE__ */ new Set([
        "tr"
    ]),
    tfoot: /* @__PURE__ */ new Set([
        "tr"
    ]),
    // these elements can not have any children elements
    script: $9f2e0bc3f9800aaa$var$emptySet,
    iframe: $9f2e0bc3f9800aaa$var$emptySet,
    option: $9f2e0bc3f9800aaa$var$emptySet,
    textarea: $9f2e0bc3f9800aaa$var$emptySet,
    style: $9f2e0bc3f9800aaa$var$emptySet,
    title: $9f2e0bc3f9800aaa$var$emptySet
};
const $9f2e0bc3f9800aaa$var$onlyValidParents = {
    // sections
    html: $9f2e0bc3f9800aaa$var$emptySet,
    body: /* @__PURE__ */ new Set([
        "html"
    ]),
    head: /* @__PURE__ */ new Set([
        "html"
    ]),
    // table
    td: /* @__PURE__ */ new Set([
        "tr"
    ]),
    colgroup: /* @__PURE__ */ new Set([
        "table"
    ]),
    caption: /* @__PURE__ */ new Set([
        "table"
    ]),
    tbody: /* @__PURE__ */ new Set([
        "table"
    ]),
    tfoot: /* @__PURE__ */ new Set([
        "table"
    ]),
    col: /* @__PURE__ */ new Set([
        "colgroup"
    ]),
    th: /* @__PURE__ */ new Set([
        "tr"
    ]),
    thead: /* @__PURE__ */ new Set([
        "table"
    ]),
    tr: /* @__PURE__ */ new Set([
        "tbody",
        "thead",
        "tfoot"
    ]),
    // data list
    dd: /* @__PURE__ */ new Set([
        "dl",
        "div"
    ]),
    dt: /* @__PURE__ */ new Set([
        "dl",
        "div"
    ]),
    // other
    figcaption: /* @__PURE__ */ new Set([
        "figure"
    ]),
    // li: new Set(["ul", "ol"]),
    summary: /* @__PURE__ */ new Set([
        "details"
    ]),
    area: /* @__PURE__ */ new Set([
        "map"
    ])
};
const $9f2e0bc3f9800aaa$var$knownInvalidChildren = {
    p: /* @__PURE__ */ new Set([
        "address",
        "article",
        "aside",
        "blockquote",
        "center",
        "details",
        "dialog",
        "dir",
        "div",
        "dl",
        "fieldset",
        "figure",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "header",
        "hgroup",
        "hr",
        "li",
        "main",
        "nav",
        "menu",
        "ol",
        "p",
        "pre",
        "section",
        "table",
        "ul"
    ]),
    svg: /* @__PURE__ */ new Set([
        "b",
        "blockquote",
        "br",
        "code",
        "dd",
        "div",
        "dl",
        "dt",
        "em",
        "embed",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "hr",
        "i",
        "img",
        "li",
        "menu",
        "meta",
        "ol",
        "p",
        "pre",
        "ruby",
        "s",
        "small",
        "span",
        "strong",
        "sub",
        "sup",
        "table",
        "u",
        "ul",
        "var"
    ])
};
const $9f2e0bc3f9800aaa$var$knownInvalidParents = {
    a: /* @__PURE__ */ new Set([
        "a"
    ]),
    button: /* @__PURE__ */ new Set([
        "button"
    ]),
    dd: /* @__PURE__ */ new Set([
        "dd",
        "dt"
    ]),
    dt: /* @__PURE__ */ new Set([
        "dd",
        "dt"
    ]),
    form: /* @__PURE__ */ new Set([
        "form"
    ]),
    li: /* @__PURE__ */ new Set([
        "li"
    ]),
    h1: $9f2e0bc3f9800aaa$var$headings,
    h2: $9f2e0bc3f9800aaa$var$headings,
    h3: $9f2e0bc3f9800aaa$var$headings,
    h4: $9f2e0bc3f9800aaa$var$headings,
    h5: $9f2e0bc3f9800aaa$var$headings,
    h6: $9f2e0bc3f9800aaa$var$headings
};
const $9f2e0bc3f9800aaa$var$validateHtmlNesting = (node, context)=>{
    if (node.type === 1 && node.tagType === 0 && context.parent && context.parent.type === 1 && context.parent.tagType === 0 && !$9f2e0bc3f9800aaa$var$isValidHTMLNesting(context.parent.tag, node.tag)) {
        const error = new SyntaxError(`<${node.tag}> cannot be child of <${context.parent.tag}>, according to HTML specifications. This can cause hydration errors or potentially disrupt future functionality.`);
        error.loc = node.loc;
        context.onWarn(error);
    }
};
const $9f2e0bc3f9800aaa$export$e801dc6012e0c348 = [
    $9f2e0bc3f9800aaa$export$8dfeb887a12dd97a
];
const $9f2e0bc3f9800aaa$export$2257f60ebb1a11be = {
    cloak: (0, $RK9so.noopDirectiveTransform),
    html: $9f2e0bc3f9800aaa$var$transformVHtml,
    text: $9f2e0bc3f9800aaa$var$transformVText,
    model: $9f2e0bc3f9800aaa$var$transformModel,
    // override compiler-core
    on: $9f2e0bc3f9800aaa$var$transformOn,
    // override compiler-core
    show: $9f2e0bc3f9800aaa$var$transformShow
};
function $9f2e0bc3f9800aaa$export$ef7acd7185315e22(src, options = {}) {
    return (0, $RK9so.baseCompile)(src, (0, $a5gC8.extend)({}, $9f2e0bc3f9800aaa$export$f3377f1c03a3aebd, options, {
        nodeTransforms: [
            // ignore <script> and <tag>
            // this is not put inside DOMNodeTransforms because that list is used
            // by compiler-ssr to generate vnode fallback branches
            $9f2e0bc3f9800aaa$var$ignoreSideEffectTags,
            ...$9f2e0bc3f9800aaa$export$e801dc6012e0c348,
            ...options.nodeTransforms || []
        ],
        directiveTransforms: (0, $a5gC8.extend)({}, $9f2e0bc3f9800aaa$export$2257f60ebb1a11be, options.directiveTransforms || {}),
        transformHoist: null
    }));
}
function $9f2e0bc3f9800aaa$export$98e6a39c04603d36(template, options = {}) {
    return (0, $RK9so.baseParse)(template, (0, $a5gC8.extend)({}, $9f2e0bc3f9800aaa$export$f3377f1c03a3aebd, options));
}

});
parcelRegister("RK9so", function(module, exports) {

$parcel$export(module.exports, "TO_DISPLAY_STRING", () => $0a18c015b5873b3d$export$68f5914cce0a5680);
$parcel$export(module.exports, "registerRuntimeHelpers", () => $0a18c015b5873b3d$export$8c4e724519c87f31);
$parcel$export(module.exports, "createObjectProperty", () => $0a18c015b5873b3d$export$45231d90c148ea74);
$parcel$export(module.exports, "createSimpleExpression", () => $0a18c015b5873b3d$export$ac2aa689b44cdd23);
$parcel$export(module.exports, "createCompoundExpression", () => $0a18c015b5873b3d$export$60ad01cd5cde5e50);
$parcel$export(module.exports, "createCallExpression", () => $0a18c015b5873b3d$export$2cdf8617f9d8e39d);
$parcel$export(module.exports, "checkCompatEnabled", () => $0a18c015b5873b3d$export$1b1c14b93fcc0fe4);
$parcel$export(module.exports, "createCompilerError", () => $0a18c015b5873b3d$export$57c5a5dc5aa19bdf);
$parcel$export(module.exports, "isStaticExp", () => $0a18c015b5873b3d$export$43d387e2d68b51dc);
$parcel$export(module.exports, "findDir", () => $0a18c015b5873b3d$export$1199bc2a2b648c8c);
$parcel$export(module.exports, "findProp", () => $0a18c015b5873b3d$export$4ae65475e3513615);
$parcel$export(module.exports, "isStaticArgOf", () => $0a18c015b5873b3d$export$45cac5109adb5e55);
$parcel$export(module.exports, "hasDynamicKeyVBind", () => $0a18c015b5873b3d$export$4e1f112c75b8dafc);
$parcel$export(module.exports, "baseParse", () => $0a18c015b5873b3d$export$f5f219d5f09c81b5);
$parcel$export(module.exports, "getConstantType", () => $0a18c015b5873b3d$export$7967f5197c38d72a);
$parcel$export(module.exports, "transformOn", () => $0a18c015b5873b3d$export$ff060d152244ee7b);
$parcel$export(module.exports, "transformModel", () => $0a18c015b5873b3d$export$567db1f69abf4dcb);
$parcel$export(module.exports, "baseCompile", () => $0a18c015b5873b3d$export$3243579822c486a0);
$parcel$export(module.exports, "noopDirectiveTransform", () => $0a18c015b5873b3d$export$eb34aa2b2065da17);
/**
* @vue/compiler-core v3.5.12
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $a5gC8 = parcelRequire("a5gC8");
const $0a18c015b5873b3d$export$4bebefc40c8513e8 = Symbol(``);
const $0a18c015b5873b3d$export$e74e82bc14ac4f98 = Symbol(``);
const $0a18c015b5873b3d$export$2237d737f4a10705 = Symbol(``);
const $0a18c015b5873b3d$export$e9ff5bb5c39478ed = Symbol(``);
const $0a18c015b5873b3d$export$b357ae9fe0a3685a = Symbol(``);
const $0a18c015b5873b3d$export$59578e14f90a15eb = Symbol(``);
const $0a18c015b5873b3d$export$37ddf5a12480514c = Symbol(``);
const $0a18c015b5873b3d$export$f87906340c78a650 = Symbol(``);
const $0a18c015b5873b3d$export$6db5bf2474139178 = Symbol(``);
const $0a18c015b5873b3d$export$b22e7e78da20c982 = Symbol(``);
const $0a18c015b5873b3d$export$b2aae42fb0a19db3 = Symbol(``);
const $0a18c015b5873b3d$export$8890896270dfc293 = Symbol(``);
const $0a18c015b5873b3d$export$1a493e4b98fdcf3 = Symbol(``);
const $0a18c015b5873b3d$export$28c52e95383d270 = Symbol(``);
const $0a18c015b5873b3d$export$582a2287b73d3265 = Symbol(``);
const $0a18c015b5873b3d$export$7f3ccc2ef793ecce = Symbol(``);
const $0a18c015b5873b3d$export$2c190751e09c3969 = Symbol(``);
const $0a18c015b5873b3d$export$a5e4c1729e50ed6d = Symbol(``);
const $0a18c015b5873b3d$export$3da0e5cd78c1870 = Symbol(``);
const $0a18c015b5873b3d$export$a91e32c6b04aa348 = Symbol(``);
const $0a18c015b5873b3d$export$6a6b6a5c860c238d = Symbol(``);
const $0a18c015b5873b3d$export$68f5914cce0a5680 = Symbol(``);
const $0a18c015b5873b3d$export$825e32c0f842262a = Symbol(``);
const $0a18c015b5873b3d$export$6382e3ed89de4e2a = Symbol(``);
const $0a18c015b5873b3d$export$b9d3780a9ab822b4 = Symbol(``);
const $0a18c015b5873b3d$export$78c34c869683dd86 = Symbol(``);
const $0a18c015b5873b3d$export$7046bb8d3c918928 = Symbol(``);
const $0a18c015b5873b3d$export$4bdbf33367525856 = Symbol(``);
const $0a18c015b5873b3d$export$3ebbf6981763e181 = Symbol(``);
const $0a18c015b5873b3d$export$e3e7f5f6c22384b5 = Symbol(``);
const $0a18c015b5873b3d$export$8687eaac3cd39ddd = Symbol(``);
const $0a18c015b5873b3d$export$37cf1f9ab937c10d = Symbol(``);
const $0a18c015b5873b3d$export$d8e039410dcfa57d = Symbol(``);
const $0a18c015b5873b3d$export$4266498fbffc3354 = Symbol(``);
const $0a18c015b5873b3d$export$141e17a2b5200090 = Symbol(``);
const $0a18c015b5873b3d$export$e0f3ad8c273cc513 = Symbol(``);
const $0a18c015b5873b3d$export$cf2c1c7bc34dc87e = Symbol(``);
const $0a18c015b5873b3d$export$a0fd71f0f7cd2781 = Symbol(``);
const $0a18c015b5873b3d$export$ae18cf0dc81df35a = Symbol(``);
const $0a18c015b5873b3d$export$7dc1fc5a07bc9b35 = {
    [$0a18c015b5873b3d$export$4bebefc40c8513e8]: `Fragment`,
    [$0a18c015b5873b3d$export$e74e82bc14ac4f98]: `Teleport`,
    [$0a18c015b5873b3d$export$2237d737f4a10705]: `Suspense`,
    [$0a18c015b5873b3d$export$e9ff5bb5c39478ed]: `KeepAlive`,
    [$0a18c015b5873b3d$export$b357ae9fe0a3685a]: `BaseTransition`,
    [$0a18c015b5873b3d$export$59578e14f90a15eb]: `openBlock`,
    [$0a18c015b5873b3d$export$37ddf5a12480514c]: `createBlock`,
    [$0a18c015b5873b3d$export$f87906340c78a650]: `createElementBlock`,
    [$0a18c015b5873b3d$export$6db5bf2474139178]: `createVNode`,
    [$0a18c015b5873b3d$export$b22e7e78da20c982]: `createElementVNode`,
    [$0a18c015b5873b3d$export$b2aae42fb0a19db3]: `createCommentVNode`,
    [$0a18c015b5873b3d$export$8890896270dfc293]: `createTextVNode`,
    [$0a18c015b5873b3d$export$1a493e4b98fdcf3]: `createStaticVNode`,
    [$0a18c015b5873b3d$export$28c52e95383d270]: `resolveComponent`,
    [$0a18c015b5873b3d$export$582a2287b73d3265]: `resolveDynamicComponent`,
    [$0a18c015b5873b3d$export$7f3ccc2ef793ecce]: `resolveDirective`,
    [$0a18c015b5873b3d$export$2c190751e09c3969]: `resolveFilter`,
    [$0a18c015b5873b3d$export$a5e4c1729e50ed6d]: `withDirectives`,
    [$0a18c015b5873b3d$export$3da0e5cd78c1870]: `renderList`,
    [$0a18c015b5873b3d$export$a91e32c6b04aa348]: `renderSlot`,
    [$0a18c015b5873b3d$export$6a6b6a5c860c238d]: `createSlots`,
    [$0a18c015b5873b3d$export$68f5914cce0a5680]: `toDisplayString`,
    [$0a18c015b5873b3d$export$825e32c0f842262a]: `mergeProps`,
    [$0a18c015b5873b3d$export$6382e3ed89de4e2a]: `normalizeClass`,
    [$0a18c015b5873b3d$export$b9d3780a9ab822b4]: `normalizeStyle`,
    [$0a18c015b5873b3d$export$78c34c869683dd86]: `normalizeProps`,
    [$0a18c015b5873b3d$export$7046bb8d3c918928]: `guardReactiveProps`,
    [$0a18c015b5873b3d$export$4bdbf33367525856]: `toHandlers`,
    [$0a18c015b5873b3d$export$3ebbf6981763e181]: `camelize`,
    [$0a18c015b5873b3d$export$e3e7f5f6c22384b5]: `capitalize`,
    [$0a18c015b5873b3d$export$8687eaac3cd39ddd]: `toHandlerKey`,
    [$0a18c015b5873b3d$export$37cf1f9ab937c10d]: `setBlockTracking`,
    [$0a18c015b5873b3d$export$d8e039410dcfa57d]: `pushScopeId`,
    [$0a18c015b5873b3d$export$4266498fbffc3354]: `popScopeId`,
    [$0a18c015b5873b3d$export$141e17a2b5200090]: `withCtx`,
    [$0a18c015b5873b3d$export$e0f3ad8c273cc513]: `unref`,
    [$0a18c015b5873b3d$export$cf2c1c7bc34dc87e]: `isRef`,
    [$0a18c015b5873b3d$export$a0fd71f0f7cd2781]: `withMemo`,
    [$0a18c015b5873b3d$export$ae18cf0dc81df35a]: `isMemoSame`
};
function $0a18c015b5873b3d$export$8c4e724519c87f31(helpers) {
    Object.getOwnPropertySymbols(helpers).forEach((s)=>{
        $0a18c015b5873b3d$export$7dc1fc5a07bc9b35[s] = helpers[s];
    });
}
const $0a18c015b5873b3d$export$2f21297dc8e7cb72 = {
    "HTML": 0,
    "0": "HTML",
    "SVG": 1,
    "1": "SVG",
    "MATH_ML": 2,
    "2": "MATH_ML"
};
const $0a18c015b5873b3d$export$2ed9472effad1b70 = {
    "ROOT": 0,
    "0": "ROOT",
    "ELEMENT": 1,
    "1": "ELEMENT",
    "TEXT": 2,
    "2": "TEXT",
    "COMMENT": 3,
    "3": "COMMENT",
    "SIMPLE_EXPRESSION": 4,
    "4": "SIMPLE_EXPRESSION",
    "INTERPOLATION": 5,
    "5": "INTERPOLATION",
    "ATTRIBUTE": 6,
    "6": "ATTRIBUTE",
    "DIRECTIVE": 7,
    "7": "DIRECTIVE",
    "COMPOUND_EXPRESSION": 8,
    "8": "COMPOUND_EXPRESSION",
    "IF": 9,
    "9": "IF",
    "IF_BRANCH": 10,
    "10": "IF_BRANCH",
    "FOR": 11,
    "11": "FOR",
    "TEXT_CALL": 12,
    "12": "TEXT_CALL",
    "VNODE_CALL": 13,
    "13": "VNODE_CALL",
    "JS_CALL_EXPRESSION": 14,
    "14": "JS_CALL_EXPRESSION",
    "JS_OBJECT_EXPRESSION": 15,
    "15": "JS_OBJECT_EXPRESSION",
    "JS_PROPERTY": 16,
    "16": "JS_PROPERTY",
    "JS_ARRAY_EXPRESSION": 17,
    "17": "JS_ARRAY_EXPRESSION",
    "JS_FUNCTION_EXPRESSION": 18,
    "18": "JS_FUNCTION_EXPRESSION",
    "JS_CONDITIONAL_EXPRESSION": 19,
    "19": "JS_CONDITIONAL_EXPRESSION",
    "JS_CACHE_EXPRESSION": 20,
    "20": "JS_CACHE_EXPRESSION",
    "JS_BLOCK_STATEMENT": 21,
    "21": "JS_BLOCK_STATEMENT",
    "JS_TEMPLATE_LITERAL": 22,
    "22": "JS_TEMPLATE_LITERAL",
    "JS_IF_STATEMENT": 23,
    "23": "JS_IF_STATEMENT",
    "JS_ASSIGNMENT_EXPRESSION": 24,
    "24": "JS_ASSIGNMENT_EXPRESSION",
    "JS_SEQUENCE_EXPRESSION": 25,
    "25": "JS_SEQUENCE_EXPRESSION",
    "JS_RETURN_STATEMENT": 26,
    "26": "JS_RETURN_STATEMENT"
};
const $0a18c015b5873b3d$export$6d501ccfb21c5e10 = {
    "ELEMENT": 0,
    "0": "ELEMENT",
    "COMPONENT": 1,
    "1": "COMPONENT",
    "SLOT": 2,
    "2": "SLOT",
    "TEMPLATE": 3,
    "3": "TEMPLATE"
};
const $0a18c015b5873b3d$export$537bd56c9a924c51 = {
    "NOT_CONSTANT": 0,
    "0": "NOT_CONSTANT",
    "CAN_SKIP_PATCH": 1,
    "1": "CAN_SKIP_PATCH",
    "CAN_CACHE": 2,
    "2": "CAN_CACHE",
    "CAN_STRINGIFY": 3,
    "3": "CAN_STRINGIFY"
};
const $0a18c015b5873b3d$export$6c4f24c93c3e8659 = {
    start: {
        line: 1,
        column: 1,
        offset: 0
    },
    end: {
        line: 1,
        column: 1,
        offset: 0
    },
    source: ""
};
function $0a18c015b5873b3d$export$882461b6382ed46c(children, source = "") {
    return {
        type: 0,
        source: source,
        children: children,
        helpers: /* @__PURE__ */ new Set(),
        components: [],
        directives: [],
        hoists: [],
        imports: [],
        cached: [],
        temps: 0,
        codegenNode: void 0,
        loc: $0a18c015b5873b3d$export$6c4f24c93c3e8659
    };
}
function $0a18c015b5873b3d$export$d1cb722ac2a8b632(context, tag, props, children, patchFlag, dynamicProps, directives, isBlock = false, disableTracking = false, isComponent = false, loc = $0a18c015b5873b3d$export$6c4f24c93c3e8659) {
    if (context) {
        if (isBlock) {
            context.helper($0a18c015b5873b3d$export$59578e14f90a15eb);
            context.helper($0a18c015b5873b3d$export$74fb204a6eba800d(context.inSSR, isComponent));
        } else context.helper($0a18c015b5873b3d$export$3b9fc44425f495a6(context.inSSR, isComponent));
        if (directives) context.helper($0a18c015b5873b3d$export$a5e4c1729e50ed6d);
    }
    return {
        type: 13,
        tag: tag,
        props: props,
        children: children,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        directives: directives,
        isBlock: isBlock,
        disableTracking: disableTracking,
        isComponent: isComponent,
        loc: loc
    };
}
function $0a18c015b5873b3d$export$c887713da9895dbb(elements, loc = $0a18c015b5873b3d$export$6c4f24c93c3e8659) {
    return {
        type: 17,
        loc: loc,
        elements: elements
    };
}
function $0a18c015b5873b3d$export$ccb2e514379853a7(properties, loc = $0a18c015b5873b3d$export$6c4f24c93c3e8659) {
    return {
        type: 15,
        loc: loc,
        properties: properties
    };
}
function $0a18c015b5873b3d$export$45231d90c148ea74(key, value) {
    return {
        type: 16,
        loc: $0a18c015b5873b3d$export$6c4f24c93c3e8659,
        key: (0, $a5gC8.isString)(key) ? $0a18c015b5873b3d$export$ac2aa689b44cdd23(key, true) : key,
        value: value
    };
}
function $0a18c015b5873b3d$export$ac2aa689b44cdd23(content, isStatic = false, loc = $0a18c015b5873b3d$export$6c4f24c93c3e8659, constType = 0) {
    return {
        type: 4,
        loc: loc,
        content: content,
        isStatic: isStatic,
        constType: isStatic ? 3 : constType
    };
}
function $0a18c015b5873b3d$export$96ca1dcf947302d0(content, loc) {
    return {
        type: 5,
        loc: loc,
        content: (0, $a5gC8.isString)(content) ? $0a18c015b5873b3d$export$ac2aa689b44cdd23(content, false, loc) : content
    };
}
function $0a18c015b5873b3d$export$60ad01cd5cde5e50(children, loc = $0a18c015b5873b3d$export$6c4f24c93c3e8659) {
    return {
        type: 8,
        loc: loc,
        children: children
    };
}
function $0a18c015b5873b3d$export$2cdf8617f9d8e39d(callee, args = [], loc = $0a18c015b5873b3d$export$6c4f24c93c3e8659) {
    return {
        type: 14,
        loc: loc,
        callee: callee,
        arguments: args
    };
}
function $0a18c015b5873b3d$export$253e05bfd5b6c4c6(params, returns, newline = false, isSlot = false, loc = $0a18c015b5873b3d$export$6c4f24c93c3e8659) {
    return {
        type: 18,
        params: params,
        returns: returns,
        newline: newline,
        isSlot: isSlot,
        loc: loc
    };
}
function $0a18c015b5873b3d$export$374e02fb5bd90a4e(test, consequent, alternate, newline = true) {
    return {
        type: 19,
        test: test,
        consequent: consequent,
        alternate: alternate,
        newline: newline,
        loc: $0a18c015b5873b3d$export$6c4f24c93c3e8659
    };
}
function $0a18c015b5873b3d$export$4abd162ddf919697(index, value, needPauseTracking = false) {
    return {
        type: 20,
        index: index,
        value: value,
        needPauseTracking: needPauseTracking,
        needArraySpread: false,
        loc: $0a18c015b5873b3d$export$6c4f24c93c3e8659
    };
}
function $0a18c015b5873b3d$export$c3ad9e28586f1d07(body) {
    return {
        type: 21,
        body: body,
        loc: $0a18c015b5873b3d$export$6c4f24c93c3e8659
    };
}
function $0a18c015b5873b3d$export$242433d85418a087(elements) {
    return {
        type: 22,
        elements: elements,
        loc: $0a18c015b5873b3d$export$6c4f24c93c3e8659
    };
}
function $0a18c015b5873b3d$export$71ff4dcc047b6a4e(test, consequent, alternate) {
    return {
        type: 23,
        test: test,
        consequent: consequent,
        alternate: alternate,
        loc: $0a18c015b5873b3d$export$6c4f24c93c3e8659
    };
}
function $0a18c015b5873b3d$export$f6cfc415b0df5d79(left, right) {
    return {
        type: 24,
        left: left,
        right: right,
        loc: $0a18c015b5873b3d$export$6c4f24c93c3e8659
    };
}
function $0a18c015b5873b3d$export$42d3d4c35b19948b(expressions) {
    return {
        type: 25,
        expressions: expressions,
        loc: $0a18c015b5873b3d$export$6c4f24c93c3e8659
    };
}
function $0a18c015b5873b3d$export$746323a443188826(returns) {
    return {
        type: 26,
        returns: returns,
        loc: $0a18c015b5873b3d$export$6c4f24c93c3e8659
    };
}
function $0a18c015b5873b3d$export$3b9fc44425f495a6(ssr, isComponent) {
    return ssr || isComponent ? $0a18c015b5873b3d$export$6db5bf2474139178 : $0a18c015b5873b3d$export$b22e7e78da20c982;
}
function $0a18c015b5873b3d$export$74fb204a6eba800d(ssr, isComponent) {
    return ssr || isComponent ? $0a18c015b5873b3d$export$37ddf5a12480514c : $0a18c015b5873b3d$export$f87906340c78a650;
}
function $0a18c015b5873b3d$export$dc00c05f515bd739(node, { helper: helper, removeHelper: removeHelper, inSSR: inSSR }) {
    if (!node.isBlock) {
        node.isBlock = true;
        removeHelper($0a18c015b5873b3d$export$3b9fc44425f495a6(inSSR, node.isComponent));
        helper($0a18c015b5873b3d$export$59578e14f90a15eb);
        helper($0a18c015b5873b3d$export$74fb204a6eba800d(inSSR, node.isComponent));
    }
}
const $0a18c015b5873b3d$var$defaultDelimitersOpen = new Uint8Array([
    123,
    123
]);
const $0a18c015b5873b3d$var$defaultDelimitersClose = new Uint8Array([
    125,
    125
]);
function $0a18c015b5873b3d$var$isTagStartChar(c) {
    return c >= 97 && c <= 122 || c >= 65 && c <= 90;
}
function $0a18c015b5873b3d$var$isWhitespace(c) {
    return c === 32 || c === 10 || c === 9 || c === 12 || c === 13;
}
function $0a18c015b5873b3d$var$isEndOfTagSection(c) {
    return c === 47 || c === 62 || $0a18c015b5873b3d$var$isWhitespace(c);
}
function $0a18c015b5873b3d$var$toCharCodes(str) {
    const ret = new Uint8Array(str.length);
    for(let i = 0; i < str.length; i++)ret[i] = str.charCodeAt(i);
    return ret;
}
const $0a18c015b5873b3d$var$Sequences = {
    Cdata: new Uint8Array([
        67,
        68,
        65,
        84,
        65,
        91
    ]),
    // CDATA[
    CdataEnd: new Uint8Array([
        93,
        93,
        62
    ]),
    // ]]>
    CommentEnd: new Uint8Array([
        45,
        45,
        62
    ]),
    // `-->`
    ScriptEnd: new Uint8Array([
        60,
        47,
        115,
        99,
        114,
        105,
        112,
        116
    ]),
    // `<\/script`
    StyleEnd: new Uint8Array([
        60,
        47,
        115,
        116,
        121,
        108,
        101
    ]),
    // `</style`
    TitleEnd: new Uint8Array([
        60,
        47,
        116,
        105,
        116,
        108,
        101
    ]),
    // `</title`
    TextareaEnd: new Uint8Array([
        60,
        47,
        116,
        101,
        120,
        116,
        97,
        114,
        101,
        97
    ])
};
class $0a18c015b5873b3d$var$Tokenizer {
    constructor(stack, cbs){
        this.stack = stack;
        this.cbs = cbs;
        /** The current state the tokenizer is in. */ this.state = 1;
        /** The read buffer. */ this.buffer = "";
        /** The beginning of the section that is currently being read. */ this.sectionStart = 0;
        /** The index within the buffer that we are currently looking at. */ this.index = 0;
        /** The start of the last entity. */ this.entityStart = 0;
        /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */ this.baseState = 1;
        /** For special parsing behavior inside of script and style tags. */ this.inRCDATA = false;
        /** For disabling RCDATA tags handling */ this.inXML = false;
        /** For disabling interpolation parsing in v-pre */ this.inVPre = false;
        /** Record newline positions for fast line / column calculation */ this.newlines = [];
        this.mode = 0;
        this.delimiterOpen = $0a18c015b5873b3d$var$defaultDelimitersOpen;
        this.delimiterClose = $0a18c015b5873b3d$var$defaultDelimitersClose;
        this.delimiterIndex = -1;
        this.currentSequence = void 0;
        this.sequenceIndex = 0;
    }
    get inSFCRoot() {
        return this.mode === 2 && this.stack.length === 0;
    }
    reset() {
        this.state = 1;
        this.mode = 0;
        this.buffer = "";
        this.sectionStart = 0;
        this.index = 0;
        this.baseState = 1;
        this.inRCDATA = false;
        this.currentSequence = void 0;
        this.newlines.length = 0;
        this.delimiterOpen = $0a18c015b5873b3d$var$defaultDelimitersOpen;
        this.delimiterClose = $0a18c015b5873b3d$var$defaultDelimitersClose;
    }
    /**
   * Generate Position object with line / column information using recorded
   * newline positions. We know the index is always going to be an already
   * processed index, so all the newlines up to this index should have been
   * recorded.
   */ getPos(index) {
        let line = 1;
        let column = index + 1;
        for(let i = this.newlines.length - 1; i >= 0; i--){
            const newlineIndex = this.newlines[i];
            if (index > newlineIndex) {
                line = i + 2;
                column = index - newlineIndex;
                break;
            }
        }
        return {
            column: column,
            line: line,
            offset: index
        };
    }
    peek() {
        return this.buffer.charCodeAt(this.index + 1);
    }
    stateText(c) {
        if (c === 60) {
            if (this.index > this.sectionStart) this.cbs.ontext(this.sectionStart, this.index);
            this.state = 5;
            this.sectionStart = this.index;
        } else if (!this.inVPre && c === this.delimiterOpen[0]) {
            this.state = 2;
            this.delimiterIndex = 0;
            this.stateInterpolationOpen(c);
        }
    }
    stateInterpolationOpen(c) {
        if (c === this.delimiterOpen[this.delimiterIndex]) {
            if (this.delimiterIndex === this.delimiterOpen.length - 1) {
                const start = this.index + 1 - this.delimiterOpen.length;
                if (start > this.sectionStart) this.cbs.ontext(this.sectionStart, start);
                this.state = 3;
                this.sectionStart = start;
            } else this.delimiterIndex++;
        } else if (this.inRCDATA) {
            this.state = 32;
            this.stateInRCDATA(c);
        } else {
            this.state = 1;
            this.stateText(c);
        }
    }
    stateInterpolation(c) {
        if (c === this.delimiterClose[0]) {
            this.state = 4;
            this.delimiterIndex = 0;
            this.stateInterpolationClose(c);
        }
    }
    stateInterpolationClose(c) {
        if (c === this.delimiterClose[this.delimiterIndex]) {
            if (this.delimiterIndex === this.delimiterClose.length - 1) {
                this.cbs.oninterpolation(this.sectionStart, this.index + 1);
                if (this.inRCDATA) this.state = 32;
                else this.state = 1;
                this.sectionStart = this.index + 1;
            } else this.delimiterIndex++;
        } else {
            this.state = 3;
            this.stateInterpolation(c);
        }
    }
    stateSpecialStartSequence(c) {
        const isEnd = this.sequenceIndex === this.currentSequence.length;
        const isMatch = isEnd ? // If we are at the end of the sequence, make sure the tag name has ended
        $0a18c015b5873b3d$var$isEndOfTagSection(c) : // Otherwise, do a case-insensitive comparison
        (c | 32) === this.currentSequence[this.sequenceIndex];
        if (!isMatch) this.inRCDATA = false;
        else if (!isEnd) {
            this.sequenceIndex++;
            return;
        }
        this.sequenceIndex = 0;
        this.state = 6;
        this.stateInTagName(c);
    }
    /** Look for an end tag. For <title> and <textarea>, also decode entities. */ stateInRCDATA(c) {
        if (this.sequenceIndex === this.currentSequence.length) {
            if (c === 62 || $0a18c015b5873b3d$var$isWhitespace(c)) {
                const endOfText = this.index - this.currentSequence.length;
                if (this.sectionStart < endOfText) {
                    const actualIndex = this.index;
                    this.index = endOfText;
                    this.cbs.ontext(this.sectionStart, endOfText);
                    this.index = actualIndex;
                }
                this.sectionStart = endOfText + 2;
                this.stateInClosingTagName(c);
                this.inRCDATA = false;
                return;
            }
            this.sequenceIndex = 0;
        }
        if ((c | 32) === this.currentSequence[this.sequenceIndex]) this.sequenceIndex += 1;
        else if (this.sequenceIndex === 0) {
            if (this.currentSequence === $0a18c015b5873b3d$var$Sequences.TitleEnd || this.currentSequence === $0a18c015b5873b3d$var$Sequences.TextareaEnd && !this.inSFCRoot) {
                if (!this.inVPre && c === this.delimiterOpen[0]) {
                    this.state = 2;
                    this.delimiterIndex = 0;
                    this.stateInterpolationOpen(c);
                }
            } else if (this.fastForwardTo(60)) this.sequenceIndex = 1;
        } else this.sequenceIndex = Number(c === 60);
    }
    stateCDATASequence(c) {
        if (c === $0a18c015b5873b3d$var$Sequences.Cdata[this.sequenceIndex]) {
            if (++this.sequenceIndex === $0a18c015b5873b3d$var$Sequences.Cdata.length) {
                this.state = 28;
                this.currentSequence = $0a18c015b5873b3d$var$Sequences.CdataEnd;
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
            }
        } else {
            this.sequenceIndex = 0;
            this.state = 23;
            this.stateInDeclaration(c);
        }
    }
    /**
   * When we wait for one specific character, we can speed things up
   * by skipping through the buffer until we find it.
   *
   * @returns Whether the character was found.
   */ fastForwardTo(c) {
        while(++this.index < this.buffer.length){
            const cc = this.buffer.charCodeAt(this.index);
            if (cc === 10) this.newlines.push(this.index);
            if (cc === c) return true;
        }
        this.index = this.buffer.length - 1;
        return false;
    }
    /**
   * Comments and CDATA end with `-->` and `]]>`.
   *
   * Their common qualities are:
   * - Their end sequences have a distinct character they start with.
   * - That character is then repeated, so we have to check multiple repeats.
   * - All characters but the start character of the sequence can be skipped.
   */ stateInCommentLike(c) {
        if (c === this.currentSequence[this.sequenceIndex]) {
            if (++this.sequenceIndex === this.currentSequence.length) {
                if (this.currentSequence === $0a18c015b5873b3d$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, this.index - 2);
                else this.cbs.oncomment(this.sectionStart, this.index - 2);
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
                this.state = 1;
            }
        } else if (this.sequenceIndex === 0) {
            if (this.fastForwardTo(this.currentSequence[0])) this.sequenceIndex = 1;
        } else if (c !== this.currentSequence[this.sequenceIndex - 1]) this.sequenceIndex = 0;
    }
    startSpecial(sequence, offset) {
        this.enterRCDATA(sequence, offset);
        this.state = 31;
    }
    enterRCDATA(sequence, offset) {
        this.inRCDATA = true;
        this.currentSequence = sequence;
        this.sequenceIndex = offset;
    }
    stateBeforeTagName(c) {
        if (c === 33) {
            this.state = 22;
            this.sectionStart = this.index + 1;
        } else if (c === 63) {
            this.state = 24;
            this.sectionStart = this.index + 1;
        } else if ($0a18c015b5873b3d$var$isTagStartChar(c)) {
            this.sectionStart = this.index;
            if (this.mode === 0) this.state = 6;
            else if (this.inSFCRoot) this.state = 34;
            else if (!this.inXML) {
                if (c === 116) this.state = 30;
                else this.state = c === 115 ? 29 : 6;
            } else this.state = 6;
        } else if (c === 47) this.state = 8;
        else {
            this.state = 1;
            this.stateText(c);
        }
    }
    stateInTagName(c) {
        if ($0a18c015b5873b3d$var$isEndOfTagSection(c)) this.handleTagName(c);
    }
    stateInSFCRootTagName(c) {
        if ($0a18c015b5873b3d$var$isEndOfTagSection(c)) {
            const tag = this.buffer.slice(this.sectionStart, this.index);
            if (tag !== "template") this.enterRCDATA($0a18c015b5873b3d$var$toCharCodes(`</` + tag), 0);
            this.handleTagName(c);
        }
    }
    handleTagName(c) {
        this.cbs.onopentagname(this.sectionStart, this.index);
        this.sectionStart = -1;
        this.state = 11;
        this.stateBeforeAttrName(c);
    }
    stateBeforeClosingTagName(c) {
        if ($0a18c015b5873b3d$var$isWhitespace(c)) ;
        else if (c === 62) {
            this.state = 1;
            this.sectionStart = this.index + 1;
        } else {
            this.state = $0a18c015b5873b3d$var$isTagStartChar(c) ? 9 : 27;
            this.sectionStart = this.index;
        }
    }
    stateInClosingTagName(c) {
        if (c === 62 || $0a18c015b5873b3d$var$isWhitespace(c)) {
            this.cbs.onclosetag(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = 10;
            this.stateAfterClosingTagName(c);
        }
    }
    stateAfterClosingTagName(c) {
        if (c === 62) {
            this.state = 1;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeAttrName(c) {
        if (c === 62) {
            this.cbs.onopentagend(this.index);
            if (this.inRCDATA) this.state = 32;
            else this.state = 1;
            this.sectionStart = this.index + 1;
        } else if (c === 47) this.state = 7;
        else if (c === 60 && this.peek() === 47) {
            this.cbs.onopentagend(this.index);
            this.state = 5;
            this.sectionStart = this.index;
        } else if (!$0a18c015b5873b3d$var$isWhitespace(c)) this.handleAttrStart(c);
    }
    handleAttrStart(c) {
        if (c === 118 && this.peek() === 45) {
            this.state = 13;
            this.sectionStart = this.index;
        } else if (c === 46 || c === 58 || c === 64 || c === 35) {
            this.cbs.ondirname(this.index, this.index + 1);
            this.state = 14;
            this.sectionStart = this.index + 1;
        } else {
            this.state = 12;
            this.sectionStart = this.index;
        }
    }
    stateInSelfClosingTag(c) {
        if (c === 62) {
            this.cbs.onselfclosingtag(this.index);
            this.state = 1;
            this.sectionStart = this.index + 1;
            this.inRCDATA = false;
        } else if (!$0a18c015b5873b3d$var$isWhitespace(c)) {
            this.state = 11;
            this.stateBeforeAttrName(c);
        }
    }
    stateInAttrName(c) {
        if (c === 61 || $0a18c015b5873b3d$var$isEndOfTagSection(c)) {
            this.cbs.onattribname(this.sectionStart, this.index);
            this.handleAttrNameEnd(c);
        }
    }
    stateInDirName(c) {
        if (c === 61 || $0a18c015b5873b3d$var$isEndOfTagSection(c)) {
            this.cbs.ondirname(this.sectionStart, this.index);
            this.handleAttrNameEnd(c);
        } else if (c === 58) {
            this.cbs.ondirname(this.sectionStart, this.index);
            this.state = 14;
            this.sectionStart = this.index + 1;
        } else if (c === 46) {
            this.cbs.ondirname(this.sectionStart, this.index);
            this.state = 16;
            this.sectionStart = this.index + 1;
        }
    }
    stateInDirArg(c) {
        if (c === 61 || $0a18c015b5873b3d$var$isEndOfTagSection(c)) {
            this.cbs.ondirarg(this.sectionStart, this.index);
            this.handleAttrNameEnd(c);
        } else if (c === 91) this.state = 15;
        else if (c === 46) {
            this.cbs.ondirarg(this.sectionStart, this.index);
            this.state = 16;
            this.sectionStart = this.index + 1;
        }
    }
    stateInDynamicDirArg(c) {
        if (c === 93) this.state = 14;
        else if (c === 61 || $0a18c015b5873b3d$var$isEndOfTagSection(c)) {
            this.cbs.ondirarg(this.sectionStart, this.index + 1);
            this.handleAttrNameEnd(c);
        }
    }
    stateInDirModifier(c) {
        if (c === 61 || $0a18c015b5873b3d$var$isEndOfTagSection(c)) {
            this.cbs.ondirmodifier(this.sectionStart, this.index);
            this.handleAttrNameEnd(c);
        } else if (c === 46) {
            this.cbs.ondirmodifier(this.sectionStart, this.index);
            this.sectionStart = this.index + 1;
        }
    }
    handleAttrNameEnd(c) {
        this.sectionStart = this.index;
        this.state = 17;
        this.cbs.onattribnameend(this.index);
        this.stateAfterAttrName(c);
    }
    stateAfterAttrName(c) {
        if (c === 61) this.state = 18;
        else if (c === 47 || c === 62) {
            this.cbs.onattribend(0, this.sectionStart);
            this.sectionStart = -1;
            this.state = 11;
            this.stateBeforeAttrName(c);
        } else if (!$0a18c015b5873b3d$var$isWhitespace(c)) {
            this.cbs.onattribend(0, this.sectionStart);
            this.handleAttrStart(c);
        }
    }
    stateBeforeAttrValue(c) {
        if (c === 34) {
            this.state = 19;
            this.sectionStart = this.index + 1;
        } else if (c === 39) {
            this.state = 20;
            this.sectionStart = this.index + 1;
        } else if (!$0a18c015b5873b3d$var$isWhitespace(c)) {
            this.sectionStart = this.index;
            this.state = 21;
            this.stateInAttrValueNoQuotes(c);
        }
    }
    handleInAttrValue(c, quote) {
        if (c === quote || this.fastForwardTo(quote)) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(quote === 34 ? 3 : 2, this.index + 1);
            this.state = 11;
        }
    }
    stateInAttrValueDoubleQuotes(c) {
        this.handleInAttrValue(c, 34);
    }
    stateInAttrValueSingleQuotes(c) {
        this.handleInAttrValue(c, 39);
    }
    stateInAttrValueNoQuotes(c) {
        if ($0a18c015b5873b3d$var$isWhitespace(c) || c === 62) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(1, this.index);
            this.state = 11;
            this.stateBeforeAttrName(c);
        } else if (c === 39 || c === 60 || c === 61 || c === 96) this.cbs.onerr(18, this.index);
    }
    stateBeforeDeclaration(c) {
        if (c === 91) {
            this.state = 26;
            this.sequenceIndex = 0;
        } else this.state = c === 45 ? 25 : 23;
    }
    stateInDeclaration(c) {
        if (c === 62 || this.fastForwardTo(62)) {
            this.state = 1;
            this.sectionStart = this.index + 1;
        }
    }
    stateInProcessingInstruction(c) {
        if (c === 62 || this.fastForwardTo(62)) {
            this.cbs.onprocessinginstruction(this.sectionStart, this.index);
            this.state = 1;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeComment(c) {
        if (c === 45) {
            this.state = 28;
            this.currentSequence = $0a18c015b5873b3d$var$Sequences.CommentEnd;
            this.sequenceIndex = 2;
            this.sectionStart = this.index + 1;
        } else this.state = 23;
    }
    stateInSpecialComment(c) {
        if (c === 62 || this.fastForwardTo(62)) {
            this.cbs.oncomment(this.sectionStart, this.index);
            this.state = 1;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeSpecialS(c) {
        if (c === $0a18c015b5873b3d$var$Sequences.ScriptEnd[3]) this.startSpecial($0a18c015b5873b3d$var$Sequences.ScriptEnd, 4);
        else if (c === $0a18c015b5873b3d$var$Sequences.StyleEnd[3]) this.startSpecial($0a18c015b5873b3d$var$Sequences.StyleEnd, 4);
        else {
            this.state = 6;
            this.stateInTagName(c);
        }
    }
    stateBeforeSpecialT(c) {
        if (c === $0a18c015b5873b3d$var$Sequences.TitleEnd[3]) this.startSpecial($0a18c015b5873b3d$var$Sequences.TitleEnd, 4);
        else if (c === $0a18c015b5873b3d$var$Sequences.TextareaEnd[3]) this.startSpecial($0a18c015b5873b3d$var$Sequences.TextareaEnd, 4);
        else {
            this.state = 6;
            this.stateInTagName(c);
        }
    }
    startEntity() {}
    stateInEntity() {}
    /**
   * Iterates through the buffer, calling the function corresponding to the current state.
   *
   * States that are more likely to be hit are higher up, as a performance improvement.
   */ parse(input) {
        this.buffer = input;
        while(this.index < this.buffer.length){
            const c = this.buffer.charCodeAt(this.index);
            if (c === 10) this.newlines.push(this.index);
            switch(this.state){
                case 1:
                    this.stateText(c);
                    break;
                case 2:
                    this.stateInterpolationOpen(c);
                    break;
                case 3:
                    this.stateInterpolation(c);
                    break;
                case 4:
                    this.stateInterpolationClose(c);
                    break;
                case 31:
                    this.stateSpecialStartSequence(c);
                    break;
                case 32:
                    this.stateInRCDATA(c);
                    break;
                case 26:
                    this.stateCDATASequence(c);
                    break;
                case 19:
                    this.stateInAttrValueDoubleQuotes(c);
                    break;
                case 12:
                    this.stateInAttrName(c);
                    break;
                case 13:
                    this.stateInDirName(c);
                    break;
                case 14:
                    this.stateInDirArg(c);
                    break;
                case 15:
                    this.stateInDynamicDirArg(c);
                    break;
                case 16:
                    this.stateInDirModifier(c);
                    break;
                case 28:
                    this.stateInCommentLike(c);
                    break;
                case 27:
                    this.stateInSpecialComment(c);
                    break;
                case 11:
                    this.stateBeforeAttrName(c);
                    break;
                case 6:
                    this.stateInTagName(c);
                    break;
                case 34:
                    this.stateInSFCRootTagName(c);
                    break;
                case 9:
                    this.stateInClosingTagName(c);
                    break;
                case 5:
                    this.stateBeforeTagName(c);
                    break;
                case 17:
                    this.stateAfterAttrName(c);
                    break;
                case 20:
                    this.stateInAttrValueSingleQuotes(c);
                    break;
                case 18:
                    this.stateBeforeAttrValue(c);
                    break;
                case 8:
                    this.stateBeforeClosingTagName(c);
                    break;
                case 10:
                    this.stateAfterClosingTagName(c);
                    break;
                case 29:
                    this.stateBeforeSpecialS(c);
                    break;
                case 30:
                    this.stateBeforeSpecialT(c);
                    break;
                case 21:
                    this.stateInAttrValueNoQuotes(c);
                    break;
                case 7:
                    this.stateInSelfClosingTag(c);
                    break;
                case 23:
                    this.stateInDeclaration(c);
                    break;
                case 22:
                    this.stateBeforeDeclaration(c);
                    break;
                case 25:
                    this.stateBeforeComment(c);
                    break;
                case 24:
                    this.stateInProcessingInstruction(c);
                    break;
                case 33:
                    this.stateInEntity();
                    break;
            }
            this.index++;
        }
        this.cleanup();
        this.finish();
    }
    /**
   * Remove data that has already been consumed from the buffer.
   */ cleanup() {
        if (this.sectionStart !== this.index) {
            if (this.state === 1 || this.state === 32 && this.sequenceIndex === 0) {
                this.cbs.ontext(this.sectionStart, this.index);
                this.sectionStart = this.index;
            } else if (this.state === 19 || this.state === 20 || this.state === 21) {
                this.cbs.onattribdata(this.sectionStart, this.index);
                this.sectionStart = this.index;
            }
        }
    }
    finish() {
        this.handleTrailingData();
        this.cbs.onend();
    }
    /** Handle any trailing data. */ handleTrailingData() {
        const endIndex = this.buffer.length;
        if (this.sectionStart >= endIndex) return;
        if (this.state === 28) {
            if (this.currentSequence === $0a18c015b5873b3d$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, endIndex);
            else this.cbs.oncomment(this.sectionStart, endIndex);
        } else if (this.state === 6 || this.state === 11 || this.state === 18 || this.state === 17 || this.state === 12 || this.state === 13 || this.state === 14 || this.state === 15 || this.state === 16 || this.state === 20 || this.state === 19 || this.state === 21 || this.state === 9) ;
        else this.cbs.ontext(this.sectionStart, endIndex);
    }
    emitCodePoint(cp, consumed) {}
}
const $0a18c015b5873b3d$export$9354a9698ba2ae26 = {
    "COMPILER_IS_ON_ELEMENT": "COMPILER_IS_ON_ELEMENT",
    "COMPILER_V_BIND_SYNC": "COMPILER_V_BIND_SYNC",
    "COMPILER_V_BIND_OBJECT_ORDER": "COMPILER_V_BIND_OBJECT_ORDER",
    "COMPILER_V_ON_NATIVE": "COMPILER_V_ON_NATIVE",
    "COMPILER_V_IF_V_FOR_PRECEDENCE": "COMPILER_V_IF_V_FOR_PRECEDENCE",
    "COMPILER_NATIVE_TEMPLATE": "COMPILER_NATIVE_TEMPLATE",
    "COMPILER_INLINE_TEMPLATE": "COMPILER_INLINE_TEMPLATE",
    "COMPILER_FILTERS": "COMPILER_FILTERS"
};
const $0a18c015b5873b3d$var$deprecationData = {
    ["COMPILER_IS_ON_ELEMENT"]: {
        message: `Platform-native elements with "is" prop will no longer be treated as components in Vue 3 unless the "is" value is explicitly prefixed with "vue:".`,
        link: `https://v3-migration.vuejs.org/breaking-changes/custom-elements-interop.html`
    },
    ["COMPILER_V_BIND_SYNC"]: {
        message: (key)=>`.sync modifier for v-bind has been removed. Use v-model with argument instead. \`v-bind:${key}.sync\` should be changed to \`v-model:${key}\`.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-model.html`
    },
    ["COMPILER_V_BIND_OBJECT_ORDER"]: {
        message: `v-bind="obj" usage is now order sensitive and behaves like JavaScript object spread: it will now overwrite an existing non-mergeable attribute that appears before v-bind in the case of conflict. To retain 2.x behavior, move v-bind to make it the first attribute. You can also suppress this warning if the usage is intended.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-bind.html`
    },
    ["COMPILER_V_ON_NATIVE"]: {
        message: `.native modifier for v-on has been removed as is no longer necessary.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-on-native-modifier-removed.html`
    },
    ["COMPILER_V_IF_V_FOR_PRECEDENCE"]: {
        message: `v-if / v-for precedence when used on the same element has changed in Vue 3: v-if now takes higher precedence and will no longer have access to v-for scope variables. It is best to avoid the ambiguity with <template> tags or use a computed property that filters v-for data source.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-if-v-for.html`
    },
    ["COMPILER_NATIVE_TEMPLATE"]: {
        message: `<template> with no special directives will render as a native template element instead of its inner content in Vue 3.`
    },
    ["COMPILER_INLINE_TEMPLATE"]: {
        message: `"inline-template" has been removed in Vue 3.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/inline-template-attribute.html`
    },
    ["COMPILER_FILTERS"]: {
        message: `filters have been removed in Vue 3. The "|" symbol will be treated as native JavaScript bitwise OR operator. Use method calls or computed properties instead.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/filters.html`
    }
};
function $0a18c015b5873b3d$var$getCompatValue(key, { compatConfig: compatConfig }) {
    const value = compatConfig && compatConfig[key];
    if (key === "MODE") return value || 3;
    else return value;
}
function $0a18c015b5873b3d$var$isCompatEnabled(key, context) {
    const mode = $0a18c015b5873b3d$var$getCompatValue("MODE", context);
    const value = $0a18c015b5873b3d$var$getCompatValue(key, context);
    return mode === 3 ? value === true : value !== false;
}
function $0a18c015b5873b3d$export$1b1c14b93fcc0fe4(key, context, loc, ...args) {
    const enabled = $0a18c015b5873b3d$var$isCompatEnabled(key, context);
    return enabled;
}
function $0a18c015b5873b3d$export$1c4d39b152e0f791(key, context, loc, ...args) {
    const val = $0a18c015b5873b3d$var$getCompatValue(key, context);
    if (val === "suppress-warning") return;
    const { message: message, link: link } = $0a18c015b5873b3d$var$deprecationData[key];
    const msg = `(deprecation ${key}) ${typeof message === "function" ? message(...args) : message}${link ? `
  Details: ${link}` : ``}`;
    const err = new SyntaxError(msg);
    err.code = key;
    if (loc) err.loc = loc;
    context.onWarn(err);
}
function $0a18c015b5873b3d$var$defaultOnError(error) {
    throw error;
}
function $0a18c015b5873b3d$var$defaultOnWarn(msg) {}
function $0a18c015b5873b3d$export$57c5a5dc5aa19bdf(code, loc, messages, additionalMessage) {
    const msg = `https://vuejs.org/error-reference/#compiler-${code}`;
    const error = new SyntaxError(String(msg));
    error.code = code;
    error.loc = loc;
    return error;
}
const $0a18c015b5873b3d$export$10e8e1cf990558d7 = {
    "ABRUPT_CLOSING_OF_EMPTY_COMMENT": 0,
    "0": "ABRUPT_CLOSING_OF_EMPTY_COMMENT",
    "CDATA_IN_HTML_CONTENT": 1,
    "1": "CDATA_IN_HTML_CONTENT",
    "DUPLICATE_ATTRIBUTE": 2,
    "2": "DUPLICATE_ATTRIBUTE",
    "END_TAG_WITH_ATTRIBUTES": 3,
    "3": "END_TAG_WITH_ATTRIBUTES",
    "END_TAG_WITH_TRAILING_SOLIDUS": 4,
    "4": "END_TAG_WITH_TRAILING_SOLIDUS",
    "EOF_BEFORE_TAG_NAME": 5,
    "5": "EOF_BEFORE_TAG_NAME",
    "EOF_IN_CDATA": 6,
    "6": "EOF_IN_CDATA",
    "EOF_IN_COMMENT": 7,
    "7": "EOF_IN_COMMENT",
    "EOF_IN_SCRIPT_HTML_COMMENT_LIKE_TEXT": 8,
    "8": "EOF_IN_SCRIPT_HTML_COMMENT_LIKE_TEXT",
    "EOF_IN_TAG": 9,
    "9": "EOF_IN_TAG",
    "INCORRECTLY_CLOSED_COMMENT": 10,
    "10": "INCORRECTLY_CLOSED_COMMENT",
    "INCORRECTLY_OPENED_COMMENT": 11,
    "11": "INCORRECTLY_OPENED_COMMENT",
    "INVALID_FIRST_CHARACTER_OF_TAG_NAME": 12,
    "12": "INVALID_FIRST_CHARACTER_OF_TAG_NAME",
    "MISSING_ATTRIBUTE_VALUE": 13,
    "13": "MISSING_ATTRIBUTE_VALUE",
    "MISSING_END_TAG_NAME": 14,
    "14": "MISSING_END_TAG_NAME",
    "MISSING_WHITESPACE_BETWEEN_ATTRIBUTES": 15,
    "15": "MISSING_WHITESPACE_BETWEEN_ATTRIBUTES",
    "NESTED_COMMENT": 16,
    "16": "NESTED_COMMENT",
    "UNEXPECTED_CHARACTER_IN_ATTRIBUTE_NAME": 17,
    "17": "UNEXPECTED_CHARACTER_IN_ATTRIBUTE_NAME",
    "UNEXPECTED_CHARACTER_IN_UNQUOTED_ATTRIBUTE_VALUE": 18,
    "18": "UNEXPECTED_CHARACTER_IN_UNQUOTED_ATTRIBUTE_VALUE",
    "UNEXPECTED_EQUALS_SIGN_BEFORE_ATTRIBUTE_NAME": 19,
    "19": "UNEXPECTED_EQUALS_SIGN_BEFORE_ATTRIBUTE_NAME",
    "UNEXPECTED_NULL_CHARACTER": 20,
    "20": "UNEXPECTED_NULL_CHARACTER",
    "UNEXPECTED_QUESTION_MARK_INSTEAD_OF_TAG_NAME": 21,
    "21": "UNEXPECTED_QUESTION_MARK_INSTEAD_OF_TAG_NAME",
    "UNEXPECTED_SOLIDUS_IN_TAG": 22,
    "22": "UNEXPECTED_SOLIDUS_IN_TAG",
    "X_INVALID_END_TAG": 23,
    "23": "X_INVALID_END_TAG",
    "X_MISSING_END_TAG": 24,
    "24": "X_MISSING_END_TAG",
    "X_MISSING_INTERPOLATION_END": 25,
    "25": "X_MISSING_INTERPOLATION_END",
    "X_MISSING_DIRECTIVE_NAME": 26,
    "26": "X_MISSING_DIRECTIVE_NAME",
    "X_MISSING_DYNAMIC_DIRECTIVE_ARGUMENT_END": 27,
    "27": "X_MISSING_DYNAMIC_DIRECTIVE_ARGUMENT_END",
    "X_V_IF_NO_EXPRESSION": 28,
    "28": "X_V_IF_NO_EXPRESSION",
    "X_V_IF_SAME_KEY": 29,
    "29": "X_V_IF_SAME_KEY",
    "X_V_ELSE_NO_ADJACENT_IF": 30,
    "30": "X_V_ELSE_NO_ADJACENT_IF",
    "X_V_FOR_NO_EXPRESSION": 31,
    "31": "X_V_FOR_NO_EXPRESSION",
    "X_V_FOR_MALFORMED_EXPRESSION": 32,
    "32": "X_V_FOR_MALFORMED_EXPRESSION",
    "X_V_FOR_TEMPLATE_KEY_PLACEMENT": 33,
    "33": "X_V_FOR_TEMPLATE_KEY_PLACEMENT",
    "X_V_BIND_NO_EXPRESSION": 34,
    "34": "X_V_BIND_NO_EXPRESSION",
    "X_V_ON_NO_EXPRESSION": 35,
    "35": "X_V_ON_NO_EXPRESSION",
    "X_V_SLOT_UNEXPECTED_DIRECTIVE_ON_SLOT_OUTLET": 36,
    "36": "X_V_SLOT_UNEXPECTED_DIRECTIVE_ON_SLOT_OUTLET",
    "X_V_SLOT_MIXED_SLOT_USAGE": 37,
    "37": "X_V_SLOT_MIXED_SLOT_USAGE",
    "X_V_SLOT_DUPLICATE_SLOT_NAMES": 38,
    "38": "X_V_SLOT_DUPLICATE_SLOT_NAMES",
    "X_V_SLOT_EXTRANEOUS_DEFAULT_SLOT_CHILDREN": 39,
    "39": "X_V_SLOT_EXTRANEOUS_DEFAULT_SLOT_CHILDREN",
    "X_V_SLOT_MISPLACED": 40,
    "40": "X_V_SLOT_MISPLACED",
    "X_V_MODEL_NO_EXPRESSION": 41,
    "41": "X_V_MODEL_NO_EXPRESSION",
    "X_V_MODEL_MALFORMED_EXPRESSION": 42,
    "42": "X_V_MODEL_MALFORMED_EXPRESSION",
    "X_V_MODEL_ON_SCOPE_VARIABLE": 43,
    "43": "X_V_MODEL_ON_SCOPE_VARIABLE",
    "X_V_MODEL_ON_PROPS": 44,
    "44": "X_V_MODEL_ON_PROPS",
    "X_INVALID_EXPRESSION": 45,
    "45": "X_INVALID_EXPRESSION",
    "X_KEEP_ALIVE_INVALID_CHILDREN": 46,
    "46": "X_KEEP_ALIVE_INVALID_CHILDREN",
    "X_PREFIX_ID_NOT_SUPPORTED": 47,
    "47": "X_PREFIX_ID_NOT_SUPPORTED",
    "X_MODULE_MODE_NOT_SUPPORTED": 48,
    "48": "X_MODULE_MODE_NOT_SUPPORTED",
    "X_CACHE_HANDLER_NOT_SUPPORTED": 49,
    "49": "X_CACHE_HANDLER_NOT_SUPPORTED",
    "X_SCOPE_ID_NOT_SUPPORTED": 50,
    "50": "X_SCOPE_ID_NOT_SUPPORTED",
    "X_VNODE_HOOKS": 51,
    "51": "X_VNODE_HOOKS",
    "X_V_BIND_INVALID_SAME_NAME_ARGUMENT": 52,
    "52": "X_V_BIND_INVALID_SAME_NAME_ARGUMENT",
    "__EXTEND_POINT__": 53,
    "53": "__EXTEND_POINT__"
};
const $0a18c015b5873b3d$export$d8bd0967cb58683 = {
    // parse errors
    [0]: "Illegal comment.",
    [1]: "CDATA section is allowed only in XML context.",
    [2]: "Duplicate attribute.",
    [3]: "End tag cannot have attributes.",
    [4]: "Illegal '/' in tags.",
    [5]: "Unexpected EOF in tag.",
    [6]: "Unexpected EOF in CDATA section.",
    [7]: "Unexpected EOF in comment.",
    [8]: "Unexpected EOF in script.",
    [9]: "Unexpected EOF in tag.",
    [10]: "Incorrectly closed comment.",
    [11]: "Incorrectly opened comment.",
    [12]: "Illegal tag name. Use '&lt;' to print '<'.",
    [13]: "Attribute value was expected.",
    [14]: "End tag name was expected.",
    [15]: "Whitespace was expected.",
    [16]: "Unexpected '<!--' in comment.",
    [17]: `Attribute name cannot contain U+0022 ("), U+0027 ('), and U+003C (<).`,
    [18]: "Unquoted attribute value cannot contain U+0022 (\"), U+0027 ('), U+003C (<), U+003D (=), and U+0060 (`).",
    [19]: "Attribute name cannot start with '='.",
    [21]: "'<?' is allowed only in XML context.",
    [20]: `Unexpected null character.`,
    [22]: "Illegal '/' in tags.",
    // Vue-specific parse errors
    [23]: "Invalid end tag.",
    [24]: "Element is missing end tag.",
    [25]: "Interpolation end sign was not found.",
    [27]: "End bracket for dynamic directive argument was not found. Note that dynamic directive argument cannot contain spaces.",
    [26]: "Legal directive name was expected.",
    // transform errors
    [28]: `v-if/v-else-if is missing expression.`,
    [29]: `v-if/else branches must use unique keys.`,
    [30]: `v-else/v-else-if has no adjacent v-if or v-else-if.`,
    [31]: `v-for is missing expression.`,
    [32]: `v-for has invalid expression.`,
    [33]: `<template v-for> key should be placed on the <template> tag.`,
    [34]: `v-bind is missing expression.`,
    [52]: `v-bind with same-name shorthand only allows static argument.`,
    [35]: `v-on is missing expression.`,
    [36]: `Unexpected custom directive on <slot> outlet.`,
    [37]: `Mixed v-slot usage on both the component and nested <template>. When there are multiple named slots, all slots should use <template> syntax to avoid scope ambiguity.`,
    [38]: `Duplicate slot names found. `,
    [39]: `Extraneous children found when component already has explicitly named default slot. These children will be ignored.`,
    [40]: `v-slot can only be used on components or <template> tags.`,
    [41]: `v-model is missing expression.`,
    [42]: `v-model value must be a valid JavaScript member expression.`,
    [43]: `v-model cannot be used on v-for or v-slot scope variables because they are not writable.`,
    [44]: `v-model cannot be used on a prop, because local prop bindings are not writable.
Use a v-bind binding combined with a v-on listener that emits update:x event instead.`,
    [45]: `Error parsing JavaScript expression: `,
    [46]: `<KeepAlive> expects exactly one child component.`,
    [51]: `@vnode-* hooks in templates are no longer supported. Use the vue: prefix instead. For example, @vnode-mounted should be changed to @vue:mounted. @vnode-* hooks support has been removed in 3.4.`,
    // generic errors
    [47]: `"prefixIdentifiers" option is not supported in this build of compiler.`,
    [48]: `ES module mode is not supported in this build of compiler.`,
    [49]: `"cacheHandlers" option is only supported when the "prefixIdentifiers" option is enabled.`,
    [50]: `"scopeId" option is only supported in module mode.`,
    // just to fulfill types
    [53]: ``
};
function $0a18c015b5873b3d$export$1f18e145724205f0(root, onIdentifier, includeAll = false, parentStack = [], knownIds = /* @__PURE__ */ Object.create(null)) {
    return;
}
function $0a18c015b5873b3d$export$a351a8c8c66104d7(id, parent, parentStack) {
    return false;
}
function $0a18c015b5873b3d$export$b1c677096ee1f9ce(parent, parentStack) {
    if (parent && (parent.type === "ObjectProperty" || parent.type === "ArrayPattern")) {
        let i = parentStack.length;
        while(i--){
            const p = parentStack[i];
            if (p.type === "AssignmentExpression") return true;
            else if (p.type !== "ObjectProperty" && !p.type.endsWith("Pattern")) break;
        }
    }
    return false;
}
function $0a18c015b5873b3d$export$6fdc7720591bc1f7(parentStack) {
    let i = parentStack.length;
    while(i--){
        const p = parentStack[i];
        if (p.type === "NewExpression") return true;
        else if (p.type !== "MemberExpression") break;
    }
    return false;
}
function $0a18c015b5873b3d$export$d41514e9f2f5bb4d(node, onIdent) {
    for (const p of node.params)for (const id of $0a18c015b5873b3d$export$31e5048ec55fc20d(p))onIdent(id);
}
function $0a18c015b5873b3d$export$3e47780ecfa08385(block, onIdent) {
    for (const stmt of block.body){
        if (stmt.type === "VariableDeclaration") {
            if (stmt.declare) continue;
            for (const decl of stmt.declarations)for (const id of $0a18c015b5873b3d$export$31e5048ec55fc20d(decl.id))onIdent(id);
        } else if (stmt.type === "FunctionDeclaration" || stmt.type === "ClassDeclaration") {
            if (stmt.declare || !stmt.id) continue;
            onIdent(stmt.id);
        } else if ($0a18c015b5873b3d$var$isForStatement(stmt)) $0a18c015b5873b3d$var$walkForStatement(stmt, true, onIdent);
    }
}
function $0a18c015b5873b3d$var$isForStatement(stmt) {
    return stmt.type === "ForOfStatement" || stmt.type === "ForInStatement" || stmt.type === "ForStatement";
}
function $0a18c015b5873b3d$var$walkForStatement(stmt, isVar, onIdent) {
    const variable = stmt.type === "ForStatement" ? stmt.init : stmt.left;
    if (variable && variable.type === "VariableDeclaration" && (variable.kind === "var" ? isVar : !isVar)) {
        for (const decl of variable.declarations)for (const id of $0a18c015b5873b3d$export$31e5048ec55fc20d(decl.id))onIdent(id);
    }
}
function $0a18c015b5873b3d$export$31e5048ec55fc20d(param, nodes = []) {
    switch(param.type){
        case "Identifier":
            nodes.push(param);
            break;
        case "MemberExpression":
            let object = param;
            while(object.type === "MemberExpression")object = object.object;
            nodes.push(object);
            break;
        case "ObjectPattern":
            for (const prop of param.properties)if (prop.type === "RestElement") $0a18c015b5873b3d$export$31e5048ec55fc20d(prop.argument, nodes);
            else $0a18c015b5873b3d$export$31e5048ec55fc20d(prop.value, nodes);
            break;
        case "ArrayPattern":
            param.elements.forEach((element)=>{
                if (element) $0a18c015b5873b3d$export$31e5048ec55fc20d(element, nodes);
            });
            break;
        case "RestElement":
            $0a18c015b5873b3d$export$31e5048ec55fc20d(param.argument, nodes);
            break;
        case "AssignmentPattern":
            $0a18c015b5873b3d$export$31e5048ec55fc20d(param.left, nodes);
            break;
    }
    return nodes;
}
const $0a18c015b5873b3d$export$8af909612acebc9b = (node)=>{
    return /Function(?:Expression|Declaration)$|Method$/.test(node.type);
};
const $0a18c015b5873b3d$export$f6ddf7e7b08e8e00 = (node)=>node && (node.type === "ObjectProperty" || node.type === "ObjectMethod") && !node.computed;
const $0a18c015b5873b3d$export$644dbfd5b3d2f87f = (node, parent)=>$0a18c015b5873b3d$export$f6ddf7e7b08e8e00(parent) && parent.key === node;
const $0a18c015b5873b3d$export$d40f31ccee2489f = [
    "TSAsExpression",
    // foo as number
    "TSTypeAssertion",
    // (<number>foo)
    "TSNonNullExpression",
    // foo!
    "TSInstantiationExpression",
    // foo<string>
    "TSSatisfiesExpression"
];
function $0a18c015b5873b3d$export$4bc65b30e69d96a9(node) {
    if ($0a18c015b5873b3d$export$d40f31ccee2489f.includes(node.type)) return $0a18c015b5873b3d$export$4bc65b30e69d96a9(node.expression);
    else return node;
}
const $0a18c015b5873b3d$export$43d387e2d68b51dc = (p)=>p.type === 4 && p.isStatic;
function $0a18c015b5873b3d$export$69768c9b514a01e9(tag) {
    switch(tag){
        case "Teleport":
        case "teleport":
            return $0a18c015b5873b3d$export$e74e82bc14ac4f98;
        case "Suspense":
        case "suspense":
            return $0a18c015b5873b3d$export$2237d737f4a10705;
        case "KeepAlive":
        case "keep-alive":
            return $0a18c015b5873b3d$export$e9ff5bb5c39478ed;
        case "BaseTransition":
        case "base-transition":
            return $0a18c015b5873b3d$export$b357ae9fe0a3685a;
    }
}
const $0a18c015b5873b3d$var$nonIdentifierRE = /^\d|[^\$\w\xA0-\uFFFF]/;
const $0a18c015b5873b3d$export$3cb8486ad206c65 = (name)=>!$0a18c015b5873b3d$var$nonIdentifierRE.test(name);
const $0a18c015b5873b3d$var$validFirstIdentCharRE = /[A-Za-z_$\xA0-\uFFFF]/;
const $0a18c015b5873b3d$var$validIdentCharRE = /[\.\?\w$\xA0-\uFFFF]/;
const $0a18c015b5873b3d$var$whitespaceRE = /\s+[.[]\s*|\s*[.[]\s+/g;
const $0a18c015b5873b3d$var$getExpSource = (exp)=>exp.type === 4 ? exp.content : exp.loc.source;
const $0a18c015b5873b3d$export$fc15bf43a5359adf = (exp)=>{
    const path = $0a18c015b5873b3d$var$getExpSource(exp).trim().replace($0a18c015b5873b3d$var$whitespaceRE, (s)=>s.trim());
    let state = 0 /* inMemberExp */ ;
    let stateStack = [];
    let currentOpenBracketCount = 0;
    let currentOpenParensCount = 0;
    let currentStringType = null;
    for(let i = 0; i < path.length; i++){
        const char = path.charAt(i);
        switch(state){
            case 0 /* inMemberExp */ :
                if (char === "[") {
                    stateStack.push(state);
                    state = 1 /* inBrackets */ ;
                    currentOpenBracketCount++;
                } else if (char === "(") {
                    stateStack.push(state);
                    state = 2 /* inParens */ ;
                    currentOpenParensCount++;
                } else if (!(i === 0 ? $0a18c015b5873b3d$var$validFirstIdentCharRE : $0a18c015b5873b3d$var$validIdentCharRE).test(char)) return false;
                break;
            case 1 /* inBrackets */ :
                if (char === `'` || char === `"` || char === "`") {
                    stateStack.push(state);
                    state = 3 /* inString */ ;
                    currentStringType = char;
                } else if (char === `[`) currentOpenBracketCount++;
                else if (char === `]`) {
                    if (!--currentOpenBracketCount) state = stateStack.pop();
                }
                break;
            case 2 /* inParens */ :
                if (char === `'` || char === `"` || char === "`") {
                    stateStack.push(state);
                    state = 3 /* inString */ ;
                    currentStringType = char;
                } else if (char === `(`) currentOpenParensCount++;
                else if (char === `)`) {
                    if (i === path.length - 1) return false;
                    if (!--currentOpenParensCount) state = stateStack.pop();
                }
                break;
            case 3 /* inString */ :
                if (char === currentStringType) {
                    state = stateStack.pop();
                    currentStringType = null;
                }
                break;
        }
    }
    return !currentOpenBracketCount && !currentOpenParensCount;
};
const $0a18c015b5873b3d$export$380d727799fbcdda = (0, $a5gC8.NOOP);
const $0a18c015b5873b3d$export$9c8bdf9fab617ce4 = $0a18c015b5873b3d$export$fc15bf43a5359adf;
const $0a18c015b5873b3d$var$fnExpRE = /^\s*(async\s*)?(\([^)]*?\)|[\w$_]+)\s*(:[^=]+)?=>|^\s*(async\s+)?function(?:\s+[\w$]+)?\s*\(/;
const $0a18c015b5873b3d$export$aaa41f84da434bf1 = (exp)=>$0a18c015b5873b3d$var$fnExpRE.test($0a18c015b5873b3d$var$getExpSource(exp));
const $0a18c015b5873b3d$export$d64efa2398fbfc9d = (0, $a5gC8.NOOP);
const $0a18c015b5873b3d$export$482164e6e5517986 = $0a18c015b5873b3d$export$aaa41f84da434bf1;
function $0a18c015b5873b3d$export$1cdf554524c0924f(pos, source, numberOfCharacters = source.length) {
    return $0a18c015b5873b3d$export$c57ab60b0c6308ea({
        offset: pos.offset,
        line: pos.line,
        column: pos.column
    }, source, numberOfCharacters);
}
function $0a18c015b5873b3d$export$c57ab60b0c6308ea(pos, source, numberOfCharacters = source.length) {
    let linesCount = 0;
    let lastNewLinePos = -1;
    for(let i = 0; i < numberOfCharacters; i++)if (source.charCodeAt(i) === 10) {
        linesCount++;
        lastNewLinePos = i;
    }
    pos.offset += numberOfCharacters;
    pos.line += linesCount;
    pos.column = lastNewLinePos === -1 ? pos.column + numberOfCharacters : numberOfCharacters - lastNewLinePos;
    return pos;
}
function $0a18c015b5873b3d$export$a7a9523472993e97(condition, msg) {
    if (!condition) throw new Error(msg || `unexpected compiler condition`);
}
function $0a18c015b5873b3d$export$1199bc2a2b648c8c(node, name, allowEmpty = false) {
    for(let i = 0; i < node.props.length; i++){
        const p = node.props[i];
        if (p.type === 7 && (allowEmpty || p.exp) && ((0, $a5gC8.isString)(name) ? p.name === name : name.test(p.name))) return p;
    }
}
function $0a18c015b5873b3d$export$4ae65475e3513615(node, name, dynamicOnly = false, allowEmpty = false) {
    for(let i = 0; i < node.props.length; i++){
        const p = node.props[i];
        if (p.type === 6) {
            if (dynamicOnly) continue;
            if (p.name === name && (p.value || allowEmpty)) return p;
        } else if (p.name === "bind" && (p.exp || allowEmpty) && $0a18c015b5873b3d$export$45cac5109adb5e55(p.arg, name)) return p;
    }
}
function $0a18c015b5873b3d$export$45cac5109adb5e55(arg, name) {
    return !!(arg && $0a18c015b5873b3d$export$43d387e2d68b51dc(arg) && arg.content === name);
}
function $0a18c015b5873b3d$export$4e1f112c75b8dafc(node) {
    return node.props.some((p)=>p.type === 7 && p.name === "bind" && (!p.arg || // v-bind="obj"
        p.arg.type !== 4 || // v-bind:[_ctx.foo]
        !p.arg.isStatic));
}
function $0a18c015b5873b3d$export$1879817ac5c922b7(node) {
    return node.type === 5 || node.type === 2;
}
function $0a18c015b5873b3d$export$eaf8991bb8af8cbb(p) {
    return p.type === 7 && p.name === "slot";
}
function $0a18c015b5873b3d$export$f125a8a2b402ed89(node) {
    return node.type === 1 && node.tagType === 3;
}
function $0a18c015b5873b3d$export$45f38ad7fffc9b53(node) {
    return node.type === 1 && node.tagType === 2;
}
const $0a18c015b5873b3d$var$propsHelperSet = /* @__PURE__ */ new Set([
    $0a18c015b5873b3d$export$78c34c869683dd86,
    $0a18c015b5873b3d$export$7046bb8d3c918928
]);
function $0a18c015b5873b3d$var$getUnnormalizedProps(props, callPath = []) {
    if (props && !(0, $a5gC8.isString)(props) && props.type === 14) {
        const callee = props.callee;
        if (!(0, $a5gC8.isString)(callee) && $0a18c015b5873b3d$var$propsHelperSet.has(callee)) return $0a18c015b5873b3d$var$getUnnormalizedProps(props.arguments[0], callPath.concat(props));
    }
    return [
        props,
        callPath
    ];
}
function $0a18c015b5873b3d$export$ec34add3fb2185f8(node, prop, context) {
    let propsWithInjection;
    let props = node.type === 13 ? node.props : node.arguments[2];
    let callPath = [];
    let parentCall;
    if (props && !(0, $a5gC8.isString)(props) && props.type === 14) {
        const ret = $0a18c015b5873b3d$var$getUnnormalizedProps(props);
        props = ret[0];
        callPath = ret[1];
        parentCall = callPath[callPath.length - 1];
    }
    if (props == null || (0, $a5gC8.isString)(props)) propsWithInjection = $0a18c015b5873b3d$export$ccb2e514379853a7([
        prop
    ]);
    else if (props.type === 14) {
        const first = props.arguments[0];
        if (!(0, $a5gC8.isString)(first) && first.type === 15) {
            if (!$0a18c015b5873b3d$var$hasProp(prop, first)) first.properties.unshift(prop);
        } else if (props.callee === $0a18c015b5873b3d$export$4bdbf33367525856) propsWithInjection = $0a18c015b5873b3d$export$2cdf8617f9d8e39d(context.helper($0a18c015b5873b3d$export$825e32c0f842262a), [
            $0a18c015b5873b3d$export$ccb2e514379853a7([
                prop
            ]),
            props
        ]);
        else props.arguments.unshift($0a18c015b5873b3d$export$ccb2e514379853a7([
            prop
        ]));
        !propsWithInjection && (propsWithInjection = props);
    } else if (props.type === 15) {
        if (!$0a18c015b5873b3d$var$hasProp(prop, props)) props.properties.unshift(prop);
        propsWithInjection = props;
    } else {
        propsWithInjection = $0a18c015b5873b3d$export$2cdf8617f9d8e39d(context.helper($0a18c015b5873b3d$export$825e32c0f842262a), [
            $0a18c015b5873b3d$export$ccb2e514379853a7([
                prop
            ]),
            props
        ]);
        if (parentCall && parentCall.callee === $0a18c015b5873b3d$export$7046bb8d3c918928) parentCall = callPath[callPath.length - 2];
    }
    if (node.type === 13) {
        if (parentCall) parentCall.arguments[0] = propsWithInjection;
        else node.props = propsWithInjection;
    } else if (parentCall) parentCall.arguments[0] = propsWithInjection;
    else node.arguments[2] = propsWithInjection;
}
function $0a18c015b5873b3d$var$hasProp(prop, props) {
    let result = false;
    if (prop.key.type === 4) {
        const propKeyName = prop.key.content;
        result = props.properties.some((p)=>p.key.type === 4 && p.key.content === propKeyName);
    }
    return result;
}
function $0a18c015b5873b3d$export$80505c1072df544f(name, type) {
    return `_${type}_${name.replace(/[^\w]/g, (searchValue, replaceValue)=>{
        return searchValue === "-" ? "_" : name.charCodeAt(replaceValue).toString();
    })}`;
}
function $0a18c015b5873b3d$export$587b5ad66ebfa843(node, ids) {
    if (!node || Object.keys(ids).length === 0) return false;
    switch(node.type){
        case 1:
            for(let i = 0; i < node.props.length; i++){
                const p = node.props[i];
                if (p.type === 7 && ($0a18c015b5873b3d$export$587b5ad66ebfa843(p.arg, ids) || $0a18c015b5873b3d$export$587b5ad66ebfa843(p.exp, ids))) return true;
            }
            return node.children.some((c)=>$0a18c015b5873b3d$export$587b5ad66ebfa843(c, ids));
        case 11:
            if ($0a18c015b5873b3d$export$587b5ad66ebfa843(node.source, ids)) return true;
            return node.children.some((c)=>$0a18c015b5873b3d$export$587b5ad66ebfa843(c, ids));
        case 9:
            return node.branches.some((b)=>$0a18c015b5873b3d$export$587b5ad66ebfa843(b, ids));
        case 10:
            if ($0a18c015b5873b3d$export$587b5ad66ebfa843(node.condition, ids)) return true;
            return node.children.some((c)=>$0a18c015b5873b3d$export$587b5ad66ebfa843(c, ids));
        case 4:
            return !node.isStatic && $0a18c015b5873b3d$export$3cb8486ad206c65(node.content) && !!ids[node.content];
        case 8:
            return node.children.some((c)=>(0, $a5gC8.isObject)(c) && $0a18c015b5873b3d$export$587b5ad66ebfa843(c, ids));
        case 5:
        case 12:
            return $0a18c015b5873b3d$export$587b5ad66ebfa843(node.content, ids);
        case 2:
        case 3:
        case 20:
            return false;
        default:
            return false;
    }
}
function $0a18c015b5873b3d$export$39e241985cd3e673(node) {
    if (node.type === 14 && node.callee === $0a18c015b5873b3d$export$a0fd71f0f7cd2781) return node.arguments[1].returns;
    else return node;
}
const $0a18c015b5873b3d$export$a81a10be31983be5 = /([\s\S]*?)\s+(?:in|of)\s+(\S[\s\S]*)/;
const $0a18c015b5873b3d$var$defaultParserOptions = {
    parseMode: "base",
    ns: 0,
    delimiters: [
        `{{`,
        `}}`
    ],
    getNamespace: ()=>0,
    isVoidTag: (0, $a5gC8.NO),
    isPreTag: (0, $a5gC8.NO),
    isIgnoreNewlineTag: (0, $a5gC8.NO),
    isCustomElement: (0, $a5gC8.NO),
    onError: $0a18c015b5873b3d$var$defaultOnError,
    onWarn: $0a18c015b5873b3d$var$defaultOnWarn,
    comments: false,
    prefixIdentifiers: false
};
let $0a18c015b5873b3d$var$currentOptions = $0a18c015b5873b3d$var$defaultParserOptions;
let $0a18c015b5873b3d$var$currentRoot = null;
let $0a18c015b5873b3d$var$currentInput = "";
let $0a18c015b5873b3d$var$currentOpenTag = null;
let $0a18c015b5873b3d$var$currentProp = null;
let $0a18c015b5873b3d$var$currentAttrValue = "";
let $0a18c015b5873b3d$var$currentAttrStartIndex = -1;
let $0a18c015b5873b3d$var$currentAttrEndIndex = -1;
let $0a18c015b5873b3d$var$inPre = 0;
let $0a18c015b5873b3d$var$inVPre = false;
let $0a18c015b5873b3d$var$currentVPreBoundary = null;
const $0a18c015b5873b3d$var$stack = [];
const $0a18c015b5873b3d$var$tokenizer = new $0a18c015b5873b3d$var$Tokenizer($0a18c015b5873b3d$var$stack, {
    onerr: $0a18c015b5873b3d$var$emitError,
    ontext (start, end) {
        $0a18c015b5873b3d$var$onText($0a18c015b5873b3d$var$getSlice(start, end), start, end);
    },
    ontextentity (char, start, end) {
        $0a18c015b5873b3d$var$onText(char, start, end);
    },
    oninterpolation (start, end) {
        if ($0a18c015b5873b3d$var$inVPre) return $0a18c015b5873b3d$var$onText($0a18c015b5873b3d$var$getSlice(start, end), start, end);
        let innerStart = start + $0a18c015b5873b3d$var$tokenizer.delimiterOpen.length;
        let innerEnd = end - $0a18c015b5873b3d$var$tokenizer.delimiterClose.length;
        while($0a18c015b5873b3d$var$isWhitespace($0a18c015b5873b3d$var$currentInput.charCodeAt(innerStart)))innerStart++;
        while($0a18c015b5873b3d$var$isWhitespace($0a18c015b5873b3d$var$currentInput.charCodeAt(innerEnd - 1)))innerEnd--;
        let exp = $0a18c015b5873b3d$var$getSlice(innerStart, innerEnd);
        if (exp.includes("&")) exp = $0a18c015b5873b3d$var$currentOptions.decodeEntities(exp, false);
        $0a18c015b5873b3d$var$addNode({
            type: 5,
            content: $0a18c015b5873b3d$var$createExp(exp, false, $0a18c015b5873b3d$var$getLoc(innerStart, innerEnd)),
            loc: $0a18c015b5873b3d$var$getLoc(start, end)
        });
    },
    onopentagname (start, end) {
        const name = $0a18c015b5873b3d$var$getSlice(start, end);
        $0a18c015b5873b3d$var$currentOpenTag = {
            type: 1,
            tag: name,
            ns: $0a18c015b5873b3d$var$currentOptions.getNamespace(name, $0a18c015b5873b3d$var$stack[0], $0a18c015b5873b3d$var$currentOptions.ns),
            tagType: 0,
            // will be refined on tag close
            props: [],
            children: [],
            loc: $0a18c015b5873b3d$var$getLoc(start - 1, end),
            codegenNode: void 0
        };
    },
    onopentagend (end) {
        $0a18c015b5873b3d$var$endOpenTag(end);
    },
    onclosetag (start, end) {
        const name = $0a18c015b5873b3d$var$getSlice(start, end);
        if (!$0a18c015b5873b3d$var$currentOptions.isVoidTag(name)) {
            let found = false;
            for(let i = 0; i < $0a18c015b5873b3d$var$stack.length; i++){
                const e = $0a18c015b5873b3d$var$stack[i];
                if (e.tag.toLowerCase() === name.toLowerCase()) {
                    found = true;
                    if (i > 0) $0a18c015b5873b3d$var$emitError(24, $0a18c015b5873b3d$var$stack[0].loc.start.offset);
                    for(let j = 0; j <= i; j++){
                        const el = $0a18c015b5873b3d$var$stack.shift();
                        $0a18c015b5873b3d$var$onCloseTag(el, end, j < i);
                    }
                    break;
                }
            }
            if (!found) $0a18c015b5873b3d$var$emitError(23, $0a18c015b5873b3d$var$backTrack(start, 60));
        }
    },
    onselfclosingtag (end) {
        const name = $0a18c015b5873b3d$var$currentOpenTag.tag;
        $0a18c015b5873b3d$var$currentOpenTag.isSelfClosing = true;
        $0a18c015b5873b3d$var$endOpenTag(end);
        if ($0a18c015b5873b3d$var$stack[0] && $0a18c015b5873b3d$var$stack[0].tag === name) $0a18c015b5873b3d$var$onCloseTag($0a18c015b5873b3d$var$stack.shift(), end);
    },
    onattribname (start, end) {
        $0a18c015b5873b3d$var$currentProp = {
            type: 6,
            name: $0a18c015b5873b3d$var$getSlice(start, end),
            nameLoc: $0a18c015b5873b3d$var$getLoc(start, end),
            value: void 0,
            loc: $0a18c015b5873b3d$var$getLoc(start)
        };
    },
    ondirname (start, end) {
        const raw = $0a18c015b5873b3d$var$getSlice(start, end);
        const name = raw === "." || raw === ":" ? "bind" : raw === "@" ? "on" : raw === "#" ? "slot" : raw.slice(2);
        if (!$0a18c015b5873b3d$var$inVPre && name === "") $0a18c015b5873b3d$var$emitError(26, start);
        if ($0a18c015b5873b3d$var$inVPre || name === "") $0a18c015b5873b3d$var$currentProp = {
            type: 6,
            name: raw,
            nameLoc: $0a18c015b5873b3d$var$getLoc(start, end),
            value: void 0,
            loc: $0a18c015b5873b3d$var$getLoc(start)
        };
        else {
            $0a18c015b5873b3d$var$currentProp = {
                type: 7,
                name: name,
                rawName: raw,
                exp: void 0,
                arg: void 0,
                modifiers: raw === "." ? [
                    $0a18c015b5873b3d$export$ac2aa689b44cdd23("prop")
                ] : [],
                loc: $0a18c015b5873b3d$var$getLoc(start)
            };
            if (name === "pre") {
                $0a18c015b5873b3d$var$inVPre = $0a18c015b5873b3d$var$tokenizer.inVPre = true;
                $0a18c015b5873b3d$var$currentVPreBoundary = $0a18c015b5873b3d$var$currentOpenTag;
                const props = $0a18c015b5873b3d$var$currentOpenTag.props;
                for(let i = 0; i < props.length; i++)if (props[i].type === 7) props[i] = $0a18c015b5873b3d$var$dirToAttr(props[i]);
            }
        }
    },
    ondirarg (start, end) {
        if (start === end) return;
        const arg = $0a18c015b5873b3d$var$getSlice(start, end);
        if ($0a18c015b5873b3d$var$inVPre) {
            $0a18c015b5873b3d$var$currentProp.name += arg;
            $0a18c015b5873b3d$var$setLocEnd($0a18c015b5873b3d$var$currentProp.nameLoc, end);
        } else {
            const isStatic = arg[0] !== `[`;
            $0a18c015b5873b3d$var$currentProp.arg = $0a18c015b5873b3d$var$createExp(isStatic ? arg : arg.slice(1, -1), isStatic, $0a18c015b5873b3d$var$getLoc(start, end), isStatic ? 3 : 0);
        }
    },
    ondirmodifier (start, end) {
        const mod = $0a18c015b5873b3d$var$getSlice(start, end);
        if ($0a18c015b5873b3d$var$inVPre) {
            $0a18c015b5873b3d$var$currentProp.name += "." + mod;
            $0a18c015b5873b3d$var$setLocEnd($0a18c015b5873b3d$var$currentProp.nameLoc, end);
        } else if ($0a18c015b5873b3d$var$currentProp.name === "slot") {
            const arg = $0a18c015b5873b3d$var$currentProp.arg;
            if (arg) {
                arg.content += "." + mod;
                $0a18c015b5873b3d$var$setLocEnd(arg.loc, end);
            }
        } else {
            const exp = $0a18c015b5873b3d$export$ac2aa689b44cdd23(mod, true, $0a18c015b5873b3d$var$getLoc(start, end));
            $0a18c015b5873b3d$var$currentProp.modifiers.push(exp);
        }
    },
    onattribdata (start, end) {
        $0a18c015b5873b3d$var$currentAttrValue += $0a18c015b5873b3d$var$getSlice(start, end);
        if ($0a18c015b5873b3d$var$currentAttrStartIndex < 0) $0a18c015b5873b3d$var$currentAttrStartIndex = start;
        $0a18c015b5873b3d$var$currentAttrEndIndex = end;
    },
    onattribentity (char, start, end) {
        $0a18c015b5873b3d$var$currentAttrValue += char;
        if ($0a18c015b5873b3d$var$currentAttrStartIndex < 0) $0a18c015b5873b3d$var$currentAttrStartIndex = start;
        $0a18c015b5873b3d$var$currentAttrEndIndex = end;
    },
    onattribnameend (end) {
        const start = $0a18c015b5873b3d$var$currentProp.loc.start.offset;
        const name = $0a18c015b5873b3d$var$getSlice(start, end);
        if ($0a18c015b5873b3d$var$currentProp.type === 7) $0a18c015b5873b3d$var$currentProp.rawName = name;
        if ($0a18c015b5873b3d$var$currentOpenTag.props.some((p)=>(p.type === 7 ? p.rawName : p.name) === name)) $0a18c015b5873b3d$var$emitError(2, start);
    },
    onattribend (quote, end) {
        if ($0a18c015b5873b3d$var$currentOpenTag && $0a18c015b5873b3d$var$currentProp) {
            $0a18c015b5873b3d$var$setLocEnd($0a18c015b5873b3d$var$currentProp.loc, end);
            if (quote !== 0) {
                if ($0a18c015b5873b3d$var$currentAttrValue.includes("&")) $0a18c015b5873b3d$var$currentAttrValue = $0a18c015b5873b3d$var$currentOptions.decodeEntities($0a18c015b5873b3d$var$currentAttrValue, true);
                if ($0a18c015b5873b3d$var$currentProp.type === 6) {
                    if ($0a18c015b5873b3d$var$currentProp.name === "class") $0a18c015b5873b3d$var$currentAttrValue = $0a18c015b5873b3d$var$condense($0a18c015b5873b3d$var$currentAttrValue).trim();
                    if (quote === 1 && !$0a18c015b5873b3d$var$currentAttrValue) $0a18c015b5873b3d$var$emitError(13, end);
                    $0a18c015b5873b3d$var$currentProp.value = {
                        type: 2,
                        content: $0a18c015b5873b3d$var$currentAttrValue,
                        loc: quote === 1 ? $0a18c015b5873b3d$var$getLoc($0a18c015b5873b3d$var$currentAttrStartIndex, $0a18c015b5873b3d$var$currentAttrEndIndex) : $0a18c015b5873b3d$var$getLoc($0a18c015b5873b3d$var$currentAttrStartIndex - 1, $0a18c015b5873b3d$var$currentAttrEndIndex + 1)
                    };
                    if ($0a18c015b5873b3d$var$tokenizer.inSFCRoot && $0a18c015b5873b3d$var$currentOpenTag.tag === "template" && $0a18c015b5873b3d$var$currentProp.name === "lang" && $0a18c015b5873b3d$var$currentAttrValue && $0a18c015b5873b3d$var$currentAttrValue !== "html") $0a18c015b5873b3d$var$tokenizer.enterRCDATA($0a18c015b5873b3d$var$toCharCodes(`</template`), 0);
                } else {
                    let expParseMode = 0 /* Normal */ ;
                    $0a18c015b5873b3d$var$currentProp.exp = $0a18c015b5873b3d$var$createExp($0a18c015b5873b3d$var$currentAttrValue, false, $0a18c015b5873b3d$var$getLoc($0a18c015b5873b3d$var$currentAttrStartIndex, $0a18c015b5873b3d$var$currentAttrEndIndex), 0, expParseMode);
                    if ($0a18c015b5873b3d$var$currentProp.name === "for") $0a18c015b5873b3d$var$currentProp.forParseResult = $0a18c015b5873b3d$var$parseForExpression($0a18c015b5873b3d$var$currentProp.exp);
                    let syncIndex = -1;
                    if ($0a18c015b5873b3d$var$currentProp.name === "bind" && (syncIndex = $0a18c015b5873b3d$var$currentProp.modifiers.findIndex((mod)=>mod.content === "sync")) > -1 && $0a18c015b5873b3d$export$1b1c14b93fcc0fe4("COMPILER_V_BIND_SYNC", $0a18c015b5873b3d$var$currentOptions, $0a18c015b5873b3d$var$currentProp.loc, $0a18c015b5873b3d$var$currentProp.rawName)) {
                        $0a18c015b5873b3d$var$currentProp.name = "model";
                        $0a18c015b5873b3d$var$currentProp.modifiers.splice(syncIndex, 1);
                    }
                }
            }
            if ($0a18c015b5873b3d$var$currentProp.type !== 7 || $0a18c015b5873b3d$var$currentProp.name !== "pre") $0a18c015b5873b3d$var$currentOpenTag.props.push($0a18c015b5873b3d$var$currentProp);
        }
        $0a18c015b5873b3d$var$currentAttrValue = "";
        $0a18c015b5873b3d$var$currentAttrStartIndex = $0a18c015b5873b3d$var$currentAttrEndIndex = -1;
    },
    oncomment (start, end) {
        if ($0a18c015b5873b3d$var$currentOptions.comments) $0a18c015b5873b3d$var$addNode({
            type: 3,
            content: $0a18c015b5873b3d$var$getSlice(start, end),
            loc: $0a18c015b5873b3d$var$getLoc(start - 4, end + 3)
        });
    },
    onend () {
        const end = $0a18c015b5873b3d$var$currentInput.length;
        for(let index = 0; index < $0a18c015b5873b3d$var$stack.length; index++){
            $0a18c015b5873b3d$var$onCloseTag($0a18c015b5873b3d$var$stack[index], end - 1);
            $0a18c015b5873b3d$var$emitError(24, $0a18c015b5873b3d$var$stack[index].loc.start.offset);
        }
    },
    oncdata (start, end) {
        if ($0a18c015b5873b3d$var$stack[0].ns !== 0) $0a18c015b5873b3d$var$onText($0a18c015b5873b3d$var$getSlice(start, end), start, end);
        else $0a18c015b5873b3d$var$emitError(1, start - 9);
    },
    onprocessinginstruction (start) {
        if (($0a18c015b5873b3d$var$stack[0] ? $0a18c015b5873b3d$var$stack[0].ns : $0a18c015b5873b3d$var$currentOptions.ns) === 0) $0a18c015b5873b3d$var$emitError(21, start - 1);
    }
});
const $0a18c015b5873b3d$var$forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
const $0a18c015b5873b3d$var$stripParensRE = /^\(|\)$/g;
function $0a18c015b5873b3d$var$parseForExpression(input) {
    const loc = input.loc;
    const exp = input.content;
    const inMatch = exp.match($0a18c015b5873b3d$export$a81a10be31983be5);
    if (!inMatch) return;
    const [, LHS, RHS] = inMatch;
    const createAliasExpression = (content, offset, asParam = false)=>{
        const start = loc.start.offset + offset;
        const end = start + content.length;
        return $0a18c015b5873b3d$var$createExp(content, false, $0a18c015b5873b3d$var$getLoc(start, end), 0, asParam ? 1 /* Params */  : 0 /* Normal */ );
    };
    const result = {
        source: createAliasExpression(RHS.trim(), exp.indexOf(RHS, LHS.length)),
        value: void 0,
        key: void 0,
        index: void 0,
        finalized: false
    };
    let valueContent = LHS.trim().replace($0a18c015b5873b3d$var$stripParensRE, "").trim();
    const trimmedOffset = LHS.indexOf(valueContent);
    const iteratorMatch = valueContent.match($0a18c015b5873b3d$var$forIteratorRE);
    if (iteratorMatch) {
        valueContent = valueContent.replace($0a18c015b5873b3d$var$forIteratorRE, "").trim();
        const keyContent = iteratorMatch[1].trim();
        let keyOffset;
        if (keyContent) {
            keyOffset = exp.indexOf(keyContent, trimmedOffset + valueContent.length);
            result.key = createAliasExpression(keyContent, keyOffset, true);
        }
        if (iteratorMatch[2]) {
            const indexContent = iteratorMatch[2].trim();
            if (indexContent) result.index = createAliasExpression(indexContent, exp.indexOf(indexContent, result.key ? keyOffset + keyContent.length : trimmedOffset + valueContent.length), true);
        }
    }
    if (valueContent) result.value = createAliasExpression(valueContent, trimmedOffset, true);
    return result;
}
function $0a18c015b5873b3d$var$getSlice(start, end) {
    return $0a18c015b5873b3d$var$currentInput.slice(start, end);
}
function $0a18c015b5873b3d$var$endOpenTag(end) {
    if ($0a18c015b5873b3d$var$tokenizer.inSFCRoot) $0a18c015b5873b3d$var$currentOpenTag.innerLoc = $0a18c015b5873b3d$var$getLoc(end + 1, end + 1);
    $0a18c015b5873b3d$var$addNode($0a18c015b5873b3d$var$currentOpenTag);
    const { tag: tag, ns: ns } = $0a18c015b5873b3d$var$currentOpenTag;
    if (ns === 0 && $0a18c015b5873b3d$var$currentOptions.isPreTag(tag)) $0a18c015b5873b3d$var$inPre++;
    if ($0a18c015b5873b3d$var$currentOptions.isVoidTag(tag)) $0a18c015b5873b3d$var$onCloseTag($0a18c015b5873b3d$var$currentOpenTag, end);
    else {
        $0a18c015b5873b3d$var$stack.unshift($0a18c015b5873b3d$var$currentOpenTag);
        if (ns === 1 || ns === 2) $0a18c015b5873b3d$var$tokenizer.inXML = true;
    }
    $0a18c015b5873b3d$var$currentOpenTag = null;
}
function $0a18c015b5873b3d$var$onText(content, start, end) {
    {
        const tag = $0a18c015b5873b3d$var$stack[0] && $0a18c015b5873b3d$var$stack[0].tag;
        if (tag !== "script" && tag !== "style" && content.includes("&")) content = $0a18c015b5873b3d$var$currentOptions.decodeEntities(content, false);
    }
    const parent = $0a18c015b5873b3d$var$stack[0] || $0a18c015b5873b3d$var$currentRoot;
    const lastNode = parent.children[parent.children.length - 1];
    if (lastNode && lastNode.type === 2) {
        lastNode.content += content;
        $0a18c015b5873b3d$var$setLocEnd(lastNode.loc, end);
    } else parent.children.push({
        type: 2,
        content: content,
        loc: $0a18c015b5873b3d$var$getLoc(start, end)
    });
}
function $0a18c015b5873b3d$var$onCloseTag(el, end, isImplied = false) {
    if (isImplied) $0a18c015b5873b3d$var$setLocEnd(el.loc, $0a18c015b5873b3d$var$backTrack(end, 60));
    else $0a18c015b5873b3d$var$setLocEnd(el.loc, $0a18c015b5873b3d$var$lookAhead(end, 62) + 1);
    if ($0a18c015b5873b3d$var$tokenizer.inSFCRoot) {
        if (el.children.length) el.innerLoc.end = (0, $a5gC8.extend)({}, el.children[el.children.length - 1].loc.end);
        else el.innerLoc.end = (0, $a5gC8.extend)({}, el.innerLoc.start);
        el.innerLoc.source = $0a18c015b5873b3d$var$getSlice(el.innerLoc.start.offset, el.innerLoc.end.offset);
    }
    const { tag: tag, ns: ns, children: children } = el;
    if (!$0a18c015b5873b3d$var$inVPre) {
        if (tag === "slot") el.tagType = 2;
        else if ($0a18c015b5873b3d$var$isFragmentTemplate(el)) el.tagType = 3;
        else if ($0a18c015b5873b3d$var$isComponent(el)) el.tagType = 1;
    }
    if (!$0a18c015b5873b3d$var$tokenizer.inRCDATA) el.children = $0a18c015b5873b3d$var$condenseWhitespace(children);
    if (ns === 0 && $0a18c015b5873b3d$var$currentOptions.isIgnoreNewlineTag(tag)) {
        const first = children[0];
        if (first && first.type === 2) first.content = first.content.replace(/^\r?\n/, "");
    }
    if (ns === 0 && $0a18c015b5873b3d$var$currentOptions.isPreTag(tag)) $0a18c015b5873b3d$var$inPre--;
    if ($0a18c015b5873b3d$var$currentVPreBoundary === el) {
        $0a18c015b5873b3d$var$inVPre = $0a18c015b5873b3d$var$tokenizer.inVPre = false;
        $0a18c015b5873b3d$var$currentVPreBoundary = null;
    }
    if ($0a18c015b5873b3d$var$tokenizer.inXML && ($0a18c015b5873b3d$var$stack[0] ? $0a18c015b5873b3d$var$stack[0].ns : $0a18c015b5873b3d$var$currentOptions.ns) === 0) $0a18c015b5873b3d$var$tokenizer.inXML = false;
    {
        const props = el.props;
        if (!$0a18c015b5873b3d$var$tokenizer.inSFCRoot && $0a18c015b5873b3d$var$isCompatEnabled("COMPILER_NATIVE_TEMPLATE", $0a18c015b5873b3d$var$currentOptions) && el.tag === "template" && !$0a18c015b5873b3d$var$isFragmentTemplate(el)) {
            const parent = $0a18c015b5873b3d$var$stack[0] || $0a18c015b5873b3d$var$currentRoot;
            const index = parent.children.indexOf(el);
            parent.children.splice(index, 1, ...el.children);
        }
        const inlineTemplateProp = props.find((p)=>p.type === 6 && p.name === "inline-template");
        if (inlineTemplateProp && $0a18c015b5873b3d$export$1b1c14b93fcc0fe4("COMPILER_INLINE_TEMPLATE", $0a18c015b5873b3d$var$currentOptions, inlineTemplateProp.loc) && el.children.length) inlineTemplateProp.value = {
            type: 2,
            content: $0a18c015b5873b3d$var$getSlice(el.children[0].loc.start.offset, el.children[el.children.length - 1].loc.end.offset),
            loc: inlineTemplateProp.loc
        };
    }
}
function $0a18c015b5873b3d$var$lookAhead(index, c) {
    let i = index;
    while($0a18c015b5873b3d$var$currentInput.charCodeAt(i) !== c && i < $0a18c015b5873b3d$var$currentInput.length - 1)i++;
    return i;
}
function $0a18c015b5873b3d$var$backTrack(index, c) {
    let i = index;
    while($0a18c015b5873b3d$var$currentInput.charCodeAt(i) !== c && i >= 0)i--;
    return i;
}
const $0a18c015b5873b3d$var$specialTemplateDir = /* @__PURE__ */ new Set([
    "if",
    "else",
    "else-if",
    "for",
    "slot"
]);
function $0a18c015b5873b3d$var$isFragmentTemplate({ tag: tag, props: props }) {
    if (tag === "template") for(let i = 0; i < props.length; i++){
        if (props[i].type === 7 && $0a18c015b5873b3d$var$specialTemplateDir.has(props[i].name)) return true;
    }
    return false;
}
function $0a18c015b5873b3d$var$isComponent({ tag: tag, props: props }) {
    if ($0a18c015b5873b3d$var$currentOptions.isCustomElement(tag)) return false;
    if (tag === "component" || $0a18c015b5873b3d$var$isUpperCase(tag.charCodeAt(0)) || $0a18c015b5873b3d$export$69768c9b514a01e9(tag) || $0a18c015b5873b3d$var$currentOptions.isBuiltInComponent && $0a18c015b5873b3d$var$currentOptions.isBuiltInComponent(tag) || $0a18c015b5873b3d$var$currentOptions.isNativeTag && !$0a18c015b5873b3d$var$currentOptions.isNativeTag(tag)) return true;
    for(let i = 0; i < props.length; i++){
        const p = props[i];
        if (p.type === 6) {
            if (p.name === "is" && p.value) {
                if (p.value.content.startsWith("vue:")) return true;
                else if ($0a18c015b5873b3d$export$1b1c14b93fcc0fe4("COMPILER_IS_ON_ELEMENT", $0a18c015b5873b3d$var$currentOptions, p.loc)) return true;
            }
        } else if (p.name === "bind" && $0a18c015b5873b3d$export$45cac5109adb5e55(p.arg, "is") && $0a18c015b5873b3d$export$1b1c14b93fcc0fe4("COMPILER_IS_ON_ELEMENT", $0a18c015b5873b3d$var$currentOptions, p.loc)) return true;
    }
    return false;
}
function $0a18c015b5873b3d$var$isUpperCase(c) {
    return c > 64 && c < 91;
}
const $0a18c015b5873b3d$var$windowsNewlineRE = /\r\n/g;
function $0a18c015b5873b3d$var$condenseWhitespace(nodes, tag) {
    const shouldCondense = $0a18c015b5873b3d$var$currentOptions.whitespace !== "preserve";
    let removedWhitespace = false;
    for(let i = 0; i < nodes.length; i++){
        const node = nodes[i];
        if (node.type === 2) {
            if (!$0a18c015b5873b3d$var$inPre) {
                if ($0a18c015b5873b3d$var$isAllWhitespace(node.content)) {
                    const prev = nodes[i - 1] && nodes[i - 1].type;
                    const next = nodes[i + 1] && nodes[i + 1].type;
                    if (!prev || !next || shouldCondense && (prev === 3 && (next === 3 || next === 1) || prev === 1 && (next === 3 || next === 1 && $0a18c015b5873b3d$var$hasNewlineChar(node.content)))) {
                        removedWhitespace = true;
                        nodes[i] = null;
                    } else node.content = " ";
                } else if (shouldCondense) node.content = $0a18c015b5873b3d$var$condense(node.content);
            } else node.content = node.content.replace($0a18c015b5873b3d$var$windowsNewlineRE, "\n");
        }
    }
    return removedWhitespace ? nodes.filter(Boolean) : nodes;
}
function $0a18c015b5873b3d$var$isAllWhitespace(str) {
    for(let i = 0; i < str.length; i++){
        if (!$0a18c015b5873b3d$var$isWhitespace(str.charCodeAt(i))) return false;
    }
    return true;
}
function $0a18c015b5873b3d$var$hasNewlineChar(str) {
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c === 10 || c === 13) return true;
    }
    return false;
}
function $0a18c015b5873b3d$var$condense(str) {
    let ret = "";
    let prevCharIsWhitespace = false;
    for(let i = 0; i < str.length; i++){
        if ($0a18c015b5873b3d$var$isWhitespace(str.charCodeAt(i))) {
            if (!prevCharIsWhitespace) {
                ret += " ";
                prevCharIsWhitespace = true;
            }
        } else {
            ret += str[i];
            prevCharIsWhitespace = false;
        }
    }
    return ret;
}
function $0a18c015b5873b3d$var$addNode(node) {
    ($0a18c015b5873b3d$var$stack[0] || $0a18c015b5873b3d$var$currentRoot).children.push(node);
}
function $0a18c015b5873b3d$var$getLoc(start, end) {
    return {
        start: $0a18c015b5873b3d$var$tokenizer.getPos(start),
        // @ts-expect-error allow late attachment
        end: end == null ? end : $0a18c015b5873b3d$var$tokenizer.getPos(end),
        // @ts-expect-error allow late attachment
        source: end == null ? end : $0a18c015b5873b3d$var$getSlice(start, end)
    };
}
function $0a18c015b5873b3d$var$cloneLoc(loc) {
    return $0a18c015b5873b3d$var$getLoc(loc.start.offset, loc.end.offset);
}
function $0a18c015b5873b3d$var$setLocEnd(loc, end) {
    loc.end = $0a18c015b5873b3d$var$tokenizer.getPos(end);
    loc.source = $0a18c015b5873b3d$var$getSlice(loc.start.offset, end);
}
function $0a18c015b5873b3d$var$dirToAttr(dir) {
    const attr = {
        type: 6,
        name: dir.rawName,
        nameLoc: $0a18c015b5873b3d$var$getLoc(dir.loc.start.offset, dir.loc.start.offset + dir.rawName.length),
        value: void 0,
        loc: dir.loc
    };
    if (dir.exp) {
        const loc = dir.exp.loc;
        if (loc.end.offset < dir.loc.end.offset) {
            loc.start.offset--;
            loc.start.column--;
            loc.end.offset++;
            loc.end.column++;
        }
        attr.value = {
            type: 2,
            content: dir.exp.content,
            loc: loc
        };
    }
    return attr;
}
function $0a18c015b5873b3d$var$createExp(content, isStatic = false, loc, constType = 0, parseMode = 0 /* Normal */ ) {
    const exp = $0a18c015b5873b3d$export$ac2aa689b44cdd23(content, isStatic, loc, constType);
    return exp;
}
function $0a18c015b5873b3d$var$emitError(code, index, message) {
    $0a18c015b5873b3d$var$currentOptions.onError($0a18c015b5873b3d$export$57c5a5dc5aa19bdf(code, $0a18c015b5873b3d$var$getLoc(index, index), void 0, message));
}
function $0a18c015b5873b3d$var$reset() {
    $0a18c015b5873b3d$var$tokenizer.reset();
    $0a18c015b5873b3d$var$currentOpenTag = null;
    $0a18c015b5873b3d$var$currentProp = null;
    $0a18c015b5873b3d$var$currentAttrValue = "";
    $0a18c015b5873b3d$var$currentAttrStartIndex = -1;
    $0a18c015b5873b3d$var$currentAttrEndIndex = -1;
    $0a18c015b5873b3d$var$stack.length = 0;
}
function $0a18c015b5873b3d$export$f5f219d5f09c81b5(input, options) {
    $0a18c015b5873b3d$var$reset();
    $0a18c015b5873b3d$var$currentInput = input;
    $0a18c015b5873b3d$var$currentOptions = (0, $a5gC8.extend)({}, $0a18c015b5873b3d$var$defaultParserOptions);
    if (options) {
        let key;
        for(key in options)if (options[key] != null) $0a18c015b5873b3d$var$currentOptions[key] = options[key];
    }
    $0a18c015b5873b3d$var$tokenizer.mode = $0a18c015b5873b3d$var$currentOptions.parseMode === "html" ? 1 : $0a18c015b5873b3d$var$currentOptions.parseMode === "sfc" ? 2 : 0;
    $0a18c015b5873b3d$var$tokenizer.inXML = $0a18c015b5873b3d$var$currentOptions.ns === 1 || $0a18c015b5873b3d$var$currentOptions.ns === 2;
    const delimiters = options && options.delimiters;
    if (delimiters) {
        $0a18c015b5873b3d$var$tokenizer.delimiterOpen = $0a18c015b5873b3d$var$toCharCodes(delimiters[0]);
        $0a18c015b5873b3d$var$tokenizer.delimiterClose = $0a18c015b5873b3d$var$toCharCodes(delimiters[1]);
    }
    const root = $0a18c015b5873b3d$var$currentRoot = $0a18c015b5873b3d$export$882461b6382ed46c([], input);
    $0a18c015b5873b3d$var$tokenizer.parse($0a18c015b5873b3d$var$currentInput);
    root.loc = $0a18c015b5873b3d$var$getLoc(0, input.length);
    root.children = $0a18c015b5873b3d$var$condenseWhitespace(root.children);
    $0a18c015b5873b3d$var$currentRoot = null;
    return root;
}
function $0a18c015b5873b3d$var$cacheStatic(root, context) {
    $0a18c015b5873b3d$var$walk(root, void 0, context, // Root node is unfortunately non-hoistable due to potential parent
    // fallthrough attributes.
    $0a18c015b5873b3d$var$isSingleElementRoot(root, root.children[0]));
}
function $0a18c015b5873b3d$var$isSingleElementRoot(root, child) {
    const { children: children } = root;
    return children.length === 1 && child.type === 1 && !$0a18c015b5873b3d$export$45f38ad7fffc9b53(child);
}
function $0a18c015b5873b3d$var$walk(node, parent, context, doNotHoistNode = false, inFor = false) {
    const { children: children } = node;
    const toCache = [];
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if (child.type === 1 && child.tagType === 0) {
            const constantType = doNotHoistNode ? 0 : $0a18c015b5873b3d$export$7967f5197c38d72a(child, context);
            if (constantType > 0) {
                if (constantType >= 2) {
                    child.codegenNode.patchFlag = -1;
                    toCache.push(child);
                    continue;
                }
            } else {
                const codegenNode = child.codegenNode;
                if (codegenNode.type === 13) {
                    const flag = codegenNode.patchFlag;
                    if ((flag === void 0 || flag === 512 || flag === 1) && $0a18c015b5873b3d$var$getGeneratedPropsConstantType(child, context) >= 2) {
                        const props = $0a18c015b5873b3d$var$getNodeProps(child);
                        if (props) codegenNode.props = context.hoist(props);
                    }
                    if (codegenNode.dynamicProps) codegenNode.dynamicProps = context.hoist(codegenNode.dynamicProps);
                }
            }
        } else if (child.type === 12) {
            const constantType = doNotHoistNode ? 0 : $0a18c015b5873b3d$export$7967f5197c38d72a(child, context);
            if (constantType >= 2) {
                toCache.push(child);
                continue;
            }
        }
        if (child.type === 1) {
            const isComponent = child.tagType === 1;
            if (isComponent) context.scopes.vSlot++;
            $0a18c015b5873b3d$var$walk(child, node, context, false, inFor);
            if (isComponent) context.scopes.vSlot--;
        } else if (child.type === 11) $0a18c015b5873b3d$var$walk(child, node, context, child.children.length === 1, true);
        else if (child.type === 9) for(let i2 = 0; i2 < child.branches.length; i2++)$0a18c015b5873b3d$var$walk(child.branches[i2], node, context, child.branches[i2].children.length === 1, inFor);
    }
    let cachedAsArray = false;
    if (toCache.length === children.length && node.type === 1) {
        if (node.tagType === 0 && node.codegenNode && node.codegenNode.type === 13 && (0, $a5gC8.isArray)(node.codegenNode.children)) {
            node.codegenNode.children = getCacheExpression($0a18c015b5873b3d$export$c887713da9895dbb(node.codegenNode.children));
            cachedAsArray = true;
        } else if (node.tagType === 1 && node.codegenNode && node.codegenNode.type === 13 && node.codegenNode.children && !(0, $a5gC8.isArray)(node.codegenNode.children) && node.codegenNode.children.type === 15) {
            const slot = getSlotNode(node.codegenNode, "default");
            if (slot) {
                slot.returns = getCacheExpression($0a18c015b5873b3d$export$c887713da9895dbb(slot.returns));
                cachedAsArray = true;
            }
        } else if (node.tagType === 3 && parent && parent.type === 1 && parent.tagType === 1 && parent.codegenNode && parent.codegenNode.type === 13 && parent.codegenNode.children && !(0, $a5gC8.isArray)(parent.codegenNode.children) && parent.codegenNode.children.type === 15) {
            const slotName = $0a18c015b5873b3d$export$1199bc2a2b648c8c(node, "slot", true);
            const slot = slotName && slotName.arg && getSlotNode(parent.codegenNode, slotName.arg);
            if (slot) {
                slot.returns = getCacheExpression($0a18c015b5873b3d$export$c887713da9895dbb(slot.returns));
                cachedAsArray = true;
            }
        }
    }
    if (!cachedAsArray) for (const child of toCache)child.codegenNode = context.cache(child.codegenNode);
    function getCacheExpression(value) {
        const exp = context.cache(value);
        if (inFor && context.hmr) exp.needArraySpread = true;
        return exp;
    }
    function getSlotNode(node2, name) {
        if (node2.children && !(0, $a5gC8.isArray)(node2.children) && node2.children.type === 15) {
            const slot = node2.children.properties.find((p)=>p.key === name || p.key.content === name);
            return slot && slot.value;
        }
    }
    if (toCache.length && context.transformHoist) context.transformHoist(children, context, node);
}
function $0a18c015b5873b3d$export$7967f5197c38d72a(node, context) {
    const { constantCache: constantCache } = context;
    switch(node.type){
        case 1:
            if (node.tagType !== 0) return 0;
            const cached = constantCache.get(node);
            if (cached !== void 0) return cached;
            const codegenNode = node.codegenNode;
            if (codegenNode.type !== 13) return 0;
            if (codegenNode.isBlock && node.tag !== "svg" && node.tag !== "foreignObject" && node.tag !== "math") return 0;
            if (codegenNode.patchFlag === void 0) {
                let returnType2 = 3;
                const generatedPropsType = $0a18c015b5873b3d$var$getGeneratedPropsConstantType(node, context);
                if (generatedPropsType === 0) {
                    constantCache.set(node, 0);
                    return 0;
                }
                if (generatedPropsType < returnType2) returnType2 = generatedPropsType;
                for(let i = 0; i < node.children.length; i++){
                    const childType = $0a18c015b5873b3d$export$7967f5197c38d72a(node.children[i], context);
                    if (childType === 0) {
                        constantCache.set(node, 0);
                        return 0;
                    }
                    if (childType < returnType2) returnType2 = childType;
                }
                if (returnType2 > 1) for(let i = 0; i < node.props.length; i++){
                    const p = node.props[i];
                    if (p.type === 7 && p.name === "bind" && p.exp) {
                        const expType = $0a18c015b5873b3d$export$7967f5197c38d72a(p.exp, context);
                        if (expType === 0) {
                            constantCache.set(node, 0);
                            return 0;
                        }
                        if (expType < returnType2) returnType2 = expType;
                    }
                }
                if (codegenNode.isBlock) {
                    for(let i = 0; i < node.props.length; i++){
                        const p = node.props[i];
                        if (p.type === 7) {
                            constantCache.set(node, 0);
                            return 0;
                        }
                    }
                    context.removeHelper($0a18c015b5873b3d$export$59578e14f90a15eb);
                    context.removeHelper($0a18c015b5873b3d$export$74fb204a6eba800d(context.inSSR, codegenNode.isComponent));
                    codegenNode.isBlock = false;
                    context.helper($0a18c015b5873b3d$export$3b9fc44425f495a6(context.inSSR, codegenNode.isComponent));
                }
                constantCache.set(node, returnType2);
                return returnType2;
            } else {
                constantCache.set(node, 0);
                return 0;
            }
        case 2:
        case 3:
            return 3;
        case 9:
        case 11:
        case 10:
            return 0;
        case 5:
        case 12:
            return $0a18c015b5873b3d$export$7967f5197c38d72a(node.content, context);
        case 4:
            return node.constType;
        case 8:
            let returnType = 3;
            for(let i = 0; i < node.children.length; i++){
                const child = node.children[i];
                if ((0, $a5gC8.isString)(child) || (0, $a5gC8.isSymbol)(child)) continue;
                const childType = $0a18c015b5873b3d$export$7967f5197c38d72a(child, context);
                if (childType === 0) return 0;
                else if (childType < returnType) returnType = childType;
            }
            return returnType;
        case 20:
            return 2;
        default:
            return 0;
    }
}
const $0a18c015b5873b3d$var$allowHoistedHelperSet = /* @__PURE__ */ new Set([
    $0a18c015b5873b3d$export$6382e3ed89de4e2a,
    $0a18c015b5873b3d$export$b9d3780a9ab822b4,
    $0a18c015b5873b3d$export$78c34c869683dd86,
    $0a18c015b5873b3d$export$7046bb8d3c918928
]);
function $0a18c015b5873b3d$var$getConstantTypeOfHelperCall(value, context) {
    if (value.type === 14 && !(0, $a5gC8.isString)(value.callee) && $0a18c015b5873b3d$var$allowHoistedHelperSet.has(value.callee)) {
        const arg = value.arguments[0];
        if (arg.type === 4) return $0a18c015b5873b3d$export$7967f5197c38d72a(arg, context);
        else if (arg.type === 14) return $0a18c015b5873b3d$var$getConstantTypeOfHelperCall(arg, context);
    }
    return 0;
}
function $0a18c015b5873b3d$var$getGeneratedPropsConstantType(node, context) {
    let returnType = 3;
    const props = $0a18c015b5873b3d$var$getNodeProps(node);
    if (props && props.type === 15) {
        const { properties: properties } = props;
        for(let i = 0; i < properties.length; i++){
            const { key: key, value: value } = properties[i];
            const keyType = $0a18c015b5873b3d$export$7967f5197c38d72a(key, context);
            if (keyType === 0) return keyType;
            if (keyType < returnType) returnType = keyType;
            let valueType;
            if (value.type === 4) valueType = $0a18c015b5873b3d$export$7967f5197c38d72a(value, context);
            else if (value.type === 14) valueType = $0a18c015b5873b3d$var$getConstantTypeOfHelperCall(value, context);
            else valueType = 0;
            if (valueType === 0) return valueType;
            if (valueType < returnType) returnType = valueType;
        }
    }
    return returnType;
}
function $0a18c015b5873b3d$var$getNodeProps(node) {
    const codegenNode = node.codegenNode;
    if (codegenNode.type === 13) return codegenNode.props;
}
function $0a18c015b5873b3d$export$7438cb739e972616(root, { filename: filename = "", prefixIdentifiers: prefixIdentifiers = false, hoistStatic: hoistStatic = false, hmr: hmr = false, cacheHandlers: cacheHandlers = false, nodeTransforms: nodeTransforms = [], directiveTransforms: directiveTransforms = {}, transformHoist: transformHoist = null, isBuiltInComponent: isBuiltInComponent = (0, $a5gC8.NOOP), isCustomElement: isCustomElement = (0, $a5gC8.NOOP), expressionPlugins: expressionPlugins = [], scopeId: scopeId = null, slotted: slotted = true, ssr: ssr = false, inSSR: inSSR = false, ssrCssVars: ssrCssVars = ``, bindingMetadata: bindingMetadata = (0, $a5gC8.EMPTY_OBJ), inline: inline = false, isTS: isTS = false, onError: onError = $0a18c015b5873b3d$var$defaultOnError, onWarn: onWarn = $0a18c015b5873b3d$var$defaultOnWarn, compatConfig: compatConfig }) {
    const nameMatch = filename.replace(/\?.*$/, "").match(/([^/\\]+)\.\w+$/);
    const context = {
        filename: // options
        filename,
        selfName: nameMatch && (0, $a5gC8.capitalize)((0, $a5gC8.camelize)(nameMatch[1])),
        prefixIdentifiers: prefixIdentifiers,
        hoistStatic: hoistStatic,
        hmr: hmr,
        cacheHandlers: cacheHandlers,
        nodeTransforms: nodeTransforms,
        directiveTransforms: directiveTransforms,
        transformHoist: transformHoist,
        isBuiltInComponent: isBuiltInComponent,
        isCustomElement: isCustomElement,
        expressionPlugins: expressionPlugins,
        scopeId: scopeId,
        slotted: slotted,
        ssr: ssr,
        inSSR: inSSR,
        ssrCssVars: ssrCssVars,
        bindingMetadata: bindingMetadata,
        inline: inline,
        isTS: isTS,
        onError: onError,
        onWarn: onWarn,
        compatConfig: compatConfig,
        root: // state
        root,
        helpers: /* @__PURE__ */ new Map(),
        components: /* @__PURE__ */ new Set(),
        directives: /* @__PURE__ */ new Set(),
        hoists: [],
        imports: [],
        cached: [],
        constantCache: /* @__PURE__ */ new WeakMap(),
        temps: 0,
        identifiers: /* @__PURE__ */ Object.create(null),
        scopes: {
            vFor: 0,
            vSlot: 0,
            vPre: 0,
            vOnce: 0
        },
        parent: null,
        grandParent: null,
        currentNode: root,
        childIndex: 0,
        inVOnce: false,
        // methods
        helper (name) {
            const count = context.helpers.get(name) || 0;
            context.helpers.set(name, count + 1);
            return name;
        },
        removeHelper (name) {
            const count = context.helpers.get(name);
            if (count) {
                const currentCount = count - 1;
                if (!currentCount) context.helpers.delete(name);
                else context.helpers.set(name, currentCount);
            }
        },
        helperString (name) {
            return `_${$0a18c015b5873b3d$export$7dc1fc5a07bc9b35[context.helper(name)]}`;
        },
        replaceNode (node) {
            context.parent.children[context.childIndex] = context.currentNode = node;
        },
        removeNode (node) {
            const list = context.parent.children;
            const removalIndex = node ? list.indexOf(node) : context.currentNode ? context.childIndex : -1;
            if (!node || node === context.currentNode) {
                context.currentNode = null;
                context.onNodeRemoved();
            } else if (context.childIndex > removalIndex) {
                context.childIndex--;
                context.onNodeRemoved();
            }
            context.parent.children.splice(removalIndex, 1);
        },
        onNodeRemoved: (0, $a5gC8.NOOP),
        addIdentifiers (exp) {},
        removeIdentifiers (exp) {},
        hoist (exp) {
            if ((0, $a5gC8.isString)(exp)) exp = $0a18c015b5873b3d$export$ac2aa689b44cdd23(exp);
            context.hoists.push(exp);
            const identifier = $0a18c015b5873b3d$export$ac2aa689b44cdd23(`_hoisted_${context.hoists.length}`, false, exp.loc, 2);
            identifier.hoisted = exp;
            return identifier;
        },
        cache (exp, isVNode = false) {
            const cacheExp = $0a18c015b5873b3d$export$4abd162ddf919697(context.cached.length, exp, isVNode);
            context.cached.push(cacheExp);
            return cacheExp;
        }
    };
    context.filters = /* @__PURE__ */ new Set();
    return context;
}
function $0a18c015b5873b3d$export$51186ad6e864892a(root, options) {
    const context = $0a18c015b5873b3d$export$7438cb739e972616(root, options);
    $0a18c015b5873b3d$export$c9d429747c1011af(root, context);
    if (options.hoistStatic) $0a18c015b5873b3d$var$cacheStatic(root, context);
    if (!options.ssr) $0a18c015b5873b3d$var$createRootCodegen(root, context);
    root.helpers = /* @__PURE__ */ new Set([
        ...context.helpers.keys()
    ]);
    root.components = [
        ...context.components
    ];
    root.directives = [
        ...context.directives
    ];
    root.imports = context.imports;
    root.hoists = context.hoists;
    root.temps = context.temps;
    root.cached = context.cached;
    root.transformed = true;
    root.filters = [
        ...context.filters
    ];
}
function $0a18c015b5873b3d$var$createRootCodegen(root, context) {
    const { helper: helper } = context;
    const { children: children } = root;
    if (children.length === 1) {
        const child = children[0];
        if ($0a18c015b5873b3d$var$isSingleElementRoot(root, child) && child.codegenNode) {
            const codegenNode = child.codegenNode;
            if (codegenNode.type === 13) $0a18c015b5873b3d$export$dc00c05f515bd739(codegenNode, context);
            root.codegenNode = codegenNode;
        } else root.codegenNode = child;
    } else if (children.length > 1) {
        let patchFlag = 64;
        root.codegenNode = $0a18c015b5873b3d$export$d1cb722ac2a8b632(context, helper($0a18c015b5873b3d$export$4bebefc40c8513e8), void 0, root.children, patchFlag, void 0, void 0, true, void 0, false);
    }
}
function $0a18c015b5873b3d$var$traverseChildren(parent, context) {
    let i = 0;
    const nodeRemoved = ()=>{
        i--;
    };
    for(; i < parent.children.length; i++){
        const child = parent.children[i];
        if ((0, $a5gC8.isString)(child)) continue;
        context.grandParent = context.parent;
        context.parent = parent;
        context.childIndex = i;
        context.onNodeRemoved = nodeRemoved;
        $0a18c015b5873b3d$export$c9d429747c1011af(child, context);
    }
}
function $0a18c015b5873b3d$export$c9d429747c1011af(node, context) {
    context.currentNode = node;
    const { nodeTransforms: nodeTransforms } = context;
    const exitFns = [];
    for(let i2 = 0; i2 < nodeTransforms.length; i2++){
        const onExit = nodeTransforms[i2](node, context);
        if (onExit) {
            if ((0, $a5gC8.isArray)(onExit)) exitFns.push(...onExit);
            else exitFns.push(onExit);
        }
        if (!context.currentNode) return;
        else node = context.currentNode;
    }
    switch(node.type){
        case 3:
            if (!context.ssr) context.helper($0a18c015b5873b3d$export$b2aae42fb0a19db3);
            break;
        case 5:
            if (!context.ssr) context.helper($0a18c015b5873b3d$export$68f5914cce0a5680);
            break;
        // for container types, further traverse downwards
        case 9:
            for(let i2 = 0; i2 < node.branches.length; i2++)$0a18c015b5873b3d$export$c9d429747c1011af(node.branches[i2], context);
            break;
        case 10:
        case 11:
        case 1:
        case 0:
            $0a18c015b5873b3d$var$traverseChildren(node, context);
            break;
    }
    context.currentNode = node;
    let i = exitFns.length;
    while(i--)exitFns[i]();
}
function $0a18c015b5873b3d$export$aee0887cf96094d7(name, fn) {
    const matches = (0, $a5gC8.isString)(name) ? (n)=>n === name : (n)=>name.test(n);
    return (node, context)=>{
        if (node.type === 1) {
            const { props: props } = node;
            if (node.tagType === 3 && props.some($0a18c015b5873b3d$export$eaf8991bb8af8cbb)) return;
            const exitFns = [];
            for(let i = 0; i < props.length; i++){
                const prop = props[i];
                if (prop.type === 7 && matches(prop.name)) {
                    props.splice(i, 1);
                    i--;
                    const onExit = fn(node, prop, context);
                    if (onExit) exitFns.push(onExit);
                }
            }
            return exitFns;
        }
    };
}
const $0a18c015b5873b3d$var$PURE_ANNOTATION = `/*@__PURE__*/`;
const $0a18c015b5873b3d$var$aliasHelper = (s)=>`${$0a18c015b5873b3d$export$7dc1fc5a07bc9b35[s]}: _${$0a18c015b5873b3d$export$7dc1fc5a07bc9b35[s]}`;
function $0a18c015b5873b3d$var$createCodegenContext(ast, { mode: mode = "function", prefixIdentifiers: prefixIdentifiers = mode === "module", sourceMap: sourceMap = false, filename: filename = `template.vue.html`, scopeId: scopeId = null, optimizeImports: optimizeImports = false, runtimeGlobalName: runtimeGlobalName = `Vue`, runtimeModuleName: runtimeModuleName = `vue`, ssrRuntimeModuleName: ssrRuntimeModuleName = "vue/server-renderer", ssr: ssr = false, isTS: isTS = false, inSSR: inSSR = false }) {
    const context = {
        mode: mode,
        prefixIdentifiers: prefixIdentifiers,
        sourceMap: sourceMap,
        filename: filename,
        scopeId: scopeId,
        optimizeImports: optimizeImports,
        runtimeGlobalName: runtimeGlobalName,
        runtimeModuleName: runtimeModuleName,
        ssrRuntimeModuleName: ssrRuntimeModuleName,
        ssr: ssr,
        isTS: isTS,
        inSSR: inSSR,
        source: ast.source,
        code: ``,
        column: 1,
        line: 1,
        offset: 0,
        indentLevel: 0,
        pure: false,
        map: void 0,
        helper (key) {
            return `_${$0a18c015b5873b3d$export$7dc1fc5a07bc9b35[key]}`;
        },
        push (code, newlineIndex = -2 /* None */ , node) {
            context.code += code;
        },
        indent () {
            newline(++context.indentLevel);
        },
        deindent (withoutNewLine = false) {
            if (withoutNewLine) --context.indentLevel;
            else newline(--context.indentLevel);
        },
        newline () {
            newline(context.indentLevel);
        }
    };
    function newline(n) {
        context.push("\n" + `  `.repeat(n), 0 /* Start */ );
    }
    return context;
}
function $0a18c015b5873b3d$export$80d376111cc09ad7(ast, options = {}) {
    const context = $0a18c015b5873b3d$var$createCodegenContext(ast, options);
    if (options.onContextCreated) options.onContextCreated(context);
    const { mode: mode, push: push, prefixIdentifiers: prefixIdentifiers, indent: indent, deindent: deindent, newline: newline, scopeId: scopeId, ssr: ssr } = context;
    const helpers = Array.from(ast.helpers);
    const hasHelpers = helpers.length > 0;
    const useWithBlock = !prefixIdentifiers && mode !== "module";
    const preambleContext = context;
    $0a18c015b5873b3d$var$genFunctionPreamble(ast, preambleContext);
    const functionName = ssr ? `ssrRender` : `render`;
    const args = ssr ? [
        "_ctx",
        "_push",
        "_parent",
        "_attrs"
    ] : [
        "_ctx",
        "_cache"
    ];
    const signature = args.join(", ");
    push(`function ${functionName}(${signature}) {`);
    indent();
    if (useWithBlock) {
        push(`with (_ctx) {`);
        indent();
        if (hasHelpers) {
            push(`const { ${helpers.map($0a18c015b5873b3d$var$aliasHelper).join(", ")} } = _Vue
`, -1 /* End */ );
            newline();
        }
    }
    if (ast.components.length) {
        $0a18c015b5873b3d$var$genAssets(ast.components, "component", context);
        if (ast.directives.length || ast.temps > 0) newline();
    }
    if (ast.directives.length) {
        $0a18c015b5873b3d$var$genAssets(ast.directives, "directive", context);
        if (ast.temps > 0) newline();
    }
    if (ast.filters && ast.filters.length) {
        newline();
        $0a18c015b5873b3d$var$genAssets(ast.filters, "filter", context);
        newline();
    }
    if (ast.temps > 0) {
        push(`let `);
        for(let i = 0; i < ast.temps; i++)push(`${i > 0 ? `, ` : ``}_temp${i}`);
    }
    if (ast.components.length || ast.directives.length || ast.temps) {
        push(`
`, 0 /* Start */ );
        newline();
    }
    if (!ssr) push(`return `);
    if (ast.codegenNode) $0a18c015b5873b3d$var$genNode(ast.codegenNode, context);
    else push(`null`);
    if (useWithBlock) {
        deindent();
        push(`}`);
    }
    deindent();
    push(`}`);
    return {
        ast: ast,
        code: context.code,
        preamble: ``,
        map: context.map ? context.map.toJSON() : void 0
    };
}
function $0a18c015b5873b3d$var$genFunctionPreamble(ast, context) {
    const { ssr: ssr, prefixIdentifiers: prefixIdentifiers, push: push, newline: newline, runtimeModuleName: runtimeModuleName, runtimeGlobalName: runtimeGlobalName, ssrRuntimeModuleName: ssrRuntimeModuleName } = context;
    const VueBinding = runtimeGlobalName;
    const helpers = Array.from(ast.helpers);
    if (helpers.length > 0) {
        push(`const _Vue = ${VueBinding}
`, -1 /* End */ );
        if (ast.hoists.length) {
            const staticHelpers = [
                $0a18c015b5873b3d$export$6db5bf2474139178,
                $0a18c015b5873b3d$export$b22e7e78da20c982,
                $0a18c015b5873b3d$export$b2aae42fb0a19db3,
                $0a18c015b5873b3d$export$8890896270dfc293,
                $0a18c015b5873b3d$export$1a493e4b98fdcf3
            ].filter((helper)=>helpers.includes(helper)).map($0a18c015b5873b3d$var$aliasHelper).join(", ");
            push(`const { ${staticHelpers} } = _Vue
`, -1 /* End */ );
        }
    }
    $0a18c015b5873b3d$var$genHoists(ast.hoists, context);
    newline();
    push(`return `);
}
function $0a18c015b5873b3d$var$genAssets(assets, type, { helper: helper, push: push, newline: newline, isTS: isTS }) {
    const resolver = helper(type === "filter" ? $0a18c015b5873b3d$export$2c190751e09c3969 : type === "component" ? $0a18c015b5873b3d$export$28c52e95383d270 : $0a18c015b5873b3d$export$7f3ccc2ef793ecce);
    for(let i = 0; i < assets.length; i++){
        let id = assets[i];
        const maybeSelfReference = id.endsWith("__self");
        if (maybeSelfReference) id = id.slice(0, -6);
        push(`const ${$0a18c015b5873b3d$export$80505c1072df544f(id, type)} = ${resolver}(${JSON.stringify(id)}${maybeSelfReference ? `, true` : ``})${isTS ? `!` : ``}`);
        if (i < assets.length - 1) newline();
    }
}
function $0a18c015b5873b3d$var$genHoists(hoists, context) {
    if (!hoists.length) return;
    context.pure = true;
    const { push: push, newline: newline } = context;
    newline();
    for(let i = 0; i < hoists.length; i++){
        const exp = hoists[i];
        if (exp) {
            push(`const _hoisted_${i + 1} = `);
            $0a18c015b5873b3d$var$genNode(exp, context);
            newline();
        }
    }
    context.pure = false;
}
function $0a18c015b5873b3d$var$isText(n) {
    return (0, $a5gC8.isString)(n) || n.type === 4 || n.type === 2 || n.type === 5 || n.type === 8;
}
function $0a18c015b5873b3d$var$genNodeListAsArray(nodes, context) {
    const multilines = nodes.length > 3 || false;
    context.push(`[`);
    multilines && context.indent();
    $0a18c015b5873b3d$var$genNodeList(nodes, context, multilines);
    multilines && context.deindent();
    context.push(`]`);
}
function $0a18c015b5873b3d$var$genNodeList(nodes, context, multilines = false, comma = true) {
    const { push: push, newline: newline } = context;
    for(let i = 0; i < nodes.length; i++){
        const node = nodes[i];
        if ((0, $a5gC8.isString)(node)) push(node, -3 /* Unknown */ );
        else if ((0, $a5gC8.isArray)(node)) $0a18c015b5873b3d$var$genNodeListAsArray(node, context);
        else $0a18c015b5873b3d$var$genNode(node, context);
        if (i < nodes.length - 1) {
            if (multilines) {
                comma && push(",");
                newline();
            } else comma && push(", ");
        }
    }
}
function $0a18c015b5873b3d$var$genNode(node, context) {
    if ((0, $a5gC8.isString)(node)) {
        context.push(node, -3 /* Unknown */ );
        return;
    }
    if ((0, $a5gC8.isSymbol)(node)) {
        context.push(context.helper(node));
        return;
    }
    switch(node.type){
        case 1:
        case 9:
        case 11:
            $0a18c015b5873b3d$var$genNode(node.codegenNode, context);
            break;
        case 2:
            $0a18c015b5873b3d$var$genText(node, context);
            break;
        case 4:
            $0a18c015b5873b3d$var$genExpression(node, context);
            break;
        case 5:
            $0a18c015b5873b3d$var$genInterpolation(node, context);
            break;
        case 12:
            $0a18c015b5873b3d$var$genNode(node.codegenNode, context);
            break;
        case 8:
            $0a18c015b5873b3d$var$genCompoundExpression(node, context);
            break;
        case 3:
            $0a18c015b5873b3d$var$genComment(node, context);
            break;
        case 13:
            $0a18c015b5873b3d$var$genVNodeCall(node, context);
            break;
        case 14:
            $0a18c015b5873b3d$var$genCallExpression(node, context);
            break;
        case 15:
            $0a18c015b5873b3d$var$genObjectExpression(node, context);
            break;
        case 17:
            $0a18c015b5873b3d$var$genArrayExpression(node, context);
            break;
        case 18:
            $0a18c015b5873b3d$var$genFunctionExpression(node, context);
            break;
        case 19:
            $0a18c015b5873b3d$var$genConditionalExpression(node, context);
            break;
        case 20:
            $0a18c015b5873b3d$var$genCacheExpression(node, context);
            break;
        case 21:
            $0a18c015b5873b3d$var$genNodeList(node.body, context, true, false);
            break;
        // SSR only types
        case 22:
            break;
        case 23:
            break;
        case 24:
            break;
        case 25:
            break;
        case 26:
            break;
        /* v8 ignore start */ case 10:
            break;
        default:
    }
}
function $0a18c015b5873b3d$var$genText(node, context) {
    context.push(JSON.stringify(node.content), -3 /* Unknown */ , node);
}
function $0a18c015b5873b3d$var$genExpression(node, context) {
    const { content: content, isStatic: isStatic } = node;
    context.push(isStatic ? JSON.stringify(content) : content, -3 /* Unknown */ , node);
}
function $0a18c015b5873b3d$var$genInterpolation(node, context) {
    const { push: push, helper: helper, pure: pure } = context;
    if (pure) push($0a18c015b5873b3d$var$PURE_ANNOTATION);
    push(`${helper($0a18c015b5873b3d$export$68f5914cce0a5680)}(`);
    $0a18c015b5873b3d$var$genNode(node.content, context);
    push(`)`);
}
function $0a18c015b5873b3d$var$genCompoundExpression(node, context) {
    for(let i = 0; i < node.children.length; i++){
        const child = node.children[i];
        if ((0, $a5gC8.isString)(child)) context.push(child, -3 /* Unknown */ );
        else $0a18c015b5873b3d$var$genNode(child, context);
    }
}
function $0a18c015b5873b3d$var$genExpressionAsPropertyKey(node, context) {
    const { push: push } = context;
    if (node.type === 8) {
        push(`[`);
        $0a18c015b5873b3d$var$genCompoundExpression(node, context);
        push(`]`);
    } else if (node.isStatic) {
        const text = $0a18c015b5873b3d$export$3cb8486ad206c65(node.content) ? node.content : JSON.stringify(node.content);
        push(text, -2 /* None */ , node);
    } else push(`[${node.content}]`, -3 /* Unknown */ , node);
}
function $0a18c015b5873b3d$var$genComment(node, context) {
    const { push: push, helper: helper, pure: pure } = context;
    if (pure) push($0a18c015b5873b3d$var$PURE_ANNOTATION);
    push(`${helper($0a18c015b5873b3d$export$b2aae42fb0a19db3)}(${JSON.stringify(node.content)})`, -3 /* Unknown */ , node);
}
function $0a18c015b5873b3d$var$genVNodeCall(node, context) {
    const { push: push, helper: helper, pure: pure } = context;
    const { tag: tag, props: props, children: children, patchFlag: patchFlag, dynamicProps: dynamicProps, directives: directives, isBlock: isBlock, disableTracking: disableTracking, isComponent: isComponent } = node;
    let patchFlagString;
    if (patchFlag) patchFlagString = String(patchFlag);
    if (directives) push(helper($0a18c015b5873b3d$export$a5e4c1729e50ed6d) + `(`);
    if (isBlock) push(`(${helper($0a18c015b5873b3d$export$59578e14f90a15eb)}(${disableTracking ? `true` : ``}), `);
    if (pure) push($0a18c015b5873b3d$var$PURE_ANNOTATION);
    const callHelper = isBlock ? $0a18c015b5873b3d$export$74fb204a6eba800d(context.inSSR, isComponent) : $0a18c015b5873b3d$export$3b9fc44425f495a6(context.inSSR, isComponent);
    push(helper(callHelper) + `(`, -2 /* None */ , node);
    $0a18c015b5873b3d$var$genNodeList($0a18c015b5873b3d$var$genNullableArgs([
        tag,
        props,
        children,
        patchFlagString,
        dynamicProps
    ]), context);
    push(`)`);
    if (isBlock) push(`)`);
    if (directives) {
        push(`, `);
        $0a18c015b5873b3d$var$genNode(directives, context);
        push(`)`);
    }
}
function $0a18c015b5873b3d$var$genNullableArgs(args) {
    let i = args.length;
    while(i--){
        if (args[i] != null) break;
    }
    return args.slice(0, i + 1).map((arg)=>arg || `null`);
}
function $0a18c015b5873b3d$var$genCallExpression(node, context) {
    const { push: push, helper: helper, pure: pure } = context;
    const callee = (0, $a5gC8.isString)(node.callee) ? node.callee : helper(node.callee);
    if (pure) push($0a18c015b5873b3d$var$PURE_ANNOTATION);
    push(callee + `(`, -2 /* None */ , node);
    $0a18c015b5873b3d$var$genNodeList(node.arguments, context);
    push(`)`);
}
function $0a18c015b5873b3d$var$genObjectExpression(node, context) {
    const { push: push, indent: indent, deindent: deindent, newline: newline } = context;
    const { properties: properties } = node;
    if (!properties.length) {
        push(`{}`, -2 /* None */ , node);
        return;
    }
    const multilines = properties.length > 1 || false;
    push(multilines ? `{` : `{ `);
    multilines && indent();
    for(let i = 0; i < properties.length; i++){
        const { key: key, value: value } = properties[i];
        $0a18c015b5873b3d$var$genExpressionAsPropertyKey(key, context);
        push(`: `);
        $0a18c015b5873b3d$var$genNode(value, context);
        if (i < properties.length - 1) {
            push(`,`);
            newline();
        }
    }
    multilines && deindent();
    push(multilines ? `}` : ` }`);
}
function $0a18c015b5873b3d$var$genArrayExpression(node, context) {
    $0a18c015b5873b3d$var$genNodeListAsArray(node.elements, context);
}
function $0a18c015b5873b3d$var$genFunctionExpression(node, context) {
    const { push: push, indent: indent, deindent: deindent } = context;
    const { params: params, returns: returns, body: body, newline: newline, isSlot: isSlot } = node;
    if (isSlot) push(`_${$0a18c015b5873b3d$export$7dc1fc5a07bc9b35[$0a18c015b5873b3d$export$141e17a2b5200090]}(`);
    push(`(`, -2 /* None */ , node);
    if ((0, $a5gC8.isArray)(params)) $0a18c015b5873b3d$var$genNodeList(params, context);
    else if (params) $0a18c015b5873b3d$var$genNode(params, context);
    push(`) => `);
    if (newline || body) {
        push(`{`);
        indent();
    }
    if (returns) {
        if (newline) push(`return `);
        if ((0, $a5gC8.isArray)(returns)) $0a18c015b5873b3d$var$genNodeListAsArray(returns, context);
        else $0a18c015b5873b3d$var$genNode(returns, context);
    } else if (body) $0a18c015b5873b3d$var$genNode(body, context);
    if (newline || body) {
        deindent();
        push(`}`);
    }
    if (isSlot) {
        if (node.isNonScopedSlot) push(`, undefined, true`);
        push(`)`);
    }
}
function $0a18c015b5873b3d$var$genConditionalExpression(node, context) {
    const { test: test, consequent: consequent, alternate: alternate, newline: needNewline } = node;
    const { push: push, indent: indent, deindent: deindent, newline: newline } = context;
    if (test.type === 4) {
        const needsParens = !$0a18c015b5873b3d$export$3cb8486ad206c65(test.content);
        needsParens && push(`(`);
        $0a18c015b5873b3d$var$genExpression(test, context);
        needsParens && push(`)`);
    } else {
        push(`(`);
        $0a18c015b5873b3d$var$genNode(test, context);
        push(`)`);
    }
    needNewline && indent();
    context.indentLevel++;
    needNewline || push(` `);
    push(`? `);
    $0a18c015b5873b3d$var$genNode(consequent, context);
    context.indentLevel--;
    needNewline && newline();
    needNewline || push(` `);
    push(`: `);
    const isNested = alternate.type === 19;
    if (!isNested) context.indentLevel++;
    $0a18c015b5873b3d$var$genNode(alternate, context);
    if (!isNested) context.indentLevel--;
    needNewline && deindent(true);
}
function $0a18c015b5873b3d$var$genCacheExpression(node, context) {
    const { push: push, helper: helper, indent: indent, deindent: deindent, newline: newline } = context;
    const { needPauseTracking: needPauseTracking, needArraySpread: needArraySpread } = node;
    if (needArraySpread) push(`[...(`);
    push(`_cache[${node.index}] || (`);
    if (needPauseTracking) {
        indent();
        push(`${helper($0a18c015b5873b3d$export$37cf1f9ab937c10d)}(-1),`);
        newline();
        push(`(`);
    }
    push(`_cache[${node.index}] = `);
    $0a18c015b5873b3d$var$genNode(node.value, context);
    if (needPauseTracking) {
        push(`).cacheIndex = ${node.index},`);
        newline();
        push(`${helper($0a18c015b5873b3d$export$37cf1f9ab937c10d)}(1),`);
        newline();
        push(`_cache[${node.index}]`);
        deindent();
    }
    push(`)`);
    if (needArraySpread) push(`)]`);
}
const $0a18c015b5873b3d$var$prohibitedKeywordRE = new RegExp("\\b" + "arguments,await,break,case,catch,class,const,continue,debugger,default,delete,do,else,export,extends,finally,for,function,if,import,let,new,return,super,switch,throw,try,var,void,while,with,yield".split(",").join("\\b|\\b") + "\\b");
const $0a18c015b5873b3d$var$stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;
function $0a18c015b5873b3d$var$validateBrowserExpression(node, context, asParams = false, asRawStatements = false) {
    const exp = node.content;
    if (!exp.trim()) return;
    try {
        new Function(asRawStatements ? ` ${exp} ` : `return ${asParams ? `(${exp}) => {}` : `(${exp})`}`);
    } catch (e) {
        let message = e.message;
        const keywordMatch = exp.replace($0a18c015b5873b3d$var$stripStringRE, "").match($0a18c015b5873b3d$var$prohibitedKeywordRE);
        if (keywordMatch) message = `avoid using JavaScript keyword as property name: "${keywordMatch[0]}"`;
        context.onError($0a18c015b5873b3d$export$57c5a5dc5aa19bdf(45, node.loc, void 0, message));
    }
}
const $0a18c015b5873b3d$export$7e9f01d2df839553 = (node, context)=>{
    if (node.type === 5) node.content = $0a18c015b5873b3d$export$997045dce990ec35(node.content, context);
    else if (node.type === 1) for(let i = 0; i < node.props.length; i++){
        const dir = node.props[i];
        if (dir.type === 7 && dir.name !== "for") {
            const exp = dir.exp;
            const arg = dir.arg;
            if (exp && exp.type === 4 && !(dir.name === "on" && arg)) dir.exp = $0a18c015b5873b3d$export$997045dce990ec35(exp, context, // slot args must be processed as function params
            dir.name === "slot");
            if (arg && arg.type === 4 && !arg.isStatic) dir.arg = $0a18c015b5873b3d$export$997045dce990ec35(arg, context);
        }
    }
};
function $0a18c015b5873b3d$export$997045dce990ec35(node, context, asParams = false, asRawStatements = false, localVars = Object.create(context.identifiers)) {
    return node;
}
function $0a18c015b5873b3d$export$123a9f8105e820ce(exp) {
    if ((0, $a5gC8.isString)(exp)) return exp;
    else if (exp.type === 4) return exp.content;
    else return exp.children.map($0a18c015b5873b3d$export$123a9f8105e820ce).join("");
}
const $0a18c015b5873b3d$var$transformIf = $0a18c015b5873b3d$export$aee0887cf96094d7(/^(if|else|else-if)$/, (node, dir, context)=>{
    return $0a18c015b5873b3d$export$a01e2bc7b2f1a6e5(node, dir, context, (ifNode, branch, isRoot)=>{
        const siblings = context.parent.children;
        let i = siblings.indexOf(ifNode);
        let key = 0;
        while(i-- >= 0){
            const sibling = siblings[i];
            if (sibling && sibling.type === 9) key += sibling.branches.length;
        }
        return ()=>{
            if (isRoot) ifNode.codegenNode = $0a18c015b5873b3d$var$createCodegenNodeForBranch(branch, key, context);
            else {
                const parentCondition = $0a18c015b5873b3d$var$getParentCondition(ifNode.codegenNode);
                parentCondition.alternate = $0a18c015b5873b3d$var$createCodegenNodeForBranch(branch, key + ifNode.branches.length - 1, context);
            }
        };
    });
});
function $0a18c015b5873b3d$export$a01e2bc7b2f1a6e5(node, dir, context, processCodegen) {
    if (dir.name !== "else" && (!dir.exp || !dir.exp.content.trim())) {
        const loc = dir.exp ? dir.exp.loc : node.loc;
        context.onError($0a18c015b5873b3d$export$57c5a5dc5aa19bdf(28, dir.loc));
        dir.exp = $0a18c015b5873b3d$export$ac2aa689b44cdd23(`true`, false, loc);
    }
    if (dir.name === "if") {
        const branch = $0a18c015b5873b3d$var$createIfBranch(node, dir);
        const ifNode = {
            type: 9,
            loc: $0a18c015b5873b3d$var$cloneLoc(node.loc),
            branches: [
                branch
            ]
        };
        context.replaceNode(ifNode);
        if (processCodegen) return processCodegen(ifNode, branch, true);
    } else {
        const siblings = context.parent.children;
        const comments = [];
        let i = siblings.indexOf(node);
        while(i-- >= -1){
            const sibling = siblings[i];
            if (sibling && sibling.type === 3) {
                context.removeNode(sibling);
                continue;
            }
            if (sibling && sibling.type === 2 && !sibling.content.trim().length) {
                context.removeNode(sibling);
                continue;
            }
            if (sibling && sibling.type === 9) {
                if (dir.name === "else-if" && sibling.branches[sibling.branches.length - 1].condition === void 0) context.onError($0a18c015b5873b3d$export$57c5a5dc5aa19bdf(30, node.loc));
                context.removeNode();
                const branch = $0a18c015b5873b3d$var$createIfBranch(node, dir);
                var userKey;
                sibling.branches.push(branch);
                const onExit = processCodegen && processCodegen(sibling, branch, false);
                $0a18c015b5873b3d$export$c9d429747c1011af(branch, context);
                if (onExit) onExit();
                context.currentNode = null;
            } else context.onError($0a18c015b5873b3d$export$57c5a5dc5aa19bdf(30, node.loc));
            break;
        }
    }
}
function $0a18c015b5873b3d$var$createIfBranch(node, dir) {
    const isTemplateIf = node.tagType === 3;
    return {
        type: 10,
        loc: node.loc,
        condition: dir.name === "else" ? void 0 : dir.exp,
        children: isTemplateIf && !$0a18c015b5873b3d$export$1199bc2a2b648c8c(node, "for") ? node.children : [
            node
        ],
        userKey: $0a18c015b5873b3d$export$4ae65475e3513615(node, `key`),
        isTemplateIf: isTemplateIf
    };
}
function $0a18c015b5873b3d$var$createCodegenNodeForBranch(branch, keyIndex, context) {
    if (branch.condition) return $0a18c015b5873b3d$export$374e02fb5bd90a4e(branch.condition, $0a18c015b5873b3d$var$createChildrenCodegenNode(branch, keyIndex, context), // make sure to pass in asBlock: true so that the comment node call
    // closes the current block.
    $0a18c015b5873b3d$export$2cdf8617f9d8e39d(context.helper($0a18c015b5873b3d$export$b2aae42fb0a19db3), [
        '""',
        "true"
    ]));
    else return $0a18c015b5873b3d$var$createChildrenCodegenNode(branch, keyIndex, context);
}
function $0a18c015b5873b3d$var$createChildrenCodegenNode(branch, keyIndex, context) {
    const { helper: helper } = context;
    const keyProperty = $0a18c015b5873b3d$export$45231d90c148ea74(`key`, $0a18c015b5873b3d$export$ac2aa689b44cdd23(`${keyIndex}`, false, $0a18c015b5873b3d$export$6c4f24c93c3e8659, 2));
    const { children: children } = branch;
    const firstChild = children[0];
    const needFragmentWrapper = children.length !== 1 || firstChild.type !== 1;
    if (needFragmentWrapper) {
        if (children.length === 1 && firstChild.type === 11) {
            const vnodeCall = firstChild.codegenNode;
            $0a18c015b5873b3d$export$ec34add3fb2185f8(vnodeCall, keyProperty, context);
            return vnodeCall;
        } else {
            let patchFlag = 64;
            return $0a18c015b5873b3d$export$d1cb722ac2a8b632(context, helper($0a18c015b5873b3d$export$4bebefc40c8513e8), $0a18c015b5873b3d$export$ccb2e514379853a7([
                keyProperty
            ]), children, patchFlag, void 0, void 0, true, false, false, branch.loc);
        }
    } else {
        const ret = firstChild.codegenNode;
        const vnodeCall = $0a18c015b5873b3d$export$39e241985cd3e673(ret);
        if (vnodeCall.type === 13) $0a18c015b5873b3d$export$dc00c05f515bd739(vnodeCall, context);
        $0a18c015b5873b3d$export$ec34add3fb2185f8(vnodeCall, keyProperty, context);
        return ret;
    }
}
function $0a18c015b5873b3d$var$isSameKey(a, b) {
    if (!a || a.type !== b.type) return false;
    if (a.type === 6) {
        if (a.value.content !== b.value.content) return false;
    } else {
        const exp = a.exp;
        const branchExp = b.exp;
        if (exp.type !== branchExp.type) return false;
        if (exp.type !== 4 || exp.isStatic !== branchExp.isStatic || exp.content !== branchExp.content) return false;
    }
    return true;
}
function $0a18c015b5873b3d$var$getParentCondition(node) {
    while(true){
        if (node.type === 19) {
            if (node.alternate.type === 19) node = node.alternate;
            else return node;
        } else if (node.type === 20) node = node.value;
    }
}
const $0a18c015b5873b3d$export$2fa367e7c04d4515 = (dir, _node, context)=>{
    const { modifiers: modifiers, loc: loc } = dir;
    const arg = dir.arg;
    let { exp: exp } = dir;
    if (exp && exp.type === 4 && !exp.content.trim()) exp = void 0;
    if (!exp) {
        if (arg.type !== 4 || !arg.isStatic) {
            context.onError($0a18c015b5873b3d$export$57c5a5dc5aa19bdf(52, arg.loc));
            return {
                props: [
                    $0a18c015b5873b3d$export$45231d90c148ea74(arg, $0a18c015b5873b3d$export$ac2aa689b44cdd23("", true, loc))
                ]
            };
        }
        $0a18c015b5873b3d$var$transformBindShorthand(dir);
        exp = dir.exp;
    }
    if (arg.type !== 4) {
        arg.children.unshift(`(`);
        arg.children.push(`) || ""`);
    } else if (!arg.isStatic) arg.content = `${arg.content} || ""`;
    if (modifiers.some((mod)=>mod.content === "camel")) {
        if (arg.type === 4) {
            if (arg.isStatic) arg.content = (0, $a5gC8.camelize)(arg.content);
            else arg.content = `${context.helperString($0a18c015b5873b3d$export$3ebbf6981763e181)}(${arg.content})`;
        } else {
            arg.children.unshift(`${context.helperString($0a18c015b5873b3d$export$3ebbf6981763e181)}(`);
            arg.children.push(`)`);
        }
    }
    if (!context.inSSR) {
        if (modifiers.some((mod)=>mod.content === "prop")) $0a18c015b5873b3d$var$injectPrefix(arg, ".");
        if (modifiers.some((mod)=>mod.content === "attr")) $0a18c015b5873b3d$var$injectPrefix(arg, "^");
    }
    return {
        props: [
            $0a18c015b5873b3d$export$45231d90c148ea74(arg, exp)
        ]
    };
};
const $0a18c015b5873b3d$var$transformBindShorthand = (dir, context)=>{
    const arg = dir.arg;
    const propName = (0, $a5gC8.camelize)(arg.content);
    dir.exp = $0a18c015b5873b3d$export$ac2aa689b44cdd23(propName, false, arg.loc);
};
const $0a18c015b5873b3d$var$injectPrefix = (arg, prefix)=>{
    if (arg.type === 4) {
        if (arg.isStatic) arg.content = prefix + arg.content;
        else arg.content = `\`${prefix}\${${arg.content}}\``;
    } else {
        arg.children.unshift(`'${prefix}' + (`);
        arg.children.push(`)`);
    }
};
const $0a18c015b5873b3d$var$transformFor = $0a18c015b5873b3d$export$aee0887cf96094d7("for", (node, dir, context)=>{
    const { helper: helper, removeHelper: removeHelper } = context;
    return $0a18c015b5873b3d$export$bb06c920f370c8cb(node, dir, context, (forNode)=>{
        const renderExp = $0a18c015b5873b3d$export$2cdf8617f9d8e39d(helper($0a18c015b5873b3d$export$3da0e5cd78c1870), [
            forNode.source
        ]);
        const isTemplate = $0a18c015b5873b3d$export$f125a8a2b402ed89(node);
        const memo = $0a18c015b5873b3d$export$1199bc2a2b648c8c(node, "memo");
        const keyProp = $0a18c015b5873b3d$export$4ae65475e3513615(node, `key`, false, true);
        if (keyProp && keyProp.type === 7 && !keyProp.exp) $0a18c015b5873b3d$var$transformBindShorthand(keyProp);
        const keyExp = keyProp && (keyProp.type === 6 ? keyProp.value ? $0a18c015b5873b3d$export$ac2aa689b44cdd23(keyProp.value.content, true) : void 0 : keyProp.exp);
        const keyProperty = keyProp && keyExp ? $0a18c015b5873b3d$export$45231d90c148ea74(`key`, keyExp) : null;
        const isStableFragment = forNode.source.type === 4 && forNode.source.constType > 0;
        const fragmentFlag = isStableFragment ? 64 : keyProp ? 128 : 256;
        forNode.codegenNode = $0a18c015b5873b3d$export$d1cb722ac2a8b632(context, helper($0a18c015b5873b3d$export$4bebefc40c8513e8), void 0, renderExp, fragmentFlag, void 0, void 0, true, !isStableFragment, false, node.loc);
        return ()=>{
            let childBlock;
            const { children: children } = forNode;
            var c;
            const needFragmentWrapper = children.length !== 1 || children[0].type !== 1;
            const slotOutlet = $0a18c015b5873b3d$export$45f38ad7fffc9b53(node) ? node : isTemplate && node.children.length === 1 && $0a18c015b5873b3d$export$45f38ad7fffc9b53(node.children[0]) ? node.children[0] : null;
            if (slotOutlet) {
                childBlock = slotOutlet.codegenNode;
                if (isTemplate && keyProperty) $0a18c015b5873b3d$export$ec34add3fb2185f8(childBlock, keyProperty, context);
            } else if (needFragmentWrapper) childBlock = $0a18c015b5873b3d$export$d1cb722ac2a8b632(context, helper($0a18c015b5873b3d$export$4bebefc40c8513e8), keyProperty ? $0a18c015b5873b3d$export$ccb2e514379853a7([
                keyProperty
            ]) : void 0, node.children, 64, void 0, void 0, true, void 0, false);
            else {
                childBlock = children[0].codegenNode;
                if (isTemplate && keyProperty) $0a18c015b5873b3d$export$ec34add3fb2185f8(childBlock, keyProperty, context);
                if (childBlock.isBlock !== !isStableFragment) {
                    if (childBlock.isBlock) {
                        removeHelper($0a18c015b5873b3d$export$59578e14f90a15eb);
                        removeHelper($0a18c015b5873b3d$export$74fb204a6eba800d(context.inSSR, childBlock.isComponent));
                    } else removeHelper($0a18c015b5873b3d$export$3b9fc44425f495a6(context.inSSR, childBlock.isComponent));
                }
                childBlock.isBlock = !isStableFragment;
                if (childBlock.isBlock) {
                    helper($0a18c015b5873b3d$export$59578e14f90a15eb);
                    helper($0a18c015b5873b3d$export$74fb204a6eba800d(context.inSSR, childBlock.isComponent));
                } else helper($0a18c015b5873b3d$export$3b9fc44425f495a6(context.inSSR, childBlock.isComponent));
            }
            if (memo) {
                const loop = $0a18c015b5873b3d$export$253e05bfd5b6c4c6($0a18c015b5873b3d$export$5796ae82f3e98f88(forNode.parseResult, [
                    $0a18c015b5873b3d$export$ac2aa689b44cdd23(`_cached`)
                ]));
                loop.body = $0a18c015b5873b3d$export$c3ad9e28586f1d07([
                    $0a18c015b5873b3d$export$60ad01cd5cde5e50([
                        `const _memo = (`,
                        memo.exp,
                        `)`
                    ]),
                    $0a18c015b5873b3d$export$60ad01cd5cde5e50([
                        `if (_cached`,
                        ...keyExp ? [
                            ` && _cached.key === `,
                            keyExp
                        ] : [],
                        ` && ${context.helperString($0a18c015b5873b3d$export$ae18cf0dc81df35a)}(_cached, _memo)) return _cached`
                    ]),
                    $0a18c015b5873b3d$export$60ad01cd5cde5e50([
                        `const _item = `,
                        childBlock
                    ]),
                    $0a18c015b5873b3d$export$ac2aa689b44cdd23(`_item.memo = _memo`),
                    $0a18c015b5873b3d$export$ac2aa689b44cdd23(`return _item`)
                ]);
                renderExp.arguments.push(loop, $0a18c015b5873b3d$export$ac2aa689b44cdd23(`_cache`), $0a18c015b5873b3d$export$ac2aa689b44cdd23(String(context.cached.length)));
                context.cached.push(null);
            } else renderExp.arguments.push($0a18c015b5873b3d$export$253e05bfd5b6c4c6($0a18c015b5873b3d$export$5796ae82f3e98f88(forNode.parseResult), childBlock, true));
        };
    });
});
function $0a18c015b5873b3d$export$bb06c920f370c8cb(node, dir, context, processCodegen) {
    if (!dir.exp) {
        context.onError($0a18c015b5873b3d$export$57c5a5dc5aa19bdf(31, dir.loc));
        return;
    }
    const parseResult = dir.forParseResult;
    if (!parseResult) {
        context.onError($0a18c015b5873b3d$export$57c5a5dc5aa19bdf(32, dir.loc));
        return;
    }
    $0a18c015b5873b3d$var$finalizeForParseResult(parseResult, context);
    const { addIdentifiers: addIdentifiers, removeIdentifiers: removeIdentifiers, scopes: scopes } = context;
    const { source: source, value: value, key: key, index: index } = parseResult;
    const forNode = {
        type: 11,
        loc: dir.loc,
        source: source,
        valueAlias: value,
        keyAlias: key,
        objectIndexAlias: index,
        parseResult: parseResult,
        children: $0a18c015b5873b3d$export$f125a8a2b402ed89(node) ? node.children : [
            node
        ]
    };
    context.replaceNode(forNode);
    scopes.vFor++;
    const onExit = processCodegen && processCodegen(forNode);
    return ()=>{
        scopes.vFor--;
        if (onExit) onExit();
    };
}
function $0a18c015b5873b3d$var$finalizeForParseResult(result, context) {
    if (result.finalized) return;
    result.finalized = true;
}
function $0a18c015b5873b3d$export$5796ae82f3e98f88({ value: value, key: key, index: index }, memoArgs = []) {
    return $0a18c015b5873b3d$var$createParamsList([
        value,
        key,
        index,
        ...memoArgs
    ]);
}
function $0a18c015b5873b3d$var$createParamsList(args) {
    let i = args.length;
    while(i--){
        if (args[i]) break;
    }
    return args.slice(0, i + 1).map((arg, i2)=>arg || $0a18c015b5873b3d$export$ac2aa689b44cdd23(`_`.repeat(i2 + 1), false));
}
const $0a18c015b5873b3d$var$defaultFallback = $0a18c015b5873b3d$export$ac2aa689b44cdd23(`undefined`, false);
const $0a18c015b5873b3d$export$f0a2c7894e526c50 = (node, context)=>{
    if (node.type === 1 && (node.tagType === 1 || node.tagType === 3)) {
        const vSlot = $0a18c015b5873b3d$export$1199bc2a2b648c8c(node, "slot");
        if (vSlot) {
            vSlot.exp;
            context.scopes.vSlot++;
            return ()=>{
                context.scopes.vSlot--;
            };
        }
    }
};
const $0a18c015b5873b3d$export$38b9212074cad7c2 = (node, context)=>{
    let vFor;
    if ($0a18c015b5873b3d$export$f125a8a2b402ed89(node) && node.props.some($0a18c015b5873b3d$export$eaf8991bb8af8cbb) && (vFor = $0a18c015b5873b3d$export$1199bc2a2b648c8c(node, "for"))) {
        const result = vFor.forParseResult;
        if (result) {
            $0a18c015b5873b3d$var$finalizeForParseResult(result, context);
            const { value: value, key: key, index: index } = result;
            const { addIdentifiers: addIdentifiers, removeIdentifiers: removeIdentifiers } = context;
            value && addIdentifiers(value);
            key && addIdentifiers(key);
            index && addIdentifiers(index);
            return ()=>{
                value && removeIdentifiers(value);
                key && removeIdentifiers(key);
                index && removeIdentifiers(index);
            };
        }
    }
};
const $0a18c015b5873b3d$var$buildClientSlotFn = (props, _vForExp, children, loc)=>$0a18c015b5873b3d$export$253e05bfd5b6c4c6(props, children, false, true, children.length ? children[0].loc : loc);
function $0a18c015b5873b3d$export$8083554712300565(node, context, buildSlotFn = $0a18c015b5873b3d$var$buildClientSlotFn) {
    context.helper($0a18c015b5873b3d$export$141e17a2b5200090);
    const { children: children, loc: loc } = node;
    const slotsProperties = [];
    const dynamicSlots = [];
    let hasDynamicSlots = context.scopes.vSlot > 0 || context.scopes.vFor > 0;
    const onComponentSlot = $0a18c015b5873b3d$export$1199bc2a2b648c8c(node, "slot", true);
    if (onComponentSlot) {
        const { arg: arg, exp: exp } = onComponentSlot;
        if (arg && !$0a18c015b5873b3d$export$43d387e2d68b51dc(arg)) hasDynamicSlots = true;
        slotsProperties.push($0a18c015b5873b3d$export$45231d90c148ea74(arg || $0a18c015b5873b3d$export$ac2aa689b44cdd23("default", true), buildSlotFn(exp, void 0, children, loc)));
    }
    let hasTemplateSlots = false;
    let hasNamedDefaultSlot = false;
    const implicitDefaultChildren = [];
    const seenSlotNames = /* @__PURE__ */ new Set();
    let conditionalBranchIndex = 0;
    for(let i = 0; i < children.length; i++){
        const slotElement = children[i];
        let slotDir;
        if (!$0a18c015b5873b3d$export$f125a8a2b402ed89(slotElement) || !(slotDir = $0a18c015b5873b3d$export$1199bc2a2b648c8c(slotElement, "slot", true))) {
            if (slotElement.type !== 3) implicitDefaultChildren.push(slotElement);
            continue;
        }
        if (onComponentSlot) {
            context.onError($0a18c015b5873b3d$export$57c5a5dc5aa19bdf(37, slotDir.loc));
            break;
        }
        hasTemplateSlots = true;
        const { children: slotChildren, loc: slotLoc } = slotElement;
        const { arg: slotName = $0a18c015b5873b3d$export$ac2aa689b44cdd23(`default`, true), exp: slotProps, loc: dirLoc } = slotDir;
        let staticSlotName;
        if ($0a18c015b5873b3d$export$43d387e2d68b51dc(slotName)) staticSlotName = slotName ? slotName.content : `default`;
        else hasDynamicSlots = true;
        const vFor = $0a18c015b5873b3d$export$1199bc2a2b648c8c(slotElement, "for");
        const slotFunction = buildSlotFn(slotProps, vFor, slotChildren, slotLoc);
        let vIf;
        let vElse;
        if (vIf = $0a18c015b5873b3d$export$1199bc2a2b648c8c(slotElement, "if")) {
            hasDynamicSlots = true;
            dynamicSlots.push($0a18c015b5873b3d$export$374e02fb5bd90a4e(vIf.exp, $0a18c015b5873b3d$var$buildDynamicSlot(slotName, slotFunction, conditionalBranchIndex++), $0a18c015b5873b3d$var$defaultFallback));
        } else if (vElse = $0a18c015b5873b3d$export$1199bc2a2b648c8c(slotElement, /^else(-if)?$/, true)) {
            let j = i;
            let prev;
            while(j--){
                prev = children[j];
                if (prev.type !== 3) break;
            }
            if (prev && $0a18c015b5873b3d$export$f125a8a2b402ed89(prev) && $0a18c015b5873b3d$export$1199bc2a2b648c8c(prev, /^(else-)?if$/)) {
                let conditional = dynamicSlots[dynamicSlots.length - 1];
                while(conditional.alternate.type === 19)conditional = conditional.alternate;
                conditional.alternate = vElse.exp ? $0a18c015b5873b3d$export$374e02fb5bd90a4e(vElse.exp, $0a18c015b5873b3d$var$buildDynamicSlot(slotName, slotFunction, conditionalBranchIndex++), $0a18c015b5873b3d$var$defaultFallback) : $0a18c015b5873b3d$var$buildDynamicSlot(slotName, slotFunction, conditionalBranchIndex++);
            } else context.onError($0a18c015b5873b3d$export$57c5a5dc5aa19bdf(30, vElse.loc));
        } else if (vFor) {
            hasDynamicSlots = true;
            const parseResult = vFor.forParseResult;
            if (parseResult) {
                $0a18c015b5873b3d$var$finalizeForParseResult(parseResult, context);
                dynamicSlots.push($0a18c015b5873b3d$export$2cdf8617f9d8e39d(context.helper($0a18c015b5873b3d$export$3da0e5cd78c1870), [
                    parseResult.source,
                    $0a18c015b5873b3d$export$253e05bfd5b6c4c6($0a18c015b5873b3d$export$5796ae82f3e98f88(parseResult), $0a18c015b5873b3d$var$buildDynamicSlot(slotName, slotFunction), true)
                ]));
            } else context.onError($0a18c015b5873b3d$export$57c5a5dc5aa19bdf(32, vFor.loc));
        } else {
            if (staticSlotName) {
                if (seenSlotNames.has(staticSlotName)) {
                    context.onError($0a18c015b5873b3d$export$57c5a5dc5aa19bdf(38, dirLoc));
                    continue;
                }
                seenSlotNames.add(staticSlotName);
                if (staticSlotName === "default") hasNamedDefaultSlot = true;
            }
            slotsProperties.push($0a18c015b5873b3d$export$45231d90c148ea74(slotName, slotFunction));
        }
    }
    if (!onComponentSlot) {
        const buildDefaultSlotProperty = (props, children2)=>{
            const fn = buildSlotFn(props, void 0, children2, loc);
            if (context.compatConfig) fn.isNonScopedSlot = true;
            return $0a18c015b5873b3d$export$45231d90c148ea74(`default`, fn);
        };
        if (!hasTemplateSlots) slotsProperties.push(buildDefaultSlotProperty(void 0, children));
        else if (implicitDefaultChildren.length && // #3766
        // with whitespace: 'preserve', whitespaces between slots will end up in
        // implicitDefaultChildren. Ignore if all implicit children are whitespaces.
        implicitDefaultChildren.some((node2)=>$0a18c015b5873b3d$var$isNonWhitespaceContent(node2))) {
            if (hasNamedDefaultSlot) context.onError($0a18c015b5873b3d$export$57c5a5dc5aa19bdf(39, implicitDefaultChildren[0].loc));
            else slotsProperties.push(buildDefaultSlotProperty(void 0, implicitDefaultChildren));
        }
    }
    const slotFlag = hasDynamicSlots ? 2 : $0a18c015b5873b3d$var$hasForwardedSlots(node.children) ? 3 : 1;
    let slots = $0a18c015b5873b3d$export$ccb2e514379853a7(slotsProperties.concat($0a18c015b5873b3d$export$45231d90c148ea74(`_`, // 2 = compiled but dynamic = can skip normalization, but must run diff
    // 1 = compiled and static = can skip normalization AND diff as optimized
    $0a18c015b5873b3d$export$ac2aa689b44cdd23(slotFlag + ``, false))), loc);
    if (dynamicSlots.length) slots = $0a18c015b5873b3d$export$2cdf8617f9d8e39d(context.helper($0a18c015b5873b3d$export$6a6b6a5c860c238d), [
        slots,
        $0a18c015b5873b3d$export$c887713da9895dbb(dynamicSlots)
    ]);
    return {
        slots: slots,
        hasDynamicSlots: hasDynamicSlots
    };
}
function $0a18c015b5873b3d$var$buildDynamicSlot(name, fn, index) {
    const props = [
        $0a18c015b5873b3d$export$45231d90c148ea74(`name`, name),
        $0a18c015b5873b3d$export$45231d90c148ea74(`fn`, fn)
    ];
    if (index != null) props.push($0a18c015b5873b3d$export$45231d90c148ea74(`key`, $0a18c015b5873b3d$export$ac2aa689b44cdd23(String(index), true)));
    return $0a18c015b5873b3d$export$ccb2e514379853a7(props);
}
function $0a18c015b5873b3d$var$hasForwardedSlots(children) {
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        switch(child.type){
            case 1:
                if (child.tagType === 2 || $0a18c015b5873b3d$var$hasForwardedSlots(child.children)) return true;
                break;
            case 9:
                if ($0a18c015b5873b3d$var$hasForwardedSlots(child.branches)) return true;
                break;
            case 10:
            case 11:
                if ($0a18c015b5873b3d$var$hasForwardedSlots(child.children)) return true;
                break;
        }
    }
    return false;
}
function $0a18c015b5873b3d$var$isNonWhitespaceContent(node) {
    if (node.type !== 2 && node.type !== 12) return true;
    return node.type === 2 ? !!node.content.trim() : $0a18c015b5873b3d$var$isNonWhitespaceContent(node.content);
}
const $0a18c015b5873b3d$var$directiveImportMap = /* @__PURE__ */ new WeakMap();
const $0a18c015b5873b3d$export$5d90dc62c1c9e431 = (node, context)=>{
    return function postTransformElement() {
        node = context.currentNode;
        if (!(node.type === 1 && (node.tagType === 0 || node.tagType === 1))) return;
        const { tag: tag, props: props } = node;
        const isComponent = node.tagType === 1;
        let vnodeTag = isComponent ? $0a18c015b5873b3d$export$9871d2aaf4643d1d(node, context) : `"${tag}"`;
        const isDynamicComponent = (0, $a5gC8.isObject)(vnodeTag) && vnodeTag.callee === $0a18c015b5873b3d$export$582a2287b73d3265;
        let vnodeProps;
        let vnodeChildren;
        let patchFlag = 0;
        let vnodeDynamicProps;
        let dynamicPropNames;
        let vnodeDirectives;
        let shouldUseBlock = // dynamic component may resolve to plain elements
        isDynamicComponent || vnodeTag === $0a18c015b5873b3d$export$e74e82bc14ac4f98 || vnodeTag === $0a18c015b5873b3d$export$2237d737f4a10705 || !isComponent && // <svg> and <foreignObject> must be forced into blocks so that block
        // updates inside get proper isSVG flag at runtime. (#639, #643)
        // This is technically web-specific, but splitting the logic out of core
        // leads to too much unnecessary complexity.
        (tag === "svg" || tag === "foreignObject" || tag === "math");
        if (props.length > 0) {
            const propsBuildResult = $0a18c015b5873b3d$export$bc4cd0273bb05e1b(node, context, void 0, isComponent, isDynamicComponent);
            vnodeProps = propsBuildResult.props;
            patchFlag = propsBuildResult.patchFlag;
            dynamicPropNames = propsBuildResult.dynamicPropNames;
            const directives = propsBuildResult.directives;
            vnodeDirectives = directives && directives.length ? $0a18c015b5873b3d$export$c887713da9895dbb(directives.map((dir)=>$0a18c015b5873b3d$export$6ff1db2f107c16cd(dir, context))) : void 0;
            if (propsBuildResult.shouldUseBlock) shouldUseBlock = true;
        }
        if (node.children.length > 0) {
            if (vnodeTag === $0a18c015b5873b3d$export$e9ff5bb5c39478ed) {
                shouldUseBlock = true;
                patchFlag |= 1024;
            }
            const shouldBuildAsSlots = isComponent && // Teleport is not a real component and has dedicated runtime handling
            vnodeTag !== $0a18c015b5873b3d$export$e74e82bc14ac4f98 && // explained above.
            vnodeTag !== $0a18c015b5873b3d$export$e9ff5bb5c39478ed;
            if (shouldBuildAsSlots) {
                const { slots: slots, hasDynamicSlots: hasDynamicSlots } = $0a18c015b5873b3d$export$8083554712300565(node, context);
                vnodeChildren = slots;
                if (hasDynamicSlots) patchFlag |= 1024;
            } else if (node.children.length === 1 && vnodeTag !== $0a18c015b5873b3d$export$e74e82bc14ac4f98) {
                const child = node.children[0];
                const type = child.type;
                const hasDynamicTextChild = type === 5 || type === 8;
                if (hasDynamicTextChild && $0a18c015b5873b3d$export$7967f5197c38d72a(child, context) === 0) patchFlag |= 1;
                if (hasDynamicTextChild || type === 2) vnodeChildren = child;
                else vnodeChildren = node.children;
            } else vnodeChildren = node.children;
        }
        if (dynamicPropNames && dynamicPropNames.length) vnodeDynamicProps = $0a18c015b5873b3d$var$stringifyDynamicPropNames(dynamicPropNames);
        node.codegenNode = $0a18c015b5873b3d$export$d1cb722ac2a8b632(context, vnodeTag, vnodeProps, vnodeChildren, patchFlag === 0 ? void 0 : patchFlag, vnodeDynamicProps, vnodeDirectives, !!shouldUseBlock, false, isComponent, node.loc);
    };
};
function $0a18c015b5873b3d$export$9871d2aaf4643d1d(node, context, ssr = false) {
    let { tag: tag } = node;
    const isExplicitDynamic = $0a18c015b5873b3d$var$isComponentTag(tag);
    const isProp = $0a18c015b5873b3d$export$4ae65475e3513615(node, "is", false, true);
    if (isProp) {
        if (isExplicitDynamic || $0a18c015b5873b3d$var$isCompatEnabled("COMPILER_IS_ON_ELEMENT", context)) {
            let exp;
            if (isProp.type === 6) exp = isProp.value && $0a18c015b5873b3d$export$ac2aa689b44cdd23(isProp.value.content, true);
            else {
                exp = isProp.exp;
                if (!exp) exp = $0a18c015b5873b3d$export$ac2aa689b44cdd23(`is`, false, isProp.arg.loc);
            }
            if (exp) return $0a18c015b5873b3d$export$2cdf8617f9d8e39d(context.helper($0a18c015b5873b3d$export$582a2287b73d3265), [
                exp
            ]);
        } else if (isProp.type === 6 && isProp.value.content.startsWith("vue:")) tag = isProp.value.content.slice(4);
    }
    const builtIn = $0a18c015b5873b3d$export$69768c9b514a01e9(tag) || context.isBuiltInComponent(tag);
    if (builtIn) {
        if (!ssr) context.helper(builtIn);
        return builtIn;
    }
    context.helper($0a18c015b5873b3d$export$28c52e95383d270);
    context.components.add(tag);
    return $0a18c015b5873b3d$export$80505c1072df544f(tag, `component`);
}
function $0a18c015b5873b3d$export$bc4cd0273bb05e1b(node, context, props = node.props, isComponent, isDynamicComponent, ssr = false) {
    const { tag: tag, loc: elementLoc, children: children } = node;
    let properties = [];
    const mergeArgs = [];
    const runtimeDirectives = [];
    const hasChildren = children.length > 0;
    let shouldUseBlock = false;
    let patchFlag = 0;
    let hasRef = false;
    let hasClassBinding = false;
    let hasStyleBinding = false;
    let hasHydrationEventBinding = false;
    let hasDynamicKeys = false;
    let hasVnodeHook = false;
    const dynamicPropNames = [];
    const pushMergeArg = (arg)=>{
        if (properties.length) {
            mergeArgs.push($0a18c015b5873b3d$export$ccb2e514379853a7($0a18c015b5873b3d$var$dedupeProperties(properties), elementLoc));
            properties = [];
        }
        if (arg) mergeArgs.push(arg);
    };
    const pushRefVForMarker = ()=>{
        if (context.scopes.vFor > 0) properties.push($0a18c015b5873b3d$export$45231d90c148ea74($0a18c015b5873b3d$export$ac2aa689b44cdd23("ref_for", true), $0a18c015b5873b3d$export$ac2aa689b44cdd23("true")));
    };
    const analyzePatchFlag = ({ key: key, value: value })=>{
        if ($0a18c015b5873b3d$export$43d387e2d68b51dc(key)) {
            const name = key.content;
            const isEventHandler = (0, $a5gC8.isOn)(name);
            if (isEventHandler && (!isComponent || isDynamicComponent) && // omit the flag for click handlers because hydration gives click
            // dedicated fast path.
            name.toLowerCase() !== "onclick" && // omit v-model handlers
            name !== "onUpdate:modelValue" && // omit onVnodeXXX hooks
            !(0, $a5gC8.isReservedProp)(name)) hasHydrationEventBinding = true;
            if (isEventHandler && (0, $a5gC8.isReservedProp)(name)) hasVnodeHook = true;
            if (isEventHandler && value.type === 14) value = value.arguments[0];
            if (value.type === 20 || (value.type === 4 || value.type === 8) && $0a18c015b5873b3d$export$7967f5197c38d72a(value, context) > 0) return;
            if (name === "ref") hasRef = true;
            else if (name === "class") hasClassBinding = true;
            else if (name === "style") hasStyleBinding = true;
            else if (name !== "key" && !dynamicPropNames.includes(name)) dynamicPropNames.push(name);
            if (isComponent && (name === "class" || name === "style") && !dynamicPropNames.includes(name)) dynamicPropNames.push(name);
        } else hasDynamicKeys = true;
    };
    for(let i = 0; i < props.length; i++){
        const prop = props[i];
        if (prop.type === 6) {
            const { loc: loc, name: name, nameLoc: nameLoc, value: value } = prop;
            let isStatic = true;
            if (name === "ref") {
                hasRef = true;
                pushRefVForMarker();
            }
            if (name === "is" && ($0a18c015b5873b3d$var$isComponentTag(tag) || value && value.content.startsWith("vue:") || $0a18c015b5873b3d$var$isCompatEnabled("COMPILER_IS_ON_ELEMENT", context))) continue;
            properties.push($0a18c015b5873b3d$export$45231d90c148ea74($0a18c015b5873b3d$export$ac2aa689b44cdd23(name, true, nameLoc), $0a18c015b5873b3d$export$ac2aa689b44cdd23(value ? value.content : "", isStatic, value ? value.loc : loc)));
        } else {
            const { name: name, arg: arg, exp: exp, loc: loc, modifiers: modifiers } = prop;
            const isVBind = name === "bind";
            const isVOn = name === "on";
            if (name === "slot") {
                if (!isComponent) context.onError($0a18c015b5873b3d$export$57c5a5dc5aa19bdf(40, loc));
                continue;
            }
            if (name === "once" || name === "memo") continue;
            if (name === "is" || isVBind && $0a18c015b5873b3d$export$45cac5109adb5e55(arg, "is") && ($0a18c015b5873b3d$var$isComponentTag(tag) || $0a18c015b5873b3d$var$isCompatEnabled("COMPILER_IS_ON_ELEMENT", context))) continue;
            if (isVOn && ssr) continue;
            if (// #938: elements with dynamic keys should be forced into blocks
            isVBind && $0a18c015b5873b3d$export$45cac5109adb5e55(arg, "key") || // inline before-update hooks need to force block so that it is invoked
            // before children
            isVOn && hasChildren && $0a18c015b5873b3d$export$45cac5109adb5e55(arg, "vue:before-update")) shouldUseBlock = true;
            if (isVBind && $0a18c015b5873b3d$export$45cac5109adb5e55(arg, "ref")) pushRefVForMarker();
            if (!arg && (isVBind || isVOn)) {
                hasDynamicKeys = true;
                if (exp) {
                    if (isVBind) {
                        pushRefVForMarker();
                        pushMergeArg();
                        if ($0a18c015b5873b3d$var$isCompatEnabled("COMPILER_V_BIND_OBJECT_ORDER", context)) {
                            mergeArgs.unshift(exp);
                            continue;
                        }
                        mergeArgs.push(exp);
                    } else pushMergeArg({
                        type: 14,
                        loc: loc,
                        callee: context.helper($0a18c015b5873b3d$export$4bdbf33367525856),
                        arguments: isComponent ? [
                            exp
                        ] : [
                            exp,
                            `true`
                        ]
                    });
                } else context.onError($0a18c015b5873b3d$export$57c5a5dc5aa19bdf(isVBind ? 34 : 35, loc));
                continue;
            }
            if (isVBind && modifiers.some((mod)=>mod.content === "prop")) patchFlag |= 32;
            const directiveTransform = context.directiveTransforms[name];
            if (directiveTransform) {
                const { props: props2, needRuntime: needRuntime } = directiveTransform(prop, node, context);
                !ssr && props2.forEach(analyzePatchFlag);
                if (isVOn && arg && !$0a18c015b5873b3d$export$43d387e2d68b51dc(arg)) pushMergeArg($0a18c015b5873b3d$export$ccb2e514379853a7(props2, elementLoc));
                else properties.push(...props2);
                if (needRuntime) {
                    runtimeDirectives.push(prop);
                    if ((0, $a5gC8.isSymbol)(needRuntime)) $0a18c015b5873b3d$var$directiveImportMap.set(prop, needRuntime);
                }
            } else if (!(0, $a5gC8.isBuiltInDirective)(name)) {
                runtimeDirectives.push(prop);
                if (hasChildren) shouldUseBlock = true;
            }
        }
    }
    let propsExpression = void 0;
    if (mergeArgs.length) {
        pushMergeArg();
        if (mergeArgs.length > 1) propsExpression = $0a18c015b5873b3d$export$2cdf8617f9d8e39d(context.helper($0a18c015b5873b3d$export$825e32c0f842262a), mergeArgs, elementLoc);
        else propsExpression = mergeArgs[0];
    } else if (properties.length) propsExpression = $0a18c015b5873b3d$export$ccb2e514379853a7($0a18c015b5873b3d$var$dedupeProperties(properties), elementLoc);
    if (hasDynamicKeys) patchFlag |= 16;
    else {
        if (hasClassBinding && !isComponent) patchFlag |= 2;
        if (hasStyleBinding && !isComponent) patchFlag |= 4;
        if (dynamicPropNames.length) patchFlag |= 8;
        if (hasHydrationEventBinding) patchFlag |= 32;
    }
    if (!shouldUseBlock && (patchFlag === 0 || patchFlag === 32) && (hasRef || hasVnodeHook || runtimeDirectives.length > 0)) patchFlag |= 512;
    if (!context.inSSR && propsExpression) switch(propsExpression.type){
        case 15:
            let classKeyIndex = -1;
            let styleKeyIndex = -1;
            let hasDynamicKey = false;
            for(let i = 0; i < propsExpression.properties.length; i++){
                const key = propsExpression.properties[i].key;
                if ($0a18c015b5873b3d$export$43d387e2d68b51dc(key)) {
                    if (key.content === "class") classKeyIndex = i;
                    else if (key.content === "style") styleKeyIndex = i;
                } else if (!key.isHandlerKey) hasDynamicKey = true;
            }
            const classProp = propsExpression.properties[classKeyIndex];
            const styleProp = propsExpression.properties[styleKeyIndex];
            if (!hasDynamicKey) {
                if (classProp && !$0a18c015b5873b3d$export$43d387e2d68b51dc(classProp.value)) classProp.value = $0a18c015b5873b3d$export$2cdf8617f9d8e39d(context.helper($0a18c015b5873b3d$export$6382e3ed89de4e2a), [
                    classProp.value
                ]);
                if (styleProp && // the static style is compiled into an object,
                // so use `hasStyleBinding` to ensure that it is a dynamic style binding
                (hasStyleBinding || styleProp.value.type === 4 && styleProp.value.content.trim()[0] === `[` || // v-bind:style and style both exist,
                // v-bind:style with static literal object
                styleProp.value.type === 17)) styleProp.value = $0a18c015b5873b3d$export$2cdf8617f9d8e39d(context.helper($0a18c015b5873b3d$export$b9d3780a9ab822b4), [
                    styleProp.value
                ]);
            } else propsExpression = $0a18c015b5873b3d$export$2cdf8617f9d8e39d(context.helper($0a18c015b5873b3d$export$78c34c869683dd86), [
                propsExpression
            ]);
            break;
        case 14:
            break;
        default:
            propsExpression = $0a18c015b5873b3d$export$2cdf8617f9d8e39d(context.helper($0a18c015b5873b3d$export$78c34c869683dd86), [
                $0a18c015b5873b3d$export$2cdf8617f9d8e39d(context.helper($0a18c015b5873b3d$export$7046bb8d3c918928), [
                    propsExpression
                ])
            ]);
            break;
    }
    return {
        props: propsExpression,
        directives: runtimeDirectives,
        patchFlag: patchFlag,
        dynamicPropNames: dynamicPropNames,
        shouldUseBlock: shouldUseBlock
    };
}
function $0a18c015b5873b3d$var$dedupeProperties(properties) {
    const knownProps = /* @__PURE__ */ new Map();
    const deduped = [];
    for(let i = 0; i < properties.length; i++){
        const prop = properties[i];
        if (prop.key.type === 8 || !prop.key.isStatic) {
            deduped.push(prop);
            continue;
        }
        const name = prop.key.content;
        const existing = knownProps.get(name);
        if (existing) {
            if (name === "style" || name === "class" || (0, $a5gC8.isOn)(name)) $0a18c015b5873b3d$var$mergeAsArray(existing, prop);
        } else {
            knownProps.set(name, prop);
            deduped.push(prop);
        }
    }
    return deduped;
}
function $0a18c015b5873b3d$var$mergeAsArray(existing, incoming) {
    if (existing.value.type === 17) existing.value.elements.push(incoming.value);
    else existing.value = $0a18c015b5873b3d$export$c887713da9895dbb([
        existing.value,
        incoming.value
    ], existing.loc);
}
function $0a18c015b5873b3d$export$6ff1db2f107c16cd(dir, context) {
    const dirArgs = [];
    const runtime = $0a18c015b5873b3d$var$directiveImportMap.get(dir);
    if (runtime) dirArgs.push(context.helperString(runtime));
    else {
        context.helper($0a18c015b5873b3d$export$7f3ccc2ef793ecce);
        context.directives.add(dir.name);
        dirArgs.push($0a18c015b5873b3d$export$80505c1072df544f(dir.name, `directive`));
    }
    const { loc: loc } = dir;
    if (dir.exp) dirArgs.push(dir.exp);
    if (dir.arg) {
        if (!dir.exp) dirArgs.push(`void 0`);
        dirArgs.push(dir.arg);
    }
    if (Object.keys(dir.modifiers).length) {
        if (!dir.arg) {
            if (!dir.exp) dirArgs.push(`void 0`);
            dirArgs.push(`void 0`);
        }
        const trueExpression = $0a18c015b5873b3d$export$ac2aa689b44cdd23(`true`, false, loc);
        dirArgs.push($0a18c015b5873b3d$export$ccb2e514379853a7(dir.modifiers.map((modifier)=>$0a18c015b5873b3d$export$45231d90c148ea74(modifier, trueExpression)), loc));
    }
    return $0a18c015b5873b3d$export$c887713da9895dbb(dirArgs, dir.loc);
}
function $0a18c015b5873b3d$var$stringifyDynamicPropNames(props) {
    let propsNamesString = `[`;
    for(let i = 0, l = props.length; i < l; i++){
        propsNamesString += JSON.stringify(props[i]);
        if (i < l - 1) propsNamesString += ", ";
    }
    return propsNamesString + `]`;
}
function $0a18c015b5873b3d$var$isComponentTag(tag) {
    return tag === "component" || tag === "Component";
}
const $0a18c015b5873b3d$var$transformSlotOutlet = (node, context)=>{
    if ($0a18c015b5873b3d$export$45f38ad7fffc9b53(node)) {
        const { children: children, loc: loc } = node;
        const { slotName: slotName, slotProps: slotProps } = $0a18c015b5873b3d$export$cab34cff437fc757(node, context);
        const slotArgs = [
            context.prefixIdentifiers ? `_ctx.$slots` : `$slots`,
            slotName,
            "{}",
            "undefined",
            "true"
        ];
        let expectedLen = 2;
        if (slotProps) {
            slotArgs[2] = slotProps;
            expectedLen = 3;
        }
        if (children.length) {
            slotArgs[3] = $0a18c015b5873b3d$export$253e05bfd5b6c4c6([], children, false, false, loc);
            expectedLen = 4;
        }
        if (context.scopeId && !context.slotted) expectedLen = 5;
        slotArgs.splice(expectedLen);
        node.codegenNode = $0a18c015b5873b3d$export$2cdf8617f9d8e39d(context.helper($0a18c015b5873b3d$export$a91e32c6b04aa348), slotArgs, loc);
    }
};
function $0a18c015b5873b3d$export$cab34cff437fc757(node, context) {
    let slotName = `"default"`;
    let slotProps = void 0;
    const nonNameProps = [];
    for(let i = 0; i < node.props.length; i++){
        const p = node.props[i];
        if (p.type === 6) {
            if (p.value) {
                if (p.name === "name") slotName = JSON.stringify(p.value.content);
                else {
                    p.name = (0, $a5gC8.camelize)(p.name);
                    nonNameProps.push(p);
                }
            }
        } else if (p.name === "bind" && $0a18c015b5873b3d$export$45cac5109adb5e55(p.arg, "name")) {
            if (p.exp) slotName = p.exp;
            else if (p.arg && p.arg.type === 4) {
                const name = (0, $a5gC8.camelize)(p.arg.content);
                slotName = p.exp = $0a18c015b5873b3d$export$ac2aa689b44cdd23(name, false, p.arg.loc);
            }
        } else {
            if (p.name === "bind" && p.arg && $0a18c015b5873b3d$export$43d387e2d68b51dc(p.arg)) p.arg.content = (0, $a5gC8.camelize)(p.arg.content);
            nonNameProps.push(p);
        }
    }
    if (nonNameProps.length > 0) {
        const { props: props, directives: directives } = $0a18c015b5873b3d$export$bc4cd0273bb05e1b(node, context, nonNameProps, false, false);
        slotProps = props;
        if (directives.length) context.onError($0a18c015b5873b3d$export$57c5a5dc5aa19bdf(36, directives[0].loc));
    }
    return {
        slotName: slotName,
        slotProps: slotProps
    };
}
const $0a18c015b5873b3d$export$ff060d152244ee7b = (dir, node, context, augmentor)=>{
    const { loc: loc, modifiers: modifiers, arg: arg } = dir;
    if (!dir.exp && !modifiers.length) context.onError($0a18c015b5873b3d$export$57c5a5dc5aa19bdf(35, loc));
    let eventName;
    if (arg.type === 4) {
        if (arg.isStatic) {
            let rawName = arg.content;
            if (rawName.startsWith("vue:")) rawName = `vnode-${rawName.slice(4)}`;
            const eventString = node.tagType !== 0 || rawName.startsWith("vnode") || !/[A-Z]/.test(rawName) ? // for non-element and vnode lifecycle event listeners, auto convert
            // it to camelCase. See issue #2249
            (0, $a5gC8.toHandlerKey)((0, $a5gC8.camelize)(rawName)) : // preserve case for plain element listeners that have uppercase
            // letters, as these may be custom elements' custom events
            `on:${rawName}`;
            eventName = $0a18c015b5873b3d$export$ac2aa689b44cdd23(eventString, true, arg.loc);
        } else eventName = $0a18c015b5873b3d$export$60ad01cd5cde5e50([
            `${context.helperString($0a18c015b5873b3d$export$8687eaac3cd39ddd)}(`,
            arg,
            `)`
        ]);
    } else {
        eventName = arg;
        eventName.children.unshift(`${context.helperString($0a18c015b5873b3d$export$8687eaac3cd39ddd)}(`);
        eventName.children.push(`)`);
    }
    let exp = dir.exp;
    if (exp && !exp.content.trim()) exp = void 0;
    let shouldCache = context.cacheHandlers && !exp && !context.inVOnce;
    if (exp) {
        const isMemberExp = $0a18c015b5873b3d$export$9c8bdf9fab617ce4(exp);
        const isInlineStatement = !(isMemberExp || $0a18c015b5873b3d$export$482164e6e5517986(exp));
        const hasMultipleStatements = exp.content.includes(`;`);
        if (isInlineStatement || shouldCache && isMemberExp) exp = $0a18c015b5873b3d$export$60ad01cd5cde5e50([
            `${isInlineStatement ? `$event` : `${``}(...args)`} => ${hasMultipleStatements ? `{` : `(`}`,
            exp,
            hasMultipleStatements ? `}` : `)`
        ]);
    }
    let ret = {
        props: [
            $0a18c015b5873b3d$export$45231d90c148ea74(eventName, exp || $0a18c015b5873b3d$export$ac2aa689b44cdd23(`() => {}`, false, loc))
        ]
    };
    if (augmentor) ret = augmentor(ret);
    if (shouldCache) ret.props[0].value = context.cache(ret.props[0].value);
    ret.props.forEach((p)=>p.key.isHandlerKey = true);
    return ret;
};
const $0a18c015b5873b3d$var$transformText = (node, context)=>{
    if (node.type === 0 || node.type === 1 || node.type === 11 || node.type === 10) return ()=>{
        const children = node.children;
        let currentContainer = void 0;
        let hasText = false;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if ($0a18c015b5873b3d$export$1879817ac5c922b7(child)) {
                hasText = true;
                for(let j = i + 1; j < children.length; j++){
                    const next = children[j];
                    if ($0a18c015b5873b3d$export$1879817ac5c922b7(next)) {
                        if (!currentContainer) currentContainer = children[i] = $0a18c015b5873b3d$export$60ad01cd5cde5e50([
                            child
                        ], child.loc);
                        currentContainer.children.push(` + `, next);
                        children.splice(j, 1);
                        j--;
                    } else {
                        currentContainer = void 0;
                        break;
                    }
                }
            }
        }
        if (!hasText || // if this is a plain element with a single text child, leave it
        // as-is since the runtime has dedicated fast path for this by directly
        // setting textContent of the element.
        // for component root it's always normalized anyway.
        children.length === 1 && (node.type === 0 || node.type === 1 && node.tagType === 0 && // #3756
        // custom directives can potentially add DOM elements arbitrarily,
        // we need to avoid setting textContent of the element at runtime
        // to avoid accidentally overwriting the DOM elements added
        // by the user through custom directives.
        !node.props.find((p)=>p.type === 7 && !context.directiveTransforms[p.name]) && // in compat mode, <template> tags with no special directives
        // will be rendered as a fragment so its children must be
        // converted into vnodes.
        !(node.tag === "template"))) return;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if ($0a18c015b5873b3d$export$1879817ac5c922b7(child) || child.type === 8) {
                const callArgs = [];
                if (child.type !== 2 || child.content !== " ") callArgs.push(child);
                if (!context.ssr && $0a18c015b5873b3d$export$7967f5197c38d72a(child, context) === 0) callArgs.push(1 + ``);
                children[i] = {
                    type: 12,
                    content: child,
                    loc: child.loc,
                    codegenNode: $0a18c015b5873b3d$export$2cdf8617f9d8e39d(context.helper($0a18c015b5873b3d$export$8890896270dfc293), callArgs)
                };
            }
        }
    };
};
const $0a18c015b5873b3d$var$seen$1 = /* @__PURE__ */ new WeakSet();
const $0a18c015b5873b3d$var$transformOnce = (node, context)=>{
    if (node.type === 1 && $0a18c015b5873b3d$export$1199bc2a2b648c8c(node, "once", true)) {
        if ($0a18c015b5873b3d$var$seen$1.has(node) || context.inVOnce || context.inSSR) return;
        $0a18c015b5873b3d$var$seen$1.add(node);
        context.inVOnce = true;
        context.helper($0a18c015b5873b3d$export$37cf1f9ab937c10d);
        return ()=>{
            context.inVOnce = false;
            const cur = context.currentNode;
            if (cur.codegenNode) cur.codegenNode = context.cache(cur.codegenNode, true);
        };
    }
};
const $0a18c015b5873b3d$export$567db1f69abf4dcb = (dir, node, context)=>{
    const { exp: exp, arg: arg } = dir;
    if (!exp) {
        context.onError($0a18c015b5873b3d$export$57c5a5dc5aa19bdf(41, dir.loc));
        return $0a18c015b5873b3d$var$createTransformProps();
    }
    const rawExp = exp.loc.source.trim();
    const expString = exp.type === 4 ? exp.content : rawExp;
    const bindingType = context.bindingMetadata[rawExp];
    if (bindingType === "props" || bindingType === "props-aliased") {
        context.onError($0a18c015b5873b3d$export$57c5a5dc5aa19bdf(44, exp.loc));
        return $0a18c015b5873b3d$var$createTransformProps();
    }
    const maybeRef = false;
    if (!expString.trim() || !$0a18c015b5873b3d$export$9c8bdf9fab617ce4(exp) && !maybeRef) {
        context.onError($0a18c015b5873b3d$export$57c5a5dc5aa19bdf(42, exp.loc));
        return $0a18c015b5873b3d$var$createTransformProps();
    }
    const propName = arg ? arg : $0a18c015b5873b3d$export$ac2aa689b44cdd23("modelValue", true);
    const eventName = arg ? $0a18c015b5873b3d$export$43d387e2d68b51dc(arg) ? `onUpdate:${(0, $a5gC8.camelize)(arg.content)}` : $0a18c015b5873b3d$export$60ad01cd5cde5e50([
        '"onUpdate:" + ',
        arg
    ]) : `onUpdate:modelValue`;
    let assignmentExp;
    const eventArg = context.isTS ? `($event: any)` : `$event`;
    assignmentExp = $0a18c015b5873b3d$export$60ad01cd5cde5e50([
        `${eventArg} => ((`,
        exp,
        `) = $event)`
    ]);
    const props = [
        // modelValue: foo
        $0a18c015b5873b3d$export$45231d90c148ea74(propName, dir.exp),
        // "onUpdate:modelValue": $event => (foo = $event)
        $0a18c015b5873b3d$export$45231d90c148ea74(eventName, assignmentExp)
    ];
    if (dir.modifiers.length && node.tagType === 1) {
        const modifiers = dir.modifiers.map((m)=>m.content).map((m)=>($0a18c015b5873b3d$export$3cb8486ad206c65(m) ? m : JSON.stringify(m)) + `: true`).join(`, `);
        const modifiersKey = arg ? $0a18c015b5873b3d$export$43d387e2d68b51dc(arg) ? `${arg.content}Modifiers` : $0a18c015b5873b3d$export$60ad01cd5cde5e50([
            arg,
            ' + "Modifiers"'
        ]) : `modelModifiers`;
        props.push($0a18c015b5873b3d$export$45231d90c148ea74(modifiersKey, $0a18c015b5873b3d$export$ac2aa689b44cdd23(`{ ${modifiers} }`, false, dir.loc, 2)));
    }
    return $0a18c015b5873b3d$var$createTransformProps(props);
};
function $0a18c015b5873b3d$var$createTransformProps(props = []) {
    return {
        props: props
    };
}
const $0a18c015b5873b3d$var$validDivisionCharRE = /[\w).+\-_$\]]/;
const $0a18c015b5873b3d$var$transformFilter = (node, context)=>{
    if (!$0a18c015b5873b3d$var$isCompatEnabled("COMPILER_FILTERS", context)) return;
    if (node.type === 5) $0a18c015b5873b3d$var$rewriteFilter(node.content, context);
    else if (node.type === 1) node.props.forEach((prop)=>{
        if (prop.type === 7 && prop.name !== "for" && prop.exp) $0a18c015b5873b3d$var$rewriteFilter(prop.exp, context);
    });
};
function $0a18c015b5873b3d$var$rewriteFilter(node, context) {
    if (node.type === 4) $0a18c015b5873b3d$var$parseFilter(node, context);
    else for(let i = 0; i < node.children.length; i++){
        const child = node.children[i];
        if (typeof child !== "object") continue;
        if (child.type === 4) $0a18c015b5873b3d$var$parseFilter(child, context);
        else if (child.type === 8) $0a18c015b5873b3d$var$rewriteFilter(node, context);
        else if (child.type === 5) $0a18c015b5873b3d$var$rewriteFilter(child.content, context);
    }
}
function $0a18c015b5873b3d$var$parseFilter(node, context) {
    const exp = node.content;
    let inSingle = false;
    let inDouble = false;
    let inTemplateString = false;
    let inRegex = false;
    let curly = 0;
    let square = 0;
    let paren = 0;
    let lastFilterIndex = 0;
    let c, prev, i, expression, filters = [];
    for(i = 0; i < exp.length; i++){
        prev = c;
        c = exp.charCodeAt(i);
        if (inSingle) {
            if (c === 39 && prev !== 92) inSingle = false;
        } else if (inDouble) {
            if (c === 34 && prev !== 92) inDouble = false;
        } else if (inTemplateString) {
            if (c === 96 && prev !== 92) inTemplateString = false;
        } else if (inRegex) {
            if (c === 47 && prev !== 92) inRegex = false;
        } else if (c === 124 && // pipe
        exp.charCodeAt(i + 1) !== 124 && exp.charCodeAt(i - 1) !== 124 && !curly && !square && !paren) {
            if (expression === void 0) {
                lastFilterIndex = i + 1;
                expression = exp.slice(0, i).trim();
            } else pushFilter();
        } else {
            switch(c){
                case 34:
                    inDouble = true;
                    break;
                // "
                case 39:
                    inSingle = true;
                    break;
                // '
                case 96:
                    inTemplateString = true;
                    break;
                // `
                case 40:
                    paren++;
                    break;
                // (
                case 41:
                    paren--;
                    break;
                // )
                case 91:
                    square++;
                    break;
                // [
                case 93:
                    square--;
                    break;
                // ]
                case 123:
                    curly++;
                    break;
                // {
                case 125:
                    curly--;
                    break;
            }
            if (c === 47) {
                let j = i - 1;
                let p;
                for(; j >= 0; j--){
                    p = exp.charAt(j);
                    if (p !== " ") break;
                }
                if (!p || !$0a18c015b5873b3d$var$validDivisionCharRE.test(p)) inRegex = true;
            }
        }
    }
    if (expression === void 0) expression = exp.slice(0, i).trim();
    else if (lastFilterIndex !== 0) pushFilter();
    function pushFilter() {
        filters.push(exp.slice(lastFilterIndex, i).trim());
        lastFilterIndex = i + 1;
    }
    if (filters.length) {
        for(i = 0; i < filters.length; i++)expression = $0a18c015b5873b3d$var$wrapFilter(expression, filters[i], context);
        node.content = expression;
        node.ast = void 0;
    }
}
function $0a18c015b5873b3d$var$wrapFilter(exp, filter, context) {
    context.helper($0a18c015b5873b3d$export$2c190751e09c3969);
    const i = filter.indexOf("(");
    if (i < 0) {
        context.filters.add(filter);
        return `${$0a18c015b5873b3d$export$80505c1072df544f(filter, "filter")}(${exp})`;
    } else {
        const name = filter.slice(0, i);
        const args = filter.slice(i + 1);
        context.filters.add(name);
        return `${$0a18c015b5873b3d$export$80505c1072df544f(name, "filter")}(${exp}${args !== ")" ? "," + args : args}`;
    }
}
const $0a18c015b5873b3d$var$seen = /* @__PURE__ */ new WeakSet();
const $0a18c015b5873b3d$var$transformMemo = (node, context)=>{
    if (node.type === 1) {
        const dir = $0a18c015b5873b3d$export$1199bc2a2b648c8c(node, "memo");
        if (!dir || $0a18c015b5873b3d$var$seen.has(node)) return;
        $0a18c015b5873b3d$var$seen.add(node);
        return ()=>{
            const codegenNode = node.codegenNode || context.currentNode.codegenNode;
            if (codegenNode && codegenNode.type === 13) {
                if (node.tagType !== 1) $0a18c015b5873b3d$export$dc00c05f515bd739(codegenNode, context);
                node.codegenNode = $0a18c015b5873b3d$export$2cdf8617f9d8e39d(context.helper($0a18c015b5873b3d$export$a0fd71f0f7cd2781), [
                    dir.exp,
                    $0a18c015b5873b3d$export$253e05bfd5b6c4c6(void 0, codegenNode),
                    `_cache`,
                    String(context.cached.length)
                ]);
                context.cached.push(null);
            }
        };
    }
};
function $0a18c015b5873b3d$export$20c96dae9bab51d8(prefixIdentifiers) {
    return [
        [
            $0a18c015b5873b3d$var$transformOnce,
            $0a18c015b5873b3d$var$transformIf,
            $0a18c015b5873b3d$var$transformMemo,
            $0a18c015b5873b3d$var$transformFor,
            $0a18c015b5873b3d$var$transformFilter,
            $0a18c015b5873b3d$var$transformSlotOutlet,
            $0a18c015b5873b3d$export$5d90dc62c1c9e431,
            $0a18c015b5873b3d$export$f0a2c7894e526c50,
            $0a18c015b5873b3d$var$transformText
        ],
        {
            on: $0a18c015b5873b3d$export$ff060d152244ee7b,
            bind: $0a18c015b5873b3d$export$2fa367e7c04d4515,
            model: $0a18c015b5873b3d$export$567db1f69abf4dcb
        }
    ];
}
function $0a18c015b5873b3d$export$3243579822c486a0(source, options = {}) {
    const onError = options.onError || $0a18c015b5873b3d$var$defaultOnError;
    const isModuleMode = options.mode === "module";
    if (options.prefixIdentifiers === true) onError($0a18c015b5873b3d$export$57c5a5dc5aa19bdf(47));
    else if (isModuleMode) onError($0a18c015b5873b3d$export$57c5a5dc5aa19bdf(48));
    const prefixIdentifiers = false;
    if (options.cacheHandlers) onError($0a18c015b5873b3d$export$57c5a5dc5aa19bdf(49));
    if (options.scopeId && !isModuleMode) onError($0a18c015b5873b3d$export$57c5a5dc5aa19bdf(50));
    const resolvedOptions = (0, $a5gC8.extend)({}, options, {
        prefixIdentifiers: prefixIdentifiers
    });
    const ast = (0, $a5gC8.isString)(source) ? $0a18c015b5873b3d$export$f5f219d5f09c81b5(source, resolvedOptions) : source;
    const [nodeTransforms, directiveTransforms] = $0a18c015b5873b3d$export$20c96dae9bab51d8();
    $0a18c015b5873b3d$export$51186ad6e864892a(ast, (0, $a5gC8.extend)({}, resolvedOptions, {
        nodeTransforms: [
            ...nodeTransforms,
            ...options.nodeTransforms || []
        ],
        directiveTransforms: (0, $a5gC8.extend)({}, directiveTransforms, options.directiveTransforms || {})
    }));
    return $0a18c015b5873b3d$export$80d376111cc09ad7(ast, resolvedOptions);
}
const $0a18c015b5873b3d$export$54871af2607057e6 = {
    "DATA": "data",
    "PROPS": "props",
    "PROPS_ALIASED": "props-aliased",
    "SETUP_LET": "setup-let",
    "SETUP_CONST": "setup-const",
    "SETUP_REACTIVE_CONST": "setup-reactive-const",
    "SETUP_MAYBE_REF": "setup-maybe-ref",
    "SETUP_REF": "setup-ref",
    "OPTIONS": "options",
    "LITERAL_CONST": "literal-const"
};
const $0a18c015b5873b3d$export$eb34aa2b2065da17 = ()=>({
        props: []
    });

});



parcelRegister("4rgor", function(module, exports) {

$parcel$export(module.exports, "default", () => $33b6666839fb0cbb$export$2e2bcd8739ae039);
parcelRequire("giao7");
var $9K9BQ = parcelRequire("9K9BQ");

var $cD5lK = parcelRequire("cD5lK");

var $j7S7Y = parcelRequire("j7S7Y");

var $9mfNp = parcelRequire("9mfNp");
class $33b6666839fb0cbb$export$2e2bcd8739ae039 {
    #colors;
    #fromDateReference;
    #toDateReference;
    timeSeries = (0, $9K9BQ.reactive)([]);
    /**
     * @param {Object} args
     * @param {vue.Reference} args.fromDateReference
     * @param {vue.Reference} args.toDateReference
     */ constructor({ fromDateReference: fromDateReference, toDateReference: toDateReference } = {}){
        this.#createColors();
        this.#fromDateReference = fromDateReference;
        this.#toDateReference = toDateReference;
    }
    /**
     * Create color palette with the total amount of expected colors we will use, then pass
     * them to the single time series entries. Docs see
     * https://mina86.github.io/palette.js/palette.js
     * Randomize palette as the original palette is rainbowy where similar colors are close to
     * each other
     */ #createColors() {
        this.#colors = (0, (/*@__PURE__*/$parcel$interopDefault($9mfNp)))("tol-rainbow", 12).map((item)=>({
                item: item,
                order: Math.random()
            })).sort((a, b)=>a.order - b.order).map(({ item: item })=>item);
    }
    #add(timeSeries) {
        this.timeSeries.push(timeSeries);
    }
    addFromCSV(text) {
        const parsed = (0, $j7S7Y.default)(text);
        parsed.forEach(({ data: data, name: columnName })=>{
            // Go through columns, transform data
            const transformedData = data.map(({ x: x, y: y })=>({
                    date: new Date(x),
                    value: parseFloat(y)
                }));
            const color = `#${this.#colors[this.timeSeries.length % this.#colors.length]}`;
            const timeSeries = new (0, $cD5lK.default)({
                data: transformedData,
                name: columnName,
                color: color,
                fromDateReference: this.#fromDateReference,
                toDateReference: this.#toDateReference
            });
            this.#add(timeSeries);
        });
    }
    /**
     * Returns the names of all timeSeries' parameters (taken from their column names)
     * @returns {String[]}
     */ getAllParameters() {
        return [
            ...this.timeSeries.reduce((previous, timeSeries)=>new Set([
                    ...previous,
                    ...timeSeries.parameters.keys()
                ]), new Set())
        ];
    }
    /**
     * Returns all values for a given parameter, as long as they belong to a visible timeSeries,
     * sorted ascending
     * @param {String} parameterName - Name of the parameter, see @method getAllParameters
     * @return {Float[]}
     */ getAllVisibleValuesForParameter(parameterName) {
        return [
            ...this.timeSeries.reduce((previous, timeSeries)=>{
                if (!timeSeries.visible) return previous;
                return new Set([
                    ...previous,
                    timeSeries.parameters.get(parameterName)
                ]);
            }, new Set())
        ].sort((a, b)=>a - b);
    }
    /**
     * Returns all timeSeries that match with a given parameter set
     * @param {[string, float][]} parameterValueSets - Array of tuples, where the first element is
     * the parameter name and the second element, e.g. [['base', 5], ['factor', 2]]
     * @returns {TimeSeries[]}
     */ getTimeSeriesForParametersAndValues(parameterValueSets) {
        console.log("parameterValueSets", parameterValueSets);
        return this.timeSeries.filter((timeSeries)=>parameterValueSets.every(([parameterName, value])=>timeSeries.parameters.get(parameterName) === value));
    }
}

});
parcelRegister("cD5lK", function(module, exports) {

$parcel$export(module.exports, "default", () => $931d46e4e5fc9db3$export$2e2bcd8739ae039);
parcelRequire("giao7");
var $9K9BQ = parcelRequire("9K9BQ");

var $ilYCa = parcelRequire("ilYCa");
var $7MJNE = parcelRequire("7MJNE");

var $8Um3G = parcelRequire("8Um3G");

var $aKqH2 = parcelRequire("aKqH2");
const $931d46e4e5fc9db3$var$getValues = (data)=>data.value.map(({ value: value })=>value);
const $931d46e4e5fc9db3$var$getDates = (data)=>data.value.map(({ date: date })=>date);
/**
 * Returns a function that we'll use as a filter function later; checks if from/to date filter
 * exists and is valid and if yes, compares an entry of the timeSeries to it. We use a factory
 * function in order to reduce duplicate code.
 */ const $931d46e4e5fc9db3$var$createMatcher = (dateFilterValue, lowerFilter = true)=>(value)=>{
        // There's no filter: return true
        if (!dateFilterValue) return true;
        const date = new Date(dateFilterValue);
        // Filter is invalid: Assume true
        if (Number.isNaN(date.getTime())) return true;
        return lowerFilter ? value.date.getTime() > date.getTime() : value.date.getTime() < date.getTime();
    };
class $931d46e4e5fc9db3$export$2e2bcd8739ae039 {
    /* type { date: Date, value: number }[] */ data = [];
    id = (0, $aKqH2.default)();
    name = "Unnamed";
    color = "#000000";
    visible = (0, $9K9BQ.ref)(true);
    #fromDateReference;
    #toDateReference;
    #originalData;
    /**
     * If the column name contains parameters (in the form of key:value), store them here. They're
     * mainly used to display heat maps across multiple TimeSeries.
     */ parameters = new Map();
    /**
     * We can't define color in here because the whole palette needs to be generated beforehand
     * to ensure high contrast between different TimeSeries.
     * Assume that we get valid data (data validation is done in parseCSV).
     * @param {Object} args
     * @param {{ date: Date, value: Number }[]} args.data
     * @param {String} args.name
     * @param {String} args.color
     * @param {vue.Reference} args.fromDateReference
     * @param {vue.Reference} args.toDateReference
     */ constructor({ data: data, name: name, color: color, toDateReference: toDateReference, fromDateReference: fromDateReference } = {}){
        this.#originalData = data;
        this.name = name;
        this.color = color;
        this.#fromDateReference = fromDateReference;
        this.#toDateReference = toDateReference;
        this.parameters = (0, $8Um3G.default)(name);
        this.#setupComputedIndicators();
    }
    #setupComputedIndicators() {
        console.log("Start setting up indicators");
        this.data = (0, $9K9BQ.computed)(()=>{
            const matchesFrom = $931d46e4e5fc9db3$var$createMatcher(this.#fromDateReference.value);
            const matchesTo = $931d46e4e5fc9db3$var$createMatcher(this.#toDateReference.value, false);
            const data = this.#originalData.filter((item)=>matchesFrom(item) && matchesTo(item));
            return data;
        });
        this.cagr = (0, $9K9BQ.computed)(()=>{
            const dates = $931d46e4e5fc9db3$var$getDates(this.data);
            return (0, $ilYCa.getCAGR)($931d46e4e5fc9db3$var$getValues(this.data), dates.at(0), dates.at(-1));
        });
        this.sortino = (0, $9K9BQ.computed)(()=>(0, $ilYCa.getSortino)($931d46e4e5fc9db3$var$getValues(this.data)));
        this.maxDD = (0, $9K9BQ.computed)(()=>(0, $ilYCa.getMaxRelativeDrawdown)($931d46e4e5fc9db3$var$getValues(this.data)));
        this.calmar = (0, $9K9BQ.computed)(()=>{
            const dates = $931d46e4e5fc9db3$var$getDates(this.data);
            return (0, $ilYCa.getCalmar)($931d46e4e5fc9db3$var$getValues(this.data), dates.at(0), dates.at(-1));
        });
        this.sharpe = (0, $9K9BQ.computed)(()=>{
            const dates = $931d46e4e5fc9db3$var$getDates(this.data);
            return (0, $ilYCa.getSharpe)($931d46e4e5fc9db3$var$getValues(this.data), dates.at(0), dates.at(-1));
        });
        this.linRegCAGR = (0, $9K9BQ.computed)(()=>{
            const start = new Date().getTime();
            const result = (0, $7MJNE.default)($931d46e4e5fc9db3$var$getValues(this.data), $931d46e4e5fc9db3$var$getDates(this.data));
            console.log("Time to calculate linRegCAGR:", new Date().getTime() - start);
            return result;
        });
        this.stdDev = (0, $9K9BQ.computed)(()=>(0, $ilYCa.getStandardDeviation)($931d46e4e5fc9db3$var$getValues(this.data)));
        this.robustRatio = (0, $9K9BQ.computed)(()=>(0, $ilYCa.getRobustRatio)($931d46e4e5fc9db3$var$getValues(this.data), $931d46e4e5fc9db3$var$getDates(this.data)));
        this.relativeTimeInMarket = (0, $9K9BQ.computed)(()=>(0, $ilYCa.getRelativeTimeInMarket)($931d46e4e5fc9db3$var$getValues(this.data)));
        this.cumulativeReturn = (0, $9K9BQ.computed)(()=>(0, $ilYCa.getCumulativeReturn)($931d46e4e5fc9db3$var$getValues(this.data)));
        console.log("Done setting up indicators");
    }
}

});
parcelRegister("ilYCa", function(module, exports) {

$parcel$export(module.exports, "getRelativeDrawdownAsSeries", () => $ec0fbdcc37f306b9$export$d8111a7369c4db7c);
$parcel$export(module.exports, "getMaxRelativeDrawdown", () => $ec0fbdcc37f306b9$export$baedc51119dc679c);
$parcel$export(module.exports, "getRelativeTimeInMarket", () => $ec0fbdcc37f306b9$export$bacfc6aa90571031);
$parcel$export(module.exports, "getCumulativeReturn", () => $ec0fbdcc37f306b9$export$709141ddbdb4416f);
$parcel$export(module.exports, "getCAGR", () => $ec0fbdcc37f306b9$export$5e90b6e0b9389ce6);
$parcel$export(module.exports, "getCalmar", () => $ec0fbdcc37f306b9$export$7a1fa5041a9049e4);
$parcel$export(module.exports, "getSortino", () => $ec0fbdcc37f306b9$export$2a0d2fd15642bf32);
$parcel$export(module.exports, "getStandardDeviation", () => $ec0fbdcc37f306b9$export$a1dda0690da3ddca);
$parcel$export(module.exports, "getSharpe", () => $ec0fbdcc37f306b9$export$334e46916966750c);
$parcel$export(module.exports, "getNormalizedAsSeries", () => $ec0fbdcc37f306b9$export$297995f09bca19d3);
$parcel$export(module.exports, "getRobustRatio", () => $ec0fbdcc37f306b9$export$25a128b7cef9ba);
$parcel$export(module.exports, "getLinearRegressionCAGR", () => (parcelRequire("7MJNE")).default);

var $aZmEn = parcelRequire("aZmEn");

var $kmmp9 = parcelRequire("kmmp9");

var $8ayA8 = parcelRequire("8ayA8");

var $7MJNE = parcelRequire("7MJNE");
const { yearInMs: $ec0fbdcc37f306b9$var$yearInMs } = (0, $8ayA8.default)();
/**
 * Returns the maximum value of all previous and the current item as an array.
 * @param {Number[]} data
 * @returns {Number[]}
 */ const $ec0fbdcc37f306b9$export$ded33df8bc89ed65 = (data)=>(0, $kmmp9.default)(data, "number").reduce((prev, item)=>[
            ...prev,
            Math.max(prev.at(-1) ?? -Infinity, item)
        ], []);
/**
 * Returns the relative drawdown for a an array as an array; drawdowns are always ≤ 0.
 * @param {Number[]} data
 * @returns {Number[]}
 */ const $ec0fbdcc37f306b9$export$d8111a7369c4db7c = (data)=>{
    const max = $ec0fbdcc37f306b9$export$ded33df8bc89ed65((0, $kmmp9.default)(data, "number"));
    return data.map((item, index)=>item / max[index] - 1);
};
/**
 * Returns the maximum relative drawdown, e.g. -0.17 for a 17% drawdown (return value is always
 * <= 0)
 * @param {Number[]} data
 * @returns {Number}
 */ const $ec0fbdcc37f306b9$export$baedc51119dc679c = (data)=>Math.min(...$ec0fbdcc37f306b9$export$d8111a7369c4db7c(data));
/**
 * Returns the relative change from the current to the previous item; if the change is 2% up,
 * the return value will be 0.02. First value will always be NaN.
 * @param {Number[]} data
 * @returns {Number[]}
 */ const $ec0fbdcc37f306b9$export$d81fdfe681c9bbc8 = (data)=>(0, $kmmp9.default)(data, "number").map((item, index)=>item / data[index - 1] - 1);
/**
 * Returns the average of a series.
 * @param {Number[]} data
 * @returns {Number}
 */ const $ec0fbdcc37f306b9$export$4c1248d708f92e20 = (data)=>(0, $kmmp9.default)(data, "number").reduce((sum, item)=>sum + item) / data.length;
/**
 * Returns relative time in market. We assume that unchanged values indicate that at this moment,
 * we were *not* in the market. The first entry in data is ignored as we do not know if it
 * changed compared to the previous (inexisting) entry; if we pass 6 values, 2 of which are
 * unchanged (e.g. 5, 3, 3, 4, 4, 5), the returned value will be 3 / 5 or 0.6.
 * @param {Number[]} data
 * @returns {Number}
 */ const $ec0fbdcc37f306b9$export$bacfc6aa90571031 = (data)=>// Ignore first entry in array because its relative change is NaN and we just don't know if we
    // were in the market on that date or not
    1 - $ec0fbdcc37f306b9$export$d81fdfe681c9bbc8(data).filter((item)=>item === 0).length / ((0, $kmmp9.default)(data).length - 1);
/**
 * Returns cumulative return, e.g. 0.2 for a 20% return (from the first item of data to the last
 * item of data).
 * @param {Number[]} data
 * @returns {Number}
 */ const $ec0fbdcc37f306b9$export$709141ddbdb4416f = (data)=>(0, $kmmp9.default)(data) && data.at(-1) / data.at(0);
/**
 * Returns compound annual growth rate ((endValue / startValue) ** (1 / years)) - 1 where a
 * year is assumed to have 365 days. Returns fraction (e.g. 0.05 for 5%).
 * See https://www.investopedia.com/terms/c/cagr.asp
 * @param {Number[]} data
 * @param {Date} startDate
 * @param {Date} endDate
 * @returns {Number}
 */ const $ec0fbdcc37f306b9$export$5e90b6e0b9389ce6 = (data, startDate, endDate)=>{
    [
        [
            startDate,
            "startDate"
        ],
        [
            endDate,
            "endDate"
        ]
    ].forEach(([date, name])=>{
        if (!(date instanceof Date)) throw new Error(`Parameter ${name} must be an instance of Date, is ${date} instead.`);
    });
    if (startDate.getTime() >= endDate.getTime()) throw new Error(`Parameter startDate (${startDate}) must lie before endDate (${endDate}).`);
    const diffInYears = (endDate.getTime() - startDate.getTime()) / $ec0fbdcc37f306b9$var$yearInMs;
    return $ec0fbdcc37f306b9$export$709141ddbdb4416f(data) ** (1 / diffInYears) - 1;
};
/**
 * Returns calmar ratio (CAGR / max drawdown)
 * @param {Number[]} data
 * @param {Date} startDate
 * @param {Date} endDate
 * @returns {Number}
 */ const $ec0fbdcc37f306b9$export$7a1fa5041a9049e4 = (data, startDate, endDate)=>$ec0fbdcc37f306b9$export$5e90b6e0b9389ce6(data, startDate, endDate) / Math.max(...$ec0fbdcc37f306b9$export$d8111a7369c4db7c(data).map(Math.abs));
/**
 * Returns the sortino ratio, according to calculations outlined by
 * http://www.redrockcapital.com/Sortino__A__Sharper__Ratio_Red_Rock_Capital.pdf
 * @param {Number[]} data
 * @returns {Number}
 */ const $ec0fbdcc37f306b9$export$2a0d2fd15642bf32 = (data)=>{
    const returns = $ec0fbdcc37f306b9$export$d81fdfe681c9bbc8(data);
    const downs = returns// Get rid of that first NaN
    .slice(1).filter((item)=>item < 0);
    // If all returns are 0, the following code will fail (because we cannot reduce over an
    // empty array without an initial value); return 0 instead
    if (downs.length === 0) return 0;
    const downsideSum = downs.map((item)=>item ** 2).reduce((sum, item)=>sum + item);
    // Ignore first entry as its change is NaN
    const downside = Math.sqrt(downsideSum / downs.length);
    return $ec0fbdcc37f306b9$export$4c1248d708f92e20($ec0fbdcc37f306b9$export$d81fdfe681c9bbc8(data).slice(1)) / downside;
};
/**
 * Returns the standard deviation of the data set
 * @param {Number} data
 * @returns {Number}
 */ const $ec0fbdcc37f306b9$export$a1dda0690da3ddca = (data)=>(0, $aZmEn.standardDeviation)((0, $kmmp9.default)(data));
/**
 * Returns the sharpe ration of the data set
 * @param {Number[]} data
 * @param {Date} startDate
 * @param {Date} endDate
 * @returns {Number}
 */ const $ec0fbdcc37f306b9$export$334e46916966750c = (data, startDate, endDate)=>$ec0fbdcc37f306b9$export$5e90b6e0b9389ce6(data, startDate, endDate) / $ec0fbdcc37f306b9$export$a1dda0690da3ddca(data);
/**
 * Returns data as a 1-based series (the first entry is 1, all following entries have the same
 * relative difference as the original series)
 * @param {Number[]} data
 * @returns {Number[]}
 */ const $ec0fbdcc37f306b9$export$297995f09bca19d3 = (data)=>(0, $kmmp9.default)(data).map((item)=>item / data[0]);
/**
 * @deprecated
 * Do not use anymore; linearRegression method from simple-statistics is rather slow, this solution
 * did not account for exponential growth.
 *
 * Returns linear regression for a dataset, consisting of slope m and intersect b. Uses
 * http://simple-statistics.github.io/docs/#linearregression.
 * @param {Number[]} data
 * @param {Number[]?} xValues       x values; if not provided, integers starting at 0
 *                                  up will be used
 * @returns {m: Number, b: Number}
 */ const $ec0fbdcc37f306b9$export$484982720961754e = (yValues, xValues)=>{
    if (xValues && xValues.length !== yValues.length) throw new Error(`If the xValues are provided for getLinearRegression, they must be an array with the same amout of items as yValues; xValues.length is ${xValues.length}, yValues.length is ${yValues.length}.`);
    return (0, $aZmEn.linearRegression)((0, $kmmp9.default)(yValues).map((value, index)=>[
            xValues ? xValues[index] : index,
            value
        ]));
};
/**
 * Returns the self-invented robust ratio, i.e. the CAGR for the linear regression of the series
 * multiplied by (1 - max drawdown).
 * @param {Number[]} data
 * @param {Date[]} dates
 * @returns {Number}
 */ const $ec0fbdcc37f306b9$export$25a128b7cef9ba = (data, dates)=>// getMaxRelativeDrawdown alsways returns a negative value
    (0, $7MJNE.default)(data, dates) * (1 + $ec0fbdcc37f306b9$export$baedc51119dc679c(data));

});
parcelRegister("aZmEn", function(module, exports) {

$parcel$export(module.exports, "linearRegression", () => $5b56aa3f46fee21b$export$534d495db1d2c72c);
$parcel$export(module.exports, "standardDeviation", () => $5b56aa3f46fee21b$export$3cc65d9d108eb4e1);
/**
 * [Simple linear regression](http://en.wikipedia.org/wiki/Simple_linear_regression)
 * is a simple way to find a fitted line
 * between a set of coordinates. This algorithm finds the slope and y-intercept of a regression line
 * using the least sum of squares.
 *
 * @param {Array<Array<number>>} data an array of two-element of arrays,
 * like `[[0, 1], [2, 3]]`
 * @returns {Object} object containing slope and intersect of regression line
 * @example
 * linearRegression([[0, 0], [1, 1]]); // => { m: 1, b: 0 }
 */ function $5b56aa3f46fee21b$export$534d495db1d2c72c(data) {
    var m;
    var b;
    // Store data length in a local variable to reduce
    // repeated object property lookups
    var dataLength = data.length;
    //if there's only one point, arbitrarily choose a slope of 0
    //and a y-intercept of whatever the y of the initial point is
    if (dataLength === 1) {
        m = 0;
        b = data[0][1];
    } else {
        // Initialize our sums and scope the `m` and `b`
        // variables that define the line.
        var sumX = 0;
        var sumY = 0;
        var sumXX = 0;
        var sumXY = 0;
        // Use local variables to grab point values
        // with minimal object property lookups
        var point;
        var x;
        var y;
        // Gather the sum of all x values, the sum of all
        // y values, and the sum of x^2 and (x*y) for each
        // value.
        //
        // In math notation, these would be SS_x, SS_y, SS_xx, and SS_xy
        for(var i = 0; i < dataLength; i++){
            point = data[i];
            x = point[0];
            y = point[1];
            sumX += x;
            sumY += y;
            sumXX += x * x;
            sumXY += x * y;
        }
        // `m` is the slope of the regression line
        m = (dataLength * sumXY - sumX * sumY) / (dataLength * sumXX - sumX * sumX);
        // `b` is the y-intercept of the line.
        b = sumY / dataLength - m * sumX / dataLength;
    }
    // Return both values as an object.
    return {
        m: m,
        b: b
    };
}
/**
 * Given the output of `linearRegression`: an object
 * with `m` and `b` values indicating slope and intercept,
 * respectively, generate a line function that translates
 * x values into y values.
 *
 * @param {Object} mb object with `m` and `b` members, representing
 * slope and intersect of desired line
 * @returns {Function} method that computes y-value at any given
 * x-value on the line.
 * @example
 * var l = linearRegressionLine(linearRegression([[0, 0], [1, 1]]));
 * l(0) // = 0
 * l(2) // = 2
 * linearRegressionLine({ b: 0, m: 1 })(1); // => 1
 * linearRegressionLine({ b: 1, m: 1 })(1); // => 2
 */ function $5b56aa3f46fee21b$export$4d701c9fd6a2e126(mb /*: { b: number, m: number }*/ ) {
    // Return a function that computes a `y` value for each
    // x value it is given, based on the values of `b` and `a`
    // that we just computed.
    return function(x) {
        return mb.b + mb.m * x;
    };
}
/**
 * Our default sum is the [Kahan-Babuska algorithm](https://pdfs.semanticscholar.org/1760/7d467cda1d0277ad272deb2113533131dc09.pdf).
 * This method is an improvement over the classical
 * [Kahan summation algorithm](https://en.wikipedia.org/wiki/Kahan_summation_algorithm).
 * It aims at computing the sum of a list of numbers while correcting for
 * floating-point errors. Traditionally, sums are calculated as many
 * successive additions, each one with its own floating-point roundoff. These
 * losses in precision add up as the number of numbers increases. This alternative
 * algorithm is more accurate than the simple way of calculating sums by simple
 * addition.
 *
 * This runs in `O(n)`, linear time, with respect to the length of the array.
 *
 * @param {Array<number>} x input
 * @return {number} sum of all input numbers
 * @example
 * sum([1, 2, 3]); // => 6
 */ function $5b56aa3f46fee21b$export$8a63f25cc62965f1(x) {
    // If the array is empty, we needn't bother computing its sum
    if (x.length === 0) return 0;
    // Initializing the sum as the first number in the array
    var sum = x[0];
    // Keeping track of the floating-point error correction
    var correction = 0;
    var transition;
    if (typeof sum !== "number") return Number.NaN;
    for(var i = 1; i < x.length; i++){
        if (typeof x[i] !== "number") return Number.NaN;
        transition = sum + x[i];
        // Here we need to update the correction in a different fashion
        // if the new absolute value is greater than the absolute sum
        if (Math.abs(sum) >= Math.abs(x[i])) correction += sum - transition + x[i];
        else correction += x[i] - transition + sum;
        sum = transition;
    }
    // Returning the corrected sum
    return sum + correction;
}
/**
 * The mean, _also known as average_,
 * is the sum of all values over the number of values.
 * This is a [measure of central tendency](https://en.wikipedia.org/wiki/Central_tendency):
 * a method of finding a typical or central value of a set of numbers.
 *
 * This runs in `O(n)`, linear time, with respect to the length of the array.
 *
 * @param {Array<number>} x sample of one or more data points
 * @throws {Error} if the length of x is less than one
 * @returns {number} mean
 * @example
 * mean([0, 10]); // => 5
 */ function $5b56aa3f46fee21b$export$cc6710ee5f037d57(x) {
    if (x.length === 0) throw new Error("mean requires at least one data point");
    return $5b56aa3f46fee21b$export$8a63f25cc62965f1(x) / x.length;
}
/**
 * The sum of deviations to the Nth power.
 * When n=2 it's the sum of squared deviations.
 * When n=3 it's the sum of cubed deviations.
 *
 * @param {Array<number>} x
 * @param {number} n power
 * @returns {number} sum of nth power deviations
 *
 * @example
 * var input = [1, 2, 3];
 * // since the variance of a set is the mean squared
 * // deviations, we can calculate that with sumNthPowerDeviations:
 * sumNthPowerDeviations(input, 2) / input.length;
 */ function $5b56aa3f46fee21b$export$b447fa15e39b76c0(x, n) {
    var meanValue = $5b56aa3f46fee21b$export$cc6710ee5f037d57(x);
    var sum = 0;
    var tempValue;
    var i;
    // This is an optimization: when n is 2 (we're computing a number squared),
    // multiplying the number by itself is significantly faster than using
    // the Math.pow method.
    if (n === 2) for(i = 0; i < x.length; i++){
        tempValue = x[i] - meanValue;
        sum += tempValue * tempValue;
    }
    else for(i = 0; i < x.length; i++)sum += Math.pow(x[i] - meanValue, n);
    return sum;
}
/**
 * The [variance](http://en.wikipedia.org/wiki/Variance)
 * is the sum of squared deviations from the mean.
 *
 * This is an implementation of variance, not sample variance:
 * see the `sampleVariance` method if you want a sample measure.
 *
 * @param {Array<number>} x a population of one or more data points
 * @returns {number} variance: a value greater than or equal to zero.
 * zero indicates that all values are identical.
 * @throws {Error} if x's length is 0
 * @example
 * variance([1, 2, 3, 4, 5, 6]); // => 2.9166666666666665
 */ function $5b56aa3f46fee21b$export$9b77da0927470c3d(x) {
    if (x.length === 0) throw new Error("variance requires at least one data point");
    // Find the mean of squared deviations between the
    // mean value and each value.
    return $5b56aa3f46fee21b$export$b447fa15e39b76c0(x, 2) / x.length;
}
/**
 * The [standard deviation](http://en.wikipedia.org/wiki/Standard_deviation)
 * is the square root of the variance. This is also known as the population
 * standard deviation. It's useful for measuring the amount
 * of variation or dispersion in a set of values.
 *
 * Standard deviation is only appropriate for full-population knowledge: for
 * samples of a population, {@link sampleStandardDeviation} is
 * more appropriate.
 *
 * @param {Array<number>} x input
 * @returns {number} standard deviation
 * @example
 * variance([2, 4, 4, 4, 5, 5, 7, 9]); // => 4
 * standardDeviation([2, 4, 4, 4, 5, 5, 7, 9]); // => 2
 */ function $5b56aa3f46fee21b$export$3cc65d9d108eb4e1(x) {
    if (x.length === 1) return 0;
    var v = $5b56aa3f46fee21b$export$9b77da0927470c3d(x);
    return Math.sqrt(v);
}
/**
 * The [R Squared](http://en.wikipedia.org/wiki/Coefficient_of_determination)
 * value of data compared with a function `f`
 * is the sum of the squared differences between the prediction
 * and the actual value.
 *
 * @param {Array<Array<number>>} x input data: this should be doubly-nested
 * @param {Function} func function called on `[i][0]` values within the dataset
 * @returns {number} r-squared value
 * @example
 * var samples = [[0, 0], [1, 1]];
 * var regressionLine = linearRegressionLine(linearRegression(samples));
 * rSquared(samples, regressionLine); // = 1 this line is a perfect fit
 */ function $5b56aa3f46fee21b$export$da4dc3481815180a(x, func) {
    if (x.length < 2) return 1;
    // Compute the average y value for the actual
    // data set in order to compute the
    // _total sum of squares_
    var sum = 0;
    for(var i = 0; i < x.length; i++)sum += x[i][1];
    var average = sum / x.length;
    // Compute the total sum of squares - the
    // squared difference between each point
    // and the average of all points.
    var sumOfSquares = 0;
    for(var j = 0; j < x.length; j++)sumOfSquares += Math.pow(average - x[j][1], 2);
    // Finally estimate the error: the squared
    // difference between the estimate and the actual data
    // value at each point.
    var err = 0;
    for(var k = 0; k < x.length; k++)err += Math.pow(x[k][1] - func(x[k][0]), 2);
    // As the error grows larger, its ratio to the
    // sum of squares increases and the r squared
    // value grows lower.
    return 1 - err / sumOfSquares;
}
/**
 * The [mode](https://en.wikipedia.org/wiki/Mode_%28statistics%29) is the number
 * that appears in a list the highest number of times.
 * There can be multiple modes in a list: in the event of a tie, this
 * algorithm will return the most recently seen mode.
 *
 * This is a [measure of central tendency](https://en.wikipedia.org/wiki/Central_tendency):
 * a method of finding a typical or central value of a set of numbers.
 *
 * This runs in `O(n)` because the input is sorted.
 *
 * @param {Array<number>} sorted a sample of one or more data points
 * @returns {number} mode
 * @throws {Error} if sorted is empty
 * @example
 * modeSorted([0, 0, 1]); // => 0
 */ function $5b56aa3f46fee21b$export$2efc0391b42dc53b(sorted) {
    // Handle edge cases:
    // The mode of an empty list is undefined
    if (sorted.length === 0) throw new Error("mode requires at least one data point");
    if (sorted.length === 1) return sorted[0];
    // This assumes it is dealing with an array of size > 1, since size
    // 0 and 1 are handled immediately. Hence it starts at index 1 in the
    // array.
    var last = sorted[0];
    // store the mode as we find new modes
    var value = Number.NaN;
    // store how many times we've seen the mode
    var maxSeen = 0;
    // how many times the current candidate for the mode
    // has been seen
    var seenThis = 1;
    // end at sorted.length + 1 to fix the case in which the mode is
    // the highest number that occurs in the sequence. the last iteration
    // compares sorted[i], which is undefined, to the highest number
    // in the series
    for(var i = 1; i < sorted.length + 1; i++)// we're seeing a new number pass by
    if (sorted[i] !== last) {
        // the last number is the new mode since we saw it more
        // often than the old one
        if (seenThis > maxSeen) {
            maxSeen = seenThis;
            value = last;
        }
        seenThis = 1;
        last = sorted[i];
    // if this isn't a new number, it's one more occurrence of
    // the potential mode
    } else seenThis++;
    return value;
}
/**
 * Sort an array of numbers by their numeric value, ensuring that the
 * array is not changed in place.
 *
 * This is necessary because the default behavior of .sort
 * in JavaScript is to sort arrays as string values
 *
 *     [1, 10, 12, 102, 20].sort()
 *     // output
 *     [1, 10, 102, 12, 20]
 *
 * @param {Array<number>} x input array
 * @return {Array<number>} sorted array
 * @private
 * @example
 * numericSort([3, 2, 1]) // => [1, 2, 3]
 */ function $5b56aa3f46fee21b$export$5b66f3fff0c2847f(x) {
    return x// ensure the array is not changed in-place
    .slice()// comparator function that treats input as numeric
    .sort(function(a, b) {
        return a - b;
    });
}
/**
 * The [mode](https://en.wikipedia.org/wiki/Mode_%28statistics%29) is the number
 * that appears in a list the highest number of times.
 * There can be multiple modes in a list: in the event of a tie, this
 * algorithm will return the most recently seen mode.
 *
 * This is a [measure of central tendency](https://en.wikipedia.org/wiki/Central_tendency):
 * a method of finding a typical or central value of a set of numbers.
 *
 * This runs in `O(n log(n))` because it needs to sort the array internally
 * before running an `O(n)` search to find the mode.
 *
 * @param {Array<number>} x input
 * @returns {number} mode
 * @example
 * mode([0, 0, 1]); // => 0
 */ function $5b56aa3f46fee21b$export$549ff81930776885(x) {
    // Sorting the array lets us iterate through it below and be sure
    // that every time we see a new number it's new and we'll never
    // see the same number twice
    return $5b56aa3f46fee21b$export$2efc0391b42dc53b($5b56aa3f46fee21b$export$5b66f3fff0c2847f(x));
}
/* globals Map: false */ /**
 * The [mode](https://en.wikipedia.org/wiki/Mode_%28statistics%29) is the number
 * that appears in a list the highest number of times.
 * There can be multiple modes in a list: in the event of a tie, this
 * algorithm will return the most recently seen mode.
 *
 * modeFast uses a Map object to keep track of the mode, instead of the approach
 * used with `mode`, a sorted array. As a result, it is faster
 * than `mode` and supports any data type that can be compared with `==`.
 * It also requires a
 * [JavaScript environment with support for Map](https://kangax.github.io/compat-table/es6/#test-Map),
 * and will throw an error if Map is not available.
 *
 * This is a [measure of central tendency](https://en.wikipedia.org/wiki/Central_tendency):
 * a method of finding a typical or central value of a set of numbers.
 *
 * @param {Array<*>} x a sample of one or more data points
 * @returns {?*} mode
 * @throws {ReferenceError} if the JavaScript environment doesn't support Map
 * @throws {Error} if x is empty
 * @example
 * modeFast(['rabbits', 'rabbits', 'squirrels']); // => 'rabbits'
 */ function $5b56aa3f46fee21b$export$3531d3836c782cd0(x) {
    // This index will reflect the incidence of different values, indexing
    // them like
    // { value: count }
    var index = new Map();
    // A running `mode` and the number of times it has been encountered.
    var mode;
    var modeCount = 0;
    for(var i = 0; i < x.length; i++){
        var newCount = index.get(x[i]);
        if (newCount === undefined) newCount = 1;
        else newCount++;
        if (newCount > modeCount) {
            mode = x[i];
            modeCount = newCount;
        }
        index.set(x[i], newCount);
    }
    if (modeCount === 0) throw new Error("mode requires at last one data point");
    return mode;
}
/**
 * The min is the lowest number in the array.
 * This runs in `O(n)`, linear time, with respect to the length of the array.
 *
 * @param {Array<number>} x sample of one or more data points
 * @throws {Error} if the length of x is less than one
 * @returns {number} minimum value
 * @example
 * min([1, 5, -10, 100, 2]); // => -10
 */ function $5b56aa3f46fee21b$export$96ec731ed4dcb222(x) {
    if (x.length === 0) throw new Error("min requires at least one data point");
    var value = x[0];
    for(var i = 1; i < x.length; i++)if (x[i] < value) value = x[i];
    return value;
}
/**
 * This computes the maximum number in an array.
 *
 * This runs in `O(n)`, linear time, with respect to the length of the array.
 *
 * @param {Array<number>} x sample of one or more data points
 * @returns {number} maximum value
 * @throws {Error} if the length of x is less than one
 * @example
 * max([1, 2, 3, 4]);
 * // => 4
 */ function $5b56aa3f46fee21b$export$8960430cfd85939f(x) {
    if (x.length === 0) throw new Error("max requires at least one data point");
    var value = x[0];
    for(var i = 1; i < x.length; i++)if (x[i] > value) value = x[i];
    return value;
}
/**
 * This computes the minimum & maximum number in an array.
 *
 * This runs in `O(n)`, linear time, with respect to the length of the array.
 *
 * @param {Array<number>} x sample of one or more data points
 * @returns {Array<number>} minimum & maximum value
 * @throws {Error} if the length of x is less than one
 * @example
 * extent([1, 2, 3, 4]);
 * // => [1, 4]
 */ function $5b56aa3f46fee21b$export$6d28227ee394ab2a(x) {
    if (x.length === 0) throw new Error("extent requires at least one data point");
    var min = x[0];
    var max = x[0];
    for(var i = 1; i < x.length; i++){
        if (x[i] > max) max = x[i];
        if (x[i] < min) min = x[i];
    }
    return [
        min,
        max
    ];
}
/**
 * The minimum is the lowest number in the array. With a sorted array,
 * the first element in the array is always the smallest, so this calculation
 * can be done in one step, or constant time.
 *
 * @param {Array<number>} x input
 * @returns {number} minimum value
 * @example
 * minSorted([-100, -10, 1, 2, 5]); // => -100
 */ function $5b56aa3f46fee21b$export$73288f8e3979ebc5(x) {
    return x[0];
}
/**
 * The maximum is the highest number in the array. With a sorted array,
 * the last element in the array is always the largest, so this calculation
 * can be done in one step, or constant time.
 *
 * @param {Array<number>} x input
 * @returns {number} maximum value
 * @example
 * maxSorted([-100, -10, 1, 2, 5]); // => 5
 */ function $5b56aa3f46fee21b$export$441bbd5a5b536504(x) {
    return x[x.length - 1];
}
/**
 * The extent is the lowest & highest number in the array. With a sorted array,
 * the first element in the array is always the lowest while the last element is always the largest, so this calculation
 * can be done in one step, or constant time.
 *
 * @param {Array<number>} x input
 * @returns {Array<number>} minimum & maximum value
 * @example
 * extentSorted([-100, -10, 1, 2, 5]); // => [-100, 5]
 */ function $5b56aa3f46fee21b$export$17b53b47ce7ee493(x) {
    return [
        x[0],
        x[x.length - 1]
    ];
}
/**
 * The simple [sum](https://en.wikipedia.org/wiki/Summation) of an array
 * is the result of adding all numbers together, starting from zero.
 *
 * This runs in `O(n)`, linear time, with respect to the length of the array.
 *
 * @param {Array<number>} x input
 * @return {number} sum of all input numbers
 * @example
 * sumSimple([1, 2, 3]); // => 6
 */ function $5b56aa3f46fee21b$export$998aefe557563e24(x) {
    var value = 0;
    for(var i = 0; i < x.length; i++){
        if (typeof x[i] !== "number") return Number.NaN;
        value += x[i];
    }
    return value;
}
/**
 * The [product](https://en.wikipedia.org/wiki/Product_(mathematics)) of an array
 * is the result of multiplying all numbers together, starting using one as the multiplicative identity.
 *
 * This runs in `O(n)`, linear time, with respect to the length of the array.
 *
 * @param {Array<number>} x input
 * @return {number} product of all input numbers
 * @example
 * product([1, 2, 3, 4]); // => 24
 */ function $5b56aa3f46fee21b$export$dbd0f18357df1ddd(x) {
    var value = 1;
    for(var i = 0; i < x.length; i++)value *= x[i];
    return value;
}
/**
 * This is the internal implementation of quantiles: when you know
 * that the order is sorted, you don't need to re-sort it, and the computations
 * are faster.
 *
 * @param {Array<number>} x sample of one or more data points
 * @param {number} p desired quantile: a number between 0 to 1, inclusive
 * @returns {number} quantile value
 * @throws {Error} if p ix outside of the range from 0 to 1
 * @throws {Error} if x is empty
 * @example
 * quantileSorted([3, 6, 7, 8, 8, 9, 10, 13, 15, 16, 20], 0.5); // => 9
 */ function $5b56aa3f46fee21b$export$f924a6cad778dddb(x, p) {
    var idx = x.length * p;
    if (x.length === 0) throw new Error("quantile requires at least one data point.");
    else if (p < 0 || p > 1) throw new Error("quantiles must be between 0 and 1");
    else if (p === 1) // If p is 1, directly return the last element
    return x[x.length - 1];
    else if (p === 0) // If p is 0, directly return the first element
    return x[0];
    else if (idx % 1 !== 0) // If p is not integer, return the next element in array
    return x[Math.ceil(idx) - 1];
    else if (x.length % 2 === 0) // If the list has even-length, we'll take the average of this number
    // and the next value, if there is one
    return (x[idx - 1] + x[idx]) / 2;
    else // Finally, in the simple case of an integer value
    // with an odd-length list, return the x value at the index.
    return x[idx];
}
/**
 * Rearrange items in `arr` so that all items in `[left, k]` range are the smallest.
 * The `k`-th element will have the `(k - left + 1)`-th smallest value in `[left, right]`.
 *
 * Implements Floyd-Rivest selection algorithm https://en.wikipedia.org/wiki/Floyd-Rivest_algorithm
 *
 * @param {Array<number>} arr input array
 * @param {number} k pivot index
 * @param {number} [left] left index
 * @param {number} [right] right index
 * @returns {void} mutates input array
 * @example
 * var arr = [65, 28, 59, 33, 21, 56, 22, 95, 50, 12, 90, 53, 28, 77, 39];
 * quickselect(arr, 8);
 * // = [39, 28, 28, 33, 21, 12, 22, 50, 53, 56, 59, 65, 90, 77, 95]
 */ function $5b56aa3f46fee21b$export$18c6c9cc7a5c0926(arr, k, left, right) {
    left = left || 0;
    right = right || arr.length - 1;
    while(right > left){
        // 600 and 0.5 are arbitrary constants chosen in the original paper to minimize execution time
        if (right - left > 600) {
            var n = right - left + 1;
            var m = k - left + 1;
            var z = Math.log(n);
            var s = 0.5 * Math.exp(2 * z / 3);
            var sd = 0.5 * Math.sqrt(z * s * (n - s) / n);
            if (m - n / 2 < 0) sd *= -1;
            var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $5b56aa3f46fee21b$export$18c6c9cc7a5c0926(arr, k, newLeft, newRight);
        }
        var t = arr[k];
        var i = left;
        var j = right;
        $5b56aa3f46fee21b$var$swap(arr, left, k);
        if (arr[right] > t) $5b56aa3f46fee21b$var$swap(arr, left, right);
        while(i < j){
            $5b56aa3f46fee21b$var$swap(arr, i, j);
            i++;
            j--;
            while(arr[i] < t)i++;
            while(arr[j] > t)j--;
        }
        if (arr[left] === t) $5b56aa3f46fee21b$var$swap(arr, left, j);
        else {
            j++;
            $5b56aa3f46fee21b$var$swap(arr, j, right);
        }
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
}
function $5b56aa3f46fee21b$var$swap(arr, i, j) {
    var tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
/**
 * The [quantile](https://en.wikipedia.org/wiki/Quantile):
 * this is a population quantile, since we assume to know the entire
 * dataset in this library. This is an implementation of the
 * [Quantiles of a Population](http://en.wikipedia.org/wiki/Quantile#Quantiles_of_a_population)
 * algorithm from wikipedia.
 *
 * Sample is a one-dimensional array of numbers,
 * and p is either a decimal number from 0 to 1 or an array of decimal
 * numbers from 0 to 1.
 * In terms of a k/q quantile, p = k/q - it's just dealing with fractions or dealing
 * with decimal values.
 * When p is an array, the result of the function is also an array containing the appropriate
 * quantiles in input order
 *
 * @param {Array<number>} x sample of one or more numbers
 * @param {Array<number> | number} p the desired quantile, as a number between 0 and 1
 * @returns {number} quantile
 * @example
 * quantile([3, 6, 7, 8, 8, 9, 10, 13, 15, 16, 20], 0.5); // => 9
 */ function $5b56aa3f46fee21b$export$651fb4afdb6caa4b(x, p) {
    var copy = x.slice();
    if (Array.isArray(p)) {
        // rearrange elements so that each element corresponding to a requested
        // quantile is on a place it would be if the array was fully sorted
        $5b56aa3f46fee21b$var$multiQuantileSelect(copy, p);
        // Initialize the result array
        var results = [];
        // For each requested quantile
        for(var i = 0; i < p.length; i++)results[i] = $5b56aa3f46fee21b$export$f924a6cad778dddb(copy, p[i]);
        return results;
    } else {
        var idx = $5b56aa3f46fee21b$var$quantileIndex(copy.length, p);
        $5b56aa3f46fee21b$var$quantileSelect(copy, idx, 0, copy.length - 1);
        return $5b56aa3f46fee21b$export$f924a6cad778dddb(copy, p);
    }
}
function $5b56aa3f46fee21b$var$quantileSelect(arr, k, left, right) {
    if (k % 1 === 0) $5b56aa3f46fee21b$export$18c6c9cc7a5c0926(arr, k, left, right);
    else {
        k = Math.floor(k);
        $5b56aa3f46fee21b$export$18c6c9cc7a5c0926(arr, k, left, right);
        $5b56aa3f46fee21b$export$18c6c9cc7a5c0926(arr, k + 1, k + 1, right);
    }
}
function $5b56aa3f46fee21b$var$multiQuantileSelect(arr, p) {
    var indices = [
        0
    ];
    for(var i = 0; i < p.length; i++)indices.push($5b56aa3f46fee21b$var$quantileIndex(arr.length, p[i]));
    indices.push(arr.length - 1);
    indices.sort($5b56aa3f46fee21b$var$compare);
    var stack = [
        0,
        indices.length - 1
    ];
    while(stack.length){
        var r = Math.ceil(stack.pop());
        var l = Math.floor(stack.pop());
        if (r - l <= 1) continue;
        var m = Math.floor((l + r) / 2);
        $5b56aa3f46fee21b$var$quantileSelect(arr, indices[m], Math.floor(indices[l]), Math.ceil(indices[r]));
        stack.push(l, m, m, r);
    }
}
function $5b56aa3f46fee21b$var$compare(a, b) {
    return a - b;
}
function $5b56aa3f46fee21b$var$quantileIndex(len, p) {
    var idx = len * p;
    if (p === 1) // If p is 1, directly return the last index
    return len - 1;
    else if (p === 0) // If p is 0, directly return the first index
    return 0;
    else if (idx % 1 !== 0) // If index is not integer, return the next index in array
    return Math.ceil(idx) - 1;
    else if (len % 2 === 0) // If the list has even-length, we'll return the middle of two indices
    // around quantile to indicate that we need an average value of the two
    return idx - 0.5;
    else // Finally, in the simple case of an integer index
    // with an odd-length list, return the index
    return idx;
}
/* eslint no-bitwise: 0 */ /**
 * This function returns the quantile in which one would find the given value in
 * the given array. With a sorted array, leveraging binary search, we can find
 * this information in logarithmic time.
 *
 * @param {Array<number>} x input
 * @returns {number} value value
 * @example
 * quantileRankSorted([1, 2, 3, 4], 3); // => 0.75
 * quantileRankSorted([1, 2, 3, 3, 4], 3); // => 0.7
 * quantileRankSorted([1, 2, 3, 4], 6); // => 1
 * quantileRankSorted([1, 2, 3, 3, 5], 4); // => 0.8
 */ function $5b56aa3f46fee21b$export$84f56f65c049cf19(x, value) {
    // Value is lesser than any value in the array
    if (value < x[0]) return 0;
    // Value is greater than any value in the array
    if (value > x[x.length - 1]) return 1;
    var l = $5b56aa3f46fee21b$var$lowerBound(x, value);
    // Value is not in the array
    if (x[l] !== value) return l / x.length;
    l++;
    var u = $5b56aa3f46fee21b$var$upperBound(x, value);
    // The value exists only once in the array
    if (u === l) return l / x.length;
    // Here, we are basically computing the mean of the range of indices
    // containing our searched value. But, instead, of initializing an
    // array and looping over it, there is a dedicated math formula that
    // we apply below to get the result.
    var r = u - l + 1;
    var sum = r * (u + l) / 2;
    var mean = sum / r;
    return mean / x.length;
}
function $5b56aa3f46fee21b$var$lowerBound(x, value) {
    var mid = 0;
    var lo = 0;
    var hi = x.length;
    while(lo < hi){
        mid = lo + hi >>> 1;
        if (value <= x[mid]) hi = mid;
        else lo = -~mid;
    }
    return lo;
}
function $5b56aa3f46fee21b$var$upperBound(x, value) {
    var mid = 0;
    var lo = 0;
    var hi = x.length;
    while(lo < hi){
        mid = lo + hi >>> 1;
        if (value >= x[mid]) lo = -~mid;
        else hi = mid;
    }
    return lo;
}
/**
 * This function returns the quantile in which one would find the given value in
 * the given array. It will copy and sort your array before each run, so
 * if you know your array is already sorted, you should use `quantileRankSorted`
 * instead.
 *
 * @param {Array<number>} x input
 * @returns {number} value value
 * @example
 * quantileRank([4, 3, 1, 2], 3); // => 0.75
 * quantileRank([4, 3, 2, 3, 1], 3); // => 0.7
 * quantileRank([2, 4, 1, 3], 6); // => 1
 * quantileRank([5, 3, 1, 2, 3], 4); // => 0.8
 */ function $5b56aa3f46fee21b$export$94de52dae56619fd(x, value) {
    // Cloning and sorting the array
    var sortedCopy = $5b56aa3f46fee21b$export$5b66f3fff0c2847f(x);
    return $5b56aa3f46fee21b$export$84f56f65c049cf19(sortedCopy, value);
}
/**
 * The [Interquartile range](http://en.wikipedia.org/wiki/Interquartile_range) is
 * a measure of statistical dispersion, or how scattered, spread, or
 * concentrated a distribution is. It's computed as the difference between
 * the third quartile and first quartile.
 *
 * @param {Array<number>} x sample of one or more numbers
 * @returns {number} interquartile range: the span between lower and upper quartile,
 * 0.25 and 0.75
 * @example
 * interquartileRange([0, 1, 2, 3]); // => 2
 */ function $5b56aa3f46fee21b$export$670a22a0cbf9a1e2(x) {
    // Interquartile range is the span between the upper quartile,
    // at `0.75`, and lower quartile, `0.25`
    var q1 = $5b56aa3f46fee21b$export$651fb4afdb6caa4b(x, 0.75);
    var q2 = $5b56aa3f46fee21b$export$651fb4afdb6caa4b(x, 0.25);
    if (typeof q1 === "number" && typeof q2 === "number") return q1 - q2;
}
/**
 * The [median](http://en.wikipedia.org/wiki/Median) is
 * the middle number of a list. This is often a good indicator of 'the middle'
 * when there are outliers that skew the `mean()` value.
 * This is a [measure of central tendency](https://en.wikipedia.org/wiki/Central_tendency):
 * a method of finding a typical or central value of a set of numbers.
 *
 * The median isn't necessarily one of the elements in the list: the value
 * can be the average of two elements if the list has an even length
 * and the two central values are different.
 *
 * @param {Array<number>} x input
 * @returns {number} median value
 * @example
 * median([10, 2, 5, 100, 2, 1]); // => 3.5
 */ function $5b56aa3f46fee21b$export$9c490b34b2f16a34(x) {
    return +$5b56aa3f46fee21b$export$651fb4afdb6caa4b(x, 0.5);
}
/**
 * The [Median Absolute Deviation](http://en.wikipedia.org/wiki/Median_absolute_deviation) is
 * a robust measure of statistical
 * dispersion. It is more resilient to outliers than the standard deviation.
 *
 * @param {Array<number>} x input array
 * @returns {number} median absolute deviation
 * @example
 * medianAbsoluteDeviation([1, 1, 2, 2, 4, 6, 9]); // => 1
 */ function $5b56aa3f46fee21b$export$b14ea41a64d6efa6(x) {
    var medianValue = $5b56aa3f46fee21b$export$9c490b34b2f16a34(x);
    var medianAbsoluteDeviations = [];
    // Make a list of absolute deviations from the median
    for(var i = 0; i < x.length; i++)medianAbsoluteDeviations.push(Math.abs(x[i] - medianValue));
    // Find the median value of that list
    return $5b56aa3f46fee21b$export$9c490b34b2f16a34(medianAbsoluteDeviations);
}
/**
 * Split an array into chunks of a specified size. This function
 * has the same behavior as [PHP's array_chunk](http://php.net/manual/en/function.array-chunk.php)
 * function, and thus will insert smaller-sized chunks at the end if
 * the input size is not divisible by the chunk size.
 *
 * `x` is expected to be an array, and `chunkSize` a number.
 * The `x` array can contain any kind of data.
 *
 * @param {Array} x a sample
 * @param {number} chunkSize size of each output array. must be a positive integer
 * @returns {Array<Array>} a chunked array
 * @throws {Error} if chunk size is less than 1 or not an integer
 * @example
 * chunk([1, 2, 3, 4, 5, 6], 2);
 * // => [[1, 2], [3, 4], [5, 6]]
 */ function $5b56aa3f46fee21b$export$5f7ec48d69707ddd(x, chunkSize) {
    // a list of result chunks, as arrays in an array
    var output = [];
    // `chunkSize` must be zero or higher - otherwise the loop below,
    // in which we call `start += chunkSize`, will loop infinitely.
    // So, we'll detect and throw in that case to indicate
    // invalid input.
    if (chunkSize < 1) throw new Error("chunk size must be a positive number");
    if (Math.floor(chunkSize) !== chunkSize) throw new Error("chunk size must be an integer");
    // `start` is the index at which `.slice` will start selecting
    // new array elements
    for(var start = 0; start < x.length; start += chunkSize)// for each chunk, slice that part of the array and add it
    // to the output. The `.slice` function does not change
    // the original array.
    output.push(x.slice(start, start + chunkSize));
    return output;
}
/**
 * Sampling with replacement is a type of sampling that allows the same
 * item to be picked out of a population more than once.
 *
 * @param {Array<*>} x an array of any kind of value
 * @param {number} n count of how many elements to take
 * @param {Function} [randomSource=Math.random] an optional entropy source that
 * returns numbers between 0 inclusive and 1 exclusive: the range [0, 1)
 * @return {Array} n sampled items from the population
 * @example
 * var values = [1, 2, 3, 4];
 * sampleWithReplacement(values, 2); // returns 2 random values, like [2, 4];
 */ function $5b56aa3f46fee21b$export$3dc8325fdb328d40(x, n, randomSource) {
    if (x.length === 0) return [];
    // a custom random number source can be provided if you want to use
    // a fixed seed or another random number generator, like
    // [random-js](https://www.npmjs.org/package/random-js)
    randomSource = randomSource || Math.random;
    var length = x.length;
    var sample = [];
    for(var i = 0; i < n; i++){
        var index = Math.floor(randomSource() * length);
        sample.push(x[index]);
    }
    return sample;
}
/**
 * A [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle)
 * in-place - which means that it **will change the order of the original
 * array by reference**.
 *
 * This is an algorithm that generates a random [permutation](https://en.wikipedia.org/wiki/Permutation)
 * of a set.
 *
 * @param {Array} x sample of one or more numbers
 * @param {Function} [randomSource=Math.random] an optional entropy source that
 * returns numbers between 0 inclusive and 1 exclusive: the range [0, 1)
 * @returns {Array} x
 * @example
 * var x = [1, 2, 3, 4];
 * shuffleInPlace(x);
 * // x is shuffled to a value like [2, 1, 4, 3]
 */ function $5b56aa3f46fee21b$export$c8bbd489f517fb10(x, randomSource) {
    // a custom random number source can be provided if you want to use
    // a fixed seed or another random number generator, like
    // [random-js](https://www.npmjs.org/package/random-js)
    randomSource = randomSource || Math.random;
    // store the current length of the x to determine
    // when no elements remain to shuffle.
    var length = x.length;
    // temporary is used to hold an item when it is being
    // swapped between indices.
    var temporary;
    // The index to swap at each stage.
    var index;
    // While there are still items to shuffle
    while(length > 0){
        // choose a random index within the subset of the array
        // that is not yet shuffled
        index = Math.floor(randomSource() * length--);
        // store the value that we'll move temporarily
        temporary = x[length];
        // swap the value at `x[length]` with `x[index]`
        x[length] = x[index];
        x[index] = temporary;
    }
    return x;
}
/**
 * A [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle)
 * is a fast way to create a random permutation of a finite set. This is
 * a function around `shuffle_in_place` that adds the guarantee that
 * it will not modify its input.
 *
 * @param {Array} x sample of 0 or more numbers
 * @param {Function} [randomSource=Math.random] an optional entropy source that
 * returns numbers between 0 inclusive and 1 exclusive: the range [0, 1)
 * @return {Array} shuffled version of input
 * @example
 * var shuffled = shuffle([1, 2, 3, 4]);
 * shuffled; // = [2, 3, 1, 4] or any other random permutation
 */ function $5b56aa3f46fee21b$export$448332262467e042(x, randomSource) {
    // slice the original array so that it is not modified
    var sample = x.slice();
    // and then shuffle that shallow-copied array, in place
    return $5b56aa3f46fee21b$export$c8bbd489f517fb10(sample, randomSource);
}
/**
 * Create a [simple random sample](http://en.wikipedia.org/wiki/Simple_random_sample)
 * from a given array of `n` elements.
 *
 * The sampled values will be in any order, not necessarily the order
 * they appear in the input.
 *
 * @param {Array<any>} x input array. can contain any type
 * @param {number} n count of how many elements to take
 * @param {Function} [randomSource=Math.random] an optional entropy source that
 * returns numbers between 0 inclusive and 1 exclusive: the range [0, 1)
 * @return {Array} subset of n elements in original array
 *
 * @example
 * var values = [1, 2, 4, 5, 6, 7, 8, 9];
 * sample(values, 3); // returns 3 random values, like [2, 5, 8];
 */ function $5b56aa3f46fee21b$export$4812e460280c6ef2(x, n, randomSource) {
    // shuffle the original array using a fisher-yates shuffle
    var shuffled = $5b56aa3f46fee21b$export$448332262467e042(x, randomSource);
    // and then return a subset of it - the first `n` elements.
    return shuffled.slice(0, n);
}
/**
 * Create a new column x row matrix.
 *
 * @private
 * @param {number} columns
 * @param {number} rows
 * @return {Array<Array<number>>} matrix
 * @example
 * makeMatrix(10, 10);
 */ function $5b56aa3f46fee21b$var$makeMatrix(columns, rows) {
    var matrix = [];
    for(var i = 0; i < columns; i++){
        var column = [];
        for(var j = 0; j < rows; j++)column.push(0);
        matrix.push(column);
    }
    return matrix;
}
/**
 * For a sorted input, counting the number of unique values
 * is possible in constant time and constant memory. This is
 * a simple implementation of the algorithm.
 *
 * Values are compared with `===`, so objects and non-primitive objects
 * are not handled in any special way.
 *
 * @param {Array<*>} x an array of any kind of value
 * @returns {number} count of unique values
 * @example
 * uniqueCountSorted([1, 2, 3]); // => 3
 * uniqueCountSorted([1, 1, 1]); // => 1
 */ function $5b56aa3f46fee21b$export$ae9b4bde688c9041(x) {
    var uniqueValueCount = 0;
    var lastSeenValue;
    for(var i = 0; i < x.length; i++)if (i === 0 || x[i] !== lastSeenValue) {
        lastSeenValue = x[i];
        uniqueValueCount++;
    }
    return uniqueValueCount;
}
/**
 * Generates incrementally computed values based on the sums and sums of
 * squares for the data array
 *
 * @private
 * @param {number} j
 * @param {number} i
 * @param {Array<number>} sums
 * @param {Array<number>} sumsOfSquares
 * @return {number}
 * @example
 * ssq(0, 1, [-1, 0, 2], [1, 1, 5]);
 */ function $5b56aa3f46fee21b$var$ssq(j, i, sums, sumsOfSquares) {
    var sji; // s(j, i)
    if (j > 0) {
        var muji = (sums[i] - sums[j - 1]) / (i - j + 1); // mu(j, i)
        sji = sumsOfSquares[i] - sumsOfSquares[j - 1] - (i - j + 1) * muji * muji;
    } else sji = sumsOfSquares[i] - sums[i] * sums[i] / (i + 1);
    if (sji < 0) return 0;
    return sji;
}
/**
 * Function that recursively divides and conquers computations
 * for cluster j
 *
 * @private
 * @param {number} iMin Minimum index in cluster to be computed
 * @param {number} iMax Maximum index in cluster to be computed
 * @param {number} cluster Index of the cluster currently being computed
 * @param {Array<Array<number>>} matrix
 * @param {Array<Array<number>>} backtrackMatrix
 * @param {Array<number>} sums
 * @param {Array<number>} sumsOfSquares
 */ function $5b56aa3f46fee21b$var$fillMatrixColumn(iMin, iMax, cluster, matrix, backtrackMatrix, sums, sumsOfSquares) {
    if (iMin > iMax) return;
    // Start at midpoint between iMin and iMax
    var i = Math.floor((iMin + iMax) / 2);
    matrix[cluster][i] = matrix[cluster - 1][i - 1];
    backtrackMatrix[cluster][i] = i;
    var jlow = cluster; // the lower end for j
    if (iMin > cluster) jlow = Math.max(jlow, backtrackMatrix[cluster][iMin - 1] || 0);
    jlow = Math.max(jlow, backtrackMatrix[cluster - 1][i] || 0);
    var jhigh = i - 1; // the upper end for j
    if (iMax < matrix[0].length - 1) /* c8 ignore start */ jhigh = Math.min(jhigh, backtrackMatrix[cluster][iMax + 1] || 0);
    var sji;
    var sjlowi;
    var ssqjlow;
    var ssqj;
    for(var j = jhigh; j >= jlow; --j){
        sji = $5b56aa3f46fee21b$var$ssq(j, i, sums, sumsOfSquares);
        if (sji + matrix[cluster - 1][jlow - 1] >= matrix[cluster][i]) break;
        // Examine the lower bound of the cluster border
        sjlowi = $5b56aa3f46fee21b$var$ssq(jlow, i, sums, sumsOfSquares);
        ssqjlow = sjlowi + matrix[cluster - 1][jlow - 1];
        if (ssqjlow < matrix[cluster][i]) {
            // Shrink the lower bound
            matrix[cluster][i] = ssqjlow;
            backtrackMatrix[cluster][i] = jlow;
        }
        jlow++;
        ssqj = sji + matrix[cluster - 1][j - 1];
        if (ssqj < matrix[cluster][i]) {
            matrix[cluster][i] = ssqj;
            backtrackMatrix[cluster][i] = j;
        }
    }
    $5b56aa3f46fee21b$var$fillMatrixColumn(iMin, i - 1, cluster, matrix, backtrackMatrix, sums, sumsOfSquares);
    $5b56aa3f46fee21b$var$fillMatrixColumn(i + 1, iMax, cluster, matrix, backtrackMatrix, sums, sumsOfSquares);
}
/**
 * Initializes the main matrices used in Ckmeans and kicks
 * off the divide and conquer cluster computation strategy
 *
 * @private
 * @param {Array<number>} data sorted array of values
 * @param {Array<Array<number>>} matrix
 * @param {Array<Array<number>>} backtrackMatrix
 */ function $5b56aa3f46fee21b$var$fillMatrices(data, matrix, backtrackMatrix) {
    var nValues = matrix[0].length;
    // Shift values by the median to improve numeric stability
    var shift = data[Math.floor(nValues / 2)];
    // Cumulative sum and cumulative sum of squares for all values in data array
    var sums = [];
    var sumsOfSquares = [];
    // Initialize first column in matrix & backtrackMatrix
    for(var i = 0, shiftedValue = void 0; i < nValues; ++i){
        shiftedValue = data[i] - shift;
        if (i === 0) {
            sums.push(shiftedValue);
            sumsOfSquares.push(shiftedValue * shiftedValue);
        } else {
            sums.push(sums[i - 1] + shiftedValue);
            sumsOfSquares.push(sumsOfSquares[i - 1] + shiftedValue * shiftedValue);
        }
        // Initialize for cluster = 0
        matrix[0][i] = $5b56aa3f46fee21b$var$ssq(0, i, sums, sumsOfSquares);
        backtrackMatrix[0][i] = 0;
    }
    // Initialize the rest of the columns
    var iMin;
    for(var cluster = 1; cluster < matrix.length; ++cluster){
        if (cluster < matrix.length - 1) iMin = cluster;
        else // No need to compute matrix[K-1][0] ... matrix[K-1][N-2]
        iMin = nValues - 1;
        $5b56aa3f46fee21b$var$fillMatrixColumn(iMin, nValues - 1, cluster, matrix, backtrackMatrix, sums, sumsOfSquares);
    }
}
/**
 * Ckmeans clustering is an improvement on heuristic-based clustering
 * approaches like Jenks. The algorithm was developed in
 * [Haizhou Wang and Mingzhou Song](http://journal.r-project.org/archive/2011-2/RJournal_2011-2_Wang+Song.pdf)
 * as a [dynamic programming](https://en.wikipedia.org/wiki/Dynamic_programming) approach
 * to the problem of clustering numeric data into groups with the least
 * within-group sum-of-squared-deviations.
 *
 * Minimizing the difference within groups - what Wang & Song refer to as
 * `withinss`, or within sum-of-squares, means that groups are optimally
 * homogenous within and the data is split into representative groups.
 * This is very useful for visualization, where you may want to represent
 * a continuous variable in discrete color or style groups. This function
 * can provide groups that emphasize differences between data.
 *
 * Being a dynamic approach, this algorithm is based on two matrices that
 * store incrementally-computed values for squared deviations and backtracking
 * indexes.
 *
 * This implementation is based on Ckmeans 3.4.6, which introduced a new divide
 * and conquer approach that improved runtime from O(kn^2) to O(kn log(n)).
 *
 * Unlike the [original implementation](https://cran.r-project.org/web/packages/Ckmeans.1d.dp/index.html),
 * this implementation does not include any code to automatically determine
 * the optimal number of clusters: this information needs to be explicitly
 * provided.
 *
 * ### References
 * _Ckmeans.1d.dp: Optimal k-means Clustering in One Dimension by Dynamic
 * Programming_ Haizhou Wang and Mingzhou Song ISSN 2073-4859
 *
 * from The R Journal Vol. 3/2, December 2011
 * @param {Array<number>} x input data, as an array of number values
 * @param {number} nClusters number of desired classes. This cannot be
 * greater than the number of values in the data array.
 * @returns {Array<Array<number>>} clustered input
 * @throws {Error} if the number of requested clusters is higher than the size of the data
 * @example
 * ckmeans([-1, 2, -1, 2, 4, 5, 6, -1, 2, -1], 3);
 * // The input, clustered into groups of similar numbers.
 * //= [[-1, -1, -1, -1], [2, 2, 2], [4, 5, 6]]);
 */ function $5b56aa3f46fee21b$export$c2ec438a39aae9b2(x, nClusters) {
    if (nClusters > x.length) throw new Error("cannot generate more classes than there are data values");
    var sorted = $5b56aa3f46fee21b$export$5b66f3fff0c2847f(x);
    // we'll use this as the maximum number of clusters
    var uniqueCount = $5b56aa3f46fee21b$export$ae9b4bde688c9041(sorted);
    // if all of the input values are identical, there's one cluster
    // with all of the input in it.
    if (uniqueCount === 1) return [
        sorted
    ];
    // named 'S' originally
    var matrix = $5b56aa3f46fee21b$var$makeMatrix(nClusters, sorted.length);
    // named 'J' originally
    var backtrackMatrix = $5b56aa3f46fee21b$var$makeMatrix(nClusters, sorted.length);
    // This is a dynamic programming way to solve the problem of minimizing
    // within-cluster sum of squares. It's similar to linear regression
    // in this way, and this calculation incrementally computes the
    // sum of squares that are later read.
    $5b56aa3f46fee21b$var$fillMatrices(sorted, matrix, backtrackMatrix);
    // The real work of Ckmeans clustering happens in the matrix generation:
    // the generated matrices encode all possible clustering combinations, and
    // once they're generated we can solve for the best clustering groups
    // very quickly.
    var clusters = [];
    var clusterRight = backtrackMatrix[0].length - 1;
    // Backtrack the clusters from the dynamic programming matrix. This
    // starts at the bottom-right corner of the matrix (if the top-left is 0, 0),
    // and moves the cluster target with the loop.
    for(var cluster = backtrackMatrix.length - 1; cluster >= 0; cluster--){
        var clusterLeft = backtrackMatrix[cluster][clusterRight];
        // fill the cluster from the sorted input by taking a slice of the
        // array. the backtrack matrix makes this easy - it stores the
        // indexes where the cluster should start and end.
        clusters[cluster] = sorted.slice(clusterLeft, clusterRight + 1);
        if (cluster > 0) clusterRight = clusterLeft - 1;
    }
    return clusters;
}
/*
 * Pull Breaks Values for Jenks
 *
 * the second part of the jenks recipe: take the calculated matrices
 * and derive an array of n breaks.
 *
 * @private
 */ function $5b56aa3f46fee21b$var$jenksBreaks(data, lowerClassLimits, nClasses) {
    var k = data.length;
    var kclass = [];
    var countNum = nClasses;
    // the calculation of classes will never include the upper
    // bound, so we need to explicitly set it
    kclass[nClasses] = data[data.length - 1];
    // the lowerClassLimits matrix is used as indices into itself
    // here: the `k` variable is reused in each iteration.
    while(countNum > 0){
        kclass[countNum - 1] = data[lowerClassLimits[k][countNum] - 1];
        k = lowerClassLimits[k][countNum] - 1;
        countNum--;
    }
    return kclass;
}
/*
 * Compute Matrices for Jenks
 *
 * Compute the matrices required for Jenks breaks. These matrices
 * can be used for any classing of data with `classes <= nClasses`
 *
 * @private
 */ function $5b56aa3f46fee21b$var$jenksMatrices(data, nClasses) {
    // in the original implementation, these matrices are referred to
    // as `LC` and `OP`
    //
    // * lowerClassLimits (LC): optimal lower class limits
    // * varianceCombinations (OP): optimal variance combinations for all classes
    var lowerClassLimits = [];
    var varianceCombinations = [];
    // loop counters
    var i;
    var j;
    // the variance, as computed at each step in the calculation
    var variance = 0;
    // Initialize and fill each matrix with zeroes
    for(i = 0; i < data.length + 1; i++){
        var tmp1 = [];
        var tmp2 = [];
        // despite these arrays having the same values, we need
        // to keep them separate so that changing one does not change
        // the other
        for(j = 0; j < nClasses + 1; j++){
            tmp1.push(0);
            tmp2.push(0);
        }
        lowerClassLimits.push(tmp1);
        varianceCombinations.push(tmp2);
    }
    for(i = 1; i < nClasses + 1; i++){
        lowerClassLimits[1][i] = 1;
        varianceCombinations[1][i] = 0;
        // in the original implementation, 9999999 is used but
        // since Javascript has `Infinity`, we use that.
        for(j = 2; j < data.length + 1; j++)varianceCombinations[j][i] = Number.POSITIVE_INFINITY;
    }
    for(var l = 2; l < data.length + 1; l++){
        // `SZ` originally. this is the sum of the values seen thus
        // far when calculating variance.
        var sum = 0;
        // `ZSQ` originally. the sum of squares of values seen
        // thus far
        var sumSquares = 0;
        // `WT` originally. This is the number of
        var w = 0;
        // `IV` originally
        var i4 = 0;
        // in several instances, you could say `Math.pow(x, 2)`
        // instead of `x * x`, but this is slower in some browsers
        // introduces an unnecessary concept.
        for(var m = 1; m < l + 1; m++){
            // `III` originally
            var lowerClassLimit = l - m + 1;
            var val = data[lowerClassLimit - 1];
            // here we're estimating variance for each potential classing
            // of the data, for each potential number of classes. `w`
            // is the number of data points considered so far.
            w++;
            // increase the current sum and sum-of-squares
            sum += val;
            sumSquares += val * val;
            // the variance at this point in the sequence is the difference
            // between the sum of squares and the total x 2, over the number
            // of samples.
            variance = sumSquares - sum * sum / w;
            i4 = lowerClassLimit - 1;
            if (i4 !== 0) {
                for(j = 2; j < nClasses + 1; j++)// if adding this element to an existing class
                // will increase its variance beyond the limit, break
                // the class at this point, setting the `lowerClassLimit`
                // at this point.
                if (varianceCombinations[l][j] >= variance + varianceCombinations[i4][j - 1]) {
                    lowerClassLimits[l][j] = lowerClassLimit;
                    varianceCombinations[l][j] = variance + varianceCombinations[i4][j - 1];
                }
            }
        }
        lowerClassLimits[l][1] = 1;
        varianceCombinations[l][1] = variance;
    }
    // return the two matrices. for just providing breaks, only
    // `lowerClassLimits` is needed, but variances can be useful to
    // evaluate goodness of fit.
    return {
        lowerClassLimits: lowerClassLimits,
        varianceCombinations: varianceCombinations
    };
}
/**
 * The **[jenks natural breaks optimization](http://en.wikipedia.org/wiki/Jenks_natural_breaks_optimization)**
 * is an algorithm commonly used in cartography and visualization to decide
 * upon groupings of data values that minimize variance within themselves
 * and maximize variation between themselves.
 *
 * For instance, cartographers often use jenks in order to choose which
 * values are assigned to which colors in a [choropleth](https://en.wikipedia.org/wiki/Choropleth_map)
 * map.
 *
 * @param {Array<number>} data input data, as an array of number values
 * @param {number} nClasses number of desired classes
 * @returns {Array<number>} array of class break positions
 * // split data into 3 break points
 * jenks([1, 2, 4, 5, 7, 9, 10, 20], 3) // = [1, 7, 20, 20]
 */ function $5b56aa3f46fee21b$export$2716a1b6ca8cd127(data, nClasses) {
    if (nClasses > data.length) return null;
    // sort data in numerical order, since this is expected
    // by the matrices function
    data = data.slice().sort(function(a, b) {
        return a - b;
    });
    // get our basic matrices
    var matrices = $5b56aa3f46fee21b$var$jenksMatrices(data, nClasses);
    // we only need lower class limits here
    var lowerClassLimits = matrices.lowerClassLimits;
    // extract nClasses out of the computed matrices
    return $5b56aa3f46fee21b$var$jenksBreaks(data, lowerClassLimits, nClasses);
}
/**
 * Given an array of x, this will find the extent of the
 * x and return an array of breaks that can be used
 * to categorize the x into a number of classes. The
 * returned array will always be 1 longer than the number of
 * classes because it includes the minimum value.
 *
 * @param {Array<number>} x an array of number values
 * @param {number} nClasses number of desired classes
 * @returns {Array<number>} array of class break positions
 * @example
 * equalIntervalBreaks([1, 2, 3, 4, 5, 6], 4); // => [1, 2.25, 3.5, 4.75, 6]
 */ function $5b56aa3f46fee21b$export$2a6bdc79b7de9ed0(x, nClasses) {
    if (x.length < 2) return x;
    var theMin = $5b56aa3f46fee21b$export$96ec731ed4dcb222(x);
    var theMax = $5b56aa3f46fee21b$export$8960430cfd85939f(x);
    // the first break will always be the minimum value
    // in the xset
    var breaks = [
        theMin
    ];
    // The size of each break is the full range of the x
    // divided by the number of classes requested
    var breakSize = (theMax - theMin) / nClasses;
    // In the case of nClasses = 1, this loop won't run
    // and the returned breaks will be [min, max]
    for(var i = 1; i < nClasses; i++)breaks.push(breaks[0] + breakSize * i);
    // the last break will always be the
    // maximum.
    breaks.push(theMax);
    return breaks;
}
/**
 * [Sample covariance](https://en.wikipedia.org/wiki/Sample_mean_and_covariance) of two datasets:
 * how much do the two datasets move together?
 * x and y are two datasets, represented as arrays of numbers.
 *
 * @param {Array<number>} x a sample of two or more data points
 * @param {Array<number>} y a sample of two or more data points
 * @throws {Error} if x and y do not have equal lengths
 * @throws {Error} if x or y have length of one or less
 * @returns {number} sample covariance
 * @example
 * sampleCovariance([1, 2, 3, 4, 5, 6], [6, 5, 4, 3, 2, 1]); // => -3.5
 */ function $5b56aa3f46fee21b$export$4c3f8111757161c8(x, y) {
    // The two datasets must have the same length which must be more than 1
    if (x.length !== y.length) throw new Error("sampleCovariance requires samples with equal lengths");
    if (x.length < 2) throw new Error("sampleCovariance requires at least two data points in each sample");
    // determine the mean of each dataset so that we can judge each
    // value of the dataset fairly as the difference from the mean. this
    // way, if one dataset is [1, 2, 3] and [2, 3, 4], their covariance
    // does not suffer because of the difference in absolute values
    var xmean = $5b56aa3f46fee21b$export$cc6710ee5f037d57(x);
    var ymean = $5b56aa3f46fee21b$export$cc6710ee5f037d57(y);
    var sum = 0;
    // for each pair of values, the covariance increases when their
    // difference from the mean is associated - if both are well above
    // or if both are well below
    // the mean, the covariance increases significantly.
    for(var i = 0; i < x.length; i++)sum += (x[i] - xmean) * (y[i] - ymean);
    // this is Bessels' Correction: an adjustment made to sample statistics
    // that allows for the reduced degree of freedom entailed in calculating
    // values from samples rather than complete populations.
    var besselsCorrection = x.length - 1;
    // the covariance is weighted by the length of the datasets.
    return sum / besselsCorrection;
}
/**
 * The [sample variance](https://en.wikipedia.org/wiki/Variance#Sample_variance)
 * is the sum of squared deviations from the mean. The sample variance
 * is distinguished from the variance by the usage of [Bessel's Correction](https://en.wikipedia.org/wiki/Bessel's_correction):
 * instead of dividing the sum of squared deviations by the length of the input,
 * it is divided by the length minus one. This corrects the bias in estimating
 * a value from a set that you don't know if full.
 *
 * References:
 * * [Wolfram MathWorld on Sample Variance](http://mathworld.wolfram.com/SampleVariance.html)
 *
 * @param {Array<number>} x a sample of two or more data points
 * @throws {Error} if the length of x is less than 2
 * @return {number} sample variance
 * @example
 * sampleVariance([1, 2, 3, 4, 5]); // => 2.5
 */ function $5b56aa3f46fee21b$export$99840dab7ddadfde(x) {
    if (x.length < 2) throw new Error("sampleVariance requires at least two data points");
    var sumSquaredDeviationsValue = $5b56aa3f46fee21b$export$b447fa15e39b76c0(x, 2);
    // this is Bessels' Correction: an adjustment made to sample statistics
    // that allows for the reduced degree of freedom entailed in calculating
    // values from samples rather than complete populations.
    var besselsCorrection = x.length - 1;
    // Find the mean value of that list
    return sumSquaredDeviationsValue / besselsCorrection;
}
/**
 * The [sample standard deviation](http://en.wikipedia.org/wiki/Standard_deviation#Sample_standard_deviation)
 * is the square root of the sample variance.
 *
 * @param {Array<number>} x input array
 * @returns {number} sample standard deviation
 * @example
 * sampleStandardDeviation([2, 4, 4, 4, 5, 5, 7, 9]).toFixed(2);
 * // => '2.14'
 */ function $5b56aa3f46fee21b$export$5cb6c9899f9010bc(x) {
    var sampleVarianceX = $5b56aa3f46fee21b$export$99840dab7ddadfde(x);
    return Math.sqrt(sampleVarianceX);
}
/**
 * The [correlation](http://en.wikipedia.org/wiki/Correlation_and_dependence) is
 * a measure of how correlated two datasets are, between -1 and 1
 *
 * @param {Array<number>} x first input
 * @param {Array<number>} y second input
 * @returns {number} sample correlation
 * @example
 * sampleCorrelation([1, 2, 3, 4, 5, 6], [2, 2, 3, 4, 5, 60]).toFixed(2);
 * // => '0.69'
 */ function $5b56aa3f46fee21b$export$823b1526f10d0ac2(x, y) {
    var cov = $5b56aa3f46fee21b$export$4c3f8111757161c8(x, y);
    var xstd = $5b56aa3f46fee21b$export$5cb6c9899f9010bc(x);
    var ystd = $5b56aa3f46fee21b$export$5cb6c9899f9010bc(y);
    return cov / xstd / ystd;
}
/**
 * The [rank correlation](https://en.wikipedia.org/wiki/Rank_correlation) is
 * a measure of the strength of monotonic relationship between two arrays
 *
 * @param {Array<number>} x first input
 * @param {Array<number>} y second input
 * @returns {number} sample rank correlation
 */ function $5b56aa3f46fee21b$export$3c0ca8a2b2c4d183(x, y) {
    var xIndexes = x.map(function(value, index) {
        return [
            value,
            index
        ];
    }).sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(pair) {
        return pair[1];
    });
    var yIndexes = y.map(function(value, index) {
        return [
            value,
            index
        ];
    }).sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(pair) {
        return pair[1];
    });
    // At this step, we have an array of indexes
    // that map from sorted numbers to their original indexes. We reverse
    // that so that it is an array of the sorted destination index.
    var xRanks = Array(xIndexes.length);
    var yRanks = Array(xIndexes.length);
    for(var i = 0; i < xIndexes.length; i++){
        xRanks[xIndexes[i]] = i;
        yRanks[yIndexes[i]] = i;
    }
    return $5b56aa3f46fee21b$export$823b1526f10d0ac2(xRanks, yRanks);
}
/**
 * [Skewness](http://en.wikipedia.org/wiki/Skewness) is
 * a measure of the extent to which a probability distribution of a
 * real-valued random variable "leans" to one side of the mean.
 * The skewness value can be positive or negative, or even undefined.
 *
 * Implementation is based on the adjusted Fisher-Pearson standardized
 * moment coefficient, which is the version found in Excel and several
 * statistical packages including Minitab, SAS and SPSS.
 *
 * @since 4.1.0
 * @param {Array<number>} x a sample of 3 or more data points
 * @returns {number} sample skewness
 * @throws {Error} if x has length less than 3
 * @example
 * sampleSkewness([2, 4, 6, 3, 1]); // => 0.590128656384365
 */ function $5b56aa3f46fee21b$export$b734d61bb3710e72(x) {
    if (x.length < 3) throw new Error("sampleSkewness requires at least three data points");
    var meanValue = $5b56aa3f46fee21b$export$cc6710ee5f037d57(x);
    var tempValue;
    var sumSquaredDeviations = 0;
    var sumCubedDeviations = 0;
    for(var i = 0; i < x.length; i++){
        tempValue = x[i] - meanValue;
        sumSquaredDeviations += tempValue * tempValue;
        sumCubedDeviations += tempValue * tempValue * tempValue;
    }
    // this is Bessels' Correction: an adjustment made to sample statistics
    // that allows for the reduced degree of freedom entailed in calculating
    // values from samples rather than complete populations.
    var besselsCorrection = x.length - 1;
    // Find the mean value of that list
    var theSampleStandardDeviation = Math.sqrt(sumSquaredDeviations / besselsCorrection);
    var n = x.length;
    var cubedS = Math.pow(theSampleStandardDeviation, 3);
    return n * sumCubedDeviations / ((n - 1) * (n - 2) * cubedS);
}
/**
 * [Kurtosis](http://en.wikipedia.org/wiki/Kurtosis) is
 * a measure of the heaviness of a distribution's tails relative to its
 * variance. The kurtosis value can be positive or negative, or even undefined.
 *
 * Implementation is based on Fisher's excess kurtosis definition and uses
 * unbiased moment estimators. This is the version found in Excel and available
 * in several statistical packages, including SAS and SciPy.
 *
 * @param {Array<number>} x a sample of 4 or more data points
 * @returns {number} sample kurtosis
 * @throws {Error} if x has length less than 4
 * @example
 * sampleKurtosis([1, 2, 2, 3, 5]); // => 1.4555765595463122
 */ function $5b56aa3f46fee21b$export$a90b8370ef79611e(x) {
    var n = x.length;
    if (n < 4) throw new Error("sampleKurtosis requires at least four data points");
    var meanValue = $5b56aa3f46fee21b$export$cc6710ee5f037d57(x);
    var tempValue;
    var secondCentralMoment = 0;
    var fourthCentralMoment = 0;
    for(var i = 0; i < n; i++){
        tempValue = x[i] - meanValue;
        secondCentralMoment += tempValue * tempValue;
        fourthCentralMoment += tempValue * tempValue * tempValue * tempValue;
    }
    return (n - 1) / ((n - 2) * (n - 3)) * (n * (n + 1) * fourthCentralMoment / (secondCentralMoment * secondCentralMoment) - 3 * (n - 1));
}
/**
 * Implementation of [Heap's Algorithm](https://en.wikipedia.org/wiki/Heap%27s_algorithm)
 * for generating permutations.
 *
 * @param {Array} elements any type of data
 * @returns {Array<Array>} array of permutations
 */ function $5b56aa3f46fee21b$export$8e099875a331ee81(elements) {
    var indexes = new Array(elements.length);
    var permutations = [
        elements.slice()
    ];
    for(var i = 0; i < elements.length; i++)indexes[i] = 0;
    for(var i$1 = 0; i$1 < elements.length;)if (indexes[i$1] < i$1) {
        // At odd indexes, swap from indexes[i] instead
        // of from the beginning of the array
        var swapFrom = 0;
        if (i$1 % 2 !== 0) swapFrom = indexes[i$1];
        // swap between swapFrom and i, using
        // a temporary variable as storage.
        var temp = elements[swapFrom];
        elements[swapFrom] = elements[i$1];
        elements[i$1] = temp;
        permutations.push(elements.slice());
        indexes[i$1]++;
        i$1 = 0;
    } else {
        indexes[i$1] = 0;
        i$1++;
    }
    return permutations;
}
/**
 * Implementation of Combinations
 * Combinations are unique subsets of a collection - in this case, k x from a collection at a time.
 * https://en.wikipedia.org/wiki/Combination
 * @param {Array} x any type of data
 * @param {int} k the number of objects in each group (without replacement)
 * @returns {Array<Array>} array of permutations
 * @example
 * combinations([1, 2, 3], 2); // => [[1,2], [1,3], [2,3]]
 */ function $5b56aa3f46fee21b$export$bdfcf4c6b5766439(x, k) {
    var i;
    var subI;
    var combinationList = [];
    var subsetCombinations;
    var next;
    for(i = 0; i < x.length; i++)if (k === 1) combinationList.push([
        x[i]
    ]);
    else {
        subsetCombinations = $5b56aa3f46fee21b$export$bdfcf4c6b5766439(x.slice(i + 1, x.length), k - 1);
        for(subI = 0; subI < subsetCombinations.length; subI++){
            next = subsetCombinations[subI];
            next.unshift(x[i]);
            combinationList.push(next);
        }
    }
    return combinationList;
}
/**
 * Implementation of [Combinations](https://en.wikipedia.org/wiki/Combination) with replacement
 * Combinations are unique subsets of a collection - in this case, k x from a collection at a time.
 * 'With replacement' means that a given element can be chosen multiple times.
 * Unlike permutation, order doesn't matter for combinations.
 *
 * @param {Array} x any type of data
 * @param {int} k the number of objects in each group (without replacement)
 * @returns {Array<Array>} array of permutations
 * @example
 * combinationsReplacement([1, 2], 2); // => [[1, 1], [1, 2], [2, 2]]
 */ function $5b56aa3f46fee21b$export$9fac5003f1f2c36a(x, k) {
    var combinationList = [];
    for(var i = 0; i < x.length; i++)if (k === 1) // If we're requested to find only one element, we don't need
    // to recurse: just push `x[i]` onto the list of combinations.
    combinationList.push([
        x[i]
    ]);
    else {
        // Otherwise, recursively find combinations, given `k - 1`. Note that
        // we request `k - 1`, so if you were looking for k=3 combinations, we're
        // requesting k=2. This -1 gets reversed in the for loop right after this
        // code, since we concatenate `x[i]` onto the selected combinations,
        // bringing `k` back up to your requested level.
        // This recursion may go many levels deep, since it only stops once
        // k=1.
        var subsetCombinations = $5b56aa3f46fee21b$export$9fac5003f1f2c36a(x.slice(i, x.length), k - 1);
        for(var j = 0; j < subsetCombinations.length; j++)combinationList.push([
            x[i]
        ].concat(subsetCombinations[j]));
    }
    return combinationList;
}
/**
 * When adding a new value to a list, one does not have to necessary
 * recompute the mean of the list in linear time. They can instead use
 * this function to compute the new mean by providing the current mean,
 * the number of elements in the list that produced it and the new
 * value to add.
 *
 * @since 2.5.0
 * @param {number} mean current mean
 * @param {number} n number of items in the list
 * @param {number} newValue the added value
 * @returns {number} the new mean
 *
 * @example
 * addToMean(14, 5, 53); // => 20.5
 */ function $5b56aa3f46fee21b$export$8563a678191303f4(mean, n, newValue) {
    return mean + (newValue - mean) / (n + 1);
}
/**
 * When combining two lists of values for which one already knows the means,
 * one does not have to necessary recompute the mean of the combined lists in
 * linear time. They can instead use this function to compute the combined
 * mean by providing the mean & number of values of the first list and the mean
 * & number of values of the second list.
 *
 * @since 3.0.0
 * @param {number} mean1 mean of the first list
 * @param {number} n1 number of items in the first list
 * @param {number} mean2 mean of the second list
 * @param {number} n2 number of items in the second list
 * @returns {number} the combined mean
 *
 * @example
 * combineMeans(5, 3, 4, 3); // => 4.5
 */ function $5b56aa3f46fee21b$export$36ef12f86011e08c(mean1, n1, mean2, n2) {
    return (mean1 * n1 + mean2 * n2) / (n1 + n2);
}
/**
 * When combining two lists of values for which one already knows the variances,
 * one does not have to necessary recompute the variance of the combined lists
 * in linear time. They can instead use this function to compute the combined
 * variance by providing the variance, mean & number of values of the first list
 * and the variance, mean & number of values of the second list.
 *
 * @since 3.0.0
 * @param {number} variance1 variance of the first list
 * @param {number} mean1 mean of the first list
 * @param {number} n1 number of items in the first list
 * @param {number} variance2 variance of the second list
 * @param {number} mean2 mean of the second list
 * @param {number} n2 number of items in the second list
 * @returns {number} the combined mean
 *
 * @example
 * combineVariances(14 / 3, 5, 3, 8 / 3, 4, 3); // => 47 / 12
 */ function $5b56aa3f46fee21b$export$d5d718054483aa84(variance1, mean1, n1, variance2, mean2, n2) {
    var newMean = $5b56aa3f46fee21b$export$36ef12f86011e08c(mean1, n1, mean2, n2);
    return (n1 * (variance1 + Math.pow(mean1 - newMean, 2)) + n2 * (variance2 + Math.pow(mean2 - newMean, 2))) / (n1 + n2);
}
/**
 * The [Geometric Mean](https://en.wikipedia.org/wiki/Geometric_mean) is
 * a mean function that is more useful for numbers in different
 * ranges.
 *
 * This is the nth root of the input numbers multiplied by each other.
 *
 * The geometric mean is often useful for
 * **[proportional growth](https://en.wikipedia.org/wiki/Geometric_mean#Proportional_growth)**: given
 * growth rates for multiple years, like _80%, 16.66% and 42.85%_, a simple
 * mean will incorrectly estimate an average growth rate, whereas a geometric
 * mean will correctly estimate a growth rate that, over those years,
 * will yield the same end value.
 *
 * This runs in `O(n)`, linear time, with respect to the length of the array.
 *
 * @param {Array<number>} x sample of one or more data points
 * @returns {number} geometric mean
 * @throws {Error} if x is empty
 * @throws {Error} if x contains a negative number
 * @example
 * var growthRates = [1.80, 1.166666, 1.428571];
 * var averageGrowth = ss.geometricMean(growthRates);
 * var averageGrowthRates = [averageGrowth, averageGrowth, averageGrowth];
 * var startingValue = 10;
 * var startingValueMean = 10;
 * growthRates.forEach(function(rate) {
 *   startingValue *= rate;
 * });
 * averageGrowthRates.forEach(function(rate) {
 *   startingValueMean *= rate;
 * });
 * startingValueMean === startingValue;
 */ function $5b56aa3f46fee21b$export$beb8ae96a1c4f82f(x) {
    if (x.length === 0) throw new Error("geometricMean requires at least one data point");
    // the starting value.
    var value = 1;
    for(var i = 0; i < x.length; i++){
        // the geometric mean is only valid for positive numbers
        if (x[i] < 0) throw new Error("geometricMean requires only non-negative numbers as input");
        // repeatedly multiply the value by each number
        value *= x[i];
    }
    return Math.pow(value, 1 / x.length);
}
/**
 * The [log average](https://en.wikipedia.org/wiki/https://en.wikipedia.org/wiki/Geometric_mean#Relationship_with_logarithms)
 * is an equivalent way of computing the geometric mean of an array suitable for large or small products.
 *
 * It's found by calculating the average logarithm of the elements and exponentiating.
 *
 * @param {Array<number>} x sample of one or more data points
 * @returns {number} geometric mean
 * @throws {Error} if x is empty
 * @throws {Error} if x contains a negative number
 */ function $5b56aa3f46fee21b$export$d715307096a7158c(x) {
    if (x.length === 0) throw new Error("logAverage requires at least one data point");
    var value = 0;
    for(var i = 0; i < x.length; i++){
        if (x[i] < 0) throw new Error("logAverage requires only non-negative numbers as input");
        value += Math.log(x[i]);
    }
    return Math.exp(value / x.length);
}
/**
 * The [Harmonic Mean](https://en.wikipedia.org/wiki/Harmonic_mean) is
 * a mean function typically used to find the average of rates.
 * This mean is calculated by taking the reciprocal of the arithmetic mean
 * of the reciprocals of the input numbers.
 *
 * This is a [measure of central tendency](https://en.wikipedia.org/wiki/Central_tendency):
 * a method of finding a typical or central value of a set of numbers.
 *
 * This runs in `O(n)`, linear time, with respect to the length of the array.
 *
 * @param {Array<number>} x sample of one or more data points
 * @returns {number} harmonic mean
 * @throws {Error} if x is empty
 * @throws {Error} if x contains a negative number
 * @example
 * harmonicMean([2, 3]).toFixed(2) // => '2.40'
 */ function $5b56aa3f46fee21b$export$5dcbfd7d952217b6(x) {
    if (x.length === 0) throw new Error("harmonicMean requires at least one data point");
    var reciprocalSum = 0;
    for(var i = 0; i < x.length; i++){
        // the harmonic mean is only valid for positive numbers
        if (x[i] <= 0) throw new Error("harmonicMean requires only positive numbers as input");
        reciprocalSum += 1 / x[i];
    }
    // divide n by the reciprocal sum
    return x.length / reciprocalSum;
}
/**
 * The mean, _also known as average_,
 * is the sum of all values over the number of values.
 * This is a [measure of central tendency](https://en.wikipedia.org/wiki/Central_tendency):
 * a method of finding a typical or central value of a set of numbers.
 *
 * The simple mean uses the successive addition method internally
 * to calculate it's result. Errors in floating-point addition are
 * not accounted for, so if precision is required, the standard {@link mean}
 * method should be used instead.
 *
 * This runs in `O(n)`, linear time, with respect to the length of the array.
 *
 *
 * @param {Array<number>} x sample of one or more data points
 * @throws {Error} if the length of x is less than one
 * @returns {number} mean
 * @example
 * mean([0, 10]); // => 5
 */ function $5b56aa3f46fee21b$export$510ecc1d2c858d43(x) {
    if (x.length === 0) throw new Error("meanSimple requires at least one data point");
    return $5b56aa3f46fee21b$export$998aefe557563e24(x) / x.length;
}
/**
 * The [median](http://en.wikipedia.org/wiki/Median) is
 * the middle number of a list. This is often a good indicator of 'the middle'
 * when there are outliers that skew the `mean()` value.
 * This is a [measure of central tendency](https://en.wikipedia.org/wiki/Central_tendency):
 * a method of finding a typical or central value of a set of numbers.
 *
 * The median isn't necessarily one of the elements in the list: the value
 * can be the average of two elements if the list has an even length
 * and the two central values are different.
 *
 * @param {Array<number>} sorted input
 * @returns {number} median value
 * @example
 * medianSorted([10, 2, 5, 100, 2, 1]); // => 52.5
 */ function $5b56aa3f46fee21b$export$f61755d927a2762b(sorted) {
    return $5b56aa3f46fee21b$export$f924a6cad778dddb(sorted, 0.5);
}
/**
 * When removing a value from a list, one does not have to necessary
 * recompute the mean of the list in linear time. They can instead use
 * this function to compute the new mean by providing the current mean,
 * the number of elements in the list that produced it and the value to remove.
 *
 * @since 3.0.0
 * @param {number} mean current mean
 * @param {number} n number of items in the list
 * @param {number} value the value to remove
 * @returns {number} the new mean
 *
 * @example
 * subtractFromMean(20.5, 6, 53); // => 14
 */ function $5b56aa3f46fee21b$export$7077e37f5b787c25(mean, n, value) {
    return (mean * n - value) / (n - 1);
}
/**
 * The Root Mean Square (RMS) is
 * a mean function used as a measure of the magnitude of a set
 * of numbers, regardless of their sign.
 * This is the square root of the mean of the squares of the
 * input numbers.
 * This runs in `O(n)`, linear time, with respect to the length of the array.
 *
 * @param {Array<number>} x a sample of one or more data points
 * @returns {number} root mean square
 * @throws {Error} if x is empty
 * @example
 * rootMeanSquare([-1, 1, -1, 1]); // => 1
 */ function $5b56aa3f46fee21b$export$f143ee74e7108cf7(x) {
    if (x.length === 0) throw new Error("rootMeanSquare requires at least one data point");
    var sumOfSquares = 0;
    for(var i = 0; i < x.length; i++)sumOfSquares += Math.pow(x[i], 2);
    return Math.sqrt(sumOfSquares / x.length);
}
/**
 * The`coefficient of variation`_ is the ratio of the standard deviation to the mean.
 * .._`coefficient of variation`: https://en.wikipedia.org/wiki/Coefficient_of_variation
 *
 *
 * @param {Array} x input
 * @returns {number} coefficient of variation
 * @example
 * coefficientOfVariation([1, 2, 3, 4]).toFixed(3); // => 0.516
 * coefficientOfVariation([1, 2, 3, 4, 5]).toFixed(3); // => 0.527
 * coefficientOfVariation([-1, 0, 1, 2, 3, 4]).toFixed(3); // => 1.247
 */ function $5b56aa3f46fee21b$export$2c00c1ee843fdc06(x) {
    return $5b56aa3f46fee21b$export$5cb6c9899f9010bc(x) / $5b56aa3f46fee21b$export$cc6710ee5f037d57(x);
}
/**
 * This is to compute [a one-sample t-test](https://en.wikipedia.org/wiki/Student%27s_t-test#One-sample_t-test), comparing the mean
 * of a sample to a known value, x.
 *
 * in this case, we're trying to determine whether the
 * population mean is equal to the value that we know, which is `x`
 * here. Usually the results here are used to look up a
 * [p-value](http://en.wikipedia.org/wiki/P-value), which, for
 * a certain level of significance, will let you determine that the
 * null hypothesis can or cannot be rejected.
 *
 * @param {Array<number>} x sample of one or more numbers
 * @param {number} expectedValue expected value of the population mean
 * @returns {number} value
 * @example
 * tTest([1, 2, 3, 4, 5, 6], 3.385).toFixed(2); // => '0.16'
 */ function $5b56aa3f46fee21b$export$41e976ea3dc1eeba(x, expectedValue) {
    // The mean of the sample
    var sampleMean = $5b56aa3f46fee21b$export$cc6710ee5f037d57(x);
    // The standard deviation of the sample
    var sd = $5b56aa3f46fee21b$export$3cc65d9d108eb4e1(x);
    // Square root the length of the sample
    var rootN = Math.sqrt(x.length);
    // returning the t value
    return (sampleMean - expectedValue) / (sd / rootN);
}
/**
 * This is to compute [two sample t-test](http://en.wikipedia.org/wiki/Student's_t-test).
 * Tests whether "mean(X)-mean(Y) = difference", (
 * in the most common case, we often have `difference == 0` to test if two samples
 * are likely to be taken from populations with the same mean value) with
 * no prior knowledge on standard deviations of both samples
 * other than the fact that they have the same standard deviation.
 *
 * Usually the results here are used to look up a
 * [p-value](http://en.wikipedia.org/wiki/P-value), which, for
 * a certain level of significance, will let you determine that the
 * null hypothesis can or cannot be rejected.
 *
 * `diff` can be omitted if it equals 0.
 *
 * [This is used to reject](https://en.wikipedia.org/wiki/Exclusion_of_the_null_hypothesis)
 * a null hypothesis that the two populations that have been sampled into
 * `sampleX` and `sampleY` are equal to each other.
 *
 * @param {Array<number>} sampleX a sample as an array of numbers
 * @param {Array<number>} sampleY a sample as an array of numbers
 * @param {number} [difference=0]
 * @returns {number|null} test result
 *
 * @example
 * tTestTwoSample([1, 2, 3, 4], [3, 4, 5, 6], 0); // => -2.1908902300206643
 */ function $5b56aa3f46fee21b$export$8d14321ccc176aa5(sampleX, sampleY, difference) {
    var n = sampleX.length;
    var m = sampleY.length;
    // If either sample doesn't actually have any values, we can't
    // compute this at all, so we return `null`.
    if (!n || !m) return null;
    // default difference (mu) is zero
    if (!difference) difference = 0;
    var meanX = $5b56aa3f46fee21b$export$cc6710ee5f037d57(sampleX);
    var meanY = $5b56aa3f46fee21b$export$cc6710ee5f037d57(sampleY);
    var sampleVarianceX = $5b56aa3f46fee21b$export$99840dab7ddadfde(sampleX);
    var sampleVarianceY = $5b56aa3f46fee21b$export$99840dab7ddadfde(sampleY);
    if (typeof meanX === "number" && typeof meanY === "number" && typeof sampleVarianceX === "number" && typeof sampleVarianceY === "number") {
        var weightedVariance = ((n - 1) * sampleVarianceX + (m - 1) * sampleVarianceY) / (n + m - 2);
        return (meanX - meanY - difference) / Math.sqrt(weightedVariance * (1 / n + 1 / m));
    }
}
/**
 * This function calculates the Wilcoxon rank sum statistic for the first sample
 * with respect to the second. The Wilcoxon rank sum test is a non-parametric
 * alternative to the t-test which is equivalent to the
 * [Mann-Whitney U test](https://en.wikipedia.org/wiki/Mann%E2%80%93Whitney_U_test).
 * The statistic is calculated by pooling all the observations together, ranking them,
 * and then summing the ranks associated with one of the samples. If this rank sum is
 * sufficiently large or small we reject the hypothesis that the two samples come
 * from the same distribution in favor of the alternative that one is shifted with
 * respect to the other.
 *
 * @param {Array<number>} sampleX a sample as an array of numbers
 * @param {Array<number>} sampleY a sample as an array of numbers
 * @returns {number} rank sum for sampleX
 *
 * @example
 * wilcoxonRankSum([1, 4, 8], [9, 12, 15]); // => 6
 */ function $5b56aa3f46fee21b$export$107e0f503d399b3(sampleX, sampleY) {
    if (!sampleX.length || !sampleY.length) throw new Error("Neither sample can be empty");
    var pooledSamples = sampleX.map(function(x) {
        return {
            label: "x",
            value: x
        };
    }).concat(sampleY.map(function(y) {
        return {
            label: "y",
            value: y
        };
    })).sort(function(a, b) {
        return a.value - b.value;
    });
    for(var rank = 0; rank < pooledSamples.length; rank++)pooledSamples[rank].rank = rank;
    var tiedRanks = [
        pooledSamples[0].rank
    ];
    for(var i = 1; i < pooledSamples.length; i++){
        if (pooledSamples[i].value === pooledSamples[i - 1].value) {
            tiedRanks.push(pooledSamples[i].rank);
            if (i === pooledSamples.length - 1) replaceRanksInPlace(pooledSamples, tiedRanks);
        } else if (tiedRanks.length > 1) replaceRanksInPlace(pooledSamples, tiedRanks);
        else tiedRanks = [
            pooledSamples[i].rank
        ];
    }
    function replaceRanksInPlace(pooledSamples, tiedRanks) {
        var average = (tiedRanks[0] + tiedRanks[tiedRanks.length - 1]) / 2;
        for(var i = 0; i < tiedRanks.length; i++)pooledSamples[tiedRanks[i]].rank = average;
    }
    var rankSum = 0;
    for(var i$1 = 0; i$1 < pooledSamples.length; i$1++){
        var sample = pooledSamples[i$1];
        if (sample.label === "x") rankSum += sample.rank + 1;
    }
    return rankSum;
}
/**
 * [Bayesian Classifier](http://en.wikipedia.org/wiki/Naive_Bayes_classifier)
 *
 * This is a naïve bayesian classifier that takes
 * singly-nested objects.
 *
 * @class
 * @example
 * var bayes = new BayesianClassifier();
 * bayes.train({
 *   species: 'Cat'
 * }, 'animal');
 * var result = bayes.score({
 *   species: 'Cat'
 * })
 * // result
 * // {
 * //   animal: 1
 * // }
 */ var $5b56aa3f46fee21b$export$393797131f9ad5e9 = function BayesianClassifier() {
    // The number of items that are currently
    // classified in the model
    this.totalCount = 0;
    // Every item classified in the model
    this.data = {};
};
/**
 * Train the classifier with a new item, which has a single
 * dimension of Javascript literal keys and values.
 *
 * @param {Object} item an object with singly-deep properties
 * @param {string} category the category this item belongs to
 * @return {undefined} adds the item to the classifier
 */ $5b56aa3f46fee21b$export$393797131f9ad5e9.prototype.train = function train(item, category) {
    // If the data object doesn't have any values
    // for this category, create a new object for it.
    if (!this.data[category]) this.data[category] = {};
    // Iterate through each key in the item.
    for(var k in item){
        var v = item[k];
        // Initialize the nested object `data[category][k][item[k]]`
        // with an object of keys that equal 0.
        if (this.data[category][k] === undefined) this.data[category][k] = {};
        if (this.data[category][k][v] === undefined) this.data[category][k][v] = 0;
        // And increment the key for this key/value combination.
        this.data[category][k][v]++;
    }
    // Increment the number of items classified
    this.totalCount++;
};
/**
 * Generate a score of how well this item matches all
 * possible categories based on its attributes
 *
 * @param {Object} item an item in the same format as with train
 * @returns {Object} of probabilities that this item belongs to a
 * given category.
 */ $5b56aa3f46fee21b$export$393797131f9ad5e9.prototype.score = function score(item) {
    // Initialize an empty array of odds per category.
    var odds = {};
    var category;
    // Iterate through each key in the item,
    // then iterate through each category that has been used
    // in previous calls to `.train()`
    for(var k in item){
        var v = item[k];
        for(category in this.data){
            // Create an empty object for storing key - value combinations
            // for this category.
            odds[category] = {};
            // If this item doesn't even have a property, it counts for nothing,
            // but if it does have the property that we're looking for from
            // the item to categorize, it counts based on how popular it is
            // versus the whole population.
            if (this.data[category][k]) odds[category][k + "_" + v] = (this.data[category][k][v] || 0) / this.totalCount;
            else odds[category][k + "_" + v] = 0;
        }
    }
    // Set up a new object that will contain sums of these odds by category
    var oddsSums = {};
    for(category in odds){
        // Tally all of the odds for each category-combination pair -
        // the non-existence of a category does not add anything to the
        // score.
        oddsSums[category] = 0;
        for(var combination in odds[category])oddsSums[category] += odds[category][combination];
    }
    return oddsSums;
};
/**
 * This is a single-layer [Perceptron Classifier](http://en.wikipedia.org/wiki/Perceptron) that takes
 * arrays of numbers and predicts whether they should be classified
 * as either 0 or 1 (negative or positive examples).
 * @class
 * @example
 * // Create the model
 * var p = new PerceptronModel();
 * // Train the model with input with a diagonal boundary.
 * for (var i = 0; i < 5; i++) {
 *     p.train([1, 1], 1);
 *     p.train([0, 1], 0);
 *     p.train([1, 0], 0);
 *     p.train([0, 0], 0);
 * }
 * p.predict([0, 0]); // 0
 * p.predict([0, 1]); // 0
 * p.predict([1, 0]); // 0
 * p.predict([1, 1]); // 1
 */ var $5b56aa3f46fee21b$export$90c8895b5336794f = function PerceptronModel() {
    // The weights, or coefficients of the model;
    // weights are only populated when training with data.
    this.weights = [];
    // The bias term, or intercept; it is also a weight but
    // it's stored separately for convenience as it is always
    // multiplied by one.
    this.bias = 0;
};
/**
 * **Predict**: Use an array of features with the weight array and bias
 * to predict whether an example is labeled 0 or 1.
 *
 * @param {Array<number>} features an array of features as numbers
 * @returns {number} 1 if the score is over 0, otherwise 0
 */ $5b56aa3f46fee21b$export$90c8895b5336794f.prototype.predict = function predict(features) {
    // Only predict if previously trained
    // on the same size feature array(s).
    if (features.length !== this.weights.length) return null;
    // Calculate the sum of features times weights,
    // with the bias added (implicitly times one).
    var score = 0;
    for(var i = 0; i < this.weights.length; i++)score += this.weights[i] * features[i];
    score += this.bias;
    // Classify as 1 if the score is over 0, otherwise 0.
    if (score > 0) return 1;
    else return 0;
};
/**
 * **Train** the classifier with a new example, which is
 * a numeric array of features and a 0 or 1 label.
 *
 * @param {Array<number>} features an array of features as numbers
 * @param {number} label either 0 or 1
 * @returns {PerceptronModel} this
 */ $5b56aa3f46fee21b$export$90c8895b5336794f.prototype.train = function train(features, label) {
    // Require that only labels of 0 or 1 are considered.
    if (label !== 0 && label !== 1) return null;
    // The length of the feature array determines
    // the length of the weight array.
    // The perceptron will continue learning as long as
    // it keeps seeing feature arrays of the same length.
    // When it sees a new data shape, it initializes.
    if (features.length !== this.weights.length) {
        this.weights = features;
        this.bias = 1;
    }
    // Make a prediction based on current weights.
    var prediction = this.predict(features);
    // Update the weights if the prediction is wrong.
    if (typeof prediction === "number" && prediction !== label) {
        var gradient = label - prediction;
        for(var i = 0; i < this.weights.length; i++)this.weights[i] += gradient * features[i];
        this.bias += gradient;
    }
    return this;
};
/**
 * We use `ε`, epsilon, as a stopping criterion when we want to iterate
 * until we're "close enough". Epsilon is a very small number: for
 * simple statistics, that number is **0.0001**
 *
 * This is used in calculations like the binomialDistribution, in which
 * the process of finding a value is [iterative](https://en.wikipedia.org/wiki/Iterative_method):
 * it progresses until it is close enough.
 *
 * Below is an example of using epsilon in [gradient descent](https://en.wikipedia.org/wiki/Gradient_descent),
 * where we're trying to find a local minimum of a function's derivative,
 * given by the `fDerivative` method.
 *
 * @example
 * // From calculation, we expect that the local minimum occurs at x=9/4
 * var x_old = 0;
 * // The algorithm starts at x=6
 * var x_new = 6;
 * var stepSize = 0.01;
 *
 * function fDerivative(x) {
 *   return 4 * Math.pow(x, 3) - 9 * Math.pow(x, 2);
 * }
 *
 * // The loop runs until the difference between the previous
 * // value and the current value is smaller than epsilon - a rough
 * // meaure of 'close enough'
 * while (Math.abs(x_new - x_old) > ss.epsilon) {
 *   x_old = x_new;
 *   x_new = x_old - stepSize * fDerivative(x_old);
 * }
 *
 * console.log('Local minimum occurs at', x_new);
 */ var $5b56aa3f46fee21b$export$6c421550c66a327d = 0.0001;
/**
 * A [Factorial](https://en.wikipedia.org/wiki/Factorial), usually written n!, is the product of all positive
 * integers less than or equal to n. Often factorial is implemented
 * recursively, but this iterative approach is significantly faster
 * and simpler.
 *
 * @param {number} n input, must be an integer number 1 or greater
 * @returns {number} factorial: n!
 * @throws {Error} if n is less than 0 or not an integer
 * @example
 * factorial(5); // => 120
 */ function $5b56aa3f46fee21b$export$329ce89a99f0e343(n) {
    // factorial is mathematically undefined for negative numbers
    if (n < 0) throw new Error("factorial requires a non-negative value");
    if (Math.floor(n) !== n) throw new Error("factorial requires an integer input");
    // typically you'll expand the factorial function going down, like
    // 5! = 5 * 4 * 3 * 2 * 1. This is going in the opposite direction,
    // counting from 2 up to the number in question, and since anything
    // multiplied by 1 is itself, the loop only needs to start at 2.
    var accumulator = 1;
    for(var i = 2; i <= n; i++)// for each number up to and including the number `n`, multiply
    // the accumulator my that number.
    accumulator *= i;
    return accumulator;
}
/**
 * Compute the [gamma function](https://en.wikipedia.org/wiki/Gamma_function) of a value using Nemes' approximation.
 * The gamma of n is equivalent to (n-1)!, but unlike the factorial function, gamma is defined for all real n except zero
 * and negative integers (where NaN is returned). Note, the gamma function is also well-defined for complex numbers,
 * though this implementation currently does not handle complex numbers as input values.
 * Nemes' approximation is defined [here](https://arxiv.org/abs/1003.6020) as Theorem 2.2.
 * Negative values use [Euler's reflection formula](https://en.wikipedia.org/wiki/Gamma_function#Properties) for computation.
 *
 * @param {number} n Any real number except for zero and negative integers.
 * @returns {number} The gamma of the input value.
 *
 * @example
 * gamma(11.5); // 11899423.084037038
 * gamma(-11.5); // 2.29575810481609e-8
 * gamma(5); // 24
 */ function $5b56aa3f46fee21b$export$a7ebe8cc6aaf8d37(n) {
    if (Number.isInteger(n)) {
        if (n <= 0) // gamma not defined for zero or negative integers
        return Number.NaN;
        else // use factorial for integer inputs
        return $5b56aa3f46fee21b$export$329ce89a99f0e343(n - 1);
    }
    // Decrement n, because approximation is defined for n - 1
    n--;
    if (n < 0) // Use Euler's reflection formula for negative inputs
    // see:  https://en.wikipedia.org/wiki/Gamma_function#Properties
    return Math.PI / (Math.sin(Math.PI * -n) * $5b56aa3f46fee21b$export$a7ebe8cc6aaf8d37(-n));
    else {
        // Nemes' expansion approximation
        var seriesCoefficient = Math.pow(n / Math.E, n) * Math.sqrt(2 * Math.PI * (n + 1 / 6));
        var seriesDenom = n + 1 / 4;
        var seriesExpansion = 1 + 1 / 144 / Math.pow(seriesDenom, 2) - 1 / 12960 / Math.pow(seriesDenom, 3) - 257 / 207360 / Math.pow(seriesDenom, 4) - 52 / 2612736 / Math.pow(seriesDenom, 5) + 5741173 / 9405849600 / Math.pow(seriesDenom, 6) + 37529 / 18811699200 / Math.pow(seriesDenom, 7);
        return seriesCoefficient * seriesExpansion;
    }
}
// Define series coefficients
var $5b56aa3f46fee21b$var$COEFFICIENTS = [
    0.99999999999999709182,
    57.156235665862923517,
    -59.59796035547549,
    14.136097974741747174,
    -0.4919138160976202,
    0.33994649984811888699e-4,
    0.46523628927048575665e-4,
    -0.00009837447530487956,
    0.15808870322491248884e-3,
    -0.00021026444172410488,
    0.2174396181152126432e-3,
    -0.0001643181065367639,
    0.84418223983852743293e-4,
    -0.000026190838401581408,
    0.36899182659531622704e-5
];
var $5b56aa3f46fee21b$var$g = 607 / 128;
var $5b56aa3f46fee21b$var$LOGSQRT2PI = Math.log(Math.sqrt(2 * Math.PI));
/**
 * Compute the logarithm of the [gamma function](https://en.wikipedia.org/wiki/Gamma_function) of a value using Lanczos' approximation.
 * This function takes as input any real-value n greater than 0.
 * This function is useful for values of n too large for the normal gamma function (n > 165).
 * The code is based on Lanczo's Gamma approximation, defined [here](http://my.fit.edu/~gabdo/gamma.txt).
 *
 * @param {number} n Any real number greater than zero.
 * @returns {number} The logarithm of gamma of the input value.
 *
 * @example
 * gammaln(500); // 2605.1158503617335
 * gammaln(2.4); // 0.21685932244884043
 */ function $5b56aa3f46fee21b$export$9bc1e10ad17a0268(n) {
    // Return infinity if value not in domain
    if (n <= 0) return Number.POSITIVE_INFINITY;
    // Decrement n, because approximation is defined for n - 1
    n--;
    // Create series approximation
    var a = $5b56aa3f46fee21b$var$COEFFICIENTS[0];
    for(var i = 1; i < 15; i++)a += $5b56aa3f46fee21b$var$COEFFICIENTS[i] / (n + i);
    var tmp = $5b56aa3f46fee21b$var$g + 0.5 + n;
    // Return natural logarithm of gamma(n)
    return $5b56aa3f46fee21b$var$LOGSQRT2PI + Math.log(a) - tmp + (n + 0.5) * Math.log(tmp);
}
/**
 * The [Bernoulli distribution](http://en.wikipedia.org/wiki/Bernoulli_distribution)
 * is the probability discrete
 * distribution of a random variable which takes value 1 with success
 * probability `p` and value 0 with failure
 * probability `q` = 1 - `p`. It can be used, for example, to represent the
 * toss of a coin, where "1" is defined to mean "heads" and "0" is defined
 * to mean "tails" (or vice versa). It is
 * a special case of a Binomial Distribution
 * where `n` = 1.
 *
 * @param {number} p input value, between 0 and 1 inclusive
 * @returns {number[]} values of bernoulli distribution at this point
 * @throws {Error} if p is outside 0 and 1
 * @example
 * bernoulliDistribution(0.3); // => [0.7, 0.3]
 */ function $5b56aa3f46fee21b$export$8f1706058efadf18(p) /*: number[] */ {
    // Check that `p` is a valid probability (0 ≤ p ≤ 1)
    if (p < 0 || p > 1) throw new Error("bernoulliDistribution requires probability to be between 0 and 1 inclusive");
    return [
        1 - p,
        p
    ];
}
/**
 * The [Binomial Distribution](http://en.wikipedia.org/wiki/Binomial_distribution) is the discrete probability
 * distribution of the number of successes in a sequence of n independent yes/no experiments, each of which yields
 * success with probability `probability`. Such a success/failure experiment is also called a Bernoulli experiment or
 * Bernoulli trial; when trials = 1, the Binomial Distribution is a Bernoulli Distribution.
 *
 * @param {number} trials number of trials to simulate
 * @param {number} probability
 * @returns {number[]} output
 */ function $5b56aa3f46fee21b$export$5ee4d6ab593de471(trials, probability) /*: ?number[] */ {
    // Check that `p` is a valid probability (0 ≤ p ≤ 1),
    // that `n` is an integer, strictly positive.
    if (probability < 0 || probability > 1 || trials <= 0 || trials % 1 !== 0) return undefined;
    // We initialize `x`, the random variable, and `accumulator`, an accumulator
    // for the cumulative distribution function to 0. `distribution_functions`
    // is the object we'll return with the `probability_of_x` and the
    // `cumulativeProbability_of_x`, as well as the calculated mean &
    // variance. We iterate until the `cumulativeProbability_of_x` is
    // within `epsilon` of 1.0.
    var x = 0;
    var cumulativeProbability = 0;
    var cells = [];
    var binomialCoefficient = 1;
    // This algorithm iterates through each potential outcome,
    // until the `cumulativeProbability` is very close to 1, at
    // which point we've defined the vast majority of outcomes
    do {
        // a [probability mass function](https://en.wikipedia.org/wiki/Probability_mass_function)
        cells[x] = binomialCoefficient * Math.pow(probability, x) * Math.pow(1 - probability, trials - x);
        cumulativeProbability += cells[x];
        x++;
        binomialCoefficient = binomialCoefficient * (trials - x + 1) / x;
    // when the cumulativeProbability is nearly 1, we've calculated
    // the useful range of this distribution
    }while (cumulativeProbability < 1 - $5b56aa3f46fee21b$export$6c421550c66a327d);
    return cells;
}
/**
 * The [Poisson Distribution](http://en.wikipedia.org/wiki/Poisson_distribution)
 * is a discrete probability distribution that expresses the probability
 * of a given number of events occurring in a fixed interval of time
 * and/or space if these events occur with a known average rate and
 * independently of the time since the last event.
 *
 * The Poisson Distribution is characterized by the strictly positive
 * mean arrival or occurrence rate, `λ`.
 *
 * @param {number} lambda location poisson distribution
 * @returns {number[]} values of poisson distribution at that point
 */ function $5b56aa3f46fee21b$export$e4c6c1af47f4911b(lambda) /*: ?number[] */ {
    // Check that lambda is strictly positive
    if (lambda <= 0) return undefined;
    // our current place in the distribution
    var x = 0;
    // and we keep track of the current cumulative probability, in
    // order to know when to stop calculating chances.
    var cumulativeProbability = 0;
    // the calculated cells to be returned
    var cells = [];
    var factorialX = 1;
    // This algorithm iterates through each potential outcome,
    // until the `cumulativeProbability` is very close to 1, at
    // which point we've defined the vast majority of outcomes
    do {
        // a [probability mass function](https://en.wikipedia.org/wiki/Probability_mass_function)
        cells[x] = Math.exp(-lambda) * Math.pow(lambda, x) / factorialX;
        cumulativeProbability += cells[x];
        x++;
        factorialX *= x;
    // when the cumulativeProbability is nearly 1, we've calculated
    // the useful range of this distribution
    }while (cumulativeProbability < 1 - $5b56aa3f46fee21b$export$6c421550c66a327d);
    return cells;
}
/**
 * **Percentage Points of the χ2 (Chi-Squared) Distribution**
 *
 * The [χ2 (Chi-Squared) Distribution](http://en.wikipedia.org/wiki/Chi-squared_distribution) is used in the common
 * chi-squared tests for goodness of fit of an observed distribution to a theoretical one, the independence of two
 * criteria of classification of qualitative data, and in confidence interval estimation for a population standard
 * deviation of a normal distribution from a sample standard deviation.
 *
 * Values from Appendix 1, Table III of William W. Hines & Douglas C. Montgomery, "Probability and Statistics in
 * Engineering and Management Science", Wiley (1980).
 */ var $5b56aa3f46fee21b$export$3c552b1d8dcf8f3e = {
    1: {
        0.995: 0,
        0.99: 0,
        0.975: 0,
        0.95: 0,
        0.9: 0.02,
        0.5: 0.45,
        0.1: 2.71,
        0.05: 3.84,
        0.025: 5.02,
        0.01: 6.63,
        0.005: 7.88
    },
    2: {
        0.995: 0.01,
        0.99: 0.02,
        0.975: 0.05,
        0.95: 0.1,
        0.9: 0.21,
        0.5: 1.39,
        0.1: 4.61,
        0.05: 5.99,
        0.025: 7.38,
        0.01: 9.21,
        0.005: 10.6
    },
    3: {
        0.995: 0.07,
        0.99: 0.11,
        0.975: 0.22,
        0.95: 0.35,
        0.9: 0.58,
        0.5: 2.37,
        0.1: 6.25,
        0.05: 7.81,
        0.025: 9.35,
        0.01: 11.34,
        0.005: 12.84
    },
    4: {
        0.995: 0.21,
        0.99: 0.3,
        0.975: 0.48,
        0.95: 0.71,
        0.9: 1.06,
        0.5: 3.36,
        0.1: 7.78,
        0.05: 9.49,
        0.025: 11.14,
        0.01: 13.28,
        0.005: 14.86
    },
    5: {
        0.995: 0.41,
        0.99: 0.55,
        0.975: 0.83,
        0.95: 1.15,
        0.9: 1.61,
        0.5: 4.35,
        0.1: 9.24,
        0.05: 11.07,
        0.025: 12.83,
        0.01: 15.09,
        0.005: 16.75
    },
    6: {
        0.995: 0.68,
        0.99: 0.87,
        0.975: 1.24,
        0.95: 1.64,
        0.9: 2.2,
        0.5: 5.35,
        0.1: 10.65,
        0.05: 12.59,
        0.025: 14.45,
        0.01: 16.81,
        0.005: 18.55
    },
    7: {
        0.995: 0.99,
        0.99: 1.25,
        0.975: 1.69,
        0.95: 2.17,
        0.9: 2.83,
        0.5: 6.35,
        0.1: 12.02,
        0.05: 14.07,
        0.025: 16.01,
        0.01: 18.48,
        0.005: 20.28
    },
    8: {
        0.995: 1.34,
        0.99: 1.65,
        0.975: 2.18,
        0.95: 2.73,
        0.9: 3.49,
        0.5: 7.34,
        0.1: 13.36,
        0.05: 15.51,
        0.025: 17.53,
        0.01: 20.09,
        0.005: 21.96
    },
    9: {
        0.995: 1.73,
        0.99: 2.09,
        0.975: 2.7,
        0.95: 3.33,
        0.9: 4.17,
        0.5: 8.34,
        0.1: 14.68,
        0.05: 16.92,
        0.025: 19.02,
        0.01: 21.67,
        0.005: 23.59
    },
    10: {
        0.995: 2.16,
        0.99: 2.56,
        0.975: 3.25,
        0.95: 3.94,
        0.9: 4.87,
        0.5: 9.34,
        0.1: 15.99,
        0.05: 18.31,
        0.025: 20.48,
        0.01: 23.21,
        0.005: 25.19
    },
    11: {
        0.995: 2.6,
        0.99: 3.05,
        0.975: 3.82,
        0.95: 4.57,
        0.9: 5.58,
        0.5: 10.34,
        0.1: 17.28,
        0.05: 19.68,
        0.025: 21.92,
        0.01: 24.72,
        0.005: 26.76
    },
    12: {
        0.995: 3.07,
        0.99: 3.57,
        0.975: 4.4,
        0.95: 5.23,
        0.9: 6.3,
        0.5: 11.34,
        0.1: 18.55,
        0.05: 21.03,
        0.025: 23.34,
        0.01: 26.22,
        0.005: 28.3
    },
    13: {
        0.995: 3.57,
        0.99: 4.11,
        0.975: 5.01,
        0.95: 5.89,
        0.9: 7.04,
        0.5: 12.34,
        0.1: 19.81,
        0.05: 22.36,
        0.025: 24.74,
        0.01: 27.69,
        0.005: 29.82
    },
    14: {
        0.995: 4.07,
        0.99: 4.66,
        0.975: 5.63,
        0.95: 6.57,
        0.9: 7.79,
        0.5: 13.34,
        0.1: 21.06,
        0.05: 23.68,
        0.025: 26.12,
        0.01: 29.14,
        0.005: 31.32
    },
    15: {
        0.995: 4.6,
        0.99: 5.23,
        0.975: 6.27,
        0.95: 7.26,
        0.9: 8.55,
        0.5: 14.34,
        0.1: 22.31,
        0.05: 25,
        0.025: 27.49,
        0.01: 30.58,
        0.005: 32.8
    },
    16: {
        0.995: 5.14,
        0.99: 5.81,
        0.975: 6.91,
        0.95: 7.96,
        0.9: 9.31,
        0.5: 15.34,
        0.1: 23.54,
        0.05: 26.3,
        0.025: 28.85,
        0.01: 32,
        0.005: 34.27
    },
    17: {
        0.995: 5.7,
        0.99: 6.41,
        0.975: 7.56,
        0.95: 8.67,
        0.9: 10.09,
        0.5: 16.34,
        0.1: 24.77,
        0.05: 27.59,
        0.025: 30.19,
        0.01: 33.41,
        0.005: 35.72
    },
    18: {
        0.995: 6.26,
        0.99: 7.01,
        0.975: 8.23,
        0.95: 9.39,
        0.9: 10.87,
        0.5: 17.34,
        0.1: 25.99,
        0.05: 28.87,
        0.025: 31.53,
        0.01: 34.81,
        0.005: 37.16
    },
    19: {
        0.995: 6.84,
        0.99: 7.63,
        0.975: 8.91,
        0.95: 10.12,
        0.9: 11.65,
        0.5: 18.34,
        0.1: 27.2,
        0.05: 30.14,
        0.025: 32.85,
        0.01: 36.19,
        0.005: 38.58
    },
    20: {
        0.995: 7.43,
        0.99: 8.26,
        0.975: 9.59,
        0.95: 10.85,
        0.9: 12.44,
        0.5: 19.34,
        0.1: 28.41,
        0.05: 31.41,
        0.025: 34.17,
        0.01: 37.57,
        0.005: 40
    },
    21: {
        0.995: 8.03,
        0.99: 8.9,
        0.975: 10.28,
        0.95: 11.59,
        0.9: 13.24,
        0.5: 20.34,
        0.1: 29.62,
        0.05: 32.67,
        0.025: 35.48,
        0.01: 38.93,
        0.005: 41.4
    },
    22: {
        0.995: 8.64,
        0.99: 9.54,
        0.975: 10.98,
        0.95: 12.34,
        0.9: 14.04,
        0.5: 21.34,
        0.1: 30.81,
        0.05: 33.92,
        0.025: 36.78,
        0.01: 40.29,
        0.005: 42.8
    },
    23: {
        0.995: 9.26,
        0.99: 10.2,
        0.975: 11.69,
        0.95: 13.09,
        0.9: 14.85,
        0.5: 22.34,
        0.1: 32.01,
        0.05: 35.17,
        0.025: 38.08,
        0.01: 41.64,
        0.005: 44.18
    },
    24: {
        0.995: 9.89,
        0.99: 10.86,
        0.975: 12.4,
        0.95: 13.85,
        0.9: 15.66,
        0.5: 23.34,
        0.1: 33.2,
        0.05: 36.42,
        0.025: 39.36,
        0.01: 42.98,
        0.005: 45.56
    },
    25: {
        0.995: 10.52,
        0.99: 11.52,
        0.975: 13.12,
        0.95: 14.61,
        0.9: 16.47,
        0.5: 24.34,
        0.1: 34.28,
        0.05: 37.65,
        0.025: 40.65,
        0.01: 44.31,
        0.005: 46.93
    },
    26: {
        0.995: 11.16,
        0.99: 12.2,
        0.975: 13.84,
        0.95: 15.38,
        0.9: 17.29,
        0.5: 25.34,
        0.1: 35.56,
        0.05: 38.89,
        0.025: 41.92,
        0.01: 45.64,
        0.005: 48.29
    },
    27: {
        0.995: 11.81,
        0.99: 12.88,
        0.975: 14.57,
        0.95: 16.15,
        0.9: 18.11,
        0.5: 26.34,
        0.1: 36.74,
        0.05: 40.11,
        0.025: 43.19,
        0.01: 46.96,
        0.005: 49.65
    },
    28: {
        0.995: 12.46,
        0.99: 13.57,
        0.975: 15.31,
        0.95: 16.93,
        0.9: 18.94,
        0.5: 27.34,
        0.1: 37.92,
        0.05: 41.34,
        0.025: 44.46,
        0.01: 48.28,
        0.005: 50.99
    },
    29: {
        0.995: 13.12,
        0.99: 14.26,
        0.975: 16.05,
        0.95: 17.71,
        0.9: 19.77,
        0.5: 28.34,
        0.1: 39.09,
        0.05: 42.56,
        0.025: 45.72,
        0.01: 49.59,
        0.005: 52.34
    },
    30: {
        0.995: 13.79,
        0.99: 14.95,
        0.975: 16.79,
        0.95: 18.49,
        0.9: 20.6,
        0.5: 29.34,
        0.1: 40.26,
        0.05: 43.77,
        0.025: 46.98,
        0.01: 50.89,
        0.005: 53.67
    },
    40: {
        0.995: 20.71,
        0.99: 22.16,
        0.975: 24.43,
        0.95: 26.51,
        0.9: 29.05,
        0.5: 39.34,
        0.1: 51.81,
        0.05: 55.76,
        0.025: 59.34,
        0.01: 63.69,
        0.005: 66.77
    },
    50: {
        0.995: 27.99,
        0.99: 29.71,
        0.975: 32.36,
        0.95: 34.76,
        0.9: 37.69,
        0.5: 49.33,
        0.1: 63.17,
        0.05: 67.5,
        0.025: 71.42,
        0.01: 76.15,
        0.005: 79.49
    },
    60: {
        0.995: 35.53,
        0.99: 37.48,
        0.975: 40.48,
        0.95: 43.19,
        0.9: 46.46,
        0.5: 59.33,
        0.1: 74.4,
        0.05: 79.08,
        0.025: 83.3,
        0.01: 88.38,
        0.005: 91.95
    },
    70: {
        0.995: 43.28,
        0.99: 45.44,
        0.975: 48.76,
        0.95: 51.74,
        0.9: 55.33,
        0.5: 69.33,
        0.1: 85.53,
        0.05: 90.53,
        0.025: 95.02,
        0.01: 100.42,
        0.005: 104.22
    },
    80: {
        0.995: 51.17,
        0.99: 53.54,
        0.975: 57.15,
        0.95: 60.39,
        0.9: 64.28,
        0.5: 79.33,
        0.1: 96.58,
        0.05: 101.88,
        0.025: 106.63,
        0.01: 112.33,
        0.005: 116.32
    },
    90: {
        0.995: 59.2,
        0.99: 61.75,
        0.975: 65.65,
        0.95: 69.13,
        0.9: 73.29,
        0.5: 89.33,
        0.1: 107.57,
        0.05: 113.14,
        0.025: 118.14,
        0.01: 124.12,
        0.005: 128.3
    },
    100: {
        0.995: 67.33,
        0.99: 70.06,
        0.975: 74.22,
        0.95: 77.93,
        0.9: 82.36,
        0.5: 99.33,
        0.1: 118.5,
        0.05: 124.34,
        0.025: 129.56,
        0.01: 135.81,
        0.005: 140.17
    }
};
/**
 * The [χ2 (Chi-Squared) Goodness-of-Fit Test](http://en.wikipedia.org/wiki/Goodness_of_fit#Pearson.27s_chi-squared_test)
 * uses a measure of goodness of fit which is the sum of differences between observed and expected outcome frequencies
 * (that is, counts of observations), each squared and divided by the number of observations expected given the
 * hypothesized distribution. The resulting χ2 statistic, `chiSquared`, can be compared to the chi-squared distribution
 * to determine the goodness of fit. In order to determine the degrees of freedom of the chi-squared distribution, one
 * takes the total number of observed frequencies and subtracts the number of estimated parameters. The test statistic
 * follows, approximately, a chi-square distribution with (k − c) degrees of freedom where `k` is the number of non-empty
 * cells and `c` is the number of estimated parameters for the distribution.
 *
 * @param {Array<number>} data
 * @param {Function} distributionType a function that returns a point in a distribution:
 * for instance, binomial, bernoulli, or poisson
 * @param {number} significance
 * @returns {number} chi squared goodness of fit
 * @example
 * // Data from Poisson goodness-of-fit example 10-19 in William W. Hines & Douglas C. Montgomery,
 * // "Probability and Statistics in Engineering and Management Science", Wiley (1980).
 * var data1019 = [
 *     0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
 *     0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
 *     1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
 *     2, 2, 2, 2, 2, 2, 2, 2, 2,
 *     3, 3, 3, 3
 * ];
 * ss.chiSquaredGoodnessOfFit(data1019, ss.poissonDistribution, 0.05); //= false
 */ function $5b56aa3f46fee21b$export$65cec896ac94916c(data, distributionType, significance) {
    // Estimate from the sample data, a weighted mean.
    var inputMean = $5b56aa3f46fee21b$export$cc6710ee5f037d57(data);
    // Calculated value of the χ2 statistic.
    var chiSquared = 0;
    // Number of hypothesized distribution parameters estimated, expected to be supplied in the distribution test.
    // Lose one degree of freedom for estimating `lambda` from the sample data.
    var c = 1;
    // The hypothesized distribution.
    // Generate the hypothesized distribution.
    var hypothesizedDistribution = distributionType(inputMean);
    var observedFrequencies = [];
    var expectedFrequencies = [];
    // Create an array holding a histogram from the sample data, of
    // the form `{ value: numberOfOcurrences }`
    for(var i = 0; i < data.length; i++){
        if (observedFrequencies[data[i]] === undefined) observedFrequencies[data[i]] = 0;
        observedFrequencies[data[i]]++;
    }
    // The histogram we created might be sparse - there might be gaps
    // between values. So we iterate through the histogram, making
    // sure that instead of undefined, gaps have 0 values.
    for(var i$1 = 0; i$1 < observedFrequencies.length; i$1++)if (observedFrequencies[i$1] === undefined) observedFrequencies[i$1] = 0;
    // Create an array holding a histogram of expected data given the
    // sample size and hypothesized distribution.
    for(var k in hypothesizedDistribution)if (k in observedFrequencies) expectedFrequencies[+k] = hypothesizedDistribution[k] * data.length;
    // Working backward through the expected frequencies, collapse classes
    // if less than three observations are expected for a class.
    // This transformation is applied to the observed frequencies as well.
    for(var k$1 = expectedFrequencies.length - 1; k$1 >= 0; k$1--)if (expectedFrequencies[k$1] < 3) {
        expectedFrequencies[k$1 - 1] += expectedFrequencies[k$1];
        expectedFrequencies.pop();
        observedFrequencies[k$1 - 1] += observedFrequencies[k$1];
        observedFrequencies.pop();
    }
    // Iterate through the squared differences between observed & expected
    // frequencies, accumulating the `chiSquared` statistic.
    for(var k$2 = 0; k$2 < observedFrequencies.length; k$2++)chiSquared += Math.pow(observedFrequencies[k$2] - expectedFrequencies[k$2], 2) / expectedFrequencies[k$2];
    // Calculate degrees of freedom for this test and look it up in the
    // `chiSquaredDistributionTable` in order to
    // accept or reject the goodness-of-fit of the hypothesized distribution.
    // Degrees of freedom, calculated as (number of class intervals -
    // number of hypothesized distribution parameters estimated - 1)
    var degreesOfFreedom = observedFrequencies.length - c - 1;
    return $5b56aa3f46fee21b$export$3c552b1d8dcf8f3e[degreesOfFreedom][significance] < chiSquared;
}
var $5b56aa3f46fee21b$var$SQRT_2PI$1 = Math.sqrt(2 * Math.PI);
/**
 * [Well-known kernels](https://en.wikipedia.org/wiki/Kernel_(statistics)#Kernel_functions_in_common_use)
 * @private
 */ var $5b56aa3f46fee21b$var$kernels = {
    /**
     * The gaussian kernel.
     * @private
     */ gaussian: function(u) {
        return Math.exp(-0.5 * u * u) / $5b56aa3f46fee21b$var$SQRT_2PI$1;
    }
};
/**
 * Well known bandwidth selection methods
 * @private
 */ var $5b56aa3f46fee21b$var$bandwidthMethods = {
    /**
     * The ["normal reference distribution"
     * rule-of-thumb](https://stat.ethz.ch/R-manual/R-devel/library/MASS/html/bandwidth.nrd.html),
     * a commonly used version of [Silverman's
     * rule-of-thumb](https://en.wikipedia.org/wiki/Kernel_density_estimation#A_rule-of-thumb_bandwidth_estimator).
     * @private
     */ nrd: function(x) {
        var s = $5b56aa3f46fee21b$export$5cb6c9899f9010bc(x);
        var iqr = $5b56aa3f46fee21b$export$670a22a0cbf9a1e2(x);
        if (typeof iqr === "number") s = Math.min(s, iqr / 1.34);
        return 1.06 * s * Math.pow(x.length, -0.2);
    }
};
/**
 * [Kernel density estimation](https://en.wikipedia.org/wiki/Kernel_density_estimation)
 * is a useful tool for, among other things, estimating the shape of the
 * underlying probability distribution from a sample.
 *
 * @name kernelDensityEstimation
 * @param X sample values
 * @param kernel The kernel function to use. If a function is provided, it should return non-negative values and integrate to 1. Defaults to 'gaussian'.
 * @param bandwidthMethod The "bandwidth selection" method to use, or a fixed bandwidth value. Defaults to "nrd", the commonly-used ["normal reference distribution" rule-of-thumb](https://stat.ethz.ch/R-manual/R-devel/library/MASS/html/bandwidth.nrd.html).
 * @returns {Function} An estimated [probability density function](https://en.wikipedia.org/wiki/Probability_density_function) for the given sample. The returned function runs in `O(X.length)`.
 */ function $5b56aa3f46fee21b$export$8ddd4266aa49b096(X, kernel, bandwidthMethod) {
    var kernelFn;
    if (kernel === undefined) kernelFn = $5b56aa3f46fee21b$var$kernels.gaussian;
    else if (typeof kernel === "string") {
        if (!$5b56aa3f46fee21b$var$kernels[kernel]) throw new Error('Unknown kernel "' + kernel + '"');
        kernelFn = $5b56aa3f46fee21b$var$kernels[kernel];
    } else kernelFn = kernel;
    var bandwidth;
    if (typeof bandwidthMethod === "undefined") bandwidth = $5b56aa3f46fee21b$var$bandwidthMethods.nrd(X);
    else if (typeof bandwidthMethod === "string") {
        if (!$5b56aa3f46fee21b$var$bandwidthMethods[bandwidthMethod]) throw new Error('Unknown bandwidth method "' + bandwidthMethod + '"');
        bandwidth = $5b56aa3f46fee21b$var$bandwidthMethods[bandwidthMethod](X);
    } else bandwidth = bandwidthMethod;
    return function(x) {
        var i = 0;
        var sum = 0;
        for(i = 0; i < X.length; i++)sum += kernelFn((x - X[i]) / bandwidth);
        return sum / bandwidth / X.length;
    };
}
/**
 * The [Z-Score, or Standard Score](http://en.wikipedia.org/wiki/Standard_score).
 *
 * The standard score is the number of standard deviations an observation
 * or datum is above or below the mean. Thus, a positive standard score
 * represents a datum above the mean, while a negative standard score
 * represents a datum below the mean. It is a dimensionless quantity
 * obtained by subtracting the population mean from an individual raw
 * score and then dividing the difference by the population standard
 * deviation.
 *
 * The z-score is only defined if one knows the population parameters;
 * if one only has a sample set, then the analogous computation with
 * sample mean and sample standard deviation yields the
 * Student's t-statistic.
 *
 * @param {number} x
 * @param {number} mean
 * @param {number} standardDeviation
 * @return {number} z score
 * @example
 * zScore(78, 80, 5); // => -0.4
 */ function $5b56aa3f46fee21b$export$d00dafabb32834ab(x, mean, standardDeviation) {
    return (x - mean) / standardDeviation;
}
var $5b56aa3f46fee21b$var$SQRT_2PI = Math.sqrt(2 * Math.PI);
function $5b56aa3f46fee21b$var$cumulativeDistribution(z) {
    var sum = z;
    var tmp = z;
    // 15 iterations are enough for 4-digit precision
    for(var i = 1; i < 15; i++){
        tmp *= z * z / (2 * i + 1);
        sum += tmp;
    }
    return Math.round((0.5 + sum / $5b56aa3f46fee21b$var$SQRT_2PI * Math.exp(-z * z / 2)) * 1e4) / 1e4;
}
/**
 * A standard normal table, also called the unit normal table or Z table,
 * is a mathematical table for the values of Φ (phi), which are the values of
 * the [cumulative distribution function](https://en.wikipedia.org/wiki/Normal_distribution#Cumulative_distribution_function)
 * of the normal distribution. It is used to find the probability that a
 * statistic is observed below, above, or between values on the standard
 * normal distribution, and by extension, any normal distribution.
 */ var $5b56aa3f46fee21b$export$1d3906d531713b3c = [];
for(var $5b56aa3f46fee21b$var$z = 0; $5b56aa3f46fee21b$var$z <= 3.09; $5b56aa3f46fee21b$var$z += 0.01)$5b56aa3f46fee21b$export$1d3906d531713b3c.push($5b56aa3f46fee21b$var$cumulativeDistribution($5b56aa3f46fee21b$var$z));
/**
 * **[Cumulative Standard Normal Probability](http://en.wikipedia.org/wiki/Standard_normal_table)**
 *
 * Since probability tables cannot be
 * printed for every normal distribution, as there are an infinite variety
 * of normal distributions, it is common practice to convert a normal to a
 * standard normal and then use the standard normal table to find probabilities.
 *
 * You can use `.5 + .5 * errorFunction(x / Math.sqrt(2))` to calculate the probability
 * instead of looking it up in a table.
 *
 * @param {number} z
 * @returns {number} cumulative standard normal probability
 */ function $5b56aa3f46fee21b$export$df9dafc5f762170f(z) {
    // Calculate the position of this value.
    var absZ = Math.abs(z);
    // Each row begins with a different
    // significant digit: 0.5, 0.6, 0.7, and so on. Each value in the table
    // corresponds to a range of 0.01 in the input values, so the value is
    // multiplied by 100.
    var index = Math.min(Math.round(absZ * 100), $5b56aa3f46fee21b$export$1d3906d531713b3c.length - 1);
    // The index we calculate must be in the table as a positive value,
    // but we still pay attention to whether the input is positive
    // or negative, and flip the output value as a last step.
    if (z >= 0) return $5b56aa3f46fee21b$export$1d3906d531713b3c[index];
    else // due to floating-point arithmetic, values in the table with
    // 4 significant figures can nevertheless end up as repeating
    // fractions when they're computed here.
    return Math.round((1 - $5b56aa3f46fee21b$export$1d3906d531713b3c[index]) * 1e4) / 1e4;
}
/**
 * **[Logistic Cumulative Distribution Function](https://en.wikipedia.org/wiki/Logistic_distribution)**
 *
 * @param {number} x
 * @returns {number} cumulative standard logistic probability
 */ function $5b56aa3f46fee21b$export$84e0eeff84b5aae0(x) {
    return 1 / (Math.exp(-x) + 1);
}
/**
 * **[Gaussian error function](http://en.wikipedia.org/wiki/Error_function)**
 *
 * The `errorFunction(x/(sd * Math.sqrt(2)))` is the probability that a value in a
 * normal distribution with standard deviation sd is within x of the mean.
 *
 * This function returns a numerical approximation to the exact value.
 * It uses Horner's method to evaluate the polynomial of τ (tau).
 *
 * @param {number} x input
 * @return {number} error estimation
 * @example
 * errorFunction(1).toFixed(2); // => '0.84'
 */ function $5b56aa3f46fee21b$export$d3896f355fc09423(x) {
    var t = 1 / (1 + 0.5 * Math.abs(x));
    var tau = t * Math.exp(-x * x + ((((((((0.17087277 * t - 0.82215223) * t + 1.48851587) * t - 1.13520398) * t + 0.27886807) * t - 0.18628806) * t + 0.09678418) * t + 0.37409196) * t + 1.00002368) * t - 1.26551223);
    if (x >= 0) return 1 - tau;
    else return tau - 1;
}
/**
 * The Inverse [Gaussian error function](http://en.wikipedia.org/wiki/Error_function)
 * returns a numerical approximation to the value that would have caused
 * `errorFunction()` to return x.
 *
 * @param {number} x value of error function
 * @returns {number} estimated inverted value
 */ function $5b56aa3f46fee21b$export$bc61a1d17b578e4b(x) {
    var a = 8 * (Math.PI - 3) / (3 * Math.PI * (4 - Math.PI));
    var inv = Math.sqrt(Math.sqrt(Math.pow(2 / (Math.PI * a) + Math.log(1 - x * x) / 2, 2) - Math.log(1 - x * x) / a) - (2 / (Math.PI * a) + Math.log(1 - x * x) / 2));
    if (x >= 0) return inv;
    else return -inv;
}
/**
 * The [Probit](http://en.wikipedia.org/wiki/Probit)
 * is the inverse of cumulativeStdNormalProbability(),
 * and is also known as the normal quantile function.
 *
 * It returns the number of standard deviations from the mean
 * where the p'th quantile of values can be found in a normal distribution.
 * So, for example, probit(0.5 + 0.6827/2) ≈ 1 because 68.27% of values are
 * normally found within 1 standard deviation above or below the mean.
 *
 * @param {number} p
 * @returns {number} probit
 */ function $5b56aa3f46fee21b$export$33ddb09e8a9ca919(p) {
    if (p === 0) p = $5b56aa3f46fee21b$export$6c421550c66a327d;
    else if (p >= 1) p = 1 - $5b56aa3f46fee21b$export$6c421550c66a327d;
    return Math.sqrt(2) * $5b56aa3f46fee21b$export$bc61a1d17b578e4b(2 * p - 1);
}
/**
 * The [Logit](https://en.wikipedia.org/wiki/Logit)
 * is the inverse of cumulativeStdLogisticProbability,
 * and is also known as the logistic quantile function.
 *
 * @param {number} p
 * @returns {number} logit
 */ function $5b56aa3f46fee21b$export$cdb624a6994a61c0(p) {
    if (p <= 0 || p >= 1) throw new Error("p must be strictly between zero and one");
    return Math.log(p / (1 - p));
}
/**
 * Conducts a [permutation test](https://en.wikipedia.org/wiki/Resampling_(statistics)#Permutation_tests)
 * to determine if two data sets are *significantly* different from each other, using
 * the difference of means between the groups as the test statistic.
 * The function allows for the following hypotheses:
 * - two_tail = Null hypothesis: the two distributions are equal.
 * - greater = Null hypothesis: observations from sampleX tend to be smaller than those from sampleY.
 * - less = Null hypothesis: observations from sampleX tend to be greater than those from sampleY.
 * [Learn more about one-tail vs two-tail tests.](https://en.wikipedia.org/wiki/One-_and_two-tailed_tests)
 *
 * @param {Array<number>} sampleX first dataset (e.g. treatment data)
 * @param {Array<number>} sampleY second dataset (e.g. control data)
 * @param {string} alternative alternative hypothesis, either 'two_sided' (default), 'greater', or 'less'
 * @param {number} k number of values in permutation distribution.
 * @param {Function} [randomSource=Math.random] an optional entropy source
 * @returns {number} p-value The probability of observing the difference between groups (as or more extreme than what we did), assuming the null hypothesis.
 *
 * @example
 * var control = [2, 5, 3, 6, 7, 2, 5];
 * var treatment = [20, 5, 13, 12, 7, 2, 2];
 * permutationTest(control, treatment); // ~0.1324
 */ function $5b56aa3f46fee21b$export$4f4e163b2988b19(sampleX, sampleY, alternative, k, randomSource) {
    // Set default arguments
    if (k === undefined) k = 10000;
    if (alternative === undefined) alternative = "two_side";
    if (alternative !== "two_side" && alternative !== "greater" && alternative !== "less") throw new Error("`alternative` must be either 'two_side', 'greater', or 'less'.");
    // get means for each sample
    var meanX = $5b56aa3f46fee21b$export$cc6710ee5f037d57(sampleX);
    var meanY = $5b56aa3f46fee21b$export$cc6710ee5f037d57(sampleY);
    // calculate initial test statistic. This will be our point of comparison with
    // the generated test statistics.
    var testStatistic = meanX - meanY;
    // create test-statistic distribution
    var testStatDsn = new Array(k);
    // combine datsets so we can easily shuffle later
    var allData = sampleX.concat(sampleY);
    var midIndex = Math.floor(allData.length / 2);
    for(var i = 0; i < k; i++){
        // 1. shuffle data assignments
        $5b56aa3f46fee21b$export$c8bbd489f517fb10(allData, randomSource);
        var permLeft = allData.slice(0, midIndex);
        var permRight = allData.slice(midIndex, allData.length);
        // 2.re-calculate test statistic
        var permTestStatistic = $5b56aa3f46fee21b$export$cc6710ee5f037d57(permLeft) - $5b56aa3f46fee21b$export$cc6710ee5f037d57(permRight);
        // 3. store test statistic to build test statistic distribution
        testStatDsn[i] = permTestStatistic;
    }
    // Calculate p-value depending on alternative
    // For this test, we calculate the percentage of 'extreme' test statistics (subject to our hypothesis)
    // more info on permutation test p-value calculations: https://onlinecourses.science.psu.edu/stat464/node/35
    var numExtremeTStats = 0;
    if (alternative === "two_side") {
        for(var i$1 = 0; i$1 <= k; i$1++)if (Math.abs(testStatDsn[i$1]) >= Math.abs(testStatistic)) numExtremeTStats += 1;
    } else if (alternative === "greater") {
        for(var i$2 = 0; i$2 <= k; i$2++)if (testStatDsn[i$2] >= testStatistic) numExtremeTStats += 1;
    } else {
        // alternative === 'less'
        for(var i$3 = 0; i$3 <= k; i$3++)/* c8 ignore start */ if (testStatDsn[i$3] <= testStatistic) numExtremeTStats += 1;
    }
    return numExtremeTStats / k;
}
/**
 * [Sign](https://en.wikipedia.org/wiki/Sign_function) is a function
 * that extracts the sign of a real number
 *
 * @param {number} x input value
 * @returns {number} sign value either 1, 0 or -1
 * @throws {TypeError} if the input argument x is not a number
 * @private
 *
 * @example
 * sign(2); // => 1
 */ function $5b56aa3f46fee21b$export$c5552dfdbc7cec71(x) {
    if (typeof x === "number") {
        if (x < 0) return -1;
        else if (x === 0) return 0;
        else return 1;
    } else throw new TypeError("not a number");
}
/**
 * [Bisection method](https://en.wikipedia.org/wiki/Bisection_method) is a root-finding
 * method that repeatedly bisects an interval to find the root.
 *
 * This function returns a numerical approximation to the exact value.
 *
 * @param {Function} func input function
 * @param {number} start - start of interval
 * @param {number} end - end of interval
 * @param {number} maxIterations - the maximum number of iterations
 * @param {number} errorTolerance - the error tolerance
 * @returns {number} estimated root value
 * @throws {TypeError} Argument func must be a function
 *
 * @example
 * bisect(Math.cos,0,4,100,0.003); // => 1.572265625
 */ function $5b56aa3f46fee21b$export$a668c821d9678ea6(func, start, end, maxIterations, errorTolerance) {
    if (typeof func !== "function") throw new TypeError("func must be a function");
    for(var i = 0; i < maxIterations; i++){
        var output = (start + end) / 2;
        if (func(output) === 0 || Math.abs((end - start) / 2) < errorTolerance) return output;
        if ($5b56aa3f46fee21b$export$c5552dfdbc7cec71(func(output)) === $5b56aa3f46fee21b$export$c5552dfdbc7cec71(func(start))) start = output;
        else end = output;
    }
    throw new Error("maximum number of iterations exceeded");
}
/**
 * Calculate Euclidean distance between two points.
 * @param {Array<number>} left First N-dimensional point.
 * @param {Array<number>} right Second N-dimensional point.
 * @returns {number} Distance.
 */ function $5b56aa3f46fee21b$var$euclideanDistance(left, right) {
    var sum = 0;
    for(var i = 0; i < left.length; i++){
        var diff = left[i] - right[i];
        sum += diff * diff;
    }
    return Math.sqrt(sum);
}
/**
 * @typedef {Object} kMeansReturn
 * @property {Array<number>} labels The labels.
 * @property {Array<Array<number>>} centroids The cluster centroids.
 */ /**
 * Perform k-means clustering.
 *
 * @param {Array<Array<number>>} points N-dimensional coordinates of points to be clustered.
 * @param {number} numCluster How many clusters to create.
 * @param {Function} randomSource An optional entropy source that generates uniform values in [0, 1).
 * @return {kMeansReturn} Labels (same length as data) and centroids (same length as numCluster).
 * @throws {Error} If any centroids wind up friendless (i.e., without associated points).
 *
 * @example
 * kMeansCluster([[0.0, 0.5], [1.0, 0.5]], 2); // => {labels: [0, 1], centroids: [[0.0, 0.5], [1.0 0.5]]}
 */ function $5b56aa3f46fee21b$export$48b6274d965106be(points, numCluster, randomSource) {
    if (randomSource === void 0) randomSource = Math.random;
    var oldCentroids = null;
    var newCentroids = $5b56aa3f46fee21b$export$4812e460280c6ef2(points, numCluster, randomSource);
    var labels = null;
    var change = Number.MAX_VALUE;
    while(change !== 0){
        labels = $5b56aa3f46fee21b$var$labelPoints(points, newCentroids);
        oldCentroids = newCentroids;
        newCentroids = $5b56aa3f46fee21b$var$calculateCentroids(points, labels, numCluster);
        change = $5b56aa3f46fee21b$var$calculateChange(newCentroids, oldCentroids);
    }
    return {
        labels: labels,
        centroids: newCentroids
    };
}
/**
 * Label each point according to which centroid it is closest to.
 *
 * @private
 * @param {Array<Array<number>>} points Array of XY coordinates.
 * @param {Array<Array<number>>} centroids Current centroids.
 * @return {Array<number>} Group labels.
 */ function $5b56aa3f46fee21b$var$labelPoints(points, centroids) {
    return points.map(function(p) {
        var minDist = Number.MAX_VALUE;
        var label = -1;
        for(var i = 0; i < centroids.length; i++){
            var dist = $5b56aa3f46fee21b$var$euclideanDistance(p, centroids[i]);
            if (dist < minDist) {
                minDist = dist;
                label = i;
            }
        }
        return label;
    });
}
/**
 * Calculate centroids for points given labels.
 *
 * @private
 * @param {Array<Array<number>>} points Array of XY coordinates.
 * @param {Array<number>} labels Which groups points belong to.
 * @param {number} numCluster Number of clusters being created.
 * @return {Array<Array<number>>} Centroid for each group.
 * @throws {Error} If any centroids wind up friendless (i.e., without associated points).
 */ function $5b56aa3f46fee21b$var$calculateCentroids(points, labels, numCluster) {
    // Initialize accumulators.
    var dimension = points[0].length;
    var centroids = $5b56aa3f46fee21b$var$makeMatrix(numCluster, dimension);
    var counts = Array(numCluster).fill(0);
    // Add points to centroids' accumulators and count points per centroid.
    var numPoints = points.length;
    for(var i = 0; i < numPoints; i++){
        var point = points[i];
        var label = labels[i];
        var current = centroids[label];
        for(var j = 0; j < dimension; j++)current[j] += point[j];
        counts[label] += 1;
    }
    // Rescale centroids, checking for any that have no points.
    for(var i$1 = 0; i$1 < numCluster; i$1++){
        if (counts[i$1] === 0) throw new Error("Centroid " + i$1 + " has no friends");
        var centroid = centroids[i$1];
        for(var j$1 = 0; j$1 < dimension; j$1++)centroid[j$1] /= counts[i$1];
    }
    return centroids;
}
/**
 * Calculate the difference between old centroids and new centroids.
 *
 * @private
 * @param {Array<Array<number>>} left One list of centroids.
 * @param {Array<Array<number>>} right Another list of centroids.
 * @return {number} Distance between centroids.
 */ function $5b56aa3f46fee21b$var$calculateChange(left, right) {
    var total = 0;
    for(var i = 0; i < left.length; i++)total += $5b56aa3f46fee21b$var$euclideanDistance(left[i], right[i]);
    return total;
}
/**
 * Calculate the [silhouette values](https://en.wikipedia.org/wiki/Silhouette_(clustering))
 * for clustered data.
 *
 * @param {Array<Array<number>>} points N-dimensional coordinates of points.
 * @param {Array<number>} labels Labels of points. This must be the same length as `points`,
 * and values must lie in [0..G-1], where G is the number of groups.
 * @return {Array<number>} The silhouette value for each point.
 *
 * @example
 * silhouette([[0.25], [0.75]], [0, 0]); // => [1.0, 1.0]
 */ function $5b56aa3f46fee21b$export$9dad0ecd32c04762(points, labels) {
    if (points.length !== labels.length) throw new Error("must have exactly as many labels as points");
    var groupings = $5b56aa3f46fee21b$var$createGroups(labels);
    var distances = $5b56aa3f46fee21b$var$calculateAllDistances(points);
    var result = [];
    for(var i = 0; i < points.length; i++){
        var s = 0;
        if (groupings[labels[i]].length > 1) {
            var a = $5b56aa3f46fee21b$var$meanDistanceFromPointToGroup(i, groupings[labels[i]], distances);
            var b = $5b56aa3f46fee21b$var$meanDistanceToNearestGroup(i, labels, groupings, distances);
            s = (b - a) / Math.max(a, b);
        }
        result.push(s);
    }
    return result;
}
/**
 * Create a lookup table mapping group IDs to point IDs.
 *
 * @private
 * @param {Array<number>} labels Labels of points. This must be the same length as `points`,
 * and values must lie in [0..G-1], where G is the number of groups.
 * @return {Array<Array<number>>} An array of length G, each of whose entries is an array
 * containing the indices of the points in that group.
 */ function $5b56aa3f46fee21b$var$createGroups(labels) {
    var numGroups = 1 + $5b56aa3f46fee21b$export$8960430cfd85939f(labels);
    var result = Array(numGroups);
    for(var i = 0; i < labels.length; i++){
        var label = labels[i];
        if (result[label] === undefined) result[label] = [];
        result[label].push(i);
    }
    return result;
}
/**
 * Create a lookup table of all inter-point distances.
 *
 * @private
 * @param {Array<Array<number>>} points N-dimensional coordinates of points.
 * @return {Array<Array<number>>} A symmetric square array of inter-point distances
 * (zero on the diagonal).
 */ function $5b56aa3f46fee21b$var$calculateAllDistances(points) {
    var numPoints = points.length;
    var result = $5b56aa3f46fee21b$var$makeMatrix(numPoints, numPoints);
    for(var i = 0; i < numPoints; i++)for(var j = 0; j < i; j++){
        result[i][j] = $5b56aa3f46fee21b$var$euclideanDistance(points[i], points[j]);
        result[j][i] = result[i][j];
    }
    return result;
}
/**
 * Calculate the mean distance between this point and all the points in the
 * nearest group (as determined by which point in another group is closest).
 *
 * @private
 * @param {number} which The index of this point.
 * @param {Array<number>} labels Labels of points.
 * @param {Array<Array<number>>} groupings An array whose entries are arrays
 * containing the indices of the points in that group.
 * @param {Array<Array<number>>} distances A symmetric square array of inter-point
 * distances.
 * @return {number} The mean distance from this point to others in the nearest
 * group.
 */ function $5b56aa3f46fee21b$var$meanDistanceToNearestGroup(which, labels, groupings, distances) {
    var label = labels[which];
    var result = Number.MAX_VALUE;
    for(var i = 0; i < groupings.length; i++)if (i !== label) {
        var d = $5b56aa3f46fee21b$var$meanDistanceFromPointToGroup(which, groupings[i], distances);
        if (d < result) result = d;
    }
    return result;
}
/**
 * Calculate the mean distance between a point and all the points in a group
 * (possibly its own).
 *
 * @private
 * @param {number} which The index of this point.
 * @param {Array<number>} group The indices of all the points in the group in
 * question.
 * @param {Array<Array<number>>} distances A symmetric square array of inter-point
 * distances.
 * @return {number} The mean distance from this point to others in the
 * specified group.
 */ function $5b56aa3f46fee21b$var$meanDistanceFromPointToGroup(which, group, distances) {
    var total = 0;
    for(var i = 0; i < group.length; i++)total += distances[which][group[i]];
    return total / group.length;
}
/**
 * Calculate the [silhouette metric](https://en.wikipedia.org/wiki/Silhouette_(clustering))
 * for a set of N-dimensional points arranged in groups. The metric is the largest
 * individual silhouette value for the data.
 *
 * @param {Array<Array<number>>} points N-dimensional coordinates of points.
 * @param {Array<number>} labels Labels of points. This must be the same length as `points`,
 * and values must lie in [0..G-1], where G is the number of groups.
 * @return {number} The silhouette metric for the groupings.
 *
 * @example
 * silhouetteMetric([[0.25], [0.75]], [0, 0]); // => 1.0
 */ function $5b56aa3f46fee21b$export$d0221010df3dd982(points, labels) {
    var values = $5b56aa3f46fee21b$export$9dad0ecd32c04762(points, labels);
    return $5b56aa3f46fee21b$export$8960430cfd85939f(values);
}
/**
 * Relative error.
 *
 * This is more difficult to calculate than it first appears [1,2].  The usual
 * formula for the relative error between an actual value A and an expected
 * value E is `|(A-E)/E|`, but:
 *
 * 1. If the expected value is 0, any other value has infinite relative error,
 *    which is counter-intuitive: if the expected voltage is 0, getting 1/10th
 *    of a volt doesn't feel like an infinitely large error.
 *
 * 2. This formula does not satisfy the mathematical definition of a metric [3].
 *    [4] solved this problem by defining the relative error as `|ln(|A/E|)|`,
 *    but that formula only works if all values are positive: for example, it
 *    reports the relative error of -10 and 10 as 0.
 *
 * Our implementation sticks with convention and returns:
 *
 * - 0 if the actual and expected values are both zero
 * - Infinity if the actual value is non-zero and the expected value is zero
 * - `|(A-E)/E|` in all other cases
 *
 * [1] https://math.stackexchange.com/questions/677852/how-to-calculate-relative-error-when-true-value-is-zero
 * [2] https://en.wikipedia.org/wiki/Relative_change_and_difference
 * [3] https://en.wikipedia.org/wiki/Metric_(mathematics)#Definition
 * [4] F.W.J. Olver: "A New Approach to Error Arithmetic." SIAM Journal on
 *     Numerical Analysis, 15(2), 1978, 10.1137/0715024.
 *
 * @param {number} actual The actual value.
 * @param {number} expected The expected value.
 * @return {number} The relative error.
 */ function $5b56aa3f46fee21b$export$b47f5643e6944a15(actual, expected) {
    // These lines are actually covered by tests, but it seems
    // like c8 has a bug that marks them as not covered.
    /* c8 ignore start */ if (actual === 0 && expected === 0) return 0;
    /* c8 ignore end */ return Math.abs((actual - expected) / expected);
}
/**
 * Approximate equality.
 *
 * @param {number} actual The value to be tested.
 * @param {number} expected The reference value.
 * @param {number} tolerance The acceptable relative difference.
 * @return {boolean} Whether numbers are within tolerance.
 */ function $5b56aa3f46fee21b$export$8a4f1dcc58a69dbd(actual, expected, tolerance) {
    if (tolerance === void 0) tolerance = $5b56aa3f46fee21b$export$6c421550c66a327d;
    return $5b56aa3f46fee21b$export$b47f5643e6944a15(actual, expected) <= tolerance;
}

});

parcelRegister("kmmp9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3ffb0913a2bbb95$export$2e2bcd8739ae039);
/**
 * Ensures that an array is passed and optionally that every member is of the given type. Throws
 * if expectation is not met.
 * @param {array} data
 * @param {string?} type    Type to check for by comparing it to `typeof item`; defaults to
 *                          'number'
 * @returns {array}         Original array
 * @throws                  An error if anything else than an array is passed or the type
 *                          requirements are not met
 */ var $d3ffb0913a2bbb95$export$2e2bcd8739ae039 = (data, type = "number")=>{
    if (!Array.isArray(data)) throw new Error(`Expected parameter to be an array, got ${data} instead.`);
    if (type) {
        // eslint-disable-next-line valid-typeof
        const invalidItems = data.filter((item)=>typeof item !== type);
        if (invalidItems.length) throw new Error(`Expected every item of array to be of type ${type}, got items ${invalidItems.join(", ")} with types ${invalidItems.map((item)=>typeof item).join(", ")} instead.`);
    }
    return data;
};

});

parcelRegister("8ayA8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c867d104c47ae046$export$2e2bcd8739ae039);
var $c867d104c47ae046$export$2e2bcd8739ae039 = ()=>{
    const dayInMs = 86400000;
    const yearInMs = dayInMs * 365;
    return {
        dayInMs: dayInMs,
        yearInMs: yearInMs
    };
};

});

parcelRegister("7MJNE", function(module, exports) {

$parcel$export(module.exports, "default", () => $127d9e89729a3d90$export$2e2bcd8739ae039);

var $iDVUS = parcelRequire("iDVUS");

var $kmmp9 = parcelRequire("kmmp9");

var $8ayA8 = parcelRequire("8ayA8");

var $dpBW2 = parcelRequire("dpBW2");
const { yearInMs: $127d9e89729a3d90$var$yearInMs } = (0, $8ayA8.default)();
var /**
 * Returns the CAGR based on a linear regression of the data provided; the serie's first value
 * is m, the last value equals m + b * diff where diff is the amount of time between the first
 * and last value of data.
 * Returns 0.05 for a CAGR of 5%.
 * @param {Number[]} data
 * @param {Date[]} dates
 * @returns {Number}            CAGR for linear regression, e.g. 0.02 for 2%
 */ $127d9e89729a3d90$export$2e2bcd8739ae039 = (data, dates)=>{
    if ((0, $kmmp9.default)(data, false).length !== (0, $kmmp9.default)(dates, false).length) throw new Error(`Length of data (${data.length}) must match length of dates (${dates.length}).`);
    // getWindows needs merged data
    const mergedData = data.map((item, index)=>({
            value: item,
            date: dates[index]
        }));
    const windows = (0, $dpBW2.default)(mergedData, $127d9e89729a3d90$var$yearInMs, $127d9e89729a3d90$var$yearInMs / 2);
    const growthRates = windows.map((window)=>{
        // Use 1 year as 1 x axis unit. (it simplifies all calculations, as slope equals CAGR)
        const xValues = window.map(({ date: date })=>(date.getTime() - window.at(0).date.getTime()) / $127d9e89729a3d90$var$yearInMs);
        const yValues = window.map(({ value: value })=>value);
        const { slope: slope, intercept: intercept } = new (0, $iDVUS.SimpleLinearRegression)(xValues, yValues);
        return (intercept + slope) / intercept;
    });
    // If there's only 1 value per window, its growth rate is NaN; filter it out
    const validGrowthRates = growthRates.filter((rate)=>!Number.isNaN(rate))// A change of 1.05 should be displayed as 5% later; remove 1
    .map((rate)=>rate - 1)// Account for the length of a window (if one is < 1 year)
    .map((rate, index)=>({
            rate: rate,
            partOfYear: (windows[index].at(-1).date.getTime() - windows[index].at(0).date.getTime()) / $127d9e89729a3d90$var$yearInMs
        }));
    const amountOfYears = validGrowthRates.reduce((sum, current)=>sum + current.partOfYear, 0);
    // Return average of all slopes; account for the length of the data behind the slope
    return validGrowthRates.reduce((sum, current)=>sum + current.rate * current.partOfYear, 0) / amountOfYears;
};

});
parcelRegister("iDVUS", function(module, exports) {

$parcel$export(module.exports, "SimpleLinearRegression", () => $d928cb7bc9943dff$export$cc07b5db0a0424bf);

var $lfmcr = parcelRequire("lfmcr");
var $6qY9C = parcelRequire("6qY9C");
var $1y5Ct = parcelRequire("1y5Ct");
class $d928cb7bc9943dff$export$cc07b5db0a0424bf extends (0, $lfmcr.BaseRegression) {
    /**
     * @param x - explanatory variable
     * @param y - response variable
     */ constructor(x, y){
        super();
        // @ts-expect-error internal use of the constructor, from `this.load`
        if (x === true) {
            // @ts-expect-error internal use of the constructor, from `this.load`
            const yObj = y;
            this.slope = yObj.slope;
            this.intercept = yObj.intercept;
            this.coefficients = [
                yObj.intercept,
                yObj.slope
            ];
        } else {
            (0, $6qY9C.checkArrayLength)(x, y);
            const result = $d928cb7bc9943dff$var$regress(x, y);
            this.slope = result.slope;
            this.intercept = result.intercept;
            this.coefficients = [
                result.intercept,
                result.slope
            ];
        }
    }
    /**
     * Get the parameters and model name in JSON format
     * @returns
     */ toJSON() {
        return {
            name: "simpleLinearRegression",
            slope: this.slope,
            intercept: this.intercept
        };
    }
    _predict(x) {
        return this.slope * x + this.intercept;
    }
    /**
     * Finds x for the given y value.
     * @param y - response variable value
     * @returns - x value
     */ computeX(y) {
        return (y - this.intercept) / this.slope;
    }
    /**
     * Strings the linear function in the form 'f(x) = ax + b'
     * @param precision - number of significant figures.
     * @returns
     */ toString(precision) {
        let result = "f(x) = ";
        if (this.slope !== 0) {
            const xFactor = (0, $1y5Ct.maybeToPrecision)(this.slope, precision);
            result += `${xFactor === "1" ? "" : `${xFactor} * `}x`;
            if (this.intercept !== 0) {
                const absIntercept = Math.abs(this.intercept);
                const operator = absIntercept === this.intercept ? "+" : "-";
                result += ` ${operator} ${(0, $1y5Ct.maybeToPrecision)(absIntercept, precision)}`;
            }
        } else result += (0, $1y5Ct.maybeToPrecision)(this.intercept, precision);
        return result;
    }
    /**
     * Strings the linear function in the form 'f(x) = ax + b'
     * @param precision - number of significant figures.
     * @returns
     */ toLaTeX(precision) {
        return this.toString(precision);
    }
    /**
     * Class instance from a JSON Object.
     * @param json
     * @returns
     */ static load(json) {
        if (json.name !== "simpleLinearRegression") throw new TypeError("not a SLR model");
        // @ts-expect-error internal use of the constructor
        return new $d928cb7bc9943dff$export$cc07b5db0a0424bf(true, json);
    }
}
/**
 * Internal  function.
 * It determines the parameters (slope, intercept) of the line that best fit the `x,y` vector-data (simple linear regression).
 * @param x - explanatory variable
 * @param y - response variable
 * @returns - slope and intercept of the best fit line
 */ function $d928cb7bc9943dff$var$regress(x, y) {
    const n = x.length;
    let xSum = 0;
    let ySum = 0;
    let xSquared = 0;
    let xY = 0;
    for(let i = 0; i < n; i++){
        xSum += x[i];
        ySum += y[i];
        xSquared += x[i] * x[i];
        xY += x[i] * y[i];
    }
    const numerator = n * xY - xSum * ySum;
    const slope = numerator / (n * xSquared - xSum * xSum);
    return {
        slope: slope,
        intercept: 1 / n * ySum - slope * (1 / n) * xSum
    };
}

});
parcelRegister("lfmcr", function(module, exports) {

$parcel$export(module.exports, "BaseRegression", () => $f77c38176cba2fc9$export$7d23541689a2f6cd);

var $ccQrj = parcelRequire("ccQrj");

var $6qY9C = parcelRequire("6qY9C");
class $f77c38176cba2fc9$export$7d23541689a2f6cd {
    constructor(){
        if (new.target === $f77c38176cba2fc9$export$7d23541689a2f6cd) throw new Error("BaseRegression must be subclassed");
    }
    predict(x) {
        if (typeof x === "number") return this._predict(x);
        else if ((0, $ccQrj.isAnyArray)(x)) {
            const y = [];
            for (const xVal of x)y.push(this._predict(xVal));
            return y;
        } else throw new TypeError("x must be a number or array");
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _predict(x) {
        throw new Error("_predict must be implemented");
    }
    train() {
    // Do nothing for this package
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    toString(precision) {
        return "";
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    toLaTeX(precision) {
        return "";
    }
    /**
     * Return the correlation coefficient of determination (r) and chi-square.
     * @param x - explanatory variable
     * @param y - response variable
     * @return - Object with further statistics.
     */ score(x, y) {
        (0, $6qY9C.checkArrayLength)(x, y);
        const n = x.length;
        const y2 = new Array(n);
        for(let i = 0; i < n; i++)y2[i] = this._predict(x[i]);
        let xSum = 0;
        let ySum = 0;
        let chi2 = 0;
        let rmsd = 0;
        let xSquared = 0;
        let ySquared = 0;
        let xY = 0;
        for(let i = 0; i < n; i++){
            xSum += y2[i];
            ySum += y[i];
            xSquared += y2[i] * y2[i];
            ySquared += y[i] * y[i];
            xY += y2[i] * y[i];
            if (y[i] !== 0) chi2 += (y[i] - y2[i]) * (y[i] - y2[i]) / y[i];
            rmsd += (y[i] - y2[i]) * (y[i] - y2[i]);
        }
        const r = (n * xY - xSum * ySum) / Math.sqrt((n * xSquared - xSum * xSum) * (n * ySquared - ySum * ySum));
        return {
            r: r,
            r2: r * r,
            chi2: chi2,
            rmsd: Math.sqrt(rmsd / n)
        };
    }
}

});
parcelRegister("ccQrj", function(module, exports) {

$parcel$export(module.exports, "isAnyArray", () => $8e2f486c6c4874e1$export$b587624c098d7880);
// eslint-disable-next-line @typescript-eslint/unbound-method
const $8e2f486c6c4874e1$var$toString = Object.prototype.toString;
function $8e2f486c6c4874e1$export$b587624c098d7880(value) {
    const tag = $8e2f486c6c4874e1$var$toString.call(value);
    return tag.endsWith("Array]") && !tag.includes("Big");
}

});

parcelRegister("6qY9C", function(module, exports) {

$parcel$export(module.exports, "checkArrayLength", () => $4af3d52997360a72$export$3364baef88af92d1);

var $ccQrj = parcelRequire("ccQrj");
function $4af3d52997360a72$export$3364baef88af92d1(x, y) {
    if (!(0, $ccQrj.isAnyArray)(x) || !(0, $ccQrj.isAnyArray)(y)) throw new TypeError("x and y must be arrays");
    if (x.length !== y.length) throw new RangeError("x and y arrays must have the same length");
}

});


parcelRegister("1y5Ct", function(module, exports) {

$parcel$export(module.exports, "maybeToPrecision", () => $120d535c78c8f25c$export$f23e52f9d9ee7d8c);
/**
 * Cast `number` to string. Optionally `digits` specifies significant figures.
 * @param number
 * @param figures
 * @returns - A string representation of `number`.
 */ function $120d535c78c8f25c$export$f23e52f9d9ee7d8c(number, figures) {
    if (number < 0) {
        number = 0 - number;
        if (typeof figures === "number") return `- ${number.toPrecision(figures)}`;
        else return `- ${number.toString()}`;
    } else if (typeof figures === "number") return number.toPrecision(figures);
    else return number.toString();
}

});


parcelRegister("dpBW2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8adb4ca0ef939db7$export$2e2bcd8739ae039);
/**
 * Divides data provided into windows that may or may not overlap.
 * @param {{ date: Date, value: Number }[]} data
 * @param {Number} windowSizeInMs - length of window
 * @param {Number?} overlapInMs - overlap of window. If you have 24 months of data and use window
 * size of 1 year and an overlap of 3 months, you'll get 3 windows. Overlap is counted from the
 * end of the previous window. Defaults to 0.
 * - month 0–12
 * - month 9–21
 * - month 18–24
 * @returns {{ date: Date, value: Number}[][]}
 */ var $8adb4ca0ef939db7$export$2e2bcd8739ae039 = (data, windowSizeInMs, overlapInMs = 0)=>{
    const dataIsArray = Array.isArray(data);
    const dataHasValidValues = dataIsArray && data.every((item)=>typeof item.value === "number" && item.date instanceof Date);
    if (!dataIsArray || !dataHasValidValues) throw new Error(`Argument data must be an array of objects, each with properties date {Date} and value {Number}; got ${JSON.stringify(data)} instead.`);
    if (typeof windowSizeInMs !== "number" || windowSizeInMs <= 0) throw new Error(`Window size must be a positive number, got ${windowSizeInMs} instead.`);
    if (overlapInMs >= windowSizeInMs) throw new Error(`Overlap must be smaller than window size; got overlap ${overlapInMs} and window size ${windowSizeInMs}.`);
    const startTime = data.at(0).date.getTime();
    const timeSeriesDuration = data.at(-1).date.getTime() - startTime;
    // How long is the non-overlapping part of a segment?
    const segmentBaseLength = windowSizeInMs - overlapInMs;
    const amountOfWindows = Math.ceil(timeSeriesDuration / segmentBaseLength);
    return Array.from({
        length: amountOfWindows
    }, (value, index)=>{
        const start = index * segmentBaseLength;
        const end = start + windowSizeInMs;
        return data.filter((item)=>item.date.getTime() - startTime >= start && item.date.getTime() - startTime < end);
    });
};

});



parcelRegister("8Um3G", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3ecefc8ade9a8f5$export$2e2bcd8739ae039);
/**
 * Takes a column name and parses out all parameters that take the form of key:value, e.g.
 * "instrument: ES with basePeriod=5 and factor:2" will become
 * new Map([['instrument', 'ES'], ['basePeriod', 5], ['factor', 2]] }
 * @param {String} columnName
 * @returns {Map}
 */ var $b3ecefc8ade9a8f5$export$2e2bcd8739ae039 = (columnName)=>[
        ...columnName.matchAll(/(\w+)[:=](\d+(\.\d+)?)/g)
    ].reduce((previous, [all, variableName, number])=>new Map([
            ...previous,
            [
                variableName,
                parseFloat(number)
            ]
        ]), new Map());

});

parcelRegister("aKqH2", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d32e7f6b7df0002$export$2e2bcd8739ae039);
var $7d32e7f6b7df0002$export$2e2bcd8739ae039 = ()=>`id${Math.random().toString(16).slice(2)}`;

});


parcelRegister("j7S7Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9db0669b72fbf0f$export$2e2bcd8739ae039);

var $8K3yR = parcelRequire("8K3yR");
var /**
 * Parses CSV content and returns in the format:
 * [{
 *    name: String,
 *    data: [{ x: Date, y: Number }, ...],
 * }]
 * @param {string} text         CSV content
 * @returns {{name: string, data: { x: Date, y: number }[]}[]}    Parsed CSV content
 */ $d9db0669b72fbf0f$export$2e2bcd8739ae039 = (text)=>{
    const parsed = (0, $8K3yR.parse)(text, {
        skip_empty_lines: true
    });
    const [head, ...body] = parsed;
    // We assume that the first column contains the date
    const colunNames = head.slice(1);
    const cols = colunNames.map((columnName, columnIndex)=>({
            name: columnName,
            data: body.map((row, rowIndex)=>{
                const date = new Date(row[0]);
                if (Number.isNaN(date.getTime())) throw new Error(`Expected row "${rowIndex}" (0-based) of first column to contain a valid date, got "${row[0]}" instead.`);
                const value = parseFloat(row[columnIndex + 1]);
                if (Number.isNaN(value)) throw new Error(`Expected row "${rowIndex}" (0-based) of column "${columnName}" to contain a valid number, got "${row[columnIndex + 1]}" instead.`);
                return {
                    x: date,
                    y: value
                };
            })
        }));
    return cols;
};

});
parcelRegister("8K3yR", function(module, exports) {

$parcel$export(module.exports, "parse", () => $65d561cf3fee4dec$export$98e6a39c04603d36);

var $7Q0sM = parcelRequire("7Q0sM");

var $7zlKx = parcelRequire("7zlKx");
var $65d561cf3fee4dec$require$Buffer = $7zlKx.Buffer;
const $65d561cf3fee4dec$export$98e6a39c04603d36 = function(data, opts = {}) {
    if (typeof data === "string") data = $65d561cf3fee4dec$require$Buffer.from(data);
    const records = opts && opts.objname ? {} : [];
    const parser = (0, $7Q0sM.transform)(opts);
    const push = (record)=>{
        if (parser.options.objname === undefined) records.push(record);
        else records[record[0]] = record[1];
    };
    const close = ()=>{};
    const err1 = parser.parse(data, false, push, close);
    if (err1 !== undefined) throw err1;
    const err2 = parser.parse(undefined, true, push, close);
    if (err2 !== undefined) throw err2;
    return records;
};

});
parcelRegister("7Q0sM", function(module, exports) {

$parcel$export(module.exports, "transform", () => $5b4dbfb740a41692$export$51186ad6e864892a);

var $4oc3f = parcelRequire("4oc3f");

var $i9Ykp = parcelRequire("i9Ykp");

var $7EamI = parcelRequire("7EamI");

var $99pXl = parcelRequire("99pXl");

var $7zlKx = parcelRequire("7zlKx");
var $5b4dbfb740a41692$require$Buffer = $7zlKx.Buffer;
const $5b4dbfb740a41692$var$isRecordEmpty = function(record) {
    return record.every((field)=>field == null || field.toString && field.toString().trim() === "");
};
const $5b4dbfb740a41692$var$cr = 13; // `\r`, carriage return, 0x0D in hexadécimal, 13 in decimal
const $5b4dbfb740a41692$var$nl = 10; // `\n`, newline, 0x0A in hexadecimal, 10 in decimal
const $5b4dbfb740a41692$var$boms = {
    // Note, the following are equals:
    // Buffer.from("\ufeff")
    // Buffer.from([239, 187, 191])
    // Buffer.from('EFBBBF', 'hex')
    "utf8": $5b4dbfb740a41692$require$Buffer.from([
        239,
        187,
        191
    ]),
    // Note, the following are equals:
    // Buffer.from "\ufeff", 'utf16le
    // Buffer.from([255, 254])
    "utf16le": $5b4dbfb740a41692$require$Buffer.from([
        255,
        254
    ])
};
const $5b4dbfb740a41692$export$51186ad6e864892a = function(original_options = {}) {
    const info = {
        bytes: 0,
        comment_lines: 0,
        empty_lines: 0,
        invalid_field_length: 0,
        lines: 1,
        records: 0
    };
    const options = (0, $7EamI.normalize_options)(original_options);
    return {
        info: info,
        original_options: original_options,
        options: options,
        state: (0, $i9Ykp.init_state)(options),
        __needMoreData: function(i, bufLen, end) {
            if (end) return false;
            const { encoding: encoding, escape: escape, quote: quote } = this.options;
            const { quoting: quoting, needMoreDataSize: needMoreDataSize, recordDelimiterMaxLength: recordDelimiterMaxLength } = this.state;
            const numOfCharLeft = bufLen - i - 1;
            const requiredLength = Math.max(needMoreDataSize, // Skip if the remaining buffer smaller than record delimiter
            // If "record_delimiter" is yet to be discovered:
            // 1. It is equals to `[]` and "recordDelimiterMaxLength" equals `0`
            // 2. We set the length to windows line ending in the current encoding
            // Note, that encoding is known from user or bom discovery at that point
            // recordDelimiterMaxLength,
            recordDelimiterMaxLength === 0 ? $5b4dbfb740a41692$require$Buffer.from("\r\n", encoding).length : recordDelimiterMaxLength, // Skip if remaining buffer can be an escaped quote
            quoting ? (escape === null ? 0 : escape.length) + quote.length : 0, // Skip if remaining buffer can be record delimiter following the closing quote
            quoting ? quote.length + recordDelimiterMaxLength : 0);
            return numOfCharLeft < requiredLength;
        },
        // Central parser implementation
        parse: function(nextBuf, end, push, close) {
            const { bom: bom, comment_no_infix: comment_no_infix, encoding: encoding, from_line: from_line, ltrim: ltrim, max_record_size: max_record_size, raw: raw, relax_quotes: relax_quotes, rtrim: rtrim, skip_empty_lines: skip_empty_lines, to: to, to_line: to_line } = this.options;
            let { comment: comment, escape: escape, quote: quote, record_delimiter: record_delimiter } = this.options;
            const { bomSkipped: bomSkipped, previousBuf: previousBuf, rawBuffer: rawBuffer, escapeIsQuote: escapeIsQuote } = this.state;
            let buf;
            if (previousBuf === undefined) {
                if (nextBuf === undefined) {
                    // Handle empty string
                    close();
                    return;
                } else buf = nextBuf;
            } else if (previousBuf !== undefined && nextBuf === undefined) buf = previousBuf;
            else buf = $5b4dbfb740a41692$require$Buffer.concat([
                previousBuf,
                nextBuf
            ]);
            // Handle UTF BOM
            if (bomSkipped === false) {
                if (bom === false) this.state.bomSkipped = true;
                else if (buf.length < 3) // No enough data
                {
                    if (end === false) {
                        // Wait for more data
                        this.state.previousBuf = buf;
                        return;
                    }
                } else {
                    for(const encoding in $5b4dbfb740a41692$var$boms)if ($5b4dbfb740a41692$var$boms[encoding].compare(buf, 0, $5b4dbfb740a41692$var$boms[encoding].length) === 0) {
                        // Skip BOM
                        const bomLength = $5b4dbfb740a41692$var$boms[encoding].length;
                        this.state.bufBytesStart += bomLength;
                        buf = buf.slice(bomLength);
                        // Renormalize original options with the new encoding
                        this.options = (0, $7EamI.normalize_options)({
                            ...this.original_options,
                            encoding: encoding
                        });
                        // Options will re-evaluate the Buffer with the new encoding
                        ({ comment: comment, escape: escape, quote: quote } = this.options);
                        break;
                    }
                    this.state.bomSkipped = true;
                }
            }
            const bufLen = buf.length;
            let pos;
            for(pos = 0; pos < bufLen; pos++){
                // Ensure we get enough space to look ahead
                // There should be a way to move this out of the loop
                if (this.__needMoreData(pos, bufLen, end)) break;
                if (this.state.wasRowDelimiter === true) {
                    this.info.lines++;
                    this.state.wasRowDelimiter = false;
                }
                if (to_line !== -1 && this.info.lines > to_line) {
                    this.state.stop = true;
                    close();
                    return;
                }
                // Auto discovery of record_delimiter, unix, mac and windows supported
                if (this.state.quoting === false && record_delimiter.length === 0) {
                    const record_delimiterCount = this.__autoDiscoverRecordDelimiter(buf, pos);
                    if (record_delimiterCount) record_delimiter = this.options.record_delimiter;
                }
                const chr = buf[pos];
                if (raw === true) rawBuffer.append(chr);
                if ((chr === $5b4dbfb740a41692$var$cr || chr === $5b4dbfb740a41692$var$nl) && this.state.wasRowDelimiter === false) this.state.wasRowDelimiter = true;
                // Previous char was a valid escape char
                // treat the current char as a regular char
                if (this.state.escaping === true) this.state.escaping = false;
                else {
                    // Escape is only active inside quoted fields
                    // We are quoting, the char is an escape chr and there is a chr to escape
                    // if(escape !== null && this.state.quoting === true && chr === escape && pos + 1 < bufLen){
                    if (escape !== null && this.state.quoting === true && this.__isEscape(buf, pos, chr) && pos + escape.length < bufLen) {
                        if (escapeIsQuote) {
                            if (this.__isQuote(buf, pos + escape.length)) {
                                this.state.escaping = true;
                                pos += escape.length - 1;
                                continue;
                            }
                        } else {
                            this.state.escaping = true;
                            pos += escape.length - 1;
                            continue;
                        }
                    }
                    // Not currently escaping and chr is a quote
                    // TODO: need to compare bytes instead of single char
                    if (this.state.commenting === false && this.__isQuote(buf, pos)) {
                        if (this.state.quoting === true) {
                            const nextChr = buf[pos + quote.length];
                            const isNextChrTrimable = rtrim && this.__isCharTrimable(buf, pos + quote.length);
                            const isNextChrComment = comment !== null && this.__compareBytes(comment, buf, pos + quote.length, nextChr);
                            const isNextChrDelimiter = this.__isDelimiter(buf, pos + quote.length, nextChr);
                            const isNextChrRecordDelimiter = record_delimiter.length === 0 ? this.__autoDiscoverRecordDelimiter(buf, pos + quote.length) : this.__isRecordDelimiter(nextChr, buf, pos + quote.length);
                            // Escape a quote
                            // Treat next char as a regular character
                            if (escape !== null && this.__isEscape(buf, pos, chr) && this.__isQuote(buf, pos + escape.length)) pos += escape.length - 1;
                            else if (!nextChr || isNextChrDelimiter || isNextChrRecordDelimiter || isNextChrComment || isNextChrTrimable) {
                                this.state.quoting = false;
                                this.state.wasQuoting = true;
                                pos += quote.length - 1;
                                continue;
                            } else if (relax_quotes === false) {
                                const err = this.__error(new (0, $99pXl.CsvError)("CSV_INVALID_CLOSING_QUOTE", [
                                    "Invalid Closing Quote:",
                                    `got "${String.fromCharCode(nextChr)}"`,
                                    `at line ${this.info.lines}`,
                                    "instead of delimiter, record delimiter, trimable character",
                                    "(if activated) or comment"
                                ], this.options, this.__infoField()));
                                if (err !== undefined) return err;
                            } else {
                                this.state.quoting = false;
                                this.state.wasQuoting = true;
                                this.state.field.prepend(quote);
                                pos += quote.length - 1;
                            }
                        } else {
                            if (this.state.field.length !== 0) // In relax_quotes mode, treat opening quote preceded by chrs as regular
                            {
                                if (relax_quotes === false) {
                                    const info = this.__infoField();
                                    const bom = Object.keys($5b4dbfb740a41692$var$boms).map((b)=>$5b4dbfb740a41692$var$boms[b].equals(this.state.field.toString()) ? b : false).filter(Boolean)[0];
                                    const err = this.__error(new (0, $99pXl.CsvError)("INVALID_OPENING_QUOTE", [
                                        "Invalid Opening Quote:",
                                        `a quote is found on field ${JSON.stringify(info.column)} at line ${info.lines}, value is ${JSON.stringify(this.state.field.toString(encoding))}`,
                                        bom ? `(${bom} bom)` : undefined
                                    ], this.options, info, {
                                        field: this.state.field
                                    }));
                                    if (err !== undefined) return err;
                                }
                            } else {
                                this.state.quoting = true;
                                pos += quote.length - 1;
                                continue;
                            }
                        }
                    }
                    if (this.state.quoting === false) {
                        const recordDelimiterLength = this.__isRecordDelimiter(chr, buf, pos);
                        if (recordDelimiterLength !== 0) {
                            // Do not emit comments which take a full line
                            const skipCommentLine = this.state.commenting && this.state.wasQuoting === false && this.state.record.length === 0 && this.state.field.length === 0;
                            if (skipCommentLine) this.info.comment_lines++;
                            else {
                                // Activate records emition if above from_line
                                if (this.state.enabled === false && this.info.lines + (this.state.wasRowDelimiter === true ? 1 : 0) >= from_line) {
                                    this.state.enabled = true;
                                    this.__resetField();
                                    this.__resetRecord();
                                    pos += recordDelimiterLength - 1;
                                    continue;
                                }
                                // Skip if line is empty and skip_empty_lines activated
                                if (skip_empty_lines === true && this.state.wasQuoting === false && this.state.record.length === 0 && this.state.field.length === 0) {
                                    this.info.empty_lines++;
                                    pos += recordDelimiterLength - 1;
                                    continue;
                                }
                                this.info.bytes = this.state.bufBytesStart + pos;
                                const errField = this.__onField();
                                if (errField !== undefined) return errField;
                                this.info.bytes = this.state.bufBytesStart + pos + recordDelimiterLength;
                                const errRecord = this.__onRecord(push);
                                if (errRecord !== undefined) return errRecord;
                                if (to !== -1 && this.info.records >= to) {
                                    this.state.stop = true;
                                    close();
                                    return;
                                }
                            }
                            this.state.commenting = false;
                            pos += recordDelimiterLength - 1;
                            continue;
                        }
                        if (this.state.commenting) continue;
                        if (comment !== null && (comment_no_infix === false || this.state.record.length === 0 && this.state.field.length === 0)) {
                            const commentCount = this.__compareBytes(comment, buf, pos, chr);
                            if (commentCount !== 0) {
                                this.state.commenting = true;
                                continue;
                            }
                        }
                        const delimiterLength = this.__isDelimiter(buf, pos, chr);
                        if (delimiterLength !== 0) {
                            this.info.bytes = this.state.bufBytesStart + pos;
                            const errField = this.__onField();
                            if (errField !== undefined) return errField;
                            pos += delimiterLength - 1;
                            continue;
                        }
                    }
                }
                if (this.state.commenting === false) {
                    if (max_record_size !== 0 && this.state.record_length + this.state.field.length > max_record_size) return this.__error(new (0, $99pXl.CsvError)("CSV_MAX_RECORD_SIZE", [
                        "Max Record Size:",
                        "record exceed the maximum number of tolerated bytes",
                        `of ${max_record_size}`,
                        `at line ${this.info.lines}`
                    ], this.options, this.__infoField()));
                }
                const lappend = ltrim === false || this.state.quoting === true || this.state.field.length !== 0 || !this.__isCharTrimable(buf, pos);
                // rtrim in non quoting is handle in __onField
                const rappend = rtrim === false || this.state.wasQuoting === false;
                if (lappend === true && rappend === true) this.state.field.append(chr);
                else if (rtrim === true && !this.__isCharTrimable(buf, pos)) return this.__error(new (0, $99pXl.CsvError)("CSV_NON_TRIMABLE_CHAR_AFTER_CLOSING_QUOTE", [
                    "Invalid Closing Quote:",
                    "found non trimable byte after quote",
                    `at line ${this.info.lines}`
                ], this.options, this.__infoField()));
                else {
                    if (lappend === false) pos += this.__isCharTrimable(buf, pos) - 1;
                    continue;
                }
            }
            if (end === true) {
                // Ensure we are not ending in a quoting state
                if (this.state.quoting === true) {
                    const err = this.__error(new (0, $99pXl.CsvError)("CSV_QUOTE_NOT_CLOSED", [
                        "Quote Not Closed:",
                        `the parsing is finished with an opening quote at line ${this.info.lines}`
                    ], this.options, this.__infoField()));
                    if (err !== undefined) return err;
                } else {
                    // Skip last line if it has no characters
                    if (this.state.wasQuoting === true || this.state.record.length !== 0 || this.state.field.length !== 0) {
                        this.info.bytes = this.state.bufBytesStart + pos;
                        const errField = this.__onField();
                        if (errField !== undefined) return errField;
                        const errRecord = this.__onRecord(push);
                        if (errRecord !== undefined) return errRecord;
                    } else if (this.state.wasRowDelimiter === true) this.info.empty_lines++;
                    else if (this.state.commenting === true) this.info.comment_lines++;
                }
            } else {
                this.state.bufBytesStart += pos;
                this.state.previousBuf = buf.slice(pos);
            }
            if (this.state.wasRowDelimiter === true) {
                this.info.lines++;
                this.state.wasRowDelimiter = false;
            }
        },
        __onRecord: function(push) {
            const { columns: columns, group_columns_by_name: group_columns_by_name, encoding: encoding, info: info, from: from, relax_column_count: relax_column_count, relax_column_count_less: relax_column_count_less, relax_column_count_more: relax_column_count_more, raw: raw, skip_records_with_empty_values: skip_records_with_empty_values } = this.options;
            const { enabled: enabled, record: record } = this.state;
            if (enabled === false) return this.__resetRecord();
            // Convert the first line into column names
            const recordLength = record.length;
            if (columns === true) {
                if (skip_records_with_empty_values === true && $5b4dbfb740a41692$var$isRecordEmpty(record)) {
                    this.__resetRecord();
                    return;
                }
                return this.__firstLineToColumns(record);
            }
            if (columns === false && this.info.records === 0) this.state.expectedRecordLength = recordLength;
            if (recordLength !== this.state.expectedRecordLength) {
                const err = columns === false ? new (0, $99pXl.CsvError)("CSV_RECORD_INCONSISTENT_FIELDS_LENGTH", [
                    "Invalid Record Length:",
                    `expect ${this.state.expectedRecordLength},`,
                    `got ${recordLength} on line ${this.info.lines}`
                ], this.options, this.__infoField(), {
                    record: record
                }) : new (0, $99pXl.CsvError)("CSV_RECORD_INCONSISTENT_COLUMNS", [
                    "Invalid Record Length:",
                    `columns length is ${columns.length},`,
                    `got ${recordLength} on line ${this.info.lines}`
                ], this.options, this.__infoField(), {
                    record: record
                });
                if (relax_column_count === true || relax_column_count_less === true && recordLength < this.state.expectedRecordLength || relax_column_count_more === true && recordLength > this.state.expectedRecordLength) {
                    this.info.invalid_field_length++;
                    this.state.error = err;
                // Error is undefined with skip_records_with_error
                } else {
                    const finalErr = this.__error(err);
                    if (finalErr) return finalErr;
                }
            }
            if (skip_records_with_empty_values === true && $5b4dbfb740a41692$var$isRecordEmpty(record)) {
                this.__resetRecord();
                return;
            }
            if (this.state.recordHasError === true) {
                this.__resetRecord();
                this.state.recordHasError = false;
                return;
            }
            this.info.records++;
            if (from === 1 || this.info.records >= from) {
                const { objname: objname } = this.options;
                // With columns, records are object
                if (columns !== false) {
                    const obj = {};
                    // Transform record array to an object
                    for(let i = 0, l = record.length; i < l; i++){
                        if (columns[i] === undefined || columns[i].disabled) continue;
                        // Turn duplicate columns into an array
                        if (group_columns_by_name === true && obj[columns[i].name] !== undefined) {
                            if (Array.isArray(obj[columns[i].name])) obj[columns[i].name] = obj[columns[i].name].concat(record[i]);
                            else obj[columns[i].name] = [
                                obj[columns[i].name],
                                record[i]
                            ];
                        } else obj[columns[i].name] = record[i];
                    }
                    // Without objname (default)
                    if (raw === true || info === true) {
                        const extRecord = Object.assign({
                            record: obj
                        }, raw === true ? {
                            raw: this.state.rawBuffer.toString(encoding)
                        } : {}, info === true ? {
                            info: this.__infoRecord()
                        } : {});
                        const err = this.__push(objname === undefined ? extRecord : [
                            obj[objname],
                            extRecord
                        ], push);
                        if (err) return err;
                    } else {
                        const err = this.__push(objname === undefined ? obj : [
                            obj[objname],
                            obj
                        ], push);
                        if (err) return err;
                    }
                // Without columns, records are array
                } else if (raw === true || info === true) {
                    const extRecord = Object.assign({
                        record: record
                    }, raw === true ? {
                        raw: this.state.rawBuffer.toString(encoding)
                    } : {}, info === true ? {
                        info: this.__infoRecord()
                    } : {});
                    const err = this.__push(objname === undefined ? extRecord : [
                        record[objname],
                        extRecord
                    ], push);
                    if (err) return err;
                } else {
                    const err = this.__push(objname === undefined ? record : [
                        record[objname],
                        record
                    ], push);
                    if (err) return err;
                }
            }
            this.__resetRecord();
        },
        __firstLineToColumns: function(record) {
            const { firstLineToHeaders: firstLineToHeaders } = this.state;
            try {
                const headers = firstLineToHeaders === undefined ? record : firstLineToHeaders.call(null, record);
                if (!Array.isArray(headers)) return this.__error(new (0, $99pXl.CsvError)("CSV_INVALID_COLUMN_MAPPING", [
                    "Invalid Column Mapping:",
                    "expect an array from column function,",
                    `got ${JSON.stringify(headers)}`
                ], this.options, this.__infoField(), {
                    headers: headers
                }));
                const normalizedHeaders = (0, $4oc3f.normalize_columns_array)(headers);
                this.state.expectedRecordLength = normalizedHeaders.length;
                this.options.columns = normalizedHeaders;
                this.__resetRecord();
                return;
            } catch (err) {
                return err;
            }
        },
        __resetRecord: function() {
            if (this.options.raw === true) this.state.rawBuffer.reset();
            this.state.error = undefined;
            this.state.record = [];
            this.state.record_length = 0;
        },
        __onField: function() {
            const { cast: cast, encoding: encoding, rtrim: rtrim, max_record_size: max_record_size } = this.options;
            const { enabled: enabled, wasQuoting: wasQuoting } = this.state;
            // Short circuit for the from_line options
            if (enabled === false) return this.__resetField();
            let field = this.state.field.toString(encoding);
            if (rtrim === true && wasQuoting === false) field = field.trimRight();
            if (cast === true) {
                const [err, f] = this.__cast(field);
                if (err !== undefined) return err;
                field = f;
            }
            this.state.record.push(field);
            // Increment record length if record size must not exceed a limit
            if (max_record_size !== 0 && typeof field === "string") this.state.record_length += field.length;
            this.__resetField();
        },
        __resetField: function() {
            this.state.field.reset();
            this.state.wasQuoting = false;
        },
        __push: function(record, push) {
            const { on_record: on_record } = this.options;
            if (on_record !== undefined) {
                const info = this.__infoRecord();
                try {
                    record = on_record.call(null, record, info);
                } catch (err) {
                    return err;
                }
                if (record === undefined || record === null) return;
            }
            push(record);
        },
        // Return a tuple with the error and the casted value
        __cast: function(field) {
            const { columns: columns, relax_column_count: relax_column_count } = this.options;
            const isColumns = Array.isArray(columns);
            // Dont loose time calling cast
            // because the final record is an object
            // and this field can't be associated to a key present in columns
            if (isColumns === true && relax_column_count && this.options.columns.length <= this.state.record.length) return [
                undefined,
                undefined
            ];
            if (this.state.castField !== null) try {
                const info = this.__infoField();
                return [
                    undefined,
                    this.state.castField.call(null, field, info)
                ];
            } catch (err) {
                return [
                    err
                ];
            }
            if (this.__isFloat(field)) return [
                undefined,
                parseFloat(field)
            ];
            else if (this.options.cast_date !== false) {
                const info = this.__infoField();
                return [
                    undefined,
                    this.options.cast_date.call(null, field, info)
                ];
            }
            return [
                undefined,
                field
            ];
        },
        // Helper to test if a character is a space or a line delimiter
        __isCharTrimable: function(buf, pos) {
            const isTrim = (buf, pos)=>{
                const { timchars: timchars } = this.state;
                loop1: for(let i = 0; i < timchars.length; i++){
                    const timchar = timchars[i];
                    for(let j = 0; j < timchar.length; j++){
                        if (timchar[j] !== buf[pos + j]) continue loop1;
                    }
                    return timchar.length;
                }
                return 0;
            };
            return isTrim(buf, pos);
        },
        // Keep it in case we implement the `cast_int` option
        // __isInt(value){
        //   // return Number.isInteger(parseInt(value))
        //   // return !isNaN( parseInt( obj ) );
        //   return /^(\-|\+)?[1-9][0-9]*$/.test(value)
        // }
        __isFloat: function(value) {
            return value - parseFloat(value) + 1 >= 0; // Borrowed from jquery
        },
        __compareBytes: function(sourceBuf, targetBuf, targetPos, firstByte) {
            if (sourceBuf[0] !== firstByte) return 0;
            const sourceLength = sourceBuf.length;
            for(let i = 1; i < sourceLength; i++){
                if (sourceBuf[i] !== targetBuf[targetPos + i]) return 0;
            }
            return sourceLength;
        },
        __isDelimiter: function(buf, pos, chr) {
            const { delimiter: delimiter, ignore_last_delimiters: ignore_last_delimiters } = this.options;
            if (ignore_last_delimiters === true && this.state.record.length === this.options.columns.length - 1) return 0;
            else if (ignore_last_delimiters !== false && typeof ignore_last_delimiters === "number" && this.state.record.length === ignore_last_delimiters - 1) return 0;
            loop1: for(let i = 0; i < delimiter.length; i++){
                const del = delimiter[i];
                if (del[0] === chr) {
                    for(let j = 1; j < del.length; j++){
                        if (del[j] !== buf[pos + j]) continue loop1;
                    }
                    return del.length;
                }
            }
            return 0;
        },
        __isRecordDelimiter: function(chr, buf, pos) {
            const { record_delimiter: record_delimiter } = this.options;
            const recordDelimiterLength = record_delimiter.length;
            loop1: for(let i = 0; i < recordDelimiterLength; i++){
                const rd = record_delimiter[i];
                const rdLength = rd.length;
                if (rd[0] !== chr) continue;
                for(let j = 1; j < rdLength; j++){
                    if (rd[j] !== buf[pos + j]) continue loop1;
                }
                return rd.length;
            }
            return 0;
        },
        __isEscape: function(buf, pos, chr) {
            const { escape: escape } = this.options;
            if (escape === null) return false;
            const l = escape.length;
            if (escape[0] === chr) {
                for(let i = 0; i < l; i++){
                    if (escape[i] !== buf[pos + i]) return false;
                }
                return true;
            }
            return false;
        },
        __isQuote: function(buf, pos) {
            const { quote: quote } = this.options;
            if (quote === null) return false;
            const l = quote.length;
            for(let i = 0; i < l; i++){
                if (quote[i] !== buf[pos + i]) return false;
            }
            return true;
        },
        __autoDiscoverRecordDelimiter: function(buf, pos) {
            const { encoding: encoding } = this.options;
            // Note, we don't need to cache this information in state,
            // It is only called on the first line until we find out a suitable
            // record delimiter.
            const rds = [
                // Important, the windows line ending must be before mac os 9
                $5b4dbfb740a41692$require$Buffer.from("\r\n", encoding),
                $5b4dbfb740a41692$require$Buffer.from("\n", encoding),
                $5b4dbfb740a41692$require$Buffer.from("\r", encoding)
            ];
            loop: for(let i = 0; i < rds.length; i++){
                const l = rds[i].length;
                for(let j = 0; j < l; j++){
                    if (rds[i][j] !== buf[pos + j]) continue loop;
                }
                this.options.record_delimiter.push(rds[i]);
                this.state.recordDelimiterMaxLength = rds[i].length;
                return rds[i].length;
            }
            return 0;
        },
        __error: function(msg) {
            const { encoding: encoding, raw: raw, skip_records_with_error: skip_records_with_error } = this.options;
            const err = typeof msg === "string" ? new Error(msg) : msg;
            if (skip_records_with_error) {
                this.state.recordHasError = true;
                if (this.options.on_skip !== undefined) this.options.on_skip(err, raw ? this.state.rawBuffer.toString(encoding) : undefined);
                // this.emit('skip', err, raw ? this.state.rawBuffer.toString(encoding) : undefined);
                return undefined;
            } else return err;
        },
        __infoDataSet: function() {
            return {
                ...this.info,
                columns: this.options.columns
            };
        },
        __infoRecord: function() {
            const { columns: columns, raw: raw, encoding: encoding } = this.options;
            return {
                ...this.__infoDataSet(),
                error: this.state.error,
                header: columns === true,
                index: this.state.record.length,
                raw: raw ? this.state.rawBuffer.toString(encoding) : undefined
            };
        },
        __infoField: function() {
            const { columns: columns } = this.options;
            const isColumns = Array.isArray(columns);
            return {
                ...this.__infoRecord(),
                column: isColumns === true ? columns.length > this.state.record.length ? columns[this.state.record.length].name : null : this.state.record.length,
                quoting: this.state.wasQuoting
            };
        }
    };
};

});
parcelRegister("4oc3f", function(module, exports) {

$parcel$export(module.exports, "normalize_columns_array", () => $3322c07b4b6b2352$export$46bd8faf65ac9e2);

var $99pXl = parcelRequire("99pXl");

var $ebECT = parcelRequire("ebECT");
const $3322c07b4b6b2352$export$46bd8faf65ac9e2 = function(columns) {
    const normalizedColumns = [];
    for(let i = 0, l = columns.length; i < l; i++){
        const column = columns[i];
        if (column === undefined || column === null || column === false) normalizedColumns[i] = {
            disabled: true
        };
        else if (typeof column === "string") normalizedColumns[i] = {
            name: column
        };
        else if ((0, $ebECT.is_object)(column)) {
            if (typeof column.name !== "string") throw new (0, $99pXl.CsvError)("CSV_OPTION_COLUMNS_MISSING_NAME", [
                "Option columns missing name:",
                `property "name" is required at position ${i}`,
                "when column is an object literal"
            ]);
            normalizedColumns[i] = column;
        } else throw new (0, $99pXl.CsvError)("CSV_INVALID_COLUMN_DEFINITION", [
            "Invalid column definition:",
            "expect a string or a literal object,",
            `got ${JSON.stringify(column)} at position ${i}`
        ]);
    }
    return normalizedColumns;
};

});
parcelRegister("99pXl", function(module, exports) {

$parcel$export(module.exports, "CsvError", () => $6a9916b217e79fa7$export$d9d08b09962b4c23);

var $7zlKx = parcelRequire("7zlKx");
var $6a9916b217e79fa7$require$Buffer = $7zlKx.Buffer;
class $6a9916b217e79fa7$export$d9d08b09962b4c23 extends Error {
    constructor(code, message, options, ...contexts){
        if (Array.isArray(message)) message = message.join(" ").trim();
        super(message);
        if (Error.captureStackTrace !== undefined) Error.captureStackTrace(this, $6a9916b217e79fa7$export$d9d08b09962b4c23);
        this.code = code;
        for (const context of contexts)for(const key in context){
            const value = context[key];
            this[key] = $6a9916b217e79fa7$require$Buffer.isBuffer(value) ? value.toString(options.encoding) : value == null ? value : JSON.parse(JSON.stringify(value));
        }
    }
}

});
parcelRegister("7zlKx", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $582cac4b36a2de1d$export$a143d493d941bafc, (v) => $582cac4b36a2de1d$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $582cac4b36a2de1d$export$f99ded8fe4b79145, (v) => $582cac4b36a2de1d$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $582cac4b36a2de1d$export$a143d493d941bafc;
var $582cac4b36a2de1d$export$e4cf37d7f6fb9e0a;
var $582cac4b36a2de1d$export$f99ded8fe4b79145;
var $582cac4b36a2de1d$export$599f31c3813fae4d;
"use strict";

var $eNaSH = parcelRequire("eNaSH");

var $dtm0F = parcelRequire("dtm0F");
const $582cac4b36a2de1d$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$582cac4b36a2de1d$export$a143d493d941bafc = $582cac4b36a2de1d$var$Buffer;
$582cac4b36a2de1d$export$e4cf37d7f6fb9e0a = $582cac4b36a2de1d$var$SlowBuffer;
$582cac4b36a2de1d$export$f99ded8fe4b79145 = 50;
const $582cac4b36a2de1d$var$K_MAX_LENGTH = 0x7fffffff;
$582cac4b36a2de1d$export$599f31c3813fae4d = $582cac4b36a2de1d$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $582cac4b36a2de1d$var$Buffer.TYPED_ARRAY_SUPPORT = $582cac4b36a2de1d$var$typedArraySupport();
if (!$582cac4b36a2de1d$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $582cac4b36a2de1d$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($582cac4b36a2de1d$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$582cac4b36a2de1d$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($582cac4b36a2de1d$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$582cac4b36a2de1d$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $582cac4b36a2de1d$var$createBuffer(length) {
    if (length > $582cac4b36a2de1d$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $582cac4b36a2de1d$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $582cac4b36a2de1d$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $582cac4b36a2de1d$var$allocUnsafe(arg);
    }
    return $582cac4b36a2de1d$var$from(arg, encodingOrOffset, length);
}
$582cac4b36a2de1d$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $582cac4b36a2de1d$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $582cac4b36a2de1d$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $582cac4b36a2de1d$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($582cac4b36a2de1d$var$isInstance(value, ArrayBuffer) || value && $582cac4b36a2de1d$var$isInstance(value.buffer, ArrayBuffer)) return $582cac4b36a2de1d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($582cac4b36a2de1d$var$isInstance(value, SharedArrayBuffer) || value && $582cac4b36a2de1d$var$isInstance(value.buffer, SharedArrayBuffer))) return $582cac4b36a2de1d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $582cac4b36a2de1d$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $582cac4b36a2de1d$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $582cac4b36a2de1d$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $582cac4b36a2de1d$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $582cac4b36a2de1d$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($582cac4b36a2de1d$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($582cac4b36a2de1d$var$Buffer, Uint8Array);
function $582cac4b36a2de1d$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $582cac4b36a2de1d$var$alloc(size, fill, encoding) {
    $582cac4b36a2de1d$var$assertSize(size);
    if (size <= 0) return $582cac4b36a2de1d$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $582cac4b36a2de1d$var$createBuffer(size).fill(fill, encoding) : $582cac4b36a2de1d$var$createBuffer(size).fill(fill);
    return $582cac4b36a2de1d$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $582cac4b36a2de1d$var$Buffer.alloc = function(size, fill, encoding) {
    return $582cac4b36a2de1d$var$alloc(size, fill, encoding);
};
function $582cac4b36a2de1d$var$allocUnsafe(size) {
    $582cac4b36a2de1d$var$assertSize(size);
    return $582cac4b36a2de1d$var$createBuffer(size < 0 ? 0 : $582cac4b36a2de1d$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $582cac4b36a2de1d$var$Buffer.allocUnsafe = function(size) {
    return $582cac4b36a2de1d$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $582cac4b36a2de1d$var$Buffer.allocUnsafeSlow = function(size) {
    return $582cac4b36a2de1d$var$allocUnsafe(size);
};
function $582cac4b36a2de1d$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$582cac4b36a2de1d$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $582cac4b36a2de1d$var$byteLength(string, encoding) | 0;
    let buf = $582cac4b36a2de1d$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $582cac4b36a2de1d$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $582cac4b36a2de1d$var$checked(array.length) | 0;
    const buf = $582cac4b36a2de1d$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $582cac4b36a2de1d$var$fromArrayView(arrayView) {
    if ($582cac4b36a2de1d$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $582cac4b36a2de1d$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $582cac4b36a2de1d$var$fromArrayLike(arrayView);
}
function $582cac4b36a2de1d$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $582cac4b36a2de1d$var$Buffer.prototype);
    return buf;
}
function $582cac4b36a2de1d$var$fromObject(obj) {
    if ($582cac4b36a2de1d$var$Buffer.isBuffer(obj)) {
        const len = $582cac4b36a2de1d$var$checked(obj.length) | 0;
        const buf = $582cac4b36a2de1d$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $582cac4b36a2de1d$var$numberIsNaN(obj.length)) return $582cac4b36a2de1d$var$createBuffer(0);
        return $582cac4b36a2de1d$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $582cac4b36a2de1d$var$fromArrayLike(obj.data);
}
function $582cac4b36a2de1d$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $582cac4b36a2de1d$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $582cac4b36a2de1d$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $582cac4b36a2de1d$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $582cac4b36a2de1d$var$Buffer.alloc(+length);
}
$582cac4b36a2de1d$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $582cac4b36a2de1d$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$582cac4b36a2de1d$var$Buffer.compare = function compare(a, b) {
    if ($582cac4b36a2de1d$var$isInstance(a, Uint8Array)) a = $582cac4b36a2de1d$var$Buffer.from(a, a.offset, a.byteLength);
    if ($582cac4b36a2de1d$var$isInstance(b, Uint8Array)) b = $582cac4b36a2de1d$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$582cac4b36a2de1d$var$Buffer.isBuffer(a) || !$582cac4b36a2de1d$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$582cac4b36a2de1d$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$582cac4b36a2de1d$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $582cac4b36a2de1d$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $582cac4b36a2de1d$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($582cac4b36a2de1d$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$582cac4b36a2de1d$var$Buffer.isBuffer(buf)) buf = $582cac4b36a2de1d$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$582cac4b36a2de1d$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $582cac4b36a2de1d$var$byteLength(string, encoding) {
    if ($582cac4b36a2de1d$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $582cac4b36a2de1d$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $582cac4b36a2de1d$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $582cac4b36a2de1d$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $582cac4b36a2de1d$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$582cac4b36a2de1d$var$Buffer.byteLength = $582cac4b36a2de1d$var$byteLength;
function $582cac4b36a2de1d$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $582cac4b36a2de1d$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $582cac4b36a2de1d$var$utf8Slice(this, start, end);
        case "ascii":
            return $582cac4b36a2de1d$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $582cac4b36a2de1d$var$latin1Slice(this, start, end);
        case "base64":
            return $582cac4b36a2de1d$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $582cac4b36a2de1d$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$582cac4b36a2de1d$var$Buffer.prototype._isBuffer = true;
function $582cac4b36a2de1d$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$582cac4b36a2de1d$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$582cac4b36a2de1d$var$swap(this, i, i + 1);
    return this;
};
$582cac4b36a2de1d$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $582cac4b36a2de1d$var$swap(this, i, i + 3);
        $582cac4b36a2de1d$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$582cac4b36a2de1d$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $582cac4b36a2de1d$var$swap(this, i, i + 7);
        $582cac4b36a2de1d$var$swap(this, i + 1, i + 6);
        $582cac4b36a2de1d$var$swap(this, i + 2, i + 5);
        $582cac4b36a2de1d$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$582cac4b36a2de1d$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $582cac4b36a2de1d$var$utf8Slice(this, 0, length);
    return $582cac4b36a2de1d$var$slowToString.apply(this, arguments);
};
$582cac4b36a2de1d$var$Buffer.prototype.toLocaleString = $582cac4b36a2de1d$var$Buffer.prototype.toString;
$582cac4b36a2de1d$var$Buffer.prototype.equals = function equals(b) {
    if (!$582cac4b36a2de1d$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $582cac4b36a2de1d$var$Buffer.compare(this, b) === 0;
};
$582cac4b36a2de1d$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $582cac4b36a2de1d$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($582cac4b36a2de1d$var$customInspectSymbol) $582cac4b36a2de1d$var$Buffer.prototype[$582cac4b36a2de1d$var$customInspectSymbol] = $582cac4b36a2de1d$var$Buffer.prototype.inspect;
$582cac4b36a2de1d$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($582cac4b36a2de1d$var$isInstance(target, Uint8Array)) target = $582cac4b36a2de1d$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$582cac4b36a2de1d$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $582cac4b36a2de1d$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($582cac4b36a2de1d$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $582cac4b36a2de1d$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($582cac4b36a2de1d$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $582cac4b36a2de1d$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $582cac4b36a2de1d$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $582cac4b36a2de1d$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$582cac4b36a2de1d$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$582cac4b36a2de1d$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $582cac4b36a2de1d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$582cac4b36a2de1d$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $582cac4b36a2de1d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $582cac4b36a2de1d$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($582cac4b36a2de1d$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $582cac4b36a2de1d$var$utf8Write(buf, string, offset, length) {
    return $582cac4b36a2de1d$var$blitBuffer($582cac4b36a2de1d$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $582cac4b36a2de1d$var$asciiWrite(buf, string, offset, length) {
    return $582cac4b36a2de1d$var$blitBuffer($582cac4b36a2de1d$var$asciiToBytes(string), buf, offset, length);
}
function $582cac4b36a2de1d$var$base64Write(buf, string, offset, length) {
    return $582cac4b36a2de1d$var$blitBuffer($582cac4b36a2de1d$var$base64ToBytes(string), buf, offset, length);
}
function $582cac4b36a2de1d$var$ucs2Write(buf, string, offset, length) {
    return $582cac4b36a2de1d$var$blitBuffer($582cac4b36a2de1d$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$582cac4b36a2de1d$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $582cac4b36a2de1d$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $582cac4b36a2de1d$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $582cac4b36a2de1d$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $582cac4b36a2de1d$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $582cac4b36a2de1d$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$582cac4b36a2de1d$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $582cac4b36a2de1d$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eNaSH.fromByteArray(buf);
    else return $eNaSH.fromByteArray(buf.slice(start, end));
}
function $582cac4b36a2de1d$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $582cac4b36a2de1d$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $582cac4b36a2de1d$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $582cac4b36a2de1d$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $582cac4b36a2de1d$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $582cac4b36a2de1d$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $582cac4b36a2de1d$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $582cac4b36a2de1d$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $582cac4b36a2de1d$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $582cac4b36a2de1d$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $582cac4b36a2de1d$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$582cac4b36a2de1d$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $582cac4b36a2de1d$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $582cac4b36a2de1d$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$582cac4b36a2de1d$var$Buffer.prototype.readUintLE = $582cac4b36a2de1d$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $582cac4b36a2de1d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$582cac4b36a2de1d$var$Buffer.prototype.readUintBE = $582cac4b36a2de1d$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $582cac4b36a2de1d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$582cac4b36a2de1d$var$Buffer.prototype.readUint8 = $582cac4b36a2de1d$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $582cac4b36a2de1d$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$582cac4b36a2de1d$var$Buffer.prototype.readUint16LE = $582cac4b36a2de1d$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $582cac4b36a2de1d$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$582cac4b36a2de1d$var$Buffer.prototype.readUint16BE = $582cac4b36a2de1d$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $582cac4b36a2de1d$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$582cac4b36a2de1d$var$Buffer.prototype.readUint32LE = $582cac4b36a2de1d$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $582cac4b36a2de1d$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$582cac4b36a2de1d$var$Buffer.prototype.readUint32BE = $582cac4b36a2de1d$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $582cac4b36a2de1d$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$582cac4b36a2de1d$var$Buffer.prototype.readBigUInt64LE = $582cac4b36a2de1d$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $582cac4b36a2de1d$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $582cac4b36a2de1d$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$582cac4b36a2de1d$var$Buffer.prototype.readBigUInt64BE = $582cac4b36a2de1d$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $582cac4b36a2de1d$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $582cac4b36a2de1d$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$582cac4b36a2de1d$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $582cac4b36a2de1d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$582cac4b36a2de1d$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $582cac4b36a2de1d$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$582cac4b36a2de1d$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $582cac4b36a2de1d$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$582cac4b36a2de1d$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $582cac4b36a2de1d$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$582cac4b36a2de1d$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $582cac4b36a2de1d$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$582cac4b36a2de1d$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $582cac4b36a2de1d$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$582cac4b36a2de1d$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $582cac4b36a2de1d$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$582cac4b36a2de1d$var$Buffer.prototype.readBigInt64LE = $582cac4b36a2de1d$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $582cac4b36a2de1d$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $582cac4b36a2de1d$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$582cac4b36a2de1d$var$Buffer.prototype.readBigInt64BE = $582cac4b36a2de1d$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $582cac4b36a2de1d$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $582cac4b36a2de1d$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$582cac4b36a2de1d$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $582cac4b36a2de1d$var$checkOffset(offset, 4, this.length);
    return $dtm0F.read(this, offset, true, 23, 4);
};
$582cac4b36a2de1d$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $582cac4b36a2de1d$var$checkOffset(offset, 4, this.length);
    return $dtm0F.read(this, offset, false, 23, 4);
};
$582cac4b36a2de1d$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $582cac4b36a2de1d$var$checkOffset(offset, 8, this.length);
    return $dtm0F.read(this, offset, true, 52, 8);
};
$582cac4b36a2de1d$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $582cac4b36a2de1d$var$checkOffset(offset, 8, this.length);
    return $dtm0F.read(this, offset, false, 52, 8);
};
function $582cac4b36a2de1d$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$582cac4b36a2de1d$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$582cac4b36a2de1d$var$Buffer.prototype.writeUintLE = $582cac4b36a2de1d$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $582cac4b36a2de1d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$582cac4b36a2de1d$var$Buffer.prototype.writeUintBE = $582cac4b36a2de1d$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $582cac4b36a2de1d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$582cac4b36a2de1d$var$Buffer.prototype.writeUint8 = $582cac4b36a2de1d$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $582cac4b36a2de1d$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$582cac4b36a2de1d$var$Buffer.prototype.writeUint16LE = $582cac4b36a2de1d$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $582cac4b36a2de1d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$582cac4b36a2de1d$var$Buffer.prototype.writeUint16BE = $582cac4b36a2de1d$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $582cac4b36a2de1d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$582cac4b36a2de1d$var$Buffer.prototype.writeUint32LE = $582cac4b36a2de1d$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $582cac4b36a2de1d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$582cac4b36a2de1d$var$Buffer.prototype.writeUint32BE = $582cac4b36a2de1d$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $582cac4b36a2de1d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $582cac4b36a2de1d$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $582cac4b36a2de1d$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $582cac4b36a2de1d$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $582cac4b36a2de1d$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$582cac4b36a2de1d$var$Buffer.prototype.writeBigUInt64LE = $582cac4b36a2de1d$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $582cac4b36a2de1d$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$582cac4b36a2de1d$var$Buffer.prototype.writeBigUInt64BE = $582cac4b36a2de1d$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $582cac4b36a2de1d$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$582cac4b36a2de1d$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $582cac4b36a2de1d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$582cac4b36a2de1d$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $582cac4b36a2de1d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$582cac4b36a2de1d$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $582cac4b36a2de1d$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$582cac4b36a2de1d$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $582cac4b36a2de1d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$582cac4b36a2de1d$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $582cac4b36a2de1d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$582cac4b36a2de1d$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $582cac4b36a2de1d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$582cac4b36a2de1d$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $582cac4b36a2de1d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$582cac4b36a2de1d$var$Buffer.prototype.writeBigInt64LE = $582cac4b36a2de1d$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $582cac4b36a2de1d$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$582cac4b36a2de1d$var$Buffer.prototype.writeBigInt64BE = $582cac4b36a2de1d$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $582cac4b36a2de1d$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $582cac4b36a2de1d$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $582cac4b36a2de1d$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $582cac4b36a2de1d$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $dtm0F.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$582cac4b36a2de1d$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $582cac4b36a2de1d$var$writeFloat(this, value, offset, true, noAssert);
};
$582cac4b36a2de1d$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $582cac4b36a2de1d$var$writeFloat(this, value, offset, false, noAssert);
};
function $582cac4b36a2de1d$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $582cac4b36a2de1d$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $dtm0F.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$582cac4b36a2de1d$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $582cac4b36a2de1d$var$writeDouble(this, value, offset, true, noAssert);
};
$582cac4b36a2de1d$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $582cac4b36a2de1d$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$582cac4b36a2de1d$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$582cac4b36a2de1d$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$582cac4b36a2de1d$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$582cac4b36a2de1d$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $582cac4b36a2de1d$var$Buffer.isBuffer(val) ? val : $582cac4b36a2de1d$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $582cac4b36a2de1d$var$errors = {};
function $582cac4b36a2de1d$var$E(sym, getMessage, Base) {
    $582cac4b36a2de1d$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$582cac4b36a2de1d$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$582cac4b36a2de1d$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$582cac4b36a2de1d$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $582cac4b36a2de1d$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $582cac4b36a2de1d$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $582cac4b36a2de1d$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $582cac4b36a2de1d$var$checkBounds(buf, offset, byteLength) {
    $582cac4b36a2de1d$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $582cac4b36a2de1d$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $582cac4b36a2de1d$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $582cac4b36a2de1d$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $582cac4b36a2de1d$var$checkBounds(buf, offset, byteLength);
}
function $582cac4b36a2de1d$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $582cac4b36a2de1d$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $582cac4b36a2de1d$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $582cac4b36a2de1d$var$validateNumber(value, type);
        throw new $582cac4b36a2de1d$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $582cac4b36a2de1d$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $582cac4b36a2de1d$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $582cac4b36a2de1d$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $582cac4b36a2de1d$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($582cac4b36a2de1d$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $582cac4b36a2de1d$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $582cac4b36a2de1d$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $582cac4b36a2de1d$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $582cac4b36a2de1d$var$base64ToBytes(str) {
    return $eNaSH.toByteArray($582cac4b36a2de1d$var$base64clean(str));
}
function $582cac4b36a2de1d$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $582cac4b36a2de1d$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $582cac4b36a2de1d$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $582cac4b36a2de1d$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $582cac4b36a2de1d$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $582cac4b36a2de1d$var$BufferBigIntNotDefined : fn;
}
function $582cac4b36a2de1d$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("eNaSH", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $ac4e1517d94fc88d$export$d622b2ad8d90c771, (v) => $ac4e1517d94fc88d$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $ac4e1517d94fc88d$export$6100ba28696e12de, (v) => $ac4e1517d94fc88d$export$6100ba28696e12de = v);
var $ac4e1517d94fc88d$export$a48f0734ac7c2329;
var $ac4e1517d94fc88d$export$d622b2ad8d90c771;
var $ac4e1517d94fc88d$export$6100ba28696e12de;
"use strict";
$ac4e1517d94fc88d$export$a48f0734ac7c2329 = $ac4e1517d94fc88d$var$byteLength;
$ac4e1517d94fc88d$export$d622b2ad8d90c771 = $ac4e1517d94fc88d$var$toByteArray;
$ac4e1517d94fc88d$export$6100ba28696e12de = $ac4e1517d94fc88d$var$fromByteArray;
var $ac4e1517d94fc88d$var$lookup = [];
var $ac4e1517d94fc88d$var$revLookup = [];
var $ac4e1517d94fc88d$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $ac4e1517d94fc88d$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $ac4e1517d94fc88d$var$i = 0, $ac4e1517d94fc88d$var$len = $ac4e1517d94fc88d$var$code.length; $ac4e1517d94fc88d$var$i < $ac4e1517d94fc88d$var$len; ++$ac4e1517d94fc88d$var$i){
    $ac4e1517d94fc88d$var$lookup[$ac4e1517d94fc88d$var$i] = $ac4e1517d94fc88d$var$code[$ac4e1517d94fc88d$var$i];
    $ac4e1517d94fc88d$var$revLookup[$ac4e1517d94fc88d$var$code.charCodeAt($ac4e1517d94fc88d$var$i)] = $ac4e1517d94fc88d$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$ac4e1517d94fc88d$var$revLookup["-".charCodeAt(0)] = 62;
$ac4e1517d94fc88d$var$revLookup["_".charCodeAt(0)] = 63;
function $ac4e1517d94fc88d$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $ac4e1517d94fc88d$var$byteLength(b64) {
    var lens = $ac4e1517d94fc88d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $ac4e1517d94fc88d$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $ac4e1517d94fc88d$var$toByteArray(b64) {
    var tmp;
    var lens = $ac4e1517d94fc88d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $ac4e1517d94fc88d$var$Arr($ac4e1517d94fc88d$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $ac4e1517d94fc88d$var$revLookup[b64.charCodeAt(i)] << 18 | $ac4e1517d94fc88d$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $ac4e1517d94fc88d$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $ac4e1517d94fc88d$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $ac4e1517d94fc88d$var$revLookup[b64.charCodeAt(i)] << 2 | $ac4e1517d94fc88d$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $ac4e1517d94fc88d$var$revLookup[b64.charCodeAt(i)] << 10 | $ac4e1517d94fc88d$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $ac4e1517d94fc88d$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $ac4e1517d94fc88d$var$tripletToBase64(num) {
    return $ac4e1517d94fc88d$var$lookup[num >> 18 & 0x3F] + $ac4e1517d94fc88d$var$lookup[num >> 12 & 0x3F] + $ac4e1517d94fc88d$var$lookup[num >> 6 & 0x3F] + $ac4e1517d94fc88d$var$lookup[num & 0x3F];
}
function $ac4e1517d94fc88d$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($ac4e1517d94fc88d$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $ac4e1517d94fc88d$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($ac4e1517d94fc88d$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($ac4e1517d94fc88d$var$lookup[tmp >> 2] + $ac4e1517d94fc88d$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($ac4e1517d94fc88d$var$lookup[tmp >> 10] + $ac4e1517d94fc88d$var$lookup[tmp >> 4 & 0x3F] + $ac4e1517d94fc88d$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("dtm0F", function(module, exports) {

$parcel$export(module.exports, "read", () => $9cef0e7dfb405399$export$aafa59e2e03f2942, (v) => $9cef0e7dfb405399$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $9cef0e7dfb405399$export$68d8715fc104d294, (v) => $9cef0e7dfb405399$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $9cef0e7dfb405399$export$aafa59e2e03f2942;
var $9cef0e7dfb405399$export$68d8715fc104d294;
$9cef0e7dfb405399$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$9cef0e7dfb405399$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("ebECT", function(module, exports) {

$parcel$export(module.exports, "is_object", () => $a5419b4c951c3ef9$export$167528a9b5133c2f);
const $a5419b4c951c3ef9$export$167528a9b5133c2f = function(obj) {
    return typeof obj === "object" && obj !== null && !Array.isArray(obj);
};

});


parcelRegister("i9Ykp", function(module, exports) {

$parcel$export(module.exports, "init_state", () => $d387dd31df09f2af$export$588199c25dc0cbed);

var $3w8eF = parcelRequire("3w8eF");

var $7zlKx = parcelRequire("7zlKx");
var $d387dd31df09f2af$require$Buffer = $7zlKx.Buffer;
// white space characters
// https://en.wikipedia.org/wiki/Whitespace_character
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions/Character_Classes#Types
// \f\n\r\t\v\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff
const $d387dd31df09f2af$var$np = 12;
const $d387dd31df09f2af$var$cr = 13; // `\r`, carriage return, 0x0D in hexadécimal, 13 in decimal
const $d387dd31df09f2af$var$nl = 10; // `\n`, newline, 0x0A in hexadecimal, 10 in decimal
const $d387dd31df09f2af$var$space = 32;
const $d387dd31df09f2af$var$tab = 9;
const $d387dd31df09f2af$export$588199c25dc0cbed = function(options) {
    return {
        bomSkipped: false,
        bufBytesStart: 0,
        castField: options.cast_function,
        commenting: false,
        // Current error encountered by a record
        error: undefined,
        enabled: options.from_line === 1,
        escaping: false,
        escapeIsQuote: $d387dd31df09f2af$require$Buffer.isBuffer(options.escape) && $d387dd31df09f2af$require$Buffer.isBuffer(options.quote) && $d387dd31df09f2af$require$Buffer.compare(options.escape, options.quote) === 0,
        // columns can be `false`, `true`, `Array`
        expectedRecordLength: Array.isArray(options.columns) ? options.columns.length : undefined,
        field: new (0, $3w8eF.default)(20),
        firstLineToHeaders: options.cast_first_line_to_header,
        needMoreDataSize: Math.max(// Skip if the remaining buffer smaller than comment
        options.comment !== null ? options.comment.length : 0, // Skip if the remaining buffer can be delimiter
        ...options.delimiter.map((delimiter)=>delimiter.length), // Skip if the remaining buffer can be escape sequence
        options.quote !== null ? options.quote.length : 0),
        previousBuf: undefined,
        quoting: false,
        stop: false,
        rawBuffer: new (0, $3w8eF.default)(100),
        record: [],
        recordHasError: false,
        record_length: 0,
        recordDelimiterMaxLength: options.record_delimiter.length === 0 ? 0 : Math.max(...options.record_delimiter.map((v)=>v.length)),
        trimChars: [
            $d387dd31df09f2af$require$Buffer.from(" ", options.encoding)[0],
            $d387dd31df09f2af$require$Buffer.from("	", options.encoding)[0]
        ],
        wasQuoting: false,
        wasRowDelimiter: false,
        timchars: [
            $d387dd31df09f2af$require$Buffer.from($d387dd31df09f2af$require$Buffer.from([
                $d387dd31df09f2af$var$cr
            ], "utf8").toString(), options.encoding),
            $d387dd31df09f2af$require$Buffer.from($d387dd31df09f2af$require$Buffer.from([
                $d387dd31df09f2af$var$nl
            ], "utf8").toString(), options.encoding),
            $d387dd31df09f2af$require$Buffer.from($d387dd31df09f2af$require$Buffer.from([
                $d387dd31df09f2af$var$np
            ], "utf8").toString(), options.encoding),
            $d387dd31df09f2af$require$Buffer.from($d387dd31df09f2af$require$Buffer.from([
                $d387dd31df09f2af$var$space
            ], "utf8").toString(), options.encoding),
            $d387dd31df09f2af$require$Buffer.from($d387dd31df09f2af$require$Buffer.from([
                $d387dd31df09f2af$var$tab
            ], "utf8").toString(), options.encoding)
        ]
    };
};

});
parcelRegister("3w8eF", function(module, exports) {

$parcel$export(module.exports, "default", () => $28fabfb0f95d0a07$export$2e2bcd8739ae039);

var $7zlKx = parcelRequire("7zlKx");
var $28fabfb0f95d0a07$require$Buffer = $7zlKx.Buffer;
class $28fabfb0f95d0a07$var$ResizeableBuffer {
    constructor(size = 100){
        this.size = size;
        this.length = 0;
        this.buf = $28fabfb0f95d0a07$require$Buffer.allocUnsafe(size);
    }
    prepend(val) {
        if ($28fabfb0f95d0a07$require$Buffer.isBuffer(val)) {
            const length = this.length + val.length;
            if (length >= this.size) {
                this.resize();
                if (length >= this.size) throw Error("INVALID_BUFFER_STATE");
            }
            const buf = this.buf;
            this.buf = $28fabfb0f95d0a07$require$Buffer.allocUnsafe(this.size);
            val.copy(this.buf, 0);
            buf.copy(this.buf, val.length);
            this.length += val.length;
        } else {
            const length = this.length++;
            if (length === this.size) this.resize();
            const buf = this.clone();
            this.buf[0] = val;
            buf.copy(this.buf, 1, 0, length);
        }
    }
    append(val) {
        const length = this.length++;
        if (length === this.size) this.resize();
        this.buf[length] = val;
    }
    clone() {
        return $28fabfb0f95d0a07$require$Buffer.from(this.buf.slice(0, this.length));
    }
    resize() {
        const length = this.length;
        this.size = this.size * 2;
        const buf = $28fabfb0f95d0a07$require$Buffer.allocUnsafe(this.size);
        this.buf.copy(buf, 0, 0, length);
        this.buf = buf;
    }
    toString(encoding) {
        if (encoding) return this.buf.slice(0, this.length).toString(encoding);
        else return Uint8Array.prototype.slice.call(this.buf.slice(0, this.length));
    }
    toJSON() {
        return this.toString("utf8");
    }
    reset() {
        this.length = 0;
    }
}
var $28fabfb0f95d0a07$export$2e2bcd8739ae039 = $28fabfb0f95d0a07$var$ResizeableBuffer;

});


parcelRegister("7EamI", function(module, exports) {

$parcel$export(module.exports, "normalize_options", () => $59144f31d6e4281a$export$ccfebcb248d28a57);

var $4oc3f = parcelRequire("4oc3f");

var $99pXl = parcelRequire("99pXl");

var $2JeRS = parcelRequire("2JeRS");

var $7zlKx = parcelRequire("7zlKx");
var $59144f31d6e4281a$require$Buffer = $7zlKx.Buffer;
const $59144f31d6e4281a$export$ccfebcb248d28a57 = function(opts) {
    const options = {};
    // Merge with user options
    for(const opt in opts)options[(0, $2JeRS.underscore)(opt)] = opts[opt];
    // Normalize option `encoding`
    // Note: defined first because other options depends on it
    // to convert chars/strings into buffers.
    if (options.encoding === undefined || options.encoding === true) options.encoding = "utf8";
    else if (options.encoding === null || options.encoding === false) options.encoding = null;
    else if (typeof options.encoding !== "string" && options.encoding !== null) throw new (0, $99pXl.CsvError)("CSV_INVALID_OPTION_ENCODING", [
        "Invalid option encoding:",
        "encoding must be a string or null to return a buffer,",
        `got ${JSON.stringify(options.encoding)}`
    ], options);
    // Normalize option `bom`
    if (options.bom === undefined || options.bom === null || options.bom === false) options.bom = false;
    else if (options.bom !== true) throw new (0, $99pXl.CsvError)("CSV_INVALID_OPTION_BOM", [
        "Invalid option bom:",
        "bom must be true,",
        `got ${JSON.stringify(options.bom)}`
    ], options);
    // Normalize option `cast`
    options.cast_function = null;
    if (options.cast === undefined || options.cast === null || options.cast === false || options.cast === "") options.cast = undefined;
    else if (typeof options.cast === "function") {
        options.cast_function = options.cast;
        options.cast = true;
    } else if (options.cast !== true) throw new (0, $99pXl.CsvError)("CSV_INVALID_OPTION_CAST", [
        "Invalid option cast:",
        "cast must be true or a function,",
        `got ${JSON.stringify(options.cast)}`
    ], options);
    // Normalize option `cast_date`
    if (options.cast_date === undefined || options.cast_date === null || options.cast_date === false || options.cast_date === "") options.cast_date = false;
    else if (options.cast_date === true) options.cast_date = function(value) {
        const date = Date.parse(value);
        return !isNaN(date) ? new Date(date) : value;
    };
    else if (typeof options.cast_date !== "function") throw new (0, $99pXl.CsvError)("CSV_INVALID_OPTION_CAST_DATE", [
        "Invalid option cast_date:",
        "cast_date must be true or a function,",
        `got ${JSON.stringify(options.cast_date)}`
    ], options);
    // Normalize option `columns`
    options.cast_first_line_to_header = null;
    if (options.columns === true) // Fields in the first line are converted as-is to columns
    options.cast_first_line_to_header = undefined;
    else if (typeof options.columns === "function") {
        options.cast_first_line_to_header = options.columns;
        options.columns = true;
    } else if (Array.isArray(options.columns)) options.columns = (0, $4oc3f.normalize_columns_array)(options.columns);
    else if (options.columns === undefined || options.columns === null || options.columns === false) options.columns = false;
    else throw new (0, $99pXl.CsvError)("CSV_INVALID_OPTION_COLUMNS", [
        "Invalid option columns:",
        "expect an array, a function or true,",
        `got ${JSON.stringify(options.columns)}`
    ], options);
    // Normalize option `group_columns_by_name`
    if (options.group_columns_by_name === undefined || options.group_columns_by_name === null || options.group_columns_by_name === false) options.group_columns_by_name = false;
    else if (options.group_columns_by_name !== true) throw new (0, $99pXl.CsvError)("CSV_INVALID_OPTION_GROUP_COLUMNS_BY_NAME", [
        "Invalid option group_columns_by_name:",
        "expect an boolean,",
        `got ${JSON.stringify(options.group_columns_by_name)}`
    ], options);
    else if (options.columns === false) throw new (0, $99pXl.CsvError)("CSV_INVALID_OPTION_GROUP_COLUMNS_BY_NAME", [
        "Invalid option group_columns_by_name:",
        "the `columns` mode must be activated."
    ], options);
    // Normalize option `comment`
    if (options.comment === undefined || options.comment === null || options.comment === false || options.comment === "") options.comment = null;
    else {
        if (typeof options.comment === "string") options.comment = $59144f31d6e4281a$require$Buffer.from(options.comment, options.encoding);
        if (!$59144f31d6e4281a$require$Buffer.isBuffer(options.comment)) throw new (0, $99pXl.CsvError)("CSV_INVALID_OPTION_COMMENT", [
            "Invalid option comment:",
            "comment must be a buffer or a string,",
            `got ${JSON.stringify(options.comment)}`
        ], options);
    }
    // Normalize option `comment_no_infix`
    if (options.comment_no_infix === undefined || options.comment_no_infix === null || options.comment_no_infix === false) options.comment_no_infix = false;
    else if (options.comment_no_infix !== true) throw new (0, $99pXl.CsvError)("CSV_INVALID_OPTION_COMMENT", [
        "Invalid option comment_no_infix:",
        "value must be a boolean,",
        `got ${JSON.stringify(options.comment_no_infix)}`
    ], options);
    // Normalize option `delimiter`
    const delimiter_json = JSON.stringify(options.delimiter);
    if (!Array.isArray(options.delimiter)) options.delimiter = [
        options.delimiter
    ];
    if (options.delimiter.length === 0) throw new (0, $99pXl.CsvError)("CSV_INVALID_OPTION_DELIMITER", [
        "Invalid option delimiter:",
        "delimiter must be a non empty string or buffer or array of string|buffer,",
        `got ${delimiter_json}`
    ], options);
    options.delimiter = options.delimiter.map(function(delimiter) {
        if (delimiter === undefined || delimiter === null || delimiter === false) return $59144f31d6e4281a$require$Buffer.from(",", options.encoding);
        if (typeof delimiter === "string") delimiter = $59144f31d6e4281a$require$Buffer.from(delimiter, options.encoding);
        if (!$59144f31d6e4281a$require$Buffer.isBuffer(delimiter) || delimiter.length === 0) throw new (0, $99pXl.CsvError)("CSV_INVALID_OPTION_DELIMITER", [
            "Invalid option delimiter:",
            "delimiter must be a non empty string or buffer or array of string|buffer,",
            `got ${delimiter_json}`
        ], options);
        return delimiter;
    });
    // Normalize option `escape`
    if (options.escape === undefined || options.escape === true) options.escape = $59144f31d6e4281a$require$Buffer.from('"', options.encoding);
    else if (typeof options.escape === "string") options.escape = $59144f31d6e4281a$require$Buffer.from(options.escape, options.encoding);
    else if (options.escape === null || options.escape === false) options.escape = null;
    if (options.escape !== null) {
        if (!$59144f31d6e4281a$require$Buffer.isBuffer(options.escape)) throw new Error(`Invalid Option: escape must be a buffer, a string or a boolean, got ${JSON.stringify(options.escape)}`);
    }
    // Normalize option `from`
    if (options.from === undefined || options.from === null) options.from = 1;
    else {
        if (typeof options.from === "string" && /\d+/.test(options.from)) options.from = parseInt(options.from);
        if (Number.isInteger(options.from)) {
            if (options.from < 0) throw new Error(`Invalid Option: from must be a positive integer, got ${JSON.stringify(opts.from)}`);
        } else throw new Error(`Invalid Option: from must be an integer, got ${JSON.stringify(options.from)}`);
    }
    // Normalize option `from_line`
    if (options.from_line === undefined || options.from_line === null) options.from_line = 1;
    else {
        if (typeof options.from_line === "string" && /\d+/.test(options.from_line)) options.from_line = parseInt(options.from_line);
        if (Number.isInteger(options.from_line)) {
            if (options.from_line <= 0) throw new Error(`Invalid Option: from_line must be a positive integer greater than 0, got ${JSON.stringify(opts.from_line)}`);
        } else throw new Error(`Invalid Option: from_line must be an integer, got ${JSON.stringify(opts.from_line)}`);
    }
    // Normalize options `ignore_last_delimiters`
    if (options.ignore_last_delimiters === undefined || options.ignore_last_delimiters === null) options.ignore_last_delimiters = false;
    else if (typeof options.ignore_last_delimiters === "number") {
        options.ignore_last_delimiters = Math.floor(options.ignore_last_delimiters);
        if (options.ignore_last_delimiters === 0) options.ignore_last_delimiters = false;
    } else if (typeof options.ignore_last_delimiters !== "boolean") throw new (0, $99pXl.CsvError)("CSV_INVALID_OPTION_IGNORE_LAST_DELIMITERS", [
        "Invalid option `ignore_last_delimiters`:",
        "the value must be a boolean value or an integer,",
        `got ${JSON.stringify(options.ignore_last_delimiters)}`
    ], options);
    if (options.ignore_last_delimiters === true && options.columns === false) throw new (0, $99pXl.CsvError)("CSV_IGNORE_LAST_DELIMITERS_REQUIRES_COLUMNS", [
        "The option `ignore_last_delimiters`",
        "requires the activation of the `columns` option"
    ], options);
    // Normalize option `info`
    if (options.info === undefined || options.info === null || options.info === false) options.info = false;
    else if (options.info !== true) throw new Error(`Invalid Option: info must be true, got ${JSON.stringify(options.info)}`);
    // Normalize option `max_record_size`
    if (options.max_record_size === undefined || options.max_record_size === null || options.max_record_size === false) options.max_record_size = 0;
    else if (Number.isInteger(options.max_record_size) && options.max_record_size >= 0) ;
    else if (typeof options.max_record_size === "string" && /\d+/.test(options.max_record_size)) options.max_record_size = parseInt(options.max_record_size);
    else throw new Error(`Invalid Option: max_record_size must be a positive integer, got ${JSON.stringify(options.max_record_size)}`);
    // Normalize option `objname`
    if (options.objname === undefined || options.objname === null || options.objname === false) options.objname = undefined;
    else if ($59144f31d6e4281a$require$Buffer.isBuffer(options.objname)) {
        if (options.objname.length === 0) throw new Error(`Invalid Option: objname must be a non empty buffer`);
        if (options.encoding === null) ;
        else options.objname = options.objname.toString(options.encoding);
    } else if (typeof options.objname === "string") {
        if (options.objname.length === 0) throw new Error(`Invalid Option: objname must be a non empty string`);
    // Great, nothing to do
    } else if (typeof options.objname === "number") ;
    else throw new Error(`Invalid Option: objname must be a string or a buffer, got ${options.objname}`);
    if (options.objname !== undefined) {
        if (typeof options.objname === "number") {
            if (options.columns !== false) throw Error("Invalid Option: objname index cannot be combined with columns or be defined as a field");
        } else {
            if (options.columns === false) throw Error("Invalid Option: objname field must be combined with columns or be defined as an index");
        }
    }
    // Normalize option `on_record`
    if (options.on_record === undefined || options.on_record === null) options.on_record = undefined;
    else if (typeof options.on_record !== "function") throw new (0, $99pXl.CsvError)("CSV_INVALID_OPTION_ON_RECORD", [
        "Invalid option `on_record`:",
        "expect a function,",
        `got ${JSON.stringify(options.on_record)}`
    ], options);
    // Normalize option `on_skip`
    // options.on_skip ??= (err, chunk) => {
    //   this.emit('skip', err, chunk);
    // };
    if (options.on_skip !== undefined && options.on_skip !== null && typeof options.on_skip !== "function") throw new Error(`Invalid Option: on_skip must be a function, got ${JSON.stringify(options.on_skip)}`);
    // Normalize option `quote`
    if (options.quote === null || options.quote === false || options.quote === "") options.quote = null;
    else {
        if (options.quote === undefined || options.quote === true) options.quote = $59144f31d6e4281a$require$Buffer.from('"', options.encoding);
        else if (typeof options.quote === "string") options.quote = $59144f31d6e4281a$require$Buffer.from(options.quote, options.encoding);
        if (!$59144f31d6e4281a$require$Buffer.isBuffer(options.quote)) throw new Error(`Invalid Option: quote must be a buffer or a string, got ${JSON.stringify(options.quote)}`);
    }
    // Normalize option `raw`
    if (options.raw === undefined || options.raw === null || options.raw === false) options.raw = false;
    else if (options.raw !== true) throw new Error(`Invalid Option: raw must be true, got ${JSON.stringify(options.raw)}`);
    // Normalize option `record_delimiter`
    if (options.record_delimiter === undefined) options.record_delimiter = [];
    else if (typeof options.record_delimiter === "string" || $59144f31d6e4281a$require$Buffer.isBuffer(options.record_delimiter)) {
        if (options.record_delimiter.length === 0) throw new (0, $99pXl.CsvError)("CSV_INVALID_OPTION_RECORD_DELIMITER", [
            "Invalid option `record_delimiter`:",
            "value must be a non empty string or buffer,",
            `got ${JSON.stringify(options.record_delimiter)}`
        ], options);
        options.record_delimiter = [
            options.record_delimiter
        ];
    } else if (!Array.isArray(options.record_delimiter)) throw new (0, $99pXl.CsvError)("CSV_INVALID_OPTION_RECORD_DELIMITER", [
        "Invalid option `record_delimiter`:",
        "value must be a string, a buffer or array of string|buffer,",
        `got ${JSON.stringify(options.record_delimiter)}`
    ], options);
    options.record_delimiter = options.record_delimiter.map(function(rd, i) {
        if (typeof rd !== "string" && !$59144f31d6e4281a$require$Buffer.isBuffer(rd)) throw new (0, $99pXl.CsvError)("CSV_INVALID_OPTION_RECORD_DELIMITER", [
            "Invalid option `record_delimiter`:",
            "value must be a string, a buffer or array of string|buffer",
            `at index ${i},`,
            `got ${JSON.stringify(rd)}`
        ], options);
        else if (rd.length === 0) throw new (0, $99pXl.CsvError)("CSV_INVALID_OPTION_RECORD_DELIMITER", [
            "Invalid option `record_delimiter`:",
            "value must be a non empty string or buffer",
            `at index ${i},`,
            `got ${JSON.stringify(rd)}`
        ], options);
        if (typeof rd === "string") rd = $59144f31d6e4281a$require$Buffer.from(rd, options.encoding);
        return rd;
    });
    // Normalize option `relax_column_count`
    if (typeof options.relax_column_count === "boolean") ;
    else if (options.relax_column_count === undefined || options.relax_column_count === null) options.relax_column_count = false;
    else throw new Error(`Invalid Option: relax_column_count must be a boolean, got ${JSON.stringify(options.relax_column_count)}`);
    if (typeof options.relax_column_count_less === "boolean") ;
    else if (options.relax_column_count_less === undefined || options.relax_column_count_less === null) options.relax_column_count_less = false;
    else throw new Error(`Invalid Option: relax_column_count_less must be a boolean, got ${JSON.stringify(options.relax_column_count_less)}`);
    if (typeof options.relax_column_count_more === "boolean") ;
    else if (options.relax_column_count_more === undefined || options.relax_column_count_more === null) options.relax_column_count_more = false;
    else throw new Error(`Invalid Option: relax_column_count_more must be a boolean, got ${JSON.stringify(options.relax_column_count_more)}`);
    // Normalize option `relax_quotes`
    if (typeof options.relax_quotes === "boolean") ;
    else if (options.relax_quotes === undefined || options.relax_quotes === null) options.relax_quotes = false;
    else throw new Error(`Invalid Option: relax_quotes must be a boolean, got ${JSON.stringify(options.relax_quotes)}`);
    // Normalize option `skip_empty_lines`
    if (typeof options.skip_empty_lines === "boolean") ;
    else if (options.skip_empty_lines === undefined || options.skip_empty_lines === null) options.skip_empty_lines = false;
    else throw new Error(`Invalid Option: skip_empty_lines must be a boolean, got ${JSON.stringify(options.skip_empty_lines)}`);
    // Normalize option `skip_records_with_empty_values`
    if (typeof options.skip_records_with_empty_values === "boolean") ;
    else if (options.skip_records_with_empty_values === undefined || options.skip_records_with_empty_values === null) options.skip_records_with_empty_values = false;
    else throw new Error(`Invalid Option: skip_records_with_empty_values must be a boolean, got ${JSON.stringify(options.skip_records_with_empty_values)}`);
    // Normalize option `skip_records_with_error`
    if (typeof options.skip_records_with_error === "boolean") ;
    else if (options.skip_records_with_error === undefined || options.skip_records_with_error === null) options.skip_records_with_error = false;
    else throw new Error(`Invalid Option: skip_records_with_error must be a boolean, got ${JSON.stringify(options.skip_records_with_error)}`);
    // Normalize option `rtrim`
    if (options.rtrim === undefined || options.rtrim === null || options.rtrim === false) options.rtrim = false;
    else if (options.rtrim !== true) throw new Error(`Invalid Option: rtrim must be a boolean, got ${JSON.stringify(options.rtrim)}`);
    // Normalize option `ltrim`
    if (options.ltrim === undefined || options.ltrim === null || options.ltrim === false) options.ltrim = false;
    else if (options.ltrim !== true) throw new Error(`Invalid Option: ltrim must be a boolean, got ${JSON.stringify(options.ltrim)}`);
    // Normalize option `trim`
    if (options.trim === undefined || options.trim === null || options.trim === false) options.trim = false;
    else if (options.trim !== true) throw new Error(`Invalid Option: trim must be a boolean, got ${JSON.stringify(options.trim)}`);
    // Normalize options `trim`, `ltrim` and `rtrim`
    if (options.trim === true && opts.ltrim !== false) options.ltrim = true;
    else if (options.ltrim !== true) options.ltrim = false;
    if (options.trim === true && opts.rtrim !== false) options.rtrim = true;
    else if (options.rtrim !== true) options.rtrim = false;
    // Normalize option `to`
    if (options.to === undefined || options.to === null) options.to = -1;
    else {
        if (typeof options.to === "string" && /\d+/.test(options.to)) options.to = parseInt(options.to);
        if (Number.isInteger(options.to)) {
            if (options.to <= 0) throw new Error(`Invalid Option: to must be a positive integer greater than 0, got ${JSON.stringify(opts.to)}`);
        } else throw new Error(`Invalid Option: to must be an integer, got ${JSON.stringify(opts.to)}`);
    }
    // Normalize option `to_line`
    if (options.to_line === undefined || options.to_line === null) options.to_line = -1;
    else {
        if (typeof options.to_line === "string" && /\d+/.test(options.to_line)) options.to_line = parseInt(options.to_line);
        if (Number.isInteger(options.to_line)) {
            if (options.to_line <= 0) throw new Error(`Invalid Option: to_line must be a positive integer greater than 0, got ${JSON.stringify(opts.to_line)}`);
        } else throw new Error(`Invalid Option: to_line must be an integer, got ${JSON.stringify(opts.to_line)}`);
    }
    return options;
};

});
parcelRegister("2JeRS", function(module, exports) {

$parcel$export(module.exports, "underscore", () => $1fcb5131e8669573$export$730f2a930033e8f0);
const $1fcb5131e8669573$export$730f2a930033e8f0 = function(str) {
    return str.replace(/([A-Z])/g, function(_, match) {
        return "_" + match.toLowerCase();
    });
};

});





parcelRegister("9mfNp", function(module, exports) {
/** @license
 *
 *     Colour Palette Generator script.
 *     Copyright (c) 2014 Google Inc.
 *
 *     Licensed under the Apache License, Version 2.0 (the "License"); you may
 *     not use this file except in compliance with the License.  You may
 *     obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 *     Unless required by applicable law or agreed to in writing, software
 *     distributed under the License is distributed on an "AS IS" BASIS,
 *     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
 *     implied.  See the License for the specific language governing
 *     permissions and limitations under the License.
 *
 * Furthermore, ColorBrewer colour schemes are covered by the following:
 *
 *     Copyright (c) 2002 Cynthia Brewer, Mark Harrower, and
 *                        The Pennsylvania State University.
 *
 *     Licensed under the Apache License, Version 2.0 (the "License"); you may
 *     not use this file except in compliance with the License. You may obtain
 *     a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 *     Unless required by applicable law or agreed to in writing, software
 *     distributed under the License is distributed on an "AS IS" BASIS,
 *     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
 *     implied. See the License for the specific language governing
 *     permissions and limitations under the License.
 *
 *     Redistribution and use in source and binary forms, with or without
 *     modification, are permitted provided that the following conditions are
 *     met:
 *
 *     1. Redistributions as source code must retain the above copyright
 *     notice, this list of conditions and the following disclaimer.
 *
 *     2. The end-user documentation included with the redistribution, if any,
 *     must include the following acknowledgment: "This product includes color
 *     specifications and designs developed by Cynthia Brewer
 *     (http://colorbrewer.org/)." Alternately, this acknowledgment may appear
 *     in the software itself, if and wherever such third-party
 *     acknowledgments normally appear.
 *
 *     4. The name "ColorBrewer" must not be used to endorse or promote products
 *     derived from this software without prior written permission. For written
 *     permission, please contact Cynthia Brewer at cbrewer@psu.edu.
 *
 *     5. Products derived from this software may not be called "ColorBrewer",
 *     nor may "ColorBrewer" appear in their name, without prior written
 *     permission of Cynthia Brewer.
 *
 * Furthermore, Solarized colour schemes are covered by the following:
 *
 *     Copyright (c) 2011 Ethan Schoonover
 *
 *     Permission is hereby granted, free of charge, to any person obtaining
 *     a copy of this software and associated documentation files (the
 *     "Software"), to deal in the Software without restriction, including
 *     without limitation the rights to use, copy, modify, merge, publish,
 *     distribute, sublicense, and/or sell copies of the Software, and to
 *     permit persons to whom the Software is furnished to do so, subject to
 *     the following conditions:
 *
 *     The above copyright notice and this permission notice shall be included
 *     in all copies or substantial portions of the Software.
 *
 *     THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 *     OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 *     MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 *     NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 *     LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 *     OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 *     WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ "use strict";
var $6d026be3651d0191$var$palette = function() {
    var proto = Array.prototype;
    var slice = function(arr, opt_begin, opt_end) {
        return proto.slice.apply(arr, proto.slice.call(arguments, 1));
    };
    var extend = function(arr, arr2) {
        return proto.push.apply(arr, arr2);
    };
    var function_type = "function";
    var INF = 1000000000; // As far as we're concerned, that's infinity. ;)
    /**
   * Generate a colour palette from given scheme.
   *
   * If scheme argument is not a function it is passed to palettes.listSchemes
   * function (along with the number argument).  This may result in an array
   * of more than one available scheme.  If that is the case, scheme at
   * opt_index position is taken.
   *
   * This allows using different palettes for different data without having to
   * name the schemes specifically, for example:
   *
   *     palette_for_foo = palette('sequential', 10, 0);
   *     palette_for_bar = palette('sequential', 10, 1);
   *     palette_for_baz = palette('sequential', 10, 2);
   *
   * @param {!palette.SchemeType|string|palette.Palette} scheme Scheme to
   *     generate palette for.  Either a function constructed with
   *     palette.Scheme object, or anything that palette.listSchemes accepts
   *     as name argument.
   * @param {number} number Number of colours to return.  If negative, absolute
   *     value is taken and colours will be returned in reverse order.
   * @param {number=} opt_index If scheme is a name of a group or an array and
   *     results in more than one scheme, index of the scheme to use.  The
   *     index wraps around.
   * @param {...*} varargs Additional arguments to pass to palette or colour
   *     generator (if the chosen scheme uses those).
   * @return {Array<string>} Array of abs(number) 'RRGGBB' strings or null if
   *     no matching scheme was found.
   */ var palette = function(scheme, number, opt_index, varargs) {
        number |= 0;
        if (number == 0) return [];
        if (typeof scheme !== function_type) {
            var arr = palette.listSchemes(/** @type {string|palette.Palette} */ scheme, number);
            if (!arr.length) return null;
            scheme = arr[(opt_index || 0) % arr.length];
        }
        var args = slice(arguments, 2);
        args[0] = number;
        return scheme.apply(scheme, args);
    };
    /**
   * Returns a callable colour scheme object.
   *
   * Just after being created, the scheme has no colour palettes and no way of
   * generating any, thus generate method will return null.  To turn scheme
   * into a useful object, addPalette, addPalettes or setColorFunction methods
   * need to be used.
   *
   * To generate a colour palette with given number colours using function
   * returned by this method, just call it with desired number of colours.
   *
   * Since this function *returns* a callable object, it must *not* be used
   * with the new operator.
   *
   * @param {string} name Name of the scheme.
   * @param {string|!Array<string>=} opt_groups A group name or list of
   *     groups the scheme should be categorised under.  Three typical groups
   *     to use are 'qualitative', 'sequential' and 'diverging', but any
   *     groups may be created.
   * @return {!palette.SchemeType} A colour palette generator function, which
   *     in addition has methods and properties like a regular object.  Think
   *     of it as a callable object.
   */ palette.Scheme = function(name, opt_groups) {
        /**
     * A map from a number to a colour palettes with given number of colours.
     * @type {!Object<number, palette.Palette>}
     */ var palettes = {};
        /**
     * The biggest palette in palettes map.
     * @type {number}
     */ var palettes_max = 0;
        /**
     * The smallest palette in palettes map.
     * @type {number}
     */ var palettes_min = INF;
        var makeGenerator = function() {
            if (arguments.length <= 1) return self.color_func.bind(self);
            else {
                var args = slice(arguments);
                return function(x) {
                    args[0] = x;
                    return self.color_func.apply(self, args);
                };
            }
        };
        /**
     * Generate a colour palette from the scheme.
     *
     * If there was a palette added with addPalette (or addPalettes) with
     * enough colours, that palette will be used.  Otherwise, if colour
     * function has been set using setColorFunction method, that function will
     * be used to generate the palette.  Otherwise null is returned.
     *
     * @param {number} number Number of colours to return.  If negative,
     *     absolute value is taken and colours will be returned in reverse
     *     order.
     * @param {...*} varargs Additional arguments to pass to palette or colour
     *     generator (if the chosen scheme uses those).
     */ var self = function(number, varargs) {
            number |= 0;
            if (!number) return [];
            var _number = number;
            number = Math.abs(number);
            if (number <= palettes_max) {
                for(var i = Math.max(number, palettes_min); !(i in palettes); ++i);
                var colors = palettes[i];
                if (i > number) {
                    var take_head = "shrinking_takes_head" in colors ? colors.shrinking_takes_head : self.shrinking_takes_head;
                    if (take_head) {
                        colors = colors.slice(0, number);
                        i = number;
                    } else return palette.generate(function(x) {
                        return colors[Math.round(x)];
                    }, _number, 0, colors.length - 1);
                }
                colors = colors.slice();
                if (_number < 0) colors.reverse();
                return colors;
            } else if (self.color_func) return palette.generate(makeGenerator.apply(self, arguments), _number, 0, 1, self.color_func_cyclic);
            else return null;
        };
        /**
     * The name of the palette.
     * @type {string}
     */ self.scheme_name = name;
        /**
     * A list of groups the palette belongs to.
     * @type {!Array<string>}
     */ self.groups = opt_groups ? typeof opt_groups === "string" ? [
            opt_groups
        ] : opt_groups : [];
        /**
     * The biggest palette this scheme can generate.
     * @type {number}
     */ self.max = 0;
        /**
     * The biggest palette this scheme can generate that is colour-blind
     * friendly.
     * @type {number}
     */ self.cbf_max = INF;
        /**
     * Adds a colour palette to the colour scheme.
     *
     * @param {palette.Palette} palette An array of 'RRGGBB' strings
     *     representing the palette to add.
     * @param {boolean=} opt_is_cbf Whether the palette is colourblind friendly.
     */ self.addPalette = function(palette, opt_is_cbf) {
            var len = palette.length;
            if (len) {
                palettes[len] = palette;
                palettes_min = Math.min(palettes_min, len);
                palettes_max = Math.max(palettes_max, len);
                self.max = Math.max(self.max, len);
                if (!opt_is_cbf && len != 1) self.cbf_max = Math.min(self.cbf_max, len - 1);
            }
        };
        /**
     * Adds number of colour palettes to the colour scheme.
     *
     * @param {palette.PalettesList} palettes A map or an array of colour
     *     palettes to add.  If map, i.e.  object, is used, properties should
     *     use integer property names.
     * @param {number=} opt_max Size of the biggest palette in palettes set.
     *     If not set, palettes must have a length property which will be used.
     * @param {number=} opt_cbf_max Size of the biggest palette which is still
     *     colourblind friendly.  1 by default.
     */ self.addPalettes = function(palettes, opt_max, opt_cbf_max) {
            opt_max = opt_max || palettes.length;
            for(var i = 0; i < opt_max; ++i)if (i in palettes) self.addPalette(palettes[i], true);
            self.cbf_max = Math.min(self.cbf_max, opt_cbf_max || 1);
        };
        /**
     * Enable shrinking palettes taking head of the list of colours.
     *
     * When user requests n-colour palette but the smallest palette added with
     * addPalette (or addPalettes) is m-colour one (where n < m), n colours
     * across the palette will be returned.  For example:
     *     var ex = palette.Scheme('ex');
     *     ex.addPalette(['000000', 'bcbcbc', 'ffffff']);
     *     var pal = ex(2);
     *     // pal == ['000000', 'ffffff']
     *
     * This works for palettes where the distance between colours is
     * correlated to distance in the palette array, which is true in gradients
     * such as the one above.
     *
     * To turn this feature off shrinkByTakingHead can be set to true either
     * for all palettes in the scheme (if opt_idx is not given) or for palette
     * with given number of colours only.  In general, setting the option for
     * given palette overwrites whatever has been set for the scheme.  The
     * default, as described above, is false.
     *
     * Alternatively, the feature can be enabled by setting shrinking_takes_head
     * property for the palette Array or the scheme object.
     *
     * For example, all of the below give equivalent results:
     *     var pal = ['ff0000', '00ff00', '0000ff'];
     *
     *     var ex = palette.Scheme('ex');
     *     ex.addPalette(pal);               // ex(2) == ['ff0000', '0000ff']
     *     ex.shrinkByTakingHead(true);      // ex(2) == ['ff0000', '00ff00']
     *
     *     ex = palette.Scheme('ex');
     *     ex.addPalette(pal);               // ex(2) == ['ff0000', '0000ff']
     *     ex.shrinkByTakingHead(true, 3);   // ex(2) == ['ff0000', '00ff00']
     *
     *     ex = palette.Scheme('ex');
     *     ex.addPalette(pal);
     *     ex.addPalette(pal);               // ex(2) == ['ff0000', '0000ff']
     *     pal.shrinking_takes_head = true;  // ex(2) == ['ff0000', '00ff00']
     *
     * @param {boolean} enabled Whether to enable or disable the “shrinking
     *     takes head” feature.  It is disabled by default.
     * @param {number=} opt_idx If given, the “shrinking takes head” option
     *     for palette with given number of colours is set.  If such palette
     *     does not exist, nothing happens.
     */ self.shrinkByTakingHead = function(enabled, opt_idx) {
            if (opt_idx !== void 0) {
                if (opt_idx in palettes) palettes[opt_idx].shrinking_takes_head = !!enabled;
            } else self.shrinking_takes_head = !!enabled;
        };
        /**
     * Sets a colour generation function of the colour scheme.
     *
     * The function must accept a singe number argument whose value can be from
     * 0.0 to 1.0, and return a colour as an 'RRGGBB' string.  This function
     * will be used when generating palettes, i.e. if 11-colour palette is
     * requested, this function will be called with arguments 0.0, 0.1, …, 1.0.
     *
     * If the palette generated by the function is colourblind friendly,
     * opt_is_cbf should be set to true.
     *
     * In some cases, it is not desirable to reach 1.0 when generating
     * a palette.  This happens for hue-rainbows where the 0–1 range corresponds
     * to a 0°–360° range in hues, and since hue at 0° is the same as at 360°,
     * it's desired to stop short the end of the range when generating
     * a palette.  To accomplish this, opt_cyclic should be set to true.
     *
     * @param {palette.ColorFunction} func A colour generator function.
     * @param {boolean=} opt_is_cbf Whether palette generate with the function
     *     is colour-blind friendly.
     * @param {boolean=} opt_cyclic Whether colour at 0.0 is the same as the
     *     one at 1.0.
     */ self.setColorFunction = function(func, opt_is_cbf, opt_cyclic) {
            self.color_func = func;
            self.color_func_cyclic = !!opt_cyclic;
            self.max = INF;
            if (!opt_is_cbf && self.cbf_max === INF) self.cbf_max = 1;
        };
        self.color = function(x, varargs) {
            if (self.color_func) return self.color_func.apply(this, arguments);
            else return null;
        };
        return self;
    };
    /**
   * Creates a new palette.Scheme and initialises it by calling addPalettes
   * method with the rest of the arguments.
   *
   * @param {string} name Name of the scheme.
   * @param {string|!Array<string>} groups A group name or list of group
   *     names the scheme belongs to.
   * @param {!Object<number, palette.Palette>|!Array<palette.Palette>}
   *     palettes A map or an array of colour palettes to add.  If map, i.e.
   *     object, is used, properties should use integer property names.
   * @param {number=} opt_max Size of the biggest palette in palettes set.
   *     If not set, palettes must have a length property which will be used.
   * @param {number=} opt_cbf_max Size of the biggest palette which is still
   *     colourblind friendly.  1 by default.
   * @return {!palette.SchemeType} A colour palette generator function, which
   *     in addition has methods and properties like a regular object.  Think
   *     of it as a callable object.
   */ palette.Scheme.fromPalettes = function(name, groups, palettes, opt_max, opt_cbf_max) {
        var scheme = palette.Scheme(name, groups);
        scheme.addPalettes.apply(scheme, slice(arguments, 2));
        return scheme;
    };
    /**
   * Creates a new palette.Scheme and initialises it by calling
   * setColorFunction method with the rest of the arguments.
   *
   * @param {string} name Name of the scheme.
   * @param {string|!Array<string>} groups A group name or list of group
   *     names the scheme belongs to.
   * @param {palette.ColorFunction} func A colour generator function.
   * @param {boolean=} opt_is_cbf Whether palette generate with the function
   *     is colour-blind friendly.
   * @param {boolean=} opt_cyclic Whether colour at 0.0 is the same as the
   *     one at 1.0.
   * @return {!palette.SchemeType} A colour palette generator function, which
   *     in addition has methods and properties like a regular object.  Think
   *     of it as a callable object.
   */ palette.Scheme.withColorFunction = function(name, groups, func, opt_is_cbf, opt_cyclic) {
        var scheme = palette.Scheme(name, groups);
        scheme.setColorFunction.apply(scheme, slice(arguments, 2));
        return scheme;
    };
    /**
   * A map of registered schemes.  Maps a scheme or group name to a list of
   * scheme objects.  Property name is either 'n-<name>' for single scheme
   * names or 'g-<name>' for scheme group names.
   *
   * @type {!Object<string, !Array<!Object>>}
   */ var registered_schemes = {};
    /**
   * Registers a new colour scheme.
   *
   * @param {!palette.SchemeType} scheme The scheme to add.
   */ palette.register = function(scheme) {
        registered_schemes["n-" + scheme.scheme_name] = [
            scheme
        ];
        scheme.groups.forEach(function(g) {
            (registered_schemes["g-" + g] = registered_schemes["g-" + g] || []).push(scheme);
        });
        (registered_schemes["g-all"] = registered_schemes["g-all"] || []).push(scheme);
    };
    /**
   * List all schemes that match given name and number of colours.
   *
   * name argument can be either a string or an array of strings.  In the
   * former case, the function acts as if the argument was an array with name
   * as a single argument (i.e. “palette.listSchemes('foo')” is exactly the same
   * as “palette.listSchemes(['foo'])”).
   *
   * Each name can be either name of a palette (e.g. 'tol-sq' for Paul Tol's
   * sequential palette), or a name of a group (e.g. 'sequential' for all
   * sequential palettes).  Name can therefore map to a single scheme or
   * several schemes.
   *
   * Furthermore, name can be suffixed with '-cbf' to indicate that only
   * schemes that are colourblind friendly should be returned.  For example,
   * 'rainbow' returns a HSV rainbow scheme, but because it is not colourblind
   * friendly, 'rainbow-cbf' returns no schemes.
   *
   * Some schemes may produce colourblind friendly palettes for some number of
   * colours.  For example ColorBrewer's Dark2 scheme is colourblind friendly
   * if no more than 3 colours are generated.  If opt_number is not specified,
   * 'qualitative-cbf' will include 'cb-Dark2' but if opt_number is given as,
   * say, 5 it won't.
   *
   * Name can also be 'all' which will return all registered schemes.
   * Naturally, 'all-cbf' will return all colourblind friendly schemes.
   *
   * Schemes are added to the library using palette.register.  Schemes are
   * created using palette.Scheme function.  By default, the following schemes
   * are available:
   *
   *     Name            Description
   *     --------------  -----------------------------------------------------
   *     tol             Paul Tol's qualitative scheme, cbf, max 12 colours.
   *     tol-dv          Paul Tol's diverging scheme, cbf.
   *     tol-sq          Paul Tol's sequential scheme, cbf.
   *     tol-rainbow     Paul Tol's qualitative scheme, cbf.
   *
   *     rainbow         A rainbow palette.
   *
   *     cb-YlGn         ColorBrewer sequential schemes.
   *     cb-YlGnBu
   *     cb-GnBu
   *     cb-BuGn
   *     cb-PuBuGn
   *     cb-PuBu
   *     cb-BuPu
   *     cb-RdPu
   *     cb-PuRd
   *     cb-OrRd
   *     cb-YlOrRd
   *     cb-YlOrBr
   *     cb-Purples
   *     cb-Blues
   *     cb-Greens
   *     cb-Oranges
   *     cb-Reds
   *     cb-Greys
   *
   *     cb-PuOr         ColorBrewer diverging schemes.
   *     cb-BrBG
   *     cb-PRGn
   *     cb-PiYG
   *     cb-RdBu
   *     cb-RdGy
   *     cb-RdYlBu
   *     cb-Spectral
   *     cb-RdYlGn
   *
   *     cb-Accent       ColorBrewer qualitative schemes.
   *     cb-Dark2
   *     cb-Paired
   *     cb-Pastel1
   *     cb-Pastel2
   *     cb-Set1
   *     cb-Set2
   *     cb-Set3
   *
   *     sol-base        Solarized base colours.
   *     sol-accent      Solarized accent colours.
   *
   * The following groups are also available by default:
   *
   *     Name            Description
   *     --------------  -----------------------------------------------------
   *     all             All registered schemes.
   *     sequential      All sequential schemes.
   *     diverging       All diverging schemes.
   *     qualitative     All qualitative schemes.
   *     cb-sequential   All ColorBrewer sequential schemes.
   *     cb-diverging    All ColorBrewer diverging schemes.
   *     cb-qualitative  All ColorBrewer qualitative schemes.
   *
   * You can read more about Paul Tol's palettes at http://www.sron.nl/~pault/.
   * You can read more about ColorBrewer at http://colorbrewer2.org.
   *
   * @param {string|!Array<string>} name A name of a colour scheme, of
   *     a group of colour schemes, or an array of any of those.
   * @param {number=} opt_number When requesting only colourblind friendly
   *     schemes, number of colours the scheme must provide generating such
   *     that the palette is still colourblind friendly.  2 by default.
   * @return {!Array<!palette.SchemeType>} An array of colour scheme objects
   *     matching the criteria.  Sorted by scheme name.
   */ palette.listSchemes = function(name, opt_number) {
        if (!opt_number) opt_number = 2;
        else if (opt_number < 0) opt_number = -opt_number;
        var ret = [];
        (typeof name === "string" ? [
            name
        ] : name).forEach(function(n) {
            var cbf = n.substring(n.length - 4) === "-cbf";
            if (cbf) n = n.substring(0, n.length - 4);
            var schemes = registered_schemes["g-" + n] || registered_schemes["n-" + n] || [];
            for(var i = 0, scheme; scheme = schemes[i]; ++i)if ((cbf ? scheme.cbf : scheme.max) >= opt_number) ret.push(scheme);
        });
        ret.sort(function(a, b) {
            return a.scheme_name >= b.scheme_name ? a.scheme_name > b.scheme_name ? 1 : 0 : -1;
        });
        return ret;
    };
    /**
   * Generates a palette using given colour generating function.
   *
   * The color_func callback must accept a singe number argument whose value
   * can vary from 0.0 to 1.0 (or in general from opt_start to opt_end), and
   * return a colour as an 'RRGGBB' string.  This function will be used when
   * generating palettes, i.e. if 11-colour palette is requested, this
   * function will be called with arguments 0.0, 0.1, …, 1.0.
   *
   * In some cases, it is not desirable to reach 1.0 when generating
   * a palette.  This happens for hue-rainbows where the 0–1 range corresponds
   * to a 0°–360° range in hues, and since hue at 0° is the same as at 360°,
   * it's desired to stop short the end of the range when generating
   * a palette.  To accomplish this, opt_cyclic should be set to true.
   *
   * opt_start and opt_end may be used to change the range the colour
   * generation function is called with.  opt_end may be less than opt_start
   * which will case to traverse the range in reverse.  Another way to reverse
   * the palette is requesting negative number of colours.  The two methods do
   * not always lead to the same results (especially if opt_cyclic is set).
   *
   * @param {palette.ColorFunction} color_func A colours generating callback
   *     function.
   * @param {number} number Number of colours to generate in the palette.  If
   *     number is negative, colours in the palette will be reversed.  If only
   *     one colour is requested, colour at opt_start will be returned.
   * @param {number=} opt_start Optional starting point for the palette
   *     generation function.  Zero by default.
   * @param {number=} opt_end Optional ending point for the palette generation
   *     function.  One by default.
   * @param {boolean=} opt_cyclic If true, function will assume colour at
   *     point opt_start is the same as one at opt_end.
   * @return {palette.Palette} An array of 'RRGGBB' colours.
   */ palette.generate = function(color_func, number, opt_start, opt_end, opt_cyclic) {
        if (Math.abs(number) < 1) return [];
        opt_start = opt_start === void 0 ? 0 : opt_start;
        opt_end = opt_end === void 0 ? 1 : opt_end;
        if (Math.abs(number) < 2) return [
            color_func(opt_start)
        ];
        var i = Math.abs(number);
        var x = opt_start;
        var ret = [];
        var step = (opt_end - opt_start) / (opt_cyclic ? i : i - 1);
        for(; --i >= 0; x += step)ret.push(color_func(x));
        if (number < 0) ret.reverse();
        return ret;
    };
    /**
   * Clamps value to [0, 1] range.
   * @param {number} v Number to limit value of.
   * @return {number} If v is inside of [0, 1] range returns v, otherwise
   *     returns 0 or 1 depending which side of the range v is closer to.
   */ var clamp = function(v) {
        return v > 0 ? v < 1 ? v : 1 : 0;
    };
    /**
   * Converts r, g, b triple into RRGGBB hex representation.
   * @param {number} r Red value of the colour in the range [0, 1].
   * @param {number} g Green value of the colour in the range [0, 1].
   * @param {number} b Blue value of the colour in the range [0, 1].
   * @return {string} A lower-case RRGGBB representation of the colour.
   */ palette.rgbColor = function(r, g, b) {
        return [
            r,
            g,
            b
        ].map(function(v) {
            v = Number(Math.round(clamp(v) * 255)).toString(16);
            return v.length == 1 ? "0" + v : v;
        }).join("");
    };
    /**
   * Converts a linear r, g, b triple into RRGGBB hex representation.
   * @param {number} r Linear red value of the colour in the range [0, 1].
   * @param {number} g Linear green value of the colour in the range [0, 1].
   * @param {number} b Linear blue value of the colour in the range [0, 1].
   * @return {string} A lower-case RRGGBB representation of the colour.
   */ palette.linearRgbColor = function(r, g, b) {
        // http://www.brucelindbloom.com/index.html?Eqn_XYZ_to_RGB.html
        return [
            r,
            g,
            b
        ].map(function(v) {
            v = clamp(v);
            if (v <= 0.0031308) v = 12.92 * v;
            else v = 1.055 * Math.pow(v, 1 / 2.4) - 0.055;
            v = Number(Math.round(v * 255)).toString(16);
            return v.length == 1 ? "0" + v : v;
        }).join("");
    };
    /**
   * Converts an HSV colours to RRGGBB hex representation.
   * @param {number} h Hue in the range [0, 1].
   * @param {number=} opt_s Saturation in the range [0, 1].  One by default.
   * @param {number=} opt_v Value in the range [0, 1].  One by default.
   * @return {string} An RRGGBB representation of the colour.
   */ palette.hsvColor = function(h, opt_s, opt_v) {
        h *= 6;
        var s = opt_s === void 0 ? 1 : clamp(opt_s);
        var v = opt_v === void 0 ? 1 : clamp(opt_v);
        var x = v * (1 - s * Math.abs(h % 2 - 1));
        var m = v * (1 - s);
        switch(Math.floor(h) % 6){
            case 0:
                return palette.rgbColor(v, x, m);
            case 1:
                return palette.rgbColor(x, v, m);
            case 2:
                return palette.rgbColor(m, v, x);
            case 3:
                return palette.rgbColor(m, x, v);
            case 4:
                return palette.rgbColor(x, m, v);
            default:
                return palette.rgbColor(v, m, x);
        }
    };
    palette.register(palette.Scheme.withColorFunction("rainbow", "qualitative", palette.hsvColor, false, true));
    return palette;
}();
/** @typedef {function(number): string} */ $6d026be3651d0191$var$palette.ColorFunction;
/** @typedef {!Array<string>} */ $6d026be3651d0191$var$palette.Palette;
/** @typedef {!Object<number, palette.Palette>|!Array<palette.Palette>} */ $6d026be3651d0191$var$palette.PalettesList;
/**
 * @typedef {
 *   function(number, ...?): Array<string>|
 *   {
 *     scheme_name: string,
 *     groups: !Array<string>,
 *     max: number,
 *     cbf_max: number,
 *     addPalette: function(!Array<string>, boolean=),
 *     addPalettes: function(palette.PalettesList, number=, number=),
 *     shrinkByTakingHead: function(boolean, number=),
 *     setColorFunction: function(palette.ColorFunction, boolean=, boolean=),
 *     color: function(number, ...?): ?string}}
 */ $6d026be3651d0191$var$palette.SchemeType;
/* mpn65 palette start here. ************************************************/ /* The ‘mpn65’ palette is designed for systems which show many graphs which
   don’t have custom colour palettes chosen by humans or if number of necessary
   colours isn’t know a priori. */ (function() {
    var scheme = $6d026be3651d0191$var$palette.Scheme.fromPalettes("mpn65", "qualitative", [
        [
            "ff0029",
            "377eb8",
            "66a61e",
            "984ea3",
            "00d2d5",
            "ff7f00",
            "af8d00",
            "7f80cd",
            "b3e900",
            "c42e60",
            "a65628",
            "f781bf",
            "8dd3c7",
            "bebada",
            "fb8072",
            "80b1d3",
            "fdb462",
            "fccde5",
            "bc80bd",
            "ffed6f",
            "c4eaff",
            "cf8c00",
            "1b9e77",
            "d95f02",
            "e7298a",
            "e6ab02",
            "a6761d",
            "0097ff",
            "00d067",
            "000000",
            "252525",
            "525252",
            "737373",
            "969696",
            "bdbdbd",
            "f43600",
            "4ba93b",
            "5779bb",
            "927acc",
            "97ee3f",
            "bf3947",
            "9f5b00",
            "f48758",
            "8caed6",
            "f2b94f",
            "eff26e",
            "e43872",
            "d9b100",
            "9d7a00",
            "698cff",
            "d9d9d9",
            "00d27e",
            "d06800",
            "009f82",
            "c49200",
            "cbe8ff",
            "fecddf",
            "c27eb6",
            "8cd2ce",
            "c4b8d9",
            "f883b0",
            "a49100",
            "f48800",
            "27d0df",
            "a04a9b"
        ]
    ]);
    scheme.shrinkByTakingHead(true);
    $6d026be3651d0191$var$palette.register(scheme);
})();
/* Paul Tol's schemes start here. *******************************************/ /* See http://www.sron.nl/~pault/ */ (function() {
    var rgb = $6d026be3651d0191$var$palette.rgbColor;
    /**
   * Calculates value of a polynomial at given point.
   * For example, poly(x, 1, 2, 3) calculates value of “1 + 2*x + 3*X²”.
   * @param {number} x Value to calculate polynomial for.
   * @param {...number} varargs Coefficients of the polynomial specified in
   *     the order of rising powers of x including constant as the first
   *     variable argument.
   */ var poly = function(x, varargs) {
        var i = arguments.length - 1, n = arguments[i];
        while(i > 1)n = n * x + arguments[--i];
        return n;
    };
    /**
   * Calculate approximate value of error function with maximum error of 0.0005.
   * See <https://en.wikipedia.org/wiki/Error_function>.
   * @param {number} x Argument of the error function.
   * @return {number} Value of error function for x.
   */ var erf = function(x) {
        // https://en.wikipedia.org/wiki/Error_function#Approximation_with_elementary_functions
        // This produces a maximum error of 0.0005 which is more then we need.  In
        // the worst case, that error is multiplied by four and then divided by two
        // before being multiplied by 255, so in the end, the error is multiplied by
        // 510 which produces 0.255 which is less than a single colour step.
        var y = poly(Math.abs(x), 1, 0.278393, 0.230389, 0.000972, 0.078108);
        y *= y; // y^2
        y *= y; // y^4
        y = 1 - 1 / y;
        return x < 0 ? -y : y;
    };
    $6d026be3651d0191$var$palette.register($6d026be3651d0191$var$palette.Scheme.fromPalettes("tol", "qualitative", [
        [
            "4477aa"
        ],
        [
            "4477aa",
            "cc6677"
        ],
        [
            "4477aa",
            "ddcc77",
            "cc6677"
        ],
        [
            "4477aa",
            "117733",
            "ddcc77",
            "cc6677"
        ],
        [
            "332288",
            "88ccee",
            "117733",
            "ddcc77",
            "cc6677"
        ],
        [
            "332288",
            "88ccee",
            "117733",
            "ddcc77",
            "cc6677",
            "aa4499"
        ],
        [
            "332288",
            "88ccee",
            "44aa99",
            "117733",
            "ddcc77",
            "cc6677",
            "aa4499"
        ],
        [
            "332288",
            "88ccee",
            "44aa99",
            "117733",
            "999933",
            "ddcc77",
            "cc6677",
            "aa4499"
        ],
        [
            "332288",
            "88ccee",
            "44aa99",
            "117733",
            "999933",
            "ddcc77",
            "cc6677",
            "882255",
            "aa4499"
        ],
        [
            "332288",
            "88ccee",
            "44aa99",
            "117733",
            "999933",
            "ddcc77",
            "661100",
            "cc6677",
            "882255",
            "aa4499"
        ],
        [
            "332288",
            "6699cc",
            "88ccee",
            "44aa99",
            "117733",
            "999933",
            "ddcc77",
            "661100",
            "cc6677",
            "882255",
            "aa4499"
        ],
        [
            "332288",
            "6699cc",
            "88ccee",
            "44aa99",
            "117733",
            "999933",
            "ddcc77",
            "661100",
            "cc6677",
            "aa4466",
            "882255",
            "aa4499"
        ]
    ], 12, 12));
    /**
   * Calculates a colour along Paul Tol's sequential colours axis.
   * See <http://www.sron.nl/~pault/colourschemes.pdf> figure 7 and equation 1.
   * @param {number} x Position of the colour on the axis in the [0, 1] range.
   * @return {string} An RRGGBB representation of the colour.
   */ $6d026be3651d0191$var$palette.tolSequentialColor = function(x) {
        return rgb(1 - 0.392 * (1 + erf((x - 0.869) / 0.255)), 1.021 - 0.456 * (1 + erf((x - 0.527) / 0.376)), 1 - 0.493 * (1 + erf((x - 0.272) / 0.309)));
    };
    $6d026be3651d0191$var$palette.register($6d026be3651d0191$var$palette.Scheme.withColorFunction("tol-sq", "sequential", $6d026be3651d0191$var$palette.tolSequentialColor, true));
    /**
   * Calculates a colour along Paul Tol's diverging colours axis.
   * See <http://www.sron.nl/~pault/colourschemes.pdf> figure 8 and equation 2.
   * @param {number} x Position of the colour on the axis in the [0, 1] range.
   * @return {string} An RRGGBB representation of the colour.
   */ $6d026be3651d0191$var$palette.tolDivergingColor = function(x) {
        var g = poly(x, 0.572, 1.524, -1.811) / poly(x, 1, -0.291, 0.1574);
        return rgb(poly(x, 0.235, -2.13, 26.92, -65.5, 63.5, -22.36), g * g, 1 / poly(x, 1.579, -4.03, 12.92, -31.4, 48.6, -23.36));
    };
    $6d026be3651d0191$var$palette.register($6d026be3651d0191$var$palette.Scheme.withColorFunction("tol-dv", "diverging", $6d026be3651d0191$var$palette.tolDivergingColor, true));
    /**
   * Calculates a colour along Paul Tol's rainbow colours axis.
   * See <http://www.sron.nl/~pault/colourschemes.pdf> figure 13 and equation 3.
   * @param {number} x Position of the colour on the axis in the [0, 1] range.
   * @return {string} An RRGGBB representation of the colour.
   */ $6d026be3651d0191$var$palette.tolRainbowColor = function(x) {
        return rgb(poly(x, 0.472, -0.567, 4.05) / poly(x, 1, 8.72, -19.17, 14.1), poly(x, 0.108932, -1.22635, 27.284, -98.577, 163.3, -131.395, 40.634), 1 / poly(x, 1.97, 3.54, -68.5, 243, -297, 125));
    };
    $6d026be3651d0191$var$palette.register($6d026be3651d0191$var$palette.Scheme.withColorFunction("tol-rainbow", "qualitative", $6d026be3651d0191$var$palette.tolRainbowColor, true));
})();
/* Solarized colour schemes start here. *************************************/ /* See http://ethanschoonover.com/solarized */ (function() {
    /*
   * Those are not really designed to be used in graphs, but we're keeping
   * them here in case someone cares.
   */ $6d026be3651d0191$var$palette.register($6d026be3651d0191$var$palette.Scheme.fromPalettes("sol-base", "sequential", [
        [
            "002b36",
            "073642",
            "586e75",
            "657b83",
            "839496",
            "93a1a1",
            "eee8d5",
            "fdf6e3"
        ]
    ], 1, 8));
    $6d026be3651d0191$var$palette.register($6d026be3651d0191$var$palette.Scheme.fromPalettes("sol-accent", "qualitative", [
        [
            "b58900",
            "cb4b16",
            "dc322f",
            "d33682",
            "6c71c4",
            "268bd2",
            "2aa198",
            "859900"
        ]
    ]));
})();
/* ColorBrewer colour schemes start here. ***********************************/ /* See http://colorbrewer2.org/ */ (function() {
    var schemes = {
        YlGn: {
            type: "sequential",
            cbf: 42,
            3: [
                "f7fcb9",
                "addd8e",
                "31a354"
            ],
            4: [
                "ffffcc",
                "c2e699",
                "78c679",
                "238443"
            ],
            5: [
                "ffffcc",
                "c2e699",
                "78c679",
                "31a354",
                "006837"
            ],
            6: [
                "ffffcc",
                "d9f0a3",
                "addd8e",
                "78c679",
                "31a354",
                "006837"
            ],
            7: [
                "ffffcc",
                "d9f0a3",
                "addd8e",
                "78c679",
                "41ab5d",
                "238443",
                "005a32"
            ],
            8: [
                "ffffe5",
                "f7fcb9",
                "d9f0a3",
                "addd8e",
                "78c679",
                "41ab5d",
                "238443",
                "005a32"
            ],
            9: [
                "ffffe5",
                "f7fcb9",
                "d9f0a3",
                "addd8e",
                "78c679",
                "41ab5d",
                "238443",
                "006837",
                "004529"
            ]
        },
        YlGnBu: {
            type: "sequential",
            cbf: 42,
            3: [
                "edf8b1",
                "7fcdbb",
                "2c7fb8"
            ],
            4: [
                "ffffcc",
                "a1dab4",
                "41b6c4",
                "225ea8"
            ],
            5: [
                "ffffcc",
                "a1dab4",
                "41b6c4",
                "2c7fb8",
                "253494"
            ],
            6: [
                "ffffcc",
                "c7e9b4",
                "7fcdbb",
                "41b6c4",
                "2c7fb8",
                "253494"
            ],
            7: [
                "ffffcc",
                "c7e9b4",
                "7fcdbb",
                "41b6c4",
                "1d91c0",
                "225ea8",
                "0c2c84"
            ],
            8: [
                "ffffd9",
                "edf8b1",
                "c7e9b4",
                "7fcdbb",
                "41b6c4",
                "1d91c0",
                "225ea8",
                "0c2c84"
            ],
            9: [
                "ffffd9",
                "edf8b1",
                "c7e9b4",
                "7fcdbb",
                "41b6c4",
                "1d91c0",
                "225ea8",
                "253494",
                "081d58"
            ]
        },
        GnBu: {
            type: "sequential",
            cbf: 42,
            3: [
                "e0f3db",
                "a8ddb5",
                "43a2ca"
            ],
            4: [
                "f0f9e8",
                "bae4bc",
                "7bccc4",
                "2b8cbe"
            ],
            5: [
                "f0f9e8",
                "bae4bc",
                "7bccc4",
                "43a2ca",
                "0868ac"
            ],
            6: [
                "f0f9e8",
                "ccebc5",
                "a8ddb5",
                "7bccc4",
                "43a2ca",
                "0868ac"
            ],
            7: [
                "f0f9e8",
                "ccebc5",
                "a8ddb5",
                "7bccc4",
                "4eb3d3",
                "2b8cbe",
                "08589e"
            ],
            8: [
                "f7fcf0",
                "e0f3db",
                "ccebc5",
                "a8ddb5",
                "7bccc4",
                "4eb3d3",
                "2b8cbe",
                "08589e"
            ],
            9: [
                "f7fcf0",
                "e0f3db",
                "ccebc5",
                "a8ddb5",
                "7bccc4",
                "4eb3d3",
                "2b8cbe",
                "0868ac",
                "084081"
            ]
        },
        BuGn: {
            type: "sequential",
            cbf: 42,
            3: [
                "e5f5f9",
                "99d8c9",
                "2ca25f"
            ],
            4: [
                "edf8fb",
                "b2e2e2",
                "66c2a4",
                "238b45"
            ],
            5: [
                "edf8fb",
                "b2e2e2",
                "66c2a4",
                "2ca25f",
                "006d2c"
            ],
            6: [
                "edf8fb",
                "ccece6",
                "99d8c9",
                "66c2a4",
                "2ca25f",
                "006d2c"
            ],
            7: [
                "edf8fb",
                "ccece6",
                "99d8c9",
                "66c2a4",
                "41ae76",
                "238b45",
                "005824"
            ],
            8: [
                "f7fcfd",
                "e5f5f9",
                "ccece6",
                "99d8c9",
                "66c2a4",
                "41ae76",
                "238b45",
                "005824"
            ],
            9: [
                "f7fcfd",
                "e5f5f9",
                "ccece6",
                "99d8c9",
                "66c2a4",
                "41ae76",
                "238b45",
                "006d2c",
                "00441b"
            ]
        },
        PuBuGn: {
            type: "sequential",
            cbf: 42,
            3: [
                "ece2f0",
                "a6bddb",
                "1c9099"
            ],
            4: [
                "f6eff7",
                "bdc9e1",
                "67a9cf",
                "02818a"
            ],
            5: [
                "f6eff7",
                "bdc9e1",
                "67a9cf",
                "1c9099",
                "016c59"
            ],
            6: [
                "f6eff7",
                "d0d1e6",
                "a6bddb",
                "67a9cf",
                "1c9099",
                "016c59"
            ],
            7: [
                "f6eff7",
                "d0d1e6",
                "a6bddb",
                "67a9cf",
                "3690c0",
                "02818a",
                "016450"
            ],
            8: [
                "fff7fb",
                "ece2f0",
                "d0d1e6",
                "a6bddb",
                "67a9cf",
                "3690c0",
                "02818a",
                "016450"
            ],
            9: [
                "fff7fb",
                "ece2f0",
                "d0d1e6",
                "a6bddb",
                "67a9cf",
                "3690c0",
                "02818a",
                "016c59",
                "014636"
            ]
        },
        PuBu: {
            type: "sequential",
            cbf: 42,
            3: [
                "ece7f2",
                "a6bddb",
                "2b8cbe"
            ],
            4: [
                "f1eef6",
                "bdc9e1",
                "74a9cf",
                "0570b0"
            ],
            5: [
                "f1eef6",
                "bdc9e1",
                "74a9cf",
                "2b8cbe",
                "045a8d"
            ],
            6: [
                "f1eef6",
                "d0d1e6",
                "a6bddb",
                "74a9cf",
                "2b8cbe",
                "045a8d"
            ],
            7: [
                "f1eef6",
                "d0d1e6",
                "a6bddb",
                "74a9cf",
                "3690c0",
                "0570b0",
                "034e7b"
            ],
            8: [
                "fff7fb",
                "ece7f2",
                "d0d1e6",
                "a6bddb",
                "74a9cf",
                "3690c0",
                "0570b0",
                "034e7b"
            ],
            9: [
                "fff7fb",
                "ece7f2",
                "d0d1e6",
                "a6bddb",
                "74a9cf",
                "3690c0",
                "0570b0",
                "045a8d",
                "023858"
            ]
        },
        BuPu: {
            type: "sequential",
            cbf: 42,
            3: [
                "e0ecf4",
                "9ebcda",
                "8856a7"
            ],
            4: [
                "edf8fb",
                "b3cde3",
                "8c96c6",
                "88419d"
            ],
            5: [
                "edf8fb",
                "b3cde3",
                "8c96c6",
                "8856a7",
                "810f7c"
            ],
            6: [
                "edf8fb",
                "bfd3e6",
                "9ebcda",
                "8c96c6",
                "8856a7",
                "810f7c"
            ],
            7: [
                "edf8fb",
                "bfd3e6",
                "9ebcda",
                "8c96c6",
                "8c6bb1",
                "88419d",
                "6e016b"
            ],
            8: [
                "f7fcfd",
                "e0ecf4",
                "bfd3e6",
                "9ebcda",
                "8c96c6",
                "8c6bb1",
                "88419d",
                "6e016b"
            ],
            9: [
                "f7fcfd",
                "e0ecf4",
                "bfd3e6",
                "9ebcda",
                "8c96c6",
                "8c6bb1",
                "88419d",
                "810f7c",
                "4d004b"
            ]
        },
        RdPu: {
            type: "sequential",
            cbf: 42,
            3: [
                "fde0dd",
                "fa9fb5",
                "c51b8a"
            ],
            4: [
                "feebe2",
                "fbb4b9",
                "f768a1",
                "ae017e"
            ],
            5: [
                "feebe2",
                "fbb4b9",
                "f768a1",
                "c51b8a",
                "7a0177"
            ],
            6: [
                "feebe2",
                "fcc5c0",
                "fa9fb5",
                "f768a1",
                "c51b8a",
                "7a0177"
            ],
            7: [
                "feebe2",
                "fcc5c0",
                "fa9fb5",
                "f768a1",
                "dd3497",
                "ae017e",
                "7a0177"
            ],
            8: [
                "fff7f3",
                "fde0dd",
                "fcc5c0",
                "fa9fb5",
                "f768a1",
                "dd3497",
                "ae017e",
                "7a0177"
            ],
            9: [
                "fff7f3",
                "fde0dd",
                "fcc5c0",
                "fa9fb5",
                "f768a1",
                "dd3497",
                "ae017e",
                "7a0177",
                "49006a"
            ]
        },
        PuRd: {
            type: "sequential",
            cbf: 42,
            3: [
                "e7e1ef",
                "c994c7",
                "dd1c77"
            ],
            4: [
                "f1eef6",
                "d7b5d8",
                "df65b0",
                "ce1256"
            ],
            5: [
                "f1eef6",
                "d7b5d8",
                "df65b0",
                "dd1c77",
                "980043"
            ],
            6: [
                "f1eef6",
                "d4b9da",
                "c994c7",
                "df65b0",
                "dd1c77",
                "980043"
            ],
            7: [
                "f1eef6",
                "d4b9da",
                "c994c7",
                "df65b0",
                "e7298a",
                "ce1256",
                "91003f"
            ],
            8: [
                "f7f4f9",
                "e7e1ef",
                "d4b9da",
                "c994c7",
                "df65b0",
                "e7298a",
                "ce1256",
                "91003f"
            ],
            9: [
                "f7f4f9",
                "e7e1ef",
                "d4b9da",
                "c994c7",
                "df65b0",
                "e7298a",
                "ce1256",
                "980043",
                "67001f"
            ]
        },
        OrRd: {
            type: "sequential",
            cbf: 42,
            3: [
                "fee8c8",
                "fdbb84",
                "e34a33"
            ],
            4: [
                "fef0d9",
                "fdcc8a",
                "fc8d59",
                "d7301f"
            ],
            5: [
                "fef0d9",
                "fdcc8a",
                "fc8d59",
                "e34a33",
                "b30000"
            ],
            6: [
                "fef0d9",
                "fdd49e",
                "fdbb84",
                "fc8d59",
                "e34a33",
                "b30000"
            ],
            7: [
                "fef0d9",
                "fdd49e",
                "fdbb84",
                "fc8d59",
                "ef6548",
                "d7301f",
                "990000"
            ],
            8: [
                "fff7ec",
                "fee8c8",
                "fdd49e",
                "fdbb84",
                "fc8d59",
                "ef6548",
                "d7301f",
                "990000"
            ],
            9: [
                "fff7ec",
                "fee8c8",
                "fdd49e",
                "fdbb84",
                "fc8d59",
                "ef6548",
                "d7301f",
                "b30000",
                "7f0000"
            ]
        },
        YlOrRd: {
            type: "sequential",
            cbf: 42,
            3: [
                "ffeda0",
                "feb24c",
                "f03b20"
            ],
            4: [
                "ffffb2",
                "fecc5c",
                "fd8d3c",
                "e31a1c"
            ],
            5: [
                "ffffb2",
                "fecc5c",
                "fd8d3c",
                "f03b20",
                "bd0026"
            ],
            6: [
                "ffffb2",
                "fed976",
                "feb24c",
                "fd8d3c",
                "f03b20",
                "bd0026"
            ],
            7: [
                "ffffb2",
                "fed976",
                "feb24c",
                "fd8d3c",
                "fc4e2a",
                "e31a1c",
                "b10026"
            ],
            8: [
                "ffffcc",
                "ffeda0",
                "fed976",
                "feb24c",
                "fd8d3c",
                "fc4e2a",
                "e31a1c",
                "b10026"
            ],
            9: [
                "ffffcc",
                "ffeda0",
                "fed976",
                "feb24c",
                "fd8d3c",
                "fc4e2a",
                "e31a1c",
                "bd0026",
                "800026"
            ]
        },
        YlOrBr: {
            type: "sequential",
            cbf: 42,
            3: [
                "fff7bc",
                "fec44f",
                "d95f0e"
            ],
            4: [
                "ffffd4",
                "fed98e",
                "fe9929",
                "cc4c02"
            ],
            5: [
                "ffffd4",
                "fed98e",
                "fe9929",
                "d95f0e",
                "993404"
            ],
            6: [
                "ffffd4",
                "fee391",
                "fec44f",
                "fe9929",
                "d95f0e",
                "993404"
            ],
            7: [
                "ffffd4",
                "fee391",
                "fec44f",
                "fe9929",
                "ec7014",
                "cc4c02",
                "8c2d04"
            ],
            8: [
                "ffffe5",
                "fff7bc",
                "fee391",
                "fec44f",
                "fe9929",
                "ec7014",
                "cc4c02",
                "8c2d04"
            ],
            9: [
                "ffffe5",
                "fff7bc",
                "fee391",
                "fec44f",
                "fe9929",
                "ec7014",
                "cc4c02",
                "993404",
                "662506"
            ]
        },
        Purples: {
            type: "sequential",
            cbf: 42,
            3: [
                "efedf5",
                "bcbddc",
                "756bb1"
            ],
            4: [
                "f2f0f7",
                "cbc9e2",
                "9e9ac8",
                "6a51a3"
            ],
            5: [
                "f2f0f7",
                "cbc9e2",
                "9e9ac8",
                "756bb1",
                "54278f"
            ],
            6: [
                "f2f0f7",
                "dadaeb",
                "bcbddc",
                "9e9ac8",
                "756bb1",
                "54278f"
            ],
            7: [
                "f2f0f7",
                "dadaeb",
                "bcbddc",
                "9e9ac8",
                "807dba",
                "6a51a3",
                "4a1486"
            ],
            8: [
                "fcfbfd",
                "efedf5",
                "dadaeb",
                "bcbddc",
                "9e9ac8",
                "807dba",
                "6a51a3",
                "4a1486"
            ],
            9: [
                "fcfbfd",
                "efedf5",
                "dadaeb",
                "bcbddc",
                "9e9ac8",
                "807dba",
                "6a51a3",
                "54278f",
                "3f007d"
            ]
        },
        Blues: {
            type: "sequential",
            cbf: 42,
            3: [
                "deebf7",
                "9ecae1",
                "3182bd"
            ],
            4: [
                "eff3ff",
                "bdd7e7",
                "6baed6",
                "2171b5"
            ],
            5: [
                "eff3ff",
                "bdd7e7",
                "6baed6",
                "3182bd",
                "08519c"
            ],
            6: [
                "eff3ff",
                "c6dbef",
                "9ecae1",
                "6baed6",
                "3182bd",
                "08519c"
            ],
            7: [
                "eff3ff",
                "c6dbef",
                "9ecae1",
                "6baed6",
                "4292c6",
                "2171b5",
                "084594"
            ],
            8: [
                "f7fbff",
                "deebf7",
                "c6dbef",
                "9ecae1",
                "6baed6",
                "4292c6",
                "2171b5",
                "084594"
            ],
            9: [
                "f7fbff",
                "deebf7",
                "c6dbef",
                "9ecae1",
                "6baed6",
                "4292c6",
                "2171b5",
                "08519c",
                "08306b"
            ]
        },
        Greens: {
            type: "sequential",
            cbf: 42,
            3: [
                "e5f5e0",
                "a1d99b",
                "31a354"
            ],
            4: [
                "edf8e9",
                "bae4b3",
                "74c476",
                "238b45"
            ],
            5: [
                "edf8e9",
                "bae4b3",
                "74c476",
                "31a354",
                "006d2c"
            ],
            6: [
                "edf8e9",
                "c7e9c0",
                "a1d99b",
                "74c476",
                "31a354",
                "006d2c"
            ],
            7: [
                "edf8e9",
                "c7e9c0",
                "a1d99b",
                "74c476",
                "41ab5d",
                "238b45",
                "005a32"
            ],
            8: [
                "f7fcf5",
                "e5f5e0",
                "c7e9c0",
                "a1d99b",
                "74c476",
                "41ab5d",
                "238b45",
                "005a32"
            ],
            9: [
                "f7fcf5",
                "e5f5e0",
                "c7e9c0",
                "a1d99b",
                "74c476",
                "41ab5d",
                "238b45",
                "006d2c",
                "00441b"
            ]
        },
        Oranges: {
            type: "sequential",
            cbf: 42,
            3: [
                "fee6ce",
                "fdae6b",
                "e6550d"
            ],
            4: [
                "feedde",
                "fdbe85",
                "fd8d3c",
                "d94701"
            ],
            5: [
                "feedde",
                "fdbe85",
                "fd8d3c",
                "e6550d",
                "a63603"
            ],
            6: [
                "feedde",
                "fdd0a2",
                "fdae6b",
                "fd8d3c",
                "e6550d",
                "a63603"
            ],
            7: [
                "feedde",
                "fdd0a2",
                "fdae6b",
                "fd8d3c",
                "f16913",
                "d94801",
                "8c2d04"
            ],
            8: [
                "fff5eb",
                "fee6ce",
                "fdd0a2",
                "fdae6b",
                "fd8d3c",
                "f16913",
                "d94801",
                "8c2d04"
            ],
            9: [
                "fff5eb",
                "fee6ce",
                "fdd0a2",
                "fdae6b",
                "fd8d3c",
                "f16913",
                "d94801",
                "a63603",
                "7f2704"
            ]
        },
        Reds: {
            type: "sequential",
            cbf: 42,
            3: [
                "fee0d2",
                "fc9272",
                "de2d26"
            ],
            4: [
                "fee5d9",
                "fcae91",
                "fb6a4a",
                "cb181d"
            ],
            5: [
                "fee5d9",
                "fcae91",
                "fb6a4a",
                "de2d26",
                "a50f15"
            ],
            6: [
                "fee5d9",
                "fcbba1",
                "fc9272",
                "fb6a4a",
                "de2d26",
                "a50f15"
            ],
            7: [
                "fee5d9",
                "fcbba1",
                "fc9272",
                "fb6a4a",
                "ef3b2c",
                "cb181d",
                "99000d"
            ],
            8: [
                "fff5f0",
                "fee0d2",
                "fcbba1",
                "fc9272",
                "fb6a4a",
                "ef3b2c",
                "cb181d",
                "99000d"
            ],
            9: [
                "fff5f0",
                "fee0d2",
                "fcbba1",
                "fc9272",
                "fb6a4a",
                "ef3b2c",
                "cb181d",
                "a50f15",
                "67000d"
            ]
        },
        Greys: {
            type: "sequential",
            cbf: 42,
            3: [
                "f0f0f0",
                "bdbdbd",
                "636363"
            ],
            4: [
                "f7f7f7",
                "cccccc",
                "969696",
                "525252"
            ],
            5: [
                "f7f7f7",
                "cccccc",
                "969696",
                "636363",
                "252525"
            ],
            6: [
                "f7f7f7",
                "d9d9d9",
                "bdbdbd",
                "969696",
                "636363",
                "252525"
            ],
            7: [
                "f7f7f7",
                "d9d9d9",
                "bdbdbd",
                "969696",
                "737373",
                "525252",
                "252525"
            ],
            8: [
                "ffffff",
                "f0f0f0",
                "d9d9d9",
                "bdbdbd",
                "969696",
                "737373",
                "525252",
                "252525"
            ],
            9: [
                "ffffff",
                "f0f0f0",
                "d9d9d9",
                "bdbdbd",
                "969696",
                "737373",
                "525252",
                "252525",
                "000000"
            ]
        },
        PuOr: {
            type: "diverging",
            cbf: 42,
            3: [
                "f1a340",
                "f7f7f7",
                "998ec3"
            ],
            4: [
                "e66101",
                "fdb863",
                "b2abd2",
                "5e3c99"
            ],
            5: [
                "e66101",
                "fdb863",
                "f7f7f7",
                "b2abd2",
                "5e3c99"
            ],
            6: [
                "b35806",
                "f1a340",
                "fee0b6",
                "d8daeb",
                "998ec3",
                "542788"
            ],
            7: [
                "b35806",
                "f1a340",
                "fee0b6",
                "f7f7f7",
                "d8daeb",
                "998ec3",
                "542788"
            ],
            8: [
                "b35806",
                "e08214",
                "fdb863",
                "fee0b6",
                "d8daeb",
                "b2abd2",
                "8073ac",
                "542788"
            ],
            9: [
                "b35806",
                "e08214",
                "fdb863",
                "fee0b6",
                "f7f7f7",
                "d8daeb",
                "b2abd2",
                "8073ac",
                "542788"
            ],
            10: [
                "7f3b08",
                "b35806",
                "e08214",
                "fdb863",
                "fee0b6",
                "d8daeb",
                "b2abd2",
                "8073ac",
                "542788",
                "2d004b"
            ],
            11: [
                "7f3b08",
                "b35806",
                "e08214",
                "fdb863",
                "fee0b6",
                "f7f7f7",
                "d8daeb",
                "b2abd2",
                "8073ac",
                "542788",
                "2d004b"
            ]
        },
        BrBG: {
            type: "diverging",
            cbf: 42,
            3: [
                "d8b365",
                "f5f5f5",
                "5ab4ac"
            ],
            4: [
                "a6611a",
                "dfc27d",
                "80cdc1",
                "018571"
            ],
            5: [
                "a6611a",
                "dfc27d",
                "f5f5f5",
                "80cdc1",
                "018571"
            ],
            6: [
                "8c510a",
                "d8b365",
                "f6e8c3",
                "c7eae5",
                "5ab4ac",
                "01665e"
            ],
            7: [
                "8c510a",
                "d8b365",
                "f6e8c3",
                "f5f5f5",
                "c7eae5",
                "5ab4ac",
                "01665e"
            ],
            8: [
                "8c510a",
                "bf812d",
                "dfc27d",
                "f6e8c3",
                "c7eae5",
                "80cdc1",
                "35978f",
                "01665e"
            ],
            9: [
                "8c510a",
                "bf812d",
                "dfc27d",
                "f6e8c3",
                "f5f5f5",
                "c7eae5",
                "80cdc1",
                "35978f",
                "01665e"
            ],
            10: [
                "543005",
                "8c510a",
                "bf812d",
                "dfc27d",
                "f6e8c3",
                "c7eae5",
                "80cdc1",
                "35978f",
                "01665e",
                "003c30"
            ],
            11: [
                "543005",
                "8c510a",
                "bf812d",
                "dfc27d",
                "f6e8c3",
                "f5f5f5",
                "c7eae5",
                "80cdc1",
                "35978f",
                "01665e",
                "003c30"
            ]
        },
        PRGn: {
            type: "diverging",
            cbf: 42,
            3: [
                "af8dc3",
                "f7f7f7",
                "7fbf7b"
            ],
            4: [
                "7b3294",
                "c2a5cf",
                "a6dba0",
                "008837"
            ],
            5: [
                "7b3294",
                "c2a5cf",
                "f7f7f7",
                "a6dba0",
                "008837"
            ],
            6: [
                "762a83",
                "af8dc3",
                "e7d4e8",
                "d9f0d3",
                "7fbf7b",
                "1b7837"
            ],
            7: [
                "762a83",
                "af8dc3",
                "e7d4e8",
                "f7f7f7",
                "d9f0d3",
                "7fbf7b",
                "1b7837"
            ],
            8: [
                "762a83",
                "9970ab",
                "c2a5cf",
                "e7d4e8",
                "d9f0d3",
                "a6dba0",
                "5aae61",
                "1b7837"
            ],
            9: [
                "762a83",
                "9970ab",
                "c2a5cf",
                "e7d4e8",
                "f7f7f7",
                "d9f0d3",
                "a6dba0",
                "5aae61",
                "1b7837"
            ],
            10: [
                "40004b",
                "762a83",
                "9970ab",
                "c2a5cf",
                "e7d4e8",
                "d9f0d3",
                "a6dba0",
                "5aae61",
                "1b7837",
                "00441b"
            ],
            11: [
                "40004b",
                "762a83",
                "9970ab",
                "c2a5cf",
                "e7d4e8",
                "f7f7f7",
                "d9f0d3",
                "a6dba0",
                "5aae61",
                "1b7837",
                "00441b"
            ]
        },
        PiYG: {
            type: "diverging",
            cbf: 42,
            3: [
                "e9a3c9",
                "f7f7f7",
                "a1d76a"
            ],
            4: [
                "d01c8b",
                "f1b6da",
                "b8e186",
                "4dac26"
            ],
            5: [
                "d01c8b",
                "f1b6da",
                "f7f7f7",
                "b8e186",
                "4dac26"
            ],
            6: [
                "c51b7d",
                "e9a3c9",
                "fde0ef",
                "e6f5d0",
                "a1d76a",
                "4d9221"
            ],
            7: [
                "c51b7d",
                "e9a3c9",
                "fde0ef",
                "f7f7f7",
                "e6f5d0",
                "a1d76a",
                "4d9221"
            ],
            8: [
                "c51b7d",
                "de77ae",
                "f1b6da",
                "fde0ef",
                "e6f5d0",
                "b8e186",
                "7fbc41",
                "4d9221"
            ],
            9: [
                "c51b7d",
                "de77ae",
                "f1b6da",
                "fde0ef",
                "f7f7f7",
                "e6f5d0",
                "b8e186",
                "7fbc41",
                "4d9221"
            ],
            10: [
                "8e0152",
                "c51b7d",
                "de77ae",
                "f1b6da",
                "fde0ef",
                "e6f5d0",
                "b8e186",
                "7fbc41",
                "4d9221",
                "276419"
            ],
            11: [
                "8e0152",
                "c51b7d",
                "de77ae",
                "f1b6da",
                "fde0ef",
                "f7f7f7",
                "e6f5d0",
                "b8e186",
                "7fbc41",
                "4d9221",
                "276419"
            ]
        },
        RdBu: {
            type: "diverging",
            cbf: 42,
            3: [
                "ef8a62",
                "f7f7f7",
                "67a9cf"
            ],
            4: [
                "ca0020",
                "f4a582",
                "92c5de",
                "0571b0"
            ],
            5: [
                "ca0020",
                "f4a582",
                "f7f7f7",
                "92c5de",
                "0571b0"
            ],
            6: [
                "b2182b",
                "ef8a62",
                "fddbc7",
                "d1e5f0",
                "67a9cf",
                "2166ac"
            ],
            7: [
                "b2182b",
                "ef8a62",
                "fddbc7",
                "f7f7f7",
                "d1e5f0",
                "67a9cf",
                "2166ac"
            ],
            8: [
                "b2182b",
                "d6604d",
                "f4a582",
                "fddbc7",
                "d1e5f0",
                "92c5de",
                "4393c3",
                "2166ac"
            ],
            9: [
                "b2182b",
                "d6604d",
                "f4a582",
                "fddbc7",
                "f7f7f7",
                "d1e5f0",
                "92c5de",
                "4393c3",
                "2166ac"
            ],
            10: [
                "67001f",
                "b2182b",
                "d6604d",
                "f4a582",
                "fddbc7",
                "d1e5f0",
                "92c5de",
                "4393c3",
                "2166ac",
                "053061"
            ],
            11: [
                "67001f",
                "b2182b",
                "d6604d",
                "f4a582",
                "fddbc7",
                "f7f7f7",
                "d1e5f0",
                "92c5de",
                "4393c3",
                "2166ac",
                "053061"
            ]
        },
        RdGy: {
            type: "diverging",
            cbf: 42,
            3: [
                "ef8a62",
                "ffffff",
                "999999"
            ],
            4: [
                "ca0020",
                "f4a582",
                "bababa",
                "404040"
            ],
            5: [
                "ca0020",
                "f4a582",
                "ffffff",
                "bababa",
                "404040"
            ],
            6: [
                "b2182b",
                "ef8a62",
                "fddbc7",
                "e0e0e0",
                "999999",
                "4d4d4d"
            ],
            7: [
                "b2182b",
                "ef8a62",
                "fddbc7",
                "ffffff",
                "e0e0e0",
                "999999",
                "4d4d4d"
            ],
            8: [
                "b2182b",
                "d6604d",
                "f4a582",
                "fddbc7",
                "e0e0e0",
                "bababa",
                "878787",
                "4d4d4d"
            ],
            9: [
                "b2182b",
                "d6604d",
                "f4a582",
                "fddbc7",
                "ffffff",
                "e0e0e0",
                "bababa",
                "878787",
                "4d4d4d"
            ],
            10: [
                "67001f",
                "b2182b",
                "d6604d",
                "f4a582",
                "fddbc7",
                "e0e0e0",
                "bababa",
                "878787",
                "4d4d4d",
                "1a1a1a"
            ],
            11: [
                "67001f",
                "b2182b",
                "d6604d",
                "f4a582",
                "fddbc7",
                "ffffff",
                "e0e0e0",
                "bababa",
                "878787",
                "4d4d4d",
                "1a1a1a"
            ]
        },
        RdYlBu: {
            type: "diverging",
            cbf: 42,
            3: [
                "fc8d59",
                "ffffbf",
                "91bfdb"
            ],
            4: [
                "d7191c",
                "fdae61",
                "abd9e9",
                "2c7bb6"
            ],
            5: [
                "d7191c",
                "fdae61",
                "ffffbf",
                "abd9e9",
                "2c7bb6"
            ],
            6: [
                "d73027",
                "fc8d59",
                "fee090",
                "e0f3f8",
                "91bfdb",
                "4575b4"
            ],
            7: [
                "d73027",
                "fc8d59",
                "fee090",
                "ffffbf",
                "e0f3f8",
                "91bfdb",
                "4575b4"
            ],
            8: [
                "d73027",
                "f46d43",
                "fdae61",
                "fee090",
                "e0f3f8",
                "abd9e9",
                "74add1",
                "4575b4"
            ],
            9: [
                "d73027",
                "f46d43",
                "fdae61",
                "fee090",
                "ffffbf",
                "e0f3f8",
                "abd9e9",
                "74add1",
                "4575b4"
            ],
            10: [
                "a50026",
                "d73027",
                "f46d43",
                "fdae61",
                "fee090",
                "e0f3f8",
                "abd9e9",
                "74add1",
                "4575b4",
                "313695"
            ],
            11: [
                "a50026",
                "d73027",
                "f46d43",
                "fdae61",
                "fee090",
                "ffffbf",
                "e0f3f8",
                "abd9e9",
                "74add1",
                "4575b4",
                "313695"
            ]
        },
        Spectral: {
            type: "diverging",
            cbf: 0,
            3: [
                "fc8d59",
                "ffffbf",
                "99d594"
            ],
            4: [
                "d7191c",
                "fdae61",
                "abdda4",
                "2b83ba"
            ],
            5: [
                "d7191c",
                "fdae61",
                "ffffbf",
                "abdda4",
                "2b83ba"
            ],
            6: [
                "d53e4f",
                "fc8d59",
                "fee08b",
                "e6f598",
                "99d594",
                "3288bd"
            ],
            7: [
                "d53e4f",
                "fc8d59",
                "fee08b",
                "ffffbf",
                "e6f598",
                "99d594",
                "3288bd"
            ],
            8: [
                "d53e4f",
                "f46d43",
                "fdae61",
                "fee08b",
                "e6f598",
                "abdda4",
                "66c2a5",
                "3288bd"
            ],
            9: [
                "d53e4f",
                "f46d43",
                "fdae61",
                "fee08b",
                "ffffbf",
                "e6f598",
                "abdda4",
                "66c2a5",
                "3288bd"
            ],
            10: [
                "9e0142",
                "d53e4f",
                "f46d43",
                "fdae61",
                "fee08b",
                "e6f598",
                "abdda4",
                "66c2a5",
                "3288bd",
                "5e4fa2"
            ],
            11: [
                "9e0142",
                "d53e4f",
                "f46d43",
                "fdae61",
                "fee08b",
                "ffffbf",
                "e6f598",
                "abdda4",
                "66c2a5",
                "3288bd",
                "5e4fa2"
            ]
        },
        RdYlGn: {
            type: "diverging",
            cbf: 0,
            3: [
                "fc8d59",
                "ffffbf",
                "91cf60"
            ],
            4: [
                "d7191c",
                "fdae61",
                "a6d96a",
                "1a9641"
            ],
            5: [
                "d7191c",
                "fdae61",
                "ffffbf",
                "a6d96a",
                "1a9641"
            ],
            6: [
                "d73027",
                "fc8d59",
                "fee08b",
                "d9ef8b",
                "91cf60",
                "1a9850"
            ],
            7: [
                "d73027",
                "fc8d59",
                "fee08b",
                "ffffbf",
                "d9ef8b",
                "91cf60",
                "1a9850"
            ],
            8: [
                "d73027",
                "f46d43",
                "fdae61",
                "fee08b",
                "d9ef8b",
                "a6d96a",
                "66bd63",
                "1a9850"
            ],
            9: [
                "d73027",
                "f46d43",
                "fdae61",
                "fee08b",
                "ffffbf",
                "d9ef8b",
                "a6d96a",
                "66bd63",
                "1a9850"
            ],
            10: [
                "a50026",
                "d73027",
                "f46d43",
                "fdae61",
                "fee08b",
                "d9ef8b",
                "a6d96a",
                "66bd63",
                "1a9850",
                "006837"
            ],
            11: [
                "a50026",
                "d73027",
                "f46d43",
                "fdae61",
                "fee08b",
                "ffffbf",
                "d9ef8b",
                "a6d96a",
                "66bd63",
                "1a9850",
                "006837"
            ]
        },
        Accent: {
            type: "qualitative",
            cbf: 0,
            3: [
                "7fc97f",
                "beaed4",
                "fdc086"
            ],
            4: [
                "7fc97f",
                "beaed4",
                "fdc086",
                "ffff99"
            ],
            5: [
                "7fc97f",
                "beaed4",
                "fdc086",
                "ffff99",
                "386cb0"
            ],
            6: [
                "7fc97f",
                "beaed4",
                "fdc086",
                "ffff99",
                "386cb0",
                "f0027f"
            ],
            7: [
                "7fc97f",
                "beaed4",
                "fdc086",
                "ffff99",
                "386cb0",
                "f0027f",
                "bf5b17"
            ],
            8: [
                "7fc97f",
                "beaed4",
                "fdc086",
                "ffff99",
                "386cb0",
                "f0027f",
                "bf5b17",
                "666666"
            ]
        },
        Dark2: {
            type: "qualitative",
            cbf: 3,
            3: [
                "1b9e77",
                "d95f02",
                "7570b3"
            ],
            4: [
                "1b9e77",
                "d95f02",
                "7570b3",
                "e7298a"
            ],
            5: [
                "1b9e77",
                "d95f02",
                "7570b3",
                "e7298a",
                "66a61e"
            ],
            6: [
                "1b9e77",
                "d95f02",
                "7570b3",
                "e7298a",
                "66a61e",
                "e6ab02"
            ],
            7: [
                "1b9e77",
                "d95f02",
                "7570b3",
                "e7298a",
                "66a61e",
                "e6ab02",
                "a6761d"
            ],
            8: [
                "1b9e77",
                "d95f02",
                "7570b3",
                "e7298a",
                "66a61e",
                "e6ab02",
                "a6761d",
                "666666"
            ]
        },
        Paired: {
            type: "qualitative",
            cbf: 4,
            3: [
                "a6cee3",
                "1f78b4",
                "b2df8a"
            ],
            4: [
                "a6cee3",
                "1f78b4",
                "b2df8a",
                "33a02c"
            ],
            5: [
                "a6cee3",
                "1f78b4",
                "b2df8a",
                "33a02c",
                "fb9a99"
            ],
            6: [
                "a6cee3",
                "1f78b4",
                "b2df8a",
                "33a02c",
                "fb9a99",
                "e31a1c"
            ],
            7: [
                "a6cee3",
                "1f78b4",
                "b2df8a",
                "33a02c",
                "fb9a99",
                "e31a1c",
                "fdbf6f"
            ],
            8: [
                "a6cee3",
                "1f78b4",
                "b2df8a",
                "33a02c",
                "fb9a99",
                "e31a1c",
                "fdbf6f",
                "ff7f00"
            ],
            9: [
                "a6cee3",
                "1f78b4",
                "b2df8a",
                "33a02c",
                "fb9a99",
                "e31a1c",
                "fdbf6f",
                "ff7f00",
                "cab2d6"
            ],
            10: [
                "a6cee3",
                "1f78b4",
                "b2df8a",
                "33a02c",
                "fb9a99",
                "e31a1c",
                "fdbf6f",
                "ff7f00",
                "cab2d6",
                "6a3d9a"
            ],
            11: [
                "a6cee3",
                "1f78b4",
                "b2df8a",
                "33a02c",
                "fb9a99",
                "e31a1c",
                "fdbf6f",
                "ff7f00",
                "cab2d6",
                "6a3d9a",
                "ffff99"
            ],
            12: [
                "a6cee3",
                "1f78b4",
                "b2df8a",
                "33a02c",
                "fb9a99",
                "e31a1c",
                "fdbf6f",
                "ff7f00",
                "cab2d6",
                "6a3d9a",
                "ffff99",
                "b15928"
            ]
        },
        Pastel1: {
            type: "qualitative",
            cbf: 0,
            3: [
                "fbb4ae",
                "b3cde3",
                "ccebc5"
            ],
            4: [
                "fbb4ae",
                "b3cde3",
                "ccebc5",
                "decbe4"
            ],
            5: [
                "fbb4ae",
                "b3cde3",
                "ccebc5",
                "decbe4",
                "fed9a6"
            ],
            6: [
                "fbb4ae",
                "b3cde3",
                "ccebc5",
                "decbe4",
                "fed9a6",
                "ffffcc"
            ],
            7: [
                "fbb4ae",
                "b3cde3",
                "ccebc5",
                "decbe4",
                "fed9a6",
                "ffffcc",
                "e5d8bd"
            ],
            8: [
                "fbb4ae",
                "b3cde3",
                "ccebc5",
                "decbe4",
                "fed9a6",
                "ffffcc",
                "e5d8bd",
                "fddaec"
            ],
            9: [
                "fbb4ae",
                "b3cde3",
                "ccebc5",
                "decbe4",
                "fed9a6",
                "ffffcc",
                "e5d8bd",
                "fddaec",
                "f2f2f2"
            ]
        },
        Pastel2: {
            type: "qualitative",
            cbf: 0,
            3: [
                "b3e2cd",
                "fdcdac",
                "cbd5e8"
            ],
            4: [
                "b3e2cd",
                "fdcdac",
                "cbd5e8",
                "f4cae4"
            ],
            5: [
                "b3e2cd",
                "fdcdac",
                "cbd5e8",
                "f4cae4",
                "e6f5c9"
            ],
            6: [
                "b3e2cd",
                "fdcdac",
                "cbd5e8",
                "f4cae4",
                "e6f5c9",
                "fff2ae"
            ],
            7: [
                "b3e2cd",
                "fdcdac",
                "cbd5e8",
                "f4cae4",
                "e6f5c9",
                "fff2ae",
                "f1e2cc"
            ],
            8: [
                "b3e2cd",
                "fdcdac",
                "cbd5e8",
                "f4cae4",
                "e6f5c9",
                "fff2ae",
                "f1e2cc",
                "cccccc"
            ]
        },
        Set1: {
            type: "qualitative",
            cbf: 0,
            3: [
                "e41a1c",
                "377eb8",
                "4daf4a"
            ],
            4: [
                "e41a1c",
                "377eb8",
                "4daf4a",
                "984ea3"
            ],
            5: [
                "e41a1c",
                "377eb8",
                "4daf4a",
                "984ea3",
                "ff7f00"
            ],
            6: [
                "e41a1c",
                "377eb8",
                "4daf4a",
                "984ea3",
                "ff7f00",
                "ffff33"
            ],
            7: [
                "e41a1c",
                "377eb8",
                "4daf4a",
                "984ea3",
                "ff7f00",
                "ffff33",
                "a65628"
            ],
            8: [
                "e41a1c",
                "377eb8",
                "4daf4a",
                "984ea3",
                "ff7f00",
                "ffff33",
                "a65628",
                "f781bf"
            ],
            9: [
                "e41a1c",
                "377eb8",
                "4daf4a",
                "984ea3",
                "ff7f00",
                "ffff33",
                "a65628",
                "f781bf",
                "999999"
            ]
        },
        Set2: {
            type: "qualitative",
            cbf: 3,
            3: [
                "66c2a5",
                "fc8d62",
                "8da0cb"
            ],
            4: [
                "66c2a5",
                "fc8d62",
                "8da0cb",
                "e78ac3"
            ],
            5: [
                "66c2a5",
                "fc8d62",
                "8da0cb",
                "e78ac3",
                "a6d854"
            ],
            6: [
                "66c2a5",
                "fc8d62",
                "8da0cb",
                "e78ac3",
                "a6d854",
                "ffd92f"
            ],
            7: [
                "66c2a5",
                "fc8d62",
                "8da0cb",
                "e78ac3",
                "a6d854",
                "ffd92f",
                "e5c494"
            ],
            8: [
                "66c2a5",
                "fc8d62",
                "8da0cb",
                "e78ac3",
                "a6d854",
                "ffd92f",
                "e5c494",
                "b3b3b3"
            ]
        },
        Set3: {
            type: "qualitative",
            cbf: 0,
            3: [
                "8dd3c7",
                "ffffb3",
                "bebada"
            ],
            4: [
                "8dd3c7",
                "ffffb3",
                "bebada",
                "fb8072"
            ],
            5: [
                "8dd3c7",
                "ffffb3",
                "bebada",
                "fb8072",
                "80b1d3"
            ],
            6: [
                "8dd3c7",
                "ffffb3",
                "bebada",
                "fb8072",
                "80b1d3",
                "fdb462"
            ],
            7: [
                "8dd3c7",
                "ffffb3",
                "bebada",
                "fb8072",
                "80b1d3",
                "fdb462",
                "b3de69"
            ],
            8: [
                "8dd3c7",
                "ffffb3",
                "bebada",
                "fb8072",
                "80b1d3",
                "fdb462",
                "b3de69",
                "fccde5"
            ],
            9: [
                "8dd3c7",
                "ffffb3",
                "bebada",
                "fb8072",
                "80b1d3",
                "fdb462",
                "b3de69",
                "fccde5",
                "d9d9d9"
            ],
            10: [
                "8dd3c7",
                "ffffb3",
                "bebada",
                "fb8072",
                "80b1d3",
                "fdb462",
                "b3de69",
                "fccde5",
                "d9d9d9",
                "bc80bd"
            ],
            11: [
                "8dd3c7",
                "ffffb3",
                "bebada",
                "fb8072",
                "80b1d3",
                "fdb462",
                "b3de69",
                "fccde5",
                "d9d9d9",
                "bc80bd",
                "ccebc5"
            ],
            12: [
                "8dd3c7",
                "ffffb3",
                "bebada",
                "fb8072",
                "80b1d3",
                "fdb462",
                "b3de69",
                "fccde5",
                "d9d9d9",
                "bc80bd",
                "ccebc5",
                "ffed6f"
            ]
        }
    };
    for(var name in schemes){
        var scheme = schemes[name];
        scheme = $6d026be3651d0191$var$palette.Scheme.fromPalettes("cb-" + name, [
            scheme.type,
            "cb-" + scheme.type
        ], scheme, 12, scheme.cbf);
        $6d026be3651d0191$var$palette.register(scheme);
    }
})();
if (0, module.exports) module.exports = $6d026be3651d0191$var$palette;

});


parcelRegister("hOC41", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf84a1e4f1be1c09$export$2e2bcd8739ae039);
let $cf84a1e4f1be1c09$var$script;



let $cf84a1e4f1be1c09$var$initialize = ()=>{
    $cf84a1e4f1be1c09$var$script = (parcelRequire("9Hvpo"));
    if ($cf84a1e4f1be1c09$var$script.__esModule) $cf84a1e4f1be1c09$var$script = $cf84a1e4f1be1c09$var$script.default;
    $cf84a1e4f1be1c09$var$script.render = (parcelRequire("kW4Rc")).render;
    (parcelRequire("2D8u5")).default($cf84a1e4f1be1c09$var$script);
    $cf84a1e4f1be1c09$var$script.__scopeId = "data-v-28d807";
    $cf84a1e4f1be1c09$var$script.__file = "Notifications.vue";
};
$cf84a1e4f1be1c09$var$initialize();
var $cf84a1e4f1be1c09$export$2e2bcd8739ae039 = $cf84a1e4f1be1c09$var$script;

});
parcelRegister("9Hvpo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $71007e4b3a347790$export$2e2bcd8739ae039);
parcelRequire("giao7");
var $4mYx6 = parcelRequire("4mYx6");
var $71007e4b3a347790$export$2e2bcd8739ae039 = {
    __name: "Notifications",
    setup (__props, { expose: __expose }) {
        __expose();
        const notifications = (0, $4mYx6.inject)("notifications");
        const __returned__ = {
            notifications: notifications,
            inject: $4mYx6.inject
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("kW4Rc", function(module, exports) {

$parcel$export(module.exports, "render", () => $f3dcfde98896bd07$export$b3890eb0ae9dca99);
parcelRequire("giao7");
var $4mYx6 = parcelRequire("4mYx6");
var $a5gC8 = parcelRequire("a5gC8");
const $f3dcfde98896bd07$var$_hoisted_1 = {
    class: "section"
};
const $f3dcfde98896bd07$var$_hoisted_2 = [
    "onClick"
];
function $f3dcfde98896bd07$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $4mYx6.openBlock)(), (0, $4mYx6.createElementBlock)("div", $f3dcfde98896bd07$var$_hoisted_1, [
        ((0, $4mYx6.openBlock)(true), (0, $4mYx6.createElementBlock)((0, $4mYx6.Fragment), null, (0, $4mYx6.renderList)($setup.notifications.getAll(), (notification)=>{
            return (0, $4mYx6.openBlock)(), (0, $4mYx6.createElementBlock)("div", {
                key: notification.id,
                class: (0, $a5gC8.normalizeClass)([
                    "notification",
                    {
                        "is-primary": notification.type === "info",
                        "is-danger": notification.type === "error"
                    }
                ])
            }, [
                (0, $4mYx6.createTextVNode)((0, $a5gC8.toDisplayString)(notification.message) + " ", 1),
                (0, $4mYx6.createElementVNode)("button", {
                    class: "delete",
                    onClick: ()=>$setup.notifications.delete(notification)
                }, null, 8, $f3dcfde98896bd07$var$_hoisted_2)
            ], 2);
        }), 128))
    ]);
}

});

parcelRegister("2D8u5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ea5ce1b82e23a78$export$2e2bcd8739ae039);
let $1ea5ce1b82e23a78$var$NOOP = ()=>{};
var $1ea5ce1b82e23a78$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("lskpI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9ec0c43189885dd$export$2e2bcd8739ae039);
let $f9ec0c43189885dd$var$script;



let $f9ec0c43189885dd$var$initialize = ()=>{
    $f9ec0c43189885dd$var$script = (parcelRequire("4ANf4"));
    if ($f9ec0c43189885dd$var$script.__esModule) $f9ec0c43189885dd$var$script = $f9ec0c43189885dd$var$script.default;
    $f9ec0c43189885dd$var$script.render = (parcelRequire("a4IYD")).render;
    (parcelRequire("ftZLs")).default($f9ec0c43189885dd$var$script);
    $f9ec0c43189885dd$var$script.__scopeId = "data-v-3f25aa";
    $f9ec0c43189885dd$var$script.__file = "Disclaimer.vue";
};
$f9ec0c43189885dd$var$initialize();
var $f9ec0c43189885dd$export$2e2bcd8739ae039 = $f9ec0c43189885dd$var$script;

});
parcelRegister("4ANf4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3580b8aa82e8265d$export$2e2bcd8739ae039);
var $3580b8aa82e8265d$export$2e2bcd8739ae039 = {
    __name: "Disclaimer",
    emits: [
        "close-overlay"
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const emit = __emit;
        const __returned__ = {
            emit: emit
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("a4IYD", function(module, exports) {

$parcel$export(module.exports, "render", () => $755d2a9bb41ab8a3$export$b3890eb0ae9dca99);
parcelRequire("giao7");
var $4mYx6 = parcelRequire("4mYx6");
const $755d2a9bb41ab8a3$var$_hoisted_1 = {
    class: "modal is-active"
};
const $755d2a9bb41ab8a3$var$_hoisted_2 = {
    class: "modal-card"
};
const $755d2a9bb41ab8a3$var$_hoisted_3 = {
    class: "modal-card-head"
};
function $755d2a9bb41ab8a3$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $4mYx6.openBlock)(), (0, $4mYx6.createElementBlock)("div", $755d2a9bb41ab8a3$var$_hoisted_1, [
        _cache[3] || (_cache[3] = (0, $4mYx6.createElementVNode)("div", {
            class: "modal-background"
        }, null, -1)),
        (0, $4mYx6.createElementVNode)("div", $755d2a9bb41ab8a3$var$_hoisted_2, [
            (0, $4mYx6.createElementVNode)("header", $755d2a9bb41ab8a3$var$_hoisted_3, [
                _cache[1] || (_cache[1] = (0, $4mYx6.createElementVNode)("p", {
                    class: "modal-card-title"
                }, "Disclaimer", -1)),
                (0, $4mYx6.createElementVNode)("button", {
                    class: "delete",
                    "aria-label": "close",
                    onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$emit("close-overlay"))
                })
            ]),
            _cache[2] || (_cache[2] = (0, $4mYx6.createStaticVNode)('<section class="modal-card-body"><div class="content"><h1>Disclaimer for ridger.io</h1> If you require any more information or have any questions about our site&#39;s disclaimer, please feel free to contact us by email at ridger@fxstr.com. <h2>Purpose and Source</h2> ridger.io gives you easy access to the Tearsheet open source project (see <a href="https://github.com/fxstr/tearsheet">GitHub</a>) to interactively visualize portfolio information. <h2>Data</h2> None of the portfolio data you provide to this website leaves your device. All data is processed strictly in your browser and is not sent to or stored on a server. The data is only used to generate the visualizations you see on the website. <h2>Disclaimers for riger.io</h2> All the information on this website is published in good faith and for general information purpose only. ridger.io does not make any warranties about the completeness, reliability and accuracy of this information. Any action you take upon the information you find on ridger.io, is strictly at your own risk. ridger.io will not be liable for any losses and/or damages in connection with the use of ridger.io. From our website, you can visit other websites by following hyperlinks to such external sites. While we strive to provide only quality links to useful and ethical websites, we have no control over the content and nature of these sites. These links to other websites do not imply a recommendation for all the content found on these sites. Site owners and content may change without notice and may occur before we have the opportunity to remove a link which may have gone &#39;bad&#39;. Please be also aware that when you leave our website, other sites may have different privacy policies and terms which are beyond our control. Please be sure to check the Privacy Policies of these sites as well as their &quot;Terms of Service&quot; before engaging in any business or uploading any information. <h2>Consent</h2> By using our website, you hereby consent to our disclaimer and agree to its terms. </div></section>', 1))
        ])
    ]);
}

});

parcelRegister("ftZLs", function(module, exports) {

$parcel$export(module.exports, "default", () => $b45979987a34a9f3$export$2e2bcd8739ae039);
let $b45979987a34a9f3$var$NOOP = ()=>{};
var $b45979987a34a9f3$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("hL1qx", function(module, exports) {

$parcel$export(module.exports, "default", () => $ced7eed23ae0a453$export$2e2bcd8739ae039);
parcelRequire("giao7");
var $9K9BQ = parcelRequire("9K9BQ");

var $8byxv = parcelRequire("8byxv");
class $ced7eed23ae0a453$export$2e2bcd8739ae039 {
    #notifications = (0, $9K9BQ.ref)([]);
    /**
     * Add notification from strings (instead of Notification object) in order to simplify the
     * usage from wherever we call this method.
     */ add(message, type) {
        console.log("Add notification", message, type);
        this.#notifications.value.push(new (0, $8byxv.default)(message, type));
    }
    delete(notificationToRemove) {
        this.#notifications.value = this.#notifications.value.filter((notification)=>notification !== notificationToRemove);
    }
    getAll() {
        return this.#notifications.value;
    }
}

});
parcelRegister("8byxv", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f5a249f845b8681$export$2e2bcd8739ae039);

var $aKqH2 = parcelRequire("aKqH2");
class $5f5a249f845b8681$export$2e2bcd8739ae039 {
    constructor(message, type = "info"){
        if (![
            "info",
            "error"
        ].includes(type)) throw new Error(`Invalid notification type: ${type}.`);
        if (!message) throw new Error(`Notification message is required, you passed ${JSON.stringify(message)} instead.`);
        this.message = message;
        this.type = type;
        this.id = (0, $aKqH2.default)();
    }
}

});


parcelRegister("32U48", function(module, exports) {

$parcel$export(module.exports, "default", () => $237d0c819cffaf82$export$2e2bcd8739ae039);
let $237d0c819cffaf82$var$script;



let $237d0c819cffaf82$var$initialize = ()=>{
    $237d0c819cffaf82$var$script = (parcelRequire("lqms9"));
    if ($237d0c819cffaf82$var$script.__esModule) $237d0c819cffaf82$var$script = $237d0c819cffaf82$var$script.default;
    $237d0c819cffaf82$var$script.render = (parcelRequire("7UWg9")).render;
    (parcelRequire("drAj1")).default($237d0c819cffaf82$var$script);
    $237d0c819cffaf82$var$script.__scopeId = "data-v-15d5dd";
    $237d0c819cffaf82$var$script.__file = "AddSeriesBox.vue";
};
$237d0c819cffaf82$var$initialize();
var $237d0c819cffaf82$export$2e2bcd8739ae039 = $237d0c819cffaf82$var$script;

});
parcelRegister("lqms9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f98d71677bc0729f$export$2e2bcd8739ae039);
parcelRequire("giao7");
var $9K9BQ = parcelRequire("9K9BQ");
var $4mYx6 = parcelRequire("4mYx6");

var $9qJfi = parcelRequire("9qJfi");

var $aCMDZ = parcelRequire("aCMDZ");
var $f98d71677bc0729f$export$2e2bcd8739ae039 = {
    __name: "AddSeriesBox",
    props: {
        timeSeriesCollection: {
            type: Object,
            required: true
        },
        isAddSeriesBoxVisible: Boolean
    },
    emits: [
        "fileUploaded",
        "fileUrlAdded",
        "changeAddSeriesBoxVisibility"
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const notifications = (0, $4mYx6.inject)("notifications");
        const props = __props;
        const emit = __emit;
        const hasAtLeastOneTimeSeries = (0, $9K9BQ.computed)(()=>props.timeSeriesCollection.timeSeries.length > 0);
        const handleUpload = async (event)=>{
            try {
                const allContent = await (0, $9qJfi.default)(event.target);
                console.log("Adding files \u2026");
                allContent.forEach((fileContent)=>{
                    props.timeSeriesCollection.addFromCSV(fileContent);
                });
                console.log("Files added.");
                emit("fileUploaded");
                notifications.add(`Successfully added file.`, "info");
            } catch (err) {
                notifications.add(`Could not read file: ${err.message}`, "error");
            }
        };
        // If box becomes visible, scroll to it to make sure user notice it
        (0, $9K9BQ.watch)(()=>props.isAddSeriesBoxVisible, (newValue)=>{
            if (newValue) window.scrollTo(0, 0);
        }, // For whatever reason, this does not work without immediate
        {
            immediate: true
        });
        /**
     * Persist file URLs in the URL's hash in order to make them shareable/persistable; use hash
     * (instead of search) to prevent reloads.
     */ const handleAddURL = (event)=>{
            const formData = new FormData(event.target);
            const fileURL = formData.get("fileURL");
            (0, $aCMDZ.default)("file-url", fileURL);
            emit("fileUrlAdded", fileURL);
        };
        const __returned__ = {
            notifications: notifications,
            props: props,
            emit: emit,
            hasAtLeastOneTimeSeries: hasAtLeastOneTimeSeries,
            handleUpload: handleUpload,
            handleAddURL: handleAddURL,
            watch: $9K9BQ.watch,
            inject: $4mYx6.inject,
            computed: $9K9BQ.computed,
            get readFiles () {
                return 0, $9qJfi.default;
            },
            get modifySearchParams () {
                return 0, $aCMDZ.default;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("9qJfi", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dd9a3a04ebbc5a6$export$2e2bcd8739ae039);
/**
 * Reads a file from file input / drop on an element
 */ var $6dd9a3a04ebbc5a6$export$2e2bcd8739ae039 = async ({ files: files } = {})=>{
    console.log("read files", files);
    return Promise.all([
        ...files
    ].map($6dd9a3a04ebbc5a6$var$readFile));
};
const $6dd9a3a04ebbc5a6$var$readFile = (file)=>{
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener("load", (event)=>{
            resolve(event.target.result);
        });
        reader.addEventListener("error", (err)=>{
            reject(err);
        });
        reader.readAsText(file);
    });
};

});

parcelRegister("aCMDZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bc32fb0a265445d$export$2e2bcd8739ae039);
var $7bc32fb0a265445d$export$2e2bcd8739ae039 = (name, value, overrideExisting = false)=>{
    const searchParams = new URLSearchParams(window.location.search);
    const method = overrideExisting ? "set" : "append";
    searchParams[method](name, value);
    window.history.pushState({}, "", `${window.location.pathname}?${searchParams.toString()}${window.location.hash ? "#" : ""}${window.location.hash}`);
};

});


parcelRegister("7UWg9", function(module, exports) {

$parcel$export(module.exports, "render", () => $5c3af47820847c6d$export$b3890eb0ae9dca99);
parcelRequire("giao7");
var $4mYx6 = parcelRequire("4mYx6");
var $5on3n = parcelRequire("5on3n");
const $5c3af47820847c6d$var$_hoisted_1 = {
    class: "box"
};
const $5c3af47820847c6d$var$_hoisted_2 = {
    class: "content"
};
const $5c3af47820847c6d$var$_hoisted_3 = {
    class: "level"
};
const $5c3af47820847c6d$var$_hoisted_4 = {
    class: "level-right"
};
const $5c3af47820847c6d$var$_hoisted_5 = {
    class: "level-item"
};
const $5c3af47820847c6d$var$_hoisted_6 = {
    class: "columns mb-6 mt-6"
};
const $5c3af47820847c6d$var$_hoisted_7 = {
    class: "column"
};
const $5c3af47820847c6d$var$_hoisted_8 = {
    class: "card has-background-info"
};
const $5c3af47820847c6d$var$_hoisted_9 = {
    class: "card-content has-text-white"
};
const $5c3af47820847c6d$var$_hoisted_10 = {
    class: "file"
};
const $5c3af47820847c6d$var$_hoisted_11 = {
    class: "file-label"
};
const $5c3af47820847c6d$var$_hoisted_12 = {
    class: "column"
};
const $5c3af47820847c6d$var$_hoisted_13 = {
    class: "card has-background-info"
};
function $5c3af47820847c6d$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $4mYx6.openBlock)(), (0, $4mYx6.createElementBlock)("div", $5c3af47820847c6d$var$_hoisted_1, [
        (0, $4mYx6.createElementVNode)("div", $5c3af47820847c6d$var$_hoisted_2, [
            (0, $4mYx6.createElementVNode)("div", $5c3af47820847c6d$var$_hoisted_3, [
                _cache[2] || (_cache[2] = (0, $4mYx6.createElementVNode)("div", {
                    class: "level-left"
                }, [
                    (0, $4mYx6.createElementVNode)("div", {
                        class: "level-item"
                    }, [
                        (0, $4mYx6.createElementVNode)("h1", {
                            class: "title is-1"
                        }, " Your Online Tearsheet ")
                    ])
                ], -1)),
                (0, $4mYx6.createElementVNode)("div", $5c3af47820847c6d$var$_hoisted_4, [
                    (0, $4mYx6.createElementVNode)("div", $5c3af47820847c6d$var$_hoisted_5, [
                        $setup.hasAtLeastOneTimeSeries ? ((0, $4mYx6.openBlock)(), (0, $4mYx6.createElementBlock)("button", {
                            key: 0,
                            class: "delete",
                            onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$emit("changeAddSeriesBoxVisibility", false))
                        })) : (0, $4mYx6.createCommentVNode)("", true)
                    ])
                ])
            ]),
            _cache[7] || (_cache[7] = (0, $4mYx6.createElementVNode)("p", null, "Add your trading results to get insights into their performance:", -1)),
            (0, $4mYx6.createElementVNode)("div", $5c3af47820847c6d$var$_hoisted_6, [
                (0, $4mYx6.createElementVNode)("div", $5c3af47820847c6d$var$_hoisted_7, [
                    (0, $4mYx6.createElementVNode)("div", $5c3af47820847c6d$var$_hoisted_8, [
                        (0, $4mYx6.createElementVNode)("div", $5c3af47820847c6d$var$_hoisted_9, [
                            _cache[4] || (_cache[4] = (0, $4mYx6.createElementVNode)("div", {
                                class: "is-size-3"
                            }, " Drop a CSV file ", -1)),
                            _cache[5] || (_cache[5] = (0, $4mYx6.createElementVNode)("p", null, "on this window or upload:", -1)),
                            (0, $4mYx6.createElementVNode)("div", $5c3af47820847c6d$var$_hoisted_10, [
                                (0, $4mYx6.createElementVNode)("label", $5c3af47820847c6d$var$_hoisted_11, [
                                    (0, $4mYx6.createElementVNode)("input", {
                                        class: "file-input is-medium",
                                        type: "file",
                                        onChange: _cache[1] || (_cache[1] = ($event)=>$setup.handleUpload($event))
                                    }, null, 32),
                                    _cache[3] || (_cache[3] = (0, $4mYx6.createElementVNode)("span", {
                                        class: "file-cta"
                                    }, [
                                        (0, $4mYx6.createElementVNode)("span", {
                                            class: "file-label"
                                        }, " Choose a file\u2026 ")
                                    ], -1))
                                ])
                            ])
                        ])
                    ])
                ]),
                (0, $4mYx6.createElementVNode)("div", $5c3af47820847c6d$var$_hoisted_12, [
                    (0, $4mYx6.createElementVNode)("div", $5c3af47820847c6d$var$_hoisted_13, [
                        (0, $4mYx6.createElementVNode)("form", {
                            class: "card-content has-text-white",
                            onSubmit: (0, $5on3n.withModifiers)($setup.handleAddURL, [
                                "prevent"
                            ])
                        }, _cache[6] || (_cache[6] = [
                            (0, $4mYx6.createStaticVNode)('<div class="is-size-3 mb-3"> Load CSV from URL </div><div class="field has-addons"><div class="control is-expanded"><input class="input is-medium" type="text" name="fileURL" placeholder="URL to CSV file"></div><div class="control"><button class="button is-link is-medium"> Load </button></div></div>', 2)
                        ]), 32)
                    ])
                ])
            ]),
            _cache[8] || (_cache[8] = (0, $4mYx6.createStaticVNode)('<div class="pt-5 has-text-grey notification"><h1>Instructions</h1><p>Use the following structure for your CSV files:</p><ul><li>The first column contains dates.</li><li>The subsequent columns contain one series per column.</li><li>A column&#39;s head will be used as the series&#39; name.</li><li>Use <code>parameter=value</code> (with value being a number) in the head to compare series in a heatmap</li></ul><h4 class="mt-6">Example</h4><table class="is-family-monospace has-text-weight-semibold"><tr><tr><td>Date</td><td>fast=10, slow=50</td><td>fast=15, slow=75</td></tr><tr><td>2024-01-01</td><td>127</td><td>183</td></tr><tr><td>2024-01-02</td><td>129</td><td>181</td></tr></tr></table></div>', 1))
        ])
    ]);
}

});

parcelRegister("drAj1", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c99f58a99d5f81d$export$2e2bcd8739ae039);
let $9c99f58a99d5f81d$var$NOOP = ()=>{};
var $9c99f58a99d5f81d$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("71wOy", function(module, exports) {

$parcel$export(module.exports, "default", () => $51d214ac236e71d3$export$2e2bcd8739ae039);
let $51d214ac236e71d3$var$script;




let $51d214ac236e71d3$var$initialize = ()=>{
    $51d214ac236e71d3$var$script = (parcelRequire("aqp3t"));
    if ($51d214ac236e71d3$var$script.__esModule) $51d214ac236e71d3$var$script = $51d214ac236e71d3$var$script.default;
    $51d214ac236e71d3$var$script.render = (parcelRequire("2M8gD")).render;
    $51d214ac236e71d3$var$script.__cssModules = {};
    (parcelRequire("9PXP6")).default($51d214ac236e71d3$var$script);
    $51d214ac236e71d3$var$script.__scopeId = "data-v-6edc5a";
    $51d214ac236e71d3$var$script.__file = "FileDropHandler.vue";
};
$51d214ac236e71d3$var$initialize();
var $51d214ac236e71d3$export$2e2bcd8739ae039 = $51d214ac236e71d3$var$script;

});
parcelRegister("aqp3t", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $796fc47a569166ef$export$2e2bcd8739ae039);
parcelRequire("giao7");
var $4mYx6 = parcelRequire("4mYx6");
var $9K9BQ = parcelRequire("9K9BQ");

var $9qJfi = parcelRequire("9qJfi");
var $796fc47a569166ef$export$2e2bcd8739ae039 = {
    __name: "FileDropHandler",
    props: {
        timeSeriesCollection: {
            type: Object,
            required: true
        }
    },
    emits: "fileUploaded",
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const notifications = (0, $4mYx6.inject)("notifications");
        const indicateDropTarget = (0, $9K9BQ.ref)(false);
        const props = __props;
        const emit = __emit;
        const handleDragEnter = ()=>{
            indicateDropTarget.value = true;
        };
        const handleDragLeave = ()=>{
            indicateDropTarget.value = false;
        };
        const handleDrop = async (event)=>{
            indicateDropTarget.value = false;
            const allContent = await (0, $9qJfi.default)(event.dataTransfer);
            allContent.forEach((fileContent)=>{
                try {
                    props.timeSeriesCollection.addFromCSV(fileContent);
                    notifications.add("Successfully added CSV file");
                } catch (err) {
                    notifications.add(`Could not add CSV file: ${err.message}`, "error");
                }
            });
            emit("fileUploaded");
        };
        const handleDragOver = ()=>{
            indicateDropTarget.value = true;
        };
        const __returned__ = {
            notifications: notifications,
            indicateDropTarget: indicateDropTarget,
            props: props,
            emit: emit,
            handleDragEnter: handleDragEnter,
            handleDragLeave: handleDragLeave,
            handleDrop: handleDrop,
            handleDragOver: handleDragOver,
            ref: $9K9BQ.ref,
            inject: $4mYx6.inject,
            get readFiles () {
                return 0, $9qJfi.default;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("2M8gD", function(module, exports) {

$parcel$export(module.exports, "render", () => $20567a29bc40df5a$export$b3890eb0ae9dca99);
parcelRequire("giao7");
var $4mYx6 = parcelRequire("4mYx6");
var $a5gC8 = parcelRequire("a5gC8");
var $5on3n = parcelRequire("5on3n");
function $20567a29bc40df5a$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $4mYx6.openBlock)(), (0, $4mYx6.createElementBlock)("div", {
        class: (0, $a5gC8.normalizeClass)({
            "can-drop": $setup.indicateDropTarget,
            "file-drop-handler": true
        }),
        onDragenter: (0, $5on3n.withModifiers)($setup.handleDragEnter, [
            "prevent"
        ]),
        onDragleave: (0, $5on3n.withModifiers)($setup.handleDragLeave, [
            "prevent"
        ]),
        onDragover: (0, $5on3n.withModifiers)($setup.handleDragOver, [
            "prevent"
        ]),
        onDrop: (0, $5on3n.withModifiers)($setup.handleDrop, [
            "prevent"
        ])
    }, [
        (0, $4mYx6.renderSlot)(_ctx.$slots, "default", {}, ()=>[
                _cache[0] || (_cache[0] = (0, $4mYx6.createTextVNode)("Loading Content \u2026"))
            ])
    ], 34);
}

});

parcelRegister("9PXP6", function(module, exports) {

$parcel$export(module.exports, "default", () => $7297481bea41520d$export$2e2bcd8739ae039);
let $7297481bea41520d$var$NOOP = ()=>{};
var $7297481bea41520d$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("88SvS", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ed95b48f7c4591f$export$2e2bcd8739ae039);
let $5ed95b48f7c4591f$var$script;



let $5ed95b48f7c4591f$var$initialize = ()=>{
    $5ed95b48f7c4591f$var$script = (parcelRequire("bzqm5"));
    if ($5ed95b48f7c4591f$var$script.__esModule) $5ed95b48f7c4591f$var$script = $5ed95b48f7c4591f$var$script.default;
    $5ed95b48f7c4591f$var$script.render = (parcelRequire("cxrLj")).render;
    (parcelRequire("cqqID")).default($5ed95b48f7c4591f$var$script);
    $5ed95b48f7c4591f$var$script.__scopeId = "data-v-544521";
    $5ed95b48f7c4591f$var$script.__file = "HeatMap.vue";
};
$5ed95b48f7c4591f$var$initialize();
var $5ed95b48f7c4591f$export$2e2bcd8739ae039 = $5ed95b48f7c4591f$var$script;

});
parcelRegister("bzqm5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $86c7682ce07aa383$export$2e2bcd8739ae039);
parcelRequire("giao7");
var $9K9BQ = parcelRequire("9K9BQ");
var $4mYx6 = parcelRequire("4mYx6");

var $2cr21 = parcelRequire("2cr21");
var $86c7682ce07aa383$export$2e2bcd8739ae039 = {
    __name: "HeatMap",
    props: {
        timeSeriesCollection: {
            type: Object,
            required: true
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const chartContainer = (0, $9K9BQ.ref)(null);
        // Dropdown values
        const xAxisParameter = (0, $9K9BQ.ref)(props.timeSeriesCollection.getAllParameters().at(0));
        const yAxisParameter = (0, $9K9BQ.ref)(props.timeSeriesCollection.getAllParameters().at(1));
        const color = (0, $9K9BQ.ref)("robustRatio");
        let chart;
        /* Only display the chart once the container is ready */ (0, $4mYx6.watchEffect)(async ()=>{
            // At least x-axis and color must be selected to draw the chart
            if (!xAxisParameter.value || !color.value) {
                if (chart) (0, (/*@__PURE__*/$parcel$interopDefault($2cr21))).purge(chart);
                return;
            }
            if (chart) (0, (/*@__PURE__*/$parcel$interopDefault($2cr21))).purge(chart);
            const container = (0, $9K9BQ.unref)(chartContainer);
            if (container === null) {
                console.log("HeatMap container not ready");
                return;
            }
            // Docs for the data structure: https://plotly.com/javascript/heatmaps/#annotated-heatmap
            const xValues = props.timeSeriesCollection.getAllVisibleValuesForParameter(xAxisParameter.value);
            const yValues = props.timeSeriesCollection.getAllVisibleValuesForParameter(yAxisParameter.value);
            console.log("y values", yValues);
            // Data for heatmap is one array per row; therefore, we must start with the y axis (=rows)
            const matrix = yValues.map((y)=>xValues.map((x)=>props.timeSeriesCollection.getTimeSeriesForParametersAndValues([
                        [
                            xAxisParameter.value,
                            x
                        ],
                        [
                            yAxisParameter.value,
                            y
                        ]
                    ])[0]?.[color.value]));
            const data = [
                {
                    z: matrix,
                    x: xValues,
                    y: yValues,
                    type: "heatmap"
                }
            ];
            console.log("Data for HeatMap is", data);
            // Docs for layout here: https://plotly.com/javascript/figure-labels/
            const layout = {
                xaxis: {
                    title: xAxisParameter.value
                },
                yaxis: {
                    title: yAxisParameter.value
                }
            };
            chart = (0, (/*@__PURE__*/$parcel$interopDefault($2cr21))).newPlot(container, data, layout);
        });
        window.addEventListener("resize", ()=>{
            // Woohoo: This seems to be the only working solution: First, set height/width to 0 in
            // order to enable a size *reduction* (offsetWidth will always at least be the plot's
            // previous size), only then manually measure out the container and use those sizes
            // for Plotly
            const container = (0, $9K9BQ.unref)(chartContainer);
            if (!container) return;
            console.log("container", container);
            (0, (/*@__PURE__*/$parcel$interopDefault($2cr21))).relayout(container, {
                height: 0,
                width: 0
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($2cr21))).relayout(container, {
                height: container.offsetHeight,
                width: container.offsetWidth
            });
        });
        const __returned__ = {
            props: props,
            chartContainer: chartContainer,
            xAxisParameter: xAxisParameter,
            yAxisParameter: yAxisParameter,
            color: color,
            get chart () {
                return chart;
            },
            set chart (v){
                chart = v;
            },
            watchEffect: $4mYx6.watchEffect,
            ref: $9K9BQ.ref,
            unref: $9K9BQ.unref,
            get Plotly () {
                return 0, (/*@__PURE__*/$parcel$interopDefault($2cr21));
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("2cr21", function(module, exports) {
/**
* plotly.js v2.35.2
* Copyright 2012-2024, Plotly, Inc.
* All rights reserved.
* Licensed under the MIT license
*/ /*! For license information please see plotly.min.js.LICENSE.txt */ !function(t1, e1) {
    module.exports = e1();
}(self, function() {
    return function() {
        var t1 = {
            6713: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = {
                    "X,X div": 'direction:ltr;font-family:"Open Sans",verdana,arial,sans-serif;margin:0;padding:0;',
                    "X input,X button": 'font-family:"Open Sans",verdana,arial,sans-serif;',
                    "X input:focus,X button:focus": "outline:none;",
                    "X a": "text-decoration:none;",
                    "X a:hover": "text-decoration:none;",
                    "X .crisp": "shape-rendering:crispEdges;",
                    "X .user-select-none": "-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none;",
                    "X svg": "overflow:hidden;",
                    "X svg a": "fill:#447adb;",
                    "X svg a:hover": "fill:#3c6dc5;",
                    "X .main-svg": "position:absolute;top:0;left:0;pointer-events:none;",
                    "X .main-svg .draglayer": "pointer-events:all;",
                    "X .cursor-default": "cursor:default;",
                    "X .cursor-pointer": "cursor:pointer;",
                    "X .cursor-crosshair": "cursor:crosshair;",
                    "X .cursor-move": "cursor:move;",
                    "X .cursor-col-resize": "cursor:col-resize;",
                    "X .cursor-row-resize": "cursor:row-resize;",
                    "X .cursor-ns-resize": "cursor:ns-resize;",
                    "X .cursor-ew-resize": "cursor:ew-resize;",
                    "X .cursor-sw-resize": "cursor:sw-resize;",
                    "X .cursor-s-resize": "cursor:s-resize;",
                    "X .cursor-se-resize": "cursor:se-resize;",
                    "X .cursor-w-resize": "cursor:w-resize;",
                    "X .cursor-e-resize": "cursor:e-resize;",
                    "X .cursor-nw-resize": "cursor:nw-resize;",
                    "X .cursor-n-resize": "cursor:n-resize;",
                    "X .cursor-ne-resize": "cursor:ne-resize;",
                    "X .cursor-grab": "cursor:-webkit-grab;cursor:grab;",
                    "X .modebar": "position:absolute;top:2px;right:2px;",
                    "X .ease-bg": "-webkit-transition:background-color .3s ease 0s;-moz-transition:background-color .3s ease 0s;-ms-transition:background-color .3s ease 0s;-o-transition:background-color .3s ease 0s;transition:background-color .3s ease 0s;",
                    "X .modebar--hover>:not(.watermark)": "opacity:0;-webkit-transition:opacity .3s ease 0s;-moz-transition:opacity .3s ease 0s;-ms-transition:opacity .3s ease 0s;-o-transition:opacity .3s ease 0s;transition:opacity .3s ease 0s;",
                    "X:hover .modebar--hover .modebar-group": "opacity:1;",
                    "X .modebar-group": "float:left;display:inline-block;box-sizing:border-box;padding-left:8px;position:relative;vertical-align:middle;white-space:nowrap;",
                    "X .modebar-btn": "position:relative;font-size:16px;padding:3px 4px;height:22px;cursor:pointer;line-height:normal;box-sizing:border-box;",
                    "X .modebar-btn svg": "position:relative;top:2px;",
                    "X .modebar.vertical": "display:flex;flex-direction:column;flex-wrap:wrap;align-content:flex-end;max-height:100%;",
                    "X .modebar.vertical svg": "top:-1px;",
                    "X .modebar.vertical .modebar-group": "display:block;float:none;padding-left:0px;padding-bottom:8px;",
                    "X .modebar.vertical .modebar-group .modebar-btn": "display:block;text-align:center;",
                    "X [data-title]:before,X [data-title]:after": "position:absolute;-webkit-transform:translate3d(0, 0, 0);-moz-transform:translate3d(0, 0, 0);-ms-transform:translate3d(0, 0, 0);-o-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0);display:none;opacity:0;z-index:1001;pointer-events:none;top:110%;right:50%;",
                    "X [data-title]:hover:before,X [data-title]:hover:after": "display:block;opacity:1;",
                    "X [data-title]:before": 'content:"";position:absolute;background:rgba(0,0,0,0);border:6px solid rgba(0,0,0,0);z-index:1002;margin-top:-12px;border-bottom-color:#69738a;margin-right:-6px;',
                    "X [data-title]:after": "content:attr(data-title);background:#69738a;color:#fff;padding:8px 10px;font-size:12px;line-height:12px;white-space:nowrap;margin-right:-18px;border-radius:2px;",
                    "X .vertical [data-title]:before,X .vertical [data-title]:after": "top:0%;right:200%;",
                    "X .vertical [data-title]:before": "border:6px solid rgba(0,0,0,0);border-left-color:#69738a;margin-top:8px;margin-right:-30px;",
                    Y: 'font-family:"Open Sans",verdana,arial,sans-serif;position:fixed;top:50px;right:20px;z-index:10000;font-size:10pt;max-width:180px;',
                    "Y p": "margin:0;",
                    "Y .notifier-note": "min-width:180px;max-width:250px;border:1px solid #fff;z-index:3000;margin:0;background-color:#8c97af;background-color:rgba(140,151,175,.9);color:#fff;padding:10px;overflow-wrap:break-word;word-wrap:break-word;-ms-hyphens:auto;-webkit-hyphens:auto;hyphens:auto;",
                    "Y .notifier-close": "color:#fff;opacity:.8;float:right;padding:0 5px;background:none;border:none;font-size:20px;font-weight:bold;line-height:20px;",
                    "Y .notifier-close:hover": "color:#444;text-decoration:none;cursor:pointer;"
                };
                for(var a in i){
                    var o = a.replace(/^,/, " ,").replace(/X/g, ".js-plotly-plot .plotly").replace(/Y/g, ".plotly-notifier");
                    n.addStyleRule(o, i[a]);
                }
            },
            14187: function(t1, e1, r) {
                "use strict";
                t1.exports = r(47908);
            },
            20273: function(t1, e1, r) {
                "use strict";
                t1.exports = r(58218);
            },
            6457: function(t1, e1, r) {
                "use strict";
                t1.exports = r(89362);
            },
            15849: function(t1, e1, r) {
                "use strict";
                t1.exports = r(53794);
            },
            38847: function(t1, e1, r) {
                "use strict";
                t1.exports = r(29698);
            },
            7659: function(t1, e1, r) {
                "use strict";
                t1.exports = r(51252);
            },
            60089: function(t1, e1, r) {
                "use strict";
                t1.exports = r(48050);
            },
            22084: function(t1, e1, r) {
                "use strict";
                t1.exports = r(58075);
            },
            35892: function(t1, e1, r) {
                "use strict";
                t1.exports = r(9419);
            },
            81204: function(t1, e1, r) {
                "use strict";
                t1.exports = r(28128);
            },
            55857: function(t1, e1, r) {
                "use strict";
                t1.exports = r(47050);
            },
            12862: function(t1, e1, r) {
                "use strict";
                t1.exports = r(91405);
            },
            97629: function(t1, e1, r) {
                "use strict";
                t1.exports = r(34406);
            },
            67549: function(t1, e1, r) {
                "use strict";
                t1.exports = r(17430);
            },
            2660: function(t1, e1, r) {
                "use strict";
                t1.exports = r(91995);
            },
            86071: function(t1, e1, r) {
                "use strict";
                t1.exports = r(81264);
            },
            66200: function(t1, e1, r) {
                "use strict";
                t1.exports = r(42849);
            },
            53446: function(t1, e1, r) {
                "use strict";
                t1.exports = r(52213);
            },
            86899: function(t1, e1, r) {
                "use strict";
                t1.exports = r(91132);
            },
            13430: function(t1, e1, r) {
                "use strict";
                t1.exports = r(50453);
            },
            21548: function(t1, e1, r) {
                "use strict";
                t1.exports = r(29251);
            },
            53939: function(t1, e1, r) {
                "use strict";
                t1.exports = r(72892);
            },
            1902: function(t1, e1, r) {
                "use strict";
                t1.exports = r(74461);
            },
            29096: function(t1, e1, r) {
                "use strict";
                t1.exports = r(66143);
            },
            23820: function(t1, e1, r) {
                "use strict";
                t1.exports = r(81955);
            },
            82017: function(t1, e1, r) {
                "use strict";
                t1.exports = r(36858);
            },
            113: function(t1, e1, r) {
                "use strict";
                t1.exports = r(92106);
            },
            20260: function(t1, e1, r) {
                "use strict";
                var n = r(67549);
                n.register([
                    r(20273),
                    r(15849),
                    r(21548),
                    r(1902),
                    r(29096),
                    r(23820),
                    r(12862),
                    r(1639),
                    r(10067),
                    r(53446),
                    r(31014),
                    r(113),
                    r(78170),
                    r(8202),
                    r(92382),
                    r(82017),
                    r(86899),
                    r(54357),
                    r(66903),
                    r(90594),
                    r(71680),
                    r(7412),
                    r(55857),
                    r(784),
                    r(74221),
                    r(22084),
                    r(44001),
                    r(97281),
                    r(12345),
                    r(53939),
                    r(29117),
                    r(5410),
                    r(5057),
                    r(81204),
                    r(86071),
                    r(14226),
                    r(35892),
                    r(2660),
                    r(96599),
                    r(28573),
                    r(76832),
                    r(60089),
                    r(51469),
                    r(97629),
                    r(27700),
                    r(7659),
                    r(11780),
                    r(27195),
                    r(6457),
                    r(84639),
                    r(14187),
                    r(66200),
                    r(13430),
                    r(90590),
                    r(38847)
                ]), t1.exports = n;
            },
            28573: function(t1, e1, r) {
                "use strict";
                t1.exports = r(25638);
            },
            90594: function(t1, e1, r) {
                "use strict";
                t1.exports = r(75297);
            },
            7412: function(t1, e1, r) {
                "use strict";
                t1.exports = r(58859);
            },
            27700: function(t1, e1, r) {
                "use strict";
                t1.exports = r(12683);
            },
            5410: function(t1, e1, r) {
                "use strict";
                t1.exports = r(6305);
            },
            29117: function(t1, e1, r) {
                "use strict";
                t1.exports = r(83910);
            },
            78170: function(t1, e1, r) {
                "use strict";
                t1.exports = r(49913);
            },
            12345: function(t1, e1, r) {
                "use strict";
                t1.exports = r(15186);
            },
            96599: function(t1, e1, r) {
                "use strict";
                t1.exports = r(71760);
            },
            54357: function(t1, e1, r) {
                "use strict";
                t1.exports = r(17822);
            },
            51469: function(t1, e1, r) {
                "use strict";
                t1.exports = r(56534);
            },
            74221: function(t1, e1, r) {
                "use strict";
                t1.exports = r(18070);
            },
            44001: function(t1, e1, r) {
                "use strict";
                t1.exports = r(52378);
            },
            14226: function(t1, e1, r) {
                "use strict";
                t1.exports = r(30929);
            },
            5057: function(t1, e1, r) {
                "use strict";
                t1.exports = r(83866);
            },
            11780: function(t1, e1, r) {
                "use strict";
                t1.exports = r(66939);
            },
            27195: function(t1, e1, r) {
                "use strict";
                t1.exports = r(23748);
            },
            84639: function(t1, e1, r) {
                "use strict";
                t1.exports = r(73304);
            },
            1639: function(t1, e1, r) {
                "use strict";
                t1.exports = r(12864);
            },
            90590: function(t1, e1, r) {
                "use strict";
                t1.exports = r(99855);
            },
            97281: function(t1, e1, r) {
                "use strict";
                t1.exports = r(91450);
            },
            784: function(t1, e1, r) {
                "use strict";
                t1.exports = r(51943);
            },
            8202: function(t1, e1, r) {
                "use strict";
                t1.exports = r(80809);
            },
            66903: function(t1, e1, r) {
                "use strict";
                t1.exports = r(95984);
            },
            76832: function(t1, e1, r) {
                "use strict";
                t1.exports = r(51671);
            },
            92382: function(t1, e1, r) {
                "use strict";
                t1.exports = r(47181);
            },
            10067: function(t1, e1, r) {
                "use strict";
                t1.exports = r(37276);
            },
            71680: function(t1, e1, r) {
                "use strict";
                t1.exports = r(75703);
            },
            31014: function(t1, e1, r) {
                "use strict";
                t1.exports = r(38261);
            },
            11645: function(t1) {
                "use strict";
                t1.exports = [
                    {
                        path: "",
                        backoff: 0
                    },
                    {
                        path: "M-2.4,-3V3L0.6,0Z",
                        backoff: .6
                    },
                    {
                        path: "M-3.7,-2.5V2.5L1.3,0Z",
                        backoff: 1.3
                    },
                    {
                        path: "M-4.45,-3L-1.65,-0.2V0.2L-4.45,3L1.55,0Z",
                        backoff: 1.55
                    },
                    {
                        path: "M-2.2,-2.2L-0.2,-0.2V0.2L-2.2,2.2L-1.4,3L1.6,0L-1.4,-3Z",
                        backoff: 1.6
                    },
                    {
                        path: "M-4.4,-2.1L-0.6,-0.2V0.2L-4.4,2.1L-4,3L2,0L-4,-3Z",
                        backoff: 2
                    },
                    {
                        path: "M2,0A2,2 0 1,1 0,-2A2,2 0 0,1 2,0Z",
                        backoff: 0,
                        noRotate: !0
                    },
                    {
                        path: "M2,2V-2H-2V2Z",
                        backoff: 0,
                        noRotate: !0
                    }
                ];
            },
            50222: function(t1, e1, r) {
                "use strict";
                var n = r(11645), i = r(80337), a = r(54826), o = r(78032).templatedArray;
                r(35081), t1.exports = o("annotation", {
                    visible: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc+arraydraw"
                    },
                    text: {
                        valType: "string",
                        editType: "calc+arraydraw"
                    },
                    textangle: {
                        valType: "angle",
                        dflt: 0,
                        editType: "calc+arraydraw"
                    },
                    font: i({
                        editType: "calc+arraydraw",
                        colorEditType: "arraydraw"
                    }),
                    width: {
                        valType: "number",
                        min: 1,
                        dflt: null,
                        editType: "calc+arraydraw"
                    },
                    height: {
                        valType: "number",
                        min: 1,
                        dflt: null,
                        editType: "calc+arraydraw"
                    },
                    opacity: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 1,
                        editType: "arraydraw"
                    },
                    align: {
                        valType: "enumerated",
                        values: [
                            "left",
                            "center",
                            "right"
                        ],
                        dflt: "center",
                        editType: "arraydraw"
                    },
                    valign: {
                        valType: "enumerated",
                        values: [
                            "top",
                            "middle",
                            "bottom"
                        ],
                        dflt: "middle",
                        editType: "arraydraw"
                    },
                    bgcolor: {
                        valType: "color",
                        dflt: "rgba(0,0,0,0)",
                        editType: "arraydraw"
                    },
                    bordercolor: {
                        valType: "color",
                        dflt: "rgba(0,0,0,0)",
                        editType: "arraydraw"
                    },
                    borderpad: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        editType: "calc+arraydraw"
                    },
                    borderwidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        editType: "calc+arraydraw"
                    },
                    showarrow: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc+arraydraw"
                    },
                    arrowcolor: {
                        valType: "color",
                        editType: "arraydraw"
                    },
                    arrowhead: {
                        valType: "integer",
                        min: 0,
                        max: n.length,
                        dflt: 1,
                        editType: "arraydraw"
                    },
                    startarrowhead: {
                        valType: "integer",
                        min: 0,
                        max: n.length,
                        dflt: 1,
                        editType: "arraydraw"
                    },
                    arrowside: {
                        valType: "flaglist",
                        flags: [
                            "end",
                            "start"
                        ],
                        extras: [
                            "none"
                        ],
                        dflt: "end",
                        editType: "arraydraw"
                    },
                    arrowsize: {
                        valType: "number",
                        min: .3,
                        dflt: 1,
                        editType: "calc+arraydraw"
                    },
                    startarrowsize: {
                        valType: "number",
                        min: .3,
                        dflt: 1,
                        editType: "calc+arraydraw"
                    },
                    arrowwidth: {
                        valType: "number",
                        min: .1,
                        editType: "calc+arraydraw"
                    },
                    standoff: {
                        valType: "number",
                        min: 0,
                        dflt: 0,
                        editType: "calc+arraydraw"
                    },
                    startstandoff: {
                        valType: "number",
                        min: 0,
                        dflt: 0,
                        editType: "calc+arraydraw"
                    },
                    ax: {
                        valType: "any",
                        editType: "calc+arraydraw"
                    },
                    ay: {
                        valType: "any",
                        editType: "calc+arraydraw"
                    },
                    axref: {
                        valType: "enumerated",
                        dflt: "pixel",
                        values: [
                            "pixel",
                            a.idRegex.x.toString()
                        ],
                        editType: "calc"
                    },
                    ayref: {
                        valType: "enumerated",
                        dflt: "pixel",
                        values: [
                            "pixel",
                            a.idRegex.y.toString()
                        ],
                        editType: "calc"
                    },
                    xref: {
                        valType: "enumerated",
                        values: [
                            "paper",
                            a.idRegex.x.toString()
                        ],
                        editType: "calc"
                    },
                    x: {
                        valType: "any",
                        editType: "calc+arraydraw"
                    },
                    xanchor: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "left",
                            "center",
                            "right"
                        ],
                        dflt: "auto",
                        editType: "calc+arraydraw"
                    },
                    xshift: {
                        valType: "number",
                        dflt: 0,
                        editType: "calc+arraydraw"
                    },
                    yref: {
                        valType: "enumerated",
                        values: [
                            "paper",
                            a.idRegex.y.toString()
                        ],
                        editType: "calc"
                    },
                    y: {
                        valType: "any",
                        editType: "calc+arraydraw"
                    },
                    yanchor: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "top",
                            "middle",
                            "bottom"
                        ],
                        dflt: "auto",
                        editType: "calc+arraydraw"
                    },
                    yshift: {
                        valType: "number",
                        dflt: 0,
                        editType: "calc+arraydraw"
                    },
                    clicktoshow: {
                        valType: "enumerated",
                        values: [
                            !1,
                            "onoff",
                            "onout"
                        ],
                        dflt: !1,
                        editType: "arraydraw"
                    },
                    xclick: {
                        valType: "any",
                        editType: "arraydraw"
                    },
                    yclick: {
                        valType: "any",
                        editType: "arraydraw"
                    },
                    hovertext: {
                        valType: "string",
                        editType: "arraydraw"
                    },
                    hoverlabel: {
                        bgcolor: {
                            valType: "color",
                            editType: "arraydraw"
                        },
                        bordercolor: {
                            valType: "color",
                            editType: "arraydraw"
                        },
                        font: i({
                            editType: "arraydraw"
                        }),
                        editType: "arraydraw"
                    },
                    captureevents: {
                        valType: "boolean",
                        editType: "arraydraw"
                    },
                    editType: "calc",
                    _deprecated: {
                        ref: {
                            valType: "string",
                            editType: "calc"
                        }
                    }
                });
            },
            60317: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(29714), a = r(3377).draw;
                function o(t1) {
                    var e1 = t1._fullLayout;
                    n.filterVisible(e1.annotations).forEach(function(e1) {
                        var r = i.getFromId(t1, e1.xref), n = i.getFromId(t1, e1.yref), a = i.getRefType(e1.xref), o = i.getRefType(e1.yref);
                        e1._extremes = {}, "range" === a && s(e1, r), "range" === o && s(e1, n);
                    });
                }
                function s(t1, e1) {
                    var r, n = e1._id, a = n.charAt(0), o = t1[a], s = t1["a" + a], l = t1[a + "ref"], c = t1["a" + a + "ref"], u = t1["_" + a + "padplus"], h = t1["_" + a + "padminus"], f = {
                        x: 1,
                        y: -1
                    }[a] * t1[a + "shift"], p = 3 * t1.arrowsize * t1.arrowwidth || 0, d = p + f, m = p - f, g = 3 * t1.startarrowsize * t1.arrowwidth || 0, y = g + f, v = g - f;
                    if (c === l) {
                        var x = i.findExtremes(e1, [
                            e1.r2c(o)
                        ], {
                            ppadplus: d,
                            ppadminus: m
                        }), _ = i.findExtremes(e1, [
                            e1.r2c(s)
                        ], {
                            ppadplus: Math.max(u, y),
                            ppadminus: Math.max(h, v)
                        });
                        r = {
                            min: [
                                x.min[0],
                                _.min[0]
                            ],
                            max: [
                                x.max[0],
                                _.max[0]
                            ]
                        };
                    } else y = s ? y + s : y, v = s ? v - s : v, r = i.findExtremes(e1, [
                        e1.r2c(o)
                    ], {
                        ppadplus: Math.max(u, d, y),
                        ppadminus: Math.max(h, m, v)
                    });
                    t1._extremes[n] = r;
                }
                t1.exports = function(t1) {
                    var e1 = t1._fullLayout;
                    if (n.filterVisible(e1.annotations).length && t1._fullData.length) return n.syncOrAsync([
                        a,
                        o
                    ], t1);
                };
            },
            6035: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(33626), a = r(78032).arrayEditor;
                function o(t1, e1) {
                    var r, n, i, a, o, l, c, u = t1._fullLayout.annotations, h = [], f = [], p = [], d = (e1 || []).length;
                    for(r = 0; r < u.length; r++)if (a = (i = u[r]).clicktoshow) {
                        for(n = 0; n < d; n++)if (l = (o = e1[n]).xaxis, c = o.yaxis, l._id === i.xref && c._id === i.yref && l.d2r(o.x) === s(i._xclick, l) && c.d2r(o.y) === s(i._yclick, c)) {
                            (i.visible ? "onout" === a ? f : p : h).push(r);
                            break;
                        }
                        n === d && i.visible && "onout" === a && f.push(r);
                    }
                    return {
                        on: h,
                        off: f,
                        explicitOff: p
                    };
                }
                function s(t1, e1) {
                    return "log" === e1.type ? e1.l2r(t1) : e1.d2r(t1);
                }
                t1.exports = {
                    hasClickToShow: function(t1, e1) {
                        var r = o(t1, e1);
                        return r.on.length > 0 || r.explicitOff.length > 0;
                    },
                    onClick: function(t1, e1) {
                        var r, s, l = o(t1, e1), c = l.on, u = l.off.concat(l.explicitOff), h = {}, f = t1._fullLayout.annotations;
                        if (c.length || u.length) {
                            for(r = 0; r < c.length; r++)(s = a(t1.layout, "annotations", f[c[r]])).modifyItem("visible", !0), n.extendFlat(h, s.getUpdateObj());
                            for(r = 0; r < u.length; r++)(s = a(t1.layout, "annotations", f[u[r]])).modifyItem("visible", !1), n.extendFlat(h, s.getUpdateObj());
                            return i.call("update", t1, {}, h);
                        }
                    }
                };
            },
            53271: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(78766);
                t1.exports = function(t1, e1, r, a) {
                    a("opacity");
                    var o = a("bgcolor"), s = a("bordercolor"), l = i.opacity(s);
                    a("borderpad");
                    var c = a("borderwidth"), u = a("showarrow");
                    if (a("text", u ? " " : r._dfltTitle.annotation), a("textangle"), n.coerceFont(a, "font", r.font), a("width"), a("align"), a("height") && a("valign"), u) {
                        var h, f, p = a("arrowside");
                        -1 !== p.indexOf("end") && (h = a("arrowhead"), f = a("arrowsize")), -1 !== p.indexOf("start") && (a("startarrowhead", h), a("startarrowsize", f)), a("arrowcolor", l ? e1.bordercolor : i.defaultLine), a("arrowwidth", 2 * (l && c || 1)), a("standoff"), a("startstandoff");
                    }
                    var d = a("hovertext"), m = r.hoverlabel || {};
                    if (d) {
                        var g = a("hoverlabel.bgcolor", m.bgcolor || (i.opacity(o) ? i.rgb(o) : i.defaultLine)), y = a("hoverlabel.bordercolor", m.bordercolor || i.contrast(g)), v = n.extendFlat({}, m.font);
                        v.color || (v.color = y), n.coerceFont(a, "hoverlabel.font", v);
                    }
                    a("captureevents", !!d);
                };
            },
            59741: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(8083);
                t1.exports = function(t1, e1, r, a) {
                    e1 = e1 || {};
                    var o = "log" === r && "linear" === e1.type, s = "linear" === r && "log" === e1.type;
                    if (o || s) for(var l, c, u = t1._fullLayout.annotations, h = e1._id.charAt(0), f = 0; f < u.length; f++)l = u[f], c = "annotations[" + f + "].", l[h + "ref"] === e1._id && p(h), l["a" + h + "ref"] === e1._id && p("a" + h);
                    function p(t1) {
                        var r = l[t1], s = null;
                        s = o ? i(r, e1.range) : Math.pow(10, r), n(s) || (s = null), a(c + t1, s);
                    }
                };
            },
            63737: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(29714), a = r(59008), o = r(53271), s = r(50222);
                function l(t1, e1, r) {
                    function a(r, i) {
                        return n.coerce(t1, e1, s, r, i);
                    }
                    var l = a("visible"), c = a("clicktoshow");
                    if (l || c) {
                        o(t1, e1, r, a);
                        for(var u = e1.showarrow, h = [
                            "x",
                            "y"
                        ], f = [
                            -10,
                            -30
                        ], p = {
                            _fullLayout: r
                        }, d = 0; d < 2; d++){
                            var m = h[d], g = i.coerceRef(t1, e1, p, m, "", "paper");
                            if ("paper" !== g && i.getFromId(p, g)._annIndices.push(e1._index), i.coercePosition(e1, p, a, g, m, .5), u) {
                                var y = "a" + m, v = i.coerceRef(t1, e1, p, y, "pixel", [
                                    "pixel",
                                    "paper"
                                ]);
                                "pixel" !== v && v !== g && (v = e1[y] = "pixel");
                                var x = "pixel" === v ? f[d] : .4;
                                i.coercePosition(e1, p, a, v, y, x);
                            }
                            a(m + "anchor"), a(m + "shift");
                        }
                        if (n.noneOrAll(t1, e1, [
                            "x",
                            "y"
                        ]), u && n.noneOrAll(t1, e1, [
                            "ax",
                            "ay"
                        ]), c) {
                            var _ = a("xclick"), b = a("yclick");
                            e1._xclick = void 0 === _ ? e1.x : i.cleanPosition(_, p, e1.xref), e1._yclick = void 0 === b ? e1.y : i.cleanPosition(b, p, e1.yref);
                        }
                    }
                }
                t1.exports = function(t1, e1) {
                    a(t1, e1, {
                        name: "annotations",
                        handleItemDefaults: l
                    });
                };
            },
            3377: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(33626), a = r(44122), o = r(34809), s = o.strTranslate, l = r(29714), c = r(78766), u = r(62203), h = r(32141), f = r(30635), p = r(27983), d = r(14751), m = r(78032).arrayEditor, g = r(23768);
                function y(t1, e1) {
                    var r = t1._fullLayout.annotations[e1] || {}, n = l.getFromId(t1, r.xref), i = l.getFromId(t1, r.yref);
                    n && n.setScale(), i && i.setScale(), x(t1, r, e1, !1, n, i);
                }
                function v(t1, e1, r, n, i) {
                    var a = i[r], o = i[r + "ref"], s = -1 !== r.indexOf("y"), c = "domain" === l.getRefType(o), u = s ? n.h : n.w;
                    return t1 ? c ? a + (s ? -e1 : e1) / t1._length : t1.p2r(t1.r2p(a) + e1) : a + (s ? -e1 : e1) / u;
                }
                function x(t1, e1, r, a, y, x) {
                    var _, b, w = t1._fullLayout, T = t1._fullLayout._size, k = t1._context.edits;
                    a ? (_ = "annotation-" + a, b = a + ".annotations") : (_ = "annotation", b = "annotations");
                    var A = m(t1.layout, b, e1), M = A.modifyBase, S = A.modifyItem, E = A.getUpdateObj;
                    w._infolayer.selectAll("." + _ + '[data-index="' + r + '"]').remove();
                    var C = "clip" + w._uid + "_ann" + r;
                    if (e1._input && !1 !== e1.visible) {
                        var L = {
                            x: {},
                            y: {}
                        }, I = +e1.textangle || 0, P = w._infolayer.append("g").classed(_, !0).attr("data-index", String(r)).style("opacity", e1.opacity), z = P.append("g").classed("annotation-text-g", !0), O = k[e1.showarrow ? "annotationTail" : "annotationPosition"], D = e1.captureevents || k.annotationText || O, R = z.append("g").style("pointer-events", D ? "all" : null).call(p, "pointer").on("click", function() {
                            t1._dragging = !1, t1.emit("plotly_clickannotation", Z(n.event));
                        });
                        e1.hovertext && R.on("mouseover", function() {
                            var r = e1.hoverlabel, n = r.font, i = this.getBoundingClientRect(), a = t1.getBoundingClientRect();
                            h.loneHover({
                                x0: i.left - a.left,
                                x1: i.right - a.left,
                                y: (i.top + i.bottom) / 2 - a.top,
                                text: e1.hovertext,
                                color: r.bgcolor,
                                borderColor: r.bordercolor,
                                fontFamily: n.family,
                                fontSize: n.size,
                                fontColor: n.color,
                                fontWeight: n.weight,
                                fontStyle: n.style,
                                fontVariant: n.variant,
                                fontShadow: n.fontShadow,
                                fontLineposition: n.fontLineposition,
                                fontTextcase: n.fontTextcase
                            }, {
                                container: w._hoverlayer.node(),
                                outerContainer: w._paper.node(),
                                gd: t1
                            });
                        }).on("mouseout", function() {
                            h.loneUnhover(w._hoverlayer.node());
                        });
                        var F = e1.borderwidth, B = e1.borderpad, N = F + B, j = R.append("rect").attr("class", "bg").style("stroke-width", F + "px").call(c.stroke, e1.bordercolor).call(c.fill, e1.bgcolor), U = e1.width || e1.height, V = w._topclips.selectAll("#" + C).data(U ? [
                            0
                        ] : []);
                        V.enter().append("clipPath").classed("annclip", !0).attr("id", C).append("rect"), V.exit().remove();
                        var q = e1.font, H = w._meta ? o.templateString(e1.text, w._meta) : e1.text, G = R.append("text").classed("annotation-text", !0).text(H);
                        k.annotationText ? G.call(f.makeEditable, {
                            delegate: R,
                            gd: t1
                        }).call(W).on("edit", function(r) {
                            e1.text = r, this.call(W), S("text", r), y && y.autorange && M(y._name + ".autorange", !0), x && x.autorange && M(x._name + ".autorange", !0), i.call("_guiRelayout", t1, E());
                        }) : G.call(W);
                    } else n.selectAll("#" + C).remove();
                    function Z(t1) {
                        var n = {
                            index: r,
                            annotation: e1._input,
                            fullAnnotation: e1,
                            event: t1
                        };
                        return a && (n.subplotId = a), n;
                    }
                    function W(r) {
                        return r.call(u.font, q).attr({
                            "text-anchor": {
                                left: "start",
                                right: "end"
                            }[e1.align] || "middle"
                        }), f.convertToTspans(r, t1, Y), r;
                    }
                    function Y() {
                        var r = G.selectAll("a");
                        1 === r.size() && r.text() === G.text() && R.insert("a", ":first-child").attr({
                            "xlink:xlink:href": r.attr("xlink:href"),
                            "xlink:xlink:show": r.attr("xlink:show")
                        }).style({
                            cursor: "pointer"
                        }).node().appendChild(j.node());
                        var n = R.select(".annotation-text-math-group"), h = !n.empty(), m = u.bBox((h ? n : G).node()), _ = m.width, b = m.height, A = e1.width || _, D = e1.height || b, B = Math.round(A + 2 * N), q = Math.round(D + 2 * N);
                        function H(t1, e1) {
                            return "auto" === e1 && (e1 = t1 < 1 / 3 ? "left" : t1 > 2 / 3 ? "right" : "center"), ({
                                center: 0,
                                middle: 0,
                                left: .5,
                                bottom: -0.5,
                                right: -0.5,
                                top: .5
                            })[e1];
                        }
                        for(var W = !1, Y = [
                            "x",
                            "y"
                        ], X = 0; X < Y.length; X++){
                            var $, J, K, Q, tt, et = Y[X], rt = e1[et + "ref"] || et, nt = e1["a" + et + "ref"], it = {
                                x: y,
                                y: x
                            }[et], at = (I + ("x" === et ? 0 : -90)) * Math.PI / 180, ot = B * Math.cos(at), st = q * Math.sin(at), lt = Math.abs(ot) + Math.abs(st), ct = e1[et + "anchor"], ut = e1[et + "shift"] * ("x" === et ? 1 : -1), ht = L[et], ft = l.getRefType(rt);
                            if (it && "domain" !== ft) {
                                var pt = it.r2fraction(e1[et]);
                                (pt < 0 || pt > 1) && (nt === rt ? ((pt = it.r2fraction(e1["a" + et])) < 0 || pt > 1) && (W = !0) : W = !0), $ = it._offset + it.r2p(e1[et]), Q = .5;
                            } else {
                                var dt = "domain" === ft;
                                "x" === et ? (K = e1[et], $ = dt ? it._offset + it._length * K : $ = T.l + T.w * K) : (K = 1 - e1[et], $ = dt ? it._offset + it._length * K : $ = T.t + T.h * K), Q = e1.showarrow ? .5 : K;
                            }
                            if (e1.showarrow) {
                                ht.head = $;
                                var mt = e1["a" + et];
                                if (tt = ot * H(.5, e1.xanchor) - st * H(.5, e1.yanchor), nt === rt) {
                                    var gt = l.getRefType(nt);
                                    "domain" === gt ? ("y" === et && (mt = 1 - mt), ht.tail = it._offset + it._length * mt) : "paper" === gt ? "y" === et ? (mt = 1 - mt, ht.tail = T.t + T.h * mt) : ht.tail = T.l + T.w * mt : ht.tail = it._offset + it.r2p(mt), J = tt;
                                } else ht.tail = $ + mt, J = tt + mt;
                                ht.text = ht.tail + tt;
                                var yt = w["x" === et ? "width" : "height"];
                                if ("paper" === rt && (ht.head = o.constrain(ht.head, 1, yt - 1)), "pixel" === nt) {
                                    var vt = -Math.max(ht.tail - 3, ht.text), xt = Math.min(ht.tail + 3, ht.text) - yt;
                                    vt > 0 ? (ht.tail += vt, ht.text += vt) : xt > 0 && (ht.tail -= xt, ht.text -= xt);
                                }
                                ht.tail += ut, ht.head += ut;
                            } else J = tt = lt * H(Q, ct), ht.text = $ + tt;
                            ht.text += ut, tt += ut, J += ut, e1["_" + et + "padplus"] = lt / 2 + J, e1["_" + et + "padminus"] = lt / 2 - J, e1["_" + et + "size"] = lt, e1["_" + et + "shift"] = tt;
                        }
                        if (W) R.remove();
                        else {
                            var _t = 0, bt = 0;
                            if ("left" !== e1.align && (_t = (A - _) * ("center" === e1.align ? .5 : 1)), "top" !== e1.valign && (bt = (D - b) * ("middle" === e1.valign ? .5 : 1)), h) n.select("svg").attr({
                                x: N + _t - 1,
                                y: N + bt
                            }).call(u.setClipUrl, U ? C : null, t1);
                            else {
                                var wt = N + bt - m.top, Tt = N + _t - m.left;
                                G.call(f.positionText, Tt, wt).call(u.setClipUrl, U ? C : null, t1);
                            }
                            V.select("rect").call(u.setRect, N, N, A, D), j.call(u.setRect, F / 2, F / 2, B - F, q - F), R.call(u.setTranslate, Math.round(L.x.text - B / 2), Math.round(L.y.text - q / 2)), z.attr({
                                transform: "rotate(" + I + "," + L.x.text + "," + L.y.text + ")"
                            });
                            var kt, At = function(r, n) {
                                P.selectAll(".annotation-arrow-g").remove();
                                var l = L.x.head, h = L.y.head, f = L.x.tail + r, p = L.y.tail + n, m = L.x.text + r, _ = L.y.text + n, b = o.rotationXYMatrix(I, m, _), w = o.apply2DTransform(b), A = o.apply2DTransform2(b), C = +j.attr("width"), O = +j.attr("height"), D = m - .5 * C, F = D + C, B = _ - .5 * O, N = B + O, U = [
                                    [
                                        D,
                                        B,
                                        D,
                                        N
                                    ],
                                    [
                                        D,
                                        N,
                                        F,
                                        N
                                    ],
                                    [
                                        F,
                                        N,
                                        F,
                                        B
                                    ],
                                    [
                                        F,
                                        B,
                                        D,
                                        B
                                    ]
                                ].map(A);
                                if (!U.reduce(function(t1, e1) {
                                    return t1 ^ !!o.segmentsIntersect(l, h, l + 1e6, h + 1e6, e1[0], e1[1], e1[2], e1[3]);
                                }, !1)) {
                                    U.forEach(function(t1) {
                                        var e1 = o.segmentsIntersect(f, p, l, h, t1[0], t1[1], t1[2], t1[3]);
                                        e1 && (f = e1.x, p = e1.y);
                                    });
                                    var V = e1.arrowwidth, q = e1.arrowcolor, H = e1.arrowside, G = P.append("g").style({
                                        opacity: c.opacity(q)
                                    }).classed("annotation-arrow-g", !0), Z = G.append("path").attr("d", "M" + f + "," + p + "L" + l + "," + h).style("stroke-width", V + "px").call(c.stroke, c.rgb(q));
                                    if (g(Z, H, e1), k.annotationPosition && Z.node().parentNode && !a) {
                                        var W = l, Y = h;
                                        if (e1.standoff) {
                                            var X = Math.sqrt(Math.pow(l - f, 2) + Math.pow(h - p, 2));
                                            W += e1.standoff * (f - l) / X, Y += e1.standoff * (p - h) / X;
                                        }
                                        var $, J, K = G.append("path").classed("annotation-arrow", !0).classed("anndrag", !0).classed("cursor-move", !0).attr({
                                            d: "M3,3H-3V-3H3ZM0,0L" + (f - W) + "," + (p - Y),
                                            transform: s(W, Y)
                                        }).style("stroke-width", V + 6 + "px").call(c.stroke, "rgba(0,0,0,0)").call(c.fill, "rgba(0,0,0,0)");
                                        d.init({
                                            element: K.node(),
                                            gd: t1,
                                            prepFn: function() {
                                                var t1 = u.getTranslate(R);
                                                $ = t1.x, J = t1.y, y && y.autorange && M(y._name + ".autorange", !0), x && x.autorange && M(x._name + ".autorange", !0);
                                            },
                                            moveFn: function(t1, r) {
                                                var n = w($, J), i = n[0] + t1, a = n[1] + r;
                                                R.call(u.setTranslate, i, a), S("x", v(y, t1, "x", T, e1)), S("y", v(x, r, "y", T, e1)), e1.axref === e1.xref && S("ax", v(y, t1, "ax", T, e1)), e1.ayref === e1.yref && S("ay", v(x, r, "ay", T, e1)), G.attr("transform", s(t1, r)), z.attr({
                                                    transform: "rotate(" + I + "," + i + "," + a + ")"
                                                });
                                            },
                                            doneFn: function() {
                                                i.call("_guiRelayout", t1, E());
                                                var e1 = document.querySelector(".js-notes-box-panel");
                                                e1 && e1.redraw(e1.selectedObj);
                                            }
                                        });
                                    }
                                }
                            };
                            e1.showarrow && At(0, 0), O && d.init({
                                element: R.node(),
                                gd: t1,
                                prepFn: function() {
                                    kt = z.attr("transform");
                                },
                                moveFn: function(t1, r) {
                                    var n = "pointer";
                                    if (e1.showarrow) e1.axref === e1.xref ? S("ax", v(y, t1, "ax", T, e1)) : S("ax", e1.ax + t1), e1.ayref === e1.yref ? S("ay", v(x, r, "ay", T.w, e1)) : S("ay", e1.ay + r), At(t1, r);
                                    else {
                                        if (a) return;
                                        var i, o;
                                        if (y) i = v(y, t1, "x", T, e1);
                                        else {
                                            var l = e1._xsize / T.w, c = e1.x + (e1._xshift - e1.xshift) / T.w - l / 2;
                                            i = d.align(c + t1 / T.w, l, 0, 1, e1.xanchor);
                                        }
                                        if (x) o = v(x, r, "y", T, e1);
                                        else {
                                            var u = e1._ysize / T.h, h = e1.y - (e1._yshift + e1.yshift) / T.h - u / 2;
                                            o = d.align(h - r / T.h, u, 0, 1, e1.yanchor);
                                        }
                                        S("x", i), S("y", o), y && x || (n = d.getCursor(y ? .5 : i, x ? .5 : o, e1.xanchor, e1.yanchor));
                                    }
                                    z.attr({
                                        transform: s(t1, r) + kt
                                    }), p(R, n);
                                },
                                clickFn: function(r, n) {
                                    e1.captureevents && t1.emit("plotly_clickannotation", Z(n));
                                },
                                doneFn: function() {
                                    p(R), i.call("_guiRelayout", t1, E());
                                    var e1 = document.querySelector(".js-notes-box-panel");
                                    e1 && e1.redraw(e1.selectedObj);
                                }
                            });
                        }
                    }
                }
                t1.exports = {
                    draw: function(t1) {
                        var e1 = t1._fullLayout;
                        e1._infolayer.selectAll(".annotation").remove();
                        for(var r = 0; r < e1.annotations.length; r++)e1.annotations[r].visible && y(t1, r);
                        return a.previousPromises(t1);
                    },
                    drawOne: y,
                    drawRaw: x
                };
            },
            23768: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(78766), a = r(11645), o = r(34809), s = o.strScale, l = o.strRotate, c = o.strTranslate;
                t1.exports = function(t1, e1, r) {
                    var o, u, h, f, p = t1.node(), d = a[r.arrowhead || 0], m = a[r.startarrowhead || 0], g = (r.arrowwidth || 1) * (r.arrowsize || 1), y = (r.arrowwidth || 1) * (r.startarrowsize || 1), v = e1.indexOf("start") >= 0, x = e1.indexOf("end") >= 0, _ = d.backoff * g + r.standoff, b = m.backoff * y + r.startstandoff;
                    if ("line" === p.nodeName) {
                        o = {
                            x: +t1.attr("x1"),
                            y: +t1.attr("y1")
                        }, u = {
                            x: +t1.attr("x2"),
                            y: +t1.attr("y2")
                        };
                        var w = o.x - u.x, T = o.y - u.y;
                        if (f = (h = Math.atan2(T, w)) + Math.PI, _ && b && _ + b > Math.sqrt(w * w + T * T)) return void O();
                        if (_) {
                            if (_ * _ > w * w + T * T) return void O();
                            var k = _ * Math.cos(h), A = _ * Math.sin(h);
                            u.x += k, u.y += A, t1.attr({
                                x2: u.x,
                                y2: u.y
                            });
                        }
                        if (b) {
                            if (b * b > w * w + T * T) return void O();
                            var M = b * Math.cos(h), S = b * Math.sin(h);
                            o.x -= M, o.y -= S, t1.attr({
                                x1: o.x,
                                y1: o.y
                            });
                        }
                    } else if ("path" === p.nodeName) {
                        var E = p.getTotalLength(), C = "";
                        if (E < _ + b) return void O();
                        var L = p.getPointAtLength(0), I = p.getPointAtLength(.1);
                        h = Math.atan2(L.y - I.y, L.x - I.x), o = p.getPointAtLength(Math.min(b, E)), C = "0px," + b + "px,";
                        var P = p.getPointAtLength(E), z = p.getPointAtLength(E - .1);
                        f = Math.atan2(P.y - z.y, P.x - z.x), u = p.getPointAtLength(Math.max(0, E - _)), C += E - (C ? b + _ : _) + "px," + E + "px", t1.style("stroke-dasharray", C);
                    }
                    function O() {
                        t1.style("stroke-dasharray", "0px,100px");
                    }
                    function D(e1, a, o, u) {
                        e1.path && (e1.noRotate && (o = 0), n.select(p.parentNode).append("path").attr({
                            class: t1.attr("class"),
                            d: e1.path,
                            transform: c(a.x, a.y) + l(180 * o / Math.PI) + s(u)
                        }).style({
                            fill: i.rgb(r.arrowcolor),
                            "stroke-width": 0
                        }));
                    }
                    v && D(m, o, h, y), x && D(d, u, f, g);
                };
            },
            3599: function(t1, e1, r) {
                "use strict";
                var n = r(3377), i = r(6035);
                t1.exports = {
                    moduleType: "component",
                    name: "annotations",
                    layoutAttributes: r(50222),
                    supplyLayoutDefaults: r(63737),
                    includeBasePlot: r(20706)("annotations"),
                    calcAutorange: r(60317),
                    draw: n.draw,
                    drawOne: n.drawOne,
                    drawRaw: n.drawRaw,
                    hasClickToShow: i.hasClickToShow,
                    onClick: i.onClick,
                    convertCoords: r(59741)
                };
            },
            38239: function(t1, e1, r) {
                "use strict";
                var n = r(50222), i = r(13582).overrideAll, a = r(78032).templatedArray;
                t1.exports = i(a("annotation", {
                    visible: n.visible,
                    x: {
                        valType: "any"
                    },
                    y: {
                        valType: "any"
                    },
                    z: {
                        valType: "any"
                    },
                    ax: {
                        valType: "number"
                    },
                    ay: {
                        valType: "number"
                    },
                    xanchor: n.xanchor,
                    xshift: n.xshift,
                    yanchor: n.yanchor,
                    yshift: n.yshift,
                    text: n.text,
                    textangle: n.textangle,
                    font: n.font,
                    width: n.width,
                    height: n.height,
                    opacity: n.opacity,
                    align: n.align,
                    valign: n.valign,
                    bgcolor: n.bgcolor,
                    bordercolor: n.bordercolor,
                    borderpad: n.borderpad,
                    borderwidth: n.borderwidth,
                    showarrow: n.showarrow,
                    arrowcolor: n.arrowcolor,
                    arrowhead: n.arrowhead,
                    startarrowhead: n.startarrowhead,
                    arrowside: n.arrowside,
                    arrowsize: n.arrowsize,
                    startarrowsize: n.startarrowsize,
                    arrowwidth: n.arrowwidth,
                    standoff: n.standoff,
                    startstandoff: n.startstandoff,
                    hovertext: n.hovertext,
                    hoverlabel: n.hoverlabel,
                    captureevents: n.captureevents
                }), "calc", "from-root");
            },
            47979: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(29714);
                function a(t1, e1) {
                    var r = e1.fullSceneLayout.domain, a = e1.fullLayout._size, o = {
                        pdata: null,
                        type: "linear",
                        autorange: !1,
                        range: [
                            -1 / 0,
                            1 / 0
                        ]
                    };
                    t1._xa = {}, n.extendFlat(t1._xa, o), i.setConvert(t1._xa), t1._xa._offset = a.l + r.x[0] * a.w, t1._xa.l2p = function() {
                        return .5 * (1 + t1._pdata[0] / t1._pdata[3]) * a.w * (r.x[1] - r.x[0]);
                    }, t1._ya = {}, n.extendFlat(t1._ya, o), i.setConvert(t1._ya), t1._ya._offset = a.t + (1 - r.y[1]) * a.h, t1._ya.l2p = function() {
                        return .5 * (1 - t1._pdata[1] / t1._pdata[3]) * a.h * (r.y[1] - r.y[0]);
                    };
                }
                t1.exports = function(t1) {
                    for(var e1 = t1.fullSceneLayout.annotations, r = 0; r < e1.length; r++)a(e1[r], t1);
                    t1.fullLayout._infolayer.selectAll(".annotation-" + t1.id).remove();
                };
            },
            34232: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(29714), a = r(59008), o = r(53271), s = r(38239);
                function l(t1, e1, r, a) {
                    function l(r, i) {
                        return n.coerce(t1, e1, s, r, i);
                    }
                    function c(t1) {
                        var n = t1 + "axis", a = {
                            _fullLayout: {}
                        };
                        return a._fullLayout[n] = r[n], i.coercePosition(e1, a, l, t1, t1, .5);
                    }
                    l("visible") && (o(t1, e1, a.fullLayout, l), c("x"), c("y"), c("z"), n.noneOrAll(t1, e1, [
                        "x",
                        "y",
                        "z"
                    ]), e1.xref = "x", e1.yref = "y", e1.zref = "z", l("xanchor"), l("yanchor"), l("xshift"), l("yshift"), e1.showarrow && (e1.axref = "pixel", e1.ayref = "pixel", l("ax", -10), l("ay", -30), n.noneOrAll(t1, e1, [
                        "ax",
                        "ay"
                    ])));
                }
                t1.exports = function(t1, e1, r) {
                    a(t1, e1, {
                        name: "annotations",
                        handleItemDefaults: l,
                        fullLayout: r.fullLayout
                    });
                };
            },
            9756: function(t1, e1, r) {
                "use strict";
                var n = r(3377).drawRaw, i = r(25802), a = [
                    "x",
                    "y",
                    "z"
                ];
                t1.exports = function(t1) {
                    for(var e1 = t1.fullSceneLayout, r = t1.dataScale, o = e1.annotations, s = 0; s < o.length; s++){
                        for(var l = o[s], c = !1, u = 0; u < 3; u++){
                            var h = a[u], f = l[h], p = e1[h + "axis"].r2fraction(f);
                            if (p < 0 || p > 1) {
                                c = !0;
                                break;
                            }
                        }
                        c ? t1.fullLayout._infolayer.select(".annotation-" + t1.id + '[data-index="' + s + '"]').remove() : (l._pdata = i(t1.glplot.cameraParams, [
                            e1.xaxis.r2l(l.x) * r[0],
                            e1.yaxis.r2l(l.y) * r[1],
                            e1.zaxis.r2l(l.z) * r[2]
                        ]), n(t1.graphDiv, l, s, t1.id, l._xa, l._ya));
                    }
                };
            },
            83348: function(t1, e1, r) {
                "use strict";
                var n = r(33626), i = r(34809);
                t1.exports = {
                    moduleType: "component",
                    name: "annotations3d",
                    schema: {
                        subplots: {
                            scene: {
                                annotations: r(38239)
                            }
                        }
                    },
                    layoutAttributes: r(38239),
                    handleDefaults: r(34232),
                    includeBasePlot: function(t1, e1) {
                        var r = n.subplotsRegistry.gl3d;
                        if (r) for(var a = r.attrRegex, o = Object.keys(t1), s = 0; s < o.length; s++){
                            var l = o[s];
                            a.test(l) && (t1[l].annotations || []).length && (i.pushUnique(e1._basePlotModules, r), i.pushUnique(e1._subplots.gl3d, l));
                        }
                    },
                    convert: r(47979),
                    draw: r(9756)
                };
            },
            37177: function(t1, e1, r) {
                "use strict";
                t1.exports = r(24453), r(23428), r(1401), r(72210), r(28569), r(81133), r(78295), r(25512), r(42645), r(62324), r(91662), r(66445), r(50506), r(84756), r(41858), r(57985);
            },
            29698: function(t1, e1, r) {
                "use strict";
                var n = r(37177), i = r(34809), a = r(63821), o = a.EPOCHJD, s = a.ONEDAY, l = {
                    valType: "enumerated",
                    values: i.sortObjectKeys(n.calendars),
                    editType: "calc",
                    dflt: "gregorian"
                }, c = function(t1, e1, r, n) {
                    var a = {};
                    return a[r] = l, i.coerce(t1, e1, a, r, n);
                }, u = "##", h = {
                    d: {
                        0: "dd",
                        "-": "d"
                    },
                    e: {
                        0: "d",
                        "-": "d"
                    },
                    a: {
                        0: "D",
                        "-": "D"
                    },
                    A: {
                        0: "DD",
                        "-": "DD"
                    },
                    j: {
                        0: "oo",
                        "-": "o"
                    },
                    W: {
                        0: "ww",
                        "-": "w"
                    },
                    m: {
                        0: "mm",
                        "-": "m"
                    },
                    b: {
                        0: "M",
                        "-": "M"
                    },
                    B: {
                        0: "MM",
                        "-": "MM"
                    },
                    y: {
                        0: "yy",
                        "-": "yy"
                    },
                    Y: {
                        0: "yyyy",
                        "-": "yyyy"
                    },
                    U: u,
                    w: u,
                    c: {
                        0: "D M d %X yyyy",
                        "-": "D M d %X yyyy"
                    },
                    x: {
                        0: "mm/dd/yyyy",
                        "-": "mm/dd/yyyy"
                    }
                }, f = {};
                function p(t1) {
                    var e1 = f[t1];
                    return e1 || (f[t1] = n.instance(t1));
                }
                function d(t1) {
                    return i.extendFlat({}, l, {
                        description: t1
                    });
                }
                function m(t1) {
                    return "Sets the calendar system to use with `" + t1 + "` date data.";
                }
                var g = {
                    xcalendar: d(m("x"))
                }, y = i.extendFlat({}, g, {
                    ycalendar: d(m("y"))
                }), v = i.extendFlat({}, y, {
                    zcalendar: d(m("z"))
                }), x = d([
                    "Sets the calendar system to use for `range` and `tick0`",
                    "if this is a date axis. This does not set the calendar for",
                    "interpreting data on this axis, that's specified in the trace",
                    "or via the global `layout.calendar`"
                ].join(" "));
                t1.exports = {
                    moduleType: "component",
                    name: "calendars",
                    schema: {
                        traces: {
                            scatter: y,
                            bar: y,
                            box: y,
                            heatmap: y,
                            contour: y,
                            histogram: y,
                            histogram2d: y,
                            histogram2dcontour: y,
                            scatter3d: v,
                            surface: v,
                            mesh3d: v,
                            scattergl: y,
                            ohlc: g,
                            candlestick: g
                        },
                        layout: {
                            calendar: d([
                                "Sets the default calendar system to use for interpreting and",
                                "displaying dates throughout the plot."
                            ].join(" "))
                        },
                        subplots: {
                            xaxis: {
                                calendar: x
                            },
                            yaxis: {
                                calendar: x
                            },
                            scene: {
                                xaxis: {
                                    calendar: x
                                },
                                yaxis: {
                                    calendar: x
                                },
                                zaxis: {
                                    calendar: x
                                }
                            },
                            polar: {
                                radialaxis: {
                                    calendar: x
                                }
                            }
                        },
                        transforms: {
                            filter: {
                                valuecalendar: d([
                                    "WARNING: All transforms are deprecated and may be removed from the API in next major version.",
                                    "Sets the calendar system to use for `value`, if it is a date."
                                ].join(" ")),
                                targetcalendar: d([
                                    "WARNING: All transforms are deprecated and may be removed from the API in next major version.",
                                    "Sets the calendar system to use for `target`, if it is an",
                                    "array of dates. If `target` is a string (eg *x*) we use the",
                                    "corresponding trace attribute (eg `xcalendar`) if it exists,",
                                    "even if `targetcalendar` is provided."
                                ].join(" "))
                            }
                        }
                    },
                    layoutAttributes: l,
                    handleDefaults: c,
                    handleTraceDefaults: function(t1, e1, r, n) {
                        for(var i = 0; i < r.length; i++)c(t1, e1, r[i] + "calendar", n.calendar);
                    },
                    CANONICAL_SUNDAY: {
                        chinese: "2000-01-02",
                        coptic: "2000-01-03",
                        discworld: "2000-01-03",
                        ethiopian: "2000-01-05",
                        hebrew: "5000-01-01",
                        islamic: "1000-01-02",
                        julian: "2000-01-03",
                        mayan: "5000-01-01",
                        nanakshahi: "1000-01-05",
                        nepali: "2000-01-05",
                        persian: "1000-01-01",
                        jalali: "1000-01-01",
                        taiwan: "1000-01-04",
                        thai: "2000-01-04",
                        ummalqura: "1400-01-06"
                    },
                    CANONICAL_TICK: {
                        chinese: "2000-01-01",
                        coptic: "2000-01-01",
                        discworld: "2000-01-01",
                        ethiopian: "2000-01-01",
                        hebrew: "5000-01-01",
                        islamic: "1000-01-01",
                        julian: "2000-01-01",
                        mayan: "5000-01-01",
                        nanakshahi: "1000-01-01",
                        nepali: "2000-01-01",
                        persian: "1000-01-01",
                        jalali: "1000-01-01",
                        taiwan: "1000-01-01",
                        thai: "2000-01-01",
                        ummalqura: "1400-01-01"
                    },
                    DFLTRANGE: {
                        chinese: [
                            "2000-01-01",
                            "2001-01-01"
                        ],
                        coptic: [
                            "1700-01-01",
                            "1701-01-01"
                        ],
                        discworld: [
                            "1800-01-01",
                            "1801-01-01"
                        ],
                        ethiopian: [
                            "2000-01-01",
                            "2001-01-01"
                        ],
                        hebrew: [
                            "5700-01-01",
                            "5701-01-01"
                        ],
                        islamic: [
                            "1400-01-01",
                            "1401-01-01"
                        ],
                        julian: [
                            "2000-01-01",
                            "2001-01-01"
                        ],
                        mayan: [
                            "5200-01-01",
                            "5201-01-01"
                        ],
                        nanakshahi: [
                            "0500-01-01",
                            "0501-01-01"
                        ],
                        nepali: [
                            "2000-01-01",
                            "2001-01-01"
                        ],
                        persian: [
                            "1400-01-01",
                            "1401-01-01"
                        ],
                        jalali: [
                            "1400-01-01",
                            "1401-01-01"
                        ],
                        taiwan: [
                            "0100-01-01",
                            "0101-01-01"
                        ],
                        thai: [
                            "2500-01-01",
                            "2501-01-01"
                        ],
                        ummalqura: [
                            "1400-01-01",
                            "1401-01-01"
                        ]
                    },
                    getCal: p,
                    worldCalFmt: function(t1, e1, r) {
                        for(var n, i, a, l, c, f = Math.floor((e1 + .05) / s) + o, d = p(r).fromJD(f), m = 0; -1 !== (m = t1.indexOf("%", m));)"0" === (n = t1.charAt(m + 1)) || "-" === n || "_" === n ? (a = 3, i = t1.charAt(m + 2), "_" === n && (n = "-")) : (i = n, n = "0", a = 2), (l = h[i]) ? (c = l === u ? u : d.formatDate(l[n]), t1 = t1.substr(0, m) + c + t1.substr(m + a), m += c.length) : m += a;
                        return t1;
                    }
                };
            },
            10229: function(t1, e1) {
                "use strict";
                e1.defaults = [
                    "#1f77b4",
                    "#ff7f0e",
                    "#2ca02c",
                    "#d62728",
                    "#9467bd",
                    "#8c564b",
                    "#e377c2",
                    "#7f7f7f",
                    "#bcbd22",
                    "#17becf"
                ], e1.defaultLine = "#444", e1.lightLine = "#eee", e1.background = "#fff", e1.borderLine = "#BEC8D9", e1.lightFraction = 1e3 / 11;
            },
            78766: function(t1, e1, r) {
                "use strict";
                var n = r(65657), i = r(10721), a = r(87800).isTypedArray, o = t1.exports = {}, s = r(10229);
                o.defaults = s.defaults;
                var l = o.defaultLine = s.defaultLine;
                o.lightLine = s.lightLine;
                var c = o.background = s.background;
                function u(t1) {
                    if (i(t1) || "string" != typeof t1) return t1;
                    var e1 = t1.trim();
                    if ("rgb" !== e1.substr(0, 3)) return t1;
                    var r = e1.match(/^rgba?\s*\(([^()]*)\)$/);
                    if (!r) return t1;
                    var n = r[1].trim().split(/\s*[\s,]\s*/), a = "a" === e1.charAt(3) && 4 === n.length;
                    if (!a && 3 !== n.length) return t1;
                    for(var o = 0; o < n.length; o++){
                        if (!n[o].length) return t1;
                        if (n[o] = Number(n[o]), !(n[o] >= 0)) return t1;
                        if (3 === o) n[o] > 1 && (n[o] = 1);
                        else if (n[o] >= 1) return t1;
                    }
                    var s = Math.round(255 * n[0]) + ", " + Math.round(255 * n[1]) + ", " + Math.round(255 * n[2]);
                    return a ? "rgba(" + s + ", " + n[3] + ")" : "rgb(" + s + ")";
                }
                o.tinyRGB = function(t1) {
                    var e1 = t1.toRgb();
                    return "rgb(" + Math.round(e1.r) + ", " + Math.round(e1.g) + ", " + Math.round(e1.b) + ")";
                }, o.rgb = function(t1) {
                    return o.tinyRGB(n(t1));
                }, o.opacity = function(t1) {
                    return t1 ? n(t1).getAlpha() : 0;
                }, o.addOpacity = function(t1, e1) {
                    var r = n(t1).toRgb();
                    return "rgba(" + Math.round(r.r) + ", " + Math.round(r.g) + ", " + Math.round(r.b) + ", " + e1 + ")";
                }, o.combine = function(t1, e1) {
                    var r = n(t1).toRgb();
                    if (1 === r.a) return n(t1).toRgbString();
                    var i = n(e1 || c).toRgb(), a = 1 === i.a ? i : {
                        r: 255 * (1 - i.a) + i.r * i.a,
                        g: 255 * (1 - i.a) + i.g * i.a,
                        b: 255 * (1 - i.a) + i.b * i.a
                    }, o = {
                        r: a.r * (1 - r.a) + r.r * r.a,
                        g: a.g * (1 - r.a) + r.g * r.a,
                        b: a.b * (1 - r.a) + r.b * r.a
                    };
                    return n(o).toRgbString();
                }, o.interpolate = function(t1, e1, r) {
                    var i = n(t1).toRgb(), a = n(e1).toRgb(), o = {
                        r: r * i.r + (1 - r) * a.r,
                        g: r * i.g + (1 - r) * a.g,
                        b: r * i.b + (1 - r) * a.b
                    };
                    return n(o).toRgbString();
                }, o.contrast = function(t1, e1, r) {
                    var i = n(t1);
                    return 1 !== i.getAlpha() && (i = n(o.combine(t1, c))), (i.isDark() ? e1 ? i.lighten(e1) : c : r ? i.darken(r) : l).toString();
                }, o.stroke = function(t1, e1) {
                    var r = n(e1);
                    t1.style({
                        stroke: o.tinyRGB(r),
                        "stroke-opacity": r.getAlpha()
                    });
                }, o.fill = function(t1, e1) {
                    var r = n(e1);
                    t1.style({
                        fill: o.tinyRGB(r),
                        "fill-opacity": r.getAlpha()
                    });
                }, o.clean = function(t1) {
                    if (t1 && "object" == typeof t1) {
                        var e1, r, n, i, s = Object.keys(t1);
                        for(e1 = 0; e1 < s.length; e1++)if (i = t1[n = s[e1]], "color" === n.substr(n.length - 5)) {
                            if (Array.isArray(i)) for(r = 0; r < i.length; r++)i[r] = u(i[r]);
                            else t1[n] = u(i);
                        } else if ("colorscale" === n.substr(n.length - 10) && Array.isArray(i)) for(r = 0; r < i.length; r++)Array.isArray(i[r]) && (i[r][1] = u(i[r][1]));
                        else if (Array.isArray(i)) {
                            var l = i[0];
                            if (!Array.isArray(l) && l && "object" == typeof l) for(r = 0; r < i.length; r++)o.clean(i[r]);
                        } else i && "object" == typeof i && !a(i) && o.clean(i);
                    }
                };
            },
            25158: function(t1, e1, r) {
                "use strict";
                var n = r(25829), i = r(80337), a = r(93049).extendFlat, o = r(13582).overrideAll;
                t1.exports = o({
                    orientation: {
                        valType: "enumerated",
                        values: [
                            "h",
                            "v"
                        ],
                        dflt: "v"
                    },
                    thicknessmode: {
                        valType: "enumerated",
                        values: [
                            "fraction",
                            "pixels"
                        ],
                        dflt: "pixels"
                    },
                    thickness: {
                        valType: "number",
                        min: 0,
                        dflt: 30
                    },
                    lenmode: {
                        valType: "enumerated",
                        values: [
                            "fraction",
                            "pixels"
                        ],
                        dflt: "fraction"
                    },
                    len: {
                        valType: "number",
                        min: 0,
                        dflt: 1
                    },
                    x: {
                        valType: "number"
                    },
                    xref: {
                        valType: "enumerated",
                        dflt: "paper",
                        values: [
                            "container",
                            "paper"
                        ],
                        editType: "layoutstyle"
                    },
                    xanchor: {
                        valType: "enumerated",
                        values: [
                            "left",
                            "center",
                            "right"
                        ]
                    },
                    xpad: {
                        valType: "number",
                        min: 0,
                        dflt: 10
                    },
                    y: {
                        valType: "number"
                    },
                    yref: {
                        valType: "enumerated",
                        dflt: "paper",
                        values: [
                            "container",
                            "paper"
                        ],
                        editType: "layoutstyle"
                    },
                    yanchor: {
                        valType: "enumerated",
                        values: [
                            "top",
                            "middle",
                            "bottom"
                        ]
                    },
                    ypad: {
                        valType: "number",
                        min: 0,
                        dflt: 10
                    },
                    outlinecolor: n.linecolor,
                    outlinewidth: n.linewidth,
                    bordercolor: n.linecolor,
                    borderwidth: {
                        valType: "number",
                        min: 0,
                        dflt: 0
                    },
                    bgcolor: {
                        valType: "color",
                        dflt: "rgba(0,0,0,0)"
                    },
                    tickmode: n.minor.tickmode,
                    nticks: n.nticks,
                    tick0: n.tick0,
                    dtick: n.dtick,
                    tickvals: n.tickvals,
                    ticktext: n.ticktext,
                    ticks: a({}, n.ticks, {
                        dflt: ""
                    }),
                    ticklabeloverflow: a({}, n.ticklabeloverflow, {}),
                    ticklabelposition: {
                        valType: "enumerated",
                        values: [
                            "outside",
                            "inside",
                            "outside top",
                            "inside top",
                            "outside left",
                            "inside left",
                            "outside right",
                            "inside right",
                            "outside bottom",
                            "inside bottom"
                        ],
                        dflt: "outside"
                    },
                    ticklen: n.ticklen,
                    tickwidth: n.tickwidth,
                    tickcolor: n.tickcolor,
                    ticklabelstep: n.ticklabelstep,
                    showticklabels: n.showticklabels,
                    labelalias: n.labelalias,
                    tickfont: i({}),
                    tickangle: n.tickangle,
                    tickformat: n.tickformat,
                    tickformatstops: n.tickformatstops,
                    tickprefix: n.tickprefix,
                    showtickprefix: n.showtickprefix,
                    ticksuffix: n.ticksuffix,
                    showticksuffix: n.showticksuffix,
                    separatethousands: n.separatethousands,
                    exponentformat: n.exponentformat,
                    minexponent: n.minexponent,
                    showexponent: n.showexponent,
                    title: {
                        text: {
                            valType: "string"
                        },
                        font: i({}),
                        side: {
                            valType: "enumerated",
                            values: [
                                "right",
                                "top",
                                "bottom"
                            ]
                        }
                    },
                    _deprecated: {
                        title: {
                            valType: "string"
                        },
                        titlefont: i({}),
                        titleside: {
                            valType: "enumerated",
                            values: [
                                "right",
                                "top",
                                "bottom"
                            ],
                            dflt: "top"
                        }
                    }
                }, "colorbars", "from-root");
            },
            34554: function(t1) {
                "use strict";
                t1.exports = {
                    cn: {
                        colorbar: "colorbar",
                        cbbg: "cbbg",
                        cbfill: "cbfill",
                        cbfills: "cbfills",
                        cbline: "cbline",
                        cblines: "cblines",
                        cbaxis: "cbaxis",
                        cbtitleunshift: "cbtitleunshift",
                        cbtitle: "cbtitle",
                        cboutline: "cboutline",
                        crisp: "crisp",
                        jsPlaceholder: "js-placeholder"
                    }
                };
            },
            42097: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(78032), a = r(22777), o = r(87433), s = r(12036), l = r(54616), c = r(25158);
                t1.exports = function(t1, e1, r) {
                    var u = i.newContainer(e1, "colorbar"), h = t1.colorbar || {};
                    function f(t1, e1) {
                        return n.coerce(h, u, c, t1, e1);
                    }
                    var p = r.margin || {
                        t: 0,
                        b: 0,
                        l: 0,
                        r: 0
                    }, d = r.width - p.l - p.r, m = r.height - p.t - p.b, g = "v" === f("orientation"), y = f("thicknessmode");
                    f("thickness", "fraction" === y ? 30 / (g ? d : m) : 30);
                    var v = f("lenmode");
                    f("len", "fraction" === v ? 1 : g ? m : d);
                    var x, _, b, w = "paper" === f("yref"), T = "paper" === f("xref"), k = "left";
                    g ? (b = "middle", k = T ? "left" : "right", x = T ? 1.02 : 1, _ = .5) : (b = w ? "bottom" : "top", k = "center", x = .5, _ = w ? 1.02 : 1), n.coerce(h, u, {
                        x: {
                            valType: "number",
                            min: T ? -2 : 0,
                            max: T ? 3 : 1,
                            dflt: x
                        }
                    }, "x"), n.coerce(h, u, {
                        y: {
                            valType: "number",
                            min: w ? -2 : 0,
                            max: w ? 3 : 1,
                            dflt: _
                        }
                    }, "y"), f("xanchor", k), f("xpad"), f("yanchor", b), f("ypad"), n.noneOrAll(h, u, [
                        "x",
                        "y"
                    ]), f("outlinecolor"), f("outlinewidth"), f("bordercolor"), f("borderwidth"), f("bgcolor");
                    var A = n.coerce(h, u, {
                        ticklabelposition: {
                            valType: "enumerated",
                            dflt: "outside",
                            values: g ? [
                                "outside",
                                "inside",
                                "outside top",
                                "inside top",
                                "outside bottom",
                                "inside bottom"
                            ] : [
                                "outside",
                                "inside",
                                "outside left",
                                "inside left",
                                "outside right",
                                "inside right"
                            ]
                        }
                    }, "ticklabelposition");
                    f("ticklabeloverflow", -1 !== A.indexOf("inside") ? "hide past domain" : "hide past div"), a(h, u, f, "linear");
                    var M = r.font, S = {
                        noAutotickangles: !0,
                        noTicklabelshift: !0,
                        noTicklabelstandoff: !0,
                        outerTicks: !1,
                        font: M
                    };
                    -1 !== A.indexOf("inside") && (S.bgColor = "black"), l(h, u, f, "linear", S), s(h, u, f, "linear", S), o(h, u, f, "linear", S), f("title.text", r._dfltTitle.colorbar);
                    var E = u.showticklabels ? u.tickfont : M, C = n.extendFlat({}, M, {
                        family: E.family,
                        size: n.bigFont(E.size)
                    });
                    n.coerceFont(f, "title.font", C), f("title.side", g ? "top" : "right");
                };
            },
            5881: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(65657), a = r(44122), o = r(33626), s = r(29714), l = r(14751), c = r(34809), u = c.strTranslate, h = r(93049).extendFlat, f = r(27983), p = r(62203), d = r(78766), m = r(17240), g = r(30635), y = r(65477).flipScale, v = r(97655), x = r(40957), _ = r(25829), b = r(4530), w = b.LINE_SPACING, T = b.FROM_TL, k = b.FROM_BR, A = r(34554).cn;
                t1.exports = {
                    draw: function(t1) {
                        var e1 = t1._fullLayout._infolayer.selectAll("g." + A.colorbar).data(function(t1) {
                            var e1, r, n, i, a = t1._fullLayout, o = t1.calcdata, s = [];
                            function l(t1) {
                                return h(t1, {
                                    _fillcolor: null,
                                    _line: {
                                        color: null,
                                        width: null,
                                        dash: null
                                    },
                                    _levels: {
                                        start: null,
                                        end: null,
                                        size: null
                                    },
                                    _filllevels: null,
                                    _fillgradient: null,
                                    _zrange: null
                                });
                            }
                            function c() {
                                "function" == typeof i.calc ? i.calc(t1, n, e1) : (e1._fillgradient = r.reversescale ? y(r.colorscale) : r.colorscale, e1._zrange = [
                                    r[i.min],
                                    r[i.max]
                                ]);
                            }
                            for(var u = 0; u < o.length; u++){
                                var f = o[u];
                                if ((n = f[0].trace)._module) {
                                    var p = n._module.colorbar;
                                    if (!0 === n.visible && p) for(var d = Array.isArray(p), m = d ? p : [
                                        p
                                    ], g = 0; g < m.length; g++){
                                        var v = (i = m[g]).container;
                                        (r = v ? n[v] : n) && r.showscale && ((e1 = l(r.colorbar))._id = "cb" + n.uid + (d && v ? "-" + v : ""), e1._traceIndex = n.index, e1._propPrefix = (v ? v + "." : "") + "colorbar.", e1._meta = n._meta, c(), s.push(e1));
                                    }
                                }
                            }
                            for(var x in a._colorAxes)if ((r = a[x]).showscale) {
                                var _ = a._colorAxes[x];
                                (e1 = l(r.colorbar))._id = "cb" + x, e1._propPrefix = x + ".colorbar.", e1._meta = a._meta, i = {
                                    min: "cmin",
                                    max: "cmax"
                                }, "heatmap" !== _[0] && (n = _[1], i.calc = n._module.colorbar.calc), c(), s.push(e1);
                            }
                            return s;
                        }(t1), function(t1) {
                            return t1._id;
                        });
                        e1.enter().append("g").attr("class", function(t1) {
                            return t1._id;
                        }).classed(A.colorbar, !0), e1.each(function(e1) {
                            var r = n.select(this);
                            c.ensureSingle(r, "rect", A.cbbg), c.ensureSingle(r, "g", A.cbfills), c.ensureSingle(r, "g", A.cblines), c.ensureSingle(r, "g", A.cbaxis, function(t1) {
                                t1.classed(A.crisp, !0);
                            }), c.ensureSingle(r, "g", A.cbtitleunshift, function(t1) {
                                t1.append("g").classed(A.cbtitle, !0);
                            }), c.ensureSingle(r, "rect", A.cboutline);
                            var y = function(t1, e1, r) {
                                var o = "v" === e1.orientation, l = e1.len, f = e1.lenmode, y = e1.thickness, b = e1.thicknessmode, M = e1.outlinewidth, S = e1.borderwidth, E = e1.bgcolor, C = e1.xanchor, L = e1.yanchor, I = e1.xpad, P = e1.ypad, z = e1.x, O = o ? e1.y : 1 - e1.y, D = "paper" === e1.yref, R = "paper" === e1.xref, F = r._fullLayout, B = F._size, N = e1._fillcolor, j = e1._line, U = e1.title, V = U.side, q = e1._zrange || n.extent(("function" == typeof N ? N : j.color).domain()), H = "function" == typeof j.color ? j.color : function() {
                                    return j.color;
                                }, G = "function" == typeof N ? N : function() {
                                    return N;
                                }, Z = e1._levels, W = function(t1, e1, r) {
                                    var n, i, a = e1._levels, o = [], s = [], l = a.end + a.size / 100, c = a.size, u = 1.001 * r[0] - .001 * r[1], h = 1.001 * r[1] - .001 * r[0];
                                    for(i = 0; i < 1e5 && (n = a.start + i * c, !(c > 0 ? n >= l : n <= l)); i++)n > u && n < h && o.push(n);
                                    if (e1._fillgradient) s = [
                                        0
                                    ];
                                    else if ("function" == typeof e1._fillcolor) {
                                        var f = e1._filllevels;
                                        if (f) for(l = f.end + f.size / 100, c = f.size, i = 0; i < 1e5 && (n = f.start + i * c, !(c > 0 ? n >= l : n <= l)); i++)n > r[0] && n < r[1] && s.push(n);
                                        else (s = o.map(function(t1) {
                                            return t1 - a.size / 2;
                                        })).push(s[s.length - 1] + a.size);
                                    } else e1._fillcolor && "string" == typeof e1._fillcolor && (s = [
                                        0
                                    ]);
                                    return a.size < 0 && (o.reverse(), s.reverse()), {
                                        line: o,
                                        fill: s
                                    };
                                }(0, e1, q), Y = W.fill, X = W.line, $ = Math.round(y * ("fraction" === b ? o ? B.w : B.h : 1)), J = $ / (o ? B.w : B.h), K = Math.round(l * ("fraction" === f ? o ? B.h : B.w : 1)), Q = K / (o ? B.h : B.w), tt = R ? B.w : r._fullLayout.width, et = D ? B.h : r._fullLayout.height, rt = Math.round(o ? z * tt + I : O * et + P), nt = {
                                    center: .5,
                                    right: 1
                                }[C] || 0, it = {
                                    top: 1,
                                    middle: .5
                                }[L] || 0, at = o ? z - nt * J : O - it * J, ot = o ? O - it * Q : z - nt * Q, st = Math.round(o ? et * (1 - ot) : tt * ot);
                                e1._lenFrac = Q, e1._thickFrac = J, e1._uFrac = at, e1._vFrac = ot;
                                var lt = e1._axis = function(t1, e1, r) {
                                    var n = t1._fullLayout, i = "v" === e1.orientation, a = {
                                        type: "linear",
                                        range: r,
                                        tickmode: e1.tickmode,
                                        nticks: e1.nticks,
                                        tick0: e1.tick0,
                                        dtick: e1.dtick,
                                        tickvals: e1.tickvals,
                                        ticktext: e1.ticktext,
                                        ticks: e1.ticks,
                                        ticklen: e1.ticklen,
                                        tickwidth: e1.tickwidth,
                                        tickcolor: e1.tickcolor,
                                        showticklabels: e1.showticklabels,
                                        labelalias: e1.labelalias,
                                        ticklabelposition: e1.ticklabelposition,
                                        ticklabeloverflow: e1.ticklabeloverflow,
                                        ticklabelstep: e1.ticklabelstep,
                                        tickfont: e1.tickfont,
                                        tickangle: e1.tickangle,
                                        tickformat: e1.tickformat,
                                        exponentformat: e1.exponentformat,
                                        minexponent: e1.minexponent,
                                        separatethousands: e1.separatethousands,
                                        showexponent: e1.showexponent,
                                        showtickprefix: e1.showtickprefix,
                                        tickprefix: e1.tickprefix,
                                        showticksuffix: e1.showticksuffix,
                                        ticksuffix: e1.ticksuffix,
                                        title: e1.title,
                                        showline: !0,
                                        anchor: "free",
                                        side: i ? "right" : "bottom",
                                        position: 1
                                    }, o = i ? "y" : "x", s = {
                                        type: "linear",
                                        _id: o + e1._id
                                    }, l = {
                                        letter: o,
                                        font: n.font,
                                        noAutotickangles: "y" === o,
                                        noHover: !0,
                                        noTickson: !0,
                                        noTicklabelmode: !0,
                                        noInsideRange: !0,
                                        calendar: n.calendar
                                    };
                                    function u(t1, e1) {
                                        return c.coerce(a, s, _, t1, e1);
                                    }
                                    return v(a, s, u, l, n), x(a, s, u, l), s;
                                }(r, e1, q);
                                lt.position = J + (o ? z + I / B.w : O + P / B.h);
                                var ct = -1 !== [
                                    "top",
                                    "bottom"
                                ].indexOf(V);
                                if (o && ct && (lt.title.side = V, lt.titlex = z + I / B.w, lt.titley = ot + ("top" === U.side ? Q - P / B.h : P / B.h)), o || ct || (lt.title.side = V, lt.titley = O + P / B.h, lt.titlex = ot + I / B.w), j.color && "auto" === e1.tickmode) {
                                    lt.tickmode = "linear", lt.tick0 = Z.start;
                                    var ut = Z.size, ht = c.constrain(K / 50, 4, 15) + 1, ft = (q[1] - q[0]) / ((e1.nticks || ht) * ut);
                                    if (ft > 1) {
                                        var pt = Math.pow(10, Math.floor(Math.log(ft) / Math.LN10));
                                        ut *= pt * c.roundUp(ft / pt, [
                                            2,
                                            5,
                                            10
                                        ]), (Math.abs(Z.start) / Z.size + 1e-6) % 1 < 2e-6 && (lt.tick0 = 0);
                                    }
                                    lt.dtick = ut;
                                }
                                lt.domain = o ? [
                                    ot + P / B.h,
                                    ot + Q - P / B.h
                                ] : [
                                    ot + I / B.w,
                                    ot + Q - I / B.w
                                ], lt.setScale(), t1.attr("transform", u(Math.round(B.l), Math.round(B.t)));
                                var dt, mt = t1.select("." + A.cbtitleunshift).attr("transform", u(-Math.round(B.l), -Math.round(B.t))), gt = lt.ticklabelposition, yt = lt.title.font.size, vt = t1.select("." + A.cbaxis), xt = 0, _t = 0;
                                function bt(n, i) {
                                    var a = {
                                        propContainer: lt,
                                        propName: e1._propPrefix + "title",
                                        traceIndex: e1._traceIndex,
                                        _meta: e1._meta,
                                        placeholder: F._dfltTitle.colorbar,
                                        containerGroup: t1.select("." + A.cbtitle)
                                    }, o = "h" === n.charAt(0) ? n.substr(1) : "h" + n;
                                    t1.selectAll("." + o + ",." + o + "-math-group").remove(), m.draw(r, n, h(a, i || {}));
                                }
                                return c.syncOrAsync([
                                    a.previousPromises,
                                    function() {
                                        var t1, e1;
                                        (o && ct || !o && !ct) && ("top" === V && (t1 = I + B.l + tt * z, e1 = P + B.t + et * (1 - ot - Q) + 3 + .75 * yt), "bottom" === V && (t1 = I + B.l + tt * z, e1 = P + B.t + et * (1 - ot) - 3 - .25 * yt), "right" === V && (e1 = P + B.t + et * O + 3 + .75 * yt, t1 = I + B.l + tt * ot), bt(lt._id + "title", {
                                            attributes: {
                                                x: t1,
                                                y: e1,
                                                "text-anchor": o ? "start" : "middle"
                                            }
                                        }));
                                    },
                                    function() {
                                        if (!o && !ct || o && ct) {
                                            var a, l = t1.select("." + A.cbtitle), h = l.select("text"), f = [
                                                -M / 2,
                                                M / 2
                                            ], d = l.select(".h" + lt._id + "title-math-group").node(), m = 15.6;
                                            if (h.node() && (m = parseInt(h.node().style.fontSize, 10) * w), d ? (a = p.bBox(d), _t = a.width, (xt = a.height) > m && (f[1] -= (xt - m) / 2)) : h.node() && !h.classed(A.jsPlaceholder) && (a = p.bBox(h.node()), _t = a.width, xt = a.height), o) {
                                                if (xt) {
                                                    if (xt += 5, "top" === V) lt.domain[1] -= xt / B.h, f[1] *= -1;
                                                    else {
                                                        lt.domain[0] += xt / B.h;
                                                        var y = g.lineCount(h);
                                                        f[1] += (1 - y) * m;
                                                    }
                                                    l.attr("transform", u(f[0], f[1])), lt.setScale();
                                                }
                                            } else _t && ("right" === V && (lt.domain[0] += (_t + yt / 2) / B.w), l.attr("transform", u(f[0], f[1])), lt.setScale());
                                        }
                                        t1.selectAll("." + A.cbfills + ",." + A.cblines).attr("transform", o ? u(0, Math.round(B.h * (1 - lt.domain[1]))) : u(Math.round(B.w * lt.domain[0]), 0)), vt.attr("transform", o ? u(0, Math.round(-B.t)) : u(Math.round(-B.l), 0));
                                        var v = t1.select("." + A.cbfills).selectAll("rect." + A.cbfill).attr("style", "").data(Y);
                                        v.enter().append("rect").classed(A.cbfill, !0).attr("style", ""), v.exit().remove();
                                        var x = q.map(lt.c2p).map(Math.round).sort(function(t1, e1) {
                                            return t1 - e1;
                                        });
                                        v.each(function(t1, a) {
                                            var s = [
                                                0 === a ? q[0] : (Y[a] + Y[a - 1]) / 2,
                                                a === Y.length - 1 ? q[1] : (Y[a] + Y[a + 1]) / 2
                                            ].map(lt.c2p).map(Math.round);
                                            o && (s[1] = c.constrain(s[1] + (s[1] > s[0]) ? 1 : -1, x[0], x[1]));
                                            var l = n.select(this).attr(o ? "x" : "y", rt).attr(o ? "y" : "x", n.min(s)).attr(o ? "width" : "height", Math.max($, 2)).attr(o ? "height" : "width", Math.max(n.max(s) - n.min(s), 2));
                                            if (e1._fillgradient) p.gradient(l, r, e1._id, o ? "vertical" : "horizontalreversed", e1._fillgradient, "fill");
                                            else {
                                                var u = G(t1).replace("e-", "");
                                                l.attr("fill", i(u).toHexString());
                                            }
                                        });
                                        var _ = t1.select("." + A.cblines).selectAll("path." + A.cbline).data(j.color && j.width ? X : []);
                                        _.enter().append("path").classed(A.cbline, !0), _.exit().remove(), _.each(function(t1) {
                                            var e1 = rt, r = Math.round(lt.c2p(t1)) + j.width / 2 % 1;
                                            n.select(this).attr("d", "M" + (o ? e1 + "," + r : r + "," + e1) + (o ? "h" : "v") + $).call(p.lineGroupStyle, j.width, H(t1), j.dash);
                                        }), vt.selectAll("g." + lt._id + "tick,path").remove();
                                        var b = rt + $ + (M || 0) / 2 - ("outside" === e1.ticks ? 1 : 0), T = s.calcTicks(lt), k = s.getTickSigns(lt)[2];
                                        return s.drawTicks(r, lt, {
                                            vals: "inside" === lt.ticks ? s.clipEnds(lt, T) : T,
                                            layer: vt,
                                            path: s.makeTickPath(lt, b, k),
                                            transFn: s.makeTransTickFn(lt)
                                        }), s.drawLabels(r, lt, {
                                            vals: T,
                                            layer: vt,
                                            transFn: s.makeTransTickLabelFn(lt),
                                            labelFns: s.makeLabelFns(lt, b)
                                        });
                                    },
                                    function() {
                                        if (o && !ct || !o && ct) {
                                            var t1, i, a = lt.position || 0, s = lt._offset + lt._length / 2;
                                            if ("right" === V) i = s, t1 = B.l + tt * a + 10 + yt * (lt.showticklabels ? 1 : .5);
                                            else if (t1 = s, "bottom" === V && (i = B.t + et * a + 10 + (-1 === gt.indexOf("inside") ? lt.tickfont.size : 0) + ("intside" !== lt.ticks && e1.ticklen || 0)), "top" === V) {
                                                var l = U.text.split("<br>").length;
                                                i = B.t + et * a + 10 - $ - w * yt * l;
                                            }
                                            bt((o ? "h" : "v") + lt._id + "title", {
                                                avoid: {
                                                    selection: n.select(r).selectAll("g." + lt._id + "tick"),
                                                    side: V,
                                                    offsetTop: o ? 0 : B.t,
                                                    offsetLeft: o ? B.l : 0,
                                                    maxShift: o ? F.width : F.height
                                                },
                                                attributes: {
                                                    x: t1,
                                                    y: i,
                                                    "text-anchor": "middle"
                                                },
                                                transform: {
                                                    rotate: o ? -90 : 0,
                                                    offset: 0
                                                }
                                            });
                                        }
                                    },
                                    a.previousPromises,
                                    function() {
                                        var n, s = $ + M / 2;
                                        -1 === gt.indexOf("inside") && (n = p.bBox(vt.node()), s += o ? n.width : n.height), dt = mt.select("text");
                                        var c = 0, h = o && "top" === V, m = !o && "right" === V, g = 0;
                                        if (dt.node() && !dt.classed(A.jsPlaceholder)) {
                                            var v, x = mt.select(".h" + lt._id + "title-math-group").node();
                                            x && (o && ct || !o && !ct) ? (c = (n = p.bBox(x)).width, v = n.height) : (c = (n = p.bBox(mt.node())).right - B.l - (o ? rt : st), v = n.bottom - B.t - (o ? st : rt), o || "top" !== V || (s += n.height, g = n.height)), m && (dt.attr("transform", u(c / 2 + yt / 2, 0)), c *= 2), s = Math.max(s, o ? c : v);
                                        }
                                        var _ = 2 * (o ? I : P) + s + S + M / 2, w = 0;
                                        !o && U.text && "bottom" === L && O <= 0 && (_ += w = _ / 2, g += w), F._hColorbarMoveTitle = w, F._hColorbarMoveCBTitle = g;
                                        var N = S + M, j = (o ? rt : st) - N / 2 - (o ? I : 0), q = (o ? st : rt) - (o ? K : P + g - w);
                                        t1.select("." + A.cbbg).attr("x", j).attr("y", q).attr(o ? "width" : "height", Math.max(_ - w, 2)).attr(o ? "height" : "width", Math.max(K + N, 2)).call(d.fill, E).call(d.stroke, e1.bordercolor).style("stroke-width", S);
                                        var H = m ? Math.max(c - 10, 0) : 0;
                                        t1.selectAll("." + A.cboutline).attr("x", (o ? rt : st + I) + H).attr("y", (o ? st + P - K : rt) + (h ? xt : 0)).attr(o ? "width" : "height", Math.max($, 2)).attr(o ? "height" : "width", Math.max(K - (o ? 2 * P + xt : 2 * I + H), 2)).call(d.stroke, e1.outlinecolor).style({
                                            fill: "none",
                                            "stroke-width": M
                                        });
                                        var G = o ? nt * _ : 0, Z = o ? 0 : (1 - it) * _ - g;
                                        if (G = R ? B.l - G : -G, Z = D ? B.t - Z : -Z, t1.attr("transform", u(G, Z)), !o && (S || i(E).getAlpha() && !i.equals(F.paper_bgcolor, E))) {
                                            var W = vt.selectAll("text"), Y = W[0].length, X = t1.select("." + A.cbbg).node(), J = p.bBox(X), Q = p.getTranslate(t1);
                                            W.each(function(t1, e1) {
                                                var r = Y - 1;
                                                if (0 === e1 || e1 === r) {
                                                    var n, i = p.bBox(this), a = p.getTranslate(this);
                                                    if (e1 === r) {
                                                        var o = i.right + a.x;
                                                        (n = J.right + Q.x + st - S - 2 + z - o) > 0 && (n = 0);
                                                    } else if (0 === e1) {
                                                        var s = i.left + a.x;
                                                        (n = J.left + Q.x + st + S + 2 - s) < 0 && (n = 0);
                                                    }
                                                    n && (Y < 3 ? this.setAttribute("transform", "translate(" + n + ",0) " + this.getAttribute("transform")) : this.setAttribute("visibility", "hidden"));
                                                }
                                            });
                                        }
                                        var tt = {}, et = T[C], at = k[C], ot = T[L], ut = k[L], ht = _ - $;
                                        o ? ("pixels" === f ? (tt.y = O, tt.t = K * ot, tt.b = K * ut) : (tt.t = tt.b = 0, tt.yt = O + l * ot, tt.yb = O - l * ut), "pixels" === b ? (tt.x = z, tt.l = _ * et, tt.r = _ * at) : (tt.l = ht * et, tt.r = ht * at, tt.xl = z - y * et, tt.xr = z + y * at)) : ("pixels" === f ? (tt.x = z, tt.l = K * et, tt.r = K * at) : (tt.l = tt.r = 0, tt.xl = z + l * et, tt.xr = z - l * at), "pixels" === b ? (tt.y = 1 - O, tt.t = _ * ot, tt.b = _ * ut) : (tt.t = ht * ot, tt.b = ht * ut, tt.yt = O - y * ot, tt.yb = O + y * ut));
                                        var ft = e1.y < .5 ? "b" : "t", pt = e1.x < .5 ? "l" : "r";
                                        r._fullLayout._reservedMargin[e1._id] = {};
                                        var _t = {
                                            r: F.width - j - G,
                                            l: j + tt.r,
                                            b: F.height - q - Z,
                                            t: q + tt.b
                                        };
                                        R && D ? a.autoMargin(r, e1._id, tt) : R ? r._fullLayout._reservedMargin[e1._id][ft] = _t[ft] : D || o ? r._fullLayout._reservedMargin[e1._id][pt] = _t[pt] : r._fullLayout._reservedMargin[e1._id][ft] = _t[ft];
                                    }
                                ], r);
                            }(r, e1, t1);
                            y && y.then && (t1._promises || []).push(y), t1._context.edits.colorbarPosition && function(t1, e1, r) {
                                var n, i, a, s = "v" === e1.orientation, c = r._fullLayout._size;
                                l.init({
                                    element: t1.node(),
                                    gd: r,
                                    prepFn: function() {
                                        n = t1.attr("transform"), f(t1);
                                    },
                                    moveFn: function(r, o) {
                                        t1.attr("transform", n + u(r, o)), i = l.align((s ? e1._uFrac : e1._vFrac) + r / c.w, s ? e1._thickFrac : e1._lenFrac, 0, 1, e1.xanchor), a = l.align((s ? e1._vFrac : 1 - e1._uFrac) - o / c.h, s ? e1._lenFrac : e1._thickFrac, 0, 1, e1.yanchor);
                                        var h = l.getCursor(i, a, e1.xanchor, e1.yanchor);
                                        f(t1, h);
                                    },
                                    doneFn: function() {
                                        if (f(t1), void 0 !== i && void 0 !== a) {
                                            var n = {};
                                            n[e1._propPrefix + "x"] = i, n[e1._propPrefix + "y"] = a, void 0 !== e1._traceIndex ? o.call("_guiRestyle", r, n, e1._traceIndex) : o.call("_guiRelayout", r, n);
                                        }
                                    }
                                });
                            }(r, e1, t1);
                        }), e1.exit().each(function(e1) {
                            a.autoMargin(t1, e1._id);
                        }).remove(), e1.order();
                    }
                };
            },
            91362: function(t1, e1, r) {
                "use strict";
                var n = r(34809);
                t1.exports = function(t1) {
                    return n.isPlainObject(t1.colorbar);
                };
            },
            96919: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    moduleType: "component",
                    name: "colorbar",
                    attributes: r(25158),
                    supplyDefaults: r(42097),
                    draw: r(5881).draw,
                    hasColorbar: r(91362)
                };
            },
            87163: function(t1, e1, r) {
                "use strict";
                var n = r(25158), i = r(90694).counter, a = r(62994), o = r(19017).scales;
                function s(t1) {
                    return "`" + t1 + "`";
                }
                a(o), t1.exports = function(t1, e1) {
                    t1 = t1 || "";
                    var r, a = (e1 = e1 || {}).cLetter || "c", l = ("onlyIfNumerical" in e1 ? e1.onlyIfNumerical : Boolean(t1), "noScale" in e1 ? e1.noScale : "marker.line" === t1), c = "showScaleDflt" in e1 ? e1.showScaleDflt : "z" === a, u = "string" == typeof e1.colorscaleDflt ? o[e1.colorscaleDflt] : null, h = e1.editTypeOverride || "", f = t1 ? t1 + "." : "";
                    "colorAttr" in e1 ? (r = e1.colorAttr, e1.colorAttr) : s(f + (r = ({
                        z: "z",
                        c: "color"
                    })[a]));
                    var p = a + "auto", d = a + "min", m = a + "max", g = a + "mid", y = (s(f + p), s(f + d), s(f + m), {});
                    y[d] = y[m] = void 0;
                    var v = {};
                    v[p] = !1;
                    var x = {};
                    return "color" === r && (x.color = {
                        valType: "color",
                        arrayOk: !0,
                        editType: h || "style"
                    }, e1.anim && (x.color.anim = !0)), x[p] = {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc",
                        impliedEdits: y
                    }, x[d] = {
                        valType: "number",
                        dflt: null,
                        editType: h || "plot",
                        impliedEdits: v
                    }, x[m] = {
                        valType: "number",
                        dflt: null,
                        editType: h || "plot",
                        impliedEdits: v
                    }, x[g] = {
                        valType: "number",
                        dflt: null,
                        editType: "calc",
                        impliedEdits: y
                    }, x.colorscale = {
                        valType: "colorscale",
                        editType: "calc",
                        dflt: u,
                        impliedEdits: {
                            autocolorscale: !1
                        }
                    }, x.autocolorscale = {
                        valType: "boolean",
                        dflt: !1 !== e1.autoColorDflt,
                        editType: "calc",
                        impliedEdits: {
                            colorscale: void 0
                        }
                    }, x.reversescale = {
                        valType: "boolean",
                        dflt: !1,
                        editType: "plot"
                    }, l || (x.showscale = {
                        valType: "boolean",
                        dflt: c,
                        editType: "calc"
                    }, x.colorbar = n), e1.noColorAxis || (x.coloraxis = {
                        valType: "subplotid",
                        regex: i("coloraxis"),
                        dflt: null,
                        editType: "calc"
                    }), x;
                };
            },
            28379: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(34809), a = r(65477).extractOpts;
                t1.exports = function(t1, e1, r) {
                    var o, s = t1._fullLayout, l = r.vals, c = r.containerStr, u = c ? i.nestedProperty(e1, c).get() : e1, h = a(u), f = !1 !== h.auto, p = h.min, d = h.max, m = h.mid, g = function() {
                        return i.aggNums(Math.min, null, l);
                    }, y = function() {
                        return i.aggNums(Math.max, null, l);
                    };
                    void 0 === p ? p = g() : f && (p = u._colorAx && n(p) ? Math.min(p, g()) : g()), void 0 === d ? d = y() : f && (d = u._colorAx && n(d) ? Math.max(d, y()) : y()), f && void 0 !== m && (d - m > m - p ? p = m - (d - m) : d - m < m - p && (d = m + (m - p))), p === d && (p -= .5, d += .5), h._sync("min", p), h._sync("max", d), h.autocolorscale && (o = p * d < 0 ? s.colorscale.diverging : p >= 0 ? s.colorscale.sequential : s.colorscale.sequentialminus, h._sync("colorscale", o));
                };
            },
            67623: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(65477).hasColorscale, a = r(65477).extractOpts;
                t1.exports = function(t1, e1) {
                    function r(t1, e1) {
                        var r = t1["_" + e1];
                        void 0 !== r && (t1[e1] = r);
                    }
                    function o(t1, i) {
                        var o = i.container ? n.nestedProperty(t1, i.container).get() : t1;
                        if (o) {
                            if (o.coloraxis) o._colorAx = e1[o.coloraxis];
                            else {
                                var s = a(o), l = s.auto;
                                (l || void 0 === s.min) && r(o, i.min), (l || void 0 === s.max) && r(o, i.max), s.autocolorscale && r(o, "colorscale");
                            }
                        }
                    }
                    for(var s = 0; s < t1.length; s++){
                        var l = t1[s], c = l._module.colorbar;
                        if (c) {
                            if (Array.isArray(c)) for(var u = 0; u < c.length; u++)o(l, c[u]);
                            else o(l, c);
                        }
                        i(l, "marker.line") && o(l, {
                            container: "marker.line",
                            min: "cmin",
                            max: "cmax"
                        });
                    }
                    for(var h in e1._colorAxes)o(e1[h], {
                        min: "cmin",
                        max: "cmax"
                    });
                };
            },
            39356: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(34809), a = r(91362), o = r(42097), s = r(19017).isValid, l = r(33626).traceIs;
                function c(t1, e1) {
                    var r = e1.slice(0, e1.length - 1);
                    return e1 ? i.nestedProperty(t1, r).get() || {} : t1;
                }
                t1.exports = function t1(e1, r, u, h, f) {
                    var p = f.prefix, d = f.cLetter, m = "_module" in r, g = c(e1, p), y = c(r, p), v = c(r._template || {}, p) || {}, x = function() {
                        return delete e1.coloraxis, delete r.coloraxis, t1(e1, r, u, h, f);
                    };
                    if (m) {
                        var _ = u._colorAxes || {}, b = h(p + "coloraxis");
                        if (b) {
                            var w = l(r, "contour") && i.nestedProperty(r, "contours.coloring").get() || "heatmap", T = _[b];
                            return void (T ? (T[2].push(x), T[0] !== w && (T[0] = !1, i.warn([
                                "Ignoring coloraxis:",
                                b,
                                "setting",
                                "as it is linked to incompatible colorscales."
                            ].join(" ")))) : _[b] = [
                                w,
                                r,
                                [
                                    x
                                ]
                            ]);
                        }
                    }
                    var k = g[d + "min"], A = g[d + "max"], M = n(k) && n(A) && k < A;
                    h(p + d + "auto", !M) ? h(p + d + "mid") : (h(p + d + "min"), h(p + d + "max"));
                    var S, E, C = g.colorscale, L = v.colorscale;
                    void 0 !== C && (S = !s(C)), void 0 !== L && (S = !s(L)), h(p + "autocolorscale", S), h(p + "colorscale"), h(p + "reversescale"), "marker.line." !== p && (p && m && (E = a(g)), h(p + "showscale", E) && (p && v && (y._template = v), o(g, y, u)));
                };
            },
            65477: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(65657), a = r(10721), o = r(34809), s = r(78766), l = r(19017).isValid, c = [
                    "showscale",
                    "autocolorscale",
                    "colorscale",
                    "reversescale",
                    "colorbar"
                ], u = [
                    "min",
                    "max",
                    "mid",
                    "auto"
                ];
                function h(t1) {
                    var e1, r, n, i = t1._colorAx, a = i || t1, o = {};
                    for(r = 0; r < c.length; r++)o[n = c[r]] = a[n];
                    if (i) for(e1 = "c", r = 0; r < u.length; r++)o[n = u[r]] = a["c" + n];
                    else {
                        var s;
                        for(r = 0; r < u.length; r++)((s = "c" + (n = u[r])) in a || (s = "z" + n) in a) && (o[n] = a[s]);
                        e1 = s.charAt(0);
                    }
                    return o._sync = function(t1, r) {
                        var n = -1 !== u.indexOf(t1) ? e1 + t1 : t1;
                        a[n] = a["_" + n] = r;
                    }, o;
                }
                function f(t1) {
                    for(var e1 = h(t1), r = e1.min, n = e1.max, i = e1.reversescale ? p(e1.colorscale) : e1.colorscale, a = i.length, o = new Array(a), s = new Array(a), l = 0; l < a; l++){
                        var c = i[l];
                        o[l] = r + c[0] * (n - r), s[l] = c[1];
                    }
                    return {
                        domain: o,
                        range: s
                    };
                }
                function p(t1) {
                    for(var e1 = t1.length, r = new Array(e1), n = e1 - 1, i = 0; n >= 0; n--, i++){
                        var a = t1[n];
                        r[i] = [
                            1 - a[0],
                            a[1]
                        ];
                    }
                    return r;
                }
                function d(t1, e1) {
                    e1 = e1 || {};
                    for(var r = t1.domain, o = t1.range, l = o.length, c = new Array(l), u = 0; u < l; u++){
                        var h = i(o[u]).toRgb();
                        c[u] = [
                            h.r,
                            h.g,
                            h.b,
                            h.a
                        ];
                    }
                    var f, p = n.scale.linear().domain(r).range(c).clamp(!0), d = e1.noNumericCheck, g = e1.returnArray;
                    return (f = d && g ? p : d ? function(t1) {
                        return m(p(t1));
                    } : g ? function(t1) {
                        return a(t1) ? p(t1) : i(t1).isValid() ? t1 : s.defaultLine;
                    } : function(t1) {
                        return a(t1) ? m(p(t1)) : i(t1).isValid() ? t1 : s.defaultLine;
                    }).domain = p.domain, f.range = function() {
                        return o;
                    }, f;
                }
                function m(t1) {
                    var e1 = {
                        r: t1[0],
                        g: t1[1],
                        b: t1[2],
                        a: t1[3]
                    };
                    return i(e1).toRgbString();
                }
                t1.exports = {
                    hasColorscale: function(t1, e1, r) {
                        var n = e1 ? o.nestedProperty(t1, e1).get() || {} : t1, i = n[r || "color"];
                        i && i._inputArray && (i = i._inputArray);
                        var s = !1;
                        if (o.isArrayOrTypedArray(i)) {
                            for(var c = 0; c < i.length; c++)if (a(i[c])) {
                                s = !0;
                                break;
                            }
                        }
                        return o.isPlainObject(n) && (s || !0 === n.showscale || a(n.cmin) && a(n.cmax) || l(n.colorscale) || o.isPlainObject(n.colorbar));
                    },
                    extractOpts: h,
                    extractScale: f,
                    flipScale: p,
                    makeColorScaleFunc: d,
                    makeColorScaleFuncFromTrace: function(t1, e1) {
                        return d(f(t1), e1);
                    }
                };
            },
            88856: function(t1, e1, r) {
                "use strict";
                var n = r(19017), i = r(65477);
                t1.exports = {
                    moduleType: "component",
                    name: "colorscale",
                    attributes: r(87163),
                    layoutAttributes: r(56978),
                    supplyLayoutDefaults: r(64613),
                    handleDefaults: r(39356),
                    crossTraceDefaults: r(67623),
                    calc: r(28379),
                    scales: n.scales,
                    defaultScale: n.defaultScale,
                    getScale: n.get,
                    isValidScale: n.isValid,
                    hasColorscale: i.hasColorscale,
                    extractOpts: i.extractOpts,
                    extractScale: i.extractScale,
                    flipScale: i.flipScale,
                    makeColorScaleFunc: i.makeColorScaleFunc,
                    makeColorScaleFuncFromTrace: i.makeColorScaleFuncFromTrace
                };
            },
            56978: function(t1, e1, r) {
                "use strict";
                var n = r(93049).extendFlat, i = r(87163), a = r(19017).scales;
                t1.exports = {
                    editType: "calc",
                    colorscale: {
                        editType: "calc",
                        sequential: {
                            valType: "colorscale",
                            dflt: a.Reds,
                            editType: "calc"
                        },
                        sequentialminus: {
                            valType: "colorscale",
                            dflt: a.Blues,
                            editType: "calc"
                        },
                        diverging: {
                            valType: "colorscale",
                            dflt: a.RdBu,
                            editType: "calc"
                        }
                    },
                    coloraxis: n({
                        _isSubplotObj: !0,
                        editType: "calc"
                    }, i("", {
                        colorAttr: "corresponding trace color array(s)",
                        noColorAxis: !0,
                        showScaleDflt: !0
                    }))
                };
            },
            64613: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(78032), a = r(56978), o = r(39356);
                t1.exports = function(t1, e1) {
                    function r(r, i) {
                        return n.coerce(t1, e1, a, r, i);
                    }
                    r("colorscale.sequential"), r("colorscale.sequentialminus"), r("colorscale.diverging");
                    var s, l, c = e1._colorAxes;
                    function u(t1, e1) {
                        return n.coerce(s, l, a.coloraxis, t1, e1);
                    }
                    for(var h in c){
                        var f = c[h];
                        if (f[0]) s = t1[h] || {}, (l = i.newContainer(e1, h, "coloraxis"))._name = h, o(s, l, e1, u, {
                            prefix: "",
                            cLetter: "c"
                        });
                        else {
                            for(var p = 0; p < f[2].length; p++)f[2][p]();
                            delete e1._colorAxes[h];
                        }
                    }
                };
            },
            19017: function(t1, e1, r) {
                "use strict";
                var n = r(65657), i = {
                    Greys: [
                        [
                            0,
                            "rgb(0,0,0)"
                        ],
                        [
                            1,
                            "rgb(255,255,255)"
                        ]
                    ],
                    YlGnBu: [
                        [
                            0,
                            "rgb(8,29,88)"
                        ],
                        [
                            .125,
                            "rgb(37,52,148)"
                        ],
                        [
                            .25,
                            "rgb(34,94,168)"
                        ],
                        [
                            .375,
                            "rgb(29,145,192)"
                        ],
                        [
                            .5,
                            "rgb(65,182,196)"
                        ],
                        [
                            .625,
                            "rgb(127,205,187)"
                        ],
                        [
                            .75,
                            "rgb(199,233,180)"
                        ],
                        [
                            .875,
                            "rgb(237,248,217)"
                        ],
                        [
                            1,
                            "rgb(255,255,217)"
                        ]
                    ],
                    Greens: [
                        [
                            0,
                            "rgb(0,68,27)"
                        ],
                        [
                            .125,
                            "rgb(0,109,44)"
                        ],
                        [
                            .25,
                            "rgb(35,139,69)"
                        ],
                        [
                            .375,
                            "rgb(65,171,93)"
                        ],
                        [
                            .5,
                            "rgb(116,196,118)"
                        ],
                        [
                            .625,
                            "rgb(161,217,155)"
                        ],
                        [
                            .75,
                            "rgb(199,233,192)"
                        ],
                        [
                            .875,
                            "rgb(229,245,224)"
                        ],
                        [
                            1,
                            "rgb(247,252,245)"
                        ]
                    ],
                    YlOrRd: [
                        [
                            0,
                            "rgb(128,0,38)"
                        ],
                        [
                            .125,
                            "rgb(189,0,38)"
                        ],
                        [
                            .25,
                            "rgb(227,26,28)"
                        ],
                        [
                            .375,
                            "rgb(252,78,42)"
                        ],
                        [
                            .5,
                            "rgb(253,141,60)"
                        ],
                        [
                            .625,
                            "rgb(254,178,76)"
                        ],
                        [
                            .75,
                            "rgb(254,217,118)"
                        ],
                        [
                            .875,
                            "rgb(255,237,160)"
                        ],
                        [
                            1,
                            "rgb(255,255,204)"
                        ]
                    ],
                    Bluered: [
                        [
                            0,
                            "rgb(0,0,255)"
                        ],
                        [
                            1,
                            "rgb(255,0,0)"
                        ]
                    ],
                    RdBu: [
                        [
                            0,
                            "rgb(5,10,172)"
                        ],
                        [
                            .35,
                            "rgb(106,137,247)"
                        ],
                        [
                            .5,
                            "rgb(190,190,190)"
                        ],
                        [
                            .6,
                            "rgb(220,170,132)"
                        ],
                        [
                            .7,
                            "rgb(230,145,90)"
                        ],
                        [
                            1,
                            "rgb(178,10,28)"
                        ]
                    ],
                    Reds: [
                        [
                            0,
                            "rgb(220,220,220)"
                        ],
                        [
                            .2,
                            "rgb(245,195,157)"
                        ],
                        [
                            .4,
                            "rgb(245,160,105)"
                        ],
                        [
                            1,
                            "rgb(178,10,28)"
                        ]
                    ],
                    Blues: [
                        [
                            0,
                            "rgb(5,10,172)"
                        ],
                        [
                            .35,
                            "rgb(40,60,190)"
                        ],
                        [
                            .5,
                            "rgb(70,100,245)"
                        ],
                        [
                            .6,
                            "rgb(90,120,245)"
                        ],
                        [
                            .7,
                            "rgb(106,137,247)"
                        ],
                        [
                            1,
                            "rgb(220,220,220)"
                        ]
                    ],
                    Picnic: [
                        [
                            0,
                            "rgb(0,0,255)"
                        ],
                        [
                            .1,
                            "rgb(51,153,255)"
                        ],
                        [
                            .2,
                            "rgb(102,204,255)"
                        ],
                        [
                            .3,
                            "rgb(153,204,255)"
                        ],
                        [
                            .4,
                            "rgb(204,204,255)"
                        ],
                        [
                            .5,
                            "rgb(255,255,255)"
                        ],
                        [
                            .6,
                            "rgb(255,204,255)"
                        ],
                        [
                            .7,
                            "rgb(255,153,255)"
                        ],
                        [
                            .8,
                            "rgb(255,102,204)"
                        ],
                        [
                            .9,
                            "rgb(255,102,102)"
                        ],
                        [
                            1,
                            "rgb(255,0,0)"
                        ]
                    ],
                    Rainbow: [
                        [
                            0,
                            "rgb(150,0,90)"
                        ],
                        [
                            .125,
                            "rgb(0,0,200)"
                        ],
                        [
                            .25,
                            "rgb(0,25,255)"
                        ],
                        [
                            .375,
                            "rgb(0,152,255)"
                        ],
                        [
                            .5,
                            "rgb(44,255,150)"
                        ],
                        [
                            .625,
                            "rgb(151,255,0)"
                        ],
                        [
                            .75,
                            "rgb(255,234,0)"
                        ],
                        [
                            .875,
                            "rgb(255,111,0)"
                        ],
                        [
                            1,
                            "rgb(255,0,0)"
                        ]
                    ],
                    Portland: [
                        [
                            0,
                            "rgb(12,51,131)"
                        ],
                        [
                            .25,
                            "rgb(10,136,186)"
                        ],
                        [
                            .5,
                            "rgb(242,211,56)"
                        ],
                        [
                            .75,
                            "rgb(242,143,56)"
                        ],
                        [
                            1,
                            "rgb(217,30,30)"
                        ]
                    ],
                    Jet: [
                        [
                            0,
                            "rgb(0,0,131)"
                        ],
                        [
                            .125,
                            "rgb(0,60,170)"
                        ],
                        [
                            .375,
                            "rgb(5,255,255)"
                        ],
                        [
                            .625,
                            "rgb(255,255,0)"
                        ],
                        [
                            .875,
                            "rgb(250,0,0)"
                        ],
                        [
                            1,
                            "rgb(128,0,0)"
                        ]
                    ],
                    Hot: [
                        [
                            0,
                            "rgb(0,0,0)"
                        ],
                        [
                            .3,
                            "rgb(230,0,0)"
                        ],
                        [
                            .6,
                            "rgb(255,210,0)"
                        ],
                        [
                            1,
                            "rgb(255,255,255)"
                        ]
                    ],
                    Blackbody: [
                        [
                            0,
                            "rgb(0,0,0)"
                        ],
                        [
                            .2,
                            "rgb(230,0,0)"
                        ],
                        [
                            .4,
                            "rgb(230,210,0)"
                        ],
                        [
                            .7,
                            "rgb(255,255,255)"
                        ],
                        [
                            1,
                            "rgb(160,200,255)"
                        ]
                    ],
                    Earth: [
                        [
                            0,
                            "rgb(0,0,130)"
                        ],
                        [
                            .1,
                            "rgb(0,180,180)"
                        ],
                        [
                            .2,
                            "rgb(40,210,40)"
                        ],
                        [
                            .4,
                            "rgb(230,230,50)"
                        ],
                        [
                            .6,
                            "rgb(120,70,20)"
                        ],
                        [
                            1,
                            "rgb(255,255,255)"
                        ]
                    ],
                    Electric: [
                        [
                            0,
                            "rgb(0,0,0)"
                        ],
                        [
                            .15,
                            "rgb(30,0,100)"
                        ],
                        [
                            .4,
                            "rgb(120,0,100)"
                        ],
                        [
                            .6,
                            "rgb(160,90,0)"
                        ],
                        [
                            .8,
                            "rgb(230,200,0)"
                        ],
                        [
                            1,
                            "rgb(255,250,220)"
                        ]
                    ],
                    Viridis: [
                        [
                            0,
                            "#440154"
                        ],
                        [
                            .06274509803921569,
                            "#48186a"
                        ],
                        [
                            .12549019607843137,
                            "#472d7b"
                        ],
                        [
                            .18823529411764706,
                            "#424086"
                        ],
                        [
                            .25098039215686274,
                            "#3b528b"
                        ],
                        [
                            .3137254901960784,
                            "#33638d"
                        ],
                        [
                            .3764705882352941,
                            "#2c728e"
                        ],
                        [
                            .4392156862745098,
                            "#26828e"
                        ],
                        [
                            .5019607843137255,
                            "#21918c"
                        ],
                        [
                            .5647058823529412,
                            "#1fa088"
                        ],
                        [
                            .6274509803921569,
                            "#28ae80"
                        ],
                        [
                            .6901960784313725,
                            "#3fbc73"
                        ],
                        [
                            .7529411764705882,
                            "#5ec962"
                        ],
                        [
                            .8156862745098039,
                            "#84d44b"
                        ],
                        [
                            .8784313725490196,
                            "#addc30"
                        ],
                        [
                            .9411764705882353,
                            "#d8e219"
                        ],
                        [
                            1,
                            "#fde725"
                        ]
                    ],
                    Cividis: [
                        [
                            0,
                            "rgb(0,32,76)"
                        ],
                        [
                            .058824,
                            "rgb(0,42,102)"
                        ],
                        [
                            .117647,
                            "rgb(0,52,110)"
                        ],
                        [
                            .176471,
                            "rgb(39,63,108)"
                        ],
                        [
                            .235294,
                            "rgb(60,74,107)"
                        ],
                        [
                            .294118,
                            "rgb(76,85,107)"
                        ],
                        [
                            .352941,
                            "rgb(91,95,109)"
                        ],
                        [
                            .411765,
                            "rgb(104,106,112)"
                        ],
                        [
                            .470588,
                            "rgb(117,117,117)"
                        ],
                        [
                            .529412,
                            "rgb(131,129,120)"
                        ],
                        [
                            .588235,
                            "rgb(146,140,120)"
                        ],
                        [
                            .647059,
                            "rgb(161,152,118)"
                        ],
                        [
                            .705882,
                            "rgb(176,165,114)"
                        ],
                        [
                            .764706,
                            "rgb(192,177,109)"
                        ],
                        [
                            .823529,
                            "rgb(209,191,102)"
                        ],
                        [
                            .882353,
                            "rgb(225,204,92)"
                        ],
                        [
                            .941176,
                            "rgb(243,219,79)"
                        ],
                        [
                            1,
                            "rgb(255,233,69)"
                        ]
                    ]
                }, a = i.RdBu;
                function o(t1) {
                    var e1 = 0;
                    if (!Array.isArray(t1) || t1.length < 2) return !1;
                    if (!t1[0] || !t1[t1.length - 1]) return !1;
                    if (0 != +t1[0][0] || 1 != +t1[t1.length - 1][0]) return !1;
                    for(var r = 0; r < t1.length; r++){
                        var i = t1[r];
                        if (2 !== i.length || +i[0] < e1 || !n(i[1]).isValid()) return !1;
                        e1 = +i[0];
                    }
                    return !0;
                }
                t1.exports = {
                    scales: i,
                    defaultScale: a,
                    get: function(t1, e1) {
                        if (e1 || (e1 = a), !t1) return e1;
                        function r() {
                            try {
                                t1 = i[t1] || JSON.parse(t1);
                            } catch (r) {
                                t1 = e1;
                            }
                        }
                        return "string" == typeof t1 && (r(), "string" == typeof t1 && r()), o(t1) ? t1 : e1;
                    },
                    isValid: function(t1) {
                        return void 0 !== i[t1] || o(t1);
                    }
                };
            },
            53770: function(t1) {
                "use strict";
                t1.exports = function(t1, e1, r, n, i) {
                    var a = (t1 - r) / (n - r), o = a + e1 / (n - r), s = (a + o) / 2;
                    return "left" === i || "bottom" === i ? a : "center" === i || "middle" === i ? s : "right" === i || "top" === i ? o : a < 2 / 3 - s ? a : o > 4 / 3 - s ? o : s;
                };
            },
            4001: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = [
                    [
                        "sw-resize",
                        "s-resize",
                        "se-resize"
                    ],
                    [
                        "w-resize",
                        "move",
                        "e-resize"
                    ],
                    [
                        "nw-resize",
                        "n-resize",
                        "ne-resize"
                    ]
                ];
                t1.exports = function(t1, e1, r, a) {
                    return t1 = "left" === r ? 0 : "center" === r ? 1 : "right" === r ? 2 : n.constrain(Math.floor(3 * t1), 0, 2), e1 = "bottom" === a ? 0 : "middle" === a ? 1 : "top" === a ? 2 : n.constrain(Math.floor(3 * e1), 0, 2), i[e1][t1];
                };
            },
            70414: function(t1, e1) {
                "use strict";
                e1.selectMode = function(t1) {
                    return "lasso" === t1 || "select" === t1;
                }, e1.drawMode = function(t1) {
                    return "drawclosedpath" === t1 || "drawopenpath" === t1 || "drawline" === t1 || "drawrect" === t1 || "drawcircle" === t1;
                }, e1.openMode = function(t1) {
                    return "drawline" === t1 || "drawopenpath" === t1;
                }, e1.rectMode = function(t1) {
                    return "select" === t1 || "drawline" === t1 || "drawrect" === t1 || "drawcircle" === t1;
                }, e1.freeMode = function(t1) {
                    return "lasso" === t1 || "drawclosedpath" === t1 || "drawopenpath" === t1;
                }, e1.selectingOrDrawing = function(t1) {
                    return e1.freeMode(t1) || e1.rectMode(t1);
                };
            },
            14751: function(t1, e1, r) {
                "use strict";
                var n = r(44039), i = r(39784), a = r(74043), o = r(34809).removeElement, s = r(54826), l = t1.exports = {};
                l.align = r(53770), l.getCursor = r(4001);
                var c = r(60148);
                function u() {
                    var t1 = document.createElement("div");
                    t1.className = "dragcover";
                    var e1 = t1.style;
                    return e1.position = "fixed", e1.left = 0, e1.right = 0, e1.top = 0, e1.bottom = 0, e1.zIndex = 999999999, e1.background = "none", document.body.appendChild(t1), t1;
                }
                function h(t1) {
                    return n(t1.changedTouches ? t1.changedTouches[0] : t1, document.body);
                }
                l.unhover = c.wrapped, l.unhoverRaw = c.raw, l.init = function(t1) {
                    var e1, r, n, c, f, p, d, m, g = t1.gd, y = 1, v = g._context.doubleClickDelay, x = t1.element;
                    g._mouseDownTime || (g._mouseDownTime = 0), x.style.pointerEvents = "all", x.onmousedown = b, a ? (x._ontouchstart && x.removeEventListener("touchstart", x._ontouchstart), x._ontouchstart = b, x.addEventListener("touchstart", b, {
                        passive: !1
                    })) : x.ontouchstart = b;
                    var _ = t1.clampFn || function(t1, e1, r) {
                        return Math.abs(t1) < r && (t1 = 0), Math.abs(e1) < r && (e1 = 0), [
                            t1,
                            e1
                        ];
                    };
                    function b(a) {
                        g._dragged = !1, g._dragging = !0;
                        var o = h(a);
                        e1 = o[0], r = o[1], d = a.target, p = a, m = 2 === a.buttons || a.ctrlKey, void 0 === a.clientX && void 0 === a.clientY && (a.clientX = e1, a.clientY = r), (n = (new Date).getTime()) - g._mouseDownTime < v ? y += 1 : (y = 1, g._mouseDownTime = n), t1.prepFn && t1.prepFn(a, e1, r), i && !m ? (f = u()).style.cursor = window.getComputedStyle(x).cursor : i || (f = document, c = window.getComputedStyle(document.documentElement).cursor, document.documentElement.style.cursor = window.getComputedStyle(x).cursor), document.addEventListener("mouseup", T), document.addEventListener("touchend", T), !1 !== t1.dragmode && (a.preventDefault(), document.addEventListener("mousemove", w), document.addEventListener("touchmove", w, {
                            passive: !1
                        }));
                    }
                    function w(n) {
                        n.preventDefault();
                        var i = h(n), a = t1.minDrag || s.MINDRAG, o = _(i[0] - e1, i[1] - r, a), c = o[0], u = o[1];
                        (c || u) && (g._dragged = !0, l.unhover(g, n)), g._dragged && t1.moveFn && !m && (g._dragdata = {
                            element: x,
                            dx: c,
                            dy: u
                        }, t1.moveFn(c, u));
                    }
                    function T(e1) {
                        if (delete g._dragdata, !1 !== t1.dragmode && (e1.preventDefault(), document.removeEventListener("mousemove", w), document.removeEventListener("touchmove", w)), document.removeEventListener("mouseup", T), document.removeEventListener("touchend", T), i ? o(f) : c && (f.documentElement.style.cursor = c, c = null), g._dragging) {
                            if (g._dragging = !1, (new Date).getTime() - g._mouseDownTime > v && (y = Math.max(y - 1, 1)), g._dragged) t1.doneFn && t1.doneFn();
                            else if (t1.clickFn && t1.clickFn(y, p), !m) {
                                var r;
                                try {
                                    r = new MouseEvent("click", e1);
                                } catch (t1) {
                                    var n = h(e1);
                                    (r = document.createEvent("MouseEvents")).initMouseEvent("click", e1.bubbles, e1.cancelable, e1.view, e1.detail, e1.screenX, e1.screenY, n[0], n[1], e1.ctrlKey, e1.altKey, e1.shiftKey, e1.metaKey, e1.button, e1.relatedTarget);
                                }
                                d.dispatchEvent(r);
                            }
                            g._dragging = !1, g._dragged = !1;
                        } else g._dragged = !1;
                    }
                }, l.coverSlip = u;
            },
            60148: function(t1, e1, r) {
                "use strict";
                var n = r(68596), i = r(64025), a = r(95425).getGraphDiv, o = r(85988), s = t1.exports = {};
                s.wrapped = function(t1, e1, r) {
                    (t1 = a(t1))._fullLayout && i.clear(t1._fullLayout._uid + o.HOVERID), s.raw(t1, e1, r);
                }, s.raw = function(t1, e1) {
                    var r = t1._fullLayout, i = t1._hoverdata;
                    e1 || (e1 = {}), e1.target && !t1._dragged && !1 === n.triggerHandler(t1, "plotly_beforehover", e1) || (r._hoverlayer.selectAll("g").remove(), r._hoverlayer.selectAll("line").remove(), r._hoverlayer.selectAll("circle").remove(), t1._hoverdata = void 0, e1.target && i && t1.emit("plotly_unhover", {
                        event: e1,
                        points: i
                    }));
                };
            },
            94850: function(t1, e1) {
                "use strict";
                e1.T = {
                    valType: "string",
                    values: [
                        "solid",
                        "dot",
                        "dash",
                        "longdash",
                        "dashdot",
                        "longdashdot"
                    ],
                    dflt: "solid",
                    editType: "style"
                }, e1.k = {
                    shape: {
                        valType: "enumerated",
                        values: [
                            "",
                            "/",
                            "\\",
                            "x",
                            "-",
                            "|",
                            "+",
                            "."
                        ],
                        dflt: "",
                        arrayOk: !0,
                        editType: "style"
                    },
                    fillmode: {
                        valType: "enumerated",
                        values: [
                            "replace",
                            "overlay"
                        ],
                        dflt: "replace",
                        editType: "style"
                    },
                    bgcolor: {
                        valType: "color",
                        arrayOk: !0,
                        editType: "style"
                    },
                    fgcolor: {
                        valType: "color",
                        arrayOk: !0,
                        editType: "style"
                    },
                    fgopacity: {
                        valType: "number",
                        editType: "style",
                        min: 0,
                        max: 1
                    },
                    size: {
                        valType: "number",
                        min: 0,
                        dflt: 8,
                        arrayOk: !0,
                        editType: "style"
                    },
                    solidity: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: .3,
                        arrayOk: !0,
                        editType: "style"
                    },
                    editType: "style"
                };
            },
            62203: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(34809), a = i.numberFormat, o = r(10721), s = r(65657), l = r(33626), c = r(78766), u = r(88856), h = i.strTranslate, f = r(30635), p = r(62972), d = r(4530).LINE_SPACING, m = r(20438).DESELECTDIM, g = r(64726), y = r(92527), v = r(36040).appendArrayPointValue, x = t1.exports = {};
                function _(t1) {
                    return "none" === t1 ? void 0 : t1;
                }
                x.font = function(t1, e1) {
                    var r = e1.variant, n = e1.style, i = e1.weight, a = e1.color, o = e1.size, s = e1.family, l = e1.shadow, u = e1.lineposition, h = e1.textcase;
                    s && t1.style("font-family", s), o + 1 && t1.style("font-size", o + "px"), a && t1.call(c.fill, a), i && t1.style("font-weight", i), n && t1.style("font-style", n), r && t1.style("font-variant", r), h && t1.style("text-transform", _(function(t1) {
                        return b[t1];
                    }(h))), l && t1.style("text-shadow", "auto" === l ? f.makeTextShadow(c.contrast(a)) : _(l)), u && t1.style("text-decoration-line", _(function(t1) {
                        return t1.replace("under", "underline").replace("over", "overline").replace("through", "line-through").split("+").join(" ");
                    }(u)));
                };
                var b = {
                    normal: "none",
                    lower: "lowercase",
                    upper: "uppercase",
                    "word caps": "capitalize"
                };
                function w(t1, e1, r, n) {
                    var i = e1.fillpattern, a = e1.fillgradient, o = i && x.getPatternAttr(i.shape, 0, "");
                    if (o) {
                        var s = x.getPatternAttr(i.bgcolor, 0, null), l = x.getPatternAttr(i.fgcolor, 0, null), u = i.fgopacity, h = x.getPatternAttr(i.size, 0, 8), f = x.getPatternAttr(i.solidity, 0, .3), p = e1.uid;
                        x.pattern(t1, "point", r, p, o, h, f, void 0, i.fillmode, s, l, u);
                    } else if (a && "none" !== a.type) {
                        var d, m, g = a.type, y = "scatterfill-" + e1.uid;
                        n && (y = "legendfill-" + e1.uid), n || void 0 === a.start && void 0 === a.stop ? ("horizontal" === g && (g += "reversed"), t1.call(x.gradient, r, y, g, a.colorscale, "fill")) : ("horizontal" === g ? (d = {
                            x: a.start,
                            y: 0
                        }, m = {
                            x: a.stop,
                            y: 0
                        }) : "vertical" === g && (d = {
                            x: 0,
                            y: a.start
                        }, m = {
                            x: 0,
                            y: a.stop
                        }), d.x = e1._xA.c2p(void 0 === d.x ? e1._extremes.x.min[0].val : d.x, !0), d.y = e1._yA.c2p(void 0 === d.y ? e1._extremes.y.min[0].val : d.y, !0), m.x = e1._xA.c2p(void 0 === m.x ? e1._extremes.x.max[0].val : m.x, !0), m.y = e1._yA.c2p(void 0 === m.y ? e1._extremes.y.max[0].val : m.y, !0), t1.call(E, r, y, "linear", a.colorscale, "fill", d, m, !0, !1));
                    } else e1.fillcolor && t1.call(c.fill, e1.fillcolor);
                }
                x.setPosition = function(t1, e1, r) {
                    t1.attr("x", e1).attr("y", r);
                }, x.setSize = function(t1, e1, r) {
                    t1.attr("width", e1).attr("height", r);
                }, x.setRect = function(t1, e1, r, n, i) {
                    t1.call(x.setPosition, e1, r).call(x.setSize, n, i);
                }, x.translatePoint = function(t1, e1, r, n) {
                    var i = r.c2p(t1.x), a = n.c2p(t1.y);
                    return !!(o(i) && o(a) && e1.node()) && ("text" === e1.node().nodeName ? e1.attr("x", i).attr("y", a) : e1.attr("transform", h(i, a)), !0);
                }, x.translatePoints = function(t1, e1, r) {
                    t1.each(function(t1) {
                        var i = n.select(this);
                        x.translatePoint(t1, i, e1, r);
                    });
                }, x.hideOutsideRangePoint = function(t1, e1, r, n, i, a) {
                    e1.attr("display", r.isPtWithinRange(t1, i) && n.isPtWithinRange(t1, a) ? null : "none");
                }, x.hideOutsideRangePoints = function(t1, e1) {
                    if (e1._hasClipOnAxisFalse) {
                        var r = e1.xaxis, i = e1.yaxis;
                        t1.each(function(e1) {
                            var a = e1[0].trace, o = a.xcalendar, s = a.ycalendar, c = l.traceIs(a, "bar-like") ? ".bartext" : ".point,.textpoint";
                            t1.selectAll(c).each(function(t1) {
                                x.hideOutsideRangePoint(t1, n.select(this), r, i, o, s);
                            });
                        });
                    }
                }, x.crispRound = function(t1, e1, r) {
                    return e1 && o(e1) ? t1._context.staticPlot ? e1 : e1 < 1 ? 1 : Math.round(e1) : r || 0;
                }, x.singleLineStyle = function(t1, e1, r, n, i) {
                    e1.style("fill", "none");
                    var a = (((t1 || [])[0] || {}).trace || {}).line || {}, o = r || a.width || 0, s = i || a.dash || "";
                    c.stroke(e1, n || a.color), x.dashLine(e1, s, o);
                }, x.lineGroupStyle = function(t1, e1, r, i) {
                    t1.style("fill", "none").each(function(t1) {
                        var a = (((t1 || [])[0] || {}).trace || {}).line || {}, o = e1 || a.width || 0, s = i || a.dash || "";
                        n.select(this).call(c.stroke, r || a.color).call(x.dashLine, s, o);
                    });
                }, x.dashLine = function(t1, e1, r) {
                    r = +r || 0, e1 = x.dashStyle(e1, r), t1.style({
                        "stroke-dasharray": e1,
                        "stroke-width": r + "px"
                    });
                }, x.dashStyle = function(t1, e1) {
                    e1 = +e1 || 1;
                    var r = Math.max(e1, 3);
                    return "solid" === t1 ? t1 = "" : "dot" === t1 ? t1 = r + "px," + r + "px" : "dash" === t1 ? t1 = 3 * r + "px," + 3 * r + "px" : "longdash" === t1 ? t1 = 5 * r + "px," + 5 * r + "px" : "dashdot" === t1 ? t1 = 3 * r + "px," + r + "px," + r + "px," + r + "px" : "longdashdot" === t1 && (t1 = 5 * r + "px," + 2 * r + "px," + r + "px," + 2 * r + "px"), t1;
                }, x.singleFillStyle = function(t1, e1) {
                    var r = n.select(t1.node());
                    w(t1, ((r.data()[0] || [])[0] || {}).trace || {}, e1, !1);
                }, x.fillGroupStyle = function(t1, e1, r) {
                    t1.style("stroke-width", 0).each(function(t1) {
                        var i = n.select(this);
                        t1[0].trace && w(i, t1[0].trace, e1, r);
                    });
                };
                var T = r(38882);
                x.symbolNames = [], x.symbolFuncs = [], x.symbolBackOffs = [], x.symbolNeedLines = {}, x.symbolNoDot = {}, x.symbolNoFill = {}, x.symbolList = [], Object.keys(T).forEach(function(t1) {
                    var e1 = T[t1], r = e1.n;
                    x.symbolList.push(r, String(r), t1, r + 100, String(r + 100), t1 + "-open"), x.symbolNames[r] = t1, x.symbolFuncs[r] = e1.f, x.symbolBackOffs[r] = e1.backoff || 0, e1.needLine && (x.symbolNeedLines[r] = !0), e1.noDot ? x.symbolNoDot[r] = !0 : x.symbolList.push(r + 200, String(r + 200), t1 + "-dot", r + 300, String(r + 300), t1 + "-open-dot"), e1.noFill && (x.symbolNoFill[r] = !0);
                });
                var k = x.symbolNames.length;
                function A(t1, e1, r, n) {
                    var i = t1 % 100;
                    return x.symbolFuncs[i](e1, r, n) + (t1 >= 200 ? "M0,0.5L0.5,0L0,-0.5L-0.5,0Z" : "");
                }
                x.symbolNumber = function(t1) {
                    if (o(t1)) t1 = +t1;
                    else if ("string" == typeof t1) {
                        var e1 = 0;
                        t1.indexOf("-open") > 0 && (e1 = 100, t1 = t1.replace("-open", "")), t1.indexOf("-dot") > 0 && (e1 += 200, t1 = t1.replace("-dot", "")), (t1 = x.symbolNames.indexOf(t1)) >= 0 && (t1 += e1);
                    }
                    return t1 % 100 >= k || t1 >= 400 ? 0 : Math.floor(Math.max(t1, 0));
                };
                var M = a("~f"), S = {
                    radial: {
                        type: "radial"
                    },
                    radialreversed: {
                        type: "radial",
                        reversed: !0
                    },
                    horizontal: {
                        type: "linear",
                        start: {
                            x: 1,
                            y: 0
                        },
                        stop: {
                            x: 0,
                            y: 0
                        }
                    },
                    horizontalreversed: {
                        type: "linear",
                        start: {
                            x: 1,
                            y: 0
                        },
                        stop: {
                            x: 0,
                            y: 0
                        },
                        reversed: !0
                    },
                    vertical: {
                        type: "linear",
                        start: {
                            x: 0,
                            y: 1
                        },
                        stop: {
                            x: 0,
                            y: 0
                        }
                    },
                    verticalreversed: {
                        type: "linear",
                        start: {
                            x: 0,
                            y: 1
                        },
                        stop: {
                            x: 0,
                            y: 0
                        },
                        reversed: !0
                    }
                };
                function E(t1, e1, r, a, o, l, u, h, f, p) {
                    var d, m = o.length;
                    "linear" === a ? d = {
                        node: "linearGradient",
                        attrs: {
                            x1: u.x,
                            y1: u.y,
                            x2: h.x,
                            y2: h.y,
                            gradientUnits: f ? "userSpaceOnUse" : "objectBoundingBox"
                        },
                        reversed: p
                    } : "radial" === a && (d = {
                        node: "radialGradient",
                        reversed: p
                    });
                    for(var g = new Array(m), y = 0; y < m; y++)d.reversed ? g[m - 1 - y] = [
                        M(100 * (1 - o[y][0])),
                        o[y][1]
                    ] : g[y] = [
                        M(100 * o[y][0]),
                        o[y][1]
                    ];
                    var v = e1._fullLayout, x = "g" + v._uid + "-" + r, _ = v._defs.select(".gradients").selectAll("#" + x).data([
                        a + g.join(";")
                    ], i.identity);
                    _.exit().remove(), _.enter().append(d.node).each(function() {
                        var t1 = n.select(this);
                        d.attrs && t1.attr(d.attrs), t1.attr("id", x);
                        var e1 = t1.selectAll("stop").data(g);
                        e1.exit().remove(), e1.enter().append("stop"), e1.each(function(t1) {
                            var e1 = s(t1[1]);
                            n.select(this).attr({
                                offset: t1[0] + "%",
                                "stop-color": c.tinyRGB(e1),
                                "stop-opacity": e1.getAlpha()
                            });
                        });
                    }), t1.style(l, q(x, e1)).style(l + "-opacity", null), t1.classed("gradient_filled", !0);
                }
                x.gradient = function(t1, e1, r, n, i, a) {
                    var o = S[n];
                    return E(t1, e1, r, o.type, i, a, o.start, o.stop, !1, o.reversed);
                }, x.pattern = function(t1, e1, r, a, o, l, u, h, f, p, d, m) {
                    var g = "legend" === e1;
                    h && ("overlay" === f ? (p = h, d = c.contrast(p)) : (p = void 0, d = h));
                    var y, v, x, _, b, w, T, k, A, M = r._fullLayout, S = "p" + M._uid + "-" + a, E = {}, C = s(d), L = c.tinyRGB(C), I = m * C.getAlpha();
                    switch(o){
                        case "/":
                            y = l * Math.sqrt(2), v = l * Math.sqrt(2), w = "path", E = {
                                d: x = "M-" + y / 4 + "," + v / 4 + "l" + y / 2 + ",-" + v / 2 + "M0," + v + "L" + y + ",0M" + y / 4 * 3 + "," + v / 4 * 5 + "l" + y / 2 + ",-" + v / 2,
                                opacity: I,
                                stroke: L,
                                "stroke-width": (_ = u * l) + "px"
                            };
                            break;
                        case "\\":
                            y = l * Math.sqrt(2), v = l * Math.sqrt(2), w = "path", E = {
                                d: x = "M" + y / 4 * 3 + ",-" + v / 4 + "l" + y / 2 + "," + v / 2 + "M0,0L" + y + "," + v + "M-" + y / 4 + "," + v / 4 * 3 + "l" + y / 2 + "," + v / 2,
                                opacity: I,
                                stroke: L,
                                "stroke-width": (_ = u * l) + "px"
                            };
                            break;
                        case "x":
                            y = l * Math.sqrt(2), v = l * Math.sqrt(2), x = "M-" + y / 4 + "," + v / 4 + "l" + y / 2 + ",-" + v / 2 + "M0," + v + "L" + y + ",0M" + y / 4 * 3 + "," + v / 4 * 5 + "l" + y / 2 + ",-" + v / 2 + "M" + y / 4 * 3 + ",-" + v / 4 + "l" + y / 2 + "," + v / 2 + "M0,0L" + y + "," + v + "M-" + y / 4 + "," + v / 4 * 3 + "l" + y / 2 + "," + v / 2, _ = l - l * Math.sqrt(1 - u), w = "path", E = {
                                d: x,
                                opacity: I,
                                stroke: L,
                                "stroke-width": _ + "px"
                            };
                            break;
                        case "|":
                            w = "path", w = "path", E = {
                                d: x = "M" + (y = l) / 2 + ",0L" + y / 2 + "," + (v = l),
                                opacity: I,
                                stroke: L,
                                "stroke-width": (_ = u * l) + "px"
                            };
                            break;
                        case "-":
                            w = "path", w = "path", E = {
                                d: x = "M0," + (v = l) / 2 + "L" + (y = l) + "," + v / 2,
                                opacity: I,
                                stroke: L,
                                "stroke-width": (_ = u * l) + "px"
                            };
                            break;
                        case "+":
                            w = "path", x = "M" + (y = l) / 2 + ",0L" + y / 2 + "," + (v = l) + "M0," + v / 2 + "L" + y + "," + v / 2, _ = l - l * Math.sqrt(1 - u), w = "path", E = {
                                d: x,
                                opacity: I,
                                stroke: L,
                                "stroke-width": _ + "px"
                            };
                            break;
                        case ".":
                            y = l, v = l, u < Math.PI / 4 ? b = Math.sqrt(u * l * l / Math.PI) : (T = u, k = Math.PI / 4, b = (A = l / 2) + (l / Math.sqrt(2) - A) * (T - k) / (1 - k)), w = "circle", E = {
                                cx: y / 2,
                                cy: v / 2,
                                r: b,
                                opacity: I,
                                fill: L
                            };
                    }
                    var P = [
                        o || "noSh",
                        p || "noBg",
                        d || "noFg",
                        l,
                        u
                    ].join(";"), z = M._defs.select(".patterns").selectAll("#" + S).data([
                        P
                    ], i.identity);
                    z.exit().remove(), z.enter().append("pattern").each(function() {
                        var t1 = n.select(this);
                        if (t1.attr({
                            id: S,
                            width: y + "px",
                            height: v + "px",
                            patternUnits: "userSpaceOnUse",
                            patternTransform: g ? "scale(0.8)" : ""
                        }), p) {
                            var e1 = s(p), r = c.tinyRGB(e1), i = e1.getAlpha(), a = t1.selectAll("rect").data([
                                0
                            ]);
                            a.exit().remove(), a.enter().append("rect").attr({
                                width: y + "px",
                                height: v + "px",
                                fill: r,
                                "fill-opacity": i
                            });
                        }
                        var o = t1.selectAll(w).data([
                            0
                        ]);
                        o.exit().remove(), o.enter().append(w).attr(E);
                    }), t1.style("fill", q(S, r)).style("fill-opacity", null), t1.classed("pattern_filled", !0);
                }, x.initGradients = function(t1) {
                    var e1 = t1._fullLayout;
                    i.ensureSingle(e1._defs, "g", "gradients").selectAll("linearGradient,radialGradient").remove(), n.select(t1).selectAll(".gradient_filled").classed("gradient_filled", !1);
                }, x.initPatterns = function(t1) {
                    var e1 = t1._fullLayout;
                    i.ensureSingle(e1._defs, "g", "patterns").selectAll("pattern").remove(), n.select(t1).selectAll(".pattern_filled").classed("pattern_filled", !1);
                }, x.getPatternAttr = function(t1, e1, r) {
                    return t1 && i.isArrayOrTypedArray(t1) ? e1 < t1.length ? t1[e1] : r : t1;
                }, x.pointStyle = function(t1, e1, r, i) {
                    if (t1.size()) {
                        var a = x.makePointStyleFns(e1);
                        t1.each(function(t1) {
                            x.singlePointStyle(t1, n.select(this), e1, a, r, i);
                        });
                    }
                }, x.singlePointStyle = function(t1, e1, r, n, a, o) {
                    var s = r.marker, l = s.line;
                    if (o && o.i >= 0 && void 0 === t1.i && (t1.i = o.i), e1.style("opacity", n.selectedOpacityFn ? n.selectedOpacityFn(t1) : void 0 === t1.mo ? s.opacity : t1.mo), n.ms2mrc) {
                        var u;
                        u = "various" === t1.ms || "various" === s.size ? 3 : n.ms2mrc(t1.ms), t1.mrc = u, n.selectedSizeFn && (u = t1.mrc = n.selectedSizeFn(t1));
                        var h = x.symbolNumber(t1.mx || s.symbol) || 0;
                        t1.om = h % 200 >= 100;
                        var f = nt(t1, r), p = Z(t1, r);
                        e1.attr("d", A(h, u, f, p));
                    }
                    var d, m, g, y = !1;
                    if (t1.so) g = l.outlierwidth, m = l.outliercolor, d = s.outliercolor;
                    else {
                        var v = (l || {}).width;
                        g = (t1.mlw + 1 || v + 1 || (t1.trace ? (t1.trace.marker.line || {}).width : 0) + 1) - 1 || 0, m = "mlc" in t1 ? t1.mlcc = n.lineScale(t1.mlc) : i.isArrayOrTypedArray(l.color) ? c.defaultLine : l.color, i.isArrayOrTypedArray(s.color) && (d = c.defaultLine, y = !0), d = "mc" in t1 ? t1.mcc = n.markerScale(t1.mc) : s.color || s.colors || "rgba(0,0,0,0)", n.selectedColorFn && (d = n.selectedColorFn(t1));
                    }
                    if (t1.om) e1.call(c.stroke, d).style({
                        "stroke-width": (g || 1) + "px",
                        fill: "none"
                    });
                    else {
                        e1.style("stroke-width", (t1.isBlank ? 0 : g) + "px");
                        var _ = s.gradient, b = t1.mgt;
                        b ? y = !0 : b = _ && _.type, i.isArrayOrTypedArray(b) && (b = b[0], S[b] || (b = 0));
                        var w = s.pattern, T = w && x.getPatternAttr(w.shape, t1.i, "");
                        if (b && "none" !== b) {
                            var k = t1.mgc;
                            k ? y = !0 : k = _.color;
                            var M = r.uid;
                            y && (M += "-" + t1.i), x.gradient(e1, a, M, b, [
                                [
                                    0,
                                    k
                                ],
                                [
                                    1,
                                    d
                                ]
                            ], "fill");
                        } else if (T) {
                            var E = !1, C = w.fgcolor;
                            !C && o && o.color && (C = o.color, E = !0);
                            var L = x.getPatternAttr(C, t1.i, o && o.color || null), I = x.getPatternAttr(w.bgcolor, t1.i, null), P = w.fgopacity, z = x.getPatternAttr(w.size, t1.i, 8), O = x.getPatternAttr(w.solidity, t1.i, .3);
                            E = E || t1.mcc || i.isArrayOrTypedArray(w.shape) || i.isArrayOrTypedArray(w.bgcolor) || i.isArrayOrTypedArray(w.fgcolor) || i.isArrayOrTypedArray(w.size) || i.isArrayOrTypedArray(w.solidity);
                            var D = r.uid;
                            E && (D += "-" + t1.i), x.pattern(e1, "point", a, D, T, z, O, t1.mcc, w.fillmode, I, L, P);
                        } else i.isArrayOrTypedArray(d) ? c.fill(e1, d[t1.i]) : c.fill(e1, d);
                        g && c.stroke(e1, m);
                    }
                }, x.makePointStyleFns = function(t1) {
                    var e1 = {}, r = t1.marker;
                    return e1.markerScale = x.tryColorscale(r, ""), e1.lineScale = x.tryColorscale(r, "line"), l.traceIs(t1, "symbols") && (e1.ms2mrc = g.isBubble(t1) ? y(t1) : function() {
                        return (r.size || 6) / 2;
                    }), t1.selectedpoints && i.extendFlat(e1, x.makeSelectedPointStyleFns(t1)), e1;
                }, x.makeSelectedPointStyleFns = function(t1) {
                    var e1 = {}, r = t1.selected || {}, n = t1.unselected || {}, a = t1.marker || {}, o = r.marker || {}, s = n.marker || {}, c = a.opacity, u = o.opacity, h = s.opacity, f = void 0 !== u, p = void 0 !== h;
                    (i.isArrayOrTypedArray(c) || f || p) && (e1.selectedOpacityFn = function(t1) {
                        var e1 = void 0 === t1.mo ? a.opacity : t1.mo;
                        return t1.selected ? f ? u : e1 : p ? h : m * e1;
                    });
                    var d = a.color, g = o.color, y = s.color;
                    (g || y) && (e1.selectedColorFn = function(t1) {
                        var e1 = t1.mcc || d;
                        return t1.selected ? g || e1 : y || e1;
                    });
                    var v = a.size, x = o.size, _ = s.size, b = void 0 !== x, w = void 0 !== _;
                    return l.traceIs(t1, "symbols") && (b || w) && (e1.selectedSizeFn = function(t1) {
                        var e1 = t1.mrc || v / 2;
                        return t1.selected ? b ? x / 2 : e1 : w ? _ / 2 : e1;
                    }), e1;
                }, x.makeSelectedTextStyleFns = function(t1) {
                    var e1 = {}, r = t1.selected || {}, n = t1.unselected || {}, i = t1.textfont || {}, a = r.textfont || {}, o = n.textfont || {}, s = i.color, l = a.color, u = o.color;
                    return e1.selectedTextColorFn = function(t1) {
                        var e1 = t1.tc || s;
                        return t1.selected ? l || e1 : u || (l ? e1 : c.addOpacity(e1, m));
                    }, e1;
                }, x.selectedPointStyle = function(t1, e1) {
                    if (t1.size() && e1.selectedpoints) {
                        var r = x.makeSelectedPointStyleFns(e1), i = e1.marker || {}, a = [];
                        r.selectedOpacityFn && a.push(function(t1, e1) {
                            t1.style("opacity", r.selectedOpacityFn(e1));
                        }), r.selectedColorFn && a.push(function(t1, e1) {
                            c.fill(t1, r.selectedColorFn(e1));
                        }), r.selectedSizeFn && a.push(function(t1, n) {
                            var a = n.mx || i.symbol || 0, o = r.selectedSizeFn(n);
                            t1.attr("d", A(x.symbolNumber(a), o, nt(n, e1), Z(n, e1))), n.mrc2 = o;
                        }), a.length && t1.each(function(t1) {
                            for(var e1 = n.select(this), r = 0; r < a.length; r++)a[r](e1, t1);
                        });
                    }
                }, x.tryColorscale = function(t1, e1) {
                    var r = e1 ? i.nestedProperty(t1, e1).get() : t1;
                    if (r) {
                        var n = r.color;
                        if ((r.colorscale || r._colorAx) && i.isArrayOrTypedArray(n)) return u.makeColorScaleFuncFromTrace(r);
                    }
                    return i.identity;
                };
                var C, L, I = {
                    start: 1,
                    end: -1,
                    middle: 0,
                    bottom: 1,
                    top: -1
                };
                function P(t1, e1, r, i, a) {
                    var o = n.select(t1.node().parentNode), s = -1 !== e1.indexOf("top") ? "top" : -1 !== e1.indexOf("bottom") ? "bottom" : "middle", l = -1 !== e1.indexOf("left") ? "end" : -1 !== e1.indexOf("right") ? "start" : "middle", c = i ? i / .8 + 1 : 0, u = (f.lineCount(t1) - 1) * d + 1, p = I[l] * c, m = .75 * r + I[s] * c + (I[s] - 1) * u * r / 2;
                    t1.attr("text-anchor", l), a || o.attr("transform", h(p, m));
                }
                function z(t1, e1) {
                    var r = t1.ts || e1.textfont.size;
                    return o(r) && r > 0 ? r : 0;
                }
                function O(t1, e1, r) {
                    return r && (t1 = j(t1)), e1 ? R(t1[1]) : D(t1[0]);
                }
                function D(t1) {
                    var e1 = n.round(t1, 2);
                    return C = e1, e1;
                }
                function R(t1) {
                    var e1 = n.round(t1, 2);
                    return L = e1, e1;
                }
                function F(t1, e1, r, n) {
                    var i = t1[0] - e1[0], a = t1[1] - e1[1], o = r[0] - e1[0], s = r[1] - e1[1], l = Math.pow(i * i + a * a, .25), c = Math.pow(o * o + s * s, .25), u = (c * c * i - l * l * o) * n, h = (c * c * a - l * l * s) * n, f = 3 * c * (l + c), p = 3 * l * (l + c);
                    return [
                        [
                            D(e1[0] + (f && u / f)),
                            R(e1[1] + (f && h / f))
                        ],
                        [
                            D(e1[0] - (p && u / p)),
                            R(e1[1] - (p && h / p))
                        ]
                    ];
                }
                x.textPointStyle = function(t1, e1, r) {
                    if (t1.size()) {
                        var a;
                        if (e1.selectedpoints) {
                            var o = x.makeSelectedTextStyleFns(e1);
                            a = o.selectedTextColorFn;
                        }
                        var s = e1.texttemplate, l = r._fullLayout;
                        t1.each(function(t1) {
                            var o = n.select(this), c = s ? i.extractOption(t1, e1, "txt", "texttemplate") : i.extractOption(t1, e1, "tx", "text");
                            if (c || 0 === c) {
                                if (s) {
                                    var u = e1._module.formatLabels, h = u ? u(t1, e1, l) : {}, p = {};
                                    v(p, e1, t1.i);
                                    var d = e1._meta || {};
                                    c = i.texttemplateString(c, h, l._d3locale, p, t1, d);
                                }
                                var m = t1.tp || e1.textposition, g = z(t1, e1), y = a ? a(t1) : t1.tc || e1.textfont.color;
                                o.call(x.font, {
                                    family: t1.tf || e1.textfont.family,
                                    weight: t1.tw || e1.textfont.weight,
                                    style: t1.ty || e1.textfont.style,
                                    variant: t1.tv || e1.textfont.variant,
                                    textcase: t1.tC || e1.textfont.textcase,
                                    lineposition: t1.tE || e1.textfont.lineposition,
                                    shadow: t1.tS || e1.textfont.shadow,
                                    size: g,
                                    color: y
                                }).text(c).call(f.convertToTspans, r).call(P, m, g, t1.mrc);
                            } else o.remove();
                        });
                    }
                }, x.selectedTextStyle = function(t1, e1) {
                    if (t1.size() && e1.selectedpoints) {
                        var r = x.makeSelectedTextStyleFns(e1);
                        t1.each(function(t1) {
                            var i = n.select(this), a = r.selectedTextColorFn(t1), o = t1.tp || e1.textposition, s = z(t1, e1);
                            c.fill(i, a);
                            var u = l.traceIs(e1, "bar-like");
                            P(i, o, s, t1.mrc2 || t1.mrc, u);
                        });
                    }
                }, x.smoothopen = function(t1, e1) {
                    if (t1.length < 3) return "M" + t1.join("L");
                    var r, n = "M" + t1[0], i = [];
                    for(r = 1; r < t1.length - 1; r++)i.push(F(t1[r - 1], t1[r], t1[r + 1], e1));
                    for(n += "Q" + i[0][0] + " " + t1[1], r = 2; r < t1.length - 1; r++)n += "C" + i[r - 2][1] + " " + i[r - 1][0] + " " + t1[r];
                    return n + "Q" + i[t1.length - 3][1] + " " + t1[t1.length - 1];
                }, x.smoothclosed = function(t1, e1) {
                    if (t1.length < 3) return "M" + t1.join("L") + "Z";
                    var r, n = "M" + t1[0], i = t1.length - 1, a = [
                        F(t1[i], t1[0], t1[1], e1)
                    ];
                    for(r = 1; r < i; r++)a.push(F(t1[r - 1], t1[r], t1[r + 1], e1));
                    for(a.push(F(t1[i - 1], t1[i], t1[0], e1)), r = 1; r <= i; r++)n += "C" + a[r - 1][1] + " " + a[r][0] + " " + t1[r];
                    return n + "C" + a[i][1] + " " + a[0][0] + " " + t1[0] + "Z";
                };
                var B = {
                    hv: function(t1, e1, r) {
                        return "H" + D(e1[0]) + "V" + O(e1, 1, r);
                    },
                    vh: function(t1, e1, r) {
                        return "V" + R(e1[1]) + "H" + O(e1, 0, r);
                    },
                    hvh: function(t1, e1, r) {
                        return "H" + D((t1[0] + e1[0]) / 2) + "V" + R(e1[1]) + "H" + O(e1, 0, r);
                    },
                    vhv: function(t1, e1, r) {
                        return "V" + R((t1[1] + e1[1]) / 2) + "H" + D(e1[0]) + "V" + O(e1, 1, r);
                    }
                }, N = function(t1, e1, r) {
                    return "L" + O(e1, 0, r) + "," + O(e1, 1, r);
                };
                function j(t1, e1) {
                    var r = t1.backoff, n = t1.trace, a = t1.d, o = t1.i;
                    if (r && n && n.marker && n.marker.angle % 360 == 0 && n.line && "spline" !== n.line.shape) {
                        var s = i.isArrayOrTypedArray(r), l = t1, c = e1 ? e1[0] : C || 0, u = e1 ? e1[1] : L || 0, h = l[0], f = l[1], p = h - c, d = f - u, m = Math.atan2(d, p), g = s ? r[o] : r;
                        if ("auto" === g) {
                            var y = l.i;
                            "scatter" === n.type && y--;
                            var v = l.marker, _ = v.symbol;
                            i.isArrayOrTypedArray(_) && (_ = _[y]);
                            var b = v.size;
                            i.isArrayOrTypedArray(b) && (b = b[y]), g = v ? x.symbolBackOffs[x.symbolNumber(_)] * b : 0, g += x.getMarkerStandoff(a[y], n) || 0;
                        }
                        var w = h - g * Math.cos(m), T = f - g * Math.sin(m);
                        (w <= h && w >= c || w >= h && w <= c) && (T <= f && T >= u || T >= f && T <= u) && (t1 = [
                            w,
                            T
                        ]);
                    }
                    return t1;
                }
                x.steps = function(t1) {
                    var e1 = B[t1] || N;
                    return function(t1) {
                        for(var r = "M" + D(t1[0][0]) + "," + R(t1[0][1]), n = t1.length, i = 1; i < n; i++)r += e1(t1[i - 1], t1[i], i === n - 1);
                        return r;
                    };
                }, x.applyBackoff = j, x.makeTester = function() {
                    var t1 = i.ensureSingleById(n.select("body"), "svg", "js-plotly-tester", function(t1) {
                        t1.attr(p.svgAttrs).style({
                            position: "absolute",
                            left: "-10000px",
                            top: "-10000px",
                            width: "9000px",
                            height: "9000px",
                            "z-index": "1"
                        });
                    }), e1 = i.ensureSingle(t1, "path", "js-reference-point", function(t1) {
                        t1.attr("d", "M0,0H1V1H0Z").style({
                            "stroke-width": 0,
                            fill: "black"
                        });
                    });
                    x.tester = t1, x.testref = e1;
                }, x.savedBBoxes = {};
                var U = 0;
                function V(t1) {
                    var e1 = t1.getAttribute("data-unformatted");
                    if (null !== e1) return e1 + t1.getAttribute("data-math") + t1.getAttribute("text-anchor") + t1.getAttribute("style");
                }
                function q(t1, e1) {
                    if (!t1) return null;
                    var r = e1._context, n = r._exportedPlot ? "" : r._baseUrl || "";
                    return n ? "url('" + n + "#" + t1 + "')" : "url(#" + t1 + ")";
                }
                x.bBox = function(t1, e1, r) {
                    var a, o, s;
                    if (r || (r = V(t1)), r) {
                        if (a = x.savedBBoxes[r]) return i.extendFlat({}, a);
                    } else if (1 === t1.childNodes.length) {
                        var l = t1.childNodes[0];
                        if (r = V(l)) {
                            var c = +l.getAttribute("x") || 0, u = +l.getAttribute("y") || 0, h = l.getAttribute("transform");
                            if (!h) {
                                var p = x.bBox(l, !1, r);
                                return c && (p.left += c, p.right += c), u && (p.top += u, p.bottom += u), p;
                            }
                            if (r += "~" + c + "~" + u + "~" + h, a = x.savedBBoxes[r]) return i.extendFlat({}, a);
                        }
                    }
                    e1 ? o = t1 : (s = x.tester.node(), o = t1.cloneNode(!0), s.appendChild(o)), n.select(o).attr("transform", null).call(f.positionText, 0, 0);
                    var d = o.getBoundingClientRect(), m = x.testref.node().getBoundingClientRect();
                    e1 || s.removeChild(o);
                    var g = {
                        height: d.height,
                        width: d.width,
                        left: d.left - m.left,
                        top: d.top - m.top,
                        right: d.right - m.left,
                        bottom: d.bottom - m.top
                    };
                    return U >= 1e4 && (x.savedBBoxes = {}, U = 0), r && (x.savedBBoxes[r] = g), U++, i.extendFlat({}, g);
                }, x.setClipUrl = function(t1, e1, r) {
                    t1.attr("clip-path", q(e1, r));
                }, x.getTranslate = function(t1) {
                    var e1 = (t1[t1.attr ? "attr" : "getAttribute"]("transform") || "").replace(/.*\btranslate\((-?\d*\.?\d*)[^-\d]*(-?\d*\.?\d*)[^\d].*/, function(t1, e1, r) {
                        return [
                            e1,
                            r
                        ].join(" ");
                    }).split(" ");
                    return {
                        x: +e1[0] || 0,
                        y: +e1[1] || 0
                    };
                }, x.setTranslate = function(t1, e1, r) {
                    var n = t1.attr ? "attr" : "getAttribute", i = t1.attr ? "attr" : "setAttribute", a = t1[n]("transform") || "";
                    return e1 = e1 || 0, r = r || 0, a = a.replace(/(\btranslate\(.*?\);?)/, "").trim(), a = (a += h(e1, r)).trim(), t1[i]("transform", a), a;
                }, x.getScale = function(t1) {
                    var e1 = (t1[t1.attr ? "attr" : "getAttribute"]("transform") || "").replace(/.*\bscale\((\d*\.?\d*)[^\d]*(\d*\.?\d*)[^\d].*/, function(t1, e1, r) {
                        return [
                            e1,
                            r
                        ].join(" ");
                    }).split(" ");
                    return {
                        x: +e1[0] || 1,
                        y: +e1[1] || 1
                    };
                }, x.setScale = function(t1, e1, r) {
                    var n = t1.attr ? "attr" : "getAttribute", i = t1.attr ? "attr" : "setAttribute", a = t1[n]("transform") || "";
                    return e1 = e1 || 1, r = r || 1, a = a.replace(/(\bscale\(.*?\);?)/, "").trim(), a = (a += "scale(" + e1 + "," + r + ")").trim(), t1[i]("transform", a), a;
                };
                var H = /\s*sc.*/;
                x.setPointGroupScale = function(t1, e1, r) {
                    if (e1 = e1 || 1, r = r || 1, t1) {
                        var n = 1 === e1 && 1 === r ? "" : "scale(" + e1 + "," + r + ")";
                        t1.each(function() {
                            var t1 = (this.getAttribute("transform") || "").replace(H, "");
                            t1 = (t1 += n).trim(), this.setAttribute("transform", t1);
                        });
                    }
                };
                var G = /translate\([^)]*\)\s*$/;
                function Z(t1, e1) {
                    var r;
                    return t1 && (r = t1.mf), void 0 === r && (r = e1.marker && e1.marker.standoff || 0), e1._geo || e1._xA ? r : -r;
                }
                x.setTextPointsScale = function(t1, e1, r) {
                    t1 && t1.each(function() {
                        var t1, i = n.select(this), a = i.select("text");
                        if (a.node()) {
                            var o = parseFloat(a.attr("x") || 0), s = parseFloat(a.attr("y") || 0), l = (i.attr("transform") || "").match(G);
                            t1 = 1 === e1 && 1 === r ? [] : [
                                h(o, s),
                                "scale(" + e1 + "," + r + ")",
                                h(-o, -s)
                            ], l && t1.push(l), i.attr("transform", t1.join(""));
                        }
                    });
                }, x.getMarkerStandoff = Z;
                var W, Y, X, $, J, K, Q = Math.atan2, tt = Math.cos, et = Math.sin;
                function rt(t1, e1) {
                    var r = e1[0], n = e1[1];
                    return [
                        r * tt(t1) - n * et(t1),
                        r * et(t1) + n * tt(t1)
                    ];
                }
                function nt(t1, e1) {
                    var r, n, a = t1.ma;
                    void 0 === a && ((a = e1.marker.angle) && !i.isArrayOrTypedArray(a) || (a = 0));
                    var s = e1.marker.angleref;
                    if ("previous" === s || "north" === s) {
                        if (e1._geo) {
                            var l = e1._geo.project(t1.lonlat);
                            r = l[0], n = l[1];
                        } else {
                            var c = e1._xA, u = e1._yA;
                            if (!c || !u) return 90;
                            r = c.c2p(t1.x), n = u.c2p(t1.y);
                        }
                        if (e1._geo) {
                            var h, f = t1.lonlat[0], p = t1.lonlat[1], d = e1._geo.project([
                                f,
                                p + 1e-5
                            ]), m = e1._geo.project([
                                f + 1e-5,
                                p
                            ]), g = Q(m[1] - n, m[0] - r), y = Q(d[1] - n, d[0] - r);
                            if ("north" === s) h = a / 180 * Math.PI;
                            else if ("previous" === s) {
                                var v = f / 180 * Math.PI, x = p / 180 * Math.PI, _ = W / 180 * Math.PI, b = Y / 180 * Math.PI, w = _ - v, T = tt(b) * et(w), k = et(b) * tt(x) - tt(b) * et(x) * tt(w);
                                h = -Q(T, k) - Math.PI, W = f, Y = p;
                            }
                            var A = rt(g, [
                                tt(h),
                                0
                            ]), M = rt(y, [
                                et(h),
                                0
                            ]);
                            a = Q(A[1] + M[1], A[0] + M[0]) / Math.PI * 180, "previous" !== s || K === e1.uid && t1.i === J + 1 || (a = null);
                        }
                        if ("previous" === s && !e1._geo) {
                            if (K === e1.uid && t1.i === J + 1 && o(r) && o(n)) {
                                var S = r - X, E = n - $, C = e1.line && e1.line.shape || "", L = C.slice(C.length - 1);
                                "h" === L && (E = 0), "v" === L && (S = 0), a += Q(E, S) / Math.PI * 180 + 90;
                            } else a = null;
                        }
                    }
                    return X = r, $ = n, J = t1.i, K = e1.uid, a;
                }
                x.getMarkerAngle = nt;
            },
            38882: function(t1, e1, r) {
                "use strict";
                var n, i, a, o, s = r(26953), l = r(45568).round, c = "M0,0Z", u = Math.sqrt(2), h = Math.sqrt(3), f = Math.PI, p = Math.cos, d = Math.sin;
                function m(t1) {
                    return null === t1;
                }
                function g(t1, e1, r) {
                    if (!(t1 && t1 % 360 != 0 || e1)) return r;
                    if (a === t1 && o === e1 && n === r) return i;
                    function l(t1, r) {
                        var n = p(t1), i = d(t1), a = r[0], o = r[1] + (e1 || 0);
                        return [
                            a * n - o * i,
                            a * i + o * n
                        ];
                    }
                    a = t1, o = e1, n = r;
                    for(var c = t1 / 180 * f, u = 0, h = 0, m = s(r), g = "", y = 0; y < m.length; y++){
                        var v = m[y], x = v[0], _ = u, b = h;
                        if ("M" === x || "L" === x) u = +v[1], h = +v[2];
                        else if ("m" === x || "l" === x) u += +v[1], h += +v[2];
                        else if ("H" === x) u = +v[1];
                        else if ("h" === x) u += +v[1];
                        else if ("V" === x) h = +v[1];
                        else if ("v" === x) h += +v[1];
                        else if ("A" === x) {
                            u = +v[1], h = +v[2];
                            var w = l(c, [
                                +v[6],
                                +v[7]
                            ]);
                            v[6] = w[0], v[7] = w[1], v[3] = +v[3] + t1;
                        }
                        "H" !== x && "V" !== x || (x = "L"), "h" !== x && "v" !== x || (x = "l"), "m" !== x && "l" !== x || (u -= _, h -= b);
                        var T = l(c, [
                            u,
                            h
                        ]);
                        "H" !== x && "V" !== x || (x = "L"), "M" !== x && "L" !== x && "m" !== x && "l" !== x || (v[1] = T[0], v[2] = T[1]), v[0] = x, g += v[0] + v.slice(1).join(",");
                    }
                    return i = g, g;
                }
                t1.exports = {
                    circle: {
                        n: 0,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(t1, 2), i = "M" + n + ",0A" + n + "," + n + " 0 1,1 0,-" + n + "A" + n + "," + n + " 0 0,1 " + n + ",0Z";
                            return r ? g(e1, r, i) : i;
                        }
                    },
                    square: {
                        n: 1,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(t1, 2);
                            return g(e1, r, "M" + n + "," + n + "H-" + n + "V-" + n + "H" + n + "Z");
                        }
                    },
                    diamond: {
                        n: 2,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(1.3 * t1, 2);
                            return g(e1, r, "M" + n + ",0L0," + n + "L-" + n + ",0L0,-" + n + "Z");
                        }
                    },
                    cross: {
                        n: 3,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(.4 * t1, 2), i = l(1.2 * t1, 2);
                            return g(e1, r, "M" + i + "," + n + "H" + n + "V" + i + "H-" + n + "V" + n + "H-" + i + "V-" + n + "H-" + n + "V-" + i + "H" + n + "V-" + n + "H" + i + "Z");
                        }
                    },
                    x: {
                        n: 4,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(.8 * t1 / u, 2), i = "l" + n + "," + n, a = "l" + n + ",-" + n, o = "l-" + n + ",-" + n, s = "l-" + n + "," + n;
                            return g(e1, r, "M0," + n + i + a + o + a + o + s + o + s + i + s + i + "Z");
                        }
                    },
                    "triangle-up": {
                        n: 5,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(2 * t1 / h, 2);
                            return g(e1, r, "M-" + n + "," + l(t1 / 2, 2) + "H" + n + "L0,-" + l(t1, 2) + "Z");
                        }
                    },
                    "triangle-down": {
                        n: 6,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(2 * t1 / h, 2);
                            return g(e1, r, "M-" + n + ",-" + l(t1 / 2, 2) + "H" + n + "L0," + l(t1, 2) + "Z");
                        }
                    },
                    "triangle-left": {
                        n: 7,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(2 * t1 / h, 2);
                            return g(e1, r, "M" + l(t1 / 2, 2) + ",-" + n + "V" + n + "L-" + l(t1, 2) + ",0Z");
                        }
                    },
                    "triangle-right": {
                        n: 8,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(2 * t1 / h, 2);
                            return g(e1, r, "M-" + l(t1 / 2, 2) + ",-" + n + "V" + n + "L" + l(t1, 2) + ",0Z");
                        }
                    },
                    "triangle-ne": {
                        n: 9,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(.6 * t1, 2), i = l(1.2 * t1, 2);
                            return g(e1, r, "M-" + i + ",-" + n + "H" + n + "V" + i + "Z");
                        }
                    },
                    "triangle-se": {
                        n: 10,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(.6 * t1, 2), i = l(1.2 * t1, 2);
                            return g(e1, r, "M" + n + ",-" + i + "V" + n + "H-" + i + "Z");
                        }
                    },
                    "triangle-sw": {
                        n: 11,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(.6 * t1, 2), i = l(1.2 * t1, 2);
                            return g(e1, r, "M" + i + "," + n + "H-" + n + "V-" + i + "Z");
                        }
                    },
                    "triangle-nw": {
                        n: 12,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(.6 * t1, 2), i = l(1.2 * t1, 2);
                            return g(e1, r, "M-" + n + "," + i + "V-" + n + "H" + i + "Z");
                        }
                    },
                    pentagon: {
                        n: 13,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(.951 * t1, 2), i = l(.588 * t1, 2), a = l(-t1, 2), o = l(-0.309 * t1, 2);
                            return g(e1, r, "M" + n + "," + o + "L" + i + "," + l(.809 * t1, 2) + "H-" + i + "L-" + n + "," + o + "L0," + a + "Z");
                        }
                    },
                    hexagon: {
                        n: 14,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(t1, 2), i = l(t1 / 2, 2), a = l(t1 * h / 2, 2);
                            return g(e1, r, "M" + a + ",-" + i + "V" + i + "L0," + n + "L-" + a + "," + i + "V-" + i + "L0,-" + n + "Z");
                        }
                    },
                    hexagon2: {
                        n: 15,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(t1, 2), i = l(t1 / 2, 2), a = l(t1 * h / 2, 2);
                            return g(e1, r, "M-" + i + "," + a + "H" + i + "L" + n + ",0L" + i + ",-" + a + "H-" + i + "L-" + n + ",0Z");
                        }
                    },
                    octagon: {
                        n: 16,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(.924 * t1, 2), i = l(.383 * t1, 2);
                            return g(e1, r, "M-" + i + ",-" + n + "H" + i + "L" + n + ",-" + i + "V" + i + "L" + i + "," + n + "H-" + i + "L-" + n + "," + i + "V-" + i + "Z");
                        }
                    },
                    star: {
                        n: 17,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = 1.4 * t1, i = l(.225 * n, 2), a = l(.951 * n, 2), o = l(.363 * n, 2), s = l(.588 * n, 2), u = l(-n, 2), h = l(-0.309 * n, 2), f = l(.118 * n, 2), p = l(.809 * n, 2);
                            return g(e1, r, "M" + i + "," + h + "H" + a + "L" + o + "," + f + "L" + s + "," + p + "L0," + l(.382 * n, 2) + "L-" + s + "," + p + "L-" + o + "," + f + "L-" + a + "," + h + "H-" + i + "L0," + u + "Z");
                        }
                    },
                    hexagram: {
                        n: 18,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(.66 * t1, 2), i = l(.38 * t1, 2), a = l(.76 * t1, 2);
                            return g(e1, r, "M-" + a + ",0l-" + i + ",-" + n + "h" + a + "l" + i + ",-" + n + "l" + i + "," + n + "h" + a + "l-" + i + "," + n + "l" + i + "," + n + "h-" + a + "l-" + i + "," + n + "l-" + i + ",-" + n + "h-" + a + "Z");
                        }
                    },
                    "star-triangle-up": {
                        n: 19,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(t1 * h * .8, 2), i = l(.8 * t1, 2), a = l(1.6 * t1, 2), o = l(4 * t1, 2), s = "A " + o + "," + o + " 0 0 1 ";
                            return g(e1, r, "M-" + n + "," + i + s + n + "," + i + s + "0,-" + a + s + "-" + n + "," + i + "Z");
                        }
                    },
                    "star-triangle-down": {
                        n: 20,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(t1 * h * .8, 2), i = l(.8 * t1, 2), a = l(1.6 * t1, 2), o = l(4 * t1, 2), s = "A " + o + "," + o + " 0 0 1 ";
                            return g(e1, r, "M" + n + ",-" + i + s + "-" + n + ",-" + i + s + "0," + a + s + n + ",-" + i + "Z");
                        }
                    },
                    "star-square": {
                        n: 21,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(1.1 * t1, 2), i = l(2 * t1, 2), a = "A " + i + "," + i + " 0 0 1 ";
                            return g(e1, r, "M-" + n + ",-" + n + a + "-" + n + "," + n + a + n + "," + n + a + n + ",-" + n + a + "-" + n + ",-" + n + "Z");
                        }
                    },
                    "star-diamond": {
                        n: 22,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(1.4 * t1, 2), i = l(1.9 * t1, 2), a = "A " + i + "," + i + " 0 0 1 ";
                            return g(e1, r, "M-" + n + ",0" + a + "0," + n + a + n + ",0" + a + "0,-" + n + a + "-" + n + ",0Z");
                        }
                    },
                    "diamond-tall": {
                        n: 23,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(.7 * t1, 2), i = l(1.4 * t1, 2);
                            return g(e1, r, "M0," + i + "L" + n + ",0L0,-" + i + "L-" + n + ",0Z");
                        }
                    },
                    "diamond-wide": {
                        n: 24,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(1.4 * t1, 2), i = l(.7 * t1, 2);
                            return g(e1, r, "M0," + i + "L" + n + ",0L0,-" + i + "L-" + n + ",0Z");
                        }
                    },
                    hourglass: {
                        n: 25,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(t1, 2);
                            return g(e1, r, "M" + n + "," + n + "H-" + n + "L" + n + ",-" + n + "H-" + n + "Z");
                        },
                        noDot: !0
                    },
                    bowtie: {
                        n: 26,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(t1, 2);
                            return g(e1, r, "M" + n + "," + n + "V-" + n + "L-" + n + "," + n + "V-" + n + "Z");
                        },
                        noDot: !0
                    },
                    "circle-cross": {
                        n: 27,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(t1, 2);
                            return g(e1, r, "M0," + n + "V-" + n + "M" + n + ",0H-" + n + "M" + n + ",0A" + n + "," + n + " 0 1,1 0,-" + n + "A" + n + "," + n + " 0 0,1 " + n + ",0Z");
                        },
                        needLine: !0,
                        noDot: !0
                    },
                    "circle-x": {
                        n: 28,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(t1, 2), i = l(t1 / u, 2);
                            return g(e1, r, "M" + i + "," + i + "L-" + i + ",-" + i + "M" + i + ",-" + i + "L-" + i + "," + i + "M" + n + ",0A" + n + "," + n + " 0 1,1 0,-" + n + "A" + n + "," + n + " 0 0,1 " + n + ",0Z");
                        },
                        needLine: !0,
                        noDot: !0
                    },
                    "square-cross": {
                        n: 29,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(t1, 2);
                            return g(e1, r, "M0," + n + "V-" + n + "M" + n + ",0H-" + n + "M" + n + "," + n + "H-" + n + "V-" + n + "H" + n + "Z");
                        },
                        needLine: !0,
                        noDot: !0
                    },
                    "square-x": {
                        n: 30,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(t1, 2);
                            return g(e1, r, "M" + n + "," + n + "L-" + n + ",-" + n + "M" + n + ",-" + n + "L-" + n + "," + n + "M" + n + "," + n + "H-" + n + "V-" + n + "H" + n + "Z");
                        },
                        needLine: !0,
                        noDot: !0
                    },
                    "diamond-cross": {
                        n: 31,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(1.3 * t1, 2);
                            return g(e1, r, "M" + n + ",0L0," + n + "L-" + n + ",0L0,-" + n + "ZM0,-" + n + "V" + n + "M-" + n + ",0H" + n);
                        },
                        needLine: !0,
                        noDot: !0
                    },
                    "diamond-x": {
                        n: 32,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(1.3 * t1, 2), i = l(.65 * t1, 2);
                            return g(e1, r, "M" + n + ",0L0," + n + "L-" + n + ",0L0,-" + n + "ZM-" + i + ",-" + i + "L" + i + "," + i + "M-" + i + "," + i + "L" + i + ",-" + i);
                        },
                        needLine: !0,
                        noDot: !0
                    },
                    "cross-thin": {
                        n: 33,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(1.4 * t1, 2);
                            return g(e1, r, "M0," + n + "V-" + n + "M" + n + ",0H-" + n);
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    "x-thin": {
                        n: 34,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(t1, 2);
                            return g(e1, r, "M" + n + "," + n + "L-" + n + ",-" + n + "M" + n + ",-" + n + "L-" + n + "," + n);
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    asterisk: {
                        n: 35,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(1.2 * t1, 2), i = l(.85 * t1, 2);
                            return g(e1, r, "M0," + n + "V-" + n + "M" + n + ",0H-" + n + "M" + i + "," + i + "L-" + i + ",-" + i + "M" + i + ",-" + i + "L-" + i + "," + i);
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    hash: {
                        n: 36,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(t1 / 2, 2), i = l(t1, 2);
                            return g(e1, r, "M" + n + "," + i + "V-" + i + "M" + (n - i) + ",-" + i + "V" + i + "M" + i + "," + n + "H-" + i + "M-" + i + "," + (n - i) + "H" + i);
                        },
                        needLine: !0,
                        noFill: !0
                    },
                    "y-up": {
                        n: 37,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(1.2 * t1, 2), i = l(1.6 * t1, 2), a = l(.8 * t1, 2);
                            return g(e1, r, "M-" + n + "," + a + "L0,0M" + n + "," + a + "L0,0M0,-" + i + "L0,0");
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    "y-down": {
                        n: 38,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(1.2 * t1, 2), i = l(1.6 * t1, 2), a = l(.8 * t1, 2);
                            return g(e1, r, "M-" + n + ",-" + a + "L0,0M" + n + ",-" + a + "L0,0M0," + i + "L0,0");
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    "y-left": {
                        n: 39,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(1.2 * t1, 2), i = l(1.6 * t1, 2), a = l(.8 * t1, 2);
                            return g(e1, r, "M" + a + "," + n + "L0,0M" + a + ",-" + n + "L0,0M-" + i + ",0L0,0");
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    "y-right": {
                        n: 40,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(1.2 * t1, 2), i = l(1.6 * t1, 2), a = l(.8 * t1, 2);
                            return g(e1, r, "M-" + a + "," + n + "L0,0M-" + a + ",-" + n + "L0,0M" + i + ",0L0,0");
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    "line-ew": {
                        n: 41,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(1.4 * t1, 2);
                            return g(e1, r, "M" + n + ",0H-" + n);
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    "line-ns": {
                        n: 42,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(1.4 * t1, 2);
                            return g(e1, r, "M0," + n + "V-" + n);
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    "line-ne": {
                        n: 43,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(t1, 2);
                            return g(e1, r, "M" + n + ",-" + n + "L-" + n + "," + n);
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    "line-nw": {
                        n: 44,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(t1, 2);
                            return g(e1, r, "M" + n + "," + n + "L-" + n + ",-" + n);
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    "arrow-up": {
                        n: 45,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(t1, 2);
                            return g(e1, r, "M0,0L-" + n + "," + l(2 * t1, 2) + "H" + n + "Z");
                        },
                        backoff: 1,
                        noDot: !0
                    },
                    "arrow-down": {
                        n: 46,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(t1, 2);
                            return g(e1, r, "M0,0L-" + n + ",-" + l(2 * t1, 2) + "H" + n + "Z");
                        },
                        noDot: !0
                    },
                    "arrow-left": {
                        n: 47,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(2 * t1, 2), i = l(t1, 2);
                            return g(e1, r, "M0,0L" + n + ",-" + i + "V" + i + "Z");
                        },
                        noDot: !0
                    },
                    "arrow-right": {
                        n: 48,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(2 * t1, 2), i = l(t1, 2);
                            return g(e1, r, "M0,0L-" + n + ",-" + i + "V" + i + "Z");
                        },
                        noDot: !0
                    },
                    "arrow-bar-up": {
                        n: 49,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(t1, 2);
                            return g(e1, r, "M-" + n + ",0H" + n + "M0,0L-" + n + "," + l(2 * t1, 2) + "H" + n + "Z");
                        },
                        backoff: 1,
                        needLine: !0,
                        noDot: !0
                    },
                    "arrow-bar-down": {
                        n: 50,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(t1, 2);
                            return g(e1, r, "M-" + n + ",0H" + n + "M0,0L-" + n + ",-" + l(2 * t1, 2) + "H" + n + "Z");
                        },
                        needLine: !0,
                        noDot: !0
                    },
                    "arrow-bar-left": {
                        n: 51,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(2 * t1, 2), i = l(t1, 2);
                            return g(e1, r, "M0,-" + i + "V" + i + "M0,0L" + n + ",-" + i + "V" + i + "Z");
                        },
                        needLine: !0,
                        noDot: !0
                    },
                    "arrow-bar-right": {
                        n: 52,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = l(2 * t1, 2), i = l(t1, 2);
                            return g(e1, r, "M0,-" + i + "V" + i + "M0,0L-" + n + ",-" + i + "V" + i + "Z");
                        },
                        needLine: !0,
                        noDot: !0
                    },
                    arrow: {
                        n: 53,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = f / 2.5, i = 2 * t1 * p(n), a = 2 * t1 * d(n);
                            return g(e1, r, "M0,0L" + -i + "," + a + "L" + i + "," + a + "Z");
                        },
                        backoff: .9,
                        noDot: !0
                    },
                    "arrow-wide": {
                        n: 54,
                        f: function(t1, e1, r) {
                            if (m(e1)) return c;
                            var n = f / 4, i = 2 * t1 * p(n), a = 2 * t1 * d(n);
                            return g(e1, r, "M0,0L" + -i + "," + a + "A " + 2 * t1 + "," + 2 * t1 + " 0 0 1 " + i + "," + a + "Z");
                        },
                        backoff: .4,
                        noDot: !0
                    }
                };
            },
            75568: function(t1) {
                "use strict";
                t1.exports = {
                    visible: {
                        valType: "boolean",
                        editType: "calc"
                    },
                    type: {
                        valType: "enumerated",
                        values: [
                            "percent",
                            "constant",
                            "sqrt",
                            "data"
                        ],
                        editType: "calc"
                    },
                    symmetric: {
                        valType: "boolean",
                        editType: "calc"
                    },
                    array: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    arrayminus: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    value: {
                        valType: "number",
                        min: 0,
                        dflt: 10,
                        editType: "calc"
                    },
                    valueminus: {
                        valType: "number",
                        min: 0,
                        dflt: 10,
                        editType: "calc"
                    },
                    traceref: {
                        valType: "integer",
                        min: 0,
                        dflt: 0,
                        editType: "style"
                    },
                    tracerefminus: {
                        valType: "integer",
                        min: 0,
                        dflt: 0,
                        editType: "style"
                    },
                    copy_ystyle: {
                        valType: "boolean",
                        editType: "plot"
                    },
                    copy_zstyle: {
                        valType: "boolean",
                        editType: "style"
                    },
                    color: {
                        valType: "color",
                        editType: "style"
                    },
                    thickness: {
                        valType: "number",
                        min: 0,
                        dflt: 2,
                        editType: "style"
                    },
                    width: {
                        valType: "number",
                        min: 0,
                        editType: "plot"
                    },
                    editType: "calc",
                    _deprecated: {
                        opacity: {
                            valType: "number",
                            editType: "style"
                        }
                    }
                };
            },
            352: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(33626), a = r(29714), o = r(34809), s = r(25589);
                function l(t1, e1, r, i) {
                    var l = e1["error_" + i] || {}, c = [];
                    if (l.visible && -1 !== [
                        "linear",
                        "log"
                    ].indexOf(r.type)) {
                        for(var u = s(l), h = 0; h < t1.length; h++){
                            var f = t1[h], p = f.i;
                            if (void 0 === p) p = h;
                            else if (null === p) continue;
                            var d = f[i];
                            if (n(r.c2l(d))) {
                                var m = u(d, p);
                                if (n(m[0]) && n(m[1])) {
                                    var g = f[i + "s"] = d - m[0], y = f[i + "h"] = d + m[1];
                                    c.push(g, y);
                                }
                            }
                        }
                        var v = r._id, x = e1._extremes[v], _ = a.findExtremes(r, c, o.extendFlat({
                            tozero: x.opts.tozero
                        }, {
                            padded: !0
                        }));
                        x.min = x.min.concat(_.min), x.max = x.max.concat(_.max);
                    }
                }
                t1.exports = function(t1) {
                    for(var e1 = t1.calcdata, r = 0; r < e1.length; r++){
                        var n = e1[r], o = n[0].trace;
                        if (!0 === o.visible && i.traceIs(o, "errorBarsOK")) {
                            var s = a.getFromId(t1, o.xaxis), c = a.getFromId(t1, o.yaxis);
                            l(n, o, s, "x"), l(n, o, c, "y");
                        }
                    }
                };
            },
            25589: function(t1) {
                "use strict";
                function e1(t1, e1) {
                    return "percent" === t1 ? function(t1) {
                        return Math.abs(t1 * e1 / 100);
                    } : "constant" === t1 ? function() {
                        return Math.abs(e1);
                    } : "sqrt" === t1 ? function(t1) {
                        return Math.sqrt(Math.abs(t1));
                    } : void 0;
                }
                t1.exports = function(t1) {
                    var r = t1.type, n = t1.symmetric;
                    if ("data" === r) {
                        var i = t1.array || [];
                        if (n) return function(t1, e1) {
                            var r = +i[e1];
                            return [
                                r,
                                r
                            ];
                        };
                        var a = t1.arrayminus || [];
                        return function(t1, e1) {
                            var r = +i[e1], n = +a[e1];
                            return isNaN(r) && isNaN(n) ? [
                                NaN,
                                NaN
                            ] : [
                                n || 0,
                                r || 0
                            ];
                        };
                    }
                    var o = e1(r, t1.value), s = e1(r, t1.valueminus);
                    return n || void 0 === t1.valueminus ? function(t1) {
                        var e1 = o(t1);
                        return [
                            e1,
                            e1
                        ];
                    } : function(t1) {
                        return [
                            s(t1),
                            o(t1)
                        ];
                    };
                };
            },
            5543: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(33626), a = r(34809), o = r(78032), s = r(75568);
                t1.exports = function(t1, e1, r, l) {
                    var c = "error_" + l.axis, u = o.newContainer(e1, c), h = t1[c] || {};
                    function f(t1, e1) {
                        return a.coerce(h, u, s, t1, e1);
                    }
                    if (!1 !== f("visible", void 0 !== h.array || void 0 !== h.value || "sqrt" === h.type)) {
                        var p = f("type", "array" in h ? "data" : "percent"), d = !0;
                        "sqrt" !== p && (d = f("symmetric", !(("data" === p ? "arrayminus" : "valueminus") in h))), "data" === p ? (f("array"), f("traceref"), d || (f("arrayminus"), f("tracerefminus"))) : "percent" !== p && "constant" !== p || (f("value"), d || f("valueminus"));
                        var m = "copy_" + l.inherit + "style";
                        l.inherit && (e1["error_" + l.inherit] || {}).visible && f(m, !(h.color || n(h.thickness) || n(h.width))), l.inherit && u[m] || (f("color", r), f("thickness"), f("width", i.traceIs(e1, "gl3d") ? 0 : 4));
                    }
                };
            },
            77901: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(13582).overrideAll, a = r(75568), o = {
                    error_x: n.extendFlat({}, a),
                    error_y: n.extendFlat({}, a)
                };
                delete o.error_x.copy_zstyle, delete o.error_y.copy_zstyle, delete o.error_y.copy_ystyle;
                var s = {
                    error_x: n.extendFlat({}, a),
                    error_y: n.extendFlat({}, a),
                    error_z: n.extendFlat({}, a)
                };
                delete s.error_x.copy_ystyle, delete s.error_y.copy_ystyle, delete s.error_z.copy_ystyle, delete s.error_z.copy_zstyle, t1.exports = {
                    moduleType: "component",
                    name: "errorbars",
                    schema: {
                        traces: {
                            scatter: o,
                            bar: o,
                            histogram: o,
                            scatter3d: i(s, "calc", "nested"),
                            scattergl: i(o, "calc", "nested")
                        }
                    },
                    supplyDefaults: r(5543),
                    calc: r(352),
                    makeComputeError: r(25589),
                    plot: r(42130),
                    style: r(22800),
                    hoverInfo: function(t1, e1, r) {
                        (e1.error_y || {}).visible && (r.yerr = t1.yh - t1.y, e1.error_y.symmetric || (r.yerrneg = t1.y - t1.ys)), (e1.error_x || {}).visible && (r.xerr = t1.xh - t1.x, e1.error_x.symmetric || (r.xerrneg = t1.x - t1.xs));
                    }
                };
            },
            42130: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(10721), a = r(62203), o = r(64726);
                t1.exports = function(t1, e1, r, s) {
                    var l = r.xaxis, c = r.yaxis, u = s && s.duration > 0, h = t1._context.staticPlot;
                    e1.each(function(e1) {
                        var f, p = e1[0].trace, d = p.error_x || {}, m = p.error_y || {};
                        p.ids && (f = function(t1) {
                            return t1.id;
                        });
                        var g = o.hasMarkers(p) && p.marker.maxdisplayed > 0;
                        m.visible || d.visible || (e1 = []);
                        var y = n.select(this).selectAll("g.errorbar").data(e1, f);
                        if (y.exit().remove(), e1.length) {
                            d.visible || y.selectAll("path.xerror").remove(), m.visible || y.selectAll("path.yerror").remove(), y.style("opacity", 1);
                            var v = y.enter().append("g").classed("errorbar", !0);
                            u && v.style("opacity", 0).transition().duration(s.duration).style("opacity", 1), a.setClipUrl(y, r.layerClipId, t1), y.each(function(t1) {
                                var e1 = n.select(this), r = function(t1, e1, r) {
                                    var n = {
                                        x: e1.c2p(t1.x),
                                        y: r.c2p(t1.y)
                                    };
                                    return void 0 !== t1.yh && (n.yh = r.c2p(t1.yh), n.ys = r.c2p(t1.ys), i(n.ys) || (n.noYS = !0, n.ys = r.c2p(t1.ys, !0))), void 0 !== t1.xh && (n.xh = e1.c2p(t1.xh), n.xs = e1.c2p(t1.xs), i(n.xs) || (n.noXS = !0, n.xs = e1.c2p(t1.xs, !0))), n;
                                }(t1, l, c);
                                if (!g || t1.vis) {
                                    var a, o = e1.select("path.yerror");
                                    if (m.visible && i(r.x) && i(r.yh) && i(r.ys)) {
                                        var f = m.width;
                                        a = "M" + (r.x - f) + "," + r.yh + "h" + 2 * f + "m-" + f + ",0V" + r.ys, r.noYS || (a += "m-" + f + ",0h" + 2 * f), o.size() ? u && (o = o.transition().duration(s.duration).ease(s.easing)) : o = e1.append("path").style("vector-effect", h ? "none" : "non-scaling-stroke").classed("yerror", !0), o.attr("d", a);
                                    } else o.remove();
                                    var p = e1.select("path.xerror");
                                    if (d.visible && i(r.y) && i(r.xh) && i(r.xs)) {
                                        var y = (d.copy_ystyle ? m : d).width;
                                        a = "M" + r.xh + "," + (r.y - y) + "v" + 2 * y + "m0,-" + y + "H" + r.xs, r.noXS || (a += "m0,-" + y + "v" + 2 * y), p.size() ? u && (p = p.transition().duration(s.duration).ease(s.easing)) : p = e1.append("path").style("vector-effect", h ? "none" : "non-scaling-stroke").classed("xerror", !0), p.attr("d", a);
                                    } else p.remove();
                                }
                            });
                        }
                    });
                };
            },
            22800: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(78766);
                t1.exports = function(t1) {
                    t1.each(function(t1) {
                        var e1 = t1[0].trace, r = e1.error_y || {}, a = e1.error_x || {}, o = n.select(this);
                        o.selectAll("path.yerror").style("stroke-width", r.thickness + "px").call(i.stroke, r.color), a.copy_ystyle && (a = r), o.selectAll("path.xerror").style("stroke-width", a.thickness + "px").call(i.stroke, a.color);
                    });
                };
            },
            70192: function(t1, e1, r) {
                "use strict";
                var n = r(80337), i = r(6811).hoverlabel, a = r(93049).extendFlat;
                t1.exports = {
                    hoverlabel: {
                        bgcolor: a({}, i.bgcolor, {
                            arrayOk: !0
                        }),
                        bordercolor: a({}, i.bordercolor, {
                            arrayOk: !0
                        }),
                        font: n({
                            arrayOk: !0,
                            editType: "none"
                        }),
                        align: a({}, i.align, {
                            arrayOk: !0
                        }),
                        namelength: a({}, i.namelength, {
                            arrayOk: !0
                        }),
                        editType: "none"
                    }
                };
            },
            83552: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(33626);
                function a(t1, e1, r, i) {
                    i = i || n.identity, Array.isArray(t1) && (e1[0][r] = i(t1));
                }
                t1.exports = function(t1) {
                    var e1 = t1.calcdata, r = t1._fullLayout;
                    function o(t1) {
                        return function(e1) {
                            return n.coerceHoverinfo({
                                hoverinfo: e1
                            }, {
                                _module: t1._module
                            }, r);
                        };
                    }
                    for(var s = 0; s < e1.length; s++){
                        var l = e1[s], c = l[0].trace;
                        if (!i.traceIs(c, "pie-like")) {
                            var u = i.traceIs(c, "2dMap") ? a : n.fillArray;
                            u(c.hoverinfo, l, "hi", o(c)), c.hovertemplate && u(c.hovertemplate, l, "ht"), c.hoverlabel && (u(c.hoverlabel.bgcolor, l, "hbg"), u(c.hoverlabel.bordercolor, l, "hbc"), u(c.hoverlabel.font.size, l, "hts"), u(c.hoverlabel.font.color, l, "htc"), u(c.hoverlabel.font.family, l, "htf"), u(c.hoverlabel.font.weight, l, "htw"), u(c.hoverlabel.font.style, l, "hty"), u(c.hoverlabel.font.variant, l, "htv"), u(c.hoverlabel.namelength, l, "hnl"), u(c.hoverlabel.align, l, "hta"));
                        }
                    }
                };
            },
            94225: function(t1, e1, r) {
                "use strict";
                var n = r(33626), i = r(38103).hover;
                t1.exports = function(t1, e1, r) {
                    var a = n.getComponentMethod("annotations", "onClick")(t1, t1._hoverdata);
                    function o() {
                        t1.emit("plotly_click", {
                            points: t1._hoverdata,
                            event: e1
                        });
                    }
                    void 0 !== r && i(t1, e1, r, !0), t1._hoverdata && e1 && e1.target && (a && a.then ? a.then(o) : o(), e1.stopImmediatePropagation && e1.stopImmediatePropagation());
                };
            },
            85988: function(t1) {
                "use strict";
                t1.exports = {
                    YANGLE: 60,
                    HOVERARROWSIZE: 6,
                    HOVERTEXTPAD: 3,
                    HOVERFONTSIZE: 13,
                    HOVERFONT: "Arial, sans-serif",
                    HOVERMINTIME: 50,
                    HOVERID: "-hover"
                };
            },
            3239: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(70192), a = r(26430);
                t1.exports = function(t1, e1, r, o) {
                    var s = n.extendFlat({}, o.hoverlabel);
                    e1.hovertemplate && (s.namelength = -1), a(t1, e1, function(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }, s);
                };
            },
            36040: function(t1, e1, r) {
                "use strict";
                var n = r(34809);
                e1.getSubplot = function(t1) {
                    return t1.subplot || t1.xaxis + t1.yaxis || t1.geo;
                }, e1.isTraceInSubplots = function(t1, r) {
                    if ("splom" === t1.type) {
                        for(var n = t1.xaxes || [], i = t1.yaxes || [], a = 0; a < n.length; a++)for(var o = 0; o < i.length; o++)if (-1 !== r.indexOf(n[a] + i[o])) return !0;
                        return !1;
                    }
                    return -1 !== r.indexOf(e1.getSubplot(t1));
                }, e1.flat = function(t1, e1) {
                    for(var r = new Array(t1.length), n = 0; n < t1.length; n++)r[n] = e1;
                    return r;
                }, e1.p2c = function(t1, e1) {
                    for(var r = new Array(t1.length), n = 0; n < t1.length; n++)r[n] = t1[n].p2c(e1);
                    return r;
                }, e1.getDistanceFunction = function(t1, r, n, i) {
                    return "closest" === t1 ? i || e1.quadrature(r, n) : "x" === t1.charAt(0) ? r : n;
                }, e1.getClosest = function(t1, e1, r) {
                    if (!1 !== r.index) r.index >= 0 && r.index < t1.length ? r.distance = 0 : r.index = !1;
                    else for(var n = 0; n < t1.length; n++){
                        var i = e1(t1[n]);
                        i <= r.distance && (r.index = n, r.distance = i);
                    }
                    return r;
                }, e1.inbox = function(t1, e1, r) {
                    return t1 * e1 < 0 || 0 === t1 ? r : 1 / 0;
                }, e1.quadrature = function(t1, e1) {
                    return function(r) {
                        var n = t1(r), i = e1(r);
                        return Math.sqrt(n * n + i * i);
                    };
                }, e1.makeEventData = function(t1, r, n) {
                    var i = "index" in t1 ? t1.index : t1.pointNumber, a = {
                        data: r._input,
                        fullData: r,
                        curveNumber: r.index,
                        pointNumber: i
                    };
                    if (r._indexToPoints) {
                        var o = r._indexToPoints[i];
                        1 === o.length ? a.pointIndex = o[0] : a.pointIndices = o;
                    } else a.pointIndex = i;
                    return r._module.eventData ? a = r._module.eventData(a, t1, r, n, i) : ("xVal" in t1 ? a.x = t1.xVal : "x" in t1 && (a.x = t1.x), "yVal" in t1 ? a.y = t1.yVal : "y" in t1 && (a.y = t1.y), t1.xa && (a.xaxis = t1.xa), t1.ya && (a.yaxis = t1.ya), void 0 !== t1.zLabelVal && (a.z = t1.zLabelVal)), e1.appendArrayPointValue(a, r, i), a;
                }, e1.appendArrayPointValue = function(t1, e1, r) {
                    var i = e1._arrayAttrs;
                    if (i) for(var s = 0; s < i.length; s++){
                        var l = i[s], c = a(l);
                        if (void 0 === t1[c]) {
                            var u = o(n.nestedProperty(e1, l).get(), r);
                            void 0 !== u && (t1[c] = u);
                        }
                    }
                }, e1.appendArrayMultiPointValues = function(t1, e1, r) {
                    var i = e1._arrayAttrs;
                    if (i) for(var s = 0; s < i.length; s++){
                        var l = i[s], c = a(l);
                        if (void 0 === t1[c]) {
                            for(var u = n.nestedProperty(e1, l).get(), h = new Array(r.length), f = 0; f < r.length; f++)h[f] = o(u, r[f]);
                            t1[c] = h;
                        }
                    }
                };
                var i = {
                    ids: "id",
                    locations: "location",
                    labels: "label",
                    values: "value",
                    "marker.colors": "color",
                    parents: "parent"
                };
                function a(t1) {
                    return i[t1] || t1;
                }
                function o(t1, e1) {
                    return Array.isArray(e1) ? Array.isArray(t1) && Array.isArray(t1[e1[0]]) ? t1[e1[0]][e1[1]] : void 0 : t1[e1];
                }
                var s = {
                    x: !0,
                    y: !0
                }, l = {
                    "x unified": !0,
                    "y unified": !0
                };
                e1.isUnifiedHover = function(t1) {
                    return "string" == typeof t1 && !!l[t1];
                }, e1.isXYhover = function(t1) {
                    return "string" == typeof t1 && !!s[t1];
                };
            },
            38103: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(10721), a = r(65657), o = r(34809), s = o.pushUnique, l = o.strTranslate, c = o.strRotate, u = r(68596), h = r(30635), f = r(93134), p = r(62203), d = r(78766), m = r(14751), g = r(29714), y = r(54826).zindexSeparator, v = r(33626), x = r(36040), _ = r(85988), b = r(73970), w = r(6134), T = _.YANGLE, k = Math.PI * T / 180, A = 1 / Math.sin(k), M = Math.cos(k), S = Math.sin(k), E = _.HOVERARROWSIZE, C = _.HOVERTEXTPAD, L = {
                    box: !0,
                    ohlc: !0,
                    violin: !0,
                    candlestick: !0
                }, I = {
                    scatter: !0,
                    scattergl: !0,
                    splom: !0
                };
                function P(t1, e1) {
                    return t1.distance - e1.distance;
                }
                function z(t1) {
                    return [
                        t1.trace.index,
                        t1.index,
                        t1.x0,
                        t1.y0,
                        t1.name,
                        t1.attr,
                        t1.xa ? t1.xa._id : "",
                        t1.ya ? t1.ya._id : ""
                    ].join(",");
                }
                e1.hover = function(t1, e1, r, a) {
                    t1 = o.getGraphDiv(t1);
                    var l = e1.target;
                    o.throttle(t1._fullLayout._uid + _.HOVERID, _.HOVERMINTIME, function() {
                        !function(t1, e1, r, a, l) {
                            r || (r = "xy"), "string" == typeof r && (r = r.split(y)[0]);
                            var c, h, p, _ = Array.isArray(r) ? r : [
                                r
                            ], b = t1._fullLayout, w = b.hoversubplots, T = b._plots || [], k = T[r], M = b._has("cartesian"), S = e1.hovermode || b.hovermode, C = "x" === (S || "").charAt(0), O = "y" === (S || "").charAt(0);
                            if (M && (C || O) && "axis" === w) {
                                for(var R = _.length, V = 0; V < R; V++)if (T[c = _[V]]) {
                                    h = g.getFromId(t1, c, "x"), p = g.getFromId(t1, c, "y");
                                    var Z = (C ? h : p)._subplotsWith;
                                    if (Z && Z.length) for(var W = 0; W < Z.length; W++)s(_, Z[W]);
                                }
                            }
                            if (k && "single" !== w) {
                                var Y = k.overlays.map(function(t1) {
                                    return t1.id;
                                });
                                _ = _.concat(Y);
                            }
                            for(var X = _.length, $ = new Array(X), J = new Array(X), K = !1, Q = 0; Q < X; Q++)if (T[c = _[Q]]) K = !0, $[Q] = T[c].xaxis, J[Q] = T[c].yaxis;
                            else {
                                if (!b[c] || !b[c]._subplot) return void o.warn("Unrecognized subplot: " + c);
                                var tt = b[c]._subplot;
                                $[Q] = tt.xaxis, J[Q] = tt.yaxis;
                            }
                            if (S && !K && (S = "closest"), -1 === [
                                "x",
                                "y",
                                "closest",
                                "x unified",
                                "y unified"
                            ].indexOf(S) || !t1.calcdata || t1.querySelector(".zoombox") || t1._dragging) return m.unhoverRaw(t1, e1);
                            var et = b.hoverdistance;
                            -1 === et && (et = 1 / 0);
                            var rt = b.spikedistance;
                            -1 === rt && (rt = 1 / 0);
                            var nt, it, at, ot, st, lt, ct, ut, ht, ft, pt, dt, mt, gt = [], yt = [], vt = {
                                hLinePoint: null,
                                vLinePoint: null
                            }, xt = !1;
                            if (Array.isArray(e1)) for(S = "array", at = 0; at < e1.length; at++)(st = t1.calcdata[e1[at].curveNumber || 0]) && (lt = st[0].trace, "skip" !== st[0].trace.hoverinfo && (yt.push(st), "h" === lt.orientation && (xt = !0)));
                            else {
                                var _t, bt, wt = t1.calcdata.slice();
                                for(wt.sort(function(t1, e1) {
                                    return (t1[0].trace.zorder || 0) - (e1[0].trace.zorder || 0);
                                }), ot = 0; ot < wt.length; ot++)st = wt[ot], "skip" !== (lt = st[0].trace).hoverinfo && x.isTraceInSubplots(lt, _) && (yt.push(st), "h" === lt.orientation && (xt = !0));
                                if (l) {
                                    if (!1 === u.triggerHandler(t1, "plotly_beforehover", e1)) return;
                                    var Tt = l.getBoundingClientRect();
                                    _t = e1.clientX - Tt.left, bt = e1.clientY - Tt.top, b._calcInverseTransform(t1);
                                    var kt = o.apply3DTransform(b._invTransform)(_t, bt);
                                    if (_t = kt[0], bt = kt[1], _t < 0 || _t > $[0]._length || bt < 0 || bt > J[0]._length) return m.unhoverRaw(t1, e1);
                                } else _t = "xpx" in e1 ? e1.xpx : $[0]._length / 2, bt = "ypx" in e1 ? e1.ypx : J[0]._length / 2;
                                if (e1.pointerX = _t + $[0]._offset, e1.pointerY = bt + J[0]._offset, nt = "xval" in e1 ? x.flat(_, e1.xval) : x.p2c($, _t), it = "yval" in e1 ? x.flat(_, e1.yval) : x.p2c(J, bt), !i(nt[0]) || !i(it[0])) return o.warn("Fx.hover failed", e1, t1), m.unhoverRaw(t1, e1);
                            }
                            var At = 1 / 0;
                            function Mt(r, n) {
                                for(ot = 0; ot < yt.length; ot++)if ((st = yt[ot]) && st[0] && st[0].trace && !0 === (lt = st[0].trace).visible && 0 !== lt._length && -1 === [
                                    "carpet",
                                    "contourcarpet"
                                ].indexOf(lt._module.name)) {
                                    if (ht = S, x.isUnifiedHover(ht) && (ht = ht.charAt(0)), "splom" === lt.type ? ct = _[ut = 0] : (ct = x.getSubplot(lt), ut = _.indexOf(ct)), dt = {
                                        cd: st,
                                        trace: lt,
                                        xa: $[ut],
                                        ya: J[ut],
                                        maxHoverDistance: et,
                                        maxSpikeDistance: rt,
                                        index: !1,
                                        distance: Math.min(At, et),
                                        spikeDistance: 1 / 0,
                                        xSpike: void 0,
                                        ySpike: void 0,
                                        color: d.defaultLine,
                                        name: lt.name,
                                        x0: void 0,
                                        x1: void 0,
                                        y0: void 0,
                                        y1: void 0,
                                        xLabelVal: void 0,
                                        yLabelVal: void 0,
                                        zLabelVal: void 0,
                                        text: void 0
                                    }, b[ct] && (dt.subplot = b[ct]._subplot), b._splomScenes && b._splomScenes[lt.uid] && (dt.scene = b._splomScenes[lt.uid]), "array" === ht) {
                                        var a = e1[ot];
                                        "pointNumber" in a ? (dt.index = a.pointNumber, ht = "closest") : (ht = "", "xval" in a && (ft = a.xval, ht = "x"), "yval" in a && (pt = a.yval, ht = ht ? "closest" : "y"));
                                    } else void 0 !== r && void 0 !== n ? (ft = r, pt = n) : (ft = nt[ut], pt = it[ut]);
                                    if (mt = gt.length, 0 !== et) {
                                        if (lt._module && lt._module.hoverPoints) {
                                            var s = lt._module.hoverPoints(dt, ft, pt, ht, {
                                                finiteRange: !0,
                                                hoverLayer: b._hoverlayer,
                                                hoversubplots: w,
                                                gd: t1
                                            });
                                            if (s) for(var l, c = 0; c < s.length; c++)l = s[c], i(l.x0) && i(l.y0) && gt.push(N(l, S));
                                        } else o.log("Unrecognized trace type in hover:", lt);
                                    }
                                    if ("closest" === S && gt.length > mt && (gt.splice(0, mt), At = gt[0].distance), M && 0 !== rt && 0 === gt.length) {
                                        dt.distance = rt, dt.index = !1;
                                        var u = lt._module.hoverPoints(dt, ft, pt, "closest", {
                                            hoverLayer: b._hoverlayer
                                        });
                                        if (u && (u = u.filter(function(t1) {
                                            return t1.spikeDistance <= rt;
                                        })), u && u.length) {
                                            var h, f = u.filter(function(t1) {
                                                return t1.xa.showspikes && "hovered data" !== t1.xa.spikesnap;
                                            });
                                            if (f.length) {
                                                var p = f[0];
                                                i(p.x0) && i(p.y0) && (h = Et(p), (!vt.vLinePoint || vt.vLinePoint.spikeDistance > h.spikeDistance) && (vt.vLinePoint = h));
                                            }
                                            var m = u.filter(function(t1) {
                                                return t1.ya.showspikes && "hovered data" !== t1.ya.spikesnap;
                                            });
                                            if (m.length) {
                                                var g = m[0];
                                                i(g.x0) && i(g.y0) && (h = Et(g), (!vt.hLinePoint || vt.hLinePoint.spikeDistance > h.spikeDistance) && (vt.hLinePoint = h));
                                            }
                                        }
                                    }
                                }
                            }
                            function St(t1, e1, r) {
                                for(var n, i = null, a = 1 / 0, o = 0; o < t1.length; o++)h && h._id !== t1[o].xa._id || p && p._id !== t1[o].ya._id || (n = t1[o].spikeDistance, r && 0 === o && (n = -1 / 0), n <= a && n <= e1 && (i = t1[o], a = n));
                                return i;
                            }
                            function Et(t1) {
                                return t1 ? {
                                    xa: t1.xa,
                                    ya: t1.ya,
                                    x: void 0 !== t1.xSpike ? t1.xSpike : (t1.x0 + t1.x1) / 2,
                                    y: void 0 !== t1.ySpike ? t1.ySpike : (t1.y0 + t1.y1) / 2,
                                    distance: t1.distance,
                                    spikeDistance: t1.spikeDistance,
                                    curveNumber: t1.trace.index,
                                    color: t1.color,
                                    pointNumber: t1.index
                                } : null;
                            }
                            Mt();
                            var Ct = {
                                fullLayout: b,
                                container: b._hoverlayer,
                                event: e1
                            }, Lt = t1._spikepoints, It = {
                                vLinePoint: vt.vLinePoint,
                                hLinePoint: vt.hLinePoint
                            };
                            t1._spikepoints = It;
                            var Pt = function() {
                                var t1 = gt.filter(function(t1) {
                                    return h && h._id === t1.xa._id && p && p._id === t1.ya._id;
                                }), e1 = gt.filter(function(t1) {
                                    return !(h && h._id === t1.xa._id && p && p._id === t1.ya._id);
                                });
                                t1.sort(P), e1.sort(P), gt = function(t1, e1) {
                                    for(var r = e1.charAt(0), n = [], i = [], a = [], o = 0; o < t1.length; o++){
                                        var s = t1[o];
                                        v.traceIs(s.trace, "bar-like") || v.traceIs(s.trace, "box-violin") ? a.push(s) : s.trace[r + "period"] ? i.push(s) : n.push(s);
                                    }
                                    return n.concat(i).concat(a);
                                }(gt = t1.concat(e1), S);
                            };
                            Pt();
                            var zt = S.charAt(0), Ot = ("x" === zt || "y" === zt) && gt[0] && I[gt[0].trace.type];
                            if (M && 0 !== rt && 0 !== gt.length) {
                                var Dt = St(gt.filter(function(t1) {
                                    return t1.ya.showspikes;
                                }), rt, Ot);
                                vt.hLinePoint = Et(Dt);
                                var Rt = St(gt.filter(function(t1) {
                                    return t1.xa.showspikes;
                                }), rt, Ot);
                                vt.vLinePoint = Et(Rt);
                            }
                            if (0 === gt.length) {
                                var Ft = m.unhoverRaw(t1, e1);
                                return !M || null === vt.hLinePoint && null === vt.vLinePoint || U(Lt) && j(t1, vt, Ct), Ft;
                            }
                            if (M && U(Lt) && j(t1, vt, Ct), x.isXYhover(ht) && 0 !== gt[0].length && "splom" !== gt[0].trace.type) {
                                var Bt = gt[0], Nt = (gt = L[Bt.trace.type] ? gt.filter(function(t1) {
                                    return t1.trace.index === Bt.trace.index;
                                }) : [
                                    Bt
                                ]).length;
                                Mt(q("x", Bt, b), q("y", Bt, b));
                                var jt, Ut = [], Vt = {}, qt = 0, Ht = function(t1) {
                                    var e1 = L[t1.trace.type] ? z(t1) : t1.trace.index;
                                    if (Vt[e1]) {
                                        var r = Vt[e1] - 1, n = Ut[r];
                                        r > 0 && Math.abs(t1.distance) < Math.abs(n.distance) && (Ut[r] = t1);
                                    } else qt++, Vt[e1] = qt, Ut.push(t1);
                                };
                                for(jt = 0; jt < Nt; jt++)Ht(gt[jt]);
                                for(jt = gt.length - 1; jt > Nt - 1; jt--)Ht(gt[jt]);
                                gt = Ut, Pt();
                            }
                            var Gt = t1._hoverdata, Zt = [], Wt = H(t1), Yt = G(t1);
                            for(at = 0; at < gt.length; at++){
                                var Xt = gt[at], $t = x.makeEventData(Xt, Xt.trace, Xt.cd);
                                if (!1 !== Xt.hovertemplate) {
                                    var Jt = !1;
                                    Xt.cd[Xt.index] && Xt.cd[Xt.index].ht && (Jt = Xt.cd[Xt.index].ht), Xt.hovertemplate = Jt || Xt.trace.hovertemplate || !1;
                                }
                                if (Xt.xa && Xt.ya) {
                                    var Kt = Xt.x0 + Xt.xa._offset, Qt = Xt.x1 + Xt.xa._offset, te = Xt.y0 + Xt.ya._offset, ee = Xt.y1 + Xt.ya._offset, re = Math.min(Kt, Qt), ne = Math.max(Kt, Qt), ie = Math.min(te, ee), ae = Math.max(te, ee);
                                    $t.bbox = {
                                        x0: re + Yt,
                                        x1: ne + Yt,
                                        y0: ie + Wt,
                                        y1: ae + Wt
                                    };
                                }
                                Xt.eventData = [
                                    $t
                                ], Zt.push($t);
                            }
                            t1._hoverdata = Zt;
                            var oe = "y" === S && (yt.length > 1 || gt.length > 1) || "closest" === S && xt && gt.length > 1, se = d.combine(b.plot_bgcolor || d.background, b.paper_bgcolor), le = D(gt, {
                                gd: t1,
                                hovermode: S,
                                rotateLabels: oe,
                                bgColor: se,
                                container: b._hoverlayer,
                                outerContainer: b._paper.node(),
                                commonLabelOpts: b.hoverlabel,
                                hoverdistance: b.hoverdistance
                            }), ce = le.hoverLabels;
                            if (x.isUnifiedHover(S) || (function(t1, e1, r, n) {
                                var i, a, o, s, l, c, u, h = e1 ? "xa" : "ya", f = e1 ? "ya" : "xa", p = 0, d = 1, m = t1.size(), g = new Array(m), y = 0, v = n.minX, x = n.maxX, _ = n.minY, b = n.maxY, w = function(t1) {
                                    return t1 * r._invScaleX;
                                }, T = function(t1) {
                                    return t1 * r._invScaleY;
                                };
                                function k(t1) {
                                    var e1 = t1[0], r = t1[t1.length - 1];
                                    if (a = e1.pmin - e1.pos - e1.dp + e1.size, o = r.pos + r.dp + r.size - e1.pmax, a > .01) {
                                        for(l = t1.length - 1; l >= 0; l--)t1[l].dp += a;
                                        i = !1;
                                    }
                                    if (!(o < .01)) {
                                        if (a < -0.01) {
                                            for(l = t1.length - 1; l >= 0; l--)t1[l].dp -= o;
                                            i = !1;
                                        }
                                        if (i) {
                                            var n = 0;
                                            for(s = 0; s < t1.length; s++)(c = t1[s]).pos + c.dp + c.size > e1.pmax && n++;
                                            for(s = t1.length - 1; s >= 0 && !(n <= 0); s--)(c = t1[s]).pos > e1.pmax - 1 && (c.del = !0, n--);
                                            for(s = 0; s < t1.length && !(n <= 0); s++)if ((c = t1[s]).pos < e1.pmin + 1) for(c.del = !0, n--, o = 2 * c.size, l = t1.length - 1; l >= 0; l--)t1[l].dp -= o;
                                            for(s = t1.length - 1; s >= 0 && !(n <= 0); s--)(c = t1[s]).pos + c.dp + c.size > e1.pmax && (c.del = !0, n--);
                                        }
                                    }
                                }
                                for(t1.each(function(t1) {
                                    var n = t1[h], i = t1[f], a = "x" === n._id.charAt(0), o = n.range;
                                    0 === y && o && o[0] > o[1] !== a && (d = -1);
                                    var s = 0, l = a ? r.width : r.height;
                                    if ("x" === r.hovermode || "y" === r.hovermode) {
                                        var c, u, p = F(t1, e1), m = t1.anchor, k = "end" === m ? -1 : 1;
                                        if ("middle" === m) u = (c = t1.crossPos + (a ? T(p.y - t1.by / 2) : w(t1.bx / 2 + t1.tx2width / 2))) + (a ? T(t1.by) : w(t1.bx));
                                        else if (a) u = (c = t1.crossPos + T(E + p.y) - T(t1.by / 2 - E)) + T(t1.by);
                                        else {
                                            var M = w(k * E + p.x), S = M + w(k * t1.bx);
                                            c = t1.crossPos + Math.min(M, S), u = t1.crossPos + Math.max(M, S);
                                        }
                                        a ? void 0 !== _ && void 0 !== b && Math.min(u, b) - Math.max(c, _) > 1 && ("left" === i.side ? (s = i._mainLinePosition, l = r.width) : l = i._mainLinePosition) : void 0 !== v && void 0 !== x && Math.min(u, x) - Math.max(c, v) > 1 && ("top" === i.side ? (s = i._mainLinePosition, l = r.height) : l = i._mainLinePosition);
                                    }
                                    g[y++] = [
                                        {
                                            datum: t1,
                                            traceIndex: t1.trace.index,
                                            dp: 0,
                                            pos: t1.pos,
                                            posref: t1.posref,
                                            size: t1.by * (a ? A : 1) / 2,
                                            pmin: s,
                                            pmax: l
                                        }
                                    ];
                                }), g.sort(function(t1, e1) {
                                    return t1[0].posref - e1[0].posref || d * (e1[0].traceIndex - t1[0].traceIndex);
                                }); !i && p <= m;){
                                    for(p++, i = !0, s = 0; s < g.length - 1;){
                                        var M = g[s], S = g[s + 1], C = M[M.length - 1], L = S[0];
                                        if ((a = C.pos + C.dp + C.size - L.pos - L.dp + L.size) > .01) {
                                            for(l = S.length - 1; l >= 0; l--)S[l].dp += a;
                                            for(M.push.apply(M, S), g.splice(s + 1, 1), u = 0, l = M.length - 1; l >= 0; l--)u += M[l].dp;
                                            for(o = u / M.length, l = M.length - 1; l >= 0; l--)M[l].dp -= o;
                                            i = !1;
                                        } else s++;
                                    }
                                    g.forEach(k);
                                }
                                for(s = g.length - 1; s >= 0; s--){
                                    var I = g[s];
                                    for(l = I.length - 1; l >= 0; l--){
                                        var P = I[l], z = P.datum;
                                        z.offset = P.dp, z.del = P.del;
                                    }
                                }
                            }(ce, oe, b, le.commonLabelBoundingBox), B(ce, oe, b._invScaleX, b._invScaleY)), l && l.tagName) {
                                var ue = v.getComponentMethod("annotations", "hasClickToShow")(t1, Zt);
                                f(n.select(l), ue ? "pointer" : "");
                            }
                            l && !a && function(t1, e1, r) {
                                if (!r || r.length !== t1._hoverdata.length) return !0;
                                for(var n = r.length - 1; n >= 0; n--){
                                    var i = r[n], a = t1._hoverdata[n];
                                    if (i.curveNumber !== a.curveNumber || String(i.pointNumber) !== String(a.pointNumber) || String(i.pointNumbers) !== String(a.pointNumbers)) return !0;
                                }
                                return !1;
                            }(t1, 0, Gt) && (Gt && t1.emit("plotly_unhover", {
                                event: e1,
                                points: Gt
                            }), t1.emit("plotly_hover", {
                                event: e1,
                                points: t1._hoverdata,
                                xaxes: $,
                                yaxes: J,
                                xvals: nt,
                                yvals: it
                            }));
                        }(t1, e1, r, a, l);
                    });
                }, e1.loneHover = function(t1, e1) {
                    var r = !0;
                    Array.isArray(t1) || (r = !1, t1 = [
                        t1
                    ]);
                    var i = e1.gd, a = H(i), o = G(i), s = D(t1.map(function(t1) {
                        var r = t1._x0 || t1.x0 || t1.x || 0, n = t1._x1 || t1.x1 || t1.x || 0, s = t1._y0 || t1.y0 || t1.y || 0, l = t1._y1 || t1.y1 || t1.y || 0, c = t1.eventData;
                        if (c) {
                            var u = Math.min(r, n), h = Math.max(r, n), f = Math.min(s, l), p = Math.max(s, l), m = t1.trace;
                            if (v.traceIs(m, "gl3d")) {
                                var g = i._fullLayout[m.scene]._scene.container, y = g.offsetLeft, x = g.offsetTop;
                                u += y, h += y, f += x, p += x;
                            }
                            c.bbox = {
                                x0: u + o,
                                x1: h + o,
                                y0: f + a,
                                y1: p + a
                            }, e1.inOut_bbox && e1.inOut_bbox.push(c.bbox);
                        } else c = !1;
                        return {
                            color: t1.color || d.defaultLine,
                            x0: t1.x0 || t1.x || 0,
                            x1: t1.x1 || t1.x || 0,
                            y0: t1.y0 || t1.y || 0,
                            y1: t1.y1 || t1.y || 0,
                            xLabel: t1.xLabel,
                            yLabel: t1.yLabel,
                            zLabel: t1.zLabel,
                            text: t1.text,
                            name: t1.name,
                            idealAlign: t1.idealAlign,
                            borderColor: t1.borderColor,
                            fontFamily: t1.fontFamily,
                            fontSize: t1.fontSize,
                            fontColor: t1.fontColor,
                            fontWeight: t1.fontWeight,
                            fontStyle: t1.fontStyle,
                            fontVariant: t1.fontVariant,
                            nameLength: t1.nameLength,
                            textAlign: t1.textAlign,
                            trace: t1.trace || {
                                index: 0,
                                hoverinfo: ""
                            },
                            xa: {
                                _offset: 0
                            },
                            ya: {
                                _offset: 0
                            },
                            index: 0,
                            hovertemplate: t1.hovertemplate || !1,
                            hovertemplateLabels: t1.hovertemplateLabels || !1,
                            eventData: c
                        };
                    }), {
                        gd: i,
                        hovermode: "closest",
                        rotateLabels: !1,
                        bgColor: e1.bgColor || d.background,
                        container: n.select(e1.container),
                        outerContainer: e1.outerContainer || e1.container
                    }).hoverLabels, l = 0, c = 0;
                    return s.sort(function(t1, e1) {
                        return t1.y0 - e1.y0;
                    }).each(function(t1, r) {
                        var n = t1.y0 - t1.by / 2;
                        t1.offset = n - 5 < l ? l - n + 5 : 0, l = n + t1.by + t1.offset, r === e1.anchorIndex && (c = t1.offset);
                    }).each(function(t1) {
                        t1.offset -= c;
                    }), B(s, !1, i._fullLayout._invScaleX, i._fullLayout._invScaleY), r ? s : s.node();
                };
                var O = /<extra>([\s\S]*)<\/extra>/;
                function D(t1, e1) {
                    var r = e1.gd, i = r._fullLayout, a = e1.hovermode, s = e1.rotateLabels, u = e1.bgColor, f = e1.container, m = e1.outerContainer, g = e1.commonLabelOpts || {};
                    if (0 === t1.length) return [
                        []
                    ];
                    var y = e1.fontFamily || _.HOVERFONT, k = e1.fontSize || _.HOVERFONTSIZE, A = e1.fontWeight || i.font.weight, M = e1.fontStyle || i.font.style, S = e1.fontVariant || i.font.variant, L = e1.fontTextcase || i.font.textcase, I = e1.fontLineposition || i.font.lineposition, P = e1.fontShadow || i.font.shadow, O = t1[0], D = O.xa, F = O.ya, B = a.charAt(0), N = B + "Label", j = O[N];
                    if (void 0 === j && "multicategory" === D.type) for(var U = 0; U < t1.length && void 0 === (j = t1[U][N]); U++);
                    var V = Z(r, m), q = V.top, H = V.width, G = V.height, W = void 0 !== j && O.distance <= e1.hoverdistance && ("x" === a || "y" === a);
                    if (W) {
                        var Y, X, $ = !0;
                        for(Y = 0; Y < t1.length; Y++)if ($ && void 0 === t1[Y].zLabel && ($ = !1), X = t1[Y].hoverinfo || t1[Y].trace.hoverinfo) {
                            var J = Array.isArray(X) ? X : X.split("+");
                            if (-1 === J.indexOf("all") && -1 === J.indexOf(a)) {
                                W = !1;
                                break;
                            }
                        }
                        $ && (W = !1);
                    }
                    var K = f.selectAll("g.axistext").data(W ? [
                        0
                    ] : []);
                    K.enter().append("g").classed("axistext", !0), K.exit().remove();
                    var Q = {
                        minX: 0,
                        maxX: 0,
                        minY: 0,
                        maxY: 0
                    };
                    if (K.each(function() {
                        var t1 = n.select(this), e1 = o.ensureSingle(t1, "path", "", function(t1) {
                            t1.style({
                                "stroke-width": "1px"
                            });
                        }), s = o.ensureSingle(t1, "text", "", function(t1) {
                            t1.attr("data-notex", 1);
                        }), c = g.bgcolor || d.defaultLine, u = g.bordercolor || d.contrast(c), f = d.contrast(c), m = g.font, v = {
                            weight: m.weight || A,
                            style: m.style || M,
                            variant: m.variant || S,
                            textcase: m.textcase || L,
                            lineposition: m.lineposition || I,
                            shadow: m.shadow || P,
                            family: m.family || y,
                            size: m.size || k,
                            color: m.color || f
                        };
                        e1.style({
                            fill: c,
                            stroke: u
                        }), s.text(j).call(p.font, v).call(h.positionText, 0, 0).call(h.convertToTspans, r), t1.attr("transform", "");
                        var x, _, b = Z(r, s.node());
                        if ("x" === a) {
                            var w = "top" === D.side ? "-" : "";
                            s.attr("text-anchor", "middle").call(h.positionText, 0, "top" === D.side ? q - b.bottom - E - C : q - b.top + E + C), x = D._offset + (O.x0 + O.x1) / 2, _ = F._offset + ("top" === D.side ? 0 : F._length);
                            var T = b.width / 2 + C, z = x;
                            x < T ? z = T : x > i.width - T && (z = i.width - T), e1.attr("d", "M" + (x - z) + ",0L" + (x - z + E) + "," + w + E + "H" + T + "v" + w + (2 * C + b.height) + "H" + -T + "V" + w + E + "H" + (x - z - E) + "Z"), x = z, Q.minX = x - T, Q.maxX = x + T, "top" === D.side ? (Q.minY = _ - (2 * C + b.height), Q.maxY = _ - C) : (Q.minY = _ + C, Q.maxY = _ + (2 * C + b.height));
                        } else {
                            var R, B, N;
                            "right" === F.side ? (R = "start", B = 1, N = "", x = D._offset + D._length) : (R = "end", B = -1, N = "-", x = D._offset), _ = F._offset + (O.y0 + O.y1) / 2, s.attr("text-anchor", R), e1.attr("d", "M0,0L" + N + E + "," + E + "V" + (C + b.height / 2) + "h" + N + (2 * C + b.width) + "V-" + (C + b.height / 2) + "H" + N + E + "V-" + E + "Z"), Q.minY = _ - (C + b.height / 2), Q.maxY = _ + (C + b.height / 2), "right" === F.side ? (Q.minX = x + E, Q.maxX = x + E + (2 * C + b.width)) : (Q.minX = x - E - (2 * C + b.width), Q.maxX = x - E);
                            var U, V = b.height / 2, H = q - b.top - V, G = "clip" + i._uid + "commonlabel" + F._id;
                            if (x < b.width + 2 * C + E) {
                                U = "M-" + (E + C) + "-" + V + "h-" + (b.width - C) + "V" + V + "h" + (b.width - C) + "Z";
                                var W = b.width - x + C;
                                h.positionText(s, W, H), "end" === R && s.selectAll("tspan").each(function() {
                                    var t1 = n.select(this), e1 = p.tester.append("text").text(t1.text()).call(p.font, v), i = Z(r, e1.node());
                                    Math.round(i.width) < Math.round(b.width) && t1.attr("x", W - i.width), e1.remove();
                                });
                            } else h.positionText(s, B * (C + E), H), U = null;
                            var Y = i._topclips.selectAll("#" + G).data(U ? [
                                0
                            ] : []);
                            Y.enter().append("clipPath").attr("id", G).append("path"), Y.exit().remove(), Y.select("path").attr("d", U), p.setClipUrl(s, U ? G : null, r);
                        }
                        t1.attr("transform", l(x, _));
                    }), x.isUnifiedHover(a)) {
                        f.selectAll("g.hovertext").remove();
                        var tt = t1.filter(function(t1) {
                            return "none" !== t1.hoverinfo;
                        });
                        if (0 === tt.length) return [];
                        var et = i.hoverlabel, rt = et.font, nt = {
                            showlegend: !0,
                            legend: {
                                title: {
                                    text: j,
                                    font: rt
                                },
                                font: rt,
                                bgcolor: et.bgcolor,
                                bordercolor: et.bordercolor,
                                borderwidth: 1,
                                tracegroupgap: 7,
                                traceorder: i.legend ? i.legend.traceorder : void 0,
                                orientation: "v"
                            }
                        }, it = {
                            font: rt
                        };
                        b(nt, it, r._fullData);
                        var at = it.legend;
                        at.entries = [];
                        for(var ot = 0; ot < tt.length; ot++){
                            var st = tt[ot];
                            if ("none" !== st.hoverinfo) {
                                var lt = R(st, !0, a, i, j), ct = lt[0], ut = lt[1];
                                st.name = ut, st.text = "" !== ut ? ut + " : " + ct : ct;
                                var ht = st.cd[st.index];
                                ht && (ht.mc && (st.mc = ht.mc), ht.mcc && (st.mc = ht.mcc), ht.mlc && (st.mlc = ht.mlc), ht.mlcc && (st.mlc = ht.mlcc), ht.mlw && (st.mlw = ht.mlw), ht.mrc && (st.mrc = ht.mrc), ht.dir && (st.dir = ht.dir)), st._distinct = !0, at.entries.push([
                                    st
                                ]);
                            }
                        }
                        at.entries.sort(function(t1, e1) {
                            return t1[0].trace.index - e1[0].trace.index;
                        }), at.layer = f, at._inHover = !0, at._groupTitleFont = et.grouptitlefont, w(r, at);
                        var ft, pt, dt, mt, gt = f.select("g.legend"), yt = Z(r, gt.node()), vt = yt.width + 2 * C, xt = yt.height + 2 * C, _t = tt[0], bt = (_t.x0 + _t.x1) / 2, wt = (_t.y0 + _t.y1) / 2, Tt = !(v.traceIs(_t.trace, "bar-like") || v.traceIs(_t.trace, "box-violin"));
                        "y" === B ? Tt ? (pt = wt - C, ft = wt + C) : (pt = Math.min.apply(null, tt.map(function(t1) {
                            return Math.min(t1.y0, t1.y1);
                        })), ft = Math.max.apply(null, tt.map(function(t1) {
                            return Math.max(t1.y0, t1.y1);
                        }))) : pt = ft = o.mean(tt.map(function(t1) {
                            return (t1.y0 + t1.y1) / 2;
                        })) - xt / 2, "x" === B ? Tt ? (dt = bt + C, mt = bt - C) : (dt = Math.max.apply(null, tt.map(function(t1) {
                            return Math.max(t1.x0, t1.x1);
                        })), mt = Math.min.apply(null, tt.map(function(t1) {
                            return Math.min(t1.x0, t1.x1);
                        }))) : dt = mt = o.mean(tt.map(function(t1) {
                            return (t1.x0 + t1.x1) / 2;
                        })) - vt / 2;
                        var kt, At, Mt = D._offset, St = F._offset;
                        return mt += Mt - vt, pt += St - xt, kt = (dt += Mt) + vt < H && dt >= 0 ? dt : mt + vt < H && mt >= 0 ? mt : Mt + vt < H ? Mt : dt - bt < bt - mt + vt ? H - vt : 0, kt += C, At = (ft += St) + xt < G && ft >= 0 ? ft : pt + xt < G && pt >= 0 ? pt : St + xt < G ? St : ft - wt < wt - pt + xt ? G - xt : 0, At += C, gt.attr("transform", l(kt - 1, At - 1)), gt;
                    }
                    var Et = f.selectAll("g.hovertext").data(t1, function(t1) {
                        return z(t1);
                    });
                    return Et.enter().append("g").classed("hovertext", !0).each(function() {
                        var t1 = n.select(this);
                        t1.append("rect").call(d.fill, d.addOpacity(u, .8)), t1.append("text").classed("name", !0), t1.append("path").style("stroke-width", "1px"), t1.append("text").classed("nums", !0).call(p.font, {
                            weight: A,
                            style: M,
                            variant: S,
                            textcase: L,
                            lineposition: I,
                            shadow: P,
                            family: y,
                            size: k
                        });
                    }), Et.exit().remove(), Et.each(function(t1) {
                        var e1 = n.select(this).attr("transform", ""), o = t1.color;
                        Array.isArray(o) && (o = o[t1.eventData[0].pointNumber]);
                        var f = t1.bgcolor || o, m = d.combine(d.opacity(f) ? f : d.defaultLine, u), g = d.combine(d.opacity(o) ? o : d.defaultLine, u), v = t1.borderColor || d.contrast(m), x = R(t1, W, a, i, j, e1), _ = x[0], b = x[1], w = e1.select("text.nums").call(p.font, {
                            family: t1.fontFamily || y,
                            size: t1.fontSize || k,
                            color: t1.fontColor || v,
                            weight: t1.fontWeight || A,
                            style: t1.fontStyle || M,
                            variant: t1.fontVariant || S,
                            textcase: t1.fontTextcase || L,
                            lineposition: t1.fontLineposition || I,
                            shadow: t1.fontShadow || P
                        }).text(_).attr("data-notex", 1).call(h.positionText, 0, 0).call(h.convertToTspans, r), z = e1.select("text.name"), O = 0, D = 0;
                        if (b && b !== _) {
                            z.call(p.font, {
                                family: t1.fontFamily || y,
                                size: t1.fontSize || k,
                                color: g,
                                weight: t1.fontWeight || A,
                                style: t1.fontStyle || M,
                                variant: t1.fontVariant || S,
                                textcase: t1.fontTextcase || L,
                                lineposition: t1.fontLineposition || I,
                                shadow: t1.fontShadow || P
                            }).text(b).attr("data-notex", 1).call(h.positionText, 0, 0).call(h.convertToTspans, r);
                            var F = Z(r, z.node());
                            O = F.width + 2 * C, D = F.height + 2 * C;
                        } else z.remove(), e1.select("rect").remove();
                        e1.select("path").style({
                            fill: m,
                            stroke: v
                        });
                        var B = t1.xa._offset + (t1.x0 + t1.x1) / 2, N = t1.ya._offset + (t1.y0 + t1.y1) / 2, U = Math.abs(t1.x1 - t1.x0), V = Math.abs(t1.y1 - t1.y0), Y = Z(r, w.node()), X = Y.width / i._invScaleX, $ = Y.height / i._invScaleY;
                        t1.ty0 = (q - Y.top) / i._invScaleY, t1.bx = X + 2 * C, t1.by = Math.max($ + 2 * C, D), t1.anchor = "start", t1.txwidth = X, t1.tx2width = O, t1.offset = 0;
                        var J, K, Q = (X + E + C + O) * i._invScaleX;
                        if (s) t1.pos = B, J = N + V / 2 + Q <= G, K = N - V / 2 - Q >= 0, "top" !== t1.idealAlign && J || !K ? J ? (N += V / 2, t1.anchor = "start") : t1.anchor = "middle" : (N -= V / 2, t1.anchor = "end"), t1.crossPos = N;
                        else {
                            if (t1.pos = N, J = B + U / 2 + Q <= H, K = B - U / 2 - Q >= 0, "left" !== t1.idealAlign && J || !K) {
                                if (J) B += U / 2, t1.anchor = "start";
                                else {
                                    t1.anchor = "middle";
                                    var tt = Q / 2, et = B + tt - H, rt = B - tt;
                                    et > 0 && (B -= et), rt < 0 && (B += -rt);
                                }
                            } else B -= U / 2, t1.anchor = "end";
                            t1.crossPos = B;
                        }
                        w.attr("text-anchor", t1.anchor), O && z.attr("text-anchor", t1.anchor), e1.attr("transform", l(B, N) + (s ? c(T) : ""));
                    }), {
                        hoverLabels: Et,
                        commonLabelBoundingBox: Q
                    };
                }
                function R(t1, e1, r, n, i, a) {
                    var s = "", l = "";
                    void 0 !== t1.nameOverride && (t1.name = t1.nameOverride), t1.name && (t1.trace._meta && (t1.name = o.templateString(t1.name, t1.trace._meta)), s = V(t1.name, t1.nameLength));
                    var c = r.charAt(0), u = "x" === c ? "y" : "x";
                    void 0 !== t1.zLabel ? (void 0 !== t1.xLabel && (l += "x: " + t1.xLabel + "<br>"), void 0 !== t1.yLabel && (l += "y: " + t1.yLabel + "<br>"), "choropleth" !== t1.trace.type && "choroplethmapbox" !== t1.trace.type && "choroplethmap" !== t1.trace.type && (l += (l ? "z: " : "") + t1.zLabel)) : e1 && t1[c + "Label"] === i ? l = t1[u + "Label"] || "" : void 0 === t1.xLabel ? void 0 !== t1.yLabel && "scattercarpet" !== t1.trace.type && (l = t1.yLabel) : l = void 0 === t1.yLabel ? t1.xLabel : "(" + t1.xLabel + ", " + t1.yLabel + ")", !t1.text && 0 !== t1.text || Array.isArray(t1.text) || (l += (l ? "<br>" : "") + t1.text), void 0 !== t1.extraText && (l += (l ? "<br>" : "") + t1.extraText), a && "" === l && !t1.hovertemplate && ("" === s && a.remove(), l = s);
                    var h = t1.hovertemplate || !1;
                    if (h) {
                        var f = t1.hovertemplateLabels || t1;
                        t1[c + "Label"] !== i && (f[c + "other"] = f[c + "Val"], f[c + "otherLabel"] = f[c + "Label"]), l = (l = o.hovertemplateString(h, f, n._d3locale, t1.eventData[0] || {}, t1.trace._meta)).replace(O, function(e1, r) {
                            return s = V(r, t1.nameLength), "";
                        });
                    }
                    return [
                        l,
                        s
                    ];
                }
                function F(t1, e1) {
                    var r = 0, n = t1.offset;
                    return e1 && (n *= -S, r = t1.offset * M), {
                        x: r,
                        y: n
                    };
                }
                function B(t1, e1, r, i) {
                    var a = function(t1) {
                        return t1 * r;
                    }, o = function(t1) {
                        return t1 * i;
                    };
                    t1.each(function(t1) {
                        var r = n.select(this);
                        if (t1.del) return r.remove();
                        var i, s, l, c, u = r.select("text.nums"), f = t1.anchor, d = "end" === f ? -1 : 1, m = (c = (l = (s = ({
                            start: 1,
                            end: -1,
                            middle: 0
                        })[(i = t1).anchor]) * (E + C)) + s * (i.txwidth + C), "middle" === i.anchor && (l -= i.tx2width / 2, c += i.txwidth / 2 + C), {
                            alignShift: s,
                            textShiftX: l,
                            text2ShiftX: c
                        }), g = F(t1, e1), y = g.x, v = g.y, x = "middle" === f;
                        r.select("path").attr("d", x ? "M-" + a(t1.bx / 2 + t1.tx2width / 2) + "," + o(v - t1.by / 2) + "h" + a(t1.bx) + "v" + o(t1.by) + "h-" + a(t1.bx) + "Z" : "M0,0L" + a(d * E + y) + "," + o(E + v) + "v" + o(t1.by / 2 - E) + "h" + a(d * t1.bx) + "v-" + o(t1.by) + "H" + a(d * E + y) + "V" + o(v - E) + "Z");
                        var _ = y + m.textShiftX, b = v + t1.ty0 - t1.by / 2 + C, w = t1.textAlign || "auto";
                        "auto" !== w && ("left" === w && "start" !== f ? (u.attr("text-anchor", "start"), _ = x ? -t1.bx / 2 - t1.tx2width / 2 + C : -t1.bx - C) : "right" === w && "end" !== f && (u.attr("text-anchor", "end"), _ = x ? t1.bx / 2 - t1.tx2width / 2 - C : t1.bx + C)), u.call(h.positionText, a(_), o(b)), t1.tx2width && (r.select("text.name").call(h.positionText, a(m.text2ShiftX + m.alignShift * C + y), o(v + t1.ty0 - t1.by / 2 + C)), r.select("rect").call(p.setRect, a(m.text2ShiftX + (m.alignShift - 1) * t1.tx2width / 2 + y), o(v - t1.by / 2 - 1), a(t1.tx2width), o(t1.by + 2)));
                    });
                }
                function N(t1, e1) {
                    var r = t1.index, n = t1.trace || {}, a = t1.cd[0], s = t1.cd[r] || {};
                    function l(t1) {
                        return t1 || i(t1) && 0 === t1;
                    }
                    var c = Array.isArray(r) ? function(t1, e1) {
                        var i = o.castOption(a, r, t1);
                        return l(i) ? i : o.extractOption({}, n, "", e1);
                    } : function(t1, e1) {
                        return o.extractOption(s, n, t1, e1);
                    };
                    function u(e1, r, n) {
                        var i = c(r, n);
                        l(i) && (t1[e1] = i);
                    }
                    if (u("hoverinfo", "hi", "hoverinfo"), u("bgcolor", "hbg", "hoverlabel.bgcolor"), u("borderColor", "hbc", "hoverlabel.bordercolor"), u("fontFamily", "htf", "hoverlabel.font.family"), u("fontSize", "hts", "hoverlabel.font.size"), u("fontColor", "htc", "hoverlabel.font.color"), u("fontWeight", "htw", "hoverlabel.font.weight"), u("fontStyle", "hty", "hoverlabel.font.style"), u("fontVariant", "htv", "hoverlabel.font.variant"), u("nameLength", "hnl", "hoverlabel.namelength"), u("textAlign", "hta", "hoverlabel.align"), t1.posref = "y" === e1 || "closest" === e1 && "h" === n.orientation ? t1.xa._offset + (t1.x0 + t1.x1) / 2 : t1.ya._offset + (t1.y0 + t1.y1) / 2, t1.x0 = o.constrain(t1.x0, 0, t1.xa._length), t1.x1 = o.constrain(t1.x1, 0, t1.xa._length), t1.y0 = o.constrain(t1.y0, 0, t1.ya._length), t1.y1 = o.constrain(t1.y1, 0, t1.ya._length), void 0 !== t1.xLabelVal && (t1.xLabel = "xLabel" in t1 ? t1.xLabel : g.hoverLabelText(t1.xa, t1.xLabelVal, n.xhoverformat), t1.xVal = t1.xa.c2d(t1.xLabelVal)), void 0 !== t1.yLabelVal && (t1.yLabel = "yLabel" in t1 ? t1.yLabel : g.hoverLabelText(t1.ya, t1.yLabelVal, n.yhoverformat), t1.yVal = t1.ya.c2d(t1.yLabelVal)), void 0 !== t1.zLabelVal && void 0 === t1.zLabel && (t1.zLabel = String(t1.zLabelVal)), !(isNaN(t1.xerr) || "log" === t1.xa.type && t1.xerr <= 0)) {
                        var h = g.tickText(t1.xa, t1.xa.c2l(t1.xerr), "hover").text;
                        void 0 !== t1.xerrneg ? t1.xLabel += " +" + h + " / -" + g.tickText(t1.xa, t1.xa.c2l(t1.xerrneg), "hover").text : t1.xLabel += " \xb1 " + h, "x" === e1 && (t1.distance += 1);
                    }
                    if (!(isNaN(t1.yerr) || "log" === t1.ya.type && t1.yerr <= 0)) {
                        var f = g.tickText(t1.ya, t1.ya.c2l(t1.yerr), "hover").text;
                        void 0 !== t1.yerrneg ? t1.yLabel += " +" + f + " / -" + g.tickText(t1.ya, t1.ya.c2l(t1.yerrneg), "hover").text : t1.yLabel += " \xb1 " + f, "y" === e1 && (t1.distance += 1);
                    }
                    var p = t1.hoverinfo || t1.trace.hoverinfo;
                    return p && "all" !== p && (-1 === (p = Array.isArray(p) ? p : p.split("+")).indexOf("x") && (t1.xLabel = void 0), -1 === p.indexOf("y") && (t1.yLabel = void 0), -1 === p.indexOf("z") && (t1.zLabel = void 0), -1 === p.indexOf("text") && (t1.text = void 0), -1 === p.indexOf("name") && (t1.name = void 0)), t1;
                }
                function j(t1, e1, r) {
                    var n, i, o = r.container, s = r.fullLayout, l = s._size, c = r.event, u = !!e1.hLinePoint, h = !!e1.vLinePoint;
                    if (o.selectAll(".spikeline").remove(), h || u) {
                        var f = d.combine(s.plot_bgcolor, s.paper_bgcolor);
                        if (u) {
                            var m, y, v = e1.hLinePoint;
                            n = v && v.xa, "cursor" === (i = v && v.ya).spikesnap ? (m = c.pointerX, y = c.pointerY) : (m = n._offset + v.x, y = i._offset + v.y);
                            var x, _, b = a.readability(v.color, f) < 1.5 ? d.contrast(f) : v.color, w = i.spikemode, T = i.spikethickness, k = i.spikecolor || b, A = g.getPxPosition(t1, i);
                            if (-1 !== w.indexOf("toaxis") || -1 !== w.indexOf("across")) {
                                if (-1 !== w.indexOf("toaxis") && (x = A, _ = m), -1 !== w.indexOf("across")) {
                                    var M = i._counterDomainMin, S = i._counterDomainMax;
                                    "free" === i.anchor && (M = Math.min(M, i.position), S = Math.max(S, i.position)), x = l.l + M * l.w, _ = l.l + S * l.w;
                                }
                                o.insert("line", ":first-child").attr({
                                    x1: x,
                                    x2: _,
                                    y1: y,
                                    y2: y,
                                    "stroke-width": T,
                                    stroke: k,
                                    "stroke-dasharray": p.dashStyle(i.spikedash, T)
                                }).classed("spikeline", !0).classed("crisp", !0), o.insert("line", ":first-child").attr({
                                    x1: x,
                                    x2: _,
                                    y1: y,
                                    y2: y,
                                    "stroke-width": T + 2,
                                    stroke: f
                                }).classed("spikeline", !0).classed("crisp", !0);
                            }
                            -1 !== w.indexOf("marker") && o.insert("circle", ":first-child").attr({
                                cx: A + ("right" !== i.side ? T : -T),
                                cy: y,
                                r: T,
                                fill: k
                            }).classed("spikeline", !0);
                        }
                        if (h) {
                            var E, C, L = e1.vLinePoint;
                            n = L && L.xa, i = L && L.ya, "cursor" === n.spikesnap ? (E = c.pointerX, C = c.pointerY) : (E = n._offset + L.x, C = i._offset + L.y);
                            var I, P, z = a.readability(L.color, f) < 1.5 ? d.contrast(f) : L.color, O = n.spikemode, D = n.spikethickness, R = n.spikecolor || z, F = g.getPxPosition(t1, n);
                            if (-1 !== O.indexOf("toaxis") || -1 !== O.indexOf("across")) {
                                if (-1 !== O.indexOf("toaxis") && (I = F, P = C), -1 !== O.indexOf("across")) {
                                    var B = n._counterDomainMin, N = n._counterDomainMax;
                                    "free" === n.anchor && (B = Math.min(B, n.position), N = Math.max(N, n.position)), I = l.t + (1 - N) * l.h, P = l.t + (1 - B) * l.h;
                                }
                                o.insert("line", ":first-child").attr({
                                    x1: E,
                                    x2: E,
                                    y1: I,
                                    y2: P,
                                    "stroke-width": D,
                                    stroke: R,
                                    "stroke-dasharray": p.dashStyle(n.spikedash, D)
                                }).classed("spikeline", !0).classed("crisp", !0), o.insert("line", ":first-child").attr({
                                    x1: E,
                                    x2: E,
                                    y1: I,
                                    y2: P,
                                    "stroke-width": D + 2,
                                    stroke: f
                                }).classed("spikeline", !0).classed("crisp", !0);
                            }
                            -1 !== O.indexOf("marker") && o.insert("circle", ":first-child").attr({
                                cx: E,
                                cy: F - ("top" !== n.side ? D : -D),
                                r: D,
                                fill: R
                            }).classed("spikeline", !0);
                        }
                    }
                }
                function U(t1, e1) {
                    return !e1 || e1.vLinePoint !== t1._spikepoints.vLinePoint || e1.hLinePoint !== t1._spikepoints.hLinePoint;
                }
                function V(t1, e1) {
                    return h.plainText(t1 || "", {
                        len: e1,
                        allowedTags: [
                            "br",
                            "sub",
                            "sup",
                            "b",
                            "i",
                            "em",
                            "s",
                            "u"
                        ]
                    });
                }
                function q(t1, e1, r) {
                    var n = e1[t1 + "a"], i = e1[t1 + "Val"], a = e1.cd[0];
                    if ("category" === n.type || "multicategory" === n.type) i = n._categoriesMap[i];
                    else if ("date" === n.type) {
                        var o = e1.trace[t1 + "periodalignment"];
                        if (o) {
                            var s = e1.cd[e1.index], l = s[t1 + "Start"];
                            void 0 === l && (l = s[t1]);
                            var c = s[t1 + "End"];
                            void 0 === c && (c = s[t1]);
                            var u = c - l;
                            "end" === o ? i += u : "middle" === o && (i += u / 2);
                        }
                        i = n.d2c(i);
                    }
                    return a && a.t && a.t.posLetter === n._id && ("group" !== r.boxmode && "group" !== r.violinmode || (i += a.t.dPos)), i;
                }
                function H(t1) {
                    return t1.offsetTop + t1.clientTop;
                }
                function G(t1) {
                    return t1.offsetLeft + t1.clientLeft;
                }
                function Z(t1, e1) {
                    var r = t1._fullLayout, n = e1.getBoundingClientRect(), i = n.left, a = n.top, s = i + n.width, l = a + n.height, c = o.apply3DTransform(r._invTransform)(i, a), u = o.apply3DTransform(r._invTransform)(s, l), h = c[0], f = c[1], p = u[0], d = u[1];
                    return {
                        x: h,
                        y: f,
                        width: p - h,
                        height: d - f,
                        top: Math.min(f, d),
                        left: Math.min(h, p),
                        right: Math.max(h, p),
                        bottom: Math.max(f, d)
                    };
                }
            },
            26430: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(78766), a = r(36040).isUnifiedHover;
                t1.exports = function(t1, e1, r, o) {
                    o = o || {};
                    var s = e1.legend;
                    function l(t1) {
                        o.font[t1] || (o.font[t1] = s ? e1.legend.font[t1] : e1.font[t1]);
                    }
                    e1 && a(e1.hovermode) && (o.font || (o.font = {}), l("size"), l("family"), l("color"), l("weight"), l("style"), l("variant"), s ? (o.bgcolor || (o.bgcolor = i.combine(e1.legend.bgcolor, e1.paper_bgcolor)), o.bordercolor || (o.bordercolor = e1.legend.bordercolor)) : o.bgcolor || (o.bgcolor = e1.paper_bgcolor)), r("hoverlabel.bgcolor", o.bgcolor), r("hoverlabel.bordercolor", o.bordercolor), r("hoverlabel.namelength", o.namelength), n.coerceFont(r, "hoverlabel.font", o.font), r("hoverlabel.align", o.align);
                };
            },
            45265: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(6811);
                t1.exports = function(t1, e1) {
                    function r(r, a) {
                        return void 0 !== e1[r] ? e1[r] : n.coerce(t1, e1, i, r, a);
                    }
                    return r("clickmode"), r("hoversubplots"), r("hovermode");
                };
            },
            32141: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(34809), a = r(14751), o = r(36040), s = r(6811), l = r(38103);
                t1.exports = {
                    moduleType: "component",
                    name: "fx",
                    constants: r(85988),
                    schema: {
                        layout: s
                    },
                    attributes: r(70192),
                    layoutAttributes: s,
                    supplyLayoutGlobalDefaults: r(5358),
                    supplyDefaults: r(3239),
                    supplyLayoutDefaults: r(8412),
                    calc: r(83552),
                    getDistanceFunction: o.getDistanceFunction,
                    getClosest: o.getClosest,
                    inbox: o.inbox,
                    quadrature: o.quadrature,
                    appendArrayPointValue: o.appendArrayPointValue,
                    castHoverOption: function(t1, e1, r) {
                        return i.castOption(t1, e1, "hoverlabel." + r);
                    },
                    castHoverinfo: function(t1, e1, r) {
                        return i.castOption(t1, r, "hoverinfo", function(r) {
                            return i.coerceHoverinfo({
                                hoverinfo: r
                            }, {
                                _module: t1._module
                            }, e1);
                        });
                    },
                    hover: l.hover,
                    unhover: a.unhover,
                    loneHover: l.loneHover,
                    loneUnhover: function(t1) {
                        var e1 = i.isD3Selection(t1) ? t1 : n.select(t1);
                        e1.selectAll("g.hovertext").remove(), e1.selectAll(".spikeline").remove();
                    },
                    click: r(94225)
                };
            },
            6811: function(t1, e1, r) {
                "use strict";
                var n = r(85988), i = r(80337), a = i({
                    editType: "none"
                });
                a.family.dflt = n.HOVERFONT, a.size.dflt = n.HOVERFONTSIZE, t1.exports = {
                    clickmode: {
                        valType: "flaglist",
                        flags: [
                            "event",
                            "select"
                        ],
                        dflt: "event",
                        editType: "plot",
                        extras: [
                            "none"
                        ]
                    },
                    dragmode: {
                        valType: "enumerated",
                        values: [
                            "zoom",
                            "pan",
                            "select",
                            "lasso",
                            "drawclosedpath",
                            "drawopenpath",
                            "drawline",
                            "drawrect",
                            "drawcircle",
                            "orbit",
                            "turntable",
                            !1
                        ],
                        dflt: "zoom",
                        editType: "modebar"
                    },
                    hovermode: {
                        valType: "enumerated",
                        values: [
                            "x",
                            "y",
                            "closest",
                            !1,
                            "x unified",
                            "y unified"
                        ],
                        dflt: "closest",
                        editType: "modebar"
                    },
                    hoversubplots: {
                        valType: "enumerated",
                        values: [
                            "single",
                            "overlaying",
                            "axis"
                        ],
                        dflt: "overlaying",
                        editType: "none"
                    },
                    hoverdistance: {
                        valType: "integer",
                        min: -1,
                        dflt: 20,
                        editType: "none"
                    },
                    spikedistance: {
                        valType: "integer",
                        min: -1,
                        dflt: -1,
                        editType: "none"
                    },
                    hoverlabel: {
                        bgcolor: {
                            valType: "color",
                            editType: "none"
                        },
                        bordercolor: {
                            valType: "color",
                            editType: "none"
                        },
                        font: a,
                        grouptitlefont: i({
                            editType: "none"
                        }),
                        align: {
                            valType: "enumerated",
                            values: [
                                "left",
                                "right",
                                "auto"
                            ],
                            dflt: "auto",
                            editType: "none"
                        },
                        namelength: {
                            valType: "integer",
                            min: -1,
                            dflt: 15,
                            editType: "none"
                        },
                        editType: "none"
                    },
                    selectdirection: {
                        valType: "enumerated",
                        values: [
                            "h",
                            "v",
                            "d",
                            "any"
                        ],
                        dflt: "any",
                        editType: "none"
                    }
                };
            },
            8412: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(6811), a = r(45265), o = r(26430);
                t1.exports = function(t1, e1) {
                    function r(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    a(t1, e1) && (r("hoverdistance"), r("spikedistance")), "select" === r("dragmode") && r("selectdirection");
                    var s = e1._has("mapbox"), l = e1._has("map"), c = e1._has("geo"), u = e1._basePlotModules.length;
                    "zoom" === e1.dragmode && ((s || l || c) && 1 === u || (s || l) && c && 2 === u) && (e1.dragmode = "pan"), o(t1, e1, r), n.coerceFont(r, "hoverlabel.grouptitlefont", e1.hoverlabel.font);
                };
            },
            5358: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(26430), a = r(6811);
                t1.exports = function(t1, e1) {
                    i(t1, e1, function(r, i) {
                        return n.coerce(t1, e1, a, r, i);
                    });
                };
            },
            83595: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(90694).counter, a = r(13792).u, o = r(54826).idRegex, s = r(78032), l = {
                    rows: {
                        valType: "integer",
                        min: 1,
                        editType: "plot"
                    },
                    roworder: {
                        valType: "enumerated",
                        values: [
                            "top to bottom",
                            "bottom to top"
                        ],
                        dflt: "top to bottom",
                        editType: "plot"
                    },
                    columns: {
                        valType: "integer",
                        min: 1,
                        editType: "plot"
                    },
                    subplots: {
                        valType: "info_array",
                        freeLength: !0,
                        dimensions: 2,
                        items: {
                            valType: "enumerated",
                            values: [
                                i("xy").toString(),
                                ""
                            ],
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    xaxes: {
                        valType: "info_array",
                        freeLength: !0,
                        items: {
                            valType: "enumerated",
                            values: [
                                o.x.toString(),
                                ""
                            ],
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    yaxes: {
                        valType: "info_array",
                        freeLength: !0,
                        items: {
                            valType: "enumerated",
                            values: [
                                o.y.toString(),
                                ""
                            ],
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    pattern: {
                        valType: "enumerated",
                        values: [
                            "independent",
                            "coupled"
                        ],
                        dflt: "coupled",
                        editType: "plot"
                    },
                    xgap: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        editType: "plot"
                    },
                    ygap: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        editType: "plot"
                    },
                    domain: a({
                        name: "grid",
                        editType: "plot",
                        noGridCell: !0
                    }, {}),
                    xside: {
                        valType: "enumerated",
                        values: [
                            "bottom",
                            "bottom plot",
                            "top plot",
                            "top"
                        ],
                        dflt: "bottom plot",
                        editType: "plot"
                    },
                    yside: {
                        valType: "enumerated",
                        values: [
                            "left",
                            "left plot",
                            "right plot",
                            "right"
                        ],
                        dflt: "left plot",
                        editType: "plot"
                    },
                    editType: "plot"
                };
                function c(t1, e1, r) {
                    var n = e1[r + "axes"], i = Object.keys((t1._splomAxes || {})[r] || {});
                    return Array.isArray(n) ? n : i.length ? i : void 0;
                }
                function u(t1, e1, r, n, i, a) {
                    var o = e1(t1 + "gap", r), s = e1("domain." + t1);
                    e1(t1 + "side", n);
                    for(var l = new Array(i), c = s[0], u = (s[1] - c) / (i - o), h = u * (1 - o), f = 0; f < i; f++){
                        var p = c + u * f;
                        l[a ? i - 1 - f : f] = [
                            p,
                            p + h
                        ];
                    }
                    return l;
                }
                function h(t1, e1, r, n, i) {
                    var a, o = new Array(r);
                    function s(t1, r) {
                        -1 !== e1.indexOf(r) && void 0 === n[r] ? (o[t1] = r, n[r] = t1) : o[t1] = "";
                    }
                    if (Array.isArray(t1)) for(a = 0; a < r; a++)s(a, t1[a]);
                    else for(s(0, i), a = 1; a < r; a++)s(a, i + (a + 1));
                    return o;
                }
                t1.exports = {
                    moduleType: "component",
                    name: "grid",
                    schema: {
                        layout: {
                            grid: l
                        }
                    },
                    layoutAttributes: l,
                    sizeDefaults: function(t1, e1) {
                        var r = t1.grid || {}, i = c(e1, r, "x"), a = c(e1, r, "y");
                        if (t1.grid || i || a) {
                            var o, h, f = Array.isArray(r.subplots) && Array.isArray(r.subplots[0]), p = Array.isArray(i), d = Array.isArray(a), m = p && i !== r.xaxes && d && a !== r.yaxes;
                            f ? (o = r.subplots.length, h = r.subplots[0].length) : (d && (o = a.length), p && (h = i.length));
                            var g = s.newContainer(e1, "grid"), y = k("rows", o), v = k("columns", h);
                            if (y * v > 1) {
                                f || p || d || "independent" === k("pattern") && (f = !0), g._hasSubplotGrid = f;
                                var x, _, b = "top to bottom" === k("roworder"), w = f ? .2 : .1, T = f ? .3 : .1;
                                m && e1._splomGridDflt && (x = e1._splomGridDflt.xside, _ = e1._splomGridDflt.yside), g._domains = {
                                    x: u("x", k, w, x, v),
                                    y: u("y", k, T, _, y, b)
                                };
                            } else delete e1.grid;
                        }
                        function k(t1, e1) {
                            return n.coerce(r, g, l, t1, e1);
                        }
                    },
                    contentDefaults: function(t1, e1) {
                        var r = e1.grid;
                        if (r && r._domains) {
                            var n, i, a, o, s, l, u, f = t1.grid || {}, p = e1._subplots, d = r._hasSubplotGrid, m = r.rows, g = r.columns, y = "independent" === r.pattern, v = r._axisMap = {};
                            if (d) {
                                var x = f.subplots || [];
                                l = r.subplots = new Array(m);
                                var _ = 1;
                                for(n = 0; n < m; n++){
                                    var b = l[n] = new Array(g), w = x[n] || [];
                                    for(i = 0; i < g; i++)if (y ? (s = 1 === _ ? "xy" : "x" + _ + "y" + _, _++) : s = w[i], b[i] = "", -1 !== p.cartesian.indexOf(s)) {
                                        if (u = s.indexOf("y"), a = s.slice(0, u), o = s.slice(u), void 0 !== v[a] && v[a] !== i || void 0 !== v[o] && v[o] !== n) continue;
                                        b[i] = s, v[a] = i, v[o] = n;
                                    }
                                }
                            } else {
                                var T = c(e1, f, "x"), k = c(e1, f, "y");
                                r.xaxes = h(T, p.xaxis, g, v, "x"), r.yaxes = h(k, p.yaxis, m, v, "y");
                            }
                            var A = r._anchors = {}, M = "top to bottom" === r.roworder;
                            for(var S in v){
                                var E, C, L, I = S.charAt(0), P = r[I + "side"];
                                if (P.length < 8) A[S] = "free";
                                else if ("x" === I) {
                                    if ("t" === P.charAt(0) === M ? (E = 0, C = 1, L = m) : (E = m - 1, C = -1, L = -1), d) {
                                        var z = v[S];
                                        for(n = E; n !== L; n += C)if ((s = l[n][z]) && (u = s.indexOf("y"), s.slice(0, u) === S)) {
                                            A[S] = s.slice(u);
                                            break;
                                        }
                                    } else for(n = E; n !== L; n += C)if (o = r.yaxes[n], -1 !== p.cartesian.indexOf(S + o)) {
                                        A[S] = o;
                                        break;
                                    }
                                } else if ("l" === P.charAt(0) ? (E = 0, C = 1, L = g) : (E = g - 1, C = -1, L = -1), d) {
                                    var O = v[S];
                                    for(n = E; n !== L; n += C)if ((s = l[O][n]) && (u = s.indexOf("y"), s.slice(u) === S)) {
                                        A[S] = s.slice(0, u);
                                        break;
                                    }
                                } else for(n = E; n !== L; n += C)if (a = r.xaxes[n], -1 !== p.cartesian.indexOf(a + S)) {
                                    A[S] = a;
                                    break;
                                }
                            }
                        }
                    }
                };
            },
            37260: function(t1, e1, r) {
                "use strict";
                var n = r(54826), i = r(78032).templatedArray;
                r(35081), t1.exports = i("image", {
                    visible: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "arraydraw"
                    },
                    source: {
                        valType: "string",
                        editType: "arraydraw"
                    },
                    layer: {
                        valType: "enumerated",
                        values: [
                            "below",
                            "above"
                        ],
                        dflt: "above",
                        editType: "arraydraw"
                    },
                    sizex: {
                        valType: "number",
                        dflt: 0,
                        editType: "arraydraw"
                    },
                    sizey: {
                        valType: "number",
                        dflt: 0,
                        editType: "arraydraw"
                    },
                    sizing: {
                        valType: "enumerated",
                        values: [
                            "fill",
                            "contain",
                            "stretch"
                        ],
                        dflt: "contain",
                        editType: "arraydraw"
                    },
                    opacity: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 1,
                        editType: "arraydraw"
                    },
                    x: {
                        valType: "any",
                        dflt: 0,
                        editType: "arraydraw"
                    },
                    y: {
                        valType: "any",
                        dflt: 0,
                        editType: "arraydraw"
                    },
                    xanchor: {
                        valType: "enumerated",
                        values: [
                            "left",
                            "center",
                            "right"
                        ],
                        dflt: "left",
                        editType: "arraydraw"
                    },
                    yanchor: {
                        valType: "enumerated",
                        values: [
                            "top",
                            "middle",
                            "bottom"
                        ],
                        dflt: "top",
                        editType: "arraydraw"
                    },
                    xref: {
                        valType: "enumerated",
                        values: [
                            "paper",
                            n.idRegex.x.toString()
                        ],
                        dflt: "paper",
                        editType: "arraydraw"
                    },
                    yref: {
                        valType: "enumerated",
                        values: [
                            "paper",
                            n.idRegex.y.toString()
                        ],
                        dflt: "paper",
                        editType: "arraydraw"
                    },
                    editType: "arraydraw"
                });
            },
            89443: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(8083);
                t1.exports = function(t1, e1, r, a) {
                    e1 = e1 || {};
                    var o = "log" === r && "linear" === e1.type, s = "linear" === r && "log" === e1.type;
                    if (o || s) {
                        for(var l, c, u = t1._fullLayout.images, h = e1._id.charAt(0), f = 0; f < u.length; f++)if (c = "images[" + f + "].", (l = u[f])[h + "ref"] === e1._id) {
                            var p = l[h], d = l["size" + h], m = null, g = null;
                            if (o) {
                                m = i(p, e1.range);
                                var y = d / Math.pow(10, m) / 2;
                                g = 2 * Math.log(y + Math.sqrt(1 + y * y)) / Math.LN10;
                            } else g = (m = Math.pow(10, p)) * (Math.pow(10, d / 2) - Math.pow(10, -d / 2));
                            n(m) ? n(g) || (g = null) : (m = null, g = null), a(c + h, m), a(c + "size" + h, g);
                        }
                    }
                };
            },
            507: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(29714), a = r(59008), o = r(37260);
                function s(t1, e1, r) {
                    function a(r, i) {
                        return n.coerce(t1, e1, o, r, i);
                    }
                    var s = a("source");
                    if (!a("visible", !!s)) return e1;
                    a("layer"), a("xanchor"), a("yanchor"), a("sizex"), a("sizey"), a("sizing"), a("opacity");
                    for(var l = {
                        _fullLayout: r
                    }, c = [
                        "x",
                        "y"
                    ], u = 0; u < 2; u++){
                        var h = c[u], f = i.coerceRef(t1, e1, l, h, "paper", void 0);
                        "paper" !== f && i.getFromId(l, f)._imgIndices.push(e1._index), i.coercePosition(e1, l, a, f, h, 0);
                    }
                    return e1;
                }
                t1.exports = function(t1, e1) {
                    a(t1, e1, {
                        name: "images",
                        handleItemDefaults: s
                    });
                };
            },
            32211: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(62203), a = r(29714), o = r(5975), s = r(62972);
                t1.exports = function(t1) {
                    var e1, r, l = t1._fullLayout, c = [], u = {}, h = [];
                    for(r = 0; r < l.images.length; r++){
                        var f = l.images[r];
                        if (f.visible) {
                            if ("below" === f.layer && "paper" !== f.xref && "paper" !== f.yref) {
                                e1 = o.ref2id(f.xref) + o.ref2id(f.yref);
                                var p = l._plots[e1];
                                if (!p) {
                                    h.push(f);
                                    continue;
                                }
                                p.mainplot && (e1 = p.mainplot.id), u[e1] || (u[e1] = []), u[e1].push(f);
                            } else "above" === f.layer ? c.push(f) : h.push(f);
                        }
                    }
                    var d = {
                        left: {
                            sizing: "xMin",
                            offset: 0
                        },
                        center: {
                            sizing: "xMid",
                            offset: -0.5
                        },
                        right: {
                            sizing: "xMax",
                            offset: -1
                        }
                    }, m = {
                        top: {
                            sizing: "YMin",
                            offset: 0
                        },
                        middle: {
                            sizing: "YMid",
                            offset: -0.5
                        },
                        bottom: {
                            sizing: "YMax",
                            offset: -1
                        }
                    };
                    function g(e1) {
                        var r = n.select(this);
                        if (this._imgSrc !== e1.source) {
                            if (r.attr("xmlns", s.svg), e1.source && "data:" === e1.source.slice(0, 5)) r.attr("xlink:href", e1.source), this._imgSrc = e1.source;
                            else {
                                var i = new Promise((function(t1) {
                                    var n = new Image;
                                    function i() {
                                        r.remove(), t1();
                                    }
                                    this.img = n, n.setAttribute("crossOrigin", "anonymous"), n.onerror = i, n.onload = function() {
                                        var e1 = document.createElement("canvas");
                                        e1.width = this.width, e1.height = this.height, e1.getContext("2d", {
                                            willReadFrequently: !0
                                        }).drawImage(this, 0, 0);
                                        var n = e1.toDataURL("image/png");
                                        r.attr("xlink:href", n), t1();
                                    }, r.on("error", i), n.src = e1.source, this._imgSrc = e1.source;
                                }).bind(this));
                                t1._promises.push(i);
                            }
                        }
                    }
                    function y(e1) {
                        var r, o, s = n.select(this), c = a.getFromId(t1, e1.xref), u = a.getFromId(t1, e1.yref), h = "domain" === a.getRefType(e1.xref), f = "domain" === a.getRefType(e1.yref), p = l._size;
                        r = void 0 !== c ? "string" == typeof e1.xref && h ? c._length * e1.sizex : Math.abs(c.l2p(e1.sizex) - c.l2p(0)) : e1.sizex * p.w, o = void 0 !== u ? "string" == typeof e1.yref && f ? u._length * e1.sizey : Math.abs(u.l2p(e1.sizey) - u.l2p(0)) : e1.sizey * p.h;
                        var g, y, v = r * d[e1.xanchor].offset, x = o * m[e1.yanchor].offset, _ = d[e1.xanchor].sizing + m[e1.yanchor].sizing;
                        switch(g = void 0 !== c ? "string" == typeof e1.xref && h ? c._length * e1.x + c._offset : c.r2p(e1.x) + c._offset : e1.x * p.w + p.l, g += v, y = void 0 !== u ? "string" == typeof e1.yref && f ? u._length * (1 - e1.y) + u._offset : u.r2p(e1.y) + u._offset : p.h - e1.y * p.h + p.t, y += x, e1.sizing){
                            case "fill":
                                _ += " slice";
                                break;
                            case "stretch":
                                _ = "none";
                        }
                        s.attr({
                            x: g,
                            y: y,
                            width: r,
                            height: o,
                            preserveAspectRatio: _,
                            opacity: e1.opacity
                        });
                        var b = (c && "domain" !== a.getRefType(e1.xref) ? c._id : "") + (u && "domain" !== a.getRefType(e1.yref) ? u._id : "");
                        i.setClipUrl(s, b ? "clip" + l._uid + b : null, t1);
                    }
                    var v = l._imageLowerLayer.selectAll("image").data(h), x = l._imageUpperLayer.selectAll("image").data(c);
                    v.enter().append("image"), x.enter().append("image"), v.exit().remove(), x.exit().remove(), v.each(function(t1) {
                        g.bind(this)(t1), y.bind(this)(t1);
                    }), x.each(function(t1) {
                        g.bind(this)(t1), y.bind(this)(t1);
                    });
                    var _ = Object.keys(l._plots);
                    for(r = 0; r < _.length; r++){
                        e1 = _[r];
                        var b = l._plots[e1];
                        if (b.imagelayer) {
                            var w = b.imagelayer.selectAll("image").data(u[e1] || []);
                            w.enter().append("image"), w.exit().remove(), w.each(function(t1) {
                                g.bind(this)(t1), y.bind(this)(t1);
                            });
                        }
                    }
                };
            },
            15553: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    moduleType: "component",
                    name: "images",
                    layoutAttributes: r(37260),
                    supplyLayoutDefaults: r(507),
                    includeBasePlot: r(20706)("images"),
                    draw: r(32211),
                    convertCoords: r(89443)
                };
            },
            86405: function(t1, e1, r) {
                "use strict";
                var n = r(80337), i = r(10229);
                t1.exports = {
                    _isSubplotObj: !0,
                    visible: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "legend"
                    },
                    bgcolor: {
                        valType: "color",
                        editType: "legend"
                    },
                    bordercolor: {
                        valType: "color",
                        dflt: i.defaultLine,
                        editType: "legend"
                    },
                    borderwidth: {
                        valType: "number",
                        min: 0,
                        dflt: 0,
                        editType: "legend"
                    },
                    font: n({
                        editType: "legend"
                    }),
                    grouptitlefont: n({
                        editType: "legend"
                    }),
                    orientation: {
                        valType: "enumerated",
                        values: [
                            "v",
                            "h"
                        ],
                        dflt: "v",
                        editType: "legend"
                    },
                    traceorder: {
                        valType: "flaglist",
                        flags: [
                            "reversed",
                            "grouped"
                        ],
                        extras: [
                            "normal"
                        ],
                        editType: "legend"
                    },
                    tracegroupgap: {
                        valType: "number",
                        min: 0,
                        dflt: 10,
                        editType: "legend"
                    },
                    entrywidth: {
                        valType: "number",
                        min: 0,
                        editType: "legend"
                    },
                    entrywidthmode: {
                        valType: "enumerated",
                        values: [
                            "fraction",
                            "pixels"
                        ],
                        dflt: "pixels",
                        editType: "legend"
                    },
                    indentation: {
                        valType: "number",
                        min: -15,
                        dflt: 0,
                        editType: "legend"
                    },
                    itemsizing: {
                        valType: "enumerated",
                        values: [
                            "trace",
                            "constant"
                        ],
                        dflt: "trace",
                        editType: "legend"
                    },
                    itemwidth: {
                        valType: "number",
                        min: 30,
                        dflt: 30,
                        editType: "legend"
                    },
                    itemclick: {
                        valType: "enumerated",
                        values: [
                            "toggle",
                            "toggleothers",
                            !1
                        ],
                        dflt: "toggle",
                        editType: "legend"
                    },
                    itemdoubleclick: {
                        valType: "enumerated",
                        values: [
                            "toggle",
                            "toggleothers",
                            !1
                        ],
                        dflt: "toggleothers",
                        editType: "legend"
                    },
                    groupclick: {
                        valType: "enumerated",
                        values: [
                            "toggleitem",
                            "togglegroup"
                        ],
                        dflt: "togglegroup",
                        editType: "legend"
                    },
                    x: {
                        valType: "number",
                        editType: "legend"
                    },
                    xref: {
                        valType: "enumerated",
                        dflt: "paper",
                        values: [
                            "container",
                            "paper"
                        ],
                        editType: "layoutstyle"
                    },
                    xanchor: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "left",
                            "center",
                            "right"
                        ],
                        dflt: "left",
                        editType: "legend"
                    },
                    y: {
                        valType: "number",
                        editType: "legend"
                    },
                    yref: {
                        valType: "enumerated",
                        dflt: "paper",
                        values: [
                            "container",
                            "paper"
                        ],
                        editType: "layoutstyle"
                    },
                    yanchor: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "top",
                            "middle",
                            "bottom"
                        ],
                        editType: "legend"
                    },
                    uirevision: {
                        valType: "any",
                        editType: "none"
                    },
                    valign: {
                        valType: "enumerated",
                        values: [
                            "top",
                            "middle",
                            "bottom"
                        ],
                        dflt: "middle",
                        editType: "legend"
                    },
                    title: {
                        text: {
                            valType: "string",
                            dflt: "",
                            editType: "legend"
                        },
                        font: n({
                            editType: "legend"
                        }),
                        side: {
                            valType: "enumerated",
                            values: [
                                "top",
                                "left",
                                "top left",
                                "top center",
                                "top right"
                            ],
                            editType: "legend"
                        },
                        editType: "legend"
                    },
                    editType: "legend"
                };
            },
            72783: function(t1) {
                "use strict";
                t1.exports = {
                    scrollBarWidth: 6,
                    scrollBarMinHeight: 20,
                    scrollBarColor: "#808BA4",
                    scrollBarMargin: 4,
                    scrollBarEnterAttrs: {
                        rx: 20,
                        ry: 3,
                        width: 0,
                        height: 0
                    },
                    titlePad: 2,
                    itemGap: 5
                };
            },
            73970: function(t1, e1, r) {
                "use strict";
                var n = r(33626), i = r(34809), a = r(78032), o = r(9829), s = r(86405), l = r(6704), c = r(57599);
                function u(t1, e1, r, u) {
                    var h = e1[t1] || {}, f = a.newContainer(r, t1);
                    function p(t1, e1) {
                        return i.coerce(h, f, s, t1, e1);
                    }
                    var d = i.coerceFont(p, "font", r.font);
                    if (p("bgcolor", r.paper_bgcolor), p("bordercolor"), p("visible")) {
                        for(var m, g = function(t1, e1) {
                            var r = m._input, n = m;
                            return i.coerce(r, n, o, t1, e1);
                        }, y = r.font || {}, v = i.coerceFont(p, "grouptitlefont", y, {
                            overrideDflt: {
                                size: Math.round(1.1 * y.size)
                            }
                        }), x = 0, _ = !1, b = "normal", w = (r.shapes || []).filter(function(t1) {
                            return t1.showlegend;
                        }), T = u.concat(w).filter(function(e1) {
                            return t1 === (e1.legend || "legend");
                        }), k = 0; k < T.length; k++)if ((m = T[k]).visible) {
                            var A = m._isShape;
                            (m.showlegend || m._dfltShowLegend && !(m._module && m._module.attributes && m._module.attributes.showlegend && !1 === m._module.attributes.showlegend.dflt)) && (x++, m.showlegend && (_ = !0, (!A && n.traceIs(m, "pie-like") || !0 === m._input.showlegend) && x++), i.coerceFont(g, "legendgrouptitle.font", v)), (!A && n.traceIs(m, "bar") && "stack" === r.barmode || -1 !== [
                                "tonextx",
                                "tonexty"
                            ].indexOf(m.fill)) && (b = c.isGrouped({
                                traceorder: b
                            }) ? "grouped+reversed" : "reversed"), void 0 !== m.legendgroup && "" !== m.legendgroup && (b = c.isReversed({
                                traceorder: b
                            }) ? "reversed+grouped" : "grouped");
                        }
                        var M = i.coerce(e1, r, l, "showlegend", _ && x > ("legend" === t1 ? 1 : 0));
                        if (!1 === M && (r[t1] = void 0), (!1 !== M || h.uirevision) && (p("uirevision", r.uirevision), !1 !== M)) {
                            p("borderwidth");
                            var S, E, C, L = "h" === p("orientation"), I = "paper" === p("yref"), P = "paper" === p("xref"), z = "left";
                            if (L ? (S = 0, n.getComponentMethod("rangeslider", "isVisible")(e1.xaxis) ? I ? (E = 1.1, C = "bottom") : (E = 1, C = "top") : I ? (E = -0.1, C = "top") : (E = 0, C = "bottom")) : (E = 1, C = "auto", P ? S = 1.02 : (S = 1, z = "right")), i.coerce(h, f, {
                                x: {
                                    valType: "number",
                                    editType: "legend",
                                    min: P ? -2 : 0,
                                    max: P ? 3 : 1,
                                    dflt: S
                                }
                            }, "x"), i.coerce(h, f, {
                                y: {
                                    valType: "number",
                                    editType: "legend",
                                    min: I ? -2 : 0,
                                    max: I ? 3 : 1,
                                    dflt: E
                                }
                            }, "y"), p("traceorder", b), c.isGrouped(r[t1]) && p("tracegroupgap"), p("entrywidth"), p("entrywidthmode"), p("indentation"), p("itemsizing"), p("itemwidth"), p("itemclick"), p("itemdoubleclick"), p("groupclick"), p("xanchor", z), p("yanchor", C), p("valign"), i.noneOrAll(h, f, [
                                "x",
                                "y"
                            ]), p("title.text")) {
                                p("title.side", L ? "left" : "top");
                                var O = i.extendFlat({}, d, {
                                    size: i.bigFont(d.size)
                                });
                                i.coerceFont(p, "title.font", O);
                            }
                        }
                    }
                }
                t1.exports = function(t1, e1, r) {
                    var n, a = r.slice(), o = e1.shapes;
                    if (o) for(n = 0; n < o.length; n++){
                        var s = o[n];
                        if (s.showlegend) {
                            var l = {
                                _input: s._input,
                                visible: s.visible,
                                showlegend: s.showlegend,
                                legend: s.legend
                            };
                            a.push(l);
                        }
                    }
                    var c = [
                        "legend"
                    ];
                    for(n = 0; n < a.length; n++)i.pushUnique(c, a[n].legend);
                    for(e1._legends = [], n = 0; n < c.length; n++){
                        var h = c[n];
                        u(h, t1, e1, a), e1[h] && e1[h].visible && (e1[h]._id = h), e1._legends.push(h);
                    }
                };
            },
            6134: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(34809), a = r(44122), o = r(33626), s = r(68596), l = r(14751), c = r(62203), u = r(78766), h = r(30635), f = r(22165), p = r(72783), d = r(4530), m = d.LINE_SPACING, g = d.FROM_TL, y = d.FROM_BR, v = r(851), x = r(14375), _ = r(57599), b = 1, w = /^legend[0-9]*$/;
                function T(t1, e1) {
                    var r, s, f = e1 || {}, d = t1._fullLayout, w = P(f), T = f._inHover;
                    if (T ? (s = f.layer, r = "hover") : (s = d._infolayer, r = w), s) {
                        var S;
                        if (r += d._uid, t1._legendMouseDownTime || (t1._legendMouseDownTime = 0), T) {
                            if (!f.entries) return;
                            S = v(f.entries, f);
                        } else {
                            for(var z = (t1.calcdata || []).slice(), O = d.shapes, D = 0; D < O.length; D++){
                                var R = O[D];
                                if (R.showlegend) {
                                    var F = {
                                        _isShape: !0,
                                        _fullInput: R,
                                        index: R._index,
                                        name: R.name || R.label.text || "shape " + R._index,
                                        legend: R.legend,
                                        legendgroup: R.legendgroup,
                                        legendgrouptitle: R.legendgrouptitle,
                                        legendrank: R.legendrank,
                                        legendwidth: R.legendwidth,
                                        showlegend: R.showlegend,
                                        visible: R.visible,
                                        opacity: R.opacity,
                                        mode: "line" === R.type ? "lines" : "markers",
                                        line: R.line,
                                        marker: {
                                            line: R.line,
                                            color: R.fillcolor,
                                            size: 12,
                                            symbol: "rect" === R.type ? "square" : "circle" === R.type ? "circle" : "hexagon2"
                                        }
                                    };
                                    z.push([
                                        {
                                            trace: F
                                        }
                                    ]);
                                }
                            }
                            S = d.showlegend && v(z, f, d._legends.length > 1);
                        }
                        var B = d.hiddenlabels || [];
                        if (!(T || d.showlegend && S.length)) return s.selectAll("." + w).remove(), d._topdefs.select("#" + r).remove(), a.autoMargin(t1, w);
                        var N = i.ensureSingle(s, "g", w, function(t1) {
                            T || t1.attr("pointer-events", "all");
                        }), j = i.ensureSingleById(d._topdefs, "clipPath", r, function(t1) {
                            t1.append("rect");
                        }), U = i.ensureSingle(N, "rect", "bg", function(t1) {
                            t1.attr("shape-rendering", "crispEdges");
                        });
                        U.call(u.stroke, f.bordercolor).call(u.fill, f.bgcolor).style("stroke-width", f.borderwidth + "px");
                        var V, q = i.ensureSingle(N, "g", "scrollbox"), H = f.title;
                        f._titleWidth = 0, f._titleHeight = 0, H.text ? ((V = i.ensureSingle(q, "text", w + "titletext")).attr("text-anchor", "start").call(c.font, H.font).text(H.text), C(V, q, t1, f, b)) : q.selectAll("." + w + "titletext").remove();
                        var G = i.ensureSingle(N, "rect", "scrollbar", function(t1) {
                            t1.attr(p.scrollBarEnterAttrs).call(u.fill, p.scrollBarColor);
                        }), Z = q.selectAll("g.groups").data(S);
                        Z.enter().append("g").attr("class", "groups"), Z.exit().remove();
                        var W = Z.selectAll("g.traces").data(i.identity);
                        W.enter().append("g").attr("class", "traces"), W.exit().remove(), W.style("opacity", function(t1) {
                            var e1 = t1[0].trace;
                            return o.traceIs(e1, "pie-like") ? -1 !== B.indexOf(t1[0].label) ? .5 : 1 : "legendonly" === e1.visible ? .5 : 1;
                        }).each(function() {
                            n.select(this).call(M, t1, f);
                        }).call(x, t1, f).each(function() {
                            T || n.select(this).call(E, t1, w);
                        }), i.syncOrAsync([
                            a.previousPromises,
                            function() {
                                return function(t1, e1, r, i) {
                                    var a = t1._fullLayout, o = P(i);
                                    i || (i = a[o]);
                                    var s = a._size, l = _.isVertical(i), u = _.isGrouped(i), h = "fraction" === i.entrywidthmode, f = i.borderwidth, d = 2 * f, m = p.itemGap, g = i.indentation + i.itemwidth + 2 * m, y = 2 * (f + m), v = I(i), x = i.y < 0 || 0 === i.y && "top" === v, b = i.y > 1 || 1 === i.y && "bottom" === v, w = i.tracegroupgap, T = {};
                                    i._maxHeight = Math.max(x || b ? a.height / 2 : s.h, 30);
                                    var A = 0;
                                    i._width = 0, i._height = 0;
                                    var M = function(t1) {
                                        var e1 = 0, r = 0, n = t1.title.side;
                                        return n && (-1 !== n.indexOf("left") && (e1 = t1._titleWidth), -1 !== n.indexOf("top") && (r = t1._titleHeight)), [
                                            e1,
                                            r
                                        ];
                                    }(i);
                                    if (l) r.each(function(t1) {
                                        var e1 = t1[0].height;
                                        c.setTranslate(this, f + M[0], f + M[1] + i._height + e1 / 2 + m), i._height += e1, i._width = Math.max(i._width, t1[0].width);
                                    }), A = g + i._width, i._width += m + g + d, i._height += y, u && (e1.each(function(t1, e1) {
                                        c.setTranslate(this, 0, e1 * i.tracegroupgap);
                                    }), i._height += (i._lgroupsLength - 1) * i.tracegroupgap);
                                    else {
                                        var S = L(i), E = i.x < 0 || 0 === i.x && "right" === S, C = i.x > 1 || 1 === i.x && "left" === S, z = b || x, O = a.width / 2;
                                        i._maxWidth = Math.max(E ? z && "left" === S ? s.l + s.w : O : C ? z && "right" === S ? s.r + s.w : O : s.w, 2 * g);
                                        var D = 0, R = 0;
                                        r.each(function(t1) {
                                            var e1 = k(t1, i, g);
                                            D = Math.max(D, e1), R += e1;
                                        }), A = null;
                                        var F = 0;
                                        if (u) {
                                            var B = 0, N = 0, j = 0;
                                            e1.each(function() {
                                                var t1 = 0, e1 = 0;
                                                n.select(this).selectAll("g.traces").each(function(r) {
                                                    var n = k(r, i, g), a = r[0].height;
                                                    c.setTranslate(this, M[0], M[1] + f + m + a / 2 + e1), e1 += a, t1 = Math.max(t1, n), T[r[0].trace.legendgroup] = t1;
                                                });
                                                var r = t1 + m;
                                                N > 0 && r + f + N > i._maxWidth ? (F = Math.max(F, N), N = 0, j += B + w, B = e1) : B = Math.max(B, e1), c.setTranslate(this, N, j), N += r;
                                            }), i._width = Math.max(F, N) + f, i._height = j + B + y;
                                        } else {
                                            var U = r.size(), V = R + d + (U - 1) * m < i._maxWidth, q = 0, H = 0, G = 0, Z = 0;
                                            r.each(function(t1) {
                                                var e1 = t1[0].height, r = k(t1, i, g), n = V ? r : D;
                                                h || (n += m), n + f + H - m >= i._maxWidth && (F = Math.max(F, Z), H = 0, G += q, i._height += q, q = 0), c.setTranslate(this, M[0] + f + H, M[1] + f + G + e1 / 2 + m), Z = H + r + m, H += n, q = Math.max(q, e1);
                                            }), V ? (i._width = H + d, i._height = q + y) : (i._width = Math.max(F, Z) + d, i._height += q + y);
                                        }
                                    }
                                    i._width = Math.ceil(Math.max(i._width + M[0], i._titleWidth + 2 * (f + p.titlePad))), i._height = Math.ceil(Math.max(i._height + M[1], i._titleHeight + 2 * (f + p.itemGap))), i._effHeight = Math.min(i._height, i._maxHeight);
                                    var W = t1._context.edits, Y = W.legendText || W.legendPosition;
                                    r.each(function(t1) {
                                        var e1 = n.select(this).select("." + o + "toggle"), r = t1[0].height, a = t1[0].trace.legendgroup, s = k(t1, i, g);
                                        u && "" !== a && (s = T[a]);
                                        var f = Y ? g : A || s;
                                        l || h || (f += m / 2), c.setRect(e1, 0, -r / 2, f, r);
                                    });
                                }(t1, Z, W, f);
                            },
                            function() {
                                var e1, u, v, x, _ = d._size, b = f.borderwidth, k = "paper" === f.xref, M = "paper" === f.yref;
                                if (H.text && function(t1, e1, r) {
                                    if ("top center" === e1.title.side || "top right" === e1.title.side) {
                                        var n = e1.title.font.size * m, i = 0, a = t1.node(), o = c.bBox(a).width;
                                        "top center" === e1.title.side ? i = .5 * (e1._width - 2 * r - 2 * p.titlePad - o) : "top right" === e1.title.side && (i = e1._width - 2 * r - 2 * p.titlePad - o), h.positionText(t1, r + p.titlePad + i, r + n);
                                    }
                                }(V, f, b), !T) {
                                    var S, E;
                                    S = k ? _.l + _.w * f.x - g[L(f)] * f._width : d.width * f.x - g[L(f)] * f._width, E = M ? _.t + _.h * (1 - f.y) - g[I(f)] * f._effHeight : d.height * (1 - f.y) - g[I(f)] * f._effHeight;
                                    var C = function(t1, e1, r, n) {
                                        var i = t1._fullLayout, o = i[e1], s = L(o), l = I(o), c = "paper" === o.xref, u = "paper" === o.yref;
                                        t1._fullLayout._reservedMargin[e1] = {};
                                        var h = o.y < .5 ? "b" : "t", f = o.x < .5 ? "l" : "r", p = {
                                            r: i.width - r,
                                            l: r + o._width,
                                            b: i.height - n,
                                            t: n + o._effHeight
                                        };
                                        if (c && u) return a.autoMargin(t1, e1, {
                                            x: o.x,
                                            y: o.y,
                                            l: o._width * g[s],
                                            r: o._width * y[s],
                                            b: o._effHeight * y[l],
                                            t: o._effHeight * g[l]
                                        });
                                        c ? t1._fullLayout._reservedMargin[e1][h] = p[h] : u || "v" === o.orientation ? t1._fullLayout._reservedMargin[e1][f] = p[f] : t1._fullLayout._reservedMargin[e1][h] = p[h];
                                    }(t1, w, S, E);
                                    if (C) return;
                                    if (d.margin.autoexpand) {
                                        var P = S, z = E;
                                        S = k ? i.constrain(S, 0, d.width - f._width) : P, E = M ? i.constrain(E, 0, d.height - f._effHeight) : z, S !== P && i.log("Constrain " + w + ".x to make legend fit inside graph"), E !== z && i.log("Constrain " + w + ".y to make legend fit inside graph");
                                    }
                                    c.setTranslate(N, S, E);
                                }
                                if (G.on(".drag", null), N.on("wheel", null), T || f._height <= f._maxHeight || t1._context.staticPlot) {
                                    var O = f._effHeight;
                                    T && (O = f._height), U.attr({
                                        width: f._width - b,
                                        height: O - b,
                                        x: b / 2,
                                        y: b / 2
                                    }), c.setTranslate(q, 0, 0), j.select("rect").attr({
                                        width: f._width - 2 * b,
                                        height: O - 2 * b,
                                        x: b,
                                        y: b
                                    }), c.setClipUrl(q, r, t1), c.setRect(G, 0, 0, 0, 0), delete f._scrollY;
                                } else {
                                    var D, R, F, B = Math.max(p.scrollBarMinHeight, f._effHeight * f._effHeight / f._height), Z = f._effHeight - B - 2 * p.scrollBarMargin, W = f._height - f._effHeight, Y = Z / W, X = Math.min(f._scrollY || 0, W);
                                    U.attr({
                                        width: f._width - 2 * b + p.scrollBarWidth + p.scrollBarMargin,
                                        height: f._effHeight - b,
                                        x: b / 2,
                                        y: b / 2
                                    }), j.select("rect").attr({
                                        width: f._width - 2 * b + p.scrollBarWidth + p.scrollBarMargin,
                                        height: f._effHeight - 2 * b,
                                        x: b,
                                        y: b + X
                                    }), c.setClipUrl(q, r, t1), K(X, B, Y), N.on("wheel", function() {
                                        K(X = i.constrain(f._scrollY + n.event.deltaY / Z * W, 0, W), B, Y), 0 !== X && X !== W && n.event.preventDefault();
                                    });
                                    var $ = n.behavior.drag().on("dragstart", function() {
                                        var t1 = n.event.sourceEvent;
                                        D = "touchstart" === t1.type ? t1.changedTouches[0].clientY : t1.clientY, F = X;
                                    }).on("drag", function() {
                                        var t1 = n.event.sourceEvent;
                                        2 === t1.buttons || t1.ctrlKey || (R = "touchmove" === t1.type ? t1.changedTouches[0].clientY : t1.clientY, X = function(t1, e1, r) {
                                            var n = (r - e1) / Y + t1;
                                            return i.constrain(n, 0, W);
                                        }(F, D, R), K(X, B, Y));
                                    });
                                    G.call($);
                                    var J = n.behavior.drag().on("dragstart", function() {
                                        var t1 = n.event.sourceEvent;
                                        "touchstart" === t1.type && (D = t1.changedTouches[0].clientY, F = X);
                                    }).on("drag", function() {
                                        var t1 = n.event.sourceEvent;
                                        "touchmove" === t1.type && (R = t1.changedTouches[0].clientY, X = function(t1, e1, r) {
                                            var n = (e1 - r) / Y + t1;
                                            return i.constrain(n, 0, W);
                                        }(F, D, R), K(X, B, Y));
                                    });
                                    q.call(J);
                                }
                                function K(e1, r, n) {
                                    f._scrollY = t1._fullLayout[w]._scrollY = e1, c.setTranslate(q, 0, -e1), c.setRect(G, f._width, p.scrollBarMargin + e1 * n, p.scrollBarWidth, r), j.select("rect").attr("y", b + e1);
                                }
                                t1._context.edits.legendPosition && (N.classed("cursor-move", !0), l.init({
                                    element: N.node(),
                                    gd: t1,
                                    prepFn: function(t1) {
                                        if (t1.target !== G.node()) {
                                            var e1 = c.getTranslate(N);
                                            v = e1.x, x = e1.y;
                                        }
                                    },
                                    moveFn: function(t1, r) {
                                        if (void 0 !== v && void 0 !== x) {
                                            var n = v + t1, i = x + r;
                                            c.setTranslate(N, n, i), e1 = l.align(n, f._width, _.l, _.l + _.w, f.xanchor), u = l.align(i + f._height, -f._height, _.t + _.h, _.t, f.yanchor);
                                        }
                                    },
                                    doneFn: function() {
                                        if (void 0 !== e1 && void 0 !== u) {
                                            var r = {};
                                            r[w + ".x"] = e1, r[w + ".y"] = u, o.call("_guiRelayout", t1, r);
                                        }
                                    },
                                    clickFn: function(e1, r) {
                                        var n = s.selectAll("g.traces").filter(function() {
                                            var t1 = this.getBoundingClientRect();
                                            return r.clientX >= t1.left && r.clientX <= t1.right && r.clientY >= t1.top && r.clientY <= t1.bottom;
                                        });
                                        n.size() > 0 && A(t1, N, n, e1, r);
                                    }
                                }));
                            }
                        ], t1);
                    }
                }
                function k(t1, e1, r) {
                    var n = t1[0], i = n.width, a = e1.entrywidthmode, o = n.trace.legendwidth || e1.entrywidth;
                    return "fraction" === a ? e1._maxWidth * o : r + (o || i);
                }
                function A(t1, e1, r, n, i) {
                    var a = r.data()[0][0].trace, l = {
                        event: i,
                        node: r.node(),
                        curveNumber: a.index,
                        expandedIndex: a._expandedIndex,
                        data: t1.data,
                        layout: t1.layout,
                        frames: t1._transitionData._frames,
                        config: t1._context,
                        fullData: t1._fullData,
                        fullLayout: t1._fullLayout
                    };
                    a._group && (l.group = a._group), o.traceIs(a, "pie-like") && (l.label = r.datum()[0].label);
                    var c = s.triggerHandler(t1, "plotly_legendclick", l);
                    if (1 === n) {
                        if (!1 === c) return;
                        e1._clickTimeout = setTimeout(function() {
                            t1._fullLayout && f(r, t1, n);
                        }, t1._context.doubleClickDelay);
                    } else 2 === n && (e1._clickTimeout && clearTimeout(e1._clickTimeout), t1._legendMouseDownTime = 0, !1 !== s.triggerHandler(t1, "plotly_legenddoubleclick", l) && !1 !== c && f(r, t1, n));
                }
                function M(t1, e1, r) {
                    var n, a, s = P(r), l = t1.data()[0][0], u = l.trace, f = o.traceIs(u, "pie-like"), d = !r._inHover && e1._context.edits.legendText && !f, m = r._maxNameLength;
                    l.groupTitle ? (n = l.groupTitle.text, a = l.groupTitle.font) : (a = r.font, r.entries ? n = l.text : (n = f ? l.label : u.name, u._meta && (n = i.templateString(n, u._meta))));
                    var g = i.ensureSingle(t1, "text", s + "text");
                    g.attr("text-anchor", "start").call(c.font, a).text(d ? S(n, m) : n);
                    var y = r.indentation + r.itemwidth + 2 * p.itemGap;
                    h.positionText(g, y, 0), d ? g.call(h.makeEditable, {
                        gd: e1,
                        text: n
                    }).call(C, t1, e1, r).on("edit", function(n) {
                        this.text(S(n, m)).call(C, t1, e1, r);
                        var a = l.trace._fullInput || {}, s = {};
                        if (o.hasTransform(a, "groupby")) {
                            var c = o.getTransformIndices(a, "groupby"), h = c[c.length - 1], f = i.keyedContainer(a, "transforms[" + h + "].styles", "target", "value.name");
                            f.set(l.trace._group, n), s = f.constructUpdate();
                        } else s.name = n;
                        return a._isShape ? o.call("_guiRelayout", e1, "shapes[" + u.index + "].name", s.name) : o.call("_guiRestyle", e1, s, u.index);
                    }) : C(g, t1, e1, r);
                }
                function S(t1, e1) {
                    var r = Math.max(4, e1);
                    if (t1 && t1.trim().length >= r / 2) return t1;
                    for(var n = r - (t1 = t1 || "").length; n > 0; n--)t1 += " ";
                    return t1;
                }
                function E(t1, e1, r) {
                    var a, o = e1._context.doubleClickDelay, s = 1, l = i.ensureSingle(t1, "rect", r + "toggle", function(t1) {
                        e1._context.staticPlot || t1.style("cursor", "pointer").attr("pointer-events", "all"), t1.call(u.fill, "rgba(0,0,0,0)");
                    });
                    e1._context.staticPlot || (l.on("mousedown", function() {
                        (a = (new Date).getTime()) - e1._legendMouseDownTime < o ? s += 1 : (s = 1, e1._legendMouseDownTime = a);
                    }), l.on("mouseup", function() {
                        if (!e1._dragged && !e1._editing) {
                            var i = e1._fullLayout[r];
                            (new Date).getTime() - e1._legendMouseDownTime > o && (s = Math.max(s - 1, 1)), A(e1, i, t1, s, n.event);
                        }
                    }));
                }
                function C(t1, e1, r, n, i) {
                    n._inHover && t1.attr("data-notex", !0), h.convertToTspans(t1, r, function() {
                        !function(t1, e1, r, n) {
                            var i = t1.data()[0][0];
                            if (r._inHover || !i || i.trace.showlegend) {
                                var a = t1.select("g[class*=math-group]"), o = a.node(), s = P(r);
                                r || (r = e1._fullLayout[s]);
                                var l, u, f = r.borderwidth, d = (n === b ? r.title.font : i.groupTitle ? i.groupTitle.font : r.font).size * m;
                                if (o) {
                                    var g = c.bBox(o);
                                    l = g.height, u = g.width, n === b ? c.setTranslate(a, f, f + .75 * l) : c.setTranslate(a, 0, .25 * l);
                                } else {
                                    var y = "." + s + (n === b ? "title" : "") + "text", v = t1.select(y), x = h.lineCount(v), _ = v.node();
                                    if (l = d * x, u = _ ? c.bBox(_).width : 0, n === b) "left" === r.title.side && (u += 2 * p.itemGap), h.positionText(v, f + p.titlePad, f + d);
                                    else {
                                        var w = 2 * p.itemGap + r.indentation + r.itemwidth;
                                        i.groupTitle && (w = p.itemGap, u -= r.indentation + r.itemwidth), h.positionText(v, w, -d * ((x - 1) / 2 - .3));
                                    }
                                }
                                n === b ? (r._titleWidth = u, r._titleHeight = l) : (i.lineHeight = d, i.height = Math.max(l, 16) + 3, i.width = u);
                            } else t1.remove();
                        }(e1, r, n, i);
                    });
                }
                function L(t1) {
                    return i.isRightAnchor(t1) ? "right" : i.isCenterAnchor(t1) ? "center" : "left";
                }
                function I(t1) {
                    return i.isBottomAnchor(t1) ? "bottom" : i.isMiddleAnchor(t1) ? "middle" : "top";
                }
                function P(t1) {
                    return t1._id || "legend";
                }
                t1.exports = function(t1, e1) {
                    if (e1) T(t1, e1);
                    else {
                        var r = t1._fullLayout, i = r._legends;
                        r._infolayer.selectAll('[class^="legend"]').each(function() {
                            var t1 = n.select(this), e1 = t1.attr("class").split(" ")[0];
                            e1.match(w) && -1 === i.indexOf(e1) && t1.remove();
                        });
                        for(var a = 0; a < i.length; a++){
                            var o = i[a];
                            T(t1, t1._fullLayout[o]);
                        }
                    }
                };
            },
            851: function(t1, e1, r) {
                "use strict";
                var n = r(33626), i = r(57599);
                t1.exports = function(t1, e1, r) {
                    var a, o, s = e1._inHover, l = i.isGrouped(e1), c = i.isReversed(e1), u = {}, h = [], f = !1, p = {}, d = 0, m = 0;
                    function g(t1, n, a) {
                        if (!1 !== e1.visible && (!r || t1 === e1._id)) {
                            if ("" !== n && i.isGrouped(e1)) -1 === h.indexOf(n) ? (h.push(n), f = !0, u[n] = [
                                a
                            ]) : u[n].push(a);
                            else {
                                var o = "~~i" + d;
                                h.push(o), u[o] = [
                                    a
                                ], d++;
                            }
                        }
                    }
                    for(a = 0; a < t1.length; a++){
                        var y = t1[a], v = y[0], x = v.trace, _ = x.legend, b = x.legendgroup;
                        if (s || x.visible && x.showlegend) {
                            if (n.traceIs(x, "pie-like")) for(p[b] || (p[b] = {}), o = 0; o < y.length; o++){
                                var w = y[o].label;
                                p[b][w] || (g(_, b, {
                                    label: w,
                                    color: y[o].color,
                                    i: y[o].i,
                                    trace: x,
                                    pts: y[o].pts
                                }), p[b][w] = !0, m = Math.max(m, (w || "").length));
                            }
                            else g(_, b, v), m = Math.max(m, (x.name || "").length);
                        }
                    }
                    if (!h.length) return [];
                    var T = !f || !l, k = [];
                    for(a = 0; a < h.length; a++){
                        var A = u[h[a]];
                        T ? k.push(A[0]) : k.push(A);
                    }
                    for(T && (k = [
                        k
                    ]), a = 0; a < k.length; a++){
                        var M = 1 / 0;
                        for(o = 0; o < k[a].length; o++){
                            var S = k[a][o].trace.legendrank;
                            M > S && (M = S);
                        }
                        k[a][0]._groupMinRank = M, k[a][0]._preGroupSort = a;
                    }
                    var E = function(t1, e1) {
                        return t1.trace.legendrank - e1.trace.legendrank || t1._preSort - e1._preSort;
                    };
                    for(k.forEach(function(t1, e1) {
                        t1[0]._preGroupSort = e1;
                    }), k.sort(function(t1, e1) {
                        return t1[0]._groupMinRank - e1[0]._groupMinRank || t1[0]._preGroupSort - e1[0]._preGroupSort;
                    }), a = 0; a < k.length; a++){
                        k[a].forEach(function(t1, e1) {
                            t1._preSort = e1;
                        }), k[a].sort(E);
                        var C = k[a][0].trace, L = null;
                        for(o = 0; o < k[a].length; o++){
                            var I = k[a][o].trace.legendgrouptitle;
                            if (I && I.text) {
                                L = I, s && (I.font = e1._groupTitleFont);
                                break;
                            }
                        }
                        if (c && k[a].reverse(), L) {
                            var P = !1;
                            for(o = 0; o < k[a].length; o++)if (n.traceIs(k[a][o].trace, "pie-like")) {
                                P = !0;
                                break;
                            }
                            k[a].unshift({
                                i: -1,
                                groupTitle: L,
                                noClick: P,
                                trace: {
                                    showlegend: C.showlegend,
                                    legendgroup: C.legendgroup,
                                    visible: "toggleitem" === e1.groupclick || C.visible
                                }
                            });
                        }
                        for(o = 0; o < k[a].length; o++)k[a][o] = [
                            k[a][o]
                        ];
                    }
                    return e1._lgroupsLength = k.length, e1._maxNameLength = m, k;
                };
            },
            22165: function(t1, e1, r) {
                "use strict";
                var n = r(33626), i = r(34809), a = i.pushUnique, o = !0;
                t1.exports = function(t1, e1, r) {
                    var s = e1._fullLayout;
                    if (!e1._dragged && !e1._editing) {
                        var l, c = s.legend.itemclick, u = s.legend.itemdoubleclick, h = s.legend.groupclick;
                        if (1 === r && "toggle" === c && "toggleothers" === u && o && e1.data && e1._context.showTips ? (i.notifier(i._(e1, "Double-click on legend to isolate one trace"), "long"), o = !1) : o = !1, 1 === r ? l = c : 2 === r && (l = u), l) {
                            var f = "togglegroup" === h, p = s.hiddenlabels ? s.hiddenlabels.slice() : [], d = t1.data()[0][0];
                            if (!d.groupTitle || !d.noClick) {
                                var m = e1._fullData, g = (s.shapes || []).filter(function(t1) {
                                    return t1.showlegend;
                                }), y = m.concat(g), v = d.trace;
                                v._isShape && (v = v._fullInput);
                                var x, _, b, w, T, k = v.legendgroup, A = {}, M = [], S = [], E = [], C = (s.shapes || []).map(function(t1) {
                                    return t1._input;
                                }), L = !1, I = v.legend, P = v._fullInput;
                                if (P && P._isShape || !n.traceIs(v, "pie-like")) {
                                    var z, O = k && k.length, D = [];
                                    if (O) for(x = 0; x < y.length; x++)(z = y[x]).visible && z.legendgroup === k && D.push(x);
                                    if ("toggle" === l) {
                                        var R;
                                        switch(v.visible){
                                            case !0:
                                                R = "legendonly";
                                                break;
                                            case !1:
                                                R = !1;
                                                break;
                                            case "legendonly":
                                                R = !0;
                                        }
                                        if (O) {
                                            if (f) for(x = 0; x < y.length; x++){
                                                var F = y[x];
                                                !1 !== F.visible && F.legendgroup === k && tt(F, R);
                                            }
                                            else tt(v, R);
                                        } else tt(v, R);
                                    } else if ("toggleothers" === l) {
                                        var B, N, j, U, V = !0;
                                        for(x = 0; x < y.length; x++)if (B = (U = y[x]) === v, N = !0 !== U.showlegend, !(B || N || O && U.legendgroup === k || U.legend !== I || !0 !== U.visible || n.traceIs(U, "notLegendIsolatable"))) {
                                            V = !1;
                                            break;
                                        }
                                        for(x = 0; x < y.length; x++)if (!1 !== (U = y[x]).visible && U.legend === I && !n.traceIs(U, "notLegendIsolatable")) switch(v.visible){
                                            case "legendonly":
                                                tt(U, !0);
                                                break;
                                            case !0:
                                                j = !!V || "legendonly", B = U === v, N = !0 !== U.showlegend && !U.legendgroup, tt(U, !!(B || O && U.legendgroup === k || N) || j);
                                        }
                                    }
                                    for(x = 0; x < S.length; x++)if (b = S[x]) {
                                        var q = b.constructUpdate(), H = Object.keys(q);
                                        for(_ = 0; _ < H.length; _++)w = H[_], (A[w] = A[w] || [])[E[x]] = q[w];
                                    }
                                    for(T = Object.keys(A), x = 0; x < T.length; x++)for(w = T[x], _ = 0; _ < M.length; _++)A[w].hasOwnProperty(_) || (A[w][_] = void 0);
                                    L ? n.call("_guiUpdate", e1, A, {
                                        shapes: C
                                    }, M) : n.call("_guiRestyle", e1, A, M);
                                } else {
                                    var G = d.label, Z = p.indexOf(G);
                                    if ("toggle" === l) -1 === Z ? p.push(G) : p.splice(Z, 1);
                                    else if ("toggleothers" === l) {
                                        var W = -1 !== Z, Y = [];
                                        for(x = 0; x < e1.calcdata.length; x++){
                                            var X = e1.calcdata[x];
                                            for(_ = 0; _ < X.length; _++){
                                                var $ = X[_].label;
                                                I === X[0].trace.legend && G !== $ && (-1 === p.indexOf($) && (W = !0), a(p, $), Y.push($));
                                            }
                                        }
                                        if (!W) for(var J = 0; J < Y.length; J++){
                                            var K = p.indexOf(Y[J]);
                                            -1 !== K && p.splice(K, 1);
                                        }
                                    }
                                    n.call("_guiRelayout", e1, "hiddenlabels", p);
                                }
                            }
                        }
                    }
                    function Q(t1, e1) {
                        var r = M.indexOf(t1), n = A.visible;
                        return n || (n = A.visible = []), -1 === M.indexOf(t1) && (M.push(t1), r = M.length - 1), n[r] = e1, r;
                    }
                    function tt(t1, e1) {
                        if (!d.groupTitle || f) {
                            var r, a = t1._fullInput || t1, o = a._isShape, s = a.index;
                            if (void 0 === s && (s = a._index), n.hasTransform(a, "groupby")) {
                                var l = S[s];
                                if (!l) {
                                    var c = n.getTransformIndices(a, "groupby"), u = c[c.length - 1];
                                    l = i.keyedContainer(a, "transforms[" + u + "].styles", "target", "value.visible"), S[s] = l;
                                }
                                var h = l.get(t1._group);
                                void 0 === h && (h = !0), !1 !== h && l.set(t1._group, e1), E[s] = Q(s, !1 !== a.visible);
                            } else {
                                var p = !1 !== a.visible && e1;
                                o ? (r = p, C[s].visible = r, L = !0) : Q(s, p);
                            }
                        }
                    }
                };
            },
            57599: function(t1, e1) {
                "use strict";
                e1.isGrouped = function(t1) {
                    return -1 !== (t1.traceorder || "").indexOf("grouped");
                }, e1.isVertical = function(t1) {
                    return "h" !== t1.orientation;
                }, e1.isReversed = function(t1) {
                    return -1 !== (t1.traceorder || "").indexOf("reversed");
                };
            },
            82494: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    moduleType: "component",
                    name: "legend",
                    layoutAttributes: r(86405),
                    supplyLayoutDefaults: r(73970),
                    draw: r(6134),
                    style: r(14375)
                };
            },
            14375: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(33626), a = r(34809), o = a.strTranslate, s = r(62203), l = r(78766), c = r(65477).extractOpts, u = r(64726), h = r(32891), f = r(37252).castOption, p = r(72783);
                function d(t1, e1) {
                    return (e1 ? "radial" : "horizontal") + (t1 ? "" : "reversed");
                }
                function m(t1) {
                    var e1 = t1[0].trace, r = e1.contours, n = u.hasLines(e1), i = u.hasMarkers(e1), a = e1.visible && e1.fill && "none" !== e1.fill, o = !1, s = !1;
                    if (r) {
                        var l = r.coloring;
                        "lines" === l ? o = !0 : n = "none" === l || "heatmap" === l || r.showlines, "constraint" === r.type ? a = "=" !== r._operation : "fill" !== l && "heatmap" !== l || (s = !0);
                    }
                    return {
                        showMarker: i,
                        showLine: n,
                        showFill: a,
                        showGradientLine: o,
                        showGradientFill: s,
                        anyLine: n || o,
                        anyFill: a || s
                    };
                }
                function g(t1, e1, r) {
                    return t1 && a.isArrayOrTypedArray(t1) ? e1 : t1 > r ? r : t1;
                }
                t1.exports = function(t1, e1, r) {
                    var y = e1._fullLayout;
                    r || (r = y.legend);
                    var v = "constant" === r.itemsizing, x = r.itemwidth, _ = (x + 2 * p.itemGap) / 2, b = o(_, 0), w = function(t1, e1, r, n) {
                        var i;
                        if (t1 + 1) i = t1;
                        else {
                            if (!(e1 && e1.width > 0)) return 0;
                            i = e1.width;
                        }
                        return v ? n : Math.min(i, r);
                    };
                    function T(t1, a, o) {
                        var u = t1[0].trace, h = u.marker || {}, f = h.line || {}, p = h.cornerradius ? "M6,3a3,3,0,0,1-3,3H-3a3,3,0,0,1-3-3V-3a3,3,0,0,1,3-3H3a3,3,0,0,1,3,3Z" : "M6,6H-6V-6H6Z", d = o ? u.visible && u.type === o : i.traceIs(u, "bar"), m = n.select(a).select("g.legendpoints").selectAll("path.legend" + o).data(d ? [
                            t1
                        ] : []);
                        m.enter().append("path").classed("legend" + o, !0).attr("d", p).attr("transform", b), m.exit().remove(), m.each(function(t1) {
                            var i = n.select(this), a = t1[0], o = w(a.mlw, h.line, 5, 2);
                            i.style("stroke-width", o + "px");
                            var p = a.mcc;
                            if (!r._inHover && "mc" in a) {
                                var d = c(h), m = d.mid;
                                void 0 === m && (m = (d.max + d.min) / 2), p = s.tryColorscale(h, "")(m);
                            }
                            var y = p || a.mc || h.color, v = h.pattern, x = v && s.getPatternAttr(v.shape, 0, "");
                            if (x) {
                                var _ = s.getPatternAttr(v.bgcolor, 0, null), b = s.getPatternAttr(v.fgcolor, 0, null), T = v.fgopacity, k = g(v.size, 8, 10), A = g(v.solidity, .5, 1), M = "legend-" + u.uid;
                                i.call(s.pattern, "legend", e1, M, x, k, A, p, v.fillmode, _, b, T);
                            } else i.call(l.fill, y);
                            o && l.stroke(i, a.mlc || f.color);
                        });
                    }
                    function k(t1, r, o) {
                        var s = t1[0], l = s.trace, c = o ? l.visible && l.type === o : i.traceIs(l, o), u = n.select(r).select("g.legendpoints").selectAll("path.legend" + o).data(c ? [
                            t1
                        ] : []);
                        if (u.enter().append("path").classed("legend" + o, !0).attr("d", "M6,6H-6V-6H6Z").attr("transform", b), u.exit().remove(), u.size()) {
                            var p = l.marker || {}, d = w(f(p.line.width, s.pts), p.line, 5, 2), m = "pieLike", g = a.minExtend(l, {
                                marker: {
                                    line: {
                                        width: d
                                    }
                                }
                            }, m), y = a.minExtend(s, {
                                trace: g
                            }, m);
                            h(u, y, g, e1);
                        }
                    }
                    t1.each(function(t1) {
                        var e1 = n.select(this), i = a.ensureSingle(e1, "g", "layers");
                        i.style("opacity", t1[0].trace.opacity);
                        var s = r.indentation, l = r.valign, c = t1[0].lineHeight, u = t1[0].height;
                        if ("middle" === l && 0 === s || !c || !u) i.attr("transform", null);
                        else {
                            var h = {
                                top: 1,
                                bottom: -1
                            }[l] * (.5 * (c - u + 3)) || 0, f = r.indentation;
                            i.attr("transform", o(f, h));
                        }
                        i.selectAll("g.legendfill").data([
                            t1
                        ]).enter().append("g").classed("legendfill", !0), i.selectAll("g.legendlines").data([
                            t1
                        ]).enter().append("g").classed("legendlines", !0);
                        var p = i.selectAll("g.legendsymbols").data([
                            t1
                        ]);
                        p.enter().append("g").classed("legendsymbols", !0), p.selectAll("g.legendpoints").data([
                            t1
                        ]).enter().append("g").classed("legendpoints", !0);
                    }).each(function(t1) {
                        var r, i = t1[0].trace, o = [];
                        if (i.visible) switch(i.type){
                            case "histogram2d":
                            case "heatmap":
                                o = [
                                    [
                                        "M-15,-2V4H15V-2Z"
                                    ]
                                ], r = !0;
                                break;
                            case "choropleth":
                            case "choroplethmapbox":
                            case "choroplethmap":
                                o = [
                                    [
                                        "M-6,-6V6H6V-6Z"
                                    ]
                                ], r = !0;
                                break;
                            case "densitymapbox":
                            case "densitymap":
                                o = [
                                    [
                                        "M-6,0 a6,6 0 1,0 12,0 a 6,6 0 1,0 -12,0"
                                    ]
                                ], r = "radial";
                                break;
                            case "cone":
                                o = [
                                    [
                                        "M-6,2 A2,2 0 0,0 -6,6 V6L6,4Z"
                                    ],
                                    [
                                        "M-6,-6 A2,2 0 0,0 -6,-2 L6,-4Z"
                                    ],
                                    [
                                        "M-6,-2 A2,2 0 0,0 -6,2 L6,0Z"
                                    ]
                                ], r = !1;
                                break;
                            case "streamtube":
                                o = [
                                    [
                                        "M-6,2 A2,2 0 0,0 -6,6 H6 A2,2 0 0,1 6,2 Z"
                                    ],
                                    [
                                        "M-6,-6 A2,2 0 0,0 -6,-2 H6 A2,2 0 0,1 6,-6 Z"
                                    ],
                                    [
                                        "M-6,-2 A2,2 0 0,0 -6,2 H6 A2,2 0 0,1 6,-2 Z"
                                    ]
                                ], r = !1;
                                break;
                            case "surface":
                                o = [
                                    [
                                        "M-6,-6 A2,3 0 0,0 -6,0 H6 A2,3 0 0,1 6,-6 Z"
                                    ],
                                    [
                                        "M-6,1 A2,3 0 0,1 -6,6 H6 A2,3 0 0,0 6,0 Z"
                                    ]
                                ], r = !0;
                                break;
                            case "mesh3d":
                                o = [
                                    [
                                        "M-6,6H0L-6,-6Z"
                                    ],
                                    [
                                        "M6,6H0L6,-6Z"
                                    ],
                                    [
                                        "M-6,-6H6L0,6Z"
                                    ]
                                ], r = !1;
                                break;
                            case "volume":
                                o = [
                                    [
                                        "M-6,6H0L-6,-6Z"
                                    ],
                                    [
                                        "M6,6H0L6,-6Z"
                                    ],
                                    [
                                        "M-6,-6H6L0,6Z"
                                    ]
                                ], r = !0;
                                break;
                            case "isosurface":
                                o = [
                                    [
                                        "M-6,6H0L-6,-6Z"
                                    ],
                                    [
                                        "M6,6H0L6,-6Z"
                                    ],
                                    [
                                        "M-6,-6 A12,24 0 0,0 6,-6 L0,6Z"
                                    ]
                                ], r = !1;
                        }
                        var u = n.select(this).select("g.legendpoints").selectAll("path.legend3dandfriends").data(o);
                        u.enter().append("path").classed("legend3dandfriends", !0).attr("transform", b).style("stroke-miterlimit", 1), u.exit().remove(), u.each(function(t1, o) {
                            var u, h = n.select(this), f = c(i), p = f.colorscale, m = f.reversescale;
                            if (p) {
                                if (!r) {
                                    var g = p.length;
                                    u = 0 === o ? p[m ? g - 1 : 0][1] : 1 === o ? p[m ? 0 : g - 1][1] : p[Math.floor((g - 1) / 2)][1];
                                }
                            } else {
                                var y = i.vertexcolor || i.facecolor || i.color;
                                u = a.isArrayOrTypedArray(y) ? y[o] || y[0] : y;
                            }
                            h.attr("d", t1[0]), u ? h.call(l.fill, u) : h.call(function(t1) {
                                if (t1.size()) {
                                    var n = "legendfill-" + i.uid;
                                    s.gradient(t1, e1, n, d(m, "radial" === r), p, "fill");
                                }
                            });
                        });
                    }).each(function(t1) {
                        var e1 = t1[0].trace, r = "waterfall" === e1.type;
                        if (t1[0]._distinct && r) {
                            var i = t1[0].trace[t1[0].dir].marker;
                            return t1[0].mc = i.color, t1[0].mlw = i.line.width, t1[0].mlc = i.line.color, T(t1, this, "waterfall");
                        }
                        var a = [];
                        e1.visible && r && (a = t1[0].hasTotals ? [
                            [
                                "increasing",
                                "M-6,-6V6H0Z"
                            ],
                            [
                                "totals",
                                "M6,6H0L-6,-6H-0Z"
                            ],
                            [
                                "decreasing",
                                "M6,6V-6H0Z"
                            ]
                        ] : [
                            [
                                "increasing",
                                "M-6,-6V6H6Z"
                            ],
                            [
                                "decreasing",
                                "M6,6V-6H-6Z"
                            ]
                        ]);
                        var o = n.select(this).select("g.legendpoints").selectAll("path.legendwaterfall").data(a);
                        o.enter().append("path").classed("legendwaterfall", !0).attr("transform", b).style("stroke-miterlimit", 1), o.exit().remove(), o.each(function(t1) {
                            var r = n.select(this), i = e1[t1[0]].marker, a = w(void 0, i.line, 5, 2);
                            r.attr("d", t1[1]).style("stroke-width", a + "px").call(l.fill, i.color), a && r.call(l.stroke, i.line.color);
                        });
                    }).each(function(t1) {
                        T(t1, this, "funnel");
                    }).each(function(t1) {
                        T(t1, this);
                    }).each(function(t1) {
                        var r = t1[0].trace, o = n.select(this).select("g.legendpoints").selectAll("path.legendbox").data(r.visible && i.traceIs(r, "box-violin") ? [
                            t1
                        ] : []);
                        o.enter().append("path").classed("legendbox", !0).attr("d", "M6,6H-6V-6H6Z").attr("transform", b), o.exit().remove(), o.each(function() {
                            var t1 = n.select(this);
                            if ("all" !== r.boxpoints && "all" !== r.points || 0 !== l.opacity(r.fillcolor) || 0 !== l.opacity((r.line || {}).color)) {
                                var i = w(void 0, r.line, 5, 2);
                                t1.style("stroke-width", i + "px").call(l.fill, r.fillcolor), i && l.stroke(t1, r.line.color);
                            } else {
                                var c = a.minExtend(r, {
                                    marker: {
                                        size: v ? 12 : a.constrain(r.marker.size, 2, 16),
                                        sizeref: 1,
                                        sizemin: 1,
                                        sizemode: "diameter"
                                    }
                                });
                                o.call(s.pointStyle, c, e1);
                            }
                        });
                    }).each(function(t1) {
                        k(t1, this, "funnelarea");
                    }).each(function(t1) {
                        k(t1, this, "pie");
                    }).each(function(t1) {
                        var r, i, o = m(t1), l = o.showFill, h = o.showLine, f = o.showGradientLine, p = o.showGradientFill, g = o.anyFill, y = o.anyLine, v = t1[0], _ = v.trace, b = c(_), T = b.colorscale, k = b.reversescale, A = u.hasMarkers(_) || !g ? "M5,0" : y ? "M5,-2" : "M5,-3", M = n.select(this), S = M.select(".legendfill").selectAll("path").data(l || p ? [
                            t1
                        ] : []);
                        if (S.enter().append("path").classed("js-fill", !0), S.exit().remove(), S.attr("d", A + "h" + x + "v6h-" + x + "z").call(function(t1) {
                            if (t1.size()) {
                                if (l) s.fillGroupStyle(t1, e1, !0);
                                else {
                                    var r = "legendfill-" + _.uid;
                                    s.gradient(t1, e1, r, d(k), T, "fill");
                                }
                            }
                        }), h || f) {
                            var E = w(void 0, _.line, 10, 5);
                            i = a.minExtend(_, {
                                line: {
                                    width: E
                                }
                            }), r = [
                                a.minExtend(v, {
                                    trace: i
                                })
                            ];
                        }
                        var C = M.select(".legendlines").selectAll("path").data(h || f ? [
                            r
                        ] : []);
                        C.enter().append("path").classed("js-line", !0), C.exit().remove(), C.attr("d", A + (f ? "l" + x + ",0.0001" : "h" + x)).call(h ? s.lineGroupStyle : function(t1) {
                            if (t1.size()) {
                                var r = "legendline-" + _.uid;
                                s.lineGroupStyle(t1), s.gradient(t1, e1, r, d(k), T, "stroke");
                            }
                        });
                    }).each(function(t1) {
                        var r, i, o = m(t1), l = o.anyFill, c = o.anyLine, h = o.showLine, f = o.showMarker, p = t1[0], d = p.trace, g = !f && !c && !l && u.hasText(d);
                        function y(t1, e1, r, n) {
                            var i = a.nestedProperty(d, t1).get(), o = a.isArrayOrTypedArray(i) && e1 ? e1(i) : i;
                            if (v && o && void 0 !== n && (o = n), r) {
                                if (o < r[0]) return r[0];
                                if (o > r[1]) return r[1];
                            }
                            return o;
                        }
                        function x(t1) {
                            return p._distinct && p.index && t1[p.index] ? t1[p.index] : t1[0];
                        }
                        if (f || g || h) {
                            var _ = {}, w = {};
                            if (f) {
                                _.mc = y("marker.color", x), _.mx = y("marker.symbol", x), _.mo = y("marker.opacity", a.mean, [
                                    .2,
                                    1
                                ]), _.mlc = y("marker.line.color", x), _.mlw = y("marker.line.width", a.mean, [
                                    0,
                                    5
                                ], 2), w.marker = {
                                    sizeref: 1,
                                    sizemin: 1,
                                    sizemode: "diameter"
                                };
                                var T = y("marker.size", a.mean, [
                                    2,
                                    16
                                ], 12);
                                _.ms = T, w.marker.size = T;
                            }
                            h && (w.line = {
                                width: y("line.width", x, [
                                    0,
                                    10
                                ], 5)
                            }), g && (_.tx = "Aa", _.tp = y("textposition", x), _.ts = 10, _.tc = y("textfont.color", x), _.tf = y("textfont.family", x), _.tw = y("textfont.weight", x), _.ty = y("textfont.style", x), _.tv = y("textfont.variant", x), _.tC = y("textfont.textcase", x), _.tE = y("textfont.lineposition", x), _.tS = y("textfont.shadow", x)), r = [
                                a.minExtend(p, _)
                            ], (i = a.minExtend(d, w)).selectedpoints = null, i.texttemplate = null;
                        }
                        var k = n.select(this).select("g.legendpoints"), A = k.selectAll("path.scatterpts").data(f ? r : []);
                        A.enter().insert("path", ":first-child").classed("scatterpts", !0).attr("transform", b), A.exit().remove(), A.call(s.pointStyle, i, e1), f && (r[0].mrc = 3);
                        var M = k.selectAll("g.pointtext").data(g ? r : []);
                        M.enter().append("g").classed("pointtext", !0).append("text").attr("transform", b), M.exit().remove(), M.selectAll("text").call(s.textPointStyle, i, e1);
                    }).each(function(t1) {
                        var e1 = t1[0].trace, r = n.select(this).select("g.legendpoints").selectAll("path.legendcandle").data(e1.visible && "candlestick" === e1.type ? [
                            t1,
                            t1
                        ] : []);
                        r.enter().append("path").classed("legendcandle", !0).attr("d", function(t1, e1) {
                            return e1 ? "M-15,0H-8M-8,6V-6H8Z" : "M15,0H8M8,-6V6H-8Z";
                        }).attr("transform", b).style("stroke-miterlimit", 1), r.exit().remove(), r.each(function(t1, r) {
                            var i = n.select(this), a = e1[r ? "increasing" : "decreasing"], o = w(void 0, a.line, 5, 2);
                            i.style("stroke-width", o + "px").call(l.fill, a.fillcolor), o && l.stroke(i, a.line.color);
                        });
                    }).each(function(t1) {
                        var e1 = t1[0].trace, r = n.select(this).select("g.legendpoints").selectAll("path.legendohlc").data(e1.visible && "ohlc" === e1.type ? [
                            t1,
                            t1
                        ] : []);
                        r.enter().append("path").classed("legendohlc", !0).attr("d", function(t1, e1) {
                            return e1 ? "M-15,0H0M-8,-6V0" : "M15,0H0M8,6V0";
                        }).attr("transform", b).style("stroke-miterlimit", 1), r.exit().remove(), r.each(function(t1, r) {
                            var i = n.select(this), a = e1[r ? "increasing" : "decreasing"], o = w(void 0, a.line, 5, 2);
                            i.style("fill", "none").call(s.dashLine, a.line.dash, o), o && l.stroke(i, a.line.color);
                        });
                    });
                };
            },
            50308: function(t1, e1, r) {
                "use strict";
                r(87632), t1.exports = {
                    editType: "modebar",
                    orientation: {
                        valType: "enumerated",
                        values: [
                            "v",
                            "h"
                        ],
                        dflt: "h",
                        editType: "modebar"
                    },
                    bgcolor: {
                        valType: "color",
                        editType: "modebar"
                    },
                    color: {
                        valType: "color",
                        editType: "modebar"
                    },
                    activecolor: {
                        valType: "color",
                        editType: "modebar"
                    },
                    uirevision: {
                        valType: "any",
                        editType: "none"
                    },
                    add: {
                        valType: "string",
                        arrayOk: !0,
                        dflt: "",
                        editType: "modebar"
                    },
                    remove: {
                        valType: "string",
                        arrayOk: !0,
                        dflt: "",
                        editType: "modebar"
                    }
                };
            },
            5832: function(t1, e1, r) {
                "use strict";
                var n = r(33626), i = r(44122), a = r(5975), o = r(35188), s = r(28231).eraseActiveShape, l = r(34809), c = l._, u = t1.exports = {};
                function h(t1, e1) {
                    var r, i, o = e1.currentTarget, s = o.getAttribute("data-attr"), l = o.getAttribute("data-val") || !0, c = t1._fullLayout, u = {}, h = a.list(t1, null, !0), f = c._cartesianSpikesEnabled;
                    if ("zoom" === s) {
                        var p, d = "in" === l ? .5 : 2, m = (1 + d) / 2, g = (1 - d) / 2;
                        for(i = 0; i < h.length; i++)if (!(r = h[i]).fixedrange) {
                            if (p = r._name, "auto" === l) u[p + ".autorange"] = !0;
                            else if ("reset" === l) void 0 === r._rangeInitial0 && void 0 === r._rangeInitial1 ? u[p + ".autorange"] = !0 : void 0 === r._rangeInitial0 ? (u[p + ".autorange"] = r._autorangeInitial, u[p + ".range"] = [
                                null,
                                r._rangeInitial1
                            ]) : void 0 === r._rangeInitial1 ? (u[p + ".range"] = [
                                r._rangeInitial0,
                                null
                            ], u[p + ".autorange"] = r._autorangeInitial) : u[p + ".range"] = [
                                r._rangeInitial0,
                                r._rangeInitial1
                            ], void 0 !== r._showSpikeInitial && (u[p + ".showspikes"] = r._showSpikeInitial, "on" !== f || r._showSpikeInitial || (f = "off"));
                            else {
                                var y = [
                                    r.r2l(r.range[0]),
                                    r.r2l(r.range[1])
                                ], v = [
                                    m * y[0] + g * y[1],
                                    m * y[1] + g * y[0]
                                ];
                                u[p + ".range[0]"] = r.l2r(v[0]), u[p + ".range[1]"] = r.l2r(v[1]);
                            }
                        }
                    } else "hovermode" !== s || "x" !== l && "y" !== l || (l = c._isHoriz ? "y" : "x", o.setAttribute("data-val", l)), u[s] = l;
                    c._cartesianSpikesEnabled = f, n.call("_guiRelayout", t1, u);
                }
                function f(t1, e1) {
                    for(var r = e1.currentTarget, i = r.getAttribute("data-attr"), a = r.getAttribute("data-val") || !0, o = t1._fullLayout._subplots.gl3d || [], s = {}, l = i.split("."), c = 0; c < o.length; c++)s[o[c] + "." + l[1]] = a;
                    var u = "pan" === a ? a : "zoom";
                    s.dragmode = u, n.call("_guiRelayout", t1, s);
                }
                function p(t1, e1) {
                    for(var r = e1.currentTarget.getAttribute("data-attr"), i = "resetLastSave" === r, a = "resetDefault" === r, o = t1._fullLayout, s = o._subplots.gl3d || [], l = {}, c = 0; c < s.length; c++){
                        var u, h = s[c], f = h + ".camera", p = h + ".aspectratio", d = h + ".aspectmode", m = o[h]._scene;
                        i ? (l[f + ".up"] = m.viewInitial.up, l[f + ".eye"] = m.viewInitial.eye, l[f + ".center"] = m.viewInitial.center, u = !0) : a && (l[f + ".up"] = null, l[f + ".eye"] = null, l[f + ".center"] = null, u = !0), u && (l[p + ".x"] = m.viewInitial.aspectratio.x, l[p + ".y"] = m.viewInitial.aspectratio.y, l[p + ".z"] = m.viewInitial.aspectratio.z, l[d] = m.viewInitial.aspectmode);
                    }
                    n.call("_guiRelayout", t1, l);
                }
                function d(t1, e1) {
                    var r = e1.currentTarget, n = r._previousVal, i = t1._fullLayout, a = i._subplots.gl3d || [], o = [
                        "xaxis",
                        "yaxis",
                        "zaxis"
                    ], s = {}, l = {};
                    if (n) l = n, r._previousVal = null;
                    else {
                        for(var c = 0; c < a.length; c++){
                            var u = a[c], h = i[u], f = u + ".hovermode";
                            s[f] = h.hovermode, l[f] = !1;
                            for(var p = 0; p < 3; p++){
                                var d = o[p], m = u + "." + d + ".showspikes";
                                l[m] = !1, s[m] = h[d].showspikes;
                            }
                        }
                        r._previousVal = s;
                    }
                    return l;
                }
                function m(t1, e1) {
                    for(var r = e1.currentTarget, i = r.getAttribute("data-attr"), a = r.getAttribute("data-val") || !0, o = t1._fullLayout, s = o._subplots.geo || [], l = 0; l < s.length; l++){
                        var c = s[l], u = o[c];
                        if ("zoom" === i) {
                            var h = u.projection.scale, f = "in" === a ? 2 * h : .5 * h;
                            n.call("_guiRelayout", t1, c + ".projection.scale", f);
                        }
                    }
                    "reset" === i && b(t1, "geo");
                }
                function g(t1) {
                    var e1 = t1._fullLayout;
                    return !e1.hovermode && (e1._has("cartesian") ? e1._isHoriz ? "y" : "x" : "closest");
                }
                function y(t1) {
                    var e1 = g(t1);
                    n.call("_guiRelayout", t1, "hovermode", e1);
                }
                function v(t1, e1) {
                    _(t1, e1, "mapbox");
                }
                function x(t1, e1) {
                    _(t1, e1, "map");
                }
                function _(t1, e1, r) {
                    for(var i = e1.currentTarget.getAttribute("data-val"), a = t1._fullLayout, o = a._subplots[r] || [], s = {}, l = 0; l < o.length; l++){
                        var c = o[l], u = a[c].zoom, h = "in" === i ? 1.05 * u : u / 1.05;
                        s[c + ".zoom"] = h;
                    }
                    n.call("_guiRelayout", t1, s);
                }
                function b(t1, e1) {
                    for(var r = t1._fullLayout, i = r._subplots[e1] || [], a = {}, o = 0; o < i.length; o++)for(var s = i[o], l = r[s]._subplot.viewInitial, c = Object.keys(l), u = 0; u < c.length; u++){
                        var h = c[u];
                        a[s + "." + h] = l[h];
                    }
                    n.call("_guiRelayout", t1, a);
                }
                u.toImage = {
                    name: "toImage",
                    title: function(t1) {
                        var e1 = (t1._context.toImageButtonOptions || {}).format || "png";
                        return c(t1, "png" === e1 ? "Download plot as a png" : "Download plot");
                    },
                    icon: o.camera,
                    click: function(t1) {
                        var e1 = t1._context.toImageButtonOptions, r = {
                            format: e1.format || "png"
                        };
                        l.notifier(c(t1, "Taking snapshot - this may take a few seconds"), "long"), "svg" !== r.format && l.isIE() && (l.notifier(c(t1, "IE only supports svg.  Changing format to svg."), "long"), r.format = "svg"), [
                            "filename",
                            "width",
                            "height",
                            "scale"
                        ].forEach(function(t1) {
                            t1 in e1 && (r[t1] = e1[t1]);
                        }), n.call("downloadImage", t1, r).then(function(e1) {
                            l.notifier(c(t1, "Snapshot succeeded") + " - " + e1, "long");
                        }).catch(function() {
                            l.notifier(c(t1, "Sorry, there was a problem downloading your snapshot!"), "long");
                        });
                    }
                }, u.sendDataToCloud = {
                    name: "sendDataToCloud",
                    title: function(t1) {
                        return c(t1, "Edit in Chart Studio");
                    },
                    icon: o.disk,
                    click: function(t1) {
                        i.sendDataToCloud(t1);
                    }
                }, u.editInChartStudio = {
                    name: "editInChartStudio",
                    title: function(t1) {
                        return c(t1, "Edit in Chart Studio");
                    },
                    icon: o.pencil,
                    click: function(t1) {
                        i.sendDataToCloud(t1);
                    }
                }, u.zoom2d = {
                    name: "zoom2d",
                    _cat: "zoom",
                    title: function(t1) {
                        return c(t1, "Zoom");
                    },
                    attr: "dragmode",
                    val: "zoom",
                    icon: o.zoombox,
                    click: h
                }, u.pan2d = {
                    name: "pan2d",
                    _cat: "pan",
                    title: function(t1) {
                        return c(t1, "Pan");
                    },
                    attr: "dragmode",
                    val: "pan",
                    icon: o.pan,
                    click: h
                }, u.select2d = {
                    name: "select2d",
                    _cat: "select",
                    title: function(t1) {
                        return c(t1, "Box Select");
                    },
                    attr: "dragmode",
                    val: "select",
                    icon: o.selectbox,
                    click: h
                }, u.lasso2d = {
                    name: "lasso2d",
                    _cat: "lasso",
                    title: function(t1) {
                        return c(t1, "Lasso Select");
                    },
                    attr: "dragmode",
                    val: "lasso",
                    icon: o.lasso,
                    click: h
                }, u.drawclosedpath = {
                    name: "drawclosedpath",
                    title: function(t1) {
                        return c(t1, "Draw closed freeform");
                    },
                    attr: "dragmode",
                    val: "drawclosedpath",
                    icon: o.drawclosedpath,
                    click: h
                }, u.drawopenpath = {
                    name: "drawopenpath",
                    title: function(t1) {
                        return c(t1, "Draw open freeform");
                    },
                    attr: "dragmode",
                    val: "drawopenpath",
                    icon: o.drawopenpath,
                    click: h
                }, u.drawline = {
                    name: "drawline",
                    title: function(t1) {
                        return c(t1, "Draw line");
                    },
                    attr: "dragmode",
                    val: "drawline",
                    icon: o.drawline,
                    click: h
                }, u.drawrect = {
                    name: "drawrect",
                    title: function(t1) {
                        return c(t1, "Draw rectangle");
                    },
                    attr: "dragmode",
                    val: "drawrect",
                    icon: o.drawrect,
                    click: h
                }, u.drawcircle = {
                    name: "drawcircle",
                    title: function(t1) {
                        return c(t1, "Draw circle");
                    },
                    attr: "dragmode",
                    val: "drawcircle",
                    icon: o.drawcircle,
                    click: h
                }, u.eraseshape = {
                    name: "eraseshape",
                    title: function(t1) {
                        return c(t1, "Erase active shape");
                    },
                    icon: o.eraseshape,
                    click: s
                }, u.zoomIn2d = {
                    name: "zoomIn2d",
                    _cat: "zoomin",
                    title: function(t1) {
                        return c(t1, "Zoom in");
                    },
                    attr: "zoom",
                    val: "in",
                    icon: o.zoom_plus,
                    click: h
                }, u.zoomOut2d = {
                    name: "zoomOut2d",
                    _cat: "zoomout",
                    title: function(t1) {
                        return c(t1, "Zoom out");
                    },
                    attr: "zoom",
                    val: "out",
                    icon: o.zoom_minus,
                    click: h
                }, u.autoScale2d = {
                    name: "autoScale2d",
                    _cat: "autoscale",
                    title: function(t1) {
                        return c(t1, "Autoscale");
                    },
                    attr: "zoom",
                    val: "auto",
                    icon: o.autoscale,
                    click: h
                }, u.resetScale2d = {
                    name: "resetScale2d",
                    _cat: "resetscale",
                    title: function(t1) {
                        return c(t1, "Reset axes");
                    },
                    attr: "zoom",
                    val: "reset",
                    icon: o.home,
                    click: h
                }, u.hoverClosestCartesian = {
                    name: "hoverClosestCartesian",
                    _cat: "hoverclosest",
                    title: function(t1) {
                        return c(t1, "Show closest data on hover");
                    },
                    attr: "hovermode",
                    val: "closest",
                    icon: o.tooltip_basic,
                    gravity: "ne",
                    click: h
                }, u.hoverCompareCartesian = {
                    name: "hoverCompareCartesian",
                    _cat: "hoverCompare",
                    title: function(t1) {
                        return c(t1, "Compare data on hover");
                    },
                    attr: "hovermode",
                    val: function(t1) {
                        return t1._fullLayout._isHoriz ? "y" : "x";
                    },
                    icon: o.tooltip_compare,
                    gravity: "ne",
                    click: h
                }, u.zoom3d = {
                    name: "zoom3d",
                    _cat: "zoom",
                    title: function(t1) {
                        return c(t1, "Zoom");
                    },
                    attr: "scene.dragmode",
                    val: "zoom",
                    icon: o.zoombox,
                    click: f
                }, u.pan3d = {
                    name: "pan3d",
                    _cat: "pan",
                    title: function(t1) {
                        return c(t1, "Pan");
                    },
                    attr: "scene.dragmode",
                    val: "pan",
                    icon: o.pan,
                    click: f
                }, u.orbitRotation = {
                    name: "orbitRotation",
                    title: function(t1) {
                        return c(t1, "Orbital rotation");
                    },
                    attr: "scene.dragmode",
                    val: "orbit",
                    icon: o["3d_rotate"],
                    click: f
                }, u.tableRotation = {
                    name: "tableRotation",
                    title: function(t1) {
                        return c(t1, "Turntable rotation");
                    },
                    attr: "scene.dragmode",
                    val: "turntable",
                    icon: o["z-axis"],
                    click: f
                }, u.resetCameraDefault3d = {
                    name: "resetCameraDefault3d",
                    _cat: "resetCameraDefault",
                    title: function(t1) {
                        return c(t1, "Reset camera to default");
                    },
                    attr: "resetDefault",
                    icon: o.home,
                    click: p
                }, u.resetCameraLastSave3d = {
                    name: "resetCameraLastSave3d",
                    _cat: "resetCameraLastSave",
                    title: function(t1) {
                        return c(t1, "Reset camera to last save");
                    },
                    attr: "resetLastSave",
                    icon: o.movie,
                    click: p
                }, u.hoverClosest3d = {
                    name: "hoverClosest3d",
                    _cat: "hoverclosest",
                    title: function(t1) {
                        return c(t1, "Toggle show closest data on hover");
                    },
                    attr: "hovermode",
                    val: null,
                    toggle: !0,
                    icon: o.tooltip_basic,
                    gravity: "ne",
                    click: function(t1, e1) {
                        var r = d(t1, e1);
                        n.call("_guiRelayout", t1, r);
                    }
                }, u.zoomInGeo = {
                    name: "zoomInGeo",
                    _cat: "zoomin",
                    title: function(t1) {
                        return c(t1, "Zoom in");
                    },
                    attr: "zoom",
                    val: "in",
                    icon: o.zoom_plus,
                    click: m
                }, u.zoomOutGeo = {
                    name: "zoomOutGeo",
                    _cat: "zoomout",
                    title: function(t1) {
                        return c(t1, "Zoom out");
                    },
                    attr: "zoom",
                    val: "out",
                    icon: o.zoom_minus,
                    click: m
                }, u.resetGeo = {
                    name: "resetGeo",
                    _cat: "reset",
                    title: function(t1) {
                        return c(t1, "Reset");
                    },
                    attr: "reset",
                    val: null,
                    icon: o.autoscale,
                    click: m
                }, u.hoverClosestGeo = {
                    name: "hoverClosestGeo",
                    _cat: "hoverclosest",
                    title: function(t1) {
                        return c(t1, "Toggle show closest data on hover");
                    },
                    attr: "hovermode",
                    val: null,
                    toggle: !0,
                    icon: o.tooltip_basic,
                    gravity: "ne",
                    click: y
                }, u.hoverClosestGl2d = {
                    name: "hoverClosestGl2d",
                    _cat: "hoverclosest",
                    title: function(t1) {
                        return c(t1, "Toggle show closest data on hover");
                    },
                    attr: "hovermode",
                    val: null,
                    toggle: !0,
                    icon: o.tooltip_basic,
                    gravity: "ne",
                    click: y
                }, u.hoverClosestPie = {
                    name: "hoverClosestPie",
                    _cat: "hoverclosest",
                    title: function(t1) {
                        return c(t1, "Toggle show closest data on hover");
                    },
                    attr: "hovermode",
                    val: "closest",
                    icon: o.tooltip_basic,
                    gravity: "ne",
                    click: y
                }, u.resetViewSankey = {
                    name: "resetSankeyGroup",
                    title: function(t1) {
                        return c(t1, "Reset view");
                    },
                    icon: o.home,
                    click: function(t1) {
                        for(var e1 = {
                            "node.groups": [],
                            "node.x": [],
                            "node.y": []
                        }, r = 0; r < t1._fullData.length; r++){
                            var i = t1._fullData[r]._viewInitial;
                            e1["node.groups"].push(i.node.groups.slice()), e1["node.x"].push(i.node.x.slice()), e1["node.y"].push(i.node.y.slice());
                        }
                        n.call("restyle", t1, e1);
                    }
                }, u.toggleHover = {
                    name: "toggleHover",
                    title: function(t1) {
                        return c(t1, "Toggle show closest data on hover");
                    },
                    attr: "hovermode",
                    val: null,
                    toggle: !0,
                    icon: o.tooltip_basic,
                    gravity: "ne",
                    click: function(t1, e1) {
                        var r = d(t1, e1);
                        r.hovermode = g(t1), n.call("_guiRelayout", t1, r);
                    }
                }, u.resetViews = {
                    name: "resetViews",
                    title: function(t1) {
                        return c(t1, "Reset views");
                    },
                    icon: o.home,
                    click: function(t1, e1) {
                        var r = e1.currentTarget;
                        r.setAttribute("data-attr", "zoom"), r.setAttribute("data-val", "reset"), h(t1, e1), r.setAttribute("data-attr", "resetLastSave"), p(t1, e1), b(t1, "geo"), b(t1, "mapbox"), b(t1, "map");
                    }
                }, u.toggleSpikelines = {
                    name: "toggleSpikelines",
                    title: function(t1) {
                        return c(t1, "Toggle Spike Lines");
                    },
                    icon: o.spikeline,
                    attr: "_cartesianSpikesEnabled",
                    val: "on",
                    click: function(t1) {
                        var e1 = t1._fullLayout, r = e1._cartesianSpikesEnabled;
                        e1._cartesianSpikesEnabled = "on" === r ? "off" : "on", n.call("_guiRelayout", t1, function(t1) {
                            for(var e1 = "on" === t1._fullLayout._cartesianSpikesEnabled, r = a.list(t1, null, !0), n = {}, i = 0; i < r.length; i++){
                                var o = r[i];
                                n[o._name + ".showspikes"] = !!e1 || o._showSpikeInitial;
                            }
                            return n;
                        }(t1));
                    }
                }, u.resetViewMapbox = {
                    name: "resetViewMapbox",
                    _cat: "resetView",
                    title: function(t1) {
                        return c(t1, "Reset view");
                    },
                    attr: "reset",
                    icon: o.home,
                    click: function(t1) {
                        b(t1, "mapbox");
                    }
                }, u.resetViewMap = {
                    name: "resetViewMap",
                    _cat: "resetView",
                    title: function(t1) {
                        return c(t1, "Reset view");
                    },
                    attr: "reset",
                    icon: o.home,
                    click: function(t1) {
                        b(t1, "map");
                    }
                }, u.zoomInMapbox = {
                    name: "zoomInMapbox",
                    _cat: "zoomin",
                    title: function(t1) {
                        return c(t1, "Zoom in");
                    },
                    attr: "zoom",
                    val: "in",
                    icon: o.zoom_plus,
                    click: v
                }, u.zoomInMap = {
                    name: "zoomInMap",
                    _cat: "zoomin",
                    title: function(t1) {
                        return c(t1, "Zoom in");
                    },
                    attr: "zoom",
                    val: "in",
                    icon: o.zoom_plus,
                    click: x
                }, u.zoomOutMapbox = {
                    name: "zoomOutMapbox",
                    _cat: "zoomout",
                    title: function(t1) {
                        return c(t1, "Zoom out");
                    },
                    attr: "zoom",
                    val: "out",
                    icon: o.zoom_minus,
                    click: v
                }, u.zoomOutMap = {
                    name: "zoomOutMap",
                    _cat: "zoomout",
                    title: function(t1) {
                        return c(t1, "Zoom out");
                    },
                    attr: "zoom",
                    val: "out",
                    icon: o.zoom_minus,
                    click: x
                };
            },
            87632: function(t1, e1, r) {
                "use strict";
                var n = r(5832), i = Object.keys(n), a = [
                    "drawline",
                    "drawopenpath",
                    "drawclosedpath",
                    "drawcircle",
                    "drawrect",
                    "eraseshape"
                ], o = [
                    "v1hovermode",
                    "hoverclosest",
                    "hovercompare",
                    "togglehover",
                    "togglespikelines"
                ].concat(a), s = [];
                i.forEach(function(t1) {
                    !function(t1) {
                        if (-1 === o.indexOf(t1._cat || t1.name)) {
                            var e1 = t1.name, r = (t1._cat || t1.name).toLowerCase();
                            -1 === s.indexOf(e1) && s.push(e1), -1 === s.indexOf(r) && s.push(r);
                        }
                    }(n[t1]);
                }), s.sort(), t1.exports = {
                    DRAW_MODES: a,
                    backButtons: o,
                    foreButtons: s
                };
            },
            17683: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(78766), a = r(78032), o = r(50308);
                t1.exports = function(t1, e1) {
                    var r = t1.modebar || {}, s = a.newContainer(e1, "modebar");
                    function l(t1, e1) {
                        return n.coerce(r, s, o, t1, e1);
                    }
                    l("orientation"), l("bgcolor", i.addOpacity(e1.paper_bgcolor, .5));
                    var c = i.contrast(i.rgb(e1.modebar.bgcolor));
                    l("color", i.addOpacity(c, .3)), l("activecolor", i.addOpacity(c, .7)), l("uirevision", e1.uirevision), l("add"), l("remove");
                };
            },
            95433: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    moduleType: "component",
                    name: "modebar",
                    layoutAttributes: r(50308),
                    supplyLayoutDefaults: r(17683),
                    manage: r(75442)
                };
            },
            75442: function(t1, e1, r) {
                "use strict";
                var n = r(5975), i = r(64726), a = r(33626), o = r(36040).isUnifiedHover, s = r(85393), l = r(5832), c = r(87632).DRAW_MODES, u = r(34809).extendDeep;
                t1.exports = function(t1) {
                    var e1 = t1._fullLayout, r = t1._context, h = e1._modeBar;
                    if (r.displayModeBar || r.watermark) {
                        if (!Array.isArray(r.modeBarButtonsToRemove)) throw new Error([
                            "*modeBarButtonsToRemove* configuration options",
                            "must be an array."
                        ].join(" "));
                        if (!Array.isArray(r.modeBarButtonsToAdd)) throw new Error([
                            "*modeBarButtonsToAdd* configuration options",
                            "must be an array."
                        ].join(" "));
                        var f, p = r.modeBarButtons;
                        f = Array.isArray(p) && p.length ? function(t1) {
                            for(var e1 = u([], t1), r = 0; r < e1.length; r++)for(var n = e1[r], i = 0; i < n.length; i++){
                                var a = n[i];
                                if ("string" == typeof a) {
                                    if (void 0 === l[a]) throw new Error([
                                        "*modeBarButtons* configuration options",
                                        "invalid button name"
                                    ].join(" "));
                                    e1[r][i] = l[a];
                                }
                            }
                            return e1;
                        }(p) : !r.displayModeBar && r.watermark ? [] : function(t1) {
                            var e1 = t1._fullLayout, r = t1._fullData, s = t1._context;
                            function u(t1, e1) {
                                if ("string" == typeof e1) {
                                    if (e1.toLowerCase() === t1.toLowerCase()) return !0;
                                } else {
                                    var r = e1.name, n = e1._cat || e1.name;
                                    if (r === t1 || n === t1.toLowerCase()) return !0;
                                }
                                return !1;
                            }
                            var h = e1.modebar.add;
                            "string" == typeof h && (h = [
                                h
                            ]);
                            var f = e1.modebar.remove;
                            "string" == typeof f && (f = [
                                f
                            ]);
                            var p = s.modeBarButtonsToAdd.concat(h.filter(function(t1) {
                                for(var e1 = 0; e1 < s.modeBarButtonsToRemove.length; e1++)if (u(t1, s.modeBarButtonsToRemove[e1])) return !1;
                                return !0;
                            })), d = s.modeBarButtonsToRemove.concat(f.filter(function(t1) {
                                for(var e1 = 0; e1 < s.modeBarButtonsToAdd.length; e1++)if (u(t1, s.modeBarButtonsToAdd[e1])) return !1;
                                return !0;
                            })), m = e1._has("cartesian"), g = e1._has("gl3d"), y = e1._has("geo"), v = e1._has("pie"), x = e1._has("funnelarea"), _ = e1._has("gl2d"), b = e1._has("ternary"), w = e1._has("mapbox"), T = e1._has("map"), k = e1._has("polar"), A = e1._has("smith"), M = e1._has("sankey"), S = function(t1) {
                                for(var e1 = n.list({
                                    _fullLayout: t1
                                }, null, !0), r = 0; r < e1.length; r++)if (!e1[r].fixedrange) return !1;
                                return !0;
                            }(e1), E = o(e1.hovermode), C = [];
                            function L(t1) {
                                if (t1.length) {
                                    for(var e1 = [], r = 0; r < t1.length; r++){
                                        for(var n = t1[r], i = l[n], a = i.name.toLowerCase(), o = (i._cat || i.name).toLowerCase(), s = !1, c = 0; c < d.length; c++){
                                            var u = d[c].toLowerCase();
                                            if (u === a || u === o) {
                                                s = !0;
                                                break;
                                            }
                                        }
                                        s || e1.push(l[n]);
                                    }
                                    C.push(e1);
                                }
                            }
                            var I = [
                                "toImage"
                            ];
                            s.showEditInChartStudio ? I.push("editInChartStudio") : s.showSendToCloud && I.push("sendDataToCloud"), L(I);
                            var P = [], z = [], O = [], D = [];
                            (m || _ || v || x || b) + y + g + w + T + k + A > 1 ? (z = [
                                "toggleHover"
                            ], O = [
                                "resetViews"
                            ]) : y ? (P = [
                                "zoomInGeo",
                                "zoomOutGeo"
                            ], z = [
                                "hoverClosestGeo"
                            ], O = [
                                "resetGeo"
                            ]) : g ? (z = [
                                "hoverClosest3d"
                            ], O = [
                                "resetCameraDefault3d",
                                "resetCameraLastSave3d"
                            ]) : w ? (P = [
                                "zoomInMapbox",
                                "zoomOutMapbox"
                            ], z = [
                                "toggleHover"
                            ], O = [
                                "resetViewMapbox"
                            ]) : T ? (P = [
                                "zoomInMap",
                                "zoomOutMap"
                            ], z = [
                                "toggleHover"
                            ], O = [
                                "resetViewMap"
                            ]) : _ ? z = [
                                "hoverClosestGl2d"
                            ] : v ? z = [
                                "hoverClosestPie"
                            ] : M ? (z = [
                                "hoverClosestCartesian",
                                "hoverCompareCartesian"
                            ], O = [
                                "resetViewSankey"
                            ]) : z = [
                                "toggleHover"
                            ], m && z.push("toggleSpikelines", "hoverClosestCartesian", "hoverCompareCartesian"), (function(t1) {
                                for(var e1 = 0; e1 < t1.length; e1++)if (!a.traceIs(t1[e1], "noHover")) return !1;
                                return !0;
                            }(r) || E) && (z = []), !m && !_ || S || (P = [
                                "zoomIn2d",
                                "zoomOut2d",
                                "autoScale2d"
                            ], "resetViews" !== O[0] && (O = [
                                "resetScale2d"
                            ])), g ? D = [
                                "zoom3d",
                                "pan3d",
                                "orbitRotation",
                                "tableRotation"
                            ] : (m || _) && !S || b ? D = [
                                "zoom2d",
                                "pan2d"
                            ] : w || T || y ? D = [
                                "pan2d"
                            ] : k && (D = [
                                "zoom2d"
                            ]), function(t1) {
                                for(var e1 = !1, r = 0; r < t1.length && !e1; r++){
                                    var n = t1[r];
                                    n._module && n._module.selectPoints && (a.traceIs(n, "scatter-like") ? (i.hasMarkers(n) || i.hasText(n)) && (e1 = !0) : a.traceIs(n, "box-violin") && "all" !== n.boxpoints && "all" !== n.points || (e1 = !0));
                                }
                                return e1;
                            }(r) && D.push("select2d", "lasso2d");
                            var R = [], F = function(t1) {
                                -1 === R.indexOf(t1) && -1 !== z.indexOf(t1) && R.push(t1);
                            };
                            if (Array.isArray(p)) {
                                for(var B = [], N = 0; N < p.length; N++){
                                    var j = p[N];
                                    "string" == typeof j ? (j = j.toLowerCase(), -1 !== c.indexOf(j) ? (e1._has("mapbox") || e1._has("map") || e1._has("cartesian")) && D.push(j) : "togglespikelines" === j ? F("toggleSpikelines") : "togglehover" === j ? F("toggleHover") : "hovercompare" === j ? F("hoverCompareCartesian") : "hoverclosest" === j ? (F("hoverClosestCartesian"), F("hoverClosestGeo"), F("hoverClosest3d"), F("hoverClosestGl2d"), F("hoverClosestPie")) : "v1hovermode" === j && (F("hoverClosestCartesian"), F("hoverCompareCartesian"), F("hoverClosestGeo"), F("hoverClosest3d"), F("hoverClosestGl2d"), F("hoverClosestPie"))) : B.push(j);
                                }
                                p = B;
                            }
                            return L(D), L(P.concat(O)), L(R), function(t1, e1) {
                                if (e1.length) {
                                    if (Array.isArray(e1[0])) for(var r = 0; r < e1.length; r++)t1.push(e1[r]);
                                    else t1.push(e1);
                                }
                                return t1;
                            }(C, p);
                        }(t1), h ? h.update(t1, f) : e1._modeBar = s(t1, f);
                    } else h && (h.destroy(), delete e1._modeBar);
                };
            },
            85393: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(10721), a = r(34809), o = r(35188), s = r(29697).version, l = new DOMParser;
                function c(t1) {
                    this.container = t1.container, this.element = document.createElement("div"), this.update(t1.graphInfo, t1.buttons), this.container.appendChild(this.element);
                }
                var u = c.prototype;
                u.update = function(t1, e1) {
                    this.graphInfo = t1;
                    var r = this.graphInfo._context, n = this.graphInfo._fullLayout, i = "modebar-" + n._uid;
                    this.element.setAttribute("id", i), this._uid = i, this.element.className = "modebar", "hover" === r.displayModeBar && (this.element.className += " modebar--hover ease-bg"), "v" === n.modebar.orientation && (this.element.className += " vertical", e1 = e1.reverse());
                    var o = n.modebar, s = "hover" === r.displayModeBar ? ".js-plotly-plot .plotly:hover " : "";
                    a.deleteRelatedStyleRule(i), a.addRelatedStyleRule(i, s + "#" + i + " .modebar-group", "background-color: " + o.bgcolor), a.addRelatedStyleRule(i, "#" + i + " .modebar-btn .icon path", "fill: " + o.color), a.addRelatedStyleRule(i, "#" + i + " .modebar-btn:hover .icon path", "fill: " + o.activecolor), a.addRelatedStyleRule(i, "#" + i + " .modebar-btn.active .icon path", "fill: " + o.activecolor);
                    var l = !this.hasButtons(e1), c = this.hasLogo !== r.displaylogo, u = this.locale !== r.locale;
                    if (this.locale = r.locale, (l || c || u) && (this.removeAllButtons(), this.updateButtons(e1), r.watermark || r.displaylogo)) {
                        var h = this.getLogo();
                        r.watermark && (h.className = h.className + " watermark"), "v" === n.modebar.orientation ? this.element.insertBefore(h, this.element.childNodes[0]) : this.element.appendChild(h), this.hasLogo = !0;
                    }
                    this.updateActiveButton();
                }, u.updateButtons = function(t1) {
                    var e1 = this;
                    this.buttons = t1, this.buttonElements = [], this.buttonsNames = [], this.buttons.forEach(function(t1) {
                        var r = e1.createGroup();
                        t1.forEach(function(t1) {
                            var n = t1.name;
                            if (!n) throw new Error("must provide button 'name' in button config");
                            if (-1 !== e1.buttonsNames.indexOf(n)) throw new Error("button name '" + n + "' is taken");
                            e1.buttonsNames.push(n);
                            var i = e1.createButton(t1);
                            e1.buttonElements.push(i), r.appendChild(i);
                        }), e1.element.appendChild(r);
                    });
                }, u.createGroup = function() {
                    var t1 = document.createElement("div");
                    return t1.className = "modebar-group", t1;
                }, u.createButton = function(t1) {
                    var e1 = this, r = document.createElement("a");
                    r.setAttribute("rel", "tooltip"), r.className = "modebar-btn";
                    var i = t1.title;
                    void 0 === i ? i = t1.name : "function" == typeof i && (i = i(this.graphInfo)), (i || 0 === i) && r.setAttribute("data-title", i), void 0 !== t1.attr && r.setAttribute("data-attr", t1.attr);
                    var a = t1.val;
                    if (void 0 !== a && ("function" == typeof a && (a = a(this.graphInfo)), r.setAttribute("data-val", a)), "function" != typeof t1.click) throw new Error("must provide button 'click' function in button config");
                    r.addEventListener("click", function(r) {
                        t1.click(e1.graphInfo, r), e1.updateActiveButton(r.currentTarget);
                    }), r.setAttribute("data-toggle", t1.toggle || !1), t1.toggle && n.select(r).classed("active", !0);
                    var s = t1.icon;
                    return "function" == typeof s ? r.appendChild(s()) : r.appendChild(this.createIcon(s || o.question)), r.setAttribute("data-gravity", t1.gravity || "n"), r;
                }, u.createIcon = function(t1) {
                    var e1, r = i(t1.height) ? Number(t1.height) : t1.ascent - t1.descent, n = "http://www.w3.org/2000/svg";
                    if (t1.path) {
                        (e1 = document.createElementNS(n, "svg")).setAttribute("viewBox", [
                            0,
                            0,
                            t1.width,
                            r
                        ].join(" ")), e1.setAttribute("class", "icon");
                        var a = document.createElementNS(n, "path");
                        a.setAttribute("d", t1.path), t1.transform ? a.setAttribute("transform", t1.transform) : void 0 !== t1.ascent && a.setAttribute("transform", "matrix(1 0 0 -1 0 " + t1.ascent + ")"), e1.appendChild(a);
                    }
                    return t1.svg && (e1 = l.parseFromString(t1.svg, "application/xml").childNodes[0]), e1.setAttribute("height", "1em"), e1.setAttribute("width", "1em"), e1;
                }, u.updateActiveButton = function(t1) {
                    var e1 = this.graphInfo._fullLayout, r = void 0 !== t1 ? t1.getAttribute("data-attr") : null;
                    this.buttonElements.forEach(function(t1) {
                        var i = t1.getAttribute("data-val") || !0, o = t1.getAttribute("data-attr"), s = "true" === t1.getAttribute("data-toggle"), l = n.select(t1);
                        if (s) o === r && l.classed("active", !l.classed("active"));
                        else {
                            var c = null === o ? o : a.nestedProperty(e1, o).get();
                            l.classed("active", c === i);
                        }
                    });
                }, u.hasButtons = function(t1) {
                    var e1 = this.buttons;
                    if (!e1) return !1;
                    if (t1.length !== e1.length) return !1;
                    for(var r = 0; r < t1.length; ++r){
                        if (t1[r].length !== e1[r].length) return !1;
                        for(var n = 0; n < t1[r].length; n++)if (t1[r][n].name !== e1[r][n].name) return !1;
                    }
                    return !0;
                }, u.getLogo = function() {
                    var t1 = this.createGroup(), e1 = document.createElement("a");
                    return e1.href = "https://plotly.com/", e1.target = "_blank", e1.setAttribute("data-title", a._(this.graphInfo, "Produced with Plotly.js") + " (v" + s + ")"), e1.className = "modebar-btn plotlyjsicon modebar-btn--logo", e1.appendChild(this.createIcon(o.newplotlylogo)), t1.appendChild(e1), t1;
                }, u.removeAllButtons = function() {
                    for(; this.element.firstChild;)this.element.removeChild(this.element.firstChild);
                    this.hasLogo = !1;
                }, u.destroy = function() {
                    a.removeElement(this.container.querySelector(".modebar")), a.deleteRelatedStyleRule(this._uid);
                }, t1.exports = function(t1, e1) {
                    var r = t1._fullLayout, i = new c({
                        graphInfo: t1,
                        container: r._modebardiv.node(),
                        buttons: e1
                    });
                    return r._privateplot && n.select(i.element).append("span").classed("badge-private float--left", !0).text("PRIVATE"), i;
                };
            },
            91032: function(t1, e1, r) {
                "use strict";
                var n = r(80337), i = r(10229), a = (0, r(78032).templatedArray)("button", {
                    visible: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "plot"
                    },
                    step: {
                        valType: "enumerated",
                        values: [
                            "month",
                            "year",
                            "day",
                            "hour",
                            "minute",
                            "second",
                            "all"
                        ],
                        dflt: "month",
                        editType: "plot"
                    },
                    stepmode: {
                        valType: "enumerated",
                        values: [
                            "backward",
                            "todate"
                        ],
                        dflt: "backward",
                        editType: "plot"
                    },
                    count: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        editType: "plot"
                    },
                    label: {
                        valType: "string",
                        editType: "plot"
                    },
                    editType: "plot"
                });
                t1.exports = {
                    visible: {
                        valType: "boolean",
                        editType: "plot"
                    },
                    buttons: a,
                    x: {
                        valType: "number",
                        min: -2,
                        max: 3,
                        editType: "plot"
                    },
                    xanchor: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "left",
                            "center",
                            "right"
                        ],
                        dflt: "left",
                        editType: "plot"
                    },
                    y: {
                        valType: "number",
                        min: -2,
                        max: 3,
                        editType: "plot"
                    },
                    yanchor: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "top",
                            "middle",
                            "bottom"
                        ],
                        dflt: "bottom",
                        editType: "plot"
                    },
                    font: n({
                        editType: "plot"
                    }),
                    bgcolor: {
                        valType: "color",
                        dflt: i.lightLine,
                        editType: "plot"
                    },
                    activecolor: {
                        valType: "color",
                        editType: "plot"
                    },
                    bordercolor: {
                        valType: "color",
                        dflt: i.defaultLine,
                        editType: "plot"
                    },
                    borderwidth: {
                        valType: "number",
                        min: 0,
                        dflt: 0,
                        editType: "plot"
                    },
                    editType: "plot"
                };
            },
            68508: function(t1) {
                "use strict";
                t1.exports = {
                    yPad: .02,
                    minButtonWidth: 30,
                    rx: 3,
                    ry: 3,
                    lightAmount: 25,
                    darkAmount: 10
                };
            },
            86255: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(78766), a = r(78032), o = r(59008), s = r(91032), l = r(68508);
                function c(t1, e1, r, i) {
                    var a = i.calendar;
                    function o(r, i) {
                        return n.coerce(t1, e1, s.buttons, r, i);
                    }
                    if (o("visible")) {
                        var l = o("step");
                        "all" !== l && (!a || "gregorian" === a || "month" !== l && "year" !== l ? o("stepmode") : e1.stepmode = "backward", o("count")), o("label");
                    }
                }
                t1.exports = function(t1, e1, r, u, h) {
                    var f = t1.rangeselector || {}, p = a.newContainer(e1, "rangeselector");
                    function d(t1, e1) {
                        return n.coerce(f, p, s, t1, e1);
                    }
                    if (d("visible", o(f, p, {
                        name: "buttons",
                        handleItemDefaults: c,
                        calendar: h
                    }).length > 0)) {
                        var m = function(t1, e1, r) {
                            for(var n = r.filter(function(r) {
                                return e1[r].anchor === t1._id;
                            }), i = 0, a = 0; a < n.length; a++){
                                var o = e1[n[a]].domain;
                                o && (i = Math.max(o[1], i));
                            }
                            return [
                                t1.domain[0],
                                i + l.yPad
                            ];
                        }(e1, r, u);
                        d("x", m[0]), d("y", m[1]), n.noneOrAll(t1, e1, [
                            "x",
                            "y"
                        ]), d("xanchor"), d("yanchor"), n.coerceFont(d, "font", r.font);
                        var g = d("bgcolor");
                        d("activecolor", i.contrast(g, l.lightAmount, l.darkAmount)), d("bordercolor"), d("borderwidth");
                    }
                };
            },
            45431: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(33626), a = r(44122), o = r(78766), s = r(62203), l = r(34809), c = l.strTranslate, u = r(30635), h = r(5975), f = r(4530), p = f.LINE_SPACING, d = f.FROM_TL, m = f.FROM_BR, g = r(68508), y = r(16383);
                function v(t1) {
                    return t1._id;
                }
                function x(t1, e1, r) {
                    var n = l.ensureSingle(t1, "rect", "selector-rect", function(t1) {
                        t1.attr("shape-rendering", "crispEdges");
                    });
                    n.attr({
                        rx: g.rx,
                        ry: g.ry
                    }), n.call(o.stroke, e1.bordercolor).call(o.fill, function(t1, e1) {
                        return e1._isActive || e1._isHovered ? t1.activecolor : t1.bgcolor;
                    }(e1, r)).style("stroke-width", e1.borderwidth + "px");
                }
                function _(t1, e1, r, n) {
                    var i, a;
                    l.ensureSingle(t1, "text", "selector-text", function(t1) {
                        t1.attr("text-anchor", "middle");
                    }).call(s.font, e1.font).text((i = r, a = n._fullLayout._meta, i.label ? a ? l.templateString(i.label, a) : i.label : "all" === i.step ? "all" : i.count + i.step.charAt(0))).call(function(t1) {
                        u.convertToTspans(t1, n);
                    });
                }
                t1.exports = function(t1) {
                    var e1 = t1._fullLayout._infolayer.selectAll(".rangeselector").data(function(t1) {
                        for(var e1 = h.list(t1, "x", !0), r = [], n = 0; n < e1.length; n++){
                            var i = e1[n];
                            i.rangeselector && i.rangeselector.visible && r.push(i);
                        }
                        return r;
                    }(t1), v);
                    e1.enter().append("g").classed("rangeselector", !0), e1.exit().remove(), e1.style({
                        cursor: "pointer",
                        "pointer-events": "all"
                    }), e1.each(function(e1) {
                        var r = n.select(this), o = e1, h = o.rangeselector, f = r.selectAll("g.button").data(l.filterVisible(h.buttons));
                        f.enter().append("g").classed("button", !0), f.exit().remove(), f.each(function(e1) {
                            var r = n.select(this), a = y(o, e1);
                            e1._isActive = function(t1, e1, r) {
                                if ("all" === e1.step) return !0 === t1.autorange;
                                var n = Object.keys(r);
                                return t1.range[0] === r[n[0]] && t1.range[1] === r[n[1]];
                            }(o, e1, a), r.call(x, h, e1), r.call(_, h, e1, t1), r.on("click", function() {
                                t1._dragged || i.call("_guiRelayout", t1, a);
                            }), r.on("mouseover", function() {
                                e1._isHovered = !0, r.call(x, h, e1);
                            }), r.on("mouseout", function() {
                                e1._isHovered = !1, r.call(x, h, e1);
                            });
                        }), function(t1, e1, r, i, o) {
                            var h = 0, f = 0, y = r.borderwidth;
                            e1.each(function() {
                                var t1 = n.select(this).select(".selector-text"), e1 = r.font.size * p, i = Math.max(e1 * u.lineCount(t1), 16) + 3;
                                f = Math.max(f, i);
                            }), e1.each(function() {
                                var t1 = n.select(this), e1 = t1.select(".selector-rect"), i = t1.select(".selector-text"), a = i.node() && s.bBox(i.node()).width, o = r.font.size * p, l = u.lineCount(i), d = Math.max(a + 10, g.minButtonWidth);
                                t1.attr("transform", c(y + h, y)), e1.attr({
                                    x: 0,
                                    y: 0,
                                    width: d,
                                    height: f
                                }), u.positionText(i, d / 2, f / 2 - (l - 1) * o / 2 + 3), h += d + 5;
                            });
                            var v = t1._fullLayout._size, x = v.l + v.w * r.x, _ = v.t + v.h * (1 - r.y), b = "left";
                            l.isRightAnchor(r) && (x -= h, b = "right"), l.isCenterAnchor(r) && (x -= h / 2, b = "center");
                            var w = "top";
                            l.isBottomAnchor(r) && (_ -= f, w = "bottom"), l.isMiddleAnchor(r) && (_ -= f / 2, w = "middle"), h = Math.ceil(h), f = Math.ceil(f), x = Math.round(x), _ = Math.round(_), a.autoMargin(t1, i + "-range-selector", {
                                x: r.x,
                                y: r.y,
                                l: h * d[b],
                                r: h * m[b],
                                b: f * m[w],
                                t: f * d[w]
                            }), o.attr("transform", c(x, _));
                        }(t1, f, h, o._name, r);
                    });
                };
            },
            16383: function(t1, e1, r) {
                "use strict";
                var n = r(50936), i = r(34809).titleCase;
                t1.exports = function(t1, e1) {
                    var r = t1._name, a = {};
                    if ("all" === e1.step) a[r + ".autorange"] = !0;
                    else {
                        var o = function(t1, e1) {
                            var r, a = t1.range, o = new Date(t1.r2l(a[1])), s = e1.step, l = n["utc" + i(s)], c = e1.count;
                            switch(e1.stepmode){
                                case "backward":
                                    r = t1.l2r(+l.offset(o, -c));
                                    break;
                                case "todate":
                                    var u = l.offset(o, -c);
                                    r = t1.l2r(+l.ceil(u));
                            }
                            return [
                                r,
                                a[1]
                            ];
                        }(t1, e1);
                        a[r + ".range[0]"] = o[0], a[r + ".range[1]"] = o[1];
                    }
                    return a;
                };
            },
            44453: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    moduleType: "component",
                    name: "rangeselector",
                    schema: {
                        subplots: {
                            xaxis: {
                                rangeselector: r(91032)
                            }
                        }
                    },
                    layoutAttributes: r(91032),
                    handleDefaults: r(86255),
                    draw: r(45431)
                };
            },
            63608: function(t1, e1, r) {
                "use strict";
                var n = r(10229);
                t1.exports = {
                    bgcolor: {
                        valType: "color",
                        dflt: n.background,
                        editType: "plot"
                    },
                    bordercolor: {
                        valType: "color",
                        dflt: n.defaultLine,
                        editType: "plot"
                    },
                    borderwidth: {
                        valType: "integer",
                        dflt: 0,
                        min: 0,
                        editType: "plot"
                    },
                    autorange: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc",
                        impliedEdits: {
                            "range[0]": void 0,
                            "range[1]": void 0
                        }
                    },
                    range: {
                        valType: "info_array",
                        items: [
                            {
                                valType: "any",
                                editType: "calc",
                                impliedEdits: {
                                    "^autorange": !1
                                }
                            },
                            {
                                valType: "any",
                                editType: "calc",
                                impliedEdits: {
                                    "^autorange": !1
                                }
                            }
                        ],
                        editType: "calc",
                        impliedEdits: {
                            autorange: !1
                        }
                    },
                    thickness: {
                        valType: "number",
                        dflt: .15,
                        min: 0,
                        max: 1,
                        editType: "plot"
                    },
                    visible: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    },
                    editType: "calc"
                };
            },
            46223: function(t1, e1, r) {
                "use strict";
                var n = r(5975).list, i = r(32919).getAutoRange, a = r(20604);
                t1.exports = function(t1) {
                    for(var e1 = n(t1, "x", !0), r = 0; r < e1.length; r++){
                        var o = e1[r], s = o[a.name];
                        s && s.visible && s.autorange && (s._input.autorange = !0, s._input.range = s.range = i(t1, o));
                    }
                };
            },
            20604: function(t1) {
                "use strict";
                t1.exports = {
                    name: "rangeslider",
                    containerClassName: "rangeslider-container",
                    bgClassName: "rangeslider-bg",
                    rangePlotClassName: "rangeslider-rangeplot",
                    maskMinClassName: "rangeslider-mask-min",
                    maskMaxClassName: "rangeslider-mask-max",
                    slideBoxClassName: "rangeslider-slidebox",
                    grabberMinClassName: "rangeslider-grabber-min",
                    grabAreaMinClassName: "rangeslider-grabarea-min",
                    handleMinClassName: "rangeslider-handle-min",
                    grabberMaxClassName: "rangeslider-grabber-max",
                    grabAreaMaxClassName: "rangeslider-grabarea-max",
                    handleMaxClassName: "rangeslider-handle-max",
                    maskMinOppAxisClassName: "rangeslider-mask-min-opp-axis",
                    maskMaxOppAxisClassName: "rangeslider-mask-max-opp-axis",
                    maskColor: "rgba(0,0,0,0.4)",
                    maskOppAxisColor: "rgba(0,0,0,0.2)",
                    slideBoxFill: "transparent",
                    slideBoxCursor: "ew-resize",
                    grabAreaFill: "transparent",
                    grabAreaCursor: "col-resize",
                    grabAreaWidth: 10,
                    handleWidth: 4,
                    handleRadius: 1,
                    handleStrokeWidth: 1,
                    extraPad: 15
                };
            },
            41295: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(78032), a = r(5975), o = r(63608), s = r(66249);
                t1.exports = function(t1, e1, r) {
                    var l = t1[r], c = e1[r];
                    if (l.rangeslider || e1._requestRangeslider[c._id]) {
                        n.isPlainObject(l.rangeslider) || (l.rangeslider = {});
                        var u, h, f = l.rangeslider, p = i.newContainer(c, "rangeslider");
                        if (b("visible")) {
                            b("bgcolor", e1.plot_bgcolor), b("bordercolor"), b("borderwidth"), b("thickness"), b("autorange", !c.isValidRange(f.range)), b("range");
                            var d = e1._subplots;
                            if (d) for(var m = d.cartesian.filter(function(t1) {
                                return t1.substr(0, t1.indexOf("y")) === a.name2id(r);
                            }).map(function(t1) {
                                return t1.substr(t1.indexOf("y"), t1.length);
                            }), g = n.simpleMap(m, a.id2name), y = 0; y < g.length; y++){
                                var v = g[y];
                                u = f[v] || {}, h = i.newContainer(p, v, "yaxis");
                                var x, _ = e1[v];
                                u.range && _.isValidRange(u.range) && (x = "fixed"), "match" !== w("rangemode", x) && w("range", _.range.slice());
                            }
                            p._input = f;
                        }
                    }
                    function b(t1, e1) {
                        return n.coerce(f, p, o, t1, e1);
                    }
                    function w(t1, e1) {
                        return n.coerce(u, h, s, t1, e1);
                    }
                };
            },
            88887: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(33626), a = r(44122), o = r(34809), s = o.strTranslate, l = r(62203), c = r(78766), u = r(17240), h = r(37703), f = r(5975), p = r(14751), d = r(27983), m = r(20604);
                function g(t1) {
                    return "number" == typeof t1.clientX ? t1.clientX : t1.touches && t1.touches.length > 0 ? t1.touches[0].clientX : 0;
                }
                function y(t1, e1, r, n) {
                    var i = o.ensureSingle(t1, "rect", m.bgClassName, function(t1) {
                        t1.attr({
                            x: 0,
                            y: 0,
                            "shape-rendering": "crispEdges"
                        });
                    }), a = n.borderwidth % 2 == 0 ? n.borderwidth : n.borderwidth - 1, u = -n._offsetShift, h = l.crispRound(e1, n.borderwidth);
                    i.attr({
                        width: n._width + a,
                        height: n._height + a,
                        transform: s(u, u),
                        "stroke-width": h
                    }).call(c.stroke, n.bordercolor).call(c.fill, n.bgcolor);
                }
                function v(t1, e1, r, n) {
                    var i = e1._fullLayout;
                    o.ensureSingleById(i._topdefs, "clipPath", n._clipId, function(t1) {
                        t1.append("rect").attr({
                            x: 0,
                            y: 0
                        });
                    }).select("rect").attr({
                        width: n._width,
                        height: n._height
                    });
                }
                function x(t1, e1, r, i) {
                    var s, c = e1.calcdata, u = t1.selectAll("g." + m.rangePlotClassName).data(r._subplotsWith, o.identity);
                    u.enter().append("g").attr("class", function(t1) {
                        return m.rangePlotClassName + " " + t1;
                    }).call(l.setClipUrl, i._clipId, e1), u.order(), u.exit().remove(), u.each(function(t1, o) {
                        var l = n.select(this), u = 0 === o, p = f.getFromId(e1, t1, "y"), d = p._name, m = i[d], g = {
                            data: [],
                            layout: {
                                xaxis: {
                                    type: r.type,
                                    domain: [
                                        0,
                                        1
                                    ],
                                    range: i.range.slice(),
                                    calendar: r.calendar
                                },
                                width: i._width,
                                height: i._height,
                                margin: {
                                    t: 0,
                                    b: 0,
                                    l: 0,
                                    r: 0
                                }
                            },
                            _context: e1._context
                        };
                        r.rangebreaks && (g.layout.xaxis.rangebreaks = r.rangebreaks), g.layout[d] = {
                            type: p.type,
                            domain: [
                                0,
                                1
                            ],
                            range: "match" !== m.rangemode ? m.range.slice() : p.range.slice(),
                            calendar: p.calendar
                        }, p.rangebreaks && (g.layout[d].rangebreaks = p.rangebreaks), a.supplyDefaults(g);
                        var y = g._fullLayout.xaxis, v = g._fullLayout[d];
                        y.clearCalc(), y.setScale(), v.clearCalc(), v.setScale();
                        var x = {
                            id: t1,
                            plotgroup: l,
                            xaxis: y,
                            yaxis: v,
                            isRangePlot: !0
                        };
                        u ? s = x : (x.mainplot = "xy", x.mainplotinfo = s), h.rangePlot(e1, x, function(t1, e1) {
                            for(var r = [], n = 0; n < t1.length; n++){
                                var i = t1[n], a = i[0].trace;
                                a.xaxis + a.yaxis === e1 && r.push(i);
                            }
                            return r;
                        }(c, t1));
                    });
                }
                function _(t1, e1, r, n, i) {
                    o.ensureSingle(t1, "rect", m.maskMinClassName, function(t1) {
                        t1.attr({
                            x: 0,
                            y: 0,
                            "shape-rendering": "crispEdges"
                        });
                    }).attr("height", n._height).call(c.fill, m.maskColor), o.ensureSingle(t1, "rect", m.maskMaxClassName, function(t1) {
                        t1.attr({
                            y: 0,
                            "shape-rendering": "crispEdges"
                        });
                    }).attr("height", n._height).call(c.fill, m.maskColor), "match" !== i.rangemode && (o.ensureSingle(t1, "rect", m.maskMinOppAxisClassName, function(t1) {
                        t1.attr({
                            y: 0,
                            "shape-rendering": "crispEdges"
                        });
                    }).attr("width", n._width).call(c.fill, m.maskOppAxisColor), o.ensureSingle(t1, "rect", m.maskMaxOppAxisClassName, function(t1) {
                        t1.attr({
                            y: 0,
                            "shape-rendering": "crispEdges"
                        });
                    }).attr("width", n._width).style("border-top", m.maskOppBorder).call(c.fill, m.maskOppAxisColor));
                }
                function b(t1, e1, r, n) {
                    e1._context.staticPlot || o.ensureSingle(t1, "rect", m.slideBoxClassName, function(t1) {
                        t1.attr({
                            y: 0,
                            cursor: m.slideBoxCursor,
                            "shape-rendering": "crispEdges"
                        });
                    }).attr({
                        height: n._height,
                        fill: m.slideBoxFill
                    });
                }
                function w(t1, e1, r, n) {
                    var i = o.ensureSingle(t1, "g", m.grabberMinClassName), a = o.ensureSingle(t1, "g", m.grabberMaxClassName), s = {
                        x: 0,
                        width: m.handleWidth,
                        rx: m.handleRadius,
                        fill: c.background,
                        stroke: c.defaultLine,
                        "stroke-width": m.handleStrokeWidth,
                        "shape-rendering": "crispEdges"
                    }, l = {
                        y: Math.round(n._height / 4),
                        height: Math.round(n._height / 2)
                    };
                    o.ensureSingle(i, "rect", m.handleMinClassName, function(t1) {
                        t1.attr(s);
                    }).attr(l), o.ensureSingle(a, "rect", m.handleMaxClassName, function(t1) {
                        t1.attr(s);
                    }).attr(l);
                    var u = {
                        width: m.grabAreaWidth,
                        x: 0,
                        y: 0,
                        fill: m.grabAreaFill,
                        cursor: e1._context.staticPlot ? void 0 : m.grabAreaCursor
                    };
                    o.ensureSingle(i, "rect", m.grabAreaMinClassName, function(t1) {
                        t1.attr(u);
                    }).attr("height", n._height), o.ensureSingle(a, "rect", m.grabAreaMaxClassName, function(t1) {
                        t1.attr(u);
                    }).attr("height", n._height);
                }
                t1.exports = function(t1) {
                    for(var e1 = t1._fullLayout, r = e1._rangeSliderData, a = 0; a < r.length; a++){
                        var l = r[a][m.name];
                        l._clipId = l._id + "-" + e1._uid;
                    }
                    var c = e1._infolayer.selectAll("g." + m.containerClassName).data(r, function(t1) {
                        return t1._name;
                    });
                    c.exit().each(function(t1) {
                        var r = t1[m.name];
                        e1._topdefs.select("#" + r._clipId).remove();
                    }).remove(), 0 !== r.length && (c.enter().append("g").classed(m.containerClassName, !0).attr("pointer-events", "all"), c.each(function(r) {
                        var a = n.select(this), l = r[m.name], c = e1[f.id2name(r.anchor)], h = l[f.id2name(r.anchor)];
                        if (l.range) {
                            var T, k = o.simpleMap(l.range, r.r2l), A = o.simpleMap(r.range, r.r2l);
                            T = A[0] < A[1] ? [
                                Math.min(k[0], A[0]),
                                Math.max(k[1], A[1])
                            ] : [
                                Math.max(k[0], A[0]),
                                Math.min(k[1], A[1])
                            ], l.range = l._input.range = o.simpleMap(T, r.l2r);
                        }
                        r.cleanRange("rangeslider.range");
                        var M = e1._size, S = r.domain;
                        l._width = M.w * (S[1] - S[0]);
                        var E = Math.round(M.l + M.w * S[0]), C = Math.round(M.t + M.h * (1 - r._counterDomainMin) + ("bottom" === r.side ? r._depth : 0) + l._offsetShift + m.extraPad);
                        a.attr("transform", s(E, C)), l._rl = o.simpleMap(l.range, r.r2l);
                        var L = l._rl[0], I = l._rl[1], P = I - L;
                        if (l.p2d = function(t1) {
                            return t1 / l._width * P + L;
                        }, l.d2p = function(t1) {
                            return (t1 - L) / P * l._width;
                        }, r.rangebreaks) {
                            var z = r.locateBreaks(L, I);
                            if (z.length) {
                                var O, D, R = 0;
                                for(O = 0; O < z.length; O++)R += (D = z[O]).max - D.min;
                                var F = l._width / (I - L - R), B = [
                                    -F * L
                                ];
                                for(O = 0; O < z.length; O++)D = z[O], B.push(B[B.length - 1] - F * (D.max - D.min));
                                for(l.d2p = function(t1) {
                                    for(var e1 = B[0], r = 0; r < z.length; r++){
                                        var n = z[r];
                                        if (t1 >= n.max) e1 = B[r + 1];
                                        else if (t1 < n.min) break;
                                    }
                                    return e1 + F * t1;
                                }, O = 0; O < z.length; O++)(D = z[O]).pmin = l.d2p(D.min), D.pmax = l.d2p(D.max);
                                l.p2d = function(t1) {
                                    for(var e1 = B[0], r = 0; r < z.length; r++){
                                        var n = z[r];
                                        if (t1 >= n.pmax) e1 = B[r + 1];
                                        else if (t1 < n.pmin) break;
                                    }
                                    return (t1 - e1) / F;
                                };
                            }
                        }
                        if ("match" !== h.rangemode) {
                            var N = c.r2l(h.range[0]), j = c.r2l(h.range[1]) - N;
                            l.d2pOppAxis = function(t1) {
                                return (t1 - N) / j * l._height;
                            };
                        }
                        a.call(y, t1, r, l).call(v, t1, r, l).call(x, t1, r, l).call(_, t1, r, l, h).call(b, t1, r, l).call(w, t1, r, l), function(t1, e1, r, a) {
                            if (!e1._context.staticPlot) {
                                var s = t1.select("rect." + m.slideBoxClassName).node(), l = t1.select("rect." + m.grabAreaMinClassName).node(), c = t1.select("rect." + m.grabAreaMaxClassName).node();
                                t1.on("mousedown", u), t1.on("touchstart", u);
                            }
                            function u() {
                                var u = n.event, h = u.target, f = g(u), m = f - t1.node().getBoundingClientRect().left, y = a.d2p(r._rl[0]), v = a.d2p(r._rl[1]), x = p.coverSlip();
                                function _(t1) {
                                    var u, p, _, b = +g(t1) - f;
                                    switch(h){
                                        case s:
                                            if (_ = "ew-resize", y + b > r._length || v + b < 0) return;
                                            u = y + b, p = v + b;
                                            break;
                                        case l:
                                            if (_ = "col-resize", y + b > r._length) return;
                                            u = y + b, p = v;
                                            break;
                                        case c:
                                            if (_ = "col-resize", v + b < 0) return;
                                            u = y, p = v + b;
                                            break;
                                        default:
                                            _ = "ew-resize", u = m, p = m + b;
                                    }
                                    if (p < u) {
                                        var w = p;
                                        p = u, u = w;
                                    }
                                    a._pixelMin = u, a._pixelMax = p, d(n.select(x), _), function(t1, e1, r, n) {
                                        function a(t1) {
                                            return r.l2r(o.constrain(t1, n._rl[0], n._rl[1]));
                                        }
                                        var s = a(n.p2d(n._pixelMin)), l = a(n.p2d(n._pixelMax));
                                        window.requestAnimationFrame(function() {
                                            i.call("_guiRelayout", e1, r._name + ".range", [
                                                s,
                                                l
                                            ]);
                                        });
                                    }(0, e1, r, a);
                                }
                                function b() {
                                    x.removeEventListener("mousemove", _), x.removeEventListener("mouseup", b), this.removeEventListener("touchmove", _), this.removeEventListener("touchend", b), o.removeElement(x);
                                }
                                this.addEventListener("touchmove", _), this.addEventListener("touchend", b), x.addEventListener("mousemove", _), x.addEventListener("mouseup", b);
                            }
                        }(a, t1, r, l), function(t1, e1, r, n, i, a) {
                            var l = m.handleWidth / 2;
                            function c(t1) {
                                return o.constrain(t1, 0, n._width);
                            }
                            function u(t1) {
                                return o.constrain(t1, 0, n._height);
                            }
                            function h(t1) {
                                return o.constrain(t1, -l, n._width + l);
                            }
                            var f = c(n.d2p(r._rl[0])), p = c(n.d2p(r._rl[1]));
                            if (t1.select("rect." + m.slideBoxClassName).attr("x", f).attr("width", p - f), t1.select("rect." + m.maskMinClassName).attr("width", f), t1.select("rect." + m.maskMaxClassName).attr("x", p).attr("width", n._width - p), "match" !== a.rangemode) {
                                var d = n._height - u(n.d2pOppAxis(i._rl[1])), g = n._height - u(n.d2pOppAxis(i._rl[0]));
                                t1.select("rect." + m.maskMinOppAxisClassName).attr("x", f).attr("height", d).attr("width", p - f), t1.select("rect." + m.maskMaxOppAxisClassName).attr("x", f).attr("y", g).attr("height", n._height - g).attr("width", p - f), t1.select("rect." + m.slideBoxClassName).attr("y", d).attr("height", g - d);
                            }
                            var y = .5, v = Math.round(h(f - l)) - y, x = Math.round(h(p - l)) + y;
                            t1.select("g." + m.grabberMinClassName).attr("transform", s(v, y)), t1.select("g." + m.grabberMaxClassName).attr("transform", s(x, y));
                        }(a, 0, r, l, c, h), "bottom" === r.side && u.draw(t1, r._id + "title", {
                            propContainer: r,
                            propName: r._name + ".title",
                            placeholder: e1._dfltTitle.x,
                            attributes: {
                                x: r._offset + r._length / 2,
                                y: C + l._height + l._offsetShift + 10 + 1.5 * r.title.font.size,
                                "text-anchor": "middle"
                            }
                        });
                    }));
                };
            },
            80400: function(t1, e1, r) {
                "use strict";
                var n = r(5975), i = r(30635), a = r(20604), o = r(4530).LINE_SPACING, s = a.name;
                function l(t1) {
                    var e1 = t1 && t1[s];
                    return e1 && e1.visible;
                }
                e1.isVisible = l, e1.makeData = function(t1) {
                    var e1 = n.list({
                        _fullLayout: t1
                    }, "x", !0), r = t1.margin, i = [];
                    if (!t1._has("gl2d")) for(var a = 0; a < e1.length; a++){
                        var o = e1[a];
                        if (l(o)) {
                            i.push(o);
                            var c = o[s];
                            c._id = s + o._id, c._height = (t1.height - r.b - r.t) * c.thickness, c._offsetShift = Math.floor(c.borderwidth / 2);
                        }
                    }
                    t1._rangeSliderData = i;
                }, e1.autoMarginOpts = function(t1, e1) {
                    var r = t1._fullLayout, n = e1[s], l = e1._id.charAt(0), c = 0, u = 0;
                    return "bottom" === e1.side && (c = e1._depth, e1.title.text !== r._dfltTitle[l] && (u = 1.5 * e1.title.font.size + 10 + n._offsetShift, u += (e1.title.text.match(i.BR_TAG_ALL) || []).length * e1.title.font.size * o)), {
                        x: 0,
                        y: e1._counterDomainMin,
                        l: 0,
                        r: 0,
                        t: 0,
                        b: n._height + c + Math.max(r.margin.b, u),
                        pad: a.extraPad + 2 * n._offsetShift
                    };
                };
            },
            55429: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(63608), a = r(66249), o = r(80400);
                t1.exports = {
                    moduleType: "component",
                    name: "rangeslider",
                    schema: {
                        subplots: {
                            xaxis: {
                                rangeslider: n.extendFlat({}, i, {
                                    yaxis: a
                                })
                            }
                        }
                    },
                    layoutAttributes: r(63608),
                    handleDefaults: r(41295),
                    calcAutorange: r(46223),
                    draw: r(88887),
                    isVisible: o.isVisible,
                    makeData: o.makeData,
                    autoMarginOpts: o.autoMarginOpts
                };
            },
            66249: function(t1) {
                "use strict";
                t1.exports = {
                    _isSubplotObj: !0,
                    rangemode: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "fixed",
                            "match"
                        ],
                        dflt: "match",
                        editType: "calc"
                    },
                    range: {
                        valType: "info_array",
                        items: [
                            {
                                valType: "any",
                                editType: "plot"
                            },
                            {
                                valType: "any",
                                editType: "plot"
                            }
                        ],
                        editType: "plot"
                    },
                    editType: "calc"
                };
            },
            4327: function(t1, e1, r) {
                "use strict";
                var n = r(50222), i = r(36640).line, a = r(94850).T, o = r(93049).extendFlat, s = r(13582).overrideAll, l = r(78032).templatedArray;
                r(35081), t1.exports = s(l("selection", {
                    type: {
                        valType: "enumerated",
                        values: [
                            "rect",
                            "path"
                        ]
                    },
                    xref: o({}, n.xref, {}),
                    yref: o({}, n.yref, {}),
                    x0: {
                        valType: "any"
                    },
                    x1: {
                        valType: "any"
                    },
                    y0: {
                        valType: "any"
                    },
                    y1: {
                        valType: "any"
                    },
                    path: {
                        valType: "string",
                        editType: "arraydraw"
                    },
                    opacity: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: .7,
                        editType: "arraydraw"
                    },
                    line: {
                        color: i.color,
                        width: o({}, i.width, {
                            min: 1,
                            dflt: 1
                        }),
                        dash: o({}, a, {
                            dflt: "dot"
                        })
                    }
                }), "arraydraw", "from-root");
            },
            78865: function(t1) {
                "use strict";
                t1.exports = {
                    BENDPX: 1.5,
                    MINSELECT: 12,
                    SELECTDELAY: 100,
                    SELECTID: "-select"
                };
            },
            2272: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(29714), a = r(59008), o = r(4327), s = r(49728);
                function l(t1, e1, r) {
                    function a(r, i) {
                        return n.coerce(t1, e1, o, r, i);
                    }
                    var l = a("path"), c = "path" !== a("type", l ? "path" : "rect");
                    c && delete e1.path, a("opacity"), a("line.color"), a("line.width"), a("line.dash");
                    for(var u = [
                        "x",
                        "y"
                    ], h = 0; h < 2; h++){
                        var f, p, d, m = u[h], g = {
                            _fullLayout: r
                        }, y = i.coerceRef(t1, e1, g, m);
                        if ((f = i.getFromId(g, y))._selectionIndices.push(e1._index), d = s.rangeToShapePosition(f), p = s.shapePositionToRange(f), c) {
                            var v = m + "0", x = m + "1", _ = t1[v], b = t1[x];
                            t1[v] = p(t1[v], !0), t1[x] = p(t1[x], !0), i.coercePosition(e1, g, a, y, v), i.coercePosition(e1, g, a, y, x);
                            var w = e1[v], T = e1[x];
                            void 0 !== w && void 0 !== T && (e1[v] = d(w), e1[x] = d(T), t1[v] = _, t1[x] = b);
                        }
                    }
                    c && n.noneOrAll(t1, e1, [
                        "x0",
                        "x1",
                        "y0",
                        "y1"
                    ]);
                }
                t1.exports = function(t1, e1) {
                    a(t1, e1, {
                        name: "selections",
                        handleItemDefaults: l
                    });
                    for(var r = e1.selections, n = 0; n < r.length; n++){
                        var i = r[n];
                        i && void 0 === i.path && (void 0 !== i.x0 && void 0 !== i.x1 && void 0 !== i.y0 && void 0 !== i.y1 || (e1.selections[n] = null));
                    }
                };
            },
            7028: function(t1, e1, r) {
                "use strict";
                var n = r(81055).readPaths, i = r(561), a = r(78534).clearOutlineControllers, o = r(78766), s = r(62203), l = r(78032).arrayEditor, c = r(49728), u = c.getPathString;
                function h(t1) {
                    var e1 = t1._fullLayout;
                    for(var r in a(t1), e1._selectionLayer.selectAll("path").remove(), e1._plots){
                        var n = e1._plots[r].selectionLayer;
                        n && n.selectAll("path").remove();
                    }
                    for(var i = 0; i < e1.selections.length; i++)p(t1, i);
                }
                function f(t1) {
                    return t1._context.editSelection;
                }
                function p(t1, e1) {
                    t1._fullLayout._paperdiv.selectAll('.selectionlayer [data-index="' + e1 + '"]').remove();
                    var r = c.makeSelectionsOptionsAndPlotinfo(t1, e1), a = r.options, p = r.plotinfo;
                    a._input && function(r) {
                        var c = u(t1, a), g = {
                            "data-index": e1,
                            "fill-rule": "evenodd",
                            d: c
                        }, y = a.opacity, v = "rgba(0,0,0,0)", x = a.line.color || o.contrast(t1._fullLayout.plot_bgcolor), _ = a.line.width, b = a.line.dash;
                        _ || (_ = 5, b = "solid");
                        var w = f(t1) && t1._fullLayout._activeSelectionIndex === e1;
                        w && (v = t1._fullLayout.activeselection.fillcolor, y = t1._fullLayout.activeselection.opacity);
                        for(var T = [], k = 1; k >= 0; k--){
                            var A = r.append("path").attr(g).style("opacity", k ? .1 : y).call(o.stroke, x).call(o.fill, v).call(s.dashLine, k ? "solid" : b, k ? 4 + _ : _);
                            if (d(A, t1, a), w) {
                                var M = l(t1.layout, "selections", a);
                                A.style({
                                    cursor: "move"
                                });
                                var S = {
                                    element: A.node(),
                                    plotinfo: p,
                                    gd: t1,
                                    editHelpers: M,
                                    isActiveSelection: !0
                                }, E = n(c, t1);
                                i(E, A, S);
                            } else A.style("pointer-events", k ? "all" : "none");
                            T[k] = A;
                        }
                        var C = T[0];
                        T[1].node().addEventListener("click", function() {
                            return function(t1, e1) {
                                if (f(t1)) {
                                    var r = +e1.node().getAttribute("data-index");
                                    if (r >= 0) {
                                        if (r === t1._fullLayout._activeSelectionIndex) return void m(t1);
                                        t1._fullLayout._activeSelectionIndex = r, t1._fullLayout._deactivateSelection = m, h(t1);
                                    }
                                }
                            }(t1, C);
                        });
                    }(t1._fullLayout._selectionLayer);
                }
                function d(t1, e1, r) {
                    var n = r.xref + r.yref;
                    s.setClipUrl(t1, "clip" + e1._fullLayout._uid + n, e1);
                }
                function m(t1) {
                    f(t1) && t1._fullLayout._activeSelectionIndex >= 0 && (a(t1), delete t1._fullLayout._activeSelectionIndex, h(t1));
                }
                t1.exports = {
                    draw: h,
                    drawOne: p,
                    activateLastSelection: function(t1) {
                        if (f(t1)) {
                            var e1 = t1._fullLayout.selections.length - 1;
                            t1._fullLayout._activeSelectionIndex = e1, t1._fullLayout._deactivateSelection = m, h(t1);
                        }
                    }
                };
            },
            52307: function(t1, e1, r) {
                "use strict";
                var n = r(94850).T, i = r(93049).extendFlat;
                t1.exports = {
                    newselection: {
                        mode: {
                            valType: "enumerated",
                            values: [
                                "immediate",
                                "gradual"
                            ],
                            dflt: "immediate",
                            editType: "none"
                        },
                        line: {
                            color: {
                                valType: "color",
                                editType: "none"
                            },
                            width: {
                                valType: "number",
                                min: 1,
                                dflt: 1,
                                editType: "none"
                            },
                            dash: i({}, n, {
                                dflt: "dot",
                                editType: "none"
                            }),
                            editType: "none"
                        },
                        editType: "none"
                    },
                    activeselection: {
                        fillcolor: {
                            valType: "color",
                            dflt: "rgba(0,0,0,0)",
                            editType: "none"
                        },
                        opacity: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: .5,
                            editType: "none"
                        },
                        editType: "none"
                    }
                };
            },
            43028: function(t1) {
                "use strict";
                t1.exports = function(t1, e1, r) {
                    r("newselection.mode"), r("newselection.line.width") && (r("newselection.line.color"), r("newselection.line.dash")), r("activeselection.fillcolor"), r("activeselection.opacity");
                };
            },
            51817: function(t1, e1, r) {
                "use strict";
                var n = r(70414).selectMode, i = r(78534).clearOutline, a = r(81055), o = a.readPaths, s = a.writePaths, l = a.fixDatesForPaths;
                t1.exports = function(t1, e1) {
                    if (t1.length) {
                        var r = t1[0][0];
                        if (r) {
                            var a = r.getAttribute("d"), c = e1.gd, u = c._fullLayout.newselection, h = e1.plotinfo, f = h.xaxis, p = h.yaxis, d = e1.isActiveSelection, m = e1.dragmode, g = (c.layout || {}).selections || [];
                            if (!n(m) && void 0 !== d) {
                                var y = c._fullLayout._activeSelectionIndex;
                                if (y < g.length) switch(c._fullLayout.selections[y].type){
                                    case "rect":
                                        m = "select";
                                        break;
                                    case "path":
                                        m = "lasso";
                                }
                            }
                            var v, x = o(a, c, h, d), _ = {
                                xref: f._id,
                                yref: p._id,
                                opacity: u.opacity,
                                line: {
                                    color: u.line.color,
                                    width: u.line.width,
                                    dash: u.line.dash
                                }
                            };
                            1 === x.length && (v = x[0]), v && 5 === v.length && "select" === m ? (_.type = "rect", _.x0 = v[0][1], _.y0 = v[0][2], _.x1 = v[2][1], _.y1 = v[2][2]) : (_.type = "path", f && p && l(x, f, p), _.path = s(x), v = null), i(c);
                            for(var b = e1.editHelpers, w = (b || {}).modifyItem, T = [], k = 0; k < g.length; k++){
                                var A = c._fullLayout.selections[k];
                                if (A) {
                                    if (T[k] = A._input, void 0 !== d && k === c._fullLayout._activeSelectionIndex) {
                                        var M = _;
                                        switch(A.type){
                                            case "rect":
                                                w("x0", M.x0), w("x1", M.x1), w("y0", M.y0), w("y1", M.y1);
                                                break;
                                            case "path":
                                                w("path", M.path);
                                        }
                                    }
                                } else T[k] = A;
                            }
                            return void 0 === d ? (T.push(_), T) : b ? b.getUpdateObj() : {};
                        }
                    }
                };
            },
            49801: function(t1, e1, r) {
                "use strict";
                var n = r(34809).strTranslate;
                function i(t1, e1) {
                    switch(t1.type){
                        case "log":
                            return t1.p2d(e1);
                        case "date":
                            return t1.p2r(e1, 0, t1.calendar);
                        default:
                            return t1.p2r(e1);
                    }
                }
                t1.exports = {
                    p2r: i,
                    r2p: function(t1, e1) {
                        switch(t1.type){
                            case "log":
                                return t1.d2p(e1);
                            case "date":
                                return t1.r2p(e1, 0, t1.calendar);
                            default:
                                return t1.r2p(e1);
                        }
                    },
                    axValue: function(t1) {
                        var e1 = "y" === t1._id.charAt(0) ? 1 : 0;
                        return function(r) {
                            return i(t1, r[e1]);
                        };
                    },
                    getTransform: function(t1) {
                        return n(t1.xaxis._offset, t1.yaxis._offset);
                    }
                };
            },
            44844: function(t1, e1, r) {
                "use strict";
                var n = r(7028), i = r(88666);
                t1.exports = {
                    moduleType: "component",
                    name: "selections",
                    layoutAttributes: r(4327),
                    supplyLayoutDefaults: r(2272),
                    supplyDrawNewSelectionDefaults: r(43028),
                    includeBasePlot: r(20706)("selections"),
                    draw: n.draw,
                    drawOne: n.drawOne,
                    reselect: i.reselect,
                    prepSelect: i.prepSelect,
                    clearOutline: i.clearOutline,
                    clearSelectionsCache: i.clearSelectionsCache,
                    selectOnClick: i.selectOnClick
                };
            },
            88666: function(t1, e1, r) {
                "use strict";
                var n = r(11516), i = r(52773), a = r(33626), o = r(62203).dashStyle, s = r(78766), l = r(32141), c = r(36040).makeEventData, u = r(70414), h = u.freeMode, f = u.rectMode, p = u.drawMode, d = u.openMode, m = u.selectMode, g = r(49728), y = r(2956), v = r(561), x = r(78534).clearOutline, _ = r(81055), b = _.handleEllipse, w = _.readPaths, T = r(87562).newShapes, k = r(51817), A = r(7028).activateLastSelection, M = r(34809), S = M.sorterAsc, E = r(80899), C = r(64025), L = r(5975).getFromId, I = r(34823), P = r(71817).redrawReglTraces, z = r(78865), O = z.MINSELECT, D = E.filter, R = E.tester, F = r(49801), B = F.p2r, N = F.axValue, j = F.getTransform;
                function U(t1) {
                    return void 0 !== t1.subplot;
                }
                function V(t1, e1, r, n, i, a, o) {
                    var s, l, c, u, h, f, p, m, g, y = e1._hoverdata, x = e1._fullLayout.clickmode.indexOf("event") > -1, _ = [];
                    if (function(t1) {
                        return t1 && Array.isArray(t1) && !0 !== t1[0].hoverOnBox;
                    }(y)) {
                        Z(t1, e1, a);
                        var b = function(t1, e1) {
                            var r, n, i = t1[0], a = -1, o = [];
                            for(n = 0; n < e1.length; n++)if (r = e1[n], i.fullData._expandedIndex === r.cd[0].trace._expandedIndex) {
                                if (!0 === i.hoverOnBox) break;
                                void 0 !== i.pointNumber ? a = i.pointNumber : void 0 !== i.binNumber && (a = i.binNumber, o = i.pointNumbers);
                                break;
                            }
                            return {
                                pointNumber: a,
                                pointNumbers: o,
                                searchInfo: r
                            };
                        }(y, s = X(e1, r, n, i));
                        if (b.pointNumbers.length > 0 ? function(t1, e1) {
                            var r, n, i, a = [];
                            for(i = 0; i < t1.length; i++)(r = t1[i]).cd[0].trace.selectedpoints && r.cd[0].trace.selectedpoints.length > 0 && a.push(r);
                            if (1 === a.length && a[0] === e1.searchInfo && (n = e1.searchInfo.cd[0].trace).selectedpoints.length === e1.pointNumbers.length) {
                                for(i = 0; i < e1.pointNumbers.length; i++)if (n.selectedpoints.indexOf(e1.pointNumbers[i]) < 0) return !1;
                                return !0;
                            }
                            return !1;
                        }(s, b) : function(t1) {
                            var e1, r, n = 0;
                            for(r = 0; r < t1.length; r++)if ((e1 = t1[r].cd[0].trace).selectedpoints) {
                                if (e1.selectedpoints.length > 1) return !1;
                                if ((n += e1.selectedpoints.length) > 1) return !1;
                            }
                            return 1 === n;
                        }(s) && (f = J(b))) {
                            for(o && o.remove(), g = 0; g < s.length; g++)(l = s[g])._module.selectPoints(l, !1);
                            K(e1, s), W(a), x && ft(e1);
                        } else {
                            for(p = t1.shiftKey && (void 0 !== f ? f : J(b)), c = function(t1, e1, r) {
                                return {
                                    pointNumber: t1,
                                    searchInfo: e1,
                                    subtract: !!r
                                };
                            }(b.pointNumber, b.searchInfo, p), u = G(a.selectionDefs.concat([
                                c
                            ])), g = 0; g < s.length; g++)if (h = tt(s[g]._module.selectPoints(s[g], u), s[g]), _.length) for(var w = 0; w < h.length; w++)_.push(h[w]);
                            else _ = h;
                            if (K(e1, s, m = {
                                points: _
                            }), c && a && a.selectionDefs.push(c), o) {
                                var T = a.mergedPolygons, k = d(a.dragmode);
                                v(et(T, k), o, a);
                            }
                            x && ht(e1, m);
                        }
                    }
                }
                function q(t1) {
                    return "pointNumber" in t1 && "searchInfo" in t1;
                }
                function H(t1) {
                    return {
                        xmin: 0,
                        xmax: 0,
                        ymin: 0,
                        ymax: 0,
                        pts: [],
                        contains: function(e1, r, n, i) {
                            var a = t1.searchInfo.cd[0].trace._expandedIndex;
                            return i.cd[0].trace._expandedIndex === a && n === t1.pointNumber;
                        },
                        isRect: !1,
                        degenerate: !1,
                        subtract: !!t1.subtract
                    };
                }
                function G(t1) {
                    if (t1.length) {
                        for(var e1 = [], r = q(t1[0]) ? 0 : t1[0][0][0], n = r, i = q(t1[0]) ? 0 : t1[0][0][1], a = i, o = 0; o < t1.length; o++)if (q(t1[o])) e1.push(H(t1[o]));
                        else {
                            var s = R(t1[o]);
                            s.subtract = !!t1[o].subtract, e1.push(s), r = Math.min(r, s.xmin), n = Math.max(n, s.xmax), i = Math.min(i, s.ymin), a = Math.max(a, s.ymax);
                        }
                        return {
                            xmin: r,
                            xmax: n,
                            ymin: i,
                            ymax: a,
                            pts: [],
                            contains: function(t1, r, n, i) {
                                for(var a = !1, o = 0; o < e1.length; o++)e1[o].contains(t1, r, n, i) && (a = !e1[o].subtract);
                                return a;
                            },
                            isRect: !1,
                            degenerate: !1
                        };
                    }
                }
                function Z(t1, e1, r) {
                    var n = e1._fullLayout, i = r.plotinfo, a = r.dragmode, o = n._lastSelectedSubplot && n._lastSelectedSubplot === i.id, s = (t1.shiftKey || t1.altKey) && !(p(a) && d(a));
                    o && s && i.selection && i.selection.selectionDefs && !r.selectionDefs ? (r.selectionDefs = i.selection.selectionDefs, r.mergedPolygons = i.selection.mergedPolygons) : s && i.selection || W(r), o || (x(e1), n._lastSelectedSubplot = i.id);
                }
                function W(t1, e1) {
                    var r = t1.dragmode, n = t1.plotinfo, i = t1.gd;
                    (function(t1) {
                        return t1._fullLayout._activeShapeIndex >= 0;
                    })(i) && i._fullLayout._deactivateShape(i), function(t1) {
                        return t1._fullLayout._activeSelectionIndex >= 0;
                    }(i) && i._fullLayout._deactivateSelection(i);
                    var o = i._fullLayout._zoomlayer, s = p(r), l = m(r);
                    if (s || l) {
                        var c, u, h = o.selectAll(".select-outline-" + n.id);
                        h && i._fullLayout._outlining && (s && (c = T(h, t1)), c && a.call("_guiRelayout", i, {
                            shapes: c
                        }), l && !U(t1) && (u = k(h, t1)), u && (i._fullLayout._noEmitSelectedAtStart = !0, a.call("_guiRelayout", i, {
                            selections: u
                        }).then(function() {
                            e1 && A(i);
                        })), i._fullLayout._outlining = !1);
                    }
                    n.selection = {}, n.selection.selectionDefs = t1.selectionDefs = [], n.selection.mergedPolygons = t1.mergedPolygons = [];
                }
                function Y(t1) {
                    return t1._id;
                }
                function X(t1, e1, r, n) {
                    if (!t1.calcdata) return [];
                    var i, a, o, s = [], l = e1.map(Y), c = r.map(Y);
                    for(o = 0; o < t1.calcdata.length; o++)if (!0 === (a = (i = t1.calcdata[o])[0].trace).visible && a._module && a._module.selectPoints) {
                        if (!U({
                            subplot: n
                        }) || a.subplot !== n && a.geo !== n) {
                            if ("splom" === a.type) {
                                if (a._xaxes[l[0]] && a._yaxes[c[0]]) {
                                    var u = $(a._module, i, e1[0], r[0]);
                                    u.scene = t1._fullLayout._splomScenes[a.uid], s.push(u);
                                }
                            } else if ("sankey" === a.type) {
                                var h = $(a._module, i, e1[0], r[0]);
                                s.push(h);
                            } else {
                                if (!(-1 !== l.indexOf(a.xaxis) || a._xA && a._xA.overlaying)) continue;
                                if (!(-1 !== c.indexOf(a.yaxis) || a._yA && a._yA.overlaying)) continue;
                                s.push($(a._module, i, L(t1, a.xaxis), L(t1, a.yaxis)));
                            }
                        } else s.push($(a._module, i, e1[0], r[0]));
                    }
                    return s;
                }
                function $(t1, e1, r, n) {
                    return {
                        _module: t1,
                        cd: e1,
                        xaxis: r,
                        yaxis: n
                    };
                }
                function J(t1) {
                    var e1 = t1.searchInfo.cd[0].trace, r = t1.pointNumber, n = t1.pointNumbers, i = n.length > 0 ? n[0] : r;
                    return !!e1.selectedpoints && e1.selectedpoints.indexOf(i) > -1;
                }
                function K(t1, e1, r) {
                    var n, i;
                    for(n = 0; n < e1.length; n++){
                        var o = e1[n].cd[0].trace._fullInput, s = t1._fullLayout._tracePreGUI[o.uid] || {};
                        void 0 === s.selectedpoints && (s.selectedpoints = o._input.selectedpoints || null);
                    }
                    if (r) {
                        var l = r.points || [];
                        for(n = 0; n < e1.length; n++)(i = e1[n].cd[0].trace)._input.selectedpoints = i._fullInput.selectedpoints = [], i._fullInput !== i && (i.selectedpoints = []);
                        for(var c = 0; c < l.length; c++){
                            var u = l[c], h = u.data, f = u.fullData, p = u.pointIndex, d = u.pointIndices;
                            d ? ([].push.apply(h.selectedpoints, d), i._fullInput !== i && [].push.apply(f.selectedpoints, d)) : (h.selectedpoints.push(p), i._fullInput !== i && f.selectedpoints.push(p));
                        }
                    } else for(n = 0; n < e1.length; n++)delete (i = e1[n].cd[0].trace).selectedpoints, delete i._input.selectedpoints, i._fullInput !== i && delete i._fullInput.selectedpoints;
                    !function(t1, e1) {
                        for(var r = !1, n = 0; n < e1.length; n++){
                            var i = e1[n], o = i.cd;
                            a.traceIs(o[0].trace, "regl") && (r = !0);
                            var s = i._module, l = s.styleOnSelect || s.style;
                            l && (l(t1, o, o[0].node3), o[0].nodeRangePlot3 && l(t1, o, o[0].nodeRangePlot3));
                        }
                        r && (I(t1), P(t1));
                    }(t1, e1);
                }
                function Q(t1, e1, r) {
                    for(var i = (r ? n.difference : n.union)({
                        regions: t1
                    }, {
                        regions: [
                            e1
                        ]
                    }).regions.reverse(), a = 0; a < i.length; a++){
                        var o = i[a];
                        o.subtract = st(o, i.slice(0, a));
                    }
                    return i;
                }
                function tt(t1, e1) {
                    if (Array.isArray(t1)) for(var r = e1.cd, n = e1.cd[0].trace, i = 0; i < t1.length; i++)t1[i] = c(t1[i], n, r);
                    return t1;
                }
                function et(t1, e1) {
                    for(var r = [], n = 0; n < t1.length; n++){
                        r[n] = [];
                        for(var i = 0; i < t1[n].length; i++){
                            r[n][i] = [], r[n][i][0] = i ? "L" : "M";
                            for(var a = 0; a < t1[n][i].length; a++)r[n][i].push(t1[n][i][a]);
                        }
                        e1 || r[n].push([
                            "Z",
                            r[n][0][1],
                            r[n][0][2]
                        ]);
                    }
                    return r;
                }
                function rt(t1, e1) {
                    for(var r, n, i = [], a = [], o = 0; o < e1.length; o++){
                        var s = e1[o];
                        n = s._module.selectPoints(s, t1), a.push(n), r = tt(n, s), i = i.concat(r);
                    }
                    return i;
                }
                function nt(t1, e1, r, n, i) {
                    var a, o, s, l = !!n;
                    i && (a = i.plotinfo, o = i.xaxes[0]._id, s = i.yaxes[0]._id);
                    var c = [], u = [], h = ot(t1), f = t1._fullLayout;
                    if (a) {
                        var d = f._zoomlayer, g = f.dragmode, y = p(g), v = m(g);
                        if (y || v) {
                            var x = L(t1, o, "x"), _ = L(t1, s, "y");
                            if (x && _) {
                                var b = d.selectAll(".select-outline-" + a.id);
                                if (b && t1._fullLayout._outlining && b.length) {
                                    for(var T = b[0][0].getAttribute("d"), k = w(T, t1, a), A = [], M = 0; M < k.length; M++){
                                        for(var S = k[M], E = [], C = 0; C < S.length; C++)E.push([
                                            lt(x, S[C][1]),
                                            lt(_, S[C][2])
                                        ]);
                                        E.xref = o, E.yref = s, E.subtract = st(E, A), A.push(E);
                                    }
                                    h = h.concat(A);
                                }
                            }
                        }
                    }
                    var I = o && s ? [
                        o + s
                    ] : f._subplots.cartesian;
                    !function(t1) {
                        var e1 = t1.calcdata;
                        if (e1) for(var r = 0; r < e1.length; r++){
                            var n = e1[r][0].trace, i = t1._fullLayout._splomScenes;
                            if (i) {
                                var a = i[n.uid];
                                a && (a.selectBatch = []);
                            }
                        }
                    }(t1);
                    for(var P = {}, z = 0; z < I.length; z++){
                        var O = I[z], D = O.indexOf("y"), R = O.slice(0, D), F = O.slice(D), B = o && s ? r : void 0;
                        if (B = at(h, R, F, B)) {
                            var N = n;
                            if (!l) {
                                var j = L(t1, R, "x"), U = L(t1, F, "y");
                                N = X(t1, [
                                    j
                                ], [
                                    U
                                ], O);
                                for(var V = 0; V < N.length; V++){
                                    var q = N[V], H = q.cd[0], G = H.trace;
                                    if ("scattergl" === q._module.name && !H.t.xpx) {
                                        var Z = G.x, W = G.y, Y = G._length;
                                        H.t.xpx = [], H.t.ypx = [];
                                        for(var $ = 0; $ < Y; $++)H.t.xpx[$] = j.c2p(Z[$]), H.t.ypx[$] = U.c2p(W[$]);
                                    }
                                    "splom" === q._module.name && (P[G.uid] || (P[G.uid] = !0));
                                }
                            }
                            var J = rt(B, N);
                            c = c.concat(J), u = u.concat(N);
                        }
                    }
                    var Q = {
                        points: c
                    };
                    K(t1, u, Q);
                    var tt = f.clickmode.indexOf("event") > -1 && e1;
                    if (!a && e1) {
                        var et = ot(t1, !0);
                        if (et.length) {
                            var nt = et[0].xref, pt = et[0].yref;
                            if (nt && pt) {
                                var dt = ct(et);
                                ut([
                                    L(t1, nt, "x"),
                                    L(t1, pt, "y")
                                ])(Q, dt);
                            }
                        }
                        t1._fullLayout._noEmitSelectedAtStart ? t1._fullLayout._noEmitSelectedAtStart = !1 : tt && ht(t1, Q), f._reselect = !1;
                    }
                    if (!a && f._deselect) {
                        var mt = f._deselect;
                        (function(t1, e1, r) {
                            for(var n = 0; n < r.length; n++){
                                var i = r[n];
                                if (i.xaxis && i.xaxis._id === t1 && i.yaxis && i.yaxis._id === e1) return !0;
                            }
                            return !1;
                        })(o = mt.xref, s = mt.yref, u) || it(t1, o, s, n), tt && (Q.points.length ? ht(t1, Q) : ft(t1)), f._deselect = !1;
                    }
                    return {
                        eventData: Q,
                        selectionTesters: r
                    };
                }
                function it(t1, e1, r, n) {
                    n = X(t1, [
                        L(t1, e1, "x")
                    ], [
                        L(t1, r, "y")
                    ], e1 + r);
                    for(var i = 0; i < n.length; i++){
                        var a = n[i];
                        a._module.selectPoints(a, !1);
                    }
                    K(t1, n);
                }
                function at(t1, e1, r, n) {
                    for(var i, a = 0; a < t1.length; a++){
                        var o = t1[a];
                        e1 === o.xref && r === o.yref && (i ? n = G(i = Q(i, o, !!o.subtract)) : (i = [
                            o
                        ], n = R(o)));
                    }
                    return n;
                }
                function ot(t1, e1) {
                    for(var r = [], n = t1._fullLayout, i = n.selections, a = i.length, o = 0; o < a; o++)if (!e1 || o === n._activeSelectionIndex) {
                        var s = i[o];
                        if (s) {
                            var l, c, u, h, f, p = s.xref, d = s.yref, m = L(t1, p, "x"), v = L(t1, d, "y");
                            if ("rect" === s.type) {
                                f = [];
                                var x = lt(m, s.x0), _ = lt(m, s.x1), b = lt(v, s.y0), w = lt(v, s.y1);
                                f = [
                                    [
                                        x,
                                        b
                                    ],
                                    [
                                        x,
                                        w
                                    ],
                                    [
                                        _,
                                        w
                                    ],
                                    [
                                        _,
                                        b
                                    ]
                                ], l = Math.min(x, _), c = Math.max(x, _), u = Math.min(b, w), h = Math.max(b, w), f.xmin = l, f.xmax = c, f.ymin = u, f.ymax = h, f.xref = p, f.yref = d, f.subtract = !1, f.isRect = !0, r.push(f);
                            } else if ("path" === s.type) for(var T = s.path.split("Z"), k = [], A = 0; A < T.length; A++){
                                var M = T[A];
                                if (M) {
                                    M += "Z";
                                    var S = g.extractPathCoords(M, y.paramIsX, "raw"), E = g.extractPathCoords(M, y.paramIsY, "raw");
                                    l = 1 / 0, c = -1 / 0, u = 1 / 0, h = -1 / 0, f = [];
                                    for(var C = 0; C < S.length; C++){
                                        var I = lt(m, S[C]), P = lt(v, E[C]);
                                        f.push([
                                            I,
                                            P
                                        ]), l = Math.min(I, l), c = Math.max(I, c), u = Math.min(P, u), h = Math.max(P, h);
                                    }
                                    f.xmin = l, f.xmax = c, f.ymin = u, f.ymax = h, f.xref = p, f.yref = d, f.subtract = st(f, k), k.push(f), r.push(f);
                                }
                            }
                        }
                    }
                    return r;
                }
                function st(t1, e1) {
                    for(var r = !1, n = 0; n < e1.length; n++)for(var a = e1[n], o = 0; o < t1.length; o++)if (i(t1[o], a)) {
                        r = !r;
                        break;
                    }
                    return r;
                }
                function lt(t1, e1) {
                    return "date" === t1.type && (e1 = e1.replace("_", " ")), "log" === t1.type ? t1.c2p(e1) : t1.r2p(e1, null, t1.calendar);
                }
                function ct(t1) {
                    for(var e1 = t1.length, r = [], n = 0; n < e1; n++){
                        var i = t1[n];
                        r = (r = r.concat(i)).concat([
                            i[0]
                        ]);
                    }
                    var a;
                    return (a = r).isRect = 5 === a.length && a[0][0] === a[4][0] && a[0][1] === a[4][1] && a[0][0] === a[1][0] && a[2][0] === a[3][0] && a[0][1] === a[3][1] && a[1][1] === a[2][1] || a[0][1] === a[1][1] && a[2][1] === a[3][1] && a[0][0] === a[3][0] && a[1][0] === a[2][0], a.isRect && (a.xmin = Math.min(a[0][0], a[2][0]), a.xmax = Math.max(a[0][0], a[2][0]), a.ymin = Math.min(a[0][1], a[2][1]), a.ymax = Math.max(a[0][1], a[2][1])), a;
                }
                function ut(t1) {
                    return function(e1, r) {
                        for(var n, i, a = 0; a < t1.length; a++){
                            var o = t1[a], s = o._id, l = s.charAt(0);
                            if (r.isRect) {
                                n || (n = {});
                                var c = r[l + "min"], u = r[l + "max"];
                                void 0 !== c && void 0 !== u && (n[s] = [
                                    B(o, c),
                                    B(o, u)
                                ].sort(S));
                            } else i || (i = {}), i[s] = r.map(N(o));
                        }
                        n && (e1.range = n), i && (e1.lassoPoints = i);
                    };
                }
                function ht(t1, e1) {
                    e1 && (e1.selections = (t1.layout || {}).selections || []), t1.emit("plotly_selected", e1);
                }
                function ft(t1) {
                    t1.emit("plotly_deselect", null);
                }
                t1.exports = {
                    reselect: nt,
                    prepSelect: function(t1, e1, r, n, i) {
                        var c = !U(n), u = h(i), g = f(i), y = d(i), x = p(i), _ = m(i), w = "drawcircle" === i, T = "drawline" === i || w, k = n.gd, A = k._fullLayout, S = _ && "immediate" === A.newselection.mode && c, E = A._zoomlayer, L = n.element.getBoundingClientRect(), I = n.plotinfo, P = j(I), F = e1 - L.left, B = r - L.top;
                        A._calcInverseTransform(k);
                        var N = M.apply3DTransform(A._invTransform)(F, B);
                        F = N[0], B = N[1];
                        var q, H, Y, $, J, tt, at, ot = A._invScaleX, st = A._invScaleY, lt = F, pt = B, dt = "M" + F + "," + B, mt = n.xaxes[0], gt = n.yaxes[0], yt = mt._length, vt = gt._length, xt = t1.altKey && !(p(i) && y);
                        Z(t1, k, n), u && (q = D([
                            [
                                F,
                                B
                            ]
                        ], z.BENDPX));
                        var _t = E.selectAll("path.select-outline-" + I.id).data([
                            1
                        ]), bt = x ? A.newshape : A.newselection;
                        x && (n.hasText = bt.label.text || bt.label.texttemplate);
                        var wt = x && !y ? bt.fillcolor : "rgba(0,0,0,0)", Tt = bt.line.color || (c ? s.contrast(k._fullLayout.plot_bgcolor) : "#7f7f7f");
                        _t.enter().append("path").attr("class", "select-outline select-outline-" + I.id).style({
                            opacity: x ? bt.opacity / 2 : 1,
                            "stroke-dasharray": o(bt.line.dash, bt.line.width),
                            "stroke-width": bt.line.width + "px",
                            "shape-rendering": "crispEdges"
                        }).call(s.stroke, Tt).call(s.fill, wt).attr("fill-rule", "evenodd").classed("cursor-move", !!x).attr("transform", P).attr("d", dt + "Z");
                        var kt = E.append("path").attr("class", "zoombox-corners").style({
                            fill: s.background,
                            stroke: s.defaultLine,
                            "stroke-width": 1
                        }).attr("transform", P).attr("d", "M0,0Z");
                        if (x && n.hasText) {
                            var At = E.select(".label-temp");
                            At.empty() && (At = E.append("g").classed("label-temp", !0).classed("select-outline", !0).style({
                                opacity: .8
                            }));
                        }
                        var Mt = A._uid + z.SELECTID, St = [], Et = X(k, n.xaxes, n.yaxes, n.subplot);
                        S && !t1.shiftKey && (n._clearSubplotSelections = function() {
                            if (c) {
                                var t1 = mt._id, e1 = gt._id;
                                it(k, t1, e1, Et);
                                for(var r = (k.layout || {}).selections || [], n = [], i = !1, o = 0; o < r.length; o++){
                                    var s = A.selections[o];
                                    s.xref !== t1 || s.yref !== e1 ? n.push(r[o]) : i = !0;
                                }
                                i && (k._fullLayout._noEmitSelectedAtStart = !0, a.call("_guiRelayout", k, {
                                    selections: n
                                }));
                            }
                        });
                        var Ct = function(t1) {
                            return t1.plotinfo.fillRangeItems || ut(t1.xaxes.concat(t1.yaxes));
                        }(n);
                        n.moveFn = function(t1, e1) {
                            n._clearSubplotSelections && (n._clearSubplotSelections(), n._clearSubplotSelections = void 0), lt = Math.max(0, Math.min(yt, ot * t1 + F)), pt = Math.max(0, Math.min(vt, st * e1 + B));
                            var r = Math.abs(lt - F), i = Math.abs(pt - B);
                            if (g) {
                                var a, o, s;
                                if (_) {
                                    var l = A.selectdirection;
                                    switch(a = "any" === l ? i < Math.min(.6 * r, O) ? "h" : r < Math.min(.6 * i, O) ? "v" : "d" : l){
                                        case "h":
                                            o = w ? vt / 2 : 0, s = vt;
                                            break;
                                        case "v":
                                            o = w ? yt / 2 : 0, s = yt;
                                    }
                                }
                                if (x) switch(A.newshape.drawdirection){
                                    case "vertical":
                                        a = "h", o = w ? vt / 2 : 0, s = vt;
                                        break;
                                    case "horizontal":
                                        a = "v", o = w ? yt / 2 : 0, s = yt;
                                        break;
                                    case "ortho":
                                        r < i ? (a = "h", o = B, s = pt) : (a = "v", o = F, s = lt);
                                        break;
                                    default:
                                        a = "d";
                                }
                                "h" === a ? (($ = T ? b(w, [
                                    lt,
                                    o
                                ], [
                                    lt,
                                    s
                                ]) : [
                                    [
                                        F,
                                        o
                                    ],
                                    [
                                        F,
                                        s
                                    ],
                                    [
                                        lt,
                                        s
                                    ],
                                    [
                                        lt,
                                        o
                                    ]
                                ]).xmin = T ? lt : Math.min(F, lt), $.xmax = T ? lt : Math.max(F, lt), $.ymin = Math.min(o, s), $.ymax = Math.max(o, s), kt.attr("d", "M" + $.xmin + "," + (B - O) + "h-4v" + 2 * O + "h4ZM" + ($.xmax - 1) + "," + (B - O) + "h4v" + 2 * O + "h-4Z")) : "v" === a ? (($ = T ? b(w, [
                                    o,
                                    pt
                                ], [
                                    s,
                                    pt
                                ]) : [
                                    [
                                        o,
                                        B
                                    ],
                                    [
                                        o,
                                        pt
                                    ],
                                    [
                                        s,
                                        pt
                                    ],
                                    [
                                        s,
                                        B
                                    ]
                                ]).xmin = Math.min(o, s), $.xmax = Math.max(o, s), $.ymin = T ? pt : Math.min(B, pt), $.ymax = T ? pt : Math.max(B, pt), kt.attr("d", "M" + (F - O) + "," + $.ymin + "v-4h" + 2 * O + "v4ZM" + (F - O) + "," + ($.ymax - 1) + "v4h" + 2 * O + "v-4Z")) : "d" === a && (($ = T ? b(w, [
                                    F,
                                    B
                                ], [
                                    lt,
                                    pt
                                ]) : [
                                    [
                                        F,
                                        B
                                    ],
                                    [
                                        F,
                                        pt
                                    ],
                                    [
                                        lt,
                                        pt
                                    ],
                                    [
                                        lt,
                                        B
                                    ]
                                ]).xmin = Math.min(F, lt), $.xmax = Math.max(F, lt), $.ymin = Math.min(B, pt), $.ymax = Math.max(B, pt), kt.attr("d", "M0,0Z"));
                            } else u && (q.addPt([
                                lt,
                                pt
                            ]), $ = q.filtered);
                            if (n.selectionDefs && n.selectionDefs.length ? (Y = Q(n.mergedPolygons, $, xt), $.subtract = xt, H = G(n.selectionDefs.concat([
                                $
                            ]))) : (Y = [
                                $
                            ], H = R($)), v(et(Y, y), _t, n), _) {
                                var c, h = nt(k, !1), f = h.eventData ? h.eventData.points.slice() : [];
                                h = nt(k, !1, H, Et, n), H = h.selectionTesters, at = h.eventData, c = q ? q.filtered : ct(Y), C.throttle(Mt, z.SELECTDELAY, function() {
                                    for(var t1 = (St = rt(H, Et)).slice(), e1 = 0; e1 < f.length; e1++){
                                        for(var r = f[e1], n = !1, i = 0; i < t1.length; i++)if (t1[i].curveNumber === r.curveNumber && t1[i].pointNumber === r.pointNumber) {
                                            n = !0;
                                            break;
                                        }
                                        n || t1.push(r);
                                    }
                                    t1.length && (at || (at = {}), at.points = t1), Ct(at, c), function(t1, e1) {
                                        t1.emit("plotly_selecting", e1);
                                    }(k, at);
                                });
                            }
                        }, n.clickFn = function(t1, e1) {
                            if (kt.remove(), k._fullLayout._activeShapeIndex >= 0) k._fullLayout._deactivateShape(k);
                            else if (!x) {
                                var r = A.clickmode;
                                C.done(Mt).then(function() {
                                    if (C.clear(Mt), 2 === t1) {
                                        for(_t.remove(), J = 0; J < Et.length; J++)(tt = Et[J])._module.selectPoints(tt, !1);
                                        if (K(k, Et), W(n), ft(k), Et.length) {
                                            var i = Et[0].xaxis, o = Et[0].yaxis;
                                            if (i && o) {
                                                for(var s = [], c = k._fullLayout.selections, u = 0; u < c.length; u++){
                                                    var h = c[u];
                                                    h && (h.xref === i._id && h.yref === o._id || s.push(h));
                                                }
                                                s.length < c.length && (k._fullLayout._noEmitSelectedAtStart = !0, a.call("_guiRelayout", k, {
                                                    selections: s
                                                }));
                                            }
                                        }
                                    } else r.indexOf("select") > -1 && V(e1, k, n.xaxes, n.yaxes, n.subplot, n, _t), "event" === r && ht(k, void 0);
                                    l.click(k, e1, I.id);
                                }).catch(M.error);
                            }
                        }, n.doneFn = function() {
                            kt.remove(), C.done(Mt).then(function() {
                                C.clear(Mt), !S && $ && n.selectionDefs && ($.subtract = xt, n.selectionDefs.push($), n.mergedPolygons.length = 0, [].push.apply(n.mergedPolygons, Y)), (S || x) && W(n, S), n.doneFnCompleted && n.doneFnCompleted(St), _ && ht(k, at);
                            }).catch(M.error);
                        };
                    },
                    clearOutline: x,
                    clearSelectionsCache: W,
                    selectOnClick: V
                };
            },
            43144: function(t1, e1, r) {
                "use strict";
                var n = r(50222), i = r(80337), a = r(36640).line, o = r(94850).T, s = r(93049).extendFlat, l = r(78032).templatedArray, c = (r(35081), r(9829)), u = r(3208).LF, h = r(41235);
                t1.exports = l("shape", {
                    visible: s({}, c.visible, {
                        editType: "calc+arraydraw"
                    }),
                    showlegend: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "calc+arraydraw"
                    },
                    legend: s({}, c.legend, {
                        editType: "calc+arraydraw"
                    }),
                    legendgroup: s({}, c.legendgroup, {
                        editType: "calc+arraydraw"
                    }),
                    legendgrouptitle: {
                        text: s({}, c.legendgrouptitle.text, {
                            editType: "calc+arraydraw"
                        }),
                        font: i({
                            editType: "calc+arraydraw"
                        }),
                        editType: "calc+arraydraw"
                    },
                    legendrank: s({}, c.legendrank, {
                        editType: "calc+arraydraw"
                    }),
                    legendwidth: s({}, c.legendwidth, {
                        editType: "calc+arraydraw"
                    }),
                    type: {
                        valType: "enumerated",
                        values: [
                            "circle",
                            "rect",
                            "path",
                            "line"
                        ],
                        editType: "calc+arraydraw"
                    },
                    layer: {
                        valType: "enumerated",
                        values: [
                            "below",
                            "above",
                            "between"
                        ],
                        dflt: "above",
                        editType: "arraydraw"
                    },
                    xref: s({}, n.xref, {}),
                    xsizemode: {
                        valType: "enumerated",
                        values: [
                            "scaled",
                            "pixel"
                        ],
                        dflt: "scaled",
                        editType: "calc+arraydraw"
                    },
                    xanchor: {
                        valType: "any",
                        editType: "calc+arraydraw"
                    },
                    x0: {
                        valType: "any",
                        editType: "calc+arraydraw"
                    },
                    x1: {
                        valType: "any",
                        editType: "calc+arraydraw"
                    },
                    x0shift: {
                        valType: "number",
                        dflt: 0,
                        min: -1,
                        max: 1,
                        editType: "calc"
                    },
                    x1shift: {
                        valType: "number",
                        dflt: 0,
                        min: -1,
                        max: 1,
                        editType: "calc"
                    },
                    yref: s({}, n.yref, {}),
                    ysizemode: {
                        valType: "enumerated",
                        values: [
                            "scaled",
                            "pixel"
                        ],
                        dflt: "scaled",
                        editType: "calc+arraydraw"
                    },
                    yanchor: {
                        valType: "any",
                        editType: "calc+arraydraw"
                    },
                    y0: {
                        valType: "any",
                        editType: "calc+arraydraw"
                    },
                    y1: {
                        valType: "any",
                        editType: "calc+arraydraw"
                    },
                    y0shift: {
                        valType: "number",
                        dflt: 0,
                        min: -1,
                        max: 1,
                        editType: "calc"
                    },
                    y1shift: {
                        valType: "number",
                        dflt: 0,
                        min: -1,
                        max: 1,
                        editType: "calc"
                    },
                    path: {
                        valType: "string",
                        editType: "calc+arraydraw"
                    },
                    opacity: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 1,
                        editType: "arraydraw"
                    },
                    line: {
                        color: s({}, a.color, {
                            editType: "arraydraw"
                        }),
                        width: s({}, a.width, {
                            editType: "calc+arraydraw"
                        }),
                        dash: s({}, o, {
                            editType: "arraydraw"
                        }),
                        editType: "calc+arraydraw"
                    },
                    fillcolor: {
                        valType: "color",
                        dflt: "rgba(0,0,0,0)",
                        editType: "arraydraw"
                    },
                    fillrule: {
                        valType: "enumerated",
                        values: [
                            "evenodd",
                            "nonzero"
                        ],
                        dflt: "evenodd",
                        editType: "arraydraw"
                    },
                    editable: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "calc+arraydraw"
                    },
                    label: {
                        text: {
                            valType: "string",
                            dflt: "",
                            editType: "arraydraw"
                        },
                        texttemplate: u({}, {
                            keys: Object.keys(h)
                        }),
                        font: i({
                            editType: "calc+arraydraw",
                            colorEditType: "arraydraw"
                        }),
                        textposition: {
                            valType: "enumerated",
                            values: [
                                "top left",
                                "top center",
                                "top right",
                                "middle left",
                                "middle center",
                                "middle right",
                                "bottom left",
                                "bottom center",
                                "bottom right",
                                "start",
                                "middle",
                                "end"
                            ],
                            editType: "arraydraw"
                        },
                        textangle: {
                            valType: "angle",
                            dflt: "auto",
                            editType: "calc+arraydraw"
                        },
                        xanchor: {
                            valType: "enumerated",
                            values: [
                                "auto",
                                "left",
                                "center",
                                "right"
                            ],
                            dflt: "auto",
                            editType: "calc+arraydraw"
                        },
                        yanchor: {
                            valType: "enumerated",
                            values: [
                                "top",
                                "middle",
                                "bottom"
                            ],
                            editType: "calc+arraydraw"
                        },
                        padding: {
                            valType: "number",
                            dflt: 3,
                            min: 0,
                            editType: "arraydraw"
                        },
                        editType: "arraydraw"
                    },
                    editType: "arraydraw"
                });
            },
            44959: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(29714), a = r(2956), o = r(49728);
                function s(t1) {
                    return c(t1.line.width, t1.xsizemode, t1.x0, t1.x1, t1.path, !1);
                }
                function l(t1) {
                    return c(t1.line.width, t1.ysizemode, t1.y0, t1.y1, t1.path, !0);
                }
                function c(t1, e1, r, i, s, l) {
                    var c = t1 / 2, u = l;
                    if ("pixel" === e1) {
                        var h = s ? o.extractPathCoords(s, l ? a.paramIsY : a.paramIsX) : [
                            r,
                            i
                        ], f = n.aggNums(Math.max, null, h), p = n.aggNums(Math.min, null, h), d = p < 0 ? Math.abs(p) + c : c, m = f > 0 ? f + c : c;
                        return {
                            ppad: c,
                            ppadplus: u ? d : m,
                            ppadminus: u ? m : d
                        };
                    }
                    return {
                        ppad: c
                    };
                }
                function u(t1, e1, r) {
                    var n, i, s = "x" === t1._id.charAt(0) ? "x" : "y", l = "category" === t1.type || "multicategory" === t1.type, c = 0, u = 0, h = l ? t1.r2c : t1.d2c;
                    if ("scaled" === e1[s + "sizemode"] ? (n = e1[s + "0"], i = e1[s + "1"], l && (c = e1[s + "0shift"], u = e1[s + "1shift"])) : (n = e1[s + "anchor"], i = e1[s + "anchor"]), void 0 !== n) return [
                        h(n) + c,
                        h(i) + u
                    ];
                    if (e1.path) {
                        var f, p, d, m, g = 1 / 0, y = -1 / 0, v = e1.path.match(a.segmentRE);
                        for("date" === t1.type && (h = o.decodeDate(h)), f = 0; f < v.length; f++)void 0 !== (p = r[v[f].charAt(0)].drawn) && (!(d = v[f].substr(1).match(a.paramRE)) || d.length < p || ((m = h(d[p])) < g && (g = m), m > y && (y = m)));
                        return y >= g ? [
                            g,
                            y
                        ] : void 0;
                    }
                }
                t1.exports = function(t1) {
                    var e1 = t1._fullLayout, r = n.filterVisible(e1.shapes);
                    if (r.length && t1._fullData.length) for(var o = 0; o < r.length; o++){
                        var c, h, f = r[o];
                        f._extremes = {};
                        var p = i.getRefType(f.xref), d = i.getRefType(f.yref);
                        "paper" !== f.xref && "domain" !== p && (h = u(c = i.getFromId(t1, f.xref), f, a.paramIsX)) && (f._extremes[c._id] = i.findExtremes(c, h, s(f))), "paper" !== f.yref && "domain" !== d && (h = u(c = i.getFromId(t1, f.yref), f, a.paramIsY)) && (f._extremes[c._id] = i.findExtremes(c, h, l(f)));
                    }
                };
            },
            2956: function(t1) {
                "use strict";
                t1.exports = {
                    segmentRE: /[MLHVQCTSZ][^MLHVQCTSZ]*/g,
                    paramRE: /[^\s,]+/g,
                    paramIsX: {
                        M: {
                            0: !0,
                            drawn: 0
                        },
                        L: {
                            0: !0,
                            drawn: 0
                        },
                        H: {
                            0: !0,
                            drawn: 0
                        },
                        V: {},
                        Q: {
                            0: !0,
                            2: !0,
                            drawn: 2
                        },
                        C: {
                            0: !0,
                            2: !0,
                            4: !0,
                            drawn: 4
                        },
                        T: {
                            0: !0,
                            drawn: 0
                        },
                        S: {
                            0: !0,
                            2: !0,
                            drawn: 2
                        },
                        Z: {}
                    },
                    paramIsY: {
                        M: {
                            1: !0,
                            drawn: 1
                        },
                        L: {
                            1: !0,
                            drawn: 1
                        },
                        H: {},
                        V: {
                            0: !0,
                            drawn: 0
                        },
                        Q: {
                            1: !0,
                            3: !0,
                            drawn: 3
                        },
                        C: {
                            1: !0,
                            3: !0,
                            5: !0,
                            drawn: 5
                        },
                        T: {
                            1: !0,
                            drawn: 1
                        },
                        S: {
                            1: !0,
                            3: !0,
                            drawn: 5
                        },
                        Z: {}
                    },
                    numParams: {
                        M: 2,
                        L: 2,
                        H: 1,
                        V: 1,
                        Q: 4,
                        C: 6,
                        T: 2,
                        S: 4,
                        Z: 0
                    }
                };
            },
            74367: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(29714), a = r(59008), o = r(43144), s = r(49728);
                function l(t1, e1, r) {
                    function a(r, i) {
                        return n.coerce(t1, e1, o, r, i);
                    }
                    if (e1._isShape = !0, a("visible")) {
                        a("showlegend") && (a("legend"), a("legendwidth"), a("legendgroup"), a("legendgrouptitle.text"), n.coerceFont(a, "legendgrouptitle.font"), a("legendrank"));
                        var l = a("path"), c = a("type", l ? "path" : "rect"), u = "path" !== c;
                        u && delete e1.path, a("editable"), a("layer"), a("opacity"), a("fillcolor"), a("fillrule"), a("line.width") && (a("line.color"), a("line.dash"));
                        for(var h = a("xsizemode"), f = a("ysizemode"), p = [
                            "x",
                            "y"
                        ], d = 0; d < 2; d++){
                            var m, g, y, v = p[d], x = v + "anchor", _ = "x" === v ? h : f, b = {
                                _fullLayout: r
                            }, w = i.coerceRef(t1, e1, b, v, void 0, "paper");
                            if ("range" === i.getRefType(w) ? ((m = i.getFromId(b, w))._shapeIndices.push(e1._index), y = s.rangeToShapePosition(m), g = s.shapePositionToRange(m), "category" !== m.type && "multicategory" !== m.type || (a(v + "0shift"), a(v + "1shift"))) : g = y = n.identity, u) {
                                var T = v + "0", k = v + "1", A = t1[T], M = t1[k];
                                t1[T] = g(t1[T], !0), t1[k] = g(t1[k], !0), "pixel" === _ ? (a(T, 0), a(k, 10)) : (i.coercePosition(e1, b, a, w, T, .25), i.coercePosition(e1, b, a, w, k, .75)), e1[T] = y(e1[T]), e1[k] = y(e1[k]), t1[T] = A, t1[k] = M;
                            }
                            if ("pixel" === _) {
                                var S = t1[x];
                                t1[x] = g(t1[x], !0), i.coercePosition(e1, b, a, w, x, .25), e1[x] = y(e1[x]), t1[x] = S;
                            }
                        }
                        u && n.noneOrAll(t1, e1, [
                            "x0",
                            "x1",
                            "y0",
                            "y1"
                        ]);
                        var E, C, L = "line" === c;
                        if (u && (E = a("label.texttemplate")), E || (C = a("label.text")), C || E) {
                            a("label.textangle");
                            var I = a("label.textposition", L ? "middle" : "middle center");
                            a("label.xanchor"), a("label.yanchor", function(t1, e1) {
                                return t1 ? "bottom" : -1 !== e1.indexOf("top") ? "top" : -1 !== e1.indexOf("bottom") ? "bottom" : "middle";
                            }(L, I)), a("label.padding"), n.coerceFont(a, "label.font", r.font);
                        }
                    }
                }
                t1.exports = function(t1, e1) {
                    a(t1, e1, {
                        name: "shapes",
                        handleItemDefaults: l
                    });
                };
            },
            44433: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(29714), a = r(30635), o = r(62203), s = r(81055).readPaths, l = r(49728), c = l.getPathString, u = r(41235), h = r(4530).FROM_TL;
                t1.exports = function(t1, e1, r, f) {
                    if (f.selectAll(".shape-label").remove(), r.label.text || r.label.texttemplate) {
                        var p;
                        if (r.label.texttemplate) {
                            var d = {};
                            if ("path" !== r.type) {
                                var m = i.getFromId(t1, r.xref), g = i.getFromId(t1, r.yref);
                                for(var y in u){
                                    var v = u[y](r, m, g);
                                    void 0 !== v && (d[y] = v);
                                }
                            }
                            p = n.texttemplateStringForShapes(r.label.texttemplate, {}, t1._fullLayout._d3locale, d);
                        } else p = r.label.text;
                        var x, _, b, w, T = {
                            "data-index": e1
                        }, k = r.label.font, A = f.append("g").attr(T).classed("shape-label", !0).append("text").attr({
                            "data-notex": 1
                        }).classed("shape-label-text", !0).text(p);
                        if (r.path) {
                            var M = c(t1, r), S = s(M, t1);
                            x = 1 / 0, b = 1 / 0, _ = -1 / 0, w = -1 / 0;
                            for(var E = 0; E < S.length; E++)for(var C = 0; C < S[E].length; C++)for(var L = S[E][C], I = 1; I < L.length; I += 2){
                                var P = L[I], z = L[I + 1];
                                x = Math.min(x, P), _ = Math.max(_, P), b = Math.min(b, z), w = Math.max(w, z);
                            }
                        } else {
                            var O = i.getFromId(t1, r.xref), D = r.x0shift, R = r.x1shift, F = i.getRefType(r.xref), B = i.getFromId(t1, r.yref), N = r.y0shift, j = r.y1shift, U = i.getRefType(r.yref), V = function(e1, r) {
                                return l.getDataToPixel(t1, O, r, !1, F)(e1);
                            }, q = function(e1, r) {
                                return l.getDataToPixel(t1, B, r, !0, U)(e1);
                            };
                            x = V(r.x0, D), _ = V(r.x1, R), b = q(r.y0, N), w = q(r.y1, j);
                        }
                        var H = r.label.textangle;
                        "auto" === H && (H = "line" === r.type ? function(t1, e1, r, n) {
                            var i, a;
                            return a = Math.abs(r - t1), i = r >= t1 ? e1 - n : n - e1, -180 / Math.PI * Math.atan2(i, a);
                        }(x, b, _, w) : 0), A.call(function(e1) {
                            return e1.call(o.font, k).attr({}), a.convertToTspans(e1, t1), e1;
                        });
                        var G = function(t1, e1, r, n, i, a, o) {
                            var s, l, c, u, f = i.label.textposition, p = i.label.textangle, d = i.label.padding, m = i.type, g = Math.PI / 180 * a, y = Math.sin(g), v = Math.cos(g), x = i.label.xanchor, _ = i.label.yanchor;
                            if ("line" === m) {
                                "start" === f ? (s = t1, l = e1) : "end" === f ? (s = r, l = n) : (s = (t1 + r) / 2, l = (e1 + n) / 2), "auto" === x && (x = "start" === f ? "auto" === p ? r > t1 ? "left" : r < t1 ? "right" : "center" : r > t1 ? "right" : r < t1 ? "left" : "center" : "end" === f ? "auto" === p ? r > t1 ? "right" : r < t1 ? "left" : "center" : r > t1 ? "left" : r < t1 ? "right" : "center" : "center");
                                var b = {
                                    bottom: -1,
                                    middle: 0,
                                    top: 1
                                };
                                if ("auto" === p) {
                                    var w = b[_];
                                    c = -d * y * w, u = d * v * w;
                                } else c = d * ({
                                    left: 1,
                                    center: 0,
                                    right: -1
                                })[x], u = d * b[_];
                                s += c, l += u;
                            } else c = d + 3, -1 !== f.indexOf("right") ? (s = Math.max(t1, r) - c, "auto" === x && (x = "right")) : -1 !== f.indexOf("left") ? (s = Math.min(t1, r) + c, "auto" === x && (x = "left")) : (s = (t1 + r) / 2, "auto" === x && (x = "center")), l = -1 !== f.indexOf("top") ? Math.min(e1, n) : -1 !== f.indexOf("bottom") ? Math.max(e1, n) : (e1 + n) / 2, u = d, "bottom" === _ ? l -= u : "top" === _ && (l += u);
                            var T = h[_], k = i.label.font.size, A = o.height;
                            return {
                                textx: s + (A * T - k) * y,
                                texty: l + -(A * T - k) * v,
                                xanchor: x
                            };
                        }(x, b, _, w, r, H, o.bBox(A.node())), Z = G.textx, W = G.texty, Y = G.xanchor;
                        A.attr({
                            "text-anchor": {
                                left: "start",
                                center: "middle",
                                right: "end"
                            }[Y],
                            y: W,
                            x: Z,
                            transform: "rotate(" + H + "," + Z + "," + W + ")"
                        }).call(a.positionText, Z, W);
                    }
                };
            },
            561: function(t1, e1, r) {
                "use strict";
                var n = r(34809).strTranslate, i = r(14751), a = r(70414), o = a.drawMode, s = a.selectMode, l = r(33626), c = r(78766), u = r(93391), h = u.i000, f = u.i090, p = u.i180, d = u.i270, m = r(78534).clearOutlineControllers, g = r(81055), y = g.pointsOnRectangle, v = g.pointsOnEllipse, x = g.writePaths, _ = r(87562).newShapes, b = r(87562).createShapeObj, w = r(51817), T = r(44433);
                function k(t1, e1) {
                    var r, n, i, a = t1[e1][1], o = t1[e1][2], s = t1.length;
                    return n = t1[r = (e1 + 1) % s][1], i = t1[r][2], n === a && i === o && (n = t1[r = (e1 + 2) % s][1], i = t1[r][2]), [
                        r,
                        n,
                        i
                    ];
                }
                t1.exports = function t1(e1, r, a, u) {
                    u || (u = 0);
                    var g = a.gd;
                    function A() {
                        t1(e1, r, a, u++), (v(e1[0]) || a.hasText) && M({
                            redrawing: !0
                        });
                    }
                    function M(t1) {
                        var e1 = {};
                        void 0 !== a.isActiveShape && (a.isActiveShape = !1, e1 = _(r, a)), void 0 !== a.isActiveSelection && (a.isActiveSelection = !1, e1 = w(r, a), g._fullLayout._reselect = !0), Object.keys(e1).length && l.call((t1 || {}).redrawing ? "relayout" : "_guiRelayout", g, e1);
                    }
                    var S, E, C, L, I, P = g._fullLayout._zoomlayer, z = a.dragmode, O = o(z), D = s(z);
                    if ((O || D) && (g._fullLayout._outlining = !0), m(g), r.attr("d", x(e1)), u || !a.isActiveShape && !a.isActiveSelection || (I = function(t1, e1) {
                        for(var r = 0; r < e1.length; r++){
                            var n = e1[r];
                            t1[r] = [];
                            for(var i = 0; i < n.length; i++){
                                t1[r][i] = [];
                                for(var a = 0; a < n[i].length; a++)t1[r][i][a] = n[i][a];
                            }
                        }
                        return t1;
                    }([], e1), function(t1) {
                        S = [];
                        for(var r = 0; r < e1.length; r++){
                            var o = e1[r], s = y(o), l = !s && v(o);
                            S[r] = [];
                            for(var u = o.length, m = 0; m < u; m++)if ("Z" !== o[m][0] && (!l || m === h || m === f || m === p || m === d)) {
                                var x, _ = s && a.isActiveSelection;
                                _ && (x = k(o, m));
                                var b = o[m][1], w = o[m][2], T = t1.append(_ ? "rect" : "circle").attr("data-i", r).attr("data-j", m).style({
                                    fill: c.background,
                                    stroke: c.defaultLine,
                                    "stroke-width": 1,
                                    "shape-rendering": "crispEdges"
                                });
                                if (_) {
                                    var A = x[1] - b, M = x[2] - w, E = M ? 5 : Math.max(Math.min(25, Math.abs(A) - 5), 5), C = A ? 5 : Math.max(Math.min(25, Math.abs(M) - 5), 5);
                                    T.classed(M ? "cursor-ew-resize" : "cursor-ns-resize", !0).attr("width", E).attr("height", C).attr("x", b - E / 2).attr("y", w - C / 2).attr("transform", n(A / 2, M / 2));
                                } else T.classed("cursor-grab", !0).attr("r", 5).attr("cx", b).attr("cy", w);
                                S[r][m] = {
                                    element: T.node(),
                                    gd: g,
                                    prepFn: B,
                                    doneFn: j,
                                    clickFn: U
                                }, i.init(S[r][m]);
                            }
                        }
                    }(P.append("g").attr("class", "outline-controllers")), function() {
                        if (E = [], e1.length) E[0] = {
                            element: r[0][0],
                            gd: g,
                            prepFn: q,
                            doneFn: H,
                            clickFn: G
                        }, i.init(E[0]);
                    }()), O && a.hasText) {
                        var R = P.select(".label-temp"), F = b(r, a, a.dragmode);
                        T(g, "label-temp", F, R);
                    }
                    function B(t1) {
                        C = +t1.srcElement.getAttribute("data-i"), L = +t1.srcElement.getAttribute("data-j"), S[C][L].moveFn = N;
                    }
                    function N(t1, r) {
                        if (e1.length) {
                            var n = I[C][L][1], i = I[C][L][2], o = e1[C], s = o.length;
                            if (y(o)) {
                                var l = t1, c = r;
                                a.isActiveSelection && (k(o, L)[1] === o[L][1] ? c = 0 : l = 0);
                                for(var u = 0; u < s; u++)if (u !== L) {
                                    var h = o[u];
                                    h[1] === o[L][1] && (h[1] = n + l), h[2] === o[L][2] && (h[2] = i + c);
                                }
                                if (o[L][1] = n + l, o[L][2] = i + c, !y(o)) for(var f = 0; f < s; f++)for(var p = 0; p < o[f].length; p++)o[f][p] = I[C][f][p];
                            } else o[L][1] = n + t1, o[L][2] = i + r;
                            A();
                        }
                    }
                    function j() {
                        M();
                    }
                    function U(t1, r) {
                        if (2 === t1) {
                            C = +r.srcElement.getAttribute("data-i"), L = +r.srcElement.getAttribute("data-j");
                            var n = e1[C];
                            y(n) || v(n) || function() {
                                if (e1.length && e1[C] && e1[C].length) {
                                    for(var t1 = [], r = 0; r < e1[C].length; r++)r !== L && t1.push(e1[C][r]);
                                    t1.length > 1 && (2 !== t1.length || "Z" !== t1[1][0]) && (0 === L && (t1[0][0] = "M"), e1[C] = t1, A(), M());
                                }
                            }();
                        }
                    }
                    function V(t1, r) {
                        !function(t1, r) {
                            if (e1.length) for(var n = 0; n < e1.length; n++)for(var i = 0; i < e1[n].length; i++)for(var a = 0; a + 2 < e1[n][i].length; a += 2)e1[n][i][a + 1] = I[n][i][a + 1] + t1, e1[n][i][a + 2] = I[n][i][a + 2] + r;
                        }(t1, r), A();
                    }
                    function q(t1) {
                        (C = +t1.srcElement.getAttribute("data-i")) || (C = 0), E[C].moveFn = V;
                    }
                    function H() {
                        M();
                    }
                    function G(t1) {
                        2 === t1 && function(t1) {
                            if (s(t1._fullLayout.dragmode)) {
                                m(t1);
                                var e1 = t1._fullLayout._activeSelectionIndex, r = (t1.layout || {}).selections || [];
                                if (e1 < r.length) {
                                    for(var n = [], i = 0; i < r.length; i++)i !== e1 && n.push(r[i]);
                                    delete t1._fullLayout._activeSelectionIndex;
                                    var a = t1._fullLayout.selections[e1];
                                    t1._fullLayout._deselect = {
                                        xref: a.xref,
                                        yref: a.yref
                                    }, l.call("_guiRelayout", t1, {
                                        selections: n
                                    });
                                }
                            }
                        }(g);
                    }
                };
            },
            28231: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(33626), a = r(34809), o = r(29714), s = r(81055).readPaths, l = r(561), c = r(44433), u = r(78534).clearOutlineControllers, h = r(78766), f = r(62203), p = r(78032).arrayEditor, d = r(14751), m = r(27983), g = r(2956), y = r(49728), v = y.getPathString;
                function x(t1) {
                    var e1 = t1._fullLayout;
                    for(var r in e1._shapeUpperLayer.selectAll("path").remove(), e1._shapeLowerLayer.selectAll("path").remove(), e1._shapeUpperLayer.selectAll("text").remove(), e1._shapeLowerLayer.selectAll("text").remove(), e1._plots){
                        var n = e1._plots[r].shapelayer;
                        n && (n.selectAll("path").remove(), n.selectAll("text").remove());
                    }
                    for(var i = 0; i < e1.shapes.length; i++)!0 === e1.shapes[i].visible && w(t1, i);
                }
                function _(t1) {
                    return !!t1._fullLayout._outlining;
                }
                function b(t1) {
                    return !t1._context.edits.shapePosition;
                }
                function w(t1, e1) {
                    t1._fullLayout._paperdiv.selectAll('.shapelayer [data-index="' + e1 + '"]').remove();
                    var r = y.makeShapesOptionsAndPlotinfo(t1, e1), u = r.options, w = r.plotinfo;
                    function M(r) {
                        var M = v(t1, u), S = {
                            "data-index": e1,
                            "fill-rule": u.fillrule,
                            d: M
                        }, E = u.opacity, C = u.fillcolor, L = u.line.width ? u.line.color : "rgba(0,0,0,0)", I = u.line.width, P = u.line.dash;
                        I || !0 !== u.editable || (I = 5, P = "solid");
                        var z = "Z" !== M[M.length - 1], O = b(t1) && u.editable && t1._fullLayout._activeShapeIndex === e1;
                        O && (C = z ? "rgba(0,0,0,0)" : t1._fullLayout.activeshape.fillcolor, E = t1._fullLayout.activeshape.opacity);
                        var D, R = r.append("g").classed("shape-group", !0).attr({
                            "data-index": e1
                        }), F = R.append("path").attr(S).style("opacity", E).call(h.stroke, L).call(h.fill, C).call(f.dashLine, P, I);
                        if (T(R, t1, u), c(t1, e1, u, R), (O || t1._context.edits.shapePosition) && (D = p(t1.layout, "shapes", u)), O) {
                            F.style({
                                cursor: "move"
                            });
                            var B = {
                                element: F.node(),
                                plotinfo: w,
                                gd: t1,
                                editHelpers: D,
                                hasText: u.label.text || u.label.texttemplate,
                                isActiveShape: !0
                            }, N = s(M, t1);
                            l(N, F, B);
                        } else t1._context.edits.shapePosition ? function(t1, e1, r, s, l, u) {
                            var h, p, x, b, w, A, M, S, E, C, L, I, P, z, O, D, R = 10, F = 10, B = "pixel" === r.xsizemode, N = "pixel" === r.ysizemode, j = "line" === r.type, U = "path" === r.type, V = u.modifyItem, q = n.select(e1.node().parentNode), H = o.getFromId(t1, r.xref), G = o.getRefType(r.xref), Z = o.getFromId(t1, r.yref), W = o.getRefType(r.yref), Y = r.x0shift, X = r.x1shift, $ = r.y0shift, J = r.y1shift, K = function(e1, r) {
                                return y.getDataToPixel(t1, H, r, !1, G)(e1);
                            }, Q = function(e1, r) {
                                return y.getDataToPixel(t1, Z, r, !0, W)(e1);
                            }, tt = y.getPixelToData(t1, H, !1, G), et = y.getPixelToData(t1, Z, !0, W), rt = j ? function() {
                                var t1 = 10, n = Math.max(r.line.width, t1), i = l.append("g").attr("data-index", s).attr("drag-helper", !0);
                                i.append("path").attr("d", e1.attr("d")).style({
                                    cursor: "move",
                                    "stroke-width": n,
                                    "stroke-opacity": "0"
                                });
                                var a = {
                                    "fill-opacity": "0"
                                }, o = Math.max(n / 2, t1);
                                return i.append("circle").attr({
                                    "data-line-point": "start-point",
                                    cx: B ? K(r.xanchor) + r.x0 : K(r.x0, Y),
                                    cy: N ? Q(r.yanchor) - r.y0 : Q(r.y0, $),
                                    r: o
                                }).style(a).classed("cursor-grab", !0), i.append("circle").attr({
                                    "data-line-point": "end-point",
                                    cx: B ? K(r.xanchor) + r.x1 : K(r.x1, X),
                                    cy: N ? Q(r.yanchor) - r.y1 : Q(r.y1, J),
                                    r: o
                                }).style(a).classed("cursor-grab", !0), i;
                            }() : e1, nt = {
                                element: rt.node(),
                                gd: t1,
                                prepFn: function(n) {
                                    _(t1) || (B && (w = K(r.xanchor)), N && (A = Q(r.yanchor)), "path" === r.type ? O = r.path : (h = B ? r.x0 : K(r.x0), p = N ? r.y0 : Q(r.y0), x = B ? r.x1 : K(r.x1), b = N ? r.y1 : Q(r.y1)), h < x ? (E = h, P = "x0", C = x, z = "x1") : (E = x, P = "x1", C = h, z = "x0"), !N && p < b || N && p > b ? (M = p, L = "y0", S = b, I = "y1") : (M = b, L = "y1", S = p, I = "y0"), it(n), st(l, r), function(t1, e1, r) {
                                        var n = e1.xref, i = e1.yref, a = o.getFromId(r, n), s = o.getFromId(r, i), l = "";
                                        "paper" === n || a.autorange || (l += n), "paper" === i || s.autorange || (l += i), f.setClipUrl(t1, l ? "clip" + r._fullLayout._uid + l : null, r);
                                    }(e1, r, t1), nt.moveFn = "move" === D ? at : ot, nt.altKey = n.altKey);
                                },
                                doneFn: function() {
                                    _(t1) || (m(e1), lt(l), T(e1, t1, r), i.call("_guiRelayout", t1, u.getUpdateObj()));
                                },
                                clickFn: function() {
                                    _(t1) || lt(l);
                                }
                            };
                            function it(r) {
                                if (_(t1)) D = null;
                                else if (j) D = "path" === r.target.tagName ? "move" : "start-point" === r.target.attributes["data-line-point"].value ? "resize-over-start-point" : "resize-over-end-point";
                                else {
                                    var n = nt.element.getBoundingClientRect(), i = n.right - n.left, a = n.bottom - n.top, o = r.clientX - n.left, s = r.clientY - n.top, l = !U && i > R && a > F && !r.shiftKey ? d.getCursor(o / i, 1 - s / a) : "move";
                                    m(e1, l), D = l.split("-")[0];
                                }
                            }
                            function at(n, i) {
                                if ("path" === r.type) {
                                    var a = function(t1) {
                                        return t1;
                                    }, o = a, u = a;
                                    B ? V("xanchor", r.xanchor = tt(w + n)) : (o = function(t1) {
                                        return tt(K(t1) + n);
                                    }, H && "date" === H.type && (o = y.encodeDate(o))), N ? V("yanchor", r.yanchor = et(A + i)) : (u = function(t1) {
                                        return et(Q(t1) + i);
                                    }, Z && "date" === Z.type && (u = y.encodeDate(u))), V("path", r.path = k(O, o, u));
                                } else B ? V("xanchor", r.xanchor = tt(w + n)) : (V("x0", r.x0 = tt(h + n)), V("x1", r.x1 = tt(x + n))), N ? V("yanchor", r.yanchor = et(A + i)) : (V("y0", r.y0 = et(p + i)), V("y1", r.y1 = et(b + i)));
                                e1.attr("d", v(t1, r)), st(l, r), c(t1, s, r, q);
                            }
                            function ot(n, i) {
                                if (U) {
                                    var a = function(t1) {
                                        return t1;
                                    }, o = a, u = a;
                                    B ? V("xanchor", r.xanchor = tt(w + n)) : (o = function(t1) {
                                        return tt(K(t1) + n);
                                    }, H && "date" === H.type && (o = y.encodeDate(o))), N ? V("yanchor", r.yanchor = et(A + i)) : (u = function(t1) {
                                        return et(Q(t1) + i);
                                    }, Z && "date" === Z.type && (u = y.encodeDate(u))), V("path", r.path = k(O, o, u));
                                } else if (j) {
                                    if ("resize-over-start-point" === D) {
                                        var f = h + n, d = N ? p - i : p + i;
                                        V("x0", r.x0 = B ? f : tt(f)), V("y0", r.y0 = N ? d : et(d));
                                    } else if ("resize-over-end-point" === D) {
                                        var m = x + n, g = N ? b - i : b + i;
                                        V("x1", r.x1 = B ? m : tt(m)), V("y1", r.y1 = N ? g : et(g));
                                    }
                                } else {
                                    var _ = function(t1) {
                                        return -1 !== D.indexOf(t1);
                                    }, T = _("n"), G = _("s"), W = _("w"), Y = _("e"), X = T ? M + i : M, $ = G ? S + i : S, J = W ? E + n : E, rt = Y ? C + n : C;
                                    N && (T && (X = M - i), G && ($ = S - i)), (!N && $ - X > F || N && X - $ > F) && (V(L, r[L] = N ? X : et(X)), V(I, r[I] = N ? $ : et($))), rt - J > R && (V(P, r[P] = B ? J : tt(J)), V(z, r[z] = B ? rt : tt(rt)));
                                }
                                e1.attr("d", v(t1, r)), st(l, r), c(t1, s, r, q);
                            }
                            function st(t1, e1) {
                                (B || N) && function() {
                                    var r = "path" !== e1.type, n = t1.selectAll(".visual-cue").data([
                                        0
                                    ]);
                                    n.enter().append("path").attr({
                                        fill: "#fff",
                                        "fill-rule": "evenodd",
                                        stroke: "#000",
                                        "stroke-width": 1
                                    }).classed("visual-cue", !0);
                                    var i = K(B ? e1.xanchor : a.midRange(r ? [
                                        e1.x0,
                                        e1.x1
                                    ] : y.extractPathCoords(e1.path, g.paramIsX))), o = Q(N ? e1.yanchor : a.midRange(r ? [
                                        e1.y0,
                                        e1.y1
                                    ] : y.extractPathCoords(e1.path, g.paramIsY)));
                                    if (i = y.roundPositionForSharpStrokeRendering(i, 1), o = y.roundPositionForSharpStrokeRendering(o, 1), B && N) {
                                        var s = "M" + (i - 1 - 1) + "," + (o - 1 - 1) + "h-8v2h8 v8h2v-8 h8v-2h-8 v-8h-2 Z";
                                        n.attr("d", s);
                                    } else if (B) {
                                        var l = "M" + (i - 1 - 1) + "," + (o - 9 - 1) + "v18 h2 v-18 Z";
                                        n.attr("d", l);
                                    } else {
                                        var c = "M" + (i - 9 - 1) + "," + (o - 1 - 1) + "h18 v2 h-18 Z";
                                        n.attr("d", c);
                                    }
                                }();
                            }
                            function lt(t1) {
                                t1.selectAll(".visual-cue").remove();
                            }
                            d.init(nt), rt.node().onmousemove = it;
                        }(t1, F, u, e1, r, D) : !0 === u.editable && F.style("pointer-events", z || h.opacity(C) * E <= .5 ? "stroke" : "all");
                        F.node().addEventListener("click", function() {
                            return function(t1, e1) {
                                if (b(t1)) {
                                    var r = +e1.node().getAttribute("data-index");
                                    if (r >= 0) {
                                        if (r === t1._fullLayout._activeShapeIndex) return void A(t1);
                                        t1._fullLayout._activeShapeIndex = r, t1._fullLayout._deactivateShape = A, x(t1);
                                    }
                                }
                            }(t1, F);
                        });
                    }
                    u._input && !0 === u.visible && ("above" === u.layer ? M(t1._fullLayout._shapeUpperLayer) : "paper" === u.xref || "paper" === u.yref ? M(t1._fullLayout._shapeLowerLayer) : "between" === u.layer ? M(w.shapelayerBetween) : w._hadPlotinfo ? M((w.mainplotinfo || w).shapelayer) : M(t1._fullLayout._shapeLowerLayer));
                }
                function T(t1, e1, r) {
                    var n = (r.xref + r.yref).replace(/paper/g, "").replace(/[xyz][1-9]* *domain/g, "");
                    f.setClipUrl(t1, n ? "clip" + e1._fullLayout._uid + n : null, e1);
                }
                function k(t1, e1, r) {
                    return t1.replace(g.segmentRE, function(t1) {
                        var n = 0, i = t1.charAt(0), a = g.paramIsX[i], o = g.paramIsY[i], s = g.numParams[i];
                        return i + t1.substr(1).replace(g.paramRE, function(t1) {
                            return n >= s || (a[n] ? t1 = e1(t1) : o[n] && (t1 = r(t1)), n++), t1;
                        });
                    });
                }
                function A(t1) {
                    b(t1) && t1._fullLayout._activeShapeIndex >= 0 && (u(t1), delete t1._fullLayout._activeShapeIndex, x(t1));
                }
                t1.exports = {
                    draw: x,
                    drawOne: w,
                    eraseActiveShape: function(t1) {
                        if (b(t1)) {
                            u(t1);
                            var e1 = t1._fullLayout._activeShapeIndex, r = (t1.layout || {}).shapes || [];
                            if (e1 < r.length) {
                                for(var n = [], a = 0; a < r.length; a++)a !== e1 && n.push(r[a]);
                                return delete t1._fullLayout._activeShapeIndex, i.call("_guiRelayout", t1, {
                                    shapes: n
                                });
                            }
                        }
                    },
                    drawLabel: c
                };
            },
            64101: function(t1, e1, r) {
                "use strict";
                var n = r(13582).overrideAll, i = r(9829), a = r(80337), o = r(94850).T, s = r(93049).extendFlat, l = r(3208).LF, c = r(41235);
                t1.exports = n({
                    newshape: {
                        visible: s({}, i.visible, {}),
                        showlegend: {
                            valType: "boolean",
                            dflt: !1
                        },
                        legend: s({}, i.legend, {}),
                        legendgroup: s({}, i.legendgroup, {}),
                        legendgrouptitle: {
                            text: s({}, i.legendgrouptitle.text, {}),
                            font: a({})
                        },
                        legendrank: s({}, i.legendrank, {}),
                        legendwidth: s({}, i.legendwidth, {}),
                        line: {
                            color: {
                                valType: "color"
                            },
                            width: {
                                valType: "number",
                                min: 0,
                                dflt: 4
                            },
                            dash: s({}, o, {
                                dflt: "solid"
                            })
                        },
                        fillcolor: {
                            valType: "color",
                            dflt: "rgba(0,0,0,0)"
                        },
                        fillrule: {
                            valType: "enumerated",
                            values: [
                                "evenodd",
                                "nonzero"
                            ],
                            dflt: "evenodd"
                        },
                        opacity: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: 1
                        },
                        layer: {
                            valType: "enumerated",
                            values: [
                                "below",
                                "above",
                                "between"
                            ],
                            dflt: "above"
                        },
                        drawdirection: {
                            valType: "enumerated",
                            values: [
                                "ortho",
                                "horizontal",
                                "vertical",
                                "diagonal"
                            ],
                            dflt: "diagonal"
                        },
                        name: s({}, i.name, {}),
                        label: {
                            text: {
                                valType: "string",
                                dflt: ""
                            },
                            texttemplate: l({
                                newshape: !0
                            }, {
                                keys: Object.keys(c)
                            }),
                            font: a({}),
                            textposition: {
                                valType: "enumerated",
                                values: [
                                    "top left",
                                    "top center",
                                    "top right",
                                    "middle left",
                                    "middle center",
                                    "middle right",
                                    "bottom left",
                                    "bottom center",
                                    "bottom right",
                                    "start",
                                    "middle",
                                    "end"
                                ]
                            },
                            textangle: {
                                valType: "angle",
                                dflt: "auto"
                            },
                            xanchor: {
                                valType: "enumerated",
                                values: [
                                    "auto",
                                    "left",
                                    "center",
                                    "right"
                                ],
                                dflt: "auto"
                            },
                            yanchor: {
                                valType: "enumerated",
                                values: [
                                    "top",
                                    "middle",
                                    "bottom"
                                ]
                            },
                            padding: {
                                valType: "number",
                                dflt: 3,
                                min: 0
                            }
                        }
                    },
                    activeshape: {
                        fillcolor: {
                            valType: "color",
                            dflt: "rgb(255,0,255)"
                        },
                        opacity: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: .5
                        }
                    }
                }, "none", "from-root");
            },
            93391: function(t1) {
                "use strict";
                t1.exports = {
                    CIRCLE_SIDES: 32,
                    i000: 0,
                    i090: 8,
                    i180: 16,
                    i270: 24,
                    cos45: Math.cos(Math.PI / 4),
                    sin45: Math.sin(Math.PI / 4),
                    SQRT2: Math.sqrt(2)
                };
            },
            85522: function(t1, e1, r) {
                "use strict";
                var n = r(78766), i = r(34809);
                t1.exports = function(t1, e1, r) {
                    if (r("newshape.visible"), r("newshape.name"), r("newshape.showlegend"), r("newshape.legend"), r("newshape.legendwidth"), r("newshape.legendgroup"), r("newshape.legendgrouptitle.text"), i.coerceFont(r, "newshape.legendgrouptitle.font"), r("newshape.legendrank"), r("newshape.drawdirection"), r("newshape.layer"), r("newshape.fillcolor"), r("newshape.fillrule"), r("newshape.opacity"), r("newshape.line.width")) {
                        var a = (t1 || {}).plot_bgcolor || "#FFF";
                        r("newshape.line.color", n.contrast(a)), r("newshape.line.dash");
                    }
                    var o = "drawline" === t1.dragmode, s = r("newshape.label.text"), l = r("newshape.label.texttemplate");
                    if (s || l) {
                        r("newshape.label.textangle");
                        var c = r("newshape.label.textposition", o ? "middle" : "middle center");
                        r("newshape.label.xanchor"), r("newshape.label.yanchor", function(t1, e1) {
                            return t1 ? "bottom" : -1 !== e1.indexOf("top") ? "top" : -1 !== e1.indexOf("bottom") ? "bottom" : "middle";
                        }(o, c)), r("newshape.label.padding"), i.coerceFont(r, "newshape.label.font", e1.font);
                    }
                    r("activeshape.fillcolor"), r("activeshape.opacity");
                };
            },
            81055: function(t1, e1, r) {
                "use strict";
                var n = r(26953), i = r(93391), a = i.CIRCLE_SIDES, o = i.SQRT2, s = r(49801), l = s.p2r, c = s.r2p, u = [
                    0,
                    3,
                    4,
                    5,
                    6,
                    1,
                    2
                ], h = [
                    0,
                    3,
                    4,
                    1,
                    2
                ];
                function f(t1, e1) {
                    return Math.abs(t1 - e1) <= 1e-6;
                }
                function p(t1, e1) {
                    var r = e1[1] - t1[1], n = e1[2] - t1[2];
                    return Math.sqrt(r * r + n * n);
                }
                e1.writePaths = function(t1) {
                    var e1 = t1.length;
                    if (!e1) return "M0,0Z";
                    for(var r = "", n = 0; n < e1; n++)for(var i = t1[n].length, a = 0; a < i; a++){
                        var o = t1[n][a][0];
                        if ("Z" === o) r += "Z";
                        else for(var s = t1[n][a].length, l = 0; l < s; l++){
                            var c = l;
                            "Q" === o || "S" === o ? c = h[l] : "C" === o && (c = u[l]), r += t1[n][a][c], l > 0 && l < s - 1 && (r += ",");
                        }
                    }
                    return r;
                }, e1.readPaths = function(t1, e1, r, i) {
                    var o, s, u, h = n(t1), f = [], p = -1, d = 0, m = 0, g = function() {
                        s = d, u = m;
                    };
                    g();
                    for(var y = 0; y < h.length; y++){
                        var v, x, _, b, w = [], T = h[y][0], k = T;
                        switch(T){
                            case "M":
                                f[++p] = [], d = +h[y][1], m = +h[y][2], w.push([
                                    k,
                                    d,
                                    m
                                ]), g();
                                break;
                            case "Q":
                            case "S":
                                v = +h[y][1], _ = +h[y][2], d = +h[y][3], m = +h[y][4], w.push([
                                    k,
                                    d,
                                    m,
                                    v,
                                    _
                                ]);
                                break;
                            case "C":
                                v = +h[y][1], _ = +h[y][2], x = +h[y][3], b = +h[y][4], d = +h[y][5], m = +h[y][6], w.push([
                                    k,
                                    d,
                                    m,
                                    v,
                                    _,
                                    x,
                                    b
                                ]);
                                break;
                            case "T":
                            case "L":
                                d = +h[y][1], m = +h[y][2], w.push([
                                    k,
                                    d,
                                    m
                                ]);
                                break;
                            case "H":
                                k = "L", d = +h[y][1], w.push([
                                    k,
                                    d,
                                    m
                                ]);
                                break;
                            case "V":
                                k = "L", m = +h[y][1], w.push([
                                    k,
                                    d,
                                    m
                                ]);
                                break;
                            case "A":
                                k = "L";
                                var A = +h[y][1], M = +h[y][2];
                                +h[y][4] || (A = -A, M = -M);
                                var S = d - A, E = m;
                                for(o = 1; o <= a / 2; o++){
                                    var C = 2 * Math.PI * o / a;
                                    w.push([
                                        k,
                                        S + A * Math.cos(C),
                                        E + M * Math.sin(C)
                                    ]);
                                }
                                break;
                            case "Z":
                                d === s && m === u || (d = s, m = u, w.push([
                                    k,
                                    d,
                                    m
                                ]));
                        }
                        for(var L = (r || {}).domain, I = e1._fullLayout._size, P = r && "pixel" === r.xsizemode, z = r && "pixel" === r.ysizemode, O = !1 === i, D = 0; D < w.length; D++){
                            for(o = 0; o + 2 < 7; o += 2){
                                var R = w[D][o + 1], F = w[D][o + 2];
                                void 0 !== R && void 0 !== F && (d = R, m = F, r && (r.xaxis && r.xaxis.p2r ? (O && (R -= r.xaxis._offset), R = P ? c(r.xaxis, r.xanchor) + R : l(r.xaxis, R)) : (O && (R -= I.l), L ? R = L.x[0] + R / I.w : R /= I.w), r.yaxis && r.yaxis.p2r ? (O && (F -= r.yaxis._offset), F = z ? c(r.yaxis, r.yanchor) - F : l(r.yaxis, F)) : (O && (F -= I.t), F = L ? L.y[1] - F / I.h : 1 - F / I.h)), w[D][o + 1] = R, w[D][o + 2] = F);
                            }
                            f[p].push(w[D].slice());
                        }
                    }
                    return f;
                }, e1.pointsOnRectangle = function(t1) {
                    if (5 !== t1.length) return !1;
                    for(var e1 = 1; e1 < 3; e1++){
                        if (!f(t1[0][e1] - t1[1][e1], t1[3][e1] - t1[2][e1])) return !1;
                        if (!f(t1[0][e1] - t1[3][e1], t1[1][e1] - t1[2][e1])) return !1;
                    }
                    return !(!f(t1[0][1], t1[1][1]) && !f(t1[0][1], t1[3][1]) || !(p(t1[0], t1[1]) * p(t1[0], t1[3])));
                }, e1.pointsOnEllipse = function(t1) {
                    var e1 = t1.length;
                    if (e1 !== a + 1) return !1;
                    e1 = a;
                    for(var r = 0; r < e1; r++){
                        var n = (2 * e1 - r) % e1, i = (e1 / 2 + n) % e1, o = (e1 / 2 + r) % e1;
                        if (!f(p(t1[r], t1[o]), p(t1[n], t1[i]))) return !1;
                    }
                    return !0;
                }, e1.handleEllipse = function(t1, r, n) {
                    if (!t1) return [
                        r,
                        n
                    ];
                    var i = e1.ellipseOver({
                        x0: r[0],
                        y0: r[1],
                        x1: n[0],
                        y1: n[1]
                    }), s = (i.x1 + i.x0) / 2, l = (i.y1 + i.y0) / 2, c = (i.x1 - i.x0) / 2, u = (i.y1 - i.y0) / 2;
                    c || (c = u /= o), u || (u = c /= o);
                    for(var h = [], f = 0; f < a; f++){
                        var p = 2 * f * Math.PI / a;
                        h.push([
                            s + c * Math.cos(p),
                            l + u * Math.sin(p)
                        ]);
                    }
                    return h;
                }, e1.ellipseOver = function(t1) {
                    var e1 = t1.x0, r = t1.y0, n = t1.x1, i = t1.y1, a = n - e1, s = i - r, l = ((e1 -= a) + n) / 2, c = ((r -= s) + i) / 2;
                    return {
                        x0: l - (a *= o),
                        y0: c - (s *= o),
                        x1: l + a,
                        y1: c + s
                    };
                }, e1.fixDatesForPaths = function(t1, e1, r) {
                    var n = "date" === e1.type, i = "date" === r.type;
                    if (!n && !i) return t1;
                    for(var a = 0; a < t1.length; a++)for(var o = 0; o < t1[a].length; o++)for(var s = 0; s + 2 < t1[a][o].length; s += 2)n && (t1[a][o][s + 1] = t1[a][o][s + 1].replace(" ", "_")), i && (t1[a][o][s + 2] = t1[a][o][s + 2].replace(" ", "_"));
                    return t1;
                };
            },
            87562: function(t1, e1, r) {
                "use strict";
                var n = r(70414), i = n.drawMode, a = n.openMode, o = r(93391), s = o.i000, l = o.i090, c = o.i180, u = o.i270, h = o.cos45, f = o.sin45, p = r(49801), d = p.p2r, m = p.r2p, g = r(78534).clearOutline, y = r(81055), v = y.readPaths, x = y.writePaths, _ = y.ellipseOver, b = y.fixDatesForPaths;
                function w(t1, e1, r) {
                    var n, i = t1[0][0], o = e1.gd, p = i.getAttribute("d"), g = o._fullLayout.newshape, y = e1.plotinfo, w = e1.isActiveShape, T = y.xaxis, k = y.yaxis, A = !!y.domain || !y.xaxis, M = !!y.domain || !y.yaxis, S = a(r), E = v(p, o, y, w), C = {
                        editable: !0,
                        visible: g.visible,
                        name: g.name,
                        showlegend: g.showlegend,
                        legend: g.legend,
                        legendwidth: g.legendwidth,
                        legendgroup: g.legendgroup,
                        legendgrouptitle: {
                            text: g.legendgrouptitle.text,
                            font: g.legendgrouptitle.font
                        },
                        legendrank: g.legendrank,
                        label: g.label,
                        xref: A ? "paper" : T._id,
                        yref: M ? "paper" : k._id,
                        layer: g.layer,
                        opacity: g.opacity,
                        line: {
                            color: g.line.color,
                            width: g.line.width,
                            dash: g.line.dash
                        }
                    };
                    if (S || (C.fillcolor = g.fillcolor, C.fillrule = g.fillrule), 1 === E.length && (n = E[0]), n && 5 === n.length && "drawrect" === r) C.type = "rect", C.x0 = n[0][1], C.y0 = n[0][2], C.x1 = n[2][1], C.y1 = n[2][2];
                    else if (n && "drawline" === r) C.type = "line", C.x0 = n[0][1], C.y0 = n[0][2], C.x1 = n[1][1], C.y1 = n[1][2];
                    else if (n && "drawcircle" === r) {
                        C.type = "circle";
                        var L = n[s][1], I = n[l][1], P = n[c][1], z = n[u][1], O = n[s][2], D = n[l][2], R = n[c][2], F = n[u][2], B = y.xaxis && ("date" === y.xaxis.type || "log" === y.xaxis.type), N = y.yaxis && ("date" === y.yaxis.type || "log" === y.yaxis.type);
                        B && (L = m(y.xaxis, L), I = m(y.xaxis, I), P = m(y.xaxis, P), z = m(y.xaxis, z)), N && (O = m(y.yaxis, O), D = m(y.yaxis, D), R = m(y.yaxis, R), F = m(y.yaxis, F));
                        var j = (I + z) / 2, U = (O + R) / 2, V = _({
                            x0: j,
                            y0: U,
                            x1: j + (z - I + P - L) / 2 * h,
                            y1: U + (F - D + R - O) / 2 * f
                        });
                        B && (V.x0 = d(y.xaxis, V.x0), V.x1 = d(y.xaxis, V.x1)), N && (V.y0 = d(y.yaxis, V.y0), V.y1 = d(y.yaxis, V.y1)), C.x0 = V.x0, C.y0 = V.y0, C.x1 = V.x1, C.y1 = V.y1;
                    } else C.type = "path", T && k && b(E, T, k), C.path = x(E), n = null;
                    return C;
                }
                t1.exports = {
                    newShapes: function(t1, e1) {
                        if (t1.length && t1[0][0]) {
                            var r = e1.gd, n = e1.isActiveShape, a = e1.dragmode, o = (r.layout || {}).shapes || [];
                            if (!i(a) && void 0 !== n) {
                                var s = r._fullLayout._activeShapeIndex;
                                if (s < o.length) switch(r._fullLayout.shapes[s].type){
                                    case "rect":
                                        a = "drawrect";
                                        break;
                                    case "circle":
                                        a = "drawcircle";
                                        break;
                                    case "line":
                                        a = "drawline";
                                        break;
                                    case "path":
                                        var l = o[s].path || "";
                                        a = "Z" === l[l.length - 1] ? "drawclosedpath" : "drawopenpath";
                                }
                            }
                            var c = w(t1, e1, a);
                            g(r);
                            for(var u = e1.editHelpers, h = (u || {}).modifyItem, f = [], p = 0; p < o.length; p++){
                                var d = r._fullLayout.shapes[p];
                                if (f[p] = d._input, void 0 !== n && p === r._fullLayout._activeShapeIndex) {
                                    var m = c;
                                    switch(d.type){
                                        case "line":
                                        case "rect":
                                        case "circle":
                                            h("x0", m.x0 - (d.x0shift || 0)), h("x1", m.x1 - (d.x1shift || 0)), h("y0", m.y0 - (d.y0shift || 0)), h("y1", m.y1 - (d.y1shift || 0));
                                            break;
                                        case "path":
                                            h("path", m.path);
                                    }
                                }
                            }
                            return void 0 === n ? (f.push(c), f) : u ? u.getUpdateObj() : {};
                        }
                    },
                    createShapeObj: w
                };
            },
            78534: function(t1) {
                "use strict";
                t1.exports = {
                    clearOutlineControllers: function(t1) {
                        var e1 = t1._fullLayout._zoomlayer;
                        e1 && e1.selectAll(".outline-controllers").remove();
                    },
                    clearOutline: function(t1) {
                        var e1 = t1._fullLayout._zoomlayer;
                        e1 && e1.selectAll(".select-outline").remove(), t1._fullLayout._outlining = !1;
                    }
                };
            },
            49728: function(t1, e1, r) {
                "use strict";
                var n = r(2956), i = r(34809), a = r(29714);
                function o(t1, e1) {
                    var r = 0;
                    return (e1 = e1 || 0) && t1 && ("category" === t1.type || "multicategory" === t1.type) && (r = (t1.r2p(1) - t1.r2p(0)) * e1), r;
                }
                e1.rangeToShapePosition = function(t1) {
                    return "log" === t1.type ? t1.r2d : function(t1) {
                        return t1;
                    };
                }, e1.shapePositionToRange = function(t1) {
                    return "log" === t1.type ? t1.d2r : function(t1) {
                        return t1;
                    };
                }, e1.decodeDate = function(t1) {
                    return function(e1) {
                        return e1.replace && (e1 = e1.replace("_", " ")), t1(e1);
                    };
                }, e1.encodeDate = function(t1) {
                    return function(e1) {
                        return t1(e1).replace(" ", "_");
                    };
                }, e1.extractPathCoords = function(t1, e1, r) {
                    var a = [];
                    return t1.match(n.segmentRE).forEach(function(t1) {
                        var o = e1[t1.charAt(0)].drawn;
                        if (void 0 !== o) {
                            var s = t1.substr(1).match(n.paramRE);
                            if (s && !(s.length < o)) {
                                var l = s[o], c = r ? l : i.cleanNumber(l);
                                a.push(c);
                            }
                        }
                    }), a;
                }, e1.getDataToPixel = function(t1, r, n, i, a) {
                    var s, l = t1._fullLayout._size;
                    if (r) {
                        if ("domain" === a) s = function(t1) {
                            return r._length * (i ? 1 - t1 : t1) + r._offset;
                        };
                        else {
                            var c = e1.shapePositionToRange(r);
                            s = function(t1) {
                                var e1 = o(r, n);
                                return r._offset + r.r2p(c(t1, !0)) + e1;
                            }, "date" === r.type && (s = e1.decodeDate(s));
                        }
                    } else s = i ? function(t1) {
                        return l.t + l.h * (1 - t1);
                    } : function(t1) {
                        return l.l + l.w * t1;
                    };
                    return s;
                }, e1.getPixelToData = function(t1, r, n, i) {
                    var a, o = t1._fullLayout._size;
                    if (r) {
                        if ("domain" === i) a = function(t1) {
                            var e1 = (t1 - r._offset) / r._length;
                            return n ? 1 - e1 : e1;
                        };
                        else {
                            var s = e1.rangeToShapePosition(r);
                            a = function(t1) {
                                return s(r.p2r(t1 - r._offset));
                            };
                        }
                    } else a = n ? function(t1) {
                        return 1 - (t1 - o.t) / o.h;
                    } : function(t1) {
                        return (t1 - o.l) / o.w;
                    };
                    return a;
                }, e1.roundPositionForSharpStrokeRendering = function(t1, e1) {
                    var r = 1 === Math.round(e1 % 2), n = Math.round(t1);
                    return r ? n + .5 : n;
                }, e1.makeShapesOptionsAndPlotinfo = function(t1, e1) {
                    var r = t1._fullLayout.shapes[e1] || {}, n = t1._fullLayout._plots[r.xref + r.yref];
                    return n ? n._hadPlotinfo = !0 : (n = {}, r.xref && "paper" !== r.xref && (n.xaxis = t1._fullLayout[r.xref + "axis"]), r.yref && "paper" !== r.yref && (n.yaxis = t1._fullLayout[r.yref + "axis"])), n.xsizemode = r.xsizemode, n.ysizemode = r.ysizemode, n.xanchor = r.xanchor, n.yanchor = r.yanchor, {
                        options: r,
                        plotinfo: n
                    };
                }, e1.makeSelectionsOptionsAndPlotinfo = function(t1, e1) {
                    var r = t1._fullLayout.selections[e1] || {}, n = t1._fullLayout._plots[r.xref + r.yref];
                    return n ? n._hadPlotinfo = !0 : (n = {}, r.xref && (n.xaxis = t1._fullLayout[r.xref + "axis"]), r.yref && (n.yaxis = t1._fullLayout[r.yref + "axis"])), {
                        options: r,
                        plotinfo: n
                    };
                }, e1.getPathString = function(t1, r) {
                    var s, l, c, u, h, f, p, d, m = r.type, g = a.getRefType(r.xref), y = a.getRefType(r.yref), v = a.getFromId(t1, r.xref), x = a.getFromId(t1, r.yref), _ = t1._fullLayout._size, b = o(v, r.x0shift), w = o(v, r.x1shift), T = o(x, r.y0shift), k = o(x, r.y1shift);
                    if (v ? "domain" === g ? l = function(t1) {
                        return v._offset + v._length * t1;
                    } : (s = e1.shapePositionToRange(v), l = function(t1) {
                        return v._offset + v.r2p(s(t1, !0));
                    }) : l = function(t1) {
                        return _.l + _.w * t1;
                    }, x ? "domain" === y ? u = function(t1) {
                        return x._offset + x._length * (1 - t1);
                    } : (c = e1.shapePositionToRange(x), u = function(t1) {
                        return x._offset + x.r2p(c(t1, !0));
                    }) : u = function(t1) {
                        return _.t + _.h * (1 - t1);
                    }, "path" === m) return v && "date" === v.type && (l = e1.decodeDate(l)), x && "date" === x.type && (u = e1.decodeDate(u)), function(t1, e1, r) {
                        var a = t1.path, o = t1.xsizemode, s = t1.ysizemode, l = t1.xanchor, c = t1.yanchor;
                        return a.replace(n.segmentRE, function(t1) {
                            var a = 0, u = t1.charAt(0), h = n.paramIsX[u], f = n.paramIsY[u], p = n.numParams[u], d = t1.substr(1).replace(n.paramRE, function(t1) {
                                return h[a] ? t1 = "pixel" === o ? e1(l) + Number(t1) : e1(t1) : f[a] && (t1 = "pixel" === s ? r(c) - Number(t1) : r(t1)), ++a > p && (t1 = "X"), t1;
                            });
                            return a > p && (d = d.replace(/[\s,]*X.*/, ""), i.log("Ignoring extra params in segment " + t1)), u + d;
                        });
                    }(r, l, u);
                    if ("pixel" === r.xsizemode) {
                        var A = l(r.xanchor);
                        h = A + r.x0 + b, f = A + r.x1 + w;
                    } else h = l(r.x0) + b, f = l(r.x1) + w;
                    if ("pixel" === r.ysizemode) {
                        var M = u(r.yanchor);
                        p = M - r.y0 + T, d = M - r.y1 + k;
                    } else p = u(r.y0) + T, d = u(r.y1) + k;
                    if ("line" === m) return "M" + h + "," + p + "L" + f + "," + d;
                    if ("rect" === m) return "M" + h + "," + p + "H" + f + "V" + d + "H" + h + "Z";
                    var S = (h + f) / 2, E = (p + d) / 2, C = Math.abs(S - h), L = Math.abs(E - p), I = "A" + C + "," + L, P = S + C + "," + E;
                    return "M" + P + I + " 0 1,1 " + S + "," + (E - L) + I + " 0 0,1 " + P + "Z";
                };
            },
            43701: function(t1, e1, r) {
                "use strict";
                var n = r(28231);
                t1.exports = {
                    moduleType: "component",
                    name: "shapes",
                    layoutAttributes: r(43144),
                    supplyLayoutDefaults: r(74367),
                    supplyDrawNewShapeDefaults: r(85522),
                    includeBasePlot: r(20706)("shapes"),
                    calcAutorange: r(44959),
                    draw: n.draw,
                    drawOne: n.drawOne
                };
            },
            41235: function(t1) {
                "use strict";
                function e1(t1, e1) {
                    return e1 ? e1.d2l(t1) : t1;
                }
                function r(t1, e1) {
                    return e1 ? e1.l2d(t1) : t1;
                }
                function n(t1) {
                    return t1.x0shift || 0;
                }
                function i(t1) {
                    return t1.x1shift || 0;
                }
                function a(t1) {
                    return t1.y0shift || 0;
                }
                function o(t1) {
                    return t1.y1shift || 0;
                }
                function s(t1, r) {
                    return e1(t1.x1, r) + i(t1) - e1(t1.x0, r) - n(t1);
                }
                function l(t1, r, n) {
                    return e1(t1.y1, n) + o(t1) - e1(t1.y0, n) - a(t1);
                }
                t1.exports = {
                    x0: function(t1) {
                        return t1.x0;
                    },
                    x1: function(t1) {
                        return t1.x1;
                    },
                    y0: function(t1) {
                        return t1.y0;
                    },
                    y1: function(t1) {
                        return t1.y1;
                    },
                    slope: function(t1, e1, r) {
                        return "line" !== t1.type ? void 0 : l(t1, 0, r) / s(t1, e1);
                    },
                    dx: s,
                    dy: l,
                    width: function(t1, e1) {
                        return Math.abs(s(t1, e1));
                    },
                    height: function(t1, e1, r) {
                        return Math.abs(l(t1, 0, r));
                    },
                    length: function(t1, e1, r) {
                        return "line" !== t1.type ? void 0 : Math.sqrt(Math.pow(s(t1, e1), 2) + Math.pow(l(t1, 0, r), 2));
                    },
                    xcenter: function(t1, a) {
                        return r((e1(t1.x1, a) + i(t1) + e1(t1.x0, a) + n(t1)) / 2, a);
                    },
                    ycenter: function(t1, n, i) {
                        return r((e1(t1.y1, i) + o(t1) + e1(t1.y0, i) + a(t1)) / 2, i);
                    }
                };
            },
            8606: function(t1, e1, r) {
                "use strict";
                var n = r(80337), i = r(57891), a = r(93049).extendDeepAll, o = r(13582).overrideAll, s = r(49722), l = r(78032).templatedArray, c = r(64194), u = l("step", {
                    visible: {
                        valType: "boolean",
                        dflt: !0
                    },
                    method: {
                        valType: "enumerated",
                        values: [
                            "restyle",
                            "relayout",
                            "animate",
                            "update",
                            "skip"
                        ],
                        dflt: "restyle"
                    },
                    args: {
                        valType: "info_array",
                        freeLength: !0,
                        items: [
                            {
                                valType: "any"
                            },
                            {
                                valType: "any"
                            },
                            {
                                valType: "any"
                            }
                        ]
                    },
                    label: {
                        valType: "string"
                    },
                    value: {
                        valType: "string"
                    },
                    execute: {
                        valType: "boolean",
                        dflt: !0
                    }
                });
                t1.exports = o(l("slider", {
                    visible: {
                        valType: "boolean",
                        dflt: !0
                    },
                    active: {
                        valType: "number",
                        min: 0,
                        dflt: 0
                    },
                    steps: u,
                    lenmode: {
                        valType: "enumerated",
                        values: [
                            "fraction",
                            "pixels"
                        ],
                        dflt: "fraction"
                    },
                    len: {
                        valType: "number",
                        min: 0,
                        dflt: 1
                    },
                    x: {
                        valType: "number",
                        min: -2,
                        max: 3,
                        dflt: 0
                    },
                    pad: a(i({
                        editType: "arraydraw"
                    }), {}, {
                        t: {
                            dflt: 20
                        }
                    }),
                    xanchor: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "left",
                            "center",
                            "right"
                        ],
                        dflt: "left"
                    },
                    y: {
                        valType: "number",
                        min: -2,
                        max: 3,
                        dflt: 0
                    },
                    yanchor: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "top",
                            "middle",
                            "bottom"
                        ],
                        dflt: "top"
                    },
                    transition: {
                        duration: {
                            valType: "number",
                            min: 0,
                            dflt: 150
                        },
                        easing: {
                            valType: "enumerated",
                            values: s.transition.easing.values,
                            dflt: "cubic-in-out"
                        }
                    },
                    currentvalue: {
                        visible: {
                            valType: "boolean",
                            dflt: !0
                        },
                        xanchor: {
                            valType: "enumerated",
                            values: [
                                "left",
                                "center",
                                "right"
                            ],
                            dflt: "left"
                        },
                        offset: {
                            valType: "number",
                            dflt: 10
                        },
                        prefix: {
                            valType: "string"
                        },
                        suffix: {
                            valType: "string"
                        },
                        font: n({})
                    },
                    font: n({}),
                    activebgcolor: {
                        valType: "color",
                        dflt: c.gripBgActiveColor
                    },
                    bgcolor: {
                        valType: "color",
                        dflt: c.railBgColor
                    },
                    bordercolor: {
                        valType: "color",
                        dflt: c.railBorderColor
                    },
                    borderwidth: {
                        valType: "number",
                        min: 0,
                        dflt: c.railBorderWidth
                    },
                    ticklen: {
                        valType: "number",
                        min: 0,
                        dflt: c.tickLength
                    },
                    tickcolor: {
                        valType: "color",
                        dflt: c.tickColor
                    },
                    tickwidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1
                    },
                    minorticklen: {
                        valType: "number",
                        min: 0,
                        dflt: c.minorTickLength
                    }
                }), "arraydraw", "from-root");
            },
            64194: function(t1) {
                "use strict";
                t1.exports = {
                    name: "sliders",
                    containerClassName: "slider-container",
                    groupClassName: "slider-group",
                    inputAreaClass: "slider-input-area",
                    railRectClass: "slider-rail-rect",
                    railTouchRectClass: "slider-rail-touch-rect",
                    gripRectClass: "slider-grip-rect",
                    tickRectClass: "slider-tick-rect",
                    inputProxyClass: "slider-input-proxy",
                    labelsClass: "slider-labels",
                    labelGroupClass: "slider-label-group",
                    labelClass: "slider-label",
                    currentValueClass: "slider-current-value",
                    railHeight: 5,
                    menuIndexAttrName: "slider-active-index",
                    autoMarginIdRoot: "slider-",
                    minWidth: 30,
                    minHeight: 30,
                    textPadX: 40,
                    arrowOffsetX: 4,
                    railRadius: 2,
                    railWidth: 5,
                    railBorder: 4,
                    railBorderWidth: 1,
                    railBorderColor: "#bec8d9",
                    railBgColor: "#f8fafc",
                    railInset: 8,
                    stepInset: 10,
                    gripRadius: 10,
                    gripWidth: 20,
                    gripHeight: 20,
                    gripBorder: 20,
                    gripBorderWidth: 1,
                    gripBorderColor: "#bec8d9",
                    gripBgColor: "#f6f8fa",
                    gripBgActiveColor: "#dbdde0",
                    labelPadding: 8,
                    labelOffset: 0,
                    tickWidth: 1,
                    tickColor: "#333",
                    tickOffset: 25,
                    tickLength: 7,
                    minorTickOffset: 25,
                    minorTickColor: "#333",
                    minorTickLength: 4,
                    currentValuePadding: 8,
                    currentValueInset: 0
                };
            },
            74537: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(59008), a = r(8606), o = r(64194).name, s = a.steps;
                function l(t1, e1, r) {
                    function o(r, i) {
                        return n.coerce(t1, e1, a, r, i);
                    }
                    for(var s = i(t1, e1, {
                        name: "steps",
                        handleItemDefaults: c
                    }), l = 0, u = 0; u < s.length; u++)s[u].visible && l++;
                    if (l < 2 ? e1.visible = !1 : o("visible")) {
                        e1._stepCount = l;
                        var h = e1._visibleSteps = n.filterVisible(s);
                        (s[o("active")] || {}).visible || (e1.active = h[0]._index), o("x"), o("y"), n.noneOrAll(t1, e1, [
                            "x",
                            "y"
                        ]), o("xanchor"), o("yanchor"), o("len"), o("lenmode"), o("pad.t"), o("pad.r"), o("pad.b"), o("pad.l"), n.coerceFont(o, "font", r.font), o("currentvalue.visible") && (o("currentvalue.xanchor"), o("currentvalue.prefix"), o("currentvalue.suffix"), o("currentvalue.offset"), n.coerceFont(o, "currentvalue.font", e1.font)), o("transition.duration"), o("transition.easing"), o("bgcolor"), o("activebgcolor"), o("bordercolor"), o("borderwidth"), o("ticklen"), o("tickwidth"), o("tickcolor"), o("minorticklen");
                    }
                }
                function c(t1, e1) {
                    function r(r, i) {
                        return n.coerce(t1, e1, s, r, i);
                    }
                    if ("skip" === t1.method || Array.isArray(t1.args) ? r("visible") : e1.visible = !1) {
                        r("method"), r("args");
                        var i = r("label", "step-" + e1._index);
                        r("value", i), r("execute");
                    }
                }
                t1.exports = function(t1, e1) {
                    i(t1, e1, {
                        name: o,
                        handleItemDefaults: l
                    });
                };
            },
            44097: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(44122), a = r(78766), o = r(62203), s = r(34809), l = s.strTranslate, c = r(30635), u = r(78032).arrayEditor, h = r(64194), f = r(4530), p = f.LINE_SPACING, d = f.FROM_TL, m = f.FROM_BR;
                function g(t1) {
                    return h.autoMarginIdRoot + t1._index;
                }
                function y(t1) {
                    return t1._index;
                }
                function v(t1, e1) {
                    var r = o.tester.selectAll("g." + h.labelGroupClass).data(e1._visibleSteps);
                    r.enter().append("g").classed(h.labelGroupClass, !0);
                    var a = 0, l = 0;
                    r.each(function(t1) {
                        var r = b(n.select(this), {
                            step: t1
                        }, e1).node();
                        if (r) {
                            var i = o.bBox(r);
                            l = Math.max(l, i.height), a = Math.max(a, i.width);
                        }
                    }), r.remove();
                    var u = e1._dims = {};
                    u.inputAreaWidth = Math.max(h.railWidth, h.gripHeight);
                    var f = t1._fullLayout._size;
                    u.lx = f.l + f.w * e1.x, u.ly = f.t + f.h * (1 - e1.y), "fraction" === e1.lenmode ? u.outerLength = Math.round(f.w * e1.len) : u.outerLength = e1.len, u.inputAreaStart = 0, u.inputAreaLength = Math.round(u.outerLength - e1.pad.l - e1.pad.r);
                    var p = (u.inputAreaLength - 2 * h.stepInset) / (e1._stepCount - 1), y = a + h.labelPadding;
                    if (u.labelStride = Math.max(1, Math.ceil(y / p)), u.labelHeight = l, u.currentValueMaxWidth = 0, u.currentValueHeight = 0, u.currentValueTotalHeight = 0, u.currentValueMaxLines = 1, e1.currentvalue.visible) {
                        var v = o.tester.append("g");
                        r.each(function(t1) {
                            var r = x(v, e1, t1.label), n = r.node() && o.bBox(r.node()) || {
                                width: 0,
                                height: 0
                            }, i = c.lineCount(r);
                            u.currentValueMaxWidth = Math.max(u.currentValueMaxWidth, Math.ceil(n.width)), u.currentValueHeight = Math.max(u.currentValueHeight, Math.ceil(n.height)), u.currentValueMaxLines = Math.max(u.currentValueMaxLines, i);
                        }), u.currentValueTotalHeight = u.currentValueHeight + e1.currentvalue.offset, v.remove();
                    }
                    u.height = u.currentValueTotalHeight + h.tickOffset + e1.ticklen + h.labelOffset + u.labelHeight + e1.pad.t + e1.pad.b;
                    var _ = "left";
                    s.isRightAnchor(e1) && (u.lx -= u.outerLength, _ = "right"), s.isCenterAnchor(e1) && (u.lx -= u.outerLength / 2, _ = "center");
                    var w = "top";
                    s.isBottomAnchor(e1) && (u.ly -= u.height, w = "bottom"), s.isMiddleAnchor(e1) && (u.ly -= u.height / 2, w = "middle"), u.outerLength = Math.ceil(u.outerLength), u.height = Math.ceil(u.height), u.lx = Math.round(u.lx), u.ly = Math.round(u.ly);
                    var T = {
                        y: e1.y,
                        b: u.height * m[w],
                        t: u.height * d[w]
                    };
                    "fraction" === e1.lenmode ? (T.l = 0, T.xl = e1.x - e1.len * d[_], T.r = 0, T.xr = e1.x + e1.len * m[_]) : (T.x = e1.x, T.l = u.outerLength * d[_], T.r = u.outerLength * m[_]), i.autoMargin(t1, g(e1), T);
                }
                function x(t1, e1, r) {
                    if (e1.currentvalue.visible) {
                        var n, i, a = e1._dims;
                        switch(e1.currentvalue.xanchor){
                            case "right":
                                n = a.inputAreaLength - h.currentValueInset - a.currentValueMaxWidth, i = "left";
                                break;
                            case "center":
                                n = .5 * a.inputAreaLength, i = "middle";
                                break;
                            default:
                                n = h.currentValueInset, i = "left";
                        }
                        var l = s.ensureSingle(t1, "text", h.labelClass, function(t1) {
                            t1.attr({
                                "text-anchor": i,
                                "data-notex": 1
                            });
                        }), u = e1.currentvalue.prefix ? e1.currentvalue.prefix : "";
                        if ("string" == typeof r) u += r;
                        else {
                            var f = e1.steps[e1.active].label, d = e1._gd._fullLayout._meta;
                            d && (f = s.templateString(f, d)), u += f;
                        }
                        e1.currentvalue.suffix && (u += e1.currentvalue.suffix), l.call(o.font, e1.currentvalue.font).text(u).call(c.convertToTspans, e1._gd);
                        var m = c.lineCount(l), g = (a.currentValueMaxLines + 1 - m) * e1.currentvalue.font.size * p;
                        return c.positionText(l, n, g), l;
                    }
                }
                function _(t1, e1, r) {
                    s.ensureSingle(t1, "rect", h.gripRectClass, function(n) {
                        n.call(A, e1, t1, r).style("pointer-events", "all");
                    }).attr({
                        width: h.gripWidth,
                        height: h.gripHeight,
                        rx: h.gripRadius,
                        ry: h.gripRadius
                    }).call(a.stroke, r.bordercolor).call(a.fill, r.bgcolor).style("stroke-width", r.borderwidth + "px");
                }
                function b(t1, e1, r) {
                    var n = s.ensureSingle(t1, "text", h.labelClass, function(t1) {
                        t1.attr({
                            "text-anchor": "middle",
                            "data-notex": 1
                        });
                    }), i = e1.step.label, a = r._gd._fullLayout._meta;
                    return a && (i = s.templateString(i, a)), n.call(o.font, r.font).text(i).call(c.convertToTspans, r._gd), n;
                }
                function w(t1, e1) {
                    var r = s.ensureSingle(t1, "g", h.labelsClass), i = e1._dims, a = r.selectAll("g." + h.labelGroupClass).data(i.labelSteps);
                    a.enter().append("g").classed(h.labelGroupClass, !0), a.exit().remove(), a.each(function(t1) {
                        var r = n.select(this);
                        r.call(b, t1, e1), o.setTranslate(r, E(e1, t1.fraction), h.tickOffset + e1.ticklen + e1.font.size * p + h.labelOffset + i.currentValueTotalHeight);
                    });
                }
                function T(t1, e1, r, n, i) {
                    var a = Math.round(n * (r._stepCount - 1)), o = r._visibleSteps[a]._index;
                    o !== r.active && k(t1, e1, r, o, !0, i);
                }
                function k(t1, e1, r, n, a, o) {
                    var s = r.active;
                    r.active = n, u(t1.layout, h.name, r).applyUpdate("active", n);
                    var l = r.steps[r.active];
                    e1.call(S, r, o), e1.call(x, r), t1.emit("plotly_sliderchange", {
                        slider: r,
                        step: r.steps[r.active],
                        interaction: a,
                        previousActive: s
                    }), l && l.method && a && (e1._nextMethod ? (e1._nextMethod.step = l, e1._nextMethod.doCallback = a, e1._nextMethod.doTransition = o) : (e1._nextMethod = {
                        step: l,
                        doCallback: a,
                        doTransition: o
                    }, e1._nextMethodRaf = window.requestAnimationFrame(function() {
                        var r = e1._nextMethod.step;
                        r.method && (r.execute && i.executeAPICommand(t1, r.method, r.args), e1._nextMethod = null, e1._nextMethodRaf = null);
                    })));
                }
                function A(t1, e1, r) {
                    if (!e1._context.staticPlot) {
                        var i = r.node(), o = n.select(e1);
                        t1.on("mousedown", l), t1.on("touchstart", l);
                    }
                    function s() {
                        return r.data()[0];
                    }
                    function l() {
                        var t1 = s();
                        e1.emit("plotly_sliderstart", {
                            slider: t1
                        });
                        var l = r.select("." + h.gripRectClass);
                        n.event.stopPropagation(), n.event.preventDefault(), l.call(a.fill, t1.activebgcolor);
                        var c = C(t1, n.mouse(i)[0]);
                        function u() {
                            var t1 = s(), a = C(t1, n.mouse(i)[0]);
                            T(e1, r, t1, a, !1);
                        }
                        function f() {
                            var t1 = s();
                            t1._dragging = !1, l.call(a.fill, t1.bgcolor), o.on("mouseup", null), o.on("mousemove", null), o.on("touchend", null), o.on("touchmove", null), e1.emit("plotly_sliderend", {
                                slider: t1,
                                step: t1.steps[t1.active]
                            });
                        }
                        T(e1, r, t1, c, !0), t1._dragging = !0, o.on("mousemove", u), o.on("touchmove", u), o.on("mouseup", f), o.on("touchend", f);
                    }
                }
                function M(t1, e1) {
                    var r = t1.selectAll("rect." + h.tickRectClass).data(e1._visibleSteps), i = e1._dims;
                    r.enter().append("rect").classed(h.tickRectClass, !0), r.exit().remove(), r.attr({
                        width: e1.tickwidth + "px",
                        "shape-rendering": "crispEdges"
                    }), r.each(function(t1, r) {
                        var s = r % i.labelStride == 0, l = n.select(this);
                        l.attr({
                            height: s ? e1.ticklen : e1.minorticklen
                        }).call(a.fill, e1.tickcolor), o.setTranslate(l, E(e1, r / (e1._stepCount - 1)) - .5 * e1.tickwidth, (s ? h.tickOffset : h.minorTickOffset) + i.currentValueTotalHeight);
                    });
                }
                function S(t1, e1, r) {
                    for(var n = t1.select("rect." + h.gripRectClass), i = 0, a = 0; a < e1._stepCount; a++)if (e1._visibleSteps[a]._index === e1.active) {
                        i = a;
                        break;
                    }
                    var o = E(e1, i / (e1._stepCount - 1));
                    if (!e1._invokingCommand) {
                        var s = n;
                        r && e1.transition.duration > 0 && (s = s.transition().duration(e1.transition.duration).ease(e1.transition.easing)), s.attr("transform", l(o - .5 * h.gripWidth, e1._dims.currentValueTotalHeight));
                    }
                }
                function E(t1, e1) {
                    var r = t1._dims;
                    return r.inputAreaStart + h.stepInset + (r.inputAreaLength - 2 * h.stepInset) * Math.min(1, Math.max(0, e1));
                }
                function C(t1, e1) {
                    var r = t1._dims;
                    return Math.min(1, Math.max(0, (e1 - h.stepInset - r.inputAreaStart) / (r.inputAreaLength - 2 * h.stepInset - 2 * r.inputAreaStart)));
                }
                function L(t1, e1, r) {
                    var n = r._dims, i = s.ensureSingle(t1, "rect", h.railTouchRectClass, function(n) {
                        n.call(A, e1, t1, r).style("pointer-events", "all");
                    });
                    i.attr({
                        width: n.inputAreaLength,
                        height: Math.max(n.inputAreaWidth, h.tickOffset + r.ticklen + n.labelHeight)
                    }).call(a.fill, r.bgcolor).attr("opacity", 0), o.setTranslate(i, 0, n.currentValueTotalHeight);
                }
                function I(t1, e1) {
                    var r = e1._dims, n = r.inputAreaLength - 2 * h.railInset, i = s.ensureSingle(t1, "rect", h.railRectClass);
                    i.attr({
                        width: n,
                        height: h.railWidth,
                        rx: h.railRadius,
                        ry: h.railRadius,
                        "shape-rendering": "crispEdges"
                    }).call(a.stroke, e1.bordercolor).call(a.fill, e1.bgcolor).style("stroke-width", e1.borderwidth + "px"), o.setTranslate(i, h.railInset, .5 * (r.inputAreaWidth - h.railWidth) + r.currentValueTotalHeight);
                }
                t1.exports = function(t1) {
                    var e1 = t1._context.staticPlot, r = t1._fullLayout, a = function(t1, e1) {
                        for(var r = t1[h.name], n = [], i = 0; i < r.length; i++){
                            var a = r[i];
                            a.visible && (a._gd = e1, n.push(a));
                        }
                        return n;
                    }(r, t1), s = r._infolayer.selectAll("g." + h.containerClassName).data(a.length > 0 ? [
                        0
                    ] : []);
                    function l(e1) {
                        e1._commandObserver && (e1._commandObserver.remove(), delete e1._commandObserver), i.autoMargin(t1, g(e1));
                    }
                    if (s.enter().append("g").classed(h.containerClassName, !0).style("cursor", e1 ? null : "ew-resize"), s.exit().each(function() {
                        n.select(this).selectAll("g." + h.groupClassName).each(l);
                    }).remove(), 0 !== a.length) {
                        var c = s.selectAll("g." + h.groupClassName).data(a, y);
                        c.enter().append("g").classed(h.groupClassName, !0), c.exit().each(l).remove();
                        for(var u = 0; u < a.length; u++){
                            var f = a[u];
                            v(t1, f);
                        }
                        c.each(function(e1) {
                            var r = n.select(this);
                            !function(t1) {
                                var e1 = t1._dims;
                                e1.labelSteps = [];
                                for(var r = t1._stepCount, n = 0; n < r; n += e1.labelStride)e1.labelSteps.push({
                                    fraction: n / (r - 1),
                                    step: t1._visibleSteps[n]
                                });
                            }(e1), i.manageCommandObserver(t1, e1, e1._visibleSteps, function(e1) {
                                var n = r.data()[0];
                                n.active !== e1.index && (n._dragging || k(t1, r, n, e1.index, !1, !0));
                            }), function(t1, e1, r) {
                                (r.steps[r.active] || {}).visible || (r.active = r._visibleSteps[0]._index), e1.call(x, r).call(I, r).call(w, r).call(M, r).call(L, t1, r).call(_, t1, r);
                                var n = r._dims;
                                o.setTranslate(e1, n.lx + r.pad.l, n.ly + r.pad.t), e1.call(S, r, !1), e1.call(x, r);
                            }(t1, n.select(this), e1);
                        });
                    }
                };
            },
            15359: function(t1, e1, r) {
                "use strict";
                var n = r(64194);
                t1.exports = {
                    moduleType: "component",
                    name: n.name,
                    layoutAttributes: r(8606),
                    supplyLayoutDefaults: r(74537),
                    draw: r(44097)
                };
            },
            17240: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(10721), a = r(44122), o = r(33626), s = r(34809), l = s.strTranslate, c = r(62203), u = r(78766), h = r(30635), f = r(20438), p = r(4530).OPPOSITE_SIDE, d = / [XY][0-9]* /;
                t1.exports = {
                    draw: function(t1, e1, r) {
                        var m, g = t1._fullLayout, y = r.propContainer, v = r.propName, x = r.placeholder, _ = r.traceIndex, b = r.avoid || {}, w = r.attributes, T = r.transform, k = r.containerGroup, A = 1, M = y.title, S = (M && M.text ? M.text : "").trim(), E = !1, C = M && M.font ? M.font : {}, L = C.family, I = C.size, P = C.color, z = C.weight, O = C.style, D = C.variant, R = C.textcase, F = C.lineposition, B = C.shadow, N = !!r.subtitlePropName, j = r.subtitlePlaceholder, U = (y.title || {}).subtitle || {
                            text: "",
                            font: {}
                        }, V = U.text.trim(), q = !1, H = 1, G = U.font, Z = G.family, W = G.size, Y = G.color, X = G.weight, $ = G.style, J = G.variant, K = G.textcase, Q = G.lineposition, tt = G.shadow;
                        "title.text" === v ? m = "titleText" : -1 !== v.indexOf("axis") ? m = "axisTitleText" : v.indexOf(!0) && (m = "colorbarTitleText");
                        var et = t1._context.edits[m];
                        function rt(t1, e1) {
                            return void 0 !== t1 && void 0 !== e1 && t1.replace(d, " % ") === e1.replace(d, " % ");
                        }
                        "" === S ? A = 0 : rt(S, x) && (et || (S = ""), A = .2, E = !0), N && ("" === V ? H = 0 : rt(V, j) && (et || (V = ""), H = .2, q = !0)), r._meta ? S = s.templateString(S, r._meta) : g._meta && (S = s.templateString(S, g._meta));
                        var nt, it = S || V || et;
                        k || (k = s.ensureSingle(g._infolayer, "g", "g-" + e1), nt = g._hColorbarMoveTitle);
                        var at = k.selectAll("text." + e1).data(it ? [
                            0
                        ] : []);
                        at.enter().append("text"), at.text(S).attr("class", e1), at.exit().remove();
                        var ot = null, st = e1 + "-subtitle", lt = V || et;
                        if (N && lt && ((ot = k.selectAll("text." + st).data(lt ? [
                            0
                        ] : [])).enter().append("text"), ot.text(V).attr("class", st), ot.exit().remove()), !it) return k;
                        function ct(t1, e1) {
                            s.syncOrAsync([
                                ut,
                                ht
                            ], {
                                title: t1,
                                subtitle: e1
                            });
                        }
                        function ut(r) {
                            var i, o = r.title, f = r.subtitle;
                            if (!T && nt && (T = {}), T ? (i = "", T.rotate && (i += "rotate(" + [
                                T.rotate,
                                w.x,
                                w.y
                            ] + ")"), (T.offset || nt) && (i += l(0, (T.offset || 0) - (nt || 0)))) : i = null, o.attr("transform", i), o.style("opacity", A * u.opacity(P)).call(c.font, {
                                color: u.rgb(P),
                                size: n.round(I, 2),
                                family: L,
                                weight: z,
                                style: O,
                                variant: D,
                                textcase: R,
                                shadow: B,
                                lineposition: F
                            }).attr(w).call(h.convertToTspans, t1, function(t1) {
                                if (t1) {
                                    var e1 = n.select(t1.node().parentNode).select("." + st);
                                    if (!e1.empty()) {
                                        var r = t1.node().getBBox();
                                        if (r.height) {
                                            var i = r.y + r.height + 1.6 * W;
                                            e1.attr("y", i);
                                        }
                                    }
                                }
                            }), f) {
                                var p = k.select("." + e1 + "-math-group"), d = o.node().getBBox(), m = p.node() ? p.node().getBBox() : void 0, g = m ? m.y + m.height + 1.6 * W : d.y + d.height + 1.6 * W, y = s.extendFlat({}, w, {
                                    y: g
                                });
                                f.attr("transform", i), f.style("opacity", H * u.opacity(Y)).call(c.font, {
                                    color: u.rgb(Y),
                                    size: n.round(W, 2),
                                    family: Z,
                                    weight: X,
                                    style: $,
                                    variant: J,
                                    textcase: K,
                                    shadow: tt,
                                    lineposition: Q
                                }).attr(y).call(h.convertToTspans, t1);
                            }
                            return a.previousPromises(t1);
                        }
                        function ht(e1) {
                            var r = e1.title, a = n.select(r.node().parentNode);
                            if (b && b.selection && b.side && S) {
                                a.attr("transform", null);
                                var o = p[b.side], u = "left" === b.side || "top" === b.side ? -1 : 1, h = i(b.pad) ? b.pad : 2, f = c.bBox(a.node()), d = {
                                    t: 0,
                                    b: 0,
                                    l: 0,
                                    r: 0
                                }, m = t1._fullLayout._reservedMargin;
                                for(var v in m)for(var x in m[v]){
                                    var _ = m[v][x];
                                    d[x] = Math.max(d[x], _);
                                }
                                var w = {
                                    left: d.l,
                                    top: d.t,
                                    right: g.width - d.r,
                                    bottom: g.height - d.b
                                }, T = b.maxShift || u * (w[b.side] - f[b.side]), k = 0;
                                if (T < 0) k = T;
                                else {
                                    var A = b.offsetLeft || 0, M = b.offsetTop || 0;
                                    f.left -= A, f.right -= A, f.top -= M, f.bottom -= M, b.selection.each(function() {
                                        var t1 = c.bBox(this);
                                        s.bBoxIntersect(f, t1, h) && (k = Math.max(k, u * (t1[b.side] - f[o]) + h));
                                    }), k = Math.min(T, k), y._titleScoot = Math.abs(k);
                                }
                                if (k > 0 || T < 0) {
                                    var E = {
                                        left: [
                                            -k,
                                            0
                                        ],
                                        right: [
                                            k,
                                            0
                                        ],
                                        top: [
                                            0,
                                            -k
                                        ],
                                        bottom: [
                                            0,
                                            k
                                        ]
                                    }[b.side];
                                    a.attr("transform", l(E[0], E[1]));
                                }
                            }
                        }
                        function ft(t1, e1) {
                            t1.text(e1).on("mouseover.opacity", function() {
                                n.select(this).transition().duration(f.SHOW_PLACEHOLDER).style("opacity", 1);
                            }).on("mouseout.opacity", function() {
                                n.select(this).transition().duration(f.HIDE_PLACEHOLDER).style("opacity", 0);
                            });
                        }
                        if (at.call(ct, ot), et && (S ? at.on(".opacity", null) : (ft(at, x), E = !0), at.call(h.makeEditable, {
                            gd: t1
                        }).on("edit", function(e1) {
                            void 0 !== _ ? o.call("_guiRestyle", t1, v, e1, _) : o.call("_guiRelayout", t1, v, e1);
                        }).on("cancel", function() {
                            this.text(this.attr("data-unformatted")).call(ct);
                        }).on("input", function(t1) {
                            this.text(t1 || " ").call(h.positionText, w.x, w.y);
                        }), N)) {
                            if (N && !S) {
                                var pt = at.node().getBBox(), dt = pt.y + pt.height + 1.6 * W;
                                ot.attr("y", dt);
                            }
                            V ? ot.on(".opacity", null) : (ft(ot, j), q = !0), ot.call(h.makeEditable, {
                                gd: t1
                            }).on("edit", function(e1) {
                                o.call("_guiRelayout", t1, "title.subtitle.text", e1);
                            }).on("cancel", function() {
                                this.text(this.attr("data-unformatted")).call(ct);
                            }).on("input", function(t1) {
                                this.text(t1 || " ").call(h.positionText, ot.attr("x"), ot.attr("y"));
                            });
                        }
                        return at.classed("js-placeholder", E), ot && ot.classed("js-placeholder", q), k;
                    },
                    SUBTITLE_PADDING_EM: 1.6,
                    SUBTITLE_PADDING_MATHJAX_EM: 1.6
                };
            },
            85389: function(t1, e1, r) {
                "use strict";
                var n = r(80337), i = r(10229), a = r(93049).extendFlat, o = r(13582).overrideAll, s = r(57891), l = r(78032).templatedArray, c = l("button", {
                    visible: {
                        valType: "boolean"
                    },
                    method: {
                        valType: "enumerated",
                        values: [
                            "restyle",
                            "relayout",
                            "animate",
                            "update",
                            "skip"
                        ],
                        dflt: "restyle"
                    },
                    args: {
                        valType: "info_array",
                        freeLength: !0,
                        items: [
                            {
                                valType: "any"
                            },
                            {
                                valType: "any"
                            },
                            {
                                valType: "any"
                            }
                        ]
                    },
                    args2: {
                        valType: "info_array",
                        freeLength: !0,
                        items: [
                            {
                                valType: "any"
                            },
                            {
                                valType: "any"
                            },
                            {
                                valType: "any"
                            }
                        ]
                    },
                    label: {
                        valType: "string",
                        dflt: ""
                    },
                    execute: {
                        valType: "boolean",
                        dflt: !0
                    }
                });
                t1.exports = o(l("updatemenu", {
                    _arrayAttrRegexps: [
                        /^updatemenus\[(0|[1-9][0-9]+)\]\.buttons/
                    ],
                    visible: {
                        valType: "boolean"
                    },
                    type: {
                        valType: "enumerated",
                        values: [
                            "dropdown",
                            "buttons"
                        ],
                        dflt: "dropdown"
                    },
                    direction: {
                        valType: "enumerated",
                        values: [
                            "left",
                            "right",
                            "up",
                            "down"
                        ],
                        dflt: "down"
                    },
                    active: {
                        valType: "integer",
                        min: -1,
                        dflt: 0
                    },
                    showactive: {
                        valType: "boolean",
                        dflt: !0
                    },
                    buttons: c,
                    x: {
                        valType: "number",
                        min: -2,
                        max: 3,
                        dflt: -0.05
                    },
                    xanchor: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "left",
                            "center",
                            "right"
                        ],
                        dflt: "right"
                    },
                    y: {
                        valType: "number",
                        min: -2,
                        max: 3,
                        dflt: 1
                    },
                    yanchor: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "top",
                            "middle",
                            "bottom"
                        ],
                        dflt: "top"
                    },
                    pad: a(s({
                        editType: "arraydraw"
                    }), {}),
                    font: n({}),
                    bgcolor: {
                        valType: "color"
                    },
                    bordercolor: {
                        valType: "color",
                        dflt: i.borderLine
                    },
                    borderwidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        editType: "arraydraw"
                    }
                }), "arraydraw", "from-root");
            },
            71559: function(t1) {
                "use strict";
                t1.exports = {
                    name: "updatemenus",
                    containerClassName: "updatemenu-container",
                    headerGroupClassName: "updatemenu-header-group",
                    headerClassName: "updatemenu-header",
                    headerArrowClassName: "updatemenu-header-arrow",
                    dropdownButtonGroupClassName: "updatemenu-dropdown-button-group",
                    dropdownButtonClassName: "updatemenu-dropdown-button",
                    buttonClassName: "updatemenu-button",
                    itemRectClassName: "updatemenu-item-rect",
                    itemTextClassName: "updatemenu-item-text",
                    menuIndexAttrName: "updatemenu-active-index",
                    autoMarginIdRoot: "updatemenu-",
                    blankHeaderOpts: {
                        label: "  "
                    },
                    minWidth: 30,
                    minHeight: 30,
                    textPadX: 24,
                    arrowPadX: 16,
                    rx: 2,
                    ry: 2,
                    textOffsetX: 12,
                    textOffsetY: 3,
                    arrowOffsetX: 4,
                    gapButtonHeader: 5,
                    gapButton: 2,
                    activeColor: "#F4FAFF",
                    hoverColor: "#F4FAFF",
                    arrowSymbol: {
                        left: "\u25C4",
                        right: "\u25BA",
                        up: "\u25B2",
                        down: "\u25BC"
                    }
                };
            },
            42746: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(59008), a = r(85389), o = r(71559).name, s = a.buttons;
                function l(t1, e1, r) {
                    function o(r, i) {
                        return n.coerce(t1, e1, a, r, i);
                    }
                    o("visible", i(t1, e1, {
                        name: "buttons",
                        handleItemDefaults: c
                    }).length > 0) && (o("active"), o("direction"), o("type"), o("showactive"), o("x"), o("y"), n.noneOrAll(t1, e1, [
                        "x",
                        "y"
                    ]), o("xanchor"), o("yanchor"), o("pad.t"), o("pad.r"), o("pad.b"), o("pad.l"), n.coerceFont(o, "font", r.font), o("bgcolor", r.paper_bgcolor), o("bordercolor"), o("borderwidth"));
                }
                function c(t1, e1) {
                    function r(r, i) {
                        return n.coerce(t1, e1, s, r, i);
                    }
                    r("visible", "skip" === t1.method || Array.isArray(t1.args)) && (r("method"), r("args"), r("args2"), r("label"), r("execute"));
                }
                t1.exports = function(t1, e1) {
                    i(t1, e1, {
                        name: o,
                        handleItemDefaults: l
                    });
                };
            },
            40974: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(44122), a = r(78766), o = r(62203), s = r(34809), l = r(30635), c = r(78032).arrayEditor, u = r(4530).LINE_SPACING, h = r(71559), f = r(21736);
                function p(t1) {
                    return t1._index;
                }
                function d(t1, e1) {
                    return +t1.attr(h.menuIndexAttrName) === e1._index;
                }
                function m(t1, e1, r, n, i, a, o, s) {
                    e1.active = o, c(t1.layout, h.name, e1).applyUpdate("active", o), "buttons" === e1.type ? y(t1, n, null, null, e1) : "dropdown" === e1.type && (i.attr(h.menuIndexAttrName, "-1"), g(t1, n, i, a, e1), s || y(t1, n, i, a, e1));
                }
                function g(t1, e1, r, n, i) {
                    var a = s.ensureSingle(e1, "g", h.headerClassName, function(t1) {
                        t1.style("pointer-events", "all");
                    }), l = i._dims, c = i.active, u = i.buttons[c] || h.blankHeaderOpts, f = {
                        y: i.pad.t,
                        yPad: 0,
                        x: i.pad.l,
                        xPad: 0,
                        index: 0
                    }, p = {
                        width: l.headerWidth,
                        height: l.headerHeight
                    };
                    a.call(v, i, u, t1).call(M, i, f, p), s.ensureSingle(e1, "text", h.headerArrowClassName, function(t1) {
                        t1.attr("text-anchor", "end").call(o.font, i.font).text(h.arrowSymbol[i.direction]);
                    }).attr({
                        x: l.headerWidth - h.arrowOffsetX + i.pad.l,
                        y: l.headerHeight / 2 + h.textOffsetY + i.pad.t
                    }), a.on("click", function() {
                        r.call(S, String(d(r, i) ? -1 : i._index)), y(t1, e1, r, n, i);
                    }), a.on("mouseover", function() {
                        a.call(w);
                    }), a.on("mouseout", function() {
                        a.call(T, i);
                    }), o.setTranslate(e1, l.lx, l.ly);
                }
                function y(t1, e1, r, a, o) {
                    r || (r = e1).attr("pointer-events", "all");
                    var l = function(t1) {
                        return -1 == +t1.attr(h.menuIndexAttrName);
                    }(r) && "buttons" !== o.type ? [] : o.buttons, c = "dropdown" === o.type ? h.dropdownButtonClassName : h.buttonClassName, u = r.selectAll("g." + c).data(s.filterVisible(l)), f = u.enter().append("g").classed(c, !0), p = u.exit();
                    "dropdown" === o.type ? (f.attr("opacity", "0").transition().attr("opacity", "1"), p.transition().attr("opacity", "0").remove()) : p.remove();
                    var d = 0, g = 0, y = o._dims, x = -1 !== [
                        "up",
                        "down"
                    ].indexOf(o.direction);
                    "dropdown" === o.type && (x ? g = y.headerHeight + h.gapButtonHeader : d = y.headerWidth + h.gapButtonHeader), "dropdown" === o.type && "up" === o.direction && (g = -h.gapButtonHeader + h.gapButton - y.openHeight), "dropdown" === o.type && "left" === o.direction && (d = -h.gapButtonHeader + h.gapButton - y.openWidth);
                    var _ = {
                        x: y.lx + d + o.pad.l,
                        y: y.ly + g + o.pad.t,
                        yPad: h.gapButton,
                        xPad: h.gapButton,
                        index: 0
                    }, k = {
                        l: _.x + o.borderwidth,
                        t: _.y + o.borderwidth
                    };
                    u.each(function(s, l) {
                        var c = n.select(this);
                        c.call(v, o, s, t1).call(M, o, _), c.on("click", function() {
                            n.event.defaultPrevented || (s.execute && (s.args2 && o.active === l ? (m(t1, o, 0, e1, r, a, -1), i.executeAPICommand(t1, s.method, s.args2)) : (m(t1, o, 0, e1, r, a, l), i.executeAPICommand(t1, s.method, s.args))), t1.emit("plotly_buttonclicked", {
                                menu: o,
                                button: s,
                                active: o.active
                            }));
                        }), c.on("mouseover", function() {
                            c.call(w);
                        }), c.on("mouseout", function() {
                            c.call(T, o), u.call(b, o);
                        });
                    }), u.call(b, o), x ? (k.w = Math.max(y.openWidth, y.headerWidth), k.h = _.y - k.t) : (k.w = _.x - k.l, k.h = Math.max(y.openHeight, y.headerHeight)), k.direction = o.direction, a && (u.size() ? function(t1, e1, r, n, i, a) {
                        var o, s, l, c = i.direction, u = "up" === c || "down" === c, f = i._dims, p = i.active;
                        if (u) for(s = 0, l = 0; l < p; l++)s += f.heights[l] + h.gapButton;
                        else for(o = 0, l = 0; l < p; l++)o += f.widths[l] + h.gapButton;
                        n.enable(a, o, s), n.hbar && n.hbar.attr("opacity", "0").transition().attr("opacity", "1"), n.vbar && n.vbar.attr("opacity", "0").transition().attr("opacity", "1");
                    }(0, 0, 0, a, o, k) : function(t1) {
                        var e1 = !!t1.hbar, r = !!t1.vbar;
                        e1 && t1.hbar.transition().attr("opacity", "0").each("end", function() {
                            e1 = !1, r || t1.disable();
                        }), r && t1.vbar.transition().attr("opacity", "0").each("end", function() {
                            r = !1, e1 || t1.disable();
                        });
                    }(a));
                }
                function v(t1, e1, r, n) {
                    t1.call(x, e1).call(_, e1, r, n);
                }
                function x(t1, e1) {
                    s.ensureSingle(t1, "rect", h.itemRectClassName, function(t1) {
                        t1.attr({
                            rx: h.rx,
                            ry: h.ry,
                            "shape-rendering": "crispEdges"
                        });
                    }).call(a.stroke, e1.bordercolor).call(a.fill, e1.bgcolor).style("stroke-width", e1.borderwidth + "px");
                }
                function _(t1, e1, r, n) {
                    var i = s.ensureSingle(t1, "text", h.itemTextClassName, function(t1) {
                        t1.attr({
                            "text-anchor": "start",
                            "data-notex": 1
                        });
                    }), a = r.label, c = n._fullLayout._meta;
                    c && (a = s.templateString(a, c)), i.call(o.font, e1.font).text(a).call(l.convertToTspans, n);
                }
                function b(t1, e1) {
                    var r = e1.active;
                    t1.each(function(t1, i) {
                        var o = n.select(this);
                        i === r && e1.showactive && o.select("rect." + h.itemRectClassName).call(a.fill, h.activeColor);
                    });
                }
                function w(t1) {
                    t1.select("rect." + h.itemRectClassName).call(a.fill, h.hoverColor);
                }
                function T(t1, e1) {
                    t1.select("rect." + h.itemRectClassName).call(a.fill, e1.bgcolor);
                }
                function k(t1, e1) {
                    var r = e1._dims = {
                        width1: 0,
                        height1: 0,
                        heights: [],
                        widths: [],
                        totalWidth: 0,
                        totalHeight: 0,
                        openWidth: 0,
                        openHeight: 0,
                        lx: 0,
                        ly: 0
                    }, a = o.tester.selectAll("g." + h.dropdownButtonClassName).data(s.filterVisible(e1.buttons));
                    a.enter().append("g").classed(h.dropdownButtonClassName, !0);
                    var c = -1 !== [
                        "up",
                        "down"
                    ].indexOf(e1.direction);
                    a.each(function(i, a) {
                        var s = n.select(this);
                        s.call(v, e1, i, t1);
                        var f = s.select("." + h.itemTextClassName), p = f.node() && o.bBox(f.node()).width, d = Math.max(p + h.textPadX, h.minWidth), m = e1.font.size * u, g = l.lineCount(f), y = Math.max(m * g, h.minHeight) + h.textOffsetY;
                        y = Math.ceil(y), d = Math.ceil(d), r.widths[a] = d, r.heights[a] = y, r.height1 = Math.max(r.height1, y), r.width1 = Math.max(r.width1, d), c ? (r.totalWidth = Math.max(r.totalWidth, d), r.openWidth = r.totalWidth, r.totalHeight += y + h.gapButton, r.openHeight += y + h.gapButton) : (r.totalWidth += d + h.gapButton, r.openWidth += d + h.gapButton, r.totalHeight = Math.max(r.totalHeight, y), r.openHeight = r.totalHeight);
                    }), c ? r.totalHeight -= h.gapButton : r.totalWidth -= h.gapButton, r.headerWidth = r.width1 + h.arrowPadX, r.headerHeight = r.height1, "dropdown" === e1.type && (c ? (r.width1 += h.arrowPadX, r.totalHeight = r.height1) : r.totalWidth = r.width1, r.totalWidth += h.arrowPadX), a.remove();
                    var f = r.totalWidth + e1.pad.l + e1.pad.r, p = r.totalHeight + e1.pad.t + e1.pad.b, d = t1._fullLayout._size;
                    r.lx = d.l + d.w * e1.x, r.ly = d.t + d.h * (1 - e1.y);
                    var m = "left";
                    s.isRightAnchor(e1) && (r.lx -= f, m = "right"), s.isCenterAnchor(e1) && (r.lx -= f / 2, m = "center");
                    var g = "top";
                    s.isBottomAnchor(e1) && (r.ly -= p, g = "bottom"), s.isMiddleAnchor(e1) && (r.ly -= p / 2, g = "middle"), r.totalWidth = Math.ceil(r.totalWidth), r.totalHeight = Math.ceil(r.totalHeight), r.lx = Math.round(r.lx), r.ly = Math.round(r.ly), i.autoMargin(t1, A(e1), {
                        x: e1.x,
                        y: e1.y,
                        l: f * (({
                            right: 1,
                            center: .5
                        })[m] || 0),
                        r: f * (({
                            left: 1,
                            center: .5
                        })[m] || 0),
                        b: p * (({
                            top: 1,
                            middle: .5
                        })[g] || 0),
                        t: p * (({
                            bottom: 1,
                            middle: .5
                        })[g] || 0)
                    });
                }
                function A(t1) {
                    return h.autoMarginIdRoot + t1._index;
                }
                function M(t1, e1, r, n) {
                    n = n || {};
                    var i = t1.select("." + h.itemRectClassName), a = t1.select("." + h.itemTextClassName), s = e1.borderwidth, c = r.index, f = e1._dims;
                    o.setTranslate(t1, s + r.x, s + r.y);
                    var p = -1 !== [
                        "up",
                        "down"
                    ].indexOf(e1.direction), d = n.height || (p ? f.heights[c] : f.height1);
                    i.attr({
                        x: 0,
                        y: 0,
                        width: n.width || (p ? f.width1 : f.widths[c]),
                        height: d
                    });
                    var m = e1.font.size * u, g = (l.lineCount(a) - 1) * m / 2;
                    l.positionText(a, h.textOffsetX, d / 2 - g + h.textOffsetY), p ? r.y += f.heights[c] + r.yPad : r.x += f.widths[c] + r.xPad, r.index++;
                }
                function S(t1, e1) {
                    t1.attr(h.menuIndexAttrName, e1 || "-1").selectAll("g." + h.dropdownButtonClassName).remove();
                }
                t1.exports = function(t1) {
                    var e1 = t1._fullLayout, r = s.filterVisible(e1[h.name]);
                    function a(e1) {
                        i.autoMargin(t1, A(e1));
                    }
                    var o = e1._menulayer.selectAll("g." + h.containerClassName).data(r.length > 0 ? [
                        0
                    ] : []);
                    if (o.enter().append("g").classed(h.containerClassName, !0).style("cursor", "pointer"), o.exit().each(function() {
                        n.select(this).selectAll("g." + h.headerGroupClassName).each(a);
                    }).remove(), 0 !== r.length) {
                        var l = o.selectAll("g." + h.headerGroupClassName).data(r, p);
                        l.enter().append("g").classed(h.headerGroupClassName, !0);
                        for(var c = s.ensureSingle(o, "g", h.dropdownButtonGroupClassName, function(t1) {
                            t1.style("pointer-events", "all");
                        }), u = 0; u < r.length; u++){
                            var v = r[u];
                            k(t1, v);
                        }
                        var x = "updatemenus" + e1._uid, _ = new f(t1, c, x);
                        l.enter().size() && (c.node().parentNode.appendChild(c.node()), c.call(S)), l.exit().each(function(t1) {
                            c.call(S), a(t1);
                        }).remove(), l.each(function(e1) {
                            var r = n.select(this), a = "dropdown" === e1.type ? c : null;
                            i.manageCommandObserver(t1, e1, e1.buttons, function(n) {
                                m(t1, e1, e1.buttons[n.index], r, a, _, n.index, !0);
                            }), "dropdown" === e1.type ? (g(t1, r, c, _, e1), d(c, e1) && y(t1, r, c, _, e1)) : y(t1, r, null, null, e1);
                        });
                    }
                };
            },
            46230: function(t1, e1, r) {
                "use strict";
                var n = r(71559);
                t1.exports = {
                    moduleType: "component",
                    name: n.name,
                    layoutAttributes: r(85389),
                    supplyLayoutDefaults: r(42746),
                    draw: r(40974)
                };
            },
            21736: function(t1, e1, r) {
                "use strict";
                t1.exports = s;
                var n = r(45568), i = r(78766), a = r(62203), o = r(34809);
                function s(t1, e1, r) {
                    this.gd = t1, this.container = e1, this.id = r, this.position = null, this.translateX = null, this.translateY = null, this.hbar = null, this.vbar = null, this.bg = this.container.selectAll("rect.scrollbox-bg").data([
                        0
                    ]), this.bg.exit().on(".drag", null).on("wheel", null).remove(), this.bg.enter().append("rect").classed("scrollbox-bg", !0).style("pointer-events", "all").attr({
                        opacity: 0,
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    });
                }
                s.barWidth = 2, s.barLength = 20, s.barRadius = 2, s.barPad = 1, s.barColor = "#808BA4", s.prototype.enable = function(t1, e1, r) {
                    var o = this.gd._fullLayout, l = o.width, c = o.height;
                    this.position = t1;
                    var u, h, f, p, d = this.position.l, m = this.position.w, g = this.position.t, y = this.position.h, v = this.position.direction, x = "down" === v, _ = "left" === v, b = "up" === v, w = m, T = y;
                    x || _ || "right" === v || b || (this.position.direction = "down", x = !0), x || b ? (h = (u = d) + w, x ? (f = g, T = (p = Math.min(f + T, c)) - f) : T = (p = g + T) - (f = Math.max(p - T, 0))) : (p = (f = g) + T, _ ? w = (h = d + w) - (u = Math.max(h - w, 0)) : (u = d, w = (h = Math.min(u + w, l)) - u)), this._box = {
                        l: u,
                        t: f,
                        w: w,
                        h: T
                    };
                    var k = m > w, A = s.barLength + 2 * s.barPad, M = s.barWidth + 2 * s.barPad, S = d, E = g + y;
                    E + M > c && (E = c - M);
                    var C = this.container.selectAll("rect.scrollbar-horizontal").data(k ? [
                        0
                    ] : []);
                    C.exit().on(".drag", null).remove(), C.enter().append("rect").classed("scrollbar-horizontal", !0).call(i.fill, s.barColor), k ? (this.hbar = C.attr({
                        rx: s.barRadius,
                        ry: s.barRadius,
                        x: S,
                        y: E,
                        width: A,
                        height: M
                    }), this._hbarXMin = S + A / 2, this._hbarTranslateMax = w - A) : (delete this.hbar, delete this._hbarXMin, delete this._hbarTranslateMax);
                    var L = y > T, I = s.barWidth + 2 * s.barPad, P = s.barLength + 2 * s.barPad, z = d + m, O = g;
                    z + I > l && (z = l - I);
                    var D = this.container.selectAll("rect.scrollbar-vertical").data(L ? [
                        0
                    ] : []);
                    D.exit().on(".drag", null).remove(), D.enter().append("rect").classed("scrollbar-vertical", !0).call(i.fill, s.barColor), L ? (this.vbar = D.attr({
                        rx: s.barRadius,
                        ry: s.barRadius,
                        x: z,
                        y: O,
                        width: I,
                        height: P
                    }), this._vbarYMin = O + P / 2, this._vbarTranslateMax = T - P) : (delete this.vbar, delete this._vbarYMin, delete this._vbarTranslateMax);
                    var R = this.id, F = u - .5, B = L ? h + I + .5 : h + .5, N = f - .5, j = k ? p + M + .5 : p + .5, U = o._topdefs.selectAll("#" + R).data(k || L ? [
                        0
                    ] : []);
                    if (U.exit().remove(), U.enter().append("clipPath").attr("id", R).append("rect"), k || L ? (this._clipRect = U.select("rect").attr({
                        x: Math.floor(F),
                        y: Math.floor(N),
                        width: Math.ceil(B) - Math.floor(F),
                        height: Math.ceil(j) - Math.floor(N)
                    }), this.container.call(a.setClipUrl, R, this.gd), this.bg.attr({
                        x: d,
                        y: g,
                        width: m,
                        height: y
                    })) : (this.bg.attr({
                        width: 0,
                        height: 0
                    }), this.container.on("wheel", null).on(".drag", null).call(a.setClipUrl, null), delete this._clipRect), k || L) {
                        var V = n.behavior.drag().on("dragstart", function() {
                            n.event.sourceEvent.preventDefault();
                        }).on("drag", this._onBoxDrag.bind(this));
                        this.container.on("wheel", null).on("wheel", this._onBoxWheel.bind(this)).on(".drag", null).call(V);
                        var q = n.behavior.drag().on("dragstart", function() {
                            n.event.sourceEvent.preventDefault(), n.event.sourceEvent.stopPropagation();
                        }).on("drag", this._onBarDrag.bind(this));
                        k && this.hbar.on(".drag", null).call(q), L && this.vbar.on(".drag", null).call(q);
                    }
                    this.setTranslate(e1, r);
                }, s.prototype.disable = function() {
                    (this.hbar || this.vbar) && (this.bg.attr({
                        width: 0,
                        height: 0
                    }), this.container.on("wheel", null).on(".drag", null).call(a.setClipUrl, null), delete this._clipRect), this.hbar && (this.hbar.on(".drag", null), this.hbar.remove(), delete this.hbar, delete this._hbarXMin, delete this._hbarTranslateMax), this.vbar && (this.vbar.on(".drag", null), this.vbar.remove(), delete this.vbar, delete this._vbarYMin, delete this._vbarTranslateMax);
                }, s.prototype._onBoxDrag = function() {
                    var t1 = this.translateX, e1 = this.translateY;
                    this.hbar && (t1 -= n.event.dx), this.vbar && (e1 -= n.event.dy), this.setTranslate(t1, e1);
                }, s.prototype._onBoxWheel = function() {
                    var t1 = this.translateX, e1 = this.translateY;
                    this.hbar && (t1 += n.event.deltaY), this.vbar && (e1 += n.event.deltaY), this.setTranslate(t1, e1);
                }, s.prototype._onBarDrag = function() {
                    var t1 = this.translateX, e1 = this.translateY;
                    if (this.hbar) {
                        var r = t1 + this._hbarXMin, i = r + this._hbarTranslateMax;
                        t1 = (o.constrain(n.event.x, r, i) - r) / (i - r) * (this.position.w - this._box.w);
                    }
                    if (this.vbar) {
                        var a = e1 + this._vbarYMin, s = a + this._vbarTranslateMax;
                        e1 = (o.constrain(n.event.y, a, s) - a) / (s - a) * (this.position.h - this._box.h);
                    }
                    this.setTranslate(t1, e1);
                }, s.prototype.setTranslate = function(t1, e1) {
                    var r = this.position.w - this._box.w, n = this.position.h - this._box.h;
                    if (t1 = o.constrain(t1 || 0, 0, r), e1 = o.constrain(e1 || 0, 0, n), this.translateX = t1, this.translateY = e1, this.container.call(a.setTranslate, this._box.l - this.position.l - t1, this._box.t - this.position.t - e1), this._clipRect && this._clipRect.attr({
                        x: Math.floor(this.position.l + t1 - .5),
                        y: Math.floor(this.position.t + e1 - .5)
                    }), this.hbar) {
                        var i = t1 / r;
                        this.hbar.call(a.setTranslate, t1 + i * this._hbarTranslateMax, e1);
                    }
                    if (this.vbar) {
                        var s = e1 / n;
                        this.vbar.call(a.setTranslate, t1, e1 + s * this._vbarTranslateMax);
                    }
                };
            },
            4530: function(t1) {
                "use strict";
                t1.exports = {
                    FROM_BL: {
                        left: 0,
                        center: .5,
                        right: 1,
                        bottom: 0,
                        middle: .5,
                        top: 1
                    },
                    FROM_TL: {
                        left: 0,
                        center: .5,
                        right: 1,
                        bottom: 1,
                        middle: .5,
                        top: 0
                    },
                    FROM_BR: {
                        left: 1,
                        center: .5,
                        right: 0,
                        bottom: 0,
                        middle: .5,
                        top: 1
                    },
                    LINE_SPACING: 1.3,
                    CAP_SHIFT: .7,
                    MID_SHIFT: .35,
                    OPPOSITE_SIDE: {
                        left: "right",
                        right: "left",
                        top: "bottom",
                        bottom: "top"
                    }
                };
            },
            35081: function(t1) {
                "use strict";
                t1.exports = {
                    axisRefDescription: function(t1, e1, r) {
                        return [
                            "If set to a",
                            t1,
                            "axis id (e.g. *" + t1 + "* or",
                            "*" + t1 + "2*), the `" + t1 + "` position refers to a",
                            t1,
                            "coordinate. If set to *paper*, the `" + t1 + "`",
                            "position refers to the distance from the",
                            e1,
                            "of the plotting",
                            "area in normalized coordinates where *0* (*1*) corresponds to the",
                            e1,
                            "(" + r + "). If set to a",
                            t1,
                            "axis ID followed by",
                            "*domain* (separated by a space), the position behaves like for",
                            "*paper*, but refers to the distance in fractions of the domain",
                            "length from the",
                            e1,
                            "of the domain of that axis: e.g.,",
                            "*" + t1 + "2 domain* refers to the domain of the second",
                            t1,
                            " axis and a",
                            t1,
                            "position of 0.5 refers to the",
                            "point between the",
                            e1,
                            "and the",
                            r,
                            "of the domain of the",
                            "second",
                            t1,
                            "axis."
                        ].join(" ");
                    }
                };
            },
            20909: function(t1) {
                "use strict";
                t1.exports = {
                    INCREASING: {
                        COLOR: "#3D9970",
                        SYMBOL: "\u25B2"
                    },
                    DECREASING: {
                        COLOR: "#FF4136",
                        SYMBOL: "\u25BC"
                    }
                };
            },
            87296: function(t1) {
                "use strict";
                t1.exports = {
                    FORMAT_LINK: "https://github.com/d3/d3-format/tree/v1.4.5#d3-format",
                    DATE_FORMAT_LINK: "https://github.com/d3/d3-time-format/tree/v2.2.3#locale_format"
                };
            },
            20726: function(t1) {
                "use strict";
                t1.exports = {
                    COMPARISON_OPS: [
                        "=",
                        "!=",
                        "<",
                        ">=",
                        ">",
                        "<="
                    ],
                    COMPARISON_OPS2: [
                        "=",
                        "<",
                        ">=",
                        ">",
                        "<="
                    ],
                    INTERVAL_OPS: [
                        "[]",
                        "()",
                        "[)",
                        "(]",
                        "][",
                        ")(",
                        "](",
                        ")["
                    ],
                    SET_OPS: [
                        "{}",
                        "}{"
                    ],
                    CONSTRAINT_REDUCTION: {
                        "=": "=",
                        "<": "<",
                        "<=": "<",
                        ">": ">",
                        ">=": ">",
                        "[]": "[]",
                        "()": "[]",
                        "[)": "[]",
                        "(]": "[]",
                        "][": "][",
                        ")(": "][",
                        "](": "][",
                        ")[": "]["
                    }
                };
            },
            84770: function(t1) {
                "use strict";
                t1.exports = {
                    solid: [
                        [],
                        0
                    ],
                    dot: [
                        [
                            .5,
                            1
                        ],
                        200
                    ],
                    dash: [
                        [
                            .5,
                            1
                        ],
                        50
                    ],
                    longdash: [
                        [
                            .5,
                            1
                        ],
                        10
                    ],
                    dashdot: [
                        [
                            .5,
                            .625,
                            .875,
                            1
                        ],
                        50
                    ],
                    longdashdot: [
                        [
                            .5,
                            .7,
                            .8,
                            1
                        ],
                        10
                    ]
                };
            },
            49467: function(t1) {
                "use strict";
                t1.exports = {
                    circle: "\u25CF",
                    "circle-open": "\u25CB",
                    square: "\u25A0",
                    "square-open": "\u25A1",
                    diamond: "\u25C6",
                    "diamond-open": "\u25C7",
                    cross: "+",
                    x: "\u274C"
                };
            },
            20438: function(t1) {
                "use strict";
                t1.exports = {
                    SHOW_PLACEHOLDER: 100,
                    HIDE_PLACEHOLDER: 1e3,
                    DESELECTDIM: .2
                };
            },
            63821: function(t1) {
                "use strict";
                t1.exports = {
                    BADNUM: void 0,
                    FP_SAFE: 1e-4 * Number.MAX_VALUE,
                    ONEMAXYEAR: 316224e5,
                    ONEAVGYEAR: 315576e5,
                    ONEMINYEAR: 31536e6,
                    ONEMAXQUARTER: 79488e5,
                    ONEAVGQUARTER: 78894e5,
                    ONEMINQUARTER: 76896e5,
                    ONEMAXMONTH: 26784e5,
                    ONEAVGMONTH: 26298e5,
                    ONEMINMONTH: 24192e5,
                    ONEWEEK: 6048e5,
                    ONEDAY: 864e5,
                    ONEHOUR: 36e5,
                    ONEMIN: 6e4,
                    ONESEC: 1e3,
                    ONEMILLI: 1,
                    ONEMICROSEC: .001,
                    EPOCHJD: 2440587.5,
                    ALMOST_EQUAL: .999999,
                    LOG_CLIP: 10,
                    MINUS_SIGN: "\u2212"
                };
            },
            1837: function(t1, e1) {
                "use strict";
                e1.CSS_DECLARATIONS = [
                    [
                        "image-rendering",
                        "optimizeSpeed"
                    ],
                    [
                        "image-rendering",
                        "-moz-crisp-edges"
                    ],
                    [
                        "image-rendering",
                        "-o-crisp-edges"
                    ],
                    [
                        "image-rendering",
                        "-webkit-optimize-contrast"
                    ],
                    [
                        "image-rendering",
                        "optimize-contrast"
                    ],
                    [
                        "image-rendering",
                        "crisp-edges"
                    ],
                    [
                        "image-rendering",
                        "pixelated"
                    ]
                ], e1.STYLE = e1.CSS_DECLARATIONS.map(function(t1) {
                    return t1.join(": ") + "; ";
                }).join("");
            },
            62972: function(t1, e1) {
                "use strict";
                e1.xmlns = "http://www.w3.org/2000/xmlns/", e1.svg = "http://www.w3.org/2000/svg", e1.xlink = "http://www.w3.org/1999/xlink", e1.svgAttrs = {
                    xmlns: e1.svg,
                    "xmlns:xlink": e1.xlink
                };
            },
            17430: function(t1, e1, r) {
                "use strict";
                e1.version = r(29697).version, r(71116), r(6713);
                for(var n = r(33626), i = e1.register = n.register, a = r(90742), o = Object.keys(a), s = 0; s < o.length; s++){
                    var l = o[s];
                    "_" !== l.charAt(0) && (e1[l] = a[l]), i({
                        moduleType: "apiMethod",
                        name: l,
                        fn: a[l]
                    });
                }
                i(r(69693)), i([
                    r(3599),
                    r(83348),
                    r(44844),
                    r(43701),
                    r(15553),
                    r(46230),
                    r(15359),
                    r(55429),
                    r(44453),
                    r(83595),
                    r(77901),
                    r(88856),
                    r(96919),
                    r(82494),
                    r(32141),
                    r(95433)
                ]), i([
                    r(30227),
                    r(44611)
                ]), window.PlotlyLocales && Array.isArray(window.PlotlyLocales) && (i(window.PlotlyLocales), delete window.PlotlyLocales), e1.Icons = r(35188);
                var c = r(32141), u = r(44122);
                e1.Plots = {
                    resize: u.resize,
                    graphJson: u.graphJson,
                    sendDataToCloud: u.sendDataToCloud
                }, e1.Fx = {
                    hover: c.hover,
                    unhover: c.unhover,
                    loneHover: c.loneHover,
                    loneUnhover: c.loneUnhover
                }, e1.Snapshot = r(6170), e1.PlotSchema = r(57297);
            },
            35188: function(t1) {
                "use strict";
                t1.exports = {
                    undo: {
                        width: 857.1,
                        height: 1e3,
                        path: "m857 350q0-87-34-166t-91-137-137-92-166-34q-96 0-183 41t-147 114q-4 6-4 13t5 11l76 77q6 5 14 5 9-1 13-7 41-53 100-82t126-29q58 0 110 23t92 61 61 91 22 111-22 111-61 91-92 61-110 23q-55 0-105-20t-90-57l77-77q17-16 8-38-10-23-33-23h-250q-15 0-25 11t-11 25v250q0 24 22 33 22 10 39-8l72-72q60 57 137 88t159 31q87 0 166-34t137-92 91-137 34-166z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    home: {
                        width: 928.6,
                        height: 1e3,
                        path: "m786 296v-267q0-15-11-26t-25-10h-214v214h-143v-214h-214q-15 0-25 10t-11 26v267q0 1 0 2t0 2l321 264 321-264q1-1 1-4z m124 39l-34-41q-5-5-12-6h-2q-7 0-12 3l-386 322-386-322q-7-4-13-4-7 2-12 7l-35 41q-4 5-3 13t6 12l401 334q18 15 42 15t43-15l136-114v109q0 8 5 13t13 5h107q8 0 13-5t5-13v-227l122-102q5-5 6-12t-4-13z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    "camera-retro": {
                        width: 1e3,
                        height: 1e3,
                        path: "m518 386q0 8-5 13t-13 5q-37 0-63-27t-26-63q0-8 5-13t13-5 12 5 5 13q0 23 16 38t38 16q8 0 13 5t5 13z m125-73q0-59-42-101t-101-42-101 42-42 101 42 101 101 42 101-42 42-101z m-572-320h858v71h-858v-71z m643 320q0 89-62 152t-152 62-151-62-63-152 63-151 151-63 152 63 62 151z m-571 358h214v72h-214v-72z m-72-107h858v143h-462l-36-71h-360v-72z m929 143v-714q0-30-21-51t-50-21h-858q-29 0-50 21t-21 51v714q0 30 21 51t50 21h858q29 0 50-21t21-51z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    zoombox: {
                        width: 1e3,
                        height: 1e3,
                        path: "m1000-25l-250 251c40 63 63 138 63 218 0 224-182 406-407 406-224 0-406-182-406-406s183-406 407-406c80 0 155 22 218 62l250-250 125 125z m-812 250l0 438 437 0 0-438-437 0z m62 375l313 0 0-312-313 0 0 312z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    pan: {
                        width: 1e3,
                        height: 1e3,
                        path: "m1000 350l-187 188 0-125-250 0 0 250 125 0-188 187-187-187 125 0 0-250-250 0 0 125-188-188 186-187 0 125 252 0 0-250-125 0 187-188 188 188-125 0 0 250 250 0 0-126 187 188z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    zoom_plus: {
                        width: 875,
                        height: 1e3,
                        path: "m1 787l0-875 875 0 0 875-875 0z m687-500l-187 0 0-187-125 0 0 187-188 0 0 125 188 0 0 187 125 0 0-187 187 0 0-125z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    zoom_minus: {
                        width: 875,
                        height: 1e3,
                        path: "m0 788l0-876 875 0 0 876-875 0z m688-500l-500 0 0 125 500 0 0-125z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    autoscale: {
                        width: 1e3,
                        height: 1e3,
                        path: "m250 850l-187 0-63 0 0-62 0-188 63 0 0 188 187 0 0 62z m688 0l-188 0 0-62 188 0 0-188 62 0 0 188 0 62-62 0z m-875-938l0 188-63 0 0-188 0-62 63 0 187 0 0 62-187 0z m875 188l0-188-188 0 0-62 188 0 62 0 0 62 0 188-62 0z m-125 188l-1 0-93-94-156 156 156 156 92-93 2 0 0 250-250 0 0-2 93-92-156-156-156 156 94 92 0 2-250 0 0-250 0 0 93 93 157-156-157-156-93 94 0 0 0-250 250 0 0 0-94 93 156 157 156-157-93-93 0 0 250 0 0 250z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    tooltip_basic: {
                        width: 1500,
                        height: 1e3,
                        path: "m375 725l0 0-375-375 375-374 0-1 1125 0 0 750-1125 0z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    tooltip_compare: {
                        width: 1125,
                        height: 1e3,
                        path: "m187 786l0 2-187-188 188-187 0 0 937 0 0 373-938 0z m0-499l0 1-187-188 188-188 0 0 937 0 0 376-938-1z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    plotlylogo: {
                        width: 1542,
                        height: 1e3,
                        path: "m0-10h182v-140h-182v140z m228 146h183v-286h-183v286z m225 714h182v-1000h-182v1000z m225-285h182v-715h-182v715z m225 142h183v-857h-183v857z m231-428h182v-429h-182v429z m225-291h183v-138h-183v138z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    "z-axis": {
                        width: 1e3,
                        height: 1e3,
                        path: "m833 5l-17 108v41l-130-65 130-66c0 0 0 38 0 39 0-1 36-14 39-25 4-15-6-22-16-30-15-12-39-16-56-20-90-22-187-23-279-23-261 0-341 34-353 59 3 60 228 110 228 110-140-8-351-35-351-116 0-120 293-142 474-142 155 0 477 22 477 142 0 50-74 79-163 96z m-374 94c-58-5-99-21-99-40 0-24 65-43 144-43 79 0 143 19 143 43 0 19-42 34-98 40v216h87l-132 135-133-135h88v-216z m167 515h-136v1c16 16 31 34 46 52l84 109v54h-230v-71h124v-1c-16-17-28-32-44-51l-89-114v-51h245v72z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    "3d_rotate": {
                        width: 1e3,
                        height: 1e3,
                        path: "m922 660c-5 4-9 7-14 11-359 263-580-31-580-31l-102 28 58-400c0 1 1 1 2 2 118 108 351 249 351 249s-62 27-100 42c88 83 222 183 347 122 16-8 30-17 44-27-2 1-4 2-6 4z m36-329c0 0 64 229-88 296-62 27-124 14-175-11 157-78 225-208 249-266 8-19 11-31 11-31 2 5 6 15 11 32-5-13-8-20-8-20z m-775-239c70-31 117-50 198-32-121 80-199 346-199 346l-96-15-58-12c0 0 55-226 155-287z m603 133l-317-139c0 0 4-4 19-14 7-5 24-15 24-15s-177-147-389 4c235-287 536-112 536-112l31-22 100 299-4-1z m-298-153c6-4 14-9 24-15 0 0-17 10-24 15z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    camera: {
                        width: 1e3,
                        height: 1e3,
                        path: "m500 450c-83 0-150-67-150-150 0-83 67-150 150-150 83 0 150 67 150 150 0 83-67 150-150 150z m400 150h-120c-16 0-34 13-39 29l-31 93c-6 15-23 28-40 28h-340c-16 0-34-13-39-28l-31-94c-6-15-23-28-40-28h-120c-55 0-100-45-100-100v-450c0-55 45-100 100-100h800c55 0 100 45 100 100v450c0 55-45 100-100 100z m-400-550c-138 0-250 112-250 250 0 138 112 250 250 250 138 0 250-112 250-250 0-138-112-250-250-250z m365 380c-19 0-35 16-35 35 0 19 16 35 35 35 19 0 35-16 35-35 0-19-16-35-35-35z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    movie: {
                        width: 1e3,
                        height: 1e3,
                        path: "m938 413l-188-125c0 37-17 71-44 94 64 38 107 107 107 187 0 121-98 219-219 219-121 0-219-98-219-219 0-61 25-117 66-156h-115c30 33 49 76 49 125 0 103-84 187-187 187s-188-84-188-187c0-57 26-107 65-141-38-22-65-62-65-109v-250c0-70 56-126 125-126h500c69 0 125 56 125 126l188-126c34 0 62 28 62 63v375c0 35-28 63-62 63z m-750 0c-69 0-125 56-125 125s56 125 125 125 125-56 125-125-56-125-125-125z m406-1c-87 0-157 70-157 157 0 86 70 156 157 156s156-70 156-156-70-157-156-157z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    question: {
                        width: 857.1,
                        height: 1e3,
                        path: "m500 82v107q0 8-5 13t-13 5h-107q-8 0-13-5t-5-13v-107q0-8 5-13t13-5h107q8 0 13 5t5 13z m143 375q0 49-31 91t-77 65-95 23q-136 0-207-119-9-14 4-24l74-55q4-4 10-4 9 0 14 7 30 38 48 51 19 14 48 14 27 0 48-15t21-33q0-21-11-34t-38-25q-35-16-65-48t-29-70v-20q0-8 5-13t13-5h107q8 0 13 5t5 13q0 10 12 27t30 28q18 10 28 16t25 19 25 27 16 34 7 45z m214-107q0-117-57-215t-156-156-215-58-216 58-155 156-58 215 58 215 155 156 216 58 215-58 156-156 57-215z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    disk: {
                        width: 857.1,
                        height: 1e3,
                        path: "m214-7h429v214h-429v-214z m500 0h72v500q0 8-6 21t-11 20l-157 156q-5 6-19 12t-22 5v-232q0-22-15-38t-38-16h-322q-22 0-37 16t-16 38v232h-72v-714h72v232q0 22 16 38t37 16h465q22 0 38-16t15-38v-232z m-214 518v178q0 8-5 13t-13 5h-107q-7 0-13-5t-5-13v-178q0-8 5-13t13-5h107q7 0 13 5t5 13z m357-18v-518q0-22-15-38t-38-16h-750q-23 0-38 16t-16 38v750q0 22 16 38t38 16h517q23 0 50-12t42-26l156-157q16-15 27-42t11-49z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    drawopenpath: {
                        width: 70,
                        height: 70,
                        path: "M33.21,85.65a7.31,7.31,0,0,1-2.59-.48c-8.16-3.11-9.27-19.8-9.88-41.3-.1-3.58-.19-6.68-.35-9-.15-2.1-.67-3.48-1.43-3.79-2.13-.88-7.91,2.32-12,5.86L3,32.38c1.87-1.64,11.55-9.66,18.27-6.9,2.13.87,4.75,3.14,5.17,9,.17,2.43.26,5.59.36,9.25a224.17,224.17,0,0,0,1.5,23.4c1.54,10.76,4,12.22,4.48,12.4.84.32,2.79-.46,5.76-3.59L43,80.07C41.53,81.57,37.68,85.64,33.21,85.65ZM74.81,69a11.34,11.34,0,0,0,6.09-6.72L87.26,44.5,74.72,32,56.9,38.35c-2.37.86-5.57,3.42-6.61,6L38.65,72.14l8.42,8.43ZM55,46.27a7.91,7.91,0,0,1,3.64-3.17l14.8-5.3,8,8L76.11,60.6l-.06.19a6.37,6.37,0,0,1-3,3.43L48.25,74.59,44.62,71Zm16.57,7.82A6.9,6.9,0,1,0,64.64,61,6.91,6.91,0,0,0,71.54,54.09Zm-4.05,0a2.85,2.85,0,1,1-2.85-2.85A2.86,2.86,0,0,1,67.49,54.09Zm-4.13,5.22L60.5,56.45,44.26,72.7l2.86,2.86ZM97.83,35.67,84.14,22l-8.57,8.57L89.26,44.24Zm-13.69-8,8,8-2.85,2.85-8-8Z",
                        transform: "matrix(1 0 0 1 -15 -15)"
                    },
                    drawclosedpath: {
                        width: 90,
                        height: 90,
                        path: "M88.41,21.12a26.56,26.56,0,0,0-36.18,0l-2.07,2-2.07-2a26.57,26.57,0,0,0-36.18,0,23.74,23.74,0,0,0,0,34.8L48,90.12a3.22,3.22,0,0,0,4.42,0l36-34.21a23.73,23.73,0,0,0,0-34.79ZM84,51.24,50.16,83.35,16.35,51.25a17.28,17.28,0,0,1,0-25.47,20,20,0,0,1,27.3,0l4.29,4.07a3.23,3.23,0,0,0,4.44,0l4.29-4.07a20,20,0,0,1,27.3,0,17.27,17.27,0,0,1,0,25.46ZM66.76,47.68h-33v6.91h33ZM53.35,35H46.44V68h6.91Z",
                        transform: "matrix(1 0 0 1 -5 -5)"
                    },
                    lasso: {
                        width: 1031,
                        height: 1e3,
                        path: "m1018 538c-36 207-290 336-568 286-277-48-473-256-436-463 10-57 36-108 76-151-13-66 11-137 68-183 34-28 75-41 114-42l-55-70 0 0c-2-1-3-2-4-3-10-14-8-34 5-45 14-11 34-8 45 4 1 1 2 3 2 5l0 0 113 140c16 11 31 24 45 40 4 3 6 7 8 11 48-3 100 0 151 9 278 48 473 255 436 462z m-624-379c-80 14-149 48-197 96 42 42 109 47 156 9 33-26 47-66 41-105z m-187-74c-19 16-33 37-39 60 50-32 109-55 174-68-42-25-95-24-135 8z m360 75c-34-7-69-9-102-8 8 62-16 128-68 170-73 59-175 54-244-5-9 20-16 40-20 61-28 159 121 317 333 354s407-60 434-217c28-159-121-318-333-355z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    selectbox: {
                        width: 1e3,
                        height: 1e3,
                        path: "m0 850l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m285 0l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m-857-286l0-143 143 0 0 143-143 0z m857 0l0-143 143 0 0 143-143 0z m-857-285l0-143 143 0 0 143-143 0z m857 0l0-143 143 0 0 143-143 0z m-857-286l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m285 0l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    drawline: {
                        width: 70,
                        height: 70,
                        path: "M60.64,62.3a11.29,11.29,0,0,0,6.09-6.72l6.35-17.72L60.54,25.31l-17.82,6.4c-2.36.86-5.57,3.41-6.6,6L24.48,65.5l8.42,8.42ZM40.79,39.63a7.89,7.89,0,0,1,3.65-3.17l14.79-5.31,8,8L61.94,54l-.06.19a6.44,6.44,0,0,1-3,3.43L34.07,68l-3.62-3.63Zm16.57,7.81a6.9,6.9,0,1,0-6.89,6.9A6.9,6.9,0,0,0,57.36,47.44Zm-4,0a2.86,2.86,0,1,1-2.85-2.85A2.86,2.86,0,0,1,53.32,47.44Zm-4.13,5.22L46.33,49.8,30.08,66.05l2.86,2.86ZM83.65,29,70,15.34,61.4,23.9,75.09,37.59ZM70,21.06l8,8-2.84,2.85-8-8ZM87,80.49H10.67V87H87Z",
                        transform: "matrix(1 0 0 1 -15 -15)"
                    },
                    drawrect: {
                        width: 80,
                        height: 80,
                        path: "M78,22V79H21V22H78m9-9H12V88H87V13ZM68,46.22H31V54H68ZM53,32H45.22V69H53Z",
                        transform: "matrix(1 0 0 1 -10 -10)"
                    },
                    drawcircle: {
                        width: 80,
                        height: 80,
                        path: "M50,84.72C26.84,84.72,8,69.28,8,50.3S26.84,15.87,50,15.87,92,31.31,92,50.3,73.16,84.72,50,84.72Zm0-60.59c-18.6,0-33.74,11.74-33.74,26.17S31.4,76.46,50,76.46,83.74,64.72,83.74,50.3,68.6,24.13,50,24.13Zm17.15,22h-34v7.11h34Zm-13.8-13H46.24v34h7.11Z",
                        transform: "matrix(1 0 0 1 -10 -10)"
                    },
                    eraseshape: {
                        width: 80,
                        height: 80,
                        path: "M82.77,78H31.85L6,49.57,31.85,21.14H82.77a8.72,8.72,0,0,1,8.65,8.77V69.24A8.72,8.72,0,0,1,82.77,78ZM35.46,69.84H82.77a.57.57,0,0,0,.49-.6V29.91a.57.57,0,0,0-.49-.61H35.46L17,49.57Zm32.68-34.7-24,24,5,5,24-24Zm-19,.53-5,5,24,24,5-5Z",
                        transform: "matrix(1 0 0 1 -10 -10)"
                    },
                    spikeline: {
                        width: 1e3,
                        height: 1e3,
                        path: "M512 409c0-57-46-104-103-104-57 0-104 47-104 104 0 57 47 103 104 103 57 0 103-46 103-103z m-327-39l92 0 0 92-92 0z m-185 0l92 0 0 92-92 0z m370-186l92 0 0 93-92 0z m0-184l92 0 0 92-92 0z",
                        transform: "matrix(1.5 0 0 -1.5 0 850)"
                    },
                    pencil: {
                        width: 1792,
                        height: 1792,
                        path: "M491 1536l91-91-235-235-91 91v107h128v128h107zm523-928q0-22-22-22-10 0-17 7l-542 542q-7 7-7 17 0 22 22 22 10 0 17-7l542-542q7-7 7-17zm-54-192l416 416-832 832h-416v-416zm683 96q0 53-37 90l-166 166-416-416 166-165q36-38 90-38 53 0 91 38l235 234q37 39 37 91z",
                        transform: "matrix(1 0 0 1 0 1)"
                    },
                    newplotlylogo: {
                        name: "newplotlylogo",
                        svg: [
                            "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 132 132'>",
                            "<defs>",
                            " <style>",
                            "  .cls-0{fill:#000;}",
                            "  .cls-1{fill:#FFF;}",
                            "  .cls-2{fill:#F26;}",
                            "  .cls-3{fill:#D69;}",
                            "  .cls-4{fill:#BAC;}",
                            "  .cls-5{fill:#9EF;}",
                            " </style>",
                            "</defs>",
                            " <title>plotly-logomark</title>",
                            " <g id='symbol'>",
                            "  <rect class='cls-0' x='0' y='0' width='132' height='132' rx='18' ry='18'/>",
                            "  <circle class='cls-5' cx='102' cy='30' r='6'/>",
                            "  <circle class='cls-4' cx='78' cy='30' r='6'/>",
                            "  <circle class='cls-4' cx='78' cy='54' r='6'/>",
                            "  <circle class='cls-3' cx='54' cy='30' r='6'/>",
                            "  <circle class='cls-2' cx='30' cy='30' r='6'/>",
                            "  <circle class='cls-2' cx='30' cy='54' r='6'/>",
                            "  <path class='cls-1' d='M30,72a6,6,0,0,0-6,6v24a6,6,0,0,0,12,0V78A6,6,0,0,0,30,72Z'/>",
                            "  <path class='cls-1' d='M78,72a6,6,0,0,0-6,6v24a6,6,0,0,0,12,0V78A6,6,0,0,0,78,72Z'/>",
                            "  <path class='cls-1' d='M54,48a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0V54A6,6,0,0,0,54,48Z'/>",
                            "  <path class='cls-1' d='M102,48a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0V54A6,6,0,0,0,102,48Z'/>",
                            " </g>",
                            "</svg>"
                        ].join("")
                    }
                };
            },
            32546: function(t1, e1) {
                "use strict";
                e1.isLeftAnchor = function(t1) {
                    return "left" === t1.xanchor || "auto" === t1.xanchor && t1.x <= 1 / 3;
                }, e1.isCenterAnchor = function(t1) {
                    return "center" === t1.xanchor || "auto" === t1.xanchor && t1.x > 1 / 3 && t1.x < 2 / 3;
                }, e1.isRightAnchor = function(t1) {
                    return "right" === t1.xanchor || "auto" === t1.xanchor && t1.x >= 2 / 3;
                }, e1.isTopAnchor = function(t1) {
                    return "top" === t1.yanchor || "auto" === t1.yanchor && t1.y >= 2 / 3;
                }, e1.isMiddleAnchor = function(t1) {
                    return "middle" === t1.yanchor || "auto" === t1.yanchor && t1.y > 1 / 3 && t1.y < 2 / 3;
                }, e1.isBottomAnchor = function(t1) {
                    return "bottom" === t1.yanchor || "auto" === t1.yanchor && t1.y <= 1 / 3;
                };
            },
            44313: function(t1, e1, r) {
                "use strict";
                var n = r(98953), i = n.mod, a = n.modHalf, o = Math.PI, s = 2 * o;
                function l(t1) {
                    return Math.abs(t1[1] - t1[0]) > s - 1e-14;
                }
                function c(t1, e1) {
                    return a(e1 - t1, s);
                }
                function u(t1, e1) {
                    if (l(e1)) return !0;
                    var r, n;
                    e1[0] < e1[1] ? (r = e1[0], n = e1[1]) : (r = e1[1], n = e1[0]), (r = i(r, s)) > (n = i(n, s)) && (n += s);
                    var a = i(t1, s), o = a + s;
                    return a >= r && a <= n || o >= r && o <= n;
                }
                function h(t1, e1, r, n, i, a, c) {
                    i = i || 0, a = a || 0;
                    var u, h, f, p, d, m = l([
                        r,
                        n
                    ]);
                    function g(t1, e1) {
                        return [
                            t1 * Math.cos(e1) + i,
                            a - t1 * Math.sin(e1)
                        ];
                    }
                    m ? (u = 0, h = o, f = s) : r < n ? (u = r, f = n) : (u = n, f = r), t1 < e1 ? (p = t1, d = e1) : (p = e1, d = t1);
                    var y, v = Math.abs(f - u) <= o ? 0 : 1;
                    function x(t1, e1, r) {
                        return "A" + [
                            t1,
                            t1
                        ] + " " + [
                            0,
                            v,
                            r
                        ] + " " + g(t1, e1);
                    }
                    return m ? y = null === p ? "M" + g(d, u) + x(d, h, 0) + x(d, f, 0) + "Z" : "M" + g(p, u) + x(p, h, 0) + x(p, f, 0) + "ZM" + g(d, u) + x(d, h, 1) + x(d, f, 1) + "Z" : null === p ? (y = "M" + g(d, u) + x(d, f, 0), c && (y += "L0,0Z")) : y = "M" + g(p, u) + "L" + g(d, u) + x(d, f, 0) + "L" + g(p, f) + x(p, u, 1) + "Z", y;
                }
                t1.exports = {
                    deg2rad: function(t1) {
                        return t1 / 180 * o;
                    },
                    rad2deg: function(t1) {
                        return t1 / o * 180;
                    },
                    angleDelta: c,
                    angleDist: function(t1, e1) {
                        return Math.abs(c(t1, e1));
                    },
                    isFullCircle: l,
                    isAngleInsideSector: u,
                    isPtInsideSector: function(t1, e1, r, n) {
                        var i, a;
                        return !!u(e1, n) && (r[0] < r[1] ? (i = r[0], a = r[1]) : (i = r[1], a = r[0]), t1 >= i && t1 <= a);
                    },
                    pathArc: function(t1, e1, r, n, i) {
                        return h(null, t1, e1, r, n, i, 0);
                    },
                    pathSector: function(t1, e1, r, n, i) {
                        return h(null, t1, e1, r, n, i, 1);
                    },
                    pathAnnulus: function(t1, e1, r, n, i, a) {
                        return h(t1, e1, r, n, i, a, 1);
                    }
                };
            },
            87800: function(t1, e1, r) {
                "use strict";
                var n = r(93229).decode, i = r(56174), a = Array.isArray, o = ArrayBuffer, s = DataView;
                function l(t1) {
                    return o.isView(t1) && !(t1 instanceof s);
                }
                function c(t1) {
                    return a(t1) || l(t1);
                }
                e1.isTypedArray = l, e1.isArrayOrTypedArray = c, e1.isArray1D = function(t1) {
                    return !c(t1[0]);
                }, e1.ensureArray = function(t1, e1) {
                    return a(t1) || (t1 = []), t1.length = e1, t1;
                };
                var u = {
                    u1c: "undefined" == typeof Uint8ClampedArray ? void 0 : Uint8ClampedArray,
                    i1: "undefined" == typeof Int8Array ? void 0 : Int8Array,
                    u1: "undefined" == typeof Uint8Array ? void 0 : Uint8Array,
                    i2: "undefined" == typeof Int16Array ? void 0 : Int16Array,
                    u2: "undefined" == typeof Uint16Array ? void 0 : Uint16Array,
                    i4: "undefined" == typeof Int32Array ? void 0 : Int32Array,
                    u4: "undefined" == typeof Uint32Array ? void 0 : Uint32Array,
                    f4: "undefined" == typeof Float32Array ? void 0 : Float32Array,
                    f8: "undefined" == typeof Float64Array ? void 0 : Float64Array
                };
                function h(t1) {
                    return t1.constructor === ArrayBuffer;
                }
                function f(t1, e1, r) {
                    if (c(t1)) {
                        if (c(t1[0])) {
                            for(var n = r, i = 0; i < t1.length; i++)n = e1(n, t1[i].length);
                            return n;
                        }
                        return t1.length;
                    }
                    return 0;
                }
                u.uint8c = u.u1c, u.uint8 = u.u1, u.int8 = u.i1, u.uint16 = u.u2, u.int16 = u.i2, u.uint32 = u.u4, u.int32 = u.i4, u.float32 = u.f4, u.float64 = u.f8, e1.isArrayBuffer = h, e1.decodeTypedArraySpec = function(t1) {
                    var e1 = [], r = function(t1) {
                        return {
                            bdata: t1.bdata,
                            dtype: t1.dtype,
                            shape: t1.shape
                        };
                    }(t1), i = r.dtype, a = u[i];
                    if (!a) throw new Error('Error in dtype: "' + i + '"');
                    var o = a.BYTES_PER_ELEMENT, s = r.bdata;
                    h(s) || (s = n(s));
                    var l = void 0 === r.shape ? [
                        s.byteLength / o
                    ] : ("" + r.shape).split(",");
                    l.reverse();
                    var c, f, p = l.length, d = +l[0], m = o * d, g = 0;
                    if (1 === p) e1 = new a(s);
                    else if (2 === p) for(c = +l[1], f = 0; f < c; f++)e1[f] = new a(s, g, d), g += m;
                    else {
                        if (3 !== p) throw new Error("ndim: " + p + 'is not supported with the shape:"' + r.shape + '"');
                        c = +l[1];
                        for(var y = +l[2], v = 0; v < y; v++)for(e1[v] = [], f = 0; f < c; f++)e1[v][f] = new a(s, g, d), g += m;
                    }
                    return e1.bdata = r.bdata, e1.dtype = r.dtype, e1.shape = l.reverse().join(","), t1._inputArray = e1, e1;
                }, e1.isTypedArraySpec = function(t1) {
                    return i(t1) && t1.hasOwnProperty("dtype") && "string" == typeof t1.dtype && t1.hasOwnProperty("bdata") && ("string" == typeof t1.bdata || h(t1.bdata)) && (void 0 === t1.shape || t1.hasOwnProperty("shape") && ("string" == typeof t1.shape || "number" == typeof t1.shape));
                }, e1.concat = function() {
                    var t1, e1, r, n, i, o, s, l, c = [], u = !0, h = 0;
                    for(r = 0; r < arguments.length; r++)(o = (n = arguments[r]).length) && (e1 ? c.push(n) : (e1 = n, i = o), a(n) ? t1 = !1 : (u = !1, h ? t1 !== n.constructor && (t1 = !1) : t1 = n.constructor), h += o);
                    if (!h) return [];
                    if (!c.length) return e1;
                    if (u) return e1.concat.apply(e1, c);
                    if (t1) {
                        for((s = new t1(h)).set(e1), r = 0; r < c.length; r++)n = c[r], s.set(n, i), i += n.length;
                        return s;
                    }
                    for(s = new Array(h), l = 0; l < e1.length; l++)s[l] = e1[l];
                    for(r = 0; r < c.length; r++){
                        for(n = c[r], l = 0; l < n.length; l++)s[i + l] = n[l];
                        i += l;
                    }
                    return s;
                }, e1.maxRowLength = function(t1) {
                    return f(t1, Math.max, 0);
                }, e1.minRowLength = function(t1) {
                    return f(t1, Math.min, 1 / 0);
                };
            },
            44498: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(63821).BADNUM, a = /^['"%,$#\s']+|[, ]|['"%,$#\s']+$/g;
                t1.exports = function(t1) {
                    return "string" == typeof t1 && (t1 = t1.replace(a, "")), n(t1) ? Number(t1) : i;
                };
            },
            34823: function(t1) {
                "use strict";
                t1.exports = function(t1) {
                    var e1 = t1._fullLayout;
                    e1._glcanvas && e1._glcanvas.size() && e1._glcanvas.each(function(t1) {
                        t1.regl && t1.regl.clear({
                            color: !0,
                            depth: !0
                        });
                    });
                };
            },
            23493: function(t1) {
                "use strict";
                t1.exports = function(t1) {
                    t1._responsiveChartHandler && (window.removeEventListener("resize", t1._responsiveChartHandler), delete t1._responsiveChartHandler);
                };
            },
            34220: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(65657), a = r(93049).extendFlat, o = r(9829), s = r(19017), l = r(78766), c = r(20438).DESELECTDIM, u = r(35632), h = r(90694).counter, f = r(98953).modHalf, p = r(87800).isArrayOrTypedArray, d = r(87800).isTypedArraySpec, m = r(87800).decodeTypedArraySpec;
                function g(t1, r) {
                    var n = e1.valObjectMeta[r.valType];
                    if (r.arrayOk && p(t1)) return !0;
                    if (n.validateFunction) return n.validateFunction(t1, r);
                    var i = {}, a = i, o = {
                        set: function(t1) {
                            a = t1;
                        }
                    };
                    return n.coerceFunction(t1, o, i, r), a !== i;
                }
                e1.valObjectMeta = {
                    data_array: {
                        coerceFunction: function(t1, e1, r) {
                            e1.set(p(t1) ? t1 : d(t1) ? m(t1) : r);
                        }
                    },
                    enumerated: {
                        coerceFunction: function(t1, e1, r, n) {
                            n.coerceNumber && (t1 = +t1), -1 === n.values.indexOf(t1) ? e1.set(r) : e1.set(t1);
                        },
                        validateFunction: function(t1, e1) {
                            e1.coerceNumber && (t1 = +t1);
                            for(var r = e1.values, n = 0; n < r.length; n++){
                                var i = String(r[n]);
                                if ("/" === i.charAt(0) && "/" === i.charAt(i.length - 1)) {
                                    if (new RegExp(i.substr(1, i.length - 2)).test(t1)) return !0;
                                } else if (t1 === r[n]) return !0;
                            }
                            return !1;
                        }
                    },
                    boolean: {
                        coerceFunction: function(t1, e1, r) {
                            !0 === t1 || !1 === t1 ? e1.set(t1) : e1.set(r);
                        }
                    },
                    number: {
                        coerceFunction: function(t1, e1, r, i) {
                            d(t1) && (t1 = m(t1)), !n(t1) || void 0 !== i.min && t1 < i.min || void 0 !== i.max && t1 > i.max ? e1.set(r) : e1.set(+t1);
                        }
                    },
                    integer: {
                        coerceFunction: function(t1, e1, r, i) {
                            -1 === (i.extras || []).indexOf(t1) ? (d(t1) && (t1 = m(t1)), t1 % 1 || !n(t1) || void 0 !== i.min && t1 < i.min || void 0 !== i.max && t1 > i.max ? e1.set(r) : e1.set(+t1)) : e1.set(t1);
                        }
                    },
                    string: {
                        coerceFunction: function(t1, e1, r, n) {
                            if ("string" != typeof t1) {
                                var i = "number" == typeof t1;
                                !0 !== n.strict && i ? e1.set(String(t1)) : e1.set(r);
                            } else n.noBlank && !t1 ? e1.set(r) : e1.set(t1);
                        }
                    },
                    color: {
                        coerceFunction: function(t1, e1, r) {
                            d(t1) && (t1 = m(t1)), i(t1).isValid() ? e1.set(t1) : e1.set(r);
                        }
                    },
                    colorlist: {
                        coerceFunction: function(t1, e1, r) {
                            Array.isArray(t1) && t1.length && t1.every(function(t1) {
                                return i(t1).isValid();
                            }) ? e1.set(t1) : e1.set(r);
                        }
                    },
                    colorscale: {
                        coerceFunction: function(t1, e1, r) {
                            e1.set(s.get(t1, r));
                        }
                    },
                    angle: {
                        coerceFunction: function(t1, e1, r) {
                            d(t1) && (t1 = m(t1)), "auto" === t1 ? e1.set("auto") : n(t1) ? e1.set(f(+t1, 360)) : e1.set(r);
                        }
                    },
                    subplotid: {
                        coerceFunction: function(t1, e1, r, n) {
                            var i = n.regex || h(r);
                            "string" == typeof t1 && i.test(t1) ? e1.set(t1) : e1.set(r);
                        },
                        validateFunction: function(t1, e1) {
                            var r = e1.dflt;
                            return t1 === r || "string" == typeof t1 && !!h(r).test(t1);
                        }
                    },
                    flaglist: {
                        coerceFunction: function(t1, e1, r, n) {
                            if (-1 === (n.extras || []).indexOf(t1)) {
                                if ("string" == typeof t1) {
                                    for(var i = t1.split("+"), a = 0; a < i.length;){
                                        var o = i[a];
                                        -1 === n.flags.indexOf(o) || i.indexOf(o) < a ? i.splice(a, 1) : a++;
                                    }
                                    i.length ? e1.set(i.join("+")) : e1.set(r);
                                } else e1.set(r);
                            } else e1.set(t1);
                        }
                    },
                    any: {
                        coerceFunction: function(t1, e1, r) {
                            void 0 === t1 ? e1.set(r) : e1.set(d(t1) ? m(t1) : t1);
                        }
                    },
                    info_array: {
                        coerceFunction: function(t1, r, n, i) {
                            function a(t1, r, n) {
                                var i, a = {
                                    set: function(t1) {
                                        i = t1;
                                    }
                                };
                                return void 0 === n && (n = r.dflt), e1.valObjectMeta[r.valType].coerceFunction(t1, a, n, r), i;
                            }
                            if (d(t1) && (t1 = m(t1)), p(t1)) {
                                var o, s, l, c, u, h, f = 2 === i.dimensions || "1-2" === i.dimensions && Array.isArray(t1) && p(t1[0]), g = i.items, y = [], v = Array.isArray(g), x = v && f && p(g[0]), _ = f && v && !x, b = v && !_ ? g.length : t1.length;
                                if (n = Array.isArray(n) ? n : [], f) for(o = 0; o < b; o++)for(y[o] = [], l = p(t1[o]) ? t1[o] : [], u = _ ? g.length : v ? g[o].length : l.length, s = 0; s < u; s++)c = _ ? g[s] : v ? g[o][s] : g, void 0 !== (h = a(l[s], c, (n[o] || [])[s])) && (y[o][s] = h);
                                else for(o = 0; o < b; o++)void 0 !== (h = a(t1[o], v ? g[o] : g, n[o])) && (y[o] = h);
                                r.set(y);
                            } else r.set(n);
                        },
                        validateFunction: function(t1, e1) {
                            if (!p(t1)) return !1;
                            var r = e1.items, n = Array.isArray(r), i = 2 === e1.dimensions;
                            if (!e1.freeLength && t1.length !== r.length) return !1;
                            for(var a = 0; a < t1.length; a++)if (i) {
                                if (!p(t1[a]) || !e1.freeLength && t1[a].length !== r[a].length) return !1;
                                for(var o = 0; o < t1[a].length; o++)if (!g(t1[a][o], n ? r[a][o] : r)) return !1;
                            } else if (!g(t1[a], n ? r[a] : r)) return !1;
                            return !0;
                        }
                    }
                }, e1.coerce = function(t1, r, n, i, a) {
                    var o = u(n, i).get(), s = u(t1, i), l = u(r, i), c = s.get(), h = r._template;
                    if (void 0 === c && h && (c = u(h, i).get(), h = 0), void 0 === a && (a = o.dflt), o.arrayOk) {
                        if (p(c)) return l.set(c), c;
                        if (d(c)) return c = m(c), l.set(c), c;
                    }
                    var f = e1.valObjectMeta[o.valType].coerceFunction;
                    f(c, l, a, o);
                    var y = l.get();
                    return h && y === a && !g(c, o) && (f(c = u(h, i).get(), l, a, o), y = l.get()), y;
                }, e1.coerce2 = function(t1, r, n, i, a) {
                    var o = u(t1, i), s = e1.coerce(t1, r, n, i, a);
                    return null != o.get() && s;
                }, e1.coerceFont = function(t1, e1, r, n) {
                    n || (n = {}), r = a({}, r);
                    var i = {
                        family: t1(e1 + ".family", (r = a(r, n.overrideDflt || {})).family),
                        size: t1(e1 + ".size", r.size),
                        color: t1(e1 + ".color", r.color),
                        weight: t1(e1 + ".weight", r.weight),
                        style: t1(e1 + ".style", r.style)
                    };
                    if (n.noFontVariant || (i.variant = t1(e1 + ".variant", r.variant)), n.noFontLineposition || (i.lineposition = t1(e1 + ".lineposition", r.lineposition)), n.noFontTextcase || (i.textcase = t1(e1 + ".textcase", r.textcase)), !n.noFontShadow) {
                        var o = r.shadow;
                        "none" === o && n.autoShadowDflt && (o = "auto"), i.shadow = t1(e1 + ".shadow", o);
                    }
                    return i;
                }, e1.coercePattern = function(t1, e1, r, n) {
                    if (t1(e1 + ".shape")) {
                        t1(e1 + ".solidity"), t1(e1 + ".size");
                        var i = "overlay" === t1(e1 + ".fillmode");
                        if (!n) {
                            var a = t1(e1 + ".bgcolor", i ? r : void 0);
                            t1(e1 + ".fgcolor", i ? l.contrast(a) : r);
                        }
                        t1(e1 + ".fgopacity", i ? .5 : 1);
                    }
                }, e1.coerceHoverinfo = function(t1, r, n) {
                    var i, a = r._module.attributes, s = a.hoverinfo ? a : o, l = s.hoverinfo;
                    if (1 === n._dataLength) {
                        var c = "all" === l.dflt ? l.flags.slice() : l.dflt.split("+");
                        c.splice(c.indexOf("name"), 1), i = c.join("+");
                    }
                    return e1.coerce(t1, r, s, "hoverinfo", i);
                }, e1.coerceSelectionMarkerOpacity = function(t1, e1) {
                    if (t1.marker) {
                        var r, n, i = t1.marker.opacity;
                        void 0 !== i && (p(i) || t1.selected || t1.unselected || (r = i, n = c * i), e1("selected.marker.opacity", r), e1("unselected.marker.opacity", n));
                    }
                }, e1.validate = g;
            },
            92596: function(t1, e1, r) {
                "use strict";
                var n, i, a = r(42696).DC, o = r(10721), s = r(48636), l = r(98953).mod, c = r(63821), u = c.BADNUM, h = c.ONEDAY, f = c.ONEHOUR, p = c.ONEMIN, d = c.ONESEC, m = c.EPOCHJD, g = r(33626), y = r(42696).aL, v = /^\s*(-?\d\d\d\d|\d\d)(-(\d?\d)(-(\d?\d)([ Tt]([01]?\d|2[0-3])(:([0-5]\d)(:([0-5]\d(\.\d+)?))?(Z|z|[+\-]\d\d(:?\d\d)?)?)?)?)?)?\s*$/m, x = /^\s*(-?\d\d\d\d|\d\d)(-(\d?\di?)(-(\d?\d)([ Tt]([01]?\d|2[0-3])(:([0-5]\d)(:([0-5]\d(\.\d+)?))?(Z|z|[+\-]\d\d(:?\d\d)?)?)?)?)?)?\s*$/m, _ = (new Date).getFullYear() - 70;
                function b(t1) {
                    return t1 && g.componentsRegistry.calendars && "string" == typeof t1 && "gregorian" !== t1;
                }
                function w(t1, e1) {
                    return String(t1 + Math.pow(10, e1)).substr(1);
                }
                e1.dateTick0 = function(t1, r) {
                    var n = function(t1, e1) {
                        return b(t1) ? e1 ? g.getComponentMethod("calendars", "CANONICAL_SUNDAY")[t1] : g.getComponentMethod("calendars", "CANONICAL_TICK")[t1] : e1 ? "2000-01-02" : "2000-01-01";
                    }(t1, !!r);
                    if (r < 2) return n;
                    var i = e1.dateTime2ms(n, t1);
                    return i += h * (r - 1), e1.ms2DateTime(i, 0, t1);
                }, e1.dfltRange = function(t1) {
                    return b(t1) ? g.getComponentMethod("calendars", "DFLTRANGE")[t1] : [
                        "2000-01-01",
                        "2001-01-01"
                    ];
                }, e1.isJSDate = function(t1) {
                    return "object" == typeof t1 && null !== t1 && "function" == typeof t1.getTime;
                }, e1.dateTime2ms = function(t1, r) {
                    if (e1.isJSDate(t1)) {
                        var a = t1.getTimezoneOffset() * p, o = (t1.getUTCMinutes() - t1.getMinutes()) * p + (t1.getUTCSeconds() - t1.getSeconds()) * d + (t1.getUTCMilliseconds() - t1.getMilliseconds());
                        if (o) {
                            var s = 3 * p;
                            a = a - s / 2 + l(o - a + s / 2, s);
                        }
                        return (t1 = Number(t1) - a) >= n && t1 <= i ? t1 : u;
                    }
                    if ("string" != typeof t1 && "number" != typeof t1) return u;
                    t1 = String(t1);
                    var c = b(r), y = t1.charAt(0);
                    !c || "G" !== y && "g" !== y || (t1 = t1.substr(1), r = "");
                    var w = c && "chinese" === r.substr(0, 7), T = t1.match(w ? x : v);
                    if (!T) return u;
                    var k = T[1], A = T[3] || "1", M = Number(T[5] || 1), S = Number(T[7] || 0), E = Number(T[9] || 0), C = Number(T[11] || 0);
                    if (c) {
                        if (2 === k.length) return u;
                        var L;
                        k = Number(k);
                        try {
                            var I = g.getComponentMethod("calendars", "getCal")(r);
                            if (w) {
                                var P = "i" === A.charAt(A.length - 1);
                                A = parseInt(A, 10), L = I.newDate(k, I.toMonthIndex(k, A, P), M);
                            } else L = I.newDate(k, Number(A), M);
                        } catch (t1) {
                            return u;
                        }
                        return L ? (L.toJD() - m) * h + S * f + E * p + C * d : u;
                    }
                    k = 2 === k.length ? (Number(k) + 2e3 - _) % 100 + _ : Number(k), A -= 1;
                    var z = new Date(Date.UTC(2e3, A, M, S, E));
                    return z.setUTCFullYear(k), z.getUTCMonth() !== A || z.getUTCDate() !== M ? u : z.getTime() + C * d;
                }, n = e1.MIN_MS = e1.dateTime2ms("-9999"), i = e1.MAX_MS = e1.dateTime2ms("9999-12-31 23:59:59.9999"), e1.isDateTime = function(t1, r) {
                    return e1.dateTime2ms(t1, r) !== u;
                };
                var T = 90 * h, k = 3 * f, A = 5 * p;
                function M(t1, e1, r, n, i) {
                    if ((e1 || r || n || i) && (t1 += " " + w(e1, 2) + ":" + w(r, 2), (n || i) && (t1 += ":" + w(n, 2), i))) {
                        for(var a = 4; i % 10 == 0;)a -= 1, i /= 10;
                        t1 += "." + w(i, a);
                    }
                    return t1;
                }
                e1.ms2DateTime = function(t1, e1, r) {
                    if ("number" != typeof t1 || !(t1 >= n && t1 <= i)) return u;
                    e1 || (e1 = 0);
                    var a, o, s, c, v, x, _ = Math.floor(10 * l(t1 + .05, 1)), w = Math.round(t1 - _ / 10);
                    if (b(r)) {
                        var S = Math.floor(w / h) + m, E = Math.floor(l(t1, h));
                        try {
                            a = g.getComponentMethod("calendars", "getCal")(r).fromJD(S).formatDate("yyyy-mm-dd");
                        } catch (t1) {
                            a = y("G%Y-%m-%d")(new Date(w));
                        }
                        if ("-" === a.charAt(0)) for(; a.length < 11;)a = "-0" + a.substr(1);
                        else for(; a.length < 10;)a = "0" + a;
                        o = e1 < T ? Math.floor(E / f) : 0, s = e1 < T ? Math.floor(E % f / p) : 0, c = e1 < k ? Math.floor(E % p / d) : 0, v = e1 < A ? E % d * 10 + _ : 0;
                    } else x = new Date(w), a = y("%Y-%m-%d")(x), o = e1 < T ? x.getUTCHours() : 0, s = e1 < T ? x.getUTCMinutes() : 0, c = e1 < k ? x.getUTCSeconds() : 0, v = e1 < A ? 10 * x.getUTCMilliseconds() + _ : 0;
                    return M(a, o, s, c, v);
                }, e1.ms2DateTimeLocal = function(t1) {
                    if (!(t1 >= n + h && t1 <= i - h)) return u;
                    var e1 = Math.floor(10 * l(t1 + .05, 1)), r = new Date(Math.round(t1 - e1 / 10));
                    return M(a("%Y-%m-%d")(r), r.getHours(), r.getMinutes(), r.getSeconds(), 10 * r.getUTCMilliseconds() + e1);
                }, e1.cleanDate = function(t1, r, n) {
                    if (t1 === u) return r;
                    if (e1.isJSDate(t1) || "number" == typeof t1 && isFinite(t1)) {
                        if (b(n)) return s.error("JS Dates and milliseconds are incompatible with world calendars", t1), r;
                        if (!(t1 = e1.ms2DateTimeLocal(+t1)) && void 0 !== r) return r;
                    } else if (!e1.isDateTime(t1, n)) return s.error("unrecognized date", t1), r;
                    return t1;
                };
                var S = /%\d?f/g, E = /%h/g, C = {
                    1: "1",
                    2: "1",
                    3: "2",
                    4: "2"
                };
                function L(t1, e1, r, n) {
                    t1 = t1.replace(S, function(t1) {
                        var r = Math.min(+t1.charAt(1) || 6, 6);
                        return (e1 / 1e3 % 1 + 2).toFixed(r).substr(2).replace(/0+$/, "") || "0";
                    });
                    var i = new Date(Math.floor(e1 + .05));
                    if (t1 = t1.replace(E, function() {
                        return C[r("%q")(i)];
                    }), b(n)) try {
                        t1 = g.getComponentMethod("calendars", "worldCalFmt")(t1, e1, n);
                    } catch (t1) {
                        return "Invalid";
                    }
                    return r(t1)(i);
                }
                var I = [
                    59,
                    59.9,
                    59.99,
                    59.999,
                    59.9999
                ];
                e1.formatDate = function(t1, e1, r, n, i, a) {
                    if (i = b(i) && i, !e1) {
                        if ("y" === r) e1 = a.year;
                        else if ("m" === r) e1 = a.month;
                        else {
                            if ("d" !== r) return function(t1, e1) {
                                var r = l(t1 + .05, h), n = w(Math.floor(r / f), 2) + ":" + w(l(Math.floor(r / p), 60), 2);
                                if ("M" !== e1) {
                                    o(e1) || (e1 = 0);
                                    var i = (100 + Math.min(l(t1 / d, 60), I[e1])).toFixed(e1).substr(1);
                                    e1 > 0 && (i = i.replace(/0+$/, "").replace(/[\.]$/, "")), n += ":" + i;
                                }
                                return n;
                            }(t1, r) + "\n" + L(a.dayMonthYear, t1, n, i);
                            e1 = a.dayMonth + "\n" + a.year;
                        }
                    }
                    return L(e1, t1, n, i);
                };
                var P = 3 * h;
                e1.incrementMonth = function(t1, e1, r) {
                    r = b(r) && r;
                    var n = l(t1, h);
                    if (t1 = Math.round(t1 - n), r) try {
                        var i = Math.round(t1 / h) + m, a = g.getComponentMethod("calendars", "getCal")(r), o = a.fromJD(i);
                        return e1 % 12 ? a.add(o, e1, "m") : a.add(o, e1 / 12, "y"), (o.toJD() - m) * h + n;
                    } catch (e1) {
                        s.error("invalid ms " + t1 + " in calendar " + r);
                    }
                    var c = new Date(t1 + P);
                    return c.setUTCMonth(c.getUTCMonth() + e1) + n - P;
                }, e1.findExactDates = function(t1, e1) {
                    for(var r, n, i = 0, a = 0, s = 0, l = 0, c = b(e1) && g.getComponentMethod("calendars", "getCal")(e1), u = 0; u < t1.length; u++)if (n = t1[u], o(n)) {
                        if (!(n % h)) {
                            if (c) try {
                                1 === (r = c.fromJD(n / h + m)).day() ? 1 === r.month() ? i++ : a++ : s++;
                            } catch (t1) {}
                            else 1 === (r = new Date(n)).getUTCDate() ? 0 === r.getUTCMonth() ? i++ : a++ : s++;
                        }
                    } else l++;
                    s += a += i;
                    var f = t1.length - l;
                    return {
                        exactYears: i / f,
                        exactMonths: a / f,
                        exactDays: s / f
                    };
                };
            },
            95425: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(48636), a = r(15236), o = r(11191);
                function s(t1) {
                    var e1 = t1 && t1.parentNode;
                    e1 && e1.removeChild(t1);
                }
                function l(t1, e1, r) {
                    var n = "plotly.js-style-" + t1, a = document.getElementById(n);
                    a || ((a = document.createElement("style")).setAttribute("id", n), a.appendChild(document.createTextNode("")), document.head.appendChild(a));
                    var o = a.sheet;
                    o.insertRule ? o.insertRule(e1 + "{" + r + "}", 0) : o.addRule ? o.addRule(e1, r, 0) : i.warn("addStyleRule failed");
                }
                function c(t1) {
                    var e1 = window.getComputedStyle(t1, null), r = e1.getPropertyValue("-webkit-transform") || e1.getPropertyValue("-moz-transform") || e1.getPropertyValue("-ms-transform") || e1.getPropertyValue("-o-transform") || e1.getPropertyValue("transform");
                    return "none" === r ? null : r.replace("matrix", "").replace("3d", "").slice(1, -1).split(",").map(function(t1) {
                        return +t1;
                    });
                }
                function u(t1) {
                    for(var e1 = []; h(t1);)e1.push(t1), t1 = t1.parentNode, "function" == typeof ShadowRoot && t1 instanceof ShadowRoot && (t1 = t1.host);
                    return e1;
                }
                function h(t1) {
                    return t1 && (t1 instanceof Element || t1 instanceof HTMLElement);
                }
                t1.exports = {
                    getGraphDiv: function(t1) {
                        var e1;
                        if ("string" == typeof t1) {
                            if (null === (e1 = document.getElementById(t1))) throw new Error("No DOM element with id '" + t1 + "' exists on the page.");
                            return e1;
                        }
                        if (null == t1) throw new Error("DOM element provided is null or undefined");
                        return t1;
                    },
                    isPlotDiv: function(t1) {
                        var e1 = n.select(t1);
                        return e1.node() instanceof HTMLElement && e1.size() && e1.classed("js-plotly-plot");
                    },
                    removeElement: s,
                    addStyleRule: function(t1, e1) {
                        l("global", t1, e1);
                    },
                    addRelatedStyleRule: l,
                    deleteRelatedStyleRule: function(t1) {
                        var e1 = "plotly.js-style-" + t1, r = document.getElementById(e1);
                        r && s(r);
                    },
                    getFullTransformMatrix: function(t1) {
                        var e1 = u(t1), r = [
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1
                        ];
                        return e1.forEach(function(t1) {
                            var e1 = c(t1);
                            if (e1) {
                                var n = a.convertCssMatrix(e1);
                                r = o.multiply(r, r, n);
                            }
                        }), r;
                    },
                    getElementTransformMatrix: c,
                    getElementAndAncestors: u,
                    equalDomRects: function(t1, e1) {
                        return t1 && e1 && t1.top === e1.top && t1.left === e1.left && t1.right === e1.right && t1.bottom === e1.bottom;
                    }
                };
            },
            68596: function(t1, e1, r) {
                "use strict";
                var n = r(7683).EventEmitter, i = {
                    init: function(t1) {
                        if (t1._ev instanceof n) return t1;
                        var e1 = new n, r = new n;
                        return t1._ev = e1, t1._internalEv = r, t1.on = e1.on.bind(e1), t1.once = e1.once.bind(e1), t1.removeListener = e1.removeListener.bind(e1), t1.removeAllListeners = e1.removeAllListeners.bind(e1), t1._internalOn = r.on.bind(r), t1._internalOnce = r.once.bind(r), t1._removeInternalListener = r.removeListener.bind(r), t1._removeAllInternalListeners = r.removeAllListeners.bind(r), t1.emit = function(n, i) {
                            "undefined" != typeof jQuery && jQuery(t1).trigger(n, i), e1.emit(n, i), r.emit(n, i);
                        }, t1;
                    },
                    triggerHandler: function(t1, e1, r) {
                        var n, i;
                        "undefined" != typeof jQuery && (n = jQuery(t1).triggerHandler(e1, r));
                        var a = t1._ev;
                        if (!a) return n;
                        var o, s = a._events[e1];
                        if (!s) return n;
                        function l(t1) {
                            return t1.listener ? (a.removeListener(e1, t1.listener), t1.fired ? void 0 : (t1.fired = !0, t1.listener.apply(a, [
                                r
                            ]))) : t1.apply(a, [
                                r
                            ]);
                        }
                        for(s = Array.isArray(s) ? s : [
                            s
                        ], o = 0; o < s.length - 1; o++)l(s[o]);
                        return i = l(s[o]), void 0 !== n ? n : i;
                    },
                    purge: function(t1) {
                        return delete t1._ev, delete t1.on, delete t1.once, delete t1.removeListener, delete t1.removeAllListeners, delete t1.emit, delete t1._ev, delete t1._internalEv, delete t1._internalOn, delete t1._internalOnce, delete t1._removeInternalListener, delete t1._removeAllInternalListeners, t1;
                    }
                };
                t1.exports = i;
            },
            93049: function(t1, e1, r) {
                "use strict";
                var n = r(56174), i = Array.isArray;
                function a(t1, e1, r, o) {
                    var s, l, c, u, h, f, p, d = t1[0], m = t1.length;
                    if (2 === m && i(d) && i(t1[1]) && 0 === d.length) {
                        if (p = function(t1, e1) {
                            var r, n;
                            for(r = 0; r < t1.length; r++){
                                if (null !== (n = t1[r]) && "object" == typeof n) return !1;
                                void 0 !== n && (e1[r] = n);
                            }
                            return !0;
                        }(t1[1], d), p) return d;
                        d.splice(0, d.length);
                    }
                    for(var g = 1; g < m; g++)for(l in s = t1[g])c = d[l], u = s[l], o && i(u) ? d[l] = u : e1 && u && (n(u) || (h = i(u))) ? (h ? (h = !1, f = c && i(c) ? c : []) : f = c && n(c) ? c : {}, d[l] = a([
                        f,
                        u
                    ], e1, r, o)) : (void 0 !== u || r) && (d[l] = u);
                    return d;
                }
                e1.extendFlat = function() {
                    return a(arguments, !1, !1, !1);
                }, e1.extendDeep = function() {
                    return a(arguments, !0, !1, !1);
                }, e1.extendDeepAll = function() {
                    return a(arguments, !0, !0, !1);
                }, e1.extendDeepNoArrays = function() {
                    return a(arguments, !0, !1, !0);
                };
            },
            48965: function(t1) {
                "use strict";
                t1.exports = function(t1) {
                    for(var e1 = {}, r = [], n = 0, i = 0; i < t1.length; i++){
                        var a = t1[i];
                        1 !== e1[a] && (e1[a] = 1, r[n++] = a);
                    }
                    return r;
                };
            },
            78926: function(t1) {
                "use strict";
                function e1(t1) {
                    return !0 === t1.visible;
                }
                function r(t1) {
                    var e1 = t1[0].trace;
                    return !0 === e1.visible && 0 !== e1._length;
                }
                t1.exports = function(t1) {
                    for(var n, i = (n = t1, Array.isArray(n) && Array.isArray(n[0]) && n[0][0] && n[0][0].trace ? r : e1), a = [], o = 0; o < t1.length; o++){
                        var s = t1[o];
                        i(s) && a.push(s);
                    }
                    return a;
                };
            },
            3994: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(78171), { area: a } = r(61990), { centroid: o } = r(30035), { bbox: s } = r(25368), l = r(29527), c = r(48636), u = r(56174), h = r(35632), f = r(80899), p = Object.keys(i), d = {
                    "ISO-3": l,
                    "USA-states": l,
                    "country names": function(t1) {
                        for(var e1 = 0; e1 < p.length; e1++){
                            var r = p[e1];
                            if (new RegExp(i[r]).test(t1.trim().toLowerCase())) return r;
                        }
                        return c.log("Unrecognized country name: " + t1 + "."), !1;
                    }
                };
                function m(t1) {
                    var e1 = t1.geojson, r = window.PlotlyGeoAssets || {}, n = "string" == typeof e1 ? r[e1] : e1;
                    return u(n) ? n : (c.error("Oops ... something went wrong when fetching " + e1), !1);
                }
                t1.exports = {
                    locationToFeature: function(t1, e1, r) {
                        if (!e1 || "string" != typeof e1) return !1;
                        var n, i, a, o = d[t1](e1);
                        if (o) {
                            if ("USA-states" === t1) for(n = [], a = 0; a < r.length; a++)(i = r[a]).properties && i.properties.gu && "USA" === i.properties.gu && n.push(i);
                            else n = r;
                            for(a = 0; a < n.length; a++)if ((i = n[a]).id === o) return i;
                            c.log([
                                "Location with id",
                                o,
                                "does not have a matching topojson feature at this resolution."
                            ].join(" "));
                        }
                        return !1;
                    },
                    feature2polygons: function(t1) {
                        var e1, r, n, i, a = t1.geometry, o = a.coordinates, s = t1.id, l = [];
                        function c(t1) {
                            for(var e1 = 0; e1 < t1.length - 1; e1++)if (t1[e1][0] > 0 && t1[e1 + 1][0] < 0) return e1;
                            return null;
                        }
                        switch(e1 = "RUS" === s || "FJI" === s ? function(t1) {
                            var e1;
                            if (null === c(t1)) e1 = t1;
                            else for(e1 = new Array(t1.length), i = 0; i < t1.length; i++)e1[i] = [
                                t1[i][0] < 0 ? t1[i][0] + 360 : t1[i][0],
                                t1[i][1]
                            ];
                            l.push(f.tester(e1));
                        } : "ATA" === s ? function(t1) {
                            var e1 = c(t1);
                            if (null === e1) return l.push(f.tester(t1));
                            var r = new Array(t1.length + 1), n = 0;
                            for(i = 0; i < t1.length; i++)i > e1 ? r[n++] = [
                                t1[i][0] + 360,
                                t1[i][1]
                            ] : i === e1 ? (r[n++] = t1[i], r[n++] = [
                                t1[i][0],
                                -90
                            ]) : r[n++] = t1[i];
                            var a = f.tester(r);
                            a.pts.pop(), l.push(a);
                        } : function(t1) {
                            l.push(f.tester(t1));
                        }, a.type){
                            case "MultiPolygon":
                                for(r = 0; r < o.length; r++)for(n = 0; n < o[r].length; n++)e1(o[r][n]);
                                break;
                            case "Polygon":
                                for(r = 0; r < o.length; r++)e1(o[r]);
                        }
                        return l;
                    },
                    getTraceGeojson: m,
                    extractTraceFeature: function(t1) {
                        var e1 = t1[0].trace, r = m(e1);
                        if (!r) return !1;
                        var n, i = {}, s = [];
                        for(n = 0; n < e1._length; n++){
                            var l = t1[n];
                            (l.loc || 0 === l.loc) && (i[l.loc] = l);
                        }
                        function u(t1) {
                            var r = h(t1, e1.featureidkey || "id").get(), n = i[r];
                            if (n) {
                                var l = t1.geometry;
                                if ("Polygon" === l.type || "MultiPolygon" === l.type) {
                                    var u = {
                                        type: "Feature",
                                        id: r,
                                        geometry: l,
                                        properties: {}
                                    };
                                    u.geometry.coordinates.length > 0 ? u.properties.ct = function(t1) {
                                        var e1, r = t1.geometry;
                                        if ("MultiPolygon" === r.type) for(var n = r.coordinates, i = 0, s = 0; s < n.length; s++){
                                            var l = {
                                                type: "Polygon",
                                                coordinates: n[s]
                                            }, c = a(l);
                                            c > i && (i = c, e1 = l);
                                        }
                                        else e1 = r;
                                        return o(e1).geometry.coordinates;
                                    }(u) : u.properties.ct = [
                                        NaN,
                                        NaN
                                    ], n.fIn = t1, n.fOut = u, s.push(u);
                                } else c.log([
                                    "Location",
                                    n.loc,
                                    "does not have a valid GeoJSON geometry.",
                                    "Traces with locationmode *geojson-id* only support",
                                    "*Polygon* and *MultiPolygon* geometries."
                                ].join(" "));
                            }
                            delete i[r];
                        }
                        switch(r.type){
                            case "FeatureCollection":
                                var f = r.features;
                                for(n = 0; n < f.length; n++)u(f[n]);
                                break;
                            case "Feature":
                                u(r);
                                break;
                            default:
                                return c.warn([
                                    "Invalid GeoJSON type",
                                    (r.type || "none") + ".",
                                    "Traces with locationmode *geojson-id* only support",
                                    "*FeatureCollection* and *Feature* types."
                                ].join(" ")), !1;
                        }
                        for(var p in i)c.log([
                            "Location *" + p + "*",
                            "does not have a matching feature with id-key",
                            "*" + e1.featureidkey + "*."
                        ].join(" "));
                        return s;
                    },
                    fetchTraceGeoData: function(t1) {
                        var e1 = window.PlotlyGeoAssets || {}, r = [];
                        function i(t1) {
                            return new Promise(function(r, i) {
                                n.json(t1, function(n, a) {
                                    if (n) {
                                        delete e1[t1];
                                        var o = 404 === n.status ? 'GeoJSON at URL "' + t1 + '" does not exist.' : "Unexpected error while fetching from " + t1;
                                        return i(new Error(o));
                                    }
                                    return e1[t1] = a, r(a);
                                });
                            });
                        }
                        function a(t1) {
                            return new Promise(function(r, n) {
                                var i = 0, a = setInterval(function() {
                                    return e1[t1] && "pending" !== e1[t1] ? (clearInterval(a), r(e1[t1])) : i > 100 ? (clearInterval(a), n("Unexpected error while fetching from " + t1)) : void i++;
                                }, 50);
                            });
                        }
                        for(var o = 0; o < t1.length; o++){
                            var s = t1[o][0].trace.geojson;
                            "string" == typeof s && (e1[s] ? "pending" === e1[s] && r.push(a(s)) : (e1[s] = "pending", r.push(i(s))));
                        }
                        return r;
                    },
                    computeBbox: function(t1) {
                        return s(t1);
                    }
                };
            },
            39532: function(t1, e1, r) {
                "use strict";
                var n = r(63821).BADNUM;
                e1.calcTraceToLineCoords = function(t1) {
                    for(var e1 = t1[0].trace.connectgaps, r = [], i = [], a = 0; a < t1.length; a++){
                        var o = t1[a].lonlat;
                        o[0] !== n ? i.push(o) : !e1 && i.length > 0 && (r.push(i), i = []);
                    }
                    return i.length > 0 && r.push(i), r;
                }, e1.makeLine = function(t1) {
                    return 1 === t1.length ? {
                        type: "LineString",
                        coordinates: t1[0]
                    } : {
                        type: "MultiLineString",
                        coordinates: t1
                    };
                }, e1.makePolygon = function(t1) {
                    if (1 === t1.length) return {
                        type: "Polygon",
                        coordinates: t1
                    };
                    for(var e1 = new Array(t1.length), r = 0; r < t1.length; r++)e1[r] = [
                        t1[r]
                    ];
                    return {
                        type: "MultiPolygon",
                        coordinates: e1
                    };
                }, e1.makeBlank = function() {
                    return {
                        type: "Point",
                        coordinates: []
                    };
                };
            },
            3447: function(t1, e1, r) {
                "use strict";
                var n, i, a, o = r(98953).mod;
                function s(t1, e1, r, n, i, a, o, s) {
                    var l = r - t1, c = i - t1, u = o - i, h = n - e1, f = a - e1, p = s - a, d = l * p - u * h;
                    if (0 === d) return null;
                    var m = (c * p - u * f) / d, g = (c * h - l * f) / d;
                    return g < 0 || g > 1 || m < 0 || m > 1 ? null : {
                        x: t1 + l * m,
                        y: e1 + h * m
                    };
                }
                function l(t1, e1, r, n, i) {
                    var a = n * t1 + i * e1;
                    if (a < 0) return n * n + i * i;
                    if (a > r) {
                        var o = n - t1, s = i - e1;
                        return o * o + s * s;
                    }
                    var l = n * e1 - i * t1;
                    return l * l / r;
                }
                e1.segmentsIntersect = s, e1.segmentDistance = function(t1, e1, r, n, i, a, o, c) {
                    if (s(t1, e1, r, n, i, a, o, c)) return 0;
                    var u = r - t1, h = n - e1, f = o - i, p = c - a, d = u * u + h * h, m = f * f + p * p, g = Math.min(l(u, h, d, i - t1, a - e1), l(u, h, d, o - t1, c - e1), l(f, p, m, t1 - i, e1 - a), l(f, p, m, r - i, n - a));
                    return Math.sqrt(g);
                }, e1.getTextLocation = function(t1, e1, r, s) {
                    if (t1 === i && s === a || (n = {}, i = t1, a = s), n[r]) return n[r];
                    var l = t1.getPointAtLength(o(r - s / 2, e1)), c = t1.getPointAtLength(o(r + s / 2, e1)), u = Math.atan((c.y - l.y) / (c.x - l.x)), h = t1.getPointAtLength(o(r, e1)), f = {
                        x: (4 * h.x + l.x + c.x) / 6,
                        y: (4 * h.y + l.y + c.y) / 6,
                        theta: u
                    };
                    return n[r] = f, f;
                }, e1.clearLocationCache = function() {
                    i = null;
                }, e1.getVisibleSegment = function(t1, e1, r) {
                    var n, i, a = e1.left, o = e1.right, s = e1.top, l = e1.bottom, c = 0, u = t1.getTotalLength(), h = u;
                    function f(e1) {
                        var r = t1.getPointAtLength(e1);
                        0 === e1 ? n = r : e1 === u && (i = r);
                        var c = r.x < a ? a - r.x : r.x > o ? r.x - o : 0, h = r.y < s ? s - r.y : r.y > l ? r.y - l : 0;
                        return Math.sqrt(c * c + h * h);
                    }
                    for(var p = f(c); p;){
                        if ((c += p + r) > h) return;
                        p = f(c);
                    }
                    for(p = f(h); p;){
                        if (c > (h -= p + r)) return;
                        p = f(h);
                    }
                    return {
                        min: c,
                        max: h,
                        len: h - c,
                        total: u,
                        isClosed: 0 === c && h === u && Math.abs(n.x - i.x) < .1 && Math.abs(n.y - i.y) < .1
                    };
                }, e1.findPointOnPath = function(t1, e1, r, n) {
                    for(var i, a, o, s = (n = n || {}).pathLength || t1.getTotalLength(), l = n.tolerance || .001, c = n.iterationLimit || 30, u = t1.getPointAtLength(0)[r] > t1.getPointAtLength(s)[r] ? -1 : 1, h = 0, f = 0, p = s; h < c;){
                        if (i = (f + p) / 2, o = (a = t1.getPointAtLength(i))[r] - e1, Math.abs(o) < l) return a;
                        u * o > 0 ? p = i : f = i, h++;
                    }
                    return a;
                };
            },
            46998: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(65657), a = r(162), o = r(88856), s = r(10229).defaultLine, l = r(87800).isArrayOrTypedArray, c = a(s);
                function u(t1, e1) {
                    var r = t1;
                    return r[3] *= e1, r;
                }
                function h(t1) {
                    if (n(t1)) return c;
                    var e1 = a(t1);
                    return e1.length ? e1 : c;
                }
                function f(t1) {
                    return n(t1) ? t1 : 1;
                }
                t1.exports = {
                    formatColor: function(t1, e1, r) {
                        var n = t1.color;
                        n && n._inputArray && (n = n._inputArray);
                        var i, s, p, d, m, g = l(n), y = l(e1), v = o.extractOpts(t1), x = [];
                        if (i = void 0 !== v.colorscale ? o.makeColorScaleFuncFromTrace(t1) : h, s = g ? function(t1, e1) {
                            return void 0 === t1[e1] ? c : a(i(t1[e1]));
                        } : h, p = y ? function(t1, e1) {
                            return void 0 === t1[e1] ? 1 : f(t1[e1]);
                        } : f, g || y) for(var _ = 0; _ < r; _++)d = s(n, _), m = p(e1, _), x[_] = u(d, m);
                        else x = u(a(n), e1);
                        return x;
                    },
                    parseColorScale: function(t1) {
                        var e1 = o.extractOpts(t1), r = e1.colorscale;
                        return e1.reversescale && (r = o.flipScale(e1.colorscale)), r.map(function(t1) {
                            var e1 = t1[0], r = i(t1[1]).toRgb();
                            return {
                                index: e1,
                                rgb: [
                                    r.r,
                                    r.g,
                                    r.b,
                                    r.a
                                ]
                            };
                        });
                    }
                };
            },
            71293: function(t1, e1, r) {
                "use strict";
                var n = r(29527);
                function i(t1) {
                    return [
                        t1
                    ];
                }
                t1.exports = {
                    keyFun: function(t1) {
                        return t1.key;
                    },
                    repeat: i,
                    descend: n,
                    wrap: i,
                    unwrap: function(t1) {
                        return t1[0];
                    }
                };
            },
            29527: function(t1) {
                "use strict";
                t1.exports = function(t1) {
                    return t1;
                };
            },
            10688: function(t1) {
                "use strict";
                t1.exports = function(t1, e1) {
                    if (!e1) return t1;
                    var r = 1 / Math.abs(e1), n = r > 1 ? (r * t1 + r * e1) / r : t1 + e1, i = String(n).length;
                    if (i > 16) {
                        var a = String(e1).length;
                        if (i >= String(t1).length + a) {
                            var o = parseFloat(n).toPrecision(12);
                            -1 === o.indexOf("e+") && (n = +o);
                        }
                    }
                    return n;
                };
            },
            34809: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(42696).aL, a = r(36464).GP, o = r(10721), s = r(63821), l = s.FP_SAFE, c = -l, u = s.BADNUM, h = t1.exports = {};
                h.adjustFormat = function(t1) {
                    return !t1 || /^\d[.]\df/.test(t1) || /[.]\d%/.test(t1) ? t1 : "0.f" === t1 ? "~f" : /^\d%/.test(t1) ? "~%" : /^\ds/.test(t1) ? "~s" : !/^[~,.0$]/.test(t1) && /[&fps]/.test(t1) ? "~" + t1 : t1;
                };
                var f = {};
                h.warnBadFormat = function(t1) {
                    var e1 = String(t1);
                    f[e1] || (f[e1] = 1, h.warn('encountered bad format: "' + e1 + '"'));
                }, h.noFormat = function(t1) {
                    return String(t1);
                }, h.numberFormat = function(t1) {
                    var e1;
                    try {
                        e1 = a(h.adjustFormat(t1));
                    } catch (e1) {
                        return h.warnBadFormat(t1), h.noFormat;
                    }
                    return e1;
                }, h.nestedProperty = r(35632), h.keyedContainer = r(34967), h.relativeAttr = r(82047), h.isPlainObject = r(56174), h.toLogRange = r(8083), h.relinkPrivateKeys = r(80428);
                var p = r(87800);
                h.isArrayBuffer = p.isArrayBuffer, h.isTypedArray = p.isTypedArray, h.isArrayOrTypedArray = p.isArrayOrTypedArray, h.isArray1D = p.isArray1D, h.ensureArray = p.ensureArray, h.concat = p.concat, h.maxRowLength = p.maxRowLength, h.minRowLength = p.minRowLength;
                var d = r(98953);
                h.mod = d.mod, h.modHalf = d.modHalf;
                var m = r(34220);
                h.valObjectMeta = m.valObjectMeta, h.coerce = m.coerce, h.coerce2 = m.coerce2, h.coerceFont = m.coerceFont, h.coercePattern = m.coercePattern, h.coerceHoverinfo = m.coerceHoverinfo, h.coerceSelectionMarkerOpacity = m.coerceSelectionMarkerOpacity, h.validate = m.validate;
                var g = r(92596);
                h.dateTime2ms = g.dateTime2ms, h.isDateTime = g.isDateTime, h.ms2DateTime = g.ms2DateTime, h.ms2DateTimeLocal = g.ms2DateTimeLocal, h.cleanDate = g.cleanDate, h.isJSDate = g.isJSDate, h.formatDate = g.formatDate, h.incrementMonth = g.incrementMonth, h.dateTick0 = g.dateTick0, h.dfltRange = g.dfltRange, h.findExactDates = g.findExactDates, h.MIN_MS = g.MIN_MS, h.MAX_MS = g.MAX_MS;
                var y = r(98813);
                h.findBin = y.findBin, h.sorterAsc = y.sorterAsc, h.sorterDes = y.sorterDes, h.distinctVals = y.distinctVals, h.roundUp = y.roundUp, h.sort = y.sort, h.findIndexOfMin = y.findIndexOfMin, h.sortObjectKeys = r(62994);
                var v = r(89258);
                h.aggNums = v.aggNums, h.len = v.len, h.mean = v.mean, h.geometricMean = v.geometricMean, h.median = v.median, h.midRange = v.midRange, h.variance = v.variance, h.stdev = v.stdev, h.interp = v.interp;
                var x = r(15236);
                h.init2dArray = x.init2dArray, h.transposeRagged = x.transposeRagged, h.dot = x.dot, h.translationMatrix = x.translationMatrix, h.rotationMatrix = x.rotationMatrix, h.rotationXYMatrix = x.rotationXYMatrix, h.apply3DTransform = x.apply3DTransform, h.apply2DTransform = x.apply2DTransform, h.apply2DTransform2 = x.apply2DTransform2, h.convertCssMatrix = x.convertCssMatrix, h.inverseTransformMatrix = x.inverseTransformMatrix;
                var _ = r(44313);
                h.deg2rad = _.deg2rad, h.rad2deg = _.rad2deg, h.angleDelta = _.angleDelta, h.angleDist = _.angleDist, h.isFullCircle = _.isFullCircle, h.isAngleInsideSector = _.isAngleInsideSector, h.isPtInsideSector = _.isPtInsideSector, h.pathArc = _.pathArc, h.pathSector = _.pathSector, h.pathAnnulus = _.pathAnnulus;
                var b = r(32546);
                h.isLeftAnchor = b.isLeftAnchor, h.isCenterAnchor = b.isCenterAnchor, h.isRightAnchor = b.isRightAnchor, h.isTopAnchor = b.isTopAnchor, h.isMiddleAnchor = b.isMiddleAnchor, h.isBottomAnchor = b.isBottomAnchor;
                var w = r(3447);
                h.segmentsIntersect = w.segmentsIntersect, h.segmentDistance = w.segmentDistance, h.getTextLocation = w.getTextLocation, h.clearLocationCache = w.clearLocationCache, h.getVisibleSegment = w.getVisibleSegment, h.findPointOnPath = w.findPointOnPath;
                var T = r(93049);
                h.extendFlat = T.extendFlat, h.extendDeep = T.extendDeep, h.extendDeepAll = T.extendDeepAll, h.extendDeepNoArrays = T.extendDeepNoArrays;
                var k = r(48636);
                h.log = k.log, h.warn = k.warn, h.error = k.error;
                var A = r(90694);
                h.counterRegex = A.counter;
                var M = r(64025);
                h.throttle = M.throttle, h.throttleDone = M.done, h.clearThrottle = M.clear;
                var S = r(95425);
                function E(t1) {
                    var e1 = {};
                    for(var r in t1)for(var n = t1[r], i = 0; i < n.length; i++)e1[n[i]] = +r;
                    return e1;
                }
                h.getGraphDiv = S.getGraphDiv, h.isPlotDiv = S.isPlotDiv, h.removeElement = S.removeElement, h.addStyleRule = S.addStyleRule, h.addRelatedStyleRule = S.addRelatedStyleRule, h.deleteRelatedStyleRule = S.deleteRelatedStyleRule, h.getFullTransformMatrix = S.getFullTransformMatrix, h.getElementTransformMatrix = S.getElementTransformMatrix, h.getElementAndAncestors = S.getElementAndAncestors, h.equalDomRects = S.equalDomRects, h.clearResponsive = r(23493), h.preserveDrawingBuffer = r(32521), h.makeTraceGroups = r(75944), h._ = r(38514), h.notifier = r(87355), h.filterUnique = r(48965), h.filterVisible = r(78926), h.pushUnique = r(36539), h.increment = r(10688), h.cleanNumber = r(44498), h.ensureNumber = function(t1) {
                    return o(t1) ? (t1 = Number(t1)) > l || t1 < c ? u : t1 : u;
                }, h.isIndex = function(t1, e1) {
                    return !(void 0 !== e1 && t1 >= e1) && o(t1) && t1 >= 0 && t1 % 1 == 0;
                }, h.noop = r(4969), h.identity = r(29527), h.repeat = function(t1, e1) {
                    for(var r = new Array(e1), n = 0; n < e1; n++)r[n] = t1;
                    return r;
                }, h.swapAttrs = function(t1, e1, r, n) {
                    r || (r = "x"), n || (n = "y");
                    for(var i = 0; i < e1.length; i++){
                        var a = e1[i], o = h.nestedProperty(t1, a.replace("?", r)), s = h.nestedProperty(t1, a.replace("?", n)), l = o.get();
                        o.set(s.get()), s.set(l);
                    }
                }, h.raiseToTop = function(t1) {
                    t1.parentNode.appendChild(t1);
                }, h.cancelTransition = function(t1) {
                    return t1.transition().duration(0);
                }, h.constrain = function(t1, e1, r) {
                    return e1 > r ? Math.max(r, Math.min(e1, t1)) : Math.max(e1, Math.min(r, t1));
                }, h.bBoxIntersect = function(t1, e1, r) {
                    return r = r || 0, t1.left <= e1.right + r && e1.left <= t1.right + r && t1.top <= e1.bottom + r && e1.top <= t1.bottom + r;
                }, h.simpleMap = function(t1, e1, r, n, i) {
                    for(var a = t1.length, o = new Array(a), s = 0; s < a; s++)o[s] = e1(t1[s], r, n, i);
                    return o;
                }, h.randstr = function t1(e1, r, n, i) {
                    if (n || (n = 16), void 0 === r && (r = 24), r <= 0) return "0";
                    var a, o, s = Math.log(Math.pow(2, r)) / Math.log(n), l = "";
                    for(a = 2; s === 1 / 0; a *= 2)s = Math.log(Math.pow(2, r / a)) / Math.log(n) * a;
                    var c = s - Math.floor(s);
                    for(a = 0; a < Math.floor(s); a++)l = Math.floor(Math.random() * n).toString(n) + l;
                    c && (o = Math.pow(n, c), l = Math.floor(Math.random() * o).toString(n) + l);
                    var u = parseInt(l, n);
                    return e1 && e1[l] || u !== 1 / 0 && u >= Math.pow(2, r) ? i > 10 ? (h.warn("randstr failed uniqueness"), l) : t1(e1, r, n, (i || 0) + 1) : l;
                }, h.OptionControl = function(t1, e1) {
                    t1 || (t1 = {}), e1 || (e1 = "opt");
                    var r = {
                        optionList: [],
                        _newoption: function(n) {
                            n[e1] = t1, r[n.name] = n, r.optionList.push(n);
                        }
                    };
                    return r["_" + e1] = t1, r;
                }, h.smooth = function(t1, e1) {
                    if ((e1 = Math.round(e1) || 0) < 2) return t1;
                    var r, n, i, a, o = t1.length, s = 2 * o, l = 2 * e1 - 1, c = new Array(l), u = new Array(o);
                    for(r = 0; r < l; r++)c[r] = (1 - Math.cos(Math.PI * (r + 1) / e1)) / (2 * e1);
                    for(r = 0; r < o; r++){
                        for(a = 0, n = 0; n < l; n++)(i = r + n + 1 - e1) < -o ? i -= s * Math.round(i / s) : i >= s && (i -= s * Math.floor(i / s)), i < 0 ? i = -1 - i : i >= o && (i = s - 1 - i), a += t1[i] * c[n];
                        u[r] = a;
                    }
                    return u;
                }, h.syncOrAsync = function(t1, e1, r) {
                    var n;
                    function i() {
                        return h.syncOrAsync(t1, e1, r);
                    }
                    for(; t1.length;)if ((n = (0, t1.splice(0, 1)[0])(e1)) && n.then) return n.then(i);
                    return r && r(e1);
                }, h.stripTrailingSlash = function(t1) {
                    return "/" === t1.substr(-1) ? t1.substr(0, t1.length - 1) : t1;
                }, h.noneOrAll = function(t1, e1, r) {
                    if (t1) {
                        var n, i = !1, a = !0;
                        for(n = 0; n < r.length; n++)null != t1[r[n]] ? i = !0 : a = !1;
                        if (i && !a) for(n = 0; n < r.length; n++)t1[r[n]] = e1[r[n]];
                    }
                }, h.mergeArray = function(t1, e1, r, n) {
                    var i = "function" == typeof n;
                    if (h.isArrayOrTypedArray(t1)) for(var a = Math.min(t1.length, e1.length), o = 0; o < a; o++){
                        var s = t1[o];
                        e1[o][r] = i ? n(s) : s;
                    }
                }, h.mergeArrayCastPositive = function(t1, e1, r) {
                    return h.mergeArray(t1, e1, r, function(t1) {
                        var e1 = +t1;
                        return isFinite(e1) && e1 > 0 ? e1 : 0;
                    });
                }, h.fillArray = function(t1, e1, r, n) {
                    if (n = n || h.identity, h.isArrayOrTypedArray(t1)) for(var i = 0; i < e1.length; i++)e1[i][r] = n(t1[i]);
                }, h.castOption = function(t1, e1, r, n) {
                    n = n || h.identity;
                    var i = h.nestedProperty(t1, r).get();
                    return h.isArrayOrTypedArray(i) ? Array.isArray(e1) && h.isArrayOrTypedArray(i[e1[0]]) ? n(i[e1[0]][e1[1]]) : n(i[e1]) : i;
                }, h.extractOption = function(t1, e1, r, n) {
                    if (r in t1) return t1[r];
                    var i = h.nestedProperty(e1, n).get();
                    return Array.isArray(i) ? void 0 : i;
                }, h.tagSelected = function(t1, e1, r) {
                    var n, i, a = e1.selectedpoints, o = e1._indexToPoints;
                    o && (n = E(o));
                    for(var s = 0; s < a.length; s++){
                        var l = a[s];
                        if (h.isIndex(l) || h.isArrayOrTypedArray(l) && h.isIndex(l[0]) && h.isIndex(l[1])) {
                            var c = n ? n[l] : l, u = r ? r[c] : c;
                            void 0 !== (i = u) && i < t1.length && (t1[u].selected = 1);
                        }
                    }
                }, h.selIndices2selPoints = function(t1) {
                    var e1 = t1.selectedpoints, r = t1._indexToPoints;
                    if (r) {
                        for(var n = E(r), i = [], a = 0; a < e1.length; a++){
                            var o = e1[a];
                            if (h.isIndex(o)) {
                                var s = n[o];
                                h.isIndex(s) && i.push(s);
                            }
                        }
                        return i;
                    }
                    return e1;
                }, h.getTargetArray = function(t1, e1) {
                    var r = e1.target;
                    if ("string" == typeof r && r) {
                        var n = h.nestedProperty(t1, r).get();
                        return !!h.isArrayOrTypedArray(n) && n;
                    }
                    return !!h.isArrayOrTypedArray(r) && r;
                }, h.minExtend = function t1(e1, r, n) {
                    var i = {};
                    "object" != typeof r && (r = {});
                    var a, o, s, l = "pieLike" === n ? -1 : 3, c = Object.keys(e1);
                    for(a = 0; a < c.length; a++)s = e1[o = c[a]], "_" !== o.charAt(0) && "function" != typeof s && ("module" === o ? i[o] = s : Array.isArray(s) ? i[o] = "colorscale" === o || -1 === l ? s.slice() : s.slice(0, l) : h.isTypedArray(s) ? i[o] = -1 === l ? s.subarray() : s.subarray(0, l) : i[o] = s && "object" == typeof s ? t1(e1[o], r[o], n) : s);
                    for(c = Object.keys(r), a = 0; a < c.length; a++)"object" == typeof (s = r[o = c[a]]) && o in i && "object" == typeof i[o] || (i[o] = s);
                    return i;
                }, h.titleCase = function(t1) {
                    return t1.charAt(0).toUpperCase() + t1.substr(1);
                }, h.containsAny = function(t1, e1) {
                    for(var r = 0; r < e1.length; r++)if (-1 !== t1.indexOf(e1[r])) return !0;
                    return !1;
                }, h.isIE = function() {
                    return void 0 !== window.navigator.msSaveBlob;
                };
                var C = /Version\/[\d\.]+.*Safari/;
                h.isSafari = function() {
                    return C.test(window.navigator.userAgent);
                };
                var L = /iPad|iPhone|iPod/;
                h.isIOS = function() {
                    return L.test(window.navigator.userAgent);
                };
                var I = /Firefox\/(\d+)\.\d+/;
                h.getFirefoxVersion = function() {
                    var t1 = I.exec(window.navigator.userAgent);
                    if (t1 && 2 === t1.length) {
                        var e1 = parseInt(t1[1]);
                        if (!isNaN(e1)) return e1;
                    }
                    return null;
                }, h.isD3Selection = function(t1) {
                    return t1 instanceof n.selection;
                }, h.ensureSingle = function(t1, e1, r, n) {
                    var i = t1.select(e1 + (r ? "." + r : ""));
                    if (i.size()) return i;
                    var a = t1.append(e1);
                    return r && a.classed(r, !0), n && a.call(n), a;
                }, h.ensureSingleById = function(t1, e1, r, n) {
                    var i = t1.select(e1 + "#" + r);
                    if (i.size()) return i;
                    var a = t1.append(e1).attr("id", r);
                    return n && a.call(n), a;
                }, h.objectFromPath = function(t1, e1) {
                    for(var r, n = t1.split("."), i = r = {}, a = 0; a < n.length; a++){
                        var o = n[a], s = null, l = n[a].match(/(.*)\[([0-9]+)\]/);
                        l ? (o = l[1], s = l[2], r = r[o] = [], a === n.length - 1 ? r[s] = e1 : r[s] = {}, r = r[s]) : (a === n.length - 1 ? r[o] = e1 : r[o] = {}, r = r[o]);
                    }
                    return i;
                };
                var P = /^([^\[\.]+)\.(.+)?/, z = /^([^\.]+)\[([0-9]+)\](\.)?(.+)?/;
                function O(t1) {
                    return "__" === t1.slice(0, 2);
                }
                h.expandObjectPaths = function(t1) {
                    var e1, r, n, i, a, o, s;
                    if ("object" == typeof t1 && !Array.isArray(t1)) {
                        for(r in t1)if (t1.hasOwnProperty(r)) {
                            if (e1 = r.match(P)) {
                                if (i = t1[r], O(n = e1[1])) continue;
                                delete t1[r], t1[n] = h.extendDeepNoArrays(t1[n] || {}, h.objectFromPath(r, h.expandObjectPaths(i))[n]);
                            } else if (e1 = r.match(z)) {
                                if (i = t1[r], O(n = e1[1])) continue;
                                if (a = parseInt(e1[2]), delete t1[r], t1[n] = t1[n] || [], "." === e1[3]) s = e1[4], o = t1[n][a] = t1[n][a] || {}, h.extendDeepNoArrays(o, h.objectFromPath(s, h.expandObjectPaths(i)));
                                else {
                                    if (O(n)) continue;
                                    t1[n][a] = h.expandObjectPaths(i);
                                }
                            } else {
                                if (O(r)) continue;
                                t1[r] = h.expandObjectPaths(t1[r]);
                            }
                        }
                    }
                    return t1;
                }, h.numSeparate = function(t1, e1, r) {
                    if (r || (r = !1), "string" != typeof e1 || 0 === e1.length) throw new Error("Separator string required for formatting!");
                    "number" == typeof t1 && (t1 = String(t1));
                    var n = /(\d+)(\d{3})/, i = e1.charAt(0), a = e1.charAt(1), o = t1.split("."), s = o[0], l = o.length > 1 ? i + o[1] : "";
                    if (a && (o.length > 1 || s.length > 4 || r)) for(; n.test(s);)s = s.replace(n, "$1" + a + "$2");
                    return s + l;
                }, h.TEMPLATE_STRING_REGEX = /%{([^\s%{}:]*)([:|\|][^}]*)?}/g;
                var D = /^\w*$/;
                h.templateString = function(t1, e1) {
                    var r = {};
                    return t1.replace(h.TEMPLATE_STRING_REGEX, function(t1, n) {
                        var i;
                        return D.test(n) ? i = e1[n] : (r[n] = r[n] || h.nestedProperty(e1, n).get, i = r[n]()), h.isValidTextValue(i) ? i : "";
                    });
                };
                var R = {
                    max: 10,
                    count: 0,
                    name: "hovertemplate"
                };
                h.hovertemplateString = function() {
                    return U.apply(R, arguments);
                };
                var F = {
                    max: 10,
                    count: 0,
                    name: "texttemplate"
                };
                h.texttemplateString = function() {
                    return U.apply(F, arguments);
                };
                var B = /^(\S+)([\*\/])(-?\d+(\.\d+)?)$/, N = {
                    max: 10,
                    count: 0,
                    name: "texttemplate",
                    parseMultDiv: !0
                };
                h.texttemplateStringForShapes = function() {
                    return U.apply(N, arguments);
                };
                var j = /^[:|\|]/;
                function U(t1, e1, r) {
                    var n = this, a = arguments;
                    e1 || (e1 = {});
                    var o = {};
                    return t1.replace(h.TEMPLATE_STRING_REGEX, function(t1, s, l) {
                        var c = "_xother" === s || "_yother" === s, u = "_xother_" === s || "_yother_" === s, f = "xother_" === s || "yother_" === s, p = "xother" === s || "yother" === s || c || f || u, d = s;
                        (c || u) && (d = d.substring(1)), (f || u) && (d = d.substring(0, d.length - 1));
                        var m, g, y, v = null, x = null;
                        if (n.parseMultDiv) {
                            var _ = function(t1) {
                                var e1 = t1.match(B);
                                return e1 ? {
                                    key: e1[1],
                                    op: e1[2],
                                    number: Number(e1[3])
                                } : {
                                    key: t1,
                                    op: null,
                                    number: null
                                };
                            }(d);
                            d = _.key, v = _.op, x = _.number;
                        }
                        if (p) {
                            if (void 0 === (m = e1[d])) return "";
                        } else for(y = 3; y < a.length; y++)if (g = a[y]) {
                            if (g.hasOwnProperty(d)) {
                                m = g[d];
                                break;
                            }
                            if (D.test(d) || (m = h.nestedProperty(g, d).get(), (m = o[d] || h.nestedProperty(g, d).get()) && (o[d] = m)), void 0 !== m) break;
                        }
                        if (void 0 !== m && ("*" === v && (m *= x), "/" === v && (m /= x)), void 0 === m && n) return n.count < n.max && (h.warn("Variable '" + d + "' in " + n.name + " could not be found!"), m = t1), n.count === n.max && h.warn("Too many " + n.name + " warnings - additional warnings will be suppressed"), n.count++, t1;
                        if (l) {
                            var b;
                            if (":" === l[0] && (b = r ? r.numberFormat : h.numberFormat, "" !== m && (m = b(l.replace(j, ""))(m))), "|" === l[0]) {
                                b = r ? r.timeFormat : i;
                                var w = h.dateTime2ms(m);
                                m = h.formatDate(w, l.replace(j, ""), !1, b);
                            }
                        } else {
                            var T = d + "Label";
                            e1.hasOwnProperty(T) && (m = e1[T]);
                        }
                        return p && (m = "(" + m + ")", (c || u) && (m = " " + m), (f || u) && (m += " ")), m;
                    });
                }
                h.subplotSort = function(t1, e1) {
                    for(var r = Math.min(t1.length, e1.length) + 1, n = 0, i = 0, a = 0; a < r; a++){
                        var o = t1.charCodeAt(a) || 0, s = e1.charCodeAt(a) || 0, l = o >= 48 && o <= 57, c = s >= 48 && s <= 57;
                        if (l && (n = 10 * n + o - 48), c && (i = 10 * i + s - 48), !l || !c) {
                            if (n !== i) return n - i;
                            if (o !== s) return o - s;
                        }
                    }
                    return i - n;
                };
                var V = 2e9;
                h.seedPseudoRandom = function() {
                    V = 2e9;
                }, h.pseudoRandom = function() {
                    var t1 = V;
                    return V = (69069 * V + 1) % 4294967296, Math.abs(V - t1) < 429496729 ? h.pseudoRandom() : V / 4294967296;
                }, h.fillText = function(t1, e1, r) {
                    var n = Array.isArray(r) ? function(t1) {
                        r.push(t1);
                    } : function(t1) {
                        r.text = t1;
                    }, i = h.extractOption(t1, e1, "htx", "hovertext");
                    if (h.isValidTextValue(i)) return n(i);
                    var a = h.extractOption(t1, e1, "tx", "text");
                    return h.isValidTextValue(a) ? n(a) : void 0;
                }, h.isValidTextValue = function(t1) {
                    return t1 || 0 === t1;
                }, h.formatPercent = function(t1, e1) {
                    e1 = e1 || 0;
                    for(var r = (Math.round(100 * t1 * Math.pow(10, e1)) * Math.pow(.1, e1)).toFixed(e1) + "%", n = 0; n < e1; n++)-1 !== r.indexOf(".") && (r = (r = r.replace("0%", "%")).replace(".%", "%"));
                    return r;
                }, h.isHidden = function(t1) {
                    var e1 = window.getComputedStyle(t1).display;
                    return !e1 || "none" === e1;
                }, h.strTranslate = function(t1, e1) {
                    return t1 || e1 ? "translate(" + t1 + "," + e1 + ")" : "";
                }, h.strRotate = function(t1) {
                    return t1 ? "rotate(" + t1 + ")" : "";
                }, h.strScale = function(t1) {
                    return 1 !== t1 ? "scale(" + t1 + ")" : "";
                }, h.getTextTransform = function(t1) {
                    var e1 = t1.noCenter, r = t1.textX, n = t1.textY, i = t1.targetX, a = t1.targetY, o = t1.anchorX || 0, s = t1.anchorY || 0, l = t1.rotate, c = t1.scale;
                    return c ? c > 1 && (c = 1) : c = 0, h.strTranslate(i - c * (r + o), a - c * (n + s)) + h.strScale(c) + (l ? "rotate(" + l + (e1 ? "" : " " + r + " " + n) + ")" : "");
                }, h.setTransormAndDisplay = function(t1, e1) {
                    t1.attr("transform", h.getTextTransform(e1)), t1.style("display", e1.scale ? null : "none");
                }, h.ensureUniformFontSize = function(t1, e1) {
                    var r = h.extendFlat({}, e1);
                    return r.size = Math.max(e1.size, t1._fullLayout.uniformtext.minsize || 0), r;
                }, h.join2 = function(t1, e1, r) {
                    var n = t1.length;
                    return n > 1 ? t1.slice(0, -1).join(e1) + r + t1[n - 1] : t1.join(e1);
                }, h.bigFont = function(t1) {
                    return Math.round(1.2 * t1);
                };
                var q = h.getFirefoxVersion(), H = null !== q && q < 86;
                h.getPositionFromD3Event = function() {
                    return H ? [
                        n.event.layerX,
                        n.event.layerY
                    ] : [
                        n.event.offsetX,
                        n.event.offsetY
                    ];
                };
            },
            56174: function(t1) {
                "use strict";
                t1.exports = function(t1) {
                    return window && window.process && window.process.versions ? "[object Object]" === Object.prototype.toString.call(t1) : "[object Object]" === Object.prototype.toString.call(t1) && Object.getPrototypeOf(t1).hasOwnProperty("hasOwnProperty");
                };
            },
            34967: function(t1, e1, r) {
                "use strict";
                var n = r(35632), i = /^\w*$/;
                t1.exports = function(t1, e1, r, a) {
                    var o, s, l;
                    r = r || "name", a = a || "value";
                    var c = {};
                    e1 && e1.length ? (l = n(t1, e1), s = l.get()) : s = t1, e1 = e1 || "";
                    var u = {};
                    if (s) for(o = 0; o < s.length; o++)u[s[o][r]] = o;
                    var h = i.test(a), f = {
                        set: function(t1, e1) {
                            var i = null === e1 ? 4 : 0;
                            if (!s) {
                                if (!l || 4 === i) return;
                                s = [], l.set(s);
                            }
                            var o = u[t1];
                            if (void 0 === o) {
                                if (4 === i) return;
                                i |= 3, o = s.length, u[t1] = o;
                            } else e1 !== (h ? s[o][a] : n(s[o], a).get()) && (i |= 2);
                            var p = s[o] = s[o] || {};
                            return p[r] = t1, h ? p[a] = e1 : n(p, a).set(e1), null !== e1 && (i &= -5), c[o] = c[o] | i, f;
                        },
                        get: function(t1) {
                            if (s) {
                                var e1 = u[t1];
                                return void 0 === e1 ? void 0 : h ? s[e1][a] : n(s[e1], a).get();
                            }
                        },
                        rename: function(t1, e1) {
                            var n = u[t1];
                            return void 0 === n || (c[n] = 1 | c[n], u[e1] = n, delete u[t1], s[n][r] = e1), f;
                        },
                        remove: function(t1) {
                            var e1 = u[t1];
                            if (void 0 === e1) return f;
                            var i = s[e1];
                            if (Object.keys(i).length > 2) return c[e1] = 2 | c[e1], f.set(t1, null);
                            if (h) {
                                for(o = e1; o < s.length; o++)c[o] = 3 | c[o];
                                for(o = e1; o < s.length; o++)u[s[o][r]]--;
                                s.splice(e1, 1), delete u[t1];
                            } else n(i, a).set(null), c[e1] = 6 | c[e1];
                            return f;
                        },
                        constructUpdate: function() {
                            for(var t1, i, o = {}, l = Object.keys(c), u = 0; u < l.length; u++)i = l[u], t1 = e1 + "[" + i + "]", s[i] ? (1 & c[i] && (o[t1 + "." + r] = s[i][r]), 2 & c[i] && (o[t1 + "." + a] = h ? 4 & c[i] ? null : s[i][a] : 4 & c[i] ? null : n(s[i], a).get())) : o[t1] = null;
                            return o;
                        }
                    };
                    return f;
                };
            },
            38514: function(t1, e1, r) {
                "use strict";
                var n = r(33626);
                t1.exports = function(t1, e1) {
                    for(var r = t1._context.locale, i = 0; i < 2; i++){
                        for(var a = t1._context.locales, o = 0; o < 2; o++){
                            var s = (a[r] || {}).dictionary;
                            if (s) {
                                var l = s[e1];
                                if (l) return l;
                            }
                            a = n.localeRegistry;
                        }
                        var c = r.split("-")[0];
                        if (c === r) break;
                        r = c;
                    }
                    return e1;
                };
            },
            48636: function(t1, e1, r) {
                "use strict";
                var n = r(24452).dfltConfig, i = r(87355), a = t1.exports = {};
                a.log = function() {
                    var t1;
                    if (n.logging > 1) {
                        var e1 = [
                            "LOG:"
                        ];
                        for(t1 = 0; t1 < arguments.length; t1++)e1.push(arguments[t1]);
                        console.trace.apply(console, e1);
                    }
                    if (n.notifyOnLogging > 1) {
                        var r = [];
                        for(t1 = 0; t1 < arguments.length; t1++)r.push(arguments[t1]);
                        i(r.join("<br>"), "long");
                    }
                }, a.warn = function() {
                    var t1;
                    if (n.logging > 0) {
                        var e1 = [
                            "WARN:"
                        ];
                        for(t1 = 0; t1 < arguments.length; t1++)e1.push(arguments[t1]);
                        console.trace.apply(console, e1);
                    }
                    if (n.notifyOnLogging > 0) {
                        var r = [];
                        for(t1 = 0; t1 < arguments.length; t1++)r.push(arguments[t1]);
                        i(r.join("<br>"), "stick");
                    }
                }, a.error = function() {
                    var t1;
                    if (n.logging > 0) {
                        var e1 = [
                            "ERROR:"
                        ];
                        for(t1 = 0; t1 < arguments.length; t1++)e1.push(arguments[t1]);
                        console.error.apply(console, e1);
                    }
                    if (n.notifyOnLogging > 0) {
                        var r = [];
                        for(t1 = 0; t1 < arguments.length; t1++)r.push(arguments[t1]);
                        i(r.join("<br>"), "stick");
                    }
                };
            },
            75944: function(t1, e1, r) {
                "use strict";
                var n = r(45568);
                t1.exports = function(t1, e1, r) {
                    var i = t1.selectAll("g." + r.replace(/\s/g, ".")).data(e1, function(t1) {
                        return t1[0].trace.uid;
                    });
                    i.exit().remove(), i.enter().append("g").attr("class", r), i.order();
                    var a = t1.classed("rangeplot") ? "nodeRangePlot3" : "node3";
                    return i.each(function(t1) {
                        t1[0][a] = n.select(this);
                    }), i;
                };
            },
            15236: function(t1, e1, r) {
                "use strict";
                var n = r(11191);
                e1.init2dArray = function(t1, e1) {
                    for(var r = new Array(t1), n = 0; n < t1; n++)r[n] = new Array(e1);
                    return r;
                }, e1.transposeRagged = function(t1) {
                    var e1, r, n = 0, i = t1.length;
                    for(e1 = 0; e1 < i; e1++)n = Math.max(n, t1[e1].length);
                    var a = new Array(n);
                    for(e1 = 0; e1 < n; e1++)for(a[e1] = new Array(i), r = 0; r < i; r++)a[e1][r] = t1[r][e1];
                    return a;
                }, e1.dot = function(t1, r) {
                    if (!t1.length || !r.length || t1.length !== r.length) return null;
                    var n, i, a = t1.length;
                    if (t1[0].length) for(n = new Array(a), i = 0; i < a; i++)n[i] = e1.dot(t1[i], r);
                    else if (r[0].length) {
                        var o = e1.transposeRagged(r);
                        for(n = new Array(o.length), i = 0; i < o.length; i++)n[i] = e1.dot(t1, o[i]);
                    } else for(n = 0, i = 0; i < a; i++)n += t1[i] * r[i];
                    return n;
                }, e1.translationMatrix = function(t1, e1) {
                    return [
                        [
                            1,
                            0,
                            t1
                        ],
                        [
                            0,
                            1,
                            e1
                        ],
                        [
                            0,
                            0,
                            1
                        ]
                    ];
                }, e1.rotationMatrix = function(t1) {
                    var e1 = t1 * Math.PI / 180;
                    return [
                        [
                            Math.cos(e1),
                            -Math.sin(e1),
                            0
                        ],
                        [
                            Math.sin(e1),
                            Math.cos(e1),
                            0
                        ],
                        [
                            0,
                            0,
                            1
                        ]
                    ];
                }, e1.rotationXYMatrix = function(t1, r, n) {
                    return e1.dot(e1.dot(e1.translationMatrix(r, n), e1.rotationMatrix(t1)), e1.translationMatrix(-r, -n));
                }, e1.apply3DTransform = function(t1) {
                    return function() {
                        var r = arguments, n = 1 === arguments.length ? r[0] : [
                            r[0],
                            r[1],
                            r[2] || 0
                        ];
                        return e1.dot(t1, [
                            n[0],
                            n[1],
                            n[2],
                            1
                        ]).slice(0, 3);
                    };
                }, e1.apply2DTransform = function(t1) {
                    return function() {
                        var r = arguments;
                        3 === r.length && (r = r[0]);
                        var n = 1 === arguments.length ? r[0] : [
                            r[0],
                            r[1]
                        ];
                        return e1.dot(t1, [
                            n[0],
                            n[1],
                            1
                        ]).slice(0, 2);
                    };
                }, e1.apply2DTransform2 = function(t1) {
                    var r = e1.apply2DTransform(t1);
                    return function(t1) {
                        return r(t1.slice(0, 2)).concat(r(t1.slice(2, 4)));
                    };
                }, e1.convertCssMatrix = function(t1) {
                    if (t1) {
                        var e1 = t1.length;
                        if (16 === e1) return t1;
                        if (6 === e1) return [
                            t1[0],
                            t1[1],
                            0,
                            0,
                            t1[2],
                            t1[3],
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            t1[4],
                            t1[5],
                            0,
                            1
                        ];
                    }
                    return [
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1
                    ];
                }, e1.inverseTransformMatrix = function(t1) {
                    var e1 = [];
                    return n.invert(e1, t1), [
                        [
                            e1[0],
                            e1[1],
                            e1[2],
                            e1[3]
                        ],
                        [
                            e1[4],
                            e1[5],
                            e1[6],
                            e1[7]
                        ],
                        [
                            e1[8],
                            e1[9],
                            e1[10],
                            e1[11]
                        ],
                        [
                            e1[12],
                            e1[13],
                            e1[14],
                            e1[15]
                        ]
                    ];
                };
            },
            98953: function(t1) {
                "use strict";
                t1.exports = {
                    mod: function(t1, e1) {
                        var r = t1 % e1;
                        return r < 0 ? r + e1 : r;
                    },
                    modHalf: function(t1, e1) {
                        return Math.abs(t1) > e1 / 2 ? t1 - Math.round(t1 / e1) * e1 : t1;
                    }
                };
            },
            35632: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(87800).isArrayOrTypedArray;
                function a(t1, e1) {
                    return function() {
                        var r, n, o, s, l, c = t1;
                        for(s = 0; s < e1.length - 1; s++){
                            if (-1 === (r = e1[s])) {
                                for(n = !0, o = [], l = 0; l < c.length; l++)o[l] = a(c[l], e1.slice(s + 1))(), o[l] !== o[0] && (n = !1);
                                return n ? o[0] : o;
                            }
                            if ("number" == typeof r && !i(c)) return;
                            if ("object" != typeof (c = c[r]) || null === c) return;
                        }
                        if ("object" == typeof c && null !== c && null !== (o = c[e1[s]])) return o;
                    };
                }
                t1.exports = function(t1, e1) {
                    if (n(e1)) e1 = String(e1);
                    else if ("string" != typeof e1 || "[-1]" === e1.substr(e1.length - 4)) throw "bad property string";
                    var r, i, o, s, c = e1.split(".");
                    for(s = 0; s < c.length; s++)if ("__" === String(c[s]).slice(0, 2)) throw "bad property string";
                    for(s = 0; s < c.length;){
                        if (r = String(c[s]).match(/^([^\[\]]*)((\[\-?[0-9]*\])+)$/)) {
                            if (r[1]) c[s] = r[1];
                            else {
                                if (0 !== s) throw "bad property string";
                                c.splice(0, 1);
                            }
                            for(i = r[2].substr(1, r[2].length - 2).split("]["), o = 0; o < i.length; o++)s++, c.splice(s, 0, Number(i[o]));
                        }
                        s++;
                    }
                    return "object" != typeof t1 ? function(t1, e1, r) {
                        return {
                            set: function() {
                                throw "bad container";
                            },
                            get: function() {},
                            astr: e1,
                            parts: r,
                            obj: t1
                        };
                    }(t1, e1, c) : {
                        set: l(t1, c, e1),
                        get: a(t1, c),
                        astr: e1,
                        parts: c,
                        obj: t1
                    };
                };
                var o = /(^|\.)args\[/;
                function s(t1, e1) {
                    return void 0 === t1 || null === t1 && !e1.match(o);
                }
                function l(t1, e1, r) {
                    return function(n) {
                        var a, o, l = t1, f = "", p = [
                            [
                                t1,
                                f
                            ]
                        ], d = s(n, r);
                        for(o = 0; o < e1.length - 1; o++){
                            if ("number" == typeof (a = e1[o]) && !i(l)) throw "array index but container is not an array";
                            if (-1 === a) {
                                if (d = !u(l, e1.slice(o + 1), n, r)) break;
                                return;
                            }
                            if (!h(l, a, e1[o + 1], d)) break;
                            if ("object" != typeof (l = l[a]) || null === l) throw "container is not an object";
                            f = c(f, a), p.push([
                                l,
                                f
                            ]);
                        }
                        if (d) {
                            if (o === e1.length - 1 && (delete l[e1[o]], Array.isArray(l) && +e1[o] == l.length - 1)) for(; l.length && void 0 === l[l.length - 1];)l.pop();
                        } else l[e1[o]] = n;
                    };
                }
                function c(t1, e1) {
                    var r = e1;
                    return n(e1) ? r = "[" + e1 + "]" : t1 && (r = "." + e1), t1 + r;
                }
                function u(t1, e1, r, n) {
                    var a, o = i(r), c = !0, u = r, f = n.replace("-1", 0), p = !o && s(r, f), d = e1[0];
                    for(a = 0; a < t1.length; a++)f = n.replace("-1", a), o && (p = s(u = r[a % r.length], f)), p && (c = !1), h(t1, a, d, p) && l(t1[a], e1, n.replace("-1", a))(u);
                    return c;
                }
                function h(t1, e1, r, n) {
                    if (void 0 === t1[e1]) {
                        if (n) return !1;
                        t1[e1] = "number" == typeof r ? [] : {};
                    }
                    return !0;
                }
            },
            4969: function(t1) {
                "use strict";
                t1.exports = function() {};
            },
            87355: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(10721), a = [];
                t1.exports = function(t1, e1) {
                    if (-1 === a.indexOf(t1)) {
                        a.push(t1);
                        var r = 1e3;
                        i(e1) ? r = e1 : "long" === e1 && (r = 3e3);
                        var o = n.select("body").selectAll(".plotly-notifier").data([
                            0
                        ]);
                        o.enter().append("div").classed("plotly-notifier", !0), o.selectAll(".notifier-note").data(a).enter().append("div").classed("notifier-note", !0).style("opacity", 0).each(function(t1) {
                            var i = n.select(this);
                            i.append("button").classed("notifier-close", !0).html("&times;").on("click", function() {
                                i.transition().call(s);
                            });
                            for(var a = i.append("p"), o = t1.split(/<br\s*\/?>/g), l = 0; l < o.length; l++)l && a.append("br"), a.append("span").text(o[l]);
                            "stick" === e1 ? i.transition().duration(350).style("opacity", 1) : i.transition().duration(700).style("opacity", 1).transition().delay(r).call(s);
                        });
                    }
                    function s(t1) {
                        t1.duration(700).style("opacity", 0).each("end", function(t1) {
                            var e1 = a.indexOf(t1);
                            -1 !== e1 && a.splice(e1, 1), n.select(this).remove();
                        });
                    }
                };
            },
            93134: function(t1, e1, r) {
                "use strict";
                var n = r(27983), i = "data-savedcursor";
                t1.exports = function(t1, e1) {
                    var r = t1.attr(i);
                    if (e1) {
                        if (!r) {
                            for(var a = (t1.attr("class") || "").split(" "), o = 0; o < a.length; o++){
                                var s = a[o];
                                0 === s.indexOf("cursor-") && t1.attr(i, s.substr(7)).classed(s, !1);
                            }
                            t1.attr(i) || t1.attr(i, "!!");
                        }
                        n(t1, e1);
                    } else r && (t1.attr(i, null), "!!" === r ? n(t1) : n(t1, r));
                };
            },
            80899: function(t1, e1, r) {
                "use strict";
                var n = r(15236).dot, i = r(63821).BADNUM, a = t1.exports = {};
                a.tester = function(t1) {
                    var e1, r = t1.slice(), n = r[0][0], a = n, o = r[0][1], s = o;
                    for(r[r.length - 1][0] === r[0][0] && r[r.length - 1][1] === r[0][1] || r.push(r[0]), e1 = 1; e1 < r.length; e1++)n = Math.min(n, r[e1][0]), a = Math.max(a, r[e1][0]), o = Math.min(o, r[e1][1]), s = Math.max(s, r[e1][1]);
                    var l, c = !1;
                    5 === r.length && (r[0][0] === r[1][0] ? r[2][0] === r[3][0] && r[0][1] === r[3][1] && r[1][1] === r[2][1] && (c = !0, l = function(t1) {
                        return t1[0] === r[0][0];
                    }) : r[0][1] === r[1][1] && r[2][1] === r[3][1] && r[0][0] === r[3][0] && r[1][0] === r[2][0] && (c = !0, l = function(t1) {
                        return t1[1] === r[0][1];
                    }));
                    var u = !0, h = r[0];
                    for(e1 = 1; e1 < r.length; e1++)if (h[0] !== r[e1][0] || h[1] !== r[e1][1]) {
                        u = !1;
                        break;
                    }
                    return {
                        xmin: n,
                        xmax: a,
                        ymin: o,
                        ymax: s,
                        pts: r,
                        contains: c ? function(t1, e1) {
                            var r = t1[0], c = t1[1];
                            return !(r === i || r < n || r > a || c === i || c < o || c > s || e1 && l(t1));
                        } : function(t1, e1) {
                            var l = t1[0], c = t1[1];
                            if (l === i || l < n || l > a || c === i || c < o || c > s) return !1;
                            var u, h, f, p, d, m = r.length, g = r[0][0], y = r[0][1], v = 0;
                            for(u = 1; u < m; u++)if (h = g, f = y, g = r[u][0], y = r[u][1], !(l < (p = Math.min(h, g)) || l > Math.max(h, g) || c > Math.max(f, y))) {
                                if (c < Math.min(f, y)) l !== p && v++;
                                else {
                                    if (c === (d = g === h ? c : f + (l - h) * (y - f) / (g - h))) return 1 !== u || !e1;
                                    c <= d && l !== p && v++;
                                }
                            }
                            return v % 2 == 1;
                        },
                        isRect: c,
                        degenerate: u
                    };
                }, a.isSegmentBent = function(t1, e1, r, i) {
                    var a, o, s, l = t1[e1], c = [
                        t1[r][0] - l[0],
                        t1[r][1] - l[1]
                    ], u = n(c, c), h = Math.sqrt(u), f = [
                        -c[1] / h,
                        c[0] / h
                    ];
                    for(a = e1 + 1; a < r; a++)if (o = [
                        t1[a][0] - l[0],
                        t1[a][1] - l[1]
                    ], (s = n(o, c)) < 0 || s > u || Math.abs(n(o, f)) > i) return !0;
                    return !1;
                }, a.filter = function(t1, e1) {
                    var r = [
                        t1[0]
                    ], n = 0, i = 0;
                    function o(o) {
                        t1.push(o);
                        var s = r.length, l = n;
                        r.splice(i + 1);
                        for(var c = l + 1; c < t1.length; c++)(c === t1.length - 1 || a.isSegmentBent(t1, l, c + 1, e1)) && (r.push(t1[c]), r.length < s - 2 && (n = c, i = r.length - 1), l = c);
                    }
                    return t1.length > 1 && o(t1.pop()), {
                        addPt: o,
                        raw: t1,
                        filtered: r
                    };
                };
            },
            22459: function(t1, e1, r) {
                "use strict";
                var n = r(97464), i = r(81330);
                t1.exports = function(t1, e1, a) {
                    var o = t1._fullLayout, s = !0;
                    return o._glcanvas.each(function(n) {
                        if (n.regl) n.regl.preloadCachedCode(a);
                        else if (!n.pick || o._has("parcoords")) {
                            try {
                                n.regl = i({
                                    canvas: this,
                                    attributes: {
                                        antialias: !n.pick,
                                        preserveDrawingBuffer: !0
                                    },
                                    pixelRatio: t1._context.plotGlPixelRatio || r.g.devicePixelRatio,
                                    extensions: e1 || [],
                                    cachedCode: a || {}
                                });
                            } catch (t1) {
                                s = !1;
                            }
                            n.regl || (s = !1), s && this.addEventListener("webglcontextlost", function(e1) {
                                t1 && t1.emit && t1.emit("plotly_webglcontextlost", {
                                    event: e1,
                                    layer: n.key
                                });
                            }, !1);
                        }
                    }), s || n({
                        container: o._glcontainer.node()
                    }), s;
                };
            },
            32521: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(13087);
                t1.exports = function(t1) {
                    var e1;
                    if ("string" != typeof (e1 = t1 && t1.hasOwnProperty("userAgent") ? t1.userAgent : function() {
                        var t1;
                        return "undefined" != typeof navigator && (t1 = navigator.userAgent), t1 && t1.headers && "string" == typeof t1.headers["user-agent"] && (t1 = t1.headers["user-agent"]), t1;
                    }())) return !0;
                    var r = i({
                        ua: {
                            headers: {
                                "user-agent": e1
                            }
                        },
                        tablet: !0,
                        featureDetect: !1
                    });
                    if (!r) {
                        for(var a = e1.split(" "), o = 1; o < a.length; o++)if (-1 !== a[o].indexOf("Safari")) for(var s = o - 1; s > -1; s--){
                            var l = a[s];
                            if ("Version/" === l.substr(0, 8)) {
                                var c = l.substr(8).split(".")[0];
                                if (n(c) && (c = +c), c >= 13) return !0;
                            }
                        }
                    }
                    return r;
                };
            },
            36539: function(t1) {
                "use strict";
                t1.exports = function(t1, e1) {
                    if (e1 instanceof RegExp) {
                        for(var r = e1.toString(), n = 0; n < t1.length; n++)if (t1[n] instanceof RegExp && t1[n].toString() === r) return t1;
                        t1.push(e1);
                    } else !e1 && 0 !== e1 || -1 !== t1.indexOf(e1) || t1.push(e1);
                    return t1;
                };
            },
            40486: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(24452).dfltConfig, a = {
                    add: function(t1, e1, r, n, a) {
                        var o, s;
                        t1.undoQueue = t1.undoQueue || {
                            index: 0,
                            queue: [],
                            sequence: !1
                        }, s = t1.undoQueue.index, t1.autoplay ? t1.undoQueue.inSequence || (t1.autoplay = !1) : (!t1.undoQueue.sequence || t1.undoQueue.beginSequence ? (o = {
                            undo: {
                                calls: [],
                                args: []
                            },
                            redo: {
                                calls: [],
                                args: []
                            }
                        }, t1.undoQueue.queue.splice(s, t1.undoQueue.queue.length - s, o), t1.undoQueue.index += 1) : o = t1.undoQueue.queue[s - 1], t1.undoQueue.beginSequence = !1, o && (o.undo.calls.unshift(e1), o.undo.args.unshift(r), o.redo.calls.push(n), o.redo.args.push(a)), t1.undoQueue.queue.length > i.queueLength && (t1.undoQueue.queue.shift(), t1.undoQueue.index--));
                    },
                    startSequence: function(t1) {
                        t1.undoQueue = t1.undoQueue || {
                            index: 0,
                            queue: [],
                            sequence: !1
                        }, t1.undoQueue.sequence = !0, t1.undoQueue.beginSequence = !0;
                    },
                    stopSequence: function(t1) {
                        t1.undoQueue = t1.undoQueue || {
                            index: 0,
                            queue: [],
                            sequence: !1
                        }, t1.undoQueue.sequence = !1, t1.undoQueue.beginSequence = !1;
                    },
                    undo: function(t1) {
                        var e1, r;
                        if (!(void 0 === t1.undoQueue || isNaN(t1.undoQueue.index) || t1.undoQueue.index <= 0)) {
                            for(t1.undoQueue.index--, e1 = t1.undoQueue.queue[t1.undoQueue.index], t1.undoQueue.inSequence = !0, r = 0; r < e1.undo.calls.length; r++)a.plotDo(t1, e1.undo.calls[r], e1.undo.args[r]);
                            t1.undoQueue.inSequence = !1, t1.autoplay = !1;
                        }
                    },
                    redo: function(t1) {
                        var e1, r;
                        if (!(void 0 === t1.undoQueue || isNaN(t1.undoQueue.index) || t1.undoQueue.index >= t1.undoQueue.queue.length)) {
                            for(e1 = t1.undoQueue.queue[t1.undoQueue.index], t1.undoQueue.inSequence = !0, r = 0; r < e1.redo.calls.length; r++)a.plotDo(t1, e1.redo.calls[r], e1.redo.args[r]);
                            t1.undoQueue.inSequence = !1, t1.autoplay = !1, t1.undoQueue.index++;
                        }
                    },
                    plotDo: function(t1, e1, r) {
                        t1.autoplay = !0, r = function(t1, e1) {
                            for(var r, i = [], a = 0; a < e1.length; a++)r = e1[a], i[a] = r === t1 ? r : "object" == typeof r ? Array.isArray(r) ? n.extendDeep([], r) : n.extendDeepAll({}, r) : r;
                            return i;
                        }(t1, r), e1.apply(null, r);
                    }
                };
                t1.exports = a;
            },
            90694: function(t1, e1) {
                "use strict";
                e1.counter = function(t1, e1, r, n) {
                    var i = (e1 || "") + (r ? "" : "$"), a = !1 === n ? "" : "^";
                    return "xy" === t1 ? new RegExp(a + "x([2-9]|[1-9][0-9]+)?y([2-9]|[1-9][0-9]+)?" + i) : new RegExp(a + t1 + "([2-9]|[1-9][0-9]+)?" + i);
                };
            },
            82047: function(t1) {
                "use strict";
                var e1 = /^(.*)(\.[^\.\[\]]+|\[\d\])$/, r = /^[^\.\[\]]+$/;
                t1.exports = function(t1, n) {
                    for(; n;){
                        var i = t1.match(e1);
                        if (i) t1 = i[1];
                        else {
                            if (!t1.match(r)) throw new Error("bad relativeAttr call:" + [
                                t1,
                                n
                            ]);
                            t1 = "";
                        }
                        if ("^" !== n.charAt(0)) break;
                        n = n.slice(1);
                    }
                    return t1 && "[" !== n.charAt(0) ? t1 + "." + n : t1 + n;
                };
            },
            80428: function(t1, e1, r) {
                "use strict";
                var n = r(87800).isArrayOrTypedArray, i = r(56174);
                t1.exports = function t1(e1, r) {
                    for(var a in r){
                        var o = r[a], s = e1[a];
                        if (s !== o) {
                            if ("_" === a.charAt(0) || "function" == typeof o) {
                                if (a in e1) continue;
                                e1[a] = o;
                            } else if (n(o) && n(s) && i(o[0])) {
                                if ("customdata" === a || "ids" === a) continue;
                                for(var l = Math.min(o.length, s.length), c = 0; c < l; c++)s[c] !== o[c] && i(o[c]) && i(s[c]) && t1(s[c], o[c]);
                            } else i(o) && i(s) && (t1(s, o), Object.keys(s).length || delete e1[a]);
                        }
                    }
                };
            },
            98813: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(48636), a = r(29527), o = r(63821).BADNUM, s = 1e-9;
                function l(t1, e1) {
                    return t1 < e1;
                }
                function c(t1, e1) {
                    return t1 <= e1;
                }
                function u(t1, e1) {
                    return t1 > e1;
                }
                function h(t1, e1) {
                    return t1 >= e1;
                }
                e1.findBin = function(t1, e1, r) {
                    if (n(e1.start)) return r ? Math.ceil((t1 - e1.start) / e1.size - s) - 1 : Math.floor((t1 - e1.start) / e1.size + s);
                    var a, o, f = 0, p = e1.length, d = 0, m = p > 1 ? (e1[p - 1] - e1[0]) / (p - 1) : 1;
                    for(o = m >= 0 ? r ? l : c : r ? h : u, t1 += m * s * (r ? -1 : 1) * (m >= 0 ? 1 : -1); f < p && d++ < 100;)o(e1[a = Math.floor((f + p) / 2)], t1) ? f = a + 1 : p = a;
                    return d > 90 && i.log("Long binary search..."), f - 1;
                }, e1.sorterAsc = function(t1, e1) {
                    return t1 - e1;
                }, e1.sorterDes = function(t1, e1) {
                    return e1 - t1;
                }, e1.distinctVals = function(t1) {
                    var r, n = t1.slice();
                    for(n.sort(e1.sorterAsc), r = n.length - 1; r > -1 && n[r] === o; r--);
                    for(var i, a = n[r] - n[0] || 1, s = a / (r || 1) / 1e4, l = [], c = 0; c <= r; c++){
                        var u = n[c], h = u - i;
                        void 0 === i ? (l.push(u), i = u) : h > s && (a = Math.min(a, h), l.push(u), i = u);
                    }
                    return {
                        vals: l,
                        minDiff: a
                    };
                }, e1.roundUp = function(t1, e1, r) {
                    for(var n, i = 0, a = e1.length - 1, o = 0, s = r ? 0 : 1, l = r ? 1 : 0, c = r ? Math.ceil : Math.floor; i < a && o++ < 100;)e1[n = c((i + a) / 2)] <= t1 ? i = n + s : a = n - l;
                    return e1[i];
                }, e1.sort = function(t1, e1) {
                    for(var r = 0, n = 0, i = 1; i < t1.length; i++){
                        var a = e1(t1[i], t1[i - 1]);
                        if (a < 0 ? r = 1 : a > 0 && (n = 1), r && n) return t1.sort(e1);
                    }
                    return n ? t1 : t1.reverse();
                }, e1.findIndexOfMin = function(t1, e1) {
                    e1 = e1 || a;
                    for(var r, n = 1 / 0, i = 0; i < t1.length; i++){
                        var o = e1(t1[i]);
                        o < n && (n = o, r = i);
                    }
                    return r;
                };
            },
            27983: function(t1) {
                "use strict";
                t1.exports = function(t1, e1) {
                    (t1.attr("class") || "").split(" ").forEach(function(e1) {
                        0 === e1.indexOf("cursor-") && t1.classed(e1, !1);
                    }), e1 && t1.classed("cursor-" + e1, !0);
                };
            },
            97464: function(t1, e1, r) {
                "use strict";
                var n = r(78766), i = function() {};
                t1.exports = function(t1) {
                    for(var e1 in t1)"function" == typeof t1[e1] && (t1[e1] = i);
                    t1.destroy = function() {
                        t1.container.parentNode.removeChild(t1.container);
                    };
                    var r = document.createElement("div");
                    r.className = "no-webgl", r.style.cursor = "pointer", r.style.fontSize = "24px", r.style.color = n.defaults[0], r.style.position = "absolute", r.style.left = r.style.top = "0px", r.style.width = r.style.height = "100%", r.style["background-color"] = n.lightLine, r.style["z-index"] = 30;
                    var a = document.createElement("p");
                    return a.textContent = "WebGL is not supported by your browser - visit https://get.webgl.org for more info", a.style.position = "relative", a.style.top = "50%", a.style.left = "50%", a.style.height = "30%", a.style.width = "50%", a.style.margin = "-15% 0 0 -25%", r.appendChild(a), t1.container.appendChild(r), t1.container.style.background = "#FFFFFF", t1.container.onclick = function() {
                        window.open("https://get.webgl.org");
                    }, !1;
                };
            },
            62994: function(t1) {
                "use strict";
                t1.exports = function(t1) {
                    return Object.keys(t1).sort();
                };
            },
            89258: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(87800).isArrayOrTypedArray;
                e1.aggNums = function(t1, r, a, o) {
                    var s, l;
                    if ((!o || o > a.length) && (o = a.length), n(r) || (r = !1), i(a[0])) {
                        for(l = new Array(o), s = 0; s < o; s++)l[s] = e1.aggNums(t1, r, a[s]);
                        a = l;
                    }
                    for(s = 0; s < o; s++)n(r) ? n(a[s]) && (r = t1(+r, +a[s])) : r = a[s];
                    return r;
                }, e1.len = function(t1) {
                    return e1.aggNums(function(t1) {
                        return t1 + 1;
                    }, 0, t1);
                }, e1.mean = function(t1, r) {
                    return r || (r = e1.len(t1)), e1.aggNums(function(t1, e1) {
                        return t1 + e1;
                    }, 0, t1) / r;
                }, e1.geometricMean = function(t1, r) {
                    return r || (r = e1.len(t1)), Math.pow(e1.aggNums(function(t1, e1) {
                        return t1 * e1;
                    }, 1, t1), 1 / r);
                }, e1.midRange = function(t1) {
                    if (void 0 !== t1 && 0 !== t1.length) return (e1.aggNums(Math.max, null, t1) + e1.aggNums(Math.min, null, t1)) / 2;
                }, e1.variance = function(t1, r, i) {
                    return r || (r = e1.len(t1)), n(i) || (i = e1.mean(t1, r)), e1.aggNums(function(t1, e1) {
                        return t1 + Math.pow(e1 - i, 2);
                    }, 0, t1) / r;
                }, e1.stdev = function(t1, r, n) {
                    return Math.sqrt(e1.variance(t1, r, n));
                }, e1.median = function(t1) {
                    var r = t1.slice().sort();
                    return e1.interp(r, .5);
                }, e1.interp = function(t1, e1) {
                    if (!n(e1)) throw "n should be a finite number";
                    if ((e1 = e1 * t1.length - .5) < 0) return t1[0];
                    if (e1 > t1.length - 1) return t1[t1.length - 1];
                    var r = e1 % 1;
                    return r * t1[Math.ceil(e1)] + (1 - r) * t1[Math.floor(e1)];
                };
            },
            55010: function(t1, e1, r) {
                "use strict";
                var n = r(162);
                t1.exports = function(t1) {
                    return t1 ? n(t1) : [
                        0,
                        0,
                        0,
                        1
                    ];
                };
            },
            95544: function(t1, e1, r) {
                "use strict";
                var n = r(1837), i = r(62203), a = r(34809), o = null;
                t1.exports = function() {
                    if (null !== o) return o;
                    o = !1;
                    var t1 = a.isIE() || a.isSafari() || a.isIOS();
                    if (window.navigator.userAgent && !t1) {
                        var e1 = Array.from(n.CSS_DECLARATIONS).reverse(), r = window.CSS && window.CSS.supports || window.supportsCSS;
                        if ("function" == typeof r) o = e1.some(function(t1) {
                            return r.apply(null, t1);
                        });
                        else {
                            var s = i.tester.append("image").attr("style", n.STYLE), l = window.getComputedStyle(s.node()).imageRendering;
                            o = e1.some(function(t1) {
                                var e1 = t1[1];
                                return l === e1 || l === e1.toLowerCase();
                            }), s.remove();
                        }
                    }
                    return o;
                };
            },
            30635: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(34809), a = i.strTranslate, o = r(62972), s = r(4530).LINE_SPACING, l = /([^$]*)([$]+[^$]*[$]+)([^$]*)/;
                e1.convertToTspans = function(t1, r, g) {
                    var S = t1.text(), E = !t1.attr("data-notex") && r && r._context.typesetMath && "undefined" != typeof MathJax && S.match(l), I = n.select(t1.node().parentNode);
                    if (!I.empty()) {
                        var P = t1.attr("class") ? t1.attr("class").split(" ")[0] : "text";
                        return P += "-math", I.selectAll("svg." + P).remove(), I.selectAll("g." + P + "-group").remove(), t1.style("display", null).attr({
                            "data-unformatted": S,
                            "data-math": "N"
                        }), E ? (r && r._promises || []).push(new Promise(function(e1) {
                            t1.style("display", "none");
                            var r = parseInt(t1.node().style.fontSize, 10), o = {
                                fontSize: r
                            };
                            !function(t1, e1, r) {
                                var a, o, s, l, f = parseInt((MathJax.version || "").split(".")[0]);
                                if (2 === f || 3 === f) {
                                    var p = function() {
                                        var r = "math-output-" + i.randstr({}, 64), a = (l = n.select("body").append("div").attr({
                                            id: r
                                        }).style({
                                            visibility: "hidden",
                                            position: "absolute",
                                            "font-size": e1.fontSize + "px"
                                        }).text(t1.replace(c, "\\lt ").replace(u, "\\gt "))).node();
                                        return 2 === f ? MathJax.Hub.Typeset(a) : MathJax.typeset([
                                            a
                                        ]);
                                    }, d = function() {
                                        var e1 = l.select(2 === f ? ".MathJax_SVG" : ".MathJax"), a = !e1.empty() && l.select("svg").node();
                                        if (a) {
                                            var o, s = a.getBoundingClientRect();
                                            o = 2 === f ? n.select("body").select("#MathJax_SVG_glyphs") : e1.select("defs"), r(e1, o, s);
                                        } else i.log("There was an error in the tex syntax.", t1), r();
                                        l.remove();
                                    };
                                    2 === f ? MathJax.Hub.Queue(function() {
                                        return o = i.extendDeepAll({}, MathJax.Hub.config), s = MathJax.Hub.processSectionDelay, void 0 !== MathJax.Hub.processSectionDelay && (MathJax.Hub.processSectionDelay = 0), MathJax.Hub.Config({
                                            messageStyle: "none",
                                            tex2jax: {
                                                inlineMath: h
                                            },
                                            displayAlign: "left"
                                        });
                                    }, function() {
                                        if ("SVG" !== (a = MathJax.Hub.config.menuSettings.renderer)) return MathJax.Hub.setRenderer("SVG");
                                    }, p, d, function() {
                                        if ("SVG" !== a) return MathJax.Hub.setRenderer(a);
                                    }, function() {
                                        return void 0 !== s && (MathJax.Hub.processSectionDelay = s), MathJax.Hub.Config(o);
                                    }) : 3 === f && (o = i.extendDeepAll({}, MathJax.config), MathJax.config.tex || (MathJax.config.tex = {}), MathJax.config.tex.inlineMath = h, "svg" !== (a = MathJax.config.startup.output) && (MathJax.config.startup.output = "svg"), MathJax.startup.defaultReady(), MathJax.startup.promise.then(function() {
                                        p(), d(), "svg" !== a && (MathJax.config.startup.output = a), MathJax.config = o;
                                    }));
                                } else i.warn("No MathJax version:", MathJax.version);
                            }(E[2], o, function(n, i, o) {
                                I.selectAll("svg." + P).remove(), I.selectAll("g." + P + "-group").remove();
                                var s = n && n.select("svg");
                                if (!s || !s.node()) return z(), void e1();
                                var l = I.append("g").classed(P + "-group", !0).attr({
                                    "pointer-events": "none",
                                    "data-unformatted": S,
                                    "data-math": "Y"
                                });
                                l.node().appendChild(s.node()), i && i.node() && s.node().insertBefore(i.node().cloneNode(!0), s.node().firstChild);
                                var c = o.width, u = o.height;
                                s.attr({
                                    class: P,
                                    height: u,
                                    preserveAspectRatio: "xMinYMin meet"
                                }).style({
                                    overflow: "visible",
                                    "pointer-events": "none"
                                });
                                var h = t1.node().style.fill || "black", f = s.select("g");
                                f.attr({
                                    fill: h,
                                    stroke: h
                                });
                                var p = f.node().getBoundingClientRect(), d = p.width, m = p.height;
                                (d > c || m > u) && (s.style("overflow", "hidden"), d = (p = s.node().getBoundingClientRect()).width, m = p.height);
                                var y = +t1.attr("x"), v = +t1.attr("y"), x = -(r || t1.node().getBoundingClientRect().height) / 4;
                                if ("y" === P[0]) l.attr({
                                    transform: "rotate(" + [
                                        -90,
                                        y,
                                        v
                                    ] + ")" + a(-d / 2, x - m / 2)
                                });
                                else if ("l" === P[0]) v = x - m / 2;
                                else if ("a" === P[0] && 0 !== P.indexOf("atitle")) y = 0, v = x;
                                else {
                                    var _ = t1.attr("text-anchor");
                                    y -= d * ("middle" === _ ? .5 : "end" === _ ? 1 : 0), v = v + x - m / 2;
                                }
                                s.attr({
                                    x: y,
                                    y: v
                                }), g && g.call(t1, l), e1(l);
                            });
                        })) : z(), t1;
                    }
                    function z() {
                        I.empty() || (P = t1.attr("class") + "-math", I.select("svg." + P).remove()), t1.text("").style("white-space", "pre");
                        var r = function(t1, e1) {
                            e1 = e1.replace(y, " ");
                            var r, a = !1, l = [], c = -1;
                            function u() {
                                c++;
                                var e1 = document.createElementNS(o.svg, "tspan");
                                n.select(e1).attr({
                                    class: "line",
                                    dy: c * s + "em"
                                }), t1.appendChild(e1), r = e1;
                                var i = l;
                                if (l = [
                                    {
                                        node: e1
                                    }
                                ], i.length > 1) for(var a = 1; a < i.length; a++)h(i[a]);
                            }
                            function h(t1) {
                                var e1, i = t1.type, a = {};
                                if ("a" === i) {
                                    e1 = "a";
                                    var s = t1.target, c = t1.href, u = t1.popup;
                                    c && (a = {
                                        "xlink:xlink:show": "_blank" === s || "_" !== s.charAt(0) ? "new" : "replace",
                                        target: s,
                                        "xlink:xlink:href": c
                                    }, u && (a.onclick = 'window.open(this.href.baseVal,this.target.baseVal,"' + u + '");return false;'));
                                } else e1 = "tspan";
                                t1.style && (a.style = t1.style);
                                var h = document.createElementNS(o.svg, e1);
                                if ("sup" === i || "sub" === i) {
                                    g(r, m), r.appendChild(h);
                                    var f = document.createElementNS(o.svg, "tspan");
                                    g(f, m), n.select(f).attr("dy", d[i]), a.dy = p[i], r.appendChild(h), r.appendChild(f);
                                } else r.appendChild(h);
                                n.select(h).attr(a), r = t1.node = h, l.push(t1);
                            }
                            function g(t1, e1) {
                                t1.appendChild(document.createTextNode(e1));
                            }
                            function S(t1) {
                                if (1 !== l.length) {
                                    var n = l.pop();
                                    t1 !== n.type && i.log("Start tag <" + n.type + "> doesnt match end tag <" + t1 + ">. Pretending it did match.", e1), r = l[l.length - 1].node;
                                } else i.log("Ignoring unexpected end tag </" + t1 + ">.", e1);
                            }
                            _.test(e1) ? u() : (r = t1, l = [
                                {
                                    node: t1
                                }
                            ]);
                            for(var E = e1.split(v), I = 0; I < E.length; I++){
                                var P = E[I], z = P.match(x), O = z && z[2].toLowerCase(), D = f[O];
                                if ("br" === O) u();
                                else if (void 0 === D) g(r, C(P));
                                else if (z[1]) S(O);
                                else {
                                    var R = z[4], F = {
                                        type: O
                                    }, B = A(R, b);
                                    if (B ? (B = B.replace(M, "$1 fill:"), D && (B += ";" + D)) : D && (B = D), B && (F.style = B), "a" === O) {
                                        a = !0;
                                        var N = A(R, w);
                                        if (N) {
                                            var j = L(N);
                                            j && (F.href = j, F.target = A(R, T) || "_blank", F.popup = A(R, k));
                                        }
                                    }
                                    h(F);
                                }
                            }
                            return a;
                        }(t1.node(), S);
                        r && t1.style("pointer-events", "all"), e1.positionText(t1), g && g.call(t1);
                    }
                };
                var c = /(<|&lt;|&#60;)/g, u = /(>|&gt;|&#62;)/g, h = [
                    [
                        "$",
                        "$"
                    ],
                    [
                        "\\(",
                        "\\)"
                    ]
                ], f = {
                    sup: "font-size:70%",
                    sub: "font-size:70%",
                    s: "text-decoration:line-through",
                    u: "text-decoration:underline",
                    b: "font-weight:bold",
                    i: "font-style:italic",
                    a: "cursor:pointer",
                    span: "",
                    em: "font-style:italic;font-weight:bold"
                }, p = {
                    sub: "0.3em",
                    sup: "-0.6em"
                }, d = {
                    sub: "-0.21em",
                    sup: "0.42em"
                }, m = "\u200B", g = [
                    "http:",
                    "https:",
                    "mailto:",
                    "",
                    void 0,
                    ":"
                ], y = e1.NEWLINES = /(\r\n?|\n)/g, v = /(<[^<>]*>)/, x = /<(\/?)([^ >]*)(\s+(.*))?>/i, _ = /<br(\s+.*)?>/i;
                e1.BR_TAG_ALL = /<br(\s+.*)?>/gi;
                var b = /(^|[\s"'])style\s*=\s*("([^"]*);?"|'([^']*);?')/i, w = /(^|[\s"'])href\s*=\s*("([^"]*)"|'([^']*)')/i, T = /(^|[\s"'])target\s*=\s*("([^"\s]*)"|'([^'\s]*)')/i, k = /(^|[\s"'])popup\s*=\s*("([\w=,]*)"|'([\w=,]*)')/i;
                function A(t1, e1) {
                    if (!t1) return null;
                    var r = t1.match(e1), n = r && (r[3] || r[4]);
                    return n && C(n);
                }
                var M = /(^|;)\s*color:/;
                e1.plainText = function(t1, e1) {
                    for(var r = void 0 !== (e1 = e1 || {}).len && -1 !== e1.len ? e1.len : 1 / 0, n = void 0 !== e1.allowedTags ? e1.allowedTags : [
                        "br"
                    ], i = t1.split(v), a = [], o = "", s = 0, l = 0; l < i.length; l++){
                        var c = i[l], u = c.match(x), h = u && u[2].toLowerCase();
                        if (h) -1 !== n.indexOf(h) && (a.push(c), o = h);
                        else {
                            var f = c.length;
                            if (s + f < r) a.push(c), s += f;
                            else if (s < r) {
                                var p = r - s;
                                o && ("br" !== o || p <= 3 || f <= 3) && a.pop(), r > 3 ? a.push(c.substr(0, p - 3) + "...") : a.push(c.substr(0, p));
                                break;
                            }
                            o = "";
                        }
                    }
                    return a.join("");
                };
                var S = {
                    mu: "\u03BC",
                    amp: "&",
                    lt: "<",
                    gt: ">",
                    nbsp: "\xa0",
                    times: "\xd7",
                    plusmn: "\xb1",
                    deg: "\xb0"
                }, E = /&(#\d+|#x[\da-fA-F]+|[a-z]+);/g;
                function C(t1) {
                    return t1.replace(E, function(t1, e1) {
                        return ("#" === e1.charAt(0) ? function(t1) {
                            if (!(t1 > 1114111)) {
                                var e1 = String.fromCodePoint;
                                if (e1) return e1(t1);
                                var r = String.fromCharCode;
                                return t1 <= 65535 ? r(t1) : r(55232 + (t1 >> 10), t1 % 1024 + 56320);
                            }
                        }("x" === e1.charAt(1) ? parseInt(e1.substr(2), 16) : parseInt(e1.substr(1), 10)) : S[e1]) || t1;
                    });
                }
                function L(t1) {
                    var e1 = encodeURI(decodeURI(t1)), r = document.createElement("a"), n = document.createElement("a");
                    r.href = t1, n.href = e1;
                    var i = r.protocol, a = n.protocol;
                    return -1 !== g.indexOf(i) && -1 !== g.indexOf(a) ? e1 : "";
                }
                function I(t1, e1, r) {
                    var n, a, o, s = r.horizontalAlign, l = r.verticalAlign || "top", c = t1.node().getBoundingClientRect(), u = e1.node().getBoundingClientRect();
                    return a = "bottom" === l ? function() {
                        return c.bottom - n.height;
                    } : "middle" === l ? function() {
                        return c.top + (c.height - n.height) / 2;
                    } : function() {
                        return c.top;
                    }, o = "right" === s ? function() {
                        return c.right - n.width;
                    } : "center" === s ? function() {
                        return c.left + (c.width - n.width) / 2;
                    } : function() {
                        return c.left;
                    }, function() {
                        n = this.node().getBoundingClientRect();
                        var t1 = o() - u.left, e1 = a() - u.top, s = r.gd || {};
                        if (r.gd) {
                            s._fullLayout._calcInverseTransform(s);
                            var l = i.apply3DTransform(s._fullLayout._invTransform)(t1, e1);
                            t1 = l[0], e1 = l[1];
                        }
                        return this.style({
                            top: e1 + "px",
                            left: t1 + "px",
                            "z-index": 1e3
                        }), this;
                    };
                }
                e1.convertEntities = C, e1.sanitizeHTML = function(t1) {
                    t1 = t1.replace(y, " ");
                    for(var e1 = document.createElement("p"), r = e1, i = [], a = t1.split(v), o = 0; o < a.length; o++){
                        var s = a[o], l = s.match(x), c = l && l[2].toLowerCase();
                        if (c in f) {
                            if (l[1]) i.length && (r = i.pop());
                            else {
                                var u = l[4], h = A(u, b), p = h ? {
                                    style: h
                                } : {};
                                if ("a" === c) {
                                    var d = A(u, w);
                                    if (d) {
                                        var m = L(d);
                                        if (m) {
                                            p.href = m;
                                            var g = A(u, T);
                                            g && (p.target = g);
                                        }
                                    }
                                }
                                var _ = document.createElement(c);
                                r.appendChild(_), n.select(_).attr(p), r = _, i.push(_);
                            }
                        } else r.appendChild(document.createTextNode(C(s)));
                    }
                    return e1.innerHTML;
                }, e1.lineCount = function(t1) {
                    return t1.selectAll("tspan.line").size() || 1;
                }, e1.positionText = function(t1, e1, r) {
                    return t1.each(function() {
                        var t1 = n.select(this);
                        function i(e1, r) {
                            return void 0 === r ? null === (r = t1.attr(e1)) && (t1.attr(e1, 0), r = 0) : t1.attr(e1, r), r;
                        }
                        var a = i("x", e1), o = i("y", r);
                        "text" === this.nodeName && t1.selectAll("tspan.line").attr({
                            x: a,
                            y: o
                        });
                    });
                };
                var P = "1px ";
                e1.makeTextShadow = function(t1) {
                    return P + P + P + t1 + ", -" + P + "-" + P + P + t1 + ", " + P + "-" + P + P + t1 + ", -" + P + P + P + t1;
                }, e1.makeEditable = function(t1, e1) {
                    var r = e1.gd, i = e1.delegate, a = n.dispatch("edit", "input", "cancel"), o = i || t1;
                    if (t1.style({
                        "pointer-events": i ? "none" : "all"
                    }), 1 !== t1.size()) throw new Error("boo");
                    function s() {
                        var i, s, c, u, h;
                        i = n.select(r).select(".svg-container"), s = i.append("div"), c = t1.node().style, u = parseFloat(c.fontSize || 12), void 0 === (h = e1.text) && (h = t1.attr("data-unformatted")), s.classed("plugin-editable editable", !0).style({
                            position: "absolute",
                            "font-family": c.fontFamily || "Arial",
                            "font-size": u,
                            color: e1.fill || c.fill || "black",
                            opacity: 1,
                            "background-color": e1.background || "transparent",
                            outline: "#ffffff33 1px solid",
                            margin: [
                                -u / 8 + 1,
                                0,
                                0,
                                -1
                            ].join("px ") + "px",
                            padding: "0",
                            "box-sizing": "border-box"
                        }).attr({
                            contenteditable: !0
                        }).text(h).call(I(t1, i, e1)).on("blur", function() {
                            r._editing = !1, t1.text(this.textContent).style({
                                opacity: 1
                            });
                            var e1, i = n.select(this).attr("class");
                            (e1 = i ? "." + i.split(" ")[0] + "-math-group" : "[class*=-math-group]") && n.select(t1.node().parentNode).select(e1).style({
                                opacity: 0
                            });
                            var o = this.textContent;
                            n.select(this).transition().duration(0).remove(), n.select(document).on("mouseup", null), a.edit.call(t1, o);
                        }).on("focus", function() {
                            var t1 = this;
                            r._editing = !0, n.select(document).on("mouseup", function() {
                                if (n.event.target === t1) return !1;
                                document.activeElement === s.node() && s.node().blur();
                            });
                        }).on("keyup", function() {
                            27 === n.event.which ? (r._editing = !1, t1.style({
                                opacity: 1
                            }), n.select(this).style({
                                opacity: 0
                            }).on("blur", function() {
                                return !1;
                            }).transition().remove(), a.cancel.call(t1, this.textContent)) : (a.input.call(t1, this.textContent), n.select(this).call(I(t1, i, e1)));
                        }).on("keydown", function() {
                            13 === n.event.which && this.blur();
                        }).call(l), t1.style({
                            opacity: 0
                        });
                        var f, p = o.attr("class");
                        (f = p ? "." + p.split(" ")[0] + "-math-group" : "[class*=-math-group]") && n.select(t1.node().parentNode).select(f).style({
                            opacity: 0
                        });
                    }
                    function l(t1) {
                        var e1 = t1.node(), r = document.createRange();
                        r.selectNodeContents(e1);
                        var n = window.getSelection();
                        n.removeAllRanges(), n.addRange(r), e1.focus();
                    }
                    return e1.immediate ? s() : o.on("click", s), n.rebind(t1, a, "on");
                };
            },
            64025: function(t1, e1) {
                "use strict";
                var r = {};
                function n(t1) {
                    t1 && null !== t1.timer && (clearTimeout(t1.timer), t1.timer = null);
                }
                e1.throttle = function(t1, e1, i) {
                    var a = r[t1], o = Date.now();
                    if (!a) {
                        for(var s in r)r[s].ts < o - 6e4 && delete r[s];
                        a = r[t1] = {
                            ts: 0,
                            timer: null
                        };
                    }
                    function l() {
                        i(), a.ts = Date.now(), a.onDone && (a.onDone(), a.onDone = null);
                    }
                    n(a), o > a.ts + e1 ? l() : a.timer = setTimeout(function() {
                        l(), a.timer = null;
                    }, e1);
                }, e1.done = function(t1) {
                    var e1 = r[t1];
                    return e1 && e1.timer ? new Promise(function(t1) {
                        var r = e1.onDone;
                        e1.onDone = function() {
                            r && r(), t1(), e1.onDone = null;
                        };
                    }) : Promise.resolve();
                }, e1.clear = function(t1) {
                    if (t1) n(r[t1]), delete r[t1];
                    else for(var i in r)e1.clear(i);
                };
            },
            8083: function(t1, e1, r) {
                "use strict";
                var n = r(10721);
                t1.exports = function(t1, e1) {
                    if (t1 > 0) return Math.log(t1) / Math.LN10;
                    var r = Math.log(Math.min(e1[0], e1[1])) / Math.LN10;
                    return n(r) || (r = Math.log(Math.max(e1[0], e1[1])) / Math.LN10 - 6), r;
                };
            },
            11577: function(t1, e1, r) {
                "use strict";
                var n = t1.exports = {}, i = r(74285).locationmodeToLayer, a = r(48640).N4;
                n.getTopojsonName = function(t1) {
                    return [
                        t1.scope.replace(/ /g, "-"),
                        "_",
                        t1.resolution.toString(),
                        "m"
                    ].join("");
                }, n.getTopojsonPath = function(t1, e1) {
                    return t1 + e1 + ".json";
                }, n.getTopojsonFeatures = function(t1, e1) {
                    var r = i[t1.locationmode], n = e1.objects[r];
                    return a(e1, n).features;
                };
            },
            44611: function(t1) {
                "use strict";
                t1.exports = {
                    moduleType: "locale",
                    name: "en-US",
                    dictionary: {
                        "Click to enter Colorscale title": "Click to enter Colorscale title"
                    },
                    format: {
                        date: "%m/%d/%Y"
                    }
                };
            },
            30227: function(t1) {
                "use strict";
                t1.exports = {
                    moduleType: "locale",
                    name: "en",
                    dictionary: {
                        "Click to enter Colorscale title": "Click to enter Colourscale title"
                    },
                    format: {
                        days: [
                            "Sunday",
                            "Monday",
                            "Tuesday",
                            "Wednesday",
                            "Thursday",
                            "Friday",
                            "Saturday"
                        ],
                        shortDays: [
                            "Sun",
                            "Mon",
                            "Tue",
                            "Wed",
                            "Thu",
                            "Fri",
                            "Sat"
                        ],
                        months: [
                            "January",
                            "February",
                            "March",
                            "April",
                            "May",
                            "June",
                            "July",
                            "August",
                            "September",
                            "October",
                            "November",
                            "December"
                        ],
                        shortMonths: [
                            "Jan",
                            "Feb",
                            "Mar",
                            "Apr",
                            "May",
                            "Jun",
                            "Jul",
                            "Aug",
                            "Sep",
                            "Oct",
                            "Nov",
                            "Dec"
                        ],
                        periods: [
                            "AM",
                            "PM"
                        ],
                        dateTime: "%a %b %e %X %Y",
                        date: "%d/%m/%Y",
                        time: "%H:%M:%S",
                        decimal: ".",
                        thousands: ",",
                        grouping: [
                            3
                        ],
                        currency: [
                            "$",
                            ""
                        ],
                        year: "%Y",
                        month: "%b %Y",
                        dayMonth: "%b %-d",
                        dayMonthYear: "%b %-d, %Y"
                    }
                };
            },
            56037: function(t1, e1, r) {
                "use strict";
                var n = r(33626);
                t1.exports = function(t1) {
                    for(var e1, r, i = n.layoutArrayContainers, a = n.layoutArrayRegexes, o = t1.split("[")[0], s = 0; s < a.length; s++)if ((r = t1.match(a[s])) && 0 === r.index) {
                        e1 = r[0];
                        break;
                    }
                    if (e1 || (e1 = i[i.indexOf(o)]), !e1) return !1;
                    var l = t1.substr(e1.length);
                    return l ? !!(r = l.match(/^\[(0|[1-9][0-9]*)\](\.(.+))?$/)) && {
                        array: e1,
                        index: Number(r[1]),
                        property: r[3] || ""
                    } : {
                        array: e1,
                        index: "",
                        property: ""
                    };
                };
            },
            13582: function(t1, e1, r) {
                "use strict";
                var n = r(93049).extendFlat, i = r(56174), a = {
                    valType: "flaglist",
                    extras: [
                        "none"
                    ],
                    flags: [
                        "calc",
                        "clearAxisTypes",
                        "plot",
                        "style",
                        "markerSize",
                        "colorbars"
                    ]
                }, o = {
                    valType: "flaglist",
                    extras: [
                        "none"
                    ],
                    flags: [
                        "calc",
                        "plot",
                        "legend",
                        "ticks",
                        "axrange",
                        "layoutstyle",
                        "modebar",
                        "camera",
                        "arraydraw",
                        "colorbars"
                    ]
                }, s = a.flags.slice().concat([
                    "fullReplot"
                ]), l = o.flags.slice().concat("layoutReplot");
                function c(t1) {
                    for(var e1 = {}, r = 0; r < t1.length; r++)e1[t1[r]] = !1;
                    return e1;
                }
                function u(t1, e1, r) {
                    var a = n({}, t1);
                    for(var o in a){
                        var s = a[o];
                        i(s) && (a[o] = h(s, e1, 0, o));
                    }
                    return "from-root" === r && (a.editType = e1), a;
                }
                function h(t1, e1, r, i) {
                    if (t1.valType) {
                        var a = n({}, t1);
                        if (a.editType = e1, Array.isArray(t1.items)) {
                            a.items = new Array(t1.items.length);
                            for(var o = 0; o < t1.items.length; o++)a.items[o] = h(t1.items[o], e1);
                        }
                        return a;
                    }
                    return u(t1, e1, "_" === i.charAt(0) ? "nested" : "from-root");
                }
                t1.exports = {
                    traces: a,
                    layout: o,
                    traceFlags: function() {
                        return c(s);
                    },
                    layoutFlags: function() {
                        return c(l);
                    },
                    update: function(t1, e1) {
                        var r = e1.editType;
                        if (r && "none" !== r) for(var n = r.split("+"), i = 0; i < n.length; i++)t1[n[i]] = !0;
                    },
                    overrideAll: u
                };
            },
            10887: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(36472), a = r(33626), o = r(34809), s = r(44122), l = r(5975), c = r(78766), u = l.cleanId, h = l.getFromTrace, f = a.traceIs;
                function p(t1, e1) {
                    var r = t1[e1], n = e1.charAt(0);
                    r && "paper" !== r && (t1[e1] = u(r, n, !0));
                }
                function d(t1) {
                    function e1(e1, r) {
                        var n = t1[e1], i = t1.title && t1.title[r];
                        n && !i && (t1.title || (t1.title = {}), t1.title[r] = t1[e1], delete t1[e1]);
                    }
                    t1 && ("string" != typeof t1.title && "number" != typeof t1.title || (t1.title = {
                        text: t1.title
                    }), e1("titlefont", "font"), e1("titleposition", "position"), e1("titleside", "side"), e1("titleoffset", "offset"));
                }
                function m(t1) {
                    if (!o.isPlainObject(t1)) return !1;
                    var e1 = t1.name;
                    return delete t1.name, delete t1.showlegend, ("string" == typeof e1 || "number" == typeof e1) && String(e1);
                }
                function g(t1, e1, r, n) {
                    if (r && !n) return t1;
                    if (n && !r) return e1;
                    if (!t1.trim()) return e1;
                    if (!e1.trim()) return t1;
                    var i, a = Math.min(t1.length, e1.length);
                    for(i = 0; i < a && t1.charAt(i) === e1.charAt(i); i++);
                    return t1.substr(0, i).trim();
                }
                function y(t1) {
                    var e1 = "middle", r = "center";
                    return "string" == typeof t1 && (-1 !== t1.indexOf("top") ? e1 = "top" : -1 !== t1.indexOf("bottom") && (e1 = "bottom"), -1 !== t1.indexOf("left") ? r = "left" : -1 !== t1.indexOf("right") && (r = "right")), e1 + " " + r;
                }
                function v(t1, e1) {
                    return e1 in t1 && "object" == typeof t1[e1] && 0 === Object.keys(t1[e1]).length;
                }
                e1.clearPromiseQueue = function(t1) {
                    Array.isArray(t1._promises) && t1._promises.length > 0 && o.log("Clearing previous rejected promises from queue."), t1._promises = [];
                }, e1.cleanLayout = function(t1) {
                    var r, n;
                    t1 || (t1 = {}), t1.xaxis1 && (t1.xaxis || (t1.xaxis = t1.xaxis1), delete t1.xaxis1), t1.yaxis1 && (t1.yaxis || (t1.yaxis = t1.yaxis1), delete t1.yaxis1), t1.scene1 && (t1.scene || (t1.scene = t1.scene1), delete t1.scene1);
                    var a = (s.subplotsRegistry.cartesian || {}).attrRegex, l = (s.subplotsRegistry.polar || {}).attrRegex, h = (s.subplotsRegistry.ternary || {}).attrRegex, f = (s.subplotsRegistry.gl3d || {}).attrRegex, m = Object.keys(t1);
                    for(r = 0; r < m.length; r++){
                        var g = m[r];
                        if (a && a.test(g)) {
                            var y = t1[g];
                            y.anchor && "free" !== y.anchor && (y.anchor = u(y.anchor)), y.overlaying && (y.overlaying = u(y.overlaying)), y.type || (y.isdate ? y.type = "date" : y.islog ? y.type = "log" : !1 === y.isdate && !1 === y.islog && (y.type = "linear")), "withzero" !== y.autorange && "tozero" !== y.autorange || (y.autorange = !0, y.rangemode = "tozero"), y.insiderange && delete y.range, delete y.islog, delete y.isdate, delete y.categories, v(y, "domain") && delete y.domain, void 0 !== y.autotick && (void 0 === y.tickmode && (y.tickmode = y.autotick ? "auto" : "linear"), delete y.autotick), d(y);
                        } else if (l && l.test(g)) d(t1[g].radialaxis);
                        else if (h && h.test(g)) {
                            var x = t1[g];
                            d(x.aaxis), d(x.baxis), d(x.caxis);
                        } else if (f && f.test(g)) {
                            var _ = t1[g], b = _.cameraposition;
                            if (Array.isArray(b) && 4 === b[0].length) {
                                var w = b[0], T = b[1], k = b[2], A = i([], w), M = [];
                                for(n = 0; n < 3; ++n)M[n] = T[n] + k * A[2 + 4 * n];
                                _.camera = {
                                    eye: {
                                        x: M[0],
                                        y: M[1],
                                        z: M[2]
                                    },
                                    center: {
                                        x: T[0],
                                        y: T[1],
                                        z: T[2]
                                    },
                                    up: {
                                        x: 0,
                                        y: 0,
                                        z: 1
                                    }
                                }, delete _.cameraposition;
                            }
                            d(_.xaxis), d(_.yaxis), d(_.zaxis);
                        }
                    }
                    var S = Array.isArray(t1.annotations) ? t1.annotations.length : 0;
                    for(r = 0; r < S; r++){
                        var E = t1.annotations[r];
                        o.isPlainObject(E) && (E.ref && ("paper" === E.ref ? (E.xref = "paper", E.yref = "paper") : "data" === E.ref && (E.xref = "x", E.yref = "y"), delete E.ref), p(E, "xref"), p(E, "yref"));
                    }
                    var C = Array.isArray(t1.shapes) ? t1.shapes.length : 0;
                    for(r = 0; r < C; r++){
                        var L = t1.shapes[r];
                        o.isPlainObject(L) && (p(L, "xref"), p(L, "yref"));
                    }
                    var I = Array.isArray(t1.images) ? t1.images.length : 0;
                    for(r = 0; r < I; r++){
                        var P = t1.images[r];
                        o.isPlainObject(P) && (p(P, "xref"), p(P, "yref"));
                    }
                    var z = t1.legend;
                    return z && (z.x > 3 ? (z.x = 1.02, z.xanchor = "left") : z.x < -2 && (z.x = -0.02, z.xanchor = "right"), z.y > 3 ? (z.y = 1.02, z.yanchor = "bottom") : z.y < -2 && (z.y = -0.02, z.yanchor = "top")), d(t1), "rotate" === t1.dragmode && (t1.dragmode = "orbit"), c.clean(t1), t1.template && t1.template.layout && e1.cleanLayout(t1.template.layout), t1;
                }, e1.cleanData = function(t1) {
                    for(var r = 0; r < t1.length; r++){
                        var n, i = t1[r];
                        if ("histogramy" === i.type && "xbins" in i && !("ybins" in i) && (i.ybins = i.xbins, delete i.xbins), i.error_y && "opacity" in i.error_y) {
                            var l = c.defaults, h = i.error_y.color || (f(i, "bar") ? c.defaultLine : l[r % l.length]);
                            i.error_y.color = c.addOpacity(c.rgb(h), c.opacity(h) * i.error_y.opacity), delete i.error_y.opacity;
                        }
                        if ("bardir" in i && ("h" !== i.bardir || !f(i, "bar") && "histogram" !== i.type.substr(0, 9) || (i.orientation = "h", e1.swapXYData(i)), delete i.bardir), "histogramy" === i.type && e1.swapXYData(i), "histogramx" !== i.type && "histogramy" !== i.type || (i.type = "histogram"), "scl" in i && !("colorscale" in i) && (i.colorscale = i.scl, delete i.scl), "reversescl" in i && !("reversescale" in i) && (i.reversescale = i.reversescl, delete i.reversescl), i.xaxis && (i.xaxis = u(i.xaxis, "x")), i.yaxis && (i.yaxis = u(i.yaxis, "y")), f(i, "gl3d") && i.scene && (i.scene = s.subplotsRegistry.gl3d.cleanId(i.scene)), !f(i, "pie-like") && !f(i, "bar-like")) {
                            if (Array.isArray(i.textposition)) for(n = 0; n < i.textposition.length; n++)i.textposition[n] = y(i.textposition[n]);
                            else i.textposition && (i.textposition = y(i.textposition));
                        }
                        var p = a.getModule(i);
                        if (p && p.colorbar) {
                            var x = p.colorbar.container, _ = x ? i[x] : i;
                            _ && _.colorscale && ("YIGnBu" === _.colorscale && (_.colorscale = "YlGnBu"), "YIOrRd" === _.colorscale && (_.colorscale = "YlOrRd"));
                        }
                        if ("surface" === i.type && o.isPlainObject(i.contours)) {
                            var b = [
                                "x",
                                "y",
                                "z"
                            ];
                            for(n = 0; n < b.length; n++){
                                var w = i.contours[b[n]];
                                o.isPlainObject(w) && (w.highlightColor && (w.highlightcolor = w.highlightColor, delete w.highlightColor), w.highlightWidth && (w.highlightwidth = w.highlightWidth, delete w.highlightWidth));
                            }
                        }
                        if ("candlestick" === i.type || "ohlc" === i.type) {
                            var T = !1 !== (i.increasing || {}).showlegend, k = !1 !== (i.decreasing || {}).showlegend, A = m(i.increasing), M = m(i.decreasing);
                            if (!1 !== A && !1 !== M) {
                                var S = g(A, M, T, k);
                                S && (i.name = S);
                            } else !A && !M || i.name || (i.name = A || M);
                        }
                        if (Array.isArray(i.transforms)) {
                            var E = i.transforms;
                            for(n = 0; n < E.length; n++){
                                var C = E[n];
                                if (o.isPlainObject(C)) switch(C.type){
                                    case "filter":
                                        C.filtersrc && (C.target = C.filtersrc, delete C.filtersrc), C.calendar && (C.valuecalendar || (C.valuecalendar = C.calendar), delete C.calendar);
                                        break;
                                    case "groupby":
                                        if (C.styles = C.styles || C.style, C.styles && !Array.isArray(C.styles)) {
                                            var L = C.styles, I = Object.keys(L);
                                            C.styles = [];
                                            for(var P = 0; P < I.length; P++)C.styles.push({
                                                target: I[P],
                                                value: L[I[P]]
                                            });
                                        }
                                }
                            }
                        }
                        v(i, "line") && delete i.line, "marker" in i && (v(i.marker, "line") && delete i.marker.line, v(i, "marker") && delete i.marker), c.clean(i), i.autobinx && (delete i.autobinx, delete i.xbins), i.autobiny && (delete i.autobiny, delete i.ybins), d(i), i.colorbar && d(i.colorbar), i.marker && i.marker.colorbar && d(i.marker.colorbar), i.line && i.line.colorbar && d(i.line.colorbar), i.aaxis && d(i.aaxis), i.baxis && d(i.baxis);
                    }
                }, e1.swapXYData = function(t1) {
                    var e1;
                    if (o.swapAttrs(t1, [
                        "?",
                        "?0",
                        "d?",
                        "?bins",
                        "nbins?",
                        "autobin?",
                        "?src",
                        "error_?"
                    ]), Array.isArray(t1.z) && Array.isArray(t1.z[0]) && (t1.transpose ? delete t1.transpose : t1.transpose = !0), t1.error_x && t1.error_y) {
                        var r = t1.error_y, n = "copy_ystyle" in r ? r.copy_ystyle : !(r.color || r.thickness || r.width);
                        o.swapAttrs(t1, [
                            "error_?.copy_ystyle"
                        ]), n && o.swapAttrs(t1, [
                            "error_?.color",
                            "error_?.thickness",
                            "error_?.width"
                        ]);
                    }
                    if ("string" == typeof t1.hoverinfo) {
                        var i = t1.hoverinfo.split("+");
                        for(e1 = 0; e1 < i.length; e1++)"x" === i[e1] ? i[e1] = "y" : "y" === i[e1] && (i[e1] = "x");
                        t1.hoverinfo = i.join("+");
                    }
                }, e1.coerceTraceIndices = function(t1, e1) {
                    if (n(e1)) return [
                        e1
                    ];
                    if (!Array.isArray(e1) || !e1.length) return t1.data.map(function(t1, e1) {
                        return e1;
                    });
                    if (Array.isArray(e1)) {
                        for(var r = [], i = 0; i < e1.length; i++)o.isIndex(e1[i], t1.data.length) ? r.push(e1[i]) : o.warn("trace index (", e1[i], ") is not a number or is out of bounds");
                        return r;
                    }
                    return e1;
                }, e1.manageArrayContainers = function(t1, e1, r) {
                    var i = t1.obj, a = t1.parts, s = a.length, l = a[s - 1], c = n(l);
                    if (c && null === e1) {
                        var u = a.slice(0, s - 1).join(".");
                        o.nestedProperty(i, u).get().splice(l, 1);
                    } else c && void 0 === t1.get() ? (void 0 === t1.get() && (r[t1.astr] = null), t1.set(e1)) : t1.set(e1);
                };
                var x = /(\.[^\[\]\.]+|\[[^\[\]\.]+\])$/;
                function _(t1) {
                    var e1 = t1.search(x);
                    if (e1 > 0) return t1.substr(0, e1);
                }
                e1.hasParent = function(t1, e1) {
                    for(var r = _(e1); r;){
                        if (r in t1) return !0;
                        r = _(r);
                    }
                    return !1;
                };
                var b = [
                    "x",
                    "y",
                    "z"
                ];
                e1.clearAxisTypes = function(t1, e1, r) {
                    for(var n = 0; n < e1.length; n++)for(var i = t1._fullData[n], a = 0; a < 3; a++){
                        var s = h(t1, i, b[a]);
                        if (s && "log" !== s.type) {
                            var l = s._name, c = s._id.substr(1);
                            if ("scene" === c.substr(0, 5)) {
                                if (void 0 !== r[c]) continue;
                                l = c + "." + l;
                            }
                            var u = l + ".type";
                            void 0 === r[l] && void 0 === r[u] && o.nestedProperty(t1.layout, u).set(null);
                        }
                    }
                };
            },
            90742: function(t1, e1, r) {
                "use strict";
                var n = r(31420);
                e1._doPlot = n._doPlot, e1.newPlot = n.newPlot, e1.restyle = n.restyle, e1.relayout = n.relayout, e1.redraw = n.redraw, e1.update = n.update, e1._guiRestyle = n._guiRestyle, e1._guiRelayout = n._guiRelayout, e1._guiUpdate = n._guiUpdate, e1._storeDirectGUIEdit = n._storeDirectGUIEdit, e1.react = n.react, e1.extendTraces = n.extendTraces, e1.prependTraces = n.prependTraces, e1.addTraces = n.addTraces, e1.deleteTraces = n.deleteTraces, e1.moveTraces = n.moveTraces, e1.purge = n.purge, e1.addFrames = n.addFrames, e1.deleteFrames = n.deleteFrames, e1.animate = n.animate, e1.setPlotConfig = n.setPlotConfig;
                var i = r(95425).getGraphDiv, a = r(28231).eraseActiveShape;
                e1.deleteActiveShape = function(t1) {
                    return a(i(t1));
                }, e1.toImage = r(80491), e1.validate = r(2466), e1.downloadImage = r(26452);
                var o = r(53853);
                e1.makeTemplate = o.makeTemplate, e1.validateTemplate = o.validateTemplate;
            },
            85844: function(t1, e1, r) {
                "use strict";
                var n = r(56174), i = r(4969), a = r(48636), o = r(98813).sorterAsc, s = r(33626);
                e1.containerArrayMatch = r(56037);
                var l = e1.isAddVal = function(t1) {
                    return "add" === t1 || n(t1);
                }, c = e1.isRemoveVal = function(t1) {
                    return null === t1 || "remove" === t1;
                };
                e1.applyContainerArrayChanges = function(t1, e1, r, n, u) {
                    var h = e1.astr, f = s.getComponentMethod(h, "supplyLayoutDefaults"), p = s.getComponentMethod(h, "draw"), d = s.getComponentMethod(h, "drawOne"), m = n.replot || n.recalc || f === i || p === i, g = t1.layout, y = t1._fullLayout;
                    if (r[""]) {
                        Object.keys(r).length > 1 && a.warn("Full array edits are incompatible with other edits", h);
                        var v = r[""][""];
                        if (c(v)) e1.set(null);
                        else {
                            if (!Array.isArray(v)) return a.warn("Unrecognized full array edit value", h, v), !0;
                            e1.set(v);
                        }
                        return !m && (f(g, y), p(t1), !0);
                    }
                    var x, _, b, w, T, k, A, M, S = Object.keys(r).map(Number).sort(o), E = e1.get(), C = E || [], L = u(y, h).get(), I = [], P = -1, z = C.length;
                    for(x = 0; x < S.length; x++)if (w = r[b = S[x]], T = Object.keys(w), k = w[""], A = l(k), b < 0 || b > C.length - (A ? 0 : 1)) a.warn("index out of range", h, b);
                    else if (void 0 !== k) T.length > 1 && a.warn("Insertion & removal are incompatible with edits to the same index.", h, b), c(k) ? I.push(b) : A ? ("add" === k && (k = {}), C.splice(b, 0, k), L && L.splice(b, 0, {})) : a.warn("Unrecognized full object edit value", h, b, k), -1 === P && (P = b);
                    else for(_ = 0; _ < T.length; _++)M = h + "[" + b + "].", u(C[b], T[_], M).set(w[T[_]]);
                    for(x = I.length - 1; x >= 0; x--)C.splice(I[x], 1), L && L.splice(I[x], 1);
                    if (C.length ? E || e1.set(C) : e1.set(null), m) return !1;
                    if (f(g, y), d !== i) {
                        var O;
                        if (-1 === P) O = S;
                        else {
                            for(z = Math.max(C.length, z), O = [], x = 0; x < S.length && !((b = S[x]) >= P); x++)O.push(b);
                            for(x = P; x < z; x++)O.push(x);
                        }
                        for(x = 0; x < O.length; x++)d(t1, O[x]);
                    } else p(t1);
                    return !0;
                };
            },
            31420: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(10721), a = r(39784), o = r(34809), s = o.nestedProperty, l = r(68596), c = r(40486), u = r(33626), h = r(57297), f = r(44122), p = r(29714), d = r(90259), m = r(25829), g = r(62203), y = r(78766), v = r(95284).initInteractions, x = r(62972), _ = r(44844).clearOutline, b = r(24452).dfltConfig, w = r(85844), T = r(10887), k = r(71817), A = r(13582), M = r(54826).AX_NAME_PATTERN, S = 0;
                function E(t1) {
                    var e1 = t1._fullLayout;
                    e1._redrawFromAutoMarginCount ? e1._redrawFromAutoMarginCount-- : t1.emit("plotly_afterplot");
                }
                function C(t1, e1) {
                    try {
                        t1._fullLayout._paper.style("background", e1);
                    } catch (t1) {
                        o.error(t1);
                    }
                }
                function L(t1, e1) {
                    C(t1, y.combine(e1, "white"));
                }
                function I(t1, e1) {
                    if (!t1._context) {
                        t1._context = o.extendDeep({}, b);
                        var r = n.select("base");
                        t1._context._baseUrl = r.size() && r.attr("href") ? window.location.href.split("#")[0] : "";
                    }
                    var i, s, l, c = t1._context;
                    if (e1) {
                        for(s = Object.keys(e1), i = 0; i < s.length; i++)"editable" !== (l = s[i]) && "edits" !== l && l in c && ("setBackground" === l && "opaque" === e1[l] ? c[l] = L : c[l] = e1[l]);
                        e1.plot3dPixelRatio && !c.plotGlPixelRatio && (c.plotGlPixelRatio = c.plot3dPixelRatio);
                        var u = e1.editable;
                        if (void 0 !== u) for(c.editable = u, s = Object.keys(c.edits), i = 0; i < s.length; i++)c.edits[s[i]] = u;
                        if (e1.edits) for(s = Object.keys(e1.edits), i = 0; i < s.length; i++)(l = s[i]) in c.edits && (c.edits[l] = e1.edits[l]);
                        c._exportedPlot = e1._exportedPlot;
                    }
                    c.staticPlot && (c.editable = !1, c.edits = {}, c.autosizable = !1, c.scrollZoom = !1, c.doubleClick = !1, c.showTips = !1, c.showLink = !1, c.displayModeBar = !1), "hover" !== c.displayModeBar || a || (c.displayModeBar = !0), "transparent" !== c.setBackground && "function" == typeof c.setBackground || (c.setBackground = C), c._hasZeroHeight = c._hasZeroHeight || 0 === t1.clientHeight, c._hasZeroWidth = c._hasZeroWidth || 0 === t1.clientWidth;
                    var h = c.scrollZoom, f = c._scrollZoom = {};
                    if (!0 === h) f.cartesian = 1, f.gl3d = 1, f.geo = 1, f.mapbox = 1, f.map = 1;
                    else if ("string" == typeof h) {
                        var p = h.split("+");
                        for(i = 0; i < p.length; i++)f[p[i]] = 1;
                    } else !1 !== h && (f.gl3d = 1, f.geo = 1, f.mapbox = 1, f.map = 1);
                }
                function P(t1, e1) {
                    var r, n, i = e1 + 1, a = [];
                    for(r = 0; r < t1.length; r++)(n = t1[r]) < 0 ? a.push(i + n) : a.push(n);
                    return a;
                }
                function z(t1, e1, r) {
                    var n, i;
                    for(n = 0; n < e1.length; n++){
                        if ((i = e1[n]) !== parseInt(i, 10)) throw new Error("all values in " + r + " must be integers");
                        if (i >= t1.data.length || i < -t1.data.length) throw new Error(r + " must be valid indices for gd.data.");
                        if (e1.indexOf(i, n + 1) > -1 || i >= 0 && e1.indexOf(-t1.data.length + i) > -1 || i < 0 && e1.indexOf(t1.data.length + i) > -1) throw new Error("each index in " + r + " must be unique.");
                    }
                }
                function O(t1, e1, r) {
                    if (!Array.isArray(t1.data)) throw new Error("gd.data must be an array.");
                    if (void 0 === e1) throw new Error("currentIndices is a required argument.");
                    if (Array.isArray(e1) || (e1 = [
                        e1
                    ]), z(t1, e1, "currentIndices"), void 0 === r || Array.isArray(r) || (r = [
                        r
                    ]), void 0 !== r && z(t1, r, "newIndices"), void 0 !== r && e1.length !== r.length) throw new Error("current and new indices must be of equal length.");
                }
                function D(t1, e1, r, n, a) {
                    !function(t1, e1, r, n) {
                        var i = o.isPlainObject(n);
                        if (!Array.isArray(t1.data)) throw new Error("gd.data must be an array");
                        if (!o.isPlainObject(e1)) throw new Error("update must be a key:value object");
                        if (void 0 === r) throw new Error("indices must be an integer or array of integers");
                        for(var a in z(t1, r, "indices"), e1){
                            if (!Array.isArray(e1[a]) || e1[a].length !== r.length) throw new Error("attribute " + a + " must be an array of length equal to indices array length");
                            if (i && (!(a in n) || !Array.isArray(n[a]) || n[a].length !== e1[a].length)) throw new Error("when maxPoints is set as a key:value object it must contain a 1:1 corrispondence with the keys and number of traces in the update object");
                        }
                    }(t1, e1, r, n);
                    for(var l = function(t1, e1, r, n) {
                        var a, l, c, u, h, f = o.isPlainObject(n), p = [];
                        for(var d in Array.isArray(r) || (r = [
                            r
                        ]), r = P(r, t1.data.length - 1), e1)for(var m = 0; m < r.length; m++){
                            if (a = t1.data[r[m]], l = (c = s(a, d)).get(), u = e1[d][m], !o.isArrayOrTypedArray(u)) throw new Error("attribute: " + d + " index: " + m + " must be an array");
                            if (!o.isArrayOrTypedArray(l)) throw new Error("cannot extend missing or non-array attribute: " + d);
                            if (l.constructor !== u.constructor) throw new Error("cannot extend array with an array of a different type: " + d);
                            h = f ? n[d][m] : n, i(h) || (h = -1), p.push({
                                prop: c,
                                target: l,
                                insert: u,
                                maxp: Math.floor(h)
                            });
                        }
                        return p;
                    }(t1, e1, r, n), c = {}, u = {}, h = 0; h < l.length; h++){
                        var f = l[h].prop, p = l[h].maxp, d = a(l[h].target, l[h].insert, p);
                        f.set(d[0]), Array.isArray(c[f.astr]) || (c[f.astr] = []), c[f.astr].push(d[1]), Array.isArray(u[f.astr]) || (u[f.astr] = []), u[f.astr].push(l[h].target.length);
                    }
                    return {
                        update: c,
                        maxPoints: u
                    };
                }
                function R(t1, e1) {
                    var r = new t1.constructor(t1.length + e1.length);
                    return r.set(t1), r.set(e1, t1.length), r;
                }
                function F(t1, r, n, i) {
                    t1 = o.getGraphDiv(t1), T.clearPromiseQueue(t1);
                    var a = {};
                    if ("string" == typeof r) a[r] = n;
                    else {
                        if (!o.isPlainObject(r)) return o.warn("Restyle fail.", r, n, i), Promise.reject();
                        a = o.extendFlat({}, r), void 0 === i && (i = n);
                    }
                    Object.keys(a).length && (t1.changed = !0);
                    var s = T.coerceTraceIndices(t1, i), l = U(t1, a, s), u = l.flags;
                    u.calc && (t1.calcdata = void 0), u.clearAxisTypes && T.clearAxisTypes(t1, s, {});
                    var h = [];
                    u.fullReplot ? h.push(e1._doPlot) : (h.push(f.previousPromises), f.supplyDefaults(t1), u.markerSize && (f.doCalcdata(t1), G(h)), u.style && h.push(k.doTraceStyle), u.colorbars && h.push(k.doColorBars), h.push(E)), h.push(f.rehover, f.redrag, f.reselect), c.add(t1, F, [
                        t1,
                        l.undoit,
                        l.traces
                    ], F, [
                        t1,
                        l.redoit,
                        l.traces
                    ]);
                    var p = o.syncOrAsync(h, t1);
                    return p && p.then || (p = Promise.resolve()), p.then(function() {
                        return t1.emit("plotly_restyle", l.eventData), t1;
                    });
                }
                function B(t1) {
                    return void 0 === t1 ? null : t1;
                }
                function N(t1, e1) {
                    return e1 ? function(e1, r, n) {
                        var i = s(e1, r), a = i.set;
                        return i.set = function(e1) {
                            j((n || "") + r, i.get(), e1, t1), a(e1);
                        }, i;
                    } : s;
                }
                function j(t1, e1, r, n) {
                    if (Array.isArray(e1) || Array.isArray(r)) for(var i = Array.isArray(e1) ? e1 : [], a = Array.isArray(r) ? r : [], s = Math.max(i.length, a.length), l = 0; l < s; l++)j(t1 + "[" + l + "]", i[l], a[l], n);
                    else if (o.isPlainObject(e1) || o.isPlainObject(r)) {
                        var c = o.isPlainObject(e1) ? e1 : {}, u = o.isPlainObject(r) ? r : {}, h = o.extendFlat({}, c, u);
                        for(var f in h)j(t1 + "." + f, c[f], u[f], n);
                    } else void 0 === n[t1] && (n[t1] = B(e1));
                }
                function U(t1, e1, r) {
                    var n, i = t1._fullLayout, a = t1._fullData, l = t1.data, c = i._guiEditing, d = N(i._preGUI, c), m = o.extendDeepAll({}, e1);
                    V(e1);
                    var g, y = A.traceFlags(), v = {}, x = {};
                    function _() {
                        return r.map(function() {});
                    }
                    function b(t1) {
                        var e1 = p.id2name(t1);
                        -1 === g.indexOf(e1) && g.push(e1);
                    }
                    function w(t1) {
                        return "LAYOUT" + t1 + ".autorange";
                    }
                    function k(t1) {
                        return "LAYOUT" + t1 + ".range";
                    }
                    function M(t1) {
                        for(var e1 = t1; e1 < a.length; e1++)if (a[e1]._input === l[t1]) return a[e1];
                    }
                    function S(n, a, o) {
                        if (Array.isArray(n)) n.forEach(function(t1) {
                            S(t1, a, o);
                        });
                        else if (!(n in e1) && !T.hasParent(e1, n)) {
                            var s;
                            if ("LAYOUT" === n.substr(0, 6)) s = d(t1.layout, n.replace("LAYOUT", ""));
                            else {
                                var u = r[o];
                                s = N(i._tracePreGUI[M(u)._fullInput.uid], c)(l[u], n);
                            }
                            n in x || (x[n] = _()), void 0 === x[n][o] && (x[n][o] = B(s.get())), void 0 !== a && s.set(a);
                        }
                    }
                    function E(t1) {
                        return function(e1) {
                            return a[e1][t1];
                        };
                    }
                    function C(t1) {
                        return function(e1, n) {
                            return !1 === e1 ? a[r[n]][t1] : null;
                        };
                    }
                    for(var L in e1){
                        if (T.hasParent(e1, L)) throw new Error("cannot set " + L + " and a parent attribute simultaneously");
                        var I, P, z, O, D, R, F = e1[L];
                        if ("autobinx" !== L && "autobiny" !== L || (L = L.charAt(L.length - 1) + "bins", F = Array.isArray(F) ? F.map(C(L)) : !1 === F ? r.map(E(L)) : null), v[L] = F, "LAYOUT" !== L.substr(0, 6)) {
                            for(x[L] = _(), n = 0; n < r.length; n++)if (I = l[r[n]], P = M(r[n]), O = (z = N(i._tracePreGUI[P._fullInput.uid], c)(I, L)).get(), void 0 !== (D = Array.isArray(F) ? F[n % F.length] : F)) {
                                var j = z.parts[z.parts.length - 1], U = L.substr(0, L.length - j.length - 1), q = U ? U + "." : "", H = U ? s(P, U).get() : P;
                                if ((R = h.getTraceValObject(P, z.parts)) && R.impliedEdits && null !== D) for(var G in R.impliedEdits)S(o.relativeAttr(L, G), R.impliedEdits[G], n);
                                else if ("thicknessmode" !== j && "lenmode" !== j || O === D || "fraction" !== D && "pixels" !== D || !H) {
                                    if ("type" === L && ("pie" === D != ("pie" === O) || "funnelarea" === D != ("funnelarea" === O))) {
                                        var Z = "x", W = "y";
                                        "bar" !== D && "bar" !== O || "h" !== I.orientation || (Z = "y", W = "x"), o.swapAttrs(I, [
                                            "?",
                                            "?src"
                                        ], "labels", Z), o.swapAttrs(I, [
                                            "d?",
                                            "?0"
                                        ], "label", Z), o.swapAttrs(I, [
                                            "?",
                                            "?src"
                                        ], "values", W), "pie" === O || "funnelarea" === O ? (s(I, "marker.color").set(s(I, "marker.colors").get()), i._pielayer.selectAll("g.trace").remove()) : u.traceIs(I, "cartesian") && s(I, "marker.colors").set(s(I, "marker.color").get());
                                    }
                                } else {
                                    var Y = i._size, X = H.orient, $ = "top" === X || "bottom" === X;
                                    if ("thicknessmode" === j) {
                                        var J = $ ? Y.h : Y.w;
                                        S(q + "thickness", H.thickness * ("fraction" === D ? 1 / J : J), n);
                                    } else {
                                        var K = $ ? Y.w : Y.h;
                                        S(q + "len", H.len * ("fraction" === D ? 1 / K : K), n);
                                    }
                                }
                                if (x[L][n] = B(O), -1 !== [
                                    "swapxy",
                                    "swapxyaxes",
                                    "orientation",
                                    "orientationaxes"
                                ].indexOf(L)) {
                                    if ("orientation" === L) {
                                        z.set(D);
                                        var Q = I.x && !I.y ? "h" : "v";
                                        if ((z.get() || Q) === P.orientation) continue;
                                    } else "orientationaxes" === L && (I.orientation = ({
                                        v: "h",
                                        h: "v"
                                    })[P.orientation]);
                                    T.swapXYData(I), y.calc = y.clearAxisTypes = !0;
                                } else -1 !== f.dataArrayContainers.indexOf(z.parts[0]) ? (T.manageArrayContainers(z, D, x), y.calc = !0) : (R ? R.arrayOk && !u.traceIs(P, "regl") && (o.isArrayOrTypedArray(D) || o.isArrayOrTypedArray(O)) ? y.calc = !0 : A.update(y, R) : y.calc = !0, z.set(D));
                            }
                            if (-1 !== [
                                "swapxyaxes",
                                "orientationaxes"
                            ].indexOf(L) && p.swap(t1, r), "orientationaxes" === L) {
                                var tt = s(t1.layout, "hovermode"), et = tt.get();
                                "x" === et ? tt.set("y") : "y" === et ? tt.set("x") : "x unified" === et ? tt.set("y unified") : "y unified" === et && tt.set("x unified");
                            }
                            if (-1 !== [
                                "orientation",
                                "type"
                            ].indexOf(L)) {
                                for(g = [], n = 0; n < r.length; n++){
                                    var rt = l[r[n]];
                                    u.traceIs(rt, "cartesian") && (b(rt.xaxis || "x"), b(rt.yaxis || "y"));
                                }
                                S(g.map(w), !0, 0), S(g.map(k), [
                                    0,
                                    1
                                ], 0);
                            }
                        } else z = d(t1.layout, L.replace("LAYOUT", "")), x[L] = [
                            B(z.get())
                        ], z.set(Array.isArray(F) ? F[0] : F), y.calc = !0;
                    }
                    return (y.calc || y.plot) && (y.fullReplot = !0), {
                        flags: y,
                        undoit: x,
                        redoit: v,
                        traces: r,
                        eventData: o.extendDeepNoArrays([], [
                            m,
                            r
                        ])
                    };
                }
                function V(t1) {
                    var e1, r, n, i = o.counterRegex("axis", ".title", !1, !1), a = /colorbar\.title$/, s = Object.keys(t1);
                    for(e1 = 0; e1 < s.length; e1++)r = s[e1], n = t1[r], "title" !== r && !i.test(r) && !a.test(r) || "string" != typeof n && "number" != typeof n ? r.indexOf("titlefont") > -1 && -1 === r.indexOf("grouptitlefont") ? l(r, r.replace("titlefont", "title.font")) : r.indexOf("titleposition") > -1 ? l(r, r.replace("titleposition", "title.position")) : r.indexOf("titleside") > -1 ? l(r, r.replace("titleside", "title.side")) : r.indexOf("titleoffset") > -1 && l(r, r.replace("titleoffset", "title.offset")) : l(r, r.replace("title", "title.text"));
                    function l(e1, r) {
                        t1[r] = t1[e1], delete t1[e1];
                    }
                }
                function q(t1, e1, r) {
                    t1 = o.getGraphDiv(t1), T.clearPromiseQueue(t1);
                    var n = {};
                    if ("string" == typeof e1) n[e1] = r;
                    else {
                        if (!o.isPlainObject(e1)) return o.warn("Relayout fail.", e1, r), Promise.reject();
                        n = o.extendFlat({}, e1);
                    }
                    Object.keys(n).length && (t1.changed = !0);
                    var i = X(t1, n), a = i.flags;
                    a.calc && (t1.calcdata = void 0);
                    var s = [
                        f.previousPromises
                    ];
                    a.layoutReplot ? s.push(k.layoutReplot) : Object.keys(n).length && (H(t1, a, i) || f.supplyDefaults(t1), a.legend && s.push(k.doLegend), a.layoutstyle && s.push(k.layoutStyles), a.axrange && G(s, i.rangesAltered), a.ticks && s.push(k.doTicksRelayout), a.modebar && s.push(k.doModeBar), a.camera && s.push(k.doCamera), a.colorbars && s.push(k.doColorBars), s.push(E)), s.push(f.rehover, f.redrag, f.reselect), c.add(t1, q, [
                        t1,
                        i.undoit
                    ], q, [
                        t1,
                        i.redoit
                    ]);
                    var l = o.syncOrAsync(s, t1);
                    return l && l.then || (l = Promise.resolve(t1)), l.then(function() {
                        return t1.emit("plotly_relayout", i.eventData), t1;
                    });
                }
                function H(t1, e1, r) {
                    var n, i, a = t1._fullLayout;
                    if (!e1.axrange) return !1;
                    for(var s in e1)if ("axrange" !== s && e1[s]) return !1;
                    var l = function(t1, e1) {
                        return o.coerce(n, i, m, t1, e1);
                    }, c = {};
                    for(var u in r.rangesAltered){
                        var h = p.id2name(u);
                        if (n = t1.layout[h], i = a[h], d(n, i, l, c), i._matchGroup) {
                            for(var f in i._matchGroup)if (f !== u) {
                                var g = a[p.id2name(f)];
                                g.autorange = i.autorange, g.range = i.range.slice(), g._input.range = i.range.slice();
                            }
                        }
                    }
                    return !0;
                }
                function G(t1, e1) {
                    var r = e1 ? function(t1) {
                        var r = [];
                        for(var n in e1){
                            var i = p.getFromId(t1, n);
                            if (r.push(n), -1 !== (i.ticklabelposition || "").indexOf("inside") && i._anchorAxis && r.push(i._anchorAxis._id), i._matchGroup) for(var a in i._matchGroup)e1[a] || r.push(a);
                        }
                        return p.draw(t1, r, {
                            skipTitle: !0
                        });
                    } : function(t1) {
                        return p.draw(t1, "redraw");
                    };
                    t1.push(_, k.doAutoRangeAndConstraints, r, k.drawData, k.finalDraw);
                }
                var Z = /^[xyz]axis[0-9]*\.range(\[[0|1]\])?$/, W = /^[xyz]axis[0-9]*\.autorange$/, Y = /^[xyz]axis[0-9]*\.domain(\[[0|1]\])?$/;
                function X(t1, e1) {
                    var r, n, i, a = t1.layout, l = t1._fullLayout, c = l._guiEditing, f = N(l._preGUI, c), d = Object.keys(e1), m = p.list(t1), g = o.extendDeepAll({}, e1), y = {};
                    for(V(e1), d = Object.keys(e1), n = 0; n < d.length; n++)if (0 === d[n].indexOf("allaxes")) {
                        for(i = 0; i < m.length; i++){
                            var v = m[i]._id.substr(1), x = -1 !== v.indexOf("scene") ? v + "." : "", _ = d[n].replace("allaxes", x + m[i]._name);
                            e1[_] || (e1[_] = e1[d[n]]);
                        }
                        delete e1[d[n]];
                    }
                    var b = A.layoutFlags(), k = {}, S = {};
                    function E(t1, r) {
                        if (Array.isArray(t1)) t1.forEach(function(t1) {
                            E(t1, r);
                        });
                        else if (!(t1 in e1) && !T.hasParent(e1, t1)) {
                            var n = f(a, t1);
                            t1 in S || (S[t1] = B(n.get())), void 0 !== r && n.set(r);
                        }
                    }
                    var C, L = {};
                    function I(t1) {
                        var e1 = p.name2id(t1.split(".")[0]);
                        return L[e1] = 1, e1;
                    }
                    for(var P in e1){
                        if (T.hasParent(e1, P)) throw new Error("cannot set " + P + " and a parent attribute simultaneously");
                        for(var z = f(a, P), O = e1[P], D = z.parts.length - 1; D > 0 && "string" != typeof z.parts[D];)D--;
                        var R = z.parts[D], F = z.parts[D - 1] + "." + R, j = z.parts.slice(0, D).join("."), U = s(t1.layout, j).get(), q = s(l, j).get(), H = z.get();
                        if (void 0 !== O) {
                            k[P] = O, S[P] = "reverse" === R ? O : B(H);
                            var G = h.getLayoutValObject(l, z.parts);
                            if (G && G.impliedEdits && null !== O) for(var X in G.impliedEdits)E(o.relativeAttr(P, X), G.impliedEdits[X]);
                            if (-1 !== [
                                "width",
                                "height"
                            ].indexOf(P)) {
                                if (O) {
                                    E("autosize", null);
                                    var J = "height" === P ? "width" : "height";
                                    E(J, l[J]);
                                } else l[P] = t1._initialAutoSize[P];
                            } else if ("autosize" === P) E("width", O ? null : l.width), E("height", O ? null : l.height);
                            else if (F.match(Z)) I(F), s(l, j + "._inputRange").set(null);
                            else if (F.match(W)) {
                                I(F), s(l, j + "._inputRange").set(null);
                                var K = s(l, j).get();
                                K._inputDomain && (K._input.domain = K._inputDomain.slice());
                            } else F.match(Y) && s(l, j + "._inputDomain").set(null);
                            if ("type" === R) {
                                C = U;
                                var Q = "linear" === q.type && "log" === O, tt = "log" === q.type && "linear" === O;
                                if (Q || tt) {
                                    if (C && C.range) {
                                        if (q.autorange) Q && (C.range = C.range[1] > C.range[0] ? [
                                            1,
                                            2
                                        ] : [
                                            2,
                                            1
                                        ]);
                                        else {
                                            var et = C.range[0], rt = C.range[1];
                                            Q ? (et <= 0 && rt <= 0 && E(j + ".autorange", !0), et <= 0 ? et = rt / 1e6 : rt <= 0 && (rt = et / 1e6), E(j + ".range[0]", Math.log(et) / Math.LN10), E(j + ".range[1]", Math.log(rt) / Math.LN10)) : (E(j + ".range[0]", Math.pow(10, et)), E(j + ".range[1]", Math.pow(10, rt)));
                                        }
                                    } else E(j + ".autorange", !0);
                                    Array.isArray(l._subplots.polar) && l._subplots.polar.length && l[z.parts[0]] && "radialaxis" === z.parts[1] && delete l[z.parts[0]]._subplot.viewInitial["radialaxis.range"], u.getComponentMethod("annotations", "convertCoords")(t1, q, O, E), u.getComponentMethod("images", "convertCoords")(t1, q, O, E);
                                } else E(j + ".autorange", !0), E(j + ".range", null);
                                s(l, j + "._inputRange").set(null);
                            } else if (R.match(M)) {
                                var nt = s(l, P).get(), it = (O || {}).type;
                                it && "-" !== it || (it = "linear"), u.getComponentMethod("annotations", "convertCoords")(t1, nt, it, E), u.getComponentMethod("images", "convertCoords")(t1, nt, it, E);
                            }
                            var at = w.containerArrayMatch(P);
                            if (at) {
                                r = at.array, n = at.index;
                                var ot = at.property, st = G || {
                                    editType: "calc"
                                };
                                "" !== n && "" === ot && (w.isAddVal(O) ? S[P] = null : w.isRemoveVal(O) ? S[P] = (s(a, r).get() || [])[n] : o.warn("unrecognized full object value", e1)), A.update(b, st), y[r] || (y[r] = {});
                                var lt = y[r][n];
                                lt || (lt = y[r][n] = {}), lt[ot] = O, delete e1[P];
                            } else "reverse" === R ? (U.range ? U.range.reverse() : (E(j + ".autorange", !0), U.range = [
                                1,
                                0
                            ]), q.autorange ? b.calc = !0 : b.plot = !0) : ("dragmode" === P && (!1 === O && !1 !== H || !1 !== O && !1 === H) || l._has("scatter-like") && l._has("regl") && "dragmode" === P && ("lasso" === O || "select" === O) && "lasso" !== H && "select" !== H || l._has("gl2d") ? b.plot = !0 : G ? A.update(b, G) : b.calc = !0, z.set(O));
                        }
                    }
                    for(r in y)w.applyContainerArrayChanges(t1, f(a, r), y[r], b, f) || (b.plot = !0);
                    for(var ct in L){
                        var ut = (C = p.getFromId(t1, ct)) && C._constraintGroup;
                        if (ut) for(var ht in b.calc = !0, ut)L[ht] || (p.getFromId(t1, ht)._constraintShrinkable = !0);
                    }
                    ($(t1) || e1.height || e1.width) && (b.plot = !0);
                    var ft = l.shapes;
                    for(n = 0; n < ft.length; n++)if (ft[n].showlegend) {
                        b.calc = !0;
                        break;
                    }
                    return (b.plot || b.calc) && (b.layoutReplot = !0), {
                        flags: b,
                        rangesAltered: L,
                        undoit: S,
                        redoit: k,
                        eventData: g
                    };
                }
                function $(t1) {
                    var e1 = t1._fullLayout, r = e1.width, n = e1.height;
                    return t1.layout.autosize && f.plotAutoSize(t1, t1.layout, e1), e1.width !== r || e1.height !== n;
                }
                function J(t1, r, n, i) {
                    t1 = o.getGraphDiv(t1), T.clearPromiseQueue(t1), o.isPlainObject(r) || (r = {}), o.isPlainObject(n) || (n = {}), Object.keys(r).length && (t1.changed = !0), Object.keys(n).length && (t1.changed = !0);
                    var a = T.coerceTraceIndices(t1, i), s = U(t1, o.extendFlat({}, r), a), l = s.flags, u = X(t1, o.extendFlat({}, n)), h = u.flags;
                    (l.calc || h.calc) && (t1.calcdata = void 0), l.clearAxisTypes && T.clearAxisTypes(t1, a, n);
                    var p = [];
                    h.layoutReplot ? p.push(k.layoutReplot) : l.fullReplot ? p.push(e1._doPlot) : (p.push(f.previousPromises), H(t1, h, u) || f.supplyDefaults(t1), l.style && p.push(k.doTraceStyle), (l.colorbars || h.colorbars) && p.push(k.doColorBars), h.legend && p.push(k.doLegend), h.layoutstyle && p.push(k.layoutStyles), h.axrange && G(p, u.rangesAltered), h.ticks && p.push(k.doTicksRelayout), h.modebar && p.push(k.doModeBar), h.camera && p.push(k.doCamera), p.push(E)), p.push(f.rehover, f.redrag, f.reselect), c.add(t1, J, [
                        t1,
                        s.undoit,
                        u.undoit,
                        s.traces
                    ], J, [
                        t1,
                        s.redoit,
                        u.redoit,
                        s.traces
                    ]);
                    var d = o.syncOrAsync(p, t1);
                    return d && d.then || (d = Promise.resolve(t1)), d.then(function() {
                        return t1.emit("plotly_update", {
                            data: s.eventData,
                            layout: u.eventData
                        }), t1;
                    });
                }
                function K(t1) {
                    return function(e1) {
                        e1._fullLayout._guiEditing = !0;
                        var r = t1.apply(null, arguments);
                        return e1._fullLayout._guiEditing = !1, r;
                    };
                }
                var Q = [
                    {
                        pattern: /^hiddenlabels/,
                        attr: "legend.uirevision"
                    },
                    {
                        pattern: /^((x|y)axis\d*)\.((auto)?range|title\.text)/
                    },
                    {
                        pattern: /axis\d*\.showspikes$/,
                        attr: "modebar.uirevision"
                    },
                    {
                        pattern: /(hover|drag)mode$/,
                        attr: "modebar.uirevision"
                    },
                    {
                        pattern: /^(scene\d*)\.camera/
                    },
                    {
                        pattern: /^(geo\d*)\.(projection|center|fitbounds)/
                    },
                    {
                        pattern: /^(ternary\d*\.[abc]axis)\.(min|title\.text)$/
                    },
                    {
                        pattern: /^(polar\d*\.radialaxis)\.((auto)?range|angle|title\.text)/
                    },
                    {
                        pattern: /^(polar\d*\.angularaxis)\.rotation/
                    },
                    {
                        pattern: /^(mapbox\d*)\.(center|zoom|bearing|pitch)/
                    },
                    {
                        pattern: /^(map\d*)\.(center|zoom|bearing|pitch)/
                    },
                    {
                        pattern: /^legend\.(x|y)$/,
                        attr: "editrevision"
                    },
                    {
                        pattern: /^(shapes|annotations)/,
                        attr: "editrevision"
                    },
                    {
                        pattern: /^title\.text$/,
                        attr: "editrevision"
                    }
                ], tt = [
                    {
                        pattern: /^selectedpoints$/,
                        attr: "selectionrevision"
                    },
                    {
                        pattern: /(^|value\.)visible$/,
                        attr: "legend.uirevision"
                    },
                    {
                        pattern: /^dimensions\[\d+\]\.constraintrange/
                    },
                    {
                        pattern: /^node\.(x|y|groups)/
                    },
                    {
                        pattern: /^level$/
                    },
                    {
                        pattern: /(^|value\.)name$/
                    },
                    {
                        pattern: /colorbar\.title\.text$/
                    },
                    {
                        pattern: /colorbar\.(x|y)$/,
                        attr: "editrevision"
                    }
                ];
                function et(t1, e1) {
                    for(var r = 0; r < e1.length; r++){
                        var n = e1[r], i = t1.match(n.pattern);
                        if (i) {
                            var a = i[1] || "";
                            return {
                                head: a,
                                tail: t1.substr(a.length + 1),
                                attr: n.attr
                            };
                        }
                    }
                }
                function rt(t1, e1) {
                    var r = s(e1, t1).get();
                    if (void 0 !== r) return r;
                    var n = t1.split(".");
                    for(n.pop(); n.length > 1;)if (n.pop(), void 0 !== (r = s(e1, n.join(".") + ".uirevision").get())) return r;
                    return e1.uirevision;
                }
                function nt(t1, e1) {
                    for(var r = 0; r < e1.length; r++)if (e1[r]._fullInput.uid === t1) return r;
                    return -1;
                }
                function it(t1, e1, r) {
                    for(var n = 0; n < e1.length; n++)if (e1[n].uid === t1) return n;
                    return !e1[r] || e1[r].uid ? -1 : r;
                }
                function at(t1, e1) {
                    var r = o.isPlainObject(t1), n = Array.isArray(t1);
                    return r || n ? (r && o.isPlainObject(e1) || n && Array.isArray(e1)) && JSON.stringify(t1) === JSON.stringify(e1) : t1 === e1;
                }
                function ot(t1, e1, r, n) {
                    var i, a, l, c = n.getValObject, u = n.flags, h = n.immutable, f = n.inArray, p = n.arrayIndex;
                    function d() {
                        var t1 = i.editType;
                        f && -1 !== t1.indexOf("arraydraw") ? o.pushUnique(u.arrays[f], p) : (A.update(u, i), "none" !== t1 && u.nChanges++, n.transition && i.anim && u.nChangesAnim++, (Z.test(l) || W.test(l)) && (u.rangesAltered[r[0]] = 1), Y.test(l) && s(e1, "_inputDomain").set(null), "datarevision" === a && (u.newDataRevision = 1));
                    }
                    function m(t1) {
                        return "data_array" === t1.valType || t1.arrayOk;
                    }
                    for(a in t1){
                        if (u.calc && !n.transition) return;
                        var g = t1[a], y = e1[a], v = r.concat(a);
                        if (l = v.join("."), "_" !== a.charAt(0) && "function" != typeof g && g !== y) {
                            if (("tick0" === a || "dtick" === a) && "geo" !== r[0]) {
                                var x = e1.tickmode;
                                if ("auto" === x || "array" === x || !x) continue;
                            }
                            if (("range" !== a || !e1.autorange) && ("zmin" !== a && "zmax" !== a || "contourcarpet" !== e1.type) && (i = c(v)) && (!i._compareAsJSON || JSON.stringify(g) !== JSON.stringify(y))) {
                                var _, b = i.valType, w = m(i), T = Array.isArray(g), k = Array.isArray(y);
                                if (T && k) {
                                    var M = "_input_" + a, S = t1[M], E = e1[M];
                                    if (Array.isArray(S) && S === E) continue;
                                }
                                if (void 0 === y) w && T ? u.calc = !0 : d();
                                else if (i._isLinkedToArray) {
                                    var C = [], L = !1;
                                    f || (u.arrays[a] = C);
                                    var I = Math.min(g.length, y.length), P = Math.max(g.length, y.length);
                                    if (I !== P) {
                                        if ("arraydraw" !== i.editType) {
                                            d();
                                            continue;
                                        }
                                        L = !0;
                                    }
                                    for(_ = 0; _ < I; _++)ot(g[_], y[_], v.concat(_), o.extendFlat({
                                        inArray: a,
                                        arrayIndex: _
                                    }, n));
                                    if (L) for(_ = I; _ < P; _++)C.push(_);
                                } else !b && o.isPlainObject(g) ? ot(g, y, v, n) : w ? T && k ? (h && (u.calc = !0), (h || n.newDataRevision) && d()) : T !== k ? u.calc = !0 : d() : T && k && g.length === y.length && String(g) === String(y) || d();
                            }
                        }
                    }
                    for(a in e1)if (!(a in t1) && "_" !== a.charAt(0) && "function" != typeof e1[a]) {
                        if (m(i = c(r.concat(a))) && Array.isArray(e1[a])) return void (u.calc = !0);
                        d();
                    }
                }
                function st(t1, e1) {
                    var r;
                    for(r in t1)if ("_" !== r.charAt(0)) {
                        var n = t1[r], i = e1[r];
                        if (n !== i) {
                            if (o.isPlainObject(n) && o.isPlainObject(i)) {
                                if (st(n, i)) return !0;
                            } else {
                                if (!Array.isArray(n) || !Array.isArray(i)) return !0;
                                if (n.length !== i.length) return !0;
                                for(var a = 0; a < n.length; a++)if (n[a] !== i[a]) {
                                    if (!o.isPlainObject(n[a]) || !o.isPlainObject(i[a])) return !0;
                                    if (st(n[a], i[a])) return !0;
                                }
                            }
                        }
                    }
                }
                function lt(t1) {
                    var e1 = t1._fullLayout, r = t1.getBoundingClientRect();
                    if (!o.equalDomRects(r, e1._lastBBox)) {
                        var n = e1._invTransform = o.inverseTransformMatrix(o.getFullTransformMatrix(t1));
                        e1._invScaleX = Math.sqrt(n[0][0] * n[0][0] + n[0][1] * n[0][1] + n[0][2] * n[0][2]), e1._invScaleY = Math.sqrt(n[1][0] * n[1][0] + n[1][1] * n[1][1] + n[1][2] * n[1][2]), e1._lastBBox = r;
                    }
                }
                e1.animate = function(t1, e1, r) {
                    if (t1 = o.getGraphDiv(t1), !o.isPlotDiv(t1)) throw new Error("This element is not a Plotly plot: " + t1 + ". It's likely that you've failed to create a plot before animating it. For more details, see https://plotly.com/javascript/animations/");
                    var n = t1._transitionData;
                    n._frameQueue || (n._frameQueue = []);
                    var i = (r = f.supplyAnimationDefaults(r)).transition, a = r.frame;
                    function s(t1) {
                        return Array.isArray(i) ? t1 >= i.length ? i[0] : i[t1] : i;
                    }
                    function l(t1) {
                        return Array.isArray(a) ? t1 >= a.length ? a[0] : a[t1] : a;
                    }
                    function c(t1, e1) {
                        var r = 0;
                        return function() {
                            if (t1 && ++r === e1) return t1();
                        };
                    }
                    return void 0 === n._frameWaitingCnt && (n._frameWaitingCnt = 0), new Promise(function(a, u) {
                        function h() {
                            t1.emit("plotly_animating"), n._lastFrameAt = -1 / 0, n._timeToNext = 0, n._runningTransitions = 0, n._currentFrame = null;
                            var e1 = function() {
                                n._animationRaf = window.requestAnimationFrame(e1), Date.now() - n._lastFrameAt > n._timeToNext && function() {
                                    n._currentFrame && n._currentFrame.onComplete && n._currentFrame.onComplete();
                                    var e1 = n._currentFrame = n._frameQueue.shift();
                                    if (e1) {
                                        var r = e1.name ? e1.name.toString() : null;
                                        t1._fullLayout._currentFrame = r, n._lastFrameAt = Date.now(), n._timeToNext = e1.frameOpts.duration, f.transition(t1, e1.frame.data, e1.frame.layout, T.coerceTraceIndices(t1, e1.frame.traces), e1.frameOpts, e1.transitionOpts).then(function() {
                                            e1.onComplete && e1.onComplete();
                                        }), t1.emit("plotly_animatingframe", {
                                            name: r,
                                            frame: e1.frame,
                                            animation: {
                                                frame: e1.frameOpts,
                                                transition: e1.transitionOpts
                                            }
                                        });
                                    } else t1.emit("plotly_animated"), window.cancelAnimationFrame(n._animationRaf), n._animationRaf = null;
                                }();
                            };
                            e1();
                        }
                        var p, d, m = 0;
                        function g(t1) {
                            return Array.isArray(i) ? m >= i.length ? t1.transitionOpts = i[m] : t1.transitionOpts = i[0] : t1.transitionOpts = i, m++, t1;
                        }
                        var y = [], v = null == e1, x = Array.isArray(e1);
                        if (v || x || !o.isPlainObject(e1)) {
                            if (v || -1 !== [
                                "string",
                                "number"
                            ].indexOf(typeof e1)) for(p = 0; p < n._frames.length; p++)(d = n._frames[p]) && (v || String(d.group) === String(e1)) && y.push({
                                type: "byname",
                                name: String(d.name),
                                data: g({
                                    name: d.name
                                })
                            });
                            else if (x) for(p = 0; p < e1.length; p++){
                                var _ = e1[p];
                                -1 !== [
                                    "number",
                                    "string"
                                ].indexOf(typeof _) ? (_ = String(_), y.push({
                                    type: "byname",
                                    name: _,
                                    data: g({
                                        name: _
                                    })
                                })) : o.isPlainObject(_) && y.push({
                                    type: "object",
                                    data: g(o.extendFlat({}, _))
                                });
                            }
                        } else y.push({
                            type: "object",
                            data: g(o.extendFlat({}, e1))
                        });
                        for(p = 0; p < y.length; p++)if ("byname" === (d = y[p]).type && !n._frameHash[d.data.name]) return o.warn('animate failure: frame not found: "' + d.data.name + '"'), void u();
                        -1 !== [
                            "next",
                            "immediate"
                        ].indexOf(r.mode) && function() {
                            if (0 !== n._frameQueue.length) {
                                for(; n._frameQueue.length;){
                                    var e1 = n._frameQueue.pop();
                                    e1.onInterrupt && e1.onInterrupt();
                                }
                                t1.emit("plotly_animationinterrupted", []);
                            }
                        }(), "reverse" === r.direction && y.reverse();
                        var b = t1._fullLayout._currentFrame;
                        if (b && r.fromcurrent) {
                            var w = -1;
                            for(p = 0; p < y.length; p++)if ("byname" === (d = y[p]).type && d.name === b) {
                                w = p;
                                break;
                            }
                            if (w > 0 && w < y.length - 1) {
                                var k = [];
                                for(p = 0; p < y.length; p++)d = y[p], ("byname" !== y[p].type || p > w) && k.push(d);
                                y = k;
                            }
                        }
                        y.length > 0 ? function(e1) {
                            if (0 !== e1.length) {
                                for(var i = 0; i < e1.length; i++){
                                    var o;
                                    o = "byname" === e1[i].type ? f.computeFrame(t1, e1[i].name) : e1[i].data;
                                    var p = l(i), d = s(i);
                                    d.duration = Math.min(d.duration, p.duration);
                                    var m = {
                                        frame: o,
                                        name: e1[i].name,
                                        frameOpts: p,
                                        transitionOpts: d
                                    };
                                    i === e1.length - 1 && (m.onComplete = c(a, 2), m.onInterrupt = u), n._frameQueue.push(m);
                                }
                                "immediate" === r.mode && (n._lastFrameAt = -1 / 0), n._animationRaf || h();
                            }
                        }(y) : (t1.emit("plotly_animated"), a());
                    });
                }, e1.addFrames = function(t1, e1, r) {
                    if (t1 = o.getGraphDiv(t1), null == e1) return Promise.resolve();
                    if (!o.isPlotDiv(t1)) throw new Error("This element is not a Plotly plot: " + t1 + ". It's likely that you've failed to create a plot before adding frames. For more details, see https://plotly.com/javascript/animations/");
                    var n, i, a, s, l = t1._transitionData._frames, u = t1._transitionData._frameHash;
                    if (!Array.isArray(e1)) throw new Error("addFrames failure: frameList must be an Array of frame definitions" + e1);
                    var h = l.length + 2 * e1.length, p = [], d = {};
                    for(n = e1.length - 1; n >= 0; n--)if (o.isPlainObject(e1[n])) {
                        var m = e1[n].name, g = (u[m] || d[m] || {}).name, y = e1[n].name, v = u[g] || d[g];
                        g && y && "number" == typeof y && v && S < 5 && (S++, o.warn('addFrames: overwriting frame "' + (u[g] || d[g]).name + '" with a frame whose name of type "number" also equates to "' + g + '". This is valid but may potentially lead to unexpected behavior since all plotly.js frame names are stored internally as strings.'), 5 === S && o.warn("addFrames: This API call has yielded too many of these warnings. For the rest of this call, further warnings about numeric frame names will be suppressed.")), d[m] = {
                            name: m
                        }, p.push({
                            frame: f.supplyFrameDefaults(e1[n]),
                            index: r && void 0 !== r[n] && null !== r[n] ? r[n] : h + n
                        });
                    }
                    p.sort(function(t1, e1) {
                        return t1.index > e1.index ? -1 : t1.index < e1.index ? 1 : 0;
                    });
                    var x = [], _ = [], b = l.length;
                    for(n = p.length - 1; n >= 0; n--){
                        if ("number" == typeof (i = p[n].frame).name && o.warn("Warning: addFrames accepts frames with numeric names, but the numbers areimplicitly cast to strings"), !i.name) for(; u[i.name = "frame " + t1._transitionData._counter++];);
                        if (u[i.name]) {
                            for(a = 0; a < l.length && (l[a] || {}).name !== i.name; a++);
                            x.push({
                                type: "replace",
                                index: a,
                                value: i
                            }), _.unshift({
                                type: "replace",
                                index: a,
                                value: l[a]
                            });
                        } else s = Math.max(0, Math.min(p[n].index, b)), x.push({
                            type: "insert",
                            index: s,
                            value: i
                        }), _.unshift({
                            type: "delete",
                            index: s
                        }), b++;
                    }
                    var w = f.modifyFrames, T = f.modifyFrames, k = [
                        t1,
                        _
                    ], A = [
                        t1,
                        x
                    ];
                    return c && c.add(t1, w, k, T, A), f.modifyFrames(t1, x);
                }, e1.deleteFrames = function(t1, e1) {
                    if (t1 = o.getGraphDiv(t1), !o.isPlotDiv(t1)) throw new Error("This element is not a Plotly plot: " + t1);
                    var r, n, i = t1._transitionData._frames, a = [], s = [];
                    if (!e1) for(e1 = [], r = 0; r < i.length; r++)e1.push(r);
                    for((e1 = e1.slice()).sort(), r = e1.length - 1; r >= 0; r--)n = e1[r], a.push({
                        type: "delete",
                        index: n
                    }), s.unshift({
                        type: "insert",
                        index: n,
                        value: i[n]
                    });
                    var l = f.modifyFrames, u = f.modifyFrames, h = [
                        t1,
                        s
                    ], p = [
                        t1,
                        a
                    ];
                    return c && c.add(t1, l, h, u, p), f.modifyFrames(t1, a);
                }, e1.addTraces = function t1(r, n, i) {
                    r = o.getGraphDiv(r);
                    var a, s, l = [], u = e1.deleteTraces, h = t1, f = [
                        r,
                        l
                    ], p = [
                        r,
                        n
                    ];
                    for(function(t1, e1, r) {
                        var n, i;
                        if (!Array.isArray(t1.data)) throw new Error("gd.data must be an array.");
                        if (void 0 === e1) throw new Error("traces must be defined.");
                        for(Array.isArray(e1) || (e1 = [
                            e1
                        ]), n = 0; n < e1.length; n++)if ("object" != typeof (i = e1[n]) || Array.isArray(i) || null === i) throw new Error("all values in traces array must be non-array objects");
                        if (void 0 === r || Array.isArray(r) || (r = [
                            r
                        ]), void 0 !== r && r.length !== e1.length) throw new Error("if indices is specified, traces.length must equal indices.length");
                    }(r, n, i), Array.isArray(n) || (n = [
                        n
                    ]), n = n.map(function(t1) {
                        return o.extendFlat({}, t1);
                    }), T.cleanData(n), a = 0; a < n.length; a++)r.data.push(n[a]);
                    for(a = 0; a < n.length; a++)l.push(-n.length + a);
                    if (void 0 === i) return s = e1.redraw(r), c.add(r, u, f, h, p), s;
                    Array.isArray(i) || (i = [
                        i
                    ]);
                    try {
                        O(r, l, i);
                    } catch (t1) {
                        throw r.data.splice(r.data.length - n.length, n.length), t1;
                    }
                    return c.startSequence(r), c.add(r, u, f, h, p), s = e1.moveTraces(r, l, i), c.stopSequence(r), s;
                }, e1.deleteTraces = function t1(r, n) {
                    r = o.getGraphDiv(r);
                    var i, a, s = [], l = e1.addTraces, u = t1, h = [
                        r,
                        s,
                        n
                    ], f = [
                        r,
                        n
                    ];
                    if (void 0 === n) throw new Error("indices must be an integer or array of integers.");
                    for(Array.isArray(n) || (n = [
                        n
                    ]), z(r, n, "indices"), (n = P(n, r.data.length - 1)).sort(o.sorterDes), i = 0; i < n.length; i += 1)a = r.data.splice(n[i], 1)[0], s.push(a);
                    var p = e1.redraw(r);
                    return c.add(r, l, h, u, f), p;
                }, e1.extendTraces = function t1(r, n, i, a) {
                    var s = D(r = o.getGraphDiv(r), n, i, a, function(t1, e1, r) {
                        var n, i;
                        if (o.isTypedArray(t1)) {
                            if (r < 0) {
                                var a = new t1.constructor(0), s = R(t1, e1);
                                r < 0 ? (n = s, i = a) : (n = a, i = s);
                            } else if (n = new t1.constructor(r), i = new t1.constructor(t1.length + e1.length - r), r === e1.length) n.set(e1), i.set(t1);
                            else if (r < e1.length) {
                                var l = e1.length - r;
                                n.set(e1.subarray(l)), i.set(t1), i.set(e1.subarray(0, l), t1.length);
                            } else {
                                var c = r - e1.length, u = t1.length - c;
                                n.set(t1.subarray(u)), n.set(e1, c), i.set(t1.subarray(0, u));
                            }
                        } else n = t1.concat(e1), i = r >= 0 && r < n.length ? n.splice(0, n.length - r) : [];
                        return [
                            n,
                            i
                        ];
                    }), l = e1.redraw(r), u = [
                        r,
                        s.update,
                        i,
                        s.maxPoints
                    ];
                    return c.add(r, e1.prependTraces, u, t1, arguments), l;
                }, e1.moveTraces = function t1(r, n, i) {
                    var a, s = [], l = [], u = t1, h = t1, f = [
                        r = o.getGraphDiv(r),
                        i,
                        n
                    ], p = [
                        r,
                        n,
                        i
                    ];
                    if (O(r, n, i), n = Array.isArray(n) ? n : [
                        n
                    ], void 0 === i) for(i = [], a = 0; a < n.length; a++)i.push(-n.length + a);
                    for(i = Array.isArray(i) ? i : [
                        i
                    ], n = P(n, r.data.length - 1), i = P(i, r.data.length - 1), a = 0; a < r.data.length; a++)-1 === n.indexOf(a) && s.push(r.data[a]);
                    for(a = 0; a < n.length; a++)l.push({
                        newIndex: i[a],
                        trace: r.data[n[a]]
                    });
                    for(l.sort(function(t1, e1) {
                        return t1.newIndex - e1.newIndex;
                    }), a = 0; a < l.length; a += 1)s.splice(l[a].newIndex, 0, l[a].trace);
                    r.data = s;
                    var d = e1.redraw(r);
                    return c.add(r, u, f, h, p), d;
                }, e1.prependTraces = function t1(r, n, i, a) {
                    var s = D(r = o.getGraphDiv(r), n, i, a, function(t1, e1, r) {
                        var n, i;
                        if (o.isTypedArray(t1)) {
                            if (r <= 0) {
                                var a = new t1.constructor(0), s = R(e1, t1);
                                r < 0 ? (n = s, i = a) : (n = a, i = s);
                            } else if (n = new t1.constructor(r), i = new t1.constructor(t1.length + e1.length - r), r === e1.length) n.set(e1), i.set(t1);
                            else if (r < e1.length) {
                                var l = e1.length - r;
                                n.set(e1.subarray(0, l)), i.set(e1.subarray(l)), i.set(t1, l);
                            } else {
                                var c = r - e1.length;
                                n.set(e1), n.set(t1.subarray(0, c), e1.length), i.set(t1.subarray(c));
                            }
                        } else n = e1.concat(t1), i = r >= 0 && r < n.length ? n.splice(r, n.length) : [];
                        return [
                            n,
                            i
                        ];
                    }), l = e1.redraw(r), u = [
                        r,
                        s.update,
                        i,
                        s.maxPoints
                    ];
                    return c.add(r, e1.extendTraces, u, t1, arguments), l;
                }, e1.newPlot = function(t1, r, n, i) {
                    return t1 = o.getGraphDiv(t1), f.cleanPlot([], {}, t1._fullData || [], t1._fullLayout || {}), f.purge(t1), e1._doPlot(t1, r, n, i);
                }, e1._doPlot = function(t1, r, i, a) {
                    var s;
                    if (t1 = o.getGraphDiv(t1), l.init(t1), o.isPlainObject(r)) {
                        var c = r;
                        r = c.data, i = c.layout, a = c.config, s = c.frames;
                    }
                    if (!1 === l.triggerHandler(t1, "plotly_beforeplot", [
                        r,
                        i,
                        a
                    ])) return Promise.reject();
                    r || i || o.isPlotDiv(t1) || o.warn("Calling _doPlot as if redrawing but this container doesn't yet have a plot.", t1), I(t1, a), i || (i = {}), n.select(t1).classed("js-plotly-plot", !0), g.makeTester(), Array.isArray(t1._promises) || (t1._promises = []);
                    var h = 0 === (t1.data || []).length && Array.isArray(r);
                    Array.isArray(r) && (T.cleanData(r), h ? t1.data = r : t1.data.push.apply(t1.data, r), t1.empty = !1), t1.layout && !h || (t1.layout = T.cleanLayout(i)), f.supplyDefaults(t1);
                    var d = t1._fullLayout, m = d._has("cartesian");
                    d._replotting = !0, (h || d._shouldCreateBgLayer) && (function(t1) {
                        var e1 = n.select(t1), r = t1._fullLayout;
                        if (r._calcInverseTransform = lt, r._calcInverseTransform(t1), r._container = e1.selectAll(".plot-container").data([
                            0
                        ]), r._container.enter().insert("div", ":first-child").classed("plot-container", !0).classed("plotly", !0), r._paperdiv = r._container.selectAll(".svg-container").data([
                            0
                        ]), r._paperdiv.enter().append("div").classed("user-select-none", !0).classed("svg-container", !0).style("position", "relative"), r._glcontainer = r._paperdiv.selectAll(".gl-container").data([
                            {}
                        ]), r._glcontainer.enter().append("div").classed("gl-container", !0), r._paperdiv.selectAll(".main-svg").remove(), r._paperdiv.select(".modebar-container").remove(), r._paper = r._paperdiv.insert("svg", ":first-child").classed("main-svg", !0), r._toppaper = r._paperdiv.append("svg").classed("main-svg", !0), r._modebardiv = r._paperdiv.append("div"), delete r._modeBar, r._hoverpaper = r._paperdiv.append("svg").classed("main-svg", !0), !r._uid) {
                            var i = {};
                            n.selectAll("defs").each(function() {
                                this.id && (i[this.id.split("-")[1]] = 1);
                            }), r._uid = o.randstr(i);
                        }
                        r._paperdiv.selectAll(".main-svg").attr(x.svgAttrs), r._defs = r._paper.append("defs").attr("id", "defs-" + r._uid), r._clips = r._defs.append("g").classed("clips", !0), r._topdefs = r._toppaper.append("defs").attr("id", "topdefs-" + r._uid), r._topclips = r._topdefs.append("g").classed("clips", !0), r._bgLayer = r._paper.append("g").classed("bglayer", !0), r._draggers = r._paper.append("g").classed("draglayer", !0);
                        var a = r._paper.append("g").classed("layer-below", !0);
                        r._imageLowerLayer = a.append("g").classed("imagelayer", !0), r._shapeLowerLayer = a.append("g").classed("shapelayer", !0), r._cartesianlayer = r._paper.append("g").classed("cartesianlayer", !0), r._polarlayer = r._paper.append("g").classed("polarlayer", !0), r._smithlayer = r._paper.append("g").classed("smithlayer", !0), r._ternarylayer = r._paper.append("g").classed("ternarylayer", !0), r._geolayer = r._paper.append("g").classed("geolayer", !0), r._funnelarealayer = r._paper.append("g").classed("funnelarealayer", !0), r._pielayer = r._paper.append("g").classed("pielayer", !0), r._iciclelayer = r._paper.append("g").classed("iciclelayer", !0), r._treemaplayer = r._paper.append("g").classed("treemaplayer", !0), r._sunburstlayer = r._paper.append("g").classed("sunburstlayer", !0), r._indicatorlayer = r._toppaper.append("g").classed("indicatorlayer", !0), r._glimages = r._paper.append("g").classed("glimages", !0);
                        var s = r._toppaper.append("g").classed("layer-above", !0);
                        r._imageUpperLayer = s.append("g").classed("imagelayer", !0), r._shapeUpperLayer = s.append("g").classed("shapelayer", !0), r._selectionLayer = r._toppaper.append("g").classed("selectionlayer", !0), r._infolayer = r._toppaper.append("g").classed("infolayer", !0), r._menulayer = r._toppaper.append("g").classed("menulayer", !0), r._zoomlayer = r._toppaper.append("g").classed("zoomlayer", !0), r._hoverlayer = r._hoverpaper.append("g").classed("hoverlayer", !0), r._modebardiv.classed("modebar-container", !0).style("position", "absolute").style("top", "0px").style("right", "0px"), t1.emit("plotly_framework");
                    }(t1), d._shouldCreateBgLayer && delete d._shouldCreateBgLayer), g.initGradients(t1), g.initPatterns(t1), h && p.saveShowSpikeInitial(t1);
                    var y = !t1.calcdata || t1.calcdata.length !== (t1._fullData || []).length;
                    y && f.doCalcdata(t1);
                    for(var _ = 0; _ < t1.calcdata.length; _++)t1.calcdata[_][0].trace = t1._fullData[_];
                    t1._context.responsive ? t1._responsiveChartHandler || (t1._responsiveChartHandler = function() {
                        o.isHidden(t1) || f.resize(t1);
                    }, window.addEventListener("resize", t1._responsiveChartHandler)) : o.clearResponsive(t1);
                    var b = o.extendFlat({}, d._size), w = 0;
                    function A() {
                        if (f.clearAutoMarginIds(t1), k.drawMarginPushers(t1), p.allowAutoMargin(t1), t1._fullLayout.title.text && t1._fullLayout.title.automargin && f.allowAutoMargin(t1, "title.automargin"), d._has("pie")) for(var e1 = t1._fullData, r = 0; r < e1.length; r++){
                            var n = e1[r];
                            "pie" === n.type && n.automargin && f.allowAutoMargin(t1, "pie." + n.uid + ".automargin");
                        }
                        return f.doAutoMargin(t1), f.previousPromises(t1);
                    }
                    function M() {
                        t1._transitioning || (k.doAutoRangeAndConstraints(t1), h && p.saveRangeInitial(t1), u.getComponentMethod("rangeslider", "calcAutorange")(t1));
                    }
                    var S = [
                        f.previousPromises,
                        function() {
                            if (s) return e1.addFrames(t1, s);
                        },
                        function e1() {
                            for(var r = d._basePlotModules, n = 0; n < r.length; n++)r[n].drawFramework && r[n].drawFramework(t1);
                            !d._glcanvas && d._has("gl") && (d._glcanvas = d._glcontainer.selectAll(".gl-canvas").data([
                                {
                                    key: "contextLayer",
                                    context: !0,
                                    pick: !1
                                },
                                {
                                    key: "focusLayer",
                                    context: !1,
                                    pick: !1
                                },
                                {
                                    key: "pickLayer",
                                    context: !1,
                                    pick: !0
                                }
                            ], function(t1) {
                                return t1.key;
                            }), d._glcanvas.enter().append("canvas").attr("class", function(t1) {
                                return "gl-canvas gl-canvas-" + t1.key.replace("Layer", "");
                            }).style({
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible",
                                "pointer-events": "none"
                            }));
                            var i = t1._context.plotGlPixelRatio;
                            if (d._glcanvas) {
                                d._glcanvas.attr("width", d.width * i).attr("height", d.height * i).style("width", d.width + "px").style("height", d.height + "px");
                                var a = d._glcanvas.data()[0].regl;
                                if (a && (Math.floor(d.width * i) !== a._gl.drawingBufferWidth || Math.floor(d.height * i) !== a._gl.drawingBufferHeight)) {
                                    var s = "WebGL context buffer and canvas dimensions do not match due to browser/WebGL bug.";
                                    if (!w) return o.log(s + " Clearing graph and plotting again."), f.cleanPlot([], {}, t1._fullData, d), f.supplyDefaults(t1), d = t1._fullLayout, f.doCalcdata(t1), w++, e1();
                                    o.error(s);
                                }
                            }
                            return "h" === d.modebar.orientation ? d._modebardiv.style("height", null).style("width", "100%") : d._modebardiv.style("width", null).style("height", d.height + "px"), f.previousPromises(t1);
                        },
                        A,
                        function() {
                            if (f.didMarginChange(b, d._size)) return o.syncOrAsync([
                                A,
                                k.layoutStyles
                            ], t1);
                        }
                    ];
                    m && S.push(function() {
                        if (y) return o.syncOrAsync([
                            u.getComponentMethod("shapes", "calcAutorange"),
                            u.getComponentMethod("annotations", "calcAutorange"),
                            M
                        ], t1);
                        M();
                    }), S.push(k.layoutStyles), m && S.push(function() {
                        return p.draw(t1, h ? "" : "redraw");
                    }, function(t1) {
                        var e1 = t1._fullLayout._insideTickLabelsUpdaterange;
                        if (e1) return t1._fullLayout._insideTickLabelsUpdaterange = void 0, q(t1, e1).then(function() {
                            p.saveRangeInitial(t1, !0);
                        });
                    }), S.push(k.drawData, k.finalDraw, v, f.addLinks, f.rehover, f.redrag, f.reselect, f.doAutoMargin, f.previousPromises);
                    var C = o.syncOrAsync(S, t1);
                    return C && C.then || (C = Promise.resolve()), C.then(function() {
                        return E(t1), t1;
                    });
                }, e1.purge = function(t1) {
                    var e1 = (t1 = o.getGraphDiv(t1))._fullLayout || {}, r = t1._fullData || [];
                    return f.cleanPlot([], {}, r, e1), f.purge(t1), l.purge(t1), e1._container && e1._container.remove(), delete t1._context, t1;
                }, e1.react = function(t1, r, n, i) {
                    var a, l;
                    t1 = o.getGraphDiv(t1), T.clearPromiseQueue(t1);
                    var c = t1._fullData, p = t1._fullLayout;
                    if (o.isPlotDiv(t1) && c && p) {
                        if (o.isPlainObject(r)) {
                            var d = r;
                            r = d.data, n = d.layout, i = d.config, a = d.frames;
                        }
                        var m = !1;
                        if (i) {
                            var g = o.extendDeep({}, t1._context);
                            t1._context = void 0, I(t1, i), m = st(g, t1._context);
                        }
                        t1.data = r || [], T.cleanData(t1.data), t1.layout = n || {}, T.cleanLayout(t1.layout), function(t1, e1, r, n) {
                            var i, a, l, c, u, h, f, p, d, m, g = n._preGUI, y = [], v = {}, x = {};
                            for(i in g){
                                if (u = et(i, Q)) {
                                    if (d = u.head, m = u.tail, a = u.attr || d + ".uirevision", (c = (l = s(n, a).get()) && rt(a, e1)) && c === l) {
                                        if (null === (h = g[i]) && (h = void 0), at(p = (f = s(e1, i)).get(), h)) {
                                            void 0 === p && "autorange" === m && y.push(d), f.set(B(s(n, i).get()));
                                            continue;
                                        }
                                        if ("autorange" === m || "range[" === m.substr(0, 6)) {
                                            var _ = g[d + ".range[0]"], b = g[d + ".range[1]"], w = g[d + ".autorange"];
                                            if (w || null === w && null === _ && null === b) {
                                                if (!(d in v)) {
                                                    var T = s(e1, d).get();
                                                    v[d] = T && (T.autorange || !1 !== T.autorange && (!T.range || 2 !== T.range.length));
                                                }
                                                if (v[d]) {
                                                    f.set(B(s(n, i).get()));
                                                    continue;
                                                }
                                            }
                                        }
                                    }
                                } else o.warn("unrecognized GUI edit: " + i);
                                delete g[i], u && "range[" === u.tail.substr(0, 6) && (x[u.head] = 1);
                            }
                            for(var k = 0; k < y.length; k++){
                                var A = y[k];
                                if (x[A]) {
                                    var M = s(e1, A).get();
                                    M && delete M.autorange;
                                }
                            }
                            var S = n._tracePreGUI;
                            for(var E in S){
                                var C, L = S[E], I = null;
                                for(i in L){
                                    if (!I) {
                                        var P = nt(E, r);
                                        if (P < 0) {
                                            delete S[E];
                                            break;
                                        }
                                        var z = it(E, t1, (C = r[P]._fullInput).index);
                                        if (z < 0) {
                                            delete S[E];
                                            break;
                                        }
                                        I = t1[z];
                                    }
                                    if (u = et(i, tt)) {
                                        if (u.attr ? c = (l = s(n, u.attr).get()) && rt(u.attr, e1) : (l = C.uirevision, void 0 === (c = I.uirevision) && (c = e1.uirevision)), c && c === l && (null === (h = L[i]) && (h = void 0), at(p = (f = s(I, i)).get(), h))) {
                                            f.set(B(s(C, i).get()));
                                            continue;
                                        }
                                    } else o.warn("unrecognized GUI edit: " + i + " in trace uid " + E);
                                    delete L[i];
                                }
                            }
                        }(t1.data, t1.layout, c, p), f.supplyDefaults(t1, {
                            skipUpdateCalc: !0
                        });
                        var y = t1._fullData, v = t1._fullLayout, x = void 0 === v.datarevision, _ = v.transition, b = function(t1, e1, r, n, i) {
                            var a = A.layoutFlags();
                            return a.arrays = {}, a.rangesAltered = {}, a.nChanges = 0, a.nChangesAnim = 0, ot(e1, r, [], {
                                getValObject: function(t1) {
                                    return h.getLayoutValObject(r, t1);
                                },
                                flags: a,
                                immutable: n,
                                transition: i,
                                gd: t1
                            }), (a.plot || a.calc) && (a.layoutReplot = !0), i && a.nChanges && a.nChangesAnim && (a.anim = a.nChanges === a.nChangesAnim ? "all" : "some"), a;
                        }(t1, p, v, x, _), w = b.newDataRevision, M = function(t1, e1, r, n, i, a) {
                            var o = e1.length === r.length;
                            if (!i && !o) return {
                                fullReplot: !0,
                                calc: !0
                            };
                            var s, l, c = A.traceFlags();
                            c.arrays = {}, c.nChanges = 0, c.nChangesAnim = 0;
                            var u = {
                                getValObject: function(t1) {
                                    var e1 = h.getTraceValObject(l, t1);
                                    return !l._module.animatable && e1.anim && (e1.anim = !1), e1;
                                },
                                flags: c,
                                immutable: n,
                                transition: i,
                                newDataRevision: a,
                                gd: t1
                            }, p = {};
                            for(s = 0; s < e1.length; s++)if (r[s]) {
                                if (l = r[s]._fullInput, f.hasMakesDataTransform(l) && (l = r[s]), p[l.uid]) continue;
                                p[l.uid] = 1, ot(e1[s]._fullInput, l, [], u);
                            }
                            return (c.calc || c.plot) && (c.fullReplot = !0), i && c.nChanges && c.nChangesAnim && (c.anim = c.nChanges === c.nChangesAnim && o ? "all" : "some"), c;
                        }(t1, c, y, x, _, w);
                        if ($(t1) && (b.layoutReplot = !0), M.calc || b.calc) {
                            t1.calcdata = void 0;
                            for(var S = Object.getOwnPropertyNames(v), C = 0; C < S.length; C++){
                                var L = S[C], P = L.substring(0, 5);
                                if ("xaxis" === P || "yaxis" === P) {
                                    var z = v[L]._emptyCategories;
                                    z && z();
                                }
                            }
                        } else f.supplyDefaultsUpdateCalc(t1.calcdata, y);
                        var O = [];
                        if (a && (t1._transitionData = {}, f.createTransitionData(t1), O.push(function() {
                            return e1.addFrames(t1, a);
                        })), v.transition && !m && (M.anim || b.anim)) b.ticks && O.push(k.doTicksRelayout), f.doCalcdata(t1), k.doAutoRangeAndConstraints(t1), O.push(function() {
                            return f.transitionFromReact(t1, M, b, p);
                        });
                        else if (M.fullReplot || b.layoutReplot || m) t1._fullLayout._skipDefaults = !0, O.push(e1._doPlot);
                        else {
                            for(var D in b.arrays){
                                var R = b.arrays[D];
                                if (R.length) {
                                    var F = u.getComponentMethod(D, "drawOne");
                                    if (F !== o.noop) for(var N = 0; N < R.length; N++)F(t1, R[N]);
                                    else {
                                        var j = u.getComponentMethod(D, "draw");
                                        if (j === o.noop) throw new Error("cannot draw components: " + D);
                                        j(t1);
                                    }
                                }
                            }
                            O.push(f.previousPromises), M.style && O.push(k.doTraceStyle), (M.colorbars || b.colorbars) && O.push(k.doColorBars), b.legend && O.push(k.doLegend), b.layoutstyle && O.push(k.layoutStyles), b.axrange && G(O), b.ticks && O.push(k.doTicksRelayout), b.modebar && O.push(k.doModeBar), b.camera && O.push(k.doCamera), O.push(E);
                        }
                        O.push(f.rehover, f.redrag, f.reselect), (l = o.syncOrAsync(O, t1)) && l.then || (l = Promise.resolve(t1));
                    } else l = e1.newPlot(t1, r, n, i);
                    return l.then(function() {
                        return t1.emit("plotly_react", {
                            data: r,
                            layout: n
                        }), t1;
                    });
                }, e1.redraw = function(t1) {
                    if (t1 = o.getGraphDiv(t1), !o.isPlotDiv(t1)) throw new Error("This element is not a Plotly plot: " + t1);
                    return T.cleanData(t1.data), T.cleanLayout(t1.layout), t1.calcdata = void 0, e1._doPlot(t1).then(function() {
                        return t1.emit("plotly_redraw"), t1;
                    });
                }, e1.relayout = q, e1.restyle = F, e1.setPlotConfig = function(t1) {
                    return o.extendFlat(b, t1);
                }, e1.update = J, e1._guiRelayout = K(q), e1._guiRestyle = K(F), e1._guiUpdate = K(J), e1._storeDirectGUIEdit = function(t1, e1, r) {
                    for(var n in r)j(n, s(t1, n).get(), r[n], e1);
                };
            },
            24452: function(t1) {
                "use strict";
                var e1 = {
                    staticPlot: {
                        valType: "boolean",
                        dflt: !1
                    },
                    typesetMath: {
                        valType: "boolean",
                        dflt: !0
                    },
                    plotlyServerURL: {
                        valType: "string",
                        dflt: ""
                    },
                    editable: {
                        valType: "boolean",
                        dflt: !1
                    },
                    edits: {
                        annotationPosition: {
                            valType: "boolean",
                            dflt: !1
                        },
                        annotationTail: {
                            valType: "boolean",
                            dflt: !1
                        },
                        annotationText: {
                            valType: "boolean",
                            dflt: !1
                        },
                        axisTitleText: {
                            valType: "boolean",
                            dflt: !1
                        },
                        colorbarPosition: {
                            valType: "boolean",
                            dflt: !1
                        },
                        colorbarTitleText: {
                            valType: "boolean",
                            dflt: !1
                        },
                        legendPosition: {
                            valType: "boolean",
                            dflt: !1
                        },
                        legendText: {
                            valType: "boolean",
                            dflt: !1
                        },
                        shapePosition: {
                            valType: "boolean",
                            dflt: !1
                        },
                        titleText: {
                            valType: "boolean",
                            dflt: !1
                        }
                    },
                    editSelection: {
                        valType: "boolean",
                        dflt: !0
                    },
                    autosizable: {
                        valType: "boolean",
                        dflt: !1
                    },
                    responsive: {
                        valType: "boolean",
                        dflt: !1
                    },
                    fillFrame: {
                        valType: "boolean",
                        dflt: !1
                    },
                    frameMargins: {
                        valType: "number",
                        dflt: 0,
                        min: 0,
                        max: .5
                    },
                    scrollZoom: {
                        valType: "flaglist",
                        flags: [
                            "cartesian",
                            "gl3d",
                            "geo",
                            "mapbox",
                            "map"
                        ],
                        extras: [
                            !0,
                            !1
                        ],
                        dflt: "gl3d+geo+map"
                    },
                    doubleClick: {
                        valType: "enumerated",
                        values: [
                            !1,
                            "reset",
                            "autosize",
                            "reset+autosize"
                        ],
                        dflt: "reset+autosize"
                    },
                    doubleClickDelay: {
                        valType: "number",
                        dflt: 300,
                        min: 0
                    },
                    showAxisDragHandles: {
                        valType: "boolean",
                        dflt: !0
                    },
                    showAxisRangeEntryBoxes: {
                        valType: "boolean",
                        dflt: !0
                    },
                    showTips: {
                        valType: "boolean",
                        dflt: !0
                    },
                    showLink: {
                        valType: "boolean",
                        dflt: !1
                    },
                    linkText: {
                        valType: "string",
                        dflt: "Edit chart",
                        noBlank: !0
                    },
                    sendData: {
                        valType: "boolean",
                        dflt: !0
                    },
                    showSources: {
                        valType: "any",
                        dflt: !1
                    },
                    displayModeBar: {
                        valType: "enumerated",
                        values: [
                            "hover",
                            !0,
                            !1
                        ],
                        dflt: "hover"
                    },
                    showSendToCloud: {
                        valType: "boolean",
                        dflt: !1
                    },
                    showEditInChartStudio: {
                        valType: "boolean",
                        dflt: !1
                    },
                    modeBarButtonsToRemove: {
                        valType: "any",
                        dflt: []
                    },
                    modeBarButtonsToAdd: {
                        valType: "any",
                        dflt: []
                    },
                    modeBarButtons: {
                        valType: "any",
                        dflt: !1
                    },
                    toImageButtonOptions: {
                        valType: "any",
                        dflt: {}
                    },
                    displaylogo: {
                        valType: "boolean",
                        dflt: !0
                    },
                    watermark: {
                        valType: "boolean",
                        dflt: !1
                    },
                    plotGlPixelRatio: {
                        valType: "number",
                        dflt: 2,
                        min: 1,
                        max: 4
                    },
                    setBackground: {
                        valType: "any",
                        dflt: "transparent"
                    },
                    topojsonURL: {
                        valType: "string",
                        noBlank: !0,
                        dflt: "https://cdn.plot.ly/"
                    },
                    mapboxAccessToken: {
                        valType: "string",
                        dflt: null
                    },
                    logging: {
                        valType: "integer",
                        min: 0,
                        max: 2,
                        dflt: 1
                    },
                    notifyOnLogging: {
                        valType: "integer",
                        min: 0,
                        max: 2,
                        dflt: 0
                    },
                    queueLength: {
                        valType: "integer",
                        min: 0,
                        dflt: 0
                    },
                    globalTransforms: {
                        valType: "any",
                        dflt: []
                    },
                    locale: {
                        valType: "string",
                        dflt: "en-US"
                    },
                    locales: {
                        valType: "any",
                        dflt: {}
                    }
                }, r = {};
                !function t1(e1, r) {
                    for(var n in e1){
                        var i = e1[n];
                        i.valType ? r[n] = i.dflt : (r[n] || (r[n] = {}), t1(i, r[n]));
                    }
                }(e1, r), t1.exports = {
                    configAttributes: e1,
                    dfltConfig: r
                };
            },
            57297: function(t1, e1, r) {
                "use strict";
                var n = r(33626), i = r(34809), a = r(9829), o = r(6704), s = r(58935), l = r(49722), c = r(24452).configAttributes, u = r(13582), h = i.extendDeepAll, f = i.isPlainObject, p = i.isArrayOrTypedArray, d = i.nestedProperty, m = i.valObjectMeta, g = "_isSubplotObj", y = "_isLinkedToArray", v = "_deprecated", x = [
                    g,
                    y,
                    "_arrayAttrRegexps",
                    v
                ];
                function _(t1, e1, r) {
                    if (!t1) return !1;
                    if (t1._isLinkedToArray) {
                        if (b(e1[r])) r++;
                        else if (r < e1.length) return !1;
                    }
                    for(; r < e1.length; r++){
                        var n = t1[e1[r]];
                        if (!f(n)) break;
                        if (t1 = n, r === e1.length - 1) break;
                        if (t1._isLinkedToArray) {
                            if (!b(e1[++r])) return !1;
                        } else if ("info_array" === t1.valType) {
                            var i = e1[++r];
                            if (!b(i)) return !1;
                            var a = t1.items;
                            if (Array.isArray(a)) {
                                if (i >= a.length) return !1;
                                if (2 === t1.dimensions) {
                                    if (r++, e1.length === r) return t1;
                                    var o = e1[r];
                                    if (!b(o)) return !1;
                                    t1 = a[i][o];
                                } else t1 = a[i];
                            } else t1 = a;
                        }
                    }
                    return t1;
                }
                function b(t1) {
                    return t1 === Math.round(t1) && t1 >= 0;
                }
                function w() {
                    var t1, e1, r = {};
                    for(t1 in h(r, o), n.subplotsRegistry)if ((e1 = n.subplotsRegistry[t1]).layoutAttributes) {
                        if (Array.isArray(e1.attr)) for(var i = 0; i < e1.attr.length; i++)k(r, e1, e1.attr[i]);
                        else k(r, e1, "subplot" === e1.attr ? e1.name : e1.attr);
                    }
                    for(t1 in n.componentsRegistry){
                        var a = (e1 = n.componentsRegistry[t1]).schema;
                        if (a && (a.subplots || a.layout)) {
                            var s = a.subplots;
                            if (s && s.xaxis && !s.yaxis) for(var l in s.xaxis)delete r.yaxis[l];
                            delete r.xaxis.shift, delete r.xaxis.autoshift;
                        } else "colorscale" === e1.name ? h(r, e1.layoutAttributes) : e1.layoutAttributes && A(r, e1.layoutAttributes, e1.name);
                    }
                    return {
                        layoutAttributes: T(r)
                    };
                }
                function T(t1) {
                    return function(t1) {
                        e1.crawl(t1, function(t1, r, n) {
                            e1.isValObject(t1) ? !0 !== t1.arrayOk && "data_array" !== t1.valType || (n[r + "src"] = {
                                valType: "string",
                                editType: "none"
                            }) : f(t1) && (t1.role = "object");
                        });
                    }(t1), function(t1) {
                        e1.crawl(t1, function(t1, e1, r) {
                            if (t1) {
                                var n = t1[y];
                                n && (delete t1[y], r[e1] = {
                                    items: {}
                                }, r[e1].items[n] = t1, r[e1].role = "object");
                            }
                        });
                    }(t1), function(t1) {
                        !function t1(e1) {
                            for(var r in e1)if (f(e1[r])) t1(e1[r]);
                            else if (Array.isArray(e1[r])) for(var n = 0; n < e1[r].length; n++)t1(e1[r][n]);
                            else e1[r] instanceof RegExp && (e1[r] = e1[r].toString());
                        }(t1);
                    }(t1), t1;
                }
                function k(t1, e1, r) {
                    var n = d(t1, r), i = h({}, e1.layoutAttributes);
                    i[g] = !0, n.set(i);
                }
                function A(t1, e1, r) {
                    var n = d(t1, r);
                    n.set(h(n.get() || {}, e1));
                }
                e1.IS_SUBPLOT_OBJ = g, e1.IS_LINKED_TO_ARRAY = y, e1.DEPRECATED = v, e1.UNDERSCORE_ATTRS = x, e1.get = function() {
                    var t1 = {};
                    n.allTypes.forEach(function(r) {
                        t1[r] = function(t1) {
                            var r, i;
                            i = (r = n.modules[t1]._module).basePlotModule;
                            var o = {
                                type: null
                            }, s = h({}, a), l = h({}, r.attributes);
                            e1.crawl(l, function(t1, e1, r, n, i) {
                                d(s, i).set(void 0), void 0 === t1 && d(l, i).set(void 0);
                            }), h(o, s), n.traceIs(t1, "noOpacity") && delete o.opacity, n.traceIs(t1, "showLegend") || (delete o.showlegend, delete o.legendgroup), n.traceIs(t1, "noHover") && (delete o.hoverinfo, delete o.hoverlabel), r.selectPoints || delete o.selectedpoints, h(o, l), i.attributes && h(o, i.attributes), o.type = t1;
                            var c = {
                                meta: r.meta || {},
                                categories: r.categories || {},
                                animatable: Boolean(r.animatable),
                                type: t1,
                                attributes: T(o)
                            };
                            if (r.layoutAttributes) {
                                var u = {};
                                h(u, r.layoutAttributes), c.layoutAttributes = T(u);
                            }
                            return r.animatable || e1.crawl(c, function(t1) {
                                e1.isValObject(t1) && "anim" in t1 && delete t1.anim;
                            }), c;
                        }(r);
                    });
                    var r, i = {};
                    return Object.keys(n.transformsRegistry).forEach(function(t1) {
                        i[t1] = function(t1) {
                            var e1 = n.transformsRegistry[t1], r = h({}, e1.attributes);
                            return Object.keys(n.componentsRegistry).forEach(function(e1) {
                                var i = n.componentsRegistry[e1];
                                i.schema && i.schema.transforms && i.schema.transforms[t1] && Object.keys(i.schema.transforms[t1]).forEach(function(e1) {
                                    A(r, i.schema.transforms[t1][e1], e1);
                                });
                            }), {
                                attributes: T(r)
                            };
                        }(t1);
                    }), {
                        defs: {
                            valObjects: m,
                            metaKeys: x.concat([
                                "description",
                                "role",
                                "editType",
                                "impliedEdits"
                            ]),
                            editType: {
                                traces: u.traces,
                                layout: u.layout
                            },
                            impliedEdits: {}
                        },
                        traces: t1,
                        layout: w(),
                        transforms: i,
                        frames: (r = {
                            frames: h({}, s)
                        }, T(r), r.frames),
                        animation: T(l),
                        config: T(c)
                    };
                }, e1.crawl = function(t1, r, n, i) {
                    var a = n || 0;
                    i = i || "", Object.keys(t1).forEach(function(n) {
                        var o = t1[n];
                        if (-1 === x.indexOf(n)) {
                            var s = (i ? i + "." : "") + n;
                            r(o, n, t1, a, s), e1.isValObject(o) || f(o) && "impliedEdits" !== n && e1.crawl(o, r, a + 1, s);
                        }
                    });
                }, e1.isValObject = function(t1) {
                    return t1 && void 0 !== t1.valType;
                }, e1.findArrayAttributes = function(t1) {
                    var r, n, i = [], o = [], s = [];
                    function l(t1, e1, n, i) {
                        o = o.slice(0, i).concat([
                            e1
                        ]), s = s.slice(0, i).concat([
                            t1 && t1._isLinkedToArray
                        ]), t1 && ("data_array" === t1.valType || !0 === t1.arrayOk) && ("colorbar" !== o[i - 1] || "ticktext" !== e1 && "tickvals" !== e1) && c(r, 0, "");
                    }
                    function c(t1, e1, r) {
                        var a = t1[o[e1]], l = r + o[e1];
                        if (e1 === o.length - 1) p(a) && i.push(n + l);
                        else if (s[e1]) {
                            if (Array.isArray(a)) for(var u = 0; u < a.length; u++)f(a[u]) && c(a[u], e1 + 1, l + "[" + u + "].");
                        } else f(a) && c(a, e1 + 1, l + ".");
                    }
                    r = t1, n = "", e1.crawl(a, l), t1._module && t1._module.attributes && e1.crawl(t1._module.attributes, l);
                    var u = t1.transforms;
                    if (u) for(var h = 0; h < u.length; h++){
                        var d = u[h], m = d._module;
                        m && (n = "transforms[" + h + "].", r = d, e1.crawl(m.attributes, l));
                    }
                    return i;
                }, e1.getTraceValObject = function(t1, e1) {
                    var r, i, o = e1[0], s = 1;
                    if ("transforms" === o) {
                        if (1 === e1.length) return a.transforms;
                        var l = t1.transforms;
                        if (!Array.isArray(l) || !l.length) return !1;
                        var c = e1[1];
                        if (!b(c) || c >= l.length) return !1;
                        i = (r = (n.transformsRegistry[l[c].type] || {}).attributes) && r[e1[2]], s = 3;
                    } else {
                        var u = t1._module;
                        if (u || (u = (n.modules[t1.type || a.type.dflt] || {})._module), !u) return !1;
                        if (!(i = (r = u.attributes) && r[o])) {
                            var h = u.basePlotModule;
                            h && h.attributes && (i = h.attributes[o]);
                        }
                        i || (i = a[o]);
                    }
                    return _(i, e1, s);
                }, e1.getLayoutValObject = function(t1, e1) {
                    var r = function(t1, e1) {
                        var r, i, a, s, l = t1._basePlotModules;
                        if (l) {
                            var c;
                            for(r = 0; r < l.length; r++){
                                if ((a = l[r]).attrRegex && a.attrRegex.test(e1)) {
                                    if (a.layoutAttrOverrides) return a.layoutAttrOverrides;
                                    !c && a.layoutAttributes && (c = a.layoutAttributes);
                                }
                                var u = a.baseLayoutAttrOverrides;
                                if (u && e1 in u) return u[e1];
                            }
                            if (c) return c;
                        }
                        var h = t1._modules;
                        if (h) {
                            for(r = 0; r < h.length; r++)if ((s = h[r].layoutAttributes) && e1 in s) return s[e1];
                        }
                        for(i in n.componentsRegistry){
                            if ("colorscale" === (a = n.componentsRegistry[i]).name && 0 === e1.indexOf("coloraxis")) return a.layoutAttributes[e1];
                            if (!a.schema && e1 === a.name) return a.layoutAttributes;
                        }
                        return e1 in o && o[e1];
                    }(t1, e1[0]);
                    return _(r, e1, 1);
                };
            },
            78032: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(9829), a = "templateitemname", o = {
                    name: {
                        valType: "string",
                        editType: "none"
                    }
                };
                function s(t1) {
                    return t1 && "string" == typeof t1;
                }
                function l(t1) {
                    var e1 = t1.length - 1;
                    return "s" !== t1.charAt(e1) && n.warn("bad argument to arrayDefaultKey: " + t1), t1.substr(0, t1.length - 1) + "defaults";
                }
                o[a] = {
                    valType: "string",
                    editType: "calc"
                }, e1.templatedArray = function(t1, e1) {
                    return e1._isLinkedToArray = t1, e1.name = o.name, e1[a] = o[a], e1;
                }, e1.traceTemplater = function(t1) {
                    var e1, r, a = {};
                    for(e1 in t1)r = t1[e1], Array.isArray(r) && r.length && (a[e1] = 0);
                    return {
                        newTrace: function(o) {
                            var s = {
                                type: e1 = n.coerce(o, {}, i, "type"),
                                _template: null
                            };
                            if (e1 in a) {
                                r = t1[e1];
                                var l = a[e1] % r.length;
                                a[e1]++, s._template = r[l];
                            }
                            return s;
                        }
                    };
                }, e1.newContainer = function(t1, e1, r) {
                    var i = t1._template, a = i && (i[e1] || r && i[r]);
                    return n.isPlainObject(a) || (a = null), t1[e1] = {
                        _template: a
                    };
                }, e1.arrayTemplater = function(t1, e1, r) {
                    var n = t1._template, i = n && n[l(e1)], o = n && n[e1];
                    Array.isArray(o) && o.length || (o = []);
                    var c = {};
                    return {
                        newItem: function(t1) {
                            var e1 = {
                                name: t1.name,
                                _input: t1
                            }, n = e1[a] = t1[a];
                            if (!s(n)) return e1._template = i, e1;
                            for(var l = 0; l < o.length; l++){
                                var u = o[l];
                                if (u.name === n) return c[n] = 1, e1._template = u, e1;
                            }
                            return e1[r] = t1[r] || !1, e1._template = !1, e1;
                        },
                        defaultItems: function() {
                            for(var t1 = [], e1 = 0; e1 < o.length; e1++){
                                var r = o[e1], n = r.name;
                                if (s(n) && !c[n]) {
                                    var i = {
                                        _template: r,
                                        name: n,
                                        _input: {
                                            _templateitemname: n
                                        }
                                    };
                                    i[a] = r[a], t1.push(i), c[n] = 1;
                                }
                            }
                            return t1;
                        }
                    };
                }, e1.arrayDefaultKey = l, e1.arrayEditor = function(t1, e1, r) {
                    var i = (n.nestedProperty(t1, e1).get() || []).length, o = r._index, s = o >= i && (r._input || {})._templateitemname;
                    s && (o = i);
                    var l, c = e1 + "[" + o + "]";
                    function u() {
                        l = {}, s && (l[c] = {}, l[c][a] = s);
                    }
                    function h(t1, e1) {
                        s ? n.nestedProperty(l[c], t1).set(e1) : l[c + "." + t1] = e1;
                    }
                    function f() {
                        var t1 = l;
                        return u(), t1;
                    }
                    return u(), {
                        modifyBase: function(t1, e1) {
                            l[t1] = e1;
                        },
                        modifyItem: h,
                        getUpdateObj: f,
                        applyUpdate: function(e1, r) {
                            e1 && h(e1, r);
                            var i = f();
                            for(var a in i)n.nestedProperty(t1, a).set(i[a]);
                        }
                    };
                };
            },
            71817: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(33626), a = r(44122), o = r(34809), s = r(30635), l = r(34823), c = r(78766), u = r(62203), h = r(17240), f = r(95433), p = r(29714), d = r(4530), m = r(84391), g = m.enforce, y = m.clean, v = r(32919).doAutoRange, x = "start", _ = r(54826).zindexSeparator;
                function b(t1, e1, r) {
                    for(var n = 0; n < r.length; n++){
                        var i = r[n][0], a = r[n][1];
                        if (!(i[0] >= t1[1] || i[1] <= t1[0]) && a[0] < e1[1] && a[1] > e1[0]) return !0;
                    }
                    return !1;
                }
                function w(t1) {
                    var r, i, s, l, h, m, g = t1._fullLayout, y = g._size, v = y.p, x = p.list(t1, "", !0);
                    if (g._paperdiv.style({
                        width: t1._context.responsive && g.autosize && !t1._context._hasZeroWidth && !t1.layout.width ? "100%" : g.width + "px",
                        height: t1._context.responsive && g.autosize && !t1._context._hasZeroHeight && !t1.layout.height ? "100%" : g.height + "px"
                    }).selectAll(".main-svg").call(u.setSize, g.width, g.height), t1._context.setBackground(t1, g.paper_bgcolor), e1.drawMainTitle(t1), f.manage(t1), !g._has("cartesian")) return a.previousPromises(t1);
                    function w(t1, e1, r) {
                        var n = t1._lw / 2;
                        return "x" === t1._id.charAt(0) ? e1 ? "top" === r ? e1._offset - v - n : e1._offset + e1._length + v + n : y.t + y.h * (1 - (t1.position || 0)) + n % 1 : e1 ? "right" === r ? e1._offset + e1._length + v + n : e1._offset - v - n : y.l + y.w * (t1.position || 0) + n % 1;
                    }
                    for(r = 0; r < x.length; r++){
                        var k = (l = x[r])._anchorAxis;
                        l._linepositions = {}, l._lw = u.crispRound(t1, l.linewidth, 1), l._mainLinePosition = w(l, k, l.side), l._mainMirrorPosition = l.mirror && k ? w(l, k, d.OPPOSITE_SIDE[l.side]) : null;
                    }
                    var M = [], S = [], E = [], C = 1 === c.opacity(g.paper_bgcolor) && 1 === c.opacity(g.plot_bgcolor) && g.paper_bgcolor === g.plot_bgcolor;
                    for(i in g._plots)if ((s = g._plots[i]).mainplot) s.bg && s.bg.remove(), s.bg = void 0;
                    else {
                        var L = s.xaxis.domain, I = s.yaxis.domain, P = s.plotgroup;
                        if (b(L, I, E) && -1 === i.indexOf(_)) {
                            var z = P.node(), O = s.bg = o.ensureSingle(P, "rect", "bg");
                            z.insertBefore(O.node(), z.childNodes[0]), S.push(i);
                        } else P.select("rect.bg").remove(), E.push([
                            L,
                            I
                        ]), C || (M.push(i), S.push(i));
                    }
                    var D, R, F, B, N, j, U, V, q, H, G, Z, W, Y = g._bgLayer.selectAll(".bg").data(M);
                    for(Y.enter().append("rect").classed("bg", !0), Y.exit().remove(), Y.each(function(t1) {
                        g._plots[t1].bg = n.select(this);
                    }), r = 0; r < S.length; r++)s = g._plots[S[r]], h = s.xaxis, m = s.yaxis, s.bg && void 0 !== h._offset && void 0 !== m._offset && s.bg.call(u.setRect, h._offset - v, m._offset - v, h._length + 2 * v, m._length + 2 * v).call(c.fill, g.plot_bgcolor).style("stroke-width", 0);
                    if (!g._hasOnlyLargeSploms) for(i in g._plots){
                        s = g._plots[i], h = s.xaxis, m = s.yaxis;
                        var X, $, J = s.clipId = "clip" + g._uid + i + "plot", K = o.ensureSingleById(g._clips, "clipPath", J, function(t1) {
                            t1.classed("plotclip", !0).append("rect");
                        });
                        s.clipRect = K.select("rect").attr({
                            width: h._length,
                            height: m._length
                        }), u.setTranslate(s.plot, h._offset, m._offset), s._hasClipOnAxisFalse ? (X = null, $ = J) : (X = J, $ = null), u.setClipUrl(s.plot, X, t1), s.layerClipId = $;
                    }
                    function Q(t1) {
                        return "M" + D + "," + t1 + "H" + R;
                    }
                    function tt(t1) {
                        return "M" + h._offset + "," + t1 + "h" + h._length;
                    }
                    function et(t1) {
                        return "M" + t1 + "," + V + "V" + U;
                    }
                    function rt(t1) {
                        return void 0 !== m._shift && (t1 += m._shift), "M" + t1 + "," + m._offset + "v" + m._length;
                    }
                    function nt(t1, e1, r) {
                        if (!t1.showline || i !== t1._mainSubplot) return "";
                        if (!t1._anchorAxis) return r(t1._mainLinePosition);
                        var n = e1(t1._mainLinePosition);
                        return t1.mirror && (n += e1(t1._mainMirrorPosition)), n;
                    }
                    for(i in g._plots){
                        s = g._plots[i], h = s.xaxis, m = s.yaxis;
                        var it = "M0,0";
                        T(h, i) && (N = A(h, "left", m, x), D = h._offset - (N ? v + N : 0), j = A(h, "right", m, x), R = h._offset + h._length + (j ? v + j : 0), F = w(h, m, "bottom"), B = w(h, m, "top"), !(W = !h._anchorAxis || i !== h._mainSubplot) || "allticks" !== h.mirror && "all" !== h.mirror || (h._linepositions[i] = [
                            F,
                            B
                        ]), it = nt(h, Q, tt), W && h.showline && ("all" === h.mirror || "allticks" === h.mirror) && (it += Q(F) + Q(B)), s.xlines.style("stroke-width", h._lw + "px").call(c.stroke, h.showline ? h.linecolor : "rgba(0,0,0,0)")), s.xlines.attr("d", it);
                        var at = "M0,0";
                        T(m, i) && (G = A(m, "bottom", h, x), U = m._offset + m._length + (G ? v : 0), Z = A(m, "top", h, x), V = m._offset - (Z ? v : 0), q = w(m, h, "left"), H = w(m, h, "right"), !(W = !m._anchorAxis || i !== m._mainSubplot) || "allticks" !== m.mirror && "all" !== m.mirror || (m._linepositions[i] = [
                            q,
                            H
                        ]), at = nt(m, et, rt), W && m.showline && ("all" === m.mirror || "allticks" === m.mirror) && (at += et(q) + et(H)), s.ylines.style("stroke-width", m._lw + "px").call(c.stroke, m.showline ? m.linecolor : "rgba(0,0,0,0)")), s.ylines.attr("d", at);
                    }
                    return p.makeClipPaths(t1), a.previousPromises(t1);
                }
                function T(t1, e1) {
                    return (t1.ticks || t1.showline) && (e1 === t1._mainSubplot || "all" === t1.mirror || "allticks" === t1.mirror);
                }
                function k(t1, e1, r) {
                    if (!r.showline || !r._lw) return !1;
                    if ("all" === r.mirror || "allticks" === r.mirror) return !0;
                    var n = r._anchorAxis;
                    if (!n) return !1;
                    var i = d.FROM_BL[e1];
                    return r.side === e1 ? n.domain[i] === t1.domain[i] : r.mirror && n.domain[1 - i] === t1.domain[1 - i];
                }
                function A(t1, e1, r, n) {
                    if (k(t1, e1, r)) return r._lw;
                    for(var i = 0; i < n.length; i++){
                        var a = n[i];
                        if (a._mainAxis === r._mainAxis && k(t1, e1, a)) return a._lw;
                    }
                    return 0;
                }
                function M(t1) {
                    return "top" === t1 ? d.CAP_SHIFT + .3 + "em" : "bottom" === t1 ? "-0.3em" : d.MID_SHIFT + "em";
                }
                e1.layoutStyles = function(t1) {
                    return o.syncOrAsync([
                        a.doAutoMargin,
                        w
                    ], t1);
                }, e1.drawMainTitle = function(t1) {
                    var e1 = t1._fullLayout.title, r = t1._fullLayout, i = function(t1) {
                        var e1 = t1.title, r = "middle";
                        return o.isRightAnchor(e1) ? r = "end" : o.isLeftAnchor(e1) && (r = x), r;
                    }(r), l = function(t1) {
                        var e1 = t1.title, r = "0em";
                        return o.isTopAnchor(e1) ? r = d.CAP_SHIFT + "em" : o.isMiddleAnchor(e1) && (r = d.MID_SHIFT + "em"), r;
                    }(r), c = function(t1, e1) {
                        var r = t1.title, n = t1._size, i = 0;
                        return "0em" !== e1 && e1 ? e1 === d.CAP_SHIFT + "em" && (i = r.pad.t) : i = -r.pad.b, "auto" === r.y ? n.t / 2 : "paper" === r.yref ? n.t + n.h - n.h * r.y + i : t1.height - t1.height * r.y + i;
                    }(r, l), f = function(t1, e1) {
                        var r = t1.title, n = t1._size, i = 0;
                        return e1 === x ? i = r.pad.l : "end" === e1 && (i = -r.pad.r), "paper" === r.xref ? n.l + n.w * r.x + i : t1.width * r.x + i;
                    }(r, i);
                    if (h.draw(t1, "gtitle", {
                        propContainer: r,
                        propName: "title.text",
                        subtitlePropName: "title.subtitle.text",
                        placeholder: r._dfltTitle.plot,
                        subtitlePlaceholder: r._dfltTitle.subtitle,
                        attributes: {
                            x: f,
                            y: c,
                            "text-anchor": i,
                            dy: l
                        }
                    }), e1.text && e1.automargin) {
                        var p = n.selectAll(".gtitle"), m = u.bBox(n.selectAll(".g-gtitle").node()).height, g = function(t1, e1, r) {
                            var n = e1.y, i = e1.yanchor, a = n > .5 ? "t" : "b", o = t1._fullLayout.margin[a], s = 0;
                            return "paper" === e1.yref ? s = r + e1.pad.t + e1.pad.b : "container" === e1.yref && (s = function(t1, e1, r, n, i) {
                                var a = 0;
                                return "middle" === r && (a += i / 2), "t" === t1 ? ("top" === r && (a += i), a += n - e1 * n) : ("bottom" === r && (a += i), a += e1 * n), a;
                            }(a, n, i, t1._fullLayout.height, r) + e1.pad.t + e1.pad.b), s > o ? s : 0;
                        }(t1, e1, m);
                        if (g > 0) {
                            !function(t1, e1, r, n) {
                                var i = "title.automargin", s = t1._fullLayout.title, l = s.y > .5 ? "t" : "b", c = {
                                    x: s.x,
                                    y: s.y,
                                    t: 0,
                                    b: 0
                                }, u = {};
                                "paper" === s.yref && function(t1, e1, r, n, i) {
                                    var a = "paper" === e1.yref ? t1._fullLayout._size.h : t1._fullLayout.height, s = o.isTopAnchor(e1) ? n : n - i, l = "b" === r ? a - s : s;
                                    return !(o.isTopAnchor(e1) && "t" === r || o.isBottomAnchor(e1) && "b" === r) && l < i;
                                }(t1, s, l, e1, n) ? c[l] = r : "container" === s.yref && (u[l] = r, t1._fullLayout._reservedMargin[i] = u), a.allowAutoMargin(t1, i), a.autoMargin(t1, i, c);
                            }(t1, c, g, m), p.attr({
                                x: f,
                                y: c,
                                "text-anchor": i,
                                dy: M(e1.yanchor)
                            }).call(s.positionText, f, c);
                            var y = (e1.text.match(s.BR_TAG_ALL) || []).length;
                            if (y) {
                                var v = d.LINE_SPACING * y + d.MID_SHIFT;
                                0 === e1.y && (v = -v), p.selectAll(".line").each(function() {
                                    var t1 = +this.getAttribute("dy").slice(0, -2) - v + "em";
                                    this.setAttribute("dy", t1);
                                });
                            }
                            var _ = n.selectAll(".gtitle-subtitle");
                            if (_.node()) {
                                var b = p.node().getBBox(), w = b.y + b.height + h.SUBTITLE_PADDING_EM * e1.subtitle.font.size;
                                _.attr({
                                    x: f,
                                    y: w,
                                    "text-anchor": i,
                                    dy: M(e1.yanchor)
                                }).call(s.positionText, f, w);
                            }
                        }
                    }
                }, e1.doTraceStyle = function(t1) {
                    var r, n = t1.calcdata, o = [];
                    for(r = 0; r < n.length; r++){
                        var s = n[r], c = s[0] || {}, u = c.trace || {}, h = u._module || {}, f = h.arraysToCalcdata;
                        f && f(s, u);
                        var p = h.editStyle;
                        p && o.push({
                            fn: p,
                            cd0: c
                        });
                    }
                    if (o.length) {
                        for(r = 0; r < o.length; r++){
                            var d = o[r];
                            d.fn(t1, d.cd0);
                        }
                        l(t1), e1.redrawReglTraces(t1);
                    }
                    return a.style(t1), i.getComponentMethod("legend", "draw")(t1), a.previousPromises(t1);
                }, e1.doColorBars = function(t1) {
                    return i.getComponentMethod("colorbar", "draw")(t1), a.previousPromises(t1);
                }, e1.layoutReplot = function(t1) {
                    var e1 = t1.layout;
                    return t1.layout = void 0, i.call("_doPlot", t1, "", e1);
                }, e1.doLegend = function(t1) {
                    return i.getComponentMethod("legend", "draw")(t1), a.previousPromises(t1);
                }, e1.doTicksRelayout = function(t1) {
                    return p.draw(t1, "redraw"), t1._fullLayout._hasOnlyLargeSploms && (i.subplotsRegistry.splom.updateGrid(t1), l(t1), e1.redrawReglTraces(t1)), e1.drawMainTitle(t1), a.previousPromises(t1);
                }, e1.doModeBar = function(t1) {
                    var e1 = t1._fullLayout;
                    f.manage(t1);
                    for(var r = 0; r < e1._basePlotModules.length; r++){
                        var n = e1._basePlotModules[r].updateFx;
                        n && n(t1);
                    }
                    return a.previousPromises(t1);
                }, e1.doCamera = function(t1) {
                    for(var e1 = t1._fullLayout, r = e1._subplots.gl3d, n = 0; n < r.length; n++){
                        var i = e1[r[n]];
                        i._scene.setViewport(i);
                    }
                }, e1.drawData = function(t1) {
                    var r = t1._fullLayout;
                    l(t1);
                    for(var n = r._basePlotModules, o = 0; o < n.length; o++)n[o].plot(t1);
                    return e1.redrawReglTraces(t1), a.style(t1), i.getComponentMethod("selections", "draw")(t1), i.getComponentMethod("shapes", "draw")(t1), i.getComponentMethod("annotations", "draw")(t1), i.getComponentMethod("images", "draw")(t1), r._replotting = !1, a.previousPromises(t1);
                }, e1.redrawReglTraces = function(t1) {
                    var e1 = t1._fullLayout;
                    if (e1._has("regl")) {
                        var r, n, i = t1._fullData, a = [], s = [];
                        for(e1._hasOnlyLargeSploms && e1._splomGrid.draw(), r = 0; r < i.length; r++){
                            var l = i[r];
                            !0 === l.visible && 0 !== l._length && ("splom" === l.type ? e1._splomScenes[l.uid].draw() : "scattergl" === l.type ? o.pushUnique(a, l.xaxis + l.yaxis) : "scatterpolargl" === l.type && o.pushUnique(s, l.subplot));
                        }
                        for(r = 0; r < a.length; r++)(n = e1._plots[a[r]])._scene && n._scene.draw();
                        for(r = 0; r < s.length; r++)(n = e1[s[r]]._subplot)._scene && n._scene.draw();
                    }
                }, e1.doAutoRangeAndConstraints = function(t1) {
                    for(var e1, r = p.list(t1, "", !0), n = {}, i = 0; i < r.length; i++)if (!n[(e1 = r[i])._id]) {
                        n[e1._id] = 1, y(t1, e1), v(t1, e1);
                        var a = e1._matchGroup;
                        if (a) for(var o in a){
                            var s = p.getFromId(t1, o);
                            v(t1, s, e1.range), n[o] = 1;
                        }
                    }
                    g(t1);
                }, e1.finalDraw = function(t1) {
                    i.getComponentMethod("rangeslider", "draw")(t1), i.getComponentMethod("rangeselector", "draw")(t1);
                }, e1.drawMarginPushers = function(t1) {
                    i.getComponentMethod("legend", "draw")(t1), i.getComponentMethod("rangeselector", "draw")(t1), i.getComponentMethod("sliders", "draw")(t1), i.getComponentMethod("updatemenus", "draw")(t1), i.getComponentMethod("colorbar", "draw")(t1);
                };
            },
            53853: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = n.isPlainObject, a = r(57297), o = r(44122), s = r(9829), l = r(78032), c = r(24452).dfltConfig;
                function u(t1, e1) {
                    t1 = n.extendDeep({}, t1);
                    var r, a, o = Object.keys(t1).sort();
                    function s(e1, r, n) {
                        if (i(r) && i(e1)) u(e1, r);
                        else if (Array.isArray(r) && Array.isArray(e1)) {
                            var o = l.arrayTemplater({
                                _template: t1
                            }, n);
                            for(a = 0; a < r.length; a++){
                                var s = r[a], c = o.newItem(s)._template;
                                c && u(c, s);
                            }
                            var h = o.defaultItems();
                            for(a = 0; a < h.length; a++)r.push(h[a]._template);
                            for(a = 0; a < r.length; a++)delete r[a].templateitemname;
                        }
                    }
                    for(r = 0; r < o.length; r++){
                        var c = o[r], f = t1[c];
                        if (c in e1 ? s(f, e1[c], c) : e1[c] = f, h(c) === c) for(var p in e1){
                            var d = h(p);
                            p === d || d !== c || p in t1 || s(f, e1[p], c);
                        }
                    }
                }
                function h(t1) {
                    return t1.replace(/[0-9]+$/, "");
                }
                function f(t1, e1, r, a, o) {
                    var s = o && r(o);
                    for(var c in t1){
                        var u = t1[c], p = m(t1, c, a), d = m(t1, c, o), g = r(d);
                        if (!g) {
                            var y = h(c);
                            y !== c && (g = r(d = m(t1, y, o)));
                        }
                        if (!(s && s === g || !g || g._noTemplating || "data_array" === g.valType || g.arrayOk && Array.isArray(u))) {
                            if (!g.valType && i(u)) f(u, e1, r, p, d);
                            else if (g._isLinkedToArray && Array.isArray(u)) for(var v = !1, x = 0, _ = {}, b = 0; b < u.length; b++){
                                var w = u[b];
                                if (i(w)) {
                                    var T = w.name;
                                    if (T) _[T] || (f(w, e1, r, m(u, x, p), m(u, x, d)), x++, _[T] = 1);
                                    else if (!v) {
                                        var k = m(t1, l.arrayDefaultKey(c), a), A = m(u, x, p);
                                        f(w, e1, r, A, m(u, x, d));
                                        var M = n.nestedProperty(e1, A);
                                        n.nestedProperty(e1, k).set(M.get()), M.set(null), v = !0;
                                    }
                                }
                            }
                            else n.nestedProperty(e1, p).set(u);
                        }
                    }
                }
                function p(t1, e1) {
                    return a.getLayoutValObject(t1, n.nestedProperty({}, e1).parts);
                }
                function d(t1, e1) {
                    return a.getTraceValObject(t1, n.nestedProperty({}, e1).parts);
                }
                function m(t1, e1, r) {
                    return r ? Array.isArray(t1) ? r + "[" + e1 + "]" : r + "." + e1 : e1;
                }
                function g(t1) {
                    for(var e1 = 0; e1 < t1.length; e1++)if (i(t1[e1])) return !0;
                }
                function y(t1) {
                    var e1;
                    switch(t1.code){
                        case "data":
                            e1 = "The template has no key data.";
                            break;
                        case "layout":
                            e1 = "The template has no key layout.";
                            break;
                        case "missing":
                            e1 = t1.path ? "There are no templates for item " + t1.path + " with name " + t1.templateitemname : "There are no templates for trace " + t1.index + ", of type " + t1.traceType + ".";
                            break;
                        case "unused":
                            e1 = t1.path ? "The template item at " + t1.path + " was not used in constructing the plot." : t1.dataCount ? "Some of the templates of type " + t1.traceType + " were not used. The template has " + t1.templateCount + " traces, the data only has " + t1.dataCount + " of this type." : "The template has " + t1.templateCount + " traces of type " + t1.traceType + " but there are none in the data.";
                            break;
                        case "reused":
                            e1 = "Some of the templates of type " + t1.traceType + " were used more than once. The template has " + t1.templateCount + " traces, the data has " + t1.dataCount + " of this type.";
                    }
                    return t1.msg = e1, t1;
                }
                e1.makeTemplate = function(t1) {
                    t1 = n.isPlainObject(t1) ? t1 : n.getGraphDiv(t1), t1 = n.extendDeep({
                        _context: c
                    }, {
                        data: t1.data,
                        layout: t1.layout
                    }), o.supplyDefaults(t1);
                    var e1 = t1.data || [], r = t1.layout || {};
                    r._basePlotModules = t1._fullLayout._basePlotModules, r._modules = t1._fullLayout._modules;
                    var a = {
                        data: {},
                        layout: {}
                    };
                    e1.forEach(function(t1) {
                        var e1 = {};
                        f(t1, e1, d.bind(null, t1));
                        var r = n.coerce(t1, {}, s, "type"), i = a.data[r];
                        i || (i = a.data[r] = []), i.push(e1);
                    }), f(r, a.layout, p.bind(null, r)), delete a.layout.template;
                    var l = r.template;
                    if (i(l)) {
                        var h, m, g, y, v, x, _ = l.layout;
                        i(_) && u(_, a.layout);
                        var b = l.data;
                        if (i(b)) {
                            for(m in a.data)if (g = b[m], Array.isArray(g)) {
                                for(x = (v = a.data[m]).length, y = g.length, h = 0; h < x; h++)u(g[h % y], v[h]);
                                for(h = x; h < y; h++)v.push(n.extendDeep({}, g[h]));
                            }
                            for(m in b)m in a.data || (a.data[m] = n.extendDeep([], b[m]));
                        }
                    }
                    return a;
                }, e1.validateTemplate = function(t1, e1) {
                    var r = n.extendDeep({}, {
                        _context: c,
                        data: t1.data,
                        layout: t1.layout
                    }), a = r.layout || {};
                    i(e1) || (e1 = a.template || {});
                    var s = e1.layout, l = e1.data, u = [];
                    r.layout = a, r.layout.template = e1, o.supplyDefaults(r);
                    var f = r._fullLayout, p = r._fullData, d = {};
                    if (i(s) ? (function t1(e1, r) {
                        for(var n in e1)if ("_" !== n.charAt(0) && i(e1[n])) {
                            var a, o = h(n), s = [];
                            for(a = 0; a < r.length; a++)s.push(m(e1, n, r[a])), o !== n && s.push(m(e1, o, r[a]));
                            for(a = 0; a < s.length; a++)d[s[a]] = 1;
                            t1(e1[n], s);
                        }
                    }(f, [
                        "layout"
                    ]), function t1(e1, r) {
                        for(var n in e1)if (-1 === n.indexOf("defaults") && i(e1[n])) {
                            var a = m(e1, n, r);
                            d[a] ? t1(e1[n], a) : u.push({
                                code: "unused",
                                path: a
                            });
                        }
                    }(s, "layout")) : u.push({
                        code: "layout"
                    }), i(l)) {
                        for(var v, x = {}, _ = 0; _ < p.length; _++){
                            var b = p[_];
                            x[v = b.type] = (x[v] || 0) + 1, b._fullInput._template || u.push({
                                code: "missing",
                                index: b._fullInput.index,
                                traceType: v
                            });
                        }
                        for(v in l){
                            var w = l[v].length, T = x[v] || 0;
                            w > T ? u.push({
                                code: "unused",
                                traceType: v,
                                templateCount: w,
                                dataCount: T
                            }) : T > w && u.push({
                                code: "reused",
                                traceType: v,
                                templateCount: w,
                                dataCount: T
                            });
                        }
                    } else u.push({
                        code: "data"
                    });
                    if (function t1(e1, r) {
                        for(var n in e1)if ("_" !== n.charAt(0)) {
                            var a = e1[n], o = m(e1, n, r);
                            i(a) ? (Array.isArray(e1) && !1 === a._template && a.templateitemname && u.push({
                                code: "missing",
                                path: o,
                                templateitemname: a.templateitemname
                            }), t1(a, o)) : Array.isArray(a) && g(a) && t1(a, o);
                        }
                    }({
                        data: p,
                        layout: f
                    }, ""), u.length) return u.map(y);
                };
            },
            80491: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(31420), a = r(44122), o = r(34809), s = r(84619), l = r(6243), c = r(72914), u = r(29697).version, h = {
                    format: {
                        valType: "enumerated",
                        values: [
                            "png",
                            "jpeg",
                            "webp",
                            "svg",
                            "full-json"
                        ],
                        dflt: "png"
                    },
                    width: {
                        valType: "number",
                        min: 1
                    },
                    height: {
                        valType: "number",
                        min: 1
                    },
                    scale: {
                        valType: "number",
                        min: 0,
                        dflt: 1
                    },
                    setBackground: {
                        valType: "any",
                        dflt: !1
                    },
                    imageDataOnly: {
                        valType: "boolean",
                        dflt: !1
                    }
                };
                t1.exports = function(t1, e1) {
                    var r, f, p, d;
                    function m(t1) {
                        return !(t1 in e1) || o.validate(e1[t1], h[t1]);
                    }
                    if (e1 = e1 || {}, o.isPlainObject(t1) ? (r = t1.data || [], f = t1.layout || {}, p = t1.config || {}, d = {}) : (t1 = o.getGraphDiv(t1), r = o.extendDeep([], t1.data), f = o.extendDeep({}, t1.layout), p = t1._context, d = t1._fullLayout || {}), !m("width") && null !== e1.width || !m("height") && null !== e1.height) throw new Error("Height and width should be pixel values.");
                    if (!m("format")) throw new Error("Export format is not " + o.join2(h.format.values, ", ", " or ") + ".");
                    var g = {};
                    function y(t1, r) {
                        return o.coerce(e1, g, h, t1, r);
                    }
                    var v = y("format"), x = y("width"), _ = y("height"), b = y("scale"), w = y("setBackground"), T = y("imageDataOnly"), k = document.createElement("div");
                    k.style.position = "absolute", k.style.left = "-5000px", document.body.appendChild(k);
                    var A = o.extendFlat({}, f);
                    x ? A.width = x : null === e1.width && n(d.width) && (A.width = d.width), _ ? A.height = _ : null === e1.height && n(d.height) && (A.height = d.height);
                    var M = o.extendFlat({}, p, {
                        _exportedPlot: !0,
                        staticPlot: !0,
                        setBackground: w
                    }), S = s.getRedrawFunc(k);
                    function E() {
                        return new Promise(function(t1) {
                            setTimeout(t1, s.getDelay(k._fullLayout));
                        });
                    }
                    function C() {
                        return new Promise(function(t1, e1) {
                            var r = l(k, v, b), n = k._fullLayout.width, h = k._fullLayout.height;
                            function f() {
                                i.purge(k), document.body.removeChild(k);
                            }
                            if ("full-json" === v) {
                                var p = a.graphJson(k, !1, "keepdata", "object", !0, !0);
                                return p.version = u, p = JSON.stringify(p), f(), t1(T ? p : s.encodeJSON(p));
                            }
                            if (f(), "svg" === v) return t1(T ? r : s.encodeSVG(r));
                            var d = document.createElement("canvas");
                            d.id = o.randstr(), c({
                                format: v,
                                width: n,
                                height: h,
                                scale: b,
                                canvas: d,
                                svg: r,
                                promise: !0
                            }).then(t1).catch(e1);
                        });
                    }
                    return new Promise(function(t1, e1) {
                        i.newPlot(k, r, A, M).then(S).then(E).then(C).then(function(e1) {
                            t1(function(t1) {
                                return T ? t1.replace(s.IMAGE_URL_PREFIX, "") : t1;
                            }(e1));
                        }).catch(function(t1) {
                            e1(t1);
                        });
                    });
                };
            },
            2466: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(44122), a = r(57297), o = r(24452).dfltConfig, s = n.isPlainObject, l = Array.isArray, c = n.isArrayOrTypedArray;
                function u(t1, e1, r, i, a, o) {
                    o = o || [];
                    for(var h = Object.keys(t1), f = 0; f < h.length; f++){
                        var g = h[f];
                        if ("transforms" !== g) {
                            var y = o.slice();
                            y.push(g);
                            var v = t1[g], x = e1[g], _ = m(r, g), b = (_ || {}).valType, w = "info_array" === b, T = "colorscale" === b, k = (_ || {}).items;
                            if (d(r, g)) {
                                if (s(v) && s(x) && "any" !== b) u(v, x, _, i, a, y);
                                else if (w && l(v)) {
                                    v.length > x.length && i.push(p("unused", a, y.concat(x.length)));
                                    var A, M, S, E, C, L = x.length, I = Array.isArray(k);
                                    if (I && (L = Math.min(L, k.length)), 2 === _.dimensions) for(M = 0; M < L; M++)if (l(v[M])) {
                                        v[M].length > x[M].length && i.push(p("unused", a, y.concat(M, x[M].length)));
                                        var P = x[M].length;
                                        for(A = 0; A < (I ? Math.min(P, k[M].length) : P); A++)S = I ? k[M][A] : k, E = v[M][A], C = x[M][A], n.validate(E, S) ? C !== E && C !== +E && i.push(p("dynamic", a, y.concat(M, A), E, C)) : i.push(p("value", a, y.concat(M, A), E));
                                    } else i.push(p("array", a, y.concat(M), v[M]));
                                    else for(M = 0; M < L; M++)S = I ? k[M] : k, E = v[M], C = x[M], n.validate(E, S) ? C !== E && C !== +E && i.push(p("dynamic", a, y.concat(M), E, C)) : i.push(p("value", a, y.concat(M), E));
                                } else if (_.items && !w && l(v)) {
                                    var z, O, D = k[Object.keys(k)[0]], R = [];
                                    for(z = 0; z < x.length; z++){
                                        var F = x[z]._index || z;
                                        if ((O = y.slice()).push(F), s(v[F]) && s(x[z])) {
                                            R.push(F);
                                            var B = v[F], N = x[z];
                                            s(B) && !1 !== B.visible && !1 === N.visible ? i.push(p("invisible", a, O)) : u(B, N, D, i, a, O);
                                        }
                                    }
                                    for(z = 0; z < v.length; z++)(O = y.slice()).push(z), s(v[z]) ? -1 === R.indexOf(z) && i.push(p("unused", a, O)) : i.push(p("object", a, O, v[z]));
                                } else !s(v) && s(x) ? i.push(p("object", a, y, v)) : c(v) || !c(x) || w || T ? g in e1 ? n.validate(v, _) ? "enumerated" === _.valType && (_.coerceNumber && v !== +x || v !== x) && i.push(p("dynamic", a, y, v, x)) : i.push(p("value", a, y, v)) : i.push(p("unused", a, y, v)) : i.push(p("array", a, y, v));
                            } else i.push(p("schema", a, y));
                        }
                    }
                    return i;
                }
                t1.exports = function(t1, e1) {
                    void 0 === t1 && (t1 = []), void 0 === e1 && (e1 = {});
                    var r, c, h = a.get(), f = [], d = {
                        _context: n.extendFlat({}, o)
                    };
                    l(t1) ? (d.data = n.extendDeep([], t1), r = t1) : (d.data = [], r = [], f.push(p("array", "data"))), s(e1) ? (d.layout = n.extendDeep({}, e1), c = e1) : (d.layout = {}, c = {}, arguments.length > 1 && f.push(p("object", "layout"))), i.supplyDefaults(d);
                    for(var m = d._fullData, g = r.length, y = 0; y < g; y++){
                        var v = r[y], x = [
                            "data",
                            y
                        ];
                        if (s(v)) {
                            var _ = m[y], b = _.type, w = h.traces[b].attributes;
                            w.type = {
                                valType: "enumerated",
                                values: [
                                    b
                                ]
                            }, !1 === _.visible && !1 !== v.visible && f.push(p("invisible", x)), u(v, _, w, f, x);
                            var T = v.transforms, k = _.transforms;
                            if (T) {
                                l(T) || f.push(p("array", x, [
                                    "transforms"
                                ])), x.push("transforms");
                                for(var A = 0; A < T.length; A++){
                                    var M = [
                                        "transforms",
                                        A
                                    ], S = T[A].type;
                                    if (s(T[A])) {
                                        var E = h.transforms[S] ? h.transforms[S].attributes : {};
                                        E.type = {
                                            valType: "enumerated",
                                            values: Object.keys(h.transforms)
                                        }, u(T[A], k[A], E, f, x, M);
                                    } else f.push(p("object", x, M));
                                }
                            }
                        } else f.push(p("object", x));
                    }
                    var C = d._fullLayout, L = function(t1, e1) {
                        for(var r = t1.layout.layoutAttributes, i = 0; i < e1.length; i++){
                            var a = e1[i], o = t1.traces[a.type], s = o.layoutAttributes;
                            s && (a.subplot ? n.extendFlat(r[o.attributes.subplot.dflt], s) : n.extendFlat(r, s));
                        }
                        return r;
                    }(h, m);
                    return u(c, C, L, f, "layout"), 0 === f.length ? void 0 : f;
                };
                var h = {
                    object: function(t1, e1) {
                        return ("layout" === t1 && "" === e1 ? "The layout argument" : "data" === t1[0] && "" === e1 ? "Trace " + t1[1] + " in the data argument" : f(t1) + "key " + e1) + " must be linked to an object container";
                    },
                    array: function(t1, e1) {
                        return ("data" === t1 ? "The data argument" : f(t1) + "key " + e1) + " must be linked to an array container";
                    },
                    schema: function(t1, e1) {
                        return f(t1) + "key " + e1 + " is not part of the schema";
                    },
                    unused: function(t1, e1, r) {
                        var n = s(r) ? "container" : "key";
                        return f(t1) + n + " " + e1 + " did not get coerced";
                    },
                    dynamic: function(t1, e1, r, n) {
                        return [
                            f(t1) + "key",
                            e1,
                            "(set to '" + r + "')",
                            "got reset to",
                            "'" + n + "'",
                            "during defaults."
                        ].join(" ");
                    },
                    invisible: function(t1, e1) {
                        return (e1 ? f(t1) + "item " + e1 : "Trace " + t1[1]) + " got defaulted to be not visible";
                    },
                    value: function(t1, e1, r) {
                        return [
                            f(t1) + "key " + e1,
                            "is set to an invalid value (" + r + ")"
                        ].join(" ");
                    }
                };
                function f(t1) {
                    return l(t1) ? "In data trace " + t1[1] + ", " : "In " + t1 + ", ";
                }
                function p(t1, e1, r, i, a) {
                    var o, s;
                    r = r || "", l(e1) ? (o = e1[0], s = e1[1]) : (o = e1, s = null);
                    var c = function(t1) {
                        if (!l(t1)) return String(t1);
                        for(var e1 = "", r = 0; r < t1.length; r++){
                            var n = t1[r];
                            "number" == typeof n ? e1 = e1.substr(0, e1.length - 1) + "[" + n + "]" : e1 += n, r < t1.length - 1 && (e1 += ".");
                        }
                        return e1;
                    }(r), u = h[t1](e1, c, i, a);
                    return n.log(u), {
                        code: t1,
                        container: o,
                        trace: s,
                        path: r,
                        astr: c,
                        msg: u
                    };
                }
                function d(t1, e1) {
                    var r = y(e1), n = r.keyMinusId, i = r.id;
                    return !!(n in t1 && t1[n]._isSubplotObj && i) || e1 in t1;
                }
                function m(t1, e1) {
                    return e1 in t1 ? t1[e1] : t1[y(e1).keyMinusId];
                }
                var g = n.counterRegex("([a-z]+)");
                function y(t1) {
                    var e1 = t1.match(g);
                    return {
                        keyMinusId: e1 && e1[1],
                        id: e1 && e1[2]
                    };
                }
            },
            49722: function(t1) {
                "use strict";
                t1.exports = {
                    mode: {
                        valType: "enumerated",
                        dflt: "afterall",
                        values: [
                            "immediate",
                            "next",
                            "afterall"
                        ]
                    },
                    direction: {
                        valType: "enumerated",
                        values: [
                            "forward",
                            "reverse"
                        ],
                        dflt: "forward"
                    },
                    fromcurrent: {
                        valType: "boolean",
                        dflt: !1
                    },
                    frame: {
                        duration: {
                            valType: "number",
                            min: 0,
                            dflt: 500
                        },
                        redraw: {
                            valType: "boolean",
                            dflt: !0
                        }
                    },
                    transition: {
                        duration: {
                            valType: "number",
                            min: 0,
                            dflt: 500,
                            editType: "none"
                        },
                        easing: {
                            valType: "enumerated",
                            dflt: "cubic-in-out",
                            values: [
                                "linear",
                                "quad",
                                "cubic",
                                "sin",
                                "exp",
                                "circle",
                                "elastic",
                                "back",
                                "bounce",
                                "linear-in",
                                "quad-in",
                                "cubic-in",
                                "sin-in",
                                "exp-in",
                                "circle-in",
                                "elastic-in",
                                "back-in",
                                "bounce-in",
                                "linear-out",
                                "quad-out",
                                "cubic-out",
                                "sin-out",
                                "exp-out",
                                "circle-out",
                                "elastic-out",
                                "back-out",
                                "bounce-out",
                                "linear-in-out",
                                "quad-in-out",
                                "cubic-in-out",
                                "sin-in-out",
                                "exp-in-out",
                                "circle-in-out",
                                "elastic-in-out",
                                "back-in-out",
                                "bounce-in-out"
                            ],
                            editType: "none"
                        },
                        ordering: {
                            valType: "enumerated",
                            values: [
                                "layout first",
                                "traces first"
                            ],
                            dflt: "layout first",
                            editType: "none"
                        }
                    }
                };
            },
            59008: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(78032);
                t1.exports = function(t1, e1, r) {
                    var a, o, s = r.name, l = r.inclusionAttr || "visible", c = e1[s], u = n.isArrayOrTypedArray(t1[s]) ? t1[s] : [], h = e1[s] = [], f = i.arrayTemplater(e1, s, l);
                    for(a = 0; a < u.length; a++){
                        var p = u[a];
                        n.isPlainObject(p) ? o = f.newItem(p) : (o = f.newItem({}))[l] = !1, o._index = a, !1 !== o[l] && r.handleItemDefaults(p, o, e1, r), h.push(o);
                    }
                    var d = f.defaultItems();
                    for(a = 0; a < d.length; a++)(o = d[a])._index = h.length, r.handleItemDefaults({}, o, e1, r, {}), h.push(o);
                    if (n.isArrayOrTypedArray(c)) {
                        var m = Math.min(c.length, h.length);
                        for(a = 0; a < m; a++)n.relinkPrivateKeys(h[a], c[a]);
                    }
                    return h;
                };
            },
            9829: function(t1, e1, r) {
                "use strict";
                var n = r(80337), i = r(70192);
                t1.exports = {
                    type: {
                        valType: "enumerated",
                        values: [],
                        dflt: "scatter",
                        editType: "calc+clearAxisTypes",
                        _noTemplating: !0
                    },
                    visible: {
                        valType: "enumerated",
                        values: [
                            !0,
                            !1,
                            "legendonly"
                        ],
                        dflt: !0,
                        editType: "calc"
                    },
                    showlegend: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "style"
                    },
                    legend: {
                        valType: "subplotid",
                        dflt: "legend",
                        editType: "style"
                    },
                    legendgroup: {
                        valType: "string",
                        dflt: "",
                        editType: "style"
                    },
                    legendgrouptitle: {
                        text: {
                            valType: "string",
                            dflt: "",
                            editType: "style"
                        },
                        font: n({
                            editType: "style"
                        }),
                        editType: "style"
                    },
                    legendrank: {
                        valType: "number",
                        dflt: 1e3,
                        editType: "style"
                    },
                    legendwidth: {
                        valType: "number",
                        min: 0,
                        editType: "style"
                    },
                    opacity: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 1,
                        editType: "style"
                    },
                    name: {
                        valType: "string",
                        editType: "style"
                    },
                    uid: {
                        valType: "string",
                        editType: "plot",
                        anim: !0
                    },
                    ids: {
                        valType: "data_array",
                        editType: "calc",
                        anim: !0
                    },
                    customdata: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    meta: {
                        valType: "any",
                        arrayOk: !0,
                        editType: "plot"
                    },
                    selectedpoints: {
                        valType: "any",
                        editType: "calc"
                    },
                    hoverinfo: {
                        valType: "flaglist",
                        flags: [
                            "x",
                            "y",
                            "z",
                            "text",
                            "name"
                        ],
                        extras: [
                            "all",
                            "none",
                            "skip"
                        ],
                        arrayOk: !0,
                        dflt: "all",
                        editType: "none"
                    },
                    hoverlabel: i.hoverlabel,
                    stream: {
                        token: {
                            valType: "string",
                            noBlank: !0,
                            strict: !0,
                            editType: "calc"
                        },
                        maxpoints: {
                            valType: "number",
                            min: 0,
                            max: 1e4,
                            dflt: 500,
                            editType: "calc"
                        },
                        editType: "calc"
                    },
                    transforms: {
                        _isLinkedToArray: "transform",
                        editType: "calc"
                    },
                    uirevision: {
                        valType: "any",
                        editType: "none"
                    }
                };
            },
            40528: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(34809), a = i.dateTime2ms, o = i.incrementMonth, s = r(63821).ONEAVGMONTH;
                t1.exports = function(t1, e1, r, i) {
                    if ("date" !== e1.type) return {
                        vals: i
                    };
                    var l = t1[r + "periodalignment"];
                    if (!l) return {
                        vals: i
                    };
                    var c, u = t1[r + "period"];
                    if (n(u)) {
                        if ((u = +u) <= 0) return {
                            vals: i
                        };
                    } else if ("string" == typeof u && "M" === u.charAt(0)) {
                        var h = +u.substring(1);
                        if (!(h > 0 && Math.round(h) === h)) return {
                            vals: i
                        };
                        c = h;
                    }
                    for(var f = e1.calendar, p = "start" === l, d = "end" === l, m = t1[r + "period0"], g = a(m, f) || 0, y = [], v = [], x = [], _ = i.length, b = 0; b < _; b++){
                        var w, T, k, A = i[b];
                        if (c) {
                            for(w = Math.round((A - g) / (c * s)), k = o(g, c * w, f); k > A;)k = o(k, -c, f);
                            for(; k <= A;)k = o(k, c, f);
                            T = o(k, -c, f);
                        } else {
                            for(k = g + (w = Math.round((A - g) / u)) * u; k > A;)k -= u;
                            for(; k <= A;)k += u;
                            T = k - u;
                        }
                        y[b] = p ? T : d ? k : (T + k) / 2, v[b] = T, x[b] = k;
                    }
                    return {
                        vals: y,
                        starts: v,
                        ends: x
                    };
                };
            },
            55126: function(t1) {
                "use strict";
                t1.exports = {
                    xaxis: {
                        valType: "subplotid",
                        dflt: "x",
                        editType: "calc+clearAxisTypes"
                    },
                    yaxis: {
                        valType: "subplotid",
                        dflt: "y",
                        editType: "calc+clearAxisTypes"
                    }
                };
            },
            32919: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(10721), a = r(34809), o = r(63821).FP_SAFE, s = r(33626), l = r(62203), c = r(5975), u = c.getFromId, h = c.isLinked;
                function f(t1, e1) {
                    var r, n, i = [], o = t1._fullLayout, s = d(o, e1, 0), l = d(o, e1, 1), c = g(t1, e1), u = c.min, h = c.max;
                    if (0 === u.length || 0 === h.length) return a.simpleMap(e1.range, e1.r2l);
                    var f = u[0].val, m = h[0].val;
                    for(r = 1; r < u.length && f === m; r++)f = Math.min(f, u[r].val);
                    for(r = 1; r < h.length && f === m; r++)m = Math.max(m, h[r].val);
                    var y = e1.autorange, v = "reversed" === y || "min reversed" === y || "max reversed" === y;
                    if (!v && e1.range) {
                        var x = a.simpleMap(e1.range, e1.r2l);
                        v = x[1] < x[0];
                    }
                    "reversed" === e1.autorange && (e1.autorange = !0);
                    var _, b, w, T, A, M, S = e1.rangemode, E = "tozero" === S, C = "nonnegative" === S, L = e1._length, I = L / 10, P = 0;
                    for(r = 0; r < u.length; r++)for(_ = u[r], n = 0; n < h.length; n++)(M = (b = h[n]).val - _.val - p(e1, _.val, b.val)) > 0 && ((A = L - s(_) - l(b)) > I ? M / A > P && (w = _, T = b, P = M / A) : M / L > P && (w = {
                        val: _.val,
                        nopad: 1
                    }, T = {
                        val: b.val,
                        nopad: 1
                    }, P = M / L));
                    if (f === m) {
                        var z = f - 1, O = f + 1;
                        if (E) {
                            if (0 === f) i = [
                                0,
                                1
                            ];
                            else {
                                var D = (f > 0 ? h : u).reduce(function(t1, e1) {
                                    return Math.max(t1, l(e1));
                                }, 0), R = f / (1 - Math.min(.5, D / L));
                                i = f > 0 ? [
                                    0,
                                    R
                                ] : [
                                    R,
                                    0
                                ];
                            }
                        } else i = C ? [
                            Math.max(0, z),
                            Math.max(1, O)
                        ] : [
                            z,
                            O
                        ];
                    } else E ? (w.val >= 0 && (w = {
                        val: 0,
                        nopad: 1
                    }), T.val <= 0 && (T = {
                        val: 0,
                        nopad: 1
                    })) : C && (w.val - P * s(w) < 0 && (w = {
                        val: 0,
                        nopad: 1
                    }), T.val <= 0 && (T = {
                        val: 1,
                        nopad: 1
                    })), P = (T.val - w.val - p(e1, _.val, b.val)) / (L - s(w) - l(T)), i = [
                        w.val - P * s(w),
                        T.val + P * l(T)
                    ];
                    return i = k(i, e1), e1.limitRange && e1.limitRange(), v && i.reverse(), a.simpleMap(i, e1.l2r || Number);
                }
                function p(t1, e1, r) {
                    var n = 0;
                    if (t1.rangebreaks) for(var i = t1.locateBreaks(e1, r), a = 0; a < i.length; a++){
                        var o = i[a];
                        n += o.max - o.min;
                    }
                    return n;
                }
                function d(t1, e1, r) {
                    var i = .05 * e1._length, o = e1._anchorAxis || {};
                    if (-1 !== (e1.ticklabelposition || "").indexOf("inside") || -1 !== (o.ticklabelposition || "").indexOf("inside")) {
                        var s = e1.isReversed();
                        if (!s) {
                            var c = a.simpleMap(e1.range, e1.r2l);
                            s = c[1] < c[0];
                        }
                        s && (r = !r);
                    }
                    var u = 0;
                    return h(t1, e1._id) || (u = function(t1, e1, r) {
                        var i = 0, o = "x" === e1._id.charAt(0);
                        for(var s in t1._plots){
                            var c = t1._plots[s];
                            if (e1._id === c.xaxis._id || e1._id === c.yaxis._id) {
                                var u = (o ? c.yaxis : c.xaxis) || {};
                                if (-1 !== (u.ticklabelposition || "").indexOf("inside") && (!r && ("left" === u.side || "bottom" === u.side) || r && ("top" === u.side || "right" === u.side))) {
                                    if (u._vals) {
                                        var h = a.deg2rad(u._tickAngles[u._id + "tick"] || 0), f = Math.abs(Math.cos(h)), p = Math.abs(Math.sin(h));
                                        if (!u._vals[0].bb) {
                                            var d = u._id + "tick";
                                            u._selections[d].each(function(t1) {
                                                var e1 = n.select(this);
                                                e1.select(".text-math-group").empty() && (t1.bb = l.bBox(e1.node()));
                                            });
                                        }
                                        for(var g = 0; g < u._vals.length; g++){
                                            var y = u._vals[g].bb;
                                            if (y) {
                                                var v = 2 * m + y.width, x = 2 * m + y.height;
                                                i = Math.max(i, o ? Math.max(v * f, x * p) : Math.max(x * f, v * p));
                                            }
                                        }
                                    }
                                    "inside" === u.ticks && "inside" === u.ticklabelposition && (i += u.ticklen || 0);
                                }
                            }
                        }
                        return i;
                    }(t1, e1, r)), i = Math.max(u, i), "domain" === e1.constrain && e1._inputDomain && (i *= (e1._inputDomain[1] - e1._inputDomain[0]) / (e1.domain[1] - e1.domain[0])), function(t1) {
                        return t1.nopad ? 0 : t1.pad + (t1.extrapad ? i : u);
                    };
                }
                t1.exports = {
                    applyAutorangeOptions: k,
                    getAutoRange: f,
                    makePadFn: d,
                    doAutoRange: function(t1, e1, r) {
                        if (e1.setScale(), e1.autorange) {
                            e1.range = r ? r.slice() : f(t1, e1), e1._r = e1.range.slice(), e1._rl = a.simpleMap(e1._r, e1.r2l);
                            var n = e1._input, i = {};
                            i[e1._attr + ".range"] = e1.range, i[e1._attr + ".autorange"] = e1.autorange, s.call("_storeDirectGUIEdit", t1.layout, t1._fullLayout._preGUI, i), n.range = e1.range.slice(), n.autorange = e1.autorange;
                        }
                        var o = e1._anchorAxis;
                        if (o && o.rangeslider) {
                            var l = o.rangeslider[e1._name];
                            l && "auto" === l.rangemode && (l.range = f(t1, e1)), o._input.rangeslider[e1._name] = a.extendFlat({}, l);
                        }
                    },
                    findExtremes: function(t1, e1, r) {
                        r || (r = {}), t1._m || t1.setScale();
                        var n, a, s, l, c, u, h, f, p, d = [], m = [], g = e1.length, x = r.padded || !1, b = r.tozero && ("linear" === t1.type || "-" === t1.type), w = "log" === t1.type, T = !1, k = r.vpadLinearized || !1;
                        function A(t1) {
                            if (Array.isArray(t1)) return T = !0, function(e1) {
                                return Math.max(Number(t1[e1] || 0), 0);
                            };
                            var e1 = Math.max(Number(t1 || 0), 0);
                            return function() {
                                return e1;
                            };
                        }
                        var M = A((t1._m > 0 ? r.ppadplus : r.ppadminus) || r.ppad || 0), S = A((t1._m > 0 ? r.ppadminus : r.ppadplus) || r.ppad || 0), E = A(r.vpadplus || r.vpad), C = A(r.vpadminus || r.vpad);
                        if (!T) {
                            if (f = 1 / 0, p = -1 / 0, w) for(n = 0; n < g; n++)(a = e1[n]) < f && a > 0 && (f = a), a > p && a < o && (p = a);
                            else for(n = 0; n < g; n++)(a = e1[n]) < f && a > -o && (f = a), a > p && a < o && (p = a);
                            e1 = [
                                f,
                                p
                            ], g = 2;
                        }
                        var L = {
                            tozero: b,
                            extrapad: x
                        };
                        function I(r) {
                            s = e1[r], i(s) && (u = M(r), h = S(r), k ? (l = t1.c2l(s) - C(r), c = t1.c2l(s) + E(r)) : (f = s - C(r), p = s + E(r), w && f < p / 10 && (f = p / 10), l = t1.c2l(f), c = t1.c2l(p)), b && (l = Math.min(0, l), c = Math.max(0, c)), _(l) && y(d, l, h, L), _(c) && v(m, c, u, L));
                        }
                        var P = Math.min(6, g);
                        for(n = 0; n < P; n++)I(n);
                        for(n = g - 1; n >= P; n--)I(n);
                        return {
                            min: d,
                            max: m,
                            opts: r
                        };
                    },
                    concatExtremes: g
                };
                var m = 3;
                function g(t1, e1, r) {
                    var n, i, a, o = e1._id, s = t1._fullData, l = t1._fullLayout, c = [], h = [];
                    function f(t1, e1) {
                        for(n = 0; n < e1.length; n++){
                            var r = t1[e1[n]], s = (r._extremes || {})[o];
                            if (!0 === r.visible && s) {
                                for(i = 0; i < s.min.length; i++)a = s.min[i], y(c, a.val, a.pad, {
                                    extrapad: a.extrapad
                                });
                                for(i = 0; i < s.max.length; i++)a = s.max[i], v(h, a.val, a.pad, {
                                    extrapad: a.extrapad
                                });
                            }
                        }
                    }
                    if (f(s, e1._traceIndices), f(l.annotations || [], e1._annIndices || []), f(l.shapes || [], e1._shapeIndices || []), e1._matchGroup && !r) {
                        for(var p in e1._matchGroup)if (p !== e1._id) {
                            var d = u(t1, p), m = g(t1, d, !0), x = e1._length / d._length;
                            for(i = 0; i < m.min.length; i++)a = m.min[i], y(c, a.val, a.pad * x, {
                                extrapad: a.extrapad
                            });
                            for(i = 0; i < m.max.length; i++)a = m.max[i], v(h, a.val, a.pad * x, {
                                extrapad: a.extrapad
                            });
                        }
                    }
                    return {
                        min: c,
                        max: h
                    };
                }
                function y(t1, e1, r, n) {
                    x(t1, e1, r, n, b);
                }
                function v(t1, e1, r, n) {
                    x(t1, e1, r, n, w);
                }
                function x(t1, e1, r, n, i) {
                    for(var a = n.tozero, o = n.extrapad, s = !0, l = 0; l < t1.length && s; l++){
                        var c = t1[l];
                        if (i(c.val, e1) && c.pad >= r && (c.extrapad || !o)) {
                            s = !1;
                            break;
                        }
                        i(e1, c.val) && c.pad <= r && (o || !c.extrapad) && (t1.splice(l, 1), l--);
                    }
                    if (s) {
                        var u = a && 0 === e1;
                        t1.push({
                            val: e1,
                            pad: u ? 0 : r,
                            extrapad: !u && o
                        });
                    }
                }
                function _(t1) {
                    return i(t1) && Math.abs(t1) < o;
                }
                function b(t1, e1) {
                    return t1 <= e1;
                }
                function w(t1, e1) {
                    return t1 >= e1;
                }
                function T(t1, e1, r) {
                    return void 0 === e1 || void 0 === r || (e1 = t1.d2l(e1)) < t1.d2l(r);
                }
                function k(t1, e1) {
                    if (!e1 || !e1.autorangeoptions) return t1;
                    var r = t1[0], n = t1[1], i = e1.autorangeoptions.include;
                    if (void 0 !== i) {
                        var o = e1.d2l(r), s = e1.d2l(n);
                        a.isArrayOrTypedArray(i) || (i = [
                            i
                        ]);
                        for(var l = 0; l < i.length; l++){
                            var c = e1.d2l(i[l]);
                            o >= c && (o = c, r = c), s <= c && (s = c, n = c);
                        }
                    }
                    return r = function(t1, e1) {
                        var r = e1.autorangeoptions;
                        return r && void 0 !== r.minallowed && T(e1, r.minallowed, r.maxallowed) ? r.minallowed : r && void 0 !== r.clipmin && T(e1, r.clipmin, r.clipmax) ? Math.max(t1, e1.d2l(r.clipmin)) : t1;
                    }(r, e1), n = function(t1, e1) {
                        var r = e1.autorangeoptions;
                        return r && void 0 !== r.maxallowed && T(e1, r.minallowed, r.maxallowed) ? r.maxallowed : r && void 0 !== r.clipmax && T(e1, r.clipmin, r.clipmax) ? Math.min(t1, e1.d2l(r.clipmax)) : t1;
                    }(n, e1), [
                        r,
                        n
                    ];
                }
            },
            75511: function(t1) {
                "use strict";
                t1.exports = function(t1, e1, r) {
                    var n, i;
                    if (r) {
                        var a = "reversed" === e1 || "min reversed" === e1 || "max reversed" === e1;
                        n = r[a ? 1 : 0], i = r[a ? 0 : 1];
                    }
                    var o = t1("autorangeoptions.minallowed", null === i ? n : void 0), s = t1("autorangeoptions.maxallowed", null === n ? i : void 0);
                    void 0 === o && t1("autorangeoptions.clipmin"), void 0 === s && t1("autorangeoptions.clipmax"), t1("autorangeoptions.include");
                };
            },
            29714: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(10721), a = r(44122), o = r(33626), s = r(34809), l = s.strTranslate, c = r(30635), u = r(17240), h = r(78766), f = r(62203), p = r(25829), d = r(68599), m = r(63821), g = m.ONEMAXYEAR, y = m.ONEAVGYEAR, v = m.ONEMINYEAR, x = m.ONEMAXQUARTER, _ = m.ONEAVGQUARTER, b = m.ONEMINQUARTER, w = m.ONEMAXMONTH, T = m.ONEAVGMONTH, k = m.ONEMINMONTH, A = m.ONEWEEK, M = m.ONEDAY, S = M / 2, E = m.ONEHOUR, C = m.ONEMIN, L = m.ONESEC, I = m.ONEMILLI, P = m.ONEMICROSEC, z = m.MINUS_SIGN, O = m.BADNUM, D = {
                    K: "zeroline"
                }, R = {
                    K: "gridline",
                    L: "path"
                }, F = {
                    K: "minor-gridline",
                    L: "path"
                }, B = {
                    K: "tick",
                    L: "path"
                }, N = {
                    K: "tick",
                    L: "text"
                }, j = {
                    width: [
                        "x",
                        "r",
                        "l",
                        "xl",
                        "xr"
                    ],
                    height: [
                        "y",
                        "t",
                        "b",
                        "yt",
                        "yb"
                    ],
                    right: [
                        "r",
                        "xr"
                    ],
                    left: [
                        "l",
                        "xl"
                    ],
                    top: [
                        "t",
                        "yt"
                    ],
                    bottom: [
                        "b",
                        "yb"
                    ]
                }, U = r(4530), V = U.MID_SHIFT, q = U.CAP_SHIFT, H = U.LINE_SPACING, G = U.OPPOSITE_SIDE, Z = t1.exports = {};
                Z.setConvert = r(19091);
                var W = r(9666), Y = r(5975), X = Y.idSort, $ = Y.isLinked;
                Z.id2name = Y.id2name, Z.name2id = Y.name2id, Z.cleanId = Y.cleanId, Z.list = Y.list, Z.listIds = Y.listIds, Z.getFromId = Y.getFromId, Z.getFromTrace = Y.getFromTrace;
                var J = r(32919);
                Z.getAutoRange = J.getAutoRange, Z.findExtremes = J.findExtremes;
                var K = 1e-4;
                function Q(t1) {
                    var e1 = (t1[1] - t1[0]) * K;
                    return [
                        t1[0] - e1,
                        t1[1] + e1
                    ];
                }
                Z.coerceRef = function(t1, e1, r, n, i, a) {
                    var o = n.charAt(n.length - 1), l = r._fullLayout._subplots[o + "axis"], c = n + "ref", u = {};
                    return i || (i = l[0] || ("string" == typeof a ? a : a[0])), a || (a = i), l = l.concat(l.map(function(t1) {
                        return t1 + " domain";
                    })), u[c] = {
                        valType: "enumerated",
                        values: l.concat(a ? "string" == typeof a ? [
                            a
                        ] : a : []),
                        dflt: i
                    }, s.coerce(t1, e1, u, c);
                }, Z.getRefType = function(t1) {
                    return void 0 === t1 ? t1 : "paper" === t1 ? "paper" : "pixel" === t1 ? "pixel" : /( domain)$/.test(t1) ? "domain" : "range";
                }, Z.coercePosition = function(t1, e1, r, n, i, a) {
                    var o, l;
                    if ("range" !== Z.getRefType(n)) o = s.ensureNumber, l = r(i, a);
                    else {
                        var c = Z.getFromId(e1, n);
                        l = r(i, a = c.fraction2r(a)), o = c.cleanPos;
                    }
                    t1[i] = o(l);
                }, Z.cleanPosition = function(t1, e1, r) {
                    return ("paper" === r || "pixel" === r ? s.ensureNumber : Z.getFromId(e1, r).cleanPos)(t1);
                }, Z.redrawComponents = function(t1, e1) {
                    e1 = e1 || Z.listIds(t1);
                    var r = t1._fullLayout;
                    function n(n, i, a, s) {
                        for(var l = o.getComponentMethod(n, i), c = {}, u = 0; u < e1.length; u++)for(var h = r[Z.id2name(e1[u])][a], f = 0; f < h.length; f++){
                            var p = h[f];
                            if (!c[p] && (l(t1, p), c[p] = 1, s)) return;
                        }
                    }
                    n("annotations", "drawOne", "_annIndices"), n("shapes", "drawOne", "_shapeIndices"), n("images", "draw", "_imgIndices", !0), n("selections", "drawOne", "_selectionIndices");
                };
                var tt = Z.getDataConversions = function(t1, e1, r, n) {
                    var i, a = "x" === r || "y" === r || "z" === r ? r : n;
                    if (s.isArrayOrTypedArray(a)) {
                        if (i = {
                            type: W(n, void 0, {
                                autotypenumbers: t1._fullLayout.autotypenumbers
                            }),
                            _categories: []
                        }, Z.setConvert(i), "category" === i.type) for(var o = 0; o < n.length; o++)i.d2c(n[o]);
                    } else i = Z.getFromTrace(t1, e1, a);
                    return i ? {
                        d2c: i.d2c,
                        c2d: i.c2d
                    } : "ids" === a ? {
                        d2c: rt,
                        c2d: rt
                    } : {
                        d2c: et,
                        c2d: et
                    };
                };
                function et(t1) {
                    return +t1;
                }
                function rt(t1) {
                    return String(t1);
                }
                function nt(t1, e1) {
                    return Math.abs((t1 / e1 + .5) % 1 - .5) < .001;
                }
                function it(t1, e1) {
                    return Math.abs(t1 / e1 - 1) < .001;
                }
                function at(t1) {
                    return +t1.substring(1);
                }
                function ot(t1, e1) {
                    return t1.rangebreaks && (e1 = e1.filter(function(e1) {
                        return t1.maskBreaks(e1.x) !== O;
                    })), e1;
                }
                function st(t1) {
                    var e1 = t1._mainAxis, r = [];
                    if (e1._vals) {
                        for(var n = 0; n < e1._vals.length; n++)if (!e1._vals[n].noTick) {
                            var i = e1.l2p(e1._vals[n].x), a = t1.p2l(i), o = Z.tickText(t1, a);
                            e1._vals[n].minor && (o.minor = !0, o.text = ""), r.push(o);
                        }
                    }
                    return ot(t1, r);
                }
                function lt(t1, e1) {
                    var r = Q(s.simpleMap(t1.range, t1.r2l)), n = Math.min(r[0], r[1]), i = Math.max(r[0], r[1]), a = "category" === t1.type ? t1.d2l_noadd : t1.d2l;
                    "log" === t1.type && "L" !== String(t1.dtick).charAt(0) && (t1.dtick = "L" + Math.pow(10, Math.floor(Math.min(t1.range[0], t1.range[1])) - 1));
                    for(var o = [], l = 0; l <= 1; l++)if ((void 0 === e1 || !(e1 && l || !1 === e1 && !l)) && (!l || t1.minor)) {
                        var c = l ? t1.minor.tickvals : t1.tickvals, u = l ? [] : t1.ticktext;
                        if (c) {
                            s.isArrayOrTypedArray(u) || (u = []);
                            for(var h = 0; h < c.length; h++){
                                var f = a(c[h]);
                                if (f > n && f < i) {
                                    var p = Z.tickText(t1, f, !1, String(u[h]));
                                    l && (p.minor = !0, p.text = ""), o.push(p);
                                }
                            }
                        }
                    }
                    return ot(t1, o);
                }
                Z.getDataToCoordFunc = function(t1, e1, r, n) {
                    return tt(t1, e1, r, n).d2c;
                }, Z.counterLetter = function(t1) {
                    var e1 = t1.charAt(0);
                    return "x" === e1 ? "y" : "y" === e1 ? "x" : void 0;
                }, Z.minDtick = function(t1, e1, r, n) {
                    -1 === [
                        "log",
                        "category",
                        "multicategory"
                    ].indexOf(t1.type) && n ? void 0 === t1._minDtick ? (t1._minDtick = e1, t1._forceTick0 = r) : t1._minDtick && ((t1._minDtick / e1 + 1e-6) % 1 < 2e-6 && ((r - t1._forceTick0) / e1 % 1 + 1.000001) % 1 < 2e-6 ? (t1._minDtick = e1, t1._forceTick0 = r) : ((e1 / t1._minDtick + 1e-6) % 1 > 2e-6 || ((r - t1._forceTick0) / t1._minDtick % 1 + 1.000001) % 1 > 2e-6) && (t1._minDtick = 0)) : t1._minDtick = 0;
                }, Z.saveRangeInitial = function(t1, e1) {
                    for(var r = Z.list(t1, "", !0), n = !1, i = 0; i < r.length; i++){
                        var a = r[i], o = void 0 === a._rangeInitial0 && void 0 === a._rangeInitial1, s = o || a.range[0] !== a._rangeInitial0 || a.range[1] !== a._rangeInitial1, l = a.autorange;
                        (o && !0 !== l || e1 && s) && (a._rangeInitial0 = "min" === l || "max reversed" === l ? void 0 : a.range[0], a._rangeInitial1 = "max" === l || "min reversed" === l ? void 0 : a.range[1], a._autorangeInitial = l, n = !0);
                    }
                    return n;
                }, Z.saveShowSpikeInitial = function(t1, e1) {
                    for(var r = Z.list(t1, "", !0), n = !1, i = "on", a = 0; a < r.length; a++){
                        var o = r[a], s = void 0 === o._showSpikeInitial, l = s || !(o.showspikes === o._showspikes);
                        (s || e1 && l) && (o._showSpikeInitial = o.showspikes, n = !0), "on" !== i || o.showspikes || (i = "off");
                    }
                    return t1._fullLayout._cartesianSpikesEnabled = i, n;
                }, Z.autoBin = function(t1, e1, r, n, a, o) {
                    var l, c = s.aggNums(Math.min, null, t1), u = s.aggNums(Math.max, null, t1);
                    if ("category" === e1.type || "multicategory" === e1.type) return {
                        start: c - .5,
                        end: u + .5,
                        size: Math.max(1, Math.round(o) || 1),
                        _dataSpan: u - c
                    };
                    if (a || (a = e1.calendar), l = "log" === e1.type ? {
                        type: "linear",
                        range: [
                            c,
                            u
                        ]
                    } : {
                        type: e1.type,
                        range: s.simpleMap([
                            c,
                            u
                        ], e1.c2r, 0, a),
                        calendar: a
                    }, Z.setConvert(l), o = o && d.dtick(o, l.type)) l.dtick = o, l.tick0 = d.tick0(void 0, l.type, a);
                    else {
                        var h;
                        if (r) h = (u - c) / r;
                        else {
                            var f = s.distinctVals(t1), p = Math.pow(10, Math.floor(Math.log(f.minDiff) / Math.LN10)), m = p * s.roundUp(f.minDiff / p, [
                                .9,
                                1.9,
                                4.9,
                                9.9
                            ], !0);
                            h = Math.max(m, 2 * s.stdev(t1) / Math.pow(t1.length, n ? .25 : .4)), i(h) || (h = 1);
                        }
                        Z.autoTicks(l, h);
                    }
                    var g, y = l.dtick, v = Z.tickIncrement(Z.tickFirst(l), y, "reverse", a);
                    if ("number" == typeof y) v = function(t1, e1, r, n, a) {
                        var o = 0, s = 0, l = 0, c = 0;
                        function u(e1) {
                            return (1 + 100 * (e1 - t1) / r.dtick) % 100 < 2;
                        }
                        for(var h = 0; h < e1.length; h++)e1[h] % 1 == 0 ? l++ : i(e1[h]) || c++, u(e1[h]) && o++, u(e1[h] + r.dtick / 2) && s++;
                        var f = e1.length - c;
                        if (l === f && "date" !== r.type) r.dtick < 1 ? t1 = n - .5 * r.dtick : (t1 -= .5) + r.dtick < n && (t1 += r.dtick);
                        else if (s < .1 * f && (o > .3 * f || u(n) || u(a))) {
                            var p = r.dtick / 2;
                            t1 += t1 + p < n ? p : -p;
                        }
                        return t1;
                    }(v, t1, l, c, u), g = v + (1 + Math.floor((u - v) / y)) * y;
                    else for("M" === l.dtick.charAt(0) && (v = function(t1, e1, r, n, i) {
                        var a = s.findExactDates(e1, i);
                        if (a.exactDays > .8) {
                            var o = Number(r.substr(1));
                            a.exactYears > .8 && o % 12 == 0 ? t1 = Z.tickIncrement(t1, "M6", "reverse") + 1.5 * M : a.exactMonths > .8 ? t1 = Z.tickIncrement(t1, "M1", "reverse") + 15.5 * M : t1 -= S;
                            var l = Z.tickIncrement(t1, r);
                            if (l <= n) return l;
                        }
                        return t1;
                    }(v, t1, y, c, a)), g = v; g <= u;)g = Z.tickIncrement(g, y, !1, a);
                    return {
                        start: e1.c2r(v, 0, a),
                        end: e1.c2r(g, 0, a),
                        size: y,
                        _dataSpan: u - c
                    };
                }, Z.prepMinorTicks = function(t1, e1, r) {
                    if (!e1.minor.dtick) {
                        delete t1.dtick;
                        var n, a = e1.dtick && i(e1._tmin);
                        if (a) {
                            var o = Z.tickIncrement(e1._tmin, e1.dtick, !0);
                            n = [
                                e1._tmin,
                                .99 * o + .01 * e1._tmin
                            ];
                        } else {
                            var l = s.simpleMap(e1.range, e1.r2l);
                            n = [
                                l[0],
                                .8 * l[0] + .2 * l[1]
                            ];
                        }
                        if (t1.range = s.simpleMap(n, e1.l2r), t1._isMinor = !0, Z.prepTicks(t1, r), a) {
                            var c = i(e1.dtick), u = i(t1.dtick), h = c ? e1.dtick : +e1.dtick.substring(1), f = u ? t1.dtick : +t1.dtick.substring(1);
                            c && u ? nt(h, f) ? h === 2 * A && f === 2 * M && (t1.dtick = A) : h === 2 * A && f === 3 * M ? t1.dtick = A : h !== A || (e1._input.minor || {}).nticks ? it(h / f, 2.5) ? t1.dtick = h / 2 : t1.dtick = h : t1.dtick = M : "M" === String(e1.dtick).charAt(0) ? u ? t1.dtick = "M1" : nt(h, f) ? h >= 12 && 2 === f && (t1.dtick = "M3") : t1.dtick = e1.dtick : "L" === String(t1.dtick).charAt(0) ? "L" === String(e1.dtick).charAt(0) ? nt(h, f) || (t1.dtick = it(h / f, 2.5) ? e1.dtick / 2 : e1.dtick) : t1.dtick = "D1" : "D2" === t1.dtick && +e1.dtick > 1 && (t1.dtick = 1);
                        }
                        t1.range = e1.range;
                    }
                    void 0 === e1.minor._tick0Init && (t1.tick0 = e1.tick0);
                }, Z.prepTicks = function(t1, e1) {
                    var r = s.simpleMap(t1.range, t1.r2l, void 0, void 0, e1);
                    if ("auto" === t1.tickmode || !t1.dtick) {
                        var n, a = t1.nticks;
                        a || ("category" === t1.type || "multicategory" === t1.type ? (n = t1.tickfont ? s.bigFont(t1.tickfont.size || 12) : 15, a = t1._length / n) : (n = "y" === t1._id.charAt(0) ? 40 : 80, a = s.constrain(t1._length / n, 4, 9) + 1), "radialaxis" === t1._name && (a *= 2)), t1.minor && "array" !== t1.minor.tickmode || "array" === t1.tickmode && (a *= 100), t1._roughDTick = Math.abs(r[1] - r[0]) / a, Z.autoTicks(t1, t1._roughDTick), t1._minDtick > 0 && t1.dtick < 2 * t1._minDtick && (t1.dtick = t1._minDtick, t1.tick0 = t1.l2r(t1._forceTick0));
                    }
                    "period" === t1.ticklabelmode && function(t1) {
                        var e1;
                        function r() {
                            return !(i(t1.dtick) || "M" !== t1.dtick.charAt(0));
                        }
                        var n = r(), a = Z.getTickFormat(t1);
                        if (a) {
                            var o = t1._dtickInit !== t1.dtick;
                            /%[fLQsSMX]/.test(a) || (/%[HI]/.test(a) ? (e1 = E, o && !n && t1.dtick < E && (t1.dtick = E)) : /%p/.test(a) ? (e1 = S, o && !n && t1.dtick < S && (t1.dtick = S)) : /%[Aadejuwx]/.test(a) ? (e1 = M, o && !n && t1.dtick < M && (t1.dtick = M)) : /%[UVW]/.test(a) ? (e1 = A, o && !n && t1.dtick < A && (t1.dtick = A)) : /%[Bbm]/.test(a) ? (e1 = T, o && (n ? at(t1.dtick) < 1 : t1.dtick < k) && (t1.dtick = "M1")) : /%[q]/.test(a) ? (e1 = _, o && (n ? at(t1.dtick) < 3 : t1.dtick < b) && (t1.dtick = "M3")) : /%[Yy]/.test(a) && (e1 = y, o && (n ? at(t1.dtick) < 12 : t1.dtick < v) && (t1.dtick = "M12")));
                        }
                        (n = r()) && t1.tick0 === t1._dowTick0 && (t1.tick0 = t1._rawTick0), t1._definedDelta = e1;
                    }(t1), t1.tick0 || (t1.tick0 = "date" === t1.type ? "2000-01-01" : 0), "date" === t1.type && t1.dtick < .1 && (t1.dtick = .1), yt(t1);
                }, Z.calcTicks = function(t1, e1) {
                    for(var r, n, a, o, l = t1.type, c = t1.calendar, u = t1.ticklabelstep, h = "period" === t1.ticklabelmode, f = t1.range[0] > t1.range[1], p = !t1.ticklabelindex || s.isArrayOrTypedArray(t1.ticklabelindex) ? t1.ticklabelindex : [
                        t1.ticklabelindex
                    ], d = s.simpleMap(t1.range, t1.r2l, void 0, void 0, e1), m = d[1] < d[0], z = Math.min(d[0], d[1]), D = Math.max(d[0], d[1]), R = Math.max(1e3, t1._length || 0), F = [], B = [], N = [], j = [], U = [], V = t1.minor && (t1.minor.ticks || t1.minor.showgrid), q = 1; q >= (V ? 0 : 1); q--){
                        var H = !q;
                        q ? (t1._dtickInit = t1.dtick, t1._tick0Init = t1.tick0) : (t1.minor._dtickInit = t1.minor.dtick, t1.minor._tick0Init = t1.minor.tick0);
                        var G = q ? t1 : s.extendFlat({}, t1, t1.minor);
                        if (H ? Z.prepMinorTicks(G, t1, e1) : Z.prepTicks(G, e1), "array" !== G.tickmode) {
                            if ("sync" !== G.tickmode) {
                                var W = Q(d), Y = W[0], X = W[1], $ = i(G.dtick), J = "log" === l && !($ || "L" === G.dtick.charAt(0)), K = Z.tickFirst(G, e1);
                                if (q) {
                                    if (t1._tmin = K, K < Y !== m) break;
                                    "category" !== l && "multicategory" !== l || (X = m ? Math.max(-0.5, X) : Math.min(t1._categories.length - .5, X));
                                }
                                var tt, et, rt = null, nt = K;
                                q && ($ ? et = t1.dtick : "date" === l ? "string" == typeof t1.dtick && "M" === t1.dtick.charAt(0) && (et = T * t1.dtick.substring(1)) : et = t1._roughDTick, tt = Math.round((t1.r2l(nt) - t1.r2l(t1.tick0)) / et) - 1);
                                var it = G.dtick;
                                for(G.rangebreaks && G._tick0Init !== G.tick0 && (nt = Ft(nt, t1), m || (nt = Z.tickIncrement(nt, it, !m, c))), q && h && (nt = Z.tickIncrement(nt, it, !m, c), tt--); m ? nt >= X : nt <= X; nt = Z.tickIncrement(nt, it, m, c)){
                                    if (q && tt++, G.rangebreaks && !m) {
                                        if (nt < Y) continue;
                                        if (G.maskBreaks(nt) === O && Ft(nt, G) >= D) break;
                                    }
                                    if (N.length > R || nt === rt) break;
                                    rt = nt;
                                    var at = {
                                        value: nt
                                    };
                                    q ? (J && nt !== (0 | nt) && (at.simpleLabel = !0), u > 1 && tt % u && (at.skipLabel = !0), N.push(at)) : (at.minor = !0, j.push(at));
                                }
                            } else N = [], F = st(t1);
                        } else q ? (N = [], F = lt(t1, !H)) : (j = [], B = lt(t1, !H));
                    }
                    !j || j.length < 2 ? p = !1 : (r = (j[1].value - j[0].value) * (f ? -1 : 1), n = t1.tickformat, (/%f/.test(n) ? r >= P : /%L/.test(n) ? r >= I : /%[SX]/.test(n) ? r >= L : /%M/.test(n) ? r >= C : /%[HI]/.test(n) ? r >= E : /%p/.test(n) ? r >= S : /%[Aadejuwx]/.test(n) ? r >= M : /%[UVW]/.test(n) ? r >= A : /%[Bbm]/.test(n) ? r >= k : /%[q]/.test(n) ? r >= b : !/%[Yy]/.test(n) || r >= v) || (p = !1));
                    if (p) {
                        var ot = N.concat(j);
                        h && N.length && (ot = ot.slice(1)), (ot = ot.sort(function(t1, e1) {
                            return t1.value - e1.value;
                        }).filter(function(t1, e1, r) {
                            return 0 === e1 || t1.value !== r[e1 - 1].value;
                        })).map(function(t1, e1) {
                            return void 0 !== t1.minor || t1.skipLabel ? null : e1;
                        }).filter(function(t1) {
                            return null !== t1;
                        }).forEach(function(t1) {
                            p.map(function(e1) {
                                var r = t1 + e1;
                                r >= 0 && r < ot.length && s.pushUnique(U, ot[r]);
                            });
                        });
                    } else U = N;
                    if (V && !("inside" === t1.minor.ticks && "outside" === t1.ticks || "outside" === t1.minor.ticks && "inside" === t1.ticks)) {
                        for(var ct = N.map(function(t1) {
                            return t1.value;
                        }), ut = [], ht = 0; ht < j.length; ht++){
                            var ft = j[ht], pt = ft.value;
                            if (-1 === ct.indexOf(pt)) {
                                for(var dt = !1, mt = 0; !dt && mt < N.length; mt++)1e7 + N[mt].value === 1e7 + pt && (dt = !0);
                                dt || ut.push(ft);
                            }
                        }
                        j = ut;
                    }
                    if (h && function(t1, e1, r) {
                        for(var n = 0; n < t1.length; n++){
                            var i = t1[n].value, a = n, o = n + 1;
                            n < t1.length - 1 ? (a = n, o = n + 1) : n > 0 ? (a = n - 1, o = n) : (a = n, o = n);
                            var s, l = t1[a].value, c = t1[o].value, u = Math.abs(c - l), h = r || u, f = 0;
                            h >= v ? f = u >= v && u <= g ? u : y : r === _ && h >= b ? f = u >= b && u <= x ? u : _ : h >= k ? f = u >= k && u <= w ? u : T : r === A && h >= A ? f = A : h >= M ? f = M : r === S && h >= S ? f = S : r === E && h >= E && (f = E), f >= u && (f = u, s = !0);
                            var p = i + f;
                            if (e1.rangebreaks && f > 0) {
                                for(var d = 0, m = 0; m < 84; m++){
                                    var C = (m + .5) / 84;
                                    e1.maskBreaks(i * (1 - C) + C * p) !== O && d++;
                                }
                                (f *= d / 84) || (t1[n].drop = !0), s && u > A && (f = u);
                            }
                            (f > 0 || 0 === n) && (t1[n].periodX = i + f / 2);
                        }
                    }(U, t1, t1._definedDelta), t1.rangebreaks) {
                        var gt = "y" === t1._id.charAt(0), yt = 1;
                        "auto" === t1.tickmode && (yt = t1.tickfont ? t1.tickfont.size : 12);
                        var vt = NaN;
                        for(a = N.length - 1; a > -1; a--)if (N[a].drop) N.splice(a, 1);
                        else {
                            N[a].value = Ft(N[a].value, t1);
                            var xt = t1.c2p(N[a].value);
                            (gt ? vt > xt - yt : vt < xt + yt) ? N.splice(m ? a + 1 : a, 1) : vt = xt;
                        }
                    }
                    Rt(t1) && 360 === Math.abs(d[1] - d[0]) && N.pop(), t1._tmax = (N[N.length - 1] || {}).value, t1._prevDateHead = "", t1._inCalcTicks = !0;
                    var _t, bt = function(e1) {
                        e1.text = "", t1._prevDateHead = o;
                    };
                    function wt(t1, e1) {
                        var r = Z.tickText(t1, e1.value, !1, e1.simpleLabel), n = e1.periodX;
                        return void 0 !== n && (r.periodX = n, (n > D || n < z) && (n > D && (r.periodX = D), n < z && (r.periodX = z), bt(r))), r;
                    }
                    for(N = N.concat(j), a = 0; a < N.length; a++){
                        var Tt = N[a].minor, kt = N[a].value;
                        Tt ? ((_t = p && -1 !== U.indexOf(N[a]) ? wt(t1, N[a]) : {
                            x: kt
                        }).minor = !0, B.push(_t)) : (o = t1._prevDateHead, _t = wt(t1, N[a]), (N[a].skipLabel || p && -1 === U.indexOf(N[a])) && bt(_t), F.push(_t));
                    }
                    return F = F.concat(B), t1._inCalcTicks = !1, h && F.length && (F[0].noTick = !0), F;
                };
                var ct = [
                    2,
                    5,
                    10
                ], ut = [
                    1,
                    2,
                    3,
                    6,
                    12
                ], ht = [
                    1,
                    2,
                    5,
                    10,
                    15,
                    30
                ], ft = [
                    1,
                    2,
                    3,
                    7,
                    14
                ], pt = [
                    -0.046,
                    0,
                    .301,
                    .477,
                    .602,
                    .699,
                    .778,
                    .845,
                    .903,
                    .954,
                    1
                ], dt = [
                    -0.301,
                    0,
                    .301,
                    .699,
                    1
                ], mt = [
                    15,
                    30,
                    45,
                    90,
                    180
                ];
                function gt(t1, e1, r) {
                    return e1 * s.roundUp(t1 / e1, r);
                }
                function yt(t1) {
                    var e1 = t1.dtick;
                    if (t1._tickexponent = 0, i(e1) || "string" == typeof e1 || (e1 = 1), "category" !== t1.type && "multicategory" !== t1.type || (t1._tickround = null), "date" === t1.type) {
                        var r = t1.r2l(t1.tick0), n = t1.l2r(r).replace(/(^-|i)/g, ""), a = n.length;
                        if ("M" === String(e1).charAt(0)) a > 10 || "01-01" !== n.substr(5) ? t1._tickround = "d" : t1._tickround = +e1.substr(1) % 12 == 0 ? "y" : "m";
                        else if (e1 >= M && a <= 10 || e1 >= 15 * M) t1._tickround = "d";
                        else if (e1 >= C && a <= 16 || e1 >= E) t1._tickround = "M";
                        else if (e1 >= L && a <= 19 || e1 >= C) t1._tickround = "S";
                        else {
                            var o = t1.l2r(r + e1).replace(/^-/, "").length;
                            t1._tickround = Math.max(a, o) - 20, t1._tickround < 0 && (t1._tickround = 4);
                        }
                    } else if (i(e1) || "L" === e1.charAt(0)) {
                        var s = t1.range.map(t1.r2d || Number);
                        i(e1) || (e1 = Number(e1.substr(1))), t1._tickround = 2 - Math.floor(Math.log(e1) / Math.LN10 + .01);
                        var l = Math.max(Math.abs(s[0]), Math.abs(s[1])), c = Math.floor(Math.log(l) / Math.LN10 + .01), u = void 0 === t1.minexponent ? 3 : t1.minexponent;
                        Math.abs(c) > u && (_t(t1.exponentformat) && !bt(c) ? t1._tickexponent = 3 * Math.round((c - 1) / 3) : t1._tickexponent = c);
                    } else t1._tickround = null;
                }
                function vt(t1, e1, r) {
                    var n = t1.tickfont || {};
                    return {
                        x: e1,
                        dx: 0,
                        dy: 0,
                        text: r || "",
                        fontSize: n.size,
                        font: n.family,
                        fontWeight: n.weight,
                        fontStyle: n.style,
                        fontVariant: n.variant,
                        fontTextcase: n.textcase,
                        fontLineposition: n.lineposition,
                        fontShadow: n.shadow,
                        fontColor: n.color
                    };
                }
                Z.autoTicks = function(t1, e1, r) {
                    var n;
                    function a(t1) {
                        return Math.pow(t1, Math.floor(Math.log(e1) / Math.LN10));
                    }
                    if ("date" === t1.type) {
                        t1.tick0 = s.dateTick0(t1.calendar, 0);
                        var o = 2 * e1;
                        if (o > y) e1 /= y, n = a(10), t1.dtick = "M" + 12 * gt(e1, n, ct);
                        else if (o > T) e1 /= T, t1.dtick = "M" + gt(e1, 1, ut);
                        else if (o > M) {
                            if (t1.dtick = gt(e1, M, t1._hasDayOfWeekBreaks ? [
                                1,
                                2,
                                7,
                                14
                            ] : ft), !r) {
                                var l = Z.getTickFormat(t1), c = "period" === t1.ticklabelmode;
                                c && (t1._rawTick0 = t1.tick0), /%[uVW]/.test(l) ? t1.tick0 = s.dateTick0(t1.calendar, 2) : t1.tick0 = s.dateTick0(t1.calendar, 1), c && (t1._dowTick0 = t1.tick0);
                            }
                        } else o > E ? t1.dtick = gt(e1, E, ut) : o > C ? t1.dtick = gt(e1, C, ht) : o > L ? t1.dtick = gt(e1, L, ht) : (n = a(10), t1.dtick = gt(e1, n, ct));
                    } else if ("log" === t1.type) {
                        t1.tick0 = 0;
                        var u = s.simpleMap(t1.range, t1.r2l);
                        if (t1._isMinor && (e1 *= 1.5), e1 > .7) t1.dtick = Math.ceil(e1);
                        else if (Math.abs(u[1] - u[0]) < 1) {
                            var h = 1.5 * Math.abs((u[1] - u[0]) / e1);
                            e1 = Math.abs(Math.pow(10, u[1]) - Math.pow(10, u[0])) / h, n = a(10), t1.dtick = "L" + gt(e1, n, ct);
                        } else t1.dtick = e1 > .3 ? "D2" : "D1";
                    } else "category" === t1.type || "multicategory" === t1.type ? (t1.tick0 = 0, t1.dtick = Math.ceil(Math.max(e1, 1))) : Rt(t1) ? (t1.tick0 = 0, n = 1, t1.dtick = gt(e1, n, mt)) : (t1.tick0 = 0, n = a(10), t1.dtick = gt(e1, n, ct));
                    if (0 === t1.dtick && (t1.dtick = 1), !i(t1.dtick) && "string" != typeof t1.dtick) {
                        var f = t1.dtick;
                        throw t1.dtick = 1, "ax.dtick error: " + String(f);
                    }
                }, Z.tickIncrement = function(t1, e1, r, a) {
                    var o = r ? -1 : 1;
                    if (i(e1)) return s.increment(t1, o * e1);
                    var l = e1.charAt(0), c = o * Number(e1.substr(1));
                    if ("M" === l) return s.incrementMonth(t1, c, a);
                    if ("L" === l) return Math.log(Math.pow(10, t1) + c) / Math.LN10;
                    if ("D" === l) {
                        var u = "D2" === e1 ? dt : pt, h = t1 + .01 * o, f = s.roundUp(s.mod(h, 1), u, r);
                        return Math.floor(h) + Math.log(n.round(Math.pow(10, f), 1)) / Math.LN10;
                    }
                    throw "unrecognized dtick " + String(e1);
                }, Z.tickFirst = function(t1, e1) {
                    var r = t1.r2l || Number, a = s.simpleMap(t1.range, r, void 0, void 0, e1), o = a[1] < a[0], l = o ? Math.floor : Math.ceil, c = Q(a)[0], u = t1.dtick, h = r(t1.tick0);
                    if (i(u)) {
                        var f = l((c - h) / u) * u + h;
                        return "category" !== t1.type && "multicategory" !== t1.type || (f = s.constrain(f, 0, t1._categories.length - 1)), f;
                    }
                    var p = u.charAt(0), d = Number(u.substr(1));
                    if ("M" === p) {
                        for(var m, g, y, v = 0, x = h; v < 10;){
                            if (((m = Z.tickIncrement(x, u, o, t1.calendar)) - c) * (x - c) <= 0) return o ? Math.min(x, m) : Math.max(x, m);
                            g = (c - (x + m) / 2) / (m - x), y = p + (Math.abs(Math.round(g)) || 1) * d, x = Z.tickIncrement(x, y, g < 0 ? !o : o, t1.calendar), v++;
                        }
                        return s.error("tickFirst did not converge", t1), x;
                    }
                    if ("L" === p) return Math.log(l((Math.pow(10, c) - h) / d) * d + h) / Math.LN10;
                    if ("D" === p) {
                        var _ = "D2" === u ? dt : pt, b = s.roundUp(s.mod(c, 1), _, o);
                        return Math.floor(c) + Math.log(n.round(Math.pow(10, b), 1)) / Math.LN10;
                    }
                    throw "unrecognized dtick " + String(u);
                }, Z.tickText = function(t1, e1, r, n) {
                    var a, o = vt(t1, e1), l = "array" === t1.tickmode, c = r || l, u = t1.type, h = "category" === u ? t1.d2l_noadd : t1.d2l, f = function(e1) {
                        var r = t1.l2p(e1);
                        return r >= 0 && r <= t1._length ? e1 : null;
                    };
                    if (l && s.isArrayOrTypedArray(t1.ticktext)) {
                        var p = s.simpleMap(t1.range, t1.r2l), d = (Math.abs(p[1] - p[0]) - (t1._lBreaks || 0)) / 1e4;
                        for(a = 0; a < t1.ticktext.length && !(Math.abs(e1 - h(t1.tickvals[a])) < d); a++);
                        if (a < t1.ticktext.length) return o.text = String(t1.ticktext[a]), o.xbnd = [
                            f(o.x - .5),
                            f(o.x + t1.dtick - .5)
                        ], o;
                    }
                    function m(n) {
                        if (void 0 === n) return !0;
                        if (r) return "none" === n;
                        var i = {
                            first: t1._tmin,
                            last: t1._tmax
                        }[n];
                        return "all" !== n && e1 !== i;
                    }
                    var g = r ? "never" : "none" !== t1.exponentformat && m(t1.showexponent) ? "hide" : "";
                    if ("date" === u ? function(t1, e1, r, n) {
                        var a = t1._tickround, o = r && t1.hoverformat || Z.getTickFormat(t1);
                        (n = !o && n) && (a = i(a) ? 4 : ({
                            y: "m",
                            m: "d",
                            d: "M",
                            M: "S",
                            S: 4
                        })[a]);
                        var l, c = s.formatDate(e1.x, o, a, t1._dateFormat, t1.calendar, t1._extraFormat), u = c.indexOf("\n");
                        if (-1 !== u && (l = c.substr(u + 1), c = c.substr(0, u)), n && (void 0 === l || "00:00:00" !== c && "00:00" !== c ? 8 === c.length && (c = c.replace(/:00$/, "")) : (c = l, l = "")), l) {
                            if (r) "d" === a ? c += ", " + l : c = l + (c ? ", " + c : "");
                            else if (t1._inCalcTicks && t1._prevDateHead === l) {
                                var h = Bt(t1), f = t1._trueSide || t1.side;
                                (!h && "top" === f || h && "bottom" === f) && (c += "<br> ");
                            } else t1._prevDateHead = l, c += "<br>" + l;
                        }
                        e1.text = c;
                    }(t1, o, r, c) : "log" === u ? function(t1, e1, r, n, a) {
                        var o = t1.dtick, l = e1.x, c = t1.tickformat, u = "string" == typeof o && o.charAt(0);
                        if ("never" === a && (a = ""), n && "L" !== u && (o = "L3", u = "L"), c || "L" === u) e1.text = wt(Math.pow(10, l), t1, a, n);
                        else if (i(o) || "D" === u && s.mod(l + .01, 1) < .1) {
                            var h = Math.round(l), f = Math.abs(h), p = t1.exponentformat;
                            "power" === p || _t(p) && bt(h) ? (e1.text = 0 === h ? 1 : 1 === h ? "10" : "10<sup>" + (h > 1 ? "" : z) + f + "</sup>", e1.fontSize *= 1.25) : ("e" === p || "E" === p) && f > 2 ? e1.text = "1" + p + (h > 0 ? "+" : z) + f : (e1.text = wt(Math.pow(10, l), t1, "", "fakehover"), "D1" === o && "y" === t1._id.charAt(0) && (e1.dy -= e1.fontSize / 6));
                        } else {
                            if ("D" !== u) throw "unrecognized dtick " + String(o);
                            e1.text = String(Math.round(Math.pow(10, s.mod(l, 1)))), e1.fontSize *= .75;
                        }
                        if ("D1" === t1.dtick) {
                            var d = String(e1.text).charAt(0);
                            "0" !== d && "1" !== d || ("y" === t1._id.charAt(0) ? e1.dx -= e1.fontSize / 4 : (e1.dy += e1.fontSize / 2, e1.dx += (t1.range[1] > t1.range[0] ? 1 : -1) * e1.fontSize * (l < 0 ? .5 : .25)));
                        }
                    }(t1, o, 0, c, g) : "category" === u ? function(t1, e1) {
                        var r = t1._categories[Math.round(e1.x)];
                        void 0 === r && (r = ""), e1.text = String(r);
                    }(t1, o) : "multicategory" === u ? function(t1, e1, r) {
                        var n = Math.round(e1.x), i = t1._categories[n] || [], a = void 0 === i[1] ? "" : String(i[1]), o = void 0 === i[0] ? "" : String(i[0]);
                        r ? e1.text = o + " - " + a : (e1.text = a, e1.text2 = o);
                    }(t1, o, r) : Rt(t1) ? function(t1, e1, r, n, i) {
                        if ("radians" !== t1.thetaunit || r) e1.text = wt(e1.x, t1, i, n);
                        else {
                            var a = e1.x / 180;
                            if (0 === a) e1.text = "0";
                            else {
                                var o = function(t1) {
                                    function e1(t1, e1) {
                                        return Math.abs(t1 - e1) <= 1e-6;
                                    }
                                    var r = function(t1) {
                                        for(var r = 1; !e1(Math.round(t1 * r) / r, t1);)r *= 10;
                                        return r;
                                    }(t1), n = t1 * r, i = Math.abs(function t1(r, n) {
                                        return e1(n, 0) ? r : t1(n, r % n);
                                    }(n, r));
                                    return [
                                        Math.round(n / i),
                                        Math.round(r / i)
                                    ];
                                }(a);
                                if (o[1] >= 100) e1.text = wt(s.deg2rad(e1.x), t1, i, n);
                                else {
                                    var l = e1.x < 0;
                                    1 === o[1] ? 1 === o[0] ? e1.text = "\u03C0" : e1.text = o[0] + "\u03C0" : e1.text = [
                                        "<sup>",
                                        o[0],
                                        "</sup>",
                                        "\u2044",
                                        "<sub>",
                                        o[1],
                                        "</sub>",
                                        "\u03C0"
                                    ].join(""), l && (e1.text = z + e1.text);
                                }
                            }
                        }
                    }(t1, o, r, c, g) : function(t1, e1, r, n, i) {
                        "never" === i ? i = "" : "all" === t1.showexponent && Math.abs(e1.x / t1.dtick) < 1e-6 && (i = "hide"), e1.text = wt(e1.x, t1, i, n);
                    }(t1, o, 0, c, g), n || (t1.tickprefix && !m(t1.showtickprefix) && (o.text = t1.tickprefix + o.text), t1.ticksuffix && !m(t1.showticksuffix) && (o.text += t1.ticksuffix)), t1.labelalias && t1.labelalias.hasOwnProperty(o.text)) {
                        var y = t1.labelalias[o.text];
                        "string" == typeof y && (o.text = y);
                    }
                    return ("boundaries" === t1.tickson || t1.showdividers) && (o.xbnd = [
                        f(o.x - .5),
                        f(o.x + t1.dtick - .5)
                    ]), o;
                }, Z.hoverLabelText = function(t1, e1, r) {
                    r && (t1 = s.extendFlat({}, t1, {
                        hoverformat: r
                    }));
                    var n = s.isArrayOrTypedArray(e1) ? e1[0] : e1, i = s.isArrayOrTypedArray(e1) ? e1[1] : void 0;
                    if (void 0 !== i && i !== n) return Z.hoverLabelText(t1, n, r) + " - " + Z.hoverLabelText(t1, i, r);
                    var a = "log" === t1.type && n <= 0, o = Z.tickText(t1, t1.c2l(a ? -n : n), "hover").text;
                    return a ? 0 === n ? "0" : z + o : o;
                };
                var xt = [
                    "f",
                    "p",
                    "n",
                    "\u03BC",
                    "m",
                    "",
                    "k",
                    "M",
                    "G",
                    "T"
                ];
                function _t(t1) {
                    return "SI" === t1 || "B" === t1;
                }
                function bt(t1) {
                    return t1 > 14 || t1 < -15;
                }
                function wt(t1, e1, r, n) {
                    var a = t1 < 0, o = e1._tickround, l = r || e1.exponentformat || "B", c = e1._tickexponent, u = Z.getTickFormat(e1), h = e1.separatethousands;
                    if (n) {
                        var f = {
                            exponentformat: l,
                            minexponent: e1.minexponent,
                            dtick: "none" === e1.showexponent ? e1.dtick : i(t1) && Math.abs(t1) || 1,
                            range: "none" === e1.showexponent ? e1.range.map(e1.r2d) : [
                                0,
                                t1 || 1
                            ]
                        };
                        yt(f), o = (Number(f._tickround) || 0) + 4, c = f._tickexponent, e1.hoverformat && (u = e1.hoverformat);
                    }
                    if (u) return e1._numFormat(u)(t1).replace(/-/g, z);
                    var p, d = Math.pow(10, -o) / 2;
                    if ("none" === l && (c = 0), (t1 = Math.abs(t1)) < d) t1 = "0", a = !1;
                    else {
                        if (t1 += d, c && (t1 *= Math.pow(10, -c), o += c), 0 === o) t1 = String(Math.floor(t1));
                        else if (o < 0) {
                            t1 = (t1 = String(Math.round(t1))).substr(0, t1.length + o);
                            for(var m = o; m < 0; m++)t1 += "0";
                        } else {
                            var g = (t1 = String(t1)).indexOf(".") + 1;
                            g && (t1 = t1.substr(0, g + o).replace(/\.?0+$/, ""));
                        }
                        t1 = s.numSeparate(t1, e1._separators, h);
                    }
                    return c && "hide" !== l && (_t(l) && bt(c) && (l = "power"), p = c < 0 ? z + -c : "power" !== l ? "+" + c : String(c), "e" === l || "E" === l ? t1 += l + p : "power" === l ? t1 += "\xd710<sup>" + p + "</sup>" : "B" === l && 9 === c ? t1 += "B" : _t(l) && (t1 += xt[c / 3 + 5])), a ? z + t1 : t1;
                }
                function Tt(t1, e1) {
                    if (t1) {
                        var r = Object.keys(j).reduce(function(t1, r) {
                            return -1 !== e1.indexOf(r) && j[r].forEach(function(e1) {
                                t1[e1] = 1;
                            }), t1;
                        }, {});
                        Object.keys(t1).forEach(function(e1) {
                            r[e1] || (1 === e1.length ? t1[e1] = 0 : delete t1[e1]);
                        });
                    }
                }
                function kt(t1, e1) {
                    for(var r = [], n = {}, i = 0; i < e1.length; i++){
                        var a = e1[i];
                        n[a.text2] ? n[a.text2].push(a.x) : n[a.text2] = [
                            a.x
                        ];
                    }
                    for(var o in n)r.push(vt(t1, s.interp(n[o], .5), o));
                    return r;
                }
                function At(t1) {
                    return void 0 !== t1.periodX ? t1.periodX : t1.x;
                }
                function Mt(t1) {
                    return [
                        t1.text,
                        t1.x,
                        t1.axInfo,
                        t1.font,
                        t1.fontSize,
                        t1.fontColor
                    ].join("_");
                }
                function St(t1) {
                    var e1 = t1.title.font.size, r = (t1.title.text.match(c.BR_TAG_ALL) || []).length;
                    return t1.title.hasOwnProperty("standoff") ? e1 * (q + r * H) : r ? e1 * (r + 1) * H : e1;
                }
                function Et(t1, e1) {
                    var r = t1.l2p(e1);
                    return r > 1 && r < t1._length - 1;
                }
                function Ct(t1) {
                    var e1 = n.select(t1), r = e1.select(".text-math-group");
                    return r.empty() ? e1.select("text") : r;
                }
                function Lt(t1) {
                    return t1._id + ".automargin";
                }
                function It(t1) {
                    return Lt(t1) + ".mirror";
                }
                function Pt(t1) {
                    return t1._id + ".rangeslider";
                }
                function zt(t1, e1) {
                    for(var r = 0; r < e1.length; r++)-1 === t1.indexOf(e1[r]) && t1.push(e1[r]);
                }
                function Ot(t1, e1, r) {
                    var n, i, a = [], o = [], l = t1.layout;
                    for(n = 0; n < e1.length; n++)a.push(Z.getFromId(t1, e1[n]));
                    for(n = 0; n < r.length; n++)o.push(Z.getFromId(t1, r[n]));
                    var c = Object.keys(p), u = [
                        "anchor",
                        "domain",
                        "overlaying",
                        "position",
                        "side",
                        "tickangle",
                        "editType"
                    ], h = [
                        "linear",
                        "log"
                    ];
                    for(n = 0; n < c.length; n++){
                        var f = c[n], d = a[0][f], m = o[0][f], g = !0, y = !1, v = !1;
                        if ("_" !== f.charAt(0) && "function" != typeof d && -1 === u.indexOf(f)) {
                            for(i = 1; i < a.length && g; i++){
                                var x = a[i][f];
                                "type" === f && -1 !== h.indexOf(d) && -1 !== h.indexOf(x) && d !== x ? y = !0 : x !== d && (g = !1);
                            }
                            for(i = 1; i < o.length && g; i++){
                                var _ = o[i][f];
                                "type" === f && -1 !== h.indexOf(m) && -1 !== h.indexOf(_) && m !== _ ? v = !0 : o[i][f] !== m && (g = !1);
                            }
                            g && (y && (l[a[0]._name].type = "linear"), v && (l[o[0]._name].type = "linear"), Dt(l, f, a, o, t1._fullLayout._dfltTitle));
                        }
                    }
                    for(n = 0; n < t1._fullLayout.annotations.length; n++){
                        var b = t1._fullLayout.annotations[n];
                        -1 !== e1.indexOf(b.xref) && -1 !== r.indexOf(b.yref) && s.swapAttrs(l.annotations[n], [
                            "?"
                        ]);
                    }
                }
                function Dt(t1, e1, r, n, i) {
                    var a, o = s.nestedProperty, l = o(t1[r[0]._name], e1).get(), c = o(t1[n[0]._name], e1).get();
                    for("title" === e1 && (l && l.text === i.x && (l.text = i.y), c && c.text === i.y && (c.text = i.x)), a = 0; a < r.length; a++)o(t1, r[a]._name + "." + e1).set(c);
                    for(a = 0; a < n.length; a++)o(t1, n[a]._name + "." + e1).set(l);
                }
                function Rt(t1) {
                    return "angularaxis" === t1._id;
                }
                function Ft(t1, e1) {
                    for(var r = e1._rangebreaks.length, n = 0; n < r; n++){
                        var i = e1._rangebreaks[n];
                        if (t1 >= i.min && t1 < i.max) return i.max;
                    }
                    return t1;
                }
                function Bt(t1) {
                    return -1 !== (t1.ticklabelposition || "").indexOf("inside");
                }
                function Nt(t1, e1) {
                    Bt(t1._anchorAxis || {}) && t1._hideCounterAxisInsideTickLabels && t1._hideCounterAxisInsideTickLabels(e1);
                }
                function jt(t1, e1, r, n) {
                    var i, a = "free" === t1.anchor || void 0 !== t1.overlaying && !1 !== t1.overlaying ? t1.overlaying : t1._id;
                    i = n ? "right" === t1.side ? e1 : -e1 : e1, a in r || (r[a] = {}), t1.side in r[a] || (r[a][t1.side] = 0), r[a][t1.side] += i;
                }
                Z.getTickFormat = function(t1) {
                    var e1, r, n, i, a, o, s, l;
                    function c(t1) {
                        return "string" != typeof t1 ? t1 : Number(t1.replace("M", "")) * T;
                    }
                    function u(t1, e1) {
                        var r = [
                            "L",
                            "D"
                        ];
                        if (typeof t1 == typeof e1) {
                            if ("number" == typeof t1) return t1 - e1;
                            var n = r.indexOf(t1.charAt(0)), i = r.indexOf(e1.charAt(0));
                            return n === i ? Number(t1.replace(/(L|D)/g, "")) - Number(e1.replace(/(L|D)/g, "")) : n - i;
                        }
                        return "number" == typeof t1 ? 1 : -1;
                    }
                    function h(t1, e1) {
                        var r = null === e1[0], n = null === e1[1], i = u(t1, e1[0]) >= 0, a = u(t1, e1[1]) <= 0;
                        return (r || i) && (n || a);
                    }
                    if (t1.tickformatstops && t1.tickformatstops.length > 0) switch(t1.type){
                        case "date":
                        case "linear":
                            for(e1 = 0; e1 < t1.tickformatstops.length; e1++)if ((n = t1.tickformatstops[e1]).enabled && (i = t1.dtick, a = n.dtickrange, o = void 0, s = void 0, l = void 0, o = c || function(t1) {
                                return t1;
                            }, s = a[0], l = a[1], (!s && "number" != typeof s || o(s) <= o(i)) && (!l && "number" != typeof l || o(l) >= o(i)))) {
                                r = n;
                                break;
                            }
                            break;
                        case "log":
                            for(e1 = 0; e1 < t1.tickformatstops.length; e1++)if ((n = t1.tickformatstops[e1]).enabled && h(t1.dtick, n.dtickrange)) {
                                r = n;
                                break;
                            }
                    }
                    return r ? r.value : t1.tickformat;
                }, Z.getSubplots = function(t1, e1) {
                    var r = t1._fullLayout._subplots, n = r.cartesian.concat(r.gl2d || []), i = e1 ? Z.findSubplotsWithAxis(n, e1) : n;
                    return i.sort(function(t1, e1) {
                        var r = t1.substr(1).split("y"), n = e1.substr(1).split("y");
                        return r[0] === n[0] ? +r[1] - +n[1] : +r[0] - +n[0];
                    }), i;
                }, Z.findSubplotsWithAxis = function(t1, e1) {
                    for(var r = new RegExp("x" === e1._id.charAt(0) ? "^" + e1._id + "y" : e1._id + "$"), n = [], i = 0; i < t1.length; i++){
                        var a = t1[i];
                        r.test(a) && n.push(a);
                    }
                    return n;
                }, Z.makeClipPaths = function(t1) {
                    var e1 = t1._fullLayout;
                    if (!e1._hasOnlyLargeSploms) {
                        var r, i, a = {
                            _offset: 0,
                            _length: e1.width,
                            _id: ""
                        }, o = {
                            _offset: 0,
                            _length: e1.height,
                            _id: ""
                        }, s = Z.list(t1, "x", !0), l = Z.list(t1, "y", !0), c = [];
                        for(r = 0; r < s.length; r++)for(c.push({
                            x: s[r],
                            y: o
                        }), i = 0; i < l.length; i++)0 === r && c.push({
                            x: a,
                            y: l[i]
                        }), c.push({
                            x: s[r],
                            y: l[i]
                        });
                        var u = e1._clips.selectAll(".axesclip").data(c, function(t1) {
                            return t1.x._id + t1.y._id;
                        });
                        u.enter().append("clipPath").classed("axesclip", !0).attr("id", function(t1) {
                            return "clip" + e1._uid + t1.x._id + t1.y._id;
                        }).append("rect"), u.exit().remove(), u.each(function(t1) {
                            n.select(this).select("rect").attr({
                                x: t1.x._offset || 0,
                                y: t1.y._offset || 0,
                                width: t1.x._length || 1,
                                height: t1.y._length || 1
                            });
                        });
                    }
                }, Z.draw = function(t1, e1, r) {
                    var n = t1._fullLayout;
                    "redraw" === e1 && n._paper.selectAll("g.subplot").each(function(t1) {
                        var e1 = t1[0], r = n._plots[e1];
                        if (r) {
                            var i = r.xaxis, a = r.yaxis;
                            r.xaxislayer.selectAll("." + i._id + "tick").remove(), r.yaxislayer.selectAll("." + a._id + "tick").remove(), r.xaxislayer.selectAll("." + i._id + "tick2").remove(), r.yaxislayer.selectAll("." + a._id + "tick2").remove(), r.xaxislayer.selectAll("." + i._id + "divider").remove(), r.yaxislayer.selectAll("." + a._id + "divider").remove(), r.minorGridlayer && r.minorGridlayer.selectAll("path").remove(), r.gridlayer && r.gridlayer.selectAll("path").remove(), r.zerolinelayer && r.zerolinelayer.selectAll("path").remove(), n._infolayer.select(".g-" + i._id + "title").remove(), n._infolayer.select(".g-" + a._id + "title").remove();
                        }
                    });
                    var i = e1 && "redraw" !== e1 ? e1 : Z.listIds(t1), a = Z.list(t1).filter(function(t1) {
                        return t1.autoshift;
                    }).map(function(t1) {
                        return t1.overlaying;
                    });
                    i.map(function(e1) {
                        var r = Z.getFromId(t1, e1);
                        if ("sync" === r.tickmode && r.overlaying) {
                            var n = i.findIndex(function(t1) {
                                return t1 === r.overlaying;
                            });
                            n >= 0 && i.unshift(i.splice(n, 1).shift());
                        }
                    });
                    var o = {
                        false: {
                            left: 0,
                            right: 0
                        }
                    };
                    return s.syncOrAsync(i.map(function(e1) {
                        return function() {
                            if (e1) {
                                var n = Z.getFromId(t1, e1);
                                r || (r = {}), r.axShifts = o, r.overlayingShiftedAx = a;
                                var i = Z.drawOne(t1, n, r);
                                return n._shiftPusher && jt(n, n._fullDepth || 0, o, !0), n._r = n.range.slice(), n._rl = s.simpleMap(n._r, n.r2l), i;
                            }
                        };
                    }));
                }, Z.drawOne = function(t1, e1, r) {
                    var n, i, l, p = (r = r || {}).axShifts || {}, d = r.overlayingShiftedAx || [];
                    e1.setScale();
                    var m = t1._fullLayout, g = e1._id, y = g.charAt(0), v = Z.counterLetter(g), x = m._plots[e1._mainSubplot];
                    if (x) {
                        if (e1._shiftPusher = e1.autoshift || -1 !== d.indexOf(e1._id) || -1 !== d.indexOf(e1.overlaying), e1._shiftPusher & "free" === e1.anchor) {
                            var _ = e1.linewidth / 2 || 0;
                            "inside" === e1.ticks && (_ += e1.ticklen), jt(e1, _, p, !0), jt(e1, e1.shift || 0, p, !1);
                        }
                        !0 === r.skipTitle && void 0 !== e1._shift || (e1._shift = function(t1, e1) {
                            return t1.autoshift ? e1[t1.overlaying][t1.side] : t1.shift || 0;
                        }(e1, p));
                        var b = x[y + "axislayer"], w = e1._mainLinePosition, T = w += e1._shift, k = e1._mainMirrorPosition, A = e1._vals = Z.calcTicks(e1), M = [
                            e1.mirror,
                            T,
                            k
                        ].join("_");
                        for(n = 0; n < A.length; n++)A[n].axInfo = M;
                        e1._selections = {}, e1._tickAngles && (e1._prevTickAngles = e1._tickAngles), e1._tickAngles = {}, e1._depth = null;
                        var S = {};
                        if (e1.visible) {
                            var E, C, L = Z.makeTransTickFn(e1), I = Z.makeTransTickLabelFn(e1), P = "inside" === e1.ticks, z = "outside" === e1.ticks;
                            if ("boundaries" === e1.tickson) {
                                var O = function(t1, e1) {
                                    var r, n = [], i = function(t1, e1) {
                                        var r = t1.xbnd[e1];
                                        null !== r && n.push(s.extendFlat({}, t1, {
                                            x: r
                                        }));
                                    };
                                    if (e1.length) {
                                        for(r = 0; r < e1.length; r++)i(e1[r], 0);
                                        i(e1[r - 1], 1);
                                    }
                                    return n;
                                }(0, A);
                                C = Z.clipEnds(e1, O), E = P ? C : O;
                            } else C = Z.clipEnds(e1, A), E = P && "period" !== e1.ticklabelmode ? C : A;
                            var D, R = e1._gridVals = C, F = function(t1, e1) {
                                var r, n, i = [], a = e1.length && e1[e1.length - 1].x < e1[0].x, o = function(t1, e1) {
                                    var r = t1.xbnd[e1];
                                    null !== r && i.push(s.extendFlat({}, t1, {
                                        x: r
                                    }));
                                };
                                if (t1.showdividers && e1.length) {
                                    for(r = 0; r < e1.length; r++){
                                        var l = e1[r];
                                        l.text2 !== n && o(l, a ? 1 : 0), n = l.text2;
                                    }
                                    o(e1[r - 1], a ? 0 : 1);
                                }
                                return i;
                            }(e1, A);
                            if (!m._hasOnlyLargeSploms) {
                                var B = e1._subplotsWith, N = {};
                                for(n = 0; n < B.length; n++){
                                    i = B[n];
                                    var j = (l = m._plots[i])[v + "axis"], U = j._mainAxis._id;
                                    if (!N[U]) {
                                        N[U] = 1;
                                        var W = "x" === y ? "M0," + j._offset + "v" + j._length : "M" + j._offset + ",0h" + j._length;
                                        Z.drawGrid(t1, e1, {
                                            vals: R,
                                            counterAxis: j,
                                            layer: l.gridlayer.select("." + g),
                                            minorLayer: l.minorGridlayer.select("." + g),
                                            path: W,
                                            transFn: L
                                        }), Z.drawZeroLine(t1, e1, {
                                            counterAxis: j,
                                            layer: l.zerolinelayer,
                                            path: W,
                                            transFn: L
                                        });
                                    }
                                }
                            }
                            var Y = Z.getTickSigns(e1), X = Z.getTickSigns(e1, "minor");
                            if (e1.ticks || e1.minor && e1.minor.ticks) {
                                var $, J, K, Q, tt = Z.makeTickPath(e1, T, Y[2]), et = Z.makeTickPath(e1, T, X[2], {
                                    minor: !0
                                });
                                if (e1._anchorAxis && e1.mirror && !0 !== e1.mirror ? ($ = Z.makeTickPath(e1, k, Y[3]), J = Z.makeTickPath(e1, k, X[3], {
                                    minor: !0
                                }), K = tt + $, Q = et + J) : ($ = "", J = "", K = tt, Q = et), e1.showdividers && z && "boundaries" === e1.tickson) {
                                    var rt = {};
                                    for(n = 0; n < F.length; n++)rt[F[n].x] = 1;
                                    D = function(t1) {
                                        return rt[t1.x] ? $ : K;
                                    };
                                } else D = function(t1) {
                                    return t1.minor ? Q : K;
                                };
                            }
                            if (Z.drawTicks(t1, e1, {
                                vals: E,
                                layer: b,
                                path: D,
                                transFn: L
                            }), "allticks" === e1.mirror) {
                                var nt = Object.keys(e1._linepositions || {});
                                for(n = 0; n < nt.length; n++){
                                    i = nt[n], l = m._plots[i];
                                    var it = e1._linepositions[i] || [], at = it[0], ot = it[1], st = it[2], lt = Z.makeTickPath(e1, at, st ? Y[0] : X[0], {
                                        minor: st
                                    }) + Z.makeTickPath(e1, ot, st ? Y[1] : X[1], {
                                        minor: st
                                    });
                                    Z.drawTicks(t1, e1, {
                                        vals: E,
                                        layer: l[y + "axislayer"],
                                        path: lt,
                                        transFn: L
                                    });
                                }
                            }
                            var ct = [];
                            if (ct.push(function() {
                                return Z.drawLabels(t1, e1, {
                                    vals: A,
                                    layer: b,
                                    plotinfo: l,
                                    transFn: I,
                                    labelFns: Z.makeLabelFns(e1, T)
                                });
                            }), "multicategory" === e1.type) {
                                var ut = {
                                    x: 2,
                                    y: 10
                                }[y];
                                ct.push(function() {
                                    var r = {
                                        x: "height",
                                        y: "width"
                                    }[y], n = ft()[r] + ut + (e1._tickAngles[g + "tick"] ? e1.tickfont.size * H : 0);
                                    return Z.drawLabels(t1, e1, {
                                        vals: kt(e1, A),
                                        layer: b,
                                        cls: g + "tick2",
                                        repositionOnUpdate: !0,
                                        secondary: !0,
                                        transFn: L,
                                        labelFns: Z.makeLabelFns(e1, T + n * Y[4])
                                    });
                                }), ct.push(function() {
                                    return e1._depth = Y[4] * (ft("tick2")[e1.side] - T), function(t1, e1, r) {
                                        var n = e1._id + "divider", i = r.vals, a = r.layer.selectAll("path." + n).data(i, Mt);
                                        a.exit().remove(), a.enter().insert("path", ":first-child").classed(n, 1).classed("crisp", 1).call(h.stroke, e1.dividercolor).style("stroke-width", f.crispRound(t1, e1.dividerwidth, 1) + "px"), a.attr("transform", r.transFn).attr("d", r.path);
                                    }(t1, e1, {
                                        vals: F,
                                        layer: b,
                                        path: Z.makeTickPath(e1, T, Y[4], {
                                            len: e1._depth
                                        }),
                                        transFn: L
                                    });
                                });
                            } else e1.title.hasOwnProperty("standoff") && ct.push(function() {
                                e1._depth = Y[4] * (ft()[e1.side] - T);
                            });
                            var ht = o.getComponentMethod("rangeslider", "isVisible")(e1);
                            return r.skipTitle || ht && "bottom" === e1.side || ct.push(function() {
                                return function(t1, e1) {
                                    var r, n = t1._fullLayout, i = e1._id, a = i.charAt(0), o = e1.title.font.size, s = (e1.title.text.match(c.BR_TAG_ALL) || []).length;
                                    if (e1.title.hasOwnProperty("standoff")) "bottom" === e1.side || "right" === e1.side ? r = e1._depth + e1.title.standoff + o * q : "top" !== e1.side && "left" !== e1.side || (r = e1._depth + e1.title.standoff + o * (V + s * H));
                                    else {
                                        var l = Bt(e1);
                                        if ("multicategory" === e1.type) r = e1._depth;
                                        else {
                                            var h = 1.5 * o;
                                            l && (h = .5 * o, "outside" === e1.ticks && (h += e1.ticklen)), r = 10 + h + (e1.linewidth ? e1.linewidth - 1 : 0);
                                        }
                                        l || (r += "x" === a ? "top" === e1.side ? o * (e1.showticklabels ? 1 : 0) : o * (e1.showticklabels ? 1.5 : .5) : "right" === e1.side ? o * (e1.showticklabels ? 1 : .5) : o * (e1.showticklabels ? .5 : 0));
                                    }
                                    var p, d, m, g, y = Z.getPxPosition(t1, e1);
                                    if ("x" === a ? (d = e1._offset + e1._length / 2, m = "top" === e1.side ? y - r : y + r) : (m = e1._offset + e1._length / 2, d = "right" === e1.side ? y + r : y - r, p = {
                                        rotate: "-90",
                                        offset: 0
                                    }), "multicategory" !== e1.type) {
                                        var v = e1._selections[e1._id + "tick"];
                                        if (g = {
                                            selection: v,
                                            side: e1.side
                                        }, v && v.node() && v.node().parentNode) {
                                            var x = f.getTranslate(v.node().parentNode);
                                            g.offsetLeft = x.x, g.offsetTop = x.y;
                                        }
                                        e1.title.hasOwnProperty("standoff") && (g.pad = 0);
                                    }
                                    return e1._titleStandoff = r, u.draw(t1, i + "title", {
                                        propContainer: e1,
                                        propName: e1._name + ".title.text",
                                        placeholder: n._dfltTitle[a],
                                        avoid: g,
                                        transform: p,
                                        attributes: {
                                            x: d,
                                            y: m,
                                            "text-anchor": "middle"
                                        }
                                    });
                                }(t1, e1);
                            }), ct.push(function() {
                                var r, n, i, s, l = e1.side.charAt(0), c = G[e1.side].charAt(0), u = Z.getPxPosition(t1, e1), h = z ? e1.ticklen : 0;
                                (e1.automargin || ht || e1._shiftPusher) && ("multicategory" === e1.type ? r = ft("tick2") : (r = ft(), "x" === y && "b" === l && (e1._depth = Math.max(r.width > 0 ? r.bottom - u : 0, h))));
                                var f = 0, p = 0;
                                if (e1._shiftPusher && (f = Math.max(h, r.height > 0 ? "l" === l ? u - r.left : r.right - u : 0), e1.title.text !== m._dfltTitle[y] && (p = (e1._titleStandoff || 0) + (e1._titleScoot || 0), "l" === l && (p += St(e1))), e1._fullDepth = Math.max(f, p)), e1.automargin) {
                                    n = {
                                        x: 0,
                                        y: 0,
                                        r: 0,
                                        l: 0,
                                        t: 0,
                                        b: 0
                                    };
                                    var d = [
                                        0,
                                        1
                                    ], g = "number" == typeof e1._shift ? e1._shift : 0;
                                    if ("x" === y) {
                                        if ("b" === l ? n[l] = e1._depth : (n[l] = e1._depth = Math.max(r.width > 0 ? u - r.top : 0, h), d.reverse()), r.width > 0) {
                                            var x = r.right - (e1._offset + e1._length);
                                            x > 0 && (n.xr = 1, n.r = x);
                                            var _ = e1._offset - r.left;
                                            _ > 0 && (n.xl = 0, n.l = _);
                                        }
                                    } else if ("l" === l ? (e1._depth = Math.max(r.height > 0 ? u - r.left : 0, h), n[l] = e1._depth - g) : (e1._depth = Math.max(r.height > 0 ? r.right - u : 0, h), n[l] = e1._depth + g, d.reverse()), r.height > 0) {
                                        var b = r.bottom - (e1._offset + e1._length);
                                        b > 0 && (n.yb = 0, n.b = b);
                                        var w = e1._offset - r.top;
                                        w > 0 && (n.yt = 1, n.t = w);
                                    }
                                    n[v] = "free" === e1.anchor ? e1.position : e1._anchorAxis.domain[d[0]], e1.title.text !== m._dfltTitle[y] && (n[l] += St(e1) + (e1.title.standoff || 0)), e1.mirror && "free" !== e1.anchor && ((i = {
                                        x: 0,
                                        y: 0,
                                        r: 0,
                                        l: 0,
                                        t: 0,
                                        b: 0
                                    })[c] = e1.linewidth, e1.mirror && !0 !== e1.mirror && (i[c] += h), !0 === e1.mirror || "ticks" === e1.mirror ? i[v] = e1._anchorAxis.domain[d[1]] : "all" !== e1.mirror && "allticks" !== e1.mirror || (i[v] = [
                                        e1._counterDomainMin,
                                        e1._counterDomainMax
                                    ][d[1]]));
                                }
                                ht && (s = o.getComponentMethod("rangeslider", "autoMarginOpts")(t1, e1)), "string" == typeof e1.automargin && (Tt(n, e1.automargin), Tt(i, e1.automargin)), a.autoMargin(t1, Lt(e1), n), a.autoMargin(t1, It(e1), i), a.autoMargin(t1, Pt(e1), s);
                            }), s.syncOrAsync(ct);
                        }
                    }
                    function ft(t1) {
                        var r = g + (t1 || "tick");
                        return S[r] || (S[r] = function(t1, e1, r) {
                            var n, i, a, o;
                            if (t1._selections[e1].size()) n = 1 / 0, i = -1 / 0, a = 1 / 0, o = -1 / 0, t1._selections[e1].each(function() {
                                var t1 = Ct(this), e1 = f.bBox(t1.node().parentNode);
                                n = Math.min(n, e1.top), i = Math.max(i, e1.bottom), a = Math.min(a, e1.left), o = Math.max(o, e1.right);
                            });
                            else {
                                var s = Z.makeLabelFns(t1, r);
                                n = i = s.yFn({
                                    dx: 0,
                                    dy: 0,
                                    fontSize: 0
                                }), a = o = s.xFn({
                                    dx: 0,
                                    dy: 0,
                                    fontSize: 0
                                });
                            }
                            return {
                                top: n,
                                bottom: i,
                                left: a,
                                right: o,
                                height: i - n,
                                width: o - a
                            };
                        }(e1, r, T)), S[r];
                    }
                }, Z.getTickSigns = function(t1, e1) {
                    var r = t1._id.charAt(0), n = {
                        x: "top",
                        y: "right"
                    }[r], i = t1.side === n ? 1 : -1, a = [
                        -1,
                        1,
                        i,
                        -i
                    ];
                    return "inside" !== (e1 ? (t1.minor || {}).ticks : t1.ticks) == ("x" === r) && (a = a.map(function(t1) {
                        return -t1;
                    })), t1.side && a.push({
                        l: -1,
                        t: -1,
                        r: 1,
                        b: 1
                    }[t1.side.charAt(0)]), a;
                }, Z.makeTransTickFn = function(t1) {
                    return "x" === t1._id.charAt(0) ? function(e1) {
                        return l(t1._offset + t1.l2p(e1.x), 0);
                    } : function(e1) {
                        return l(0, t1._offset + t1.l2p(e1.x));
                    };
                }, Z.makeTransTickLabelFn = function(t1) {
                    var e1 = function(t1) {
                        var e1 = t1.ticklabelposition || "", r = function(t1) {
                            return -1 !== e1.indexOf(t1);
                        }, n = r("top"), i = r("left"), a = r("right"), o = r("bottom"), s = r("inside"), l = o || i || n || a;
                        if (!l && !s) return [
                            0,
                            0
                        ];
                        var c = t1.side, u = l ? (t1.tickwidth || 0) / 2 : 0, h = 3, f = t1.tickfont ? t1.tickfont.size : 12;
                        return (o || n) && (u += f * q, h += (t1.linewidth || 0) / 2), (i || a) && (u += (t1.linewidth || 0) / 2, h += 3), s && "top" === c && (h -= f * (1 - q)), (i || n) && (u = -u), "bottom" !== c && "right" !== c || (h = -h), [
                            l ? u : 0,
                            s ? h : 0
                        ];
                    }(t1), r = t1.ticklabelshift || 0, n = t1.ticklabelstandoff || 0, i = e1[0], a = e1[1], o = t1.range[0] > t1.range[1], s = t1.ticklabelposition && -1 !== t1.ticklabelposition.indexOf("inside"), c = !s;
                    if (r && (r *= o ? -1 : 1), n) {
                        var u = t1.side;
                        n *= s && ("top" === u || "left" === u) || c && ("bottom" === u || "right" === u) ? 1 : -1;
                    }
                    return "x" === t1._id.charAt(0) ? function(e1) {
                        return l(i + t1._offset + t1.l2p(At(e1)) + r, a + n);
                    } : function(e1) {
                        return l(a + n, i + t1._offset + t1.l2p(At(e1)) + r);
                    };
                }, Z.makeTickPath = function(t1, e1, r, n) {
                    n || (n = {});
                    var i = n.minor;
                    if (i && !t1.minor) return "";
                    var a = void 0 !== n.len ? n.len : i ? t1.minor.ticklen : t1.ticklen, o = t1._id.charAt(0), s = (t1.linewidth || 1) / 2;
                    return "x" === o ? "M0," + (e1 + s * r) + "v" + a * r : "M" + (e1 + s * r) + ",0h" + a * r;
                }, Z.makeLabelFns = function(t1, e1, r) {
                    var n = t1.ticklabelposition || "", a = function(t1) {
                        return -1 !== n.indexOf(t1);
                    }, o = a("top"), l = a("left"), c = a("right"), u = a("bottom") || l || o || c, h = a("inside"), f = "inside" === n && "inside" === t1.ticks || !h && "outside" === t1.ticks && "boundaries" !== t1.tickson, p = 0, d = 0, m = f ? t1.ticklen : 0;
                    if (h ? m *= -1 : u && (m = 0), f && (p += m, r)) {
                        var g = s.deg2rad(r);
                        p = m * Math.cos(g) + 1, d = m * Math.sin(g);
                    }
                    t1.showticklabels && (f || t1.showline) && (p += .2 * t1.tickfont.size);
                    var y, v, x, _, b, w = {
                        labelStandoff: p += (t1.linewidth || 1) / 2 * (h ? -1 : 1),
                        labelShift: d
                    }, T = 0, k = t1.side, A = t1._id.charAt(0), M = t1.tickangle;
                    if ("x" === A) _ = (b = !h && "bottom" === k || h && "top" === k) ? 1 : -1, h && (_ *= -1), y = d * _, v = e1 + p * _, x = b ? 1 : -0.2, 90 === Math.abs(M) && (h ? x += V : x = -90 === M && "bottom" === k ? q : 90 === M && "top" === k ? V : .5, T = V / 2 * (M / 90)), w.xFn = function(t1) {
                        return t1.dx + y + T * t1.fontSize;
                    }, w.yFn = function(t1) {
                        return t1.dy + v + t1.fontSize * x;
                    }, w.anchorFn = function(t1, e1) {
                        if (u) {
                            if (l) return "end";
                            if (c) return "start";
                        }
                        return i(e1) && 0 !== e1 && 180 !== e1 ? e1 * _ < 0 !== h ? "end" : "start" : "middle";
                    }, w.heightFn = function(e1, r, n) {
                        return r < -60 || r > 60 ? -0.5 * n : "top" === t1.side !== h ? -n : 0;
                    };
                    else if ("y" === A) {
                        if (_ = (b = !h && "left" === k || h && "right" === k) ? 1 : -1, h && (_ *= -1), y = p, v = d * _, x = 0, h || 90 !== Math.abs(M) || (x = -90 === M && "left" === k || 90 === M && "right" === k ? q : .5), h) {
                            var S = i(M) ? +M : 0;
                            if (0 !== S) {
                                var E = s.deg2rad(S);
                                T = Math.abs(Math.sin(E)) * q * _, x = 0;
                            }
                        }
                        w.xFn = function(t1) {
                            return t1.dx + e1 - (y + t1.fontSize * x) * _ + T * t1.fontSize;
                        }, w.yFn = function(t1) {
                            return t1.dy + v + t1.fontSize * V;
                        }, w.anchorFn = function(t1, e1) {
                            return i(e1) && 90 === Math.abs(e1) ? "middle" : b ? "end" : "start";
                        }, w.heightFn = function(e1, r, n) {
                            return "right" === t1.side && (r *= -1), r < -30 ? -n : r < 30 ? -0.5 * n : 0;
                        };
                    }
                    return w;
                }, Z.drawTicks = function(t1, e1, r) {
                    r = r || {};
                    var i = e1._id + "tick", a = [].concat(e1.minor && e1.minor.ticks ? r.vals.filter(function(t1) {
                        return t1.minor && !t1.noTick;
                    }) : []).concat(e1.ticks ? r.vals.filter(function(t1) {
                        return !t1.minor && !t1.noTick;
                    }) : []), o = r.layer.selectAll("path." + i).data(a, Mt);
                    o.exit().remove(), o.enter().append("path").classed(i, 1).classed("ticks", 1).classed("crisp", !1 !== r.crisp).each(function(t1) {
                        return h.stroke(n.select(this), t1.minor ? e1.minor.tickcolor : e1.tickcolor);
                    }).style("stroke-width", function(r) {
                        return f.crispRound(t1, r.minor ? e1.minor.tickwidth : e1.tickwidth, 1) + "px";
                    }).attr("d", r.path).style("display", null), Nt(e1, [
                        B
                    ]), o.attr("transform", r.transFn);
                }, Z.drawGrid = function(t1, e1, r) {
                    if (r = r || {}, "sync" !== e1.tickmode) {
                        var i = e1._id + "grid", a = e1.minor && e1.minor.showgrid, o = a ? r.vals.filter(function(t1) {
                            return t1.minor;
                        }) : [], s = e1.showgrid ? r.vals.filter(function(t1) {
                            return !t1.minor;
                        }) : [], l = r.counterAxis;
                        if (l && Z.shouldShowZeroLine(t1, e1, l)) for(var c = "array" === e1.tickmode, u = 0; u < s.length; u++){
                            var p = s[u].x;
                            if (c ? !p : Math.abs(p) < e1.dtick / 100) {
                                if (s = s.slice(0, u).concat(s.slice(u + 1)), !c) break;
                                u--;
                            }
                        }
                        e1._gw = f.crispRound(t1, e1.gridwidth, 1);
                        for(var d = a ? f.crispRound(t1, e1.minor.gridwidth, 1) : 0, m = r.layer, g = r.minorLayer, y = 1; y >= 0; y--){
                            var v = y ? m : g;
                            if (v) {
                                var x = v.selectAll("path." + i).data(y ? s : o, Mt);
                                x.exit().remove(), x.enter().append("path").classed(i, 1).classed("crisp", !1 !== r.crisp), x.attr("transform", r.transFn).attr("d", r.path).each(function(t1) {
                                    return h.stroke(n.select(this), t1.minor ? e1.minor.gridcolor : e1.gridcolor || "#ddd");
                                }).style("stroke-dasharray", function(t1) {
                                    return f.dashStyle(t1.minor ? e1.minor.griddash : e1.griddash, t1.minor ? e1.minor.gridwidth : e1.gridwidth);
                                }).style("stroke-width", function(t1) {
                                    return (t1.minor ? d : e1._gw) + "px";
                                }).style("display", null), "function" == typeof r.path && x.attr("d", r.path);
                            }
                        }
                        Nt(e1, [
                            R,
                            F
                        ]);
                    }
                }, Z.drawZeroLine = function(t1, e1, r) {
                    r = r || r;
                    var n = e1._id + "zl", i = Z.shouldShowZeroLine(t1, e1, r.counterAxis), a = r.layer.selectAll("path." + n).data(i ? [
                        {
                            x: 0,
                            id: e1._id
                        }
                    ] : []);
                    a.exit().remove(), a.enter().append("path").classed(n, 1).classed("zl", 1).classed("crisp", !1 !== r.crisp).each(function() {
                        r.layer.selectAll("path").sort(function(t1, e1) {
                            return X(t1.id, e1.id);
                        });
                    }), a.attr("transform", r.transFn).attr("d", r.path).call(h.stroke, e1.zerolinecolor || h.defaultLine).style("stroke-width", f.crispRound(t1, e1.zerolinewidth, e1._gw || 1) + "px").style("display", null), Nt(e1, [
                        D
                    ]);
                }, Z.drawLabels = function(t1, e1, r) {
                    r = r || {};
                    var a = t1._fullLayout, o = e1._id, u = r.cls || o + "tick", h = r.vals.filter(function(t1) {
                        return t1.text;
                    }), p = r.labelFns, d = r.secondary ? 0 : e1.tickangle, m = (e1._prevTickAngles || {})[u], g = r.layer.selectAll("g." + u).data(e1.showticklabels ? h : [], Mt), y = [];
                    function v(t1, a) {
                        t1.each(function(t1) {
                            var o = n.select(this), s = o.select(".text-math-group"), u = p.anchorFn(t1, a), h = r.transFn.call(o.node(), t1) + (i(a) && 0 != +a ? " rotate(" + a + "," + p.xFn(t1) + "," + (p.yFn(t1) - t1.fontSize / 2) + ")" : ""), d = c.lineCount(o), m = H * t1.fontSize, g = p.heightFn(t1, i(a) ? +a : 0, (d - 1) * m);
                            if (g && (h += l(0, g)), s.empty()) {
                                var y = o.select("text");
                                y.attr({
                                    transform: h,
                                    "text-anchor": u
                                }), y.style("opacity", 1), e1._adjustTickLabelsOverflow && e1._adjustTickLabelsOverflow();
                            } else {
                                var v = f.bBox(s.node()).width * ({
                                    end: -0.5,
                                    start: .5
                                })[u];
                                s.attr("transform", h + l(v, 0));
                            }
                        });
                    }
                    g.enter().append("g").classed(u, 1).append("text").attr("text-anchor", "middle").each(function(e1) {
                        var r = n.select(this), i = t1._promises.length;
                        r.call(c.positionText, p.xFn(e1), p.yFn(e1)).call(f.font, {
                            family: e1.font,
                            size: e1.fontSize,
                            color: e1.fontColor,
                            weight: e1.fontWeight,
                            style: e1.fontStyle,
                            variant: e1.fontVariant,
                            textcase: e1.fontTextcase,
                            lineposition: e1.fontLineposition,
                            shadow: e1.fontShadow
                        }).text(e1.text).call(c.convertToTspans, t1), t1._promises[i] ? y.push(t1._promises.pop().then(function() {
                            v(r, d);
                        })) : v(r, d);
                    }), Nt(e1, [
                        N
                    ]), g.exit().remove(), r.repositionOnUpdate && g.each(function(t1) {
                        n.select(this).select("text").call(c.positionText, p.xFn(t1), p.yFn(t1));
                    }), e1._adjustTickLabelsOverflow = function() {
                        var r = e1.ticklabeloverflow;
                        if (r && "allow" !== r) {
                            var i = -1 !== r.indexOf("hide"), o = "x" === e1._id.charAt(0), l = 0, c = o ? t1._fullLayout.width : t1._fullLayout.height;
                            if (-1 !== r.indexOf("domain")) {
                                var u = s.simpleMap(e1.range, e1.r2l);
                                l = e1.l2p(u[0]) + e1._offset, c = e1.l2p(u[1]) + e1._offset;
                            }
                            var h = Math.min(l, c), p = Math.max(l, c), d = e1.side, m = 1 / 0, y = -1 / 0;
                            for(var v in g.each(function(t1) {
                                var r = n.select(this);
                                if (r.select(".text-math-group").empty()) {
                                    var a = f.bBox(r.node()), s = 0;
                                    o ? (a.right > p || a.left < h) && (s = 1) : (a.bottom > p || a.top + (e1.tickangle ? 0 : t1.fontSize / 4) < h) && (s = 1);
                                    var l = r.select("text");
                                    s ? i && l.style("opacity", 0) : (l.style("opacity", 1), m = "bottom" === d || "right" === d ? Math.min(m, o ? a.top : a.left) : -1 / 0, y = "top" === d || "left" === d ? Math.max(y, o ? a.bottom : a.right) : 1 / 0);
                                }
                            }), a._plots){
                                var x = a._plots[v];
                                if (e1._id === x.xaxis._id || e1._id === x.yaxis._id) {
                                    var _ = o ? x.yaxis : x.xaxis;
                                    _ && (_["_visibleLabelMin_" + e1._id] = m, _["_visibleLabelMax_" + e1._id] = y);
                                }
                            }
                        }
                    }, e1._hideCounterAxisInsideTickLabels = function(t1) {
                        var r = "x" === e1._id.charAt(0), i = [];
                        for(var o in a._plots){
                            var s = a._plots[o];
                            e1._id !== s.xaxis._id && e1._id !== s.yaxis._id || i.push(r ? s.yaxis : s.xaxis);
                        }
                        i.forEach(function(r, i) {
                            r && Bt(r) && (t1 || [
                                D,
                                F,
                                R,
                                B,
                                N
                            ]).forEach(function(t1) {
                                var o = "tick" === t1.K && "text" === t1.L && "period" === e1.ticklabelmode, s = a._plots[e1._mainSubplot];
                                (t1.K === D.K ? s.zerolinelayer.selectAll("." + e1._id + "zl") : t1.K === F.K ? s.minorGridlayer.selectAll("." + e1._id) : t1.K === R.K ? s.gridlayer.selectAll("." + e1._id) : s[e1._id.charAt(0) + "axislayer"]).each(function() {
                                    var a = n.select(this);
                                    t1.L && (a = a.selectAll(t1.L)), a.each(function(a) {
                                        var s = e1.l2p(o ? At(a) : a.x) + e1._offset, l = n.select(this);
                                        s < e1["_visibleLabelMax_" + r._id] && s > e1["_visibleLabelMin_" + r._id] ? l.style("display", "none") : "tick" !== t1.K || i || l.style("display", null);
                                    });
                                });
                            });
                        });
                    }, v(g, m + 1 ? m : d);
                    var x = null;
                    e1._selections && (e1._selections[u] = g);
                    var _ = [
                        function() {
                            return y.length && Promise.all(y);
                        }
                    ];
                    e1.automargin && a._redrawFromAutoMarginCount && 90 === m ? (x = m, _.push(function() {
                        v(g, m);
                    })) : _.push(function() {
                        if (v(g, d), h.length && e1.autotickangles && ("log" !== e1.type || "D" !== String(e1.dtick).charAt(0))) {
                            x = e1.autotickangles[0];
                            var t1, n = 0, i = [], a = 1;
                            g.each(function(t1) {
                                n = Math.max(n, t1.fontSize);
                                var r = e1.l2p(t1.x), o = Ct(this), s = f.bBox(o.node());
                                a = Math.max(a, c.lineCount(o)), i.push({
                                    top: 0,
                                    bottom: 10,
                                    height: 10,
                                    left: r - s.width / 2,
                                    right: r + s.width / 2 + 2,
                                    width: s.width + 2
                                });
                            });
                            var o = ("boundaries" === e1.tickson || e1.showdividers) && !r.secondary, l = h.length, u = Math.abs((h[l - 1].x - h[0].x) * e1._m) / (l - 1), p = o ? u / 2 : u, m = o ? e1.ticklen : 1.25 * n * a, y = p / Math.sqrt(Math.pow(p, 2) + Math.pow(m, 2)), _ = e1.autotickangles.map(function(t1) {
                                return t1 * Math.PI / 180;
                            }), b = _.find(function(t1) {
                                return Math.abs(Math.cos(t1)) <= y;
                            });
                            void 0 === b && (b = _.reduce(function(t1, e1) {
                                return Math.abs(Math.cos(t1)) < Math.abs(Math.cos(e1)) ? t1 : e1;
                            }, _[0]));
                            var w = b * (180 / Math.PI);
                            if (o) {
                                var T = 2;
                                for(e1.ticks && (T += e1.tickwidth / 2), t1 = 0; t1 < i.length; t1++){
                                    var k = h[t1].xbnd, A = i[t1];
                                    if (null !== k[0] && A.left - e1.l2p(k[0]) < T || null !== k[1] && e1.l2p(k[1]) - A.right < T) {
                                        x = w;
                                        break;
                                    }
                                }
                            } else {
                                var M = e1.ticklabelposition || "", S = function(t1) {
                                    return -1 !== M.indexOf(t1);
                                }, E = S("top"), C = S("left"), L = S("right"), I = S("bottom") || C || E || L ? (e1.tickwidth || 0) + 6 : 0;
                                for(t1 = 0; t1 < i.length - 1; t1++)if (s.bBoxIntersect(i[t1], i[t1 + 1], I)) {
                                    x = w;
                                    break;
                                }
                            }
                            x && v(g, x);
                        }
                    }), e1._tickAngles && _.push(function() {
                        e1._tickAngles[u] = null === x ? i(d) ? d : 0 : x;
                    });
                    var b = function() {
                        var t1 = 0, r = 0;
                        return g.each(function(n, i) {
                            var a, o = Ct(this);
                            o.select(".text-math-group").empty() && (e1._vals[i] && (a = e1._vals[i].bb || f.bBox(o.node()), e1._vals[i].bb = a), t1 = Math.max(t1, a.width), r = Math.max(r, a.height));
                        }), {
                            labelsMaxW: t1,
                            labelsMaxH: r
                        };
                    }, w = e1._anchorAxis;
                    if (w && (w.autorange || w.insiderange) && Bt(e1) && !$(a, e1._id) && (a._insideTickLabelsUpdaterange || (a._insideTickLabelsUpdaterange = {}), w.autorange && (a._insideTickLabelsUpdaterange[w._name + ".autorange"] = w.autorange, _.push(b)), w.insiderange)) {
                        var T = b(), k = "y" === e1._id.charAt(0) ? T.labelsMaxW : T.labelsMaxH;
                        k += 6, "inside" === e1.ticklabelposition && (k += e1.ticklen || 0);
                        var A = "right" === e1.side || "top" === e1.side ? 1 : -1, M = 1 === A ? 1 : 0, S = 1 === A ? 0 : 1, E = [];
                        E[S] = w.range[S];
                        var C = w.range, L = w.r2p(C[M]), I = w.r2p(C[S]), P = a._insideTickLabelsUpdaterange[w._name + ".range"];
                        if (P) {
                            var z = w.r2p(P[M]), O = w.r2p(P[S]), j = A * ("y" === e1._id.charAt(0) ? 1 : -1);
                            j * L < j * z && (L = z, E[M] = C[M] = P[M]), j * I > j * O && (I = O, E[S] = C[S] = P[S]);
                        }
                        var U = Math.abs(I - L);
                        U - k > 0 ? k *= 1 + k / (U -= k) : k = 0, "y" !== e1._id.charAt(0) && (k = -k), E[M] = w.p2r(w.r2p(C[M]) + A * k), "min" === w.autorange || "max reversed" === w.autorange ? (E[0] = null, w._rangeInitial0 = void 0, w._rangeInitial1 = void 0) : "max" !== w.autorange && "min reversed" !== w.autorange || (E[1] = null, w._rangeInitial0 = void 0, w._rangeInitial1 = void 0), a._insideTickLabelsUpdaterange[w._name + ".range"] = E;
                    }
                    var V = s.syncOrAsync(_);
                    return V && V.then && t1._promises.push(V), V;
                }, Z.getPxPosition = function(t1, e1) {
                    var r, n = t1._fullLayout._size, i = e1._id.charAt(0), a = e1.side;
                    return "free" !== e1.anchor ? r = e1._anchorAxis : "x" === i ? r = {
                        _offset: n.t + (1 - (e1.position || 0)) * n.h,
                        _length: 0
                    } : "y" === i && (r = {
                        _offset: n.l + (e1.position || 0) * n.w + e1._shift,
                        _length: 0
                    }), "top" === a || "left" === a ? r._offset : "bottom" === a || "right" === a ? r._offset + r._length : void 0;
                }, Z.shouldShowZeroLine = function(t1, e1, r) {
                    var n = s.simpleMap(e1.range, e1.r2l);
                    return n[0] * n[1] <= 0 && e1.zeroline && ("linear" === e1.type || "-" === e1.type) && !(e1.rangebreaks && e1.maskBreaks(0) === O) && (Et(e1, 0) || !function(t1, e1, r, n) {
                        var i = r._mainAxis;
                        if (i) {
                            var a = t1._fullLayout, o = e1._id.charAt(0), s = Z.counterLetter(e1._id), l = e1._offset + (Math.abs(n[0]) < Math.abs(n[1]) == ("x" === o) ? 0 : e1._length), c = a._plots[r._mainSubplot];
                            if (!(c.mainplotinfo || c).overlays.length) return p(r);
                            for(var u = Z.list(t1, s), h = 0; h < u.length; h++){
                                var f = u[h];
                                if (f._mainAxis === i && p(f)) return !0;
                            }
                        }
                        function p(t1) {
                            if (!t1.showline || !t1.linewidth) return !1;
                            var r = Math.max((t1.linewidth + e1.zerolinewidth) / 2, 1);
                            function n(t1) {
                                return "number" == typeof t1 && Math.abs(t1 - l) < r;
                            }
                            if (n(t1._mainLinePosition) || n(t1._mainMirrorPosition)) return !0;
                            var i = t1._linepositions || {};
                            for(var a in i)if (n(i[a][0]) || n(i[a][1])) return !0;
                        }
                    }(t1, e1, r, n) || function(t1, e1) {
                        for(var r = t1._fullData, n = e1._mainSubplot, i = e1._id.charAt(0), a = 0; a < r.length; a++){
                            var s = r[a];
                            if (!0 === s.visible && s.xaxis + s.yaxis === n) {
                                if (o.traceIs(s, "bar-like") && s.orientation === ({
                                    x: "h",
                                    y: "v"
                                })[i]) return !0;
                                if (s.fill && s.fill.charAt(s.fill.length - 1) === i) return !0;
                            }
                        }
                        return !1;
                    }(t1, e1));
                }, Z.clipEnds = function(t1, e1) {
                    return e1.filter(function(e1) {
                        return Et(t1, e1.x);
                    });
                }, Z.allowAutoMargin = function(t1) {
                    for(var e1 = Z.list(t1, "", !0), r = 0; r < e1.length; r++){
                        var n = e1[r];
                        n.automargin && (a.allowAutoMargin(t1, Lt(n)), n.mirror && a.allowAutoMargin(t1, It(n))), o.getComponentMethod("rangeslider", "isVisible")(n) && a.allowAutoMargin(t1, Pt(n));
                    }
                }, Z.swap = function(t1, e1) {
                    for(var r = function(t1, e1) {
                        var r, n, i = [];
                        for(r = 0; r < e1.length; r++){
                            var a = [], o = t1._fullData[e1[r]].xaxis, s = t1._fullData[e1[r]].yaxis;
                            if (o && s) {
                                for(n = 0; n < i.length; n++)-1 === i[n].x.indexOf(o) && -1 === i[n].y.indexOf(s) || a.push(n);
                                if (a.length) {
                                    var l, c = i[a[0]];
                                    if (a.length > 1) for(n = 1; n < a.length; n++)l = i[a[n]], zt(c.x, l.x), zt(c.y, l.y);
                                    zt(c.x, [
                                        o
                                    ]), zt(c.y, [
                                        s
                                    ]);
                                } else i.push({
                                    x: [
                                        o
                                    ],
                                    y: [
                                        s
                                    ]
                                });
                            }
                        }
                        return i;
                    }(t1, e1), n = 0; n < r.length; n++)Ot(t1, r[n].x, r[n].y);
                };
            },
            9666: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(34809), a = r(63821).BADNUM, o = i.isArrayOrTypedArray, s = i.isDateTime, l = i.cleanNumber, c = Math.round;
                function u(t1, e1) {
                    return e1 ? n(t1) : "number" == typeof t1;
                }
                function h(t1) {
                    return Math.max(1, (t1 - 1) / 1e3);
                }
                t1.exports = function(t1, e1, r) {
                    var i = t1, f = r.noMultiCategory;
                    if (o(i) && !i.length) return "-";
                    if (!f && function(t1) {
                        return o(t1[0]) && o(t1[1]);
                    }(i)) return "multicategory";
                    if (f && Array.isArray(i[0])) {
                        for(var p = [], d = 0; d < i.length; d++)if (o(i[d])) for(var m = 0; m < i[d].length; m++)p.push(i[d][m]);
                        i = p;
                    }
                    if (function(t1, e1) {
                        for(var r = t1.length, i = h(r), a = 0, o = 0, l = {}, u = 0; u < r; u += i){
                            var f = t1[c(u)], p = String(f);
                            l[p] || (l[p] = 1, s(f, e1) && a++, n(f) && o++);
                        }
                        return a > 2 * o;
                    }(i, e1)) return "date";
                    var g = "strict" !== r.autotypenumbers;
                    return function(t1, e1) {
                        for(var r = t1.length, n = h(r), i = 0, o = 0, s = {}, u = 0; u < r; u += n){
                            var f = t1[c(u)], p = String(f);
                            if (!s[p]) {
                                s[p] = 1;
                                var d = typeof f;
                                "boolean" === d ? o++ : (e1 ? l(f) !== a : "number" === d) ? i++ : "string" === d && o++;
                            }
                        }
                        return o > 2 * i;
                    }(i, g) ? "category" : function(t1, e1) {
                        for(var r = t1.length, n = 0; n < r; n++)if (u(t1[n], e1)) return !0;
                        return !1;
                    }(i, g) ? "linear" : "-";
                };
            },
            97655: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(33626), a = r(34809), o = r(78032), s = r(59008), l = r(25829), c = r(22777), u = r(87433), h = r(12036), f = r(54616), p = r(46473), d = r(97405), m = r(90259), g = r(19091), y = r(54826).WEEKDAY_PATTERN, v = r(54826).HOUR_PATTERN;
                function x(t1, e1, r) {
                    function i(r, n) {
                        return a.coerce(t1, e1, l.rangebreaks, r, n);
                    }
                    if (i("enabled")) {
                        var o = i("bounds");
                        if (o && o.length >= 2) {
                            var s, c, u = "";
                            if (2 === o.length) {
                                for(s = 0; s < 2; s++)if (c = b(o[s])) {
                                    u = y;
                                    break;
                                }
                            }
                            var h = i("pattern", u);
                            if (h === y) for(s = 0; s < 2; s++)(c = b(o[s])) && (e1.bounds[s] = o[s] = c - 1);
                            if (h) for(s = 0; s < 2; s++)switch(c = o[s], h){
                                case y:
                                    if (!n(c)) return void (e1.enabled = !1);
                                    if ((c = +c) !== Math.floor(c) || c < 0 || c >= 7) return void (e1.enabled = !1);
                                    e1.bounds[s] = o[s] = c;
                                    break;
                                case v:
                                    if (!n(c)) return void (e1.enabled = !1);
                                    if ((c = +c) < 0 || c > 24) return void (e1.enabled = !1);
                                    e1.bounds[s] = o[s] = c;
                            }
                            if (!1 === r.autorange) {
                                var f = r.range;
                                if (f[0] < f[1]) {
                                    if (o[0] < f[0] && o[1] > f[1]) return void (e1.enabled = !1);
                                } else if (o[0] > f[0] && o[1] < f[1]) return void (e1.enabled = !1);
                            }
                        } else {
                            var p = i("values");
                            if (!p || !p.length) return void (e1.enabled = !1);
                            i("dvalue");
                        }
                    }
                }
                t1.exports = function(t1, e1, r, n, v) {
                    var _, b = n.letter, w = n.font || {}, T = n.splomStash || {}, k = r("visible", !n.visibleDflt), A = e1._template || {}, M = e1.type || A.type || "-";
                    "date" === M && (i.getComponentMethod("calendars", "handleDefaults")(t1, e1, "calendar", n.calendar), n.noTicklabelmode || (_ = r("ticklabelmode"))), n.noTicklabelindex || "date" !== M && "linear" !== M || r("ticklabelindex");
                    var S = "";
                    n.noTicklabelposition && "multicategory" !== M || (S = a.coerce(t1, e1, {
                        ticklabelposition: {
                            valType: "enumerated",
                            dflt: "outside",
                            values: "period" === _ ? [
                                "outside",
                                "inside"
                            ] : "x" === b ? [
                                "outside",
                                "inside",
                                "outside left",
                                "inside left",
                                "outside right",
                                "inside right"
                            ] : [
                                "outside",
                                "inside",
                                "outside top",
                                "inside top",
                                "outside bottom",
                                "inside bottom"
                            ]
                        }
                    }, "ticklabelposition")), n.noTicklabeloverflow || r("ticklabeloverflow", -1 !== S.indexOf("inside") ? "hide past domain" : "category" === M || "multicategory" === M ? "allow" : "hide past div"), g(e1, v), m(t1, e1, r, n), p(t1, e1, r, n), "category" === M || n.noHover || r("hoverformat");
                    var E = r("color"), C = E !== l.color.dflt ? E : w.color, L = T.label || v._dfltTitle[b];
                    if (f(t1, e1, r, M, n), !k) return e1;
                    r("title.text", L), a.coerceFont(r, "title.font", w, {
                        overrideDflt: {
                            size: a.bigFont(w.size),
                            color: C
                        }
                    }), c(t1, e1, r, M);
                    var I = n.hasMinor;
                    if (I && (o.newContainer(e1, "minor"), c(t1, e1, r, M, {
                        isMinor: !0
                    })), h(t1, e1, r, M, n), u(t1, e1, r, n), I) {
                        var P = n.isMinor;
                        n.isMinor = !0, u(t1, e1, r, n), n.isMinor = P;
                    }
                    d(t1, e1, r, {
                        dfltColor: E,
                        bgColor: n.bgColor,
                        showGrid: n.showGrid,
                        hasMinor: I,
                        attributes: l
                    }), !I || e1.minor.ticks || e1.minor.showgrid || delete e1.minor, (e1.showline || e1.ticks) && r("mirror");
                    var z, O = "multicategory" === M;
                    if (n.noTickson || "category" !== M && !O || !e1.ticks && !e1.showgrid || (O && (z = "boundaries"), "boundaries" === r("tickson", z) && delete e1.ticklabelposition), O && r("showdividers") && (r("dividercolor"), r("dividerwidth")), "date" === M) {
                        if (s(t1, e1, {
                            name: "rangebreaks",
                            inclusionAttr: "enabled",
                            handleItemDefaults: x
                        }), e1.rangebreaks.length) {
                            for(var D = 0; D < e1.rangebreaks.length; D++)if (e1.rangebreaks[D].pattern === y) {
                                e1._hasDayOfWeekBreaks = !0;
                                break;
                            }
                            if (g(e1, v), v._has("scattergl") || v._has("splom")) for(var R = 0; R < n.data.length; R++){
                                var F = n.data[R];
                                "scattergl" !== F.type && "splom" !== F.type || (F.visible = !1, a.warn(F.type + " traces do not work on axes with rangebreaks. Setting trace " + F.index + " to `visible: false`."));
                            }
                        } else delete e1.rangebreaks;
                    }
                    return e1;
                };
                var _ = {
                    sun: 1,
                    mon: 2,
                    tue: 3,
                    wed: 4,
                    thu: 5,
                    fri: 6,
                    sat: 7
                };
                function b(t1) {
                    if ("string" == typeof t1) return _[t1.substr(0, 3).toLowerCase()];
                }
            },
            80712: function(t1, e1, r) {
                "use strict";
                var n = r(87296), i = n.FORMAT_LINK, a = n.DATE_FORMAT_LINK;
                function o(t1, e1) {
                    return [
                        "Sets the " + t1 + " formatting rule" + (e1 ? "for `" + e1 + "` " : ""),
                        "using d3 formatting mini-languages",
                        "which are very similar to those in Python. For numbers, see: " + i + "."
                    ].join(" ");
                }
                function s(t1, e1) {
                    return o(t1, e1) + [
                        " And for dates see: " + a + ".",
                        "We add two items to d3's date formatter:",
                        "*%h* for half of the year as a decimal number as well as",
                        "*%{n}f* for fractional seconds",
                        "with n digits. For example, *2016-10-13 09:15:23.456* with tickformat",
                        "*%H~%M~%S.%2f* would display *09~15~23.46*"
                    ].join(" ");
                }
                t1.exports = {
                    axisHoverFormat: function(t1, e1) {
                        return {
                            valType: "string",
                            dflt: "",
                            editType: "none",
                            description: (e1 ? o : s)("hover text", t1) + [
                                "By default the values are formatted using " + (e1 ? "generic number format" : "`" + t1 + "axis.hoverformat`") + "."
                            ].join(" ")
                        };
                    },
                    descriptionOnlyNumbers: o,
                    descriptionWithDates: s
                };
            },
            5975: function(t1, e1, r) {
                "use strict";
                var n = r(33626), i = r(54826);
                function a(t1, e1) {
                    if (e1 && e1.length) {
                        for(var r = 0; r < e1.length; r++)if (e1[r][t1]) return !0;
                    }
                    return !1;
                }
                e1.id2name = function(t1) {
                    if ("string" == typeof t1 && t1.match(i.AX_ID_PATTERN)) {
                        var e1 = t1.split(" ")[0].substr(1);
                        return "1" === e1 && (e1 = ""), t1.charAt(0) + "axis" + e1;
                    }
                }, e1.name2id = function(t1) {
                    if (t1.match(i.AX_NAME_PATTERN)) {
                        var e1 = t1.substr(5);
                        return "1" === e1 && (e1 = ""), t1.charAt(0) + e1;
                    }
                }, e1.cleanId = function(t1, e1, r) {
                    var n = /( domain)$/.test(t1);
                    if ("string" == typeof t1 && t1.match(i.AX_ID_PATTERN) && (!e1 || t1.charAt(0) === e1) && (!n || r)) {
                        var a = t1.split(" ")[0].substr(1).replace(/^0+/, "");
                        return "1" === a && (a = ""), t1.charAt(0) + a + (n && r ? " domain" : "");
                    }
                }, e1.list = function(t1, r, n) {
                    var i = t1._fullLayout;
                    if (!i) return [];
                    var a, o = e1.listIds(t1, r), s = new Array(o.length);
                    for(a = 0; a < o.length; a++){
                        var l = o[a];
                        s[a] = i[l.charAt(0) + "axis" + l.substr(1)];
                    }
                    if (!n) {
                        var c = i._subplots.gl3d || [];
                        for(a = 0; a < c.length; a++){
                            var u = i[c[a]];
                            r ? s.push(u[r + "axis"]) : s.push(u.xaxis, u.yaxis, u.zaxis);
                        }
                    }
                    return s;
                }, e1.listIds = function(t1, e1) {
                    var r = t1._fullLayout;
                    if (!r) return [];
                    var n = r._subplots;
                    return e1 ? n[e1 + "axis"] : n.xaxis.concat(n.yaxis);
                }, e1.getFromId = function(t1, r, n) {
                    var i = t1._fullLayout;
                    return r = void 0 === r || "string" != typeof r ? r : r.replace(" domain", ""), "x" === n ? r = r.replace(/y[0-9]*/, "") : "y" === n && (r = r.replace(/x[0-9]*/, "")), i[e1.id2name(r)];
                }, e1.getFromTrace = function(t1, r, i) {
                    var a = t1._fullLayout, o = null;
                    if (n.traceIs(r, "gl3d")) {
                        var s = r.scene;
                        "scene" === s.substr(0, 5) && (o = a[s][i + "axis"]);
                    } else o = e1.getFromId(t1, r[i + "axis"] || i);
                    return o;
                }, e1.idSort = function(t1, e1) {
                    var r = t1.charAt(0), n = e1.charAt(0);
                    return r !== n ? r > n ? 1 : -1 : +(t1.substr(1) || 1) - +(e1.substr(1) || 1);
                }, e1.ref2id = function(t1) {
                    return !!/^[xyz]/.test(t1) && t1.split(" ")[0];
                }, e1.isLinked = function(t1, e1) {
                    return a(e1, t1._axisMatchGroups) || a(e1, t1._axisConstraintGroups);
                };
            },
            46473: function(t1, e1, r) {
                "use strict";
                var n = r(87800).isTypedArraySpec;
                t1.exports = function(t1, e1, r, i) {
                    if ("category" === e1.type) {
                        var a, o = t1.categoryarray, s = Array.isArray(o) && o.length > 0 || n(o);
                        s && (a = "array");
                        var l, c = r("categoryorder", a);
                        "array" === c && (l = r("categoryarray")), s || "array" !== c || (c = e1.categoryorder = "trace"), "trace" === c ? e1._initialCategories = [] : "array" === c ? e1._initialCategories = l.slice() : (l = (function(t1, e1) {
                            var r, n, i, a = e1.dataAttr || t1._id.charAt(0), o = {};
                            if (e1.axData) r = e1.axData;
                            else for(r = [], n = 0; n < e1.data.length; n++){
                                var s = e1.data[n];
                                s[a + "axis"] === t1._id && r.push(s);
                            }
                            for(n = 0; n < r.length; n++){
                                var l = r[n][a];
                                for(i = 0; i < l.length; i++){
                                    var c = l[i];
                                    null != c && (o[c] = 1);
                                }
                            }
                            return Object.keys(o);
                        })(e1, i).sort(), "category ascending" === c ? e1._initialCategories = l : "category descending" === c && (e1._initialCategories = l.reverse()));
                    }
                };
            },
            68599: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(34809), a = r(63821), o = a.ONEDAY, s = a.ONEWEEK;
                e1.dtick = function(t1, e1) {
                    var r = "log" === e1, i = "date" === e1, a = "category" === e1, s = i ? o : 1;
                    if (!t1) return s;
                    if (n(t1)) return (t1 = Number(t1)) <= 0 ? s : a ? Math.max(1, Math.round(t1)) : i ? Math.max(.1, t1) : t1;
                    if ("string" != typeof t1 || !i && !r) return s;
                    var l = t1.charAt(0), c = t1.substr(1);
                    return (c = n(c) ? Number(c) : 0) <= 0 || !(i && "M" === l && c === Math.round(c) || r && "L" === l || r && "D" === l && (1 === c || 2 === c)) ? s : t1;
                }, e1.tick0 = function(t1, e1, r, a) {
                    return "date" === e1 ? i.cleanDate(t1, i.dateTick0(r, a % s == 0 ? 1 : 0)) : "D1" !== a && "D2" !== a ? n(t1) ? Number(t1) : 0 : void 0;
                };
            },
            54826: function(t1, e1, r) {
                "use strict";
                var n = r(90694).counter;
                t1.exports = {
                    idRegex: {
                        x: n("x", "( domain)?"),
                        y: n("y", "( domain)?")
                    },
                    attrRegex: n("[xy]axis"),
                    xAxisMatch: n("xaxis"),
                    yAxisMatch: n("yaxis"),
                    AX_ID_PATTERN: /^[xyz][0-9]*( domain)?$/,
                    AX_NAME_PATTERN: /^[xyz]axis[0-9]*$/,
                    SUBPLOT_PATTERN: /^x([0-9]*)y([0-9]*)$/,
                    HOUR_PATTERN: "hour",
                    WEEKDAY_PATTERN: "day of week",
                    MINDRAG: 8,
                    MINZOOM: 20,
                    DRAGGERSIZE: 20,
                    REDRAWDELAY: 50,
                    DFLTRANGEX: [
                        -1,
                        6
                    ],
                    DFLTRANGEY: [
                        -1,
                        4
                    ],
                    traceLayerClasses: [
                        "imagelayer",
                        "heatmaplayer",
                        "contourcarpetlayer",
                        "contourlayer",
                        "funnellayer",
                        "waterfalllayer",
                        "barlayer",
                        "carpetlayer",
                        "violinlayer",
                        "boxlayer",
                        "ohlclayer",
                        "scattercarpetlayer",
                        "scatterlayer"
                    ],
                    clipOnAxisFalseQuery: [
                        ".scatterlayer",
                        ".barlayer",
                        ".funnellayer",
                        ".waterfalllayer"
                    ],
                    layerValue2layerClass: {
                        "above traces": "above",
                        "below traces": "below"
                    },
                    zindexSeparator: "z"
                };
            },
            84391: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(32919), a = r(5975).id2name, o = r(25829), s = r(67611), l = r(19091), c = r(63821).ALMOST_EQUAL, u = r(4530).FROM_BL;
                function h(t1, e1, r) {
                    var i = r.axIds, s = r.layoutOut, l = r.hasImage, c = s._axisConstraintGroups, u = s._axisMatchGroups, h = e1._id, m = h.charAt(0), g = ((s._splomAxes || {})[m] || {})[h] || {}, y = e1._id, v = "x" === y.charAt(0);
                    function x(r, i) {
                        return n.coerce(t1, e1, o, r, i);
                    }
                    e1._matchGroup = null, e1._constraintGroup = null, x("constrain", l ? "domain" : "range"), n.coerce(t1, e1, {
                        constraintoward: {
                            valType: "enumerated",
                            values: v ? [
                                "left",
                                "center",
                                "right"
                            ] : [
                                "bottom",
                                "middle",
                                "top"
                            ],
                            dflt: v ? "center" : "middle"
                        }
                    }, "constraintoward");
                    var _, b, w = e1.type, T = [];
                    for(_ = 0; _ < i.length; _++)(b = i[_]) !== y && s[a(b)].type === w && T.push(b);
                    var k = p(c, y);
                    if (k) {
                        var A = [];
                        for(_ = 0; _ < T.length; _++)k[b = T[_]] || A.push(b);
                        T = A;
                    }
                    var M, S, E = T.length;
                    E && (t1.matches || g.matches) && (M = n.coerce(t1, e1, {
                        matches: {
                            valType: "enumerated",
                            values: T,
                            dflt: -1 !== T.indexOf(g.matches) ? g.matches : void 0
                        }
                    }, "matches"));
                    var C = l && !v ? e1.anchor : void 0;
                    if (E && !M && (t1.scaleanchor || C) && (S = n.coerce(t1, e1, {
                        scaleanchor: {
                            valType: "enumerated",
                            values: T.concat([
                                !1
                            ])
                        }
                    }, "scaleanchor", C)), M) {
                        e1._matchGroup = d(u, y, M, 1);
                        var L = s[a(M)], I = f(s, e1) / f(s, L);
                        v !== ("x" === M.charAt(0)) && (I = (v ? "x" : "y") + I), d(c, y, M, I);
                    } else t1.matches && -1 !== i.indexOf(t1.matches) && n.warn("ignored " + e1._name + '.matches: "' + t1.matches + '" to avoid an infinite loop');
                    if (S) {
                        var P = x("scaleratio");
                        P || (P = e1.scaleratio = 1), d(c, y, S, P);
                    } else t1.scaleanchor && -1 !== i.indexOf(t1.scaleanchor) && n.warn("ignored " + e1._name + '.scaleanchor: "' + t1.scaleanchor + '" to avoid either an infinite loop and possibly inconsistent scaleratios, or because this axis declares a *matches* constraint.');
                }
                function f(t1, e1) {
                    var r = e1.domain;
                    return r || (r = t1[a(e1.overlaying)].domain), r[1] - r[0];
                }
                function p(t1, e1) {
                    for(var r = 0; r < t1.length; r++)if (t1[r][e1]) return t1[r];
                    return null;
                }
                function d(t1, e1, r, n) {
                    var i, a, o, s, l, c = p(t1, e1);
                    null === c ? ((c = {})[e1] = 1, l = t1.length, t1.push(c)) : l = t1.indexOf(c);
                    var u = Object.keys(c);
                    for(i = 0; i < t1.length; i++)if (o = t1[i], i !== l && o[r]) {
                        var h = o[r];
                        for(a = 0; a < u.length; a++)o[s = u[a]] = m(h, m(n, c[s]));
                        return void t1.splice(l, 1);
                    }
                    if (1 !== n) for(a = 0; a < u.length; a++){
                        var f = u[a];
                        c[f] = m(n, c[f]);
                    }
                    c[r] = 1;
                }
                function m(t1, e1) {
                    var r, n, i = "", a = "";
                    "string" == typeof t1 && (r = (i = t1.match(/^[xy]*/)[0]).length, t1 = +t1.substr(r)), "string" == typeof e1 && (n = (a = e1.match(/^[xy]*/)[0]).length, e1 = +e1.substr(n));
                    var o = t1 * e1;
                    return r || n ? r && n && i.charAt(0) !== a.charAt(0) ? r === n ? o : (r > n ? i.substr(n) : a.substr(r)) + o : i + a + t1 * e1 : o;
                }
                function g(t1, e1) {
                    for(var r = e1._size, n = r.h / r.w, i = {}, a = Object.keys(t1), o = 0; o < a.length; o++){
                        var s = a[o], l = t1[s];
                        if ("string" == typeof l) {
                            var c = l.match(/^[xy]*/)[0], u = c.length;
                            l = +l.substr(u);
                            for(var h = "y" === c.charAt(0) ? n : 1 / n, f = 0; f < u; f++)l *= h;
                        }
                        i[s] = l;
                    }
                    return i;
                }
                function y(t1, e1) {
                    var r = t1._inputDomain, n = u[t1.constraintoward], i = r[0] + (r[1] - r[0]) * n;
                    t1.domain = t1._input.domain = [
                        i + (r[0] - i) / e1,
                        i + (r[1] - i) / e1
                    ], t1.setScale();
                }
                e1.handleDefaults = function(t1, e1, r) {
                    var i, o, s, c, u, f, p, d, m = r.axIds, g = r.axHasImage, y = e1._axisConstraintGroups = [], v = e1._axisMatchGroups = [];
                    for(i = 0; i < m.length; i++)h(u = t1[c = a(m[i])], f = e1[c], {
                        axIds: m,
                        layoutOut: e1,
                        hasImage: g[c]
                    });
                    function x(t1, r) {
                        for(i = 0; i < t1.length; i++)for(s in o = t1[i])e1[a(s)][r] = o;
                    }
                    for(x(v, "_matchGroup"), i = 0; i < y.length; i++)for(s in o = y[i])if ((f = e1[a(s)]).fixedrange) {
                        for(var _ in o){
                            var b = a(_);
                            !1 === (t1[b] || {}).fixedrange && n.warn("fixedrange was specified as false for axis " + b + " but was overridden because another axis in its constraint group has fixedrange true"), e1[b].fixedrange = !0;
                        }
                        break;
                    }
                    for(i = 0; i < y.length;){
                        for(s in o = y[i]){
                            (f = e1[a(s)])._matchGroup && Object.keys(f._matchGroup).length === Object.keys(o).length && (y.splice(i, 1), i--);
                            break;
                        }
                        i++;
                    }
                    x(y, "_constraintGroup");
                    var w = [
                        "constrain",
                        "range",
                        "autorange",
                        "rangemode",
                        "rangebreaks",
                        "categoryorder",
                        "categoryarray"
                    ], T = !1, k = !1;
                    function A() {
                        d = f[p], "rangebreaks" === p && (k = f._hasDayOfWeekBreaks);
                    }
                    for(i = 0; i < v.length; i++){
                        o = v[i];
                        for(var M = 0; M < w.length; M++){
                            var S;
                            for(s in p = w[M], d = null, o)if (u = t1[c = a(s)], f = e1[c], p in f) {
                                if (!f.matches && (S = f, p in u)) {
                                    A();
                                    break;
                                }
                                null === d && p in u && A();
                            }
                            if ("range" === p && d && u.range && 2 === u.range.length && null !== u.range[0] && null !== u.range[1] && (T = !0), "autorange" === p && null === d && T && (d = !1), null === d && p in S && (d = S[p]), null !== d) for(s in o)(f = e1[a(s)])[p] = "range" === p ? d.slice() : d, "rangebreaks" === p && (f._hasDayOfWeekBreaks = k, l(f, e1));
                        }
                    }
                }, e1.enforce = function(t1) {
                    var e1, r, n, o, l, u, h, f, p = t1._fullLayout, d = p._axisConstraintGroups || [];
                    for(e1 = 0; e1 < d.length; e1++){
                        n = g(d[e1], p);
                        var m = Object.keys(n), v = 1 / 0, x = 0, _ = 1 / 0, b = {}, w = {}, T = !1;
                        for(r = 0; r < m.length; r++)w[o = m[r]] = l = p[a(o)], l._inputDomain ? l.domain = l._inputDomain.slice() : l._inputDomain = l.domain.slice(), l._inputRange || (l._inputRange = l.range.slice()), l.setScale(), b[o] = u = Math.abs(l._m) / n[o], v = Math.min(v, u), "domain" !== l.constrain && l._constraintShrinkable || (_ = Math.min(_, u)), delete l._constraintShrinkable, x = Math.max(x, u), "domain" === l.constrain && (T = !0);
                        if (!(v > c * x) || T) {
                            for(r = 0; r < m.length; r++)if (u = b[o = m[r]], h = (l = w[o]).constrain, u !== _ || "domain" === h) {
                                if (f = u / _, "range" === h) s(l, f);
                                else {
                                    var k = l._inputDomain, A = (l.domain[1] - l.domain[0]) / (k[1] - k[0]), M = (l.r2l(l.range[1]) - l.r2l(l.range[0])) / (l.r2l(l._inputRange[1]) - l.r2l(l._inputRange[0]));
                                    if ((f /= A) * M < 1) {
                                        l.domain = l._input.domain = k.slice(), s(l, f);
                                        continue;
                                    }
                                    if (M < 1 && (l.range = l._input.range = l._inputRange.slice(), f *= M), l.autorange) {
                                        var S = l.r2l(l.range[0]), E = l.r2l(l.range[1]), C = (S + E) / 2, L = C, I = C, P = Math.abs(E - C), z = C - P * f * 1.0001, O = C + P * f * 1.0001, D = i.makePadFn(p, l, 0), R = i.makePadFn(p, l, 1);
                                        y(l, f);
                                        var F, B, N = Math.abs(l._m), j = i.concatExtremes(t1, l), U = j.min, V = j.max;
                                        for(B = 0; B < U.length; B++)(F = U[B].val - D(U[B]) / N) > z && F < L && (L = F);
                                        for(B = 0; B < V.length; B++)(F = V[B].val + R(V[B]) / N) < O && F > I && (I = F);
                                        f /= (I - L) / (2 * P), L = l.l2r(L), I = l.l2r(I), l.range = l._input.range = S < E ? [
                                            L,
                                            I
                                        ] : [
                                            I,
                                            L
                                        ];
                                    }
                                    y(l, f);
                                }
                            }
                        }
                    }
                }, e1.getAxisGroup = function(t1, e1) {
                    for(var r = t1._axisMatchGroups, n = 0; n < r.length; n++)if (r[n][e1]) return "g" + n;
                    return e1;
                }, e1.clean = function(t1, e1) {
                    if (e1._inputDomain) {
                        for(var r = !1, n = e1._id, i = t1._fullLayout._axisConstraintGroups, a = 0; a < i.length; a++)if (i[a][n]) {
                            r = !0;
                            break;
                        }
                        r && "domain" === e1.constrain || (e1._input.domain = e1.domain = e1._inputDomain, delete e1._inputDomain);
                    }
                };
            },
            51680: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(34809), a = i.numberFormat, o = r(65657), s = r(74043), l = r(33626), c = i.strTranslate, u = r(30635), h = r(78766), f = r(62203), p = r(32141), d = r(29714), m = r(27983), g = r(14751), y = r(70414), v = y.selectingOrDrawing, x = y.freeMode, _ = r(4530).FROM_TL, b = r(34823), w = r(71817).redrawReglTraces, T = r(44122), k = r(5975).getFromId, A = r(44844).prepSelect, M = r(44844).clearOutline, S = r(44844).selectOnClick, E = r(67611), C = r(54826), L = C.MINDRAG, I = C.MINZOOM, P = !0;
                function z(t1, e1, r, n) {
                    var a = i.ensureSingle(t1.draglayer, e1, r, function(e1) {
                        e1.classed("drag", !0).style({
                            fill: "transparent",
                            "stroke-width": 0
                        }).attr("data-subplot", t1.id);
                    });
                    return a.call(m, n), a.node();
                }
                function O(t1, e1, r, i, a, o, s) {
                    var l = z(t1, "rect", e1, r);
                    return n.select(l).call(f.setRect, i, a, o, s), l;
                }
                function D(t1, e1) {
                    for(var r = 0; r < t1.length; r++)if (!t1[r].fixedrange) return e1;
                    return "";
                }
                function R(t1, e1, r, n, i) {
                    for(var a = 0; a < t1.length; a++){
                        var o = t1[a];
                        if (!o.fixedrange) {
                            if (o.rangebreaks) {
                                var s = "y" === o._id.charAt(0), l = s ? 1 - e1 : e1, c = s ? 1 - r : r;
                                n[o._name + ".range[0]"] = o.l2r(o.p2l(l * o._length)), n[o._name + ".range[1]"] = o.l2r(o.p2l(c * o._length));
                            } else {
                                var u = o._rl[0], h = o._rl[1] - u;
                                n[o._name + ".range[0]"] = o.l2r(u + h * e1), n[o._name + ".range[1]"] = o.l2r(u + h * r);
                            }
                        }
                    }
                    if (i && i.length) {
                        var f = (e1 + (1 - r)) / 2;
                        R(i, f, 1 - f, n, []);
                    }
                }
                function F(t1, e1) {
                    for(var r = 0; r < t1.length; r++){
                        var n = t1[r];
                        if (!n.fixedrange) {
                            if (n.rangebreaks) {
                                var i = n._length, a = (n.p2l(0 + e1) - n.p2l(0) + (n.p2l(i + e1) - n.p2l(i))) / 2;
                                n.range = [
                                    n.l2r(n._rl[0] - a),
                                    n.l2r(n._rl[1] - a)
                                ];
                            } else n.range = [
                                n.l2r(n._rl[0] - e1 / n._m),
                                n.l2r(n._rl[1] - e1 / n._m)
                            ];
                            n.limitRange && n.limitRange();
                        }
                    }
                }
                function B(t1) {
                    return 1 - (t1 >= 0 ? Math.min(t1, .9) : 1 / (1 / Math.max(t1, -0.3) + 3.222));
                }
                function N(t1, e1, r, n, i) {
                    return t1.append("path").attr("class", "zoombox").style({
                        fill: e1 > .2 ? "rgba(0,0,0,0)" : "rgba(255,255,255,0)",
                        "stroke-width": 0
                    }).attr("transform", c(r, n)).attr("d", i + "Z");
                }
                function j(t1, e1, r) {
                    return t1.append("path").attr("class", "zoombox-corners").style({
                        fill: h.background,
                        stroke: h.defaultLine,
                        "stroke-width": 1,
                        opacity: 0
                    }).attr("transform", c(e1, r)).attr("d", "M0,0Z");
                }
                function U(t1, e1, r, n, i, a) {
                    t1.attr("d", n + "M" + r.l + "," + r.t + "v" + r.h + "h" + r.w + "v-" + r.h + "h-" + r.w + "Z"), V(t1, e1, i, a);
                }
                function V(t1, e1, r, n) {
                    r || (t1.transition().style("fill", n > .2 ? "rgba(0,0,0,0.4)" : "rgba(255,255,255,0.3)").duration(200), e1.transition().style("opacity", 1).duration(200));
                }
                function q(t1) {
                    n.select(t1).selectAll(".zoombox,.js-zoombox-backdrop,.js-zoombox-menu,.zoombox-corners").remove();
                }
                function H(t1) {
                    P && t1.data && t1._context.showTips && (i.notifier(i._(t1, "Double-click to zoom back out"), "long"), P = !1);
                }
                function G(t1) {
                    var e1 = Math.floor(Math.min(t1.b - t1.t, t1.r - t1.l, I) / 2);
                    return "M" + (t1.l - 3.5) + "," + (t1.t - .5 + e1) + "h3v" + -e1 + "h" + e1 + "v-3h-" + (e1 + 3) + "ZM" + (t1.r + 3.5) + "," + (t1.t - .5 + e1) + "h-3v" + -e1 + "h" + -e1 + "v-3h" + (e1 + 3) + "ZM" + (t1.r + 3.5) + "," + (t1.b + .5 - e1) + "h-3v" + e1 + "h" + -e1 + "v3h" + (e1 + 3) + "ZM" + (t1.l - 3.5) + "," + (t1.b + .5 - e1) + "h3v" + e1 + "h" + e1 + "v3h-" + (e1 + 3) + "Z";
                }
                function Z(t1, e1, r, n, a) {
                    for(var o, s, l, c, u = !1, h = {}, f = {}, p = (a || {}).xaHash, d = (a || {}).yaHash, m = 0; m < e1.length; m++){
                        var g = e1[m];
                        for(o in r)if (g[o]) {
                            for(l in g)a && (p[l] || d[l]) || ("x" === l.charAt(0) ? r : n)[l] || (h[l] = o);
                            for(s in n)a && (p[s] || d[s]) || !g[s] || (u = !0);
                        }
                        for(s in n)if (g[s]) for(c in g)a && (p[c] || d[c]) || ("x" === c.charAt(0) ? r : n)[c] || (f[c] = s);
                    }
                    u && (i.extendFlat(h, f), f = {});
                    var y = {}, v = [];
                    for(l in h){
                        var x = k(t1, l);
                        v.push(x), y[x._id] = x;
                    }
                    var _ = {}, b = [];
                    for(c in f){
                        var w = k(t1, c);
                        b.push(w), _[w._id] = w;
                    }
                    return {
                        xaHash: y,
                        yaHash: _,
                        xaxes: v,
                        yaxes: b,
                        xLinks: h,
                        yLinks: f,
                        isSubplotConstrained: u
                    };
                }
                function W(t1, e1) {
                    if (s) {
                        var r = void 0 !== t1.onwheel ? "wheel" : "mousewheel";
                        t1._onwheel && t1.removeEventListener(r, t1._onwheel), t1._onwheel = e1, t1.addEventListener(r, e1, {
                            passive: !1
                        });
                    } else void 0 !== t1.onwheel ? t1.onwheel = e1 : void 0 !== t1.onmousewheel ? t1.onmousewheel = e1 : t1.isAddedWheelEvent || (t1.isAddedWheelEvent = !0, t1.addEventListener("wheel", e1, {
                        passive: !1
                    }));
                }
                function Y(t1) {
                    var e1 = [];
                    for(var r in t1)e1.push(t1[r]);
                    return e1;
                }
                t1.exports = {
                    makeDragBox: function(t1, e1, r, s, c, h, m, y) {
                        var P, z, V, X, $, J, K, Q, tt, et, rt, nt, it, at, ot, st, lt, ct, ut, ht, ft, pt, dt, mt = t1._fullLayout._zoomlayer, gt = m + y === "nsew", yt = 1 === (m + y).length;
                        function vt() {
                            if (P = e1.xaxis, z = e1.yaxis, tt = P._length, et = z._length, K = P._offset, Q = z._offset, (V = {})[P._id] = P, (X = {})[z._id] = z, m && y) for(var r = e1.overlays, n = 0; n < r.length; n++){
                                var i = r[n].xaxis;
                                V[i._id] = i;
                                var a = r[n].yaxis;
                                X[a._id] = a;
                            }
                            $ = Y(V), J = Y(X), it = D($, y), at = D(J, m), ot = !at && !it, nt = Z(t1, t1._fullLayout._axisMatchGroups, V, X);
                            var o = (rt = Z(t1, t1._fullLayout._axisConstraintGroups, V, X, nt)).isSubplotConstrained || nt.isSubplotConstrained;
                            st = y || o, lt = m || o;
                            var s = t1._fullLayout;
                            ct = s._has("scattergl"), ut = s._has("splom"), ht = s._has("svg");
                        }
                        r += e1.yaxis._shift, vt();
                        var xt = function(t1, e1, r) {
                            return t1 ? "nsew" === t1 ? r ? "" : "pan" === e1 ? "move" : "crosshair" : t1.toLowerCase() + "-resize" : "pointer";
                        }(at + it, t1._fullLayout.dragmode, gt), _t = O(e1, m + y + "drag", xt, r, s, c, h);
                        if (ot && !gt) return _t.onmousedown = null, _t.style.pointerEvents = "none", _t;
                        var bt, wt, Tt, kt, At, Mt, St, Et, Ct, Lt, It = {
                            element: _t,
                            gd: t1,
                            plotinfo: e1
                        };
                        function Pt() {
                            It.plotinfo.selection = !1, M(t1);
                        }
                        function zt(t1, r) {
                            var i = It.gd;
                            if (i._fullLayout._activeShapeIndex >= 0) i._fullLayout._deactivateShape(i);
                            else {
                                var o = i._fullLayout.clickmode;
                                if (q(i), 2 !== t1 || yt || Ht(), gt) o.indexOf("select") > -1 && S(r, i, $, J, e1.id, It), o.indexOf("event") > -1 && p.click(i, r, e1.id);
                                else if (1 === t1 && yt) {
                                    var s = m ? z : P, c = "s" === m || "w" === y ? 0 : 1, h = s._name + ".range[" + c + "]", f = function(t1, e1) {
                                        var r, n = t1.range[e1], i = Math.abs(n - t1.range[1 - e1]);
                                        return "date" === t1.type ? n : "log" === t1.type ? (r = Math.ceil(Math.max(0, -Math.log(i) / Math.LN10)) + 3, a("." + r + "g")(Math.pow(10, n))) : (r = Math.floor(Math.log(Math.abs(n)) / Math.LN10) - Math.floor(Math.log(i) / Math.LN10) + 4, a("." + String(r) + "g")(n));
                                    }(s, c), d = "left", g = "middle";
                                    if (s.fixedrange) return;
                                    m ? (g = "n" === m ? "top" : "bottom", "right" === s.side && (d = "right")) : "e" === y && (d = "right"), i._context.showAxisRangeEntryBoxes && n.select(_t).call(u.makeEditable, {
                                        gd: i,
                                        immediate: !0,
                                        background: i._fullLayout.paper_bgcolor,
                                        text: String(f),
                                        fill: s.tickfont ? s.tickfont.color : "#444",
                                        horizontalAlign: d,
                                        verticalAlign: g
                                    }).on("edit", function(t1) {
                                        var e1 = s.d2r(t1);
                                        void 0 !== e1 && l.call("_guiRelayout", i, h, e1);
                                    });
                                }
                            }
                        }
                        function Ot(e1, r) {
                            if (t1._transitioningWithDuration) return !1;
                            var n = Math.max(0, Math.min(tt, pt * e1 + bt)), i = Math.max(0, Math.min(et, dt * r + wt)), a = Math.abs(n - bt), o = Math.abs(i - wt);
                            function s() {
                                St = "", Tt.r = Tt.l, Tt.t = Tt.b, Ct.attr("d", "M0,0Z");
                            }
                            if (Tt.l = Math.min(bt, n), Tt.r = Math.max(bt, n), Tt.t = Math.min(wt, i), Tt.b = Math.max(wt, i), rt.isSubplotConstrained) a > I || o > I ? (St = "xy", a / tt > o / et ? (o = a * et / tt, wt > i ? Tt.t = wt - o : Tt.b = wt + o) : (a = o * tt / et, bt > n ? Tt.l = bt - a : Tt.r = bt + a), Ct.attr("d", G(Tt))) : s();
                            else if (nt.isSubplotConstrained) {
                                if (a > I || o > I) {
                                    St = "xy";
                                    var l = Math.min(Tt.l / tt, (et - Tt.b) / et), c = Math.max(Tt.r / tt, (et - Tt.t) / et);
                                    Tt.l = l * tt, Tt.r = c * tt, Tt.b = (1 - l) * et, Tt.t = (1 - c) * et, Ct.attr("d", G(Tt));
                                } else s();
                            } else !at || o < Math.min(Math.max(.6 * a, L), I) ? a < L || !it ? s() : (Tt.t = 0, Tt.b = et, St = "x", Ct.attr("d", function(t1, e1) {
                                return "M" + (t1.l - .5) + "," + (e1 - I - .5) + "h-3v" + (2 * I + 1) + "h3ZM" + (t1.r + .5) + "," + (e1 - I - .5) + "h3v" + (2 * I + 1) + "h-3Z";
                            }(Tt, wt))) : !it || a < Math.min(.6 * o, I) ? (Tt.l = 0, Tt.r = tt, St = "y", Ct.attr("d", function(t1, e1) {
                                return "M" + (e1 - I - .5) + "," + (t1.t - .5) + "v-3h" + (2 * I + 1) + "v3ZM" + (e1 - I - .5) + "," + (t1.b + .5) + "v3h" + (2 * I + 1) + "v-3Z";
                            }(Tt, bt))) : (St = "xy", Ct.attr("d", G(Tt)));
                            Tt.w = Tt.r - Tt.l, Tt.h = Tt.b - Tt.t, St && (Lt = !0), t1._dragged = Lt, U(Et, Ct, Tt, At, Mt, kt), Dt(), t1.emit("plotly_relayouting", ft), Mt = !0;
                        }
                        function Dt() {
                            ft = {}, "xy" !== St && "x" !== St || (R($, Tt.l / tt, Tt.r / tt, ft, rt.xaxes), Vt("x", ft)), "xy" !== St && "y" !== St || (R(J, (et - Tt.b) / et, (et - Tt.t) / et, ft, rt.yaxes), Vt("y", ft));
                        }
                        function Rt() {
                            Dt(), q(t1), Gt(), H(t1);
                        }
                        It.prepFn = function(e1, r, n) {
                            var a = It.dragmode, s = t1._fullLayout.dragmode;
                            s !== a && (It.dragmode = s), vt(), pt = t1._fullLayout._invScaleX, dt = t1._fullLayout._invScaleY, ot || (gt ? e1.shiftKey ? "pan" === s ? s = "zoom" : v(s) || (s = "pan") : e1.ctrlKey && (s = "pan") : s = "pan"), x(s) ? It.minDrag = 1 : It.minDrag = void 0, v(s) ? (It.xaxes = $, It.yaxes = J, A(e1, r, n, It, s)) : (It.clickFn = zt, v(a) && Pt(), ot || ("zoom" === s ? (It.moveFn = Ot, It.doneFn = Rt, It.minDrag = 1, function(e1, r, n) {
                                var a = _t.getBoundingClientRect();
                                bt = r - a.left, wt = n - a.top, t1._fullLayout._calcInverseTransform(t1);
                                var s = i.apply3DTransform(t1._fullLayout._invTransform)(bt, wt);
                                bt = s[0], wt = s[1], Tt = {
                                    l: bt,
                                    r: bt,
                                    w: 0,
                                    t: wt,
                                    b: wt,
                                    h: 0
                                }, kt = t1._hmpixcount ? t1._hmlumcount / t1._hmpixcount : o(t1._fullLayout.plot_bgcolor).getLuminance(), Mt = !1, St = "xy", Lt = !1, Et = N(mt, kt, K, Q, At = "M0,0H" + tt + "V" + et + "H0V0"), Ct = j(mt, K, Q);
                            }(0, r, n)) : "pan" === s && (It.moveFn = Ut, It.doneFn = Gt))), t1._fullLayout._redrag = function() {
                                var e1 = t1._dragdata;
                                if (e1 && e1.element === _t) {
                                    var r = t1._fullLayout.dragmode;
                                    v(r) || (vt(), Zt([
                                        0,
                                        0,
                                        tt,
                                        et
                                    ]), It.moveFn(e1.dx, e1.dy));
                                }
                            };
                        }, g.init(It);
                        var Ft = [
                            0,
                            0,
                            tt,
                            et
                        ], Bt = null, Nt = C.REDRAWDELAY, jt = e1.mainplot ? t1._fullLayout._plots[e1.mainplot] : e1;
                        function Ut(e1, r) {
                            if (e1 *= pt, r *= dt, !t1._transitioningWithDuration) {
                                if (t1._fullLayout._replotting = !0, "ew" === it || "ns" === at) {
                                    var n = it ? -e1 : 0, i = at ? -r : 0;
                                    if (nt.isSubplotConstrained) {
                                        if (it && at) {
                                            var a = (e1 / tt - r / et) / 2;
                                            n = -(e1 = a * tt), i = -(r = -a * et);
                                        }
                                        at ? n = -i * tt / et : i = -n * et / tt;
                                    }
                                    return it && (F($, e1), Vt("x")), at && (F(J, r), Vt("y")), Zt([
                                        n,
                                        i,
                                        tt,
                                        et
                                    ]), qt(), void t1.emit("plotly_relayouting", ft);
                                }
                                var o, s, l = "w" === it == ("n" === at) ? 1 : -1;
                                if (it && at && (rt.isSubplotConstrained || nt.isSubplotConstrained)) {
                                    var c = (e1 / tt + l * r / et) / 2;
                                    e1 = c * tt, r = l * c * et;
                                }
                                if ("w" === it ? e1 = p($, 0, e1) : "e" === it ? e1 = p($, 1, -e1) : it || (e1 = 0), "n" === at ? r = p(J, 1, r) : "s" === at ? r = p(J, 0, -r) : at || (r = 0), o = "w" === it ? e1 : 0, s = "n" === at ? r : 0, rt.isSubplotConstrained && !nt.isSubplotConstrained || nt.isSubplotConstrained && it && at && l > 0) {
                                    var u;
                                    if (nt.isSubplotConstrained || !it && 1 === at.length) {
                                        for(u = 0; u < $.length; u++)$[u].range = $[u]._r.slice(), E($[u], 1 - r / et);
                                        o = (e1 = r * tt / et) / 2;
                                    }
                                    if (nt.isSubplotConstrained || !at && 1 === it.length) {
                                        for(u = 0; u < J.length; u++)J[u].range = J[u]._r.slice(), E(J[u], 1 - e1 / tt);
                                        s = (r = e1 * et / tt) / 2;
                                    }
                                }
                                nt.isSubplotConstrained && at || Vt("x"), nt.isSubplotConstrained && it || Vt("y");
                                var h = tt - e1, f = et - r;
                                !nt.isSubplotConstrained || it && at || (it ? (s = o ? 0 : e1 * et / tt, f = h * et / tt) : (o = s ? 0 : r * tt / et, h = f * tt / et)), Zt([
                                    o,
                                    s,
                                    h,
                                    f
                                ]), qt(), t1.emit("plotly_relayouting", ft);
                            }
                            function p(t1, e1, r) {
                                for(var n, i, a = 1 - e1, o = 0; o < t1.length; o++){
                                    var s = t1[o];
                                    if (!s.fixedrange) {
                                        n = s, i = s._rl[a] + (s._rl[e1] - s._rl[a]) / B(r / s._length);
                                        var l = s.l2r(i);
                                        !1 !== l && void 0 !== l && (s.range[e1] = l);
                                    }
                                }
                                return n._length * (n._rl[e1] - i) / (n._rl[e1] - n._rl[a]);
                            }
                        }
                        function Vt(t1, e1) {
                            for(var r = nt.isSubplotConstrained ? ({
                                x: J,
                                y: $
                            })[t1] : nt[t1 + "axes"], n = nt.isSubplotConstrained ? ({
                                x: $,
                                y: J
                            })[t1] : [], i = 0; i < r.length; i++){
                                var a = r[i], o = a._id, s = nt.xLinks[o] || nt.yLinks[o], l = n[0] || V[s] || X[s];
                                l && (e1 ? (e1[a._name + ".range[0]"] = e1[l._name + ".range[0]"], e1[a._name + ".range[1]"] = e1[l._name + ".range[1]"]) : a.range = l.range.slice());
                            }
                        }
                        function qt() {
                            var r, n = [];
                            function i(t1) {
                                for(r = 0; r < t1.length; r++)t1[r].fixedrange || n.push(t1[r]._id);
                            }
                            function a(t1, e1) {
                                for(r = 0; r < t1.length; r++){
                                    var i = t1[r], a = i[e1];
                                    i.fixedrange || "sync" !== a.tickmode || n.push(a._id);
                                }
                            }
                            for(st && (i($), i(rt.xaxes), i(nt.xaxes), a(e1.overlays, "xaxis")), lt && (i(J), i(rt.yaxes), i(nt.yaxes), a(e1.overlays, "yaxis")), ft = {}, r = 0; r < n.length; r++){
                                var o = n[r], s = k(t1, o);
                                d.drawOne(t1, s, {
                                    skipTitle: !0
                                }), ft[s._name + ".range[0]"] = s.range[0], ft[s._name + ".range[1]"] = s.range[1];
                            }
                            d.redrawComponents(t1, n);
                        }
                        function Ht() {
                            if (!t1._transitioningWithDuration) {
                                var e1 = t1._context.doubleClick, r = [];
                                it && (r = r.concat($)), at && (r = r.concat(J)), nt.xaxes && (r = r.concat(nt.xaxes)), nt.yaxes && (r = r.concat(nt.yaxes));
                                var n, i, a = {};
                                if ("reset+autosize" === e1) for(e1 = "autosize", i = 0; i < r.length; i++){
                                    var o = (n = r[i])._rangeInitial0, s = n._rangeInitial1, c = void 0 !== o || void 0 !== s;
                                    if (c && (void 0 !== o && o !== n.range[0] || void 0 !== s && s !== n.range[1]) || !c && !0 !== n.autorange) {
                                        e1 = "reset";
                                        break;
                                    }
                                }
                                if ("autosize" === e1) for(i = 0; i < r.length; i++)(n = r[i]).fixedrange || (a[n._name + ".autorange"] = !0);
                                else if ("reset" === e1) {
                                    for((it || rt.isSubplotConstrained) && (r = r.concat(rt.xaxes)), at && !rt.isSubplotConstrained && (r = r.concat(rt.yaxes)), rt.isSubplotConstrained && (it ? at || (r = r.concat(J)) : r = r.concat($)), i = 0; i < r.length; i++)if (!(n = r[i]).fixedrange) {
                                        var u = n._name, h = n._autorangeInitial;
                                        void 0 === n._rangeInitial0 && void 0 === n._rangeInitial1 ? a[u + ".autorange"] = !0 : void 0 === n._rangeInitial0 ? (a[u + ".autorange"] = h, a[u + ".range"] = [
                                            null,
                                            n._rangeInitial1
                                        ]) : void 0 === n._rangeInitial1 ? (a[u + ".range"] = [
                                            n._rangeInitial0,
                                            null
                                        ], a[u + ".autorange"] = h) : a[u + ".range"] = [
                                            n._rangeInitial0,
                                            n._rangeInitial1
                                        ];
                                    }
                                }
                                t1.emit("plotly_doubleclick", null), l.call("_guiRelayout", t1, a);
                            }
                        }
                        function Gt() {
                            Zt([
                                0,
                                0,
                                tt,
                                et
                            ]), i.syncOrAsync([
                                T.previousPromises,
                                function() {
                                    t1._fullLayout._replotting = !1, l.call("_guiRelayout", t1, ft);
                                }
                            ], t1);
                        }
                        function Zt(e1) {
                            var r, n, a, o, s = t1._fullLayout, c = s._plots, u = s._subplots.cartesian;
                            if (ut && l.subplotsRegistry.splom.drag(t1), ct) {
                                for(r = 0; r < u.length; r++)if (a = (n = c[u[r]]).xaxis, o = n.yaxis, n._scene) {
                                    a.limitRange && a.limitRange(), o.limitRange && o.limitRange();
                                    var h = i.simpleMap(a.range, a.r2l), p = i.simpleMap(o.range, o.r2l);
                                    n._scene.update({
                                        range: [
                                            h[0],
                                            p[0],
                                            h[1],
                                            p[1]
                                        ]
                                    });
                                }
                            }
                            if ((ut || ct) && (b(t1), w(t1)), ht) {
                                var d = e1[2] / P._length, g = e1[3] / z._length;
                                for(r = 0; r < u.length; r++){
                                    a = (n = c[u[r]]).xaxis, o = n.yaxis;
                                    var v, x, _, T, k = (st || nt.isSubplotConstrained) && !a.fixedrange && V[a._id], A = (lt || nt.isSubplotConstrained) && !o.fixedrange && X[o._id];
                                    if (k ? (v = d, _ = y || nt.isSubplotConstrained ? e1[0] : Xt(a, v)) : nt.xaHash[a._id] ? (v = d, _ = e1[0] * a._length / P._length) : nt.yaHash[a._id] ? (v = g, _ = "ns" === at ? -e1[1] * a._length / z._length : Xt(a, v, {
                                        n: "top",
                                        s: "bottom"
                                    }[at])) : _ = Yt(a, v = Wt(a, d, g)), v > 1 && (void 0 !== a.maxallowed && st === (a.range[0] < a.range[1] ? "e" : "w") || void 0 !== a.minallowed && st === (a.range[0] < a.range[1] ? "w" : "e")) && (v = 1, _ = 0), A ? (x = g, T = m || nt.isSubplotConstrained ? e1[1] : Xt(o, x)) : nt.yaHash[o._id] ? (x = g, T = e1[1] * o._length / z._length) : nt.xaHash[o._id] ? (x = d, T = "ew" === it ? -e1[0] * o._length / P._length : Xt(o, x, {
                                        e: "right",
                                        w: "left"
                                    }[it])) : T = Yt(o, x = Wt(o, d, g)), x > 1 && (void 0 !== o.maxallowed && lt === (o.range[0] < o.range[1] ? "n" : "s") || void 0 !== o.minallowed && lt === (o.range[0] < o.range[1] ? "s" : "n")) && (x = 1, T = 0), v || x) {
                                        v || (v = 1), x || (x = 1);
                                        var M = a._offset - _ / v, S = o._offset - T / x;
                                        n.clipRect.call(f.setTranslate, _, T).call(f.setScale, v, x), n.plot.call(f.setTranslate, M, S).call(f.setScale, 1 / v, 1 / x), v === n.xScaleFactor && x === n.yScaleFactor || (f.setPointGroupScale(n.zoomScalePts, v, x), f.setTextPointsScale(n.zoomScaleTxt, v, x)), f.hideOutsideRangePoints(n.clipOnAxisFalseTraces, n), n.xScaleFactor = v, n.yScaleFactor = x;
                                    }
                                }
                            }
                        }
                        function Wt(t1, e1, r) {
                            return t1.fixedrange ? 0 : st && rt.xaHash[t1._id] ? e1 : lt && (rt.isSubplotConstrained ? rt.xaHash : rt.yaHash)[t1._id] ? r : 0;
                        }
                        function Yt(t1, e1) {
                            return e1 ? (t1.range = t1._r.slice(), E(t1, e1), Xt(t1, e1)) : 0;
                        }
                        function Xt(t1, e1, r) {
                            return t1._length * (1 - e1) * _[r || t1.constraintoward || "middle"];
                        }
                        return m.length * y.length != 1 && W(_t, function(e1) {
                            if (t1._context._scrollZoom.cartesian || t1._fullLayout._enablescrollzoom) {
                                if (Pt(), t1._transitioningWithDuration) return e1.preventDefault(), void e1.stopPropagation();
                                vt(), clearTimeout(Bt);
                                var r = -e1.deltaY;
                                if (isFinite(r) || (r = e1.wheelDelta / 10), isFinite(r)) {
                                    var n, a = Math.exp(-Math.min(Math.max(r, -20), 20) / 200), o = jt.draglayer.select(".nsewdrag").node().getBoundingClientRect(), s = (e1.clientX - o.left) / o.width, l = (o.bottom - e1.clientY) / o.height;
                                    if (st) {
                                        for(y || (s = .5), n = 0; n < $.length; n++)c($[n], s, a);
                                        Vt("x"), Ft[2] *= a, Ft[0] += Ft[2] * s * (1 / a - 1);
                                    }
                                    if (lt) {
                                        for(m || (l = .5), n = 0; n < J.length; n++)c(J[n], l, a);
                                        Vt("y"), Ft[3] *= a, Ft[1] += Ft[3] * (1 - l) * (1 / a - 1);
                                    }
                                    Zt(Ft), qt(), t1.emit("plotly_relayouting", ft), Bt = setTimeout(function() {
                                        t1._fullLayout && (Ft = [
                                            0,
                                            0,
                                            tt,
                                            et
                                        ], Gt());
                                    }, Nt), e1.preventDefault();
                                } else i.log("Did not find wheel motion attributes: ", e1);
                            }
                            function c(t1, e1, r) {
                                if (!t1.fixedrange) {
                                    var n = i.simpleMap(t1.range, t1.r2l), a = n[0] + (n[1] - n[0]) * e1;
                                    t1.range = n.map(function(e1) {
                                        return t1.l2r(a + (e1 - a) * r);
                                    });
                                }
                            }
                        }), _t;
                    },
                    makeDragger: z,
                    makeRectDragger: O,
                    makeZoombox: N,
                    makeCorners: j,
                    updateZoombox: U,
                    xyCorners: G,
                    transitionZoombox: V,
                    removeZoombox: q,
                    showDoubleClickNotifier: H,
                    attachWheelEventHandler: W
                };
            },
            95284: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(32141), a = r(14751), o = r(27983), s = r(51680).makeDragBox, l = r(54826).DRAGGERSIZE;
                e1.initInteractions = function(t1) {
                    var r = t1._fullLayout;
                    if (t1._context.staticPlot) n.select(t1).selectAll(".drag").remove();
                    else if (r._has("cartesian") || r._has("splom")) {
                        Object.keys(r._plots || {}).sort(function(t1, e1) {
                            if ((r._plots[t1].mainplot && !0) === (r._plots[e1].mainplot && !0)) {
                                var n = t1.split("y"), i = e1.split("y");
                                return n[0] === i[0] ? Number(n[1] || 1) - Number(i[1] || 1) : Number(n[0] || 1) - Number(i[0] || 1);
                            }
                            return r._plots[t1].mainplot ? 1 : -1;
                        }).forEach(function(e1) {
                            var n = r._plots[e1], o = n.xaxis, c = n.yaxis;
                            if (!n.mainplot) {
                                var u = s(t1, n, o._offset, c._offset, o._length, c._length, "ns", "ew");
                                u.onmousemove = function(r) {
                                    t1._fullLayout._rehover = function() {
                                        t1._fullLayout._hoversubplot === e1 && t1._fullLayout._plots[e1] && i.hover(t1, r, e1);
                                    }, i.hover(t1, r, e1), t1._fullLayout._lasthover = u, t1._fullLayout._hoversubplot = e1;
                                }, u.onmouseout = function(e1) {
                                    t1._dragging || (t1._fullLayout._hoversubplot = null, a.unhover(t1, e1));
                                }, t1._context.showAxisDragHandles && (s(t1, n, o._offset - l, c._offset - l, l, l, "n", "w"), s(t1, n, o._offset + o._length, c._offset - l, l, l, "n", "e"), s(t1, n, o._offset - l, c._offset + c._length, l, l, "s", "w"), s(t1, n, o._offset + o._length, c._offset + c._length, l, l, "s", "e"));
                            }
                            if (t1._context.showAxisDragHandles) {
                                if (e1 === o._mainSubplot) {
                                    var h = o._mainLinePosition;
                                    "top" === o.side && (h -= l), s(t1, n, o._offset + .1 * o._length, h, .8 * o._length, l, "", "ew"), s(t1, n, o._offset, h, .1 * o._length, l, "", "w"), s(t1, n, o._offset + .9 * o._length, h, .1 * o._length, l, "", "e");
                                }
                                if (e1 === c._mainSubplot) {
                                    var f = c._mainLinePosition;
                                    "right" !== c.side && (f -= l), s(t1, n, f, c._offset + .1 * c._length, l, .8 * c._length, "ns", ""), s(t1, n, f, c._offset + .9 * c._length, l, .1 * c._length, "s", ""), s(t1, n, f, c._offset, l, .1 * c._length, "n", "");
                                }
                            }
                        });
                        var o = r._hoverlayer.node();
                        o.onmousemove = function(e1) {
                            e1.target = t1._fullLayout._lasthover, i.hover(t1, e1, r._hoversubplot);
                        }, o.onclick = function(e1) {
                            e1.target = t1._fullLayout._lasthover, i.click(t1, e1);
                        }, o.onmousedown = function(e1) {
                            t1._fullLayout._lasthover.onmousedown(e1);
                        }, e1.updateFx(t1);
                    }
                }, e1.updateFx = function(t1) {
                    var e1 = t1._fullLayout, r = "pan" === e1.dragmode ? "move" : "crosshair";
                    o(e1._draggers, r);
                };
            },
            20706: function(t1, e1, r) {
                "use strict";
                var n = r(33626), i = r(34809), a = r(5975);
                t1.exports = function(t1) {
                    return function(e1, r) {
                        var o = e1[t1];
                        if (Array.isArray(o)) for(var s = n.subplotsRegistry.cartesian, l = s.idRegex, c = r._subplots, u = c.xaxis, h = c.yaxis, f = c.cartesian, p = r._has("cartesian") || r._has("gl2d"), d = 0; d < o.length; d++){
                            var m = o[d];
                            if (i.isPlainObject(m)) {
                                var g = a.cleanId(m.xref, "x", !1), y = a.cleanId(m.yref, "y", !1), v = l.x.test(g), x = l.y.test(y);
                                if (v || x) {
                                    p || i.pushUnique(r._basePlotModules, s);
                                    var _ = !1;
                                    v && -1 === u.indexOf(g) && (u.push(g), _ = !0), x && -1 === h.indexOf(y) && (h.push(y), _ = !0), _ && v && x && f.push(g + y);
                                }
                            }
                        }
                    };
                };
            },
            37703: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(33626), a = r(34809), o = r(44122), s = r(62203), l = r(4173).eV, c = r(5975), u = r(54826), h = r(62972), f = a.ensureSingle;
                function p(t1, e1, r) {
                    return a.ensureSingle(t1, e1, r, function(t1) {
                        t1.datum(r);
                    });
                }
                var d = u.zindexSeparator;
                function m(t1, e1, r, a, o) {
                    for(var c, h, f, p = u.traceLayerClasses, d = t1._fullLayout, m = d._zindices, g = d._modules, y = [], v = [], x = 0; x < m.length; x++)for(var _ = m[x], b = 0; b < g.length; b++){
                        var w = (c = g[b]).name, T = i.modules[w].categories;
                        if (T.svg) {
                            var k = c.layerName || w + "layer", A = k + (x ? Number(x) + 1 : ""), M = c.plot;
                            f = (h = l(r, M, _))[0], r = h[1], f.length && y.push({
                                i: p.indexOf(k),
                                zindex: x,
                                className: A,
                                plotMethod: M,
                                cdModule: f
                            }), T.zoomScale && v.push("." + A);
                        }
                    }
                    y.sort(function(t1, e1) {
                        return (t1.zindex || 0) - (e1.zindex || 0) || t1.i - e1.i;
                    });
                    var S = e1.plot.selectAll("g.mlayer").data(y, function(t1) {
                        return t1.className;
                    });
                    if (S.enter().append("g").attr("class", function(t1) {
                        return t1.className;
                    }).classed("mlayer", !0).classed("rangeplot", e1.isRangePlot), S.exit().remove(), S.order(), S.each(function(r) {
                        var i = n.select(this), l = r.className;
                        r.plotMethod(t1, e1, r.cdModule, i, a, o), -1 === u.clipOnAxisFalseQuery.indexOf("." + l) && s.setClipUrl(i, e1.layerClipId, t1);
                    }), d._has("scattergl") && (c = i.getModule("scattergl"), f = l(r, c)[0], c.plot(t1, e1, f)), !t1._context.staticPlot && (e1._hasClipOnAxisFalse && (e1.clipOnAxisFalseTraces = e1.plot.selectAll(u.clipOnAxisFalseQuery.join(",")).selectAll(".trace")), v.length)) {
                        var E = e1.plot.selectAll(v.join(",")).selectAll(".trace");
                        e1.zoomScalePts = E.selectAll("path.point"), e1.zoomScaleTxt = E.selectAll(".textpoint");
                    }
                }
                function g(t1, e1) {
                    var r = t1._fullLayout, n = e1.plotgroup, i = e1.id, a = -1 !== i.indexOf(d), o = u.layerValue2layerClass[e1.xaxis.layer], s = u.layerValue2layerClass[e1.yaxis.layer], l = r._hasOnlyLargeSploms;
                    if (!e1.mainplot || r._zindices.length > 1) {
                        if (l) e1.xlines = f(n, "path", "xlines-above"), e1.ylines = f(n, "path", "ylines-above"), e1.xaxislayer = f(n, "g", "xaxislayer-above"), e1.yaxislayer = f(n, "g", "yaxislayer-above");
                        else {
                            if (!a) {
                                var h = f(n, "g", "layer-subplot");
                                e1.shapelayer = f(h, "g", "shapelayer"), e1.imagelayer = f(h, "g", "imagelayer"), e1.minorGridlayer = f(n, "g", "minor-gridlayer"), e1.gridlayer = f(n, "g", "gridlayer"), e1.zerolinelayer = f(n, "g", "zerolinelayer");
                                var m = f(n, "g", "layer-between");
                                e1.shapelayerBetween = f(m, "g", "shapelayer"), e1.imagelayerBetween = f(m, "g", "imagelayer"), f(n, "path", "xlines-below"), f(n, "path", "ylines-below"), e1.overlinesBelow = f(n, "g", "overlines-below"), f(n, "g", "xaxislayer-below"), f(n, "g", "yaxislayer-below"), e1.overaxesBelow = f(n, "g", "overaxes-below");
                            }
                            e1.overplot = f(n, "g", "overplot"), e1.plot = f(e1.overplot, "g", i), a || (e1.xlines = f(n, "path", "xlines-above"), e1.ylines = f(n, "path", "ylines-above"), e1.overlinesAbove = f(n, "g", "overlines-above"), f(n, "g", "xaxislayer-above"), f(n, "g", "yaxislayer-above"), e1.overaxesAbove = f(n, "g", "overaxes-above"), e1.xlines = n.select(".xlines-" + o), e1.ylines = n.select(".ylines-" + s), e1.xaxislayer = n.select(".xaxislayer-" + o), e1.yaxislayer = n.select(".yaxislayer-" + s));
                        }
                    } else {
                        var g = e1.mainplotinfo, y = g.plotgroup, v = i + "-x", x = i + "-y";
                        e1.minorGridlayer = g.minorGridlayer, e1.gridlayer = g.gridlayer, e1.zerolinelayer = g.zerolinelayer, f(g.overlinesBelow, "path", v), f(g.overlinesBelow, "path", x), f(g.overaxesBelow, "g", v), f(g.overaxesBelow, "g", x), e1.plot = f(g.overplot, "g", i), f(g.overlinesAbove, "path", v), f(g.overlinesAbove, "path", x), f(g.overaxesAbove, "g", v), f(g.overaxesAbove, "g", x), e1.xlines = y.select(".overlines-" + o).select("." + v), e1.ylines = y.select(".overlines-" + s).select("." + x), e1.xaxislayer = y.select(".overaxes-" + o).select("." + v), e1.yaxislayer = y.select(".overaxes-" + s).select("." + x);
                    }
                    a || (l || (p(e1.minorGridlayer, "g", e1.xaxis._id), p(e1.minorGridlayer, "g", e1.yaxis._id), e1.minorGridlayer.selectAll("g").map(function(t1) {
                        return t1[0];
                    }).sort(c.idSort), p(e1.gridlayer, "g", e1.xaxis._id), p(e1.gridlayer, "g", e1.yaxis._id), e1.gridlayer.selectAll("g").map(function(t1) {
                        return t1[0];
                    }).sort(c.idSort)), e1.xlines.style("fill", "none").classed("crisp", !0), e1.ylines.style("fill", "none").classed("crisp", !0));
                }
                function y(t1, e1) {
                    if (t1) {
                        var r = {};
                        for(var i in t1.each(function(t1) {
                            var i = t1[0];
                            n.select(this).remove(), v(i, e1), r[i] = !0;
                        }), e1._plots)for(var a = e1._plots[i].overlays || [], o = 0; o < a.length; o++){
                            var s = a[o];
                            r[s.id] && s.plot.selectAll(".trace").remove();
                        }
                    }
                }
                function v(t1, e1) {
                    e1._draggers.selectAll("g." + t1).remove(), e1._defs.select("#clip" + e1._uid + t1 + "plot").remove();
                }
                e1.name = "cartesian", e1.attr = [
                    "xaxis",
                    "yaxis"
                ], e1.idRoot = [
                    "x",
                    "y"
                ], e1.idRegex = u.idRegex, e1.attrRegex = u.attrRegex, e1.attributes = r(55126), e1.layoutAttributes = r(25829), e1.supplyLayoutDefaults = r(74098), e1.transitionAxes = r(84982), e1.finalizeSubplots = function(t1, e1) {
                    var r, n, i, o = e1._subplots, s = o.xaxis, l = o.yaxis, h = o.cartesian, f = h.concat(o.gl2d || []), p = {}, d = {};
                    for(r = 0; r < f.length; r++){
                        var m = f[r].split("y");
                        p[m[0]] = 1, d["y" + m[1]] = 1;
                    }
                    for(r = 0; r < s.length; r++)p[n = s[r]] || (i = (t1[c.id2name(n)] || {}).anchor, u.idRegex.y.test(i) || (i = "y"), h.push(n + i), f.push(n + i), d[i] || (d[i] = 1, a.pushUnique(l, i)));
                    for(r = 0; r < l.length; r++)d[i = l[r]] || (n = (t1[c.id2name(i)] || {}).anchor, u.idRegex.x.test(n) || (n = "x"), h.push(n + i), f.push(n + i), p[n] || (p[n] = 1, a.pushUnique(s, n)));
                    if (!f.length) {
                        for(var g in n = "", i = "", t1)u.attrRegex.test(g) && ("x" === g.charAt(0) ? (!n || +g.substr(5) < +n.substr(5)) && (n = g) : (!i || +g.substr(5) < +i.substr(5)) && (i = g));
                        n = n ? c.name2id(n) : "x", i = i ? c.name2id(i) : "y", s.push(n), l.push(i), h.push(n + i);
                    }
                }, e1.plot = function(t1, e1, r, n) {
                    var i, o = t1._fullLayout, s = o._subplots.cartesian, l = t1.calcdata;
                    if (!Array.isArray(e1)) for(e1 = [], i = 0; i < l.length; i++)e1.push(i);
                    for(var c = o._zindices, u = 0; u < c.length; u++){
                        var h = c[u];
                        for(i = 0; i < s.length; i++){
                            var f = s[i], p = o._plots[f];
                            if (u > 0) {
                                var g = p.id;
                                if (-1 !== g.indexOf(d)) continue;
                                g += d + (u + 1), p = a.extendFlat({}, p, {
                                    id: g,
                                    plot: o._cartesianlayer.selectAll(".subplot").select("." + g)
                                });
                            }
                            for(var y, v = [], x = 0; x < l.length; x++){
                                var _ = l[x], b = _[0].trace;
                                h === (b.zorder || 0) && b.xaxis + b.yaxis === f && ((-1 !== e1.indexOf(b.index) || b.carpet) && (y && y[0].trace.xaxis + y[0].trace.yaxis === f && -1 !== [
                                    "tonextx",
                                    "tonexty",
                                    "tonext"
                                ].indexOf(b.fill) && -1 === v.indexOf(y) && v.push(y), v.push(_)), y = _);
                            }
                            m(t1, p, v, r, n);
                        }
                    }
                }, e1.clean = function(t1, e1, r, n) {
                    var i, a, o, s = n._plots || {}, l = e1._plots || {}, u = n._subplots || {};
                    if (n._hasOnlyLargeSploms && !e1._hasOnlyLargeSploms) for(o in s)(i = s[o]).plotgroup && i.plotgroup.remove();
                    var h = n._has && n._has("gl"), f = e1._has && e1._has("gl");
                    if (h && !f) for(o in s)(i = s[o])._scene && i._scene.destroy();
                    if (u.xaxis && u.yaxis) {
                        var p = c.listIds({
                            _fullLayout: n
                        });
                        for(a = 0; a < p.length; a++){
                            var m = p[a];
                            e1[c.id2name(m)] || n._infolayer.selectAll(".g-" + m + "title").remove();
                        }
                    }
                    var g = n._has && n._has("cartesian"), x = e1._has && e1._has("cartesian");
                    if (g && !x) y(n._cartesianlayer.selectAll(".subplot"), n), n._defs.selectAll(".axesclip").remove(), delete n._axisConstraintGroups, delete n._axisMatchGroups;
                    else if (u.cartesian) for(a = 0; a < u.cartesian.length; a++){
                        var _ = u.cartesian[a];
                        if (-1 === _.indexOf(d) && !l[_]) {
                            var b = "." + _ + ",." + _ + "-x,." + _ + "-y";
                            n._cartesianlayer.selectAll(b).remove(), v(_, n);
                        }
                    }
                }, e1.drawFramework = function(t1) {
                    var e1, r = t1._fullLayout, i = t1.calcdata, o = {};
                    for(e1 = 0; e1 < i.length; e1++){
                        var s = i[e1][0], l = s.trace.zorder || 0;
                        o[l] || (o[l] = []), o[l].push(s);
                    }
                    var c = Object.keys(o).map(Number).sort(a.sorterAsc);
                    c.length || (c = [
                        0
                    ]), r._zindices = c;
                    var u = function(t1) {
                        var e1, r, n, i, a, o, s = t1._fullLayout, l = s._zindices.length, c = s._subplots.cartesian, u = c.length, h = [], f = [];
                        for(e1 = 0; e1 < u; e1++){
                            n = c[e1], a = (i = s._plots[n]).xaxis, o = i.yaxis;
                            var p = a._mainAxis, m = o._mainAxis, g = p._id + m._id, y = s._plots[g];
                            i.overlays = [], g !== n && y ? (i.mainplot = g, i.mainplotinfo = y, f.push(n)) : (i.mainplot = void 0, i.mainplotinfo = void 0, h.push(n));
                        }
                        for(e1 = 0; e1 < f.length; e1++)n = f[e1], (i = s._plots[n]).mainplotinfo.overlays.push(i);
                        var v = h.concat(f), x = [];
                        for(e1 = 0; e1 < u; e1++){
                            n = v[e1], a = (i = s._plots[n]).xaxis, o = i.yaxis;
                            for(var _ = [], b = 1; b <= l; b++){
                                var w = "";
                                for(b > 1 && (w += d + b), _.push(n + w), r = 0; r < i.overlays.length; r++)_.push(i.overlays[r].id + w);
                            }
                            _ = _.concat([
                                a.layer,
                                o.layer,
                                a.overlaying || "",
                                o.overlaying || ""
                            ]), x.push(_);
                        }
                        return x;
                    }(t1), h = u.length, p = [];
                    for(e1 = 0; e1 < h; e1++)p[e1] = u[e1].slice();
                    for(var m = 1; m < c.length; m++){
                        var v = [];
                        for(e1 = 0; e1 < h; e1++)v[e1] = u[e1].slice(), v[e1][0] += d + (m + 1);
                        p = p.concat(v);
                    }
                    var x = r._cartesianlayer.selectAll(".subplot").data(p, String);
                    x.enter().append("g").attr("class", function(t1) {
                        return "subplot " + t1[0];
                    }), x.order(), x.exit().call(y, r), x.each(function(e1) {
                        var i = e1[0], o = i.indexOf(d), s = -1 !== o, l = s ? i.slice(0, o) : i, c = r._plots[i];
                        c || (c = a.extendFlat({}, r._plots[l])) && (c.id = i, r._plots[i] = c, r._subplots.cartesian.push(i)), c && (c.plotgroup = n.select(this), g(t1, c), s || (c.draglayer = f(r._draggers, "g", i)));
                    });
                }, e1.rangePlot = function(t1, e1, r) {
                    g(t1, e1), m(t1, e1, r), o.style(t1);
                }, e1.toSVG = function(t1) {
                    var e1 = t1._fullLayout._glimages, r = n.select(t1).selectAll(".svg-container");
                    r.filter(function(t1, e1) {
                        return e1 === r.size() - 1;
                    }).selectAll(".gl-canvas-context, .gl-canvas-focus").each(function() {
                        var t1 = this, r = t1.toDataURL("image/png");
                        e1.append("svg:image").attr({
                            xmlns: h.svg,
                            "xlink:href": r,
                            preserveAspectRatio: "none",
                            x: 0,
                            y: 0,
                            width: t1.style.width,
                            height: t1.style.height
                        });
                    });
                }, e1.updateFx = r(95284).updateFx;
            },
            25829: function(t1, e1, r) {
                "use strict";
                var n = r(80337), i = r(10229), a = r(94850).T, o = r(93049).extendFlat, s = r(78032).templatedArray, l = r(80712).descriptionWithDates, c = r(63821).ONEDAY, u = r(54826), h = u.HOUR_PATTERN, f = u.WEEKDAY_PATTERN, p = {
                    valType: "enumerated",
                    values: [
                        "auto",
                        "linear",
                        "array"
                    ],
                    editType: "ticks",
                    impliedEdits: {
                        tick0: void 0,
                        dtick: void 0
                    }
                }, d = o({}, p, {
                    values: p.values.slice().concat([
                        "sync"
                    ])
                });
                function m(t1) {
                    return {
                        valType: "integer",
                        min: 0,
                        dflt: t1 ? 5 : 0,
                        editType: "ticks"
                    };
                }
                var g = {
                    valType: "any",
                    editType: "ticks",
                    impliedEdits: {
                        tickmode: "linear"
                    }
                }, y = {
                    valType: "any",
                    editType: "ticks",
                    impliedEdits: {
                        tickmode: "linear"
                    }
                }, v = {
                    valType: "data_array",
                    editType: "ticks"
                }, x = {
                    valType: "enumerated",
                    values: [
                        "outside",
                        "inside",
                        ""
                    ],
                    editType: "ticks"
                };
                function _(t1) {
                    var e1 = {
                        valType: "number",
                        min: 0,
                        editType: "ticks"
                    };
                    return t1 || (e1.dflt = 5), e1;
                }
                function b(t1) {
                    var e1 = {
                        valType: "number",
                        min: 0,
                        editType: "ticks"
                    };
                    return t1 || (e1.dflt = 1), e1;
                }
                var w = {
                    valType: "color",
                    dflt: i.defaultLine,
                    editType: "ticks"
                }, T = {
                    valType: "color",
                    dflt: i.lightLine,
                    editType: "ticks"
                };
                function k(t1) {
                    var e1 = {
                        valType: "number",
                        min: 0,
                        editType: "ticks"
                    };
                    return t1 || (e1.dflt = 1), e1;
                }
                var A = o({}, a, {
                    editType: "ticks"
                }), M = {
                    valType: "boolean",
                    editType: "ticks"
                };
                t1.exports = {
                    visible: {
                        valType: "boolean",
                        editType: "plot"
                    },
                    color: {
                        valType: "color",
                        dflt: i.defaultLine,
                        editType: "ticks"
                    },
                    title: {
                        text: {
                            valType: "string",
                            editType: "ticks"
                        },
                        font: n({
                            editType: "ticks"
                        }),
                        standoff: {
                            valType: "number",
                            min: 0,
                            editType: "ticks"
                        },
                        editType: "ticks"
                    },
                    type: {
                        valType: "enumerated",
                        values: [
                            "-",
                            "linear",
                            "log",
                            "date",
                            "category",
                            "multicategory"
                        ],
                        dflt: "-",
                        editType: "calc",
                        _noTemplating: !0
                    },
                    autotypenumbers: {
                        valType: "enumerated",
                        values: [
                            "convert types",
                            "strict"
                        ],
                        dflt: "convert types",
                        editType: "calc"
                    },
                    autorange: {
                        valType: "enumerated",
                        values: [
                            !0,
                            !1,
                            "reversed",
                            "min reversed",
                            "max reversed",
                            "min",
                            "max"
                        ],
                        dflt: !0,
                        editType: "axrange",
                        impliedEdits: {
                            "range[0]": void 0,
                            "range[1]": void 0
                        }
                    },
                    autorangeoptions: {
                        minallowed: {
                            valType: "any",
                            editType: "plot",
                            impliedEdits: {
                                "range[0]": void 0,
                                "range[1]": void 0
                            }
                        },
                        maxallowed: {
                            valType: "any",
                            editType: "plot",
                            impliedEdits: {
                                "range[0]": void 0,
                                "range[1]": void 0
                            }
                        },
                        clipmin: {
                            valType: "any",
                            editType: "plot",
                            impliedEdits: {
                                "range[0]": void 0,
                                "range[1]": void 0
                            }
                        },
                        clipmax: {
                            valType: "any",
                            editType: "plot",
                            impliedEdits: {
                                "range[0]": void 0,
                                "range[1]": void 0
                            }
                        },
                        include: {
                            valType: "any",
                            arrayOk: !0,
                            editType: "plot",
                            impliedEdits: {
                                "range[0]": void 0,
                                "range[1]": void 0
                            }
                        },
                        editType: "plot"
                    },
                    rangemode: {
                        valType: "enumerated",
                        values: [
                            "normal",
                            "tozero",
                            "nonnegative"
                        ],
                        dflt: "normal",
                        editType: "plot"
                    },
                    range: {
                        valType: "info_array",
                        items: [
                            {
                                valType: "any",
                                editType: "axrange",
                                impliedEdits: {
                                    "^autorange": !1
                                },
                                anim: !0
                            },
                            {
                                valType: "any",
                                editType: "axrange",
                                impliedEdits: {
                                    "^autorange": !1
                                },
                                anim: !0
                            }
                        ],
                        editType: "axrange",
                        impliedEdits: {
                            autorange: !1
                        },
                        anim: !0
                    },
                    minallowed: {
                        valType: "any",
                        editType: "plot",
                        impliedEdits: {
                            "^autorange": !1
                        }
                    },
                    maxallowed: {
                        valType: "any",
                        editType: "plot",
                        impliedEdits: {
                            "^autorange": !1
                        }
                    },
                    fixedrange: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "calc"
                    },
                    insiderange: {
                        valType: "info_array",
                        items: [
                            {
                                valType: "any",
                                editType: "plot"
                            },
                            {
                                valType: "any",
                                editType: "plot"
                            }
                        ],
                        editType: "plot"
                    },
                    scaleanchor: {
                        valType: "enumerated",
                        values: [
                            u.idRegex.x.toString(),
                            u.idRegex.y.toString(),
                            !1
                        ],
                        editType: "plot"
                    },
                    scaleratio: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        editType: "plot"
                    },
                    constrain: {
                        valType: "enumerated",
                        values: [
                            "range",
                            "domain"
                        ],
                        editType: "plot"
                    },
                    constraintoward: {
                        valType: "enumerated",
                        values: [
                            "left",
                            "center",
                            "right",
                            "top",
                            "middle",
                            "bottom"
                        ],
                        editType: "plot"
                    },
                    matches: {
                        valType: "enumerated",
                        values: [
                            u.idRegex.x.toString(),
                            u.idRegex.y.toString()
                        ],
                        editType: "calc"
                    },
                    rangebreaks: s("rangebreak", {
                        enabled: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "calc"
                        },
                        bounds: {
                            valType: "info_array",
                            items: [
                                {
                                    valType: "any",
                                    editType: "calc"
                                },
                                {
                                    valType: "any",
                                    editType: "calc"
                                }
                            ],
                            editType: "calc"
                        },
                        pattern: {
                            valType: "enumerated",
                            values: [
                                f,
                                h,
                                ""
                            ],
                            editType: "calc"
                        },
                        values: {
                            valType: "info_array",
                            freeLength: !0,
                            editType: "calc",
                            items: {
                                valType: "any",
                                editType: "calc"
                            }
                        },
                        dvalue: {
                            valType: "number",
                            editType: "calc",
                            min: 0,
                            dflt: c
                        },
                        editType: "calc"
                    }),
                    tickmode: d,
                    nticks: m(),
                    tick0: g,
                    dtick: y,
                    ticklabelstep: {
                        valType: "integer",
                        min: 1,
                        dflt: 1,
                        editType: "ticks"
                    },
                    tickvals: v,
                    ticktext: {
                        valType: "data_array",
                        editType: "ticks"
                    },
                    ticks: x,
                    tickson: {
                        valType: "enumerated",
                        values: [
                            "labels",
                            "boundaries"
                        ],
                        dflt: "labels",
                        editType: "ticks"
                    },
                    ticklabelmode: {
                        valType: "enumerated",
                        values: [
                            "instant",
                            "period"
                        ],
                        dflt: "instant",
                        editType: "ticks"
                    },
                    ticklabelposition: {
                        valType: "enumerated",
                        values: [
                            "outside",
                            "inside",
                            "outside top",
                            "inside top",
                            "outside left",
                            "inside left",
                            "outside right",
                            "inside right",
                            "outside bottom",
                            "inside bottom"
                        ],
                        dflt: "outside",
                        editType: "calc"
                    },
                    ticklabeloverflow: {
                        valType: "enumerated",
                        values: [
                            "allow",
                            "hide past div",
                            "hide past domain"
                        ],
                        editType: "calc"
                    },
                    ticklabelshift: {
                        valType: "integer",
                        dflt: 0,
                        editType: "ticks"
                    },
                    ticklabelstandoff: {
                        valType: "integer",
                        dflt: 0,
                        editType: "ticks"
                    },
                    ticklabelindex: {
                        valType: "integer",
                        arrayOk: !0,
                        editType: "calc"
                    },
                    mirror: {
                        valType: "enumerated",
                        values: [
                            !0,
                            "ticks",
                            !1,
                            "all",
                            "allticks"
                        ],
                        dflt: !1,
                        editType: "ticks+layoutstyle"
                    },
                    ticklen: _(),
                    tickwidth: b(),
                    tickcolor: w,
                    showticklabels: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "ticks"
                    },
                    labelalias: {
                        valType: "any",
                        dflt: !1,
                        editType: "ticks"
                    },
                    automargin: {
                        valType: "flaglist",
                        flags: [
                            "height",
                            "width",
                            "left",
                            "right",
                            "top",
                            "bottom"
                        ],
                        extras: [
                            !0,
                            !1
                        ],
                        dflt: !1,
                        editType: "ticks"
                    },
                    showspikes: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "modebar"
                    },
                    spikecolor: {
                        valType: "color",
                        dflt: null,
                        editType: "none"
                    },
                    spikethickness: {
                        valType: "number",
                        dflt: 3,
                        editType: "none"
                    },
                    spikedash: o({}, a, {
                        dflt: "dash",
                        editType: "none"
                    }),
                    spikemode: {
                        valType: "flaglist",
                        flags: [
                            "toaxis",
                            "across",
                            "marker"
                        ],
                        dflt: "toaxis",
                        editType: "none"
                    },
                    spikesnap: {
                        valType: "enumerated",
                        values: [
                            "data",
                            "cursor",
                            "hovered data"
                        ],
                        dflt: "hovered data",
                        editType: "none"
                    },
                    tickfont: n({
                        editType: "ticks"
                    }),
                    tickangle: {
                        valType: "angle",
                        dflt: "auto",
                        editType: "ticks"
                    },
                    autotickangles: {
                        valType: "info_array",
                        freeLength: !0,
                        items: {
                            valType: "angle"
                        },
                        dflt: [
                            0,
                            30,
                            90
                        ],
                        editType: "ticks"
                    },
                    tickprefix: {
                        valType: "string",
                        dflt: "",
                        editType: "ticks"
                    },
                    showtickprefix: {
                        valType: "enumerated",
                        values: [
                            "all",
                            "first",
                            "last",
                            "none"
                        ],
                        dflt: "all",
                        editType: "ticks"
                    },
                    ticksuffix: {
                        valType: "string",
                        dflt: "",
                        editType: "ticks"
                    },
                    showticksuffix: {
                        valType: "enumerated",
                        values: [
                            "all",
                            "first",
                            "last",
                            "none"
                        ],
                        dflt: "all",
                        editType: "ticks"
                    },
                    showexponent: {
                        valType: "enumerated",
                        values: [
                            "all",
                            "first",
                            "last",
                            "none"
                        ],
                        dflt: "all",
                        editType: "ticks"
                    },
                    exponentformat: {
                        valType: "enumerated",
                        values: [
                            "none",
                            "e",
                            "E",
                            "power",
                            "SI",
                            "B"
                        ],
                        dflt: "B",
                        editType: "ticks"
                    },
                    minexponent: {
                        valType: "number",
                        dflt: 3,
                        min: 0,
                        editType: "ticks"
                    },
                    separatethousands: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "ticks"
                    },
                    tickformat: {
                        valType: "string",
                        dflt: "",
                        editType: "ticks",
                        description: l("tick label")
                    },
                    tickformatstops: s("tickformatstop", {
                        enabled: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "ticks"
                        },
                        dtickrange: {
                            valType: "info_array",
                            items: [
                                {
                                    valType: "any",
                                    editType: "ticks"
                                },
                                {
                                    valType: "any",
                                    editType: "ticks"
                                }
                            ],
                            editType: "ticks"
                        },
                        value: {
                            valType: "string",
                            dflt: "",
                            editType: "ticks"
                        },
                        editType: "ticks"
                    }),
                    hoverformat: {
                        valType: "string",
                        dflt: "",
                        editType: "none",
                        description: l("hover text")
                    },
                    showline: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "ticks+layoutstyle"
                    },
                    linecolor: {
                        valType: "color",
                        dflt: i.defaultLine,
                        editType: "layoutstyle"
                    },
                    linewidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        editType: "ticks+layoutstyle"
                    },
                    showgrid: M,
                    gridcolor: T,
                    gridwidth: k(),
                    griddash: A,
                    zeroline: {
                        valType: "boolean",
                        editType: "ticks"
                    },
                    zerolinecolor: {
                        valType: "color",
                        dflt: i.defaultLine,
                        editType: "ticks"
                    },
                    zerolinewidth: {
                        valType: "number",
                        dflt: 1,
                        editType: "ticks"
                    },
                    showdividers: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "ticks"
                    },
                    dividercolor: {
                        valType: "color",
                        dflt: i.defaultLine,
                        editType: "ticks"
                    },
                    dividerwidth: {
                        valType: "number",
                        dflt: 1,
                        editType: "ticks"
                    },
                    anchor: {
                        valType: "enumerated",
                        values: [
                            "free",
                            u.idRegex.x.toString(),
                            u.idRegex.y.toString()
                        ],
                        editType: "plot"
                    },
                    side: {
                        valType: "enumerated",
                        values: [
                            "top",
                            "bottom",
                            "left",
                            "right"
                        ],
                        editType: "plot"
                    },
                    overlaying: {
                        valType: "enumerated",
                        values: [
                            "free",
                            u.idRegex.x.toString(),
                            u.idRegex.y.toString()
                        ],
                        editType: "plot"
                    },
                    minor: {
                        tickmode: p,
                        nticks: m("minor"),
                        tick0: g,
                        dtick: y,
                        tickvals: v,
                        ticks: x,
                        ticklen: _("minor"),
                        tickwidth: b("minor"),
                        tickcolor: w,
                        gridcolor: T,
                        gridwidth: k("minor"),
                        griddash: A,
                        showgrid: M,
                        editType: "ticks"
                    },
                    layer: {
                        valType: "enumerated",
                        values: [
                            "above traces",
                            "below traces"
                        ],
                        dflt: "above traces",
                        editType: "plot"
                    },
                    domain: {
                        valType: "info_array",
                        items: [
                            {
                                valType: "number",
                                min: 0,
                                max: 1,
                                editType: "plot"
                            },
                            {
                                valType: "number",
                                min: 0,
                                max: 1,
                                editType: "plot"
                            }
                        ],
                        dflt: [
                            0,
                            1
                        ],
                        editType: "plot"
                    },
                    position: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 0,
                        editType: "plot"
                    },
                    autoshift: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "plot"
                    },
                    shift: {
                        valType: "number",
                        editType: "plot"
                    },
                    categoryorder: {
                        valType: "enumerated",
                        values: [
                            "trace",
                            "category ascending",
                            "category descending",
                            "array",
                            "total ascending",
                            "total descending",
                            "min ascending",
                            "min descending",
                            "max ascending",
                            "max descending",
                            "sum ascending",
                            "sum descending",
                            "mean ascending",
                            "mean descending",
                            "geometric mean ascending",
                            "geometric mean descending",
                            "median ascending",
                            "median descending"
                        ],
                        dflt: "trace",
                        editType: "calc"
                    },
                    categoryarray: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    uirevision: {
                        valType: "any",
                        editType: "none"
                    },
                    editType: "calc",
                    _deprecated: {
                        autotick: {
                            valType: "boolean",
                            editType: "ticks"
                        },
                        title: {
                            valType: "string",
                            editType: "ticks"
                        },
                        titlefont: n({
                            editType: "ticks"
                        })
                    }
                };
            },
            74098: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(78766), a = r(36040).isUnifiedHover, o = r(45265), s = r(78032), l = r(6704), c = r(25829), u = r(4392), h = r(97655), f = r(84391), p = r(40957), d = r(5975), m = d.id2name, g = d.name2id, y = r(54826).AX_ID_PATTERN, v = r(33626), x = v.traceIs, _ = v.getComponentMethod;
                function b(t1, e1, r) {
                    Array.isArray(t1[e1]) ? t1[e1].push(r) : t1[e1] = [
                        r
                    ];
                }
                t1.exports = function(t1, e1, r) {
                    var v, w, T = e1.autotypenumbers, k = {}, A = {}, M = {}, S = {}, E = {}, C = {}, L = {}, I = {}, P = {}, z = {};
                    for(v = 0; v < r.length; v++){
                        var O = r[v];
                        if (x(O, "cartesian") || x(O, "gl2d")) {
                            var D, R;
                            if (O.xaxis) D = m(O.xaxis), b(k, D, O);
                            else if (O.xaxes) for(w = 0; w < O.xaxes.length; w++)b(k, m(O.xaxes[w]), O);
                            if (O.yaxis) R = m(O.yaxis), b(k, R, O);
                            else if (O.yaxes) for(w = 0; w < O.yaxes.length; w++)b(k, m(O.yaxes[w]), O);
                            "funnel" === O.type ? "h" === O.orientation ? (D && (A[D] = !0), R && (L[R] = !0)) : R && (M[R] = !0) : "image" === O.type ? (R && (I[R] = !0), D && (I[D] = !0)) : (R && (E[R] = !0, C[R] = !0), x(O, "carpet") && ("carpet" !== O.type || O._cheater) || D && (S[D] = !0)), "carpet" === O.type && O._cheater && D && (A[D] = !0), x(O, "2dMap") && (P[D] = !0, P[R] = !0), x(O, "oriented") && (z["h" === O.orientation ? R : D] = !0);
                        }
                    }
                    var F = e1._subplots, B = F.xaxis, N = F.yaxis, j = n.simpleMap(B, m), U = n.simpleMap(N, m), V = j.concat(U), q = i.background;
                    B.length && N.length && (q = n.coerce(t1, e1, l, "plot_bgcolor"));
                    var H, G, Z, W, Y, X = i.combine(q, e1.paper_bgcolor);
                    function $() {
                        var t1 = k[H] || [];
                        Y._traceIndices = t1.map(function(t1) {
                            return t1._expandedIndex;
                        }), Y._annIndices = [], Y._shapeIndices = [], Y._selectionIndices = [], Y._imgIndices = [], Y._subplotsWith = [], Y._counterAxes = [], Y._name = Y._attr = H, Y._id = G;
                    }
                    function J(t1, e1) {
                        return n.coerce(W, Y, c, t1, e1);
                    }
                    function K(t1, e1) {
                        return n.coerce2(W, Y, c, t1, e1);
                    }
                    function Q(t1) {
                        return "x" === t1 ? N : B;
                    }
                    function tt(e1, r) {
                        for(var n = "x" === e1 ? j : U, i = [], a = 0; a < n.length; a++){
                            var o = n[a];
                            o === r || (t1[o] || {}).overlaying || i.push(g(o));
                        }
                        return i;
                    }
                    var et = {
                        x: Q("x"),
                        y: Q("y")
                    }, rt = et.x.concat(et.y), nt = {}, it = [];
                    function at() {
                        var t1 = W.matches;
                        y.test(t1) && -1 === rt.indexOf(t1) && (nt[t1] = W.type, it = Object.keys(nt));
                    }
                    var ot = o(t1, e1), st = a(ot);
                    for(v = 0; v < V.length; v++){
                        H = V[v], G = g(H), Z = H.charAt(0), n.isPlainObject(t1[H]) || (t1[H] = {}), W = t1[H], Y = s.newContainer(e1, H, Z + "axis"), $();
                        var lt = "x" === Z && !S[H] && A[H] || "y" === Z && !E[H] && M[H], ct = "y" === Z && (!C[H] && L[H] || I[H]), ut = {
                            hasMinor: !0,
                            letter: Z,
                            font: e1.font,
                            outerTicks: P[H],
                            showGrid: !z[H],
                            data: k[H] || [],
                            bgColor: X,
                            calendar: e1.calendar,
                            automargin: !0,
                            visibleDflt: lt,
                            reverseDflt: ct,
                            autotypenumbersDflt: T,
                            splomStash: ((e1._splomAxes || {})[Z] || {})[G],
                            noAutotickangles: "y" === Z
                        };
                        J("uirevision", e1.uirevision), u(W, Y, J, ut), h(W, Y, J, ut, e1);
                        var ht = st && Z === ot.charAt(0), ft = K("spikecolor", st ? Y.color : void 0), pt = K("spikethickness", st ? 1.5 : void 0), dt = K("spikedash", st ? "dot" : void 0), mt = K("spikemode", st ? "across" : void 0), gt = K("spikesnap");
                        J("showspikes", !!(ht || ft || pt || dt || mt || gt)) || (delete Y.spikecolor, delete Y.spikethickness, delete Y.spikedash, delete Y.spikemode, delete Y.spikesnap);
                        var yt = m(W.overlaying), vt = [
                            0,
                            1
                        ];
                        if (void 0 !== e1[yt]) {
                            var xt = m(e1[yt].anchor);
                            void 0 !== e1[xt] && (vt = e1[xt].domain);
                        }
                        p(W, Y, J, {
                            letter: Z,
                            counterAxes: et[Z],
                            overlayableAxes: tt(Z, H),
                            grid: e1.grid,
                            overlayingDomain: vt
                        }), J("title.standoff"), at(), Y._input = W;
                    }
                    for(v = 0; v < it.length;){
                        G = it[v++], Z = (H = m(G)).charAt(0), n.isPlainObject(t1[H]) || (t1[H] = {}), W = t1[H], Y = s.newContainer(e1, H, Z + "axis"), $();
                        var _t = {
                            letter: Z,
                            font: e1.font,
                            outerTicks: P[H],
                            showGrid: !z[H],
                            data: [],
                            bgColor: X,
                            calendar: e1.calendar,
                            automargin: !0,
                            visibleDflt: !1,
                            reverseDflt: !1,
                            autotypenumbersDflt: T,
                            splomStash: ((e1._splomAxes || {})[Z] || {})[G]
                        };
                        J("uirevision", e1.uirevision), Y.type = nt[G] || "linear", h(W, Y, J, _t, e1), p(W, Y, J, {
                            letter: Z,
                            counterAxes: et[Z],
                            overlayableAxes: tt(Z, H),
                            grid: e1.grid
                        }), J("fixedrange"), at(), Y._input = W;
                    }
                    var bt = _("rangeslider", "handleDefaults"), wt = _("rangeselector", "handleDefaults");
                    for(v = 0; v < j.length; v++)H = j[v], W = t1[H], Y = e1[H], bt(t1, e1, H), "date" === Y.type && wt(W, Y, e1, U, Y.calendar), J("fixedrange");
                    for(v = 0; v < U.length; v++){
                        H = U[v], W = t1[H], Y = e1[H];
                        var Tt = e1[m(Y.anchor)];
                        J("fixedrange", _("rangeslider", "isVisible")(Tt));
                    }
                    f.handleDefaults(t1, e1, {
                        axIds: rt.concat(it).sort(d.idSort),
                        axHasImage: I
                    });
                };
            },
            97405: function(t1, e1, r) {
                "use strict";
                var n = r(65657).mix, i = r(10229), a = r(34809);
                t1.exports = function(t1, e1, r, o) {
                    var s = (o = o || {}).dfltColor;
                    function l(r, n) {
                        return a.coerce2(t1, e1, o.attributes, r, n);
                    }
                    var c = l("linecolor", s), u = l("linewidth");
                    r("showline", o.showLine || !!c || !!u) || (delete e1.linecolor, delete e1.linewidth);
                    var h = l("gridcolor", n(s, o.bgColor, o.blend || i.lightFraction).toRgbString()), f = l("gridwidth"), p = l("griddash");
                    if (r("showgrid", o.showGrid || !!h || !!f || !!p) || (delete e1.gridcolor, delete e1.gridwidth, delete e1.griddash), o.hasMinor) {
                        var d = l("minor.gridcolor", n(e1.gridcolor, o.bgColor, 67).toRgbString()), m = l("minor.gridwidth", e1.gridwidth || 1), g = l("minor.griddash", e1.griddash || "solid");
                        r("minor.showgrid", !!d || !!m || !!g) || (delete e1.minor.gridcolor, delete e1.minor.gridwidth, delete e1.minor.griddash);
                    }
                    if (!o.noZeroLine) {
                        var y = l("zerolinecolor", s), v = l("zerolinewidth");
                        r("zeroline", o.showGrid || !!y || !!v) || (delete e1.zerolinecolor, delete e1.zerolinewidth);
                    }
                };
            },
            40957: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(34809);
                t1.exports = function(t1, e1, r, a) {
                    var o, s, l, c, u, h, f = a.counterAxes || [], p = a.overlayableAxes || [], d = a.letter, m = a.grid, g = a.overlayingDomain;
                    m && (s = m._domains[d][m._axisMap[e1._id]], o = m._anchors[e1._id], s && (l = m[d + "side"].split(" ")[0], c = m.domain[d]["right" === l || "top" === l ? 1 : 0])), s = s || [
                        0,
                        1
                    ], o = o || (n(t1.position) ? "free" : f[0] || "free"), l = l || ("x" === d ? "bottom" : "left"), c = c || 0, u = 0, h = !1;
                    var y = i.coerce(t1, e1, {
                        anchor: {
                            valType: "enumerated",
                            values: [
                                "free"
                            ].concat(f),
                            dflt: o
                        }
                    }, "anchor"), v = i.coerce(t1, e1, {
                        side: {
                            valType: "enumerated",
                            values: "x" === d ? [
                                "bottom",
                                "top"
                            ] : [
                                "left",
                                "right"
                            ],
                            dflt: l
                        }
                    }, "side");
                    "free" === y && ("y" === d && (r("autoshift") && (c = "left" === v ? g[0] : g[1], h = !e1.automargin || e1.automargin, u = "left" === v ? -3 : 3), r("shift", u)), r("position", c)), r("automargin", h);
                    var x = !1;
                    if (p.length && (x = i.coerce(t1, e1, {
                        overlaying: {
                            valType: "enumerated",
                            values: [
                                !1
                            ].concat(p),
                            dflt: !1
                        }
                    }, "overlaying")), !x) {
                        var _ = r("domain", s);
                        _[0] > _[1] - 1 / 4096 && (e1.domain = s), i.noneOrAll(t1.domain, e1.domain, s), "sync" === e1.tickmode && (e1.tickmode = "auto");
                    }
                    return r("layer"), e1;
                };
            },
            54616: function(t1, e1, r) {
                "use strict";
                var n = r(87703);
                t1.exports = function(t1, e1, r, i, a) {
                    a || (a = {});
                    var o = a.tickSuffixDflt, s = n(t1);
                    r("tickprefix") && r("showtickprefix", s), r("ticksuffix", o) && r("showticksuffix", s);
                };
            },
            90259: function(t1, e1, r) {
                "use strict";
                var n = r(75511);
                t1.exports = function(t1, e1, r, i) {
                    var a = e1._template || {}, o = e1.type || a.type || "-";
                    r("minallowed"), r("maxallowed");
                    var s, l = r("range");
                    l || i.noInsiderange || "log" === o || (!(s = r("insiderange")) || null !== s[0] && null !== s[1] || (e1.insiderange = !1, s = void 0), s && (l = r("range", s)));
                    var c, u = e1.getAutorangeDflt(l, i), h = r("autorange", u);
                    !l || (null !== l[0] || null !== l[1]) && (null !== l[0] && null !== l[1] || "reversed" !== h && !0 !== h) && (null === l[0] || "min" !== h && "max reversed" !== h) && (null === l[1] || "max" !== h && "min reversed" !== h) || (l = void 0, delete e1.range, e1.autorange = !0, c = !0), c || (h = r("autorange", u = e1.getAutorangeDflt(l, i))), h && (n(r, h, l), "linear" !== o && "-" !== o || r("rangemode")), e1.cleanRange();
                };
            },
            67611: function(t1, e1, r) {
                "use strict";
                var n = r(4530).FROM_BL;
                t1.exports = function(t1, e1, r) {
                    void 0 === r && (r = n[t1.constraintoward || "center"]);
                    var i = [
                        t1.r2l(t1.range[0]),
                        t1.r2l(t1.range[1])
                    ], a = i[0] + (i[1] - i[0]) * r;
                    t1.range = t1._input.range = [
                        t1.l2r(a + (i[0] - a) * e1),
                        t1.l2r(a + (i[1] - a) * e1)
                    ], t1.setScale();
                };
            },
            19091: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(42696).aL, a = r(34809), o = a.numberFormat, s = r(10721), l = a.cleanNumber, c = a.ms2DateTime, u = a.dateTime2ms, h = a.ensureNumber, f = a.isArrayOrTypedArray, p = r(63821), d = p.FP_SAFE, m = p.BADNUM, g = p.LOG_CLIP, y = p.ONEWEEK, v = p.ONEDAY, x = p.ONEHOUR, _ = p.ONEMIN, b = p.ONESEC, w = r(5975), T = r(54826), k = T.HOUR_PATTERN, A = T.WEEKDAY_PATTERN;
                function M(t1) {
                    return Math.pow(10, t1);
                }
                function S(t1) {
                    return null != t1;
                }
                t1.exports = function(t1, e1) {
                    e1 = e1 || {};
                    var r = t1._id || "x", p = r.charAt(0);
                    function E(e1, r) {
                        if (e1 > 0) return Math.log(e1) / Math.LN10;
                        if (e1 <= 0 && r && t1.range && 2 === t1.range.length) {
                            var n = t1.range[0], i = t1.range[1];
                            return .5 * (n + i - 2 * g * Math.abs(n - i));
                        }
                        return m;
                    }
                    function C(e1, r, n, i) {
                        if ((i || {}).msUTC && s(e1)) return +e1;
                        var o = u(e1, n || t1.calendar);
                        if (o === m) {
                            if (!s(e1)) return m;
                            e1 = +e1;
                            var l = Math.floor(10 * a.mod(e1 + .05, 1)), c = Math.round(e1 - l / 10);
                            o = u(new Date(c)) + l / 10;
                        }
                        return o;
                    }
                    function L(e1, r, n) {
                        return c(e1, r, n || t1.calendar);
                    }
                    function I(e1) {
                        return t1._categories[Math.round(e1)];
                    }
                    function P(e1) {
                        if (S(e1)) {
                            if (void 0 === t1._categoriesMap && (t1._categoriesMap = {}), void 0 !== t1._categoriesMap[e1]) return t1._categoriesMap[e1];
                            t1._categories.push("number" == typeof e1 ? String(e1) : e1);
                            var r = t1._categories.length - 1;
                            return t1._categoriesMap[e1] = r, r;
                        }
                        return m;
                    }
                    function z(e1) {
                        if (t1._categoriesMap) return t1._categoriesMap[e1];
                    }
                    function O(t1) {
                        var e1 = z(t1);
                        return void 0 !== e1 ? e1 : s(t1) ? +t1 : void 0;
                    }
                    function D(t1) {
                        return s(t1) ? +t1 : z(t1);
                    }
                    function R(t1, e1, r) {
                        return n.round(r + e1 * t1, 2);
                    }
                    function F(t1, e1, r) {
                        return (t1 - r) / e1;
                    }
                    var B = function(e1) {
                        return s(e1) ? R(e1, t1._m, t1._b) : m;
                    }, N = function(e1) {
                        return F(e1, t1._m, t1._b);
                    };
                    if (t1.rangebreaks) {
                        var j = "y" === p;
                        B = function(e1) {
                            if (!s(e1)) return m;
                            var r = t1._rangebreaks.length;
                            if (!r) return R(e1, t1._m, t1._b);
                            var n = j;
                            t1.range[0] > t1.range[1] && (n = !n);
                            for(var i = n ? -1 : 1, a = i * e1, o = 0, l = 0; l < r; l++){
                                var c = i * t1._rangebreaks[l].min, u = i * t1._rangebreaks[l].max;
                                if (a < c) break;
                                if (!(a > u)) {
                                    o = a < (c + u) / 2 ? l : l + 1;
                                    break;
                                }
                                o = l + 1;
                            }
                            var h = t1._B[o] || 0;
                            return isFinite(h) ? R(e1, t1._m2, h) : 0;
                        }, N = function(e1) {
                            var r = t1._rangebreaks.length;
                            if (!r) return F(e1, t1._m, t1._b);
                            for(var n = 0, i = 0; i < r && !(e1 < t1._rangebreaks[i].pmin); i++)e1 > t1._rangebreaks[i].pmax && (n = i + 1);
                            return F(e1, t1._m2, t1._B[n]);
                        };
                    }
                    t1.c2l = "log" === t1.type ? E : h, t1.l2c = "log" === t1.type ? M : h, t1.l2p = B, t1.p2l = N, t1.c2p = "log" === t1.type ? function(t1, e1) {
                        return B(E(t1, e1));
                    } : B, t1.p2c = "log" === t1.type ? function(t1) {
                        return M(N(t1));
                    } : N, -1 !== [
                        "linear",
                        "-"
                    ].indexOf(t1.type) ? (t1.d2r = t1.r2d = t1.d2c = t1.r2c = t1.d2l = t1.r2l = l, t1.c2d = t1.c2r = t1.l2d = t1.l2r = h, t1.d2p = t1.r2p = function(e1) {
                        return t1.l2p(l(e1));
                    }, t1.p2d = t1.p2r = N, t1.cleanPos = h) : "log" === t1.type ? (t1.d2r = t1.d2l = function(t1, e1) {
                        return E(l(t1), e1);
                    }, t1.r2d = t1.r2c = function(t1) {
                        return M(l(t1));
                    }, t1.d2c = t1.r2l = l, t1.c2d = t1.l2r = h, t1.c2r = E, t1.l2d = M, t1.d2p = function(e1, r) {
                        return t1.l2p(t1.d2r(e1, r));
                    }, t1.p2d = function(t1) {
                        return M(N(t1));
                    }, t1.r2p = function(e1) {
                        return t1.l2p(l(e1));
                    }, t1.p2r = N, t1.cleanPos = h) : "date" === t1.type ? (t1.d2r = t1.r2d = a.identity, t1.d2c = t1.r2c = t1.d2l = t1.r2l = C, t1.c2d = t1.c2r = t1.l2d = t1.l2r = L, t1.d2p = t1.r2p = function(e1, r, n) {
                        return t1.l2p(C(e1, 0, n));
                    }, t1.p2d = t1.p2r = function(t1, e1, r) {
                        return L(N(t1), e1, r);
                    }, t1.cleanPos = function(e1) {
                        return a.cleanDate(e1, m, t1.calendar);
                    }) : "category" === t1.type ? (t1.d2c = t1.d2l = P, t1.r2d = t1.c2d = t1.l2d = I, t1.d2r = t1.d2l_noadd = O, t1.r2c = function(e1) {
                        var r = D(e1);
                        return void 0 !== r ? r : t1.fraction2r(.5);
                    }, t1.l2r = t1.c2r = h, t1.r2l = D, t1.d2p = function(e1) {
                        return t1.l2p(t1.r2c(e1));
                    }, t1.p2d = function(t1) {
                        return I(N(t1));
                    }, t1.r2p = t1.d2p, t1.p2r = N, t1.cleanPos = function(t1) {
                        return "string" == typeof t1 && "" !== t1 ? t1 : h(t1);
                    }) : "multicategory" === t1.type && (t1.r2d = t1.c2d = t1.l2d = I, t1.d2r = t1.d2l_noadd = O, t1.r2c = function(e1) {
                        var r = O(e1);
                        return void 0 !== r ? r : t1.fraction2r(.5);
                    }, t1.r2c_just_indices = z, t1.l2r = t1.c2r = h, t1.r2l = O, t1.d2p = function(e1) {
                        return t1.l2p(t1.r2c(e1));
                    }, t1.p2d = function(t1) {
                        return I(N(t1));
                    }, t1.r2p = t1.d2p, t1.p2r = N, t1.cleanPos = function(t1) {
                        return Array.isArray(t1) || "string" == typeof t1 && "" !== t1 ? t1 : h(t1);
                    }, t1.setupMultiCategory = function(n) {
                        var i, o, s = t1._traceIndices, l = t1._matchGroup;
                        if (l && 0 === t1._categories.length) {
                            for(var c in l)if (c !== r) {
                                var u = e1[w.id2name(c)];
                                s = s.concat(u._traceIndices);
                            }
                        }
                        var h = [
                            [
                                0,
                                {}
                            ],
                            [
                                0,
                                {}
                            ]
                        ], d = [];
                        for(i = 0; i < s.length; i++){
                            var m = n[s[i]];
                            if (p in m) {
                                var g = m[p], y = m._length || a.minRowLength(g);
                                if (f(g[0]) && f(g[1])) for(o = 0; o < y; o++){
                                    var v = g[0][o], x = g[1][o];
                                    S(v) && S(x) && (d.push([
                                        v,
                                        x
                                    ]), v in h[0][1] || (h[0][1][v] = h[0][0]++), x in h[1][1] || (h[1][1][x] = h[1][0]++));
                                }
                            }
                        }
                        for(d.sort(function(t1, e1) {
                            var r = h[0][1], n = r[t1[0]] - r[e1[0]];
                            if (n) return n;
                            var i = h[1][1];
                            return i[t1[1]] - i[e1[1]];
                        }), i = 0; i < d.length; i++)P(d[i]);
                    }), t1.fraction2r = function(e1) {
                        var r = t1.r2l(t1.range[0]), n = t1.r2l(t1.range[1]);
                        return t1.l2r(r + e1 * (n - r));
                    }, t1.r2fraction = function(e1) {
                        var r = t1.r2l(t1.range[0]), n = t1.r2l(t1.range[1]);
                        return (t1.r2l(e1) - r) / (n - r);
                    }, t1.limitRange = function(e1) {
                        var r = t1.minallowed, n = t1.maxallowed;
                        if (void 0 !== r || void 0 !== n) {
                            e1 || (e1 = "range");
                            var i = a.nestedProperty(t1, e1).get(), o = a.simpleMap(i, t1.r2l), s = o[1] < o[0];
                            s && o.reverse();
                            var l = a.simpleMap([
                                r,
                                n
                            ], t1.r2l);
                            if (void 0 !== r && o[0] < l[0] && (i[s ? 1 : 0] = r), void 0 !== n && o[1] > l[1] && (i[s ? 0 : 1] = n), i[0] === i[1]) {
                                var c = t1.l2r(r), u = t1.l2r(n);
                                if (void 0 !== r) {
                                    var h = c + 1;
                                    void 0 !== n && (h = Math.min(h, u)), i[s ? 1 : 0] = h;
                                }
                                if (void 0 !== n) {
                                    var f = u + 1;
                                    void 0 !== r && (f = Math.max(f, c)), i[s ? 0 : 1] = f;
                                }
                            }
                        }
                    }, t1.cleanRange = function(e1, r) {
                        t1._cleanRange(e1, r), t1.limitRange(e1);
                    }, t1._cleanRange = function(e1, r) {
                        r || (r = {}), e1 || (e1 = "range");
                        var n, i, o = a.nestedProperty(t1, e1).get();
                        if (i = (i = "date" === t1.type ? a.dfltRange(t1.calendar) : "y" === p ? T.DFLTRANGEY : "realaxis" === t1._name ? [
                            0,
                            1
                        ] : r.dfltRange || T.DFLTRANGEX).slice(), "tozero" !== t1.rangemode && "nonnegative" !== t1.rangemode || (i[0] = 0), o && 2 === o.length) {
                            var l = null === o[0], c = null === o[1];
                            for("date" !== t1.type || t1.autorange || (o[0] = a.cleanDate(o[0], m, t1.calendar), o[1] = a.cleanDate(o[1], m, t1.calendar)), n = 0; n < 2; n++)if ("date" === t1.type) {
                                if (!a.isDateTime(o[n], t1.calendar)) {
                                    t1[e1] = i;
                                    break;
                                }
                                if (t1.r2l(o[0]) === t1.r2l(o[1])) {
                                    var u = a.constrain(t1.r2l(o[0]), a.MIN_MS + 1e3, a.MAX_MS - 1e3);
                                    o[0] = t1.l2r(u - 1e3), o[1] = t1.l2r(u + 1e3);
                                    break;
                                }
                            } else {
                                if (!s(o[n])) {
                                    if (l || c || !s(o[1 - n])) {
                                        t1[e1] = i;
                                        break;
                                    }
                                    o[n] = o[1 - n] * (n ? 10 : .1);
                                }
                                if (o[n] < -d ? o[n] = -d : o[n] > d && (o[n] = d), o[0] === o[1]) {
                                    var h = Math.max(1, Math.abs(1e-6 * o[0]));
                                    o[0] -= h, o[1] += h;
                                }
                            }
                        } else a.nestedProperty(t1, e1).set(i);
                    }, t1.setScale = function(r) {
                        var n = e1._size;
                        if (t1.overlaying) {
                            var i = w.getFromId({
                                _fullLayout: e1
                            }, t1.overlaying);
                            t1.domain = i.domain;
                        }
                        var a = r && t1._r ? "_r" : "range", o = t1.calendar;
                        t1.cleanRange(a);
                        var s, l, c = t1.r2l(t1[a][0], o), u = t1.r2l(t1[a][1], o), h = "y" === p;
                        if (h ? (t1._offset = n.t + (1 - t1.domain[1]) * n.h, t1._length = n.h * (t1.domain[1] - t1.domain[0]), t1._m = t1._length / (c - u), t1._b = -t1._m * u) : (t1._offset = n.l + t1.domain[0] * n.w, t1._length = n.w * (t1.domain[1] - t1.domain[0]), t1._m = t1._length / (u - c), t1._b = -t1._m * c), t1._rangebreaks = [], t1._lBreaks = 0, t1._m2 = 0, t1._B = [], t1.rangebreaks && (t1._rangebreaks = t1.locateBreaks(Math.min(c, u), Math.max(c, u)), t1._rangebreaks.length)) {
                            for(s = 0; s < t1._rangebreaks.length; s++)l = t1._rangebreaks[s], t1._lBreaks += Math.abs(l.max - l.min);
                            var f = h;
                            c > u && (f = !f), f && t1._rangebreaks.reverse();
                            var d = f ? -1 : 1;
                            for(t1._m2 = d * t1._length / (Math.abs(u - c) - t1._lBreaks), t1._B.push(-t1._m2 * (h ? u : c)), s = 0; s < t1._rangebreaks.length; s++)l = t1._rangebreaks[s], t1._B.push(t1._B[t1._B.length - 1] - d * t1._m2 * (l.max - l.min));
                            for(s = 0; s < t1._rangebreaks.length; s++)(l = t1._rangebreaks[s]).pmin = B(l.min), l.pmax = B(l.max);
                        }
                        if (!isFinite(t1._m) || !isFinite(t1._b) || t1._length < 0) throw e1._replotting = !1, new Error("Something went wrong with axis scaling");
                    }, t1.maskBreaks = function(e1) {
                        var r, n, i, o, s, c = t1.rangebreaks || [];
                        c._cachedPatterns || (c._cachedPatterns = c.map(function(e1) {
                            return e1.enabled && e1.bounds ? a.simpleMap(e1.bounds, e1.pattern ? l : t1.d2c) : null;
                        })), c._cachedValues || (c._cachedValues = c.map(function(e1) {
                            return e1.enabled && e1.values ? a.simpleMap(e1.values, t1.d2c).sort(a.sorterAsc) : null;
                        }));
                        for(var u = 0; u < c.length; u++){
                            var h = c[u];
                            if (h.enabled) {
                                if (h.bounds) {
                                    var f = h.pattern;
                                    switch(n = (r = c._cachedPatterns[u])[0], i = r[1], f){
                                        case A:
                                            o = (s = new Date(e1)).getUTCDay(), n > i && (i += 7, o < n && (o += 7));
                                            break;
                                        case k:
                                            o = (s = new Date(e1)).getUTCHours() + (s.getUTCMinutes() / 60 + s.getUTCSeconds() / 3600 + s.getUTCMilliseconds() / 36e5), n > i && (i += 24, o < n && (o += 24));
                                            break;
                                        case "":
                                            o = e1;
                                    }
                                    if (o >= n && o < i) return m;
                                } else for(var p = c._cachedValues[u], d = 0; d < p.length; d++)if (i = (n = p[d]) + h.dvalue, e1 >= n && e1 < i) return m;
                            }
                        }
                        return e1;
                    }, t1.locateBreaks = function(e1, r) {
                        var n, i, o, s, c = [];
                        if (!t1.rangebreaks) return c;
                        var u = t1.rangebreaks.slice().sort(function(t1, e1) {
                            return t1.pattern === A && e1.pattern === k ? -1 : e1.pattern === A && t1.pattern === k ? 1 : 0;
                        }), h = function(t1, n) {
                            if ((t1 = a.constrain(t1, e1, r)) !== (n = a.constrain(n, e1, r))) {
                                for(var i = !0, o = 0; o < c.length; o++){
                                    var s = c[o];
                                    t1 < s.max && n >= s.min && (t1 < s.min && (s.min = t1), n > s.max && (s.max = n), i = !1);
                                }
                                i && c.push({
                                    min: t1,
                                    max: n
                                });
                            }
                        };
                        for(n = 0; n < u.length; n++){
                            var f = u[n];
                            if (f.enabled) {
                                if (f.bounds) {
                                    var p = e1, d = r;
                                    f.pattern && (p = Math.floor(p)), o = (i = a.simpleMap(f.bounds, f.pattern ? l : t1.r2l))[0], s = i[1];
                                    var m, g, w = new Date(p);
                                    switch(f.pattern){
                                        case A:
                                            g = y, m = (s - o + (s < o ? 7 : 0)) * v, p += o * v - (w.getUTCDay() * v + w.getUTCHours() * x + w.getUTCMinutes() * _ + w.getUTCSeconds() * b + w.getUTCMilliseconds());
                                            break;
                                        case k:
                                            g = v, m = (s - o + (s < o ? 24 : 0)) * x, p += o * x - (w.getUTCHours() * x + w.getUTCMinutes() * _ + w.getUTCSeconds() * b + w.getUTCMilliseconds());
                                            break;
                                        default:
                                            p = Math.min(i[0], i[1]), m = g = (d = Math.max(i[0], i[1])) - p;
                                    }
                                    for(var T = p; T < d; T += g)h(T, T + m);
                                } else for(var M = a.simpleMap(f.values, t1.d2c), S = 0; S < M.length; S++)h(o = M[S], s = o + f.dvalue);
                            }
                        }
                        return c.sort(function(t1, e1) {
                            return t1.min - e1.min;
                        }), c;
                    }, t1.makeCalcdata = function(e1, r, n) {
                        var i, o, s, l, c = t1.type, u = "date" === c && e1[r + "calendar"];
                        if (r in e1) {
                            if (i = e1[r], l = e1._length || a.minRowLength(i), a.isTypedArray(i) && ("linear" === c || "log" === c)) {
                                if (l === i.length) return i;
                                if (i.subarray) return i.subarray(0, l);
                            }
                            if ("multicategory" === c) return function(t1, e1) {
                                for(var r = new Array(e1), n = 0; n < e1; n++){
                                    var i = (t1[0] || [])[n], a = (t1[1] || [])[n];
                                    r[n] = z([
                                        i,
                                        a
                                    ]);
                                }
                                return r;
                            }(i, l);
                            for(o = new Array(l), s = 0; s < l; s++)o[s] = t1.d2c(i[s], 0, u, n);
                        } else {
                            var h = r + "0" in e1 ? t1.d2c(e1[r + "0"], 0, u) : 0, f = e1["d" + r] ? Number(e1["d" + r]) : 1;
                            for(i = e1[({
                                x: "y",
                                y: "x"
                            })[r]], l = e1._length || i.length, o = new Array(l), s = 0; s < l; s++)o[s] = h + s * f;
                        }
                        if (t1.rangebreaks) for(s = 0; s < l; s++)o[s] = t1.maskBreaks(o[s]);
                        return o;
                    }, t1.isValidRange = function(e1, r) {
                        return Array.isArray(e1) && 2 === e1.length && (r && null === e1[0] || s(t1.r2l(e1[0]))) && (r && null === e1[1] || s(t1.r2l(e1[1])));
                    }, t1.getAutorangeDflt = function(e1, r) {
                        var n = !t1.isValidRange(e1, "nullOk");
                        return n && r && r.reverseDflt ? n = "reversed" : e1 && (null === e1[0] && null === e1[1] ? n = !0 : null === e1[0] && null !== e1[1] ? n = "min" : null !== e1[0] && null === e1[1] && (n = "max")), n;
                    }, t1.isReversed = function() {
                        var e1 = t1.autorange;
                        return "reversed" === e1 || "min reversed" === e1 || "max reversed" === e1;
                    }, t1.isPtWithinRange = function(e1, r) {
                        var n = t1.c2l(e1[p], null, r), i = t1.r2l(t1.range[0]), a = t1.r2l(t1.range[1]);
                        return i < a ? i <= n && n <= a : a <= n && n <= i;
                    }, t1._emptyCategories = function() {
                        t1._categories = [], t1._categoriesMap = {};
                    }, t1.clearCalc = function() {
                        var r = t1._matchGroup;
                        if (r) {
                            var n = null, i = null;
                            for(var a in r){
                                var o = e1[w.id2name(a)];
                                if (o._categories) {
                                    n = o._categories, i = o._categoriesMap;
                                    break;
                                }
                            }
                            n && i ? (t1._categories = n, t1._categoriesMap = i) : t1._emptyCategories();
                        } else t1._emptyCategories();
                        if (t1._initialCategories) for(var s = 0; s < t1._initialCategories.length; s++)P(t1._initialCategories[s]);
                    }, t1.sortByInitialCategories = function() {
                        var n = [];
                        if (t1._emptyCategories(), t1._initialCategories) for(var i = 0; i < t1._initialCategories.length; i++)P(t1._initialCategories[i]);
                        n = n.concat(t1._traceIndices);
                        var a = t1._matchGroup;
                        for(var o in a)if (r !== o) {
                            var s = e1[w.id2name(o)];
                            s._categories = t1._categories, s._categoriesMap = t1._categoriesMap, n = n.concat(s._traceIndices);
                        }
                        return n;
                    };
                    var U = e1._d3locale;
                    "date" === t1.type && (t1._dateFormat = U ? U.timeFormat : i, t1._extraFormat = e1._extraFormat), t1._separators = e1.separators, t1._numFormat = U ? U.numberFormat : o, delete t1._minDtick, delete t1._forceTick0;
                };
            },
            87703: function(t1) {
                "use strict";
                t1.exports = function(t1) {
                    var e1 = [
                        "showexponent",
                        "showtickprefix",
                        "showticksuffix"
                    ].filter(function(e1) {
                        return void 0 !== t1[e1];
                    });
                    if (e1.every(function(r) {
                        return t1[r] === t1[e1[0]];
                    }) || 1 === e1.length) return t1[e1[0]];
                };
            },
            12036: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(78766).contrast, a = r(25829), o = r(87703), s = r(59008);
                function l(t1, e1) {
                    function r(r, i) {
                        return n.coerce(t1, e1, a.tickformatstops, r, i);
                    }
                    r("enabled") && (r("dtickrange"), r("value"));
                }
                t1.exports = function(t1, e1, r, c, u) {
                    u || (u = {});
                    var h = r("labelalias");
                    n.isPlainObject(h) || delete e1.labelalias;
                    var f = o(t1);
                    if (r("showticklabels")) {
                        u.noTicklabelshift || r("ticklabelshift"), u.noTicklabelstandoff || r("ticklabelstandoff");
                        var p = u.font || {}, d = e1.color, m = -1 !== (e1.ticklabelposition || "").indexOf("inside") ? i(u.bgColor) : d && d !== a.color.dflt ? d : p.color;
                        if (n.coerceFont(r, "tickfont", p, {
                            overrideDflt: {
                                color: m
                            }
                        }), u.noTicklabelstep || "multicategory" === c || "log" === c || r("ticklabelstep"), !u.noAng) {
                            var g = r("tickangle");
                            u.noAutotickangles || "auto" !== g || r("autotickangles");
                        }
                        if ("category" !== c) {
                            var y = r("tickformat");
                            s(t1, e1, {
                                name: "tickformatstops",
                                inclusionAttr: "enabled",
                                handleItemDefaults: l
                            }), e1.tickformatstops.length || delete e1.tickformatstops, u.noExp || y || "date" === c || (r("showexponent", f), r("exponentformat"), r("minexponent"), r("separatethousands"));
                        }
                    }
                };
            },
            87433: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(25829);
                t1.exports = function(t1, e1, r, a) {
                    var o = a.isMinor, s = o ? t1.minor || {} : t1, l = o ? e1.minor : e1, c = o ? i.minor : i, u = o ? "minor." : "", h = n.coerce2(s, l, c, "ticklen", o ? .6 * (e1.ticklen || 5) : void 0), f = n.coerce2(s, l, c, "tickwidth", o ? e1.tickwidth || 1 : void 0), p = n.coerce2(s, l, c, "tickcolor", (o ? e1.tickcolor : void 0) || l.color);
                    r(u + "ticks", !o && a.outerTicks || h || f || p ? "outside" : "") || (delete l.ticklen, delete l.tickwidth, delete l.tickcolor);
                };
            },
            22777: function(t1, e1, r) {
                "use strict";
                var n = r(68599), i = r(34809).isArrayOrTypedArray, a = r(87800).isTypedArraySpec, o = r(87800).decodeTypedArraySpec;
                t1.exports = function(t1, e1, r, s, l) {
                    l || (l = {});
                    var c = l.isMinor, u = c ? t1.minor || {} : t1, h = c ? e1.minor : e1, f = c ? "minor." : "";
                    function p(t1) {
                        var e1 = u[t1];
                        return a(e1) && (e1 = o(e1)), void 0 !== e1 ? e1 : (h._template || {})[t1];
                    }
                    var d = p("tick0"), m = p("dtick"), g = p("tickvals"), y = r(f + "tickmode", i(g) ? "array" : m ? "linear" : "auto");
                    if ("auto" === y || "sync" === y) r(f + "nticks");
                    else if ("linear" === y) {
                        var v = h.dtick = n.dtick(m, s);
                        h.tick0 = n.tick0(d, s, e1.calendar, v);
                    } else "multicategory" !== s && (void 0 === r(f + "tickvals") ? h.tickmode = "auto" : c || r("ticktext"));
                };
            },
            84982: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(33626), a = r(34809), o = r(62203), s = r(29714);
                t1.exports = function(t1, e1, r, l) {
                    var c = t1._fullLayout;
                    if (0 !== e1.length) {
                        var u, h, f, p;
                        l && (u = l());
                        var d = n.ease(r.easing);
                        return t1._transitionData._interruptCallbacks.push(function() {
                            return window.cancelAnimationFrame(p), p = null, function() {
                                for(var r = {}, n = 0; n < e1.length; n++){
                                    var a = e1[n], o = a.plotinfo.xaxis, s = a.plotinfo.yaxis;
                                    a.xr0 && (r[o._name + ".range"] = a.xr0.slice()), a.yr0 && (r[s._name + ".range"] = a.yr0.slice());
                                }
                                return i.call("relayout", t1, r).then(function() {
                                    for(var t1 = 0; t1 < e1.length; t1++)m(e1[t1].plotinfo);
                                });
                            }();
                        }), h = Date.now(), p = window.requestAnimationFrame(function n() {
                            f = Date.now();
                            for(var a = Math.min(1, (f - h) / r.duration), o = d(a), s = 0; s < e1.length; s++)g(e1[s], o);
                            f - h > r.duration ? (function() {
                                for(var r = {}, n = 0; n < e1.length; n++){
                                    var a = e1[n], o = a.plotinfo.xaxis, s = a.plotinfo.yaxis;
                                    a.xr1 && (r[o._name + ".range"] = a.xr1.slice()), a.yr1 && (r[s._name + ".range"] = a.yr1.slice());
                                }
                                u && u(), i.call("relayout", t1, r).then(function() {
                                    for(var t1 = 0; t1 < e1.length; t1++)m(e1[t1].plotinfo);
                                });
                            }(), p = window.cancelAnimationFrame(n)) : p = window.requestAnimationFrame(n);
                        }), Promise.resolve();
                    }
                    function m(t1) {
                        var e1 = t1.xaxis, r = t1.yaxis;
                        c._defs.select("#" + t1.clipId + "> rect").call(o.setTranslate, 0, 0).call(o.setScale, 1, 1), t1.plot.call(o.setTranslate, e1._offset, r._offset).call(o.setScale, 1, 1);
                        var n = t1.plot.selectAll(".scatterlayer .trace");
                        n.selectAll(".point").call(o.setPointGroupScale, 1, 1), n.selectAll(".textpoint").call(o.setTextPointsScale, 1, 1), n.call(o.hideOutsideRangePoints, t1);
                    }
                    function g(e1, r) {
                        var n = e1.plotinfo, i = n.xaxis, l = n.yaxis, c = i._length, u = l._length, h = !!e1.xr1, f = !!e1.yr1, p = [];
                        if (h) {
                            var d = a.simpleMap(e1.xr0, i.r2l), m = a.simpleMap(e1.xr1, i.r2l), g = d[1] - d[0], y = m[1] - m[0];
                            p[0] = (d[0] * (1 - r) + r * m[0] - d[0]) / (d[1] - d[0]) * c, p[2] = c * (1 - r + r * y / g), i.range[0] = i.l2r(d[0] * (1 - r) + r * m[0]), i.range[1] = i.l2r(d[1] * (1 - r) + r * m[1]);
                        } else p[0] = 0, p[2] = c;
                        if (f) {
                            var v = a.simpleMap(e1.yr0, l.r2l), x = a.simpleMap(e1.yr1, l.r2l), _ = v[1] - v[0], b = x[1] - x[0];
                            p[1] = (v[1] * (1 - r) + r * x[1] - v[1]) / (v[0] - v[1]) * u, p[3] = u * (1 - r + r * b / _), l.range[0] = i.l2r(v[0] * (1 - r) + r * x[0]), l.range[1] = l.l2r(v[1] * (1 - r) + r * x[1]);
                        } else p[1] = 0, p[3] = u;
                        s.drawOne(t1, i, {
                            skipTitle: !0
                        }), s.drawOne(t1, l, {
                            skipTitle: !0
                        }), s.redrawComponents(t1, [
                            i._id,
                            l._id
                        ]);
                        var w = h ? c / p[2] : 1, T = f ? u / p[3] : 1, k = h ? p[0] : 0, A = f ? p[1] : 0, M = h ? p[0] / p[2] * c : 0, S = f ? p[1] / p[3] * u : 0, E = i._offset - M, C = l._offset - S;
                        n.clipRect.call(o.setTranslate, k, A).call(o.setScale, 1 / w, 1 / T), n.plot.call(o.setTranslate, E, C).call(o.setScale, w, T), o.setPointGroupScale(n.zoomScalePts, 1 / w, 1 / T), o.setTextPointsScale(n.zoomScaleTxt, 1 / w, 1 / T);
                    }
                    s.redrawComponents(t1);
                };
            },
            4392: function(t1, e1, r) {
                "use strict";
                var n = r(33626).traceIs, i = r(9666);
                function a(t1) {
                    return ({
                        v: "x",
                        h: "y"
                    })[t1.orientation || "v"];
                }
                function o(t1, e1) {
                    var r = a(t1), i = n(t1, "box-violin"), o = n(t1._fullInput || {}, "candlestick");
                    return i && !o && e1 === r && void 0 === t1[r] && void 0 === t1[r + "0"];
                }
                t1.exports = function(t1, e1, r, s) {
                    r("autotypenumbers", s.autotypenumbersDflt), "-" === r("type", (s.splomStash || {}).type) && (function(t1, e1) {
                        if ("-" === t1.type) {
                            var r, s = t1._id, l = s.charAt(0);
                            -1 !== s.indexOf("scene") && (s = l);
                            var c = function(t1, e1, r) {
                                for(var n = 0; n < t1.length; n++){
                                    var i = t1[n];
                                    if ("splom" === i.type && i._length > 0 && (i["_" + r + "axes"] || {})[e1]) return i;
                                    if ((i[r + "axis"] || r) === e1) {
                                        if (o(i, r)) return i;
                                        if ((i[r] || []).length || i[r + "0"]) return i;
                                    }
                                }
                            }(e1, s, l);
                            if (c) {
                                if ("histogram" !== c.type || l !== ({
                                    v: "y",
                                    h: "x"
                                })[c.orientation || "v"]) {
                                    var u = l + "calendar", h = c[u], f = {
                                        noMultiCategory: !n(c, "cartesian") || n(c, "noMultiCategory")
                                    };
                                    if ("box" === c.type && c._hasPreCompStats && l === ({
                                        h: "x",
                                        v: "y"
                                    })[c.orientation || "v"] && (f.noMultiCategory = !0), f.autotypenumbers = t1.autotypenumbers, o(c, l)) {
                                        var p = a(c), d = [];
                                        for(r = 0; r < e1.length; r++){
                                            var m = e1[r];
                                            n(m, "box-violin") && (m[l + "axis"] || l) === s && (void 0 !== m[p] ? d.push(m[p][0]) : void 0 !== m.name ? d.push(m.name) : d.push("text"), m[u] !== h && (h = void 0));
                                        }
                                        t1.type = i(d, h, f);
                                    } else if ("splom" === c.type) {
                                        var g = c.dimensions[c._axesDim[s]];
                                        g.visible && (t1.type = i(g.values, h, f));
                                    } else t1.type = i(c[l] || [
                                        c[l + "0"]
                                    ], h, f);
                                } else t1.type = "linear";
                            }
                        }
                    }(e1, s.data), "-" === e1.type ? e1.type = "linear" : t1.type = e1.type);
                };
            },
            90251: function(t1, e1, r) {
                "use strict";
                var n = r(33626), i = r(34809);
                function a(t1, e1, r) {
                    var n, a, o, s = !1;
                    if ("data" === e1.type) n = t1._fullData[null !== e1.traces ? e1.traces[0] : 0];
                    else {
                        if ("layout" !== e1.type) return !1;
                        n = t1._fullLayout;
                    }
                    return a = i.nestedProperty(n, e1.prop).get(), (o = r[e1.type] = r[e1.type] || {}).hasOwnProperty(e1.prop) && o[e1.prop] !== a && (s = !0), o[e1.prop] = a, {
                        changed: s,
                        value: a
                    };
                }
                function o(t1, e1) {
                    var r = [], n = e1[0], a = {};
                    if ("string" == typeof n) a[n] = e1[1];
                    else {
                        if (!i.isPlainObject(n)) return r;
                        a = n;
                    }
                    return l(a, function(t1, e1, n) {
                        r.push({
                            type: "layout",
                            prop: t1,
                            value: n
                        });
                    }, "", 0), r;
                }
                function s(t1, e1) {
                    var r, n, a, o, s = [];
                    if (n = e1[0], a = e1[1], r = e1[2], o = {}, "string" == typeof n) o[n] = a;
                    else {
                        if (!i.isPlainObject(n)) return s;
                        o = n, void 0 === r && (r = a);
                    }
                    return void 0 === r && (r = null), l(o, function(e1, n, i) {
                        var a, o;
                        if (Array.isArray(i)) {
                            o = i.slice();
                            var l = Math.min(o.length, t1.data.length);
                            r && (l = Math.min(l, r.length)), a = [];
                            for(var c = 0; c < l; c++)a[c] = r ? r[c] : c;
                        } else o = i, a = r ? r.slice() : null;
                        if (null === a) Array.isArray(o) && (o = o[0]);
                        else if (Array.isArray(a)) {
                            if (!Array.isArray(o)) {
                                var u = o;
                                o = [];
                                for(var h = 0; h < a.length; h++)o[h] = u;
                            }
                            o.length = Math.min(a.length, o.length);
                        }
                        s.push({
                            type: "data",
                            prop: e1,
                            traces: a,
                            value: o
                        });
                    }, "", 0), s;
                }
                function l(t1, e1, r, n) {
                    Object.keys(t1).forEach(function(a) {
                        var o = t1[a];
                        if ("_" !== a[0]) {
                            var s = r + (n > 0 ? "." : "") + a;
                            i.isPlainObject(o) ? l(o, e1, s, n + 1) : e1(s, a, o);
                        }
                    });
                }
                e1.manageCommandObserver = function(t1, r, n, o) {
                    var s = {}, l = !0;
                    r && r._commandObserver && (s = r._commandObserver), s.cache || (s.cache = {}), s.lookupTable = {};
                    var c = e1.hasSimpleAPICommandBindings(t1, n, s.lookupTable);
                    if (r && r._commandObserver) {
                        if (c) return s;
                        if (r._commandObserver.remove) return r._commandObserver.remove(), r._commandObserver = null, s;
                    }
                    if (c) {
                        a(t1, c, s.cache), s.check = function() {
                            if (l) {
                                var e1 = a(t1, c, s.cache);
                                return e1.changed && o && void 0 !== s.lookupTable[e1.value] && (s.disable(), Promise.resolve(o({
                                    value: e1.value,
                                    type: c.type,
                                    prop: c.prop,
                                    traces: c.traces,
                                    index: s.lookupTable[e1.value]
                                })).then(s.enable, s.enable)), e1.changed;
                            }
                        };
                        for(var u = [
                            "plotly_relayout",
                            "plotly_redraw",
                            "plotly_restyle",
                            "plotly_update",
                            "plotly_animatingframe",
                            "plotly_afterplot"
                        ], h = 0; h < u.length; h++)t1._internalOn(u[h], s.check);
                        s.remove = function() {
                            for(var e1 = 0; e1 < u.length; e1++)t1._removeInternalListener(u[e1], s.check);
                        };
                    } else i.log("Unable to automatically bind plot updates to API command"), s.lookupTable = {}, s.remove = function() {};
                    return s.disable = function() {
                        l = !1;
                    }, s.enable = function() {
                        l = !0;
                    }, r && (r._commandObserver = s), s;
                }, e1.hasSimpleAPICommandBindings = function(t1, r, n) {
                    var i, a, o = r.length;
                    for(i = 0; i < o; i++){
                        var s, l = r[i], c = l.method, u = l.args;
                        if (Array.isArray(u) || (u = []), !c) return !1;
                        var h = e1.computeAPICommandBindings(t1, c, u);
                        if (1 !== h.length) return !1;
                        if (a) {
                            if ((s = h[0]).type !== a.type) return !1;
                            if (s.prop !== a.prop) return !1;
                            if (Array.isArray(a.traces)) {
                                if (!Array.isArray(s.traces)) return !1;
                                s.traces.sort();
                                for(var f = 0; f < a.traces.length; f++)if (a.traces[f] !== s.traces[f]) return !1;
                            } else if (s.prop !== a.prop) return !1;
                        } else a = h[0], Array.isArray(a.traces) && a.traces.sort();
                        var p = (s = h[0]).value;
                        if (Array.isArray(p)) {
                            if (1 !== p.length) return !1;
                            p = p[0];
                        }
                        n && (n[p] = i);
                    }
                    return a;
                }, e1.executeAPICommand = function(t1, e1, r) {
                    if ("skip" === e1) return Promise.resolve();
                    var a = n.apiMethodRegistry[e1], o = [
                        t1
                    ];
                    Array.isArray(r) || (r = []);
                    for(var s = 0; s < r.length; s++)o.push(r[s]);
                    return a.apply(null, o).catch(function(t1) {
                        return i.warn("API call to Plotly." + e1 + " rejected.", t1), Promise.reject(t1);
                    });
                }, e1.computeAPICommandBindings = function(t1, e1, r) {
                    var n;
                    switch(Array.isArray(r) || (r = []), e1){
                        case "restyle":
                            n = s(t1, r);
                            break;
                        case "relayout":
                            n = o(0, r);
                            break;
                        case "update":
                            n = s(t1, [
                                r[0],
                                r[2]
                            ]).concat(o(0, [
                                r[1]
                            ]));
                            break;
                        case "animate":
                            n = function(t1, e1) {
                                return Array.isArray(e1[0]) && 1 === e1[0].length && -1 !== [
                                    "string",
                                    "number"
                                ].indexOf(typeof e1[0][0]) ? [
                                    {
                                        type: "layout",
                                        prop: "_currentFrame",
                                        value: e1[0][0].toString()
                                    }
                                ] : [];
                            }(0, r);
                            break;
                        default:
                            n = [];
                    }
                    return n;
                };
            },
            13792: function(t1, e1, r) {
                "use strict";
                var n = r(93049).extendFlat;
                e1.u = function(t1, e1) {
                    e1 = e1 || {};
                    var r = {
                        valType: "info_array",
                        editType: (t1 = t1 || {}).editType,
                        items: [
                            {
                                valType: "number",
                                min: 0,
                                max: 1,
                                editType: t1.editType
                            },
                            {
                                valType: "number",
                                min: 0,
                                max: 1,
                                editType: t1.editType
                            }
                        ],
                        dflt: [
                            0,
                            1
                        ]
                    }, i = (t1.name && t1.name, t1.trace, e1.description && e1.description, {
                        x: n({}, r, {}),
                        y: n({}, r, {}),
                        editType: t1.editType
                    });
                    return t1.noGridCell || (i.row = {
                        valType: "integer",
                        min: 0,
                        dflt: 0,
                        editType: t1.editType
                    }, i.column = {
                        valType: "integer",
                        min: 0,
                        dflt: 0,
                        editType: t1.editType
                    }), i;
                }, e1.N = function(t1, e1, r, n) {
                    var i = n && n.x || [
                        0,
                        1
                    ], a = n && n.y || [
                        0,
                        1
                    ], o = e1.grid;
                    if (o) {
                        var s = r("domain.column");
                        void 0 !== s && (s < o.columns ? i = o._domains.x[s] : delete t1.domain.column);
                        var l = r("domain.row");
                        void 0 !== l && (l < o.rows ? a = o._domains.y[l] : delete t1.domain.row);
                    }
                    var c = r("domain.x", i), u = r("domain.y", a);
                    c[0] < c[1] || (t1.domain.x = i.slice()), u[0] < u[1] || (t1.domain.y = a.slice());
                };
            },
            80337: function(t1) {
                "use strict";
                t1.exports = function(t1) {
                    var e1 = t1.variantValues, r = t1.editType, n = t1.colorEditType;
                    void 0 === n && (n = r);
                    var i = {
                        editType: r,
                        valType: "integer",
                        min: 1,
                        max: 1e3,
                        extras: [
                            "normal",
                            "bold"
                        ],
                        dflt: "normal"
                    };
                    t1.noNumericWeightValues && (i.valType = "enumerated", i.values = i.extras, i.extras = void 0, i.min = void 0, i.max = void 0);
                    var a = {
                        family: {
                            valType: "string",
                            noBlank: !0,
                            strict: !0,
                            editType: r
                        },
                        size: {
                            valType: "number",
                            min: 1,
                            editType: r
                        },
                        color: {
                            valType: "color",
                            editType: n
                        },
                        weight: i,
                        style: {
                            editType: r,
                            valType: "enumerated",
                            values: [
                                "normal",
                                "italic"
                            ],
                            dflt: "normal"
                        },
                        variant: t1.noFontVariant ? void 0 : {
                            editType: r,
                            valType: "enumerated",
                            values: e1 || [
                                "normal",
                                "small-caps",
                                "all-small-caps",
                                "all-petite-caps",
                                "petite-caps",
                                "unicase"
                            ],
                            dflt: "normal"
                        },
                        textcase: t1.noFontTextcase ? void 0 : {
                            editType: r,
                            valType: "enumerated",
                            values: [
                                "normal",
                                "word caps",
                                "upper",
                                "lower"
                            ],
                            dflt: "normal"
                        },
                        lineposition: t1.noFontLineposition ? void 0 : {
                            editType: r,
                            valType: "flaglist",
                            flags: [
                                "under",
                                "over",
                                "through"
                            ],
                            extras: [
                                "none"
                            ],
                            dflt: "none"
                        },
                        shadow: t1.noFontShadow ? void 0 : {
                            editType: r,
                            valType: "string",
                            dflt: t1.autoShadowDflt ? "auto" : "none"
                        },
                        editType: r
                    };
                    return t1.autoSize && (a.size.dflt = "auto"), t1.autoColor && (a.color.dflt = "auto"), t1.arrayOk && (a.family.arrayOk = !0, a.weight.arrayOk = !0, a.style.arrayOk = !0, t1.noFontVariant || (a.variant.arrayOk = !0), t1.noFontTextcase || (a.textcase.arrayOk = !0), t1.noFontLineposition || (a.lineposition.arrayOk = !0), t1.noFontShadow || (a.shadow.arrayOk = !0), a.size.arrayOk = !0, a.color.arrayOk = !0), a;
                };
            },
            58935: function(t1) {
                "use strict";
                t1.exports = {
                    _isLinkedToArray: "frames_entry",
                    group: {
                        valType: "string"
                    },
                    name: {
                        valType: "string"
                    },
                    traces: {
                        valType: "any"
                    },
                    baseframe: {
                        valType: "string"
                    },
                    data: {
                        valType: "any"
                    },
                    layout: {
                        valType: "any"
                    }
                };
            },
            74285: function(t1, e1) {
                "use strict";
                e1.projNames = {
                    airy: "airy",
                    aitoff: "aitoff",
                    "albers usa": "albersUsa",
                    albers: "albers",
                    august: "august",
                    "azimuthal equal area": "azimuthalEqualArea",
                    "azimuthal equidistant": "azimuthalEquidistant",
                    baker: "baker",
                    bertin1953: "bertin1953",
                    boggs: "boggs",
                    bonne: "bonne",
                    bottomley: "bottomley",
                    bromley: "bromley",
                    collignon: "collignon",
                    "conic conformal": "conicConformal",
                    "conic equal area": "conicEqualArea",
                    "conic equidistant": "conicEquidistant",
                    craig: "craig",
                    craster: "craster",
                    "cylindrical equal area": "cylindricalEqualArea",
                    "cylindrical stereographic": "cylindricalStereographic",
                    eckert1: "eckert1",
                    eckert2: "eckert2",
                    eckert3: "eckert3",
                    eckert4: "eckert4",
                    eckert5: "eckert5",
                    eckert6: "eckert6",
                    eisenlohr: "eisenlohr",
                    "equal earth": "equalEarth",
                    equirectangular: "equirectangular",
                    fahey: "fahey",
                    "foucaut sinusoidal": "foucautSinusoidal",
                    foucaut: "foucaut",
                    ginzburg4: "ginzburg4",
                    ginzburg5: "ginzburg5",
                    ginzburg6: "ginzburg6",
                    ginzburg8: "ginzburg8",
                    ginzburg9: "ginzburg9",
                    gnomonic: "gnomonic",
                    "gringorten quincuncial": "gringortenQuincuncial",
                    gringorten: "gringorten",
                    guyou: "guyou",
                    hammer: "hammer",
                    hill: "hill",
                    homolosine: "homolosine",
                    hufnagel: "hufnagel",
                    hyperelliptical: "hyperelliptical",
                    kavrayskiy7: "kavrayskiy7",
                    lagrange: "lagrange",
                    larrivee: "larrivee",
                    laskowski: "laskowski",
                    loximuthal: "loximuthal",
                    mercator: "mercator",
                    miller: "miller",
                    mollweide: "mollweide",
                    "mt flat polar parabolic": "mtFlatPolarParabolic",
                    "mt flat polar quartic": "mtFlatPolarQuartic",
                    "mt flat polar sinusoidal": "mtFlatPolarSinusoidal",
                    "natural earth": "naturalEarth",
                    "natural earth1": "naturalEarth1",
                    "natural earth2": "naturalEarth2",
                    "nell hammer": "nellHammer",
                    nicolosi: "nicolosi",
                    orthographic: "orthographic",
                    patterson: "patterson",
                    "peirce quincuncial": "peirceQuincuncial",
                    polyconic: "polyconic",
                    "rectangular polyconic": "rectangularPolyconic",
                    robinson: "robinson",
                    satellite: "satellite",
                    "sinu mollweide": "sinuMollweide",
                    sinusoidal: "sinusoidal",
                    stereographic: "stereographic",
                    times: "times",
                    "transverse mercator": "transverseMercator",
                    "van der grinten": "vanDerGrinten",
                    "van der grinten2": "vanDerGrinten2",
                    "van der grinten3": "vanDerGrinten3",
                    "van der grinten4": "vanDerGrinten4",
                    wagner4: "wagner4",
                    wagner6: "wagner6",
                    wiechel: "wiechel",
                    "winkel tripel": "winkel3",
                    winkel3: "winkel3"
                }, e1.axesNames = [
                    "lonaxis",
                    "lataxis"
                ], e1.lonaxisSpan = {
                    orthographic: 180,
                    "azimuthal equal area": 360,
                    "azimuthal equidistant": 360,
                    "conic conformal": 180,
                    gnomonic: 160,
                    stereographic: 180,
                    "transverse mercator": 180,
                    "*": 360
                }, e1.lataxisSpan = {
                    "conic conformal": 150,
                    stereographic: 179.5,
                    "*": 180
                }, e1.scopeDefaults = {
                    world: {
                        lonaxisRange: [
                            -180,
                            180
                        ],
                        lataxisRange: [
                            -90,
                            90
                        ],
                        projType: "equirectangular",
                        projRotate: [
                            0,
                            0,
                            0
                        ]
                    },
                    usa: {
                        lonaxisRange: [
                            -180,
                            -50
                        ],
                        lataxisRange: [
                            15,
                            80
                        ],
                        projType: "albers usa"
                    },
                    europe: {
                        lonaxisRange: [
                            -30,
                            60
                        ],
                        lataxisRange: [
                            30,
                            85
                        ],
                        projType: "conic conformal",
                        projRotate: [
                            15,
                            0,
                            0
                        ],
                        projParallels: [
                            0,
                            60
                        ]
                    },
                    asia: {
                        lonaxisRange: [
                            22,
                            160
                        ],
                        lataxisRange: [
                            -15,
                            55
                        ],
                        projType: "mercator",
                        projRotate: [
                            0,
                            0,
                            0
                        ]
                    },
                    africa: {
                        lonaxisRange: [
                            -30,
                            60
                        ],
                        lataxisRange: [
                            -40,
                            40
                        ],
                        projType: "mercator",
                        projRotate: [
                            0,
                            0,
                            0
                        ]
                    },
                    "north america": {
                        lonaxisRange: [
                            -180,
                            -45
                        ],
                        lataxisRange: [
                            5,
                            85
                        ],
                        projType: "conic conformal",
                        projRotate: [
                            -100,
                            0,
                            0
                        ],
                        projParallels: [
                            29.5,
                            45.5
                        ]
                    },
                    "south america": {
                        lonaxisRange: [
                            -100,
                            -30
                        ],
                        lataxisRange: [
                            -60,
                            15
                        ],
                        projType: "mercator",
                        projRotate: [
                            0,
                            0,
                            0
                        ]
                    }
                }, e1.clipPad = .001, e1.precision = .1, e1.landColor = "#F0DC82", e1.waterColor = "#3399FF", e1.locationmodeToLayer = {
                    "ISO-3": "countries",
                    "USA-states": "subunits",
                    "country names": "countries"
                }, e1.sphereSVG = {
                    type: "Sphere"
                }, e1.fillLayers = {
                    ocean: 1,
                    land: 1,
                    lakes: 1
                }, e1.lineLayers = {
                    subunits: 1,
                    countries: 1,
                    coastlines: 1,
                    rivers: 1,
                    frame: 1
                }, e1.layers = [
                    "bg",
                    "ocean",
                    "land",
                    "lakes",
                    "subunits",
                    "countries",
                    "coastlines",
                    "rivers",
                    "lataxis",
                    "lonaxis",
                    "frame",
                    "backplot",
                    "frontplot"
                ], e1.layersForChoropleth = [
                    "bg",
                    "ocean",
                    "land",
                    "subunits",
                    "countries",
                    "coastlines",
                    "lataxis",
                    "lonaxis",
                    "frame",
                    "backplot",
                    "rivers",
                    "lakes",
                    "frontplot"
                ], e1.layerNameToAdjective = {
                    ocean: "ocean",
                    land: "land",
                    lakes: "lake",
                    subunits: "subunit",
                    countries: "country",
                    coastlines: "coastline",
                    rivers: "river",
                    frame: "frame"
                };
            },
            6493: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(70884), a = i.geoPath, o = i.geoDistance, s = r(75987), l = r(33626), c = r(34809), u = c.strTranslate, h = r(78766), f = r(62203), p = r(32141), d = r(44122), m = r(29714), g = r(32919).getAutoRange, y = r(14751), v = r(44844).prepSelect, x = r(44844).clearOutline, _ = r(44844).selectOnClick, b = r(14309), w = r(74285), T = r(3994), k = r(11577), A = r(48640).N4;
                function M(t1) {
                    this.id = t1.id, this.graphDiv = t1.graphDiv, this.container = t1.container, this.topojsonURL = t1.topojsonURL, this.isStatic = t1.staticPlot, this.topojsonName = null, this.topojson = null, this.projection = null, this.scope = null, this.viewInitial = null, this.fitScale = null, this.bounds = null, this.midPt = null, this.hasChoropleth = !1, this.traceHash = {}, this.layers = {}, this.basePaths = {}, this.dataPaths = {}, this.dataPoints = {}, this.clipDef = null, this.clipRect = null, this.bgRect = null, this.makeFramework();
                }
                var S = M.prototype;
                function E(t1, e1) {
                    var r = w.clipPad, n = t1[0] + r, i = t1[1] - r, a = e1[0] + r, o = e1[1] - r;
                    n > 0 && i < 0 && (i += 360);
                    var s = (i - n) / 4;
                    return {
                        type: "Polygon",
                        coordinates: [
                            [
                                [
                                    n,
                                    a
                                ],
                                [
                                    n,
                                    o
                                ],
                                [
                                    n + s,
                                    o
                                ],
                                [
                                    n + 2 * s,
                                    o
                                ],
                                [
                                    n + 3 * s,
                                    o
                                ],
                                [
                                    i,
                                    o
                                ],
                                [
                                    i,
                                    a
                                ],
                                [
                                    i - s,
                                    a
                                ],
                                [
                                    i - 2 * s,
                                    a
                                ],
                                [
                                    i - 3 * s,
                                    a
                                ],
                                [
                                    n,
                                    a
                                ]
                            ]
                        ]
                    };
                }
                t1.exports = function(t1) {
                    return new M(t1);
                }, S.plot = function(t1, e1, r, n) {
                    var i = this;
                    if (n) return i.update(t1, e1, !0);
                    i._geoCalcData = t1, i._fullLayout = e1;
                    var a = e1[this.id], o = [], s = !1;
                    for(var l in w.layerNameToAdjective)if ("frame" !== l && a["show" + l]) {
                        s = !0;
                        break;
                    }
                    for(var c = !1, u = 0; u < t1.length; u++){
                        var h = t1[0][0].trace;
                        h._geo = i, h.locationmode && (s = !0);
                        var f = h.marker;
                        if (f) {
                            var p = f.angle, d = f.angleref;
                            (p || "north" === d || "previous" === d) && (c = !0);
                        }
                    }
                    if (this._hasMarkerAngles = c, s) {
                        var m = k.getTopojsonName(a);
                        null !== i.topojson && m === i.topojsonName || (i.topojsonName = m, void 0 === PlotlyGeoAssets.topojson[i.topojsonName] && o.push(i.fetchTopojson()));
                    }
                    o = o.concat(T.fetchTraceGeoData(t1)), r.push(new Promise(function(r, n) {
                        Promise.all(o).then(function() {
                            i.topojson = PlotlyGeoAssets.topojson[i.topojsonName], i.update(t1, e1), r();
                        }).catch(n);
                    }));
                }, S.fetchTopojson = function() {
                    var t1 = this, e1 = k.getTopojsonPath(t1.topojsonURL, t1.topojsonName);
                    return new Promise(function(r, i) {
                        n.json(e1, function(n, a) {
                            if (n) return 404 === n.status ? i(new Error([
                                "plotly.js could not find topojson file at",
                                e1 + ".",
                                "Make sure the *topojsonURL* plot config option",
                                "is set properly."
                            ].join(" "))) : i(new Error([
                                "unexpected error while fetching topojson file at",
                                e1
                            ].join(" ")));
                            PlotlyGeoAssets.topojson[t1.topojsonName] = a, r();
                        });
                    });
                }, S.update = function(t1, e1, r) {
                    var n = e1[this.id];
                    this.hasChoropleth = !1;
                    for(var i = 0; i < t1.length; i++){
                        var a = t1[i], o = a[0].trace;
                        "choropleth" === o.type && (this.hasChoropleth = !0), !0 === o.visible && o._length > 0 && o._module.calcGeoJSON(a, e1);
                    }
                    if (!r) {
                        if (this.updateProjection(t1, e1)) return;
                        this.viewInitial && this.scope === n.scope || this.saveViewInitial(n);
                    }
                    this.scope = n.scope, this.updateBaseLayers(e1, n), this.updateDims(e1, n), this.updateFx(e1, n), d.generalUpdatePerTraceModule(this.graphDiv, this, t1, n);
                    var s = this.layers.frontplot.select(".scatterlayer");
                    this.dataPoints.point = s.selectAll(".point"), this.dataPoints.text = s.selectAll("text"), this.dataPaths.line = s.selectAll(".js-line");
                    var l = this.layers.backplot.select(".choroplethlayer");
                    this.dataPaths.choropleth = l.selectAll("path"), this._render();
                }, S.updateProjection = function(t1, e1) {
                    var r = this.graphDiv, n = e1[this.id], l = e1._size, u = n.domain, h = n.projection, f = n.lonaxis, p = n.lataxis, d = f._ax, m = p._ax, y = this.projection = function(t1) {
                        var e1 = t1.projection, r = e1.type, n = w.projNames[r];
                        n = "geo" + c.titleCase(n);
                        for(var l = (i[n] || s[n])(), u = t1._isSatellite ? 180 * Math.acos(1 / e1.distance) / Math.PI : t1._isClipped ? w.lonaxisSpan[r] / 2 : null, h = [
                            "center",
                            "rotate",
                            "parallels",
                            "clipExtent"
                        ], f = function(t1) {
                            return t1 ? l : [];
                        }, p = 0; p < h.length; p++){
                            var d = h[p];
                            "function" != typeof l[d] && (l[d] = f);
                        }
                        return l.isLonLatOverEdges = function(t1) {
                            if (null === l(t1)) return !0;
                            if (u) {
                                var e1 = l.rotate();
                                return o(t1, [
                                    -e1[0],
                                    -e1[1]
                                ]) > u * Math.PI / 180;
                            }
                            return !1;
                        }, l.getPath = function() {
                            return a().projection(l);
                        }, l.getBounds = function(t1) {
                            return l.getPath().bounds(t1);
                        }, l.precision(w.precision), t1._isSatellite && l.tilt(e1.tilt).distance(e1.distance), u && l.clipAngle(u - w.clipPad), l;
                    }(n), v = [
                        [
                            l.l + l.w * u.x[0],
                            l.t + l.h * (1 - u.y[1])
                        ],
                        [
                            l.l + l.w * u.x[1],
                            l.t + l.h * (1 - u.y[0])
                        ]
                    ], x = n.center || {}, _ = h.rotation || {}, b = f.range || [], T = p.range || [];
                    if (n.fitbounds) {
                        d._length = v[1][0] - v[0][0], m._length = v[1][1] - v[0][1], d.range = g(r, d), m.range = g(r, m);
                        var k = (d.range[0] + d.range[1]) / 2, A = (m.range[0] + m.range[1]) / 2;
                        if (n._isScoped) x = {
                            lon: k,
                            lat: A
                        };
                        else if (n._isClipped) {
                            x = {
                                lon: k,
                                lat: A
                            }, _ = {
                                lon: k,
                                lat: A,
                                roll: _.roll
                            };
                            var M = h.type, S = w.lonaxisSpan[M] / 2 || 180, C = w.lataxisSpan[M] / 2 || 90;
                            b = [
                                k - S,
                                k + S
                            ], T = [
                                A - C,
                                A + C
                            ];
                        } else x = {
                            lon: k,
                            lat: A
                        }, _ = {
                            lon: k,
                            lat: _.lat,
                            roll: _.roll
                        };
                    }
                    y.center([
                        x.lon - _.lon,
                        x.lat - _.lat
                    ]).rotate([
                        -_.lon,
                        -_.lat,
                        _.roll
                    ]).parallels(h.parallels);
                    var L = E(b, T);
                    y.fitExtent(v, L);
                    var I = this.bounds = y.getBounds(L), P = this.fitScale = y.scale(), z = y.translate();
                    if (n.fitbounds) {
                        var O = y.getBounds(E(d.range, m.range)), D = Math.min((I[1][0] - I[0][0]) / (O[1][0] - O[0][0]), (I[1][1] - I[0][1]) / (O[1][1] - O[0][1]));
                        isFinite(D) ? y.scale(D * P) : c.warn("Something went wrong during" + this.id + "fitbounds computations.");
                    } else y.scale(h.scale * P);
                    var R = this.midPt = [
                        (I[0][0] + I[1][0]) / 2,
                        (I[0][1] + I[1][1]) / 2
                    ];
                    if (y.translate([
                        z[0] + (R[0] - z[0]),
                        z[1] + (R[1] - z[1])
                    ]).clipExtent(I), n._isAlbersUsa) {
                        var F = y([
                            x.lon,
                            x.lat
                        ]), B = y.translate();
                        y.translate([
                            B[0] - (F[0] - B[0]),
                            B[1] - (F[1] - B[1])
                        ]);
                    }
                }, S.updateBaseLayers = function(t1, e1) {
                    var r = this, i = r.topojson, a = r.layers, o = r.basePaths;
                    function s(t1) {
                        return "lonaxis" === t1 || "lataxis" === t1;
                    }
                    function l(t1) {
                        return Boolean(w.lineLayers[t1]);
                    }
                    function c(t1) {
                        return Boolean(w.fillLayers[t1]);
                    }
                    var u = (this.hasChoropleth ? w.layersForChoropleth : w.layers).filter(function(t1) {
                        return l(t1) || c(t1) ? e1["show" + t1] : !s(t1) || e1[t1].showgrid;
                    }), p = r.framework.selectAll(".layer").data(u, String);
                    p.exit().each(function(t1) {
                        delete a[t1], delete o[t1], n.select(this).remove();
                    }), p.enter().append("g").attr("class", function(t1) {
                        return "layer " + t1;
                    }).each(function(t1) {
                        var e1 = a[t1] = n.select(this);
                        "bg" === t1 ? r.bgRect = e1.append("rect").style("pointer-events", "all") : s(t1) ? o[t1] = e1.append("path").style("fill", "none") : "backplot" === t1 ? e1.append("g").classed("choroplethlayer", !0) : "frontplot" === t1 ? e1.append("g").classed("scatterlayer", !0) : l(t1) ? o[t1] = e1.append("path").style("fill", "none").style("stroke-miterlimit", 2) : c(t1) && (o[t1] = e1.append("path").style("stroke", "none"));
                    }), p.order(), p.each(function(r) {
                        var n = o[r], a = w.layerNameToAdjective[r];
                        "frame" === r ? n.datum(w.sphereSVG) : l(r) || c(r) ? n.datum(A(i, i.objects[r])) : s(r) && n.datum(function(t1, e1, r) {
                            var n, i, a, o = e1[t1], s = w.scopeDefaults[e1.scope];
                            "lonaxis" === t1 ? (n = s.lonaxisRange, i = s.lataxisRange, a = function(t1, e1) {
                                return [
                                    t1,
                                    e1
                                ];
                            }) : "lataxis" === t1 && (n = s.lataxisRange, i = s.lonaxisRange, a = function(t1, e1) {
                                return [
                                    e1,
                                    t1
                                ];
                            });
                            var l = {
                                type: "linear",
                                range: [
                                    n[0],
                                    n[1] - 1e-6
                                ],
                                tick0: o.tick0,
                                dtick: o.dtick
                            };
                            m.setConvert(l, r);
                            var c = m.calcTicks(l);
                            e1.isScoped || "lonaxis" !== t1 || c.pop();
                            for(var u = c.length, h = new Array(u), f = 0; f < u; f++)for(var p = c[f].x, d = h[f] = [], g = i[0]; g < i[1] + 2.5; g += 2.5)d.push(a(p, g));
                            return {
                                type: "MultiLineString",
                                coordinates: h
                            };
                        }(r, e1, t1)).call(h.stroke, e1[r].gridcolor).call(f.dashLine, e1[r].griddash, e1[r].gridwidth), l(r) ? n.call(h.stroke, e1[a + "color"]).call(f.dashLine, "", e1[a + "width"]) : c(r) && n.call(h.fill, e1[a + "color"]);
                    });
                }, S.updateDims = function(t1, e1) {
                    var r = this.bounds, n = (e1.framewidth || 0) / 2, i = r[0][0] - n, a = r[0][1] - n, o = r[1][0] - i + n, s = r[1][1] - a + n;
                    f.setRect(this.clipRect, i, a, o, s), this.bgRect.call(f.setRect, i, a, o, s).call(h.fill, e1.bgcolor), this.xaxis._offset = i, this.xaxis._length = o, this.yaxis._offset = a, this.yaxis._length = s;
                }, S.updateFx = function(t1, e1) {
                    var r = this, i = r.graphDiv, a = r.bgRect, o = t1.dragmode, s = t1.clickmode;
                    if (!r.isStatic) {
                        var u = {
                            element: r.bgRect.node(),
                            gd: i,
                            plotinfo: {
                                id: r.id,
                                xaxis: r.xaxis,
                                yaxis: r.yaxis,
                                fillRangeItems: function(t1, e1) {
                                    e1.isRect ? (t1.range = {})[r.id] = [
                                        h([
                                            e1.xmin,
                                            e1.ymin
                                        ]),
                                        h([
                                            e1.xmax,
                                            e1.ymax
                                        ])
                                    ] : (t1.lassoPoints = {})[r.id] = e1.map(h);
                                }
                            },
                            xaxes: [
                                r.xaxis
                            ],
                            yaxes: [
                                r.yaxis
                            ],
                            subplot: r.id,
                            clickFn: function(t1) {
                                2 === t1 && x(i);
                            }
                        };
                        "pan" === o ? (a.node().onmousedown = null, a.call(b(r, e1)), a.on("dblclick.zoom", function() {
                            var t1 = r.viewInitial, e1 = {};
                            for(var n in t1)e1[r.id + "." + n] = t1[n];
                            l.call("_guiRelayout", i, e1), i.emit("plotly_doubleclick", null);
                        }), i._context._scrollZoom.geo || a.on("wheel.zoom", null)) : "select" !== o && "lasso" !== o || (a.on(".zoom", null), u.prepFn = function(t1, e1, r) {
                            v(t1, e1, r, u, o);
                        }, y.init(u)), a.on("mousemove", function() {
                            var t1 = r.projection.invert(c.getPositionFromD3Event());
                            if (!t1) return y.unhover(i, n.event);
                            r.xaxis.p2c = function() {
                                return t1[0];
                            }, r.yaxis.p2c = function() {
                                return t1[1];
                            }, p.hover(i, n.event, r.id);
                        }), a.on("mouseout", function() {
                            i._dragging || y.unhover(i, n.event);
                        }), a.on("click", function() {
                            "select" !== o && "lasso" !== o && (s.indexOf("select") > -1 && _(n.event, i, [
                                r.xaxis
                            ], [
                                r.yaxis
                            ], r.id, u), s.indexOf("event") > -1 && p.click(i, n.event));
                        });
                    }
                    function h(t1) {
                        return r.projection.invert([
                            t1[0] + r.xaxis._offset,
                            t1[1] + r.yaxis._offset
                        ]);
                    }
                }, S.makeFramework = function() {
                    var t1 = this, e1 = t1.graphDiv, r = e1._fullLayout, i = "clip" + r._uid + t1.id;
                    t1.clipDef = r._clips.append("clipPath").attr("id", i), t1.clipRect = t1.clipDef.append("rect"), t1.framework = n.select(t1.container).append("g").attr("class", "geo " + t1.id).call(f.setClipUrl, i, e1), t1.project = function(e1) {
                        var r = t1.projection(e1);
                        return r ? [
                            r[0] - t1.xaxis._offset,
                            r[1] - t1.yaxis._offset
                        ] : [
                            null,
                            null
                        ];
                    }, t1.xaxis = {
                        _id: "x",
                        c2p: function(e1) {
                            return t1.project(e1)[0];
                        }
                    }, t1.yaxis = {
                        _id: "y",
                        c2p: function(e1) {
                            return t1.project(e1)[1];
                        }
                    }, t1.mockAxis = {
                        type: "linear",
                        showexponent: "all",
                        exponentformat: "B"
                    }, m.setConvert(t1.mockAxis, r);
                }, S.saveViewInitial = function(t1) {
                    var e1, r = t1.center || {}, n = t1.projection, i = n.rotation || {};
                    this.viewInitial = {
                        fitbounds: t1.fitbounds,
                        "projection.scale": n.scale
                    }, e1 = t1._isScoped ? {
                        "center.lon": r.lon,
                        "center.lat": r.lat
                    } : t1._isClipped ? {
                        "projection.rotation.lon": i.lon,
                        "projection.rotation.lat": i.lat
                    } : {
                        "center.lon": r.lon,
                        "center.lat": r.lat,
                        "projection.rotation.lon": i.lon
                    }, c.extendFlat(this.viewInitial, e1);
                }, S.render = function(t1) {
                    this._hasMarkerAngles && t1 ? this.plot(this._geoCalcData, this._fullLayout, [], !0) : this._render();
                }, S._render = function() {
                    var t1, e1 = this.projection, r = e1.getPath();
                    function n(t1) {
                        var r = e1(t1.lonlat);
                        return r ? u(r[0], r[1]) : null;
                    }
                    function i(t1) {
                        return e1.isLonLatOverEdges(t1.lonlat) ? "none" : null;
                    }
                    for(t1 in this.basePaths)this.basePaths[t1].attr("d", r);
                    for(t1 in this.dataPaths)this.dataPaths[t1].attr("d", function(t1) {
                        return r(t1.geojson);
                    });
                    for(t1 in this.dataPoints)this.dataPoints[t1].attr("display", i).attr("transform", n);
                };
            },
            47544: function(t1, e1, r) {
                "use strict";
                var n = r(4173).fX, i = r(34809).counterRegex, a = r(6493), o = "geo", s = i(o), l = {};
                l[o] = {
                    valType: "subplotid",
                    dflt: o,
                    editType: "calc"
                }, t1.exports = {
                    attr: o,
                    name: o,
                    idRoot: o,
                    idRegex: s,
                    attrRegex: s,
                    attributes: l,
                    layoutAttributes: r(42194),
                    supplyLayoutDefaults: r(31653),
                    plot: function(t1) {
                        for(var e1 = t1._fullLayout, r = t1.calcdata, i = e1._subplots[o], s = 0; s < i.length; s++){
                            var l = i[s], c = n(r, o, l), u = e1[l]._subplot;
                            u || (u = a({
                                id: l,
                                graphDiv: t1,
                                container: e1._geolayer.node(),
                                topojsonURL: t1._context.topojsonURL,
                                staticPlot: t1._context.staticPlot
                            }), e1[l]._subplot = u), u.plot(c, e1, t1._promises);
                        }
                    },
                    updateFx: function(t1) {
                        for(var e1 = t1._fullLayout, r = e1._subplots[o], n = 0; n < r.length; n++){
                            var i = e1[r[n]];
                            i._subplot.updateFx(e1, i);
                        }
                    },
                    clean: function(t1, e1, r, n) {
                        for(var i = n._subplots[o] || [], a = 0; a < i.length; a++){
                            var s = i[a], l = n[s]._subplot;
                            !e1[s] && l && (l.framework.remove(), l.clipDef.remove());
                        }
                    }
                };
            },
            42194: function(t1, e1, r) {
                "use strict";
                var n = r(10229), i = r(13792).u, a = r(94850).T, o = r(74285), s = r(13582).overrideAll, l = r(62994), c = {
                    range: {
                        valType: "info_array",
                        items: [
                            {
                                valType: "number"
                            },
                            {
                                valType: "number"
                            }
                        ]
                    },
                    showgrid: {
                        valType: "boolean",
                        dflt: !1
                    },
                    tick0: {
                        valType: "number",
                        dflt: 0
                    },
                    dtick: {
                        valType: "number"
                    },
                    gridcolor: {
                        valType: "color",
                        dflt: n.lightLine
                    },
                    gridwidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1
                    },
                    griddash: a
                };
                (t1.exports = s({
                    domain: i({
                        name: "geo"
                    }, {}),
                    fitbounds: {
                        valType: "enumerated",
                        values: [
                            !1,
                            "locations",
                            "geojson"
                        ],
                        dflt: !1,
                        editType: "plot"
                    },
                    resolution: {
                        valType: "enumerated",
                        values: [
                            110,
                            50
                        ],
                        dflt: 110,
                        coerceNumber: !0
                    },
                    scope: {
                        valType: "enumerated",
                        values: l(o.scopeDefaults),
                        dflt: "world"
                    },
                    projection: {
                        type: {
                            valType: "enumerated",
                            values: l(o.projNames)
                        },
                        rotation: {
                            lon: {
                                valType: "number"
                            },
                            lat: {
                                valType: "number"
                            },
                            roll: {
                                valType: "number"
                            }
                        },
                        tilt: {
                            valType: "number",
                            dflt: 0
                        },
                        distance: {
                            valType: "number",
                            min: 1.001,
                            dflt: 2
                        },
                        parallels: {
                            valType: "info_array",
                            items: [
                                {
                                    valType: "number"
                                },
                                {
                                    valType: "number"
                                }
                            ]
                        },
                        scale: {
                            valType: "number",
                            min: 0,
                            dflt: 1
                        }
                    },
                    center: {
                        lon: {
                            valType: "number"
                        },
                        lat: {
                            valType: "number"
                        }
                    },
                    visible: {
                        valType: "boolean",
                        dflt: !0
                    },
                    showcoastlines: {
                        valType: "boolean"
                    },
                    coastlinecolor: {
                        valType: "color",
                        dflt: n.defaultLine
                    },
                    coastlinewidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1
                    },
                    showland: {
                        valType: "boolean",
                        dflt: !1
                    },
                    landcolor: {
                        valType: "color",
                        dflt: o.landColor
                    },
                    showocean: {
                        valType: "boolean",
                        dflt: !1
                    },
                    oceancolor: {
                        valType: "color",
                        dflt: o.waterColor
                    },
                    showlakes: {
                        valType: "boolean",
                        dflt: !1
                    },
                    lakecolor: {
                        valType: "color",
                        dflt: o.waterColor
                    },
                    showrivers: {
                        valType: "boolean",
                        dflt: !1
                    },
                    rivercolor: {
                        valType: "color",
                        dflt: o.waterColor
                    },
                    riverwidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1
                    },
                    showcountries: {
                        valType: "boolean"
                    },
                    countrycolor: {
                        valType: "color",
                        dflt: n.defaultLine
                    },
                    countrywidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1
                    },
                    showsubunits: {
                        valType: "boolean"
                    },
                    subunitcolor: {
                        valType: "color",
                        dflt: n.defaultLine
                    },
                    subunitwidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1
                    },
                    showframe: {
                        valType: "boolean"
                    },
                    framecolor: {
                        valType: "color",
                        dflt: n.defaultLine
                    },
                    framewidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1
                    },
                    bgcolor: {
                        valType: "color",
                        dflt: n.background
                    },
                    lonaxis: c,
                    lataxis: c
                }, "plot", "from-root")).uirevision = {
                    valType: "any",
                    editType: "none"
                };
            },
            31653: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(4448), a = r(4173).KO, o = r(74285), s = r(42194), l = o.axesNames;
                function c(t1, e1, r, i) {
                    var s = a(i.fullData, "geo", i.id).map(function(t1) {
                        return t1._expandedIndex;
                    }), c = r("resolution"), u = r("scope"), h = o.scopeDefaults[u], f = r("projection.type", h.projType), p = e1._isAlbersUsa = "albers usa" === f;
                    p && (u = e1.scope = "usa");
                    var d = e1._isScoped = "world" !== u, m = e1._isSatellite = "satellite" === f, g = e1._isConic = -1 !== f.indexOf("conic") || "albers" === f, y = e1._isClipped = !!o.lonaxisSpan[f];
                    if (!1 === t1.visible) {
                        var v = n.extendDeep({}, e1._template);
                        v.showcoastlines = !1, v.showcountries = !1, v.showframe = !1, v.showlakes = !1, v.showland = !1, v.showocean = !1, v.showrivers = !1, v.showsubunits = !1, v.lonaxis && (v.lonaxis.showgrid = !1), v.lataxis && (v.lataxis.showgrid = !1), e1._template = v;
                    }
                    for(var x = r("visible"), _ = 0; _ < l.length; _++){
                        var b, w = l[_], T = [
                            30,
                            10
                        ][_];
                        if (d) b = h[w + "Range"];
                        else {
                            var k = o[w + "Span"], A = (k[f] || k["*"]) / 2, M = r("projection.rotation." + w.substr(0, 3), h.projRotate[_]);
                            b = [
                                M - A,
                                M + A
                            ];
                        }
                        var S = r(w + ".range", b);
                        r(w + ".tick0"), r(w + ".dtick", T), r(w + ".showgrid", !!x && void 0) && (r(w + ".gridcolor"), r(w + ".gridwidth"), r(w + ".griddash")), e1[w]._ax = {
                            type: "linear",
                            _id: w.slice(0, 3),
                            _traceIndices: s,
                            setScale: n.identity,
                            c2l: n.identity,
                            r2l: n.identity,
                            autorange: !0,
                            range: S.slice(),
                            _m: 1,
                            _input: {}
                        };
                    }
                    var E = e1.lonaxis.range, C = e1.lataxis.range, L = E[0], I = E[1];
                    L > 0 && I < 0 && (I += 360);
                    var P, z, O, D = (L + I) / 2;
                    if (!p) {
                        var R = d ? h.projRotate : [
                            D,
                            0,
                            0
                        ];
                        P = r("projection.rotation.lon", R[0]), r("projection.rotation.lat", R[1]), r("projection.rotation.roll", R[2]), r("showcoastlines", !d && x) && (r("coastlinecolor"), r("coastlinewidth")), r("showocean", !!x && void 0) && r("oceancolor");
                    }
                    p ? (z = -96.6, O = 38.7) : (z = d ? D : P, O = (C[0] + C[1]) / 2), r("center.lon", z), r("center.lat", O), m && (r("projection.tilt"), r("projection.distance")), g && r("projection.parallels", h.projParallels || [
                        0,
                        60
                    ]), r("projection.scale"), r("showland", !!x && void 0) && r("landcolor"), r("showlakes", !!x && void 0) && r("lakecolor"), r("showrivers", !!x && void 0) && (r("rivercolor"), r("riverwidth")), r("showcountries", d && "usa" !== u && x) && (r("countrycolor"), r("countrywidth")), ("usa" === u || "north america" === u && 50 === c) && (r("showsubunits", x), r("subunitcolor"), r("subunitwidth")), d || r("showframe", x) && (r("framecolor"), r("framewidth")), r("bgcolor"), r("fitbounds") && (delete e1.projection.scale, d ? (delete e1.center.lon, delete e1.center.lat) : y ? (delete e1.center.lon, delete e1.center.lat, delete e1.projection.rotation.lon, delete e1.projection.rotation.lat, delete e1.lonaxis.range, delete e1.lataxis.range) : (delete e1.center.lon, delete e1.center.lat, delete e1.projection.rotation.lon));
                }
                t1.exports = function(t1, e1, r) {
                    i(t1, e1, r, {
                        type: "geo",
                        attributes: s,
                        handleDefaults: c,
                        fullData: r,
                        partition: "y"
                    });
                };
            },
            14309: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(34809), a = r(33626), o = Math.PI / 180, s = 180 / Math.PI, l = {
                    cursor: "pointer"
                }, c = {
                    cursor: "auto"
                };
                function u(t1, e1) {
                    return n.behavior.zoom().translate(e1.translate()).scale(e1.scale());
                }
                function h(t1, e1, r) {
                    var n = t1.id, o = t1.graphDiv, s = o.layout, l = s[n], c = o._fullLayout, u = c[n], h = {}, f = {};
                    function p(t1, e1) {
                        h[n + "." + t1] = i.nestedProperty(l, t1).get(), a.call("_storeDirectGUIEdit", s, c._preGUI, h);
                        var r = i.nestedProperty(u, t1);
                        r.get() !== e1 && (r.set(e1), i.nestedProperty(l, t1).set(e1), f[n + "." + t1] = e1);
                    }
                    r(p), p("projection.scale", e1.scale() / t1.fitScale), p("fitbounds", !1), o.emit("plotly_relayout", f);
                }
                function f(t1, e1) {
                    var r = u(0, e1);
                    function i(r) {
                        var n = e1.invert(t1.midPt);
                        r("center.lon", n[0]), r("center.lat", n[1]);
                    }
                    return r.on("zoomstart", function() {
                        n.select(this).style(l);
                    }).on("zoom", function() {
                        e1.scale(n.event.scale).translate(n.event.translate), t1.render(!0);
                        var r = e1.invert(t1.midPt);
                        t1.graphDiv.emit("plotly_relayouting", {
                            "geo.projection.scale": e1.scale() / t1.fitScale,
                            "geo.center.lon": r[0],
                            "geo.center.lat": r[1]
                        });
                    }).on("zoomend", function() {
                        n.select(this).style(c), h(t1, e1, i);
                    }), r;
                }
                function p(t1, e1) {
                    var r, i, a, o, s, f, p, d, m, g = u(0, e1);
                    function y(t1) {
                        return e1.invert(t1);
                    }
                    function v(r) {
                        var n = e1.rotate(), i = e1.invert(t1.midPt);
                        r("projection.rotation.lon", -n[0]), r("center.lon", i[0]), r("center.lat", i[1]);
                    }
                    return g.on("zoomstart", function() {
                        n.select(this).style(l), r = n.mouse(this), i = e1.rotate(), a = e1.translate(), o = i, s = y(r);
                    }).on("zoom", function() {
                        if (f = n.mouse(this), function(t1) {
                            var r = y(t1);
                            if (!r) return !0;
                            var n = e1(r);
                            return Math.abs(n[0] - t1[0]) > 2 || Math.abs(n[1] - t1[1]) > 2;
                        }(r)) return g.scale(e1.scale()), void g.translate(e1.translate());
                        e1.scale(n.event.scale), e1.translate([
                            a[0],
                            n.event.translate[1]
                        ]), s ? y(f) && (d = y(f), p = [
                            o[0] + (d[0] - s[0]),
                            i[1],
                            i[2]
                        ], e1.rotate(p), o = p) : s = y(r = f), m = !0, t1.render(!0);
                        var l = e1.rotate(), c = e1.invert(t1.midPt);
                        t1.graphDiv.emit("plotly_relayouting", {
                            "geo.projection.scale": e1.scale() / t1.fitScale,
                            "geo.center.lon": c[0],
                            "geo.center.lat": c[1],
                            "geo.projection.rotation.lon": -l[0]
                        });
                    }).on("zoomend", function() {
                        n.select(this).style(c), m && h(t1, e1, v);
                    }), g;
                }
                function d(t1, e1) {
                    var r, i = {
                        r: e1.rotate(),
                        k: e1.scale()
                    }, a = u(0, e1), f = function(t1) {
                        for(var e1 = 0, r = arguments.length, i = []; ++e1 < r;)i.push(arguments[e1]);
                        var a = n.dispatch.apply(null, i);
                        return a.of = function(e1, r) {
                            return function(i) {
                                var o;
                                try {
                                    o = i.sourceEvent = n.event, i.target = t1, n.event = i, a[i.type].apply(e1, r);
                                } finally{
                                    n.event = o;
                                }
                            };
                        }, a;
                    }(a, "zoomstart", "zoom", "zoomend"), p = 0, d = a.on;
                    function y(t1) {
                        var r = e1.rotate();
                        t1("projection.rotation.lon", -r[0]), t1("projection.rotation.lat", -r[1]);
                    }
                    return a.on("zoomstart", function() {
                        n.select(this).style(l);
                        var t1, c, u, h, y, _, b, w, T, k, A, M = n.mouse(this), S = e1.rotate(), E = S, C = e1.translate(), L = (c = .5 * (t1 = S)[0] * o, u = .5 * t1[1] * o, h = .5 * t1[2] * o, y = Math.sin(c), _ = Math.cos(c), b = Math.sin(u), w = Math.cos(u), T = Math.sin(h), [
                            _ * w * (k = Math.cos(h)) + y * b * T,
                            y * w * k - _ * b * T,
                            _ * b * k + y * w * T,
                            _ * w * T - y * b * k
                        ]);
                        r = m(e1, M), d.call(a, "zoom", function() {
                            var t1, a, o, l, c, u, h, p, d, y, _ = n.mouse(this);
                            if (e1.scale(i.k = n.event.scale), r) {
                                if (m(e1, _)) {
                                    e1.rotate(S).translate(C);
                                    var b = m(e1, _), w = function(t1, e1) {
                                        if (t1 && e1) {
                                            var r = function(t1, e1) {
                                                return [
                                                    t1[1] * e1[2] - t1[2] * e1[1],
                                                    t1[2] * e1[0] - t1[0] * e1[2],
                                                    t1[0] * e1[1] - t1[1] * e1[0]
                                                ];
                                            }(t1, e1), n = Math.sqrt(x(r, r)), i = .5 * Math.acos(Math.max(-1, Math.min(1, x(t1, e1)))), a = Math.sin(i) / n;
                                            return n && [
                                                Math.cos(i),
                                                r[2] * a,
                                                -r[1] * a,
                                                r[0] * a
                                            ];
                                        }
                                    }(r, b), T = function(t1) {
                                        return [
                                            Math.atan2(2 * (t1[0] * t1[1] + t1[2] * t1[3]), 1 - 2 * (t1[1] * t1[1] + t1[2] * t1[2])) * s,
                                            Math.asin(Math.max(-1, Math.min(1, 2 * (t1[0] * t1[2] - t1[3] * t1[1])))) * s,
                                            Math.atan2(2 * (t1[0] * t1[3] + t1[1] * t1[2]), 1 - 2 * (t1[2] * t1[2] + t1[3] * t1[3])) * s
                                        ];
                                    }((o = (t1 = L)[0], l = t1[1], c = t1[2], u = t1[3], [
                                        o * (h = (a = w)[0]) - l * (p = a[1]) - c * (d = a[2]) - u * (y = a[3]),
                                        o * p + l * h + c * y - u * d,
                                        o * d - l * y + c * h + u * p,
                                        o * y + l * d - c * p + u * h
                                    ])), k = i.r = function(t1, e1, r) {
                                        var n = v(e1, 2, t1[0]);
                                        n = v(n, 1, t1[1]), n = v(n, 0, t1[2] - r[2]);
                                        var i, a, o = e1[0], l = e1[1], c = e1[2], u = n[0], h = n[1], f = n[2], p = Math.atan2(l, o) * s, d = Math.sqrt(o * o + l * l);
                                        Math.abs(h) > d ? (a = (h > 0 ? 90 : -90) - p, i = 0) : (a = Math.asin(h / d) * s - p, i = Math.sqrt(d * d - h * h));
                                        var m = 180 - a - 2 * p, y = (Math.atan2(f, u) - Math.atan2(c, i)) * s, x = (Math.atan2(f, u) - Math.atan2(c, -i)) * s;
                                        return g(r[0], r[1], a, y) <= g(r[0], r[1], m, x) ? [
                                            a,
                                            y,
                                            r[2]
                                        ] : [
                                            m,
                                            x,
                                            r[2]
                                        ];
                                    }(T, r, E);
                                    isFinite(k[0]) && isFinite(k[1]) && isFinite(k[2]) || (k = E), e1.rotate(k), E = k;
                                }
                            } else r = m(e1, M = _);
                            f.of(this, arguments)({
                                type: "zoom"
                            });
                        }), A = f.of(this, arguments), p++ || A({
                            type: "zoomstart"
                        });
                    }).on("zoomend", function() {
                        var r;
                        n.select(this).style(c), d.call(a, "zoom", null), r = f.of(this, arguments), --p || r({
                            type: "zoomend"
                        }), h(t1, e1, y);
                    }).on("zoom.redraw", function() {
                        t1.render(!0);
                        var r = e1.rotate();
                        t1.graphDiv.emit("plotly_relayouting", {
                            "geo.projection.scale": e1.scale() / t1.fitScale,
                            "geo.projection.rotation.lon": -r[0],
                            "geo.projection.rotation.lat": -r[1]
                        });
                    }), n.rebind(a, f, "on");
                }
                function m(t1, e1) {
                    var r = t1.invert(e1);
                    return r && isFinite(r[0]) && isFinite(r[1]) && function(t1) {
                        var e1 = t1[0] * o, r = t1[1] * o, n = Math.cos(r);
                        return [
                            n * Math.cos(e1),
                            n * Math.sin(e1),
                            Math.sin(r)
                        ];
                    }(r);
                }
                function g(t1, e1, r, n) {
                    var i = y(r - t1), a = y(n - e1);
                    return Math.sqrt(i * i + a * a);
                }
                function y(t1) {
                    return (t1 % 360 + 540) % 360 - 180;
                }
                function v(t1, e1, r) {
                    var n = r * o, i = t1.slice(), a = 0 === e1 ? 1 : 0, s = 2 === e1 ? 1 : 2, l = Math.cos(n), c = Math.sin(n);
                    return i[a] = t1[a] * l - t1[s] * c, i[s] = t1[s] * l + t1[a] * c, i;
                }
                function x(t1, e1) {
                    for(var r = 0, n = 0, i = t1.length; n < i; ++n)r += t1[n] * e1[n];
                    return r;
                }
                t1.exports = function(t1, e1) {
                    var r = t1.projection;
                    return (e1._isScoped ? f : e1._isClipped ? d : p)(t1, r);
                };
            },
            4173: function(t1, e1, r) {
                "use strict";
                var n = r(33626), i = r(54826).SUBPLOT_PATTERN;
                e1.fX = function(t1, e1, r) {
                    var i = n.subplotsRegistry[e1];
                    if (!i) return [];
                    for(var a = i.attr, o = [], s = 0; s < t1.length; s++){
                        var l = t1[s];
                        l[0].trace[a] === r && o.push(l);
                    }
                    return o;
                }, e1.eV = function(t1, e1, r) {
                    var i, a = [], o = [];
                    if (!(i = "string" == typeof e1 ? n.getModule(e1).plot : "function" == typeof e1 ? e1 : e1.plot)) return [
                        a,
                        t1
                    ];
                    for(var s = r, l = 0; l < t1.length; l++){
                        var c = t1[l], u = c[0].trace, h = void 0 !== u.zorder;
                        !0 === u.visible && 0 !== u._length && (!u._module || u._module.plot !== i || h && u.zorder !== s ? o.push(c) : a.push(c));
                    }
                    return [
                        a,
                        o
                    ];
                }, e1.KO = function(t1, e1, r) {
                    if (!n.subplotsRegistry[e1]) return [];
                    var a, o, s, l = n.subplotsRegistry[e1].attr, c = [];
                    if ("gl2d" === e1) {
                        var u = r.match(i);
                        o = "x" + u[1], s = "y" + u[2];
                    }
                    for(var h = 0; h < t1.length; h++)a = t1[h], "gl2d" === e1 && n.traceIs(a, "gl2d") ? a[l[0]] === o && a[l[1]] === s && c.push(a) : a[l] === r && c.push(a);
                    return c;
                };
            },
            77055: function(t1, e1, r) {
                "use strict";
                var n = r(99978), i = r(20573), a = r(44039), o = r(54826), s = r(74043);
                function l(t1, e1) {
                    this.element = t1, this.plot = e1, this.mouseListener = null, this.wheelListener = null, this.lastInputTime = Date.now(), this.lastPos = [
                        0,
                        0
                    ], this.boxEnabled = !1, this.boxInited = !1, this.boxStart = [
                        0,
                        0
                    ], this.boxEnd = [
                        0,
                        0
                    ], this.dragStart = [
                        0,
                        0
                    ];
                }
                t1.exports = function(t1) {
                    var e1 = t1.mouseContainer, r = t1.glplot, c = new l(e1, r);
                    function u() {
                        t1.xaxis.autorange = !1, t1.yaxis.autorange = !1;
                    }
                    function h(e1, n, i) {
                        var a, s, l = t1.calcDataBox(), h = r.viewBox, f = c.lastPos[0], p = c.lastPos[1], d = o.MINDRAG * r.pixelRatio, m = o.MINZOOM * r.pixelRatio;
                        function g(e1, r, n) {
                            var i = Math.min(r, n), a = Math.max(r, n);
                            i !== a ? (l[e1] = i, l[e1 + 2] = a, c.dataBox = l, t1.setRanges(l)) : (t1.selectBox.selectBox = [
                                0,
                                0,
                                1,
                                1
                            ], t1.glplot.setDirty());
                        }
                        switch(n *= r.pixelRatio, i *= r.pixelRatio, i = h[3] - h[1] - i, t1.fullLayout.dragmode){
                            case "zoom":
                                if (e1) {
                                    var y = n / (h[2] - h[0]) * (l[2] - l[0]) + l[0], v = i / (h[3] - h[1]) * (l[3] - l[1]) + l[1];
                                    c.boxInited || (c.boxStart[0] = y, c.boxStart[1] = v, c.dragStart[0] = n, c.dragStart[1] = i), c.boxEnd[0] = y, c.boxEnd[1] = v, c.boxInited = !0, c.boxEnabled || c.boxStart[0] === c.boxEnd[0] && c.boxStart[1] === c.boxEnd[1] || (c.boxEnabled = !0);
                                    var x = Math.abs(c.dragStart[0] - n) < m, _ = Math.abs(c.dragStart[1] - i) < m;
                                    if (!function() {
                                        for(var e1 = t1.graphDiv._fullLayout._axisConstraintGroups, r = t1.xaxis._id, n = t1.yaxis._id, i = 0; i < e1.length; i++)if (-1 !== e1[i][r]) {
                                            if (-1 !== e1[i][n]) return !0;
                                            break;
                                        }
                                        return !1;
                                    }() || x && _) x && (c.boxEnd[0] = c.boxStart[0]), _ && (c.boxEnd[1] = c.boxStart[1]);
                                    else {
                                        a = c.boxEnd[0] - c.boxStart[0], s = c.boxEnd[1] - c.boxStart[1];
                                        var b = (l[3] - l[1]) / (l[2] - l[0]);
                                        Math.abs(a * b) > Math.abs(s) ? (c.boxEnd[1] = c.boxStart[1] + Math.abs(a) * b * (s >= 0 ? 1 : -1), c.boxEnd[1] < l[1] ? (c.boxEnd[1] = l[1], c.boxEnd[0] = c.boxStart[0] + (l[1] - c.boxStart[1]) / Math.abs(b)) : c.boxEnd[1] > l[3] && (c.boxEnd[1] = l[3], c.boxEnd[0] = c.boxStart[0] + (l[3] - c.boxStart[1]) / Math.abs(b))) : (c.boxEnd[0] = c.boxStart[0] + Math.abs(s) / b * (a >= 0 ? 1 : -1), c.boxEnd[0] < l[0] ? (c.boxEnd[0] = l[0], c.boxEnd[1] = c.boxStart[1] + (l[0] - c.boxStart[0]) * Math.abs(b)) : c.boxEnd[0] > l[2] && (c.boxEnd[0] = l[2], c.boxEnd[1] = c.boxStart[1] + (l[2] - c.boxStart[0]) * Math.abs(b)));
                                    }
                                } else c.boxEnabled ? (a = c.boxStart[0] !== c.boxEnd[0], s = c.boxStart[1] !== c.boxEnd[1], a || s ? (a && (g(0, c.boxStart[0], c.boxEnd[0]), t1.xaxis.autorange = !1), s && (g(1, c.boxStart[1], c.boxEnd[1]), t1.yaxis.autorange = !1), t1.relayoutCallback()) : t1.glplot.setDirty(), c.boxEnabled = !1, c.boxInited = !1) : c.boxInited && (c.boxInited = !1);
                                break;
                            case "pan":
                                c.boxEnabled = !1, c.boxInited = !1, e1 ? (c.panning || (c.dragStart[0] = n, c.dragStart[1] = i), Math.abs(c.dragStart[0] - n) < d && (n = c.dragStart[0]), Math.abs(c.dragStart[1] - i) < d && (i = c.dragStart[1]), a = (f - n) * (l[2] - l[0]) / (r.viewBox[2] - r.viewBox[0]), s = (p - i) * (l[3] - l[1]) / (r.viewBox[3] - r.viewBox[1]), l[0] += a, l[2] += a, l[1] += s, l[3] += s, t1.setRanges(l), c.panning = !0, c.lastInputTime = Date.now(), u(), t1.cameraChanged(), t1.handleAnnotations()) : c.panning && (c.panning = !1, t1.relayoutCallback());
                        }
                        c.lastPos[0] = n, c.lastPos[1] = i;
                    }
                    return c.mouseListener = n(e1, h), e1.addEventListener("touchstart", function(t1) {
                        var r = a(t1.changedTouches[0], e1);
                        h(0, r[0], r[1]), h(1, r[0], r[1]), t1.preventDefault();
                    }, !!s && {
                        passive: !1
                    }), e1.addEventListener("touchmove", function(t1) {
                        t1.preventDefault();
                        var r = a(t1.changedTouches[0], e1);
                        h(1, r[0], r[1]), t1.preventDefault();
                    }, !!s && {
                        passive: !1
                    }), e1.addEventListener("touchend", function(t1) {
                        h(0, c.lastPos[0], c.lastPos[1]), t1.preventDefault();
                    }, !!s && {
                        passive: !1
                    }), c.wheelListener = i(e1, function(e1, n) {
                        if (!t1.scrollZoom) return !1;
                        var i = t1.calcDataBox(), a = r.viewBox, o = c.lastPos[0], s = c.lastPos[1], l = Math.exp(5 * n / (a[3] - a[1])), h = o / (a[2] - a[0]) * (i[2] - i[0]) + i[0], f = s / (a[3] - a[1]) * (i[3] - i[1]) + i[1];
                        return i[0] = (i[0] - h) * l + h, i[2] = (i[2] - h) * l + h, i[1] = (i[1] - f) * l + f, i[3] = (i[3] - f) * l + f, t1.setRanges(i), c.lastInputTime = Date.now(), u(), t1.cameraChanged(), t1.handleAnnotations(), t1.relayoutCallback(), !0;
                    }, !0), c;
                };
            },
            10749: function(t1, e1, r) {
                "use strict";
                var n = r(29714), i = r(55010);
                function a(t1) {
                    this.scene = t1, this.gl = t1.gl, this.pixelRatio = t1.pixelRatio, this.screenBox = [
                        0,
                        0,
                        1,
                        1
                    ], this.viewBox = [
                        0,
                        0,
                        1,
                        1
                    ], this.dataBox = [
                        -1,
                        -1,
                        1,
                        1
                    ], this.borderLineEnable = [
                        !1,
                        !1,
                        !1,
                        !1
                    ], this.borderLineWidth = [
                        1,
                        1,
                        1,
                        1
                    ], this.borderLineColor = [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ]
                    ], this.ticks = [
                        [],
                        []
                    ], this.tickEnable = [
                        !0,
                        !0,
                        !1,
                        !1
                    ], this.tickPad = [
                        15,
                        15,
                        15,
                        15
                    ], this.tickAngle = [
                        0,
                        0,
                        0,
                        0
                    ], this.tickColor = [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ]
                    ], this.tickMarkLength = [
                        0,
                        0,
                        0,
                        0
                    ], this.tickMarkWidth = [
                        0,
                        0,
                        0,
                        0
                    ], this.tickMarkColor = [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ]
                    ], this.labels = [
                        "x",
                        "y"
                    ], this.labelEnable = [
                        !0,
                        !0,
                        !1,
                        !1
                    ], this.labelAngle = [
                        0,
                        Math.PI / 2,
                        0,
                        3 * Math.PI / 2
                    ], this.labelPad = [
                        15,
                        15,
                        15,
                        15
                    ], this.labelSize = [
                        12,
                        12
                    ], this.labelFont = [
                        "sans-serif",
                        "sans-serif"
                    ], this.labelColor = [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ]
                    ], this.title = "", this.titleEnable = !0, this.titleCenter = [
                        0,
                        0,
                        0,
                        0
                    ], this.titleAngle = 0, this.titleColor = [
                        0,
                        0,
                        0,
                        1
                    ], this.titleFont = "sans-serif", this.titleSize = 18, this.gridLineEnable = [
                        !0,
                        !0
                    ], this.gridLineColor = [
                        [
                            0,
                            0,
                            0,
                            .5
                        ],
                        [
                            0,
                            0,
                            0,
                            .5
                        ]
                    ], this.gridLineWidth = [
                        1,
                        1
                    ], this.zeroLineEnable = [
                        !0,
                        !0
                    ], this.zeroLineWidth = [
                        1,
                        1
                    ], this.zeroLineColor = [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ]
                    ], this.borderColor = [
                        0,
                        0,
                        0,
                        0
                    ], this.backgroundColor = [
                        0,
                        0,
                        0,
                        0
                    ], this.static = this.scene.staticPlot;
                }
                var o = a.prototype, s = [
                    "xaxis",
                    "yaxis"
                ];
                o.merge = function(t1) {
                    var e1, r, n, a, o, l, c, u, h, f, p;
                    for(this.titleEnable = !1, this.backgroundColor = i(t1.plot_bgcolor), f = 0; f < 2; ++f){
                        var d = (e1 = s[f]).charAt(0);
                        for(n = (r = t1[this.scene[e1]._name]).title.text === this.scene.fullLayout._dfltTitle[d] ? "" : r.title.text, p = 0; p <= 2; p += 2)this.labelEnable[f + p] = !1, this.labels[f + p] = n, this.labelColor[f + p] = i(r.title.font.color), this.labelFont[f + p] = r.title.font.family, this.labelSize[f + p] = r.title.font.size, this.labelPad[f + p] = this.getLabelPad(e1, r), this.tickEnable[f + p] = !1, this.tickColor[f + p] = i((r.tickfont || {}).color), this.tickAngle[f + p] = "auto" === r.tickangle ? 0 : Math.PI * -r.tickangle / 180, this.tickPad[f + p] = this.getTickPad(r), this.tickMarkLength[f + p] = 0, this.tickMarkWidth[f + p] = r.tickwidth || 0, this.tickMarkColor[f + p] = i(r.tickcolor), this.borderLineEnable[f + p] = !1, this.borderLineColor[f + p] = i(r.linecolor), this.borderLineWidth[f + p] = r.linewidth || 0;
                        c = this.hasSharedAxis(r), o = this.hasAxisInDfltPos(e1, r) && !c, l = this.hasAxisInAltrPos(e1, r) && !c, a = r.mirror || !1, u = c ? -1 !== String(a).indexOf("all") : !!a, h = c ? "allticks" === a : -1 !== String(a).indexOf("ticks"), o ? this.labelEnable[f] = !0 : l && (this.labelEnable[f + 2] = !0), o ? this.tickEnable[f] = r.showticklabels : l && (this.tickEnable[f + 2] = r.showticklabels), (o || u) && (this.borderLineEnable[f] = r.showline), (l || u) && (this.borderLineEnable[f + 2] = r.showline), (o || h) && (this.tickMarkLength[f] = this.getTickMarkLength(r)), (l || h) && (this.tickMarkLength[f + 2] = this.getTickMarkLength(r)), this.gridLineEnable[f] = r.showgrid, this.gridLineColor[f] = i(r.gridcolor), this.gridLineWidth[f] = r.gridwidth, this.zeroLineEnable[f] = r.zeroline, this.zeroLineColor[f] = i(r.zerolinecolor), this.zeroLineWidth[f] = r.zerolinewidth;
                    }
                }, o.hasSharedAxis = function(t1) {
                    var e1 = this.scene, r = e1.fullLayout._subplots.gl2d;
                    return 0 !== n.findSubplotsWithAxis(r, t1).indexOf(e1.id);
                }, o.hasAxisInDfltPos = function(t1, e1) {
                    var r = e1.side;
                    return "xaxis" === t1 ? "bottom" === r : "yaxis" === t1 ? "left" === r : void 0;
                }, o.hasAxisInAltrPos = function(t1, e1) {
                    var r = e1.side;
                    return "xaxis" === t1 ? "top" === r : "yaxis" === t1 ? "right" === r : void 0;
                }, o.getLabelPad = function(t1, e1) {
                    var r = 1.5, n = e1.title.font.size, i = e1.showticklabels;
                    return "xaxis" === t1 ? "top" === e1.side ? n * (r + (i ? 1 : 0)) - 10 : n * (r + (i ? .5 : 0)) - 10 : "yaxis" === t1 ? "right" === e1.side ? 10 + n * (r + (i ? 1 : .5)) : 10 + n * (r + (i ? .5 : 0)) : void 0;
                }, o.getTickPad = function(t1) {
                    return "outside" === t1.ticks ? 10 + t1.ticklen : 15;
                }, o.getTickMarkLength = function(t1) {
                    if (!t1.ticks) return 0;
                    var e1 = t1.ticklen;
                    return "inside" === t1.ticks ? -e1 : e1;
                }, t1.exports = function(t1) {
                    return new a(t1);
                };
            },
            24585: function(t1, e1, r) {
                "use strict";
                var n = r(13582).overrideAll, i = r(27672), a = r(6704), o = r(62972), s = r(54826), l = r(37703), c = r(6811), u = r(4173).KO;
                e1.name = "gl2d", e1.attr = [
                    "xaxis",
                    "yaxis"
                ], e1.idRoot = [
                    "x",
                    "y"
                ], e1.idRegex = s.idRegex, e1.attrRegex = s.attrRegex, e1.attributes = r(55126), e1.supplyLayoutDefaults = function(t1, e1, r) {
                    e1._has("cartesian") || l.supplyLayoutDefaults(t1, e1, r);
                }, e1.layoutAttrOverrides = n(l.layoutAttributes, "plot", "from-root"), e1.baseLayoutAttrOverrides = n({
                    plot_bgcolor: a.plot_bgcolor,
                    hoverlabel: c.hoverlabel
                }, "plot", "nested"), e1.plot = function(t1) {
                    for(var e1 = t1._fullLayout, r = t1._fullData, n = e1._subplots.gl2d, a = 0; a < n.length; a++){
                        var o = n[a], s = e1._plots[o], l = u(r, "gl2d", o), c = s._scene2d;
                        void 0 === c && (c = new i({
                            id: o,
                            graphDiv: t1,
                            container: t1.querySelector(".gl-container"),
                            staticPlot: t1._context.staticPlot,
                            plotGlPixelRatio: t1._context.plotGlPixelRatio
                        }, e1), s._scene2d = c), c.plot(l, t1.calcdata, e1, t1.layout);
                    }
                }, e1.clean = function(t1, e1, r, n) {
                    for(var i = n._subplots.gl2d || [], a = 0; a < i.length; a++){
                        var o = i[a], s = n._plots[o];
                        s._scene2d && 0 === u(t1, "gl2d", o).length && (s._scene2d.destroy(), delete n._plots[o]);
                    }
                    l.clean.apply(this, arguments);
                }, e1.drawFramework = function(t1) {
                    t1._context.staticPlot || l.drawFramework(t1);
                }, e1.toSVG = function(t1) {
                    for(var e1 = t1._fullLayout, r = e1._subplots.gl2d, n = 0; n < r.length; n++){
                        var i = e1._plots[r[n]]._scene2d, a = i.toImage("png");
                        e1._glimages.append("svg:image").attr({
                            xmlns: o.svg,
                            "xlink:href": a,
                            x: 0,
                            y: 0,
                            width: "100%",
                            height: "100%",
                            preserveAspectRatio: "none"
                        }), i.destroy();
                    }
                }, e1.updateFx = function(t1) {
                    for(var e1 = t1._fullLayout, r = e1._subplots.gl2d, n = 0; n < r.length; n++)e1._plots[r[n]]._scene2d.updateFx(e1.dragmode);
                };
            },
            27672: function(t1, e1, r) {
                "use strict";
                var n, i, a = r(33626), o = r(29714), s = r(32141), l = r(99098).gl_plot2d, c = r(99098).gl_spikes2d, u = r(99098).gl_select_box, h = r(22248), f = r(10749), p = r(77055), d = r(97464), m = r(84391), g = m.enforce, y = m.clean, v = r(32919).doAutoRange, x = r(70414), _ = x.drawMode, b = x.selectMode, w = [
                    "xaxis",
                    "yaxis"
                ], T = r(54826).SUBPLOT_PATTERN;
                function k(t1, e1) {
                    this.container = t1.container, this.graphDiv = t1.graphDiv, this.pixelRatio = t1.plotGlPixelRatio || window.devicePixelRatio, this.id = t1.id, this.staticPlot = !!t1.staticPlot, this.scrollZoom = this.graphDiv._context._scrollZoom.cartesian, this.fullData = null, this.updateRefs(e1), this.makeFramework(), this.stopped || (this.glplotOptions = f(this), this.glplotOptions.merge(e1), this.glplot = l(this.glplotOptions), this.camera = p(this), this.traces = {}, this.spikes = c(this.glplot), this.selectBox = u(this.glplot, {
                        innerFill: !1,
                        outerFill: !0
                    }), this.lastButtonState = 0, this.pickResult = null, this.isMouseOver = !0, this.stopped = !1, this.redraw = this.draw.bind(this), this.redraw());
                }
                t1.exports = k;
                var A = k.prototype;
                A.makeFramework = function() {
                    if (this.staticPlot) {
                        if (!(i || (n = document.createElement("canvas"), i = h({
                            canvas: n,
                            preserveDrawingBuffer: !1,
                            premultipliedAlpha: !0,
                            antialias: !0
                        })))) throw new Error("Error creating static canvas/context for image server");
                        this.canvas = n, this.gl = i;
                    } else {
                        var t1 = this.container.querySelector(".gl-canvas-focus"), e1 = h({
                            canvas: t1,
                            preserveDrawingBuffer: !0,
                            premultipliedAlpha: !0
                        });
                        if (!e1) return d(this), void (this.stopped = !0);
                        this.canvas = t1, this.gl = e1;
                    }
                    var r = this.canvas;
                    r.style.width = "100%", r.style.height = "100%", r.style.position = "absolute", r.style.top = "0px", r.style.left = "0px", r.style["pointer-events"] = "none", this.updateSize(r);
                    var a = this.svgContainer = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                    a.style.position = "absolute", a.style.top = a.style.left = "0px", a.style.width = a.style.height = "100%", a.style["z-index"] = 20, a.style["pointer-events"] = "none";
                    var o = this.mouseContainer = document.createElement("div");
                    o.style.position = "absolute", o.style["pointer-events"] = "auto", this.pickCanvas = this.container.querySelector(".gl-canvas-pick");
                    var s = this.container;
                    s.appendChild(a), s.appendChild(o);
                    var l = this;
                    o.addEventListener("mouseout", function() {
                        l.isMouseOver = !1, l.unhover();
                    }), o.addEventListener("mouseover", function() {
                        l.isMouseOver = !0;
                    });
                }, A.toImage = function(t1) {
                    t1 || (t1 = "png"), this.stopped = !0, this.staticPlot && this.container.appendChild(n), this.updateSize(this.canvas);
                    var e1 = this.glplot.gl, r = e1.drawingBufferWidth, i = e1.drawingBufferHeight;
                    e1.clearColor(1, 1, 1, 0), e1.clear(e1.COLOR_BUFFER_BIT | e1.DEPTH_BUFFER_BIT), this.glplot.setDirty(), this.glplot.draw(), e1.bindFramebuffer(e1.FRAMEBUFFER, null);
                    var a = new Uint8Array(r * i * 4);
                    e1.readPixels(0, 0, r, i, e1.RGBA, e1.UNSIGNED_BYTE, a);
                    for(var o = 0, s = i - 1; o < s; ++o, --s)for(var l = 0; l < r; ++l)for(var c = 0; c < 4; ++c){
                        var u = a[4 * (r * o + l) + c];
                        a[4 * (r * o + l) + c] = a[4 * (r * s + l) + c], a[4 * (r * s + l) + c] = u;
                    }
                    var h = document.createElement("canvas");
                    h.width = r, h.height = i;
                    var f, p = h.getContext("2d", {
                        willReadFrequently: !0
                    }), d = p.createImageData(r, i);
                    switch(d.data.set(a), p.putImageData(d, 0, 0), t1){
                        case "jpeg":
                            f = h.toDataURL("image/jpeg");
                            break;
                        case "webp":
                            f = h.toDataURL("image/webp");
                            break;
                        default:
                            f = h.toDataURL("image/png");
                    }
                    return this.staticPlot && this.container.removeChild(n), f;
                }, A.updateSize = function(t1) {
                    t1 || (t1 = this.canvas);
                    var e1 = this.pixelRatio, r = this.fullLayout, n = r.width, i = r.height, a = 0 | Math.ceil(e1 * n), o = 0 | Math.ceil(e1 * i);
                    return t1.width === a && t1.height === o || (t1.width = a, t1.height = o), t1;
                }, A.computeTickMarks = function() {
                    this.xaxis.setScale(), this.yaxis.setScale();
                    for(var t1 = [
                        o.calcTicks(this.xaxis),
                        o.calcTicks(this.yaxis)
                    ], e1 = 0; e1 < 2; ++e1)for(var r = 0; r < t1[e1].length; ++r)t1[e1][r].text = t1[e1][r].text + "";
                    return t1;
                }, A.updateRefs = function(t1) {
                    this.fullLayout = t1;
                    var e1 = this.id.match(T), r = "xaxis" + e1[1], n = "yaxis" + e1[2];
                    this.xaxis = this.fullLayout[r], this.yaxis = this.fullLayout[n];
                }, A.relayoutCallback = function() {
                    var t1 = this.graphDiv, e1 = this.xaxis, r = this.yaxis, n = t1.layout, i = {}, o = i[e1._name + ".range"] = e1.range.slice(), s = i[r._name + ".range"] = r.range.slice();
                    i[e1._name + ".autorange"] = e1.autorange, i[r._name + ".autorange"] = r.autorange, a.call("_storeDirectGUIEdit", t1.layout, t1._fullLayout._preGUI, i);
                    var l = n[e1._name];
                    l.range = o, l.autorange = e1.autorange;
                    var c = n[r._name];
                    c.range = s, c.autorange = r.autorange, i.lastInputTime = this.camera.lastInputTime, t1.emit("plotly_relayout", i);
                }, A.cameraChanged = function() {
                    var t1 = this.camera;
                    this.glplot.setDataBox(this.calcDataBox());
                    var e1 = this.computeTickMarks();
                    (function(t1, e1) {
                        for(var r = 0; r < 2; ++r){
                            var n = t1[r], i = e1[r];
                            if (n.length !== i.length) return !0;
                            for(var a = 0; a < n.length; ++a)if (n[a].x !== i[a].x) return !0;
                        }
                        return !1;
                    })(e1, this.glplotOptions.ticks) && (this.glplotOptions.ticks = e1, this.glplotOptions.dataBox = t1.dataBox, this.glplot.update(this.glplotOptions), this.handleAnnotations());
                }, A.handleAnnotations = function() {
                    for(var t1 = this.graphDiv, e1 = this.fullLayout.annotations, r = 0; r < e1.length; r++){
                        var n = e1[r];
                        n.xref === this.xaxis._id && n.yref === this.yaxis._id && a.getComponentMethod("annotations", "drawOne")(t1, r);
                    }
                }, A.destroy = function() {
                    if (this.glplot) {
                        var t1 = this.traces;
                        t1 && Object.keys(t1).map(function(e1) {
                            t1[e1].dispose(), delete t1[e1];
                        }), this.glplot.dispose(), this.container.removeChild(this.svgContainer), this.container.removeChild(this.mouseContainer), this.fullData = null, this.glplot = null, this.stopped = !0, this.camera.mouseListener.enabled = !1, this.mouseContainer.removeEventListener("wheel", this.camera.wheelListener), this.camera = null;
                    }
                }, A.plot = function(t1, e1, r) {
                    var n = this.glplot;
                    this.updateRefs(r), this.xaxis.clearCalc(), this.yaxis.clearCalc(), this.updateTraces(t1, e1), this.updateFx(r.dragmode);
                    var i = r.width, a = r.height;
                    this.updateSize(this.canvas);
                    var o = this.glplotOptions;
                    o.merge(r), o.screenBox = [
                        0,
                        0,
                        i,
                        a
                    ];
                    var s = {
                        _fullLayout: {
                            _axisConstraintGroups: r._axisConstraintGroups,
                            xaxis: this.xaxis,
                            yaxis: this.yaxis,
                            _size: r._size
                        }
                    };
                    y(s, this.xaxis), y(s, this.yaxis);
                    var l, c, u = r._size, h = this.xaxis.domain, f = this.yaxis.domain;
                    for(o.viewBox = [
                        u.l + h[0] * u.w,
                        u.b + f[0] * u.h,
                        i - u.r - (1 - h[1]) * u.w,
                        a - u.t - (1 - f[1]) * u.h
                    ], this.mouseContainer.style.width = u.w * (h[1] - h[0]) + "px", this.mouseContainer.style.height = u.h * (f[1] - f[0]) + "px", this.mouseContainer.height = u.h * (f[1] - f[0]), this.mouseContainer.style.left = u.l + h[0] * u.w + "px", this.mouseContainer.style.top = u.t + (1 - f[1]) * u.h + "px", c = 0; c < 2; ++c)(l = this[w[c]])._length = o.viewBox[c + 2] - o.viewBox[c], v(this.graphDiv, l), l.setScale();
                    g(s), o.ticks = this.computeTickMarks(), o.dataBox = this.calcDataBox(), o.merge(r), n.update(o), this.glplot.draw();
                }, A.calcDataBox = function() {
                    var t1 = this.xaxis, e1 = this.yaxis, r = t1.range, n = e1.range, i = t1.r2l, a = e1.r2l;
                    return [
                        i(r[0]),
                        a(n[0]),
                        i(r[1]),
                        a(n[1])
                    ];
                }, A.setRanges = function(t1) {
                    var e1 = this.xaxis, r = this.yaxis, n = e1.l2r, i = r.l2r;
                    e1.range = [
                        n(t1[0]),
                        n(t1[2])
                    ], r.range = [
                        i(t1[1]),
                        i(t1[3])
                    ];
                }, A.updateTraces = function(t1, e1) {
                    var r, n, i, a = Object.keys(this.traces);
                    this.fullData = t1;
                    t: for(r = 0; r < a.length; r++){
                        var o = a[r], s = this.traces[o];
                        for(n = 0; n < t1.length; n++)if ((i = t1[n]).uid === o && i.type === s.type) continue t;
                        s.dispose(), delete this.traces[o];
                    }
                    for(r = 0; r < t1.length; r++){
                        i = t1[r];
                        var l = e1[r], c = this.traces[i.uid];
                        c ? c.update(i, l) : (c = i._module.plot(this, i, l), this.traces[i.uid] = c);
                    }
                    this.glplot.objects.sort(function(t1, e1) {
                        return t1._trace.index - e1._trace.index;
                    });
                }, A.updateFx = function(t1) {
                    b(t1) || _(t1) ? (this.pickCanvas.style["pointer-events"] = "none", this.mouseContainer.style["pointer-events"] = "none") : (this.pickCanvas.style["pointer-events"] = "auto", this.mouseContainer.style["pointer-events"] = "auto"), this.mouseContainer.style.cursor = "pan" === t1 ? "move" : "zoom" === t1 ? "crosshair" : null;
                }, A.emitPointAction = function(t1, e1) {
                    for(var r, n = t1.trace.uid, i = t1.pointIndex, a = 0; a < this.fullData.length; a++)this.fullData[a].uid === n && (r = this.fullData[a]);
                    var o = {
                        x: t1.traceCoord[0],
                        y: t1.traceCoord[1],
                        curveNumber: r.index,
                        pointNumber: i,
                        data: r._input,
                        fullData: this.fullData,
                        xaxis: this.xaxis,
                        yaxis: this.yaxis
                    };
                    s.appendArrayPointValue(o, r, i), this.graphDiv.emit(e1, {
                        points: [
                            o
                        ]
                    });
                }, A.draw = function() {
                    if (!this.stopped) {
                        requestAnimationFrame(this.redraw);
                        var t1 = this.glplot, e1 = this.camera, r = e1.mouseListener, n = 1 === this.lastButtonState && 0 === r.buttons, i = this.fullLayout;
                        this.lastButtonState = r.buttons, this.cameraChanged();
                        var a, o = r.x * t1.pixelRatio, l = this.canvas.height - t1.pixelRatio * r.y;
                        if (e1.boxEnabled && "zoom" === i.dragmode) {
                            this.selectBox.enabled = !0;
                            for(var c = this.selectBox.selectBox = [
                                Math.min(e1.boxStart[0], e1.boxEnd[0]),
                                Math.min(e1.boxStart[1], e1.boxEnd[1]),
                                Math.max(e1.boxStart[0], e1.boxEnd[0]),
                                Math.max(e1.boxStart[1], e1.boxEnd[1])
                            ], u = 0; u < 2; u++)e1.boxStart[u] === e1.boxEnd[u] && (c[u] = t1.dataBox[u], c[u + 2] = t1.dataBox[u + 2]);
                            t1.setDirty();
                        } else if (!e1.panning && this.isMouseOver) {
                            this.selectBox.enabled = !1;
                            var h = i._size, f = this.xaxis.domain, p = this.yaxis.domain, d = (a = t1.pick(o / t1.pixelRatio + h.l + f[0] * h.w, l / t1.pixelRatio - (h.t + (1 - p[1]) * h.h))) && a.object._trace.handlePick(a);
                            if (d && n && this.emitPointAction(d, "plotly_click"), a && "skip" !== a.object._trace.hoverinfo && i.hovermode && d && (!this.lastPickResult || this.lastPickResult.traceUid !== d.trace.uid || this.lastPickResult.dataCoord[0] !== d.dataCoord[0] || this.lastPickResult.dataCoord[1] !== d.dataCoord[1])) {
                                var m = d;
                                this.lastPickResult = {
                                    traceUid: d.trace ? d.trace.uid : null,
                                    dataCoord: d.dataCoord.slice()
                                }, this.spikes.update({
                                    center: a.dataCoord
                                }), m.screenCoord = [
                                    ((t1.viewBox[2] - t1.viewBox[0]) * (a.dataCoord[0] - t1.dataBox[0]) / (t1.dataBox[2] - t1.dataBox[0]) + t1.viewBox[0]) / t1.pixelRatio,
                                    (this.canvas.height - (t1.viewBox[3] - t1.viewBox[1]) * (a.dataCoord[1] - t1.dataBox[1]) / (t1.dataBox[3] - t1.dataBox[1]) - t1.viewBox[1]) / t1.pixelRatio
                                ], this.emitPointAction(d, "plotly_hover");
                                var g = this.fullData[m.trace.index] || {}, y = m.pointIndex, v = s.castHoverinfo(g, i, y);
                                if (v && "all" !== v) {
                                    var x = v.split("+");
                                    -1 === x.indexOf("x") && (m.traceCoord[0] = void 0), -1 === x.indexOf("y") && (m.traceCoord[1] = void 0), -1 === x.indexOf("z") && (m.traceCoord[2] = void 0), -1 === x.indexOf("text") && (m.textLabel = void 0), -1 === x.indexOf("name") && (m.name = void 0);
                                }
                                s.loneHover({
                                    x: m.screenCoord[0],
                                    y: m.screenCoord[1],
                                    xLabel: this.hoverFormatter("xaxis", m.traceCoord[0]),
                                    yLabel: this.hoverFormatter("yaxis", m.traceCoord[1]),
                                    zLabel: m.traceCoord[2],
                                    text: m.textLabel,
                                    name: m.name,
                                    color: s.castHoverOption(g, y, "bgcolor") || m.color,
                                    borderColor: s.castHoverOption(g, y, "bordercolor"),
                                    fontFamily: s.castHoverOption(g, y, "font.family"),
                                    fontSize: s.castHoverOption(g, y, "font.size"),
                                    fontColor: s.castHoverOption(g, y, "font.color"),
                                    nameLength: s.castHoverOption(g, y, "namelength"),
                                    textAlign: s.castHoverOption(g, y, "align")
                                }, {
                                    container: this.svgContainer,
                                    gd: this.graphDiv
                                });
                            }
                        }
                        a || this.unhover(), t1.draw();
                    }
                }, A.unhover = function() {
                    this.lastPickResult && (this.spikes.update({}), this.lastPickResult = null, this.graphDiv.emit("plotly_unhover"), s.loneUnhover(this.svgContainer));
                }, A.hoverFormatter = function(t1, e1) {
                    if (void 0 !== e1) {
                        var r = this[t1];
                        return o.tickText(r, r.c2l(e1), "hover").text;
                    }
                };
            },
            2487: function(t1, e1, r) {
                "use strict";
                var n = r(13582).overrideAll, i = r(6811), a = r(20299), o = r(4173).KO, s = r(34809), l = r(62972), c = "gl3d", u = "scene";
                e1.name = c, e1.attr = u, e1.idRoot = u, e1.idRegex = e1.attrRegex = s.counterRegex("scene"), e1.attributes = r(22597), e1.layoutAttributes = r(77168), e1.baseLayoutAttrOverrides = n({
                    hoverlabel: i.hoverlabel
                }, "plot", "nested"), e1.supplyLayoutDefaults = r(15250), e1.plot = function(t1) {
                    for(var e1 = t1._fullLayout, r = t1._fullData, n = e1._subplots[c], i = 0; i < n.length; i++){
                        var s = n[i], l = o(r, c, s), u = e1[s], h = u.camera, f = u._scene;
                        f || (f = new a({
                            id: s,
                            graphDiv: t1,
                            container: t1.querySelector(".gl-container"),
                            staticPlot: t1._context.staticPlot,
                            plotGlPixelRatio: t1._context.plotGlPixelRatio,
                            camera: h
                        }, e1), u._scene = f), f.viewInitial || (f.viewInitial = {
                            up: {
                                x: h.up.x,
                                y: h.up.y,
                                z: h.up.z
                            },
                            eye: {
                                x: h.eye.x,
                                y: h.eye.y,
                                z: h.eye.z
                            },
                            center: {
                                x: h.center.x,
                                y: h.center.y,
                                z: h.center.z
                            }
                        }), f.plot(l, e1, t1.layout);
                    }
                }, e1.clean = function(t1, e1, r, n) {
                    for(var i = n._subplots[c] || [], a = 0; a < i.length; a++){
                        var o = i[a];
                        !e1[o] && n[o]._scene && (n[o]._scene.destroy(), n._infolayer && n._infolayer.selectAll(".annotation-" + o).remove());
                    }
                }, e1.toSVG = function(t1) {
                    for(var e1 = t1._fullLayout, r = e1._subplots[c], n = e1._size, i = 0; i < r.length; i++){
                        var a = e1[r[i]], o = a.domain, s = a._scene, u = s.toImage("png");
                        e1._glimages.append("svg:image").attr({
                            xmlns: l.svg,
                            "xlink:href": u,
                            x: n.l + n.w * o.x[0],
                            y: n.t + n.h * (1 - o.y[1]),
                            width: n.w * (o.x[1] - o.x[0]),
                            height: n.h * (o.y[1] - o.y[0]),
                            preserveAspectRatio: "none"
                        }), s.destroy();
                    }
                }, e1.cleanId = function(t1) {
                    if (t1.match(/^scene[0-9]*$/)) {
                        var e1 = t1.substr(5);
                        return "1" === e1 && (e1 = ""), u + e1;
                    }
                }, e1.updateFx = function(t1) {
                    for(var e1 = t1._fullLayout, r = e1._subplots[c], n = 0; n < r.length; n++)e1[r[n]]._scene.updateFx(e1.dragmode, e1.hovermode);
                };
            },
            22597: function(t1) {
                "use strict";
                t1.exports = {
                    scene: {
                        valType: "subplotid",
                        dflt: "scene",
                        editType: "calc+clearAxisTypes"
                    }
                };
            },
            63397: function(t1, e1, r) {
                "use strict";
                var n = r(78766), i = r(25829), a = r(93049).extendFlat, o = r(13582).overrideAll;
                t1.exports = o({
                    visible: i.visible,
                    showspikes: {
                        valType: "boolean",
                        dflt: !0
                    },
                    spikesides: {
                        valType: "boolean",
                        dflt: !0
                    },
                    spikethickness: {
                        valType: "number",
                        min: 0,
                        dflt: 2
                    },
                    spikecolor: {
                        valType: "color",
                        dflt: n.defaultLine
                    },
                    showbackground: {
                        valType: "boolean",
                        dflt: !1
                    },
                    backgroundcolor: {
                        valType: "color",
                        dflt: "rgba(204, 204, 204, 0.5)"
                    },
                    showaxeslabels: {
                        valType: "boolean",
                        dflt: !0
                    },
                    color: i.color,
                    categoryorder: i.categoryorder,
                    categoryarray: i.categoryarray,
                    title: {
                        text: i.title.text,
                        font: i.title.font
                    },
                    type: a({}, i.type, {
                        values: [
                            "-",
                            "linear",
                            "log",
                            "date",
                            "category"
                        ]
                    }),
                    autotypenumbers: i.autotypenumbers,
                    autorange: i.autorange,
                    autorangeoptions: {
                        minallowed: i.autorangeoptions.minallowed,
                        maxallowed: i.autorangeoptions.maxallowed,
                        clipmin: i.autorangeoptions.clipmin,
                        clipmax: i.autorangeoptions.clipmax,
                        include: i.autorangeoptions.include,
                        editType: "plot"
                    },
                    rangemode: i.rangemode,
                    minallowed: i.minallowed,
                    maxallowed: i.maxallowed,
                    range: a({}, i.range, {
                        items: [
                            {
                                valType: "any",
                                editType: "plot",
                                impliedEdits: {
                                    "^autorange": !1
                                }
                            },
                            {
                                valType: "any",
                                editType: "plot",
                                impliedEdits: {
                                    "^autorange": !1
                                }
                            }
                        ],
                        anim: !1
                    }),
                    tickmode: i.minor.tickmode,
                    nticks: i.nticks,
                    tick0: i.tick0,
                    dtick: i.dtick,
                    tickvals: i.tickvals,
                    ticktext: i.ticktext,
                    ticks: i.ticks,
                    mirror: i.mirror,
                    ticklen: i.ticklen,
                    tickwidth: i.tickwidth,
                    tickcolor: i.tickcolor,
                    showticklabels: i.showticklabels,
                    labelalias: i.labelalias,
                    tickfont: i.tickfont,
                    tickangle: i.tickangle,
                    tickprefix: i.tickprefix,
                    showtickprefix: i.showtickprefix,
                    ticksuffix: i.ticksuffix,
                    showticksuffix: i.showticksuffix,
                    showexponent: i.showexponent,
                    exponentformat: i.exponentformat,
                    minexponent: i.minexponent,
                    separatethousands: i.separatethousands,
                    tickformat: i.tickformat,
                    tickformatstops: i.tickformatstops,
                    hoverformat: i.hoverformat,
                    showline: i.showline,
                    linecolor: i.linecolor,
                    linewidth: i.linewidth,
                    showgrid: i.showgrid,
                    gridcolor: a({}, i.gridcolor, {
                        dflt: "rgb(204, 204, 204)"
                    }),
                    gridwidth: i.gridwidth,
                    zeroline: i.zeroline,
                    zerolinecolor: i.zerolinecolor,
                    zerolinewidth: i.zerolinewidth,
                    _deprecated: {
                        title: i._deprecated.title,
                        titlefont: i._deprecated.titlefont
                    }
                }, "plot", "from-root");
            },
            34258: function(t1, e1, r) {
                "use strict";
                var n = r(65657).mix, i = r(34809), a = r(78032), o = r(63397), s = r(4392), l = r(97655), c = [
                    "xaxis",
                    "yaxis",
                    "zaxis"
                ];
                t1.exports = function(t1, e1, r) {
                    var u, h;
                    function f(t1, e1) {
                        return i.coerce(u, h, o, t1, e1);
                    }
                    for(var p = 0; p < c.length; p++){
                        var d = c[p];
                        u = t1[d] || {}, (h = a.newContainer(e1, d))._id = d[0] + r.scene, h._name = d, s(u, h, f, r), l(u, h, f, {
                            font: r.font,
                            letter: d[0],
                            data: r.data,
                            showGrid: !0,
                            noAutotickangles: !0,
                            noTicklabelindex: !0,
                            noTickson: !0,
                            noTicklabelmode: !0,
                            noTicklabelshift: !0,
                            noTicklabelstandoff: !0,
                            noTicklabelstep: !0,
                            noTicklabelposition: !0,
                            noTicklabeloverflow: !0,
                            noInsiderange: !0,
                            bgColor: r.bgColor,
                            calendar: r.calendar
                        }, r.fullLayout), f("gridcolor", n(h.color, r.bgColor, 72.72727272727273).toRgbString()), f("title.text", d[0]), h.setScale = i.noop, f("showspikes") && (f("spikesides"), f("spikethickness"), f("spikecolor", h.color)), f("showaxeslabels"), f("showbackground") && f("backgroundcolor");
                    }
                };
            },
            95701: function(t1, e1, r) {
                "use strict";
                var n = r(55010), i = r(34809), a = [
                    "xaxis",
                    "yaxis",
                    "zaxis"
                ];
                function o() {
                    this.bounds = [
                        [
                            -10,
                            -10,
                            -10
                        ],
                        [
                            10,
                            10,
                            10
                        ]
                    ], this.ticks = [
                        [],
                        [],
                        []
                    ], this.tickEnable = [
                        !0,
                        !0,
                        !0
                    ], this.tickFont = [
                        "sans-serif",
                        "sans-serif",
                        "sans-serif"
                    ], this.tickSize = [
                        12,
                        12,
                        12
                    ], this.tickFontWeight = [
                        "normal",
                        "normal",
                        "normal",
                        "normal"
                    ], this.tickFontStyle = [
                        "normal",
                        "normal",
                        "normal",
                        "normal"
                    ], this.tickFontVariant = [
                        "normal",
                        "normal",
                        "normal",
                        "normal"
                    ], this.tickAngle = [
                        0,
                        0,
                        0
                    ], this.tickColor = [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ]
                    ], this.tickPad = [
                        18,
                        18,
                        18
                    ], this.labels = [
                        "x",
                        "y",
                        "z"
                    ], this.labelEnable = [
                        !0,
                        !0,
                        !0
                    ], this.labelFont = [
                        "Open Sans",
                        "Open Sans",
                        "Open Sans"
                    ], this.labelSize = [
                        20,
                        20,
                        20
                    ], this.labelFontWeight = [
                        "normal",
                        "normal",
                        "normal",
                        "normal"
                    ], this.labelFontStyle = [
                        "normal",
                        "normal",
                        "normal",
                        "normal"
                    ], this.labelFontVariant = [
                        "normal",
                        "normal",
                        "normal",
                        "normal"
                    ], this.labelColor = [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ]
                    ], this.labelPad = [
                        30,
                        30,
                        30
                    ], this.lineEnable = [
                        !0,
                        !0,
                        !0
                    ], this.lineMirror = [
                        !1,
                        !1,
                        !1
                    ], this.lineWidth = [
                        1,
                        1,
                        1
                    ], this.lineColor = [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ]
                    ], this.lineTickEnable = [
                        !0,
                        !0,
                        !0
                    ], this.lineTickMirror = [
                        !1,
                        !1,
                        !1
                    ], this.lineTickLength = [
                        10,
                        10,
                        10
                    ], this.lineTickWidth = [
                        1,
                        1,
                        1
                    ], this.lineTickColor = [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ]
                    ], this.gridEnable = [
                        !0,
                        !0,
                        !0
                    ], this.gridWidth = [
                        1,
                        1,
                        1
                    ], this.gridColor = [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ]
                    ], this.zeroEnable = [
                        !0,
                        !0,
                        !0
                    ], this.zeroLineColor = [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ]
                    ], this.zeroLineWidth = [
                        2,
                        2,
                        2
                    ], this.backgroundEnable = [
                        !0,
                        !0,
                        !0
                    ], this.backgroundColor = [
                        [
                            .8,
                            .8,
                            .8,
                            .5
                        ],
                        [
                            .8,
                            .8,
                            .8,
                            .5
                        ],
                        [
                            .8,
                            .8,
                            .8,
                            .5
                        ]
                    ], this._defaultTickPad = this.tickPad.slice(), this._defaultLabelPad = this.labelPad.slice(), this._defaultLineTickLength = this.lineTickLength.slice();
                }
                o.prototype.merge = function(t1, e1) {
                    for(var r = this, o = 0; o < 3; ++o){
                        var s = e1[a[o]];
                        s.visible ? (r.labels[o] = t1._meta ? i.templateString(s.title.text, t1._meta) : s.title.text, "font" in s.title && (s.title.font.color && (r.labelColor[o] = n(s.title.font.color)), s.title.font.family && (r.labelFont[o] = s.title.font.family), s.title.font.size && (r.labelSize[o] = s.title.font.size), s.title.font.weight && (r.labelFontWeight[o] = s.title.font.weight), s.title.font.style && (r.labelFontStyle[o] = s.title.font.style), s.title.font.variant && (r.labelFontVariant[o] = s.title.font.variant)), "showline" in s && (r.lineEnable[o] = s.showline), "linecolor" in s && (r.lineColor[o] = n(s.linecolor)), "linewidth" in s && (r.lineWidth[o] = s.linewidth), "showgrid" in s && (r.gridEnable[o] = s.showgrid), "gridcolor" in s && (r.gridColor[o] = n(s.gridcolor)), "gridwidth" in s && (r.gridWidth[o] = s.gridwidth), "log" === s.type ? r.zeroEnable[o] = !1 : "zeroline" in s && (r.zeroEnable[o] = s.zeroline), "zerolinecolor" in s && (r.zeroLineColor[o] = n(s.zerolinecolor)), "zerolinewidth" in s && (r.zeroLineWidth[o] = s.zerolinewidth), "ticks" in s && s.ticks ? r.lineTickEnable[o] = !0 : r.lineTickEnable[o] = !1, "ticklen" in s && (r.lineTickLength[o] = r._defaultLineTickLength[o] = s.ticklen), "tickcolor" in s && (r.lineTickColor[o] = n(s.tickcolor)), "tickwidth" in s && (r.lineTickWidth[o] = s.tickwidth), "tickangle" in s && (r.tickAngle[o] = "auto" === s.tickangle ? -3600 : Math.PI * -s.tickangle / 180), "showticklabels" in s && (r.tickEnable[o] = s.showticklabels), "tickfont" in s && (s.tickfont.color && (r.tickColor[o] = n(s.tickfont.color)), s.tickfont.family && (r.tickFont[o] = s.tickfont.family), s.tickfont.size && (r.tickSize[o] = s.tickfont.size), s.tickfont.weight && (r.tickFontWeight[o] = s.tickfont.weight), s.tickfont.style && (r.tickFontStyle[o] = s.tickfont.style), s.tickfont.variant && (r.tickFontVariant[o] = s.tickfont.variant)), "mirror" in s ? -1 !== [
                            "ticks",
                            "all",
                            "allticks"
                        ].indexOf(s.mirror) ? (r.lineTickMirror[o] = !0, r.lineMirror[o] = !0) : !0 === s.mirror ? (r.lineTickMirror[o] = !1, r.lineMirror[o] = !0) : (r.lineTickMirror[o] = !1, r.lineMirror[o] = !1) : r.lineMirror[o] = !1, "showbackground" in s && !1 !== s.showbackground ? (r.backgroundEnable[o] = !0, r.backgroundColor[o] = n(s.backgroundcolor)) : r.backgroundEnable[o] = !1) : (r.tickEnable[o] = !1, r.labelEnable[o] = !1, r.lineEnable[o] = !1, r.lineTickEnable[o] = !1, r.gridEnable[o] = !1, r.zeroEnable[o] = !1, r.backgroundEnable[o] = !1);
                    }
                }, t1.exports = function(t1, e1) {
                    var r = new o;
                    return r.merge(t1, e1), r;
                };
            },
            15250: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(78766), a = r(33626), o = r(4448), s = r(34258), l = r(77168), c = r(4173).KO, u = "gl3d";
                function h(t1, e1, r, n) {
                    for(var o = r("bgcolor"), l = i.combine(o, n.paper_bgcolor), h = [
                        "up",
                        "center",
                        "eye"
                    ], f = 0; f < h.length; f++)r("camera." + h[f] + ".x"), r("camera." + h[f] + ".y"), r("camera." + h[f] + ".z");
                    r("camera.projection.type");
                    var p = !!r("aspectratio.x") && !!r("aspectratio.y") && !!r("aspectratio.z"), d = r("aspectmode", p ? "manual" : "auto");
                    p || (t1.aspectratio = e1.aspectratio = {
                        x: 1,
                        y: 1,
                        z: 1
                    }, "manual" === d && (e1.aspectmode = "auto"), t1.aspectmode = e1.aspectmode);
                    var m = c(n.fullData, u, n.id);
                    s(t1, e1, {
                        font: n.font,
                        scene: n.id,
                        data: m,
                        bgColor: l,
                        calendar: n.calendar,
                        autotypenumbersDflt: n.autotypenumbersDflt,
                        fullLayout: n.fullLayout
                    }), a.getComponentMethod("annotations3d", "handleDefaults")(t1, e1, n);
                    var g = n.getDfltFromLayout("dragmode");
                    if (!1 !== g && !g) {
                        if (g = "orbit", t1.camera && t1.camera.up) {
                            var y = t1.camera.up.x, v = t1.camera.up.y, x = t1.camera.up.z;
                            0 !== x && (y && v && x ? x / Math.sqrt(y * y + v * v + x * x) > .999 && (g = "turntable") : g = "turntable");
                        } else g = "turntable";
                    }
                    r("dragmode", g), r("hovermode", n.getDfltFromLayout("hovermode"));
                }
                t1.exports = function(t1, e1, r) {
                    var i = e1._basePlotModules.length > 1;
                    o(t1, e1, r, {
                        type: u,
                        attributes: l,
                        handleDefaults: h,
                        fullLayout: e1,
                        font: e1.font,
                        fullData: r,
                        getDfltFromLayout: function(e1) {
                            if (!i) return n.validate(t1[e1], l[e1]) ? t1[e1] : void 0;
                        },
                        autotypenumbersDflt: e1.autotypenumbers,
                        paper_bgcolor: e1.paper_bgcolor,
                        calendar: e1.calendar
                    });
                };
            },
            77168: function(t1, e1, r) {
                "use strict";
                var n = r(63397), i = r(13792).u, a = r(93049).extendFlat, o = r(34809).counterRegex;
                function s(t1, e1, r) {
                    return {
                        x: {
                            valType: "number",
                            dflt: t1,
                            editType: "camera"
                        },
                        y: {
                            valType: "number",
                            dflt: e1,
                            editType: "camera"
                        },
                        z: {
                            valType: "number",
                            dflt: r,
                            editType: "camera"
                        },
                        editType: "camera"
                    };
                }
                t1.exports = {
                    _arrayAttrRegexps: [
                        o("scene", ".annotations", !0)
                    ],
                    bgcolor: {
                        valType: "color",
                        dflt: "rgba(0,0,0,0)",
                        editType: "plot"
                    },
                    camera: {
                        up: a(s(0, 0, 1), {}),
                        center: a(s(0, 0, 0), {}),
                        eye: a(s(1.25, 1.25, 1.25), {}),
                        projection: {
                            type: {
                                valType: "enumerated",
                                values: [
                                    "perspective",
                                    "orthographic"
                                ],
                                dflt: "perspective",
                                editType: "calc"
                            },
                            editType: "calc"
                        },
                        editType: "camera"
                    },
                    domain: i({
                        name: "scene",
                        editType: "plot"
                    }),
                    aspectmode: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "cube",
                            "data",
                            "manual"
                        ],
                        dflt: "auto",
                        editType: "plot",
                        impliedEdits: {
                            "aspectratio.x": void 0,
                            "aspectratio.y": void 0,
                            "aspectratio.z": void 0
                        }
                    },
                    aspectratio: {
                        x: {
                            valType: "number",
                            min: 0,
                            editType: "plot",
                            impliedEdits: {
                                "^aspectmode": "manual"
                            }
                        },
                        y: {
                            valType: "number",
                            min: 0,
                            editType: "plot",
                            impliedEdits: {
                                "^aspectmode": "manual"
                            }
                        },
                        z: {
                            valType: "number",
                            min: 0,
                            editType: "plot",
                            impliedEdits: {
                                "^aspectmode": "manual"
                            }
                        },
                        editType: "plot",
                        impliedEdits: {
                            aspectmode: "manual"
                        }
                    },
                    xaxis: n,
                    yaxis: n,
                    zaxis: n,
                    dragmode: {
                        valType: "enumerated",
                        values: [
                            "orbit",
                            "turntable",
                            "zoom",
                            "pan",
                            !1
                        ],
                        editType: "plot"
                    },
                    hovermode: {
                        valType: "enumerated",
                        values: [
                            "closest",
                            !1
                        ],
                        dflt: "closest",
                        editType: "modebar"
                    },
                    uirevision: {
                        valType: "any",
                        editType: "none"
                    },
                    editType: "plot",
                    _deprecated: {
                        cameraposition: {
                            valType: "info_array",
                            editType: "camera"
                        }
                    }
                };
            },
            64087: function(t1, e1, r) {
                "use strict";
                var n = r(55010), i = [
                    "xaxis",
                    "yaxis",
                    "zaxis"
                ];
                function a() {
                    this.enabled = [
                        !0,
                        !0,
                        !0
                    ], this.colors = [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ]
                    ], this.drawSides = [
                        !0,
                        !0,
                        !0
                    ], this.lineWidth = [
                        1,
                        1,
                        1
                    ];
                }
                a.prototype.merge = function(t1) {
                    for(var e1 = 0; e1 < 3; ++e1){
                        var r = t1[i[e1]];
                        r.visible ? (this.enabled[e1] = r.showspikes, this.colors[e1] = n(r.spikecolor), this.drawSides[e1] = r.spikesides, this.lineWidth[e1] = r.spikethickness) : (this.enabled[e1] = !1, this.drawSides[e1] = !1);
                    }
                }, t1.exports = function(t1) {
                    var e1 = new a;
                    return e1.merge(t1), e1;
                };
            },
            32412: function(t1, e1, r) {
                "use strict";
                t1.exports = function(t1) {
                    for(var e1 = t1.axesOptions, r = t1.glplot.axesPixels, s = t1.fullSceneLayout, l = [
                        [],
                        [],
                        []
                    ], c = 0; c < 3; ++c){
                        var u = s[a[c]];
                        if (u._length = (r[c].hi - r[c].lo) * r[c].pixelsPerDataUnit / t1.dataScale[c], Math.abs(u._length) === 1 / 0 || isNaN(u._length)) l[c] = [];
                        else {
                            u._input_range = u.range.slice(), u.range[0] = r[c].lo / t1.dataScale[c], u.range[1] = r[c].hi / t1.dataScale[c], u._m = 1 / (t1.dataScale[c] * r[c].pixelsPerDataUnit), u.range[0] === u.range[1] && (u.range[0] -= 1, u.range[1] += 1);
                            var h = u.tickmode;
                            if ("auto" === u.tickmode) {
                                u.tickmode = "linear";
                                var f = u.nticks || i.constrain(u._length / 40, 4, 9);
                                n.autoTicks(u, Math.abs(u.range[1] - u.range[0]) / f);
                            }
                            for(var p = n.calcTicks(u, {
                                msUTC: !0
                            }), d = 0; d < p.length; ++d)p[d].x = p[d].x * t1.dataScale[c], "date" === u.type && (p[d].text = p[d].text.replace(/\<br\>/g, " "));
                            l[c] = p, u.tickmode = h;
                        }
                    }
                    for(e1.ticks = l, c = 0; c < 3; ++c)for(o[c] = .5 * (t1.glplot.bounds[0][c] + t1.glplot.bounds[1][c]), d = 0; d < 2; ++d)e1.bounds[d][c] = t1.glplot.bounds[d][c];
                    t1.contourLevels = function(t1) {
                        for(var e1 = new Array(3), r = 0; r < 3; ++r){
                            for(var n = t1[r], i = new Array(n.length), a = 0; a < n.length; ++a)i[a] = n[a].x;
                            e1[r] = i;
                        }
                        return e1;
                    }(l);
                };
                var n = r(29714), i = r(34809), a = [
                    "xaxis",
                    "yaxis",
                    "zaxis"
                ], o = [
                    0,
                    0,
                    0
                ];
            },
            25802: function(t1) {
                "use strict";
                function e1(t1, e1) {
                    var r, n, i = [
                        0,
                        0,
                        0,
                        0
                    ];
                    for(r = 0; r < 4; ++r)for(n = 0; n < 4; ++n)i[n] += t1[4 * r + n] * e1[r];
                    return i;
                }
                t1.exports = function(t1, r) {
                    return e1(t1.projection, e1(t1.view, e1(t1.model, [
                        r[0],
                        r[1],
                        r[2],
                        1
                    ])));
                };
            },
            20299: function(t1, e1, r) {
                "use strict";
                var n, i, a = r(99098).gl_plot3d, o = a.createCamera, s = a.createScene, l = r(22248), c = r(74043), u = r(33626), h = r(34809), f = h.preserveDrawingBuffer(), p = r(29714), d = r(32141), m = r(55010), g = r(97464), y = r(25802), v = r(95701), x = r(64087), _ = r(32412), b = r(32919).applyAutorangeOptions, w = !1;
                function T(t1, e1) {
                    var r = document.createElement("div"), n = t1.container;
                    this.graphDiv = t1.graphDiv;
                    var i = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                    i.style.position = "absolute", i.style.top = i.style.left = "0px", i.style.width = i.style.height = "100%", i.style["z-index"] = 20, i.style["pointer-events"] = "none", r.appendChild(i), this.svgContainer = i, r.id = t1.id, r.style.position = "absolute", r.style.top = r.style.left = "0px", r.style.width = r.style.height = "100%", n.appendChild(r), this.fullLayout = e1, this.id = t1.id || "scene", this.fullSceneLayout = e1[this.id], this.plotArgs = [
                        [],
                        {},
                        {}
                    ], this.axesOptions = v(e1, e1[this.id]), this.spikeOptions = x(e1[this.id]), this.container = r, this.staticMode = !!t1.staticPlot, this.pixelRatio = this.pixelRatio || t1.plotGlPixelRatio || 2, this.dataScale = [
                        1,
                        1,
                        1
                    ], this.contourLevels = [
                        [],
                        [],
                        []
                    ], this.convertAnnotations = u.getComponentMethod("annotations3d", "convert"), this.drawAnnotations = u.getComponentMethod("annotations3d", "draw"), this.initializeGLPlot();
                }
                var k = T.prototype;
                k.prepareOptions = function() {
                    var t1 = this, e1 = {
                        canvas: t1.canvas,
                        gl: t1.gl,
                        glOptions: {
                            preserveDrawingBuffer: f,
                            premultipliedAlpha: !0,
                            antialias: !0
                        },
                        container: t1.container,
                        axes: t1.axesOptions,
                        spikes: t1.spikeOptions,
                        pickRadius: 10,
                        snapToData: !0,
                        autoScale: !0,
                        autoBounds: !1,
                        cameraObject: t1.camera,
                        pixelRatio: t1.pixelRatio
                    };
                    if (t1.staticMode) {
                        if (!(i || (n = document.createElement("canvas"), i = l({
                            canvas: n,
                            preserveDrawingBuffer: !0,
                            premultipliedAlpha: !0,
                            antialias: !0
                        })))) throw new Error("error creating static canvas/context for image server");
                        e1.gl = i, e1.canvas = n;
                    }
                    return e1;
                };
                var A = !0;
                k.tryCreatePlot = function() {
                    var t1 = this, e1 = t1.prepareOptions(), r = !0;
                    try {
                        t1.glplot = s(e1);
                    } catch (n) {
                        if (t1.staticMode || !A || f) r = !1;
                        else {
                            h.warn([
                                "webgl setup failed possibly due to",
                                "false preserveDrawingBuffer config.",
                                "The mobile/tablet device may not be detected by is-mobile module.",
                                "Enabling preserveDrawingBuffer in second attempt to create webgl scene..."
                            ].join(" "));
                            try {
                                f = e1.glOptions.preserveDrawingBuffer = !0, t1.glplot = s(e1);
                            } catch (t1) {
                                f = e1.glOptions.preserveDrawingBuffer = !1, r = !1;
                            }
                        }
                    }
                    return A = !1, r;
                }, k.initializeGLCamera = function() {
                    var t1 = this, e1 = t1.fullSceneLayout.camera, r = "orthographic" === e1.projection.type;
                    t1.camera = o(t1.container, {
                        center: [
                            e1.center.x,
                            e1.center.y,
                            e1.center.z
                        ],
                        eye: [
                            e1.eye.x,
                            e1.eye.y,
                            e1.eye.z
                        ],
                        up: [
                            e1.up.x,
                            e1.up.y,
                            e1.up.z
                        ],
                        _ortho: r,
                        zoomMin: .01,
                        zoomMax: 100,
                        mode: "orbit"
                    });
                }, k.initializeGLPlot = function() {
                    var t1 = this;
                    if (t1.initializeGLCamera(), !t1.tryCreatePlot()) return g(t1);
                    t1.traces = {}, t1.make4thDimension();
                    var e1 = t1.graphDiv, r = e1.layout, n = function() {
                        var e1 = {};
                        return t1.isCameraChanged(r) && (e1[t1.id + ".camera"] = t1.getCamera()), t1.isAspectChanged(r) && (e1[t1.id + ".aspectratio"] = t1.glplot.getAspectratio(), "manual" !== r[t1.id].aspectmode && (t1.fullSceneLayout.aspectmode = r[t1.id].aspectmode = e1[t1.id + ".aspectmode"] = "manual")), e1;
                    }, i = function(t1) {
                        if (!1 !== t1.fullSceneLayout.dragmode) {
                            var e1 = n();
                            t1.saveLayout(r), t1.graphDiv.emit("plotly_relayout", e1);
                        }
                    };
                    return t1.glplot.canvas && (t1.glplot.canvas.addEventListener("mouseup", function() {
                        i(t1);
                    }), t1.glplot.canvas.addEventListener("touchstart", function() {
                        w = !0;
                    }), t1.glplot.canvas.addEventListener("wheel", function(r) {
                        if (e1._context._scrollZoom.gl3d) {
                            if (t1.camera._ortho) {
                                var n = r.deltaX > r.deltaY ? 1.1 : 1 / 1.1, a = t1.glplot.getAspectratio();
                                t1.glplot.setAspectratio({
                                    x: n * a.x,
                                    y: n * a.y,
                                    z: n * a.z
                                });
                            }
                            i(t1);
                        }
                    }, !!c && {
                        passive: !1
                    }), t1.glplot.canvas.addEventListener("mousemove", function() {
                        if (!1 !== t1.fullSceneLayout.dragmode && 0 !== t1.camera.mouseListener.buttons) {
                            var e1 = n();
                            t1.graphDiv.emit("plotly_relayouting", e1);
                        }
                    }), t1.staticMode || t1.glplot.canvas.addEventListener("webglcontextlost", function(r) {
                        e1 && e1.emit && e1.emit("plotly_webglcontextlost", {
                            event: r,
                            layer: t1.id
                        });
                    }, !1)), t1.glplot.oncontextloss = function() {
                        t1.recoverContext();
                    }, t1.glplot.onrender = function() {
                        t1.render();
                    }, !0;
                }, k.render = function() {
                    var t1, e1 = this, r = e1.graphDiv, n = e1.svgContainer, i = e1.container.getBoundingClientRect();
                    r._fullLayout._calcInverseTransform(r);
                    var a = r._fullLayout._invScaleX, o = r._fullLayout._invScaleY, s = i.width * a, l = i.height * o;
                    n.setAttributeNS(null, "viewBox", "0 0 " + s + " " + l), n.setAttributeNS(null, "width", s), n.setAttributeNS(null, "height", l), _(e1), e1.glplot.axes.update(e1.axesOptions);
                    for(var c = Object.keys(e1.traces), u = null, f = e1.glplot.selection, m = 0; m < c.length; ++m)"skip" !== (t1 = e1.traces[c[m]]).data.hoverinfo && t1.handlePick(f) && (u = t1), t1.setContourLevels && t1.setContourLevels();
                    function g(t1, r, n) {
                        var i = e1.fullSceneLayout[t1 + "axis"];
                        return "log" !== i.type && (r = i.d2l(r)), p.hoverLabelText(i, r, n);
                    }
                    if (null !== u) {
                        var v = y(e1.glplot.cameraParams, f.dataCoordinate);
                        t1 = u.data;
                        var x, b = r._fullData[t1.index], T = f.index, k = {
                            xLabel: g("x", f.traceCoordinate[0], t1.xhoverformat),
                            yLabel: g("y", f.traceCoordinate[1], t1.yhoverformat),
                            zLabel: g("z", f.traceCoordinate[2], t1.zhoverformat)
                        }, A = d.castHoverinfo(b, e1.fullLayout, T), M = (A || "").split("+"), S = A && "all" === A;
                        b.hovertemplate || S || (-1 === M.indexOf("x") && (k.xLabel = void 0), -1 === M.indexOf("y") && (k.yLabel = void 0), -1 === M.indexOf("z") && (k.zLabel = void 0), -1 === M.indexOf("text") && (f.textLabel = void 0), -1 === M.indexOf("name") && (u.name = void 0));
                        var E = [];
                        "cone" === t1.type || "streamtube" === t1.type ? (k.uLabel = g("x", f.traceCoordinate[3], t1.uhoverformat), (S || -1 !== M.indexOf("u")) && E.push("u: " + k.uLabel), k.vLabel = g("y", f.traceCoordinate[4], t1.vhoverformat), (S || -1 !== M.indexOf("v")) && E.push("v: " + k.vLabel), k.wLabel = g("z", f.traceCoordinate[5], t1.whoverformat), (S || -1 !== M.indexOf("w")) && E.push("w: " + k.wLabel), k.normLabel = f.traceCoordinate[6].toPrecision(3), (S || -1 !== M.indexOf("norm")) && E.push("norm: " + k.normLabel), "streamtube" === t1.type && (k.divergenceLabel = f.traceCoordinate[7].toPrecision(3), (S || -1 !== M.indexOf("divergence")) && E.push("divergence: " + k.divergenceLabel)), f.textLabel && E.push(f.textLabel), x = E.join("<br>")) : "isosurface" === t1.type || "volume" === t1.type ? (k.valueLabel = p.hoverLabelText(e1._mockAxis, e1._mockAxis.d2l(f.traceCoordinate[3]), t1.valuehoverformat), E.push("value: " + k.valueLabel), f.textLabel && E.push(f.textLabel), x = E.join("<br>")) : x = f.textLabel;
                        var C = {
                            x: f.traceCoordinate[0],
                            y: f.traceCoordinate[1],
                            z: f.traceCoordinate[2],
                            data: b._input,
                            fullData: b,
                            curveNumber: b.index,
                            pointNumber: T
                        };
                        d.appendArrayPointValue(C, b, T), t1._module.eventData && (C = b._module.eventData(C, f, b, {}, T));
                        var L = {
                            points: [
                                C
                            ]
                        };
                        if (e1.fullSceneLayout.hovermode) {
                            var I = [];
                            d.loneHover({
                                trace: b,
                                x: (.5 + .5 * v[0] / v[3]) * s,
                                y: (.5 - .5 * v[1] / v[3]) * l,
                                xLabel: k.xLabel,
                                yLabel: k.yLabel,
                                zLabel: k.zLabel,
                                text: x,
                                name: u.name,
                                color: d.castHoverOption(b, T, "bgcolor") || u.color,
                                borderColor: d.castHoverOption(b, T, "bordercolor"),
                                fontFamily: d.castHoverOption(b, T, "font.family"),
                                fontSize: d.castHoverOption(b, T, "font.size"),
                                fontColor: d.castHoverOption(b, T, "font.color"),
                                nameLength: d.castHoverOption(b, T, "namelength"),
                                textAlign: d.castHoverOption(b, T, "align"),
                                hovertemplate: h.castOption(b, T, "hovertemplate"),
                                hovertemplateLabels: h.extendFlat({}, C, k),
                                eventData: [
                                    C
                                ]
                            }, {
                                container: n,
                                gd: r,
                                inOut_bbox: I
                            }), C.bbox = I[0];
                        }
                        f.distance < 5 && (f.buttons || w) ? r.emit("plotly_click", L) : r.emit("plotly_hover", L), this.oldEventData = L;
                    } else d.loneUnhover(n), this.oldEventData && r.emit("plotly_unhover", this.oldEventData), this.oldEventData = void 0;
                    e1.drawAnnotations(e1);
                }, k.recoverContext = function() {
                    var t1 = this;
                    t1.glplot.dispose();
                    var e1 = function() {
                        t1.glplot.gl.isContextLost() ? requestAnimationFrame(e1) : t1.initializeGLPlot() ? t1.plot.apply(t1, t1.plotArgs) : h.error("Catastrophic and unrecoverable WebGL error. Context lost.");
                    };
                    requestAnimationFrame(e1);
                };
                var M = [
                    "xaxis",
                    "yaxis",
                    "zaxis"
                ];
                function S(t1, e1, r) {
                    for(var n = t1.fullSceneLayout, i = 0; i < 3; i++){
                        var a = M[i], o = a.charAt(0), s = n[a], l = e1[o], c = e1[o + "calendar"], u = e1["_" + o + "length"];
                        if (h.isArrayOrTypedArray(l)) for(var f, p = 0; p < (u || l.length); p++)if (h.isArrayOrTypedArray(l[p])) for(var d = 0; d < l[p].length; ++d)f = s.d2l(l[p][d], 0, c), !isNaN(f) && isFinite(f) && (r[0][i] = Math.min(r[0][i], f), r[1][i] = Math.max(r[1][i], f));
                        else f = s.d2l(l[p], 0, c), !isNaN(f) && isFinite(f) && (r[0][i] = Math.min(r[0][i], f), r[1][i] = Math.max(r[1][i], f));
                        else r[0][i] = Math.min(r[0][i], 0), r[1][i] = Math.max(r[1][i], u - 1);
                    }
                }
                k.plot = function(t1, e1, r) {
                    var n = this;
                    if (n.plotArgs = [
                        t1,
                        e1,
                        r
                    ], !n.glplot.contextLost) {
                        var i, a, o, s, l, c, u = e1[n.id], h = r[n.id];
                        n.fullLayout = e1, n.fullSceneLayout = u, n.axesOptions.merge(e1, u), n.spikeOptions.merge(u), n.setViewport(u), n.updateFx(u.dragmode, u.hovermode), n.camera.enableWheel = n.graphDiv._context._scrollZoom.gl3d, n.glplot.setClearColor(m(u.bgcolor)), n.setConvert(l), t1 ? Array.isArray(t1) || (t1 = [
                            t1
                        ]) : t1 = [];
                        var f = [
                            [
                                1 / 0,
                                1 / 0,
                                1 / 0
                            ],
                            [
                                -1 / 0,
                                -1 / 0,
                                -1 / 0
                            ]
                        ];
                        for(o = 0; o < t1.length; ++o)!0 === (i = t1[o]).visible && 0 !== i._length && S(this, i, f);
                        !function(t1, e1) {
                            for(var r = t1.fullSceneLayout, n = r.annotations || [], i = 0; i < 3; i++)for(var a = M[i], o = a.charAt(0), s = r[a], l = 0; l < n.length; l++){
                                var c = n[l];
                                if (c.visible) {
                                    var u = s.r2l(c[o]);
                                    !isNaN(u) && isFinite(u) && (e1[0][i] = Math.min(e1[0][i], u), e1[1][i] = Math.max(e1[1][i], u));
                                }
                            }
                        }(this, f);
                        var p = [
                            1,
                            1,
                            1
                        ];
                        for(s = 0; s < 3; ++s)f[1][s] === f[0][s] ? p[s] = 1 : p[s] = 1 / (f[1][s] - f[0][s]);
                        for(n.dataScale = p, n.convertAnnotations(this), o = 0; o < t1.length; ++o)!0 === (i = t1[o]).visible && 0 !== i._length && ((a = n.traces[i.uid]) ? a.data.type === i.type ? a.update(i) : (a.dispose(), a = i._module.plot(this, i), n.traces[i.uid] = a) : (a = i._module.plot(this, i), n.traces[i.uid] = a), a.name = i.name);
                        var d = Object.keys(n.traces);
                        t: for(o = 0; o < d.length; ++o){
                            for(s = 0; s < t1.length; ++s)if (t1[s].uid === d[o] && !0 === t1[s].visible && 0 !== t1[s]._length) continue t;
                            (a = n.traces[d[o]]).dispose(), delete n.traces[d[o]];
                        }
                        n.glplot.objects.sort(function(t1, e1) {
                            return t1._trace.data.index - e1._trace.data.index;
                        });
                        var g, y = [
                            [
                                0,
                                0,
                                0
                            ],
                            [
                                0,
                                0,
                                0
                            ]
                        ], v = [], x = {};
                        for(o = 0; o < 3; ++o){
                            var _;
                            if ((c = (l = u[M[o]]).type) in x ? (x[c].acc *= p[o], x[c].count += 1) : x[c] = {
                                acc: p[o],
                                count: 1
                            }, l.autorange) {
                                y[0][o] = 1 / 0, y[1][o] = -1 / 0;
                                var w = n.glplot.objects, T = n.fullSceneLayout.annotations || [], k = l._name.charAt(0);
                                for(s = 0; s < w.length; s++){
                                    var A = w[s], E = A.bounds, C = A._trace.data._pad || 0;
                                    "ErrorBars" === A.constructor.name && l._lowerLogErrorBound ? y[0][o] = Math.min(y[0][o], l._lowerLogErrorBound) : y[0][o] = Math.min(y[0][o], E[0][o] / p[o] - C), y[1][o] = Math.max(y[1][o], E[1][o] / p[o] + C);
                                }
                                for(s = 0; s < T.length; s++){
                                    var L = T[s];
                                    if (L.visible) {
                                        var I = l.r2l(L[k]);
                                        y[0][o] = Math.min(y[0][o], I), y[1][o] = Math.max(y[1][o], I);
                                    }
                                }
                                if ("rangemode" in l && "tozero" === l.rangemode && (y[0][o] = Math.min(y[0][o], 0), y[1][o] = Math.max(y[1][o], 0)), y[0][o] > y[1][o]) y[0][o] = -1, y[1][o] = 1;
                                else {
                                    var P = y[1][o] - y[0][o];
                                    y[0][o] -= P / 32, y[1][o] += P / 32;
                                }
                                if (_ = [
                                    y[0][o],
                                    y[1][o]
                                ], _ = b(_, l), y[0][o] = _[0], y[1][o] = _[1], l.isReversed()) {
                                    var z = y[0][o];
                                    y[0][o] = y[1][o], y[1][o] = z;
                                }
                            } else _ = l.range, y[0][o] = l.r2l(_[0]), y[1][o] = l.r2l(_[1]);
                            y[0][o] === y[1][o] && (y[0][o] -= 1, y[1][o] += 1), v[o] = y[1][o] - y[0][o], l.range = [
                                y[0][o],
                                y[1][o]
                            ], l.limitRange(), n.glplot.setBounds(o, {
                                min: l.range[0] * p[o],
                                max: l.range[1] * p[o]
                            });
                        }
                        var O = u.aspectmode;
                        if ("cube" === O) g = [
                            1,
                            1,
                            1
                        ];
                        else if ("manual" === O) {
                            var D = u.aspectratio;
                            g = [
                                D.x,
                                D.y,
                                D.z
                            ];
                        } else {
                            if ("auto" !== O && "data" !== O) throw new Error("scene.js aspectRatio was not one of the enumerated types");
                            var R = [
                                1,
                                1,
                                1
                            ];
                            for(o = 0; o < 3; ++o){
                                var F = x[c = (l = u[M[o]]).type];
                                R[o] = Math.pow(F.acc, 1 / F.count) / p[o];
                            }
                            g = "data" === O || Math.max.apply(null, R) / Math.min.apply(null, R) <= 4 ? R : [
                                1,
                                1,
                                1
                            ];
                        }
                        u.aspectratio.x = h.aspectratio.x = g[0], u.aspectratio.y = h.aspectratio.y = g[1], u.aspectratio.z = h.aspectratio.z = g[2], n.glplot.setAspectratio(u.aspectratio), n.viewInitial.aspectratio || (n.viewInitial.aspectratio = {
                            x: u.aspectratio.x,
                            y: u.aspectratio.y,
                            z: u.aspectratio.z
                        }), n.viewInitial.aspectmode || (n.viewInitial.aspectmode = u.aspectmode);
                        var B = u.domain || null, N = e1._size || null;
                        if (B && N) {
                            var j = n.container.style;
                            j.position = "absolute", j.left = N.l + B.x[0] * N.w + "px", j.top = N.t + (1 - B.y[1]) * N.h + "px", j.width = N.w * (B.x[1] - B.x[0]) + "px", j.height = N.h * (B.y[1] - B.y[0]) + "px";
                        }
                        n.glplot.redraw();
                    }
                }, k.destroy = function() {
                    var t1 = this;
                    t1.glplot && (t1.camera.mouseListener.enabled = !1, t1.container.removeEventListener("wheel", t1.camera.wheelListener), t1.camera = null, t1.glplot.dispose(), t1.container.parentNode.removeChild(t1.container), t1.glplot = null);
                }, k.getCamera = function() {
                    var t1, e1 = this;
                    return e1.camera.view.recalcMatrix(e1.camera.view.lastT()), {
                        up: {
                            x: (t1 = e1.camera).up[0],
                            y: t1.up[1],
                            z: t1.up[2]
                        },
                        center: {
                            x: t1.center[0],
                            y: t1.center[1],
                            z: t1.center[2]
                        },
                        eye: {
                            x: t1.eye[0],
                            y: t1.eye[1],
                            z: t1.eye[2]
                        },
                        projection: {
                            type: !0 === t1._ortho ? "orthographic" : "perspective"
                        }
                    };
                }, k.setViewport = function(t1) {
                    var e1, r = this, n = t1.camera;
                    r.camera.lookAt.apply(this, [
                        [
                            (e1 = n).eye.x,
                            e1.eye.y,
                            e1.eye.z
                        ],
                        [
                            e1.center.x,
                            e1.center.y,
                            e1.center.z
                        ],
                        [
                            e1.up.x,
                            e1.up.y,
                            e1.up.z
                        ]
                    ]), r.glplot.setAspectratio(t1.aspectratio), "orthographic" === n.projection.type !== r.camera._ortho && (r.glplot.redraw(), r.glplot.clearRGBA(), r.glplot.dispose(), r.initializeGLPlot());
                }, k.isCameraChanged = function(t1) {
                    var e1 = this.getCamera(), r = h.nestedProperty(t1, this.id + ".camera").get();
                    function n(t1, e1, r, n) {
                        var i = [
                            "up",
                            "center",
                            "eye"
                        ], a = [
                            "x",
                            "y",
                            "z"
                        ];
                        return e1[i[r]] && t1[i[r]][a[n]] === e1[i[r]][a[n]];
                    }
                    var i = !1;
                    if (void 0 === r) i = !0;
                    else {
                        for(var a = 0; a < 3; a++)for(var o = 0; o < 3; o++)if (!n(e1, r, a, o)) {
                            i = !0;
                            break;
                        }
                        (!r.projection || e1.projection && e1.projection.type !== r.projection.type) && (i = !0);
                    }
                    return i;
                }, k.isAspectChanged = function(t1) {
                    var e1 = this.glplot.getAspectratio(), r = h.nestedProperty(t1, this.id + ".aspectratio").get();
                    return void 0 === r || r.x !== e1.x || r.y !== e1.y || r.z !== e1.z;
                }, k.saveLayout = function(t1) {
                    var e1, r, n, i, a, o, s = this, l = s.fullLayout, c = s.isCameraChanged(t1), f = s.isAspectChanged(t1), p = c || f;
                    if (p) {
                        var d = {};
                        c && (e1 = s.getCamera(), n = (r = h.nestedProperty(t1, s.id + ".camera")).get(), d[s.id + ".camera"] = n), f && (i = s.glplot.getAspectratio(), o = (a = h.nestedProperty(t1, s.id + ".aspectratio")).get(), d[s.id + ".aspectratio"] = o), u.call("_storeDirectGUIEdit", t1, l._preGUI, d), c && (r.set(e1), h.nestedProperty(l, s.id + ".camera").set(e1)), f && (a.set(i), h.nestedProperty(l, s.id + ".aspectratio").set(i), s.glplot.redraw());
                    }
                    return p;
                }, k.updateFx = function(t1, e1) {
                    var r = this, n = r.camera;
                    if (n) {
                        if ("orbit" === t1) n.mode = "orbit", n.keyBindingMode = "rotate";
                        else if ("turntable" === t1) {
                            n.up = [
                                0,
                                0,
                                1
                            ], n.mode = "turntable", n.keyBindingMode = "rotate";
                            var i = r.graphDiv, a = i._fullLayout, o = r.fullSceneLayout.camera, s = o.up.x, l = o.up.y, c = o.up.z;
                            if (c / Math.sqrt(s * s + l * l + c * c) < .999) {
                                var f = r.id + ".camera.up", p = {
                                    x: 0,
                                    y: 0,
                                    z: 1
                                }, d = {};
                                d[f] = p;
                                var m = i.layout;
                                u.call("_storeDirectGUIEdit", m, a._preGUI, d), o.up = p, h.nestedProperty(m, f).set(p);
                            }
                        } else n.keyBindingMode = t1;
                    }
                    r.fullSceneLayout.hovermode = e1;
                }, k.toImage = function(t1) {
                    var e1 = this;
                    t1 || (t1 = "png"), e1.staticMode && e1.container.appendChild(n), e1.glplot.redraw();
                    var r = e1.glplot.gl, i = r.drawingBufferWidth, a = r.drawingBufferHeight;
                    r.bindFramebuffer(r.FRAMEBUFFER, null);
                    var o = new Uint8Array(i * a * 4);
                    r.readPixels(0, 0, i, a, r.RGBA, r.UNSIGNED_BYTE, o), function(t1, e1, r) {
                        for(var n = 0, i = r - 1; n < i; ++n, --i)for(var a = 0; a < e1; ++a)for(var o = 0; o < 4; ++o){
                            var s = 4 * (e1 * n + a) + o, l = 4 * (e1 * i + a) + o, c = t1[s];
                            t1[s] = t1[l], t1[l] = c;
                        }
                    }(o, i, a), function(t1, e1, r) {
                        for(var n = 0; n < r; ++n)for(var i = 0; i < e1; ++i){
                            var a = 4 * (e1 * n + i), o = t1[a + 3];
                            if (o > 0) for(var s = 255 / o, l = 0; l < 3; ++l)t1[a + l] = Math.min(s * t1[a + l], 255);
                        }
                    }(o, i, a);
                    var s = document.createElement("canvas");
                    s.width = i, s.height = a;
                    var l, c = s.getContext("2d", {
                        willReadFrequently: !0
                    }), u = c.createImageData(i, a);
                    switch(u.data.set(o), c.putImageData(u, 0, 0), t1){
                        case "jpeg":
                            l = s.toDataURL("image/jpeg");
                            break;
                        case "webp":
                            l = s.toDataURL("image/webp");
                            break;
                        default:
                            l = s.toDataURL("image/png");
                    }
                    return e1.staticMode && e1.container.removeChild(n), l;
                }, k.setConvert = function() {
                    for(var t1 = 0; t1 < 3; t1++){
                        var e1 = this.fullSceneLayout[M[t1]];
                        p.setConvert(e1, this.fullLayout), e1.setScale = h.noop;
                    }
                }, k.make4thDimension = function() {
                    var t1 = this, e1 = t1.graphDiv._fullLayout;
                    t1._mockAxis = {
                        type: "linear",
                        showexponent: "all",
                        exponentformat: "B"
                    }, p.setConvert(t1._mockAxis, e1);
                }, t1.exports = T;
            },
            88239: function(t1) {
                "use strict";
                t1.exports = function(t1, e1, r, n) {
                    n = n || t1.length;
                    for(var i = new Array(n), a = 0; a < n; a++)i[a] = [
                        t1[a],
                        e1[a],
                        r[a]
                    ];
                    return i;
                };
            },
            6704: function(t1, e1, r) {
                "use strict";
                var n = r(80337), i = r(49722), a = r(10229), o = r(64101), s = r(52307), l = r(57891), c = r(93049).extendFlat, u = n({
                    editType: "calc"
                });
                u.family.dflt = '"Open Sans", verdana, arial, sans-serif', u.size.dflt = 12, u.color.dflt = a.defaultLine, t1.exports = {
                    font: u,
                    title: {
                        text: {
                            valType: "string",
                            editType: "layoutstyle"
                        },
                        font: n({
                            editType: "layoutstyle"
                        }),
                        subtitle: {
                            text: {
                                valType: "string",
                                editType: "layoutstyle"
                            },
                            font: n({
                                editType: "layoutstyle"
                            }),
                            editType: "layoutstyle"
                        },
                        xref: {
                            valType: "enumerated",
                            dflt: "container",
                            values: [
                                "container",
                                "paper"
                            ],
                            editType: "layoutstyle"
                        },
                        yref: {
                            valType: "enumerated",
                            dflt: "container",
                            values: [
                                "container",
                                "paper"
                            ],
                            editType: "layoutstyle"
                        },
                        x: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: .5,
                            editType: "layoutstyle"
                        },
                        y: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: "auto",
                            editType: "layoutstyle"
                        },
                        xanchor: {
                            valType: "enumerated",
                            dflt: "auto",
                            values: [
                                "auto",
                                "left",
                                "center",
                                "right"
                            ],
                            editType: "layoutstyle"
                        },
                        yanchor: {
                            valType: "enumerated",
                            dflt: "auto",
                            values: [
                                "auto",
                                "top",
                                "middle",
                                "bottom"
                            ],
                            editType: "layoutstyle"
                        },
                        pad: c(l({
                            editType: "layoutstyle"
                        }), {}),
                        automargin: {
                            valType: "boolean",
                            dflt: !1,
                            editType: "plot"
                        },
                        editType: "layoutstyle"
                    },
                    uniformtext: {
                        mode: {
                            valType: "enumerated",
                            values: [
                                !1,
                                "hide",
                                "show"
                            ],
                            dflt: !1,
                            editType: "plot"
                        },
                        minsize: {
                            valType: "number",
                            min: 0,
                            dflt: 0,
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    autosize: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "none"
                    },
                    width: {
                        valType: "number",
                        min: 10,
                        dflt: 700,
                        editType: "plot"
                    },
                    height: {
                        valType: "number",
                        min: 10,
                        dflt: 450,
                        editType: "plot"
                    },
                    minreducedwidth: {
                        valType: "number",
                        min: 2,
                        dflt: 64,
                        editType: "plot"
                    },
                    minreducedheight: {
                        valType: "number",
                        min: 2,
                        dflt: 64,
                        editType: "plot"
                    },
                    margin: {
                        l: {
                            valType: "number",
                            min: 0,
                            dflt: 80,
                            editType: "plot"
                        },
                        r: {
                            valType: "number",
                            min: 0,
                            dflt: 80,
                            editType: "plot"
                        },
                        t: {
                            valType: "number",
                            min: 0,
                            dflt: 100,
                            editType: "plot"
                        },
                        b: {
                            valType: "number",
                            min: 0,
                            dflt: 80,
                            editType: "plot"
                        },
                        pad: {
                            valType: "number",
                            min: 0,
                            dflt: 0,
                            editType: "plot"
                        },
                        autoexpand: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    computed: {
                        valType: "any",
                        editType: "none"
                    },
                    paper_bgcolor: {
                        valType: "color",
                        dflt: a.background,
                        editType: "plot"
                    },
                    plot_bgcolor: {
                        valType: "color",
                        dflt: a.background,
                        editType: "layoutstyle"
                    },
                    autotypenumbers: {
                        valType: "enumerated",
                        values: [
                            "convert types",
                            "strict"
                        ],
                        dflt: "convert types",
                        editType: "calc"
                    },
                    separators: {
                        valType: "string",
                        editType: "plot"
                    },
                    hidesources: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "plot"
                    },
                    showlegend: {
                        valType: "boolean",
                        editType: "legend"
                    },
                    colorway: {
                        valType: "colorlist",
                        dflt: a.defaults,
                        editType: "calc"
                    },
                    datarevision: {
                        valType: "any",
                        editType: "calc"
                    },
                    uirevision: {
                        valType: "any",
                        editType: "none"
                    },
                    editrevision: {
                        valType: "any",
                        editType: "none"
                    },
                    selectionrevision: {
                        valType: "any",
                        editType: "none"
                    },
                    template: {
                        valType: "any",
                        editType: "calc"
                    },
                    newshape: o.newshape,
                    activeshape: o.activeshape,
                    newselection: s.newselection,
                    activeselection: s.activeselection,
                    meta: {
                        valType: "any",
                        arrayOk: !0,
                        editType: "plot"
                    },
                    transition: c({}, i.transition, {
                        editType: "none"
                    }),
                    _deprecated: {
                        title: {
                            valType: "string",
                            editType: "layoutstyle"
                        },
                        titlefont: n({
                            editType: "layoutstyle"
                        })
                    }
                };
            },
            8814: function(t1, e1, r) {
                "use strict";
                var n = r(62994), i = r(37071), a = "https://basemaps.cartocdn.com/gl/positron-gl-style/style.json", o = "https://basemaps.cartocdn.com/gl/dark-matter-gl-style/style.json", s = "https://basemaps.cartocdn.com/gl/voyager-gl-style/style.json", l = {
                    basic: s,
                    streets: s,
                    outdoors: s,
                    light: a,
                    dark: o,
                    satellite: r(51962),
                    "satellite-streets": i,
                    "open-street-map": {
                        id: "osm",
                        version: 8,
                        sources: {
                            "plotly-osm-tiles": {
                                type: "raster",
                                attribution: '\xa9 <a target="_blank" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                                tiles: [
                                    "https://tile.openstreetmap.org/{z}/{x}/{y}.png"
                                ],
                                tileSize: 256
                            }
                        },
                        layers: [
                            {
                                id: "plotly-osm-tiles",
                                type: "raster",
                                source: "plotly-osm-tiles",
                                minzoom: 0,
                                maxzoom: 22
                            }
                        ],
                        glyphs: "https://fonts.openmaptiles.org/{fontstack}/{range}.pbf"
                    },
                    "white-bg": {
                        id: "white-bg",
                        version: 8,
                        sources: {},
                        layers: [
                            {
                                id: "white-bg",
                                type: "background",
                                paint: {
                                    "background-color": "#FFFFFF"
                                },
                                minzoom: 0,
                                maxzoom: 22
                            }
                        ],
                        glyphs: "https://fonts.openmaptiles.org/{fontstack}/{range}.pbf"
                    },
                    "carto-positron": a,
                    "carto-darkmatter": o,
                    "carto-voyager": s,
                    "carto-positron-nolabels": "https://basemaps.cartocdn.com/gl/positron-nolabels-gl-style/style.json",
                    "carto-darkmatter-nolabels": "https://basemaps.cartocdn.com/gl/dark-matter-nolabels-gl-style/style.json",
                    "carto-voyager-nolabels": "https://basemaps.cartocdn.com/gl/voyager-nolabels-gl-style/style.json"
                }, c = n(l);
                t1.exports = {
                    styleValueDflt: "basic",
                    stylesMap: l,
                    styleValuesMap: c,
                    traceLayerPrefix: "plotly-trace-layer-",
                    layoutLayerPrefix: "plotly-layout-layer-",
                    missingStyleErrorMsg: [
                        "No valid maplibre style found, please set `map.style` to one of:",
                        c.join(", "),
                        "or use a tile service."
                    ].join("\n"),
                    mapOnErrorMsg: "Map error."
                };
            },
            4657: function(t1, e1, r) {
                "use strict";
                var n = r(34809);
                t1.exports = function(t1, e1) {
                    var r = t1.split(" "), i = r[0], a = r[1], o = n.isArrayOrTypedArray(e1) ? n.mean(e1) : e1, s = .5 + o / 100, l = 1.5 + o / 100, c = [
                        "",
                        ""
                    ], u = [
                        0,
                        0
                    ];
                    switch(i){
                        case "top":
                            c[0] = "top", u[1] = -l;
                            break;
                        case "bottom":
                            c[0] = "bottom", u[1] = l;
                    }
                    switch(a){
                        case "left":
                            c[1] = "right", u[0] = -s;
                            break;
                        case "right":
                            c[1] = "left", u[0] = s;
                    }
                    return {
                        anchor: c[0] && c[1] ? c.join("-") : c[0] ? c[0] : c[1] ? c[1] : "center",
                        offset: u
                    };
                };
            },
            34091: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = n.strTranslate, a = n.strScale, o = r(4173).fX, s = r(62972), l = r(45568), c = r(62203), u = r(30635), h = r(38793), f = "map";
                e1.name = f, e1.attr = "subplot", e1.idRoot = f, e1.idRegex = e1.attrRegex = n.counterRegex(f), e1.attributes = {
                    subplot: {
                        valType: "subplotid",
                        dflt: "map",
                        editType: "calc"
                    }
                }, e1.layoutAttributes = r(8257), e1.supplyLayoutDefaults = r(97446), e1.plot = function(t1) {
                    for(var e1 = t1._fullLayout, r = t1.calcdata, i = e1._subplots[f], a = 0; a < i.length; a++){
                        var s = i[a], l = o(r, f, s), c = e1[s], u = c._subplot;
                        u || (u = new h(t1, s), e1[s]._subplot = u), u.viewInitial || (u.viewInitial = {
                            center: n.extendFlat({}, c.center),
                            zoom: c.zoom,
                            bearing: c.bearing,
                            pitch: c.pitch
                        }), u.plot(l, e1, t1._promises);
                    }
                }, e1.clean = function(t1, e1, r, n) {
                    for(var i = n._subplots[f] || [], a = 0; a < i.length; a++){
                        var o = i[a];
                        !e1[o] && n[o]._subplot && n[o]._subplot.destroy();
                    }
                }, e1.toSVG = function(t1) {
                    for(var e1 = t1._fullLayout, r = e1._subplots[f], n = e1._size, o = 0; o < r.length; o++){
                        var h = e1[r[o]], p = h.domain, d = h._subplot.toImage("png");
                        e1._glimages.append("svg:image").attr({
                            xmlns: s.svg,
                            "xlink:href": d,
                            x: n.l + n.w * p.x[0],
                            y: n.t + n.h * (1 - p.y[1]),
                            width: n.w * (p.x[1] - p.x[0]),
                            height: n.h * (p.y[1] - p.y[0]),
                            preserveAspectRatio: "none"
                        });
                        var m = l.select(h._subplot.div).select(".maplibregl-ctrl-attrib").text().replace("Improve this map", ""), g = e1._glimages.append("g"), y = g.append("text");
                        y.text(m).classed("static-attribution", !0).attr({
                            "font-size": 12,
                            "font-family": "Arial",
                            color: "rgba(0, 0, 0, 0.75)",
                            "text-anchor": "end",
                            "data-unformatted": m
                        });
                        var v = c.bBox(y.node()), x = n.w * (p.x[1] - p.x[0]);
                        if (v.width > x / 2) {
                            var _ = m.split("|").join("<br>");
                            y.text(_).attr("data-unformatted", _).call(u.convertToTspans, t1), v = c.bBox(y.node());
                        }
                        y.attr("transform", i(-3, 8 - v.height)), g.insert("rect", ".static-attribution").attr({
                            x: -v.width - 6,
                            y: -v.height - 3,
                            width: v.width + 6,
                            height: v.height + 3,
                            fill: "rgba(255, 255, 255, 0.75)"
                        });
                        var b = 1;
                        v.width + 6 > x && (b = x / (v.width + 6));
                        var w = [
                            n.l + n.w * p.x[1],
                            n.t + n.h * (1 - p.y[0])
                        ];
                        g.attr("transform", i(w[0], w[1]) + a(b));
                    }
                }, e1.updateFx = function(t1) {
                    for(var e1 = t1._fullLayout, r = e1._subplots[f], n = 0; n < r.length; n++)e1[r[n]]._subplot.updateFx(e1);
                };
            },
            33389: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(30635).sanitizeHTML, a = r(4657), o = r(8814);
                function s(t1, e1) {
                    this.subplot = t1, this.uid = t1.uid + "-" + e1, this.index = e1, this.idSource = "source-" + this.uid, this.idLayer = o.layoutLayerPrefix + this.uid, this.sourceType = null, this.source = null, this.layerType = null, this.below = null, this.visible = !1;
                }
                var l = s.prototype;
                function c(t1) {
                    if (!t1.visible) return !1;
                    var e1 = t1.source;
                    if (Array.isArray(e1) && e1.length > 0) {
                        for(var r = 0; r < e1.length; r++)if ("string" != typeof e1[r] || 0 === e1[r].length) return !1;
                        return !0;
                    }
                    return n.isPlainObject(e1) || "string" == typeof e1 && e1.length > 0;
                }
                function u(t1) {
                    var e1 = {}, r = {};
                    switch(t1.type){
                        case "circle":
                            n.extendFlat(r, {
                                "circle-radius": t1.circle.radius,
                                "circle-color": t1.color,
                                "circle-opacity": t1.opacity
                            });
                            break;
                        case "line":
                            n.extendFlat(r, {
                                "line-width": t1.line.width,
                                "line-color": t1.color,
                                "line-opacity": t1.opacity,
                                "line-dasharray": t1.line.dash
                            });
                            break;
                        case "fill":
                            n.extendFlat(r, {
                                "fill-color": t1.color,
                                "fill-outline-color": t1.fill.outlinecolor,
                                "fill-opacity": t1.opacity
                            });
                            break;
                        case "symbol":
                            var i = t1.symbol, o = a(i.textposition, i.iconsize);
                            n.extendFlat(e1, {
                                "icon-image": i.icon + "-15",
                                "icon-size": i.iconsize / 10,
                                "text-field": i.text,
                                "text-size": i.textfont.size,
                                "text-anchor": o.anchor,
                                "text-offset": o.offset,
                                "symbol-placement": i.placement
                            }), n.extendFlat(r, {
                                "icon-color": t1.color,
                                "text-color": i.textfont.color,
                                "text-opacity": t1.opacity
                            });
                            break;
                        case "raster":
                            n.extendFlat(r, {
                                "raster-fade-duration": 0,
                                "raster-opacity": t1.opacity
                            });
                    }
                    return {
                        layout: e1,
                        paint: r
                    };
                }
                l.update = function(t1) {
                    this.visible ? this.needsNewImage(t1) ? this.updateImage(t1) : this.needsNewSource(t1) ? (this.removeLayer(), this.updateSource(t1), this.updateLayer(t1)) : this.needsNewLayer(t1) ? this.updateLayer(t1) : this.updateStyle(t1) : (this.updateSource(t1), this.updateLayer(t1)), this.visible = c(t1);
                }, l.needsNewImage = function(t1) {
                    return this.subplot.map.getSource(this.idSource) && "image" === this.sourceType && "image" === t1.sourcetype && (this.source !== t1.source || JSON.stringify(this.coordinates) !== JSON.stringify(t1.coordinates));
                }, l.needsNewSource = function(t1) {
                    return this.sourceType !== t1.sourcetype || JSON.stringify(this.source) !== JSON.stringify(t1.source) || this.layerType !== t1.type;
                }, l.needsNewLayer = function(t1) {
                    return this.layerType !== t1.type || this.below !== this.subplot.belowLookup["layout-" + this.index];
                }, l.lookupBelow = function() {
                    return this.subplot.belowLookup["layout-" + this.index];
                }, l.updateImage = function(t1) {
                    this.subplot.map.getSource(this.idSource).updateImage({
                        url: t1.source,
                        coordinates: t1.coordinates
                    });
                    var e1 = this.findFollowingMapLayerId(this.lookupBelow());
                    null !== e1 && this.subplot.map.moveLayer(this.idLayer, e1);
                }, l.updateSource = function(t1) {
                    var e1 = this.subplot.map;
                    if (e1.getSource(this.idSource) && e1.removeSource(this.idSource), this.sourceType = t1.sourcetype, this.source = t1.source, c(t1)) {
                        var r = function(t1) {
                            var e1, r = t1.sourcetype, n = t1.source, a = {
                                type: r
                            };
                            return "geojson" === r ? e1 = "data" : "vector" === r ? e1 = "string" == typeof n ? "url" : "tiles" : "raster" === r ? (e1 = "tiles", a.tileSize = 256) : "image" === r && (e1 = "url", a.coordinates = t1.coordinates), a[e1] = n, t1.sourceattribution && (a.attribution = i(t1.sourceattribution)), a;
                        }(t1);
                        e1.addSource(this.idSource, r);
                    }
                }, l.findFollowingMapLayerId = function(t1) {
                    if ("traces" === t1) for(var e1 = this.subplot.getMapLayers(), r = 0; r < e1.length; r++){
                        var n = e1[r].id;
                        if ("string" == typeof n && 0 === n.indexOf(o.traceLayerPrefix)) {
                            t1 = n;
                            break;
                        }
                    }
                    return t1;
                }, l.updateLayer = function(t1) {
                    var e1 = this.subplot, r = u(t1), n = this.lookupBelow(), i = this.findFollowingMapLayerId(n);
                    this.removeLayer(), c(t1) && e1.addLayer({
                        id: this.idLayer,
                        source: this.idSource,
                        "source-layer": t1.sourcelayer || "",
                        type: t1.type,
                        minzoom: t1.minzoom,
                        maxzoom: t1.maxzoom,
                        layout: r.layout,
                        paint: r.paint
                    }, i), this.layerType = t1.type, this.below = n;
                }, l.updateStyle = function(t1) {
                    if (c(t1)) {
                        var e1 = u(t1);
                        this.subplot.setOptions(this.idLayer, "setLayoutProperty", e1.layout), this.subplot.setOptions(this.idLayer, "setPaintProperty", e1.paint);
                    }
                }, l.removeLayer = function() {
                    var t1 = this.subplot.map;
                    t1.getLayer(this.idLayer) && t1.removeLayer(this.idLayer);
                }, l.dispose = function() {
                    var t1 = this.subplot.map;
                    t1.getLayer(this.idLayer) && t1.removeLayer(this.idLayer), t1.getSource(this.idSource) && t1.removeSource(this.idSource);
                }, t1.exports = function(t1, e1, r) {
                    var n = new s(t1, e1);
                    return n.update(r), n;
                };
            },
            8257: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(78766).defaultLine, a = r(13792).u, o = r(80337), s = r(36640).textposition, l = r(13582).overrideAll, c = r(78032).templatedArray, u = r(8814), h = o({
                    noFontVariant: !0,
                    noFontShadow: !0,
                    noFontLineposition: !0,
                    noFontTextcase: !0
                });
                h.family.dflt = "Open Sans Regular, Arial Unicode MS Regular", (t1.exports = l({
                    _arrayAttrRegexps: [
                        n.counterRegex("map", ".layers", !0)
                    ],
                    domain: a({
                        name: "map"
                    }),
                    style: {
                        valType: "any",
                        values: u.styleValuesMap,
                        dflt: u.styleValueDflt
                    },
                    center: {
                        lon: {
                            valType: "number",
                            dflt: 0
                        },
                        lat: {
                            valType: "number",
                            dflt: 0
                        }
                    },
                    zoom: {
                        valType: "number",
                        dflt: 1
                    },
                    bearing: {
                        valType: "number",
                        dflt: 0
                    },
                    pitch: {
                        valType: "number",
                        dflt: 0
                    },
                    bounds: {
                        west: {
                            valType: "number"
                        },
                        east: {
                            valType: "number"
                        },
                        south: {
                            valType: "number"
                        },
                        north: {
                            valType: "number"
                        }
                    },
                    layers: c("layer", {
                        visible: {
                            valType: "boolean",
                            dflt: !0
                        },
                        sourcetype: {
                            valType: "enumerated",
                            values: [
                                "geojson",
                                "vector",
                                "raster",
                                "image"
                            ],
                            dflt: "geojson"
                        },
                        source: {
                            valType: "any"
                        },
                        sourcelayer: {
                            valType: "string",
                            dflt: ""
                        },
                        sourceattribution: {
                            valType: "string"
                        },
                        type: {
                            valType: "enumerated",
                            values: [
                                "circle",
                                "line",
                                "fill",
                                "symbol",
                                "raster"
                            ],
                            dflt: "circle"
                        },
                        coordinates: {
                            valType: "any"
                        },
                        below: {
                            valType: "string"
                        },
                        color: {
                            valType: "color",
                            dflt: i
                        },
                        opacity: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: 1
                        },
                        minzoom: {
                            valType: "number",
                            min: 0,
                            max: 24,
                            dflt: 0
                        },
                        maxzoom: {
                            valType: "number",
                            min: 0,
                            max: 24,
                            dflt: 24
                        },
                        circle: {
                            radius: {
                                valType: "number",
                                dflt: 15
                            }
                        },
                        line: {
                            width: {
                                valType: "number",
                                dflt: 2
                            },
                            dash: {
                                valType: "data_array"
                            }
                        },
                        fill: {
                            outlinecolor: {
                                valType: "color",
                                dflt: i
                            }
                        },
                        symbol: {
                            icon: {
                                valType: "string",
                                dflt: "marker"
                            },
                            iconsize: {
                                valType: "number",
                                dflt: 10
                            },
                            text: {
                                valType: "string",
                                dflt: ""
                            },
                            placement: {
                                valType: "enumerated",
                                values: [
                                    "point",
                                    "line",
                                    "line-center"
                                ],
                                dflt: "point"
                            },
                            textfont: h,
                            textposition: n.extendFlat({}, s, {
                                arrayOk: !1
                            })
                        }
                    })
                }, "plot", "from-root")).uirevision = {
                    valType: "any",
                    editType: "none"
                };
            },
            97446: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(4448), a = r(59008), o = r(8257);
                function s(t1, e1, r) {
                    r("style"), r("center.lon"), r("center.lat"), r("zoom"), r("bearing"), r("pitch");
                    var n = r("bounds.west"), i = r("bounds.east"), o = r("bounds.south"), s = r("bounds.north");
                    void 0 !== n && void 0 !== i && void 0 !== o && void 0 !== s || delete e1.bounds, a(t1, e1, {
                        name: "layers",
                        handleItemDefaults: l
                    }), e1._input = t1;
                }
                function l(t1, e1) {
                    function r(r, i) {
                        return n.coerce(t1, e1, o.layers, r, i);
                    }
                    if (r("visible")) {
                        var i, a = r("sourcetype"), s = "raster" === a || "image" === a;
                        r("source"), r("sourceattribution"), "vector" === a && r("sourcelayer"), "image" === a && r("coordinates"), s && (i = "raster");
                        var l = r("type", i);
                        s && "raster" !== l && (l = e1.type = "raster", n.log("Source types *raster* and *image* must drawn *raster* layer type.")), r("below"), r("color"), r("opacity"), r("minzoom"), r("maxzoom"), "circle" === l && r("circle.radius"), "line" === l && (r("line.width"), r("line.dash")), "fill" === l && r("fill.outlinecolor"), "symbol" === l && (r("symbol.icon"), r("symbol.iconsize"), r("symbol.text"), n.coerceFont(r, "symbol.textfont", void 0, {
                            noFontVariant: !0,
                            noFontShadow: !0,
                            noFontLineposition: !0,
                            noFontTextcase: !0
                        }), r("symbol.textposition"), r("symbol.placement"));
                    }
                }
                t1.exports = function(t1, e1, r) {
                    i(t1, e1, r, {
                        type: "map",
                        attributes: o,
                        handleDefaults: s,
                        partition: "y"
                    });
                };
            },
            38793: function(t1, e1, r) {
                "use strict";
                var n = r(89380), i = r(34809), a = r(3994), o = r(33626), s = r(29714), l = r(14751), c = r(32141), u = r(70414), h = u.drawMode, f = u.selectMode, p = r(44844).prepSelect, d = r(44844).clearOutline, m = r(44844).clearSelectionsCache, g = r(44844).selectOnClick, y = r(8814), v = r(33389);
                function x(t1, e1) {
                    this.id = e1, this.gd = t1;
                    var r = t1._fullLayout, n = t1._context;
                    this.container = r._glcontainer.node(), this.isStatic = n.staticPlot, this.uid = r._uid + "-" + this.id, this.div = null, this.xaxis = null, this.yaxis = null, this.createFramework(r), this.map = null, this.styleObj = null, this.traceHash = {}, this.layerList = [], this.belowLookup = {}, this.dragging = !1, this.wheeling = !1;
                }
                var _ = x.prototype;
                _.plot = function(t1, e1, r) {
                    var n, i = this;
                    n = i.map ? new Promise(function(r, n) {
                        i.updateMap(t1, e1, r, n);
                    }) : new Promise(function(r, n) {
                        i.createMap(t1, e1, r, n);
                    }), r.push(n);
                }, _.createMap = function(t1, e1, r, i) {
                    var o = this, s = e1[o.id], l = o.styleObj = w(s.style), c = s.bounds, u = c ? [
                        [
                            c.west,
                            c.south
                        ],
                        [
                            c.east,
                            c.north
                        ]
                    ] : null, h = o.map = new n.Map({
                        container: o.div,
                        style: l.style,
                        center: T(s.center),
                        zoom: s.zoom,
                        bearing: s.bearing,
                        pitch: s.pitch,
                        maxBounds: u,
                        interactive: !o.isStatic,
                        preserveDrawingBuffer: o.isStatic,
                        doubleClickZoom: !1,
                        boxZoom: !1,
                        attributionControl: !1
                    }).addControl(new n.AttributionControl({
                        compact: !0
                    })), f = {};
                    h.on("styleimagemissing", function(t1) {
                        var e1 = t1.id;
                        if (!f[e1] && e1.includes("-15")) {
                            f[e1] = !0;
                            var r = new Image(15, 15);
                            r.onload = function() {
                                h.addImage(e1, r);
                            }, r.crossOrigin = "Anonymous", r.src = "https://unpkg.com/maki@2.1.0/icons/" + e1 + ".svg";
                        }
                    }), h.setTransformRequest(function(t1) {
                        return {
                            url: t1 = (t1 = (t1 = t1.replace("https://fonts.openmaptiles.org/Open Sans Extrabold", "https://fonts.openmaptiles.org/Open Sans Extra Bold")).replace("https://tiles.basemaps.cartocdn.com/fonts/Open Sans Extrabold", "https://fonts.openmaptiles.org/Open Sans Extra Bold")).replace("https://fonts.openmaptiles.org/Open Sans Regular,Arial Unicode MS Regular", "https://fonts.openmaptiles.org/Klokantech Noto Sans Regular")
                        };
                    }), h._canvas.style.left = "0px", h._canvas.style.top = "0px", o.rejectOnError(i), o.isStatic || o.initFx(t1, e1);
                    var p = [];
                    p.push(new Promise(function(t1) {
                        h.once("load", t1);
                    })), p = p.concat(a.fetchTraceGeoData(t1)), Promise.all(p).then(function() {
                        o.fillBelowLookup(t1, e1), o.updateData(t1), o.updateLayout(e1), o.resolveOnRender(r);
                    }).catch(i);
                }, _.updateMap = function(t1, e1, r, n) {
                    var i = this, o = i.map, s = e1[this.id];
                    i.rejectOnError(n);
                    var l = [], c = w(s.style);
                    JSON.stringify(i.styleObj) !== JSON.stringify(c) && (i.styleObj = c, o.setStyle(c.style), i.traceHash = {}, l.push(new Promise(function(t1) {
                        o.once("styledata", t1);
                    }))), l = l.concat(a.fetchTraceGeoData(t1)), Promise.all(l).then(function() {
                        i.fillBelowLookup(t1, e1), i.updateData(t1), i.updateLayout(e1), i.resolveOnRender(r);
                    }).catch(n);
                }, _.fillBelowLookup = function(t1, e1) {
                    var r, n, i = e1[this.id].layers, a = this.belowLookup = {}, o = !1;
                    for(r = 0; r < t1.length; r++){
                        var s = t1[r][0].trace, l = s._module;
                        "string" == typeof s.below ? n = s.below : l.getBelow && (n = l.getBelow(s, this)), "" === n && (o = !0), a["trace-" + s.uid] = n || "";
                    }
                    for(r = 0; r < i.length; r++){
                        var c = i[r];
                        n = "string" == typeof c.below ? c.below : o ? "traces" : "", a["layout-" + r] = n;
                    }
                    var u, h, f = {};
                    for(u in a)f[n = a[u]] ? f[n].push(u) : f[n] = [
                        u
                    ];
                    for(n in f){
                        var p = f[n];
                        if (p.length > 1) for(r = 0; r < p.length; r++)0 === (u = p[r]).indexOf("trace-") ? (h = u.split("trace-")[1], this.traceHash[h] && (this.traceHash[h].below = null)) : 0 === u.indexOf("layout-") && (h = u.split("layout-")[1], this.layerList[h] && (this.layerList[h].below = null));
                    }
                };
                var b = {
                    choroplethmap: 0,
                    densitymap: 1,
                    scattermap: 2
                };
                function w(t1) {
                    var e1 = {};
                    return i.isPlainObject(t1) ? (e1.id = t1.id, e1.style = t1) : "string" == typeof t1 ? (e1.id = t1, y.stylesMap[t1] ? e1.style = y.stylesMap[t1] : e1.style = t1) : (e1.id = y.styleValueDflt, e1.style = function(t1) {
                        return y.styleUrlPrefix + t1 + "-" + y.styleUrlSuffix;
                    }(y.styleValueDflt)), e1.transition = {
                        duration: 0,
                        delay: 0
                    }, e1;
                }
                function T(t1) {
                    return [
                        t1.lon,
                        t1.lat
                    ];
                }
                _.updateData = function(t1) {
                    var e1, r, n, i, a = this.traceHash, o = t1.slice().sort(function(t1, e1) {
                        return b[t1[0].trace.type] - b[e1[0].trace.type];
                    });
                    for(n = 0; n < o.length; n++){
                        var s = o[n], l = !1;
                        (e1 = a[(r = s[0].trace).uid]) && (e1.type === r.type ? (e1.update(s), l = !0) : e1.dispose()), !l && r._module && (a[r.uid] = r._module.plot(this, s));
                    }
                    var c = Object.keys(a);
                    t: for(n = 0; n < c.length; n++){
                        var u = c[n];
                        for(i = 0; i < t1.length; i++)if (u === (r = t1[i][0].trace).uid) continue t;
                        (e1 = a[u]).dispose(), delete a[u];
                    }
                }, _.updateLayout = function(t1) {
                    var e1 = this.map, r = t1[this.id];
                    this.dragging || this.wheeling || (e1.setCenter(T(r.center)), e1.setZoom(r.zoom), e1.setBearing(r.bearing), e1.setPitch(r.pitch)), this.updateLayers(t1), this.updateFramework(t1), this.updateFx(t1), this.map.resize(), this.gd._context._scrollZoom.map ? e1.scrollZoom.enable() : e1.scrollZoom.disable();
                }, _.resolveOnRender = function(t1) {
                    var e1 = this.map;
                    e1.on("render", function r() {
                        e1.loaded() && (e1.off("render", r), setTimeout(t1, 10));
                    });
                }, _.rejectOnError = function(t1) {
                    var e1 = this.map;
                    function r() {
                        t1(new Error(y.mapOnErrorMsg));
                    }
                    e1.once("error", r), e1.once("style.error", r), e1.once("source.error", r), e1.once("tile.error", r), e1.once("layer.error", r);
                }, _.createFramework = function(t1) {
                    var e1 = this, r = e1.div = document.createElement("div");
                    r.id = e1.uid, r.style.position = "absolute", e1.container.appendChild(r), e1.xaxis = {
                        _id: "x",
                        c2p: function(t1) {
                            return e1.project(t1).x;
                        }
                    }, e1.yaxis = {
                        _id: "y",
                        c2p: function(t1) {
                            return e1.project(t1).y;
                        }
                    }, e1.updateFramework(t1), e1.mockAxis = {
                        type: "linear",
                        showexponent: "all",
                        exponentformat: "B"
                    }, s.setConvert(e1.mockAxis, t1);
                }, _.initFx = function(t1, e1) {
                    var r = this, n = r.gd, i = r.map;
                    function a() {
                        c.loneUnhover(e1._hoverlayer);
                    }
                    function s() {
                        var t1 = r.getView();
                        n.emit("plotly_relayouting", r.getViewEditsWithDerived(t1));
                    }
                    i.on("moveend", function(t1) {
                        if (r.map) {
                            var e1 = n._fullLayout;
                            if (t1.originalEvent || r.wheeling) {
                                var i = e1[r.id];
                                o.call("_storeDirectGUIEdit", n.layout, e1._preGUI, r.getViewEdits(i));
                                var a = r.getView();
                                i._input.center = i.center = a.center, i._input.zoom = i.zoom = a.zoom, i._input.bearing = i.bearing = a.bearing, i._input.pitch = i.pitch = a.pitch, n.emit("plotly_relayout", r.getViewEditsWithDerived(a));
                            }
                            t1.originalEvent && "mouseup" === t1.originalEvent.type ? r.dragging = !1 : r.wheeling && (r.wheeling = !1), e1 && e1._rehover && e1._rehover();
                        }
                    }), i.on("wheel", function() {
                        r.wheeling = !0;
                    }), i.on("mousemove", function(t1) {
                        var e1 = r.div.getBoundingClientRect(), a = [
                            t1.originalEvent.offsetX,
                            t1.originalEvent.offsetY
                        ];
                        t1.target.getBoundingClientRect = function() {
                            return e1;
                        }, r.xaxis.p2c = function() {
                            return i.unproject(a).lng;
                        }, r.yaxis.p2c = function() {
                            return i.unproject(a).lat;
                        }, n._fullLayout._rehover = function() {
                            n._fullLayout._hoversubplot === r.id && n._fullLayout[r.id] && c.hover(n, t1, r.id);
                        }, c.hover(n, t1, r.id), n._fullLayout._hoversubplot = r.id;
                    }), i.on("dragstart", function() {
                        r.dragging = !0, a();
                    }), i.on("zoomstart", a), i.on("mouseout", function() {
                        n._fullLayout._hoversubplot = null;
                    }), i.on("drag", s), i.on("zoom", s), i.on("dblclick", function() {
                        var t1 = n._fullLayout[r.id];
                        o.call("_storeDirectGUIEdit", n.layout, n._fullLayout._preGUI, r.getViewEdits(t1));
                        var e1 = r.viewInitial;
                        i.setCenter(T(e1.center)), i.setZoom(e1.zoom), i.setBearing(e1.bearing), i.setPitch(e1.pitch);
                        var a = r.getView();
                        t1._input.center = t1.center = a.center, t1._input.zoom = t1.zoom = a.zoom, t1._input.bearing = t1.bearing = a.bearing, t1._input.pitch = t1.pitch = a.pitch, n.emit("plotly_doubleclick", null), n.emit("plotly_relayout", r.getViewEditsWithDerived(a));
                    }), r.clearOutline = function() {
                        m(r.dragOptions), d(r.dragOptions.gd);
                    }, r.onClickInPanFn = function(t1) {
                        return function(e1) {
                            var i = n._fullLayout.clickmode;
                            i.indexOf("select") > -1 && g(e1.originalEvent, n, [
                                r.xaxis
                            ], [
                                r.yaxis
                            ], r.id, t1), i.indexOf("event") > -1 && c.click(n, e1.originalEvent);
                        };
                    };
                }, _.updateFx = function(t1) {
                    var e1 = this, r = e1.map, n = e1.gd;
                    if (!e1.isStatic) {
                        var a, o = t1.dragmode;
                        a = function(t1, r) {
                            r.isRect ? (t1.range = {})[e1.id] = [
                                c([
                                    r.xmin,
                                    r.ymin
                                ]),
                                c([
                                    r.xmax,
                                    r.ymax
                                ])
                            ] : (t1.lassoPoints = {})[e1.id] = r.map(c);
                        };
                        var s = e1.dragOptions;
                        e1.dragOptions = i.extendDeep(s || {}, {
                            dragmode: t1.dragmode,
                            element: e1.div,
                            gd: n,
                            plotinfo: {
                                id: e1.id,
                                domain: t1[e1.id].domain,
                                xaxis: e1.xaxis,
                                yaxis: e1.yaxis,
                                fillRangeItems: a
                            },
                            xaxes: [
                                e1.xaxis
                            ],
                            yaxes: [
                                e1.yaxis
                            ],
                            subplot: e1.id
                        }), r.off("click", e1.onClickInPanHandler), f(o) || h(o) ? (r.dragPan.disable(), r.on("zoomstart", e1.clearOutline), e1.dragOptions.prepFn = function(t1, r, n) {
                            p(t1, r, n, e1.dragOptions, o);
                        }, l.init(e1.dragOptions)) : (r.dragPan.enable(), r.off("zoomstart", e1.clearOutline), e1.div.onmousedown = null, e1.div.ontouchstart = null, e1.div.removeEventListener("touchstart", e1.div._ontouchstart), e1.onClickInPanHandler = e1.onClickInPanFn(e1.dragOptions), r.on("click", e1.onClickInPanHandler));
                    }
                    function c(t1) {
                        var r = e1.map.unproject(t1);
                        return [
                            r.lng,
                            r.lat
                        ];
                    }
                }, _.updateFramework = function(t1) {
                    var e1 = t1[this.id].domain, r = t1._size, n = this.div.style;
                    n.width = r.w * (e1.x[1] - e1.x[0]) + "px", n.height = r.h * (e1.y[1] - e1.y[0]) + "px", n.left = r.l + e1.x[0] * r.w + "px", n.top = r.t + (1 - e1.y[1]) * r.h + "px", this.xaxis._offset = r.l + e1.x[0] * r.w, this.xaxis._length = r.w * (e1.x[1] - e1.x[0]), this.yaxis._offset = r.t + (1 - e1.y[1]) * r.h, this.yaxis._length = r.h * (e1.y[1] - e1.y[0]);
                }, _.updateLayers = function(t1) {
                    var e1, r = t1[this.id].layers, n = this.layerList;
                    if (r.length !== n.length) {
                        for(e1 = 0; e1 < n.length; e1++)n[e1].dispose();
                        for(n = this.layerList = [], e1 = 0; e1 < r.length; e1++)n.push(v(this, e1, r[e1]));
                    } else for(e1 = 0; e1 < r.length; e1++)n[e1].update(r[e1]);
                }, _.destroy = function() {
                    this.map && (this.map.remove(), this.map = null, this.container.removeChild(this.div));
                }, _.toImage = function() {
                    return this.map.stop(), this.map.getCanvas().toDataURL();
                }, _.setOptions = function(t1, e1, r) {
                    for(var n in r)this.map[e1](t1, n, r[n]);
                }, _.getMapLayers = function() {
                    return this.map.getStyle().layers;
                }, _.addLayer = function(t1, e1) {
                    var r = this.map;
                    if ("string" == typeof e1) {
                        if ("" === e1) return void r.addLayer(t1, e1);
                        for(var n = this.getMapLayers(), a = 0; a < n.length; a++)if (e1 === n[a].id) return void r.addLayer(t1, e1);
                        i.warn([
                            "Trying to add layer with *below* value",
                            e1,
                            "referencing a layer that does not exist",
                            "or that does not yet exist."
                        ].join(" "));
                    }
                    r.addLayer(t1);
                }, _.project = function(t1) {
                    return this.map.project(new n.LngLat(t1[0], t1[1]));
                }, _.getView = function() {
                    var t1 = this.map, e1 = t1.getCenter(), r = {
                        lon: e1.lng,
                        lat: e1.lat
                    }, n = t1.getCanvas(), i = parseInt(n.style.width), a = parseInt(n.style.height);
                    return {
                        center: r,
                        zoom: t1.getZoom(),
                        bearing: t1.getBearing(),
                        pitch: t1.getPitch(),
                        _derived: {
                            coordinates: [
                                t1.unproject([
                                    0,
                                    0
                                ]).toArray(),
                                t1.unproject([
                                    i,
                                    0
                                ]).toArray(),
                                t1.unproject([
                                    i,
                                    a
                                ]).toArray(),
                                t1.unproject([
                                    0,
                                    a
                                ]).toArray()
                            ]
                        }
                    };
                }, _.getViewEdits = function(t1) {
                    for(var e1 = this.id, r = [
                        "center",
                        "zoom",
                        "bearing",
                        "pitch"
                    ], n = {}, i = 0; i < r.length; i++){
                        var a = r[i];
                        n[e1 + "." + a] = t1[a];
                    }
                    return n;
                }, _.getViewEditsWithDerived = function(t1) {
                    var e1 = this.id, r = this.getViewEdits(t1);
                    return r[e1 + "._derived"] = t1._derived, r;
                }, t1.exports = x;
            },
            44245: function(t1, e1, r) {
                "use strict";
                var n = r(62994), i = "1.13.4", a = '\xa9 <a target="_blank" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors', o = [
                    '\xa9 <a target="_blank" href="https://carto.com/">Carto</a>',
                    a
                ].join(" "), s = [
                    'Map tiles by <a target="_blank" href="https://stamen.com">Stamen Design</a>',
                    'under <a target="_blank" href="https://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>',
                    "|",
                    'Data by <a target="_blank" href="https://openstreetmap.org">OpenStreetMap</a> contributors',
                    'under <a target="_blank" href="https://www.openstreetmap.org/copyright">ODbL</a>'
                ].join(" "), l = {
                    "open-street-map": {
                        id: "osm",
                        version: 8,
                        sources: {
                            "plotly-osm-tiles": {
                                type: "raster",
                                attribution: a,
                                tiles: [
                                    "https://a.tile.openstreetmap.org/{z}/{x}/{y}.png",
                                    "https://b.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                ],
                                tileSize: 256
                            }
                        },
                        layers: [
                            {
                                id: "plotly-osm-tiles",
                                type: "raster",
                                source: "plotly-osm-tiles",
                                minzoom: 0,
                                maxzoom: 22
                            }
                        ],
                        glyphs: "https://fonts.openmaptiles.org/{fontstack}/{range}.pbf"
                    },
                    "white-bg": {
                        id: "white-bg",
                        version: 8,
                        sources: {},
                        layers: [
                            {
                                id: "white-bg",
                                type: "background",
                                paint: {
                                    "background-color": "#FFFFFF"
                                },
                                minzoom: 0,
                                maxzoom: 22
                            }
                        ],
                        glyphs: "https://fonts.openmaptiles.org/{fontstack}/{range}.pbf"
                    },
                    "carto-positron": {
                        id: "carto-positron",
                        version: 8,
                        sources: {
                            "plotly-carto-positron": {
                                type: "raster",
                                attribution: o,
                                tiles: [
                                    "https://cartodb-basemaps-c.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"
                                ],
                                tileSize: 256
                            }
                        },
                        layers: [
                            {
                                id: "plotly-carto-positron",
                                type: "raster",
                                source: "plotly-carto-positron",
                                minzoom: 0,
                                maxzoom: 22
                            }
                        ],
                        glyphs: "https://fonts.openmaptiles.org/{fontstack}/{range}.pbf"
                    },
                    "carto-darkmatter": {
                        id: "carto-darkmatter",
                        version: 8,
                        sources: {
                            "plotly-carto-darkmatter": {
                                type: "raster",
                                attribution: o,
                                tiles: [
                                    "https://cartodb-basemaps-c.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png"
                                ],
                                tileSize: 256
                            }
                        },
                        layers: [
                            {
                                id: "plotly-carto-darkmatter",
                                type: "raster",
                                source: "plotly-carto-darkmatter",
                                minzoom: 0,
                                maxzoom: 22
                            }
                        ],
                        glyphs: "https://fonts.openmaptiles.org/{fontstack}/{range}.pbf"
                    },
                    "stamen-terrain": {
                        id: "stamen-terrain",
                        version: 8,
                        sources: {
                            "plotly-stamen-terrain": {
                                type: "raster",
                                attribution: s,
                                tiles: [
                                    "https://tiles.stadiamaps.com/tiles/stamen_terrain/{z}/{x}/{y}.png?api_key="
                                ],
                                tileSize: 256
                            }
                        },
                        layers: [
                            {
                                id: "plotly-stamen-terrain",
                                type: "raster",
                                source: "plotly-stamen-terrain",
                                minzoom: 0,
                                maxzoom: 22
                            }
                        ],
                        glyphs: "https://fonts.openmaptiles.org/{fontstack}/{range}.pbf"
                    },
                    "stamen-toner": {
                        id: "stamen-toner",
                        version: 8,
                        sources: {
                            "plotly-stamen-toner": {
                                type: "raster",
                                attribution: s,
                                tiles: [
                                    "https://tiles.stadiamaps.com/tiles/stamen_toner/{z}/{x}/{y}.png?api_key="
                                ],
                                tileSize: 256
                            }
                        },
                        layers: [
                            {
                                id: "plotly-stamen-toner",
                                type: "raster",
                                source: "plotly-stamen-toner",
                                minzoom: 0,
                                maxzoom: 22
                            }
                        ],
                        glyphs: "https://fonts.openmaptiles.org/{fontstack}/{range}.pbf"
                    },
                    "stamen-watercolor": {
                        id: "stamen-watercolor",
                        version: 8,
                        sources: {
                            "plotly-stamen-watercolor": {
                                type: "raster",
                                attribution: [
                                    'Map tiles by <a target="_blank" href="https://stamen.com">Stamen Design</a>',
                                    'under <a target="_blank" href="https://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>',
                                    "|",
                                    'Data by <a target="_blank" href="https://openstreetmap.org">OpenStreetMap</a> contributors',
                                    'under <a target="_blank" href="https://creativecommons.org/licenses/by-sa/3.0">CC BY SA</a>'
                                ].join(" "),
                                tiles: [
                                    "https://tiles.stadiamaps.com/tiles/stamen_watercolor/{z}/{x}/{y}.jpg?api_key="
                                ],
                                tileSize: 256
                            }
                        },
                        layers: [
                            {
                                id: "plotly-stamen-watercolor",
                                type: "raster",
                                source: "plotly-stamen-watercolor",
                                minzoom: 0,
                                maxzoom: 22
                            }
                        ],
                        glyphs: "https://fonts.openmaptiles.org/{fontstack}/{range}.pbf"
                    }
                }, c = n(l);
                t1.exports = {
                    requiredVersion: i,
                    styleUrlPrefix: "mapbox://styles/mapbox/",
                    styleUrlSuffix: "v9",
                    styleValuesMapbox: [
                        "basic",
                        "streets",
                        "outdoors",
                        "light",
                        "dark",
                        "satellite",
                        "satellite-streets"
                    ],
                    styleValueDflt: "basic",
                    stylesNonMapbox: l,
                    styleValuesNonMapbox: c,
                    traceLayerPrefix: "plotly-trace-layer-",
                    layoutLayerPrefix: "plotly-layout-layer-",
                    wrongVersionErrorMsg: [
                        "Your custom plotly.js bundle is not using the correct mapbox-gl version",
                        "Please install @plotly/mapbox-gl@" + i + "."
                    ].join("\n"),
                    noAccessTokenErrorMsg: [
                        "Missing Mapbox access token.",
                        "Mapbox trace type require a Mapbox access token to be registered.",
                        "For example:",
                        "  Plotly.newPlot(gd, data, layout, { mapboxAccessToken: 'my-access-token' });",
                        "More info here: https://www.mapbox.com/help/define-access-token/"
                    ].join("\n"),
                    missingStyleErrorMsg: [
                        "No valid mapbox style found, please set `mapbox.style` to one of:",
                        c.join(", "),
                        "or register a Mapbox access token to use a Mapbox-served style."
                    ].join("\n"),
                    multipleTokensErrorMsg: [
                        "Set multiple mapbox access token across different mapbox subplot,",
                        "using first token found as mapbox-gl does not allow multipleaccess tokens on the same page."
                    ].join("\n"),
                    mapOnErrorMsg: "Mapbox error.",
                    mapboxLogo: {
                        path0: "m 10.5,1.24 c -5.11,0 -9.25,4.15 -9.25,9.25 0,5.1 4.15,9.25 9.25,9.25 5.1,0 9.25,-4.15 9.25,-9.25 0,-5.11 -4.14,-9.25 -9.25,-9.25 z m 4.39,11.53 c -1.93,1.93 -4.78,2.31 -6.7,2.31 -0.7,0 -1.41,-0.05 -2.1,-0.16 0,0 -1.02,-5.64 2.14,-8.81 0.83,-0.83 1.95,-1.28 3.13,-1.28 1.27,0 2.49,0.51 3.39,1.42 1.84,1.84 1.89,4.75 0.14,6.52 z",
                        path1: "M 10.5,-0.01 C 4.7,-0.01 0,4.7 0,10.49 c 0,5.79 4.7,10.5 10.5,10.5 5.8,0 10.5,-4.7 10.5,-10.5 C 20.99,4.7 16.3,-0.01 10.5,-0.01 Z m 0,19.75 c -5.11,0 -9.25,-4.15 -9.25,-9.25 0,-5.1 4.14,-9.26 9.25,-9.26 5.11,0 9.25,4.15 9.25,9.25 0,5.13 -4.14,9.26 -9.25,9.26 z",
                        path2: "M 14.74,6.25 C 12.9,4.41 9.98,4.35 8.23,6.1 5.07,9.27 6.09,14.91 6.09,14.91 c 0,0 5.64,1.02 8.81,-2.14 C 16.64,11 16.59,8.09 14.74,6.25 Z m -2.27,4.09 -0.91,1.87 -0.9,-1.87 -1.86,-0.91 1.86,-0.9 0.9,-1.87 0.91,1.87 1.86,0.9 z",
                        polygon: "11.56,12.21 10.66,10.34 8.8,9.43 10.66,8.53 11.56,6.66 12.47,8.53 14.33,9.43 12.47,10.34"
                    },
                    styleRules: {
                        map: "overflow:hidden;position:relative;",
                        "missing-css": "display:none;",
                        canary: "background-color:salmon;",
                        "ctrl-bottom-left": "position: absolute; pointer-events: none; z-index: 2; bottom: 0; left: 0;",
                        "ctrl-bottom-right": "position: absolute; pointer-events: none; z-index: 2; right: 0; bottom: 0;",
                        ctrl: "clear: both; pointer-events: auto; transform: translate(0, 0);",
                        "ctrl-attrib.mapboxgl-compact .mapboxgl-ctrl-attrib-inner": "display: none;",
                        "ctrl-attrib.mapboxgl-compact:hover .mapboxgl-ctrl-attrib-inner": "display: block; margin-top:2px",
                        "ctrl-attrib.mapboxgl-compact:hover": "padding: 2px 24px 2px 4px; visibility: visible; margin-top: 6px;",
                        "ctrl-attrib.mapboxgl-compact::after": 'content: ""; cursor: pointer; position: absolute; background-image: url(\'data:image/svg+xml;charset=utf-8,%3Csvg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"%3E %3Cpath fill="%23333333" fill-rule="evenodd" d="M4,10a6,6 0 1,0 12,0a6,6 0 1,0 -12,0 M9,7a1,1 0 1,0 2,0a1,1 0 1,0 -2,0 M9,10a1,1 0 1,1 2,0l0,3a1,1 0 1,1 -2,0"/%3E %3C/svg%3E\'); background-color: rgba(255, 255, 255, 0.5); width: 24px; height: 24px; box-sizing: border-box; border-radius: 12px;',
                        "ctrl-attrib.mapboxgl-compact": "min-height: 20px; padding: 0; margin: 10px; position: relative; background-color: #fff; border-radius: 3px 12px 12px 3px;",
                        "ctrl-bottom-right > .mapboxgl-ctrl-attrib.mapboxgl-compact::after": "bottom: 0; right: 0",
                        "ctrl-bottom-left > .mapboxgl-ctrl-attrib.mapboxgl-compact::after": "bottom: 0; left: 0",
                        "ctrl-bottom-left .mapboxgl-ctrl": "margin: 0 0 10px 10px; float: left;",
                        "ctrl-bottom-right .mapboxgl-ctrl": "margin: 0 10px 10px 0; float: right;",
                        "ctrl-attrib": "color: rgba(0, 0, 0, 0.75); text-decoration: none; font-size: 12px",
                        "ctrl-attrib a": "color: rgba(0, 0, 0, 0.75); text-decoration: none; font-size: 12px",
                        "ctrl-attrib a:hover": "color: inherit; text-decoration: underline;",
                        "ctrl-attrib .mapbox-improve-map": "font-weight: bold; margin-left: 2px;",
                        "attrib-empty": "display: none;",
                        "ctrl-logo": 'display:block; width: 21px; height: 21px; background-image: url(\'data:image/svg+xml;charset=utf-8,%3C?xml version="1.0" encoding="utf-8"?%3E %3Csvg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 21 21" style="enable-background:new 0 0 21 21;" xml:space="preserve"%3E%3Cg transform="translate(0,0.01)"%3E%3Cpath d="m 10.5,1.24 c -5.11,0 -9.25,4.15 -9.25,9.25 0,5.1 4.15,9.25 9.25,9.25 5.1,0 9.25,-4.15 9.25,-9.25 0,-5.11 -4.14,-9.25 -9.25,-9.25 z m 4.39,11.53 c -1.93,1.93 -4.78,2.31 -6.7,2.31 -0.7,0 -1.41,-0.05 -2.1,-0.16 0,0 -1.02,-5.64 2.14,-8.81 0.83,-0.83 1.95,-1.28 3.13,-1.28 1.27,0 2.49,0.51 3.39,1.42 1.84,1.84 1.89,4.75 0.14,6.52 z" style="opacity:0.9;fill:%23ffffff;enable-background:new" class="st0"/%3E%3Cpath d="M 10.5,-0.01 C 4.7,-0.01 0,4.7 0,10.49 c 0,5.79 4.7,10.5 10.5,10.5 5.8,0 10.5,-4.7 10.5,-10.5 C 20.99,4.7 16.3,-0.01 10.5,-0.01 Z m 0,19.75 c -5.11,0 -9.25,-4.15 -9.25,-9.25 0,-5.1 4.14,-9.26 9.25,-9.26 5.11,0 9.25,4.15 9.25,9.25 0,5.13 -4.14,9.26 -9.25,9.26 z" style="opacity:0.35;enable-background:new" class="st1"/%3E%3Cpath d="M 14.74,6.25 C 12.9,4.41 9.98,4.35 8.23,6.1 5.07,9.27 6.09,14.91 6.09,14.91 c 0,0 5.64,1.02 8.81,-2.14 C 16.64,11 16.59,8.09 14.74,6.25 Z m -2.27,4.09 -0.91,1.87 -0.9,-1.87 -1.86,-0.91 1.86,-0.9 0.9,-1.87 0.91,1.87 1.86,0.9 z" style="opacity:0.35;enable-background:new" class="st1"/%3E%3Cpolygon points="11.56,12.21 10.66,10.34 8.8,9.43 10.66,8.53 11.56,6.66 12.47,8.53 14.33,9.43 12.47,10.34 " style="opacity:0.9;fill:%23ffffff;enable-background:new" class="st0"/%3E%3C/g%3E%3C/svg%3E\')'
                    }
                };
            },
            2178: function(t1, e1, r) {
                "use strict";
                var n = r(34809);
                t1.exports = function(t1, e1) {
                    var r = t1.split(" "), i = r[0], a = r[1], o = n.isArrayOrTypedArray(e1) ? n.mean(e1) : e1, s = .5 + o / 100, l = 1.5 + o / 100, c = [
                        "",
                        ""
                    ], u = [
                        0,
                        0
                    ];
                    switch(i){
                        case "top":
                            c[0] = "top", u[1] = -l;
                            break;
                        case "bottom":
                            c[0] = "bottom", u[1] = l;
                    }
                    switch(a){
                        case "left":
                            c[1] = "right", u[0] = -s;
                            break;
                        case "right":
                            c[1] = "left", u[0] = s;
                    }
                    return {
                        anchor: c[0] && c[1] ? c.join("-") : c[0] ? c[0] : c[1] ? c[1] : "center",
                        offset: u
                    };
                };
            },
            68192: function(t1, e1, r) {
                "use strict";
                var n = r(32280), i = r(34809), a = i.strTranslate, o = i.strScale, s = r(4173).fX, l = r(62972), c = r(45568), u = r(62203), h = r(30635), f = r(5417), p = "mapbox", d = e1.constants = r(44245);
                e1.name = p, e1.attr = "subplot", e1.idRoot = p, e1.idRegex = e1.attrRegex = i.counterRegex(p);
                var m = [
                    "mapbox subplots and traces are deprecated!",
                    "Please consider switching to `map` subplots and traces.",
                    "Learn more at: https://plotly.com/javascript/maplibre-migration/"
                ].join(" ");
                e1.attributes = {
                    subplot: {
                        valType: "subplotid",
                        dflt: "mapbox",
                        editType: "calc"
                    }
                }, e1.layoutAttributes = r(67514), e1.supplyLayoutDefaults = r(86989);
                var g = !0;
                function y(t1) {
                    return "string" == typeof t1 && (-1 !== d.styleValuesMapbox.indexOf(t1) || 0 === t1.indexOf("mapbox://") || 0 === t1.indexOf("stamen"));
                }
                e1.plot = function(t1) {
                    g && (g = !1, i.warn(m));
                    var e1 = t1._fullLayout, r = t1.calcdata, a = e1._subplots[p];
                    if (n.version !== d.requiredVersion) throw new Error(d.wrongVersionErrorMsg);
                    var o = function(t1, e1) {
                        var r = t1._fullLayout;
                        if ("" === t1._context.mapboxAccessToken) return "";
                        for(var n = [], a = [], o = !1, s = !1, l = 0; l < e1.length; l++){
                            var c = r[e1[l]], u = c.accesstoken;
                            y(c.style) && (u ? i.pushUnique(n, u) : (y(c._input.style) && (i.error("Uses Mapbox map style, but did not set an access token."), o = !0), s = !0)), u && i.pushUnique(a, u);
                        }
                        if (s) {
                            var h = o ? d.noAccessTokenErrorMsg : d.missingStyleErrorMsg;
                            throw i.error(h), new Error(h);
                        }
                        return n.length ? (n.length > 1 && i.warn(d.multipleTokensErrorMsg), n[0]) : (a.length && i.log([
                            "Listed mapbox access token(s)",
                            a.join(","),
                            "but did not use a Mapbox map style, ignoring token(s)."
                        ].join(" ")), "");
                    }(t1, a);
                    n.accessToken = o;
                    for(var l = 0; l < a.length; l++){
                        var c = a[l], u = s(r, p, c), h = e1[c], v = h._subplot;
                        v || (v = new f(t1, c), e1[c]._subplot = v), v.viewInitial || (v.viewInitial = {
                            center: i.extendFlat({}, h.center),
                            zoom: h.zoom,
                            bearing: h.bearing,
                            pitch: h.pitch
                        }), v.plot(u, e1, t1._promises);
                    }
                }, e1.clean = function(t1, e1, r, n) {
                    for(var i = n._subplots[p] || [], a = 0; a < i.length; a++){
                        var o = i[a];
                        !e1[o] && n[o]._subplot && n[o]._subplot.destroy();
                    }
                }, e1.toSVG = function(t1) {
                    for(var e1 = t1._fullLayout, r = e1._subplots[p], n = e1._size, i = 0; i < r.length; i++){
                        var s = e1[r[i]], f = s.domain, m = s._subplot.toImage("png");
                        e1._glimages.append("svg:image").attr({
                            xmlns: l.svg,
                            "xlink:href": m,
                            x: n.l + n.w * f.x[0],
                            y: n.t + n.h * (1 - f.y[1]),
                            width: n.w * (f.x[1] - f.x[0]),
                            height: n.h * (f.y[1] - f.y[0]),
                            preserveAspectRatio: "none"
                        });
                        var g = c.select(s._subplot.div);
                        if (null !== g.select(".mapboxgl-ctrl-logo").node().offsetParent) {
                            var y = e1._glimages.append("g");
                            y.attr("transform", a(n.l + n.w * f.x[0] + 10, n.t + n.h * (1 - f.y[0]) - 31)), y.append("path").attr("d", d.mapboxLogo.path0).style({
                                opacity: .9,
                                fill: "#ffffff",
                                "enable-background": "new"
                            }), y.append("path").attr("d", d.mapboxLogo.path1).style("opacity", .35).style("enable-background", "new"), y.append("path").attr("d", d.mapboxLogo.path2).style("opacity", .35).style("enable-background", "new"), y.append("polygon").attr("points", d.mapboxLogo.polygon).style({
                                opacity: .9,
                                fill: "#ffffff",
                                "enable-background": "new"
                            });
                        }
                        var v = g.select(".mapboxgl-ctrl-attrib").text().replace("Improve this map", ""), x = e1._glimages.append("g"), _ = x.append("text");
                        _.text(v).classed("static-attribution", !0).attr({
                            "font-size": 12,
                            "font-family": "Arial",
                            color: "rgba(0, 0, 0, 0.75)",
                            "text-anchor": "end",
                            "data-unformatted": v
                        });
                        var b = u.bBox(_.node()), w = n.w * (f.x[1] - f.x[0]);
                        if (b.width > w / 2) {
                            var T = v.split("|").join("<br>");
                            _.text(T).attr("data-unformatted", T).call(h.convertToTspans, t1), b = u.bBox(_.node());
                        }
                        _.attr("transform", a(-3, 8 - b.height)), x.insert("rect", ".static-attribution").attr({
                            x: -b.width - 6,
                            y: -b.height - 3,
                            width: b.width + 6,
                            height: b.height + 3,
                            fill: "rgba(255, 255, 255, 0.75)"
                        });
                        var k = 1;
                        b.width + 6 > w && (k = w / (b.width + 6));
                        var A = [
                            n.l + n.w * f.x[1],
                            n.t + n.h * (1 - f.y[0])
                        ];
                        x.attr("transform", a(A[0], A[1]) + o(k));
                    }
                }, e1.updateFx = function(t1) {
                    for(var e1 = t1._fullLayout, r = e1._subplots[p], n = 0; n < r.length; n++)e1[r[n]]._subplot.updateFx(e1);
                };
            },
            51276: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(30635).sanitizeHTML, a = r(2178), o = r(44245);
                function s(t1, e1) {
                    this.subplot = t1, this.uid = t1.uid + "-" + e1, this.index = e1, this.idSource = "source-" + this.uid, this.idLayer = o.layoutLayerPrefix + this.uid, this.sourceType = null, this.source = null, this.layerType = null, this.below = null, this.visible = !1;
                }
                var l = s.prototype;
                function c(t1) {
                    if (!t1.visible) return !1;
                    var e1 = t1.source;
                    if (Array.isArray(e1) && e1.length > 0) {
                        for(var r = 0; r < e1.length; r++)if ("string" != typeof e1[r] || 0 === e1[r].length) return !1;
                        return !0;
                    }
                    return n.isPlainObject(e1) || "string" == typeof e1 && e1.length > 0;
                }
                function u(t1) {
                    var e1 = {}, r = {};
                    switch(t1.type){
                        case "circle":
                            n.extendFlat(r, {
                                "circle-radius": t1.circle.radius,
                                "circle-color": t1.color,
                                "circle-opacity": t1.opacity
                            });
                            break;
                        case "line":
                            n.extendFlat(r, {
                                "line-width": t1.line.width,
                                "line-color": t1.color,
                                "line-opacity": t1.opacity,
                                "line-dasharray": t1.line.dash
                            });
                            break;
                        case "fill":
                            n.extendFlat(r, {
                                "fill-color": t1.color,
                                "fill-outline-color": t1.fill.outlinecolor,
                                "fill-opacity": t1.opacity
                            });
                            break;
                        case "symbol":
                            var i = t1.symbol, o = a(i.textposition, i.iconsize);
                            n.extendFlat(e1, {
                                "icon-image": i.icon + "-15",
                                "icon-size": i.iconsize / 10,
                                "text-field": i.text,
                                "text-size": i.textfont.size,
                                "text-anchor": o.anchor,
                                "text-offset": o.offset,
                                "symbol-placement": i.placement
                            }), n.extendFlat(r, {
                                "icon-color": t1.color,
                                "text-color": i.textfont.color,
                                "text-opacity": t1.opacity
                            });
                            break;
                        case "raster":
                            n.extendFlat(r, {
                                "raster-fade-duration": 0,
                                "raster-opacity": t1.opacity
                            });
                    }
                    return {
                        layout: e1,
                        paint: r
                    };
                }
                l.update = function(t1) {
                    this.visible ? this.needsNewImage(t1) ? this.updateImage(t1) : this.needsNewSource(t1) ? (this.removeLayer(), this.updateSource(t1), this.updateLayer(t1)) : this.needsNewLayer(t1) ? this.updateLayer(t1) : this.updateStyle(t1) : (this.updateSource(t1), this.updateLayer(t1)), this.visible = c(t1);
                }, l.needsNewImage = function(t1) {
                    return this.subplot.map.getSource(this.idSource) && "image" === this.sourceType && "image" === t1.sourcetype && (this.source !== t1.source || JSON.stringify(this.coordinates) !== JSON.stringify(t1.coordinates));
                }, l.needsNewSource = function(t1) {
                    return this.sourceType !== t1.sourcetype || JSON.stringify(this.source) !== JSON.stringify(t1.source) || this.layerType !== t1.type;
                }, l.needsNewLayer = function(t1) {
                    return this.layerType !== t1.type || this.below !== this.subplot.belowLookup["layout-" + this.index];
                }, l.lookupBelow = function() {
                    return this.subplot.belowLookup["layout-" + this.index];
                }, l.updateImage = function(t1) {
                    this.subplot.map.getSource(this.idSource).updateImage({
                        url: t1.source,
                        coordinates: t1.coordinates
                    });
                    var e1 = this.findFollowingMapboxLayerId(this.lookupBelow());
                    null !== e1 && this.subplot.map.moveLayer(this.idLayer, e1);
                }, l.updateSource = function(t1) {
                    var e1 = this.subplot.map;
                    if (e1.getSource(this.idSource) && e1.removeSource(this.idSource), this.sourceType = t1.sourcetype, this.source = t1.source, c(t1)) {
                        var r = function(t1) {
                            var e1, r = t1.sourcetype, n = t1.source, a = {
                                type: r
                            };
                            return "geojson" === r ? e1 = "data" : "vector" === r ? e1 = "string" == typeof n ? "url" : "tiles" : "raster" === r ? (e1 = "tiles", a.tileSize = 256) : "image" === r && (e1 = "url", a.coordinates = t1.coordinates), a[e1] = n, t1.sourceattribution && (a.attribution = i(t1.sourceattribution)), a;
                        }(t1);
                        e1.addSource(this.idSource, r);
                    }
                }, l.findFollowingMapboxLayerId = function(t1) {
                    if ("traces" === t1) for(var e1 = this.subplot.getMapLayers(), r = 0; r < e1.length; r++){
                        var n = e1[r].id;
                        if ("string" == typeof n && 0 === n.indexOf(o.traceLayerPrefix)) {
                            t1 = n;
                            break;
                        }
                    }
                    return t1;
                }, l.updateLayer = function(t1) {
                    var e1 = this.subplot, r = u(t1), n = this.lookupBelow(), i = this.findFollowingMapboxLayerId(n);
                    this.removeLayer(), c(t1) && e1.addLayer({
                        id: this.idLayer,
                        source: this.idSource,
                        "source-layer": t1.sourcelayer || "",
                        type: t1.type,
                        minzoom: t1.minzoom,
                        maxzoom: t1.maxzoom,
                        layout: r.layout,
                        paint: r.paint
                    }, i), this.layerType = t1.type, this.below = n;
                }, l.updateStyle = function(t1) {
                    if (c(t1)) {
                        var e1 = u(t1);
                        this.subplot.setOptions(this.idLayer, "setLayoutProperty", e1.layout), this.subplot.setOptions(this.idLayer, "setPaintProperty", e1.paint);
                    }
                }, l.removeLayer = function() {
                    var t1 = this.subplot.map;
                    t1.getLayer(this.idLayer) && t1.removeLayer(this.idLayer);
                }, l.dispose = function() {
                    var t1 = this.subplot.map;
                    t1.getLayer(this.idLayer) && t1.removeLayer(this.idLayer), t1.getSource(this.idSource) && t1.removeSource(this.idSource);
                }, t1.exports = function(t1, e1, r) {
                    var n = new s(t1, e1);
                    return n.update(r), n;
                };
            },
            67514: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(78766).defaultLine, a = r(13792).u, o = r(80337), s = r(36640).textposition, l = r(13582).overrideAll, c = r(78032).templatedArray, u = r(44245), h = o({
                    noFontVariant: !0,
                    noFontShadow: !0,
                    noFontLineposition: !0,
                    noFontTextcase: !0
                });
                h.family.dflt = "Open Sans Regular, Arial Unicode MS Regular", (t1.exports = l({
                    _arrayAttrRegexps: [
                        n.counterRegex("mapbox", ".layers", !0)
                    ],
                    domain: a({
                        name: "mapbox"
                    }),
                    accesstoken: {
                        valType: "string",
                        noBlank: !0,
                        strict: !0
                    },
                    style: {
                        valType: "any",
                        values: u.styleValuesMapbox.concat(u.styleValuesNonMapbox),
                        dflt: u.styleValueDflt
                    },
                    center: {
                        lon: {
                            valType: "number",
                            dflt: 0
                        },
                        lat: {
                            valType: "number",
                            dflt: 0
                        }
                    },
                    zoom: {
                        valType: "number",
                        dflt: 1
                    },
                    bearing: {
                        valType: "number",
                        dflt: 0
                    },
                    pitch: {
                        valType: "number",
                        dflt: 0
                    },
                    bounds: {
                        west: {
                            valType: "number"
                        },
                        east: {
                            valType: "number"
                        },
                        south: {
                            valType: "number"
                        },
                        north: {
                            valType: "number"
                        }
                    },
                    layers: c("layer", {
                        visible: {
                            valType: "boolean",
                            dflt: !0
                        },
                        sourcetype: {
                            valType: "enumerated",
                            values: [
                                "geojson",
                                "vector",
                                "raster",
                                "image"
                            ],
                            dflt: "geojson"
                        },
                        source: {
                            valType: "any"
                        },
                        sourcelayer: {
                            valType: "string",
                            dflt: ""
                        },
                        sourceattribution: {
                            valType: "string"
                        },
                        type: {
                            valType: "enumerated",
                            values: [
                                "circle",
                                "line",
                                "fill",
                                "symbol",
                                "raster"
                            ],
                            dflt: "circle"
                        },
                        coordinates: {
                            valType: "any"
                        },
                        below: {
                            valType: "string"
                        },
                        color: {
                            valType: "color",
                            dflt: i
                        },
                        opacity: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: 1
                        },
                        minzoom: {
                            valType: "number",
                            min: 0,
                            max: 24,
                            dflt: 0
                        },
                        maxzoom: {
                            valType: "number",
                            min: 0,
                            max: 24,
                            dflt: 24
                        },
                        circle: {
                            radius: {
                                valType: "number",
                                dflt: 15
                            }
                        },
                        line: {
                            width: {
                                valType: "number",
                                dflt: 2
                            },
                            dash: {
                                valType: "data_array"
                            }
                        },
                        fill: {
                            outlinecolor: {
                                valType: "color",
                                dflt: i
                            }
                        },
                        symbol: {
                            icon: {
                                valType: "string",
                                dflt: "marker"
                            },
                            iconsize: {
                                valType: "number",
                                dflt: 10
                            },
                            text: {
                                valType: "string",
                                dflt: ""
                            },
                            placement: {
                                valType: "enumerated",
                                values: [
                                    "point",
                                    "line",
                                    "line-center"
                                ],
                                dflt: "point"
                            },
                            textfont: h,
                            textposition: n.extendFlat({}, s, {
                                arrayOk: !1
                            })
                        }
                    })
                }, "plot", "from-root")).uirevision = {
                    valType: "any",
                    editType: "none"
                };
            },
            86989: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(4448), a = r(59008), o = r(67514);
                function s(t1, e1, r, n) {
                    r("accesstoken", n.accessToken), r("style"), r("center.lon"), r("center.lat"), r("zoom"), r("bearing"), r("pitch");
                    var i = r("bounds.west"), o = r("bounds.east"), s = r("bounds.south"), c = r("bounds.north");
                    void 0 !== i && void 0 !== o && void 0 !== s && void 0 !== c || delete e1.bounds, a(t1, e1, {
                        name: "layers",
                        handleItemDefaults: l
                    }), e1._input = t1;
                }
                function l(t1, e1) {
                    function r(r, i) {
                        return n.coerce(t1, e1, o.layers, r, i);
                    }
                    if (r("visible")) {
                        var i, a = r("sourcetype"), s = "raster" === a || "image" === a;
                        r("source"), r("sourceattribution"), "vector" === a && r("sourcelayer"), "image" === a && r("coordinates"), s && (i = "raster");
                        var l = r("type", i);
                        s && "raster" !== l && (l = e1.type = "raster", n.log("Source types *raster* and *image* must drawn *raster* layer type.")), r("below"), r("color"), r("opacity"), r("minzoom"), r("maxzoom"), "circle" === l && r("circle.radius"), "line" === l && (r("line.width"), r("line.dash")), "fill" === l && r("fill.outlinecolor"), "symbol" === l && (r("symbol.icon"), r("symbol.iconsize"), r("symbol.text"), n.coerceFont(r, "symbol.textfont", void 0, {
                            noFontVariant: !0,
                            noFontShadow: !0,
                            noFontLineposition: !0,
                            noFontTextcase: !0
                        }), r("symbol.textposition"), r("symbol.placement"));
                    }
                }
                t1.exports = function(t1, e1, r) {
                    i(t1, e1, r, {
                        type: "mapbox",
                        attributes: o,
                        handleDefaults: s,
                        partition: "y",
                        accessToken: e1._mapboxAccessToken
                    });
                };
            },
            5417: function(t1, e1, r) {
                "use strict";
                var n = r(32280), i = r(34809), a = r(3994), o = r(33626), s = r(29714), l = r(14751), c = r(32141), u = r(70414), h = u.drawMode, f = u.selectMode, p = r(44844).prepSelect, d = r(44844).clearOutline, m = r(44844).clearSelectionsCache, g = r(44844).selectOnClick, y = r(44245), v = r(51276);
                function x(t1, e1) {
                    this.id = e1, this.gd = t1;
                    var r = t1._fullLayout, n = t1._context;
                    this.container = r._glcontainer.node(), this.isStatic = n.staticPlot, this.uid = r._uid + "-" + this.id, this.div = null, this.xaxis = null, this.yaxis = null, this.createFramework(r), this.map = null, this.accessToken = null, this.styleObj = null, this.traceHash = {}, this.layerList = [], this.belowLookup = {}, this.dragging = !1, this.wheeling = !1;
                }
                var _ = x.prototype;
                _.plot = function(t1, e1, r) {
                    var n, i = this, a = e1[i.id];
                    i.map && a.accesstoken !== i.accessToken && (i.map.remove(), i.map = null, i.styleObj = null, i.traceHash = {}, i.layerList = []), n = i.map ? new Promise(function(r, n) {
                        i.updateMap(t1, e1, r, n);
                    }) : new Promise(function(r, n) {
                        i.createMap(t1, e1, r, n);
                    }), r.push(n);
                }, _.createMap = function(t1, e1, r, i) {
                    var o = this, s = e1[o.id], l = o.styleObj = w(s.style, e1);
                    o.accessToken = s.accesstoken;
                    var c = s.bounds, u = c ? [
                        [
                            c.west,
                            c.south
                        ],
                        [
                            c.east,
                            c.north
                        ]
                    ] : null, h = o.map = new n.Map({
                        container: o.div,
                        style: l.style,
                        center: k(s.center),
                        zoom: s.zoom,
                        bearing: s.bearing,
                        pitch: s.pitch,
                        maxBounds: u,
                        interactive: !o.isStatic,
                        preserveDrawingBuffer: o.isStatic,
                        doubleClickZoom: !1,
                        boxZoom: !1,
                        attributionControl: !1
                    }).addControl(new n.AttributionControl({
                        compact: !0
                    }));
                    h._canvas.style.left = "0px", h._canvas.style.top = "0px", o.rejectOnError(i), o.isStatic || o.initFx(t1, e1);
                    var f = [];
                    f.push(new Promise(function(t1) {
                        h.once("load", t1);
                    })), f = f.concat(a.fetchTraceGeoData(t1)), Promise.all(f).then(function() {
                        o.fillBelowLookup(t1, e1), o.updateData(t1), o.updateLayout(e1), o.resolveOnRender(r);
                    }).catch(i);
                }, _.updateMap = function(t1, e1, r, n) {
                    var i = this, o = i.map, s = e1[this.id];
                    i.rejectOnError(n);
                    var l = [], c = w(s.style, e1);
                    JSON.stringify(i.styleObj) !== JSON.stringify(c) && (i.styleObj = c, o.setStyle(c.style), i.traceHash = {}, l.push(new Promise(function(t1) {
                        o.once("styledata", t1);
                    }))), l = l.concat(a.fetchTraceGeoData(t1)), Promise.all(l).then(function() {
                        i.fillBelowLookup(t1, e1), i.updateData(t1), i.updateLayout(e1), i.resolveOnRender(r);
                    }).catch(n);
                }, _.fillBelowLookup = function(t1, e1) {
                    var r, n, i = e1[this.id].layers, a = this.belowLookup = {}, o = !1;
                    for(r = 0; r < t1.length; r++){
                        var s = t1[r][0].trace, l = s._module;
                        "string" == typeof s.below ? n = s.below : l.getBelow && (n = l.getBelow(s, this)), "" === n && (o = !0), a["trace-" + s.uid] = n || "";
                    }
                    for(r = 0; r < i.length; r++){
                        var c = i[r];
                        n = "string" == typeof c.below ? c.below : o ? "traces" : "", a["layout-" + r] = n;
                    }
                    var u, h, f = {};
                    for(u in a)f[n = a[u]] ? f[n].push(u) : f[n] = [
                        u
                    ];
                    for(n in f){
                        var p = f[n];
                        if (p.length > 1) for(r = 0; r < p.length; r++)0 === (u = p[r]).indexOf("trace-") ? (h = u.split("trace-")[1], this.traceHash[h] && (this.traceHash[h].below = null)) : 0 === u.indexOf("layout-") && (h = u.split("layout-")[1], this.layerList[h] && (this.layerList[h].below = null));
                    }
                };
                var b = {
                    choroplethmapbox: 0,
                    densitymapbox: 1,
                    scattermapbox: 2
                };
                function w(t1, e1) {
                    var r = {};
                    if (i.isPlainObject(t1)) r.id = t1.id, r.style = t1;
                    else if ("string" == typeof t1) {
                        if (r.id = t1, -1 !== y.styleValuesMapbox.indexOf(t1)) r.style = T(t1);
                        else if (y.stylesNonMapbox[t1]) {
                            r.style = y.stylesNonMapbox[t1];
                            var n = r.style.sources["plotly-" + t1], a = n ? n.tiles : void 0;
                            a && a[0] && "?api_key=" === a[0].slice(-9) && (a[0] += e1._mapboxAccessToken);
                        } else r.style = t1;
                    } else r.id = y.styleValueDflt, r.style = T(y.styleValueDflt);
                    return r.transition = {
                        duration: 0,
                        delay: 0
                    }, r;
                }
                function T(t1) {
                    return y.styleUrlPrefix + t1 + "-" + y.styleUrlSuffix;
                }
                function k(t1) {
                    return [
                        t1.lon,
                        t1.lat
                    ];
                }
                _.updateData = function(t1) {
                    var e1, r, n, i, a = this.traceHash, o = t1.slice().sort(function(t1, e1) {
                        return b[t1[0].trace.type] - b[e1[0].trace.type];
                    });
                    for(n = 0; n < o.length; n++){
                        var s = o[n], l = !1;
                        (e1 = a[(r = s[0].trace).uid]) && (e1.type === r.type ? (e1.update(s), l = !0) : e1.dispose()), !l && r._module && (a[r.uid] = r._module.plot(this, s));
                    }
                    var c = Object.keys(a);
                    t: for(n = 0; n < c.length; n++){
                        var u = c[n];
                        for(i = 0; i < t1.length; i++)if (u === (r = t1[i][0].trace).uid) continue t;
                        (e1 = a[u]).dispose(), delete a[u];
                    }
                }, _.updateLayout = function(t1) {
                    var e1 = this.map, r = t1[this.id];
                    this.dragging || this.wheeling || (e1.setCenter(k(r.center)), e1.setZoom(r.zoom), e1.setBearing(r.bearing), e1.setPitch(r.pitch)), this.updateLayers(t1), this.updateFramework(t1), this.updateFx(t1), this.map.resize(), this.gd._context._scrollZoom.mapbox ? e1.scrollZoom.enable() : e1.scrollZoom.disable();
                }, _.resolveOnRender = function(t1) {
                    var e1 = this.map;
                    e1.on("render", function r() {
                        e1.loaded() && (e1.off("render", r), setTimeout(t1, 10));
                    });
                }, _.rejectOnError = function(t1) {
                    var e1 = this.map;
                    function r() {
                        t1(new Error(y.mapOnErrorMsg));
                    }
                    e1.once("error", r), e1.once("style.error", r), e1.once("source.error", r), e1.once("tile.error", r), e1.once("layer.error", r);
                }, _.createFramework = function(t1) {
                    var e1 = this, r = e1.div = document.createElement("div");
                    r.id = e1.uid, r.style.position = "absolute", e1.container.appendChild(r), e1.xaxis = {
                        _id: "x",
                        c2p: function(t1) {
                            return e1.project(t1).x;
                        }
                    }, e1.yaxis = {
                        _id: "y",
                        c2p: function(t1) {
                            return e1.project(t1).y;
                        }
                    }, e1.updateFramework(t1), e1.mockAxis = {
                        type: "linear",
                        showexponent: "all",
                        exponentformat: "B"
                    }, s.setConvert(e1.mockAxis, t1);
                }, _.initFx = function(t1, e1) {
                    var r = this, n = r.gd, i = r.map;
                    function a() {
                        c.loneUnhover(e1._hoverlayer);
                    }
                    function s() {
                        var t1 = r.getView();
                        n.emit("plotly_relayouting", r.getViewEditsWithDerived(t1));
                    }
                    i.on("moveend", function(t1) {
                        if (r.map) {
                            var e1 = n._fullLayout;
                            if (t1.originalEvent || r.wheeling) {
                                var i = e1[r.id];
                                o.call("_storeDirectGUIEdit", n.layout, e1._preGUI, r.getViewEdits(i));
                                var a = r.getView();
                                i._input.center = i.center = a.center, i._input.zoom = i.zoom = a.zoom, i._input.bearing = i.bearing = a.bearing, i._input.pitch = i.pitch = a.pitch, n.emit("plotly_relayout", r.getViewEditsWithDerived(a));
                            }
                            t1.originalEvent && "mouseup" === t1.originalEvent.type ? r.dragging = !1 : r.wheeling && (r.wheeling = !1), e1._rehover && e1._rehover();
                        }
                    }), i.on("wheel", function() {
                        r.wheeling = !0;
                    }), i.on("mousemove", function(t1) {
                        var e1 = r.div.getBoundingClientRect(), a = [
                            t1.originalEvent.offsetX,
                            t1.originalEvent.offsetY
                        ];
                        t1.target.getBoundingClientRect = function() {
                            return e1;
                        }, r.xaxis.p2c = function() {
                            return i.unproject(a).lng;
                        }, r.yaxis.p2c = function() {
                            return i.unproject(a).lat;
                        }, n._fullLayout._rehover = function() {
                            n._fullLayout._hoversubplot === r.id && n._fullLayout[r.id] && c.hover(n, t1, r.id);
                        }, c.hover(n, t1, r.id), n._fullLayout._hoversubplot = r.id;
                    }), i.on("dragstart", function() {
                        r.dragging = !0, a();
                    }), i.on("zoomstart", a), i.on("mouseout", function() {
                        n._fullLayout._hoversubplot = null;
                    }), i.on("drag", s), i.on("zoom", s), i.on("dblclick", function() {
                        var t1 = n._fullLayout[r.id];
                        o.call("_storeDirectGUIEdit", n.layout, n._fullLayout._preGUI, r.getViewEdits(t1));
                        var e1 = r.viewInitial;
                        i.setCenter(k(e1.center)), i.setZoom(e1.zoom), i.setBearing(e1.bearing), i.setPitch(e1.pitch);
                        var a = r.getView();
                        t1._input.center = t1.center = a.center, t1._input.zoom = t1.zoom = a.zoom, t1._input.bearing = t1.bearing = a.bearing, t1._input.pitch = t1.pitch = a.pitch, n.emit("plotly_doubleclick", null), n.emit("plotly_relayout", r.getViewEditsWithDerived(a));
                    }), r.clearOutline = function() {
                        m(r.dragOptions), d(r.dragOptions.gd);
                    }, r.onClickInPanFn = function(t1) {
                        return function(e1) {
                            var i = n._fullLayout.clickmode;
                            i.indexOf("select") > -1 && g(e1.originalEvent, n, [
                                r.xaxis
                            ], [
                                r.yaxis
                            ], r.id, t1), i.indexOf("event") > -1 && c.click(n, e1.originalEvent);
                        };
                    };
                }, _.updateFx = function(t1) {
                    var e1 = this, r = e1.map, n = e1.gd;
                    if (!e1.isStatic) {
                        var a, o = t1.dragmode;
                        a = function(t1, r) {
                            r.isRect ? (t1.range = {})[e1.id] = [
                                c([
                                    r.xmin,
                                    r.ymin
                                ]),
                                c([
                                    r.xmax,
                                    r.ymax
                                ])
                            ] : (t1.lassoPoints = {})[e1.id] = r.map(c);
                        };
                        var s = e1.dragOptions;
                        e1.dragOptions = i.extendDeep(s || {}, {
                            dragmode: t1.dragmode,
                            element: e1.div,
                            gd: n,
                            plotinfo: {
                                id: e1.id,
                                domain: t1[e1.id].domain,
                                xaxis: e1.xaxis,
                                yaxis: e1.yaxis,
                                fillRangeItems: a
                            },
                            xaxes: [
                                e1.xaxis
                            ],
                            yaxes: [
                                e1.yaxis
                            ],
                            subplot: e1.id
                        }), r.off("click", e1.onClickInPanHandler), f(o) || h(o) ? (r.dragPan.disable(), r.on("zoomstart", e1.clearOutline), e1.dragOptions.prepFn = function(t1, r, n) {
                            p(t1, r, n, e1.dragOptions, o);
                        }, l.init(e1.dragOptions)) : (r.dragPan.enable(), r.off("zoomstart", e1.clearOutline), e1.div.onmousedown = null, e1.div.ontouchstart = null, e1.div.removeEventListener("touchstart", e1.div._ontouchstart), e1.onClickInPanHandler = e1.onClickInPanFn(e1.dragOptions), r.on("click", e1.onClickInPanHandler));
                    }
                    function c(t1) {
                        var r = e1.map.unproject(t1);
                        return [
                            r.lng,
                            r.lat
                        ];
                    }
                }, _.updateFramework = function(t1) {
                    var e1 = t1[this.id].domain, r = t1._size, n = this.div.style;
                    n.width = r.w * (e1.x[1] - e1.x[0]) + "px", n.height = r.h * (e1.y[1] - e1.y[0]) + "px", n.left = r.l + e1.x[0] * r.w + "px", n.top = r.t + (1 - e1.y[1]) * r.h + "px", this.xaxis._offset = r.l + e1.x[0] * r.w, this.xaxis._length = r.w * (e1.x[1] - e1.x[0]), this.yaxis._offset = r.t + (1 - e1.y[1]) * r.h, this.yaxis._length = r.h * (e1.y[1] - e1.y[0]);
                }, _.updateLayers = function(t1) {
                    var e1, r = t1[this.id].layers, n = this.layerList;
                    if (r.length !== n.length) {
                        for(e1 = 0; e1 < n.length; e1++)n[e1].dispose();
                        for(n = this.layerList = [], e1 = 0; e1 < r.length; e1++)n.push(v(this, e1, r[e1]));
                    } else for(e1 = 0; e1 < r.length; e1++)n[e1].update(r[e1]);
                }, _.destroy = function() {
                    this.map && (this.map.remove(), this.map = null, this.container.removeChild(this.div));
                }, _.toImage = function() {
                    return this.map.stop(), this.map.getCanvas().toDataURL();
                }, _.setOptions = function(t1, e1, r) {
                    for(var n in r)this.map[e1](t1, n, r[n]);
                }, _.getMapLayers = function() {
                    return this.map.getStyle().layers;
                }, _.addLayer = function(t1, e1) {
                    var r = this.map;
                    if ("string" == typeof e1) {
                        if ("" === e1) return void r.addLayer(t1, e1);
                        for(var n = this.getMapLayers(), a = 0; a < n.length; a++)if (e1 === n[a].id) return void r.addLayer(t1, e1);
                        i.warn([
                            "Trying to add layer with *below* value",
                            e1,
                            "referencing a layer that does not exist",
                            "or that does not yet exist."
                        ].join(" "));
                    }
                    r.addLayer(t1);
                }, _.project = function(t1) {
                    return this.map.project(new n.LngLat(t1[0], t1[1]));
                }, _.getView = function() {
                    var t1 = this.map, e1 = t1.getCenter(), r = {
                        lon: e1.lng,
                        lat: e1.lat
                    }, n = t1.getCanvas(), i = parseInt(n.style.width), a = parseInt(n.style.height);
                    return {
                        center: r,
                        zoom: t1.getZoom(),
                        bearing: t1.getBearing(),
                        pitch: t1.getPitch(),
                        _derived: {
                            coordinates: [
                                t1.unproject([
                                    0,
                                    0
                                ]).toArray(),
                                t1.unproject([
                                    i,
                                    0
                                ]).toArray(),
                                t1.unproject([
                                    i,
                                    a
                                ]).toArray(),
                                t1.unproject([
                                    0,
                                    a
                                ]).toArray()
                            ]
                        }
                    };
                }, _.getViewEdits = function(t1) {
                    for(var e1 = this.id, r = [
                        "center",
                        "zoom",
                        "bearing",
                        "pitch"
                    ], n = {}, i = 0; i < r.length; i++){
                        var a = r[i];
                        n[e1 + "." + a] = t1[a];
                    }
                    return n;
                }, _.getViewEditsWithDerived = function(t1) {
                    var e1 = this.id, r = this.getViewEdits(t1);
                    return r[e1 + "._derived"] = t1._derived, r;
                }, t1.exports = x;
            },
            57891: function(t1) {
                "use strict";
                t1.exports = function(t1) {
                    var e1 = t1.editType;
                    return {
                        t: {
                            valType: "number",
                            dflt: 0,
                            editType: e1
                        },
                        r: {
                            valType: "number",
                            dflt: 0,
                            editType: e1
                        },
                        b: {
                            valType: "number",
                            dflt: 0,
                            editType: e1
                        },
                        l: {
                            valType: "number",
                            dflt: 0,
                            editType: e1
                        },
                        editType: e1
                    };
                };
            },
            44122: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(42696).de, a = r(36464).OE, o = r(10721), s = r(93229), l = r(33626), c = r(57297), u = r(78032), h = r(34809), f = r(78766), p = r(63821).BADNUM, d = r(5975), m = r(78534).clearOutline, g = r(26667), y = r(49722), v = r(58935), x = r(4173).eV, _ = h.relinkPrivateKeys, b = h._, w = t1.exports = {};
                h.extendFlat(w, l), w.attributes = r(9829), w.attributes.type.values = w.allTypes, w.fontAttrs = r(80337), w.layoutAttributes = r(6704);
                var T = w.transformsRegistry, k = r(90251);
                w.executeAPICommand = k.executeAPICommand, w.computeAPICommandBindings = k.computeAPICommandBindings, w.manageCommandObserver = k.manageCommandObserver, w.hasSimpleAPICommandBindings = k.hasSimpleAPICommandBindings, w.redrawText = function(t1) {
                    return t1 = h.getGraphDiv(t1), new Promise(function(e1) {
                        setTimeout(function() {
                            t1._fullLayout && (l.getComponentMethod("annotations", "draw")(t1), l.getComponentMethod("legend", "draw")(t1), l.getComponentMethod("colorbar", "draw")(t1), e1(w.previousPromises(t1)));
                        }, 300);
                    });
                }, w.resize = function(t1) {
                    var e1;
                    t1 = h.getGraphDiv(t1);
                    var r = new Promise(function(r, n) {
                        t1 && !h.isHidden(t1) || n(new Error("Resize must be passed a displayed plot div element.")), t1._redrawTimer && clearTimeout(t1._redrawTimer), t1._resolveResize && (e1 = t1._resolveResize), t1._resolveResize = r, t1._redrawTimer = setTimeout(function() {
                            if (!t1.layout || t1.layout.width && t1.layout.height || h.isHidden(t1)) r(t1);
                            else {
                                delete t1.layout.width, delete t1.layout.height;
                                var e1 = t1.changed;
                                t1.autoplay = !0, l.call("relayout", t1, {
                                    autosize: !0
                                }).then(function() {
                                    t1.changed = e1, t1._resolveResize === r && (delete t1._resolveResize, r(t1));
                                });
                            }
                        }, 100);
                    });
                    return e1 && e1(r), r;
                }, w.previousPromises = function(t1) {
                    if ((t1._promises || []).length) return Promise.all(t1._promises).then(function() {
                        t1._promises = [];
                    });
                }, w.addLinks = function(t1) {
                    if (t1._context.showLink || t1._context.showSources) {
                        var e1 = t1._fullLayout, r = h.ensureSingle(e1._paper, "text", "js-plot-link-container", function(t1) {
                            t1.style({
                                "font-family": '"Open Sans", Arial, sans-serif',
                                "font-size": "12px",
                                fill: f.defaultLine,
                                "pointer-events": "all"
                            }).each(function() {
                                var t1 = n.select(this);
                                t1.append("tspan").classed("js-link-to-tool", !0), t1.append("tspan").classed("js-link-spacer", !0), t1.append("tspan").classed("js-sourcelinks", !0);
                            });
                        }), i = r.node(), a = {
                            y: e1._paper.attr("height") - 9
                        };
                        document.body.contains(i) && i.getComputedTextLength() >= e1.width - 20 ? (a["text-anchor"] = "start", a.x = 5) : (a["text-anchor"] = "end", a.x = e1._paper.attr("width") - 7), r.attr(a);
                        var o = r.select(".js-link-to-tool"), s = r.select(".js-link-spacer"), l = r.select(".js-sourcelinks");
                        t1._context.showSources && t1._context.showSources(t1), t1._context.showLink && function(t1, e1) {
                            e1.text("");
                            var r = e1.append("a").attr({
                                "xlink:xlink:href": "#",
                                class: "link--impt link--embedview",
                                "font-weight": "bold"
                            }).text(t1._context.linkText + " " + String.fromCharCode(187));
                            if (t1._context.sendData) r.on("click", function() {
                                w.sendDataToCloud(t1);
                            });
                            else {
                                var n = window.location.pathname.split("/"), i = window.location.search;
                                r.attr({
                                    "xlink:xlink:show": "new",
                                    "xlink:xlink:href": "/" + n[2].split(".")[0] + "/" + n[1] + i
                                });
                            }
                        }(t1, o), s.text(o.text() && l.text() ? " - " : "");
                    }
                }, w.sendDataToCloud = function(t1) {
                    var e1 = (window.PLOTLYENV || {}).BASE_URL || t1._context.plotlyServerURL;
                    if (e1) {
                        t1.emit("plotly_beforeexport");
                        var r = n.select(t1).append("div").attr("id", "hiddenform").style("display", "none"), i = r.append("form").attr({
                            action: e1 + "/external",
                            method: "post",
                            target: "_blank"
                        });
                        return i.append("input").attr({
                            type: "text",
                            name: "data"
                        }).node().value = w.graphJson(t1, !1, "keepdata"), i.node().submit(), r.remove(), t1.emit("plotly_afterexport"), !1;
                    }
                };
                var A = [
                    "days",
                    "shortDays",
                    "months",
                    "shortMonths",
                    "periods",
                    "dateTime",
                    "date",
                    "time",
                    "decimal",
                    "thousands",
                    "grouping",
                    "currency"
                ], M = [
                    "year",
                    "month",
                    "dayMonth",
                    "dayMonthYear"
                ];
                function S(t1, e1) {
                    var r = t1._context.locale;
                    r || (r = "en-US");
                    var n = !1, i = {};
                    function a(t1) {
                        for(var r = !0, a = 0; a < e1.length; a++){
                            var o = e1[a];
                            i[o] || (t1[o] ? i[o] = t1[o] : r = !1);
                        }
                        r && (n = !0);
                    }
                    for(var o = 0; o < 2; o++){
                        for(var s = t1._context.locales, c = 0; c < 2; c++){
                            var u = (s[r] || {}).format;
                            if (u && (a(u), n)) break;
                            s = l.localeRegistry;
                        }
                        var h = r.split("-")[0];
                        if (n || h === r) break;
                        r = h;
                    }
                    return n || a(l.localeRegistry.en.format), i;
                }
                function E(t1, e1) {
                    var r = {
                        _fullLayout: e1
                    }, n = "x" === t1._id.charAt(0), i = t1._mainAxis._anchorAxis, a = "", o = "", s = "";
                    if (i && (s = i._mainAxis._id, a = n ? t1._id + s : s + t1._id), !a || !e1._plots[a]) {
                        a = "";
                        for(var l = t1._counterAxes, c = 0; c < l.length; c++){
                            var u = l[c], h = n ? t1._id + u : u + t1._id;
                            o || (o = h);
                            var f = d.getFromId(r, u);
                            if (s && f.overlaying === s) {
                                a = h;
                                break;
                            }
                        }
                    }
                    return a || o;
                }
                function C(t1) {
                    var e1 = t1.transforms;
                    if (Array.isArray(e1) && e1.length) for(var r = 0; r < e1.length; r++){
                        var n = e1[r], i = n._module || T[n.type];
                        if (i && i.makesData) return !0;
                    }
                    return !1;
                }
                function L(t1, e1, r, n) {
                    for(var i = t1.transforms, a = [
                        t1
                    ], o = 0; o < i.length; o++){
                        var s = i[o], l = T[s.type];
                        l && l.transform && (a = l.transform(a, {
                            transform: s,
                            fullTrace: t1,
                            fullData: e1,
                            layout: r,
                            fullLayout: n,
                            transformIndex: o
                        }));
                    }
                    return a;
                }
                function I(t1) {
                    return "string" == typeof t1 && "px" === t1.substr(t1.length - 2) && parseFloat(t1);
                }
                function P(t1) {
                    var e1 = t1.margin;
                    if (!t1._size) {
                        var r = t1._size = {
                            l: Math.round(e1.l),
                            r: Math.round(e1.r),
                            t: Math.round(e1.t),
                            b: Math.round(e1.b),
                            p: Math.round(e1.pad)
                        };
                        r.w = Math.round(t1.width) - r.l - r.r, r.h = Math.round(t1.height) - r.t - r.b;
                    }
                    t1._pushmargin || (t1._pushmargin = {}), t1._pushmarginIds || (t1._pushmarginIds = {}), t1._reservedMargin || (t1._reservedMargin = {});
                }
                w.supplyDefaults = function(t1, e1) {
                    var r = e1 && e1.skipUpdateCalc, n = t1._fullLayout || {};
                    if (n._skipDefaults) delete n._skipDefaults;
                    else {
                        var o, s = t1._fullLayout = {}, c = t1.layout || {}, u = t1._fullData || [], f = t1._fullData = [], p = t1.data || [], d = t1.calcdata || [], g = t1._context || {};
                        t1._transitionData || w.createTransitionData(t1), s._dfltTitle = {
                            plot: b(t1, "Click to enter Plot title"),
                            subtitle: b(t1, "Click to enter Plot subtitle"),
                            x: b(t1, "Click to enter X axis title"),
                            y: b(t1, "Click to enter Y axis title"),
                            colorbar: b(t1, "Click to enter Colorscale title"),
                            annotation: b(t1, "new text")
                        }, s._traceWord = b(t1, "trace");
                        var y = S(t1, A);
                        if (s._mapboxAccessToken = g.mapboxAccessToken, n._initialAutoSizeIsDone) {
                            var v = n.width, x = n.height;
                            w.supplyLayoutGlobalDefaults(c, s, y), c.width || (s.width = v), c.height || (s.height = x), w.sanitizeMargins(s);
                        } else {
                            w.supplyLayoutGlobalDefaults(c, s, y);
                            var T = !c.width || !c.height, k = s.autosize, E = g.autosizable;
                            T && (k || E) ? w.plotAutoSize(t1, c, s) : T && w.sanitizeMargins(s), !k && T && (c.width = s.width, c.height = s.height);
                        }
                        s._d3locale = function(t1, e1) {
                            return t1.decimal = e1.charAt(0), t1.thousands = e1.charAt(1), {
                                numberFormat: function(e1) {
                                    try {
                                        e1 = a(t1).format(h.adjustFormat(e1));
                                    } catch (t1) {
                                        return h.warnBadFormat(e1), h.noFormat;
                                    }
                                    return e1;
                                },
                                timeFormat: i(t1).utcFormat
                            };
                        }(y, s.separators), s._extraFormat = S(t1, M), s._initialAutoSizeIsDone = !0, s._dataLength = p.length, s._modules = [], s._visibleModules = [], s._basePlotModules = [];
                        var C = s._subplots = function() {
                            var t1, e1, r = l.collectableSubplotTypes, n = {};
                            if (!r) {
                                r = [];
                                var i = l.subplotsRegistry;
                                for(var a in i){
                                    var o = i[a].attr;
                                    if (o && (r.push(a), Array.isArray(o))) for(e1 = 0; e1 < o.length; e1++)h.pushUnique(r, o[e1]);
                                }
                            }
                            for(t1 = 0; t1 < r.length; t1++)n[r[t1]] = [];
                            return n;
                        }(), L = s._splomAxes = {
                            x: {},
                            y: {}
                        }, I = s._splomSubplots = {};
                        s._splomGridDflt = {}, s._scatterStackOpts = {}, s._firstScatter = {}, s._alignmentOpts = {}, s._colorAxes = {}, s._requestRangeslider = {}, s._traceUids = function(t1, e1) {
                            var r, n, i = e1.length, a = [];
                            for(r = 0; r < t1.length; r++){
                                var o = t1[r]._fullInput;
                                o !== n && a.push(o), n = o;
                            }
                            var s = a.length, l = new Array(i), c = {};
                            function u(t1, e1) {
                                l[e1] = t1, c[t1] = 1;
                            }
                            function f(t1, e1) {
                                if (t1 && "string" == typeof t1 && !c[t1]) return u(t1, e1), !0;
                            }
                            for(r = 0; r < i; r++){
                                var p = e1[r].uid;
                                "number" == typeof p && (p = String(p)), f(p, r) || r < s && f(a[r].uid, r) || u(h.randstr(c), r);
                            }
                            return l;
                        }(u, p), s._globalTransforms = (t1._context || {}).globalTransforms, w.supplyDataDefaults(p, f, c, s);
                        var z = Object.keys(L.x), O = Object.keys(L.y);
                        if (z.length > 1 && O.length > 1) {
                            for(l.getComponentMethod("grid", "sizeDefaults")(c, s), o = 0; o < z.length; o++)h.pushUnique(C.xaxis, z[o]);
                            for(o = 0; o < O.length; o++)h.pushUnique(C.yaxis, O[o]);
                            for(var D in I)h.pushUnique(C.cartesian, D);
                        }
                        if (s._has = w._hasPlotType.bind(s), u.length === f.length) for(o = 0; o < f.length; o++)_(f[o], u[o]);
                        w.supplyLayoutModuleDefaults(c, s, f, t1._transitionData);
                        var R = s._visibleModules, F = [];
                        for(o = 0; o < R.length; o++){
                            var B = R[o].crossTraceDefaults;
                            B && h.pushUnique(F, B);
                        }
                        for(o = 0; o < F.length; o++)F[o](f, s);
                        s._hasOnlyLargeSploms = 1 === s._basePlotModules.length && "splom" === s._basePlotModules[0].name && z.length > 15 && O.length > 15 && 0 === s.shapes.length && 0 === s.images.length, w.linkSubplots(f, s, u, n), w.cleanPlot(f, s, u, n);
                        var N = !(!n._has || !n._has("gl2d")), j = !(!s._has || !s._has("gl2d")), U = !(!n._has || !n._has("cartesian")) || N, V = !(!s._has || !s._has("cartesian")) || j;
                        U && !V ? n._bgLayer.remove() : V && !U && (s._shouldCreateBgLayer = !0), n._zoomlayer && !t1._dragging && m({
                            _fullLayout: n
                        }), function(t1, e1) {
                            var r, n = [];
                            e1.meta && (r = e1._meta = {
                                meta: e1.meta,
                                layout: {
                                    meta: e1.meta
                                }
                            });
                            for(var i = 0; i < t1.length; i++){
                                var a = t1[i];
                                a.meta ? n[a.index] = a._meta = {
                                    meta: a.meta
                                } : e1.meta && (a._meta = {
                                    meta: e1.meta
                                }), e1.meta && (a._meta.layout = {
                                    meta: e1.meta
                                });
                            }
                            n.length && (r || (r = e1._meta = {}), r.data = n);
                        }(f, s), _(s, n), l.getComponentMethod("colorscale", "crossTraceDefaults")(f, s), s._preGUI || (s._preGUI = {}), s._tracePreGUI || (s._tracePreGUI = {});
                        var q, H = s._tracePreGUI, G = {};
                        for(q in H)G[q] = "old";
                        for(o = 0; o < f.length; o++)G[q = f[o]._fullInput.uid] || (H[q] = {}), G[q] = "new";
                        for(q in G)"old" === G[q] && delete H[q];
                        P(s), l.getComponentMethod("rangeslider", "makeData")(s), r || d.length !== f.length || w.supplyDefaultsUpdateCalc(d, f);
                    }
                }, w.supplyDefaultsUpdateCalc = function(t1, e1) {
                    for(var r = 0; r < e1.length; r++){
                        var n = e1[r], i = (t1[r] || [])[0];
                        if (i && i.trace) {
                            var a = i.trace;
                            if (a._hasCalcTransform) {
                                var o, s, l, c = a._arrayAttrs;
                                for(o = 0; o < c.length; o++)s = c[o], l = h.nestedProperty(a, s).get().slice(), h.nestedProperty(n, s).set(l);
                            }
                            i.trace = n;
                        }
                    }
                }, w.createTransitionData = function(t1) {
                    t1._transitionData || (t1._transitionData = {}), t1._transitionData._frames || (t1._transitionData._frames = []), t1._transitionData._frameHash || (t1._transitionData._frameHash = {}), t1._transitionData._counter || (t1._transitionData._counter = 0), t1._transitionData._interruptCallbacks || (t1._transitionData._interruptCallbacks = []);
                }, w._hasPlotType = function(t1) {
                    var e1, r = this._basePlotModules || [];
                    for(e1 = 0; e1 < r.length; e1++)if (r[e1].name === t1) return !0;
                    var n = this._modules || [];
                    for(e1 = 0; e1 < n.length; e1++){
                        var i = n[e1].name;
                        if (i === t1) return !0;
                        var a = l.modules[i];
                        if (a && a.categories[t1]) return !0;
                    }
                    return !1;
                }, w.cleanPlot = function(t1, e1, r, n) {
                    var i, a, o = n._basePlotModules || [];
                    for(i = 0; i < o.length; i++){
                        var s = o[i];
                        s.clean && s.clean(t1, e1, r, n);
                    }
                    var l = n._has && n._has("gl"), c = e1._has && e1._has("gl");
                    l && !c && void 0 !== n._glcontainer && (n._glcontainer.selectAll(".gl-canvas").remove(), n._glcontainer.selectAll(".no-webgl").remove(), n._glcanvas = null);
                    var u = !!n._infolayer;
                    t: for(i = 0; i < r.length; i++){
                        var h = r[i].uid;
                        for(a = 0; a < t1.length; a++)if (h === t1[a].uid) continue t;
                        u && n._infolayer.select(".cb" + h).remove();
                    }
                }, w.linkSubplots = function(t1, e1, r, n) {
                    var i, a, o = n._plots || {}, s = e1._plots = {}, c = e1._subplots, u = {
                        _fullData: t1,
                        _fullLayout: e1
                    }, f = c.cartesian.concat(c.gl2d || []);
                    for(i = 0; i < f.length; i++){
                        var p, m = f[i], g = o[m], y = d.getFromId(u, m, "x"), v = d.getFromId(u, m, "y");
                        for(g ? p = s[m] = g : (p = s[m] = {}).id = m, y._counterAxes.push(v._id), v._counterAxes.push(y._id), y._subplotsWith.push(m), v._subplotsWith.push(m), p.xaxis = y, p.yaxis = v, p._hasClipOnAxisFalse = !1, a = 0; a < t1.length; a++){
                            var x = t1[a];
                            if (x.xaxis === p.xaxis._id && x.yaxis === p.yaxis._id && !1 === x.cliponaxis) {
                                p._hasClipOnAxisFalse = !0;
                                break;
                            }
                        }
                    }
                    var _, b = d.list(u, null, !0);
                    for(i = 0; i < b.length; i++){
                        var w = null;
                        (_ = b[i]).overlaying && (w = d.getFromId(u, _.overlaying)) && w.overlaying && (_.overlaying = !1, w = null), _._mainAxis = w || _, w && (_.domain = w.domain.slice()), _._anchorAxis = "free" === _.anchor ? null : d.getFromId(u, _.anchor);
                    }
                    for(i = 0; i < b.length; i++)if ((_ = b[i])._counterAxes.sort(d.idSort), _._subplotsWith.sort(h.subplotSort), _._mainSubplot = E(_, e1), _._counterAxes.length && (_.spikemode && -1 !== _.spikemode.indexOf("across") || _.automargin && _.mirror && "free" !== _.anchor || l.getComponentMethod("rangeslider", "isVisible")(_))) {
                        var T = 1, k = 0;
                        for(a = 0; a < _._counterAxes.length; a++){
                            var A = d.getFromId(u, _._counterAxes[a]);
                            T = Math.min(T, A.domain[0]), k = Math.max(k, A.domain[1]);
                        }
                        T < k && (_._counterDomainMin = T, _._counterDomainMax = k);
                    }
                }, w.clearExpandedTraceDefaultColors = function(t1) {
                    var e1, r, n;
                    for(r = [], (e1 = t1._module._colorAttrs) || (t1._module._colorAttrs = e1 = [], c.crawl(t1._module.attributes, function(t1, n, i, a) {
                        r[a] = n, r.length = a + 1, "color" === t1.valType && void 0 === t1.dflt && e1.push(r.join("."));
                    })), n = 0; n < e1.length; n++)h.nestedProperty(t1, "_input." + e1[n]).get() || h.nestedProperty(t1, e1[n]).set(null);
                }, w.supplyDataDefaults = function(t1, e1, r, n) {
                    var i, a, o, s = n._modules, c = n._visibleModules, f = n._basePlotModules, p = 0, d = 0;
                    function m(t1) {
                        e1.push(t1);
                        var r = t1._module;
                        r && (h.pushUnique(s, r), !0 === t1.visible && h.pushUnique(c, r), h.pushUnique(f, t1._module.basePlotModule), p++, !1 !== t1._input.visible && d++);
                    }
                    n._transformModules = [];
                    var g = {}, y = [], v = (r.template || {}).data || {}, x = u.traceTemplater(v);
                    for(i = 0; i < t1.length; i++){
                        if (o = t1[i], (a = x.newTrace(o)).uid = n._traceUids[i], w.supplyTraceDefaults(o, a, d, n, i), a.index = i, a._input = o, a._expandedIndex = p, a.transforms && a.transforms.length) for(var b = !1 !== o.visible && !1 === a.visible, T = L(a, e1, r, n), k = 0; k < T.length; k++){
                            var A = T[k], M = {
                                _template: a._template,
                                type: a.type,
                                uid: a.uid + k
                            };
                            b && !1 === A.visible && delete A.visible, w.supplyTraceDefaults(A, M, p, n, i), _(M, A), M.index = i, M._input = o, M._fullInput = a, M._expandedIndex = p, M._expandedInput = A, m(M);
                        }
                        else a._fullInput = a, a._expandedInput = a, m(a);
                        l.traceIs(a, "carpetAxis") && (g[a.carpet] = a), l.traceIs(a, "carpetDependent") && y.push(i);
                    }
                    for(i = 0; i < y.length; i++)if ((a = e1[y[i]]).visible) {
                        var S = g[a.carpet];
                        a._carpet = S, S && S.visible ? (a.xaxis = S.xaxis, a.yaxis = S.yaxis) : a.visible = !1;
                    }
                }, w.supplyAnimationDefaults = function(t1) {
                    var e1;
                    t1 = t1 || {};
                    var r = {};
                    function n(e1, n) {
                        return h.coerce(t1 || {}, r, y, e1, n);
                    }
                    if (n("mode"), n("direction"), n("fromcurrent"), Array.isArray(t1.frame)) for(r.frame = [], e1 = 0; e1 < t1.frame.length; e1++)r.frame[e1] = w.supplyAnimationFrameDefaults(t1.frame[e1] || {});
                    else r.frame = w.supplyAnimationFrameDefaults(t1.frame || {});
                    if (Array.isArray(t1.transition)) for(r.transition = [], e1 = 0; e1 < t1.transition.length; e1++)r.transition[e1] = w.supplyAnimationTransitionDefaults(t1.transition[e1] || {});
                    else r.transition = w.supplyAnimationTransitionDefaults(t1.transition || {});
                    return r;
                }, w.supplyAnimationFrameDefaults = function(t1) {
                    var e1 = {};
                    function r(r, n) {
                        return h.coerce(t1 || {}, e1, y.frame, r, n);
                    }
                    return r("duration"), r("redraw"), e1;
                }, w.supplyAnimationTransitionDefaults = function(t1) {
                    var e1 = {};
                    function r(r, n) {
                        return h.coerce(t1 || {}, e1, y.transition, r, n);
                    }
                    return r("duration"), r("easing"), e1;
                }, w.supplyFrameDefaults = function(t1) {
                    var e1 = {};
                    function r(r, n) {
                        return h.coerce(t1, e1, v, r, n);
                    }
                    return r("group"), r("name"), r("traces"), r("baseframe"), r("data"), r("layout"), e1;
                }, w.supplyTraceDefaults = function(t1, e1, r, n, i) {
                    var a, o = n.colorway || f.defaults, s = o[r % o.length];
                    function c(r, n) {
                        return h.coerce(t1, e1, w.attributes, r, n);
                    }
                    var u = c("visible");
                    c("type"), c("name", n._traceWord + " " + i), c("uirevision", n.uirevision);
                    var p = w.getModule(e1);
                    if (e1._module = p, p) {
                        var d = p.basePlotModule, m = d.attr, g = d.attributes;
                        if (m && g) {
                            var y = n._subplots, v = "";
                            if (u || "gl2d" !== d.name) {
                                if (Array.isArray(m)) for(a = 0; a < m.length; a++){
                                    var x = m[a], _ = h.coerce(t1, e1, g, x);
                                    y[x] && h.pushUnique(y[x], _), v += _;
                                }
                                else v = h.coerce(t1, e1, g, m);
                                y[d.name] && h.pushUnique(y[d.name], v);
                            }
                        }
                    }
                    if (u) {
                        if (c("customdata"), c("ids"), c("meta"), l.traceIs(e1, "showLegend") ? (h.coerce(t1, e1, p.attributes.showlegend ? p.attributes : w.attributes, "showlegend"), c("legend"), c("legendwidth"), c("legendgroup"), c("legendgrouptitle.text"), c("legendrank"), e1._dfltShowLegend = !0) : e1._dfltShowLegend = !1, p && p.supplyDefaults(t1, e1, s, n), l.traceIs(e1, "noOpacity") || c("opacity"), l.traceIs(e1, "notLegendIsolatable") && (e1.visible = !!e1.visible), l.traceIs(e1, "noHover") || (e1.hovertemplate || h.coerceHoverinfo(t1, e1, n), "parcats" !== e1.type && l.getComponentMethod("fx", "supplyDefaults")(t1, e1, s, n)), p && p.selectPoints) {
                            var b = c("selectedpoints");
                            h.isTypedArray(b) && (e1.selectedpoints = Array.from(b));
                        }
                        w.supplyTransformDefaults(t1, e1, n);
                    }
                    return e1;
                }, w.hasMakesDataTransform = C, w.supplyTransformDefaults = function(t1, e1, r) {
                    if (e1._length || C(t1)) {
                        var n = r._globalTransforms || [], i = r._transformModules || [];
                        if (Array.isArray(t1.transforms) || 0 !== n.length) for(var a = t1.transforms || [], o = n.concat(a), s = e1.transforms = [], l = 0; l < o.length; l++){
                            var c, u = o[l], f = u.type, p = T[f], d = !(u._module && u._module === p), m = p && "function" == typeof p.transform;
                            p || h.warn("Unrecognized transform type " + f + "."), p && p.supplyDefaults && (d || m) ? ((c = p.supplyDefaults(u, e1, r, t1)).type = f, c._module = p, h.pushUnique(i, p)) : c = h.extendFlat({}, u), s.push(c);
                        }
                    }
                }, w.supplyLayoutGlobalDefaults = function(t1, e1, r) {
                    function n(r, n) {
                        return h.coerce(t1, e1, w.layoutAttributes, r, n);
                    }
                    var i = t1.template;
                    h.isPlainObject(i) && (e1.template = i, e1._template = i.layout, e1._dataTemplate = i.data), n("autotypenumbers");
                    var a = h.coerceFont(n, "font"), o = a.size;
                    h.coerceFont(n, "title.font", a, {
                        overrideDflt: {
                            size: Math.round(1.4 * o)
                        }
                    }), n("title.text", e1._dfltTitle.plot), n("title.xref");
                    var s = n("title.yref");
                    n("title.pad.t"), n("title.pad.r"), n("title.pad.b"), n("title.pad.l");
                    var c = n("title.automargin");
                    n("title.x"), n("title.xanchor"), n("title.y"), n("title.yanchor"), n("title.subtitle.text", e1._dfltTitle.subtitle), h.coerceFont(n, "title.subtitle.font", a, {
                        overrideDflt: {
                            size: Math.round(.7 * e1.title.font.size)
                        }
                    }), c && ("paper" === s && (0 !== e1.title.y && (e1.title.y = 1), "auto" === e1.title.yanchor && (e1.title.yanchor = 0 === e1.title.y ? "top" : "bottom")), "container" === s && ("auto" === e1.title.y && (e1.title.y = 1), "auto" === e1.title.yanchor && (e1.title.yanchor = e1.title.y < .5 ? "bottom" : "top"))), n("uniformtext.mode") && n("uniformtext.minsize"), n("autosize", !(t1.width && t1.height)), n("width"), n("height"), n("minreducedwidth"), n("minreducedheight"), n("margin.l"), n("margin.r"), n("margin.t"), n("margin.b"), n("margin.pad"), n("margin.autoexpand"), t1.width && t1.height && w.sanitizeMargins(e1), l.getComponentMethod("grid", "sizeDefaults")(t1, e1), n("paper_bgcolor"), n("separators", r.decimal + r.thousands), n("hidesources"), n("colorway"), n("datarevision");
                    var u = n("uirevision");
                    n("editrevision", u), n("selectionrevision", u), l.getComponentMethod("modebar", "supplyLayoutDefaults")(t1, e1), l.getComponentMethod("shapes", "supplyDrawNewShapeDefaults")(t1, e1, n), l.getComponentMethod("selections", "supplyDrawNewSelectionDefaults")(t1, e1, n), n("meta"), h.isPlainObject(t1.transition) && (n("transition.duration"), n("transition.easing"), n("transition.ordering")), l.getComponentMethod("calendars", "handleDefaults")(t1, e1, "calendar"), l.getComponentMethod("fx", "supplyLayoutGlobalDefaults")(t1, e1, n), h.coerce(t1, e1, g, "scattermode");
                }, w.plotAutoSize = function(t1, e1, r) {
                    var n, i, a = t1._context || {}, s = a.frameMargins, l = h.isPlotDiv(t1);
                    if (l && t1.emit("plotly_autosize"), a.fillFrame) n = window.innerWidth, i = window.innerHeight, document.body.style.overflow = "hidden";
                    else {
                        var c = l ? window.getComputedStyle(t1) : {};
                        if (n = I(c.width) || I(c.maxWidth) || r.width, i = I(c.height) || I(c.maxHeight) || r.height, o(s) && s > 0) {
                            var u = 1 - 2 * s;
                            n = Math.round(u * n), i = Math.round(u * i);
                        }
                    }
                    var f = w.layoutAttributes.width.min, p = w.layoutAttributes.height.min;
                    n < f && (n = f), i < p && (i = p);
                    var d = !e1.width && Math.abs(r.width - n) > 1, m = !e1.height && Math.abs(r.height - i) > 1;
                    (m || d) && (d && (r.width = n), m && (r.height = i)), t1._initialAutoSize || (t1._initialAutoSize = {
                        width: n,
                        height: i
                    }), w.sanitizeMargins(r);
                }, w.supplyLayoutModuleDefaults = function(t1, e1, r, n) {
                    var i, a, o, s = l.componentsRegistry, c = e1._basePlotModules, u = l.subplotsRegistry.cartesian;
                    for(i in s)(o = s[i]).includeBasePlot && o.includeBasePlot(t1, e1);
                    for(var f in c.length || c.push(u), e1._has("cartesian") && (l.getComponentMethod("grid", "contentDefaults")(t1, e1), u.finalizeSubplots(t1, e1)), e1._subplots)e1._subplots[f].sort(h.subplotSort);
                    for(a = 0; a < c.length; a++)(o = c[a]).supplyLayoutDefaults && o.supplyLayoutDefaults(t1, e1, r);
                    var p = e1._modules;
                    for(a = 0; a < p.length; a++)(o = p[a]).supplyLayoutDefaults && o.supplyLayoutDefaults(t1, e1, r);
                    var d = e1._transformModules;
                    for(a = 0; a < d.length; a++)(o = d[a]).supplyLayoutDefaults && o.supplyLayoutDefaults(t1, e1, r, n);
                    for(i in s)(o = s[i]).supplyLayoutDefaults && o.supplyLayoutDefaults(t1, e1, r);
                }, w.purge = function(t1) {
                    var e1 = t1._fullLayout || {};
                    void 0 !== e1._glcontainer && (e1._glcontainer.selectAll(".gl-canvas").remove(), e1._glcontainer.remove(), e1._glcanvas = null), e1._modeBar && e1._modeBar.destroy(), t1._transitionData && (t1._transitionData._interruptCallbacks && (t1._transitionData._interruptCallbacks.length = 0), t1._transitionData._animationRaf && window.cancelAnimationFrame(t1._transitionData._animationRaf)), h.clearThrottle(), h.clearResponsive(t1), delete t1.data, delete t1.layout, delete t1._fullData, delete t1._fullLayout, delete t1.calcdata, delete t1.empty, delete t1.fid, delete t1.undoqueue, delete t1.undonum, delete t1.autoplay, delete t1.changed, delete t1._promises, delete t1._redrawTimer, delete t1._hmlumcount, delete t1._hmpixcount, delete t1._transitionData, delete t1._transitioning, delete t1._initialAutoSize, delete t1._transitioningWithDuration, delete t1._dragging, delete t1._dragged, delete t1._dragdata, delete t1._hoverdata, delete t1._snapshotInProgress, delete t1._editing, delete t1._mouseDownTime, delete t1._legendMouseDownTime, t1.removeAllListeners && t1.removeAllListeners();
                }, w.style = function(t1) {
                    var e1, r = t1._fullLayout._visibleModules, n = [];
                    for(e1 = 0; e1 < r.length; e1++){
                        var i = r[e1];
                        i.style && h.pushUnique(n, i.style);
                    }
                    for(e1 = 0; e1 < n.length; e1++)n[e1](t1);
                }, w.sanitizeMargins = function(t1) {
                    if (t1 && t1.margin) {
                        var e1, r = t1.width, n = t1.height, i = t1.margin, a = r - (i.l + i.r), o = n - (i.t + i.b);
                        a < 0 && (e1 = (r - 1) / (i.l + i.r), i.l = Math.floor(e1 * i.l), i.r = Math.floor(e1 * i.r)), o < 0 && (e1 = (n - 1) / (i.t + i.b), i.t = Math.floor(e1 * i.t), i.b = Math.floor(e1 * i.b));
                    }
                }, w.clearAutoMarginIds = function(t1) {
                    t1._fullLayout._pushmarginIds = {};
                }, w.allowAutoMargin = function(t1, e1) {
                    t1._fullLayout._pushmarginIds[e1] = 1;
                }, w.autoMargin = function(t1, e1, r) {
                    var n = t1._fullLayout, i = n.width, a = n.height, o = n.margin, s = n.minreducedwidth, l = n.minreducedheight, c = h.constrain(i - o.l - o.r, 2, s), u = h.constrain(a - o.t - o.b, 2, l), f = Math.max(0, i - c), p = Math.max(0, a - u), d = n._pushmargin, m = n._pushmarginIds;
                    if (!1 !== o.autoexpand) {
                        if (r) {
                            var g = r.pad;
                            if (void 0 === g && (g = Math.min(12, o.l, o.r, o.t, o.b)), f) {
                                var y = (r.l + r.r) / f;
                                y > 1 && (r.l /= y, r.r /= y);
                            }
                            if (p) {
                                var v = (r.t + r.b) / p;
                                v > 1 && (r.t /= v, r.b /= v);
                            }
                            var x = void 0 !== r.xl ? r.xl : r.x, _ = void 0 !== r.xr ? r.xr : r.x, b = void 0 !== r.yt ? r.yt : r.y, T = void 0 !== r.yb ? r.yb : r.y;
                            d[e1] = {
                                l: {
                                    val: x,
                                    size: r.l + g
                                },
                                r: {
                                    val: _,
                                    size: r.r + g
                                },
                                b: {
                                    val: T,
                                    size: r.b + g
                                },
                                t: {
                                    val: b,
                                    size: r.t + g
                                }
                            }, m[e1] = 1;
                        } else delete d[e1], delete m[e1];
                        if (!n._replotting) return w.doAutoMargin(t1);
                    }
                }, w.doAutoMargin = function(t1) {
                    var e1 = t1._fullLayout, r = e1.width, n = e1.height;
                    e1._size || (e1._size = {}), P(e1);
                    var i = e1._size, a = e1.margin, s = {
                        t: 0,
                        b: 0,
                        l: 0,
                        r: 0
                    }, c = h.extendFlat({}, i), u = a.l, f = a.r, p = a.t, m = a.b, g = e1._pushmargin, y = e1._pushmarginIds, v = e1.minreducedwidth, x = e1.minreducedheight;
                    if (!1 !== a.autoexpand) {
                        for(var _ in g)y[_] || delete g[_];
                        var b = t1._fullLayout._reservedMargin;
                        for(var T in b)for(var k in b[T]){
                            var A = b[T][k];
                            s[k] = Math.max(s[k], A);
                        }
                        for(var M in g.base = {
                            l: {
                                val: 0,
                                size: u
                            },
                            r: {
                                val: 1,
                                size: f
                            },
                            t: {
                                val: 1,
                                size: p
                            },
                            b: {
                                val: 0,
                                size: m
                            }
                        }, s){
                            var S = 0;
                            for(var E in g)"base" !== E && o(g[E][M].size) && (S = g[E][M].size > S ? g[E][M].size : S);
                            var C = Math.max(0, a[M] - S);
                            s[M] = Math.max(0, s[M] - C);
                        }
                        for(var L in g){
                            var I = g[L].l || {}, z = g[L].b || {}, O = I.val, D = I.size, R = z.val, F = z.size, B = r - s.r - s.l, N = n - s.t - s.b;
                            for(var j in g){
                                if (o(D) && g[j].r) {
                                    var U = g[j].r.val, V = g[j].r.size;
                                    if (U > O) {
                                        var q = (D * U + (V - B) * O) / (U - O), H = (V * (1 - O) + (D - B) * (1 - U)) / (U - O);
                                        q + H > u + f && (u = q, f = H);
                                    }
                                }
                                if (o(F) && g[j].t) {
                                    var G = g[j].t.val, Z = g[j].t.size;
                                    if (G > R) {
                                        var W = (F * G + (Z - N) * R) / (G - R), Y = (Z * (1 - R) + (F - N) * (1 - G)) / (G - R);
                                        W + Y > m + p && (m = W, p = Y);
                                    }
                                }
                            }
                        }
                    }
                    var X = h.constrain(r - a.l - a.r, 2, v), $ = h.constrain(n - a.t - a.b, 2, x), J = Math.max(0, r - X), K = Math.max(0, n - $);
                    if (J) {
                        var Q = (u + f) / J;
                        Q > 1 && (u /= Q, f /= Q);
                    }
                    if (K) {
                        var tt = (m + p) / K;
                        tt > 1 && (m /= tt, p /= tt);
                    }
                    if (i.l = Math.round(u) + s.l, i.r = Math.round(f) + s.r, i.t = Math.round(p) + s.t, i.b = Math.round(m) + s.b, i.p = Math.round(a.pad), i.w = Math.round(r) - i.l - i.r, i.h = Math.round(n) - i.t - i.b, !e1._replotting && (w.didMarginChange(c, i) || function(t1) {
                        if ("_redrawFromAutoMarginCount" in t1._fullLayout) return !1;
                        var e1 = d.list(t1, "", !0);
                        for(var r in e1)if (e1[r].autoshift || e1[r].shift) return !0;
                        return !1;
                    }(t1))) {
                        "_redrawFromAutoMarginCount" in e1 ? e1._redrawFromAutoMarginCount++ : e1._redrawFromAutoMarginCount = 1;
                        var et = 3 * (1 + Object.keys(y).length);
                        if (e1._redrawFromAutoMarginCount < et) return l.call("_doPlot", t1);
                        e1._size = c, h.warn("Too many auto-margin redraws.");
                    }
                    !function(t1) {
                        var e1 = d.list(t1, "", !0);
                        [
                            "_adjustTickLabelsOverflow",
                            "_hideCounterAxisInsideTickLabels"
                        ].forEach(function(t1) {
                            for(var r = 0; r < e1.length; r++){
                                var n = e1[r][t1];
                                n && n();
                            }
                        });
                    }(t1);
                };
                var z = [
                    "l",
                    "r",
                    "t",
                    "b",
                    "p",
                    "w",
                    "h"
                ];
                function O(t1, e1, r) {
                    var n = !1, i = [
                        w.previousPromises,
                        function() {
                            if (t1._transitionData) return t1._transitioning = !1, function(t1) {
                                var e1 = Promise.resolve();
                                if (!t1) return e1;
                                for(; t1.length;)e1 = e1.then(t1.shift());
                                return e1;
                            }(t1._transitionData._interruptCallbacks);
                        },
                        r.prepareFn,
                        w.rehover,
                        w.reselect,
                        function() {
                            return t1.emit("plotly_transitioning", []), new Promise(function(i) {
                                t1._transitioning = !0, e1.duration > 0 && (t1._transitioningWithDuration = !0), t1._transitionData._interruptCallbacks.push(function() {
                                    n = !0;
                                }), r.redraw && t1._transitionData._interruptCallbacks.push(function() {
                                    return l.call("redraw", t1);
                                }), t1._transitionData._interruptCallbacks.push(function() {
                                    t1.emit("plotly_transitioninterrupted", []);
                                });
                                var a = 0, o = 0;
                                function s() {
                                    return a++, function() {
                                        var e1;
                                        o++, n || o !== a || (e1 = i, t1._transitionData && (function(t1) {
                                            if (t1) for(; t1.length;)t1.shift();
                                        }(t1._transitionData._interruptCallbacks), Promise.resolve().then(function() {
                                            if (r.redraw) return l.call("redraw", t1);
                                        }).then(function() {
                                            t1._transitioning = !1, t1._transitioningWithDuration = !1, t1.emit("plotly_transitioned", []);
                                        }).then(e1)));
                                    };
                                }
                                r.runFn(s), setTimeout(s());
                            });
                        }
                    ], a = h.syncOrAsync(i, t1);
                    return a && a.then || (a = Promise.resolve()), a.then(function() {
                        return t1;
                    });
                }
                w.didMarginChange = function(t1, e1) {
                    for(var r = 0; r < z.length; r++){
                        var n = z[r], i = t1[n], a = e1[n];
                        if (!o(i) || Math.abs(a - i) > 1) return !0;
                    }
                    return !1;
                }, w.graphJson = function(t1, e1, r, n, i, a) {
                    (i && e1 && !t1._fullData || i && !e1 && !t1._fullLayout) && w.supplyDefaults(t1);
                    var o = i ? t1._fullData : t1.data, l = i ? t1._fullLayout : t1.layout, c = (t1._transitionData || {})._frames;
                    function u(t1, e1) {
                        if ("function" == typeof t1) return e1 ? "_function_" : null;
                        if (h.isPlainObject(t1)) {
                            var n, i = {};
                            return Object.keys(t1).sort().forEach(function(a) {
                                if (-1 === [
                                    "_",
                                    "["
                                ].indexOf(a.charAt(0))) {
                                    if ("function" != typeof t1[a]) {
                                        if ("keepdata" === r) {
                                            if ("src" === a.substr(a.length - 3)) return;
                                        } else if ("keepstream" === r) {
                                            if ("string" == typeof (n = t1[a + "src"]) && n.indexOf(":") > 0 && !h.isPlainObject(t1.stream)) return;
                                        } else if ("keepall" !== r && "string" == typeof (n = t1[a + "src"]) && n.indexOf(":") > 0) return;
                                        i[a] = u(t1[a], e1);
                                    } else e1 && (i[a] = "_function");
                                }
                            }), i;
                        }
                        var a = Array.isArray(t1), o = h.isTypedArray(t1);
                        if ((a || o) && t1.dtype && t1.shape) {
                            var l = t1.bdata;
                            return u({
                                dtype: t1.dtype,
                                shape: t1.shape,
                                bdata: h.isArrayBuffer(l) ? s.encode(l) : l
                            }, e1);
                        }
                        return a ? t1.map(function(t1) {
                            return u(t1, e1);
                        }) : o ? h.simpleMap(t1, h.identity) : h.isJSDate(t1) ? h.ms2DateTimeLocal(+t1) : t1;
                    }
                    var f = {
                        data: (o || []).map(function(t1) {
                            var r = u(t1);
                            return e1 && delete r.fit, r;
                        })
                    };
                    if (!e1 && (f.layout = u(l), i)) {
                        var p = l._size;
                        f.layout.computed = {
                            margin: {
                                b: p.b,
                                l: p.l,
                                r: p.r,
                                t: p.t
                            }
                        };
                    }
                    return c && (f.frames = u(c)), a && (f.config = u(t1._context, !0)), "object" === n ? f : JSON.stringify(f);
                }, w.modifyFrames = function(t1, e1) {
                    var r, n, i, a = t1._transitionData._frames, o = t1._transitionData._frameHash;
                    for(r = 0; r < e1.length; r++)switch((n = e1[r]).type){
                        case "replace":
                            i = n.value;
                            var s = (a[n.index] || {}).name, l = i.name;
                            a[n.index] = o[l] = i, l !== s && (delete o[s], o[l] = i);
                            break;
                        case "insert":
                            o[(i = n.value).name] = i, a.splice(n.index, 0, i);
                            break;
                        case "delete":
                            delete o[(i = a[n.index]).name], a.splice(n.index, 1);
                    }
                    return Promise.resolve();
                }, w.computeFrame = function(t1, e1) {
                    var r, n, i, a, o = t1._transitionData._frameHash;
                    if (!e1) throw new Error("computeFrame must be given a string frame name");
                    var s = o[e1.toString()];
                    if (!s) return !1;
                    for(var l = [
                        s
                    ], c = [
                        s.name
                    ]; s.baseframe && (s = o[s.baseframe.toString()]) && -1 === c.indexOf(s.name);)l.push(s), c.push(s.name);
                    for(var u = {}; s = l.pop();)if (s.layout && (u.layout = w.extendLayout(u.layout, s.layout)), s.data) {
                        if (u.data || (u.data = []), !(n = s.traces)) for(n = [], r = 0; r < s.data.length; r++)n[r] = r;
                        for(u.traces || (u.traces = []), r = 0; r < s.data.length; r++)null != (i = n[r]) && (-1 === (a = u.traces.indexOf(i)) && (a = u.data.length, u.traces[a] = i), u.data[a] = w.extendTrace(u.data[a], s.data[r]));
                    }
                    return u;
                }, w.recomputeFrameHash = function(t1) {
                    for(var e1 = t1._transitionData._frameHash = {}, r = t1._transitionData._frames, n = 0; n < r.length; n++){
                        var i = r[n];
                        i && i.name && (e1[i.name] = i);
                    }
                }, w.extendObjectWithContainers = function(t1, e1, r) {
                    var n, i, a, o, s, l, c, u = h.extendDeepNoArrays({}, e1 || {}), f = h.expandObjectPaths(u), p = {};
                    if (r && r.length) for(a = 0; a < r.length; a++)void 0 === (i = (n = h.nestedProperty(f, r[a])).get()) ? h.nestedProperty(p, r[a]).set(null) : (n.set(null), h.nestedProperty(p, r[a]).set(i));
                    if (t1 = h.extendDeepNoArrays(t1 || {}, f), r && r.length) {
                        for(a = 0; a < r.length; a++)if (l = h.nestedProperty(p, r[a]).get()) {
                            for(c = (s = h.nestedProperty(t1, r[a])).get(), Array.isArray(c) || (c = [], s.set(c)), o = 0; o < l.length; o++){
                                var d = l[o];
                                c[o] = null === d ? null : w.extendObjectWithContainers(c[o], d);
                            }
                            s.set(c);
                        }
                    }
                    return t1;
                }, w.dataArrayContainers = [
                    "transforms",
                    "dimensions"
                ], w.layoutArrayContainers = l.layoutArrayContainers, w.extendTrace = function(t1, e1) {
                    return w.extendObjectWithContainers(t1, e1, w.dataArrayContainers);
                }, w.extendLayout = function(t1, e1) {
                    return w.extendObjectWithContainers(t1, e1, w.layoutArrayContainers);
                }, w.transition = function(t1, e1, r, n, i, a) {
                    var o = {
                        redraw: i.redraw
                    }, s = {}, l = [];
                    return o.prepareFn = function() {
                        for(var i = Array.isArray(e1) ? e1.length : 0, a = n.slice(0, i), o = 0; o < a.length; o++){
                            var c = a[o], u = t1._fullData[c]._module;
                            if (u) {
                                if (u.animatable) {
                                    var f = u.basePlotModule.name;
                                    s[f] || (s[f] = []), s[f].push(c);
                                }
                                t1.data[a[o]] = w.extendTrace(t1.data[a[o]], e1[o]);
                            }
                        }
                        var p = h.expandObjectPaths(h.extendDeepNoArrays({}, r)), d = /^[xy]axis[0-9]*$/;
                        for(var m in p)d.test(m) && delete p[m].range;
                        w.extendLayout(t1.layout, p), delete t1.calcdata, w.supplyDefaults(t1), w.doCalcdata(t1);
                        var g = h.expandObjectPaths(r);
                        if (g) {
                            var y = t1._fullLayout._plots;
                            for(var v in y){
                                var x = y[v], _ = x.xaxis, b = x.yaxis, T = _.range.slice(), k = b.range.slice(), A = null, M = null, S = null, E = null;
                                Array.isArray(g[_._name + ".range"]) ? A = g[_._name + ".range"].slice() : Array.isArray((g[_._name] || {}).range) && (A = g[_._name].range.slice()), Array.isArray(g[b._name + ".range"]) ? M = g[b._name + ".range"].slice() : Array.isArray((g[b._name] || {}).range) && (M = g[b._name].range.slice()), T && A && (_.r2l(T[0]) !== _.r2l(A[0]) || _.r2l(T[1]) !== _.r2l(A[1])) && (S = {
                                    xr0: T,
                                    xr1: A
                                }), k && M && (b.r2l(k[0]) !== b.r2l(M[0]) || b.r2l(k[1]) !== b.r2l(M[1])) && (E = {
                                    yr0: k,
                                    yr1: M
                                }), (S || E) && l.push(h.extendFlat({
                                    plotinfo: x
                                }, S, E));
                            }
                        }
                        return Promise.resolve();
                    }, o.runFn = function(e1) {
                        var n, i, o = t1._fullLayout._basePlotModules, c = l.length;
                        if (r) for(i = 0; i < o.length; i++)o[i].transitionAxes && o[i].transitionAxes(t1, l, a, e1);
                        for(var u in c ? ((n = h.extendFlat({}, a)).duration = 0, delete s.cartesian) : n = a, s){
                            var f = s[u];
                            t1._fullData[f[0]]._module.basePlotModule.plot(t1, f, n, e1);
                        }
                    }, O(t1, a, o);
                }, w.transitionFromReact = function(t1, e1, r, n) {
                    var i = t1._fullLayout, a = i.transition, o = {}, s = [];
                    return o.prepareFn = function() {
                        var t1 = i._plots;
                        for(var a in o.redraw = !1, "some" === e1.anim && (o.redraw = !0), "some" === r.anim && (o.redraw = !0), t1){
                            var l = t1[a], c = l.xaxis, u = l.yaxis, f = n[c._name].range.slice(), p = n[u._name].range.slice(), d = c.range.slice(), m = u.range.slice();
                            c.setScale(), u.setScale();
                            var g = null, y = null;
                            c.r2l(f[0]) === c.r2l(d[0]) && c.r2l(f[1]) === c.r2l(d[1]) || (g = {
                                xr0: f,
                                xr1: d
                            }), u.r2l(p[0]) === u.r2l(m[0]) && u.r2l(p[1]) === u.r2l(m[1]) || (y = {
                                yr0: p,
                                yr1: m
                            }), (g || y) && s.push(h.extendFlat({
                                plotinfo: l
                            }, g, y));
                        }
                        return Promise.resolve();
                    }, o.runFn = function(r) {
                        for(var n, i, o, l = t1._fullData, c = t1._fullLayout._basePlotModules, u = [], f = 0; f < l.length; f++)u.push(f);
                        function p() {
                            if (t1._fullLayout) for(var e1 = 0; e1 < c.length; e1++)c[e1].transitionAxes && c[e1].transitionAxes(t1, s, n, r);
                        }
                        function d() {
                            if (t1._fullLayout) for(var e1 = 0; e1 < c.length; e1++)c[e1].plot(t1, o, i, r);
                        }
                        s.length && e1.anim ? "traces first" === a.ordering ? (n = h.extendFlat({}, a, {
                            duration: 0
                        }), o = u, i = a, setTimeout(p, a.duration), d()) : (n = a, o = null, i = h.extendFlat({}, a, {
                            duration: 0
                        }), setTimeout(d, n.duration), p()) : s.length ? (n = a, p()) : e1.anim && (o = u, i = a, d());
                    }, O(t1, a, o);
                }, w.doCalcdata = function(t1, e1) {
                    var r, n, i, a, o = d.list(t1), s = t1._fullData, u = t1._fullLayout, f = new Array(s.length), m = (t1.calcdata || []).slice();
                    for(t1.calcdata = f, u._numBoxes = 0, u._numViolins = 0, u._violinScaleGroupStats = {}, t1._hmpixcount = 0, t1._hmlumcount = 0, u._piecolormap = {}, u._sunburstcolormap = {}, u._treemapcolormap = {}, u._iciclecolormap = {}, u._funnelareacolormap = {}, i = 0; i < s.length; i++)Array.isArray(e1) && -1 === e1.indexOf(i) && (f[i] = m[i]);
                    for(i = 0; i < s.length; i++)(r = s[i])._arrayAttrs = c.findArrayAttributes(r), r._extremes = {};
                    var g = u._subplots.polar || [];
                    for(i = 0; i < g.length; i++)o.push(u[g[i]].radialaxis, u[g[i]].angularaxis);
                    for(var y in u._colorAxes){
                        var v = u[y];
                        !1 !== v.cauto && (delete v.cmin, delete v.cmax);
                    }
                    var x = !1;
                    function _(e1) {
                        if (r = s[e1], n = r._module, !0 === r.visible && r.transforms) {
                            if (n && n.calc) {
                                var i = n.calc(t1, r);
                                i[0] && i[0].t && i[0].t._scene && delete i[0].t._scene.dirty;
                            }
                            for(a = 0; a < r.transforms.length; a++){
                                var o = r.transforms[a];
                                (n = T[o.type]) && n.calcTransform && (r._hasCalcTransform = !0, x = !0, n.calcTransform(t1, r, o));
                            }
                        }
                    }
                    function b(e1, i) {
                        if (r = s[e1], !!(n = r._module).isContainer === i) {
                            var o = [];
                            if (!0 === r.visible && 0 !== r._length) {
                                delete r._indexToPoints;
                                var l = r.transforms || [];
                                for(a = l.length - 1; a >= 0; a--)if (l[a].enabled) {
                                    r._indexToPoints = l[a]._indexToPoints;
                                    break;
                                }
                                n && n.calc && (o = n.calc(t1, r));
                            }
                            Array.isArray(o) && o[0] || (o = [
                                {
                                    x: p,
                                    y: p
                                }
                            ]), o[0].t || (o[0].t = {}), o[0].trace = r, f[e1] = o;
                        }
                    }
                    for(R(o, s, u), i = 0; i < s.length; i++)b(i, !0);
                    for(i = 0; i < s.length; i++)_(i);
                    for(x && R(o, s, u), i = 0; i < s.length; i++)b(i, !0);
                    for(i = 0; i < s.length; i++)b(i, !1);
                    F(t1);
                    var w = function(t1, e1) {
                        var r, n, i, a, o, s = [];
                        function c(t1, r, n) {
                            var i = r._id.charAt(0);
                            if ("histogram2dcontour" === t1) {
                                var a = r._counterAxes[0], o = d.getFromId(e1, a), s = "x" === i || "x" === a && "category" === o.type, l = "y" === i || "y" === a && "category" === o.type;
                                return function(t1, e1) {
                                    return 0 === t1 || 0 === e1 || s && t1 === n[e1].length - 1 || l && e1 === n.length - 1 ? -1 : ("y" === i ? e1 : t1) - 1;
                                };
                            }
                            return function(t1, e1) {
                                return "y" === i ? e1 : t1;
                            };
                        }
                        var u = {
                            min: function(t1) {
                                return h.aggNums(Math.min, null, t1);
                            },
                            max: function(t1) {
                                return h.aggNums(Math.max, null, t1);
                            },
                            sum: function(t1) {
                                return h.aggNums(function(t1, e1) {
                                    return t1 + e1;
                                }, null, t1);
                            },
                            total: function(t1) {
                                return h.aggNums(function(t1, e1) {
                                    return t1 + e1;
                                }, null, t1);
                            },
                            mean: function(t1) {
                                return h.mean(t1);
                            },
                            "geometric mean": function(t1) {
                                return h.geometricMean(t1);
                            },
                            median: function(t1) {
                                return h.median(t1);
                            }
                        };
                        function f(t1, e1) {
                            return t1[1] - e1[1];
                        }
                        function p(t1, e1) {
                            return e1[1] - t1[1];
                        }
                        for(r = 0; r < t1.length; r++){
                            var m = t1[r];
                            if ("category" === m.type) {
                                var g = m.categoryorder.match(D);
                                if (g) {
                                    var y = g[1], v = g[2], x = m._id.charAt(0), _ = "x" === x, b = [];
                                    for(n = 0; n < m._categories.length; n++)b.push([
                                        m._categories[n],
                                        []
                                    ]);
                                    for(n = 0; n < m._traceIndices.length; n++){
                                        var w = m._traceIndices[n], T = e1._fullData[w];
                                        if (!0 === T.visible) {
                                            var k = T.type;
                                            l.traceIs(T, "histogram") && (delete T._xautoBinFinished, delete T._yautoBinFinished);
                                            var A = "splom" === k, M = "scattergl" === k, S = e1.calcdata[w];
                                            for(i = 0; i < S.length; i++){
                                                var E, C, L = S[i];
                                                if (A) {
                                                    var I = T._axesDim[m._id];
                                                    if (!_) {
                                                        var P = T._diag[I][0];
                                                        P && (m = e1._fullLayout[d.id2name(P)]);
                                                    }
                                                    var z = L.trace.dimensions[I].values;
                                                    for(a = 0; a < z.length; a++)for(E = m._categoriesMap[z[a]], o = 0; o < L.trace.dimensions.length; o++)if (o !== I) {
                                                        var O = L.trace.dimensions[o];
                                                        b[E][1].push(O.values[a]);
                                                    }
                                                } else if (M) {
                                                    for(a = 0; a < L.t.x.length; a++)_ ? (E = L.t.x[a], C = L.t.y[a]) : (E = L.t.y[a], C = L.t.x[a]), b[E][1].push(C);
                                                    L.t && L.t._scene && delete L.t._scene.dirty;
                                                } else if (L.hasOwnProperty("z")) {
                                                    C = L.z;
                                                    var R = c(T.type, m, C);
                                                    for(a = 0; a < C.length; a++)for(o = 0; o < C[a].length; o++)(E = R(o, a)) + 1 && b[E][1].push(C[a][o]);
                                                } else for(void 0 === (E = L.p) && (E = L[x]), void 0 === (C = L.s) && (C = L.v), void 0 === C && (C = _ ? L.y : L.x), Array.isArray(C) || (C = void 0 === C ? [] : [
                                                    C
                                                ]), a = 0; a < C.length; a++)b[E][1].push(C[a]);
                                            }
                                        }
                                    }
                                    m._categoriesValue = b;
                                    var F = [];
                                    for(n = 0; n < b.length; n++)F.push([
                                        b[n][0],
                                        u[y](b[n][1])
                                    ]);
                                    F.sort("descending" === v ? p : f), m._categoriesAggregatedValue = F, m._initialCategories = F.map(function(t1) {
                                        return t1[0];
                                    }), s = s.concat(m.sortByInitialCategories());
                                }
                            }
                        }
                        return s;
                    }(o, t1);
                    if (w.length) {
                        for(u._numBoxes = 0, u._numViolins = 0, i = 0; i < w.length; i++)b(w[i], !0);
                        for(i = 0; i < w.length; i++)b(w[i], !1);
                        F(t1);
                    }
                    l.getComponentMethod("fx", "calc")(t1), l.getComponentMethod("errorbars", "calc")(t1);
                };
                var D = /(total|sum|min|max|mean|geometric mean|median) (ascending|descending)/;
                function R(t1, e1, r) {
                    var n = {};
                    function i(t1) {
                        t1.clearCalc(), "multicategory" === t1.type && t1.setupMultiCategory(e1), n[t1._id] = 1;
                    }
                    h.simpleMap(t1, i);
                    for(var a = r._axisMatchGroups || [], o = 0; o < a.length; o++)for(var s in a[o])n[s] || i(r[d.id2name(s)]);
                }
                function F(t1) {
                    var e1, r, n, i = t1._fullLayout, a = i._visibleModules, o = {};
                    for(r = 0; r < a.length; r++){
                        var s = a[r], l = s.crossTraceCalc;
                        if (l) {
                            var c = s.basePlotModule.name;
                            o[c] ? h.pushUnique(o[c], l) : o[c] = [
                                l
                            ];
                        }
                    }
                    for(n in o){
                        var u = o[n], f = i._subplots[n];
                        if (Array.isArray(f)) for(e1 = 0; e1 < f.length; e1++){
                            var p = f[e1], d = "cartesian" === n ? i._plots[p] : i[p];
                            for(r = 0; r < u.length; r++)u[r](t1, d, p);
                        }
                        else for(r = 0; r < u.length; r++)u[r](t1);
                    }
                }
                w.rehover = function(t1) {
                    t1._fullLayout._rehover && t1._fullLayout._rehover();
                }, w.redrag = function(t1) {
                    t1._fullLayout._redrag && t1._fullLayout._redrag();
                }, w.reselect = function(t1) {
                    var e1 = t1._fullLayout, r = (t1.layout || {}).selections, n = e1._previousSelections;
                    e1._previousSelections = r;
                    var i = e1._reselect || JSON.stringify(r) !== JSON.stringify(n);
                    l.getComponentMethod("selections", "reselect")(t1, i);
                }, w.generalUpdatePerTraceModule = function(t1, e1, r, n) {
                    var i, a = e1.traceHash, o = {};
                    for(i = 0; i < r.length; i++){
                        var s = r[i], l = s[0].trace;
                        l.visible && (o[l.type] = o[l.type] || [], o[l.type].push(s));
                    }
                    for(var c in a)if (!o[c]) {
                        var u = a[c][0];
                        u[0].trace.visible = !1, o[c] = [
                            u
                        ];
                    }
                    for(var f in o){
                        var p = o[f];
                        p[0][0].trace._module.plot(t1, e1, h.filterVisible(p), n);
                    }
                    e1.traceHash = o;
                }, w.plotBasePlot = function(t1, e1, r, n, i) {
                    var a = l.getModule(t1), o = x(e1.calcdata, a)[0];
                    a.plot(e1, o, n, i);
                }, w.cleanBasePlot = function(t1, e1, r, n, i) {
                    var a = i._has && i._has(t1), o = r._has && r._has(t1);
                    a && !o && i["_" + t1 + "layer"].selectAll("g.trace").remove();
                };
            },
            26484: function(t1) {
                "use strict";
                t1.exports = {
                    attr: "subplot",
                    name: "polar",
                    axisNames: [
                        "angularaxis",
                        "radialaxis"
                    ],
                    axisName2dataArray: {
                        angularaxis: "theta",
                        radialaxis: "r"
                    },
                    layerNames: [
                        "draglayer",
                        "plotbg",
                        "backplot",
                        "angular-grid",
                        "radial-grid",
                        "frontplot",
                        "angular-line",
                        "radial-line",
                        "angular-axis",
                        "radial-axis"
                    ],
                    radialDragBoxSize: 50,
                    angularDragBoxSize: 30,
                    cornerLen: 25,
                    cornerHalfWidth: 2,
                    MINDRAG: 8,
                    MINZOOM: 20,
                    OFFEDGE: 20
                };
            },
            95928: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(80899).tester, a = n.findIndexOfMin, o = n.isAngleInsideSector, s = n.angleDelta, l = n.angleDist;
                function c(t1, e1, r, n) {
                    var i, a, o = n[0], s = n[1], l = h(Math.sin(e1) - Math.sin(t1)), c = h(Math.cos(e1) - Math.cos(t1)), u = Math.tan(r), f = h(1 / u), p = l / c, d = s - p * o;
                    return f ? l && c ? a = u * (i = d / (u - p)) : c ? (i = s * f, a = s) : (i = o, a = o * u) : l && c ? (i = 0, a = d) : c ? (i = 0, a = s) : i = a = NaN, [
                        i,
                        a
                    ];
                }
                function u(t1, e1, r, i) {
                    return n.isFullCircle([
                        e1,
                        r
                    ]) ? function(t1, e1) {
                        var r, n = e1.length, i = new Array(n + 1);
                        for(r = 0; r < n; r++){
                            var a = e1[r];
                            i[r] = [
                                t1 * Math.cos(a),
                                t1 * Math.sin(a)
                            ];
                        }
                        return i[r] = i[0].slice(), i;
                    }(t1, i) : function(t1, e1, r, i) {
                        var s, u, h = i.length, f = [];
                        function p(e1) {
                            return [
                                t1 * Math.cos(e1),
                                t1 * Math.sin(e1)
                            ];
                        }
                        function d(t1, e1, r) {
                            return c(t1, e1, r, p(t1));
                        }
                        function m(t1) {
                            return n.mod(t1, h);
                        }
                        function g(t1) {
                            return o(t1, [
                                e1,
                                r
                            ]);
                        }
                        var y = a(i, function(t1) {
                            return g(t1) ? l(t1, e1) : 1 / 0;
                        }), v = d(i[y], i[m(y - 1)], e1);
                        for(f.push(v), s = y, u = 0; u < h; s++, u++){
                            var x = i[m(s)];
                            if (!g(x)) break;
                            f.push(p(x));
                        }
                        var _ = a(i, function(t1) {
                            return g(t1) ? l(t1, r) : 1 / 0;
                        }), b = d(i[_], i[m(_ + 1)], r);
                        return f.push(b), f.push([
                            0,
                            0
                        ]), f.push(f[0].slice()), f;
                    }(t1, e1, r, i);
                }
                function h(t1) {
                    return Math.abs(t1) > 1e-10 ? t1 : 0;
                }
                function f(t1, e1, r) {
                    e1 = e1 || 0, r = r || 0;
                    for(var n = t1.length, i = new Array(n), a = 0; a < n; a++){
                        var o = t1[a];
                        i[a] = [
                            e1 + o[0],
                            r - o[1]
                        ];
                    }
                    return i;
                }
                t1.exports = {
                    isPtInsidePolygon: function(t1, e1, r, n, a) {
                        if (!o(e1, n)) return !1;
                        var s, l;
                        r[0] < r[1] ? (s = r[0], l = r[1]) : (s = r[1], l = r[0]);
                        var c = i(u(s, n[0], n[1], a)), h = i(u(l, n[0], n[1], a)), f = [
                            t1 * Math.cos(e1),
                            t1 * Math.sin(e1)
                        ];
                        return h.contains(f) && !c.contains(f);
                    },
                    findPolygonOffset: function(t1, e1, r, n) {
                        for(var i = 1 / 0, a = 1 / 0, o = u(t1, e1, r, n), s = 0; s < o.length; s++){
                            var l = o[s];
                            i = Math.min(i, l[0]), a = Math.min(a, -l[1]);
                        }
                        return [
                            i,
                            a
                        ];
                    },
                    findEnclosingVertexAngles: function(t1, e1) {
                        var r = a(e1, function(e1) {
                            var r = s(e1, t1);
                            return r > 0 ? r : 1 / 0;
                        }), i = n.mod(r + 1, e1.length);
                        return [
                            e1[r],
                            e1[i]
                        ];
                    },
                    findIntersectionXY: c,
                    findXYatLength: function(t1, e1, r, n) {
                        var i = -e1 * r, a = e1 * e1 + 1, o = 2 * (e1 * i - r), s = i * i + r * r - t1 * t1, l = Math.sqrt(o * o - 4 * a * s), c = (-o + l) / (2 * a), u = (-o - l) / (2 * a);
                        return [
                            [
                                c,
                                e1 * c + i + n
                            ],
                            [
                                u,
                                e1 * u + i + n
                            ]
                        ];
                    },
                    clampTiny: h,
                    pathPolygon: function(t1, e1, r, n, i, a) {
                        return "M" + f(u(t1, e1, r, n), i, a).join("L");
                    },
                    pathPolygonAnnulus: function(t1, e1, r, n, i, a, o) {
                        var s, l;
                        t1 < e1 ? (s = t1, l = e1) : (s = e1, l = t1);
                        var c = f(u(s, r, n, i), a, o);
                        return "M" + f(u(l, r, n, i), a, o).reverse().join("L") + "M" + c.join("L");
                    }
                };
            },
            31645: function(t1, e1, r) {
                "use strict";
                var n = r(4173).fX, i = r(34809).counterRegex, a = r(35785), o = r(26484), s = o.attr, l = o.name, c = i(l), u = {};
                u[s] = {
                    valType: "subplotid",
                    dflt: l,
                    editType: "calc"
                }, t1.exports = {
                    attr: s,
                    name: l,
                    idRoot: l,
                    idRegex: c,
                    attrRegex: c,
                    attributes: u,
                    layoutAttributes: r(42219),
                    supplyLayoutDefaults: r(84588),
                    plot: function(t1) {
                        for(var e1 = t1._fullLayout, r = t1.calcdata, i = e1._subplots[l], o = 0; o < i.length; o++){
                            var s = i[o], c = n(r, l, s), u = e1[s]._subplot;
                            u || (u = a(t1, s), e1[s]._subplot = u), u.plot(c, e1, t1._promises);
                        }
                    },
                    clean: function(t1, e1, r, n) {
                        for(var i = n._subplots[l] || [], a = n._has && n._has("gl"), o = e1._has && e1._has("gl"), s = a && !o, c = 0; c < i.length; c++){
                            var u = i[c], h = n[u]._subplot;
                            if (!e1[u] && h) for(var f in h.framework.remove(), h.layers["radial-axis-title"].remove(), h.clipPaths)h.clipPaths[f].remove();
                            s && h._scene && (h._scene.destroy(), h._scene = null);
                        }
                    },
                    toSVG: r(37703).toSVG
                };
            },
            42219: function(t1, e1, r) {
                "use strict";
                var n = r(10229), i = r(25829), a = r(13792).u, o = r(34809).extendFlat, s = r(13582).overrideAll, l = s({
                    color: i.color,
                    showline: o({}, i.showline, {
                        dflt: !0
                    }),
                    linecolor: i.linecolor,
                    linewidth: i.linewidth,
                    showgrid: o({}, i.showgrid, {
                        dflt: !0
                    }),
                    gridcolor: i.gridcolor,
                    gridwidth: i.gridwidth,
                    griddash: i.griddash
                }, "plot", "from-root"), c = s({
                    tickmode: i.minor.tickmode,
                    nticks: i.nticks,
                    tick0: i.tick0,
                    dtick: i.dtick,
                    tickvals: i.tickvals,
                    ticktext: i.ticktext,
                    ticks: i.ticks,
                    ticklen: i.ticklen,
                    tickwidth: i.tickwidth,
                    tickcolor: i.tickcolor,
                    ticklabelstep: i.ticklabelstep,
                    showticklabels: i.showticklabels,
                    labelalias: i.labelalias,
                    showtickprefix: i.showtickprefix,
                    tickprefix: i.tickprefix,
                    showticksuffix: i.showticksuffix,
                    ticksuffix: i.ticksuffix,
                    showexponent: i.showexponent,
                    exponentformat: i.exponentformat,
                    minexponent: i.minexponent,
                    separatethousands: i.separatethousands,
                    tickfont: i.tickfont,
                    tickangle: i.tickangle,
                    tickformat: i.tickformat,
                    tickformatstops: i.tickformatstops,
                    layer: i.layer
                }, "plot", "from-root"), u = {
                    visible: o({}, i.visible, {
                        dflt: !0
                    }),
                    type: o({}, i.type, {
                        values: [
                            "-",
                            "linear",
                            "log",
                            "date",
                            "category"
                        ]
                    }),
                    autotypenumbers: i.autotypenumbers,
                    autorangeoptions: {
                        minallowed: i.autorangeoptions.minallowed,
                        maxallowed: i.autorangeoptions.maxallowed,
                        clipmin: i.autorangeoptions.clipmin,
                        clipmax: i.autorangeoptions.clipmax,
                        include: i.autorangeoptions.include,
                        editType: "plot"
                    },
                    autorange: o({}, i.autorange, {
                        editType: "plot"
                    }),
                    rangemode: {
                        valType: "enumerated",
                        values: [
                            "tozero",
                            "nonnegative",
                            "normal"
                        ],
                        dflt: "tozero",
                        editType: "calc"
                    },
                    minallowed: o({}, i.minallowed, {
                        editType: "plot"
                    }),
                    maxallowed: o({}, i.maxallowed, {
                        editType: "plot"
                    }),
                    range: o({}, i.range, {
                        items: [
                            {
                                valType: "any",
                                editType: "plot",
                                impliedEdits: {
                                    "^autorange": !1
                                }
                            },
                            {
                                valType: "any",
                                editType: "plot",
                                impliedEdits: {
                                    "^autorange": !1
                                }
                            }
                        ],
                        editType: "plot"
                    }),
                    categoryorder: i.categoryorder,
                    categoryarray: i.categoryarray,
                    angle: {
                        valType: "angle",
                        editType: "plot"
                    },
                    autotickangles: i.autotickangles,
                    side: {
                        valType: "enumerated",
                        values: [
                            "clockwise",
                            "counterclockwise"
                        ],
                        dflt: "clockwise",
                        editType: "plot"
                    },
                    title: {
                        text: o({}, i.title.text, {
                            editType: "plot",
                            dflt: ""
                        }),
                        font: o({}, i.title.font, {
                            editType: "plot"
                        }),
                        editType: "plot"
                    },
                    hoverformat: i.hoverformat,
                    uirevision: {
                        valType: "any",
                        editType: "none"
                    },
                    editType: "calc",
                    _deprecated: {
                        title: i._deprecated.title,
                        titlefont: i._deprecated.titlefont
                    }
                };
                o(u, l, c);
                var h = {
                    visible: o({}, i.visible, {
                        dflt: !0
                    }),
                    type: {
                        valType: "enumerated",
                        values: [
                            "-",
                            "linear",
                            "category"
                        ],
                        dflt: "-",
                        editType: "calc",
                        _noTemplating: !0
                    },
                    autotypenumbers: i.autotypenumbers,
                    categoryorder: i.categoryorder,
                    categoryarray: i.categoryarray,
                    thetaunit: {
                        valType: "enumerated",
                        values: [
                            "radians",
                            "degrees"
                        ],
                        dflt: "degrees",
                        editType: "calc"
                    },
                    period: {
                        valType: "number",
                        editType: "calc",
                        min: 0
                    },
                    direction: {
                        valType: "enumerated",
                        values: [
                            "counterclockwise",
                            "clockwise"
                        ],
                        dflt: "counterclockwise",
                        editType: "calc"
                    },
                    rotation: {
                        valType: "angle",
                        editType: "calc"
                    },
                    hoverformat: i.hoverformat,
                    uirevision: {
                        valType: "any",
                        editType: "none"
                    },
                    editType: "calc"
                };
                o(h, l, c), t1.exports = {
                    domain: a({
                        name: "polar",
                        editType: "plot"
                    }),
                    sector: {
                        valType: "info_array",
                        items: [
                            {
                                valType: "number",
                                editType: "plot"
                            },
                            {
                                valType: "number",
                                editType: "plot"
                            }
                        ],
                        dflt: [
                            0,
                            360
                        ],
                        editType: "plot"
                    },
                    hole: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 0,
                        editType: "plot"
                    },
                    bgcolor: {
                        valType: "color",
                        editType: "plot",
                        dflt: n.background
                    },
                    radialaxis: u,
                    angularaxis: h,
                    gridshape: {
                        valType: "enumerated",
                        values: [
                            "circular",
                            "linear"
                        ],
                        dflt: "circular",
                        editType: "plot"
                    },
                    uirevision: {
                        valType: "any",
                        editType: "none"
                    },
                    editType: "calc"
                };
            },
            84588: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(78766), a = r(78032), o = r(4448), s = r(4173).KO, l = r(22777), c = r(87433), u = r(12036), h = r(54616), f = r(46473), p = r(97405), d = r(75511), m = r(9666), g = r(42219), y = r(51937), v = r(26484), x = v.axisNames;
                function _(t1, e1, r, o) {
                    var m = r("bgcolor");
                    o.bgColor = i.combine(m, o.paper_bgcolor);
                    var _ = r("sector");
                    r("hole");
                    var w, T = s(o.fullData, v.name, o.id), k = o.layoutOut;
                    function A(t1, e1) {
                        return r(w + "." + t1, e1);
                    }
                    for(var M = 0; M < x.length; M++){
                        w = x[M], n.isPlainObject(t1[w]) || (t1[w] = {});
                        var S = t1[w], E = a.newContainer(e1, w);
                        E._id = E._name = w, E._attr = o.id + "." + w, E._traceIndices = T.map(function(t1) {
                            return t1._expandedIndex;
                        });
                        var C = v.axisName2dataArray[w], L = b(S, E, A, T, C, o);
                        f(S, E, A, {
                            axData: T,
                            dataAttr: C
                        });
                        var I = A("visible");
                        switch(y(E, e1, k), A("uirevision", e1.uirevision), E._m = 1, w){
                            case "radialaxis":
                                A("minallowed"), A("maxallowed");
                                var P, z = A("range"), O = E.getAutorangeDflt(z), D = A("autorange", O);
                                !z || (null !== z[0] || null !== z[1]) && (null !== z[0] && null !== z[1] || "reversed" !== D && !0 !== D) && (null === z[0] || "min" !== D && "max reversed" !== D) && (null === z[1] || "max" !== D && "min reversed" !== D) || (z = void 0, delete E.range, E.autorange = !0, P = !0), P || (D = A("autorange", O = E.getAutorangeDflt(z))), S.autorange = D, D && (d(A, D, z), "linear" !== L && "-" !== L || A("rangemode"), E.isReversed() && (E._m = -1)), E.cleanRange("range", {
                                    dfltRange: [
                                        0,
                                        1
                                    ]
                                });
                                break;
                            case "angularaxis":
                                if ("date" === L) {
                                    n.log("Polar plots do not support date angular axes yet.");
                                    for(var R = 0; R < T.length; R++)T[R].visible = !1;
                                    L = S.type = E.type = "linear";
                                }
                                A("linear" === L ? "thetaunit" : "period");
                                var F = A("direction");
                                A("rotation", {
                                    counterclockwise: 0,
                                    clockwise: 90
                                }[F]);
                        }
                        if (h(S, E, A, E.type, {
                            tickSuffixDflt: "degrees" === E.thetaunit ? "\xb0" : void 0
                        }), I) {
                            var B, N, j, U, V, q, H, G, Z, W, Y = o.font || {};
                            N = (B = A("color")) === S.color ? B : Y.color, j = Y.size, U = Y.family, V = Y.weight, q = Y.style, H = Y.variant, G = Y.textcase, Z = Y.lineposition, W = Y.shadow, l(S, E, A, E.type), u(S, E, A, E.type, {
                                font: {
                                    weight: V,
                                    style: q,
                                    variant: H,
                                    textcase: G,
                                    lineposition: Z,
                                    shadow: W,
                                    color: N,
                                    size: j,
                                    family: U
                                },
                                noAutotickangles: "angularaxis" === w,
                                noTicklabelshift: !0,
                                noTicklabelstandoff: !0
                            }), c(S, E, A, {
                                outerTicks: !0
                            }), p(S, E, A, {
                                dfltColor: B,
                                bgColor: o.bgColor,
                                blend: 60,
                                showLine: !0,
                                showGrid: !0,
                                noZeroLine: !0,
                                attributes: g[w]
                            }), A("layer"), "radialaxis" === w && (A("side"), A("angle", _[0]), A("title.text"), n.coerceFont(A, "title.font", {
                                weight: V,
                                style: q,
                                variant: H,
                                textcase: G,
                                lineposition: Z,
                                shadow: W,
                                color: N,
                                size: n.bigFont(j),
                                family: U
                            }));
                        }
                        "category" !== L && A("hoverformat"), E._input = S;
                    }
                    "category" === e1.angularaxis.type && r("gridshape");
                }
                function b(t1, e1, r, n, i, a) {
                    var o = r("autotypenumbers", a.autotypenumbersDflt);
                    if ("-" === r("type")) {
                        for(var s, l = 0; l < n.length; l++)if (n[l].visible) {
                            s = n[l];
                            break;
                        }
                        s && s[i] && (e1.type = m(s[i], "gregorian", {
                            noMultiCategory: !0,
                            autotypenumbers: o
                        })), "-" === e1.type ? e1.type = "linear" : t1.type = e1.type;
                    }
                    return e1.type;
                }
                t1.exports = function(t1, e1, r) {
                    o(t1, e1, r, {
                        type: v.name,
                        attributes: g,
                        handleDefaults: _,
                        font: e1.font,
                        autotypenumbersDflt: e1.autotypenumbers,
                        paper_bgcolor: e1.paper_bgcolor,
                        fullData: r,
                        layoutOut: e1
                    });
                };
            },
            35785: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(65657), a = r(33626), o = r(34809), s = o.strRotate, l = o.strTranslate, c = r(78766), u = r(62203), h = r(44122), f = r(29714), p = r(19091), d = r(51937), m = r(32919).doAutoRange, g = r(51680), y = r(14751), v = r(32141), x = r(17240), _ = r(44844).prepSelect, b = r(44844).selectOnClick, w = r(44844).clearOutline, T = r(27983), k = r(34823), A = r(71817).redrawReglTraces, M = r(4530).MID_SHIFT, S = r(26484), E = r(95928), C = r(52007), L = C.smith, I = C.reactanceArc, P = C.resistanceArc, z = C.smithTransform, O = o._, D = o.mod, R = o.deg2rad, F = o.rad2deg;
                function B(t1, e1, r) {
                    this.isSmith = r || !1, this.id = e1, this.gd = t1, this._hasClipOnAxisFalse = null, this.vangles = null, this.radialAxisAngle = null, this.traceHash = {}, this.layers = {}, this.clipPaths = {}, this.clipIds = {}, this.viewInitial = {};
                    var n = t1._fullLayout, i = "clip" + n._uid + e1;
                    this.clipIds.forTraces = i + "-for-traces", this.clipPaths.forTraces = n._clips.append("clipPath").attr("id", this.clipIds.forTraces), this.clipPaths.forTraces.append("path"), this.framework = n["_" + (r ? "smith" : "polar") + "layer"].append("g").attr("class", e1), this.getHole = function(t1) {
                        return this.isSmith ? 0 : t1.hole;
                    }, this.getSector = function(t1) {
                        return this.isSmith ? [
                            0,
                            360
                        ] : t1.sector;
                    }, this.getRadial = function(t1) {
                        return this.isSmith ? t1.realaxis : t1.radialaxis;
                    }, this.getAngular = function(t1) {
                        return this.isSmith ? t1.imaginaryaxis : t1.angularaxis;
                    }, r || (this.radialTickLayout = null, this.angularTickLayout = null);
                }
                var N = B.prototype;
                function j(t1) {
                    var e1 = t1.ticks + String(t1.ticklen) + String(t1.showticklabels);
                    return "side" in t1 && (e1 += t1.side), e1;
                }
                function U(t1, e1) {
                    return e1[o.findIndexOfMin(e1, function(e1) {
                        return o.angleDist(t1, e1);
                    })];
                }
                function V(t1, e1, r) {
                    return e1 ? (t1.attr("display", null), t1.attr(r)) : t1 && t1.attr("display", "none"), t1;
                }
                t1.exports = function(t1, e1, r) {
                    return new B(t1, e1, r);
                }, N.plot = function(t1, e1) {
                    for(var r = this, n = e1[r.id], i = !1, a = 0; a < t1.length; a++)if (!1 === t1[a][0].trace.cliponaxis) {
                        i = !0;
                        break;
                    }
                    r._hasClipOnAxisFalse = i, r.updateLayers(e1, n), r.updateLayout(e1, n), h.generalUpdatePerTraceModule(r.gd, r, t1, n), r.updateFx(e1, n), r.isSmith && (delete n.realaxis.range, delete n.imaginaryaxis.range);
                }, N.updateLayers = function(t1, e1) {
                    var r = this, i = r.isSmith, a = r.layers, o = r.getRadial(e1), s = r.getAngular(e1), l = S.layerNames, c = l.indexOf("frontplot"), u = l.slice(0, c), h = "below traces" === s.layer, f = "below traces" === o.layer;
                    h && u.push("angular-line"), f && u.push("radial-line"), h && u.push("angular-axis"), f && u.push("radial-axis"), u.push("frontplot"), h || u.push("angular-line"), f || u.push("radial-line"), h || u.push("angular-axis"), f || u.push("radial-axis");
                    var p = (i ? "smith" : "polar") + "sublayer", d = r.framework.selectAll("." + p).data(u, String);
                    d.enter().append("g").attr("class", function(t1) {
                        return p + " " + t1;
                    }).each(function(t1) {
                        var e1 = a[t1] = n.select(this);
                        switch(t1){
                            case "frontplot":
                                i || e1.append("g").classed("barlayer", !0), e1.append("g").classed("scatterlayer", !0);
                                break;
                            case "backplot":
                                e1.append("g").classed("maplayer", !0);
                                break;
                            case "plotbg":
                                a.bg = e1.append("path");
                                break;
                            case "radial-grid":
                            case "angular-grid":
                                e1.style("fill", "none");
                                break;
                            case "radial-line":
                                e1.append("line").style("fill", "none");
                                break;
                            case "angular-line":
                                e1.append("path").style("fill", "none");
                        }
                    }), d.order();
                }, N.updateLayout = function(t1, e1) {
                    var r = this, n = r.layers, i = t1._size, a = r.getRadial(e1), o = r.getAngular(e1), s = e1.domain.x, h = e1.domain.y;
                    r.xOffset = i.l + i.w * s[0], r.yOffset = i.t + i.h * (1 - h[1]);
                    var f = r.xLength = i.w * (s[1] - s[0]), p = r.yLength = i.h * (h[1] - h[0]), d = r.getSector(e1);
                    r.sectorInRad = d.map(R);
                    var m, g, y, v, x, _ = r.sectorBBox = function(t1) {
                        var e1, r = t1[0], n = t1[1] - r, i = D(r, 360), a = i + n, o = Math.cos(R(i)), s = Math.sin(R(i)), l = Math.cos(R(a)), c = Math.sin(R(a));
                        return e1 = i <= 90 && a >= 90 || i > 90 && a >= 450 ? 1 : s <= 0 && c <= 0 ? 0 : Math.max(s, c), [
                            i <= 180 && a >= 180 || i > 180 && a >= 540 ? -1 : o >= 0 && l >= 0 ? 0 : Math.min(o, l),
                            i <= 270 && a >= 270 || i > 270 && a >= 630 ? -1 : s >= 0 && c >= 0 ? 0 : Math.min(s, c),
                            a >= 360 ? 1 : o <= 0 && l <= 0 ? 0 : Math.max(o, l),
                            e1
                        ];
                    }(d), b = _[2] - _[0], w = _[3] - _[1], T = p / f, k = Math.abs(w / b);
                    T > k ? (m = f, x = (p - (g = f * k)) / i.h / 2, y = [
                        s[0],
                        s[1]
                    ], v = [
                        h[0] + x,
                        h[1] - x
                    ]) : (g = p, x = (f - (m = p / k)) / i.w / 2, y = [
                        s[0] + x,
                        s[1] - x
                    ], v = [
                        h[0],
                        h[1]
                    ]), r.xLength2 = m, r.yLength2 = g, r.xDomain2 = y, r.yDomain2 = v;
                    var A, M = r.xOffset2 = i.l + i.w * y[0], S = r.yOffset2 = i.t + i.h * (1 - v[1]), E = r.radius = m / b, C = r.innerRadius = r.getHole(e1) * E, L = r.cx = M - E * _[0], I = r.cy = S + E * _[3], P = r.cxx = L - M, z = r.cyy = I - S, O = a.side;
                    "counterclockwise" === O ? (A = O, O = "top") : "clockwise" === O && (A = O, O = "bottom"), r.radialAxis = r.mockAxis(t1, e1, a, {
                        _id: "x",
                        side: O,
                        _trueSide: A,
                        domain: [
                            C / i.w,
                            E / i.w
                        ]
                    }), r.angularAxis = r.mockAxis(t1, e1, o, {
                        side: "right",
                        domain: [
                            0,
                            Math.PI
                        ],
                        autorange: !1
                    }), r.doAutoRange(t1, e1), r.updateAngularAxis(t1, e1), r.updateRadialAxis(t1, e1), r.updateRadialAxisTitle(t1, e1), r.xaxis = r.mockCartesianAxis(t1, e1, {
                        _id: "x",
                        domain: y
                    }), r.yaxis = r.mockCartesianAxis(t1, e1, {
                        _id: "y",
                        domain: v
                    });
                    var F = r.pathSubplot();
                    r.clipPaths.forTraces.select("path").attr("d", F).attr("transform", l(P, z)), n.frontplot.attr("transform", l(M, S)).call(u.setClipUrl, r._hasClipOnAxisFalse ? null : r.clipIds.forTraces, r.gd), n.bg.attr("d", F).attr("transform", l(L, I)).call(c.fill, e1.bgcolor);
                }, N.mockAxis = function(t1, e1, r, n) {
                    var i = o.extendFlat({}, r, n);
                    return d(i, e1, t1), i;
                }, N.mockCartesianAxis = function(t1, e1, r) {
                    var n = this, i = n.isSmith, a = r._id, s = o.extendFlat({
                        type: "linear"
                    }, r);
                    p(s, t1);
                    var l = {
                        x: [
                            0,
                            2
                        ],
                        y: [
                            1,
                            3
                        ]
                    };
                    return s.setRange = function() {
                        var t1 = n.sectorBBox, r = l[a], i = n.radialAxis._rl, o = (i[1] - i[0]) / (1 - n.getHole(e1));
                        s.range = [
                            t1[r[0]] * o,
                            t1[r[1]] * o
                        ];
                    }, s.isPtWithinRange = "x" !== a || i ? function() {
                        return !0;
                    } : function(t1) {
                        return n.isPtInside(t1);
                    }, s.setRange(), s.setScale(), s;
                }, N.doAutoRange = function(t1, e1) {
                    var r = this, n = r.gd, i = r.radialAxis, a = r.getRadial(e1);
                    m(n, i);
                    var o = i.range;
                    if (a.range = o.slice(), a._input.range = o.slice(), i._rl = [
                        i.r2l(o[0], null, "gregorian"),
                        i.r2l(o[1], null, "gregorian")
                    ], void 0 !== i.minallowed) {
                        var s = i.r2l(i.minallowed);
                        i._rl[0] > i._rl[1] ? i._rl[1] = Math.max(i._rl[1], s) : i._rl[0] = Math.max(i._rl[0], s);
                    }
                    if (void 0 !== i.maxallowed) {
                        var l = i.r2l(i.maxallowed);
                        i._rl[0] < i._rl[1] ? i._rl[1] = Math.min(i._rl[1], l) : i._rl[0] = Math.min(i._rl[0], l);
                    }
                }, N.updateRadialAxis = function(t1, e1) {
                    var r = this, n = r.gd, i = r.layers, a = r.radius, u = r.innerRadius, h = r.cx, p = r.cy, d = r.getRadial(e1), m = D(r.getSector(e1)[0], 360), g = r.radialAxis, y = u < a, v = r.isSmith;
                    v || (r.fillViewInitialKey("radialaxis.angle", d.angle), r.fillViewInitialKey("radialaxis.range", g.range.slice()), g.setGeometry()), "auto" === g.tickangle && m > 90 && m <= 270 && (g.tickangle = 180);
                    var x = v ? function(t1) {
                        var e1 = z(r, L([
                            t1.x,
                            0
                        ]));
                        return l(e1[0] - h, e1[1] - p);
                    } : function(t1) {
                        return l(g.l2p(t1.x) + u, 0);
                    }, _ = v ? function(t1) {
                        return P(r, t1.x, -1 / 0, 1 / 0);
                    } : function(t1) {
                        return r.pathArc(g.r2p(t1.x) + u);
                    }, b = j(d);
                    if (r.radialTickLayout !== b && (i["radial-axis"].selectAll(".xtick").remove(), r.radialTickLayout = b), y) {
                        g.setScale();
                        var w = 0, T = v ? (g.tickvals || []).filter(function(t1) {
                            return t1 >= 0;
                        }).map(function(t1) {
                            return f.tickText(g, t1, !0, !1);
                        }) : f.calcTicks(g), k = v ? T : f.clipEnds(g, T), A = f.getTickSigns(g)[2];
                        v && (("top" === g.ticks && "bottom" === g.side || "bottom" === g.ticks && "top" === g.side) && (A = -A), "top" === g.ticks && "top" === g.side && (w = -g.ticklen), "bottom" === g.ticks && "bottom" === g.side && (w = g.ticklen)), f.drawTicks(n, g, {
                            vals: T,
                            layer: i["radial-axis"],
                            path: f.makeTickPath(g, 0, A),
                            transFn: x,
                            crisp: !1
                        }), f.drawGrid(n, g, {
                            vals: k,
                            layer: i["radial-grid"],
                            path: _,
                            transFn: o.noop,
                            crisp: !1
                        }), f.drawLabels(n, g, {
                            vals: T,
                            layer: i["radial-axis"],
                            transFn: x,
                            labelFns: f.makeLabelFns(g, w)
                        });
                    }
                    var M = r.radialAxisAngle = r.vangles ? F(U(R(d.angle), r.vangles)) : d.angle, S = l(h, p), E = S + s(-M);
                    V(i["radial-axis"], y && (d.showticklabels || d.ticks), {
                        transform: E
                    }), V(i["radial-grid"], y && d.showgrid, {
                        transform: v ? "" : S
                    }), V(i["radial-line"].select("line"), y && d.showline, {
                        x1: v ? -a : u,
                        y1: 0,
                        x2: a,
                        y2: 0,
                        transform: E
                    }).attr("stroke-width", d.linewidth).call(c.stroke, d.linecolor);
                }, N.updateRadialAxisTitle = function(t1, e1, r) {
                    if (!this.isSmith) {
                        var n = this, i = n.gd, a = n.radius, o = n.cx, s = n.cy, l = n.getRadial(e1), c = n.id + "title", h = 0;
                        if (l.title) {
                            var f = u.bBox(n.layers["radial-axis"].node()).height, p = l.title.font.size, d = l.side;
                            h = "top" === d ? p : "counterclockwise" === d ? -(f + .4 * p) : f + .8 * p;
                        }
                        var m = void 0 !== r ? r : n.radialAxisAngle, g = R(m), y = Math.cos(g), v = Math.sin(g), _ = o + a / 2 * y + h * v, b = s - a / 2 * v + h * y;
                        n.layers["radial-axis-title"] = x.draw(i, c, {
                            propContainer: l,
                            propName: n.id + ".radialaxis.title",
                            placeholder: O(i, "Click to enter radial axis title"),
                            attributes: {
                                x: _,
                                y: b,
                                "text-anchor": "middle"
                            },
                            transform: {
                                rotate: -m
                            }
                        });
                    }
                }, N.updateAngularAxis = function(t1, e1) {
                    var r = this, n = r.gd, i = r.layers, a = r.radius, u = r.innerRadius, h = r.cx, p = r.cy, d = r.getAngular(e1), m = r.angularAxis, g = r.isSmith;
                    g || (r.fillViewInitialKey("angularaxis.rotation", d.rotation), m.setGeometry(), m.setScale());
                    var y = g ? function(t1) {
                        var e1 = z(r, L([
                            0,
                            t1.x
                        ]));
                        return Math.atan2(e1[0] - h, e1[1] - p) - Math.PI / 2;
                    } : function(t1) {
                        return m.t2g(t1.x);
                    };
                    "linear" === m.type && "radians" === m.thetaunit && (m.tick0 = F(m.tick0), m.dtick = F(m.dtick));
                    var v = function(t1) {
                        return l(h + a * Math.cos(t1), p - a * Math.sin(t1));
                    }, x = g ? function(t1) {
                        var e1 = z(r, L([
                            0,
                            t1.x
                        ]));
                        return l(e1[0], e1[1]);
                    } : function(t1) {
                        return v(y(t1));
                    }, _ = g ? function(t1) {
                        var e1 = z(r, L([
                            0,
                            t1.x
                        ])), n = Math.atan2(e1[0] - h, e1[1] - p) - Math.PI / 2;
                        return l(e1[0], e1[1]) + s(-F(n));
                    } : function(t1) {
                        var e1 = y(t1);
                        return v(e1) + s(-F(e1));
                    }, b = g ? function(t1) {
                        return I(r, t1.x, 0, 1 / 0);
                    } : function(t1) {
                        var e1 = y(t1), r = Math.cos(e1), n = Math.sin(e1);
                        return "M" + [
                            h + u * r,
                            p - u * n
                        ] + "L" + [
                            h + a * r,
                            p - a * n
                        ];
                    }, w = f.makeLabelFns(m, 0).labelStandoff, T = {
                        xFn: function(t1) {
                            var e1 = y(t1);
                            return Math.cos(e1) * w;
                        },
                        yFn: function(t1) {
                            var e1 = y(t1), r = Math.sin(e1) > 0 ? .2 : 1;
                            return -Math.sin(e1) * (w + t1.fontSize * r) + Math.abs(Math.cos(e1)) * (t1.fontSize * M);
                        },
                        anchorFn: function(t1) {
                            var e1 = y(t1), r = Math.cos(e1);
                            return Math.abs(r) < .1 ? "middle" : r > 0 ? "start" : "end";
                        },
                        heightFn: function(t1, e1, r) {
                            var n = y(t1);
                            return -0.5 * (1 + Math.sin(n)) * r;
                        }
                    }, k = j(d);
                    r.angularTickLayout !== k && (i["angular-axis"].selectAll("." + m._id + "tick").remove(), r.angularTickLayout = k);
                    var A, S = g ? [
                        1 / 0
                    ].concat(m.tickvals || []).map(function(t1) {
                        return f.tickText(m, t1, !0, !1);
                    }) : f.calcTicks(m);
                    if (g && (S[0].text = "\u221E", S[0].fontSize *= 1.75), "linear" === e1.gridshape ? (A = S.map(y), o.angleDelta(A[0], A[1]) < 0 && (A = A.slice().reverse())) : A = null, r.vangles = A, "category" === m.type && (S = S.filter(function(t1) {
                        return o.isAngleInsideSector(y(t1), r.sectorInRad);
                    })), m.visible) {
                        var E = "inside" === m.ticks ? -1 : 1, C = (m.linewidth || 1) / 2;
                        f.drawTicks(n, m, {
                            vals: S,
                            layer: i["angular-axis"],
                            path: "M" + E * C + ",0h" + E * m.ticklen,
                            transFn: _,
                            crisp: !1
                        }), f.drawGrid(n, m, {
                            vals: S,
                            layer: i["angular-grid"],
                            path: b,
                            transFn: o.noop,
                            crisp: !1
                        }), f.drawLabels(n, m, {
                            vals: S,
                            layer: i["angular-axis"],
                            repositionOnUpdate: !0,
                            transFn: x,
                            labelFns: T
                        });
                    }
                    V(i["angular-line"].select("path"), d.showline, {
                        d: r.pathSubplot(),
                        transform: l(h, p)
                    }).attr("stroke-width", d.linewidth).call(c.stroke, d.linecolor);
                }, N.updateFx = function(t1, e1) {
                    this.gd._context.staticPlot || (!this.isSmith && (this.updateAngularDrag(t1), this.updateRadialDrag(t1, e1, 0), this.updateRadialDrag(t1, e1, 1)), this.updateHoverAndMainDrag(t1));
                }, N.updateHoverAndMainDrag = function(t1) {
                    var e1, r, s = this, c = s.isSmith, u = s.gd, h = s.layers, f = t1._zoomlayer, p = S.MINZOOM, d = S.OFFEDGE, m = s.radius, x = s.innerRadius, T = s.cx, k = s.cy, A = s.cxx, M = s.cyy, C = s.sectorInRad, L = s.vangles, I = s.radialAxis, P = E.clampTiny, z = E.findXYatLength, O = E.findEnclosingVertexAngles, D = S.cornerHalfWidth, R = S.cornerLen / 2, F = g.makeDragger(h, "path", "maindrag", !1 === t1.dragmode ? "none" : "crosshair");
                    n.select(F).attr("d", s.pathSubplot()).attr("transform", l(T, k)), F.onmousemove = function(t1) {
                        v.hover(u, t1, s.id), u._fullLayout._lasthover = F, u._fullLayout._hoversubplot = s.id;
                    }, F.onmouseout = function(t1) {
                        u._dragging || y.unhover(u, t1);
                    };
                    var B, N, j, U, V, q, H, G, Z, W = {
                        element: F,
                        gd: u,
                        subplot: s.id,
                        plotinfo: {
                            id: s.id,
                            xaxis: s.xaxis,
                            yaxis: s.yaxis
                        },
                        xaxes: [
                            s.xaxis
                        ],
                        yaxes: [
                            s.yaxis
                        ]
                    };
                    function Y(t1, e1) {
                        return Math.sqrt(t1 * t1 + e1 * e1);
                    }
                    function X(t1, e1) {
                        return Y(t1 - A, e1 - M);
                    }
                    function $(t1, e1) {
                        return Math.atan2(M - e1, t1 - A);
                    }
                    function J(t1, e1) {
                        return [
                            t1 * Math.cos(e1),
                            t1 * Math.sin(-e1)
                        ];
                    }
                    function K(t1, e1) {
                        if (0 === t1) return s.pathSector(2 * D);
                        var r = R / t1, n = e1 - r, i = e1 + r, a = Math.max(0, Math.min(t1, m)), o = a - D, l = a + D;
                        return "M" + J(o, n) + "A" + [
                            o,
                            o
                        ] + " 0,0,0 " + J(o, i) + "L" + J(l, i) + "A" + [
                            l,
                            l
                        ] + " 0,0,1 " + J(l, n) + "Z";
                    }
                    function Q(t1, e1, r) {
                        if (0 === t1) return s.pathSector(2 * D);
                        var n, i, a = J(t1, e1), o = J(t1, r), l = P((a[0] + o[0]) / 2), c = P((a[1] + o[1]) / 2);
                        if (l && c) {
                            var u = c / l, h = -1 / u, f = z(D, u, l, c);
                            n = z(R, h, f[0][0], f[0][1]), i = z(R, h, f[1][0], f[1][1]);
                        } else {
                            var p, d;
                            c ? (p = R, d = D) : (p = D, d = R), n = [
                                [
                                    l - p,
                                    c - d
                                ],
                                [
                                    l + p,
                                    c - d
                                ]
                            ], i = [
                                [
                                    l - p,
                                    c + d
                                ],
                                [
                                    l + p,
                                    c + d
                                ]
                            ];
                        }
                        return "M" + n.join("L") + "L" + i.reverse().join("L") + "Z";
                    }
                    function tt(t1, e1) {
                        return e1 = Math.max(Math.min(e1, m), x), t1 < d ? t1 = 0 : m - t1 < d ? t1 = m : e1 < d ? e1 = 0 : m - e1 < d && (e1 = m), Math.abs(e1 - t1) > p ? (t1 < e1 ? (j = t1, U = e1) : (j = e1, U = t1), !0) : (j = null, U = null, !1);
                    }
                    function et(t1, e1) {
                        t1 = t1 || V, e1 = e1 || "M0,0Z", G.attr("d", t1), Z.attr("d", e1), g.transitionZoombox(G, Z, q, H), q = !0;
                        var r = {};
                        ot(r), u.emit("plotly_relayouting", r);
                    }
                    function rt(t1, n) {
                        var i, a, o = B + (t1 *= e1), l = N + (n *= r), c = X(B, N), u = Math.min(X(o, l), m), h = $(B, N);
                        tt(c, u) && (i = V + s.pathSector(U), j && (i += s.pathSector(j)), a = K(j, h) + K(U, h)), et(i, a);
                    }
                    function nt(t1, e1, r, n) {
                        var i = E.findIntersectionXY(r, n, r, [
                            t1 - A,
                            M - e1
                        ]);
                        return Y(i[0], i[1]);
                    }
                    function it(t1, e1) {
                        var r, n, i = B + t1, a = N + e1, o = $(B, N), l = $(i, a), c = O(o, L), u = O(l, L);
                        tt(nt(B, N, c[0], c[1]), Math.min(nt(i, a, u[0], u[1]), m)) && (r = V + s.pathSector(U), j && (r += s.pathSector(j)), n = [
                            Q(j, c[0], c[1]),
                            Q(U, c[0], c[1])
                        ].join(" ")), et(r, n);
                    }
                    function at() {
                        if (g.removeZoombox(u), null !== j && null !== U) {
                            var t1 = {};
                            ot(t1), g.showDoubleClickNotifier(u), a.call("_guiRelayout", u, t1);
                        }
                    }
                    function ot(t1) {
                        var e1 = I._rl, r = (e1[1] - e1[0]) / (1 - x / m) / m, n = [
                            e1[0] + (j - x) * r,
                            e1[0] + (U - x) * r
                        ];
                        t1[s.id + ".radialaxis.range"] = n;
                    }
                    function st(t1, e1) {
                        var r = u._fullLayout.clickmode;
                        if (g.removeZoombox(u), 2 === t1) {
                            var n = {};
                            for(var i in s.viewInitial)n[s.id + "." + i] = s.viewInitial[i];
                            u.emit("plotly_doubleclick", null), a.call("_guiRelayout", u, n);
                        }
                        r.indexOf("select") > -1 && 1 === t1 && b(e1, u, [
                            s.xaxis
                        ], [
                            s.yaxis
                        ], s.id, W), r.indexOf("event") > -1 && v.click(u, e1, s.id);
                    }
                    W.prepFn = function(t1, n, a) {
                        var l = u._fullLayout.dragmode, h = F.getBoundingClientRect();
                        u._fullLayout._calcInverseTransform(u);
                        var p = u._fullLayout._invTransform;
                        e1 = u._fullLayout._invScaleX, r = u._fullLayout._invScaleY;
                        var d = o.apply3DTransform(p)(n - h.left, a - h.top);
                        if (B = d[0], N = d[1], L) {
                            var y = E.findPolygonOffset(m, C[0], C[1], L);
                            B += A + y[0], N += M + y[1];
                        }
                        switch(l){
                            case "zoom":
                                W.clickFn = st, c || (W.moveFn = L ? it : rt, W.doneFn = at, function() {
                                    j = null, U = null, V = s.pathSubplot(), q = !1;
                                    var t1 = u._fullLayout[s.id];
                                    H = i(t1.bgcolor).getLuminance(), (G = g.makeZoombox(f, H, T, k, V)).attr("fill-rule", "evenodd"), Z = g.makeCorners(f, T, k), w(u);
                                }());
                                break;
                            case "select":
                            case "lasso":
                                _(t1, n, a, W, l);
                        }
                    }, y.init(W);
                }, N.updateRadialDrag = function(t1, e1, r) {
                    var i = this, c = i.gd, u = i.layers, h = i.radius, f = i.innerRadius, p = i.cx, d = i.cy, m = i.radialAxis, v = S.radialDragBoxSize, x = v / 2;
                    if (m.visible) {
                        var _, b, T, M = R(i.radialAxisAngle), E = m._rl, C = E[0], L = E[1], I = E[r], P = .75 * (E[1] - E[0]) / (1 - i.getHole(e1)) / h;
                        r ? (_ = p + (h + x) * Math.cos(M), b = d - (h + x) * Math.sin(M), T = "radialdrag") : (_ = p + (f - x) * Math.cos(M), b = d - (f - x) * Math.sin(M), T = "radialdrag-inner");
                        var z, O, D, B = g.makeRectDragger(u, T, "crosshair", -x, -x, v, v), N = {
                            element: B,
                            gd: c
                        };
                        !1 === t1.dragmode && (N.dragmode = !1), V(n.select(B), m.visible && f < h, {
                            transform: l(_, b)
                        }), N.prepFn = function() {
                            z = null, O = null, D = null, N.moveFn = j, N.doneFn = q, w(c);
                        }, N.clampFn = function(t1, e1) {
                            return Math.sqrt(t1 * t1 + e1 * e1) < S.MINDRAG && (t1 = 0, e1 = 0), [
                                t1,
                                e1
                            ];
                        }, y.init(N);
                    }
                    function j(t1, e1) {
                        if (z) z(t1, e1);
                        else {
                            var n = [
                                t1,
                                -e1
                            ], a = [
                                Math.cos(M),
                                Math.sin(M)
                            ], s = Math.abs(o.dot(n, a) / Math.sqrt(o.dot(n, n)));
                            isNaN(s) || (z = s < .5 ? H : G);
                        }
                        var l = {};
                        !function(t1) {
                            null !== O ? t1[i.id + ".radialaxis.angle"] = O : null !== D && (t1[i.id + ".radialaxis.range[" + r + "]"] = D);
                        }(l), c.emit("plotly_relayouting", l);
                    }
                    function q() {
                        null !== O ? a.call("_guiRelayout", c, i.id + ".radialaxis.angle", O) : null !== D && a.call("_guiRelayout", c, i.id + ".radialaxis.range[" + r + "]", D);
                    }
                    function H(t1, e1) {
                        if (0 !== r) {
                            var n = _ + t1, a = b + e1;
                            O = Math.atan2(d - a, n - p), i.vangles && (O = U(O, i.vangles)), O = F(O);
                            var o = l(p, d) + s(-O);
                            u["radial-axis"].attr("transform", o), u["radial-line"].select("line").attr("transform", o);
                            var c = i.gd._fullLayout, h = c[i.id];
                            i.updateRadialAxisTitle(c, h, O);
                        }
                    }
                    function G(t1, e1) {
                        var n = o.dot([
                            t1,
                            -e1
                        ], [
                            Math.cos(M),
                            Math.sin(M)
                        ]);
                        if (D = I - P * n, P > 0 == (r ? D > C : D < L)) {
                            var s = c._fullLayout, l = s[i.id];
                            m.range[r] = D, m._rl[r] = D, i.updateRadialAxis(s, l), i.xaxis.setRange(), i.xaxis.setScale(), i.yaxis.setRange(), i.yaxis.setScale();
                            var u = !1;
                            for(var h in i.traceHash){
                                var f = i.traceHash[h], p = o.filterVisible(f);
                                f[0][0].trace._module.plot(c, i, p, l), a.traceIs(h, "gl") && p.length && (u = !0);
                            }
                            u && (k(c), A(c));
                        } else D = null;
                    }
                }, N.updateAngularDrag = function(t1) {
                    var e1 = this, r = e1.gd, i = e1.layers, c = e1.radius, h = e1.angularAxis, f = e1.cx, p = e1.cy, d = e1.cxx, m = e1.cyy, v = S.angularDragBoxSize, x = g.makeDragger(i, "path", "angulardrag", !1 === t1.dragmode ? "none" : "move"), _ = {
                        element: x,
                        gd: r
                    };
                    function b(t1, e1) {
                        return Math.atan2(m + v - e1, t1 - d - v);
                    }
                    !1 === t1.dragmode ? _.dragmode = !1 : n.select(x).attr("d", e1.pathAnnulus(c, c + v)).attr("transform", l(f, p)).call(T, "move");
                    var M, E, C, L, I, P, z = i.frontplot.select(".scatterlayer").selectAll(".trace"), O = z.selectAll(".point"), D = z.selectAll(".textpoint");
                    function R(c, g) {
                        var y = e1.gd._fullLayout, v = y[e1.id], x = b(M + c * t1._invScaleX, E + g * t1._invScaleY), _ = F(x - P);
                        if (L = C + _, i.frontplot.attr("transform", l(e1.xOffset2, e1.yOffset2) + s([
                            -_,
                            d,
                            m
                        ])), e1.vangles) {
                            I = e1.radialAxisAngle + _;
                            var w = l(f, p) + s(-_), T = l(f, p) + s(-I);
                            i.bg.attr("transform", w), i["radial-grid"].attr("transform", w), i["radial-axis"].attr("transform", T), i["radial-line"].select("line").attr("transform", T), e1.updateRadialAxisTitle(y, v, I);
                        } else e1.clipPaths.forTraces.select("path").attr("transform", l(d, m) + s(_));
                        O.each(function() {
                            var t1 = n.select(this), e1 = u.getTranslate(t1);
                            t1.attr("transform", l(e1.x, e1.y) + s([
                                _
                            ]));
                        }), D.each(function() {
                            var t1 = n.select(this), e1 = t1.select("text"), r = u.getTranslate(t1);
                            t1.attr("transform", s([
                                _,
                                e1.attr("x"),
                                e1.attr("y")
                            ]) + l(r.x, r.y));
                        }), h.rotation = o.modHalf(L, 360), e1.updateAngularAxis(y, v), e1._hasClipOnAxisFalse && !o.isFullCircle(e1.sectorInRad) && z.call(u.hideOutsideRangePoints, e1);
                        var S = !1;
                        for(var R in e1.traceHash)if (a.traceIs(R, "gl")) {
                            var N = e1.traceHash[R], j = o.filterVisible(N);
                            N[0][0].trace._module.plot(r, e1, j, v), j.length && (S = !0);
                        }
                        S && (k(r), A(r));
                        var U = {};
                        B(U), r.emit("plotly_relayouting", U);
                    }
                    function B(t1) {
                        t1[e1.id + ".angularaxis.rotation"] = L, e1.vangles && (t1[e1.id + ".radialaxis.angle"] = I);
                    }
                    function N() {
                        D.select("text").attr("transform", null);
                        var t1 = {};
                        B(t1), a.call("_guiRelayout", r, t1);
                    }
                    _.prepFn = function(n, i, a) {
                        var s = t1[e1.id];
                        C = s.angularaxis.rotation;
                        var l = x.getBoundingClientRect();
                        M = i - l.left, E = a - l.top, r._fullLayout._calcInverseTransform(r);
                        var c = o.apply3DTransform(t1._invTransform)(M, E);
                        M = c[0], E = c[1], P = b(M, E), _.moveFn = R, _.doneFn = N, w(r);
                    }, e1.vangles && !o.isFullCircle(e1.sectorInRad) && (_.prepFn = o.noop, T(n.select(x), null)), y.init(_);
                }, N.isPtInside = function(t1) {
                    if (this.isSmith) return !0;
                    var e1 = this.sectorInRad, r = this.vangles, n = this.angularAxis.c2g(t1.theta), i = this.radialAxis, a = i.c2l(t1.r), s = i._rl;
                    return (r ? E.isPtInsidePolygon : o.isPtInsideSector)(a, n, s, e1, r);
                }, N.pathArc = function(t1) {
                    var e1 = this.sectorInRad, r = this.vangles;
                    return (r ? E.pathPolygon : o.pathArc)(t1, e1[0], e1[1], r);
                }, N.pathSector = function(t1) {
                    var e1 = this.sectorInRad, r = this.vangles;
                    return (r ? E.pathPolygon : o.pathSector)(t1, e1[0], e1[1], r);
                }, N.pathAnnulus = function(t1, e1) {
                    var r = this.sectorInRad, n = this.vangles;
                    return (n ? E.pathPolygonAnnulus : o.pathAnnulus)(t1, e1, r[0], r[1], n);
                }, N.pathSubplot = function() {
                    var t1 = this.innerRadius, e1 = this.radius;
                    return t1 ? this.pathAnnulus(t1, e1) : this.pathSector(e1);
                }, N.fillViewInitialKey = function(t1, e1) {
                    t1 in this.viewInitial || (this.viewInitial[t1] = e1);
                };
            },
            51937: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(19091), a = n.deg2rad, o = n.rad2deg;
                t1.exports = function(t1, e1, r) {
                    switch(i(t1, r), t1._id){
                        case "x":
                        case "radialaxis":
                            !function(t1, e1) {
                                var r = e1._subplot;
                                t1.setGeometry = function() {
                                    var e1 = t1._rl[0], n = t1._rl[1], i = r.innerRadius, a = (r.radius - i) / (n - e1), o = i / a, s = e1 > n ? function(t1) {
                                        return t1 <= 0;
                                    } : function(t1) {
                                        return t1 >= 0;
                                    };
                                    t1.c2g = function(r) {
                                        var n = t1.c2l(r) - e1;
                                        return (s(n) ? n : 0) + o;
                                    }, t1.g2c = function(r) {
                                        return t1.l2c(r + e1 - o);
                                    }, t1.g2p = function(t1) {
                                        return t1 * a;
                                    }, t1.c2p = function(e1) {
                                        return t1.g2p(t1.c2g(e1));
                                    };
                                };
                            }(t1, e1);
                            break;
                        case "angularaxis":
                            !function(t1, e1) {
                                var r = t1.type;
                                if ("linear" === r) {
                                    var i = t1.d2c, s = t1.c2d;
                                    t1.d2c = function(t1, e1) {
                                        return function(t1, e1) {
                                            return "degrees" === e1 ? a(t1) : t1;
                                        }(i(t1), e1);
                                    }, t1.c2d = function(t1, e1) {
                                        return s(function(t1, e1) {
                                            return "degrees" === e1 ? o(t1) : t1;
                                        }(t1, e1));
                                    };
                                }
                                t1.makeCalcdata = function(e1, r) {
                                    var n, i, a = e1[r], o = e1._length, s = function(r) {
                                        return t1.d2c(r, e1.thetaunit);
                                    };
                                    if (a) for(n = new Array(o), i = 0; i < o; i++)n[i] = s(a[i]);
                                    else {
                                        var l = r + "0", c = "d" + r, u = l in e1 ? s(e1[l]) : 0, h = e1[c] ? s(e1[c]) : (t1.period || 2 * Math.PI) / o;
                                        for(n = new Array(o), i = 0; i < o; i++)n[i] = u + i * h;
                                    }
                                    return n;
                                }, t1.setGeometry = function() {
                                    var i, s, l, c, u = e1.sector, h = u.map(a), f = {
                                        clockwise: -1,
                                        counterclockwise: 1
                                    }[t1.direction], p = a(t1.rotation), d = function(t1) {
                                        return f * t1 + p;
                                    }, m = function(t1) {
                                        return (t1 - p) / f;
                                    };
                                    switch(r){
                                        case "linear":
                                            s = i = n.identity, c = a, l = o, t1.range = n.isFullCircle(h) ? [
                                                u[0],
                                                u[0] + 360
                                            ] : h.map(m).map(o);
                                            break;
                                        case "category":
                                            var g = t1._categories.length, y = t1.period ? Math.max(t1.period, g) : g;
                                            0 === y && (y = 1), s = c = function(t1) {
                                                return 2 * t1 * Math.PI / y;
                                            }, i = l = function(t1) {
                                                return t1 * y / Math.PI / 2;
                                            }, t1.range = [
                                                0,
                                                y
                                            ];
                                    }
                                    t1.c2g = function(t1) {
                                        return d(s(t1));
                                    }, t1.g2c = function(t1) {
                                        return i(m(t1));
                                    }, t1.t2g = function(t1) {
                                        return d(c(t1));
                                    }, t1.g2t = function(t1) {
                                        return l(m(t1));
                                    };
                                };
                            }(t1, e1);
                    }
                };
            },
            70951: function(t1) {
                "use strict";
                t1.exports = {
                    attr: "subplot",
                    name: "smith",
                    axisNames: [
                        "realaxis",
                        "imaginaryaxis"
                    ],
                    axisName2dataArray: {
                        imaginaryaxis: "imag",
                        realaxis: "real"
                    }
                };
            },
            52007: function(t1) {
                "use strict";
                function e1(t1) {
                    return t1 < 0 ? -1 : t1 > 0 ? 1 : 0;
                }
                function r(t1) {
                    var e1 = t1[0], r = t1[1];
                    if (!isFinite(e1) || !isFinite(r)) return [
                        1,
                        0
                    ];
                    var n = (e1 + 1) * (e1 + 1) + r * r;
                    return [
                        (e1 * e1 + r * r - 1) / n,
                        2 * r / n
                    ];
                }
                function n(t1, e1) {
                    var r = e1[0], n = e1[1];
                    return [
                        r * t1.radius + t1.cx,
                        -n * t1.radius + t1.cy
                    ];
                }
                function i(t1, e1) {
                    return e1 * t1.radius;
                }
                t1.exports = {
                    smith: r,
                    reactanceArc: function(t1, e1, a, o) {
                        var s = n(t1, r([
                            a,
                            e1
                        ])), l = s[0], c = s[1], u = n(t1, r([
                            o,
                            e1
                        ])), h = u[0], f = u[1];
                        if (0 === e1) return [
                            "M" + l + "," + c,
                            "L" + h + "," + f
                        ].join(" ");
                        var p = i(t1, 1 / Math.abs(e1));
                        return [
                            "M" + l + "," + c,
                            "A" + p + "," + p + " 0 0," + (e1 < 0 ? 1 : 0) + " " + h + "," + f
                        ].join(" ");
                    },
                    resistanceArc: function(t1, a, o, s) {
                        var l = i(t1, 1 / (a + 1)), c = n(t1, r([
                            a,
                            o
                        ])), u = c[0], h = c[1], f = n(t1, r([
                            a,
                            s
                        ])), p = f[0], d = f[1];
                        if (e1(o) !== e1(s)) {
                            var m = n(t1, r([
                                a,
                                0
                            ]));
                            return [
                                "M" + u + "," + h,
                                "A" + l + "," + l + " 0 0," + (0 < o ? 0 : 1) + " " + m[0] + "," + m[1],
                                "A" + l + "," + l + " 0 0," + (s < 0 ? 0 : 1) + p + "," + d
                            ].join(" ");
                        }
                        return [
                            "M" + u + "," + h,
                            "A" + l + "," + l + " 0 0," + (s < o ? 0 : 1) + " " + p + "," + d
                        ].join(" ");
                    },
                    smithTransform: n
                };
            },
            50358: function(t1, e1, r) {
                "use strict";
                var n = r(4173).fX, i = r(34809).counterRegex, a = r(35785), o = r(70951), s = o.attr, l = o.name, c = i(l), u = {};
                u[s] = {
                    valType: "subplotid",
                    dflt: l,
                    editType: "calc"
                }, t1.exports = {
                    attr: s,
                    name: l,
                    idRoot: l,
                    idRegex: c,
                    attrRegex: c,
                    attributes: u,
                    layoutAttributes: r(93288),
                    supplyLayoutDefaults: r(31359),
                    plot: function(t1) {
                        for(var e1 = t1._fullLayout, r = t1.calcdata, i = e1._subplots[l], o = 0; o < i.length; o++){
                            var s = i[o], c = n(r, l, s), u = e1[s]._subplot;
                            u || (u = a(t1, s, !0), e1[s]._subplot = u), u.plot(c, e1, t1._promises);
                        }
                    },
                    clean: function(t1, e1, r, n) {
                        for(var i = n._subplots[l] || [], a = 0; a < i.length; a++){
                            var o = i[a], s = n[o]._subplot;
                            if (!e1[o] && s) for(var c in s.framework.remove(), s.clipPaths)s.clipPaths[c].remove();
                        }
                    },
                    toSVG: r(37703).toSVG
                };
            },
            93288: function(t1, e1, r) {
                "use strict";
                var n = r(10229), i = r(25829), a = r(13792).u, o = r(34809).extendFlat, s = r(13582).overrideAll, l = s({
                    color: i.color,
                    showline: o({}, i.showline, {
                        dflt: !0
                    }),
                    linecolor: i.linecolor,
                    linewidth: i.linewidth,
                    showgrid: o({}, i.showgrid, {
                        dflt: !0
                    }),
                    gridcolor: i.gridcolor,
                    gridwidth: i.gridwidth,
                    griddash: i.griddash
                }, "plot", "from-root"), c = s({
                    ticklen: i.ticklen,
                    tickwidth: o({}, i.tickwidth, {
                        dflt: 2
                    }),
                    tickcolor: i.tickcolor,
                    showticklabels: i.showticklabels,
                    labelalias: i.labelalias,
                    showtickprefix: i.showtickprefix,
                    tickprefix: i.tickprefix,
                    showticksuffix: i.showticksuffix,
                    ticksuffix: i.ticksuffix,
                    tickfont: i.tickfont,
                    tickformat: i.tickformat,
                    hoverformat: i.hoverformat,
                    layer: i.layer
                }, "plot", "from-root"), u = o({
                    visible: o({}, i.visible, {
                        dflt: !0
                    }),
                    tickvals: {
                        dflt: [
                            .2,
                            .5,
                            1,
                            2,
                            5
                        ],
                        valType: "data_array",
                        editType: "plot"
                    },
                    tickangle: o({}, i.tickangle, {
                        dflt: 90
                    }),
                    ticks: {
                        valType: "enumerated",
                        values: [
                            "top",
                            "bottom",
                            ""
                        ],
                        editType: "ticks"
                    },
                    side: {
                        valType: "enumerated",
                        values: [
                            "top",
                            "bottom"
                        ],
                        dflt: "top",
                        editType: "plot"
                    },
                    editType: "calc"
                }, l, c), h = o({
                    visible: o({}, i.visible, {
                        dflt: !0
                    }),
                    tickvals: {
                        valType: "data_array",
                        editType: "plot"
                    },
                    ticks: i.ticks,
                    editType: "calc"
                }, l, c);
                t1.exports = {
                    domain: a({
                        name: "smith",
                        editType: "plot"
                    }),
                    bgcolor: {
                        valType: "color",
                        editType: "plot",
                        dflt: n.background
                    },
                    realaxis: u,
                    imaginaryaxis: h,
                    editType: "calc"
                };
            },
            31359: function(t1, e1, r) {
                "use strict";
                var n, i, a, o = r(34809), s = r(78766), l = r(78032), c = r(4448), u = r(4173).KO, h = r(54616), f = r(12036), p = r(97405), d = r(19091), m = r(93288), g = r(70951), y = g.axisNames, v = (n = function(t1) {
                    return o.isTypedArray(t1) && (t1 = Array.from(t1)), t1.slice().reverse().map(function(t1) {
                        return -t1;
                    }).concat([
                        0
                    ]).concat(t1);
                }, i = String, a = {}, function(t1) {
                    var e1 = i ? i(t1) : t1;
                    if (e1 in a) return a[e1];
                    var r = n(t1);
                    return a[e1] = r, r;
                });
                function x(t1, e1, r, n) {
                    var i = r("bgcolor");
                    n.bgColor = s.combine(i, n.paper_bgcolor);
                    var a, c = u(n.fullData, g.name, n.id), x = n.layoutOut;
                    function _(t1, e1) {
                        return r(a + "." + t1, e1);
                    }
                    for(var b = 0; b < y.length; b++){
                        a = y[b], o.isPlainObject(t1[a]) || (t1[a] = {});
                        var w = t1[a], T = l.newContainer(e1, a);
                        T._id = T._name = a, T._attr = n.id + "." + a, T._traceIndices = c.map(function(t1) {
                            return t1._expandedIndex;
                        });
                        var k = _("visible");
                        if (T.type = "linear", d(T, x), h(w, T, _, T.type), k) {
                            var A, M, S, E, C = "realaxis" === a;
                            C && _("side"), C ? _("tickvals") : _("tickvals", v(e1.realaxis.tickvals || m.realaxis.tickvals.dflt)), o.isTypedArray(T.tickvals) && (T.tickvals = Array.from(T.tickvals));
                            var L = n.font || {};
                            k && (M = (A = _("color")) === w.color ? A : L.color, S = L.size, E = L.family), f(w, T, _, T.type, {
                                noAutotickangles: !0,
                                noTicklabelshift: !0,
                                noTicklabelstandoff: !0,
                                noTicklabelstep: !0,
                                noAng: !C,
                                noExp: !0,
                                font: {
                                    color: M,
                                    size: S,
                                    family: E
                                }
                            }), o.coerce2(t1, e1, m, a + ".ticklen"), o.coerce2(t1, e1, m, a + ".tickwidth"), o.coerce2(t1, e1, m, a + ".tickcolor", e1.color), _("ticks") || (delete e1[a].ticklen, delete e1[a].tickwidth, delete e1[a].tickcolor), p(w, T, _, {
                                dfltColor: A,
                                bgColor: n.bgColor,
                                blend: 60,
                                showLine: !0,
                                showGrid: !0,
                                noZeroLine: !0,
                                attributes: m[a]
                            }), _("layer");
                        }
                        _("hoverformat"), delete T.type, T._input = w;
                    }
                }
                t1.exports = function(t1, e1, r) {
                    c(t1, e1, r, {
                        noUirevision: !0,
                        type: g.name,
                        attributes: m,
                        handleDefaults: x,
                        font: e1.font,
                        paper_bgcolor: e1.paper_bgcolor,
                        fullData: r,
                        layoutOut: e1
                    });
                };
            },
            4448: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(78032), a = r(13792).N;
                t1.exports = function(t1, e1, r, o) {
                    var s, l, c = o.type, u = o.attributes, h = o.handleDefaults, f = o.partition || "x", p = e1._subplots[c], d = p.length, m = d && p[0].replace(/\d+$/, "");
                    function g(t1, e1) {
                        return n.coerce(s, l, u, t1, e1);
                    }
                    for(var y = 0; y < d; y++){
                        var v = p[y];
                        s = t1[v] ? t1[v] : t1[v] = {}, l = i.newContainer(e1, v, m), o.noUirevision || g("uirevision", e1.uirevision);
                        var x = {};
                        x[f] = [
                            y / d,
                            (y + 1) / d
                        ], a(l, e1, g, x), o.id = v, h(s, l, g, o);
                    }
                };
            },
            3208: function(t1, e1, r) {
                "use strict";
                var n = r(87296);
                function i(t1) {
                    var e1 = t1.description ? " " + t1.description : "", r = t1.keys || [];
                    if (r.length > 0) {
                        for(var n = [], i = 0; i < r.length; i++)n[i] = "`" + r[i] + "`";
                        e1 += "Finally, the template string has access to ", e1 = 1 === r.length ? e1 + "variable " + n[0] : e1 + "variables " + n.slice(0, -1).join(", ") + " and " + n.slice(-1) + ".";
                    }
                    return e1;
                }
                n.FORMAT_LINK, n.DATE_FORMAT_LINK, e1.rb = function(t1, e1) {
                    t1 = t1 || {}, i(e1 = e1 || {});
                    var r = {
                        valType: "string",
                        dflt: "",
                        editType: t1.editType || "none"
                    };
                    return !1 !== t1.arrayOk && (r.arrayOk = !0), r;
                }, e1.ay = function(t1, e1) {
                    t1 = t1 || {}, i(e1 = e1 || {});
                    var r = {
                        valType: "string",
                        dflt: "",
                        editType: t1.editType || "calc"
                    };
                    return !1 !== t1.arrayOk && (r.arrayOk = !0), r;
                }, e1.LF = function(t1, e1) {
                    return e1 = e1 || {}, (t1 = t1 || {}).newshape, i(e1), {
                        valType: "string",
                        dflt: "",
                        editType: t1.editType || "arraydraw"
                    };
                };
            },
            7638: function(t1, e1, r) {
                "use strict";
                var n = r(83637), i = r(4173).fX, a = r(34809).counterRegex, o = "ternary";
                e1.name = o;
                var s = e1.attr = "subplot";
                e1.idRoot = o, e1.idRegex = e1.attrRegex = a(o), (e1.attributes = {})[s] = {
                    valType: "subplotid",
                    dflt: "ternary",
                    editType: "calc"
                }, e1.layoutAttributes = r(77416), e1.supplyLayoutDefaults = r(25247), e1.plot = function(t1) {
                    for(var e1 = t1._fullLayout, r = t1.calcdata, a = e1._subplots[o], s = 0; s < a.length; s++){
                        var l = a[s], c = i(r, o, l), u = e1[l]._subplot;
                        u || (u = new n({
                            id: l,
                            graphDiv: t1,
                            container: e1._ternarylayer.node()
                        }, e1), e1[l]._subplot = u), u.plot(c, e1, t1._promises);
                    }
                }, e1.clean = function(t1, e1, r, n) {
                    for(var i = n._subplots[o] || [], a = 0; a < i.length; a++){
                        var s = i[a], l = n[s]._subplot;
                        !e1[s] && l && (l.plotContainer.remove(), l.clipDef.remove(), l.clipDefRelative.remove(), l.layers["a-title"].remove(), l.layers["b-title"].remove(), l.layers["c-title"].remove());
                    }
                }, e1.updateFx = function(t1) {
                    var e1 = t1._fullLayout;
                    e1._ternarylayer.selectAll("g.toplevel").style("cursor", "pan" === e1.dragmode ? "move" : "crosshair");
                };
            },
            77416: function(t1, e1, r) {
                "use strict";
                var n = r(10229), i = r(13792).u, a = r(25829), o = r(13582).overrideAll, s = r(93049).extendFlat, l = {
                    title: {
                        text: a.title.text,
                        font: a.title.font
                    },
                    color: a.color,
                    tickmode: a.minor.tickmode,
                    nticks: s({}, a.nticks, {
                        dflt: 6,
                        min: 1
                    }),
                    tick0: a.tick0,
                    dtick: a.dtick,
                    tickvals: a.tickvals,
                    ticktext: a.ticktext,
                    ticks: a.ticks,
                    ticklen: a.ticklen,
                    tickwidth: a.tickwidth,
                    tickcolor: a.tickcolor,
                    ticklabelstep: a.ticklabelstep,
                    showticklabels: a.showticklabels,
                    labelalias: a.labelalias,
                    showtickprefix: a.showtickprefix,
                    tickprefix: a.tickprefix,
                    showticksuffix: a.showticksuffix,
                    ticksuffix: a.ticksuffix,
                    showexponent: a.showexponent,
                    exponentformat: a.exponentformat,
                    minexponent: a.minexponent,
                    separatethousands: a.separatethousands,
                    tickfont: a.tickfont,
                    tickangle: a.tickangle,
                    tickformat: a.tickformat,
                    tickformatstops: a.tickformatstops,
                    hoverformat: a.hoverformat,
                    showline: s({}, a.showline, {
                        dflt: !0
                    }),
                    linecolor: a.linecolor,
                    linewidth: a.linewidth,
                    showgrid: s({}, a.showgrid, {
                        dflt: !0
                    }),
                    gridcolor: a.gridcolor,
                    gridwidth: a.gridwidth,
                    griddash: a.griddash,
                    layer: a.layer,
                    min: {
                        valType: "number",
                        dflt: 0,
                        min: 0
                    },
                    _deprecated: {
                        title: a._deprecated.title,
                        titlefont: a._deprecated.titlefont
                    }
                }, c = t1.exports = o({
                    domain: i({
                        name: "ternary"
                    }),
                    bgcolor: {
                        valType: "color",
                        dflt: n.background
                    },
                    sum: {
                        valType: "number",
                        dflt: 1,
                        min: 0
                    },
                    aaxis: l,
                    baxis: l,
                    caxis: l
                }, "plot", "from-root");
                c.uirevision = {
                    valType: "any",
                    editType: "none"
                }, c.aaxis.uirevision = c.baxis.uirevision = c.caxis.uirevision = {
                    valType: "any",
                    editType: "none"
                };
            },
            25247: function(t1, e1, r) {
                "use strict";
                var n = r(78766), i = r(78032), a = r(34809), o = r(4448), s = r(12036), l = r(54616), c = r(87433), u = r(22777), h = r(97405), f = r(77416), p = [
                    "aaxis",
                    "baxis",
                    "caxis"
                ];
                function d(t1, e1, r, a) {
                    var o, s, l, c = r("bgcolor"), u = r("sum");
                    a.bgColor = n.combine(c, a.paper_bgcolor);
                    for(var h = 0; h < p.length; h++)s = t1[o = p[h]] || {}, (l = i.newContainer(e1, o))._name = o, m(s, l, a, e1);
                    var f = e1.aaxis, d = e1.baxis, g = e1.caxis;
                    f.min + d.min + g.min >= u && (f.min = 0, d.min = 0, g.min = 0, t1.aaxis && delete t1.aaxis.min, t1.baxis && delete t1.baxis.min, t1.caxis && delete t1.caxis.min);
                }
                function m(t1, e1, r, n) {
                    var i = f[e1._name];
                    function o(r, n) {
                        return a.coerce(t1, e1, i, r, n);
                    }
                    o("uirevision", n.uirevision), e1.type = "linear";
                    var p = o("color"), d = p !== i.color.dflt ? p : r.font.color, m = e1._name.charAt(0).toUpperCase(), g = "Component " + m, y = o("title.text", g);
                    e1._hovertitle = y === g ? y : m, a.coerceFont(o, "title.font", r.font, {
                        overrideDflt: {
                            size: a.bigFont(r.font.size),
                            color: d
                        }
                    }), o("min"), u(t1, e1, o, "linear"), l(t1, e1, o, "linear"), s(t1, e1, o, "linear", {
                        noAutotickangles: !0,
                        noTicklabelshift: !0,
                        noTicklabelstandoff: !0
                    }), c(t1, e1, o, {
                        outerTicks: !0
                    }), o("showticklabels") && (a.coerceFont(o, "tickfont", r.font, {
                        overrideDflt: {
                            color: d
                        }
                    }), o("tickangle"), o("tickformat")), h(t1, e1, o, {
                        dfltColor: p,
                        bgColor: r.bgColor,
                        blend: 60,
                        showLine: !0,
                        showGrid: !0,
                        noZeroLine: !0,
                        attributes: i
                    }), o("hoverformat"), o("layer");
                }
                t1.exports = function(t1, e1, r) {
                    o(t1, e1, r, {
                        type: "ternary",
                        attributes: f,
                        handleDefaults: d,
                        font: e1.font,
                        paper_bgcolor: e1.paper_bgcolor
                    });
                };
            },
            83637: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(65657), a = r(33626), o = r(34809), s = o.strTranslate, l = o._, c = r(78766), u = r(62203), h = r(19091), f = r(93049).extendFlat, p = r(44122), d = r(29714), m = r(14751), g = r(32141), y = r(70414), v = y.freeMode, x = y.rectMode, _ = r(17240), b = r(44844).prepSelect, w = r(44844).selectOnClick, T = r(44844).clearOutline, k = r(44844).clearSelectionsCache, A = r(54826);
                function M(t1, e1) {
                    this.id = t1.id, this.graphDiv = t1.graphDiv, this.init(e1), this.makeFramework(e1), this.updateFx(e1), this.aTickLayout = null, this.bTickLayout = null, this.cTickLayout = null;
                }
                t1.exports = M;
                var S = M.prototype;
                S.init = function(t1) {
                    this.container = t1._ternarylayer, this.defs = t1._defs, this.layoutId = t1._uid, this.traceHash = {}, this.layers = {};
                }, S.plot = function(t1, e1) {
                    var r = this, n = e1[r.id], i = e1._size;
                    r._hasClipOnAxisFalse = !1;
                    for(var a = 0; a < t1.length; a++)if (!1 === t1[a][0].trace.cliponaxis) {
                        r._hasClipOnAxisFalse = !0;
                        break;
                    }
                    r.updateLayers(n), r.adjustLayout(n, i), p.generalUpdatePerTraceModule(r.graphDiv, r, t1, n), r.layers.plotbg.select("path").call(c.fill, n.bgcolor);
                }, S.makeFramework = function(t1) {
                    var e1 = this, r = e1.graphDiv, n = t1[e1.id], i = e1.clipId = "clip" + e1.layoutId + e1.id, a = e1.clipIdRelative = "clip-relative" + e1.layoutId + e1.id;
                    e1.clipDef = o.ensureSingleById(t1._clips, "clipPath", i, function(t1) {
                        t1.append("path").attr("d", "M0,0Z");
                    }), e1.clipDefRelative = o.ensureSingleById(t1._clips, "clipPath", a, function(t1) {
                        t1.append("path").attr("d", "M0,0Z");
                    }), e1.plotContainer = o.ensureSingle(e1.container, "g", e1.id), e1.updateLayers(n), u.setClipUrl(e1.layers.backplot, i, r), u.setClipUrl(e1.layers.grids, i, r);
                }, S.updateFx = function(t1) {
                    t1._ternarylayer.selectAll("g.toplevel").style("cursor", "pan" === t1.dragmode ? "move" : "crosshair");
                }, S.updateLayers = function(t1) {
                    var e1 = this.layers, r = [
                        "draglayer",
                        "plotbg",
                        "backplot",
                        "grids"
                    ];
                    "below traces" === t1.aaxis.layer && r.push("aaxis", "aline"), "below traces" === t1.baxis.layer && r.push("baxis", "bline"), "below traces" === t1.caxis.layer && r.push("caxis", "cline"), r.push("frontplot"), "above traces" === t1.aaxis.layer && r.push("aaxis", "aline"), "above traces" === t1.baxis.layer && r.push("baxis", "bline"), "above traces" === t1.caxis.layer && r.push("caxis", "cline");
                    var i = this.plotContainer.selectAll("g.toplevel").data(r, String), a = [
                        "agrid",
                        "bgrid",
                        "cgrid"
                    ];
                    i.enter().append("g").attr("class", function(t1) {
                        return "toplevel " + t1;
                    }).each(function(t1) {
                        var r = n.select(this);
                        e1[t1] = r, "frontplot" === t1 ? r.append("g").classed("scatterlayer", !0) : "backplot" === t1 ? r.append("g").classed("maplayer", !0) : "plotbg" === t1 ? r.append("path").attr("d", "M0,0Z") : "aline" === t1 || "bline" === t1 || "cline" === t1 ? r.append("path") : "grids" === t1 && a.forEach(function(t1) {
                            e1[t1] = r.append("g").classed("grid " + t1, !0);
                        });
                    }), i.order();
                };
                var E = Math.sqrt(4 / 3);
                S.adjustLayout = function(t1, e1) {
                    var r, n, i, a, o, l, p = this, d = t1.domain, m = (d.x[0] + d.x[1]) / 2, g = (d.y[0] + d.y[1]) / 2, y = d.x[1] - d.x[0], v = d.y[1] - d.y[0], x = y * e1.w, _ = v * e1.h, b = t1.sum, w = t1.aaxis.min, T = t1.baxis.min, k = t1.caxis.min;
                    x > E * _ ? i = (a = _) * E : a = (i = x) / E, o = y * i / x, l = v * a / _, r = e1.l + e1.w * m - i / 2, n = e1.t + e1.h * (1 - g) - a / 2, p.x0 = r, p.y0 = n, p.w = i, p.h = a, p.sum = b, p.xaxis = {
                        type: "linear",
                        range: [
                            w + 2 * k - b,
                            b - w - 2 * T
                        ],
                        domain: [
                            m - o / 2,
                            m + o / 2
                        ],
                        _id: "x"
                    }, h(p.xaxis, p.graphDiv._fullLayout), p.xaxis.setScale(), p.xaxis.isPtWithinRange = function(t1) {
                        return t1.a >= p.aaxis.range[0] && t1.a <= p.aaxis.range[1] && t1.b >= p.baxis.range[1] && t1.b <= p.baxis.range[0] && t1.c >= p.caxis.range[1] && t1.c <= p.caxis.range[0];
                    }, p.yaxis = {
                        type: "linear",
                        range: [
                            w,
                            b - T - k
                        ],
                        domain: [
                            g - l / 2,
                            g + l / 2
                        ],
                        _id: "y"
                    }, h(p.yaxis, p.graphDiv._fullLayout), p.yaxis.setScale(), p.yaxis.isPtWithinRange = function() {
                        return !0;
                    };
                    var A = p.yaxis.domain[0], M = p.aaxis = f({}, t1.aaxis, {
                        range: [
                            w,
                            b - T - k
                        ],
                        side: "left",
                        tickangle: (+t1.aaxis.tickangle || 0) - 30,
                        domain: [
                            A,
                            A + l * E
                        ],
                        anchor: "free",
                        position: 0,
                        _id: "y",
                        _length: i
                    });
                    h(M, p.graphDiv._fullLayout), M.setScale();
                    var S = p.baxis = f({}, t1.baxis, {
                        range: [
                            b - w - k,
                            T
                        ],
                        side: "bottom",
                        domain: p.xaxis.domain,
                        anchor: "free",
                        position: 0,
                        _id: "x",
                        _length: i
                    });
                    h(S, p.graphDiv._fullLayout), S.setScale();
                    var C = p.caxis = f({}, t1.caxis, {
                        range: [
                            b - w - T,
                            k
                        ],
                        side: "right",
                        tickangle: (+t1.caxis.tickangle || 0) + 30,
                        domain: [
                            A,
                            A + l * E
                        ],
                        anchor: "free",
                        position: 0,
                        _id: "y",
                        _length: i
                    });
                    h(C, p.graphDiv._fullLayout), C.setScale();
                    var L = "M" + r + "," + (n + a) + "h" + i + "l-" + i / 2 + ",-" + a + "Z";
                    p.clipDef.select("path").attr("d", L), p.layers.plotbg.select("path").attr("d", L);
                    var I = "M0," + a + "h" + i + "l-" + i / 2 + ",-" + a + "Z";
                    p.clipDefRelative.select("path").attr("d", I);
                    var P = s(r, n);
                    p.plotContainer.selectAll(".scatterlayer,.maplayer").attr("transform", P), p.clipDefRelative.select("path").attr("transform", null);
                    var z = s(r - S._offset, n + a);
                    p.layers.baxis.attr("transform", z), p.layers.bgrid.attr("transform", z);
                    var O = s(r + i / 2, n) + "rotate(30)" + s(0, -M._offset);
                    p.layers.aaxis.attr("transform", O), p.layers.agrid.attr("transform", O);
                    var D = s(r + i / 2, n) + "rotate(-30)" + s(0, -C._offset);
                    p.layers.caxis.attr("transform", D), p.layers.cgrid.attr("transform", D), p.drawAxes(!0), p.layers.aline.select("path").attr("d", M.showline ? "M" + r + "," + (n + a) + "l" + i / 2 + ",-" + a : "M0,0").call(c.stroke, M.linecolor || "#000").style("stroke-width", (M.linewidth || 0) + "px"), p.layers.bline.select("path").attr("d", S.showline ? "M" + r + "," + (n + a) + "h" + i : "M0,0").call(c.stroke, S.linecolor || "#000").style("stroke-width", (S.linewidth || 0) + "px"), p.layers.cline.select("path").attr("d", C.showline ? "M" + (r + i / 2) + "," + n + "l" + i / 2 + "," + a : "M0,0").call(c.stroke, C.linecolor || "#000").style("stroke-width", (C.linewidth || 0) + "px"), p.graphDiv._context.staticPlot || p.initInteractions(), u.setClipUrl(p.layers.frontplot, p._hasClipOnAxisFalse ? null : p.clipId, p.graphDiv);
                }, S.drawAxes = function(t1) {
                    var e1 = this, r = e1.graphDiv, n = e1.id.substr(7) + "title", i = e1.layers, a = e1.aaxis, o = e1.baxis, s = e1.caxis;
                    if (e1.drawAx(a), e1.drawAx(o), e1.drawAx(s), t1) {
                        var c = Math.max(a.showticklabels ? a.tickfont.size / 2 : 0, (s.showticklabels ? .75 * s.tickfont.size : 0) + ("outside" === s.ticks ? .87 * s.ticklen : 0)), u = (o.showticklabels ? o.tickfont.size : 0) + ("outside" === o.ticks ? o.ticklen : 0) + 3;
                        i["a-title"] = _.draw(r, "a" + n, {
                            propContainer: a,
                            propName: e1.id + ".aaxis.title",
                            placeholder: l(r, "Click to enter Component A title"),
                            attributes: {
                                x: e1.x0 + e1.w / 2,
                                y: e1.y0 - a.title.font.size / 3 - c,
                                "text-anchor": "middle"
                            }
                        }), i["b-title"] = _.draw(r, "b" + n, {
                            propContainer: o,
                            propName: e1.id + ".baxis.title",
                            placeholder: l(r, "Click to enter Component B title"),
                            attributes: {
                                x: e1.x0 - u,
                                y: e1.y0 + e1.h + .83 * o.title.font.size + u,
                                "text-anchor": "middle"
                            }
                        }), i["c-title"] = _.draw(r, "c" + n, {
                            propContainer: s,
                            propName: e1.id + ".caxis.title",
                            placeholder: l(r, "Click to enter Component C title"),
                            attributes: {
                                x: e1.x0 + e1.w + u,
                                y: e1.y0 + e1.h + .83 * s.title.font.size + u,
                                "text-anchor": "middle"
                            }
                        });
                    }
                }, S.drawAx = function(t1) {
                    var e1, r = this, n = r.graphDiv, i = t1._name, a = i.charAt(0), s = t1._id, l = r.layers[i], c = a + "tickLayout", u = (e1 = t1).ticks + String(e1.ticklen) + String(e1.showticklabels);
                    r[c] !== u && (l.selectAll("." + s + "tick").remove(), r[c] = u), t1.setScale();
                    var h = d.calcTicks(t1), f = d.clipEnds(t1, h), p = d.makeTransTickFn(t1), m = d.getTickSigns(t1)[2], g = o.deg2rad(30), y = m * (t1.linewidth || 1) / 2, v = m * t1.ticklen, x = r.w, _ = r.h, b = "b" === a ? "M0," + y + "l" + Math.sin(g) * v + "," + Math.cos(g) * v : "M" + y + ",0l" + Math.cos(g) * v + "," + -Math.sin(g) * v, w = {
                        a: "M0,0l" + _ + ",-" + x / 2,
                        b: "M0,0l-" + x / 2 + ",-" + _,
                        c: "M0,0l-" + _ + "," + x / 2
                    }[a];
                    d.drawTicks(n, t1, {
                        vals: "inside" === t1.ticks ? f : h,
                        layer: l,
                        path: b,
                        transFn: p,
                        crisp: !1
                    }), d.drawGrid(n, t1, {
                        vals: f,
                        layer: r.layers[a + "grid"],
                        path: w,
                        transFn: p,
                        crisp: !1
                    }), d.drawLabels(n, t1, {
                        vals: h,
                        layer: l,
                        transFn: p,
                        labelFns: d.makeLabelFns(t1, 0, 30)
                    });
                };
                var C = A.MINZOOM / 2 + .87, L = "m-0.87,.5h" + C + "v3h-" + (C + 5.2) + "l" + (C / 2 + 2.6) + ",-" + (.87 * C + 4.5) + "l2.6,1.5l-" + C / 2 + "," + .87 * C + "Z", I = "m0.87,.5h-" + C + "v3h" + (C + 5.2) + "l-" + (C / 2 + 2.6) + ",-" + (.87 * C + 4.5) + "l-2.6,1.5l" + C / 2 + "," + .87 * C + "Z", P = "m0,1l" + C / 2 + "," + .87 * C + "l2.6,-1.5l-" + (C / 2 + 2.6) + ",-" + (.87 * C + 4.5) + "l-" + (C / 2 + 2.6) + "," + (.87 * C + 4.5) + "l2.6,1.5l" + C / 2 + ",-" + .87 * C + "Z", z = !0;
                function O(t1) {
                    n.select(t1).selectAll(".zoombox,.js-zoombox-backdrop,.js-zoombox-menu,.zoombox-corners").remove();
                }
                S.clearOutline = function() {
                    k(this.dragOptions), T(this.dragOptions.gd);
                }, S.initInteractions = function() {
                    var t1, e1, r, n, h, f, p, d, y, _, T, k, M = this, S = M.layers.plotbg.select("path").node(), C = M.graphDiv, D = C._fullLayout._zoomlayer;
                    function R(t1) {
                        var e1 = {};
                        return e1[M.id + ".aaxis.min"] = t1.a, e1[M.id + ".baxis.min"] = t1.b, e1[M.id + ".caxis.min"] = t1.c, e1;
                    }
                    function F(t1, e1) {
                        var r = C._fullLayout.clickmode;
                        O(C), 2 === t1 && (C.emit("plotly_doubleclick", null), a.call("_guiRelayout", C, R({
                            a: 0,
                            b: 0,
                            c: 0
                        }))), r.indexOf("select") > -1 && 1 === t1 && w(e1, C, [
                            M.xaxis
                        ], [
                            M.yaxis
                        ], M.id, M.dragOptions), r.indexOf("event") > -1 && g.click(C, e1, M.id);
                    }
                    function B(t1, e1) {
                        return 1 - e1 / M.h;
                    }
                    function N(t1, e1) {
                        return 1 - (t1 + (M.h - e1) / Math.sqrt(3)) / M.w;
                    }
                    function j(t1, e1) {
                        return (t1 - (M.h - e1) / Math.sqrt(3)) / M.w;
                    }
                    function U(i, a) {
                        var o = r + i * t1, s = n + a * e1, l = Math.max(0, Math.min(1, B(0, n), B(0, s))), c = Math.max(0, Math.min(1, N(r, n), N(o, s))), u = Math.max(0, Math.min(1, j(r, n), j(o, s))), m = (l / 2 + u) * M.w, g = (1 - l / 2 - c) * M.w, v = (m + g) / 2, x = g - m, b = (1 - l) * M.h, w = b - x / E;
                        x < A.MINZOOM ? (p = h, T.attr("d", y), k.attr("d", "M0,0Z")) : (p = {
                            a: h.a + l * f,
                            b: h.b + c * f,
                            c: h.c + u * f
                        }, T.attr("d", y + "M" + m + "," + b + "H" + g + "L" + v + "," + w + "L" + m + "," + b + "Z"), k.attr("d", "M" + r + "," + n + "m0.5,0.5h5v-2h-5v-5h-2v5h-5v2h5v5h2ZM" + m + "," + b + L + "M" + g + "," + b + I + "M" + v + "," + w + P)), _ || (T.transition().style("fill", d > .2 ? "rgba(0,0,0,0.4)" : "rgba(255,255,255,0.3)").duration(200), k.transition().style("opacity", 1).duration(200), _ = !0), C.emit("plotly_relayouting", R(p));
                    }
                    function V() {
                        O(C), p !== h && (a.call("_guiRelayout", C, R(p)), z && C.data && C._context.showTips && (o.notifier(l(C, "Double-click to zoom back out"), "long"), z = !1));
                    }
                    function q(t1, e1) {
                        var r = t1 / M.xaxis._m, n = e1 / M.yaxis._m, i = [
                            (p = {
                                a: h.a - n,
                                b: h.b + (r + n) / 2,
                                c: h.c - (r - n) / 2
                            }).a,
                            p.b,
                            p.c
                        ].sort(o.sorterAsc), a = i.indexOf(p.a), l = i.indexOf(p.b), c = i.indexOf(p.c);
                        i[0] < 0 && (i[1] + i[0] / 2 < 0 ? (i[2] += i[0] + i[1], i[0] = i[1] = 0) : (i[2] += i[0] / 2, i[1] += i[0] / 2, i[0] = 0), p = {
                            a: i[a],
                            b: i[l],
                            c: i[c]
                        }, e1 = (h.a - p.a) * M.yaxis._m, t1 = (h.c - p.c - h.b + p.b) * M.xaxis._m);
                        var f = s(M.x0 + t1, M.y0 + e1);
                        M.plotContainer.selectAll(".scatterlayer,.maplayer").attr("transform", f);
                        var d = s(-t1, -e1);
                        M.clipDefRelative.select("path").attr("transform", d), M.aaxis.range = [
                            p.a,
                            M.sum - p.b - p.c
                        ], M.baxis.range = [
                            M.sum - p.a - p.c,
                            p.b
                        ], M.caxis.range = [
                            M.sum - p.a - p.b,
                            p.c
                        ], M.drawAxes(!1), M._hasClipOnAxisFalse && M.plotContainer.select(".scatterlayer").selectAll(".trace").call(u.hideOutsideRangePoints, M), C.emit("plotly_relayouting", R(p));
                    }
                    function H() {
                        a.call("_guiRelayout", C, R(p));
                    }
                    this.dragOptions = {
                        element: S,
                        gd: C,
                        plotinfo: {
                            id: M.id,
                            domain: C._fullLayout[M.id].domain,
                            xaxis: M.xaxis,
                            yaxis: M.yaxis
                        },
                        subplot: M.id,
                        prepFn: function(a, l, u) {
                            M.dragOptions.xaxes = [
                                M.xaxis
                            ], M.dragOptions.yaxes = [
                                M.yaxis
                            ], t1 = C._fullLayout._invScaleX, e1 = C._fullLayout._invScaleY;
                            var m = M.dragOptions.dragmode = C._fullLayout.dragmode;
                            v(m) ? M.dragOptions.minDrag = 1 : M.dragOptions.minDrag = void 0, "zoom" === m ? (M.dragOptions.moveFn = U, M.dragOptions.clickFn = F, M.dragOptions.doneFn = V, function(t1, e1, a) {
                                var l = S.getBoundingClientRect();
                                r = e1 - l.left, n = a - l.top, C._fullLayout._calcInverseTransform(C);
                                var u = C._fullLayout._invTransform, m = o.apply3DTransform(u)(r, n);
                                r = m[0], n = m[1], h = {
                                    a: M.aaxis.range[0],
                                    b: M.baxis.range[1],
                                    c: M.caxis.range[1]
                                }, p = h, f = M.aaxis.range[1] - h.a, d = i(M.graphDiv._fullLayout[M.id].bgcolor).getLuminance(), y = "M0," + M.h + "L" + M.w / 2 + ", 0L" + M.w + "," + M.h + "Z", _ = !1, T = D.append("path").attr("class", "zoombox").attr("transform", s(M.x0, M.y0)).style({
                                    fill: d > .2 ? "rgba(0,0,0,0)" : "rgba(255,255,255,0)",
                                    "stroke-width": 0
                                }).attr("d", y), k = D.append("path").attr("class", "zoombox-corners").attr("transform", s(M.x0, M.y0)).style({
                                    fill: c.background,
                                    stroke: c.defaultLine,
                                    "stroke-width": 1,
                                    opacity: 0
                                }).attr("d", "M0,0Z"), M.clearOutline(C);
                            }(0, l, u)) : "pan" === m ? (M.dragOptions.moveFn = q, M.dragOptions.clickFn = F, M.dragOptions.doneFn = H, h = {
                                a: M.aaxis.range[0],
                                b: M.baxis.range[1],
                                c: M.caxis.range[1]
                            }, p = h, M.clearOutline(C)) : (x(m) || v(m)) && b(a, l, u, M.dragOptions, m);
                        }
                    }, S.onmousemove = function(t1) {
                        g.hover(C, t1, M.id), C._fullLayout._lasthover = S, C._fullLayout._hoversubplot = M.id;
                    }, S.onmouseout = function(t1) {
                        C._dragging || m.unhover(C, t1);
                    }, m.init(this.dragOptions);
                };
            },
            33626: function(t1, e1, r) {
                "use strict";
                var n = r(48636), i = r(4969), a = r(36539), o = r(56174), s = r(95425).addStyleRule, l = r(93049), c = r(9829), u = r(6704), h = l.extendFlat, f = l.extendDeepAll;
                function p(t1) {
                    var i = t1.name, a = t1.categories, o = t1.meta;
                    if (e1.modules[i]) n.log("Type " + i + " already registered");
                    else {
                        e1.subplotsRegistry[t1.basePlotModule.name] || function(t1) {
                            var r = t1.name;
                            if (e1.subplotsRegistry[r]) n.log("Plot type " + r + " already registered.");
                            else for(var i in y(t1), e1.subplotsRegistry[r] = t1, e1.componentsRegistry)_(i, t1.name);
                        }(t1.basePlotModule);
                        for(var l = {}, c = 0; c < a.length; c++)l[a[c]] = !0, e1.allCategories[a[c]] = !0;
                        for(var u in e1.modules[i] = {
                            _module: t1,
                            categories: l
                        }, o && Object.keys(o).length && (e1.modules[i].meta = o), e1.allTypes.push(i), e1.componentsRegistry)v(u, i);
                        t1.layoutAttributes && h(e1.traceLayoutAttributes, t1.layoutAttributes);
                        var f = t1.basePlotModule, p = f.name;
                        if ("mapbox" === p) {
                            var d = f.constants.styleRules;
                            for(var m in d)s(".js-plotly-plot .plotly .mapboxgl-" + m, d[m]);
                        }
                        "map" === p && r(96144), "geo" !== p && "mapbox" !== p && "map" !== p || void 0 !== window.PlotlyGeoAssets || (window.PlotlyGeoAssets = {
                            topojson: {}
                        });
                    }
                }
                function d(t1) {
                    if ("string" != typeof t1.name) throw new Error("Component module *name* must be a string.");
                    var r = t1.name;
                    for(var n in e1.componentsRegistry[r] = t1, t1.layoutAttributes && (t1.layoutAttributes._isLinkedToArray && a(e1.layoutArrayContainers, r), y(t1)), e1.modules)v(r, n);
                    for(var i in e1.subplotsRegistry)_(r, i);
                    for(var o in e1.transformsRegistry)x(r, o);
                    t1.schema && t1.schema.layout && f(u, t1.schema.layout);
                }
                function m(t1) {
                    if ("string" != typeof t1.name) throw new Error("Transform module *name* must be a string.");
                    var r = "Transform module " + t1.name, i = "function" == typeof t1.transform, a = "function" == typeof t1.calcTransform;
                    if (!i && !a) throw new Error(r + " is missing a *transform* or *calcTransform* method.");
                    for(var s in i && a && n.log([
                        r + " has both a *transform* and *calcTransform* methods.",
                        "Please note that all *transform* methods are executed",
                        "before all *calcTransform* methods."
                    ].join(" ")), o(t1.attributes) || n.log(r + " registered without an *attributes* object."), "function" != typeof t1.supplyDefaults && n.log(r + " registered without a *supplyDefaults* method."), e1.transformsRegistry[t1.name] = t1, e1.componentsRegistry)x(s, t1.name);
                }
                function g(t1) {
                    var r = t1.name, n = r.split("-")[0], i = t1.dictionary, a = t1.format, o = i && Object.keys(i).length, s = a && Object.keys(a).length, l = e1.localeRegistry, c = l[r];
                    if (c || (l[r] = c = {}), n !== r) {
                        var u = l[n];
                        u || (l[n] = u = {}), o && u.dictionary === c.dictionary && (u.dictionary = i), s && u.format === c.format && (u.format = a);
                    }
                    o && (c.dictionary = i), s && (c.format = a);
                }
                function y(t1) {
                    if (t1.layoutAttributes) {
                        var r = t1.layoutAttributes._arrayAttrRegexps;
                        if (r) for(var n = 0; n < r.length; n++)a(e1.layoutArrayRegexes, r[n]);
                    }
                }
                function v(t1, r) {
                    var n = e1.componentsRegistry[t1].schema;
                    if (n && n.traces) {
                        var i = n.traces[r];
                        i && f(e1.modules[r]._module.attributes, i);
                    }
                }
                function x(t1, r) {
                    var n = e1.componentsRegistry[t1].schema;
                    if (n && n.transforms) {
                        var i = n.transforms[r];
                        i && f(e1.transformsRegistry[r].attributes, i);
                    }
                }
                function _(t1, r) {
                    var n = e1.componentsRegistry[t1].schema;
                    if (n && n.subplots) {
                        var i = e1.subplotsRegistry[r], a = i.layoutAttributes, o = "subplot" === i.attr ? i.name : i.attr;
                        Array.isArray(o) && (o = o[0]);
                        var s = n.subplots[o];
                        a && s && f(a, s);
                    }
                }
                function b(t1) {
                    return "object" == typeof t1 && (t1 = t1.type), t1;
                }
                e1.modules = {}, e1.allCategories = {}, e1.allTypes = [], e1.subplotsRegistry = {}, e1.transformsRegistry = {}, e1.componentsRegistry = {}, e1.layoutArrayContainers = [], e1.layoutArrayRegexes = [], e1.traceLayoutAttributes = {}, e1.localeRegistry = {}, e1.apiMethodRegistry = {}, e1.collectableSubplotTypes = null, e1.register = function(t1) {
                    if (e1.collectableSubplotTypes = null, !t1) throw new Error("No argument passed to Plotly.register.");
                    t1 && !Array.isArray(t1) && (t1 = [
                        t1
                    ]);
                    for(var r = 0; r < t1.length; r++){
                        var n = t1[r];
                        if (!n) throw new Error("Invalid module was attempted to be registered!");
                        switch(n.moduleType){
                            case "trace":
                                p(n);
                                break;
                            case "transform":
                                m(n);
                                break;
                            case "component":
                                d(n);
                                break;
                            case "locale":
                                g(n);
                                break;
                            case "apiMethod":
                                var i = n.name;
                                e1.apiMethodRegistry[i] = n.fn;
                                break;
                            default:
                                throw new Error("Invalid module was attempted to be registered!");
                        }
                    }
                }, e1.getModule = function(t1) {
                    var r = e1.modules[b(t1)];
                    return !!r && r._module;
                }, e1.traceIs = function(t1, r) {
                    if ("various" === (t1 = b(t1))) return !1;
                    var i = e1.modules[t1];
                    return i || (t1 && n.log("Unrecognized trace type " + t1 + "."), i = e1.modules[c.type.dflt]), !!i.categories[r];
                }, e1.getTransformIndices = function(t1, e1) {
                    for(var r = [], n = t1.transforms || [], i = 0; i < n.length; i++)n[i].type === e1 && r.push(i);
                    return r;
                }, e1.hasTransform = function(t1, e1) {
                    for(var r = t1.transforms || [], n = 0; n < r.length; n++)if (r[n].type === e1) return !0;
                    return !1;
                }, e1.getComponentMethod = function(t1, r) {
                    var n = e1.componentsRegistry[t1];
                    return n && n[r] || i;
                }, e1.call = function() {
                    var t1 = arguments[0], r = [].slice.call(arguments, 1);
                    return e1.apiMethodRegistry[t1].apply(null, r);
                };
            },
            3164: function(t1, e1, r) {
                "use strict";
                var n = r(33626), i = r(34809), a = i.extendFlat, o = i.extendDeep;
                function s(t1) {
                    var e1;
                    switch(t1){
                        case "themes__thumb":
                            e1 = {
                                autosize: !0,
                                width: 150,
                                height: 150,
                                title: {
                                    text: ""
                                },
                                showlegend: !1,
                                margin: {
                                    l: 5,
                                    r: 5,
                                    t: 5,
                                    b: 5,
                                    pad: 0
                                },
                                annotations: []
                            };
                            break;
                        case "thumbnail":
                            e1 = {
                                title: {
                                    text: ""
                                },
                                hidesources: !0,
                                showlegend: !1,
                                borderwidth: 0,
                                bordercolor: "",
                                margin: {
                                    l: 1,
                                    r: 1,
                                    t: 1,
                                    b: 1,
                                    pad: 0
                                },
                                annotations: []
                            };
                            break;
                        default:
                            e1 = {};
                    }
                    return e1;
                }
                t1.exports = function(t1, e1) {
                    var r, i, l = t1.data, c = t1.layout, u = o([], l), h = o({}, c, s(e1.tileClass)), f = t1._context || {};
                    if (e1.width && (h.width = e1.width), e1.height && (h.height = e1.height), "thumbnail" === e1.tileClass || "themes__thumb" === e1.tileClass) {
                        h.annotations = [];
                        var p = Object.keys(h);
                        for(r = 0; r < p.length; r++)i = p[r], [
                            "xaxis",
                            "yaxis",
                            "zaxis"
                        ].indexOf(i.slice(0, 5)) > -1 && (h[p[r]].title = {
                            text: ""
                        });
                        for(r = 0; r < u.length; r++){
                            var d = u[r];
                            d.showscale = !1, d.marker && (d.marker.showscale = !1), n.traceIs(d, "pie-like") && (d.textposition = "none");
                        }
                    }
                    if (Array.isArray(e1.annotations)) for(r = 0; r < e1.annotations.length; r++)h.annotations.push(e1.annotations[r]);
                    var m = Object.keys(h).filter(function(t1) {
                        return t1.match(/^scene\d*$/);
                    });
                    if (m.length) {
                        var g = {};
                        for("thumbnail" === e1.tileClass && (g = {
                            title: {
                                text: ""
                            },
                            showaxeslabels: !1,
                            showticklabels: !1,
                            linetickenable: !1
                        }), r = 0; r < m.length; r++){
                            var y = h[m[r]];
                            y.xaxis || (y.xaxis = {}), y.yaxis || (y.yaxis = {}), y.zaxis || (y.zaxis = {}), a(y.xaxis, g), a(y.yaxis, g), a(y.zaxis, g), y._scene = null;
                        }
                    }
                    var v = document.createElement("div");
                    e1.tileClass && (v.className = e1.tileClass);
                    var x = {
                        gd: v,
                        td: v,
                        layout: h,
                        data: u,
                        config: {
                            staticPlot: void 0 === e1.staticPlot || e1.staticPlot,
                            plotGlPixelRatio: void 0 === e1.plotGlPixelRatio ? 2 : e1.plotGlPixelRatio,
                            displaylogo: e1.displaylogo || !1,
                            showLink: e1.showLink || !1,
                            showTips: e1.showTips || !1,
                            mapboxAccessToken: f.mapboxAccessToken
                        }
                    };
                    return "transparent" !== e1.setBackground && (x.config.setBackground = e1.setBackground || "opaque"), x.gd.defaultLayout = s(e1.tileClass), x;
                };
            },
            26452: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(80491), a = r(33353), o = r(84619);
                t1.exports = function(t1, e1) {
                    var r;
                    return n.isPlainObject(t1) || (r = n.getGraphDiv(t1)), (e1 = e1 || {}).format = e1.format || "png", e1.width = e1.width || null, e1.height = e1.height || null, e1.imageDataOnly = !0, new Promise(function(s, l) {
                        r && r._snapshotInProgress && l(new Error("Snapshotting already in progress.")), n.isIE() && "svg" !== e1.format && l(new Error(o.MSG_IE_BAD_FORMAT)), r && (r._snapshotInProgress = !0);
                        var c = i(t1, e1), u = e1.filename || t1.fn || "newplot";
                        u += "." + e1.format.replace("-", "."), c.then(function(t1) {
                            return r && (r._snapshotInProgress = !1), a(t1, u, e1.format);
                        }).then(function(t1) {
                            s(t1);
                        }).catch(function(t1) {
                            r && (r._snapshotInProgress = !1), l(t1);
                        });
                    });
                };
            },
            33353: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(84619);
                t1.exports = function(t1, e1, r) {
                    var a = document.createElement("a"), o = "download" in a;
                    return new Promise(function(s, l) {
                        var c, u;
                        if (n.isIE()) return c = i.createBlob(t1, "svg"), window.navigator.msSaveBlob(c, e1), c = null, s(e1);
                        if (o) return c = i.createBlob(t1, r), u = i.createObjectURL(c), a.href = u, a.download = e1, document.body.appendChild(a), a.click(), document.body.removeChild(a), i.revokeObjectURL(u), c = null, s(e1);
                        if (n.isSafari()) {
                            var h = "svg" === r ? "," : ";base64,";
                            return i.octetStream(h + encodeURIComponent(t1)), s(e1);
                        }
                        l(new Error("download error"));
                    });
                };
            },
            84619: function(t1, e1, r) {
                "use strict";
                var n = r(33626);
                e1.getDelay = function(t1) {
                    return t1._has && (t1._has("gl3d") || t1._has("gl2d") || t1._has("mapbox") || t1._has("map")) ? 500 : 0;
                }, e1.getRedrawFunc = function(t1) {
                    return function() {
                        n.getComponentMethod("colorbar", "draw")(t1);
                    };
                }, e1.encodeSVG = function(t1) {
                    return "data:image/svg+xml," + encodeURIComponent(t1);
                }, e1.encodeJSON = function(t1) {
                    return "data:application/json," + encodeURIComponent(t1);
                };
                var i = window.URL || window.webkitURL;
                e1.createObjectURL = function(t1) {
                    return i.createObjectURL(t1);
                }, e1.revokeObjectURL = function(t1) {
                    return i.revokeObjectURL(t1);
                }, e1.createBlob = function(t1, e1) {
                    if ("svg" === e1) return new window.Blob([
                        t1
                    ], {
                        type: "image/svg+xml;charset=utf-8"
                    });
                    if ("full-json" === e1) return new window.Blob([
                        t1
                    ], {
                        type: "application/json;charset=utf-8"
                    });
                    var r = function(t1) {
                        for(var e1 = t1.length, r = new ArrayBuffer(e1), n = new Uint8Array(r), i = 0; i < e1; i++)n[i] = t1.charCodeAt(i);
                        return r;
                    }(window.atob(t1));
                    return new window.Blob([
                        r
                    ], {
                        type: "image/" + e1
                    });
                }, e1.octetStream = function(t1) {
                    document.location.href = "data:application/octet-stream" + t1;
                }, e1.IMAGE_URL_PREFIX = /^data:image\/\w+;base64,/, e1.MSG_IE_BAD_FORMAT = "Sorry IE does not support downloading from canvas. Try {format:'svg'} instead.";
            },
            6170: function(t1, e1, r) {
                "use strict";
                var n = r(84619), i = {
                    getDelay: n.getDelay,
                    getRedrawFunc: n.getRedrawFunc,
                    clone: r(3164),
                    toSVG: r(6243),
                    svgToImg: r(72914),
                    toImage: r(76896),
                    downloadImage: r(26452)
                };
                t1.exports = i;
            },
            72914: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(7683).EventEmitter, a = r(84619);
                t1.exports = function(t1) {
                    var e1 = t1.emitter || new i, r = new Promise(function(i, o) {
                        var s = window.Image, l = t1.svg, c = t1.format || "png";
                        if (n.isIE() && "svg" !== c) {
                            var u = new Error(a.MSG_IE_BAD_FORMAT);
                            return o(u), t1.promise ? r : e1.emit("error", u);
                        }
                        var h, f, p = t1.canvas, d = t1.scale || 1, m = t1.width || 300, g = t1.height || 150, y = d * m, v = d * g, x = p.getContext("2d", {
                            willReadFrequently: !0
                        }), _ = new s;
                        "svg" === c || n.isSafari() ? f = a.encodeSVG(l) : (h = a.createBlob(l, "svg"), f = a.createObjectURL(h)), p.width = y, p.height = v, _.onload = function() {
                            var r;
                            switch(h = null, a.revokeObjectURL(f), "svg" !== c && x.drawImage(_, 0, 0, y, v), c){
                                case "jpeg":
                                    r = p.toDataURL("image/jpeg");
                                    break;
                                case "png":
                                    r = p.toDataURL("image/png");
                                    break;
                                case "webp":
                                    r = p.toDataURL("image/webp");
                                    break;
                                case "svg":
                                    r = f;
                                    break;
                                default:
                                    var n = "Image format is not jpeg, png, svg or webp.";
                                    if (o(new Error(n)), !t1.promise) return e1.emit("error", n);
                            }
                            i(r), t1.promise || e1.emit("success", r);
                        }, _.onerror = function(r) {
                            if (h = null, a.revokeObjectURL(f), o(r), !t1.promise) return e1.emit("error", r);
                        }, _.src = f;
                    });
                    return t1.promise ? r : e1;
                };
            },
            76896: function(t1, e1, r) {
                "use strict";
                var n = r(7683).EventEmitter, i = r(33626), a = r(34809), o = r(84619), s = r(3164), l = r(6243), c = r(72914);
                t1.exports = function(t1, e1) {
                    var r = new n, u = s(t1, {
                        format: "png"
                    }), h = u.gd;
                    h.style.position = "absolute", h.style.left = "-5000px", document.body.appendChild(h);
                    var f = o.getRedrawFunc(h);
                    return i.call("_doPlot", h, u.data, u.layout, u.config).then(f).then(function() {
                        var t1 = o.getDelay(h._fullLayout);
                        setTimeout(function() {
                            var t1 = l(h), n = document.createElement("canvas");
                            n.id = a.randstr(), (r = c({
                                format: e1.format,
                                width: h._fullLayout.width,
                                height: h._fullLayout.height,
                                canvas: n,
                                emitter: r,
                                svg: t1
                            })).clean = function() {
                                h && document.body.removeChild(h);
                            };
                        }, t1);
                    }).catch(function(t1) {
                        r.emit("error", t1);
                    }), r;
                };
            },
            6243: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(34809), a = r(62203), o = r(78766), s = r(62972), l = /"/g, c = "TOBESTRIPPED", u = new RegExp('("' + c + ")|(" + c + '")', "g");
                t1.exports = function(t1, e1, r) {
                    var h, f = t1._fullLayout, p = f._paper, d = f._toppaper, m = f.width, g = f.height;
                    p.insert("rect", ":first-child").call(a.setRect, 0, 0, m, g).call(o.fill, f.paper_bgcolor);
                    var y = f._basePlotModules || [];
                    for(h = 0; h < y.length; h++){
                        var v = y[h];
                        v.toSVG && v.toSVG(t1);
                    }
                    if (d) {
                        var x = d.node().childNodes, _ = Array.prototype.slice.call(x);
                        for(h = 0; h < _.length; h++){
                            var b = _[h];
                            b.childNodes.length && p.node().appendChild(b);
                        }
                    }
                    f._draggers && f._draggers.remove(), p.node().style.background = "", p.selectAll("text").attr({
                        "data-unformatted": null,
                        "data-math": null
                    }).each(function() {
                        var t1 = n.select(this);
                        if ("hidden" !== this.style.visibility && "none" !== this.style.display) {
                            t1.style({
                                visibility: null,
                                display: null
                            });
                            var e1 = this.style.fontFamily;
                            e1 && -1 !== e1.indexOf('"') && t1.style("font-family", e1.replace(l, c));
                            var r = this.style.fontWeight;
                            !r || "normal" !== r && "400" !== r || t1.style("font-weight", void 0);
                            var i = this.style.fontStyle;
                            i && "normal" === i && t1.style("font-style", void 0);
                            var a = this.style.fontVariant;
                            a && "normal" === a && t1.style("font-variant", void 0);
                        } else t1.remove();
                    }), p.selectAll(".gradient_filled,.pattern_filled").each(function() {
                        var t1 = n.select(this), e1 = this.style.fill;
                        e1 && -1 !== e1.indexOf("url(") && t1.style("fill", e1.replace(l, c));
                        var r = this.style.stroke;
                        r && -1 !== r.indexOf("url(") && t1.style("stroke", r.replace(l, c));
                    }), "pdf" !== e1 && "eps" !== e1 || p.selectAll("#MathJax_SVG_glyphs path").attr("stroke-width", 0), p.node().setAttributeNS(s.xmlns, "xmlns", s.svg), p.node().setAttributeNS(s.xmlns, "xmlns:xlink", s.xlink), "svg" === e1 && r && (p.attr("width", r * m), p.attr("height", r * g), p.attr("viewBox", "0 0 " + m + " " + g));
                    var w = (new window.XMLSerializer).serializeToString(p.node());
                    return w = (w = (w = function(t1) {
                        var e1 = n.select("body").append("div").style({
                            display: "none"
                        }).html(""), r = t1.replace(/(&[^;]*;)/gi, function(t1) {
                            return "&lt;" === t1 ? "&#60;" : "&rt;" === t1 ? "&#62;" : -1 !== t1.indexOf("<") || -1 !== t1.indexOf(">") ? "" : e1.html(t1).text();
                        });
                        return e1.remove(), r;
                    }(w)).replace(/&(?!\w+;|\#[0-9]+;| \#x[0-9A-F]+;)/g, "&amp;")).replace(u, "'"), i.isIE() && (w = (w = (w = w.replace(/"/gi, "'")).replace(/(\('#)([^']*)('\))/gi, '("#$2")')).replace(/(\\')/gi, '"')), w;
                };
            },
            35374: function(t1, e1, r) {
                "use strict";
                var n = r(34809);
                t1.exports = function(t1, e1) {
                    for(var r = 0; r < t1.length; r++)t1[r].i = r;
                    n.mergeArray(e1.text, t1, "tx"), n.mergeArray(e1.hovertext, t1, "htx");
                    var i = e1.marker;
                    if (i) {
                        n.mergeArray(i.opacity, t1, "mo", !0), n.mergeArray(i.color, t1, "mc");
                        var a = i.line;
                        a && (n.mergeArray(a.color, t1, "mlc"), n.mergeArrayCastPositive(a.width, t1, "mlw"));
                    }
                };
            },
            81481: function(t1, e1, r) {
                "use strict";
                var n = r(36640), i = r(80712).axisHoverFormat, a = r(3208).rb, o = r(3208).ay, s = r(87163), l = r(80337), c = r(56155), u = r(94850).k, h = r(93049).extendFlat, f = l({
                    editType: "calc",
                    arrayOk: !0,
                    colorEditType: "style"
                }), p = h({}, n.marker.line.width, {
                    dflt: 0
                }), d = h({
                    width: p,
                    editType: "calc"
                }, s("marker.line")), m = h({
                    line: d,
                    editType: "calc"
                }, s("marker"), {
                    opacity: {
                        valType: "number",
                        arrayOk: !0,
                        dflt: 1,
                        min: 0,
                        max: 1,
                        editType: "style"
                    },
                    pattern: u,
                    cornerradius: {
                        valType: "any",
                        editType: "calc"
                    }
                });
                t1.exports = {
                    x: n.x,
                    x0: n.x0,
                    dx: n.dx,
                    y: n.y,
                    y0: n.y0,
                    dy: n.dy,
                    xperiod: n.xperiod,
                    yperiod: n.yperiod,
                    xperiod0: n.xperiod0,
                    yperiod0: n.yperiod0,
                    xperiodalignment: n.xperiodalignment,
                    yperiodalignment: n.yperiodalignment,
                    xhoverformat: i("x"),
                    yhoverformat: i("y"),
                    text: n.text,
                    texttemplate: o({
                        editType: "plot"
                    }, {
                        keys: c.eventDataKeys
                    }),
                    hovertext: n.hovertext,
                    hovertemplate: a({}, {
                        keys: c.eventDataKeys
                    }),
                    textposition: {
                        valType: "enumerated",
                        values: [
                            "inside",
                            "outside",
                            "auto",
                            "none"
                        ],
                        dflt: "auto",
                        arrayOk: !0,
                        editType: "calc"
                    },
                    insidetextanchor: {
                        valType: "enumerated",
                        values: [
                            "end",
                            "middle",
                            "start"
                        ],
                        dflt: "end",
                        editType: "plot"
                    },
                    textangle: {
                        valType: "angle",
                        dflt: "auto",
                        editType: "plot"
                    },
                    textfont: h({}, f, {}),
                    insidetextfont: h({}, f, {}),
                    outsidetextfont: h({}, f, {}),
                    constraintext: {
                        valType: "enumerated",
                        values: [
                            "inside",
                            "outside",
                            "both",
                            "none"
                        ],
                        dflt: "both",
                        editType: "calc"
                    },
                    cliponaxis: h({}, n.cliponaxis, {}),
                    orientation: {
                        valType: "enumerated",
                        values: [
                            "v",
                            "h"
                        ],
                        editType: "calc+clearAxisTypes"
                    },
                    base: {
                        valType: "any",
                        dflt: null,
                        arrayOk: !0,
                        editType: "calc"
                    },
                    offset: {
                        valType: "number",
                        dflt: null,
                        arrayOk: !0,
                        editType: "calc"
                    },
                    width: {
                        valType: "number",
                        dflt: null,
                        min: 0,
                        arrayOk: !0,
                        editType: "calc"
                    },
                    marker: m,
                    offsetgroup: n.offsetgroup,
                    alignmentgroup: n.alignmentgroup,
                    selected: {
                        marker: {
                            opacity: n.selected.marker.opacity,
                            color: n.selected.marker.color,
                            editType: "style"
                        },
                        textfont: n.selected.textfont,
                        editType: "style"
                    },
                    unselected: {
                        marker: {
                            opacity: n.unselected.marker.opacity,
                            color: n.unselected.marker.color,
                            editType: "style"
                        },
                        textfont: n.unselected.textfont,
                        editType: "style"
                    },
                    zorder: n.zorder,
                    _deprecated: {
                        bardir: {
                            valType: "enumerated",
                            editType: "calc",
                            values: [
                                "v",
                                "h"
                            ]
                        }
                    }
                };
            },
            67565: function(t1, e1, r) {
                "use strict";
                var n = r(29714), i = r(40528), a = r(65477).hasColorscale, o = r(28379), s = r(35374), l = r(48861);
                t1.exports = function(t1, e1) {
                    var r, c, u, h, f, p, d = n.getFromId(t1, e1.xaxis || "x"), m = n.getFromId(t1, e1.yaxis || "y"), g = {
                        msUTC: !(!e1.base && 0 !== e1.base)
                    };
                    "h" === e1.orientation ? (r = d.makeCalcdata(e1, "x", g), u = m.makeCalcdata(e1, "y"), h = i(e1, m, "y", u), f = !!e1.yperiodalignment, p = "y") : (r = m.makeCalcdata(e1, "y", g), u = d.makeCalcdata(e1, "x"), h = i(e1, d, "x", u), f = !!e1.xperiodalignment, p = "x"), c = h.vals;
                    for(var y = Math.min(c.length, r.length), v = new Array(y), x = 0; x < y; x++)v[x] = {
                        p: c[x],
                        s: r[x]
                    }, f && (v[x].orig_p = u[x], v[x][p + "End"] = h.ends[x], v[x][p + "Start"] = h.starts[x]), e1.ids && (v[x].id = String(e1.ids[x]));
                    return a(e1, "marker") && o(t1, e1, {
                        vals: e1.marker.color,
                        containerStr: "marker",
                        cLetter: "c"
                    }), a(e1, "marker.line") && o(t1, e1, {
                        vals: e1.marker.line.color,
                        containerStr: "marker.line",
                        cLetter: "c"
                    }), s(v, e1), l(v, e1), v;
                };
            },
            56155: function(t1) {
                "use strict";
                t1.exports = {
                    TEXTPAD: 3,
                    eventDataKeys: [
                        "value",
                        "label"
                    ]
                };
            },
            24782: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(34809).isArrayOrTypedArray, a = r(63821).BADNUM, o = r(33626), s = r(29714), l = r(84391).getAxisGroup, c = r(2880);
                function u(t1, e1, r, o, u) {
                    if (o.length) {
                        var _, b, w, T;
                        switch(function(t1, e1) {
                            var r, a;
                            for(r = 0; r < e1.length; r++){
                                var o, s = e1[r], l = s[0].trace, c = "funnel" === l.type ? l._base : l.base, u = "h" === l.orientation ? l.xcalendar : l.ycalendar, h = "category" === t1.type || "multicategory" === t1.type ? function() {
                                    return null;
                                } : t1.d2c;
                                if (i(c)) {
                                    for(a = 0; a < Math.min(c.length, s.length); a++)o = h(c[a], 0, u), n(o) ? (s[a].b = +o, s[a].hasB = 1) : s[a].b = 0;
                                    for(; a < s.length; a++)s[a].b = 0;
                                } else {
                                    o = h(c, 0, u);
                                    var f = n(o);
                                    for(o = f ? o : 0, a = 0; a < s.length; a++)s[a].b = o, f && (s[a].hasB = 1);
                                }
                            }
                        }(r, o), u.mode){
                            case "overlay":
                                h(e1, r, o, u);
                                break;
                            case "group":
                                for(_ = [], b = [], w = 0; w < o.length; w++)void 0 === (T = o[w])[0].trace.offset ? b.push(T) : _.push(T);
                                b.length && function(t1, e1, r, n, i) {
                                    var o = new c(n, {
                                        posAxis: e1,
                                        sepNegVal: !1,
                                        overlapNoMerge: !i.norm
                                    });
                                    (function(t1, e1, r, n) {
                                        for(var i = t1._fullLayout, a = r.positions, o = r.distinctPositions, s = r.minDiff, c = r.traces, u = c.length, h = a.length !== o.length, f = s * (1 - n.gap), g = l(i, e1._id) + c[0][0].trace.orientation, y = i._alignmentOpts[g] || {}, v = 0; v < u; v++){
                                            var x, _, b = c[v], w = b[0].trace, T = y[w.alignmentgroup] || {}, k = Object.keys(T.offsetGroups || {}).length, A = (x = k ? f / k : h ? f / u : f) * (1 - (n.groupgap || 0));
                                            _ = k ? ((2 * w._offsetIndex + 1 - k) * x - A) / 2 : h ? ((2 * v + 1 - u) * x - A) / 2 : -A / 2;
                                            var M = b[0].t;
                                            M.barwidth = A, M.poffset = _, M.bargroupwidth = f, M.bardelta = s;
                                        }
                                        r.binWidth = c[0][0].t.barwidth / 100, p(r), d(e1, r), m(e1, r, h);
                                    })(t1, e1, o, i), function(t1, e1) {
                                        for(var r = t1.traces, n = 0; n < r.length; n++){
                                            var i = r[n];
                                            if (void 0 === i[0].trace.base) for(var o = new c([
                                                i
                                            ], {
                                                posAxis: e1,
                                                sepNegVal: !0,
                                                overlapNoMerge: !0
                                            }), s = 0; s < i.length; s++){
                                                var l = i[s];
                                                if (l.p !== a) {
                                                    var u = o.put(l.p, l.b + l.s);
                                                    u && (l.b = u);
                                                }
                                            }
                                        }
                                    }(o, e1), i.norm ? (y(o), v(r, o, i)) : g(r, o);
                                }(t1, e1, r, b, u), _.length && h(e1, r, _, u);
                                break;
                            case "stack":
                            case "relative":
                                for(_ = [], b = [], w = 0; w < o.length; w++)void 0 === (T = o[w])[0].trace.base ? b.push(T) : _.push(T);
                                !function(t1) {
                                    if (!(t1.length < 2)) {
                                        var e1, r, i, a, o, s;
                                        for(e1 = 0; e1 < t1.length && void 0 === (a = (r = t1[e1][0].trace).marker ? r.marker.cornerradius : void 0); e1++);
                                        if (void 0 !== a) for(o = n(a) ? +a : +a.slice(0, -1), s = n(a) ? "px" : "%", e1 = 0; e1 < t1.length; e1++)(i = t1[e1][0].t).cornerradiusvalue = o, i.cornerradiusform = s;
                                    }
                                }(b), b.length && function(t1, e1, r, n, i) {
                                    var o = new c(n, {
                                        posAxis: e1,
                                        sepNegVal: "relative" === i.mode,
                                        overlapNoMerge: !(i.norm || "stack" === i.mode || "relative" === i.mode)
                                    });
                                    f(e1, o, i), function(t1, e1, r) {
                                        var n, i, o, l, c, u, h = x(t1), f = e1.traces;
                                        for(l = 0; l < f.length; l++)if ("funnel" === (i = (n = f[l])[0].trace).type) for(c = 0; c < n.length; c++)(u = n[c]).s !== a && e1.put(u.p, -0.5 * u.s);
                                        for(l = 0; l < f.length; l++){
                                            o = "funnel" === (i = (n = f[l])[0].trace).type;
                                            var p = [];
                                            for(c = 0; c < n.length; c++)if ((u = n[c]).s !== a) {
                                                var d;
                                                d = o ? u.s : u.s + u.b;
                                                var m = e1.put(u.p, d), g = m + d;
                                                u.b = m, u[h] = g, r.norm || (p.push(g), u.hasB && p.push(m));
                                            }
                                            r.norm || (i._extremes[t1._id] = s.findExtremes(t1, p, {
                                                tozero: !0,
                                                padded: !0
                                            }));
                                        }
                                    }(r, o, i);
                                    for(var l = 0; l < n.length; l++)for(var u = n[l], h = 0; h < u.length; h++){
                                        var p = u[h];
                                        p.s !== a && p.b + p.s === o.get(p.p, p.s) && (p._outmost = !0);
                                    }
                                    i.norm && v(r, o, i);
                                }(0, e1, r, b, u), _.length && h(e1, r, _, u);
                        }
                        !function(t1) {
                            var e1, r, i, a, o, s, l;
                            for(e1 = 0; e1 < t1.length; e1++)i = (r = t1[e1])[0].trace, void 0 === (a = r[0].t).cornerradiusvalue && void 0 !== (o = i.marker ? i.marker.cornerradius : void 0) && (s = n(o) ? +o : +o.slice(0, -1), l = n(o) ? "px" : "%", a.cornerradiusvalue = s, a.cornerradiusform = l);
                        }(o), function(t1, e1) {
                            var r, a, o, s = x(e1), l = {}, c = 1 / 0, u = -1 / 0;
                            for(r = 0; r < t1.length; r++)for(o = t1[r], a = 0; a < o.length; a++){
                                var h = o[a].p;
                                n(h) && (c = Math.min(c, h), u = Math.max(u, h));
                            }
                            var f = 1e4 / (u - c), p = l.round = function(t1) {
                                return String(Math.round(f * (t1 - c)));
                            }, d = {}, m = {}, g = t1.some(function(t1) {
                                var e1 = t1[0].trace;
                                return "marker" in e1 && e1.marker.cornerradius;
                            });
                            for(r = 0; r < t1.length; r++){
                                (o = t1[r])[0].t.extents = l;
                                var y = o[0].t.poffset, v = i(y);
                                for(a = 0; a < o.length; a++){
                                    var _ = o[a], b = _[s] - _.w / 2;
                                    if (n(b)) {
                                        var w = _[s] + _.w / 2, T = p(_.p);
                                        l[T] ? l[T] = [
                                            Math.min(b, l[T][0]),
                                            Math.max(w, l[T][1])
                                        ] : l[T] = [
                                            b,
                                            w
                                        ];
                                    }
                                    if (_.p0 = _.p + (v ? y[a] : y), _.p1 = _.p0 + _.w, _.s0 = _.b, _.s1 = _.s0 + _.s, g) {
                                        var k = Math.min(_.s0, _.s1) || 0, A = Math.max(_.s0, _.s1) || 0, M = _[s];
                                        d[M] = M in d ? Math.min(d[M], k) : k, m[M] = M in m ? Math.max(m[M], A) : A;
                                    }
                                }
                            }
                            g && function(t1, e1, r, n) {
                                for(var i = x(n), a = 0; a < t1.length; a++)for(var o = t1[a], s = 0; s < o.length; s++){
                                    var l = o[s], c = l[i];
                                    l._sMin = e1[c], l._sMax = r[c];
                                }
                            }(t1, d, m, e1);
                        }(o, e1);
                    }
                }
                function h(t1, e1, r, n) {
                    for(var i = 0; i < r.length; i++){
                        var a = r[i], o = new c([
                            a
                        ], {
                            posAxis: t1,
                            sepNegVal: !1,
                            overlapNoMerge: !n.norm
                        });
                        f(t1, o, n), n.norm ? (y(o), v(e1, o, n)) : g(e1, o);
                    }
                }
                function f(t1, e1, r) {
                    for(var n = e1.minDiff, i = e1.traces, a = n * (1 - r.gap), o = a * (1 - (r.groupgap || 0)), s = -o / 2, l = 0; l < i.length; l++){
                        var c = i[l][0].t;
                        c.barwidth = o, c.poffset = s, c.bargroupwidth = a, c.bardelta = n;
                    }
                    e1.binWidth = i[0][0].t.barwidth / 100, p(e1), d(t1, e1), m(t1, e1);
                }
                function p(t1) {
                    var e1, r, a = t1.traces;
                    for(e1 = 0; e1 < a.length; e1++){
                        var o, s = a[e1], l = s[0], c = l.trace, u = l.t, h = c._offset || c.offset, f = u.poffset;
                        if (i(h)) {
                            for(o = Array.prototype.slice.call(h, 0, s.length), r = 0; r < o.length; r++)n(o[r]) || (o[r] = f);
                            for(r = o.length; r < s.length; r++)o.push(f);
                            u.poffset = o;
                        } else void 0 !== h && (u.poffset = h);
                        var p = c._width || c.width, d = u.barwidth;
                        if (i(p)) {
                            var m = Array.prototype.slice.call(p, 0, s.length);
                            for(r = 0; r < m.length; r++)n(m[r]) || (m[r] = d);
                            for(r = m.length; r < s.length; r++)m.push(d);
                            if (u.barwidth = m, void 0 === h) {
                                for(o = [], r = 0; r < s.length; r++)o.push(f + (d - m[r]) / 2);
                                u.poffset = o;
                            }
                        } else void 0 !== p && (u.barwidth = p, void 0 === h && (u.poffset = f + (d - p) / 2));
                    }
                }
                function d(t1, e1) {
                    for(var r = e1.traces, n = x(t1), a = 0; a < r.length; a++)for(var o = r[a], s = o[0].t, l = s.poffset, c = i(l), u = s.barwidth, h = i(u), f = 0; f < o.length; f++){
                        var p = o[f], d = p.w = h ? u[f] : u;
                        void 0 === p.p && (p.p = p[n], p["orig_" + n] = p[n]);
                        var m = (c ? l[f] : l) + d / 2;
                        p[n] = p.p + m;
                    }
                }
                function m(t1, e1, r) {
                    var n = e1.traces, a = e1.minDiff / 2;
                    s.minDtick(t1, e1.minDiff, e1.distinctPositions[0], r);
                    for(var o = 0; o < n.length; o++){
                        var l, c, u, h, f = n[o], p = f[0], d = p.trace, m = [];
                        for(h = 0; h < f.length; h++)c = (l = f[h]).p - a, u = l.p + a, m.push(c, u);
                        if (d.width || d.offset) {
                            var g = p.t, y = g.poffset, v = g.barwidth, x = i(y), _ = i(v);
                            for(h = 0; h < f.length; h++){
                                l = f[h];
                                var b = x ? y[h] : y, w = _ ? v[h] : v;
                                u = (c = l.p + b) + w, m.push(c, u);
                            }
                        }
                        d._extremes[t1._id] = s.findExtremes(t1, m, {
                            padded: !1
                        });
                    }
                }
                function g(t1, e1) {
                    for(var r = e1.traces, n = x(t1), i = 0; i < r.length; i++){
                        for(var a = r[i], o = a[0].trace, l = "scatter" === o.type, c = "v" === o.orientation, u = [], h = !1, f = 0; f < a.length; f++){
                            var p = a[f], d = l ? 0 : p.b, m = l ? c ? p.y : p.x : d + p.s;
                            p[n] = m, u.push(m), p.hasB && u.push(d), p.hasB && p.b || (h = !0);
                        }
                        o._extremes[t1._id] = s.findExtremes(t1, u, {
                            tozero: h,
                            padded: !0
                        });
                    }
                }
                function y(t1) {
                    for(var e1 = t1.traces, r = 0; r < e1.length; r++)for(var n = e1[r], i = 0; i < n.length; i++){
                        var o = n[i];
                        o.s !== a && t1.put(o.p, o.b + o.s);
                    }
                }
                function v(t1, e1, r) {
                    var i = e1.traces, o = x(t1), l = "fraction" === r.norm ? 1 : 100, c = l / 1e9, u = t1.l2c(t1.c2l(0)), h = "stack" === r.mode ? l : u;
                    function f(e1) {
                        return n(t1.c2l(e1)) && (e1 < u - c || e1 > h + c || !n(u));
                    }
                    for(var p = 0; p < i.length; p++){
                        for(var d = i[p], m = d[0].trace, g = [], y = !1, v = !1, _ = 0; _ < d.length; _++){
                            var b = d[_];
                            if (b.s !== a) {
                                var w = Math.abs(l / e1.get(b.p, b.s));
                                b.b *= w, b.s *= w;
                                var T = b.b, k = T + b.s;
                                b[o] = k, g.push(k), v = v || f(k), b.hasB && (g.push(T), v = v || f(T)), b.hasB && b.b || (y = !0);
                            }
                        }
                        m._extremes[t1._id] = s.findExtremes(t1, g, {
                            tozero: y,
                            padded: v
                        });
                    }
                }
                function x(t1) {
                    return t1._id.charAt(0);
                }
                t1.exports = {
                    crossTraceCalc: function(t1, e1) {
                        for(var r = e1.xaxis, n = e1.yaxis, i = t1._fullLayout, a = t1._fullData, s = t1.calcdata, l = [], c = [], h = 0; h < a.length; h++){
                            var f = a[h];
                            if (!0 === f.visible && o.traceIs(f, "bar") && f.xaxis === r._id && f.yaxis === n._id && ("h" === f.orientation ? l.push(s[h]) : c.push(s[h]), f._computePh)) for(var p = t1.calcdata[h], d = 0; d < p.length; d++)"function" == typeof p[d].ph0 && (p[d].ph0 = p[d].ph0()), "function" == typeof p[d].ph1 && (p[d].ph1 = p[d].ph1());
                        }
                        var m = {
                            xCat: "category" === r.type || "multicategory" === r.type,
                            yCat: "category" === n.type || "multicategory" === n.type,
                            mode: i.barmode,
                            norm: i.barnorm,
                            gap: i.bargap,
                            groupgap: i.bargroupgap
                        };
                        u(t1, r, n, c, m), u(t1, n, r, l, m);
                    },
                    setGroupPositions: u
                };
            },
            17550: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(34809), a = r(78766), o = r(33626), s = r(99867), l = r(99669), c = r(59760), u = r(36301), h = r(81481), f = i.coerceFont;
                function p(t1) {
                    if (n(t1)) {
                        if ((t1 = +t1) >= 0) return t1;
                    } else if ("string" == typeof t1 && "%" === (t1 = t1.trim()).slice(-1) && n(t1.slice(0, -1)) && (t1 = +t1.slice(0, -1)) >= 0) return t1 + "%";
                }
                function d(t1, e1, r, n, a, o) {
                    var s = !(!1 === (o = o || {}).moduleHasSelected), l = !(!1 === o.moduleHasUnselected), c = !(!1 === o.moduleHasConstrain), u = !(!1 === o.moduleHasCliponaxis), h = !(!1 === o.moduleHasTextangle), p = !(!1 === o.moduleHasInsideanchor), d = !!o.hasPathbar, m = Array.isArray(a) || "auto" === a, g = m || "inside" === a, y = m || "outside" === a;
                    if (g || y) {
                        var v = f(n, "textfont", r.font), x = i.extendFlat({}, v), _ = !(t1.textfont && t1.textfont.color);
                        if (_ && delete x.color, f(n, "insidetextfont", x), d) {
                            var b = i.extendFlat({}, v);
                            _ && delete b.color, f(n, "pathbar.textfont", b);
                        }
                        y && f(n, "outsidetextfont", v), s && n("selected.textfont.color"), l && n("unselected.textfont.color"), c && n("constraintext"), u && n("cliponaxis"), h && n("textangle"), n("texttemplate");
                    }
                    g && p && n("insidetextanchor");
                }
                t1.exports = {
                    supplyDefaults: function(t1, e1, r, n) {
                        function u(r, n) {
                            return i.coerce(t1, e1, h, r, n);
                        }
                        if (s(t1, e1, n, u)) {
                            l(t1, e1, n, u), u("xhoverformat"), u("yhoverformat"), u("zorder"), u("orientation", e1.x && !e1.y ? "h" : "v"), u("base"), u("offset"), u("width"), u("text"), u("hovertext"), u("hovertemplate");
                            var f = u("textposition");
                            d(t1, 0, n, u, f, {
                                moduleHasSelected: !0,
                                moduleHasUnselected: !0,
                                moduleHasConstrain: !0,
                                moduleHasCliponaxis: !0,
                                moduleHasTextangle: !0,
                                moduleHasInsideanchor: !0
                            }), c(t1, e1, u, r, n);
                            var p = (e1.marker.line || {}).color, m = o.getComponentMethod("errorbars", "supplyDefaults");
                            m(t1, e1, p || a.defaultLine, {
                                axis: "y"
                            }), m(t1, e1, p || a.defaultLine, {
                                axis: "x",
                                inherit: "y"
                            }), i.coerceSelectionMarkerOpacity(e1, u);
                        } else e1.visible = !1;
                    },
                    crossTraceDefaults: function(t1, e1) {
                        var r, n;
                        function a(t1, e1) {
                            return i.coerce(n._input, n, h, t1, e1);
                        }
                        for(var o = 0; o < t1.length; o++)if ("bar" === (n = t1[o]).type) {
                            r = n._input;
                            var s = a("marker.cornerradius", e1.barcornerradius);
                            n.marker && (n.marker.cornerradius = p(s)), "group" === e1.barmode && u(r, n, e1, a);
                        }
                    },
                    handleText: d,
                    validateCornerradius: p
                };
            },
            59541: function(t1) {
                "use strict";
                t1.exports = function(t1, e1, r) {
                    return t1.x = "xVal" in e1 ? e1.xVal : e1.x, t1.y = "yVal" in e1 ? e1.yVal : e1.y, e1.xa && (t1.xaxis = e1.xa), e1.ya && (t1.yaxis = e1.ya), "h" === r.orientation ? (t1.label = t1.y, t1.value = t1.x) : (t1.label = t1.x, t1.value = t1.y), t1;
                };
            },
            42843: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(65657), a = r(34809).isArrayOrTypedArray;
                e1.coerceString = function(t1, e1, r) {
                    if ("string" == typeof e1) {
                        if (e1 || !t1.noBlank) return e1;
                    } else if (("number" == typeof e1 || !0 === e1) && !t1.strict) return String(e1);
                    return void 0 !== r ? r : t1.dflt;
                }, e1.coerceNumber = function(t1, e1, r) {
                    if (n(e1)) {
                        e1 = +e1;
                        var i = t1.min, a = t1.max;
                        if (!(void 0 !== i && e1 < i || void 0 !== a && e1 > a)) return e1;
                    }
                    return void 0 !== r ? r : t1.dflt;
                }, e1.coerceColor = function(t1, e1, r) {
                    return i(e1).isValid() ? e1 : void 0 !== r ? r : t1.dflt;
                }, e1.coerceEnumerated = function(t1, e1, r) {
                    return t1.coerceNumber && (e1 = +e1), -1 !== t1.values.indexOf(e1) ? e1 : void 0 !== r ? r : t1.dflt;
                }, e1.getValue = function(t1, e1) {
                    var r;
                    return a(t1) ? e1 < t1.length && (r = t1[e1]) : r = t1, r;
                }, e1.getLineWidth = function(t1, e1) {
                    return 0 < e1.mlw ? e1.mlw : a(t1.marker.line.width) ? 0 : t1.marker.line.width;
                };
            },
            91664: function(t1, e1, r) {
                "use strict";
                var n = r(32141), i = r(33626), a = r(78766), o = r(34809).fillText, s = r(42843).getLineWidth, l = r(29714).hoverLabelText, c = r(63821).BADNUM;
                function u(t1, e1, r, i, a) {
                    var s, u, h, f, p, d, m, g = t1.cd, y = g[0].trace, v = g[0].t, x = "closest" === i, _ = "waterfall" === y.type, b = t1.maxHoverDistance, w = t1.maxSpikeDistance;
                    "h" === y.orientation ? (s = r, u = e1, h = "y", f = "x", p = O, d = P) : (s = e1, u = r, h = "x", f = "y", d = O, p = P);
                    var T = y[h + "period"], k = x || T;
                    function A(t1) {
                        return S(t1, -1);
                    }
                    function M(t1) {
                        return S(t1, 1);
                    }
                    function S(t1, e1) {
                        var r = t1.w;
                        return t1[h] + e1 * r / 2;
                    }
                    function E(t1) {
                        return t1[h + "End"] - t1[h + "Start"];
                    }
                    var C = x ? A : T ? function(t1) {
                        return t1.p - E(t1) / 2;
                    } : function(t1) {
                        return Math.min(A(t1), t1.p - v.bardelta / 2);
                    }, L = x ? M : T ? function(t1) {
                        return t1.p + E(t1) / 2;
                    } : function(t1) {
                        return Math.max(M(t1), t1.p + v.bardelta / 2);
                    };
                    function I(t1, e1, r) {
                        return a.finiteRange && (r = 0), n.inbox(t1 - s, e1 - s, r + Math.min(1, Math.abs(e1 - t1) / m) - 1);
                    }
                    function P(t1) {
                        return I(C(t1), L(t1), b);
                    }
                    function z(t1) {
                        var e1 = t1[f];
                        if (_) {
                            var r = Math.abs(t1.rawS) || 0;
                            u > 0 ? e1 += r : u < 0 && (e1 -= r);
                        }
                        return e1;
                    }
                    function O(t1) {
                        var e1 = u, r = t1.b, i = z(t1);
                        return n.inbox(r - e1, i - e1, b + (i - e1) / (i - r) - 1);
                    }
                    var D = t1[h + "a"], R = t1[f + "a"];
                    m = Math.abs(D.r2c(D.range[1]) - D.r2c(D.range[0]));
                    var F = n.getDistanceFunction(i, p, d, function(t1) {
                        return (p(t1) + d(t1)) / 2;
                    });
                    if (n.getClosest(g, F, t1), !1 !== t1.index && g[t1.index].p !== c) {
                        k || (C = function(t1) {
                            return Math.min(A(t1), t1.p - v.bargroupwidth / 2);
                        }, L = function(t1) {
                            return Math.max(M(t1), t1.p + v.bargroupwidth / 2);
                        });
                        var B = g[t1.index], N = y.base ? B.b + B.s : B.s;
                        t1[f + "0"] = t1[f + "1"] = R.c2p(B[f], !0), t1[f + "LabelVal"] = N;
                        var j = v.extents[v.extents.round(B.p)];
                        t1[h + "0"] = D.c2p(x ? C(B) : j[0], !0), t1[h + "1"] = D.c2p(x ? L(B) : j[1], !0);
                        var U = void 0 !== B.orig_p;
                        return t1[h + "LabelVal"] = U ? B.orig_p : B.p, t1.labelLabel = l(D, t1[h + "LabelVal"], y[h + "hoverformat"]), t1.valueLabel = l(R, t1[f + "LabelVal"], y[f + "hoverformat"]), t1.baseLabel = l(R, B.b, y[f + "hoverformat"]), t1.spikeDistance = (function(t1) {
                            var e1 = u, r = t1.b, i = z(t1);
                            return n.inbox(r - e1, i - e1, w + (i - e1) / (i - r) - 1);
                        }(B) + function(t1) {
                            return I(A(t1), M(t1), w);
                        }(B)) / 2, t1[h + "Spike"] = D.c2p(B.p, !0), o(B, y, t1), t1.hovertemplate = y.hovertemplate, t1;
                    }
                }
                function h(t1, e1) {
                    var r = e1.mcc || t1.marker.color, n = e1.mlcc || t1.marker.line.color, i = s(t1, e1);
                    return a.opacity(r) ? r : a.opacity(n) && i ? n : void 0;
                }
                t1.exports = {
                    hoverPoints: function(t1, e1, r, n, a) {
                        var o = u(t1, e1, r, n, a);
                        if (o) {
                            var s = o.cd, l = s[0].trace, c = s[o.index];
                            return o.color = h(l, c), i.getComponentMethod("errorbars", "hoverInfo")(c, l, o), [
                                o
                            ];
                        }
                    },
                    hoverOnBars: u,
                    getTraceColor: h
                };
            },
            58218: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    attributes: r(81481),
                    layoutAttributes: r(25412),
                    supplyDefaults: r(17550).supplyDefaults,
                    crossTraceDefaults: r(17550).crossTraceDefaults,
                    supplyLayoutDefaults: r(78931),
                    calc: r(67565),
                    crossTraceCalc: r(24782).crossTraceCalc,
                    colorbar: r(21146),
                    arraysToCalcdata: r(35374),
                    plot: r(32995).plot,
                    style: r(6851).style,
                    styleOnSelect: r(6851).styleOnSelect,
                    hoverPoints: r(91664).hoverPoints,
                    eventData: r(59541),
                    selectPoints: r(88384),
                    moduleType: "trace",
                    name: "bar",
                    basePlotModule: r(37703),
                    categories: [
                        "bar-like",
                        "cartesian",
                        "svg",
                        "bar",
                        "oriented",
                        "errorBarsOK",
                        "showLegend",
                        "zoomScale"
                    ],
                    animatable: !0,
                    meta: {}
                };
            },
            25412: function(t1) {
                "use strict";
                t1.exports = {
                    barmode: {
                        valType: "enumerated",
                        values: [
                            "stack",
                            "group",
                            "overlay",
                            "relative"
                        ],
                        dflt: "group",
                        editType: "calc"
                    },
                    barnorm: {
                        valType: "enumerated",
                        values: [
                            "",
                            "fraction",
                            "percent"
                        ],
                        dflt: "",
                        editType: "calc"
                    },
                    bargap: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        editType: "calc"
                    },
                    bargroupgap: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 0,
                        editType: "calc"
                    },
                    barcornerradius: {
                        valType: "any",
                        editType: "calc"
                    }
                };
            },
            78931: function(t1, e1, r) {
                "use strict";
                var n = r(33626), i = r(29714), a = r(34809), o = r(25412), s = r(17550).validateCornerradius;
                t1.exports = function(t1, e1, r) {
                    function l(r, n) {
                        return a.coerce(t1, e1, o, r, n);
                    }
                    for(var c = !1, u = !1, h = !1, f = {}, p = l("barmode"), d = 0; d < r.length; d++){
                        var m = r[d];
                        if (n.traceIs(m, "bar") && m.visible) {
                            if (c = !0, "group" === p) {
                                var g = m.xaxis + m.yaxis;
                                f[g] && (h = !0), f[g] = !0;
                            }
                            m.visible && "histogram" === m.type && "category" !== i.getFromId({
                                _fullLayout: e1
                            }, m["v" === m.orientation ? "xaxis" : "yaxis"]).type && (u = !0);
                        }
                    }
                    if (c) {
                        "overlay" !== p && l("barnorm"), l("bargap", u && !h ? 0 : .2), l("bargroupgap");
                        var y = l("barcornerradius");
                        e1.barcornerradius = s(y);
                    } else delete e1.barmode;
                };
            },
            32995: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(10721), a = r(34809), o = r(30635), s = r(78766), l = r(62203), c = r(33626), u = r(29714).tickText, h = r(84102), f = h.recordMinTextSize, p = h.clearMinTextSize, d = r(6851), m = r(42843), g = r(56155), y = r(81481), v = y.text, x = y.textposition, _ = r(36040).appendArrayPointValue, b = g.TEXTPAD;
                function w(t1) {
                    return t1.id;
                }
                function T(t1) {
                    if (t1.ids) return w;
                }
                function k(t1) {
                    return (t1 > 0) - (t1 < 0);
                }
                function A(t1, e1) {
                    return t1 < e1 ? 1 : -1;
                }
                function M(t1, e1, r, n) {
                    var i;
                    return !e1.uniformtext.mode && S(r) ? (n && (i = n()), t1.transition().duration(r.duration).ease(r.easing).each("end", function() {
                        i && i();
                    }).each("interrupt", function() {
                        i && i();
                    })) : t1;
                }
                function S(t1) {
                    return t1 && t1.duration > 0;
                }
                function E(t1, e1, r, n, i) {
                    return !(t1 < 0 || e1 < 0) && (r <= t1 && n <= e1 || r <= e1 && n <= t1 || (i ? t1 >= r * (e1 / n) : e1 >= n * (t1 / r)));
                }
                function C(t1) {
                    return "auto" === t1 ? 0 : t1;
                }
                function L(t1, e1) {
                    var r = Math.PI / 180 * e1, n = Math.abs(Math.sin(r)), i = Math.abs(Math.cos(r));
                    return {
                        x: t1.width * i + t1.height * n,
                        y: t1.width * n + t1.height * i
                    };
                }
                function I(t1, e1, r, n, i, a) {
                    var o = !!a.isHorizontal, s = !!a.constrained, l = a.angle || 0, c = a.anchor, u = "end" === c, h = "start" === c, f = ((a.leftToRight || 0) + 1) / 2, p = 1 - f, d = a.hasB, m = a.r, g = a.overhead, y = i.width, v = i.height, x = Math.abs(e1 - t1), _ = Math.abs(n - r), w = x > 2 * b && _ > 2 * b ? b : 0;
                    x -= 2 * w, _ -= 2 * w;
                    var T = C(l);
                    "auto" !== l || y <= x && v <= _ || !(y > x || v > _) || (y > _ || v > x) && y < v == x < _ || (T += 90);
                    var k, M, S = L(i, T);
                    if (m && m - g > b) {
                        var E = function(t1, e1, r, n, i, a, o, s, l) {
                            var c, u, h, f, p = Math.max(0, Math.abs(e1 - t1) - 2 * b), d = Math.max(0, Math.abs(n - r) - 2 * b), m = a - b, g = o ? m - Math.sqrt(m * m - (m - o) * (m - o)) : m, y = l ? 2 * m : s ? m - o : 2 * g, v = l ? 2 * m : s ? 2 * g : m - o;
                            return i.y / i.x >= d / (p - y) ? f = d / i.y : i.y / i.x <= (d - v) / p ? f = p / i.x : !l && s ? (c = i.x * i.x + i.y * i.y / 4, h = (p - m) * (p - m) + (d / 2 - m) * (d / 2 - m) - m * m, f = (-(u = -2 * i.x * (p - m) - i.y * (d / 2 - m)) + Math.sqrt(u * u - 4 * c * h)) / (2 * c)) : l ? (c = (i.x * i.x + i.y * i.y) / 4, h = (p / 2 - m) * (p / 2 - m) + (d / 2 - m) * (d / 2 - m) - m * m, f = (-(u = -i.x * (p / 2 - m) - i.y * (d / 2 - m)) + Math.sqrt(u * u - 4 * c * h)) / (2 * c)) : (c = i.x * i.x / 4 + i.y * i.y, h = (p / 2 - m) * (p / 2 - m) + (d - m) * (d - m) - m * m, f = (-(u = -i.x * (p / 2 - m) - 2 * i.y * (d - m)) + Math.sqrt(u * u - 4 * c * h)) / (2 * c)), {
                                scale: f = Math.min(1, f),
                                pad: s ? Math.max(0, m - Math.sqrt(Math.max(0, m * m - (m - (d - i.y * f) / 2) * (m - (d - i.y * f) / 2))) - o) : Math.max(0, m - Math.sqrt(Math.max(0, m * m - (m - (p - i.x * f) / 2) * (m - (p - i.x * f) / 2))) - o)
                            };
                        }(t1, e1, r, n, S, m, g, o, d);
                        k = E.scale, M = E.pad;
                    } else k = 1, s && (k = Math.min(1, x / S.x, _ / S.y)), M = 0;
                    var I = i.left * p + i.right * f, P = (i.top + i.bottom) / 2, z = (t1 + b) * p + (e1 - b) * f, O = (r + n) / 2, D = 0, R = 0;
                    if (h || u) {
                        var F = (o ? S.x : S.y) / 2;
                        m && (u || d) && (w += M);
                        var B = o ? A(t1, e1) : A(r, n);
                        o ? h ? (z = t1 + B * w, D = -B * F) : (z = e1 - B * w, D = B * F) : h ? (O = r + B * w, R = -B * F) : (O = n - B * w, R = B * F);
                    }
                    return {
                        textX: I,
                        textY: P,
                        targetX: z,
                        targetY: O,
                        anchorX: D,
                        anchorY: R,
                        scale: k,
                        rotate: T
                    };
                }
                t1.exports = {
                    plot: function(t1, e1, r, h, g, y) {
                        var w = e1.xaxis, P = e1.yaxis, z = t1._fullLayout, O = t1._context.staticPlot;
                        g || (g = {
                            mode: z.barmode,
                            norm: z.barmode,
                            gap: z.bargap,
                            groupgap: z.bargroupgap
                        }, p("bar", z));
                        var D = a.makeTraceGroups(h, r, "trace bars").each(function(r) {
                            var c = n.select(this), h = r[0].trace, p = r[0].t, D = "waterfall" === h.type, R = "funnel" === h.type, F = "histogram" === h.type, B = "bar" === h.type, N = B || R, j = 0;
                            D && h.connector.visible && "between" === h.connector.mode && (j = h.connector.line.width / 2);
                            var U = "h" === h.orientation, V = S(g), q = a.ensureSingle(c, "g", "points"), H = T(h), G = q.selectAll("g.point").data(a.identity, H);
                            G.enter().append("g").classed("point", !0), G.exit().remove(), G.each(function(c, T) {
                                var S, D, R = n.select(this), q = function(t1, e1, r, n) {
                                    var i = [], a = [], o = n ? e1 : r, s = n ? r : e1;
                                    return i[0] = o.c2p(t1.s0, !0), a[0] = s.c2p(t1.p0, !0), i[1] = o.c2p(t1.s1, !0), a[1] = s.c2p(t1.p1, !0), n ? [
                                        i,
                                        a
                                    ] : [
                                        a,
                                        i
                                    ];
                                }(c, w, P, U), H = q[0][0], G = q[0][1], Z = q[1][0], W = q[1][1], Y = 0 == (U ? G - H : W - Z);
                                if (Y && N && m.getLineWidth(h, c) && (Y = !1), Y || (Y = !(i(H) && i(G) && i(Z) && i(W))), c.isBlank = Y, Y && (U ? G = H : W = Z), j && !Y && (U ? (H -= A(H, G) * j, G += A(H, G) * j) : (Z -= A(Z, W) * j, W += A(Z, W) * j)), "waterfall" === h.type) {
                                    if (!Y) {
                                        var X = h[c.dir].marker;
                                        S = X.line.width, D = X.color;
                                    }
                                } else S = m.getLineWidth(h, c), D = c.mc || h.marker.color;
                                function $(t1) {
                                    var e1 = n.round(S / 2 % 1, 2);
                                    return 0 === g.gap && 0 === g.groupgap ? n.round(Math.round(t1) - e1, 2) : t1;
                                }
                                var J = s.opacity(D) < 1 || S > .01 ? $ : function(t1, e1, r) {
                                    return r && t1 === e1 ? t1 : Math.abs(t1 - e1) >= 2 ? $(t1) : t1 > e1 ? Math.ceil(t1) : Math.floor(t1);
                                };
                                t1._context.staticPlot || (H = J(H, G, U), G = J(G, H, U), Z = J(Z, W, !U), W = J(W, Z, !U));
                                var K, Q = U ? w.c2p : P.c2p;
                                K = c.s0 > 0 ? c._sMax : c.s0 < 0 ? c._sMin : c.s1 > 0 ? c._sMax : c._sMin;
                                var tt, et, rt = B || F ? function(t1, e1) {
                                    if (!t1) return 0;
                                    var r, n = U ? Math.abs(W - Z) : Math.abs(G - H), i = U ? Math.abs(G - H) : Math.abs(W - Z), a = J(Math.abs(Q(K, !0) - Q(0, !0))), o = c.hasB ? Math.min(n / 2, i / 2) : Math.min(n / 2, a);
                                    return r = "%" === e1 ? n * (Math.min(50, t1) / 100) : t1, J(Math.max(Math.min(r, o), 0));
                                }(p.cornerradiusvalue, p.cornerradiusform) : 0, nt = "M" + H + "," + Z + "V" + W + "H" + G + "V" + Z + "Z", it = 0;
                                if (rt && c.s) {
                                    var at = 0 === k(c.s0) || k(c.s) === k(c.s0) ? c.s1 : c.s0;
                                    if ((it = J(c.hasB ? 0 : Math.abs(Q(K, !0) - Q(at, !0)))) < rt) {
                                        var ot = A(H, G), st = A(Z, W), lt = ot === -st ? 1 : 0;
                                        if (U) {
                                            if (c.hasB) tt = "M" + (H + rt * ot) + "," + Z + "A " + rt + "," + rt + " 0 0 " + lt + " " + H + "," + (Z + rt * st) + "V" + (W - rt * st) + "A " + rt + "," + rt + " 0 0 " + lt + " " + (H + rt * ot) + "," + W + "H" + (G - rt * ot) + "A " + rt + "," + rt + " 0 0 " + lt + " " + G + "," + (W - rt * st) + "V" + (Z + rt * st) + "A " + rt + "," + rt + " 0 0 " + lt + " " + (G - rt * ot) + "," + Z + "Z";
                                            else {
                                                var ct = (et = Math.abs(G - H) + it) < rt ? rt - Math.sqrt(et * (2 * rt - et)) : 0, ut = it > 0 ? Math.sqrt(it * (2 * rt - it)) : 0, ht = ot > 0 ? Math.max : Math.min;
                                                tt = "M" + H + "," + Z + "V" + (W - ct * st) + "H" + ht(G - (rt - it) * ot, H) + "A " + rt + "," + rt + " 0 0 " + lt + " " + G + "," + (W - rt * st - ut) + "V" + (Z + rt * st + ut) + "A " + rt + "," + rt + " 0 0 " + lt + " " + ht(G - (rt - it) * ot, H) + "," + (Z + ct * st) + "Z";
                                            }
                                        } else if (c.hasB) tt = "M" + (H + rt * ot) + "," + Z + "A " + rt + "," + rt + " 0 0 " + lt + " " + H + "," + (Z + rt * st) + "V" + (W - rt * st) + "A " + rt + "," + rt + " 0 0 " + lt + " " + (H + rt * ot) + "," + W + "H" + (G - rt * ot) + "A " + rt + "," + rt + " 0 0 " + lt + " " + G + "," + (W - rt * st) + "V" + (Z + rt * st) + "A " + rt + "," + rt + " 0 0 " + lt + " " + (G - rt * ot) + "," + Z + "Z";
                                        else {
                                            var ft = (et = Math.abs(W - Z) + it) < rt ? rt - Math.sqrt(et * (2 * rt - et)) : 0, pt = it > 0 ? Math.sqrt(it * (2 * rt - it)) : 0, dt = st > 0 ? Math.max : Math.min;
                                            tt = "M" + (H + ft * ot) + "," + Z + "V" + dt(W - (rt - it) * st, Z) + "A " + rt + "," + rt + " 0 0 " + lt + " " + (H + rt * ot - pt) + "," + W + "H" + (G - rt * ot + pt) + "A " + rt + "," + rt + " 0 0 " + lt + " " + (G - ft * ot) + "," + dt(W - (rt - it) * st, Z) + "V" + Z + "Z";
                                        }
                                    } else tt = nt;
                                } else tt = nt;
                                var mt = M(a.ensureSingle(R, "path"), z, g, y);
                                if (mt.style("vector-effect", O ? "none" : "non-scaling-stroke").attr("d", isNaN((G - H) * (W - Z)) || Y && t1._context.staticPlot ? "M0,0Z" : tt).call(l.setClipUrl, e1.layerClipId, t1), !z.uniformtext.mode && V) {
                                    var gt = l.makePointStyleFns(h);
                                    l.singlePointStyle(c, mt, h, gt, t1);
                                }
                                !function(t1, e1, r, n, i, s, c, h, p, g, y, w, T) {
                                    var k, S = e1.xaxis, P = e1.yaxis, z = t1._fullLayout;
                                    function O(e1, r, n) {
                                        return a.ensureSingle(e1, "text").text(r).attr({
                                            class: "bartext bartext-" + k,
                                            "text-anchor": "middle",
                                            "data-notex": 1
                                        }).call(l.font, n).call(o.convertToTspans, t1);
                                    }
                                    var D = n[0].trace, R = "h" === D.orientation, F = function(t1, e1, r, n, i) {
                                        var o, s = e1[0].trace;
                                        return o = s.texttemplate ? function(t1, e1, r, n, i) {
                                            var o = e1[0].trace, s = a.castOption(o, r, "texttemplate");
                                            if (!s) return "";
                                            var l, c, h, f, p = "histogram" === o.type, d = "waterfall" === o.type, m = "funnel" === o.type, g = "h" === o.orientation;
                                            function y(t1) {
                                                return u(f, f.c2l(t1), !0).text;
                                            }
                                            g ? (l = "y", c = i, h = "x", f = n) : (l = "x", c = n, h = "y", f = i);
                                            var v, x = e1[r], b = {};
                                            b.label = x.p, b.labelLabel = b[l + "Label"] = (v = x.p, u(c, c.c2l(v), !0).text);
                                            var w = a.castOption(o, x.i, "text");
                                            (0 === w || w) && (b.text = w), b.value = x.s, b.valueLabel = b[h + "Label"] = y(x.s);
                                            var T = {};
                                            _(T, o, x.i), (p || void 0 === T.x) && (T.x = g ? b.value : b.label), (p || void 0 === T.y) && (T.y = g ? b.label : b.value), (p || void 0 === T.xLabel) && (T.xLabel = g ? b.valueLabel : b.labelLabel), (p || void 0 === T.yLabel) && (T.yLabel = g ? b.labelLabel : b.valueLabel), d && (b.delta = +x.rawS || x.s, b.deltaLabel = y(b.delta), b.final = x.v, b.finalLabel = y(b.final), b.initial = b.final - b.delta, b.initialLabel = y(b.initial)), m && (b.value = x.s, b.valueLabel = y(b.value), b.percentInitial = x.begR, b.percentInitialLabel = a.formatPercent(x.begR), b.percentPrevious = x.difR, b.percentPreviousLabel = a.formatPercent(x.difR), b.percentTotal = x.sumR, b.percenTotalLabel = a.formatPercent(x.sumR));
                                            var k = a.castOption(o, x.i, "customdata");
                                            return k && (b.customdata = k), a.texttemplateString(s, b, t1._d3locale, T, b, o._meta || {});
                                        }(t1, e1, r, n, i) : s.textinfo ? function(t1, e1, r, n) {
                                            var i = t1[0].trace, o = "h" === i.orientation, s = "waterfall" === i.type, l = "funnel" === i.type;
                                            function c(t1) {
                                                return u(o ? r : n, +t1, !0).text;
                                            }
                                            var h, f, p = i.textinfo, d = t1[e1], m = p.split("+"), g = [], y = function(t1) {
                                                return -1 !== m.indexOf(t1);
                                            };
                                            if (y("label") && g.push((f = t1[e1].p, u(o ? n : r, f, !0).text)), y("text") && (0 === (h = a.castOption(i, d.i, "text")) || h) && g.push(h), s) {
                                                var v = +d.rawS || d.s, x = d.v, _ = x - v;
                                                y("initial") && g.push(c(_)), y("delta") && g.push(c(v)), y("final") && g.push(c(x));
                                            }
                                            if (l) {
                                                y("value") && g.push(c(d.s));
                                                var b = 0;
                                                y("percent initial") && b++, y("percent previous") && b++, y("percent total") && b++;
                                                var w = b > 1;
                                                y("percent initial") && (h = a.formatPercent(d.begR), w && (h += " of initial"), g.push(h)), y("percent previous") && (h = a.formatPercent(d.difR), w && (h += " of previous"), g.push(h)), y("percent total") && (h = a.formatPercent(d.sumR), w && (h += " of total"), g.push(h));
                                            }
                                            return g.join("<br>");
                                        }(e1, r, n, i) : m.getValue(s.text, r), m.coerceString(v, o);
                                    }(z, n, i, S, P);
                                    k = function(t1, e1) {
                                        var r = m.getValue(t1.textposition, e1);
                                        return m.coerceEnumerated(x, r);
                                    }(D, i);
                                    var B = "stack" === w.mode || "relative" === w.mode, N = n[i], j = !B || N._outmost, U = N.hasB, V = g && g - y > b;
                                    if (F && "none" !== k && (!N.isBlank && s !== c && h !== p || "auto" !== k && "inside" !== k)) {
                                        var q = z.font, H = d.getBarColor(n[i], D), G = d.getInsideTextFont(D, i, q, H), Z = d.getOutsideTextFont(D, i, q), W = D.insidetextanchor || "end", Y = r.datum();
                                        R ? "log" === S.type && Y.s0 <= 0 && (s = S.range[0] < S.range[1] ? 0 : S._length) : "log" === P.type && Y.s0 <= 0 && (h = P.range[0] < P.range[1] ? P._length : 0);
                                        var X, $, J, K, Q, tt = Math.abs(c - s), et = Math.abs(p - h), rt = tt - 2 * b, nt = et - 2 * b;
                                        if ("outside" === k && (j || N.hasB || (k = "inside")), "auto" === k) {
                                            if (j) {
                                                k = "inside", X = O(r, F, Q = a.ensureUniformFontSize(t1, G)), J = ($ = l.bBox(X.node())).width, K = $.height;
                                                var it, at = J > 0 && K > 0;
                                                it = V ? U ? E(rt - 2 * g, nt, J, K, R) || E(rt, nt - 2 * g, J, K, R) : R ? E(rt - (g - y), nt, J, K, R) || E(rt, nt - 2 * (g - y), J, K, R) : E(rt, nt - (g - y), J, K, R) || E(rt - 2 * (g - y), nt, J, K, R) : E(rt, nt, J, K, R), at && it ? k = "inside" : (k = "outside", X.remove(), X = null);
                                            } else k = "inside";
                                        }
                                        if (!X) {
                                            var ot = (X = O(r, F, Q = a.ensureUniformFontSize(t1, "outside" === k ? Z : G))).attr("transform");
                                            if (X.attr("transform", ""), J = ($ = l.bBox(X.node())).width, K = $.height, X.attr("transform", ot), J <= 0 || K <= 0) return void X.remove();
                                        }
                                        var st, lt = D.textangle;
                                        st = "outside" === k ? function(t1, e1, r, n, i, a) {
                                            var o, s = !!a.isHorizontal, l = !!a.constrained, c = a.angle || 0, u = i.width, h = i.height, f = Math.abs(e1 - t1), p = Math.abs(n - r);
                                            o = s ? p > 2 * b ? b : 0 : f > 2 * b ? b : 0;
                                            var d = 1;
                                            l && (d = s ? Math.min(1, p / h) : Math.min(1, f / u));
                                            var m = C(c), g = L(i, m), y = (s ? g.x : g.y) / 2, v = (i.left + i.right) / 2, x = (i.top + i.bottom) / 2, _ = (t1 + e1) / 2, w = (r + n) / 2, T = 0, k = 0, M = s ? A(e1, t1) : A(r, n);
                                            return s ? (_ = e1 - M * o, T = M * y) : (w = n + M * o, k = -M * y), {
                                                textX: v,
                                                textY: x,
                                                targetX: _,
                                                targetY: w,
                                                anchorX: T,
                                                anchorY: k,
                                                scale: d,
                                                rotate: m
                                            };
                                        }(s, c, h, p, $, {
                                            isHorizontal: R,
                                            constrained: "both" === D.constraintext || "outside" === D.constraintext,
                                            angle: lt
                                        }) : I(s, c, h, p, $, {
                                            isHorizontal: R,
                                            constrained: "both" === D.constraintext || "inside" === D.constraintext,
                                            angle: lt,
                                            anchor: W,
                                            hasB: U,
                                            r: g,
                                            overhead: y
                                        }), st.fontSize = Q.size, f("histogram" === D.type ? "bar" : D.type, st, z), N.transform = st;
                                        var ct = M(X, z, w, T);
                                        a.setTransormAndDisplay(ct, st);
                                    } else r.select("text").remove();
                                }(t1, e1, R, r, T, H, G, Z, W, rt, it, g, y), e1.layerClipId && l.hideOutsideRangePoint(c, R.select("text"), w, P, h.xcalendar, h.ycalendar);
                            });
                            var Z = !1 === h.cliponaxis;
                            l.setClipUrl(c, Z ? null : e1.layerClipId, t1);
                        });
                        c.getComponentMethod("errorbars", "plot")(t1, D, e1, g);
                    },
                    toMoveInsideBar: I
                };
            },
            88384: function(t1) {
                "use strict";
                function e1(t1, e1, r, n, i) {
                    var a = e1.c2p(n ? t1.s0 : t1.p0, !0), o = e1.c2p(n ? t1.s1 : t1.p1, !0), s = r.c2p(n ? t1.p0 : t1.s0, !0), l = r.c2p(n ? t1.p1 : t1.s1, !0);
                    return i ? [
                        (a + o) / 2,
                        (s + l) / 2
                    ] : n ? [
                        o,
                        (s + l) / 2
                    ] : [
                        (a + o) / 2,
                        l
                    ];
                }
                t1.exports = function(t1, r) {
                    var n, i = t1.cd, a = t1.xaxis, o = t1.yaxis, s = i[0].trace, l = "funnel" === s.type, c = "h" === s.orientation, u = [];
                    if (!1 === r) for(n = 0; n < i.length; n++)i[n].selected = 0;
                    else for(n = 0; n < i.length; n++){
                        var h = i[n], f = "ct" in h ? h.ct : e1(h, a, o, c, l);
                        r.contains(f, !1, n, t1) ? (u.push({
                            pointNumber: n,
                            x: a.c2d(h.x),
                            y: o.c2d(h.y)
                        }), h.selected = 1) : h.selected = 0;
                    }
                    return u;
                };
            },
            2880: function(t1, e1, r) {
                "use strict";
                t1.exports = i;
                var n = r(34809).distinctVals;
                function i(t1, e1) {
                    this.traces = t1, this.sepNegVal = e1.sepNegVal, this.overlapNoMerge = e1.overlapNoMerge;
                    for(var r = 1 / 0, i = e1.posAxis._id.charAt(0), a = [], o = 0; o < t1.length; o++){
                        for(var s = t1[o], l = 0; l < s.length; l++){
                            var c = s[l], u = c.p;
                            void 0 === u && (u = c[i]), void 0 !== u && a.push(u);
                        }
                        s[0] && s[0].width1 && (r = Math.min(s[0].width1, r));
                    }
                    this.positions = a;
                    var h = n(a);
                    this.distinctPositions = h.vals, 1 === h.vals.length && r !== 1 / 0 ? this.minDiff = r : this.minDiff = Math.min(h.minDiff, r);
                    var f = (e1.posAxis || {}).type;
                    "category" !== f && "multicategory" !== f || (this.minDiff = 1), this.binWidth = this.minDiff, this.bins = {};
                }
                i.prototype.put = function(t1, e1) {
                    var r = this.getLabel(t1, e1), n = this.bins[r] || 0;
                    return this.bins[r] = n + e1, n;
                }, i.prototype.get = function(t1, e1) {
                    var r = this.getLabel(t1, e1);
                    return this.bins[r] || 0;
                }, i.prototype.getLabel = function(t1, e1) {
                    return (e1 < 0 && this.sepNegVal ? "v" : "^") + (this.overlapNoMerge ? t1 : Math.round(t1 / this.binWidth));
                };
            },
            6851: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(78766), a = r(62203), o = r(34809), s = r(33626), l = r(84102).resizeText, c = r(81481), u = c.textfont, h = c.insidetextfont, f = c.outsidetextfont, p = r(42843);
                function d(t1, e1, r) {
                    a.pointStyle(t1.selectAll("path"), e1, r), m(t1, e1, r);
                }
                function m(t1, e1, r) {
                    t1.selectAll("text").each(function(t1) {
                        var i = n.select(this), s = o.ensureUniformFontSize(r, g(i, t1, e1, r));
                        a.font(i, s);
                    });
                }
                function g(t1, e1, r, n) {
                    var i = n._fullLayout.font, a = r.textfont;
                    if (t1.classed("bartext-inside")) {
                        var o = b(e1, r);
                        a = v(r, e1.i, i, o);
                    } else t1.classed("bartext-outside") && (a = x(r, e1.i, i));
                    return a;
                }
                function y(t1, e1, r) {
                    return _(u, t1.textfont, e1, r);
                }
                function v(t1, e1, r, n) {
                    var a = y(t1, e1, r);
                    return (void 0 === t1._input.textfont || void 0 === t1._input.textfont.color || Array.isArray(t1.textfont.color) && void 0 === t1.textfont.color[e1]) && (a = {
                        color: i.contrast(n),
                        family: a.family,
                        size: a.size,
                        weight: a.weight,
                        style: a.style,
                        variant: a.variant,
                        textcase: a.textcase,
                        lineposition: a.lineposition,
                        shadow: a.shadow
                    }), _(h, t1.insidetextfont, e1, a);
                }
                function x(t1, e1, r) {
                    var n = y(t1, e1, r);
                    return _(f, t1.outsidetextfont, e1, n);
                }
                function _(t1, e1, r, n) {
                    e1 = e1 || {};
                    var i = p.getValue(e1.family, r), a = p.getValue(e1.size, r), o = p.getValue(e1.color, r), s = p.getValue(e1.weight, r), l = p.getValue(e1.style, r), c = p.getValue(e1.variant, r), u = p.getValue(e1.textcase, r), h = p.getValue(e1.lineposition, r), f = p.getValue(e1.shadow, r);
                    return {
                        family: p.coerceString(t1.family, i, n.family),
                        size: p.coerceNumber(t1.size, a, n.size),
                        color: p.coerceColor(t1.color, o, n.color),
                        weight: p.coerceString(t1.weight, s, n.weight),
                        style: p.coerceString(t1.style, l, n.style),
                        variant: p.coerceString(t1.variant, c, n.variant),
                        textcase: p.coerceString(t1.variant, u, n.textcase),
                        lineposition: p.coerceString(t1.variant, h, n.lineposition),
                        shadow: p.coerceString(t1.variant, f, n.shadow)
                    };
                }
                function b(t1, e1) {
                    return "waterfall" === e1.type ? e1[t1.dir].marker.color : t1.mcc || t1.mc || e1.marker.color;
                }
                t1.exports = {
                    style: function(t1) {
                        var e1 = n.select(t1).selectAll('g[class^="barlayer"]').selectAll("g.trace");
                        l(t1, e1, "bar");
                        var r = e1.size(), i = t1._fullLayout;
                        e1.style("opacity", function(t1) {
                            return t1[0].trace.opacity;
                        }).each(function(t1) {
                            ("stack" === i.barmode && r > 1 || 0 === i.bargap && 0 === i.bargroupgap && !t1[0].trace.marker.line.width) && n.select(this).attr("shape-rendering", "crispEdges");
                        }), e1.selectAll("g.points").each(function(e1) {
                            d(n.select(this), e1[0].trace, t1);
                        }), s.getComponentMethod("errorbars", "style")(e1);
                    },
                    styleTextPoints: m,
                    styleOnSelect: function(t1, e1, r) {
                        var i = e1[0].trace;
                        i.selectedpoints ? function(t1, e1, r) {
                            a.selectedPointStyle(t1.selectAll("path"), e1), function(t1, e1, r) {
                                t1.each(function(t1) {
                                    var i, s = n.select(this);
                                    if (t1.selected) {
                                        i = o.ensureUniformFontSize(r, g(s, t1, e1, r));
                                        var l = e1.selected.textfont && e1.selected.textfont.color;
                                        l && (i.color = l), a.font(s, i);
                                    } else a.selectedTextStyle(s, e1);
                                });
                            }(t1.selectAll("text"), e1, r);
                        }(r, i, t1) : (d(r, i, t1), s.getComponentMethod("errorbars", "style")(r));
                    },
                    getInsideTextFont: v,
                    getOutsideTextFont: x,
                    getBarColor: b,
                    resizeText: l
                };
            },
            59760: function(t1, e1, r) {
                "use strict";
                var n = r(78766), i = r(65477).hasColorscale, a = r(39356), o = r(34809).coercePattern;
                t1.exports = function(t1, e1, r, s, l) {
                    var c = r("marker.color", s), u = i(t1, "marker");
                    u && a(t1, e1, l, r, {
                        prefix: "marker.",
                        cLetter: "c"
                    }), r("marker.line.color", n.defaultLine), i(t1, "marker.line") && a(t1, e1, l, r, {
                        prefix: "marker.line.",
                        cLetter: "c"
                    }), r("marker.line.width"), r("marker.opacity"), o(r, "marker.pattern", c, u), r("selected.marker.color"), r("unselected.marker.color");
                };
            },
            84102: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(34809);
                function a(t1) {
                    return "_" + t1 + "Text_minsize";
                }
                t1.exports = {
                    recordMinTextSize: function(t1, e1, r) {
                        if (r.uniformtext.mode) {
                            var n = a(t1), i = r.uniformtext.minsize, o = e1.scale * e1.fontSize;
                            e1.hide = o < i, r[n] = r[n] || 1 / 0, e1.hide || (r[n] = Math.min(r[n], Math.max(o, i)));
                        }
                    },
                    clearMinTextSize: function(t1, e1) {
                        e1[a(t1)] = void 0;
                    },
                    resizeText: function(t1, e1, r) {
                        var a = t1._fullLayout, o = a["_" + r + "Text_minsize"];
                        if (o) {
                            var s, l = "hide" === a.uniformtext.mode;
                            switch(r){
                                case "funnelarea":
                                case "pie":
                                case "sunburst":
                                    s = "g.slice";
                                    break;
                                case "treemap":
                                case "icicle":
                                    s = "g.slice, g.pathbar";
                                    break;
                                default:
                                    s = "g.points > g.point";
                            }
                            e1.selectAll(s).each(function(t1) {
                                var e1 = t1.transform;
                                if (e1) {
                                    e1.scale = l && e1.hide ? 0 : o / e1.fontSize;
                                    var r = n.select(this).select("text");
                                    i.setTransormAndDisplay(r, e1);
                                }
                            });
                        }
                    }
                };
            },
            32225: function(t1, e1, r) {
                "use strict";
                var n, i = r(3208).rb, a = r(93049).extendFlat, o = r(8738), s = r(81481);
                t1.exports = {
                    r: o.r,
                    theta: o.theta,
                    r0: o.r0,
                    dr: o.dr,
                    theta0: o.theta0,
                    dtheta: o.dtheta,
                    thetaunit: o.thetaunit,
                    base: a({}, s.base, {}),
                    offset: a({}, s.offset, {}),
                    width: a({}, s.width, {}),
                    text: a({}, s.text, {}),
                    hovertext: a({}, s.hovertext, {}),
                    marker: (n = a({}, s.marker), delete n.cornerradius, n),
                    hoverinfo: o.hoverinfo,
                    hovertemplate: i(),
                    selected: s.selected,
                    unselected: s.unselected
                };
            },
            27941: function(t1, e1, r) {
                "use strict";
                var n = r(65477).hasColorscale, i = r(28379), a = r(34809).isArrayOrTypedArray, o = r(35374), s = r(24782).setGroupPositions, l = r(48861), c = r(33626).traceIs, u = r(34809).extendFlat;
                t1.exports = {
                    calc: function(t1, e1) {
                        for(var r = t1._fullLayout, s = e1.subplot, c = r[s].radialaxis, u = r[s].angularaxis, h = c.makeCalcdata(e1, "r"), f = u.makeCalcdata(e1, "theta"), p = e1._length, d = new Array(p), m = h, g = f, y = 0; y < p; y++)d[y] = {
                            p: g[y],
                            s: m[y]
                        };
                        function v(t1) {
                            var r = e1[t1];
                            void 0 !== r && (e1["_" + t1] = a(r) ? u.makeCalcdata(e1, t1) : u.d2c(r, e1.thetaunit));
                        }
                        return "linear" === u.type && (v("width"), v("offset")), n(e1, "marker") && i(t1, e1, {
                            vals: e1.marker.color,
                            containerStr: "marker",
                            cLetter: "c"
                        }), n(e1, "marker.line") && i(t1, e1, {
                            vals: e1.marker.line.color,
                            containerStr: "marker.line",
                            cLetter: "c"
                        }), o(d, e1), l(d, e1), d;
                    },
                    crossTraceCalc: function(t1, e1, r) {
                        for(var n = t1.calcdata, i = [], a = 0; a < n.length; a++){
                            var o = n[a], l = o[0].trace;
                            !0 === l.visible && c(l, "bar") && l.subplot === r && i.push(o);
                        }
                        var h = u({}, e1.radialaxis, {
                            _id: "x"
                        }), f = e1.angularaxis;
                        s(t1, f, h, i, {
                            mode: e1.barmode,
                            norm: e1.barnorm,
                            gap: e1.bargap,
                            groupgap: e1.bargroupgap
                        });
                    }
                };
            },
            77318: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(73749).handleRThetaDefaults, a = r(59760), o = r(32225);
                t1.exports = function(t1, e1, r, s) {
                    function l(r, i) {
                        return n.coerce(t1, e1, o, r, i);
                    }
                    i(t1, e1, s, l) ? (l("thetaunit"), l("base"), l("offset"), l("width"), l("text"), l("hovertext"), l("hovertemplate"), a(t1, e1, l, r, s), n.coerceSelectionMarkerOpacity(e1, l)) : e1.visible = !1;
                };
            },
            83080: function(t1, e1, r) {
                "use strict";
                var n = r(32141), i = r(34809), a = r(91664).getTraceColor, o = i.fillText, s = r(29709).makeHoverPointText, l = r(95928).isPtInsidePolygon;
                t1.exports = function(t1, e1, r) {
                    var c = t1.cd, u = c[0].trace, h = t1.subplot, f = h.radialAxis, p = h.angularAxis, d = h.vangles, m = d ? l : i.isPtInsideSector, g = t1.maxHoverDistance, y = p._period || 2 * Math.PI, v = Math.abs(f.g2p(Math.sqrt(e1 * e1 + r * r))), x = Math.atan2(r, e1);
                    if (f.range[0] > f.range[1] && (x += Math.PI), n.getClosest(c, function(t1) {
                        return m(v, x, [
                            t1.rp0,
                            t1.rp1
                        ], [
                            t1.thetag0,
                            t1.thetag1
                        ], d) ? g + Math.min(1, Math.abs(t1.thetag1 - t1.thetag0) / y) - 1 + (t1.rp1 - v) / (t1.rp1 - t1.rp0) - 1 : 1 / 0;
                    }, t1), !1 !== t1.index) {
                        var _ = c[t1.index];
                        t1.x0 = t1.x1 = _.ct[0], t1.y0 = t1.y1 = _.ct[1];
                        var b = i.extendFlat({}, _, {
                            r: _.s,
                            theta: _.p
                        });
                        return o(_, u, t1), s(b, u, h, t1), t1.hovertemplate = u.hovertemplate, t1.color = a(u, _), t1.xLabelVal = t1.yLabelVal = void 0, _.s < 0 && (t1.idealAlign = "left"), [
                            t1
                        ];
                    }
                };
            },
            89362: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    moduleType: "trace",
                    name: "barpolar",
                    basePlotModule: r(31645),
                    categories: [
                        "polar",
                        "bar",
                        "showLegend"
                    ],
                    attributes: r(32225),
                    layoutAttributes: r(42956),
                    supplyDefaults: r(77318),
                    supplyLayoutDefaults: r(60507),
                    calc: r(27941).calc,
                    crossTraceCalc: r(27941).crossTraceCalc,
                    plot: r(11627),
                    colorbar: r(21146),
                    formatLabels: r(33368),
                    style: r(6851).style,
                    styleOnSelect: r(6851).styleOnSelect,
                    hoverPoints: r(83080),
                    selectPoints: r(88384),
                    meta: {}
                };
            },
            42956: function(t1) {
                "use strict";
                t1.exports = {
                    barmode: {
                        valType: "enumerated",
                        values: [
                            "stack",
                            "overlay"
                        ],
                        dflt: "stack",
                        editType: "calc"
                    },
                    bargap: {
                        valType: "number",
                        dflt: .1,
                        min: 0,
                        max: 1,
                        editType: "calc"
                    }
                };
            },
            60507: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(42956);
                t1.exports = function(t1, e1, r) {
                    var a, o = {};
                    function s(r, o) {
                        return n.coerce(t1[a] || {}, e1[a], i, r, o);
                    }
                    for(var l = 0; l < r.length; l++){
                        var c = r[l];
                        "barpolar" === c.type && !0 === c.visible && (o[a = c.subplot] || (s("barmode"), s("bargap"), o[a] = 1));
                    }
                };
            },
            11627: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(10721), a = r(34809), o = r(62203), s = r(95928);
                t1.exports = function(t1, e1, r) {
                    var l = t1._context.staticPlot, c = e1.xaxis, u = e1.yaxis, h = e1.radialAxis, f = e1.angularAxis, p = function(t1) {
                        var e1 = t1.cxx, r = t1.cyy;
                        return t1.vangles ? function(n, i, o, l) {
                            var c, u;
                            a.angleDelta(o, l) > 0 ? (c = o, u = l) : (c = l, u = o);
                            var h = [
                                s.findEnclosingVertexAngles(c, t1.vangles)[0],
                                (c + u) / 2,
                                s.findEnclosingVertexAngles(u, t1.vangles)[1]
                            ];
                            return s.pathPolygonAnnulus(n, i, c, u, h, e1, r);
                        } : function(t1, n, i, o) {
                            return a.pathAnnulus(t1, n, i, o, e1, r);
                        };
                    }(e1), d = e1.layers.frontplot.select("g.barlayer");
                    a.makeTraceGroups(d, r, "trace bars").each(function() {
                        var r = n.select(this), s = a.ensureSingle(r, "g", "points").selectAll("g.point").data(a.identity);
                        s.enter().append("g").style("vector-effect", l ? "none" : "non-scaling-stroke").style("stroke-miterlimit", 2).classed("point", !0), s.exit().remove(), s.each(function(t1) {
                            var e1, r = n.select(this), o = t1.rp0 = h.c2p(t1.s0), s = t1.rp1 = h.c2p(t1.s1), l = t1.thetag0 = f.c2g(t1.p0), d = t1.thetag1 = f.c2g(t1.p1);
                            if (i(o) && i(s) && i(l) && i(d) && o !== s && l !== d) {
                                var m = h.c2g(t1.s1), g = (l + d) / 2;
                                t1.ct = [
                                    c.c2p(m * Math.cos(g)),
                                    u.c2p(m * Math.sin(g))
                                ], e1 = p(o, s, l, d);
                            } else e1 = "M0,0Z";
                            a.ensureSingle(r, "path").attr("d", e1);
                        }), o.setClipUrl(r, e1._hasClipOnAxisFalse ? e1.clipIds.forTraces : null, t1);
                    });
                };
            },
            64625: function(t1, e1, r) {
                "use strict";
                var n = r(19326), i = r(36640), a = r(81481), o = r(10229), s = r(80712).axisHoverFormat, l = r(3208).rb, c = r(93049).extendFlat, u = i.marker, h = u.line;
                t1.exports = {
                    y: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    x: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    x0: {
                        valType: "any",
                        editType: "calc+clearAxisTypes"
                    },
                    y0: {
                        valType: "any",
                        editType: "calc+clearAxisTypes"
                    },
                    dx: {
                        valType: "number",
                        editType: "calc"
                    },
                    dy: {
                        valType: "number",
                        editType: "calc"
                    },
                    xperiod: i.xperiod,
                    yperiod: i.yperiod,
                    xperiod0: i.xperiod0,
                    yperiod0: i.yperiod0,
                    xperiodalignment: i.xperiodalignment,
                    yperiodalignment: i.yperiodalignment,
                    xhoverformat: s("x"),
                    yhoverformat: s("y"),
                    name: {
                        valType: "string",
                        editType: "calc+clearAxisTypes"
                    },
                    q1: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    median: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    q3: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    lowerfence: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    upperfence: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    notched: {
                        valType: "boolean",
                        editType: "calc"
                    },
                    notchwidth: {
                        valType: "number",
                        min: 0,
                        max: .5,
                        dflt: .25,
                        editType: "calc"
                    },
                    notchspan: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    boxpoints: {
                        valType: "enumerated",
                        values: [
                            "all",
                            "outliers",
                            "suspectedoutliers",
                            !1
                        ],
                        editType: "calc"
                    },
                    jitter: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        editType: "calc"
                    },
                    pointpos: {
                        valType: "number",
                        min: -2,
                        max: 2,
                        editType: "calc"
                    },
                    sdmultiple: {
                        valType: "number",
                        min: 0,
                        editType: "calc",
                        dflt: 1
                    },
                    sizemode: {
                        valType: "enumerated",
                        values: [
                            "quartiles",
                            "sd"
                        ],
                        editType: "calc",
                        dflt: "quartiles"
                    },
                    boxmean: {
                        valType: "enumerated",
                        values: [
                            !0,
                            "sd",
                            !1
                        ],
                        editType: "calc"
                    },
                    mean: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    sd: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    orientation: {
                        valType: "enumerated",
                        values: [
                            "v",
                            "h"
                        ],
                        editType: "calc+clearAxisTypes"
                    },
                    quartilemethod: {
                        valType: "enumerated",
                        values: [
                            "linear",
                            "exclusive",
                            "inclusive"
                        ],
                        dflt: "linear",
                        editType: "calc"
                    },
                    width: {
                        valType: "number",
                        min: 0,
                        dflt: 0,
                        editType: "calc"
                    },
                    marker: {
                        outliercolor: {
                            valType: "color",
                            dflt: "rgba(0, 0, 0, 0)",
                            editType: "style"
                        },
                        symbol: c({}, u.symbol, {
                            arrayOk: !1,
                            editType: "plot"
                        }),
                        opacity: c({}, u.opacity, {
                            arrayOk: !1,
                            dflt: 1,
                            editType: "style"
                        }),
                        angle: c({}, u.angle, {
                            arrayOk: !1,
                            editType: "calc"
                        }),
                        size: c({}, u.size, {
                            arrayOk: !1,
                            editType: "calc"
                        }),
                        color: c({}, u.color, {
                            arrayOk: !1,
                            editType: "style"
                        }),
                        line: {
                            color: c({}, h.color, {
                                arrayOk: !1,
                                dflt: o.defaultLine,
                                editType: "style"
                            }),
                            width: c({}, h.width, {
                                arrayOk: !1,
                                dflt: 0,
                                editType: "style"
                            }),
                            outliercolor: {
                                valType: "color",
                                editType: "style"
                            },
                            outlierwidth: {
                                valType: "number",
                                min: 0,
                                dflt: 1,
                                editType: "style"
                            },
                            editType: "style"
                        },
                        editType: "plot"
                    },
                    line: {
                        color: {
                            valType: "color",
                            editType: "style"
                        },
                        width: {
                            valType: "number",
                            min: 0,
                            dflt: 2,
                            editType: "style"
                        },
                        editType: "plot"
                    },
                    fillcolor: n(),
                    whiskerwidth: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: .5,
                        editType: "calc"
                    },
                    showwhiskers: {
                        valType: "boolean",
                        editType: "calc"
                    },
                    offsetgroup: a.offsetgroup,
                    alignmentgroup: a.alignmentgroup,
                    selected: {
                        marker: i.selected.marker,
                        editType: "style"
                    },
                    unselected: {
                        marker: i.unselected.marker,
                        editType: "style"
                    },
                    text: c({}, i.text, {}),
                    hovertext: c({}, i.hovertext, {}),
                    hovertemplate: l({}),
                    hoveron: {
                        valType: "flaglist",
                        flags: [
                            "boxes",
                            "points"
                        ],
                        dflt: "boxes+points",
                        editType: "style"
                    },
                    zorder: i.zorder
                };
            },
            89429: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(29714), a = r(40528), o = r(34809), s = r(63821).BADNUM, l = o._;
                t1.exports = function(t1, e1) {
                    var r, c, v, x, _, b, w, T = t1._fullLayout, k = i.getFromId(t1, e1.xaxis || "x"), A = i.getFromId(t1, e1.yaxis || "y"), M = [], S = "violin" === e1.type ? "_numViolins" : "_numBoxes";
                    "h" === e1.orientation ? (v = k, x = "x", _ = A, b = "y", w = !!e1.yperiodalignment) : (v = A, x = "y", _ = k, b = "x", w = !!e1.xperiodalignment);
                    var E, C, L, I, P, z, O = function(t1, e1, r, i) {
                        var s, l = e1 + "0" in t1;
                        if (e1 in t1 || l && "d" + e1 in t1) {
                            var c = r.makeCalcdata(t1, e1);
                            return [
                                a(t1, r, e1, c).vals,
                                c
                            ];
                        }
                        s = l ? t1[e1 + "0"] : "name" in t1 && ("category" === r.type || n(t1.name) && -1 !== [
                            "linear",
                            "log"
                        ].indexOf(r.type) || o.isDateTime(t1.name) && "date" === r.type) ? t1.name : i;
                        for(var u = "multicategory" === r.type ? r.r2c_just_indices(s) : r.d2c(s, 0, t1[e1 + "calendar"]), h = t1._length, f = new Array(h), p = 0; p < h; p++)f[p] = u;
                        return [
                            f
                        ];
                    }(e1, b, _, T[S]), D = O[0], R = O[1], F = o.distinctVals(D, _), B = F.vals, N = F.minDiff / 2, j = "all" === (e1.boxpoints || e1.points) ? o.identity : function(t1) {
                        return t1.v < E.lf || t1.v > E.uf;
                    };
                    if (e1._hasPreCompStats) {
                        var U = e1[x], V = function(t1) {
                            return v.d2c((e1[t1] || [])[r]);
                        }, q = 1 / 0, H = -1 / 0;
                        for(r = 0; r < e1._length; r++){
                            var G = D[r];
                            if (n(G)) {
                                if ((E = {}).pos = E[b] = G, w && R && (E.orig_p = R[r]), E.q1 = V("q1"), E.med = V("median"), E.q3 = V("q3"), C = [], U && o.isArrayOrTypedArray(U[r])) for(c = 0; c < U[r].length; c++)(z = v.d2c(U[r][c])) !== s && (u(P = {
                                    v: z,
                                    i: [
                                        r,
                                        c
                                    ]
                                }, e1, [
                                    r,
                                    c
                                ]), C.push(P));
                                if (E.pts = C.sort(h), I = (L = E[x] = C.map(f)).length, E.med !== s && E.q1 !== s && E.q3 !== s && E.med >= E.q1 && E.q3 >= E.med) {
                                    var Z = V("lowerfence");
                                    E.lf = Z !== s && Z <= E.q1 ? Z : p(E, L, I);
                                    var W = V("upperfence");
                                    E.uf = W !== s && W >= E.q3 ? W : d(E, L, I);
                                    var Y = V("mean");
                                    E.mean = Y !== s ? Y : I ? o.mean(L, I) : (E.q1 + E.q3) / 2;
                                    var X = V("sd");
                                    E.sd = Y !== s && X >= 0 ? X : I ? o.stdev(L, I, E.mean) : E.q3 - E.q1, E.lo = m(E), E.uo = g(E);
                                    var $ = V("notchspan");
                                    $ = $ !== s && $ > 0 ? $ : y(E, I), E.ln = E.med - $, E.un = E.med + $;
                                    var J = E.lf, K = E.uf;
                                    e1.boxpoints && L.length && (J = Math.min(J, L[0]), K = Math.max(K, L[I - 1])), e1.notched && (J = Math.min(J, E.ln), K = Math.max(K, E.un)), E.min = J, E.max = K;
                                } else {
                                    var Q;
                                    o.warn([
                                        "Invalid input - make sure that q1 <= median <= q3",
                                        "q1 = " + E.q1,
                                        "median = " + E.med,
                                        "q3 = " + E.q3
                                    ].join("\n")), Q = E.med !== s ? E.med : E.q1 !== s ? E.q3 !== s ? (E.q1 + E.q3) / 2 : E.q1 : E.q3 !== s ? E.q3 : 0, E.med = Q, E.q1 = E.q3 = Q, E.lf = E.uf = Q, E.mean = E.sd = Q, E.ln = E.un = Q, E.min = E.max = Q;
                                }
                                q = Math.min(q, E.min), H = Math.max(H, E.max), E.pts2 = C.filter(j), M.push(E);
                            }
                        }
                        e1._extremes[v._id] = i.findExtremes(v, [
                            q,
                            H
                        ], {
                            padded: !0
                        });
                    } else {
                        var tt = v.makeCalcdata(e1, x), et = function(t1, e1) {
                            for(var r = t1.length, n = new Array(r + 1), i = 0; i < r; i++)n[i] = t1[i] - e1;
                            return n[r] = t1[r - 1] + e1, n;
                        }(B, N), rt = B.length, nt = function(t1) {
                            for(var e1 = new Array(t1), r = 0; r < t1; r++)e1[r] = [];
                            return e1;
                        }(rt);
                        for(r = 0; r < e1._length; r++)if (z = tt[r], n(z)) {
                            var it = o.findBin(D[r], et);
                            it >= 0 && it < rt && (u(P = {
                                v: z,
                                i: r
                            }, e1, r), nt[it].push(P));
                        }
                        var at = 1 / 0, ot = -1 / 0, st = e1.quartilemethod, lt = "exclusive" === st, ct = "inclusive" === st;
                        for(r = 0; r < rt; r++)if (nt[r].length > 0) {
                            var ut, ht;
                            (E = {}).pos = E[b] = B[r], C = E.pts = nt[r].sort(h), I = (L = E[x] = C.map(f)).length, E.min = L[0], E.max = L[I - 1], E.mean = o.mean(L, I), E.sd = o.stdev(L, I, E.mean) * e1.sdmultiple, E.med = o.interp(L, .5), I % 2 && (lt || ct) ? (lt ? (ut = L.slice(0, I / 2), ht = L.slice(I / 2 + 1)) : ct && (ut = L.slice(0, I / 2 + 1), ht = L.slice(I / 2)), E.q1 = o.interp(ut, .5), E.q3 = o.interp(ht, .5)) : (E.q1 = o.interp(L, .25), E.q3 = o.interp(L, .75)), E.lf = p(E, L, I), E.uf = d(E, L, I), E.lo = m(E), E.uo = g(E);
                            var ft = y(E, I);
                            E.ln = E.med - ft, E.un = E.med + ft, at = Math.min(at, E.ln), ot = Math.max(ot, E.un), E.pts2 = C.filter(j), M.push(E);
                        }
                        e1.notched && o.isTypedArray(tt) && (tt = Array.from(tt)), e1._extremes[v._id] = i.findExtremes(v, e1.notched ? tt.concat([
                            at,
                            ot
                        ]) : tt, {
                            padded: !0
                        });
                    }
                    return function(t1, e1) {
                        if (o.isArrayOrTypedArray(e1.selectedpoints)) for(var r = 0; r < t1.length; r++){
                            for(var n = t1[r].pts || [], i = {}, a = 0; a < n.length; a++)i[n[a].i] = a;
                            o.tagSelected(n, e1, i);
                        }
                    }(M, e1), M.length > 0 ? (M[0].t = {
                        num: T[S],
                        dPos: N,
                        posLetter: b,
                        valLetter: x,
                        labels: {
                            med: l(t1, "median:"),
                            min: l(t1, "min:"),
                            q1: l(t1, "q1:"),
                            q3: l(t1, "q3:"),
                            max: l(t1, "max:"),
                            mean: "sd" === e1.boxmean || "sd" === e1.sizemode ? l(t1, "mean \xb1 \u03C3:").replace("\u03C3", 1 === e1.sdmultiple ? "\u03C3" : e1.sdmultiple + "\u03C3") : l(t1, "mean:"),
                            lf: l(t1, "lower fence:"),
                            uf: l(t1, "upper fence:")
                        }
                    }, T[S]++, M) : [
                        {
                            t: {
                                empty: !0
                            }
                        }
                    ];
                };
                var c = {
                    text: "tx",
                    hovertext: "htx"
                };
                function u(t1, e1, r) {
                    for(var n in c)o.isArrayOrTypedArray(e1[n]) && (Array.isArray(r) ? o.isArrayOrTypedArray(e1[n][r[0]]) && (t1[c[n]] = e1[n][r[0]][r[1]]) : t1[c[n]] = e1[n][r]);
                }
                function h(t1, e1) {
                    return t1.v - e1.v;
                }
                function f(t1) {
                    return t1.v;
                }
                function p(t1, e1, r) {
                    return 0 === r ? t1.q1 : Math.min(t1.q1, e1[Math.min(o.findBin(2.5 * t1.q1 - 1.5 * t1.q3, e1, !0) + 1, r - 1)]);
                }
                function d(t1, e1, r) {
                    return 0 === r ? t1.q3 : Math.max(t1.q3, e1[Math.max(o.findBin(2.5 * t1.q3 - 1.5 * t1.q1, e1), 0)]);
                }
                function m(t1) {
                    return 4 * t1.q1 - 3 * t1.q3;
                }
                function g(t1) {
                    return 4 * t1.q3 - 3 * t1.q1;
                }
                function y(t1, e1) {
                    return 0 === e1 ? 0 : 1.57 * (t1.q3 - t1.q1) / Math.sqrt(e1);
                }
            },
            81606: function(t1, e1, r) {
                "use strict";
                var n = r(29714), i = r(34809), a = r(84391).getAxisGroup, o = [
                    "v",
                    "h"
                ];
                function s(t1, e1, r, o) {
                    var s, l, c, u = e1.calcdata, h = e1._fullLayout, f = o._id, p = f.charAt(0), d = [], m = 0;
                    for(s = 0; s < r.length; s++)for(c = u[r[s]], l = 0; l < c.length; l++)d.push(o.c2l(c[l].pos, !0)), m += (c[l].pts2 || []).length;
                    if (d.length) {
                        var g = i.distinctVals(d);
                        "category" !== o.type && "multicategory" !== o.type || (g.minDiff = 1);
                        var y = g.minDiff / 2;
                        n.minDtick(o, g.minDiff, g.vals[0], !0);
                        var v = h["violin" === t1 ? "_numViolins" : "_numBoxes"], x = "group" === h[t1 + "mode"] && v > 1, _ = 1 - h[t1 + "gap"], b = 1 - h[t1 + "groupgap"];
                        for(s = 0; s < r.length; s++){
                            var w, T, k, A, M, S, E = (c = u[r[s]])[0].trace, C = c[0].t, L = E.width, I = E.side;
                            if (L) w = T = A = L / 2, k = 0;
                            else if (w = y, x) {
                                var P = a(h, o._id) + E.orientation, z = (h._alignmentOpts[P] || {})[E.alignmentgroup] || {}, O = Object.keys(z.offsetGroups || {}).length, D = O || v;
                                T = w * _ * b / D, k = 2 * w * (((O ? E._offsetIndex : C.num) + .5) / D - .5) * _, A = w * _ / D;
                            } else T = w * _ * b, k = 0, A = w;
                            C.dPos = w, C.bPos = k, C.bdPos = T, C.wHover = A;
                            var R, F, B, N, j, U, V = k + T, q = Boolean(L);
                            if ("positive" === I ? (M = w * (L ? 1 : .5), R = V, S = R = k) : "negative" === I ? (M = R = k, S = w * (L ? 1 : .5), F = V) : (M = S = w, R = F = V), (E.boxpoints || E.points) && m > 0) {
                                var H = E.pointpos, G = E.jitter, Z = E.marker.size / 2, W = 0;
                                H + G >= 0 && ((W = V * (H + G)) > M ? (q = !0, j = Z, B = W) : W > R && (j = Z, B = M)), W <= M && (B = M);
                                var Y = 0;
                                H - G <= 0 && ((Y = -V * (H - G)) > S ? (q = !0, U = Z, N = Y) : Y > F && (U = Z, N = S)), Y <= S && (N = S);
                            } else B = M, N = S;
                            var X = new Array(c.length);
                            for(l = 0; l < c.length; l++)X[l] = c[l].pos;
                            E._extremes[f] = n.findExtremes(o, X, {
                                padded: q,
                                vpadminus: N,
                                vpadplus: B,
                                vpadLinearized: !0,
                                ppadminus: {
                                    x: U,
                                    y: j
                                }[p],
                                ppadplus: {
                                    x: j,
                                    y: U
                                }[p]
                            });
                        }
                    }
                }
                t1.exports = {
                    crossTraceCalc: function(t1, e1) {
                        for(var r = t1.calcdata, n = e1.xaxis, i = e1.yaxis, a = 0; a < o.length; a++){
                            for(var l = o[a], c = "h" === l ? i : n, u = [], h = 0; h < r.length; h++){
                                var f = r[h], p = f[0].t, d = f[0].trace;
                                !0 !== d.visible || "box" !== d.type && "candlestick" !== d.type || p.empty || (d.orientation || "v") !== l || d.xaxis !== n._id || d.yaxis !== i._id || u.push(h);
                            }
                            s("box", t1, u, c);
                        }
                    },
                    setPositionOffset: s
                };
            },
            62294: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(33626), a = r(78766), o = r(99669), s = r(36301), l = r(9666), c = r(64625);
                function u(t1, e1, r, a) {
                    function o(t1) {
                        var e1 = 0;
                        return t1 && t1.length && (e1 += 1, n.isArrayOrTypedArray(t1[0]) && t1[0].length && (e1 += 1)), e1;
                    }
                    function s(e1) {
                        return n.validate(t1[e1], c[e1]);
                    }
                    var u, h = r("y"), f = r("x");
                    if ("box" === e1.type) {
                        var p = r("q1"), d = r("median"), m = r("q3");
                        e1._hasPreCompStats = p && p.length && d && d.length && m && m.length, u = Math.min(n.minRowLength(p), n.minRowLength(d), n.minRowLength(m));
                    }
                    var g, y, v = o(h), x = o(f), _ = v && n.minRowLength(h), b = x && n.minRowLength(f), w = a.calendar, T = {
                        autotypenumbers: a.autotypenumbers
                    };
                    if (e1._hasPreCompStats) switch(String(x) + String(v)){
                        case "00":
                            var k = s("x0") || s("dx");
                            g = !s("y0") && !s("dy") || k ? "v" : "h", y = u;
                            break;
                        case "10":
                            g = "v", y = Math.min(u, b);
                            break;
                        case "20":
                            g = "h", y = Math.min(u, f.length);
                            break;
                        case "01":
                            g = "h", y = Math.min(u, _);
                            break;
                        case "02":
                            g = "v", y = Math.min(u, h.length);
                            break;
                        case "12":
                            g = "v", y = Math.min(u, b, h.length);
                            break;
                        case "21":
                            g = "h", y = Math.min(u, f.length, _);
                            break;
                        case "11":
                            y = 0;
                            break;
                        case "22":
                            var A, M = !1;
                            for(A = 0; A < f.length; A++)if ("category" === l(f[A], w, T)) {
                                M = !0;
                                break;
                            }
                            if (M) g = "v", y = Math.min(u, b, h.length);
                            else {
                                for(A = 0; A < h.length; A++)if ("category" === l(h[A], w, T)) {
                                    M = !0;
                                    break;
                                }
                                M ? (g = "h", y = Math.min(u, f.length, _)) : (g = "v", y = Math.min(u, b, h.length));
                            }
                    }
                    else v > 0 ? (g = "v", y = x > 0 ? Math.min(b, _) : Math.min(_)) : x > 0 ? (g = "h", y = Math.min(b)) : y = 0;
                    if (y) {
                        e1._length = y;
                        var S = r("orientation", g);
                        e1._hasPreCompStats ? "v" === S && 0 === x ? (r("x0", 0), r("dx", 1)) : "h" === S && 0 === v && (r("y0", 0), r("dy", 1)) : "v" === S && 0 === x ? r("x0") : "h" === S && 0 === v && r("y0"), i.getComponentMethod("calendars", "handleTraceDefaults")(t1, e1, [
                            "x",
                            "y"
                        ], a);
                    } else e1.visible = !1;
                }
                function h(t1, e1, r, i) {
                    var a = i.prefix, o = n.coerce2(t1, e1, c, "marker.outliercolor"), s = r("marker.line.outliercolor"), l = "outliers";
                    e1._hasPreCompStats ? l = "all" : (o || s) && (l = "suspectedoutliers");
                    var u = r(a + "points", l);
                    u ? (r("jitter", "all" === u ? .3 : 0), r("pointpos", "all" === u ? -1.5 : 0), r("marker.symbol"), r("marker.opacity"), r("marker.size"), r("marker.angle"), r("marker.color", e1.line.color), r("marker.line.color"), r("marker.line.width"), "suspectedoutliers" === u && (r("marker.line.outliercolor", e1.marker.color), r("marker.line.outlierwidth")), r("selected.marker.color"), r("unselected.marker.color"), r("selected.marker.size"), r("unselected.marker.size"), r("text"), r("hovertext")) : delete e1.marker;
                    var h = r("hoveron");
                    "all" !== h && -1 === h.indexOf("points") || r("hovertemplate"), n.coerceSelectionMarkerOpacity(e1, r);
                }
                t1.exports = {
                    supplyDefaults: function(t1, e1, r, i) {
                        function s(r, i) {
                            return n.coerce(t1, e1, c, r, i);
                        }
                        if (u(t1, e1, s, i), !1 !== e1.visible) {
                            o(t1, e1, i, s), s("xhoverformat"), s("yhoverformat");
                            var l = e1._hasPreCompStats;
                            l && (s("lowerfence"), s("upperfence")), s("line.color", (t1.marker || {}).color || r), s("line.width"), s("fillcolor", a.addOpacity(e1.line.color, .5));
                            var f = !1;
                            if (l) {
                                var p = s("mean"), d = s("sd");
                                p && p.length && (f = !0, d && d.length && (f = "sd"));
                            }
                            s("whiskerwidth");
                            var m, g = s("sizemode");
                            "quartiles" === g && (m = s("boxmean", f)), s("showwhiskers", "quartiles" === g), "sd" !== g && "sd" !== m || s("sdmultiple"), s("width"), s("quartilemethod");
                            var y = !1;
                            if (l) {
                                var v = s("notchspan");
                                v && v.length && (y = !0);
                            } else n.validate(t1.notchwidth, c.notchwidth) && (y = !0);
                            s("notched", y) && s("notchwidth"), h(t1, e1, s, {
                                prefix: "box"
                            }), s("zorder");
                        }
                    },
                    crossTraceDefaults: function(t1, e1) {
                        var r, i;
                        function a(t1) {
                            return n.coerce(i._input, i, c, t1);
                        }
                        for(var o = 0; o < t1.length; o++){
                            var l = (i = t1[o]).type;
                            "box" !== l && "violin" !== l || (r = i._input, "group" === e1[l + "mode"] && s(r, i, e1, a));
                        }
                    },
                    handleSampleDefaults: u,
                    handlePointsDefaults: h
                };
            },
            76429: function(t1) {
                "use strict";
                t1.exports = function(t1, e1) {
                    return e1.hoverOnBox && (t1.hoverOnBox = e1.hoverOnBox), "xVal" in e1 && (t1.x = e1.xVal), "yVal" in e1 && (t1.y = e1.yVal), e1.xa && (t1.xaxis = e1.xa), e1.ya && (t1.yaxis = e1.ya), t1;
                };
            },
            11448: function(t1, e1, r) {
                "use strict";
                var n = r(29714), i = r(34809), a = r(32141), o = r(78766), s = i.fillText;
                function l(t1, e1, r, s) {
                    var l, c, u, h, f, p, d, m, g, y, v, x, _, b, w = t1.cd, T = t1.xa, k = t1.ya, A = w[0].trace, M = w[0].t, S = "violin" === A.type, E = M.bdPos, C = M.wHover, L = function(t1) {
                        return u.c2l(t1.pos) + M.bPos - u.c2l(p);
                    };
                    S && "both" !== A.side ? ("positive" === A.side && (g = function(t1) {
                        var e1 = L(t1);
                        return a.inbox(e1, e1 + C, y);
                    }, x = E, _ = 0), "negative" === A.side && (g = function(t1) {
                        var e1 = L(t1);
                        return a.inbox(e1 - C, e1, y);
                    }, x = 0, _ = E)) : (g = function(t1) {
                        var e1 = L(t1);
                        return a.inbox(e1 - C, e1 + C, y);
                    }, x = _ = E), b = S ? function(t1) {
                        return a.inbox(t1.span[0] - f, t1.span[1] - f, y);
                    } : function(t1) {
                        return a.inbox(t1.min - f, t1.max - f, y);
                    }, "h" === A.orientation ? (f = e1, p = r, d = b, m = g, l = "y", u = k, c = "x", h = T) : (f = r, p = e1, d = g, m = b, l = "x", u = T, c = "y", h = k);
                    var I = Math.min(1, E / Math.abs(u.r2c(u.range[1]) - u.r2c(u.range[0])));
                    function P(t1) {
                        return (d(t1) + m(t1)) / 2;
                    }
                    y = t1.maxHoverDistance - I, v = t1.maxSpikeDistance - I;
                    var z = a.getDistanceFunction(s, d, m, P);
                    if (a.getClosest(w, z, t1), !1 === t1.index) return [];
                    var O = w[t1.index], D = A.line.color, R = (A.marker || {}).color;
                    o.opacity(D) && A.line.width ? t1.color = D : o.opacity(R) && A.boxpoints ? t1.color = R : t1.color = A.fillcolor, t1[l + "0"] = u.c2p(O.pos + M.bPos - _, !0), t1[l + "1"] = u.c2p(O.pos + M.bPos + x, !0), t1[l + "LabelVal"] = void 0 !== O.orig_p ? O.orig_p : O.pos;
                    var F = l + "Spike";
                    t1.spikeDistance = P(O) * v / y, t1[F] = u.c2p(O.pos, !0);
                    var B = A.boxmean || "sd" === A.sizemode || (A.meanline || {}).visible, N = A.boxpoints || A.points, j = N && B ? [
                        "max",
                        "uf",
                        "q3",
                        "med",
                        "mean",
                        "q1",
                        "lf",
                        "min"
                    ] : N && !B ? [
                        "max",
                        "uf",
                        "q3",
                        "med",
                        "q1",
                        "lf",
                        "min"
                    ] : !N && B ? [
                        "max",
                        "q3",
                        "med",
                        "mean",
                        "q1",
                        "min"
                    ] : [
                        "max",
                        "q3",
                        "med",
                        "q1",
                        "min"
                    ], U = h.range[1] < h.range[0];
                    A.orientation === (U ? "v" : "h") && j.reverse();
                    for(var V = t1.spikeDistance, q = t1[F], H = [], G = 0; G < j.length; G++){
                        var Z = j[G];
                        if (Z in O) {
                            var W = O[Z], Y = h.c2p(W, !0), X = i.extendFlat({}, t1);
                            X.attr = Z, X[c + "0"] = X[c + "1"] = Y, X[c + "LabelVal"] = W, X[c + "Label"] = (M.labels ? M.labels[Z] + " " : "") + n.hoverLabelText(h, W, A[c + "hoverformat"]), X.hoverOnBox = !0, "mean" !== Z || !("sd" in O) || "sd" !== A.boxmean && "sd" !== A.sizemode || (X[c + "err"] = O.sd), X.hovertemplate = !1, H.push(X);
                        }
                    }
                    t1.name = "", t1.spikeDistance = void 0, t1[F] = void 0;
                    for(var $ = 0; $ < H.length; $++)"med" !== H[$].attr ? (H[$].name = "", H[$].spikeDistance = void 0, H[$][F] = void 0) : (H[$].spikeDistance = V, H[$][F] = q);
                    return H;
                }
                function c(t1, e1, r) {
                    for(var n, o, l, c = t1.cd, u = t1.xa, h = t1.ya, f = c[0].trace, p = u.c2p(e1), d = h.c2p(r), m = a.quadrature(function(t1) {
                        var e1 = Math.max(3, t1.mrc || 0);
                        return Math.max(Math.abs(u.c2p(t1.x) - p) - e1, 1 - 3 / e1);
                    }, function(t1) {
                        var e1 = Math.max(3, t1.mrc || 0);
                        return Math.max(Math.abs(h.c2p(t1.y) - d) - e1, 1 - 3 / e1);
                    }), g = !1, y = 0; y < c.length; y++){
                        o = c[y];
                        for(var v = 0; v < (o.pts || []).length; v++){
                            var x = m(l = o.pts[v]);
                            x <= t1.distance && (t1.distance = x, g = [
                                y,
                                v
                            ]);
                        }
                    }
                    if (!g) return !1;
                    l = (o = c[g[0]]).pts[g[1]];
                    var _ = u.c2p(l.x, !0), b = h.c2p(l.y, !0), w = l.mrc || 1;
                    n = i.extendFlat({}, t1, {
                        index: l.i,
                        color: (f.marker || {}).color,
                        name: f.name,
                        x0: _ - w,
                        x1: _ + w,
                        y0: b - w,
                        y1: b + w,
                        spikeDistance: t1.distance,
                        hovertemplate: f.hovertemplate
                    });
                    var T, k = o.orig_p, A = void 0 !== k ? k : o.pos;
                    return "h" === f.orientation ? (T = h, n.xLabelVal = l.x, n.yLabelVal = A) : (T = u, n.xLabelVal = A, n.yLabelVal = l.y), n[T._id.charAt(0) + "Spike"] = T.c2p(o.pos, !0), s(l, f, n), n;
                }
                t1.exports = {
                    hoverPoints: function(t1, e1, r, n) {
                        var i, a = t1.cd[0].trace.hoveron, o = [];
                        return -1 !== a.indexOf("boxes") && (o = o.concat(l(t1, e1, r, n))), -1 !== a.indexOf("points") && (i = c(t1, e1, r)), "closest" === n ? i ? [
                            i
                        ] : o : i ? (o.push(i), o) : o;
                    },
                    hoverOnBoxes: l,
                    hoverOnPoints: c
                };
            },
            53794: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    attributes: r(64625),
                    layoutAttributes: r(64636),
                    supplyDefaults: r(62294).supplyDefaults,
                    crossTraceDefaults: r(62294).crossTraceDefaults,
                    supplyLayoutDefaults: r(65067).supplyLayoutDefaults,
                    calc: r(89429),
                    crossTraceCalc: r(81606).crossTraceCalc,
                    plot: r(95419).plot,
                    style: r(59979).style,
                    styleOnSelect: r(59979).styleOnSelect,
                    hoverPoints: r(11448).hoverPoints,
                    eventData: r(76429),
                    selectPoints: r(72488),
                    moduleType: "trace",
                    name: "box",
                    basePlotModule: r(37703),
                    categories: [
                        "cartesian",
                        "svg",
                        "symbols",
                        "oriented",
                        "box-violin",
                        "showLegend",
                        "boxLayout",
                        "zoomScale"
                    ],
                    meta: {}
                };
            },
            64636: function(t1) {
                "use strict";
                t1.exports = {
                    boxmode: {
                        valType: "enumerated",
                        values: [
                            "group",
                            "overlay"
                        ],
                        dflt: "overlay",
                        editType: "calc"
                    },
                    boxgap: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: .3,
                        editType: "calc"
                    },
                    boxgroupgap: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: .3,
                        editType: "calc"
                    }
                };
            },
            65067: function(t1, e1, r) {
                "use strict";
                var n = r(33626), i = r(34809), a = r(64636);
                function o(t1, e1, r, i, a) {
                    for(var o = a + "Layout", s = !1, l = 0; l < r.length; l++){
                        var c = r[l];
                        if (n.traceIs(c, o)) {
                            s = !0;
                            break;
                        }
                    }
                    s && (i(a + "mode"), i(a + "gap"), i(a + "groupgap"));
                }
                t1.exports = {
                    supplyLayoutDefaults: function(t1, e1, r) {
                        o(0, 0, r, function(r, n) {
                            return i.coerce(t1, e1, a, r, n);
                        }, "box");
                    },
                    _supply: o
                };
            },
            95419: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(34809), a = r(62203);
                function o(t1, e1, r, a, o) {
                    var s, l, c = "h" === r.orientation, u = e1.val, h = e1.pos, f = !!h.rangebreaks, p = a.bPos, d = a.wdPos || 0, m = a.bPosPxOffset || 0, g = r.whiskerwidth || 0, y = !1 !== r.showwhiskers, v = r.notched || !1, x = v ? 1 - 2 * r.notchwidth : 1;
                    Array.isArray(a.bdPos) ? (s = a.bdPos[0], l = a.bdPos[1]) : (s = a.bdPos, l = a.bdPos);
                    var _ = t1.selectAll("path.box").data("violin" !== r.type || r.box.visible ? i.identity : []);
                    _.enter().append("path").style("vector-effect", o ? "none" : "non-scaling-stroke").attr("class", "box"), _.exit().remove(), _.each(function(t1) {
                        if (t1.empty) return n.select(this).attr("d", "M0,0Z");
                        var e1 = h.c2l(t1.pos + p, !0), a = h.l2p(e1 - s) + m, o = h.l2p(e1 + l) + m, _ = f ? (a + o) / 2 : h.l2p(e1) + m, b = r.whiskerwidth, w = f ? a * b + (1 - b) * _ : h.l2p(e1 - d) + m, T = f ? o * b + (1 - b) * _ : h.l2p(e1 + d) + m, k = h.l2p(e1 - s * x) + m, A = h.l2p(e1 + l * x) + m, M = "sd" === r.sizemode, S = u.c2p(M ? t1.mean - t1.sd : t1.q1, !0), E = M ? u.c2p(t1.mean + t1.sd, !0) : u.c2p(t1.q3, !0), C = i.constrain(M ? u.c2p(t1.mean, !0) : u.c2p(t1.med, !0), Math.min(S, E) + 1, Math.max(S, E) - 1), L = void 0 === t1.lf || !1 === r.boxpoints || M, I = u.c2p(L ? t1.min : t1.lf, !0), P = u.c2p(L ? t1.max : t1.uf, !0), z = u.c2p(t1.ln, !0), O = u.c2p(t1.un, !0);
                        c ? n.select(this).attr("d", "M" + C + "," + k + "V" + A + "M" + S + "," + a + "V" + o + (v ? "H" + z + "L" + C + "," + A + "L" + O + "," + o : "") + "H" + E + "V" + a + (v ? "H" + O + "L" + C + "," + k + "L" + z + "," + a : "") + "Z" + (y ? "M" + S + "," + _ + "H" + I + "M" + E + "," + _ + "H" + P + (0 === g ? "" : "M" + I + "," + w + "V" + T + "M" + P + "," + w + "V" + T) : "")) : n.select(this).attr("d", "M" + k + "," + C + "H" + A + "M" + a + "," + S + "H" + o + (v ? "V" + z + "L" + A + "," + C + "L" + o + "," + O : "") + "V" + E + "H" + a + (v ? "V" + O + "L" + k + "," + C + "L" + a + "," + z : "") + "Z" + (y ? "M" + _ + "," + S + "V" + I + "M" + _ + "," + E + "V" + P + (0 === g ? "" : "M" + w + "," + I + "H" + T + "M" + w + "," + P + "H" + T) : ""));
                    });
                }
                function s(t1, e1, r, n) {
                    var o = e1.x, s = e1.y, l = n.bdPos, c = n.bPos, u = r.boxpoints || r.points;
                    i.seedPseudoRandom();
                    var h = t1.selectAll("g.points").data(u ? function(t1) {
                        return t1.forEach(function(t1) {
                            t1.t = n, t1.trace = r;
                        }), t1;
                    } : []);
                    h.enter().append("g").attr("class", "points"), h.exit().remove();
                    var f = h.selectAll("path").data(function(t1) {
                        var e1, n, a = t1.pts2, o = Math.max((t1.max - t1.min) / 10, t1.q3 - t1.q1), s = 1e-9 * o, h = .01 * o, f = [], p = 0;
                        if (r.jitter) {
                            if (0 === o) for(p = 1, f = new Array(a.length), e1 = 0; e1 < a.length; e1++)f[e1] = 1;
                            else for(e1 = 0; e1 < a.length; e1++){
                                var d = Math.max(0, e1 - 5), m = a[d].v, g = Math.min(a.length - 1, e1 + 5), y = a[g].v;
                                "all" !== u && (a[e1].v < t1.lf ? y = Math.min(y, t1.lf) : m = Math.max(m, t1.uf));
                                var v = Math.sqrt(h * (g - d) / (y - m + s)) || 0;
                                v = i.constrain(Math.abs(v), 0, 1), f.push(v), p = Math.max(v, p);
                            }
                            n = 2 * r.jitter / (p || 1);
                        }
                        for(e1 = 0; e1 < a.length; e1++){
                            var x = a[e1], _ = x.v, b = r.jitter ? n * f[e1] * (i.pseudoRandom() - .5) : 0, w = t1.pos + c + l * (r.pointpos + b);
                            "h" === r.orientation ? (x.y = w, x.x = _) : (x.x = w, x.y = _), "suspectedoutliers" === u && _ < t1.uo && _ > t1.lo && (x.so = !0);
                        }
                        return a;
                    });
                    f.enter().append("path").classed("point", !0), f.exit().remove(), f.call(a.translatePoints, o, s);
                }
                function l(t1, e1, r, a) {
                    var o, s, l = e1.val, c = e1.pos, u = !!c.rangebreaks, h = a.bPos, f = a.bPosPxOffset || 0, p = r.boxmean || (r.meanline || {}).visible;
                    Array.isArray(a.bdPos) ? (o = a.bdPos[0], s = a.bdPos[1]) : (o = a.bdPos, s = a.bdPos);
                    var d = t1.selectAll("path.mean").data("box" === r.type && r.boxmean || "violin" === r.type && r.box.visible && r.meanline.visible ? i.identity : []);
                    d.enter().append("path").attr("class", "mean").style({
                        fill: "none",
                        "vector-effect": "non-scaling-stroke"
                    }), d.exit().remove(), d.each(function(t1) {
                        var e1 = c.c2l(t1.pos + h, !0), i = c.l2p(e1 - o) + f, a = c.l2p(e1 + s) + f, d = u ? (i + a) / 2 : c.l2p(e1) + f, m = l.c2p(t1.mean, !0), g = l.c2p(t1.mean - t1.sd, !0), y = l.c2p(t1.mean + t1.sd, !0);
                        "h" === r.orientation ? n.select(this).attr("d", "M" + m + "," + i + "V" + a + ("sd" === p ? "m0,0L" + g + "," + d + "L" + m + "," + i + "L" + y + "," + d + "Z" : "")) : n.select(this).attr("d", "M" + i + "," + m + "H" + a + ("sd" === p ? "m0,0L" + d + "," + g + "L" + i + "," + m + "L" + d + "," + y + "Z" : ""));
                    });
                }
                t1.exports = {
                    plot: function(t1, e1, r, a) {
                        var c = t1._context.staticPlot, u = e1.xaxis, h = e1.yaxis;
                        i.makeTraceGroups(a, r, "trace boxes").each(function(t1) {
                            var e1, r, i = n.select(this), a = t1[0], f = a.t, p = a.trace;
                            f.wdPos = f.bdPos * p.whiskerwidth, !0 !== p.visible || f.empty ? i.remove() : ("h" === p.orientation ? (e1 = h, r = u) : (e1 = u, r = h), o(i, {
                                pos: e1,
                                val: r
                            }, p, f, c), s(i, {
                                x: u,
                                y: h
                            }, p, f), l(i, {
                                pos: e1,
                                val: r
                            }, p, f));
                        });
                    },
                    plotBoxAndWhiskers: o,
                    plotPoints: s,
                    plotBoxMean: l
                };
            },
            72488: function(t1) {
                "use strict";
                t1.exports = function(t1, e1) {
                    var r, n, i = t1.cd, a = t1.xaxis, o = t1.yaxis, s = [];
                    if (!1 === e1) for(r = 0; r < i.length; r++)for(n = 0; n < (i[r].pts || []).length; n++)i[r].pts[n].selected = 0;
                    else for(r = 0; r < i.length; r++)for(n = 0; n < (i[r].pts || []).length; n++){
                        var l = i[r].pts[n], c = a.c2p(l.x), u = o.c2p(l.y);
                        e1.contains([
                            c,
                            u
                        ], null, l.i, t1) ? (s.push({
                            pointNumber: l.i,
                            x: a.c2d(l.x),
                            y: o.c2d(l.y)
                        }), l.selected = 1) : l.selected = 0;
                    }
                    return s;
                };
            },
            59979: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(78766), a = r(62203);
                t1.exports = {
                    style: function(t1, e1, r) {
                        var o = r || n.select(t1).selectAll("g.trace.boxes");
                        o.style("opacity", function(t1) {
                            return t1[0].trace.opacity;
                        }), o.each(function(e1) {
                            var r = n.select(this), o = e1[0].trace, s = o.line.width;
                            function l(t1, e1, r, n) {
                                t1.style("stroke-width", e1 + "px").call(i.stroke, r).call(i.fill, n);
                            }
                            var c = r.selectAll("path.box");
                            if ("candlestick" === o.type) c.each(function(t1) {
                                if (!t1.empty) {
                                    var e1 = n.select(this), r = o[t1.dir];
                                    l(e1, r.line.width, r.line.color, r.fillcolor), e1.style("opacity", o.selectedpoints && !t1.selected ? .3 : 1);
                                }
                            });
                            else {
                                l(c, s, o.line.color, o.fillcolor), r.selectAll("path.mean").style({
                                    "stroke-width": s,
                                    "stroke-dasharray": 2 * s + "px," + s + "px"
                                }).call(i.stroke, o.line.color);
                                var u = r.selectAll("path.point");
                                a.pointStyle(u, o, t1);
                            }
                        });
                    },
                    styleOnSelect: function(t1, e1, r) {
                        var n = e1[0].trace, i = r.selectAll("path.point");
                        n.selectedpoints ? a.selectedPointStyle(i, n) : a.pointStyle(i, n, t1);
                    }
                };
            },
            24319: function(t1, e1, r) {
                "use strict";
                var n = r(34809).extendFlat, i = r(80712).axisHoverFormat, a = r(86706), o = r(64625);
                function s(t1) {
                    return {
                        line: {
                            color: n({}, o.line.color, {
                                dflt: t1
                            }),
                            width: o.line.width,
                            editType: "style"
                        },
                        fillcolor: o.fillcolor,
                        editType: "style"
                    };
                }
                t1.exports = {
                    xperiod: a.xperiod,
                    xperiod0: a.xperiod0,
                    xperiodalignment: a.xperiodalignment,
                    xhoverformat: i("x"),
                    yhoverformat: i("y"),
                    x: a.x,
                    open: a.open,
                    high: a.high,
                    low: a.low,
                    close: a.close,
                    line: {
                        width: n({}, o.line.width, {}),
                        editType: "style"
                    },
                    increasing: s(a.increasing.line.color.dflt),
                    decreasing: s(a.decreasing.line.color.dflt),
                    text: a.text,
                    hovertext: a.hovertext,
                    whiskerwidth: n({}, o.whiskerwidth, {
                        dflt: 0
                    }),
                    hoverlabel: a.hoverlabel,
                    zorder: o.zorder
                };
            },
            63679: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(29714), a = r(40528), o = r(95694).calcCommon;
                function s(t1, e1, r, n) {
                    return {
                        min: r,
                        q1: Math.min(t1, n),
                        med: n,
                        q3: Math.max(t1, n),
                        max: e1
                    };
                }
                t1.exports = function(t1, e1) {
                    var r = t1._fullLayout, l = i.getFromId(t1, e1.xaxis), c = i.getFromId(t1, e1.yaxis), u = l.makeCalcdata(e1, "x"), h = a(e1, l, "x", u).vals, f = o(t1, e1, u, h, c, s);
                    return f.length ? (n.extendFlat(f[0].t, {
                        num: r._numBoxes,
                        dPos: n.distinctVals(h).minDiff / 2,
                        posLetter: "x",
                        valLetter: "y"
                    }), r._numBoxes++, f) : [
                        {
                            t: {
                                empty: !0
                            }
                        }
                    ];
                };
            },
            57336: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(78766), a = r(28270), o = r(99669), s = r(24319);
                function l(t1, e1, r, n) {
                    var a = r(n + ".line.color");
                    r(n + ".line.width", e1.line.width), r(n + ".fillcolor", i.addOpacity(a, .5));
                }
                t1.exports = function(t1, e1, r, i) {
                    function c(r, i) {
                        return n.coerce(t1, e1, s, r, i);
                    }
                    a(t1, e1, c, i) ? (o(t1, e1, i, c, {
                        x: !0
                    }), c("xhoverformat"), c("yhoverformat"), c("line.width"), l(0, e1, c, "increasing"), l(0, e1, c, "decreasing"), c("text"), c("hovertext"), c("whiskerwidth"), i._requestRangeslider[e1.xaxis] = !0, c("zorder")) : e1.visible = !1;
                };
            },
            51252: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    moduleType: "trace",
                    name: "candlestick",
                    basePlotModule: r(37703),
                    categories: [
                        "cartesian",
                        "svg",
                        "showLegend",
                        "candlestick",
                        "boxLayout"
                    ],
                    meta: {},
                    attributes: r(24319),
                    layoutAttributes: r(64636),
                    supplyLayoutDefaults: r(65067).supplyLayoutDefaults,
                    crossTraceCalc: r(81606).crossTraceCalc,
                    supplyDefaults: r(57336),
                    calc: r(63679),
                    plot: r(95419).plot,
                    layerName: "boxlayer",
                    style: r(59979).style,
                    hoverPoints: r(93245).hoverPoints,
                    selectPoints: r(49343)
                };
            },
            8432: function(t1, e1, r) {
                "use strict";
                var n = r(6038), i = r(78032);
                t1.exports = function(t1, e1, r, a, o) {
                    a("a") || (a("da"), a("a0")), a("b") || (a("db"), a("b0")), function(t1, e1, r, a) {
                        [
                            "aaxis",
                            "baxis"
                        ].forEach(function(o) {
                            var s = o.charAt(0), l = t1[o] || {}, c = i.newContainer(e1, o), u = {
                                noAutotickangles: !0,
                                noTicklabelshift: !0,
                                noTicklabelstandoff: !0,
                                noTicklabelstep: !0,
                                tickfont: "x",
                                id: s + "axis",
                                letter: s,
                                font: e1.font,
                                name: o,
                                data: t1[s],
                                calendar: e1.calendar,
                                dfltColor: a,
                                bgColor: r.paper_bgcolor,
                                autotypenumbersDflt: r.autotypenumbers,
                                fullLayout: r
                            };
                            n(l, c, u), c._categories = c._categories || [], t1[o] || "-" === l.type || (t1[o] = {
                                type: l.type
                            });
                        });
                    }(t1, e1, r, o);
                };
            },
            97052: function(t1, e1, r) {
                "use strict";
                var n = r(34809).isArrayOrTypedArray;
                function i(t1, e1) {
                    if (!n(t1) || e1 >= 10) return null;
                    for(var r = 1 / 0, a = -1 / 0, o = t1.length, s = 0; s < o; s++){
                        var l = t1[s];
                        if (n(l)) {
                            var c = i(l, e1 + 1);
                            c && (r = Math.min(c[0], r), a = Math.max(c[1], a));
                        } else r = Math.min(l, r), a = Math.max(l, a);
                    }
                    return [
                        r,
                        a
                    ];
                }
                t1.exports = function(t1) {
                    return i(t1, 0);
                };
            },
            43745: function(t1, e1, r) {
                "use strict";
                var n = r(80337), i = r(86961), a = r(10229), o = n({
                    editType: "calc"
                }), s = r(36640).zorder;
                o.family.dflt = '"Open Sans", verdana, arial, sans-serif', o.size.dflt = 12, o.color.dflt = a.defaultLine, t1.exports = {
                    carpet: {
                        valType: "string",
                        editType: "calc"
                    },
                    x: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    y: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    a: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    a0: {
                        valType: "number",
                        dflt: 0,
                        editType: "calc"
                    },
                    da: {
                        valType: "number",
                        dflt: 1,
                        editType: "calc"
                    },
                    b: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    b0: {
                        valType: "number",
                        dflt: 0,
                        editType: "calc"
                    },
                    db: {
                        valType: "number",
                        dflt: 1,
                        editType: "calc"
                    },
                    cheaterslope: {
                        valType: "number",
                        dflt: 1,
                        editType: "calc"
                    },
                    aaxis: i,
                    baxis: i,
                    font: o,
                    color: {
                        valType: "color",
                        dflt: a.defaultLine,
                        editType: "plot"
                    },
                    transforms: void 0,
                    zorder: s
                };
            },
            94903: function(t1, e1, r) {
                "use strict";
                var n = r(34809).isArrayOrTypedArray;
                t1.exports = function(t1, e1, r, i) {
                    var a, o, s, l, c, u, h, f, p, d, m, g, y, v = n(r) ? "a" : "b", x = ("a" === v ? t1.aaxis : t1.baxis).smoothing, _ = "a" === v ? t1.a2i : t1.b2j, b = "a" === v ? r : i, w = "a" === v ? i : r, T = "a" === v ? e1.a.length : e1.b.length, k = "a" === v ? e1.b.length : e1.a.length, A = Math.floor("a" === v ? t1.b2j(w) : t1.a2i(w)), M = "a" === v ? function(e1) {
                        return t1.evalxy([], e1, A);
                    } : function(e1) {
                        return t1.evalxy([], A, e1);
                    };
                    x && (s = Math.max(0, Math.min(k - 2, A)), l = A - s, o = "a" === v ? function(e1, r) {
                        return t1.dxydi([], e1, s, r, l);
                    } : function(e1, r) {
                        return t1.dxydj([], s, e1, l, r);
                    });
                    var S = _(b[0]), E = _(b[1]), C = S < E ? 1 : -1, L = 1e-8 * (E - S), I = C > 0 ? Math.floor : Math.ceil, P = C > 0 ? Math.ceil : Math.floor, z = C > 0 ? Math.min : Math.max, O = C > 0 ? Math.max : Math.min, D = I(S + L), R = P(E - L), F = [
                        [
                            h = M(S)
                        ]
                    ];
                    for(a = D; a * C < R * C; a += C)c = [], m = O(S, a), y = (g = z(E, a + C)) - m, u = Math.max(0, Math.min(T - 2, Math.floor(.5 * (m + g)))), f = M(g), x && (p = o(u, m - u), d = o(u, g - u), c.push([
                        h[0] + p[0] / 3 * y,
                        h[1] + p[1] / 3 * y
                    ]), c.push([
                        f[0] - d[0] / 3 * y,
                        f[1] - d[1] / 3 * y
                    ])), c.push(f), F.push(c), h = f;
                    return F;
                };
            },
            86961: function(t1, e1, r) {
                "use strict";
                var n = r(80337), i = r(10229), a = r(25829), o = r(80712).descriptionWithDates, s = r(13582).overrideAll, l = r(94850).T, c = r(93049).extendFlat;
                t1.exports = {
                    color: {
                        valType: "color",
                        editType: "calc"
                    },
                    smoothing: {
                        valType: "number",
                        dflt: 1,
                        min: 0,
                        max: 1.3,
                        editType: "calc"
                    },
                    title: {
                        text: {
                            valType: "string",
                            dflt: "",
                            editType: "calc"
                        },
                        font: n({
                            editType: "calc"
                        }),
                        offset: {
                            valType: "number",
                            dflt: 10,
                            editType: "calc"
                        },
                        editType: "calc"
                    },
                    type: {
                        valType: "enumerated",
                        values: [
                            "-",
                            "linear",
                            "date",
                            "category"
                        ],
                        dflt: "-",
                        editType: "calc"
                    },
                    autotypenumbers: a.autotypenumbers,
                    autorange: {
                        valType: "enumerated",
                        values: [
                            !0,
                            !1,
                            "reversed"
                        ],
                        dflt: !0,
                        editType: "calc"
                    },
                    rangemode: {
                        valType: "enumerated",
                        values: [
                            "normal",
                            "tozero",
                            "nonnegative"
                        ],
                        dflt: "normal",
                        editType: "calc"
                    },
                    range: {
                        valType: "info_array",
                        editType: "calc",
                        items: [
                            {
                                valType: "any",
                                editType: "calc"
                            },
                            {
                                valType: "any",
                                editType: "calc"
                            }
                        ]
                    },
                    fixedrange: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "calc"
                    },
                    cheatertype: {
                        valType: "enumerated",
                        values: [
                            "index",
                            "value"
                        ],
                        dflt: "value",
                        editType: "calc"
                    },
                    tickmode: {
                        valType: "enumerated",
                        values: [
                            "linear",
                            "array"
                        ],
                        dflt: "array",
                        editType: "calc"
                    },
                    nticks: {
                        valType: "integer",
                        min: 0,
                        dflt: 0,
                        editType: "calc"
                    },
                    tickvals: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    ticktext: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    showticklabels: {
                        valType: "enumerated",
                        values: [
                            "start",
                            "end",
                            "both",
                            "none"
                        ],
                        dflt: "start",
                        editType: "calc"
                    },
                    labelalias: c({}, a.labelalias, {
                        editType: "calc"
                    }),
                    tickfont: n({
                        editType: "calc"
                    }),
                    tickangle: {
                        valType: "angle",
                        dflt: "auto",
                        editType: "calc"
                    },
                    tickprefix: {
                        valType: "string",
                        dflt: "",
                        editType: "calc"
                    },
                    showtickprefix: {
                        valType: "enumerated",
                        values: [
                            "all",
                            "first",
                            "last",
                            "none"
                        ],
                        dflt: "all",
                        editType: "calc"
                    },
                    ticksuffix: {
                        valType: "string",
                        dflt: "",
                        editType: "calc"
                    },
                    showticksuffix: {
                        valType: "enumerated",
                        values: [
                            "all",
                            "first",
                            "last",
                            "none"
                        ],
                        dflt: "all",
                        editType: "calc"
                    },
                    showexponent: {
                        valType: "enumerated",
                        values: [
                            "all",
                            "first",
                            "last",
                            "none"
                        ],
                        dflt: "all",
                        editType: "calc"
                    },
                    exponentformat: {
                        valType: "enumerated",
                        values: [
                            "none",
                            "e",
                            "E",
                            "power",
                            "SI",
                            "B"
                        ],
                        dflt: "B",
                        editType: "calc"
                    },
                    minexponent: {
                        valType: "number",
                        dflt: 3,
                        min: 0,
                        editType: "calc"
                    },
                    separatethousands: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "calc"
                    },
                    tickformat: {
                        valType: "string",
                        dflt: "",
                        editType: "calc",
                        description: o("tick label")
                    },
                    tickformatstops: s(a.tickformatstops, "calc", "from-root"),
                    categoryorder: {
                        valType: "enumerated",
                        values: [
                            "trace",
                            "category ascending",
                            "category descending",
                            "array"
                        ],
                        dflt: "trace",
                        editType: "calc"
                    },
                    categoryarray: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    labelpadding: {
                        valType: "integer",
                        dflt: 10,
                        editType: "calc"
                    },
                    labelprefix: {
                        valType: "string",
                        editType: "calc"
                    },
                    labelsuffix: {
                        valType: "string",
                        dflt: "",
                        editType: "calc"
                    },
                    showline: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "calc"
                    },
                    linecolor: {
                        valType: "color",
                        dflt: i.defaultLine,
                        editType: "calc"
                    },
                    linewidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        editType: "calc"
                    },
                    gridcolor: {
                        valType: "color",
                        editType: "calc"
                    },
                    gridwidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        editType: "calc"
                    },
                    griddash: c({}, l, {
                        editType: "calc"
                    }),
                    showgrid: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    },
                    minorgridcount: {
                        valType: "integer",
                        min: 0,
                        dflt: 0,
                        editType: "calc"
                    },
                    minorgridwidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        editType: "calc"
                    },
                    minorgriddash: c({}, l, {
                        editType: "calc"
                    }),
                    minorgridcolor: {
                        valType: "color",
                        dflt: i.lightLine,
                        editType: "calc"
                    },
                    startline: {
                        valType: "boolean",
                        editType: "calc"
                    },
                    startlinecolor: {
                        valType: "color",
                        editType: "calc"
                    },
                    startlinewidth: {
                        valType: "number",
                        dflt: 1,
                        editType: "calc"
                    },
                    endline: {
                        valType: "boolean",
                        editType: "calc"
                    },
                    endlinewidth: {
                        valType: "number",
                        dflt: 1,
                        editType: "calc"
                    },
                    endlinecolor: {
                        valType: "color",
                        editType: "calc"
                    },
                    tick0: {
                        valType: "number",
                        min: 0,
                        dflt: 0,
                        editType: "calc"
                    },
                    dtick: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        editType: "calc"
                    },
                    arraytick0: {
                        valType: "integer",
                        min: 0,
                        dflt: 0,
                        editType: "calc"
                    },
                    arraydtick: {
                        valType: "integer",
                        min: 1,
                        dflt: 1,
                        editType: "calc"
                    },
                    _deprecated: {
                        title: {
                            valType: "string",
                            editType: "calc"
                        },
                        titlefont: n({
                            editType: "calc"
                        }),
                        titleoffset: {
                            valType: "number",
                            dflt: 10,
                            editType: "calc"
                        }
                    },
                    editType: "calc"
                };
            },
            6038: function(t1, e1, r) {
                "use strict";
                var n = r(43745), i = r(78766).addOpacity, a = r(33626), o = r(34809), s = r(22777), l = r(12036), c = r(54616), u = r(46473), h = r(19091), f = r(9666);
                t1.exports = function(t1, e1, r) {
                    var p = r.letter, d = r.font || {}, m = n[p + "axis"];
                    function g(r, n) {
                        return o.coerce(t1, e1, m, r, n);
                    }
                    function y(r, n) {
                        return o.coerce2(t1, e1, m, r, n);
                    }
                    r.name && (e1._name = r.name, e1._id = r.name), g("autotypenumbers", r.autotypenumbersDflt);
                    var v = g("type");
                    "-" === v && (r.data && function(t1, e1) {
                        if ("-" === t1.type) {
                            var r = t1._id.charAt(0), n = t1[r + "calendar"];
                            t1.type = f(e1, n, {
                                autotypenumbers: t1.autotypenumbers
                            });
                        }
                    }(e1, r.data), "-" === e1.type ? e1.type = "linear" : v = t1.type = e1.type), g("smoothing"), g("cheatertype"), g("showticklabels"), g("labelprefix", p + " = "), g("labelsuffix"), g("showtickprefix"), g("showticksuffix"), g("separatethousands"), g("tickformat"), g("exponentformat"), g("minexponent"), g("showexponent"), g("categoryorder"), g("tickmode"), g("tickvals"), g("ticktext"), g("tick0"), g("dtick"), "array" === e1.tickmode && (g("arraytick0"), g("arraydtick")), g("labelpadding"), e1._hovertitle = p, "date" === v && a.getComponentMethod("calendars", "handleDefaults")(t1, e1, "calendar", r.calendar), h(e1, r.fullLayout), e1.c2p = o.identity;
                    var x = g("color", r.dfltColor), _ = x === t1.color ? x : d.color;
                    g("title.text") && (o.coerceFont(g, "title.font", d, {
                        overrideDflt: {
                            size: o.bigFont(d.size),
                            color: _
                        }
                    }), g("title.offset")), g("tickangle"), g("autorange", !e1.isValidRange(t1.range)) && g("rangemode"), g("range"), e1.cleanRange(), g("fixedrange"), s(t1, e1, g, v), c(t1, e1, g, v, r), l(t1, e1, g, v, r), u(t1, e1, g, {
                        data: r.data,
                        dataAttr: p
                    });
                    var b = y("gridcolor", i(x, .3)), w = y("gridwidth"), T = y("griddash"), k = g("showgrid");
                    k || (delete e1.gridcolor, delete e1.gridwidth, delete e1.griddash);
                    var A = y("startlinecolor", x), M = y("startlinewidth", w);
                    g("startline", e1.showgrid || !!A || !!M) || (delete e1.startlinecolor, delete e1.startlinewidth);
                    var S = y("endlinecolor", x), E = y("endlinewidth", w);
                    return g("endline", e1.showgrid || !!S || !!E) || (delete e1.endlinecolor, delete e1.endlinewidth), k ? (g("minorgridcount"), g("minorgridwidth", w), g("minorgriddash", T), g("minorgridcolor", i(b, .06)), e1.minorgridcount || (delete e1.minorgridwidth, delete e1.minorgriddash, delete e1.minorgridcolor)) : (delete e1.gridcolor, delete e1.gridwidth, delete e1.griddash), "none" === e1.showticklabels && (delete e1.tickfont, delete e1.tickangle, delete e1.showexponent, delete e1.exponentformat, delete e1.minexponent, delete e1.tickformat, delete e1.showticksuffix, delete e1.showtickprefix), e1.showticksuffix || delete e1.ticksuffix, e1.showtickprefix || delete e1.tickprefix, g("tickmode"), e1;
                };
            },
            67525: function(t1, e1, r) {
                "use strict";
                var n = r(29714), i = r(34809).isArray1D, a = r(89992), o = r(97052), s = r(4753), l = r(93923), c = r(39373), u = r(93877), h = r(13007), f = r(87869), p = r(76842);
                t1.exports = function(t1, e1) {
                    var r = n.getFromId(t1, e1.xaxis), d = n.getFromId(t1, e1.yaxis), m = e1.aaxis, g = e1.baxis, y = e1.x, v = e1.y, x = [];
                    y && i(y) && x.push("x"), v && i(v) && x.push("y"), x.length && f(e1, m, g, "a", "b", x);
                    var _ = e1._a = e1._a || e1.a, b = e1._b = e1._b || e1.b;
                    y = e1._x || e1.x, v = e1._y || e1.y;
                    var w = {};
                    if (e1._cheater) {
                        var T = "index" === m.cheatertype ? _.length : _, k = "index" === g.cheatertype ? b.length : b;
                        y = a(T, k, e1.cheaterslope);
                    }
                    e1._x = y = u(y), e1._y = v = u(v), h(y, _, b), h(v, _, b), p(e1), e1.setScale();
                    var A = o(y), M = o(v), S = .5 * (A[1] - A[0]), E = .5 * (A[1] + A[0]), C = .5 * (M[1] - M[0]), L = .5 * (M[1] + M[0]), I = 1.3;
                    return A = [
                        E - S * I,
                        E + S * I
                    ], M = [
                        L - C * I,
                        L + C * I
                    ], e1._extremes[r._id] = n.findExtremes(r, A, {
                        padded: !0
                    }), e1._extremes[d._id] = n.findExtremes(d, M, {
                        padded: !0
                    }), s(e1, "a", "b"), s(e1, "b", "a"), l(e1, m), l(e1, g), w.clipsegments = c(e1._xctrl, e1._yctrl, m, g), w.x = y, w.y = v, w.a = _, w.b = b, [
                        w
                    ];
                };
            },
            39373: function(t1) {
                "use strict";
                t1.exports = function(t1, e1, r, n) {
                    var i, a, o, s = [], l = !!r.smoothing, c = !!n.smoothing, u = t1[0].length - 1, h = t1.length - 1;
                    for(i = 0, a = [], o = []; i <= u; i++)a[i] = t1[0][i], o[i] = e1[0][i];
                    for(s.push({
                        x: a,
                        y: o,
                        bicubic: l
                    }), i = 0, a = [], o = []; i <= h; i++)a[i] = t1[i][u], o[i] = e1[i][u];
                    for(s.push({
                        x: a,
                        y: o,
                        bicubic: c
                    }), i = u, a = [], o = []; i >= 0; i--)a[u - i] = t1[h][i], o[u - i] = e1[h][i];
                    for(s.push({
                        x: a,
                        y: o,
                        bicubic: l
                    }), i = h, a = [], o = []; i >= 0; i--)a[h - i] = t1[i][0], o[h - i] = e1[i][0];
                    return s.push({
                        x: a,
                        y: o,
                        bicubic: c
                    }), s;
                };
            },
            4753: function(t1, e1, r) {
                "use strict";
                var n = r(29714), i = r(93049).extendFlat;
                t1.exports = function(t1, e1, r) {
                    var a, o, s, l, c, u, h, f, p, d, m, g, y, v, x = t1["_" + e1], _ = t1[e1 + "axis"], b = _._gridlines = [], w = _._minorgridlines = [], T = _._boundarylines = [], k = t1["_" + r], A = t1[r + "axis"];
                    "array" === _.tickmode && (_.tickvals = x.slice());
                    var M = t1._xctrl, S = t1._yctrl, E = M[0].length, C = M.length, L = t1._a.length, I = t1._b.length;
                    n.prepTicks(_), "array" === _.tickmode && delete _.tickvals;
                    var P = _.smoothing ? 3 : 1;
                    function z(n) {
                        var i, a, o, s, l, c, u, h, p, d, m, g, y = [], v = [], x = {};
                        if ("b" === e1) for(a = t1.b2j(n), o = Math.floor(Math.max(0, Math.min(I - 2, a))), s = a - o, x.length = I, x.crossLength = L, x.xy = function(e1) {
                            return t1.evalxy([], e1, a);
                        }, x.dxy = function(e1, r) {
                            return t1.dxydi([], e1, o, r, s);
                        }, i = 0; i < L; i++)c = Math.min(L - 2, i), u = i - c, h = t1.evalxy([], i, a), A.smoothing && i > 0 && (p = t1.dxydi([], i - 1, o, 0, s), y.push(l[0] + p[0] / 3), v.push(l[1] + p[1] / 3), d = t1.dxydi([], i - 1, o, 1, s), y.push(h[0] - d[0] / 3), v.push(h[1] - d[1] / 3)), y.push(h[0]), v.push(h[1]), l = h;
                        else for(i = t1.a2i(n), c = Math.floor(Math.max(0, Math.min(L - 2, i))), u = i - c, x.length = L, x.crossLength = I, x.xy = function(e1) {
                            return t1.evalxy([], i, e1);
                        }, x.dxy = function(e1, r) {
                            return t1.dxydj([], c, e1, u, r);
                        }, a = 0; a < I; a++)o = Math.min(I - 2, a), s = a - o, h = t1.evalxy([], i, a), A.smoothing && a > 0 && (m = t1.dxydj([], c, a - 1, u, 0), y.push(l[0] + m[0] / 3), v.push(l[1] + m[1] / 3), g = t1.dxydj([], c, a - 1, u, 1), y.push(h[0] - g[0] / 3), v.push(h[1] - g[1] / 3)), y.push(h[0]), v.push(h[1]), l = h;
                        return x.axisLetter = e1, x.axis = _, x.crossAxis = A, x.value = n, x.constvar = r, x.index = f, x.x = y, x.y = v, x.smoothing = A.smoothing, x;
                    }
                    function O(n) {
                        var i, a, o, s, l, c = [], u = [], h = {};
                        if (h.length = x.length, h.crossLength = k.length, "b" === e1) for(o = Math.max(0, Math.min(I - 2, n)), l = Math.min(1, Math.max(0, n - o)), h.xy = function(e1) {
                            return t1.evalxy([], e1, n);
                        }, h.dxy = function(e1, r) {
                            return t1.dxydi([], e1, o, r, l);
                        }, i = 0; i < E; i++)c[i] = M[n * P][i], u[i] = S[n * P][i];
                        else for(a = Math.max(0, Math.min(L - 2, n)), s = Math.min(1, Math.max(0, n - a)), h.xy = function(e1) {
                            return t1.evalxy([], n, e1);
                        }, h.dxy = function(e1, r) {
                            return t1.dxydj([], a, e1, s, r);
                        }, i = 0; i < C; i++)c[i] = M[i][n * P], u[i] = S[i][n * P];
                        return h.axisLetter = e1, h.axis = _, h.crossAxis = A, h.value = x[n], h.constvar = r, h.index = n, h.x = c, h.y = u, h.smoothing = A.smoothing, h;
                    }
                    if ("array" === _.tickmode) {
                        for(l = 5e-15, u = (c = [
                            Math.floor((x.length - 1 - _.arraytick0) / _.arraydtick * (1 + l)),
                            Math.ceil(-_.arraytick0 / _.arraydtick / (1 + l))
                        ].sort(function(t1, e1) {
                            return t1 - e1;
                        }))[0] - 1, h = c[1] + 1, f = u; f < h; f++)(o = _.arraytick0 + _.arraydtick * f) < 0 || o > x.length - 1 || b.push(i(O(o), {
                            color: _.gridcolor,
                            width: _.gridwidth,
                            dash: _.griddash
                        }));
                        for(f = u; f < h; f++)if (s = _.arraytick0 + _.arraydtick * f, m = Math.min(s + _.arraydtick, x.length - 1), !(s < 0 || s > x.length - 1 || m < 0 || m > x.length - 1)) for(g = x[s], y = x[m], a = 0; a < _.minorgridcount; a++)(v = m - s) <= 0 || (d = g + (y - g) * (a + 1) / (_.minorgridcount + 1) * (_.arraydtick / v)) < x[0] || d > x[x.length - 1] || w.push(i(z(d), {
                            color: _.minorgridcolor,
                            width: _.minorgridwidth,
                            dash: _.minorgriddash
                        }));
                        _.startline && T.push(i(O(0), {
                            color: _.startlinecolor,
                            width: _.startlinewidth
                        })), _.endline && T.push(i(O(x.length - 1), {
                            color: _.endlinecolor,
                            width: _.endlinewidth
                        }));
                    } else {
                        for(l = 5e-15, u = (c = [
                            Math.floor((x[x.length - 1] - _.tick0) / _.dtick * (1 + l)),
                            Math.ceil((x[0] - _.tick0) / _.dtick / (1 + l))
                        ].sort(function(t1, e1) {
                            return t1 - e1;
                        }))[0], h = c[1], f = u; f <= h; f++)p = _.tick0 + _.dtick * f, b.push(i(z(p), {
                            color: _.gridcolor,
                            width: _.gridwidth,
                            dash: _.griddash
                        }));
                        for(f = u - 1; f < h + 1; f++)for(p = _.tick0 + _.dtick * f, a = 0; a < _.minorgridcount; a++)(d = p + _.dtick * (a + 1) / (_.minorgridcount + 1)) < x[0] || d > x[x.length - 1] || w.push(i(z(d), {
                            color: _.minorgridcolor,
                            width: _.minorgridwidth,
                            dash: _.minorgriddash
                        }));
                        _.startline && T.push(i(z(x[0]), {
                            color: _.startlinecolor,
                            width: _.startlinewidth
                        })), _.endline && T.push(i(z(x[x.length - 1]), {
                            color: _.endlinecolor,
                            width: _.endlinewidth
                        }));
                    }
                };
            },
            93923: function(t1, e1, r) {
                "use strict";
                var n = r(29714), i = r(93049).extendFlat;
                t1.exports = function(t1, e1) {
                    var r, a, o, s = e1._labels = [], l = e1._gridlines;
                    for(r = 0; r < l.length; r++)o = l[r], -1 !== [
                        "start",
                        "both"
                    ].indexOf(e1.showticklabels) && (a = n.tickText(e1, o.value), i(a, {
                        prefix: void 0,
                        suffix: void 0,
                        endAnchor: !0,
                        xy: o.xy(0),
                        dxy: o.dxy(0, 0),
                        axis: o.axis,
                        length: o.crossAxis.length,
                        font: o.axis.tickfont,
                        isFirst: 0 === r,
                        isLast: r === l.length - 1
                    }), s.push(a)), -1 !== [
                        "end",
                        "both"
                    ].indexOf(e1.showticklabels) && (a = n.tickText(e1, o.value), i(a, {
                        endAnchor: !1,
                        xy: o.xy(o.crossLength - 1),
                        dxy: o.dxy(o.crossLength - 2, 1),
                        axis: o.axis,
                        length: o.crossAxis.length,
                        font: o.axis.tickfont,
                        isFirst: 0 === r,
                        isLast: r === l.length - 1
                    }), s.push(a));
                };
            },
            49109: function(t1) {
                "use strict";
                t1.exports = function(t1, e1, r, n) {
                    var i = t1[0] - e1[0], a = t1[1] - e1[1], o = r[0] - e1[0], s = r[1] - e1[1], l = Math.pow(i * i + a * a, .25), c = Math.pow(o * o + s * s, .25), u = (c * c * i - l * l * o) * n, h = (c * c * a - l * l * s) * n, f = c * (l + c) * 3, p = l * (l + c) * 3;
                    return [
                        [
                            e1[0] + (f && u / f),
                            e1[1] + (f && h / f)
                        ],
                        [
                            e1[0] - (p && u / p),
                            e1[1] - (p && h / p)
                        ]
                    ];
                };
            },
            89992: function(t1, e1, r) {
                "use strict";
                var n = r(34809).isArrayOrTypedArray;
                t1.exports = function(t1, e1, r) {
                    var i, a, o, s, l, c, u = [], h = n(t1) ? t1.length : t1, f = n(e1) ? e1.length : e1, p = n(t1) ? t1 : null, d = n(e1) ? e1 : null;
                    p && (o = (p.length - 1) / (p[p.length - 1] - p[0]) / (h - 1)), d && (s = (d.length - 1) / (d[d.length - 1] - d[0]) / (f - 1));
                    var m = 1 / 0, g = -1 / 0;
                    for(a = 0; a < f; a++)for(u[a] = [], l = d ? (d[a] - d[0]) * s : a / (f - 1), i = 0; i < h; i++)c = (p ? (p[i] - p[0]) * o : i / (h - 1)) - l * r, m = Math.min(c, m), g = Math.max(c, g), u[a][i] = c;
                    var y = 1 / (g - m), v = -m * y;
                    for(a = 0; a < f; a++)for(i = 0; i < h; i++)u[a][i] = y * u[a][i] + v;
                    return u;
                };
            },
            57075: function(t1, e1, r) {
                "use strict";
                var n = r(49109), i = r(34809).ensureArray;
                function a(t1, e1, r) {
                    var n = -0.5 * r[0] + 1.5 * e1[0], i = -0.5 * r[1] + 1.5 * e1[1];
                    return [
                        (2 * n + t1[0]) / 3,
                        (2 * i + t1[1]) / 3
                    ];
                }
                t1.exports = function(t1, e1, r, o, s, l) {
                    var c, u, h, f, p, d, m, g, y, v, x = r[0].length, _ = r.length, b = s ? 3 * x - 2 : x, w = l ? 3 * _ - 2 : _;
                    for(t1 = i(t1, w), e1 = i(e1, w), h = 0; h < w; h++)t1[h] = i(t1[h], b), e1[h] = i(e1[h], b);
                    for(u = 0, f = 0; u < _; u++, f += l ? 3 : 1)for(p = t1[f], d = e1[f], m = r[u], g = o[u], c = 0, h = 0; c < x; c++, h += s ? 3 : 1)p[h] = m[c], d[h] = g[c];
                    if (s) for(u = 0, f = 0; u < _; u++, f += l ? 3 : 1){
                        for(c = 1, h = 3; c < x - 1; c++, h += 3)y = n([
                            r[u][c - 1],
                            o[u][c - 1]
                        ], [
                            r[u][c],
                            o[u][c]
                        ], [
                            r[u][c + 1],
                            o[u][c + 1]
                        ], s), t1[f][h - 1] = y[0][0], e1[f][h - 1] = y[0][1], t1[f][h + 1] = y[1][0], e1[f][h + 1] = y[1][1];
                        v = a([
                            t1[f][0],
                            e1[f][0]
                        ], [
                            t1[f][2],
                            e1[f][2]
                        ], [
                            t1[f][3],
                            e1[f][3]
                        ]), t1[f][1] = v[0], e1[f][1] = v[1], v = a([
                            t1[f][b - 1],
                            e1[f][b - 1]
                        ], [
                            t1[f][b - 3],
                            e1[f][b - 3]
                        ], [
                            t1[f][b - 4],
                            e1[f][b - 4]
                        ]), t1[f][b - 2] = v[0], e1[f][b - 2] = v[1];
                    }
                    if (l) for(h = 0; h < b; h++){
                        for(f = 3; f < w - 3; f += 3)y = n([
                            t1[f - 3][h],
                            e1[f - 3][h]
                        ], [
                            t1[f][h],
                            e1[f][h]
                        ], [
                            t1[f + 3][h],
                            e1[f + 3][h]
                        ], l), t1[f - 1][h] = y[0][0], e1[f - 1][h] = y[0][1], t1[f + 1][h] = y[1][0], e1[f + 1][h] = y[1][1];
                        v = a([
                            t1[0][h],
                            e1[0][h]
                        ], [
                            t1[2][h],
                            e1[2][h]
                        ], [
                            t1[3][h],
                            e1[3][h]
                        ]), t1[1][h] = v[0], e1[1][h] = v[1], v = a([
                            t1[w - 1][h],
                            e1[w - 1][h]
                        ], [
                            t1[w - 3][h],
                            e1[w - 3][h]
                        ], [
                            t1[w - 4][h],
                            e1[w - 4][h]
                        ]), t1[w - 2][h] = v[0], e1[w - 2][h] = v[1];
                    }
                    if (s && l) for(f = 1; f < w; f += (f + 1) % 3 == 0 ? 2 : 1){
                        for(h = 3; h < b - 3; h += 3)y = n([
                            t1[f][h - 3],
                            e1[f][h - 3]
                        ], [
                            t1[f][h],
                            e1[f][h]
                        ], [
                            t1[f][h + 3],
                            e1[f][h + 3]
                        ], s), t1[f][h - 1] = .5 * (t1[f][h - 1] + y[0][0]), e1[f][h - 1] = .5 * (e1[f][h - 1] + y[0][1]), t1[f][h + 1] = .5 * (t1[f][h + 1] + y[1][0]), e1[f][h + 1] = .5 * (e1[f][h + 1] + y[1][1]);
                        v = a([
                            t1[f][0],
                            e1[f][0]
                        ], [
                            t1[f][2],
                            e1[f][2]
                        ], [
                            t1[f][3],
                            e1[f][3]
                        ]), t1[f][1] = .5 * (t1[f][1] + v[0]), e1[f][1] = .5 * (e1[f][1] + v[1]), v = a([
                            t1[f][b - 1],
                            e1[f][b - 1]
                        ], [
                            t1[f][b - 3],
                            e1[f][b - 3]
                        ], [
                            t1[f][b - 4],
                            e1[f][b - 4]
                        ]), t1[f][b - 2] = .5 * (t1[f][b - 2] + v[0]), e1[f][b - 2] = .5 * (e1[f][b - 2] + v[1]);
                    }
                    return [
                        t1,
                        e1
                    ];
                };
            },
            45923: function(t1) {
                "use strict";
                t1.exports = {
                    RELATIVE_CULL_TOLERANCE: 1e-6
                };
            },
            39848: function(t1) {
                "use strict";
                t1.exports = function(t1, e1, r) {
                    return e1 && r ? function(e1, r, n, i, a) {
                        var o, s, l, c, u, h;
                        e1 || (e1 = []), r *= 3, n *= 3;
                        var f = i * i, p = 1 - i, d = p * p, m = p * i * 2, g = -3 * d, y = 3 * (d - m), v = 3 * (m - f), x = 3 * f, _ = a * a, b = _ * a, w = 1 - a, T = w * w, k = T * w;
                        for(h = 0; h < t1.length; h++)o = g * (u = t1[h])[n][r] + y * u[n][r + 1] + v * u[n][r + 2] + x * u[n][r + 3], s = g * u[n + 1][r] + y * u[n + 1][r + 1] + v * u[n + 1][r + 2] + x * u[n + 1][r + 3], l = g * u[n + 2][r] + y * u[n + 2][r + 1] + v * u[n + 2][r + 2] + x * u[n + 2][r + 3], c = g * u[n + 3][r] + y * u[n + 3][r + 1] + v * u[n + 3][r + 2] + x * u[n + 3][r + 3], e1[h] = k * o + 3 * (T * a * s + w * _ * l) + b * c;
                        return e1;
                    } : e1 ? function(e1, r, n, i, a) {
                        var o, s, l, c;
                        e1 || (e1 = []), r *= 3;
                        var u = i * i, h = 1 - i, f = h * h, p = h * i * 2, d = -3 * f, m = 3 * (f - p), g = 3 * (p - u), y = 3 * u, v = 1 - a;
                        for(l = 0; l < t1.length; l++)o = d * (c = t1[l])[n][r] + m * c[n][r + 1] + g * c[n][r + 2] + y * c[n][r + 3], s = d * c[n + 1][r] + m * c[n + 1][r + 1] + g * c[n + 1][r + 2] + y * c[n + 1][r + 3], e1[l] = v * o + a * s;
                        return e1;
                    } : r ? function(e1, r, n, i, a) {
                        var o, s, l, c, u, h;
                        e1 || (e1 = []), n *= 3;
                        var f = a * a, p = f * a, d = 1 - a, m = d * d, g = m * d;
                        for(u = 0; u < t1.length; u++)o = (h = t1[u])[n][r + 1] - h[n][r], s = h[n + 1][r + 1] - h[n + 1][r], l = h[n + 2][r + 1] - h[n + 2][r], c = h[n + 3][r + 1] - h[n + 3][r], e1[u] = g * o + 3 * (m * a * s + d * f * l) + p * c;
                        return e1;
                    } : function(e1, r, n, i, a) {
                        var o, s, l, c;
                        e1 || (e1 = []);
                        var u = 1 - a;
                        for(l = 0; l < t1.length; l++)o = (c = t1[l])[n][r + 1] - c[n][r], s = c[n + 1][r + 1] - c[n + 1][r], e1[l] = u * o + a * s;
                        return e1;
                    };
                };
            },
            41839: function(t1) {
                "use strict";
                t1.exports = function(t1, e1, r) {
                    return e1 && r ? function(e1, r, n, i, a) {
                        var o, s, l, c, u, h;
                        e1 || (e1 = []), r *= 3, n *= 3;
                        var f = i * i, p = f * i, d = 1 - i, m = d * d, g = m * d, y = a * a, v = 1 - a, x = v * v, _ = v * a * 2, b = -3 * x, w = 3 * (x - _), T = 3 * (_ - y), k = 3 * y;
                        for(h = 0; h < t1.length; h++)o = b * (u = t1[h])[n][r] + w * u[n + 1][r] + T * u[n + 2][r] + k * u[n + 3][r], s = b * u[n][r + 1] + w * u[n + 1][r + 1] + T * u[n + 2][r + 1] + k * u[n + 3][r + 1], l = b * u[n][r + 2] + w * u[n + 1][r + 2] + T * u[n + 2][r + 2] + k * u[n + 3][r + 2], c = b * u[n][r + 3] + w * u[n + 1][r + 3] + T * u[n + 2][r + 3] + k * u[n + 3][r + 3], e1[h] = g * o + 3 * (m * i * s + d * f * l) + p * c;
                        return e1;
                    } : e1 ? function(e1, r, n, i, a) {
                        var o, s, l, c, u, h;
                        e1 || (e1 = []), r *= 3;
                        var f = a * a, p = f * a, d = 1 - a, m = d * d, g = m * d;
                        for(u = 0; u < t1.length; u++)o = (h = t1[u])[n + 1][r] - h[n][r], s = h[n + 1][r + 1] - h[n][r + 1], l = h[n + 1][r + 2] - h[n][r + 2], c = h[n + 1][r + 3] - h[n][r + 3], e1[u] = g * o + 3 * (m * a * s + d * f * l) + p * c;
                        return e1;
                    } : r ? function(e1, r, n, i, a) {
                        var o, s, l, c;
                        e1 || (e1 = []), n *= 3;
                        var u = 1 - i, h = a * a, f = 1 - a, p = f * f, d = f * a * 2, m = -3 * p, g = 3 * (p - d), y = 3 * (d - h), v = 3 * h;
                        for(l = 0; l < t1.length; l++)o = m * (c = t1[l])[n][r] + g * c[n + 1][r] + y * c[n + 2][r] + v * c[n + 3][r], s = m * c[n][r + 1] + g * c[n + 1][r + 1] + y * c[n + 2][r + 1] + v * c[n + 3][r + 1], e1[l] = u * o + i * s;
                        return e1;
                    } : function(e1, r, n, i, a) {
                        var o, s, l, c;
                        e1 || (e1 = []);
                        var u = 1 - i;
                        for(l = 0; l < t1.length; l++)o = (c = t1[l])[n + 1][r] - c[n][r], s = c[n + 1][r + 1] - c[n][r + 1], e1[l] = u * o + i * s;
                        return e1;
                    };
                };
            },
            13828: function(t1) {
                "use strict";
                t1.exports = function(t1, e1, r, n, i) {
                    var a = e1 - 2, o = r - 2;
                    return n && i ? function(e1, r, n) {
                        var i, s, l, c, u, h;
                        e1 || (e1 = []);
                        var f = Math.max(0, Math.min(Math.floor(r), a)), p = Math.max(0, Math.min(Math.floor(n), o)), d = Math.max(0, Math.min(1, r - f)), m = Math.max(0, Math.min(1, n - p));
                        f *= 3, p *= 3;
                        var g = d * d, y = g * d, v = 1 - d, x = v * v, _ = x * v, b = m * m, w = b * m, T = 1 - m, k = T * T, A = k * T;
                        for(h = 0; h < t1.length; h++)i = _ * (u = t1[h])[p][f] + 3 * (x * d * u[p][f + 1] + v * g * u[p][f + 2]) + y * u[p][f + 3], s = _ * u[p + 1][f] + 3 * (x * d * u[p + 1][f + 1] + v * g * u[p + 1][f + 2]) + y * u[p + 1][f + 3], l = _ * u[p + 2][f] + 3 * (x * d * u[p + 2][f + 1] + v * g * u[p + 2][f + 2]) + y * u[p + 2][f + 3], c = _ * u[p + 3][f] + 3 * (x * d * u[p + 3][f + 1] + v * g * u[p + 3][f + 2]) + y * u[p + 3][f + 3], e1[h] = A * i + 3 * (k * m * s + T * b * l) + w * c;
                        return e1;
                    } : n ? function(e1, r, n) {
                        e1 || (e1 = []);
                        var i, s, l, c, u, h, f = Math.max(0, Math.min(Math.floor(r), a)), p = Math.max(0, Math.min(Math.floor(n), o)), d = Math.max(0, Math.min(1, r - f)), m = Math.max(0, Math.min(1, n - p));
                        f *= 3;
                        var g = d * d, y = g * d, v = 1 - d, x = v * v, _ = x * v, b = 1 - m;
                        for(u = 0; u < t1.length; u++)i = b * (h = t1[u])[p][f] + m * h[p + 1][f], s = b * h[p][f + 1] + m * h[p + 1][f + 1], l = b * h[p][f + 2] + m * h[p + 1][f + 1], c = b * h[p][f + 3] + m * h[p + 1][f + 1], e1[u] = _ * i + 3 * (x * d * s + v * g * l) + y * c;
                        return e1;
                    } : i ? function(e1, r, n) {
                        e1 || (e1 = []);
                        var i, s, l, c, u, h, f = Math.max(0, Math.min(Math.floor(r), a)), p = Math.max(0, Math.min(Math.floor(n), o)), d = Math.max(0, Math.min(1, r - f)), m = Math.max(0, Math.min(1, n - p));
                        p *= 3;
                        var g = m * m, y = g * m, v = 1 - m, x = v * v, _ = x * v, b = 1 - d;
                        for(u = 0; u < t1.length; u++)i = b * (h = t1[u])[p][f] + d * h[p][f + 1], s = b * h[p + 1][f] + d * h[p + 1][f + 1], l = b * h[p + 2][f] + d * h[p + 2][f + 1], c = b * h[p + 3][f] + d * h[p + 3][f + 1], e1[u] = _ * i + 3 * (x * m * s + v * g * l) + y * c;
                        return e1;
                    } : function(e1, r, n) {
                        e1 || (e1 = []);
                        var i, s, l, c, u = Math.max(0, Math.min(Math.floor(r), a)), h = Math.max(0, Math.min(Math.floor(n), o)), f = Math.max(0, Math.min(1, r - u)), p = Math.max(0, Math.min(1, n - h)), d = 1 - p, m = 1 - f;
                        for(l = 0; l < t1.length; l++)i = m * (c = t1[l])[h][u] + f * c[h][u + 1], s = m * c[h + 1][u] + f * c[h + 1][u + 1], e1[l] = d * i + p * s;
                        return e1;
                    };
                };
            },
            13254: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(10820), a = r(8432), o = r(43745), s = r(10229);
                t1.exports = function(t1, e1, r, l) {
                    function c(r, i) {
                        return n.coerce(t1, e1, o, r, i);
                    }
                    e1._clipPathId = "clip" + e1.uid + "carpet";
                    var u = c("color", s.defaultLine);
                    n.coerceFont(c, "font", l.font), c("carpet"), a(t1, e1, l, c, u), e1.a && e1.b ? (e1.a.length < 3 && (e1.aaxis.smoothing = 0), e1.b.length < 3 && (e1.baxis.smoothing = 0), i(t1, e1, c) || (e1.visible = !1), e1._cheater && c("cheaterslope"), c("zorder")) : e1.visible = !1;
                };
            },
            48050: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    attributes: r(43745),
                    supplyDefaults: r(13254),
                    plot: r(87947),
                    calc: r(67525),
                    animatable: !0,
                    isContainer: !0,
                    moduleType: "trace",
                    name: "carpet",
                    basePlotModule: r(37703),
                    categories: [
                        "cartesian",
                        "svg",
                        "carpet",
                        "carpetAxis",
                        "notLegendIsolatable",
                        "noMultiCategory",
                        "noHover",
                        "noSortingByValue"
                    ],
                    meta: {}
                };
            },
            26571: function(t1) {
                "use strict";
                t1.exports = function(t1, e1) {
                    for(var r, n = t1._fullData.length, i = 0; i < n; i++){
                        var a = t1._fullData[i];
                        if (a.index !== e1.index && "carpet" === a.type && (r || (r = a), a.carpet === e1.carpet)) return a;
                    }
                    return r;
                };
            },
            3685: function(t1) {
                "use strict";
                t1.exports = function(t1, e1, r) {
                    if (0 === t1.length) return "";
                    var n, i = [], a = r ? 3 : 1;
                    for(n = 0; n < t1.length; n += a)i.push(t1[n] + "," + e1[n]), r && n < t1.length - a && (i.push("C"), i.push([
                        t1[n + 1] + "," + e1[n + 1],
                        t1[n + 2] + "," + e1[n + 2] + " "
                    ].join(" ")));
                    return i.join(r ? "" : "L");
                };
            },
            6720: function(t1, e1, r) {
                "use strict";
                var n = r(34809).isArrayOrTypedArray;
                t1.exports = function(t1, e1, r) {
                    var i;
                    for(n(t1) ? t1.length > e1.length && (t1 = t1.slice(0, e1.length)) : t1 = [], i = 0; i < e1.length; i++)t1[i] = r(e1[i]);
                    return t1;
                };
            },
            33163: function(t1) {
                "use strict";
                t1.exports = function(t1, e1, r, n, i, a) {
                    var o = i[0] * t1.dpdx(e1), s = i[1] * t1.dpdy(r), l = 1, c = 1;
                    if (a) {
                        var u = Math.sqrt(i[0] * i[0] + i[1] * i[1]), h = Math.sqrt(a[0] * a[0] + a[1] * a[1]), f = (i[0] * a[0] + i[1] * a[1]) / u / h;
                        c = Math.max(0, f);
                    }
                    var p = 180 * Math.atan2(s, o) / Math.PI;
                    return p < -90 ? (p += 180, l = -l) : p > 90 && (p -= 180, l = -l), {
                        angle: p,
                        flip: l,
                        p: t1.c2p(n, e1, r),
                        offsetMultplier: c
                    };
                };
            },
            87947: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(62203), a = r(6720), o = r(3685), s = r(33163), l = r(30635), c = r(34809), u = c.strRotate, h = c.strTranslate, f = r(4530);
                function p(t1, e1, r, s, l, c, u) {
                    var h = "const-" + l + "-lines", f = r.selectAll("." + h).data(c);
                    f.enter().append("path").classed(h, !0).style("vector-effect", u ? "none" : "non-scaling-stroke"), f.each(function(r) {
                        var s = r, l = s.x, c = s.y, u = a([], l, t1.c2p), h = a([], c, e1.c2p), f = "M" + o(u, h, s.smoothing);
                        n.select(this).attr("d", f).style("stroke-width", s.width).style("stroke", s.color).style("stroke-dasharray", i.dashStyle(s.dash, s.width)).style("fill", "none");
                    }), f.exit().remove();
                }
                function d(t1, e1, r, a, o, c, f, p) {
                    var d = c.selectAll("text." + p).data(f);
                    d.enter().append("text").classed(p, !0);
                    var m = 0, g = {};
                    return d.each(function(o, c) {
                        var f;
                        if ("auto" === o.axis.tickangle) f = s(a, e1, r, o.xy, o.dxy);
                        else {
                            var p = (o.axis.tickangle + 180) * Math.PI / 180;
                            f = s(a, e1, r, o.xy, [
                                Math.cos(p),
                                Math.sin(p)
                            ]);
                        }
                        c || (g = {
                            angle: f.angle,
                            flip: f.flip
                        });
                        var d = (o.endAnchor ? -1 : 1) * f.flip, y = n.select(this).attr({
                            "text-anchor": d > 0 ? "start" : "end",
                            "data-notex": 1
                        }).call(i.font, o.font).text(o.text).call(l.convertToTspans, t1), v = i.bBox(this);
                        y.attr("transform", h(f.p[0], f.p[1]) + u(f.angle) + h(o.axis.labelpadding * d, .3 * v.height)), m = Math.max(m, v.width + o.axis.labelpadding);
                    }), d.exit().remove(), g.maxExtent = m, g;
                }
                t1.exports = function(t1, e1, r, i) {
                    var l = t1._context.staticPlot, u = e1.xaxis, h = e1.yaxis, f = t1._fullLayout._clips;
                    c.makeTraceGroups(i, r, "trace").each(function(e1) {
                        var r = n.select(this), i = e1[0], m = i.trace, g = m.aaxis, v = m.baxis, x = c.ensureSingle(r, "g", "minorlayer"), _ = c.ensureSingle(r, "g", "majorlayer"), b = c.ensureSingle(r, "g", "boundarylayer"), w = c.ensureSingle(r, "g", "labellayer");
                        r.style("opacity", m.opacity), p(u, h, _, 0, "a", g._gridlines, !0), p(u, h, _, 0, "b", v._gridlines, !0), p(u, h, x, 0, "a", g._minorgridlines, !0), p(u, h, x, 0, "b", v._minorgridlines, !0), p(u, h, b, 0, "a-boundary", g._boundarylines, l), p(u, h, b, 0, "b-boundary", v._boundarylines, l);
                        var T = d(t1, u, h, m, 0, w, g._labels, "a-label"), k = d(t1, u, h, m, 0, w, v._labels, "b-label");
                        !function(t1, e1, r, n, i, a, o, l) {
                            var u, h, f, p, d = c.aggNums(Math.min, null, r.a), m = c.aggNums(Math.max, null, r.a), g = c.aggNums(Math.min, null, r.b), v = c.aggNums(Math.max, null, r.b);
                            u = .5 * (d + m), h = g, f = r.ab2xy(u, h, !0), p = r.dxyda_rough(u, h), void 0 === o.angle && c.extendFlat(o, s(r, i, a, f, r.dxydb_rough(u, h))), y(t1, e1, r, 0, f, p, r.aaxis, i, a, o, "a-title"), u = d, h = .5 * (g + v), f = r.ab2xy(u, h, !0), p = r.dxydb_rough(u, h), void 0 === l.angle && c.extendFlat(l, s(r, i, a, f, r.dxyda_rough(u, h))), y(t1, e1, r, 0, f, p, r.baxis, i, a, l, "b-title");
                        }(t1, w, m, 0, u, h, T, k), function(t1, e1, r, n, i) {
                            var s, l, u, h, f = r.select("#" + t1._clipPathId);
                            f.size() || (f = r.append("clipPath").classed("carpetclip", !0));
                            var p = c.ensureSingle(f, "path", "carpetboundary"), d = e1.clipsegments, m = [];
                            for(h = 0; h < d.length; h++)s = d[h], l = a([], s.x, n.c2p), u = a([], s.y, i.c2p), m.push(o(l, u, s.bicubic));
                            var g = "M" + m.join("L") + "Z";
                            f.attr("id", t1._clipPathId), p.attr("d", g);
                        }(m, i, f, u, h);
                    });
                };
                var m = f.LINE_SPACING, g = (1 - f.MID_SHIFT) / m + 1;
                function y(t1, e1, r, a, o, c, f, p, d, y, v) {
                    var x = [];
                    f.title.text && x.push(f.title.text);
                    var _ = e1.selectAll("text." + v).data(x), b = y.maxExtent;
                    _.enter().append("text").classed(v, !0), _.each(function() {
                        var e1 = s(r, p, d, o, c);
                        -1 === [
                            "start",
                            "both"
                        ].indexOf(f.showticklabels) && (b = 0);
                        var a = f.title.font.size;
                        b += a + f.title.offset;
                        var v = (y.angle + (y.flip < 0 ? 180 : 0) - e1.angle + 450) % 360, x = v > 90 && v < 270, _ = n.select(this);
                        _.text(f.title.text).call(l.convertToTspans, t1), x && (b = (-l.lineCount(_) + g) * m * a - b), _.attr("transform", h(e1.p[0], e1.p[1]) + u(e1.angle) + h(0, b)).attr("text-anchor", "middle").call(i.font, f.title.font);
                    }), _.exit().remove();
                }
            },
            76842: function(t1, e1, r) {
                "use strict";
                var n = r(45923), i = r(98813).findBin, a = r(57075), o = r(13828), s = r(39848), l = r(41839);
                t1.exports = function(t1) {
                    var e1 = t1._a, r = t1._b, c = e1.length, u = r.length, h = t1.aaxis, f = t1.baxis, p = e1[0], d = e1[c - 1], m = r[0], g = r[u - 1], y = e1[e1.length - 1] - e1[0], v = r[r.length - 1] - r[0], x = y * n.RELATIVE_CULL_TOLERANCE, _ = v * n.RELATIVE_CULL_TOLERANCE;
                    p -= x, d += x, m -= _, g += _, t1.isVisible = function(t1, e1) {
                        return t1 > p && t1 < d && e1 > m && e1 < g;
                    }, t1.isOccluded = function(t1, e1) {
                        return t1 < p || t1 > d || e1 < m || e1 > g;
                    }, t1.setScale = function() {
                        var e1 = t1._x, r = t1._y, n = a(t1._xctrl, t1._yctrl, e1, r, h.smoothing, f.smoothing);
                        t1._xctrl = n[0], t1._yctrl = n[1], t1.evalxy = o([
                            t1._xctrl,
                            t1._yctrl
                        ], c, u, h.smoothing, f.smoothing), t1.dxydi = s([
                            t1._xctrl,
                            t1._yctrl
                        ], h.smoothing, f.smoothing), t1.dxydj = l([
                            t1._xctrl,
                            t1._yctrl
                        ], h.smoothing, f.smoothing);
                    }, t1.i2a = function(t1) {
                        var r = Math.max(0, Math.floor(t1[0]), c - 2), n = t1[0] - r;
                        return (1 - n) * e1[r] + n * e1[r + 1];
                    }, t1.j2b = function(t1) {
                        var e1 = Math.max(0, Math.floor(t1[1]), c - 2), n = t1[1] - e1;
                        return (1 - n) * r[e1] + n * r[e1 + 1];
                    }, t1.ij2ab = function(e1) {
                        return [
                            t1.i2a(e1[0]),
                            t1.j2b(e1[1])
                        ];
                    }, t1.a2i = function(t1) {
                        var r = Math.max(0, Math.min(i(t1, e1), c - 2)), n = e1[r], a = e1[r + 1];
                        return Math.max(0, Math.min(c - 1, r + (t1 - n) / (a - n)));
                    }, t1.b2j = function(t1) {
                        var e1 = Math.max(0, Math.min(i(t1, r), u - 2)), n = r[e1], a = r[e1 + 1];
                        return Math.max(0, Math.min(u - 1, e1 + (t1 - n) / (a - n)));
                    }, t1.ab2ij = function(e1) {
                        return [
                            t1.a2i(e1[0]),
                            t1.b2j(e1[1])
                        ];
                    }, t1.i2c = function(e1, r) {
                        return t1.evalxy([], e1, r);
                    }, t1.ab2xy = function(n, i, a) {
                        if (!a && (n < e1[0] || n > e1[c - 1] | i < r[0] || i > r[u - 1])) return [
                            !1,
                            !1
                        ];
                        var o = t1.a2i(n), s = t1.b2j(i), l = t1.evalxy([], o, s);
                        if (a) {
                            var h, f, p, d, m = 0, g = 0, y = [];
                            n < e1[0] ? (h = 0, f = 0, m = (n - e1[0]) / (e1[1] - e1[0])) : n > e1[c - 1] ? (h = c - 2, f = 1, m = (n - e1[c - 1]) / (e1[c - 1] - e1[c - 2])) : f = o - (h = Math.max(0, Math.min(c - 2, Math.floor(o)))), i < r[0] ? (p = 0, d = 0, g = (i - r[0]) / (r[1] - r[0])) : i > r[u - 1] ? (p = u - 2, d = 1, g = (i - r[u - 1]) / (r[u - 1] - r[u - 2])) : d = s - (p = Math.max(0, Math.min(u - 2, Math.floor(s)))), m && (t1.dxydi(y, h, p, f, d), l[0] += y[0] * m, l[1] += y[1] * m), g && (t1.dxydj(y, h, p, f, d), l[0] += y[0] * g, l[1] += y[1] * g);
                        }
                        return l;
                    }, t1.c2p = function(t1, e1, r) {
                        return [
                            e1.c2p(t1[0]),
                            r.c2p(t1[1])
                        ];
                    }, t1.p2x = function(t1, e1, r) {
                        return [
                            e1.p2c(t1[0]),
                            r.p2c(t1[1])
                        ];
                    }, t1.dadi = function(t1) {
                        var r = Math.max(0, Math.min(e1.length - 2, t1));
                        return e1[r + 1] - e1[r];
                    }, t1.dbdj = function(t1) {
                        var e1 = Math.max(0, Math.min(r.length - 2, t1));
                        return r[e1 + 1] - r[e1];
                    }, t1.dxyda = function(e1, r, n, i) {
                        var a = t1.dxydi(null, e1, r, n, i), o = t1.dadi(e1, n);
                        return [
                            a[0] / o,
                            a[1] / o
                        ];
                    }, t1.dxydb = function(e1, r, n, i) {
                        var a = t1.dxydj(null, e1, r, n, i), o = t1.dbdj(r, i);
                        return [
                            a[0] / o,
                            a[1] / o
                        ];
                    }, t1.dxyda_rough = function(e1, r, n) {
                        var i = y * (n || .1), a = t1.ab2xy(e1 + i, r, !0), o = t1.ab2xy(e1 - i, r, !0);
                        return [
                            .5 * (a[0] - o[0]) / i,
                            .5 * (a[1] - o[1]) / i
                        ];
                    }, t1.dxydb_rough = function(e1, r, n) {
                        var i = v * (n || .1), a = t1.ab2xy(e1, r + i, !0), o = t1.ab2xy(e1, r - i, !0);
                        return [
                            .5 * (a[0] - o[0]) / i,
                            .5 * (a[1] - o[1]) / i
                        ];
                    }, t1.dpdx = function(t1) {
                        return t1._m;
                    }, t1.dpdy = function(t1) {
                        return t1._m;
                    };
                };
            },
            13007: function(t1, e1, r) {
                "use strict";
                var n = r(34809);
                t1.exports = function(t1, e1, r) {
                    var i, a, o, s = [], l = [], c = t1[0].length, u = t1.length;
                    function h(e1, r) {
                        var n, i = 0, a = 0;
                        return e1 > 0 && void 0 !== (n = t1[r][e1 - 1]) && (a++, i += n), e1 < c - 1 && void 0 !== (n = t1[r][e1 + 1]) && (a++, i += n), r > 0 && void 0 !== (n = t1[r - 1][e1]) && (a++, i += n), r < u - 1 && void 0 !== (n = t1[r + 1][e1]) && (a++, i += n), i / Math.max(1, a);
                    }
                    var f, p, d, m, g, y, v, x, _, b, w, T = 0;
                    for(i = 0; i < c; i++)for(a = 0; a < u; a++)void 0 === t1[a][i] && (s.push(i), l.push(a), t1[a][i] = h(i, a)), T = Math.max(T, Math.abs(t1[a][i]));
                    if (!s.length) return t1;
                    var k = 0, A = 0, M = s.length;
                    do {
                        for(k = 0, o = 0; o < M; o++){
                            i = s[o], a = l[o];
                            var S, E, C, L, I, P, z = 0, O = 0;
                            0 === i ? (C = e1[I = Math.min(c - 1, 2)], L = e1[1], S = t1[a][I], O += (E = t1[a][1]) + (E - S) * (e1[0] - L) / (L - C), z++) : i === c - 1 && (C = e1[I = Math.max(0, c - 3)], L = e1[c - 2], S = t1[a][I], O += (E = t1[a][c - 2]) + (E - S) * (e1[c - 1] - L) / (L - C), z++), (0 === i || i === c - 1) && a > 0 && a < u - 1 && (f = r[a + 1] - r[a], O += ((p = r[a] - r[a - 1]) * t1[a + 1][i] + f * t1[a - 1][i]) / (p + f), z++), 0 === a ? (C = r[P = Math.min(u - 1, 2)], L = r[1], S = t1[P][i], O += (E = t1[1][i]) + (E - S) * (r[0] - L) / (L - C), z++) : a === u - 1 && (C = r[P = Math.max(0, u - 3)], L = r[u - 2], S = t1[P][i], O += (E = t1[u - 2][i]) + (E - S) * (r[u - 1] - L) / (L - C), z++), (0 === a || a === u - 1) && i > 0 && i < c - 1 && (f = e1[i + 1] - e1[i], O += ((p = e1[i] - e1[i - 1]) * t1[a][i + 1] + f * t1[a][i - 1]) / (p + f), z++), z ? O /= z : (d = e1[i + 1] - e1[i], m = e1[i] - e1[i - 1], x = (g = r[a + 1] - r[a]) * (y = r[a] - r[a - 1]) * (g + y), O = ((v = d * m * (d + m)) * (y * t1[a + 1][i] + g * t1[a - 1][i]) + x * (m * t1[a][i + 1] + d * t1[a][i - 1])) / (x * (m + d) + v * (y + g))), k += (b = (_ = O - t1[a][i]) / T) * b, w = z ? 0 : .85, t1[a][i] += _ * (1 + w);
                        }
                        k = Math.sqrt(k);
                    }while (A++ < 100 && k > 1e-5);
                    return n.log("Smoother converged to", k, "after", A, "iterations"), t1;
                };
            },
            10820: function(t1, e1, r) {
                "use strict";
                var n = r(34809).isArray1D;
                t1.exports = function(t1, e1, r) {
                    var i = r("x"), a = i && i.length, o = r("y"), s = o && o.length;
                    if (!a && !s) return !1;
                    if (e1._cheater = !i, a && !n(i) || s && !n(o)) e1._length = null;
                    else {
                        var l = a ? i.length : 1 / 0;
                        s && (l = Math.min(l, o.length)), e1.a && e1.a.length && (l = Math.min(l, e1.a.length)), e1.b && e1.b.length && (l = Math.min(l, e1.b.length)), e1._length = l;
                    }
                    return !0;
                };
            },
            92802: function(t1, e1, r) {
                "use strict";
                var n = r(3208).rb, i = r(6893), a = r(87163), o = r(9829), s = r(10229).defaultLine, l = r(93049).extendFlat, c = i.marker.line;
                t1.exports = l({
                    locations: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    locationmode: i.locationmode,
                    z: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    geojson: l({}, i.geojson, {}),
                    featureidkey: i.featureidkey,
                    text: l({}, i.text, {}),
                    hovertext: l({}, i.hovertext, {}),
                    marker: {
                        line: {
                            color: l({}, c.color, {
                                dflt: s
                            }),
                            width: l({}, c.width, {
                                dflt: 1
                            }),
                            editType: "calc"
                        },
                        opacity: {
                            valType: "number",
                            arrayOk: !0,
                            min: 0,
                            max: 1,
                            dflt: 1,
                            editType: "style"
                        },
                        editType: "calc"
                    },
                    selected: {
                        marker: {
                            opacity: i.selected.marker.opacity,
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    unselected: {
                        marker: {
                            opacity: i.unselected.marker.opacity,
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    hoverinfo: l({}, o.hoverinfo, {
                        editType: "calc",
                        flags: [
                            "location",
                            "z",
                            "text",
                            "name"
                        ]
                    }),
                    hovertemplate: n(),
                    showlegend: l({}, o.showlegend, {
                        dflt: !1
                    })
                }, a("", {
                    cLetter: "z",
                    editTypeOverride: "calc"
                }));
            },
            12702: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(63821).BADNUM, a = r(28379), o = r(99203), s = r(48861);
                function l(t1) {
                    return t1 && "string" == typeof t1;
                }
                t1.exports = function(t1, e1) {
                    var r, c = e1._length, u = new Array(c);
                    r = e1.geojson ? function(t1) {
                        return l(t1) || n(t1);
                    } : l;
                    for(var h = 0; h < c; h++){
                        var f = u[h] = {}, p = e1.locations[h], d = e1.z[h];
                        r(p) && n(d) ? (f.loc = p, f.z = d) : (f.loc = null, f.z = i), f.index = h;
                    }
                    return o(u, e1), a(t1, e1, {
                        vals: e1.z,
                        containerStr: "",
                        cLetter: "z"
                    }), s(u, e1), u;
                };
            },
            51893: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(39356), a = r(92802);
                t1.exports = function(t1, e1, r, o) {
                    function s(r, i) {
                        return n.coerce(t1, e1, a, r, i);
                    }
                    var l = s("locations"), c = s("z");
                    if (l && l.length && n.isArrayOrTypedArray(c) && c.length) {
                        e1._length = Math.min(l.length, c.length);
                        var u, h = s("geojson");
                        ("string" == typeof h && "" !== h || n.isPlainObject(h)) && (u = "geojson-id"), "geojson-id" === s("locationmode", u) && s("featureidkey"), s("text"), s("hovertext"), s("hovertemplate"), s("marker.line.width") && s("marker.line.color"), s("marker.opacity"), i(t1, e1, o, s, {
                            prefix: "",
                            cLetter: "z"
                        }), n.coerceSelectionMarkerOpacity(e1, s);
                    } else e1.visible = !1;
                };
            },
            38414: function(t1) {
                "use strict";
                t1.exports = function(t1, e1, r, n, i) {
                    t1.location = e1.location, t1.z = e1.z;
                    var a = n[i];
                    return a.fIn && a.fIn.properties && (t1.properties = a.fIn.properties), t1.ct = a.ct, t1;
                };
            },
            94125: function(t1, e1, r) {
                "use strict";
                var n = r(29714), i = r(92802), a = r(34809).fillText;
                t1.exports = function(t1, e1, r) {
                    var o, s, l, c, u = t1.cd, h = u[0].trace, f = t1.subplot, p = [
                        e1,
                        r
                    ], d = [
                        e1 + 360,
                        r
                    ];
                    for(s = 0; s < u.length; s++)if (c = !1, (o = u[s])._polygons) {
                        for(l = 0; l < o._polygons.length; l++)o._polygons[l].contains(p) && (c = !c), o._polygons[l].contains(d) && (c = !c);
                        if (c) break;
                    }
                    if (c && o) return t1.x0 = t1.x1 = t1.xa.c2p(o.ct), t1.y0 = t1.y1 = t1.ya.c2p(o.ct), t1.index = o.index, t1.location = o.loc, t1.z = o.z, t1.zLabel = n.tickText(f.mockAxis, f.mockAxis.c2l(o.z), "hover").text, t1.hovertemplate = o.hovertemplate, function(t1, e1, r) {
                        if (!e1.hovertemplate) {
                            var n = r.hi || e1.hoverinfo, o = String(r.loc), s = "all" === n ? i.hoverinfo.flags : n.split("+"), l = -1 !== s.indexOf("name"), c = -1 !== s.indexOf("location"), u = -1 !== s.indexOf("z"), h = -1 !== s.indexOf("text"), f = [];
                            !l && c ? t1.nameOverride = o : (l && (t1.nameOverride = e1.name), c && f.push(o)), u && f.push(t1.zLabel), h && a(r, e1, f), t1.extraText = f.join("<br>");
                        }
                    }(t1, h, o), [
                        t1
                    ];
                };
            },
            58075: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    attributes: r(92802),
                    supplyDefaults: r(51893),
                    colorbar: r(12431),
                    calc: r(12702),
                    calcGeoJSON: r(4700).calcGeoJSON,
                    plot: r(4700).plot,
                    style: r(59342).style,
                    styleOnSelect: r(59342).styleOnSelect,
                    hoverPoints: r(94125),
                    eventData: r(38414),
                    selectPoints: r(43727),
                    moduleType: "trace",
                    name: "choropleth",
                    basePlotModule: r(47544),
                    categories: [
                        "geo",
                        "noOpacity",
                        "showLegend"
                    ],
                    meta: {}
                };
            },
            4700: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(34809), a = r(3994), o = r(11577).getTopojsonFeatures, s = r(32919).findExtremes, l = r(59342).style;
                t1.exports = {
                    calcGeoJSON: function(t1, e1) {
                        for(var r = t1[0].trace, n = e1[r.geo], i = n._subplot, l = r.locationmode, c = r._length, u = "geojson-id" === l ? a.extractTraceFeature(t1) : o(r, i.topojson), h = [], f = [], p = 0; p < c; p++){
                            var d = t1[p], m = "geojson-id" === l ? d.fOut : a.locationToFeature(l, d.loc, u);
                            if (m) {
                                d.geojson = m, d.ct = m.properties.ct, d._polygons = a.feature2polygons(m);
                                var g = a.computeBbox(m);
                                h.push(g[0], g[2]), f.push(g[1], g[3]);
                            } else d.geojson = null;
                        }
                        if ("geojson" === n.fitbounds && "geojson-id" === l) {
                            var y = a.computeBbox(a.getTraceGeojson(r));
                            h = [
                                y[0],
                                y[2]
                            ], f = [
                                y[1],
                                y[3]
                            ];
                        }
                        var v = {
                            padded: !0
                        };
                        r._extremes.lon = s(n.lonaxis._ax, h, v), r._extremes.lat = s(n.lataxis._ax, f, v);
                    },
                    plot: function(t1, e1, r) {
                        var a = e1.layers.backplot.select(".choroplethlayer");
                        i.makeTraceGroups(a, r, "trace choropleth").each(function(e1) {
                            var r = n.select(this).selectAll("path.choroplethlocation").data(i.identity);
                            r.enter().append("path").classed("choroplethlocation", !0), r.exit().remove(), l(t1, e1);
                        });
                    }
                };
            },
            43727: function(t1) {
                "use strict";
                t1.exports = function(t1, e1) {
                    var r, n, i, a, o, s = t1.cd, l = t1.xaxis, c = t1.yaxis, u = [];
                    if (!1 === e1) for(r = 0; r < s.length; r++)s[r].selected = 0;
                    else for(r = 0; r < s.length; r++)(i = (n = s[r]).ct) && (a = l.c2p(i), o = c.c2p(i), e1.contains([
                        a,
                        o
                    ], null, r, t1) ? (u.push({
                        pointNumber: r,
                        lon: i[0],
                        lat: i[1]
                    }), n.selected = 1) : n.selected = 0);
                    return u;
                };
            },
            59342: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(78766), a = r(62203), o = r(88856);
                function s(t1, e1) {
                    var r = e1[0].trace, s = e1[0].node3.selectAll(".choroplethlocation"), l = r.marker || {}, c = l.line || {}, u = o.makeColorScaleFuncFromTrace(r);
                    s.each(function(t1) {
                        n.select(this).attr("fill", u(t1.z)).call(i.stroke, t1.mlc || c.color).call(a.dashLine, "", t1.mlw || c.width || 0).style("opacity", l.opacity);
                    }), a.selectedPointStyle(s, r);
                }
                t1.exports = {
                    style: function(t1, e1) {
                        e1 && s(0, e1);
                    },
                    styleOnSelect: function(t1, e1) {
                        var r = e1[0].node3, n = e1[0].trace;
                        n.selectedpoints ? a.selectedPointStyle(r.selectAll(".choroplethlocation"), n) : s(0, e1);
                    }
                };
            },
            34770: function(t1, e1, r) {
                "use strict";
                var n = r(92802), i = r(87163), a = r(3208).rb, o = r(9829), s = r(93049).extendFlat;
                t1.exports = s({
                    locations: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    z: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    geojson: {
                        valType: "any",
                        editType: "calc"
                    },
                    featureidkey: s({}, n.featureidkey, {}),
                    below: {
                        valType: "string",
                        editType: "plot"
                    },
                    text: n.text,
                    hovertext: n.hovertext,
                    marker: {
                        line: {
                            color: s({}, n.marker.line.color, {
                                editType: "plot"
                            }),
                            width: s({}, n.marker.line.width, {
                                editType: "plot"
                            }),
                            editType: "calc"
                        },
                        opacity: s({}, n.marker.opacity, {
                            editType: "plot"
                        }),
                        editType: "calc"
                    },
                    selected: {
                        marker: {
                            opacity: s({}, n.selected.marker.opacity, {
                                editType: "plot"
                            }),
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    unselected: {
                        marker: {
                            opacity: s({}, n.unselected.marker.opacity, {
                                editType: "plot"
                            }),
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    hoverinfo: n.hoverinfo,
                    hovertemplate: a({}, {
                        keys: [
                            "properties"
                        ]
                    }),
                    showlegend: s({}, o.showlegend, {
                        dflt: !1
                    })
                }, i("", {
                    cLetter: "z",
                    editTypeOverride: "calc"
                }));
            },
            40980: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(34809), a = r(88856), o = r(62203), s = r(39532).makeBlank, l = r(3994);
                function c(t1) {
                    var e1, r = t1[0].trace, n = r._opts;
                    if (r.selectedpoints) {
                        for(var a = o.makeSelectedPointStyleFns(r), s = 0; s < t1.length; s++){
                            var l = t1[s];
                            l.fOut && (l.fOut.properties.mo2 = a.selectedOpacityFn(l));
                        }
                        e1 = {
                            type: "identity",
                            property: "mo2"
                        };
                    } else e1 = i.isArrayOrTypedArray(r.marker.opacity) ? {
                        type: "identity",
                        property: "mo"
                    } : r.marker.opacity;
                    return i.extendFlat(n.fill.paint, {
                        "fill-opacity": e1
                    }), i.extendFlat(n.line.paint, {
                        "line-opacity": e1
                    }), n;
                }
                t1.exports = {
                    convert: function(t1) {
                        var e1 = t1[0].trace, r = !0 === e1.visible && 0 !== e1._length, o = {
                            layout: {
                                visibility: "none"
                            },
                            paint: {}
                        }, u = {
                            layout: {
                                visibility: "none"
                            },
                            paint: {}
                        }, h = e1._opts = {
                            fill: o,
                            line: u,
                            geojson: s()
                        };
                        if (!r) return h;
                        var f = l.extractTraceFeature(t1);
                        if (!f) return h;
                        var p, d, m, g = a.makeColorScaleFuncFromTrace(e1), y = e1.marker, v = y.line || {};
                        i.isArrayOrTypedArray(y.opacity) && (p = function(t1) {
                            var e1 = t1.mo;
                            return n(e1) ? +i.constrain(e1, 0, 1) : 0;
                        }), i.isArrayOrTypedArray(v.color) && (d = function(t1) {
                            return t1.mlc;
                        }), i.isArrayOrTypedArray(v.width) && (m = function(t1) {
                            return t1.mlw;
                        });
                        for(var x = 0; x < t1.length; x++){
                            var _ = t1[x], b = _.fOut;
                            if (b) {
                                var w = b.properties;
                                w.fc = g(_.z), p && (w.mo = p(_)), d && (w.mlc = d(_)), m && (w.mlw = m(_)), _.ct = w.ct, _._polygons = l.feature2polygons(b);
                            }
                        }
                        var T = p ? {
                            type: "identity",
                            property: "mo"
                        } : y.opacity;
                        return i.extendFlat(o.paint, {
                            "fill-color": {
                                type: "identity",
                                property: "fc"
                            },
                            "fill-opacity": T
                        }), i.extendFlat(u.paint, {
                            "line-color": d ? {
                                type: "identity",
                                property: "mlc"
                            } : v.color,
                            "line-width": m ? {
                                type: "identity",
                                property: "mlw"
                            } : v.width,
                            "line-opacity": T
                        }), o.layout.visibility = "visible", u.layout.visibility = "visible", h.geojson = {
                            type: "FeatureCollection",
                            features: f
                        }, c(t1), h;
                    },
                    convertOnSelect: c
                };
            },
            94149: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(39356), a = r(34770);
                t1.exports = function(t1, e1, r, o) {
                    function s(r, i) {
                        return n.coerce(t1, e1, a, r, i);
                    }
                    var l = s("locations"), c = s("z"), u = s("geojson");
                    n.isArrayOrTypedArray(l) && l.length && n.isArrayOrTypedArray(c) && c.length && ("string" == typeof u && "" !== u || n.isPlainObject(u)) ? (s("featureidkey"), e1._length = Math.min(l.length, c.length), s("below"), s("text"), s("hovertext"), s("hovertemplate"), s("marker.line.width") && s("marker.line.color"), s("marker.opacity"), i(t1, e1, o, s, {
                        prefix: "",
                        cLetter: "z"
                    }), n.coerceSelectionMarkerOpacity(e1, s)) : e1.visible = !1;
                };
            },
            9419: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    attributes: r(34770),
                    supplyDefaults: r(94149),
                    colorbar: r(12431),
                    calc: r(12702),
                    plot: r(30316),
                    hoverPoints: r(94125),
                    eventData: r(38414),
                    selectPoints: r(43727),
                    styleOnSelect: function(t1, e1) {
                        e1 && e1[0].trace._glTrace.updateOnSelect(e1);
                    },
                    getBelow: function(t1, e1) {
                        for(var r = e1.getMapLayers(), n = r.length - 2; n >= 0; n--){
                            var i = r[n].id;
                            if ("string" == typeof i && 0 === i.indexOf("water")) {
                                for(var a = n + 1; a < r.length; a++)if ("string" == typeof (i = r[a].id) && -1 === i.indexOf("plotly-")) return i;
                            }
                        }
                    },
                    moduleType: "trace",
                    name: "choroplethmap",
                    basePlotModule: r(34091),
                    categories: [
                        "map",
                        "gl",
                        "noOpacity",
                        "showLegend"
                    ],
                    meta: {
                        hr_name: "choropleth_map"
                    }
                };
            },
            30316: function(t1, e1, r) {
                "use strict";
                var n = r(40980).convert, i = r(40980).convertOnSelect, a = r(8814).traceLayerPrefix;
                function o(t1, e1) {
                    this.type = "choroplethmap", this.subplot = t1, this.uid = e1, this.sourceId = "source-" + e1, this.layerList = [
                        [
                            "fill",
                            a + e1 + "-fill"
                        ],
                        [
                            "line",
                            a + e1 + "-line"
                        ]
                    ], this.below = null;
                }
                var s = o.prototype;
                s.update = function(t1) {
                    this._update(n(t1)), t1[0].trace._glTrace = this;
                }, s.updateOnSelect = function(t1) {
                    this._update(i(t1));
                }, s._update = function(t1) {
                    var e1 = this.subplot, r = this.layerList, n = e1.belowLookup["trace-" + this.uid];
                    e1.map.getSource(this.sourceId).setData(t1.geojson), n !== this.below && (this._removeLayers(), this._addLayers(t1, n), this.below = n);
                    for(var i = 0; i < r.length; i++){
                        var a = r[i], o = a[0], s = a[1], l = t1[o];
                        e1.setOptions(s, "setLayoutProperty", l.layout), "visible" === l.layout.visibility && e1.setOptions(s, "setPaintProperty", l.paint);
                    }
                }, s._addLayers = function(t1, e1) {
                    for(var r = this.subplot, n = this.layerList, i = this.sourceId, a = 0; a < n.length; a++){
                        var o = n[a], s = o[0], l = t1[s];
                        r.addLayer({
                            type: s,
                            id: o[1],
                            source: i,
                            layout: l.layout,
                            paint: l.paint
                        }, e1);
                    }
                }, s._removeLayers = function() {
                    for(var t1 = this.subplot.map, e1 = this.layerList, r = e1.length - 1; r >= 0; r--)t1.removeLayer(e1[r][1]);
                }, s.dispose = function() {
                    var t1 = this.subplot.map;
                    this._removeLayers(), t1.removeSource(this.sourceId);
                }, t1.exports = function(t1, e1) {
                    var r = e1[0].trace, i = new o(t1, r.uid), a = i.sourceId, s = n(e1), l = i.below = t1.belowLookup["trace-" + r.uid];
                    return t1.map.addSource(a, {
                        type: "geojson",
                        data: s.geojson
                    }), i._addLayers(s, l), e1[0].trace._glTrace = i, i;
                };
            },
            86227: function(t1, e1, r) {
                "use strict";
                var n = r(92802), i = r(87163), a = r(3208).rb, o = r(9829), s = r(93049).extendFlat;
                t1.exports = s({
                    locations: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    z: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    geojson: {
                        valType: "any",
                        editType: "calc"
                    },
                    featureidkey: s({}, n.featureidkey, {}),
                    below: {
                        valType: "string",
                        editType: "plot"
                    },
                    text: n.text,
                    hovertext: n.hovertext,
                    marker: {
                        line: {
                            color: s({}, n.marker.line.color, {
                                editType: "plot"
                            }),
                            width: s({}, n.marker.line.width, {
                                editType: "plot"
                            }),
                            editType: "calc"
                        },
                        opacity: s({}, n.marker.opacity, {
                            editType: "plot"
                        }),
                        editType: "calc"
                    },
                    selected: {
                        marker: {
                            opacity: s({}, n.selected.marker.opacity, {
                                editType: "plot"
                            }),
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    unselected: {
                        marker: {
                            opacity: s({}, n.unselected.marker.opacity, {
                                editType: "plot"
                            }),
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    hoverinfo: n.hoverinfo,
                    hovertemplate: a({}, {
                        keys: [
                            "properties"
                        ]
                    }),
                    showlegend: s({}, o.showlegend, {
                        dflt: !1
                    })
                }, i("", {
                    cLetter: "z",
                    editTypeOverride: "calc"
                }));
            },
            51335: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(34809), a = r(88856), o = r(62203), s = r(39532).makeBlank, l = r(3994);
                function c(t1) {
                    var e1, r = t1[0].trace, n = r._opts;
                    if (r.selectedpoints) {
                        for(var a = o.makeSelectedPointStyleFns(r), s = 0; s < t1.length; s++){
                            var l = t1[s];
                            l.fOut && (l.fOut.properties.mo2 = a.selectedOpacityFn(l));
                        }
                        e1 = {
                            type: "identity",
                            property: "mo2"
                        };
                    } else e1 = i.isArrayOrTypedArray(r.marker.opacity) ? {
                        type: "identity",
                        property: "mo"
                    } : r.marker.opacity;
                    return i.extendFlat(n.fill.paint, {
                        "fill-opacity": e1
                    }), i.extendFlat(n.line.paint, {
                        "line-opacity": e1
                    }), n;
                }
                t1.exports = {
                    convert: function(t1) {
                        var e1 = t1[0].trace, r = !0 === e1.visible && 0 !== e1._length, o = {
                            layout: {
                                visibility: "none"
                            },
                            paint: {}
                        }, u = {
                            layout: {
                                visibility: "none"
                            },
                            paint: {}
                        }, h = e1._opts = {
                            fill: o,
                            line: u,
                            geojson: s()
                        };
                        if (!r) return h;
                        var f = l.extractTraceFeature(t1);
                        if (!f) return h;
                        var p, d, m, g = a.makeColorScaleFuncFromTrace(e1), y = e1.marker, v = y.line || {};
                        i.isArrayOrTypedArray(y.opacity) && (p = function(t1) {
                            var e1 = t1.mo;
                            return n(e1) ? +i.constrain(e1, 0, 1) : 0;
                        }), i.isArrayOrTypedArray(v.color) && (d = function(t1) {
                            return t1.mlc;
                        }), i.isArrayOrTypedArray(v.width) && (m = function(t1) {
                            return t1.mlw;
                        });
                        for(var x = 0; x < t1.length; x++){
                            var _ = t1[x], b = _.fOut;
                            if (b) {
                                var w = b.properties;
                                w.fc = g(_.z), p && (w.mo = p(_)), d && (w.mlc = d(_)), m && (w.mlw = m(_)), _.ct = w.ct, _._polygons = l.feature2polygons(b);
                            }
                        }
                        var T = p ? {
                            type: "identity",
                            property: "mo"
                        } : y.opacity;
                        return i.extendFlat(o.paint, {
                            "fill-color": {
                                type: "identity",
                                property: "fc"
                            },
                            "fill-opacity": T
                        }), i.extendFlat(u.paint, {
                            "line-color": d ? {
                                type: "identity",
                                property: "mlc"
                            } : v.color,
                            "line-width": m ? {
                                type: "identity",
                                property: "mlw"
                            } : v.width,
                            "line-opacity": T
                        }), o.layout.visibility = "visible", u.layout.visibility = "visible", h.geojson = {
                            type: "FeatureCollection",
                            features: f
                        }, c(t1), h;
                    },
                    convertOnSelect: c
                };
            },
            8244: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(39356), a = r(86227);
                t1.exports = function(t1, e1, r, o) {
                    function s(r, i) {
                        return n.coerce(t1, e1, a, r, i);
                    }
                    var l = s("locations"), c = s("z"), u = s("geojson");
                    n.isArrayOrTypedArray(l) && l.length && n.isArrayOrTypedArray(c) && c.length && ("string" == typeof u && "" !== u || n.isPlainObject(u)) ? (s("featureidkey"), e1._length = Math.min(l.length, c.length), s("below"), s("text"), s("hovertext"), s("hovertemplate"), s("marker.line.width") && s("marker.line.color"), s("marker.opacity"), i(t1, e1, o, s, {
                        prefix: "",
                        cLetter: "z"
                    }), n.coerceSelectionMarkerOpacity(e1, s)) : e1.visible = !1;
                };
            },
            28128: function(t1, e1, r) {
                "use strict";
                [
                    "*choroplethmapbox* trace is deprecated!",
                    "Please consider switching to the *choroplethmap* trace type and `map` subplots.",
                    "Learn more at: https://plotly.com/javascript/maplibre-migration/"
                ].join(" "), t1.exports = {
                    attributes: r(86227),
                    supplyDefaults: r(8244),
                    colorbar: r(12431),
                    calc: r(12702),
                    plot: r(33501),
                    hoverPoints: r(94125),
                    eventData: r(38414),
                    selectPoints: r(43727),
                    styleOnSelect: function(t1, e1) {
                        e1 && e1[0].trace._glTrace.updateOnSelect(e1);
                    },
                    getBelow: function(t1, e1) {
                        for(var r = e1.getMapLayers(), n = r.length - 2; n >= 0; n--){
                            var i = r[n].id;
                            if ("string" == typeof i && 0 === i.indexOf("water")) {
                                for(var a = n + 1; a < r.length; a++)if ("string" == typeof (i = r[a].id) && -1 === i.indexOf("plotly-")) return i;
                            }
                        }
                    },
                    moduleType: "trace",
                    name: "choroplethmapbox",
                    basePlotModule: r(68192),
                    categories: [
                        "mapbox",
                        "gl",
                        "noOpacity",
                        "showLegend"
                    ],
                    meta: {
                        hr_name: "choropleth_mapbox"
                    }
                };
            },
            33501: function(t1, e1, r) {
                "use strict";
                var n = r(51335).convert, i = r(51335).convertOnSelect, a = r(44245).traceLayerPrefix;
                function o(t1, e1) {
                    this.type = "choroplethmapbox", this.subplot = t1, this.uid = e1, this.sourceId = "source-" + e1, this.layerList = [
                        [
                            "fill",
                            a + e1 + "-fill"
                        ],
                        [
                            "line",
                            a + e1 + "-line"
                        ]
                    ], this.below = null;
                }
                var s = o.prototype;
                s.update = function(t1) {
                    this._update(n(t1)), t1[0].trace._glTrace = this;
                }, s.updateOnSelect = function(t1) {
                    this._update(i(t1));
                }, s._update = function(t1) {
                    var e1 = this.subplot, r = this.layerList, n = e1.belowLookup["trace-" + this.uid];
                    e1.map.getSource(this.sourceId).setData(t1.geojson), n !== this.below && (this._removeLayers(), this._addLayers(t1, n), this.below = n);
                    for(var i = 0; i < r.length; i++){
                        var a = r[i], o = a[0], s = a[1], l = t1[o];
                        e1.setOptions(s, "setLayoutProperty", l.layout), "visible" === l.layout.visibility && e1.setOptions(s, "setPaintProperty", l.paint);
                    }
                }, s._addLayers = function(t1, e1) {
                    for(var r = this.subplot, n = this.layerList, i = this.sourceId, a = 0; a < n.length; a++){
                        var o = n[a], s = o[0], l = t1[s];
                        r.addLayer({
                            type: s,
                            id: o[1],
                            source: i,
                            layout: l.layout,
                            paint: l.paint
                        }, e1);
                    }
                }, s._removeLayers = function() {
                    for(var t1 = this.subplot.map, e1 = this.layerList, r = e1.length - 1; r >= 0; r--)t1.removeLayer(e1[r][1]);
                }, s.dispose = function() {
                    var t1 = this.subplot.map;
                    this._removeLayers(), t1.removeSource(this.sourceId);
                }, t1.exports = function(t1, e1) {
                    var r = e1[0].trace, i = new o(t1, r.uid), a = i.sourceId, s = n(e1), l = i.below = t1.belowLookup["trace-" + r.uid];
                    return t1.map.addSource(a, {
                        type: "geojson",
                        data: s.geojson
                    }), i._addLayers(s, l), e1[0].trace._glTrace = i, i;
                };
            },
            49865: function(t1, e1, r) {
                "use strict";
                var n = r(87163), i = r(80712).axisHoverFormat, a = r(3208).rb, o = r(42450), s = r(9829), l = r(93049).extendFlat, c = {
                    x: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    y: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    z: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    u: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    v: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    w: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    sizemode: {
                        valType: "enumerated",
                        values: [
                            "scaled",
                            "absolute",
                            "raw"
                        ],
                        editType: "calc",
                        dflt: "scaled"
                    },
                    sizeref: {
                        valType: "number",
                        editType: "calc",
                        min: 0
                    },
                    anchor: {
                        valType: "enumerated",
                        editType: "calc",
                        values: [
                            "tip",
                            "tail",
                            "cm",
                            "center"
                        ],
                        dflt: "cm"
                    },
                    text: {
                        valType: "string",
                        dflt: "",
                        arrayOk: !0,
                        editType: "calc"
                    },
                    hovertext: {
                        valType: "string",
                        dflt: "",
                        arrayOk: !0,
                        editType: "calc"
                    },
                    hovertemplate: a({
                        editType: "calc"
                    }, {
                        keys: [
                            "norm"
                        ]
                    }),
                    uhoverformat: i("u", 1),
                    vhoverformat: i("v", 1),
                    whoverformat: i("w", 1),
                    xhoverformat: i("x"),
                    yhoverformat: i("y"),
                    zhoverformat: i("z"),
                    showlegend: l({}, s.showlegend, {
                        dflt: !1
                    })
                };
                l(c, n("", {
                    colorAttr: "u/v/w norm",
                    showScaleDflt: !0,
                    editTypeOverride: "calc"
                })), [
                    "opacity",
                    "lightposition",
                    "lighting"
                ].forEach(function(t1) {
                    c[t1] = o[t1];
                }), c.hoverinfo = l({}, s.hoverinfo, {
                    editType: "calc",
                    flags: [
                        "x",
                        "y",
                        "z",
                        "u",
                        "v",
                        "w",
                        "norm",
                        "text",
                        "name"
                    ],
                    dflt: "x+y+z+norm+text+name"
                }), c.transforms = void 0, t1.exports = c;
            },
            93805: function(t1, e1, r) {
                "use strict";
                var n = r(28379);
                t1.exports = function(t1, e1) {
                    for(var r = e1.u, i = e1.v, a = e1.w, o = Math.min(e1.x.length, e1.y.length, e1.z.length, r.length, i.length, a.length), s = -1 / 0, l = 1 / 0, c = 0; c < o; c++){
                        var u = r[c], h = i[c], f = a[c], p = Math.sqrt(u * u + h * h + f * f);
                        s = Math.max(s, p), l = Math.min(l, p);
                    }
                    e1._len = o, e1._normMax = s, n(t1, e1, {
                        vals: [
                            l,
                            s
                        ],
                        containerStr: "",
                        cLetter: "c"
                    });
                };
            },
            49393: function(t1, e1, r) {
                "use strict";
                var n = r(99098).gl_cone3d, i = r(99098).gl_cone3d.createConeMesh, a = r(34809).simpleMap, o = r(46998).parseColorScale, s = r(88856).extractOpts, l = r(34809).isArrayOrTypedArray, c = r(88239);
                function u(t1, e1) {
                    this.scene = t1, this.uid = e1, this.mesh = null, this.data = null;
                }
                var h = u.prototype;
                h.handlePick = function(t1) {
                    if (t1.object === this.mesh) {
                        var e1 = t1.index = t1.data.index, r = this.data.x[e1], n = this.data.y[e1], i = this.data.z[e1], a = this.data.u[e1], o = this.data.v[e1], s = this.data.w[e1];
                        t1.traceCoordinate = [
                            r,
                            n,
                            i,
                            a,
                            o,
                            s,
                            Math.sqrt(a * a + o * o + s * s)
                        ];
                        var c = this.data.hovertext || this.data.text;
                        return l(c) && void 0 !== c[e1] ? t1.textLabel = c[e1] : c && (t1.textLabel = c), !0;
                    }
                };
                var f = {
                    xaxis: 0,
                    yaxis: 1,
                    zaxis: 2
                }, p = {
                    tip: 1,
                    tail: 0,
                    cm: .25,
                    center: .5
                }, d = {
                    tip: 1,
                    tail: 1,
                    cm: .75,
                    center: .5
                };
                function m(t1, e1) {
                    var r = t1.fullSceneLayout, i = t1.dataScale, l = {};
                    function u(t1, e1) {
                        var n = r[e1], o = i[f[e1]];
                        return a(t1, function(t1) {
                            return n.d2l(t1) * o;
                        });
                    }
                    l.vectors = c(u(e1.u, "xaxis"), u(e1.v, "yaxis"), u(e1.w, "zaxis"), e1._len), l.positions = c(u(e1.x, "xaxis"), u(e1.y, "yaxis"), u(e1.z, "zaxis"), e1._len);
                    var h = s(e1);
                    l.colormap = o(e1), l.vertexIntensityBounds = [
                        h.min / e1._normMax,
                        h.max / e1._normMax
                    ], l.coneOffset = p[e1.anchor];
                    var m = e1.sizemode;
                    "scaled" === m ? l.coneSize = e1.sizeref || .5 : "absolute" === m ? l.coneSize = e1.sizeref && e1._normMax ? e1.sizeref / e1._normMax : .5 : "raw" === m && (l.coneSize = e1.sizeref), l.coneSizemode = m;
                    var g = n(l), y = e1.lightposition;
                    return g.lightPosition = [
                        y.x,
                        y.y,
                        y.z
                    ], g.ambient = e1.lighting.ambient, g.diffuse = e1.lighting.diffuse, g.specular = e1.lighting.specular, g.roughness = e1.lighting.roughness, g.fresnel = e1.lighting.fresnel, g.opacity = e1.opacity, e1._pad = d[e1.anchor] * g.vectorScale * g.coneScale * e1._normMax, g;
                }
                h.update = function(t1) {
                    this.data = t1;
                    var e1 = m(this.scene, t1);
                    this.mesh.update(e1);
                }, h.dispose = function() {
                    this.scene.glplot.remove(this.mesh), this.mesh.dispose();
                }, t1.exports = function(t1, e1) {
                    var r = t1.glplot.gl, n = m(t1, e1), a = i(r, n), o = new u(t1, e1.uid);
                    return o.mesh = a, o.data = e1, a._trace = o, t1.glplot.add(a), o;
                };
            },
            17326: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(39356), a = r(49865);
                t1.exports = function(t1, e1, r, o) {
                    function s(r, i) {
                        return n.coerce(t1, e1, a, r, i);
                    }
                    var l = s("u"), c = s("v"), u = s("w"), h = s("x"), f = s("y"), p = s("z");
                    if (l && l.length && c && c.length && u && u.length && h && h.length && f && f.length && p && p.length) {
                        var d = s("sizemode");
                        s("sizeref", "raw" === d ? 1 : .5), s("anchor"), s("lighting.ambient"), s("lighting.diffuse"), s("lighting.specular"), s("lighting.roughness"), s("lighting.fresnel"), s("lightposition.x"), s("lightposition.y"), s("lightposition.z"), i(t1, e1, o, s, {
                            prefix: "",
                            cLetter: "c"
                        }), s("text"), s("hovertext"), s("hovertemplate"), s("uhoverformat"), s("vhoverformat"), s("whoverformat"), s("xhoverformat"), s("yhoverformat"), s("zhoverformat"), e1._length = null;
                    } else e1.visible = !1;
                };
            },
            47050: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    moduleType: "trace",
                    name: "cone",
                    basePlotModule: r(2487),
                    categories: [
                        "gl3d",
                        "showLegend"
                    ],
                    attributes: r(49865),
                    supplyDefaults: r(17326),
                    colorbar: {
                        min: "cmin",
                        max: "cmax"
                    },
                    calc: r(93805),
                    plot: r(49393),
                    eventData: function(t1, e1) {
                        return t1.norm = e1.traceCoordinate[6], t1;
                    },
                    meta: {}
                };
            },
            52240: function(t1, e1, r) {
                "use strict";
                var n = r(81658), i = r(36640), a = r(80712), o = a.axisHoverFormat, s = a.descriptionOnlyNumbers, l = r(87163), c = r(94850).T, u = r(80337), h = r(93049).extendFlat, f = r(20726), p = f.COMPARISON_OPS2, d = f.INTERVAL_OPS, m = i.line;
                t1.exports = h({
                    z: n.z,
                    x: n.x,
                    x0: n.x0,
                    dx: n.dx,
                    y: n.y,
                    y0: n.y0,
                    dy: n.dy,
                    xperiod: n.xperiod,
                    yperiod: n.yperiod,
                    xperiod0: i.xperiod0,
                    yperiod0: i.yperiod0,
                    xperiodalignment: n.xperiodalignment,
                    yperiodalignment: n.yperiodalignment,
                    text: n.text,
                    hovertext: n.hovertext,
                    transpose: n.transpose,
                    xtype: n.xtype,
                    ytype: n.ytype,
                    xhoverformat: o("x"),
                    yhoverformat: o("y"),
                    zhoverformat: o("z", 1),
                    hovertemplate: n.hovertemplate,
                    texttemplate: h({}, n.texttemplate, {}),
                    textfont: h({}, n.textfont, {}),
                    hoverongaps: n.hoverongaps,
                    connectgaps: h({}, n.connectgaps, {}),
                    fillcolor: {
                        valType: "color",
                        editType: "calc"
                    },
                    autocontour: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc",
                        impliedEdits: {
                            "contours.start": void 0,
                            "contours.end": void 0,
                            "contours.size": void 0
                        }
                    },
                    ncontours: {
                        valType: "integer",
                        dflt: 15,
                        min: 1,
                        editType: "calc"
                    },
                    contours: {
                        type: {
                            valType: "enumerated",
                            values: [
                                "levels",
                                "constraint"
                            ],
                            dflt: "levels",
                            editType: "calc"
                        },
                        start: {
                            valType: "number",
                            dflt: null,
                            editType: "plot",
                            impliedEdits: {
                                "^autocontour": !1
                            }
                        },
                        end: {
                            valType: "number",
                            dflt: null,
                            editType: "plot",
                            impliedEdits: {
                                "^autocontour": !1
                            }
                        },
                        size: {
                            valType: "number",
                            dflt: null,
                            min: 0,
                            editType: "plot",
                            impliedEdits: {
                                "^autocontour": !1
                            }
                        },
                        coloring: {
                            valType: "enumerated",
                            values: [
                                "fill",
                                "heatmap",
                                "lines",
                                "none"
                            ],
                            dflt: "fill",
                            editType: "calc"
                        },
                        showlines: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "plot"
                        },
                        showlabels: {
                            valType: "boolean",
                            dflt: !1,
                            editType: "plot"
                        },
                        labelfont: u({
                            editType: "plot",
                            colorEditType: "style"
                        }),
                        labelformat: {
                            valType: "string",
                            dflt: "",
                            editType: "plot",
                            description: s("contour label")
                        },
                        operation: {
                            valType: "enumerated",
                            values: [].concat(p).concat(d),
                            dflt: "=",
                            editType: "calc"
                        },
                        value: {
                            valType: "any",
                            dflt: 0,
                            editType: "calc"
                        },
                        editType: "calc",
                        impliedEdits: {
                            autocontour: !1
                        }
                    },
                    line: {
                        color: h({}, m.color, {
                            editType: "style+colorbars"
                        }),
                        width: {
                            valType: "number",
                            min: 0,
                            editType: "style+colorbars"
                        },
                        dash: c,
                        smoothing: h({}, m.smoothing, {}),
                        editType: "plot"
                    },
                    zorder: i.zorder
                }, l("", {
                    cLetter: "z",
                    autoColorDflt: !1,
                    editTypeOverride: "calc"
                }));
            },
            40352: function(t1, e1, r) {
                "use strict";
                var n = r(88856), i = r(51670), a = r(62475), o = r(48715);
                t1.exports = function(t1, e1) {
                    var r = i(t1, e1), s = r[0].z;
                    a(e1, s);
                    var l, c = e1.contours, u = n.extractOpts(e1);
                    if ("heatmap" === c.coloring && u.auto && !1 === e1.autocontour) {
                        var h = c.start, f = o(c), p = c.size || 1, d = Math.floor((f - h) / p) + 1;
                        isFinite(p) || (p = 1, d = 1);
                        var m = h - p / 2;
                        l = [
                            m,
                            m + d * p
                        ];
                    } else l = s;
                    return n.calc(t1, e1, {
                        vals: l,
                        cLetter: "z"
                    }), r;
                };
            },
            49886: function(t1) {
                "use strict";
                t1.exports = function(t1, e1) {
                    var r, n = t1[0], i = n.z;
                    switch(e1.type){
                        case "levels":
                            var a = Math.min(i[0][0], i[0][1]);
                            for(r = 0; r < t1.length; r++){
                                var o = t1[r];
                                o.prefixBoundary = !o.edgepaths.length && (a > o.level || o.starts.length && a === o.level);
                            }
                            break;
                        case "constraint":
                            if (n.prefixBoundary = !1, n.edgepaths.length) return;
                            var s = n.x.length, l = n.y.length, c = -1 / 0, u = 1 / 0;
                            for(r = 0; r < l; r++)u = Math.min(u, i[r][0]), u = Math.min(u, i[r][s - 1]), c = Math.max(c, i[r][0]), c = Math.max(c, i[r][s - 1]);
                            for(r = 1; r < s - 1; r++)u = Math.min(u, i[0][r]), u = Math.min(u, i[l - 1][r]), c = Math.max(c, i[0][r]), c = Math.max(c, i[l - 1][r]);
                            var h, f, p = e1.value;
                            switch(e1._operation){
                                case ">":
                                    p > c && (n.prefixBoundary = !0);
                                    break;
                                case "<":
                                    (p < u || n.starts.length && p === u) && (n.prefixBoundary = !0);
                                    break;
                                case "[]":
                                    h = Math.min(p[0], p[1]), ((f = Math.max(p[0], p[1])) < u || h > c || n.starts.length && f === u) && (n.prefixBoundary = !0);
                                    break;
                                case "][":
                                    h = Math.min(p[0], p[1]), f = Math.max(p[0], p[1]), h < u && f > c && (n.prefixBoundary = !0);
                            }
                    }
                };
            },
            92697: function(t1, e1, r) {
                "use strict";
                var n = r(88856), i = r(16438), a = r(48715);
                t1.exports = {
                    min: "zmin",
                    max: "zmax",
                    calc: function(t1, e1, r) {
                        var o = e1.contours, s = e1.line, l = o.size || 1, c = o.coloring, u = i(e1, {
                            isColorbar: !0
                        });
                        if ("heatmap" === c) {
                            var h = n.extractOpts(e1);
                            r._fillgradient = h.reversescale ? n.flipScale(h.colorscale) : h.colorscale, r._zrange = [
                                h.min,
                                h.max
                            ];
                        } else "fill" === c && (r._fillcolor = u);
                        r._line = {
                            color: "lines" === c ? u : s.color,
                            width: !1 !== o.showlines ? s.width : 0,
                            dash: s.dash
                        }, r._levels = {
                            start: o.start,
                            end: a(o),
                            size: l
                        };
                    }
                };
            },
            53156: function(t1) {
                "use strict";
                t1.exports = {
                    BOTTOMSTART: [
                        1,
                        9,
                        13,
                        104,
                        713
                    ],
                    TOPSTART: [
                        4,
                        6,
                        7,
                        104,
                        713
                    ],
                    LEFTSTART: [
                        8,
                        12,
                        14,
                        208,
                        1114
                    ],
                    RIGHTSTART: [
                        2,
                        3,
                        11,
                        208,
                        1114
                    ],
                    NEWDELTA: [
                        null,
                        [
                            -1,
                            0
                        ],
                        [
                            0,
                            -1
                        ],
                        [
                            -1,
                            0
                        ],
                        [
                            1,
                            0
                        ],
                        null,
                        [
                            0,
                            -1
                        ],
                        [
                            -1,
                            0
                        ],
                        [
                            0,
                            1
                        ],
                        [
                            0,
                            1
                        ],
                        null,
                        [
                            0,
                            1
                        ],
                        [
                            1,
                            0
                        ],
                        [
                            1,
                            0
                        ],
                        [
                            0,
                            -1
                        ]
                    ],
                    CHOOSESADDLE: {
                        104: [
                            4,
                            1
                        ],
                        208: [
                            2,
                            8
                        ],
                        713: [
                            7,
                            13
                        ],
                        1114: [
                            11,
                            14
                        ]
                    },
                    SADDLEREMAINDER: {
                        1: 4,
                        2: 8,
                        4: 1,
                        7: 13,
                        8: 2,
                        11: 14,
                        13: 7,
                        14: 11
                    },
                    LABELDISTANCE: 2,
                    LABELINCREASE: 10,
                    LABELMIN: 3,
                    LABELMAX: 10,
                    LABELOPTIMIZER: {
                        EDGECOST: 1,
                        ANGLECOST: 1,
                        NEIGHBORCOST: 5,
                        SAMELEVELFACTOR: 10,
                        SAMELEVELDISTANCE: 5,
                        MAXCOST: 100,
                        INITIALSEARCHPOINTS: 10,
                        ITERATIONS: 5
                    }
                };
            },
            29503: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(20576), a = r(78766), o = a.addOpacity, s = a.opacity, l = r(20726), c = r(34809).isArrayOrTypedArray, u = l.CONSTRAINT_REDUCTION, h = l.COMPARISON_OPS2;
                t1.exports = function(t1, e1, r, a, l, f) {
                    var p, d, m, g = e1.contours, y = r("contours.operation");
                    g._operation = u[y], function(t1, e1) {
                        var r;
                        -1 === h.indexOf(e1.operation) ? (t1("contours.value", [
                            0,
                            1
                        ]), c(e1.value) ? e1.value.length > 2 ? e1.value = e1.value.slice(2) : 0 === e1.length ? e1.value = [
                            0,
                            1
                        ] : e1.length < 2 ? (r = parseFloat(e1.value[0]), e1.value = [
                            r,
                            r + 1
                        ]) : e1.value = [
                            parseFloat(e1.value[0]),
                            parseFloat(e1.value[1])
                        ] : n(e1.value) && (r = parseFloat(e1.value), e1.value = [
                            r,
                            r + 1
                        ])) : (t1("contours.value", 0), n(e1.value) || (c(e1.value) ? e1.value = parseFloat(e1.value[0]) : e1.value = 0));
                    }(r, g), "=" === y ? p = g.showlines = !0 : (p = r("contours.showlines"), m = r("fillcolor", o((t1.line || {}).color || l, .5))), p && (d = r("line.color", m && s(m) ? o(e1.fillcolor, 1) : l), r("line.width", 2), r("line.dash")), r("line.smoothing"), i(r, a, d, f);
                };
            },
            22783: function(t1, e1, r) {
                "use strict";
                var n = r(20726), i = r(10721);
                function a(t1, e1) {
                    var r, a = Array.isArray(e1);
                    function o(t1) {
                        return i(t1) ? +t1 : null;
                    }
                    return -1 !== n.COMPARISON_OPS2.indexOf(t1) ? r = o(a ? e1[0] : e1) : -1 !== n.INTERVAL_OPS.indexOf(t1) ? r = a ? [
                        o(e1[0]),
                        o(e1[1])
                    ] : [
                        o(e1),
                        o(e1)
                    ] : -1 !== n.SET_OPS.indexOf(t1) && (r = a ? e1.map(o) : [
                        o(e1)
                    ]), r;
                }
                function o(t1) {
                    return function(e1) {
                        e1 = a(t1, e1);
                        var r = Math.min(e1[0], e1[1]), n = Math.max(e1[0], e1[1]);
                        return {
                            start: r,
                            end: n,
                            size: n - r
                        };
                    };
                }
                function s(t1) {
                    return function(e1) {
                        return {
                            start: e1 = a(t1, e1),
                            end: 1 / 0,
                            size: 1 / 0
                        };
                    };
                }
                t1.exports = {
                    "[]": o("[]"),
                    "][": o("]["),
                    ">": s(">"),
                    "<": s("<"),
                    "=": s("=")
                };
            },
            47495: function(t1) {
                "use strict";
                t1.exports = function(t1, e1, r, n) {
                    var i = n("contours.start"), a = n("contours.end"), o = !1 === i || !1 === a, s = r("contours.size");
                    !(o ? e1.autocontour = !0 : r("autocontour", !1)) && s || r("ncontours");
                };
            },
            1999: function(t1, e1, r) {
                "use strict";
                var n = r(34809);
                function i(t1) {
                    return n.extendFlat({}, t1, {
                        edgepaths: n.extendDeep([], t1.edgepaths),
                        paths: n.extendDeep([], t1.paths),
                        starts: n.extendDeep([], t1.starts)
                    });
                }
                t1.exports = function(t1, e1) {
                    var r, a, o, s = function(t1) {
                        return t1.reverse();
                    }, l = function(t1) {
                        return t1;
                    };
                    switch(e1){
                        case "=":
                        case "<":
                            return t1;
                        case ">":
                            for(1 !== t1.length && n.warn("Contour data invalid for the specified inequality operation."), a = t1[0], r = 0; r < a.edgepaths.length; r++)a.edgepaths[r] = s(a.edgepaths[r]);
                            for(r = 0; r < a.paths.length; r++)a.paths[r] = s(a.paths[r]);
                            for(r = 0; r < a.starts.length; r++)a.starts[r] = s(a.starts[r]);
                            return t1;
                        case "][":
                            var c = s;
                            s = l, l = c;
                        case "[]":
                            for(2 !== t1.length && n.warn("Contour data invalid for the specified inequality range operation."), a = i(t1[0]), o = i(t1[1]), r = 0; r < a.edgepaths.length; r++)a.edgepaths[r] = s(a.edgepaths[r]);
                            for(r = 0; r < a.paths.length; r++)a.paths[r] = s(a.paths[r]);
                            for(r = 0; r < a.starts.length; r++)a.starts[r] = s(a.starts[r]);
                            for(; o.edgepaths.length;)a.edgepaths.push(l(o.edgepaths.shift()));
                            for(; o.paths.length;)a.paths.push(l(o.paths.shift()));
                            for(; o.starts.length;)a.starts.push(l(o.starts.shift()));
                            return [
                                a
                            ];
                    }
                };
            },
            57543: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(86073), a = r(99669), o = r(29503), s = r(47495), l = r(39889), c = r(63814), u = r(52240);
                t1.exports = function(t1, e1, r, h) {
                    function f(r, i) {
                        return n.coerce(t1, e1, u, r, i);
                    }
                    if (i(t1, e1, f, h)) {
                        a(t1, e1, h, f), f("xhoverformat"), f("yhoverformat"), f("text"), f("hovertext"), f("hoverongaps"), f("hovertemplate");
                        var p = "constraint" === f("contours.type");
                        f("connectgaps", n.isArray1D(e1.z)), p ? o(t1, e1, f, h, r) : (s(t1, e1, f, function(r) {
                            return n.coerce2(t1, e1, u, r);
                        }), l(t1, e1, f, h)), e1.contours && "heatmap" === e1.contours.coloring && c(f, h), f("zorder");
                    } else e1.visible = !1;
                };
            },
            86828: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(22783), a = r(48715);
                t1.exports = function(t1, e1, r) {
                    for(var o = "constraint" === t1.type ? i[t1._operation](t1.value) : t1, s = o.size, l = [], c = a(o), u = r.trace._carpetTrace, h = u ? {
                        xaxis: u.aaxis,
                        yaxis: u.baxis,
                        x: r.a,
                        y: r.b
                    } : {
                        xaxis: e1.xaxis,
                        yaxis: e1.yaxis,
                        x: r.x,
                        y: r.y
                    }, f = o.start; f < c; f += s)if (l.push(n.extendFlat({
                        level: f,
                        crossings: {},
                        starts: [],
                        edgepaths: [],
                        paths: [],
                        z: r.z,
                        smoothing: r.trace.line.smoothing
                    }, h)), l.length > 1e3) {
                        n.warn("Too many contours, clipping at 1000", t1);
                        break;
                    }
                    return l;
                };
            },
            48715: function(t1) {
                "use strict";
                t1.exports = function(t1) {
                    return t1.end + t1.size / 1e6;
                };
            },
            27657: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(53156);
                function a(t1, e1, r, n) {
                    return Math.abs(t1[0] - e1[0]) < r && Math.abs(t1[1] - e1[1]) < n;
                }
                function o(t1, e1, r, o, l) {
                    var c, u = e1.join(","), h = t1.crossings[u], f = function(t1, e1, r) {
                        var n = 0, a = 0;
                        return t1 > 20 && e1 ? 208 === t1 || 1114 === t1 ? n = 0 === r[0] ? 1 : -1 : a = 0 === r[1] ? 1 : -1 : -1 !== i.BOTTOMSTART.indexOf(t1) ? a = 1 : -1 !== i.LEFTSTART.indexOf(t1) ? n = 1 : -1 !== i.TOPSTART.indexOf(t1) ? a = -1 : n = -1, [
                            n,
                            a
                        ];
                    }(h, r, e1), p = [
                        s(t1, e1, [
                            -f[0],
                            -f[1]
                        ])
                    ], d = t1.z.length, m = t1.z[0].length, g = e1.slice(), y = f.slice();
                    for(c = 0; c < 1e4; c++){
                        if (h > 20 ? (h = i.CHOOSESADDLE[h][(f[0] || f[1]) < 0 ? 0 : 1], t1.crossings[u] = i.SADDLEREMAINDER[h]) : delete t1.crossings[u], !(f = i.NEWDELTA[h])) {
                            n.log("Found bad marching index:", h, e1, t1.level);
                            break;
                        }
                        p.push(s(t1, e1, f)), e1[0] += f[0], e1[1] += f[1], u = e1.join(","), a(p[p.length - 1], p[p.length - 2], o, l) && p.pop();
                        var v = f[0] && (e1[0] < 0 || e1[0] > m - 2) || f[1] && (e1[1] < 0 || e1[1] > d - 2);
                        if (e1[0] === g[0] && e1[1] === g[1] && f[0] === y[0] && f[1] === y[1] || r && v) break;
                        h = t1.crossings[u];
                    }
                    1e4 === c && n.log("Infinite loop in contour?");
                    var x, _, b, w, T, k, A, M, S, E, C, L, I, P, z, O = a(p[0], p[p.length - 1], o, l), D = 0, R = .2 * t1.smoothing, F = [], B = 0;
                    for(c = 1; c < p.length; c++)L = p[c], I = p[c - 1], P = L[2] - I[2], z = L[3] - I[3], D += A = Math.sqrt(P * P + z * z), F.push(A);
                    var N = D / F.length * R;
                    function j(t1) {
                        return p[t1 % p.length];
                    }
                    for(c = p.length - 2; c >= B; c--)if ((x = F[c]) < N) {
                        for(b = 0, _ = c - 1; _ >= B && x + F[_] < N; _--)x += F[_];
                        if (O && c === p.length - 2) for(b = 0; b < _ && x + F[b] < N; b++)x += F[b];
                        T = c - _ + b + 1, k = Math.floor((c + _ + b + 2) / 2), w = O || c !== p.length - 2 ? O || -1 !== _ ? T % 2 ? j(k) : [
                            (j(k)[0] + j(k + 1)[0]) / 2,
                            (j(k)[1] + j(k + 1)[1]) / 2
                        ] : p[0] : p[p.length - 1], p.splice(_ + 1, c - _ + 1, w), c = _ + 1, b && (B = b), O && (c === p.length - 2 ? p[b] = p[p.length - 1] : 0 === c && (p[p.length - 1] = p[0]));
                    }
                    for(p.splice(0, B), c = 0; c < p.length; c++)p[c].length = 2;
                    if (!(p.length < 2)) {
                        if (O) p.pop(), t1.paths.push(p);
                        else {
                            r || n.log("Unclosed interior contour?", t1.level, g.join(","), p.join("L"));
                            var U = !1;
                            for(M = 0; M < t1.edgepaths.length; M++)if (E = t1.edgepaths[M], !U && a(E[0], p[p.length - 1], o, l)) {
                                p.pop(), U = !0;
                                var V = !1;
                                for(S = 0; S < t1.edgepaths.length; S++)if (a((C = t1.edgepaths[S])[C.length - 1], p[0], o, l)) {
                                    V = !0, p.shift(), t1.edgepaths.splice(M, 1), S === M ? t1.paths.push(p.concat(C)) : (S > M && S--, t1.edgepaths[S] = C.concat(p, E));
                                    break;
                                }
                                V || (t1.edgepaths[M] = p.concat(E));
                            }
                            for(M = 0; M < t1.edgepaths.length && !U; M++)a((E = t1.edgepaths[M])[E.length - 1], p[0], o, l) && (p.shift(), t1.edgepaths[M] = E.concat(p), U = !0);
                            U || t1.edgepaths.push(p);
                        }
                    }
                }
                function s(t1, e1, r) {
                    var n = e1[0] + Math.max(r[0], 0), i = e1[1] + Math.max(r[1], 0), a = t1.z[i][n], o = t1.xaxis, s = t1.yaxis;
                    if (r[1]) {
                        var l = (t1.level - a) / (t1.z[i][n + 1] - a), c = (1 !== l ? (1 - l) * o.c2l(t1.x[n]) : 0) + (0 !== l ? l * o.c2l(t1.x[n + 1]) : 0);
                        return [
                            o.c2p(o.l2c(c), !0),
                            s.c2p(t1.y[i], !0),
                            n + l,
                            i
                        ];
                    }
                    var u = (t1.level - a) / (t1.z[i + 1][n] - a), h = (1 !== u ? (1 - u) * s.c2l(t1.y[i]) : 0) + (0 !== u ? u * s.c2l(t1.y[i + 1]) : 0);
                    return [
                        o.c2p(t1.x[n], !0),
                        s.c2p(s.l2c(h), !0),
                        n,
                        i + u
                    ];
                }
                t1.exports = function(t1, e1, r) {
                    var i, a, s, l;
                    for(e1 = e1 || .01, r = r || .01, a = 0; a < t1.length; a++){
                        for(s = t1[a], l = 0; l < s.starts.length; l++)o(s, s.starts[l], "edge", e1, r);
                        for(i = 0; Object.keys(s.crossings).length && i < 1e4;)i++, o(s, Object.keys(s.crossings)[0].split(",").map(Number), void 0, e1, r);
                        1e4 === i && n.log("Infinite loop in contour?");
                    }
                };
            },
            29815: function(t1, e1, r) {
                "use strict";
                var n = r(78766), i = r(93125);
                t1.exports = function(t1, e1, r, a, o) {
                    o || (o = {}), o.isContour = !0;
                    var s = i(t1, e1, r, a, o);
                    return s && s.forEach(function(t1) {
                        var e1 = t1.trace;
                        "constraint" === e1.contours.type && (e1.fillcolor && n.opacity(e1.fillcolor) ? t1.color = n.addOpacity(e1.fillcolor, 1) : e1.contours.showlines && n.opacity(e1.line.color) && (t1.color = n.addOpacity(e1.line.color, 1)));
                    }), s;
                };
            },
            91405: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    attributes: r(52240),
                    supplyDefaults: r(57543),
                    calc: r(40352),
                    plot: r(8850).plot,
                    style: r(1328),
                    colorbar: r(92697),
                    hoverPoints: r(29815),
                    moduleType: "trace",
                    name: "contour",
                    basePlotModule: r(37703),
                    categories: [
                        "cartesian",
                        "svg",
                        "2dMap",
                        "contour",
                        "showLegend"
                    ],
                    meta: {}
                };
            },
            20576: function(t1, e1, r) {
                "use strict";
                var n = r(34809);
                t1.exports = function(t1, e1, r, i) {
                    if (i || (i = {}), t1("contours.showlabels")) {
                        var a = e1.font;
                        n.coerceFont(t1, "contours.labelfont", a, {
                            overrideDflt: {
                                color: r
                            }
                        }), t1("contours.labelformat");
                    }
                    !1 !== i.hasHover && t1("zhoverformat");
                };
            },
            16438: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(88856), a = r(48715);
                t1.exports = function(t1) {
                    var e1 = t1.contours, r = e1.start, o = a(e1), s = e1.size || 1, l = Math.floor((o - r) / s) + 1, c = "lines" === e1.coloring ? 0 : 1, u = i.extractOpts(t1);
                    isFinite(s) || (s = 1, l = 1);
                    var h, f, p = u.reversescale ? i.flipScale(u.colorscale) : u.colorscale, d = p.length, m = new Array(d), g = new Array(d), y = u.min, v = u.max;
                    if ("heatmap" === e1.coloring) {
                        for(f = 0; f < d; f++)h = p[f], m[f] = h[0] * (v - y) + y, g[f] = h[1];
                        var x = n.extent([
                            y,
                            v,
                            e1.start,
                            e1.start + s * (l - 1)
                        ]), _ = x[y < v ? 0 : 1], b = x[y < v ? 1 : 0];
                        _ !== y && (m.splice(0, 0, _), g.splice(0, 0, g[0])), b !== v && (m.push(b), g.push(g[g.length - 1]));
                    } else {
                        var w = t1._input && "number" == typeof t1._input.zmin && "number" == typeof t1._input.zmax;
                        for(w && (r <= y || o >= v) && (r <= y && (r = y), o >= v && (o = v), l = Math.floor((o - r) / s) + 1, c = 0), f = 0; f < d; f++)h = p[f], m[f] = (h[0] * (l + c - 1) - c / 2) * s + r, g[f] = h[1];
                        (w || t1.autocontour) && (m[0] > y && (m.unshift(y), g.unshift(g[0])), m[m.length - 1] < v && (m.push(v), g.push(g[g.length - 1])));
                    }
                    return i.makeColorScaleFunc({
                        domain: m,
                        range: g
                    }, {
                        noNumericCheck: !0
                    });
                };
            },
            83545: function(t1, e1, r) {
                "use strict";
                var n = r(53156);
                function i(t1, e1) {
                    var r = (e1[0][0] > t1 ? 0 : 1) + (e1[0][1] > t1 ? 0 : 2) + (e1[1][1] > t1 ? 0 : 4) + (e1[1][0] > t1 ? 0 : 8);
                    return 5 === r || 10 === r ? t1 > (e1[0][0] + e1[0][1] + e1[1][0] + e1[1][1]) / 4 ? 5 === r ? 713 : 1114 : 5 === r ? 104 : 208 : 15 === r ? 0 : r;
                }
                t1.exports = function(t1) {
                    var e1, r, a, o, s, l, c, u, h, f = t1[0].z, p = f.length, d = f[0].length, m = 2 === p || 2 === d;
                    for(r = 0; r < p - 1; r++)for(o = [], 0 === r && (o = o.concat(n.BOTTOMSTART)), r === p - 2 && (o = o.concat(n.TOPSTART)), e1 = 0; e1 < d - 1; e1++)for(a = o.slice(), 0 === e1 && (a = a.concat(n.LEFTSTART)), e1 === d - 2 && (a = a.concat(n.RIGHTSTART)), s = e1 + "," + r, l = [
                        [
                            f[r][e1],
                            f[r][e1 + 1]
                        ],
                        [
                            f[r + 1][e1],
                            f[r + 1][e1 + 1]
                        ]
                    ], h = 0; h < t1.length; h++)(c = i((u = t1[h]).level, l)) && (u.crossings[s] = c, -1 !== a.indexOf(c) && (u.starts.push([
                        e1,
                        r
                    ]), m && -1 !== a.indexOf(c, a.indexOf(c) + 1) && u.starts.push([
                        e1,
                        r
                    ])));
                };
            },
            8850: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(34809), a = r(62203), o = r(88856), s = r(30635), l = r(29714), c = r(19091), u = r(19236), h = r(83545), f = r(27657), p = r(86828), d = r(1999), m = r(49886), g = r(53156), y = g.LABELOPTIMIZER;
                function v(t1, e1) {
                    var r, n, o, s, l, c, u, h = "", f = 0, p = t1.edgepaths.map(function(t1, e1) {
                        return e1;
                    }), d = !0;
                    function m(t1) {
                        return Math.abs(t1[1] - e1[2][1]) < .01;
                    }
                    function g(t1) {
                        return Math.abs(t1[0] - e1[0][0]) < .01;
                    }
                    function y(t1) {
                        return Math.abs(t1[0] - e1[2][0]) < .01;
                    }
                    for(; p.length;){
                        for(c = a.smoothopen(t1.edgepaths[f], t1.smoothing), h += d ? c : c.replace(/^M/, "L"), p.splice(p.indexOf(f), 1), r = t1.edgepaths[f][t1.edgepaths[f].length - 1], s = -1, o = 0; o < 4; o++){
                            if (!r) {
                                i.log("Missing end?", f, t1);
                                break;
                            }
                            for(u = r, Math.abs(u[1] - e1[0][1]) < .01 && !y(r) ? n = e1[1] : g(r) ? n = e1[0] : m(r) ? n = e1[3] : y(r) && (n = e1[2]), l = 0; l < t1.edgepaths.length; l++){
                                var v = t1.edgepaths[l][0];
                                Math.abs(r[0] - n[0]) < .01 ? Math.abs(r[0] - v[0]) < .01 && (v[1] - r[1]) * (n[1] - v[1]) >= 0 && (n = v, s = l) : Math.abs(r[1] - n[1]) < .01 ? Math.abs(r[1] - v[1]) < .01 && (v[0] - r[0]) * (n[0] - v[0]) >= 0 && (n = v, s = l) : i.log("endpt to newendpt is not vert. or horz.", r, n, v);
                            }
                            if (r = n, s >= 0) break;
                            h += "L" + n;
                        }
                        if (s === t1.edgepaths.length) {
                            i.log("unclosed perimeter path");
                            break;
                        }
                        f = s, (d = -1 === p.indexOf(f)) && (f = p[0], h += "Z");
                    }
                    for(f = 0; f < t1.paths.length; f++)h += a.smoothclosed(t1.paths[f], t1.smoothing);
                    return h;
                }
                function x(t1, e1, r, n) {
                    var a = e1.width / 2, o = e1.height / 2, s = t1.x, l = t1.y, c = t1.theta, u = Math.cos(c) * a, h = Math.sin(c) * a, f = (s > n.center ? n.right - s : s - n.left) / (u + Math.abs(Math.sin(c) * o)), p = (l > n.middle ? n.bottom - l : l - n.top) / (Math.abs(h) + Math.cos(c) * o);
                    if (f < 1 || p < 1) return 1 / 0;
                    var d = y.EDGECOST * (1 / (f - 1) + 1 / (p - 1));
                    d += y.ANGLECOST * c * c;
                    for(var m = s - u, g = l - h, v = s + u, x = l + h, _ = 0; _ < r.length; _++){
                        var b = r[_], w = Math.cos(b.theta) * b.width / 2, T = Math.sin(b.theta) * b.width / 2, k = 2 * i.segmentDistance(m, g, v, x, b.x - w, b.y - T, b.x + w, b.y + T) / (e1.height + b.height), A = b.level === e1.level, M = A ? y.SAMELEVELDISTANCE : 1;
                        if (k <= M) return 1 / 0;
                        d += y.NEIGHBORCOST * (A ? y.SAMELEVELFACTOR : 1) / (k - M);
                    }
                    return d;
                }
                function _(t1) {
                    var e1, r, n = t1.trace._emptypoints, i = [], a = t1.z.length, o = t1.z[0].length, s = [];
                    for(e1 = 0; e1 < o; e1++)s.push(1);
                    for(e1 = 0; e1 < a; e1++)i.push(s.slice());
                    for(e1 = 0; e1 < n.length; e1++)i[(r = n[e1])[0]][r[1]] = 0;
                    return t1.zmask = i, i;
                }
                e1.plot = function(t1, r, o, s) {
                    var l = r.xaxis, c = r.yaxis;
                    i.makeTraceGroups(s, o, "contour").each(function(o) {
                        var s = n.select(this), y = o[0], x = y.trace, b = y.x, w = y.y, T = x.contours, k = p(T, r, y), A = i.ensureSingle(s, "g", "heatmapcoloring"), M = [];
                        "heatmap" === T.coloring && (M = [
                            o
                        ]), u(t1, r, M, A), h(k), f(k);
                        var S = l.c2p(b[0], !0), E = l.c2p(b[b.length - 1], !0), C = c.c2p(w[0], !0), L = c.c2p(w[w.length - 1], !0), I = [
                            [
                                S,
                                L
                            ],
                            [
                                E,
                                L
                            ],
                            [
                                E,
                                C
                            ],
                            [
                                S,
                                C
                            ]
                        ], P = k;
                        "constraint" === T.type && (P = d(k, T._operation)), function(t1, e1, r) {
                            var n = i.ensureSingle(t1, "g", "contourbg").selectAll("path").data("fill" === r.coloring ? [
                                0
                            ] : []);
                            n.enter().append("path"), n.exit().remove(), n.attr("d", "M" + e1.join("L") + "Z").style("stroke", "none");
                        }(s, I, T), function(t1, e1, r, a) {
                            var o = "fill" === a.coloring || "constraint" === a.type && "=" !== a._operation, s = "M" + r.join("L") + "Z";
                            o && m(e1, a);
                            var l = i.ensureSingle(t1, "g", "contourfill").selectAll("path").data(o ? e1 : []);
                            l.enter().append("path"), l.exit().remove(), l.each(function(t1) {
                                var e1 = (t1.prefixBoundary ? s : "") + v(t1, r);
                                e1 ? n.select(this).attr("d", e1).style("stroke", "none") : n.select(this).remove();
                            });
                        }(s, P, I, T), function(t1, r, o, s, l) {
                            var c = o._context.staticPlot, u = i.ensureSingle(t1, "g", "contourlines"), h = !1 !== l.showlines, f = l.showlabels, p = h && f, d = e1.createLines(u, h || f, r, c), m = e1.createLineClip(u, p, o, s.trace.uid), y = t1.selectAll("g.contourlabels").data(f ? [
                                0
                            ] : []);
                            if (y.exit().remove(), y.enter().append("g").classed("contourlabels", !0), f) {
                                var v = [], x = [];
                                i.clearLocationCache();
                                var _ = e1.labelFormatter(o, s), b = a.tester.append("text").attr("data-notex", 1).call(a.font, l.labelfont), w = r[0].xaxis, T = r[0].yaxis, k = w._length, A = T._length, M = w.range, S = T.range, E = i.aggNums(Math.min, null, s.x), C = i.aggNums(Math.max, null, s.x), L = i.aggNums(Math.min, null, s.y), I = i.aggNums(Math.max, null, s.y), P = Math.max(w.c2p(E, !0), 0), z = Math.min(w.c2p(C, !0), k), O = Math.max(T.c2p(I, !0), 0), D = Math.min(T.c2p(L, !0), A), R = {};
                                M[0] < M[1] ? (R.left = P, R.right = z) : (R.left = z, R.right = P), S[0] < S[1] ? (R.top = O, R.bottom = D) : (R.top = D, R.bottom = O), R.middle = (R.top + R.bottom) / 2, R.center = (R.left + R.right) / 2, v.push([
                                    [
                                        R.left,
                                        R.top
                                    ],
                                    [
                                        R.right,
                                        R.top
                                    ],
                                    [
                                        R.right,
                                        R.bottom
                                    ],
                                    [
                                        R.left,
                                        R.bottom
                                    ]
                                ]);
                                var F = Math.sqrt(k * k + A * A), B = g.LABELDISTANCE * F / Math.max(1, r.length / g.LABELINCREASE);
                                d.each(function(t1) {
                                    var r = e1.calcTextOpts(t1.level, _, b, o);
                                    n.select(this).selectAll("path").each(function() {
                                        var t1 = i.getVisibleSegment(this, R, r.height / 2);
                                        if (t1 && !(t1.len < (r.width + r.height) * g.LABELMIN)) for(var n = Math.min(Math.ceil(t1.len / B), g.LABELMAX), a = 0; a < n; a++){
                                            var o = e1.findBestTextLocation(this, t1, r, x, R);
                                            if (!o) break;
                                            e1.addLabelData(o, r, x, v);
                                        }
                                    });
                                }), b.remove(), e1.drawLabels(y, x, o, m, p ? v : null);
                            }
                            f && !h && d.remove();
                        }(s, k, t1, y, T), function(t1, e1, r, n, o) {
                            var s = n.trace, l = r._fullLayout._clips, c = "clip" + s.uid, u = l.selectAll("#" + c).data(s.connectgaps ? [] : [
                                0
                            ]);
                            if (u.enter().append("clipPath").classed("contourclip", !0).attr("id", c), u.exit().remove(), !1 === s.connectgaps) {
                                var p = {
                                    level: .9,
                                    crossings: {},
                                    starts: [],
                                    edgepaths: [],
                                    paths: [],
                                    xaxis: e1.xaxis,
                                    yaxis: e1.yaxis,
                                    x: n.x,
                                    y: n.y,
                                    z: _(n),
                                    smoothing: 0
                                };
                                h([
                                    p
                                ]), f([
                                    p
                                ]), m([
                                    p
                                ], {
                                    type: "levels"
                                }), i.ensureSingle(u, "path", "").attr("d", (p.prefixBoundary ? "M" + o.join("L") + "Z" : "") + v(p, o));
                            } else c = null;
                            a.setClipUrl(t1, c, r);
                        }(s, r, t1, y, I);
                    });
                }, e1.createLines = function(t1, e1, r, n) {
                    var i = r[0].smoothing, o = t1.selectAll("g.contourlevel").data(e1 ? r : []);
                    if (o.exit().remove(), o.enter().append("g").classed("contourlevel", !0), e1) {
                        var s = o.selectAll("path.openline").data(function(t1) {
                            return t1.pedgepaths || t1.edgepaths;
                        });
                        s.exit().remove(), s.enter().append("path").classed("openline", !0), s.attr("d", function(t1) {
                            return a.smoothopen(t1, i);
                        }).style("stroke-miterlimit", 1).style("vector-effect", n ? "none" : "non-scaling-stroke");
                        var l = o.selectAll("path.closedline").data(function(t1) {
                            return t1.ppaths || t1.paths;
                        });
                        l.exit().remove(), l.enter().append("path").classed("closedline", !0), l.attr("d", function(t1) {
                            return a.smoothclosed(t1, i);
                        }).style("stroke-miterlimit", 1).style("vector-effect", n ? "none" : "non-scaling-stroke");
                    }
                    return o;
                }, e1.createLineClip = function(t1, e1, r, n) {
                    var i = e1 ? "clipline" + n : null, o = r._fullLayout._clips.selectAll("#" + i).data(e1 ? [
                        0
                    ] : []);
                    return o.exit().remove(), o.enter().append("clipPath").classed("contourlineclip", !0).attr("id", i), a.setClipUrl(t1, i, r), o;
                }, e1.labelFormatter = function(t1, e1) {
                    var r = t1._fullLayout, n = e1.trace, a = n.contours, s = {
                        type: "linear",
                        _id: "ycontour",
                        showexponent: "all",
                        exponentformat: "B"
                    };
                    if (a.labelformat) s.tickformat = a.labelformat, c(s, r);
                    else {
                        var u = o.extractOpts(n);
                        if (u && u.colorbar && u.colorbar._axis) s = u.colorbar._axis;
                        else {
                            if ("constraint" === a.type) {
                                var h = a.value;
                                i.isArrayOrTypedArray(h) ? s.range = [
                                    h[0],
                                    h[h.length - 1]
                                ] : s.range = [
                                    h,
                                    h
                                ];
                            } else s.range = [
                                a.start,
                                a.end
                            ], s.nticks = (a.end - a.start) / a.size;
                            s.range[0] === s.range[1] && (s.range[1] += s.range[0] || 1), s.nticks || (s.nticks = 1e3), c(s, r), l.prepTicks(s), s._tmin = null, s._tmax = null;
                        }
                    }
                    return function(t1) {
                        return l.tickText(s, t1).text;
                    };
                }, e1.calcTextOpts = function(t1, e1, r, n) {
                    var i = e1(t1);
                    r.text(i).call(s.convertToTspans, n);
                    var o = r.node(), l = a.bBox(o, !0);
                    return {
                        text: i,
                        width: l.width,
                        height: l.height,
                        fontSize: +o.style["font-size"].replace("px", ""),
                        level: t1,
                        dy: (l.top + l.bottom) / 2
                    };
                }, e1.findBestTextLocation = function(t1, e1, r, n, a) {
                    var o, s, l, c, u, h = r.width;
                    e1.isClosed ? (s = e1.len / y.INITIALSEARCHPOINTS, o = e1.min + s / 2, l = e1.max) : (s = (e1.len - h) / (y.INITIALSEARCHPOINTS + 1), o = e1.min + s + h / 2, l = e1.max - (s + h) / 2);
                    for(var f = 1 / 0, p = 0; p < y.ITERATIONS; p++){
                        for(var d = o; d < l; d += s){
                            var m = i.getTextLocation(t1, e1.total, d, h), g = x(m, r, n, a);
                            g < f && (f = g, u = m, c = d);
                        }
                        if (f > 2 * y.MAXCOST) break;
                        p && (s /= 2), l = (o = c - s / 2) + 1.5 * s;
                    }
                    if (f <= y.MAXCOST) return u;
                }, e1.addLabelData = function(t1, e1, r, n) {
                    var i = e1.fontSize, a = e1.width + i / 3, o = Math.max(0, e1.height - i / 3), s = t1.x, l = t1.y, c = t1.theta, u = Math.sin(c), h = Math.cos(c), f = function(t1, e1) {
                        return [
                            s + t1 * h - e1 * u,
                            l + t1 * u + e1 * h
                        ];
                    }, p = [
                        f(-a / 2, -o / 2),
                        f(-a / 2, o / 2),
                        f(a / 2, o / 2),
                        f(a / 2, -o / 2)
                    ];
                    r.push({
                        text: e1.text,
                        x: s,
                        y: l,
                        dy: e1.dy,
                        theta: c,
                        level: e1.level,
                        width: a,
                        height: o
                    }), n.push(p);
                }, e1.drawLabels = function(t1, e1, r, a, o) {
                    var l = t1.selectAll("text").data(e1, function(t1) {
                        return t1.text + "," + t1.x + "," + t1.y + "," + t1.theta;
                    });
                    if (l.exit().remove(), l.enter().append("text").attr({
                        "data-notex": 1,
                        "text-anchor": "middle"
                    }).each(function(t1) {
                        var e1 = t1.x + Math.sin(t1.theta) * t1.dy, i = t1.y - Math.cos(t1.theta) * t1.dy;
                        n.select(this).text(t1.text).attr({
                            x: e1,
                            y: i,
                            transform: "rotate(" + 180 * t1.theta / Math.PI + " " + e1 + " " + i + ")"
                        }).call(s.convertToTspans, r);
                    }), o) {
                        for(var c = "", u = 0; u < o.length; u++)c += "M" + o[u].join("L") + "Z";
                        i.ensureSingle(a, "path", "").attr("d", c);
                    }
                };
            },
            62475: function(t1, e1, r) {
                "use strict";
                var n = r(29714), i = r(34809);
                function a(t1, e1, r) {
                    var i = {
                        type: "linear",
                        range: [
                            t1,
                            e1
                        ]
                    };
                    return n.autoTicks(i, (e1 - t1) / (r || 15)), i;
                }
                t1.exports = function(t1, e1) {
                    var r = t1.contours;
                    if (t1.autocontour) {
                        var o = t1.zmin, s = t1.zmax;
                        (t1.zauto || void 0 === o) && (o = i.aggNums(Math.min, null, e1)), (t1.zauto || void 0 === s) && (s = i.aggNums(Math.max, null, e1));
                        var l = a(o, s, t1.ncontours);
                        r.size = l.dtick, r.start = n.tickFirst(l), l.range.reverse(), r.end = n.tickFirst(l), r.start === o && (r.start += r.size), r.end === s && (r.end -= r.size), r.start > r.end && (r.start = r.end = (r.start + r.end) / 2), t1._input.contours || (t1._input.contours = {}), i.extendFlat(t1._input.contours, {
                            start: r.start,
                            end: r.end,
                            size: r.size
                        }), t1._input.autocontour = !0;
                    } else if ("constraint" !== r.type) {
                        var c, u = r.start, h = r.end, f = t1._input.contours;
                        u > h && (r.start = f.start = h, h = r.end = f.end = u, u = r.start), r.size > 0 || (c = u === h ? 1 : a(u, h, t1.ncontours).dtick, f.size = r.size = c);
                    }
                };
            },
            1328: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(62203), a = r(12774), o = r(16438);
                t1.exports = function(t1) {
                    var e1 = n.select(t1).selectAll("g.contour");
                    e1.style("opacity", function(t1) {
                        return t1[0].trace.opacity;
                    }), e1.each(function(t1) {
                        var e1 = n.select(this), r = t1[0].trace, a = r.contours, s = r.line, l = a.size || 1, c = a.start, u = "constraint" === a.type, h = !u && "lines" === a.coloring, f = !u && "fill" === a.coloring, p = h || f ? o(r) : null;
                        e1.selectAll("g.contourlevel").each(function(t1) {
                            n.select(this).selectAll("path").call(i.lineGroupStyle, s.width, h ? p(t1.level) : s.color, s.dash);
                        });
                        var d = a.labelfont;
                        if (e1.selectAll("g.contourlabels text").each(function(t1) {
                            i.font(n.select(this), {
                                weight: d.weight,
                                style: d.style,
                                variant: d.variant,
                                textcase: d.textcase,
                                lineposition: d.lineposition,
                                shadow: d.shadow,
                                family: d.family,
                                size: d.size,
                                color: d.color || (h ? p(t1.level) : s.color)
                            });
                        }), u) e1.selectAll("g.contourfill path").style("fill", r.fillcolor);
                        else if (f) {
                            var m;
                            e1.selectAll("g.contourfill path").style("fill", function(t1) {
                                return void 0 === m && (m = t1.level), p(t1.level + .5 * l);
                            }), void 0 === m && (m = c), e1.selectAll("g.contourbg path").style("fill", p(m - .5 * l));
                        }
                    }), a(t1);
                };
            },
            39889: function(t1, e1, r) {
                "use strict";
                var n = r(39356), i = r(20576);
                t1.exports = function(t1, e1, r, a, o) {
                    var s, l = r("contours.coloring"), c = "";
                    "fill" === l && (s = r("contours.showlines")), !1 !== s && ("lines" !== l && (c = r("line.color", "#000")), r("line.width", .5), r("line.dash")), "none" !== l && (!0 !== t1.showlegend && (e1.showlegend = !1), e1._dfltShowLegend = !1, n(t1, e1, a, r, {
                        prefix: "",
                        cLetter: "z"
                    })), r("line.smoothing"), i(r, a, c, o);
                };
            },
            66365: function(t1, e1, r) {
                "use strict";
                var n = r(81658), i = r(52240), a = r(87163), o = r(93049).extendFlat, s = i.contours;
                t1.exports = o({
                    carpet: {
                        valType: "string",
                        editType: "calc"
                    },
                    z: n.z,
                    a: n.x,
                    a0: n.x0,
                    da: n.dx,
                    b: n.y,
                    b0: n.y0,
                    db: n.dy,
                    text: n.text,
                    hovertext: n.hovertext,
                    transpose: n.transpose,
                    atype: n.xtype,
                    btype: n.ytype,
                    fillcolor: i.fillcolor,
                    autocontour: i.autocontour,
                    ncontours: i.ncontours,
                    contours: {
                        type: s.type,
                        start: s.start,
                        end: s.end,
                        size: s.size,
                        coloring: {
                            valType: "enumerated",
                            values: [
                                "fill",
                                "lines",
                                "none"
                            ],
                            dflt: "fill",
                            editType: "calc"
                        },
                        showlines: s.showlines,
                        showlabels: s.showlabels,
                        labelfont: s.labelfont,
                        labelformat: s.labelformat,
                        operation: s.operation,
                        value: s.value,
                        editType: "calc",
                        impliedEdits: {
                            autocontour: !1
                        }
                    },
                    line: {
                        color: i.line.color,
                        width: i.line.width,
                        dash: i.line.dash,
                        smoothing: i.line.smoothing,
                        editType: "plot"
                    },
                    zorder: i.zorder,
                    transforms: void 0
                }, a("", {
                    cLetter: "z",
                    autoColorDflt: !1
                }));
            },
            80849: function(t1, e1, r) {
                "use strict";
                var n = r(28379), i = r(34809), a = r(87869), o = r(93877), s = r(69295), l = r(78106), c = r(80924), u = r(50538), h = r(26571), f = r(62475);
                t1.exports = function(t1, e1) {
                    var r = e1._carpetTrace = h(t1, e1);
                    if (r && r.visible && "legendonly" !== r.visible) {
                        if (!e1.a || !e1.b) {
                            var p = t1.data[r.index], d = t1.data[e1.index];
                            d.a || (d.a = p.a), d.b || (d.b = p.b), u(d, e1, e1._defaultColor, t1._fullLayout);
                        }
                        var m = function(t1, e1) {
                            var r, u, h, f, p, d, m, g = e1._carpetTrace, y = g.aaxis, v = g.baxis;
                            y._minDtick = 0, v._minDtick = 0, i.isArray1D(e1.z) && a(e1, y, v, "a", "b", [
                                "z"
                            ]), r = e1._a = e1._a || e1.a, f = e1._b = e1._b || e1.b, r = r ? y.makeCalcdata(e1, "_a") : [], f = f ? v.makeCalcdata(e1, "_b") : [], u = e1.a0 || 0, h = e1.da || 1, p = e1.b0 || 0, d = e1.db || 1, m = e1._z = o(e1._z || e1.z, e1.transpose), e1._emptypoints = l(m), s(m, e1._emptypoints);
                            var x = i.maxRowLength(m), _ = "scaled" === e1.xtype ? "" : r, b = c(e1, _, u, h, x, y), w = "scaled" === e1.ytype ? "" : f, T = {
                                a: b,
                                b: c(e1, w, p, d, m.length, v),
                                z: m
                            };
                            return "levels" === e1.contours.type && "none" !== e1.contours.coloring && n(t1, e1, {
                                vals: m,
                                containerStr: "",
                                cLetter: "z"
                            }), [
                                T
                            ];
                        }(t1, e1);
                        return f(e1, e1._z), m;
                    }
                };
            },
            50538: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(86073), a = r(66365), o = r(29503), s = r(47495), l = r(39889);
                t1.exports = function(t1, e1, r, c) {
                    function u(r, i) {
                        return n.coerce(t1, e1, a, r, i);
                    }
                    if (u("carpet"), t1.a && t1.b) {
                        if (!i(t1, e1, u, c, "a", "b")) return void (e1.visible = !1);
                        u("text"), "constraint" === u("contours.type") ? o(t1, e1, u, c, r, {
                            hasHover: !1
                        }) : (s(t1, e1, u, function(r) {
                            return n.coerce2(t1, e1, a, r);
                        }), l(t1, e1, u, c, {
                            hasHover: !1
                        }));
                    } else e1._defaultColor = r, e1._length = null;
                    u("zorder");
                };
            },
            34406: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    attributes: r(66365),
                    supplyDefaults: r(50538),
                    colorbar: r(92697),
                    calc: r(80849),
                    plot: r(71815),
                    style: r(1328),
                    moduleType: "trace",
                    name: "contourcarpet",
                    basePlotModule: r(37703),
                    categories: [
                        "cartesian",
                        "svg",
                        "carpet",
                        "contour",
                        "symbols",
                        "showLegend",
                        "hasLines",
                        "carpetDependent",
                        "noHover",
                        "noSortingByValue"
                    ],
                    meta: {}
                };
            },
            71815: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(6720), a = r(3685), o = r(62203), s = r(34809), l = r(83545), c = r(27657), u = r(8850), h = r(53156), f = r(1999), p = r(86828), d = r(49886), m = r(26571), g = r(94903);
                function y(t1, e1, r) {
                    var n = t1.getPointAtLength(e1), i = t1.getPointAtLength(r), a = i.x - n.x, o = i.y - n.y, s = Math.sqrt(a * a + o * o);
                    return [
                        a / s,
                        o / s
                    ];
                }
                function v(t1) {
                    var e1 = Math.sqrt(t1[0] * t1[0] + t1[1] * t1[1]);
                    return [
                        t1[0] / e1,
                        t1[1] / e1
                    ];
                }
                function x(t1, e1) {
                    var r = Math.abs(t1[0] * e1[0] + t1[1] * e1[1]);
                    return Math.sqrt(1 - r * r) / r;
                }
                t1.exports = function(t1, e1, r, _) {
                    var b = e1.xaxis, w = e1.yaxis;
                    s.makeTraceGroups(_, r, "contour").each(function(r) {
                        var _ = n.select(this), T = r[0], k = T.trace, A = k._carpetTrace = m(t1, k), M = t1.calcdata[A.index][0];
                        if (A.visible && "legendonly" !== A.visible) {
                            var S = T.a, E = T.b, C = k.contours, L = p(C, e1, T), I = "constraint" === C.type, P = C._operation, z = I ? "=" === P ? "lines" : "fill" : C.coloring, O = [
                                [
                                    S[0],
                                    E[E.length - 1]
                                ],
                                [
                                    S[S.length - 1],
                                    E[E.length - 1]
                                ],
                                [
                                    S[S.length - 1],
                                    E[0]
                                ],
                                [
                                    S[0],
                                    E[0]
                                ]
                            ];
                            l(L);
                            var D = 1e-8 * (S[S.length - 1] - S[0]), R = 1e-8 * (E[E.length - 1] - E[0]);
                            c(L, D, R);
                            var F, B, N, j, U = L;
                            "constraint" === C.type && (U = f(L, P)), function(t1, e1) {
                                var r, n, i, a, o, s, l, c, u;
                                for(r = 0; r < t1.length; r++){
                                    for(o = (a = t1[r]).pedgepaths = [], s = a.ppaths = [], n = 0; n < a.edgepaths.length; n++){
                                        for(u = a.edgepaths[n], l = [], i = 0; i < u.length; i++)l[i] = e1(u[i]);
                                        o.push(l);
                                    }
                                    for(n = 0; n < a.paths.length; n++){
                                        for(u = a.paths[n], c = [], i = 0; i < u.length; i++)c[i] = e1(u[i]);
                                        s.push(c);
                                    }
                                }
                            }(L, H);
                            var V = [];
                            for(j = M.clipsegments.length - 1; j >= 0; j--)F = M.clipsegments[j], B = i([], F.x, b.c2p), N = i([], F.y, w.c2p), B.reverse(), N.reverse(), V.push(a(B, N, F.bicubic));
                            var q = "M" + V.join("L") + "Z";
                            !function(t1, e1, r, n, o, l) {
                                var c, u, h, f, p = s.ensureSingle(t1, "g", "contourbg").selectAll("path").data("fill" !== l || o ? [] : [
                                    0
                                ]);
                                p.enter().append("path"), p.exit().remove();
                                var d = [];
                                for(f = 0; f < e1.length; f++)c = e1[f], u = i([], c.x, r.c2p), h = i([], c.y, n.c2p), d.push(a(u, h, c.bicubic));
                                p.attr("d", "M" + d.join("L") + "Z").style("stroke", "none");
                            }(_, M.clipsegments, b, w, I, z), function(t1, e1, r, i, a, l, c, u, h, f, p) {
                                var m = "fill" === f;
                                m && d(a, t1.contours);
                                var y = s.ensureSingle(e1, "g", "contourfill").selectAll("path").data(m ? a : []);
                                y.enter().append("path"), y.exit().remove(), y.each(function(t1) {
                                    var e1 = (t1.prefixBoundary ? p : "") + function(t1, e1, r, n, i, a, l, c) {
                                        var u, h, f, p, d, m, y, v = "", x = e1.edgepaths.map(function(t1, e1) {
                                            return e1;
                                        }), _ = !0, b = 1e-4 * Math.abs(r[0][0] - r[2][0]), w = 1e-4 * Math.abs(r[0][1] - r[2][1]);
                                        function T(t1) {
                                            return Math.abs(t1[1] - r[0][1]) < w;
                                        }
                                        function k(t1) {
                                            return Math.abs(t1[1] - r[2][1]) < w;
                                        }
                                        function A(t1) {
                                            return Math.abs(t1[0] - r[0][0]) < b;
                                        }
                                        function M(t1) {
                                            return Math.abs(t1[0] - r[2][0]) < b;
                                        }
                                        function S(t1, e1) {
                                            var r, n, o, s, u = "";
                                            for(T(t1) && !M(t1) || k(t1) && !A(t1) ? (s = i.aaxis, o = g(i, a, [
                                                t1[0],
                                                e1[0]
                                            ], .5 * (t1[1] + e1[1]))) : (s = i.baxis, o = g(i, a, .5 * (t1[0] + e1[0]), [
                                                t1[1],
                                                e1[1]
                                            ])), r = 1; r < o.length; r++)for(u += s.smoothing ? "C" : "L", n = 0; n < o[r].length; n++){
                                                var h = o[r][n];
                                                u += [
                                                    l.c2p(h[0]),
                                                    c.c2p(h[1])
                                                ] + " ";
                                            }
                                            return u;
                                        }
                                        for(u = 0, h = null; x.length;){
                                            var E = e1.edgepaths[u][0];
                                            for(h && (v += S(h, E)), y = o.smoothopen(e1.edgepaths[u].map(n), e1.smoothing), v += _ ? y : y.replace(/^M/, "L"), x.splice(x.indexOf(u), 1), h = e1.edgepaths[u][e1.edgepaths[u].length - 1], d = -1, p = 0; p < 4; p++){
                                                if (!h) {
                                                    s.log("Missing end?", u, e1);
                                                    break;
                                                }
                                                for(T(h) && !M(h) ? f = r[1] : A(h) ? f = r[0] : k(h) ? f = r[3] : M(h) && (f = r[2]), m = 0; m < e1.edgepaths.length; m++){
                                                    var C = e1.edgepaths[m][0];
                                                    Math.abs(h[0] - f[0]) < b ? Math.abs(h[0] - C[0]) < b && (C[1] - h[1]) * (f[1] - C[1]) >= 0 && (f = C, d = m) : Math.abs(h[1] - f[1]) < w ? Math.abs(h[1] - C[1]) < w && (C[0] - h[0]) * (f[0] - C[0]) >= 0 && (f = C, d = m) : s.log("endpt to newendpt is not vert. or horz.", h, f, C);
                                                }
                                                if (d >= 0) break;
                                                v += S(h, f), h = f;
                                            }
                                            if (d === e1.edgepaths.length) {
                                                s.log("unclosed perimeter path");
                                                break;
                                            }
                                            u = d, (_ = -1 === x.indexOf(u)) && (u = x[0], v += S(h, f) + "Z", h = null);
                                        }
                                        for(u = 0; u < e1.paths.length; u++)v += o.smoothclosed(e1.paths[u].map(n), e1.smoothing);
                                        return v;
                                    }(0, t1, l, c, u, h, r, i);
                                    e1 ? n.select(this).attr("d", e1).style("stroke", "none") : n.select(this).remove();
                                });
                            }(k, _, b, w, U, O, H, A, M, z, q), function(t1, e1, r, i, a, l, c) {
                                var f = r._context.staticPlot, p = s.ensureSingle(t1, "g", "contourlines"), d = !1 !== a.showlines, m = a.showlabels, g = d && m, _ = u.createLines(p, d || m, e1, f), b = u.createLineClip(p, g, r, i.trace.uid), w = t1.selectAll("g.contourlabels").data(m ? [
                                    0
                                ] : []);
                                if (w.exit().remove(), w.enter().append("g").classed("contourlabels", !0), m) {
                                    var T = l.xaxis, k = l.yaxis, A = T._length, M = k._length, S = [
                                        [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                A,
                                                0
                                            ],
                                            [
                                                A,
                                                M
                                            ],
                                            [
                                                0,
                                                M
                                            ]
                                        ]
                                    ], E = [];
                                    s.clearLocationCache();
                                    var C = u.labelFormatter(r, i), L = o.tester.append("text").attr("data-notex", 1).call(o.font, a.labelfont), I = {
                                        left: 0,
                                        right: A,
                                        center: A / 2,
                                        top: 0,
                                        bottom: M,
                                        middle: M / 2
                                    }, P = Math.sqrt(A * A + M * M), z = h.LABELDISTANCE * P / Math.max(1, e1.length / h.LABELINCREASE);
                                    _.each(function(t1) {
                                        var e1 = u.calcTextOpts(t1.level, C, L, r);
                                        n.select(this).selectAll("path").each(function(r) {
                                            var n = this, i = s.getVisibleSegment(n, I, e1.height / 2);
                                            if (i && (function(t1, e1, r, n, i, a) {
                                                for(var o, s = 0; s < r.pedgepaths.length; s++)e1 === r.pedgepaths[s] && (o = r.edgepaths[s]);
                                                if (o) {
                                                    var l = i.a[0], c = i.a[i.a.length - 1], u = i.b[0], h = i.b[i.b.length - 1], f = y(t1, 0, 1), p = y(t1, n.total, n.total - 1), d = g(o[0], f), m = n.total - g(o[o.length - 1], p);
                                                    n.min < d && (n.min = d), n.max > m && (n.max = m), n.len = n.max - n.min;
                                                }
                                                function g(t1, e1) {
                                                    var r, n = 0, o = .1;
                                                    return (Math.abs(t1[0] - l) < o || Math.abs(t1[0] - c) < o) && (r = v(i.dxydb_rough(t1[0], t1[1], o)), n = Math.max(n, a * x(e1, r) / 2)), (Math.abs(t1[1] - u) < o || Math.abs(t1[1] - h) < o) && (r = v(i.dxyda_rough(t1[0], t1[1], o)), n = Math.max(n, a * x(e1, r) / 2)), n;
                                                }
                                            }(n, r, t1, i, c, e1.height), !(i.len < (e1.width + e1.height) * h.LABELMIN))) for(var a = Math.min(Math.ceil(i.len / z), h.LABELMAX), o = 0; o < a; o++){
                                                var l = u.findBestTextLocation(n, i, e1, E, I);
                                                if (!l) break;
                                                u.addLabelData(l, e1, E, S);
                                            }
                                        });
                                    }), L.remove(), u.drawLabels(w, E, r, b, g ? S : null);
                                }
                                m && !d && _.remove();
                            }(_, L, t1, T, C, e1, A), o.setClipUrl(_, A._clipPathId, t1);
                        }
                        function H(t1) {
                            var e1 = A.ab2xy(t1[0], t1[1], !0);
                            return [
                                b.c2p(e1[0]),
                                w.c2p(e1[1])
                            ];
                        }
                    });
                };
            },
            70690: function(t1, e1, r) {
                "use strict";
                var n = r(87163), i = r(3208).rb, a = r(9829), o = r(71388), s = r(93049).extendFlat;
                t1.exports = s({
                    lon: o.lon,
                    lat: o.lat,
                    z: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    radius: {
                        valType: "number",
                        editType: "plot",
                        arrayOk: !0,
                        min: 1,
                        dflt: 30
                    },
                    below: {
                        valType: "string",
                        editType: "plot"
                    },
                    text: o.text,
                    hovertext: o.hovertext,
                    hoverinfo: s({}, a.hoverinfo, {
                        flags: [
                            "lon",
                            "lat",
                            "z",
                            "text",
                            "name"
                        ]
                    }),
                    hovertemplate: i(),
                    showlegend: s({}, a.showlegend, {
                        dflt: !1
                    })
                }, n("", {
                    cLetter: "z",
                    editTypeOverride: "calc"
                }));
            },
            91582: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(34809).isArrayOrTypedArray, a = r(63821).BADNUM, o = r(28379), s = r(34809)._;
                t1.exports = function(t1, e1) {
                    for(var r = e1._length, l = new Array(r), c = e1.z, u = i(c) && c.length, h = 0; h < r; h++){
                        var f = l[h] = {}, p = e1.lon[h], d = e1.lat[h];
                        if (f.lonlat = n(p) && n(d) ? [
                            +p,
                            +d
                        ] : [
                            a,
                            a
                        ], u) {
                            var m = c[h];
                            f.z = n(m) ? m : a;
                        }
                    }
                    return o(t1, e1, {
                        vals: u ? c : [
                            0,
                            1
                        ],
                        containerStr: "",
                        cLetter: "z"
                    }), r && (l[0].t = {
                        labels: {
                            lat: s(t1, "lat:") + " ",
                            lon: s(t1, "lon:") + " "
                        }
                    }), l;
                };
            },
            95012: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(34809), a = r(78766), o = r(88856), s = r(63821).BADNUM, l = r(39532).makeBlank;
                t1.exports = function(t1) {
                    var e1 = t1[0].trace, r = !0 === e1.visible && 0 !== e1._length, c = e1._opts = {
                        heatmap: {
                            layout: {
                                visibility: "none"
                            },
                            paint: {}
                        },
                        geojson: l()
                    };
                    if (!r) return c;
                    var u, h = [], f = e1.z, p = e1.radius, d = i.isArrayOrTypedArray(f) && f.length, m = i.isArrayOrTypedArray(p);
                    for(u = 0; u < t1.length; u++){
                        var g = t1[u], y = g.lonlat;
                        if (y[0] !== s) {
                            var v = {};
                            if (d) {
                                var x = g.z;
                                v.z = x !== s ? x : 0;
                            }
                            m && (v.r = n(p[u]) && p[u] > 0 ? +p[u] : 0), h.push({
                                type: "Feature",
                                geometry: {
                                    type: "Point",
                                    coordinates: y
                                },
                                properties: v
                            });
                        }
                    }
                    var _ = o.extractOpts(e1), b = _.reversescale ? o.flipScale(_.colorscale) : _.colorscale, w = b[0][1], T = [
                        "interpolate",
                        [
                            "linear"
                        ],
                        [
                            "heatmap-density"
                        ],
                        0,
                        a.opacity(w) < 1 ? w : a.addOpacity(w, 0)
                    ];
                    for(u = 1; u < b.length; u++)T.push(b[u][0], b[u][1]);
                    var k = [
                        "interpolate",
                        [
                            "linear"
                        ],
                        [
                            "get",
                            "z"
                        ],
                        _.min,
                        0,
                        _.max,
                        1
                    ];
                    return i.extendFlat(c.heatmap.paint, {
                        "heatmap-weight": d ? k : 1 / (_.max - _.min),
                        "heatmap-color": T,
                        "heatmap-radius": m ? {
                            type: "identity",
                            property: "r"
                        } : e1.radius,
                        "heatmap-opacity": e1.opacity
                    }), c.geojson = {
                        type: "FeatureCollection",
                        features: h
                    }, c.heatmap.layout.visibility = "visible", c;
                };
            },
            9653: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(39356), a = r(70690);
                t1.exports = function(t1, e1, r, o) {
                    function s(r, i) {
                        return n.coerce(t1, e1, a, r, i);
                    }
                    var l = s("lon") || [], c = s("lat") || [], u = Math.min(l.length, c.length);
                    u ? (e1._length = u, s("z"), s("radius"), s("below"), s("text"), s("hovertext"), s("hovertemplate"), i(t1, e1, o, s, {
                        prefix: "",
                        cLetter: "z"
                    })) : e1.visible = !1;
                };
            },
            16302: function(t1) {
                "use strict";
                t1.exports = function(t1, e1) {
                    return t1.lon = e1.lon, t1.lat = e1.lat, t1.z = e1.z, t1;
                };
            },
            28045: function(t1, e1, r) {
                "use strict";
                var n = r(29714), i = r(67275).hoverPoints, a = r(67275).getExtraText;
                t1.exports = function(t1, e1, r) {
                    var o = i(t1, e1, r);
                    if (o) {
                        var s = o[0], l = s.cd, c = l[0].trace, u = l[s.index];
                        if (delete s.color, "z" in u) {
                            var h = s.subplot.mockAxis;
                            s.z = u.z, s.zLabel = n.tickText(h, h.c2l(u.z), "hover").text;
                        }
                        return s.extraText = a(c, u, l[0].t.labels), [
                            s
                        ];
                    }
                };
            },
            91995: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    attributes: r(70690),
                    supplyDefaults: r(9653),
                    colorbar: r(12431),
                    formatLabels: r(66762),
                    calc: r(91582),
                    plot: r(99932),
                    hoverPoints: r(28045),
                    eventData: r(16302),
                    getBelow: function(t1, e1) {
                        for(var r = e1.getMapLayers(), n = 0; n < r.length; n++){
                            var i = r[n], a = i.id;
                            if ("symbol" === i.type && "string" == typeof a && -1 === a.indexOf("plotly-")) return a;
                        }
                    },
                    moduleType: "trace",
                    name: "densitymap",
                    basePlotModule: r(34091),
                    categories: [
                        "map",
                        "gl",
                        "showLegend"
                    ],
                    meta: {
                        hr_name: "density_map"
                    }
                };
            },
            99932: function(t1, e1, r) {
                "use strict";
                var n = r(95012), i = r(8814).traceLayerPrefix;
                function a(t1, e1) {
                    this.type = "densitymap", this.subplot = t1, this.uid = e1, this.sourceId = "source-" + e1, this.layerList = [
                        [
                            "heatmap",
                            i + e1 + "-heatmap"
                        ]
                    ], this.below = null;
                }
                var o = a.prototype;
                o.update = function(t1) {
                    var e1 = this.subplot, r = this.layerList, i = n(t1), a = e1.belowLookup["trace-" + this.uid];
                    e1.map.getSource(this.sourceId).setData(i.geojson), a !== this.below && (this._removeLayers(), this._addLayers(i, a), this.below = a);
                    for(var o = 0; o < r.length; o++){
                        var s = r[o], l = s[0], c = s[1], u = i[l];
                        e1.setOptions(c, "setLayoutProperty", u.layout), "visible" === u.layout.visibility && e1.setOptions(c, "setPaintProperty", u.paint);
                    }
                }, o._addLayers = function(t1, e1) {
                    for(var r = this.subplot, n = this.layerList, i = this.sourceId, a = 0; a < n.length; a++){
                        var o = n[a], s = o[0], l = t1[s];
                        r.addLayer({
                            type: s,
                            id: o[1],
                            source: i,
                            layout: l.layout,
                            paint: l.paint
                        }, e1);
                    }
                }, o._removeLayers = function() {
                    for(var t1 = this.subplot.map, e1 = this.layerList, r = e1.length - 1; r >= 0; r--)t1.removeLayer(e1[r][1]);
                }, o.dispose = function() {
                    var t1 = this.subplot.map;
                    this._removeLayers(), t1.removeSource(this.sourceId);
                }, t1.exports = function(t1, e1) {
                    var r = e1[0].trace, i = new a(t1, r.uid), o = i.sourceId, s = n(e1), l = i.below = t1.belowLookup["trace-" + r.uid];
                    return t1.map.addSource(o, {
                        type: "geojson",
                        data: s.geojson
                    }), i._addLayers(s, l), i;
                };
            },
            17347: function(t1, e1, r) {
                "use strict";
                var n = r(87163), i = r(3208).rb, a = r(9829), o = r(95833), s = r(93049).extendFlat;
                t1.exports = s({
                    lon: o.lon,
                    lat: o.lat,
                    z: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    radius: {
                        valType: "number",
                        editType: "plot",
                        arrayOk: !0,
                        min: 1,
                        dflt: 30
                    },
                    below: {
                        valType: "string",
                        editType: "plot"
                    },
                    text: o.text,
                    hovertext: o.hovertext,
                    hoverinfo: s({}, a.hoverinfo, {
                        flags: [
                            "lon",
                            "lat",
                            "z",
                            "text",
                            "name"
                        ]
                    }),
                    hovertemplate: i(),
                    showlegend: s({}, a.showlegend, {
                        dflt: !1
                    })
                }, n("", {
                    cLetter: "z",
                    editTypeOverride: "calc"
                }));
            },
            60675: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(34809).isArrayOrTypedArray, a = r(63821).BADNUM, o = r(28379), s = r(34809)._;
                t1.exports = function(t1, e1) {
                    for(var r = e1._length, l = new Array(r), c = e1.z, u = i(c) && c.length, h = 0; h < r; h++){
                        var f = l[h] = {}, p = e1.lon[h], d = e1.lat[h];
                        if (f.lonlat = n(p) && n(d) ? [
                            +p,
                            +d
                        ] : [
                            a,
                            a
                        ], u) {
                            var m = c[h];
                            f.z = n(m) ? m : a;
                        }
                    }
                    return o(t1, e1, {
                        vals: u ? c : [
                            0,
                            1
                        ],
                        containerStr: "",
                        cLetter: "z"
                    }), r && (l[0].t = {
                        labels: {
                            lat: s(t1, "lat:") + " ",
                            lon: s(t1, "lon:") + " "
                        }
                    }), l;
                };
            },
            78391: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(34809), a = r(78766), o = r(88856), s = r(63821).BADNUM, l = r(39532).makeBlank;
                t1.exports = function(t1) {
                    var e1 = t1[0].trace, r = !0 === e1.visible && 0 !== e1._length, c = e1._opts = {
                        heatmap: {
                            layout: {
                                visibility: "none"
                            },
                            paint: {}
                        },
                        geojson: l()
                    };
                    if (!r) return c;
                    var u, h = [], f = e1.z, p = e1.radius, d = i.isArrayOrTypedArray(f) && f.length, m = i.isArrayOrTypedArray(p);
                    for(u = 0; u < t1.length; u++){
                        var g = t1[u], y = g.lonlat;
                        if (y[0] !== s) {
                            var v = {};
                            if (d) {
                                var x = g.z;
                                v.z = x !== s ? x : 0;
                            }
                            m && (v.r = n(p[u]) && p[u] > 0 ? +p[u] : 0), h.push({
                                type: "Feature",
                                geometry: {
                                    type: "Point",
                                    coordinates: y
                                },
                                properties: v
                            });
                        }
                    }
                    var _ = o.extractOpts(e1), b = _.reversescale ? o.flipScale(_.colorscale) : _.colorscale, w = b[0][1], T = [
                        "interpolate",
                        [
                            "linear"
                        ],
                        [
                            "heatmap-density"
                        ],
                        0,
                        a.opacity(w) < 1 ? w : a.addOpacity(w, 0)
                    ];
                    for(u = 1; u < b.length; u++)T.push(b[u][0], b[u][1]);
                    var k = [
                        "interpolate",
                        [
                            "linear"
                        ],
                        [
                            "get",
                            "z"
                        ],
                        _.min,
                        0,
                        _.max,
                        1
                    ];
                    return i.extendFlat(c.heatmap.paint, {
                        "heatmap-weight": d ? k : 1 / (_.max - _.min),
                        "heatmap-color": T,
                        "heatmap-radius": m ? {
                            type: "identity",
                            property: "r"
                        } : e1.radius,
                        "heatmap-opacity": e1.opacity
                    }), c.geojson = {
                        type: "FeatureCollection",
                        features: h
                    }, c.heatmap.layout.visibility = "visible", c;
                };
            },
            1892: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(39356), a = r(17347);
                t1.exports = function(t1, e1, r, o) {
                    function s(r, i) {
                        return n.coerce(t1, e1, a, r, i);
                    }
                    var l = s("lon") || [], c = s("lat") || [], u = Math.min(l.length, c.length);
                    u ? (e1._length = u, s("z"), s("radius"), s("below"), s("text"), s("hovertext"), s("hovertemplate"), i(t1, e1, o, s, {
                        prefix: "",
                        cLetter: "z"
                    })) : e1.visible = !1;
                };
            },
            8919: function(t1) {
                "use strict";
                t1.exports = function(t1, e1) {
                    return t1.lon = e1.lon, t1.lat = e1.lat, t1.z = e1.z, t1;
                };
            },
            54478: function(t1, e1, r) {
                "use strict";
                var n = r(29714), i = r(18016).hoverPoints, a = r(18016).getExtraText;
                t1.exports = function(t1, e1, r) {
                    var o = i(t1, e1, r);
                    if (o) {
                        var s = o[0], l = s.cd, c = l[0].trace, u = l[s.index];
                        if (delete s.color, "z" in u) {
                            var h = s.subplot.mockAxis;
                            s.z = u.z, s.zLabel = n.tickText(h, h.c2l(u.z), "hover").text;
                        }
                        return s.extraText = a(c, u, l[0].t.labels), [
                            s
                        ];
                    }
                };
            },
            81264: function(t1, e1, r) {
                "use strict";
                [
                    "*densitymapbox* trace is deprecated!",
                    "Please consider switching to the *densitymap* trace type and `map` subplots.",
                    "Learn more at: https://plotly.com/javascript/maplibre-migration/"
                ].join(" "), t1.exports = {
                    attributes: r(17347),
                    supplyDefaults: r(1892),
                    colorbar: r(12431),
                    formatLabels: r(69009),
                    calc: r(60675),
                    plot: r(5165),
                    hoverPoints: r(54478),
                    eventData: r(8919),
                    getBelow: function(t1, e1) {
                        for(var r = e1.getMapLayers(), n = 0; n < r.length; n++){
                            var i = r[n], a = i.id;
                            if ("symbol" === i.type && "string" == typeof a && -1 === a.indexOf("plotly-")) return a;
                        }
                    },
                    moduleType: "trace",
                    name: "densitymapbox",
                    basePlotModule: r(68192),
                    categories: [
                        "mapbox",
                        "gl",
                        "showLegend"
                    ],
                    meta: {
                        hr_name: "density_mapbox"
                    }
                };
            },
            5165: function(t1, e1, r) {
                "use strict";
                var n = r(78391), i = r(44245).traceLayerPrefix;
                function a(t1, e1) {
                    this.type = "densitymapbox", this.subplot = t1, this.uid = e1, this.sourceId = "source-" + e1, this.layerList = [
                        [
                            "heatmap",
                            i + e1 + "-heatmap"
                        ]
                    ], this.below = null;
                }
                var o = a.prototype;
                o.update = function(t1) {
                    var e1 = this.subplot, r = this.layerList, i = n(t1), a = e1.belowLookup["trace-" + this.uid];
                    e1.map.getSource(this.sourceId).setData(i.geojson), a !== this.below && (this._removeLayers(), this._addLayers(i, a), this.below = a);
                    for(var o = 0; o < r.length; o++){
                        var s = r[o], l = s[0], c = s[1], u = i[l];
                        e1.setOptions(c, "setLayoutProperty", u.layout), "visible" === u.layout.visibility && e1.setOptions(c, "setPaintProperty", u.paint);
                    }
                }, o._addLayers = function(t1, e1) {
                    for(var r = this.subplot, n = this.layerList, i = this.sourceId, a = 0; a < n.length; a++){
                        var o = n[a], s = o[0], l = t1[s];
                        r.addLayer({
                            type: s,
                            id: o[1],
                            source: i,
                            layout: l.layout,
                            paint: l.paint
                        }, e1);
                    }
                }, o._removeLayers = function() {
                    for(var t1 = this.subplot.map, e1 = this.layerList, r = e1.length - 1; r >= 0; r--)t1.removeLayer(e1[r][1]);
                }, o.dispose = function() {
                    var t1 = this.subplot.map;
                    this._removeLayers(), t1.removeSource(this.sourceId);
                }, t1.exports = function(t1, e1) {
                    var r = e1[0].trace, i = new a(t1, r.uid), o = i.sourceId, s = n(e1), l = i.below = t1.belowLookup["trace-" + r.uid];
                    return t1.map.addSource(o, {
                        type: "geojson",
                        data: s.geojson
                    }), i._addLayers(s, l), i;
                };
            },
            43179: function(t1, e1, r) {
                "use strict";
                var n = r(34809);
                t1.exports = function(t1, e1) {
                    for(var r = 0; r < t1.length; r++)t1[r].i = r;
                    n.mergeArray(e1.text, t1, "tx"), n.mergeArray(e1.hovertext, t1, "htx");
                    var i = e1.marker;
                    if (i) {
                        n.mergeArray(i.opacity, t1, "mo"), n.mergeArray(i.color, t1, "mc");
                        var a = i.line;
                        a && (n.mergeArray(a.color, t1, "mlc"), n.mergeArrayCastPositive(a.width, t1, "mlw"));
                    }
                };
            },
            62824: function(t1, e1, r) {
                "use strict";
                var n, i = r(81481), a = r(36640).line, o = r(9829), s = r(80712).axisHoverFormat, l = r(3208).rb, c = r(3208).ay, u = r(87948), h = r(93049).extendFlat, f = r(78766);
                t1.exports = {
                    x: i.x,
                    x0: i.x0,
                    dx: i.dx,
                    y: i.y,
                    y0: i.y0,
                    dy: i.dy,
                    xperiod: i.xperiod,
                    yperiod: i.yperiod,
                    xperiod0: i.xperiod0,
                    yperiod0: i.yperiod0,
                    xperiodalignment: i.xperiodalignment,
                    yperiodalignment: i.yperiodalignment,
                    xhoverformat: s("x"),
                    yhoverformat: s("y"),
                    hovertext: i.hovertext,
                    hovertemplate: l({}, {
                        keys: u.eventDataKeys
                    }),
                    hoverinfo: h({}, o.hoverinfo, {
                        flags: [
                            "name",
                            "x",
                            "y",
                            "text",
                            "percent initial",
                            "percent previous",
                            "percent total"
                        ]
                    }),
                    textinfo: {
                        valType: "flaglist",
                        flags: [
                            "label",
                            "text",
                            "percent initial",
                            "percent previous",
                            "percent total",
                            "value"
                        ],
                        extras: [
                            "none"
                        ],
                        editType: "plot",
                        arrayOk: !1
                    },
                    texttemplate: c({
                        editType: "plot"
                    }, {
                        keys: u.eventDataKeys.concat([
                            "label",
                            "value"
                        ])
                    }),
                    text: i.text,
                    textposition: i.textposition,
                    insidetextanchor: h({}, i.insidetextanchor, {
                        dflt: "middle"
                    }),
                    textangle: h({}, i.textangle, {
                        dflt: 0
                    }),
                    textfont: i.textfont,
                    insidetextfont: i.insidetextfont,
                    outsidetextfont: i.outsidetextfont,
                    constraintext: i.constraintext,
                    cliponaxis: i.cliponaxis,
                    orientation: h({}, i.orientation, {}),
                    offset: h({}, i.offset, {
                        arrayOk: !1
                    }),
                    width: h({}, i.width, {
                        arrayOk: !1
                    }),
                    marker: (n = h({}, i.marker), delete n.pattern, delete n.cornerradius, n),
                    connector: {
                        fillcolor: {
                            valType: "color",
                            editType: "style"
                        },
                        line: {
                            color: h({}, a.color, {
                                dflt: f.defaultLine
                            }),
                            width: h({}, a.width, {
                                dflt: 0,
                                editType: "plot"
                            }),
                            dash: a.dash,
                            editType: "style"
                        },
                        visible: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    offsetgroup: i.offsetgroup,
                    alignmentgroup: i.alignmentgroup,
                    zorder: i.zorder
                };
            },
            28152: function(t1, e1, r) {
                "use strict";
                var n = r(29714), i = r(40528), a = r(43179), o = r(48861), s = r(63821).BADNUM;
                function l(t1) {
                    return t1 === s ? 0 : t1;
                }
                t1.exports = function(t1, e1) {
                    var r, c, u, h, f, p, d, m, g = n.getFromId(t1, e1.xaxis || "x"), y = n.getFromId(t1, e1.yaxis || "y");
                    "h" === e1.orientation ? (r = g.makeCalcdata(e1, "x"), u = y.makeCalcdata(e1, "y"), h = i(e1, y, "y", u), f = !!e1.yperiodalignment, p = "y") : (r = y.makeCalcdata(e1, "y"), u = g.makeCalcdata(e1, "x"), h = i(e1, g, "x", u), f = !!e1.xperiodalignment, p = "x"), c = h.vals;
                    var v, x = Math.min(c.length, r.length), _ = new Array(x);
                    for(e1._base = [], d = 0; d < x; d++){
                        r[d] < 0 && (r[d] = s);
                        var b = !1;
                        r[d] !== s && d + 1 < x && r[d + 1] !== s && (b = !0), m = _[d] = {
                            p: c[d],
                            s: r[d],
                            cNext: b
                        }, e1._base[d] = -0.5 * m.s, f && (_[d].orig_p = u[d], _[d][p + "End"] = h.ends[d], _[d][p + "Start"] = h.starts[d]), e1.ids && (m.id = String(e1.ids[d])), 0 === d && (_[0].vTotal = 0), _[0].vTotal += l(m.s), m.begR = l(m.s) / l(_[0].s);
                    }
                    for(d = 0; d < x; d++)(m = _[d]).s !== s && (m.sumR = m.s / _[0].vTotal, m.difR = void 0 !== v ? m.s / v : 1, v = m.s);
                    return a(_, e1), o(_, e1), _;
                };
            },
            87948: function(t1) {
                "use strict";
                t1.exports = {
                    eventDataKeys: [
                        "percentInitial",
                        "percentPrevious",
                        "percentTotal"
                    ]
                };
            },
            82539: function(t1, e1, r) {
                "use strict";
                var n = r(24782).setGroupPositions;
                t1.exports = function(t1, e1) {
                    var r, i, a = t1._fullLayout, o = t1._fullData, s = t1.calcdata, l = e1.xaxis, c = e1.yaxis, u = [], h = [], f = [];
                    for(i = 0; i < o.length; i++){
                        var p = o[i], d = "h" === p.orientation;
                        !0 === p.visible && p.xaxis === l._id && p.yaxis === c._id && "funnel" === p.type && (r = s[i], d ? f.push(r) : h.push(r), u.push(r));
                    }
                    var m = {
                        mode: a.funnelmode,
                        norm: a.funnelnorm,
                        gap: a.funnelgap,
                        groupgap: a.funnelgroupgap
                    };
                    for(n(t1, l, c, h, m), n(t1, c, l, f, m), i = 0; i < u.length; i++){
                        r = u[i];
                        for(var g = 0; g < r.length; g++)g + 1 < r.length && (r[g].nextP0 = r[g + 1].p0, r[g].nextS0 = r[g + 1].s0, r[g].nextP1 = r[g + 1].p1, r[g].nextS1 = r[g + 1].s1);
                    }
                };
            },
            30495: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(36301), a = r(17550).handleText, o = r(99867), s = r(99669), l = r(62824), c = r(78766);
                t1.exports = {
                    supplyDefaults: function(t1, e1, r, i) {
                        function u(r, i) {
                            return n.coerce(t1, e1, l, r, i);
                        }
                        if (o(t1, e1, i, u)) {
                            s(t1, e1, i, u), u("xhoverformat"), u("yhoverformat"), u("orientation", e1.y && !e1.x ? "v" : "h"), u("offset"), u("width");
                            var h = u("text");
                            u("hovertext"), u("hovertemplate");
                            var f = u("textposition");
                            a(t1, e1, i, u, f, {
                                moduleHasSelected: !1,
                                moduleHasUnselected: !1,
                                moduleHasConstrain: !0,
                                moduleHasCliponaxis: !0,
                                moduleHasTextangle: !0,
                                moduleHasInsideanchor: !0
                            }), "none" === e1.textposition || e1.texttemplate || u("textinfo", n.isArrayOrTypedArray(h) ? "text+value" : "value");
                            var p = u("marker.color", r);
                            u("marker.line.color", c.defaultLine), u("marker.line.width"), u("connector.visible") && (u("connector.fillcolor", function(t1) {
                                var e1 = n.isArrayOrTypedArray(t1) ? "#000" : t1;
                                return c.addOpacity(e1, .5 * c.opacity(e1));
                            }(p)), u("connector.line.width") && (u("connector.line.color"), u("connector.line.dash"))), u("zorder");
                        } else e1.visible = !1;
                    },
                    crossTraceDefaults: function(t1, e1) {
                        var r, a;
                        function o(t1) {
                            return n.coerce(a._input, a, l, t1);
                        }
                        if ("group" === e1.funnelmode) for(var s = 0; s < t1.length; s++)r = (a = t1[s])._input, i(r, a, e1, o);
                    }
                };
            },
            29412: function(t1) {
                "use strict";
                t1.exports = function(t1, e1) {
                    return t1.x = "xVal" in e1 ? e1.xVal : e1.x, t1.y = "yVal" in e1 ? e1.yVal : e1.y, "percentInitial" in e1 && (t1.percentInitial = e1.percentInitial), "percentPrevious" in e1 && (t1.percentPrevious = e1.percentPrevious), "percentTotal" in e1 && (t1.percentTotal = e1.percentTotal), e1.xa && (t1.xaxis = e1.xa), e1.ya && (t1.yaxis = e1.ya), t1;
                };
            },
            27759: function(t1, e1, r) {
                "use strict";
                var n = r(78766).opacity, i = r(91664).hoverOnBars, a = r(34809).formatPercent;
                t1.exports = function(t1, e1, r, o, s) {
                    var l = i(t1, e1, r, o, s);
                    if (l) {
                        var c = l.cd, u = c[0].trace, h = "h" === u.orientation, f = c[l.index];
                        l[(h ? "x" : "y") + "LabelVal"] = f.s, l.percentInitial = f.begR, l.percentInitialLabel = a(f.begR, 1), l.percentPrevious = f.difR, l.percentPreviousLabel = a(f.difR, 1), l.percentTotal = f.sumR, l.percentTotalLabel = a(f.sumR, 1);
                        var p = f.hi || u.hoverinfo, d = [];
                        if (p && "none" !== p && "skip" !== p) {
                            var m = "all" === p, g = p.split("+"), y = function(t1) {
                                return m || -1 !== g.indexOf(t1);
                            };
                            y("percent initial") && d.push(l.percentInitialLabel + " of initial"), y("percent previous") && d.push(l.percentPreviousLabel + " of previous"), y("percent total") && d.push(l.percentTotalLabel + " of total");
                        }
                        return l.extraText = d.join("<br>"), l.color = function(t1, e1) {
                            var r = t1.marker, i = e1.mc || r.color, a = e1.mlc || r.line.color, o = e1.mlw || r.line.width;
                            return n(i) ? i : n(a) && o ? a : void 0;
                        }(u, f), [
                            l
                        ];
                    }
                };
            },
            52213: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    attributes: r(62824),
                    layoutAttributes: r(93795),
                    supplyDefaults: r(30495).supplyDefaults,
                    crossTraceDefaults: r(30495).crossTraceDefaults,
                    supplyLayoutDefaults: r(34980),
                    calc: r(28152),
                    crossTraceCalc: r(82539),
                    plot: r(83482),
                    style: r(7240).style,
                    hoverPoints: r(27759),
                    eventData: r(29412),
                    selectPoints: r(88384),
                    moduleType: "trace",
                    name: "funnel",
                    basePlotModule: r(37703),
                    categories: [
                        "bar-like",
                        "cartesian",
                        "svg",
                        "oriented",
                        "showLegend",
                        "zoomScale"
                    ],
                    meta: {}
                };
            },
            93795: function(t1) {
                "use strict";
                t1.exports = {
                    funnelmode: {
                        valType: "enumerated",
                        values: [
                            "stack",
                            "group",
                            "overlay"
                        ],
                        dflt: "stack",
                        editType: "calc"
                    },
                    funnelgap: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        editType: "calc"
                    },
                    funnelgroupgap: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 0,
                        editType: "calc"
                    }
                };
            },
            34980: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(93795);
                t1.exports = function(t1, e1, r) {
                    var a = !1;
                    function o(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    for(var s = 0; s < r.length; s++){
                        var l = r[s];
                        if (l.visible && "funnel" === l.type) {
                            a = !0;
                            break;
                        }
                    }
                    a && (o("funnelmode"), o("funnelgap", .2), o("funnelgroupgap"));
                };
            },
            83482: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(34809), a = r(62203), o = r(63821).BADNUM, s = r(32995), l = r(84102).clearMinTextSize;
                function c(t1, e1, r, n) {
                    var i = [], a = [], o = n ? e1 : r, s = n ? r : e1;
                    return i[0] = o.c2p(t1.s0, !0), a[0] = s.c2p(t1.p0, !0), i[1] = o.c2p(t1.s1, !0), a[1] = s.c2p(t1.p1, !0), i[2] = o.c2p(t1.nextS0, !0), a[2] = s.c2p(t1.nextP0, !0), i[3] = o.c2p(t1.nextS1, !0), a[3] = s.c2p(t1.nextP1, !0), n ? [
                        i,
                        a
                    ] : [
                        a,
                        i
                    ];
                }
                t1.exports = function(t1, e1, r, u) {
                    var h = t1._fullLayout;
                    l("funnel", h), function(t1, e1, r, s) {
                        var l = e1.xaxis, u = e1.yaxis;
                        i.makeTraceGroups(s, r, "trace bars").each(function(r) {
                            var s = n.select(this), h = r[0].trace, f = i.ensureSingle(s, "g", "regions");
                            if (h.connector && h.connector.visible) {
                                var p = "h" === h.orientation, d = f.selectAll("g.region").data(i.identity);
                                d.enter().append("g").classed("region", !0), d.exit().remove();
                                var m = d.size();
                                d.each(function(r, s) {
                                    if (s === m - 1 || r.cNext) {
                                        var h = c(r, l, u, p), f = h[0], d = h[1], g = "";
                                        f[0] !== o && d[0] !== o && f[1] !== o && d[1] !== o && f[2] !== o && d[2] !== o && f[3] !== o && d[3] !== o && (g += p ? "M" + f[0] + "," + d[1] + "L" + f[2] + "," + d[2] + "H" + f[3] + "L" + f[1] + "," + d[1] + "Z" : "M" + f[1] + "," + d[1] + "L" + f[2] + "," + d[3] + "V" + d[2] + "L" + f[1] + "," + d[0] + "Z"), "" === g && (g = "M0,0Z"), i.ensureSingle(n.select(this), "path").attr("d", g).call(a.setClipUrl, e1.layerClipId, t1);
                                    }
                                });
                            } else f.remove();
                        });
                    }(t1, e1, r, u), function(t1, e1, r, o) {
                        var s = e1.xaxis, l = e1.yaxis;
                        i.makeTraceGroups(o, r, "trace bars").each(function(r) {
                            var o = n.select(this), u = r[0].trace, h = i.ensureSingle(o, "g", "lines");
                            if (u.connector && u.connector.visible && u.connector.line.width) {
                                var f = "h" === u.orientation, p = h.selectAll("g.line").data(i.identity);
                                p.enter().append("g").classed("line", !0), p.exit().remove();
                                var d = p.size();
                                p.each(function(r, o) {
                                    if (o === d - 1 || r.cNext) {
                                        var u = c(r, s, l, f), h = u[0], p = u[1], m = "";
                                        void 0 !== h[3] && void 0 !== p[3] && (f ? (m += "M" + h[0] + "," + p[1] + "L" + h[2] + "," + p[2], m += "M" + h[1] + "," + p[1] + "L" + h[3] + "," + p[2]) : (m += "M" + h[1] + "," + p[1] + "L" + h[2] + "," + p[3], m += "M" + h[1] + "," + p[0] + "L" + h[2] + "," + p[2])), "" === m && (m = "M0,0Z"), i.ensureSingle(n.select(this), "path").attr("d", m).call(a.setClipUrl, e1.layerClipId, t1);
                                    }
                                });
                            } else h.remove();
                        });
                    }(t1, e1, r, u), s.plot(t1, e1, r, u, {
                        mode: h.funnelmode,
                        norm: h.funnelmode,
                        gap: h.funnelgap,
                        groupgap: h.funnelgroupgap
                    });
                };
            },
            7240: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(62203), a = r(78766), o = r(20438).DESELECTDIM, s = r(6851), l = r(84102).resizeText, c = s.styleTextPoints;
                t1.exports = {
                    style: function(t1, e1, r) {
                        var s = r || n.select(t1).selectAll('g[class^="funnellayer"]').selectAll("g.trace");
                        l(t1, s, "funnel"), s.style("opacity", function(t1) {
                            return t1[0].trace.opacity;
                        }), s.each(function(e1) {
                            var r = n.select(this), s = e1[0].trace;
                            r.selectAll(".point > path").each(function(t1) {
                                if (!t1.isBlank) {
                                    var e1 = s.marker;
                                    n.select(this).call(a.fill, t1.mc || e1.color).call(a.stroke, t1.mlc || e1.line.color).call(i.dashLine, e1.line.dash, t1.mlw || e1.line.width).style("opacity", s.selectedpoints && !t1.selected ? o : 1);
                                }
                            }), c(r, s, t1), r.selectAll(".regions").each(function() {
                                n.select(this).selectAll("path").style("stroke-width", 0).call(a.fill, s.connector.fillcolor);
                            }), r.selectAll(".lines").each(function() {
                                var t1 = s.connector.line;
                                i.lineGroupStyle(n.select(this).selectAll("path"), t1.width, t1.color, t1.dash);
                            });
                        });
                    }
                };
            },
            63447: function(t1, e1, r) {
                "use strict";
                var n = r(55412), i = r(9829), a = r(13792).u, o = r(3208).rb, s = r(3208).ay, l = r(93049).extendFlat;
                t1.exports = {
                    labels: n.labels,
                    label0: n.label0,
                    dlabel: n.dlabel,
                    values: n.values,
                    marker: {
                        colors: n.marker.colors,
                        line: {
                            color: l({}, n.marker.line.color, {
                                dflt: null
                            }),
                            width: l({}, n.marker.line.width, {
                                dflt: 1
                            }),
                            editType: "calc"
                        },
                        pattern: n.marker.pattern,
                        editType: "calc"
                    },
                    text: n.text,
                    hovertext: n.hovertext,
                    scalegroup: l({}, n.scalegroup, {}),
                    textinfo: l({}, n.textinfo, {
                        flags: [
                            "label",
                            "text",
                            "value",
                            "percent"
                        ]
                    }),
                    texttemplate: s({
                        editType: "plot"
                    }, {
                        keys: [
                            "label",
                            "color",
                            "value",
                            "text",
                            "percent"
                        ]
                    }),
                    hoverinfo: l({}, i.hoverinfo, {
                        flags: [
                            "label",
                            "text",
                            "value",
                            "percent",
                            "name"
                        ]
                    }),
                    hovertemplate: o({}, {
                        keys: [
                            "label",
                            "color",
                            "value",
                            "text",
                            "percent"
                        ]
                    }),
                    textposition: l({}, n.textposition, {
                        values: [
                            "inside",
                            "none"
                        ],
                        dflt: "inside"
                    }),
                    textfont: n.textfont,
                    insidetextfont: n.insidetextfont,
                    title: {
                        text: n.title.text,
                        font: n.title.font,
                        position: l({}, n.title.position, {
                            values: [
                                "top left",
                                "top center",
                                "top right"
                            ],
                            dflt: "top center"
                        }),
                        editType: "plot"
                    },
                    domain: a({
                        name: "funnelarea",
                        trace: !0,
                        editType: "calc"
                    }),
                    aspectratio: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        editType: "plot"
                    },
                    baseratio: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: .333,
                        editType: "plot"
                    }
                };
            },
            86817: function(t1, e1, r) {
                "use strict";
                var n = r(44122);
                e1.name = "funnelarea", e1.plot = function(t1, r, i, a) {
                    n.plotBasePlot(e1.name, t1, r, i, a);
                }, e1.clean = function(t1, r, i, a) {
                    n.cleanBasePlot(e1.name, t1, r, i, a);
                };
            },
            2807: function(t1, e1, r) {
                "use strict";
                var n = r(44148);
                t1.exports = {
                    calc: function(t1, e1) {
                        return n.calc(t1, e1);
                    },
                    crossTraceCalc: function(t1) {
                        n.crossTraceCalc(t1, {
                            type: "funnelarea"
                        });
                    }
                };
            },
            79824: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(63447), a = r(13792).N, o = r(17550).handleText, s = r(46979).handleLabelsAndValues, l = r(46979).handleMarkerDefaults;
                t1.exports = function(t1, e1, r, c) {
                    function u(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    var h = u("labels"), f = u("values"), p = s(h, f), d = p.len;
                    if (e1._hasLabels = p.hasLabels, e1._hasValues = p.hasValues, !e1._hasLabels && e1._hasValues && (u("label0"), u("dlabel")), d) {
                        e1._length = d, l(t1, e1, c, u), u("scalegroup");
                        var m, g = u("text"), y = u("texttemplate");
                        if (y || (m = u("textinfo", Array.isArray(g) ? "text+percent" : "percent")), u("hovertext"), u("hovertemplate"), y || m && "none" !== m) {
                            var v = u("textposition");
                            o(t1, e1, c, u, v, {
                                moduleHasSelected: !1,
                                moduleHasUnselected: !1,
                                moduleHasConstrain: !1,
                                moduleHasCliponaxis: !1,
                                moduleHasTextangle: !1,
                                moduleHasInsideanchor: !1
                            });
                        } else "none" === m && u("textposition", "none");
                        a(e1, c, u), u("title.text") && (u("title.position"), n.coerceFont(u, "title.font", c.font)), u("aspectratio"), u("baseratio");
                    } else e1.visible = !1;
                };
            },
            91132: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    moduleType: "trace",
                    name: "funnelarea",
                    basePlotModule: r(86817),
                    categories: [
                        "pie-like",
                        "funnelarea",
                        "showLegend"
                    ],
                    attributes: r(63447),
                    layoutAttributes: r(10270),
                    supplyDefaults: r(79824),
                    supplyLayoutDefaults: r(69161),
                    calc: r(2807).calc,
                    crossTraceCalc: r(2807).crossTraceCalc,
                    plot: r(96673),
                    style: r(13757),
                    styleOne: r(32891),
                    meta: {}
                };
            },
            10270: function(t1, e1, r) {
                "use strict";
                var n = r(4031).hiddenlabels;
                t1.exports = {
                    hiddenlabels: n,
                    funnelareacolorway: {
                        valType: "colorlist",
                        editType: "calc"
                    },
                    extendfunnelareacolors: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    }
                };
            },
            69161: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(10270);
                t1.exports = function(t1, e1) {
                    function r(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    r("hiddenlabels"), r("funnelareacolorway", e1.colorway), r("extendfunnelareacolors");
                };
            },
            96673: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(62203), a = r(34809), o = a.strScale, s = a.strTranslate, l = r(30635), c = r(32995).toMoveInsideBar, u = r(84102), h = u.recordMinTextSize, f = u.clearMinTextSize, p = r(37252), d = r(35734), m = d.attachFxHandlers, g = d.determineInsideTextFont, y = d.layoutAreas, v = d.prerenderTitles, x = d.positionTitleOutside, _ = d.formatSliceLabel;
                function b(t1, e1) {
                    return "l" + (e1[0] - t1[0]) + "," + (e1[1] - t1[1]);
                }
                t1.exports = function(t1, e1) {
                    var r = t1._context.staticPlot, u = t1._fullLayout;
                    f("funnelarea", u), v(e1, t1), y(e1, u._size), a.makeTraceGroups(u._funnelarealayer, e1, "trace").each(function(e1) {
                        var f = n.select(this), d = e1[0], y = d.trace;
                        !function(t1) {
                            if (t1.length) {
                                var e1 = t1[0], r = e1.trace, n = r.aspectratio, i = r.baseratio;
                                i > .999 && (i = .999);
                                var a, o, s, l = Math.pow(i, 2), c = e1.vTotal, u = c, h = c * l / (1 - l) / c, f = [];
                                for(f.push(E()), o = t1.length - 1; o > -1; o--)if (!(s = t1[o]).hidden) {
                                    var p = s.v / u;
                                    h += p, f.push(E());
                                }
                                var d = 1 / 0, m = -1 / 0;
                                for(o = 0; o < f.length; o++)a = f[o], d = Math.min(d, a[1]), m = Math.max(m, a[1]);
                                for(o = 0; o < f.length; o++)f[o][1] -= (m + d) / 2;
                                var g = f[f.length - 1][0], y = e1.r, v = (m - d) / 2, x = y / g, _ = y / v * n;
                                for(e1.r = _ * v, o = 0; o < f.length; o++)f[o][0] *= x, f[o][1] *= _;
                                var b, w, T = [
                                    -(a = f[0])[0],
                                    a[1]
                                ], k = [
                                    a[0],
                                    a[1]
                                ], A = 0;
                                for(o = t1.length - 1; o > -1; o--)if (!(s = t1[o]).hidden) {
                                    var M = f[A += 1][0], S = f[A][1];
                                    s.TL = [
                                        -M,
                                        S
                                    ], s.TR = [
                                        M,
                                        S
                                    ], s.BL = T, s.BR = k, s.pxmid = (b = s.TR, w = s.BR, [
                                        .5 * (b[0] + w[0]),
                                        .5 * (b[1] + w[1])
                                    ]), T = s.TL, k = s.TR;
                                }
                            }
                            function E() {
                                var t1, e1 = {
                                    x: t1 = Math.sqrt(h),
                                    y: -t1
                                };
                                return [
                                    e1.x,
                                    e1.y
                                ];
                            }
                        }(e1), f.each(function() {
                            var f = n.select(this).selectAll("g.slice").data(e1);
                            f.enter().append("g").classed("slice", !0), f.exit().remove(), f.each(function(o, s) {
                                if (o.hidden) n.select(this).selectAll("path,g").remove();
                                else {
                                    o.pointNumber = o.i, o.curveNumber = y.index;
                                    var f = d.cx, v = d.cy, x = n.select(this), w = x.selectAll("path.surface").data([
                                        o
                                    ]);
                                    w.enter().append("path").classed("surface", !0).style({
                                        "pointer-events": r ? "none" : "all"
                                    }), x.call(m, t1, e1);
                                    var T = "M" + (f + o.TR[0]) + "," + (v + o.TR[1]) + b(o.TR, o.BR) + b(o.BR, o.BL) + b(o.BL, o.TL) + "Z";
                                    w.attr("d", T), _(t1, o, d);
                                    var k = p.castOption(y.textposition, o.pts), A = x.selectAll("g.slicetext").data(o.text && "none" !== k ? [
                                        0
                                    ] : []);
                                    A.enter().append("g").classed("slicetext", !0), A.exit().remove(), A.each(function() {
                                        var r = a.ensureSingle(n.select(this), "text", "", function(t1) {
                                            t1.attr("data-notex", 1);
                                        }), p = a.ensureUniformFontSize(t1, g(y, o, u.font));
                                        r.text(o.text).attr({
                                            class: "slicetext",
                                            transform: "",
                                            "text-anchor": "middle"
                                        }).call(i.font, p).call(l.convertToTspans, t1);
                                        var d, m, x, _ = i.bBox(r.node()), b = Math.min(o.BL[1], o.BR[1]) + v, w = Math.max(o.TL[1], o.TR[1]) + v;
                                        m = Math.max(o.TL[0], o.BL[0]) + f, x = Math.min(o.TR[0], o.BR[0]) + f, (d = c(m, x, b, w, _, {
                                            isHorizontal: !0,
                                            constrained: !0,
                                            angle: 0,
                                            anchor: "middle"
                                        })).fontSize = p.size, h(y.type, d, u), e1[s].transform = d, a.setTransormAndDisplay(r, d);
                                    });
                                }
                            });
                            var v = n.select(this).selectAll("g.titletext").data(y.title.text ? [
                                0
                            ] : []);
                            v.enter().append("g").classed("titletext", !0), v.exit().remove(), v.each(function() {
                                var e1 = a.ensureSingle(n.select(this), "text", "", function(t1) {
                                    t1.attr("data-notex", 1);
                                }), r = y.title.text;
                                y._meta && (r = a.templateString(r, y._meta)), e1.text(r).attr({
                                    class: "titletext",
                                    transform: "",
                                    "text-anchor": "middle"
                                }).call(i.font, y.title.font).call(l.convertToTspans, t1);
                                var c = x(d, u._size);
                                e1.attr("transform", s(c.x, c.y) + o(Math.min(1, c.scale)) + s(c.tx, c.ty));
                            });
                        });
                    });
                };
            },
            13757: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(32891), a = r(84102).resizeText;
                t1.exports = function(t1) {
                    var e1 = t1._fullLayout._funnelarealayer.selectAll(".trace");
                    a(t1, e1, "funnelarea"), e1.each(function(e1) {
                        var r = e1[0].trace, a = n.select(this);
                        a.style({
                            opacity: r.opacity
                        }), a.selectAll("path.surface").each(function(e1) {
                            n.select(this).call(i, e1, r, t1);
                        });
                    });
                };
            },
            81658: function(t1, e1, r) {
                "use strict";
                var n = r(36640), i = r(9829), a = r(80337), o = r(80712).axisHoverFormat, s = r(3208).rb, l = r(3208).ay, c = r(87163), u = r(93049).extendFlat;
                t1.exports = u({
                    z: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    x: u({}, n.x, {
                        impliedEdits: {
                            xtype: "array"
                        }
                    }),
                    x0: u({}, n.x0, {
                        impliedEdits: {
                            xtype: "scaled"
                        }
                    }),
                    dx: u({}, n.dx, {
                        impliedEdits: {
                            xtype: "scaled"
                        }
                    }),
                    y: u({}, n.y, {
                        impliedEdits: {
                            ytype: "array"
                        }
                    }),
                    y0: u({}, n.y0, {
                        impliedEdits: {
                            ytype: "scaled"
                        }
                    }),
                    dy: u({}, n.dy, {
                        impliedEdits: {
                            ytype: "scaled"
                        }
                    }),
                    xperiod: u({}, n.xperiod, {
                        impliedEdits: {
                            xtype: "scaled"
                        }
                    }),
                    yperiod: u({}, n.yperiod, {
                        impliedEdits: {
                            ytype: "scaled"
                        }
                    }),
                    xperiod0: u({}, n.xperiod0, {
                        impliedEdits: {
                            xtype: "scaled"
                        }
                    }),
                    yperiod0: u({}, n.yperiod0, {
                        impliedEdits: {
                            ytype: "scaled"
                        }
                    }),
                    xperiodalignment: u({}, n.xperiodalignment, {
                        impliedEdits: {
                            xtype: "scaled"
                        }
                    }),
                    yperiodalignment: u({}, n.yperiodalignment, {
                        impliedEdits: {
                            ytype: "scaled"
                        }
                    }),
                    text: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    hovertext: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    transpose: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "calc"
                    },
                    xtype: {
                        valType: "enumerated",
                        values: [
                            "array",
                            "scaled"
                        ],
                        editType: "calc+clearAxisTypes"
                    },
                    ytype: {
                        valType: "enumerated",
                        values: [
                            "array",
                            "scaled"
                        ],
                        editType: "calc+clearAxisTypes"
                    },
                    zsmooth: {
                        valType: "enumerated",
                        values: [
                            "fast",
                            "best",
                            !1
                        ],
                        dflt: !1,
                        editType: "calc"
                    },
                    hoverongaps: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "none"
                    },
                    connectgaps: {
                        valType: "boolean",
                        editType: "calc"
                    },
                    xgap: {
                        valType: "number",
                        dflt: 0,
                        min: 0,
                        editType: "plot"
                    },
                    ygap: {
                        valType: "number",
                        dflt: 0,
                        min: 0,
                        editType: "plot"
                    },
                    xhoverformat: o("x"),
                    yhoverformat: o("y"),
                    zhoverformat: o("z", 1),
                    hovertemplate: s(),
                    texttemplate: l({
                        arrayOk: !1,
                        editType: "plot"
                    }, {
                        keys: [
                            "x",
                            "y",
                            "z",
                            "text"
                        ]
                    }),
                    textfont: a({
                        editType: "plot",
                        autoSize: !0,
                        autoColor: !0,
                        colorEditType: "style"
                    }),
                    showlegend: u({}, i.showlegend, {
                        dflt: !1
                    }),
                    zorder: n.zorder
                }, {
                    transforms: void 0
                }, c("", {
                    cLetter: "z",
                    autoColorDflt: !1
                }));
            },
            51670: function(t1, e1, r) {
                "use strict";
                var n = r(33626), i = r(34809), a = r(29714), o = r(40528), s = r(19226), l = r(28379), c = r(87869), u = r(93877), h = r(69295), f = r(78106), p = r(80924), d = r(63821).BADNUM;
                function m(t1) {
                    for(var e1 = [], r = t1.length, n = 0; n < r; n++){
                        var i = t1[n];
                        i !== d && e1.push(i);
                    }
                    return e1;
                }
                t1.exports = function(t1, e1) {
                    var r, g, y, v, x, _, b, w, T, k, A, M = a.getFromId(t1, e1.xaxis || "x"), S = a.getFromId(t1, e1.yaxis || "y"), E = n.traceIs(e1, "contour"), C = n.traceIs(e1, "histogram"), L = n.traceIs(e1, "gl2d"), I = E ? "best" : e1.zsmooth;
                    if (M._minDtick = 0, S._minDtick = 0, C) v = (A = s(t1, e1)).orig_x, r = A.x, g = A.x0, y = A.dx, w = A.orig_y, x = A.y, _ = A.y0, b = A.dy, T = A.z;
                    else {
                        var P = e1.z;
                        i.isArray1D(P) ? (c(e1, M, S, "x", "y", [
                            "z"
                        ]), r = e1._x, x = e1._y, P = e1._z) : (v = e1.x ? M.makeCalcdata(e1, "x") : [], w = e1.y ? S.makeCalcdata(e1, "y") : [], r = o(e1, M, "x", v).vals, x = o(e1, S, "y", w).vals, e1._x = r, e1._y = x), g = e1.x0, y = e1.dx, _ = e1.y0, b = e1.dy, T = u(P, e1, M, S);
                    }
                    function z(t1) {
                        I = e1._input.zsmooth = e1.zsmooth = !1, i.warn('cannot use zsmooth: "fast": ' + t1);
                    }
                    function O(t1) {
                        if (t1.length > 1) {
                            var e1 = (t1[t1.length - 1] - t1[0]) / (t1.length - 1), r = Math.abs(e1 / 100);
                            for(k = 0; k < t1.length - 1; k++)if (Math.abs(t1[k + 1] - t1[k] - e1) > r) return !1;
                        }
                        return !0;
                    }
                    (M.rangebreaks || S.rangebreaks) && (T = function(t1, e1, r) {
                        for(var n = [], i = -1, a = 0; a < r.length; a++)if (e1[a] !== d) {
                            n[++i] = [];
                            for(var o = 0; o < r[a].length; o++)t1[o] !== d && n[i].push(r[a][o]);
                        }
                        return n;
                    }(r, x, T), C || (r = m(r), x = m(x), e1._x = r, e1._y = x)), C || !E && !e1.connectgaps || (e1._emptypoints = f(T), h(T, e1._emptypoints)), e1._islinear = !1, "log" === M.type || "log" === S.type ? "fast" === I && z("log axis found") : O(r) ? O(x) ? e1._islinear = !0 : "fast" === I && z("y scale is not linear") : "fast" === I && z("x scale is not linear");
                    var D = i.maxRowLength(T), R = "scaled" === e1.xtype ? "" : r, F = p(e1, R, g, y, D, M), B = "scaled" === e1.ytype ? "" : x, N = p(e1, B, _, b, T.length, S);
                    L || (e1._extremes[M._id] = a.findExtremes(M, F), e1._extremes[S._id] = a.findExtremes(S, N));
                    var j = {
                        x: F,
                        y: N,
                        z: T,
                        text: e1._text || e1.text,
                        hovertext: e1._hovertext || e1.hovertext
                    };
                    if (e1.xperiodalignment && v && (j.orig_x = v), e1.yperiodalignment && w && (j.orig_y = w), R && R.length === F.length - 1 && (j.xCenter = R), B && B.length === N.length - 1 && (j.yCenter = B), C && (j.xRanges = A.xRanges, j.yRanges = A.yRanges, j.pts = A.pts), E || l(t1, e1, {
                        vals: T,
                        cLetter: "z"
                    }), E && e1.contours && "heatmap" === e1.contours.coloring) {
                        var U = {
                            type: "contour" === e1.type ? "heatmap" : "histogram2d",
                            xcalendar: e1.xcalendar,
                            ycalendar: e1.ycalendar
                        };
                        j.xfill = p(U, R, g, y, D, M), j.yfill = p(U, B, _, b, T.length, S);
                    }
                    return [
                        j
                    ];
                };
            },
            93877: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(34809), a = r(63821).BADNUM;
                t1.exports = function(t1, e1, r, o) {
                    var s, l, c, u, h, f;
                    function p(t1) {
                        if (n(t1)) return +t1;
                    }
                    if (e1 && e1.transpose) {
                        for(s = 0, h = 0; h < t1.length; h++)s = Math.max(s, t1[h].length);
                        if (0 === s) return !1;
                        c = function(t1) {
                            return t1.length;
                        }, u = function(t1, e1, r) {
                            return (t1[r] || [])[e1];
                        };
                    } else s = t1.length, c = function(t1, e1) {
                        return t1[e1].length;
                    }, u = function(t1, e1, r) {
                        return (t1[e1] || [])[r];
                    };
                    var d = function(t1, e1, r) {
                        return e1 === a || r === a ? a : u(t1, e1, r);
                    };
                    function m(t1) {
                        if (e1 && "carpet" !== e1.type && "contourcarpet" !== e1.type && t1 && "category" === t1.type && e1["_" + t1._id.charAt(0)].length) {
                            var r = t1._id.charAt(0), n = {}, o = e1["_" + r + "CategoryMap"] || e1[r];
                            for(h = 0; h < o.length; h++)n[o[h]] = h;
                            return function(e1) {
                                var r = n[t1._categories[e1]];
                                return r + 1 ? r : a;
                            };
                        }
                        return i.identity;
                    }
                    var g = m(r), y = m(o);
                    o && "category" === o.type && (s = o._categories.length);
                    var v = new Array(s);
                    for(h = 0; h < s; h++)for(l = r && "category" === r.type ? r._categories.length : c(t1, h), v[h] = new Array(l), f = 0; f < l; f++)v[h][f] = p(d(t1, y(h), g(f)));
                    return v;
                };
            },
            12431: function(t1) {
                "use strict";
                t1.exports = {
                    min: "zmin",
                    max: "zmax"
                };
            },
            87869: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(63821).BADNUM, a = r(40528);
                t1.exports = function(t1, e1, r, o, s, l) {
                    var c = t1._length, u = e1.makeCalcdata(t1, o), h = r.makeCalcdata(t1, s);
                    u = a(t1, e1, o, u).vals, h = a(t1, r, s, h).vals;
                    var f, p, d, m, g = t1.text, y = void 0 !== g && n.isArray1D(g), v = t1.hovertext, x = void 0 !== v && n.isArray1D(v), _ = n.distinctVals(u), b = _.vals, w = n.distinctVals(h), T = w.vals, k = [], A = T.length, M = b.length;
                    for(f = 0; f < l.length; f++)k[f] = n.init2dArray(A, M);
                    y && (d = n.init2dArray(A, M)), x && (m = n.init2dArray(A, M));
                    var S = n.init2dArray(A, M);
                    for(f = 0; f < c; f++)if (u[f] !== i && h[f] !== i) {
                        var E = n.findBin(u[f] + _.minDiff / 2, b), C = n.findBin(h[f] + w.minDiff / 2, T);
                        for(p = 0; p < l.length; p++){
                            var L = t1[l[p]];
                            k[p][C][E] = L[f], S[C][E] = f;
                        }
                        y && (d[C][E] = g[f]), x && (m[C][E] = v[f]);
                    }
                    for(t1["_" + o] = b, t1["_" + s] = T, p = 0; p < l.length; p++)t1["_" + l[p]] = k[p];
                    y && (t1._text = d), x && (t1._hovertext = m), e1 && "category" === e1.type && (t1["_" + o + "CategoryMap"] = b.map(function(t1) {
                        return e1._categories[t1];
                    })), r && "category" === r.type && (t1["_" + s + "CategoryMap"] = T.map(function(t1) {
                        return r._categories[t1];
                    })), t1._after2before = S;
                };
            },
            52813: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(86073), a = r(63814), o = r(99669), s = r(44143), l = r(39356), c = r(81658);
                t1.exports = function(t1, e1, r, u) {
                    function h(r, i) {
                        return n.coerce(t1, e1, c, r, i);
                    }
                    i(t1, e1, h, u) ? (o(t1, e1, u, h), h("xhoverformat"), h("yhoverformat"), h("text"), h("hovertext"), h("hovertemplate"), a(h, u), s(t1, e1, h, u), h("hoverongaps"), h("connectgaps", n.isArray1D(e1.z) && !1 !== e1.zsmooth), l(t1, e1, u, h, {
                        prefix: "",
                        cLetter: "z"
                    }), h("zorder")) : e1.visible = !1;
                };
            },
            78106: function(t1, e1, r) {
                "use strict";
                var n = r(34809).maxRowLength;
                t1.exports = function(t1) {
                    var e1, r, i, a, o, s, l, c, u = [], h = {}, f = [], p = t1[0], d = [], m = [
                        0,
                        0,
                        0
                    ], g = n(t1);
                    for(r = 0; r < t1.length; r++)for(e1 = d, d = p, p = t1[r + 1] || [], i = 0; i < g; i++)void 0 === d[i] && ((s = (void 0 !== d[i - 1] ? 1 : 0) + (void 0 !== d[i + 1] ? 1 : 0) + (void 0 !== e1[i] ? 1 : 0) + (void 0 !== p[i] ? 1 : 0)) ? (0 === r && s++, 0 === i && s++, r === t1.length - 1 && s++, i === d.length - 1 && s++, s < 4 && (h[[
                        r,
                        i
                    ]] = [
                        r,
                        i,
                        s
                    ]), u.push([
                        r,
                        i,
                        s
                    ])) : f.push([
                        r,
                        i
                    ]));
                    for(; f.length;){
                        for(l = {}, c = !1, o = f.length - 1; o >= 0; o--)(s = ((h[[
                            (r = (a = f[o])[0]) - 1,
                            i = a[1]
                        ]] || m)[2] + (h[[
                            r + 1,
                            i
                        ]] || m)[2] + (h[[
                            r,
                            i - 1
                        ]] || m)[2] + (h[[
                            r,
                            i + 1
                        ]] || m)[2]) / 20) && (l[a] = [
                            r,
                            i,
                            s
                        ], f.splice(o, 1), c = !0);
                        if (!c) throw "findEmpties iterated with no new neighbors";
                        for(a in l)h[a] = l[a], u.push(l[a]);
                    }
                    return u.sort(function(t1, e1) {
                        return e1[2] - t1[2];
                    });
                };
            },
            93125: function(t1, e1, r) {
                "use strict";
                var n = r(32141), i = r(34809), a = i.isArrayOrTypedArray, o = r(29714), s = r(88856).extractOpts;
                t1.exports = function(t1, e1, r, l, c) {
                    c || (c = {});
                    var u, h, f, p, d = c.isContour, m = t1.cd[0], g = m.trace, y = t1.xa, v = t1.ya, x = m.x, _ = m.y, b = m.z, w = m.xCenter, T = m.yCenter, k = m.zmask, A = g.zhoverformat, M = x, S = _;
                    if (!1 !== t1.index) {
                        try {
                            f = Math.round(t1.index[1]), p = Math.round(t1.index[0]);
                        } catch (e1) {
                            return void i.error("Error hovering on heatmap, pointNumber must be [row,col], found:", t1.index);
                        }
                        if (f < 0 || f >= b[0].length || p < 0 || p > b.length) return;
                    } else {
                        if (n.inbox(e1 - x[0], e1 - x[x.length - 1], 0) > 0 || n.inbox(r - _[0], r - _[_.length - 1], 0) > 0) return;
                        if (d) {
                            var E;
                            for(M = [
                                2 * x[0] - x[1]
                            ], E = 1; E < x.length; E++)M.push((x[E] + x[E - 1]) / 2);
                            for(M.push([
                                2 * x[x.length - 1] - x[x.length - 2]
                            ]), S = [
                                2 * _[0] - _[1]
                            ], E = 1; E < _.length; E++)S.push((_[E] + _[E - 1]) / 2);
                            S.push([
                                2 * _[_.length - 1] - _[_.length - 2]
                            ]);
                        }
                        f = Math.max(0, Math.min(M.length - 2, i.findBin(e1, M))), p = Math.max(0, Math.min(S.length - 2, i.findBin(r, S)));
                    }
                    var C, L, I = y.c2p(x[f]), P = y.c2p(x[f + 1]), z = v.c2p(_[p]), O = v.c2p(_[p + 1]);
                    d ? (C = m.orig_x || x, L = m.orig_y || _, P = I, u = C[f], O = z, h = L[p]) : (C = m.orig_x || w || x, L = m.orig_y || T || _, u = w ? C[f] : (C[f] + C[f + 1]) / 2, h = T ? L[p] : (L[p] + L[p + 1]) / 2, y && "category" === y.type && (u = x[f]), v && "category" === v.type && (h = _[p]), g.zsmooth && (I = P = y.c2p(u), z = O = v.c2p(h)));
                    var D = b[p][f];
                    if (k && !k[p][f] && (D = void 0), void 0 !== D || g.hoverongaps) {
                        var R;
                        a(m.hovertext) && a(m.hovertext[p]) ? R = m.hovertext[p][f] : a(m.text) && a(m.text[p]) && (R = m.text[p][f]);
                        var F = s(g), B = {
                            type: "linear",
                            range: [
                                F.min,
                                F.max
                            ],
                            hoverformat: A,
                            _separators: y._separators,
                            _numFormat: y._numFormat
                        }, N = o.tickText(B, D, "hover").text;
                        return [
                            i.extendFlat(t1, {
                                index: g._after2before ? g._after2before[p][f] : [
                                    p,
                                    f
                                ],
                                distance: t1.maxHoverDistance,
                                spikeDistance: t1.maxSpikeDistance,
                                x0: I,
                                x1: P,
                                y0: z,
                                y1: O,
                                xLabelVal: u,
                                yLabelVal: h,
                                zLabelVal: D,
                                zLabel: N,
                                text: R
                            })
                        ];
                    }
                };
            },
            29251: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    attributes: r(81658),
                    supplyDefaults: r(52813),
                    calc: r(51670),
                    plot: r(19236),
                    colorbar: r(12431),
                    style: r(12774),
                    hoverPoints: r(93125),
                    moduleType: "trace",
                    name: "heatmap",
                    basePlotModule: r(37703),
                    categories: [
                        "cartesian",
                        "svg",
                        "2dMap",
                        "showLegend"
                    ],
                    meta: {}
                };
            },
            69295: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = [
                    [
                        -1,
                        0
                    ],
                    [
                        1,
                        0
                    ],
                    [
                        0,
                        -1
                    ],
                    [
                        0,
                        1
                    ]
                ];
                function a(t1) {
                    return .5 - .25 * Math.min(1, .5 * t1);
                }
                function o(t1, e1, r) {
                    var n, a, o, s, l, c, u, h, f, p, d, m, g, y = 0;
                    for(s = 0; s < e1.length; s++){
                        for(a = (n = e1[s])[0], o = n[1], d = t1[a][o], p = 0, f = 0, l = 0; l < 4; l++)(u = t1[a + (c = i[l])[0]]) && void 0 !== (h = u[o + c[1]]) && (0 === p ? m = g = h : (m = Math.min(m, h), g = Math.max(g, h)), f++, p += h);
                        if (0 === f) throw "iterateInterp2d order is wrong: no defined neighbors";
                        t1[a][o] = p / f, void 0 === d ? f < 4 && (y = 1) : (t1[a][o] = (1 + r) * t1[a][o] - r * d, g > m && (y = Math.max(y, Math.abs(t1[a][o] - d) / (g - m))));
                    }
                    return y;
                }
                t1.exports = function(t1, e1) {
                    var r, i = 1;
                    for(o(t1, e1), r = 0; r < e1.length && !(e1[r][2] < 4); r++);
                    for(e1 = e1.slice(r), r = 0; r < 100 && i > .01; r++)i = o(t1, e1, a(i));
                    return i > .01 && n.log("interp2d didn't converge quickly", i), t1;
                };
            },
            63814: function(t1, e1, r) {
                "use strict";
                var n = r(34809);
                t1.exports = function(t1, e1) {
                    t1("texttemplate");
                    var r = n.extendFlat({}, e1.font, {
                        color: "auto",
                        size: "auto"
                    });
                    n.coerceFont(t1, "textfont", r);
                };
            },
            80924: function(t1, e1, r) {
                "use strict";
                var n = r(33626), i = r(34809).isArrayOrTypedArray;
                t1.exports = function(t1, e1, r, a, o, s) {
                    var l, c, u, h = [], f = n.traceIs(t1, "contour"), p = n.traceIs(t1, "histogram"), d = n.traceIs(t1, "gl2d");
                    if (i(e1) && e1.length > 1 && !p && "category" !== s.type) {
                        var m = e1.length;
                        if (!(m <= o)) return f ? e1.slice(0, o) : e1.slice(0, o + 1);
                        if (f || d) h = Array.from(e1).slice(0, o);
                        else if (1 === o) h = "log" === s.type ? [
                            .5 * e1[0],
                            2 * e1[0]
                        ] : [
                            e1[0] - .5,
                            e1[0] + .5
                        ];
                        else if ("log" === s.type) {
                            for(h = [
                                Math.pow(e1[0], 1.5) / Math.pow(e1[1], .5)
                            ], u = 1; u < m; u++)h.push(Math.sqrt(e1[u - 1] * e1[u]));
                            h.push(Math.pow(e1[m - 1], 1.5) / Math.pow(e1[m - 2], .5));
                        } else {
                            for(h = [
                                1.5 * e1[0] - .5 * e1[1]
                            ], u = 1; u < m; u++)h.push(.5 * (e1[u - 1] + e1[u]));
                            h.push(1.5 * e1[m - 1] - .5 * e1[m - 2]);
                        }
                        if (m < o) {
                            var g, y = h[h.length - 1];
                            if ("log" === s.type) for(g = y / h[h.length - 2], u = m; u < o; u++)y *= g, h.push(y);
                            else for(g = y - h[h.length - 2], u = m; u < o; u++)y += g, h.push(y);
                        }
                    } else {
                        var v = t1[s._id.charAt(0) + "calendar"];
                        for(l = p ? s.r2c(r, 0, v) : i(e1) && 1 === e1.length ? e1[0] : void 0 === r ? 0 : ("log" === s.type ? s.d2c : s.r2c)(r, 0, v), c = a || 1, u = f || d ? 0 : -0.5; u < o; u++)h.push(l + c * u);
                    }
                    return h;
                };
            },
            19236: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(65657), a = r(33626), o = r(62203), s = r(29714), l = r(34809), c = r(30635), u = r(15294), h = r(78766), f = r(88856).extractOpts, p = r(88856).makeColorScaleFuncFromTrace, d = r(62972), m = r(4530).LINE_SPACING, g = r(95544), y = r(1837).STYLE, v = "heatmap-label";
                function x(t1) {
                    return t1.selectAll("g." + v);
                }
                function _(t1) {
                    x(t1).remove();
                }
                function b(t1, e1) {
                    var r = e1.length - 2, n = l.constrain(l.findBin(t1, e1), 0, r), i = e1[n], a = e1[n + 1], o = l.constrain(n + (t1 - i) / (a - i) - .5, 0, r), s = Math.round(o), c = Math.abs(o - s);
                    return o && o !== r && c ? {
                        bin0: s,
                        frac: c,
                        bin1: Math.round(s + c / (o - s))
                    } : {
                        bin0: s,
                        bin1: s,
                        frac: 0
                    };
                }
                function w(t1, e1) {
                    var r = e1.length - 1, n = l.constrain(l.findBin(t1, e1), 0, r), i = e1[n], a = (t1 - i) / (e1[n + 1] - i) || 0;
                    return a <= 0 ? {
                        bin0: n,
                        bin1: n,
                        frac: 0
                    } : a < .5 ? {
                        bin0: n,
                        bin1: n + 1,
                        frac: a
                    } : {
                        bin0: n + 1,
                        bin1: n,
                        frac: 1 - a
                    };
                }
                function T(t1, e1, r) {
                    t1[e1] = r[0], t1[e1 + 1] = r[1], t1[e1 + 2] = r[2], t1[e1 + 3] = Math.round(255 * r[3]);
                }
                t1.exports = function(t1, e1, r, k) {
                    var A = e1.xaxis, M = e1.yaxis;
                    l.makeTraceGroups(k, r, "hm").each(function(e1) {
                        var r, k, S, E, C, L, I, P, z = n.select(this), O = e1[0], D = O.trace, R = D.xgap || 0, F = D.ygap || 0, B = O.z, N = O.x, j = O.y, U = O.xCenter, V = O.yCenter, q = a.traceIs(D, "contour"), H = q ? "best" : D.zsmooth, G = B.length, Z = l.maxRowLength(B), W = !1, Y = !1;
                        for(L = 0; void 0 === r && L < N.length - 1;)r = A.c2p(N[L]), L++;
                        for(L = N.length - 1; void 0 === k && L > 0;)k = A.c2p(N[L]), L--;
                        for(k < r && (S = k, k = r, r = S, W = !0), L = 0; void 0 === E && L < j.length - 1;)E = M.c2p(j[L]), L++;
                        for(L = j.length - 1; void 0 === C && L > 0;)C = M.c2p(j[L]), L--;
                        C < E && (S = E, E = C, C = S, Y = !0), q && (U = N, V = j, N = O.xfill, j = O.yfill);
                        var X = "default";
                        if (H ? X = "best" === H ? "smooth" : "fast" : D._islinear && 0 === R && 0 === F && g() && (X = "fast"), "fast" !== X) {
                            var $ = "best" === H ? 0 : .5;
                            r = Math.max(-$ * A._length, r), k = Math.min((1 + $) * A._length, k), E = Math.max(-$ * M._length, E), C = Math.min((1 + $) * M._length, C);
                        }
                        var J, K, Q = Math.round(k - r), tt = Math.round(C - E);
                        if (r >= A._length || k <= 0 || E >= M._length || C <= 0) return z.selectAll("image").data([]).exit().remove(), void _(z);
                        "fast" === X ? (J = Z, K = G) : (J = Q, K = tt);
                        var et = document.createElement("canvas");
                        et.width = J, et.height = K;
                        var rt, nt, it = et.getContext("2d", {
                            willReadFrequently: !0
                        }), at = p(D, {
                            noNumericCheck: !0,
                            returnArray: !0
                        });
                        "fast" === X ? (rt = W ? function(t1) {
                            return Z - 1 - t1;
                        } : l.identity, nt = Y ? function(t1) {
                            return G - 1 - t1;
                        } : l.identity) : (rt = function(t1) {
                            return l.constrain(Math.round(A.c2p(N[t1]) - r), 0, Q);
                        }, nt = function(t1) {
                            return l.constrain(Math.round(M.c2p(j[t1]) - E), 0, tt);
                        });
                        var ot, st, lt, ct, ut = nt(0), ht = [
                            ut,
                            ut
                        ], ft = W ? 0 : 1, pt = Y ? 0 : 1, dt = 0, mt = 0, gt = 0, yt = 0;
                        function vt(t1, e1) {
                            if (void 0 !== t1) {
                                var r = at(t1);
                                return r[0] = Math.round(r[0]), r[1] = Math.round(r[1]), r[2] = Math.round(r[2]), dt += e1, mt += r[0] * e1, gt += r[1] * e1, yt += r[2] * e1, r;
                            }
                            return [
                                0,
                                0,
                                0,
                                0
                            ];
                        }
                        function xt(t1, e1, r, n) {
                            var i = t1[r.bin0];
                            if (void 0 === i) return vt(void 0, 1);
                            var a, o = t1[r.bin1], s = e1[r.bin0], l = e1[r.bin1], c = o - i || 0, u = s - i || 0;
                            return a = void 0 === o ? void 0 === l ? 0 : void 0 === s ? 2 * (l - i) : 2 * (2 * l - s - i) / 3 : void 0 === l ? void 0 === s ? 0 : 2 * (2 * i - o - s) / 3 : void 0 === s ? 2 * (2 * l - o - i) / 3 : l + i - o - s, vt(i + r.frac * c + n.frac * (u + r.frac * a));
                        }
                        if ("default" !== X) {
                            var _t, bt = 0;
                            try {
                                _t = new Uint8Array(J * K * 4);
                            } catch (t1) {
                                _t = new Array(J * K * 4);
                            }
                            if ("smooth" === X) {
                                var wt, Tt, kt, At = U || N, Mt = V || j, St = new Array(At.length), Et = new Array(Mt.length), Ct = new Array(Q), Lt = U ? w : b, It = V ? w : b;
                                for(L = 0; L < At.length; L++)St[L] = Math.round(A.c2p(At[L]) - r);
                                for(L = 0; L < Mt.length; L++)Et[L] = Math.round(M.c2p(Mt[L]) - E);
                                for(L = 0; L < Q; L++)Ct[L] = Lt(L, St);
                                for(I = 0; I < tt; I++)for(Tt = B[(wt = It(I, Et)).bin0], kt = B[wt.bin1], L = 0; L < Q; L++, bt += 4)T(_t, bt, ct = xt(Tt, kt, Ct[L], wt));
                            } else for(I = 0; I < G; I++)for(lt = B[I], ht = nt(I), L = 0; L < Z; L++)ct = vt(lt[L], 1), T(_t, bt = 4 * (ht * Z + rt(L)), ct);
                            var Pt = it.createImageData(J, K);
                            try {
                                Pt.data.set(_t);
                            } catch (t1) {
                                var zt = Pt.data, Ot = zt.length;
                                for(I = 0; I < Ot; I++)zt[I] = _t[I];
                            }
                            it.putImageData(Pt, 0, 0);
                        } else {
                            var Dt = Math.floor(R / 2), Rt = Math.floor(F / 2);
                            for(I = 0; I < G; I++)if (lt = B[I], ht.reverse(), ht[pt] = nt(I + 1), ht[0] !== ht[1] && void 0 !== ht[0] && void 0 !== ht[1]) for(ot = [
                                st = rt(0),
                                st
                            ], L = 0; L < Z; L++)ot.reverse(), ot[ft] = rt(L + 1), ot[0] !== ot[1] && void 0 !== ot[0] && void 0 !== ot[1] && (ct = vt(lt[L], (ot[1] - ot[0]) * (ht[1] - ht[0])), it.fillStyle = "rgba(" + ct.join(",") + ")", it.fillRect(ot[0] + Dt, ht[0] + Rt, ot[1] - ot[0] - R, ht[1] - ht[0] - F));
                        }
                        mt = Math.round(mt / dt), gt = Math.round(gt / dt), yt = Math.round(yt / dt);
                        var Ft = i("rgb(" + mt + "," + gt + "," + yt + ")");
                        t1._hmpixcount = (t1._hmpixcount || 0) + dt, t1._hmlumcount = (t1._hmlumcount || 0) + dt * Ft.getLuminance();
                        var Bt = z.selectAll("image").data(e1);
                        Bt.enter().append("svg:image").attr({
                            xmlns: d.svg,
                            preserveAspectRatio: "none"
                        }), Bt.attr({
                            height: tt,
                            width: Q,
                            x: r,
                            y: E,
                            "xlink:href": et.toDataURL("image/png")
                        }), "fast" !== X || H || Bt.attr("style", y), _(z);
                        var Nt = D.texttemplate;
                        if (Nt) {
                            var jt = f(D), Ut = {
                                type: "linear",
                                range: [
                                    jt.min,
                                    jt.max
                                ],
                                _separators: A._separators,
                                _numFormat: A._numFormat
                            }, Vt = "histogram2dcontour" === D.type, qt = "contour" === D.type, Ht = qt ? G - 1 : G, Gt = qt ? 1 : 0, Zt = qt ? Z - 1 : Z, Wt = [];
                            for(L = qt ? 1 : 0; L < Ht; L++){
                                var Yt;
                                if (qt) Yt = O.y[L];
                                else if (Vt) {
                                    if (0 === L || L === G - 1) continue;
                                    Yt = O.y[L];
                                } else if (O.yCenter) Yt = O.yCenter[L];
                                else {
                                    if (L + 1 === G && void 0 === O.y[L + 1]) continue;
                                    Yt = (O.y[L] + O.y[L + 1]) / 2;
                                }
                                var Xt = Math.round(M.c2p(Yt));
                                if (!(0 > Xt || Xt > M._length)) for(I = Gt; I < Zt; I++){
                                    var $t;
                                    if (qt) $t = O.x[I];
                                    else if (Vt) {
                                        if (0 === I || I === Z - 1) continue;
                                        $t = O.x[I];
                                    } else if (O.xCenter) $t = O.xCenter[I];
                                    else {
                                        if (I + 1 === Z && void 0 === O.x[I + 1]) continue;
                                        $t = (O.x[I] + O.x[I + 1]) / 2;
                                    }
                                    var Jt = Math.round(A.c2p($t));
                                    if (!(0 > Jt || Jt > A._length)) {
                                        var Kt = u({
                                            x: $t,
                                            y: Yt
                                        }, D, t1._fullLayout);
                                        Kt.x = $t, Kt.y = Yt;
                                        var Qt = O.z[L][I];
                                        void 0 === Qt ? (Kt.z = "", Kt.zLabel = "") : (Kt.z = Qt, Kt.zLabel = s.tickText(Ut, Qt, "hover").text);
                                        var te = O.text && O.text[L] && O.text[L][I];
                                        void 0 !== te && !1 !== te || (te = ""), Kt.text = te;
                                        var ee = l.texttemplateString(Nt, Kt, t1._fullLayout._d3locale, Kt, D._meta || {});
                                        if (ee) {
                                            var re = ee.split("<br>"), ne = re.length, ie = 0;
                                            for(P = 0; P < ne; P++)ie = Math.max(ie, re[P].length);
                                            Wt.push({
                                                l: ne,
                                                c: ie,
                                                t: ee,
                                                x: Jt,
                                                y: Xt,
                                                z: Qt
                                            });
                                        }
                                    }
                                }
                            }
                            var ae = D.textfont, oe = ae.size, se = t1._fullLayout.font.size;
                            if (!oe || "auto" === oe) {
                                var le = 1 / 0, ce = 1 / 0, ue = 0, he = 0;
                                for(P = 0; P < Wt.length; P++){
                                    var fe = Wt[P];
                                    if (ue = Math.max(ue, fe.l), he = Math.max(he, fe.c), P < Wt.length - 1) {
                                        var pe = Wt[P + 1], de = Math.abs(pe.x - fe.x), me = Math.abs(pe.y - fe.y);
                                        de && (le = Math.min(le, de)), me && (ce = Math.min(ce, me));
                                    }
                                }
                                isFinite(le) && isFinite(ce) ? (le -= R, ce -= F, le /= he, ce /= ue, le /= m / 2, ce /= m, oe = Math.min(Math.floor(le), Math.floor(ce), se)) : oe = se;
                            }
                            if (oe <= 0 || !isFinite(oe)) return;
                            x(z).data(Wt).enter().append("g").classed(v, 1).append("text").attr("text-anchor", "middle").each(function(e1) {
                                var r = n.select(this), i = ae.color;
                                i && "auto" !== i || (i = h.contrast(void 0 === e1.z ? t1._fullLayout.plot_bgcolor : "rgba(" + at(e1.z).join() + ")")), r.attr("data-notex", 1).call(c.positionText, function(t1) {
                                    return t1.x;
                                }(e1), function(t1) {
                                    return t1.y - oe * (t1.l * m / 2 - 1);
                                }(e1)).call(o.font, {
                                    family: ae.family,
                                    size: oe,
                                    color: i,
                                    weight: ae.weight,
                                    style: ae.style,
                                    variant: ae.variant,
                                    textcase: ae.textcase,
                                    lineposition: ae.lineposition,
                                    shadow: ae.shadow
                                }).text(e1.t).call(c.convertToTspans, t1);
                            });
                        }
                    });
                };
            },
            12774: function(t1, e1, r) {
                "use strict";
                var n = r(45568);
                t1.exports = function(t1) {
                    n.select(t1).selectAll(".hm image").style("opacity", function(t1) {
                        return t1.trace.opacity;
                    });
                };
            },
            44143: function(t1) {
                "use strict";
                t1.exports = function(t1, e1, r) {
                    !1 === r("zsmooth") && (r("xgap"), r("ygap")), r("zhoverformat");
                };
            },
            86073: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(34809), a = r(33626);
                function o(t1, e1) {
                    var r = e1(t1);
                    return "scaled" === (r ? e1(t1 + "type", "array") : "scaled") && (e1(t1 + "0"), e1("d" + t1)), r;
                }
                t1.exports = function(t1, e1, r, s, l, c) {
                    var u, h, f = r("z");
                    if (l = l || "x", c = c || "y", void 0 === f || !f.length) return 0;
                    if (i.isArray1D(f)) {
                        u = r(l), h = r(c);
                        var p = i.minRowLength(u), d = i.minRowLength(h);
                        if (0 === p || 0 === d) return 0;
                        e1._length = Math.min(p, d, f.length);
                    } else {
                        if (u = o(l, r), h = o(c, r), !function(t1) {
                            for(var e1, r = !0, a = !1, o = !1, s = 0; s < t1.length; s++){
                                if (e1 = t1[s], !i.isArrayOrTypedArray(e1)) {
                                    r = !1;
                                    break;
                                }
                                e1.length > 0 && (a = !0);
                                for(var l = 0; l < e1.length; l++)if (n(e1[l])) {
                                    o = !0;
                                    break;
                                }
                            }
                            return r && a && o;
                        }(f)) return 0;
                        r("transpose"), e1._length = null;
                    }
                    return "heatmapgl" === t1.type || a.getComponentMethod("calendars", "handleTraceDefaults")(t1, e1, [
                        l,
                        c
                    ], s), !0;
                };
            },
            29751: function(t1, e1, r) {
                "use strict";
                for(var n = r(81658), i = r(87163), a = r(93049).extendFlat, o = r(13582).overrideAll, s = [
                    "z",
                    "x",
                    "x0",
                    "dx",
                    "y",
                    "y0",
                    "dy",
                    "text",
                    "transpose",
                    "xtype",
                    "ytype"
                ], l = {}, c = 0; c < s.length; c++){
                    var u = s[c];
                    l[u] = n[u];
                }
                l.zsmooth = {
                    valType: "enumerated",
                    values: [
                        "fast",
                        !1
                    ],
                    dflt: "fast",
                    editType: "calc"
                }, a(l, i("", {
                    cLetter: "z",
                    autoColorDflt: !1
                })), t1.exports = o(l, "calc", "nested");
            },
            89987: function(t1, e1, r) {
                "use strict";
                var n = r(99098).gl_heatmap2d, i = r(29714), a = r(55010);
                function o(t1, e1) {
                    this.scene = t1, this.uid = e1, this.type = "heatmapgl", this.name = "", this.hoverinfo = "all", this.xData = [], this.yData = [], this.zData = [], this.textLabels = [], this.idToIndex = [], this.bounds = [
                        0,
                        0,
                        0,
                        0
                    ], this.options = {
                        zsmooth: "fast",
                        z: [],
                        x: [],
                        y: [],
                        shape: [
                            0,
                            0
                        ],
                        colorLevels: [
                            0
                        ],
                        colorValues: [
                            0,
                            0,
                            0,
                            1
                        ]
                    }, this.heatmap = n(t1.glplot, this.options), this.heatmap._trace = this;
                }
                var s = o.prototype;
                s.handlePick = function(t1) {
                    var e1 = this.options, r = e1.shape, n = t1.pointId, i = n % r[0], a = Math.floor(n / r[0]), o = n;
                    return {
                        trace: this,
                        dataCoord: t1.dataCoord,
                        traceCoord: [
                            e1.x[i],
                            e1.y[a],
                            e1.z[o]
                        ],
                        textLabel: this.textLabels[n],
                        name: this.name,
                        pointIndex: [
                            a,
                            i
                        ],
                        hoverinfo: this.hoverinfo
                    };
                }, s.update = function(t1, e1) {
                    var r = e1[0];
                    this.index = t1.index, this.name = t1.name, this.hoverinfo = t1.hoverinfo;
                    var n = r.z;
                    this.options.z = [].concat.apply([], n);
                    var o = n[0].length, s = n.length;
                    this.options.shape = [
                        o,
                        s
                    ], this.options.x = r.x, this.options.y = r.y, this.options.zsmooth = t1.zsmooth;
                    var l = function(t1) {
                        for(var e1 = t1.colorscale, r = t1.zmin, n = t1.zmax, i = e1.length, o = new Array(i), s = new Array(4 * i), l = 0; l < i; l++){
                            var c = e1[l], u = a(c[1]);
                            o[l] = r + c[0] * (n - r);
                            for(var h = 0; h < 4; h++)s[4 * l + h] = u[h];
                        }
                        return {
                            colorLevels: o,
                            colorValues: s
                        };
                    }(t1);
                    this.options.colorLevels = l.colorLevels, this.options.colorValues = l.colorValues, this.textLabels = [].concat.apply([], t1.text), this.heatmap.update(this.options);
                    var c, u, h = this.scene.xaxis, f = this.scene.yaxis;
                    !1 === t1.zsmooth && (c = {
                        ppad: r.x[1] - r.x[0]
                    }, u = {
                        ppad: r.y[1] - r.y[0]
                    }), t1._extremes[h._id] = i.findExtremes(h, r.x, c), t1._extremes[f._id] = i.findExtremes(f, r.y, u);
                }, s.dispose = function() {
                    this.heatmap.dispose();
                }, t1.exports = function(t1, e1, r) {
                    var n = new o(t1, e1.uid);
                    return n.update(e1, r), n;
                };
            },
            51312: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(86073), a = r(39356), o = r(29751);
                t1.exports = function(t1, e1, r, s) {
                    function l(r, i) {
                        return n.coerce(t1, e1, o, r, i);
                    }
                    i(t1, e1, l, s) ? (l("text"), l("zsmooth"), a(t1, e1, s, l, {
                        prefix: "",
                        cLetter: "z"
                    })) : e1.visible = !1;
                };
            },
            72892: function(t1, e1, r) {
                "use strict";
                [
                    "*heatmapgl* trace is deprecated!",
                    "Please consider switching to the *heatmap* or *image* trace types.",
                    "Alternatively you could contribute/sponsor rewriting this trace type",
                    "based on cartesian features and using regl framework."
                ].join(" "), t1.exports = {
                    attributes: r(29751),
                    supplyDefaults: r(51312),
                    colorbar: r(12431),
                    calc: r(51670),
                    plot: r(89987),
                    moduleType: "trace",
                    name: "heatmapgl",
                    basePlotModule: r(24585),
                    categories: [
                        "gl",
                        "gl2d",
                        "2dMap"
                    ],
                    meta: {}
                };
            },
            16160: function(t1, e1, r) {
                "use strict";
                var n = r(81481), i = r(80712).axisHoverFormat, a = r(3208).rb, o = r(3208).ay, s = r(80337), l = r(64766), c = r(39732), u = r(93049).extendFlat;
                t1.exports = {
                    x: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    y: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    xhoverformat: i("x"),
                    yhoverformat: i("y"),
                    text: u({}, n.text, {}),
                    hovertext: u({}, n.hovertext, {}),
                    orientation: n.orientation,
                    histfunc: {
                        valType: "enumerated",
                        values: [
                            "count",
                            "sum",
                            "avg",
                            "min",
                            "max"
                        ],
                        dflt: "count",
                        editType: "calc"
                    },
                    histnorm: {
                        valType: "enumerated",
                        values: [
                            "",
                            "percent",
                            "probability",
                            "density",
                            "probability density"
                        ],
                        dflt: "",
                        editType: "calc"
                    },
                    cumulative: {
                        enabled: {
                            valType: "boolean",
                            dflt: !1,
                            editType: "calc"
                        },
                        direction: {
                            valType: "enumerated",
                            values: [
                                "increasing",
                                "decreasing"
                            ],
                            dflt: "increasing",
                            editType: "calc"
                        },
                        currentbin: {
                            valType: "enumerated",
                            values: [
                                "include",
                                "exclude",
                                "half"
                            ],
                            dflt: "include",
                            editType: "calc"
                        },
                        editType: "calc"
                    },
                    nbinsx: {
                        valType: "integer",
                        min: 0,
                        dflt: 0,
                        editType: "calc"
                    },
                    xbins: l("x", !0),
                    nbinsy: {
                        valType: "integer",
                        min: 0,
                        dflt: 0,
                        editType: "calc"
                    },
                    ybins: l("y", !0),
                    autobinx: {
                        valType: "boolean",
                        dflt: null,
                        editType: "calc"
                    },
                    autobiny: {
                        valType: "boolean",
                        dflt: null,
                        editType: "calc"
                    },
                    bingroup: {
                        valType: "string",
                        dflt: "",
                        editType: "calc"
                    },
                    hovertemplate: a({}, {
                        keys: c.eventDataKeys
                    }),
                    texttemplate: o({
                        arrayOk: !1,
                        editType: "plot"
                    }, {
                        keys: [
                            "label",
                            "value"
                        ]
                    }),
                    textposition: u({}, n.textposition, {
                        arrayOk: !1
                    }),
                    textfont: s({
                        arrayOk: !1,
                        editType: "plot",
                        colorEditType: "style"
                    }),
                    outsidetextfont: s({
                        arrayOk: !1,
                        editType: "plot",
                        colorEditType: "style"
                    }),
                    insidetextfont: s({
                        arrayOk: !1,
                        editType: "plot",
                        colorEditType: "style"
                    }),
                    insidetextanchor: n.insidetextanchor,
                    textangle: n.textangle,
                    cliponaxis: n.cliponaxis,
                    constraintext: n.constraintext,
                    marker: n.marker,
                    offsetgroup: n.offsetgroup,
                    alignmentgroup: n.alignmentgroup,
                    selected: n.selected,
                    unselected: n.unselected,
                    _deprecated: {
                        bardir: n._deprecated.bardir
                    },
                    zorder: n.zorder
                };
            },
            48198: function(t1) {
                "use strict";
                t1.exports = function(t1, e1) {
                    for(var r = t1.length, n = 0, i = 0; i < r; i++)e1[i] ? (t1[i] /= e1[i], n += t1[i]) : t1[i] = null;
                    return n;
                };
            },
            64766: function(t1) {
                "use strict";
                t1.exports = function(t1, e1) {
                    return {
                        start: {
                            valType: "any",
                            editType: "calc"
                        },
                        end: {
                            valType: "any",
                            editType: "calc"
                        },
                        size: {
                            valType: "any",
                            editType: "calc"
                        },
                        editType: "calc"
                    };
                };
            },
            34870: function(t1, e1, r) {
                "use strict";
                var n = r(10721);
                t1.exports = {
                    count: function(t1, e1, r) {
                        return r[t1]++, 1;
                    },
                    sum: function(t1, e1, r, i) {
                        var a = i[e1];
                        return n(a) ? (a = Number(a), r[t1] += a, a) : 0;
                    },
                    avg: function(t1, e1, r, i, a) {
                        var o = i[e1];
                        return n(o) && (o = Number(o), r[t1] += o, a[t1]++), 0;
                    },
                    min: function(t1, e1, r, i) {
                        var a = i[e1];
                        if (n(a)) {
                            if (a = Number(a), !n(r[t1])) return r[t1] = a, a;
                            if (r[t1] > a) {
                                var o = a - r[t1];
                                return r[t1] = a, o;
                            }
                        }
                        return 0;
                    },
                    max: function(t1, e1, r, i) {
                        var a = i[e1];
                        if (n(a)) {
                            if (a = Number(a), !n(r[t1])) return r[t1] = a, a;
                            if (r[t1] < a) {
                                var o = a - r[t1];
                                return r[t1] = a, o;
                            }
                        }
                        return 0;
                    }
                };
            },
            64852: function(t1, e1, r) {
                "use strict";
                var n = r(63821), i = n.ONEAVGYEAR, a = n.ONEAVGMONTH, o = n.ONEDAY, s = n.ONEHOUR, l = n.ONEMIN, c = n.ONESEC, u = r(29714).tickIncrement;
                function h(t1, e1, r, n) {
                    if (t1 * e1 <= 0) return 1 / 0;
                    for(var i = Math.abs(e1 - t1), a = "date" === r.type, o = f(i, a), s = 0; s < 10; s++){
                        var l = f(80 * o, a);
                        if (o === l) break;
                        if (!p(l, t1, e1, a, r, n)) break;
                        o = l;
                    }
                    return o;
                }
                function f(t1, e1) {
                    return e1 && t1 > c ? t1 > o ? t1 > 1.1 * i ? i : t1 > 1.1 * a ? a : o : t1 > s ? s : t1 > l ? l : c : Math.pow(10, Math.floor(Math.log(t1) / Math.LN10));
                }
                function p(t1, e1, r, n, a, s) {
                    if (n && t1 > o) {
                        var l = d(e1, a, s), c = d(r, a, s), u = t1 === i ? 0 : 1;
                        return l[u] !== c[u];
                    }
                    return Math.floor(r / t1) - Math.floor(e1 / t1) > .1;
                }
                function d(t1, e1, r) {
                    var n = e1.c2d(t1, i, r).split("-");
                    return "" === n[0] && (n.unshift(), n[0] = "-" + n[0]), n;
                }
                t1.exports = function(t1, e1, r, n, a) {
                    var s, l, c = -1.1 * e1, f = -0.1 * e1, p = t1 - f, d = r[0], m = r[1], g = Math.min(h(d + f, d + p, n, a), h(m + f, m + p, n, a)), y = Math.min(h(d + c, d + f, n, a), h(m + c, m + f, n, a));
                    if (g > y && y < Math.abs(m - d) / 4e3 ? (s = g, l = !1) : (s = Math.min(g, y), l = !0), "date" === n.type && s > o) {
                        var v = s === i ? 1 : 6, x = s === i ? "M12" : "M1";
                        return function(e1, r) {
                            var o = n.c2d(e1, i, a), s = o.indexOf("-", v);
                            s > 0 && (o = o.substr(0, s));
                            var c = n.d2c(o, 0, a);
                            if (c < e1) {
                                var h = u(c, x, !1, a);
                                (c + h) / 2 < e1 + t1 && (c = h);
                            }
                            return r && l ? u(c, x, !0, a) : c;
                        };
                    }
                    return function(e1, r) {
                        var n = s * Math.round(e1 / s);
                        return n + s / 10 < e1 && n + .9 * s < e1 + t1 && (n += s), r && l && (n -= s), n;
                    };
                };
            },
            53616: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(34809), a = r(33626), o = r(29714), s = r(35374), l = r(34870), c = r(58665), u = r(48198), h = r(64852);
                function f(t1, e1, r, s, l) {
                    var c, u, h, p, d, m, g, y = s + "bins", v = t1._fullLayout, x = e1["_" + s + "bingroup"], _ = v._histogramBinOpts[x], b = "overlay" === v.barmode, w = function(t1) {
                        return r.r2c(t1, 0, p);
                    }, T = function(t1) {
                        return r.c2r(t1, 0, p);
                    }, k = "date" === r.type ? function(t1) {
                        return t1 || 0 === t1 ? i.cleanDate(t1, null, p) : null;
                    } : function(t1) {
                        return n(t1) ? Number(t1) : null;
                    };
                    function A(t1, e1, r) {
                        e1[t1 + "Found"] ? (e1[t1] = k(e1[t1]), null === e1[t1] && (e1[t1] = r[t1])) : (m[t1] = e1[t1] = r[t1], i.nestedProperty(u[0], y + "." + t1).set(r[t1]));
                    }
                    if (e1["_" + s + "autoBinFinished"]) delete e1["_" + s + "autoBinFinished"];
                    else {
                        u = _.traces;
                        var M = [], S = !0, E = !1, C = !1;
                        for(c = 0; c < u.length; c++)if ((h = u[c]).visible) {
                            var L = _.dirs[c];
                            d = h["_" + L + "pos0"] = r.makeCalcdata(h, L), M = i.concat(M, d), delete h["_" + s + "autoBinFinished"], !0 === e1.visible && (S ? S = !1 : (delete h._autoBin, h["_" + s + "autoBinFinished"] = 1), a.traceIs(h, "2dMap") && (E = !0), "histogram2dcontour" === h.type && (C = !0));
                        }
                        p = u[0][s + "calendar"];
                        var I = o.autoBin(M, r, _.nbins, E, p, _.sizeFound && _.size), P = u[0]._autoBin = {};
                        if (m = P[_.dirs[0]] = {}, C && (_.size || (I.start = T(o.tickIncrement(w(I.start), I.size, !0, p))), void 0 === _.end && (I.end = T(o.tickIncrement(w(I.end), I.size, !1, p)))), b && !a.traceIs(e1, "2dMap") && 0 === I._dataSpan && "category" !== r.type && "multicategory" !== r.type && "" === e1.bingroup && void 0 === e1.xbins) {
                            if (l) return [
                                I,
                                d,
                                !0
                            ];
                            I = function(t1, e1, r, n, a) {
                                var o, s, l, c = t1._fullLayout, u = function(t1, e1) {
                                    for(var r = e1.xaxis, n = e1.yaxis, i = e1.orientation, a = [], o = t1._fullData, s = 0; s < o.length; s++){
                                        var l = o[s];
                                        "histogram" === l.type && !0 === l.visible && l.orientation === i && l.xaxis === r && l.yaxis === n && a.push(l);
                                    }
                                    return a;
                                }(t1, e1), h = !1, p = 1 / 0, d = [
                                    e1
                                ];
                                for(o = 0; o < u.length; o++)if ((s = u[o]) === e1) h = !0;
                                else if (h) {
                                    var m = f(t1, s, r, n, !0), g = m[0], y = m[2];
                                    s["_" + n + "autoBinFinished"] = 1, s["_" + n + "pos0"] = m[1], y ? d.push(s) : p = Math.min(p, g.size);
                                } else l = c._histogramBinOpts[s["_" + n + "bingroup"]], p = Math.min(p, l.size || s[a].size);
                                var v = new Array(d.length);
                                for(o = 0; o < d.length; o++)for(var x = d[o]["_" + n + "pos0"], _ = 0; _ < x.length; _++)if (void 0 !== x[_]) {
                                    v[o] = x[_];
                                    break;
                                }
                                for(isFinite(p) || (p = i.distinctVals(v).minDiff), o = 0; o < d.length; o++){
                                    var b = (s = d[o])[n + "calendar"], w = {
                                        start: r.c2r(v[o] - p / 2, 0, b),
                                        end: r.c2r(v[o] + p / 2, 0, b),
                                        size: p
                                    };
                                    s._input[a] = s[a] = w, (l = c._histogramBinOpts[s["_" + n + "bingroup"]]) && i.extendFlat(l, w);
                                }
                                return e1[a];
                            }(t1, e1, r, s, y);
                        }
                        (g = h.cumulative || {}).enabled && "include" !== g.currentbin && ("decreasing" === g.direction ? I.start = T(o.tickIncrement(w(I.start), I.size, !0, p)) : I.end = T(o.tickIncrement(w(I.end), I.size, !1, p))), _.size = I.size, _.sizeFound || (m.size = I.size, i.nestedProperty(u[0], y + ".size").set(I.size)), A("start", _, I), A("end", _, I);
                    }
                    d = e1["_" + s + "pos0"], delete e1["_" + s + "pos0"];
                    var z = e1._input[y] || {}, O = i.extendFlat({}, _), D = _.start, R = r.r2l(z.start), F = void 0 !== R;
                    if ((_.startFound || F) && R !== r.r2l(D)) {
                        var B = F ? R : i.aggNums(Math.min, null, d), N = {
                            type: "category" === r.type || "multicategory" === r.type ? "linear" : r.type,
                            r2l: r.r2l,
                            dtick: _.size,
                            tick0: D,
                            calendar: p,
                            range: [
                                B,
                                o.tickIncrement(B, _.size, !1, p)
                            ].map(r.l2r)
                        }, j = o.tickFirst(N);
                        j > r.r2l(B) && (j = o.tickIncrement(j, _.size, !0, p)), O.start = r.l2r(j), F || i.nestedProperty(e1, y + ".start").set(O.start);
                    }
                    var U = _.end, V = r.r2l(z.end), q = void 0 !== V;
                    if ((_.endFound || q) && V !== r.r2l(U)) {
                        var H = q ? V : i.aggNums(Math.max, null, d);
                        O.end = r.l2r(H), q || i.nestedProperty(e1, y + ".start").set(O.end);
                    }
                    var G = "autobin" + s;
                    return !1 === e1._input[G] && (e1._input[y] = i.extendFlat({}, e1[y] || {}), delete e1._input[G], delete e1[G]), [
                        O,
                        d
                    ];
                }
                t1.exports = {
                    calc: function(t1, e1) {
                        var r, a, p, d, m = [], g = [], y = "h" === e1.orientation, v = o.getFromId(t1, y ? e1.yaxis : e1.xaxis), x = y ? "y" : "x", _ = {
                            x: "y",
                            y: "x"
                        }[x], b = e1[x + "calendar"], w = e1.cumulative, T = f(t1, e1, v, x), k = T[0], A = T[1], M = "string" == typeof k.size, S = [], E = M ? S : k, C = [], L = [], I = [], P = 0, z = e1.histnorm, O = e1.histfunc, D = -1 !== z.indexOf("density");
                        w.enabled && D && (z = z.replace(/ ?density$/, ""), D = !1);
                        var R, F = "max" === O || "min" === O ? null : 0, B = l.count, N = c[z], j = !1, U = function(t1) {
                            return v.r2c(t1, 0, b);
                        };
                        for(i.isArrayOrTypedArray(e1[_]) && "count" !== O && (R = e1[_], j = "avg" === O, B = l[O]), r = U(k.start), p = U(k.end) + (r - o.tickIncrement(r, k.size, !1, b)) / 1e6; r < p && m.length < 1e6 && (a = o.tickIncrement(r, k.size, !1, b), m.push((r + a) / 2), g.push(F), I.push([]), S.push(r), D && C.push(1 / (a - r)), j && L.push(0), !(a <= r));)r = a;
                        S.push(r), M || "date" !== v.type || (E = {
                            start: U(E.start),
                            end: U(E.end),
                            size: E.size
                        }), t1._fullLayout._roundFnOpts || (t1._fullLayout._roundFnOpts = {});
                        var V = e1["_" + x + "bingroup"], q = {
                            leftGap: 1 / 0,
                            rightGap: 1 / 0
                        };
                        V && (t1._fullLayout._roundFnOpts[V] || (t1._fullLayout._roundFnOpts[V] = q), q = t1._fullLayout._roundFnOpts[V]);
                        var H, G = g.length, Z = !0, W = q.leftGap, Y = q.rightGap, X = {};
                        for(r = 0; r < A.length; r++){
                            var $ = A[r];
                            (d = i.findBin($, E)) >= 0 && d < G && (P += B(d, r, g, R, L), Z && I[d].length && $ !== A[I[d][0]] && (Z = !1), I[d].push(r), X[r] = d, W = Math.min(W, $ - S[d]), Y = Math.min(Y, S[d + 1] - $));
                        }
                        q.leftGap = W, q.rightGap = Y, Z || (H = function(e1, r) {
                            return function() {
                                var n = t1._fullLayout._roundFnOpts[V];
                                return h(n.leftGap, n.rightGap, S, v, b)(e1, r);
                            };
                        }), j && (P = u(g, L)), N && N(g, P, C), w.enabled && function(t1, e1, r) {
                            var n, i, a;
                            function o(e1) {
                                a = t1[e1], t1[e1] /= 2;
                            }
                            function s(e1) {
                                i = t1[e1], t1[e1] = a + i / 2, a += i;
                            }
                            if ("half" === r) {
                                if ("increasing" === e1) for(o(0), n = 1; n < t1.length; n++)s(n);
                                else for(o(t1.length - 1), n = t1.length - 2; n >= 0; n--)s(n);
                            } else if ("increasing" === e1) {
                                for(n = 1; n < t1.length; n++)t1[n] += t1[n - 1];
                                "exclude" === r && (t1.unshift(0), t1.pop());
                            } else {
                                for(n = t1.length - 2; n >= 0; n--)t1[n] += t1[n + 1];
                                "exclude" === r && (t1.push(0), t1.shift());
                            }
                        }(g, w.direction, w.currentbin);
                        var J = Math.min(m.length, g.length), K = [], Q = 0, tt = J - 1;
                        for(r = 0; r < J; r++)if (g[r]) {
                            Q = r;
                            break;
                        }
                        for(r = J - 1; r >= Q; r--)if (g[r]) {
                            tt = r;
                            break;
                        }
                        for(r = Q; r <= tt; r++)if (n(m[r]) && n(g[r])) {
                            var et = {
                                p: m[r],
                                s: g[r],
                                b: 0
                            };
                            w.enabled || (et.pts = I[r], Z ? et.ph0 = et.ph1 = I[r].length ? A[I[r][0]] : m[r] : (e1._computePh = !0, et.ph0 = H(S[r]), et.ph1 = H(S[r + 1], !0))), K.push(et);
                        }
                        return 1 === K.length && (K[0].width1 = o.tickIncrement(K[0].p, k.size, !1, b) - K[0].p), s(K, e1), i.isArrayOrTypedArray(e1.selectedpoints) && i.tagSelected(K, e1, X), K;
                    },
                    calcAllAutoBins: f
                };
            },
            39732: function(t1) {
                "use strict";
                t1.exports = {
                    eventDataKeys: [
                        "binNumber"
                    ]
                };
            },
            83380: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(5975), a = r(33626).traceIs, o = r(36301), s = r(17550).validateCornerradius, l = n.nestedProperty, c = r(84391).getAxisGroup, u = [
                    {
                        aStr: {
                            x: "xbins.start",
                            y: "ybins.start"
                        },
                        name: "start"
                    },
                    {
                        aStr: {
                            x: "xbins.end",
                            y: "ybins.end"
                        },
                        name: "end"
                    },
                    {
                        aStr: {
                            x: "xbins.size",
                            y: "ybins.size"
                        },
                        name: "size"
                    },
                    {
                        aStr: {
                            x: "nbinsx",
                            y: "nbinsy"
                        },
                        name: "nbins"
                    }
                ], h = [
                    "x",
                    "y"
                ];
                t1.exports = function(t1, e1) {
                    var r, f, p, d, m, g, y, v = e1._histogramBinOpts = {}, x = [], _ = {}, b = [];
                    function w(t1, e1) {
                        return n.coerce(r._input, r, r._module.attributes, t1, e1);
                    }
                    function T(t1) {
                        return "v" === t1.orientation ? "x" : "y";
                    }
                    function k(t1, r, a) {
                        var o = t1.uid + "__" + a;
                        r || (r = o);
                        var s = function(t1, r) {
                            return i.getFromTrace({
                                _fullLayout: e1
                            }, t1, r).type;
                        }(t1, a), l = t1[a + "calendar"] || "", c = v[r], u = !0;
                        c && (s === c.axType && l === c.calendar ? (u = !1, c.traces.push(t1), c.dirs.push(a)) : (r = o, s !== c.axType && n.warn([
                            "Attempted to group the bins of trace",
                            t1.index,
                            "set on a",
                            "type:" + s,
                            "axis",
                            "with bins on",
                            "type:" + c.axType,
                            "axis."
                        ].join(" ")), l !== c.calendar && n.warn([
                            "Attempted to group the bins of trace",
                            t1.index,
                            "set with a",
                            l,
                            "calendar",
                            "with bins",
                            c.calendar ? "on a " + c.calendar + " calendar" : "w/o a set calendar"
                        ].join(" ")))), u && (v[r] = {
                            traces: [
                                t1
                            ],
                            dirs: [
                                a
                            ],
                            axType: s,
                            calendar: t1[a + "calendar"] || ""
                        }), t1["_" + a + "bingroup"] = r;
                    }
                    for(m = 0; m < t1.length; m++)if (r = t1[m], a(r, "histogram")) {
                        if (x.push(r), delete r._xautoBinFinished, delete r._yautoBinFinished, "histogram" === r.type) {
                            var A = w("marker.cornerradius", e1.barcornerradius);
                            r.marker && (r.marker.cornerradius = s(A));
                        }
                        a(r, "2dMap") || o(r._input, r, e1, w);
                    }
                    var M = e1._alignmentOpts || {};
                    for(m = 0; m < x.length; m++){
                        if (r = x[m], p = "", !a(r, "2dMap")) {
                            if (d = T(r), "group" === e1.barmode && r.alignmentgroup) {
                                var S = r[d + "axis"], E = c(e1, S) + r.orientation;
                                (M[E] || {})[r.alignmentgroup] && (p = E);
                            }
                            p || "overlay" === e1.barmode || (p = c(e1, r.xaxis) + c(e1, r.yaxis) + T(r));
                        }
                        p ? (_[p] || (_[p] = []), _[p].push(r)) : b.push(r);
                    }
                    for(p in _)if (1 !== (f = _[p]).length) {
                        var C = !1;
                        for(f.length && (r = f[0], C = w("bingroup")), p = C || p, m = 0; m < f.length; m++){
                            var L = (r = f[m])._input.bingroup;
                            L && L !== p && n.warn([
                                "Trace",
                                r.index,
                                "must match",
                                "within bingroup",
                                p + ".",
                                "Ignoring its bingroup:",
                                L,
                                "setting."
                            ].join(" ")), r.bingroup = p, k(r, p, T(r));
                        }
                    } else b.push(f[0]);
                    for(m = 0; m < b.length; m++){
                        r = b[m];
                        var I = w("bingroup");
                        if (a(r, "2dMap")) for(y = 0; y < 2; y++){
                            var P = w((d = h[y]) + "bingroup", I ? I + "__" + d : null);
                            k(r, P, d);
                        }
                        else k(r, I, T(r));
                    }
                    for(p in v){
                        var z = v[p];
                        for(f = z.traces, g = 0; g < u.length; g++){
                            var O, D, R = u[g], F = R.name;
                            if ("nbins" !== F || !z.sizeFound) {
                                for(m = 0; m < f.length; m++){
                                    if (r = f[m], d = z.dirs[m], O = R.aStr[d], void 0 !== l(r._input, O).get()) {
                                        z[F] = w(O), z[F + "Found"] = !0;
                                        break;
                                    }
                                    (D = (r._autoBin || {})[d] || {})[F] && l(r, O).set(D[F]);
                                }
                                if ("start" === F || "end" === F) for(; m < f.length; m++)(r = f[m])["_" + d + "bingroup"] && w(O, (D = (r._autoBin || {})[d] || {})[F]);
                                "nbins" !== F || z.sizeFound || z.nbinsFound || (r = f[0], z[F] = w(O));
                            }
                        }
                    }
                };
            },
            85079: function(t1, e1, r) {
                "use strict";
                var n = r(33626), i = r(34809), a = r(78766), o = r(17550).handleText, s = r(59760), l = r(16160);
                t1.exports = function(t1, e1, r, c) {
                    function u(r, n) {
                        return i.coerce(t1, e1, l, r, n);
                    }
                    var h = u("x"), f = u("y");
                    u("cumulative.enabled") && (u("cumulative.direction"), u("cumulative.currentbin")), u("text");
                    var p = u("textposition");
                    o(t1, e1, c, u, p, {
                        moduleHasSelected: !0,
                        moduleHasUnselected: !0,
                        moduleHasConstrain: !0,
                        moduleHasCliponaxis: !0,
                        moduleHasTextangle: !0,
                        moduleHasInsideanchor: !0
                    }), u("hovertext"), u("hovertemplate"), u("xhoverformat"), u("yhoverformat");
                    var d = u("orientation", f && !h ? "h" : "v"), m = "v" === d ? "x" : "y", g = "v" === d ? "y" : "x", y = h && f ? Math.min(i.minRowLength(h) && i.minRowLength(f)) : i.minRowLength(e1[m] || []);
                    if (y) {
                        e1._length = y, n.getComponentMethod("calendars", "handleTraceDefaults")(t1, e1, [
                            "x",
                            "y"
                        ], c), e1[g] && u("histfunc"), u("histnorm"), u("autobin" + m), s(t1, e1, u, r, c), i.coerceSelectionMarkerOpacity(e1, u);
                        var v = (e1.marker.line || {}).color, x = n.getComponentMethod("errorbars", "supplyDefaults");
                        x(t1, e1, v || a.defaultLine, {
                            axis: "y"
                        }), x(t1, e1, v || a.defaultLine, {
                            axis: "x",
                            inherit: "y"
                        }), u("zorder");
                    } else e1.visible = !1;
                };
            },
            82604: function(t1) {
                "use strict";
                t1.exports = function(t1, e1, r, n, i) {
                    if (t1.x = "xVal" in e1 ? e1.xVal : e1.x, t1.y = "yVal" in e1 ? e1.yVal : e1.y, "zLabelVal" in e1 && (t1.z = e1.zLabelVal), e1.xa && (t1.xaxis = e1.xa), e1.ya && (t1.yaxis = e1.ya), !(r.cumulative || {}).enabled) {
                        var a, o = Array.isArray(i) ? n[0].pts[i[0]][i[1]] : n[i].pts;
                        if (t1.pointNumbers = o, t1.binNumber = t1.pointNumber, delete t1.pointNumber, delete t1.pointIndex, r._indexToPoints) {
                            a = [];
                            for(var s = 0; s < o.length; s++)a = a.concat(r._indexToPoints[o[s]]);
                        } else a = o;
                        t1.pointIndices = a;
                    }
                    return t1;
                };
            },
            20487: function(t1, e1, r) {
                "use strict";
                var n = r(91664).hoverPoints, i = r(29714).hoverLabelText;
                t1.exports = function(t1, e1, r, a, o) {
                    var s = n(t1, e1, r, a, o);
                    if (s) {
                        var l = (t1 = s[0]).cd[t1.index], c = t1.cd[0].trace;
                        if (!c.cumulative.enabled) {
                            var u = "h" === c.orientation ? "y" : "x";
                            t1[u + "Label"] = i(t1[u + "a"], [
                                l.ph0,
                                l.ph1
                            ], c[u + "hoverformat"]);
                        }
                        return s;
                    }
                };
            },
            74461: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    attributes: r(16160),
                    layoutAttributes: r(25412),
                    supplyDefaults: r(85079),
                    crossTraceDefaults: r(83380),
                    supplyLayoutDefaults: r(78931),
                    calc: r(53616).calc,
                    crossTraceCalc: r(24782).crossTraceCalc,
                    plot: r(32995).plot,
                    layerName: "barlayer",
                    style: r(6851).style,
                    styleOnSelect: r(6851).styleOnSelect,
                    colorbar: r(21146),
                    hoverPoints: r(20487),
                    selectPoints: r(88384),
                    eventData: r(82604),
                    moduleType: "trace",
                    name: "histogram",
                    basePlotModule: r(37703),
                    categories: [
                        "bar-like",
                        "cartesian",
                        "svg",
                        "bar",
                        "histogram",
                        "oriented",
                        "errorBarsOK",
                        "showLegend"
                    ],
                    meta: {}
                };
            },
            58665: function(t1) {
                "use strict";
                t1.exports = {
                    percent: function(t1, e1) {
                        for(var r = t1.length, n = 100 / e1, i = 0; i < r; i++)t1[i] *= n;
                    },
                    probability: function(t1, e1) {
                        for(var r = t1.length, n = 0; n < r; n++)t1[n] /= e1;
                    },
                    density: function(t1, e1, r, n) {
                        var i = t1.length;
                        n = n || 1;
                        for(var a = 0; a < i; a++)t1[a] *= r[a] * n;
                    },
                    "probability density": function(t1, e1, r, n) {
                        var i = t1.length;
                        n && (e1 /= n);
                        for(var a = 0; a < i; a++)t1[a] *= r[a] / e1;
                    }
                };
            },
            9310: function(t1, e1, r) {
                "use strict";
                var n = r(16160), i = r(64766), a = r(81658), o = r(9829), s = r(80712).axisHoverFormat, l = r(3208).rb, c = r(3208).ay, u = r(87163), h = r(93049).extendFlat;
                t1.exports = h({
                    x: n.x,
                    y: n.y,
                    z: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    marker: {
                        color: {
                            valType: "data_array",
                            editType: "calc"
                        },
                        editType: "calc"
                    },
                    histnorm: n.histnorm,
                    histfunc: n.histfunc,
                    nbinsx: n.nbinsx,
                    xbins: i("x"),
                    nbinsy: n.nbinsy,
                    ybins: i("y"),
                    autobinx: n.autobinx,
                    autobiny: n.autobiny,
                    bingroup: h({}, n.bingroup, {}),
                    xbingroup: h({}, n.bingroup, {}),
                    ybingroup: h({}, n.bingroup, {}),
                    xgap: a.xgap,
                    ygap: a.ygap,
                    zsmooth: a.zsmooth,
                    xhoverformat: s("x"),
                    yhoverformat: s("y"),
                    zhoverformat: s("z", 1),
                    hovertemplate: l({}, {
                        keys: "z"
                    }),
                    texttemplate: c({
                        arrayOk: !1,
                        editType: "plot"
                    }, {
                        keys: "z"
                    }),
                    textfont: a.textfont,
                    showlegend: h({}, o.showlegend, {
                        dflt: !1
                    })
                }, u("", {
                    cLetter: "z",
                    autoColorDflt: !1
                }));
            },
            19226: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(29714), a = r(34870), o = r(58665), s = r(48198), l = r(64852), c = r(53616).calcAllAutoBins;
                function u(t1, e1, r, n) {
                    var i, a = new Array(t1);
                    if (n) for(i = 0; i < t1; i++)a[i] = 1 / (e1[i + 1] - e1[i]);
                    else {
                        var o = 1 / r;
                        for(i = 0; i < t1; i++)a[i] = o;
                    }
                    return a;
                }
                function h(t1, e1) {
                    return {
                        start: t1(e1.start),
                        end: t1(e1.end),
                        size: e1.size
                    };
                }
                function f(t1, e1, r, n, i, a) {
                    var o, s = t1.length - 1, c = new Array(s), u = l(r, n, t1, i, a);
                    for(o = 0; o < s; o++){
                        var h = (e1 || [])[o];
                        c[o] = void 0 === h ? [
                            u(t1[o]),
                            u(t1[o + 1], !0)
                        ] : [
                            h,
                            h
                        ];
                    }
                    return c;
                }
                t1.exports = function(t1, e1) {
                    var r, l, p, d, m = i.getFromId(t1, e1.xaxis), g = i.getFromId(t1, e1.yaxis), y = e1.xcalendar, v = e1.ycalendar, x = function(t1) {
                        return m.r2c(t1, 0, y);
                    }, _ = function(t1) {
                        return g.r2c(t1, 0, v);
                    }, b = c(t1, e1, m, "x"), w = b[0], T = b[1], k = c(t1, e1, g, "y"), A = k[0], M = k[1], S = e1._length;
                    T.length > S && T.splice(S, T.length - S), M.length > S && M.splice(S, M.length - S);
                    var E = [], C = [], L = [], I = "string" == typeof w.size, P = "string" == typeof A.size, z = [], O = [], D = I ? z : w, R = P ? O : A, F = 0, B = [], N = [], j = e1.histnorm, U = e1.histfunc, V = -1 !== j.indexOf("density"), q = "max" === U || "min" === U ? null : 0, H = a.count, G = o[j], Z = !1, W = [], Y = [], X = "z" in e1 ? e1.z : "marker" in e1 && Array.isArray(e1.marker.color) ? e1.marker.color : "";
                    X && "count" !== U && (Z = "avg" === U, H = a[U]);
                    var $ = w.size, J = x(w.start), K = x(w.end) + (J - i.tickIncrement(J, $, !1, y)) / 1e6;
                    for(r = J; r < K; r = i.tickIncrement(r, $, !1, y))C.push(q), z.push(r), Z && L.push(0);
                    z.push(r);
                    var Q, tt = C.length, et = (r - J) / tt, rt = (Q = J + et / 2, m.c2r(Q, 0, y)), nt = A.size, it = _(A.start), at = _(A.end) + (it - i.tickIncrement(it, nt, !1, v)) / 1e6;
                    for(r = it; r < at; r = i.tickIncrement(r, nt, !1, v)){
                        E.push(C.slice()), O.push(r);
                        var ot = new Array(tt);
                        for(l = 0; l < tt; l++)ot[l] = [];
                        N.push(ot), Z && B.push(L.slice());
                    }
                    O.push(r);
                    var st = E.length, lt = (r - it) / st, ct = function(t1) {
                        return g.c2r(t1, 0, v);
                    }(it + lt / 2);
                    V && (W = u(C.length, D, et, I), Y = u(E.length, R, lt, P)), I || "date" !== m.type || (D = h(x, D)), P || "date" !== g.type || (R = h(_, R));
                    var ut = !0, ht = !0, ft = new Array(tt), pt = new Array(st), dt = 1 / 0, mt = 1 / 0, gt = 1 / 0, yt = 1 / 0;
                    for(r = 0; r < S; r++){
                        var vt = T[r], xt = M[r];
                        p = n.findBin(vt, D), d = n.findBin(xt, R), p >= 0 && p < tt && d >= 0 && d < st && (F += H(p, r, E[d], X, B[d]), N[d][p].push(r), ut && (void 0 === ft[p] ? ft[p] = vt : ft[p] !== vt && (ut = !1)), ht && (void 0 === pt[d] ? pt[d] = xt : pt[d] !== xt && (ht = !1)), dt = Math.min(dt, vt - z[p]), mt = Math.min(mt, z[p + 1] - vt), gt = Math.min(gt, xt - O[d]), yt = Math.min(yt, O[d + 1] - xt));
                    }
                    if (Z) for(d = 0; d < st; d++)F += s(E[d], B[d]);
                    if (G) for(d = 0; d < st; d++)G(E[d], F, W, Y[d]);
                    return {
                        x: T,
                        xRanges: f(z, ut && ft, dt, mt, m, y),
                        x0: rt,
                        dx: et,
                        y: M,
                        yRanges: f(O, ht && pt, gt, yt, g, v),
                        y0: ct,
                        dy: lt,
                        z: E,
                        pts: N
                    };
                };
            },
            29097: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(77134), a = r(44143), o = r(39356), s = r(63814), l = r(9310);
                t1.exports = function(t1, e1, r, c) {
                    function u(r, i) {
                        return n.coerce(t1, e1, l, r, i);
                    }
                    i(t1, e1, u, c), !1 !== e1.visible && (a(t1, e1, u, c), o(t1, e1, c, u, {
                        prefix: "",
                        cLetter: "z"
                    }), u("hovertemplate"), s(u, c), u("xhoverformat"), u("yhoverformat"));
                };
            },
            1873: function(t1, e1, r) {
                "use strict";
                var n = r(93125), i = r(29714).hoverLabelText;
                t1.exports = function(t1, e1, r, a, o) {
                    var s = n(t1, e1, r, a, o);
                    if (s) {
                        var l = (t1 = s[0]).index, c = l[0], u = l[1], h = t1.cd[0], f = h.trace, p = h.xRanges[u], d = h.yRanges[c];
                        return t1.xLabel = i(t1.xa, [
                            p[0],
                            p[1]
                        ], f.xhoverformat), t1.yLabel = i(t1.ya, [
                            d[0],
                            d[1]
                        ], f.yhoverformat), s;
                    }
                };
            },
            66143: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    attributes: r(9310),
                    supplyDefaults: r(29097),
                    crossTraceDefaults: r(83380),
                    calc: r(51670),
                    plot: r(19236),
                    layerName: "heatmaplayer",
                    colorbar: r(12431),
                    style: r(12774),
                    hoverPoints: r(1873),
                    eventData: r(82604),
                    moduleType: "trace",
                    name: "histogram2d",
                    basePlotModule: r(37703),
                    categories: [
                        "cartesian",
                        "svg",
                        "2dMap",
                        "histogram",
                        "showLegend"
                    ],
                    meta: {}
                };
            },
            77134: function(t1, e1, r) {
                "use strict";
                var n = r(33626), i = r(34809);
                t1.exports = function(t1, e1, r, a) {
                    var o = r("x"), s = r("y"), l = i.minRowLength(o), c = i.minRowLength(s);
                    l && c ? (e1._length = Math.min(l, c), n.getComponentMethod("calendars", "handleTraceDefaults")(t1, e1, [
                        "x",
                        "y"
                    ], a), (r("z") || r("marker.color")) && r("histfunc"), r("histnorm"), r("autobinx"), r("autobiny")) : e1.visible = !1;
                };
            },
            85018: function(t1, e1, r) {
                "use strict";
                var n = r(9310), i = r(52240), a = r(87163), o = r(80712).axisHoverFormat, s = r(93049).extendFlat;
                t1.exports = s({
                    x: n.x,
                    y: n.y,
                    z: n.z,
                    marker: n.marker,
                    histnorm: n.histnorm,
                    histfunc: n.histfunc,
                    nbinsx: n.nbinsx,
                    xbins: n.xbins,
                    nbinsy: n.nbinsy,
                    ybins: n.ybins,
                    autobinx: n.autobinx,
                    autobiny: n.autobiny,
                    bingroup: n.bingroup,
                    xbingroup: n.xbingroup,
                    ybingroup: n.ybingroup,
                    autocontour: i.autocontour,
                    ncontours: i.ncontours,
                    contours: i.contours,
                    line: {
                        color: i.line.color,
                        width: s({}, i.line.width, {
                            dflt: .5
                        }),
                        dash: i.line.dash,
                        smoothing: i.line.smoothing,
                        editType: "plot"
                    },
                    xhoverformat: o("x"),
                    yhoverformat: o("y"),
                    zhoverformat: o("z", 1),
                    hovertemplate: n.hovertemplate,
                    texttemplate: i.texttemplate,
                    textfont: i.textfont
                }, a("", {
                    cLetter: "z",
                    editTypeOverride: "calc"
                }));
            },
            49389: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(77134), a = r(47495), o = r(39889), s = r(63814), l = r(85018);
                t1.exports = function(t1, e1, r, c) {
                    function u(r, i) {
                        return n.coerce(t1, e1, l, r, i);
                    }
                    i(t1, e1, u, c), !1 !== e1.visible && (a(t1, e1, u, function(r) {
                        return n.coerce2(t1, e1, l, r);
                    }), o(t1, e1, u, c), u("xhoverformat"), u("yhoverformat"), u("hovertemplate"), e1.contours && "heatmap" === e1.contours.coloring && s(u, c));
                };
            },
            81955: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    attributes: r(85018),
                    supplyDefaults: r(49389),
                    crossTraceDefaults: r(83380),
                    calc: r(40352),
                    plot: r(8850).plot,
                    layerName: "contourlayer",
                    style: r(1328),
                    colorbar: r(92697),
                    hoverPoints: r(29815),
                    moduleType: "trace",
                    name: "histogram2dcontour",
                    basePlotModule: r(37703),
                    categories: [
                        "cartesian",
                        "svg",
                        "2dMap",
                        "contour",
                        "histogram",
                        "showLegend"
                    ],
                    meta: {}
                };
            },
            12505: function(t1, e1, r) {
                "use strict";
                var n = r(3208).rb, i = r(3208).ay, a = r(87163), o = r(13792).u, s = r(55412), l = r(56708), c = r(71856), u = r(43236), h = r(93049).extendFlat, f = r(94850).k;
                t1.exports = {
                    labels: l.labels,
                    parents: l.parents,
                    values: l.values,
                    branchvalues: l.branchvalues,
                    count: l.count,
                    level: l.level,
                    maxdepth: l.maxdepth,
                    tiling: {
                        orientation: {
                            valType: "enumerated",
                            values: [
                                "v",
                                "h"
                            ],
                            dflt: "h",
                            editType: "plot"
                        },
                        flip: c.tiling.flip,
                        pad: {
                            valType: "number",
                            min: 0,
                            dflt: 0,
                            editType: "plot"
                        },
                        editType: "calc"
                    },
                    marker: h({
                        colors: l.marker.colors,
                        line: l.marker.line,
                        pattern: f,
                        editType: "calc"
                    }, a("marker", {
                        colorAttr: "colors",
                        anim: !1
                    })),
                    leaf: l.leaf,
                    pathbar: c.pathbar,
                    text: s.text,
                    textinfo: l.textinfo,
                    texttemplate: i({
                        editType: "plot"
                    }, {
                        keys: u.eventDataKeys.concat([
                            "label",
                            "value"
                        ])
                    }),
                    hovertext: s.hovertext,
                    hoverinfo: l.hoverinfo,
                    hovertemplate: n({}, {
                        keys: u.eventDataKeys
                    }),
                    textfont: s.textfont,
                    insidetextfont: s.insidetextfont,
                    outsidetextfont: c.outsidetextfont,
                    textposition: c.textposition,
                    sort: s.sort,
                    root: l.root,
                    domain: o({
                        name: "icicle",
                        trace: !0,
                        editType: "calc"
                    })
                };
            },
            63387: function(t1, e1, r) {
                "use strict";
                var n = r(44122);
                e1.name = "icicle", e1.plot = function(t1, r, i, a) {
                    n.plotBasePlot(e1.name, t1, r, i, a);
                }, e1.clean = function(t1, r, i, a) {
                    n.cleanBasePlot(e1.name, t1, r, i, a);
                };
            },
            36349: function(t1, e1, r) {
                "use strict";
                var n = r(14852);
                e1._ = function(t1, e1) {
                    return n.calc(t1, e1);
                }, e1.t = function(t1) {
                    return n._runCrossTraceCalc("icicle", t1);
                };
            },
            17918: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(12505), a = r(78766), o = r(13792).N, s = r(17550).handleText, l = r(56155).TEXTPAD, c = r(46979).handleMarkerDefaults, u = r(88856), h = u.hasColorscale, f = u.handleDefaults;
                t1.exports = function(t1, e1, r, u) {
                    function p(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    var d = p("labels"), m = p("parents");
                    if (d && d.length && m && m.length) {
                        var g = p("values");
                        g && g.length ? p("branchvalues") : p("count"), p("level"), p("maxdepth"), p("tiling.orientation"), p("tiling.flip"), p("tiling.pad");
                        var y = p("text");
                        p("texttemplate"), e1.texttemplate || p("textinfo", n.isArrayOrTypedArray(y) ? "text+label" : "label"), p("hovertext"), p("hovertemplate");
                        var v = p("pathbar.visible");
                        s(t1, e1, u, p, "auto", {
                            hasPathbar: v,
                            moduleHasSelected: !1,
                            moduleHasUnselected: !1,
                            moduleHasConstrain: !1,
                            moduleHasCliponaxis: !1,
                            moduleHasTextangle: !1,
                            moduleHasInsideanchor: !1
                        }), p("textposition"), c(t1, e1, u, p);
                        var x = e1._hasColorscale = h(t1, "marker", "colors") || (t1.marker || {}).coloraxis;
                        x && f(t1, e1, u, p, {
                            prefix: "marker.",
                            cLetter: "c"
                        }), p("leaf.opacity", x ? 1 : .7), e1._hovered = {
                            marker: {
                                line: {
                                    width: 2,
                                    color: a.contrast(u.paper_bgcolor)
                                }
                            }
                        }, v && (p("pathbar.thickness", e1.pathbar.textfont.size + 2 * l), p("pathbar.side"), p("pathbar.edgeshape")), p("sort"), p("root.color"), o(e1, u, p), e1._length = null;
                    } else e1.visible = !1;
                };
            },
            23593: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(34809), a = r(62203), o = r(30635), s = r(29316), l = r(50579).styleOne, c = r(43236), u = r(33108), h = r(44691), f = r(19718).formatSliceLabel, p = !1;
                t1.exports = function(t1, e1, r, d, m) {
                    var g = m.width, y = m.height, v = m.viewX, x = m.viewY, _ = m.pathSlice, b = m.toMoveInsideSlice, w = m.strTransform, T = m.hasTransition, k = m.handleSlicesExit, A = m.makeUpdateSliceInterpolator, M = m.makeUpdateTextInterpolator, S = m.prevEntry, E = t1._context.staticPlot, C = t1._fullLayout, L = e1[0].trace, I = -1 !== L.textposition.indexOf("left"), P = -1 !== L.textposition.indexOf("right"), z = -1 !== L.textposition.indexOf("bottom"), O = s(r, [
                        g,
                        y
                    ], {
                        flipX: L.tiling.flip.indexOf("x") > -1,
                        flipY: L.tiling.flip.indexOf("y") > -1,
                        orientation: L.tiling.orientation,
                        pad: {
                            inner: L.tiling.pad
                        },
                        maxDepth: L._maxDepth
                    }).descendants(), D = 1 / 0, R = -1 / 0;
                    O.forEach(function(t1) {
                        var e1 = t1.depth;
                        e1 >= L._maxDepth ? (t1.x0 = t1.x1 = (t1.x0 + t1.x1) / 2, t1.y0 = t1.y1 = (t1.y0 + t1.y1) / 2) : (D = Math.min(D, e1), R = Math.max(R, e1));
                    }), d = d.data(O, u.getPtId), L._maxVisibleLayers = isFinite(R) ? R - D + 1 : 0, d.enter().append("g").classed("slice", !0), k(d, p, {}, [
                        g,
                        y
                    ], _), d.order();
                    var F = null;
                    if (T && S) {
                        var B = u.getPtId(S);
                        d.each(function(t1) {
                            null === F && u.getPtId(t1) === B && (F = {
                                x0: t1.x0,
                                x1: t1.x1,
                                y0: t1.y0,
                                y1: t1.y1
                            });
                        });
                    }
                    var N = function() {
                        return F || {
                            x0: 0,
                            x1: g,
                            y0: 0,
                            y1: y
                        };
                    }, j = d;
                    return T && (j = j.transition().each("end", function() {
                        var e1 = n.select(this);
                        u.setSliceCursor(e1, t1, {
                            hideOnRoot: !0,
                            hideOnLeaves: !1,
                            isTransitioning: !1
                        });
                    })), j.each(function(s) {
                        s._x0 = v(s.x0), s._x1 = v(s.x1), s._y0 = x(s.y0), s._y1 = x(s.y1), s._hoverX = v(s.x1 - L.tiling.pad), s._hoverY = x(z ? s.y1 - L.tiling.pad / 2 : s.y0 + L.tiling.pad / 2);
                        var d = n.select(this), m = i.ensureSingle(d, "path", "surface", function(t1) {
                            t1.style("pointer-events", E ? "none" : "all");
                        });
                        T ? m.transition().attrTween("d", function(t1) {
                            var e1 = A(t1, p, N(), [
                                g,
                                y
                            ], {
                                orientation: L.tiling.orientation,
                                flipX: L.tiling.flip.indexOf("x") > -1,
                                flipY: L.tiling.flip.indexOf("y") > -1
                            });
                            return function(t1) {
                                return _(e1(t1));
                            };
                        }) : m.attr("d", _), d.call(h, r, t1, e1, {
                            styleOne: l,
                            eventDataKeys: c.eventDataKeys,
                            transitionTime: c.CLICK_TRANSITION_TIME,
                            transitionEasing: c.CLICK_TRANSITION_EASING
                        }).call(u.setSliceCursor, t1, {
                            isTransitioning: t1._transitioning
                        }), m.call(l, s, L, t1, {
                            hovered: !1
                        }), s.x0 === s.x1 || s.y0 === s.y1 ? s._text = "" : s._text = f(s, r, L, e1, C) || "";
                        var k = i.ensureSingle(d, "g", "slicetext"), S = i.ensureSingle(k, "text", "", function(t1) {
                            t1.attr("data-notex", 1);
                        }), O = i.ensureUniformFontSize(t1, u.determineTextFont(L, s, C.font));
                        S.text(s._text || " ").classed("slicetext", !0).attr("text-anchor", P ? "end" : I ? "start" : "middle").call(a.font, O).call(o.convertToTspans, t1), s.textBB = a.bBox(S.node()), s.transform = b(s, {
                            fontSize: O.size
                        }), s.transform.fontSize = O.size, T ? S.transition().attrTween("transform", function(t1) {
                            var e1 = M(t1, p, N(), [
                                g,
                                y
                            ]);
                            return function(t1) {
                                return w(e1(t1));
                            };
                        }) : S.attr("transform", w(s));
                    }), F;
                };
            },
            36858: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    moduleType: "trace",
                    name: "icicle",
                    basePlotModule: r(63387),
                    categories: [],
                    animatable: !0,
                    attributes: r(12505),
                    layoutAttributes: r(60052),
                    supplyDefaults: r(17918),
                    supplyLayoutDefaults: r(11747),
                    calc: r(36349)._,
                    crossTraceCalc: r(36349).t,
                    plot: r(1395),
                    style: r(50579).style,
                    colorbar: r(21146),
                    meta: {}
                };
            },
            60052: function(t1) {
                "use strict";
                t1.exports = {
                    iciclecolorway: {
                        valType: "colorlist",
                        editType: "calc"
                    },
                    extendiciclecolors: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    }
                };
            },
            11747: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(60052);
                t1.exports = function(t1, e1) {
                    function r(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    r("iciclecolorway", e1.colorway), r("extendiciclecolors");
                };
            },
            29316: function(t1, e1, r) {
                "use strict";
                var n = r(92264), i = r(36141);
                t1.exports = function(t1, e1, r) {
                    var a = r.flipX, o = r.flipY, s = "h" === r.orientation, l = r.maxDepth, c = e1[0], u = e1[1];
                    l && (c = (t1.height + 1) * e1[0] / Math.min(t1.height + 1, l), u = (t1.height + 1) * e1[1] / Math.min(t1.height + 1, l));
                    var h = n.partition().padding(r.pad.inner).size(s ? [
                        e1[1],
                        c
                    ] : [
                        e1[0],
                        u
                    ])(t1);
                    return (s || a || o) && i(h, e1, {
                        swapXY: s,
                        flipX: a,
                        flipY: o
                    }), h;
                };
            },
            1395: function(t1, e1, r) {
                "use strict";
                var n = r(41567), i = r(23593);
                t1.exports = function(t1, e1, r, a) {
                    return n(t1, e1, r, a, {
                        type: "icicle",
                        drawDescendants: i
                    });
                };
            },
            50579: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(78766), a = r(34809), o = r(84102).resizeText, s = r(72043);
                function l(t1, e1, r, n) {
                    var o = e1.data.data, l = !e1.children, c = o.i, u = a.castOption(r, c, "marker.line.color") || i.defaultLine, h = a.castOption(r, c, "marker.line.width") || 0;
                    t1.call(s, e1, r, n).style("stroke-width", h).call(i.stroke, u).style("opacity", l ? r.leaf.opacity : null);
                }
                t1.exports = {
                    style: function(t1) {
                        var e1 = t1._fullLayout._iciclelayer.selectAll(".trace");
                        o(t1, e1, "icicle"), e1.each(function(e1) {
                            var r = n.select(this), i = e1[0].trace;
                            r.style("opacity", i.opacity), r.selectAll("path.surface").each(function(e1) {
                                n.select(this).call(l, e1, i, t1);
                            });
                        });
                    },
                    styleOne: l
                };
            },
            22153: function(t1, e1, r) {
                "use strict";
                for(var n = r(9829), i = r(36640).zorder, a = r(3208).rb, o = r(93049).extendFlat, s = r(42939).colormodel, l = [
                    "rgb",
                    "rgba",
                    "rgba256",
                    "hsl",
                    "hsla"
                ], c = [], u = [], h = 0; h < l.length; h++){
                    var f = s[l[h]];
                    c.push("For the `" + l[h] + "` colormodel, it is [" + (f.zminDflt || f.min).join(", ") + "]."), u.push("For the `" + l[h] + "` colormodel, it is [" + (f.zmaxDflt || f.max).join(", ") + "].");
                }
                t1.exports = o({
                    source: {
                        valType: "string",
                        editType: "calc"
                    },
                    z: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    colormodel: {
                        valType: "enumerated",
                        values: l,
                        editType: "calc"
                    },
                    zsmooth: {
                        valType: "enumerated",
                        values: [
                            "fast",
                            !1
                        ],
                        dflt: !1,
                        editType: "plot"
                    },
                    zmin: {
                        valType: "info_array",
                        items: [
                            {
                                valType: "number",
                                editType: "calc"
                            },
                            {
                                valType: "number",
                                editType: "calc"
                            },
                            {
                                valType: "number",
                                editType: "calc"
                            },
                            {
                                valType: "number",
                                editType: "calc"
                            }
                        ],
                        editType: "calc"
                    },
                    zmax: {
                        valType: "info_array",
                        items: [
                            {
                                valType: "number",
                                editType: "calc"
                            },
                            {
                                valType: "number",
                                editType: "calc"
                            },
                            {
                                valType: "number",
                                editType: "calc"
                            },
                            {
                                valType: "number",
                                editType: "calc"
                            }
                        ],
                        editType: "calc"
                    },
                    x0: {
                        valType: "any",
                        dflt: 0,
                        editType: "calc+clearAxisTypes"
                    },
                    y0: {
                        valType: "any",
                        dflt: 0,
                        editType: "calc+clearAxisTypes"
                    },
                    dx: {
                        valType: "number",
                        dflt: 1,
                        editType: "calc"
                    },
                    dy: {
                        valType: "number",
                        dflt: 1,
                        editType: "calc"
                    },
                    text: {
                        valType: "data_array",
                        editType: "plot"
                    },
                    hovertext: {
                        valType: "data_array",
                        editType: "plot"
                    },
                    hoverinfo: o({}, n.hoverinfo, {
                        flags: [
                            "x",
                            "y",
                            "z",
                            "color",
                            "name",
                            "text"
                        ],
                        dflt: "x+y+z+text+name"
                    }),
                    hovertemplate: a({}, {
                        keys: [
                            "z",
                            "color",
                            "colormodel"
                        ]
                    }),
                    zorder: i,
                    transforms: void 0
                });
            },
            31181: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(42939), a = r(10721), o = r(29714), s = r(34809).maxRowLength, l = r(96315).p;
                function c(t1, e1, r, i) {
                    return function(a) {
                        return n.constrain((a - t1) * e1, r, i);
                    };
                }
                function u(t1, e1) {
                    return function(r) {
                        return n.constrain(r, t1, e1);
                    };
                }
                t1.exports = function(t1, e1) {
                    var r, n;
                    if (e1._hasZ) r = e1.z.length, n = s(e1.z);
                    else if (e1._hasSource) {
                        var h = l(e1.source);
                        r = h.height, n = h.width;
                    }
                    var f, p = o.getFromId(t1, e1.xaxis || "x"), d = o.getFromId(t1, e1.yaxis || "y"), m = p.d2c(e1.x0) - e1.dx / 2, g = d.d2c(e1.y0) - e1.dy / 2, y = [
                        m,
                        m + n * e1.dx
                    ], v = [
                        g,
                        g + r * e1.dy
                    ];
                    if (p && "log" === p.type) for(f = 0; f < n; f++)y.push(m + f * e1.dx);
                    if (d && "log" === d.type) for(f = 0; f < r; f++)v.push(g + f * e1.dy);
                    return e1._extremes[p._id] = o.findExtremes(p, y), e1._extremes[d._id] = o.findExtremes(d, v), e1._scaler = function(t1) {
                        var e1 = i.colormodel[t1.colormodel], r = (e1.colormodel || t1.colormodel).length;
                        t1._sArray = [];
                        for(var n = 0; n < r; n++)e1.min[n] !== t1.zmin[n] || e1.max[n] !== t1.zmax[n] ? t1._sArray.push(c(t1.zmin[n], (e1.max[n] - e1.min[n]) / (t1.zmax[n] - t1.zmin[n]), e1.min[n], e1.max[n])) : t1._sArray.push(u(e1.min[n], e1.max[n]));
                        return function(e1) {
                            for(var n = e1.slice(0, r), i = 0; i < r; i++){
                                var o = n[i];
                                if (!a(o)) return !1;
                                n[i] = t1._sArray[i](o);
                            }
                            return n;
                        };
                    }(e1), [
                        {
                            x0: m,
                            y0: g,
                            z: e1.z,
                            w: n,
                            h: r
                        }
                    ];
                };
            },
            42939: function(t1) {
                "use strict";
                t1.exports = {
                    colormodel: {
                        rgb: {
                            min: [
                                0,
                                0,
                                0
                            ],
                            max: [
                                255,
                                255,
                                255
                            ],
                            fmt: function(t1) {
                                return t1.slice(0, 3);
                            },
                            suffix: [
                                "",
                                "",
                                ""
                            ]
                        },
                        rgba: {
                            min: [
                                0,
                                0,
                                0,
                                0
                            ],
                            max: [
                                255,
                                255,
                                255,
                                1
                            ],
                            fmt: function(t1) {
                                return t1.slice(0, 4);
                            },
                            suffix: [
                                "",
                                "",
                                "",
                                ""
                            ]
                        },
                        rgba256: {
                            colormodel: "rgba",
                            zminDflt: [
                                0,
                                0,
                                0,
                                0
                            ],
                            zmaxDflt: [
                                255,
                                255,
                                255,
                                255
                            ],
                            min: [
                                0,
                                0,
                                0,
                                0
                            ],
                            max: [
                                255,
                                255,
                                255,
                                1
                            ],
                            fmt: function(t1) {
                                return t1.slice(0, 4);
                            },
                            suffix: [
                                "",
                                "",
                                "",
                                ""
                            ]
                        },
                        hsl: {
                            min: [
                                0,
                                0,
                                0
                            ],
                            max: [
                                360,
                                100,
                                100
                            ],
                            fmt: function(t1) {
                                var e1 = t1.slice(0, 3);
                                return e1[1] = e1[1] + "%", e1[2] = e1[2] + "%", e1;
                            },
                            suffix: [
                                "\xb0",
                                "%",
                                "%"
                            ]
                        },
                        hsla: {
                            min: [
                                0,
                                0,
                                0,
                                0
                            ],
                            max: [
                                360,
                                100,
                                100,
                                1
                            ],
                            fmt: function(t1) {
                                var e1 = t1.slice(0, 4);
                                return e1[1] = e1[1] + "%", e1[2] = e1[2] + "%", e1;
                            },
                            suffix: [
                                "\xb0",
                                "%",
                                "%",
                                ""
                            ]
                        }
                    }
                };
            },
            82766: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(22153), a = r(42939), o = r(84619).IMAGE_URL_PREFIX;
                t1.exports = function(t1, e1) {
                    function r(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    r("source"), e1.source && !e1.source.match(o) && delete e1.source, e1._hasSource = !!e1.source;
                    var s, l = r("z");
                    e1._hasZ = !(void 0 === l || !l.length || !l[0] || !l[0].length), e1._hasZ || e1._hasSource ? (r("x0"), r("y0"), r("dx"), r("dy"), e1._hasZ ? (r("colormodel", "rgb"), r("zmin", (s = a.colormodel[e1.colormodel]).zminDflt || s.min), r("zmax", s.zmaxDflt || s.max)) : e1._hasSource && (e1.colormodel = "rgba256", s = a.colormodel[e1.colormodel], e1.zmin = s.zminDflt, e1.zmax = s.zmaxDflt), r("zsmooth"), r("text"), r("hovertext"), r("hovertemplate"), e1._length = null, r("zorder")) : e1.visible = !1;
                };
            },
            45461: function(t1) {
                "use strict";
                t1.exports = function(t1, e1) {
                    return "xVal" in e1 && (t1.x = e1.xVal), "yVal" in e1 && (t1.y = e1.yVal), e1.xa && (t1.xaxis = e1.xa), e1.ya && (t1.yaxis = e1.ya), t1.color = e1.color, t1.colormodel = e1.trace.colormodel, t1.z || (t1.z = e1.color), t1;
                };
            },
            96315: function(t1, e1, r) {
                "use strict";
                var n = r(19490), i = r(84619).IMAGE_URL_PREFIX, a = r(45708).Buffer;
                e1.p = function(t1) {
                    var e1 = t1.replace(i, ""), r = new a(e1, "base64");
                    return n(r);
                };
            },
            57328: function(t1, e1, r) {
                "use strict";
                var n = r(32141), i = r(34809), a = i.isArrayOrTypedArray, o = r(42939);
                t1.exports = function(t1, e1, r) {
                    var s = t1.cd[0], l = s.trace, c = t1.xa, u = t1.ya;
                    if (!(n.inbox(e1 - s.x0, e1 - (s.x0 + s.w * l.dx), 0) > 0 || n.inbox(r - s.y0, r - (s.y0 + s.h * l.dy), 0) > 0)) {
                        var h, f = Math.floor((e1 - s.x0) / l.dx), p = Math.floor(Math.abs(r - s.y0) / l.dy);
                        if (l._hasZ ? h = s.z[p][f] : l._hasSource && (h = l._canvas.el.getContext("2d", {
                            willReadFrequently: !0
                        }).getImageData(f, p, 1, 1).data), h) {
                            var d, m = s.hi || l.hoverinfo;
                            if (m) {
                                var g = m.split("+");
                                -1 !== g.indexOf("all") && (g = [
                                    "color"
                                ]), -1 !== g.indexOf("color") && (d = !0);
                            }
                            var y, v = o.colormodel[l.colormodel], x = v.colormodel || l.colormodel, _ = x.length, b = l._scaler(h), w = v.suffix, T = [];
                            (l.hovertemplate || d) && (T.push("[" + [
                                b[0] + w[0],
                                b[1] + w[1],
                                b[2] + w[2]
                            ].join(", ")), 4 === _ && T.push(", " + b[3] + w[3]), T.push("]"), T = T.join(""), t1.extraText = x.toUpperCase() + ": " + T), a(l.hovertext) && a(l.hovertext[p]) ? y = l.hovertext[p][f] : a(l.text) && a(l.text[p]) && (y = l.text[p][f]);
                            var k = u.c2p(s.y0 + (p + .5) * l.dy), A = s.x0 + (f + .5) * l.dx, M = s.y0 + (p + .5) * l.dy, S = "[" + h.slice(0, l.colormodel.length).join(", ") + "]";
                            return [
                                i.extendFlat(t1, {
                                    index: [
                                        p,
                                        f
                                    ],
                                    x0: c.c2p(s.x0 + f * l.dx),
                                    x1: c.c2p(s.x0 + (f + 1) * l.dx),
                                    y0: k,
                                    y1: k,
                                    color: b,
                                    xVal: A,
                                    xLabelVal: A,
                                    yVal: M,
                                    yLabelVal: M,
                                    zLabelVal: S,
                                    text: y,
                                    hovertemplateLabels: {
                                        zLabel: S,
                                        colorLabel: T,
                                        "color[0]Label": b[0] + w[0],
                                        "color[1]Label": b[1] + w[1],
                                        "color[2]Label": b[2] + w[2],
                                        "color[3]Label": b[3] + w[3]
                                    }
                                })
                            ];
                        }
                    }
                };
            },
            92106: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    attributes: r(22153),
                    supplyDefaults: r(82766),
                    calc: r(31181),
                    plot: r(36899),
                    style: r(67555),
                    hoverPoints: r(57328),
                    eventData: r(45461),
                    moduleType: "trace",
                    name: "image",
                    basePlotModule: r(37703),
                    categories: [
                        "cartesian",
                        "svg",
                        "2dMap",
                        "noSortingByValue"
                    ],
                    animatable: !1,
                    meta: {}
                };
            },
            36899: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(34809), a = i.strTranslate, o = r(62972), s = r(42939), l = r(95544), c = r(1837).STYLE;
                t1.exports = function(t1, e1, r, u) {
                    var h = e1.xaxis, f = e1.yaxis, p = !t1._context._exportedPlot && l();
                    i.makeTraceGroups(u, r, "im").each(function(e1) {
                        var r = n.select(this), l = e1[0], u = l.trace, d = ("fast" === u.zsmooth || !1 === u.zsmooth && p) && !u._hasZ && u._hasSource && "linear" === h.type && "linear" === f.type;
                        u._realImage = d;
                        var m, g, y, v, x, _, b = l.z, w = l.x0, T = l.y0, k = l.w, A = l.h, M = u.dx, S = u.dy;
                        for(_ = 0; void 0 === m && _ < k;)m = h.c2p(w + _ * M), _++;
                        for(_ = k; void 0 === g && _ > 0;)g = h.c2p(w + _ * M), _--;
                        for(_ = 0; void 0 === v && _ < A;)v = f.c2p(T + _ * S), _++;
                        for(_ = A; void 0 === x && _ > 0;)x = f.c2p(T + _ * S), _--;
                        g < m && (y = g, g = m, m = y), x < v && (y = v, v = x, x = y), d || (m = Math.max(-0.5 * h._length, m), g = Math.min(1.5 * h._length, g), v = Math.max(-0.5 * f._length, v), x = Math.min(1.5 * f._length, x));
                        var E = Math.round(g - m), C = Math.round(x - v);
                        if (E <= 0 || C <= 0) r.selectAll("image").data([]).exit().remove();
                        else {
                            var L = r.selectAll("image").data([
                                e1
                            ]);
                            L.enter().append("svg:image").attr({
                                xmlns: o.svg,
                                preserveAspectRatio: "none"
                            }), L.exit().remove();
                            var I = !1 === u.zsmooth ? c : "";
                            if (d) {
                                var P = i.simpleMap(h.range, h.r2l), z = i.simpleMap(f.range, f.r2l), O = P[1] < P[0], D = z[1] > z[0];
                                if (O || D) {
                                    var R = m + E / 2, F = v + C / 2;
                                    I += "transform:" + a(R + "px", F + "px") + "scale(" + (O ? -1 : 1) + "," + (D ? -1 : 1) + ")" + a(-R + "px", -F + "px") + ";";
                                }
                            }
                            L.attr("style", I);
                            var B = new Promise(function(t1) {
                                if (u._hasZ) t1();
                                else if (u._hasSource) {
                                    if (u._canvas && u._canvas.el.width === k && u._canvas.el.height === A && u._canvas.source === u.source) t1();
                                    else {
                                        var e1 = document.createElement("canvas");
                                        e1.width = k, e1.height = A;
                                        var r = e1.getContext("2d", {
                                            willReadFrequently: !0
                                        });
                                        u._image = u._image || new Image;
                                        var n = u._image;
                                        n.onload = function() {
                                            r.drawImage(n, 0, 0), u._canvas = {
                                                el: e1,
                                                source: u.source
                                            }, t1();
                                        }, n.setAttribute("src", u.source);
                                    }
                                }
                            }).then(function() {
                                var t1, e1;
                                if (u._hasZ) e1 = N(function(t1, e1) {
                                    var r = b[e1][t1];
                                    return i.isTypedArray(r) && (r = Array.from(r)), r;
                                }), t1 = e1.toDataURL("image/png");
                                else if (u._hasSource) {
                                    if (d) t1 = u.source;
                                    else {
                                        var r = u._canvas.el.getContext("2d", {
                                            willReadFrequently: !0
                                        }).getImageData(0, 0, k, A).data;
                                        e1 = N(function(t1, e1) {
                                            var n = 4 * (e1 * k + t1);
                                            return [
                                                r[n],
                                                r[n + 1],
                                                r[n + 2],
                                                r[n + 3]
                                            ];
                                        }), t1 = e1.toDataURL("image/png");
                                    }
                                }
                                L.attr({
                                    "xlink:href": t1,
                                    height: C,
                                    width: E,
                                    x: m,
                                    y: v
                                });
                            });
                            t1._promises.push(B);
                        }
                        function N(t1) {
                            var e1 = document.createElement("canvas");
                            e1.width = E, e1.height = C;
                            var r, n = e1.getContext("2d", {
                                willReadFrequently: !0
                            }), a = function(t1) {
                                return i.constrain(Math.round(h.c2p(w + t1 * M) - m), 0, E);
                            }, o = function(t1) {
                                return i.constrain(Math.round(f.c2p(T + t1 * S) - v), 0, C);
                            }, c = s.colormodel[u.colormodel], p = c.colormodel || u.colormodel, d = c.fmt;
                            for(_ = 0; _ < l.w; _++){
                                var g = a(_), y = a(_ + 1);
                                if (y !== g && !isNaN(y) && !isNaN(g)) for(var x = 0; x < l.h; x++){
                                    var b = o(x), k = o(x + 1);
                                    k === b || isNaN(k) || isNaN(b) || !t1(_, x) || (r = u._scaler(t1(_, x)), n.fillStyle = r ? p + "(" + d(r).join(",") + ")" : "rgba(0,0,0,0)", n.fillRect(g, b, y - g, k - b));
                                }
                            }
                            return e1;
                        }
                    });
                };
            },
            67555: function(t1, e1, r) {
                "use strict";
                var n = r(45568);
                t1.exports = function(t1) {
                    n.select(t1).selectAll(".im image").style("opacity", function(t1) {
                        return t1[0].trace.opacity;
                    });
                };
            },
            95485: function(t1, e1, r) {
                "use strict";
                var n = r(93049).extendFlat, i = r(93049).extendDeep, a = r(13582).overrideAll, o = r(80337), s = r(10229), l = r(13792).u, c = r(25829), u = r(78032).templatedArray, h = r(20909), f = r(80712).descriptionOnlyNumbers, p = o({
                    editType: "plot",
                    colorEditType: "plot"
                }), d = {
                    color: {
                        valType: "color",
                        editType: "plot"
                    },
                    line: {
                        color: {
                            valType: "color",
                            dflt: s.defaultLine,
                            editType: "plot"
                        },
                        width: {
                            valType: "number",
                            min: 0,
                            dflt: 0,
                            editType: "plot"
                        },
                        editType: "calc"
                    },
                    thickness: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 1,
                        editType: "plot"
                    },
                    editType: "calc"
                }, m = {
                    valType: "info_array",
                    items: [
                        {
                            valType: "number",
                            editType: "plot"
                        },
                        {
                            valType: "number",
                            editType: "plot"
                        }
                    ],
                    editType: "plot"
                }, g = u("step", i({}, d, {
                    range: m
                }));
                t1.exports = {
                    mode: {
                        valType: "flaglist",
                        editType: "calc",
                        flags: [
                            "number",
                            "delta",
                            "gauge"
                        ],
                        dflt: "number"
                    },
                    value: {
                        valType: "number",
                        editType: "calc",
                        anim: !0
                    },
                    align: {
                        valType: "enumerated",
                        values: [
                            "left",
                            "center",
                            "right"
                        ],
                        editType: "plot"
                    },
                    domain: l({
                        name: "indicator",
                        trace: !0,
                        editType: "calc"
                    }),
                    title: {
                        text: {
                            valType: "string",
                            editType: "plot"
                        },
                        align: {
                            valType: "enumerated",
                            values: [
                                "left",
                                "center",
                                "right"
                            ],
                            editType: "plot"
                        },
                        font: n({}, p, {}),
                        editType: "plot"
                    },
                    number: {
                        valueformat: {
                            valType: "string",
                            dflt: "",
                            editType: "plot",
                            description: f("value")
                        },
                        font: n({}, p, {}),
                        prefix: {
                            valType: "string",
                            dflt: "",
                            editType: "plot"
                        },
                        suffix: {
                            valType: "string",
                            dflt: "",
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    delta: {
                        reference: {
                            valType: "number",
                            editType: "calc"
                        },
                        position: {
                            valType: "enumerated",
                            values: [
                                "top",
                                "bottom",
                                "left",
                                "right"
                            ],
                            dflt: "bottom",
                            editType: "plot"
                        },
                        relative: {
                            valType: "boolean",
                            editType: "plot",
                            dflt: !1
                        },
                        valueformat: {
                            valType: "string",
                            editType: "plot",
                            description: f("value")
                        },
                        increasing: {
                            symbol: {
                                valType: "string",
                                dflt: h.INCREASING.SYMBOL,
                                editType: "plot"
                            },
                            color: {
                                valType: "color",
                                dflt: h.INCREASING.COLOR,
                                editType: "plot"
                            },
                            editType: "plot"
                        },
                        decreasing: {
                            symbol: {
                                valType: "string",
                                dflt: h.DECREASING.SYMBOL,
                                editType: "plot"
                            },
                            color: {
                                valType: "color",
                                dflt: h.DECREASING.COLOR,
                                editType: "plot"
                            },
                            editType: "plot"
                        },
                        font: n({}, p, {}),
                        prefix: {
                            valType: "string",
                            dflt: "",
                            editType: "plot"
                        },
                        suffix: {
                            valType: "string",
                            dflt: "",
                            editType: "plot"
                        },
                        editType: "calc"
                    },
                    gauge: {
                        shape: {
                            valType: "enumerated",
                            editType: "plot",
                            dflt: "angular",
                            values: [
                                "angular",
                                "bullet"
                            ]
                        },
                        bar: i({}, d, {
                            color: {
                                dflt: "green"
                            }
                        }),
                        bgcolor: {
                            valType: "color",
                            editType: "plot"
                        },
                        bordercolor: {
                            valType: "color",
                            dflt: s.defaultLine,
                            editType: "plot"
                        },
                        borderwidth: {
                            valType: "number",
                            min: 0,
                            dflt: 1,
                            editType: "plot"
                        },
                        axis: a({
                            range: m,
                            visible: n({}, c.visible, {
                                dflt: !0
                            }),
                            tickmode: c.minor.tickmode,
                            nticks: c.nticks,
                            tick0: c.tick0,
                            dtick: c.dtick,
                            tickvals: c.tickvals,
                            ticktext: c.ticktext,
                            ticks: n({}, c.ticks, {
                                dflt: "outside"
                            }),
                            ticklen: c.ticklen,
                            tickwidth: c.tickwidth,
                            tickcolor: c.tickcolor,
                            ticklabelstep: c.ticklabelstep,
                            showticklabels: c.showticklabels,
                            labelalias: c.labelalias,
                            tickfont: o({}),
                            tickangle: c.tickangle,
                            tickformat: c.tickformat,
                            tickformatstops: c.tickformatstops,
                            tickprefix: c.tickprefix,
                            showtickprefix: c.showtickprefix,
                            ticksuffix: c.ticksuffix,
                            showticksuffix: c.showticksuffix,
                            separatethousands: c.separatethousands,
                            exponentformat: c.exponentformat,
                            minexponent: c.minexponent,
                            showexponent: c.showexponent,
                            editType: "plot"
                        }, "plot"),
                        steps: g,
                        threshold: {
                            line: {
                                color: n({}, d.line.color, {}),
                                width: n({}, d.line.width, {
                                    dflt: 1
                                }),
                                editType: "plot"
                            },
                            thickness: n({}, d.thickness, {
                                dflt: .85
                            }),
                            value: {
                                valType: "number",
                                editType: "calc",
                                dflt: !1
                            },
                            editType: "plot"
                        },
                        editType: "plot"
                    }
                };
            },
            47751: function(t1, e1, r) {
                "use strict";
                var n = r(44122);
                e1.name = "indicator", e1.plot = function(t1, r, i, a) {
                    n.plotBasePlot(e1.name, t1, r, i, a);
                }, e1.clean = function(t1, r, i, a) {
                    n.cleanBasePlot(e1.name, t1, r, i, a);
                };
            },
            98385: function(t1) {
                "use strict";
                t1.exports = {
                    calc: function(t1, e1) {
                        var r = [], n = e1.value;
                        "number" != typeof e1._lastValue && (e1._lastValue = e1.value);
                        var i = e1._lastValue, a = i;
                        return e1._hasDelta && "number" == typeof e1.delta.reference && (a = e1.delta.reference), r[0] = {
                            y: n,
                            lastY: i,
                            delta: n - a,
                            relativeDelta: (n - a) / a
                        }, r;
                    }
                };
            },
            74807: function(t1) {
                "use strict";
                t1.exports = {
                    defaultNumberFontSize: 80,
                    bulletNumberDomainSize: .25,
                    bulletPadding: .025,
                    innerRadius: .75,
                    valueThickness: .5,
                    titlePadding: 5,
                    horizontalPadding: 10
                };
            },
            79306: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(95485), a = r(13792).N, o = r(78032), s = r(59008), l = r(74807), c = r(22777), u = r(87433), h = r(12036), f = r(54616);
                function p(t1, e1) {
                    function r(r, a) {
                        return n.coerce(t1, e1, i.gauge.steps, r, a);
                    }
                    r("color"), r("line.color"), r("line.width"), r("range"), r("thickness");
                }
                t1.exports = {
                    supplyDefaults: function(t1, e1, r, d) {
                        function m(r, a) {
                            return n.coerce(t1, e1, i, r, a);
                        }
                        a(e1, d, m), m("mode"), e1._hasNumber = -1 !== e1.mode.indexOf("number"), e1._hasDelta = -1 !== e1.mode.indexOf("delta"), e1._hasGauge = -1 !== e1.mode.indexOf("gauge");
                        var g = m("value");
                        e1._range = [
                            0,
                            "number" == typeof g ? 1.5 * g : 1
                        ];
                        var y, v, x = new Array(2);
                        if (e1._hasNumber) {
                            m("number.valueformat");
                            var _ = n.extendFlat({}, d.font);
                            _.size = void 0, n.coerceFont(m, "number.font", _), void 0 === e1.number.font.size && (e1.number.font.size = l.defaultNumberFontSize, x[0] = !0), m("number.prefix"), m("number.suffix"), y = e1.number.font.size;
                        }
                        if (e1._hasDelta) {
                            var b = n.extendFlat({}, d.font);
                            b.size = void 0, n.coerceFont(m, "delta.font", b), void 0 === e1.delta.font.size && (e1.delta.font.size = (e1._hasNumber ? .5 : 1) * (y || l.defaultNumberFontSize), x[1] = !0), m("delta.reference", e1.value), m("delta.relative"), m("delta.valueformat", e1.delta.relative ? "2%" : ""), m("delta.increasing.symbol"), m("delta.increasing.color"), m("delta.decreasing.symbol"), m("delta.decreasing.color"), m("delta.position"), m("delta.prefix"), m("delta.suffix"), v = e1.delta.font.size;
                        }
                        e1._scaleNumbers = (!e1._hasNumber || x[0]) && (!e1._hasDelta || x[1]) || !1;
                        var w, T, k, A, M = n.extendFlat({}, d.font);
                        function S(t1, e1) {
                            return n.coerce(w, T, i.gauge, t1, e1);
                        }
                        function E(t1, e1) {
                            return n.coerce(k, A, i.gauge.axis, t1, e1);
                        }
                        if (M.size = .25 * (y || v || l.defaultNumberFontSize), n.coerceFont(m, "title.font", M), m("title.text"), e1._hasGauge) {
                            (w = t1.gauge) || (w = {}), T = o.newContainer(e1, "gauge"), S("shape"), (e1._isBullet = "bullet" === e1.gauge.shape) || m("title.align", "center"), (e1._isAngular = "angular" === e1.gauge.shape) || m("align", "center"), S("bgcolor", d.paper_bgcolor), S("borderwidth"), S("bordercolor"), S("bar.color"), S("bar.line.color"), S("bar.line.width"), S("bar.thickness", l.valueThickness * ("bullet" === e1.gauge.shape ? .5 : 1)), s(w, T, {
                                name: "steps",
                                handleItemDefaults: p
                            }), S("threshold.value"), S("threshold.thickness"), S("threshold.line.width"), S("threshold.line.color"), k = {}, w && (k = w.axis || {}), A = o.newContainer(T, "axis"), E("visible"), e1._range = E("range", e1._range);
                            var C = {
                                font: d.font,
                                noAutotickangles: !0,
                                outerTicks: !0,
                                noTicklabelshift: !0,
                                noTicklabelstandoff: !0
                            };
                            c(k, A, E, "linear"), f(k, A, E, "linear", C), h(k, A, E, "linear", C), u(k, A, E, C);
                        } else m("title.align", "center"), m("align", "center"), e1._isAngular = e1._isBullet = !1;
                        e1._length = null;
                    }
                };
            },
            25638: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    moduleType: "trace",
                    name: "indicator",
                    basePlotModule: r(47751),
                    categories: [
                        "svg",
                        "noOpacity",
                        "noHover"
                    ],
                    animatable: !0,
                    attributes: r(95485),
                    supplyDefaults: r(79306).supplyDefaults,
                    calc: r(98385).calc,
                    plot: r(37095),
                    meta: {}
                };
            },
            37095: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(88640).GW, a = r(88640).Dj, o = r(34809), s = o.strScale, l = o.strTranslate, c = o.rad2deg, u = r(4530).MID_SHIFT, h = r(62203), f = r(74807), p = r(30635), d = r(29714), m = r(97655), g = r(40957), y = r(25829), v = r(78766), x = {
                    left: "start",
                    center: "middle",
                    right: "end"
                }, _ = {
                    left: 0,
                    center: .5,
                    right: 1
                }, b = /[yzafpnµmkMGTPEZY]/;
                function w(t1) {
                    return t1 && t1.duration > 0;
                }
                function T(t1) {
                    t1.each(function(t1) {
                        v.stroke(n.select(this), t1.line.color);
                    }).each(function(t1) {
                        v.fill(n.select(this), t1.color);
                    }).style("stroke-width", function(t1) {
                        return t1.line.width;
                    });
                }
                function k(t1, e1, r) {
                    var n = t1._fullLayout, i = o.extendFlat({
                        type: "linear",
                        ticks: "outside",
                        range: r,
                        showline: !0
                    }, e1), a = {
                        type: "linear",
                        _id: "x" + e1._id
                    }, s = {
                        letter: "x",
                        font: n.font,
                        noAutotickangles: !0,
                        noHover: !0,
                        noTickson: !0
                    };
                    function l(t1, e1) {
                        return o.coerce(i, a, y, t1, e1);
                    }
                    return m(i, a, l, s, n), g(i, a, l, s), a;
                }
                function A(t1, e1, r) {
                    return [
                        Math.min(e1 / t1.width, r / t1.height),
                        t1,
                        e1 + "x" + r
                    ];
                }
                function M(t1, e1, r, i) {
                    var a = document.createElementNS("http://www.w3.org/2000/svg", "text"), o = n.select(a);
                    return o.text(t1).attr("x", 0).attr("y", 0).attr("text-anchor", r).attr("data-unformatted", t1).call(p.convertToTspans, i).call(h.font, e1), h.bBox(o.node());
                }
                function S(t1, e1, r, n, i, a) {
                    var s = "_cache" + e1;
                    t1[s] && t1[s].key === i || (t1[s] = {
                        key: i,
                        value: r
                    });
                    var l = o.aggNums(a, null, [
                        t1[s].value,
                        n
                    ], 2);
                    return t1[s].value = l, l;
                }
                t1.exports = function(t1, e1, r, m) {
                    var g, y = t1._fullLayout;
                    w(r) && m && (g = m()), o.makeTraceGroups(y._indicatorlayer, e1, "trace").each(function(e1) {
                        var m, E, C, L, I, P = e1[0].trace, z = n.select(this), O = P._hasGauge, D = P._isAngular, R = P._isBullet, F = P.domain, B = {
                            w: y._size.w * (F.x[1] - F.x[0]),
                            h: y._size.h * (F.y[1] - F.y[0]),
                            l: y._size.l + y._size.w * F.x[0],
                            r: y._size.r + y._size.w * (1 - F.x[1]),
                            t: y._size.t + y._size.h * (1 - F.y[1]),
                            b: y._size.b + y._size.h * F.y[0]
                        }, N = B.l + B.w / 2, j = B.t + B.h / 2, U = Math.min(B.w / 2, B.h), V = f.innerRadius * U, q = P.align || "center";
                        if (E = j, O) {
                            if (D && (m = N, E = j + U / 2, C = function(t1) {
                                return function(t1, e1) {
                                    return [
                                        e1 / Math.sqrt(t1.width / 2 * (t1.width / 2) + t1.height * t1.height),
                                        t1,
                                        e1
                                    ];
                                }(t1, .9 * V);
                            }), R) {
                                var H = f.bulletPadding, G = 1 - f.bulletNumberDomainSize + H;
                                m = B.l + (G + (1 - G) * _[q]) * B.w, C = function(t1) {
                                    return A(t1, (f.bulletNumberDomainSize - H) * B.w, B.h);
                                };
                            }
                        } else m = B.l + _[q] * B.w, C = function(t1) {
                            return A(t1, B.w, B.h);
                        };
                        !function(t1, e1, r, i) {
                            var c, u, f, m = r[0].trace, g = i.numbersX, y = i.numbersY, T = m.align || "center", A = x[T], E = i.transitionOpts, C = i.onComplete, L = o.ensureSingle(e1, "g", "numbers"), I = [];
                            m._hasNumber && I.push("number"), m._hasDelta && (I.push("delta"), "left" === m.delta.position && I.reverse());
                            var P = L.selectAll("text").data(I);
                            function z(e1, r, n, i) {
                                if (!e1.match("s") || n >= 0 == i >= 0 || r(n).slice(-1).match(b) || r(i).slice(-1).match(b)) return r;
                                var a = e1.slice().replace("s", "f").replace(/\d+/, function(t1) {
                                    return parseInt(t1) - 1;
                                }), o = k(t1, {
                                    tickformat: a
                                });
                                return function(t1) {
                                    return Math.abs(t1) < 1 ? d.tickText(o, t1).text : r(t1);
                                };
                            }
                            P.enter().append("text"), P.attr("text-anchor", function() {
                                return A;
                            }).attr("class", function(t1) {
                                return t1;
                            }).attr("x", null).attr("y", null).attr("dx", null).attr("dy", null), P.exit().remove();
                            var O, D = m.mode + m.align;
                            if (m._hasDelta && (O = function() {
                                var e1 = k(t1, {
                                    tickformat: m.delta.valueformat
                                }, m._range);
                                e1.setScale(), d.prepTicks(e1);
                                var i = function(t1) {
                                    return d.tickText(e1, t1).text;
                                }, o = m.delta.suffix, s = m.delta.prefix, l = function(t1) {
                                    return m.delta.relative ? t1.relativeDelta : t1.delta;
                                }, c = function(t1, e1) {
                                    return 0 === t1 || "number" != typeof t1 || isNaN(t1) ? "-" : (t1 > 0 ? m.delta.increasing.symbol : m.delta.decreasing.symbol) + s + e1(t1) + o;
                                }, f = function(t1) {
                                    return t1.delta >= 0 ? m.delta.increasing.color : m.delta.decreasing.color;
                                };
                                void 0 === m._deltaLastValue && (m._deltaLastValue = l(r[0]));
                                var g = L.select("text.delta");
                                function y() {
                                    g.text(c(l(r[0]), i)).call(v.fill, f(r[0])).call(p.convertToTspans, t1);
                                }
                                return g.call(h.font, m.delta.font).call(v.fill, f({
                                    delta: m._deltaLastValue
                                })), w(E) ? g.transition().duration(E.duration).ease(E.easing).tween("text", function() {
                                    var t1 = n.select(this), e1 = l(r[0]), o = m._deltaLastValue, s = z(m.delta.valueformat, i, o, e1), u = a(o, e1);
                                    return m._deltaLastValue = e1, function(e1) {
                                        t1.text(c(u(e1), s)), t1.call(v.fill, f({
                                            delta: u(e1)
                                        }));
                                    };
                                }).each("end", function() {
                                    y(), C && C();
                                }).each("interrupt", function() {
                                    y(), C && C();
                                }) : y(), u = M(c(l(r[0]), i), m.delta.font, A, t1), g;
                            }(), D += m.delta.position + m.delta.font.size + m.delta.font.family + m.delta.valueformat, D += m.delta.increasing.symbol + m.delta.decreasing.symbol, f = u), m._hasNumber && (function() {
                                var e1 = k(t1, {
                                    tickformat: m.number.valueformat
                                }, m._range);
                                e1.setScale(), d.prepTicks(e1);
                                var i = function(t1) {
                                    return d.tickText(e1, t1).text;
                                }, o = m.number.suffix, s = m.number.prefix, l = L.select("text.number");
                                function u() {
                                    var e1 = "number" == typeof r[0].y ? s + i(r[0].y) + o : "-";
                                    l.text(e1).call(h.font, m.number.font).call(p.convertToTspans, t1);
                                }
                                w(E) ? l.transition().duration(E.duration).ease(E.easing).each("end", function() {
                                    u(), C && C();
                                }).each("interrupt", function() {
                                    u(), C && C();
                                }).attrTween("text", function() {
                                    var t1 = n.select(this), e1 = a(r[0].lastY, r[0].y);
                                    m._lastValue = r[0].y;
                                    var l = z(m.number.valueformat, i, r[0].lastY, r[0].y);
                                    return function(r) {
                                        t1.text(s + l(e1(r)) + o);
                                    };
                                }) : u(), c = M(s + i(r[0].y) + o, m.number.font, A, t1);
                            }(), D += m.number.font.size + m.number.font.family + m.number.valueformat + m.number.suffix + m.number.prefix, f = c), m._hasDelta && m._hasNumber) {
                                var R, F, B = [
                                    (c.left + c.right) / 2,
                                    (c.top + c.bottom) / 2
                                ], N = [
                                    (u.left + u.right) / 2,
                                    (u.top + u.bottom) / 2
                                ], j = .75 * m.delta.font.size;
                                "left" === m.delta.position && (R = S(m, "deltaPos", 0, -1 * (c.width * _[m.align] + u.width * (1 - _[m.align]) + j), D, Math.min), F = B[1] - N[1], f = {
                                    width: c.width + u.width + j,
                                    height: Math.max(c.height, u.height),
                                    left: u.left + R,
                                    right: c.right,
                                    top: Math.min(c.top, u.top + F),
                                    bottom: Math.max(c.bottom, u.bottom + F)
                                }), "right" === m.delta.position && (R = S(m, "deltaPos", 0, c.width * (1 - _[m.align]) + u.width * _[m.align] + j, D, Math.max), F = B[1] - N[1], f = {
                                    width: c.width + u.width + j,
                                    height: Math.max(c.height, u.height),
                                    left: c.left,
                                    right: u.right + R,
                                    top: Math.min(c.top, u.top + F),
                                    bottom: Math.max(c.bottom, u.bottom + F)
                                }), "bottom" === m.delta.position && (R = null, F = u.height, f = {
                                    width: Math.max(c.width, u.width),
                                    height: c.height + u.height,
                                    left: Math.min(c.left, u.left),
                                    right: Math.max(c.right, u.right),
                                    top: c.bottom - c.height,
                                    bottom: c.bottom + u.height
                                }), "top" === m.delta.position && (R = null, F = c.top, f = {
                                    width: Math.max(c.width, u.width),
                                    height: c.height + u.height,
                                    left: Math.min(c.left, u.left),
                                    right: Math.max(c.right, u.right),
                                    top: c.bottom - c.height - u.height,
                                    bottom: c.bottom
                                }), O.attr({
                                    dx: R,
                                    dy: F
                                });
                            }
                            (m._hasNumber || m._hasDelta) && L.attr("transform", function() {
                                var t1 = i.numbersScaler(f);
                                D += t1[2];
                                var e1, r = S(m, "numbersScale", 1, t1[0], D, Math.min);
                                m._scaleNumbers || (r = 1), e1 = m._isAngular ? y - r * f.bottom : y - r * (f.top + f.bottom) / 2, m._numbersTop = r * f.top + e1;
                                var n = f[T];
                                "center" === T && (n = (f.left + f.right) / 2);
                                var a = g - r * n;
                                return a = S(m, "numbersTranslate", 0, a, D, Math.max), l(a, e1) + s(r);
                            });
                        }(t1, z, e1, {
                            numbersX: m,
                            numbersY: E,
                            numbersScaler: C,
                            transitionOpts: r,
                            onComplete: g
                        }), O && (L = {
                            range: P.gauge.axis.range,
                            color: P.gauge.bgcolor,
                            line: {
                                color: P.gauge.bordercolor,
                                width: 0
                            },
                            thickness: 1
                        }, I = {
                            range: P.gauge.axis.range,
                            color: "rgba(0, 0, 0, 0)",
                            line: {
                                color: P.gauge.bordercolor,
                                width: P.gauge.borderwidth
                            },
                            thickness: 1
                        });
                        var Z = z.selectAll("g.angular").data(D ? e1 : []);
                        Z.exit().remove();
                        var W = z.selectAll("g.angularaxis").data(D ? e1 : []);
                        W.exit().remove(), D && function(t1, e1, r, a) {
                            var o, s, h, f, p = r[0].trace, m = a.size, g = a.radius, y = a.innerRadius, v = a.gaugeBg, x = a.gaugeOutline, _ = [
                                m.l + m.w / 2,
                                m.t + m.h / 2 + g / 2
                            ], b = a.gauge, A = a.layer, M = a.transitionOpts, S = a.onComplete, E = Math.PI / 2;
                            function C(t1) {
                                var e1 = p.gauge.axis.range[0], r = (t1 - e1) / (p.gauge.axis.range[1] - e1) * Math.PI - E;
                                return r < -E ? -E : r > E ? E : r;
                            }
                            function L(t1) {
                                return n.svg.arc().innerRadius((y + g) / 2 - t1 / 2 * (g - y)).outerRadius((y + g) / 2 + t1 / 2 * (g - y)).startAngle(-E);
                            }
                            function I(t1) {
                                t1.attr("d", function(t1) {
                                    return L(t1.thickness).startAngle(C(t1.range[0])).endAngle(C(t1.range[1]))();
                                });
                            }
                            b.enter().append("g").classed("angular", !0), b.attr("transform", l(_[0], _[1])), A.enter().append("g").classed("angularaxis", !0).classed("crisp", !0), A.selectAll("g.xangularaxistick,path,text").remove(), (o = k(t1, p.gauge.axis)).type = "linear", o.range = p.gauge.axis.range, o._id = "xangularaxis", o.ticklabeloverflow = "allow", o.setScale();
                            var P = function(t1) {
                                return (o.range[0] - t1.x) / (o.range[1] - o.range[0]) * Math.PI + Math.PI;
                            }, z = {}, O = d.makeLabelFns(o, 0).labelStandoff;
                            z.xFn = function(t1) {
                                var e1 = P(t1);
                                return Math.cos(e1) * O;
                            }, z.yFn = function(t1) {
                                var e1 = P(t1), r = Math.sin(e1) > 0 ? .2 : 1;
                                return -Math.sin(e1) * (O + t1.fontSize * r) + Math.abs(Math.cos(e1)) * (t1.fontSize * u);
                            }, z.anchorFn = function(t1) {
                                var e1 = P(t1), r = Math.cos(e1);
                                return Math.abs(r) < .1 ? "middle" : r > 0 ? "start" : "end";
                            }, z.heightFn = function(t1, e1, r) {
                                var n = P(t1);
                                return -0.5 * (1 + Math.sin(n)) * r;
                            };
                            var D = function(t1) {
                                return l(_[0] + g * Math.cos(t1), _[1] - g * Math.sin(t1));
                            };
                            h = function(t1) {
                                return D(P(t1));
                            };
                            if (s = d.calcTicks(o), f = d.getTickSigns(o)[2], o.visible) {
                                f = "inside" === o.ticks ? -1 : 1;
                                var R = (o.linewidth || 1) / 2;
                                d.drawTicks(t1, o, {
                                    vals: s,
                                    layer: A,
                                    path: "M" + f * R + ",0h" + f * o.ticklen,
                                    transFn: function(t1) {
                                        var e1 = P(t1);
                                        return D(e1) + "rotate(" + -c(e1) + ")";
                                    }
                                }), d.drawLabels(t1, o, {
                                    vals: s,
                                    layer: A,
                                    transFn: h,
                                    labelFns: z
                                });
                            }
                            var F = [
                                v
                            ].concat(p.gauge.steps), B = b.selectAll("g.bg-arc").data(F);
                            B.enter().append("g").classed("bg-arc", !0).append("path"), B.select("path").call(I).call(T), B.exit().remove();
                            var N = L(p.gauge.bar.thickness), j = b.selectAll("g.value-arc").data([
                                p.gauge.bar
                            ]);
                            j.enter().append("g").classed("value-arc", !0).append("path");
                            var U, V, q, H = j.select("path");
                            w(M) ? (H.transition().duration(M.duration).ease(M.easing).each("end", function() {
                                S && S();
                            }).each("interrupt", function() {
                                S && S();
                            }).attrTween("d", (U = N, V = C(r[0].lastY), q = C(r[0].y), function() {
                                var t1 = i(V, q);
                                return function(e1) {
                                    return U.endAngle(t1(e1))();
                                };
                            })), p._lastValue = r[0].y) : H.attr("d", "number" == typeof r[0].y ? N.endAngle(C(r[0].y)) : "M0,0Z"), H.call(T), j.exit().remove(), F = [];
                            var G = p.gauge.threshold.value;
                            (G || 0 === G) && F.push({
                                range: [
                                    G,
                                    G
                                ],
                                color: p.gauge.threshold.color,
                                line: {
                                    color: p.gauge.threshold.line.color,
                                    width: p.gauge.threshold.line.width
                                },
                                thickness: p.gauge.threshold.thickness
                            });
                            var Z = b.selectAll("g.threshold-arc").data(F);
                            Z.enter().append("g").classed("threshold-arc", !0).append("path"), Z.select("path").call(I).call(T), Z.exit().remove();
                            var W = b.selectAll("g.gauge-outline").data([
                                x
                            ]);
                            W.enter().append("g").classed("gauge-outline", !0).append("path"), W.select("path").call(I).call(T), W.exit().remove();
                        }(t1, 0, e1, {
                            radius: U,
                            innerRadius: V,
                            gauge: Z,
                            layer: W,
                            size: B,
                            gaugeBg: L,
                            gaugeOutline: I,
                            transitionOpts: r,
                            onComplete: g
                        });
                        var Y = z.selectAll("g.bullet").data(R ? e1 : []);
                        Y.exit().remove();
                        var X = z.selectAll("g.bulletaxis").data(R ? e1 : []);
                        X.exit().remove(), R && function(t1, e1, r, n) {
                            var i, a, o, s, c, u = r[0].trace, h = n.gauge, p = n.layer, m = n.gaugeBg, g = n.gaugeOutline, y = n.size, x = u.domain, _ = n.transitionOpts, b = n.onComplete;
                            h.enter().append("g").classed("bullet", !0), h.attr("transform", l(y.l, y.t)), p.enter().append("g").classed("bulletaxis", !0).classed("crisp", !0), p.selectAll("g.xbulletaxistick,path,text").remove();
                            var A = y.h, M = u.gauge.bar.thickness * A, S = x.x[0], E = x.x[0] + (x.x[1] - x.x[0]) * (u._hasNumber || u._hasDelta ? 1 - f.bulletNumberDomainSize : 1);
                            function C(t1) {
                                t1.attr("width", function(t1) {
                                    return Math.max(0, i.c2p(t1.range[1]) - i.c2p(t1.range[0]));
                                }).attr("x", function(t1) {
                                    return i.c2p(t1.range[0]);
                                }).attr("y", function(t1) {
                                    return .5 * (1 - t1.thickness) * A;
                                }).attr("height", function(t1) {
                                    return t1.thickness * A;
                                });
                            }
                            (i = k(t1, u.gauge.axis))._id = "xbulletaxis", i.domain = [
                                S,
                                E
                            ], i.setScale(), a = d.calcTicks(i), o = d.makeTransTickFn(i), s = d.getTickSigns(i)[2], c = y.t + y.h, i.visible && (d.drawTicks(t1, i, {
                                vals: "inside" === i.ticks ? d.clipEnds(i, a) : a,
                                layer: p,
                                path: d.makeTickPath(i, c, s),
                                transFn: o
                            }), d.drawLabels(t1, i, {
                                vals: a,
                                layer: p,
                                transFn: o,
                                labelFns: d.makeLabelFns(i, c)
                            }));
                            var L = [
                                m
                            ].concat(u.gauge.steps), I = h.selectAll("g.bg-bullet").data(L);
                            I.enter().append("g").classed("bg-bullet", !0).append("rect"), I.select("rect").call(C).call(T), I.exit().remove();
                            var P = h.selectAll("g.value-bullet").data([
                                u.gauge.bar
                            ]);
                            P.enter().append("g").classed("value-bullet", !0).append("rect"), P.select("rect").attr("height", M).attr("y", (A - M) / 2).call(T), w(_) ? P.select("rect").transition().duration(_.duration).ease(_.easing).each("end", function() {
                                b && b();
                            }).each("interrupt", function() {
                                b && b();
                            }).attr("width", Math.max(0, i.c2p(Math.min(u.gauge.axis.range[1], r[0].y)))) : P.select("rect").attr("width", "number" == typeof r[0].y ? Math.max(0, i.c2p(Math.min(u.gauge.axis.range[1], r[0].y))) : 0), P.exit().remove();
                            var z = r.filter(function() {
                                return u.gauge.threshold.value || 0 === u.gauge.threshold.value;
                            }), O = h.selectAll("g.threshold-bullet").data(z);
                            O.enter().append("g").classed("threshold-bullet", !0).append("line"), O.select("line").attr("x1", i.c2p(u.gauge.threshold.value)).attr("x2", i.c2p(u.gauge.threshold.value)).attr("y1", (1 - u.gauge.threshold.thickness) / 2 * A).attr("y2", (1 - (1 - u.gauge.threshold.thickness) / 2) * A).call(v.stroke, u.gauge.threshold.line.color).style("stroke-width", u.gauge.threshold.line.width), O.exit().remove();
                            var D = h.selectAll("g.gauge-outline").data([
                                g
                            ]);
                            D.enter().append("g").classed("gauge-outline", !0).append("rect"), D.select("rect").call(C).call(T), D.exit().remove();
                        }(t1, 0, e1, {
                            gauge: Y,
                            layer: X,
                            size: B,
                            gaugeBg: L,
                            gaugeOutline: I,
                            transitionOpts: r,
                            onComplete: g
                        });
                        var $ = z.selectAll("text.title").data(e1);
                        $.exit().remove(), $.enter().append("text").classed("title", !0), $.attr("text-anchor", function() {
                            return R ? x.right : x[P.title.align];
                        }).text(P.title.text).call(h.font, P.title.font).call(p.convertToTspans, t1), $.attr("transform", function() {
                            var t1, e1 = B.l + B.w * _[P.title.align], r = f.titlePadding, n = h.bBox($.node());
                            return O ? (D && (t1 = P.gauge.axis.visible ? h.bBox(W.node()).top - r - n.bottom : B.t + B.h / 2 - U / 2 - n.bottom - r), R && (t1 = E - (n.top + n.bottom) / 2, e1 = B.l - f.bulletPadding * B.w)) : t1 = P._numbersTop - r - n.bottom, l(e1, t1);
                        });
                    });
                };
            },
            70252: function(t1, e1, r) {
                "use strict";
                var n = r(87163), i = r(80712).axisHoverFormat, a = r(3208).rb, o = r(42450), s = r(9829), l = r(93049).extendFlat, c = r(13582).overrideAll, u = t1.exports = c(l({
                    x: {
                        valType: "data_array"
                    },
                    y: {
                        valType: "data_array"
                    },
                    z: {
                        valType: "data_array"
                    },
                    value: {
                        valType: "data_array"
                    },
                    isomin: {
                        valType: "number"
                    },
                    isomax: {
                        valType: "number"
                    },
                    surface: {
                        show: {
                            valType: "boolean",
                            dflt: !0
                        },
                        count: {
                            valType: "integer",
                            dflt: 2,
                            min: 1
                        },
                        fill: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: 1
                        },
                        pattern: {
                            valType: "flaglist",
                            flags: [
                                "A",
                                "B",
                                "C",
                                "D",
                                "E"
                            ],
                            extras: [
                                "all",
                                "odd",
                                "even"
                            ],
                            dflt: "all"
                        }
                    },
                    spaceframe: {
                        show: {
                            valType: "boolean",
                            dflt: !1
                        },
                        fill: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: .15
                        }
                    },
                    slices: {
                        x: {
                            show: {
                                valType: "boolean",
                                dflt: !1
                            },
                            locations: {
                                valType: "data_array",
                                dflt: []
                            },
                            fill: {
                                valType: "number",
                                min: 0,
                                max: 1,
                                dflt: 1
                            }
                        },
                        y: {
                            show: {
                                valType: "boolean",
                                dflt: !1
                            },
                            locations: {
                                valType: "data_array",
                                dflt: []
                            },
                            fill: {
                                valType: "number",
                                min: 0,
                                max: 1,
                                dflt: 1
                            }
                        },
                        z: {
                            show: {
                                valType: "boolean",
                                dflt: !1
                            },
                            locations: {
                                valType: "data_array",
                                dflt: []
                            },
                            fill: {
                                valType: "number",
                                min: 0,
                                max: 1,
                                dflt: 1
                            }
                        }
                    },
                    caps: {
                        x: {
                            show: {
                                valType: "boolean",
                                dflt: !0
                            },
                            fill: {
                                valType: "number",
                                min: 0,
                                max: 1,
                                dflt: 1
                            }
                        },
                        y: {
                            show: {
                                valType: "boolean",
                                dflt: !0
                            },
                            fill: {
                                valType: "number",
                                min: 0,
                                max: 1,
                                dflt: 1
                            }
                        },
                        z: {
                            show: {
                                valType: "boolean",
                                dflt: !0
                            },
                            fill: {
                                valType: "number",
                                min: 0,
                                max: 1,
                                dflt: 1
                            }
                        }
                    },
                    text: {
                        valType: "string",
                        dflt: "",
                        arrayOk: !0
                    },
                    hovertext: {
                        valType: "string",
                        dflt: "",
                        arrayOk: !0
                    },
                    hovertemplate: a(),
                    xhoverformat: i("x"),
                    yhoverformat: i("y"),
                    zhoverformat: i("z"),
                    valuehoverformat: i("value", 1),
                    showlegend: l({}, s.showlegend, {
                        dflt: !1
                    })
                }, n("", {
                    colorAttr: "`value`",
                    showScaleDflt: !0,
                    editTypeOverride: "calc"
                }), {
                    opacity: o.opacity,
                    lightposition: o.lightposition,
                    lighting: o.lighting,
                    flatshading: o.flatshading,
                    contour: o.contour,
                    hoverinfo: l({}, s.hoverinfo)
                }), "calc", "nested");
                u.flatshading.dflt = !0, u.lighting.facenormalsepsilon.dflt = 0, u.x.editType = u.y.editType = u.z.editType = u.value.editType = "calc+clearAxisTypes", u.transforms = void 0;
            },
            58988: function(t1, e1, r) {
                "use strict";
                var n = r(28379), i = r(36402).processGrid, a = r(36402).filter;
                t1.exports = function(t1, e1) {
                    e1._len = Math.min(e1.x.length, e1.y.length, e1.z.length, e1.value.length), e1._x = a(e1.x, e1._len), e1._y = a(e1.y, e1._len), e1._z = a(e1.z, e1._len), e1._value = a(e1.value, e1._len);
                    var r = i(e1);
                    e1._gridFill = r.fill, e1._Xs = r.Xs, e1._Ys = r.Ys, e1._Zs = r.Zs, e1._len = r.len;
                    for(var o = 1 / 0, s = -1 / 0, l = 0; l < e1._len; l++){
                        var c = e1._value[l];
                        o = Math.min(o, c), s = Math.max(s, c);
                    }
                    e1._minValues = o, e1._maxValues = s, e1._vMin = void 0 === e1.isomin || null === e1.isomin ? o : e1.isomin, e1._vMax = void 0 === e1.isomax || null === e1.isomax ? s : e1.isomax, n(t1, e1, {
                        vals: [
                            e1._vMin,
                            e1._vMax
                        ],
                        containerStr: "",
                        cLetter: "c"
                    });
                };
            },
            91370: function(t1, e1, r) {
                "use strict";
                var n = r(99098).gl_mesh3d, i = r(46998).parseColorScale, a = r(34809).isArrayOrTypedArray, o = r(55010), s = r(88856).extractOpts, l = r(88239), c = function(t1, e1) {
                    for(var r = e1.length - 1; r > 0; r--){
                        var n = Math.min(e1[r], e1[r - 1]), i = Math.max(e1[r], e1[r - 1]);
                        if (i > n && n < t1 && t1 <= i) return {
                            id: r,
                            distRatio: (i - t1) / (i - n)
                        };
                    }
                    return {
                        id: 0,
                        distRatio: 0
                    };
                };
                function u(t1, e1, r) {
                    this.scene = t1, this.uid = r, this.mesh = e1, this.name = "", this.data = null, this.showContour = !1;
                }
                var h = u.prototype;
                h.handlePick = function(t1) {
                    if (t1.object === this.mesh) {
                        var e1 = t1.data.index, r = this.data._meshX[e1], n = this.data._meshY[e1], i = this.data._meshZ[e1], o = this.data._Ys.length, s = this.data._Zs.length, l = c(r, this.data._Xs).id, u = c(n, this.data._Ys).id, h = c(i, this.data._Zs).id, f = t1.index = h + s * u + s * o * l;
                        t1.traceCoordinate = [
                            this.data._meshX[f],
                            this.data._meshY[f],
                            this.data._meshZ[f],
                            this.data._value[f]
                        ];
                        var p = this.data.hovertext || this.data.text;
                        return a(p) && void 0 !== p[f] ? t1.textLabel = p[f] : p && (t1.textLabel = p), !0;
                    }
                }, h.update = function(t1) {
                    var e1 = this.scene, r = e1.fullSceneLayout;
                    function n(t1, e1, r, n) {
                        return e1.map(function(e1) {
                            return t1.d2l(e1, 0, n) * r;
                        });
                    }
                    this.data = p(t1);
                    var a = {
                        positions: l(n(r.xaxis, t1._meshX, e1.dataScale[0], t1.xcalendar), n(r.yaxis, t1._meshY, e1.dataScale[1], t1.ycalendar), n(r.zaxis, t1._meshZ, e1.dataScale[2], t1.zcalendar)),
                        cells: l(t1._meshI, t1._meshJ, t1._meshK),
                        lightPosition: [
                            t1.lightposition.x,
                            t1.lightposition.y,
                            t1.lightposition.z
                        ],
                        ambient: t1.lighting.ambient,
                        diffuse: t1.lighting.diffuse,
                        specular: t1.lighting.specular,
                        roughness: t1.lighting.roughness,
                        fresnel: t1.lighting.fresnel,
                        vertexNormalsEpsilon: t1.lighting.vertexnormalsepsilon,
                        faceNormalsEpsilon: t1.lighting.facenormalsepsilon,
                        opacity: t1.opacity,
                        contourEnable: t1.contour.show,
                        contourColor: o(t1.contour.color).slice(0, 3),
                        contourWidth: t1.contour.width,
                        useFacetNormals: t1.flatshading
                    }, c = s(t1);
                    a.vertexIntensity = t1._meshIntensity, a.vertexIntensityBounds = [
                        c.min,
                        c.max
                    ], a.colormap = i(t1), this.mesh.update(a);
                }, h.dispose = function() {
                    this.scene.glplot.remove(this.mesh), this.mesh.dispose();
                };
                var f = [
                    "xyz",
                    "xzy",
                    "yxz",
                    "yzx",
                    "zxy",
                    "zyx"
                ];
                function p(t1) {
                    t1._meshI = [], t1._meshJ = [], t1._meshK = [];
                    var e1, r, n, i, a, o, s, l = t1.surface.show, u = t1.spaceframe.show, h = t1.surface.fill, p = t1.spaceframe.fill, d = !1, m = !1, g = 0, y = t1._Xs, v = t1._Ys, x = t1._Zs, _ = y.length, b = v.length, w = x.length, T = f.indexOf(t1._gridFill.replace(/-/g, "").replace(/\+/g, "")), k = function(t1, e1, r) {
                        switch(T){
                            case 5:
                                return r + w * e1 + w * b * t1;
                            case 4:
                                return r + w * t1 + w * _ * e1;
                            case 3:
                                return e1 + b * r + b * w * t1;
                            case 2:
                                return e1 + b * t1 + b * _ * r;
                            case 1:
                                return t1 + _ * r + _ * w * e1;
                            default:
                                return t1 + _ * e1 + _ * b * r;
                        }
                    }, A = t1._minValues, M = t1._maxValues, S = t1._vMin, E = t1._vMax;
                    function C(t1, e1, s) {
                        for(var l = o.length, c = r; c < l; c++)if (t1 === n[c] && e1 === i[c] && s === a[c]) return c;
                        return -1;
                    }
                    function L() {
                        r = e1;
                    }
                    function I() {
                        n = [], i = [], a = [], o = [], e1 = 0, L();
                    }
                    function P(t1, r, s, l) {
                        return n.push(t1), i.push(r), a.push(s), o.push(l), ++e1 - 1;
                    }
                    function z(t1, e1, r) {
                        for(var n = [], i = 0; i < t1.length; i++)n[i] = t1[i] * (1 - r) + r * e1[i];
                        return n;
                    }
                    function O(t1) {
                        s = t1;
                    }
                    function D(t1, e1) {
                        return "all" === t1 || null === t1 || t1.indexOf(e1) > -1;
                    }
                    function R(t1, e1) {
                        return null === t1 ? e1 : t1;
                    }
                    function F(e1, r, n) {
                        L();
                        var i, a, o, l = [
                            r
                        ], c = [
                            n
                        ];
                        if (s >= 1) l = [
                            r
                        ], c = [
                            n
                        ];
                        else if (s > 0) {
                            var u = function(t1, e1) {
                                var r = t1[0], n = t1[1], i = t1[2], a = function(t1, e1, r) {
                                    for(var n = [], i = 0; i < t1.length; i++)n[i] = (t1[i] + e1[i] + r[i]) / 3;
                                    return n;
                                }(r, n, i), o = Math.sqrt(1 - s), l = z(a, r, o), c = z(a, n, o), u = z(a, i, o), h = e1[0], f = e1[1], p = e1[2];
                                return {
                                    xyzv: [
                                        [
                                            r,
                                            n,
                                            c
                                        ],
                                        [
                                            c,
                                            l,
                                            r
                                        ],
                                        [
                                            n,
                                            i,
                                            u
                                        ],
                                        [
                                            u,
                                            c,
                                            n
                                        ],
                                        [
                                            i,
                                            r,
                                            l
                                        ],
                                        [
                                            l,
                                            u,
                                            i
                                        ]
                                    ],
                                    abc: [
                                        [
                                            h,
                                            f,
                                            -1
                                        ],
                                        [
                                            -1,
                                            -1,
                                            h
                                        ],
                                        [
                                            f,
                                            p,
                                            -1
                                        ],
                                        [
                                            -1,
                                            -1,
                                            f
                                        ],
                                        [
                                            p,
                                            h,
                                            -1
                                        ],
                                        [
                                            -1,
                                            -1,
                                            p
                                        ]
                                    ]
                                };
                            }(r, n);
                            l = u.xyzv, c = u.abc;
                        }
                        for(var h = 0; h < l.length; h++){
                            r = l[h], n = c[h];
                            for(var f = [], p = 0; p < 3; p++){
                                var d = r[p][0], m = r[p][1], y = r[p][2], v = r[p][3], x = n[p] > -1 ? n[p] : C(d, m, y);
                                f[p] = x > -1 ? x : P(d, m, y, R(e1, v));
                            }
                            i = f[0], a = f[1], o = f[2], t1._meshI.push(i), t1._meshJ.push(a), t1._meshK.push(o), ++g;
                        }
                    }
                    function B(t1, e1, r, n) {
                        var i = t1[3];
                        i < r && (i = r), i > n && (i = n);
                        for(var a = (t1[3] - i) / (t1[3] - e1[3] + 1e-9), o = [], s = 0; s < 4; s++)o[s] = (1 - a) * t1[s] + a * e1[s];
                        return o;
                    }
                    function N(t1, e1, r) {
                        return t1 >= e1 && t1 <= r;
                    }
                    function j(t1) {
                        var e1 = .001 * (E - S);
                        return t1 >= S - e1 && t1 <= E + e1;
                    }
                    function U(e1) {
                        for(var r = [], n = 0; n < 4; n++){
                            var i = e1[n];
                            r.push([
                                t1._x[i],
                                t1._y[i],
                                t1._z[i],
                                t1._value[i]
                            ]);
                        }
                        return r;
                    }
                    var V = 3;
                    function q(t1, e1, r, n, i, a) {
                        a || (a = 1), r = [
                            -1,
                            -1,
                            -1
                        ];
                        var o = !1, s = [
                            N(e1[0][3], n, i),
                            N(e1[1][3], n, i),
                            N(e1[2][3], n, i)
                        ];
                        if (!s[0] && !s[1] && !s[2]) return !1;
                        var l = function(t1, e1, r) {
                            return j(e1[0][3]) && j(e1[1][3]) && j(e1[2][3]) ? (F(t1, e1, r), !0) : a < V && q(t1, e1, r, S, E, ++a);
                        };
                        if (s[0] && s[1] && s[2]) return l(t1, e1, r) || o;
                        var c = !1;
                        return [
                            [
                                0,
                                1,
                                2
                            ],
                            [
                                2,
                                0,
                                1
                            ],
                            [
                                1,
                                2,
                                0
                            ]
                        ].forEach(function(a) {
                            if (s[a[0]] && s[a[1]] && !s[a[2]]) {
                                var u = e1[a[0]], h = e1[a[1]], f = e1[a[2]], p = B(f, u, n, i), d = B(f, h, n, i);
                                o = l(t1, [
                                    d,
                                    p,
                                    u
                                ], [
                                    -1,
                                    -1,
                                    r[a[0]]
                                ]) || o, o = l(t1, [
                                    u,
                                    h,
                                    d
                                ], [
                                    r[a[0]],
                                    r[a[1]],
                                    -1
                                ]) || o, c = !0;
                            }
                        }), c || [
                            [
                                0,
                                1,
                                2
                            ],
                            [
                                1,
                                2,
                                0
                            ],
                            [
                                2,
                                0,
                                1
                            ]
                        ].forEach(function(a) {
                            if (s[a[0]] && !s[a[1]] && !s[a[2]]) {
                                var u = e1[a[0]], h = e1[a[1]], f = e1[a[2]], p = B(h, u, n, i), d = B(f, u, n, i);
                                o = l(t1, [
                                    d,
                                    p,
                                    u
                                ], [
                                    -1,
                                    -1,
                                    r[a[0]]
                                ]) || o, c = !0;
                            }
                        }), o;
                    }
                    function H(t1, e1, r, n) {
                        var i = !1, a = U(e1), o = [
                            N(a[0][3], r, n),
                            N(a[1][3], r, n),
                            N(a[2][3], r, n),
                            N(a[3][3], r, n)
                        ];
                        if (!(o[0] || o[1] || o[2] || o[3])) return i;
                        if (o[0] && o[1] && o[2] && o[3]) return m && (i = function(t1, e1, r) {
                            var n = function(n, i, a) {
                                F(t1, [
                                    e1[n],
                                    e1[i],
                                    e1[a]
                                ], [
                                    r[n],
                                    r[i],
                                    r[a]
                                ]);
                            };
                            n(0, 1, 2), n(3, 0, 1), n(2, 3, 0), n(1, 2, 3);
                        }(t1, a, e1) || i), i;
                        var s = !1;
                        return [
                            [
                                0,
                                1,
                                2,
                                3
                            ],
                            [
                                3,
                                0,
                                1,
                                2
                            ],
                            [
                                2,
                                3,
                                0,
                                1
                            ],
                            [
                                1,
                                2,
                                3,
                                0
                            ]
                        ].forEach(function(l) {
                            if (o[l[0]] && o[l[1]] && o[l[2]] && !o[l[3]]) {
                                var c = a[l[0]], u = a[l[1]], h = a[l[2]], f = a[l[3]];
                                if (m) i = F(t1, [
                                    c,
                                    u,
                                    h
                                ], [
                                    e1[l[0]],
                                    e1[l[1]],
                                    e1[l[2]]
                                ]) || i;
                                else {
                                    var p = B(f, c, r, n), d = B(f, u, r, n), g = B(f, h, r, n);
                                    i = F(null, [
                                        p,
                                        d,
                                        g
                                    ], [
                                        -1,
                                        -1,
                                        -1
                                    ]) || i;
                                }
                                s = !0;
                            }
                        }), s || ([
                            [
                                0,
                                1,
                                2,
                                3
                            ],
                            [
                                1,
                                2,
                                3,
                                0
                            ],
                            [
                                2,
                                3,
                                0,
                                1
                            ],
                            [
                                3,
                                0,
                                1,
                                2
                            ],
                            [
                                0,
                                2,
                                3,
                                1
                            ],
                            [
                                1,
                                3,
                                2,
                                0
                            ]
                        ].forEach(function(l) {
                            if (o[l[0]] && o[l[1]] && !o[l[2]] && !o[l[3]]) {
                                var c = a[l[0]], u = a[l[1]], h = a[l[2]], f = a[l[3]], p = B(h, c, r, n), d = B(h, u, r, n), g = B(f, u, r, n), y = B(f, c, r, n);
                                m ? (i = F(t1, [
                                    c,
                                    y,
                                    p
                                ], [
                                    e1[l[0]],
                                    -1,
                                    -1
                                ]) || i, i = F(t1, [
                                    u,
                                    d,
                                    g
                                ], [
                                    e1[l[1]],
                                    -1,
                                    -1
                                ]) || i) : i = function(t1, e1, r) {
                                    var n = function(t1, n, i) {
                                        F(null, [
                                            e1[t1],
                                            e1[n],
                                            e1[i]
                                        ], [
                                            r[t1],
                                            r[n],
                                            r[i]
                                        ]);
                                    };
                                    n(0, 1, 2), n(2, 3, 0);
                                }(0, [
                                    p,
                                    d,
                                    g,
                                    y
                                ], [
                                    -1,
                                    -1,
                                    -1,
                                    -1
                                ]) || i, s = !0;
                            }
                        }), s || [
                            [
                                0,
                                1,
                                2,
                                3
                            ],
                            [
                                1,
                                2,
                                3,
                                0
                            ],
                            [
                                2,
                                3,
                                0,
                                1
                            ],
                            [
                                3,
                                0,
                                1,
                                2
                            ]
                        ].forEach(function(l) {
                            if (o[l[0]] && !o[l[1]] && !o[l[2]] && !o[l[3]]) {
                                var c = a[l[0]], u = a[l[1]], h = a[l[2]], f = a[l[3]], p = B(u, c, r, n), d = B(h, c, r, n), g = B(f, c, r, n);
                                m ? (i = F(t1, [
                                    c,
                                    p,
                                    d
                                ], [
                                    e1[l[0]],
                                    -1,
                                    -1
                                ]) || i, i = F(t1, [
                                    c,
                                    d,
                                    g
                                ], [
                                    e1[l[0]],
                                    -1,
                                    -1
                                ]) || i, i = F(t1, [
                                    c,
                                    g,
                                    p
                                ], [
                                    e1[l[0]],
                                    -1,
                                    -1
                                ]) || i) : i = F(null, [
                                    p,
                                    d,
                                    g
                                ], [
                                    -1,
                                    -1,
                                    -1
                                ]) || i, s = !0;
                            }
                        })), i;
                    }
                    function G(t1, e1, r, n, i, a, o, s, l, c, u) {
                        var h = !1;
                        return d && (D(t1, "A") && (h = H(null, [
                            e1,
                            r,
                            n,
                            a
                        ], c, u) || h), D(t1, "B") && (h = H(null, [
                            r,
                            n,
                            i,
                            l
                        ], c, u) || h), D(t1, "C") && (h = H(null, [
                            r,
                            a,
                            o,
                            l
                        ], c, u) || h), D(t1, "D") && (h = H(null, [
                            n,
                            a,
                            s,
                            l
                        ], c, u) || h), D(t1, "E") && (h = H(null, [
                            r,
                            n,
                            a,
                            l
                        ], c, u) || h)), m && (h = H(t1, [
                            r,
                            n,
                            a,
                            l
                        ], c, u) || h), h;
                    }
                    function Z(t1, e1, r, n, i, a, o, s) {
                        return [
                            !0 === s[0] || q(t1, U([
                                e1,
                                r,
                                n
                            ]), [
                                e1,
                                r,
                                n
                            ], a, o),
                            !0 === s[1] || q(t1, U([
                                n,
                                i,
                                e1
                            ]), [
                                n,
                                i,
                                e1
                            ], a, o)
                        ];
                    }
                    function W(t1, e1, r, n, i, a, o, s, l) {
                        return s ? Z(t1, e1, r, i, n, a, o, l) : Z(t1, r, i, n, e1, a, o, l);
                    }
                    function Y(t1, e1, r, n, i, a, o) {
                        var s, l, c, u, h = !1, f = function() {
                            h = q(t1, [
                                s,
                                l,
                                c
                            ], [
                                -1,
                                -1,
                                -1
                            ], i, a) || h, h = q(t1, [
                                c,
                                u,
                                s
                            ], [
                                -1,
                                -1,
                                -1
                            ], i, a) || h;
                        }, p = o[0], d = o[1], m = o[2];
                        return p && (s = z(U([
                            k(e1, r - 0, n - 0)
                        ])[0], U([
                            k(e1 - 1, r - 0, n - 0)
                        ])[0], p), l = z(U([
                            k(e1, r - 0, n - 1)
                        ])[0], U([
                            k(e1 - 1, r - 0, n - 1)
                        ])[0], p), c = z(U([
                            k(e1, r - 1, n - 1)
                        ])[0], U([
                            k(e1 - 1, r - 1, n - 1)
                        ])[0], p), u = z(U([
                            k(e1, r - 1, n - 0)
                        ])[0], U([
                            k(e1 - 1, r - 1, n - 0)
                        ])[0], p), f()), d && (s = z(U([
                            k(e1 - 0, r, n - 0)
                        ])[0], U([
                            k(e1 - 0, r - 1, n - 0)
                        ])[0], d), l = z(U([
                            k(e1 - 0, r, n - 1)
                        ])[0], U([
                            k(e1 - 0, r - 1, n - 1)
                        ])[0], d), c = z(U([
                            k(e1 - 1, r, n - 1)
                        ])[0], U([
                            k(e1 - 1, r - 1, n - 1)
                        ])[0], d), u = z(U([
                            k(e1 - 1, r, n - 0)
                        ])[0], U([
                            k(e1 - 1, r - 1, n - 0)
                        ])[0], d), f()), m && (s = z(U([
                            k(e1 - 0, r - 0, n)
                        ])[0], U([
                            k(e1 - 0, r - 0, n - 1)
                        ])[0], m), l = z(U([
                            k(e1 - 0, r - 1, n)
                        ])[0], U([
                            k(e1 - 0, r - 1, n - 1)
                        ])[0], m), c = z(U([
                            k(e1 - 1, r - 1, n)
                        ])[0], U([
                            k(e1 - 1, r - 1, n - 1)
                        ])[0], m), u = z(U([
                            k(e1 - 1, r - 0, n)
                        ])[0], U([
                            k(e1 - 1, r - 0, n - 1)
                        ])[0], m), f()), h;
                    }
                    function X(t1, e1, r, n, i, a, o, s, l, c, u, h) {
                        var f = t1;
                        return h ? (d && "even" === t1 && (f = null), G(f, e1, r, n, i, a, o, s, l, c, u)) : (d && "odd" === t1 && (f = null), G(f, l, s, o, a, i, n, r, e1, c, u));
                    }
                    function $(t1, e1, r, n, i) {
                        for(var a = [], o = 0, s = 0; s < e1.length; s++)for(var l = e1[s], c = 1; c < w; c++)for(var u = 1; u < b; u++)a.push(W(t1, k(l, u - 1, c - 1), k(l, u - 1, c), k(l, u, c - 1), k(l, u, c), r, n, (l + u + c) % 2, i && i[o] ? i[o] : [])), o++;
                        return a;
                    }
                    function J(t1, e1, r, n, i) {
                        for(var a = [], o = 0, s = 0; s < e1.length; s++)for(var l = e1[s], c = 1; c < _; c++)for(var u = 1; u < w; u++)a.push(W(t1, k(c - 1, l, u - 1), k(c, l, u - 1), k(c - 1, l, u), k(c, l, u), r, n, (c + l + u) % 2, i && i[o] ? i[o] : [])), o++;
                        return a;
                    }
                    function K(t1, e1, r, n, i) {
                        for(var a = [], o = 0, s = 0; s < e1.length; s++)for(var l = e1[s], c = 1; c < b; c++)for(var u = 1; u < _; u++)a.push(W(t1, k(u - 1, c - 1, l), k(u - 1, c, l), k(u, c - 1, l), k(u, c, l), r, n, (u + c + l) % 2, i && i[o] ? i[o] : [])), o++;
                        return a;
                    }
                    function Q(t1, e1, r) {
                        for(var n = 1; n < w; n++)for(var i = 1; i < b; i++)for(var a = 1; a < _; a++)X(t1, k(a - 1, i - 1, n - 1), k(a - 1, i - 1, n), k(a - 1, i, n - 1), k(a - 1, i, n), k(a, i - 1, n - 1), k(a, i - 1, n), k(a, i, n - 1), k(a, i, n), e1, r, (a + i + n) % 2);
                    }
                    function tt(t1, e1, r, n, i, a) {
                        for(var o = [], s = 0, l = 0; l < e1.length; l++)for(var c = e1[l], u = 1; u < w; u++)for(var h = 1; h < b; h++)o.push(Y(t1, c, h, u, r, n, i[l], a && a[s] && a[s])), s++;
                        return o;
                    }
                    function et(t1, e1, r, n, i, a) {
                        for(var o = [], s = 0, l = 0; l < e1.length; l++)for(var c = e1[l], u = 1; u < _; u++)for(var h = 1; h < w; h++)o.push(Y(t1, u, c, h, r, n, i[l], a && a[s] && a[s])), s++;
                        return o;
                    }
                    function rt(t1, e1, r, n, i, a) {
                        for(var o = [], s = 0, l = 0; l < e1.length; l++)for(var c = e1[l], u = 1; u < b; u++)for(var h = 1; h < _; h++)o.push(Y(t1, h, u, c, r, n, i[l], a && a[s] && a[s])), s++;
                        return o;
                    }
                    function nt(t1, e1) {
                        for(var r = [], n = t1; n < e1; n++)r.push(n);
                        return r;
                    }
                    return function() {
                        I(), function() {
                            for(var e1 = 0; e1 < _; e1++)for(var r = 0; r < b; r++)for(var n = 0; n < w; n++){
                                var i = k(e1, r, n);
                                P(t1._x[i], t1._y[i], t1._z[i], t1._value[i]);
                            }
                        }();
                        var e1 = null;
                        if (u && p && (O(p), m = !0, Q(e1, S, E), m = !1), l && h) {
                            O(h);
                            for(var r = t1.surface.pattern, s = t1.surface.count, f = 0; f < s; f++){
                                var T = 1 === s ? .5 : f / (s - 1), C = (1 - T) * S + T * E, L = Math.abs(C - A) > Math.abs(C - M) ? [
                                    A,
                                    C
                                ] : [
                                    C,
                                    M
                                ];
                                d = !0, Q(r, L[0], L[1]), d = !1;
                            }
                        }
                        var z = [
                            [
                                Math.min(S, M),
                                Math.max(S, M)
                            ],
                            [
                                Math.min(A, E),
                                Math.max(A, E)
                            ]
                        ];
                        [
                            "x",
                            "y",
                            "z"
                        ].forEach(function(r) {
                            for(var n = [], i = 0; i < z.length; i++){
                                var a = 0, o = z[i][0], s = z[i][1], l = t1.slices[r];
                                if (l.show && l.fill) {
                                    O(l.fill);
                                    var u = [], h = [], f = [];
                                    if (l.locations.length) for(var p = 0; p < l.locations.length; p++){
                                        var d = c(l.locations[p], "x" === r ? y : "y" === r ? v : x);
                                        0 === d.distRatio ? u.push(d.id) : d.id > 0 && (h.push(d.id), "x" === r ? f.push([
                                            d.distRatio,
                                            0,
                                            0
                                        ]) : "y" === r ? f.push([
                                            0,
                                            d.distRatio,
                                            0
                                        ]) : f.push([
                                            0,
                                            0,
                                            d.distRatio
                                        ]));
                                    }
                                    else u = nt(1, "x" === r ? _ - 1 : "y" === r ? b - 1 : w - 1);
                                    h.length > 0 && (n[a] = "x" === r ? tt(e1, h, o, s, f, n[a]) : "y" === r ? et(e1, h, o, s, f, n[a]) : rt(e1, h, o, s, f, n[a]), a++), u.length > 0 && (n[a] = "x" === r ? $(e1, u, o, s, n[a]) : "y" === r ? J(e1, u, o, s, n[a]) : K(e1, u, o, s, n[a]), a++);
                                }
                                var m = t1.caps[r];
                                m.show && m.fill && (O(m.fill), n[a] = "x" === r ? $(e1, [
                                    0,
                                    _ - 1
                                ], o, s, n[a]) : "y" === r ? J(e1, [
                                    0,
                                    b - 1
                                ], o, s, n[a]) : K(e1, [
                                    0,
                                    w - 1
                                ], o, s, n[a]), a++);
                            }
                        }), 0 === g && I(), t1._meshX = n, t1._meshY = i, t1._meshZ = a, t1._meshIntensity = o, t1._Xs = y, t1._Ys = v, t1._Zs = x;
                    }(), t1;
                }
                t1.exports = {
                    findNearestOnAxis: c,
                    generateIsoMeshes: p,
                    createIsosurfaceTrace: function(t1, e1) {
                        var r = t1.glplot.gl, i = n({
                            gl: r
                        }), a = new u(t1, i, e1.uid);
                        return i._trace = a, a.update(e1), t1.glplot.add(i), a;
                    }
                };
            },
            44731: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(33626), a = r(70252), o = r(39356);
                function s(t1, e1, r, n, a) {
                    var s = a("isomin"), l = a("isomax");
                    null != l && null != s && s > l && (e1.isomin = null, e1.isomax = null);
                    var c = a("x"), u = a("y"), h = a("z"), f = a("value");
                    c && c.length && u && u.length && h && h.length && f && f.length ? (i.getComponentMethod("calendars", "handleTraceDefaults")(t1, e1, [
                        "x",
                        "y",
                        "z"
                    ], n), a("valuehoverformat"), [
                        "x",
                        "y",
                        "z"
                    ].forEach(function(t1) {
                        a(t1 + "hoverformat");
                        var e1 = "caps." + t1;
                        a(e1 + ".show") && a(e1 + ".fill");
                        var r = "slices." + t1;
                        a(r + ".show") && (a(r + ".fill"), a(r + ".locations"));
                    }), a("spaceframe.show") && a("spaceframe.fill"), a("surface.show") && (a("surface.count"), a("surface.fill"), a("surface.pattern")), a("contour.show") && (a("contour.color"), a("contour.width")), [
                        "text",
                        "hovertext",
                        "hovertemplate",
                        "lighting.ambient",
                        "lighting.diffuse",
                        "lighting.specular",
                        "lighting.roughness",
                        "lighting.fresnel",
                        "lighting.vertexnormalsepsilon",
                        "lighting.facenormalsepsilon",
                        "lightposition.x",
                        "lightposition.y",
                        "lightposition.z",
                        "flatshading",
                        "opacity"
                    ].forEach(function(t1) {
                        a(t1);
                    }), o(t1, e1, n, a, {
                        prefix: "",
                        cLetter: "c"
                    }), e1._length = null) : e1.visible = !1;
                }
                t1.exports = {
                    supplyDefaults: function(t1, e1, r, i) {
                        s(t1, e1, 0, i, function(r, i) {
                            return n.coerce(t1, e1, a, r, i);
                        });
                    },
                    supplyIsoDefaults: s
                };
            },
            75297: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    attributes: r(70252),
                    supplyDefaults: r(44731).supplyDefaults,
                    calc: r(58988),
                    colorbar: {
                        min: "cmin",
                        max: "cmax"
                    },
                    plot: r(91370).createIsosurfaceTrace,
                    moduleType: "trace",
                    name: "isosurface",
                    basePlotModule: r(2487),
                    categories: [
                        "gl3d",
                        "showLegend"
                    ],
                    meta: {}
                };
            },
            42450: function(t1, e1, r) {
                "use strict";
                var n = r(87163), i = r(80712).axisHoverFormat, a = r(3208).rb, o = r(16131), s = r(9829), l = r(93049).extendFlat;
                t1.exports = l({
                    x: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    y: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    z: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    i: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    j: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    k: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    text: {
                        valType: "string",
                        dflt: "",
                        arrayOk: !0,
                        editType: "calc"
                    },
                    hovertext: {
                        valType: "string",
                        dflt: "",
                        arrayOk: !0,
                        editType: "calc"
                    },
                    hovertemplate: a({
                        editType: "calc"
                    }),
                    xhoverformat: i("x"),
                    yhoverformat: i("y"),
                    zhoverformat: i("z"),
                    delaunayaxis: {
                        valType: "enumerated",
                        values: [
                            "x",
                            "y",
                            "z"
                        ],
                        dflt: "z",
                        editType: "calc"
                    },
                    alphahull: {
                        valType: "number",
                        dflt: -1,
                        editType: "calc"
                    },
                    intensity: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    intensitymode: {
                        valType: "enumerated",
                        values: [
                            "vertex",
                            "cell"
                        ],
                        dflt: "vertex",
                        editType: "calc"
                    },
                    color: {
                        valType: "color",
                        editType: "calc"
                    },
                    vertexcolor: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    facecolor: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    transforms: void 0
                }, n("", {
                    colorAttr: "`intensity`",
                    showScaleDflt: !0,
                    editTypeOverride: "calc"
                }), {
                    opacity: o.opacity,
                    flatshading: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "calc"
                    },
                    contour: {
                        show: l({}, o.contours.x.show, {}),
                        color: o.contours.x.color,
                        width: o.contours.x.width,
                        editType: "calc"
                    },
                    lightposition: {
                        x: l({}, o.lightposition.x, {
                            dflt: 1e5
                        }),
                        y: l({}, o.lightposition.y, {
                            dflt: 1e5
                        }),
                        z: l({}, o.lightposition.z, {
                            dflt: 0
                        }),
                        editType: "calc"
                    },
                    lighting: l({
                        vertexnormalsepsilon: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: 1e-12,
                            editType: "calc"
                        },
                        facenormalsepsilon: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: 1e-6,
                            editType: "calc"
                        },
                        editType: "calc"
                    }, o.lighting),
                    hoverinfo: l({}, s.hoverinfo, {
                        editType: "calc"
                    }),
                    showlegend: l({}, s.showlegend, {
                        dflt: !1
                    })
                });
            },
            44878: function(t1, e1, r) {
                "use strict";
                var n = r(28379);
                t1.exports = function(t1, e1) {
                    e1.intensity && n(t1, e1, {
                        vals: e1.intensity,
                        containerStr: "",
                        cLetter: "c"
                    });
                };
            },
            82836: function(t1, e1, r) {
                "use strict";
                var n = r(99098).gl_mesh3d, i = r(99098).delaunay_triangulate, a = r(99098).alpha_shape, o = r(99098).convex_hull, s = r(46998).parseColorScale, l = r(34809).isArrayOrTypedArray, c = r(55010), u = r(88856).extractOpts, h = r(88239);
                function f(t1, e1, r) {
                    this.scene = t1, this.uid = r, this.mesh = e1, this.name = "", this.color = "#fff", this.data = null, this.showContour = !1;
                }
                var p = f.prototype;
                function d(t1) {
                    for(var e1 = [], r = t1.length, n = 0; n < r; n++)e1[n] = c(t1[n]);
                    return e1;
                }
                function m(t1, e1, r, n) {
                    for(var i = [], a = e1.length, o = 0; o < a; o++)i[o] = t1.d2l(e1[o], 0, n) * r;
                    return i;
                }
                function g(t1) {
                    for(var e1 = [], r = t1.length, n = 0; n < r; n++)e1[n] = Math.round(t1[n]);
                    return e1;
                }
                function y(t1, e1) {
                    for(var r = t1.length, n = 0; n < r; n++)if (t1[n] <= -0.5 || t1[n] >= e1 - .5) return !1;
                    return !0;
                }
                p.handlePick = function(t1) {
                    if (t1.object === this.mesh) {
                        var e1 = t1.index = t1.data.index;
                        t1.data._cellCenter ? t1.traceCoordinate = t1.data.dataCoordinate : t1.traceCoordinate = [
                            this.data.x[e1],
                            this.data.y[e1],
                            this.data.z[e1]
                        ];
                        var r = this.data.hovertext || this.data.text;
                        return l(r) && void 0 !== r[e1] ? t1.textLabel = r[e1] : r && (t1.textLabel = r), !0;
                    }
                }, p.update = function(t1) {
                    var e1 = this.scene, r = e1.fullSceneLayout;
                    this.data = t1;
                    var n, l = t1.x.length, f = h(m(r.xaxis, t1.x, e1.dataScale[0], t1.xcalendar), m(r.yaxis, t1.y, e1.dataScale[1], t1.ycalendar), m(r.zaxis, t1.z, e1.dataScale[2], t1.zcalendar));
                    if (t1.i && t1.j && t1.k) {
                        if (t1.i.length !== t1.j.length || t1.j.length !== t1.k.length || !y(t1.i, l) || !y(t1.j, l) || !y(t1.k, l)) return;
                        n = h(g(t1.i), g(t1.j), g(t1.k));
                    } else n = 0 === t1.alphahull ? o(f) : t1.alphahull > 0 ? a(t1.alphahull, f) : function(t1, e1) {
                        for(var r = [
                            "x",
                            "y",
                            "z"
                        ].indexOf(t1), n = [], a = e1.length, o = 0; o < a; o++)n[o] = [
                            e1[o][(r + 1) % 3],
                            e1[o][(r + 2) % 3]
                        ];
                        return i(n);
                    }(t1.delaunayaxis, f);
                    var p = {
                        positions: f,
                        cells: n,
                        lightPosition: [
                            t1.lightposition.x,
                            t1.lightposition.y,
                            t1.lightposition.z
                        ],
                        ambient: t1.lighting.ambient,
                        diffuse: t1.lighting.diffuse,
                        specular: t1.lighting.specular,
                        roughness: t1.lighting.roughness,
                        fresnel: t1.lighting.fresnel,
                        vertexNormalsEpsilon: t1.lighting.vertexnormalsepsilon,
                        faceNormalsEpsilon: t1.lighting.facenormalsepsilon,
                        opacity: t1.opacity,
                        contourEnable: t1.contour.show,
                        contourColor: c(t1.contour.color).slice(0, 3),
                        contourWidth: t1.contour.width,
                        useFacetNormals: t1.flatshading
                    };
                    if (t1.intensity) {
                        var v = u(t1);
                        this.color = "#fff";
                        var x = t1.intensitymode;
                        p[x + "Intensity"] = t1.intensity, p[x + "IntensityBounds"] = [
                            v.min,
                            v.max
                        ], p.colormap = s(t1);
                    } else t1.vertexcolor ? (this.color = t1.vertexcolor[0], p.vertexColors = d(t1.vertexcolor)) : t1.facecolor ? (this.color = t1.facecolor[0], p.cellColors = d(t1.facecolor)) : (this.color = t1.color, p.meshColor = c(t1.color));
                    this.mesh.update(p);
                }, p.dispose = function() {
                    this.scene.glplot.remove(this.mesh), this.mesh.dispose();
                }, t1.exports = function(t1, e1) {
                    var r = t1.glplot.gl, i = n({
                        gl: r
                    }), a = new f(t1, i, e1.uid);
                    return i._trace = a, a.update(e1), t1.glplot.add(i), a;
                };
            },
            13573: function(t1, e1, r) {
                "use strict";
                var n = r(33626), i = r(34809), a = r(39356), o = r(42450);
                t1.exports = function(t1, e1, r, s) {
                    function l(r, n) {
                        return i.coerce(t1, e1, o, r, n);
                    }
                    function c(t1) {
                        var e1 = t1.map(function(t1) {
                            var e1 = l(t1);
                            return e1 && i.isArrayOrTypedArray(e1) ? e1 : null;
                        });
                        return e1.every(function(t1) {
                            return t1 && t1.length === e1[0].length;
                        }) && e1;
                    }
                    c([
                        "x",
                        "y",
                        "z"
                    ]) ? (c([
                        "i",
                        "j",
                        "k"
                    ]), (!e1.i || e1.j && e1.k) && (!e1.j || e1.k && e1.i) && (!e1.k || e1.i && e1.j) ? (n.getComponentMethod("calendars", "handleTraceDefaults")(t1, e1, [
                        "x",
                        "y",
                        "z"
                    ], s), [
                        "lighting.ambient",
                        "lighting.diffuse",
                        "lighting.specular",
                        "lighting.roughness",
                        "lighting.fresnel",
                        "lighting.vertexnormalsepsilon",
                        "lighting.facenormalsepsilon",
                        "lightposition.x",
                        "lightposition.y",
                        "lightposition.z",
                        "flatshading",
                        "alphahull",
                        "delaunayaxis",
                        "opacity"
                    ].forEach(function(t1) {
                        l(t1);
                    }), l("contour.show") && (l("contour.color"), l("contour.width")), "intensity" in t1 ? (l("intensity"), l("intensitymode"), a(t1, e1, s, l, {
                        prefix: "",
                        cLetter: "c"
                    })) : (e1.showscale = !1, "facecolor" in t1 ? l("facecolor") : "vertexcolor" in t1 ? l("vertexcolor") : l("color", r)), l("text"), l("hovertext"), l("hovertemplate"), l("xhoverformat"), l("yhoverformat"), l("zhoverformat"), e1._length = null) : e1.visible = !1) : e1.visible = !1;
                };
            },
            58859: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    attributes: r(42450),
                    supplyDefaults: r(13573),
                    calc: r(44878),
                    colorbar: {
                        min: "cmin",
                        max: "cmax"
                    },
                    plot: r(82836),
                    moduleType: "trace",
                    name: "mesh3d",
                    basePlotModule: r(2487),
                    categories: [
                        "gl3d",
                        "showLegend"
                    ],
                    meta: {}
                };
            },
            86706: function(t1, e1, r) {
                "use strict";
                var n = r(34809).extendFlat, i = r(36640), a = r(80712).axisHoverFormat, o = r(94850).T, s = r(70192), l = r(20909), c = l.INCREASING.COLOR, u = l.DECREASING.COLOR, h = i.line;
                function f(t1) {
                    return {
                        line: {
                            color: n({}, h.color, {
                                dflt: t1
                            }),
                            width: h.width,
                            dash: o,
                            editType: "style"
                        },
                        editType: "style"
                    };
                }
                t1.exports = {
                    xperiod: i.xperiod,
                    xperiod0: i.xperiod0,
                    xperiodalignment: i.xperiodalignment,
                    xhoverformat: a("x"),
                    yhoverformat: a("y"),
                    x: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    open: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    high: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    low: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    close: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    line: {
                        width: n({}, h.width, {}),
                        dash: n({}, o, {}),
                        editType: "style"
                    },
                    increasing: f(c),
                    decreasing: f(u),
                    text: {
                        valType: "string",
                        dflt: "",
                        arrayOk: !0,
                        editType: "calc"
                    },
                    hovertext: {
                        valType: "string",
                        dflt: "",
                        arrayOk: !0,
                        editType: "calc"
                    },
                    tickwidth: {
                        valType: "number",
                        min: 0,
                        max: .5,
                        dflt: .3,
                        editType: "calc"
                    },
                    hoverlabel: n({}, s.hoverlabel, {
                        split: {
                            valType: "boolean",
                            dflt: !1,
                            editType: "style"
                        }
                    }),
                    zorder: i.zorder
                };
            },
            95694: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = n._, a = r(29714), o = r(40528), s = r(63821).BADNUM;
                function l(t1, e1, r, n) {
                    return {
                        o: t1,
                        h: e1,
                        l: r,
                        c: n
                    };
                }
                function c(t1, e1, r, o, l, c) {
                    for(var u = l.makeCalcdata(e1, "open"), h = l.makeCalcdata(e1, "high"), f = l.makeCalcdata(e1, "low"), p = l.makeCalcdata(e1, "close"), d = n.isArrayOrTypedArray(e1.text), m = n.isArrayOrTypedArray(e1.hovertext), g = !0, y = null, v = !!e1.xperiodalignment, x = [], _ = 0; _ < o.length; _++){
                        var b = o[_], w = u[_], T = h[_], k = f[_], A = p[_];
                        if (b !== s && w !== s && T !== s && k !== s && A !== s) {
                            A === w ? null !== y && A !== y && (g = A > y) : g = A > w, y = A;
                            var M = c(w, T, k, A);
                            M.pos = b, M.yc = (w + A) / 2, M.i = _, M.dir = g ? "increasing" : "decreasing", M.x = M.pos, M.y = [
                                k,
                                T
                            ], v && (M.orig_p = r[_]), d && (M.tx = e1.text[_]), m && (M.htx = e1.hovertext[_]), x.push(M);
                        } else x.push({
                            pos: b,
                            empty: !0
                        });
                    }
                    return e1._extremes[l._id] = a.findExtremes(l, n.concat(f, h), {
                        padded: !0
                    }), x.length && (x[0].t = {
                        labels: {
                            open: i(t1, "open:") + " ",
                            high: i(t1, "high:") + " ",
                            low: i(t1, "low:") + " ",
                            close: i(t1, "close:") + " "
                        }
                    }), x;
                }
                t1.exports = {
                    calc: function(t1, e1) {
                        var r = a.getFromId(t1, e1.xaxis), i = a.getFromId(t1, e1.yaxis), s = function(t1, e1, r) {
                            var i = r._minDiff;
                            if (!i) {
                                var a, s = t1._fullData, l = [];
                                for(i = 1 / 0, a = 0; a < s.length; a++){
                                    var c = s[a];
                                    if ("ohlc" === c.type && !0 === c.visible && c.xaxis === e1._id) {
                                        l.push(c);
                                        var u = e1.makeCalcdata(c, "x");
                                        c._origX = u;
                                        var h = o(r, e1, "x", u).vals;
                                        c._xcalc = h;
                                        var f = n.distinctVals(h).minDiff;
                                        f && isFinite(f) && (i = Math.min(i, f));
                                    }
                                }
                                for(i === 1 / 0 && (i = 1), a = 0; a < l.length; a++)l[a]._minDiff = i;
                            }
                            return i * r.tickwidth;
                        }(t1, r, e1), u = e1._minDiff;
                        e1._minDiff = null;
                        var h = e1._origX;
                        e1._origX = null;
                        var f = e1._xcalc;
                        e1._xcalc = null;
                        var p = c(t1, e1, h, f, i, l);
                        return e1._extremes[r._id] = a.findExtremes(r, f, {
                            vpad: u / 2
                        }), p.length ? (n.extendFlat(p[0].t, {
                            wHover: u / 2,
                            tickLen: s
                        }), p) : [
                            {
                                t: {
                                    empty: !0
                                }
                            }
                        ];
                    },
                    calcCommon: c
                };
            },
            22629: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(28270), a = r(99669), o = r(86706);
                function s(t1, e1, r, n) {
                    r(n + ".line.color"), r(n + ".line.width", e1.line.width), r(n + ".line.dash", e1.line.dash);
                }
                t1.exports = function(t1, e1, r, l) {
                    function c(r, i) {
                        return n.coerce(t1, e1, o, r, i);
                    }
                    i(t1, e1, c, l) ? (a(t1, e1, l, c, {
                        x: !0
                    }), c("xhoverformat"), c("yhoverformat"), c("line.width"), c("line.dash"), s(0, e1, c, "increasing"), s(0, e1, c, "decreasing"), c("text"), c("hovertext"), c("tickwidth"), l._requestRangeslider[e1.xaxis] = !0, c("zorder")) : e1.visible = !1;
                };
            },
            93245: function(t1, e1, r) {
                "use strict";
                var n = r(29714), i = r(34809), a = r(32141), o = r(78766), s = r(34809).fillText, l = r(20909), c = {
                    increasing: l.INCREASING.SYMBOL,
                    decreasing: l.DECREASING.SYMBOL
                };
                function u(t1, e1, r, n) {
                    var i, s, l = t1.cd, c = t1.xa, u = l[0].trace, h = l[0].t, f = u.type, p = "ohlc" === f ? "l" : "min", d = "ohlc" === f ? "h" : "max", m = h.bPos || 0, g = function(t1) {
                        return t1.pos + m - e1;
                    }, y = h.bdPos || h.tickLen, v = h.wHover, x = Math.min(1, y / Math.abs(c.r2c(c.range[1]) - c.r2c(c.range[0])));
                    function _(t1) {
                        var e1 = g(t1);
                        return a.inbox(e1 - v, e1 + v, i);
                    }
                    function b(t1) {
                        var e1 = t1[p], n = t1[d];
                        return e1 === n || a.inbox(e1 - r, n - r, i);
                    }
                    function w(t1) {
                        return (_(t1) + b(t1)) / 2;
                    }
                    i = t1.maxHoverDistance - x, s = t1.maxSpikeDistance - x;
                    var T = a.getDistanceFunction(n, _, b, w);
                    if (a.getClosest(l, T, t1), !1 === t1.index) return null;
                    var k = l[t1.index];
                    if (k.empty) return null;
                    var A = u[k.dir], M = A.line.color;
                    return o.opacity(M) && A.line.width ? t1.color = M : t1.color = A.fillcolor, t1.x0 = c.c2p(k.pos + m - y, !0), t1.x1 = c.c2p(k.pos + m + y, !0), t1.xLabelVal = void 0 !== k.orig_p ? k.orig_p : k.pos, t1.spikeDistance = w(k) * s / i, t1.xSpike = c.c2p(k.pos, !0), t1;
                }
                function h(t1, e1, r, a) {
                    var o = t1.cd, s = t1.ya, l = o[0].trace, c = o[0].t, h = [], f = u(t1, e1, r, a);
                    if (!f) return [];
                    var p = o[f.index].hi || l.hoverinfo, d = p.split("+");
                    if ("all" !== p && -1 === d.indexOf("y")) return [];
                    for(var m = [
                        "high",
                        "open",
                        "close",
                        "low"
                    ], g = {}, y = 0; y < m.length; y++){
                        var v, x = m[y], _ = l[x][f.index], b = s.c2p(_, !0);
                        _ in g ? (v = g[_]).yLabel += "<br>" + c.labels[x] + n.hoverLabelText(s, _, l.yhoverformat) : ((v = i.extendFlat({}, f)).y0 = v.y1 = b, v.yLabelVal = _, v.yLabel = c.labels[x] + n.hoverLabelText(s, _, l.yhoverformat), v.name = "", h.push(v), g[_] = v);
                    }
                    return h;
                }
                function f(t1, e1, r, i) {
                    var a = t1.cd, o = t1.ya, l = a[0].trace, h = a[0].t, f = u(t1, e1, r, i);
                    if (!f) return [];
                    var p = a[f.index], d = f.index = p.i, m = p.dir;
                    function g(t1) {
                        return h.labels[t1] + n.hoverLabelText(o, l[t1][d], l.yhoverformat);
                    }
                    var y = p.hi || l.hoverinfo, v = y.split("+"), x = "all" === y, _ = x || -1 !== v.indexOf("y"), b = x || -1 !== v.indexOf("text"), w = _ ? [
                        g("open"),
                        g("high"),
                        g("low"),
                        g("close") + "  " + c[m]
                    ] : [];
                    return b && s(p, l, w), f.extraText = w.join("<br>"), f.y0 = f.y1 = o.c2p(p.yc, !0), [
                        f
                    ];
                }
                t1.exports = {
                    hoverPoints: function(t1, e1, r, n) {
                        return t1.cd[0].trace.hoverlabel.split ? h(t1, e1, r, n) : f(t1, e1, r, n);
                    },
                    hoverSplit: h,
                    hoverOnPoints: f
                };
            },
            12683: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    moduleType: "trace",
                    name: "ohlc",
                    basePlotModule: r(37703),
                    categories: [
                        "cartesian",
                        "svg",
                        "showLegend"
                    ],
                    meta: {},
                    attributes: r(86706),
                    supplyDefaults: r(22629),
                    calc: r(95694).calc,
                    plot: r(38956),
                    style: r(57406),
                    hoverPoints: r(93245).hoverPoints,
                    selectPoints: r(49343)
                };
            },
            28270: function(t1, e1, r) {
                "use strict";
                var n = r(33626), i = r(34809);
                t1.exports = function(t1, e1, r, a) {
                    var o = r("x"), s = r("open"), l = r("high"), c = r("low"), u = r("close");
                    if (r("hoverlabel.split"), n.getComponentMethod("calendars", "handleTraceDefaults")(t1, e1, [
                        "x"
                    ], a), s && l && c && u) {
                        var h = Math.min(s.length, l.length, c.length, u.length);
                        return o && (h = Math.min(h, i.minRowLength(o))), e1._length = h, h;
                    }
                };
            },
            38956: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(34809);
                t1.exports = function(t1, e1, r, a) {
                    var o = e1.yaxis, s = e1.xaxis, l = !!s.rangebreaks;
                    i.makeTraceGroups(a, r, "trace ohlc").each(function(t1) {
                        var e1 = n.select(this), r = t1[0], a = r.t;
                        if (!0 !== r.trace.visible || a.empty) e1.remove();
                        else {
                            var c = a.tickLen, u = e1.selectAll("path").data(i.identity);
                            u.enter().append("path"), u.exit().remove(), u.attr("d", function(t1) {
                                if (t1.empty) return "M0,0Z";
                                var e1 = s.c2p(t1.pos - c, !0), r = s.c2p(t1.pos + c, !0), n = l ? (e1 + r) / 2 : s.c2p(t1.pos, !0);
                                return "M" + e1 + "," + o.c2p(t1.o, !0) + "H" + n + "M" + n + "," + o.c2p(t1.h, !0) + "V" + o.c2p(t1.l, !0) + "M" + r + "," + o.c2p(t1.c, !0) + "H" + n;
                            });
                        }
                    });
                };
            },
            49343: function(t1) {
                "use strict";
                t1.exports = function(t1, e1) {
                    var r, n = t1.cd, i = t1.xaxis, a = t1.yaxis, o = [], s = n[0].t.bPos || 0;
                    if (!1 === e1) for(r = 0; r < n.length; r++)n[r].selected = 0;
                    else for(r = 0; r < n.length; r++){
                        var l = n[r];
                        e1.contains([
                            i.c2p(l.pos + s),
                            a.c2p(l.yc)
                        ], null, l.i, t1) ? (o.push({
                            pointNumber: l.i,
                            x: i.c2d(l.pos),
                            y: a.c2d(l.yc)
                        }), l.selected = 1) : l.selected = 0;
                    }
                    return o;
                };
            },
            57406: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(62203), a = r(78766);
                t1.exports = function(t1, e1, r) {
                    var o = r || n.select(t1).selectAll("g.ohlclayer").selectAll("g.trace");
                    o.style("opacity", function(t1) {
                        return t1[0].trace.opacity;
                    }), o.each(function(t1) {
                        var e1 = t1[0].trace;
                        n.select(this).selectAll("path").each(function(t1) {
                            if (!t1.empty) {
                                var r = e1[t1.dir].line;
                                n.select(this).style("fill", "none").call(a.stroke, r.color).call(i.dashLine, r.dash, r.width).style("opacity", e1.selectedpoints && !t1.selected ? .3 : 1);
                            }
                        });
                    });
                };
            },
            11660: function(t1, e1, r) {
                "use strict";
                var n = r(93049).extendFlat, i = r(9829), a = r(80337), o = r(87163), s = r(3208).rb, l = r(13792).u, c = n({
                    editType: "calc"
                }, o("line", {
                    editTypeOverride: "calc"
                }), {
                    shape: {
                        valType: "enumerated",
                        values: [
                            "linear",
                            "hspline"
                        ],
                        dflt: "linear",
                        editType: "plot"
                    },
                    hovertemplate: s({
                        editType: "plot",
                        arrayOk: !1
                    }, {
                        keys: [
                            "count",
                            "probability"
                        ]
                    })
                });
                t1.exports = {
                    domain: l({
                        name: "parcats",
                        trace: !0,
                        editType: "calc"
                    }),
                    hoverinfo: n({}, i.hoverinfo, {
                        flags: [
                            "count",
                            "probability"
                        ],
                        editType: "plot",
                        arrayOk: !1
                    }),
                    hoveron: {
                        valType: "enumerated",
                        values: [
                            "category",
                            "color",
                            "dimension"
                        ],
                        dflt: "category",
                        editType: "plot"
                    },
                    hovertemplate: s({
                        editType: "plot",
                        arrayOk: !1
                    }, {
                        keys: [
                            "count",
                            "probability",
                            "category",
                            "categorycount",
                            "colorcount",
                            "bandcolorcount"
                        ]
                    }),
                    arrangement: {
                        valType: "enumerated",
                        values: [
                            "perpendicular",
                            "freeform",
                            "fixed"
                        ],
                        dflt: "perpendicular",
                        editType: "plot"
                    },
                    bundlecolors: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "plot"
                    },
                    sortpaths: {
                        valType: "enumerated",
                        values: [
                            "forward",
                            "backward"
                        ],
                        dflt: "forward",
                        editType: "plot"
                    },
                    labelfont: a({
                        editType: "calc"
                    }),
                    tickfont: a({
                        autoShadowDflt: !0,
                        editType: "calc"
                    }),
                    dimensions: {
                        _isLinkedToArray: "dimension",
                        label: {
                            valType: "string",
                            editType: "calc"
                        },
                        categoryorder: {
                            valType: "enumerated",
                            values: [
                                "trace",
                                "category ascending",
                                "category descending",
                                "array"
                            ],
                            dflt: "trace",
                            editType: "calc"
                        },
                        categoryarray: {
                            valType: "data_array",
                            editType: "calc"
                        },
                        ticktext: {
                            valType: "data_array",
                            editType: "calc"
                        },
                        values: {
                            valType: "data_array",
                            dflt: [],
                            editType: "calc"
                        },
                        displayindex: {
                            valType: "integer",
                            editType: "calc"
                        },
                        editType: "calc",
                        visible: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "calc"
                        }
                    },
                    line: c,
                    counts: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        arrayOk: !0,
                        editType: "calc"
                    },
                    customdata: void 0,
                    hoverlabel: void 0,
                    ids: void 0,
                    legend: void 0,
                    legendgroup: void 0,
                    legendrank: void 0,
                    opacity: void 0,
                    selectedpoints: void 0,
                    showlegend: void 0
                };
            },
            83260: function(t1, e1, r) {
                "use strict";
                var n = r(4173).eV, i = r(37822), a = "parcats";
                e1.name = a, e1.plot = function(t1, e1, r, o) {
                    var s = n(t1.calcdata, a);
                    if (s.length) {
                        var l = s[0];
                        i(t1, l, r, o);
                    }
                }, e1.clean = function(t1, e1, r, n) {
                    var i = n._has && n._has("parcats"), a = e1._has && e1._has("parcats");
                    i && !a && n._paperdiv.selectAll(".parcats").remove();
                };
            },
            95564: function(t1, e1, r) {
                "use strict";
                var n = r(71293).wrap, i = r(65477).hasColorscale, a = r(28379), o = r(48965), s = r(62203), l = r(34809), c = r(10721);
                function u(t1, e1, r) {
                    t1.valueInds.push(e1), t1.count += r;
                }
                function h(t1, e1, r) {
                    return {
                        categoryInds: t1,
                        color: e1,
                        rawColor: r,
                        valueInds: [],
                        count: 0
                    };
                }
                function f(t1, e1, r) {
                    t1.valueInds.push(e1), t1.count += r;
                }
                t1.exports = function(t1, e1) {
                    var r = l.filterVisible(e1.dimensions);
                    if (0 === r.length) return [];
                    var p, d, m, g = r.map(function(t1) {
                        var e1;
                        if ("trace" === t1.categoryorder) e1 = null;
                        else if ("array" === t1.categoryorder) e1 = t1.categoryarray;
                        else {
                            e1 = o(t1.values);
                            for(var r = !0, n = 0; n < e1.length; n++)if (!c(e1[n])) {
                                r = !1;
                                break;
                            }
                            e1.sort(r ? l.sorterAsc : void 0), "category descending" === t1.categoryorder && (e1 = e1.reverse());
                        }
                        return function(t1, e1) {
                            e1 = null == e1 ? [] : e1.map(function(t1) {
                                return t1;
                            });
                            var r = {}, n = {}, i = [];
                            e1.forEach(function(t1, e1) {
                                r[t1] = 0, n[t1] = e1;
                            });
                            for(var a = 0; a < t1.length; a++){
                                var o, s = t1[a];
                                void 0 === r[s] ? (r[s] = 1, o = e1.push(s) - 1, n[s] = o) : (r[s]++, o = n[s]), i.push(o);
                            }
                            var l = e1.map(function(t1) {
                                return r[t1];
                            });
                            return {
                                uniqueValues: e1,
                                uniqueCounts: l,
                                inds: i
                            };
                        }(t1.values, e1);
                    });
                    p = l.isArrayOrTypedArray(e1.counts) ? e1.counts : [
                        e1.counts
                    ], function(t1) {
                        var e1, r = t1.map(function(t1) {
                            return t1.displayindex;
                        });
                        if (function(t1) {
                            for(var e1 = new Array(t1.length), r = 0; r < t1.length; r++){
                                if (t1[r] < 0 || t1[r] >= t1.length) return !1;
                                if (void 0 !== e1[t1[r]]) return !1;
                                e1[t1[r]] = !0;
                            }
                            return !0;
                        }(r)) for(e1 = 0; e1 < t1.length; e1++)t1[e1]._displayindex = t1[e1].displayindex;
                        else for(e1 = 0; e1 < t1.length; e1++)t1[e1]._displayindex = e1;
                    }(r), r.forEach(function(t1, e1) {
                        !function(t1, e1) {
                            t1._categoryarray = e1.uniqueValues, null === t1.ticktext || void 0 === t1.ticktext ? t1._ticktext = [] : t1._ticktext = t1.ticktext.slice();
                            for(var r = t1._ticktext.length; r < e1.uniqueValues.length; r++)t1._ticktext.push(e1.uniqueValues[r]);
                        }(t1, g[e1]);
                    });
                    var y, v = e1.line;
                    v ? (i(e1, "line") && a(t1, e1, {
                        vals: e1.line.color,
                        containerStr: "line",
                        cLetter: "c"
                    }), y = s.tryColorscale(v)) : y = l.identity;
                    var x, _, b, w, T, k = r[0].values.length, A = {}, M = g.map(function(t1) {
                        return t1.inds;
                    });
                    for(m = 0, x = 0; x < k; x++){
                        var S = [];
                        for(_ = 0; _ < M.length; _++)S.push(M[_][x]);
                        d = p[x % p.length], m += d;
                        var E = (b = x, w = void 0, T = void 0, l.isArrayOrTypedArray(v.color) ? T = w = v.color[b % v.color.length] : w = v.color, {
                            color: y(w),
                            rawColor: T
                        }), C = S + "-" + E.rawColor;
                        void 0 === A[C] && (A[C] = h(S, E.color, E.rawColor)), f(A[C], x, d);
                    }
                    var L, I = r.map(function(t1, e1) {
                        return function(t1, e1, r, n, i) {
                            return {
                                dimensionInd: t1,
                                containerInd: e1,
                                displayInd: r,
                                dimensionLabel: n,
                                count: i,
                                categories: [],
                                dragX: null
                            };
                        }(e1, t1._index, t1._displayindex, t1.label, m);
                    });
                    for(x = 0; x < k; x++)for(d = p[x % p.length], _ = 0; _ < I.length; _++){
                        var P = I[_].containerInd, z = g[_].inds[x], O = I[_].categories;
                        if (void 0 === O[z]) {
                            var D = e1.dimensions[P]._categoryarray[z], R = e1.dimensions[P]._ticktext[z];
                            O[z] = {
                                dimensionInd: _,
                                categoryInd: L = z,
                                categoryValue: D,
                                displayInd: L,
                                categoryLabel: R,
                                valueInds: [],
                                count: 0,
                                dragY: null
                            };
                        }
                        u(O[z], x, d);
                    }
                    return n(function(t1, e1, r) {
                        var n = t1.map(function(t1) {
                            return t1.categories.length;
                        }).reduce(function(t1, e1) {
                            return Math.max(t1, e1);
                        });
                        return {
                            dimensions: t1,
                            paths: e1,
                            trace: void 0,
                            maxCats: n,
                            count: r
                        };
                    }(I, A, m));
                };
            },
            62651: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(65477).hasColorscale, a = r(39356), o = r(13792).N, s = r(59008), l = r(11660), c = r(63197), u = r(87800).isTypedArraySpec;
                function h(t1, e1) {
                    function r(r, i) {
                        return n.coerce(t1, e1, l.dimensions, r, i);
                    }
                    var i = r("values"), a = r("visible");
                    if (i && i.length || (a = e1.visible = !1), a) {
                        r("label"), r("displayindex", e1._index);
                        var o, s = t1.categoryarray, c = n.isArrayOrTypedArray(s) && s.length > 0 || u(s);
                        c && (o = "array");
                        var h = r("categoryorder", o);
                        "array" === h ? (r("categoryarray"), r("ticktext")) : (delete t1.categoryarray, delete t1.ticktext), c || "array" !== h || (e1.categoryorder = "trace");
                    }
                }
                t1.exports = function(t1, e1, r, u) {
                    function f(r, i) {
                        return n.coerce(t1, e1, l, r, i);
                    }
                    var p = s(t1, e1, {
                        name: "dimensions",
                        handleItemDefaults: h
                    }), d = function(t1, e1, r, o, s) {
                        s("line.shape"), s("line.hovertemplate");
                        var l = s("line.color", o.colorway[0]);
                        if (i(t1, "line") && n.isArrayOrTypedArray(l)) {
                            if (l.length) return s("line.colorscale"), a(t1, e1, o, s, {
                                prefix: "line.",
                                cLetter: "c"
                            }), l.length;
                            e1.line.color = r;
                        }
                        return 1 / 0;
                    }(t1, e1, r, u, f);
                    o(e1, u, f), Array.isArray(p) && p.length || (e1.visible = !1), c(e1, p, "values", d), f("hoveron"), f("hovertemplate"), f("arrangement"), f("bundlecolors"), f("sortpaths"), f("counts");
                    var m = u.font;
                    n.coerceFont(f, "labelfont", m, {
                        overrideDflt: {
                            size: Math.round(m.size)
                        }
                    }), n.coerceFont(f, "tickfont", m, {
                        autoShadowDflt: !0,
                        overrideDflt: {
                            size: Math.round(m.size / 1.2)
                        }
                    });
                };
            },
            6305: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    attributes: r(11660),
                    supplyDefaults: r(62651),
                    calc: r(95564),
                    plot: r(37822),
                    colorbar: {
                        container: "line",
                        min: "cmin",
                        max: "cmax"
                    },
                    moduleType: "trace",
                    name: "parcats",
                    basePlotModule: r(83260),
                    categories: [
                        "noOpacity"
                    ],
                    meta: {}
                };
            },
            27219: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(88640).Dj, a = r(31420), o = r(32141), s = r(34809), l = s.strTranslate, c = r(62203), u = r(65657), h = r(30635);
                function f(t1, e1, r, i) {
                    var a = e1._context.staticPlot, o = t1.map(F.bind(0, e1, r)), u = i.selectAll("g.parcatslayer").data([
                        null
                    ]);
                    u.enter().append("g").attr("class", "parcatslayer").style("pointer-events", a ? "none" : "all");
                    var f = u.selectAll("g.trace.parcats").data(o, p), v = f.enter().append("g").attr("class", "trace parcats");
                    f.attr("transform", function(t1) {
                        return l(t1.x, t1.y);
                    }), v.append("g").attr("class", "paths");
                    var x = f.select("g.paths").selectAll("path.path").data(function(t1) {
                        return t1.paths;
                    }, p);
                    x.attr("fill", function(t1) {
                        return t1.model.color;
                    });
                    var w = x.enter().append("path").attr("class", "path").attr("stroke-opacity", 0).attr("fill", function(t1) {
                        return t1.model.color;
                    }).attr("fill-opacity", 0);
                    b(w), x.attr("d", function(t1) {
                        return t1.svgD;
                    }), w.empty() || x.sort(m), x.exit().remove(), x.on("mouseover", g).on("mouseout", y).on("click", _), v.append("g").attr("class", "dimensions");
                    var A = f.select("g.dimensions").selectAll("g.dimension").data(function(t1) {
                        return t1.dimensions;
                    }, p);
                    A.enter().append("g").attr("class", "dimension"), A.attr("transform", function(t1) {
                        return l(t1.x, 0);
                    }), A.exit().remove();
                    var M = A.selectAll("g.category").data(function(t1) {
                        return t1.categories;
                    }, p), S = M.enter().append("g").attr("class", "category");
                    M.attr("transform", function(t1) {
                        return l(0, t1.y);
                    }), S.append("rect").attr("class", "catrect").attr("pointer-events", "none"), M.select("rect.catrect").attr("fill", "none").attr("width", function(t1) {
                        return t1.width;
                    }).attr("height", function(t1) {
                        return t1.height;
                    }), T(S);
                    var E = M.selectAll("rect.bandrect").data(function(t1) {
                        return t1.bands;
                    }, p);
                    E.each(function() {
                        s.raiseToTop(this);
                    }), E.attr("fill", function(t1) {
                        return t1.color;
                    });
                    var O = E.enter().append("rect").attr("class", "bandrect").attr("stroke-opacity", 0).attr("fill", function(t1) {
                        return t1.color;
                    }).attr("fill-opacity", 0);
                    E.attr("fill", function(t1) {
                        return t1.color;
                    }).attr("width", function(t1) {
                        return t1.width;
                    }).attr("height", function(t1) {
                        return t1.height;
                    }).attr("y", function(t1) {
                        return t1.y;
                    }).attr("cursor", function(t1) {
                        return "fixed" === t1.parcatsViewModel.arrangement ? "default" : "perpendicular" === t1.parcatsViewModel.arrangement ? "ns-resize" : "move";
                    }), k(O), E.exit().remove(), S.append("text").attr("class", "catlabel").attr("pointer-events", "none"), M.select("text.catlabel").attr("text-anchor", function(t1) {
                        return d(t1) ? "start" : "end";
                    }).attr("alignment-baseline", "middle").style("fill", "rgb(0, 0, 0)").attr("x", function(t1) {
                        return d(t1) ? t1.width + 5 : -5;
                    }).attr("y", function(t1) {
                        return t1.height / 2;
                    }).text(function(t1) {
                        return t1.model.categoryLabel;
                    }).each(function(t1) {
                        c.font(n.select(this), t1.parcatsViewModel.categorylabelfont), h.convertToTspans(n.select(this), e1);
                    }), S.append("text").attr("class", "dimlabel"), M.select("text.dimlabel").attr("text-anchor", "middle").attr("alignment-baseline", "baseline").attr("cursor", function(t1) {
                        return "fixed" === t1.parcatsViewModel.arrangement ? "default" : "ew-resize";
                    }).attr("x", function(t1) {
                        return t1.width / 2;
                    }).attr("y", -5).text(function(t1, e1) {
                        return 0 === e1 ? t1.parcatsViewModel.model.dimensions[t1.model.dimensionInd].dimensionLabel : null;
                    }).each(function(t1) {
                        c.font(n.select(this), t1.parcatsViewModel.labelfont);
                    }), M.selectAll("rect.bandrect").on("mouseover", C).on("mouseout", L), M.exit().remove(), A.call(n.behavior.drag().origin(function(t1) {
                        return {
                            x: t1.x,
                            y: 0
                        };
                    }).on("dragstart", I).on("drag", P).on("dragend", z)), f.each(function(t1) {
                        t1.traceSelection = n.select(this), t1.pathSelection = n.select(this).selectAll("g.paths").selectAll("path.path"), t1.dimensionSelection = n.select(this).selectAll("g.dimensions").selectAll("g.dimension");
                    }), f.exit().remove();
                }
                function p(t1) {
                    return t1.key;
                }
                function d(t1) {
                    var e1 = t1.parcatsViewModel.dimensions.length, r = t1.parcatsViewModel.dimensions[e1 - 1].model.dimensionInd;
                    return t1.model.dimensionInd === r;
                }
                function m(t1, e1) {
                    return t1.model.rawColor > e1.model.rawColor ? 1 : t1.model.rawColor < e1.model.rawColor ? -1 : 0;
                }
                function g(t1) {
                    if (!t1.parcatsViewModel.dragDimension && -1 === t1.parcatsViewModel.hoverinfoItems.indexOf("skip")) {
                        s.raiseToTop(this), w(n.select(this));
                        var e1 = v(t1), r = x(t1);
                        if (t1.parcatsViewModel.graphDiv.emit("plotly_hover", {
                            points: e1,
                            event: n.event,
                            constraints: r
                        }), -1 === t1.parcatsViewModel.hoverinfoItems.indexOf("none")) {
                            var i, a, l, c = n.mouse(this)[0], h = t1.parcatsViewModel.graphDiv, f = t1.parcatsViewModel.trace, p = h._fullLayout, d = p._paperdiv.node().getBoundingClientRect(), m = t1.parcatsViewModel.graphDiv.getBoundingClientRect();
                            for(l = 0; l < t1.leftXs.length - 1; l++)if (t1.leftXs[l] + t1.dimWidths[l] - 2 <= c && c <= t1.leftXs[l + 1] + 2) {
                                var g = t1.parcatsViewModel.dimensions[l], y = t1.parcatsViewModel.dimensions[l + 1];
                                i = (g.x + g.width + y.x) / 2, a = (t1.topYs[l] + t1.topYs[l + 1] + t1.height) / 2;
                                break;
                            }
                            var _ = t1.parcatsViewModel.x + i, b = t1.parcatsViewModel.y + a, T = u.mostReadable(t1.model.color, [
                                "black",
                                "white"
                            ]), k = t1.model.count, A = k / t1.parcatsViewModel.model.count, M = {
                                countLabel: k,
                                probabilityLabel: A.toFixed(3)
                            }, S = [];
                            -1 !== t1.parcatsViewModel.hoverinfoItems.indexOf("count") && S.push([
                                "Count:",
                                M.countLabel
                            ].join(" ")), -1 !== t1.parcatsViewModel.hoverinfoItems.indexOf("probability") && S.push([
                                "P:",
                                M.probabilityLabel
                            ].join(" "));
                            var E = S.join("<br>"), C = n.mouse(h)[0];
                            o.loneHover({
                                trace: f,
                                x: _ - d.left + m.left,
                                y: b - d.top + m.top,
                                text: E,
                                color: t1.model.color,
                                borderColor: "black",
                                fontFamily: 'Monaco, "Courier New", monospace',
                                fontSize: 10,
                                fontColor: T,
                                idealAlign: C < _ ? "right" : "left",
                                hovertemplate: (f.line || {}).hovertemplate,
                                hovertemplateLabels: M,
                                eventData: [
                                    {
                                        data: f._input,
                                        fullData: f,
                                        count: k,
                                        probability: A
                                    }
                                ]
                            }, {
                                container: p._hoverlayer.node(),
                                outerContainer: p._paper.node(),
                                gd: h
                            });
                        }
                    }
                }
                function y(t1) {
                    if (!t1.parcatsViewModel.dragDimension && (b(n.select(this)), o.loneUnhover(t1.parcatsViewModel.graphDiv._fullLayout._hoverlayer.node()), t1.parcatsViewModel.pathSelection.sort(m), -1 === t1.parcatsViewModel.hoverinfoItems.indexOf("skip"))) {
                        var e1 = v(t1), r = x(t1);
                        t1.parcatsViewModel.graphDiv.emit("plotly_unhover", {
                            points: e1,
                            event: n.event,
                            constraints: r
                        });
                    }
                }
                function v(t1) {
                    for(var e1 = [], r = O(t1.parcatsViewModel), n = 0; n < t1.model.valueInds.length; n++){
                        var i = t1.model.valueInds[n];
                        e1.push({
                            curveNumber: r,
                            pointNumber: i
                        });
                    }
                    return e1;
                }
                function x(t1) {
                    for(var e1 = {}, r = t1.parcatsViewModel.model.dimensions, n = 0; n < r.length; n++){
                        var i = r[n], a = i.categories[t1.model.categoryInds[n]];
                        e1[i.containerInd] = a.categoryValue;
                    }
                    return void 0 !== t1.model.rawColor && (e1.color = t1.model.rawColor), e1;
                }
                function _(t1) {
                    if (-1 === t1.parcatsViewModel.hoverinfoItems.indexOf("skip")) {
                        var e1 = v(t1), r = x(t1);
                        t1.parcatsViewModel.graphDiv.emit("plotly_click", {
                            points: e1,
                            event: n.event,
                            constraints: r
                        });
                    }
                }
                function b(t1) {
                    t1.attr("fill", function(t1) {
                        return t1.model.color;
                    }).attr("fill-opacity", .6).attr("stroke", "lightgray").attr("stroke-width", .2).attr("stroke-opacity", 1);
                }
                function w(t1) {
                    t1.attr("fill-opacity", .8).attr("stroke", function(t1) {
                        return u.mostReadable(t1.model.color, [
                            "black",
                            "white"
                        ]);
                    }).attr("stroke-width", .3);
                }
                function T(t1) {
                    t1.select("rect.catrect").attr("stroke", "black").attr("stroke-width", 1).attr("stroke-opacity", 1);
                }
                function k(t1) {
                    t1.attr("stroke", "black").attr("stroke-width", .2).attr("stroke-opacity", 1).attr("fill-opacity", 1);
                }
                function A(t1) {
                    var e1 = t1.parcatsViewModel.pathSelection, r = t1.categoryViewModel.model.dimensionInd, n = t1.categoryViewModel.model.categoryInd;
                    return e1.filter(function(e1) {
                        return e1.model.categoryInds[r] === n && e1.model.color === t1.color;
                    });
                }
                function M(t1, e1, r) {
                    var i = n.select(t1).datum(), a = i.categoryViewModel.model, o = i.parcatsViewModel.graphDiv, s = n.select(t1.parentNode).selectAll("rect.bandrect"), l = [];
                    s.each(function(t1) {
                        A(t1).each(function(t1) {
                            Array.prototype.push.apply(l, v(t1));
                        });
                    });
                    var c = {};
                    c[a.dimensionInd] = a.categoryValue, o.emit(e1, {
                        points: l,
                        event: r,
                        constraints: c
                    });
                }
                function S(t1, e1, r) {
                    var i = n.select(t1).datum(), a = i.categoryViewModel.model, o = i.parcatsViewModel.graphDiv, s = A(i), l = [];
                    s.each(function(t1) {
                        Array.prototype.push.apply(l, v(t1));
                    });
                    var c = {};
                    c[a.dimensionInd] = a.categoryValue, void 0 !== i.rawColor && (c.color = i.rawColor), o.emit(e1, {
                        points: l,
                        event: r,
                        constraints: c
                    });
                }
                function E(t1, e1, r) {
                    t1._fullLayout._calcInverseTransform(t1);
                    var i, a, o = t1._fullLayout._invScaleX, s = t1._fullLayout._invScaleY, l = n.select(r.parentNode).select("rect.catrect"), c = l.node().getBoundingClientRect(), u = l.datum(), h = u.parcatsViewModel, f = h.model.dimensions[u.model.dimensionInd], p = h.trace, d = c.top + c.height / 2;
                    h.dimensions.length > 1 && f.displayInd === h.dimensions.length - 1 ? (i = c.left, a = "left") : (i = c.left + c.width, a = "right");
                    var m = u.model.count, g = u.model.categoryLabel, y = m / u.parcatsViewModel.model.count, v = {
                        countLabel: m,
                        categoryLabel: g,
                        probabilityLabel: y.toFixed(3)
                    }, x = [];
                    -1 !== u.parcatsViewModel.hoverinfoItems.indexOf("count") && x.push([
                        "Count:",
                        v.countLabel
                    ].join(" ")), -1 !== u.parcatsViewModel.hoverinfoItems.indexOf("probability") && x.push([
                        "P(" + v.categoryLabel + "):",
                        v.probabilityLabel
                    ].join(" "));
                    var _ = x.join("<br>");
                    return {
                        trace: p,
                        x: o * (i - e1.left),
                        y: s * (d - e1.top),
                        text: _,
                        color: "lightgray",
                        borderColor: "black",
                        fontFamily: 'Monaco, "Courier New", monospace',
                        fontSize: 12,
                        fontColor: "black",
                        idealAlign: a,
                        hovertemplate: p.hovertemplate,
                        hovertemplateLabels: v,
                        eventData: [
                            {
                                data: p._input,
                                fullData: p,
                                count: m,
                                category: g,
                                probability: y
                            }
                        ]
                    };
                }
                function C(t1) {
                    if (!t1.parcatsViewModel.dragDimension && -1 === t1.parcatsViewModel.hoverinfoItems.indexOf("skip")) {
                        if (n.mouse(this)[1] < -1) return;
                        var e1, r = t1.parcatsViewModel.graphDiv, i = r._fullLayout, a = i._paperdiv.node().getBoundingClientRect(), l = t1.parcatsViewModel.hoveron, c = this;
                        "color" === l ? (function(t1) {
                            var e1 = n.select(t1).datum(), r = A(e1);
                            w(r), r.each(function() {
                                s.raiseToTop(this);
                            }), n.select(t1.parentNode).selectAll("rect.bandrect").filter(function(t1) {
                                return t1.color === e1.color;
                            }).each(function() {
                                s.raiseToTop(this), n.select(this).attr("stroke", "black").attr("stroke-width", 1.5);
                            });
                        }(c), S(c, "plotly_hover", n.event)) : (function(t1) {
                            n.select(t1.parentNode).selectAll("rect.bandrect").each(function(t1) {
                                var e1 = A(t1);
                                w(e1), e1.each(function() {
                                    s.raiseToTop(this);
                                });
                            }), n.select(t1.parentNode).select("rect.catrect").attr("stroke", "black").attr("stroke-width", 2.5);
                        }(c), M(c, "plotly_hover", n.event)), -1 === t1.parcatsViewModel.hoverinfoItems.indexOf("none") && ("category" === l ? e1 = E(r, a, c) : "color" === l ? e1 = function(t1, e1, r) {
                            t1._fullLayout._calcInverseTransform(t1);
                            var i, a, o = t1._fullLayout._invScaleX, s = t1._fullLayout._invScaleY, l = r.getBoundingClientRect(), c = n.select(r).datum(), h = c.categoryViewModel, f = h.parcatsViewModel, p = f.model.dimensions[h.model.dimensionInd], d = f.trace, m = l.y + l.height / 2;
                            f.dimensions.length > 1 && p.displayInd === f.dimensions.length - 1 ? (i = l.left, a = "left") : (i = l.left + l.width, a = "right");
                            var g = h.model.categoryLabel, y = c.parcatsViewModel.model.count, v = 0;
                            c.categoryViewModel.bands.forEach(function(t1) {
                                t1.color === c.color && (v += t1.count);
                            });
                            var x = h.model.count, _ = 0;
                            f.pathSelection.each(function(t1) {
                                t1.model.color === c.color && (_ += t1.model.count);
                            });
                            var b = v / y, w = v / _, T = v / x, k = {
                                countLabel: v,
                                categoryLabel: g,
                                probabilityLabel: b.toFixed(3)
                            }, A = [];
                            -1 !== h.parcatsViewModel.hoverinfoItems.indexOf("count") && A.push([
                                "Count:",
                                k.countLabel
                            ].join(" ")), -1 !== h.parcatsViewModel.hoverinfoItems.indexOf("probability") && (A.push("P(color \u2229 " + g + "): " + k.probabilityLabel), A.push("P(" + g + " | color): " + w.toFixed(3)), A.push("P(color | " + g + "): " + T.toFixed(3)));
                            var M = A.join("<br>"), S = u.mostReadable(c.color, [
                                "black",
                                "white"
                            ]);
                            return {
                                trace: d,
                                x: o * (i - e1.left),
                                y: s * (m - e1.top),
                                text: M,
                                color: c.color,
                                borderColor: "black",
                                fontFamily: 'Monaco, "Courier New", monospace',
                                fontColor: S,
                                fontSize: 10,
                                idealAlign: a,
                                hovertemplate: d.hovertemplate,
                                hovertemplateLabels: k,
                                eventData: [
                                    {
                                        data: d._input,
                                        fullData: d,
                                        category: g,
                                        count: y,
                                        probability: b,
                                        categorycount: x,
                                        colorcount: _,
                                        bandcolorcount: v
                                    }
                                ]
                            };
                        }(r, a, c) : "dimension" === l && (e1 = function(t1, e1, r) {
                            var i = [];
                            return n.select(r.parentNode.parentNode).selectAll("g.category").select("rect.catrect").each(function() {
                                i.push(E(t1, e1, this));
                            }), i;
                        }(r, a, c)), e1 && o.loneHover(e1, {
                            container: i._hoverlayer.node(),
                            outerContainer: i._paper.node(),
                            gd: r
                        }));
                    }
                }
                function L(t1) {
                    var e1 = t1.parcatsViewModel;
                    e1.dragDimension || (b(e1.pathSelection), T(e1.dimensionSelection.selectAll("g.category")), k(e1.dimensionSelection.selectAll("g.category").selectAll("rect.bandrect")), o.loneUnhover(e1.graphDiv._fullLayout._hoverlayer.node()), e1.pathSelection.sort(m), -1 !== e1.hoverinfoItems.indexOf("skip")) || ("color" === t1.parcatsViewModel.hoveron ? S(this, "plotly_unhover", n.event) : M(this, "plotly_unhover", n.event));
                }
                function I(t1) {
                    "fixed" !== t1.parcatsViewModel.arrangement && (t1.dragDimensionDisplayInd = t1.model.displayInd, t1.initialDragDimensionDisplayInds = t1.parcatsViewModel.model.dimensions.map(function(t1) {
                        return t1.displayInd;
                    }), t1.dragHasMoved = !1, t1.dragCategoryDisplayInd = null, n.select(this).selectAll("g.category").select("rect.catrect").each(function(e1) {
                        var r = n.mouse(this)[0], i = n.mouse(this)[1];
                        -2 <= r && r <= e1.width + 2 && -2 <= i && i <= e1.height + 2 && (t1.dragCategoryDisplayInd = e1.model.displayInd, t1.initialDragCategoryDisplayInds = t1.model.categories.map(function(t1) {
                            return t1.displayInd;
                        }), e1.model.dragY = e1.y, s.raiseToTop(this.parentNode), n.select(this.parentNode).selectAll("rect.bandrect").each(function(e1) {
                            e1.y < i && i <= e1.y + e1.height && (t1.potentialClickBand = this);
                        }));
                    }), t1.parcatsViewModel.dragDimension = t1, o.loneUnhover(t1.parcatsViewModel.graphDiv._fullLayout._hoverlayer.node()));
                }
                function P(t1) {
                    if ("fixed" !== t1.parcatsViewModel.arrangement && (t1.dragHasMoved = !0, null !== t1.dragDimensionDisplayInd)) {
                        var e1 = t1.dragDimensionDisplayInd, r = e1 - 1, i = e1 + 1, a = t1.parcatsViewModel.dimensions[e1];
                        if (null !== t1.dragCategoryDisplayInd) {
                            var o = a.categories[t1.dragCategoryDisplayInd];
                            o.model.dragY += n.event.dy;
                            var s = o.model.dragY, l = o.model.displayInd, c = a.categories, u = c[l - 1], h = c[l + 1];
                            void 0 !== u && s < u.y + u.height / 2 && (o.model.displayInd = u.model.displayInd, u.model.displayInd = l), void 0 !== h && s + o.height > h.y + h.height / 2 && (o.model.displayInd = h.model.displayInd, h.model.displayInd = l), t1.dragCategoryDisplayInd = o.model.displayInd;
                        }
                        if (null === t1.dragCategoryDisplayInd || "freeform" === t1.parcatsViewModel.arrangement) {
                            a.model.dragX = n.event.x;
                            var f = t1.parcatsViewModel.dimensions[r], p = t1.parcatsViewModel.dimensions[i];
                            void 0 !== f && a.model.dragX < f.x + f.width && (a.model.displayInd = f.model.displayInd, f.model.displayInd = e1), void 0 !== p && a.model.dragX + a.width > p.x && (a.model.displayInd = p.model.displayInd, p.model.displayInd = t1.dragDimensionDisplayInd), t1.dragDimensionDisplayInd = a.model.displayInd;
                        }
                        j(t1.parcatsViewModel), N(t1.parcatsViewModel), R(t1.parcatsViewModel), D(t1.parcatsViewModel);
                    }
                }
                function z(t1) {
                    if ("fixed" !== t1.parcatsViewModel.arrangement && null !== t1.dragDimensionDisplayInd) {
                        n.select(this).selectAll("text").attr("font-weight", "normal");
                        var e1 = {}, r = O(t1.parcatsViewModel), i = t1.parcatsViewModel.model.dimensions.map(function(t1) {
                            return t1.displayInd;
                        }), o = t1.initialDragDimensionDisplayInds.some(function(t1, e1) {
                            return t1 !== i[e1];
                        });
                        o && i.forEach(function(r, n) {
                            var i = t1.parcatsViewModel.model.dimensions[n].containerInd;
                            e1["dimensions[" + i + "].displayindex"] = r;
                        });
                        var s = !1;
                        if (null !== t1.dragCategoryDisplayInd) {
                            var l = t1.model.categories.map(function(t1) {
                                return t1.displayInd;
                            });
                            if (s = t1.initialDragCategoryDisplayInds.some(function(t1, e1) {
                                return t1 !== l[e1];
                            })) {
                                var c = t1.model.categories.slice().sort(function(t1, e1) {
                                    return t1.displayInd - e1.displayInd;
                                }), u = c.map(function(t1) {
                                    return t1.categoryValue;
                                }), h = c.map(function(t1) {
                                    return t1.categoryLabel;
                                });
                                e1["dimensions[" + t1.model.containerInd + "].categoryarray"] = [
                                    u
                                ], e1["dimensions[" + t1.model.containerInd + "].ticktext"] = [
                                    h
                                ], e1["dimensions[" + t1.model.containerInd + "].categoryorder"] = "array";
                            }
                        }
                        -1 === t1.parcatsViewModel.hoverinfoItems.indexOf("skip") && !t1.dragHasMoved && t1.potentialClickBand && ("color" === t1.parcatsViewModel.hoveron ? S(t1.potentialClickBand, "plotly_click", n.event.sourceEvent) : M(t1.potentialClickBand, "plotly_click", n.event.sourceEvent)), t1.model.dragX = null, null !== t1.dragCategoryDisplayInd && (t1.parcatsViewModel.dimensions[t1.dragDimensionDisplayInd].categories[t1.dragCategoryDisplayInd].model.dragY = null, t1.dragCategoryDisplayInd = null), t1.dragDimensionDisplayInd = null, t1.parcatsViewModel.dragDimension = null, t1.dragHasMoved = null, t1.potentialClickBand = null, j(t1.parcatsViewModel), N(t1.parcatsViewModel), n.transition().duration(300).ease("cubic-in-out").each(function() {
                            R(t1.parcatsViewModel, !0), D(t1.parcatsViewModel, !0);
                        }).each("end", function() {
                            (o || s) && a.restyle(t1.parcatsViewModel.graphDiv, e1, [
                                r
                            ]);
                        });
                    }
                }
                function O(t1) {
                    for(var e1, r = t1.graphDiv._fullData, n = 0; n < r.length; n++)if (t1.key === r[n].uid) {
                        e1 = n;
                        break;
                    }
                    return e1;
                }
                function D(t1, e1) {
                    var r;
                    void 0 === e1 && (e1 = !1), t1.pathSelection.data(function(t1) {
                        return t1.paths;
                    }, p), (r = t1.pathSelection, e1 ? r.transition() : r).attr("d", function(t1) {
                        return t1.svgD;
                    });
                }
                function R(t1, e1) {
                    function r(t1) {
                        return e1 ? t1.transition() : t1;
                    }
                    void 0 === e1 && (e1 = !1), t1.dimensionSelection.data(function(t1) {
                        return t1.dimensions;
                    }, p);
                    var i = t1.dimensionSelection.selectAll("g.category").data(function(t1) {
                        return t1.categories;
                    }, p);
                    r(t1.dimensionSelection).attr("transform", function(t1) {
                        return l(t1.x, 0);
                    }), r(i).attr("transform", function(t1) {
                        return l(0, t1.y);
                    }), i.select(".dimlabel").text(function(t1, e1) {
                        return 0 === e1 ? t1.parcatsViewModel.model.dimensions[t1.model.dimensionInd].dimensionLabel : null;
                    }), i.select(".catlabel").attr("text-anchor", function(t1) {
                        return d(t1) ? "start" : "end";
                    }).attr("x", function(t1) {
                        return d(t1) ? t1.width + 5 : -5;
                    }).each(function(t1) {
                        var e1, r;
                        d(t1) ? (e1 = t1.width + 5, r = "start") : (e1 = -5, r = "end"), n.select(this).selectAll("tspan").attr("x", e1).attr("text-anchor", r);
                    });
                    var a = i.selectAll("rect.bandrect").data(function(t1) {
                        return t1.bands;
                    }, p), o = a.enter().append("rect").attr("class", "bandrect").attr("cursor", "move").attr("stroke-opacity", 0).attr("fill", function(t1) {
                        return t1.color;
                    }).attr("fill-opacity", 0);
                    a.attr("fill", function(t1) {
                        return t1.color;
                    }).attr("width", function(t1) {
                        return t1.width;
                    }).attr("height", function(t1) {
                        return t1.height;
                    }).attr("y", function(t1) {
                        return t1.y;
                    }), k(o), a.each(function() {
                        s.raiseToTop(this);
                    }), a.exit().remove();
                }
                function F(t1, e1, r) {
                    var n, i = r[0], a = e1.margin || {
                        l: 80,
                        r: 80,
                        t: 100,
                        b: 80
                    }, o = i.trace, s = o.domain, l = e1.width, c = e1.height, u = Math.floor(l * (s.x[1] - s.x[0])), h = Math.floor(c * (s.y[1] - s.y[0])), f = s.x[0] * l + a.l, p = e1.height - s.y[1] * e1.height + a.t, d = o.line.shape;
                    n = "all" === o.hoverinfo ? [
                        "count",
                        "probability"
                    ] : (o.hoverinfo || "").split("+");
                    var m = {
                        trace: o,
                        key: o.uid,
                        model: i,
                        x: f,
                        y: p,
                        width: u,
                        height: h,
                        hoveron: o.hoveron,
                        hoverinfoItems: n,
                        arrangement: o.arrangement,
                        bundlecolors: o.bundlecolors,
                        sortpaths: o.sortpaths,
                        labelfont: o.labelfont,
                        categorylabelfont: o.tickfont,
                        pathShape: d,
                        dragDimension: null,
                        margin: a,
                        paths: [],
                        dimensions: [],
                        graphDiv: t1,
                        traceSelection: null,
                        pathSelection: null,
                        dimensionSelection: null
                    };
                    return i.dimensions && (j(m), N(m)), m;
                }
                function B(t1, e1, r, n, a) {
                    var o, s, l = [], c = [];
                    for(s = 0; s < r.length - 1; s++)o = i(r[s] + t1[s], t1[s + 1]), l.push(o(a)), c.push(o(1 - a));
                    var u = "M " + t1[0] + "," + e1[0];
                    for(u += "l" + r[0] + ",0 ", s = 1; s < r.length; s++)u += "C" + l[s - 1] + "," + e1[s - 1] + " " + c[s - 1] + "," + e1[s] + " " + t1[s] + "," + e1[s], u += "l" + r[s] + ",0 ";
                    for(u += "l0," + n + " ", u += "l -" + r[r.length - 1] + ",0 ", s = r.length - 2; s >= 0; s--)u += "C" + c[s] + "," + (e1[s + 1] + n) + " " + l[s] + "," + (e1[s] + n) + " " + (t1[s] + r[s]) + "," + (e1[s] + n), u += "l-" + r[s] + ",0 ";
                    return u + "Z";
                }
                function N(t1) {
                    var e1 = t1.dimensions, r = t1.model, n = e1.map(function(t1) {
                        return t1.categories.map(function(t1) {
                            return t1.y;
                        });
                    }), i = t1.model.dimensions.map(function(t1) {
                        return t1.categories.map(function(t1) {
                            return t1.displayInd;
                        });
                    }), a = t1.model.dimensions.map(function(t1) {
                        return t1.displayInd;
                    }), o = t1.dimensions.map(function(t1) {
                        return t1.model.dimensionInd;
                    }), s = e1.map(function(t1) {
                        return t1.x;
                    }), l = e1.map(function(t1) {
                        return t1.width;
                    }), c = [];
                    for(var u in r.paths)r.paths.hasOwnProperty(u) && c.push(r.paths[u]);
                    function h(t1) {
                        var e1 = t1.categoryInds.map(function(t1, e1) {
                            return i[e1][t1];
                        });
                        return o.map(function(t1) {
                            return e1[t1];
                        });
                    }
                    c.sort(function(e1, r) {
                        var n = h(e1), i = h(r);
                        return "backward" === t1.sortpaths && (n.reverse(), i.reverse()), n.push(e1.valueInds[0]), i.push(r.valueInds[0]), t1.bundlecolors && (n.unshift(e1.rawColor), i.unshift(r.rawColor)), n < i ? -1 : n > i ? 1 : 0;
                    });
                    for(var f = new Array(c.length), p = e1[0].model.count, d = e1[0].categories.map(function(t1) {
                        return t1.height;
                    }).reduce(function(t1, e1) {
                        return t1 + e1;
                    }), m = 0; m < c.length; m++){
                        var g, y = c[m];
                        g = p > 0 ? d * (y.count / p) : 0;
                        for(var v, x = new Array(n.length), _ = 0; _ < y.categoryInds.length; _++){
                            var b = y.categoryInds[_], w = i[_][b], T = a[_];
                            x[T] = n[T][w], n[T][w] += g;
                            var k = t1.dimensions[T].categories[w], A = k.bands.length, M = k.bands[A - 1];
                            if (void 0 === M || y.rawColor !== M.rawColor) {
                                var S = void 0 === M ? 0 : M.y + M.height;
                                k.bands.push({
                                    key: S,
                                    color: y.color,
                                    rawColor: y.rawColor,
                                    height: g,
                                    width: k.width,
                                    count: y.count,
                                    y: S,
                                    categoryViewModel: k,
                                    parcatsViewModel: t1
                                });
                            } else {
                                var E = k.bands[A - 1];
                                E.height += g, E.count += y.count;
                            }
                        }
                        v = "hspline" === t1.pathShape ? B(s, x, l, g, .5) : B(s, x, l, g, 0), f[m] = {
                            key: y.valueInds[0],
                            model: y,
                            height: g,
                            leftXs: s,
                            topYs: x,
                            dimWidths: l,
                            svgD: v,
                            parcatsViewModel: t1
                        };
                    }
                    t1.paths = f;
                }
                function j(t1) {
                    var e1 = t1.model.dimensions.map(function(t1) {
                        return {
                            displayInd: t1.displayInd,
                            dimensionInd: t1.dimensionInd
                        };
                    });
                    e1.sort(function(t1, e1) {
                        return t1.displayInd - e1.displayInd;
                    });
                    var r = [];
                    for(var n in e1){
                        var i = e1[n].dimensionInd, a = t1.model.dimensions[i];
                        r.push(U(t1, a));
                    }
                    t1.dimensions = r;
                }
                function U(t1, e1) {
                    var r, n = t1.model.dimensions.length, i = e1.displayInd;
                    r = 40 + (n > 1 ? (t1.width - 80 - 16) / (n - 1) : 0) * i;
                    var a, o, s, l, c, u = [], h = t1.model.maxCats, f = e1.categories.length, p = e1.count, d = t1.height - 8 * (h - 1), m = 8 * (h - f) / 2, g = e1.categories.map(function(t1) {
                        return {
                            displayInd: t1.displayInd,
                            categoryInd: t1.categoryInd
                        };
                    });
                    for(g.sort(function(t1, e1) {
                        return t1.displayInd - e1.displayInd;
                    }), c = 0; c < f; c++)l = g[c].categoryInd, o = e1.categories[l], a = p > 0 ? o.count / p * d : 0, s = {
                        key: o.valueInds[0],
                        model: o,
                        width: 16,
                        height: a,
                        y: null !== o.dragY ? o.dragY : m,
                        bands: [],
                        parcatsViewModel: t1
                    }, m = m + a + 8, u.push(s);
                    return {
                        key: e1.dimensionInd,
                        x: null !== e1.dragX ? e1.dragX : r,
                        y: 0,
                        width: 16,
                        model: e1,
                        categories: u,
                        parcatsViewModel: t1,
                        dragCategoryDisplayInd: null,
                        dragDimensionDisplayInd: null,
                        initialDragDimensionDisplayInds: null,
                        initialDragCategoryDisplayInds: null,
                        dragHasMoved: null,
                        potentialClickBand: null
                    };
                }
                t1.exports = function(t1, e1, r, n) {
                    f(r, t1, n, e1);
                };
            },
            37822: function(t1, e1, r) {
                "use strict";
                var n = r(27219);
                t1.exports = function(t1, e1, r, i) {
                    var a = t1._fullLayout, o = a._paper, s = a._size;
                    n(t1, o, e1, {
                        width: s.w,
                        height: s.h,
                        margin: {
                            t: s.t,
                            r: s.r,
                            b: s.b,
                            l: s.l
                        }
                    }, r, i);
                };
            },
            59549: function(t1, e1, r) {
                "use strict";
                var n = r(87163), i = r(25829), a = r(80337), o = r(13792).u, s = r(93049).extendFlat, l = r(78032).templatedArray;
                t1.exports = {
                    domain: o({
                        name: "parcoords",
                        trace: !0,
                        editType: "plot"
                    }),
                    labelangle: {
                        valType: "angle",
                        dflt: 0,
                        editType: "plot"
                    },
                    labelside: {
                        valType: "enumerated",
                        values: [
                            "top",
                            "bottom"
                        ],
                        dflt: "top",
                        editType: "plot"
                    },
                    labelfont: a({
                        editType: "plot"
                    }),
                    tickfont: a({
                        autoShadowDflt: !0,
                        editType: "plot"
                    }),
                    rangefont: a({
                        editType: "plot"
                    }),
                    dimensions: l("dimension", {
                        label: {
                            valType: "string",
                            editType: "plot"
                        },
                        tickvals: s({}, i.tickvals, {
                            editType: "plot"
                        }),
                        ticktext: s({}, i.ticktext, {
                            editType: "plot"
                        }),
                        tickformat: s({}, i.tickformat, {
                            editType: "plot"
                        }),
                        visible: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "plot"
                        },
                        range: {
                            valType: "info_array",
                            items: [
                                {
                                    valType: "number",
                                    editType: "plot"
                                },
                                {
                                    valType: "number",
                                    editType: "plot"
                                }
                            ],
                            editType: "plot"
                        },
                        constraintrange: {
                            valType: "info_array",
                            freeLength: !0,
                            dimensions: "1-2",
                            items: [
                                {
                                    valType: "any",
                                    editType: "plot"
                                },
                                {
                                    valType: "any",
                                    editType: "plot"
                                }
                            ],
                            editType: "plot"
                        },
                        multiselect: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "plot"
                        },
                        values: {
                            valType: "data_array",
                            editType: "calc"
                        },
                        editType: "calc"
                    }),
                    line: s({
                        editType: "calc"
                    }, n("line", {
                        colorscaleDflt: "Viridis",
                        autoColorDflt: !1,
                        editTypeOverride: "calc"
                    })),
                    unselected: {
                        line: {
                            color: {
                                valType: "color",
                                dflt: "#7f7f7f",
                                editType: "plot"
                            },
                            opacity: {
                                valType: "number",
                                min: 0,
                                max: 1,
                                dflt: "auto",
                                editType: "plot"
                            },
                            editType: "plot"
                        },
                        editType: "plot"
                    }
                };
            },
            23245: function(t1, e1, r) {
                "use strict";
                var n = r(77911), i = r(45568), a = r(71293).keyFun, o = r(71293).repeat, s = r(34809).sorterAsc, l = r(34809).strTranslate, c = n.bar.snapRatio;
                function u(t1, e1) {
                    return t1 * (1 - c) + e1 * c;
                }
                var h = n.bar.snapClose;
                function f(t1, e1) {
                    return t1 * (1 - h) + e1 * h;
                }
                function p(t1, e1, r, n) {
                    if (function(t1, e1) {
                        for(var r = 0; r < e1.length; r++)if (t1 >= e1[r][0] && t1 <= e1[r][1]) return !0;
                        return !1;
                    }(r, n)) return r;
                    var i = t1 ? -1 : 1, a = 0, o = e1.length - 1;
                    if (i < 0) {
                        var s = a;
                        a = o, o = s;
                    }
                    for(var l = e1[a], c = l, h = a; i * h < i * o; h += i){
                        var p = h + i, d = e1[p];
                        if (i * r < i * f(l, d)) return u(l, c);
                        if (i * r < i * d || p === o) return u(d, l);
                        c = l, l = d;
                    }
                }
                function d(t1) {
                    t1.attr("x", -n.bar.captureWidth / 2).attr("width", n.bar.captureWidth);
                }
                function m(t1) {
                    t1.attr("visibility", "visible").style("visibility", "visible").attr("fill", "yellow").attr("opacity", 0);
                }
                function g(t1) {
                    if (!t1.brush.filterSpecified) return "0," + t1.height;
                    for(var e1, r, n, i = y(t1.brush.filter.getConsolidated(), t1.height), a = [
                        0
                    ], o = i.length ? i[0][0] : null, s = 0; s < i.length; s++)r = (e1 = i[s])[1] - e1[0], a.push(o), a.push(r), (n = s + 1) < i.length && (o = i[n][0] - e1[1]);
                    return a.push(t1.height), a;
                }
                function y(t1, e1) {
                    return t1.map(function(t1) {
                        return t1.map(function(t1) {
                            return Math.max(0, t1 * e1);
                        }).sort(s);
                    });
                }
                function v() {
                    i.select(document.body).style("cursor", null);
                }
                function x(t1) {
                    t1.attr("stroke-dasharray", g);
                }
                function _(t1, e1) {
                    var r = i.select(t1).selectAll(".highlight, .highlight-shadow");
                    x(e1 ? r.transition().duration(n.bar.snapDuration).each("end", e1) : r);
                }
                function b(t1, e1) {
                    var r, i = t1.brush, a = NaN, o = {};
                    if (i.filterSpecified) {
                        var s = t1.height, l = i.filter.getConsolidated(), c = y(l, s), u = NaN, h = NaN, f = NaN;
                        for(r = 0; r <= c.length; r++){
                            var p = c[r];
                            if (p && p[0] <= e1 && e1 <= p[1]) {
                                u = r;
                                break;
                            }
                            if (h = r ? r - 1 : NaN, p && p[0] > e1) {
                                f = r;
                                break;
                            }
                        }
                        if (a = u, isNaN(a) && (a = isNaN(h) || isNaN(f) ? isNaN(h) ? f : h : e1 - c[h][1] < c[f][0] - e1 ? h : f), !isNaN(a)) {
                            var d = c[a], m = function(t1, e1) {
                                var r = n.bar.handleHeight;
                                if (!(e1 > t1[1] + r || e1 < t1[0] - r)) return e1 >= .9 * t1[1] + .1 * t1[0] ? "n" : e1 <= .9 * t1[0] + .1 * t1[1] ? "s" : "ns";
                            }(d, e1);
                            m && (o.interval = l[a], o.intervalPix = d, o.region = m);
                        }
                    }
                    if (t1.ordinal && !o.region) {
                        var g = t1.unitTickvals, v = t1.unitToPaddedPx.invert(e1);
                        for(r = 0; r < g.length; r++){
                            var x = [
                                .25 * g[Math.max(r - 1, 0)] + .75 * g[r],
                                .25 * g[Math.min(r + 1, g.length - 1)] + .75 * g[r]
                            ];
                            if (v >= x[0] && v <= x[1]) {
                                o.clickableOrdinalRange = x;
                                break;
                            }
                        }
                    }
                    return o;
                }
                function w(t1, e1) {
                    i.event.sourceEvent.stopPropagation();
                    var r = e1.height - i.mouse(t1)[1] - 2 * n.verticalPadding, a = e1.brush.svgBrush;
                    a.wasDragged = !0, a._dragging = !0, a.grabbingBar ? a.newExtent = [
                        r - a.grabPoint,
                        r + a.barLength - a.grabPoint
                    ].map(e1.unitToPaddedPx.invert) : a.newExtent = [
                        a.startExtent,
                        e1.unitToPaddedPx.invert(r)
                    ].sort(s), e1.brush.filterSpecified = !0, a.extent = a.stayingIntervals.concat([
                        a.newExtent
                    ]), a.brushCallback(e1), _(t1.parentNode);
                }
                function T(t1, e1) {
                    var r = b(e1, e1.height - i.mouse(t1)[1] - 2 * n.verticalPadding), a = "crosshair";
                    r.clickableOrdinalRange ? a = "pointer" : r.region && (a = r.region + "-resize"), i.select(document.body).style("cursor", a);
                }
                function k(t1) {
                    t1.on("mousemove", function(t1) {
                        i.event.preventDefault(), t1.parent.inBrushDrag || T(this, t1);
                    }).on("mouseleave", function(t1) {
                        t1.parent.inBrushDrag || v();
                    }).call(i.behavior.drag().on("dragstart", function(t1) {
                        !function(t1, e1) {
                            i.event.sourceEvent.stopPropagation();
                            var r = e1.height - i.mouse(t1)[1] - 2 * n.verticalPadding, a = e1.unitToPaddedPx.invert(r), o = e1.brush, s = b(e1, r), l = s.interval, c = o.svgBrush;
                            if (c.wasDragged = !1, c.grabbingBar = "ns" === s.region, c.grabbingBar) {
                                var u = l.map(e1.unitToPaddedPx);
                                c.grabPoint = r - u[0] - n.verticalPadding, c.barLength = u[1] - u[0];
                            }
                            c.clickableOrdinalRange = s.clickableOrdinalRange, c.stayingIntervals = e1.multiselect && o.filterSpecified ? o.filter.getConsolidated() : [], l && (c.stayingIntervals = c.stayingIntervals.filter(function(t1) {
                                return t1[0] !== l[0] && t1[1] !== l[1];
                            })), c.startExtent = s.region ? l["s" === s.region ? 1 : 0] : a, e1.parent.inBrushDrag = !0, c.brushStartCallback();
                        }(this, t1);
                    }).on("drag", function(t1) {
                        w(this, t1);
                    }).on("dragend", function(t1) {
                        !function(t1, e1) {
                            var r = e1.brush, n = r.filter, a = r.svgBrush;
                            a._dragging || (T(t1, e1), w(t1, e1), e1.brush.svgBrush.wasDragged = !1), a._dragging = !1, i.event.sourceEvent.stopPropagation();
                            var o = a.grabbingBar;
                            if (a.grabbingBar = !1, a.grabLocation = void 0, e1.parent.inBrushDrag = !1, v(), !a.wasDragged) return a.wasDragged = void 0, a.clickableOrdinalRange ? r.filterSpecified && e1.multiselect ? a.extent.push(a.clickableOrdinalRange) : (a.extent = [
                                a.clickableOrdinalRange
                            ], r.filterSpecified = !0) : o ? (a.extent = a.stayingIntervals, 0 === a.extent.length && M(r)) : M(r), a.brushCallback(e1), _(t1.parentNode), void a.brushEndCallback(r.filterSpecified ? n.getConsolidated() : []);
                            var s = function() {
                                n.set(n.getConsolidated());
                            };
                            if (e1.ordinal) {
                                var l = e1.unitTickvals;
                                l[l.length - 1] < l[0] && l.reverse(), a.newExtent = [
                                    p(0, l, a.newExtent[0], a.stayingIntervals),
                                    p(1, l, a.newExtent[1], a.stayingIntervals)
                                ];
                                var c = a.newExtent[1] > a.newExtent[0];
                                a.extent = a.stayingIntervals.concat(c ? [
                                    a.newExtent
                                ] : []), a.extent.length || M(r), a.brushCallback(e1), c ? _(t1.parentNode, s) : (s(), _(t1.parentNode));
                            } else s();
                            a.brushEndCallback(r.filterSpecified ? n.getConsolidated() : []);
                        }(this, t1);
                    }));
                }
                function A(t1, e1) {
                    return t1[0] - e1[0];
                }
                function M(t1) {
                    t1.filterSpecified = !1, t1.svgBrush.extent = [
                        [
                            -1 / 0,
                            1 / 0
                        ]
                    ];
                }
                function S(t1) {
                    for(var e1, r = t1.slice(), n = [], i = r.shift(); i;){
                        for(e1 = i.slice(); (i = r.shift()) && i[0] <= e1[1];)e1[1] = Math.max(e1[1], i[1]);
                        n.push(e1);
                    }
                    return 1 === n.length && n[0][0] > n[0][1] && (n = []), n;
                }
                t1.exports = {
                    makeBrush: function(t1, e1, r, n, i, a) {
                        var o, l = function() {
                            var t1, e1, r = [];
                            return {
                                set: function(n) {
                                    1 === (r = n.map(function(t1) {
                                        return t1.slice().sort(s);
                                    }).sort(A)).length && r[0][0] === -1 / 0 && r[0][1] === 1 / 0 && (r = [
                                        [
                                            0,
                                            -1
                                        ]
                                    ]), t1 = S(r), e1 = r.reduce(function(t1, e1) {
                                        return [
                                            Math.min(t1[0], e1[0]),
                                            Math.max(t1[1], e1[1])
                                        ];
                                    }, [
                                        1 / 0,
                                        -1 / 0
                                    ]);
                                },
                                get: function() {
                                    return r.slice();
                                },
                                getConsolidated: function() {
                                    return t1;
                                },
                                getBounds: function() {
                                    return e1;
                                }
                            };
                        }();
                        return l.set(r), {
                            filter: l,
                            filterSpecified: e1,
                            svgBrush: {
                                extent: [],
                                brushStartCallback: n,
                                brushCallback: (o = i, function(t1) {
                                    var e1 = t1.brush, r = function(t1) {
                                        return t1.svgBrush.extent.map(function(t1) {
                                            return t1.slice();
                                        });
                                    }(e1), n = r.slice();
                                    e1.filter.set(n), o();
                                }),
                                brushEndCallback: a
                            }
                        };
                    },
                    ensureAxisBrush: function(t1, e1, r) {
                        var i = t1.selectAll("." + n.cn.axisBrush).data(o, a);
                        i.enter().append("g").classed(n.cn.axisBrush, !0), function(t1, e1, r) {
                            var i = r._context.staticPlot, a = t1.selectAll(".background").data(o);
                            a.enter().append("rect").classed("background", !0).call(d).call(m).style("pointer-events", i ? "none" : "auto").attr("transform", l(0, n.verticalPadding)), a.call(k).attr("height", function(t1) {
                                return t1.height - n.verticalPadding;
                            });
                            var s = t1.selectAll(".highlight-shadow").data(o);
                            s.enter().append("line").classed("highlight-shadow", !0).attr("x", -n.bar.width / 2).attr("stroke-width", n.bar.width + n.bar.strokeWidth).attr("stroke", e1).attr("opacity", n.bar.strokeOpacity).attr("stroke-linecap", "butt"), s.attr("y1", function(t1) {
                                return t1.height;
                            }).call(x);
                            var c = t1.selectAll(".highlight").data(o);
                            c.enter().append("line").classed("highlight", !0).attr("x", -n.bar.width / 2).attr("stroke-width", n.bar.width - n.bar.strokeWidth).attr("stroke", n.bar.fillColor).attr("opacity", n.bar.fillOpacity).attr("stroke-linecap", "butt"), c.attr("y1", function(t1) {
                                return t1.height;
                            }).call(x);
                        }(i, e1, r);
                    },
                    cleanRanges: function(t1, e1) {
                        if (Array.isArray(t1[0]) ? (t1 = t1.map(function(t1) {
                            return t1.sort(s);
                        }), t1 = e1.multiselect ? S(t1.sort(A)) : [
                            t1[0]
                        ]) : t1 = [
                            t1.sort(s)
                        ], e1.tickvals) {
                            var r = e1.tickvals.slice().sort(s);
                            if (!(t1 = t1.map(function(t1) {
                                var e1 = [
                                    p(0, r, t1[0], []),
                                    p(1, r, t1[1], [])
                                ];
                                if (e1[1] > e1[0]) return e1;
                            }).filter(function(t1) {
                                return t1;
                            })).length) return;
                        }
                        return t1.length > 1 ? t1 : t1[0];
                    }
                };
            },
            79846: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    attributes: r(59549),
                    supplyDefaults: r(12842),
                    calc: r(20113),
                    colorbar: {
                        container: "line",
                        min: "cmin",
                        max: "cmax"
                    },
                    moduleType: "trace",
                    name: "parcoords",
                    basePlotModule: r(67207),
                    categories: [
                        "gl",
                        "regl",
                        "noOpacity",
                        "noHover"
                    ],
                    meta: {}
                };
            },
            67207: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(4173).eV, a = r(58823), o = r(62972);
                e1.name = "parcoords", e1.plot = function(t1) {
                    var e1 = i(t1.calcdata, "parcoords")[0];
                    e1.length && a(t1, e1);
                }, e1.clean = function(t1, e1, r, n) {
                    var i = n._has && n._has("parcoords"), a = e1._has && e1._has("parcoords");
                    i && !a && (n._paperdiv.selectAll(".parcoords").remove(), n._glimages.selectAll("*").remove());
                }, e1.toSVG = function(t1) {
                    var e1 = t1._fullLayout._glimages, r = n.select(t1).selectAll(".svg-container");
                    r.filter(function(t1, e1) {
                        return e1 === r.size() - 1;
                    }).selectAll(".gl-canvas-context, .gl-canvas-focus").each(function() {
                        var t1 = this, r = t1.toDataURL("image/png");
                        e1.append("svg:image").attr({
                            xmlns: o.svg,
                            "xlink:href": r,
                            preserveAspectRatio: "none",
                            x: 0,
                            y: 0,
                            width: t1.style.width,
                            height: t1.style.height
                        });
                    }), window.setTimeout(function() {
                        n.selectAll("#filterBarPattern").attr("id", "filterBarPattern");
                    }, 60);
                };
            },
            20113: function(t1, e1, r) {
                "use strict";
                var n = r(34809).isArrayOrTypedArray, i = r(88856), a = r(71293).wrap;
                t1.exports = function(t1, e1) {
                    var r, o;
                    return i.hasColorscale(e1, "line") && n(e1.line.color) ? (r = e1.line.color, o = i.extractOpts(e1.line).colorscale, i.calc(t1, e1, {
                        vals: r,
                        containerStr: "line",
                        cLetter: "c"
                    })) : (r = function(t1) {
                        for(var e1 = new Array(t1), r = 0; r < t1; r++)e1[r] = .5;
                        return e1;
                    }(e1._length), o = [
                        [
                            0,
                            e1.line.color
                        ],
                        [
                            1,
                            e1.line.color
                        ]
                    ]), a({
                        lineColor: r,
                        cscale: o
                    });
                };
            },
            77911: function(t1) {
                "use strict";
                t1.exports = {
                    maxDimensionCount: 60,
                    overdrag: 45,
                    verticalPadding: 2,
                    tickDistance: 50,
                    canvasPixelRatio: 1,
                    blockLineCount: 5e3,
                    layers: [
                        "contextLineLayer",
                        "focusLineLayer",
                        "pickLineLayer"
                    ],
                    axisTitleOffset: 28,
                    axisExtentOffset: 10,
                    bar: {
                        width: 4,
                        captureWidth: 10,
                        fillColor: "magenta",
                        fillOpacity: 1,
                        snapDuration: 150,
                        snapRatio: .25,
                        snapClose: .01,
                        strokeOpacity: 1,
                        strokeWidth: 1,
                        handleHeight: 8,
                        handleOpacity: 1,
                        handleOverlap: 0
                    },
                    cn: {
                        axisExtentText: "axis-extent-text",
                        parcoordsLineLayers: "parcoords-line-layers",
                        parcoordsLineLayer: "parcoords-lines",
                        parcoords: "parcoords",
                        parcoordsControlView: "parcoords-control-view",
                        yAxis: "y-axis",
                        axisOverlays: "axis-overlays",
                        axis: "axis",
                        axisHeading: "axis-heading",
                        axisTitle: "axis-title",
                        axisExtent: "axis-extent",
                        axisExtentTop: "axis-extent-top",
                        axisExtentTopText: "axis-extent-top-text",
                        axisExtentBottom: "axis-extent-bottom",
                        axisExtentBottomText: "axis-extent-bottom-text",
                        axisBrush: "axis-brush"
                    },
                    id: {
                        filterBarPattern: "filter-bar-pattern"
                    }
                };
            },
            12842: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(65477).hasColorscale, a = r(39356), o = r(13792).N, s = r(59008), l = r(29714), c = r(59549), u = r(23245), h = r(77911).maxDimensionCount, f = r(63197);
                function p(t1, e1, r, i) {
                    function a(r, i) {
                        return n.coerce(t1, e1, c.dimensions, r, i);
                    }
                    var o = a("values"), s = a("visible");
                    if (o && o.length || (s = e1.visible = !1), s) {
                        a("label"), a("tickvals"), a("ticktext"), a("tickformat");
                        var h = a("range");
                        e1._ax = {
                            _id: "y",
                            type: "linear",
                            showexponent: "all",
                            exponentformat: "B",
                            range: h
                        }, l.setConvert(e1._ax, i.layout), a("multiselect");
                        var f = a("constraintrange");
                        f && (e1.constraintrange = u.cleanRanges(f, e1));
                    }
                }
                t1.exports = function(t1, e1, r, l) {
                    function u(r, i) {
                        return n.coerce(t1, e1, c, r, i);
                    }
                    var d = t1.dimensions;
                    Array.isArray(d) && d.length > h && (n.log("parcoords traces support up to " + h + " dimensions at the moment"), d.splice(h));
                    var m = s(t1, e1, {
                        name: "dimensions",
                        layout: l,
                        handleItemDefaults: p
                    }), g = function(t1, e1, r, o, s) {
                        var l = s("line.color", r);
                        if (i(t1, "line") && n.isArrayOrTypedArray(l)) {
                            if (l.length) return s("line.colorscale"), a(t1, e1, o, s, {
                                prefix: "line.",
                                cLetter: "c"
                            }), l.length;
                            e1.line.color = r;
                        }
                        return 1 / 0;
                    }(t1, e1, r, l, u);
                    o(e1, l, u), Array.isArray(m) && m.length || (e1.visible = !1), f(e1, m, "values", g);
                    var y = n.extendFlat({}, l.font, {
                        size: Math.round(l.font.size / 1.2)
                    });
                    n.coerceFont(u, "labelfont", y), n.coerceFont(u, "tickfont", y, {
                        autoShadowDflt: !0
                    }), n.coerceFont(u, "rangefont", y), u("labelangle"), u("labelside"), u("unselected.line.color"), u("unselected.line.opacity");
                };
            },
            62935: function(t1, e1, r) {
                "use strict";
                var n = r(34809).isTypedArray;
                e1.convertTypedArray = function(t1) {
                    return n(t1) ? Array.prototype.slice.call(t1) : t1;
                }, e1.isOrdinal = function(t1) {
                    return !!t1.tickvals;
                }, e1.isVisible = function(t1) {
                    return t1.visible || !("visible" in t1);
                };
            },
            83910: function(t1, e1, r) {
                "use strict";
                var n = r(79846);
                n.plot = r(58823), t1.exports = n;
            },
            1293: function(t1, e1, r) {
                "use strict";
                var n = [
                    "precision highp float;",
                    "",
                    "varying vec4 fragColor;",
                    "",
                    "attribute vec4 p01_04, p05_08, p09_12, p13_16,",
                    "               p17_20, p21_24, p25_28, p29_32,",
                    "               p33_36, p37_40, p41_44, p45_48,",
                    "               p49_52, p53_56, p57_60, colors;",
                    "",
                    "uniform mat4 dim0A, dim1A, dim0B, dim1B, dim0C, dim1C, dim0D, dim1D,",
                    "             loA, hiA, loB, hiB, loC, hiC, loD, hiD;",
                    "",
                    "uniform vec2 resolution, viewBoxPos, viewBoxSize;",
                    "uniform float maskHeight;",
                    "uniform float drwLayer; // 0: context, 1: focus, 2: pick",
                    "uniform vec4 contextColor;",
                    "uniform sampler2D maskTexture, palette;",
                    "",
                    "bool isPick    = (drwLayer > 1.5);",
                    "bool isContext = (drwLayer < 0.5);",
                    "",
                    "const vec4 ZEROS = vec4(0.0, 0.0, 0.0, 0.0);",
                    "const vec4 UNITS = vec4(1.0, 1.0, 1.0, 1.0);",
                    "",
                    "float val(mat4 p, mat4 v) {",
                    "    return dot(matrixCompMult(p, v) * UNITS, UNITS);",
                    "}",
                    "",
                    "float axisY(float ratio, mat4 A, mat4 B, mat4 C, mat4 D) {",
                    "    float y1 = val(A, dim0A) + val(B, dim0B) + val(C, dim0C) + val(D, dim0D);",
                    "    float y2 = val(A, dim1A) + val(B, dim1B) + val(C, dim1C) + val(D, dim1D);",
                    "    return y1 * (1.0 - ratio) + y2 * ratio;",
                    "}",
                    "",
                    "int iMod(int a, int b) {",
                    "    return a - b * (a / b);",
                    "}",
                    "",
                    "bool fOutside(float p, float lo, float hi) {",
                    "    return (lo < hi) && (lo > p || p > hi);",
                    "}",
                    "",
                    "bool vOutside(vec4 p, vec4 lo, vec4 hi) {",
                    "    return (",
                    "        fOutside(p[0], lo[0], hi[0]) ||",
                    "        fOutside(p[1], lo[1], hi[1]) ||",
                    "        fOutside(p[2], lo[2], hi[2]) ||",
                    "        fOutside(p[3], lo[3], hi[3])",
                    "    );",
                    "}",
                    "",
                    "bool mOutside(mat4 p, mat4 lo, mat4 hi) {",
                    "    return (",
                    "        vOutside(p[0], lo[0], hi[0]) ||",
                    "        vOutside(p[1], lo[1], hi[1]) ||",
                    "        vOutside(p[2], lo[2], hi[2]) ||",
                    "        vOutside(p[3], lo[3], hi[3])",
                    "    );",
                    "}",
                    "",
                    "bool outsideBoundingBox(mat4 A, mat4 B, mat4 C, mat4 D) {",
                    "    return mOutside(A, loA, hiA) ||",
                    "           mOutside(B, loB, hiB) ||",
                    "           mOutside(C, loC, hiC) ||",
                    "           mOutside(D, loD, hiD);",
                    "}",
                    "",
                    "bool outsideRasterMask(mat4 A, mat4 B, mat4 C, mat4 D) {",
                    "    mat4 pnts[4];",
                    "    pnts[0] = A;",
                    "    pnts[1] = B;",
                    "    pnts[2] = C;",
                    "    pnts[3] = D;",
                    "",
                    "    for(int i = 0; i < 4; ++i) {",
                    "        for(int j = 0; j < 4; ++j) {",
                    "            for(int k = 0; k < 4; ++k) {",
                    "                if(0 == iMod(",
                    "                    int(255.0 * texture2D(maskTexture,",
                    "                        vec2(",
                    "                            (float(i * 2 + j / 2) + 0.5) / 8.0,",
                    "                            (pnts[i][j][k] * (maskHeight - 1.0) + 1.0) / maskHeight",
                    "                        ))[3]",
                    "                    ) / int(pow(2.0, float(iMod(j * 4 + k, 8)))),",
                    "                    2",
                    "                )) return true;",
                    "            }",
                    "        }",
                    "    }",
                    "    return false;",
                    "}",
                    "",
                    "vec4 position(bool isContext, float v, mat4 A, mat4 B, mat4 C, mat4 D) {",
                    "    float x = 0.5 * sign(v) + 0.5;",
                    "    float y = axisY(x, A, B, C, D);",
                    "    float z = 1.0 - abs(v);",
                    "",
                    "    z += isContext ? 0.0 : 2.0 * float(",
                    "        outsideBoundingBox(A, B, C, D) ||",
                    "        outsideRasterMask(A, B, C, D)",
                    "    );",
                    "",
                    "    return vec4(",
                    "        2.0 * (vec2(x, y) * viewBoxSize + viewBoxPos) / resolution - 1.0,",
                    "        z,",
                    "        1.0",
                    "    );",
                    "}",
                    "",
                    "void main() {",
                    "    mat4 A = mat4(p01_04, p05_08, p09_12, p13_16);",
                    "    mat4 B = mat4(p17_20, p21_24, p25_28, p29_32);",
                    "    mat4 C = mat4(p33_36, p37_40, p41_44, p45_48);",
                    "    mat4 D = mat4(p49_52, p53_56, p57_60, ZEROS);",
                    "",
                    "    float v = colors[3];",
                    "",
                    "    gl_Position = position(isContext, v, A, B, C, D);",
                    "",
                    "    fragColor =",
                    "        isContext ? vec4(contextColor) :",
                    "        isPick ? vec4(colors.rgb, 1.0) : texture2D(palette, vec2(abs(v), 0.5));",
                    "}"
                ].join("\n"), i = [
                    "precision highp float;",
                    "",
                    "varying vec4 fragColor;",
                    "",
                    "void main() {",
                    "    gl_FragColor = fragColor;",
                    "}"
                ].join("\n"), a = r(77911).maxDimensionCount, o = r(34809), s = 1e-6, l = new Uint8Array(4), c = new Uint8Array(4), u = {
                    shape: [
                        256,
                        1
                    ],
                    format: "rgba",
                    type: "uint8",
                    mag: "nearest",
                    min: "nearest"
                };
                function h(t1, e1, r, n, i) {
                    var a = t1._gl;
                    a.enable(a.SCISSOR_TEST), a.scissor(e1, r, n, i), t1.clear({
                        color: [
                            0,
                            0,
                            0,
                            0
                        ],
                        depth: 1
                    });
                }
                function f(t1, e1, r, n, i, a) {
                    var o = a.key;
                    r.drawCompleted || (function(t1) {
                        t1.read({
                            x: 0,
                            y: 0,
                            width: 1,
                            height: 1,
                            data: l
                        });
                    }(t1), r.drawCompleted = !0), function s(l) {
                        var c = Math.min(n, i - l * n);
                        0 === l && (window.cancelAnimationFrame(r.currentRafs[o]), delete r.currentRafs[o], h(t1, a.scissorX, a.scissorY, a.scissorWidth, a.viewBoxSize[1])), r.clearOnly || (a.count = 2 * c, a.offset = 2 * l * n, e1(a), l * n + c < i && (r.currentRafs[o] = window.requestAnimationFrame(function() {
                            s(l + 1);
                        })), r.drawCompleted = !1);
                    }(0);
                }
                function p(t1, e1) {
                    for(var r = new Array(256), n = 0; n < 256; n++)r[n] = t1(n / 255).concat(e1);
                    return r;
                }
                function d(t1, e1) {
                    return (t1 >>> 8 * e1) % 256 / 255;
                }
                function m(t1, e1, r) {
                    for(var n = new Array(8 * e1), i = 0, a = 0; a < e1; a++)for(var o = 0; o < 2; o++)for(var s = 0; s < 4; s++){
                        var l = 4 * t1 + s, c = r[64 * a + l];
                        63 === l && 0 === o && (c *= -1), n[i++] = c;
                    }
                    return n;
                }
                function g(t1) {
                    var e1 = "0" + t1;
                    return e1.substr(e1.length - 2);
                }
                function y(t1) {
                    return t1 < a ? "p" + g(t1 + 1) + "_" + g(t1 + 4) : "colors";
                }
                function v(t1, e1, r, n, i, a, s, l, c, u, h, f, p, d) {
                    for(var m = [
                        [],
                        []
                    ], g = 0; g < 64; g++)m[0][g] = g === i ? 1 : 0, m[1][g] = g === a ? 1 : 0;
                    s *= d, l *= d, c *= d, u *= d;
                    var y = t1.lines.canvasOverdrag * d, v = t1.domain, x = t1.canvasWidth * d, _ = t1.canvasHeight * d, b = t1.pad.l * d, w = t1.pad.b * d, T = t1.layoutHeight * d, k = t1.layoutWidth * d, A = t1.deselectedLines.color, M = t1.deselectedLines.opacity;
                    return o.extendFlat({
                        key: h,
                        resolution: [
                            x,
                            _
                        ],
                        viewBoxPos: [
                            s + y,
                            l
                        ],
                        viewBoxSize: [
                            c,
                            u
                        ],
                        i0: i,
                        i1: a,
                        dim0A: m[0].slice(0, 16),
                        dim0B: m[0].slice(16, 32),
                        dim0C: m[0].slice(32, 48),
                        dim0D: m[0].slice(48, 64),
                        dim1A: m[1].slice(0, 16),
                        dim1B: m[1].slice(16, 32),
                        dim1C: m[1].slice(32, 48),
                        dim1D: m[1].slice(48, 64),
                        drwLayer: f,
                        contextColor: [
                            A[0] / 255,
                            A[1] / 255,
                            A[2] / 255,
                            "auto" !== M ? A[3] * M : Math.max(1 / 255, Math.pow(1 / t1.lines.color.length, 1 / 3))
                        ],
                        scissorX: (n === e1 ? 0 : s + y) + (b - y) + k * v.x[0],
                        scissorWidth: (n === r ? x - s + y : c + .5) + (n === e1 ? s + y : 0),
                        scissorY: l + w + T * v.y[0],
                        scissorHeight: u,
                        viewportX: b - y + k * v.x[0],
                        viewportY: w + T * v.y[0],
                        viewportWidth: x,
                        viewportHeight: _
                    }, p);
                }
                function x(t1) {
                    var e1 = 2047, r = Math.max(0, Math.floor(t1[0] * e1), 0), n = Math.min(e1, Math.ceil(t1[1] * e1), e1);
                    return [
                        Math.min(r, n),
                        Math.max(r, n)
                    ];
                }
                t1.exports = function(t1, e1) {
                    var r, l, g, _, b, w = e1.context, T = e1.pick, k = e1.regl, A = k._gl, M = A.getParameter(A.ALIASED_LINE_WIDTH_RANGE), S = Math.max(M[0], Math.min(M[1], e1.viewModel.plotGlPixelRatio)), E = {
                        currentRafs: {},
                        drawCompleted: !0,
                        clearOnly: !1
                    }, C = function(t1) {
                        for(var e1 = {}, r = 0; r <= a; r += 4)e1[y(r)] = t1.buffer({
                            usage: "dynamic",
                            type: "float",
                            data: new Uint8Array(0)
                        });
                        return e1;
                    }(k), L = k.texture(u), I = [];
                    z(e1);
                    var P = k({
                        profile: !1,
                        blend: {
                            enable: w,
                            func: {
                                srcRGB: "src alpha",
                                dstRGB: "one minus src alpha",
                                srcAlpha: 1,
                                dstAlpha: 1
                            },
                            equation: {
                                rgb: "add",
                                alpha: "add"
                            },
                            color: [
                                0,
                                0,
                                0,
                                0
                            ]
                        },
                        depth: {
                            enable: !w,
                            mask: !0,
                            func: "less",
                            range: [
                                0,
                                1
                            ]
                        },
                        cull: {
                            enable: !0,
                            face: "back"
                        },
                        scissor: {
                            enable: !0,
                            box: {
                                x: k.prop("scissorX"),
                                y: k.prop("scissorY"),
                                width: k.prop("scissorWidth"),
                                height: k.prop("scissorHeight")
                            }
                        },
                        viewport: {
                            x: k.prop("viewportX"),
                            y: k.prop("viewportY"),
                            width: k.prop("viewportWidth"),
                            height: k.prop("viewportHeight")
                        },
                        dither: !1,
                        vert: n,
                        frag: i,
                        primitive: "lines",
                        lineWidth: S,
                        attributes: C,
                        uniforms: {
                            resolution: k.prop("resolution"),
                            viewBoxPos: k.prop("viewBoxPos"),
                            viewBoxSize: k.prop("viewBoxSize"),
                            dim0A: k.prop("dim0A"),
                            dim1A: k.prop("dim1A"),
                            dim0B: k.prop("dim0B"),
                            dim1B: k.prop("dim1B"),
                            dim0C: k.prop("dim0C"),
                            dim1C: k.prop("dim1C"),
                            dim0D: k.prop("dim0D"),
                            dim1D: k.prop("dim1D"),
                            loA: k.prop("loA"),
                            hiA: k.prop("hiA"),
                            loB: k.prop("loB"),
                            hiB: k.prop("hiB"),
                            loC: k.prop("loC"),
                            hiC: k.prop("hiC"),
                            loD: k.prop("loD"),
                            hiD: k.prop("hiD"),
                            palette: L,
                            contextColor: k.prop("contextColor"),
                            maskTexture: k.prop("maskTexture"),
                            drwLayer: k.prop("drwLayer"),
                            maskHeight: k.prop("maskHeight")
                        },
                        offset: k.prop("offset"),
                        count: k.prop("count")
                    });
                    function z(t1) {
                        r = t1.model, l = t1.viewModel, g = l.dimensions.slice(), _ = g[0] ? g[0].values.length : 0;
                        var e1 = r.lines, n = T ? e1.color.map(function(t1, r) {
                            return r / e1.color.length;
                        }) : e1.color, i = function(t1, e1, r) {
                            for(var n, i = new Array(t1 * (a + 4)), o = 0, l = 0; l < t1; l++){
                                for(var c = 0; c < a; c++)i[o++] = c < e1.length ? e1[c].paddedUnitValues[l] : .5;
                                i[o++] = d(l, 2), i[o++] = d(l, 1), i[o++] = d(l, 0), i[o++] = (n = r[l], Math.max(s, Math.min(.999999, n)));
                            }
                            return i;
                        }(_, g, n);
                        !function(t1, e1, r) {
                            for(var n = 0; n <= a; n += 4)t1[y(n)](m(n / 4, e1, r));
                        }(C, _, i), w || T || (L = k.texture(o.extendFlat({
                            data: p(r.unitToColor, 255)
                        }, u)));
                    }
                    return {
                        render: function(t1, e1, n) {
                            var i, a, o, s = t1.length, l = 1 / 0, c = -1 / 0;
                            for(i = 0; i < s; i++)t1[i].dim0.canvasX < l && (l = t1[i].dim0.canvasX, a = i), t1[i].dim1.canvasX > c && (c = t1[i].dim1.canvasX, o = i);
                            0 === s && h(k, 0, 0, r.canvasWidth, r.canvasHeight);
                            var u = function(t1) {
                                var e1, r, n, i = [
                                    [],
                                    []
                                ];
                                for(n = 0; n < 64; n++){
                                    var a = !t1 && n < g.length ? g[n].brush.filter.getBounds() : [
                                        -1 / 0,
                                        1 / 0
                                    ];
                                    i[0][n] = a[0], i[1][n] = a[1];
                                }
                                var o = new Array(16384);
                                for(e1 = 0; e1 < 16384; e1++)o[e1] = 255;
                                if (!t1) for(e1 = 0; e1 < g.length; e1++){
                                    var s = e1 % 8, l = (e1 - s) / 8, c = Math.pow(2, s), u = g[e1].brush.filter.get();
                                    if (!(u.length < 2)) {
                                        var h = x(u[0])[1];
                                        for(r = 1; r < u.length; r++){
                                            var f = x(u[r]);
                                            for(n = h + 1; n < f[0]; n++)o[8 * n + l] &= ~c;
                                            h = Math.max(h, f[1]);
                                        }
                                    }
                                }
                                var p = {
                                    shape: [
                                        8,
                                        2048
                                    ],
                                    format: "alpha",
                                    type: "uint8",
                                    mag: "nearest",
                                    min: "nearest",
                                    data: o
                                };
                                return b ? b(p) : b = k.texture(p), {
                                    maskTexture: b,
                                    maskHeight: 2048,
                                    loA: i[0].slice(0, 16),
                                    loB: i[0].slice(16, 32),
                                    loC: i[0].slice(32, 48),
                                    loD: i[0].slice(48, 64),
                                    hiA: i[1].slice(0, 16),
                                    hiB: i[1].slice(16, 32),
                                    hiC: i[1].slice(32, 48),
                                    hiD: i[1].slice(48, 64)
                                };
                            }(w);
                            for(i = 0; i < s; i++){
                                var p = t1[i], d = p.dim0.crossfilterDimensionIndex, m = p.dim1.crossfilterDimensionIndex, y = p.canvasX, A = p.canvasY, M = y + p.panelSizeX, S = p.plotGlPixelRatio;
                                if (e1 || !I[d] || I[d][0] !== y || I[d][1] !== M) {
                                    I[d] = [
                                        y,
                                        M
                                    ];
                                    var C = v(r, a, o, i, d, m, y, A, p.panelSizeX, p.panelSizeY, p.dim0.crossfilterDimensionIndex, w ? 0 : T ? 2 : 1, u, S);
                                    E.clearOnly = n;
                                    var L = e1 ? r.lines.blockLineCount : _;
                                    f(k, P, E, L, _, C);
                                }
                            }
                        },
                        readPixel: function(t1, e1) {
                            return k.read({
                                x: t1,
                                y: e1,
                                width: 1,
                                height: 1,
                                data: c
                            }), c;
                        },
                        readPixels: function(t1, e1, r, n) {
                            var i = new Uint8Array(4 * r * n);
                            return k.read({
                                x: t1,
                                y: e1,
                                width: r,
                                height: n,
                                data: i
                            }), i;
                        },
                        destroy: function() {
                            for(var e1 in t1.style["pointer-events"] = "none", L.destroy(), b && b.destroy(), C)C[e1].destroy();
                        },
                        update: z
                    };
                };
            },
            63197: function(t1) {
                "use strict";
                t1.exports = function(t1, e1, r, n) {
                    var i, a;
                    for(n || (n = 1 / 0), i = 0; i < e1.length; i++)(a = e1[i]).visible && (n = Math.min(n, a[r].length));
                    for(n === 1 / 0 && (n = 0), t1._length = n, i = 0; i < e1.length; i++)(a = e1[i]).visible && (a._length = n);
                    return n;
                };
            },
            16019: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(34809), a = i.isArrayOrTypedArray, o = i.numberFormat, s = r(16401), l = r(29714), c = i.strRotate, u = i.strTranslate, h = r(30635), f = r(62203), p = r(88856), d = r(71293), m = d.keyFun, g = d.repeat, y = d.unwrap, v = r(62935), x = r(77911), _ = r(23245), b = r(1293);
                function w(t1, e1, r) {
                    return i.aggNums(t1, null, e1, r);
                }
                function T(t1, e1) {
                    return A(w(Math.min, t1, e1), w(Math.max, t1, e1));
                }
                function k(t1) {
                    var e1 = t1.range;
                    return e1 ? A(e1[0], e1[1]) : T(t1.values, t1._length);
                }
                function A(t1, e1) {
                    return !isNaN(t1) && isFinite(t1) || (t1 = 0), !isNaN(e1) && isFinite(e1) || (e1 = 0), t1 === e1 && (0 === t1 ? (t1 -= 1, e1 += 1) : (t1 *= .9, e1 *= 1.1)), [
                        t1,
                        e1
                    ];
                }
                function M(t1, e1, r, i, a) {
                    var s, l, c = k(r);
                    return i ? n.scale.ordinal().domain(i.map((s = o(r.tickformat), l = a, l ? function(t1, e1) {
                        var r = l[e1];
                        return null == r ? s(t1) : r;
                    } : s))).range(i.map(function(r) {
                        var n = (r - c[0]) / (c[1] - c[0]);
                        return t1 - e1 + n * (2 * e1 - t1);
                    })) : n.scale.linear().domain(c).range([
                        t1 - e1,
                        e1
                    ]);
                }
                function S(t1) {
                    if (t1.tickvals) {
                        var e1 = k(t1);
                        return n.scale.ordinal().domain(t1.tickvals).range(t1.tickvals.map(function(t1) {
                            return (t1 - e1[0]) / (e1[1] - e1[0]);
                        }));
                    }
                }
                function E(t1) {
                    var e1 = t1.map(function(t1) {
                        return t1[0];
                    }), r = t1.map(function(t1) {
                        var e1 = s(t1[1]);
                        return n.rgb("rgb(" + e1[0] + "," + e1[1] + "," + e1[2] + ")");
                    }), i = "rgb".split("").map(function(t1) {
                        var i;
                        return n.scale.linear().clamp(!0).domain(e1).range(r.map((i = t1, function(t1) {
                            return t1[i];
                        })));
                    });
                    return function(t1) {
                        return i.map(function(e1) {
                            return e1(t1);
                        });
                    };
                }
                function C(t1) {
                    return t1.dimensions.some(function(t1) {
                        return t1.brush.filterSpecified;
                    });
                }
                function L(t1, e1, r) {
                    var a = y(e1), o = a.trace, l = v.convertTypedArray(a.lineColor), c = o.line, u = {
                        color: s(o.unselected.line.color),
                        opacity: o.unselected.line.opacity
                    }, h = p.extractOpts(c), f = h.reversescale ? p.flipScale(a.cscale) : a.cscale, d = o.domain, m = o.dimensions, g = t1.width, _ = o.labelangle, b = o.labelside, w = o.labelfont, T = o.tickfont, A = o.rangefont, M = i.extendDeepNoArrays({}, c, {
                        color: l.map(n.scale.linear().domain(k({
                            values: l,
                            range: [
                                h.min,
                                h.max
                            ],
                            _length: o._length
                        }))),
                        blockLineCount: x.blockLineCount,
                        canvasOverdrag: x.overdrag * x.canvasPixelRatio
                    }), S = Math.floor(g * (d.x[1] - d.x[0])), C = Math.floor(t1.height * (d.y[1] - d.y[0])), L = t1.margin || {
                        l: 80,
                        r: 80,
                        t: 100,
                        b: 80
                    }, I = S, P = C;
                    return {
                        key: r,
                        colCount: m.filter(v.isVisible).length,
                        dimensions: m,
                        tickDistance: x.tickDistance,
                        unitToColor: E(f),
                        lines: M,
                        deselectedLines: u,
                        labelAngle: _,
                        labelSide: b,
                        labelFont: w,
                        tickFont: T,
                        rangeFont: A,
                        layoutWidth: g,
                        layoutHeight: t1.height,
                        domain: d,
                        translateX: d.x[0] * g,
                        translateY: t1.height - d.y[1] * t1.height,
                        pad: L,
                        canvasWidth: I * x.canvasPixelRatio + 2 * M.canvasOverdrag,
                        canvasHeight: P * x.canvasPixelRatio,
                        width: I,
                        height: P,
                        canvasPixelRatio: x.canvasPixelRatio
                    };
                }
                function I(t1, e1, r) {
                    var s = r.width, l = r.height, c = r.dimensions, u = r.canvasPixelRatio, h = function(t1) {
                        return s * t1 / Math.max(1, r.colCount - 1);
                    }, f = x.verticalPadding / l, p = function(t1, e1) {
                        return n.scale.linear().range([
                            e1,
                            t1 - e1
                        ]);
                    }(l, x.verticalPadding), d = {
                        key: r.key,
                        xScale: h,
                        model: r,
                        inBrushDrag: !1
                    }, m = {};
                    return d.dimensions = c.filter(v.isVisible).map(function(s, c) {
                        var g = function(t1, e1) {
                            return n.scale.linear().domain(k(t1)).range([
                                e1,
                                1 - e1
                            ]);
                        }(s, f), y = m[s.label];
                        m[s.label] = (y || 0) + 1;
                        var b = s.label + (y ? "__" + y : ""), w = s.constraintrange, T = w && w.length;
                        T && !a(w[0]) && (w = [
                            w
                        ]);
                        var A = T ? w.map(function(t1) {
                            return t1.map(g);
                        }) : [
                            [
                                -1 / 0,
                                1 / 0
                            ]
                        ], E = s.values;
                        E.length > s._length && (E = E.slice(0, s._length));
                        var L, I = s.tickvals;
                        function P(t1, e1) {
                            return {
                                val: t1,
                                text: L[e1]
                            };
                        }
                        function z(t1, e1) {
                            return t1.val - e1.val;
                        }
                        if (a(I) && I.length) {
                            i.isTypedArray(I) && (I = Array.from(I)), L = s.ticktext, a(L) && L.length ? L.length > I.length ? L = L.slice(0, I.length) : I.length > L.length && (I = I.slice(0, L.length)) : L = I.map(o(s.tickformat));
                            for(var O = 1; O < I.length; O++)if (I[O] < I[O - 1]) {
                                for(var D = I.map(P).sort(z), R = 0; R < I.length; R++)I[R] = D[R].val, L[R] = D[R].text;
                                break;
                            }
                        } else I = void 0;
                        return E = v.convertTypedArray(E), {
                            key: b,
                            label: s.label,
                            tickFormat: s.tickformat,
                            tickvals: I,
                            ticktext: L,
                            ordinal: v.isOrdinal(s),
                            multiselect: s.multiselect,
                            xIndex: c,
                            crossfilterDimensionIndex: c,
                            visibleIndex: s._index,
                            height: l,
                            values: E,
                            paddedUnitValues: E.map(g),
                            unitTickvals: I && I.map(g),
                            xScale: h,
                            x: h(c),
                            canvasX: h(c) * u,
                            unitToPaddedPx: p,
                            domainScale: M(l, x.verticalPadding, s, I, L),
                            ordinalScale: S(s),
                            parent: d,
                            model: r,
                            brush: _.makeBrush(t1, T, A, function() {
                                t1.linePickActive(!1);
                            }, function() {
                                var e1 = d;
                                e1.focusLayer && e1.focusLayer.render(e1.panels, !0);
                                var r = C(e1);
                                !t1.contextShown() && r ? (e1.contextLayer && e1.contextLayer.render(e1.panels, !0), t1.contextShown(!0)) : t1.contextShown() && !r && (e1.contextLayer && e1.contextLayer.render(e1.panels, !0, !0), t1.contextShown(!1));
                            }, function(r) {
                                if (d.focusLayer.render(d.panels, !0), d.pickLayer && d.pickLayer.render(d.panels, !0), t1.linePickActive(!0), e1 && e1.filterChanged) {
                                    var n = g.invert, a = r.map(function(t1) {
                                        return t1.map(n).sort(i.sorterAsc);
                                    }).sort(function(t1, e1) {
                                        return t1[0] - e1[0];
                                    });
                                    e1.filterChanged(d.key, s._index, a);
                                }
                            })
                        };
                    }), d;
                }
                function P(t1) {
                    t1.classed(x.cn.axisExtentText, !0).attr("text-anchor", "middle").style("cursor", "default");
                }
                function z(t1, e1) {
                    var r = "top" === e1 ? 1 : -1, n = t1 * Math.PI / 180;
                    return {
                        dir: r,
                        dx: Math.sin(n),
                        dy: Math.cos(n),
                        degrees: t1
                    };
                }
                function O(t1, e1, r) {
                    for(var n = e1.panels || (e1.panels = []), i = t1.data(), a = 0; a < i.length - 1; a++){
                        var o = n[a] || (n[a] = {}), s = i[a], l = i[a + 1];
                        o.dim0 = s, o.dim1 = l, o.canvasX = s.canvasX, o.panelSizeX = l.canvasX - s.canvasX, o.panelSizeY = e1.model.canvasHeight, o.y = 0, o.canvasY = 0, o.plotGlPixelRatio = r;
                    }
                }
                function D(t1, e1) {
                    return l.tickText(t1._ax, e1, !1).text;
                }
                function R(t1, e1) {
                    if (t1.ordinal) return "";
                    var r = t1.domainScale.domain(), n = r[e1 ? r.length - 1 : 0];
                    return D(t1.model.dimensions[t1.visibleIndex], n);
                }
                t1.exports = function(t1, e1, r, a) {
                    var o = t1._context.staticPlot, s = t1._fullLayout, p = s._toppaper, d = s._glcontainer, w = t1._context.plotGlPixelRatio, k = t1._fullLayout.paper_bgcolor;
                    !function(t1) {
                        for(var e1 = 0; e1 < t1.length; e1++)for(var r = 0; r < t1[e1].length; r++)for(var n = t1[e1][r].trace, i = n.dimensions, a = 0; a < i.length; a++){
                            var o = i[a].values, s = i[a]._ax;
                            s && (s.range ? s.range = A(s.range[0], s.range[1]) : s.range = T(o, n._length), s.dtick || (s.dtick = .01 * (Math.abs(s.range[1] - s.range[0]) || 1)), s.tickformat = i[a].tickformat, l.calcTicks(s), s.cleanRange());
                        }
                    }(e1);
                    var M, S, E = (M = !0, S = !1, {
                        linePickActive: function(t1) {
                            return arguments.length ? M = !!t1 : M;
                        },
                        contextShown: function(t1) {
                            return arguments.length ? S = !!t1 : S;
                        }
                    }), F = e1.filter(function(t1) {
                        return y(t1).trace.visible;
                    }).map(L.bind(0, r)).map(I.bind(0, E, a));
                    d.each(function(t1, e1) {
                        return i.extendFlat(t1, F[e1]);
                    });
                    var B = d.selectAll(".gl-canvas").each(function(t1) {
                        t1.viewModel = F[0], t1.viewModel.plotGlPixelRatio = w, t1.viewModel.paperColor = k, t1.model = t1.viewModel ? t1.viewModel.model : null;
                    }), N = null;
                    B.filter(function(t1) {
                        return t1.pick;
                    }).style("pointer-events", o ? "none" : "auto").on("mousemove", function(t1) {
                        if (E.linePickActive() && t1.lineLayer && a && a.hover) {
                            var e1 = n.event, r = this.width, i = this.height, o = n.mouse(this), s = o[0], l = o[1];
                            if (s < 0 || l < 0 || s >= r || l >= i) return;
                            var c = t1.lineLayer.readPixel(s, i - 1 - l), u = 0 !== c[3], h = u ? c[2] + 256 * (c[1] + 256 * c[0]) : null, f = {
                                x: s,
                                y: l,
                                clientX: e1.clientX,
                                clientY: e1.clientY,
                                dataIndex: t1.model.key,
                                curveNumber: h
                            };
                            h !== N && (u ? a.hover(f) : a.unhover && a.unhover(f), N = h);
                        }
                    }), B.style("opacity", function(t1) {
                        return t1.pick ? 0 : 1;
                    }), p.style("background", "rgba(255, 255, 255, 0)");
                    var j = p.selectAll("." + x.cn.parcoords).data(F, m);
                    j.exit().remove(), j.enter().append("g").classed(x.cn.parcoords, !0).style("shape-rendering", "crispEdges").style("pointer-events", "none"), j.attr("transform", function(t1) {
                        return u(t1.model.translateX, t1.model.translateY);
                    });
                    var U = j.selectAll("." + x.cn.parcoordsControlView).data(g, m);
                    U.enter().append("g").classed(x.cn.parcoordsControlView, !0), U.attr("transform", function(t1) {
                        return u(t1.model.pad.l, t1.model.pad.t);
                    });
                    var V = U.selectAll("." + x.cn.yAxis).data(function(t1) {
                        return t1.dimensions;
                    }, m);
                    V.enter().append("g").classed(x.cn.yAxis, !0), U.each(function(t1) {
                        O(V, t1, w);
                    }), B.each(function(t1) {
                        if (t1.viewModel) {
                            !t1.lineLayer || a ? t1.lineLayer = b(this, t1) : t1.lineLayer.update(t1), (t1.key || 0 === t1.key) && (t1.viewModel[t1.key] = t1.lineLayer);
                            var e1 = !t1.context || a;
                            t1.lineLayer.render(t1.viewModel.panels, e1);
                        }
                    }), V.attr("transform", function(t1) {
                        return u(t1.xScale(t1.xIndex), 0);
                    }), V.call(n.behavior.drag().origin(function(t1) {
                        return t1;
                    }).on("drag", function(t1) {
                        var e1 = t1.parent;
                        E.linePickActive(!1), t1.x = Math.max(-x.overdrag, Math.min(t1.model.width + x.overdrag, n.event.x)), t1.canvasX = t1.x * t1.model.canvasPixelRatio, V.sort(function(t1, e1) {
                            return t1.x - e1.x;
                        }).each(function(e1, r) {
                            e1.xIndex = r, e1.x = t1 === e1 ? e1.x : e1.xScale(e1.xIndex), e1.canvasX = e1.x * e1.model.canvasPixelRatio;
                        }), O(V, e1, w), V.filter(function(e1) {
                            return 0 !== Math.abs(t1.xIndex - e1.xIndex);
                        }).attr("transform", function(t1) {
                            return u(t1.xScale(t1.xIndex), 0);
                        }), n.select(this).attr("transform", u(t1.x, 0)), V.each(function(r, n, i) {
                            i === t1.parent.key && (e1.dimensions[n] = r);
                        }), e1.contextLayer && e1.contextLayer.render(e1.panels, !1, !C(e1)), e1.focusLayer.render && e1.focusLayer.render(e1.panels);
                    }).on("dragend", function(t1) {
                        var e1 = t1.parent;
                        t1.x = t1.xScale(t1.xIndex), t1.canvasX = t1.x * t1.model.canvasPixelRatio, O(V, e1, w), n.select(this).attr("transform", function(t1) {
                            return u(t1.x, 0);
                        }), e1.contextLayer && e1.contextLayer.render(e1.panels, !1, !C(e1)), e1.focusLayer && e1.focusLayer.render(e1.panels), e1.pickLayer && e1.pickLayer.render(e1.panels, !0), E.linePickActive(!0), a && a.axesMoved && a.axesMoved(e1.key, e1.dimensions.map(function(t1) {
                            return t1.crossfilterDimensionIndex;
                        }));
                    })), V.exit().remove();
                    var q = V.selectAll("." + x.cn.axisOverlays).data(g, m);
                    q.enter().append("g").classed(x.cn.axisOverlays, !0), q.selectAll("." + x.cn.axis).remove();
                    var H = q.selectAll("." + x.cn.axis).data(g, m);
                    H.enter().append("g").classed(x.cn.axis, !0), H.each(function(t1) {
                        var e1 = t1.model.height / t1.model.tickDistance, r = t1.domainScale, i = r.domain();
                        n.select(this).call(n.svg.axis().orient("left").tickSize(4).outerTickSize(2).ticks(e1, t1.tickFormat).tickValues(t1.ordinal ? i : null).tickFormat(function(e1) {
                            return v.isOrdinal(t1) ? e1 : D(t1.model.dimensions[t1.visibleIndex], e1);
                        }).scale(r)), f.font(H.selectAll("text"), t1.model.tickFont);
                    }), H.selectAll(".domain, .tick>line").attr("fill", "none").attr("stroke", "black").attr("stroke-opacity", .25).attr("stroke-width", "1px"), H.selectAll("text").style("cursor", "default");
                    var G = q.selectAll("." + x.cn.axisHeading).data(g, m);
                    G.enter().append("g").classed(x.cn.axisHeading, !0);
                    var Z = G.selectAll("." + x.cn.axisTitle).data(g, m);
                    Z.enter().append("text").classed(x.cn.axisTitle, !0).attr("text-anchor", "middle").style("cursor", "ew-resize").style("pointer-events", o ? "none" : "auto"), Z.text(function(t1) {
                        return t1.label;
                    }).each(function(e1) {
                        var r = n.select(this);
                        f.font(r, e1.model.labelFont), h.convertToTspans(r, t1);
                    }).attr("transform", function(t1) {
                        var e1 = z(t1.model.labelAngle, t1.model.labelSide), r = x.axisTitleOffset;
                        return (e1.dir > 0 ? "" : u(0, 2 * r + t1.model.height)) + c(e1.degrees) + u(-r * e1.dx, -r * e1.dy);
                    }).attr("text-anchor", function(t1) {
                        var e1 = z(t1.model.labelAngle, t1.model.labelSide);
                        return 2 * Math.abs(e1.dx) > Math.abs(e1.dy) ? e1.dir * e1.dx < 0 ? "start" : "end" : "middle";
                    });
                    var W = q.selectAll("." + x.cn.axisExtent).data(g, m);
                    W.enter().append("g").classed(x.cn.axisExtent, !0);
                    var Y = W.selectAll("." + x.cn.axisExtentTop).data(g, m);
                    Y.enter().append("g").classed(x.cn.axisExtentTop, !0), Y.attr("transform", u(0, -x.axisExtentOffset));
                    var X = Y.selectAll("." + x.cn.axisExtentTopText).data(g, m);
                    X.enter().append("text").classed(x.cn.axisExtentTopText, !0).call(P), X.text(function(t1) {
                        return R(t1, !0);
                    }).each(function(t1) {
                        f.font(n.select(this), t1.model.rangeFont);
                    });
                    var $ = W.selectAll("." + x.cn.axisExtentBottom).data(g, m);
                    $.enter().append("g").classed(x.cn.axisExtentBottom, !0), $.attr("transform", function(t1) {
                        return u(0, t1.model.height + x.axisExtentOffset);
                    });
                    var J = $.selectAll("." + x.cn.axisExtentBottomText).data(g, m);
                    J.enter().append("text").classed(x.cn.axisExtentBottomText, !0).attr("dy", "0.75em").call(P), J.text(function(t1) {
                        return R(t1, !1);
                    }).each(function(t1) {
                        f.font(n.select(this), t1.model.rangeFont);
                    }), _.ensureAxisBrush(q, k, t1);
                };
            },
            58823: function(t1, e1, r) {
                "use strict";
                var n = r(16019), i = r(22459), a = r(62935).isVisible, o = {};
                function s(t1, e1, r) {
                    var n = e1.indexOf(r), i = t1.indexOf(n);
                    return -1 === i && (i += e1.length), i;
                }
                (t1.exports = function(t1, e1) {
                    var r = t1._fullLayout;
                    if (i(t1, [], o)) {
                        var l = {}, c = {}, u = {}, h = {}, f = r._size;
                        e1.forEach(function(e1, r) {
                            var n = e1[0].trace;
                            u[r] = n.index;
                            var i = h[r] = n._fullInput.index;
                            l[r] = t1.data[i].dimensions, c[r] = t1.data[i].dimensions.slice();
                        }), n(t1, e1, {
                            width: f.w,
                            height: f.h,
                            margin: {
                                t: f.t,
                                r: f.r,
                                b: f.b,
                                l: f.l
                            }
                        }, {
                            filterChanged: function(e1, n, i) {
                                var a = c[e1][n], o = i.map(function(t1) {
                                    return t1.slice();
                                }), s = "dimensions[" + n + "].constraintrange", l = r._tracePreGUI[t1._fullData[u[e1]]._fullInput.uid];
                                if (void 0 === l[s]) {
                                    var f = a.constraintrange;
                                    l[s] = f || null;
                                }
                                var p = t1._fullData[u[e1]].dimensions[n];
                                o.length ? (1 === o.length && (o = o[0]), a.constraintrange = o, p.constraintrange = o.slice(), o = [
                                    o
                                ]) : (delete a.constraintrange, delete p.constraintrange, o = null);
                                var d = {};
                                d[s] = o, t1.emit("plotly_restyle", [
                                    d,
                                    [
                                        h[e1]
                                    ]
                                ]);
                            },
                            hover: function(e1) {
                                t1.emit("plotly_hover", e1);
                            },
                            unhover: function(e1) {
                                t1.emit("plotly_unhover", e1);
                            },
                            axesMoved: function(e1, r) {
                                var n = function(t1, e1) {
                                    return function(r, n) {
                                        return s(t1, e1, r) - s(t1, e1, n);
                                    };
                                }(r, c[e1].filter(a));
                                l[e1].sort(n), c[e1].filter(function(t1) {
                                    return !a(t1);
                                }).sort(function(t1) {
                                    return c[e1].indexOf(t1);
                                }).forEach(function(t1) {
                                    l[e1].splice(l[e1].indexOf(t1), 1), l[e1].splice(c[e1].indexOf(t1), 0, t1);
                                }), t1.emit("plotly_restyle", [
                                    {
                                        dimensions: [
                                            l[e1]
                                        ]
                                    },
                                    [
                                        h[e1]
                                    ]
                                ]);
                            }
                        });
                    }
                }).reglPrecompiled = o;
            },
            55412: function(t1, e1, r) {
                "use strict";
                var n = r(9829), i = r(13792).u, a = r(80337), o = r(10229), s = r(3208).rb, l = r(3208).ay, c = r(93049).extendFlat, u = r(94850).k, h = a({
                    editType: "plot",
                    arrayOk: !0,
                    colorEditType: "plot"
                });
                t1.exports = {
                    labels: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    label0: {
                        valType: "number",
                        dflt: 0,
                        editType: "calc"
                    },
                    dlabel: {
                        valType: "number",
                        dflt: 1,
                        editType: "calc"
                    },
                    values: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    marker: {
                        colors: {
                            valType: "data_array",
                            editType: "calc"
                        },
                        line: {
                            color: {
                                valType: "color",
                                dflt: o.defaultLine,
                                arrayOk: !0,
                                editType: "style"
                            },
                            width: {
                                valType: "number",
                                min: 0,
                                dflt: 0,
                                arrayOk: !0,
                                editType: "style"
                            },
                            editType: "calc"
                        },
                        pattern: u,
                        editType: "calc"
                    },
                    text: {
                        valType: "data_array",
                        editType: "plot"
                    },
                    hovertext: {
                        valType: "string",
                        dflt: "",
                        arrayOk: !0,
                        editType: "style"
                    },
                    scalegroup: {
                        valType: "string",
                        dflt: "",
                        editType: "calc"
                    },
                    textinfo: {
                        valType: "flaglist",
                        flags: [
                            "label",
                            "text",
                            "value",
                            "percent"
                        ],
                        extras: [
                            "none"
                        ],
                        editType: "calc"
                    },
                    hoverinfo: c({}, n.hoverinfo, {
                        flags: [
                            "label",
                            "text",
                            "value",
                            "percent",
                            "name"
                        ]
                    }),
                    hovertemplate: s({}, {
                        keys: [
                            "label",
                            "color",
                            "value",
                            "percent",
                            "text"
                        ]
                    }),
                    texttemplate: l({
                        editType: "plot"
                    }, {
                        keys: [
                            "label",
                            "color",
                            "value",
                            "percent",
                            "text"
                        ]
                    }),
                    textposition: {
                        valType: "enumerated",
                        values: [
                            "inside",
                            "outside",
                            "auto",
                            "none"
                        ],
                        dflt: "auto",
                        arrayOk: !0,
                        editType: "plot"
                    },
                    textfont: c({}, h, {}),
                    insidetextorientation: {
                        valType: "enumerated",
                        values: [
                            "horizontal",
                            "radial",
                            "tangential",
                            "auto"
                        ],
                        dflt: "auto",
                        editType: "plot"
                    },
                    insidetextfont: c({}, h, {}),
                    outsidetextfont: c({}, h, {}),
                    automargin: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "plot"
                    },
                    title: {
                        text: {
                            valType: "string",
                            dflt: "",
                            editType: "plot"
                        },
                        font: c({}, h, {}),
                        position: {
                            valType: "enumerated",
                            values: [
                                "top left",
                                "top center",
                                "top right",
                                "middle center",
                                "bottom left",
                                "bottom center",
                                "bottom right"
                            ],
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    domain: i({
                        name: "pie",
                        trace: !0,
                        editType: "calc"
                    }),
                    hole: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 0,
                        editType: "calc"
                    },
                    sort: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    },
                    direction: {
                        valType: "enumerated",
                        values: [
                            "clockwise",
                            "counterclockwise"
                        ],
                        dflt: "counterclockwise",
                        editType: "calc"
                    },
                    rotation: {
                        valType: "angle",
                        dflt: 0,
                        editType: "calc"
                    },
                    pull: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 0,
                        arrayOk: !0,
                        editType: "calc"
                    },
                    _deprecated: {
                        title: {
                            valType: "string",
                            dflt: "",
                            editType: "calc"
                        },
                        titlefont: c({}, h, {}),
                        titleposition: {
                            valType: "enumerated",
                            values: [
                                "top left",
                                "top center",
                                "top right",
                                "middle center",
                                "bottom left",
                                "bottom center",
                                "bottom right"
                            ],
                            editType: "calc"
                        }
                    }
                };
            },
            96052: function(t1, e1, r) {
                "use strict";
                var n = r(44122);
                e1.name = "pie", e1.plot = function(t1, r, i, a) {
                    n.plotBasePlot(e1.name, t1, r, i, a);
                }, e1.clean = function(t1, r, i, a) {
                    n.cleanBasePlot(e1.name, t1, r, i, a);
                };
            },
            44148: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(65657), a = r(78766), o = {};
                function s(t1) {
                    return function(e1, r) {
                        return !!e1 && !!(e1 = i(e1)).isValid() && (e1 = a.addOpacity(e1, e1.getAlpha()), t1[r] || (t1[r] = e1), e1);
                    };
                }
                function l(t1, e1) {
                    var r, n = JSON.stringify(t1), a = e1[n];
                    if (!a) {
                        for(a = t1.slice(), r = 0; r < t1.length; r++)a.push(i(t1[r]).lighten(20).toHexString());
                        for(r = 0; r < t1.length; r++)a.push(i(t1[r]).darken(20).toHexString());
                        e1[n] = a;
                    }
                    return a;
                }
                t1.exports = {
                    calc: function(t1, e1) {
                        var r, i, a = [], o = t1._fullLayout, l = o.hiddenlabels || [], c = e1.labels, u = e1.marker.colors || [], h = e1.values, f = e1._length, p = e1._hasValues && f;
                        if (e1.dlabel) for(c = new Array(f), r = 0; r < f; r++)c[r] = String(e1.label0 + r * e1.dlabel);
                        var d = {}, m = s(o["_" + e1.type + "colormap"]), g = 0, y = !1;
                        for(r = 0; r < f; r++){
                            var v, x, _;
                            if (p) {
                                if (v = h[r], !n(v)) continue;
                                v = +v;
                            } else v = 1;
                            void 0 !== (x = c[r]) && "" !== x || (x = r);
                            var b = d[x = String(x)];
                            void 0 === b ? (d[x] = a.length, (_ = -1 !== l.indexOf(x)) || (g += v), a.push({
                                v: v,
                                label: x,
                                color: m(u[r], x),
                                i: r,
                                pts: [
                                    r
                                ],
                                hidden: _
                            })) : (y = !0, (i = a[b]).v += v, i.pts.push(r), i.hidden || (g += v), !1 === i.color && u[r] && (i.color = m(u[r], x)));
                        }
                        return a = a.filter(function(t1) {
                            return t1.v >= 0;
                        }), ("funnelarea" === e1.type ? y : e1.sort) && a.sort(function(t1, e1) {
                            return e1.v - t1.v;
                        }), a[0] && (a[0].vTotal = g), a;
                    },
                    crossTraceCalc: function(t1, e1) {
                        var r = (e1 || {}).type;
                        r || (r = "pie");
                        var n = t1._fullLayout, i = t1.calcdata, a = n[r + "colorway"], s = n["_" + r + "colormap"];
                        n["extend" + r + "colors"] && (a = l(a, o));
                        for(var c = 0, u = 0; u < i.length; u++){
                            var h = i[u];
                            if (h[0].trace.type === r) for(var f = 0; f < h.length; f++){
                                var p = h[f];
                                !1 === p.color && (s[p.label] ? p.color = s[p.label] : (s[p.label] = p.color = a[c % a.length], c++));
                            }
                        }
                    },
                    makePullColorFn: s,
                    generateExtendedColors: l
                };
            },
            46979: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(34809), a = r(55412), o = r(13792).N, s = r(17550).handleText, l = r(34809).coercePattern;
                function c(t1, e1) {
                    var r = i.isArrayOrTypedArray(t1), a = i.isArrayOrTypedArray(e1), o = Math.min(r ? t1.length : 1 / 0, a ? e1.length : 1 / 0);
                    if (isFinite(o) || (o = 0), o && a) {
                        for(var s, l = 0; l < o; l++){
                            var c = e1[l];
                            if (n(c) && c > 0) {
                                s = !0;
                                break;
                            }
                        }
                        s || (o = 0);
                    }
                    return {
                        hasLabels: r,
                        hasValues: a,
                        len: o
                    };
                }
                function u(t1, e1, r, n, i) {
                    n("marker.line.width") && n("marker.line.color", i ? void 0 : r.paper_bgcolor);
                    var a = n("marker.colors");
                    l(n, "marker.pattern", a), t1.marker && !e1.marker.pattern.fgcolor && (e1.marker.pattern.fgcolor = t1.marker.colors), e1.marker.pattern.bgcolor || (e1.marker.pattern.bgcolor = r.paper_bgcolor);
                }
                t1.exports = {
                    handleLabelsAndValues: c,
                    handleMarkerDefaults: u,
                    supplyDefaults: function(t1, e1, r, n) {
                        function l(r, n) {
                            return i.coerce(t1, e1, a, r, n);
                        }
                        var h = c(l("labels"), l("values")), f = h.len;
                        if (e1._hasLabels = h.hasLabels, e1._hasValues = h.hasValues, !e1._hasLabels && e1._hasValues && (l("label0"), l("dlabel")), f) {
                            e1._length = f, u(t1, e1, n, l, !0), l("scalegroup");
                            var p, d = l("text"), m = l("texttemplate");
                            if (m || (p = l("textinfo", i.isArrayOrTypedArray(d) ? "text+percent" : "percent")), l("hovertext"), l("hovertemplate"), m || p && "none" !== p) {
                                var g = l("textposition");
                                s(t1, e1, n, l, g, {
                                    moduleHasSelected: !1,
                                    moduleHasUnselected: !1,
                                    moduleHasConstrain: !1,
                                    moduleHasCliponaxis: !1,
                                    moduleHasTextangle: !1,
                                    moduleHasInsideanchor: !1
                                }), (Array.isArray(g) || "auto" === g || "outside" === g) && l("automargin"), ("inside" === g || "auto" === g || Array.isArray(g)) && l("insidetextorientation");
                            } else "none" === p && l("textposition", "none");
                            o(e1, n, l);
                            var y = l("hole");
                            if (l("title.text")) {
                                var v = l("title.position", y ? "middle center" : "top center");
                                y || "middle center" !== v || (e1.title.position = "top center"), i.coerceFont(l, "title.font", n.font);
                            }
                            l("sort"), l("direction"), l("rotation"), l("pull");
                        } else e1.visible = !1;
                    }
                };
            },
            50568: function(t1, e1, r) {
                "use strict";
                var n = r(36040).appendArrayMultiPointValues;
                t1.exports = function(t1, e1) {
                    var r = {
                        curveNumber: e1.index,
                        pointNumbers: t1.pts,
                        data: e1._input,
                        fullData: e1,
                        label: t1.label,
                        color: t1.color,
                        value: t1.v,
                        percent: t1.percent,
                        text: t1.text,
                        bbox: t1.bbox,
                        v: t1.v
                    };
                    return 1 === t1.pts.length && (r.pointNumber = r.i = t1.pts[0]), n(r, e1, t1.pts), "funnelarea" === e1.type && (delete r.v, delete r.i), r;
                };
            },
            75067: function(t1, e1, r) {
                "use strict";
                var n = r(62203), i = r(78766);
                t1.exports = function(t1, e1, r, a) {
                    var o = r.marker.pattern;
                    o && o.shape ? n.pointStyle(t1, r, a, e1) : i.fill(t1, e1.color);
                };
            },
            37252: function(t1, e1, r) {
                "use strict";
                var n = r(34809);
                function i(t1) {
                    return -1 !== t1.indexOf("e") ? t1.replace(/[.]?0+e/, "e") : -1 !== t1.indexOf(".") ? t1.replace(/[.]?0+$/, "") : t1;
                }
                e1.formatPiePercent = function(t1, e1) {
                    var r = i((100 * t1).toPrecision(3));
                    return n.numSeparate(r, e1) + "%";
                }, e1.formatPieValue = function(t1, e1) {
                    var r = i(t1.toPrecision(10));
                    return n.numSeparate(r, e1);
                }, e1.getFirstFilled = function(t1, e1) {
                    if (n.isArrayOrTypedArray(t1)) for(var r = 0; r < e1.length; r++){
                        var i = t1[e1[r]];
                        if (i || 0 === i || "" === i) return i;
                    }
                }, e1.castOption = function(t1, r) {
                    return n.isArrayOrTypedArray(t1) ? e1.getFirstFilled(t1, r) : t1 || void 0;
                }, e1.getRotationAngle = function(t1) {
                    return ("auto" === t1 ? 0 : t1) * Math.PI / 180;
                };
            },
            49913: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    attributes: r(55412),
                    supplyDefaults: r(46979).supplyDefaults,
                    supplyLayoutDefaults: r(13464),
                    layoutAttributes: r(4031),
                    calc: r(44148).calc,
                    crossTraceCalc: r(44148).crossTraceCalc,
                    plot: r(35734).plot,
                    style: r(140),
                    styleOne: r(32891),
                    moduleType: "trace",
                    name: "pie",
                    basePlotModule: r(96052),
                    categories: [
                        "pie-like",
                        "pie",
                        "showLegend"
                    ],
                    meta: {}
                };
            },
            4031: function(t1) {
                "use strict";
                t1.exports = {
                    hiddenlabels: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    piecolorway: {
                        valType: "colorlist",
                        editType: "calc"
                    },
                    extendpiecolors: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    }
                };
            },
            13464: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(4031);
                t1.exports = function(t1, e1) {
                    function r(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    r("hiddenlabels"), r("piecolorway", e1.colorway), r("extendpiecolors");
                };
            },
            35734: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(44122), a = r(32141), o = r(78766), s = r(62203), l = r(34809), c = l.strScale, u = l.strTranslate, h = r(30635), f = r(84102), p = f.recordMinTextSize, d = f.clearMinTextSize, m = r(56155).TEXTPAD, g = r(37252), y = r(50568), v = r(34809).isValidTextValue;
                function x(t1, e1, r) {
                    var i = r[0], o = i.cx, s = i.cy, c = i.trace, u = "funnelarea" === c.type;
                    "_hasHoverLabel" in c || (c._hasHoverLabel = !1), "_hasHoverEvent" in c || (c._hasHoverEvent = !1), t1.on("mouseover", function(t1) {
                        var r = e1._fullLayout, h = e1._fullData[c.index];
                        if (!e1._dragging && !1 !== r.hovermode) {
                            var f = h.hoverinfo;
                            if (Array.isArray(f) && (f = a.castHoverinfo({
                                hoverinfo: [
                                    g.castOption(f, t1.pts)
                                ],
                                _module: c._module
                            }, r, 0)), "all" === f && (f = "label+text+value+percent+name"), h.hovertemplate || "none" !== f && "skip" !== f && f) {
                                var p = t1.rInscribed || 0, d = o + t1.pxmid[0] * (1 - p), m = s + t1.pxmid[1] * (1 - p), v = r.separators, x = [];
                                if (f && -1 !== f.indexOf("label") && x.push(t1.label), t1.text = g.castOption(h.hovertext || h.text, t1.pts), f && -1 !== f.indexOf("text")) {
                                    var _ = t1.text;
                                    l.isValidTextValue(_) && x.push(_);
                                }
                                t1.value = t1.v, t1.valueLabel = g.formatPieValue(t1.v, v), f && -1 !== f.indexOf("value") && x.push(t1.valueLabel), t1.percent = t1.v / i.vTotal, t1.percentLabel = g.formatPiePercent(t1.percent, v), f && -1 !== f.indexOf("percent") && x.push(t1.percentLabel);
                                var b = h.hoverlabel, w = b.font, T = [];
                                a.loneHover({
                                    trace: c,
                                    x0: d - p * i.r,
                                    x1: d + p * i.r,
                                    y: m,
                                    _x0: u ? o + t1.TL[0] : d - p * i.r,
                                    _x1: u ? o + t1.TR[0] : d + p * i.r,
                                    _y0: u ? s + t1.TL[1] : m - p * i.r,
                                    _y1: u ? s + t1.BL[1] : m + p * i.r,
                                    text: x.join("<br>"),
                                    name: h.hovertemplate || -1 !== f.indexOf("name") ? h.name : void 0,
                                    idealAlign: t1.pxmid[0] < 0 ? "left" : "right",
                                    color: g.castOption(b.bgcolor, t1.pts) || t1.color,
                                    borderColor: g.castOption(b.bordercolor, t1.pts),
                                    fontFamily: g.castOption(w.family, t1.pts),
                                    fontSize: g.castOption(w.size, t1.pts),
                                    fontColor: g.castOption(w.color, t1.pts),
                                    nameLength: g.castOption(b.namelength, t1.pts),
                                    textAlign: g.castOption(b.align, t1.pts),
                                    hovertemplate: g.castOption(h.hovertemplate, t1.pts),
                                    hovertemplateLabels: t1,
                                    eventData: [
                                        y(t1, h)
                                    ]
                                }, {
                                    container: r._hoverlayer.node(),
                                    outerContainer: r._paper.node(),
                                    gd: e1,
                                    inOut_bbox: T
                                }), t1.bbox = T[0], c._hasHoverLabel = !0;
                            }
                            c._hasHoverEvent = !0, e1.emit("plotly_hover", {
                                points: [
                                    y(t1, h)
                                ],
                                event: n.event
                            });
                        }
                    }), t1.on("mouseout", function(t1) {
                        var r = e1._fullLayout, i = e1._fullData[c.index], o = n.select(this).datum();
                        c._hasHoverEvent && (t1.originalEvent = n.event, e1.emit("plotly_unhover", {
                            points: [
                                y(o, i)
                            ],
                            event: n.event
                        }), c._hasHoverEvent = !1), c._hasHoverLabel && (a.loneUnhover(r._hoverlayer.node()), c._hasHoverLabel = !1);
                    }), t1.on("click", function(t1) {
                        var r = e1._fullLayout, i = e1._fullData[c.index];
                        e1._dragging || !1 === r.hovermode || (e1._hoverdata = [
                            y(t1, i)
                        ], a.click(e1, n.event));
                    });
                }
                function _(t1, e1, r) {
                    var n = g.castOption(t1.insidetextfont.color, e1.pts);
                    !n && t1._input.textfont && (n = g.castOption(t1._input.textfont.color, e1.pts));
                    var i = g.castOption(t1.insidetextfont.family, e1.pts) || g.castOption(t1.textfont.family, e1.pts) || r.family, a = g.castOption(t1.insidetextfont.size, e1.pts) || g.castOption(t1.textfont.size, e1.pts) || r.size, s = g.castOption(t1.insidetextfont.weight, e1.pts) || g.castOption(t1.textfont.weight, e1.pts) || r.weight, l = g.castOption(t1.insidetextfont.style, e1.pts) || g.castOption(t1.textfont.style, e1.pts) || r.style, c = g.castOption(t1.insidetextfont.variant, e1.pts) || g.castOption(t1.textfont.variant, e1.pts) || r.variant, u = g.castOption(t1.insidetextfont.textcase, e1.pts) || g.castOption(t1.textfont.textcase, e1.pts) || r.textcase, h = g.castOption(t1.insidetextfont.lineposition, e1.pts) || g.castOption(t1.textfont.lineposition, e1.pts) || r.lineposition, f = g.castOption(t1.insidetextfont.shadow, e1.pts) || g.castOption(t1.textfont.shadow, e1.pts) || r.shadow;
                    return {
                        color: n || o.contrast(e1.color),
                        family: i,
                        size: a,
                        weight: s,
                        style: l,
                        variant: c,
                        textcase: u,
                        lineposition: h,
                        shadow: f
                    };
                }
                function b(t1, e1) {
                    for(var r, n, i = 0; i < t1.length; i++)if ((n = (r = t1[i][0]).trace).title.text) {
                        var a = n.title.text;
                        n._meta && (a = l.templateString(a, n._meta));
                        var o = s.tester.append("text").attr("data-notex", 1).text(a).call(s.font, n.title.font).call(h.convertToTspans, e1), c = s.bBox(o.node(), !0);
                        r.titleBox = {
                            width: c.width,
                            height: c.height
                        }, o.remove();
                    }
                }
                function w(t1, e1, r) {
                    var n = r.r || e1.rpx1, i = e1.rInscribed;
                    if (e1.startangle === e1.stopangle) return {
                        rCenter: 1 - i,
                        scale: 0,
                        rotate: 0,
                        textPosAngle: 0
                    };
                    var a, o = e1.ring, s = 1 === o && Math.abs(e1.startangle - e1.stopangle) === 2 * Math.PI, l = e1.halfangle, c = e1.midangle, u = r.trace.insidetextorientation, h = "horizontal" === u, f = "tangential" === u, p = "radial" === u, d = "auto" === u, m = [];
                    if (!d) {
                        var g, y = function(r, i) {
                            if (function(t1, e1) {
                                var r = t1.startangle, n = t1.stopangle;
                                return r > e1 && e1 > n || r < e1 && e1 < n;
                            }(e1, r)) {
                                var s = Math.abs(r - e1.startangle), l = Math.abs(r - e1.stopangle), c = s < l ? s : l;
                                (a = "tan" === i ? k(t1, n, o, c, 0) : T(t1, n, o, c, Math.PI / 2)).textPosAngle = r, m.push(a);
                            }
                        };
                        if (h || f) {
                            for(g = 4; g >= -4; g -= 2)y(Math.PI * g, "tan");
                            for(g = 4; g >= -4; g -= 2)y(Math.PI * (g + 1), "tan");
                        }
                        if (h || p) {
                            for(g = 4; g >= -4; g -= 2)y(Math.PI * (g + 1.5), "rad");
                            for(g = 4; g >= -4; g -= 2)y(Math.PI * (g + .5), "rad");
                        }
                    }
                    if (s || d || h) {
                        var v = Math.sqrt(t1.width * t1.width + t1.height * t1.height);
                        if ((a = {
                            scale: i * n * 2 / v,
                            rCenter: 1 - i,
                            rotate: 0
                        }).textPosAngle = (e1.startangle + e1.stopangle) / 2, a.scale >= 1) return a;
                        m.push(a);
                    }
                    (d || p) && ((a = T(t1, n, o, l, c)).textPosAngle = (e1.startangle + e1.stopangle) / 2, m.push(a)), (d || f) && ((a = k(t1, n, o, l, c)).textPosAngle = (e1.startangle + e1.stopangle) / 2, m.push(a));
                    for(var x = 0, _ = 0, b = 0; b < m.length; b++){
                        var w = m[b].scale;
                        if (_ < w && (_ = w, x = b), !d && _ >= 1) break;
                    }
                    return m[x];
                }
                function T(t1, e1, r, n, i) {
                    e1 = Math.max(0, e1 - 2 * m);
                    var a = t1.width / t1.height, o = S(a, n, e1, r);
                    return {
                        scale: 2 * o / t1.height,
                        rCenter: A(a, o / e1),
                        rotate: M(i)
                    };
                }
                function k(t1, e1, r, n, i) {
                    e1 = Math.max(0, e1 - 2 * m);
                    var a = t1.height / t1.width, o = S(a, n, e1, r);
                    return {
                        scale: 2 * o / t1.width,
                        rCenter: A(a, o / e1),
                        rotate: M(i + Math.PI / 2)
                    };
                }
                function A(t1, e1) {
                    return Math.cos(e1) - t1 * e1;
                }
                function M(t1) {
                    return (180 / Math.PI * t1 + 720) % 180 - 90;
                }
                function S(t1, e1, r, n) {
                    var i = t1 + 1 / (2 * Math.tan(e1));
                    return r * Math.min(1 / (Math.sqrt(i * i + .5) + i), n / (Math.sqrt(t1 * t1 + n / 2) + t1));
                }
                function E(t1, e1) {
                    return t1.v !== e1.vTotal || e1.trace.hole ? Math.min(1 / (1 + 1 / Math.sin(t1.halfangle)), t1.ring / 2) : 1;
                }
                function C(t1, e1) {
                    var r = e1.pxmid[0], n = e1.pxmid[1], i = t1.width / 2, a = t1.height / 2;
                    return r < 0 && (i *= -1), n < 0 && (a *= -1), {
                        scale: 1,
                        rCenter: 1,
                        rotate: 0,
                        x: i + Math.abs(a) * (i > 0 ? 1 : -1) / 2,
                        y: a / (1 + r * r / (n * n)),
                        outside: !0
                    };
                }
                function L(t1, e1) {
                    var r, n, i, a = t1.trace, o = {
                        x: t1.cx,
                        y: t1.cy
                    }, s = {
                        tx: 0,
                        ty: 0
                    };
                    s.ty += a.title.font.size, i = P(a), -1 !== a.title.position.indexOf("top") ? (o.y -= (1 + i) * t1.r, s.ty -= t1.titleBox.height) : -1 !== a.title.position.indexOf("bottom") && (o.y += (1 + i) * t1.r);
                    var l, c = t1.r / (void 0 === (l = t1.trace.aspectratio) ? 1 : l), u = e1.w * (a.domain.x[1] - a.domain.x[0]) / 2;
                    return -1 !== a.title.position.indexOf("left") ? (u += c, o.x -= (1 + i) * c, s.tx += t1.titleBox.width / 2) : -1 !== a.title.position.indexOf("center") ? u *= 2 : -1 !== a.title.position.indexOf("right") && (u += c, o.x += (1 + i) * c, s.tx -= t1.titleBox.width / 2), r = u / t1.titleBox.width, n = I(t1, e1) / t1.titleBox.height, {
                        x: o.x,
                        y: o.y,
                        scale: Math.min(r, n),
                        tx: s.tx,
                        ty: s.ty
                    };
                }
                function I(t1, e1) {
                    var r = t1.trace, n = e1.h * (r.domain.y[1] - r.domain.y[0]);
                    return Math.min(t1.titleBox.height, n / 2);
                }
                function P(t1) {
                    var e1, r = t1.pull;
                    if (!r) return 0;
                    if (l.isArrayOrTypedArray(r)) for(r = 0, e1 = 0; e1 < t1.pull.length; e1++)t1.pull[e1] > r && (r = t1.pull[e1]);
                    return r;
                }
                function z(t1, e1) {
                    for(var r = [], n = 0; n < t1.length; n++){
                        var i = t1[n][0], a = i.trace, o = a.domain, s = e1.w * (o.x[1] - o.x[0]), l = e1.h * (o.y[1] - o.y[0]);
                        a.title.text && "middle center" !== a.title.position && (l -= I(i, e1));
                        var c = s / 2, u = l / 2;
                        "funnelarea" !== a.type || a.scalegroup || (u /= a.aspectratio), i.r = Math.min(c, u) / (1 + P(a)), i.cx = e1.l + e1.w * (a.domain.x[1] + a.domain.x[0]) / 2, i.cy = e1.t + e1.h * (1 - a.domain.y[0]) - l / 2, a.title.text && -1 !== a.title.position.indexOf("bottom") && (i.cy -= I(i, e1)), a.scalegroup && -1 === r.indexOf(a.scalegroup) && r.push(a.scalegroup);
                    }
                    !function(t1, e1) {
                        for(var r, n, i, a = 0; a < e1.length; a++){
                            var o = 1 / 0, s = e1[a];
                            for(n = 0; n < t1.length; n++)if ((i = (r = t1[n][0]).trace).scalegroup === s) {
                                var l;
                                if ("pie" === i.type) l = r.r * r.r;
                                else if ("funnelarea" === i.type) {
                                    var c, u;
                                    i.aspectratio > 1 ? u = (c = r.r) / i.aspectratio : c = (u = r.r) * i.aspectratio, l = (c *= (1 + i.baseratio) / 2) * u;
                                }
                                o = Math.min(o, l / r.vTotal);
                            }
                            for(n = 0; n < t1.length; n++)if ((i = (r = t1[n][0]).trace).scalegroup === s) {
                                var h = o * r.vTotal;
                                "funnelarea" === i.type && (h /= (1 + i.baseratio) / 2, h /= i.aspectratio), r.r = Math.sqrt(h);
                            }
                        }
                    }(t1, r);
                }
                function O(t1, e1) {
                    return [
                        t1 * Math.sin(e1),
                        -t1 * Math.cos(e1)
                    ];
                }
                function D(t1, e1, r) {
                    var n = t1._fullLayout, i = r.trace, a = i.texttemplate, o = i.textinfo;
                    if (!a && o && "none" !== o) {
                        var s, c = o.split("+"), u = function(t1) {
                            return -1 !== c.indexOf(t1);
                        }, h = u("label"), f = u("text"), p = u("value"), d = u("percent"), m = n.separators;
                        if (s = h ? [
                            e1.label
                        ] : [], f) {
                            var y = g.getFirstFilled(i.text, e1.pts);
                            v(y) && s.push(y);
                        }
                        p && s.push(g.formatPieValue(e1.v, m)), d && s.push(g.formatPiePercent(e1.v / r.vTotal, m)), e1.text = s.join("<br>");
                    }
                    if (a) {
                        var x = l.castOption(i, e1.i, "texttemplate");
                        if (x) {
                            var _ = function(t1) {
                                return {
                                    label: t1.label,
                                    value: t1.v,
                                    valueLabel: g.formatPieValue(t1.v, n.separators),
                                    percent: t1.v / r.vTotal,
                                    percentLabel: g.formatPiePercent(t1.v / r.vTotal, n.separators),
                                    color: t1.color,
                                    text: t1.text,
                                    customdata: l.castOption(i, t1.i, "customdata")
                                };
                            }(e1), b = g.getFirstFilled(i.text, e1.pts);
                            (v(b) || "" === b) && (_.text = b), e1.text = l.texttemplateString(x, _, t1._fullLayout._d3locale, _, i._meta || {});
                        } else e1.text = "";
                    }
                }
                function R(t1, e1) {
                    var r = t1.rotate * Math.PI / 180, n = Math.cos(r), i = Math.sin(r), a = (e1.left + e1.right) / 2, o = (e1.top + e1.bottom) / 2;
                    t1.textX = a * n - o * i, t1.textY = a * i + o * n, t1.noCenter = !0;
                }
                t1.exports = {
                    plot: function(t1, e1) {
                        var r = t1._context.staticPlot, a = t1._fullLayout, f = a._size;
                        d("pie", a), b(e1, t1), z(e1, f);
                        var m = l.makeTraceGroups(a._pielayer, e1, "trace").each(function(e1) {
                            var d = n.select(this), m = e1[0], y = m.trace;
                            !function(t1) {
                                var e1, r, n, i = t1[0], a = i.r, o = i.trace, s = g.getRotationAngle(o.rotation), l = 2 * Math.PI / i.vTotal, c = "px0", u = "px1";
                                if ("counterclockwise" === o.direction) {
                                    for(e1 = 0; e1 < t1.length && t1[e1].hidden; e1++);
                                    if (e1 === t1.length) return;
                                    s += l * t1[e1].v, l *= -1, c = "px1", u = "px0";
                                }
                                for(n = O(a, s), e1 = 0; e1 < t1.length; e1++)(r = t1[e1]).hidden || (r[c] = n, r.startangle = s, s += l * r.v / 2, r.pxmid = O(a, s), r.midangle = s, n = O(a, s += l * r.v / 2), r.stopangle = s, r[u] = n, r.largeArc = r.v > i.vTotal / 2 ? 1 : 0, r.halfangle = Math.PI * Math.min(r.v / i.vTotal, .5), r.ring = 1 - o.hole, r.rInscribed = E(r, i));
                            }(e1), d.attr("stroke-linejoin", "round"), d.each(function() {
                                var v = n.select(this).selectAll("g.slice").data(e1);
                                v.enter().append("g").classed("slice", !0), v.exit().remove();
                                var b = [
                                    [
                                        [],
                                        []
                                    ],
                                    [
                                        [],
                                        []
                                    ]
                                ], T = !1;
                                v.each(function(i, o) {
                                    if (i.hidden) n.select(this).selectAll("path,g").remove();
                                    else {
                                        i.pointNumber = i.i, i.curveNumber = y.index, b[i.pxmid[1] < 0 ? 0 : 1][i.pxmid[0] < 0 ? 0 : 1].push(i);
                                        var c = m.cx, u = m.cy, f = n.select(this), d = f.selectAll("path.surface").data([
                                            i
                                        ]);
                                        if (d.enter().append("path").classed("surface", !0).style({
                                            "pointer-events": r ? "none" : "all"
                                        }), f.call(x, t1, e1), y.pull) {
                                            var v = +g.castOption(y.pull, i.pts) || 0;
                                            v > 0 && (c += v * i.pxmid[0], u += v * i.pxmid[1]);
                                        }
                                        i.cxFinal = c, i.cyFinal = u;
                                        var k = y.hole;
                                        if (i.v === m.vTotal) {
                                            var A = "M" + (c + i.px0[0]) + "," + (u + i.px0[1]) + I(i.px0, i.pxmid, !0, 1) + I(i.pxmid, i.px0, !0, 1) + "Z";
                                            k ? d.attr("d", "M" + (c + k * i.px0[0]) + "," + (u + k * i.px0[1]) + I(i.px0, i.pxmid, !1, k) + I(i.pxmid, i.px0, !1, k) + "Z" + A) : d.attr("d", A);
                                        } else {
                                            var M = I(i.px0, i.px1, !0, 1);
                                            if (k) {
                                                var S = 1 - k;
                                                d.attr("d", "M" + (c + k * i.px1[0]) + "," + (u + k * i.px1[1]) + I(i.px1, i.px0, !1, k) + "l" + S * i.px0[0] + "," + S * i.px0[1] + M + "Z");
                                            } else d.attr("d", "M" + c + "," + u + "l" + i.px0[0] + "," + i.px0[1] + M + "Z");
                                        }
                                        D(t1, i, m);
                                        var E = g.castOption(y.textposition, i.pts), L = f.selectAll("g.slicetext").data(i.text && "none" !== E ? [
                                            0
                                        ] : []);
                                        L.enter().append("g").classed("slicetext", !0), L.exit().remove(), L.each(function() {
                                            var r = l.ensureSingle(n.select(this), "text", "", function(t1) {
                                                t1.attr("data-notex", 1);
                                            }), f = l.ensureUniformFontSize(t1, "outside" === E ? function(t1, e1, r) {
                                                return {
                                                    color: g.castOption(t1.outsidetextfont.color, e1.pts) || g.castOption(t1.textfont.color, e1.pts) || r.color,
                                                    family: g.castOption(t1.outsidetextfont.family, e1.pts) || g.castOption(t1.textfont.family, e1.pts) || r.family,
                                                    size: g.castOption(t1.outsidetextfont.size, e1.pts) || g.castOption(t1.textfont.size, e1.pts) || r.size,
                                                    weight: g.castOption(t1.outsidetextfont.weight, e1.pts) || g.castOption(t1.textfont.weight, e1.pts) || r.weight,
                                                    style: g.castOption(t1.outsidetextfont.style, e1.pts) || g.castOption(t1.textfont.style, e1.pts) || r.style,
                                                    variant: g.castOption(t1.outsidetextfont.variant, e1.pts) || g.castOption(t1.textfont.variant, e1.pts) || r.variant,
                                                    textcase: g.castOption(t1.outsidetextfont.textcase, e1.pts) || g.castOption(t1.textfont.textcase, e1.pts) || r.textcase,
                                                    lineposition: g.castOption(t1.outsidetextfont.lineposition, e1.pts) || g.castOption(t1.textfont.lineposition, e1.pts) || r.lineposition,
                                                    shadow: g.castOption(t1.outsidetextfont.shadow, e1.pts) || g.castOption(t1.textfont.shadow, e1.pts) || r.shadow
                                                };
                                            }(y, i, a.font) : _(y, i, a.font));
                                            r.text(i.text).attr({
                                                class: "slicetext",
                                                transform: "",
                                                "text-anchor": "middle"
                                            }).call(s.font, f).call(h.convertToTspans, t1);
                                            var d, v = s.bBox(r.node());
                                            if ("outside" === E) d = C(v, i);
                                            else if (d = w(v, i, m), "auto" === E && d.scale < 1) {
                                                var x = l.ensureUniformFontSize(t1, y.outsidetextfont);
                                                r.call(s.font, x), d = C(v = s.bBox(r.node()), i);
                                            }
                                            var b = d.textPosAngle, k = void 0 === b ? i.pxmid : O(m.r, b);
                                            if (d.targetX = c + k[0] * d.rCenter + (d.x || 0), d.targetY = u + k[1] * d.rCenter + (d.y || 0), R(d, v), d.outside) {
                                                var A = d.targetY;
                                                i.yLabelMin = A - v.height / 2, i.yLabelMid = A, i.yLabelMax = A + v.height / 2, i.labelExtraX = 0, i.labelExtraY = 0, T = !0;
                                            }
                                            d.fontSize = f.size, p(y.type, d, a), e1[o].transform = d, l.setTransormAndDisplay(r, d);
                                        });
                                    }
                                    function I(t1, e1, r, n) {
                                        var a = n * (e1[0] - t1[0]), o = n * (e1[1] - t1[1]);
                                        return "a" + n * m.r + "," + n * m.r + " 0 " + i.largeArc + (r ? " 1 " : " 0 ") + a + "," + o;
                                    }
                                });
                                var k = n.select(this).selectAll("g.titletext").data(y.title.text ? [
                                    0
                                ] : []);
                                if (k.enter().append("g").classed("titletext", !0), k.exit().remove(), k.each(function() {
                                    var e1, r = l.ensureSingle(n.select(this), "text", "", function(t1) {
                                        t1.attr("data-notex", 1);
                                    }), i = y.title.text;
                                    y._meta && (i = l.templateString(i, y._meta)), r.text(i).attr({
                                        class: "titletext",
                                        transform: "",
                                        "text-anchor": "middle"
                                    }).call(s.font, y.title.font).call(h.convertToTspans, t1), e1 = "middle center" === y.title.position ? function(t1) {
                                        var e1 = Math.sqrt(t1.titleBox.width * t1.titleBox.width + t1.titleBox.height * t1.titleBox.height);
                                        return {
                                            x: t1.cx,
                                            y: t1.cy,
                                            scale: t1.trace.hole * t1.r * 2 / e1,
                                            tx: 0,
                                            ty: -t1.titleBox.height / 2 + t1.trace.title.font.size
                                        };
                                    }(m) : L(m, f), r.attr("transform", u(e1.x, e1.y) + c(Math.min(1, e1.scale)) + u(e1.tx, e1.ty));
                                }), T && function(t1, e1) {
                                    var r, n, i, a, o, s, c, u, h, f, p, d, m;
                                    function y(t1, e1) {
                                        return t1.pxmid[1] - e1.pxmid[1];
                                    }
                                    function v(t1, e1) {
                                        return e1.pxmid[1] - t1.pxmid[1];
                                    }
                                    function x(t1, r) {
                                        r || (r = {});
                                        var i, u, h, p, d = r.labelExtraY + (n ? r.yLabelMax : r.yLabelMin), m = n ? t1.yLabelMin : t1.yLabelMax, y = n ? t1.yLabelMax : t1.yLabelMin, v = t1.cyFinal + o(t1.px0[1], t1.px1[1]), x = d - m;
                                        if (x * c > 0 && (t1.labelExtraY = x), l.isArrayOrTypedArray(e1.pull)) for(u = 0; u < f.length; u++)(h = f[u]) === t1 || (g.castOption(e1.pull, t1.pts) || 0) >= (g.castOption(e1.pull, h.pts) || 0) || ((t1.pxmid[1] - h.pxmid[1]) * c > 0 ? (x = h.cyFinal + o(h.px0[1], h.px1[1]) - m - t1.labelExtraY) * c > 0 && (t1.labelExtraY += x) : (y + t1.labelExtraY - v) * c > 0 && (i = 3 * s * Math.abs(u - f.indexOf(t1)), (p = h.cxFinal + a(h.px0[0], h.px1[0]) + i - (t1.cxFinal + t1.pxmid[0]) - t1.labelExtraX) * s > 0 && (t1.labelExtraX += p)));
                                    }
                                    for(n = 0; n < 2; n++)for(i = n ? y : v, o = n ? Math.max : Math.min, c = n ? 1 : -1, r = 0; r < 2; r++){
                                        for(a = r ? Math.max : Math.min, s = r ? 1 : -1, (u = t1[n][r]).sort(i), h = t1[1 - n][r], f = h.concat(u), d = [], p = 0; p < u.length; p++)void 0 !== u[p].yLabelMid && d.push(u[p]);
                                        for(m = !1, p = 0; n && p < h.length; p++)if (void 0 !== h[p].yLabelMid) {
                                            m = h[p];
                                            break;
                                        }
                                        for(p = 0; p < d.length; p++){
                                            var _ = p && d[p - 1];
                                            m && !p && (_ = m), x(d[p], _);
                                        }
                                    }
                                }(b, y), function(t1, e1) {
                                    t1.each(function(t1) {
                                        var r = n.select(this);
                                        if (t1.labelExtraX || t1.labelExtraY) {
                                            var i = r.select("g.slicetext text");
                                            t1.transform.targetX += t1.labelExtraX, t1.transform.targetY += t1.labelExtraY, l.setTransormAndDisplay(i, t1.transform);
                                            var a = t1.cxFinal + t1.pxmid[0], s = "M" + a + "," + (t1.cyFinal + t1.pxmid[1]), c = (t1.yLabelMax - t1.yLabelMin) * (t1.pxmid[0] < 0 ? -1 : 1) / 4;
                                            if (t1.labelExtraX) {
                                                var u = t1.labelExtraX * t1.pxmid[1] / t1.pxmid[0], h = t1.yLabelMid + t1.labelExtraY - (t1.cyFinal + t1.pxmid[1]);
                                                Math.abs(u) > Math.abs(h) ? s += "l" + h * t1.pxmid[0] / t1.pxmid[1] + "," + h + "H" + (a + t1.labelExtraX + c) : s += "l" + t1.labelExtraX + "," + u + "v" + (h - u) + "h" + c;
                                            } else s += "V" + (t1.yLabelMid + t1.labelExtraY) + "h" + c;
                                            l.ensureSingle(r, "path", "textline").call(o.stroke, e1.outsidetextfont.color).attr({
                                                "stroke-width": Math.min(2, e1.outsidetextfont.size / 8),
                                                d: s,
                                                fill: "none"
                                            });
                                        } else r.select("path.textline").remove();
                                    });
                                }(v, y), T && y.automargin) {
                                    var A = s.bBox(d.node()), M = y.domain, S = f.w * (M.x[1] - M.x[0]), E = f.h * (M.y[1] - M.y[0]), I = (.5 * S - m.r) / f.w, P = (.5 * E - m.r) / f.h;
                                    i.autoMargin(t1, "pie." + y.uid + ".automargin", {
                                        xl: M.x[0] - I,
                                        xr: M.x[1] + I,
                                        yb: M.y[0] - P,
                                        yt: M.y[1] + P,
                                        l: Math.max(m.cx - m.r - A.left, 0),
                                        r: Math.max(A.right - (m.cx + m.r), 0),
                                        b: Math.max(A.bottom - (m.cy + m.r), 0),
                                        t: Math.max(m.cy - m.r - A.top, 0),
                                        pad: 5
                                    });
                                }
                            });
                        });
                        setTimeout(function() {
                            m.selectAll("tspan").each(function() {
                                var t1 = n.select(this);
                                t1.attr("dy") && t1.attr("dy", t1.attr("dy"));
                            });
                        }, 0);
                    },
                    formatSliceLabel: D,
                    transformInsideText: w,
                    determineInsideTextFont: _,
                    positionTitleOutside: L,
                    prerenderTitles: b,
                    layoutAreas: z,
                    attachFxHandlers: x,
                    computeTransform: R
                };
            },
            140: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(32891), a = r(84102).resizeText;
                t1.exports = function(t1) {
                    var e1 = t1._fullLayout._pielayer.selectAll(".trace");
                    a(t1, e1, "pie"), e1.each(function(e1) {
                        var r = e1[0].trace, a = n.select(this);
                        a.style({
                            opacity: r.opacity
                        }), a.selectAll("path.surface").each(function(e1) {
                            n.select(this).call(i, e1, r, t1);
                        });
                    });
                };
            },
            32891: function(t1, e1, r) {
                "use strict";
                var n = r(78766), i = r(37252).castOption, a = r(75067);
                t1.exports = function(t1, e1, r, o) {
                    var s = r.marker.line, l = i(s.color, e1.pts) || n.defaultLine, c = i(s.width, e1.pts) || 0;
                    t1.call(a, e1, r, o).style("stroke-width", c).call(n.stroke, l);
                };
            },
            36961: function(t1, e1, r) {
                "use strict";
                var n = r(36640);
                t1.exports = {
                    x: n.x,
                    y: n.y,
                    xy: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    indices: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    xbounds: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    ybounds: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    text: n.text,
                    marker: {
                        color: {
                            valType: "color",
                            arrayOk: !1,
                            editType: "calc"
                        },
                        opacity: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: 1,
                            arrayOk: !1,
                            editType: "calc"
                        },
                        blend: {
                            valType: "boolean",
                            dflt: null,
                            editType: "calc"
                        },
                        sizemin: {
                            valType: "number",
                            min: .1,
                            max: 2,
                            dflt: .5,
                            editType: "calc"
                        },
                        sizemax: {
                            valType: "number",
                            min: .1,
                            dflt: 20,
                            editType: "calc"
                        },
                        border: {
                            color: {
                                valType: "color",
                                arrayOk: !1,
                                editType: "calc"
                            },
                            arearatio: {
                                valType: "number",
                                min: 0,
                                max: 1,
                                dflt: 0,
                                editType: "calc"
                            },
                            editType: "calc"
                        },
                        editType: "calc"
                    },
                    transforms: void 0
                };
            },
            71593: function(t1, e1, r) {
                "use strict";
                var n = r(99098).gl_pointcloud2d, i = r(34809).isArrayOrTypedArray, a = r(55010), o = r(32919).findExtremes, s = r(11539);
                function l(t1, e1) {
                    this.scene = t1, this.uid = e1, this.type = "pointcloud", this.pickXData = [], this.pickYData = [], this.xData = [], this.yData = [], this.textLabels = [], this.color = "rgb(0, 0, 0)", this.name = "", this.hoverinfo = "all", this.idToIndex = new Int32Array(0), this.bounds = [
                        0,
                        0,
                        0,
                        0
                    ], this.pointcloudOptions = {
                        positions: new Float32Array(0),
                        idToIndex: this.idToIndex,
                        sizemin: .5,
                        sizemax: 12,
                        color: [
                            0,
                            0,
                            0,
                            1
                        ],
                        areaRatio: 1,
                        borderColor: [
                            0,
                            0,
                            0,
                            1
                        ]
                    }, this.pointcloud = n(t1.glplot, this.pointcloudOptions), this.pointcloud._trace = this;
                }
                var c = l.prototype;
                c.handlePick = function(t1) {
                    var e1 = this.idToIndex[t1.pointId];
                    return {
                        trace: this,
                        dataCoord: t1.dataCoord,
                        traceCoord: this.pickXYData ? [
                            this.pickXYData[2 * e1],
                            this.pickXYData[2 * e1 + 1]
                        ] : [
                            this.pickXData[e1],
                            this.pickYData[e1]
                        ],
                        textLabel: i(this.textLabels) ? this.textLabels[e1] : this.textLabels,
                        color: this.color,
                        name: this.name,
                        pointIndex: e1,
                        hoverinfo: this.hoverinfo
                    };
                }, c.update = function(t1) {
                    this.index = t1.index, this.textLabels = t1.text, this.name = t1.name, this.hoverinfo = t1.hoverinfo, this.bounds = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ], this.updateFast(t1), this.color = s(t1, {});
                }, c.updateFast = function(t1) {
                    var e1, r, n, i, s, l, c = this.xData = this.pickXData = t1.x, u = this.yData = this.pickYData = t1.y, h = this.pickXYData = t1.xy, f = t1.xbounds && t1.ybounds, p = t1.indices, d = this.bounds;
                    if (h) {
                        if (n = h, e1 = h.length >>> 1, f) d[0] = t1.xbounds[0], d[2] = t1.xbounds[1], d[1] = t1.ybounds[0], d[3] = t1.ybounds[1];
                        else for(l = 0; l < e1; l++)i = n[2 * l], s = n[2 * l + 1], i < d[0] && (d[0] = i), i > d[2] && (d[2] = i), s < d[1] && (d[1] = s), s > d[3] && (d[3] = s);
                        if (p) r = p;
                        else for(r = new Int32Array(e1), l = 0; l < e1; l++)r[l] = l;
                    } else for(e1 = c.length, n = new Float32Array(2 * e1), r = new Int32Array(e1), l = 0; l < e1; l++)i = c[l], s = u[l], r[l] = l, n[2 * l] = i, n[2 * l + 1] = s, i < d[0] && (d[0] = i), i > d[2] && (d[2] = i), s < d[1] && (d[1] = s), s > d[3] && (d[3] = s);
                    this.idToIndex = r, this.pointcloudOptions.idToIndex = r, this.pointcloudOptions.positions = n;
                    var m = a(t1.marker.color), g = a(t1.marker.border.color), y = t1.opacity * t1.marker.opacity;
                    m[3] *= y, this.pointcloudOptions.color = m;
                    var v = t1.marker.blend;
                    null === v && (v = c.length < 100 || u.length < 100), this.pointcloudOptions.blend = v, g[3] *= y, this.pointcloudOptions.borderColor = g;
                    var x = t1.marker.sizemin, _ = Math.max(t1.marker.sizemax, t1.marker.sizemin);
                    this.pointcloudOptions.sizeMin = x, this.pointcloudOptions.sizeMax = _, this.pointcloudOptions.areaRatio = t1.marker.border.arearatio, this.pointcloud.update(this.pointcloudOptions);
                    var b = this.scene.xaxis, w = this.scene.yaxis, T = _ / 2 || .5;
                    t1._extremes[b._id] = o(b, [
                        d[0],
                        d[2]
                    ], {
                        ppad: T
                    }), t1._extremes[w._id] = o(w, [
                        d[1],
                        d[3]
                    ], {
                        ppad: T
                    });
                }, c.dispose = function() {
                    this.pointcloud.dispose();
                }, t1.exports = function(t1, e1) {
                    var r = new l(t1, e1.uid);
                    return r.update(e1), r;
                };
            },
            75526: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(36961);
                t1.exports = function(t1, e1, r) {
                    function a(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    a("x"), a("y"), a("xbounds"), a("ybounds"), t1.xy && t1.xy instanceof Float32Array && (e1.xy = t1.xy), t1.indices && t1.indices instanceof Int32Array && (e1.indices = t1.indices), a("text"), a("marker.color", r), a("marker.opacity"), a("marker.blend"), a("marker.sizemin"), a("marker.sizemax"), a("marker.border.color", r), a("marker.border.arearatio"), e1._length = null;
                };
            },
            15186: function(t1, e1, r) {
                "use strict";
                [
                    "*pointcloud* trace is deprecated!",
                    "Please consider switching to the *scattergl* trace type."
                ].join(" "), t1.exports = {
                    attributes: r(36961),
                    supplyDefaults: r(75526),
                    calc: r(37593),
                    plot: r(71593),
                    moduleType: "trace",
                    name: "pointcloud",
                    basePlotModule: r(24585),
                    categories: [
                        "gl",
                        "gl2d",
                        "showLegend"
                    ],
                    meta: {}
                };
            },
            33795: function(t1, e1, r) {
                "use strict";
                var n = r(80337), i = r(9829), a = r(10229), o = r(70192), s = r(13792).u, l = r(3208).rb, c = r(87163), u = r(78032).templatedArray, h = r(80712).descriptionOnlyNumbers, f = r(93049).extendFlat, p = r(13582).overrideAll;
                (t1.exports = p({
                    hoverinfo: f({}, i.hoverinfo, {
                        flags: [],
                        arrayOk: !1
                    }),
                    hoverlabel: o.hoverlabel,
                    domain: s({
                        name: "sankey",
                        trace: !0
                    }),
                    orientation: {
                        valType: "enumerated",
                        values: [
                            "v",
                            "h"
                        ],
                        dflt: "h"
                    },
                    valueformat: {
                        valType: "string",
                        dflt: ".3s",
                        description: h("value")
                    },
                    valuesuffix: {
                        valType: "string",
                        dflt: ""
                    },
                    arrangement: {
                        valType: "enumerated",
                        values: [
                            "snap",
                            "perpendicular",
                            "freeform",
                            "fixed"
                        ],
                        dflt: "snap"
                    },
                    textfont: n({
                        autoShadowDflt: !0
                    }),
                    customdata: void 0,
                    node: {
                        label: {
                            valType: "data_array",
                            dflt: []
                        },
                        groups: {
                            valType: "info_array",
                            impliedEdits: {
                                x: [],
                                y: []
                            },
                            dimensions: 2,
                            freeLength: !0,
                            dflt: [],
                            items: {
                                valType: "number",
                                editType: "calc"
                            }
                        },
                        x: {
                            valType: "data_array",
                            dflt: []
                        },
                        y: {
                            valType: "data_array",
                            dflt: []
                        },
                        color: {
                            valType: "color",
                            arrayOk: !0
                        },
                        customdata: {
                            valType: "data_array",
                            editType: "calc"
                        },
                        line: {
                            color: {
                                valType: "color",
                                dflt: a.defaultLine,
                                arrayOk: !0
                            },
                            width: {
                                valType: "number",
                                min: 0,
                                dflt: .5,
                                arrayOk: !0
                            }
                        },
                        pad: {
                            valType: "number",
                            arrayOk: !1,
                            min: 0,
                            dflt: 20
                        },
                        thickness: {
                            valType: "number",
                            arrayOk: !1,
                            min: 1,
                            dflt: 20
                        },
                        hoverinfo: {
                            valType: "enumerated",
                            values: [
                                "all",
                                "none",
                                "skip"
                            ],
                            dflt: "all"
                        },
                        hoverlabel: o.hoverlabel,
                        hovertemplate: l({}, {
                            keys: [
                                "value",
                                "label"
                            ]
                        }),
                        align: {
                            valType: "enumerated",
                            values: [
                                "justify",
                                "left",
                                "right",
                                "center"
                            ],
                            dflt: "justify"
                        }
                    },
                    link: {
                        arrowlen: {
                            valType: "number",
                            min: 0,
                            dflt: 0
                        },
                        label: {
                            valType: "data_array",
                            dflt: []
                        },
                        color: {
                            valType: "color",
                            arrayOk: !0
                        },
                        hovercolor: {
                            valType: "color",
                            arrayOk: !0
                        },
                        customdata: {
                            valType: "data_array",
                            editType: "calc"
                        },
                        line: {
                            color: {
                                valType: "color",
                                dflt: a.defaultLine,
                                arrayOk: !0
                            },
                            width: {
                                valType: "number",
                                min: 0,
                                dflt: 0,
                                arrayOk: !0
                            }
                        },
                        source: {
                            valType: "data_array",
                            dflt: []
                        },
                        target: {
                            valType: "data_array",
                            dflt: []
                        },
                        value: {
                            valType: "data_array",
                            dflt: []
                        },
                        hoverinfo: {
                            valType: "enumerated",
                            values: [
                                "all",
                                "none",
                                "skip"
                            ],
                            dflt: "all"
                        },
                        hoverlabel: o.hoverlabel,
                        hovertemplate: l({}, {
                            keys: [
                                "value",
                                "label"
                            ]
                        }),
                        colorscales: u("concentrationscales", {
                            editType: "calc",
                            label: {
                                valType: "string",
                                editType: "calc",
                                dflt: ""
                            },
                            cmax: {
                                valType: "number",
                                editType: "calc",
                                dflt: 1
                            },
                            cmin: {
                                valType: "number",
                                editType: "calc",
                                dflt: 0
                            },
                            colorscale: f(c().colorscale, {
                                dflt: [
                                    [
                                        0,
                                        "white"
                                    ],
                                    [
                                        1,
                                        "black"
                                    ]
                                ]
                            })
                        })
                    }
                }, "calc", "nested")).transforms = void 0;
            },
            42229: function(t1, e1, r) {
                "use strict";
                var n = r(13582).overrideAll, i = r(4173).eV, a = r(16506), o = r(6811), s = r(27983), l = r(14751), c = r(44844).prepSelect, u = r(34809), h = r(33626), f = "sankey";
                function p(t1, e1) {
                    var r = t1._fullData[e1], n = t1._fullLayout, i = n.dragmode, a = "pan" === n.dragmode ? "move" : "crosshair", o = r._bgRect;
                    if (o && "pan" !== i && "zoom" !== i) {
                        s(o, a);
                        var f = {
                            _id: "x",
                            c2p: u.identity,
                            _offset: r._sankey.translateX,
                            _length: r._sankey.width
                        }, p = {
                            _id: "y",
                            c2p: u.identity,
                            _offset: r._sankey.translateY,
                            _length: r._sankey.height
                        }, d = {
                            gd: t1,
                            element: o.node(),
                            plotinfo: {
                                id: e1,
                                xaxis: f,
                                yaxis: p,
                                fillRangeItems: u.noop
                            },
                            subplot: e1,
                            xaxes: [
                                f
                            ],
                            yaxes: [
                                p
                            ],
                            doneFnCompleted: function(r) {
                                var n, i = t1._fullData[e1], a = i.node.groups.slice(), o = [];
                                function s(t1) {
                                    for(var e1 = i._sankey.graph.nodes, r = 0; r < e1.length; r++)if (e1[r].pointNumber === t1) return e1[r];
                                }
                                for(var l = 0; l < r.length; l++){
                                    var c = s(r[l].pointNumber);
                                    if (c) {
                                        if (c.group) {
                                            for(var u = 0; u < c.childrenNodes.length; u++)o.push(c.childrenNodes[u].pointNumber);
                                            a[c.pointNumber - i.node._count] = !1;
                                        } else o.push(c.pointNumber);
                                    }
                                }
                                n = a.filter(Boolean).concat([
                                    o
                                ]), h.call("_guiRestyle", t1, {
                                    "node.groups": [
                                        n
                                    ]
                                }, e1);
                            },
                            prepFn: function(t1, e1, r) {
                                c(t1, e1, r, d, i);
                            }
                        };
                        l.init(d);
                    }
                }
                e1.name = f, e1.baseLayoutAttrOverrides = n({
                    hoverlabel: o.hoverlabel
                }, "plot", "nested"), e1.plot = function(t1) {
                    var r = i(t1.calcdata, f)[0];
                    a(t1, r), e1.updateFx(t1);
                }, e1.clean = function(t1, e1, r, n) {
                    var i = n._has && n._has(f), a = e1._has && e1._has(f);
                    i && !a && (n._paperdiv.selectAll(".sankey").remove(), n._paperdiv.selectAll(".bgsankey").remove());
                }, e1.updateFx = function(t1) {
                    for(var e1 = 0; e1 < t1._fullData.length; e1++)p(t1, e1);
                };
            },
            22915: function(t1, e1, r) {
                "use strict";
                var n = r(26381), i = r(34809), a = r(71293).wrap, o = i.isArrayOrTypedArray, s = i.isIndex, l = r(88856);
                t1.exports = function(t1, e1) {
                    var r = function(t1) {
                        var e1, r = t1.node, a = t1.link, c = [], u = o(a.color), h = o(a.hovercolor), f = o(a.customdata), p = {}, d = {}, m = a.colorscales.length;
                        for(e1 = 0; e1 < m; e1++){
                            var g = a.colorscales[e1], y = l.extractScale(g, {
                                cLetter: "c"
                            }), v = l.makeColorScaleFunc(y);
                            d[g.label] = v;
                        }
                        var x = 0;
                        for(e1 = 0; e1 < a.value.length; e1++)a.source[e1] > x && (x = a.source[e1]), a.target[e1] > x && (x = a.target[e1]);
                        var _, b = x + 1;
                        t1.node._count = b;
                        var w = t1.node.groups, T = {};
                        for(e1 = 0; e1 < w.length; e1++){
                            var k = w[e1];
                            for(_ = 0; _ < k.length; _++){
                                var A = k[_], M = b + e1;
                                T.hasOwnProperty(A) ? i.warn("Node " + A + " is already part of a group.") : T[A] = M;
                            }
                        }
                        var S = {
                            source: [],
                            target: []
                        };
                        for(e1 = 0; e1 < a.value.length; e1++){
                            var E = a.value[e1], C = a.source[e1], L = a.target[e1];
                            if (E > 0 && s(C, b) && s(L, b) && (!T.hasOwnProperty(C) || !T.hasOwnProperty(L) || T[C] !== T[L])) {
                                T.hasOwnProperty(L) && (L = T[L]), T.hasOwnProperty(C) && (C = T[C]), L = +L, p[C = +C] = p[L] = !0;
                                var I = "";
                                a.label && a.label[e1] && (I = a.label[e1]);
                                var P = null;
                                I && d.hasOwnProperty(I) && (P = d[I]), c.push({
                                    pointNumber: e1,
                                    label: I,
                                    color: u ? a.color[e1] : a.color,
                                    hovercolor: h ? a.hovercolor[e1] : a.hovercolor,
                                    customdata: f ? a.customdata[e1] : a.customdata,
                                    concentrationscale: P,
                                    source: C,
                                    target: L,
                                    value: +E
                                }), S.source.push(C), S.target.push(L);
                            }
                        }
                        var z = b + w.length, O = o(r.color), D = o(r.customdata), R = [];
                        for(e1 = 0; e1 < z; e1++)if (p[e1]) {
                            var F = r.label[e1];
                            R.push({
                                group: e1 > b - 1,
                                childrenNodes: [],
                                pointNumber: e1,
                                label: F,
                                color: O ? r.color[e1] : r.color,
                                customdata: D ? r.customdata[e1] : r.customdata
                            });
                        }
                        var B = !1;
                        return function(t1, e1, r) {
                            for(var a = i.init2dArray(t1, 0), o = 0; o < Math.min(e1.length, r.length); o++)if (i.isIndex(e1[o], t1) && i.isIndex(r[o], t1)) {
                                if (e1[o] === r[o]) return !0;
                                a[e1[o]].push(r[o]);
                            }
                            return n(a).components.some(function(t1) {
                                return t1.length > 1;
                            });
                        }(z, S.source, S.target) && (B = !0), {
                            circular: B,
                            links: c,
                            nodes: R,
                            groups: w,
                            groupLookup: T
                        };
                    }(e1);
                    return a({
                        circular: r.circular,
                        _nodes: r.nodes,
                        _links: r.links,
                        _groups: r.groups,
                        _groupLookup: r.groupLookup
                    });
                };
            },
            21541: function(t1) {
                "use strict";
                t1.exports = {
                    nodeTextOffsetHorizontal: 4,
                    nodeTextOffsetVertical: 3,
                    nodePadAcross: 10,
                    sankeyIterations: 50,
                    forceIterations: 5,
                    forceTicksPerFrame: 10,
                    duration: 500,
                    ease: "linear",
                    cn: {
                        sankey: "sankey",
                        sankeyLinks: "sankey-links",
                        sankeyLink: "sankey-link",
                        sankeyNodeSet: "sankey-node-set",
                        sankeyNode: "sankey-node",
                        nodeRect: "node-rect",
                        nodeLabel: "node-label"
                    }
                };
            },
            67940: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(33795), a = r(78766), o = r(65657), s = r(13792).N, l = r(26430), c = r(78032), u = r(59008);
                function h(t1, e1) {
                    function r(r, a) {
                        return n.coerce(t1, e1, i.link.colorscales, r, a);
                    }
                    r("label"), r("cmin"), r("cmax"), r("colorscale");
                }
                t1.exports = function(t1, e1, r, f) {
                    function p(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    var d = n.extendDeep(f.hoverlabel, t1.hoverlabel), m = t1.node, g = c.newContainer(e1, "node");
                    function y(t1, e1) {
                        return n.coerce(m, g, i.node, t1, e1);
                    }
                    y("label"), y("groups"), y("x"), y("y"), y("pad"), y("thickness"), y("line.color"), y("line.width"), y("hoverinfo", t1.hoverinfo), l(m, g, y, d), y("hovertemplate"), y("align");
                    var v = f.colorway;
                    y("color", g.label.map(function(t1, e1) {
                        return a.addOpacity(function(t1) {
                            return v[t1 % v.length];
                        }(e1), .8);
                    })), y("customdata");
                    var x = t1.link || {}, _ = c.newContainer(e1, "link");
                    function b(t1, e1) {
                        return n.coerce(x, _, i.link, t1, e1);
                    }
                    b("label"), b("arrowlen"), b("source"), b("target"), b("value"), b("line.color"), b("line.width"), b("hoverinfo", t1.hoverinfo), l(x, _, b, d), b("hovertemplate");
                    var w, T = o(f.paper_bgcolor).getLuminance() < .333, k = b("color", T ? "rgba(255, 255, 255, 0.6)" : "rgba(0, 0, 0, 0.2)");
                    function A(t1) {
                        var e1 = o(t1);
                        if (!e1.isValid()) return t1;
                        var r = e1.getAlpha();
                        return r <= .8 ? e1.setAlpha(r + .2) : e1 = T ? e1.brighten() : e1.darken(), e1.toRgbString();
                    }
                    b("hovercolor", Array.isArray(k) ? k.map(A) : A(k)), b("customdata"), u(x, _, {
                        name: "colorscales",
                        handleItemDefaults: h
                    }), s(e1, f, p), p("orientation"), p("valueformat"), p("valuesuffix"), g.x.length && g.y.length && (w = "freeform"), p("arrangement", w), n.coerceFont(p, "textfont", f.font, {
                        autoShadowDflt: !0
                    }), e1._length = null;
                };
            },
            71760: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    attributes: r(33795),
                    supplyDefaults: r(67940),
                    calc: r(22915),
                    plot: r(16506),
                    moduleType: "trace",
                    name: "sankey",
                    basePlotModule: r(42229),
                    selectPoints: r(74670),
                    categories: [
                        "noOpacity"
                    ],
                    meta: {}
                };
            },
            16506: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(34809), a = i.numberFormat, o = r(90958), s = r(32141), l = r(78766), c = r(21541).cn, u = i._;
                function h(t1) {
                    return "" !== t1;
                }
                function f(t1, e1) {
                    return t1.filter(function(t1) {
                        return t1.key === e1.traceId;
                    });
                }
                function p(t1, e1) {
                    n.select(t1).select("path").style("fill-opacity", e1), n.select(t1).select("rect").style("fill-opacity", e1);
                }
                function d(t1) {
                    n.select(t1).select("text.name").style("fill", "black");
                }
                function m(t1) {
                    return function(e1) {
                        return -1 !== t1.node.sourceLinks.indexOf(e1.link) || -1 !== t1.node.targetLinks.indexOf(e1.link);
                    };
                }
                function g(t1) {
                    return function(e1) {
                        return -1 !== e1.node.sourceLinks.indexOf(t1.link) || -1 !== e1.node.targetLinks.indexOf(t1.link);
                    };
                }
                function y(t1, e1, r) {
                    e1 && r && f(r, e1).selectAll("." + c.sankeyLink).filter(m(e1)).call(x.bind(0, e1, r, !1));
                }
                function v(t1, e1, r) {
                    e1 && r && f(r, e1).selectAll("." + c.sankeyLink).filter(m(e1)).call(_.bind(0, e1, r, !1));
                }
                function x(t1, e1, r, n) {
                    n.style("fill", function(t1) {
                        if (!t1.link.concentrationscale) return t1.tinyColorHoverHue;
                    }).style("fill-opacity", function(t1) {
                        if (!t1.link.concentrationscale) return t1.tinyColorHoverAlpha;
                    }), n.each(function(r) {
                        var n = r.link.label;
                        "" !== n && f(e1, t1).selectAll("." + c.sankeyLink).filter(function(t1) {
                            return t1.link.label === n;
                        }).style("fill", function(t1) {
                            if (!t1.link.concentrationscale) return t1.tinyColorHoverHue;
                        }).style("fill-opacity", function(t1) {
                            if (!t1.link.concentrationscale) return t1.tinyColorHoverAlpha;
                        });
                    }), r && f(e1, t1).selectAll("." + c.sankeyNode).filter(g(t1)).call(y);
                }
                function _(t1, e1, r, n) {
                    n.style("fill", function(t1) {
                        return t1.tinyColorHue;
                    }).style("fill-opacity", function(t1) {
                        return t1.tinyColorAlpha;
                    }), n.each(function(r) {
                        var n = r.link.label;
                        "" !== n && f(e1, t1).selectAll("." + c.sankeyLink).filter(function(t1) {
                            return t1.link.label === n;
                        }).style("fill", function(t1) {
                            return t1.tinyColorHue;
                        }).style("fill-opacity", function(t1) {
                            return t1.tinyColorAlpha;
                        });
                    }), r && f(e1, t1).selectAll(c.sankeyNode).filter(g(t1)).call(v);
                }
                function b(t1, e1) {
                    var r = t1.hoverlabel || {}, n = i.nestedProperty(r, e1).get();
                    return !Array.isArray(n) && n;
                }
                t1.exports = function(t1, e1) {
                    for(var r = t1._fullLayout, i = r._paper, f = r._size, m = 0; m < t1._fullData.length; m++)if (t1._fullData[m].visible && t1._fullData[m].type === c.sankey && !t1._fullData[m]._viewInitial) {
                        var g = t1._fullData[m].node;
                        t1._fullData[m]._viewInitial = {
                            node: {
                                groups: g.groups.slice(),
                                x: g.x.slice(),
                                y: g.y.slice()
                            }
                        };
                    }
                    var w = u(t1, "source:") + " ", T = u(t1, "target:") + " ", k = u(t1, "concentration:") + " ", A = u(t1, "incoming flow count:") + " ", M = u(t1, "outgoing flow count:") + " ";
                    o(t1, i, e1, {
                        width: f.w,
                        height: f.h,
                        margin: {
                            t: f.t,
                            r: f.r,
                            b: f.b,
                            l: f.l
                        }
                    }, {
                        linkEvents: {
                            hover: function(e1, r, i) {
                                !1 !== t1._fullLayout.hovermode && (n.select(e1).call(x.bind(0, r, i, !0)), "skip" !== r.link.trace.link.hoverinfo && (r.link.fullData = r.link.trace, t1.emit("plotly_hover", {
                                    event: n.event,
                                    points: [
                                        r.link
                                    ]
                                })));
                            },
                            follow: function(e1, i) {
                                if (!1 !== t1._fullLayout.hovermode) {
                                    var o = i.link.trace.link;
                                    if ("none" !== o.hoverinfo && "skip" !== o.hoverinfo) {
                                        for(var c = [], u = 0, f = 0; f < i.flow.links.length; f++){
                                            var m = i.flow.links[f];
                                            if ("closest" !== t1._fullLayout.hovermode || i.link.pointNumber === m.pointNumber) {
                                                i.link.pointNumber === m.pointNumber && (u = f), m.fullData = m.trace, o = i.link.trace.link;
                                                var g = v(m), y = {
                                                    valueLabel: a(i.valueFormat)(m.value) + i.valueSuffix
                                                };
                                                c.push({
                                                    x: g[0],
                                                    y: g[1],
                                                    name: y.valueLabel,
                                                    text: [
                                                        m.label || "",
                                                        w + m.source.label,
                                                        T + m.target.label,
                                                        m.concentrationscale ? k + a("%0.2f")(m.flow.labelConcentration) : ""
                                                    ].filter(h).join("<br>"),
                                                    color: b(o, "bgcolor") || l.addOpacity(m.color, 1),
                                                    borderColor: b(o, "bordercolor"),
                                                    fontFamily: b(o, "font.family"),
                                                    fontSize: b(o, "font.size"),
                                                    fontColor: b(o, "font.color"),
                                                    fontWeight: b(o, "font.weight"),
                                                    fontStyle: b(o, "font.style"),
                                                    fontVariant: b(o, "font.variant"),
                                                    fontTextcase: b(o, "font.textcase"),
                                                    fontLineposition: b(o, "font.lineposition"),
                                                    fontShadow: b(o, "font.shadow"),
                                                    nameLength: b(o, "namelength"),
                                                    textAlign: b(o, "align"),
                                                    idealAlign: n.event.x < g[0] ? "right" : "left",
                                                    hovertemplate: o.hovertemplate,
                                                    hovertemplateLabels: y,
                                                    eventData: [
                                                        m
                                                    ]
                                                });
                                            }
                                        }
                                        s.loneHover(c, {
                                            container: r._hoverlayer.node(),
                                            outerContainer: r._paper.node(),
                                            gd: t1,
                                            anchorIndex: u
                                        }).each(function() {
                                            i.link.concentrationscale || p(this, .65), d(this);
                                        });
                                    }
                                }
                                function v(t1) {
                                    var e1, r;
                                    t1.circular ? (e1 = (t1.circularPathData.leftInnerExtent + t1.circularPathData.rightInnerExtent) / 2, r = t1.circularPathData.verticalFullExtent) : (e1 = (t1.source.x1 + t1.target.x0) / 2, r = (t1.y0 + t1.y1) / 2);
                                    var n = [
                                        e1,
                                        r
                                    ];
                                    return "v" === t1.trace.orientation && n.reverse(), n[0] += i.parent.translateX, n[1] += i.parent.translateY, n;
                                }
                            },
                            unhover: function(e1, i, a) {
                                !1 !== t1._fullLayout.hovermode && (n.select(e1).call(_.bind(0, i, a, !0)), "skip" !== i.link.trace.link.hoverinfo && (i.link.fullData = i.link.trace, t1.emit("plotly_unhover", {
                                    event: n.event,
                                    points: [
                                        i.link
                                    ]
                                })), s.loneUnhover(r._hoverlayer.node()));
                            },
                            select: function(e1, r) {
                                var i = r.link;
                                i.originalEvent = n.event, t1._hoverdata = [
                                    i
                                ], s.click(t1, {
                                    target: !0
                                });
                            }
                        },
                        nodeEvents: {
                            hover: function(e1, r, i) {
                                !1 !== t1._fullLayout.hovermode && (n.select(e1).call(y, r, i), "skip" !== r.node.trace.node.hoverinfo && (r.node.fullData = r.node.trace, t1.emit("plotly_hover", {
                                    event: n.event,
                                    points: [
                                        r.node
                                    ]
                                })));
                            },
                            follow: function(e1, i) {
                                if (!1 !== t1._fullLayout.hovermode) {
                                    var o = i.node.trace.node;
                                    if ("none" !== o.hoverinfo && "skip" !== o.hoverinfo) {
                                        var l = n.select(e1).select("." + c.nodeRect), u = t1._fullLayout._paperdiv.node().getBoundingClientRect(), f = l.node().getBoundingClientRect(), m = f.left - 2 - u.left, g = f.right + 2 - u.left, y = f.top + f.height / 4 - u.top, v = {
                                            valueLabel: a(i.valueFormat)(i.node.value) + i.valueSuffix
                                        };
                                        i.node.fullData = i.node.trace, t1._fullLayout._calcInverseTransform(t1);
                                        var x = t1._fullLayout._invScaleX, _ = t1._fullLayout._invScaleY, w = s.loneHover({
                                            x0: x * m,
                                            x1: x * g,
                                            y: _ * y,
                                            name: a(i.valueFormat)(i.node.value) + i.valueSuffix,
                                            text: [
                                                i.node.label,
                                                A + i.node.targetLinks.length,
                                                M + i.node.sourceLinks.length
                                            ].filter(h).join("<br>"),
                                            color: b(o, "bgcolor") || i.tinyColorHue,
                                            borderColor: b(o, "bordercolor"),
                                            fontFamily: b(o, "font.family"),
                                            fontSize: b(o, "font.size"),
                                            fontColor: b(o, "font.color"),
                                            fontWeight: b(o, "font.weight"),
                                            fontStyle: b(o, "font.style"),
                                            fontVariant: b(o, "font.variant"),
                                            fontTextcase: b(o, "font.textcase"),
                                            fontLineposition: b(o, "font.lineposition"),
                                            fontShadow: b(o, "font.shadow"),
                                            nameLength: b(o, "namelength"),
                                            textAlign: b(o, "align"),
                                            idealAlign: "left",
                                            hovertemplate: o.hovertemplate,
                                            hovertemplateLabels: v,
                                            eventData: [
                                                i.node
                                            ]
                                        }, {
                                            container: r._hoverlayer.node(),
                                            outerContainer: r._paper.node(),
                                            gd: t1
                                        });
                                        p(w, .85), d(w);
                                    }
                                }
                            },
                            unhover: function(e1, i, a) {
                                !1 !== t1._fullLayout.hovermode && (n.select(e1).call(v, i, a), "skip" !== i.node.trace.node.hoverinfo && (i.node.fullData = i.node.trace, t1.emit("plotly_unhover", {
                                    event: n.event,
                                    points: [
                                        i.node
                                    ]
                                })), s.loneUnhover(r._hoverlayer.node()));
                            },
                            select: function(e1, r, i) {
                                var a = r.node;
                                a.originalEvent = n.event, t1._hoverdata = [
                                    a
                                ], n.select(e1).call(v, r, i), s.click(t1, {
                                    target: !0
                                });
                            }
                        }
                    });
                };
            },
            90958: function(t1, e1, r) {
                "use strict";
                var n = r(32702), i = r(88640).Dj, a = r(45568), o = r(62369), s = r(68735), l = r(21541), c = r(65657), u = r(78766), h = r(62203), f = r(34809), p = f.strTranslate, d = f.strRotate, m = r(71293), g = m.keyFun, y = m.repeat, v = m.unwrap, x = r(30635), _ = r(33626), b = r(4530), w = b.CAP_SHIFT, T = b.LINE_SPACING;
                function k(t1, e1, r) {
                    var n, i = v(e1), a = i.trace, u = a.domain, h = "h" === a.orientation, p = a.node.pad, d = a.node.thickness, m = {
                        justify: o.sankeyJustify,
                        left: o.sankeyLeft,
                        right: o.sankeyRight,
                        center: o.sankeyCenter
                    }[a.node.align], g = t1.width * (u.x[1] - u.x[0]), y = t1.height * (u.y[1] - u.y[0]), x = i._nodes, _ = i._links, b = i.circular;
                    (n = b ? s.sankeyCircular().circularLinkGap(0) : o.sankey()).iterations(l.sankeyIterations).size(h ? [
                        g,
                        y
                    ] : [
                        y,
                        g
                    ]).nodeWidth(d).nodePadding(p).nodeId(function(t1) {
                        return t1.pointNumber;
                    }).nodeAlign(m).nodes(x).links(_);
                    var w, T, k, A = n();
                    for(var M in n.nodePadding() < p && f.warn("node.pad was reduced to ", n.nodePadding(), " to fit within the figure."), i._groupLookup){
                        var S, E = parseInt(i._groupLookup[M]);
                        for(w = 0; w < A.nodes.length; w++)if (A.nodes[w].pointNumber === E) {
                            S = A.nodes[w];
                            break;
                        }
                        if (S) {
                            var C = {
                                pointNumber: parseInt(M),
                                x0: S.x0,
                                x1: S.x1,
                                y0: S.y0,
                                y1: S.y1,
                                partOfGroup: !0,
                                sourceLinks: [],
                                targetLinks: []
                            };
                            A.nodes.unshift(C), S.childrenNodes.unshift(C);
                        }
                    }
                    if (function() {
                        for(w = 0; w < A.nodes.length; w++){
                            var t1, e1, r = A.nodes[w], n = {};
                            for(T = 0; T < r.targetLinks.length; T++)t1 = (e1 = r.targetLinks[T]).source.pointNumber + ":" + e1.target.pointNumber, n.hasOwnProperty(t1) || (n[t1] = []), n[t1].push(e1);
                            var i = Object.keys(n);
                            for(T = 0; T < i.length; T++){
                                var a = n[t1 = i[T]], o = 0, s = {};
                                for(k = 0; k < a.length; k++)s[(e1 = a[k]).label] || (s[e1.label] = 0), s[e1.label] += e1.value, o += e1.value;
                                for(k = 0; k < a.length; k++)(e1 = a[k]).flow = {
                                    value: o,
                                    labelConcentration: s[e1.label] / o,
                                    concentration: e1.value / o,
                                    links: a
                                }, e1.concentrationscale && (e1.color = c(e1.concentrationscale(e1.flow.labelConcentration)));
                            }
                            var l = 0;
                            for(T = 0; T < r.sourceLinks.length; T++)l += r.sourceLinks[T].value;
                            for(T = 0; T < r.sourceLinks.length; T++)(e1 = r.sourceLinks[T]).concentrationOut = e1.value / l;
                            var u = 0;
                            for(T = 0; T < r.targetLinks.length; T++)u += r.targetLinks[T].value;
                            for(T = 0; T < r.targetLinks.length; T++)(e1 = r.targetLinks[T]).concenrationIn = e1.value / u;
                        }
                    }(), a.node.x.length && a.node.y.length) {
                        for(w = 0; w < Math.min(a.node.x.length, a.node.y.length, A.nodes.length); w++)if (a.node.x[w] && a.node.y[w]) {
                            var L = [
                                a.node.x[w] * g,
                                a.node.y[w] * y
                            ];
                            A.nodes[w].x0 = L[0] - d / 2, A.nodes[w].x1 = L[0] + d / 2;
                            var I = A.nodes[w].y1 - A.nodes[w].y0;
                            A.nodes[w].y0 = L[1] - I / 2, A.nodes[w].y1 = L[1] + I / 2;
                        }
                        "snap" === a.arrangement && (function(t1) {
                            var e1, r, n = t1.map(function(t1, e1) {
                                return {
                                    x0: t1.x0,
                                    index: e1
                                };
                            }).sort(function(t1, e1) {
                                return t1.x0 - e1.x0;
                            }), i = [], a = -1, o = -1 / 0;
                            for(w = 0; w < n.length; w++){
                                var s = t1[n[w].index];
                                s.x0 > o + d && (a += 1, e1 = s.x0), o = s.x0, i[a] || (i[a] = []), i[a].push(s), r = e1 - s.x0, s.x0 += r, s.x1 += r;
                            }
                            return i;
                        })(x = A.nodes).forEach(function(t1) {
                            var e1, r, n, i = 0, a = t1.length;
                            for(t1.sort(function(t1, e1) {
                                return t1.y0 - e1.y0;
                            }), n = 0; n < a; ++n)(e1 = t1[n]).y0 >= i || (r = i - e1.y0) > 1e-6 && (e1.y0 += r, e1.y1 += r), i = e1.y1 + p;
                        }), n.update(A);
                    }
                    return {
                        circular: b,
                        key: r,
                        trace: a,
                        guid: f.randstr(),
                        horizontal: h,
                        width: g,
                        height: y,
                        nodePad: a.node.pad,
                        nodeLineColor: a.node.line.color,
                        nodeLineWidth: a.node.line.width,
                        linkLineColor: a.link.line.color,
                        linkLineWidth: a.link.line.width,
                        linkArrowLength: a.link.arrowlen,
                        valueFormat: a.valueformat,
                        valueSuffix: a.valuesuffix,
                        textFont: a.textfont,
                        translateX: u.x[0] * t1.width + t1.margin.l,
                        translateY: t1.height - u.y[1] * t1.height + t1.margin.t,
                        dragParallel: h ? y : g,
                        dragPerpendicular: h ? g : y,
                        arrangement: a.arrangement,
                        sankey: n,
                        graph: A,
                        forceLayouts: {},
                        interactionState: {
                            dragInProgress: !1,
                            hovered: !1
                        }
                    };
                }
                function A(t1, e1, r) {
                    var n = c(e1.color), i = c(e1.hovercolor), a = e1.source.label + "|" + e1.target.label + "__" + r;
                    return e1.trace = t1.trace, e1.curveNumber = t1.trace.index, {
                        circular: t1.circular,
                        key: a,
                        traceId: t1.key,
                        pointNumber: e1.pointNumber,
                        link: e1,
                        tinyColorHue: u.tinyRGB(n),
                        tinyColorAlpha: n.getAlpha(),
                        tinyColorHoverHue: u.tinyRGB(i),
                        tinyColorHoverAlpha: i.getAlpha(),
                        linkPath: M,
                        linkLineColor: t1.linkLineColor,
                        linkLineWidth: t1.linkLineWidth,
                        linkArrowLength: t1.linkArrowLength,
                        valueFormat: t1.valueFormat,
                        valueSuffix: t1.valueSuffix,
                        sankey: t1.sankey,
                        parent: t1,
                        interactionState: t1.interactionState,
                        flow: e1.flow
                    };
                }
                function M() {
                    return function(t1) {
                        var e1 = t1.linkArrowLength;
                        if (t1.link.circular) return function(t1, e1) {
                            var r = t1.width / 2, n = t1.circularPathData;
                            return "top" === t1.circularLinkType ? "M " + (n.targetX - e1) + " " + (n.targetY + r) + " L" + (n.rightInnerExtent - e1) + " " + (n.targetY + r) + "A" + (n.rightLargeArcRadius + r) + " " + (n.rightSmallArcRadius + r) + " 0 0 1 " + (n.rightFullExtent - r - e1) + " " + (n.targetY - n.rightSmallArcRadius) + "L" + (n.rightFullExtent - r - e1) + " " + n.verticalRightInnerExtent + "A" + (n.rightLargeArcRadius + r) + " " + (n.rightLargeArcRadius + r) + " 0 0 1 " + (n.rightInnerExtent - e1) + " " + (n.verticalFullExtent - r) + "L" + n.leftInnerExtent + " " + (n.verticalFullExtent - r) + "A" + (n.leftLargeArcRadius + r) + " " + (n.leftLargeArcRadius + r) + " 0 0 1 " + (n.leftFullExtent + r) + " " + n.verticalLeftInnerExtent + "L" + (n.leftFullExtent + r) + " " + (n.sourceY - n.leftSmallArcRadius) + "A" + (n.leftLargeArcRadius + r) + " " + (n.leftSmallArcRadius + r) + " 0 0 1 " + n.leftInnerExtent + " " + (n.sourceY + r) + "L" + n.sourceX + " " + (n.sourceY + r) + "L" + n.sourceX + " " + (n.sourceY - r) + "L" + n.leftInnerExtent + " " + (n.sourceY - r) + "A" + (n.leftLargeArcRadius - r) + " " + (n.leftSmallArcRadius - r) + " 0 0 0 " + (n.leftFullExtent - r) + " " + (n.sourceY - n.leftSmallArcRadius) + "L" + (n.leftFullExtent - r) + " " + n.verticalLeftInnerExtent + "A" + (n.leftLargeArcRadius - r) + " " + (n.leftLargeArcRadius - r) + " 0 0 0 " + n.leftInnerExtent + " " + (n.verticalFullExtent + r) + "L" + (n.rightInnerExtent - e1) + " " + (n.verticalFullExtent + r) + "A" + (n.rightLargeArcRadius - r) + " " + (n.rightLargeArcRadius - r) + " 0 0 0 " + (n.rightFullExtent + r - e1) + " " + n.verticalRightInnerExtent + "L" + (n.rightFullExtent + r - e1) + " " + (n.targetY - n.rightSmallArcRadius) + "A" + (n.rightLargeArcRadius - r) + " " + (n.rightSmallArcRadius - r) + " 0 0 0 " + (n.rightInnerExtent - e1) + " " + (n.targetY - r) + "L" + (n.targetX - e1) + " " + (n.targetY - r) + (e1 > 0 ? "L" + n.targetX + " " + n.targetY : "") + "Z" : "M " + (n.targetX - e1) + " " + (n.targetY - r) + " L" + (n.rightInnerExtent - e1) + " " + (n.targetY - r) + "A" + (n.rightLargeArcRadius + r) + " " + (n.rightSmallArcRadius + r) + " 0 0 0 " + (n.rightFullExtent - r - e1) + " " + (n.targetY + n.rightSmallArcRadius) + "L" + (n.rightFullExtent - r - e1) + " " + n.verticalRightInnerExtent + "A" + (n.rightLargeArcRadius + r) + " " + (n.rightLargeArcRadius + r) + " 0 0 0 " + (n.rightInnerExtent - e1) + " " + (n.verticalFullExtent + r) + "L" + n.leftInnerExtent + " " + (n.verticalFullExtent + r) + "A" + (n.leftLargeArcRadius + r) + " " + (n.leftLargeArcRadius + r) + " 0 0 0 " + (n.leftFullExtent + r) + " " + n.verticalLeftInnerExtent + "L" + (n.leftFullExtent + r) + " " + (n.sourceY + n.leftSmallArcRadius) + "A" + (n.leftLargeArcRadius + r) + " " + (n.leftSmallArcRadius + r) + " 0 0 0 " + n.leftInnerExtent + " " + (n.sourceY - r) + "L" + n.sourceX + " " + (n.sourceY - r) + "L" + n.sourceX + " " + (n.sourceY + r) + "L" + n.leftInnerExtent + " " + (n.sourceY + r) + "A" + (n.leftLargeArcRadius - r) + " " + (n.leftSmallArcRadius - r) + " 0 0 1 " + (n.leftFullExtent - r) + " " + (n.sourceY + n.leftSmallArcRadius) + "L" + (n.leftFullExtent - r) + " " + n.verticalLeftInnerExtent + "A" + (n.leftLargeArcRadius - r) + " " + (n.leftLargeArcRadius - r) + " 0 0 1 " + n.leftInnerExtent + " " + (n.verticalFullExtent - r) + "L" + (n.rightInnerExtent - e1) + " " + (n.verticalFullExtent - r) + "A" + (n.rightLargeArcRadius - r) + " " + (n.rightLargeArcRadius - r) + " 0 0 1 " + (n.rightFullExtent + r - e1) + " " + n.verticalRightInnerExtent + "L" + (n.rightFullExtent + r - e1) + " " + (n.targetY + n.rightSmallArcRadius) + "A" + (n.rightLargeArcRadius - r) + " " + (n.rightSmallArcRadius - r) + " 0 0 1 " + (n.rightInnerExtent - e1) + " " + (n.targetY + r) + "L" + (n.targetX - e1) + " " + (n.targetY + r) + (e1 > 0 ? "L" + n.targetX + " " + n.targetY : "") + "Z";
                        }(t1.link, e1);
                        var r = Math.abs((t1.link.target.x0 - t1.link.source.x1) / 2);
                        e1 > r && (e1 = r);
                        var n = t1.link.source.x1, a = t1.link.target.x0 - e1, o = i(n, a), s = o(.5), l = o(.5), c = t1.link.y0 - t1.link.width / 2, u = t1.link.y0 + t1.link.width / 2, h = t1.link.y1 - t1.link.width / 2, f = t1.link.y1 + t1.link.width / 2, p = "M" + n + "," + c, d = "C" + s + "," + c + " " + l + "," + h + " " + a + "," + h, m = "C" + l + "," + f + " " + s + "," + u + " " + n + "," + u, g = e1 > 0 ? "L" + (a + e1) + "," + (h + t1.link.width / 2) : "";
                        return p + d + (g += "L" + a + "," + f) + m + "Z";
                    };
                }
                function S(t1, e1) {
                    var r = c(e1.color), n = l.nodePadAcross, i = t1.nodePad / 2;
                    e1.dx = e1.x1 - e1.x0, e1.dy = e1.y1 - e1.y0;
                    var a = e1.dx, o = Math.max(.5, e1.dy), s = "node_" + e1.pointNumber;
                    return e1.group && (s = f.randstr()), e1.trace = t1.trace, e1.curveNumber = t1.trace.index, {
                        index: e1.pointNumber,
                        key: s,
                        partOfGroup: e1.partOfGroup || !1,
                        group: e1.group,
                        traceId: t1.key,
                        trace: t1.trace,
                        node: e1,
                        nodePad: t1.nodePad,
                        nodeLineColor: t1.nodeLineColor,
                        nodeLineWidth: t1.nodeLineWidth,
                        textFont: t1.textFont,
                        size: t1.horizontal ? t1.height : t1.width,
                        visibleWidth: Math.ceil(a),
                        visibleHeight: o,
                        zoneX: -n,
                        zoneY: -i,
                        zoneWidth: a + 2 * n,
                        zoneHeight: o + 2 * i,
                        labelY: t1.horizontal ? e1.dy / 2 + 1 : e1.dx / 2 + 1,
                        left: 1 === e1.originalLayer,
                        sizeAcross: t1.width,
                        forceLayouts: t1.forceLayouts,
                        horizontal: t1.horizontal,
                        darkBackground: r.getBrightness() <= 128,
                        tinyColorHue: u.tinyRGB(r),
                        tinyColorAlpha: r.getAlpha(),
                        valueFormat: t1.valueFormat,
                        valueSuffix: t1.valueSuffix,
                        sankey: t1.sankey,
                        graph: t1.graph,
                        arrangement: t1.arrangement,
                        uniqueNodeLabelPathId: [
                            t1.guid,
                            t1.key,
                            s
                        ].join("_"),
                        interactionState: t1.interactionState,
                        figure: t1
                    };
                }
                function E(t1) {
                    t1.attr("transform", function(t1) {
                        return p(t1.node.x0.toFixed(3), t1.node.y0.toFixed(3));
                    });
                }
                function C(t1) {
                    t1.call(E);
                }
                function L(t1, e1) {
                    t1.call(C), e1.attr("d", M());
                }
                function I(t1) {
                    t1.attr("width", function(t1) {
                        return t1.node.x1 - t1.node.x0;
                    }).attr("height", function(t1) {
                        return t1.visibleHeight;
                    });
                }
                function P(t1) {
                    return t1.link.width > 1 || t1.linkLineWidth > 0;
                }
                function z(t1) {
                    return p(t1.translateX, t1.translateY) + (t1.horizontal ? "matrix(1 0 0 1 0 0)" : "matrix(0 1 1 0 0 0)");
                }
                function O(t1, e1, r) {
                    t1.on(".basic", null).on("mouseover.basic", function(t1) {
                        t1.interactionState.dragInProgress || t1.partOfGroup || (r.hover(this, t1, e1), t1.interactionState.hovered = [
                            this,
                            t1
                        ]);
                    }).on("mousemove.basic", function(t1) {
                        t1.interactionState.dragInProgress || t1.partOfGroup || (r.follow(this, t1), t1.interactionState.hovered = [
                            this,
                            t1
                        ]);
                    }).on("mouseout.basic", function(t1) {
                        t1.interactionState.dragInProgress || t1.partOfGroup || (r.unhover(this, t1, e1), t1.interactionState.hovered = !1);
                    }).on("click.basic", function(t1) {
                        t1.interactionState.hovered && (r.unhover(this, t1, e1), t1.interactionState.hovered = !1), t1.interactionState.dragInProgress || t1.partOfGroup || r.select(this, t1, e1);
                    });
                }
                function D(t1, e1, r, i) {
                    var o = a.behavior.drag().origin(function(t1) {
                        return {
                            x: t1.node.x0 + t1.visibleWidth / 2,
                            y: t1.node.y0 + t1.visibleHeight / 2
                        };
                    }).on("dragstart", function(a) {
                        if ("fixed" !== a.arrangement && (f.ensureSingle(i._fullLayout._infolayer, "g", "dragcover", function(t1) {
                            i._fullLayout._dragCover = t1;
                        }), f.raiseToTop(this), a.interactionState.dragInProgress = a.node, F(a.node), a.interactionState.hovered && (r.nodeEvents.unhover.apply(0, a.interactionState.hovered), a.interactionState.hovered = !1), "snap" === a.arrangement)) {
                            var o = a.traceId + "|" + a.key;
                            a.forceLayouts[o] ? a.forceLayouts[o].alpha(1) : function(t1, e1, r, i) {
                                !function(t1) {
                                    for(var e1 = 0; e1 < t1.length; e1++)t1[e1].y = (t1[e1].y0 + t1[e1].y1) / 2, t1[e1].x = (t1[e1].x0 + t1[e1].x1) / 2;
                                }(r.graph.nodes);
                                var a = r.graph.nodes.filter(function(t1) {
                                    return t1.originalX === r.node.originalX;
                                }).filter(function(t1) {
                                    return !t1.partOfGroup;
                                });
                                r.forceLayouts[e1] = n.forceSimulation(a).alphaDecay(0).force("collide", n.forceCollide().radius(function(t1) {
                                    return t1.dy / 2 + r.nodePad / 2;
                                }).strength(1).iterations(l.forceIterations)).force("constrain", function(t1, e1, r, n) {
                                    return function() {
                                        for(var t1 = 0, i = 0; i < r.length; i++){
                                            var a = r[i];
                                            a === n.interactionState.dragInProgress ? (a.x = a.lastDraggedX, a.y = a.lastDraggedY) : (a.vx = (a.originalX - a.x) / l.forceTicksPerFrame, a.y = Math.min(n.size - a.dy / 2, Math.max(a.dy / 2, a.y))), t1 = Math.max(t1, Math.abs(a.vx), Math.abs(a.vy));
                                        }
                                        !n.interactionState.dragInProgress && t1 < .1 && n.forceLayouts[e1].alpha() > 0 && n.forceLayouts[e1].alpha(0);
                                    };
                                }(0, e1, a, r)).stop();
                            }(0, o, a), function(t1, e1, r, n, i) {
                                window.requestAnimationFrame(function a() {
                                    var o;
                                    for(o = 0; o < l.forceTicksPerFrame; o++)r.forceLayouts[n].tick();
                                    if (function(t1) {
                                        for(var e1 = 0; e1 < t1.length; e1++)t1[e1].y0 = t1[e1].y - t1[e1].dy / 2, t1[e1].y1 = t1[e1].y0 + t1[e1].dy, t1[e1].x0 = t1[e1].x - t1[e1].dx / 2, t1[e1].x1 = t1[e1].x0 + t1[e1].dx;
                                    }(r.graph.nodes), r.sankey.update(r.graph), L(t1.filter(B(r)), e1), r.forceLayouts[n].alpha() > 0) window.requestAnimationFrame(a);
                                    else {
                                        var s = r.node.originalX;
                                        r.node.x0 = s - r.visibleWidth / 2, r.node.x1 = s + r.visibleWidth / 2, R(r, i);
                                    }
                                });
                            }(t1, e1, a, o, i);
                        }
                    }).on("drag", function(r) {
                        if ("fixed" !== r.arrangement) {
                            var n = a.event.x, i = a.event.y;
                            "snap" === r.arrangement ? (r.node.x0 = n - r.visibleWidth / 2, r.node.x1 = n + r.visibleWidth / 2, r.node.y0 = i - r.visibleHeight / 2, r.node.y1 = i + r.visibleHeight / 2) : ("freeform" === r.arrangement && (r.node.x0 = n - r.visibleWidth / 2, r.node.x1 = n + r.visibleWidth / 2), i = Math.max(0, Math.min(r.size - r.visibleHeight / 2, i)), r.node.y0 = i - r.visibleHeight / 2, r.node.y1 = i + r.visibleHeight / 2), F(r.node), "snap" !== r.arrangement && (r.sankey.update(r.graph), L(t1.filter(B(r)), e1));
                        }
                    }).on("dragend", function(t1) {
                        if ("fixed" !== t1.arrangement) {
                            t1.interactionState.dragInProgress = !1;
                            for(var e1 = 0; e1 < t1.node.childrenNodes.length; e1++)t1.node.childrenNodes[e1].x = t1.node.x, t1.node.childrenNodes[e1].y = t1.node.y;
                            "snap" !== t1.arrangement && R(t1, i);
                        }
                    });
                    t1.on(".drag", null).call(o);
                }
                function R(t1, e1) {
                    for(var r = [], n = [], i = 0; i < t1.graph.nodes.length; i++){
                        var a = (t1.graph.nodes[i].x0 + t1.graph.nodes[i].x1) / 2, o = (t1.graph.nodes[i].y0 + t1.graph.nodes[i].y1) / 2;
                        r.push(a / t1.figure.width), n.push(o / t1.figure.height);
                    }
                    _.call("_guiRestyle", e1, {
                        "node.x": [
                            r
                        ],
                        "node.y": [
                            n
                        ]
                    }, t1.trace.index).then(function() {
                        e1._fullLayout._dragCover && e1._fullLayout._dragCover.remove();
                    });
                }
                function F(t1) {
                    t1.lastDraggedX = t1.x0 + t1.dx / 2, t1.lastDraggedY = t1.y0 + t1.dy / 2;
                }
                function B(t1) {
                    return function(e1) {
                        return e1.node.originalX === t1.node.originalX;
                    };
                }
                t1.exports = function(t1, e1, r, n, i) {
                    var o = t1._context.staticPlot, s = !1;
                    f.ensureSingle(t1._fullLayout._infolayer, "g", "first-render", function() {
                        s = !0;
                    });
                    var m = t1._fullLayout._dragCover, _ = r.filter(function(t1) {
                        return v(t1).trace.visible;
                    }).map(k.bind(null, n)), b = e1.selectAll("." + l.cn.sankey).data(_, g);
                    b.exit().remove(), b.enter().append("g").classed(l.cn.sankey, !0).style("box-sizing", "content-box").style("position", "absolute").style("left", 0).style("shape-rendering", "geometricPrecision").style("pointer-events", o ? "none" : "auto").attr("transform", z), b.each(function(e1, r) {
                        t1._fullData[r]._sankey = e1;
                        var n = "bgsankey-" + e1.trace.uid + "-" + r;
                        f.ensureSingle(t1._fullLayout._draggers, "rect", n), t1._fullData[r]._bgRect = a.select("." + n), t1._fullData[r]._bgRect.style("pointer-events", o ? "none" : "all").attr("width", e1.width).attr("height", e1.height).attr("x", e1.translateX).attr("y", e1.translateY).classed("bgsankey", !0).style({
                            fill: "transparent",
                            "stroke-width": 0
                        });
                    }), b.transition().ease(l.ease).duration(l.duration).attr("transform", z);
                    var C = b.selectAll("." + l.cn.sankeyLinks).data(y, g);
                    C.enter().append("g").classed(l.cn.sankeyLinks, !0).style("fill", "none");
                    var L = C.selectAll("." + l.cn.sankeyLink).data(function(t1) {
                        return t1.graph.links.filter(function(t1) {
                            return t1.value;
                        }).map(A.bind(null, t1));
                    }, g);
                    L.enter().append("path").classed(l.cn.sankeyLink, !0).call(O, b, i.linkEvents), L.style("stroke", function(t1) {
                        return P(t1) ? u.tinyRGB(c(t1.linkLineColor)) : t1.tinyColorHue;
                    }).style("stroke-opacity", function(t1) {
                        return P(t1) ? u.opacity(t1.linkLineColor) : t1.tinyColorAlpha;
                    }).style("fill", function(t1) {
                        return t1.tinyColorHue;
                    }).style("fill-opacity", function(t1) {
                        return t1.tinyColorAlpha;
                    }).style("stroke-width", function(t1) {
                        return P(t1) ? t1.linkLineWidth : 1;
                    }).attr("d", M()), L.style("opacity", function() {
                        return t1._context.staticPlot || s || m ? 1 : 0;
                    }).transition().ease(l.ease).duration(l.duration).style("opacity", 1), L.exit().transition().ease(l.ease).duration(l.duration).style("opacity", 0).remove();
                    var R = b.selectAll("." + l.cn.sankeyNodeSet).data(y, g);
                    R.enter().append("g").classed(l.cn.sankeyNodeSet, !0), R.style("cursor", function(t1) {
                        switch(t1.arrangement){
                            case "fixed":
                                return "default";
                            case "perpendicular":
                                return "ns-resize";
                            default:
                                return "move";
                        }
                    });
                    var F = R.selectAll("." + l.cn.sankeyNode).data(function(t1) {
                        var e1 = t1.graph.nodes;
                        return function(t1) {
                            var e1, r = [];
                            for(e1 = 0; e1 < t1.length; e1++)t1[e1].originalX = (t1[e1].x0 + t1[e1].x1) / 2, t1[e1].originalY = (t1[e1].y0 + t1[e1].y1) / 2, -1 === r.indexOf(t1[e1].originalX) && r.push(t1[e1].originalX);
                            for(r.sort(function(t1, e1) {
                                return t1 - e1;
                            }), e1 = 0; e1 < t1.length; e1++)t1[e1].originalLayerIndex = r.indexOf(t1[e1].originalX), t1[e1].originalLayer = t1[e1].originalLayerIndex / (r.length - 1);
                        }(e1), e1.map(S.bind(null, t1));
                    }, g);
                    F.enter().append("g").classed(l.cn.sankeyNode, !0).call(E).style("opacity", function(e1) {
                        return !t1._context.staticPlot && !s || e1.partOfGroup ? 0 : 1;
                    }), F.call(O, b, i.nodeEvents).call(D, L, i, t1), F.transition().ease(l.ease).duration(l.duration).call(E).style("opacity", function(t1) {
                        return t1.partOfGroup ? 0 : 1;
                    }), F.exit().transition().ease(l.ease).duration(l.duration).style("opacity", 0).remove();
                    var B = F.selectAll("." + l.cn.nodeRect).data(y);
                    B.enter().append("rect").classed(l.cn.nodeRect, !0).call(I), B.style("stroke-width", function(t1) {
                        return t1.nodeLineWidth;
                    }).style("stroke", function(t1) {
                        return u.tinyRGB(c(t1.nodeLineColor));
                    }).style("stroke-opacity", function(t1) {
                        return u.opacity(t1.nodeLineColor);
                    }).style("fill", function(t1) {
                        return t1.tinyColorHue;
                    }).style("fill-opacity", function(t1) {
                        return t1.tinyColorAlpha;
                    }), B.transition().ease(l.ease).duration(l.duration).call(I);
                    var N = F.selectAll("." + l.cn.nodeLabel).data(y);
                    N.enter().append("text").classed(l.cn.nodeLabel, !0).style("cursor", "default"), N.attr("data-notex", 1).text(function(t1) {
                        return t1.node.label;
                    }).each(function(e1) {
                        var r = a.select(this);
                        h.font(r, e1.textFont), x.convertToTspans(r, t1);
                    }).attr("text-anchor", function(t1) {
                        return t1.horizontal && t1.left ? "end" : "start";
                    }).attr("transform", function(t1) {
                        var e1 = a.select(this), r = x.lineCount(e1), n = t1.textFont.size * ((r - 1) * T - w), i = t1.nodeLineWidth / 2 + 3, o = ((t1.horizontal ? t1.visibleHeight : t1.visibleWidth) - n) / 2;
                        t1.horizontal && (t1.left ? i = -i : i += t1.visibleWidth);
                        var s = t1.horizontal ? "" : "scale(-1,1)" + d(90);
                        return p(t1.horizontal ? i : o, t1.horizontal ? o : i) + s;
                    }), N.transition().ease(l.ease).duration(l.duration);
                };
            },
            74670: function(t1) {
                "use strict";
                t1.exports = function(t1, e1) {
                    for(var r = [], n = t1.cd[0].trace, i = n._sankey.graph.nodes, a = 0; a < i.length; a++){
                        var o = i[a];
                        if (!o.partOfGroup) {
                            var s = [
                                (o.x0 + o.x1) / 2,
                                (o.y0 + o.y1) / 2
                            ];
                            "v" === n.orientation && s.reverse(), e1 && e1.contains(s, !1, a, t1) && r.push({
                                pointNumber: o.pointNumber
                            });
                        }
                    }
                    return r;
                };
            },
            99203: function(t1, e1, r) {
                "use strict";
                var n = r(34809);
                t1.exports = function(t1, e1) {
                    for(var r = 0; r < t1.length; r++)t1[r].i = r;
                    n.mergeArray(e1.text, t1, "tx"), n.mergeArray(e1.texttemplate, t1, "txt"), n.mergeArray(e1.hovertext, t1, "htx"), n.mergeArray(e1.customdata, t1, "data"), n.mergeArray(e1.textposition, t1, "tp"), e1.textfont && (n.mergeArrayCastPositive(e1.textfont.size, t1, "ts"), n.mergeArray(e1.textfont.color, t1, "tc"), n.mergeArray(e1.textfont.family, t1, "tf"), n.mergeArray(e1.textfont.weight, t1, "tw"), n.mergeArray(e1.textfont.style, t1, "ty"), n.mergeArray(e1.textfont.variant, t1, "tv"), n.mergeArray(e1.textfont.textcase, t1, "tC"), n.mergeArray(e1.textfont.lineposition, t1, "tE"), n.mergeArray(e1.textfont.shadow, t1, "tS"));
                    var i = e1.marker;
                    if (i) {
                        n.mergeArrayCastPositive(i.size, t1, "ms"), n.mergeArrayCastPositive(i.opacity, t1, "mo"), n.mergeArray(i.symbol, t1, "mx"), n.mergeArray(i.angle, t1, "ma"), n.mergeArray(i.standoff, t1, "mf"), n.mergeArray(i.color, t1, "mc");
                        var a = i.line;
                        i.line && (n.mergeArray(a.color, t1, "mlc"), n.mergeArrayCastPositive(a.width, t1, "mlw"));
                        var o = i.gradient;
                        o && "none" !== o.type && (n.mergeArray(o.type, t1, "mgt"), n.mergeArray(o.color, t1, "mgc"));
                    }
                };
            },
            36640: function(t1, e1, r) {
                "use strict";
                var n = r(80712).axisHoverFormat, i = r(3208).ay, a = r(3208).rb, o = r(87163), s = r(80337), l = r(94850).T, c = r(94850).k, u = r(62203), h = r(32660), f = r(93049).extendFlat, p = r(19326);
                t1.exports = {
                    x: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes",
                        anim: !0
                    },
                    x0: {
                        valType: "any",
                        dflt: 0,
                        editType: "calc+clearAxisTypes",
                        anim: !0
                    },
                    dx: {
                        valType: "number",
                        dflt: 1,
                        editType: "calc",
                        anim: !0
                    },
                    y: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes",
                        anim: !0
                    },
                    y0: {
                        valType: "any",
                        dflt: 0,
                        editType: "calc+clearAxisTypes",
                        anim: !0
                    },
                    dy: {
                        valType: "number",
                        dflt: 1,
                        editType: "calc",
                        anim: !0
                    },
                    xperiod: {
                        valType: "any",
                        dflt: 0,
                        editType: "calc"
                    },
                    yperiod: {
                        valType: "any",
                        dflt: 0,
                        editType: "calc"
                    },
                    xperiod0: {
                        valType: "any",
                        editType: "calc"
                    },
                    yperiod0: {
                        valType: "any",
                        editType: "calc"
                    },
                    xperiodalignment: {
                        valType: "enumerated",
                        values: [
                            "start",
                            "middle",
                            "end"
                        ],
                        dflt: "middle",
                        editType: "calc"
                    },
                    yperiodalignment: {
                        valType: "enumerated",
                        values: [
                            "start",
                            "middle",
                            "end"
                        ],
                        dflt: "middle",
                        editType: "calc"
                    },
                    xhoverformat: n("x"),
                    yhoverformat: n("y"),
                    offsetgroup: {
                        valType: "string",
                        dflt: "",
                        editType: "calc"
                    },
                    alignmentgroup: {
                        valType: "string",
                        dflt: "",
                        editType: "calc"
                    },
                    stackgroup: {
                        valType: "string",
                        dflt: "",
                        editType: "calc"
                    },
                    orientation: {
                        valType: "enumerated",
                        values: [
                            "v",
                            "h"
                        ],
                        editType: "calc"
                    },
                    groupnorm: {
                        valType: "enumerated",
                        values: [
                            "",
                            "fraction",
                            "percent"
                        ],
                        dflt: "",
                        editType: "calc"
                    },
                    stackgaps: {
                        valType: "enumerated",
                        values: [
                            "infer zero",
                            "interpolate"
                        ],
                        dflt: "infer zero",
                        editType: "calc"
                    },
                    text: {
                        valType: "string",
                        dflt: "",
                        arrayOk: !0,
                        editType: "calc"
                    },
                    texttemplate: i({}, {}),
                    hovertext: {
                        valType: "string",
                        dflt: "",
                        arrayOk: !0,
                        editType: "style"
                    },
                    mode: {
                        valType: "flaglist",
                        flags: [
                            "lines",
                            "markers",
                            "text"
                        ],
                        extras: [
                            "none"
                        ],
                        editType: "calc"
                    },
                    hoveron: {
                        valType: "flaglist",
                        flags: [
                            "points",
                            "fills"
                        ],
                        editType: "style"
                    },
                    hovertemplate: a({}, {
                        keys: h.eventDataKeys
                    }),
                    line: {
                        color: {
                            valType: "color",
                            editType: "style",
                            anim: !0
                        },
                        width: {
                            valType: "number",
                            min: 0,
                            dflt: 2,
                            editType: "style",
                            anim: !0
                        },
                        shape: {
                            valType: "enumerated",
                            values: [
                                "linear",
                                "spline",
                                "hv",
                                "vh",
                                "hvh",
                                "vhv"
                            ],
                            dflt: "linear",
                            editType: "plot"
                        },
                        smoothing: {
                            valType: "number",
                            min: 0,
                            max: 1.3,
                            dflt: 1,
                            editType: "plot"
                        },
                        dash: f({}, l, {
                            editType: "style"
                        }),
                        backoff: {
                            valType: "number",
                            min: 0,
                            dflt: "auto",
                            arrayOk: !0,
                            editType: "plot"
                        },
                        simplify: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    connectgaps: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "calc"
                    },
                    cliponaxis: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "plot"
                    },
                    fill: {
                        valType: "enumerated",
                        values: [
                            "none",
                            "tozeroy",
                            "tozerox",
                            "tonexty",
                            "tonextx",
                            "toself",
                            "tonext"
                        ],
                        editType: "calc"
                    },
                    fillcolor: p(!0),
                    fillgradient: f({
                        type: {
                            valType: "enumerated",
                            values: [
                                "radial",
                                "horizontal",
                                "vertical",
                                "none"
                            ],
                            dflt: "none",
                            editType: "calc"
                        },
                        start: {
                            valType: "number",
                            editType: "calc"
                        },
                        stop: {
                            valType: "number",
                            editType: "calc"
                        },
                        colorscale: {
                            valType: "colorscale",
                            editType: "style"
                        },
                        editType: "calc"
                    }),
                    fillpattern: c,
                    marker: f({
                        symbol: {
                            valType: "enumerated",
                            values: u.symbolList,
                            dflt: "circle",
                            arrayOk: !0,
                            editType: "style"
                        },
                        opacity: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            arrayOk: !0,
                            editType: "style",
                            anim: !0
                        },
                        angle: {
                            valType: "angle",
                            dflt: 0,
                            arrayOk: !0,
                            editType: "plot",
                            anim: !1
                        },
                        angleref: {
                            valType: "enumerated",
                            values: [
                                "previous",
                                "up"
                            ],
                            dflt: "up",
                            editType: "plot",
                            anim: !1
                        },
                        standoff: {
                            valType: "number",
                            min: 0,
                            dflt: 0,
                            arrayOk: !0,
                            editType: "plot",
                            anim: !0
                        },
                        size: {
                            valType: "number",
                            min: 0,
                            dflt: 6,
                            arrayOk: !0,
                            editType: "calc",
                            anim: !0
                        },
                        maxdisplayed: {
                            valType: "number",
                            min: 0,
                            dflt: 0,
                            editType: "plot"
                        },
                        sizeref: {
                            valType: "number",
                            dflt: 1,
                            editType: "calc"
                        },
                        sizemin: {
                            valType: "number",
                            min: 0,
                            dflt: 0,
                            editType: "calc"
                        },
                        sizemode: {
                            valType: "enumerated",
                            values: [
                                "diameter",
                                "area"
                            ],
                            dflt: "diameter",
                            editType: "calc"
                        },
                        line: f({
                            width: {
                                valType: "number",
                                min: 0,
                                arrayOk: !0,
                                editType: "style",
                                anim: !0
                            },
                            editType: "calc"
                        }, o("marker.line", {
                            anim: !0
                        })),
                        gradient: {
                            type: {
                                valType: "enumerated",
                                values: [
                                    "radial",
                                    "horizontal",
                                    "vertical",
                                    "none"
                                ],
                                arrayOk: !0,
                                dflt: "none",
                                editType: "calc"
                            },
                            color: {
                                valType: "color",
                                arrayOk: !0,
                                editType: "calc"
                            },
                            editType: "calc"
                        },
                        editType: "calc"
                    }, o("marker", {
                        anim: !0
                    })),
                    selected: {
                        marker: {
                            opacity: {
                                valType: "number",
                                min: 0,
                                max: 1,
                                editType: "style"
                            },
                            color: {
                                valType: "color",
                                editType: "style"
                            },
                            size: {
                                valType: "number",
                                min: 0,
                                editType: "style"
                            },
                            editType: "style"
                        },
                        textfont: {
                            color: {
                                valType: "color",
                                editType: "style"
                            },
                            editType: "style"
                        },
                        editType: "style"
                    },
                    unselected: {
                        marker: {
                            opacity: {
                                valType: "number",
                                min: 0,
                                max: 1,
                                editType: "style"
                            },
                            color: {
                                valType: "color",
                                editType: "style"
                            },
                            size: {
                                valType: "number",
                                min: 0,
                                editType: "style"
                            },
                            editType: "style"
                        },
                        textfont: {
                            color: {
                                valType: "color",
                                editType: "style"
                            },
                            editType: "style"
                        },
                        editType: "style"
                    },
                    textposition: {
                        valType: "enumerated",
                        values: [
                            "top left",
                            "top center",
                            "top right",
                            "middle left",
                            "middle center",
                            "middle right",
                            "bottom left",
                            "bottom center",
                            "bottom right"
                        ],
                        dflt: "middle center",
                        arrayOk: !0,
                        editType: "calc"
                    },
                    textfont: s({
                        editType: "calc",
                        colorEditType: "style",
                        arrayOk: !0
                    }),
                    zorder: {
                        valType: "integer",
                        dflt: 0,
                        editType: "plot"
                    }
                };
            },
            26544: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(34809), a = r(29714), o = r(40528), s = r(63821).BADNUM, l = r(64726), c = r(77272), u = r(99203), h = r(48861);
                function f(t1, e1, r, n, i, o, s) {
                    var c = e1._length, u = t1._fullLayout, h = r._id, f = n._id, p = u._firstScatter[m(e1)] === e1.uid, d = (g(e1, u, r, n) || {}).orientation, y = e1.fill;
                    r._minDtick = 0, n._minDtick = 0;
                    var v = {
                        padded: !0
                    }, x = {
                        padded: !0
                    };
                    s && (v.ppad = x.ppad = s);
                    var _ = c < 2 || i[0] !== i[c - 1] || o[0] !== o[c - 1];
                    _ && ("tozerox" === y || "tonextx" === y && (p || "h" === d)) ? v.tozero = !0 : (e1.error_y || {}).visible || "tonexty" !== y && "tozeroy" !== y && (l.hasMarkers(e1) || l.hasText(e1)) || (v.padded = !1, v.ppad = 0), _ && ("tozeroy" === y || "tonexty" === y && (p || "v" === d)) ? x.tozero = !0 : "tonextx" !== y && "tozerox" !== y || (x.padded = !1), h && (e1._extremes[h] = a.findExtremes(r, i, v)), f && (e1._extremes[f] = a.findExtremes(n, o, x));
                }
                function p(t1, e1) {
                    if (l.hasMarkers(t1)) {
                        var r, n = t1.marker, o = 1.6 * (t1.marker.sizeref || 1);
                        if (r = "area" === t1.marker.sizemode ? function(t1) {
                            return Math.max(Math.sqrt((t1 || 0) / o), 3);
                        } : function(t1) {
                            return Math.max((t1 || 0) / o, 3);
                        }, i.isArrayOrTypedArray(n.size)) {
                            var s = {
                                type: "linear"
                            };
                            a.setConvert(s);
                            for(var c = s.makeCalcdata(t1.marker, "size"), u = new Array(e1), h = 0; h < e1; h++)u[h] = r(c[h]);
                            return u;
                        }
                        return r(n.size);
                    }
                }
                function d(t1, e1) {
                    var r = m(e1), n = t1._firstScatter;
                    n[r] || (n[r] = e1.uid);
                }
                function m(t1) {
                    var e1 = t1.stackgroup;
                    return t1.xaxis + t1.yaxis + t1.type + (e1 ? "-" + e1 : "");
                }
                function g(t1, e1, r, n) {
                    var i = t1.stackgroup;
                    if (i) {
                        var a = e1._scatterStackOpts[r._id + n._id][i], o = "v" === a.orientation ? n : r;
                        return "linear" === o.type || "log" === o.type ? a : void 0;
                    }
                }
                t1.exports = {
                    calc: function(t1, e1) {
                        var r, l, m, y, v, x, _ = t1._fullLayout, b = e1._xA = a.getFromId(t1, e1.xaxis || "x", "x"), w = e1._yA = a.getFromId(t1, e1.yaxis || "y", "y"), T = b.makeCalcdata(e1, "x"), k = w.makeCalcdata(e1, "y"), A = o(e1, b, "x", T), M = o(e1, w, "y", k), S = A.vals, E = M.vals, C = e1._length, L = new Array(C), I = e1.ids, P = g(e1, _, b, w), z = !1;
                        d(_, e1);
                        var O, D = "x", R = "y";
                        P ? (i.pushUnique(P.traceIndices, e1._expandedIndex), (r = "v" === P.orientation) ? (R = "s", O = "x") : (D = "s", O = "y"), v = "interpolate" === P.stackgaps) : f(t1, e1, b, w, S, E, p(e1, C));
                        var F = !!e1.xperiodalignment, B = !!e1.yperiodalignment;
                        for(l = 0; l < C; l++){
                            var N = L[l] = {}, j = n(S[l]), U = n(E[l]);
                            j && U ? (N[D] = S[l], N[R] = E[l], F && (N.orig_x = T[l], N.xEnd = A.ends[l], N.xStart = A.starts[l]), B && (N.orig_y = k[l], N.yEnd = M.ends[l], N.yStart = M.starts[l])) : P && (r ? j : U) ? (N[O] = r ? S[l] : E[l], N.gap = !0, v ? (N.s = s, z = !0) : N.s = 0) : N[D] = N[R] = s, I && (N.id = String(I[l]));
                        }
                        if (u(L, e1), c(t1, e1), h(L, e1), P) {
                            for(l = 0; l < L.length;)L[l][O] === s ? L.splice(l, 1) : l++;
                            if (i.sort(L, function(t1, e1) {
                                return t1[O] - e1[O] || t1.i - e1.i;
                            }), z) {
                                for(l = 0; l < L.length - 1 && L[l].gap;)l++;
                                for((x = L[l].s) || (x = L[l].s = 0), m = 0; m < l; m++)L[m].s = x;
                                for(y = L.length - 1; y > l && L[y].gap;)y--;
                                for(x = L[y].s, m = L.length - 1; m > y; m--)L[m].s = x;
                                for(; l < y;)if (L[++l].gap) {
                                    for(m = l + 1; L[m].gap;)m++;
                                    for(var V = L[l - 1][O], q = L[l - 1].s, H = (L[m].s - q) / (L[m][O] - V); l < m;)L[l].s = q + (L[l][O] - V) * H, l++;
                                }
                            }
                        }
                        return L;
                    },
                    calcMarkerSize: p,
                    calcAxisExpansion: f,
                    setFirstScatter: d,
                    getStackOpts: g
                };
            },
            48861: function(t1, e1, r) {
                "use strict";
                var n = r(34809);
                t1.exports = function(t1, e1) {
                    n.isArrayOrTypedArray(e1.selectedpoints) && n.tagSelected(t1, e1);
                };
            },
            77272: function(t1, e1, r) {
                "use strict";
                var n = r(65477).hasColorscale, i = r(28379), a = r(64726);
                t1.exports = function(t1, e1) {
                    a.hasLines(e1) && n(e1, "line") && i(t1, e1, {
                        vals: e1.line.color,
                        containerStr: "line",
                        cLetter: "c"
                    }), a.hasMarkers(e1) && (n(e1, "marker") && i(t1, e1, {
                        vals: e1.marker.color,
                        containerStr: "marker",
                        cLetter: "c"
                    }), n(e1, "marker.line") && i(t1, e1, {
                        vals: e1.marker.line.color,
                        containerStr: "marker.line",
                        cLetter: "c"
                    }));
                };
            },
            32660: function(t1) {
                "use strict";
                t1.exports = {
                    PTS_LINESONLY: 20,
                    minTolerance: .2,
                    toleranceGrowth: 10,
                    maxScreensAway: 20,
                    eventDataKeys: []
                };
            },
            75603: function(t1, e1, r) {
                "use strict";
                var n = r(26544), i = r(24782).setGroupPositions;
                function a(t1, e1, r, n, i, a, o) {
                    i[n] = !0;
                    var s = {
                        i: null,
                        gap: !0,
                        s: 0
                    };
                    if (s[o] = r, t1.splice(e1, 0, s), e1 && r === t1[e1 - 1][o]) {
                        var l = t1[e1 - 1];
                        s.s = l.s, s.i = l.i, s.gap = l.gap;
                    } else a && (s.s = function(t1, e1, r, n) {
                        var i = t1[e1 - 1], a = t1[e1 + 1];
                        return a ? i ? i.s + (a.s - i.s) * (r - i[n]) / (a[n] - i[n]) : a.s : i.s;
                    }(t1, e1, r, o));
                    e1 || (t1[0].t = t1[1].t, t1[0].trace = t1[1].trace, delete t1[1].t, delete t1[1].trace);
                }
                t1.exports = function(t1, e1) {
                    "group" === t1._fullLayout.scattermode && function(t1, e1) {
                        for(var r = e1.xaxis, n = e1.yaxis, a = t1._fullLayout, o = t1._fullData, s = t1.calcdata, l = [], c = [], u = 0; u < o.length; u++){
                            var h = o[u];
                            !0 === h.visible && "scatter" === h.type && h.xaxis === r._id && h.yaxis === n._id && ("h" === h.orientation ? l.push(s[u]) : "v" === h.orientation && c.push(s[u]));
                        }
                        var f = {
                            mode: a.scattermode,
                            gap: a.scattergap
                        };
                        i(t1, r, n, c, f), i(t1, n, r, l, f);
                    }(t1, e1);
                    var r = e1.xaxis, o = e1.yaxis, s = r._id + o._id, l = t1._fullLayout._scatterStackOpts[s];
                    if (l) {
                        var c, u, h, f, p, d, m, g, y, v, x, _, b, w, T, k = t1.calcdata;
                        for(var A in l){
                            var M = (v = l[A]).traceIndices;
                            if (M.length) {
                                for(x = "interpolate" === v.stackgaps, _ = v.groupnorm, "v" === v.orientation ? (b = "x", w = "y") : (b = "y", w = "x"), T = new Array(M.length), c = 0; c < T.length; c++)T[c] = !1;
                                d = k[M[0]];
                                var S = new Array(d.length);
                                for(c = 0; c < d.length; c++)S[c] = d[c][b];
                                for(c = 1; c < M.length; c++){
                                    for(p = k[M[c]], u = h = 0; u < p.length; u++){
                                        for(m = p[u][b]; m > S[h] && h < S.length; h++)a(p, u, S[h], c, T, x, b), u++;
                                        if (m !== S[h]) {
                                            for(f = 0; f < c; f++)a(k[M[f]], h, m, f, T, x, b);
                                            S.splice(h, 0, m);
                                        }
                                        h++;
                                    }
                                    for(; h < S.length; h++)a(p, u, S[h], c, T, x, b), u++;
                                }
                                var E = S.length;
                                for(u = 0; u < d.length; u++){
                                    for(g = d[u][w] = d[u].s, c = 1; c < M.length; c++)(p = k[M[c]])[0].trace._rawLength = p[0].trace._length, p[0].trace._length = E, g += p[u].s, p[u][w] = g;
                                    if (_) for(y = ("fraction" === _ ? g : g / 100) || 1, c = 0; c < M.length; c++){
                                        var C = k[M[c]][u];
                                        C[w] /= y, C.sNorm = C.s / y;
                                    }
                                }
                                for(c = 0; c < M.length; c++){
                                    var L = (p = k[M[c]])[0].trace, I = n.calcMarkerSize(L, L._rawLength), P = Array.isArray(I);
                                    if (I && T[c] || P) {
                                        var z = I;
                                        for(I = new Array(E), u = 0; u < E; u++)I[u] = p[u].gap ? 0 : P ? z[p[u].i] : z;
                                    }
                                    var O = new Array(E), D = new Array(E);
                                    for(u = 0; u < E; u++)O[u] = p[u].x, D[u] = p[u].y;
                                    n.calcAxisExpansion(t1, L, r, o, O, D, I), p[0].t.orientation = v.orientation;
                                }
                            }
                        }
                    }
                };
            },
            53044: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(36301), a = r(36640);
                t1.exports = function(t1, e1) {
                    var r, o, s;
                    function l(t1) {
                        return n.coerce(o._input, o, a, t1);
                    }
                    if ("group" === e1.scattermode) for(s = 0; s < t1.length; s++)"scatter" === (o = t1[s]).type && (r = o._input, i(r, o, e1, l));
                    for(s = 0; s < t1.length; s++){
                        var c = t1[s];
                        if ("scatter" === c.type) {
                            var u = c.fill;
                            if ("none" !== u && "toself" !== u && (c.opacity = void 0, "tonexty" === u || "tonextx" === u)) for(var h = s - 1; h >= 0; h--){
                                var f = t1[h];
                                if ("scatter" === f.type && f.xaxis === c.xaxis && f.yaxis === c.yaxis) {
                                    f.opacity = void 0;
                                    break;
                                }
                            }
                        }
                    }
                };
            },
            40247: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(33626), a = r(36640), o = r(32660), s = r(64726), l = r(99867), c = r(99669), u = r(382), h = r(24272), f = r(98168), p = r(91602), d = r(663), m = r(54114), g = r(34809).coercePattern;
                t1.exports = function(t1, e1, r, y) {
                    function v(r, i) {
                        return n.coerce(t1, e1, a, r, i);
                    }
                    var x = l(t1, e1, y, v);
                    if (x || (e1.visible = !1), e1.visible) {
                        c(t1, e1, y, v), v("xhoverformat"), v("yhoverformat"), v("zorder");
                        var _ = u(t1, e1, y, v);
                        "group" === y.scattermode && void 0 === e1.orientation && v("orientation", "v");
                        var b = !_ && x < o.PTS_LINESONLY ? "lines+markers" : "lines";
                        v("text"), v("hovertext"), v("mode", b), s.hasMarkers(e1) && h(t1, e1, r, y, v, {
                            gradient: !0
                        }), s.hasLines(e1) && (f(t1, e1, r, y, v, {
                            backoff: !0
                        }), p(t1, e1, v), v("connectgaps"), v("line.simplify")), s.hasText(e1) && (v("texttemplate"), d(t1, e1, y, v));
                        var w = [];
                        (s.hasMarkers(e1) || s.hasText(e1)) && (v("cliponaxis"), v("marker.maxdisplayed"), w.push("points")), v("fill", _ ? _.fillDflt : "none"), "none" !== e1.fill && (m(t1, e1, r, v, {
                            moduleHasFillgradient: !0
                        }), s.hasLines(e1) || p(t1, e1, v), g(v, "fillpattern", e1.fillcolor, !1));
                        var T = (e1.line || {}).color, k = (e1.marker || {}).color;
                        "tonext" !== e1.fill && "toself" !== e1.fill || w.push("fills"), v("hoveron", w.join("+") || "points"), "fills" !== e1.hoveron && v("hovertemplate");
                        var A = i.getComponentMethod("errorbars", "supplyDefaults");
                        A(t1, e1, T || k || r, {
                            axis: "y"
                        }), A(t1, e1, T || k || r, {
                            axis: "x",
                            inherit: "y"
                        }), n.coerceSelectionMarkerOpacity(e1, v);
                    }
                };
            },
            19326: function(t1) {
                "use strict";
                t1.exports = function(t1) {
                    return {
                        valType: "color",
                        editType: "style",
                        anim: !0
                    };
                };
            },
            54114: function(t1, e1, r) {
                "use strict";
                var n = r(78766), i = r(34809).isArrayOrTypedArray;
                t1.exports = function(t1, e1, r, a, o) {
                    o || (o = {});
                    var s, l = !1;
                    if (e1.marker) {
                        var c = e1.marker.color, u = (e1.marker.line || {}).color;
                        c && !i(c) ? l = c : u && !i(u) && (l = u);
                    }
                    if (o.moduleHasFillgradient && "none" !== a("fillgradient.type")) {
                        a("fillgradient.start"), a("fillgradient.stop");
                        var h = a("fillgradient.colorscale");
                        h && (s = function(t1) {
                            for(var e1 = n.interpolate(t1[0][1], t1[1][1], .5), r = 2; r < t1.length; r++){
                                var i = n.interpolate(t1[r - 1][1], t1[r][1], .5);
                                e1 = n.interpolate(e1, i, t1[r - 1][0] / t1[r][0]);
                            }
                            return e1;
                        }(h));
                    }
                    a("fillcolor", n.addOpacity((e1.line || {}).color || l || s || r, .5));
                };
            },
            15294: function(t1, e1, r) {
                "use strict";
                var n = r(29714);
                t1.exports = function(t1, e1, r) {
                    var i = {}, a = {
                        _fullLayout: r
                    }, o = n.getFromTrace(a, e1, "x"), s = n.getFromTrace(a, e1, "y"), l = t1.orig_x;
                    void 0 === l && (l = t1.x);
                    var c = t1.orig_y;
                    return void 0 === c && (c = t1.y), i.xLabel = n.tickText(o, o.c2l(l), !0).text, i.yLabel = n.tickText(s, s.c2l(c), !0).text, i;
                };
            },
            11539: function(t1, e1, r) {
                "use strict";
                var n = r(78766), i = r(64726);
                t1.exports = function(t1, e1) {
                    var r, a;
                    if ("lines" === t1.mode) return (r = t1.line.color) && n.opacity(r) ? r : t1.fillcolor;
                    if ("none" === t1.mode) return t1.fill ? t1.fillcolor : "";
                    var o = e1.mcc || (t1.marker || {}).color, s = e1.mlcc || ((t1.marker || {}).line || {}).color;
                    return (a = o && n.opacity(o) ? o : s && n.opacity(s) && (e1.mlw || ((t1.marker || {}).line || {}).width) ? s : "") ? n.opacity(a) < .3 ? n.addOpacity(a, .3) : a : (r = (t1.line || {}).color) && n.opacity(r) && i.hasLines(t1) && t1.line.width ? r : t1.fillcolor;
                };
            },
            36301: function(t1, e1, r) {
                "use strict";
                var n = r(84391).getAxisGroup;
                t1.exports = function(t1, e1, r, i) {
                    var a = e1.orientation, o = e1[({
                        v: "x",
                        h: "y"
                    })[a] + "axis"], s = n(r, o) + a, l = r._alignmentOpts || {}, c = i("alignmentgroup"), u = l[s];
                    u || (u = l[s] = {});
                    var h = u[c];
                    h ? h.traces.push(e1) : h = u[c] = {
                        traces: [
                            e1
                        ],
                        alignmentIndex: Object.keys(u).length,
                        offsetGroups: {}
                    };
                    var f = i("offsetgroup"), p = h.offsetGroups, d = p[f];
                    f && (d || (d = p[f] = {
                        offsetIndex: Object.keys(p).length
                    }), e1._offsetIndex = d.offsetIndex);
                };
            },
            37255: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(32141), a = r(33626), o = r(11539), s = r(78766), l = n.fillText;
                t1.exports = function(t1, e1, r, c) {
                    var u = t1.cd, h = u[0].trace, f = t1.xa, p = t1.ya, d = f.c2p(e1), m = p.c2p(r), g = [
                        d,
                        m
                    ], y = h.hoveron || "", v = -1 !== h.mode.indexOf("markers") ? 3 : .5, x = !!h.xperiodalignment, _ = !!h.yperiodalignment;
                    if (-1 !== y.indexOf("points")) {
                        var b = function(t1) {
                            var e1 = Math.max(v, t1.mrc || 0), r = f.c2p(t1.x) - d, n = p.c2p(t1.y) - m;
                            return Math.max(Math.sqrt(r * r + n * n) - e1, 1 - v / e1);
                        }, w = i.getDistanceFunction(c, function(t1) {
                            if (x) {
                                var e1 = f.c2p(t1.xStart), r = f.c2p(t1.xEnd);
                                return d >= Math.min(e1, r) && d <= Math.max(e1, r) ? 0 : 1 / 0;
                            }
                            var n = Math.max(3, t1.mrc || 0), i = 1 - 1 / n, a = Math.abs(f.c2p(t1.x) - d);
                            return a < n ? i * a / n : a - n + i;
                        }, function(t1) {
                            if (_) {
                                var e1 = p.c2p(t1.yStart), r = p.c2p(t1.yEnd);
                                return m >= Math.min(e1, r) && m <= Math.max(e1, r) ? 0 : 1 / 0;
                            }
                            var n = Math.max(3, t1.mrc || 0), i = 1 - 1 / n, a = Math.abs(p.c2p(t1.y) - m);
                            return a < n ? i * a / n : a - n + i;
                        }, b);
                        if (i.getClosest(u, w, t1), !1 !== t1.index) {
                            var T = u[t1.index], k = f.c2p(T.x, !0), A = p.c2p(T.y, !0), M = T.mrc || 1;
                            t1.index = T.i;
                            var S = u[0].t.orientation, E = S && (T.sNorm || T.s), C = "h" === S ? E : void 0 !== T.orig_x ? T.orig_x : T.x, L = "v" === S ? E : void 0 !== T.orig_y ? T.orig_y : T.y;
                            return n.extendFlat(t1, {
                                color: o(h, T),
                                x0: k - M,
                                x1: k + M,
                                xLabelVal: C,
                                y0: A - M,
                                y1: A + M,
                                yLabelVal: L,
                                spikeDistance: b(T),
                                hovertemplate: h.hovertemplate
                            }), l(T, h, t1), a.getComponentMethod("errorbars", "hoverInfo")(T, h, t1), [
                                t1
                            ];
                        }
                    }
                    function I(t1) {
                        if (!t1) return !1;
                        var e1 = t1.node();
                        try {
                            var r = new DOMPoint(g[0], g[1]);
                            return e1.isPointInFill(r);
                        } catch (t1) {
                            var n = e1.ownerSVGElement.createSVGPoint();
                            return n.x = g[0], n.y = g[1], e1.isPointInFill(n);
                        }
                    }
                    if (-1 !== y.indexOf("fills") && h._fillElement && I(h._fillElement) && !I(h._fillExclusionElement)) {
                        var P = function(t1) {
                            var e1, r, n, i, a, o, s, l, c, u = [], h = 1 / 0, d = -1 / 0, m = 1 / 0, y = -1 / 0;
                            for(e1 = 0; e1 < t1.length; e1++){
                                var v = t1[e1];
                                v.contains(g) && (u.push(v), m = Math.min(m, v.ymin), y = Math.max(y, v.ymax));
                            }
                            if (0 === u.length) return null;
                            for(r = ((m = Math.max(m, 0)) + (y = Math.min(y, p._length))) / 2, e1 = 0; e1 < u.length; e1++)for(i = u[e1].pts, n = 1; n < i.length; n++)(l = i[n - 1][1]) > r != (c = i[n][1]) >= r && (o = i[n - 1][0], s = i[n][0], c - l && (a = o + (s - o) * (r - l) / (c - l), h = Math.min(h, a), d = Math.max(d, a)));
                            return {
                                x0: h = Math.max(h, 0),
                                x1: d = Math.min(d, f._length),
                                y0: r,
                                y1: r
                            };
                        }(h._polygons);
                        null === P && (P = {
                            x0: g[0],
                            x1: g[0],
                            y0: g[1],
                            y1: g[1]
                        });
                        var z = s.defaultLine;
                        return s.opacity(h.fillcolor) ? z = h.fillcolor : s.opacity((h.line || {}).color) && (z = h.line.color), n.extendFlat(t1, {
                            distance: t1.maxHoverDistance,
                            x0: P.x0,
                            x1: P.x1,
                            y0: P.y0,
                            y1: P.y1,
                            color: z,
                            hovertemplate: !1
                        }), delete t1.index, h.text && !n.isArrayOrTypedArray(h.text) ? t1.text = String(h.text) : t1.text = h.name, [
                            t1
                        ];
                    }
                };
            },
            69693: function(t1, e1, r) {
                "use strict";
                var n = r(64726);
                t1.exports = {
                    hasLines: n.hasLines,
                    hasMarkers: n.hasMarkers,
                    hasText: n.hasText,
                    isBubble: n.isBubble,
                    attributes: r(36640),
                    layoutAttributes: r(26667),
                    supplyDefaults: r(40247),
                    crossTraceDefaults: r(53044),
                    supplyLayoutDefaults: r(12332),
                    calc: r(26544).calc,
                    crossTraceCalc: r(75603),
                    arraysToCalcdata: r(99203),
                    plot: r(36098),
                    colorbar: r(21146),
                    formatLabels: r(15294),
                    style: r(9408).style,
                    styleOnSelect: r(9408).styleOnSelect,
                    hoverPoints: r(37255),
                    selectPoints: r(32665),
                    animatable: !0,
                    moduleType: "trace",
                    name: "scatter",
                    basePlotModule: r(37703),
                    categories: [
                        "cartesian",
                        "svg",
                        "symbols",
                        "errorBarsOK",
                        "showLegend",
                        "scatter-like",
                        "zoomScale"
                    ],
                    meta: {}
                };
            },
            26667: function(t1) {
                "use strict";
                t1.exports = {
                    scattermode: {
                        valType: "enumerated",
                        values: [
                            "group",
                            "overlay"
                        ],
                        dflt: "overlay",
                        editType: "calc"
                    },
                    scattergap: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        editType: "calc"
                    }
                };
            },
            12332: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(26667);
                t1.exports = function(t1, e1) {
                    var r, a = "group" === e1.barmode;
                    "group" === e1.scattermode && (r = a ? e1.bargap : .2, n.coerce(t1, e1, i, "scattergap", r));
                };
            },
            98168: function(t1, e1, r) {
                "use strict";
                var n = r(34809).isArrayOrTypedArray, i = r(65477).hasColorscale, a = r(39356);
                t1.exports = function(t1, e1, r, o, s, l) {
                    l || (l = {});
                    var c = (t1.marker || {}).color;
                    c && c._inputArray && (c = c._inputArray), s("line.color", r), i(t1, "line") ? a(t1, e1, o, s, {
                        prefix: "line.",
                        cLetter: "c"
                    }) : s("line.color", !n(c) && c || r), s("line.width"), l.noDash || s("line.dash"), l.backoff && s("line.backoff");
                };
            },
            5525: function(t1, e1, r) {
                "use strict";
                var n = r(62203), i = r(63821), a = i.BADNUM, o = i.LOG_CLIP, s = o + .5, l = o - .5, c = r(34809), u = c.segmentsIntersect, h = c.constrain, f = r(32660);
                t1.exports = function(t1, e1) {
                    var r, i, o, p, d, m, g, y, v, x, _, b, w, T, k, A, M, S, E = e1.trace || {}, C = e1.xaxis, L = e1.yaxis, I = "log" === C.type, P = "log" === L.type, z = C._length, O = L._length, D = e1.backoff, R = E.marker, F = e1.connectGaps, B = e1.baseTolerance, N = e1.shape, j = "linear" === N, U = E.fill && "none" !== E.fill, V = [], q = f.minTolerance, H = t1.length, G = new Array(H), Z = 0;
                    function W(r) {
                        var n = t1[r];
                        if (!n) return !1;
                        var i = e1.linearized ? C.l2p(n.x) : C.c2p(n.x), o = e1.linearized ? L.l2p(n.y) : L.c2p(n.y);
                        if (i === a) {
                            if (I && (i = C.c2p(n.x, !0)), i === a) return !1;
                            P && o === a && (i *= Math.abs(C._m * O * (C._m > 0 ? s : l) / (L._m * z * (L._m > 0 ? s : l)))), i *= 1e3;
                        }
                        if (o === a) {
                            if (P && (o = L.c2p(n.y, !0)), o === a) return !1;
                            o *= 1e3;
                        }
                        return [
                            i,
                            o
                        ];
                    }
                    function Y(t1, e1, r, n) {
                        var i = r - t1, a = n - e1, o = .5 - t1, s = .5 - e1, l = i * i + a * a, c = i * o + a * s;
                        if (c > 0 && c < l) {
                            var u = o * a - s * i;
                            if (u * u < l) return !0;
                        }
                    }
                    function X(t1, e1) {
                        var r = t1[0] / z, n = t1[1] / O, i = Math.max(0, -r, r - 1, -n, n - 1);
                        return i && void 0 !== M && Y(r, n, M, S) && (i = 0), i && e1 && Y(r, n, e1[0] / z, e1[1] / O) && (i = 0), (1 + f.toleranceGrowth * i) * B;
                    }
                    function $(t1, e1) {
                        var r = t1[0] - e1[0], n = t1[1] - e1[1];
                        return Math.sqrt(r * r + n * n);
                    }
                    var J, K, Q, tt, et, rt, nt, it = f.maxScreensAway, at = -z * it, ot = z * (1 + it), st = -O * it, lt = O * (1 + it), ct = [
                        [
                            at,
                            st,
                            ot,
                            st
                        ],
                        [
                            ot,
                            st,
                            ot,
                            lt
                        ],
                        [
                            ot,
                            lt,
                            at,
                            lt
                        ],
                        [
                            at,
                            lt,
                            at,
                            st
                        ]
                    ];
                    function ut(t1) {
                        if (t1[0] < at || t1[0] > ot || t1[1] < st || t1[1] > lt) return [
                            h(t1[0], at, ot),
                            h(t1[1], st, lt)
                        ];
                    }
                    function ht(t1, e1) {
                        return t1[0] === e1[0] && (t1[0] === at || t1[0] === ot) || t1[1] === e1[1] && (t1[1] === st || t1[1] === lt) || void 0;
                    }
                    function ft(t1, e1, r) {
                        return function(n, i) {
                            var a = ut(n), o = ut(i), s = [];
                            if (a && o && ht(a, o)) return s;
                            a && s.push(a), o && s.push(o);
                            var l = 2 * c.constrain((n[t1] + i[t1]) / 2, e1, r) - ((a || n)[t1] + (o || i)[t1]);
                            return l && ((a && o ? l > 0 == a[t1] > o[t1] ? a : o : a || o)[t1] += l), s;
                        };
                    }
                    function pt(t1) {
                        var e1 = t1[0], r = t1[1], n = e1 === G[Z - 1][0], i = r === G[Z - 1][1];
                        if (!n || !i) {
                            if (Z > 1) {
                                var a = e1 === G[Z - 2][0], o = r === G[Z - 2][1];
                                n && (e1 === at || e1 === ot) && a ? o ? Z-- : G[Z - 1] = t1 : i && (r === st || r === lt) && o ? a ? Z-- : G[Z - 1] = t1 : G[Z++] = t1;
                            } else G[Z++] = t1;
                        }
                    }
                    function dt(t1) {
                        G[Z - 1][0] !== t1[0] && G[Z - 1][1] !== t1[1] && pt([
                            Q,
                            tt
                        ]), pt(t1), et = null, Q = tt = 0;
                    }
                    "linear" === N || "spline" === N ? nt = function(t1, e1) {
                        for(var r = [], n = 0, i = 0; i < 4; i++){
                            var a = ct[i], o = u(t1[0], t1[1], e1[0], e1[1], a[0], a[1], a[2], a[3]);
                            o && (!n || Math.abs(o.x - r[0][0]) > 1 || Math.abs(o.y - r[0][1]) > 1) && (o = [
                                o.x,
                                o.y
                            ], n && $(o, t1) < $(r[0], t1) ? r.unshift(o) : r.push(o), n++);
                        }
                        return r;
                    } : "hv" === N || "vh" === N ? nt = function(t1, e1) {
                        var r = [], n = ut(t1), i = ut(e1);
                        return n && i && ht(n, i) || (n && r.push(n), i && r.push(i)), r;
                    } : "hvh" === N ? nt = ft(0, at, ot) : "vhv" === N && (nt = ft(1, st, lt));
                    var mt = c.isArrayOrTypedArray(R);
                    function gt(e1) {
                        if (e1 && D && (e1.i = r, e1.d = t1, e1.trace = E, e1.marker = mt ? R[e1.i] : R, e1.backoff = D), M = e1[0] / z, S = e1[1] / O, J = e1[0] < at ? at : e1[0] > ot ? ot : 0, K = e1[1] < st ? st : e1[1] > lt ? lt : 0, J || K) {
                            if (Z) {
                                if (et) {
                                    var n = nt(et, e1);
                                    n.length > 1 && (dt(n[0]), G[Z++] = n[1]);
                                } else rt = nt(G[Z - 1], e1)[0], G[Z++] = rt;
                            } else G[Z++] = [
                                J || e1[0],
                                K || e1[1]
                            ];
                            var i = G[Z - 1];
                            J && K && (i[0] !== J || i[1] !== K) ? (et && (Q !== J && tt !== K ? pt(Q && tt ? (a = et, s = (o = e1)[0] - a[0], l = (o[1] - a[1]) / s, (a[1] * o[0] - o[1] * a[0]) / s > 0 ? [
                                l > 0 ? at : ot,
                                lt
                            ] : [
                                l > 0 ? ot : at,
                                st
                            ]) : [
                                Q || J,
                                tt || K
                            ]) : Q && tt && pt([
                                Q,
                                tt
                            ])), pt([
                                J,
                                K
                            ])) : Q - J && tt - K && pt([
                                J || Q,
                                K || tt
                            ]), et = e1, Q = J, tt = K;
                        } else et && dt(nt(et, e1)[0]), G[Z++] = e1;
                        var a, o, s, l;
                    }
                    for(r = 0; r < H; r++)if (i = W(r)) {
                        for(Z = 0, et = null, gt(i), r++; r < H; r++){
                            if (!(p = W(r))) {
                                if (F) continue;
                                break;
                            }
                            if (j && e1.simplify) {
                                var yt = W(r + 1);
                                if (x = $(p, i), U && (0 === Z || Z === H - 1) || !(x < X(p, yt) * q)) {
                                    for(y = [
                                        (p[0] - i[0]) / x,
                                        (p[1] - i[1]) / x
                                    ], d = i, _ = x, b = T = k = 0, g = !1, o = p, r++; r < t1.length; r++){
                                        if (m = yt, yt = W(r + 1), !m) {
                                            if (F) continue;
                                            break;
                                        }
                                        if (A = (v = [
                                            m[0] - i[0],
                                            m[1] - i[1]
                                        ])[0] * y[1] - v[1] * y[0], T = Math.min(T, A), (k = Math.max(k, A)) - T > X(m, yt)) break;
                                        o = m, (w = v[0] * y[0] + v[1] * y[1]) > _ ? (_ = w, p = m, g = !1) : w < b && (b = w, d = m, g = !0);
                                    }
                                    if (g ? (gt(p), o !== d && gt(d)) : (d !== i && gt(d), o !== p && gt(p)), gt(o), r >= t1.length || !m) break;
                                    gt(m), i = m;
                                }
                            } else gt(p);
                        }
                        et && pt([
                            Q || et[0],
                            tt || et[1]
                        ]), V.push(G.slice(0, Z));
                    }
                    var vt = N.slice(N.length - 1);
                    if (D && "h" !== vt && "v" !== vt) {
                        for(var xt = !1, _t = -1, bt = [], wt = 0; wt < V.length; wt++)for(var Tt = 0; Tt < V[wt].length - 1; Tt++){
                            var kt = V[wt][Tt], At = V[wt][Tt + 1], Mt = n.applyBackoff(At, kt);
                            Mt[0] === At[0] && Mt[1] === At[1] || (xt = !0), bt[_t + 1] || (bt[++_t] = [
                                kt,
                                [
                                    Mt[0],
                                    Mt[1]
                                ]
                            ]);
                        }
                        return xt ? bt : V;
                    }
                    return V;
                };
            },
            91602: function(t1) {
                "use strict";
                t1.exports = function(t1, e1, r) {
                    "spline" === r("line.shape") && r("line.smoothing");
                };
            },
            17210: function(t1) {
                "use strict";
                var e1 = {
                    tonextx: 1,
                    tonexty: 1,
                    tonext: 1
                };
                t1.exports = function(t1, r, n) {
                    var i, a, o, s, l, c = {}, u = !1, h = -1, f = 0, p = -1;
                    for(a = 0; a < n.length; a++)(o = (i = n[a][0].trace).stackgroup || "") ? o in c ? l = c[o] : (l = c[o] = f, f++) : i.fill in e1 && p >= 0 ? l = p : (l = p = f, f++), l < h && (u = !0), i._groupIndex = h = l;
                    var d = n.slice();
                    u && d.sort(function(t1, e1) {
                        var r = t1[0].trace, n = e1[0].trace;
                        return r._groupIndex - n._groupIndex || r.index - n.index;
                    });
                    var m = {};
                    for(a = 0; a < d.length; a++)o = (i = d[a][0].trace).stackgroup || "", !0 === i.visible ? (i._nexttrace = null, i.fill in e1 && (s = m[o], i._prevtrace = s || null, s && (s._nexttrace = i)), i._ownfill = i.fill && ("tozero" === i.fill.substr(0, 6) || "toself" === i.fill || "to" === i.fill.substr(0, 2) && !i._prevtrace), m[o] = i) : i._prevtrace = i._nexttrace = i._ownfill = null;
                    return d;
                };
            },
            92527: function(t1, e1, r) {
                "use strict";
                var n = r(10721);
                t1.exports = function(t1, e1) {
                    e1 || (e1 = 2);
                    var r = t1.marker, i = r.sizeref || 1, a = r.sizemin || 0, o = "area" === r.sizemode ? function(t1) {
                        return Math.sqrt(t1 / i);
                    } : function(t1) {
                        return t1 / i;
                    };
                    return function(t1) {
                        var r = o(t1 / e1);
                        return n(r) && r > 0 ? Math.max(r, a) : 0;
                    };
                };
            },
            21146: function(t1) {
                "use strict";
                t1.exports = {
                    container: "marker",
                    min: "cmin",
                    max: "cmax"
                };
            },
            24272: function(t1, e1, r) {
                "use strict";
                var n = r(78766), i = r(65477).hasColorscale, a = r(39356), o = r(64726);
                t1.exports = function(t1, e1, r, s, l, c) {
                    var u = o.isBubble(t1), h = (t1.line || {}).color;
                    c = c || {}, h && (r = h), l("marker.symbol"), l("marker.opacity", u ? .7 : 1), l("marker.size"), c.noAngle || (l("marker.angle"), c.noAngleRef || l("marker.angleref"), c.noStandOff || l("marker.standoff")), l("marker.color", r), i(t1, "marker") && a(t1, e1, s, l, {
                        prefix: "marker.",
                        cLetter: "c"
                    }), c.noSelect || (l("selected.marker.color"), l("unselected.marker.color"), l("selected.marker.size"), l("unselected.marker.size")), c.noLine || (l("marker.line.color", h && !Array.isArray(h) && e1.marker.color !== h ? h : u ? n.background : n.defaultLine), i(t1, "marker.line") && a(t1, e1, s, l, {
                        prefix: "marker.line.",
                        cLetter: "c"
                    }), l("marker.line.width", u ? 1 : 0)), u && (l("marker.sizeref"), l("marker.sizemin"), l("marker.sizemode")), c.gradient && "none" !== l("marker.gradient.type") && l("marker.gradient.color");
                };
            },
            99669: function(t1, e1, r) {
                "use strict";
                var n = r(34809).dateTick0, i = r(63821).ONEWEEK;
                function a(t1, e1) {
                    return n(e1, t1 % i == 0 ? 1 : 0);
                }
                t1.exports = function(t1, e1, r, n, i) {
                    if (i || (i = {
                        x: !0,
                        y: !0
                    }), i.x) {
                        var o = n("xperiod");
                        o && (n("xperiod0", a(o, e1.xcalendar)), n("xperiodalignment"));
                    }
                    if (i.y) {
                        var s = n("yperiod");
                        s && (n("yperiod0", a(s, e1.ycalendar)), n("yperiodalignment"));
                    }
                };
            },
            36098: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(33626), a = r(34809), o = a.ensureSingle, s = a.identity, l = r(62203), c = r(64726), u = r(5525), h = r(17210), f = r(80899).tester;
                function p(t1, e1, r, h, p, d, m) {
                    var g, y = t1._context.staticPlot;
                    !function(t1, e1, r, i, o) {
                        var s = r.xaxis, l = r.yaxis, u = n.extent(a.simpleMap(s.range, s.r2c)), h = n.extent(a.simpleMap(l.range, l.r2c)), f = i[0].trace;
                        if (c.hasMarkers(f)) {
                            var p = f.marker.maxdisplayed;
                            if (0 !== p) {
                                var d = i.filter(function(t1) {
                                    return t1.x >= u[0] && t1.x <= u[1] && t1.y >= h[0] && t1.y <= h[1];
                                }), m = Math.ceil(d.length / p), g = 0;
                                o.forEach(function(t1, r) {
                                    var n = t1[0].trace;
                                    c.hasMarkers(n) && n.marker.maxdisplayed > 0 && r < e1 && g++;
                                });
                                var y = Math.round(g * m / 3 + Math.floor(g / 3) * m / 7.1);
                                i.forEach(function(t1) {
                                    delete t1.vis;
                                }), d.forEach(function(t1, e1) {
                                    0 === Math.round((e1 + y) % m) && (t1.vis = !0);
                                });
                            }
                        }
                    }(0, e1, r, h, p);
                    var v = !!m && m.duration > 0;
                    function x(t1) {
                        return v ? t1.transition() : t1;
                    }
                    var _ = r.xaxis, b = r.yaxis, w = h[0].trace, T = w.line, k = n.select(d), A = o(k, "g", "errorbars"), M = o(k, "g", "lines"), S = o(k, "g", "points"), E = o(k, "g", "text");
                    if (i.getComponentMethod("errorbars", "plot")(t1, A, r, m), !0 === w.visible) {
                        var C, L;
                        x(k).style("opacity", w.opacity);
                        var I, P, z = w.fill.charAt(w.fill.length - 1);
                        "x" !== z && "y" !== z && (z = ""), "y" === z ? (I = 1, P = b.c2p(0, !0)) : "x" === z && (I = 0, P = _.c2p(0, !0)), h[0][r.isRangePlot ? "nodeRangePlot3" : "node3"] = k;
                        var O, D, R = "", F = [], B = w._prevtrace, N = null, j = null;
                        B && (R = B._prevRevpath || "", L = B._nextFill, F = B._ownPolygons, N = B._fillsegments, j = B._fillElement);
                        var U, V, q, H, G, Z, W = "", Y = "", X = [];
                        w._polygons = [];
                        var $ = [], J = [], K = a.noop;
                        if (C = w._ownFill, c.hasLines(w) || "none" !== w.fill) {
                            L && L.datum(h), -1 !== [
                                "hv",
                                "vh",
                                "hvh",
                                "vhv"
                            ].indexOf(T.shape) ? (U = l.steps(T.shape), V = l.steps(T.shape.split("").reverse().join(""))) : U = V = "spline" === T.shape ? function(t1) {
                                var e1 = t1[t1.length - 1];
                                return t1.length > 1 && t1[0][0] === e1[0] && t1[0][1] === e1[1] ? l.smoothclosed(t1.slice(1), T.smoothing) : l.smoothopen(t1, T.smoothing);
                            } : function(t1) {
                                return "M" + t1.join("L");
                            }, q = function(t1) {
                                return V(t1.reverse());
                            }, J = u(h, {
                                xaxis: _,
                                yaxis: b,
                                trace: w,
                                connectGaps: w.connectgaps,
                                baseTolerance: Math.max(T.width || 1, 3) / 4,
                                shape: T.shape,
                                backoff: T.backoff,
                                simplify: T.simplify,
                                fill: w.fill
                            }), $ = new Array(J.length);
                            var Q = 0;
                            for(g = 0; g < J.length; g++){
                                var tt, et = J[g];
                                tt && z ? tt.push.apply(tt, et) : (tt = et.slice(), $[Q] = tt, Q++);
                            }
                            w._fillElement = null, w._fillExclusionElement = j, w._fillsegments = $.slice(0, Q), $ = w._fillsegments, J.length && (H = J[0][0].slice(), Z = (G = J[J.length - 1])[G.length - 1].slice()), K = function(t1) {
                                return function(e1) {
                                    if (O = U(e1), D = q(e1), W ? z ? (W += "L" + O.substr(1), Y = D + "L" + Y.substr(1)) : (W += "Z" + O, Y = D + "Z" + Y) : (W = O, Y = D), c.hasLines(w)) {
                                        var r = n.select(this);
                                        if (r.datum(h), t1) x(r.style("opacity", 0).attr("d", O).call(l.lineGroupStyle)).style("opacity", 1);
                                        else {
                                            var i = x(r);
                                            i.attr("d", O), l.singleLineStyle(h, i);
                                        }
                                    }
                                };
                            };
                        }
                        var rt = M.selectAll(".js-line").data(J);
                        x(rt.exit()).style("opacity", 0).remove(), rt.each(K(!1)), rt.enter().append("path").classed("js-line", !0).style("vector-effect", y ? "none" : "non-scaling-stroke").call(l.lineGroupStyle).each(K(!0)), l.setClipUrl(rt, r.layerClipId, t1);
                        var nt = function() {
                            var t1 = new Array($.length);
                            for(g = 0; g < $.length; g++)t1[g] = f($[g]);
                            return t1;
                        }, it = function(t1) {
                            var e1, r;
                            if (t1 && 0 !== t1.length) {
                                for(e1 = new Array(t1.length - 1 + $.length), r = 0; r < t1.length - 1; r++)e1[r] = f(t1[r]);
                                var n = t1[t1.length - 1].slice();
                                for(n.reverse(), r = 0; r < $.length; r++)e1[t1.length - 1 + r] = f($[r].concat(n));
                            } else for(e1 = new Array($.length), r = 0; r < $.length; r++){
                                var i = $[r][0].slice(), a = $[r][$[r].length - 1].slice();
                                i[I] = a[I] = P;
                                var o = [
                                    a,
                                    i
                                ].concat($[r]);
                                e1[r] = f(o);
                            }
                            return e1;
                        };
                        J.length ? (C ? (C.datum(h), H && Z && (z ? (H[I] = Z[I] = P, x(C).attr("d", "M" + Z + "L" + H + "L" + W.substr(1)).call(l.singleFillStyle, t1), X = it(null)) : (x(C).attr("d", W + "Z").call(l.singleFillStyle, t1), X = nt())), w._polygons = X, w._fillElement = C) : L && ("tonext" === w.fill.substr(0, 6) && W && R ? ("tonext" === w.fill ? (x(L).attr("d", W + "Z" + R + "Z").call(l.singleFillStyle, t1), X = nt(), w._polygons = X.concat(F)) : (x(L).attr("d", W + "L" + R.substr(1) + "Z").call(l.singleFillStyle, t1), X = it(N), w._polygons = X), w._fillElement = L) : ot(L)), w._prevRevpath = Y) : (C ? ot(C) : L && ot(L), w._prevRevpath = null), w._ownPolygons = X, S.datum(h), E.datum(h), function(e1, i, a) {
                            var o, u = a[0].trace, h = c.hasMarkers(u), f = c.hasText(u), p = ht(u), d = ft, m = ft;
                            if (h || f) {
                                var g = s, y = u.stackgroup, w = y && "infer zero" === t1._fullLayout._scatterStackOpts[_._id + b._id][y].stackgaps;
                                u.marker.maxdisplayed || u._needsCull ? g = w ? lt : st : y && !w && (g = ct), h && (d = g), f && (m = g);
                            }
                            var T, k = (o = e1.selectAll("path.point").data(d, p)).enter().append("path").classed("point", !0);
                            v && k.call(l.pointStyle, u, t1).call(l.translatePoints, _, b).style("opacity", 0).transition().style("opacity", 1), o.order(), h && (T = l.makePointStyleFns(u)), o.each(function(e1) {
                                var i = n.select(this), a = x(i);
                                l.translatePoint(e1, a, _, b) ? (l.singlePointStyle(e1, a, u, T, t1), r.layerClipId && l.hideOutsideRangePoint(e1, a, _, b, u.xcalendar, u.ycalendar), u.customdata && i.classed("plotly-customdata", null !== e1.data && void 0 !== e1.data)) : a.remove();
                            }), v ? o.exit().transition().style("opacity", 0).remove() : o.exit().remove(), (o = i.selectAll("g").data(m, p)).enter().append("g").classed("textpoint", !0).append("text"), o.order(), o.each(function(t1) {
                                var e1 = n.select(this), i = x(e1.select("text"));
                                l.translatePoint(t1, i, _, b) ? r.layerClipId && l.hideOutsideRangePoint(t1, e1, _, b, u.xcalendar, u.ycalendar) : e1.remove();
                            }), o.selectAll("text").call(l.textPointStyle, u, t1).each(function(t1) {
                                var e1 = _.c2p(t1.x), r = b.c2p(t1.y);
                                n.select(this).selectAll("tspan.line").each(function() {
                                    x(n.select(this)).attr({
                                        x: e1,
                                        y: r
                                    });
                                });
                            }), o.exit().remove();
                        }(S, E, h);
                        var at = !1 === w.cliponaxis ? null : r.layerClipId;
                        l.setClipUrl(S, at, t1), l.setClipUrl(E, at, t1);
                    }
                    function ot(t1) {
                        x(t1).attr("d", "M0,0Z");
                    }
                    function st(t1) {
                        return t1.filter(function(t1) {
                            return !t1.gap && t1.vis;
                        });
                    }
                    function lt(t1) {
                        return t1.filter(function(t1) {
                            return t1.vis;
                        });
                    }
                    function ct(t1) {
                        return t1.filter(function(t1) {
                            return !t1.gap;
                        });
                    }
                    function ut(t1) {
                        return t1.id;
                    }
                    function ht(t1) {
                        if (t1.ids) return ut;
                    }
                    function ft() {
                        return !1;
                    }
                }
                t1.exports = function(t1, e1, r, i, a, c) {
                    var u, f, d = !a, m = !!a && a.duration > 0, g = h(t1, e1, r);
                    (u = i.selectAll("g.trace").data(g, function(t1) {
                        return t1[0].trace.uid;
                    })).enter().append("g").attr("class", function(t1) {
                        return "trace scatter trace" + t1[0].trace.uid;
                    }).style("stroke-miterlimit", 2), u.order(), function(t1, e1, r) {
                        e1.each(function(e1) {
                            var i = o(n.select(this), "g", "fills");
                            l.setClipUrl(i, r.layerClipId, t1);
                            var a = e1[0].trace, c = [];
                            a._ownfill && c.push("_ownFill"), a._nexttrace && c.push("_nextFill");
                            var u = i.selectAll("g").data(c, s);
                            u.enter().append("g"), u.exit().each(function(t1) {
                                a[t1] = null;
                            }).remove(), u.order().each(function(t1) {
                                a[t1] = o(n.select(this), "path", "js-fill");
                            });
                        });
                    }(t1, u, e1), m ? (c && (f = c()), n.transition().duration(a.duration).ease(a.easing).each("end", function() {
                        f && f();
                    }).each("interrupt", function() {
                        f && f();
                    }).each(function() {
                        i.selectAll("g.trace").each(function(r, n) {
                            p(t1, n, e1, r, g, this, a);
                        });
                    })) : u.each(function(r, n) {
                        p(t1, n, e1, r, g, this, a);
                    }), d && u.exit().remove(), i.selectAll("path:not([d])").remove();
                };
            },
            32665: function(t1, e1, r) {
                "use strict";
                var n = r(64726);
                t1.exports = function(t1, e1) {
                    var r, i, a, o, s = t1.cd, l = t1.xaxis, c = t1.yaxis, u = [], h = s[0].trace;
                    if (!n.hasMarkers(h) && !n.hasText(h)) return [];
                    if (!1 === e1) for(r = 0; r < s.length; r++)s[r].selected = 0;
                    else for(r = 0; r < s.length; r++)i = s[r], a = l.c2p(i.x), o = c.c2p(i.y), null !== i.i && e1.contains([
                        a,
                        o
                    ], !1, r, t1) ? (u.push({
                        pointNumber: i.i,
                        x: l.c2d(i.x),
                        y: c.c2d(i.y)
                    }), i.selected = 1) : i.selected = 0;
                    return u;
                };
            },
            382: function(t1) {
                "use strict";
                var e1 = [
                    "orientation",
                    "groupnorm",
                    "stackgaps"
                ];
                t1.exports = function(t1, r, n, i) {
                    var a = n._scatterStackOpts, o = i("stackgroup");
                    if (o) {
                        var s = r.xaxis + r.yaxis, l = a[s];
                        l || (l = a[s] = {});
                        var c = l[o], u = !1;
                        c ? c.traces.push(r) : (c = l[o] = {
                            traceIndices: [],
                            traces: [
                                r
                            ]
                        }, u = !0);
                        for(var h = {
                            orientation: r.x && !r.y ? "h" : "v"
                        }, f = 0; f < e1.length; f++){
                            var p = e1[f], d = p + "Found";
                            if (!c[d]) {
                                var m = void 0 !== t1[p], g = "orientation" === p;
                                if ((m || u) && (c[p] = i(p, h[p]), g && (c.fillDflt = "h" === c[p] ? "tonextx" : "tonexty"), m && (c[d] = !0, !u && (delete c.traces[0][p], g)))) for(var y = 0; y < c.traces.length - 1; y++){
                                    var v = c.traces[y];
                                    v._input.fill !== v.fill && (v.fill = c.fillDflt);
                                }
                            }
                        }
                        return c;
                    }
                };
            },
            9408: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(62203), a = r(33626);
                function o(t1, e1, r) {
                    i.pointStyle(t1.selectAll("path.point"), e1, r);
                }
                function s(t1, e1, r) {
                    i.textPointStyle(t1.selectAll("text"), e1, r);
                }
                t1.exports = {
                    style: function(t1) {
                        var e1 = n.select(t1).selectAll("g.trace.scatter");
                        e1.style("opacity", function(t1) {
                            return t1[0].trace.opacity;
                        }), e1.selectAll("g.points").each(function(e1) {
                            o(n.select(this), e1.trace || e1[0].trace, t1);
                        }), e1.selectAll("g.text").each(function(e1) {
                            s(n.select(this), e1.trace || e1[0].trace, t1);
                        }), e1.selectAll("g.trace path.js-line").call(i.lineGroupStyle), e1.selectAll("g.trace path.js-fill").call(i.fillGroupStyle, t1, !1), a.getComponentMethod("errorbars", "style")(e1);
                    },
                    stylePoints: o,
                    styleText: s,
                    styleOnSelect: function(t1, e1, r) {
                        var n = e1[0].trace;
                        n.selectedpoints ? (i.selectedPointStyle(r.selectAll("path.point"), n), i.selectedTextStyle(r.selectAll("text"), n)) : (o(r, n, t1), s(r, n, t1));
                    }
                };
            },
            64726: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(87800).isTypedArraySpec;
                t1.exports = {
                    hasLines: function(t1) {
                        return t1.visible && t1.mode && -1 !== t1.mode.indexOf("lines");
                    },
                    hasMarkers: function(t1) {
                        return t1.visible && (t1.mode && -1 !== t1.mode.indexOf("markers") || "splom" === t1.type);
                    },
                    hasText: function(t1) {
                        return t1.visible && t1.mode && -1 !== t1.mode.indexOf("text");
                    },
                    isBubble: function(t1) {
                        var e1 = t1.marker;
                        return n.isPlainObject(e1) && (n.isArrayOrTypedArray(e1.size) || i(e1.size));
                    }
                };
            },
            663: function(t1, e1, r) {
                "use strict";
                var n = r(34809);
                t1.exports = function(t1, e1, r, i, a) {
                    a = a || {}, i("textposition"), n.coerceFont(i, "textfont", a.font || r.font, a), a.noSelect || (i("selected.textfont.color"), i("unselected.textfont.color"));
                };
            },
            99867: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(33626);
                t1.exports = function(t1, e1, r, a) {
                    var o, s = a("x"), l = a("y");
                    if (i.getComponentMethod("calendars", "handleTraceDefaults")(t1, e1, [
                        "x",
                        "y"
                    ], r), s) {
                        var c = n.minRowLength(s);
                        l ? o = Math.min(c, n.minRowLength(l)) : (o = c, a("y0"), a("dy"));
                    } else {
                        if (!l) return 0;
                        o = n.minRowLength(l), a("x0"), a("dx");
                    }
                    return e1._length = o, o;
                };
            },
            14117: function(t1, e1, r) {
                "use strict";
                var n = r(36640), i = r(80337), a = r(87163), o = r(80712).axisHoverFormat, s = r(3208).rb, l = r(3208).ay, c = r(9829), u = r(84770), h = r(49467), f = r(93049).extendFlat, p = r(13582).overrideAll, d = r(62994), m = n.line, g = n.marker, y = g.line, v = f({
                    width: m.width,
                    dash: {
                        valType: "enumerated",
                        values: d(u),
                        dflt: "solid"
                    }
                }, a("line")), x = t1.exports = p({
                    x: n.x,
                    y: n.y,
                    z: {
                        valType: "data_array"
                    },
                    text: f({}, n.text, {}),
                    texttemplate: l({}, {}),
                    hovertext: f({}, n.hovertext, {}),
                    hovertemplate: s(),
                    xhoverformat: o("x"),
                    yhoverformat: o("y"),
                    zhoverformat: o("z"),
                    mode: f({}, n.mode, {
                        dflt: "lines+markers"
                    }),
                    surfaceaxis: {
                        valType: "enumerated",
                        values: [
                            -1,
                            0,
                            1,
                            2
                        ],
                        dflt: -1
                    },
                    surfacecolor: {
                        valType: "color"
                    },
                    projection: {
                        x: {
                            show: {
                                valType: "boolean",
                                dflt: !1
                            },
                            opacity: {
                                valType: "number",
                                min: 0,
                                max: 1,
                                dflt: 1
                            },
                            scale: {
                                valType: "number",
                                min: 0,
                                max: 10,
                                dflt: 2 / 3
                            }
                        },
                        y: {
                            show: {
                                valType: "boolean",
                                dflt: !1
                            },
                            opacity: {
                                valType: "number",
                                min: 0,
                                max: 1,
                                dflt: 1
                            },
                            scale: {
                                valType: "number",
                                min: 0,
                                max: 10,
                                dflt: 2 / 3
                            }
                        },
                        z: {
                            show: {
                                valType: "boolean",
                                dflt: !1
                            },
                            opacity: {
                                valType: "number",
                                min: 0,
                                max: 1,
                                dflt: 1
                            },
                            scale: {
                                valType: "number",
                                min: 0,
                                max: 10,
                                dflt: 2 / 3
                            }
                        }
                    },
                    connectgaps: n.connectgaps,
                    line: v,
                    marker: f({
                        symbol: {
                            valType: "enumerated",
                            values: d(h),
                            dflt: "circle",
                            arrayOk: !0
                        },
                        size: f({}, g.size, {
                            dflt: 8
                        }),
                        sizeref: g.sizeref,
                        sizemin: g.sizemin,
                        sizemode: g.sizemode,
                        opacity: f({}, g.opacity, {
                            arrayOk: !1
                        }),
                        colorbar: g.colorbar,
                        line: f({
                            width: f({}, y.width, {
                                arrayOk: !1
                            })
                        }, a("marker.line"))
                    }, a("marker")),
                    textposition: f({}, n.textposition, {
                        dflt: "top center"
                    }),
                    textfont: i({
                        noFontShadow: !0,
                        noFontLineposition: !0,
                        noFontTextcase: !0,
                        editType: "calc",
                        colorEditType: "style",
                        arrayOk: !0,
                        variantValues: [
                            "normal",
                            "small-caps"
                        ]
                    }),
                    opacity: c.opacity,
                    hoverinfo: f({}, c.hoverinfo)
                }, "calc", "nested");
                x.x.editType = x.y.editType = x.z.editType = "calc+clearAxisTypes";
            },
            37593: function(t1, e1, r) {
                "use strict";
                var n = r(99203), i = r(77272);
                t1.exports = function(t1, e1) {
                    var r = [
                        {
                            x: !1,
                            y: !1,
                            trace: e1,
                            t: {}
                        }
                    ];
                    return n(r, e1), i(t1, e1), r;
                };
            },
            95447: function(t1, e1, r) {
                "use strict";
                var n = r(33626);
                function i(t1, e1, r, i) {
                    if (!e1 || !e1.visible) return null;
                    for(var a = n.getComponentMethod("errorbars", "makeComputeError")(e1), o = new Array(t1.length), s = 0; s < t1.length; s++){
                        var l = a(+t1[s], s);
                        if ("log" === i.type) {
                            var c = i.c2l(t1[s]), u = t1[s] - l[0], h = t1[s] + l[1];
                            if (o[s] = [
                                (i.c2l(u, !0) - c) * r,
                                (i.c2l(h, !0) - c) * r
                            ], u > 0) {
                                var f = i.c2l(u);
                                i._lowerLogErrorBound || (i._lowerLogErrorBound = f), i._lowerErrorBound = Math.min(i._lowerLogErrorBound, f);
                            }
                        } else o[s] = [
                            -l[0] * r,
                            l[1] * r
                        ];
                    }
                    return o;
                }
                t1.exports = function(t1, e1, r) {
                    var n = [
                        i(t1.x, t1.error_x, e1[0], r.xaxis),
                        i(t1.y, t1.error_y, e1[1], r.yaxis),
                        i(t1.z, t1.error_z, e1[2], r.zaxis)
                    ], a = function(t1) {
                        for(var e1 = 0; e1 < t1.length; e1++)if (t1[e1]) return t1[e1].length;
                        return 0;
                    }(n);
                    if (0 === a) return null;
                    for(var o = new Array(a), s = 0; s < a; s++){
                        for(var l = [
                            [
                                0,
                                0,
                                0
                            ],
                            [
                                0,
                                0,
                                0
                            ]
                        ], c = 0; c < 3; c++)if (n[c]) for(var u = 0; u < 2; u++)l[u][c] = n[c][s][u];
                        o[s] = l;
                    }
                    return o;
                };
            },
            16533: function(t1, e1, r) {
                "use strict";
                var n = r(99098).gl_line3d, i = r(99098).gl_scatter3d, a = r(99098).gl_error3d, o = r(99098).gl_mesh3d, s = r(99098).delaunay_triangulate, l = r(34809), c = r(55010), u = r(46998).formatColor, h = r(92527), f = r(84770), p = r(49467), d = r(29714), m = r(36040).appendArrayPointValue, g = r(95447);
                function y(t1, e1) {
                    this.scene = t1, this.uid = e1, this.linePlot = null, this.scatterPlot = null, this.errorBars = null, this.textMarkers = null, this.delaunayMesh = null, this.color = null, this.mode = "", this.dataPoints = [], this.axesBounds = [
                        [
                            -1 / 0,
                            -1 / 0,
                            -1 / 0
                        ],
                        [
                            1 / 0,
                            1 / 0,
                            1 / 0
                        ]
                    ], this.textLabels = null, this.data = null;
                }
                var v = y.prototype;
                function x(t1) {
                    return null == t1 ? 0 : t1.indexOf("left") > -1 ? -1 : t1.indexOf("right") > -1 ? 1 : 0;
                }
                function _(t1) {
                    return null == t1 ? 0 : t1.indexOf("top") > -1 ? -1 : t1.indexOf("bottom") > -1 ? 1 : 0;
                }
                function b(t1, e1) {
                    return e1(4 * t1);
                }
                function w(t1) {
                    return p[t1];
                }
                function T(t1, e1, r, n, i) {
                    var a = null;
                    if (l.isArrayOrTypedArray(t1)) {
                        a = [];
                        for(var o = 0; o < e1; o++)void 0 === t1[o] ? a[o] = n : a[o] = r(t1[o], i);
                    } else a = r(t1, l.identity);
                    return a;
                }
                function k(t1) {
                    if (l.isArrayOrTypedArray(t1)) {
                        var e1 = t1[0];
                        return l.isArrayOrTypedArray(e1) && (t1 = e1), "rgb(" + t1.slice(0, 3).map(function(t1) {
                            return Math.round(255 * t1);
                        }) + ")";
                    }
                    return null;
                }
                function A(t1) {
                    return l.isArrayOrTypedArray(t1) ? 4 === t1.length && "number" == typeof t1[0] ? k(t1) : t1.map(k) : null;
                }
                v.handlePick = function(t1) {
                    if (t1.object && (t1.object === this.linePlot || t1.object === this.delaunayMesh || t1.object === this.textMarkers || t1.object === this.scatterPlot)) {
                        var e1 = t1.index = t1.data.index;
                        return t1.object.highlight && t1.object.highlight(null), this.scatterPlot && (t1.object = this.scatterPlot, this.scatterPlot.highlight(t1.data)), t1.textLabel = "", this.textLabels && (l.isArrayOrTypedArray(this.textLabels) ? (this.textLabels[e1] || 0 === this.textLabels[e1]) && (t1.textLabel = this.textLabels[e1]) : t1.textLabel = this.textLabels), t1.traceCoordinate = [
                            this.data.x[e1],
                            this.data.y[e1],
                            this.data.z[e1]
                        ], !0;
                    }
                }, v.update = function(t1) {
                    var e1, r, p, y, v = this.scene.glplot.gl, k = f.solid;
                    this.data = t1;
                    var M = function(t1, e1) {
                        var r, n, i, a, o, s, f = [], p = t1.fullSceneLayout, y = t1.dataScale, v = p.xaxis, k = p.yaxis, A = p.zaxis, M = e1.marker, S = e1.line, E = e1.x || [], C = e1.y || [], L = e1.z || [], I = E.length, P = e1.xcalendar, z = e1.ycalendar, O = e1.zcalendar;
                        for(o = 0; o < I; o++)r = v.d2l(E[o], 0, P) * y[0], n = k.d2l(C[o], 0, z) * y[1], i = A.d2l(L[o], 0, O) * y[2], f[o] = [
                            r,
                            n,
                            i
                        ];
                        if (Array.isArray(e1.text)) s = e1.text;
                        else if (l.isTypedArray(e1.text)) s = Array.from(e1.text);
                        else if (void 0 !== e1.text) for(s = new Array(I), o = 0; o < I; o++)s[o] = e1.text;
                        function D(t1, e1) {
                            var r = p[t1];
                            return d.tickText(r, r.d2l(e1), !0).text;
                        }
                        var R = e1.texttemplate;
                        if (R) {
                            var F = t1.fullLayout._d3locale, B = Array.isArray(R), N = B ? Math.min(R.length, I) : I, j = B ? function(t1) {
                                return R[t1];
                            } : function() {
                                return R;
                            };
                            for(s = new Array(N), o = 0; o < N; o++){
                                var U = {
                                    x: E[o],
                                    y: C[o],
                                    z: L[o]
                                }, V = {
                                    xLabel: D("xaxis", E[o]),
                                    yLabel: D("yaxis", C[o]),
                                    zLabel: D("zaxis", L[o])
                                }, q = {};
                                m(q, e1, o);
                                var H = e1._meta || {};
                                s[o] = l.texttemplateString(j(o), V, F, q, U, H);
                            }
                        }
                        if (a = {
                            position: f,
                            mode: e1.mode,
                            text: s
                        }, "line" in e1 && (a.lineColor = u(S, 1, I), a.lineWidth = S.width, a.lineDashes = S.dash), "marker" in e1) {
                            var G = h(e1);
                            a.scatterColor = u(M, 1, I), a.scatterSize = T(M.size, I, b, 20, G), a.scatterMarker = T(M.symbol, I, w, "\u25CF"), a.scatterLineWidth = M.line.width, a.scatterLineColor = u(M.line, 1, I), a.scatterAngle = 0;
                        }
                        "textposition" in e1 && (a.textOffset = function(t1) {
                            var e1 = [
                                0,
                                0
                            ];
                            if (Array.isArray(t1)) for(var r = 0; r < t1.length; r++)e1[r] = [
                                0,
                                0
                            ], t1[r] && (e1[r][0] = x(t1[r]), e1[r][1] = _(t1[r]));
                            else e1[0] = x(t1), e1[1] = _(t1);
                            return e1;
                        }(e1.textposition), a.textColor = u(e1.textfont, 1, I), a.textSize = T(e1.textfont.size, I, l.identity, 12), a.textFontFamily = e1.textfont.family, a.textFontWeight = e1.textfont.weight, a.textFontStyle = e1.textfont.style, a.textFontVariant = e1.textfont.variant, a.textAngle = 0);
                        var Z = [
                            "x",
                            "y",
                            "z"
                        ];
                        for(a.project = [
                            !1,
                            !1,
                            !1
                        ], a.projectScale = [
                            1,
                            1,
                            1
                        ], a.projectOpacity = [
                            1,
                            1,
                            1
                        ], o = 0; o < 3; ++o){
                            var W = e1.projection[Z[o]];
                            (a.project[o] = W.show) && (a.projectOpacity[o] = W.opacity, a.projectScale[o] = W.scale);
                        }
                        a.errorBounds = g(e1, y, p);
                        var Y = function(t1) {
                            for(var e1 = [
                                0,
                                0,
                                0
                            ], r = [
                                [
                                    0,
                                    0,
                                    0
                                ],
                                [
                                    0,
                                    0,
                                    0
                                ],
                                [
                                    0,
                                    0,
                                    0
                                ]
                            ], n = [
                                1,
                                1,
                                1
                            ], i = 0; i < 3; i++){
                                var a = t1[i];
                                a && !1 !== a.copy_zstyle && !1 !== t1[2].visible && (a = t1[2]), a && a.visible && (e1[i] = a.width / 2, r[i] = c(a.color), n[i] = a.thickness);
                            }
                            return {
                                capSize: e1,
                                color: r,
                                lineWidth: n
                            };
                        }([
                            e1.error_x,
                            e1.error_y,
                            e1.error_z
                        ]);
                        return a.errorColor = Y.color, a.errorLineWidth = Y.lineWidth, a.errorCapSize = Y.capSize, a.delaunayAxis = e1.surfaceaxis, a.delaunayColor = c(e1.surfacecolor), a;
                    }(this.scene, t1);
                    "mode" in M && (this.mode = M.mode), "lineDashes" in M && M.lineDashes in f && (k = f[M.lineDashes]), this.color = A(M.scatterColor) || A(M.lineColor), this.dataPoints = M.position, e1 = {
                        gl: this.scene.glplot.gl,
                        position: M.position,
                        color: M.lineColor,
                        lineWidth: M.lineWidth || 1,
                        dashes: k[0],
                        dashScale: k[1],
                        opacity: t1.opacity,
                        connectGaps: t1.connectgaps
                    }, -1 !== this.mode.indexOf("lines") ? this.linePlot ? this.linePlot.update(e1) : (this.linePlot = n(e1), this.linePlot._trace = this, this.scene.glplot.add(this.linePlot)) : this.linePlot && (this.scene.glplot.remove(this.linePlot), this.linePlot.dispose(), this.linePlot = null);
                    var S = t1.opacity;
                    if (t1.marker && void 0 !== t1.marker.opacity && (S *= t1.marker.opacity), r = {
                        gl: this.scene.glplot.gl,
                        position: M.position,
                        color: M.scatterColor,
                        size: M.scatterSize,
                        glyph: M.scatterMarker,
                        opacity: S,
                        orthographic: !0,
                        lineWidth: M.scatterLineWidth,
                        lineColor: M.scatterLineColor,
                        project: M.project,
                        projectScale: M.projectScale,
                        projectOpacity: M.projectOpacity
                    }, -1 !== this.mode.indexOf("markers") ? this.scatterPlot ? this.scatterPlot.update(r) : (this.scatterPlot = i(r), this.scatterPlot._trace = this, this.scatterPlot.highlightScale = 1, this.scene.glplot.add(this.scatterPlot)) : this.scatterPlot && (this.scene.glplot.remove(this.scatterPlot), this.scatterPlot.dispose(), this.scatterPlot = null), y = {
                        gl: this.scene.glplot.gl,
                        position: M.position,
                        glyph: M.text,
                        color: M.textColor,
                        size: M.textSize,
                        angle: M.textAngle,
                        alignment: M.textOffset,
                        font: M.textFontFamily,
                        fontWeight: M.textFontWeight,
                        fontStyle: M.textFontStyle,
                        fontVariant: M.textFontVariant,
                        orthographic: !0,
                        lineWidth: 0,
                        project: !1,
                        opacity: t1.opacity
                    }, this.textLabels = t1.hovertext || t1.text, -1 !== this.mode.indexOf("text") ? this.textMarkers ? this.textMarkers.update(y) : (this.textMarkers = i(y), this.textMarkers._trace = this, this.textMarkers.highlightScale = 1, this.scene.glplot.add(this.textMarkers)) : this.textMarkers && (this.scene.glplot.remove(this.textMarkers), this.textMarkers.dispose(), this.textMarkers = null), p = {
                        gl: this.scene.glplot.gl,
                        position: M.position,
                        color: M.errorColor,
                        error: M.errorBounds,
                        lineWidth: M.errorLineWidth,
                        capSize: M.errorCapSize,
                        opacity: t1.opacity
                    }, this.errorBars ? M.errorBounds ? this.errorBars.update(p) : (this.scene.glplot.remove(this.errorBars), this.errorBars.dispose(), this.errorBars = null) : M.errorBounds && (this.errorBars = a(p), this.errorBars._trace = this, this.scene.glplot.add(this.errorBars)), M.delaunayAxis >= 0) {
                        var E = function(t1, e1, r) {
                            var n, i = (r + 1) % 3, a = (r + 2) % 3, o = [], l = [];
                            for(n = 0; n < t1.length; ++n){
                                var c = t1[n];
                                !isNaN(c[i]) && isFinite(c[i]) && !isNaN(c[a]) && isFinite(c[a]) && (o.push([
                                    c[i],
                                    c[a]
                                ]), l.push(n));
                            }
                            var u = s(o);
                            for(n = 0; n < u.length; ++n)for(var h = u[n], f = 0; f < h.length; ++f)h[f] = l[h[f]];
                            return {
                                positions: t1,
                                cells: u,
                                meshColor: e1
                            };
                        }(M.position, M.delaunayColor, M.delaunayAxis);
                        E.opacity = t1.opacity, this.delaunayMesh ? this.delaunayMesh.update(E) : (E.gl = v, this.delaunayMesh = o(E), this.delaunayMesh._trace = this, this.scene.glplot.add(this.delaunayMesh));
                    } else this.delaunayMesh && (this.scene.glplot.remove(this.delaunayMesh), this.delaunayMesh.dispose(), this.delaunayMesh = null);
                }, v.dispose = function() {
                    this.linePlot && (this.scene.glplot.remove(this.linePlot), this.linePlot.dispose()), this.scatterPlot && (this.scene.glplot.remove(this.scatterPlot), this.scatterPlot.dispose()), this.errorBars && (this.scene.glplot.remove(this.errorBars), this.errorBars.dispose()), this.textMarkers && (this.scene.glplot.remove(this.textMarkers), this.textMarkers.dispose()), this.delaunayMesh && (this.scene.glplot.remove(this.delaunayMesh), this.delaunayMesh.dispose());
                }, t1.exports = function(t1, e1) {
                    var r = new y(t1, e1.uid);
                    return r.update(e1), r;
                };
            },
            82418: function(t1, e1, r) {
                "use strict";
                var n = r(33626), i = r(34809), a = r(64726), o = r(24272), s = r(98168), l = r(663), c = r(14117);
                t1.exports = function(t1, e1, r, u) {
                    function h(r, n) {
                        return i.coerce(t1, e1, c, r, n);
                    }
                    var f = function(t1, e1, r, i) {
                        var a = 0, o = r("x"), s = r("y"), l = r("z");
                        return n.getComponentMethod("calendars", "handleTraceDefaults")(t1, e1, [
                            "x",
                            "y",
                            "z"
                        ], i), o && s && l && (a = Math.min(o.length, s.length, l.length), e1._length = e1._xlength = e1._ylength = e1._zlength = a), a;
                    }(t1, e1, h, u);
                    if (f) {
                        h("text"), h("hovertext"), h("hovertemplate"), h("xhoverformat"), h("yhoverformat"), h("zhoverformat"), h("mode"), a.hasMarkers(e1) && o(t1, e1, r, u, h, {
                            noSelect: !0,
                            noAngle: !0
                        }), a.hasLines(e1) && (h("connectgaps"), s(t1, e1, r, u, h)), a.hasText(e1) && (h("texttemplate"), l(t1, e1, u, h, {
                            noSelect: !0,
                            noFontShadow: !0,
                            noFontLineposition: !0,
                            noFontTextcase: !0
                        }));
                        var p = (e1.line || {}).color, d = (e1.marker || {}).color;
                        h("surfaceaxis") >= 0 && h("surfacecolor", p || d);
                        for(var m = [
                            "x",
                            "y",
                            "z"
                        ], g = 0; g < 3; ++g){
                            var y = "projection." + m[g];
                            h(y + ".show") && (h(y + ".opacity"), h(y + ".scale"));
                        }
                        var v = n.getComponentMethod("errorbars", "supplyDefaults");
                        v(t1, e1, p || d || r, {
                            axis: "z"
                        }), v(t1, e1, p || d || r, {
                            axis: "y",
                            inherit: "z"
                        }), v(t1, e1, p || d || r, {
                            axis: "x",
                            inherit: "z"
                        });
                    } else e1.visible = !1;
                };
            },
            17822: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    plot: r(16533),
                    attributes: r(14117),
                    markerSymbols: r(49467),
                    supplyDefaults: r(82418),
                    colorbar: [
                        {
                            container: "marker",
                            min: "cmin",
                            max: "cmax"
                        },
                        {
                            container: "line",
                            min: "cmin",
                            max: "cmax"
                        }
                    ],
                    calc: r(37593),
                    moduleType: "trace",
                    name: "scatter3d",
                    basePlotModule: r(2487),
                    categories: [
                        "gl3d",
                        "symbols",
                        "showLegend",
                        "scatter-like"
                    ],
                    meta: {}
                };
            },
            54637: function(t1, e1, r) {
                "use strict";
                var n = r(19326), i = r(36640), a = r(9829), o = r(3208).rb, s = r(3208).ay, l = r(87163), c = r(93049).extendFlat, u = i.marker, h = i.line, f = u.line;
                t1.exports = {
                    carpet: {
                        valType: "string",
                        editType: "calc"
                    },
                    a: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    b: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    mode: c({}, i.mode, {
                        dflt: "markers"
                    }),
                    text: c({}, i.text, {}),
                    texttemplate: s({
                        editType: "plot"
                    }, {
                        keys: [
                            "a",
                            "b",
                            "text"
                        ]
                    }),
                    hovertext: c({}, i.hovertext, {}),
                    line: {
                        color: h.color,
                        width: h.width,
                        dash: h.dash,
                        backoff: h.backoff,
                        shape: c({}, h.shape, {
                            values: [
                                "linear",
                                "spline"
                            ]
                        }),
                        smoothing: h.smoothing,
                        editType: "calc"
                    },
                    connectgaps: i.connectgaps,
                    fill: c({}, i.fill, {
                        values: [
                            "none",
                            "toself",
                            "tonext"
                        ],
                        dflt: "none"
                    }),
                    fillcolor: n(),
                    marker: c({
                        symbol: u.symbol,
                        opacity: u.opacity,
                        maxdisplayed: u.maxdisplayed,
                        angle: u.angle,
                        angleref: u.angleref,
                        standoff: u.standoff,
                        size: u.size,
                        sizeref: u.sizeref,
                        sizemin: u.sizemin,
                        sizemode: u.sizemode,
                        line: c({
                            width: f.width,
                            editType: "calc"
                        }, l("marker.line")),
                        gradient: u.gradient,
                        editType: "calc"
                    }, l("marker")),
                    textfont: i.textfont,
                    textposition: i.textposition,
                    selected: i.selected,
                    unselected: i.unselected,
                    hoverinfo: c({}, a.hoverinfo, {
                        flags: [
                            "a",
                            "b",
                            "text",
                            "name"
                        ]
                    }),
                    hoveron: i.hoveron,
                    hovertemplate: o(),
                    zorder: i.zorder
                };
            },
            68001: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(77272), a = r(99203), o = r(48861), s = r(26544).calcMarkerSize, l = r(26571);
                t1.exports = function(t1, e1) {
                    var r = e1._carpetTrace = l(t1, e1);
                    if (r && r.visible && "legendonly" !== r.visible) {
                        var c;
                        e1.xaxis = r.xaxis, e1.yaxis = r.yaxis;
                        var u, h, f = e1._length, p = new Array(f), d = !1;
                        for(c = 0; c < f; c++)if (u = e1.a[c], h = e1.b[c], n(u) && n(h)) {
                            var m = r.ab2xy(+u, +h, !0), g = r.isVisible(+u, +h);
                            g || (d = !0), p[c] = {
                                x: m[0],
                                y: m[1],
                                a: u,
                                b: h,
                                vis: g
                            };
                        } else p[c] = {
                            x: !1,
                            y: !1
                        };
                        return e1._needsCull = d, p[0].carpet = r, p[0].trace = e1, s(e1, f), i(t1, e1), a(p, e1), o(p, e1), p;
                    }
                };
            },
            16986: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(32660), a = r(64726), o = r(24272), s = r(98168), l = r(91602), c = r(663), u = r(54114), h = r(54637);
                t1.exports = function(t1, e1, r, f) {
                    function p(r, i) {
                        return n.coerce(t1, e1, h, r, i);
                    }
                    p("carpet"), e1.xaxis = "x", e1.yaxis = "y";
                    var d = p("a"), m = p("b"), g = Math.min(d.length, m.length);
                    if (g) {
                        e1._length = g, p("text"), p("texttemplate"), p("hovertext"), p("mode", g < i.PTS_LINESONLY ? "lines+markers" : "lines"), a.hasMarkers(e1) && o(t1, e1, r, f, p, {
                            gradient: !0
                        }), a.hasLines(e1) && (s(t1, e1, r, f, p, {
                            backoff: !0
                        }), l(t1, e1, p), p("connectgaps")), a.hasText(e1) && c(t1, e1, f, p);
                        var y = [];
                        (a.hasMarkers(e1) || a.hasText(e1)) && (p("marker.maxdisplayed"), y.push("points")), p("fill"), "none" !== e1.fill && (u(t1, e1, r, p), a.hasLines(e1) || l(t1, e1, p)), "tonext" !== e1.fill && "toself" !== e1.fill || y.push("fills"), "fills" !== p("hoveron", y.join("+") || "points") && p("hovertemplate"), p("zorder"), n.coerceSelectionMarkerOpacity(e1, p);
                    } else e1.visible = !1;
                };
            },
            68289: function(t1) {
                "use strict";
                t1.exports = function(t1, e1, r, n, i) {
                    var a = n[i];
                    return t1.a = a.a, t1.b = a.b, t1.y = a.y, t1;
                };
            },
            32709: function(t1) {
                "use strict";
                t1.exports = function(t1, e1) {
                    var r = {}, n = e1._carpet, i = n.ab2ij([
                        t1.a,
                        t1.b
                    ]), a = Math.floor(i[0]), o = i[0] - a, s = Math.floor(i[1]), l = i[1] - s, c = n.evalxy([], a, s, o, l);
                    return r.yLabel = c[1].toFixed(3), r;
                };
            },
            59420: function(t1, e1, r) {
                "use strict";
                var n = r(37255), i = r(34809).fillText;
                t1.exports = function(t1, e1, r, a) {
                    var o = n(t1, e1, r, a);
                    if (o && !1 !== o[0].index) {
                        var s = o[0];
                        if (void 0 === s.index) {
                            var l = 1 - s.y0 / t1.ya._length, c = t1.xa._length, u = c * l / 2, h = c - u;
                            return s.x0 = Math.max(Math.min(s.x0, h), u), s.x1 = Math.max(Math.min(s.x1, h), u), o;
                        }
                        var f = s.cd[s.index];
                        s.a = f.a, s.b = f.b, s.xLabelVal = void 0, s.yLabelVal = void 0;
                        var p = s.trace, d = p._carpet, m = p._module.formatLabels(f, p);
                        s.yLabel = m.yLabel, delete s.text;
                        var g = [];
                        if (!p.hovertemplate) {
                            var y = (f.hi || p.hoverinfo).split("+");
                            -1 !== y.indexOf("all") && (y = [
                                "a",
                                "b",
                                "text"
                            ]), -1 !== y.indexOf("a") && v(d.aaxis, f.a), -1 !== y.indexOf("b") && v(d.baxis, f.b), g.push("y: " + s.yLabel), -1 !== y.indexOf("text") && i(f, p, g), s.extraText = g.join("<br>");
                        }
                        return o;
                    }
                    function v(t1, e1) {
                        var r;
                        r = t1.labelprefix && t1.labelprefix.length > 0 ? t1.labelprefix.replace(/ = $/, "") : t1._hovertitle, g.push(r + ": " + e1.toFixed(3) + t1.labelsuffix);
                    }
                };
            },
            56534: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    attributes: r(54637),
                    supplyDefaults: r(16986),
                    colorbar: r(21146),
                    formatLabels: r(32709),
                    calc: r(68001),
                    plot: r(64535),
                    style: r(9408).style,
                    styleOnSelect: r(9408).styleOnSelect,
                    hoverPoints: r(59420),
                    selectPoints: r(32665),
                    eventData: r(68289),
                    moduleType: "trace",
                    name: "scattercarpet",
                    basePlotModule: r(37703),
                    categories: [
                        "svg",
                        "carpet",
                        "symbols",
                        "showLegend",
                        "carpetDependent",
                        "zoomScale"
                    ],
                    meta: {}
                };
            },
            64535: function(t1, e1, r) {
                "use strict";
                var n = r(36098), i = r(29714), a = r(62203);
                t1.exports = function(t1, e1, r, o) {
                    var s, l, c, u = r[0][0].carpet, h = i.getFromId(t1, u.xaxis || "x"), f = i.getFromId(t1, u.yaxis || "y"), p = {
                        xaxis: h,
                        yaxis: f,
                        plot: e1.plot
                    };
                    for(s = 0; s < r.length; s++)(l = r[s][0].trace)._xA = h, l._yA = f;
                    for(n(t1, p, r, o), s = 0; s < r.length; s++)l = r[s][0].trace, c = o.selectAll("g.trace" + l.uid + " .js-line"), a.setClipUrl(c, r[s][0].carpet._clipPathId, t1);
                };
            },
            6893: function(t1, e1, r) {
                "use strict";
                var n = r(3208).rb, i = r(3208).ay, a = r(19326), o = r(36640), s = r(9829), l = r(87163), c = r(94850).T, u = r(93049).extendFlat, h = r(13582).overrideAll, f = o.marker, p = o.line, d = f.line;
                t1.exports = h({
                    lon: {
                        valType: "data_array"
                    },
                    lat: {
                        valType: "data_array"
                    },
                    locations: {
                        valType: "data_array"
                    },
                    locationmode: {
                        valType: "enumerated",
                        values: [
                            "ISO-3",
                            "USA-states",
                            "country names",
                            "geojson-id"
                        ],
                        dflt: "ISO-3"
                    },
                    geojson: {
                        valType: "any",
                        editType: "calc"
                    },
                    featureidkey: {
                        valType: "string",
                        editType: "calc",
                        dflt: "id"
                    },
                    mode: u({}, o.mode, {
                        dflt: "markers"
                    }),
                    text: u({}, o.text, {}),
                    texttemplate: i({
                        editType: "plot"
                    }, {
                        keys: [
                            "lat",
                            "lon",
                            "location",
                            "text"
                        ]
                    }),
                    hovertext: u({}, o.hovertext, {}),
                    textfont: o.textfont,
                    textposition: o.textposition,
                    line: {
                        color: p.color,
                        width: p.width,
                        dash: c
                    },
                    connectgaps: o.connectgaps,
                    marker: u({
                        symbol: f.symbol,
                        opacity: f.opacity,
                        angle: f.angle,
                        angleref: u({}, f.angleref, {
                            values: [
                                "previous",
                                "up",
                                "north"
                            ]
                        }),
                        standoff: f.standoff,
                        size: f.size,
                        sizeref: f.sizeref,
                        sizemin: f.sizemin,
                        sizemode: f.sizemode,
                        colorbar: f.colorbar,
                        line: u({
                            width: d.width
                        }, l("marker.line")),
                        gradient: f.gradient
                    }, l("marker")),
                    fill: {
                        valType: "enumerated",
                        values: [
                            "none",
                            "toself"
                        ],
                        dflt: "none"
                    },
                    fillcolor: a(),
                    selected: o.selected,
                    unselected: o.unselected,
                    hoverinfo: u({}, s.hoverinfo, {
                        flags: [
                            "lon",
                            "lat",
                            "location",
                            "text",
                            "name"
                        ]
                    }),
                    hovertemplate: n()
                }, "calc", "nested");
            },
            75649: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(63821).BADNUM, a = r(77272), o = r(99203), s = r(48861), l = r(34809).isArrayOrTypedArray, c = r(34809)._;
                function u(t1) {
                    return t1 && "string" == typeof t1;
                }
                t1.exports = function(t1, e1) {
                    var r, h = l(e1.locations), f = h ? e1.locations.length : e1._length, p = new Array(f);
                    r = e1.geojson ? function(t1) {
                        return u(t1) || n(t1);
                    } : u;
                    for(var d = 0; d < f; d++){
                        var m = p[d] = {};
                        if (h) {
                            var g = e1.locations[d];
                            m.loc = r(g) ? g : null;
                        } else {
                            var y = e1.lon[d], v = e1.lat[d];
                            n(y) && n(v) ? m.lonlat = [
                                +y,
                                +v
                            ] : m.lonlat = [
                                i,
                                i
                            ];
                        }
                    }
                    return o(p, e1), a(t1, e1), s(p, e1), f && (p[0].t = {
                        labels: {
                            lat: c(t1, "lat:") + " ",
                            lon: c(t1, "lon:") + " "
                        }
                    }), p;
                };
            },
            27386: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(64726), a = r(24272), o = r(98168), s = r(663), l = r(54114), c = r(6893);
                t1.exports = function(t1, e1, r, u) {
                    function h(r, i) {
                        return n.coerce(t1, e1, c, r, i);
                    }
                    var f, p = h("locations");
                    if (p && p.length) {
                        var d, m = h("geojson");
                        ("string" == typeof m && "" !== m || n.isPlainObject(m)) && (d = "geojson-id"), "geojson-id" === h("locationmode", d) && h("featureidkey"), f = p.length;
                    } else {
                        var g = h("lon") || [], y = h("lat") || [];
                        f = Math.min(g.length, y.length);
                    }
                    f ? (e1._length = f, h("text"), h("hovertext"), h("hovertemplate"), h("mode"), i.hasMarkers(e1) && a(t1, e1, r, u, h, {
                        gradient: !0
                    }), i.hasLines(e1) && (o(t1, e1, r, u, h), h("connectgaps")), i.hasText(e1) && (h("texttemplate"), s(t1, e1, u, h)), h("fill"), "none" !== e1.fill && l(t1, e1, r, h), n.coerceSelectionMarkerOpacity(e1, h)) : e1.visible = !1;
                };
            },
            71873: function(t1) {
                "use strict";
                t1.exports = function(t1, e1, r, n, i) {
                    t1.lon = e1.lon, t1.lat = e1.lat, t1.location = e1.loc ? e1.loc : null;
                    var a = n[i];
                    return a.fIn && a.fIn.properties && (t1.properties = a.fIn.properties), t1;
                };
            },
            57413: function(t1, e1, r) {
                "use strict";
                var n = r(29714);
                t1.exports = function(t1, e1, r) {
                    var i = {}, a = r[e1.geo]._subplot.mockAxis, o = t1.lonlat;
                    return i.lonLabel = n.tickText(a, a.c2l(o[0]), !0).text, i.latLabel = n.tickText(a, a.c2l(o[1]), !0).text, i;
                };
            },
            40636: function(t1, e1, r) {
                "use strict";
                var n = r(32141), i = r(63821).BADNUM, a = r(11539), o = r(34809).fillText, s = r(6893);
                t1.exports = function(t1, e1, r) {
                    var l = t1.cd, c = l[0].trace, u = t1.xa, h = t1.ya, f = t1.subplot, p = f.projection.isLonLatOverEdges, d = f.project;
                    if (n.getClosest(l, function(t1) {
                        var n = t1.lonlat;
                        if (n[0] === i) return 1 / 0;
                        if (p(n)) return 1 / 0;
                        var a = d(n), o = d([
                            e1,
                            r
                        ]), s = Math.abs(a[0] - o[0]), l = Math.abs(a[1] - o[1]), c = Math.max(3, t1.mrc || 0);
                        return Math.max(Math.sqrt(s * s + l * l) - c, 1 - 3 / c);
                    }, t1), !1 !== t1.index) {
                        var m = l[t1.index], g = m.lonlat, y = [
                            u.c2p(g),
                            h.c2p(g)
                        ], v = m.mrc || 1;
                        t1.x0 = y[0] - v, t1.x1 = y[0] + v, t1.y0 = y[1] - v, t1.y1 = y[1] + v, t1.loc = m.loc, t1.lon = g[0], t1.lat = g[1];
                        var x = {};
                        x[c.geo] = {
                            _subplot: f
                        };
                        var _ = c._module.formatLabels(m, c, x);
                        return t1.lonLabel = _.lonLabel, t1.latLabel = _.latLabel, t1.color = a(c, m), t1.extraText = function(t1, e1, r, n) {
                            if (!t1.hovertemplate) {
                                var i = e1.hi || t1.hoverinfo, a = "all" === i ? s.hoverinfo.flags : i.split("+"), l = -1 !== a.indexOf("location") && Array.isArray(t1.locations), c = -1 !== a.indexOf("lon"), u = -1 !== a.indexOf("lat"), h = -1 !== a.indexOf("text"), f = [];
                                return l ? f.push(e1.loc) : c && u ? f.push("(" + p(r.latLabel) + ", " + p(r.lonLabel) + ")") : c ? f.push(n.lon + p(r.lonLabel)) : u && f.push(n.lat + p(r.latLabel)), h && o(e1, t1, f), f.join("<br>");
                            }
                            function p(t1) {
                                return t1 + "\xb0";
                            }
                        }(c, m, t1, l[0].t.labels), t1.hovertemplate = c.hovertemplate, [
                            t1
                        ];
                    }
                };
            },
            18070: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    attributes: r(6893),
                    supplyDefaults: r(27386),
                    colorbar: r(21146),
                    formatLabels: r(57413),
                    calc: r(75649),
                    calcGeoJSON: r(48887).calcGeoJSON,
                    plot: r(48887).plot,
                    style: r(60367),
                    styleOnSelect: r(9408).styleOnSelect,
                    hoverPoints: r(40636),
                    eventData: r(71873),
                    selectPoints: r(45852),
                    moduleType: "trace",
                    name: "scattergeo",
                    basePlotModule: r(47544),
                    categories: [
                        "geo",
                        "symbols",
                        "showLegend",
                        "scatter-like"
                    ],
                    meta: {}
                };
            },
            48887: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(34809), a = r(11577).getTopojsonFeatures, o = r(39532), s = r(3994), l = r(32919).findExtremes, c = r(63821).BADNUM, u = r(26544).calcMarkerSize, h = r(64726), f = r(60367);
                t1.exports = {
                    calcGeoJSON: function(t1, e1) {
                        var r, n, o = t1[0].trace, h = e1[o.geo], f = h._subplot, p = o._length;
                        if (i.isArrayOrTypedArray(o.locations)) {
                            var d = o.locationmode, m = "geojson-id" === d ? s.extractTraceFeature(t1) : a(o, f.topojson);
                            for(r = 0; r < p; r++){
                                n = t1[r];
                                var g = "geojson-id" === d ? n.fOut : s.locationToFeature(d, n.loc, m);
                                n.lonlat = g ? g.properties.ct : [
                                    c,
                                    c
                                ];
                            }
                        }
                        var y, v, x = {
                            padded: !0
                        };
                        if ("geojson" === h.fitbounds && "geojson-id" === o.locationmode) {
                            var _ = s.computeBbox(s.getTraceGeojson(o));
                            y = [
                                _[0],
                                _[2]
                            ], v = [
                                _[1],
                                _[3]
                            ];
                        } else {
                            for(y = new Array(p), v = new Array(p), r = 0; r < p; r++)n = t1[r], y[r] = n.lonlat[0], v[r] = n.lonlat[1];
                            x.ppad = u(o, p);
                        }
                        o._extremes.lon = l(h.lonaxis._ax, y, x), o._extremes.lat = l(h.lataxis._ax, v, x);
                    },
                    plot: function(t1, e1, r) {
                        var a = e1.layers.frontplot.select(".scatterlayer"), s = i.makeTraceGroups(a, r, "trace scattergeo");
                        function l(t1, e1) {
                            t1.lonlat[0] === c && n.select(e1).remove();
                        }
                        s.selectAll("*").remove(), s.each(function(e1) {
                            var r = n.select(this), a = e1[0].trace;
                            if (h.hasLines(a) || "none" !== a.fill) {
                                var s = o.calcTraceToLineCoords(e1), c = "none" !== a.fill ? o.makePolygon(s) : o.makeLine(s);
                                r.selectAll("path.js-line").data([
                                    {
                                        geojson: c,
                                        trace: a
                                    }
                                ]).enter().append("path").classed("js-line", !0).style("stroke-miterlimit", 2);
                            }
                            h.hasMarkers(a) && r.selectAll("path.point").data(i.identity).enter().append("path").classed("point", !0).each(function(t1) {
                                l(t1, this);
                            }), h.hasText(a) && r.selectAll("g").data(i.identity).enter().append("g").append("text").each(function(t1) {
                                l(t1, this);
                            }), f(t1, e1);
                        });
                    }
                };
            },
            45852: function(t1, e1, r) {
                "use strict";
                var n = r(64726), i = r(63821).BADNUM;
                t1.exports = function(t1, e1) {
                    var r, a, o, s, l, c = t1.cd, u = t1.xaxis, h = t1.yaxis, f = [], p = c[0].trace;
                    if (!n.hasMarkers(p) && !n.hasText(p)) return [];
                    if (!1 === e1) for(l = 0; l < c.length; l++)c[l].selected = 0;
                    else for(l = 0; l < c.length; l++)(a = (r = c[l]).lonlat)[0] !== i && (o = u.c2p(a), s = h.c2p(a), e1.contains([
                        o,
                        s
                    ], null, l, t1) ? (f.push({
                        pointNumber: l,
                        lon: a[0],
                        lat: a[1]
                    }), r.selected = 1) : r.selected = 0);
                    return f;
                };
            },
            60367: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(62203), a = r(78766), o = r(9408), s = o.stylePoints, l = o.styleText;
                t1.exports = function(t1, e1) {
                    e1 && function(t1, e1) {
                        var r = e1[0].trace, o = e1[0].node3;
                        o.style("opacity", e1[0].trace.opacity), s(o, r, t1), l(o, r, t1), o.selectAll("path.js-line").style("fill", "none").each(function(t1) {
                            var e1 = n.select(this), r = t1.trace, o = r.line || {};
                            e1.call(a.stroke, o.color).call(i.dashLine, o.dash || "", o.width || 0), "none" !== r.fill && e1.call(a.fill, r.fillcolor);
                        });
                    }(t1, e1);
                };
            },
            92089: function(t1, e1, r) {
                "use strict";
                var n = r(9829), i = r(80337), a = r(19326), o = r(36640), s = r(80712).axisHoverFormat, l = r(87163), c = r(62994), u = r(93049).extendFlat, h = r(13582).overrideAll, f = r(29483).DASHES, p = o.line, d = o.marker, m = d.line, g = t1.exports = h({
                    x: o.x,
                    x0: o.x0,
                    dx: o.dx,
                    y: o.y,
                    y0: o.y0,
                    dy: o.dy,
                    xperiod: o.xperiod,
                    yperiod: o.yperiod,
                    xperiod0: o.xperiod0,
                    yperiod0: o.yperiod0,
                    xperiodalignment: o.xperiodalignment,
                    yperiodalignment: o.yperiodalignment,
                    xhoverformat: s("x"),
                    yhoverformat: s("y"),
                    text: o.text,
                    hovertext: o.hovertext,
                    textposition: o.textposition,
                    textfont: i({
                        noFontShadow: !0,
                        noFontLineposition: !0,
                        noFontTextcase: !0,
                        editType: "calc",
                        colorEditType: "style",
                        arrayOk: !0,
                        noNumericWeightValues: !0,
                        variantValues: [
                            "normal",
                            "small-caps"
                        ]
                    }),
                    mode: {
                        valType: "flaglist",
                        flags: [
                            "lines",
                            "markers",
                            "text"
                        ],
                        extras: [
                            "none"
                        ]
                    },
                    line: {
                        color: p.color,
                        width: p.width,
                        shape: {
                            valType: "enumerated",
                            values: [
                                "linear",
                                "hv",
                                "vh",
                                "hvh",
                                "vhv"
                            ],
                            dflt: "linear",
                            editType: "plot"
                        },
                        dash: {
                            valType: "enumerated",
                            values: c(f),
                            dflt: "solid"
                        }
                    },
                    marker: u({}, l("marker"), {
                        symbol: d.symbol,
                        angle: d.angle,
                        size: d.size,
                        sizeref: d.sizeref,
                        sizemin: d.sizemin,
                        sizemode: d.sizemode,
                        opacity: d.opacity,
                        colorbar: d.colorbar,
                        line: u({}, l("marker.line"), {
                            width: m.width
                        })
                    }),
                    connectgaps: o.connectgaps,
                    fill: u({}, o.fill, {
                        dflt: "none"
                    }),
                    fillcolor: a(),
                    selected: {
                        marker: o.selected.marker,
                        textfont: o.selected.textfont
                    },
                    unselected: {
                        marker: o.unselected.marker,
                        textfont: o.unselected.textfont
                    },
                    opacity: n.opacity
                }, "calc", "nested");
                g.x.editType = g.y.editType = g.x0.editType = g.y0.editType = "calc+clearAxisTypes", g.hovertemplate = o.hovertemplate, g.texttemplate = o.texttemplate;
            },
            68258: function(t1, e1, r) {
                "use strict";
                var n = r(36544);
                t1.exports = {
                    moduleType: "trace",
                    name: "scattergl",
                    basePlotModule: r(37703),
                    categories: [
                        "gl",
                        "regl",
                        "cartesian",
                        "symbols",
                        "errorBarsOK",
                        "showLegend",
                        "scatter-like"
                    ],
                    attributes: r(92089),
                    supplyDefaults: r(86590),
                    crossTraceDefaults: r(53044),
                    colorbar: r(21146),
                    formatLabels: r(99185),
                    calc: r(15293),
                    hoverPoints: n.hoverPoints,
                    selectPoints: r(17168),
                    meta: {}
                };
            },
            15293: function(t1, e1, r) {
                "use strict";
                var n = r(27549), i = r(34809), a = r(5975), o = r(32919).findExtremes, s = r(40528), l = r(26544), c = l.calcMarkerSize, u = l.calcAxisExpansion, h = l.setFirstScatter, f = r(77272), p = r(19937), d = r(62336), m = r(63821).BADNUM, g = r(29483).TOO_MANY_POINTS;
                function y(t1, e1, r) {
                    var n = t1._extremes[e1._id], i = o(e1, r._bnds, {
                        padded: !0
                    });
                    n.min = n.min.concat(i.min), n.max = n.max.concat(i.max);
                }
                t1.exports = function(t1, e1) {
                    var r, o = t1._fullLayout, l = e1._xA = a.getFromId(t1, e1.xaxis, "x"), v = e1._yA = a.getFromId(t1, e1.yaxis, "y"), x = o._plots[e1.xaxis + e1.yaxis], _ = e1._length, b = _ >= g, w = 2 * _, T = {}, k = l.makeCalcdata(e1, "x"), A = v.makeCalcdata(e1, "y"), M = s(e1, l, "x", k), S = s(e1, v, "y", A), E = M.vals, C = S.vals;
                    e1._x = E, e1._y = C, e1.xperiodalignment && (e1._origX = k, e1._xStarts = M.starts, e1._xEnds = M.ends), e1.yperiodalignment && (e1._origY = A, e1._yStarts = S.starts, e1._yEnds = S.ends);
                    var L = new Array(w), I = new Array(_);
                    for(r = 0; r < _; r++)L[2 * r] = E[r] === m ? NaN : E[r], L[2 * r + 1] = C[r] === m ? NaN : C[r], I[r] = r;
                    if ("log" === l.type) for(r = 0; r < w; r += 2)L[r] = l.c2l(L[r]);
                    if ("log" === v.type) for(r = 1; r < w; r += 2)L[r] = v.c2l(L[r]);
                    b && "log" !== l.type && "log" !== v.type ? T.tree = n(L) : T.ids = I, f(t1, e1);
                    var P, z = function(t1, e1, r, n, a, o) {
                        var s = p.style(t1, r);
                        if (s.marker && (s.marker.positions = n), s.line && n.length > 1 && i.extendFlat(s.line, p.linePositions(t1, r, n)), s.errorX || s.errorY) {
                            var l = p.errorBarPositions(t1, r, n, a, o);
                            s.errorX && i.extendFlat(s.errorX, l.x), s.errorY && i.extendFlat(s.errorY, l.y);
                        }
                        return s.text && (i.extendFlat(s.text, {
                            positions: n
                        }, p.textPosition(t1, r, s.text, s.marker)), i.extendFlat(s.textSel, {
                            positions: n
                        }, p.textPosition(t1, r, s.text, s.markerSel)), i.extendFlat(s.textUnsel, {
                            positions: n
                        }, p.textPosition(t1, r, s.text, s.markerUnsel))), s;
                    }(t1, 0, e1, L, E, C), O = d(t1, x);
                    return h(o, e1), b ? z.marker && (P = z.marker.sizeAvg || Math.max(z.marker.size, 3)) : P = c(e1, _), u(t1, e1, l, v, E, C, P), z.errorX && y(e1, l, z.errorX), z.errorY && y(e1, v, z.errorY), z.fill && !O.fill2d && (O.fill2d = !0), z.marker && !O.scatter2d && (O.scatter2d = !0), z.line && !O.line2d && (O.line2d = !0), !z.errorX && !z.errorY || O.error2d || (O.error2d = !0), z.text && !O.glText && (O.glText = !0), z.marker && (z.marker.snap = _), O.lineOptions.push(z.line), O.errorXOptions.push(z.errorX), O.errorYOptions.push(z.errorY), O.fillOptions.push(z.fill), O.markerOptions.push(z.marker), O.markerSelectedOptions.push(z.markerSel), O.markerUnselectedOptions.push(z.markerUnsel), O.textOptions.push(z.text), O.textSelectedOptions.push(z.textSel), O.textUnselectedOptions.push(z.textUnsel), O.selectBatch.push([]), O.unselectBatch.push([]), T._scene = O, T.index = O.count, T.x = E, T.y = C, T.positions = L, O.count++, [
                        {
                            x: !1,
                            y: !1,
                            t: T,
                            trace: e1
                        }
                    ];
                };
            },
            29483: function(t1) {
                "use strict";
                t1.exports = {
                    TOO_MANY_POINTS: 1e5,
                    SYMBOL_SDF_SIZE: 200,
                    SYMBOL_SIZE: 20,
                    SYMBOL_STROKE: 1,
                    DOT_RE: /-dot/,
                    OPEN_RE: /-open/,
                    DASHES: {
                        solid: [
                            1
                        ],
                        dot: [
                            1,
                            1
                        ],
                        dash: [
                            4,
                            1
                        ],
                        longdash: [
                            8,
                            1
                        ],
                        dashdot: [
                            4,
                            1,
                            1,
                            1
                        ],
                        longdashdot: [
                            8,
                            1,
                            1,
                            1
                        ]
                    }
                };
            },
            19937: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(96021), a = r(162), o = r(33626), s = r(34809), l = s.isArrayOrTypedArray, c = r(62203), u = r(5975), h = r(46998).formatColor, f = r(64726), p = r(92527), d = r(4075), m = r(29483), g = r(20438).DESELECTDIM, y = {
                    start: 1,
                    left: 1,
                    end: -1,
                    right: -1,
                    middle: 0,
                    center: 0,
                    bottom: 1,
                    top: -1
                }, v = r(36040).appendArrayPointValue;
                function x(t1, e1) {
                    var r, i = t1._fullLayout, a = e1._length, o = e1.textfont, c = e1.textposition, u = l(c) ? c : [
                        c
                    ], h = o.color, f = o.size, p = o.family, d = o.weight, m = o.style, g = o.variant, y = {}, x = t1._context.plotGlPixelRatio, b = e1.texttemplate;
                    if (b) {
                        y.text = [];
                        var w = i._d3locale, T = Array.isArray(b), k = T ? Math.min(b.length, a) : a, A = T ? function(t1) {
                            return b[t1];
                        } : function() {
                            return b;
                        };
                        for(r = 0; r < k; r++){
                            var M = {
                                i: r
                            }, S = e1._module.formatLabels(M, e1, i), E = {};
                            v(E, e1, r);
                            var C = e1._meta || {};
                            y.text.push(s.texttemplateString(A(r), S, w, E, M, C));
                        }
                    } else l(e1.text) && e1.text.length < a ? y.text = e1.text.slice() : y.text = e1.text;
                    if (l(y.text)) for(r = y.text.length; r < a; r++)y.text[r] = "";
                    for(y.opacity = e1.opacity, y.font = {}, y.align = [], y.baseline = [], r = 0; r < u.length; r++){
                        var L = u[r].split(/\s+/);
                        switch(L[1]){
                            case "left":
                                y.align.push("right");
                                break;
                            case "right":
                                y.align.push("left");
                                break;
                            default:
                                y.align.push(L[1]);
                        }
                        switch(L[0]){
                            case "top":
                                y.baseline.push("bottom");
                                break;
                            case "bottom":
                                y.baseline.push("top");
                                break;
                            default:
                                y.baseline.push(L[0]);
                        }
                    }
                    if (l(h)) for(y.color = new Array(a), r = 0; r < a; r++)y.color[r] = h[r];
                    else y.color = h;
                    if (l(f) || Array.isArray(p) || l(d) || Array.isArray(m) || Array.isArray(g)) for(y.font = new Array(a), r = 0; r < a; r++){
                        var I = y.font[r] = {};
                        I.size = (s.isTypedArray(f) ? f[r] : l(f) ? n(f[r]) ? f[r] : 0 : f) * x, I.family = Array.isArray(p) ? p[r] : p, I.weight = _(l(d) ? d[r] : d), I.style = Array.isArray(m) ? m[r] : m, I.variant = Array.isArray(g) ? g[r] : g;
                    }
                    else y.font = {
                        size: f * x,
                        family: p,
                        weight: _(d),
                        style: m,
                        variant: g
                    };
                    return y;
                }
                function _(t1) {
                    return t1 <= 1e3 ? t1 > 500 ? "bold" : "normal" : t1;
                }
                function b(t1, e1) {
                    var r, n, i = e1._length, o = e1.marker, s = {}, c = l(o.symbol), u = l(o.angle), f = l(o.color), m = l(o.line.color), g = l(o.opacity), y = l(o.size), v = l(o.line.width);
                    if (c || (n = d.isOpenSymbol(o.symbol)), c || f || m || g || u) {
                        s.symbols = new Array(i), s.angles = new Array(i), s.colors = new Array(i), s.borderColors = new Array(i);
                        var x = o.symbol, _ = o.angle, b = h(o, o.opacity, i), w = h(o.line, o.opacity, i);
                        if (!l(w[0])) {
                            var T = w;
                            for(w = Array(i), r = 0; r < i; r++)w[r] = T;
                        }
                        if (!l(b[0])) {
                            var k = b;
                            for(b = Array(i), r = 0; r < i; r++)b[r] = k;
                        }
                        if (!l(x)) {
                            var A = x;
                            for(x = Array(i), r = 0; r < i; r++)x[r] = A;
                        }
                        if (!l(_)) {
                            var M = _;
                            for(_ = Array(i), r = 0; r < i; r++)_[r] = M;
                        }
                        for(s.symbols = x, s.angles = _, s.colors = b, s.borderColors = w, r = 0; r < i; r++)c && (n = d.isOpenSymbol(o.symbol[r])), n && (w[r] = b[r].slice(), b[r] = b[r].slice(), b[r][3] = 0);
                        for(s.opacity = e1.opacity, s.markers = new Array(i), r = 0; r < i; r++)s.markers[r] = L({
                            mx: s.symbols[r],
                            ma: s.angles[r]
                        }, e1);
                    } else n ? (s.color = a(o.color, "uint8"), s.color[3] = 0, s.borderColor = a(o.color, "uint8")) : (s.color = a(o.color, "uint8"), s.borderColor = a(o.line.color, "uint8")), s.opacity = e1.opacity * o.opacity, s.marker = L({
                        mx: o.symbol,
                        ma: o.angle
                    }, e1);
                    var S, E = p(e1, 1);
                    if (y || v) {
                        var C, I = s.sizes = new Array(i), P = s.borderSizes = new Array(i), z = 0;
                        if (y) {
                            for(r = 0; r < i; r++)I[r] = E(o.size[r]), z += I[r];
                            C = z / i;
                        } else for(S = E(o.size), r = 0; r < i; r++)I[r] = S;
                        if (v) for(r = 0; r < i; r++)P[r] = o.line.width[r];
                        else for(S = o.line.width, r = 0; r < i; r++)P[r] = S;
                        s.sizeAvg = C;
                    } else s.size = E(o && o.size || 10), s.borderSizes = E(o.line.width);
                    return s;
                }
                function w(t1, e1, r) {
                    var n = e1.marker, i = {};
                    return r ? (r.marker && r.marker.symbol ? i = b(0, s.extendFlat({}, n, r.marker)) : r.marker && (r.marker.size && (i.size = r.marker.size), r.marker.color && (i.colors = r.marker.color), void 0 !== r.marker.opacity && (i.opacity = r.marker.opacity)), i) : i;
                }
                function T(t1, e1, r) {
                    var n = {};
                    if (!r) return n;
                    if (r.textfont) {
                        var i = {
                            opacity: 1,
                            text: e1.text,
                            texttemplate: e1.texttemplate,
                            textposition: e1.textposition,
                            textfont: s.extendFlat({}, e1.textfont)
                        };
                        r.textfont && s.extendFlat(i.textfont, r.textfont), n = x(t1, i);
                    }
                    return n;
                }
                function k(t1, e1, r) {
                    var n = {
                        capSize: 2 * e1.width * r,
                        lineWidth: e1.thickness * r,
                        color: e1.color
                    };
                    return e1.copy_ystyle && (n = t1.error_y), n;
                }
                var A = m.SYMBOL_SDF_SIZE, M = m.SYMBOL_SIZE, S = m.SYMBOL_STROKE, E = {}, C = c.symbolFuncs[0](.05 * M);
                function L(t1, e1) {
                    var r, n, a = t1.mx;
                    if ("circle" === a) return null;
                    var o = c.symbolNumber(a), s = c.symbolFuncs[o % 100], l = !!c.symbolNoDot[o % 100], u = !!c.symbolNoFill[o % 100], h = d.isDotSymbol(a);
                    if (t1.ma && (a += "_" + t1.ma), E[a]) return E[a];
                    var f = c.getMarkerAngle(t1, e1);
                    return r = h && !l ? s(1.1 * M, f) + C : s(M, f), n = i(r, {
                        w: A,
                        h: A,
                        viewBox: [
                            -M,
                            -M,
                            M,
                            M
                        ],
                        stroke: u ? S : -S
                    }), E[a] = n, n || null;
                }
                t1.exports = {
                    style: function(t1, e1) {
                        var r, n = {
                            marker: void 0,
                            markerSel: void 0,
                            markerUnsel: void 0,
                            line: void 0,
                            fill: void 0,
                            errorX: void 0,
                            errorY: void 0,
                            text: void 0,
                            textSel: void 0,
                            textUnsel: void 0
                        }, i = t1._context.plotGlPixelRatio;
                        if (!0 !== e1.visible) return n;
                        if (f.hasText(e1) && (n.text = x(t1, e1), n.textSel = T(t1, e1, e1.selected), n.textUnsel = T(t1, e1, e1.unselected)), f.hasMarkers(e1) && (n.marker = b(0, e1), n.markerSel = w(0, e1, e1.selected), n.markerUnsel = w(0, e1, e1.unselected), !e1.unselected && l(e1.marker.opacity))) {
                            var a = e1.marker.opacity;
                            for(n.markerUnsel.opacity = new Array(a.length), r = 0; r < a.length; r++)n.markerUnsel.opacity[r] = g * a[r];
                        }
                        if (f.hasLines(e1)) {
                            n.line = {
                                overlay: !0,
                                thickness: e1.line.width * i,
                                color: e1.line.color,
                                opacity: e1.opacity
                            };
                            var o = (m.DASHES[e1.line.dash] || [
                                1
                            ]).slice();
                            for(r = 0; r < o.length; ++r)o[r] *= e1.line.width * i;
                            n.line.dashes = o;
                        }
                        return e1.error_x && e1.error_x.visible && (n.errorX = k(e1, e1.error_x, i)), e1.error_y && e1.error_y.visible && (n.errorY = k(e1, e1.error_y, i)), e1.fill && "none" !== e1.fill && (n.fill = {
                            closed: !0,
                            fill: e1.fillcolor,
                            thickness: 0
                        }), n;
                    },
                    markerStyle: b,
                    markerSelection: w,
                    linePositions: function(t1, e1, r) {
                        var n, i, a = r.length, o = a / 2;
                        if (f.hasLines(e1) && o) {
                            if ("hv" === e1.line.shape) {
                                for(n = [], i = 0; i < o - 1; i++)isNaN(r[2 * i]) || isNaN(r[2 * i + 1]) ? n.push(NaN, NaN, NaN, NaN) : (n.push(r[2 * i], r[2 * i + 1]), isNaN(r[2 * i + 2]) || isNaN(r[2 * i + 3]) ? n.push(NaN, NaN) : n.push(r[2 * i + 2], r[2 * i + 1]));
                                n.push(r[a - 2], r[a - 1]);
                            } else if ("hvh" === e1.line.shape) {
                                for(n = [], i = 0; i < o - 1; i++)if (isNaN(r[2 * i]) || isNaN(r[2 * i + 1]) || isNaN(r[2 * i + 2]) || isNaN(r[2 * i + 3])) isNaN(r[2 * i]) || isNaN(r[2 * i + 1]) ? n.push(NaN, NaN) : n.push(r[2 * i], r[2 * i + 1]), n.push(NaN, NaN);
                                else {
                                    var s = (r[2 * i] + r[2 * i + 2]) / 2;
                                    n.push(r[2 * i], r[2 * i + 1], s, r[2 * i + 1], s, r[2 * i + 3]);
                                }
                                n.push(r[a - 2], r[a - 1]);
                            } else if ("vhv" === e1.line.shape) {
                                for(n = [], i = 0; i < o - 1; i++)if (isNaN(r[2 * i]) || isNaN(r[2 * i + 1]) || isNaN(r[2 * i + 2]) || isNaN(r[2 * i + 3])) isNaN(r[2 * i]) || isNaN(r[2 * i + 1]) ? n.push(NaN, NaN) : n.push(r[2 * i], r[2 * i + 1]), n.push(NaN, NaN);
                                else {
                                    var l = (r[2 * i + 1] + r[2 * i + 3]) / 2;
                                    n.push(r[2 * i], r[2 * i + 1], r[2 * i], l, r[2 * i + 2], l);
                                }
                                n.push(r[a - 2], r[a - 1]);
                            } else if ("vh" === e1.line.shape) {
                                for(n = [], i = 0; i < o - 1; i++)isNaN(r[2 * i]) || isNaN(r[2 * i + 1]) ? n.push(NaN, NaN, NaN, NaN) : (n.push(r[2 * i], r[2 * i + 1]), isNaN(r[2 * i + 2]) || isNaN(r[2 * i + 3]) ? n.push(NaN, NaN) : n.push(r[2 * i], r[2 * i + 3]));
                                n.push(r[a - 2], r[a - 1]);
                            } else n = r;
                        }
                        var c = !1;
                        for(i = 0; i < n.length; i++)if (isNaN(n[i])) {
                            c = !0;
                            break;
                        }
                        var u = c || n.length > m.TOO_MANY_POINTS || f.hasMarkers(e1) ? "rect" : "round";
                        if (c && e1.connectgaps) {
                            var h = n[0], p = n[1];
                            for(i = 0; i < n.length; i += 2)isNaN(n[i]) || isNaN(n[i + 1]) ? (n[i] = h, n[i + 1] = p) : (h = n[i], p = n[i + 1]);
                        }
                        return {
                            join: u,
                            positions: n
                        };
                    },
                    errorBarPositions: function(t1, e1, r, i, a) {
                        var s = o.getComponentMethod("errorbars", "makeComputeError"), l = u.getFromId(t1, e1.xaxis, "x"), c = u.getFromId(t1, e1.yaxis, "y"), h = r.length / 2, f = {};
                        function p(t1, i) {
                            var a = i._id.charAt(0), o = e1["error_" + a];
                            if (o && o.visible && ("linear" === i.type || "log" === i.type)) {
                                for(var l = s(o), c = {
                                    x: 0,
                                    y: 1
                                }[a], u = {
                                    x: [
                                        0,
                                        1,
                                        2,
                                        3
                                    ],
                                    y: [
                                        2,
                                        3,
                                        0,
                                        1
                                    ]
                                }[a], p = new Float64Array(4 * h), d = 1 / 0, m = -1 / 0, g = 0, y = 0; g < h; g++, y += 4){
                                    var v = t1[g];
                                    if (n(v)) {
                                        var x = r[2 * g + c], _ = l(v, g), b = _[0], w = _[1];
                                        if (n(b) && n(w)) {
                                            var T = v - b, k = v + w;
                                            p[y + u[0]] = x - i.c2l(T), p[y + u[1]] = i.c2l(k) - x, p[y + u[2]] = 0, p[y + u[3]] = 0, d = Math.min(d, v - b), m = Math.max(m, v + w);
                                        }
                                    }
                                }
                                f[a] = {
                                    positions: r,
                                    errors: p,
                                    _bnds: [
                                        d,
                                        m
                                    ]
                                };
                            }
                        }
                        return p(i, l), p(a, c), f;
                    },
                    textPosition: function(t1, e1, r, n) {
                        var i, a = e1._length, o = {};
                        if (f.hasMarkers(e1)) {
                            var s = r.font, c = r.align, u = r.baseline;
                            for(o.offset = new Array(a), i = 0; i < a; i++){
                                var h = n.sizes ? n.sizes[i] : n.size, p = l(s) ? s[i].size : s.size, d = l(c) ? c.length > 1 ? c[i] : c[0] : c, m = l(u) ? u.length > 1 ? u[i] : u[0] : u, g = y[d], v = y[m], x = h ? h / .8 + 1 : 0, _ = -v * x - .5 * v;
                                o.offset[i] = [
                                    g * x / p,
                                    _ / p
                                ];
                            }
                        }
                        return o;
                    }
                };
            },
            86590: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(33626), a = r(4075), o = r(92089), s = r(32660), l = r(64726), c = r(99867), u = r(99669), h = r(24272), f = r(98168), p = r(54114), d = r(663);
                t1.exports = function(t1, e1, r, m) {
                    function g(r, i) {
                        return n.coerce(t1, e1, o, r, i);
                    }
                    var y = !!t1.marker && a.isOpenSymbol(t1.marker.symbol), v = l.isBubble(t1), x = c(t1, e1, m, g);
                    if (x) {
                        u(t1, e1, m, g), g("xhoverformat"), g("yhoverformat");
                        var _ = x < s.PTS_LINESONLY ? "lines+markers" : "lines";
                        g("text"), g("hovertext"), g("hovertemplate"), g("mode", _), l.hasMarkers(e1) && (h(t1, e1, r, m, g, {
                            noAngleRef: !0,
                            noStandOff: !0
                        }), g("marker.line.width", y || v ? 1 : 0)), l.hasLines(e1) && (g("connectgaps"), f(t1, e1, r, m, g), g("line.shape")), l.hasText(e1) && (g("texttemplate"), d(t1, e1, m, g, {
                            noFontShadow: !0,
                            noFontLineposition: !0,
                            noFontTextcase: !0
                        }));
                        var b = (e1.line || {}).color, w = (e1.marker || {}).color;
                        g("fill"), "none" !== e1.fill && p(t1, e1, r, g);
                        var T = i.getComponentMethod("errorbars", "supplyDefaults");
                        T(t1, e1, b || w || r, {
                            axis: "y"
                        }), T(t1, e1, b || w || r, {
                            axis: "x",
                            inherit: "y"
                        }), n.coerceSelectionMarkerOpacity(e1, g);
                    } else e1.visible = !1;
                };
            },
            85686: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(78766), a = r(20438).DESELECTDIM;
                t1.exports = {
                    styleTextSelection: function(t1) {
                        var e1, r, o = t1[0], s = o.trace, l = o.t, c = l._scene, u = l.index, h = c.selectBatch[u], f = c.unselectBatch[u], p = c.textOptions[u], d = c.textSelectedOptions[u] || {}, m = c.textUnselectedOptions[u] || {}, g = n.extendFlat({}, p);
                        if (h.length || f.length) {
                            var y = d.color, v = m.color, x = p.color, _ = n.isArrayOrTypedArray(x);
                            for(g.color = new Array(s._length), e1 = 0; e1 < h.length; e1++)r = h[e1], g.color[r] = y || (_ ? x[r] : x);
                            for(e1 = 0; e1 < f.length; e1++){
                                r = f[e1];
                                var b = _ ? x[r] : x;
                                g.color[r] = v || (y ? b : i.addOpacity(b, a));
                            }
                        }
                        c.glText[u].update(g);
                    }
                };
            },
            99185: function(t1, e1, r) {
                "use strict";
                var n = r(15294);
                t1.exports = function(t1, e1, r) {
                    var i = t1.i;
                    return "x" in t1 || (t1.x = e1._x[i]), "y" in t1 || (t1.y = e1._y[i]), n(t1, e1, r);
                };
            },
            4075: function(t1, e1, r) {
                "use strict";
                var n = r(29483);
                e1.isOpenSymbol = function(t1) {
                    return "string" == typeof t1 ? n.OPEN_RE.test(t1) : t1 % 200 > 100;
                }, e1.isDotSymbol = function(t1) {
                    return "string" == typeof t1 ? n.DOT_RE.test(t1) : t1 > 200;
                };
            },
            36544: function(t1, e1, r) {
                "use strict";
                var n = r(33626), i = r(34809), a = r(11539);
                function o(t1, e1, r, o) {
                    var s = t1.xa, l = t1.ya, c = t1.distance, u = t1.dxy, h = t1.index, f = {
                        pointNumber: h,
                        x: e1[h],
                        y: r[h]
                    };
                    f.tx = i.isArrayOrTypedArray(o.text) ? o.text[h] : o.text, f.htx = Array.isArray(o.hovertext) ? o.hovertext[h] : o.hovertext, f.data = Array.isArray(o.customdata) ? o.customdata[h] : o.customdata, f.tp = Array.isArray(o.textposition) ? o.textposition[h] : o.textposition;
                    var p = o.textfont;
                    p && (f.ts = i.isArrayOrTypedArray(p.size) ? p.size[h] : p.size, f.tc = i.isArrayOrTypedArray(p.color) ? p.color[h] : p.color, f.tf = Array.isArray(p.family) ? p.family[h] : p.family, f.tw = Array.isArray(p.weight) ? p.weight[h] : p.weight, f.ty = Array.isArray(p.style) ? p.style[h] : p.style, f.tv = Array.isArray(p.variant) ? p.variant[h] : p.variant);
                    var d = o.marker;
                    d && (f.ms = i.isArrayOrTypedArray(d.size) ? d.size[h] : d.size, f.mo = i.isArrayOrTypedArray(d.opacity) ? d.opacity[h] : d.opacity, f.mx = i.isArrayOrTypedArray(d.symbol) ? d.symbol[h] : d.symbol, f.ma = i.isArrayOrTypedArray(d.angle) ? d.angle[h] : d.angle, f.mc = i.isArrayOrTypedArray(d.color) ? d.color[h] : d.color);
                    var m = d && d.line;
                    m && (f.mlc = Array.isArray(m.color) ? m.color[h] : m.color, f.mlw = i.isArrayOrTypedArray(m.width) ? m.width[h] : m.width);
                    var g = d && d.gradient;
                    g && "none" !== g.type && (f.mgt = Array.isArray(g.type) ? g.type[h] : g.type, f.mgc = Array.isArray(g.color) ? g.color[h] : g.color);
                    var y = s.c2p(f.x, !0), v = l.c2p(f.y, !0), x = f.mrc || 1, _ = o.hoverlabel;
                    _ && (f.hbg = Array.isArray(_.bgcolor) ? _.bgcolor[h] : _.bgcolor, f.hbc = Array.isArray(_.bordercolor) ? _.bordercolor[h] : _.bordercolor, f.hts = i.isArrayOrTypedArray(_.font.size) ? _.font.size[h] : _.font.size, f.htc = Array.isArray(_.font.color) ? _.font.color[h] : _.font.color, f.htf = Array.isArray(_.font.family) ? _.font.family[h] : _.font.family, f.hnl = i.isArrayOrTypedArray(_.namelength) ? _.namelength[h] : _.namelength);
                    var b = o.hoverinfo;
                    b && (f.hi = Array.isArray(b) ? b[h] : b);
                    var w = o.hovertemplate;
                    w && (f.ht = Array.isArray(w) ? w[h] : w);
                    var T = {};
                    T[t1.index] = f;
                    var k = o._origX, A = o._origY, M = i.extendFlat({}, t1, {
                        color: a(o, f),
                        x0: y - x,
                        x1: y + x,
                        xLabelVal: k ? k[h] : f.x,
                        y0: v - x,
                        y1: v + x,
                        yLabelVal: A ? A[h] : f.y,
                        cd: T,
                        distance: c,
                        spikeDistance: u,
                        hovertemplate: f.ht
                    });
                    return f.htx ? M.text = f.htx : f.tx ? M.text = f.tx : o.text && (M.text = o.text), i.fillText(f, o, M), n.getComponentMethod("errorbars", "hoverInfo")(f, o, M), M;
                }
                t1.exports = {
                    hoverPoints: function(t1, e1, r, n) {
                        var i, a, s, l, c, u, h, f, p, d, m = t1.cd, g = m[0].t, y = m[0].trace, v = t1.xa, x = t1.ya, _ = g.x, b = g.y, w = v.c2p(e1), T = x.c2p(r), k = t1.distance;
                        if (g.tree) {
                            var A = v.p2c(w - k), M = v.p2c(w + k), S = x.p2c(T - k), E = x.p2c(T + k);
                            i = "x" === n ? g.tree.range(Math.min(A, M), Math.min(x._rl[0], x._rl[1]), Math.max(A, M), Math.max(x._rl[0], x._rl[1])) : g.tree.range(Math.min(A, M), Math.min(S, E), Math.max(A, M), Math.max(S, E));
                        } else i = g.ids;
                        var C = k;
                        if ("x" === n) {
                            var L = !!y.xperiodalignment, I = !!y.yperiodalignment;
                            for(u = 0; u < i.length; u++){
                                if (l = _[a = i[u]], h = Math.abs(v.c2p(l) - w), L) {
                                    var P = v.c2p(y._xStarts[a]), z = v.c2p(y._xEnds[a]);
                                    h = w >= Math.min(P, z) && w <= Math.max(P, z) ? 0 : 1 / 0;
                                }
                                if (h < C) {
                                    if (C = h, c = b[a], f = x.c2p(c) - T, I) {
                                        var O = x.c2p(y._yStarts[a]), D = x.c2p(y._yEnds[a]);
                                        f = T >= Math.min(O, D) && T <= Math.max(O, D) ? 0 : 1 / 0;
                                    }
                                    d = Math.sqrt(h * h + f * f), s = i[u];
                                }
                            }
                        } else for(u = i.length - 1; u > -1; u--)l = _[a = i[u]], c = b[a], h = v.c2p(l) - w, f = x.c2p(c) - T, (p = Math.sqrt(h * h + f * f)) < C && (C = d = p, s = a);
                        return t1.index = s, t1.distance = C, t1.dxy = d, void 0 === s ? [
                            t1
                        ] : [
                            o(t1, _, b, y)
                        ];
                    },
                    calcHover: o
                };
            },
            52378: function(t1, e1, r) {
                "use strict";
                var n = r(68258);
                n.plot = r(47731), t1.exports = n;
            },
            47731: function(t1, e1, r) {
                "use strict";
                var n = r(62172), i = r(49478), a = r(29978), o = r(74024), s = r(34809), l = r(70414).selectMode, c = r(22459), u = r(64726), h = r(17210), f = r(85686).styleTextSelection, p = {};
                function d(t1, e1, r, n) {
                    var i = t1._size, a = t1.width * n, o = t1.height * n, s = i.l * n, l = i.b * n, c = i.r * n, u = i.t * n, h = i.w * n, f = i.h * n;
                    return [
                        s + e1.domain[0] * h,
                        l + r.domain[0] * f,
                        a - c - (1 - e1.domain[1]) * h,
                        o - u - (1 - r.domain[1]) * f
                    ];
                }
                (t1.exports = function(t1, e1, r) {
                    if (r.length) {
                        var m, g, y = t1._fullLayout, v = e1._scene, x = e1.xaxis, _ = e1.yaxis;
                        if (v) {
                            if (c(t1, [
                                "ANGLE_instanced_arrays",
                                "OES_element_index_uint"
                            ], p)) {
                                var b = v.count, w = y._glcanvas.data()[0].regl;
                                if (h(t1, e1, r), v.dirty) {
                                    if (!v.line2d && !v.error2d || v.scatter2d || v.fill2d || v.glText || w.clear({}), !0 === v.error2d && (v.error2d = a(w)), !0 === v.line2d && (v.line2d = i(w)), !0 === v.scatter2d && (v.scatter2d = n(w)), !0 === v.fill2d && (v.fill2d = i(w)), !0 === v.glText) for(v.glText = new Array(b), m = 0; m < b; m++)v.glText[m] = new o(w);
                                    if (v.glText) {
                                        if (b > v.glText.length) {
                                            var T = b - v.glText.length;
                                            for(m = 0; m < T; m++)v.glText.push(new o(w));
                                        } else if (b < v.glText.length) {
                                            var k = v.glText.length - b;
                                            v.glText.splice(b, k).forEach(function(t1) {
                                                t1.destroy();
                                            });
                                        }
                                        for(m = 0; m < b; m++)v.glText[m].update(v.textOptions[m]);
                                    }
                                    if (v.line2d && (v.line2d.update(v.lineOptions), v.lineOptions = v.lineOptions.map(function(t1) {
                                        if (t1 && t1.positions) {
                                            for(var e1 = t1.positions, r = 0; r < e1.length && (isNaN(e1[r]) || isNaN(e1[r + 1]));)r += 2;
                                            for(var n = e1.length - 2; n > r && (isNaN(e1[n]) || isNaN(e1[n + 1]));)n -= 2;
                                            t1.positions = e1.slice(r, n + 2);
                                        }
                                        return t1;
                                    }), v.line2d.update(v.lineOptions)), v.error2d) {
                                        var A = (v.errorXOptions || []).concat(v.errorYOptions || []);
                                        v.error2d.update(A);
                                    }
                                    v.scatter2d && v.scatter2d.update(v.markerOptions), v.fillOrder = s.repeat(null, b), v.fill2d && (v.fillOptions = v.fillOptions.map(function(t1, e1) {
                                        var n = r[e1];
                                        if (t1 && n && n[0] && n[0].trace) {
                                            var i, a, o = n[0], s = o.trace, l = o.t, c = v.lineOptions[e1], u = [];
                                            s._ownfill && u.push(e1), s._nexttrace && u.push(e1 + 1), u.length && (v.fillOrder[e1] = u);
                                            var h, f, p = [], d = c && c.positions || l.positions;
                                            if ("tozeroy" === s.fill) {
                                                for(h = 0; h < d.length && isNaN(d[h + 1]);)h += 2;
                                                for(f = d.length - 2; f > h && isNaN(d[f + 1]);)f -= 2;
                                                0 !== d[h + 1] && (p = [
                                                    d[h],
                                                    0
                                                ]), p = p.concat(d.slice(h, f + 2)), 0 !== d[f + 1] && (p = p.concat([
                                                    d[f],
                                                    0
                                                ]));
                                            } else if ("tozerox" === s.fill) {
                                                for(h = 0; h < d.length && isNaN(d[h]);)h += 2;
                                                for(f = d.length - 2; f > h && isNaN(d[f]);)f -= 2;
                                                0 !== d[h] && (p = [
                                                    0,
                                                    d[h + 1]
                                                ]), p = p.concat(d.slice(h, f + 2)), 0 !== d[f] && (p = p.concat([
                                                    0,
                                                    d[f + 1]
                                                ]));
                                            } else if ("toself" === s.fill || "tonext" === s.fill) {
                                                for(p = [], i = 0, t1.splitNull = !0, a = 0; a < d.length; a += 2)(isNaN(d[a]) || isNaN(d[a + 1])) && ((p = p.concat(d.slice(i, a))).push(d[i], d[i + 1]), p.push(null, null), i = a + 2);
                                                p = p.concat(d.slice(i)), i && p.push(d[i], d[i + 1]);
                                            } else {
                                                var m = s._nexttrace;
                                                if (m) {
                                                    var g = v.lineOptions[e1 + 1];
                                                    if (g) {
                                                        var y = g.positions;
                                                        if ("tonexty" === s.fill) {
                                                            for(p = d.slice(), e1 = Math.floor(y.length / 2); e1--;){
                                                                var x = y[2 * e1], _ = y[2 * e1 + 1];
                                                                isNaN(x) || isNaN(_) || p.push(x, _);
                                                            }
                                                            t1.fill = m.fillcolor;
                                                        }
                                                    }
                                                }
                                            }
                                            if (s._prevtrace && "tonext" === s._prevtrace.fill) {
                                                var b = v.lineOptions[e1 - 1].positions, w = p.length / 2, T = [
                                                    i = w
                                                ];
                                                for(a = 0; a < b.length; a += 2)(isNaN(b[a]) || isNaN(b[a + 1])) && (T.push(a / 2 + w + 1), i = a + 2);
                                                p = p.concat(b), t1.hole = T;
                                            }
                                            return t1.fillmode = s.fill, t1.opacity = s.opacity, t1.positions = p, t1;
                                        }
                                    }), v.fill2d.update(v.fillOptions));
                                }
                                var M = y.dragmode, S = l(M), E = y.clickmode.indexOf("select") > -1;
                                for(m = 0; m < b; m++){
                                    var C = r[m][0], L = C.trace, I = C.t, P = I.index, z = L._length, O = I.x, D = I.y;
                                    if (L.selectedpoints || S || E) {
                                        if (S || (S = !0), L.selectedpoints) {
                                            var R = v.selectBatch[P] = s.selIndices2selPoints(L), F = {};
                                            for(g = 0; g < R.length; g++)F[R[g]] = 1;
                                            var B = [];
                                            for(g = 0; g < z; g++)F[g] || B.push(g);
                                            v.unselectBatch[P] = B;
                                        }
                                        var N = I.xpx = new Array(z), j = I.ypx = new Array(z);
                                        for(g = 0; g < z; g++)N[g] = x.c2p(O[g]), j[g] = _.c2p(D[g]);
                                    } else I.xpx = I.ypx = null;
                                }
                                if (S) {
                                    if (v.select2d || (v.select2d = n(y._glcanvas.data()[1].regl)), v.scatter2d) {
                                        var U = new Array(b);
                                        for(m = 0; m < b; m++)U[m] = v.selectBatch[m].length || v.unselectBatch[m].length ? v.markerUnselectedOptions[m] : {};
                                        v.scatter2d.update(U);
                                    }
                                    v.select2d && (v.select2d.update(v.markerOptions), v.select2d.update(v.markerSelectedOptions)), v.glText && r.forEach(function(t1) {
                                        var e1 = ((t1 || [])[0] || {}).trace || {};
                                        u.hasText(e1) && f(t1);
                                    });
                                } else v.scatter2d && v.scatter2d.update(v.markerOptions);
                                var V = {
                                    viewport: d(y, x, _, t1._context.plotGlPixelRatio),
                                    range: [
                                        (x._rl || x.range)[0],
                                        (_._rl || _.range)[0],
                                        (x._rl || x.range)[1],
                                        (_._rl || _.range)[1]
                                    ]
                                }, q = s.repeat(V, v.count);
                                v.fill2d && v.fill2d.update(q), v.line2d && v.line2d.update(q), v.error2d && v.error2d.update(q.concat(q)), v.scatter2d && v.scatter2d.update(q), v.select2d && v.select2d.update(q), v.glText && v.glText.forEach(function(t1) {
                                    t1.update(V);
                                });
                            } else v.init();
                        }
                    }
                }).reglPrecompiled = p;
            },
            62336: function(t1, e1, r) {
                "use strict";
                var n = r(34809);
                t1.exports = function(t1, e1) {
                    var r = e1._scene, i = {
                        count: 0,
                        dirty: !0,
                        lineOptions: [],
                        fillOptions: [],
                        markerOptions: [],
                        markerSelectedOptions: [],
                        markerUnselectedOptions: [],
                        errorXOptions: [],
                        errorYOptions: [],
                        textOptions: [],
                        textSelectedOptions: [],
                        textUnselectedOptions: [],
                        selectBatch: [],
                        unselectBatch: []
                    }, a = {
                        fill2d: !1,
                        scatter2d: !1,
                        error2d: !1,
                        line2d: !1,
                        glText: !1,
                        select2d: !1
                    };
                    return e1._scene || ((r = e1._scene = {}).init = function() {
                        n.extendFlat(r, a, i);
                    }, r.init(), r.update = function(t1) {
                        var e1 = n.repeat(t1, r.count);
                        if (r.fill2d && r.fill2d.update(e1), r.scatter2d && r.scatter2d.update(e1), r.line2d && r.line2d.update(e1), r.error2d && r.error2d.update(e1.concat(e1)), r.select2d && r.select2d.update(e1), r.glText) for(var i = 0; i < r.count; i++)r.glText[i].update(t1);
                    }, r.draw = function() {
                        for(var t1 = r.count, e1 = r.fill2d, i = r.error2d, a = r.line2d, o = r.scatter2d, s = r.glText, l = r.select2d, c = r.selectBatch, u = r.unselectBatch, h = 0; h < t1; h++){
                            if (e1 && r.fillOrder[h] && e1.draw(r.fillOrder[h]), a && r.lineOptions[h] && a.draw(h), i && (r.errorXOptions[h] && i.draw(h), r.errorYOptions[h] && i.draw(h + t1)), o && r.markerOptions[h]) {
                                if (u[h].length) {
                                    var f = n.repeat([], r.count);
                                    f[h] = u[h], o.draw(f);
                                } else c[h].length || o.draw(h);
                            }
                            s[h] && r.textOptions[h] && s[h].render();
                        }
                        l && l.draw(c), r.dirty = !1;
                    }, r.destroy = function() {
                        r.fill2d && r.fill2d.destroy && r.fill2d.destroy(), r.scatter2d && r.scatter2d.destroy && r.scatter2d.destroy(), r.error2d && r.error2d.destroy && r.error2d.destroy(), r.line2d && r.line2d.destroy && r.line2d.destroy(), r.select2d && r.select2d.destroy && r.select2d.destroy(), r.glText && r.glText.forEach(function(t1) {
                            t1.destroy && t1.destroy();
                        }), r.lineOptions = null, r.fillOptions = null, r.markerOptions = null, r.markerSelectedOptions = null, r.markerUnselectedOptions = null, r.errorXOptions = null, r.errorYOptions = null, r.textOptions = null, r.textSelectedOptions = null, r.textUnselectedOptions = null, r.selectBatch = null, r.unselectBatch = null, e1._scene = null;
                    }), r.dirty || n.extendFlat(r, i), r;
                };
            },
            17168: function(t1, e1, r) {
                "use strict";
                var n = r(64726), i = r(85686).styleTextSelection;
                t1.exports = function(t1, e1) {
                    var r = t1.cd, a = t1.xaxis, o = t1.yaxis, s = [], l = r[0].trace, c = r[0].t, u = l._length, h = c.x, f = c.y, p = c._scene, d = c.index;
                    if (!p) return s;
                    var m = n.hasText(l), g = n.hasMarkers(l), y = !g && !m;
                    if (!0 !== l.visible || y) return s;
                    var v = [], x = [];
                    if (!1 !== e1 && !e1.degenerate) for(var _ = 0; _ < u; _++)e1.contains([
                        c.xpx[_],
                        c.ypx[_]
                    ], !1, _, t1) ? (v.push(_), s.push({
                        pointNumber: _,
                        x: a.c2d(h[_]),
                        y: o.c2d(f[_])
                    })) : x.push(_);
                    if (g) {
                        var b = p.scatter2d;
                        if (v.length || x.length) {
                            if (!p.selectBatch[d].length && !p.unselectBatch[d].length) {
                                var w = new Array(p.count);
                                w[d] = p.markerUnselectedOptions[d], b.update.apply(b, w);
                            }
                        } else {
                            var T = new Array(p.count);
                            T[d] = p.markerOptions[d], b.update.apply(b, T);
                        }
                    }
                    return p.selectBatch[d] = v, p.unselectBatch[d] = x, m && i(r), s;
                };
            },
            71388: function(t1, e1, r) {
                "use strict";
                var n = r(3208).rb, i = r(3208).ay, a = r(19326), o = r(6893), s = r(36640), l = r(8257), c = r(9829), u = r(87163), h = r(93049).extendFlat, f = r(13582).overrideAll, p = r(8257), d = o.line, m = o.marker;
                t1.exports = f({
                    lon: o.lon,
                    lat: o.lat,
                    cluster: {
                        enabled: {
                            valType: "boolean"
                        },
                        maxzoom: h({}, p.layers.maxzoom, {}),
                        step: {
                            valType: "number",
                            arrayOk: !0,
                            dflt: -1,
                            min: -1
                        },
                        size: {
                            valType: "number",
                            arrayOk: !0,
                            dflt: 20,
                            min: 0
                        },
                        color: {
                            valType: "color",
                            arrayOk: !0
                        },
                        opacity: h({}, m.opacity, {
                            dflt: 1
                        })
                    },
                    mode: h({}, s.mode, {
                        dflt: "markers"
                    }),
                    text: h({}, s.text, {}),
                    texttemplate: i({
                        editType: "plot"
                    }, {
                        keys: [
                            "lat",
                            "lon",
                            "text"
                        ]
                    }),
                    hovertext: h({}, s.hovertext, {}),
                    line: {
                        color: d.color,
                        width: d.width
                    },
                    connectgaps: s.connectgaps,
                    marker: h({
                        symbol: {
                            valType: "string",
                            dflt: "circle",
                            arrayOk: !0
                        },
                        angle: {
                            valType: "number",
                            dflt: "auto",
                            arrayOk: !0
                        },
                        allowoverlap: {
                            valType: "boolean",
                            dflt: !1
                        },
                        opacity: m.opacity,
                        size: m.size,
                        sizeref: m.sizeref,
                        sizemin: m.sizemin,
                        sizemode: m.sizemode
                    }, u("marker")),
                    fill: o.fill,
                    fillcolor: a(),
                    textfont: l.layers.symbol.textfont,
                    textposition: l.layers.symbol.textposition,
                    below: {
                        valType: "string"
                    },
                    selected: {
                        marker: s.selected.marker
                    },
                    unselected: {
                        marker: s.unselected.marker
                    },
                    hoverinfo: h({}, c.hoverinfo, {
                        flags: [
                            "lon",
                            "lat",
                            "text",
                            "name"
                        ]
                    }),
                    hovertemplate: n()
                }, "calc", "nested");
            },
            13624: function(t1) {
                "use strict";
                var e1 = [
                    "Metropolis Black Italic",
                    "Metropolis Black",
                    "Metropolis Bold Italic",
                    "Metropolis Bold",
                    "Metropolis Extra Bold Italic",
                    "Metropolis Extra Bold",
                    "Metropolis Extra Light Italic",
                    "Metropolis Extra Light",
                    "Metropolis Light Italic",
                    "Metropolis Light",
                    "Metropolis Medium Italic",
                    "Metropolis Medium",
                    "Metropolis Regular Italic",
                    "Metropolis Regular",
                    "Metropolis Semi Bold Italic",
                    "Metropolis Semi Bold",
                    "Metropolis Thin Italic",
                    "Metropolis Thin",
                    "Open Sans Bold Italic",
                    "Open Sans Bold",
                    "Open Sans Extrabold Italic",
                    "Open Sans Extrabold",
                    "Open Sans Italic",
                    "Open Sans Light Italic",
                    "Open Sans Light",
                    "Open Sans Regular",
                    "Open Sans Semibold Italic",
                    "Open Sans Semibold",
                    "Klokantech Noto Sans Bold",
                    "Klokantech Noto Sans CJK Bold",
                    "Klokantech Noto Sans CJK Regular",
                    "Klokantech Noto Sans Italic",
                    "Klokantech Noto Sans Regular"
                ];
                t1.exports = {
                    isSupportedFont: function(t1) {
                        return -1 !== e1.indexOf(t1);
                    }
                };
            },
            76717: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(34809), a = r(63821).BADNUM, o = r(39532), s = r(88856), l = r(62203), c = r(92527), u = r(64726), h = r(13624).isSupportedFont, f = r(4657), p = r(36040).appendArrayPointValue, d = r(30635).NEWLINES, m = r(30635).BR_TAG_ALL;
                function g(t1) {
                    return {
                        type: t1,
                        geojson: o.makeBlank(),
                        layout: {
                            visibility: "none"
                        },
                        filter: null,
                        paint: {}
                    };
                }
                function y(t1, e1) {
                    return i.isArrayOrTypedArray(t1) ? e1 ? function(e1) {
                        return n(t1[e1]) ? +t1[e1] : 0;
                    } : function(e1) {
                        return t1[e1];
                    } : t1 ? function() {
                        return t1;
                    } : v;
                }
                function v() {
                    return "";
                }
                function x(t1) {
                    return t1[0] === a;
                }
                function _(t1, e1) {
                    var r;
                    if (i.isArrayOrTypedArray(t1) && i.isArrayOrTypedArray(e1)) {
                        r = [
                            "step",
                            [
                                "get",
                                "point_count"
                            ],
                            t1[0]
                        ];
                        for(var n = 1; n < t1.length; n++)r.push(e1[n - 1], t1[n]);
                    } else r = t1;
                    return r;
                }
                function b(t1) {
                    var e1 = t1.textfont, r = e1.family, n = e1.style, i = e1.weight, a = r.split(" "), o = "Italic" === a[a.length - 1];
                    o && a.pop(), o = o || "italic" === n;
                    var s = a.join(" ");
                    return "bold" === i && -1 === a.indexOf("Bold") ? s += " Bold" : i <= 1e3 && ("Metropolis" === a[0] ? (s = "Metropolis", s += i > 850 ? " Black" : i > 750 ? " Extra Bold" : i > 650 ? " Bold" : i > 550 ? " Semi Bold" : i > 450 ? " Medium" : i > 350 ? " Regular" : i > 250 ? " Light" : i > 150 ? " Extra Light" : " Thin") : "Open Sans" === a.slice(0, 2).join(" ") ? (s = "Open Sans", s += i > 750 ? " Extrabold" : i > 650 ? " Bold" : i > 550 ? " Semibold" : i > 350 ? " Regular" : " Light") : "Klokantech Noto Sans" === a.slice(0, 3).join(" ") && (s = "Klokantech Noto Sans", "CJK" === a[3] && (s += " CJK"), s += i > 500 ? " Bold" : " Regular")), o && (s += " Italic"), "Open Sans Regular Italic" === s ? s = "Open Sans Italic" : "Open Sans Regular Bold" === s ? s = "Open Sans Bold" : "Open Sans Regular Bold Italic" === s ? s = "Open Sans Bold Italic" : "Klokantech Noto Sans Regular Italic" === s && (s = "Klokantech Noto Sans Italic"), h(s) || (s = r), s.split(", ");
                }
                t1.exports = function(t1, e1) {
                    var r, a = e1[0].trace, h = !0 === a.visible && 0 !== a._length, w = "none" !== a.fill, T = u.hasLines(a), k = u.hasMarkers(a), A = u.hasText(a), M = k && "circle" === a.marker.symbol, S = k && "circle" !== a.marker.symbol, E = a.cluster && a.cluster.enabled, C = g("fill"), L = g("line"), I = g("circle"), P = g("symbol"), z = {
                        fill: C,
                        line: L,
                        circle: I,
                        symbol: P
                    };
                    if (!h) return z;
                    if ((w || T) && (r = o.calcTraceToLineCoords(e1)), w && (C.geojson = o.makePolygon(r), C.layout.visibility = "visible", i.extendFlat(C.paint, {
                        "fill-color": a.fillcolor
                    })), T && (L.geojson = o.makeLine(r), L.layout.visibility = "visible", i.extendFlat(L.paint, {
                        "line-width": a.line.width,
                        "line-color": a.line.color,
                        "line-opacity": a.opacity
                    })), M) {
                        var O = function(t1) {
                            var e1, r, a, o, u = t1[0].trace, h = u.marker, f = u.selectedpoints, p = i.isArrayOrTypedArray(h.color), d = i.isArrayOrTypedArray(h.size), m = i.isArrayOrTypedArray(h.opacity);
                            function g(t1) {
                                return u.opacity * t1;
                            }
                            p && (r = s.hasColorscale(u, "marker") ? s.makeColorScaleFuncFromTrace(h) : i.identity), d && (a = c(u)), m && (o = function(t1) {
                                return g(n(t1) ? +i.constrain(t1, 0, 1) : 0);
                            });
                            var y, v, _ = [];
                            for(e1 = 0; e1 < t1.length; e1++){
                                var b = t1[e1], w = b.lonlat;
                                if (!x(w)) {
                                    var T = {};
                                    r && (T.mcc = b.mcc = r(b.mc)), a && (T.mrc = b.mrc = a(b.ms)), o && (T.mo = o(b.mo)), f && (T.selected = b.selected || 0), _.push({
                                        type: "Feature",
                                        id: e1 + 1,
                                        geometry: {
                                            type: "Point",
                                            coordinates: w
                                        },
                                        properties: T
                                    });
                                }
                            }
                            if (f) for(y = l.makeSelectedPointStyleFns(u), e1 = 0; e1 < _.length; e1++){
                                var k = _[e1].properties;
                                y.selectedOpacityFn && (k.mo = g(y.selectedOpacityFn(k))), y.selectedColorFn && (k.mcc = y.selectedColorFn(k)), y.selectedSizeFn && (k.mrc = y.selectedSizeFn(k));
                            }
                            return {
                                geojson: {
                                    type: "FeatureCollection",
                                    features: _
                                },
                                mcc: p || y && y.selectedColorFn ? {
                                    type: "identity",
                                    property: "mcc"
                                } : h.color,
                                mrc: d || y && y.selectedSizeFn ? {
                                    type: "identity",
                                    property: "mrc"
                                } : (v = h.size, v / 2),
                                mo: m || y && y.selectedOpacityFn ? {
                                    type: "identity",
                                    property: "mo"
                                } : g(h.opacity)
                            };
                        }(e1);
                        I.geojson = O.geojson, I.layout.visibility = "visible", E && (I.filter = [
                            "!",
                            [
                                "has",
                                "point_count"
                            ]
                        ], z.cluster = {
                            type: "circle",
                            filter: [
                                "has",
                                "point_count"
                            ],
                            layout: {
                                visibility: "visible"
                            },
                            paint: {
                                "circle-color": _(a.cluster.color, a.cluster.step),
                                "circle-radius": _(a.cluster.size, a.cluster.step),
                                "circle-opacity": _(a.cluster.opacity, a.cluster.step)
                            }
                        }, z.clusterCount = {
                            type: "symbol",
                            filter: [
                                "has",
                                "point_count"
                            ],
                            paint: {},
                            layout: {
                                "text-field": "{point_count_abbreviated}",
                                "text-font": b(a),
                                "text-size": 12
                            }
                        }), i.extendFlat(I.paint, {
                            "circle-color": O.mcc,
                            "circle-radius": O.mrc,
                            "circle-opacity": O.mo
                        });
                    }
                    if (M && E && (I.filter = [
                        "!",
                        [
                            "has",
                            "point_count"
                        ]
                    ]), (S || A) && (P.geojson = function(t1, e1) {
                        for(var r = e1._fullLayout, n = t1[0].trace, a = n.marker || {}, o = a.symbol, s = a.angle, l = "circle" !== o ? y(o) : v, c = "auto" !== s ? y(s, !0) : v, h = u.hasText(n) ? y(n.text) : v, f = [], g = 0; g < t1.length; g++){
                            var _ = t1[g];
                            if (!x(_.lonlat)) {
                                var b, w = n.texttemplate;
                                if (w) {
                                    var T = Array.isArray(w) ? w[g] || "" : w, k = n._module.formatLabels(_, n, r), A = {};
                                    p(A, n, _.i);
                                    var M = n._meta || {};
                                    b = i.texttemplateString(T, k, r._d3locale, A, _, M);
                                } else b = h(g);
                                b && (b = b.replace(d, "").replace(m, "\n")), f.push({
                                    type: "Feature",
                                    geometry: {
                                        type: "Point",
                                        coordinates: _.lonlat
                                    },
                                    properties: {
                                        symbol: l(g),
                                        angle: c(g),
                                        text: b
                                    }
                                });
                            }
                        }
                        return {
                            type: "FeatureCollection",
                            features: f
                        };
                    }(e1, t1), i.extendFlat(P.layout, {
                        visibility: "visible",
                        "icon-image": "{symbol}-15",
                        "text-field": "{text}"
                    }), S && (i.extendFlat(P.layout, {
                        "icon-size": a.marker.size / 10
                    }), "angle" in a.marker && "auto" !== a.marker.angle && i.extendFlat(P.layout, {
                        "icon-rotate": {
                            type: "identity",
                            property: "angle"
                        },
                        "icon-rotation-alignment": "map"
                    }), P.layout["icon-allow-overlap"] = a.marker.allowoverlap, i.extendFlat(P.paint, {
                        "icon-opacity": a.opacity * a.marker.opacity,
                        "icon-color": a.marker.color
                    })), A)) {
                        var D = (a.marker || {}).size, R = f(a.textposition, D);
                        i.extendFlat(P.layout, {
                            "text-size": a.textfont.size,
                            "text-anchor": R.anchor,
                            "text-offset": R.offset,
                            "text-font": b(a)
                        }), i.extendFlat(P.paint, {
                            "text-color": a.textfont.color,
                            "text-opacity": a.opacity
                        });
                    }
                    return z;
                };
            },
            57387: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(64726), a = r(24272), o = r(98168), s = r(663), l = r(54114), c = r(71388), u = r(13624).isSupportedFont;
                t1.exports = function(t1, e1, r, h) {
                    function f(r, i) {
                        return n.coerce(t1, e1, c, r, i);
                    }
                    function p(r, i) {
                        return n.coerce2(t1, e1, c, r, i);
                    }
                    var d = function(t1, e1, r) {
                        var n = r("lon") || [], i = r("lat") || [], a = Math.min(n.length, i.length);
                        return e1._length = a, a;
                    }(0, e1, f);
                    if (d) {
                        if (f("text"), f("texttemplate"), f("hovertext"), f("hovertemplate"), f("mode"), f("below"), i.hasMarkers(e1)) {
                            a(t1, e1, r, h, f, {
                                noLine: !0,
                                noAngle: !0
                            }), f("marker.allowoverlap"), f("marker.angle");
                            var m = e1.marker;
                            "circle" !== m.symbol && (n.isArrayOrTypedArray(m.size) && (m.size = m.size[0]), n.isArrayOrTypedArray(m.color) && (m.color = m.color[0]));
                        }
                        i.hasLines(e1) && (o(t1, e1, r, h, f, {
                            noDash: !0
                        }), f("connectgaps"));
                        var g = p("cluster.maxzoom"), y = p("cluster.step"), v = p("cluster.color", e1.marker && e1.marker.color || r), x = p("cluster.size"), _ = p("cluster.opacity");
                        if (f("cluster.enabled", !1 !== g || !1 !== y || !1 !== v || !1 !== x || !1 !== _) || i.hasText(e1)) {
                            var b = h.font.family;
                            s(t1, e1, h, f, {
                                noSelect: !0,
                                noFontVariant: !0,
                                noFontShadow: !0,
                                noFontLineposition: !0,
                                noFontTextcase: !0,
                                font: {
                                    family: u(b) ? b : "Open Sans Regular",
                                    weight: h.font.weight,
                                    style: h.font.style,
                                    size: h.font.size,
                                    color: h.font.color
                                }
                            });
                        }
                        f("fill"), "none" !== e1.fill && l(t1, e1, r, f), n.coerceSelectionMarkerOpacity(e1, f);
                    } else e1.visible = !1;
                };
            },
            58240: function(t1) {
                "use strict";
                t1.exports = function(t1, e1) {
                    return t1.lon = e1.lon, t1.lat = e1.lat, t1;
                };
            },
            66762: function(t1, e1, r) {
                "use strict";
                var n = r(29714);
                t1.exports = function(t1, e1, r) {
                    var i = {}, a = r[e1.subplot]._subplot.mockAxis, o = t1.lonlat;
                    return i.lonLabel = n.tickText(a, a.c2l(o[0]), !0).text, i.latLabel = n.tickText(a, a.c2l(o[1]), !0).text, i;
                };
            },
            67275: function(t1, e1, r) {
                "use strict";
                var n = r(32141), i = r(34809), a = r(11539), o = i.fillText, s = r(63821).BADNUM, l = r(8814).traceLayerPrefix;
                function c(t1, e1, r) {
                    if (!t1.hovertemplate) {
                        var n = (e1.hi || t1.hoverinfo).split("+"), i = -1 !== n.indexOf("all"), a = -1 !== n.indexOf("lon"), s = -1 !== n.indexOf("lat"), l = e1.lonlat, c = [];
                        return i || a && s ? c.push("(" + u(l[1]) + ", " + u(l[0]) + ")") : a ? c.push(r.lon + u(l[0])) : s && c.push(r.lat + u(l[1])), (i || -1 !== n.indexOf("text")) && o(e1, t1, c), c.join("<br>");
                    }
                    function u(t1) {
                        return t1 + "\xb0";
                    }
                }
                t1.exports = {
                    hoverPoints: function(t1, e1, r) {
                        var o = t1.cd, u = o[0].trace, h = t1.xa, f = t1.ya, p = t1.subplot, d = [], m = l + u.uid + "-circle", g = u.cluster && u.cluster.enabled;
                        if (g) {
                            var y = p.map.queryRenderedFeatures(null, {
                                layers: [
                                    m
                                ]
                            });
                            d = y.map(function(t1) {
                                return t1.id;
                            });
                        }
                        var v = 360 * (e1 >= 0 ? Math.floor((e1 + 180) / 360) : Math.ceil((e1 - 180) / 360)), x = e1 - v;
                        if (n.getClosest(o, function(t1) {
                            var e1 = t1.lonlat;
                            if (e1[0] === s) return 1 / 0;
                            if (g && -1 === d.indexOf(t1.i + 1)) return 1 / 0;
                            var n = i.modHalf(e1[0], 360), a = e1[1], o = p.project([
                                n,
                                a
                            ]), l = o.x - h.c2p([
                                x,
                                a
                            ]), c = o.y - f.c2p([
                                n,
                                r
                            ]), u = Math.max(3, t1.mrc || 0);
                            return Math.max(Math.sqrt(l * l + c * c) - u, 1 - 3 / u);
                        }, t1), !1 !== t1.index) {
                            var _ = o[t1.index], b = _.lonlat, w = [
                                i.modHalf(b[0], 360) + v,
                                b[1]
                            ], T = h.c2p(w), k = f.c2p(w), A = _.mrc || 1;
                            t1.x0 = T - A, t1.x1 = T + A, t1.y0 = k - A, t1.y1 = k + A;
                            var M = {};
                            M[u.subplot] = {
                                _subplot: p
                            };
                            var S = u._module.formatLabels(_, u, M);
                            return t1.lonLabel = S.lonLabel, t1.latLabel = S.latLabel, t1.color = a(u, _), t1.extraText = c(u, _, o[0].t.labels), t1.hovertemplate = u.hovertemplate, [
                                t1
                            ];
                        }
                    },
                    getExtraText: c
                };
            },
            30929: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    attributes: r(71388),
                    supplyDefaults: r(57387),
                    colorbar: r(21146),
                    formatLabels: r(66762),
                    calc: r(75649),
                    plot: r(26126),
                    hoverPoints: r(67275).hoverPoints,
                    eventData: r(58240),
                    selectPoints: r(21501),
                    styleOnSelect: function(t1, e1) {
                        e1 && e1[0].trace._glTrace.update(e1);
                    },
                    moduleType: "trace",
                    name: "scattermap",
                    basePlotModule: r(34091),
                    categories: [
                        "map",
                        "gl",
                        "symbols",
                        "showLegend",
                        "scatter-like"
                    ],
                    meta: {}
                };
            },
            26126: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(76717), a = r(8814).traceLayerPrefix, o = {
                    cluster: [
                        "cluster",
                        "clusterCount",
                        "circle"
                    ],
                    nonCluster: [
                        "fill",
                        "line",
                        "circle",
                        "symbol"
                    ]
                };
                function s(t1, e1, r, n) {
                    this.type = "scattermap", this.subplot = t1, this.uid = e1, this.clusterEnabled = r, this.isHidden = n, this.sourceIds = {
                        fill: "source-" + e1 + "-fill",
                        line: "source-" + e1 + "-line",
                        circle: "source-" + e1 + "-circle",
                        symbol: "source-" + e1 + "-symbol",
                        cluster: "source-" + e1 + "-circle",
                        clusterCount: "source-" + e1 + "-circle"
                    }, this.layerIds = {
                        fill: a + e1 + "-fill",
                        line: a + e1 + "-line",
                        circle: a + e1 + "-circle",
                        symbol: a + e1 + "-symbol",
                        cluster: a + e1 + "-cluster",
                        clusterCount: a + e1 + "-cluster-count"
                    }, this.below = null;
                }
                var l = s.prototype;
                l.addSource = function(t1, e1, r) {
                    var i = {
                        type: "geojson",
                        data: e1.geojson
                    };
                    r && r.enabled && n.extendFlat(i, {
                        cluster: !0,
                        clusterMaxZoom: r.maxzoom
                    });
                    var a = this.subplot.map.getSource(this.sourceIds[t1]);
                    a ? a.setData(e1.geojson) : this.subplot.map.addSource(this.sourceIds[t1], i);
                }, l.setSourceData = function(t1, e1) {
                    this.subplot.map.getSource(this.sourceIds[t1]).setData(e1.geojson);
                }, l.addLayer = function(t1, e1, r) {
                    var n = {
                        type: e1.type,
                        id: this.layerIds[t1],
                        source: this.sourceIds[t1],
                        layout: e1.layout,
                        paint: e1.paint
                    };
                    e1.filter && (n.filter = e1.filter);
                    for(var i, a = this.layerIds[t1], o = this.subplot.getMapLayers(), s = 0; s < o.length; s++)if (o[s].id === a) {
                        i = !0;
                        break;
                    }
                    i ? (this.subplot.setOptions(a, "setLayoutProperty", n.layout), "visible" === n.layout.visibility && this.subplot.setOptions(a, "setPaintProperty", n.paint)) : this.subplot.addLayer(n, r);
                }, l.update = function(t1) {
                    var e1 = t1[0].trace, r = this.subplot, n = r.map, a = i(r.gd, t1), s = r.belowLookup["trace-" + this.uid], l = !(!e1.cluster || !e1.cluster.enabled), c = !!this.clusterEnabled, u = this;
                    function h(t1) {
                        c ? function(t1) {
                            for(var e1 = o.cluster, r = e1.length - 1; r >= 0; r--){
                                var i = e1[r];
                                n.removeLayer(u.layerIds[i]);
                            }
                            t1 || n.removeSource(u.sourceIds.circle);
                        }(t1) : function(t1) {
                            for(var e1 = o.nonCluster, r = e1.length - 1; r >= 0; r--){
                                var i = e1[r];
                                n.removeLayer(u.layerIds[i]), t1 || n.removeSource(u.sourceIds[i]);
                            }
                        }(t1);
                    }
                    function f(t1) {
                        l ? function(t1) {
                            t1 || u.addSource("circle", a.circle, e1.cluster);
                            for(var r = o.cluster, n = 0; n < r.length; n++){
                                var i = r[n], l = a[i];
                                u.addLayer(i, l, s);
                            }
                        }(t1) : function(t1) {
                            for(var e1 = o.nonCluster, r = 0; r < e1.length; r++){
                                var n = e1[r], i = a[n];
                                t1 || u.addSource(n, i), u.addLayer(n, i, s);
                            }
                        }(t1);
                    }
                    function p() {
                        for(var t1 = l ? o.cluster : o.nonCluster, e1 = 0; e1 < t1.length; e1++){
                            var n = t1[e1], i = a[n];
                            i && (r.setOptions(u.layerIds[n], "setLayoutProperty", i.layout), "visible" === i.layout.visibility && ("cluster" !== n && u.setSourceData(n, i), r.setOptions(u.layerIds[n], "setPaintProperty", i.paint)));
                        }
                    }
                    var d = this.isHidden, m = !0 !== e1.visible;
                    m ? d || h() : d ? m || f() : c !== l ? (h(), f()) : this.below !== s ? (h(!0), f(!0), p()) : p(), this.clusterEnabled = l, this.isHidden = m, this.below = s, t1[0].trace._glTrace = this;
                }, l.dispose = function() {
                    for(var t1 = this.subplot.map, e1 = this.clusterEnabled ? o.cluster : o.nonCluster, r = e1.length - 1; r >= 0; r--){
                        var n = e1[r];
                        t1.removeLayer(this.layerIds[n]), t1.removeSource(this.sourceIds[n]);
                    }
                }, t1.exports = function(t1, e1) {
                    var r, n, a, l = e1[0].trace, c = l.cluster && l.cluster.enabled, u = !0 !== l.visible, h = new s(t1, l.uid, c, u), f = i(t1.gd, e1), p = h.below = t1.belowLookup["trace-" + l.uid];
                    if (c) for(h.addSource("circle", f.circle, l.cluster), r = 0; r < o.cluster.length; r++)a = f[n = o.cluster[r]], h.addLayer(n, a, p);
                    else for(r = 0; r < o.nonCluster.length; r++)a = f[n = o.nonCluster[r]], h.addSource(n, a, l.cluster), h.addLayer(n, a, p);
                    return e1[0].trace._glTrace = h, h;
                };
            },
            21501: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(64726), a = r(63821).BADNUM;
                t1.exports = function(t1, e1) {
                    var r, o = t1.cd, s = t1.xaxis, l = t1.yaxis, c = [], u = o[0].trace;
                    if (!i.hasMarkers(u)) return [];
                    if (!1 === e1) for(r = 0; r < o.length; r++)o[r].selected = 0;
                    else for(r = 0; r < o.length; r++){
                        var h = o[r], f = h.lonlat;
                        if (f[0] !== a) {
                            var p = [
                                n.modHalf(f[0], 360),
                                f[1]
                            ], d = [
                                s.c2p(p),
                                l.c2p(p)
                            ];
                            e1.contains(d, null, r, t1) ? (c.push({
                                pointNumber: r,
                                lon: f[0],
                                lat: f[1]
                            }), h.selected = 1) : h.selected = 0;
                        }
                    }
                    return c;
                };
            },
            95833: function(t1, e1, r) {
                "use strict";
                var n = r(3208).rb, i = r(3208).ay, a = r(19326), o = r(6893), s = r(36640), l = r(67514), c = r(9829), u = r(87163), h = r(93049).extendFlat, f = r(13582).overrideAll, p = r(67514), d = o.line, m = o.marker;
                t1.exports = f({
                    lon: o.lon,
                    lat: o.lat,
                    cluster: {
                        enabled: {
                            valType: "boolean"
                        },
                        maxzoom: h({}, p.layers.maxzoom, {}),
                        step: {
                            valType: "number",
                            arrayOk: !0,
                            dflt: -1,
                            min: -1
                        },
                        size: {
                            valType: "number",
                            arrayOk: !0,
                            dflt: 20,
                            min: 0
                        },
                        color: {
                            valType: "color",
                            arrayOk: !0
                        },
                        opacity: h({}, m.opacity, {
                            dflt: 1
                        })
                    },
                    mode: h({}, s.mode, {
                        dflt: "markers"
                    }),
                    text: h({}, s.text, {}),
                    texttemplate: i({
                        editType: "plot"
                    }, {
                        keys: [
                            "lat",
                            "lon",
                            "text"
                        ]
                    }),
                    hovertext: h({}, s.hovertext, {}),
                    line: {
                        color: d.color,
                        width: d.width
                    },
                    connectgaps: s.connectgaps,
                    marker: h({
                        symbol: {
                            valType: "string",
                            dflt: "circle",
                            arrayOk: !0
                        },
                        angle: {
                            valType: "number",
                            dflt: "auto",
                            arrayOk: !0
                        },
                        allowoverlap: {
                            valType: "boolean",
                            dflt: !1
                        },
                        opacity: m.opacity,
                        size: m.size,
                        sizeref: m.sizeref,
                        sizemin: m.sizemin,
                        sizemode: m.sizemode
                    }, u("marker")),
                    fill: o.fill,
                    fillcolor: a(),
                    textfont: l.layers.symbol.textfont,
                    textposition: l.layers.symbol.textposition,
                    below: {
                        valType: "string"
                    },
                    selected: {
                        marker: s.selected.marker
                    },
                    unselected: {
                        marker: s.unselected.marker
                    },
                    hoverinfo: h({}, c.hoverinfo, {
                        flags: [
                            "lon",
                            "lat",
                            "text",
                            "name"
                        ]
                    }),
                    hovertemplate: n()
                }, "calc", "nested");
            },
            2795: function(t1) {
                "use strict";
                var e1 = [
                    "Metropolis Black Italic",
                    "Metropolis Black",
                    "Metropolis Bold Italic",
                    "Metropolis Bold",
                    "Metropolis Extra Bold Italic",
                    "Metropolis Extra Bold",
                    "Metropolis Extra Light Italic",
                    "Metropolis Extra Light",
                    "Metropolis Light Italic",
                    "Metropolis Light",
                    "Metropolis Medium Italic",
                    "Metropolis Medium",
                    "Metropolis Regular Italic",
                    "Metropolis Regular",
                    "Metropolis Semi Bold Italic",
                    "Metropolis Semi Bold",
                    "Metropolis Thin Italic",
                    "Metropolis Thin",
                    "Open Sans Bold Italic",
                    "Open Sans Bold",
                    "Open Sans Extrabold Italic",
                    "Open Sans Extrabold",
                    "Open Sans Italic",
                    "Open Sans Light Italic",
                    "Open Sans Light",
                    "Open Sans Regular",
                    "Open Sans Semibold Italic",
                    "Open Sans Semibold",
                    "Klokantech Noto Sans Bold",
                    "Klokantech Noto Sans CJK Bold",
                    "Klokantech Noto Sans CJK Regular",
                    "Klokantech Noto Sans Italic",
                    "Klokantech Noto Sans Regular"
                ];
                t1.exports = {
                    isSupportedFont: function(t1) {
                        return -1 !== e1.indexOf(t1);
                    }
                };
            },
            27009: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(34809), a = r(63821).BADNUM, o = r(39532), s = r(88856), l = r(62203), c = r(92527), u = r(64726), h = r(2795).isSupportedFont, f = r(2178), p = r(36040).appendArrayPointValue, d = r(30635).NEWLINES, m = r(30635).BR_TAG_ALL;
                function g(t1) {
                    return {
                        type: t1,
                        geojson: o.makeBlank(),
                        layout: {
                            visibility: "none"
                        },
                        filter: null,
                        paint: {}
                    };
                }
                function y(t1, e1) {
                    return i.isArrayOrTypedArray(t1) ? e1 ? function(e1) {
                        return n(t1[e1]) ? +t1[e1] : 0;
                    } : function(e1) {
                        return t1[e1];
                    } : t1 ? function() {
                        return t1;
                    } : v;
                }
                function v() {
                    return "";
                }
                function x(t1) {
                    return t1[0] === a;
                }
                function _(t1, e1) {
                    var r;
                    if (i.isArrayOrTypedArray(t1) && i.isArrayOrTypedArray(e1)) {
                        r = [
                            "step",
                            [
                                "get",
                                "point_count"
                            ],
                            t1[0]
                        ];
                        for(var n = 1; n < t1.length; n++)r.push(e1[n - 1], t1[n]);
                    } else r = t1;
                    return r;
                }
                function b(t1) {
                    var e1 = t1.textfont, r = e1.family, n = e1.style, i = e1.weight, a = r.split(" "), o = "Italic" === a[a.length - 1];
                    o && a.pop(), o = o || "italic" === n;
                    var s = a.join(" ");
                    return "bold" === i && -1 === a.indexOf("Bold") ? s += " Bold" : i <= 1e3 && ("Metropolis" === a[0] ? (s = "Metropolis", s += i > 850 ? " Black" : i > 750 ? " Extra Bold" : i > 650 ? " Bold" : i > 550 ? " Semi Bold" : i > 450 ? " Medium" : i > 350 ? " Regular" : i > 250 ? " Light" : i > 150 ? " Extra Light" : " Thin") : "Open Sans" === a.slice(0, 2).join(" ") ? (s = "Open Sans", s += i > 750 ? " Extrabold" : i > 650 ? " Bold" : i > 550 ? " Semibold" : i > 350 ? " Regular" : " Light") : "Klokantech Noto Sans" === a.slice(0, 3).join(" ") && (s = "Klokantech Noto Sans", "CJK" === a[3] && (s += " CJK"), s += i > 500 ? " Bold" : " Regular")), o && (s += " Italic"), "Open Sans Regular Italic" === s ? s = "Open Sans Italic" : "Open Sans Regular Bold" === s ? s = "Open Sans Bold" : "Open Sans Regular Bold Italic" === s ? s = "Open Sans Bold Italic" : "Klokantech Noto Sans Regular Italic" === s && (s = "Klokantech Noto Sans Italic"), h(s) || (s = r), s.split(", ");
                }
                t1.exports = function(t1, e1) {
                    var r, a = e1[0].trace, h = !0 === a.visible && 0 !== a._length, w = "none" !== a.fill, T = u.hasLines(a), k = u.hasMarkers(a), A = u.hasText(a), M = k && "circle" === a.marker.symbol, S = k && "circle" !== a.marker.symbol, E = a.cluster && a.cluster.enabled, C = g("fill"), L = g("line"), I = g("circle"), P = g("symbol"), z = {
                        fill: C,
                        line: L,
                        circle: I,
                        symbol: P
                    };
                    if (!h) return z;
                    if ((w || T) && (r = o.calcTraceToLineCoords(e1)), w && (C.geojson = o.makePolygon(r), C.layout.visibility = "visible", i.extendFlat(C.paint, {
                        "fill-color": a.fillcolor
                    })), T && (L.geojson = o.makeLine(r), L.layout.visibility = "visible", i.extendFlat(L.paint, {
                        "line-width": a.line.width,
                        "line-color": a.line.color,
                        "line-opacity": a.opacity
                    })), M) {
                        var O = function(t1) {
                            var e1, r, a, o, u = t1[0].trace, h = u.marker, f = u.selectedpoints, p = i.isArrayOrTypedArray(h.color), d = i.isArrayOrTypedArray(h.size), m = i.isArrayOrTypedArray(h.opacity);
                            function g(t1) {
                                return u.opacity * t1;
                            }
                            p && (r = s.hasColorscale(u, "marker") ? s.makeColorScaleFuncFromTrace(h) : i.identity), d && (a = c(u)), m && (o = function(t1) {
                                return g(n(t1) ? +i.constrain(t1, 0, 1) : 0);
                            });
                            var y, v, _ = [];
                            for(e1 = 0; e1 < t1.length; e1++){
                                var b = t1[e1], w = b.lonlat;
                                if (!x(w)) {
                                    var T = {};
                                    r && (T.mcc = b.mcc = r(b.mc)), a && (T.mrc = b.mrc = a(b.ms)), o && (T.mo = o(b.mo)), f && (T.selected = b.selected || 0), _.push({
                                        type: "Feature",
                                        id: e1 + 1,
                                        geometry: {
                                            type: "Point",
                                            coordinates: w
                                        },
                                        properties: T
                                    });
                                }
                            }
                            if (f) for(y = l.makeSelectedPointStyleFns(u), e1 = 0; e1 < _.length; e1++){
                                var k = _[e1].properties;
                                y.selectedOpacityFn && (k.mo = g(y.selectedOpacityFn(k))), y.selectedColorFn && (k.mcc = y.selectedColorFn(k)), y.selectedSizeFn && (k.mrc = y.selectedSizeFn(k));
                            }
                            return {
                                geojson: {
                                    type: "FeatureCollection",
                                    features: _
                                },
                                mcc: p || y && y.selectedColorFn ? {
                                    type: "identity",
                                    property: "mcc"
                                } : h.color,
                                mrc: d || y && y.selectedSizeFn ? {
                                    type: "identity",
                                    property: "mrc"
                                } : (v = h.size, v / 2),
                                mo: m || y && y.selectedOpacityFn ? {
                                    type: "identity",
                                    property: "mo"
                                } : g(h.opacity)
                            };
                        }(e1);
                        I.geojson = O.geojson, I.layout.visibility = "visible", E && (I.filter = [
                            "!",
                            [
                                "has",
                                "point_count"
                            ]
                        ], z.cluster = {
                            type: "circle",
                            filter: [
                                "has",
                                "point_count"
                            ],
                            layout: {
                                visibility: "visible"
                            },
                            paint: {
                                "circle-color": _(a.cluster.color, a.cluster.step),
                                "circle-radius": _(a.cluster.size, a.cluster.step),
                                "circle-opacity": _(a.cluster.opacity, a.cluster.step)
                            }
                        }, z.clusterCount = {
                            type: "symbol",
                            filter: [
                                "has",
                                "point_count"
                            ],
                            paint: {},
                            layout: {
                                "text-field": "{point_count_abbreviated}",
                                "text-font": b(a),
                                "text-size": 12
                            }
                        }), i.extendFlat(I.paint, {
                            "circle-color": O.mcc,
                            "circle-radius": O.mrc,
                            "circle-opacity": O.mo
                        });
                    }
                    if (M && E && (I.filter = [
                        "!",
                        [
                            "has",
                            "point_count"
                        ]
                    ]), (S || A) && (P.geojson = function(t1, e1) {
                        for(var r = e1._fullLayout, n = t1[0].trace, a = n.marker || {}, o = a.symbol, s = a.angle, l = "circle" !== o ? y(o) : v, c = "auto" !== s ? y(s, !0) : v, h = u.hasText(n) ? y(n.text) : v, f = [], g = 0; g < t1.length; g++){
                            var _ = t1[g];
                            if (!x(_.lonlat)) {
                                var b, w = n.texttemplate;
                                if (w) {
                                    var T = Array.isArray(w) ? w[g] || "" : w, k = n._module.formatLabels(_, n, r), A = {};
                                    p(A, n, _.i);
                                    var M = n._meta || {};
                                    b = i.texttemplateString(T, k, r._d3locale, A, _, M);
                                } else b = h(g);
                                b && (b = b.replace(d, "").replace(m, "\n")), f.push({
                                    type: "Feature",
                                    geometry: {
                                        type: "Point",
                                        coordinates: _.lonlat
                                    },
                                    properties: {
                                        symbol: l(g),
                                        angle: c(g),
                                        text: b
                                    }
                                });
                            }
                        }
                        return {
                            type: "FeatureCollection",
                            features: f
                        };
                    }(e1, t1), i.extendFlat(P.layout, {
                        visibility: "visible",
                        "icon-image": "{symbol}-15",
                        "text-field": "{text}"
                    }), S && (i.extendFlat(P.layout, {
                        "icon-size": a.marker.size / 10
                    }), "angle" in a.marker && "auto" !== a.marker.angle && i.extendFlat(P.layout, {
                        "icon-rotate": {
                            type: "identity",
                            property: "angle"
                        },
                        "icon-rotation-alignment": "map"
                    }), P.layout["icon-allow-overlap"] = a.marker.allowoverlap, i.extendFlat(P.paint, {
                        "icon-opacity": a.opacity * a.marker.opacity,
                        "icon-color": a.marker.color
                    })), A)) {
                        var D = (a.marker || {}).size, R = f(a.textposition, D);
                        i.extendFlat(P.layout, {
                            "text-size": a.textfont.size,
                            "text-anchor": R.anchor,
                            "text-offset": R.offset,
                            "text-font": b(a)
                        }), i.extendFlat(P.paint, {
                            "text-color": a.textfont.color,
                            "text-opacity": a.opacity
                        });
                    }
                    return z;
                };
            },
            38302: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(64726), a = r(24272), o = r(98168), s = r(663), l = r(54114), c = r(95833), u = r(2795).isSupportedFont;
                t1.exports = function(t1, e1, r, h) {
                    function f(r, i) {
                        return n.coerce(t1, e1, c, r, i);
                    }
                    function p(r, i) {
                        return n.coerce2(t1, e1, c, r, i);
                    }
                    var d = function(t1, e1, r) {
                        var n = r("lon") || [], i = r("lat") || [], a = Math.min(n.length, i.length);
                        return e1._length = a, a;
                    }(0, e1, f);
                    if (d) {
                        if (f("text"), f("texttemplate"), f("hovertext"), f("hovertemplate"), f("mode"), f("below"), i.hasMarkers(e1)) {
                            a(t1, e1, r, h, f, {
                                noLine: !0,
                                noAngle: !0
                            }), f("marker.allowoverlap"), f("marker.angle");
                            var m = e1.marker;
                            "circle" !== m.symbol && (n.isArrayOrTypedArray(m.size) && (m.size = m.size[0]), n.isArrayOrTypedArray(m.color) && (m.color = m.color[0]));
                        }
                        i.hasLines(e1) && (o(t1, e1, r, h, f, {
                            noDash: !0
                        }), f("connectgaps"));
                        var g = p("cluster.maxzoom"), y = p("cluster.step"), v = p("cluster.color", e1.marker && e1.marker.color || r), x = p("cluster.size"), _ = p("cluster.opacity");
                        if (f("cluster.enabled", !1 !== g || !1 !== y || !1 !== v || !1 !== x || !1 !== _) || i.hasText(e1)) {
                            var b = h.font.family;
                            s(t1, e1, h, f, {
                                noSelect: !0,
                                noFontVariant: !0,
                                noFontShadow: !0,
                                noFontLineposition: !0,
                                noFontTextcase: !0,
                                font: {
                                    family: u(b) ? b : "Open Sans Regular",
                                    weight: h.font.weight,
                                    style: h.font.style,
                                    size: h.font.size,
                                    color: h.font.color
                                }
                            });
                        }
                        f("fill"), "none" !== e1.fill && l(t1, e1, r, f), n.coerceSelectionMarkerOpacity(e1, f);
                    } else e1.visible = !1;
                };
            },
            68197: function(t1) {
                "use strict";
                t1.exports = function(t1, e1) {
                    return t1.lon = e1.lon, t1.lat = e1.lat, t1;
                };
            },
            69009: function(t1, e1, r) {
                "use strict";
                var n = r(29714);
                t1.exports = function(t1, e1, r) {
                    var i = {}, a = r[e1.subplot]._subplot.mockAxis, o = t1.lonlat;
                    return i.lonLabel = n.tickText(a, a.c2l(o[0]), !0).text, i.latLabel = n.tickText(a, a.c2l(o[1]), !0).text, i;
                };
            },
            18016: function(t1, e1, r) {
                "use strict";
                var n = r(32141), i = r(34809), a = r(11539), o = i.fillText, s = r(63821).BADNUM, l = r(44245).traceLayerPrefix;
                function c(t1, e1, r) {
                    if (!t1.hovertemplate) {
                        var n = (e1.hi || t1.hoverinfo).split("+"), i = -1 !== n.indexOf("all"), a = -1 !== n.indexOf("lon"), s = -1 !== n.indexOf("lat"), l = e1.lonlat, c = [];
                        return i || a && s ? c.push("(" + u(l[1]) + ", " + u(l[0]) + ")") : a ? c.push(r.lon + u(l[0])) : s && c.push(r.lat + u(l[1])), (i || -1 !== n.indexOf("text")) && o(e1, t1, c), c.join("<br>");
                    }
                    function u(t1) {
                        return t1 + "\xb0";
                    }
                }
                t1.exports = {
                    hoverPoints: function(t1, e1, r) {
                        var o = t1.cd, u = o[0].trace, h = t1.xa, f = t1.ya, p = t1.subplot, d = [], m = l + u.uid + "-circle", g = u.cluster && u.cluster.enabled;
                        if (g) {
                            var y = p.map.queryRenderedFeatures(null, {
                                layers: [
                                    m
                                ]
                            });
                            d = y.map(function(t1) {
                                return t1.id;
                            });
                        }
                        var v = 360 * (e1 >= 0 ? Math.floor((e1 + 180) / 360) : Math.ceil((e1 - 180) / 360)), x = e1 - v;
                        if (n.getClosest(o, function(t1) {
                            var e1 = t1.lonlat;
                            if (e1[0] === s) return 1 / 0;
                            if (g && -1 === d.indexOf(t1.i + 1)) return 1 / 0;
                            var n = i.modHalf(e1[0], 360), a = e1[1], o = p.project([
                                n,
                                a
                            ]), l = o.x - h.c2p([
                                x,
                                a
                            ]), c = o.y - f.c2p([
                                n,
                                r
                            ]), u = Math.max(3, t1.mrc || 0);
                            return Math.max(Math.sqrt(l * l + c * c) - u, 1 - 3 / u);
                        }, t1), !1 !== t1.index) {
                            var _ = o[t1.index], b = _.lonlat, w = [
                                i.modHalf(b[0], 360) + v,
                                b[1]
                            ], T = h.c2p(w), k = f.c2p(w), A = _.mrc || 1;
                            t1.x0 = T - A, t1.x1 = T + A, t1.y0 = k - A, t1.y1 = k + A;
                            var M = {};
                            M[u.subplot] = {
                                _subplot: p
                            };
                            var S = u._module.formatLabels(_, u, M);
                            return t1.lonLabel = S.lonLabel, t1.latLabel = S.latLabel, t1.color = a(u, _), t1.extraText = c(u, _, o[0].t.labels), t1.hovertemplate = u.hovertemplate, [
                                t1
                            ];
                        }
                    },
                    getExtraText: c
                };
            },
            83866: function(t1, e1, r) {
                "use strict";
                [
                    "*scattermapbox* trace is deprecated!",
                    "Please consider switching to the *scattermap* trace type and `map` subplots.",
                    "Learn more at: https://plotly.com/javascript/maplibre-migration/"
                ].join(" "), t1.exports = {
                    attributes: r(95833),
                    supplyDefaults: r(38302),
                    colorbar: r(21146),
                    formatLabels: r(69009),
                    calc: r(75649),
                    plot: r(20691),
                    hoverPoints: r(18016).hoverPoints,
                    eventData: r(68197),
                    selectPoints: r(60784),
                    styleOnSelect: function(t1, e1) {
                        e1 && e1[0].trace._glTrace.update(e1);
                    },
                    moduleType: "trace",
                    name: "scattermapbox",
                    basePlotModule: r(68192),
                    categories: [
                        "mapbox",
                        "gl",
                        "symbols",
                        "showLegend",
                        "scatter-like"
                    ],
                    meta: {}
                };
            },
            20691: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(27009), a = r(44245).traceLayerPrefix, o = {
                    cluster: [
                        "cluster",
                        "clusterCount",
                        "circle"
                    ],
                    nonCluster: [
                        "fill",
                        "line",
                        "circle",
                        "symbol"
                    ]
                };
                function s(t1, e1, r, n) {
                    this.type = "scattermapbox", this.subplot = t1, this.uid = e1, this.clusterEnabled = r, this.isHidden = n, this.sourceIds = {
                        fill: "source-" + e1 + "-fill",
                        line: "source-" + e1 + "-line",
                        circle: "source-" + e1 + "-circle",
                        symbol: "source-" + e1 + "-symbol",
                        cluster: "source-" + e1 + "-circle",
                        clusterCount: "source-" + e1 + "-circle"
                    }, this.layerIds = {
                        fill: a + e1 + "-fill",
                        line: a + e1 + "-line",
                        circle: a + e1 + "-circle",
                        symbol: a + e1 + "-symbol",
                        cluster: a + e1 + "-cluster",
                        clusterCount: a + e1 + "-cluster-count"
                    }, this.below = null;
                }
                var l = s.prototype;
                l.addSource = function(t1, e1, r) {
                    var i = {
                        type: "geojson",
                        data: e1.geojson
                    };
                    r && r.enabled && n.extendFlat(i, {
                        cluster: !0,
                        clusterMaxZoom: r.maxzoom
                    });
                    var a = this.subplot.map.getSource(this.sourceIds[t1]);
                    a ? a.setData(e1.geojson) : this.subplot.map.addSource(this.sourceIds[t1], i);
                }, l.setSourceData = function(t1, e1) {
                    this.subplot.map.getSource(this.sourceIds[t1]).setData(e1.geojson);
                }, l.addLayer = function(t1, e1, r) {
                    var n = {
                        type: e1.type,
                        id: this.layerIds[t1],
                        source: this.sourceIds[t1],
                        layout: e1.layout,
                        paint: e1.paint
                    };
                    e1.filter && (n.filter = e1.filter);
                    for(var i, a = this.layerIds[t1], o = this.subplot.getMapLayers(), s = 0; s < o.length; s++)if (o[s].id === a) {
                        i = !0;
                        break;
                    }
                    i ? (this.subplot.setOptions(a, "setLayoutProperty", n.layout), "visible" === n.layout.visibility && this.subplot.setOptions(a, "setPaintProperty", n.paint)) : this.subplot.addLayer(n, r);
                }, l.update = function(t1) {
                    var e1 = t1[0].trace, r = this.subplot, n = r.map, a = i(r.gd, t1), s = r.belowLookup["trace-" + this.uid], l = !(!e1.cluster || !e1.cluster.enabled), c = !!this.clusterEnabled, u = this;
                    function h(t1) {
                        c ? function(t1) {
                            for(var e1 = o.cluster, r = e1.length - 1; r >= 0; r--){
                                var i = e1[r];
                                n.removeLayer(u.layerIds[i]);
                            }
                            t1 || n.removeSource(u.sourceIds.circle);
                        }(t1) : function(t1) {
                            for(var e1 = o.nonCluster, r = e1.length - 1; r >= 0; r--){
                                var i = e1[r];
                                n.removeLayer(u.layerIds[i]), t1 || n.removeSource(u.sourceIds[i]);
                            }
                        }(t1);
                    }
                    function f(t1) {
                        l ? function(t1) {
                            t1 || u.addSource("circle", a.circle, e1.cluster);
                            for(var r = o.cluster, n = 0; n < r.length; n++){
                                var i = r[n], l = a[i];
                                u.addLayer(i, l, s);
                            }
                        }(t1) : function(t1) {
                            for(var e1 = o.nonCluster, r = 0; r < e1.length; r++){
                                var n = e1[r], i = a[n];
                                t1 || u.addSource(n, i), u.addLayer(n, i, s);
                            }
                        }(t1);
                    }
                    function p() {
                        for(var t1 = l ? o.cluster : o.nonCluster, e1 = 0; e1 < t1.length; e1++){
                            var n = t1[e1], i = a[n];
                            i && (r.setOptions(u.layerIds[n], "setLayoutProperty", i.layout), "visible" === i.layout.visibility && ("cluster" !== n && u.setSourceData(n, i), r.setOptions(u.layerIds[n], "setPaintProperty", i.paint)));
                        }
                    }
                    var d = this.isHidden, m = !0 !== e1.visible;
                    m ? d || h() : d ? m || f() : c !== l ? (h(), f()) : this.below !== s ? (h(!0), f(!0), p()) : p(), this.clusterEnabled = l, this.isHidden = m, this.below = s, t1[0].trace._glTrace = this;
                }, l.dispose = function() {
                    for(var t1 = this.subplot.map, e1 = this.clusterEnabled ? o.cluster : o.nonCluster, r = e1.length - 1; r >= 0; r--){
                        var n = e1[r];
                        t1.removeLayer(this.layerIds[n]), t1.removeSource(this.sourceIds[n]);
                    }
                }, t1.exports = function(t1, e1) {
                    var r, n, a, l = e1[0].trace, c = l.cluster && l.cluster.enabled, u = !0 !== l.visible, h = new s(t1, l.uid, c, u), f = i(t1.gd, e1), p = h.below = t1.belowLookup["trace-" + l.uid];
                    if (c) for(h.addSource("circle", f.circle, l.cluster), r = 0; r < o.cluster.length; r++)a = f[n = o.cluster[r]], h.addLayer(n, a, p);
                    else for(r = 0; r < o.nonCluster.length; r++)a = f[n = o.nonCluster[r]], h.addSource(n, a, l.cluster), h.addLayer(n, a, p);
                    return e1[0].trace._glTrace = h, h;
                };
            },
            60784: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(64726), a = r(63821).BADNUM;
                t1.exports = function(t1, e1) {
                    var r, o = t1.cd, s = t1.xaxis, l = t1.yaxis, c = [], u = o[0].trace;
                    if (!i.hasMarkers(u)) return [];
                    if (!1 === e1) for(r = 0; r < o.length; r++)o[r].selected = 0;
                    else for(r = 0; r < o.length; r++){
                        var h = o[r], f = h.lonlat;
                        if (f[0] !== a) {
                            var p = [
                                n.modHalf(f[0], 360),
                                f[1]
                            ], d = [
                                s.c2p(p),
                                l.c2p(p)
                            ];
                            e1.contains(d, null, r, t1) ? (c.push({
                                pointNumber: r,
                                lon: f[0],
                                lat: f[1]
                            }), h.selected = 1) : h.selected = 0;
                        }
                    }
                    return c;
                };
            },
            8738: function(t1, e1, r) {
                "use strict";
                var n = r(3208).rb, i = r(3208).ay, a = r(93049).extendFlat, o = r(19326), s = r(36640), l = r(9829), c = s.line;
                t1.exports = {
                    mode: s.mode,
                    r: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    theta: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    r0: {
                        valType: "any",
                        dflt: 0,
                        editType: "calc+clearAxisTypes"
                    },
                    dr: {
                        valType: "number",
                        dflt: 1,
                        editType: "calc"
                    },
                    theta0: {
                        valType: "any",
                        dflt: 0,
                        editType: "calc+clearAxisTypes"
                    },
                    dtheta: {
                        valType: "number",
                        editType: "calc"
                    },
                    thetaunit: {
                        valType: "enumerated",
                        values: [
                            "radians",
                            "degrees",
                            "gradians"
                        ],
                        dflt: "degrees",
                        editType: "calc+clearAxisTypes"
                    },
                    text: s.text,
                    texttemplate: i({
                        editType: "plot"
                    }, {
                        keys: [
                            "r",
                            "theta",
                            "text"
                        ]
                    }),
                    hovertext: s.hovertext,
                    line: {
                        color: c.color,
                        width: c.width,
                        dash: c.dash,
                        backoff: c.backoff,
                        shape: a({}, c.shape, {
                            values: [
                                "linear",
                                "spline"
                            ]
                        }),
                        smoothing: c.smoothing,
                        editType: "calc"
                    },
                    connectgaps: s.connectgaps,
                    marker: s.marker,
                    cliponaxis: a({}, s.cliponaxis, {
                        dflt: !1
                    }),
                    textposition: s.textposition,
                    textfont: s.textfont,
                    fill: a({}, s.fill, {
                        values: [
                            "none",
                            "toself",
                            "tonext"
                        ],
                        dflt: "none"
                    }),
                    fillcolor: o(),
                    hoverinfo: a({}, l.hoverinfo, {
                        flags: [
                            "r",
                            "theta",
                            "text",
                            "name"
                        ]
                    }),
                    hoveron: s.hoveron,
                    hovertemplate: n(),
                    selected: s.selected,
                    unselected: s.unselected
                };
            },
            13246: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(63821).BADNUM, a = r(29714), o = r(77272), s = r(99203), l = r(48861), c = r(26544).calcMarkerSize;
                t1.exports = function(t1, e1) {
                    for(var r = t1._fullLayout, u = e1.subplot, h = r[u].radialaxis, f = r[u].angularaxis, p = h.makeCalcdata(e1, "r"), d = f.makeCalcdata(e1, "theta"), m = e1._length, g = new Array(m), y = 0; y < m; y++){
                        var v = p[y], x = d[y], _ = g[y] = {};
                        n(v) && n(x) ? (_.r = v, _.theta = x) : _.r = i;
                    }
                    var b = c(e1, m);
                    return e1._extremes.x = a.findExtremes(h, p, {
                        ppad: b
                    }), o(t1, e1), s(g, e1), l(g, e1), g;
                };
            },
            73749: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(64726), a = r(24272), o = r(98168), s = r(91602), l = r(663), c = r(54114), u = r(32660).PTS_LINESONLY, h = r(8738);
                function f(t1, e1, r, i) {
                    var a, o = i("r"), s = i("theta");
                    if (n.isTypedArray(o) && (e1.r = o = Array.from(o)), n.isTypedArray(s) && (e1.theta = s = Array.from(s)), o) s ? a = Math.min(o.length, s.length) : (a = o.length, i("theta0"), i("dtheta"));
                    else {
                        if (!s) return 0;
                        a = e1.theta.length, i("r0"), i("dr");
                    }
                    return e1._length = a, a;
                }
                t1.exports = {
                    handleRThetaDefaults: f,
                    supplyDefaults: function(t1, e1, r, p) {
                        function d(r, i) {
                            return n.coerce(t1, e1, h, r, i);
                        }
                        var m = f(0, e1, 0, d);
                        if (m) {
                            d("thetaunit"), d("mode", m < u ? "lines+markers" : "lines"), d("text"), d("hovertext"), "fills" !== e1.hoveron && d("hovertemplate"), i.hasMarkers(e1) && a(t1, e1, r, p, d, {
                                gradient: !0
                            }), i.hasLines(e1) && (o(t1, e1, r, p, d, {
                                backoff: !0
                            }), s(t1, e1, d), d("connectgaps")), i.hasText(e1) && (d("texttemplate"), l(t1, e1, p, d));
                            var g = [];
                            (i.hasMarkers(e1) || i.hasText(e1)) && (d("cliponaxis"), d("marker.maxdisplayed"), g.push("points")), d("fill"), "none" !== e1.fill && (c(t1, e1, r, d), i.hasLines(e1) || s(t1, e1, d)), "tonext" !== e1.fill && "toself" !== e1.fill || g.push("fills"), d("hoveron", g.join("+") || "points"), n.coerceSelectionMarkerOpacity(e1, d);
                        } else e1.visible = !1;
                    }
                };
            },
            33368: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(29714);
                t1.exports = function(t1, e1, r) {
                    var a, o, s = {}, l = r[e1.subplot]._subplot;
                    l ? (a = l.radialAxis, o = l.angularAxis) : (a = (l = r[e1.subplot]).radialaxis, o = l.angularaxis);
                    var c = a.c2l(t1.r);
                    s.rLabel = i.tickText(a, c, !0).text;
                    var u = "degrees" === o.thetaunit ? n.rad2deg(t1.theta) : t1.theta;
                    return s.thetaLabel = i.tickText(o, u, !0).text, s;
                };
            },
            29709: function(t1, e1, r) {
                "use strict";
                var n = r(37255);
                function i(t1, e1, r, n) {
                    var i = r.radialAxis, a = r.angularAxis;
                    i._hovertitle = "r", a._hovertitle = "\u03B8";
                    var o = {};
                    o[e1.subplot] = {
                        _subplot: r
                    };
                    var s = e1._module.formatLabels(t1, e1, o);
                    n.rLabel = s.rLabel, n.thetaLabel = s.thetaLabel;
                    var l = t1.hi || e1.hoverinfo, c = [];
                    function u(t1, e1) {
                        c.push(t1._hovertitle + ": " + e1);
                    }
                    if (!e1.hovertemplate) {
                        var h = l.split("+");
                        -1 !== h.indexOf("all") && (h = [
                            "r",
                            "theta",
                            "text"
                        ]), -1 !== h.indexOf("r") && u(i, n.rLabel), -1 !== h.indexOf("theta") && u(a, n.thetaLabel), -1 !== h.indexOf("text") && n.text && (c.push(n.text), delete n.text), n.extraText = c.join("<br>");
                    }
                }
                t1.exports = {
                    hoverPoints: function(t1, e1, r, a) {
                        var o = n(t1, e1, r, a);
                        if (o && !1 !== o[0].index) {
                            var s = o[0];
                            if (void 0 === s.index) return o;
                            var l = t1.subplot, c = s.cd[s.index], u = s.trace;
                            if (l.isPtInside(c)) return s.xLabelVal = void 0, s.yLabelVal = void 0, i(c, u, l, s), s.hovertemplate = u.hovertemplate, o;
                        }
                    },
                    makeHoverPointText: i
                };
            },
            66939: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    moduleType: "trace",
                    name: "scatterpolar",
                    basePlotModule: r(31645),
                    categories: [
                        "polar",
                        "symbols",
                        "showLegend",
                        "scatter-like"
                    ],
                    attributes: r(8738),
                    supplyDefaults: r(73749).supplyDefaults,
                    colorbar: r(21146),
                    formatLabels: r(33368),
                    calc: r(13246),
                    plot: r(43836),
                    style: r(9408).style,
                    styleOnSelect: r(9408).styleOnSelect,
                    hoverPoints: r(29709).hoverPoints,
                    selectPoints: r(32665),
                    meta: {}
                };
            },
            43836: function(t1, e1, r) {
                "use strict";
                var n = r(36098), i = r(63821).BADNUM;
                t1.exports = function(t1, e1, r) {
                    for(var a = e1.layers.frontplot.select("g.scatterlayer"), o = e1.xaxis, s = e1.yaxis, l = {
                        xaxis: o,
                        yaxis: s,
                        plot: e1.framework,
                        layerClipId: e1._hasClipOnAxisFalse ? e1.clipIds.forTraces : null
                    }, c = e1.radialAxis, u = e1.angularAxis, h = 0; h < r.length; h++)for(var f = r[h], p = 0; p < f.length; p++){
                        0 === p && (f[0].trace._xA = o, f[0].trace._yA = s);
                        var d = f[p], m = d.r;
                        if (m === i) d.x = d.y = i;
                        else {
                            var g = c.c2g(m), y = u.c2g(d.theta);
                            d.x = g * Math.cos(y), d.y = g * Math.sin(y);
                        }
                    }
                    n(t1, l, r, a);
                };
            },
            58319: function(t1, e1, r) {
                "use strict";
                var n = r(8738), i = r(92089), a = r(3208).ay;
                t1.exports = {
                    mode: n.mode,
                    r: n.r,
                    theta: n.theta,
                    r0: n.r0,
                    dr: n.dr,
                    theta0: n.theta0,
                    dtheta: n.dtheta,
                    thetaunit: n.thetaunit,
                    text: n.text,
                    texttemplate: a({
                        editType: "plot"
                    }, {
                        keys: [
                            "r",
                            "theta",
                            "text"
                        ]
                    }),
                    hovertext: n.hovertext,
                    hovertemplate: n.hovertemplate,
                    line: {
                        color: i.line.color,
                        width: i.line.width,
                        dash: i.line.dash,
                        editType: "calc"
                    },
                    connectgaps: i.connectgaps,
                    marker: i.marker,
                    fill: i.fill,
                    fillcolor: i.fillcolor,
                    textposition: i.textposition,
                    textfont: i.textfont,
                    hoverinfo: n.hoverinfo,
                    selected: n.selected,
                    unselected: n.unselected
                };
            },
            25796: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    moduleType: "trace",
                    name: "scatterpolargl",
                    basePlotModule: r(31645),
                    categories: [
                        "gl",
                        "regl",
                        "polar",
                        "symbols",
                        "showLegend",
                        "scatter-like"
                    ],
                    attributes: r(58319),
                    supplyDefaults: r(14952),
                    colorbar: r(21146),
                    formatLabels: r(94015),
                    calc: r(71535),
                    hoverPoints: r(47522).hoverPoints,
                    selectPoints: r(17168),
                    meta: {}
                };
            },
            71535: function(t1, e1, r) {
                "use strict";
                var n = r(77272), i = r(26544).calcMarkerSize, a = r(19937), o = r(29714), s = r(29483).TOO_MANY_POINTS;
                t1.exports = function(t1, e1) {
                    var r = t1._fullLayout, l = e1.subplot, c = r[l].radialaxis, u = r[l].angularaxis, h = e1._r = c.makeCalcdata(e1, "r"), f = e1._theta = u.makeCalcdata(e1, "theta"), p = e1._length, d = {};
                    p < h.length && (h = h.slice(0, p)), p < f.length && (f = f.slice(0, p)), d.r = h, d.theta = f, n(t1, e1);
                    var m, g = d.opts = a.style(t1, e1);
                    return p < s ? m = i(e1, p) : g.marker && (m = 2 * (g.marker.sizeAvg || Math.max(g.marker.size, 3))), e1._extremes.x = o.findExtremes(c, h, {
                        ppad: m
                    }), [
                        {
                            x: !1,
                            y: !1,
                            t: d,
                            trace: e1
                        }
                    ];
                };
            },
            14952: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(64726), a = r(73749).handleRThetaDefaults, o = r(24272), s = r(98168), l = r(663), c = r(54114), u = r(32660).PTS_LINESONLY, h = r(58319);
                t1.exports = function(t1, e1, r, f) {
                    function p(r, i) {
                        return n.coerce(t1, e1, h, r, i);
                    }
                    var d = a(t1, e1, f, p);
                    d ? (p("thetaunit"), p("mode", d < u ? "lines+markers" : "lines"), p("text"), p("hovertext"), "fills" !== e1.hoveron && p("hovertemplate"), i.hasMarkers(e1) && o(t1, e1, r, f, p, {
                        noAngleRef: !0,
                        noStandOff: !0
                    }), i.hasLines(e1) && (s(t1, e1, r, f, p), p("connectgaps")), i.hasText(e1) && (p("texttemplate"), l(t1, e1, f, p, {
                        noFontShadow: !0,
                        noFontLineposition: !0,
                        noFontTextcase: !0
                    })), p("fill"), "none" !== e1.fill && c(t1, e1, r, p), n.coerceSelectionMarkerOpacity(e1, p)) : e1.visible = !1;
                };
            },
            94015: function(t1, e1, r) {
                "use strict";
                var n = r(33368);
                t1.exports = function(t1, e1, r) {
                    var i = t1.i;
                    return "r" in t1 || (t1.r = e1._r[i]), "theta" in t1 || (t1.theta = e1._theta[i]), n(t1, e1, r);
                };
            },
            47522: function(t1, e1, r) {
                "use strict";
                var n = r(36544), i = r(29709).makeHoverPointText;
                t1.exports = {
                    hoverPoints: function(t1, e1, r, a) {
                        var o = t1.cd[0].t, s = o.r, l = o.theta, c = n.hoverPoints(t1, e1, r, a);
                        if (c && !1 !== c[0].index) {
                            var u = c[0];
                            if (void 0 === u.index) return c;
                            var h = t1.subplot, f = u.cd[u.index], p = u.trace;
                            if (f.r = s[u.index], f.theta = l[u.index], h.isPtInside(f)) return u.xLabelVal = void 0, u.yLabelVal = void 0, i(f, p, h, u), c;
                        }
                    }
                };
            },
            23748: function(t1, e1, r) {
                "use strict";
                var n = r(25796);
                n.plot = r(54121), t1.exports = n;
            },
            54121: function(t1, e1, r) {
                "use strict";
                var n = r(27549), i = r(10721), a = r(47731), o = r(62336), s = r(19937), l = r(34809), c = r(29483).TOO_MANY_POINTS;
                t1.exports = function(t1, e1, r) {
                    if (r.length) {
                        var u = e1.radialAxis, h = e1.angularAxis, f = o(t1, e1);
                        return r.forEach(function(r) {
                            if (r && r[0] && r[0].trace) {
                                var a, o = r[0], p = o.trace, d = o.t, m = p._length, g = d.r, y = d.theta, v = d.opts, x = g.slice(), _ = y.slice();
                                for(a = 0; a < g.length; a++)e1.isPtInside({
                                    r: g[a],
                                    theta: y[a]
                                }) || (x[a] = NaN, _[a] = NaN);
                                var b = new Array(2 * m), w = Array(m), T = Array(m);
                                for(a = 0; a < m; a++){
                                    var k, A, M = x[a];
                                    if (i(M)) {
                                        var S = u.c2g(M), E = h.c2g(_[a], p.thetaunit);
                                        k = S * Math.cos(E), A = S * Math.sin(E);
                                    } else k = A = NaN;
                                    w[a] = b[2 * a] = k, T[a] = b[2 * a + 1] = A;
                                }
                                d.tree = n(b), v.marker && m >= c && (v.marker.cluster = d.tree), v.marker && (v.markerSel.positions = v.markerUnsel.positions = v.marker.positions = b), v.line && b.length > 1 && l.extendFlat(v.line, s.linePositions(t1, p, b)), v.text && (l.extendFlat(v.text, {
                                    positions: b
                                }, s.textPosition(t1, p, v.text, v.marker)), l.extendFlat(v.textSel, {
                                    positions: b
                                }, s.textPosition(t1, p, v.text, v.markerSel)), l.extendFlat(v.textUnsel, {
                                    positions: b
                                }, s.textPosition(t1, p, v.text, v.markerUnsel))), v.fill && !f.fill2d && (f.fill2d = !0), v.marker && !f.scatter2d && (f.scatter2d = !0), v.line && !f.line2d && (f.line2d = !0), v.text && !f.glText && (f.glText = !0), f.lineOptions.push(v.line), f.fillOptions.push(v.fill), f.markerOptions.push(v.marker), f.markerSelectedOptions.push(v.markerSel), f.markerUnselectedOptions.push(v.markerUnsel), f.textOptions.push(v.text), f.textSelectedOptions.push(v.textSel), f.textUnselectedOptions.push(v.textUnsel), f.selectBatch.push([]), f.unselectBatch.push([]), d.x = w, d.y = T, d.rawx = w, d.rawy = T, d.r = g, d.theta = y, d.positions = b, d._scene = f, d.index = f.count, f.count++;
                            }
                        }), a(t1, e1, r);
                    }
                }, t1.exports.reglPrecompiled = {};
            },
            69595: function(t1, e1, r) {
                "use strict";
                var n = r(3208).rb, i = r(3208).ay, a = r(93049).extendFlat, o = r(19326), s = r(36640), l = r(9829), c = s.line;
                t1.exports = {
                    mode: s.mode,
                    real: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    imag: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    text: s.text,
                    texttemplate: i({
                        editType: "plot"
                    }, {
                        keys: [
                            "real",
                            "imag",
                            "text"
                        ]
                    }),
                    hovertext: s.hovertext,
                    line: {
                        color: c.color,
                        width: c.width,
                        dash: c.dash,
                        backoff: c.backoff,
                        shape: a({}, c.shape, {
                            values: [
                                "linear",
                                "spline"
                            ]
                        }),
                        smoothing: c.smoothing,
                        editType: "calc"
                    },
                    connectgaps: s.connectgaps,
                    marker: s.marker,
                    cliponaxis: a({}, s.cliponaxis, {
                        dflt: !1
                    }),
                    textposition: s.textposition,
                    textfont: s.textfont,
                    fill: a({}, s.fill, {
                        values: [
                            "none",
                            "toself",
                            "tonext"
                        ],
                        dflt: "none"
                    }),
                    fillcolor: o(),
                    hoverinfo: a({}, l.hoverinfo, {
                        flags: [
                            "real",
                            "imag",
                            "text",
                            "name"
                        ]
                    }),
                    hoveron: s.hoveron,
                    hovertemplate: n(),
                    selected: s.selected,
                    unselected: s.unselected
                };
            },
            44315: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(63821).BADNUM, a = r(77272), o = r(99203), s = r(48861), l = r(26544).calcMarkerSize;
                t1.exports = function(t1, e1) {
                    for(var r = t1._fullLayout, c = e1.subplot, u = r[c].realaxis, h = r[c].imaginaryaxis, f = u.makeCalcdata(e1, "real"), p = h.makeCalcdata(e1, "imag"), d = e1._length, m = new Array(d), g = 0; g < d; g++){
                        var y = f[g], v = p[g], x = m[g] = {};
                        n(y) && n(v) ? (x.real = y, x.imag = v) : x.real = i;
                    }
                    return l(e1, d), a(t1, e1), o(m, e1), s(m, e1), m;
                };
            },
            93788: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(64726), a = r(24272), o = r(98168), s = r(91602), l = r(663), c = r(54114), u = r(32660).PTS_LINESONLY, h = r(69595);
                t1.exports = function(t1, e1, r, f) {
                    function p(r, i) {
                        return n.coerce(t1, e1, h, r, i);
                    }
                    var d = function(t1, e1, r, i) {
                        var a, o = i("real"), s = i("imag");
                        return o && s && (a = Math.min(o.length, s.length)), n.isTypedArray(o) && (e1.real = o = Array.from(o)), n.isTypedArray(s) && (e1.imag = s = Array.from(s)), e1._length = a, a;
                    }(0, e1, 0, p);
                    if (d) {
                        p("mode", d < u ? "lines+markers" : "lines"), p("text"), p("hovertext"), "fills" !== e1.hoveron && p("hovertemplate"), i.hasMarkers(e1) && a(t1, e1, r, f, p, {
                            gradient: !0
                        }), i.hasLines(e1) && (o(t1, e1, r, f, p, {
                            backoff: !0
                        }), s(t1, e1, p), p("connectgaps")), i.hasText(e1) && (p("texttemplate"), l(t1, e1, f, p));
                        var m = [];
                        (i.hasMarkers(e1) || i.hasText(e1)) && (p("cliponaxis"), p("marker.maxdisplayed"), m.push("points")), p("fill"), "none" !== e1.fill && (c(t1, e1, r, p), i.hasLines(e1) || s(t1, e1, p)), "tonext" !== e1.fill && "toself" !== e1.fill || m.push("fills"), p("hoveron", m.join("+") || "points"), n.coerceSelectionMarkerOpacity(e1, p);
                    } else e1.visible = !1;
                };
            },
            89419: function(t1, e1, r) {
                "use strict";
                var n = r(29714);
                t1.exports = function(t1, e1, r) {
                    var i = {}, a = r[e1.subplot]._subplot;
                    return i.realLabel = n.tickText(a.radialAxis, t1.real, !0).text, i.imagLabel = n.tickText(a.angularAxis, t1.imag, !0).text, i;
                };
            },
            64422: function(t1, e1, r) {
                "use strict";
                var n = r(37255);
                function i(t1, e1, r, n) {
                    var i = r.radialAxis, a = r.angularAxis;
                    i._hovertitle = "real", a._hovertitle = "imag";
                    var o = {};
                    o[e1.subplot] = {
                        _subplot: r
                    };
                    var s = e1._module.formatLabels(t1, e1, o);
                    n.realLabel = s.realLabel, n.imagLabel = s.imagLabel;
                    var l = t1.hi || e1.hoverinfo, c = [];
                    function u(t1, e1) {
                        c.push(t1._hovertitle + ": " + e1);
                    }
                    if (!e1.hovertemplate) {
                        var h = l.split("+");
                        -1 !== h.indexOf("all") && (h = [
                            "real",
                            "imag",
                            "text"
                        ]), -1 !== h.indexOf("real") && u(i, n.realLabel), -1 !== h.indexOf("imag") && u(a, n.imagLabel), -1 !== h.indexOf("text") && n.text && (c.push(n.text), delete n.text), n.extraText = c.join("<br>");
                    }
                }
                t1.exports = {
                    hoverPoints: function(t1, e1, r, a) {
                        var o = n(t1, e1, r, a);
                        if (o && !1 !== o[0].index) {
                            var s = o[0];
                            if (void 0 === s.index) return o;
                            var l = t1.subplot, c = s.cd[s.index], u = s.trace;
                            if (l.isPtInside(c)) return s.xLabelVal = void 0, s.yLabelVal = void 0, i(c, u, l, s), s.hovertemplate = u.hovertemplate, o;
                        }
                    },
                    makeHoverPointText: i
                };
            },
            73304: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    moduleType: "trace",
                    name: "scattersmith",
                    basePlotModule: r(50358),
                    categories: [
                        "smith",
                        "symbols",
                        "showLegend",
                        "scatter-like"
                    ],
                    attributes: r(69595),
                    supplyDefaults: r(93788),
                    colorbar: r(21146),
                    formatLabels: r(89419),
                    calc: r(44315),
                    plot: r(6229),
                    style: r(9408).style,
                    styleOnSelect: r(9408).styleOnSelect,
                    hoverPoints: r(64422).hoverPoints,
                    selectPoints: r(32665),
                    meta: {}
                };
            },
            6229: function(t1, e1, r) {
                "use strict";
                var n = r(36098), i = r(63821).BADNUM, a = r(52007).smith;
                t1.exports = function(t1, e1, r) {
                    for(var o = e1.layers.frontplot.select("g.scatterlayer"), s = e1.xaxis, l = e1.yaxis, c = {
                        xaxis: s,
                        yaxis: l,
                        plot: e1.framework,
                        layerClipId: e1._hasClipOnAxisFalse ? e1.clipIds.forTraces : null
                    }, u = 0; u < r.length; u++)for(var h = r[u], f = 0; f < h.length; f++){
                        0 === f && (h[0].trace._xA = s, h[0].trace._yA = l);
                        var p = h[f], d = p.real;
                        if (d === i) p.x = p.y = i;
                        else {
                            var m = a([
                                d,
                                p.imag
                            ]);
                            p.x = m[0], p.y = m[1];
                        }
                    }
                    n(t1, c, r, o);
                };
            },
            18483: function(t1, e1, r) {
                "use strict";
                var n = r(3208).rb, i = r(3208).ay, a = r(19326), o = r(36640), s = r(9829), l = r(87163), c = r(94850).T, u = r(93049).extendFlat, h = o.marker, f = o.line, p = h.line;
                t1.exports = {
                    a: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    b: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    c: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    sum: {
                        valType: "number",
                        dflt: 0,
                        min: 0,
                        editType: "calc"
                    },
                    mode: u({}, o.mode, {
                        dflt: "markers"
                    }),
                    text: u({}, o.text, {}),
                    texttemplate: i({
                        editType: "plot"
                    }, {
                        keys: [
                            "a",
                            "b",
                            "c",
                            "text"
                        ]
                    }),
                    hovertext: u({}, o.hovertext, {}),
                    line: {
                        color: f.color,
                        width: f.width,
                        dash: c,
                        backoff: f.backoff,
                        shape: u({}, f.shape, {
                            values: [
                                "linear",
                                "spline"
                            ]
                        }),
                        smoothing: f.smoothing,
                        editType: "calc"
                    },
                    connectgaps: o.connectgaps,
                    cliponaxis: o.cliponaxis,
                    fill: u({}, o.fill, {
                        values: [
                            "none",
                            "toself",
                            "tonext"
                        ],
                        dflt: "none"
                    }),
                    fillcolor: a(),
                    marker: u({
                        symbol: h.symbol,
                        opacity: h.opacity,
                        angle: h.angle,
                        angleref: h.angleref,
                        standoff: h.standoff,
                        maxdisplayed: h.maxdisplayed,
                        size: h.size,
                        sizeref: h.sizeref,
                        sizemin: h.sizemin,
                        sizemode: h.sizemode,
                        line: u({
                            width: p.width,
                            editType: "calc"
                        }, l("marker.line")),
                        gradient: h.gradient,
                        editType: "calc"
                    }, l("marker")),
                    textfont: o.textfont,
                    textposition: o.textposition,
                    selected: o.selected,
                    unselected: o.unselected,
                    hoverinfo: u({}, s.hoverinfo, {
                        flags: [
                            "a",
                            "b",
                            "c",
                            "text",
                            "name"
                        ]
                    }),
                    hoveron: o.hoveron,
                    hovertemplate: n()
                };
            },
            67091: function(t1, e1, r) {
                "use strict";
                var n = r(10721), i = r(77272), a = r(99203), o = r(48861), s = r(26544).calcMarkerSize, l = [
                    "a",
                    "b",
                    "c"
                ], c = {
                    a: [
                        "b",
                        "c"
                    ],
                    b: [
                        "a",
                        "c"
                    ],
                    c: [
                        "a",
                        "b"
                    ]
                };
                t1.exports = function(t1, e1) {
                    var r, u, h, f, p, d, m = t1._fullLayout[e1.subplot].sum, g = e1.sum || m, y = {
                        a: e1.a,
                        b: e1.b,
                        c: e1.c
                    };
                    for(r = 0; r < l.length; r++)if (!y[h = l[r]]) {
                        for(p = y[c[h][0]], d = y[c[h][1]], f = new Array(p.length), u = 0; u < p.length; u++)f[u] = g - p[u] - d[u];
                        y[h] = f;
                    }
                    var v, x, _, b, w, T, k = e1._length, A = new Array(k);
                    for(r = 0; r < k; r++)v = y.a[r], x = y.b[r], _ = y.c[r], n(v) && n(x) && n(_) ? (1 != (b = m / ((v = +v) + (x = +x) + (_ = +_))) && (v *= b, x *= b, _ *= b), T = v, w = _ - x, A[r] = {
                        x: w,
                        y: T,
                        a: v,
                        b: x,
                        c: _
                    }) : A[r] = {
                        x: !1,
                        y: !1
                    };
                    return s(e1, k), i(t1, e1), a(A, e1), o(A, e1), A;
                };
            },
            79028: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(32660), a = r(64726), o = r(24272), s = r(98168), l = r(91602), c = r(663), u = r(54114), h = r(18483);
                t1.exports = function(t1, e1, r, f) {
                    function p(r, i) {
                        return n.coerce(t1, e1, h, r, i);
                    }
                    var d, m = p("a"), g = p("b"), y = p("c");
                    if (m ? (d = m.length, g ? (d = Math.min(d, g.length), y && (d = Math.min(d, y.length))) : d = y ? Math.min(d, y.length) : 0) : g && y && (d = Math.min(g.length, y.length)), d) {
                        e1._length = d, p("sum"), p("text"), p("hovertext"), "fills" !== e1.hoveron && p("hovertemplate"), p("mode", d < i.PTS_LINESONLY ? "lines+markers" : "lines"), a.hasMarkers(e1) && o(t1, e1, r, f, p, {
                            gradient: !0
                        }), a.hasLines(e1) && (s(t1, e1, r, f, p, {
                            backoff: !0
                        }), l(t1, e1, p), p("connectgaps")), a.hasText(e1) && (p("texttemplate"), c(t1, e1, f, p));
                        var v = [];
                        (a.hasMarkers(e1) || a.hasText(e1)) && (p("cliponaxis"), p("marker.maxdisplayed"), v.push("points")), p("fill"), "none" !== e1.fill && (u(t1, e1, r, p), a.hasLines(e1) || l(t1, e1, p)), "tonext" !== e1.fill && "toself" !== e1.fill || v.push("fills"), p("hoveron", v.join("+") || "points"), n.coerceSelectionMarkerOpacity(e1, p);
                    } else e1.visible = !1;
                };
            },
            94343: function(t1) {
                "use strict";
                t1.exports = function(t1, e1, r, n, i) {
                    if (e1.xa && (t1.xaxis = e1.xa), e1.ya && (t1.yaxis = e1.ya), n[i]) {
                        var a = n[i];
                        t1.a = a.a, t1.b = a.b, t1.c = a.c;
                    } else t1.a = e1.a, t1.b = e1.b, t1.c = e1.c;
                    return t1;
                };
            },
            78995: function(t1, e1, r) {
                "use strict";
                var n = r(29714);
                t1.exports = function(t1, e1, r) {
                    var i = {}, a = r[e1.subplot]._subplot;
                    return i.aLabel = n.tickText(a.aaxis, t1.a, !0).text, i.bLabel = n.tickText(a.baxis, t1.b, !0).text, i.cLabel = n.tickText(a.caxis, t1.c, !0).text, i;
                };
            },
            26558: function(t1, e1, r) {
                "use strict";
                var n = r(37255);
                t1.exports = function(t1, e1, r, i) {
                    var a = n(t1, e1, r, i);
                    if (a && !1 !== a[0].index) {
                        var o = a[0];
                        if (void 0 === o.index) {
                            var s = 1 - o.y0 / t1.ya._length, l = t1.xa._length, c = l * s / 2, u = l - c;
                            return o.x0 = Math.max(Math.min(o.x0, u), c), o.x1 = Math.max(Math.min(o.x1, u), c), a;
                        }
                        var h = o.cd[o.index], f = o.trace, p = o.subplot;
                        o.a = h.a, o.b = h.b, o.c = h.c, o.xLabelVal = void 0, o.yLabelVal = void 0;
                        var d = {};
                        d[f.subplot] = {
                            _subplot: p
                        };
                        var m = f._module.formatLabels(h, f, d);
                        o.aLabel = m.aLabel, o.bLabel = m.bLabel, o.cLabel = m.cLabel;
                        var g = h.hi || f.hoverinfo, y = [];
                        if (!f.hovertemplate) {
                            var v = g.split("+");
                            -1 !== v.indexOf("all") && (v = [
                                "a",
                                "b",
                                "c"
                            ]), -1 !== v.indexOf("a") && x(p.aaxis, o.aLabel), -1 !== v.indexOf("b") && x(p.baxis, o.bLabel), -1 !== v.indexOf("c") && x(p.caxis, o.cLabel);
                        }
                        return o.extraText = y.join("<br>"), o.hovertemplate = f.hovertemplate, a;
                    }
                    function x(t1, e1) {
                        y.push(t1._hovertitle + ": " + e1);
                    }
                };
            },
            12864: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    attributes: r(18483),
                    supplyDefaults: r(79028),
                    colorbar: r(21146),
                    formatLabels: r(78995),
                    calc: r(67091),
                    plot: r(79005),
                    style: r(9408).style,
                    styleOnSelect: r(9408).styleOnSelect,
                    hoverPoints: r(26558),
                    selectPoints: r(32665),
                    eventData: r(94343),
                    moduleType: "trace",
                    name: "scatterternary",
                    basePlotModule: r(7638),
                    categories: [
                        "ternary",
                        "symbols",
                        "showLegend",
                        "scatter-like"
                    ],
                    meta: {}
                };
            },
            79005: function(t1, e1, r) {
                "use strict";
                var n = r(36098);
                t1.exports = function(t1, e1, r) {
                    var i = e1.plotContainer;
                    i.select(".scatterlayer").selectAll("*").remove();
                    for(var a = e1.xaxis, o = e1.yaxis, s = {
                        xaxis: a,
                        yaxis: o,
                        plot: i,
                        layerClipId: e1._hasClipOnAxisFalse ? e1.clipIdRelative : null
                    }, l = e1.layers.frontplot.select("g.scatterlayer"), c = 0; c < r.length; c++){
                        var u = r[c];
                        u.length && (u[0].trace._xA = a, u[0].trace._yA = o);
                    }
                    n(t1, s, r, l);
                };
            },
            68697: function(t1, e1, r) {
                "use strict";
                var n = r(36640), i = r(87163), a = r(80712).axisHoverFormat, o = r(3208).rb, s = r(92089), l = r(54826).idRegex, c = r(78032).templatedArray, u = r(93049).extendFlat, h = n.marker, f = h.line, p = u(i("marker.line", {
                    editTypeOverride: "calc"
                }), {
                    width: u({}, f.width, {
                        editType: "calc"
                    }),
                    editType: "calc"
                }), d = u(i("marker"), {
                    symbol: h.symbol,
                    angle: h.angle,
                    size: u({}, h.size, {
                        editType: "markerSize"
                    }),
                    sizeref: h.sizeref,
                    sizemin: h.sizemin,
                    sizemode: h.sizemode,
                    opacity: h.opacity,
                    colorbar: h.colorbar,
                    line: p,
                    editType: "calc"
                });
                function m(t1) {
                    return {
                        valType: "info_array",
                        freeLength: !0,
                        editType: "calc",
                        items: {
                            valType: "subplotid",
                            regex: l[t1],
                            editType: "plot"
                        }
                    };
                }
                d.color.editType = d.cmin.editType = d.cmax.editType = "style", t1.exports = {
                    dimensions: c("dimension", {
                        visible: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "calc"
                        },
                        label: {
                            valType: "string",
                            editType: "calc"
                        },
                        values: {
                            valType: "data_array",
                            editType: "calc+clearAxisTypes"
                        },
                        axis: {
                            type: {
                                valType: "enumerated",
                                values: [
                                    "linear",
                                    "log",
                                    "date",
                                    "category"
                                ],
                                editType: "calc+clearAxisTypes"
                            },
                            matches: {
                                valType: "boolean",
                                dflt: !1,
                                editType: "calc"
                            },
                            editType: "calc+clearAxisTypes"
                        },
                        editType: "calc+clearAxisTypes"
                    }),
                    text: u({}, s.text, {}),
                    hovertext: u({}, s.hovertext, {}),
                    hovertemplate: o(),
                    xhoverformat: a("x"),
                    yhoverformat: a("y"),
                    marker: d,
                    xaxes: m("x"),
                    yaxes: m("y"),
                    diagonal: {
                        visible: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "calc"
                        },
                        editType: "calc"
                    },
                    showupperhalf: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    },
                    showlowerhalf: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    },
                    selected: {
                        marker: s.selected.marker,
                        editType: "calc"
                    },
                    unselected: {
                        marker: s.unselected.marker,
                        editType: "calc"
                    },
                    opacity: s.opacity
                };
            },
            86690: function(t1, e1, r) {
                "use strict";
                var n = r(33626), i = r(83595);
                t1.exports = {
                    moduleType: "trace",
                    name: "splom",
                    categories: [
                        "gl",
                        "regl",
                        "cartesian",
                        "symbols",
                        "showLegend",
                        "scatter-like"
                    ],
                    attributes: r(68697),
                    supplyDefaults: r(52542),
                    colorbar: r(21146),
                    calc: r(55325),
                    plot: r(83027),
                    hoverPoints: r(25600).hoverPoints,
                    selectPoints: r(13392),
                    editStyle: r(27926),
                    meta: {}
                }, n.register(i);
            },
            571: function(t1, e1, r) {
                "use strict";
                var n = r(49478), i = r(33626), a = r(22459), o = r(4173).eV, s = r(37703), l = r(5975).getFromId, c = r(29714).shouldShowZeroLine, u = "splom", h = {};
                function f(t1, e1, r) {
                    for(var n = r.matrixOptions.data.length, i = e1._visibleDims, a = r.viewOpts.ranges = new Array(n), o = 0; o < i.length; o++){
                        var s = i[o], c = a[o] = new Array(4), u = l(t1, e1._diag[s][0]);
                        u && (c[0] = u.r2l(u.range[0]), c[2] = u.r2l(u.range[1]));
                        var h = l(t1, e1._diag[s][1]);
                        h && (c[1] = h.r2l(h.range[0]), c[3] = h.r2l(h.range[1]));
                    }
                    r.selectBatch.length || r.unselectBatch.length ? r.matrix.update({
                        ranges: a
                    }, {
                        ranges: a
                    }) : r.matrix.update({
                        ranges: a
                    });
                }
                function p(t1) {
                    var e1 = t1._fullLayout, r = e1._glcanvas.data()[0].regl, i = e1._splomGrid;
                    i || (i = e1._splomGrid = n(r)), i.update(function(t1) {
                        var e1, r = t1._context.plotGlPixelRatio, n = t1._fullLayout, i = n._size, a = [
                            0,
                            0,
                            n.width * r,
                            n.height * r
                        ], o = {};
                        function s(t1, e1, n, i, s, l) {
                            n *= r, i *= r, s *= r, l *= r;
                            var c = e1[t1 + "color"], u = e1[t1 + "width"], h = String(c + u);
                            h in o ? o[h].data.push(NaN, NaN, n, i, s, l) : o[h] = {
                                data: [
                                    n,
                                    i,
                                    s,
                                    l
                                ],
                                join: "rect",
                                thickness: u * r,
                                color: c,
                                viewport: a,
                                range: a,
                                overlay: !1
                            };
                        }
                        for(e1 in n._splomSubplots){
                            var l, u, h = n._plots[e1], f = h.xaxis, p = h.yaxis, d = f._gridVals, m = p._gridVals, g = f._offset, y = f._length, v = p._length, x = i.b + p.domain[0] * i.h, _ = -p._m, b = -_ * p.r2l(p.range[0], p.calendar);
                            if (f.showgrid) for(e1 = 0; e1 < d.length; e1++)l = g + f.l2p(d[e1].x), s("grid", f, l, x, l, x + v);
                            if (p.showgrid) for(e1 = 0; e1 < m.length; e1++)s("grid", p, g, u = x + b + _ * m[e1].x, g + y, u);
                            c(t1, f, p) && (l = g + f.l2p(0), s("zeroline", f, l, x, l, x + v)), c(t1, p, f) && s("zeroline", p, g, u = x + b + 0, g + y, u);
                        }
                        var w = [];
                        for(e1 in o)w.push(o[e1]);
                        return w;
                    }(t1));
                }
                t1.exports = {
                    name: u,
                    attr: s.attr,
                    attrRegex: s.attrRegex,
                    layoutAttributes: s.layoutAttributes,
                    supplyLayoutDefaults: s.supplyLayoutDefaults,
                    drawFramework: s.drawFramework,
                    plot: function(t1) {
                        var e1 = t1._fullLayout, r = i.getModule(u), n = o(t1.calcdata, r)[0];
                        a(t1, [
                            "ANGLE_instanced_arrays",
                            "OES_element_index_uint"
                        ], h) && (e1._hasOnlyLargeSploms && p(t1), r.plot(t1, {}, n));
                    },
                    drag: function(t1) {
                        var e1 = t1.calcdata, r = t1._fullLayout;
                        r._hasOnlyLargeSploms && p(t1);
                        for(var n = 0; n < e1.length; n++){
                            var i = e1[n][0].trace, a = r._splomScenes[i.uid];
                            "splom" === i.type && a && a.matrix && f(t1, i, a);
                        }
                    },
                    updateGrid: p,
                    clean: function(t1, e1, r, n) {
                        var i, a = {};
                        if (n._splomScenes) {
                            for(i = 0; i < t1.length; i++){
                                var o = t1[i];
                                "splom" === o.type && (a[o.uid] = 1);
                            }
                            for(i = 0; i < r.length; i++){
                                var l = r[i];
                                if (!a[l.uid]) {
                                    var c = n._splomScenes[l.uid];
                                    c && c.destroy && c.destroy(), n._splomScenes[l.uid] = null, delete n._splomScenes[l.uid];
                                }
                            }
                        }
                        0 === Object.keys(n._splomScenes || {}).length && delete n._splomScenes, n._splomGrid && !e1._hasOnlyLargeSploms && n._hasOnlyLargeSploms && (n._splomGrid.destroy(), n._splomGrid = null, delete n._splomGrid), s.clean(t1, e1, r, n);
                    },
                    updateFx: s.updateFx,
                    toSVG: s.toSVG,
                    reglPrecompiled: h
                };
            },
            55325: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(5975), a = r(26544).calcMarkerSize, o = r(26544).calcAxisExpansion, s = r(77272), l = r(19937).markerSelection, c = r(19937).markerStyle, u = r(78880), h = r(63821).BADNUM, f = r(29483).TOO_MANY_POINTS;
                t1.exports = function(t1, e1) {
                    var r, p, d, m, g, y, v = e1.dimensions, x = e1._length, _ = {}, b = _.cdata = [], w = _.data = [], T = e1._visibleDims = [];
                    function k(t1, r) {
                        for(var i = t1.makeCalcdata({
                            v: r.values,
                            vcalendar: e1.calendar
                        }, "v"), a = 0; a < i.length; a++)i[a] = i[a] === h ? NaN : i[a];
                        b.push(i), w.push("log" === t1.type ? n.simpleMap(i, t1.c2l) : i);
                    }
                    for(r = 0; r < v.length; r++)if ((d = v[r]).visible) {
                        if (m = i.getFromId(t1, e1._diag[r][0]), g = i.getFromId(t1, e1._diag[r][1]), m && g && m.type !== g.type) {
                            n.log("Skipping splom dimension " + r + " with conflicting axis types");
                            continue;
                        }
                        m ? (k(m, d), g && "category" === g.type && (g._categories = m._categories.slice())) : k(g, d), T.push(r);
                    }
                    for(s(t1, e1), n.extendFlat(_, c(t1, e1)), y = b.length * x > f ? _.sizeAvg || Math.max(_.size, 3) : a(e1, x), p = 0; p < T.length; p++)d = v[r = T[p]], m = i.getFromId(t1, e1._diag[r][0]) || {}, g = i.getFromId(t1, e1._diag[r][1]) || {}, o(t1, e1, m, g, b[p], b[p], y);
                    var A = u(t1, e1);
                    return A.matrix || (A.matrix = !0), A.matrixOptions = _, A.selectedOptions = l(t1, e1, e1.selected), A.unselectedOptions = l(t1, e1, e1.unselected), [
                        {
                            x: !1,
                            y: !1,
                            t: {},
                            trace: e1
                        }
                    ];
                };
            },
            52542: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(59008), a = r(68697), o = r(64726), s = r(24272), l = r(63197), c = r(4075).isOpenSymbol;
                function u(t1, e1) {
                    function r(r, i) {
                        return n.coerce(t1, e1, a.dimensions, r, i);
                    }
                    r("label");
                    var i = r("values");
                    i && i.length ? r("visible") : e1.visible = !1, r("axis.type"), r("axis.matches");
                }
                t1.exports = function(t1, e1, r, h) {
                    function f(r, i) {
                        return n.coerce(t1, e1, a, r, i);
                    }
                    var p = i(t1, e1, {
                        name: "dimensions",
                        handleItemDefaults: u
                    }), d = f("diagonal.visible"), m = f("showupperhalf"), g = f("showlowerhalf");
                    if (l(e1, p, "values") && (d || m || g)) {
                        f("text"), f("hovertext"), f("hovertemplate"), f("xhoverformat"), f("yhoverformat"), s(t1, e1, r, h, f, {
                            noAngleRef: !0,
                            noStandOff: !0
                        });
                        var y = c(e1.marker.symbol), v = o.isBubble(e1);
                        f("marker.line.width", y || v ? 1 : 0), function(t1, e1, r, n) {
                            var i, a, o = e1.dimensions, s = o.length, l = e1.showupperhalf, c = e1.showlowerhalf, u = e1.diagonal.visible, h = new Array(s), f = new Array(s);
                            for(i = 0; i < s; i++){
                                var p = i ? i + 1 : "";
                                h[i] = "x" + p, f[i] = "y" + p;
                            }
                            var d = n("xaxes", h), m = n("yaxes", f), g = e1._diag = new Array(s);
                            e1._xaxes = {}, e1._yaxes = {};
                            var y = [], v = [];
                            function x(t1, n, i, a) {
                                if (t1) {
                                    var o = t1.charAt(0), s = r._splomAxes[o];
                                    if (e1["_" + o + "axes"][t1] = 1, a.push(t1), !(t1 in s)) {
                                        var l = s[t1] = {};
                                        i && (l.label = i.label || "", i.visible && i.axis && (i.axis.type && (l.type = i.axis.type), i.axis.matches && (l.matches = n)));
                                    }
                                }
                            }
                            var _ = !u && !c, b = !u && !l;
                            for(e1._axesDim = {}, i = 0; i < s; i++){
                                var w = o[i], T = 0 === i, k = i === s - 1, A = T && _ || k && b ? void 0 : d[i], M = T && b || k && _ ? void 0 : m[i];
                                x(A, M, w, y), x(M, A, w, v), g[i] = [
                                    A,
                                    M
                                ], e1._axesDim[A] = i, e1._axesDim[M] = i;
                            }
                            for(i = 0; i < y.length; i++)for(a = 0; a < v.length; a++){
                                var S = y[i] + v[a];
                                i > a && l || i < a && c ? r._splomSubplots[S] = 1 : i !== a || !u && c && l || (r._splomSubplots[S] = 1);
                            }
                            (!c || !u && l && c) && (r._splomGridDflt.xside = "bottom", r._splomGridDflt.yside = "left");
                        }(0, e1, h, f), n.coerceSelectionMarkerOpacity(e1, f);
                    } else e1.visible = !1;
                };
            },
            27926: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(77272), a = r(19937).markerStyle;
                t1.exports = function(t1, e1) {
                    var r = e1.trace, o = t1._fullLayout._splomScenes[r.uid];
                    if (o) {
                        i(t1, r), n.extendFlat(o.matrixOptions, a(t1, r));
                        var s = n.extendFlat({}, o.matrixOptions, o.viewOpts);
                        o.matrix.update(s, null);
                    }
                };
            },
            52875: function(t1, e1) {
                "use strict";
                e1.getDimIndex = function(t1, e1) {
                    for(var r = e1._id, n = {
                        x: 0,
                        y: 1
                    }[r.charAt(0)], i = t1._visibleDims, a = 0; a < i.length; a++){
                        var o = i[a];
                        if (t1._diag[o][n] === r) return a;
                    }
                    return !1;
                };
            },
            25600: function(t1, e1, r) {
                "use strict";
                var n = r(52875), i = r(36544).calcHover, a = r(29714).getFromId, o = r(93049).extendFlat;
                function s(t1, e1, r, a) {
                    var o = t1.cd[0].trace, s = t1.scene.matrixOptions.cdata, l = t1.xa, c = t1.ya, u = l.c2p(e1), h = c.c2p(r), f = t1.distance, p = n.getDimIndex(o, l), d = n.getDimIndex(o, c);
                    if (!1 === p || !1 === d) return [
                        t1
                    ];
                    for(var m, g, y = s[p], v = s[d], x = f, _ = 0; _ < y.length; _++)if (!a || _ === t1.index) {
                        var b = y[_], w = v[_], T = l.c2p(b) - u, k = c.c2p(w) - h, A = Math.sqrt(T * T + k * k);
                        (a || A < x) && (x = g = A, m = _);
                    }
                    return t1.index = m, t1.distance = x, t1.dxy = g, void 0 === m ? [
                        t1
                    ] : [
                        i(t1, y, v, o)
                    ];
                }
                t1.exports = {
                    hoverPoints: function(t1, e1, r, n, i) {
                        i || (i = {});
                        var l = "x" === (n || "").charAt(0), c = "y" === (n || "").charAt(0), u = s(t1, e1, r);
                        if ((l || c) && "axis" === i.hoversubplots && u[0]) for(var h = (l ? t1.xa : t1.ya)._subplotsWith, f = i.gd, p = o({}, t1), d = 0; d < h.length; d++){
                            var m = h[d];
                            if (m !== t1.xa._id + t1.ya._id) {
                                c ? p.xa = a(f, m, "x") : p.ya = a(f, m, "y");
                                var g = s(p, e1, r, l || c);
                                u = u.concat(g);
                            }
                        }
                        return u;
                    }
                };
            },
            91450: function(t1, e1, r) {
                "use strict";
                var n = r(86690);
                n.basePlotModule = r(571), t1.exports = n;
            },
            83027: function(t1, e1, r) {
                "use strict";
                var n = r(31239), i = r(34809), a = r(5975), o = r(70414).selectMode;
                function s(t1, e1) {
                    var r, s, l, c, u, h = t1._fullLayout, f = h._size, p = e1.trace, d = e1.t, m = h._splomScenes[p.uid], g = m.matrixOptions, y = g.cdata, v = h._glcanvas.data()[0].regl, x = h.dragmode;
                    if (0 !== y.length) {
                        g.lower = p.showupperhalf, g.upper = p.showlowerhalf, g.diagonal = p.diagonal.visible;
                        var _ = p._visibleDims, b = y.length, w = m.viewOpts = {};
                        for(w.ranges = new Array(b), w.domains = new Array(b), u = 0; u < _.length; u++){
                            l = _[u];
                            var T = w.ranges[u] = new Array(4), k = w.domains[u] = new Array(4);
                            (r = a.getFromId(t1, p._diag[l][0])) && (T[0] = r._rl[0], T[2] = r._rl[1], k[0] = r.domain[0], k[2] = r.domain[1]), (s = a.getFromId(t1, p._diag[l][1])) && (T[1] = s._rl[0], T[3] = s._rl[1], k[1] = s.domain[0], k[3] = s.domain[1]);
                        }
                        var A = t1._context.plotGlPixelRatio, M = f.l * A, S = f.b * A, E = f.w * A, C = f.h * A;
                        w.viewport = [
                            M,
                            S,
                            E + M,
                            C + S
                        ], !0 === m.matrix && (m.matrix = n(v));
                        var L = h.clickmode.indexOf("select") > -1, I = !0;
                        if (o(x) || p.selectedpoints || L) {
                            var P = p._length;
                            if (p.selectedpoints) {
                                m.selectBatch = p.selectedpoints;
                                var z = p.selectedpoints, O = {};
                                for(l = 0; l < z.length; l++)O[z[l]] = !0;
                                var D = [];
                                for(l = 0; l < P; l++)O[l] || D.push(l);
                                m.unselectBatch = D;
                            }
                            var R = d.xpx = new Array(b), F = d.ypx = new Array(b);
                            for(u = 0; u < _.length; u++){
                                if (l = _[u], r = a.getFromId(t1, p._diag[l][0])) for(R[u] = new Array(P), c = 0; c < P; c++)R[u][c] = r.c2p(y[u][c]);
                                if (s = a.getFromId(t1, p._diag[l][1])) for(F[u] = new Array(P), c = 0; c < P; c++)F[u][c] = s.c2p(y[u][c]);
                            }
                            if (m.selectBatch.length || m.unselectBatch.length) {
                                var B = i.extendFlat({}, g, m.unselectedOptions, w), N = i.extendFlat({}, g, m.selectedOptions, w);
                                m.matrix.update(B, N), I = !1;
                            }
                        } else d.xpx = d.ypx = null;
                        if (I) {
                            var j = i.extendFlat({}, g, w);
                            m.matrix.update(j, null);
                        }
                    }
                }
                t1.exports = function(t1, e1, r) {
                    if (r.length) for(var n = 0; n < r.length; n++)s(t1, r[n][0]);
                };
            },
            78880: function(t1, e1, r) {
                "use strict";
                var n = r(34809);
                t1.exports = function(t1, e1) {
                    var r = t1._fullLayout, i = e1.uid, a = r._splomScenes;
                    a || (a = r._splomScenes = {});
                    var o = {
                        dirty: !0,
                        selectBatch: [],
                        unselectBatch: []
                    }, s = a[e1.uid];
                    return s || ((s = a[i] = n.extendFlat({}, o, {
                        matrix: !1,
                        selectBatch: [],
                        unselectBatch: []
                    })).draw = function() {
                        s.matrix && s.matrix.draw && (s.selectBatch.length || s.unselectBatch.length ? s.matrix.draw(s.unselectBatch, s.selectBatch) : s.matrix.draw()), s.dirty = !1;
                    }, s.destroy = function() {
                        s.matrix && s.matrix.destroy && s.matrix.destroy(), s.matrixOptions = null, s.selectBatch = null, s.unselectBatch = null, s = null;
                    }), s.dirty || n.extendFlat(s, o), s;
                };
            },
            13392: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = n.pushUnique, a = r(64726), o = r(52875);
                t1.exports = function(t1, e1) {
                    var r = t1.cd, s = r[0].trace, l = r[0].t, c = t1.scene, u = c.matrixOptions.cdata, h = t1.xaxis, f = t1.yaxis, p = [];
                    if (!c) return p;
                    var d = !a.hasMarkers(s) && !a.hasText(s);
                    if (!0 !== s.visible || d) return p;
                    var m = o.getDimIndex(s, h), g = o.getDimIndex(s, f);
                    if (!1 === m || !1 === g) return p;
                    var y = l.xpx[m], v = l.ypx[g], x = u[m], _ = u[g], b = (t1.scene.selectBatch || []).slice(), w = [];
                    if (!1 !== e1 && !e1.degenerate) for(var T = 0; T < x.length; T++)e1.contains([
                        y[T],
                        v[T]
                    ], null, T, t1) ? (p.push({
                        pointNumber: T,
                        x: x[T],
                        y: _[T]
                    }), i(b, T)) : -1 !== b.indexOf(T) ? i(b, T) : w.push(T);
                    var k = c.matrixOptions;
                    return b.length || w.length ? c.selectBatch.length || c.unselectBatch.length || c.matrix.update(c.unselectedOptions, n.extendFlat({}, k, c.selectedOptions, c.viewOpts)) : c.matrix.update(k, null), c.selectBatch = b, c.unselectBatch = w, p;
                };
            },
            14774: function(t1, e1, r) {
                "use strict";
                var n = r(87163), i = r(80712).axisHoverFormat, a = r(3208).rb, o = r(42450), s = r(9829), l = r(93049).extendFlat, c = {
                    x: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    y: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    z: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    u: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    v: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    w: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    starts: {
                        x: {
                            valType: "data_array",
                            editType: "calc"
                        },
                        y: {
                            valType: "data_array",
                            editType: "calc"
                        },
                        z: {
                            valType: "data_array",
                            editType: "calc"
                        },
                        editType: "calc"
                    },
                    maxdisplayed: {
                        valType: "integer",
                        min: 0,
                        dflt: 1e3,
                        editType: "calc"
                    },
                    sizeref: {
                        valType: "number",
                        editType: "calc",
                        min: 0,
                        dflt: 1
                    },
                    text: {
                        valType: "string",
                        dflt: "",
                        editType: "calc"
                    },
                    hovertext: {
                        valType: "string",
                        dflt: "",
                        editType: "calc"
                    },
                    hovertemplate: a({
                        editType: "calc"
                    }, {
                        keys: [
                            "tubex",
                            "tubey",
                            "tubez",
                            "tubeu",
                            "tubev",
                            "tubew",
                            "norm",
                            "divergence"
                        ]
                    }),
                    uhoverformat: i("u", 1),
                    vhoverformat: i("v", 1),
                    whoverformat: i("w", 1),
                    xhoverformat: i("x"),
                    yhoverformat: i("y"),
                    zhoverformat: i("z"),
                    showlegend: l({}, s.showlegend, {
                        dflt: !1
                    })
                };
                l(c, n("", {
                    colorAttr: "u/v/w norm",
                    showScaleDflt: !0,
                    editTypeOverride: "calc"
                })), [
                    "opacity",
                    "lightposition",
                    "lighting"
                ].forEach(function(t1) {
                    c[t1] = o[t1];
                }), c.hoverinfo = l({}, s.hoverinfo, {
                    editType: "calc",
                    flags: [
                        "x",
                        "y",
                        "z",
                        "u",
                        "v",
                        "w",
                        "norm",
                        "divergence",
                        "text",
                        "name"
                    ],
                    dflt: "x+y+z+norm+text+name"
                }), c.transforms = void 0, t1.exports = c;
            },
            36402: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(28379);
                function a(t1) {
                    var e1, r, i, a, s, l, c, u, h, f, p, d, m = t1._x, g = t1._y, y = t1._z, v = t1._len, x = -1 / 0, _ = 1 / 0, b = -1 / 0, w = 1 / 0, T = -1 / 0, k = 1 / 0, A = "";
                    for(v && (c = m[0], h = g[0], p = y[0]), v > 1 && (u = m[v - 1], f = g[v - 1], d = y[v - 1]), e1 = 0; e1 < v; e1++)x = Math.max(x, m[e1]), _ = Math.min(_, m[e1]), b = Math.max(b, g[e1]), w = Math.min(w, g[e1]), T = Math.max(T, y[e1]), k = Math.min(k, y[e1]), a || m[e1] === c || (a = !0, A += "x"), s || g[e1] === h || (s = !0, A += "y"), l || y[e1] === p || (l = !0, A += "z");
                    a || (A += "x"), s || (A += "y"), l || (A += "z");
                    var M = o(t1._x), S = o(t1._y), E = o(t1._z);
                    A = (A = (A = A.replace("x", (c > u ? "-" : "+") + "x")).replace("y", (h > f ? "-" : "+") + "y")).replace("z", (p > d ? "-" : "+") + "z");
                    var C = function() {
                        v = 0, M = [], S = [], E = [];
                    };
                    (!v || v < M.length * S.length * E.length) && C();
                    var L = function(t1) {
                        return "x" === t1 ? m : "y" === t1 ? g : y;
                    }, I = function(t1) {
                        return "x" === t1 ? M : "y" === t1 ? S : E;
                    }, P = function(t1) {
                        return t1[v - 1] < t1[0] ? -1 : 1;
                    }, z = L(A[1]), O = L(A[3]), D = L(A[5]), R = I(A[1]).length, F = I(A[3]).length, B = I(A[5]).length, N = !1, j = function(t1, e1, r) {
                        return R * (F * t1 + e1) + r;
                    }, U = P(L(A[1])), V = P(L(A[3])), q = P(L(A[5]));
                    for(e1 = 0; e1 < B - 1; e1++){
                        for(r = 0; r < F - 1; r++){
                            for(i = 0; i < R - 1; i++){
                                var H = j(e1, r, i), G = j(e1, r, i + 1), Z = j(e1, r + 1, i), W = j(e1 + 1, r, i);
                                if (z[H] * U < z[G] * U && O[H] * V < O[Z] * V && D[H] * q < D[W] * q || (N = !0), N) break;
                            }
                            if (N) break;
                        }
                        if (N) break;
                    }
                    return N && (n.warn("Encountered arbitrary coordinates! Unable to input data grid."), C()), {
                        xMin: _,
                        yMin: w,
                        zMin: k,
                        xMax: x,
                        yMax: b,
                        zMax: T,
                        Xs: M,
                        Ys: S,
                        Zs: E,
                        len: v,
                        fill: A
                    };
                }
                function o(t1) {
                    return n.distinctVals(t1).vals;
                }
                function s(t1, e1) {
                    if (void 0 === e1 && (e1 = t1.length), n.isTypedArray(t1)) return t1.subarray(0, e1);
                    for(var r = [], i = 0; i < e1; i++)r[i] = +t1[i];
                    return r;
                }
                t1.exports = {
                    calc: function(t1, e1) {
                        e1._len = Math.min(e1.u.length, e1.v.length, e1.w.length, e1.x.length, e1.y.length, e1.z.length), e1._u = s(e1.u, e1._len), e1._v = s(e1.v, e1._len), e1._w = s(e1.w, e1._len), e1._x = s(e1.x, e1._len), e1._y = s(e1.y, e1._len), e1._z = s(e1.z, e1._len);
                        var r = a(e1);
                        e1._gridFill = r.fill, e1._Xs = r.Xs, e1._Ys = r.Ys, e1._Zs = r.Zs, e1._len = r.len;
                        var n, o, l, c = 0;
                        e1.starts && (n = s(e1.starts.x || []), o = s(e1.starts.y || []), l = s(e1.starts.z || []), c = Math.min(n.length, o.length, l.length)), e1._startsX = n || [], e1._startsY = o || [], e1._startsZ = l || [];
                        var u, h = 0, f = 1 / 0;
                        for(u = 0; u < e1._len; u++){
                            var p = e1._u[u], d = e1._v[u], m = e1._w[u], g = Math.sqrt(p * p + d * d + m * m);
                            h = Math.max(h, g), f = Math.min(f, g);
                        }
                        for(i(t1, e1, {
                            vals: [
                                f,
                                h
                            ],
                            containerStr: "",
                            cLetter: "c"
                        }), u = 0; u < c; u++){
                            var y = n[u];
                            r.xMax = Math.max(r.xMax, y), r.xMin = Math.min(r.xMin, y);
                            var v = o[u];
                            r.yMax = Math.max(r.yMax, v), r.yMin = Math.min(r.yMin, v);
                            var x = l[u];
                            r.zMax = Math.max(r.zMax, x), r.zMin = Math.min(r.zMin, x);
                        }
                        e1._slen = c, e1._normMax = h, e1._xbnds = [
                            r.xMin,
                            r.xMax
                        ], e1._ybnds = [
                            r.yMin,
                            r.yMax
                        ], e1._zbnds = [
                            r.zMin,
                            r.zMax
                        ];
                    },
                    filter: s,
                    processGrid: a
                };
            },
            49280: function(t1, e1, r) {
                "use strict";
                var n = r(99098).gl_streamtube3d, i = n.createTubeMesh, a = r(34809), o = r(46998).parseColorScale, s = r(88856).extractOpts, l = r(88239), c = {
                    xaxis: 0,
                    yaxis: 1,
                    zaxis: 2
                };
                function u(t1, e1) {
                    this.scene = t1, this.uid = e1, this.mesh = null, this.data = null;
                }
                var h = u.prototype;
                function f(t1) {
                    var e1 = t1.length;
                    return e1 > 2 ? t1.slice(1, e1 - 1) : 2 === e1 ? [
                        (t1[0] + t1[1]) / 2
                    ] : t1;
                }
                function p(t1) {
                    var e1 = t1.length;
                    return 1 === e1 ? [
                        .5,
                        .5
                    ] : [
                        t1[1] - t1[0],
                        t1[e1 - 1] - t1[e1 - 2]
                    ];
                }
                function d(t1, e1) {
                    var r = t1.fullSceneLayout, i = t1.dataScale, u = e1._len, h = {};
                    function d(t1, e1) {
                        var n = r[e1], o = i[c[e1]];
                        return a.simpleMap(t1, function(t1) {
                            return n.d2l(t1) * o;
                        });
                    }
                    if (h.vectors = l(d(e1._u, "xaxis"), d(e1._v, "yaxis"), d(e1._w, "zaxis"), u), !u) return {
                        positions: [],
                        cells: []
                    };
                    var m = d(e1._Xs, "xaxis"), g = d(e1._Ys, "yaxis"), y = d(e1._Zs, "zaxis");
                    if (h.meshgrid = [
                        m,
                        g,
                        y
                    ], h.gridFill = e1._gridFill, e1._slen) h.startingPositions = l(d(e1._startsX, "xaxis"), d(e1._startsY, "yaxis"), d(e1._startsZ, "zaxis"));
                    else {
                        for(var v = g[0], x = f(m), _ = f(y), b = new Array(x.length * _.length), w = 0, T = 0; T < x.length; T++)for(var k = 0; k < _.length; k++)b[w++] = [
                            x[T],
                            v,
                            _[k]
                        ];
                        h.startingPositions = b;
                    }
                    h.colormap = o(e1), h.tubeSize = e1.sizeref, h.maxLength = e1.maxdisplayed;
                    var A = d(e1._xbnds, "xaxis"), M = d(e1._ybnds, "yaxis"), S = d(e1._zbnds, "zaxis"), E = p(m), C = p(g), L = p(y), I = [
                        [
                            A[0] - E[0],
                            M[0] - C[0],
                            S[0] - L[0]
                        ],
                        [
                            A[1] + E[1],
                            M[1] + C[1],
                            S[1] + L[1]
                        ]
                    ], P = n(h, I), z = s(e1);
                    P.vertexIntensityBounds = [
                        z.min / e1._normMax,
                        z.max / e1._normMax
                    ];
                    var O = e1.lightposition;
                    return P.lightPosition = [
                        O.x,
                        O.y,
                        O.z
                    ], P.ambient = e1.lighting.ambient, P.diffuse = e1.lighting.diffuse, P.specular = e1.lighting.specular, P.roughness = e1.lighting.roughness, P.fresnel = e1.lighting.fresnel, P.opacity = e1.opacity, e1._pad = P.tubeScale * e1.sizeref * 2, P;
                }
                h.handlePick = function(t1) {
                    var e1 = this.scene.fullSceneLayout, r = this.scene.dataScale;
                    function n(t1, n) {
                        var i = e1[n], a = r[c[n]];
                        return i.l2c(t1) / a;
                    }
                    if (t1.object === this.mesh) {
                        var i = t1.data.position, a = t1.data.velocity;
                        return t1.traceCoordinate = [
                            n(i[0], "xaxis"),
                            n(i[1], "yaxis"),
                            n(i[2], "zaxis"),
                            n(a[0], "xaxis"),
                            n(a[1], "yaxis"),
                            n(a[2], "zaxis"),
                            t1.data.intensity * this.data._normMax,
                            t1.data.divergence
                        ], t1.textLabel = this.data.hovertext || this.data.text, !0;
                    }
                }, h.update = function(t1) {
                    this.data = t1;
                    var e1 = d(this.scene, t1);
                    this.mesh.update(e1);
                }, h.dispose = function() {
                    this.scene.glplot.remove(this.mesh), this.mesh.dispose();
                }, t1.exports = function(t1, e1) {
                    var r = t1.glplot.gl, n = d(t1, e1), a = i(r, n), o = new u(t1, e1.uid);
                    return o.mesh = a, o.data = e1, a._trace = o, t1.glplot.add(a), o;
                };
            },
            52737: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(39356), a = r(14774);
                t1.exports = function(t1, e1, r, o) {
                    function s(r, i) {
                        return n.coerce(t1, e1, a, r, i);
                    }
                    var l = s("u"), c = s("v"), u = s("w"), h = s("x"), f = s("y"), p = s("z");
                    l && l.length && c && c.length && u && u.length && h && h.length && f && f.length && p && p.length ? (s("starts.x"), s("starts.y"), s("starts.z"), s("maxdisplayed"), s("sizeref"), s("lighting.ambient"), s("lighting.diffuse"), s("lighting.specular"), s("lighting.roughness"), s("lighting.fresnel"), s("lightposition.x"), s("lightposition.y"), s("lightposition.z"), i(t1, e1, o, s, {
                        prefix: "",
                        cLetter: "c"
                    }), s("text"), s("hovertext"), s("hovertemplate"), s("uhoverformat"), s("vhoverformat"), s("whoverformat"), s("xhoverformat"), s("yhoverformat"), s("zhoverformat"), e1._length = null) : e1.visible = !1;
                };
            },
            51943: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    moduleType: "trace",
                    name: "streamtube",
                    basePlotModule: r(2487),
                    categories: [
                        "gl3d",
                        "showLegend"
                    ],
                    attributes: r(14774),
                    supplyDefaults: r(52737),
                    colorbar: {
                        min: "cmin",
                        max: "cmax"
                    },
                    calc: r(36402).calc,
                    plot: r(49280),
                    eventData: function(t1, e1) {
                        return t1.tubex = t1.x, t1.tubey = t1.y, t1.tubez = t1.z, t1.tubeu = e1.traceCoordinate[3], t1.tubev = e1.traceCoordinate[4], t1.tubew = e1.traceCoordinate[5], t1.norm = e1.traceCoordinate[6], t1.divergence = e1.traceCoordinate[7], delete t1.x, delete t1.y, delete t1.z, t1;
                    },
                    meta: {}
                };
            },
            56708: function(t1, e1, r) {
                "use strict";
                var n = r(9829), i = r(3208).rb, a = r(3208).ay, o = r(87163), s = r(13792).u, l = r(55412), c = r(2032), u = r(93049).extendFlat, h = r(94850).k;
                t1.exports = {
                    labels: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    parents: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    values: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    branchvalues: {
                        valType: "enumerated",
                        values: [
                            "remainder",
                            "total"
                        ],
                        dflt: "remainder",
                        editType: "calc"
                    },
                    count: {
                        valType: "flaglist",
                        flags: [
                            "branches",
                            "leaves"
                        ],
                        dflt: "leaves",
                        editType: "calc"
                    },
                    level: {
                        valType: "any",
                        editType: "plot",
                        anim: !0
                    },
                    maxdepth: {
                        valType: "integer",
                        editType: "plot",
                        dflt: -1
                    },
                    marker: u({
                        colors: {
                            valType: "data_array",
                            editType: "calc"
                        },
                        line: {
                            color: u({}, l.marker.line.color, {
                                dflt: null
                            }),
                            width: u({}, l.marker.line.width, {
                                dflt: 1
                            }),
                            editType: "calc"
                        },
                        pattern: h,
                        editType: "calc"
                    }, o("marker", {
                        colorAttr: "colors",
                        anim: !1
                    })),
                    leaf: {
                        opacity: {
                            valType: "number",
                            editType: "style",
                            min: 0,
                            max: 1
                        },
                        editType: "plot"
                    },
                    text: l.text,
                    textinfo: {
                        valType: "flaglist",
                        flags: [
                            "label",
                            "text",
                            "value",
                            "current path",
                            "percent root",
                            "percent entry",
                            "percent parent"
                        ],
                        extras: [
                            "none"
                        ],
                        editType: "plot"
                    },
                    texttemplate: a({
                        editType: "plot"
                    }, {
                        keys: c.eventDataKeys.concat([
                            "label",
                            "value"
                        ])
                    }),
                    hovertext: l.hovertext,
                    hoverinfo: u({}, n.hoverinfo, {
                        flags: [
                            "label",
                            "text",
                            "value",
                            "name",
                            "current path",
                            "percent root",
                            "percent entry",
                            "percent parent"
                        ],
                        dflt: "label+text+value+name"
                    }),
                    hovertemplate: i({}, {
                        keys: c.eventDataKeys
                    }),
                    textfont: l.textfont,
                    insidetextorientation: l.insidetextorientation,
                    insidetextfont: l.insidetextfont,
                    outsidetextfont: u({}, l.outsidetextfont, {}),
                    rotation: {
                        valType: "angle",
                        dflt: 0,
                        editType: "plot"
                    },
                    sort: l.sort,
                    root: {
                        color: {
                            valType: "color",
                            editType: "calc",
                            dflt: "rgba(0,0,0,0)"
                        },
                        editType: "calc"
                    },
                    domain: s({
                        name: "sunburst",
                        trace: !0,
                        editType: "calc"
                    })
                };
            },
            14724: function(t1, e1, r) {
                "use strict";
                var n = r(44122);
                e1.name = "sunburst", e1.plot = function(t1, r, i, a) {
                    n.plotBasePlot(e1.name, t1, r, i, a);
                }, e1.clean = function(t1, r, i, a) {
                    n.cleanBasePlot(e1.name, t1, r, i, a);
                };
            },
            14852: function(t1, e1, r) {
                "use strict";
                var n = r(92264), i = r(10721), a = r(34809), o = r(88856).makeColorScaleFuncFromTrace, s = r(44148).makePullColorFn, l = r(44148).generateExtendedColors, c = r(88856).calc, u = r(63821).ALMOST_EQUAL, h = {}, f = {}, p = {};
                function d(t1, e1, r) {
                    var n = 0, i = t1.children;
                    if (i) {
                        for(var a = i.length, o = 0; o < a; o++)n += d(i[o], e1, r);
                        r.branches && n++;
                    } else r.leaves && n++;
                    return t1.value = t1.data.data.value = n, e1._values || (e1._values = []), e1._values[t1.data.data.i] = n, n;
                }
                e1.calc = function(t1, e1) {
                    var r, l, h, f, p, m, g = t1._fullLayout, y = e1.ids, v = a.isArrayOrTypedArray(y), x = e1.labels, _ = e1.parents, b = e1.values, w = a.isArrayOrTypedArray(b), T = [], k = {}, A = {}, M = function(t1) {
                        return t1 || "number" == typeof t1;
                    }, S = function(t1) {
                        return !w || i(b[t1]) && b[t1] >= 0;
                    };
                    v ? (r = Math.min(y.length, _.length), l = function(t1) {
                        return M(y[t1]) && S(t1);
                    }, h = function(t1) {
                        return String(y[t1]);
                    }) : (r = Math.min(x.length, _.length), l = function(t1) {
                        return M(x[t1]) && S(t1);
                    }, h = function(t1) {
                        return String(x[t1]);
                    }), w && (r = Math.min(r, b.length));
                    for(var E = 0; E < r; E++)if (l(E)) {
                        var C = h(E), L = M(_[E]) ? String(_[E]) : "", I = {
                            i: E,
                            id: C,
                            pid: L,
                            label: M(x[E]) ? String(x[E]) : ""
                        };
                        w && (I.v = +b[E]), T.push(I), p = C, k[f = L] ? k[f].push(p) : k[f] = [
                            p
                        ], A[p] = 1;
                    }
                    if (k[""]) {
                        if (k[""].length > 1) {
                            for(var P = a.randstr(), z = 0; z < T.length; z++)"" === T[z].pid && (T[z].pid = P);
                            T.unshift({
                                hasMultipleRoots: !0,
                                id: P,
                                pid: "",
                                label: ""
                            });
                        }
                    } else {
                        var O, D = [];
                        for(O in k)A[O] || D.push(O);
                        if (1 !== D.length) return a.warn([
                            "Multiple implied roots, cannot build",
                            e1.type,
                            "hierarchy of",
                            e1.name + ".",
                            "These roots include:",
                            D.join(", ")
                        ].join(" "));
                        O = D[0], T.unshift({
                            hasImpliedRoot: !0,
                            id: O,
                            pid: "",
                            label: O
                        });
                    }
                    try {
                        m = n.stratify().id(function(t1) {
                            return t1.id;
                        }).parentId(function(t1) {
                            return t1.pid;
                        })(T);
                    } catch (t1) {
                        return a.warn([
                            "Failed to build",
                            e1.type,
                            "hierarchy of",
                            e1.name + ".",
                            "Error:",
                            t1.message
                        ].join(" "));
                    }
                    var R = n.hierarchy(m), F = !1;
                    if (w) switch(e1.branchvalues){
                        case "remainder":
                            R.sum(function(t1) {
                                return t1.data.v;
                            });
                            break;
                        case "total":
                            R.each(function(t1) {
                                var r = t1.data.data, n = r.v;
                                if (t1.children) {
                                    var i = t1.children.reduce(function(t1, e1) {
                                        return t1 + e1.data.data.v;
                                    }, 0);
                                    if ((r.hasImpliedRoot || r.hasMultipleRoots) && (n = i), n < i * u) return F = !0, a.warn([
                                        "Total value for node",
                                        t1.data.data.id,
                                        "of",
                                        e1.name,
                                        "is smaller than the sum of its children.",
                                        "\nparent value =",
                                        n,
                                        "\nchildren sum =",
                                        i
                                    ].join(" "));
                                }
                                t1.value = n;
                            });
                    }
                    else d(R, e1, {
                        branches: -1 !== e1.count.indexOf("branches"),
                        leaves: -1 !== e1.count.indexOf("leaves")
                    });
                    if (!F) {
                        var B, N;
                        e1.sort && R.sort(function(t1, e1) {
                            return e1.value - t1.value;
                        });
                        var j = e1.marker.colors || [], U = !!j.length;
                        return e1._hasColorscale ? (U || (j = w ? e1.values : e1._values), c(t1, e1, {
                            vals: j,
                            containerStr: "marker",
                            cLetter: "c"
                        }), N = o(e1.marker)) : B = s(g["_" + e1.type + "colormap"]), R.each(function(t1) {
                            var r = t1.data.data;
                            r.color = e1._hasColorscale ? N(j[r.i]) : B(j[r.i], r.id);
                        }), T[0].hierarchy = R, T;
                    }
                }, e1._runCrossTraceCalc = function(t1, e1) {
                    var r = e1._fullLayout, n = e1.calcdata, i = r[t1 + "colorway"], a = r["_" + t1 + "colormap"];
                    r["extend" + t1 + "colors"] && (i = l(i, "icicle" === t1 ? p : "treemap" === t1 ? f : h));
                    var o, s = 0;
                    function c(t1) {
                        var e1 = t1.data.data, r = e1.id;
                        !1 === e1.color && (a[r] ? e1.color = a[r] : t1.parent ? t1.parent.parent ? e1.color = t1.parent.data.data.color : (a[r] = e1.color = i[s % i.length], s++) : e1.color = o);
                    }
                    for(var u = 0; u < n.length; u++){
                        var d = n[u][0];
                        d.trace.type === t1 && d.hierarchy && (o = d.trace.root.color, d.hierarchy.each(c));
                    }
                }, e1.crossTraceCalc = function(t1) {
                    return e1._runCrossTraceCalc("sunburst", t1);
                };
            },
            2032: function(t1) {
                "use strict";
                t1.exports = {
                    CLICK_TRANSITION_TIME: 750,
                    CLICK_TRANSITION_EASING: "linear",
                    eventDataKeys: [
                        "currentPath",
                        "root",
                        "entry",
                        "percentRoot",
                        "percentEntry",
                        "percentParent"
                    ]
                };
            },
            33459: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(56708), a = r(13792).N, o = r(17550).handleText, s = r(46979).handleMarkerDefaults, l = r(88856), c = l.hasColorscale, u = l.handleDefaults;
                t1.exports = function(t1, e1, r, l) {
                    function h(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    var f = h("labels"), p = h("parents");
                    if (f && f.length && p && p.length) {
                        var d = h("values");
                        d && d.length ? h("branchvalues") : h("count"), h("level"), h("maxdepth"), s(t1, e1, l, h);
                        var m = e1._hasColorscale = c(t1, "marker", "colors") || (t1.marker || {}).coloraxis;
                        m && u(t1, e1, l, h, {
                            prefix: "marker.",
                            cLetter: "c"
                        }), h("leaf.opacity", m ? 1 : .7);
                        var g = h("text");
                        h("texttemplate"), e1.texttemplate || h("textinfo", n.isArrayOrTypedArray(g) ? "text+label" : "label"), h("hovertext"), h("hovertemplate"), o(t1, e1, l, h, "auto", {
                            moduleHasSelected: !1,
                            moduleHasUnselected: !1,
                            moduleHasConstrain: !1,
                            moduleHasCliponaxis: !1,
                            moduleHasTextangle: !1,
                            moduleHasInsideanchor: !1
                        }), h("insidetextorientation"), h("sort"), h("rotation"), h("root.color"), a(e1, l, h), e1._length = null;
                    } else e1.visible = !1;
                };
            },
            72043: function(t1, e1, r) {
                "use strict";
                var n = r(62203), i = r(78766);
                t1.exports = function(t1, e1, r, a, o) {
                    var s = e1.data.data, l = s.i, c = o || s.color;
                    if (l >= 0) {
                        e1.i = s.i;
                        var u = r.marker;
                        u.pattern && u.colors && u.pattern.shape || (u.color = c, e1.color = c), n.pointStyle(t1, r, a, e1);
                    } else i.fill(t1, c);
                };
            },
            44691: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(33626), a = r(36040).appendArrayPointValue, o = r(32141), s = r(34809), l = r(68596), c = r(33108), u = r(37252).formatPieValue;
                function h(t1, e1, r) {
                    for(var n = t1.data.data, i = {
                        curveNumber: e1.index,
                        pointNumber: n.i,
                        data: e1._input,
                        fullData: e1
                    }, o = 0; o < r.length; o++){
                        var s = r[o];
                        s in t1 && (i[s] = t1[s]);
                    }
                    return "parentString" in t1 && !c.isHierarchyRoot(t1) && (i.parent = t1.parentString), a(i, e1, n.i), i;
                }
                t1.exports = function(t1, e1, r, a, f) {
                    var p = a[0], d = p.trace, m = p.hierarchy, g = "sunburst" === d.type, y = "treemap" === d.type || "icicle" === d.type;
                    "_hasHoverLabel" in d || (d._hasHoverLabel = !1), "_hasHoverEvent" in d || (d._hasHoverEvent = !1), t1.on("mouseover", function(i) {
                        var a = r._fullLayout;
                        if (!r._dragging && !1 !== a.hovermode) {
                            var l, v = r._fullData[d.index], x = i.data.data, _ = x.i, b = c.isHierarchyRoot(i), w = c.getParent(m, i), T = c.getValue(i), k = function(t1) {
                                return s.castOption(v, _, t1);
                            }, A = k("hovertemplate"), M = o.castHoverinfo(v, a, _), S = a.separators;
                            if (A || M && "none" !== M && "skip" !== M) {
                                var E, C;
                                g && (E = p.cx + i.pxmid[0] * (1 - i.rInscribed), C = p.cy + i.pxmid[1] * (1 - i.rInscribed)), y && (E = i._hoverX, C = i._hoverY);
                                var L, I = {}, P = [], z = [], O = function(t1) {
                                    return -1 !== P.indexOf(t1);
                                };
                                M && (P = "all" === M ? v._module.attributes.hoverinfo.flags : M.split("+")), I.label = x.label, O("label") && I.label && z.push(I.label), x.hasOwnProperty("v") && (I.value = x.v, I.valueLabel = u(I.value, S), O("value") && z.push(I.valueLabel)), I.currentPath = i.currentPath = c.getPath(i.data), O("current path") && !b && z.push(I.currentPath);
                                var D = [], R = function() {
                                    -1 === D.indexOf(L) && (z.push(L), D.push(L));
                                };
                                I.percentParent = i.percentParent = T / c.getValue(w), I.parent = i.parentString = c.getPtLabel(w), O("percent parent") && (L = c.formatPercent(I.percentParent, S) + " of " + I.parent, R()), I.percentEntry = i.percentEntry = T / c.getValue(e1), I.entry = i.entry = c.getPtLabel(e1), !O("percent entry") || b || i.onPathbar || (L = c.formatPercent(I.percentEntry, S) + " of " + I.entry, R()), I.percentRoot = i.percentRoot = T / c.getValue(m), I.root = i.root = c.getPtLabel(m), O("percent root") && !b && (L = c.formatPercent(I.percentRoot, S) + " of " + I.root, R()), I.text = k("hovertext") || k("text"), O("text") && (L = I.text, s.isValidTextValue(L) && z.push(L)), l = [
                                    h(i, v, f.eventDataKeys)
                                ];
                                var F = {
                                    trace: v,
                                    y: C,
                                    _x0: i._x0,
                                    _x1: i._x1,
                                    _y0: i._y0,
                                    _y1: i._y1,
                                    text: z.join("<br>"),
                                    name: A || O("name") ? v.name : void 0,
                                    color: k("hoverlabel.bgcolor") || x.color,
                                    borderColor: k("hoverlabel.bordercolor"),
                                    fontFamily: k("hoverlabel.font.family"),
                                    fontSize: k("hoverlabel.font.size"),
                                    fontColor: k("hoverlabel.font.color"),
                                    fontWeight: k("hoverlabel.font.weight"),
                                    fontStyle: k("hoverlabel.font.style"),
                                    fontVariant: k("hoverlabel.font.variant"),
                                    nameLength: k("hoverlabel.namelength"),
                                    textAlign: k("hoverlabel.align"),
                                    hovertemplate: A,
                                    hovertemplateLabels: I,
                                    eventData: l
                                };
                                g && (F.x0 = E - i.rInscribed * i.rpx1, F.x1 = E + i.rInscribed * i.rpx1, F.idealAlign = i.pxmid[0] < 0 ? "left" : "right"), y && (F.x = E, F.idealAlign = E < 0 ? "left" : "right");
                                var B = [];
                                o.loneHover(F, {
                                    container: a._hoverlayer.node(),
                                    outerContainer: a._paper.node(),
                                    gd: r,
                                    inOut_bbox: B
                                }), l[0].bbox = B[0], d._hasHoverLabel = !0;
                            }
                            if (y) {
                                var N = t1.select("path.surface");
                                f.styleOne(N, i, v, r, {
                                    hovered: !0
                                });
                            }
                            d._hasHoverEvent = !0, r.emit("plotly_hover", {
                                points: l || [
                                    h(i, v, f.eventDataKeys)
                                ],
                                event: n.event
                            });
                        }
                    }), t1.on("mouseout", function(e1) {
                        var i = r._fullLayout, a = r._fullData[d.index], s = n.select(this).datum();
                        if (d._hasHoverEvent && (e1.originalEvent = n.event, r.emit("plotly_unhover", {
                            points: [
                                h(s, a, f.eventDataKeys)
                            ],
                            event: n.event
                        }), d._hasHoverEvent = !1), d._hasHoverLabel && (o.loneUnhover(i._hoverlayer.node()), d._hasHoverLabel = !1), y) {
                            var l = t1.select("path.surface");
                            f.styleOne(l, s, a, r, {
                                hovered: !1
                            });
                        }
                    }), t1.on("click", function(t1) {
                        var e1 = r._fullLayout, a = r._fullData[d.index], s = g && (c.isHierarchyRoot(t1) || c.isLeaf(t1)), u = c.getPtId(t1), p = c.isEntry(t1) ? c.findEntryWithChild(m, u) : c.findEntryWithLevel(m, u), y = c.getPtId(p), v = {
                            points: [
                                h(t1, a, f.eventDataKeys)
                            ],
                            event: n.event
                        };
                        s || (v.nextLevel = y);
                        var x = l.triggerHandler(r, "plotly_" + d.type + "click", v);
                        if (!1 !== x && e1.hovermode && (r._hoverdata = [
                            h(t1, a, f.eventDataKeys)
                        ], o.click(r, n.event)), !s && !1 !== x && !r._dragging && !r._transitioning) {
                            i.call("_storeDirectGUIEdit", a, e1._tracePreGUI[a.uid], {
                                level: a.level
                            });
                            var _ = {
                                data: [
                                    {
                                        level: y
                                    }
                                ],
                                traces: [
                                    d.index
                                ]
                            }, b = {
                                frame: {
                                    redraw: !1,
                                    duration: f.transitionTime
                                },
                                transition: {
                                    duration: f.transitionTime,
                                    easing: f.transitionEasing
                                },
                                mode: "immediate",
                                fromcurrent: !0
                            };
                            o.loneUnhover(e1._hoverlayer.node()), i.call("animate", r, _, b);
                        }
                    });
                };
            },
            33108: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(78766), a = r(27983), o = r(37252);
                function s(t1) {
                    return t1.data.data.pid;
                }
                e1.findEntryWithLevel = function(t1, r) {
                    var n;
                    return r && t1.eachAfter(function(t1) {
                        if (e1.getPtId(t1) === r) return n = t1.copy();
                    }), n || t1;
                }, e1.findEntryWithChild = function(t1, r) {
                    var n;
                    return t1.eachAfter(function(t1) {
                        for(var i = t1.children || [], a = 0; a < i.length; a++){
                            var o = i[a];
                            if (e1.getPtId(o) === r) return n = t1.copy();
                        }
                    }), n || t1;
                }, e1.isEntry = function(t1) {
                    return !t1.parent;
                }, e1.isLeaf = function(t1) {
                    return !t1.children;
                }, e1.getPtId = function(t1) {
                    return t1.data.data.id;
                }, e1.getPtLabel = function(t1) {
                    return t1.data.data.label;
                }, e1.getValue = function(t1) {
                    return t1.value;
                }, e1.isHierarchyRoot = function(t1) {
                    return "" === s(t1);
                }, e1.setSliceCursor = function(t1, r, n) {
                    var i = n.isTransitioning;
                    if (!i) {
                        var o = t1.datum();
                        i = n.hideOnRoot && e1.isHierarchyRoot(o) || n.hideOnLeaves && e1.isLeaf(o);
                    }
                    a(t1, i ? null : "pointer");
                }, e1.getInsideTextFontKey = function(t1, e1, r, i, a) {
                    var o = (a || {}).onPathbar ? "pathbar.textfont" : "insidetextfont", s = r.data.data.i;
                    return n.castOption(e1, s, o + "." + t1) || n.castOption(e1, s, "textfont." + t1) || i.size;
                }, e1.getOutsideTextFontKey = function(t1, e1, r, i) {
                    var a = r.data.data.i;
                    return n.castOption(e1, a, "outsidetextfont." + t1) || n.castOption(e1, a, "textfont." + t1) || i.size;
                }, e1.isOutsideText = function(t1, r) {
                    return !t1._hasColorscale && e1.isHierarchyRoot(r);
                }, e1.determineTextFont = function(t1, r, a, o) {
                    return e1.isOutsideText(t1, r) ? function(t1, r, n) {
                        return {
                            color: e1.getOutsideTextFontKey("color", t1, r, n),
                            family: e1.getOutsideTextFontKey("family", t1, r, n),
                            size: e1.getOutsideTextFontKey("size", t1, r, n),
                            weight: e1.getOutsideTextFontKey("weight", t1, r, n),
                            style: e1.getOutsideTextFontKey("style", t1, r, n),
                            variant: e1.getOutsideTextFontKey("variant", t1, r, n),
                            textcase: e1.getOutsideTextFontKey("textcase", t1, r, n),
                            lineposition: e1.getOutsideTextFontKey("lineposition", t1, r, n),
                            shadow: e1.getOutsideTextFontKey("shadow", t1, r, n)
                        };
                    }(t1, r, a) : function(t1, r, a, o) {
                        var s = (o || {}).onPathbar, l = r.data.data, c = l.i, u = n.castOption(t1, c, (s ? "pathbar.textfont" : "insidetextfont") + ".color");
                        return !u && t1._input.textfont && (u = n.castOption(t1._input, c, "textfont.color")), {
                            color: u || i.contrast(l.color),
                            family: e1.getInsideTextFontKey("family", t1, r, a, o),
                            size: e1.getInsideTextFontKey("size", t1, r, a, o),
                            weight: e1.getInsideTextFontKey("weight", t1, r, a, o),
                            style: e1.getInsideTextFontKey("style", t1, r, a, o),
                            variant: e1.getInsideTextFontKey("variant", t1, r, a, o),
                            textcase: e1.getInsideTextFontKey("textcase", t1, r, a, o),
                            lineposition: e1.getInsideTextFontKey("lineposition", t1, r, a, o),
                            shadow: e1.getInsideTextFontKey("shadow", t1, r, a, o)
                        };
                    }(t1, r, a, o);
                }, e1.hasTransition = function(t1) {
                    return !!(t1 && t1.duration > 0);
                }, e1.getMaxDepth = function(t1) {
                    return t1.maxdepth >= 0 ? t1.maxdepth : 1 / 0;
                }, e1.isHeader = function(t1, r) {
                    return !(e1.isLeaf(t1) || t1.depth === r._maxDepth - 1);
                }, e1.getParent = function(t1, r) {
                    return e1.findEntryWithLevel(t1, s(r));
                }, e1.listPath = function(t1, r) {
                    var n = t1.parent;
                    if (!n) return [];
                    var i = r ? [
                        n.data[r]
                    ] : [
                        n
                    ];
                    return e1.listPath(n, r).concat(i);
                }, e1.getPath = function(t1) {
                    return e1.listPath(t1, "label").join("/") + "/";
                }, e1.formatValue = o.formatPieValue, e1.formatPercent = function(t1, e1) {
                    var r = n.formatPercent(t1, 0);
                    return "0%" === r && (r = o.formatPiePercent(t1, e1)), r;
                };
            },
            80809: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    moduleType: "trace",
                    name: "sunburst",
                    basePlotModule: r(14724),
                    categories: [],
                    animatable: !0,
                    attributes: r(56708),
                    layoutAttributes: r(98959),
                    supplyDefaults: r(33459),
                    supplyLayoutDefaults: r(75816),
                    calc: r(14852).calc,
                    crossTraceCalc: r(14852).crossTraceCalc,
                    plot: r(19718).plot,
                    style: r(98972).style,
                    colorbar: r(21146),
                    meta: {}
                };
            },
            98959: function(t1) {
                "use strict";
                t1.exports = {
                    sunburstcolorway: {
                        valType: "colorlist",
                        editType: "calc"
                    },
                    extendsunburstcolors: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    }
                };
            },
            75816: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(98959);
                t1.exports = function(t1, e1) {
                    function r(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    r("sunburstcolorway", e1.colorway), r("extendsunburstcolors");
                };
            },
            19718: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(92264), a = r(88640).GW, o = r(62203), s = r(34809), l = r(30635), c = r(84102), u = c.recordMinTextSize, h = c.clearMinTextSize, f = r(35734), p = r(37252).getRotationAngle, d = f.computeTransform, m = f.transformInsideText, g = r(98972).styleOne, y = r(6851).resizeText, v = r(44691), x = r(2032), _ = r(33108);
                function b(t1, r, c, h) {
                    var f = t1._context.staticPlot, y = t1._fullLayout, b = !y.uniformtext.mode && _.hasTransition(h), T = n.select(c).selectAll("g.slice"), k = r[0], A = k.trace, M = k.hierarchy, S = _.findEntryWithLevel(M, A.level), E = _.getMaxDepth(A), C = y._size, L = A.domain, I = C.w * (L.x[1] - L.x[0]), P = C.h * (L.y[1] - L.y[0]), z = .5 * Math.min(I, P), O = k.cx = C.l + C.w * (L.x[1] + L.x[0]) / 2, D = k.cy = C.t + C.h * (1 - L.y[0]) - P / 2;
                    if (!S) return T.remove();
                    var R = null, F = {};
                    b && T.each(function(t1) {
                        F[_.getPtId(t1)] = {
                            rpx0: t1.rpx0,
                            rpx1: t1.rpx1,
                            x0: t1.x0,
                            x1: t1.x1,
                            transform: t1.transform
                        }, !R && _.isEntry(t1) && (R = t1);
                    });
                    var B = (function(t1) {
                        return i.partition().size([
                            2 * Math.PI,
                            t1.height + 1
                        ])(t1);
                    })(S).descendants(), N = S.height + 1, j = 0, U = E;
                    k.hasMultipleRoots && _.isHierarchyRoot(S) && (B = B.slice(1), N -= 1, j = 1, U += 1), B = B.filter(function(t1) {
                        return t1.y1 <= U;
                    });
                    var V = p(A.rotation);
                    V && B.forEach(function(t1) {
                        t1.x0 += V, t1.x1 += V;
                    });
                    var q = Math.min(N, E), H = function(t1) {
                        return (t1 - j) / q * z;
                    }, G = function(t1, e1) {
                        return [
                            t1 * Math.cos(e1),
                            -t1 * Math.sin(e1)
                        ];
                    }, Z = function(t1) {
                        return s.pathAnnulus(t1.rpx0, t1.rpx1, t1.x0, t1.x1, O, D);
                    }, W = function(t1) {
                        return O + w(t1)[0] * (t1.transform.rCenter || 0) + (t1.transform.x || 0);
                    }, Y = function(t1) {
                        return D + w(t1)[1] * (t1.transform.rCenter || 0) + (t1.transform.y || 0);
                    };
                    (T = T.data(B, _.getPtId)).enter().append("g").classed("slice", !0), b ? T.exit().transition().each(function() {
                        var t1 = n.select(this);
                        t1.select("path.surface").transition().attrTween("d", function(t1) {
                            var e1 = function(t1) {
                                var e1, r = _.getPtId(t1), n = F[r], i = F[_.getPtId(S)];
                                if (i) {
                                    var o = (t1.x1 > i.x1 ? 2 * Math.PI : 0) + V;
                                    e1 = t1.rpx1 < i.rpx1 ? {
                                        x0: t1.x0,
                                        x1: t1.x1,
                                        rpx0: 0,
                                        rpx1: 0
                                    } : {
                                        x0: o,
                                        x1: o,
                                        rpx0: t1.rpx0,
                                        rpx1: t1.rpx1
                                    };
                                } else {
                                    var s, l = _.getPtId(t1.parent);
                                    T.each(function(t1) {
                                        if (_.getPtId(t1) === l) return s = t1;
                                    });
                                    var c, u = s.children;
                                    u.forEach(function(t1, e1) {
                                        if (_.getPtId(t1) === r) return c = e1;
                                    });
                                    var h = u.length, f = a(s.x0, s.x1);
                                    e1 = {
                                        rpx0: z,
                                        rpx1: z,
                                        x0: f(c / h),
                                        x1: f((c + 1) / h)
                                    };
                                }
                                return a(n, e1);
                            }(t1);
                            return function(t1) {
                                return Z(e1(t1));
                            };
                        }), t1.select("g.slicetext").attr("opacity", 0);
                    }).remove() : T.exit().remove(), T.order();
                    var X = null;
                    if (b && R) {
                        var $ = _.getPtId(R);
                        T.each(function(t1) {
                            null === X && _.getPtId(t1) === $ && (X = t1.x1);
                        });
                    }
                    var J = T;
                    function K(t1) {
                        var e1 = t1.parent, r = F[_.getPtId(e1)], n = {};
                        if (r) {
                            var i = e1.children, o = i.indexOf(t1), s = i.length, l = a(r.x0, r.x1);
                            n.x0 = l(o / s), n.x1 = l(o / s);
                        } else n.x0 = n.x1 = 0;
                        return n;
                    }
                    b && (J = J.transition().each("end", function() {
                        var e1 = n.select(this);
                        _.setSliceCursor(e1, t1, {
                            hideOnRoot: !0,
                            hideOnLeaves: !0,
                            isTransitioning: !1
                        });
                    })), J.each(function(i) {
                        var c = n.select(this), h = s.ensureSingle(c, "path", "surface", function(t1) {
                            t1.style("pointer-events", f ? "none" : "all");
                        });
                        i.rpx0 = H(i.y0), i.rpx1 = H(i.y1), i.xmid = (i.x0 + i.x1) / 2, i.pxmid = G(i.rpx1, i.xmid), i.midangle = -(i.xmid - Math.PI / 2), i.startangle = -(i.x0 - Math.PI / 2), i.stopangle = -(i.x1 - Math.PI / 2), i.halfangle = .5 * Math.min(s.angleDelta(i.x0, i.x1) || Math.PI, Math.PI), i.ring = 1 - i.rpx0 / i.rpx1, i.rInscribed = function(t1) {
                            return 0 === t1.rpx0 && s.isFullCircle([
                                t1.x0,
                                t1.x1
                            ]) ? 1 : Math.max(0, Math.min(1 / (1 + 1 / Math.sin(t1.halfangle)), t1.ring / 2));
                        }(i), b ? h.transition().attrTween("d", function(t1) {
                            var e1 = function(t1) {
                                var e1, r = F[_.getPtId(t1)], n = {
                                    x0: t1.x0,
                                    x1: t1.x1,
                                    rpx0: t1.rpx0,
                                    rpx1: t1.rpx1
                                };
                                if (r) e1 = r;
                                else if (R) {
                                    if (t1.parent) {
                                        if (X) {
                                            var i = (t1.x1 > X ? 2 * Math.PI : 0) + V;
                                            e1 = {
                                                x0: i,
                                                x1: i
                                            };
                                        } else e1 = {
                                            rpx0: z,
                                            rpx1: z
                                        }, s.extendFlat(e1, K(t1));
                                    } else e1 = {
                                        rpx0: 0,
                                        rpx1: 0
                                    };
                                } else e1 = {
                                    x0: V,
                                    x1: V
                                };
                                return a(e1, n);
                            }(t1);
                            return function(t1) {
                                return Z(e1(t1));
                            };
                        }) : h.attr("d", Z), c.call(v, S, t1, r, {
                            eventDataKeys: x.eventDataKeys,
                            transitionTime: x.CLICK_TRANSITION_TIME,
                            transitionEasing: x.CLICK_TRANSITION_EASING
                        }).call(_.setSliceCursor, t1, {
                            hideOnRoot: !0,
                            hideOnLeaves: !0,
                            isTransitioning: t1._transitioning
                        }), h.call(g, i, A, t1);
                        var p = s.ensureSingle(c, "g", "slicetext"), w = s.ensureSingle(p, "text", "", function(t1) {
                            t1.attr("data-notex", 1);
                        }), T = s.ensureUniformFontSize(t1, _.determineTextFont(A, i, y.font));
                        w.text(e1.formatSliceLabel(i, S, A, r, y)).classed("slicetext", !0).attr("text-anchor", "middle").call(o.font, T).call(l.convertToTspans, t1);
                        var M = o.bBox(w.node());
                        i.transform = m(M, i, k), i.transform.targetX = W(i), i.transform.targetY = Y(i);
                        var E = function(t1, e1) {
                            var r = t1.transform;
                            return d(r, e1), r.fontSize = T.size, u(A.type, r, y), s.getTextTransform(r);
                        };
                        b ? w.transition().attrTween("transform", function(t1) {
                            var e1 = function(t1) {
                                var e1, r = F[_.getPtId(t1)], n = t1.transform;
                                if (r) e1 = r;
                                else if (e1 = {
                                    rpx1: t1.rpx1,
                                    transform: {
                                        textPosAngle: n.textPosAngle,
                                        scale: 0,
                                        rotate: n.rotate,
                                        rCenter: n.rCenter,
                                        x: n.x,
                                        y: n.y
                                    }
                                }, R) {
                                    if (t1.parent) {
                                        if (X) {
                                            var i = t1.x1 > X ? 2 * Math.PI : 0;
                                            e1.x0 = e1.x1 = i;
                                        } else s.extendFlat(e1, K(t1));
                                    } else e1.x0 = e1.x1 = V;
                                } else e1.x0 = e1.x1 = V;
                                var o = a(e1.transform.textPosAngle, t1.transform.textPosAngle), l = a(e1.rpx1, t1.rpx1), c = a(e1.x0, t1.x0), h = a(e1.x1, t1.x1), f = a(e1.transform.scale, n.scale), p = a(e1.transform.rotate, n.rotate), d = 0 === n.rCenter ? 3 : 0 === e1.transform.rCenter ? 1 / 3 : 1, m = a(e1.transform.rCenter, n.rCenter);
                                return function(t1) {
                                    var e1 = l(t1), r = c(t1), i = h(t1), a = function(t1) {
                                        return m(Math.pow(t1, d));
                                    }(t1), s = {
                                        pxmid: G(e1, (r + i) / 2),
                                        rpx1: e1,
                                        transform: {
                                            textPosAngle: o(t1),
                                            rCenter: a,
                                            x: n.x,
                                            y: n.y
                                        }
                                    };
                                    return u(A.type, n, y), {
                                        transform: {
                                            targetX: W(s),
                                            targetY: Y(s),
                                            scale: f(t1),
                                            rotate: p(t1),
                                            rCenter: a
                                        }
                                    };
                                };
                            }(t1);
                            return function(t1) {
                                return E(e1(t1), M);
                            };
                        }) : w.attr("transform", E(i, M));
                    });
                }
                function w(t1) {
                    var e1, r;
                    return e1 = t1.rpx1, r = t1.transform.textPosAngle, [
                        e1 * Math.sin(r),
                        -e1 * Math.cos(r)
                    ];
                }
                e1.plot = function(t1, e1, r, i) {
                    var a, o, s = t1._fullLayout, l = s._sunburstlayer, c = !r, u = !s.uniformtext.mode && _.hasTransition(r);
                    h("sunburst", s), (a = l.selectAll("g.trace.sunburst").data(e1, function(t1) {
                        return t1[0].trace.uid;
                    })).enter().append("g").classed("trace", !0).classed("sunburst", !0).attr("stroke-linejoin", "round"), a.order(), u ? (i && (o = i()), n.transition().duration(r.duration).ease(r.easing).each("end", function() {
                        o && o();
                    }).each("interrupt", function() {
                        o && o();
                    }).each(function() {
                        l.selectAll("g.trace").each(function(e1) {
                            b(t1, e1, this, r);
                        });
                    })) : (a.each(function(e1) {
                        b(t1, e1, this, r);
                    }), s.uniformtext.mode && y(t1, s._sunburstlayer.selectAll(".trace"), "sunburst")), c && a.exit().remove();
                }, e1.formatSliceLabel = function(t1, e1, r, n, i) {
                    var a = r.texttemplate, o = r.textinfo;
                    if (!(a || o && "none" !== o)) return "";
                    var l = i.separators, c = n[0], u = t1.data.data, h = c.hierarchy, f = _.isHierarchyRoot(t1), p = _.getParent(h, t1), d = _.getValue(t1);
                    if (!a) {
                        var m, g = o.split("+"), y = function(t1) {
                            return -1 !== g.indexOf(t1);
                        }, v = [];
                        if (y("label") && u.label && v.push(u.label), u.hasOwnProperty("v") && y("value") && v.push(_.formatValue(u.v, l)), !f) {
                            y("current path") && v.push(_.getPath(t1.data));
                            var x = 0;
                            y("percent parent") && x++, y("percent entry") && x++, y("percent root") && x++;
                            var b = x > 1;
                            if (x) {
                                var w, T = function(t1) {
                                    m = _.formatPercent(w, l), b && (m += " of " + t1), v.push(m);
                                };
                                y("percent parent") && !f && (w = d / _.getValue(p), T("parent")), y("percent entry") && (w = d / _.getValue(e1), T("entry")), y("percent root") && (w = d / _.getValue(h), T("root"));
                            }
                        }
                        return y("text") && (m = s.castOption(r, u.i, "text"), s.isValidTextValue(m) && v.push(m)), v.join("<br>");
                    }
                    var k = s.castOption(r, u.i, "texttemplate");
                    if (!k) return "";
                    var A = {};
                    u.label && (A.label = u.label), u.hasOwnProperty("v") && (A.value = u.v, A.valueLabel = _.formatValue(u.v, l)), A.currentPath = _.getPath(t1.data), f || (A.percentParent = d / _.getValue(p), A.percentParentLabel = _.formatPercent(A.percentParent, l), A.parent = _.getPtLabel(p)), A.percentEntry = d / _.getValue(e1), A.percentEntryLabel = _.formatPercent(A.percentEntry, l), A.entry = _.getPtLabel(e1), A.percentRoot = d / _.getValue(h), A.percentRootLabel = _.formatPercent(A.percentRoot, l), A.root = _.getPtLabel(h), u.hasOwnProperty("color") && (A.color = u.color);
                    var M = s.castOption(r, u.i, "text");
                    return (s.isValidTextValue(M) || "" === M) && (A.text = M), A.customdata = s.castOption(r, u.i, "customdata"), s.texttemplateString(k, A, i._d3locale, A, r._meta || {});
                };
            },
            98972: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(78766), a = r(34809), o = r(84102).resizeText, s = r(72043);
                function l(t1, e1, r, n) {
                    var o = e1.data.data, l = !e1.children, c = o.i, u = a.castOption(r, c, "marker.line.color") || i.defaultLine, h = a.castOption(r, c, "marker.line.width") || 0;
                    t1.call(s, e1, r, n).style("stroke-width", h).call(i.stroke, u).style("opacity", l ? r.leaf.opacity : null);
                }
                t1.exports = {
                    style: function(t1) {
                        var e1 = t1._fullLayout._sunburstlayer.selectAll(".trace");
                        o(t1, e1, "sunburst"), e1.each(function(e1) {
                            var r = n.select(this), i = e1[0].trace;
                            r.style("opacity", i.opacity), r.selectAll("path.surface").each(function(e1) {
                                n.select(this).call(l, e1, i, t1);
                            });
                        });
                    },
                    styleOne: l
                };
            },
            16131: function(t1, e1, r) {
                "use strict";
                var n = r(78766), i = r(87163), a = r(80712).axisHoverFormat, o = r(3208).rb, s = r(9829), l = r(93049).extendFlat, c = r(13582).overrideAll;
                function u(t1) {
                    return {
                        show: {
                            valType: "boolean",
                            dflt: !1
                        },
                        start: {
                            valType: "number",
                            dflt: null,
                            editType: "plot"
                        },
                        end: {
                            valType: "number",
                            dflt: null,
                            editType: "plot"
                        },
                        size: {
                            valType: "number",
                            dflt: null,
                            min: 0,
                            editType: "plot"
                        },
                        project: {
                            x: {
                                valType: "boolean",
                                dflt: !1
                            },
                            y: {
                                valType: "boolean",
                                dflt: !1
                            },
                            z: {
                                valType: "boolean",
                                dflt: !1
                            }
                        },
                        color: {
                            valType: "color",
                            dflt: n.defaultLine
                        },
                        usecolormap: {
                            valType: "boolean",
                            dflt: !1
                        },
                        width: {
                            valType: "number",
                            min: 1,
                            max: 16,
                            dflt: 2
                        },
                        highlight: {
                            valType: "boolean",
                            dflt: !0
                        },
                        highlightcolor: {
                            valType: "color",
                            dflt: n.defaultLine
                        },
                        highlightwidth: {
                            valType: "number",
                            min: 1,
                            max: 16,
                            dflt: 2
                        }
                    };
                }
                var h = t1.exports = c(l({
                    z: {
                        valType: "data_array"
                    },
                    x: {
                        valType: "data_array"
                    },
                    y: {
                        valType: "data_array"
                    },
                    text: {
                        valType: "string",
                        dflt: "",
                        arrayOk: !0
                    },
                    hovertext: {
                        valType: "string",
                        dflt: "",
                        arrayOk: !0
                    },
                    hovertemplate: o(),
                    xhoverformat: a("x"),
                    yhoverformat: a("y"),
                    zhoverformat: a("z"),
                    connectgaps: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "calc"
                    },
                    surfacecolor: {
                        valType: "data_array"
                    }
                }, i("", {
                    colorAttr: "z or surfacecolor",
                    showScaleDflt: !0,
                    autoColorDflt: !1,
                    editTypeOverride: "calc"
                }), {
                    contours: {
                        x: u(),
                        y: u(),
                        z: u()
                    },
                    hidesurface: {
                        valType: "boolean",
                        dflt: !1
                    },
                    lightposition: {
                        x: {
                            valType: "number",
                            min: -100000,
                            max: 1e5,
                            dflt: 10
                        },
                        y: {
                            valType: "number",
                            min: -100000,
                            max: 1e5,
                            dflt: 1e4
                        },
                        z: {
                            valType: "number",
                            min: -100000,
                            max: 1e5,
                            dflt: 0
                        }
                    },
                    lighting: {
                        ambient: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: .8
                        },
                        diffuse: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: .8
                        },
                        specular: {
                            valType: "number",
                            min: 0,
                            max: 2,
                            dflt: .05
                        },
                        roughness: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: .5
                        },
                        fresnel: {
                            valType: "number",
                            min: 0,
                            max: 5,
                            dflt: .2
                        }
                    },
                    opacity: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 1
                    },
                    opacityscale: {
                        valType: "any",
                        editType: "calc"
                    },
                    _deprecated: {
                        zauto: l({}, i.zauto, {}),
                        zmin: l({}, i.zmin, {}),
                        zmax: l({}, i.zmax, {})
                    },
                    hoverinfo: l({}, s.hoverinfo),
                    showlegend: l({}, s.showlegend, {
                        dflt: !1
                    })
                }), "calc", "nested");
                h.x.editType = h.y.editType = h.z.editType = "calc+clearAxisTypes", h.transforms = void 0;
            },
            53027: function(t1, e1, r) {
                "use strict";
                var n = r(28379);
                t1.exports = function(t1, e1) {
                    e1.surfacecolor ? n(t1, e1, {
                        vals: e1.surfacecolor,
                        containerStr: "",
                        cLetter: "c"
                    }) : n(t1, e1, {
                        vals: e1.z,
                        containerStr: "",
                        cLetter: "c"
                    });
                };
            },
            27159: function(t1, e1, r) {
                "use strict";
                var n = r(99098).gl_surface3d, i = r(99098).ndarray, a = r(99098).ndarray_linear_interpolate.d2, o = r(69295), s = r(78106), l = r(34809).isArrayOrTypedArray, c = r(46998).parseColorScale, u = r(55010), h = r(88856).extractOpts;
                function f(t1, e1, r) {
                    this.scene = t1, this.uid = r, this.surface = e1, this.data = null, this.showContour = [
                        !1,
                        !1,
                        !1
                    ], this.contourStart = [
                        null,
                        null,
                        null
                    ], this.contourEnd = [
                        null,
                        null,
                        null
                    ], this.contourSize = [
                        0,
                        0,
                        0
                    ], this.minValues = [
                        1 / 0,
                        1 / 0,
                        1 / 0
                    ], this.maxValues = [
                        -1 / 0,
                        -1 / 0,
                        -1 / 0
                    ], this.dataScaleX = 1, this.dataScaleY = 1, this.refineData = !0, this.objectOffset = [
                        0,
                        0,
                        0
                    ];
                }
                var p = f.prototype;
                p.getXat = function(t1, e1, r, n) {
                    var i = l(this.data.x) ? l(this.data.x[0]) ? this.data.x[e1][t1] : this.data.x[t1] : t1;
                    return void 0 === r ? i : n.d2l(i, 0, r);
                }, p.getYat = function(t1, e1, r, n) {
                    var i = l(this.data.y) ? l(this.data.y[0]) ? this.data.y[e1][t1] : this.data.y[e1] : e1;
                    return void 0 === r ? i : n.d2l(i, 0, r);
                }, p.getZat = function(t1, e1, r, n) {
                    var i = this.data.z[e1][t1];
                    return null === i && this.data.connectgaps && this.data._interpolatedZ && (i = this.data._interpolatedZ[e1][t1]), void 0 === r ? i : n.d2l(i, 0, r);
                }, p.handlePick = function(t1) {
                    if (t1.object === this.surface) {
                        var e1 = (t1.data.index[0] - 1) / this.dataScaleX - 1, r = (t1.data.index[1] - 1) / this.dataScaleY - 1, n = Math.max(Math.min(Math.round(e1), this.data.z[0].length - 1), 0), i = Math.max(Math.min(Math.round(r), this.data._ylength - 1), 0);
                        t1.index = [
                            n,
                            i
                        ], t1.traceCoordinate = [
                            this.getXat(n, i),
                            this.getYat(n, i),
                            this.getZat(n, i)
                        ], t1.dataCoordinate = [
                            this.getXat(n, i, this.data.xcalendar, this.scene.fullSceneLayout.xaxis),
                            this.getYat(n, i, this.data.ycalendar, this.scene.fullSceneLayout.yaxis),
                            this.getZat(n, i, this.data.zcalendar, this.scene.fullSceneLayout.zaxis)
                        ];
                        for(var a = 0; a < 3; a++)null != t1.dataCoordinate[a] && (t1.dataCoordinate[a] *= this.scene.dataScale[a]);
                        var o = this.data.hovertext || this.data.text;
                        return l(o) && o[i] && void 0 !== o[i][n] ? t1.textLabel = o[i][n] : t1.textLabel = o || "", t1.data.dataCoordinate = t1.dataCoordinate.slice(), this.surface.highlight(t1.data), this.scene.glplot.spikes.position = t1.dataCoordinate, !0;
                    }
                };
                var d = [
                    2,
                    3,
                    5,
                    7,
                    11,
                    13,
                    17,
                    19,
                    23,
                    29,
                    31,
                    37,
                    41,
                    43,
                    47,
                    53,
                    59,
                    61,
                    67,
                    71,
                    73,
                    79,
                    83,
                    89,
                    97,
                    101,
                    103,
                    107,
                    109,
                    113,
                    127,
                    131,
                    137,
                    139,
                    149,
                    151,
                    157,
                    163,
                    167,
                    173,
                    179,
                    181,
                    191,
                    193,
                    197,
                    199,
                    211,
                    223,
                    227,
                    229,
                    233,
                    239,
                    241,
                    251,
                    257,
                    263,
                    269,
                    271,
                    277,
                    281,
                    283,
                    293,
                    307,
                    311,
                    313,
                    317,
                    331,
                    337,
                    347,
                    349,
                    353,
                    359,
                    367,
                    373,
                    379,
                    383,
                    389,
                    397,
                    401,
                    409,
                    419,
                    421,
                    431,
                    433,
                    439,
                    443,
                    449,
                    457,
                    461,
                    463,
                    467,
                    479,
                    487,
                    491,
                    499,
                    503,
                    509,
                    521,
                    523,
                    541,
                    547,
                    557,
                    563,
                    569,
                    571,
                    577,
                    587,
                    593,
                    599,
                    601,
                    607,
                    613,
                    617,
                    619,
                    631,
                    641,
                    643,
                    647,
                    653,
                    659,
                    661,
                    673,
                    677,
                    683,
                    691,
                    701,
                    709,
                    719,
                    727,
                    733,
                    739,
                    743,
                    751,
                    757,
                    761,
                    769,
                    773,
                    787,
                    797,
                    809,
                    811,
                    821,
                    823,
                    827,
                    829,
                    839,
                    853,
                    857,
                    859,
                    863,
                    877,
                    881,
                    883,
                    887,
                    907,
                    911,
                    919,
                    929,
                    937,
                    941,
                    947,
                    953,
                    967,
                    971,
                    977,
                    983,
                    991,
                    997,
                    1009,
                    1013,
                    1019,
                    1021,
                    1031,
                    1033,
                    1039,
                    1049,
                    1051,
                    1061,
                    1063,
                    1069,
                    1087,
                    1091,
                    1093,
                    1097,
                    1103,
                    1109,
                    1117,
                    1123,
                    1129,
                    1151,
                    1153,
                    1163,
                    1171,
                    1181,
                    1187,
                    1193,
                    1201,
                    1213,
                    1217,
                    1223,
                    1229,
                    1231,
                    1237,
                    1249,
                    1259,
                    1277,
                    1279,
                    1283,
                    1289,
                    1291,
                    1297,
                    1301,
                    1303,
                    1307,
                    1319,
                    1321,
                    1327,
                    1361,
                    1367,
                    1373,
                    1381,
                    1399,
                    1409,
                    1423,
                    1427,
                    1429,
                    1433,
                    1439,
                    1447,
                    1451,
                    1453,
                    1459,
                    1471,
                    1481,
                    1483,
                    1487,
                    1489,
                    1493,
                    1499,
                    1511,
                    1523,
                    1531,
                    1543,
                    1549,
                    1553,
                    1559,
                    1567,
                    1571,
                    1579,
                    1583,
                    1597,
                    1601,
                    1607,
                    1609,
                    1613,
                    1619,
                    1621,
                    1627,
                    1637,
                    1657,
                    1663,
                    1667,
                    1669,
                    1693,
                    1697,
                    1699,
                    1709,
                    1721,
                    1723,
                    1733,
                    1741,
                    1747,
                    1753,
                    1759,
                    1777,
                    1783,
                    1787,
                    1789,
                    1801,
                    1811,
                    1823,
                    1831,
                    1847,
                    1861,
                    1867,
                    1871,
                    1873,
                    1877,
                    1879,
                    1889,
                    1901,
                    1907,
                    1913,
                    1931,
                    1933,
                    1949,
                    1951,
                    1973,
                    1979,
                    1987,
                    1993,
                    1997,
                    1999,
                    2003,
                    2011,
                    2017,
                    2027,
                    2029,
                    2039,
                    2053,
                    2063,
                    2069,
                    2081,
                    2083,
                    2087,
                    2089,
                    2099,
                    2111,
                    2113,
                    2129,
                    2131,
                    2137,
                    2141,
                    2143,
                    2153,
                    2161,
                    2179,
                    2203,
                    2207,
                    2213,
                    2221,
                    2237,
                    2239,
                    2243,
                    2251,
                    2267,
                    2269,
                    2273,
                    2281,
                    2287,
                    2293,
                    2297,
                    2309,
                    2311,
                    2333,
                    2339,
                    2341,
                    2347,
                    2351,
                    2357,
                    2371,
                    2377,
                    2381,
                    2383,
                    2389,
                    2393,
                    2399,
                    2411,
                    2417,
                    2423,
                    2437,
                    2441,
                    2447,
                    2459,
                    2467,
                    2473,
                    2477,
                    2503,
                    2521,
                    2531,
                    2539,
                    2543,
                    2549,
                    2551,
                    2557,
                    2579,
                    2591,
                    2593,
                    2609,
                    2617,
                    2621,
                    2633,
                    2647,
                    2657,
                    2659,
                    2663,
                    2671,
                    2677,
                    2683,
                    2687,
                    2689,
                    2693,
                    2699,
                    2707,
                    2711,
                    2713,
                    2719,
                    2729,
                    2731,
                    2741,
                    2749,
                    2753,
                    2767,
                    2777,
                    2789,
                    2791,
                    2797,
                    2801,
                    2803,
                    2819,
                    2833,
                    2837,
                    2843,
                    2851,
                    2857,
                    2861,
                    2879,
                    2887,
                    2897,
                    2903,
                    2909,
                    2917,
                    2927,
                    2939,
                    2953,
                    2957,
                    2963,
                    2969,
                    2971,
                    2999
                ];
                function m(t1, e1) {
                    if (t1 < e1) return 0;
                    for(var r = 0; 0 === Math.floor(t1 % e1);)t1 /= e1, r++;
                    return r;
                }
                function g(t1) {
                    for(var e1 = [], r = 0; r < d.length; r++){
                        var n = d[r];
                        e1.push(m(t1, n));
                    }
                    return e1;
                }
                function y(t1) {
                    for(var e1 = g(t1), r = t1, n = 0; n < d.length; n++)if (e1[n] > 0) {
                        r = d[n];
                        break;
                    }
                    return r;
                }
                function v(t1, e1) {
                    if (!(t1 < 1 || e1 < 1)) {
                        for(var r = g(t1), n = g(e1), i = 1, a = 0; a < d.length; a++)i *= Math.pow(d[a], Math.max(r[a], n[a]));
                        return i;
                    }
                }
                p.calcXnums = function(t1) {
                    var e1, r = [];
                    for(e1 = 1; e1 < t1; e1++){
                        var n = this.getXat(e1 - 1, 0), i = this.getXat(e1, 0);
                        r[e1 - 1] = i !== n && null != n && null != i ? Math.abs(i - n) : 0;
                    }
                    var a = 0;
                    for(e1 = 1; e1 < t1; e1++)a += r[e1 - 1];
                    for(e1 = 1; e1 < t1; e1++)0 === r[e1 - 1] ? r[e1 - 1] = 1 : r[e1 - 1] = Math.round(a / r[e1 - 1]);
                    return r;
                }, p.calcYnums = function(t1) {
                    var e1, r = [];
                    for(e1 = 1; e1 < t1; e1++){
                        var n = this.getYat(0, e1 - 1), i = this.getYat(0, e1);
                        r[e1 - 1] = i !== n && null != n && null != i ? Math.abs(i - n) : 0;
                    }
                    var a = 0;
                    for(e1 = 1; e1 < t1; e1++)a += r[e1 - 1];
                    for(e1 = 1; e1 < t1; e1++)0 === r[e1 - 1] ? r[e1 - 1] = 1 : r[e1 - 1] = Math.round(a / r[e1 - 1]);
                    return r;
                };
                var x = [
                    1,
                    2,
                    4,
                    6,
                    12,
                    24,
                    36,
                    48,
                    60,
                    120,
                    180,
                    240,
                    360,
                    720,
                    840,
                    1260
                ], _ = x[9], b = x[13];
                function w(t1, e1, r) {
                    var n = r[8] + r[2] * e1[0] + r[5] * e1[1];
                    return t1[0] = (r[6] + r[0] * e1[0] + r[3] * e1[1]) / n, t1[1] = (r[7] + r[1] * e1[0] + r[4] * e1[1]) / n, t1;
                }
                function T(t1, e1, r) {
                    return function(t1, e1, r, n) {
                        for(var i = [
                            0,
                            0
                        ], o = t1.shape[0], s = t1.shape[1], l = 0; l < o; l++)for(var c = 0; c < s; c++)r(i, [
                            l,
                            c
                        ], n), t1.set(l, c, a(e1, i[0], i[1]));
                    }(t1, e1, w, r), t1;
                }
                function k(t1, e1) {
                    for(var r = !1, n = 0; n < t1.length; n++)if (e1 === t1[n]) {
                        r = !0;
                        break;
                    }
                    !1 === r && t1.push(e1);
                }
                p.estimateScale = function(t1, e1) {
                    for(var r = 1 + function(t1) {
                        if (0 !== t1.length) {
                            for(var e1 = 1, r = 0; r < t1.length; r++)e1 = v(e1, t1[r]);
                            return e1;
                        }
                    }(0 === e1 ? this.calcXnums(t1) : this.calcYnums(t1)); r < _;)r *= 2;
                    for(; r > b;)r--, r /= y(r), ++r < _ && (r = b);
                    var n = Math.round(r / t1);
                    return n > 1 ? n : 1;
                }, p.refineCoords = function(t1) {
                    for(var e1 = this.dataScaleX, r = this.dataScaleY, n = t1[0].shape[0], a = t1[0].shape[1], o = 0 | Math.floor(t1[0].shape[0] * e1 + 1), s = 0 | Math.floor(t1[0].shape[1] * r + 1), l = 1 + n + 1, c = 1 + a + 1, u = i(new Float32Array(l * c), [
                        l,
                        c
                    ]), h = [
                        1 / e1,
                        0,
                        0,
                        0,
                        1 / r,
                        0,
                        0,
                        0,
                        1
                    ], f = 0; f < t1.length; ++f){
                        this.surface.padField(u, t1[f]);
                        var p = i(new Float32Array(o * s), [
                            o,
                            s
                        ]);
                        T(p, u, h), t1[f] = p;
                    }
                }, p.setContourLevels = function() {
                    var t1, e1, r, n = [
                        [],
                        [],
                        []
                    ], i = [
                        !1,
                        !1,
                        !1
                    ], a = !1;
                    for(t1 = 0; t1 < 3; ++t1)if (this.showContour[t1] && (a = !0, this.contourSize[t1] > 0 && null !== this.contourStart[t1] && null !== this.contourEnd[t1] && this.contourEnd[t1] > this.contourStart[t1])) for(i[t1] = !0, e1 = this.contourStart[t1]; e1 < this.contourEnd[t1]; e1 += this.contourSize[t1])r = e1 * this.scene.dataScale[t1], k(n[t1], r);
                    if (a) {
                        var o = [
                            [],
                            [],
                            []
                        ];
                        for(t1 = 0; t1 < 3; ++t1)this.showContour[t1] && (o[t1] = i[t1] ? n[t1] : this.scene.contourLevels[t1]);
                        this.surface.update({
                            levels: o
                        });
                    }
                }, p.update = function(t1) {
                    var e1, r, n, a, l = this.scene, f = l.fullSceneLayout, p = this.surface, d = c(t1), m = l.dataScale, g = t1.z[0].length, y = t1._ylength, v = l.contourLevels;
                    this.data = t1;
                    var x = [];
                    for(e1 = 0; e1 < 3; e1++)for(x[e1] = [], r = 0; r < g; r++)x[e1][r] = [];
                    for(r = 0; r < g; r++)for(n = 0; n < y; n++)x[0][r][n] = this.getXat(r, n, t1.xcalendar, f.xaxis), x[1][r][n] = this.getYat(r, n, t1.ycalendar, f.yaxis), x[2][r][n] = this.getZat(r, n, t1.zcalendar, f.zaxis);
                    if (t1.connectgaps) for(t1._emptypoints = s(x[2]), o(x[2], t1._emptypoints), t1._interpolatedZ = [], r = 0; r < g; r++)for(t1._interpolatedZ[r] = [], n = 0; n < y; n++)t1._interpolatedZ[r][n] = x[2][r][n];
                    for(e1 = 0; e1 < 3; e1++)for(r = 0; r < g; r++)for(n = 0; n < y; n++)null == (a = x[e1][r][n]) ? x[e1][r][n] = NaN : a = x[e1][r][n] *= m[e1];
                    for(e1 = 0; e1 < 3; e1++)for(r = 0; r < g; r++)for(n = 0; n < y; n++)null != (a = x[e1][r][n]) && (this.minValues[e1] > a && (this.minValues[e1] = a), this.maxValues[e1] < a && (this.maxValues[e1] = a));
                    for(e1 = 0; e1 < 3; e1++)this.objectOffset[e1] = .5 * (this.minValues[e1] + this.maxValues[e1]);
                    for(e1 = 0; e1 < 3; e1++)for(r = 0; r < g; r++)for(n = 0; n < y; n++)null != (a = x[e1][r][n]) && (x[e1][r][n] -= this.objectOffset[e1]);
                    var _ = [
                        i(new Float32Array(g * y), [
                            g,
                            y
                        ]),
                        i(new Float32Array(g * y), [
                            g,
                            y
                        ]),
                        i(new Float32Array(g * y), [
                            g,
                            y
                        ])
                    ];
                    for(e1 = 0; e1 < 3; e1++)for(r = 0; r < g; r++)for(n = 0; n < y; n++)_[e1].set(r, n, x[e1][r][n]);
                    x = [];
                    var w = {
                        colormap: d,
                        levels: [
                            [],
                            [],
                            []
                        ],
                        showContour: [
                            !0,
                            !0,
                            !0
                        ],
                        showSurface: !t1.hidesurface,
                        contourProject: [
                            [
                                !1,
                                !1,
                                !1
                            ],
                            [
                                !1,
                                !1,
                                !1
                            ],
                            [
                                !1,
                                !1,
                                !1
                            ]
                        ],
                        contourWidth: [
                            1,
                            1,
                            1
                        ],
                        contourColor: [
                            [
                                1,
                                1,
                                1,
                                1
                            ],
                            [
                                1,
                                1,
                                1,
                                1
                            ],
                            [
                                1,
                                1,
                                1,
                                1
                            ]
                        ],
                        contourTint: [
                            1,
                            1,
                            1
                        ],
                        dynamicColor: [
                            [
                                1,
                                1,
                                1,
                                1
                            ],
                            [
                                1,
                                1,
                                1,
                                1
                            ],
                            [
                                1,
                                1,
                                1,
                                1
                            ]
                        ],
                        dynamicWidth: [
                            1,
                            1,
                            1
                        ],
                        dynamicTint: [
                            1,
                            1,
                            1
                        ],
                        opacityscale: t1.opacityscale,
                        opacity: t1.opacity
                    }, T = h(t1);
                    if (w.intensityBounds = [
                        T.min,
                        T.max
                    ], t1.surfacecolor) {
                        var k = i(new Float32Array(g * y), [
                            g,
                            y
                        ]);
                        for(r = 0; r < g; r++)for(n = 0; n < y; n++)k.set(r, n, t1.surfacecolor[n][r]);
                        _.push(k);
                    } else w.intensityBounds[0] *= m[2], w.intensityBounds[1] *= m[2];
                    (b < _[0].shape[0] || b < _[0].shape[1]) && (this.refineData = !1), !0 === this.refineData && (this.dataScaleX = this.estimateScale(_[0].shape[0], 0), this.dataScaleY = this.estimateScale(_[0].shape[1], 1), 1 === this.dataScaleX && 1 === this.dataScaleY || this.refineCoords(_)), t1.surfacecolor && (w.intensity = _.pop());
                    var A = [
                        !0,
                        !0,
                        !0
                    ], M = [
                        "x",
                        "y",
                        "z"
                    ];
                    for(e1 = 0; e1 < 3; ++e1){
                        var S = t1.contours[M[e1]];
                        A[e1] = S.highlight, w.showContour[e1] = S.show || S.highlight, w.showContour[e1] && (w.contourProject[e1] = [
                            S.project.x,
                            S.project.y,
                            S.project.z
                        ], S.show ? (this.showContour[e1] = !0, w.levels[e1] = v[e1], p.highlightColor[e1] = w.contourColor[e1] = u(S.color), S.usecolormap ? p.highlightTint[e1] = w.contourTint[e1] = 0 : p.highlightTint[e1] = w.contourTint[e1] = 1, w.contourWidth[e1] = S.width, this.contourStart[e1] = S.start, this.contourEnd[e1] = S.end, this.contourSize[e1] = S.size) : (this.showContour[e1] = !1, this.contourStart[e1] = null, this.contourEnd[e1] = null, this.contourSize[e1] = 0), S.highlight && (w.dynamicColor[e1] = u(S.highlightcolor), w.dynamicWidth[e1] = S.highlightwidth));
                    }
                    (function(t1) {
                        var e1 = t1[0].rgb, r = t1[t1.length - 1].rgb;
                        return e1[0] === r[0] && e1[1] === r[1] && e1[2] === r[2] && e1[3] === r[3];
                    })(d) && (w.vertexColor = !0), w.objectOffset = this.objectOffset, w.coords = _, p.update(w), p.visible = t1.visible, p.enableDynamic = A, p.enableHighlight = A, p.snapToData = !0, "lighting" in t1 && (p.ambientLight = t1.lighting.ambient, p.diffuseLight = t1.lighting.diffuse, p.specularLight = t1.lighting.specular, p.roughness = t1.lighting.roughness, p.fresnel = t1.lighting.fresnel), "lightposition" in t1 && (p.lightPosition = [
                        t1.lightposition.x,
                        t1.lightposition.y,
                        t1.lightposition.z
                    ]);
                }, p.dispose = function() {
                    this.scene.glplot.remove(this.surface), this.surface.dispose();
                }, t1.exports = function(t1, e1) {
                    var r = t1.glplot.gl, i = n({
                        gl: r
                    }), a = new f(t1, i, e1.uid);
                    return i._trace = a, a.update(e1), t1.glplot.add(i), a;
                };
            },
            65444: function(t1, e1, r) {
                "use strict";
                var n = r(33626), i = r(34809), a = r(39356), o = r(16131);
                function s(t1, e1, r, n) {
                    var i = n("opacityscale");
                    "max" === i ? e1.opacityscale = [
                        [
                            0,
                            .1
                        ],
                        [
                            1,
                            1
                        ]
                    ] : "min" === i ? e1.opacityscale = [
                        [
                            0,
                            1
                        ],
                        [
                            1,
                            .1
                        ]
                    ] : "extremes" === i ? e1.opacityscale = function(t1, e1) {
                        for(var r = [], n = 0; n < 32; n++){
                            var i = n / 31, a = .1 + .9 * (1 - Math.pow(Math.sin(1 * i * Math.PI), 2));
                            r.push([
                                i,
                                Math.max(0, Math.min(1, a))
                            ]);
                        }
                        return r;
                    }() : function(t1) {
                        var e1 = 0;
                        if (!Array.isArray(t1) || t1.length < 2) return !1;
                        if (!t1[0] || !t1[t1.length - 1]) return !1;
                        if (0 != +t1[0][0] || 1 != +t1[t1.length - 1][0]) return !1;
                        for(var r = 0; r < t1.length; r++){
                            var n = t1[r];
                            if (2 !== n.length || +n[0] < e1) return !1;
                            e1 = +n[0];
                        }
                        return !0;
                    }(i) || (e1.opacityscale = void 0);
                }
                function l(t1, e1, r) {
                    e1 in t1 && !(r in t1) && (t1[r] = t1[e1]);
                }
                t1.exports = {
                    supplyDefaults: function(t1, e1, r, c) {
                        var u, h;
                        function f(r, n) {
                            return i.coerce(t1, e1, o, r, n);
                        }
                        var p = f("x"), d = f("y"), m = f("z");
                        if (!m || !m.length || p && p.length < 1 || d && d.length < 1) e1.visible = !1;
                        else {
                            e1._xlength = Array.isArray(p) && i.isArrayOrTypedArray(p[0]) ? m.length : m[0].length, e1._ylength = m.length, n.getComponentMethod("calendars", "handleTraceDefaults")(t1, e1, [
                                "x",
                                "y",
                                "z"
                            ], c), f("text"), f("hovertext"), f("hovertemplate"), f("xhoverformat"), f("yhoverformat"), f("zhoverformat"), [
                                "lighting.ambient",
                                "lighting.diffuse",
                                "lighting.specular",
                                "lighting.roughness",
                                "lighting.fresnel",
                                "lightposition.x",
                                "lightposition.y",
                                "lightposition.z",
                                "hidesurface",
                                "connectgaps",
                                "opacity"
                            ].forEach(function(t1) {
                                f(t1);
                            });
                            var g = f("surfacecolor"), y = [
                                "x",
                                "y",
                                "z"
                            ];
                            for(u = 0; u < 3; ++u){
                                var v = "contours." + y[u], x = f(v + ".show"), _ = f(v + ".highlight");
                                if (x || _) for(h = 0; h < 3; ++h)f(v + ".project." + y[h]);
                                x && (f(v + ".color"), f(v + ".width"), f(v + ".usecolormap")), _ && (f(v + ".highlightcolor"), f(v + ".highlightwidth")), f(v + ".start"), f(v + ".end"), f(v + ".size");
                            }
                            g || (l(t1, "zmin", "cmin"), l(t1, "zmax", "cmax"), l(t1, "zauto", "cauto")), a(t1, e1, c, f, {
                                prefix: "",
                                cLetter: "c"
                            }), s(0, e1, 0, f), e1._length = null;
                        }
                    },
                    opacityscaleDefaults: s
                };
            },
            95984: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    attributes: r(16131),
                    supplyDefaults: r(65444).supplyDefaults,
                    colorbar: {
                        min: "cmin",
                        max: "cmax"
                    },
                    calc: r(53027),
                    plot: r(27159),
                    moduleType: "trace",
                    name: "surface",
                    basePlotModule: r(2487),
                    categories: [
                        "gl3d",
                        "2dMap",
                        "showLegend"
                    ],
                    meta: {}
                };
            },
            92294: function(t1, e1, r) {
                "use strict";
                var n = r(50222), i = r(93049).extendFlat, a = r(13582).overrideAll, o = r(80337), s = r(13792).u, l = r(80712).descriptionOnlyNumbers;
                (t1.exports = a({
                    domain: s({
                        name: "table",
                        trace: !0
                    }),
                    columnwidth: {
                        valType: "number",
                        arrayOk: !0,
                        dflt: null
                    },
                    columnorder: {
                        valType: "data_array"
                    },
                    header: {
                        values: {
                            valType: "data_array",
                            dflt: []
                        },
                        format: {
                            valType: "data_array",
                            dflt: [],
                            description: l("cell value")
                        },
                        prefix: {
                            valType: "string",
                            arrayOk: !0,
                            dflt: null
                        },
                        suffix: {
                            valType: "string",
                            arrayOk: !0,
                            dflt: null
                        },
                        height: {
                            valType: "number",
                            dflt: 28
                        },
                        align: i({}, n.align, {
                            arrayOk: !0
                        }),
                        line: {
                            width: {
                                valType: "number",
                                arrayOk: !0,
                                dflt: 1
                            },
                            color: {
                                valType: "color",
                                arrayOk: !0,
                                dflt: "grey"
                            }
                        },
                        fill: {
                            color: {
                                valType: "color",
                                arrayOk: !0,
                                dflt: "white"
                            }
                        },
                        font: i({}, o({
                            arrayOk: !0
                        }))
                    },
                    cells: {
                        values: {
                            valType: "data_array",
                            dflt: []
                        },
                        format: {
                            valType: "data_array",
                            dflt: [],
                            description: l("cell value")
                        },
                        prefix: {
                            valType: "string",
                            arrayOk: !0,
                            dflt: null
                        },
                        suffix: {
                            valType: "string",
                            arrayOk: !0,
                            dflt: null
                        },
                        height: {
                            valType: "number",
                            dflt: 20
                        },
                        align: i({}, n.align, {
                            arrayOk: !0
                        }),
                        line: {
                            width: {
                                valType: "number",
                                arrayOk: !0,
                                dflt: 1
                            },
                            color: {
                                valType: "color",
                                arrayOk: !0,
                                dflt: "grey"
                            }
                        },
                        fill: {
                            color: {
                                valType: "color",
                                arrayOk: !0,
                                dflt: "white"
                            }
                        },
                        font: i({}, o({
                            arrayOk: !0
                        }))
                    }
                }, "calc", "from-root")).transforms = void 0;
            },
            82662: function(t1, e1, r) {
                "use strict";
                var n = r(4173).eV, i = r(84576), a = "table";
                e1.name = a, e1.plot = function(t1) {
                    var e1 = n(t1.calcdata, a)[0];
                    e1.length && i(t1, e1);
                }, e1.clean = function(t1, e1, r, n) {
                    var i = n._has && n._has(a), o = e1._has && e1._has(a);
                    i && !o && n._paperdiv.selectAll(".table").remove();
                };
            },
            87522: function(t1, e1, r) {
                "use strict";
                var n = r(71293).wrap;
                t1.exports = function() {
                    return n({});
                };
            },
            18426: function(t1) {
                "use strict";
                t1.exports = {
                    cellPad: 8,
                    columnExtentOffset: 10,
                    columnTitleOffset: 28,
                    emptyHeaderHeight: 16,
                    latexCheck: /^\$.*\$$/,
                    goldenRatio: 1.618,
                    lineBreaker: "<br>",
                    maxDimensionCount: 60,
                    overdrag: 45,
                    releaseTransitionDuration: 120,
                    releaseTransitionEase: "cubic-out",
                    scrollbarCaptureWidth: 18,
                    scrollbarHideDelay: 1e3,
                    scrollbarHideDuration: 1e3,
                    scrollbarOffset: 5,
                    scrollbarWidth: 8,
                    transitionDuration: 100,
                    transitionEase: "cubic-out",
                    uplift: 5,
                    wrapSpacer: " ",
                    wrapSplitCharacter: " ",
                    cn: {
                        table: "table",
                        tableControlView: "table-control-view",
                        scrollBackground: "scroll-background",
                        yColumn: "y-column",
                        columnBlock: "column-block",
                        scrollAreaClip: "scroll-area-clip",
                        scrollAreaClipRect: "scroll-area-clip-rect",
                        columnBoundary: "column-boundary",
                        columnBoundaryClippath: "column-boundary-clippath",
                        columnBoundaryRect: "column-boundary-rect",
                        columnCells: "column-cells",
                        columnCell: "column-cell",
                        cellRect: "cell-rect",
                        cellText: "cell-text",
                        cellTextHolder: "cell-text-holder",
                        scrollbarKit: "scrollbar-kit",
                        scrollbar: "scrollbar",
                        scrollbarSlider: "scrollbar-slider",
                        scrollbarGlyph: "scrollbar-glyph",
                        scrollbarCaptureZone: "scrollbar-capture-zone"
                    }
                };
            },
            21908: function(t1, e1, r) {
                "use strict";
                var n = r(18426), i = r(93049).extendFlat, a = r(10721), o = r(87800).isTypedArray, s = r(87800).isArrayOrTypedArray;
                function l(t1) {
                    if (s(t1)) {
                        for(var e1 = 0, r = 0; r < t1.length; r++)e1 = Math.max(e1, l(t1[r]));
                        return e1;
                    }
                    return t1;
                }
                function c(t1, e1) {
                    return t1 + e1;
                }
                function u(t1) {
                    var e1, r = t1.slice(), n = 1 / 0, i = 0;
                    for(e1 = 0; e1 < r.length; e1++)o(r[e1]) ? r[e1] = Array.from(r[e1]) : s(r[e1]) || (r[e1] = [
                        r[e1]
                    ]), n = Math.min(n, r[e1].length), i = Math.max(i, r[e1].length);
                    if (n !== i) for(e1 = 0; e1 < r.length; e1++){
                        var a = i - r[e1].length;
                        a && (r[e1] = r[e1].concat(h(a)));
                    }
                    return r;
                }
                function h(t1) {
                    for(var e1 = new Array(t1), r = 0; r < t1; r++)e1[r] = "";
                    return e1;
                }
                function f(t1) {
                    return t1.calcdata.columns.reduce(function(e1, r) {
                        return r.xIndex < t1.xIndex ? e1 + r.columnWidth : e1;
                    }, 0);
                }
                function p(t1, e1) {
                    return Object.keys(t1).map(function(r) {
                        return i({}, t1[r], {
                            auxiliaryBlocks: e1
                        });
                    });
                }
                function d(t1, e1) {
                    for(var r, n = {}, i = 0, a = 0, o = {
                        firstRowIndex: null,
                        lastRowIndex: null,
                        rows: []
                    }, s = 0, l = 0, c = 0; c < t1.length; c++)r = t1[c], o.rows.push({
                        rowIndex: c,
                        rowHeight: r
                    }), ((a += r) >= e1 || c === t1.length - 1) && (n[i] = o, o.key = l++, o.firstRowIndex = s, o.lastRowIndex = c, o = {
                        firstRowIndex: null,
                        lastRowIndex: null,
                        rows: []
                    }, i += a, s = c + 1, a = 0);
                    return n;
                }
                t1.exports = function(t1, e1) {
                    var r = u(e1.cells.values), o = function(t1) {
                        return t1.slice(e1.header.values.length, t1.length);
                    }, m = u(e1.header.values);
                    m.length && !m[0].length && (m[0] = [
                        ""
                    ], m = u(m));
                    var g = m.concat(o(r).map(function() {
                        return h((m[0] || [
                            ""
                        ]).length);
                    })), y = e1.domain, v = Math.floor(t1._fullLayout._size.w * (y.x[1] - y.x[0])), x = Math.floor(t1._fullLayout._size.h * (y.y[1] - y.y[0])), _ = e1.header.values.length ? g[0].map(function() {
                        return e1.header.height;
                    }) : [
                        n.emptyHeaderHeight
                    ], b = r.length ? r[0].map(function() {
                        return e1.cells.height;
                    }) : [], w = _.reduce(c, 0), T = d(b, x - w + n.uplift), k = p(d(_, w), []), A = p(T, k), M = {}, S = e1._fullInput.columnorder;
                    s(S) && (S = Array.from(S)), S = S.concat(o(r.map(function(t1, e1) {
                        return e1;
                    })));
                    var E = g.map(function(t1, r) {
                        var n = s(e1.columnwidth) ? e1.columnwidth[Math.min(r, e1.columnwidth.length - 1)] : e1.columnwidth;
                        return a(n) ? Number(n) : 1;
                    }), C = E.reduce(c, 0);
                    E = E.map(function(t1) {
                        return t1 / C * v;
                    });
                    var L = Math.max(l(e1.header.line.width), l(e1.cells.line.width)), I = {
                        key: e1.uid + t1._context.staticPlot,
                        translateX: y.x[0] * t1._fullLayout._size.w,
                        translateY: t1._fullLayout._size.h * (1 - y.y[1]),
                        size: t1._fullLayout._size,
                        width: v,
                        maxLineWidth: L,
                        height: x,
                        columnOrder: S,
                        groupHeight: x,
                        rowBlocks: A,
                        headerRowBlocks: k,
                        scrollY: 0,
                        cells: i({}, e1.cells, {
                            values: r
                        }),
                        headerCells: i({}, e1.header, {
                            values: g
                        }),
                        gdColumns: g.map(function(t1) {
                            return t1[0];
                        }),
                        gdColumnsOriginalOrder: g.map(function(t1) {
                            return t1[0];
                        }),
                        prevPages: [
                            0,
                            0
                        ],
                        scrollbarState: {
                            scrollbarScrollInProgress: !1
                        },
                        columns: g.map(function(t1, e1) {
                            var r = M[t1];
                            return M[t1] = (r || 0) + 1, {
                                key: t1 + "__" + M[t1],
                                label: t1,
                                specIndex: e1,
                                xIndex: S[e1],
                                xScale: f,
                                x: void 0,
                                calcdata: void 0,
                                columnWidth: E[e1]
                            };
                        })
                    };
                    return I.columns.forEach(function(t1) {
                        t1.calcdata = I, t1.x = f(t1);
                    }), I;
                };
            },
            49618: function(t1, e1, r) {
                "use strict";
                var n = r(93049).extendFlat;
                e1.splitToPanels = function(t1) {
                    var e1 = [
                        0,
                        0
                    ], r = n({}, t1, {
                        key: "header",
                        type: "header",
                        page: 0,
                        prevPages: e1,
                        currentRepaint: [
                            null,
                            null
                        ],
                        dragHandle: !0,
                        values: t1.calcdata.headerCells.values[t1.specIndex],
                        rowBlocks: t1.calcdata.headerRowBlocks,
                        calcdata: n({}, t1.calcdata, {
                            cells: t1.calcdata.headerCells
                        })
                    });
                    return [
                        n({}, t1, {
                            key: "cells1",
                            type: "cells",
                            page: 0,
                            prevPages: e1,
                            currentRepaint: [
                                null,
                                null
                            ],
                            dragHandle: !1,
                            values: t1.calcdata.cells.values[t1.specIndex],
                            rowBlocks: t1.calcdata.rowBlocks
                        }),
                        n({}, t1, {
                            key: "cells2",
                            type: "cells",
                            page: 1,
                            prevPages: e1,
                            currentRepaint: [
                                null,
                                null
                            ],
                            dragHandle: !1,
                            values: t1.calcdata.cells.values[t1.specIndex],
                            rowBlocks: t1.calcdata.rowBlocks
                        }),
                        r
                    ];
                }, e1.splitToCells = function(t1) {
                    var e1 = function(t1) {
                        var e1 = t1.rowBlocks[t1.page], r = e1 ? e1.rows[0].rowIndex : 0;
                        return [
                            r,
                            e1 ? r + e1.rows.length : 0
                        ];
                    }(t1);
                    return (t1.values || []).slice(e1[0], e1[1]).map(function(r, n) {
                        return {
                            keyWithinBlock: n + ("string" == typeof r && r.match(/[<$&> ]/) ? "_keybuster_" + Math.random() : ""),
                            key: e1[0] + n,
                            column: t1,
                            calcdata: t1.calcdata,
                            page: t1.page,
                            rowBlocks: t1.rowBlocks,
                            value: r
                        };
                    });
                };
            },
            23281: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(92294), a = r(13792).N;
                t1.exports = function(t1, e1, r, o) {
                    function s(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    a(e1, o, s), s("columnwidth"), s("header.values"), s("header.format"), s("header.align"), s("header.prefix"), s("header.suffix"), s("header.height"), s("header.line.width"), s("header.line.color"), s("header.fill.color"), n.coerceFont(s, "header.font", o.font), function(t1, e1) {
                        for(var r = t1.columnorder || [], n = t1.header.values.length, i = r.slice(0, n), a = i.slice().sort(function(t1, e1) {
                            return t1 - e1;
                        }), o = i.map(function(t1) {
                            return a.indexOf(t1);
                        }), s = o.length; s < n; s++)o.push(s);
                        e1("columnorder", o);
                    }(e1, s), s("cells.values"), s("cells.format"), s("cells.align"), s("cells.prefix"), s("cells.suffix"), s("cells.height"), s("cells.line.width"), s("cells.line.color"), s("cells.fill.color"), n.coerceFont(s, "cells.font", o.font), e1._length = null;
                };
            },
            51671: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    attributes: r(92294),
                    supplyDefaults: r(23281),
                    calc: r(87522),
                    plot: r(84576),
                    moduleType: "trace",
                    name: "table",
                    basePlotModule: r(82662),
                    categories: [
                        "noOpacity"
                    ],
                    meta: {}
                };
            },
            84576: function(t1, e1, r) {
                "use strict";
                var n = r(18426), i = r(45568), a = r(34809), o = a.numberFormat, s = r(71293), l = r(62203), c = r(30635), u = r(34809).raiseToTop, h = r(34809).strTranslate, f = r(34809).cancelTransition, p = r(21908), d = r(49618), m = r(78766);
                function g(t1) {
                    return Math.ceil(t1.calcdata.maxLineWidth / 2);
                }
                function y(t1, e1) {
                    return "clip" + t1._fullLayout._uid + "_scrollAreaBottomClip_" + e1.key;
                }
                function v(t1, e1) {
                    return "clip" + t1._fullLayout._uid + "_columnBoundaryClippath_" + e1.calcdata.key + "_" + e1.specIndex;
                }
                function x(t1) {
                    return [].concat.apply([], t1.map(function(t1) {
                        return t1;
                    })).map(function(t1) {
                        return t1.__data__;
                    });
                }
                function _(t1, e1, r) {
                    var a = t1.selectAll("." + n.cn.scrollbarKit).data(s.repeat, s.keyFun);
                    a.enter().append("g").classed(n.cn.scrollbarKit, !0).style("shape-rendering", "geometricPrecision"), a.each(function(t1) {
                        var e1 = t1.scrollbarState;
                        e1.totalHeight = function(t1) {
                            var e1 = t1.rowBlocks;
                            return R(e1, e1.length - 1) + (e1.length ? F(e1[e1.length - 1], 1 / 0) : 1);
                        }(t1), e1.scrollableAreaHeight = t1.groupHeight - E(t1), e1.currentlyVisibleHeight = Math.min(e1.totalHeight, e1.scrollableAreaHeight), e1.ratio = e1.currentlyVisibleHeight / e1.totalHeight, e1.barLength = Math.max(e1.ratio * e1.currentlyVisibleHeight, n.goldenRatio * n.scrollbarWidth), e1.barWiggleRoom = e1.currentlyVisibleHeight - e1.barLength, e1.wiggleRoom = Math.max(0, e1.totalHeight - e1.scrollableAreaHeight), e1.topY = 0 === e1.barWiggleRoom ? 0 : t1.scrollY / e1.wiggleRoom * e1.barWiggleRoom, e1.bottomY = e1.topY + e1.barLength, e1.dragMultiplier = e1.wiggleRoom / e1.barWiggleRoom;
                    }).attr("transform", function(t1) {
                        var e1 = t1.width + n.scrollbarWidth / 2 + n.scrollbarOffset;
                        return h(e1, E(t1));
                    });
                    var o = a.selectAll("." + n.cn.scrollbar).data(s.repeat, s.keyFun);
                    o.enter().append("g").classed(n.cn.scrollbar, !0);
                    var l = o.selectAll("." + n.cn.scrollbarSlider).data(s.repeat, s.keyFun);
                    l.enter().append("g").classed(n.cn.scrollbarSlider, !0), l.attr("transform", function(t1) {
                        return h(0, t1.scrollbarState.topY || 0);
                    });
                    var c = l.selectAll("." + n.cn.scrollbarGlyph).data(s.repeat, s.keyFun);
                    c.enter().append("line").classed(n.cn.scrollbarGlyph, !0).attr("stroke", "black").attr("stroke-width", n.scrollbarWidth).attr("stroke-linecap", "round").attr("y1", n.scrollbarWidth / 2), c.attr("y2", function(t1) {
                        return t1.scrollbarState.barLength - n.scrollbarWidth / 2;
                    }).attr("stroke-opacity", function(t1) {
                        return t1.columnDragInProgress || !t1.scrollbarState.barWiggleRoom || r ? 0 : .4;
                    }), c.transition().delay(0).duration(0), c.transition().delay(n.scrollbarHideDelay).duration(n.scrollbarHideDuration).attr("stroke-opacity", 0);
                    var u = o.selectAll("." + n.cn.scrollbarCaptureZone).data(s.repeat, s.keyFun);
                    u.enter().append("line").classed(n.cn.scrollbarCaptureZone, !0).attr("stroke", "white").attr("stroke-opacity", .01).attr("stroke-width", n.scrollbarCaptureWidth).attr("stroke-linecap", "butt").attr("y1", 0).on("mousedown", function(r) {
                        var n = i.event.y, a = this.getBoundingClientRect(), o = r.scrollbarState, s = n - a.top, l = i.scale.linear().domain([
                            0,
                            o.scrollableAreaHeight
                        ]).range([
                            0,
                            o.totalHeight
                        ]).clamp(!0);
                        o.topY <= s && s <= o.bottomY || L(e1, t1, null, l(s - o.barLength / 2))(r);
                    }).call(i.behavior.drag().origin(function(t1) {
                        return i.event.stopPropagation(), t1.scrollbarState.scrollbarScrollInProgress = !0, t1;
                    }).on("drag", L(e1, t1)).on("dragend", function() {})), u.attr("y2", function(t1) {
                        return t1.scrollbarState.scrollableAreaHeight;
                    }), e1._context.staticPlot && (c.remove(), u.remove());
                }
                function b(t1, e1, r, a) {
                    var o = function(t1) {
                        var e1 = t1.selectAll("." + n.cn.columnCells).data(s.repeat, s.keyFun);
                        return e1.enter().append("g").classed(n.cn.columnCells, !0), e1.exit().remove(), e1;
                    }(r), c = function(t1) {
                        var e1 = t1.selectAll("." + n.cn.columnCell).data(d.splitToCells, function(t1) {
                            return t1.keyWithinBlock;
                        });
                        return e1.enter().append("g").classed(n.cn.columnCell, !0), e1.exit().remove(), e1;
                    }(o);
                    !function(t1) {
                        t1.each(function(t1, e1) {
                            var r = t1.calcdata.cells.font, n = t1.column.specIndex, i = {
                                size: k(r.size, n, e1),
                                color: k(r.color, n, e1),
                                family: k(r.family, n, e1),
                                weight: k(r.weight, n, e1),
                                style: k(r.style, n, e1),
                                variant: k(r.variant, n, e1),
                                textcase: k(r.textcase, n, e1),
                                lineposition: k(r.lineposition, n, e1),
                                shadow: k(r.shadow, n, e1)
                            };
                            t1.rowNumber = t1.key, t1.align = k(t1.calcdata.cells.align, n, e1), t1.cellBorderWidth = k(t1.calcdata.cells.line.width, n, e1), t1.font = i;
                        });
                    }(c);
                    var u = function(t1) {
                        var e1 = t1.selectAll("." + n.cn.cellRect).data(s.repeat, function(t1) {
                            return t1.keyWithinBlock;
                        });
                        return e1.enter().append("rect").classed(n.cn.cellRect, !0), e1;
                    }(c);
                    !function(t1) {
                        t1.attr("width", function(t1) {
                            return t1.column.columnWidth;
                        }).attr("stroke-width", function(t1) {
                            return t1.cellBorderWidth;
                        }).each(function(t1) {
                            var e1 = i.select(this);
                            m.stroke(e1, k(t1.calcdata.cells.line.color, t1.column.specIndex, t1.rowNumber)), m.fill(e1, k(t1.calcdata.cells.fill.color, t1.column.specIndex, t1.rowNumber));
                        });
                    }(u);
                    var h = function(t1) {
                        var e1 = t1.selectAll("." + n.cn.cellTextHolder).data(s.repeat, function(t1) {
                            return t1.keyWithinBlock;
                        });
                        return e1.enter().append("g").classed(n.cn.cellTextHolder, !0).style("shape-rendering", "geometricPrecision"), e1;
                    }(c), f = function(t1) {
                        var e1 = t1.selectAll("." + n.cn.cellText).data(s.repeat, function(t1) {
                            return t1.keyWithinBlock;
                        });
                        return e1.enter().append("text").classed(n.cn.cellText, !0).style("cursor", function() {
                            return "auto";
                        }).on("mousedown", function() {
                            i.event.stopPropagation();
                        }), e1;
                    }(h);
                    !function(t1) {
                        t1.each(function(t1) {
                            l.font(i.select(this), t1.font);
                        });
                    }(f), w(f, e1, a, t1), D(c);
                }
                function w(t1, e1, r, a) {
                    t1.text(function(t1) {
                        var e1 = t1.column.specIndex, r = t1.rowNumber, i = t1.value, a = "string" == typeof i, s = a && i.match(/<br>/i), l = !a || s;
                        t1.mayHaveMarkup = a && i.match(/[<&>]/);
                        var c, u = "string" == typeof (c = i) && c.match(n.latexCheck);
                        t1.latex = u;
                        var h, f, p = u ? "" : k(t1.calcdata.cells.prefix, e1, r) || "", d = u ? "" : k(t1.calcdata.cells.suffix, e1, r) || "", m = u ? null : k(t1.calcdata.cells.format, e1, r) || null, g = p + (m ? o(m)(t1.value) : t1.value) + d;
                        if (t1.wrappingNeeded = !t1.wrapped && !l && !u && (h = T(g)), t1.cellHeightMayIncrease = s || u || t1.mayHaveMarkup || (void 0 === h ? T(g) : h), t1.needsConvertToTspans = t1.mayHaveMarkup || t1.wrappingNeeded || t1.latex, t1.wrappingNeeded) {
                            var y = (" " === n.wrapSplitCharacter ? g.replace(/<a href=/gi, "<a_href=") : g).split(n.wrapSplitCharacter), v = " " === n.wrapSplitCharacter ? y.map(function(t1) {
                                return t1.replace(/<a_href=/gi, "<a href=");
                            }) : y;
                            t1.fragments = v.map(function(t1) {
                                return {
                                    text: t1,
                                    width: null
                                };
                            }), t1.fragments.push({
                                fragment: n.wrapSpacer,
                                width: null
                            }), f = v.join(n.lineBreaker) + n.lineBreaker + n.wrapSpacer;
                        } else delete t1.fragments, f = g;
                        return f;
                    }).attr("dy", function(t1) {
                        return t1.needsConvertToTspans ? 0 : "0.75em";
                    }).each(function(t1) {
                        var o = this, s = i.select(o), l = t1.wrappingNeeded ? P : z;
                        t1.needsConvertToTspans ? c.convertToTspans(s, a, l(r, o, e1, a, t1)) : i.select(o.parentNode).attr("transform", function(t1) {
                            return h(O(t1), n.cellPad);
                        }).attr("text-anchor", function(t1) {
                            return ({
                                left: "start",
                                center: "middle",
                                right: "end"
                            })[t1.align];
                        });
                    });
                }
                function T(t1) {
                    return -1 !== t1.indexOf(n.wrapSplitCharacter);
                }
                function k(t1, e1, r) {
                    if (a.isArrayOrTypedArray(t1)) {
                        var n = t1[Math.min(e1, t1.length - 1)];
                        return a.isArrayOrTypedArray(n) ? n[Math.min(r, n.length - 1)] : n;
                    }
                    return t1;
                }
                function A(t1, e1, r) {
                    t1.transition().ease(n.releaseTransitionEase).duration(n.releaseTransitionDuration).attr("transform", h(e1.x, r));
                }
                function M(t1) {
                    return "cells" === t1.type;
                }
                function S(t1) {
                    return "header" === t1.type;
                }
                function E(t1) {
                    return (t1.rowBlocks.length ? t1.rowBlocks[0].auxiliaryBlocks : []).reduce(function(t1, e1) {
                        return t1 + F(e1, 1 / 0);
                    }, 0);
                }
                function C(t1, e1, r) {
                    var n = x(e1)[0];
                    if (void 0 !== n) {
                        var i = n.rowBlocks, a = n.calcdata, o = R(i, i.length), s = n.calcdata.groupHeight - E(n), l = a.scrollY = Math.max(0, Math.min(o - s, a.scrollY)), c = function(t1, e1, r) {
                            for(var n = [], i = 0, a = 0; a < t1.length; a++){
                                for(var o = t1[a], s = o.rows, l = 0, c = 0; c < s.length; c++)l += s[c].rowHeight;
                                o.allRowsHeight = l, e1 < i + l && e1 + r > i && n.push(a), i += l;
                            }
                            return n;
                        }(i, l, s);
                        1 === c.length && (c[0] === i.length - 1 ? c.unshift(c[0] - 1) : c.push(c[0] + 1)), c[0] % 2 && c.reverse(), e1.each(function(t1, e1) {
                            t1.page = c[e1], t1.scrollY = l;
                        }), e1.attr("transform", function(t1) {
                            var e1 = R(t1.rowBlocks, t1.page) - t1.scrollY;
                            return h(0, e1);
                        }), t1 && (I(t1, r, e1, c, n.prevPages, n, 0), I(t1, r, e1, c, n.prevPages, n, 1), _(r, t1));
                    }
                }
                function L(t1, e1, r, a) {
                    return function(o) {
                        var s = o.calcdata ? o.calcdata : o, l = e1.filter(function(t1) {
                            return s.key === t1.key;
                        }), c = r || s.scrollbarState.dragMultiplier, u = s.scrollY;
                        s.scrollY = void 0 === a ? s.scrollY + c * i.event.dy : a;
                        var h = l.selectAll("." + n.cn.yColumn).selectAll("." + n.cn.columnBlock).filter(M);
                        return C(t1, h, l), s.scrollY === u;
                    };
                }
                function I(t1, e1, r, n, i, a, o) {
                    n[o] !== i[o] && (clearTimeout(a.currentRepaint[o]), a.currentRepaint[o] = setTimeout(function() {
                        var a = r.filter(function(t1, e1) {
                            return e1 === o && n[e1] !== i[e1];
                        });
                        b(t1, e1, a, r), i[o] = n[o];
                    }));
                }
                function P(t1, e1, r, a) {
                    return function() {
                        var o = i.select(e1.parentNode);
                        o.each(function(t1) {
                            var e1 = t1.fragments;
                            o.selectAll("tspan.line").each(function(t1, r) {
                                e1[r].width = this.getComputedTextLength();
                            });
                            var r, i, a = e1[e1.length - 1].width, s = e1.slice(0, -1), l = [], c = 0, u = t1.column.columnWidth - 2 * n.cellPad;
                            for(t1.value = ""; s.length;)c + (i = (r = s.shift()).width + a) > u && (t1.value += l.join(n.wrapSpacer) + n.lineBreaker, l = [], c = 0), l.push(r.text), c += i;
                            c && (t1.value += l.join(n.wrapSpacer)), t1.wrapped = !0;
                        }), o.selectAll("tspan.line").remove(), w(o.select("." + n.cn.cellText), r, t1, a), i.select(e1.parentNode.parentNode).call(D);
                    };
                }
                function z(t1, e1, r, a, o) {
                    return function() {
                        if (!o.settledY) {
                            var s = i.select(e1.parentNode), l = N(o), c = o.key - l.firstRowIndex, u = l.rows[c].rowHeight, f = o.cellHeightMayIncrease ? e1.parentNode.getBoundingClientRect().height + 2 * n.cellPad : u, p = Math.max(f, u);
                            p - l.rows[c].rowHeight && (l.rows[c].rowHeight = p, t1.selectAll("." + n.cn.columnCell).call(D), C(null, t1.filter(M), 0), _(r, a, !0)), s.attr("transform", function() {
                                var t1 = this, e1 = t1.parentNode.getBoundingClientRect(), r = i.select(t1.parentNode).select("." + n.cn.cellRect).node().getBoundingClientRect(), a = t1.transform.baseVal.consolidate(), s = r.top - e1.top + (a ? a.matrix.f : n.cellPad);
                                return h(O(o, i.select(t1.parentNode).select("." + n.cn.cellTextHolder).node().getBoundingClientRect().width), s);
                            }), o.settledY = !0;
                        }
                    };
                }
                function O(t1, e1) {
                    switch(t1.align){
                        case "left":
                        default:
                            return n.cellPad;
                        case "right":
                            return t1.column.columnWidth - (e1 || 0) - n.cellPad;
                        case "center":
                            return (t1.column.columnWidth - (e1 || 0)) / 2;
                    }
                }
                function D(t1) {
                    t1.attr("transform", function(t1) {
                        var e1 = t1.rowBlocks[0].auxiliaryBlocks.reduce(function(t1, e1) {
                            return t1 + F(e1, 1 / 0);
                        }, 0), r = F(N(t1), t1.key);
                        return h(0, r + e1);
                    }).selectAll("." + n.cn.cellRect).attr("height", function(t1) {
                        var e1, r;
                        return (e1 = N(t1), r = t1.key, e1.rows[r - e1.firstRowIndex]).rowHeight;
                    });
                }
                function R(t1, e1) {
                    for(var r = 0, n = e1 - 1; n >= 0; n--)r += B(t1[n]);
                    return r;
                }
                function F(t1, e1) {
                    for(var r = 0, n = 0; n < t1.rows.length && t1.rows[n].rowIndex < e1; n++)r += t1.rows[n].rowHeight;
                    return r;
                }
                function B(t1) {
                    var e1 = t1.allRowsHeight;
                    if (void 0 !== e1) return e1;
                    for(var r = 0, n = 0; n < t1.rows.length; n++)r += t1.rows[n].rowHeight;
                    return t1.allRowsHeight = r, r;
                }
                function N(t1) {
                    return t1.rowBlocks[t1.page];
                }
                t1.exports = function(t1, e1) {
                    var r = !t1._context.staticPlot, a = t1._fullLayout._paper.selectAll("." + n.cn.table).data(e1.map(function(e1) {
                        var r = s.unwrap(e1).trace;
                        return p(t1, r);
                    }), s.keyFun);
                    a.exit().remove(), a.enter().append("g").classed(n.cn.table, !0).attr("overflow", "visible").style("box-sizing", "content-box").style("position", "absolute").style("left", 0).style("overflow", "visible").style("shape-rendering", "crispEdges").style("pointer-events", "all"), a.attr("width", function(t1) {
                        return t1.width + t1.size.l + t1.size.r;
                    }).attr("height", function(t1) {
                        return t1.height + t1.size.t + t1.size.b;
                    }).attr("transform", function(t1) {
                        return h(t1.translateX, t1.translateY);
                    });
                    var o = a.selectAll("." + n.cn.tableControlView).data(s.repeat, s.keyFun), c = o.enter().append("g").classed(n.cn.tableControlView, !0).style("box-sizing", "content-box");
                    if (r) {
                        var m = "onwheel" in document ? "wheel" : "mousewheel";
                        c.on("mousemove", function(e1) {
                            o.filter(function(t1) {
                                return e1 === t1;
                            }).call(_, t1);
                        }).on(m, function(e1) {
                            if (!e1.scrollbarState.wheeling) {
                                e1.scrollbarState.wheeling = !0;
                                var r = e1.scrollY + i.event.deltaY;
                                L(t1, o, null, r)(e1) || (i.event.stopPropagation(), i.event.preventDefault()), e1.scrollbarState.wheeling = !1;
                            }
                        }).call(_, t1, !0);
                    }
                    o.attr("transform", function(t1) {
                        return h(t1.size.l, t1.size.t);
                    });
                    var w = o.selectAll("." + n.cn.scrollBackground).data(s.repeat, s.keyFun);
                    w.enter().append("rect").classed(n.cn.scrollBackground, !0).attr("fill", "none"), w.attr("width", function(t1) {
                        return t1.width;
                    }).attr("height", function(t1) {
                        return t1.height;
                    }), o.each(function(e1) {
                        l.setClipUrl(i.select(this), y(t1, e1), t1);
                    });
                    var T = o.selectAll("." + n.cn.yColumn).data(function(t1) {
                        return t1.columns;
                    }, s.keyFun);
                    T.enter().append("g").classed(n.cn.yColumn, !0), T.exit().remove(), T.attr("transform", function(t1) {
                        return h(t1.x, 0);
                    }), r && T.call(i.behavior.drag().origin(function(e1) {
                        return A(i.select(this), e1, -n.uplift), u(this), e1.calcdata.columnDragInProgress = !0, _(o.filter(function(t1) {
                            return e1.calcdata.key === t1.key;
                        }), t1), e1;
                    }).on("drag", function(t1) {
                        var e1 = i.select(this), r = function(e1) {
                            return (t1 === e1 ? i.event.x : e1.x) + e1.columnWidth / 2;
                        };
                        t1.x = Math.max(-n.overdrag, Math.min(t1.calcdata.width + n.overdrag - t1.columnWidth, i.event.x)), x(T).filter(function(e1) {
                            return e1.calcdata.key === t1.calcdata.key;
                        }).sort(function(t1, e1) {
                            return r(t1) - r(e1);
                        }).forEach(function(e1, r) {
                            e1.xIndex = r, e1.x = t1 === e1 ? e1.x : e1.xScale(e1);
                        }), T.filter(function(e1) {
                            return t1 !== e1;
                        }).transition().ease(n.transitionEase).duration(n.transitionDuration).attr("transform", function(t1) {
                            return h(t1.x, 0);
                        }), e1.call(f).attr("transform", h(t1.x, -n.uplift));
                    }).on("dragend", function(e1) {
                        var r = i.select(this), n = e1.calcdata;
                        e1.x = e1.xScale(e1), e1.calcdata.columnDragInProgress = !1, A(r, e1, 0), function(t1, e1, r) {
                            var n = e1.gdColumnsOriginalOrder;
                            e1.gdColumns.sort(function(t1, e1) {
                                return r[n.indexOf(t1)] - r[n.indexOf(e1)];
                            }), e1.columnorder = r, t1.emit("plotly_restyle");
                        }(t1, n, n.columns.map(function(t1) {
                            return t1.xIndex;
                        }));
                    })), T.each(function(e1) {
                        l.setClipUrl(i.select(this), v(t1, e1), t1);
                    });
                    var k = T.selectAll("." + n.cn.columnBlock).data(d.splitToPanels, s.keyFun);
                    k.enter().append("g").classed(n.cn.columnBlock, !0).attr("id", function(t1) {
                        return t1.key;
                    }), k.style("cursor", function(t1) {
                        return t1.dragHandle ? "ew-resize" : t1.calcdata.scrollbarState.barWiggleRoom ? "ns-resize" : "default";
                    });
                    var E = k.filter(S), I = k.filter(M);
                    r && I.call(i.behavior.drag().origin(function(t1) {
                        return i.event.stopPropagation(), t1;
                    }).on("drag", L(t1, o, -1)).on("dragend", function() {})), b(t1, o, E, k), b(t1, o, I, k);
                    var P = o.selectAll("." + n.cn.scrollAreaClip).data(s.repeat, s.keyFun);
                    P.enter().append("clipPath").classed(n.cn.scrollAreaClip, !0).attr("id", function(e1) {
                        return y(t1, e1);
                    });
                    var z = P.selectAll("." + n.cn.scrollAreaClipRect).data(s.repeat, s.keyFun);
                    z.enter().append("rect").classed(n.cn.scrollAreaClipRect, !0).attr("x", -n.overdrag).attr("y", -n.uplift).attr("fill", "none"), z.attr("width", function(t1) {
                        return t1.width + 2 * n.overdrag;
                    }).attr("height", function(t1) {
                        return t1.height + n.uplift;
                    }), T.selectAll("." + n.cn.columnBoundary).data(s.repeat, s.keyFun).enter().append("g").classed(n.cn.columnBoundary, !0);
                    var O = T.selectAll("." + n.cn.columnBoundaryClippath).data(s.repeat, s.keyFun);
                    O.enter().append("clipPath").classed(n.cn.columnBoundaryClippath, !0), O.attr("id", function(e1) {
                        return v(t1, e1);
                    });
                    var D = O.selectAll("." + n.cn.columnBoundaryRect).data(s.repeat, s.keyFun);
                    D.enter().append("rect").classed(n.cn.columnBoundaryRect, !0).attr("fill", "none"), D.attr("width", function(t1) {
                        return t1.columnWidth + 2 * g(t1);
                    }).attr("height", function(t1) {
                        return t1.calcdata.height + 2 * g(t1) + n.uplift;
                    }).attr("x", function(t1) {
                        return -g(t1);
                    }).attr("y", function(t1) {
                        return -g(t1);
                    }), C(null, I, o);
                };
            },
            71856: function(t1, e1, r) {
                "use strict";
                var n = r(3208).rb, i = r(3208).ay, a = r(87163), o = r(13792).u, s = r(55412), l = r(56708), c = r(43236), u = r(93049).extendFlat, h = r(94850).k;
                t1.exports = {
                    labels: l.labels,
                    parents: l.parents,
                    values: l.values,
                    branchvalues: l.branchvalues,
                    count: l.count,
                    level: l.level,
                    maxdepth: l.maxdepth,
                    tiling: {
                        packing: {
                            valType: "enumerated",
                            values: [
                                "squarify",
                                "binary",
                                "dice",
                                "slice",
                                "slice-dice",
                                "dice-slice"
                            ],
                            dflt: "squarify",
                            editType: "plot"
                        },
                        squarifyratio: {
                            valType: "number",
                            min: 1,
                            dflt: 1,
                            editType: "plot"
                        },
                        flip: {
                            valType: "flaglist",
                            flags: [
                                "x",
                                "y"
                            ],
                            dflt: "",
                            editType: "plot"
                        },
                        pad: {
                            valType: "number",
                            min: 0,
                            dflt: 3,
                            editType: "plot"
                        },
                        editType: "calc"
                    },
                    marker: u({
                        pad: {
                            t: {
                                valType: "number",
                                min: 0,
                                editType: "plot"
                            },
                            l: {
                                valType: "number",
                                min: 0,
                                editType: "plot"
                            },
                            r: {
                                valType: "number",
                                min: 0,
                                editType: "plot"
                            },
                            b: {
                                valType: "number",
                                min: 0,
                                editType: "plot"
                            },
                            editType: "calc"
                        },
                        colors: l.marker.colors,
                        pattern: h,
                        depthfade: {
                            valType: "enumerated",
                            values: [
                                !0,
                                !1,
                                "reversed"
                            ],
                            editType: "style"
                        },
                        line: l.marker.line,
                        cornerradius: {
                            valType: "number",
                            min: 0,
                            dflt: 0,
                            editType: "plot"
                        },
                        editType: "calc"
                    }, a("marker", {
                        colorAttr: "colors",
                        anim: !1
                    })),
                    pathbar: {
                        visible: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "plot"
                        },
                        side: {
                            valType: "enumerated",
                            values: [
                                "top",
                                "bottom"
                            ],
                            dflt: "top",
                            editType: "plot"
                        },
                        edgeshape: {
                            valType: "enumerated",
                            values: [
                                ">",
                                "<",
                                "|",
                                "/",
                                "\\"
                            ],
                            dflt: ">",
                            editType: "plot"
                        },
                        thickness: {
                            valType: "number",
                            min: 12,
                            editType: "plot"
                        },
                        textfont: u({}, s.textfont, {}),
                        editType: "calc"
                    },
                    text: s.text,
                    textinfo: l.textinfo,
                    texttemplate: i({
                        editType: "plot"
                    }, {
                        keys: c.eventDataKeys.concat([
                            "label",
                            "value"
                        ])
                    }),
                    hovertext: s.hovertext,
                    hoverinfo: l.hoverinfo,
                    hovertemplate: n({}, {
                        keys: c.eventDataKeys
                    }),
                    textfont: s.textfont,
                    insidetextfont: s.insidetextfont,
                    outsidetextfont: u({}, s.outsidetextfont, {}),
                    textposition: {
                        valType: "enumerated",
                        values: [
                            "top left",
                            "top center",
                            "top right",
                            "middle left",
                            "middle center",
                            "middle right",
                            "bottom left",
                            "bottom center",
                            "bottom right"
                        ],
                        dflt: "top left",
                        editType: "plot"
                    },
                    sort: s.sort,
                    root: l.root,
                    domain: o({
                        name: "treemap",
                        trace: !0,
                        editType: "calc"
                    })
                };
            },
            69784: function(t1, e1, r) {
                "use strict";
                var n = r(44122);
                e1.name = "treemap", e1.plot = function(t1, r, i, a) {
                    n.plotBasePlot(e1.name, t1, r, i, a);
                }, e1.clean = function(t1, r, i, a) {
                    n.cleanBasePlot(e1.name, t1, r, i, a);
                };
            },
            38848: function(t1, e1, r) {
                "use strict";
                var n = r(14852);
                e1._ = function(t1, e1) {
                    return n.calc(t1, e1);
                }, e1.t = function(t1) {
                    return n._runCrossTraceCalc("treemap", t1);
                };
            },
            43236: function(t1) {
                "use strict";
                t1.exports = {
                    CLICK_TRANSITION_TIME: 750,
                    CLICK_TRANSITION_EASING: "poly",
                    eventDataKeys: [
                        "currentPath",
                        "root",
                        "entry",
                        "percentRoot",
                        "percentEntry",
                        "percentParent"
                    ],
                    gapWithPathbar: 1
                };
            },
            95719: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(71856), a = r(78766), o = r(13792).N, s = r(17550).handleText, l = r(56155).TEXTPAD, c = r(46979).handleMarkerDefaults, u = r(88856), h = u.hasColorscale, f = u.handleDefaults;
                t1.exports = function(t1, e1, r, u) {
                    function p(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    var d = p("labels"), m = p("parents");
                    if (d && d.length && m && m.length) {
                        var g = p("values");
                        g && g.length ? p("branchvalues") : p("count"), p("level"), p("maxdepth"), "squarify" === p("tiling.packing") && p("tiling.squarifyratio"), p("tiling.flip"), p("tiling.pad");
                        var y = p("text");
                        p("texttemplate"), e1.texttemplate || p("textinfo", n.isArrayOrTypedArray(y) ? "text+label" : "label"), p("hovertext"), p("hovertemplate");
                        var v = p("pathbar.visible");
                        s(t1, e1, u, p, "auto", {
                            hasPathbar: v,
                            moduleHasSelected: !1,
                            moduleHasUnselected: !1,
                            moduleHasConstrain: !1,
                            moduleHasCliponaxis: !1,
                            moduleHasTextangle: !1,
                            moduleHasInsideanchor: !1
                        }), p("textposition");
                        var x = -1 !== e1.textposition.indexOf("bottom");
                        c(t1, e1, u, p), (e1._hasColorscale = h(t1, "marker", "colors") || (t1.marker || {}).coloraxis) ? f(t1, e1, u, p, {
                            prefix: "marker.",
                            cLetter: "c"
                        }) : p("marker.depthfade", !(e1.marker.colors || []).length);
                        var _ = 2 * e1.textfont.size;
                        p("marker.pad.t", x ? _ / 4 : _), p("marker.pad.l", _ / 4), p("marker.pad.r", _ / 4), p("marker.pad.b", x ? _ : _ / 4), p("marker.cornerradius"), e1._hovered = {
                            marker: {
                                line: {
                                    width: 2,
                                    color: a.contrast(u.paper_bgcolor)
                                }
                            }
                        }, v && (p("pathbar.thickness", e1.pathbar.textfont.size + 2 * l), p("pathbar.side"), p("pathbar.edgeshape")), p("sort"), p("root.color"), o(e1, u, p), e1._length = null;
                    } else e1.visible = !1;
                };
            },
            41567: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(33108), a = r(84102).clearMinTextSize, o = r(6851).resizeText, s = r(95709);
                t1.exports = function(t1, e1, r, l, c) {
                    var u, h, f = c.type, p = c.drawDescendants, d = t1._fullLayout, m = d["_" + f + "layer"], g = !r;
                    a(f, d), (u = m.selectAll("g.trace." + f).data(e1, function(t1) {
                        return t1[0].trace.uid;
                    })).enter().append("g").classed("trace", !0).classed(f, !0), u.order(), !d.uniformtext.mode && i.hasTransition(r) ? (l && (h = l()), n.transition().duration(r.duration).ease(r.easing).each("end", function() {
                        h && h();
                    }).each("interrupt", function() {
                        h && h();
                    }).each(function() {
                        m.selectAll("g.trace").each(function(e1) {
                            s(t1, e1, this, r, p);
                        });
                    })) : (u.each(function(e1) {
                        s(t1, e1, this, r, p);
                    }), d.uniformtext.mode && o(t1, m.selectAll(".trace"), f)), g && u.exit().remove();
                };
            },
            17010: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(34809), a = r(62203), o = r(30635), s = r(11995), l = r(92080).styleOne, c = r(43236), u = r(33108), h = r(44691), f = !0;
                t1.exports = function(t1, e1, r, p, d) {
                    var m = d.barDifY, g = d.width, y = d.height, v = d.viewX, x = d.viewY, _ = d.pathSlice, b = d.toMoveInsideSlice, w = d.strTransform, T = d.hasTransition, k = d.handleSlicesExit, A = d.makeUpdateSliceInterpolator, M = d.makeUpdateTextInterpolator, S = {}, E = t1._context.staticPlot, C = t1._fullLayout, L = e1[0], I = L.trace, P = L.hierarchy, z = g / I._entryDepth, O = u.listPath(r.data, "id"), D = s(P.copy(), [
                        g,
                        y
                    ], {
                        packing: "dice",
                        pad: {
                            inner: 0,
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0
                        }
                    }).descendants();
                    (D = D.filter(function(t1) {
                        var e1 = O.indexOf(t1.data.id);
                        return -1 !== e1 && (t1.x0 = z * e1, t1.x1 = z * (e1 + 1), t1.y0 = m, t1.y1 = m + y, t1.onPathbar = !0, !0);
                    })).reverse(), (p = p.data(D, u.getPtId)).enter().append("g").classed("pathbar", !0), k(p, f, S, [
                        g,
                        y
                    ], _), p.order();
                    var R = p;
                    T && (R = R.transition().each("end", function() {
                        var e1 = n.select(this);
                        u.setSliceCursor(e1, t1, {
                            hideOnRoot: !1,
                            hideOnLeaves: !1,
                            isTransitioning: !1
                        });
                    })), R.each(function(s) {
                        s._x0 = v(s.x0), s._x1 = v(s.x1), s._y0 = x(s.y0), s._y1 = x(s.y1), s._hoverX = v(s.x1 - Math.min(g, y) / 2), s._hoverY = x(s.y1 - y / 2);
                        var p = n.select(this), d = i.ensureSingle(p, "path", "surface", function(t1) {
                            t1.style("pointer-events", E ? "none" : "all");
                        });
                        T ? d.transition().attrTween("d", function(t1) {
                            var e1 = A(t1, f, S, [
                                g,
                                y
                            ]);
                            return function(t1) {
                                return _(e1(t1));
                            };
                        }) : d.attr("d", _), p.call(h, r, t1, e1, {
                            styleOne: l,
                            eventDataKeys: c.eventDataKeys,
                            transitionTime: c.CLICK_TRANSITION_TIME,
                            transitionEasing: c.CLICK_TRANSITION_EASING
                        }).call(u.setSliceCursor, t1, {
                            hideOnRoot: !1,
                            hideOnLeaves: !1,
                            isTransitioning: t1._transitioning
                        }), d.call(l, s, I, t1, {
                            hovered: !1
                        }), s._text = (u.getPtLabel(s) || "").split("<br>").join(" ") || "";
                        var m = i.ensureSingle(p, "g", "slicetext"), k = i.ensureSingle(m, "text", "", function(t1) {
                            t1.attr("data-notex", 1);
                        }), L = i.ensureUniformFontSize(t1, u.determineTextFont(I, s, C.font, {
                            onPathbar: !0
                        }));
                        k.text(s._text || " ").classed("slicetext", !0).attr("text-anchor", "start").call(a.font, L).call(o.convertToTspans, t1), s.textBB = a.bBox(k.node()), s.transform = b(s, {
                            fontSize: L.size,
                            onPathbar: !0
                        }), s.transform.fontSize = L.size, T ? k.transition().attrTween("transform", function(t1) {
                            var e1 = M(t1, f, S, [
                                g,
                                y
                            ]);
                            return function(t1) {
                                return w(e1(t1));
                            };
                        }) : k.attr("transform", w(s));
                    });
                };
            },
            50916: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(34809), a = r(62203), o = r(30635), s = r(11995), l = r(92080).styleOne, c = r(43236), u = r(33108), h = r(44691), f = r(19718).formatSliceLabel, p = !1;
                t1.exports = function(t1, e1, r, d, m) {
                    var g = m.width, y = m.height, v = m.viewX, x = m.viewY, _ = m.pathSlice, b = m.toMoveInsideSlice, w = m.strTransform, T = m.hasTransition, k = m.handleSlicesExit, A = m.makeUpdateSliceInterpolator, M = m.makeUpdateTextInterpolator, S = m.prevEntry, E = t1._context.staticPlot, C = t1._fullLayout, L = e1[0].trace, I = -1 !== L.textposition.indexOf("left"), P = -1 !== L.textposition.indexOf("right"), z = -1 !== L.textposition.indexOf("bottom"), O = !z && !L.marker.pad.t || z && !L.marker.pad.b, D = s(r, [
                        g,
                        y
                    ], {
                        packing: L.tiling.packing,
                        squarifyratio: L.tiling.squarifyratio,
                        flipX: L.tiling.flip.indexOf("x") > -1,
                        flipY: L.tiling.flip.indexOf("y") > -1,
                        pad: {
                            inner: L.tiling.pad,
                            top: L.marker.pad.t,
                            left: L.marker.pad.l,
                            right: L.marker.pad.r,
                            bottom: L.marker.pad.b
                        }
                    }).descendants(), R = 1 / 0, F = -1 / 0;
                    D.forEach(function(t1) {
                        var e1 = t1.depth;
                        e1 >= L._maxDepth ? (t1.x0 = t1.x1 = (t1.x0 + t1.x1) / 2, t1.y0 = t1.y1 = (t1.y0 + t1.y1) / 2) : (R = Math.min(R, e1), F = Math.max(F, e1));
                    }), d = d.data(D, u.getPtId), L._maxVisibleLayers = isFinite(F) ? F - R + 1 : 0, d.enter().append("g").classed("slice", !0), k(d, p, {}, [
                        g,
                        y
                    ], _), d.order();
                    var B = null;
                    if (T && S) {
                        var N = u.getPtId(S);
                        d.each(function(t1) {
                            null === B && u.getPtId(t1) === N && (B = {
                                x0: t1.x0,
                                x1: t1.x1,
                                y0: t1.y0,
                                y1: t1.y1
                            });
                        });
                    }
                    var j = function() {
                        return B || {
                            x0: 0,
                            x1: g,
                            y0: 0,
                            y1: y
                        };
                    }, U = d;
                    return T && (U = U.transition().each("end", function() {
                        var e1 = n.select(this);
                        u.setSliceCursor(e1, t1, {
                            hideOnRoot: !0,
                            hideOnLeaves: !1,
                            isTransitioning: !1
                        });
                    })), U.each(function(s) {
                        var d = u.isHeader(s, L);
                        s._x0 = v(s.x0), s._x1 = v(s.x1), s._y0 = x(s.y0), s._y1 = x(s.y1), s._hoverX = v(s.x1 - L.marker.pad.r), s._hoverY = x(z ? s.y1 - L.marker.pad.b / 2 : s.y0 + L.marker.pad.t / 2);
                        var m = n.select(this), k = i.ensureSingle(m, "path", "surface", function(t1) {
                            t1.style("pointer-events", E ? "none" : "all");
                        });
                        T ? k.transition().attrTween("d", function(t1) {
                            var e1 = A(t1, p, j(), [
                                g,
                                y
                            ]);
                            return function(t1) {
                                return _(e1(t1));
                            };
                        }) : k.attr("d", _), m.call(h, r, t1, e1, {
                            styleOne: l,
                            eventDataKeys: c.eventDataKeys,
                            transitionTime: c.CLICK_TRANSITION_TIME,
                            transitionEasing: c.CLICK_TRANSITION_EASING
                        }).call(u.setSliceCursor, t1, {
                            isTransitioning: t1._transitioning
                        }), k.call(l, s, L, t1, {
                            hovered: !1
                        }), s.x0 === s.x1 || s.y0 === s.y1 ? s._text = "" : s._text = d ? O ? "" : u.getPtLabel(s) || "" : f(s, r, L, e1, C) || "";
                        var S = i.ensureSingle(m, "g", "slicetext"), D = i.ensureSingle(S, "text", "", function(t1) {
                            t1.attr("data-notex", 1);
                        }), R = i.ensureUniformFontSize(t1, u.determineTextFont(L, s, C.font)), F = s._text || " ", B = d && -1 === F.indexOf("<br>");
                        D.text(F).classed("slicetext", !0).attr("text-anchor", P ? "end" : I || B ? "start" : "middle").call(a.font, R).call(o.convertToTspans, t1), s.textBB = a.bBox(D.node()), s.transform = b(s, {
                            fontSize: R.size,
                            isHeader: d
                        }), s.transform.fontSize = R.size, T ? D.transition().attrTween("transform", function(t1) {
                            var e1 = M(t1, p, j(), [
                                g,
                                y
                            ]);
                            return function(t1) {
                                return w(e1(t1));
                            };
                        }) : D.attr("transform", w(s));
                    }), B;
                };
            },
            36141: function(t1) {
                "use strict";
                t1.exports = function t1(e1, r, n) {
                    var i;
                    n.swapXY && (i = e1.x0, e1.x0 = e1.y0, e1.y0 = i, i = e1.x1, e1.x1 = e1.y1, e1.y1 = i), n.flipX && (i = e1.x0, e1.x0 = r[0] - e1.x1, e1.x1 = r[0] - i), n.flipY && (i = e1.y0, e1.y0 = r[1] - e1.y1, e1.y1 = r[1] - i);
                    var a = e1.children;
                    if (a) for(var o = 0; o < a.length; o++)t1(a[o], r, n);
                };
            },
            47181: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    moduleType: "trace",
                    name: "treemap",
                    basePlotModule: r(69784),
                    categories: [],
                    animatable: !0,
                    attributes: r(71856),
                    layoutAttributes: r(4219),
                    supplyDefaults: r(95719),
                    supplyLayoutDefaults: r(49852),
                    calc: r(38848)._,
                    crossTraceCalc: r(38848).t,
                    plot: r(64274),
                    style: r(92080).style,
                    colorbar: r(21146),
                    meta: {}
                };
            },
            4219: function(t1) {
                "use strict";
                t1.exports = {
                    treemapcolorway: {
                        valType: "colorlist",
                        editType: "calc"
                    },
                    extendtreemapcolors: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    }
                };
            },
            49852: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(4219);
                t1.exports = function(t1, e1) {
                    function r(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    r("treemapcolorway", e1.colorway), r("extendtreemapcolors");
                };
            },
            11995: function(t1, e1, r) {
                "use strict";
                var n = r(92264), i = r(36141);
                t1.exports = function(t1, e1, r) {
                    var a, o = r.flipX, s = r.flipY, l = "dice-slice" === r.packing, c = r.pad[s ? "bottom" : "top"], u = r.pad[o ? "right" : "left"], h = r.pad[o ? "left" : "right"], f = r.pad[s ? "top" : "bottom"];
                    l && (a = u, u = c, c = a, a = h, h = f, f = a);
                    var p = n.treemap().tile(function(t1, e1) {
                        switch(t1){
                            case "squarify":
                                return n.treemapSquarify.ratio(e1);
                            case "binary":
                                return n.treemapBinary;
                            case "dice":
                                return n.treemapDice;
                            case "slice":
                                return n.treemapSlice;
                            default:
                                return n.treemapSliceDice;
                        }
                    }(r.packing, r.squarifyratio)).paddingInner(r.pad.inner).paddingLeft(u).paddingRight(h).paddingTop(c).paddingBottom(f).size(l ? [
                        e1[1],
                        e1[0]
                    ] : e1)(t1);
                    return (l || o || s) && i(p, e1, {
                        swapXY: l,
                        flipX: o,
                        flipY: s
                    }), p;
                };
            },
            64274: function(t1, e1, r) {
                "use strict";
                var n = r(41567), i = r(50916);
                t1.exports = function(t1, e1, r, a) {
                    return n(t1, e1, r, a, {
                        type: "treemap",
                        drawDescendants: i
                    });
                };
            },
            95709: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(88640).GW, a = r(33108), o = r(34809), s = r(56155).TEXTPAD, l = r(32995).toMoveInsideBar, c = r(84102).recordMinTextSize, u = r(43236), h = r(17010);
                function f(t1) {
                    return a.isHierarchyRoot(t1) ? "" : a.getPtId(t1);
                }
                t1.exports = function(t1, e1, r, p, d) {
                    var m = t1._fullLayout, g = e1[0], y = g.trace, v = "icicle" === y.type, x = g.hierarchy, _ = a.findEntryWithLevel(x, y.level), b = n.select(r), w = b.selectAll("g.pathbar"), T = b.selectAll("g.slice");
                    if (!_) return w.remove(), void T.remove();
                    var k = a.isHierarchyRoot(_), A = !m.uniformtext.mode && a.hasTransition(p), M = a.getMaxDepth(y), S = m._size, E = y.domain, C = S.w * (E.x[1] - E.x[0]), L = S.h * (E.y[1] - E.y[0]), I = C, P = y.pathbar.thickness, z = y.marker.line.width + u.gapWithPathbar, O = y.pathbar.visible ? y.pathbar.side.indexOf("bottom") > -1 ? L + z : -(P + z) : 0, D = {
                        x0: I,
                        x1: I,
                        y0: O,
                        y1: O + P
                    }, R = function(t1, e1, r) {
                        var n = y.tiling.pad, i = function(t1) {
                            return t1 - n <= e1.x0;
                        }, a = function(t1) {
                            return t1 + n >= e1.x1;
                        }, o = function(t1) {
                            return t1 - n <= e1.y0;
                        }, s = function(t1) {
                            return t1 + n >= e1.y1;
                        };
                        return t1.x0 === e1.x0 && t1.x1 === e1.x1 && t1.y0 === e1.y0 && t1.y1 === e1.y1 ? {
                            x0: t1.x0,
                            x1: t1.x1,
                            y0: t1.y0,
                            y1: t1.y1
                        } : {
                            x0: i(t1.x0 - n) ? 0 : a(t1.x0 - n) ? r[0] : t1.x0,
                            x1: i(t1.x1 + n) ? 0 : a(t1.x1 + n) ? r[0] : t1.x1,
                            y0: o(t1.y0 - n) ? 0 : s(t1.y0 - n) ? r[1] : t1.y0,
                            y1: o(t1.y1 + n) ? 0 : s(t1.y1 + n) ? r[1] : t1.y1
                        };
                    }, F = null, B = {}, N = {}, j = null, U = function(t1, e1) {
                        return e1 ? B[f(t1)] : N[f(t1)];
                    };
                    g.hasMultipleRoots && k && M++, y._maxDepth = M, y._backgroundColor = m.paper_bgcolor, y._entryDepth = _.data.depth, y._atRootLevel = k;
                    var V = -C / 2 + S.l + S.w * (E.x[1] + E.x[0]) / 2, q = -L / 2 + S.t + S.h * (1 - (E.y[1] + E.y[0]) / 2), H = function(t1) {
                        return V + t1;
                    }, G = function(t1) {
                        return q + t1;
                    }, Z = G(0), W = H(0), Y = function(t1) {
                        return W + t1;
                    }, X = function(t1) {
                        return Z + t1;
                    };
                    function $(t1, e1) {
                        return t1 + "," + e1;
                    }
                    var J = Y(0), K = function(t1) {
                        t1.x = Math.max(J, t1.x);
                    }, Q = y.pathbar.edgeshape, tt = y[v ? "tiling" : "marker"].pad, et = function(t1) {
                        return -1 !== y.textposition.indexOf(t1);
                    }, rt = et("top"), nt = et("left"), it = et("right"), at = et("bottom"), ot = function(t1, e1) {
                        var r = t1.x0, n = t1.x1, i = t1.y0, a = t1.y1, o = t1.textBB, u = rt || e1.isHeader && !at ? "start" : at ? "end" : "middle", h = et("right"), f = et("left") || e1.onPathbar ? -1 : h ? 1 : 0;
                        if (e1.isHeader) {
                            if ((r += (v ? tt : tt.l) - s) >= (n -= (v ? tt : tt.r) - s)) {
                                var p = (r + n) / 2;
                                r = p, n = p;
                            }
                            var d;
                            at ? i < (d = a - (v ? tt : tt.b)) && d < a && (i = d) : i < (d = i + (v ? tt : tt.t)) && d < a && (a = d);
                        }
                        var g = l(r, n, i, a, o, {
                            isHorizontal: !1,
                            constrained: !0,
                            angle: 0,
                            anchor: u,
                            leftToRight: f
                        });
                        return g.fontSize = e1.fontSize, g.targetX = H(g.targetX), g.targetY = G(g.targetY), isNaN(g.targetX) || isNaN(g.targetY) ? {} : (r !== n && i !== a && c(y.type, g, m), {
                            scale: g.scale,
                            rotate: g.rotate,
                            textX: g.textX,
                            textY: g.textY,
                            anchorX: g.anchorX,
                            anchorY: g.anchorY,
                            targetX: g.targetX,
                            targetY: g.targetY
                        });
                    }, st = function(t1, e1) {
                        for(var r, n = 0, i = t1; !r && n < M;)n++, (i = i.parent) ? r = U(i, e1) : n = M;
                        return r || {};
                    }, lt = function(t1, e1, r, n, a) {
                        var s, l = U(t1, e1);
                        if (l) s = l;
                        else if (e1) s = D;
                        else if (F) {
                            if (t1.parent) {
                                var c = j || r;
                                c && !e1 ? s = R(t1, c, n) : (s = {}, o.extendFlat(s, st(t1, e1)));
                            } else s = o.extendFlat({}, t1), v && ("h" === a.orientation ? a.flipX ? s.x0 = t1.x1 : s.x1 = 0 : a.flipY ? s.y0 = t1.y1 : s.y1 = 0);
                        } else s = {};
                        return i(s, {
                            x0: t1.x0,
                            x1: t1.x1,
                            y0: t1.y0,
                            y1: t1.y1
                        });
                    }, ct = function(t1, e1, r, n) {
                        var s = U(t1, e1), l = {}, u = function(t1, e1, r, n) {
                            if (e1) return B[f(x)] || D;
                            var i = N[y.level] || r;
                            return function(t1) {
                                return t1.data.depth - _.data.depth < M;
                            }(t1) ? R(t1, i, n) : {};
                        }(t1, e1, r, n);
                        o.extendFlat(l, {
                            transform: ot({
                                x0: u.x0,
                                x1: u.x1,
                                y0: u.y0,
                                y1: u.y1,
                                textBB: t1.textBB,
                                _text: t1._text
                            }, {
                                isHeader: a.isHeader(t1, y)
                            })
                        }), s ? l = s : t1.parent && o.extendFlat(l, st(t1, e1));
                        var h = t1.transform;
                        return t1.x0 !== t1.x1 && t1.y0 !== t1.y1 && c(y.type, h, m), i(l, {
                            transform: {
                                scale: h.scale,
                                rotate: h.rotate,
                                textX: h.textX,
                                textY: h.textY,
                                anchorX: h.anchorX,
                                anchorY: h.anchorY,
                                targetX: h.targetX,
                                targetY: h.targetY
                            }
                        });
                    }, ut = function(t1, e1, r, a, o) {
                        var s = a[0], l = a[1];
                        A ? t1.exit().transition().each(function() {
                            var t1 = n.select(this);
                            t1.select("path.surface").transition().attrTween("d", function(t1) {
                                var r = function(t1, e1, r, n) {
                                    var a, o = U(t1, e1);
                                    if (e1) a = D;
                                    else {
                                        var s = U(_, e1);
                                        a = s ? R(t1, s, n) : {};
                                    }
                                    return i(o, a);
                                }(t1, e1, 0, [
                                    s,
                                    l
                                ]);
                                return function(t1) {
                                    return o(r(t1));
                                };
                            }), t1.select("g.slicetext").attr("opacity", 0);
                        }).remove() : t1.exit().remove();
                    }, ht = function(t1) {
                        var e1 = t1.transform;
                        return t1.x0 !== t1.x1 && t1.y0 !== t1.y1 && c(y.type, e1, m), o.getTextTransform({
                            textX: e1.textX,
                            textY: e1.textY,
                            anchorX: e1.anchorX,
                            anchorY: e1.anchorY,
                            targetX: e1.targetX,
                            targetY: e1.targetY,
                            scale: e1.scale,
                            rotate: e1.rotate
                        });
                    };
                    A && (w.each(function(t1) {
                        B[f(t1)] = {
                            x0: t1.x0,
                            x1: t1.x1,
                            y0: t1.y0,
                            y1: t1.y1
                        }, t1.transform && (B[f(t1)].transform = {
                            textX: t1.transform.textX,
                            textY: t1.transform.textY,
                            anchorX: t1.transform.anchorX,
                            anchorY: t1.transform.anchorY,
                            targetX: t1.transform.targetX,
                            targetY: t1.transform.targetY,
                            scale: t1.transform.scale,
                            rotate: t1.transform.rotate
                        });
                    }), T.each(function(t1) {
                        N[f(t1)] = {
                            x0: t1.x0,
                            x1: t1.x1,
                            y0: t1.y0,
                            y1: t1.y1
                        }, t1.transform && (N[f(t1)].transform = {
                            textX: t1.transform.textX,
                            textY: t1.transform.textY,
                            anchorX: t1.transform.anchorX,
                            anchorY: t1.transform.anchorY,
                            targetX: t1.transform.targetX,
                            targetY: t1.transform.targetY,
                            scale: t1.transform.scale,
                            rotate: t1.transform.rotate
                        }), !F && a.isEntry(t1) && (F = t1);
                    })), j = d(t1, e1, _, T, {
                        width: C,
                        height: L,
                        viewX: H,
                        viewY: G,
                        pathSlice: function(t1) {
                            var e1 = H(t1.x0), r = H(t1.x1), n = G(t1.y0), i = G(t1.y1), a = r - e1, o = i - n;
                            if (!a || !o) return "";
                            var s = y.marker.cornerradius || 0, l = Math.min(s, a / 2, o / 2);
                            l && t1.data && t1.data.data && t1.data.data.label && (rt && (l = Math.min(l, tt.t)), nt && (l = Math.min(l, tt.l)), it && (l = Math.min(l, tt.r)), at && (l = Math.min(l, tt.b)));
                            var c = function(t1, e1) {
                                return l ? "a" + $(l, l) + " 0 0 1 " + $(t1, e1) : "";
                            };
                            return "M" + $(e1, n + l) + c(l, -l) + "L" + $(r - l, n) + c(l, l) + "L" + $(r, i - l) + c(-l, l) + "L" + $(e1 + l, i) + c(-l, -l) + "Z";
                        },
                        toMoveInsideSlice: ot,
                        prevEntry: F,
                        makeUpdateSliceInterpolator: lt,
                        makeUpdateTextInterpolator: ct,
                        handleSlicesExit: ut,
                        hasTransition: A,
                        strTransform: ht
                    }), y.pathbar.visible ? h(t1, e1, _, w, {
                        barDifY: O,
                        width: I,
                        height: P,
                        viewX: Y,
                        viewY: X,
                        pathSlice: function(t1) {
                            var e1 = Y(Math.max(Math.min(t1.x0, t1.x0), 0)), r = Y(Math.min(Math.max(t1.x1, t1.x1), I)), n = X(t1.y0), i = X(t1.y1), a = P / 2, o = {}, s = {};
                            o.x = e1, s.x = r, o.y = s.y = (n + i) / 2;
                            var l = {
                                x: e1,
                                y: n
                            }, c = {
                                x: r,
                                y: n
                            }, u = {
                                x: r,
                                y: i
                            }, h = {
                                x: e1,
                                y: i
                            };
                            return ">" === Q ? (l.x -= a, c.x -= a, u.x -= a, h.x -= a) : "/" === Q ? (u.x -= a, h.x -= a, o.x -= a / 2, s.x -= a / 2) : "\\" === Q ? (l.x -= a, c.x -= a, o.x -= a / 2, s.x -= a / 2) : "<" === Q && (o.x -= a, s.x -= a), K(l), K(h), K(o), K(c), K(u), K(s), "M" + $(l.x, l.y) + "L" + $(c.x, c.y) + "L" + $(s.x, s.y) + "L" + $(u.x, u.y) + "L" + $(h.x, h.y) + "L" + $(o.x, o.y) + "Z";
                        },
                        toMoveInsideSlice: ot,
                        makeUpdateSliceInterpolator: lt,
                        makeUpdateTextInterpolator: ct,
                        handleSlicesExit: ut,
                        hasTransition: A,
                        strTransform: ht
                    }) : w.remove();
                };
            },
            92080: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(78766), a = r(34809), o = r(33108), s = r(84102).resizeText, l = r(72043);
                function c(t1, e1, r, n, s) {
                    var c, u, h = (s || {}).hovered, f = e1.data.data, p = f.i, d = f.color, m = o.isHierarchyRoot(e1), g = 1;
                    if (h) c = r._hovered.marker.line.color, u = r._hovered.marker.line.width;
                    else if (m && d === r.root.color) g = 100, c = "rgba(0,0,0,0)", u = 0;
                    else if (c = a.castOption(r, p, "marker.line.color") || i.defaultLine, u = a.castOption(r, p, "marker.line.width") || 0, !r._hasColorscale && !e1.onPathbar) {
                        var y = r.marker.depthfade;
                        if (y) {
                            var v, x = i.combine(i.addOpacity(r._backgroundColor, .75), d);
                            if (!0 === y) {
                                var _ = o.getMaxDepth(r);
                                v = isFinite(_) ? o.isLeaf(e1) ? 0 : r._maxVisibleLayers - (e1.data.depth - r._entryDepth) : e1.data.height + 1;
                            } else v = e1.data.depth - r._entryDepth, r._atRootLevel || v++;
                            if (v > 0) for(var b = 0; b < v; b++){
                                var w = .5 * b / v;
                                d = i.combine(i.addOpacity(x, w), d);
                            }
                        }
                    }
                    t1.call(l, e1, r, n, d).style("stroke-width", u).call(i.stroke, c).style("opacity", g);
                }
                t1.exports = {
                    style: function(t1) {
                        var e1 = t1._fullLayout._treemaplayer.selectAll(".trace");
                        s(t1, e1, "treemap"), e1.each(function(e1) {
                            var r = n.select(this), i = e1[0].trace;
                            r.style("opacity", i.opacity), r.selectAll("path.surface").each(function(e1) {
                                n.select(this).call(c, e1, i, t1, {
                                    hovered: !1
                                });
                            });
                        });
                    },
                    styleOne: c
                };
            },
            14711: function(t1, e1, r) {
                "use strict";
                var n = r(64625), i = r(93049).extendFlat, a = r(80712).axisHoverFormat;
                t1.exports = {
                    y: n.y,
                    x: n.x,
                    x0: n.x0,
                    y0: n.y0,
                    xhoverformat: a("x"),
                    yhoverformat: a("y"),
                    name: i({}, n.name, {}),
                    orientation: i({}, n.orientation, {}),
                    bandwidth: {
                        valType: "number",
                        min: 0,
                        editType: "calc"
                    },
                    scalegroup: {
                        valType: "string",
                        dflt: "",
                        editType: "calc"
                    },
                    scalemode: {
                        valType: "enumerated",
                        values: [
                            "width",
                            "count"
                        ],
                        dflt: "width",
                        editType: "calc"
                    },
                    spanmode: {
                        valType: "enumerated",
                        values: [
                            "soft",
                            "hard",
                            "manual"
                        ],
                        dflt: "soft",
                        editType: "calc"
                    },
                    span: {
                        valType: "info_array",
                        items: [
                            {
                                valType: "any",
                                editType: "calc"
                            },
                            {
                                valType: "any",
                                editType: "calc"
                            }
                        ],
                        editType: "calc"
                    },
                    line: {
                        color: {
                            valType: "color",
                            editType: "style"
                        },
                        width: {
                            valType: "number",
                            min: 0,
                            dflt: 2,
                            editType: "style"
                        },
                        editType: "plot"
                    },
                    fillcolor: n.fillcolor,
                    points: i({}, n.boxpoints, {}),
                    jitter: i({}, n.jitter, {}),
                    pointpos: i({}, n.pointpos, {}),
                    width: i({}, n.width, {}),
                    marker: n.marker,
                    text: n.text,
                    hovertext: n.hovertext,
                    hovertemplate: n.hovertemplate,
                    quartilemethod: n.quartilemethod,
                    box: {
                        visible: {
                            valType: "boolean",
                            dflt: !1,
                            editType: "plot"
                        },
                        width: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: .25,
                            editType: "plot"
                        },
                        fillcolor: {
                            valType: "color",
                            editType: "style"
                        },
                        line: {
                            color: {
                                valType: "color",
                                editType: "style"
                            },
                            width: {
                                valType: "number",
                                min: 0,
                                editType: "style"
                            },
                            editType: "style"
                        },
                        editType: "plot"
                    },
                    meanline: {
                        visible: {
                            valType: "boolean",
                            dflt: !1,
                            editType: "plot"
                        },
                        color: {
                            valType: "color",
                            editType: "style"
                        },
                        width: {
                            valType: "number",
                            min: 0,
                            editType: "style"
                        },
                        editType: "plot"
                    },
                    side: {
                        valType: "enumerated",
                        values: [
                            "both",
                            "positive",
                            "negative"
                        ],
                        dflt: "both",
                        editType: "calc"
                    },
                    offsetgroup: n.offsetgroup,
                    alignmentgroup: n.alignmentgroup,
                    selected: n.selected,
                    unselected: n.unselected,
                    hoveron: {
                        valType: "flaglist",
                        flags: [
                            "violins",
                            "points",
                            "kde"
                        ],
                        dflt: "violins+points+kde",
                        extras: [
                            "all"
                        ],
                        editType: "style"
                    },
                    zorder: n.zorder
                };
            },
            88759: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(29714), a = r(89429), o = r(37881), s = r(63821).BADNUM;
                function l(t1, e1, r) {
                    var i = e1.max - e1.min;
                    if (!i) return t1.bandwidth ? t1.bandwidth : 0;
                    if (t1.bandwidth) return Math.max(t1.bandwidth, i / 1e4);
                    var a = r.length, o = n.stdev(r, a - 1, e1.mean);
                    return Math.max(function(t1, e1, r) {
                        return 1.059 * Math.min(e1, r / 1.349) * Math.pow(t1, -0.2);
                    }(a, o, e1.q3 - e1.q1), i / 100);
                }
                function c(t1, e1, r, n) {
                    var a, o = t1.spanmode, l = t1.span || [], c = [
                        e1.min,
                        e1.max
                    ], u = [
                        e1.min - 2 * n,
                        e1.max + 2 * n
                    ];
                    function h(n) {
                        var i = l[n], a = "multicategory" === r.type ? r.r2c(i) : r.d2c(i, 0, t1[e1.valLetter + "calendar"]);
                        return a === s ? u[n] : a;
                    }
                    var f = {
                        type: "linear",
                        range: a = "soft" === o ? u : "hard" === o ? c : [
                            h(0),
                            h(1)
                        ]
                    };
                    return i.setConvert(f), f.cleanRange(), a;
                }
                t1.exports = function(t1, e1) {
                    var r = a(t1, e1);
                    if (r[0].t.empty) return r;
                    for(var s = t1._fullLayout, u = i.getFromId(t1, e1["h" === e1.orientation ? "xaxis" : "yaxis"]), h = 1 / 0, f = -1 / 0, p = 0, d = 0, m = 0; m < r.length; m++){
                        var g = r[m], y = g.pts.map(o.extractVal), v = g.bandwidth = l(e1, g, y), x = g.span = c(e1, g, u, v);
                        if (g.min === g.max && 0 === v) x = g.span = [
                            g.min,
                            g.max
                        ], g.density = [
                            {
                                v: 1,
                                t: x[0]
                            }
                        ], g.bandwidth = v, p = Math.max(p, 1);
                        else {
                            var _ = x[1] - x[0], b = Math.ceil(_ / (v / 3)), w = _ / b;
                            if (!isFinite(w) || !isFinite(b)) return n.error("Something went wrong with computing the violin span"), r[0].t.empty = !0, r;
                            var T = o.makeKDE(g, e1, y);
                            g.density = new Array(b);
                            for(var k = 0, A = x[0]; A < x[1] + w / 2; k++, A += w){
                                var M = T(A);
                                g.density[k] = {
                                    v: M,
                                    t: A
                                }, p = Math.max(p, M);
                            }
                        }
                        d = Math.max(d, y.length), h = Math.min(h, x[0]), f = Math.max(f, x[1]);
                    }
                    var S = i.findExtremes(u, [
                        h,
                        f
                    ], {
                        padded: !0
                    });
                    if (e1._extremes[u._id] = S, e1.width) r[0].t.maxKDE = p;
                    else {
                        var E = s._violinScaleGroupStats, C = e1.scalegroup, L = E[C];
                        L ? (L.maxKDE = Math.max(L.maxKDE, p), L.maxCount = Math.max(L.maxCount, d)) : E[C] = {
                            maxKDE: p,
                            maxCount: d
                        };
                    }
                    return r[0].t.labels.kde = n._(t1, "kde:"), r;
                };
            },
            67316: function(t1, e1, r) {
                "use strict";
                var n = r(81606).setPositionOffset, i = [
                    "v",
                    "h"
                ];
                t1.exports = function(t1, e1) {
                    for(var r = t1.calcdata, a = e1.xaxis, o = e1.yaxis, s = 0; s < i.length; s++){
                        for(var l = i[s], c = "h" === l ? o : a, u = [], h = 0; h < r.length; h++){
                            var f = r[h], p = f[0].t, d = f[0].trace;
                            !0 !== d.visible || "violin" !== d.type || p.empty || d.orientation !== l || d.xaxis !== a._id || d.yaxis !== o._id || u.push(h);
                        }
                        n("violin", t1, u, c);
                    }
                };
            },
            10864: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(78766), a = r(62294), o = r(14711);
                t1.exports = function(t1, e1, r, s) {
                    function l(r, i) {
                        return n.coerce(t1, e1, o, r, i);
                    }
                    function c(r, i) {
                        return n.coerce2(t1, e1, o, r, i);
                    }
                    if (a.handleSampleDefaults(t1, e1, l, s), !1 !== e1.visible) {
                        l("bandwidth"), l("side"), l("width") || (l("scalegroup", e1.name), l("scalemode"));
                        var u, h = l("span");
                        Array.isArray(h) && (u = "manual"), l("spanmode", u);
                        var f = l("line.color", (t1.marker || {}).color || r), p = l("line.width"), d = l("fillcolor", i.addOpacity(e1.line.color, .5));
                        a.handlePointsDefaults(t1, e1, l, {
                            prefix: ""
                        });
                        var m = c("box.width"), g = c("box.fillcolor", d), y = c("box.line.color", f), v = c("box.line.width", p);
                        l("box.visible", Boolean(m || g || y || v)) || (e1.box = {
                            visible: !1
                        });
                        var x = c("meanline.color", f), _ = c("meanline.width", p);
                        l("meanline.visible", Boolean(x || _)) || (e1.meanline = {
                            visible: !1
                        }), l("quartilemethod"), l("zorder");
                    }
                };
            },
            37881: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = function(t1) {
                    return 1 / Math.sqrt(2 * Math.PI) * Math.exp(-0.5 * t1 * t1);
                };
                e1.makeKDE = function(t1, e1, r) {
                    var n = r.length, a = i, o = t1.bandwidth, s = 1 / (n * o);
                    return function(t1) {
                        for(var e1 = 0, i = 0; i < n; i++)e1 += a((t1 - r[i]) / o);
                        return s * e1;
                    };
                }, e1.getPositionOnKdePath = function(t1, e1, r) {
                    var i, a;
                    "h" === e1.orientation ? (i = "y", a = "x") : (i = "x", a = "y");
                    var o = n.findPointOnPath(t1.path, r, a, {
                        pathLength: t1.pathLength
                    }), s = t1.posCenterPx, l = o[i];
                    return [
                        l,
                        "both" === e1.side ? 2 * s - l : s
                    ];
                }, e1.getKdeValue = function(t1, r, n) {
                    var i = t1.pts.map(e1.extractVal);
                    return e1.makeKDE(t1, r, i)(n) / t1.posDensityScale;
                }, e1.extractVal = function(t1) {
                    return t1.v;
                };
            },
            16842: function(t1, e1, r) {
                "use strict";
                var n = r(78766), i = r(34809), a = r(29714), o = r(11448), s = r(37881);
                t1.exports = function(t1, e1, r, l, c) {
                    c || (c = {});
                    var u, h, f = c.hoverLayer, p = t1.cd, d = p[0].trace, m = d.hoveron, g = -1 !== m.indexOf("violins"), y = -1 !== m.indexOf("kde"), v = [];
                    if (g || y) {
                        var x = o.hoverOnBoxes(t1, e1, r, l);
                        if (y && x.length > 0) {
                            var _, b, w, T, k, A = t1.xa, M = t1.ya;
                            "h" === d.orientation ? (k = e1, _ = "y", w = M, b = "x", T = A) : (k = r, _ = "x", w = A, b = "y", T = M);
                            var S = p[t1.index];
                            if (k >= S.span[0] && k <= S.span[1]) {
                                var E = i.extendFlat({}, t1), C = T.c2p(k, !0), L = s.getKdeValue(S, d, k), I = s.getPositionOnKdePath(S, d, C), P = w._offset, z = w._length;
                                E[_ + "0"] = I[0], E[_ + "1"] = I[1], E[b + "0"] = E[b + "1"] = C, E[b + "Label"] = b + ": " + a.hoverLabelText(T, k, d[b + "hoverformat"]) + ", " + p[0].t.labels.kde + " " + L.toFixed(3);
                                for(var O = 0, D = 0; D < x.length; D++)if ("med" === x[D].attr) {
                                    O = D;
                                    break;
                                }
                                E.spikeDistance = x[O].spikeDistance;
                                var R = _ + "Spike";
                                E[R] = x[O][R], x[O].spikeDistance = void 0, x[O][R] = void 0, E.hovertemplate = !1, v.push(E), (h = {})[_ + "1"] = i.constrain(P + I[0], P, P + z), h[_ + "2"] = i.constrain(P + I[1], P, P + z), h[b + "1"] = h[b + "2"] = T._offset + C;
                            }
                        }
                        g && (v = v.concat(x));
                    }
                    -1 !== m.indexOf("points") && (u = o.hoverOnPoints(t1, e1, r));
                    var F = f.selectAll(".violinline-" + d.uid).data(h ? [
                        0
                    ] : []);
                    return F.enter().append("line").classed("violinline-" + d.uid, !0).attr("stroke-width", 1.5), F.exit().remove(), F.attr(h).call(n.stroke, t1.color), "closest" === l ? u ? [
                        u
                    ] : v : u ? (v.push(u), v) : v;
                };
            },
            37276: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    attributes: r(14711),
                    layoutAttributes: r(84734),
                    supplyDefaults: r(10864),
                    crossTraceDefaults: r(62294).crossTraceDefaults,
                    supplyLayoutDefaults: r(55145),
                    calc: r(88759),
                    crossTraceCalc: r(67316),
                    plot: r(36769),
                    style: r(25117),
                    styleOnSelect: r(9408).styleOnSelect,
                    hoverPoints: r(16842),
                    selectPoints: r(72488),
                    moduleType: "trace",
                    name: "violin",
                    basePlotModule: r(37703),
                    categories: [
                        "cartesian",
                        "svg",
                        "symbols",
                        "oriented",
                        "box-violin",
                        "showLegend",
                        "violinLayout",
                        "zoomScale"
                    ],
                    meta: {}
                };
            },
            84734: function(t1, e1, r) {
                "use strict";
                var n = r(64636), i = r(34809).extendFlat;
                t1.exports = {
                    violinmode: i({}, n.boxmode, {}),
                    violingap: i({}, n.boxgap, {}),
                    violingroupgap: i({}, n.boxgroupgap, {})
                };
            },
            55145: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(84734), a = r(65067);
                t1.exports = function(t1, e1, r) {
                    a._supply(t1, e1, r, function(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }, "violin");
                };
            },
            36769: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(34809), a = r(62203), o = r(95419), s = r(5525), l = r(37881);
                t1.exports = function(t1, e1, r, c) {
                    var u = t1._context.staticPlot, h = t1._fullLayout, f = e1.xaxis, p = e1.yaxis;
                    function d(t1, e1) {
                        var r = s(t1, {
                            xaxis: f,
                            yaxis: p,
                            trace: e1,
                            connectGaps: !0,
                            baseTolerance: .75,
                            shape: "spline",
                            simplify: !0,
                            linearized: !0
                        });
                        return a.smoothopen(r[0], 1);
                    }
                    i.makeTraceGroups(c, r, "trace violins").each(function(t1) {
                        var r = n.select(this), a = t1[0], s = a.t, c = a.trace;
                        if (!0 !== c.visible || s.empty) r.remove();
                        else {
                            var m = s.bPos, g = s.bdPos, y = e1[s.valLetter + "axis"], v = e1[s.posLetter + "axis"], x = "both" === c.side, _ = x || "positive" === c.side, b = x || "negative" === c.side, w = r.selectAll("path.violin").data(i.identity);
                            w.enter().append("path").style("vector-effect", u ? "none" : "non-scaling-stroke").attr("class", "violin"), w.exit().remove(), w.each(function(t1) {
                                var e1, r, i, a, o, l, u, f, p = n.select(this), w = t1.density, T = w.length, k = v.c2l(t1.pos + m, !0), A = v.l2p(k);
                                if (c.width) e1 = s.maxKDE / g;
                                else {
                                    var M = h._violinScaleGroupStats[c.scalegroup];
                                    e1 = "count" === c.scalemode ? M.maxKDE / g * (M.maxCount / t1.pts.length) : M.maxKDE / g;
                                }
                                if (_) {
                                    for(u = new Array(T), o = 0; o < T; o++)(f = u[o] = {})[s.posLetter] = k + w[o].v / e1, f[s.valLetter] = y.c2l(w[o].t, !0);
                                    r = d(u, c);
                                }
                                if (b) {
                                    for(u = new Array(T), l = 0, o = T - 1; l < T; l++, o--)(f = u[l] = {})[s.posLetter] = k - w[o].v / e1, f[s.valLetter] = y.c2l(w[o].t, !0);
                                    i = d(u, c);
                                }
                                if (x) a = r + "L" + i.substr(1) + "Z";
                                else {
                                    var S = [
                                        A,
                                        y.c2p(w[0].t)
                                    ], E = [
                                        A,
                                        y.c2p(w[T - 1].t)
                                    ];
                                    "h" === c.orientation && (S.reverse(), E.reverse()), a = _ ? "M" + S + "L" + r.substr(1) + "L" + E : "M" + E + "L" + i.substr(1) + "L" + S;
                                }
                                p.attr("d", a), t1.posCenterPx = A, t1.posDensityScale = e1 * g, t1.path = p.node(), t1.pathLength = t1.path.getTotalLength() / (x ? 2 : 1);
                            });
                            var T, k, A, M = c.box, S = M.width, E = (M.line || {}).width;
                            x ? (T = g * S, k = 0) : _ ? (T = [
                                0,
                                g * S / 2
                            ], k = E * ({
                                x: 1,
                                y: -1
                            })[s.posLetter]) : (T = [
                                g * S / 2,
                                0
                            ], k = E * ({
                                x: -1,
                                y: 1
                            })[s.posLetter]), o.plotBoxAndWhiskers(r, {
                                pos: v,
                                val: y
                            }, c, {
                                bPos: m,
                                bdPos: T,
                                bPosPxOffset: k
                            }), o.plotBoxMean(r, {
                                pos: v,
                                val: y
                            }, c, {
                                bPos: m,
                                bdPos: T,
                                bPosPxOffset: k
                            }), !c.box.visible && c.meanline.visible && (A = i.identity);
                            var C = r.selectAll("path.meanline").data(A || []);
                            C.enter().append("path").attr("class", "meanline").style("fill", "none").style("vector-effect", u ? "none" : "non-scaling-stroke"), C.exit().remove(), C.each(function(t1) {
                                var e1 = y.c2p(t1.mean, !0), r = l.getPositionOnKdePath(t1, c, e1);
                                n.select(this).attr("d", "h" === c.orientation ? "M" + e1 + "," + r[0] + "V" + r[1] : "M" + r[0] + "," + e1 + "H" + r[1]);
                            }), o.plotPoints(r, {
                                x: f,
                                y: p
                            }, c, s);
                        }
                    });
                };
            },
            25117: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(78766), a = r(9408).stylePoints;
                t1.exports = function(t1) {
                    var e1 = n.select(t1).selectAll("g.trace.violins");
                    e1.style("opacity", function(t1) {
                        return t1[0].trace.opacity;
                    }), e1.each(function(e1) {
                        var r = e1[0].trace, o = n.select(this), s = r.box || {}, l = s.line || {}, c = r.meanline || {}, u = c.width;
                        o.selectAll("path.violin").style("stroke-width", r.line.width + "px").call(i.stroke, r.line.color).call(i.fill, r.fillcolor), o.selectAll("path.box").style("stroke-width", l.width + "px").call(i.stroke, l.color).call(i.fill, s.fillcolor);
                        var h = {
                            "stroke-width": u + "px",
                            "stroke-dasharray": 2 * u + "px," + u + "px"
                        };
                        o.selectAll("path.mean").style(h).call(i.stroke, c.color), o.selectAll("path.meanline").style(h).call(i.stroke, c.color), a(o, r, t1);
                    });
                };
            },
            51526: function(t1, e1, r) {
                "use strict";
                var n = r(87163), i = r(70252), a = r(16131), o = r(9829), s = r(93049).extendFlat, l = r(13582).overrideAll, c = t1.exports = l(s({
                    x: i.x,
                    y: i.y,
                    z: i.z,
                    value: i.value,
                    isomin: i.isomin,
                    isomax: i.isomax,
                    surface: i.surface,
                    spaceframe: {
                        show: {
                            valType: "boolean",
                            dflt: !1
                        },
                        fill: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: 1
                        }
                    },
                    slices: i.slices,
                    caps: i.caps,
                    text: i.text,
                    hovertext: i.hovertext,
                    xhoverformat: i.xhoverformat,
                    yhoverformat: i.yhoverformat,
                    zhoverformat: i.zhoverformat,
                    valuehoverformat: i.valuehoverformat,
                    hovertemplate: i.hovertemplate
                }, n("", {
                    colorAttr: "`value`",
                    showScaleDflt: !0,
                    editTypeOverride: "calc"
                }), {
                    colorbar: i.colorbar,
                    opacity: i.opacity,
                    opacityscale: a.opacityscale,
                    lightposition: i.lightposition,
                    lighting: i.lighting,
                    flatshading: i.flatshading,
                    contour: i.contour,
                    hoverinfo: s({}, o.hoverinfo),
                    showlegend: s({}, o.showlegend, {
                        dflt: !1
                    })
                }), "calc", "nested");
                c.x.editType = c.y.editType = c.z.editType = c.value.editType = "calc+clearAxisTypes", c.transforms = void 0;
            },
            96496: function(t1, e1, r) {
                "use strict";
                var n = r(99098).gl_mesh3d, i = r(46998).parseColorScale, a = r(34809).isArrayOrTypedArray, o = r(55010), s = r(88856).extractOpts, l = r(88239), c = r(91370).findNearestOnAxis, u = r(91370).generateIsoMeshes;
                function h(t1, e1, r) {
                    this.scene = t1, this.uid = r, this.mesh = e1, this.name = "", this.data = null, this.showContour = !1;
                }
                var f = h.prototype;
                f.handlePick = function(t1) {
                    if (t1.object === this.mesh) {
                        var e1 = t1.data.index, r = this.data._meshX[e1], n = this.data._meshY[e1], i = this.data._meshZ[e1], o = this.data._Ys.length, s = this.data._Zs.length, l = c(r, this.data._Xs).id, u = c(n, this.data._Ys).id, h = c(i, this.data._Zs).id, f = t1.index = h + s * u + s * o * l;
                        t1.traceCoordinate = [
                            this.data._meshX[f],
                            this.data._meshY[f],
                            this.data._meshZ[f],
                            this.data._value[f]
                        ];
                        var p = this.data.hovertext || this.data.text;
                        return a(p) && void 0 !== p[f] ? t1.textLabel = p[f] : p && (t1.textLabel = p), !0;
                    }
                }, f.update = function(t1) {
                    var e1 = this.scene, r = e1.fullSceneLayout;
                    function n(t1, e1, r, n) {
                        return e1.map(function(e1) {
                            return t1.d2l(e1, 0, n) * r;
                        });
                    }
                    this.data = u(t1);
                    var a = {
                        positions: l(n(r.xaxis, t1._meshX, e1.dataScale[0], t1.xcalendar), n(r.yaxis, t1._meshY, e1.dataScale[1], t1.ycalendar), n(r.zaxis, t1._meshZ, e1.dataScale[2], t1.zcalendar)),
                        cells: l(t1._meshI, t1._meshJ, t1._meshK),
                        lightPosition: [
                            t1.lightposition.x,
                            t1.lightposition.y,
                            t1.lightposition.z
                        ],
                        ambient: t1.lighting.ambient,
                        diffuse: t1.lighting.diffuse,
                        specular: t1.lighting.specular,
                        roughness: t1.lighting.roughness,
                        fresnel: t1.lighting.fresnel,
                        vertexNormalsEpsilon: t1.lighting.vertexnormalsepsilon,
                        faceNormalsEpsilon: t1.lighting.facenormalsepsilon,
                        opacity: t1.opacity,
                        opacityscale: t1.opacityscale,
                        contourEnable: t1.contour.show,
                        contourColor: o(t1.contour.color).slice(0, 3),
                        contourWidth: t1.contour.width,
                        useFacetNormals: t1.flatshading
                    }, c = s(t1);
                    a.vertexIntensity = t1._meshIntensity, a.vertexIntensityBounds = [
                        c.min,
                        c.max
                    ], a.colormap = i(t1), this.mesh.update(a);
                }, f.dispose = function() {
                    this.scene.glplot.remove(this.mesh), this.mesh.dispose();
                }, t1.exports = function(t1, e1) {
                    var r = t1.glplot.gl, i = n({
                        gl: r
                    }), a = new h(t1, i, e1.uid);
                    return i._trace = a, a.update(e1), t1.glplot.add(i), a;
                };
            },
            22385: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(51526), a = r(44731).supplyIsoDefaults, o = r(65444).opacityscaleDefaults;
                t1.exports = function(t1, e1, r, s) {
                    function l(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    a(t1, e1, r, s, l), o(t1, e1, s, l);
                };
            },
            75703: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    attributes: r(51526),
                    supplyDefaults: r(22385),
                    calc: r(58988),
                    colorbar: {
                        min: "cmin",
                        max: "cmax"
                    },
                    plot: r(96496),
                    moduleType: "trace",
                    name: "volume",
                    basePlotModule: r(2487),
                    categories: [
                        "gl3d",
                        "showLegend"
                    ],
                    meta: {}
                };
            },
            37832: function(t1, e1, r) {
                "use strict";
                var n = r(81481), i = r(36640).line, a = r(9829), o = r(80712).axisHoverFormat, s = r(3208).rb, l = r(3208).ay, c = r(82508), u = r(93049).extendFlat, h = r(78766);
                function f(t1) {
                    return {
                        marker: {
                            color: u({}, n.marker.color, {
                                arrayOk: !1,
                                editType: "style"
                            }),
                            line: {
                                color: u({}, n.marker.line.color, {
                                    arrayOk: !1,
                                    editType: "style"
                                }),
                                width: u({}, n.marker.line.width, {
                                    arrayOk: !1,
                                    editType: "style"
                                }),
                                editType: "style"
                            },
                            editType: "style"
                        },
                        editType: "style"
                    };
                }
                t1.exports = {
                    measure: {
                        valType: "data_array",
                        dflt: [],
                        editType: "calc"
                    },
                    base: {
                        valType: "number",
                        dflt: null,
                        arrayOk: !1,
                        editType: "calc"
                    },
                    x: n.x,
                    x0: n.x0,
                    dx: n.dx,
                    y: n.y,
                    y0: n.y0,
                    dy: n.dy,
                    xperiod: n.xperiod,
                    yperiod: n.yperiod,
                    xperiod0: n.xperiod0,
                    yperiod0: n.yperiod0,
                    xperiodalignment: n.xperiodalignment,
                    yperiodalignment: n.yperiodalignment,
                    xhoverformat: o("x"),
                    yhoverformat: o("y"),
                    hovertext: n.hovertext,
                    hovertemplate: s({}, {
                        keys: c.eventDataKeys
                    }),
                    hoverinfo: u({}, a.hoverinfo, {
                        flags: [
                            "name",
                            "x",
                            "y",
                            "text",
                            "initial",
                            "delta",
                            "final"
                        ]
                    }),
                    textinfo: {
                        valType: "flaglist",
                        flags: [
                            "label",
                            "text",
                            "initial",
                            "delta",
                            "final"
                        ],
                        extras: [
                            "none"
                        ],
                        editType: "plot",
                        arrayOk: !1
                    },
                    texttemplate: l({
                        editType: "plot"
                    }, {
                        keys: c.eventDataKeys.concat([
                            "label"
                        ])
                    }),
                    text: n.text,
                    textposition: n.textposition,
                    insidetextanchor: n.insidetextanchor,
                    textangle: n.textangle,
                    textfont: n.textfont,
                    insidetextfont: n.insidetextfont,
                    outsidetextfont: n.outsidetextfont,
                    constraintext: n.constraintext,
                    cliponaxis: n.cliponaxis,
                    orientation: n.orientation,
                    offset: n.offset,
                    width: n.width,
                    increasing: f(),
                    decreasing: f(),
                    totals: f(),
                    connector: {
                        line: {
                            color: u({}, i.color, {
                                dflt: h.defaultLine
                            }),
                            width: u({}, i.width, {
                                editType: "plot"
                            }),
                            dash: i.dash,
                            editType: "plot"
                        },
                        mode: {
                            valType: "enumerated",
                            values: [
                                "spanning",
                                "between"
                            ],
                            dflt: "between",
                            editType: "plot"
                        },
                        visible: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    offsetgroup: n.offsetgroup,
                    alignmentgroup: n.alignmentgroup,
                    zorder: n.zorder
                };
            },
            15e3: function(t1, e1, r) {
                "use strict";
                var n = r(29714), i = r(40528), a = r(34809).mergeArray, o = r(48861), s = r(63821).BADNUM;
                function l(t1) {
                    return "a" === t1 || "absolute" === t1;
                }
                function c(t1) {
                    return "t" === t1 || "total" === t1;
                }
                t1.exports = function(t1, e1) {
                    var r, u, h, f, p, d, m = n.getFromId(t1, e1.xaxis || "x"), g = n.getFromId(t1, e1.yaxis || "y");
                    "h" === e1.orientation ? (r = m.makeCalcdata(e1, "x"), h = g.makeCalcdata(e1, "y"), f = i(e1, g, "y", h), p = !!e1.yperiodalignment, d = "y") : (r = g.makeCalcdata(e1, "y"), h = m.makeCalcdata(e1, "x"), f = i(e1, m, "x", h), p = !!e1.xperiodalignment, d = "x"), u = f.vals;
                    for(var y, v = Math.min(u.length, r.length), x = new Array(v), _ = 0, b = !1, w = 0; w < v; w++){
                        var T = r[w] || 0, k = !1;
                        (r[w] !== s || c(e1.measure[w]) || l(e1.measure[w])) && w + 1 < v && (r[w + 1] !== s || c(e1.measure[w + 1]) || l(e1.measure[w + 1])) && (k = !0);
                        var A = x[w] = {
                            i: w,
                            p: u[w],
                            s: T,
                            rawS: T,
                            cNext: k
                        };
                        l(e1.measure[w]) ? (_ = A.s, A.isSum = !0, A.dir = "totals", A.s = _) : c(e1.measure[w]) ? (A.isSum = !0, A.dir = "totals", A.s = _) : (A.isSum = !1, A.dir = A.rawS < 0 ? "decreasing" : "increasing", y = A.s, A.s = _ + y, _ += y), "totals" === A.dir && (b = !0), p && (x[w].orig_p = h[w], x[w][d + "End"] = f.ends[w], x[w][d + "Start"] = f.starts[w]), e1.ids && (A.id = String(e1.ids[w])), A.v = (e1.base || 0) + _;
                    }
                    return x.length && (x[0].hasTotals = b), a(e1.text, x, "tx"), a(e1.hovertext, x, "htx"), o(x, e1), x;
                };
            },
            82508: function(t1) {
                "use strict";
                t1.exports = {
                    eventDataKeys: [
                        "initial",
                        "delta",
                        "final"
                    ]
                };
            },
            9963: function(t1, e1, r) {
                "use strict";
                var n = r(24782).setGroupPositions;
                t1.exports = function(t1, e1) {
                    var r, i, a = t1._fullLayout, o = t1._fullData, s = t1.calcdata, l = e1.xaxis, c = e1.yaxis, u = [], h = [], f = [];
                    for(i = 0; i < o.length; i++){
                        var p = o[i];
                        !0 === p.visible && p.xaxis === l._id && p.yaxis === c._id && "waterfall" === p.type && (r = s[i], "h" === p.orientation ? f.push(r) : h.push(r), u.push(r));
                    }
                    var d = {
                        mode: a.waterfallmode,
                        norm: a.waterfallnorm,
                        gap: a.waterfallgap,
                        groupgap: a.waterfallgroupgap
                    };
                    for(n(t1, l, c, h, d), n(t1, c, l, f, d), i = 0; i < u.length; i++){
                        r = u[i];
                        for(var m = 0; m < r.length; m++){
                            var g = r[m];
                            !1 === g.isSum && (g.s0 += 0 === m ? 0 : r[m - 1].s), m + 1 < r.length && (r[m].nextP0 = r[m + 1].p0, r[m].nextS0 = r[m + 1].s0);
                        }
                    }
                };
            },
            67199: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(36301), a = r(17550).handleText, o = r(99867), s = r(99669), l = r(37832), c = r(78766), u = r(20909), h = u.INCREASING.COLOR, f = u.DECREASING.COLOR;
                function p(t1, e1, r) {
                    t1(e1 + ".marker.color", r), t1(e1 + ".marker.line.color", c.defaultLine), t1(e1 + ".marker.line.width");
                }
                t1.exports = {
                    supplyDefaults: function(t1, e1, r, i) {
                        function c(r, i) {
                            return n.coerce(t1, e1, l, r, i);
                        }
                        if (o(t1, e1, i, c)) {
                            s(t1, e1, i, c), c("xhoverformat"), c("yhoverformat"), c("measure"), c("orientation", e1.x && !e1.y ? "h" : "v"), c("base"), c("offset"), c("width"), c("text"), c("hovertext"), c("hovertemplate");
                            var u = c("textposition");
                            a(t1, e1, i, c, u, {
                                moduleHasSelected: !1,
                                moduleHasUnselected: !1,
                                moduleHasConstrain: !0,
                                moduleHasCliponaxis: !0,
                                moduleHasTextangle: !0,
                                moduleHasInsideanchor: !0
                            }), "none" !== e1.textposition && (c("texttemplate"), e1.texttemplate || c("textinfo")), p(c, "increasing", h), p(c, "decreasing", f), p(c, "totals", "#4499FF"), c("connector.visible") && (c("connector.mode"), c("connector.line.width") && (c("connector.line.color"), c("connector.line.dash"))), c("zorder");
                        } else e1.visible = !1;
                    },
                    crossTraceDefaults: function(t1, e1) {
                        var r, a;
                        function o(t1) {
                            return n.coerce(a._input, a, l, t1);
                        }
                        if ("group" === e1.waterfallmode) for(var s = 0; s < t1.length; s++)r = (a = t1[s])._input, i(r, a, e1, o);
                    }
                };
            },
            64932: function(t1) {
                "use strict";
                t1.exports = function(t1, e1) {
                    return t1.x = "xVal" in e1 ? e1.xVal : e1.x, t1.y = "yVal" in e1 ? e1.yVal : e1.y, "initial" in e1 && (t1.initial = e1.initial), "delta" in e1 && (t1.delta = e1.delta), "final" in e1 && (t1.final = e1.final), e1.xa && (t1.xaxis = e1.xa), e1.ya && (t1.yaxis = e1.ya), t1;
                };
            },
            40943: function(t1, e1, r) {
                "use strict";
                var n = r(29714).hoverLabelText, i = r(78766).opacity, a = r(91664).hoverOnBars, o = r(20909), s = o.INCREASING.SYMBOL, l = o.DECREASING.SYMBOL;
                t1.exports = function(t1, e1, r, o, c) {
                    var u = a(t1, e1, r, o, c);
                    if (u) {
                        var h = u.cd, f = h[0].trace, p = "h" === f.orientation, d = p ? "x" : "y", m = p ? t1.xa : t1.ya, g = h[u.index], y = g.isSum ? g.b + g.s : g.rawS;
                        u.initial = g.b + g.s - y, u.delta = y, u.final = u.initial + u.delta;
                        var v = k(Math.abs(u.delta));
                        u.deltaLabel = y < 0 ? "(" + v + ")" : v, u.finalLabel = k(u.final), u.initialLabel = k(u.initial);
                        var x = g.hi || f.hoverinfo, _ = [];
                        if (x && "none" !== x && "skip" !== x) {
                            var b = "all" === x, w = x.split("+"), T = function(t1) {
                                return b || -1 !== w.indexOf(t1);
                            };
                            g.isSum || (!T("final") || T(p ? "x" : "y") || _.push(u.finalLabel), T("delta") && (y < 0 ? _.push(u.deltaLabel + " " + l) : _.push(u.deltaLabel + " " + s)), T("initial") && _.push("Initial: " + u.initialLabel));
                        }
                        return _.length && (u.extraText = _.join("<br>")), u.color = function(t1, e1) {
                            var r = t1[e1.dir].marker, n = r.color, a = r.line.color, o = r.line.width;
                            return i(n) ? n : i(a) && o ? a : void 0;
                        }(f, g), [
                            u
                        ];
                    }
                    function k(t1) {
                        return n(m, t1, f[d + "hoverformat"]);
                    }
                };
            },
            38261: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    attributes: r(37832),
                    layoutAttributes: r(579),
                    supplyDefaults: r(67199).supplyDefaults,
                    crossTraceDefaults: r(67199).crossTraceDefaults,
                    supplyLayoutDefaults: r(71492),
                    calc: r(15e3),
                    crossTraceCalc: r(9963),
                    plot: r(71130),
                    style: r(57256).style,
                    hoverPoints: r(40943),
                    eventData: r(64932),
                    selectPoints: r(88384),
                    moduleType: "trace",
                    name: "waterfall",
                    basePlotModule: r(37703),
                    categories: [
                        "bar-like",
                        "cartesian",
                        "svg",
                        "oriented",
                        "showLegend",
                        "zoomScale"
                    ],
                    meta: {}
                };
            },
            579: function(t1) {
                "use strict";
                t1.exports = {
                    waterfallmode: {
                        valType: "enumerated",
                        values: [
                            "group",
                            "overlay"
                        ],
                        dflt: "group",
                        editType: "calc"
                    },
                    waterfallgap: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        editType: "calc"
                    },
                    waterfallgroupgap: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 0,
                        editType: "calc"
                    }
                };
            },
            71492: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(579);
                t1.exports = function(t1, e1, r) {
                    var a = !1;
                    function o(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    for(var s = 0; s < r.length; s++){
                        var l = r[s];
                        if (l.visible && "waterfall" === l.type) {
                            a = !0;
                            break;
                        }
                    }
                    a && (o("waterfallmode"), o("waterfallgap", .2), o("waterfallgroupgap"));
                };
            },
            71130: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(34809), a = r(62203), o = r(63821).BADNUM, s = r(32995), l = r(84102).clearMinTextSize;
                t1.exports = function(t1, e1, r, c) {
                    var u = t1._fullLayout;
                    l("waterfall", u), s.plot(t1, e1, r, c, {
                        mode: u.waterfallmode,
                        norm: u.waterfallmode,
                        gap: u.waterfallgap,
                        groupgap: u.waterfallgroupgap
                    }), function(t1, e1, r, s) {
                        var l = e1.xaxis, c = e1.yaxis;
                        i.makeTraceGroups(s, r, "trace bars").each(function(r) {
                            var s = n.select(this), u = r[0].trace, h = i.ensureSingle(s, "g", "lines");
                            if (u.connector && u.connector.visible) {
                                var f = "h" === u.orientation, p = u.connector.mode, d = h.selectAll("g.line").data(i.identity);
                                d.enter().append("g").classed("line", !0), d.exit().remove();
                                var m = d.size();
                                d.each(function(r, s) {
                                    if (s === m - 1 || r.cNext) {
                                        var u = function(t1, e1, r, n) {
                                            var i = [], a = [], o = n ? e1 : r, s = n ? r : e1;
                                            return i[0] = o.c2p(t1.s0, !0), a[0] = s.c2p(t1.p0, !0), i[1] = o.c2p(t1.s1, !0), a[1] = s.c2p(t1.p1, !0), i[2] = o.c2p(t1.nextS0, !0), a[2] = s.c2p(t1.nextP0, !0), n ? [
                                                i,
                                                a
                                            ] : [
                                                a,
                                                i
                                            ];
                                        }(r, l, c, f), h = u[0], d = u[1], g = "";
                                        h[0] !== o && d[0] !== o && h[1] !== o && d[1] !== o && ("spanning" === p && !r.isSum && s > 0 && (g += f ? "M" + h[0] + "," + d[1] + "V" + d[0] : "M" + h[1] + "," + d[0] + "H" + h[0]), "between" !== p && (r.isSum || s < m - 1) && (g += f ? "M" + h[1] + "," + d[0] + "V" + d[1] : "M" + h[0] + "," + d[1] + "H" + h[1]), h[2] !== o && d[2] !== o && (g += f ? "M" + h[1] + "," + d[1] + "V" + d[2] : "M" + h[1] + "," + d[1] + "H" + h[2])), "" === g && (g = "M0,0Z"), i.ensureSingle(n.select(this), "path").attr("d", g).call(a.setClipUrl, e1.layerClipId, t1);
                                    }
                                });
                            } else h.remove();
                        });
                    }(t1, e1, r, c);
                };
            },
            57256: function(t1, e1, r) {
                "use strict";
                var n = r(45568), i = r(62203), a = r(78766), o = r(20438).DESELECTDIM, s = r(6851), l = r(84102).resizeText, c = s.styleTextPoints;
                t1.exports = {
                    style: function(t1, e1, r) {
                        var s = r || n.select(t1).selectAll('g[class^="waterfalllayer"]').selectAll("g.trace");
                        l(t1, s, "waterfall"), s.style("opacity", function(t1) {
                            return t1[0].trace.opacity;
                        }), s.each(function(e1) {
                            var r = n.select(this), s = e1[0].trace;
                            r.selectAll(".point > path").each(function(t1) {
                                if (!t1.isBlank) {
                                    var e1 = s[t1.dir].marker;
                                    n.select(this).call(a.fill, e1.color).call(a.stroke, e1.line.color).call(i.dashLine, e1.line.dash, e1.line.width).style("opacity", s.selectedpoints && !t1.selected ? o : 1);
                                }
                            }), c(r, s, t1), r.selectAll(".lines").each(function() {
                                var t1 = s.connector.line;
                                i.lineGroupStyle(n.select(this).selectAll("path"), t1.width, t1.color, t1.dash);
                            });
                        });
                    }
                };
            },
            47908: function(t1, e1, r) {
                "use strict";
                var n = r(29714), i = r(34809), a = r(57297), o = r(5086).z, s = r(63821).BADNUM;
                e1.moduleType = "transform", e1.name = "aggregate";
                var l = e1.attributes = {
                    enabled: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    },
                    groups: {
                        valType: "string",
                        strict: !0,
                        noBlank: !0,
                        arrayOk: !0,
                        dflt: "x",
                        editType: "calc"
                    },
                    aggregations: {
                        _isLinkedToArray: "aggregation",
                        target: {
                            valType: "string",
                            editType: "calc"
                        },
                        func: {
                            valType: "enumerated",
                            values: [
                                "count",
                                "sum",
                                "avg",
                                "median",
                                "mode",
                                "rms",
                                "stddev",
                                "min",
                                "max",
                                "first",
                                "last",
                                "change",
                                "range"
                            ],
                            dflt: "first",
                            editType: "calc"
                        },
                        funcmode: {
                            valType: "enumerated",
                            values: [
                                "sample",
                                "population"
                            ],
                            dflt: "sample",
                            editType: "calc"
                        },
                        enabled: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "calc"
                        },
                        editType: "calc"
                    },
                    editType: "calc"
                }, c = l.aggregations;
                function u(t1, e1, r, a) {
                    if (a.enabled) {
                        for(var o = a.target, l = i.nestedProperty(e1, o), c = l.get(), u = function(t1, e1) {
                            var r = t1.func, n = e1.d2c, a = e1.c2d;
                            switch(r){
                                case "count":
                                    return h;
                                case "first":
                                    return f;
                                case "last":
                                    return p;
                                case "sum":
                                    return function(t1, e1) {
                                        for(var r = 0, i = 0; i < e1.length; i++){
                                            var o = n(t1[e1[i]]);
                                            o !== s && (r += o);
                                        }
                                        return a(r);
                                    };
                                case "avg":
                                    return function(t1, e1) {
                                        for(var r = 0, i = 0, o = 0; o < e1.length; o++){
                                            var l = n(t1[e1[o]]);
                                            l !== s && (r += l, i++);
                                        }
                                        return i ? a(r / i) : s;
                                    };
                                case "min":
                                    return function(t1, e1) {
                                        for(var r = 1 / 0, i = 0; i < e1.length; i++){
                                            var o = n(t1[e1[i]]);
                                            o !== s && (r = Math.min(r, o));
                                        }
                                        return r === 1 / 0 ? s : a(r);
                                    };
                                case "max":
                                    return function(t1, e1) {
                                        for(var r = -1 / 0, i = 0; i < e1.length; i++){
                                            var o = n(t1[e1[i]]);
                                            o !== s && (r = Math.max(r, o));
                                        }
                                        return r === -1 / 0 ? s : a(r);
                                    };
                                case "range":
                                    return function(t1, e1) {
                                        for(var r = 1 / 0, i = -1 / 0, o = 0; o < e1.length; o++){
                                            var l = n(t1[e1[o]]);
                                            l !== s && (r = Math.min(r, l), i = Math.max(i, l));
                                        }
                                        return i === -1 / 0 || r === 1 / 0 ? s : a(i - r);
                                    };
                                case "change":
                                    return function(t1, e1) {
                                        var r = n(t1[e1[0]]), i = n(t1[e1[e1.length - 1]]);
                                        return r === s || i === s ? s : a(i - r);
                                    };
                                case "median":
                                    return function(t1, e1) {
                                        for(var r = [], o = 0; o < e1.length; o++){
                                            var l = n(t1[e1[o]]);
                                            l !== s && r.push(l);
                                        }
                                        if (!r.length) return s;
                                        r.sort(i.sorterAsc);
                                        var c = (r.length - 1) / 2;
                                        return a((r[Math.floor(c)] + r[Math.ceil(c)]) / 2);
                                    };
                                case "mode":
                                    return function(t1, e1) {
                                        for(var r = {}, i = 0, o = s, l = 0; l < e1.length; l++){
                                            var c = n(t1[e1[l]]);
                                            if (c !== s) {
                                                var u = r[c] = (r[c] || 0) + 1;
                                                u > i && (i = u, o = c);
                                            }
                                        }
                                        return i ? a(o) : s;
                                    };
                                case "rms":
                                    return function(t1, e1) {
                                        for(var r = 0, i = 0, o = 0; o < e1.length; o++){
                                            var l = n(t1[e1[o]]);
                                            l !== s && (r += l * l, i++);
                                        }
                                        return i ? a(Math.sqrt(r / i)) : s;
                                    };
                                case "stddev":
                                    return function(e1, r) {
                                        var i, a = 0, o = 0, l = 1, c = s;
                                        for(i = 0; i < r.length && c === s; i++)c = n(e1[r[i]]);
                                        if (c === s) return s;
                                        for(; i < r.length; i++){
                                            var u = n(e1[r[i]]);
                                            if (u !== s) {
                                                var h = u - c;
                                                a += h, o += h * h, l++;
                                            }
                                        }
                                        var f = "sample" === t1.funcmode ? l - 1 : l;
                                        return f ? Math.sqrt((o - a * a / l) / f) : 0;
                                    };
                            }
                        }(a, n.getDataConversions(t1, e1, o, c)), d = new Array(r.length), m = 0; m < r.length; m++)d[m] = u(c, r[m]);
                        l.set(d), "count" === a.func && i.pushUnique(e1._arrayAttrs, o);
                    }
                }
                function h(t1, e1) {
                    return e1.length;
                }
                function f(t1, e1) {
                    return t1[e1[0]];
                }
                function p(t1, e1) {
                    return t1[e1[e1.length - 1]];
                }
                e1.supplyDefaults = function(t1, e1) {
                    var r, n = {};
                    function o(e1, r) {
                        return i.coerce(t1, n, l, e1, r);
                    }
                    if (!o("enabled")) return n;
                    var s = a.findArrayAttributes(e1), u = {};
                    for(r = 0; r < s.length; r++)u[s[r]] = 1;
                    var h = o("groups");
                    if (!Array.isArray(h)) {
                        if (!u[h]) return n.enabled = !1, n;
                        u[h] = 0;
                    }
                    var f, p = t1.aggregations || [], d = n.aggregations = new Array(p.length);
                    function m(t1, e1) {
                        return i.coerce(p[r], f, c, t1, e1);
                    }
                    for(r = 0; r < p.length; r++){
                        f = {
                            _index: r
                        };
                        var g = m("target"), y = m("func");
                        m("enabled") && g && (u[g] || "count" === y && void 0 === u[g]) ? ("stddev" === y && m("funcmode"), u[g] = 0, d[r] = f) : d[r] = {
                            enabled: !1,
                            _index: r
                        };
                    }
                    for(r = 0; r < s.length; r++)u[s[r]] && d.push({
                        target: s[r],
                        func: c.func.dflt,
                        enabled: !0,
                        _index: -1
                    });
                    return n;
                }, e1.calcTransform = function(t1, e1, r) {
                    if (r.enabled) {
                        var n = r.groups, a = i.getTargetArray(e1, {
                            target: n
                        });
                        if (a) {
                            var s, l, c, h, f = {}, p = {}, d = [], m = o(e1.transforms, r), g = a.length;
                            for(e1._length && (g = Math.min(g, e1._length)), s = 0; s < g; s++)void 0 === (c = f[l = a[s]]) ? (f[l] = d.length, h = [
                                s
                            ], d.push(h), p[f[l]] = m(s)) : (d[c].push(s), p[f[l]] = (p[f[l]] || []).concat(m(s)));
                            r._indexToPoints = p;
                            var y = r.aggregations;
                            for(s = 0; s < y.length; s++)u(t1, e1, d, y[s]);
                            "string" == typeof n && u(t1, e1, d, {
                                target: n,
                                func: "first",
                                enabled: !0
                            }), e1._length = d.length;
                        }
                    }
                };
            },
            42849: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(33626), a = r(29714), o = r(5086).z, s = r(20726), l = s.COMPARISON_OPS, c = s.INTERVAL_OPS, u = s.SET_OPS;
                e1.moduleType = "transform", e1.name = "filter", e1.attributes = {
                    enabled: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    },
                    target: {
                        valType: "string",
                        strict: !0,
                        noBlank: !0,
                        arrayOk: !0,
                        dflt: "x",
                        editType: "calc"
                    },
                    operation: {
                        valType: "enumerated",
                        values: [].concat(l).concat(c).concat(u),
                        dflt: "=",
                        editType: "calc"
                    },
                    value: {
                        valType: "any",
                        dflt: 0,
                        editType: "calc"
                    },
                    preservegaps: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "calc"
                    },
                    editType: "calc"
                }, e1.supplyDefaults = function(t1) {
                    var r = {};
                    function a(i, a) {
                        return n.coerce(t1, r, e1.attributes, i, a);
                    }
                    if (a("enabled")) {
                        var o = a("target");
                        if (n.isArrayOrTypedArray(o) && 0 === o.length) return r.enabled = !1, r;
                        a("preservegaps"), a("operation"), a("value");
                        var s = i.getComponentMethod("calendars", "handleDefaults");
                        s(t1, r, "valuecalendar", null), s(t1, r, "targetcalendar", null);
                    }
                    return r;
                }, e1.calcTransform = function(t1, e1, r) {
                    if (r.enabled) {
                        var i = n.getTargetArray(e1, r);
                        if (i) {
                            var s = r.target, h = i.length;
                            e1._length && (h = Math.min(h, e1._length));
                            var f = r.targetcalendar, p = e1._arrayAttrs, d = r.preservegaps;
                            if ("string" == typeof s) {
                                var m = n.nestedProperty(e1, s + "calendar").get();
                                m && (f = m);
                            }
                            var g, y, v = function(t1, e1, r) {
                                var i = t1.operation, a = t1.value, o = n.isArrayOrTypedArray(a);
                                function s(t1) {
                                    return -1 !== t1.indexOf(i);
                                }
                                var h, f = function(r) {
                                    return e1(r, 0, t1.valuecalendar);
                                }, p = function(t1) {
                                    return e1(t1, 0, r);
                                };
                                switch(s(l) ? h = f(o ? a[0] : a) : s(c) ? h = o ? [
                                    f(a[0]),
                                    f(a[1])
                                ] : [
                                    f(a),
                                    f(a)
                                ] : s(u) && (h = o ? a.map(f) : [
                                    f(a)
                                ]), i){
                                    case "=":
                                        return function(t1) {
                                            return p(t1) === h;
                                        };
                                    case "!=":
                                        return function(t1) {
                                            return p(t1) !== h;
                                        };
                                    case "<":
                                        return function(t1) {
                                            return p(t1) < h;
                                        };
                                    case "<=":
                                        return function(t1) {
                                            return p(t1) <= h;
                                        };
                                    case ">":
                                        return function(t1) {
                                            return p(t1) > h;
                                        };
                                    case ">=":
                                        return function(t1) {
                                            return p(t1) >= h;
                                        };
                                    case "[]":
                                        return function(t1) {
                                            var e1 = p(t1);
                                            return e1 >= h[0] && e1 <= h[1];
                                        };
                                    case "()":
                                        return function(t1) {
                                            var e1 = p(t1);
                                            return e1 > h[0] && e1 < h[1];
                                        };
                                    case "[)":
                                        return function(t1) {
                                            var e1 = p(t1);
                                            return e1 >= h[0] && e1 < h[1];
                                        };
                                    case "(]":
                                        return function(t1) {
                                            var e1 = p(t1);
                                            return e1 > h[0] && e1 <= h[1];
                                        };
                                    case "][":
                                        return function(t1) {
                                            var e1 = p(t1);
                                            return e1 <= h[0] || e1 >= h[1];
                                        };
                                    case ")(":
                                        return function(t1) {
                                            var e1 = p(t1);
                                            return e1 < h[0] || e1 > h[1];
                                        };
                                    case "](":
                                        return function(t1) {
                                            var e1 = p(t1);
                                            return e1 <= h[0] || e1 > h[1];
                                        };
                                    case ")[":
                                        return function(t1) {
                                            var e1 = p(t1);
                                            return e1 < h[0] || e1 >= h[1];
                                        };
                                    case "{}":
                                        return function(t1) {
                                            return -1 !== h.indexOf(p(t1));
                                        };
                                    case "}{":
                                        return function(t1) {
                                            return -1 === h.indexOf(p(t1));
                                        };
                                }
                            }(r, a.getDataToCoordFunc(t1, e1, s, i), f), x = {}, _ = {}, b = 0;
                            d ? (g = function(t1) {
                                x[t1.astr] = n.extendDeep([], t1.get()), t1.set(new Array(h));
                            }, y = function(t1, e1) {
                                var r = x[t1.astr][e1];
                                t1.get()[e1] = r;
                            }) : (g = function(t1) {
                                x[t1.astr] = n.extendDeep([], t1.get()), t1.set([]);
                            }, y = function(t1, e1) {
                                var r = x[t1.astr][e1];
                                t1.get().push(r);
                            }), k(g);
                            for(var w = o(e1.transforms, r), T = 0; T < h; T++)v(i[T]) ? (k(y, T), _[b++] = w(T)) : d && b++;
                            r._indexToPoints = _, e1._length = b;
                        }
                    }
                    function k(t1, r) {
                        for(var i = 0; i < p.length; i++)t1(n.nestedProperty(e1, p[i]), r);
                    }
                };
            },
            50453: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(57297), a = r(44122), o = r(5086).z;
                function s(t1, e1) {
                    var r, s, l, c, u, h, f, p, d, m, g = e1.transform, y = e1.transformIndex, v = t1.transforms[y].groups, x = o(t1.transforms, g);
                    if (!n.isArrayOrTypedArray(v) || 0 === v.length) return [
                        t1
                    ];
                    var _ = n.filterUnique(v), b = new Array(_.length), w = v.length, T = i.findArrayAttributes(t1), k = g.styles || [], A = {};
                    for(r = 0; r < k.length; r++)A[k[r].target] = k[r].value;
                    g.styles && (m = n.keyedContainer(g, "styles", "target", "value.name"));
                    var M = {}, S = {};
                    for(r = 0; r < _.length; r++){
                        M[h = _[r]] = r, S[h] = 0, (f = b[r] = n.extendDeepNoArrays({}, t1))._group = h, f.transforms[y]._indexToPoints = {};
                        var E = null;
                        for(m && (E = m.get(h)), f.name = E || "" === E ? E : n.templateString(g.nameformat, {
                            trace: t1.name,
                            group: h
                        }), p = f.transforms, f.transforms = [], s = 0; s < p.length; s++)f.transforms[s] = n.extendDeepNoArrays({}, p[s]);
                        for(s = 0; s < T.length; s++)n.nestedProperty(f, T[s]).set([]);
                    }
                    for(l = 0; l < T.length; l++){
                        for(c = T[l], s = 0, d = []; s < _.length; s++)d[s] = n.nestedProperty(b[s], c).get();
                        for(u = n.nestedProperty(t1, c).get(), s = 0; s < w; s++)d[M[v[s]]].push(u[s]);
                    }
                    for(s = 0; s < w; s++)(f = b[M[v[s]]]).transforms[y]._indexToPoints[S[v[s]]] = x(s), S[v[s]]++;
                    for(r = 0; r < _.length; r++)h = _[r], f = b[r], a.clearExpandedTraceDefaultColors(f), f = n.extendDeepNoArrays(f, A[h] || {});
                    return b;
                }
                e1.moduleType = "transform", e1.name = "groupby", e1.attributes = {
                    enabled: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    },
                    groups: {
                        valType: "data_array",
                        dflt: [],
                        editType: "calc"
                    },
                    nameformat: {
                        valType: "string",
                        editType: "calc"
                    },
                    styles: {
                        _isLinkedToArray: "style",
                        target: {
                            valType: "string",
                            editType: "calc"
                        },
                        value: {
                            valType: "any",
                            dflt: {},
                            editType: "calc",
                            _compareAsJSON: !0
                        },
                        editType: "calc"
                    },
                    editType: "calc"
                }, e1.supplyDefaults = function(t1, r, i) {
                    var a, o = {};
                    function s(r, i) {
                        return n.coerce(t1, o, e1.attributes, r, i);
                    }
                    if (!s("enabled")) return o;
                    s("groups"), s("nameformat", i._dataLength > 1 ? "%{group} (%{trace})" : "%{group}");
                    var l = t1.styles, c = o.styles = [];
                    if (l) for(a = 0; a < l.length; a++){
                        var u = c[a] = {};
                        n.coerce(l[a], c[a], e1.attributes.styles, "target");
                        var h = n.coerce(l[a], c[a], e1.attributes.styles, "value");
                        n.isPlainObject(h) ? u.value = n.extendDeep({}, h) : h && delete u.value;
                    }
                    return o;
                }, e1.transform = function(t1, e1) {
                    var r, n, i, a = [];
                    for(n = 0; n < t1.length; n++)for(r = s(t1[n], e1), i = 0; i < r.length; i++)a.push(r[i]);
                    return a;
                };
            },
            5086: function(t1, e1) {
                "use strict";
                e1.z = function(t1, e1) {
                    for(var r, n, i = 0; i < t1.length && (r = t1[i]) !== e1; i++)r._indexToPoints && !1 !== r.enabled && (n = r._indexToPoints);
                    var a = n ? function(t1) {
                        return n[t1];
                    } : function(t1) {
                        return [
                            t1
                        ];
                    };
                    return a;
                };
            },
            99855: function(t1, e1, r) {
                "use strict";
                var n = r(34809), i = r(29714), a = r(5086).z, o = r(63821).BADNUM;
                e1.moduleType = "transform", e1.name = "sort", e1.attributes = {
                    enabled: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    },
                    target: {
                        valType: "string",
                        strict: !0,
                        noBlank: !0,
                        arrayOk: !0,
                        dflt: "x",
                        editType: "calc"
                    },
                    order: {
                        valType: "enumerated",
                        values: [
                            "ascending",
                            "descending"
                        ],
                        dflt: "ascending",
                        editType: "calc"
                    },
                    editType: "calc"
                }, e1.supplyDefaults = function(t1) {
                    var r = {};
                    function i(i, a) {
                        return n.coerce(t1, r, e1.attributes, i, a);
                    }
                    return i("enabled") && (i("target"), i("order")), r;
                }, e1.calcTransform = function(t1, e1, r) {
                    if (r.enabled) {
                        var s = n.getTargetArray(e1, r);
                        if (s) {
                            var l = r.target, c = s.length;
                            e1._length && (c = Math.min(c, e1._length));
                            var u, h, f = e1._arrayAttrs, p = function(t1, e1, r, n) {
                                var i, a = new Array(n), s = new Array(n);
                                for(i = 0; i < n; i++)a[i] = {
                                    v: e1[i],
                                    i: i
                                };
                                for(a.sort(function(t1, e1) {
                                    switch(t1.order){
                                        case "ascending":
                                            return function(t1, r) {
                                                var n = e1(t1.v), i = e1(r.v);
                                                return n === o ? 1 : i === o ? -1 : n - i;
                                            };
                                        case "descending":
                                            return function(t1, r) {
                                                var n = e1(t1.v), i = e1(r.v);
                                                return n === o ? 1 : i === o ? -1 : i - n;
                                            };
                                    }
                                }(t1, r)), i = 0; i < n; i++)s[i] = a[i].i;
                                return s;
                            }(r, s, i.getDataToCoordFunc(t1, e1, l, s), c), d = a(e1.transforms, r), m = {};
                            for(u = 0; u < f.length; u++){
                                var g = n.nestedProperty(e1, f[u]), y = g.get(), v = new Array(c);
                                for(h = 0; h < c; h++)v[h] = y[p[h]];
                                g.set(v);
                            }
                            for(h = 0; h < c; h++)m[h] = d(p[h]);
                            r._indexToPoints = m, e1._length = c;
                        }
                    }
                };
            },
            29697: function(t1, e1) {
                "use strict";
                e1.version = "2.35.2";
            },
            99098: function(t1, e1, r) {
                var n = r(45708).Buffer, i = r(33282);
                !function() {
                    var e1 = {
                        1964: function(t1, e1, r) {
                            t1.exports = {
                                alpha_shape: r(3502),
                                convex_hull: r(7352),
                                delaunay_triangulate: r(7642),
                                gl_cone3d: r(6405),
                                gl_error3d: r(9165),
                                gl_heatmap2d: r(2510),
                                gl_line3d: r(5714),
                                gl_mesh3d: r(7201),
                                gl_plot2d: r(1850),
                                gl_plot3d: r(4100),
                                gl_pointcloud2d: r(4696),
                                gl_scatter3d: r(8418),
                                gl_select_box: r(3161),
                                gl_spikes2d: r(4098),
                                gl_streamtube3d: r(7815),
                                gl_surface3d: r(9499),
                                ndarray: r(9618),
                                ndarray_linear_interpolate: r(4317)
                            };
                        },
                        4793: function(t1, e1, r) {
                            "use strict";
                            function n(t1, e1) {
                                for(var r = 0; r < e1.length; r++){
                                    var n = e1[r];
                                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t1, i(n.key), n);
                                }
                            }
                            function i(t1) {
                                var e1 = function(t1, e1) {
                                    if ("object" != l(t1) || !t1) return t1;
                                    var r = t1[Symbol.toPrimitive];
                                    if (void 0 !== r) {
                                        var n = r.call(t1, "string");
                                        if ("object" != l(n)) return n;
                                        throw new TypeError("@@toPrimitive must return a primitive value.");
                                    }
                                    return String(t1);
                                }(t1);
                                return "symbol" == l(e1) ? e1 : e1 + "";
                            }
                            function a() {
                                try {
                                    var t1 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                                } catch (t1) {}
                                return (a = function() {
                                    return !!t1;
                                })();
                            }
                            function o(t1) {
                                return o = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t1) {
                                    return t1.__proto__ || Object.getPrototypeOf(t1);
                                }, o(t1);
                            }
                            function s(t1, e1) {
                                return s = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t1, e1) {
                                    return t1.__proto__ = e1, t1;
                                }, s(t1, e1);
                            }
                            function l(t1) {
                                return l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                                    return typeof t1;
                                } : function(t1) {
                                    return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                                }, l(t1);
                            }
                            var c = r(7507), u = r(3778), h = "function" == typeof Symbol && "function" == typeof Symbol.for ? Symbol.for("nodejs.util.inspect.custom") : null;
                            e1.hp = d, e1.IS = 50;
                            var f = 2147483647;
                            function p(t1) {
                                if (t1 > f) throw new RangeError('The value "' + t1 + '" is invalid for option "size"');
                                var e1 = new Uint8Array(t1);
                                return Object.setPrototypeOf(e1, d.prototype), e1;
                            }
                            function d(t1, e1, r) {
                                if ("number" == typeof t1) {
                                    if ("string" == typeof e1) throw new TypeError('The "string" argument must be of type string. Received type number');
                                    return y(t1);
                                }
                                return m(t1, e1, r);
                            }
                            function m(t1, e1, r) {
                                if ("string" == typeof t1) return function(t1, e1) {
                                    if ("string" == typeof e1 && "" !== e1 || (e1 = "utf8"), !d.isEncoding(e1)) throw new TypeError("Unknown encoding: " + e1);
                                    var r = 0 | b(t1, e1), n = p(r), i = n.write(t1, e1);
                                    return i !== r && (n = n.slice(0, i)), n;
                                }(t1, e1);
                                if (ArrayBuffer.isView(t1)) return function(t1) {
                                    if (et(t1, Uint8Array)) {
                                        var e1 = new Uint8Array(t1);
                                        return x(e1.buffer, e1.byteOffset, e1.byteLength);
                                    }
                                    return v(t1);
                                }(t1);
                                if (null == t1) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + l(t1));
                                if (et(t1, ArrayBuffer) || t1 && et(t1.buffer, ArrayBuffer)) return x(t1, e1, r);
                                if ("undefined" != typeof SharedArrayBuffer && (et(t1, SharedArrayBuffer) || t1 && et(t1.buffer, SharedArrayBuffer))) return x(t1, e1, r);
                                if ("number" == typeof t1) throw new TypeError('The "value" argument must not be of type number. Received type number');
                                var n = t1.valueOf && t1.valueOf();
                                if (null != n && n !== t1) return d.from(n, e1, r);
                                var i = function(t1) {
                                    if (d.isBuffer(t1)) {
                                        var e1 = 0 | _(t1.length), r = p(e1);
                                        return 0 === r.length || t1.copy(r, 0, 0, e1), r;
                                    }
                                    return void 0 !== t1.length ? "number" != typeof t1.length || rt(t1.length) ? p(0) : v(t1) : "Buffer" === t1.type && Array.isArray(t1.data) ? v(t1.data) : void 0;
                                }(t1);
                                if (i) return i;
                                if ("undefined" != typeof Symbol && null != Symbol.toPrimitive && "function" == typeof t1[Symbol.toPrimitive]) return d.from(t1[Symbol.toPrimitive]("string"), e1, r);
                                throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + l(t1));
                            }
                            function g(t1) {
                                if ("number" != typeof t1) throw new TypeError('"size" argument must be of type number');
                                if (t1 < 0) throw new RangeError('The value "' + t1 + '" is invalid for option "size"');
                            }
                            function y(t1) {
                                return g(t1), p(t1 < 0 ? 0 : 0 | _(t1));
                            }
                            function v(t1) {
                                for(var e1 = t1.length < 0 ? 0 : 0 | _(t1.length), r = p(e1), n = 0; n < e1; n += 1)r[n] = 255 & t1[n];
                                return r;
                            }
                            function x(t1, e1, r) {
                                if (e1 < 0 || t1.byteLength < e1) throw new RangeError('"offset" is outside of buffer bounds');
                                if (t1.byteLength < e1 + (r || 0)) throw new RangeError('"length" is outside of buffer bounds');
                                var n;
                                return n = void 0 === e1 && void 0 === r ? new Uint8Array(t1) : void 0 === r ? new Uint8Array(t1, e1) : new Uint8Array(t1, e1, r), Object.setPrototypeOf(n, d.prototype), n;
                            }
                            function _(t1) {
                                if (t1 >= f) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + f.toString(16) + " bytes");
                                return 0 | t1;
                            }
                            function b(t1, e1) {
                                if (d.isBuffer(t1)) return t1.length;
                                if (ArrayBuffer.isView(t1) || et(t1, ArrayBuffer)) return t1.byteLength;
                                if ("string" != typeof t1) throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + l(t1));
                                var r = t1.length, n = arguments.length > 2 && !0 === arguments[2];
                                if (!n && 0 === r) return 0;
                                for(var i = !1;;)switch(e1){
                                    case "ascii":
                                    case "latin1":
                                    case "binary":
                                        return r;
                                    case "utf8":
                                    case "utf-8":
                                        return K(t1).length;
                                    case "ucs2":
                                    case "ucs-2":
                                    case "utf16le":
                                    case "utf-16le":
                                        return 2 * r;
                                    case "hex":
                                        return r >>> 1;
                                    case "base64":
                                        return Q(t1).length;
                                    default:
                                        if (i) return n ? -1 : K(t1).length;
                                        e1 = ("" + e1).toLowerCase(), i = !0;
                                }
                            }
                            function w(t1, e1, r) {
                                var n = !1;
                                if ((void 0 === e1 || e1 < 0) && (e1 = 0), e1 > this.length) return "";
                                if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
                                if ((r >>>= 0) <= (e1 >>>= 0)) return "";
                                for(t1 || (t1 = "utf8");;)switch(t1){
                                    case "hex":
                                        return R(this, e1, r);
                                    case "utf8":
                                    case "utf-8":
                                        return P(this, e1, r);
                                    case "ascii":
                                        return O(this, e1, r);
                                    case "latin1":
                                    case "binary":
                                        return D(this, e1, r);
                                    case "base64":
                                        return I(this, e1, r);
                                    case "ucs2":
                                    case "ucs-2":
                                    case "utf16le":
                                    case "utf-16le":
                                        return F(this, e1, r);
                                    default:
                                        if (n) throw new TypeError("Unknown encoding: " + t1);
                                        t1 = (t1 + "").toLowerCase(), n = !0;
                                }
                            }
                            function T(t1, e1, r) {
                                var n = t1[e1];
                                t1[e1] = t1[r], t1[r] = n;
                            }
                            function k(t1, e1, r, n, i) {
                                if (0 === t1.length) return -1;
                                if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), rt(r = +r) && (r = i ? 0 : t1.length - 1), r < 0 && (r = t1.length + r), r >= t1.length) {
                                    if (i) return -1;
                                    r = t1.length - 1;
                                } else if (r < 0) {
                                    if (!i) return -1;
                                    r = 0;
                                }
                                if ("string" == typeof e1 && (e1 = d.from(e1, n)), d.isBuffer(e1)) return 0 === e1.length ? -1 : A(t1, e1, r, n, i);
                                if ("number" == typeof e1) return e1 &= 255, "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(t1, e1, r) : Uint8Array.prototype.lastIndexOf.call(t1, e1, r) : A(t1, [
                                    e1
                                ], r, n, i);
                                throw new TypeError("val must be string, number or Buffer");
                            }
                            function A(t1, e1, r, n, i) {
                                var a, o = 1, s = t1.length, l = e1.length;
                                if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
                                    if (t1.length < 2 || e1.length < 2) return -1;
                                    o = 2, s /= 2, l /= 2, r /= 2;
                                }
                                function c(t1, e1) {
                                    return 1 === o ? t1[e1] : t1.readUInt16BE(e1 * o);
                                }
                                if (i) {
                                    var u = -1;
                                    for(a = r; a < s; a++)if (c(t1, a) === c(e1, -1 === u ? 0 : a - u)) {
                                        if (-1 === u && (u = a), a - u + 1 === l) return u * o;
                                    } else -1 !== u && (a -= a - u), u = -1;
                                } else for(r + l > s && (r = s - l), a = r; a >= 0; a--){
                                    for(var h = !0, f = 0; f < l; f++)if (c(t1, a + f) !== c(e1, f)) {
                                        h = !1;
                                        break;
                                    }
                                    if (h) return a;
                                }
                                return -1;
                            }
                            function M(t1, e1, r, n) {
                                r = Number(r) || 0;
                                var i = t1.length - r;
                                n ? (n = Number(n)) > i && (n = i) : n = i;
                                var a, o = e1.length;
                                for(n > o / 2 && (n = o / 2), a = 0; a < n; ++a){
                                    var s = parseInt(e1.substr(2 * a, 2), 16);
                                    if (rt(s)) return a;
                                    t1[r + a] = s;
                                }
                                return a;
                            }
                            function S(t1, e1, r, n) {
                                return tt(K(e1, t1.length - r), t1, r, n);
                            }
                            function E(t1, e1, r, n) {
                                return tt(function(t1) {
                                    for(var e1 = [], r = 0; r < t1.length; ++r)e1.push(255 & t1.charCodeAt(r));
                                    return e1;
                                }(e1), t1, r, n);
                            }
                            function C(t1, e1, r, n) {
                                return tt(Q(e1), t1, r, n);
                            }
                            function L(t1, e1, r, n) {
                                return tt(function(t1, e1) {
                                    for(var r, n, i, a = [], o = 0; o < t1.length && !((e1 -= 2) < 0); ++o)n = (r = t1.charCodeAt(o)) >> 8, i = r % 256, a.push(i), a.push(n);
                                    return a;
                                }(e1, t1.length - r), t1, r, n);
                            }
                            function I(t1, e1, r) {
                                return 0 === e1 && r === t1.length ? c.fromByteArray(t1) : c.fromByteArray(t1.slice(e1, r));
                            }
                            function P(t1, e1, r) {
                                r = Math.min(t1.length, r);
                                for(var n = [], i = e1; i < r;){
                                    var a = t1[i], o = null, s = a > 239 ? 4 : a > 223 ? 3 : a > 191 ? 2 : 1;
                                    if (i + s <= r) {
                                        var l = void 0, c = void 0, u = void 0, h = void 0;
                                        switch(s){
                                            case 1:
                                                a < 128 && (o = a);
                                                break;
                                            case 2:
                                                128 == (192 & (l = t1[i + 1])) && (h = (31 & a) << 6 | 63 & l) > 127 && (o = h);
                                                break;
                                            case 3:
                                                l = t1[i + 1], c = t1[i + 2], 128 == (192 & l) && 128 == (192 & c) && (h = (15 & a) << 12 | (63 & l) << 6 | 63 & c) > 2047 && (h < 55296 || h > 57343) && (o = h);
                                                break;
                                            case 4:
                                                l = t1[i + 1], c = t1[i + 2], u = t1[i + 3], 128 == (192 & l) && 128 == (192 & c) && 128 == (192 & u) && (h = (15 & a) << 18 | (63 & l) << 12 | (63 & c) << 6 | 63 & u) > 65535 && h < 1114112 && (o = h);
                                        }
                                    }
                                    null === o ? (o = 65533, s = 1) : o > 65535 && (o -= 65536, n.push(o >>> 10 & 1023 | 55296), o = 56320 | 1023 & o), n.push(o), i += s;
                                }
                                return function(t1) {
                                    var e1 = t1.length;
                                    if (e1 <= z) return String.fromCharCode.apply(String, t1);
                                    for(var r = "", n = 0; n < e1;)r += String.fromCharCode.apply(String, t1.slice(n, n += z));
                                    return r;
                                }(n);
                            }
                            d.TYPED_ARRAY_SUPPORT = function() {
                                try {
                                    var t1 = new Uint8Array(1), e1 = {
                                        foo: function() {
                                            return 42;
                                        }
                                    };
                                    return Object.setPrototypeOf(e1, Uint8Array.prototype), Object.setPrototypeOf(t1, e1), 42 === t1.foo();
                                } catch (t1) {
                                    return !1;
                                }
                            }(), d.TYPED_ARRAY_SUPPORT || "undefined" == typeof console || "function" != typeof console.error || console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."), Object.defineProperty(d.prototype, "parent", {
                                enumerable: !0,
                                get: function() {
                                    if (d.isBuffer(this)) return this.buffer;
                                }
                            }), Object.defineProperty(d.prototype, "offset", {
                                enumerable: !0,
                                get: function() {
                                    if (d.isBuffer(this)) return this.byteOffset;
                                }
                            }), d.poolSize = 8192, d.from = function(t1, e1, r) {
                                return m(t1, e1, r);
                            }, Object.setPrototypeOf(d.prototype, Uint8Array.prototype), Object.setPrototypeOf(d, Uint8Array), d.alloc = function(t1, e1, r) {
                                return function(t1, e1, r) {
                                    return g(t1), t1 <= 0 ? p(t1) : void 0 !== e1 ? "string" == typeof r ? p(t1).fill(e1, r) : p(t1).fill(e1) : p(t1);
                                }(t1, e1, r);
                            }, d.allocUnsafe = function(t1) {
                                return y(t1);
                            }, d.allocUnsafeSlow = function(t1) {
                                return y(t1);
                            }, d.isBuffer = function(t1) {
                                return null != t1 && !0 === t1._isBuffer && t1 !== d.prototype;
                            }, d.compare = function(t1, e1) {
                                if (et(t1, Uint8Array) && (t1 = d.from(t1, t1.offset, t1.byteLength)), et(e1, Uint8Array) && (e1 = d.from(e1, e1.offset, e1.byteLength)), !d.isBuffer(t1) || !d.isBuffer(e1)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
                                if (t1 === e1) return 0;
                                for(var r = t1.length, n = e1.length, i = 0, a = Math.min(r, n); i < a; ++i)if (t1[i] !== e1[i]) {
                                    r = t1[i], n = e1[i];
                                    break;
                                }
                                return r < n ? -1 : n < r ? 1 : 0;
                            }, d.isEncoding = function(t1) {
                                switch(String(t1).toLowerCase()){
                                    case "hex":
                                    case "utf8":
                                    case "utf-8":
                                    case "ascii":
                                    case "latin1":
                                    case "binary":
                                    case "base64":
                                    case "ucs2":
                                    case "ucs-2":
                                    case "utf16le":
                                    case "utf-16le":
                                        return !0;
                                    default:
                                        return !1;
                                }
                            }, d.concat = function(t1, e1) {
                                if (!Array.isArray(t1)) throw new TypeError('"list" argument must be an Array of Buffers');
                                if (0 === t1.length) return d.alloc(0);
                                var r;
                                if (void 0 === e1) for(e1 = 0, r = 0; r < t1.length; ++r)e1 += t1[r].length;
                                var n = d.allocUnsafe(e1), i = 0;
                                for(r = 0; r < t1.length; ++r){
                                    var a = t1[r];
                                    if (et(a, Uint8Array)) i + a.length > n.length ? (d.isBuffer(a) || (a = d.from(a)), a.copy(n, i)) : Uint8Array.prototype.set.call(n, a, i);
                                    else {
                                        if (!d.isBuffer(a)) throw new TypeError('"list" argument must be an Array of Buffers');
                                        a.copy(n, i);
                                    }
                                    i += a.length;
                                }
                                return n;
                            }, d.byteLength = b, d.prototype._isBuffer = !0, d.prototype.swap16 = function() {
                                var t1 = this.length;
                                if (t1 % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
                                for(var e1 = 0; e1 < t1; e1 += 2)T(this, e1, e1 + 1);
                                return this;
                            }, d.prototype.swap32 = function() {
                                var t1 = this.length;
                                if (t1 % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
                                for(var e1 = 0; e1 < t1; e1 += 4)T(this, e1, e1 + 3), T(this, e1 + 1, e1 + 2);
                                return this;
                            }, d.prototype.swap64 = function() {
                                var t1 = this.length;
                                if (t1 % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
                                for(var e1 = 0; e1 < t1; e1 += 8)T(this, e1, e1 + 7), T(this, e1 + 1, e1 + 6), T(this, e1 + 2, e1 + 5), T(this, e1 + 3, e1 + 4);
                                return this;
                            }, d.prototype.toString = function() {
                                var t1 = this.length;
                                return 0 === t1 ? "" : 0 === arguments.length ? P(this, 0, t1) : w.apply(this, arguments);
                            }, d.prototype.toLocaleString = d.prototype.toString, d.prototype.equals = function(t1) {
                                if (!d.isBuffer(t1)) throw new TypeError("Argument must be a Buffer");
                                return this === t1 || 0 === d.compare(this, t1);
                            }, d.prototype.inspect = function() {
                                var t1 = "", r = e1.IS;
                                return t1 = this.toString("hex", 0, r).replace(/(.{2})/g, "$1 ").trim(), this.length > r && (t1 += " ... "), "<Buffer " + t1 + ">";
                            }, h && (d.prototype[h] = d.prototype.inspect), d.prototype.compare = function(t1, e1, r, n, i) {
                                if (et(t1, Uint8Array) && (t1 = d.from(t1, t1.offset, t1.byteLength)), !d.isBuffer(t1)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + l(t1));
                                if (void 0 === e1 && (e1 = 0), void 0 === r && (r = t1 ? t1.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), e1 < 0 || r > t1.length || n < 0 || i > this.length) throw new RangeError("out of range index");
                                if (n >= i && e1 >= r) return 0;
                                if (n >= i) return -1;
                                if (e1 >= r) return 1;
                                if (this === t1) return 0;
                                for(var a = (i >>>= 0) - (n >>>= 0), o = (r >>>= 0) - (e1 >>>= 0), s = Math.min(a, o), c = this.slice(n, i), u = t1.slice(e1, r), h = 0; h < s; ++h)if (c[h] !== u[h]) {
                                    a = c[h], o = u[h];
                                    break;
                                }
                                return a < o ? -1 : o < a ? 1 : 0;
                            }, d.prototype.includes = function(t1, e1, r) {
                                return -1 !== this.indexOf(t1, e1, r);
                            }, d.prototype.indexOf = function(t1, e1, r) {
                                return k(this, t1, e1, r, !0);
                            }, d.prototype.lastIndexOf = function(t1, e1, r) {
                                return k(this, t1, e1, r, !1);
                            }, d.prototype.write = function(t1, e1, r, n) {
                                if (void 0 === e1) n = "utf8", r = this.length, e1 = 0;
                                else if (void 0 === r && "string" == typeof e1) n = e1, r = this.length, e1 = 0;
                                else {
                                    if (!isFinite(e1)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                                    e1 >>>= 0, isFinite(r) ? (r >>>= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
                                }
                                var i = this.length - e1;
                                if ((void 0 === r || r > i) && (r = i), t1.length > 0 && (r < 0 || e1 < 0) || e1 > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                                n || (n = "utf8");
                                for(var a = !1;;)switch(n){
                                    case "hex":
                                        return M(this, t1, e1, r);
                                    case "utf8":
                                    case "utf-8":
                                        return S(this, t1, e1, r);
                                    case "ascii":
                                    case "latin1":
                                    case "binary":
                                        return E(this, t1, e1, r);
                                    case "base64":
                                        return C(this, t1, e1, r);
                                    case "ucs2":
                                    case "ucs-2":
                                    case "utf16le":
                                    case "utf-16le":
                                        return L(this, t1, e1, r);
                                    default:
                                        if (a) throw new TypeError("Unknown encoding: " + n);
                                        n = ("" + n).toLowerCase(), a = !0;
                                }
                            }, d.prototype.toJSON = function() {
                                return {
                                    type: "Buffer",
                                    data: Array.prototype.slice.call(this._arr || this, 0)
                                };
                            };
                            var z = 4096;
                            function O(t1, e1, r) {
                                var n = "";
                                r = Math.min(t1.length, r);
                                for(var i = e1; i < r; ++i)n += String.fromCharCode(127 & t1[i]);
                                return n;
                            }
                            function D(t1, e1, r) {
                                var n = "";
                                r = Math.min(t1.length, r);
                                for(var i = e1; i < r; ++i)n += String.fromCharCode(t1[i]);
                                return n;
                            }
                            function R(t1, e1, r) {
                                var n = t1.length;
                                (!e1 || e1 < 0) && (e1 = 0), (!r || r < 0 || r > n) && (r = n);
                                for(var i = "", a = e1; a < r; ++a)i += nt[t1[a]];
                                return i;
                            }
                            function F(t1, e1, r) {
                                for(var n = t1.slice(e1, r), i = "", a = 0; a < n.length - 1; a += 2)i += String.fromCharCode(n[a] + 256 * n[a + 1]);
                                return i;
                            }
                            function B(t1, e1, r) {
                                if (t1 % 1 != 0 || t1 < 0) throw new RangeError("offset is not uint");
                                if (t1 + e1 > r) throw new RangeError("Trying to access beyond buffer length");
                            }
                            function N(t1, e1, r, n, i, a) {
                                if (!d.isBuffer(t1)) throw new TypeError('"buffer" argument must be a Buffer instance');
                                if (e1 > i || e1 < a) throw new RangeError('"value" argument is out of bounds');
                                if (r + n > t1.length) throw new RangeError("Index out of range");
                            }
                            function j(t1, e1, r, n, i) {
                                Y(e1, n, i, t1, r, 7);
                                var a = Number(e1 & BigInt(4294967295));
                                t1[r++] = a, a >>= 8, t1[r++] = a, a >>= 8, t1[r++] = a, a >>= 8, t1[r++] = a;
                                var o = Number(e1 >> BigInt(32) & BigInt(4294967295));
                                return t1[r++] = o, o >>= 8, t1[r++] = o, o >>= 8, t1[r++] = o, o >>= 8, t1[r++] = o, r;
                            }
                            function U(t1, e1, r, n, i) {
                                Y(e1, n, i, t1, r, 7);
                                var a = Number(e1 & BigInt(4294967295));
                                t1[r + 7] = a, a >>= 8, t1[r + 6] = a, a >>= 8, t1[r + 5] = a, a >>= 8, t1[r + 4] = a;
                                var o = Number(e1 >> BigInt(32) & BigInt(4294967295));
                                return t1[r + 3] = o, o >>= 8, t1[r + 2] = o, o >>= 8, t1[r + 1] = o, o >>= 8, t1[r] = o, r + 8;
                            }
                            function V(t1, e1, r, n, i, a) {
                                if (r + n > t1.length) throw new RangeError("Index out of range");
                                if (r < 0) throw new RangeError("Index out of range");
                            }
                            function q(t1, e1, r, n, i) {
                                return e1 = +e1, r >>>= 0, i || V(t1, 0, r, 4), u.write(t1, e1, r, n, 23, 4), r + 4;
                            }
                            function H(t1, e1, r, n, i) {
                                return e1 = +e1, r >>>= 0, i || V(t1, 0, r, 8), u.write(t1, e1, r, n, 52, 8), r + 8;
                            }
                            d.prototype.slice = function(t1, e1) {
                                var r = this.length;
                                (t1 = ~~t1) < 0 ? (t1 += r) < 0 && (t1 = 0) : t1 > r && (t1 = r), (e1 = void 0 === e1 ? r : ~~e1) < 0 ? (e1 += r) < 0 && (e1 = 0) : e1 > r && (e1 = r), e1 < t1 && (e1 = t1);
                                var n = this.subarray(t1, e1);
                                return Object.setPrototypeOf(n, d.prototype), n;
                            }, d.prototype.readUintLE = d.prototype.readUIntLE = function(t1, e1, r) {
                                t1 >>>= 0, e1 >>>= 0, r || B(t1, e1, this.length);
                                for(var n = this[t1], i = 1, a = 0; ++a < e1 && (i *= 256);)n += this[t1 + a] * i;
                                return n;
                            }, d.prototype.readUintBE = d.prototype.readUIntBE = function(t1, e1, r) {
                                t1 >>>= 0, e1 >>>= 0, r || B(t1, e1, this.length);
                                for(var n = this[t1 + --e1], i = 1; e1 > 0 && (i *= 256);)n += this[t1 + --e1] * i;
                                return n;
                            }, d.prototype.readUint8 = d.prototype.readUInt8 = function(t1, e1) {
                                return t1 >>>= 0, e1 || B(t1, 1, this.length), this[t1];
                            }, d.prototype.readUint16LE = d.prototype.readUInt16LE = function(t1, e1) {
                                return t1 >>>= 0, e1 || B(t1, 2, this.length), this[t1] | this[t1 + 1] << 8;
                            }, d.prototype.readUint16BE = d.prototype.readUInt16BE = function(t1, e1) {
                                return t1 >>>= 0, e1 || B(t1, 2, this.length), this[t1] << 8 | this[t1 + 1];
                            }, d.prototype.readUint32LE = d.prototype.readUInt32LE = function(t1, e1) {
                                return t1 >>>= 0, e1 || B(t1, 4, this.length), (this[t1] | this[t1 + 1] << 8 | this[t1 + 2] << 16) + 16777216 * this[t1 + 3];
                            }, d.prototype.readUint32BE = d.prototype.readUInt32BE = function(t1, e1) {
                                return t1 >>>= 0, e1 || B(t1, 4, this.length), 16777216 * this[t1] + (this[t1 + 1] << 16 | this[t1 + 2] << 8 | this[t1 + 3]);
                            }, d.prototype.readBigUInt64LE = it(function(t1) {
                                X(t1 >>>= 0, "offset");
                                var e1 = this[t1], r = this[t1 + 7];
                                void 0 !== e1 && void 0 !== r || $(t1, this.length - 8);
                                var n = e1 + this[++t1] * Math.pow(2, 8) + this[++t1] * Math.pow(2, 16) + this[++t1] * Math.pow(2, 24), i = this[++t1] + this[++t1] * Math.pow(2, 8) + this[++t1] * Math.pow(2, 16) + r * Math.pow(2, 24);
                                return BigInt(n) + (BigInt(i) << BigInt(32));
                            }), d.prototype.readBigUInt64BE = it(function(t1) {
                                X(t1 >>>= 0, "offset");
                                var e1 = this[t1], r = this[t1 + 7];
                                void 0 !== e1 && void 0 !== r || $(t1, this.length - 8);
                                var n = e1 * Math.pow(2, 24) + this[++t1] * Math.pow(2, 16) + this[++t1] * Math.pow(2, 8) + this[++t1], i = this[++t1] * Math.pow(2, 24) + this[++t1] * Math.pow(2, 16) + this[++t1] * Math.pow(2, 8) + r;
                                return (BigInt(n) << BigInt(32)) + BigInt(i);
                            }), d.prototype.readIntLE = function(t1, e1, r) {
                                t1 >>>= 0, e1 >>>= 0, r || B(t1, e1, this.length);
                                for(var n = this[t1], i = 1, a = 0; ++a < e1 && (i *= 256);)n += this[t1 + a] * i;
                                return n >= (i *= 128) && (n -= Math.pow(2, 8 * e1)), n;
                            }, d.prototype.readIntBE = function(t1, e1, r) {
                                t1 >>>= 0, e1 >>>= 0, r || B(t1, e1, this.length);
                                for(var n = e1, i = 1, a = this[t1 + --n]; n > 0 && (i *= 256);)a += this[t1 + --n] * i;
                                return a >= (i *= 128) && (a -= Math.pow(2, 8 * e1)), a;
                            }, d.prototype.readInt8 = function(t1, e1) {
                                return t1 >>>= 0, e1 || B(t1, 1, this.length), 128 & this[t1] ? -1 * (255 - this[t1] + 1) : this[t1];
                            }, d.prototype.readInt16LE = function(t1, e1) {
                                t1 >>>= 0, e1 || B(t1, 2, this.length);
                                var r = this[t1] | this[t1 + 1] << 8;
                                return 32768 & r ? 4294901760 | r : r;
                            }, d.prototype.readInt16BE = function(t1, e1) {
                                t1 >>>= 0, e1 || B(t1, 2, this.length);
                                var r = this[t1 + 1] | this[t1] << 8;
                                return 32768 & r ? 4294901760 | r : r;
                            }, d.prototype.readInt32LE = function(t1, e1) {
                                return t1 >>>= 0, e1 || B(t1, 4, this.length), this[t1] | this[t1 + 1] << 8 | this[t1 + 2] << 16 | this[t1 + 3] << 24;
                            }, d.prototype.readInt32BE = function(t1, e1) {
                                return t1 >>>= 0, e1 || B(t1, 4, this.length), this[t1] << 24 | this[t1 + 1] << 16 | this[t1 + 2] << 8 | this[t1 + 3];
                            }, d.prototype.readBigInt64LE = it(function(t1) {
                                X(t1 >>>= 0, "offset");
                                var e1 = this[t1], r = this[t1 + 7];
                                void 0 !== e1 && void 0 !== r || $(t1, this.length - 8);
                                var n = this[t1 + 4] + this[t1 + 5] * Math.pow(2, 8) + this[t1 + 6] * Math.pow(2, 16) + (r << 24);
                                return (BigInt(n) << BigInt(32)) + BigInt(e1 + this[++t1] * Math.pow(2, 8) + this[++t1] * Math.pow(2, 16) + this[++t1] * Math.pow(2, 24));
                            }), d.prototype.readBigInt64BE = it(function(t1) {
                                X(t1 >>>= 0, "offset");
                                var e1 = this[t1], r = this[t1 + 7];
                                void 0 !== e1 && void 0 !== r || $(t1, this.length - 8);
                                var n = (e1 << 24) + this[++t1] * Math.pow(2, 16) + this[++t1] * Math.pow(2, 8) + this[++t1];
                                return (BigInt(n) << BigInt(32)) + BigInt(this[++t1] * Math.pow(2, 24) + this[++t1] * Math.pow(2, 16) + this[++t1] * Math.pow(2, 8) + r);
                            }), d.prototype.readFloatLE = function(t1, e1) {
                                return t1 >>>= 0, e1 || B(t1, 4, this.length), u.read(this, t1, !0, 23, 4);
                            }, d.prototype.readFloatBE = function(t1, e1) {
                                return t1 >>>= 0, e1 || B(t1, 4, this.length), u.read(this, t1, !1, 23, 4);
                            }, d.prototype.readDoubleLE = function(t1, e1) {
                                return t1 >>>= 0, e1 || B(t1, 8, this.length), u.read(this, t1, !0, 52, 8);
                            }, d.prototype.readDoubleBE = function(t1, e1) {
                                return t1 >>>= 0, e1 || B(t1, 8, this.length), u.read(this, t1, !1, 52, 8);
                            }, d.prototype.writeUintLE = d.prototype.writeUIntLE = function(t1, e1, r, n) {
                                t1 = +t1, e1 >>>= 0, r >>>= 0, n || N(this, t1, e1, r, Math.pow(2, 8 * r) - 1, 0);
                                var i = 1, a = 0;
                                for(this[e1] = 255 & t1; ++a < r && (i *= 256);)this[e1 + a] = t1 / i & 255;
                                return e1 + r;
                            }, d.prototype.writeUintBE = d.prototype.writeUIntBE = function(t1, e1, r, n) {
                                t1 = +t1, e1 >>>= 0, r >>>= 0, n || N(this, t1, e1, r, Math.pow(2, 8 * r) - 1, 0);
                                var i = r - 1, a = 1;
                                for(this[e1 + i] = 255 & t1; --i >= 0 && (a *= 256);)this[e1 + i] = t1 / a & 255;
                                return e1 + r;
                            }, d.prototype.writeUint8 = d.prototype.writeUInt8 = function(t1, e1, r) {
                                return t1 = +t1, e1 >>>= 0, r || N(this, t1, e1, 1, 255, 0), this[e1] = 255 & t1, e1 + 1;
                            }, d.prototype.writeUint16LE = d.prototype.writeUInt16LE = function(t1, e1, r) {
                                return t1 = +t1, e1 >>>= 0, r || N(this, t1, e1, 2, 65535, 0), this[e1] = 255 & t1, this[e1 + 1] = t1 >>> 8, e1 + 2;
                            }, d.prototype.writeUint16BE = d.prototype.writeUInt16BE = function(t1, e1, r) {
                                return t1 = +t1, e1 >>>= 0, r || N(this, t1, e1, 2, 65535, 0), this[e1] = t1 >>> 8, this[e1 + 1] = 255 & t1, e1 + 2;
                            }, d.prototype.writeUint32LE = d.prototype.writeUInt32LE = function(t1, e1, r) {
                                return t1 = +t1, e1 >>>= 0, r || N(this, t1, e1, 4, 4294967295, 0), this[e1 + 3] = t1 >>> 24, this[e1 + 2] = t1 >>> 16, this[e1 + 1] = t1 >>> 8, this[e1] = 255 & t1, e1 + 4;
                            }, d.prototype.writeUint32BE = d.prototype.writeUInt32BE = function(t1, e1, r) {
                                return t1 = +t1, e1 >>>= 0, r || N(this, t1, e1, 4, 4294967295, 0), this[e1] = t1 >>> 24, this[e1 + 1] = t1 >>> 16, this[e1 + 2] = t1 >>> 8, this[e1 + 3] = 255 & t1, e1 + 4;
                            }, d.prototype.writeBigUInt64LE = it(function(t1) {
                                return j(this, t1, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, BigInt(0), BigInt("0xffffffffffffffff"));
                            }), d.prototype.writeBigUInt64BE = it(function(t1) {
                                return U(this, t1, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, BigInt(0), BigInt("0xffffffffffffffff"));
                            }), d.prototype.writeIntLE = function(t1, e1, r, n) {
                                if (t1 = +t1, e1 >>>= 0, !n) {
                                    var i = Math.pow(2, 8 * r - 1);
                                    N(this, t1, e1, r, i - 1, -i);
                                }
                                var a = 0, o = 1, s = 0;
                                for(this[e1] = 255 & t1; ++a < r && (o *= 256);)t1 < 0 && 0 === s && 0 !== this[e1 + a - 1] && (s = 1), this[e1 + a] = (t1 / o >> 0) - s & 255;
                                return e1 + r;
                            }, d.prototype.writeIntBE = function(t1, e1, r, n) {
                                if (t1 = +t1, e1 >>>= 0, !n) {
                                    var i = Math.pow(2, 8 * r - 1);
                                    N(this, t1, e1, r, i - 1, -i);
                                }
                                var a = r - 1, o = 1, s = 0;
                                for(this[e1 + a] = 255 & t1; --a >= 0 && (o *= 256);)t1 < 0 && 0 === s && 0 !== this[e1 + a + 1] && (s = 1), this[e1 + a] = (t1 / o >> 0) - s & 255;
                                return e1 + r;
                            }, d.prototype.writeInt8 = function(t1, e1, r) {
                                return t1 = +t1, e1 >>>= 0, r || N(this, t1, e1, 1, 127, -128), t1 < 0 && (t1 = 255 + t1 + 1), this[e1] = 255 & t1, e1 + 1;
                            }, d.prototype.writeInt16LE = function(t1, e1, r) {
                                return t1 = +t1, e1 >>>= 0, r || N(this, t1, e1, 2, 32767, -32768), this[e1] = 255 & t1, this[e1 + 1] = t1 >>> 8, e1 + 2;
                            }, d.prototype.writeInt16BE = function(t1, e1, r) {
                                return t1 = +t1, e1 >>>= 0, r || N(this, t1, e1, 2, 32767, -32768), this[e1] = t1 >>> 8, this[e1 + 1] = 255 & t1, e1 + 2;
                            }, d.prototype.writeInt32LE = function(t1, e1, r) {
                                return t1 = +t1, e1 >>>= 0, r || N(this, t1, e1, 4, 2147483647, -2147483648), this[e1] = 255 & t1, this[e1 + 1] = t1 >>> 8, this[e1 + 2] = t1 >>> 16, this[e1 + 3] = t1 >>> 24, e1 + 4;
                            }, d.prototype.writeInt32BE = function(t1, e1, r) {
                                return t1 = +t1, e1 >>>= 0, r || N(this, t1, e1, 4, 2147483647, -2147483648), t1 < 0 && (t1 = 4294967295 + t1 + 1), this[e1] = t1 >>> 24, this[e1 + 1] = t1 >>> 16, this[e1 + 2] = t1 >>> 8, this[e1 + 3] = 255 & t1, e1 + 4;
                            }, d.prototype.writeBigInt64LE = it(function(t1) {
                                return j(this, t1, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
                            }), d.prototype.writeBigInt64BE = it(function(t1) {
                                return U(this, t1, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
                            }), d.prototype.writeFloatLE = function(t1, e1, r) {
                                return q(this, t1, e1, !0, r);
                            }, d.prototype.writeFloatBE = function(t1, e1, r) {
                                return q(this, t1, e1, !1, r);
                            }, d.prototype.writeDoubleLE = function(t1, e1, r) {
                                return H(this, t1, e1, !0, r);
                            }, d.prototype.writeDoubleBE = function(t1, e1, r) {
                                return H(this, t1, e1, !1, r);
                            }, d.prototype.copy = function(t1, e1, r, n) {
                                if (!d.isBuffer(t1)) throw new TypeError("argument should be a Buffer");
                                if (r || (r = 0), n || 0 === n || (n = this.length), e1 >= t1.length && (e1 = t1.length), e1 || (e1 = 0), n > 0 && n < r && (n = r), n === r) return 0;
                                if (0 === t1.length || 0 === this.length) return 0;
                                if (e1 < 0) throw new RangeError("targetStart out of bounds");
                                if (r < 0 || r >= this.length) throw new RangeError("Index out of range");
                                if (n < 0) throw new RangeError("sourceEnd out of bounds");
                                n > this.length && (n = this.length), t1.length - e1 < n - r && (n = t1.length - e1 + r);
                                var i = n - r;
                                return this === t1 && "function" == typeof Uint8Array.prototype.copyWithin ? this.copyWithin(e1, r, n) : Uint8Array.prototype.set.call(t1, this.subarray(r, n), e1), i;
                            }, d.prototype.fill = function(t1, e1, r, n) {
                                if ("string" == typeof t1) {
                                    if ("string" == typeof e1 ? (n = e1, e1 = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
                                    if ("string" == typeof n && !d.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
                                    if (1 === t1.length) {
                                        var i = t1.charCodeAt(0);
                                        ("utf8" === n && i < 128 || "latin1" === n) && (t1 = i);
                                    }
                                } else "number" == typeof t1 ? t1 &= 255 : "boolean" == typeof t1 && (t1 = Number(t1));
                                if (e1 < 0 || this.length < e1 || this.length < r) throw new RangeError("Out of range index");
                                if (r <= e1) return this;
                                var a;
                                if (e1 >>>= 0, r = void 0 === r ? this.length : r >>> 0, t1 || (t1 = 0), "number" == typeof t1) for(a = e1; a < r; ++a)this[a] = t1;
                                else {
                                    var o = d.isBuffer(t1) ? t1 : d.from(t1, n), s = o.length;
                                    if (0 === s) throw new TypeError('The value "' + t1 + '" is invalid for argument "value"');
                                    for(a = 0; a < r - e1; ++a)this[a + e1] = o[a % s];
                                }
                                return this;
                            };
                            var G = {};
                            function Z(t1, e1, r) {
                                G[t1] = function(r) {
                                    function i() {
                                        var r;
                                        return function(t1, e1) {
                                            if (!(t1 instanceof e1)) throw new TypeError("Cannot call a class as a function");
                                        }(this, i), r = function(t1, e1, r) {
                                            return e1 = o(e1), function(t1, e1) {
                                                if (e1 && ("object" == l(e1) || "function" == typeof e1)) return e1;
                                                if (void 0 !== e1) throw new TypeError("Derived constructors may only return object or undefined");
                                                return function(t1) {
                                                    if (void 0 === t1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                                    return t1;
                                                }(t1);
                                            }(t1, a() ? Reflect.construct(e1, r || [], o(t1).constructor) : e1.apply(t1, r));
                                        }(this, i), Object.defineProperty(r, "message", {
                                            value: e1.apply(r, arguments),
                                            writable: !0,
                                            configurable: !0
                                        }), r.name = "".concat(r.name, " [").concat(t1, "]"), r.stack, delete r.name, r;
                                    }
                                    var c, u;
                                    return function(t1, e1) {
                                        if ("function" != typeof e1 && null !== e1) throw new TypeError("Super expression must either be null or a function");
                                        t1.prototype = Object.create(e1 && e1.prototype, {
                                            constructor: {
                                                value: t1,
                                                writable: !0,
                                                configurable: !0
                                            }
                                        }), Object.defineProperty(t1, "prototype", {
                                            writable: !1
                                        }), e1 && s(t1, e1);
                                    }(i, r), c = i, u = [
                                        {
                                            key: "code",
                                            get: function() {
                                                return t1;
                                            },
                                            set: function(t1) {
                                                Object.defineProperty(this, "code", {
                                                    configurable: !0,
                                                    enumerable: !0,
                                                    value: t1,
                                                    writable: !0
                                                });
                                            }
                                        },
                                        {
                                            key: "toString",
                                            value: function() {
                                                return "".concat(this.name, " [").concat(t1, "]: ").concat(this.message);
                                            }
                                        }
                                    ], n(c.prototype, u), Object.defineProperty(c, "prototype", {
                                        writable: !1
                                    }), c;
                                }(r);
                            }
                            function W(t1) {
                                for(var e1 = "", r = t1.length, n = "-" === t1[0] ? 1 : 0; r >= n + 4; r -= 3)e1 = "_".concat(t1.slice(r - 3, r)).concat(e1);
                                return "".concat(t1.slice(0, r)).concat(e1);
                            }
                            function Y(t1, e1, r, n, i, a) {
                                if (t1 > r || t1 < e1) {
                                    var o, s = "bigint" == typeof e1 ? "n" : "";
                                    throw o = a > 3 ? 0 === e1 || e1 === BigInt(0) ? ">= 0".concat(s, " and < 2").concat(s, " ** ").concat(8 * (a + 1)).concat(s) : ">= -(2".concat(s, " ** ").concat(8 * (a + 1) - 1).concat(s, ") and < 2 ** ") + "".concat(8 * (a + 1) - 1).concat(s) : ">= ".concat(e1).concat(s, " and <= ").concat(r).concat(s), new G.ERR_OUT_OF_RANGE("value", o, t1);
                                }
                                !function(t1, e1, r) {
                                    X(e1, "offset"), void 0 !== t1[e1] && void 0 !== t1[e1 + r] || $(e1, t1.length - (r + 1));
                                }(n, i, a);
                            }
                            function X(t1, e1) {
                                if ("number" != typeof t1) throw new G.ERR_INVALID_ARG_TYPE(e1, "number", t1);
                            }
                            function $(t1, e1, r) {
                                if (Math.floor(t1) !== t1) throw X(t1, r), new G.ERR_OUT_OF_RANGE(r || "offset", "an integer", t1);
                                if (e1 < 0) throw new G.ERR_BUFFER_OUT_OF_BOUNDS;
                                throw new G.ERR_OUT_OF_RANGE(r || "offset", ">= ".concat(r ? 1 : 0, " and <= ").concat(e1), t1);
                            }
                            Z("ERR_BUFFER_OUT_OF_BOUNDS", function(t1) {
                                return t1 ? "".concat(t1, " is outside of buffer bounds") : "Attempt to access memory outside buffer bounds";
                            }, RangeError), Z("ERR_INVALID_ARG_TYPE", function(t1, e1) {
                                return 'The "'.concat(t1, '" argument must be of type number. Received type ').concat(l(e1));
                            }, TypeError), Z("ERR_OUT_OF_RANGE", function(t1, e1, r) {
                                var n = 'The value of "'.concat(t1, '" is out of range.'), i = r;
                                return Number.isInteger(r) && Math.abs(r) > Math.pow(2, 32) ? i = W(String(r)) : "bigint" == typeof r && (i = String(r), (r > Math.pow(BigInt(2), BigInt(32)) || r < -Math.pow(BigInt(2), BigInt(32))) && (i = W(i)), i += "n"), n + " It must be ".concat(e1, ". Received ").concat(i);
                            }, RangeError);
                            var J = /[^+/0-9A-Za-z-_]/g;
                            function K(t1, e1) {
                                var r;
                                e1 = e1 || 1 / 0;
                                for(var n = t1.length, i = null, a = [], o = 0; o < n; ++o){
                                    if ((r = t1.charCodeAt(o)) > 55295 && r < 57344) {
                                        if (!i) {
                                            if (r > 56319) {
                                                (e1 -= 3) > -1 && a.push(239, 191, 189);
                                                continue;
                                            }
                                            if (o + 1 === n) {
                                                (e1 -= 3) > -1 && a.push(239, 191, 189);
                                                continue;
                                            }
                                            i = r;
                                            continue;
                                        }
                                        if (r < 56320) {
                                            (e1 -= 3) > -1 && a.push(239, 191, 189), i = r;
                                            continue;
                                        }
                                        r = 65536 + (i - 55296 << 10 | r - 56320);
                                    } else i && (e1 -= 3) > -1 && a.push(239, 191, 189);
                                    if (i = null, r < 128) {
                                        if ((e1 -= 1) < 0) break;
                                        a.push(r);
                                    } else if (r < 2048) {
                                        if ((e1 -= 2) < 0) break;
                                        a.push(r >> 6 | 192, 63 & r | 128);
                                    } else if (r < 65536) {
                                        if ((e1 -= 3) < 0) break;
                                        a.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
                                    } else {
                                        if (!(r < 1114112)) throw new Error("Invalid code point");
                                        if ((e1 -= 4) < 0) break;
                                        a.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
                                    }
                                }
                                return a;
                            }
                            function Q(t1) {
                                return c.toByteArray(function(t1) {
                                    if ((t1 = (t1 = t1.split("=")[0]).trim().replace(J, "")).length < 2) return "";
                                    for(; t1.length % 4 != 0;)t1 += "=";
                                    return t1;
                                }(t1));
                            }
                            function tt(t1, e1, r, n) {
                                var i;
                                for(i = 0; i < n && !(i + r >= e1.length || i >= t1.length); ++i)e1[i + r] = t1[i];
                                return i;
                            }
                            function et(t1, e1) {
                                return t1 instanceof e1 || null != t1 && null != t1.constructor && null != t1.constructor.name && t1.constructor.name === e1.name;
                            }
                            function rt(t1) {
                                return t1 != t1;
                            }
                            var nt = function() {
                                for(var t1 = "0123456789abcdef", e1 = new Array(256), r = 0; r < 16; ++r)for(var n = 16 * r, i = 0; i < 16; ++i)e1[n + i] = t1[r] + t1[i];
                                return e1;
                            }();
                            function it(t1) {
                                return "undefined" == typeof BigInt ? at : t1;
                            }
                            function at() {
                                throw new Error("BigInt not supported");
                            }
                        },
                        9216: function(t1) {
                            "use strict";
                            t1.exports = i, t1.exports.isMobile = i, t1.exports.default = i;
                            var e1 = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser.*mobile|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i, r = /CrOS/, n = /android|ipad|playbook|silk/i;
                            function i(t1) {
                                t1 || (t1 = {});
                                var i = t1.ua;
                                if (i || "undefined" == typeof navigator || (i = navigator.userAgent), i && i.headers && "string" == typeof i.headers["user-agent"] && (i = i.headers["user-agent"]), "string" != typeof i) return !1;
                                var a = e1.test(i) && !r.test(i) || !!t1.tablet && n.test(i);
                                return !a && t1.tablet && t1.featureDetect && navigator && navigator.maxTouchPoints > 1 && -1 !== i.indexOf("Macintosh") && -1 !== i.indexOf("Safari") && (a = !0), a;
                            }
                        },
                        6296: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1) {
                                var e1 = (t1 = t1 || {}).eye || [
                                    0,
                                    0,
                                    1
                                ], r = t1.center || [
                                    0,
                                    0,
                                    0
                                ], s = t1.up || [
                                    0,
                                    1,
                                    0
                                ], l = t1.distanceLimits || [
                                    0,
                                    1 / 0
                                ], c = t1.mode || "turntable", u = n(), h = i(), f = a();
                                return u.setDistanceLimits(l[0], l[1]), u.lookAt(0, e1, r, s), h.setDistanceLimits(l[0], l[1]), h.lookAt(0, e1, r, s), f.setDistanceLimits(l[0], l[1]), f.lookAt(0, e1, r, s), new o({
                                    turntable: u,
                                    orbit: h,
                                    matrix: f
                                }, c);
                            };
                            var n = r(7261), i = r(9977), a = r(4192);
                            function o(t1, e1) {
                                this._controllerNames = Object.keys(t1), this._controllerList = this._controllerNames.map(function(e1) {
                                    return t1[e1];
                                }), this._mode = e1, this._active = t1[e1], this._active || (this._mode = "turntable", this._active = t1.turntable), this.modes = this._controllerNames, this.computedMatrix = this._active.computedMatrix, this.computedEye = this._active.computedEye, this.computedUp = this._active.computedUp, this.computedCenter = this._active.computedCenter, this.computedRadius = this._active.computedRadius;
                            }
                            var s = o.prototype;
                            s.flush = function(t1) {
                                for(var e1 = this._controllerList, r = 0; r < e1.length; ++r)e1[r].flush(t1);
                            }, s.idle = function(t1) {
                                for(var e1 = this._controllerList, r = 0; r < e1.length; ++r)e1[r].idle(t1);
                            }, s.lookAt = function(t1, e1, r, n) {
                                for(var i = this._controllerList, a = 0; a < i.length; ++a)i[a].lookAt(t1, e1, r, n);
                            }, s.rotate = function(t1, e1, r, n) {
                                for(var i = this._controllerList, a = 0; a < i.length; ++a)i[a].rotate(t1, e1, r, n);
                            }, s.pan = function(t1, e1, r, n) {
                                for(var i = this._controllerList, a = 0; a < i.length; ++a)i[a].pan(t1, e1, r, n);
                            }, s.translate = function(t1, e1, r, n) {
                                for(var i = this._controllerList, a = 0; a < i.length; ++a)i[a].translate(t1, e1, r, n);
                            }, s.setMatrix = function(t1, e1) {
                                for(var r = this._controllerList, n = 0; n < r.length; ++n)r[n].setMatrix(t1, e1);
                            }, s.setDistanceLimits = function(t1, e1) {
                                for(var r = this._controllerList, n = 0; n < r.length; ++n)r[n].setDistanceLimits(t1, e1);
                            }, s.setDistance = function(t1, e1) {
                                for(var r = this._controllerList, n = 0; n < r.length; ++n)r[n].setDistance(t1, e1);
                            }, s.recalcMatrix = function(t1) {
                                this._active.recalcMatrix(t1);
                            }, s.getDistance = function(t1) {
                                return this._active.getDistance(t1);
                            }, s.getDistanceLimits = function(t1) {
                                return this._active.getDistanceLimits(t1);
                            }, s.lastT = function() {
                                return this._active.lastT();
                            }, s.setMode = function(t1) {
                                if (t1 !== this._mode) {
                                    var e1 = this._controllerNames.indexOf(t1);
                                    if (!(e1 < 0)) {
                                        var r = this._active, n = this._controllerList[e1], i = Math.max(r.lastT(), n.lastT());
                                        r.recalcMatrix(i), n.setMatrix(i, r.computedMatrix), this._active = n, this._mode = t1, this.computedMatrix = this._active.computedMatrix, this.computedEye = this._active.computedEye, this.computedUp = this._active.computedUp, this.computedCenter = this._active.computedCenter, this.computedRadius = this._active.computedRadius;
                                    }
                                }
                            }, s.getMode = function() {
                                return this._mode;
                            };
                        },
                        7169: function(t1, e1, r) {
                            "use strict";
                            var n = "undefined" == typeof WeakMap ? r(1538) : WeakMap, i = r(2762), a = r(8116), o = new n;
                            t1.exports = function(t1) {
                                var e1 = o.get(t1), r = e1 && (e1._triangleBuffer.handle || e1._triangleBuffer.buffer);
                                if (!r || !t1.isBuffer(r)) {
                                    var n = i(t1, new Float32Array([
                                        -1,
                                        -1,
                                        -1,
                                        4,
                                        4,
                                        -1
                                    ]));
                                    (e1 = a(t1, [
                                        {
                                            buffer: n,
                                            type: t1.FLOAT,
                                            size: 2
                                        }
                                    ]))._triangleBuffer = n, o.set(t1, e1);
                                }
                                e1.bind(), t1.drawArrays(t1.TRIANGLES, 0, 3), e1.unbind();
                            };
                        },
                        1085: function(t1, e1, r) {
                            var n = r(1371);
                            t1.exports = function(t1, e1, r) {
                                e1 = "number" == typeof e1 ? e1 : 1, r = r || ": ";
                                var i = t1.split(/\r?\n/), a = String(i.length + e1 - 1).length;
                                return i.map(function(t1, i) {
                                    var o = i + e1, s = String(o).length;
                                    return n(o, a - s) + r + t1;
                                }).join("\n");
                            };
                        },
                        3952: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1) {
                                var e1 = t1.length;
                                if (0 === e1) return [];
                                if (1 === e1) return [
                                    0
                                ];
                                for(var r = t1[0].length, n = [
                                    t1[0]
                                ], a = [
                                    0
                                ], o = 1; o < e1; ++o)if (n.push(t1[o]), i(n, r)) {
                                    if (a.push(o), a.length === r + 1) return a;
                                } else n.pop();
                                return a;
                            };
                            var n = r(3250);
                            function i(t1, e1) {
                                for(var r = new Array(e1 + 1), i = 0; i < t1.length; ++i)r[i] = t1[i];
                                for(i = 0; i <= t1.length; ++i){
                                    for(var a = t1.length; a <= e1; ++a){
                                        for(var o = new Array(e1), s = 0; s < e1; ++s)o[s] = Math.pow(a + 1 - i, s);
                                        r[a] = o;
                                    }
                                    if (n.apply(void 0, r)) return !0;
                                }
                                return !1;
                            }
                        },
                        5995: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1) {
                                return n(e1).filter(function(r) {
                                    for(var n = new Array(r.length), a = 0; a < r.length; ++a)n[a] = e1[r[a]];
                                    return i(n) * t1 < 1;
                                });
                            };
                            var n = r(7642), i = r(6037);
                        },
                        3502: function(t1, e1, r) {
                            t1.exports = function(t1, e1) {
                                return i(n(t1, e1));
                            };
                            var n = r(5995), i = r(9127);
                        },
                        6468: function(t1) {
                            t1.exports = function(t1) {
                                return atob(t1);
                            };
                        },
                        2642: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1) {
                                for(var r = e1.length, a = new Array(r + 1), o = 0; o < r; ++o){
                                    for(var s = new Array(r + 1), l = 0; l <= r; ++l)s[l] = t1[l][o];
                                    a[o] = s;
                                }
                                for(a[r] = new Array(r + 1), o = 0; o <= r; ++o)a[r][o] = 1;
                                var c = new Array(r + 1);
                                for(o = 0; o < r; ++o)c[o] = e1[o];
                                c[r] = 1;
                                var u = n(a, c), h = i(u[r + 1]);
                                0 === h && (h = 1);
                                var f = new Array(r + 1);
                                for(o = 0; o <= r; ++o)f[o] = i(u[o]) / h;
                                return f;
                            };
                            var n = r(727);
                            function i(t1) {
                                for(var e1 = 0, r = 0; r < t1.length; ++r)e1 += t1[r];
                                return e1;
                            }
                        },
                        7507: function(t1, e1) {
                            "use strict";
                            e1.byteLength = function(t1) {
                                var e1 = s(t1), r = e1[0], n = e1[1];
                                return 3 * (r + n) / 4 - n;
                            }, e1.toByteArray = function(t1) {
                                var e1, r, a = s(t1), o = a[0], l = a[1], c = new i(function(t1, e1, r) {
                                    return 3 * (e1 + r) / 4 - r;
                                }(0, o, l)), u = 0, h = l > 0 ? o - 4 : o;
                                for(r = 0; r < h; r += 4)e1 = n[t1.charCodeAt(r)] << 18 | n[t1.charCodeAt(r + 1)] << 12 | n[t1.charCodeAt(r + 2)] << 6 | n[t1.charCodeAt(r + 3)], c[u++] = e1 >> 16 & 255, c[u++] = e1 >> 8 & 255, c[u++] = 255 & e1;
                                return 2 === l && (e1 = n[t1.charCodeAt(r)] << 2 | n[t1.charCodeAt(r + 1)] >> 4, c[u++] = 255 & e1), 1 === l && (e1 = n[t1.charCodeAt(r)] << 10 | n[t1.charCodeAt(r + 1)] << 4 | n[t1.charCodeAt(r + 2)] >> 2, c[u++] = e1 >> 8 & 255, c[u++] = 255 & e1), c;
                            }, e1.fromByteArray = function(t1) {
                                for(var e1, n = t1.length, i = n % 3, a = [], o = 16383, s = 0, c = n - i; s < c; s += o)a.push(l(t1, s, s + o > c ? c : s + o));
                                return 1 === i ? (e1 = t1[n - 1], a.push(r[e1 >> 2] + r[e1 << 4 & 63] + "==")) : 2 === i && (e1 = (t1[n - 2] << 8) + t1[n - 1], a.push(r[e1 >> 10] + r[e1 >> 4 & 63] + r[e1 << 2 & 63] + "=")), a.join("");
                            };
                            for(var r = [], n = [], i = "undefined" != typeof Uint8Array ? Uint8Array : Array, a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", o = 0; o < 64; ++o)r[o] = a[o], n[a.charCodeAt(o)] = o;
                            function s(t1) {
                                var e1 = t1.length;
                                if (e1 % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
                                var r = t1.indexOf("=");
                                return -1 === r && (r = e1), [
                                    r,
                                    r === e1 ? 0 : 4 - r % 4
                                ];
                            }
                            function l(t1, e1, n) {
                                for(var i, a, o = [], s = e1; s < n; s += 3)i = (t1[s] << 16 & 16711680) + (t1[s + 1] << 8 & 65280) + (255 & t1[s + 2]), o.push(r[(a = i) >> 18 & 63] + r[a >> 12 & 63] + r[a >> 6 & 63] + r[63 & a]);
                                return o.join("");
                            }
                            n["-".charCodeAt(0)] = 62, n["_".charCodeAt(0)] = 63;
                        },
                        3865: function(t1, e1, r) {
                            "use strict";
                            var n = r(869);
                            t1.exports = function(t1, e1) {
                                return n(t1[0].mul(e1[1]).add(e1[0].mul(t1[1])), t1[1].mul(e1[1]));
                            };
                        },
                        1318: function(t1) {
                            "use strict";
                            t1.exports = function(t1, e1) {
                                return t1[0].mul(e1[1]).cmp(e1[0].mul(t1[1]));
                            };
                        },
                        8697: function(t1, e1, r) {
                            "use strict";
                            var n = r(869);
                            t1.exports = function(t1, e1) {
                                return n(t1[0].mul(e1[1]), t1[1].mul(e1[0]));
                            };
                        },
                        7842: function(t1, e1, r) {
                            "use strict";
                            var n = r(6330), i = r(1533), a = r(2651), o = r(4387), s = r(869), l = r(8697);
                            t1.exports = function t1(e1, r) {
                                if (n(e1)) return r ? l(e1, t1(r)) : [
                                    e1[0].clone(),
                                    e1[1].clone()
                                ];
                                var c, u, h = 0;
                                if (i(e1)) c = e1.clone();
                                else if ("string" == typeof e1) c = o(e1);
                                else {
                                    if (0 === e1) return [
                                        a(0),
                                        a(1)
                                    ];
                                    if (e1 === Math.floor(e1)) c = a(e1);
                                    else {
                                        for(; e1 !== Math.floor(e1);)e1 *= Math.pow(2, 256), h -= 256;
                                        c = a(e1);
                                    }
                                }
                                if (n(r)) c.mul(r[1]), u = r[0].clone();
                                else if (i(r)) u = r.clone();
                                else if ("string" == typeof r) u = o(r);
                                else if (r) {
                                    if (r === Math.floor(r)) u = a(r);
                                    else {
                                        for(; r !== Math.floor(r);)r *= Math.pow(2, 256), h += 256;
                                        u = a(r);
                                    }
                                } else u = a(1);
                                return h > 0 ? c = c.ushln(h) : h < 0 && (u = u.ushln(-h)), s(c, u);
                            };
                        },
                        6330: function(t1, e1, r) {
                            "use strict";
                            var n = r(1533);
                            t1.exports = function(t1) {
                                return Array.isArray(t1) && 2 === t1.length && n(t1[0]) && n(t1[1]);
                            };
                        },
                        5716: function(t1, e1, r) {
                            "use strict";
                            var n = r(6859);
                            t1.exports = function(t1) {
                                return t1.cmp(new n(0));
                            };
                        },
                        1369: function(t1, e1, r) {
                            "use strict";
                            var n = r(5716);
                            t1.exports = function(t1) {
                                var e1 = t1.length, r = t1.words, i = 0;
                                if (1 === e1) i = r[0];
                                else if (2 === e1) i = r[0] + 67108864 * r[1];
                                else for(var a = 0; a < e1; a++)i += r[a] * Math.pow(67108864, a);
                                return n(t1) * i;
                            };
                        },
                        4025: function(t1, e1, r) {
                            "use strict";
                            var n = r(2361), i = r(8828).countTrailingZeros;
                            t1.exports = function(t1) {
                                var e1 = i(n.lo(t1));
                                if (e1 < 32) return e1;
                                var r = i(n.hi(t1));
                                return r > 20 ? 52 : r + 32;
                            };
                        },
                        1533: function(t1, e1, r) {
                            "use strict";
                            r(6859), t1.exports = function(t1) {
                                return t1 && "object" == typeof t1 && Boolean(t1.words);
                            };
                        },
                        2651: function(t1, e1, r) {
                            "use strict";
                            var n = r(6859), i = r(2361);
                            t1.exports = function(t1) {
                                var e1 = i.exponent(t1);
                                return e1 < 52 ? new n(t1) : new n(t1 * Math.pow(2, 52 - e1)).ushln(e1 - 52);
                            };
                        },
                        869: function(t1, e1, r) {
                            "use strict";
                            var n = r(2651), i = r(5716);
                            t1.exports = function(t1, e1) {
                                var r = i(t1), a = i(e1);
                                if (0 === r) return [
                                    n(0),
                                    n(1)
                                ];
                                if (0 === a) return [
                                    n(0),
                                    n(0)
                                ];
                                a < 0 && (t1 = t1.neg(), e1 = e1.neg());
                                var o = t1.gcd(e1);
                                return o.cmpn(1) ? [
                                    t1.div(o),
                                    e1.div(o)
                                ] : [
                                    t1,
                                    e1
                                ];
                            };
                        },
                        4387: function(t1, e1, r) {
                            "use strict";
                            var n = r(6859);
                            t1.exports = function(t1) {
                                return new n(t1);
                            };
                        },
                        6504: function(t1, e1, r) {
                            "use strict";
                            var n = r(869);
                            t1.exports = function(t1, e1) {
                                return n(t1[0].mul(e1[0]), t1[1].mul(e1[1]));
                            };
                        },
                        7721: function(t1, e1, r) {
                            "use strict";
                            var n = r(5716);
                            t1.exports = function(t1) {
                                return n(t1[0]) * n(t1[1]);
                            };
                        },
                        5572: function(t1, e1, r) {
                            "use strict";
                            var n = r(869);
                            t1.exports = function(t1, e1) {
                                return n(t1[0].mul(e1[1]).sub(t1[1].mul(e1[0])), t1[1].mul(e1[1]));
                            };
                        },
                        946: function(t1, e1, r) {
                            "use strict";
                            var n = r(1369), i = r(4025);
                            t1.exports = function(t1) {
                                var e1 = t1[0], r = t1[1];
                                if (0 === e1.cmpn(0)) return 0;
                                var a = e1.abs().divmod(r.abs()), o = a.div, s = n(o), l = a.mod, c = e1.negative !== r.negative ? -1 : 1;
                                if (0 === l.cmpn(0)) return c * s;
                                if (s) {
                                    var u = i(s) + 4;
                                    return c * (s + (f = n(l.ushln(u).divRound(r))) * Math.pow(2, -u));
                                }
                                var h = r.bitLength() - l.bitLength() + 53, f = n(l.ushln(h).divRound(r));
                                return h < 1023 ? c * f * Math.pow(2, -h) : c * (f *= Math.pow(2, -1023)) * Math.pow(2, 1023 - h);
                            };
                        },
                        2478: function(t1) {
                            "use strict";
                            function e1(t1, e1, r, n, i) {
                                for(var a = i + 1; n <= i;){
                                    var o = n + i >>> 1, s = t1[o];
                                    (void 0 !== r ? r(s, e1) : s - e1) >= 0 ? (a = o, i = o - 1) : n = o + 1;
                                }
                                return a;
                            }
                            function r(t1, e1, r, n, i) {
                                for(var a = i + 1; n <= i;){
                                    var o = n + i >>> 1, s = t1[o];
                                    (void 0 !== r ? r(s, e1) : s - e1) > 0 ? (a = o, i = o - 1) : n = o + 1;
                                }
                                return a;
                            }
                            function n(t1, e1, r, n, i) {
                                for(var a = n - 1; n <= i;){
                                    var o = n + i >>> 1, s = t1[o];
                                    (void 0 !== r ? r(s, e1) : s - e1) < 0 ? (a = o, n = o + 1) : i = o - 1;
                                }
                                return a;
                            }
                            function i(t1, e1, r, n, i) {
                                for(var a = n - 1; n <= i;){
                                    var o = n + i >>> 1, s = t1[o];
                                    (void 0 !== r ? r(s, e1) : s - e1) <= 0 ? (a = o, n = o + 1) : i = o - 1;
                                }
                                return a;
                            }
                            function a(t1, e1, r, n, i) {
                                for(; n <= i;){
                                    var a = n + i >>> 1, o = t1[a], s = void 0 !== r ? r(o, e1) : o - e1;
                                    if (0 === s) return a;
                                    s <= 0 ? n = a + 1 : i = a - 1;
                                }
                                return -1;
                            }
                            function o(t1, e1, r, n, i, a) {
                                return "function" == typeof r ? a(t1, e1, r, void 0 === n ? 0 : 0 | n, void 0 === i ? t1.length - 1 : 0 | i) : a(t1, e1, void 0, void 0 === r ? 0 : 0 | r, void 0 === n ? t1.length - 1 : 0 | n);
                            }
                            t1.exports = {
                                ge: function(t1, r, n, i, a) {
                                    return o(t1, r, n, i, a, e1);
                                },
                                gt: function(t1, e1, n, i, a) {
                                    return o(t1, e1, n, i, a, r);
                                },
                                lt: function(t1, e1, r, i, a) {
                                    return o(t1, e1, r, i, a, n);
                                },
                                le: function(t1, e1, r, n, a) {
                                    return o(t1, e1, r, n, a, i);
                                },
                                eq: function(t1, e1, r, n, i) {
                                    return o(t1, e1, r, n, i, a);
                                }
                            };
                        },
                        8828: function(t1, e1) {
                            "use strict";
                            function r(t1) {
                                var e1 = 32;
                                return (t1 &= -t1) && e1--, 65535 & t1 && (e1 -= 16), 16711935 & t1 && (e1 -= 8), 252645135 & t1 && (e1 -= 4), 858993459 & t1 && (e1 -= 2), 1431655765 & t1 && (e1 -= 1), e1;
                            }
                            e1.INT_BITS = 32, e1.INT_MAX = 2147483647, e1.INT_MIN = -2147483648, e1.sign = function(t1) {
                                return (t1 > 0) - (t1 < 0);
                            }, e1.abs = function(t1) {
                                var e1 = t1 >> 31;
                                return (t1 ^ e1) - e1;
                            }, e1.min = function(t1, e1) {
                                return e1 ^ (t1 ^ e1) & -(t1 < e1);
                            }, e1.max = function(t1, e1) {
                                return t1 ^ (t1 ^ e1) & -(t1 < e1);
                            }, e1.isPow2 = function(t1) {
                                return !(t1 & t1 - 1 || !t1);
                            }, e1.log2 = function(t1) {
                                var e1, r;
                                return e1 = (t1 > 65535) << 4, e1 |= r = ((t1 >>>= e1) > 255) << 3, e1 |= r = ((t1 >>>= r) > 15) << 2, (e1 |= r = ((t1 >>>= r) > 3) << 1) | (t1 >>>= r) >> 1;
                            }, e1.log10 = function(t1) {
                                return t1 >= 1e9 ? 9 : t1 >= 1e8 ? 8 : t1 >= 1e7 ? 7 : t1 >= 1e6 ? 6 : t1 >= 1e5 ? 5 : t1 >= 1e4 ? 4 : t1 >= 1e3 ? 3 : t1 >= 100 ? 2 : t1 >= 10 ? 1 : 0;
                            }, e1.popCount = function(t1) {
                                return 16843009 * ((t1 = (858993459 & (t1 -= t1 >>> 1 & 1431655765)) + (t1 >>> 2 & 858993459)) + (t1 >>> 4) & 252645135) >>> 24;
                            }, e1.countTrailingZeros = r, e1.nextPow2 = function(t1) {
                                return t1 += 0 === t1, --t1, t1 |= t1 >>> 1, t1 |= t1 >>> 2, t1 |= t1 >>> 4, t1 |= t1 >>> 8, 1 + (t1 |= t1 >>> 16);
                            }, e1.prevPow2 = function(t1) {
                                return t1 |= t1 >>> 1, t1 |= t1 >>> 2, t1 |= t1 >>> 4, t1 |= t1 >>> 8, (t1 |= t1 >>> 16) - (t1 >>> 1);
                            }, e1.parity = function(t1) {
                                return t1 ^= t1 >>> 16, t1 ^= t1 >>> 8, t1 ^= t1 >>> 4, 27030 >>> (t1 &= 15) & 1;
                            };
                            var n = new Array(256);
                            !function(t1) {
                                for(var e1 = 0; e1 < 256; ++e1){
                                    var r = e1, n = e1, i = 7;
                                    for(r >>>= 1; r; r >>>= 1)n <<= 1, n |= 1 & r, --i;
                                    t1[e1] = n << i & 255;
                                }
                            }(n), e1.reverse = function(t1) {
                                return n[255 & t1] << 24 | n[t1 >>> 8 & 255] << 16 | n[t1 >>> 16 & 255] << 8 | n[t1 >>> 24 & 255];
                            }, e1.interleave2 = function(t1, e1) {
                                return (t1 = 1431655765 & ((t1 = 858993459 & ((t1 = 252645135 & ((t1 = 16711935 & ((t1 &= 65535) | t1 << 8)) | t1 << 4)) | t1 << 2)) | t1 << 1)) | (e1 = 1431655765 & ((e1 = 858993459 & ((e1 = 252645135 & ((e1 = 16711935 & ((e1 &= 65535) | e1 << 8)) | e1 << 4)) | e1 << 2)) | e1 << 1)) << 1;
                            }, e1.deinterleave2 = function(t1, e1) {
                                return (t1 = 65535 & ((t1 = 16711935 & ((t1 = 252645135 & ((t1 = 858993459 & ((t1 = t1 >>> e1 & 1431655765) | t1 >>> 1)) | t1 >>> 2)) | t1 >>> 4)) | t1 >>> 16)) << 16 >> 16;
                            }, e1.interleave3 = function(t1, e1, r) {
                                return t1 = 1227133513 & ((t1 = 3272356035 & ((t1 = 251719695 & ((t1 = 4278190335 & ((t1 &= 1023) | t1 << 16)) | t1 << 8)) | t1 << 4)) | t1 << 2), (t1 |= (e1 = 1227133513 & ((e1 = 3272356035 & ((e1 = 251719695 & ((e1 = 4278190335 & ((e1 &= 1023) | e1 << 16)) | e1 << 8)) | e1 << 4)) | e1 << 2)) << 1) | (r = 1227133513 & ((r = 3272356035 & ((r = 251719695 & ((r = 4278190335 & ((r &= 1023) | r << 16)) | r << 8)) | r << 4)) | r << 2)) << 2;
                            }, e1.deinterleave3 = function(t1, e1) {
                                return (t1 = 1023 & ((t1 = 4278190335 & ((t1 = 251719695 & ((t1 = 3272356035 & ((t1 = t1 >>> e1 & 1227133513) | t1 >>> 2)) | t1 >>> 4)) | t1 >>> 8)) | t1 >>> 16)) << 22 >> 22;
                            }, e1.nextCombination = function(t1) {
                                var e1 = t1 | t1 - 1;
                                return e1 + 1 | (~e1 & -~e1) - 1 >>> r(t1) + 1;
                            };
                        },
                        6859: function(t1, e1, r) {
                            !function(t1, e1) {
                                "use strict";
                                function n(t1, e1) {
                                    if (!t1) throw new Error(e1 || "Assertion failed");
                                }
                                function i(t1, e1) {
                                    t1.super_ = e1;
                                    var r = function() {};
                                    r.prototype = e1.prototype, t1.prototype = new r, t1.prototype.constructor = t1;
                                }
                                function a(t1, e1, r) {
                                    if (a.isBN(t1)) return t1;
                                    this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== t1 && ("le" !== e1 && "be" !== e1 || (r = e1, e1 = 10), this._init(t1 || 0, e1 || 10, r || "be"));
                                }
                                var o;
                                "object" == typeof t1 ? t1.exports = a : e1.BN = a, a.BN = a, a.wordSize = 26;
                                try {
                                    o = "undefined" != typeof window && void 0 !== window.Buffer ? window.Buffer : r(7790).Buffer;
                                } catch (t1) {}
                                function s(t1, e1) {
                                    var r = t1.charCodeAt(e1);
                                    return r >= 65 && r <= 70 ? r - 55 : r >= 97 && r <= 102 ? r - 87 : r - 48 & 15;
                                }
                                function l(t1, e1, r) {
                                    var n = s(t1, r);
                                    return r - 1 >= e1 && (n |= s(t1, r - 1) << 4), n;
                                }
                                function c(t1, e1, r, n) {
                                    for(var i = 0, a = Math.min(t1.length, r), o = e1; o < a; o++){
                                        var s = t1.charCodeAt(o) - 48;
                                        i *= n, i += s >= 49 ? s - 49 + 10 : s >= 17 ? s - 17 + 10 : s;
                                    }
                                    return i;
                                }
                                a.isBN = function(t1) {
                                    return t1 instanceof a || null !== t1 && "object" == typeof t1 && t1.constructor.wordSize === a.wordSize && Array.isArray(t1.words);
                                }, a.max = function(t1, e1) {
                                    return t1.cmp(e1) > 0 ? t1 : e1;
                                }, a.min = function(t1, e1) {
                                    return t1.cmp(e1) < 0 ? t1 : e1;
                                }, a.prototype._init = function(t1, e1, r) {
                                    if ("number" == typeof t1) return this._initNumber(t1, e1, r);
                                    if ("object" == typeof t1) return this._initArray(t1, e1, r);
                                    "hex" === e1 && (e1 = 16), n(e1 === (0 | e1) && e1 >= 2 && e1 <= 36);
                                    var i = 0;
                                    "-" === (t1 = t1.toString().replace(/\s+/g, ""))[0] && (i++, this.negative = 1), i < t1.length && (16 === e1 ? this._parseHex(t1, i, r) : (this._parseBase(t1, e1, i), "le" === r && this._initArray(this.toArray(), e1, r)));
                                }, a.prototype._initNumber = function(t1, e1, r) {
                                    t1 < 0 && (this.negative = 1, t1 = -t1), t1 < 67108864 ? (this.words = [
                                        67108863 & t1
                                    ], this.length = 1) : t1 < 4503599627370496 ? (this.words = [
                                        67108863 & t1,
                                        t1 / 67108864 & 67108863
                                    ], this.length = 2) : (n(t1 < 9007199254740992), this.words = [
                                        67108863 & t1,
                                        t1 / 67108864 & 67108863,
                                        1
                                    ], this.length = 3), "le" === r && this._initArray(this.toArray(), e1, r);
                                }, a.prototype._initArray = function(t1, e1, r) {
                                    if (n("number" == typeof t1.length), t1.length <= 0) return this.words = [
                                        0
                                    ], this.length = 1, this;
                                    this.length = Math.ceil(t1.length / 3), this.words = new Array(this.length);
                                    for(var i = 0; i < this.length; i++)this.words[i] = 0;
                                    var a, o, s = 0;
                                    if ("be" === r) for(i = t1.length - 1, a = 0; i >= 0; i -= 3)o = t1[i] | t1[i - 1] << 8 | t1[i - 2] << 16, this.words[a] |= o << s & 67108863, this.words[a + 1] = o >>> 26 - s & 67108863, (s += 24) >= 26 && (s -= 26, a++);
                                    else if ("le" === r) for(i = 0, a = 0; i < t1.length; i += 3)o = t1[i] | t1[i + 1] << 8 | t1[i + 2] << 16, this.words[a] |= o << s & 67108863, this.words[a + 1] = o >>> 26 - s & 67108863, (s += 24) >= 26 && (s -= 26, a++);
                                    return this.strip();
                                }, a.prototype._parseHex = function(t1, e1, r) {
                                    this.length = Math.ceil((t1.length - e1) / 6), this.words = new Array(this.length);
                                    for(var n = 0; n < this.length; n++)this.words[n] = 0;
                                    var i, a = 0, o = 0;
                                    if ("be" === r) for(n = t1.length - 1; n >= e1; n -= 2)i = l(t1, e1, n) << a, this.words[o] |= 67108863 & i, a >= 18 ? (a -= 18, o += 1, this.words[o] |= i >>> 26) : a += 8;
                                    else for(n = (t1.length - e1) % 2 == 0 ? e1 + 1 : e1; n < t1.length; n += 2)i = l(t1, e1, n) << a, this.words[o] |= 67108863 & i, a >= 18 ? (a -= 18, o += 1, this.words[o] |= i >>> 26) : a += 8;
                                    this.strip();
                                }, a.prototype._parseBase = function(t1, e1, r) {
                                    this.words = [
                                        0
                                    ], this.length = 1;
                                    for(var n = 0, i = 1; i <= 67108863; i *= e1)n++;
                                    n--, i = i / e1 | 0;
                                    for(var a = t1.length - r, o = a % n, s = Math.min(a, a - o) + r, l = 0, u = r; u < s; u += n)l = c(t1, u, u + n, e1), this.imuln(i), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
                                    if (0 !== o) {
                                        var h = 1;
                                        for(l = c(t1, u, t1.length, e1), u = 0; u < o; u++)h *= e1;
                                        this.imuln(h), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
                                    }
                                    this.strip();
                                }, a.prototype.copy = function(t1) {
                                    t1.words = new Array(this.length);
                                    for(var e1 = 0; e1 < this.length; e1++)t1.words[e1] = this.words[e1];
                                    t1.length = this.length, t1.negative = this.negative, t1.red = this.red;
                                }, a.prototype.clone = function() {
                                    var t1 = new a(null);
                                    return this.copy(t1), t1;
                                }, a.prototype._expand = function(t1) {
                                    for(; this.length < t1;)this.words[this.length++] = 0;
                                    return this;
                                }, a.prototype.strip = function() {
                                    for(; this.length > 1 && 0 === this.words[this.length - 1];)this.length--;
                                    return this._normSign();
                                }, a.prototype._normSign = function() {
                                    return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
                                }, a.prototype.inspect = function() {
                                    return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
                                };
                                var u = [
                                    "",
                                    "0",
                                    "00",
                                    "000",
                                    "0000",
                                    "00000",
                                    "000000",
                                    "0000000",
                                    "00000000",
                                    "000000000",
                                    "0000000000",
                                    "00000000000",
                                    "000000000000",
                                    "0000000000000",
                                    "00000000000000",
                                    "000000000000000",
                                    "0000000000000000",
                                    "00000000000000000",
                                    "000000000000000000",
                                    "0000000000000000000",
                                    "00000000000000000000",
                                    "000000000000000000000",
                                    "0000000000000000000000",
                                    "00000000000000000000000",
                                    "000000000000000000000000",
                                    "0000000000000000000000000"
                                ], h = [
                                    0,
                                    0,
                                    25,
                                    16,
                                    12,
                                    11,
                                    10,
                                    9,
                                    8,
                                    8,
                                    7,
                                    7,
                                    7,
                                    7,
                                    6,
                                    6,
                                    6,
                                    6,
                                    6,
                                    6,
                                    6,
                                    5,
                                    5,
                                    5,
                                    5,
                                    5,
                                    5,
                                    5,
                                    5,
                                    5,
                                    5,
                                    5,
                                    5,
                                    5,
                                    5,
                                    5,
                                    5
                                ], f = [
                                    0,
                                    0,
                                    33554432,
                                    43046721,
                                    16777216,
                                    48828125,
                                    60466176,
                                    40353607,
                                    16777216,
                                    43046721,
                                    1e7,
                                    19487171,
                                    35831808,
                                    62748517,
                                    7529536,
                                    11390625,
                                    16777216,
                                    24137569,
                                    34012224,
                                    47045881,
                                    64e6,
                                    4084101,
                                    5153632,
                                    6436343,
                                    7962624,
                                    9765625,
                                    11881376,
                                    14348907,
                                    17210368,
                                    20511149,
                                    243e5,
                                    28629151,
                                    33554432,
                                    39135393,
                                    45435424,
                                    52521875,
                                    60466176
                                ];
                                function p(t1, e1, r) {
                                    r.negative = e1.negative ^ t1.negative;
                                    var n = t1.length + e1.length | 0;
                                    r.length = n, n = n - 1 | 0;
                                    var i = 0 | t1.words[0], a = 0 | e1.words[0], o = i * a, s = 67108863 & o, l = o / 67108864 | 0;
                                    r.words[0] = s;
                                    for(var c = 1; c < n; c++){
                                        for(var u = l >>> 26, h = 67108863 & l, f = Math.min(c, e1.length - 1), p = Math.max(0, c - t1.length + 1); p <= f; p++){
                                            var d = c - p | 0;
                                            u += (o = (i = 0 | t1.words[d]) * (a = 0 | e1.words[p]) + h) / 67108864 | 0, h = 67108863 & o;
                                        }
                                        r.words[c] = 0 | h, l = 0 | u;
                                    }
                                    return 0 !== l ? r.words[c] = 0 | l : r.length--, r.strip();
                                }
                                a.prototype.toString = function(t1, e1) {
                                    var r;
                                    if (e1 = 0 | e1 || 1, 16 === (t1 = t1 || 10) || "hex" === t1) {
                                        r = "";
                                        for(var i = 0, a = 0, o = 0; o < this.length; o++){
                                            var s = this.words[o], l = (16777215 & (s << i | a)).toString(16);
                                            r = 0 != (a = s >>> 24 - i & 16777215) || o !== this.length - 1 ? u[6 - l.length] + l + r : l + r, (i += 2) >= 26 && (i -= 26, o--);
                                        }
                                        for(0 !== a && (r = a.toString(16) + r); r.length % e1 != 0;)r = "0" + r;
                                        return 0 !== this.negative && (r = "-" + r), r;
                                    }
                                    if (t1 === (0 | t1) && t1 >= 2 && t1 <= 36) {
                                        var c = h[t1], p = f[t1];
                                        r = "";
                                        var d = this.clone();
                                        for(d.negative = 0; !d.isZero();){
                                            var m = d.modn(p).toString(t1);
                                            r = (d = d.idivn(p)).isZero() ? m + r : u[c - m.length] + m + r;
                                        }
                                        for(this.isZero() && (r = "0" + r); r.length % e1 != 0;)r = "0" + r;
                                        return 0 !== this.negative && (r = "-" + r), r;
                                    }
                                    n(!1, "Base should be between 2 and 36");
                                }, a.prototype.toNumber = function() {
                                    var t1 = this.words[0];
                                    return 2 === this.length ? t1 += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? t1 += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -t1 : t1;
                                }, a.prototype.toJSON = function() {
                                    return this.toString(16);
                                }, a.prototype.toBuffer = function(t1, e1) {
                                    return n(void 0 !== o), this.toArrayLike(o, t1, e1);
                                }, a.prototype.toArray = function(t1, e1) {
                                    return this.toArrayLike(Array, t1, e1);
                                }, a.prototype.toArrayLike = function(t1, e1, r) {
                                    var i = this.byteLength(), a = r || Math.max(1, i);
                                    n(i <= a, "byte array longer than desired length"), n(a > 0, "Requested array length <= 0"), this.strip();
                                    var o, s, l = "le" === e1, c = new t1(a), u = this.clone();
                                    if (l) {
                                        for(s = 0; !u.isZero(); s++)o = u.andln(255), u.iushrn(8), c[s] = o;
                                        for(; s < a; s++)c[s] = 0;
                                    } else {
                                        for(s = 0; s < a - i; s++)c[s] = 0;
                                        for(s = 0; !u.isZero(); s++)o = u.andln(255), u.iushrn(8), c[a - s - 1] = o;
                                    }
                                    return c;
                                }, Math.clz32 ? a.prototype._countBits = function(t1) {
                                    return 32 - Math.clz32(t1);
                                } : a.prototype._countBits = function(t1) {
                                    var e1 = t1, r = 0;
                                    return e1 >= 4096 && (r += 13, e1 >>>= 13), e1 >= 64 && (r += 7, e1 >>>= 7), e1 >= 8 && (r += 4, e1 >>>= 4), e1 >= 2 && (r += 2, e1 >>>= 2), r + e1;
                                }, a.prototype._zeroBits = function(t1) {
                                    if (0 === t1) return 26;
                                    var e1 = t1, r = 0;
                                    return 0 == (8191 & e1) && (r += 13, e1 >>>= 13), 0 == (127 & e1) && (r += 7, e1 >>>= 7), 0 == (15 & e1) && (r += 4, e1 >>>= 4), 0 == (3 & e1) && (r += 2, e1 >>>= 2), 0 == (1 & e1) && r++, r;
                                }, a.prototype.bitLength = function() {
                                    var t1 = this.words[this.length - 1], e1 = this._countBits(t1);
                                    return 26 * (this.length - 1) + e1;
                                }, a.prototype.zeroBits = function() {
                                    if (this.isZero()) return 0;
                                    for(var t1 = 0, e1 = 0; e1 < this.length; e1++){
                                        var r = this._zeroBits(this.words[e1]);
                                        if (t1 += r, 26 !== r) break;
                                    }
                                    return t1;
                                }, a.prototype.byteLength = function() {
                                    return Math.ceil(this.bitLength() / 8);
                                }, a.prototype.toTwos = function(t1) {
                                    return 0 !== this.negative ? this.abs().inotn(t1).iaddn(1) : this.clone();
                                }, a.prototype.fromTwos = function(t1) {
                                    return this.testn(t1 - 1) ? this.notn(t1).iaddn(1).ineg() : this.clone();
                                }, a.prototype.isNeg = function() {
                                    return 0 !== this.negative;
                                }, a.prototype.neg = function() {
                                    return this.clone().ineg();
                                }, a.prototype.ineg = function() {
                                    return this.isZero() || (this.negative ^= 1), this;
                                }, a.prototype.iuor = function(t1) {
                                    for(; this.length < t1.length;)this.words[this.length++] = 0;
                                    for(var e1 = 0; e1 < t1.length; e1++)this.words[e1] = this.words[e1] | t1.words[e1];
                                    return this.strip();
                                }, a.prototype.ior = function(t1) {
                                    return n(0 == (this.negative | t1.negative)), this.iuor(t1);
                                }, a.prototype.or = function(t1) {
                                    return this.length > t1.length ? this.clone().ior(t1) : t1.clone().ior(this);
                                }, a.prototype.uor = function(t1) {
                                    return this.length > t1.length ? this.clone().iuor(t1) : t1.clone().iuor(this);
                                }, a.prototype.iuand = function(t1) {
                                    var e1;
                                    e1 = this.length > t1.length ? t1 : this;
                                    for(var r = 0; r < e1.length; r++)this.words[r] = this.words[r] & t1.words[r];
                                    return this.length = e1.length, this.strip();
                                }, a.prototype.iand = function(t1) {
                                    return n(0 == (this.negative | t1.negative)), this.iuand(t1);
                                }, a.prototype.and = function(t1) {
                                    return this.length > t1.length ? this.clone().iand(t1) : t1.clone().iand(this);
                                }, a.prototype.uand = function(t1) {
                                    return this.length > t1.length ? this.clone().iuand(t1) : t1.clone().iuand(this);
                                }, a.prototype.iuxor = function(t1) {
                                    var e1, r;
                                    this.length > t1.length ? (e1 = this, r = t1) : (e1 = t1, r = this);
                                    for(var n = 0; n < r.length; n++)this.words[n] = e1.words[n] ^ r.words[n];
                                    if (this !== e1) for(; n < e1.length; n++)this.words[n] = e1.words[n];
                                    return this.length = e1.length, this.strip();
                                }, a.prototype.ixor = function(t1) {
                                    return n(0 == (this.negative | t1.negative)), this.iuxor(t1);
                                }, a.prototype.xor = function(t1) {
                                    return this.length > t1.length ? this.clone().ixor(t1) : t1.clone().ixor(this);
                                }, a.prototype.uxor = function(t1) {
                                    return this.length > t1.length ? this.clone().iuxor(t1) : t1.clone().iuxor(this);
                                }, a.prototype.inotn = function(t1) {
                                    n("number" == typeof t1 && t1 >= 0);
                                    var e1 = 0 | Math.ceil(t1 / 26), r = t1 % 26;
                                    this._expand(e1), r > 0 && e1--;
                                    for(var i = 0; i < e1; i++)this.words[i] = 67108863 & ~this.words[i];
                                    return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this.strip();
                                }, a.prototype.notn = function(t1) {
                                    return this.clone().inotn(t1);
                                }, a.prototype.setn = function(t1, e1) {
                                    n("number" == typeof t1 && t1 >= 0);
                                    var r = t1 / 26 | 0, i = t1 % 26;
                                    return this._expand(r + 1), this.words[r] = e1 ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this.strip();
                                }, a.prototype.iadd = function(t1) {
                                    var e1, r, n;
                                    if (0 !== this.negative && 0 === t1.negative) return this.negative = 0, e1 = this.isub(t1), this.negative ^= 1, this._normSign();
                                    if (0 === this.negative && 0 !== t1.negative) return t1.negative = 0, e1 = this.isub(t1), t1.negative = 1, e1._normSign();
                                    this.length > t1.length ? (r = this, n = t1) : (r = t1, n = this);
                                    for(var i = 0, a = 0; a < n.length; a++)e1 = (0 | r.words[a]) + (0 | n.words[a]) + i, this.words[a] = 67108863 & e1, i = e1 >>> 26;
                                    for(; 0 !== i && a < r.length; a++)e1 = (0 | r.words[a]) + i, this.words[a] = 67108863 & e1, i = e1 >>> 26;
                                    if (this.length = r.length, 0 !== i) this.words[this.length] = i, this.length++;
                                    else if (r !== this) for(; a < r.length; a++)this.words[a] = r.words[a];
                                    return this;
                                }, a.prototype.add = function(t1) {
                                    var e1;
                                    return 0 !== t1.negative && 0 === this.negative ? (t1.negative = 0, e1 = this.sub(t1), t1.negative ^= 1, e1) : 0 === t1.negative && 0 !== this.negative ? (this.negative = 0, e1 = t1.sub(this), this.negative = 1, e1) : this.length > t1.length ? this.clone().iadd(t1) : t1.clone().iadd(this);
                                }, a.prototype.isub = function(t1) {
                                    if (0 !== t1.negative) {
                                        t1.negative = 0;
                                        var e1 = this.iadd(t1);
                                        return t1.negative = 1, e1._normSign();
                                    }
                                    if (0 !== this.negative) return this.negative = 0, this.iadd(t1), this.negative = 1, this._normSign();
                                    var r, n, i = this.cmp(t1);
                                    if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
                                    i > 0 ? (r = this, n = t1) : (r = t1, n = this);
                                    for(var a = 0, o = 0; o < n.length; o++)a = (e1 = (0 | r.words[o]) - (0 | n.words[o]) + a) >> 26, this.words[o] = 67108863 & e1;
                                    for(; 0 !== a && o < r.length; o++)a = (e1 = (0 | r.words[o]) + a) >> 26, this.words[o] = 67108863 & e1;
                                    if (0 === a && o < r.length && r !== this) for(; o < r.length; o++)this.words[o] = r.words[o];
                                    return this.length = Math.max(this.length, o), r !== this && (this.negative = 1), this.strip();
                                }, a.prototype.sub = function(t1) {
                                    return this.clone().isub(t1);
                                };
                                var d = function(t1, e1, r) {
                                    var n, i, a, o = t1.words, s = e1.words, l = r.words, c = 0, u = 0 | o[0], h = 8191 & u, f = u >>> 13, p = 0 | o[1], d = 8191 & p, m = p >>> 13, g = 0 | o[2], y = 8191 & g, v = g >>> 13, x = 0 | o[3], _ = 8191 & x, b = x >>> 13, w = 0 | o[4], T = 8191 & w, k = w >>> 13, A = 0 | o[5], M = 8191 & A, S = A >>> 13, E = 0 | o[6], C = 8191 & E, L = E >>> 13, I = 0 | o[7], P = 8191 & I, z = I >>> 13, O = 0 | o[8], D = 8191 & O, R = O >>> 13, F = 0 | o[9], B = 8191 & F, N = F >>> 13, j = 0 | s[0], U = 8191 & j, V = j >>> 13, q = 0 | s[1], H = 8191 & q, G = q >>> 13, Z = 0 | s[2], W = 8191 & Z, Y = Z >>> 13, X = 0 | s[3], $ = 8191 & X, J = X >>> 13, K = 0 | s[4], Q = 8191 & K, tt = K >>> 13, et = 0 | s[5], rt = 8191 & et, nt = et >>> 13, it = 0 | s[6], at = 8191 & it, ot = it >>> 13, st = 0 | s[7], lt = 8191 & st, ct = st >>> 13, ut = 0 | s[8], ht = 8191 & ut, ft = ut >>> 13, pt = 0 | s[9], dt = 8191 & pt, mt = pt >>> 13;
                                    r.negative = t1.negative ^ e1.negative, r.length = 19;
                                    var gt = (c + (n = Math.imul(h, U)) | 0) + ((8191 & (i = (i = Math.imul(h, V)) + Math.imul(f, U) | 0)) << 13) | 0;
                                    c = ((a = Math.imul(f, V)) + (i >>> 13) | 0) + (gt >>> 26) | 0, gt &= 67108863, n = Math.imul(d, U), i = (i = Math.imul(d, V)) + Math.imul(m, U) | 0, a = Math.imul(m, V);
                                    var yt = (c + (n = n + Math.imul(h, H) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, G) | 0) + Math.imul(f, H) | 0)) << 13) | 0;
                                    c = ((a = a + Math.imul(f, G) | 0) + (i >>> 13) | 0) + (yt >>> 26) | 0, yt &= 67108863, n = Math.imul(y, U), i = (i = Math.imul(y, V)) + Math.imul(v, U) | 0, a = Math.imul(v, V), n = n + Math.imul(d, H) | 0, i = (i = i + Math.imul(d, G) | 0) + Math.imul(m, H) | 0, a = a + Math.imul(m, G) | 0;
                                    var vt = (c + (n = n + Math.imul(h, W) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, Y) | 0) + Math.imul(f, W) | 0)) << 13) | 0;
                                    c = ((a = a + Math.imul(f, Y) | 0) + (i >>> 13) | 0) + (vt >>> 26) | 0, vt &= 67108863, n = Math.imul(_, U), i = (i = Math.imul(_, V)) + Math.imul(b, U) | 0, a = Math.imul(b, V), n = n + Math.imul(y, H) | 0, i = (i = i + Math.imul(y, G) | 0) + Math.imul(v, H) | 0, a = a + Math.imul(v, G) | 0, n = n + Math.imul(d, W) | 0, i = (i = i + Math.imul(d, Y) | 0) + Math.imul(m, W) | 0, a = a + Math.imul(m, Y) | 0;
                                    var xt = (c + (n = n + Math.imul(h, $) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, J) | 0) + Math.imul(f, $) | 0)) << 13) | 0;
                                    c = ((a = a + Math.imul(f, J) | 0) + (i >>> 13) | 0) + (xt >>> 26) | 0, xt &= 67108863, n = Math.imul(T, U), i = (i = Math.imul(T, V)) + Math.imul(k, U) | 0, a = Math.imul(k, V), n = n + Math.imul(_, H) | 0, i = (i = i + Math.imul(_, G) | 0) + Math.imul(b, H) | 0, a = a + Math.imul(b, G) | 0, n = n + Math.imul(y, W) | 0, i = (i = i + Math.imul(y, Y) | 0) + Math.imul(v, W) | 0, a = a + Math.imul(v, Y) | 0, n = n + Math.imul(d, $) | 0, i = (i = i + Math.imul(d, J) | 0) + Math.imul(m, $) | 0, a = a + Math.imul(m, J) | 0;
                                    var _t = (c + (n = n + Math.imul(h, Q) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, tt) | 0) + Math.imul(f, Q) | 0)) << 13) | 0;
                                    c = ((a = a + Math.imul(f, tt) | 0) + (i >>> 13) | 0) + (_t >>> 26) | 0, _t &= 67108863, n = Math.imul(M, U), i = (i = Math.imul(M, V)) + Math.imul(S, U) | 0, a = Math.imul(S, V), n = n + Math.imul(T, H) | 0, i = (i = i + Math.imul(T, G) | 0) + Math.imul(k, H) | 0, a = a + Math.imul(k, G) | 0, n = n + Math.imul(_, W) | 0, i = (i = i + Math.imul(_, Y) | 0) + Math.imul(b, W) | 0, a = a + Math.imul(b, Y) | 0, n = n + Math.imul(y, $) | 0, i = (i = i + Math.imul(y, J) | 0) + Math.imul(v, $) | 0, a = a + Math.imul(v, J) | 0, n = n + Math.imul(d, Q) | 0, i = (i = i + Math.imul(d, tt) | 0) + Math.imul(m, Q) | 0, a = a + Math.imul(m, tt) | 0;
                                    var bt = (c + (n = n + Math.imul(h, rt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, nt) | 0) + Math.imul(f, rt) | 0)) << 13) | 0;
                                    c = ((a = a + Math.imul(f, nt) | 0) + (i >>> 13) | 0) + (bt >>> 26) | 0, bt &= 67108863, n = Math.imul(C, U), i = (i = Math.imul(C, V)) + Math.imul(L, U) | 0, a = Math.imul(L, V), n = n + Math.imul(M, H) | 0, i = (i = i + Math.imul(M, G) | 0) + Math.imul(S, H) | 0, a = a + Math.imul(S, G) | 0, n = n + Math.imul(T, W) | 0, i = (i = i + Math.imul(T, Y) | 0) + Math.imul(k, W) | 0, a = a + Math.imul(k, Y) | 0, n = n + Math.imul(_, $) | 0, i = (i = i + Math.imul(_, J) | 0) + Math.imul(b, $) | 0, a = a + Math.imul(b, J) | 0, n = n + Math.imul(y, Q) | 0, i = (i = i + Math.imul(y, tt) | 0) + Math.imul(v, Q) | 0, a = a + Math.imul(v, tt) | 0, n = n + Math.imul(d, rt) | 0, i = (i = i + Math.imul(d, nt) | 0) + Math.imul(m, rt) | 0, a = a + Math.imul(m, nt) | 0;
                                    var wt = (c + (n = n + Math.imul(h, at) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ot) | 0) + Math.imul(f, at) | 0)) << 13) | 0;
                                    c = ((a = a + Math.imul(f, ot) | 0) + (i >>> 13) | 0) + (wt >>> 26) | 0, wt &= 67108863, n = Math.imul(P, U), i = (i = Math.imul(P, V)) + Math.imul(z, U) | 0, a = Math.imul(z, V), n = n + Math.imul(C, H) | 0, i = (i = i + Math.imul(C, G) | 0) + Math.imul(L, H) | 0, a = a + Math.imul(L, G) | 0, n = n + Math.imul(M, W) | 0, i = (i = i + Math.imul(M, Y) | 0) + Math.imul(S, W) | 0, a = a + Math.imul(S, Y) | 0, n = n + Math.imul(T, $) | 0, i = (i = i + Math.imul(T, J) | 0) + Math.imul(k, $) | 0, a = a + Math.imul(k, J) | 0, n = n + Math.imul(_, Q) | 0, i = (i = i + Math.imul(_, tt) | 0) + Math.imul(b, Q) | 0, a = a + Math.imul(b, tt) | 0, n = n + Math.imul(y, rt) | 0, i = (i = i + Math.imul(y, nt) | 0) + Math.imul(v, rt) | 0, a = a + Math.imul(v, nt) | 0, n = n + Math.imul(d, at) | 0, i = (i = i + Math.imul(d, ot) | 0) + Math.imul(m, at) | 0, a = a + Math.imul(m, ot) | 0;
                                    var Tt = (c + (n = n + Math.imul(h, lt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ct) | 0) + Math.imul(f, lt) | 0)) << 13) | 0;
                                    c = ((a = a + Math.imul(f, ct) | 0) + (i >>> 13) | 0) + (Tt >>> 26) | 0, Tt &= 67108863, n = Math.imul(D, U), i = (i = Math.imul(D, V)) + Math.imul(R, U) | 0, a = Math.imul(R, V), n = n + Math.imul(P, H) | 0, i = (i = i + Math.imul(P, G) | 0) + Math.imul(z, H) | 0, a = a + Math.imul(z, G) | 0, n = n + Math.imul(C, W) | 0, i = (i = i + Math.imul(C, Y) | 0) + Math.imul(L, W) | 0, a = a + Math.imul(L, Y) | 0, n = n + Math.imul(M, $) | 0, i = (i = i + Math.imul(M, J) | 0) + Math.imul(S, $) | 0, a = a + Math.imul(S, J) | 0, n = n + Math.imul(T, Q) | 0, i = (i = i + Math.imul(T, tt) | 0) + Math.imul(k, Q) | 0, a = a + Math.imul(k, tt) | 0, n = n + Math.imul(_, rt) | 0, i = (i = i + Math.imul(_, nt) | 0) + Math.imul(b, rt) | 0, a = a + Math.imul(b, nt) | 0, n = n + Math.imul(y, at) | 0, i = (i = i + Math.imul(y, ot) | 0) + Math.imul(v, at) | 0, a = a + Math.imul(v, ot) | 0, n = n + Math.imul(d, lt) | 0, i = (i = i + Math.imul(d, ct) | 0) + Math.imul(m, lt) | 0, a = a + Math.imul(m, ct) | 0;
                                    var kt = (c + (n = n + Math.imul(h, ht) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ft) | 0) + Math.imul(f, ht) | 0)) << 13) | 0;
                                    c = ((a = a + Math.imul(f, ft) | 0) + (i >>> 13) | 0) + (kt >>> 26) | 0, kt &= 67108863, n = Math.imul(B, U), i = (i = Math.imul(B, V)) + Math.imul(N, U) | 0, a = Math.imul(N, V), n = n + Math.imul(D, H) | 0, i = (i = i + Math.imul(D, G) | 0) + Math.imul(R, H) | 0, a = a + Math.imul(R, G) | 0, n = n + Math.imul(P, W) | 0, i = (i = i + Math.imul(P, Y) | 0) + Math.imul(z, W) | 0, a = a + Math.imul(z, Y) | 0, n = n + Math.imul(C, $) | 0, i = (i = i + Math.imul(C, J) | 0) + Math.imul(L, $) | 0, a = a + Math.imul(L, J) | 0, n = n + Math.imul(M, Q) | 0, i = (i = i + Math.imul(M, tt) | 0) + Math.imul(S, Q) | 0, a = a + Math.imul(S, tt) | 0, n = n + Math.imul(T, rt) | 0, i = (i = i + Math.imul(T, nt) | 0) + Math.imul(k, rt) | 0, a = a + Math.imul(k, nt) | 0, n = n + Math.imul(_, at) | 0, i = (i = i + Math.imul(_, ot) | 0) + Math.imul(b, at) | 0, a = a + Math.imul(b, ot) | 0, n = n + Math.imul(y, lt) | 0, i = (i = i + Math.imul(y, ct) | 0) + Math.imul(v, lt) | 0, a = a + Math.imul(v, ct) | 0, n = n + Math.imul(d, ht) | 0, i = (i = i + Math.imul(d, ft) | 0) + Math.imul(m, ht) | 0, a = a + Math.imul(m, ft) | 0;
                                    var At = (c + (n = n + Math.imul(h, dt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, mt) | 0) + Math.imul(f, dt) | 0)) << 13) | 0;
                                    c = ((a = a + Math.imul(f, mt) | 0) + (i >>> 13) | 0) + (At >>> 26) | 0, At &= 67108863, n = Math.imul(B, H), i = (i = Math.imul(B, G)) + Math.imul(N, H) | 0, a = Math.imul(N, G), n = n + Math.imul(D, W) | 0, i = (i = i + Math.imul(D, Y) | 0) + Math.imul(R, W) | 0, a = a + Math.imul(R, Y) | 0, n = n + Math.imul(P, $) | 0, i = (i = i + Math.imul(P, J) | 0) + Math.imul(z, $) | 0, a = a + Math.imul(z, J) | 0, n = n + Math.imul(C, Q) | 0, i = (i = i + Math.imul(C, tt) | 0) + Math.imul(L, Q) | 0, a = a + Math.imul(L, tt) | 0, n = n + Math.imul(M, rt) | 0, i = (i = i + Math.imul(M, nt) | 0) + Math.imul(S, rt) | 0, a = a + Math.imul(S, nt) | 0, n = n + Math.imul(T, at) | 0, i = (i = i + Math.imul(T, ot) | 0) + Math.imul(k, at) | 0, a = a + Math.imul(k, ot) | 0, n = n + Math.imul(_, lt) | 0, i = (i = i + Math.imul(_, ct) | 0) + Math.imul(b, lt) | 0, a = a + Math.imul(b, ct) | 0, n = n + Math.imul(y, ht) | 0, i = (i = i + Math.imul(y, ft) | 0) + Math.imul(v, ht) | 0, a = a + Math.imul(v, ft) | 0;
                                    var Mt = (c + (n = n + Math.imul(d, dt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, mt) | 0) + Math.imul(m, dt) | 0)) << 13) | 0;
                                    c = ((a = a + Math.imul(m, mt) | 0) + (i >>> 13) | 0) + (Mt >>> 26) | 0, Mt &= 67108863, n = Math.imul(B, W), i = (i = Math.imul(B, Y)) + Math.imul(N, W) | 0, a = Math.imul(N, Y), n = n + Math.imul(D, $) | 0, i = (i = i + Math.imul(D, J) | 0) + Math.imul(R, $) | 0, a = a + Math.imul(R, J) | 0, n = n + Math.imul(P, Q) | 0, i = (i = i + Math.imul(P, tt) | 0) + Math.imul(z, Q) | 0, a = a + Math.imul(z, tt) | 0, n = n + Math.imul(C, rt) | 0, i = (i = i + Math.imul(C, nt) | 0) + Math.imul(L, rt) | 0, a = a + Math.imul(L, nt) | 0, n = n + Math.imul(M, at) | 0, i = (i = i + Math.imul(M, ot) | 0) + Math.imul(S, at) | 0, a = a + Math.imul(S, ot) | 0, n = n + Math.imul(T, lt) | 0, i = (i = i + Math.imul(T, ct) | 0) + Math.imul(k, lt) | 0, a = a + Math.imul(k, ct) | 0, n = n + Math.imul(_, ht) | 0, i = (i = i + Math.imul(_, ft) | 0) + Math.imul(b, ht) | 0, a = a + Math.imul(b, ft) | 0;
                                    var St = (c + (n = n + Math.imul(y, dt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(y, mt) | 0) + Math.imul(v, dt) | 0)) << 13) | 0;
                                    c = ((a = a + Math.imul(v, mt) | 0) + (i >>> 13) | 0) + (St >>> 26) | 0, St &= 67108863, n = Math.imul(B, $), i = (i = Math.imul(B, J)) + Math.imul(N, $) | 0, a = Math.imul(N, J), n = n + Math.imul(D, Q) | 0, i = (i = i + Math.imul(D, tt) | 0) + Math.imul(R, Q) | 0, a = a + Math.imul(R, tt) | 0, n = n + Math.imul(P, rt) | 0, i = (i = i + Math.imul(P, nt) | 0) + Math.imul(z, rt) | 0, a = a + Math.imul(z, nt) | 0, n = n + Math.imul(C, at) | 0, i = (i = i + Math.imul(C, ot) | 0) + Math.imul(L, at) | 0, a = a + Math.imul(L, ot) | 0, n = n + Math.imul(M, lt) | 0, i = (i = i + Math.imul(M, ct) | 0) + Math.imul(S, lt) | 0, a = a + Math.imul(S, ct) | 0, n = n + Math.imul(T, ht) | 0, i = (i = i + Math.imul(T, ft) | 0) + Math.imul(k, ht) | 0, a = a + Math.imul(k, ft) | 0;
                                    var Et = (c + (n = n + Math.imul(_, dt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(_, mt) | 0) + Math.imul(b, dt) | 0)) << 13) | 0;
                                    c = ((a = a + Math.imul(b, mt) | 0) + (i >>> 13) | 0) + (Et >>> 26) | 0, Et &= 67108863, n = Math.imul(B, Q), i = (i = Math.imul(B, tt)) + Math.imul(N, Q) | 0, a = Math.imul(N, tt), n = n + Math.imul(D, rt) | 0, i = (i = i + Math.imul(D, nt) | 0) + Math.imul(R, rt) | 0, a = a + Math.imul(R, nt) | 0, n = n + Math.imul(P, at) | 0, i = (i = i + Math.imul(P, ot) | 0) + Math.imul(z, at) | 0, a = a + Math.imul(z, ot) | 0, n = n + Math.imul(C, lt) | 0, i = (i = i + Math.imul(C, ct) | 0) + Math.imul(L, lt) | 0, a = a + Math.imul(L, ct) | 0, n = n + Math.imul(M, ht) | 0, i = (i = i + Math.imul(M, ft) | 0) + Math.imul(S, ht) | 0, a = a + Math.imul(S, ft) | 0;
                                    var Ct = (c + (n = n + Math.imul(T, dt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(T, mt) | 0) + Math.imul(k, dt) | 0)) << 13) | 0;
                                    c = ((a = a + Math.imul(k, mt) | 0) + (i >>> 13) | 0) + (Ct >>> 26) | 0, Ct &= 67108863, n = Math.imul(B, rt), i = (i = Math.imul(B, nt)) + Math.imul(N, rt) | 0, a = Math.imul(N, nt), n = n + Math.imul(D, at) | 0, i = (i = i + Math.imul(D, ot) | 0) + Math.imul(R, at) | 0, a = a + Math.imul(R, ot) | 0, n = n + Math.imul(P, lt) | 0, i = (i = i + Math.imul(P, ct) | 0) + Math.imul(z, lt) | 0, a = a + Math.imul(z, ct) | 0, n = n + Math.imul(C, ht) | 0, i = (i = i + Math.imul(C, ft) | 0) + Math.imul(L, ht) | 0, a = a + Math.imul(L, ft) | 0;
                                    var Lt = (c + (n = n + Math.imul(M, dt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(M, mt) | 0) + Math.imul(S, dt) | 0)) << 13) | 0;
                                    c = ((a = a + Math.imul(S, mt) | 0) + (i >>> 13) | 0) + (Lt >>> 26) | 0, Lt &= 67108863, n = Math.imul(B, at), i = (i = Math.imul(B, ot)) + Math.imul(N, at) | 0, a = Math.imul(N, ot), n = n + Math.imul(D, lt) | 0, i = (i = i + Math.imul(D, ct) | 0) + Math.imul(R, lt) | 0, a = a + Math.imul(R, ct) | 0, n = n + Math.imul(P, ht) | 0, i = (i = i + Math.imul(P, ft) | 0) + Math.imul(z, ht) | 0, a = a + Math.imul(z, ft) | 0;
                                    var It = (c + (n = n + Math.imul(C, dt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(C, mt) | 0) + Math.imul(L, dt) | 0)) << 13) | 0;
                                    c = ((a = a + Math.imul(L, mt) | 0) + (i >>> 13) | 0) + (It >>> 26) | 0, It &= 67108863, n = Math.imul(B, lt), i = (i = Math.imul(B, ct)) + Math.imul(N, lt) | 0, a = Math.imul(N, ct), n = n + Math.imul(D, ht) | 0, i = (i = i + Math.imul(D, ft) | 0) + Math.imul(R, ht) | 0, a = a + Math.imul(R, ft) | 0;
                                    var Pt = (c + (n = n + Math.imul(P, dt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(P, mt) | 0) + Math.imul(z, dt) | 0)) << 13) | 0;
                                    c = ((a = a + Math.imul(z, mt) | 0) + (i >>> 13) | 0) + (Pt >>> 26) | 0, Pt &= 67108863, n = Math.imul(B, ht), i = (i = Math.imul(B, ft)) + Math.imul(N, ht) | 0, a = Math.imul(N, ft);
                                    var zt = (c + (n = n + Math.imul(D, dt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(D, mt) | 0) + Math.imul(R, dt) | 0)) << 13) | 0;
                                    c = ((a = a + Math.imul(R, mt) | 0) + (i >>> 13) | 0) + (zt >>> 26) | 0, zt &= 67108863;
                                    var Ot = (c + (n = Math.imul(B, dt)) | 0) + ((8191 & (i = (i = Math.imul(B, mt)) + Math.imul(N, dt) | 0)) << 13) | 0;
                                    return c = ((a = Math.imul(N, mt)) + (i >>> 13) | 0) + (Ot >>> 26) | 0, Ot &= 67108863, l[0] = gt, l[1] = yt, l[2] = vt, l[3] = xt, l[4] = _t, l[5] = bt, l[6] = wt, l[7] = Tt, l[8] = kt, l[9] = At, l[10] = Mt, l[11] = St, l[12] = Et, l[13] = Ct, l[14] = Lt, l[15] = It, l[16] = Pt, l[17] = zt, l[18] = Ot, 0 !== c && (l[19] = c, r.length++), r;
                                };
                                function m(t1, e1, r) {
                                    return (new g).mulp(t1, e1, r);
                                }
                                function g(t1, e1) {
                                    this.x = t1, this.y = e1;
                                }
                                Math.imul || (d = p), a.prototype.mulTo = function(t1, e1) {
                                    var r, n = this.length + t1.length;
                                    return r = 10 === this.length && 10 === t1.length ? d(this, t1, e1) : n < 63 ? p(this, t1, e1) : n < 1024 ? function(t1, e1, r) {
                                        r.negative = e1.negative ^ t1.negative, r.length = t1.length + e1.length;
                                        for(var n = 0, i = 0, a = 0; a < r.length - 1; a++){
                                            var o = i;
                                            i = 0;
                                            for(var s = 67108863 & n, l = Math.min(a, e1.length - 1), c = Math.max(0, a - t1.length + 1); c <= l; c++){
                                                var u = a - c, h = (0 | t1.words[u]) * (0 | e1.words[c]), f = 67108863 & h;
                                                s = 67108863 & (f = f + s | 0), i += (o = (o = o + (h / 67108864 | 0) | 0) + (f >>> 26) | 0) >>> 26, o &= 67108863;
                                            }
                                            r.words[a] = s, n = o, o = i;
                                        }
                                        return 0 !== n ? r.words[a] = n : r.length--, r.strip();
                                    }(this, t1, e1) : m(this, t1, e1), r;
                                }, g.prototype.makeRBT = function(t1) {
                                    for(var e1 = new Array(t1), r = a.prototype._countBits(t1) - 1, n = 0; n < t1; n++)e1[n] = this.revBin(n, r, t1);
                                    return e1;
                                }, g.prototype.revBin = function(t1, e1, r) {
                                    if (0 === t1 || t1 === r - 1) return t1;
                                    for(var n = 0, i = 0; i < e1; i++)n |= (1 & t1) << e1 - i - 1, t1 >>= 1;
                                    return n;
                                }, g.prototype.permute = function(t1, e1, r, n, i, a) {
                                    for(var o = 0; o < a; o++)n[o] = e1[t1[o]], i[o] = r[t1[o]];
                                }, g.prototype.transform = function(t1, e1, r, n, i, a) {
                                    this.permute(a, t1, e1, r, n, i);
                                    for(var o = 1; o < i; o <<= 1)for(var s = o << 1, l = Math.cos(2 * Math.PI / s), c = Math.sin(2 * Math.PI / s), u = 0; u < i; u += s)for(var h = l, f = c, p = 0; p < o; p++){
                                        var d = r[u + p], m = n[u + p], g = r[u + p + o], y = n[u + p + o], v = h * g - f * y;
                                        y = h * y + f * g, g = v, r[u + p] = d + g, n[u + p] = m + y, r[u + p + o] = d - g, n[u + p + o] = m - y, p !== s && (v = l * h - c * f, f = l * f + c * h, h = v);
                                    }
                                }, g.prototype.guessLen13b = function(t1, e1) {
                                    var r = 1 | Math.max(e1, t1), n = 1 & r, i = 0;
                                    for(r = r / 2 | 0; r; r >>>= 1)i++;
                                    return 1 << i + 1 + n;
                                }, g.prototype.conjugate = function(t1, e1, r) {
                                    if (!(r <= 1)) for(var n = 0; n < r / 2; n++){
                                        var i = t1[n];
                                        t1[n] = t1[r - n - 1], t1[r - n - 1] = i, i = e1[n], e1[n] = -e1[r - n - 1], e1[r - n - 1] = -i;
                                    }
                                }, g.prototype.normalize13b = function(t1, e1) {
                                    for(var r = 0, n = 0; n < e1 / 2; n++){
                                        var i = 8192 * Math.round(t1[2 * n + 1] / e1) + Math.round(t1[2 * n] / e1) + r;
                                        t1[n] = 67108863 & i, r = i < 67108864 ? 0 : i / 67108864 | 0;
                                    }
                                    return t1;
                                }, g.prototype.convert13b = function(t1, e1, r, i) {
                                    for(var a = 0, o = 0; o < e1; o++)a += 0 | t1[o], r[2 * o] = 8191 & a, a >>>= 13, r[2 * o + 1] = 8191 & a, a >>>= 13;
                                    for(o = 2 * e1; o < i; ++o)r[o] = 0;
                                    n(0 === a), n(0 == (-8192 & a));
                                }, g.prototype.stub = function(t1) {
                                    for(var e1 = new Array(t1), r = 0; r < t1; r++)e1[r] = 0;
                                    return e1;
                                }, g.prototype.mulp = function(t1, e1, r) {
                                    var n = 2 * this.guessLen13b(t1.length, e1.length), i = this.makeRBT(n), a = this.stub(n), o = new Array(n), s = new Array(n), l = new Array(n), c = new Array(n), u = new Array(n), h = new Array(n), f = r.words;
                                    f.length = n, this.convert13b(t1.words, t1.length, o, n), this.convert13b(e1.words, e1.length, c, n), this.transform(o, a, s, l, n, i), this.transform(c, a, u, h, n, i);
                                    for(var p = 0; p < n; p++){
                                        var d = s[p] * u[p] - l[p] * h[p];
                                        l[p] = s[p] * h[p] + l[p] * u[p], s[p] = d;
                                    }
                                    return this.conjugate(s, l, n), this.transform(s, l, f, a, n, i), this.conjugate(f, a, n), this.normalize13b(f, n), r.negative = t1.negative ^ e1.negative, r.length = t1.length + e1.length, r.strip();
                                }, a.prototype.mul = function(t1) {
                                    var e1 = new a(null);
                                    return e1.words = new Array(this.length + t1.length), this.mulTo(t1, e1);
                                }, a.prototype.mulf = function(t1) {
                                    var e1 = new a(null);
                                    return e1.words = new Array(this.length + t1.length), m(this, t1, e1);
                                }, a.prototype.imul = function(t1) {
                                    return this.clone().mulTo(t1, this);
                                }, a.prototype.imuln = function(t1) {
                                    n("number" == typeof t1), n(t1 < 67108864);
                                    for(var e1 = 0, r = 0; r < this.length; r++){
                                        var i = (0 | this.words[r]) * t1, a = (67108863 & i) + (67108863 & e1);
                                        e1 >>= 26, e1 += i / 67108864 | 0, e1 += a >>> 26, this.words[r] = 67108863 & a;
                                    }
                                    return 0 !== e1 && (this.words[r] = e1, this.length++), this;
                                }, a.prototype.muln = function(t1) {
                                    return this.clone().imuln(t1);
                                }, a.prototype.sqr = function() {
                                    return this.mul(this);
                                }, a.prototype.isqr = function() {
                                    return this.imul(this.clone());
                                }, a.prototype.pow = function(t1) {
                                    var e1 = function(t1) {
                                        for(var e1 = new Array(t1.bitLength()), r = 0; r < e1.length; r++){
                                            var n = r / 26 | 0, i = r % 26;
                                            e1[r] = (t1.words[n] & 1 << i) >>> i;
                                        }
                                        return e1;
                                    }(t1);
                                    if (0 === e1.length) return new a(1);
                                    for(var r = this, n = 0; n < e1.length && 0 === e1[n]; n++, r = r.sqr());
                                    if (++n < e1.length) for(var i = r.sqr(); n < e1.length; n++, i = i.sqr())0 !== e1[n] && (r = r.mul(i));
                                    return r;
                                }, a.prototype.iushln = function(t1) {
                                    n("number" == typeof t1 && t1 >= 0);
                                    var e1, r = t1 % 26, i = (t1 - r) / 26, a = 67108863 >>> 26 - r << 26 - r;
                                    if (0 !== r) {
                                        var o = 0;
                                        for(e1 = 0; e1 < this.length; e1++){
                                            var s = this.words[e1] & a, l = (0 | this.words[e1]) - s << r;
                                            this.words[e1] = l | o, o = s >>> 26 - r;
                                        }
                                        o && (this.words[e1] = o, this.length++);
                                    }
                                    if (0 !== i) {
                                        for(e1 = this.length - 1; e1 >= 0; e1--)this.words[e1 + i] = this.words[e1];
                                        for(e1 = 0; e1 < i; e1++)this.words[e1] = 0;
                                        this.length += i;
                                    }
                                    return this.strip();
                                }, a.prototype.ishln = function(t1) {
                                    return n(0 === this.negative), this.iushln(t1);
                                }, a.prototype.iushrn = function(t1, e1, r) {
                                    var i;
                                    n("number" == typeof t1 && t1 >= 0), i = e1 ? (e1 - e1 % 26) / 26 : 0;
                                    var a = t1 % 26, o = Math.min((t1 - a) / 26, this.length), s = 67108863 ^ 67108863 >>> a << a, l = r;
                                    if (i -= o, i = Math.max(0, i), l) {
                                        for(var c = 0; c < o; c++)l.words[c] = this.words[c];
                                        l.length = o;
                                    }
                                    if (0 === o) ;
                                    else if (this.length > o) for(this.length -= o, c = 0; c < this.length; c++)this.words[c] = this.words[c + o];
                                    else this.words[0] = 0, this.length = 1;
                                    var u = 0;
                                    for(c = this.length - 1; c >= 0 && (0 !== u || c >= i); c--){
                                        var h = 0 | this.words[c];
                                        this.words[c] = u << 26 - a | h >>> a, u = h & s;
                                    }
                                    return l && 0 !== u && (l.words[l.length++] = u), 0 === this.length && (this.words[0] = 0, this.length = 1), this.strip();
                                }, a.prototype.ishrn = function(t1, e1, r) {
                                    return n(0 === this.negative), this.iushrn(t1, e1, r);
                                }, a.prototype.shln = function(t1) {
                                    return this.clone().ishln(t1);
                                }, a.prototype.ushln = function(t1) {
                                    return this.clone().iushln(t1);
                                }, a.prototype.shrn = function(t1) {
                                    return this.clone().ishrn(t1);
                                }, a.prototype.ushrn = function(t1) {
                                    return this.clone().iushrn(t1);
                                }, a.prototype.testn = function(t1) {
                                    n("number" == typeof t1 && t1 >= 0);
                                    var e1 = t1 % 26, r = (t1 - e1) / 26, i = 1 << e1;
                                    return !(this.length <= r || !(this.words[r] & i));
                                }, a.prototype.imaskn = function(t1) {
                                    n("number" == typeof t1 && t1 >= 0);
                                    var e1 = t1 % 26, r = (t1 - e1) / 26;
                                    if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;
                                    if (0 !== e1 && r++, this.length = Math.min(r, this.length), 0 !== e1) {
                                        var i = 67108863 ^ 67108863 >>> e1 << e1;
                                        this.words[this.length - 1] &= i;
                                    }
                                    return this.strip();
                                }, a.prototype.maskn = function(t1) {
                                    return this.clone().imaskn(t1);
                                }, a.prototype.iaddn = function(t1) {
                                    return n("number" == typeof t1), n(t1 < 67108864), t1 < 0 ? this.isubn(-t1) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) < t1 ? (this.words[0] = t1 - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(t1), this.negative = 1, this) : this._iaddn(t1);
                                }, a.prototype._iaddn = function(t1) {
                                    this.words[0] += t1;
                                    for(var e1 = 0; e1 < this.length && this.words[e1] >= 67108864; e1++)this.words[e1] -= 67108864, e1 === this.length - 1 ? this.words[e1 + 1] = 1 : this.words[e1 + 1]++;
                                    return this.length = Math.max(this.length, e1 + 1), this;
                                }, a.prototype.isubn = function(t1) {
                                    if (n("number" == typeof t1), n(t1 < 67108864), t1 < 0) return this.iaddn(-t1);
                                    if (0 !== this.negative) return this.negative = 0, this.iaddn(t1), this.negative = 1, this;
                                    if (this.words[0] -= t1, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;
                                    else for(var e1 = 0; e1 < this.length && this.words[e1] < 0; e1++)this.words[e1] += 67108864, this.words[e1 + 1] -= 1;
                                    return this.strip();
                                }, a.prototype.addn = function(t1) {
                                    return this.clone().iaddn(t1);
                                }, a.prototype.subn = function(t1) {
                                    return this.clone().isubn(t1);
                                }, a.prototype.iabs = function() {
                                    return this.negative = 0, this;
                                }, a.prototype.abs = function() {
                                    return this.clone().iabs();
                                }, a.prototype._ishlnsubmul = function(t1, e1, r) {
                                    var i, a, o = t1.length + r;
                                    this._expand(o);
                                    var s = 0;
                                    for(i = 0; i < t1.length; i++){
                                        a = (0 | this.words[i + r]) + s;
                                        var l = (0 | t1.words[i]) * e1;
                                        s = ((a -= 67108863 & l) >> 26) - (l / 67108864 | 0), this.words[i + r] = 67108863 & a;
                                    }
                                    for(; i < this.length - r; i++)s = (a = (0 | this.words[i + r]) + s) >> 26, this.words[i + r] = 67108863 & a;
                                    if (0 === s) return this.strip();
                                    for(n(-1 === s), s = 0, i = 0; i < this.length; i++)s = (a = -(0 | this.words[i]) + s) >> 26, this.words[i] = 67108863 & a;
                                    return this.negative = 1, this.strip();
                                }, a.prototype._wordDiv = function(t1, e1) {
                                    var r = (this.length, t1.length), n = this.clone(), i = t1, o = 0 | i.words[i.length - 1];
                                    0 != (r = 26 - this._countBits(o)) && (i = i.ushln(r), n.iushln(r), o = 0 | i.words[i.length - 1]);
                                    var s, l = n.length - i.length;
                                    if ("mod" !== e1) {
                                        (s = new a(null)).length = l + 1, s.words = new Array(s.length);
                                        for(var c = 0; c < s.length; c++)s.words[c] = 0;
                                    }
                                    var u = n.clone()._ishlnsubmul(i, 1, l);
                                    0 === u.negative && (n = u, s && (s.words[l] = 1));
                                    for(var h = l - 1; h >= 0; h--){
                                        var f = 67108864 * (0 | n.words[i.length + h]) + (0 | n.words[i.length + h - 1]);
                                        for(f = Math.min(f / o | 0, 67108863), n._ishlnsubmul(i, f, h); 0 !== n.negative;)f--, n.negative = 0, n._ishlnsubmul(i, 1, h), n.isZero() || (n.negative ^= 1);
                                        s && (s.words[h] = f);
                                    }
                                    return s && s.strip(), n.strip(), "div" !== e1 && 0 !== r && n.iushrn(r), {
                                        div: s || null,
                                        mod: n
                                    };
                                }, a.prototype.divmod = function(t1, e1, r) {
                                    var i, o, s;
                                    return n(!t1.isZero()), this.isZero() ? {
                                        div: new a(0),
                                        mod: new a(0)
                                    } : 0 !== this.negative && 0 === t1.negative ? (s = this.neg().divmod(t1, e1), "mod" !== e1 && (i = s.div.neg()), "div" !== e1 && (o = s.mod.neg(), r && 0 !== o.negative && o.iadd(t1)), {
                                        div: i,
                                        mod: o
                                    }) : 0 === this.negative && 0 !== t1.negative ? (s = this.divmod(t1.neg(), e1), "mod" !== e1 && (i = s.div.neg()), {
                                        div: i,
                                        mod: s.mod
                                    }) : 0 != (this.negative & t1.negative) ? (s = this.neg().divmod(t1.neg(), e1), "div" !== e1 && (o = s.mod.neg(), r && 0 !== o.negative && o.isub(t1)), {
                                        div: s.div,
                                        mod: o
                                    }) : t1.length > this.length || this.cmp(t1) < 0 ? {
                                        div: new a(0),
                                        mod: this
                                    } : 1 === t1.length ? "div" === e1 ? {
                                        div: this.divn(t1.words[0]),
                                        mod: null
                                    } : "mod" === e1 ? {
                                        div: null,
                                        mod: new a(this.modn(t1.words[0]))
                                    } : {
                                        div: this.divn(t1.words[0]),
                                        mod: new a(this.modn(t1.words[0]))
                                    } : this._wordDiv(t1, e1);
                                }, a.prototype.div = function(t1) {
                                    return this.divmod(t1, "div", !1).div;
                                }, a.prototype.mod = function(t1) {
                                    return this.divmod(t1, "mod", !1).mod;
                                }, a.prototype.umod = function(t1) {
                                    return this.divmod(t1, "mod", !0).mod;
                                }, a.prototype.divRound = function(t1) {
                                    var e1 = this.divmod(t1);
                                    if (e1.mod.isZero()) return e1.div;
                                    var r = 0 !== e1.div.negative ? e1.mod.isub(t1) : e1.mod, n = t1.ushrn(1), i = t1.andln(1), a = r.cmp(n);
                                    return a < 0 || 1 === i && 0 === a ? e1.div : 0 !== e1.div.negative ? e1.div.isubn(1) : e1.div.iaddn(1);
                                }, a.prototype.modn = function(t1) {
                                    n(t1 <= 67108863);
                                    for(var e1 = 67108864 % t1, r = 0, i = this.length - 1; i >= 0; i--)r = (e1 * r + (0 | this.words[i])) % t1;
                                    return r;
                                }, a.prototype.idivn = function(t1) {
                                    n(t1 <= 67108863);
                                    for(var e1 = 0, r = this.length - 1; r >= 0; r--){
                                        var i = (0 | this.words[r]) + 67108864 * e1;
                                        this.words[r] = i / t1 | 0, e1 = i % t1;
                                    }
                                    return this.strip();
                                }, a.prototype.divn = function(t1) {
                                    return this.clone().idivn(t1);
                                }, a.prototype.egcd = function(t1) {
                                    n(0 === t1.negative), n(!t1.isZero());
                                    var e1 = this, r = t1.clone();
                                    e1 = 0 !== e1.negative ? e1.umod(t1) : e1.clone();
                                    for(var i = new a(1), o = new a(0), s = new a(0), l = new a(1), c = 0; e1.isEven() && r.isEven();)e1.iushrn(1), r.iushrn(1), ++c;
                                    for(var u = r.clone(), h = e1.clone(); !e1.isZero();){
                                        for(var f = 0, p = 1; 0 == (e1.words[0] & p) && f < 26; ++f, p <<= 1);
                                        if (f > 0) for(e1.iushrn(f); f-- > 0;)(i.isOdd() || o.isOdd()) && (i.iadd(u), o.isub(h)), i.iushrn(1), o.iushrn(1);
                                        for(var d = 0, m = 1; 0 == (r.words[0] & m) && d < 26; ++d, m <<= 1);
                                        if (d > 0) for(r.iushrn(d); d-- > 0;)(s.isOdd() || l.isOdd()) && (s.iadd(u), l.isub(h)), s.iushrn(1), l.iushrn(1);
                                        e1.cmp(r) >= 0 ? (e1.isub(r), i.isub(s), o.isub(l)) : (r.isub(e1), s.isub(i), l.isub(o));
                                    }
                                    return {
                                        a: s,
                                        b: l,
                                        gcd: r.iushln(c)
                                    };
                                }, a.prototype._invmp = function(t1) {
                                    n(0 === t1.negative), n(!t1.isZero());
                                    var e1 = this, r = t1.clone();
                                    e1 = 0 !== e1.negative ? e1.umod(t1) : e1.clone();
                                    for(var i, o = new a(1), s = new a(0), l = r.clone(); e1.cmpn(1) > 0 && r.cmpn(1) > 0;){
                                        for(var c = 0, u = 1; 0 == (e1.words[0] & u) && c < 26; ++c, u <<= 1);
                                        if (c > 0) for(e1.iushrn(c); c-- > 0;)o.isOdd() && o.iadd(l), o.iushrn(1);
                                        for(var h = 0, f = 1; 0 == (r.words[0] & f) && h < 26; ++h, f <<= 1);
                                        if (h > 0) for(r.iushrn(h); h-- > 0;)s.isOdd() && s.iadd(l), s.iushrn(1);
                                        e1.cmp(r) >= 0 ? (e1.isub(r), o.isub(s)) : (r.isub(e1), s.isub(o));
                                    }
                                    return (i = 0 === e1.cmpn(1) ? o : s).cmpn(0) < 0 && i.iadd(t1), i;
                                }, a.prototype.gcd = function(t1) {
                                    if (this.isZero()) return t1.abs();
                                    if (t1.isZero()) return this.abs();
                                    var e1 = this.clone(), r = t1.clone();
                                    e1.negative = 0, r.negative = 0;
                                    for(var n = 0; e1.isEven() && r.isEven(); n++)e1.iushrn(1), r.iushrn(1);
                                    for(;;){
                                        for(; e1.isEven();)e1.iushrn(1);
                                        for(; r.isEven();)r.iushrn(1);
                                        var i = e1.cmp(r);
                                        if (i < 0) {
                                            var a = e1;
                                            e1 = r, r = a;
                                        } else if (0 === i || 0 === r.cmpn(1)) break;
                                        e1.isub(r);
                                    }
                                    return r.iushln(n);
                                }, a.prototype.invm = function(t1) {
                                    return this.egcd(t1).a.umod(t1);
                                }, a.prototype.isEven = function() {
                                    return 0 == (1 & this.words[0]);
                                }, a.prototype.isOdd = function() {
                                    return 1 == (1 & this.words[0]);
                                }, a.prototype.andln = function(t1) {
                                    return this.words[0] & t1;
                                }, a.prototype.bincn = function(t1) {
                                    n("number" == typeof t1);
                                    var e1 = t1 % 26, r = (t1 - e1) / 26, i = 1 << e1;
                                    if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;
                                    for(var a = i, o = r; 0 !== a && o < this.length; o++){
                                        var s = 0 | this.words[o];
                                        a = (s += a) >>> 26, s &= 67108863, this.words[o] = s;
                                    }
                                    return 0 !== a && (this.words[o] = a, this.length++), this;
                                }, a.prototype.isZero = function() {
                                    return 1 === this.length && 0 === this.words[0];
                                }, a.prototype.cmpn = function(t1) {
                                    var e1, r = t1 < 0;
                                    if (0 !== this.negative && !r) return -1;
                                    if (0 === this.negative && r) return 1;
                                    if (this.strip(), this.length > 1) e1 = 1;
                                    else {
                                        r && (t1 = -t1), n(t1 <= 67108863, "Number is too big");
                                        var i = 0 | this.words[0];
                                        e1 = i === t1 ? 0 : i < t1 ? -1 : 1;
                                    }
                                    return 0 !== this.negative ? 0 | -e1 : e1;
                                }, a.prototype.cmp = function(t1) {
                                    if (0 !== this.negative && 0 === t1.negative) return -1;
                                    if (0 === this.negative && 0 !== t1.negative) return 1;
                                    var e1 = this.ucmp(t1);
                                    return 0 !== this.negative ? 0 | -e1 : e1;
                                }, a.prototype.ucmp = function(t1) {
                                    if (this.length > t1.length) return 1;
                                    if (this.length < t1.length) return -1;
                                    for(var e1 = 0, r = this.length - 1; r >= 0; r--){
                                        var n = 0 | this.words[r], i = 0 | t1.words[r];
                                        if (n !== i) {
                                            n < i ? e1 = -1 : n > i && (e1 = 1);
                                            break;
                                        }
                                    }
                                    return e1;
                                }, a.prototype.gtn = function(t1) {
                                    return 1 === this.cmpn(t1);
                                }, a.prototype.gt = function(t1) {
                                    return 1 === this.cmp(t1);
                                }, a.prototype.gten = function(t1) {
                                    return this.cmpn(t1) >= 0;
                                }, a.prototype.gte = function(t1) {
                                    return this.cmp(t1) >= 0;
                                }, a.prototype.ltn = function(t1) {
                                    return -1 === this.cmpn(t1);
                                }, a.prototype.lt = function(t1) {
                                    return -1 === this.cmp(t1);
                                }, a.prototype.lten = function(t1) {
                                    return this.cmpn(t1) <= 0;
                                }, a.prototype.lte = function(t1) {
                                    return this.cmp(t1) <= 0;
                                }, a.prototype.eqn = function(t1) {
                                    return 0 === this.cmpn(t1);
                                }, a.prototype.eq = function(t1) {
                                    return 0 === this.cmp(t1);
                                }, a.red = function(t1) {
                                    return new T(t1);
                                }, a.prototype.toRed = function(t1) {
                                    return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), t1.convertTo(this)._forceRed(t1);
                                }, a.prototype.fromRed = function() {
                                    return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
                                }, a.prototype._forceRed = function(t1) {
                                    return this.red = t1, this;
                                }, a.prototype.forceRed = function(t1) {
                                    return n(!this.red, "Already a number in reduction context"), this._forceRed(t1);
                                }, a.prototype.redAdd = function(t1) {
                                    return n(this.red, "redAdd works only with red numbers"), this.red.add(this, t1);
                                }, a.prototype.redIAdd = function(t1) {
                                    return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, t1);
                                }, a.prototype.redSub = function(t1) {
                                    return n(this.red, "redSub works only with red numbers"), this.red.sub(this, t1);
                                }, a.prototype.redISub = function(t1) {
                                    return n(this.red, "redISub works only with red numbers"), this.red.isub(this, t1);
                                }, a.prototype.redShl = function(t1) {
                                    return n(this.red, "redShl works only with red numbers"), this.red.shl(this, t1);
                                }, a.prototype.redMul = function(t1) {
                                    return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, t1), this.red.mul(this, t1);
                                }, a.prototype.redIMul = function(t1) {
                                    return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, t1), this.red.imul(this, t1);
                                }, a.prototype.redSqr = function() {
                                    return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
                                }, a.prototype.redISqr = function() {
                                    return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
                                }, a.prototype.redSqrt = function() {
                                    return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
                                }, a.prototype.redInvm = function() {
                                    return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
                                }, a.prototype.redNeg = function() {
                                    return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
                                }, a.prototype.redPow = function(t1) {
                                    return n(this.red && !t1.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, t1);
                                };
                                var y = {
                                    k256: null,
                                    p224: null,
                                    p192: null,
                                    p25519: null
                                };
                                function v(t1, e1) {
                                    this.name = t1, this.p = new a(e1, 16), this.n = this.p.bitLength(), this.k = new a(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
                                }
                                function x() {
                                    v.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
                                }
                                function _() {
                                    v.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
                                }
                                function b() {
                                    v.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
                                }
                                function w() {
                                    v.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
                                }
                                function T(t1) {
                                    if ("string" == typeof t1) {
                                        var e1 = a._prime(t1);
                                        this.m = e1.p, this.prime = e1;
                                    } else n(t1.gtn(1), "modulus must be greater than 1"), this.m = t1, this.prime = null;
                                }
                                function k(t1) {
                                    T.call(this, t1), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new a(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
                                }
                                v.prototype._tmp = function() {
                                    var t1 = new a(null);
                                    return t1.words = new Array(Math.ceil(this.n / 13)), t1;
                                }, v.prototype.ireduce = function(t1) {
                                    var e1, r = t1;
                                    do this.split(r, this.tmp), e1 = (r = (r = this.imulK(r)).iadd(this.tmp)).bitLength();
                                    while (e1 > this.n);
                                    var n = e1 < this.n ? -1 : r.ucmp(this.p);
                                    return 0 === n ? (r.words[0] = 0, r.length = 1) : n > 0 ? r.isub(this.p) : void 0 !== r.strip ? r.strip() : r._strip(), r;
                                }, v.prototype.split = function(t1, e1) {
                                    t1.iushrn(this.n, 0, e1);
                                }, v.prototype.imulK = function(t1) {
                                    return t1.imul(this.k);
                                }, i(x, v), x.prototype.split = function(t1, e1) {
                                    for(var r = 4194303, n = Math.min(t1.length, 9), i = 0; i < n; i++)e1.words[i] = t1.words[i];
                                    if (e1.length = n, t1.length <= 9) return t1.words[0] = 0, void (t1.length = 1);
                                    var a = t1.words[9];
                                    for(e1.words[e1.length++] = a & r, i = 10; i < t1.length; i++){
                                        var o = 0 | t1.words[i];
                                        t1.words[i - 10] = (o & r) << 4 | a >>> 22, a = o;
                                    }
                                    a >>>= 22, t1.words[i - 10] = a, 0 === a && t1.length > 10 ? t1.length -= 10 : t1.length -= 9;
                                }, x.prototype.imulK = function(t1) {
                                    t1.words[t1.length] = 0, t1.words[t1.length + 1] = 0, t1.length += 2;
                                    for(var e1 = 0, r = 0; r < t1.length; r++){
                                        var n = 0 | t1.words[r];
                                        e1 += 977 * n, t1.words[r] = 67108863 & e1, e1 = 64 * n + (e1 / 67108864 | 0);
                                    }
                                    return 0 === t1.words[t1.length - 1] && (t1.length--, 0 === t1.words[t1.length - 1] && t1.length--), t1;
                                }, i(_, v), i(b, v), i(w, v), w.prototype.imulK = function(t1) {
                                    for(var e1 = 0, r = 0; r < t1.length; r++){
                                        var n = 19 * (0 | t1.words[r]) + e1, i = 67108863 & n;
                                        n >>>= 26, t1.words[r] = i, e1 = n;
                                    }
                                    return 0 !== e1 && (t1.words[t1.length++] = e1), t1;
                                }, a._prime = function(t1) {
                                    if (y[t1]) return y[t1];
                                    var e1;
                                    if ("k256" === t1) e1 = new x;
                                    else if ("p224" === t1) e1 = new _;
                                    else if ("p192" === t1) e1 = new b;
                                    else {
                                        if ("p25519" !== t1) throw new Error("Unknown prime " + t1);
                                        e1 = new w;
                                    }
                                    return y[t1] = e1, e1;
                                }, T.prototype._verify1 = function(t1) {
                                    n(0 === t1.negative, "red works only with positives"), n(t1.red, "red works only with red numbers");
                                }, T.prototype._verify2 = function(t1, e1) {
                                    n(0 == (t1.negative | e1.negative), "red works only with positives"), n(t1.red && t1.red === e1.red, "red works only with red numbers");
                                }, T.prototype.imod = function(t1) {
                                    return this.prime ? this.prime.ireduce(t1)._forceRed(this) : t1.umod(this.m)._forceRed(this);
                                }, T.prototype.neg = function(t1) {
                                    return t1.isZero() ? t1.clone() : this.m.sub(t1)._forceRed(this);
                                }, T.prototype.add = function(t1, e1) {
                                    this._verify2(t1, e1);
                                    var r = t1.add(e1);
                                    return r.cmp(this.m) >= 0 && r.isub(this.m), r._forceRed(this);
                                }, T.prototype.iadd = function(t1, e1) {
                                    this._verify2(t1, e1);
                                    var r = t1.iadd(e1);
                                    return r.cmp(this.m) >= 0 && r.isub(this.m), r;
                                }, T.prototype.sub = function(t1, e1) {
                                    this._verify2(t1, e1);
                                    var r = t1.sub(e1);
                                    return r.cmpn(0) < 0 && r.iadd(this.m), r._forceRed(this);
                                }, T.prototype.isub = function(t1, e1) {
                                    this._verify2(t1, e1);
                                    var r = t1.isub(e1);
                                    return r.cmpn(0) < 0 && r.iadd(this.m), r;
                                }, T.prototype.shl = function(t1, e1) {
                                    return this._verify1(t1), this.imod(t1.ushln(e1));
                                }, T.prototype.imul = function(t1, e1) {
                                    return this._verify2(t1, e1), this.imod(t1.imul(e1));
                                }, T.prototype.mul = function(t1, e1) {
                                    return this._verify2(t1, e1), this.imod(t1.mul(e1));
                                }, T.prototype.isqr = function(t1) {
                                    return this.imul(t1, t1.clone());
                                }, T.prototype.sqr = function(t1) {
                                    return this.mul(t1, t1);
                                }, T.prototype.sqrt = function(t1) {
                                    if (t1.isZero()) return t1.clone();
                                    var e1 = this.m.andln(3);
                                    if (n(e1 % 2 == 1), 3 === e1) {
                                        var r = this.m.add(new a(1)).iushrn(2);
                                        return this.pow(t1, r);
                                    }
                                    for(var i = this.m.subn(1), o = 0; !i.isZero() && 0 === i.andln(1);)o++, i.iushrn(1);
                                    n(!i.isZero());
                                    var s = new a(1).toRed(this), l = s.redNeg(), c = this.m.subn(1).iushrn(1), u = this.m.bitLength();
                                    for(u = new a(2 * u * u).toRed(this); 0 !== this.pow(u, c).cmp(l);)u.redIAdd(l);
                                    for(var h = this.pow(u, i), f = this.pow(t1, i.addn(1).iushrn(1)), p = this.pow(t1, i), d = o; 0 !== p.cmp(s);){
                                        for(var m = p, g = 0; 0 !== m.cmp(s); g++)m = m.redSqr();
                                        n(g < d);
                                        var y = this.pow(h, new a(1).iushln(d - g - 1));
                                        f = f.redMul(y), h = y.redSqr(), p = p.redMul(h), d = g;
                                    }
                                    return f;
                                }, T.prototype.invm = function(t1) {
                                    var e1 = t1._invmp(this.m);
                                    return 0 !== e1.negative ? (e1.negative = 0, this.imod(e1).redNeg()) : this.imod(e1);
                                }, T.prototype.pow = function(t1, e1) {
                                    if (e1.isZero()) return new a(1).toRed(this);
                                    if (0 === e1.cmpn(1)) return t1.clone();
                                    var r = new Array(16);
                                    r[0] = new a(1).toRed(this), r[1] = t1;
                                    for(var n = 2; n < r.length; n++)r[n] = this.mul(r[n - 1], t1);
                                    var i = r[0], o = 0, s = 0, l = e1.bitLength() % 26;
                                    for(0 === l && (l = 26), n = e1.length - 1; n >= 0; n--){
                                        for(var c = e1.words[n], u = l - 1; u >= 0; u--){
                                            var h = c >> u & 1;
                                            i !== r[0] && (i = this.sqr(i)), 0 !== h || 0 !== o ? (o <<= 1, o |= h, (4 == ++s || 0 === n && 0 === u) && (i = this.mul(i, r[o]), s = 0, o = 0)) : s = 0;
                                        }
                                        l = 26;
                                    }
                                    return i;
                                }, T.prototype.convertTo = function(t1) {
                                    var e1 = t1.umod(this.m);
                                    return e1 === t1 ? e1.clone() : e1;
                                }, T.prototype.convertFrom = function(t1) {
                                    var e1 = t1.clone();
                                    return e1.red = null, e1;
                                }, a.mont = function(t1) {
                                    return new k(t1);
                                }, i(k, T), k.prototype.convertTo = function(t1) {
                                    return this.imod(t1.ushln(this.shift));
                                }, k.prototype.convertFrom = function(t1) {
                                    var e1 = this.imod(t1.mul(this.rinv));
                                    return e1.red = null, e1;
                                }, k.prototype.imul = function(t1, e1) {
                                    if (t1.isZero() || e1.isZero()) return t1.words[0] = 0, t1.length = 1, t1;
                                    var r = t1.imul(e1), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), a = i;
                                    return i.cmp(this.m) >= 0 ? a = i.isub(this.m) : i.cmpn(0) < 0 && (a = i.iadd(this.m)), a._forceRed(this);
                                }, k.prototype.mul = function(t1, e1) {
                                    if (t1.isZero() || e1.isZero()) return new a(0)._forceRed(this);
                                    var r = t1.mul(e1), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), o = i;
                                    return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
                                }, k.prototype.invm = function(t1) {
                                    return this.imod(t1._invmp(this.m).mul(this.r2))._forceRed(this);
                                };
                            }(t1 = r.nmd(t1), this);
                        },
                        6204: function(t1) {
                            "use strict";
                            t1.exports = function(t1) {
                                var e1, r, n, i = t1.length, a = 0;
                                for(e1 = 0; e1 < i; ++e1)a += t1[e1].length;
                                var o = new Array(a), s = 0;
                                for(e1 = 0; e1 < i; ++e1){
                                    var l = t1[e1], c = l.length;
                                    for(r = 0; r < c; ++r){
                                        var u = o[s++] = new Array(c - 1), h = 0;
                                        for(n = 0; n < c; ++n)n !== r && (u[h++] = l[n]);
                                        if (1 & r) {
                                            var f = u[1];
                                            u[1] = u[0], u[0] = f;
                                        }
                                    }
                                }
                                return o;
                            };
                        },
                        6867: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1, r) {
                                switch(arguments.length){
                                    case 1:
                                        return n = [], c(i = t1, i, u, !0), n;
                                    case 2:
                                        return "function" == typeof e1 ? c(t1, t1, e1, !0) : function(t1, e1) {
                                            return n = [], c(t1, e1, u, !1), n;
                                        }(t1, e1);
                                    case 3:
                                        return c(t1, e1, r, !1);
                                    default:
                                        throw new Error("box-intersect: Invalid arguments");
                                }
                                var i;
                            };
                            var n, i = r(1888), a = r(855), o = r(7150);
                            function s(t1, e1) {
                                for(var r = 0; r < t1; ++r)if (!(e1[r] <= e1[r + t1])) return !0;
                                return !1;
                            }
                            function l(t1, e1, r, n) {
                                for(var i = 0, a = 0, o = 0, l = t1.length; o < l; ++o){
                                    var c = t1[o];
                                    if (!s(e1, c)) {
                                        for(var u = 0; u < 2 * e1; ++u)r[i++] = c[u];
                                        n[a++] = o;
                                    }
                                }
                                return a;
                            }
                            function c(t1, e1, r, n) {
                                var s = t1.length, c = e1.length;
                                if (!(s <= 0 || c <= 0)) {
                                    var u = t1[0].length >>> 1;
                                    if (!(u <= 0)) {
                                        var h, f = i.mallocDouble(2 * u * s), p = i.mallocInt32(s);
                                        if ((s = l(t1, u, f, p)) > 0) {
                                            if (1 === u && n) a.init(s), h = a.sweepComplete(u, r, 0, s, f, p, 0, s, f, p);
                                            else {
                                                var d = i.mallocDouble(2 * u * c), m = i.mallocInt32(c);
                                                (c = l(e1, u, d, m)) > 0 && (a.init(s + c), h = 1 === u ? a.sweepBipartite(u, r, 0, s, f, p, 0, c, d, m) : o(u, r, n, s, f, p, c, d, m), i.free(d), i.free(m));
                                            }
                                            i.free(f), i.free(p);
                                        }
                                        return h;
                                    }
                                }
                            }
                            function u(t1, e1) {
                                n.push([
                                    t1,
                                    e1
                                ]);
                            }
                        },
                        2455: function(t1, e1) {
                            "use strict";
                            function r(t1) {
                                return t1 ? function(t1, e1, r, n, i, a, o, s, l, c, u) {
                                    return i - n > l - s ? function(t1, e1, r, n, i, a, o, s, l, c, u) {
                                        for(var h = 2 * t1, f = n, p = h * n; f < i; ++f, p += h){
                                            var d = a[e1 + p], m = a[e1 + p + t1], g = o[f];
                                            t: for(var y = s, v = h * s; y < l; ++y, v += h){
                                                var x = c[e1 + v], _ = c[e1 + v + t1], b = u[y];
                                                if (!(_ < d || m < x)) {
                                                    for(var w = e1 + 1; w < t1; ++w){
                                                        var T = a[w + p], k = a[w + t1 + p], A = c[w + v], M = c[w + t1 + v];
                                                        if (k < A || M < T) continue t;
                                                    }
                                                    var S = r(g, b);
                                                    if (void 0 !== S) return S;
                                                }
                                            }
                                        }
                                    }(t1, e1, r, n, i, a, o, s, l, c, u) : function(t1, e1, r, n, i, a, o, s, l, c, u) {
                                        for(var h = 2 * t1, f = s, p = h * s; f < l; ++f, p += h){
                                            var d = c[e1 + p], m = c[e1 + p + t1], g = u[f];
                                            t: for(var y = n, v = h * n; y < i; ++y, v += h){
                                                var x = a[e1 + v], _ = a[e1 + v + t1], b = o[y];
                                                if (!(m < x || _ < d)) {
                                                    for(var w = e1 + 1; w < t1; ++w){
                                                        var T = a[w + v], k = a[w + t1 + v], A = c[w + p], M = c[w + t1 + p];
                                                        if (k < A || M < T) continue t;
                                                    }
                                                    var S = r(b, g);
                                                    if (void 0 !== S) return S;
                                                }
                                            }
                                        }
                                    }(t1, e1, r, n, i, a, o, s, l, c, u);
                                } : function(t1, e1, r, n, i, a, o, s, l, c, u, h) {
                                    return a - i > c - l ? n ? function(t1, e1, r, n, i, a, o, s, l, c, u) {
                                        for(var h = 2 * t1, f = n, p = h * n; f < i; ++f, p += h){
                                            var d = a[e1 + p], m = a[e1 + p + t1], g = o[f];
                                            t: for(var y = s, v = h * s; y < l; ++y, v += h){
                                                var x = c[e1 + v], _ = u[y];
                                                if (!(x <= d || m < x)) {
                                                    for(var b = e1 + 1; b < t1; ++b){
                                                        var w = a[b + p], T = a[b + t1 + p], k = c[b + v], A = c[b + t1 + v];
                                                        if (T < k || A < w) continue t;
                                                    }
                                                    var M = r(_, g);
                                                    if (void 0 !== M) return M;
                                                }
                                            }
                                        }
                                    }(t1, e1, r, i, a, o, s, l, c, u, h) : function(t1, e1, r, n, i, a, o, s, l, c, u) {
                                        for(var h = 2 * t1, f = n, p = h * n; f < i; ++f, p += h){
                                            var d = a[e1 + p], m = a[e1 + p + t1], g = o[f];
                                            t: for(var y = s, v = h * s; y < l; ++y, v += h){
                                                var x = c[e1 + v], _ = u[y];
                                                if (!(x < d || m < x)) {
                                                    for(var b = e1 + 1; b < t1; ++b){
                                                        var w = a[b + p], T = a[b + t1 + p], k = c[b + v], A = c[b + t1 + v];
                                                        if (T < k || A < w) continue t;
                                                    }
                                                    var M = r(g, _);
                                                    if (void 0 !== M) return M;
                                                }
                                            }
                                        }
                                    }(t1, e1, r, i, a, o, s, l, c, u, h) : n ? function(t1, e1, r, n, i, a, o, s, l, c, u) {
                                        for(var h = 2 * t1, f = s, p = h * s; f < l; ++f, p += h){
                                            var d = c[e1 + p], m = u[f];
                                            t: for(var g = n, y = h * n; g < i; ++g, y += h){
                                                var v = a[e1 + y], x = a[e1 + y + t1], _ = o[g];
                                                if (!(d <= v || x < d)) {
                                                    for(var b = e1 + 1; b < t1; ++b){
                                                        var w = a[b + y], T = a[b + t1 + y], k = c[b + p], A = c[b + t1 + p];
                                                        if (T < k || A < w) continue t;
                                                    }
                                                    var M = r(m, _);
                                                    if (void 0 !== M) return M;
                                                }
                                            }
                                        }
                                    }(t1, e1, r, i, a, o, s, l, c, u, h) : function(t1, e1, r, n, i, a, o, s, l, c, u) {
                                        for(var h = 2 * t1, f = s, p = h * s; f < l; ++f, p += h){
                                            var d = c[e1 + p], m = u[f];
                                            t: for(var g = n, y = h * n; g < i; ++g, y += h){
                                                var v = a[e1 + y], x = a[e1 + y + t1], _ = o[g];
                                                if (!(d < v || x < d)) {
                                                    for(var b = e1 + 1; b < t1; ++b){
                                                        var w = a[b + y], T = a[b + t1 + y], k = c[b + p], A = c[b + t1 + p];
                                                        if (T < k || A < w) continue t;
                                                    }
                                                    var M = r(_, m);
                                                    if (void 0 !== M) return M;
                                                }
                                            }
                                        }
                                    }(t1, e1, r, i, a, o, s, l, c, u, h);
                                };
                            }
                            e1.partial = r(!1), e1.full = r(!0);
                        },
                        7150: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1, r, a, u, S, E, C, L) {
                                !function(t1, e1) {
                                    var r = 8 * i.log2(e1 + 1) * (t1 + 1) | 0, a = i.nextPow2(_ * r);
                                    w.length < a && (n.free(w), w = n.mallocInt32(a));
                                    var o = i.nextPow2(b * r);
                                    T.length < o && (n.free(T), T = n.mallocDouble(o));
                                }(t1, a + E);
                                var I, P = 0, z = 2 * t1;
                                for(k(P++, 0, 0, a, 0, E, r ? 16 : 0, -1 / 0, 1 / 0), r || k(P++, 0, 0, E, 0, a, 1, -1 / 0, 1 / 0); P > 0;){
                                    var O = (P -= 1) * _, D = w[O], R = w[O + 1], F = w[O + 2], B = w[O + 3], N = w[O + 4], j = w[O + 5], U = P * b, V = T[U], q = T[U + 1], H = 1 & j, G = !!(16 & j), Z = u, W = S, Y = C, X = L;
                                    if (H && (Z = C, W = L, Y = u, X = S), !(2 & j && R >= (F = g(t1, D, R, F, Z, W, q)) || 4 & j && (R = y(t1, D, R, F, Z, W, V)) >= F)) {
                                        var $ = F - R, J = N - B;
                                        if (G) {
                                            if (t1 * $ * ($ + J) < p) {
                                                if (void 0 !== (I = l.scanComplete(t1, D, e1, R, F, Z, W, B, N, Y, X))) return I;
                                                continue;
                                            }
                                        } else {
                                            if (t1 * Math.min($, J) < h) {
                                                if (void 0 !== (I = o(t1, D, e1, H, R, F, Z, W, B, N, Y, X))) return I;
                                                continue;
                                            }
                                            if (t1 * $ * J < f) {
                                                if (void 0 !== (I = l.scanBipartite(t1, D, e1, H, R, F, Z, W, B, N, Y, X))) return I;
                                                continue;
                                            }
                                        }
                                        var K = d(t1, D, R, F, Z, W, V, q);
                                        if (R < K) {
                                            if (t1 * (K - R) < h) {
                                                if (void 0 !== (I = s(t1, D + 1, e1, R, K, Z, W, B, N, Y, X))) return I;
                                            } else if (D === t1 - 2) {
                                                if (void 0 !== (I = H ? l.sweepBipartite(t1, e1, B, N, Y, X, R, K, Z, W) : l.sweepBipartite(t1, e1, R, K, Z, W, B, N, Y, X))) return I;
                                            } else k(P++, D + 1, R, K, B, N, H, -1 / 0, 1 / 0), k(P++, D + 1, B, N, R, K, 1 ^ H, -1 / 0, 1 / 0);
                                        }
                                        if (K < F) {
                                            var Q = c(t1, D, B, N, Y, X), tt = Y[z * Q + D], et = m(t1, D, Q, N, Y, X, tt);
                                            if (et < N && k(P++, D, K, F, et, N, (4 | H) + (G ? 16 : 0), tt, q), B < Q && k(P++, D, K, F, B, Q, (2 | H) + (G ? 16 : 0), V, tt), Q + 1 === et) {
                                                if (void 0 !== (I = G ? M(t1, D, e1, K, F, Z, W, Q, Y, X[Q]) : A(t1, D, e1, H, K, F, Z, W, Q, Y, X[Q]))) return I;
                                            } else if (Q < et) {
                                                var rt;
                                                if (G) {
                                                    if (K < (rt = v(t1, D, K, F, Z, W, tt))) {
                                                        var nt = m(t1, D, K, rt, Z, W, tt);
                                                        if (D === t1 - 2) {
                                                            if (K < nt && void 0 !== (I = l.sweepComplete(t1, e1, K, nt, Z, W, Q, et, Y, X))) return I;
                                                            if (nt < rt && void 0 !== (I = l.sweepBipartite(t1, e1, nt, rt, Z, W, Q, et, Y, X))) return I;
                                                        } else K < nt && k(P++, D + 1, K, nt, Q, et, 16, -1 / 0, 1 / 0), nt < rt && (k(P++, D + 1, nt, rt, Q, et, 0, -1 / 0, 1 / 0), k(P++, D + 1, Q, et, nt, rt, 1, -1 / 0, 1 / 0));
                                                    }
                                                } else K < (rt = H ? x(t1, D, K, F, Z, W, tt) : v(t1, D, K, F, Z, W, tt)) && (D === t1 - 2 ? I = H ? l.sweepBipartite(t1, e1, Q, et, Y, X, K, rt, Z, W) : l.sweepBipartite(t1, e1, K, rt, Z, W, Q, et, Y, X) : (k(P++, D + 1, K, rt, Q, et, H, -1 / 0, 1 / 0), k(P++, D + 1, Q, et, K, rt, 1 ^ H, -1 / 0, 1 / 0)));
                                            }
                                        }
                                    }
                                }
                            };
                            var n = r(1888), i = r(8828), a = r(2455), o = a.partial, s = a.full, l = r(855), c = r(3545), u = r(8105), h = 128, f = 4194304, p = 4194304, d = u("!(lo>=p0)&&!(p1>=hi)"), m = u("lo===p0"), g = u("lo<p0"), y = u("hi<=p0"), v = u("lo<=p0&&p0<=hi"), x = u("lo<p0&&p0<=hi"), _ = 6, b = 2, w = n.mallocInt32(1024), T = n.mallocDouble(1024);
                            function k(t1, e1, r, n, i, a, o, s, l) {
                                var c = _ * t1;
                                w[c] = e1, w[c + 1] = r, w[c + 2] = n, w[c + 3] = i, w[c + 4] = a, w[c + 5] = o;
                                var u = b * t1;
                                T[u] = s, T[u + 1] = l;
                            }
                            function A(t1, e1, r, n, i, a, o, s, l, c, u) {
                                var h = 2 * t1, f = l * h, p = c[f + e1];
                                t: for(var d = i, m = i * h; d < a; ++d, m += h){
                                    var g = o[m + e1], y = o[m + e1 + t1];
                                    if (!(p < g || y < p || n && p === g)) {
                                        for(var v, x = s[d], _ = e1 + 1; _ < t1; ++_){
                                            g = o[m + _], y = o[m + _ + t1];
                                            var b = c[f + _], w = c[f + _ + t1];
                                            if (y < b || w < g) continue t;
                                        }
                                        if (void 0 !== (v = n ? r(u, x) : r(x, u))) return v;
                                    }
                                }
                            }
                            function M(t1, e1, r, n, i, a, o, s, l, c) {
                                var u = 2 * t1, h = s * u, f = l[h + e1];
                                t: for(var p = n, d = n * u; p < i; ++p, d += u){
                                    var m = o[p];
                                    if (m !== c) {
                                        var g = a[d + e1], y = a[d + e1 + t1];
                                        if (!(f < g || y < f)) {
                                            for(var v = e1 + 1; v < t1; ++v){
                                                g = a[d + v], y = a[d + v + t1];
                                                var x = l[h + v], _ = l[h + v + t1];
                                                if (y < x || _ < g) continue t;
                                            }
                                            var b = r(m, c);
                                            if (void 0 !== b) return b;
                                        }
                                    }
                                }
                            }
                        },
                        3545: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1, r, o, s, l) {
                                if (o <= r + 1) return r;
                                for(var c = r, u = o, h = o + r >>> 1, f = 2 * t1, p = h, d = s[f * h + e1]; c < u;){
                                    if (u - c < i) {
                                        a(t1, e1, c, u, s, l), d = s[f * h + e1];
                                        break;
                                    }
                                    var m = u - c, g = Math.random() * m + c | 0, y = s[f * g + e1], v = Math.random() * m + c | 0, x = s[f * v + e1], _ = Math.random() * m + c | 0, b = s[f * _ + e1];
                                    y <= x ? b >= x ? (p = v, d = x) : y >= b ? (p = g, d = y) : (p = _, d = b) : x >= b ? (p = v, d = x) : b >= y ? (p = g, d = y) : (p = _, d = b);
                                    for(var w = f * (u - 1), T = f * p, k = 0; k < f; ++k, ++w, ++T){
                                        var A = s[w];
                                        s[w] = s[T], s[T] = A;
                                    }
                                    var M = l[u - 1];
                                    for(l[u - 1] = l[p], l[p] = M, w = f * (u - 1), T = f * (p = n(t1, e1, c, u - 1, s, l, d)), k = 0; k < f; ++k, ++w, ++T)A = s[w], s[w] = s[T], s[T] = A;
                                    if (M = l[u - 1], l[u - 1] = l[p], l[p] = M, h < p) {
                                        for(u = p - 1; c < u && s[f * (u - 1) + e1] === d;)u -= 1;
                                        u += 1;
                                    } else {
                                        if (!(p < h)) break;
                                        for(c = p + 1; c < u && s[f * c + e1] === d;)c += 1;
                                    }
                                }
                                return n(t1, e1, r, h, s, l, s[f * h + e1]);
                            };
                            var n = r(8105)("lo<p0"), i = 8;
                            function a(t1, e1, r, n, i, a) {
                                for(var o = 2 * t1, s = o * (r + 1) + e1, l = r + 1; l < n; ++l, s += o)for(var c = i[s], u = l, h = o * (l - 1); u > r && i[h + e1] > c; --u, h -= o){
                                    for(var f = h, p = h + o, d = 0; d < o; ++d, ++f, ++p){
                                        var m = i[f];
                                        i[f] = i[p], i[p] = m;
                                    }
                                    var g = a[u];
                                    a[u] = a[u - 1], a[u - 1] = g;
                                }
                            }
                        },
                        8105: function(t1) {
                            "use strict";
                            t1.exports = function(t1) {
                                return e1[t1];
                            };
                            var e1 = {
                                "lo===p0": function(t1, e1, r, n, i, a, o) {
                                    for(var s = 2 * t1, l = s * r, c = l, u = r, h = e1, f = r; n > f; ++f, l += s)if (i[l + h] === o) {
                                        if (u === f) u += 1, c += s;
                                        else {
                                            for(var p = 0; s > p; ++p){
                                                var d = i[l + p];
                                                i[l + p] = i[c], i[c++] = d;
                                            }
                                            var m = a[f];
                                            a[f] = a[u], a[u++] = m;
                                        }
                                    }
                                    return u;
                                },
                                "lo<p0": function(t1, e1, r, n, i, a, o) {
                                    for(var s = 2 * t1, l = s * r, c = l, u = r, h = e1, f = r; n > f; ++f, l += s)if (i[l + h] < o) {
                                        if (u === f) u += 1, c += s;
                                        else {
                                            for(var p = 0; s > p; ++p){
                                                var d = i[l + p];
                                                i[l + p] = i[c], i[c++] = d;
                                            }
                                            var m = a[f];
                                            a[f] = a[u], a[u++] = m;
                                        }
                                    }
                                    return u;
                                },
                                "lo<=p0": function(t1, e1, r, n, i, a, o) {
                                    for(var s = 2 * t1, l = s * r, c = l, u = r, h = t1 + e1, f = r; n > f; ++f, l += s)if (i[l + h] <= o) {
                                        if (u === f) u += 1, c += s;
                                        else {
                                            for(var p = 0; s > p; ++p){
                                                var d = i[l + p];
                                                i[l + p] = i[c], i[c++] = d;
                                            }
                                            var m = a[f];
                                            a[f] = a[u], a[u++] = m;
                                        }
                                    }
                                    return u;
                                },
                                "hi<=p0": function(t1, e1, r, n, i, a, o) {
                                    for(var s = 2 * t1, l = s * r, c = l, u = r, h = t1 + e1, f = r; n > f; ++f, l += s)if (i[l + h] <= o) {
                                        if (u === f) u += 1, c += s;
                                        else {
                                            for(var p = 0; s > p; ++p){
                                                var d = i[l + p];
                                                i[l + p] = i[c], i[c++] = d;
                                            }
                                            var m = a[f];
                                            a[f] = a[u], a[u++] = m;
                                        }
                                    }
                                    return u;
                                },
                                "lo<p0&&p0<=hi": function(t1, e1, r, n, i, a, o) {
                                    for(var s = 2 * t1, l = s * r, c = l, u = r, h = e1, f = t1 + e1, p = r; n > p; ++p, l += s){
                                        var d = i[l + h], m = i[l + f];
                                        if (d < o && o <= m) {
                                            if (u === p) u += 1, c += s;
                                            else {
                                                for(var g = 0; s > g; ++g){
                                                    var y = i[l + g];
                                                    i[l + g] = i[c], i[c++] = y;
                                                }
                                                var v = a[p];
                                                a[p] = a[u], a[u++] = v;
                                            }
                                        }
                                    }
                                    return u;
                                },
                                "lo<=p0&&p0<=hi": function(t1, e1, r, n, i, a, o) {
                                    for(var s = 2 * t1, l = s * r, c = l, u = r, h = e1, f = t1 + e1, p = r; n > p; ++p, l += s){
                                        var d = i[l + h], m = i[l + f];
                                        if (d <= o && o <= m) {
                                            if (u === p) u += 1, c += s;
                                            else {
                                                for(var g = 0; s > g; ++g){
                                                    var y = i[l + g];
                                                    i[l + g] = i[c], i[c++] = y;
                                                }
                                                var v = a[p];
                                                a[p] = a[u], a[u++] = v;
                                            }
                                        }
                                    }
                                    return u;
                                },
                                "!(lo>=p0)&&!(p1>=hi)": function(t1, e1, r, n, i, a, o, s) {
                                    for(var l = 2 * t1, c = l * r, u = c, h = r, f = e1, p = t1 + e1, d = r; n > d; ++d, c += l){
                                        var m = i[c + f], g = i[c + p];
                                        if (!(m >= o || s >= g)) {
                                            if (h === d) h += 1, u += l;
                                            else {
                                                for(var y = 0; l > y; ++y){
                                                    var v = i[c + y];
                                                    i[c + y] = i[u], i[u++] = v;
                                                }
                                                var x = a[d];
                                                a[d] = a[h], a[h++] = x;
                                            }
                                        }
                                    }
                                    return h;
                                }
                            };
                        },
                        1811: function(t1) {
                            "use strict";
                            t1.exports = function(t1, n) {
                                n <= 4 * e1 ? r(0, n - 1, t1) : c(0, n - 1, t1);
                            };
                            var e1 = 32;
                            function r(t1, e1, r) {
                                for(var n = 2 * (t1 + 1), i = t1 + 1; i <= e1; ++i){
                                    for(var a = r[n++], o = r[n++], s = i, l = n - 2; s-- > t1;){
                                        var c = r[l - 2], u = r[l - 1];
                                        if (c < a) break;
                                        if (c === a && u < o) break;
                                        r[l] = c, r[l + 1] = u, l -= 2;
                                    }
                                    r[l] = a, r[l + 1] = o;
                                }
                            }
                            function n(t1, e1, r) {
                                e1 *= 2;
                                var n = r[t1 *= 2], i = r[t1 + 1];
                                r[t1] = r[e1], r[t1 + 1] = r[e1 + 1], r[e1] = n, r[e1 + 1] = i;
                            }
                            function i(t1, e1, r) {
                                e1 *= 2, r[t1 *= 2] = r[e1], r[t1 + 1] = r[e1 + 1];
                            }
                            function a(t1, e1, r, n) {
                                e1 *= 2, r *= 2;
                                var i = n[t1 *= 2], a = n[t1 + 1];
                                n[t1] = n[e1], n[t1 + 1] = n[e1 + 1], n[e1] = n[r], n[e1 + 1] = n[r + 1], n[r] = i, n[r + 1] = a;
                            }
                            function o(t1, e1, r, n, i) {
                                e1 *= 2, i[t1 *= 2] = i[e1], i[e1] = r, i[t1 + 1] = i[e1 + 1], i[e1 + 1] = n;
                            }
                            function s(t1, e1, r) {
                                e1 *= 2;
                                var n = r[t1 *= 2], i = r[e1];
                                return !(n < i) && (n !== i || r[t1 + 1] > r[e1 + 1]);
                            }
                            function l(t1, e1, r, n) {
                                var i = n[t1 *= 2];
                                return i < e1 || i === e1 && n[t1 + 1] < r;
                            }
                            function c(t1, u, h) {
                                var f = (u - t1 + 1) / 6 | 0, p = t1 + f, d = u - f, m = t1 + u >> 1, g = m - f, y = m + f, v = p, x = g, _ = m, b = y, w = d, T = t1 + 1, k = u - 1, A = 0;
                                s(v, x, h) && (A = v, v = x, x = A), s(b, w, h) && (A = b, b = w, w = A), s(v, _, h) && (A = v, v = _, _ = A), s(x, _, h) && (A = x, x = _, _ = A), s(v, b, h) && (A = v, v = b, b = A), s(_, b, h) && (A = _, _ = b, b = A), s(x, w, h) && (A = x, x = w, w = A), s(x, _, h) && (A = x, x = _, _ = A), s(b, w, h) && (A = b, b = w, w = A);
                                for(var M = h[2 * x], S = h[2 * x + 1], E = h[2 * b], C = h[2 * b + 1], L = 2 * v, I = 2 * _, P = 2 * w, z = 2 * p, O = 2 * m, D = 2 * d, R = 0; R < 2; ++R){
                                    var F = h[L + R], B = h[I + R], N = h[P + R];
                                    h[z + R] = F, h[O + R] = B, h[D + R] = N;
                                }
                                i(g, t1, h), i(y, u, h);
                                for(var j = T; j <= k; ++j)if (l(j, M, S, h)) j !== T && n(j, T, h), ++T;
                                else if (!l(j, E, C, h)) for(;;){
                                    if (l(k, E, C, h)) {
                                        l(k, M, S, h) ? (a(j, T, k, h), ++T, --k) : (n(j, k, h), --k);
                                        break;
                                    }
                                    if (--k < j) break;
                                }
                                o(t1, T - 1, M, S, h), o(u, k + 1, E, C, h), T - 2 - t1 <= e1 ? r(t1, T - 2, h) : c(t1, T - 2, h), u - (k + 2) <= e1 ? r(k + 2, u, h) : c(k + 2, u, h), k - T <= e1 ? r(T, k, h) : c(T, k, h);
                            }
                        },
                        855: function(t1, e1, r) {
                            "use strict";
                            t1.exports = {
                                init: function(t1) {
                                    var e1 = i.nextPow2(t1);
                                    l.length < e1 && (n.free(l), l = n.mallocInt32(e1)), c.length < e1 && (n.free(c), c = n.mallocInt32(e1)), u.length < e1 && (n.free(u), u = n.mallocInt32(e1)), h.length < e1 && (n.free(h), h = n.mallocInt32(e1)), f.length < e1 && (n.free(f), f = n.mallocInt32(e1)), p.length < e1 && (n.free(p), p = n.mallocInt32(e1));
                                    var r = 8 * e1;
                                    d.length < r && (n.free(d), d = n.mallocDouble(r));
                                },
                                sweepBipartite: function(t1, e1, r, n, i, s, f, p, y, v) {
                                    for(var x = 0, _ = 2 * t1, b = t1 - 1, w = _ - 1, T = r; T < n; ++T){
                                        var k = s[T], A = _ * T;
                                        d[x++] = i[A + b], d[x++] = -(k + 1), d[x++] = i[A + w], d[x++] = k;
                                    }
                                    for(T = f; T < p; ++T){
                                        k = v[T] + o;
                                        var M = _ * T;
                                        d[x++] = y[M + b], d[x++] = -k, d[x++] = y[M + w], d[x++] = k;
                                    }
                                    var S = x >>> 1;
                                    a(d, S);
                                    var E = 0, C = 0;
                                    for(T = 0; T < S; ++T){
                                        var L = 0 | d[2 * T + 1];
                                        if (L >= o) m(u, h, C--, L = L - o | 0);
                                        else if (L >= 0) m(l, c, E--, L);
                                        else if (L <= -o) {
                                            L = -L - o | 0;
                                            for(var I = 0; I < E; ++I)if (void 0 !== (P = e1(l[I], L))) return P;
                                            g(u, h, C++, L);
                                        } else {
                                            for(L = -L - 1 | 0, I = 0; I < C; ++I){
                                                var P;
                                                if (void 0 !== (P = e1(L, u[I]))) return P;
                                            }
                                            g(l, c, E++, L);
                                        }
                                    }
                                },
                                sweepComplete: function(t1, e1, r, n, i, o, s, y, v, x) {
                                    for(var _ = 0, b = 2 * t1, w = t1 - 1, T = b - 1, k = r; k < n; ++k){
                                        var A = o[k] + 1 << 1, M = b * k;
                                        d[_++] = i[M + w], d[_++] = -A, d[_++] = i[M + T], d[_++] = A;
                                    }
                                    for(k = s; k < y; ++k){
                                        A = x[k] + 1 << 1;
                                        var S = b * k;
                                        d[_++] = v[S + w], d[_++] = 1 | -A, d[_++] = v[S + T], d[_++] = 1 | A;
                                    }
                                    var E = _ >>> 1;
                                    a(d, E);
                                    var C = 0, L = 0, I = 0;
                                    for(k = 0; k < E; ++k){
                                        var P = 0 | d[2 * k + 1], z = 1 & P;
                                        if (k < E - 1 && P >> 1 == d[2 * k + 3] >> 1 && (z = 2, k += 1), P < 0) {
                                            for(var O = -(P >> 1) - 1, D = 0; D < I; ++D)if (void 0 !== (R = e1(f[D], O))) return R;
                                            if (0 !== z) {
                                                for(D = 0; D < C; ++D)if (void 0 !== (R = e1(l[D], O))) return R;
                                            }
                                            if (1 !== z) for(D = 0; D < L; ++D){
                                                var R;
                                                if (void 0 !== (R = e1(u[D], O))) return R;
                                            }
                                            0 === z ? g(l, c, C++, O) : 1 === z ? g(u, h, L++, O) : 2 === z && g(f, p, I++, O);
                                        } else O = (P >> 1) - 1, 0 === z ? m(l, c, C--, O) : 1 === z ? m(u, h, L--, O) : 2 === z && m(f, p, I--, O);
                                    }
                                },
                                scanBipartite: function(t1, e1, r, n, i, s, u, h, f, p, y, v) {
                                    var x = 0, _ = 2 * t1, b = e1, w = e1 + t1, T = 1, k = 1;
                                    n ? k = o : T = o;
                                    for(var A = i; A < s; ++A){
                                        var M = A + T, S = _ * A;
                                        d[x++] = u[S + b], d[x++] = -M, d[x++] = u[S + w], d[x++] = M;
                                    }
                                    for(A = f; A < p; ++A){
                                        M = A + k;
                                        var E = _ * A;
                                        d[x++] = y[E + b], d[x++] = -M;
                                    }
                                    var C = x >>> 1;
                                    a(d, C);
                                    var L = 0;
                                    for(A = 0; A < C; ++A){
                                        var I = 0 | d[2 * A + 1];
                                        if (I < 0) {
                                            var P = !1;
                                            if ((M = -I) >= o ? (P = !n, M -= o) : (P = !!n, M -= 1), P) g(l, c, L++, M);
                                            else {
                                                var z = v[M], O = _ * M, D = y[O + e1 + 1], R = y[O + e1 + 1 + t1];
                                                t: for(var F = 0; F < L; ++F){
                                                    var B = l[F], N = _ * B;
                                                    if (!(R < u[N + e1 + 1] || u[N + e1 + 1 + t1] < D)) {
                                                        for(var j = e1 + 2; j < t1; ++j)if (y[O + j + t1] < u[N + j] || u[N + j + t1] < y[O + j]) continue t;
                                                        var U, V = h[B];
                                                        if (void 0 !== (U = n ? r(z, V) : r(V, z))) return U;
                                                    }
                                                }
                                            }
                                        } else m(l, c, L--, I - T);
                                    }
                                },
                                scanComplete: function(t1, e1, r, n, i, s, c, u, h, f, p) {
                                    for(var m = 0, g = 2 * t1, y = e1, v = e1 + t1, x = n; x < i; ++x){
                                        var _ = x + o, b = g * x;
                                        d[m++] = s[b + y], d[m++] = -_, d[m++] = s[b + v], d[m++] = _;
                                    }
                                    for(x = u; x < h; ++x){
                                        _ = x + 1;
                                        var w = g * x;
                                        d[m++] = f[w + y], d[m++] = -_;
                                    }
                                    var T = m >>> 1;
                                    a(d, T);
                                    var k = 0;
                                    for(x = 0; x < T; ++x){
                                        var A = 0 | d[2 * x + 1];
                                        if (A < 0) {
                                            if ((_ = -A) >= o) l[k++] = _ - o;
                                            else {
                                                var M = p[_ -= 1], S = g * _, E = f[S + e1 + 1], C = f[S + e1 + 1 + t1];
                                                t: for(var L = 0; L < k; ++L){
                                                    var I = l[L], P = c[I];
                                                    if (P === M) break;
                                                    var z = g * I;
                                                    if (!(C < s[z + e1 + 1] || s[z + e1 + 1 + t1] < E)) {
                                                        for(var O = e1 + 2; O < t1; ++O)if (f[S + O + t1] < s[z + O] || s[z + O + t1] < f[S + O]) continue t;
                                                        var D = r(P, M);
                                                        if (void 0 !== D) return D;
                                                    }
                                                }
                                            }
                                        } else {
                                            for(_ = A - o, L = k - 1; L >= 0; --L)if (l[L] === _) {
                                                for(O = L + 1; O < k; ++O)l[O - 1] = l[O];
                                                break;
                                            }
                                            --k;
                                        }
                                    }
                                }
                            };
                            var n = r(1888), i = r(8828), a = r(1811), o = 268435456, s = 1024, l = n.mallocInt32(s), c = n.mallocInt32(s), u = n.mallocInt32(s), h = n.mallocInt32(s), f = n.mallocInt32(s), p = n.mallocInt32(s), d = n.mallocDouble(8192);
                            function m(t1, e1, r, n) {
                                var i = e1[n], a = t1[r - 1];
                                t1[i] = a, e1[a] = i;
                            }
                            function g(t1, e1, r, n) {
                                t1[r] = n, e1[n] = r;
                            }
                        },
                        2538: function(t1, e1, r) {
                            "use strict";
                            var n = r(8902), i = r(5542), a = r(2272), o = r(5023);
                            function s(t1) {
                                return [
                                    Math.min(t1[0], t1[1]),
                                    Math.max(t1[0], t1[1])
                                ];
                            }
                            function l(t1, e1) {
                                return t1[0] - e1[0] || t1[1] - e1[1];
                            }
                            function c(t1, e1, r) {
                                return e1 in t1 ? t1[e1] : r;
                            }
                            t1.exports = function(t1, e1, r) {
                                Array.isArray(e1) ? (r = r || {}, e1 = e1 || []) : (r = e1 || {}, e1 = []);
                                var u = !!c(r, "delaunay", !0), h = !!c(r, "interior", !0), f = !!c(r, "exterior", !0), p = !!c(r, "infinity", !1);
                                if (!h && !f || 0 === t1.length) return [];
                                var d = n(t1, e1);
                                if (u || h !== f || p) {
                                    for(var m = i(t1.length, function(t1) {
                                        return t1.map(s).sort(l);
                                    }(e1)), g = 0; g < d.length; ++g){
                                        var y = d[g];
                                        m.addTriangle(y[0], y[1], y[2]);
                                    }
                                    return u && a(t1, m), f ? h ? p ? o(m, 0, p) : m.cells() : o(m, 1, p) : o(m, -1);
                                }
                                return d;
                            };
                        },
                        2272: function(t1, e1, r) {
                            "use strict";
                            var n = r(2646)[4];
                            function i(t1, e1, r, i, a, o) {
                                var s = e1.opposite(i, a);
                                if (!(s < 0)) {
                                    if (a < i) {
                                        var l = i;
                                        i = a, a = l, l = o, o = s, s = l;
                                    }
                                    e1.isConstraint(i, a) || n(t1[i], t1[a], t1[o], t1[s]) < 0 && r.push(i, a);
                                }
                            }
                            r(2478), t1.exports = function(t1, e1) {
                                for(var r = [], a = t1.length, o = e1.stars, s = 0; s < a; ++s)for(var l = o[s], c = 1; c < l.length; c += 2)if (!((p = l[c]) < s || e1.isConstraint(s, p))) {
                                    for(var u = l[c - 1], h = -1, f = 1; f < l.length; f += 2)if (l[f - 1] === p) {
                                        h = l[f];
                                        break;
                                    }
                                    h < 0 || n(t1[s], t1[p], t1[u], t1[h]) < 0 && r.push(s, p);
                                }
                                for(; r.length > 0;){
                                    for(var p = r.pop(), d = (u = -1, h = -1, l = o[s = r.pop()], 1); d < l.length; d += 2){
                                        var m = l[d - 1], g = l[d];
                                        m === p ? h = g : g === p && (u = m);
                                    }
                                    u < 0 || h < 0 || n(t1[s], t1[p], t1[u], t1[h]) >= 0 || (e1.flip(s, p), i(t1, e1, r, u, s, h), i(t1, e1, r, s, h, u), i(t1, e1, r, h, p, u), i(t1, e1, r, p, u, h));
                                }
                            };
                        },
                        5023: function(t1, e1, r) {
                            "use strict";
                            var n, i = r(2478);
                            function a(t1, e1, r, n, i, a, o) {
                                this.cells = t1, this.neighbor = e1, this.flags = n, this.constraint = r, this.active = i, this.next = a, this.boundary = o;
                            }
                            function o(t1, e1) {
                                return t1[0] - e1[0] || t1[1] - e1[1] || t1[2] - e1[2];
                            }
                            t1.exports = function(t1, e1, r) {
                                var n = function(t1, e1) {
                                    for(var r = t1.cells(), n = r.length, i = 0; i < n; ++i){
                                        var s = (y = r[i])[0], l = y[1], c = y[2];
                                        l < c ? l < s && (y[0] = l, y[1] = c, y[2] = s) : c < s && (y[0] = c, y[1] = s, y[2] = l);
                                    }
                                    r.sort(o);
                                    var u = new Array(n);
                                    for(i = 0; i < u.length; ++i)u[i] = 0;
                                    var h = [], f = [], p = new Array(3 * n), d = new Array(3 * n), m = null;
                                    e1 && (m = []);
                                    var g = new a(r, p, d, u, h, f, m);
                                    for(i = 0; i < n; ++i)for(var y = r[i], v = 0; v < 3; ++v){
                                        s = y[v], l = y[(v + 1) % 3];
                                        var x = p[3 * i + v] = g.locate(l, s, t1.opposite(l, s)), _ = d[3 * i + v] = t1.isConstraint(s, l);
                                        x < 0 && (_ ? f.push(i) : (h.push(i), u[i] = 1), e1 && m.push([
                                            l,
                                            s,
                                            -1
                                        ]));
                                    }
                                    return g;
                                }(t1, r);
                                if (0 === e1) return r ? n.cells.concat(n.boundary) : n.cells;
                                for(var i = 1, s = n.active, l = n.next, c = n.flags, u = n.cells, h = n.constraint, f = n.neighbor; s.length > 0 || l.length > 0;){
                                    for(; s.length > 0;){
                                        var p = s.pop();
                                        if (c[p] !== -i) {
                                            c[p] = i, u[p];
                                            for(var d = 0; d < 3; ++d){
                                                var m = f[3 * p + d];
                                                m >= 0 && 0 === c[m] && (h[3 * p + d] ? l.push(m) : (s.push(m), c[m] = i));
                                            }
                                        }
                                    }
                                    var g = l;
                                    l = s, s = g, l.length = 0, i = -i;
                                }
                                var y = function(t1, e1, r) {
                                    for(var n = 0, i = 0; i < t1.length; ++i)e1[i] === r && (t1[n++] = t1[i]);
                                    return t1.length = n, t1;
                                }(u, c, e1);
                                return r ? y.concat(n.boundary) : y;
                            }, a.prototype.locate = (n = [
                                0,
                                0,
                                0
                            ], function(t1, e1, r) {
                                var a = t1, s = e1, l = r;
                                return e1 < r ? e1 < t1 && (a = e1, s = r, l = t1) : r < t1 && (a = r, s = t1, l = e1), a < 0 ? -1 : (n[0] = a, n[1] = s, n[2] = l, i.eq(this.cells, n, o));
                            });
                        },
                        8902: function(t1, e1, r) {
                            "use strict";
                            var n = r(2478), i = r(3250)[3];
                            function a(t1, e1, r, n, i) {
                                this.a = t1, this.b = e1, this.idx = r, this.lowerIds = n, this.upperIds = i;
                            }
                            function o(t1, e1, r, n) {
                                this.a = t1, this.b = e1, this.type = r, this.idx = n;
                            }
                            function s(t1, e1) {
                                var r = t1.a[0] - e1.a[0] || t1.a[1] - e1.a[1] || t1.type - e1.type;
                                return r || (0 !== t1.type && (r = i(t1.a, t1.b, e1.b)) ? r : t1.idx - e1.idx);
                            }
                            function l(t1, e1) {
                                return i(t1.a, t1.b, e1);
                            }
                            function c(t1, e1, r, a, o) {
                                for(var s = n.lt(e1, a, l), c = n.gt(e1, a, l), u = s; u < c; ++u){
                                    for(var h = e1[u], f = h.lowerIds, p = f.length; p > 1 && i(r[f[p - 2]], r[f[p - 1]], a) > 0;)t1.push([
                                        f[p - 1],
                                        f[p - 2],
                                        o
                                    ]), p -= 1;
                                    f.length = p, f.push(o);
                                    var d = h.upperIds;
                                    for(p = d.length; p > 1 && i(r[d[p - 2]], r[d[p - 1]], a) < 0;)t1.push([
                                        d[p - 2],
                                        d[p - 1],
                                        o
                                    ]), p -= 1;
                                    d.length = p, d.push(o);
                                }
                            }
                            function u(t1, e1) {
                                var r;
                                return (r = t1.a[0] < e1.a[0] ? i(t1.a, t1.b, e1.a) : i(e1.b, e1.a, t1.a)) ? r : (r = e1.b[0] < t1.b[0] ? i(t1.a, t1.b, e1.b) : i(e1.b, e1.a, t1.b)) || t1.idx - e1.idx;
                            }
                            function h(t1, e1, r) {
                                var i = n.le(t1, r, u), o = t1[i], s = o.upperIds, l = s[s.length - 1];
                                o.upperIds = [
                                    l
                                ], t1.splice(i + 1, 0, new a(r.a, r.b, r.idx, [
                                    l
                                ], s));
                            }
                            function f(t1, e1, r) {
                                var i = r.a;
                                r.a = r.b, r.b = i;
                                var a = n.eq(t1, r, u), o = t1[a];
                                t1[a - 1].upperIds = o.upperIds, t1.splice(a, 1);
                            }
                            t1.exports = function(t1, e1) {
                                for(var r = t1.length, n = e1.length, i = [], l = 0; l < r; ++l)i.push(new o(t1[l], null, 0, l));
                                for(l = 0; l < n; ++l){
                                    var u = e1[l], p = t1[u[0]], d = t1[u[1]];
                                    p[0] < d[0] ? i.push(new o(p, d, 2, l), new o(d, p, 1, l)) : p[0] > d[0] && i.push(new o(d, p, 2, l), new o(p, d, 1, l));
                                }
                                i.sort(s);
                                for(var m = i[0].a[0] - (1 + Math.abs(i[0].a[0])) * Math.pow(2, -52), g = [
                                    new a([
                                        m,
                                        1
                                    ], [
                                        m,
                                        0
                                    ], -1, [], [], [], [])
                                ], y = [], v = (l = 0, i.length); l < v; ++l){
                                    var x = i[l], _ = x.type;
                                    0 === _ ? c(y, g, t1, x.a, x.idx) : 2 === _ ? h(g, 0, x) : f(g, 0, x);
                                }
                                return y;
                            };
                        },
                        5542: function(t1, e1, r) {
                            "use strict";
                            var n = r(2478);
                            function i(t1, e1) {
                                this.stars = t1, this.edges = e1;
                            }
                            t1.exports = function(t1, e1) {
                                for(var r = new Array(t1), n = 0; n < t1; ++n)r[n] = [];
                                return new i(r, e1);
                            };
                            var a = i.prototype;
                            function o(t1, e1, r) {
                                for(var n = 1, i = t1.length; n < i; n += 2)if (t1[n - 1] === e1 && t1[n] === r) return t1[n - 1] = t1[i - 2], t1[n] = t1[i - 1], void (t1.length = i - 2);
                            }
                            a.isConstraint = function() {
                                var t1 = [
                                    0,
                                    0
                                ];
                                function e1(t1, e1) {
                                    return t1[0] - e1[0] || t1[1] - e1[1];
                                }
                                return function(r, i) {
                                    return t1[0] = Math.min(r, i), t1[1] = Math.max(r, i), n.eq(this.edges, t1, e1) >= 0;
                                };
                            }(), a.removeTriangle = function(t1, e1, r) {
                                var n = this.stars;
                                o(n[t1], e1, r), o(n[e1], r, t1), o(n[r], t1, e1);
                            }, a.addTriangle = function(t1, e1, r) {
                                var n = this.stars;
                                n[t1].push(e1, r), n[e1].push(r, t1), n[r].push(t1, e1);
                            }, a.opposite = function(t1, e1) {
                                for(var r = this.stars[e1], n = 1, i = r.length; n < i; n += 2)if (r[n] === t1) return r[n - 1];
                                return -1;
                            }, a.flip = function(t1, e1) {
                                var r = this.opposite(t1, e1), n = this.opposite(e1, t1);
                                this.removeTriangle(t1, e1, r), this.removeTriangle(e1, t1, n), this.addTriangle(t1, n, r), this.addTriangle(e1, r, n);
                            }, a.edges = function() {
                                for(var t1 = this.stars, e1 = [], r = 0, n = t1.length; r < n; ++r)for(var i = t1[r], a = 0, o = i.length; a < o; a += 2)e1.push([
                                    i[a],
                                    i[a + 1]
                                ]);
                                return e1;
                            }, a.cells = function() {
                                for(var t1 = this.stars, e1 = [], r = 0, n = t1.length; r < n; ++r)for(var i = t1[r], a = 0, o = i.length; a < o; a += 2){
                                    var s = i[a], l = i[a + 1];
                                    r < Math.min(s, l) && e1.push([
                                        r,
                                        s,
                                        l
                                    ]);
                                }
                                return e1;
                            };
                        },
                        2419: function(t1) {
                            "use strict";
                            t1.exports = function(t1) {
                                for(var e1 = 1, r = 1; r < t1.length; ++r)for(var n = 0; n < r; ++n)if (t1[r] < t1[n]) e1 = -e1;
                                else if (t1[n] === t1[r]) return 0;
                                return e1;
                            };
                        },
                        3628: function(t1, e1, r) {
                            "use strict";
                            var n = r(1338), i = r(727);
                            function a(t1, e1) {
                                for(var r = 0, n = t1.length, i = 0; i < n; ++i)r += t1[i] * e1[i];
                                return r;
                            }
                            function o(t1) {
                                var e1 = t1.length;
                                if (0 === e1) return [];
                                t1[0].length;
                                var r = n([
                                    t1.length + 1,
                                    t1.length + 1
                                ], 1), o = n([
                                    t1.length + 1
                                ], 1);
                                r[e1][e1] = 0;
                                for(var s = 0; s < e1; ++s){
                                    for(var l = 0; l <= s; ++l)r[l][s] = r[s][l] = 2 * a(t1[s], t1[l]);
                                    o[s] = a(t1[s], t1[s]);
                                }
                                var c = i(r, o), u = 0, h = c[e1 + 1];
                                for(s = 0; s < h.length; ++s)u += h[s];
                                var f = new Array(e1);
                                for(s = 0; s < e1; ++s){
                                    h = c[s];
                                    var p = 0;
                                    for(l = 0; l < h.length; ++l)p += h[l];
                                    f[s] = p / u;
                                }
                                return f;
                            }
                            function s(t1) {
                                if (0 === t1.length) return [];
                                for(var e1 = t1[0].length, r = n([
                                    e1
                                ]), i = o(t1), a = 0; a < t1.length; ++a)for(var s = 0; s < e1; ++s)r[s] += t1[a][s] * i[a];
                                return r;
                            }
                            s.barycenetric = o, t1.exports = s;
                        },
                        6037: function(t1, e1, r) {
                            t1.exports = function(t1) {
                                for(var e1 = n(t1), r = 0, i = 0; i < t1.length; ++i)for(var a = t1[i], o = 0; o < e1.length; ++o)r += Math.pow(a[o] - e1[o], 2);
                                return Math.sqrt(r / t1.length);
                            };
                            var n = r(3628);
                        },
                        332: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1, r) {
                                var n;
                                if (r) {
                                    n = e1;
                                    for(var i = new Array(e1.length), a = 0; a < e1.length; ++a){
                                        var o = e1[a];
                                        i[a] = [
                                            o[0],
                                            o[1],
                                            r[a]
                                        ];
                                    }
                                    e1 = i;
                                }
                                for(var s = function(t1, e1, r) {
                                    var n = d(t1, [], p(t1));
                                    return y(e1, n, r), !!n;
                                }(t1, e1, !!r); v(t1, e1, !!r);)s = !0;
                                if (r && s) for(n.length = 0, r.length = 0, a = 0; a < e1.length; ++a)o = e1[a], n.push([
                                    o[0],
                                    o[1]
                                ]), r.push(o[2]);
                                return s;
                            };
                            var n = r(1755), i = r(6867), a = r(1125), o = r(7842), s = r(1318), l = r(946), c = r(5838), u = r(1278), h = r(3637);
                            function f(t1) {
                                var e1 = l(t1);
                                return [
                                    u(e1, -1 / 0),
                                    u(e1, 1 / 0)
                                ];
                            }
                            function p(t1) {
                                for(var e1 = new Array(t1.length), r = 0; r < t1.length; ++r){
                                    var n = t1[r];
                                    e1[r] = [
                                        u(n[0], -1 / 0),
                                        u(n[1], -1 / 0),
                                        u(n[0], 1 / 0),
                                        u(n[1], 1 / 0)
                                    ];
                                }
                                return e1;
                            }
                            function d(t1, e1, r) {
                                for(var a = e1.length, o = new n(a), s = [], l = 0; l < e1.length; ++l){
                                    var c = e1[l], h = f(c[0]), p = f(c[1]);
                                    s.push([
                                        u(h[0], -1 / 0),
                                        u(p[0], -1 / 0),
                                        u(h[1], 1 / 0),
                                        u(p[1], 1 / 0)
                                    ]);
                                }
                                i(s, function(t1, e1) {
                                    o.link(t1, e1);
                                });
                                var d = !0, m = new Array(a);
                                for(l = 0; l < a; ++l)(y = o.find(l)) !== l && (d = !1, t1[y] = [
                                    Math.min(t1[l][0], t1[y][0]),
                                    Math.min(t1[l][1], t1[y][1])
                                ]);
                                if (d) return null;
                                var g = 0;
                                for(l = 0; l < a; ++l){
                                    var y;
                                    (y = o.find(l)) === l ? (m[l] = g, t1[g++] = t1[l]) : m[l] = -1;
                                }
                                for(t1.length = g, l = 0; l < a; ++l)m[l] < 0 && (m[l] = m[o.find(l)]);
                                return m;
                            }
                            function m(t1, e1) {
                                return t1[0] - e1[0] || t1[1] - e1[1];
                            }
                            function g(t1, e1) {
                                return t1[0] - e1[0] || t1[1] - e1[1] || (t1[2] < e1[2] ? -1 : t1[2] > e1[2] ? 1 : 0);
                            }
                            function y(t1, e1, r) {
                                if (0 !== t1.length) {
                                    if (e1) for(var n = 0; n < t1.length; ++n){
                                        var i = e1[(o = t1[n])[0]], a = e1[o[1]];
                                        o[0] = Math.min(i, a), o[1] = Math.max(i, a);
                                    }
                                    else for(n = 0; n < t1.length; ++n){
                                        var o;
                                        i = (o = t1[n])[0], a = o[1], o[0] = Math.min(i, a), o[1] = Math.max(i, a);
                                    }
                                    r ? t1.sort(g) : t1.sort(m);
                                    var s = 1;
                                    for(n = 1; n < t1.length; ++n){
                                        var l = t1[n - 1], c = t1[n];
                                        (c[0] !== l[0] || c[1] !== l[1] || r && c[2] !== l[2]) && (t1[s++] = c);
                                    }
                                    t1.length = s;
                                }
                            }
                            function v(t1, e1, r) {
                                var n = function(t1, e1) {
                                    for(var r = new Array(e1.length), n = 0; n < e1.length; ++n){
                                        var i = e1[n], a = t1[i[0]], o = t1[i[1]];
                                        r[n] = [
                                            u(Math.min(a[0], o[0]), -1 / 0),
                                            u(Math.min(a[1], o[1]), -1 / 0),
                                            u(Math.max(a[0], o[0]), 1 / 0),
                                            u(Math.max(a[1], o[1]), 1 / 0)
                                        ];
                                    }
                                    return r;
                                }(t1, e1), f = function(t1, e1, r) {
                                    var n = [];
                                    return i(r, function(r, i) {
                                        var o = e1[r], s = e1[i];
                                        if (o[0] !== s[0] && o[0] !== s[1] && o[1] !== s[0] && o[1] !== s[1]) {
                                            var l = t1[o[0]], c = t1[o[1]], u = t1[s[0]], h = t1[s[1]];
                                            a(l, c, u, h) && n.push([
                                                r,
                                                i
                                            ]);
                                        }
                                    }), n;
                                }(t1, e1, n), m = function(t1, e1, r, n) {
                                    var o = [];
                                    return i(r, n, function(r, n) {
                                        var i = e1[r];
                                        if (i[0] !== n && i[1] !== n) {
                                            var s = t1[n], l = t1[i[0]], c = t1[i[1]];
                                            a(l, c, s, s) && o.push([
                                                r,
                                                n
                                            ]);
                                        }
                                    }), o;
                                }(t1, e1, n, p(t1)), g = function(t1, e1, r, n, i) {
                                    var a, u, f = t1.map(function(t1) {
                                        return [
                                            o(t1[0]),
                                            o(t1[1])
                                        ];
                                    });
                                    for(a = 0; a < r.length; ++a){
                                        var p = r[a];
                                        u = p[0];
                                        var d = p[1], m = e1[u], g = e1[d], y = h(c(t1[m[0]]), c(t1[m[1]]), c(t1[g[0]]), c(t1[g[1]]));
                                        if (y) {
                                            var v = t1.length;
                                            t1.push([
                                                l(y[0]),
                                                l(y[1])
                                            ]), f.push(y), n.push([
                                                u,
                                                v
                                            ], [
                                                d,
                                                v
                                            ]);
                                        }
                                    }
                                    for(n.sort(function(t1, e1) {
                                        if (t1[0] !== e1[0]) return t1[0] - e1[0];
                                        var r = f[t1[1]], n = f[e1[1]];
                                        return s(r[0], n[0]) || s(r[1], n[1]);
                                    }), a = n.length - 1; a >= 0; --a){
                                        var x = e1[u = (S = n[a])[0]], _ = x[0], b = x[1], w = t1[_], T = t1[b];
                                        if ((w[0] - T[0] || w[1] - T[1]) < 0) {
                                            var k = _;
                                            _ = b, b = k;
                                        }
                                        x[0] = _;
                                        var A, M = x[1] = S[1];
                                        for(i && (A = x[2]); a > 0 && n[a - 1][0] === u;){
                                            var S, E = (S = n[--a])[1];
                                            i ? e1.push([
                                                M,
                                                E,
                                                A
                                            ]) : e1.push([
                                                M,
                                                E
                                            ]), M = E;
                                        }
                                        i ? e1.push([
                                            M,
                                            b,
                                            A
                                        ]) : e1.push([
                                            M,
                                            b
                                        ]);
                                    }
                                    return f;
                                }(t1, e1, f, m, r), v = d(t1, g);
                                return y(e1, v, r), !!v || f.length > 0 || m.length > 0;
                            }
                        },
                        3637: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1, r, n) {
                                var a = s(e1, t1), h = s(n, r), f = u(a, h);
                                if (0 === o(f)) return null;
                                var p = u(h, s(t1, r)), d = i(p, f), m = c(a, d);
                                return l(t1, m);
                            };
                            var n = r(6504), i = r(8697), a = r(5572), o = r(7721), s = r(544), l = r(2653), c = r(8987);
                            function u(t1, e1) {
                                return a(n(t1[0], e1[1]), n(t1[1], e1[0]));
                            }
                        },
                        3642: function(t1) {
                            t1.exports = {
                                jet: [
                                    {
                                        index: 0,
                                        rgb: [
                                            0,
                                            0,
                                            131
                                        ]
                                    },
                                    {
                                        index: .125,
                                        rgb: [
                                            0,
                                            60,
                                            170
                                        ]
                                    },
                                    {
                                        index: .375,
                                        rgb: [
                                            5,
                                            255,
                                            255
                                        ]
                                    },
                                    {
                                        index: .625,
                                        rgb: [
                                            255,
                                            255,
                                            0
                                        ]
                                    },
                                    {
                                        index: .875,
                                        rgb: [
                                            250,
                                            0,
                                            0
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            128,
                                            0,
                                            0
                                        ]
                                    }
                                ],
                                hsv: [
                                    {
                                        index: 0,
                                        rgb: [
                                            255,
                                            0,
                                            0
                                        ]
                                    },
                                    {
                                        index: .169,
                                        rgb: [
                                            253,
                                            255,
                                            2
                                        ]
                                    },
                                    {
                                        index: .173,
                                        rgb: [
                                            247,
                                            255,
                                            2
                                        ]
                                    },
                                    {
                                        index: .337,
                                        rgb: [
                                            0,
                                            252,
                                            4
                                        ]
                                    },
                                    {
                                        index: .341,
                                        rgb: [
                                            0,
                                            252,
                                            10
                                        ]
                                    },
                                    {
                                        index: .506,
                                        rgb: [
                                            1,
                                            249,
                                            255
                                        ]
                                    },
                                    {
                                        index: .671,
                                        rgb: [
                                            2,
                                            0,
                                            253
                                        ]
                                    },
                                    {
                                        index: .675,
                                        rgb: [
                                            8,
                                            0,
                                            253
                                        ]
                                    },
                                    {
                                        index: .839,
                                        rgb: [
                                            255,
                                            0,
                                            251
                                        ]
                                    },
                                    {
                                        index: .843,
                                        rgb: [
                                            255,
                                            0,
                                            245
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            255,
                                            0,
                                            6
                                        ]
                                    }
                                ],
                                hot: [
                                    {
                                        index: 0,
                                        rgb: [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    {
                                        index: .3,
                                        rgb: [
                                            230,
                                            0,
                                            0
                                        ]
                                    },
                                    {
                                        index: .6,
                                        rgb: [
                                            255,
                                            210,
                                            0
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            255,
                                            255,
                                            255
                                        ]
                                    }
                                ],
                                spring: [
                                    {
                                        index: 0,
                                        rgb: [
                                            255,
                                            0,
                                            255
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            255,
                                            255,
                                            0
                                        ]
                                    }
                                ],
                                summer: [
                                    {
                                        index: 0,
                                        rgb: [
                                            0,
                                            128,
                                            102
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            255,
                                            255,
                                            102
                                        ]
                                    }
                                ],
                                autumn: [
                                    {
                                        index: 0,
                                        rgb: [
                                            255,
                                            0,
                                            0
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            255,
                                            255,
                                            0
                                        ]
                                    }
                                ],
                                winter: [
                                    {
                                        index: 0,
                                        rgb: [
                                            0,
                                            0,
                                            255
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            0,
                                            255,
                                            128
                                        ]
                                    }
                                ],
                                bone: [
                                    {
                                        index: 0,
                                        rgb: [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    {
                                        index: .376,
                                        rgb: [
                                            84,
                                            84,
                                            116
                                        ]
                                    },
                                    {
                                        index: .753,
                                        rgb: [
                                            169,
                                            200,
                                            200
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            255,
                                            255,
                                            255
                                        ]
                                    }
                                ],
                                copper: [
                                    {
                                        index: 0,
                                        rgb: [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    {
                                        index: .804,
                                        rgb: [
                                            255,
                                            160,
                                            102
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            255,
                                            199,
                                            127
                                        ]
                                    }
                                ],
                                greys: [
                                    {
                                        index: 0,
                                        rgb: [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            255,
                                            255,
                                            255
                                        ]
                                    }
                                ],
                                yignbu: [
                                    {
                                        index: 0,
                                        rgb: [
                                            8,
                                            29,
                                            88
                                        ]
                                    },
                                    {
                                        index: .125,
                                        rgb: [
                                            37,
                                            52,
                                            148
                                        ]
                                    },
                                    {
                                        index: .25,
                                        rgb: [
                                            34,
                                            94,
                                            168
                                        ]
                                    },
                                    {
                                        index: .375,
                                        rgb: [
                                            29,
                                            145,
                                            192
                                        ]
                                    },
                                    {
                                        index: .5,
                                        rgb: [
                                            65,
                                            182,
                                            196
                                        ]
                                    },
                                    {
                                        index: .625,
                                        rgb: [
                                            127,
                                            205,
                                            187
                                        ]
                                    },
                                    {
                                        index: .75,
                                        rgb: [
                                            199,
                                            233,
                                            180
                                        ]
                                    },
                                    {
                                        index: .875,
                                        rgb: [
                                            237,
                                            248,
                                            217
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            255,
                                            255,
                                            217
                                        ]
                                    }
                                ],
                                greens: [
                                    {
                                        index: 0,
                                        rgb: [
                                            0,
                                            68,
                                            27
                                        ]
                                    },
                                    {
                                        index: .125,
                                        rgb: [
                                            0,
                                            109,
                                            44
                                        ]
                                    },
                                    {
                                        index: .25,
                                        rgb: [
                                            35,
                                            139,
                                            69
                                        ]
                                    },
                                    {
                                        index: .375,
                                        rgb: [
                                            65,
                                            171,
                                            93
                                        ]
                                    },
                                    {
                                        index: .5,
                                        rgb: [
                                            116,
                                            196,
                                            118
                                        ]
                                    },
                                    {
                                        index: .625,
                                        rgb: [
                                            161,
                                            217,
                                            155
                                        ]
                                    },
                                    {
                                        index: .75,
                                        rgb: [
                                            199,
                                            233,
                                            192
                                        ]
                                    },
                                    {
                                        index: .875,
                                        rgb: [
                                            229,
                                            245,
                                            224
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            247,
                                            252,
                                            245
                                        ]
                                    }
                                ],
                                yiorrd: [
                                    {
                                        index: 0,
                                        rgb: [
                                            128,
                                            0,
                                            38
                                        ]
                                    },
                                    {
                                        index: .125,
                                        rgb: [
                                            189,
                                            0,
                                            38
                                        ]
                                    },
                                    {
                                        index: .25,
                                        rgb: [
                                            227,
                                            26,
                                            28
                                        ]
                                    },
                                    {
                                        index: .375,
                                        rgb: [
                                            252,
                                            78,
                                            42
                                        ]
                                    },
                                    {
                                        index: .5,
                                        rgb: [
                                            253,
                                            141,
                                            60
                                        ]
                                    },
                                    {
                                        index: .625,
                                        rgb: [
                                            254,
                                            178,
                                            76
                                        ]
                                    },
                                    {
                                        index: .75,
                                        rgb: [
                                            254,
                                            217,
                                            118
                                        ]
                                    },
                                    {
                                        index: .875,
                                        rgb: [
                                            255,
                                            237,
                                            160
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            255,
                                            255,
                                            204
                                        ]
                                    }
                                ],
                                bluered: [
                                    {
                                        index: 0,
                                        rgb: [
                                            0,
                                            0,
                                            255
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            255,
                                            0,
                                            0
                                        ]
                                    }
                                ],
                                rdbu: [
                                    {
                                        index: 0,
                                        rgb: [
                                            5,
                                            10,
                                            172
                                        ]
                                    },
                                    {
                                        index: .35,
                                        rgb: [
                                            106,
                                            137,
                                            247
                                        ]
                                    },
                                    {
                                        index: .5,
                                        rgb: [
                                            190,
                                            190,
                                            190
                                        ]
                                    },
                                    {
                                        index: .6,
                                        rgb: [
                                            220,
                                            170,
                                            132
                                        ]
                                    },
                                    {
                                        index: .7,
                                        rgb: [
                                            230,
                                            145,
                                            90
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            178,
                                            10,
                                            28
                                        ]
                                    }
                                ],
                                picnic: [
                                    {
                                        index: 0,
                                        rgb: [
                                            0,
                                            0,
                                            255
                                        ]
                                    },
                                    {
                                        index: .1,
                                        rgb: [
                                            51,
                                            153,
                                            255
                                        ]
                                    },
                                    {
                                        index: .2,
                                        rgb: [
                                            102,
                                            204,
                                            255
                                        ]
                                    },
                                    {
                                        index: .3,
                                        rgb: [
                                            153,
                                            204,
                                            255
                                        ]
                                    },
                                    {
                                        index: .4,
                                        rgb: [
                                            204,
                                            204,
                                            255
                                        ]
                                    },
                                    {
                                        index: .5,
                                        rgb: [
                                            255,
                                            255,
                                            255
                                        ]
                                    },
                                    {
                                        index: .6,
                                        rgb: [
                                            255,
                                            204,
                                            255
                                        ]
                                    },
                                    {
                                        index: .7,
                                        rgb: [
                                            255,
                                            153,
                                            255
                                        ]
                                    },
                                    {
                                        index: .8,
                                        rgb: [
                                            255,
                                            102,
                                            204
                                        ]
                                    },
                                    {
                                        index: .9,
                                        rgb: [
                                            255,
                                            102,
                                            102
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            255,
                                            0,
                                            0
                                        ]
                                    }
                                ],
                                rainbow: [
                                    {
                                        index: 0,
                                        rgb: [
                                            150,
                                            0,
                                            90
                                        ]
                                    },
                                    {
                                        index: .125,
                                        rgb: [
                                            0,
                                            0,
                                            200
                                        ]
                                    },
                                    {
                                        index: .25,
                                        rgb: [
                                            0,
                                            25,
                                            255
                                        ]
                                    },
                                    {
                                        index: .375,
                                        rgb: [
                                            0,
                                            152,
                                            255
                                        ]
                                    },
                                    {
                                        index: .5,
                                        rgb: [
                                            44,
                                            255,
                                            150
                                        ]
                                    },
                                    {
                                        index: .625,
                                        rgb: [
                                            151,
                                            255,
                                            0
                                        ]
                                    },
                                    {
                                        index: .75,
                                        rgb: [
                                            255,
                                            234,
                                            0
                                        ]
                                    },
                                    {
                                        index: .875,
                                        rgb: [
                                            255,
                                            111,
                                            0
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            255,
                                            0,
                                            0
                                        ]
                                    }
                                ],
                                portland: [
                                    {
                                        index: 0,
                                        rgb: [
                                            12,
                                            51,
                                            131
                                        ]
                                    },
                                    {
                                        index: .25,
                                        rgb: [
                                            10,
                                            136,
                                            186
                                        ]
                                    },
                                    {
                                        index: .5,
                                        rgb: [
                                            242,
                                            211,
                                            56
                                        ]
                                    },
                                    {
                                        index: .75,
                                        rgb: [
                                            242,
                                            143,
                                            56
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            217,
                                            30,
                                            30
                                        ]
                                    }
                                ],
                                blackbody: [
                                    {
                                        index: 0,
                                        rgb: [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    {
                                        index: .2,
                                        rgb: [
                                            230,
                                            0,
                                            0
                                        ]
                                    },
                                    {
                                        index: .4,
                                        rgb: [
                                            230,
                                            210,
                                            0
                                        ]
                                    },
                                    {
                                        index: .7,
                                        rgb: [
                                            255,
                                            255,
                                            255
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            160,
                                            200,
                                            255
                                        ]
                                    }
                                ],
                                earth: [
                                    {
                                        index: 0,
                                        rgb: [
                                            0,
                                            0,
                                            130
                                        ]
                                    },
                                    {
                                        index: .1,
                                        rgb: [
                                            0,
                                            180,
                                            180
                                        ]
                                    },
                                    {
                                        index: .2,
                                        rgb: [
                                            40,
                                            210,
                                            40
                                        ]
                                    },
                                    {
                                        index: .4,
                                        rgb: [
                                            230,
                                            230,
                                            50
                                        ]
                                    },
                                    {
                                        index: .6,
                                        rgb: [
                                            120,
                                            70,
                                            20
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            255,
                                            255,
                                            255
                                        ]
                                    }
                                ],
                                electric: [
                                    {
                                        index: 0,
                                        rgb: [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    {
                                        index: .15,
                                        rgb: [
                                            30,
                                            0,
                                            100
                                        ]
                                    },
                                    {
                                        index: .4,
                                        rgb: [
                                            120,
                                            0,
                                            100
                                        ]
                                    },
                                    {
                                        index: .6,
                                        rgb: [
                                            160,
                                            90,
                                            0
                                        ]
                                    },
                                    {
                                        index: .8,
                                        rgb: [
                                            230,
                                            200,
                                            0
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            255,
                                            250,
                                            220
                                        ]
                                    }
                                ],
                                alpha: [
                                    {
                                        index: 0,
                                        rgb: [
                                            255,
                                            255,
                                            255,
                                            0
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            255,
                                            255,
                                            255,
                                            1
                                        ]
                                    }
                                ],
                                viridis: [
                                    {
                                        index: 0,
                                        rgb: [
                                            68,
                                            1,
                                            84
                                        ]
                                    },
                                    {
                                        index: .13,
                                        rgb: [
                                            71,
                                            44,
                                            122
                                        ]
                                    },
                                    {
                                        index: .25,
                                        rgb: [
                                            59,
                                            81,
                                            139
                                        ]
                                    },
                                    {
                                        index: .38,
                                        rgb: [
                                            44,
                                            113,
                                            142
                                        ]
                                    },
                                    {
                                        index: .5,
                                        rgb: [
                                            33,
                                            144,
                                            141
                                        ]
                                    },
                                    {
                                        index: .63,
                                        rgb: [
                                            39,
                                            173,
                                            129
                                        ]
                                    },
                                    {
                                        index: .75,
                                        rgb: [
                                            92,
                                            200,
                                            99
                                        ]
                                    },
                                    {
                                        index: .88,
                                        rgb: [
                                            170,
                                            220,
                                            50
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            253,
                                            231,
                                            37
                                        ]
                                    }
                                ],
                                inferno: [
                                    {
                                        index: 0,
                                        rgb: [
                                            0,
                                            0,
                                            4
                                        ]
                                    },
                                    {
                                        index: .13,
                                        rgb: [
                                            31,
                                            12,
                                            72
                                        ]
                                    },
                                    {
                                        index: .25,
                                        rgb: [
                                            85,
                                            15,
                                            109
                                        ]
                                    },
                                    {
                                        index: .38,
                                        rgb: [
                                            136,
                                            34,
                                            106
                                        ]
                                    },
                                    {
                                        index: .5,
                                        rgb: [
                                            186,
                                            54,
                                            85
                                        ]
                                    },
                                    {
                                        index: .63,
                                        rgb: [
                                            227,
                                            89,
                                            51
                                        ]
                                    },
                                    {
                                        index: .75,
                                        rgb: [
                                            249,
                                            140,
                                            10
                                        ]
                                    },
                                    {
                                        index: .88,
                                        rgb: [
                                            249,
                                            201,
                                            50
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            252,
                                            255,
                                            164
                                        ]
                                    }
                                ],
                                magma: [
                                    {
                                        index: 0,
                                        rgb: [
                                            0,
                                            0,
                                            4
                                        ]
                                    },
                                    {
                                        index: .13,
                                        rgb: [
                                            28,
                                            16,
                                            68
                                        ]
                                    },
                                    {
                                        index: .25,
                                        rgb: [
                                            79,
                                            18,
                                            123
                                        ]
                                    },
                                    {
                                        index: .38,
                                        rgb: [
                                            129,
                                            37,
                                            129
                                        ]
                                    },
                                    {
                                        index: .5,
                                        rgb: [
                                            181,
                                            54,
                                            122
                                        ]
                                    },
                                    {
                                        index: .63,
                                        rgb: [
                                            229,
                                            80,
                                            100
                                        ]
                                    },
                                    {
                                        index: .75,
                                        rgb: [
                                            251,
                                            135,
                                            97
                                        ]
                                    },
                                    {
                                        index: .88,
                                        rgb: [
                                            254,
                                            194,
                                            135
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            252,
                                            253,
                                            191
                                        ]
                                    }
                                ],
                                plasma: [
                                    {
                                        index: 0,
                                        rgb: [
                                            13,
                                            8,
                                            135
                                        ]
                                    },
                                    {
                                        index: .13,
                                        rgb: [
                                            75,
                                            3,
                                            161
                                        ]
                                    },
                                    {
                                        index: .25,
                                        rgb: [
                                            125,
                                            3,
                                            168
                                        ]
                                    },
                                    {
                                        index: .38,
                                        rgb: [
                                            168,
                                            34,
                                            150
                                        ]
                                    },
                                    {
                                        index: .5,
                                        rgb: [
                                            203,
                                            70,
                                            121
                                        ]
                                    },
                                    {
                                        index: .63,
                                        rgb: [
                                            229,
                                            107,
                                            93
                                        ]
                                    },
                                    {
                                        index: .75,
                                        rgb: [
                                            248,
                                            148,
                                            65
                                        ]
                                    },
                                    {
                                        index: .88,
                                        rgb: [
                                            253,
                                            195,
                                            40
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            240,
                                            249,
                                            33
                                        ]
                                    }
                                ],
                                warm: [
                                    {
                                        index: 0,
                                        rgb: [
                                            125,
                                            0,
                                            179
                                        ]
                                    },
                                    {
                                        index: .13,
                                        rgb: [
                                            172,
                                            0,
                                            187
                                        ]
                                    },
                                    {
                                        index: .25,
                                        rgb: [
                                            219,
                                            0,
                                            170
                                        ]
                                    },
                                    {
                                        index: .38,
                                        rgb: [
                                            255,
                                            0,
                                            130
                                        ]
                                    },
                                    {
                                        index: .5,
                                        rgb: [
                                            255,
                                            63,
                                            74
                                        ]
                                    },
                                    {
                                        index: .63,
                                        rgb: [
                                            255,
                                            123,
                                            0
                                        ]
                                    },
                                    {
                                        index: .75,
                                        rgb: [
                                            234,
                                            176,
                                            0
                                        ]
                                    },
                                    {
                                        index: .88,
                                        rgb: [
                                            190,
                                            228,
                                            0
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            147,
                                            255,
                                            0
                                        ]
                                    }
                                ],
                                cool: [
                                    {
                                        index: 0,
                                        rgb: [
                                            125,
                                            0,
                                            179
                                        ]
                                    },
                                    {
                                        index: .13,
                                        rgb: [
                                            116,
                                            0,
                                            218
                                        ]
                                    },
                                    {
                                        index: .25,
                                        rgb: [
                                            98,
                                            74,
                                            237
                                        ]
                                    },
                                    {
                                        index: .38,
                                        rgb: [
                                            68,
                                            146,
                                            231
                                        ]
                                    },
                                    {
                                        index: .5,
                                        rgb: [
                                            0,
                                            204,
                                            197
                                        ]
                                    },
                                    {
                                        index: .63,
                                        rgb: [
                                            0,
                                            247,
                                            146
                                        ]
                                    },
                                    {
                                        index: .75,
                                        rgb: [
                                            0,
                                            255,
                                            88
                                        ]
                                    },
                                    {
                                        index: .88,
                                        rgb: [
                                            40,
                                            255,
                                            8
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            147,
                                            255,
                                            0
                                        ]
                                    }
                                ],
                                "rainbow-soft": [
                                    {
                                        index: 0,
                                        rgb: [
                                            125,
                                            0,
                                            179
                                        ]
                                    },
                                    {
                                        index: .1,
                                        rgb: [
                                            199,
                                            0,
                                            180
                                        ]
                                    },
                                    {
                                        index: .2,
                                        rgb: [
                                            255,
                                            0,
                                            121
                                        ]
                                    },
                                    {
                                        index: .3,
                                        rgb: [
                                            255,
                                            108,
                                            0
                                        ]
                                    },
                                    {
                                        index: .4,
                                        rgb: [
                                            222,
                                            194,
                                            0
                                        ]
                                    },
                                    {
                                        index: .5,
                                        rgb: [
                                            150,
                                            255,
                                            0
                                        ]
                                    },
                                    {
                                        index: .6,
                                        rgb: [
                                            0,
                                            255,
                                            55
                                        ]
                                    },
                                    {
                                        index: .7,
                                        rgb: [
                                            0,
                                            246,
                                            150
                                        ]
                                    },
                                    {
                                        index: .8,
                                        rgb: [
                                            50,
                                            167,
                                            222
                                        ]
                                    },
                                    {
                                        index: .9,
                                        rgb: [
                                            103,
                                            51,
                                            235
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            124,
                                            0,
                                            186
                                        ]
                                    }
                                ],
                                bathymetry: [
                                    {
                                        index: 0,
                                        rgb: [
                                            40,
                                            26,
                                            44
                                        ]
                                    },
                                    {
                                        index: .13,
                                        rgb: [
                                            59,
                                            49,
                                            90
                                        ]
                                    },
                                    {
                                        index: .25,
                                        rgb: [
                                            64,
                                            76,
                                            139
                                        ]
                                    },
                                    {
                                        index: .38,
                                        rgb: [
                                            63,
                                            110,
                                            151
                                        ]
                                    },
                                    {
                                        index: .5,
                                        rgb: [
                                            72,
                                            142,
                                            158
                                        ]
                                    },
                                    {
                                        index: .63,
                                        rgb: [
                                            85,
                                            174,
                                            163
                                        ]
                                    },
                                    {
                                        index: .75,
                                        rgb: [
                                            120,
                                            206,
                                            163
                                        ]
                                    },
                                    {
                                        index: .88,
                                        rgb: [
                                            187,
                                            230,
                                            172
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            253,
                                            254,
                                            204
                                        ]
                                    }
                                ],
                                cdom: [
                                    {
                                        index: 0,
                                        rgb: [
                                            47,
                                            15,
                                            62
                                        ]
                                    },
                                    {
                                        index: .13,
                                        rgb: [
                                            87,
                                            23,
                                            86
                                        ]
                                    },
                                    {
                                        index: .25,
                                        rgb: [
                                            130,
                                            28,
                                            99
                                        ]
                                    },
                                    {
                                        index: .38,
                                        rgb: [
                                            171,
                                            41,
                                            96
                                        ]
                                    },
                                    {
                                        index: .5,
                                        rgb: [
                                            206,
                                            67,
                                            86
                                        ]
                                    },
                                    {
                                        index: .63,
                                        rgb: [
                                            230,
                                            106,
                                            84
                                        ]
                                    },
                                    {
                                        index: .75,
                                        rgb: [
                                            242,
                                            149,
                                            103
                                        ]
                                    },
                                    {
                                        index: .88,
                                        rgb: [
                                            249,
                                            193,
                                            135
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            254,
                                            237,
                                            176
                                        ]
                                    }
                                ],
                                chlorophyll: [
                                    {
                                        index: 0,
                                        rgb: [
                                            18,
                                            36,
                                            20
                                        ]
                                    },
                                    {
                                        index: .13,
                                        rgb: [
                                            25,
                                            63,
                                            41
                                        ]
                                    },
                                    {
                                        index: .25,
                                        rgb: [
                                            24,
                                            91,
                                            59
                                        ]
                                    },
                                    {
                                        index: .38,
                                        rgb: [
                                            13,
                                            119,
                                            72
                                        ]
                                    },
                                    {
                                        index: .5,
                                        rgb: [
                                            18,
                                            148,
                                            80
                                        ]
                                    },
                                    {
                                        index: .63,
                                        rgb: [
                                            80,
                                            173,
                                            89
                                        ]
                                    },
                                    {
                                        index: .75,
                                        rgb: [
                                            132,
                                            196,
                                            122
                                        ]
                                    },
                                    {
                                        index: .88,
                                        rgb: [
                                            175,
                                            221,
                                            162
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            215,
                                            249,
                                            208
                                        ]
                                    }
                                ],
                                density: [
                                    {
                                        index: 0,
                                        rgb: [
                                            54,
                                            14,
                                            36
                                        ]
                                    },
                                    {
                                        index: .13,
                                        rgb: [
                                            89,
                                            23,
                                            80
                                        ]
                                    },
                                    {
                                        index: .25,
                                        rgb: [
                                            110,
                                            45,
                                            132
                                        ]
                                    },
                                    {
                                        index: .38,
                                        rgb: [
                                            120,
                                            77,
                                            178
                                        ]
                                    },
                                    {
                                        index: .5,
                                        rgb: [
                                            120,
                                            113,
                                            213
                                        ]
                                    },
                                    {
                                        index: .63,
                                        rgb: [
                                            115,
                                            151,
                                            228
                                        ]
                                    },
                                    {
                                        index: .75,
                                        rgb: [
                                            134,
                                            185,
                                            227
                                        ]
                                    },
                                    {
                                        index: .88,
                                        rgb: [
                                            177,
                                            214,
                                            227
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            230,
                                            241,
                                            241
                                        ]
                                    }
                                ],
                                "freesurface-blue": [
                                    {
                                        index: 0,
                                        rgb: [
                                            30,
                                            4,
                                            110
                                        ]
                                    },
                                    {
                                        index: .13,
                                        rgb: [
                                            47,
                                            14,
                                            176
                                        ]
                                    },
                                    {
                                        index: .25,
                                        rgb: [
                                            41,
                                            45,
                                            236
                                        ]
                                    },
                                    {
                                        index: .38,
                                        rgb: [
                                            25,
                                            99,
                                            212
                                        ]
                                    },
                                    {
                                        index: .5,
                                        rgb: [
                                            68,
                                            131,
                                            200
                                        ]
                                    },
                                    {
                                        index: .63,
                                        rgb: [
                                            114,
                                            156,
                                            197
                                        ]
                                    },
                                    {
                                        index: .75,
                                        rgb: [
                                            157,
                                            181,
                                            203
                                        ]
                                    },
                                    {
                                        index: .88,
                                        rgb: [
                                            200,
                                            208,
                                            216
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            241,
                                            237,
                                            236
                                        ]
                                    }
                                ],
                                "freesurface-red": [
                                    {
                                        index: 0,
                                        rgb: [
                                            60,
                                            9,
                                            18
                                        ]
                                    },
                                    {
                                        index: .13,
                                        rgb: [
                                            100,
                                            17,
                                            27
                                        ]
                                    },
                                    {
                                        index: .25,
                                        rgb: [
                                            142,
                                            20,
                                            29
                                        ]
                                    },
                                    {
                                        index: .38,
                                        rgb: [
                                            177,
                                            43,
                                            27
                                        ]
                                    },
                                    {
                                        index: .5,
                                        rgb: [
                                            192,
                                            87,
                                            63
                                        ]
                                    },
                                    {
                                        index: .63,
                                        rgb: [
                                            205,
                                            125,
                                            105
                                        ]
                                    },
                                    {
                                        index: .75,
                                        rgb: [
                                            216,
                                            162,
                                            148
                                        ]
                                    },
                                    {
                                        index: .88,
                                        rgb: [
                                            227,
                                            199,
                                            193
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            241,
                                            237,
                                            236
                                        ]
                                    }
                                ],
                                oxygen: [
                                    {
                                        index: 0,
                                        rgb: [
                                            64,
                                            5,
                                            5
                                        ]
                                    },
                                    {
                                        index: .13,
                                        rgb: [
                                            106,
                                            6,
                                            15
                                        ]
                                    },
                                    {
                                        index: .25,
                                        rgb: [
                                            144,
                                            26,
                                            7
                                        ]
                                    },
                                    {
                                        index: .38,
                                        rgb: [
                                            168,
                                            64,
                                            3
                                        ]
                                    },
                                    {
                                        index: .5,
                                        rgb: [
                                            188,
                                            100,
                                            4
                                        ]
                                    },
                                    {
                                        index: .63,
                                        rgb: [
                                            206,
                                            136,
                                            11
                                        ]
                                    },
                                    {
                                        index: .75,
                                        rgb: [
                                            220,
                                            174,
                                            25
                                        ]
                                    },
                                    {
                                        index: .88,
                                        rgb: [
                                            231,
                                            215,
                                            44
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            248,
                                            254,
                                            105
                                        ]
                                    }
                                ],
                                par: [
                                    {
                                        index: 0,
                                        rgb: [
                                            51,
                                            20,
                                            24
                                        ]
                                    },
                                    {
                                        index: .13,
                                        rgb: [
                                            90,
                                            32,
                                            35
                                        ]
                                    },
                                    {
                                        index: .25,
                                        rgb: [
                                            129,
                                            44,
                                            34
                                        ]
                                    },
                                    {
                                        index: .38,
                                        rgb: [
                                            159,
                                            68,
                                            25
                                        ]
                                    },
                                    {
                                        index: .5,
                                        rgb: [
                                            182,
                                            99,
                                            19
                                        ]
                                    },
                                    {
                                        index: .63,
                                        rgb: [
                                            199,
                                            134,
                                            22
                                        ]
                                    },
                                    {
                                        index: .75,
                                        rgb: [
                                            212,
                                            171,
                                            35
                                        ]
                                    },
                                    {
                                        index: .88,
                                        rgb: [
                                            221,
                                            210,
                                            54
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            225,
                                            253,
                                            75
                                        ]
                                    }
                                ],
                                phase: [
                                    {
                                        index: 0,
                                        rgb: [
                                            145,
                                            105,
                                            18
                                        ]
                                    },
                                    {
                                        index: .13,
                                        rgb: [
                                            184,
                                            71,
                                            38
                                        ]
                                    },
                                    {
                                        index: .25,
                                        rgb: [
                                            186,
                                            58,
                                            115
                                        ]
                                    },
                                    {
                                        index: .38,
                                        rgb: [
                                            160,
                                            71,
                                            185
                                        ]
                                    },
                                    {
                                        index: .5,
                                        rgb: [
                                            110,
                                            97,
                                            218
                                        ]
                                    },
                                    {
                                        index: .63,
                                        rgb: [
                                            50,
                                            123,
                                            164
                                        ]
                                    },
                                    {
                                        index: .75,
                                        rgb: [
                                            31,
                                            131,
                                            110
                                        ]
                                    },
                                    {
                                        index: .88,
                                        rgb: [
                                            77,
                                            129,
                                            34
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            145,
                                            105,
                                            18
                                        ]
                                    }
                                ],
                                salinity: [
                                    {
                                        index: 0,
                                        rgb: [
                                            42,
                                            24,
                                            108
                                        ]
                                    },
                                    {
                                        index: .13,
                                        rgb: [
                                            33,
                                            50,
                                            162
                                        ]
                                    },
                                    {
                                        index: .25,
                                        rgb: [
                                            15,
                                            90,
                                            145
                                        ]
                                    },
                                    {
                                        index: .38,
                                        rgb: [
                                            40,
                                            118,
                                            137
                                        ]
                                    },
                                    {
                                        index: .5,
                                        rgb: [
                                            59,
                                            146,
                                            135
                                        ]
                                    },
                                    {
                                        index: .63,
                                        rgb: [
                                            79,
                                            175,
                                            126
                                        ]
                                    },
                                    {
                                        index: .75,
                                        rgb: [
                                            120,
                                            203,
                                            104
                                        ]
                                    },
                                    {
                                        index: .88,
                                        rgb: [
                                            193,
                                            221,
                                            100
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            253,
                                            239,
                                            154
                                        ]
                                    }
                                ],
                                temperature: [
                                    {
                                        index: 0,
                                        rgb: [
                                            4,
                                            35,
                                            51
                                        ]
                                    },
                                    {
                                        index: .13,
                                        rgb: [
                                            23,
                                            51,
                                            122
                                        ]
                                    },
                                    {
                                        index: .25,
                                        rgb: [
                                            85,
                                            59,
                                            157
                                        ]
                                    },
                                    {
                                        index: .38,
                                        rgb: [
                                            129,
                                            79,
                                            143
                                        ]
                                    },
                                    {
                                        index: .5,
                                        rgb: [
                                            175,
                                            95,
                                            130
                                        ]
                                    },
                                    {
                                        index: .63,
                                        rgb: [
                                            222,
                                            112,
                                            101
                                        ]
                                    },
                                    {
                                        index: .75,
                                        rgb: [
                                            249,
                                            146,
                                            66
                                        ]
                                    },
                                    {
                                        index: .88,
                                        rgb: [
                                            249,
                                            196,
                                            65
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            232,
                                            250,
                                            91
                                        ]
                                    }
                                ],
                                turbidity: [
                                    {
                                        index: 0,
                                        rgb: [
                                            34,
                                            31,
                                            27
                                        ]
                                    },
                                    {
                                        index: .13,
                                        rgb: [
                                            65,
                                            50,
                                            41
                                        ]
                                    },
                                    {
                                        index: .25,
                                        rgb: [
                                            98,
                                            69,
                                            52
                                        ]
                                    },
                                    {
                                        index: .38,
                                        rgb: [
                                            131,
                                            89,
                                            57
                                        ]
                                    },
                                    {
                                        index: .5,
                                        rgb: [
                                            161,
                                            112,
                                            59
                                        ]
                                    },
                                    {
                                        index: .63,
                                        rgb: [
                                            185,
                                            140,
                                            66
                                        ]
                                    },
                                    {
                                        index: .75,
                                        rgb: [
                                            202,
                                            174,
                                            88
                                        ]
                                    },
                                    {
                                        index: .88,
                                        rgb: [
                                            216,
                                            209,
                                            126
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            233,
                                            246,
                                            171
                                        ]
                                    }
                                ],
                                "velocity-blue": [
                                    {
                                        index: 0,
                                        rgb: [
                                            17,
                                            32,
                                            64
                                        ]
                                    },
                                    {
                                        index: .13,
                                        rgb: [
                                            35,
                                            52,
                                            116
                                        ]
                                    },
                                    {
                                        index: .25,
                                        rgb: [
                                            29,
                                            81,
                                            156
                                        ]
                                    },
                                    {
                                        index: .38,
                                        rgb: [
                                            31,
                                            113,
                                            162
                                        ]
                                    },
                                    {
                                        index: .5,
                                        rgb: [
                                            50,
                                            144,
                                            169
                                        ]
                                    },
                                    {
                                        index: .63,
                                        rgb: [
                                            87,
                                            173,
                                            176
                                        ]
                                    },
                                    {
                                        index: .75,
                                        rgb: [
                                            149,
                                            196,
                                            189
                                        ]
                                    },
                                    {
                                        index: .88,
                                        rgb: [
                                            203,
                                            221,
                                            211
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            254,
                                            251,
                                            230
                                        ]
                                    }
                                ],
                                "velocity-green": [
                                    {
                                        index: 0,
                                        rgb: [
                                            23,
                                            35,
                                            19
                                        ]
                                    },
                                    {
                                        index: .13,
                                        rgb: [
                                            24,
                                            64,
                                            38
                                        ]
                                    },
                                    {
                                        index: .25,
                                        rgb: [
                                            11,
                                            95,
                                            45
                                        ]
                                    },
                                    {
                                        index: .38,
                                        rgb: [
                                            39,
                                            123,
                                            35
                                        ]
                                    },
                                    {
                                        index: .5,
                                        rgb: [
                                            95,
                                            146,
                                            12
                                        ]
                                    },
                                    {
                                        index: .63,
                                        rgb: [
                                            152,
                                            165,
                                            18
                                        ]
                                    },
                                    {
                                        index: .75,
                                        rgb: [
                                            201,
                                            186,
                                            69
                                        ]
                                    },
                                    {
                                        index: .88,
                                        rgb: [
                                            233,
                                            216,
                                            137
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            255,
                                            253,
                                            205
                                        ]
                                    }
                                ],
                                cubehelix: [
                                    {
                                        index: 0,
                                        rgb: [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    {
                                        index: .07,
                                        rgb: [
                                            22,
                                            5,
                                            59
                                        ]
                                    },
                                    {
                                        index: .13,
                                        rgb: [
                                            60,
                                            4,
                                            105
                                        ]
                                    },
                                    {
                                        index: .2,
                                        rgb: [
                                            109,
                                            1,
                                            135
                                        ]
                                    },
                                    {
                                        index: .27,
                                        rgb: [
                                            161,
                                            0,
                                            147
                                        ]
                                    },
                                    {
                                        index: .33,
                                        rgb: [
                                            210,
                                            2,
                                            142
                                        ]
                                    },
                                    {
                                        index: .4,
                                        rgb: [
                                            251,
                                            11,
                                            123
                                        ]
                                    },
                                    {
                                        index: .47,
                                        rgb: [
                                            255,
                                            29,
                                            97
                                        ]
                                    },
                                    {
                                        index: .53,
                                        rgb: [
                                            255,
                                            54,
                                            69
                                        ]
                                    },
                                    {
                                        index: .6,
                                        rgb: [
                                            255,
                                            85,
                                            46
                                        ]
                                    },
                                    {
                                        index: .67,
                                        rgb: [
                                            255,
                                            120,
                                            34
                                        ]
                                    },
                                    {
                                        index: .73,
                                        rgb: [
                                            255,
                                            157,
                                            37
                                        ]
                                    },
                                    {
                                        index: .8,
                                        rgb: [
                                            241,
                                            191,
                                            57
                                        ]
                                    },
                                    {
                                        index: .87,
                                        rgb: [
                                            224,
                                            220,
                                            93
                                        ]
                                    },
                                    {
                                        index: .93,
                                        rgb: [
                                            218,
                                            241,
                                            142
                                        ]
                                    },
                                    {
                                        index: 1,
                                        rgb: [
                                            227,
                                            253,
                                            198
                                        ]
                                    }
                                ]
                            };
                        },
                        6729: function(t1, e1, r) {
                            "use strict";
                            var n = r(3642), i = r(395);
                            function a(t1) {
                                return [
                                    t1[0] / 255,
                                    t1[1] / 255,
                                    t1[2] / 255,
                                    t1[3]
                                ];
                            }
                            function o(t1) {
                                for(var e1, r = "#", n = 0; n < 3; ++n)r += ("00" + (e1 = (e1 = t1[n]).toString(16))).substr(e1.length);
                                return r;
                            }
                            function s(t1) {
                                return "rgba(" + t1.join(",") + ")";
                            }
                            t1.exports = function(t1) {
                                var e1, r, l, c, u, h, f, p, d, m;
                                if (t1 || (t1 = {}), p = (t1.nshades || 72) - 1, f = t1.format || "hex", (h = t1.colormap) || (h = "jet"), "string" == typeof h) {
                                    if (h = h.toLowerCase(), !n[h]) throw Error(h + " not a supported colorscale");
                                    u = n[h];
                                } else {
                                    if (!Array.isArray(h)) throw Error("unsupported colormap option", h);
                                    u = h.slice();
                                }
                                if (u.length > p + 1) throw new Error(h + " map requires nshades to be at least size " + u.length);
                                d = Array.isArray(t1.alpha) ? 2 !== t1.alpha.length ? [
                                    1,
                                    1
                                ] : t1.alpha.slice() : "number" == typeof t1.alpha ? [
                                    t1.alpha,
                                    t1.alpha
                                ] : [
                                    1,
                                    1
                                ], e1 = u.map(function(t1) {
                                    return Math.round(t1.index * p);
                                }), d[0] = Math.min(Math.max(d[0], 0), 1), d[1] = Math.min(Math.max(d[1], 0), 1);
                                var g = u.map(function(t1, e1) {
                                    var r = u[e1].index, n = u[e1].rgb.slice();
                                    return 4 === n.length && n[3] >= 0 && n[3] <= 1 || (n[3] = d[0] + (d[1] - d[0]) * r), n;
                                }), y = [];
                                for(m = 0; m < e1.length - 1; ++m){
                                    c = e1[m + 1] - e1[m], r = g[m], l = g[m + 1];
                                    for(var v = 0; v < c; v++){
                                        var x = v / c;
                                        y.push([
                                            Math.round(i(r[0], l[0], x)),
                                            Math.round(i(r[1], l[1], x)),
                                            Math.round(i(r[2], l[2], x)),
                                            i(r[3], l[3], x)
                                        ]);
                                    }
                                }
                                return y.push(u[u.length - 1].rgb.concat(d[1])), "hex" === f ? y = y.map(o) : "rgbaString" === f ? y = y.map(s) : "float" === f && (y = y.map(a)), y;
                            };
                        },
                        3140: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1, r, a) {
                                var o = n(e1, r, a);
                                if (0 === o) {
                                    var s = i(n(t1, e1, r)), c = i(n(t1, e1, a));
                                    if (s === c) {
                                        if (0 === s) {
                                            var u = l(t1, e1, r);
                                            return u === l(t1, e1, a) ? 0 : u ? 1 : -1;
                                        }
                                        return 0;
                                    }
                                    return 0 === c ? s > 0 || l(t1, e1, a) ? -1 : 1 : 0 === s ? c > 0 || l(t1, e1, r) ? 1 : -1 : i(c - s);
                                }
                                var h = n(t1, e1, r);
                                return h > 0 ? o > 0 && n(t1, e1, a) > 0 ? 1 : -1 : h < 0 ? o > 0 || n(t1, e1, a) > 0 ? 1 : -1 : n(t1, e1, a) > 0 || l(t1, e1, r) ? 1 : -1;
                            };
                            var n = r(3250), i = r(8572), a = r(9362), o = r(5382), s = r(8210);
                            function l(t1, e1, r) {
                                var n = a(t1[0], -e1[0]), i = a(t1[1], -e1[1]), l = a(r[0], -e1[0]), c = a(r[1], -e1[1]), u = s(o(n, l), o(i, c));
                                return u[u.length - 1] >= 0;
                            }
                        },
                        8572: function(t1) {
                            "use strict";
                            t1.exports = function(t1) {
                                return t1 < 0 ? -1 : t1 > 0 ? 1 : 0;
                            };
                        },
                        8507: function(t1) {
                            t1.exports = function(t1, n) {
                                var i = t1.length, a = t1.length - n.length;
                                if (a) return a;
                                switch(i){
                                    case 0:
                                        return 0;
                                    case 1:
                                        return t1[0] - n[0];
                                    case 2:
                                        return t1[0] + t1[1] - n[0] - n[1] || e1(t1[0], t1[1]) - e1(n[0], n[1]);
                                    case 3:
                                        var o = t1[0] + t1[1], s = n[0] + n[1];
                                        if (a = o + t1[2] - (s + n[2])) return a;
                                        var l = e1(t1[0], t1[1]), c = e1(n[0], n[1]);
                                        return e1(l, t1[2]) - e1(c, n[2]) || e1(l + t1[2], o) - e1(c + n[2], s);
                                    case 4:
                                        var u = t1[0], h = t1[1], f = t1[2], p = t1[3], d = n[0], m = n[1], g = n[2], y = n[3];
                                        return u + h + f + p - (d + m + g + y) || e1(u, h, f, p) - e1(d, m, g, y, d) || e1(u + h, u + f, u + p, h + f, h + p, f + p) - e1(d + m, d + g, d + y, m + g, m + y, g + y) || e1(u + h + f, u + h + p, u + f + p, h + f + p) - e1(d + m + g, d + m + y, d + g + y, m + g + y);
                                    default:
                                        for(var v = t1.slice().sort(r), x = n.slice().sort(r), _ = 0; _ < i; ++_)if (a = v[_] - x[_]) return a;
                                        return 0;
                                }
                            };
                            var e1 = Math.min;
                            function r(t1, e1) {
                                return t1 - e1;
                            }
                        },
                        3788: function(t1, e1, r) {
                            "use strict";
                            var n = r(8507), i = r(2419);
                            t1.exports = function(t1, e1) {
                                return n(t1, e1) || i(t1) - i(e1);
                            };
                        },
                        7352: function(t1, e1, r) {
                            "use strict";
                            var n = r(5721), i = r(4750), a = r(2690);
                            t1.exports = function(t1) {
                                var e1 = t1.length;
                                if (0 === e1) return [];
                                if (1 === e1) return [
                                    [
                                        0
                                    ]
                                ];
                                var r = t1[0].length;
                                return 0 === r ? [] : 1 === r ? n(t1) : 2 === r ? i(t1) : a(t1, r);
                            };
                        },
                        5721: function(t1) {
                            "use strict";
                            t1.exports = function(t1) {
                                for(var e1 = 0, r = 0, n = 1; n < t1.length; ++n)t1[n][0] < t1[e1][0] && (e1 = n), t1[n][0] > t1[r][0] && (r = n);
                                return e1 < r ? [
                                    [
                                        e1
                                    ],
                                    [
                                        r
                                    ]
                                ] : e1 > r ? [
                                    [
                                        r
                                    ],
                                    [
                                        e1
                                    ]
                                ] : [
                                    [
                                        e1
                                    ]
                                ];
                            };
                        },
                        4750: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1) {
                                var e1 = n(t1), r = e1.length;
                                if (r <= 2) return [];
                                for(var i = new Array(r), a = e1[r - 1], o = 0; o < r; ++o){
                                    var s = e1[o];
                                    i[o] = [
                                        a,
                                        s
                                    ], a = s;
                                }
                                return i;
                            };
                            var n = r(3090);
                        },
                        2690: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1) {
                                try {
                                    return n(t1, !0);
                                } catch (o) {
                                    var r = i(t1);
                                    if (r.length <= e1) return [];
                                    var a = function(t1, e1) {
                                        for(var r = t1.length, n = new Array(r), i = 0; i < e1.length; ++i)n[i] = t1[e1[i]];
                                        var a = e1.length;
                                        for(i = 0; i < r; ++i)e1.indexOf(i) < 0 && (n[a++] = t1[i]);
                                        return n;
                                    }(t1, r);
                                    return function(t1, e1) {
                                        for(var r = t1.length, n = e1.length, i = 0; i < r; ++i)for(var a = t1[i], o = 0; o < a.length; ++o){
                                            var s = a[o];
                                            if (s < n) a[o] = e1[s];
                                            else {
                                                s -= n;
                                                for(var l = 0; l < n; ++l)s >= e1[l] && (s += 1);
                                                a[o] = s;
                                            }
                                        }
                                        return t1;
                                    }(n(a, !0), r);
                                }
                            };
                            var n = r(8954), i = r(3952);
                        },
                        4769: function(t1) {
                            "use strict";
                            t1.exports = function(t1, e1, r, n, i, a) {
                                var o = i - 1, s = i * i, l = o * o, c = (1 + 2 * i) * l, u = i * l, h = s * (3 - 2 * i), f = s * o;
                                if (t1.length) {
                                    a || (a = new Array(t1.length));
                                    for(var p = t1.length - 1; p >= 0; --p)a[p] = c * t1[p] + u * e1[p] + h * r[p] + f * n[p];
                                    return a;
                                }
                                return c * t1 + u * e1 + h * r + f * n;
                            }, t1.exports.derivative = function(t1, e1, r, n, i, a) {
                                var o = 6 * i * i - 6 * i, s = 3 * i * i - 4 * i + 1, l = -6 * i * i + 6 * i, c = 3 * i * i - 2 * i;
                                if (t1.length) {
                                    a || (a = new Array(t1.length));
                                    for(var u = t1.length - 1; u >= 0; --u)a[u] = o * t1[u] + s * e1[u] + l * r[u] + c * n[u];
                                    return a;
                                }
                                return o * t1 + s * e1 + l * r[u] + c * n;
                            };
                        },
                        7642: function(t1, e1, r) {
                            "use strict";
                            var n = r(8954), i = r(1682);
                            function a(t1, e1) {
                                this.point = t1, this.index = e1;
                            }
                            function o(t1, e1) {
                                for(var r = t1.point, n = e1.point, i = r.length, a = 0; a < i; ++a){
                                    var o = n[a] - r[a];
                                    if (o) return o;
                                }
                                return 0;
                            }
                            t1.exports = function(t1, e1) {
                                var r = t1.length;
                                if (0 === r) return [];
                                var s = t1[0].length;
                                if (s < 1) return [];
                                if (1 === s) return function(t1, e1, r) {
                                    if (1 === t1) return r ? [
                                        [
                                            -1,
                                            0
                                        ]
                                    ] : [];
                                    var n = e1.map(function(t1, e1) {
                                        return [
                                            t1[0],
                                            e1
                                        ];
                                    });
                                    n.sort(function(t1, e1) {
                                        return t1[0] - e1[0];
                                    });
                                    for(var i = new Array(t1 - 1), a = 1; a < t1; ++a){
                                        var o = n[a - 1], s = n[a];
                                        i[a - 1] = [
                                            o[1],
                                            s[1]
                                        ];
                                    }
                                    return r && i.push([
                                        -1,
                                        i[0][1]
                                    ], [
                                        i[t1 - 1][1],
                                        -1
                                    ]), i;
                                }(r, t1, e1);
                                for(var l = new Array(r), c = 1, u = 0; u < r; ++u){
                                    for(var h = t1[u], f = new Array(s + 1), p = 0, d = 0; d < s; ++d){
                                        var m = h[d];
                                        f[d] = m, p += m * m;
                                    }
                                    f[s] = p, l[u] = new a(f, u), c = Math.max(p, c);
                                }
                                i(l, o), r = l.length;
                                var g = new Array(r + s + 1), y = new Array(r + s + 1), v = (s + 1) * (s + 1) * c, x = new Array(s + 1);
                                for(u = 0; u <= s; ++u)x[u] = 0;
                                for(x[s] = v, g[0] = x.slice(), y[0] = -1, u = 0; u <= s; ++u)(f = x.slice())[u] = 1, g[u + 1] = f, y[u + 1] = -1;
                                for(u = 0; u < r; ++u){
                                    var _ = l[u];
                                    g[u + s + 1] = _.point, y[u + s + 1] = _.index;
                                }
                                var b = n(g, !1);
                                if (b = e1 ? b.filter(function(t1) {
                                    for(var e1 = 0, r = 0; r <= s; ++r){
                                        var n = y[t1[r]];
                                        if (n < 0 && ++e1 >= 2) return !1;
                                        t1[r] = n;
                                    }
                                    return !0;
                                }) : b.filter(function(t1) {
                                    for(var e1 = 0; e1 <= s; ++e1){
                                        var r = y[t1[e1]];
                                        if (r < 0) return !1;
                                        t1[e1] = r;
                                    }
                                    return !0;
                                }), 1 & s) for(u = 0; u < b.length; ++u)f = (_ = b[u])[0], _[0] = _[1], _[1] = f;
                                return b;
                            };
                        },
                        2361: function(t1) {
                            var e1 = !1;
                            if ("undefined" != typeof Float64Array) {
                                var r = new Float64Array(1), i = new Uint32Array(r.buffer);
                                r[0] = 1, e1 = !0, 1072693248 === i[1] ? (t1.exports = function(t1) {
                                    return r[0] = t1, [
                                        i[0],
                                        i[1]
                                    ];
                                }, t1.exports.pack = function(t1, e1) {
                                    return i[0] = t1, i[1] = e1, r[0];
                                }, t1.exports.lo = function(t1) {
                                    return r[0] = t1, i[0];
                                }, t1.exports.hi = function(t1) {
                                    return r[0] = t1, i[1];
                                }) : 1072693248 === i[0] ? (t1.exports = function(t1) {
                                    return r[0] = t1, [
                                        i[1],
                                        i[0]
                                    ];
                                }, t1.exports.pack = function(t1, e1) {
                                    return i[1] = t1, i[0] = e1, r[0];
                                }, t1.exports.lo = function(t1) {
                                    return r[0] = t1, i[1];
                                }, t1.exports.hi = function(t1) {
                                    return r[0] = t1, i[0];
                                }) : e1 = !1;
                            }
                            if (!e1) {
                                var a = new n(8);
                                t1.exports = function(t1) {
                                    return a.writeDoubleLE(t1, 0, !0), [
                                        a.readUInt32LE(0, !0),
                                        a.readUInt32LE(4, !0)
                                    ];
                                }, t1.exports.pack = function(t1, e1) {
                                    return a.writeUInt32LE(t1, 0, !0), a.writeUInt32LE(e1, 4, !0), a.readDoubleLE(0, !0);
                                }, t1.exports.lo = function(t1) {
                                    return a.writeDoubleLE(t1, 0, !0), a.readUInt32LE(0, !0);
                                }, t1.exports.hi = function(t1) {
                                    return a.writeDoubleLE(t1, 0, !0), a.readUInt32LE(4, !0);
                                };
                            }
                            t1.exports.sign = function(e1) {
                                return t1.exports.hi(e1) >>> 31;
                            }, t1.exports.exponent = function(e1) {
                                return (t1.exports.hi(e1) << 1 >>> 21) - 1023;
                            }, t1.exports.fraction = function(e1) {
                                var r = t1.exports.lo(e1), n = t1.exports.hi(e1), i = 1048575 & n;
                                return 2146435072 & n && (i += 1048576), [
                                    r,
                                    i
                                ];
                            }, t1.exports.denormalized = function(e1) {
                                return !(2146435072 & t1.exports.hi(e1));
                            };
                        },
                        1338: function(t1) {
                            "use strict";
                            function e1(t1, r, n) {
                                var i = 0 | t1[n];
                                if (i <= 0) return [];
                                var a, o = new Array(i);
                                if (n === t1.length - 1) for(a = 0; a < i; ++a)o[a] = r;
                                else for(a = 0; a < i; ++a)o[a] = e1(t1, r, n + 1);
                                return o;
                            }
                            t1.exports = function(t1, r) {
                                switch(void 0 === r && (r = 0), typeof t1){
                                    case "number":
                                        if (t1 > 0) return function(t1, e1) {
                                            var r, n;
                                            for(r = new Array(t1), n = 0; n < t1; ++n)r[n] = e1;
                                            return r;
                                        }(0 | t1, r);
                                        break;
                                    case "object":
                                        if ("number" == typeof t1.length) return e1(t1, r, 0);
                                }
                                return [];
                            };
                        },
                        3134: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1) {
                                var r = t1.length;
                                if ("number" != typeof e1) {
                                    e1 = 0;
                                    for(var i = 0; i < r; ++i){
                                        var a = t1[i];
                                        e1 = Math.max(e1, a[0], a[1]);
                                    }
                                    e1 = 1 + (0 | e1);
                                }
                                e1 |= 0;
                                var o = new Array(e1);
                                for(i = 0; i < e1; ++i)o[i] = [];
                                for(i = 0; i < r; ++i)o[(a = t1[i])[0]].push(a[1]), o[a[1]].push(a[0]);
                                for(var s = 0; s < e1; ++s)n(o[s], function(t1, e1) {
                                    return t1 - e1;
                                });
                                return o;
                            };
                            var n = r(1682);
                        },
                        5033: function(t1) {
                            "use strict";
                            t1.exports = function(t1, e1, r) {
                                var n = e1 || 0, i = r || 1;
                                return [
                                    [
                                        t1[12] + t1[0],
                                        t1[13] + t1[1],
                                        t1[14] + t1[2],
                                        t1[15] + t1[3]
                                    ],
                                    [
                                        t1[12] - t1[0],
                                        t1[13] - t1[1],
                                        t1[14] - t1[2],
                                        t1[15] - t1[3]
                                    ],
                                    [
                                        t1[12] + t1[4],
                                        t1[13] + t1[5],
                                        t1[14] + t1[6],
                                        t1[15] + t1[7]
                                    ],
                                    [
                                        t1[12] - t1[4],
                                        t1[13] - t1[5],
                                        t1[14] - t1[6],
                                        t1[15] - t1[7]
                                    ],
                                    [
                                        n * t1[12] + t1[8],
                                        n * t1[13] + t1[9],
                                        n * t1[14] + t1[10],
                                        n * t1[15] + t1[11]
                                    ],
                                    [
                                        i * t1[12] - t1[8],
                                        i * t1[13] - t1[9],
                                        i * t1[14] - t1[10],
                                        i * t1[15] - t1[11]
                                    ]
                                ];
                            };
                        },
                        9215: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1, r) {
                                switch(arguments.length){
                                    case 0:
                                        return new o([
                                            0
                                        ], [
                                            0
                                        ], 0);
                                    case 1:
                                        return "number" == typeof t1 ? new o(n = l(t1), n, 0) : new o(t1, l(t1.length), 0);
                                    case 2:
                                        var n;
                                        if ("number" == typeof e1) return new o(t1, n = l(t1.length), +e1);
                                        r = 0;
                                    case 3:
                                        if (t1.length !== e1.length) throw new Error("state and velocity lengths must match");
                                        return new o(t1, e1, r);
                                }
                            };
                            var n = r(4769), i = r(2478);
                            function a(t1, e1, r) {
                                return Math.min(e1, Math.max(t1, r));
                            }
                            function o(t1, e1, r) {
                                this.dimension = t1.length, this.bounds = [
                                    new Array(this.dimension),
                                    new Array(this.dimension)
                                ];
                                for(var n = 0; n < this.dimension; ++n)this.bounds[0][n] = -1 / 0, this.bounds[1][n] = 1 / 0;
                                this._state = t1.slice().reverse(), this._velocity = e1.slice().reverse(), this._time = [
                                    r
                                ], this._scratch = [
                                    t1.slice(),
                                    t1.slice(),
                                    t1.slice(),
                                    t1.slice(),
                                    t1.slice()
                                ];
                            }
                            var s = o.prototype;
                            function l(t1) {
                                for(var e1 = new Array(t1), r = 0; r < t1; ++r)e1[r] = 0;
                                return e1;
                            }
                            s.flush = function(t1) {
                                var e1 = i.gt(this._time, t1) - 1;
                                e1 <= 0 || (this._time.splice(0, e1), this._state.splice(0, e1 * this.dimension), this._velocity.splice(0, e1 * this.dimension));
                            }, s.curve = function(t1) {
                                var e1 = this._time, r = e1.length, o = i.le(e1, t1), s = this._scratch[0], l = this._state, c = this._velocity, u = this.dimension, h = this.bounds;
                                if (o < 0) for(var f = u - 1, p = 0; p < u; ++p, --f)s[p] = l[f];
                                else if (o >= r - 1) {
                                    f = l.length - 1;
                                    var d = t1 - e1[r - 1];
                                    for(p = 0; p < u; ++p, --f)s[p] = l[f] + d * c[f];
                                } else {
                                    f = u * (o + 1) - 1;
                                    var m = e1[o], g = e1[o + 1] - m || 1, y = this._scratch[1], v = this._scratch[2], x = this._scratch[3], _ = this._scratch[4], b = !0;
                                    for(p = 0; p < u; ++p, --f)y[p] = l[f], x[p] = c[f] * g, v[p] = l[f + u], _[p] = c[f + u] * g, b = b && y[p] === v[p] && x[p] === _[p] && 0 === x[p];
                                    if (b) for(p = 0; p < u; ++p)s[p] = y[p];
                                    else n(y, x, v, _, (t1 - m) / g, s);
                                }
                                var w = h[0], T = h[1];
                                for(p = 0; p < u; ++p)s[p] = a(w[p], T[p], s[p]);
                                return s;
                            }, s.dcurve = function(t1) {
                                var e1 = this._time, r = e1.length, a = i.le(e1, t1), o = this._scratch[0], s = this._state, l = this._velocity, c = this.dimension;
                                if (a >= r - 1) for(var u = s.length - 1, h = (e1[r - 1], 0); h < c; ++h, --u)o[h] = l[u];
                                else {
                                    u = c * (a + 1) - 1;
                                    var f = e1[a], p = e1[a + 1] - f || 1, d = this._scratch[1], m = this._scratch[2], g = this._scratch[3], y = this._scratch[4], v = !0;
                                    for(h = 0; h < c; ++h, --u)d[h] = s[u], g[h] = l[u] * p, m[h] = s[u + c], y[h] = l[u + c] * p, v = v && d[h] === m[h] && g[h] === y[h] && 0 === g[h];
                                    if (v) for(h = 0; h < c; ++h)o[h] = 0;
                                    else for(n.derivative(d, g, m, y, (t1 - f) / p, o), h = 0; h < c; ++h)o[h] /= p;
                                }
                                return o;
                            }, s.lastT = function() {
                                var t1 = this._time;
                                return t1[t1.length - 1];
                            }, s.stable = function() {
                                for(var t1 = this._velocity, e1 = t1.length, r = this.dimension - 1; r >= 0; --r)if (t1[--e1]) return !1;
                                return !0;
                            }, s.jump = function(t1) {
                                var e1 = this.lastT(), r = this.dimension;
                                if (!(t1 < e1 || arguments.length !== r + 1)) {
                                    var n = this._state, i = this._velocity, o = n.length - this.dimension, s = this.bounds, l = s[0], c = s[1];
                                    this._time.push(e1, t1);
                                    for(var u = 0; u < 2; ++u)for(var h = 0; h < r; ++h)n.push(n[o++]), i.push(0);
                                    for(this._time.push(t1), h = r; h > 0; --h)n.push(a(l[h - 1], c[h - 1], arguments[h])), i.push(0);
                                }
                            }, s.push = function(t1) {
                                var e1 = this.lastT(), r = this.dimension;
                                if (!(t1 < e1 || arguments.length !== r + 1)) {
                                    var n = this._state, i = this._velocity, o = n.length - this.dimension, s = t1 - e1, l = this.bounds, c = l[0], u = l[1], h = s > 1e-6 ? 1 / s : 0;
                                    this._time.push(t1);
                                    for(var f = r; f > 0; --f){
                                        var p = a(c[f - 1], u[f - 1], arguments[f]);
                                        n.push(p), i.push((p - n[o++]) * h);
                                    }
                                }
                            }, s.set = function(t1) {
                                var e1 = this.dimension;
                                if (!(t1 < this.lastT() || arguments.length !== e1 + 1)) {
                                    var r = this._state, n = this._velocity, i = this.bounds, o = i[0], s = i[1];
                                    this._time.push(t1);
                                    for(var l = e1; l > 0; --l)r.push(a(o[l - 1], s[l - 1], arguments[l])), n.push(0);
                                }
                            }, s.move = function(t1) {
                                var e1 = this.lastT(), r = this.dimension;
                                if (!(t1 <= e1 || arguments.length !== r + 1)) {
                                    var n = this._state, i = this._velocity, o = n.length - this.dimension, s = this.bounds, l = s[0], c = s[1], u = t1 - e1, h = u > 1e-6 ? 1 / u : 0;
                                    this._time.push(t1);
                                    for(var f = r; f > 0; --f){
                                        var p = arguments[f];
                                        n.push(a(l[f - 1], c[f - 1], n[o++] + p)), i.push(p * h);
                                    }
                                }
                            }, s.idle = function(t1) {
                                var e1 = this.lastT();
                                if (!(t1 < e1)) {
                                    var r = this.dimension, n = this._state, i = this._velocity, o = n.length - r, s = this.bounds, l = s[0], c = s[1], u = t1 - e1;
                                    this._time.push(t1);
                                    for(var h = r - 1; h >= 0; --h)n.push(a(l[h], c[h], n[o] + u * i[o])), i.push(0), o += 1;
                                }
                            };
                        },
                        3840: function(t1) {
                            "use strict";
                            function e1(t1, e1, r, n, i, a) {
                                this._color = t1, this.key = e1, this.value = r, this.left = n, this.right = i, this._count = a;
                            }
                            function r(t1) {
                                return new e1(t1._color, t1.key, t1.value, t1.left, t1.right, t1._count);
                            }
                            function n(t1, r) {
                                return new e1(t1, r.key, r.value, r.left, r.right, r._count);
                            }
                            function i(t1) {
                                t1._count = 1 + (t1.left ? t1.left._count : 0) + (t1.right ? t1.right._count : 0);
                            }
                            function a(t1, e1) {
                                this._compare = t1, this.root = e1;
                            }
                            t1.exports = function(t1) {
                                return new a(t1 || p, null);
                            };
                            var o = a.prototype;
                            function s(t1, e1) {
                                var r;
                                return e1.left && (r = s(t1, e1.left)) ? r : (r = t1(e1.key, e1.value)) || (e1.right ? s(t1, e1.right) : void 0);
                            }
                            function l(t1, e1, r, n) {
                                if (e1(t1, n.key) <= 0) {
                                    var i;
                                    if (n.left && (i = l(t1, e1, r, n.left))) return i;
                                    if (i = r(n.key, n.value)) return i;
                                }
                                if (n.right) return l(t1, e1, r, n.right);
                            }
                            function c(t1, e1, r, n, i) {
                                var a, o = r(t1, i.key), s = r(e1, i.key);
                                if (o <= 0) {
                                    if (i.left && (a = c(t1, e1, r, n, i.left))) return a;
                                    if (s > 0 && (a = n(i.key, i.value))) return a;
                                }
                                if (s > 0 && i.right) return c(t1, e1, r, n, i.right);
                            }
                            function u(t1, e1) {
                                this.tree = t1, this._stack = e1;
                            }
                            Object.defineProperty(o, "keys", {
                                get: function() {
                                    var t1 = [];
                                    return this.forEach(function(e1, r) {
                                        t1.push(e1);
                                    }), t1;
                                }
                            }), Object.defineProperty(o, "values", {
                                get: function() {
                                    var t1 = [];
                                    return this.forEach(function(e1, r) {
                                        t1.push(r);
                                    }), t1;
                                }
                            }), Object.defineProperty(o, "length", {
                                get: function() {
                                    return this.root ? this.root._count : 0;
                                }
                            }), o.insert = function(t1, r) {
                                for(var o = this._compare, s = this.root, l = [], c = []; s;){
                                    var u = o(t1, s.key);
                                    l.push(s), c.push(u), s = u <= 0 ? s.left : s.right;
                                }
                                l.push(new e1(0, t1, r, null, null, 1));
                                for(var h = l.length - 2; h >= 0; --h)s = l[h], c[h] <= 0 ? l[h] = new e1(s._color, s.key, s.value, l[h + 1], s.right, s._count + 1) : l[h] = new e1(s._color, s.key, s.value, s.left, l[h + 1], s._count + 1);
                                for(h = l.length - 1; h > 1; --h){
                                    var f = l[h - 1];
                                    if (s = l[h], 1 === f._color || 1 === s._color) break;
                                    var p = l[h - 2];
                                    if (p.left === f) {
                                        if (f.left === s) {
                                            if (!(d = p.right) || 0 !== d._color) {
                                                p._color = 0, p.left = f.right, f._color = 1, f.right = p, l[h - 2] = f, l[h - 1] = s, i(p), i(f), h >= 3 && ((m = l[h - 3]).left === p ? m.left = f : m.right = f);
                                                break;
                                            }
                                            f._color = 1, p.right = n(1, d), p._color = 0, h -= 1;
                                        } else {
                                            if (!(d = p.right) || 0 !== d._color) {
                                                f.right = s.left, p._color = 0, p.left = s.right, s._color = 1, s.left = f, s.right = p, l[h - 2] = s, l[h - 1] = f, i(p), i(f), i(s), h >= 3 && ((m = l[h - 3]).left === p ? m.left = s : m.right = s);
                                                break;
                                            }
                                            f._color = 1, p.right = n(1, d), p._color = 0, h -= 1;
                                        }
                                    } else if (f.right === s) {
                                        if (!(d = p.left) || 0 !== d._color) {
                                            p._color = 0, p.right = f.left, f._color = 1, f.left = p, l[h - 2] = f, l[h - 1] = s, i(p), i(f), h >= 3 && ((m = l[h - 3]).right === p ? m.right = f : m.left = f);
                                            break;
                                        }
                                        f._color = 1, p.left = n(1, d), p._color = 0, h -= 1;
                                    } else {
                                        var d;
                                        if (!(d = p.left) || 0 !== d._color) {
                                            var m;
                                            f.left = s.right, p._color = 0, p.right = s.left, s._color = 1, s.right = f, s.left = p, l[h - 2] = s, l[h - 1] = f, i(p), i(f), i(s), h >= 3 && ((m = l[h - 3]).right === p ? m.right = s : m.left = s);
                                            break;
                                        }
                                        f._color = 1, p.left = n(1, d), p._color = 0, h -= 1;
                                    }
                                }
                                return l[0]._color = 1, new a(o, l[0]);
                            }, o.forEach = function(t1, e1, r) {
                                if (this.root) switch(arguments.length){
                                    case 1:
                                        return s(t1, this.root);
                                    case 2:
                                        return l(e1, this._compare, t1, this.root);
                                    case 3:
                                        if (this._compare(e1, r) >= 0) return;
                                        return c(e1, r, this._compare, t1, this.root);
                                }
                            }, Object.defineProperty(o, "begin", {
                                get: function() {
                                    for(var t1 = [], e1 = this.root; e1;)t1.push(e1), e1 = e1.left;
                                    return new u(this, t1);
                                }
                            }), Object.defineProperty(o, "end", {
                                get: function() {
                                    for(var t1 = [], e1 = this.root; e1;)t1.push(e1), e1 = e1.right;
                                    return new u(this, t1);
                                }
                            }), o.at = function(t1) {
                                if (t1 < 0) return new u(this, []);
                                for(var e1 = this.root, r = [];;){
                                    if (r.push(e1), e1.left) {
                                        if (t1 < e1.left._count) {
                                            e1 = e1.left;
                                            continue;
                                        }
                                        t1 -= e1.left._count;
                                    }
                                    if (!t1) return new u(this, r);
                                    if (t1 -= 1, !e1.right) break;
                                    if (t1 >= e1.right._count) break;
                                    e1 = e1.right;
                                }
                                return new u(this, []);
                            }, o.ge = function(t1) {
                                for(var e1 = this._compare, r = this.root, n = [], i = 0; r;){
                                    var a = e1(t1, r.key);
                                    n.push(r), a <= 0 && (i = n.length), r = a <= 0 ? r.left : r.right;
                                }
                                return n.length = i, new u(this, n);
                            }, o.gt = function(t1) {
                                for(var e1 = this._compare, r = this.root, n = [], i = 0; r;){
                                    var a = e1(t1, r.key);
                                    n.push(r), a < 0 && (i = n.length), r = a < 0 ? r.left : r.right;
                                }
                                return n.length = i, new u(this, n);
                            }, o.lt = function(t1) {
                                for(var e1 = this._compare, r = this.root, n = [], i = 0; r;){
                                    var a = e1(t1, r.key);
                                    n.push(r), a > 0 && (i = n.length), r = a <= 0 ? r.left : r.right;
                                }
                                return n.length = i, new u(this, n);
                            }, o.le = function(t1) {
                                for(var e1 = this._compare, r = this.root, n = [], i = 0; r;){
                                    var a = e1(t1, r.key);
                                    n.push(r), a >= 0 && (i = n.length), r = a < 0 ? r.left : r.right;
                                }
                                return n.length = i, new u(this, n);
                            }, o.find = function(t1) {
                                for(var e1 = this._compare, r = this.root, n = []; r;){
                                    var i = e1(t1, r.key);
                                    if (n.push(r), 0 === i) return new u(this, n);
                                    r = i <= 0 ? r.left : r.right;
                                }
                                return new u(this, []);
                            }, o.remove = function(t1) {
                                var e1 = this.find(t1);
                                return e1 ? e1.remove() : this;
                            }, o.get = function(t1) {
                                for(var e1 = this._compare, r = this.root; r;){
                                    var n = e1(t1, r.key);
                                    if (0 === n) return r.value;
                                    r = n <= 0 ? r.left : r.right;
                                }
                            };
                            var h = u.prototype;
                            function f(t1, e1) {
                                t1.key = e1.key, t1.value = e1.value, t1.left = e1.left, t1.right = e1.right, t1._color = e1._color, t1._count = e1._count;
                            }
                            function p(t1, e1) {
                                return t1 < e1 ? -1 : t1 > e1 ? 1 : 0;
                            }
                            Object.defineProperty(h, "valid", {
                                get: function() {
                                    return this._stack.length > 0;
                                }
                            }), Object.defineProperty(h, "node", {
                                get: function() {
                                    return this._stack.length > 0 ? this._stack[this._stack.length - 1] : null;
                                },
                                enumerable: !0
                            }), h.clone = function() {
                                return new u(this.tree, this._stack.slice());
                            }, h.remove = function() {
                                var t1 = this._stack;
                                if (0 === t1.length) return this.tree;
                                var o = new Array(t1.length), s = t1[t1.length - 1];
                                o[o.length - 1] = new e1(s._color, s.key, s.value, s.left, s.right, s._count);
                                for(var l = t1.length - 2; l >= 0; --l)(s = t1[l]).left === t1[l + 1] ? o[l] = new e1(s._color, s.key, s.value, o[l + 1], s.right, s._count) : o[l] = new e1(s._color, s.key, s.value, s.left, o[l + 1], s._count);
                                if ((s = o[o.length - 1]).left && s.right) {
                                    var c = o.length;
                                    for(s = s.left; s.right;)o.push(s), s = s.right;
                                    var u = o[c - 1];
                                    for(o.push(new e1(s._color, u.key, u.value, s.left, s.right, s._count)), o[c - 1].key = s.key, o[c - 1].value = s.value, l = o.length - 2; l >= c; --l)s = o[l], o[l] = new e1(s._color, s.key, s.value, s.left, o[l + 1], s._count);
                                    o[c - 1].left = o[c];
                                }
                                if (0 === (s = o[o.length - 1])._color) {
                                    var h = o[o.length - 2];
                                    for(h.left === s ? h.left = null : h.right === s && (h.right = null), o.pop(), l = 0; l < o.length; ++l)o[l]._count--;
                                    return new a(this.tree._compare, o[0]);
                                }
                                if (s.left || s.right) {
                                    for(s.left ? f(s, s.left) : s.right && f(s, s.right), s._color = 1, l = 0; l < o.length - 1; ++l)o[l]._count--;
                                    return new a(this.tree._compare, o[0]);
                                }
                                if (1 === o.length) return new a(this.tree._compare, null);
                                for(l = 0; l < o.length; ++l)o[l]._count--;
                                var p = o[o.length - 2];
                                return function(t1) {
                                    for(var e1, a, o, s, l = t1.length - 1; l >= 0; --l){
                                        if (e1 = t1[l], 0 === l) return void (e1._color = 1);
                                        if ((a = t1[l - 1]).left === e1) {
                                            if ((o = a.right).right && 0 === o.right._color) return s = (o = a.right = r(o)).right = r(o.right), a.right = o.left, o.left = a, o.right = s, o._color = a._color, e1._color = 1, a._color = 1, s._color = 1, i(a), i(o), l > 1 && ((c = t1[l - 2]).left === a ? c.left = o : c.right = o), void (t1[l - 1] = o);
                                            if (o.left && 0 === o.left._color) return s = (o = a.right = r(o)).left = r(o.left), a.right = s.left, o.left = s.right, s.left = a, s.right = o, s._color = a._color, a._color = 1, o._color = 1, e1._color = 1, i(a), i(o), i(s), l > 1 && ((c = t1[l - 2]).left === a ? c.left = s : c.right = s), void (t1[l - 1] = s);
                                            if (1 === o._color) {
                                                if (0 === a._color) return a._color = 1, void (a.right = n(0, o));
                                                a.right = n(0, o);
                                                continue;
                                            }
                                            o = r(o), a.right = o.left, o.left = a, o._color = a._color, a._color = 0, i(a), i(o), l > 1 && ((c = t1[l - 2]).left === a ? c.left = o : c.right = o), t1[l - 1] = o, t1[l] = a, l + 1 < t1.length ? t1[l + 1] = e1 : t1.push(e1), l += 2;
                                        } else {
                                            if ((o = a.left).left && 0 === o.left._color) return s = (o = a.left = r(o)).left = r(o.left), a.left = o.right, o.right = a, o.left = s, o._color = a._color, e1._color = 1, a._color = 1, s._color = 1, i(a), i(o), l > 1 && ((c = t1[l - 2]).right === a ? c.right = o : c.left = o), void (t1[l - 1] = o);
                                            if (o.right && 0 === o.right._color) return s = (o = a.left = r(o)).right = r(o.right), a.left = s.right, o.right = s.left, s.right = a, s.left = o, s._color = a._color, a._color = 1, o._color = 1, e1._color = 1, i(a), i(o), i(s), l > 1 && ((c = t1[l - 2]).right === a ? c.right = s : c.left = s), void (t1[l - 1] = s);
                                            if (1 === o._color) {
                                                if (0 === a._color) return a._color = 1, void (a.left = n(0, o));
                                                a.left = n(0, o);
                                                continue;
                                            }
                                            var c;
                                            o = r(o), a.left = o.right, o.right = a, o._color = a._color, a._color = 0, i(a), i(o), l > 1 && ((c = t1[l - 2]).right === a ? c.right = o : c.left = o), t1[l - 1] = o, t1[l] = a, l + 1 < t1.length ? t1[l + 1] = e1 : t1.push(e1), l += 2;
                                        }
                                    }
                                }(o), p.left === s ? p.left = null : p.right = null, new a(this.tree._compare, o[0]);
                            }, Object.defineProperty(h, "key", {
                                get: function() {
                                    if (this._stack.length > 0) return this._stack[this._stack.length - 1].key;
                                },
                                enumerable: !0
                            }), Object.defineProperty(h, "value", {
                                get: function() {
                                    if (this._stack.length > 0) return this._stack[this._stack.length - 1].value;
                                },
                                enumerable: !0
                            }), Object.defineProperty(h, "index", {
                                get: function() {
                                    var t1 = 0, e1 = this._stack;
                                    if (0 === e1.length) {
                                        var r = this.tree.root;
                                        return r ? r._count : 0;
                                    }
                                    e1[e1.length - 1].left && (t1 = e1[e1.length - 1].left._count);
                                    for(var n = e1.length - 2; n >= 0; --n)e1[n + 1] === e1[n].right && (++t1, e1[n].left && (t1 += e1[n].left._count));
                                    return t1;
                                },
                                enumerable: !0
                            }), h.next = function() {
                                var t1 = this._stack;
                                if (0 !== t1.length) {
                                    var e1 = t1[t1.length - 1];
                                    if (e1.right) for(e1 = e1.right; e1;)t1.push(e1), e1 = e1.left;
                                    else for(t1.pop(); t1.length > 0 && t1[t1.length - 1].right === e1;)e1 = t1[t1.length - 1], t1.pop();
                                }
                            }, Object.defineProperty(h, "hasNext", {
                                get: function() {
                                    var t1 = this._stack;
                                    if (0 === t1.length) return !1;
                                    if (t1[t1.length - 1].right) return !0;
                                    for(var e1 = t1.length - 1; e1 > 0; --e1)if (t1[e1 - 1].left === t1[e1]) return !0;
                                    return !1;
                                }
                            }), h.update = function(t1) {
                                var r = this._stack;
                                if (0 === r.length) throw new Error("Can't update empty node!");
                                var n = new Array(r.length), i = r[r.length - 1];
                                n[n.length - 1] = new e1(i._color, i.key, t1, i.left, i.right, i._count);
                                for(var o = r.length - 2; o >= 0; --o)(i = r[o]).left === r[o + 1] ? n[o] = new e1(i._color, i.key, i.value, n[o + 1], i.right, i._count) : n[o] = new e1(i._color, i.key, i.value, i.left, n[o + 1], i._count);
                                return new a(this.tree._compare, n[0]);
                            }, h.prev = function() {
                                var t1 = this._stack;
                                if (0 !== t1.length) {
                                    var e1 = t1[t1.length - 1];
                                    if (e1.left) for(e1 = e1.left; e1;)t1.push(e1), e1 = e1.right;
                                    else for(t1.pop(); t1.length > 0 && t1[t1.length - 1].left === e1;)e1 = t1[t1.length - 1], t1.pop();
                                }
                            }, Object.defineProperty(h, "hasPrev", {
                                get: function() {
                                    var t1 = this._stack;
                                    if (0 === t1.length) return !1;
                                    if (t1[t1.length - 1].left) return !0;
                                    for(var e1 = t1.length - 1; e1 > 0; --e1)if (t1[e1 - 1].right === t1[e1]) return !0;
                                    return !1;
                                }
                            });
                        },
                        3837: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1) {
                                var r = new p(t1);
                                return r.update(e1), r;
                            };
                            var n = r(4935), i = r(501), a = r(5304), o = r(6429), s = r(6444), l = new Float32Array([
                                1,
                                0,
                                0,
                                0,
                                0,
                                1,
                                0,
                                0,
                                0,
                                0,
                                1,
                                0,
                                0,
                                0,
                                0,
                                1
                            ]), c = ArrayBuffer, u = DataView;
                            function h(t1) {
                                return Array.isArray(t1) || function(t1) {
                                    return c.isView(t1) && !(t1 instanceof u);
                                }(t1);
                            }
                            function f(t1, e1) {
                                return t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1;
                            }
                            function p(t1) {
                                this.gl = t1, this.pixelRatio = 1, this.bounds = [
                                    [
                                        -10,
                                        -10,
                                        -10
                                    ],
                                    [
                                        10,
                                        10,
                                        10
                                    ]
                                ], this.ticks = [
                                    [],
                                    [],
                                    []
                                ], this.autoTicks = !0, this.tickSpacing = [
                                    1,
                                    1,
                                    1
                                ], this.tickEnable = [
                                    !0,
                                    !0,
                                    !0
                                ], this.tickFont = [
                                    "sans-serif",
                                    "sans-serif",
                                    "sans-serif"
                                ], this.tickFontStyle = [
                                    "normal",
                                    "normal",
                                    "normal"
                                ], this.tickFontWeight = [
                                    "normal",
                                    "normal",
                                    "normal"
                                ], this.tickFontVariant = [
                                    "normal",
                                    "normal",
                                    "normal"
                                ], this.tickSize = [
                                    12,
                                    12,
                                    12
                                ], this.tickAngle = [
                                    0,
                                    0,
                                    0
                                ], this.tickAlign = [
                                    "auto",
                                    "auto",
                                    "auto"
                                ], this.tickColor = [
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ]
                                ], this.tickPad = [
                                    10,
                                    10,
                                    10
                                ], this.lastCubeProps = {
                                    cubeEdges: [
                                        0,
                                        0,
                                        0
                                    ],
                                    axis: [
                                        0,
                                        0,
                                        0
                                    ]
                                }, this.labels = [
                                    "x",
                                    "y",
                                    "z"
                                ], this.labelEnable = [
                                    !0,
                                    !0,
                                    !0
                                ], this.labelFont = [
                                    "sans-serif",
                                    "sans-serif",
                                    "sans-serif"
                                ], this.labelFontStyle = [
                                    "normal",
                                    "normal",
                                    "normal"
                                ], this.labelFontWeight = [
                                    "normal",
                                    "normal",
                                    "normal"
                                ], this.labelFontVariant = [
                                    "normal",
                                    "normal",
                                    "normal"
                                ], this.labelSize = [
                                    20,
                                    20,
                                    20
                                ], this.labelAngle = [
                                    0,
                                    0,
                                    0
                                ], this.labelAlign = [
                                    "auto",
                                    "auto",
                                    "auto"
                                ], this.labelColor = [
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ]
                                ], this.labelPad = [
                                    10,
                                    10,
                                    10
                                ], this.lineEnable = [
                                    !0,
                                    !0,
                                    !0
                                ], this.lineMirror = [
                                    !1,
                                    !1,
                                    !1
                                ], this.lineWidth = [
                                    1,
                                    1,
                                    1
                                ], this.lineColor = [
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ]
                                ], this.lineTickEnable = [
                                    !0,
                                    !0,
                                    !0
                                ], this.lineTickMirror = [
                                    !1,
                                    !1,
                                    !1
                                ], this.lineTickLength = [
                                    0,
                                    0,
                                    0
                                ], this.lineTickWidth = [
                                    1,
                                    1,
                                    1
                                ], this.lineTickColor = [
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ]
                                ], this.gridEnable = [
                                    !0,
                                    !0,
                                    !0
                                ], this.gridWidth = [
                                    1,
                                    1,
                                    1
                                ], this.gridColor = [
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ]
                                ], this.zeroEnable = [
                                    !0,
                                    !0,
                                    !0
                                ], this.zeroLineColor = [
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ]
                                ], this.zeroLineWidth = [
                                    2,
                                    2,
                                    2
                                ], this.backgroundEnable = [
                                    !1,
                                    !1,
                                    !1
                                ], this.backgroundColor = [
                                    [
                                        .8,
                                        .8,
                                        .8,
                                        .5
                                    ],
                                    [
                                        .8,
                                        .8,
                                        .8,
                                        .5
                                    ],
                                    [
                                        .8,
                                        .8,
                                        .8,
                                        .5
                                    ]
                                ], this._firstInit = !0, this._text = null, this._lines = null, this._background = a(t1);
                            }
                            var d = p.prototype;
                            function m() {
                                this.primalOffset = [
                                    0,
                                    0,
                                    0
                                ], this.primalMinor = [
                                    0,
                                    0,
                                    0
                                ], this.mirrorOffset = [
                                    0,
                                    0,
                                    0
                                ], this.mirrorMinor = [
                                    0,
                                    0,
                                    0
                                ];
                            }
                            d.update = function(t1) {
                                function e1(e1, r, n) {
                                    if (n in t1) {
                                        var i, a = t1[n], o = this[n];
                                        (e1 ? h(a) && h(a[0]) : h(a)) ? this[n] = i = [
                                            r(a[0]),
                                            r(a[1]),
                                            r(a[2])
                                        ] : this[n] = i = [
                                            r(a),
                                            r(a),
                                            r(a)
                                        ];
                                        for(var s = 0; s < 3; ++s)if (i[s] !== o[s]) return !0;
                                    }
                                    return !1;
                                }
                                t1 = t1 || {};
                                var r, a = e1.bind(this, !1, Number), o = e1.bind(this, !1, Boolean), l = e1.bind(this, !1, String), c = e1.bind(this, !0, function(t1) {
                                    if (h(t1)) {
                                        if (3 === t1.length) return [
                                            +t1[0],
                                            +t1[1],
                                            +t1[2],
                                            1
                                        ];
                                        if (4 === t1.length) return [
                                            +t1[0],
                                            +t1[1],
                                            +t1[2],
                                            +t1[3]
                                        ];
                                    }
                                    return [
                                        0,
                                        0,
                                        0,
                                        1
                                    ];
                                }), u = !1, f = !1;
                                if ("bounds" in t1) for(var p = t1.bounds, d = 0; d < 2; ++d)for(var m = 0; m < 3; ++m)p[d][m] !== this.bounds[d][m] && (f = !0), this.bounds[d][m] = p[d][m];
                                if ("ticks" in t1) for(r = t1.ticks, u = !0, this.autoTicks = !1, d = 0; d < 3; ++d)this.tickSpacing[d] = 0;
                                else a("tickSpacing") && (this.autoTicks = !0, f = !0);
                                if (this._firstInit && ("ticks" in t1 || "tickSpacing" in t1 || (this.autoTicks = !0), f = !0, u = !0, this._firstInit = !1), f && this.autoTicks && (r = s.create(this.bounds, this.tickSpacing), u = !0), u) {
                                    for(d = 0; d < 3; ++d)r[d].sort(function(t1, e1) {
                                        return t1.x - e1.x;
                                    });
                                    s.equal(r, this.ticks) ? u = !1 : this.ticks = r;
                                }
                                o("tickEnable"), l("tickFont") && (u = !0), l("tickFontStyle") && (u = !0), l("tickFontWeight") && (u = !0), l("tickFontVariant") && (u = !0), a("tickSize"), a("tickAngle"), a("tickPad"), c("tickColor");
                                var g = l("labels");
                                l("labelFont") && (g = !0), l("labelFontStyle") && (g = !0), l("labelFontWeight") && (g = !0), l("labelFontVariant") && (g = !0), o("labelEnable"), a("labelSize"), a("labelPad"), c("labelColor"), o("lineEnable"), o("lineMirror"), a("lineWidth"), c("lineColor"), o("lineTickEnable"), o("lineTickMirror"), a("lineTickLength"), a("lineTickWidth"), c("lineTickColor"), o("gridEnable"), a("gridWidth"), c("gridColor"), o("zeroEnable"), c("zeroLineColor"), a("zeroLineWidth"), o("backgroundEnable"), c("backgroundColor");
                                var y = [
                                    {
                                        family: this.labelFont[0],
                                        style: this.labelFontStyle[0],
                                        weight: this.labelFontWeight[0],
                                        variant: this.labelFontVariant[0]
                                    },
                                    {
                                        family: this.labelFont[1],
                                        style: this.labelFontStyle[1],
                                        weight: this.labelFontWeight[1],
                                        variant: this.labelFontVariant[1]
                                    },
                                    {
                                        family: this.labelFont[2],
                                        style: this.labelFontStyle[2],
                                        weight: this.labelFontWeight[2],
                                        variant: this.labelFontVariant[2]
                                    }
                                ], v = [
                                    {
                                        family: this.tickFont[0],
                                        style: this.tickFontStyle[0],
                                        weight: this.tickFontWeight[0],
                                        variant: this.tickFontVariant[0]
                                    },
                                    {
                                        family: this.tickFont[1],
                                        style: this.tickFontStyle[1],
                                        weight: this.tickFontWeight[1],
                                        variant: this.tickFontVariant[1]
                                    },
                                    {
                                        family: this.tickFont[2],
                                        style: this.tickFontStyle[2],
                                        weight: this.tickFontWeight[2],
                                        variant: this.tickFontVariant[2]
                                    }
                                ];
                                this._text ? this._text && (g || u) && this._text.update(this.bounds, this.labels, y, this.ticks, v) : this._text = n(this.gl, this.bounds, this.labels, y, this.ticks, v), this._lines && u && (this._lines.dispose(), this._lines = null), this._lines || (this._lines = i(this.gl, this.bounds, this.ticks));
                            };
                            var g = [
                                new m,
                                new m,
                                new m
                            ];
                            function y(t1, e1, r, n, i) {
                                for(var a = t1.primalOffset, o = t1.primalMinor, s = t1.mirrorOffset, l = t1.mirrorMinor, c = n[e1], u = 0; u < 3; ++u)if (e1 !== u) {
                                    var h = a, f = s, p = o, d = l;
                                    c & 1 << u && (h = s, f = a, p = l, d = o), h[u] = r[0][u], f[u] = r[1][u], i[u] > 0 ? (p[u] = -1, d[u] = 0) : (p[u] = 0, d[u] = 1);
                                }
                            }
                            var v = [
                                0,
                                0,
                                0
                            ], x = {
                                model: l,
                                view: l,
                                projection: l,
                                _ortho: !1
                            };
                            d.isOpaque = function() {
                                return !0;
                            }, d.isTransparent = function() {
                                return !1;
                            }, d.drawTransparent = function(t1) {};
                            var _ = [
                                0,
                                0,
                                0
                            ], b = [
                                0,
                                0,
                                0
                            ], w = [
                                0,
                                0,
                                0
                            ];
                            d.draw = function(t1) {
                                t1 = t1 || x;
                                for(var e1 = this.gl, r = t1.model || l, n = t1.view || l, i = t1.projection || l, a = this.bounds, s = t1._ortho || !1, c = o(r, n, i, a, s), u = c.cubeEdges, h = c.axis, p = n[12], d = n[13], m = n[14], T = n[15], k = (s ? 2 : 1) * this.pixelRatio * (i[3] * p + i[7] * d + i[11] * m + i[15] * T) / e1.drawingBufferHeight, A = 0; A < 3; ++A)this.lastCubeProps.cubeEdges[A] = u[A], this.lastCubeProps.axis[A] = h[A];
                                var M = g;
                                for(A = 0; A < 3; ++A)y(g[A], A, this.bounds, u, h);
                                e1 = this.gl;
                                var S, E, C, L = v;
                                for(A = 0; A < 3; ++A)this.backgroundEnable[A] ? L[A] = h[A] : L[A] = 0;
                                for(this._background.draw(r, n, i, a, L, this.backgroundColor), this._lines.bind(r, n, i, this), A = 0; A < 3; ++A){
                                    var I = [
                                        0,
                                        0,
                                        0
                                    ];
                                    h[A] > 0 ? I[A] = a[1][A] : I[A] = a[0][A];
                                    for(var P = 0; P < 2; ++P){
                                        var z = (A + 1 + P) % 3, O = (A + 1 + (1 ^ P)) % 3;
                                        this.gridEnable[z] && this._lines.drawGrid(z, O, this.bounds, I, this.gridColor[z], this.gridWidth[z] * this.pixelRatio);
                                    }
                                    for(P = 0; P < 2; ++P)z = (A + 1 + P) % 3, O = (A + 1 + (1 ^ P)) % 3, this.zeroEnable[O] && Math.min(a[0][O], a[1][O]) <= 0 && Math.max(a[0][O], a[1][O]) >= 0 && this._lines.drawZero(z, O, this.bounds, I, this.zeroLineColor[O], this.zeroLineWidth[O] * this.pixelRatio);
                                }
                                for(A = 0; A < 3; ++A){
                                    this.lineEnable[A] && this._lines.drawAxisLine(A, this.bounds, M[A].primalOffset, this.lineColor[A], this.lineWidth[A] * this.pixelRatio), this.lineMirror[A] && this._lines.drawAxisLine(A, this.bounds, M[A].mirrorOffset, this.lineColor[A], this.lineWidth[A] * this.pixelRatio);
                                    var D = f(_, M[A].primalMinor), R = f(b, M[A].mirrorMinor), F = this.lineTickLength;
                                    for(P = 0; P < 3; ++P){
                                        var B = k / r[5 * P];
                                        D[P] *= F[P] * B, R[P] *= F[P] * B;
                                    }
                                    this.lineTickEnable[A] && this._lines.drawAxisTicks(A, M[A].primalOffset, D, this.lineTickColor[A], this.lineTickWidth[A] * this.pixelRatio), this.lineTickMirror[A] && this._lines.drawAxisTicks(A, M[A].mirrorOffset, R, this.lineTickColor[A], this.lineTickWidth[A] * this.pixelRatio);
                                }
                                function N(t1) {
                                    (C = [
                                        0,
                                        0,
                                        0
                                    ])[t1] = 1;
                                }
                                function j(t1, e1, r) {
                                    var n = (t1 + 1) % 3, i = (t1 + 2) % 3, a = e1[n], o = e1[i], s = r[n], l = r[i];
                                    a > 0 && l > 0 || a > 0 && l < 0 || a < 0 && l > 0 || a < 0 && l < 0 ? N(n) : (o > 0 && s > 0 || o > 0 && s < 0 || o < 0 && s > 0 || o < 0 && s < 0) && N(i);
                                }
                                for(this._lines.unbind(), this._text.bind(r, n, i, this.pixelRatio), A = 0; A < 3; ++A){
                                    var U = M[A].primalMinor, V = M[A].mirrorMinor, q = f(w, M[A].primalOffset);
                                    for(P = 0; P < 3; ++P)this.lineTickEnable[A] && (q[P] += k * U[P] * Math.max(this.lineTickLength[P], 0) / r[5 * P]);
                                    var H = [
                                        0,
                                        0,
                                        0
                                    ];
                                    if (H[A] = 1, this.tickEnable[A]) {
                                        for(-3600 === this.tickAngle[A] ? (this.tickAngle[A] = 0, this.tickAlign[A] = "auto") : this.tickAlign[A] = -1, E = 1, "auto" === (S = [
                                            this.tickAlign[A],
                                            .5,
                                            E
                                        ])[0] ? S[0] = 0 : S[0] = parseInt("" + S[0]), C = [
                                            0,
                                            0,
                                            0
                                        ], j(A, U, V), P = 0; P < 3; ++P)q[P] += k * U[P] * this.tickPad[P] / r[5 * P];
                                        this._text.drawTicks(A, this.tickSize[A], this.tickAngle[A], q, this.tickColor[A], H, C, S);
                                    }
                                    if (this.labelEnable[A]) {
                                        for(E = 0, C = [
                                            0,
                                            0,
                                            0
                                        ], this.labels[A].length > 4 && (N(A), E = 1), "auto" === (S = [
                                            this.labelAlign[A],
                                            .5,
                                            E
                                        ])[0] ? S[0] = 0 : S[0] = parseInt("" + S[0]), P = 0; P < 3; ++P)q[P] += k * U[P] * this.labelPad[P] / r[5 * P];
                                        q[A] += .5 * (a[0][A] + a[1][A]), this._text.drawLabel(A, this.labelSize[A], this.labelAngle[A], q, this.labelColor[A], [
                                            0,
                                            0,
                                            0
                                        ], C, S);
                                    }
                                }
                                this._text.unbind();
                            }, d.dispose = function() {
                                this._text.dispose(), this._lines.dispose(), this._background.dispose(), this._lines = null, this._text = null, this._background = null, this.gl = null;
                            };
                        },
                        5304: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1) {
                                for(var e1 = [], r = [], s = 0, l = 0; l < 3; ++l)for(var c = (l + 1) % 3, u = (l + 2) % 3, h = [
                                    0,
                                    0,
                                    0
                                ], f = [
                                    0,
                                    0,
                                    0
                                ], p = -1; p <= 1; p += 2){
                                    r.push(s, s + 2, s + 1, s + 1, s + 2, s + 3), h[l] = p, f[l] = p;
                                    for(var d = -1; d <= 1; d += 2){
                                        h[c] = d;
                                        for(var m = -1; m <= 1; m += 2)h[u] = m, e1.push(h[0], h[1], h[2], f[0], f[1], f[2]), s += 1;
                                    }
                                    var g = c;
                                    c = u, u = g;
                                }
                                var y = n(t1, new Float32Array(e1)), v = n(t1, new Uint16Array(r), t1.ELEMENT_ARRAY_BUFFER), x = i(t1, [
                                    {
                                        buffer: y,
                                        type: t1.FLOAT,
                                        size: 3,
                                        offset: 0,
                                        stride: 24
                                    },
                                    {
                                        buffer: y,
                                        type: t1.FLOAT,
                                        size: 3,
                                        offset: 12,
                                        stride: 24
                                    }
                                ], v), _ = a(t1);
                                return _.attributes.position.location = 0, _.attributes.normal.location = 1, new o(t1, y, x, _);
                            };
                            var n = r(2762), i = r(8116), a = r(1879).bg;
                            function o(t1, e1, r, n) {
                                this.gl = t1, this.buffer = e1, this.vao = r, this.shader = n;
                            }
                            var s = o.prototype;
                            s.draw = function(t1, e1, r, n, i, a) {
                                for(var o = !1, s = 0; s < 3; ++s)o = o || i[s];
                                if (o) {
                                    var l = this.gl;
                                    l.enable(l.POLYGON_OFFSET_FILL), l.polygonOffset(1, 2), this.shader.bind(), this.shader.uniforms = {
                                        model: t1,
                                        view: e1,
                                        projection: r,
                                        bounds: n,
                                        enable: i,
                                        colors: a
                                    }, this.vao.bind(), this.vao.draw(this.gl.TRIANGLES, 36), this.vao.unbind(), l.disable(l.POLYGON_OFFSET_FILL);
                                }
                            }, s.dispose = function() {
                                this.vao.dispose(), this.buffer.dispose(), this.shader.dispose();
                            };
                        },
                        6429: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1, r, a, p) {
                                i(s, e1, t1), i(s, r, s);
                                for(var v = 0, x = 0; x < 2; ++x){
                                    u[2] = a[x][2];
                                    for(var _ = 0; _ < 2; ++_){
                                        u[1] = a[_][1];
                                        for(var b = 0; b < 2; ++b)u[0] = a[b][0], f(l[v], u, s), v += 1;
                                    }
                                }
                                var w = -1;
                                for(x = 0; x < 8; ++x){
                                    for(var T = l[x][3], k = 0; k < 3; ++k)c[x][k] = l[x][k] / T;
                                    p && (c[x][2] *= -1), T < 0 && (w < 0 || c[x][2] < c[w][2]) && (w = x);
                                }
                                if (w < 0) {
                                    w = 0;
                                    for(var A = 0; A < 3; ++A){
                                        for(var M = (A + 2) % 3, S = (A + 1) % 3, E = -1, C = -1, L = 0; L < 2; ++L){
                                            var I = (z = L << A) + (L << M) + (1 - L << S), P = z + (1 - L << M) + (L << S);
                                            o(c[z], c[I], c[P], h) < 0 || (L ? E = 1 : C = 1);
                                        }
                                        if (E < 0 || C < 0) C > E && (w |= 1 << A);
                                        else {
                                            for(L = 0; L < 2; ++L){
                                                I = (z = L << A) + (L << M) + (1 - L << S), P = z + (1 - L << M) + (L << S);
                                                var z, O = d([
                                                    l[z],
                                                    l[I],
                                                    l[P],
                                                    l[z + (1 << M) + (1 << S)]
                                                ]);
                                                L ? E = O : C = O;
                                            }
                                            C > E && (w |= 1 << A);
                                        }
                                    }
                                }
                                var D = 7 ^ w, R = -1;
                                for(x = 0; x < 8; ++x)x !== w && x !== D && (R < 0 || c[R][1] > c[x][1]) && (R = x);
                                var F = -1;
                                for(x = 0; x < 3; ++x)(N = R ^ 1 << x) !== w && N !== D && (F < 0 && (F = N), (S = c[N])[0] < c[F][0] && (F = N));
                                var B = -1;
                                for(x = 0; x < 3; ++x){
                                    var N;
                                    (N = R ^ 1 << x) !== w && N !== D && N !== F && (B < 0 && (B = N), (S = c[N])[0] > c[B][0] && (B = N));
                                }
                                var j = m;
                                j[0] = j[1] = j[2] = 0, j[n.log2(F ^ R)] = R & F, j[n.log2(R ^ B)] = R & B;
                                var U = 7 ^ B;
                                U === w || U === D ? (U = 7 ^ F, j[n.log2(B ^ U)] = U & B) : j[n.log2(F ^ U)] = U & F;
                                var V = g, q = w;
                                for(A = 0; A < 3; ++A)V[A] = q & 1 << A ? -1 : 1;
                                return y;
                            };
                            var n = r(8828), i = r(6760), a = r(5202), o = r(3250), s = new Array(16), l = new Array(8), c = new Array(8), u = new Array(3), h = [
                                0,
                                0,
                                0
                            ];
                            function f(t1, e1, r) {
                                for(var n = 0; n < 4; ++n){
                                    t1[n] = r[12 + n];
                                    for(var i = 0; i < 3; ++i)t1[n] += e1[i] * r[4 * i + n];
                                }
                            }
                            !function() {
                                for(var t1 = 0; t1 < 8; ++t1)l[t1] = [
                                    1,
                                    1,
                                    1,
                                    1
                                ], c[t1] = [
                                    1,
                                    1,
                                    1
                                ];
                            }();
                            var p = [
                                [
                                    0,
                                    0,
                                    1,
                                    0,
                                    0
                                ],
                                [
                                    0,
                                    0,
                                    -1,
                                    1,
                                    0
                                ],
                                [
                                    0,
                                    -1,
                                    0,
                                    1,
                                    0
                                ],
                                [
                                    0,
                                    1,
                                    0,
                                    1,
                                    0
                                ],
                                [
                                    -1,
                                    0,
                                    0,
                                    1,
                                    0
                                ],
                                [
                                    1,
                                    0,
                                    0,
                                    1,
                                    0
                                ]
                            ];
                            function d(t1) {
                                for(var e1 = 0; e1 < p.length; ++e1)if ((t1 = a.positive(t1, p[e1])).length < 3) return 0;
                                var r = t1[0], n = r[0] / r[3], i = r[1] / r[3], o = 0;
                                for(e1 = 1; e1 + 1 < t1.length; ++e1){
                                    var s = t1[e1], l = t1[e1 + 1], c = s[0] / s[3] - n, u = s[1] / s[3] - i, h = l[0] / l[3] - n, f = l[1] / l[3] - i;
                                    o += Math.abs(c * f - u * h);
                                }
                                return o;
                            }
                            var m = [
                                1,
                                1,
                                1
                            ], g = [
                                0,
                                0,
                                0
                            ], y = {
                                cubeEdges: m,
                                axis: g
                            };
                        },
                        501: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1, r) {
                                var o = [], s = [
                                    0,
                                    0,
                                    0
                                ], l = [
                                    0,
                                    0,
                                    0
                                ], c = [
                                    0,
                                    0,
                                    0
                                ], u = [
                                    0,
                                    0,
                                    0
                                ];
                                o.push(0, 0, 1, 0, 1, 1, 0, 0, -1, 0, 0, -1, 0, 1, 1, 0, 1, -1);
                                for(var h = 0; h < 3; ++h){
                                    for(var f = o.length / 3 | 0, d = 0; d < r[h].length; ++d){
                                        var m = +r[h][d].x;
                                        o.push(m, 0, 1, m, 1, 1, m, 0, -1, m, 0, -1, m, 1, 1, m, 1, -1);
                                    }
                                    var g = o.length / 3 | 0;
                                    s[h] = f, l[h] = g - f, f = o.length / 3 | 0;
                                    for(var y = 0; y < r[h].length; ++y)m = +r[h][y].x, o.push(m, 0, 1, m, 1, 1, m, 0, -1, m, 0, -1, m, 1, 1, m, 1, -1);
                                    g = o.length / 3 | 0, c[h] = f, u[h] = g - f;
                                }
                                var v = n(t1, new Float32Array(o)), x = i(t1, [
                                    {
                                        buffer: v,
                                        type: t1.FLOAT,
                                        size: 3,
                                        stride: 0,
                                        offset: 0
                                    }
                                ]), _ = a(t1);
                                return _.attributes.position.location = 0, new p(t1, v, x, _, l, s, u, c);
                            };
                            var n = r(2762), i = r(8116), a = r(1879).n, o = [
                                0,
                                0,
                                0
                            ], s = [
                                0,
                                0,
                                0
                            ], l = [
                                0,
                                0,
                                0
                            ], c = [
                                0,
                                0,
                                0
                            ], u = [
                                1,
                                1
                            ];
                            function h(t1) {
                                return t1[0] = t1[1] = t1[2] = 0, t1;
                            }
                            function f(t1, e1) {
                                return t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1;
                            }
                            function p(t1, e1, r, n, i, a, o, s) {
                                this.gl = t1, this.vertBuffer = e1, this.vao = r, this.shader = n, this.tickCount = i, this.tickOffset = a, this.gridCount = o, this.gridOffset = s;
                            }
                            var d = p.prototype;
                            d.bind = function(t1, e1, r) {
                                this.shader.bind(), this.shader.uniforms.model = t1, this.shader.uniforms.view = e1, this.shader.uniforms.projection = r, u[0] = this.gl.drawingBufferWidth, u[1] = this.gl.drawingBufferHeight, this.shader.uniforms.screenShape = u, this.vao.bind();
                            }, d.unbind = function() {
                                this.vao.unbind();
                            }, d.drawAxisLine = function(t1, e1, r, n, i) {
                                var a = h(s);
                                this.shader.uniforms.majorAxis = s, a[t1] = e1[1][t1] - e1[0][t1], this.shader.uniforms.minorAxis = a;
                                var o, u = f(c, r);
                                u[t1] += e1[0][t1], this.shader.uniforms.offset = u, this.shader.uniforms.lineWidth = i, this.shader.uniforms.color = n, (o = h(l))[(t1 + 2) % 3] = 1, this.shader.uniforms.screenAxis = o, this.vao.draw(this.gl.TRIANGLES, 6), (o = h(l))[(t1 + 1) % 3] = 1, this.shader.uniforms.screenAxis = o, this.vao.draw(this.gl.TRIANGLES, 6);
                            }, d.drawAxisTicks = function(t1, e1, r, n, i) {
                                if (this.tickCount[t1]) {
                                    var a = h(o);
                                    a[t1] = 1, this.shader.uniforms.majorAxis = a, this.shader.uniforms.offset = e1, this.shader.uniforms.minorAxis = r, this.shader.uniforms.color = n, this.shader.uniforms.lineWidth = i;
                                    var s = h(l);
                                    s[t1] = 1, this.shader.uniforms.screenAxis = s, this.vao.draw(this.gl.TRIANGLES, this.tickCount[t1], this.tickOffset[t1]);
                                }
                            }, d.drawGrid = function(t1, e1, r, n, i, a) {
                                if (this.gridCount[t1]) {
                                    var u = h(s);
                                    u[e1] = r[1][e1] - r[0][e1], this.shader.uniforms.minorAxis = u;
                                    var p = f(c, n);
                                    p[e1] += r[0][e1], this.shader.uniforms.offset = p;
                                    var d = h(o);
                                    d[t1] = 1, this.shader.uniforms.majorAxis = d;
                                    var m = h(l);
                                    m[t1] = 1, this.shader.uniforms.screenAxis = m, this.shader.uniforms.lineWidth = a, this.shader.uniforms.color = i, this.vao.draw(this.gl.TRIANGLES, this.gridCount[t1], this.gridOffset[t1]);
                                }
                            }, d.drawZero = function(t1, e1, r, n, i, a) {
                                var o = h(s);
                                this.shader.uniforms.majorAxis = o, o[t1] = r[1][t1] - r[0][t1], this.shader.uniforms.minorAxis = o;
                                var u = f(c, n);
                                u[t1] += r[0][t1], this.shader.uniforms.offset = u;
                                var p = h(l);
                                p[e1] = 1, this.shader.uniforms.screenAxis = p, this.shader.uniforms.lineWidth = a, this.shader.uniforms.color = i, this.vao.draw(this.gl.TRIANGLES, 6);
                            }, d.dispose = function() {
                                this.vao.dispose(), this.vertBuffer.dispose(), this.shader.dispose();
                            };
                        },
                        1879: function(t1, e1, r) {
                            "use strict";
                            var n = r(3236), i = r(9405), a = n([
                                "precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\n\nuniform mat4 model, view, projection;\nuniform vec3 offset, majorAxis, minorAxis, screenAxis;\nuniform float lineWidth;\nuniform vec2 screenShape;\n\nvec3 project(vec3 p) {\n  vec4 pp = projection * (view * (model * vec4(p, 1.0)));\n  return pp.xyz / max(pp.w, 0.0001);\n}\n\nvoid main() {\n  vec3 major = position.x * majorAxis;\n  vec3 minor = position.y * minorAxis;\n\n  vec3 vPosition = major + minor + offset;\n  vec3 pPosition = project(vPosition);\n  vec3 offset = project(vPosition + screenAxis * position.z);\n\n  vec2 screen = normalize((offset - pPosition).xy * screenShape) / screenShape;\n\n  gl_Position = vec4(pPosition + vec3(0.5 * screen * lineWidth, 0), 1.0);\n}\n"
                            ]), o = n([
                                "precision highp float;\n#define GLSLIFY 1\n\nuniform vec4 color;\nvoid main() {\n  gl_FragColor = color;\n}"
                            ]);
                            e1.n = function(t1) {
                                return i(t1, a, o, null, [
                                    {
                                        name: "position",
                                        type: "vec3"
                                    }
                                ]);
                            };
                            var s = n([
                                "precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\n\nuniform mat4 model, view, projection;\nuniform vec3 offset, axis, alignDir, alignOpt;\nuniform float scale, angle, pixelScale;\nuniform vec2 resolution;\n\nvec3 project(vec3 p) {\n  vec4 pp = projection * (view * (model * vec4(p, 1.0)));\n  return pp.xyz / max(pp.w, 0.0001);\n}\n\nfloat computeViewAngle(vec3 a, vec3 b) {\n  vec3 A = project(a);\n  vec3 B = project(b);\n\n  return atan(\n    (B.y - A.y) * resolution.y,\n    (B.x - A.x) * resolution.x\n  );\n}\n\nconst float PI = 3.141592;\nconst float TWO_PI = 2.0 * PI;\nconst float HALF_PI = 0.5 * PI;\nconst float ONE_AND_HALF_PI = 1.5 * PI;\n\nint option = int(floor(alignOpt.x + 0.001));\nfloat hv_ratio =       alignOpt.y;\nbool enableAlign =    (alignOpt.z != 0.0);\n\nfloat mod_angle(float a) {\n  return mod(a, PI);\n}\n\nfloat positive_angle(float a) {\n  return mod_angle((a < 0.0) ?\n    a + TWO_PI :\n    a\n  );\n}\n\nfloat look_upwards(float a) {\n  float b = positive_angle(a);\n  return ((b > HALF_PI) && (b <= ONE_AND_HALF_PI)) ?\n    b - PI :\n    b;\n}\n\nfloat look_horizontal_or_vertical(float a, float ratio) {\n  // ratio controls the ratio between being horizontal to (vertical + horizontal)\n  // if ratio is set to 0.5 then it is 50%, 50%.\n  // when using a higher ratio e.g. 0.75 the result would\n  // likely be more horizontal than vertical.\n\n  float b = positive_angle(a);\n\n  return\n    (b < (      ratio) * HALF_PI) ? 0.0 :\n    (b < (2.0 - ratio) * HALF_PI) ? -HALF_PI :\n    (b < (2.0 + ratio) * HALF_PI) ? 0.0 :\n    (b < (4.0 - ratio) * HALF_PI) ? HALF_PI :\n                                    0.0;\n}\n\nfloat roundTo(float a, float b) {\n  return float(b * floor((a + 0.5 * b) / b));\n}\n\nfloat look_round_n_directions(float a, int n) {\n  float b = positive_angle(a);\n  float div = TWO_PI / float(n);\n  float c = roundTo(b, div);\n  return look_upwards(c);\n}\n\nfloat applyAlignOption(float rawAngle, float delta) {\n  return\n    (option >  2) ? look_round_n_directions(rawAngle + delta, option) :       // option 3-n: round to n directions\n    (option == 2) ? look_horizontal_or_vertical(rawAngle + delta, hv_ratio) : // horizontal or vertical\n    (option == 1) ? rawAngle + delta :       // use free angle, and flip to align with one direction of the axis\n    (option == 0) ? look_upwards(rawAngle) : // use free angle, and stay upwards\n    (option ==-1) ? 0.0 :                    // useful for backward compatibility, all texts remains horizontal\n                    rawAngle;                // otherwise return back raw input angle\n}\n\nbool isAxisTitle = (axis.x == 0.0) &&\n                   (axis.y == 0.0) &&\n                   (axis.z == 0.0);\n\nvoid main() {\n  //Compute world offset\n  float axisDistance = position.z;\n  vec3 dataPosition = axisDistance * axis + offset;\n\n  float beta = angle; // i.e. user defined attributes for each tick\n\n  float axisAngle;\n  float clipAngle;\n  float flip;\n\n  if (enableAlign) {\n    axisAngle = (isAxisTitle) ? HALF_PI :\n                      computeViewAngle(dataPosition, dataPosition + axis);\n    clipAngle = computeViewAngle(dataPosition, dataPosition + alignDir);\n\n    axisAngle += (sin(axisAngle) < 0.0) ? PI : 0.0;\n    clipAngle += (sin(clipAngle) < 0.0) ? PI : 0.0;\n\n    flip = (dot(vec2(cos(axisAngle), sin(axisAngle)),\n                vec2(sin(clipAngle),-cos(clipAngle))) > 0.0) ? 1.0 : 0.0;\n\n    beta += applyAlignOption(clipAngle, flip * PI);\n  }\n\n  //Compute plane offset\n  vec2 planeCoord = position.xy * pixelScale;\n\n  mat2 planeXform = scale * mat2(\n     cos(beta), sin(beta),\n    -sin(beta), cos(beta)\n  );\n\n  vec2 viewOffset = 2.0 * planeXform * planeCoord / resolution;\n\n  //Compute clip position\n  vec3 clipPosition = project(dataPosition);\n\n  //Apply text offset in clip coordinates\n  clipPosition += vec3(viewOffset, 0.0);\n\n  //Done\n  gl_Position = vec4(clipPosition, 1.0);\n}\n"
                            ]), l = n([
                                "precision highp float;\n#define GLSLIFY 1\n\nuniform vec4 color;\nvoid main() {\n  gl_FragColor = color;\n}"
                            ]);
                            e1.Q = function(t1) {
                                return i(t1, s, l, null, [
                                    {
                                        name: "position",
                                        type: "vec3"
                                    }
                                ]);
                            };
                            var c = n([
                                "precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\nattribute vec3 normal;\n\nuniform mat4 model, view, projection;\nuniform vec3 enable;\nuniform vec3 bounds[2];\n\nvarying vec3 colorChannel;\n\nvoid main() {\n\n  vec3 signAxis = sign(bounds[1] - bounds[0]);\n\n  vec3 realNormal = signAxis * normal;\n\n  if(dot(realNormal, enable) > 0.0) {\n    vec3 minRange = min(bounds[0], bounds[1]);\n    vec3 maxRange = max(bounds[0], bounds[1]);\n    vec3 nPosition = mix(minRange, maxRange, 0.5 * (position + 1.0));\n    gl_Position = projection * (view * (model * vec4(nPosition, 1.0)));\n  } else {\n    gl_Position = vec4(0,0,0,0);\n  }\n\n  colorChannel = abs(realNormal);\n}\n"
                            ]), u = n([
                                "precision highp float;\n#define GLSLIFY 1\n\nuniform vec4 colors[3];\n\nvarying vec3 colorChannel;\n\nvoid main() {\n  gl_FragColor = colorChannel.x * colors[0] +\n                 colorChannel.y * colors[1] +\n                 colorChannel.z * colors[2];\n}"
                            ]);
                            e1.bg = function(t1) {
                                return i(t1, c, u, null, [
                                    {
                                        name: "position",
                                        type: "vec3"
                                    },
                                    {
                                        name: "normal",
                                        type: "vec3"
                                    }
                                ]);
                            };
                        },
                        4935: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1, r, i, o, l) {
                                var c = n(t1), h = a(t1, [
                                    {
                                        buffer: c,
                                        size: 3
                                    }
                                ]), f = s(t1);
                                f.attributes.position.location = 0;
                                var p = new u(t1, f, c, h);
                                return p.update(e1, r, i, o, l), p;
                            };
                            var n = r(2762), a = r(8116), o = r(4359), s = r(1879).Q, l = window || i.global || {}, c = l.__TEXT_CACHE || {};
                            function u(t1, e1, r, n) {
                                this.gl = t1, this.shader = e1, this.buffer = r, this.vao = n, this.tickOffset = this.tickCount = this.labelOffset = this.labelCount = null;
                            }
                            l.__TEXT_CACHE = {};
                            var h = u.prototype, f = [
                                0,
                                0
                            ];
                            h.bind = function(t1, e1, r, n) {
                                this.vao.bind(), this.shader.bind();
                                var i = this.shader.uniforms;
                                i.model = t1, i.view = e1, i.projection = r, i.pixelScale = n, f[0] = this.gl.drawingBufferWidth, f[1] = this.gl.drawingBufferHeight, this.shader.uniforms.resolution = f;
                            }, h.unbind = function() {
                                this.vao.unbind();
                            }, h.update = function(t1, e1, r, n, i) {
                                var a = [];
                                function s(t1, e1, r, n, i, s) {
                                    var l = [
                                        r.style,
                                        r.weight,
                                        r.variant,
                                        r.family
                                    ].join("_"), u = c[l];
                                    u || (u = c[l] = {});
                                    var h = u[e1];
                                    h || (h = u[e1] = function(t1, e1) {
                                        try {
                                            return o(t1, e1);
                                        } catch (e1) {
                                            return console.warn('error vectorizing text:"' + t1 + '" error:', e1), {
                                                cells: [],
                                                positions: []
                                            };
                                        }
                                    }(e1, {
                                        triangles: !0,
                                        font: r.family,
                                        fontStyle: r.style,
                                        fontWeight: r.weight,
                                        fontVariant: r.variant,
                                        textAlign: "center",
                                        textBaseline: "middle",
                                        lineSpacing: i,
                                        styletags: s
                                    }));
                                    for(var f = (n || 12) / 12, p = h.positions, d = h.cells, m = 0, g = d.length; m < g; ++m)for(var y = d[m], v = 2; v >= 0; --v){
                                        var x = p[y[v]];
                                        a.push(f * x[0], -f * x[1], t1);
                                    }
                                }
                                for(var l = [
                                    0,
                                    0,
                                    0
                                ], u = [
                                    0,
                                    0,
                                    0
                                ], h = [
                                    0,
                                    0,
                                    0
                                ], f = [
                                    0,
                                    0,
                                    0
                                ], p = {
                                    breaklines: !0,
                                    bolds: !0,
                                    italics: !0,
                                    subscripts: !0,
                                    superscripts: !0
                                }, d = 0; d < 3; ++d){
                                    h[d] = a.length / 3 | 0, s(.5 * (t1[0][d] + t1[1][d]), e1[d], r[d], 12, 1.25, p), f[d] = (a.length / 3 | 0) - h[d], l[d] = a.length / 3 | 0;
                                    for(var m = 0; m < n[d].length; ++m)if (n[d][m].text) {
                                        var g = {
                                            family: n[d][m].font || i[d].family,
                                            style: i[d].fontStyle || i[d].style,
                                            weight: i[d].fontWeight || i[d].weight,
                                            variant: i[d].fontVariant || i[d].variant
                                        };
                                        s(n[d][m].x, n[d][m].text, g, n[d][m].fontSize || 12, 1.25, p);
                                    }
                                    u[d] = (a.length / 3 | 0) - l[d];
                                }
                                this.buffer.update(a), this.tickOffset = l, this.tickCount = u, this.labelOffset = h, this.labelCount = f;
                            }, h.drawTicks = function(t1, e1, r, n, i, a, o, s) {
                                this.tickCount[t1] && (this.shader.uniforms.axis = a, this.shader.uniforms.color = i, this.shader.uniforms.angle = r, this.shader.uniforms.scale = e1, this.shader.uniforms.offset = n, this.shader.uniforms.alignDir = o, this.shader.uniforms.alignOpt = s, this.vao.draw(this.gl.TRIANGLES, this.tickCount[t1], this.tickOffset[t1]));
                            }, h.drawLabel = function(t1, e1, r, n, i, a, o, s) {
                                this.labelCount[t1] && (this.shader.uniforms.axis = a, this.shader.uniforms.color = i, this.shader.uniforms.angle = r, this.shader.uniforms.scale = e1, this.shader.uniforms.offset = n, this.shader.uniforms.alignDir = o, this.shader.uniforms.alignOpt = s, this.vao.draw(this.gl.TRIANGLES, this.labelCount[t1], this.labelOffset[t1]));
                            }, h.dispose = function() {
                                this.shader.dispose(), this.vao.dispose(), this.buffer.dispose();
                            };
                        },
                        6444: function(t1, e1) {
                            "use strict";
                            function r(t1, e1) {
                                var r = t1 + "", n = r.indexOf("."), i = 0;
                                n >= 0 && (i = r.length - n - 1);
                                var a = Math.pow(10, i), o = Math.round(t1 * e1 * a), s = o + "";
                                if (s.indexOf("e") >= 0) return s;
                                var l = o / a, c = o % a;
                                o < 0 ? (l = 0 | -Math.ceil(l), c = 0 | -c) : (l = 0 | Math.floor(l), c |= 0);
                                var u = "" + l;
                                if (o < 0 && (u = "-" + u), i) {
                                    for(var h = "" + c; h.length < i;)h = "0" + h;
                                    return u + "." + h;
                                }
                                return u;
                            }
                            e1.create = function(t1, e1) {
                                for(var n = [], i = 0; i < 3; ++i){
                                    for(var a = [], o = (t1[0][i], t1[1][i], 0); o * e1[i] <= t1[1][i]; ++o)a.push({
                                        x: o * e1[i],
                                        text: r(e1[i], o)
                                    });
                                    for(o = -1; o * e1[i] >= t1[0][i]; --o)a.push({
                                        x: o * e1[i],
                                        text: r(e1[i], o)
                                    });
                                    n.push(a);
                                }
                                return n;
                            }, e1.equal = function(t1, e1) {
                                for(var r = 0; r < 3; ++r){
                                    if (t1[r].length !== e1[r].length) return !1;
                                    for(var n = 0; n < t1[r].length; ++n){
                                        var i = t1[r][n], a = e1[r][n];
                                        if (i.x !== a.x || i.text !== a.text || i.font !== a.font || i.fontColor !== a.fontColor || i.fontSize !== a.fontSize || i.dx !== a.dx || i.dy !== a.dy) return !1;
                                    }
                                }
                                return !0;
                            };
                        },
                        5445: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1, r, l, h) {
                                var f = e1.model || c, p = e1.view || c, y = e1.projection || c, v = e1._ortho || !1, x = t1.bounds, _ = (h = h || a(f, p, y, x, v)).axis;
                                o(u, p, f), o(u, y, u);
                                for(var b = m, w = 0; w < 3; ++w)b[w].lo = 1 / 0, b[w].hi = -1 / 0, b[w].pixelsPerDataUnit = 1 / 0;
                                var T = n(s(u, u));
                                s(u, u);
                                for(var k = 0; k < 3; ++k){
                                    var A = (k + 1) % 3, M = (k + 2) % 3, S = g;
                                    t: for(w = 0; w < 2; ++w){
                                        var E = [];
                                        if (_[k] < 0 != !!w) {
                                            S[k] = x[w][k];
                                            for(var C = 0; C < 2; ++C){
                                                S[A] = x[C ^ w][A];
                                                for(var L = 0; L < 2; ++L)S[M] = x[L ^ C ^ w][M], E.push(S.slice());
                                            }
                                            var I = v ? 5 : 4;
                                            for(C = I; C === I; ++C){
                                                if (0 === E.length) continue t;
                                                E = i.positive(E, T[C]);
                                            }
                                            for(C = 0; C < E.length; ++C){
                                                M = E[C];
                                                var P = d(g, u, M, r, l);
                                                for(L = 0; L < 3; ++L)b[L].lo = Math.min(b[L].lo, M[L]), b[L].hi = Math.max(b[L].hi, M[L]), L !== k && (b[L].pixelsPerDataUnit = Math.min(b[L].pixelsPerDataUnit, Math.abs(P[L])));
                                            }
                                        }
                                    }
                                }
                                return b;
                            };
                            var n = r(5033), i = r(5202), a = r(6429), o = r(6760), s = r(5665), l = r(5352), c = new Float32Array([
                                1,
                                0,
                                0,
                                0,
                                0,
                                1,
                                0,
                                0,
                                0,
                                0,
                                1,
                                0,
                                0,
                                0,
                                0,
                                1
                            ]), u = new Float32Array(16);
                            function h(t1, e1, r) {
                                this.lo = t1, this.hi = e1, this.pixelsPerDataUnit = r;
                            }
                            var f = [
                                0,
                                0,
                                0,
                                1
                            ], p = [
                                0,
                                0,
                                0,
                                1
                            ];
                            function d(t1, e1, r, n, i) {
                                for(var a = 0; a < 3; ++a){
                                    for(var o = f, s = p, c = 0; c < 3; ++c)s[c] = o[c] = r[c];
                                    s[3] = o[3] = 1, s[a] += 1, l(s, s, e1), s[3] < 0 && (t1[a] = 1 / 0), o[a] -= 1, l(o, o, e1), o[3] < 0 && (t1[a] = 1 / 0);
                                    var u = (o[0] / o[3] - s[0] / s[3]) * n, h = (o[1] / o[3] - s[1] / s[3]) * i;
                                    t1[a] = .25 * Math.sqrt(u * u + h * h);
                                }
                                return t1;
                            }
                            var m = [
                                new h(1 / 0, -1 / 0, 1 / 0),
                                new h(1 / 0, -1 / 0, 1 / 0),
                                new h(1 / 0, -1 / 0, 1 / 0)
                            ], g = [
                                0,
                                0,
                                0
                            ];
                        },
                        2762: function(t1, e1, r) {
                            "use strict";
                            var n = r(1888), i = r(5298), a = r(9618), o = [
                                "uint8",
                                "uint8_clamped",
                                "uint16",
                                "uint32",
                                "int8",
                                "int16",
                                "int32",
                                "float32"
                            ];
                            function s(t1, e1, r, n, i) {
                                this.gl = t1, this.type = e1, this.handle = r, this.length = n, this.usage = i;
                            }
                            var l = s.prototype;
                            function c(t1, e1, r, n, i, a) {
                                var o = i.length * i.BYTES_PER_ELEMENT;
                                if (a < 0) return t1.bufferData(e1, i, n), o;
                                if (o + a > r) throw new Error("gl-buffer: If resizing buffer, must not specify offset");
                                return t1.bufferSubData(e1, a, i), r;
                            }
                            function u(t1, e1) {
                                for(var r = n.malloc(t1.length, e1), i = t1.length, a = 0; a < i; ++a)r[a] = t1[a];
                                return r;
                            }
                            l.bind = function() {
                                this.gl.bindBuffer(this.type, this.handle);
                            }, l.unbind = function() {
                                this.gl.bindBuffer(this.type, null);
                            }, l.dispose = function() {
                                this.gl.deleteBuffer(this.handle);
                            }, l.update = function(t1, e1) {
                                if ("number" != typeof e1 && (e1 = -1), this.bind(), "object" == typeof t1 && void 0 !== t1.shape) {
                                    var r = t1.dtype;
                                    if (o.indexOf(r) < 0 && (r = "float32"), this.type === this.gl.ELEMENT_ARRAY_BUFFER && (r = gl.getExtension("OES_element_index_uint") && "uint16" !== r ? "uint32" : "uint16"), r === t1.dtype && function(t1, e1) {
                                        for(var r = 1, n = e1.length - 1; n >= 0; --n){
                                            if (e1[n] !== r) return !1;
                                            r *= t1[n];
                                        }
                                        return !0;
                                    }(t1.shape, t1.stride)) 0 === t1.offset && t1.data.length === t1.shape[0] ? this.length = c(this.gl, this.type, this.length, this.usage, t1.data, e1) : this.length = c(this.gl, this.type, this.length, this.usage, t1.data.subarray(t1.offset, t1.shape[0]), e1);
                                    else {
                                        var s = n.malloc(t1.size, r), l = a(s, t1.shape);
                                        i.assign(l, t1), this.length = c(this.gl, this.type, this.length, this.usage, e1 < 0 ? s : s.subarray(0, t1.size), e1), n.free(s);
                                    }
                                } else if (Array.isArray(t1)) {
                                    var h;
                                    h = this.type === this.gl.ELEMENT_ARRAY_BUFFER ? u(t1, "uint16") : u(t1, "float32"), this.length = c(this.gl, this.type, this.length, this.usage, e1 < 0 ? h : h.subarray(0, t1.length), e1), n.free(h);
                                } else if ("object" == typeof t1 && "number" == typeof t1.length) this.length = c(this.gl, this.type, this.length, this.usage, t1, e1);
                                else {
                                    if ("number" != typeof t1 && void 0 !== t1) throw new Error("gl-buffer: Invalid data type");
                                    if (e1 >= 0) throw new Error("gl-buffer: Cannot specify offset when resizing buffer");
                                    (t1 |= 0) <= 0 && (t1 = 1), this.gl.bufferData(this.type, 0 | t1, this.usage), this.length = t1;
                                }
                            }, t1.exports = function(t1, e1, r, n) {
                                if (r = r || t1.ARRAY_BUFFER, n = n || t1.DYNAMIC_DRAW, r !== t1.ARRAY_BUFFER && r !== t1.ELEMENT_ARRAY_BUFFER) throw new Error("gl-buffer: Invalid type for webgl buffer, must be either gl.ARRAY_BUFFER or gl.ELEMENT_ARRAY_BUFFER");
                                if (n !== t1.DYNAMIC_DRAW && n !== t1.STATIC_DRAW && n !== t1.STREAM_DRAW) throw new Error("gl-buffer: Invalid usage for buffer, must be either gl.DYNAMIC_DRAW, gl.STATIC_DRAW or gl.STREAM_DRAW");
                                var i = t1.createBuffer(), a = new s(t1, r, i, 0, n);
                                return a.update(e1), a;
                            };
                        },
                        6405: function(t1, e1, r) {
                            "use strict";
                            var n = r(2931);
                            t1.exports = function(t1, e1) {
                                var r = t1.positions, i = t1.vectors, a = {
                                    positions: [],
                                    vertexIntensity: [],
                                    vertexIntensityBounds: t1.vertexIntensityBounds,
                                    vectors: [],
                                    cells: [],
                                    coneOffset: t1.coneOffset,
                                    colormap: t1.colormap
                                };
                                if (0 === t1.positions.length) return e1 && (e1[0] = [
                                    0,
                                    0,
                                    0
                                ], e1[1] = [
                                    0,
                                    0,
                                    0
                                ]), a;
                                for(var o = 0, s = 1 / 0, l = -1 / 0, c = 1 / 0, u = -1 / 0, h = 1 / 0, f = -1 / 0, p = null, d = null, m = [], g = 1 / 0, y = !1, v = "raw" === t1.coneSizemode, x = 0; x < r.length; x++){
                                    var _ = r[x];
                                    s = Math.min(_[0], s), l = Math.max(_[0], l), c = Math.min(_[1], c), u = Math.max(_[1], u), h = Math.min(_[2], h), f = Math.max(_[2], f);
                                    var b = i[x];
                                    if (n.length(b) > o && (o = n.length(b)), x && !v) {
                                        var w = 2 * n.distance(p, _) / (n.length(d) + n.length(b));
                                        w ? (g = Math.min(g, w), y = !1) : y = !0;
                                    }
                                    y || (p = _, d = b), m.push(b);
                                }
                                var T = [
                                    s,
                                    c,
                                    h
                                ], k = [
                                    l,
                                    u,
                                    f
                                ];
                                e1 && (e1[0] = T, e1[1] = k), 0 === o && (o = 1);
                                var A = 1 / o;
                                isFinite(g) || (g = 1), a.vectorScale = g;
                                var M = t1.coneSize || (v ? 1 : .5);
                                t1.absoluteConeSize && (M = t1.absoluteConeSize * A), a.coneScale = M, x = 0;
                                for(var S = 0; x < r.length; x++)for(var E = (_ = r[x])[0], C = _[1], L = _[2], I = m[x], P = n.length(I) * A, z = 0; z < 8; z++){
                                    a.positions.push([
                                        E,
                                        C,
                                        L,
                                        S++
                                    ]), a.positions.push([
                                        E,
                                        C,
                                        L,
                                        S++
                                    ]), a.positions.push([
                                        E,
                                        C,
                                        L,
                                        S++
                                    ]), a.positions.push([
                                        E,
                                        C,
                                        L,
                                        S++
                                    ]), a.positions.push([
                                        E,
                                        C,
                                        L,
                                        S++
                                    ]), a.positions.push([
                                        E,
                                        C,
                                        L,
                                        S++
                                    ]), a.vectors.push(I), a.vectors.push(I), a.vectors.push(I), a.vectors.push(I), a.vectors.push(I), a.vectors.push(I), a.vertexIntensity.push(P, P, P), a.vertexIntensity.push(P, P, P);
                                    var O = a.positions.length;
                                    a.cells.push([
                                        O - 6,
                                        O - 5,
                                        O - 4
                                    ], [
                                        O - 3,
                                        O - 2,
                                        O - 1
                                    ]);
                                }
                                return a;
                            };
                            var i = r(614);
                            t1.exports.createMesh = r(9060), t1.exports.createConeMesh = function(e1, r) {
                                return t1.exports.createMesh(e1, r, {
                                    shaders: i,
                                    traceType: "cone"
                                });
                            };
                        },
                        9060: function(t1, e1, r) {
                            "use strict";
                            var n = r(9405), i = r(2762), a = r(8116), o = r(7766), s = r(6760), l = r(7608), c = r(9618), u = r(6729), h = [
                                1,
                                0,
                                0,
                                0,
                                0,
                                1,
                                0,
                                0,
                                0,
                                0,
                                1,
                                0,
                                0,
                                0,
                                0,
                                1
                            ];
                            function f(t1, e1, r, n, i, a, o, s, l, c, u) {
                                this.gl = t1, this.pixelRatio = 1, this.cells = [], this.positions = [], this.intensity = [], this.texture = e1, this.dirty = !0, this.triShader = r, this.pickShader = n, this.trianglePositions = i, this.triangleVectors = a, this.triangleColors = s, this.triangleUVs = l, this.triangleIds = o, this.triangleVAO = c, this.triangleCount = 0, this.pickId = 1, this.bounds = [
                                    [
                                        1 / 0,
                                        1 / 0,
                                        1 / 0
                                    ],
                                    [
                                        -1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ]
                                ], this.clipBounds = [
                                    [
                                        -1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ],
                                    [
                                        1 / 0,
                                        1 / 0,
                                        1 / 0
                                    ]
                                ], this.lightPosition = [
                                    1e5,
                                    1e5,
                                    0
                                ], this.ambientLight = .8, this.diffuseLight = .8, this.specularLight = 2, this.roughness = .5, this.fresnel = 1.5, this.opacity = 1, this.traceType = u, this.tubeScale = 1, this.coneScale = 2, this.vectorScale = 1, this.coneOffset = .25, this._model = h, this._view = h, this._projection = h, this._resolution = [
                                    1,
                                    1
                                ];
                            }
                            var p = f.prototype;
                            p.isOpaque = function() {
                                return this.opacity >= 1;
                            }, p.isTransparent = function() {
                                return this.opacity < 1;
                            }, p.pickSlots = 1, p.setPickBase = function(t1) {
                                this.pickId = t1;
                            }, p.update = function(t1) {
                                t1 = t1 || {};
                                var e1 = this.gl;
                                this.dirty = !0, "lightPosition" in t1 && (this.lightPosition = t1.lightPosition), "opacity" in t1 && (this.opacity = t1.opacity), "ambient" in t1 && (this.ambientLight = t1.ambient), "diffuse" in t1 && (this.diffuseLight = t1.diffuse), "specular" in t1 && (this.specularLight = t1.specular), "roughness" in t1 && (this.roughness = t1.roughness), "fresnel" in t1 && (this.fresnel = t1.fresnel), void 0 !== t1.tubeScale && (this.tubeScale = t1.tubeScale), void 0 !== t1.vectorScale && (this.vectorScale = t1.vectorScale), void 0 !== t1.coneScale && (this.coneScale = t1.coneScale), void 0 !== t1.coneOffset && (this.coneOffset = t1.coneOffset), t1.colormap && (this.texture.shape = [
                                    256,
                                    256
                                ], this.texture.minFilter = e1.LINEAR_MIPMAP_LINEAR, this.texture.magFilter = e1.LINEAR, this.texture.setPixels(function(t1) {
                                    for(var e1 = u({
                                        colormap: t1,
                                        nshades: 256,
                                        format: "rgba"
                                    }), r = new Uint8Array(1024), n = 0; n < 256; ++n){
                                        for(var i = e1[n], a = 0; a < 3; ++a)r[4 * n + a] = i[a];
                                        r[4 * n + 3] = 255 * i[3];
                                    }
                                    return c(r, [
                                        256,
                                        256,
                                        4
                                    ], [
                                        4,
                                        0,
                                        1
                                    ]);
                                }(t1.colormap)), this.texture.generateMipmap());
                                var r = t1.cells, n = t1.positions, i = t1.vectors;
                                if (n && r && i) {
                                    var a = [], o = [], s = [], l = [], h = [];
                                    this.cells = r, this.positions = n, this.vectors = i;
                                    var f = t1.meshColor || [
                                        1,
                                        1,
                                        1,
                                        1
                                    ], p = t1.vertexIntensity, d = 1 / 0, m = -1 / 0;
                                    if (p) {
                                        if (t1.vertexIntensityBounds) d = +t1.vertexIntensityBounds[0], m = +t1.vertexIntensityBounds[1];
                                        else for(var g = 0; g < p.length; ++g){
                                            var y = p[g];
                                            d = Math.min(d, y), m = Math.max(m, y);
                                        }
                                    } else for(g = 0; g < n.length; ++g)y = n[g][2], d = Math.min(d, y), m = Math.max(m, y);
                                    for(this.intensity = p || function(t1) {
                                        for(var e1 = t1.length, r = new Array(e1), n = 0; n < e1; ++n)r[n] = t1[n][2];
                                        return r;
                                    }(n), this.bounds = [
                                        [
                                            1 / 0,
                                            1 / 0,
                                            1 / 0
                                        ],
                                        [
                                            -1 / 0,
                                            -1 / 0,
                                            -1 / 0
                                        ]
                                    ], g = 0; g < n.length; ++g)for(var v = n[g], x = 0; x < 3; ++x)!isNaN(v[x]) && isFinite(v[x]) && (this.bounds[0][x] = Math.min(this.bounds[0][x], v[x]), this.bounds[1][x] = Math.max(this.bounds[1][x], v[x]));
                                    var _ = 0;
                                    t: for(g = 0; g < r.length; ++g){
                                        var b = r[g];
                                        if (3 === b.length) {
                                            for(x = 0; x < 3; ++x){
                                                v = n[T = b[x]];
                                                for(var w = 0; w < 3; ++w)if (isNaN(v[w]) || !isFinite(v[w])) continue t;
                                            }
                                            for(x = 0; x < 3; ++x){
                                                var T;
                                                v = n[T = b[2 - x]], a.push(v[0], v[1], v[2], v[3]);
                                                var k = i[T];
                                                o.push(k[0], k[1], k[2], k[3] || 0);
                                                var A, M = f;
                                                3 === M.length ? s.push(M[0], M[1], M[2], 1) : s.push(M[0], M[1], M[2], M[3]), A = p ? [
                                                    (p[T] - d) / (m - d),
                                                    0
                                                ] : [
                                                    (v[2] - d) / (m - d),
                                                    0
                                                ], l.push(A[0], A[1]), h.push(g);
                                            }
                                            _ += 1;
                                        }
                                    }
                                    this.triangleCount = _, this.trianglePositions.update(a), this.triangleVectors.update(o), this.triangleColors.update(s), this.triangleUVs.update(l), this.triangleIds.update(new Uint32Array(h));
                                }
                            }, p.drawTransparent = p.draw = function(t1) {
                                t1 = t1 || {};
                                for(var e1 = this.gl, r = t1.model || h, n = t1.view || h, i = t1.projection || h, a = [
                                    [
                                        -1000000,
                                        -1000000,
                                        -1000000
                                    ],
                                    [
                                        1e6,
                                        1e6,
                                        1e6
                                    ]
                                ], o = 0; o < 3; ++o)a[0][o] = Math.max(a[0][o], this.clipBounds[0][o]), a[1][o] = Math.min(a[1][o], this.clipBounds[1][o]);
                                var c = {
                                    model: r,
                                    view: n,
                                    projection: i,
                                    inverseModel: h.slice(),
                                    clipBounds: a,
                                    kambient: this.ambientLight,
                                    kdiffuse: this.diffuseLight,
                                    kspecular: this.specularLight,
                                    roughness: this.roughness,
                                    fresnel: this.fresnel,
                                    eyePosition: [
                                        0,
                                        0,
                                        0
                                    ],
                                    lightPosition: [
                                        0,
                                        0,
                                        0
                                    ],
                                    opacity: this.opacity,
                                    tubeScale: this.tubeScale,
                                    vectorScale: this.vectorScale,
                                    coneScale: this.coneScale,
                                    coneOffset: this.coneOffset,
                                    texture: 0
                                };
                                c.inverseModel = l(c.inverseModel, c.model), e1.disable(e1.CULL_FACE), this.texture.bind(0);
                                var u = new Array(16);
                                for(s(u, c.view, c.model), s(u, c.projection, u), l(u, u), o = 0; o < 3; ++o)c.eyePosition[o] = u[12 + o] / u[15];
                                var f = u[15];
                                for(o = 0; o < 3; ++o)f += this.lightPosition[o] * u[4 * o + 3];
                                for(o = 0; o < 3; ++o){
                                    for(var p = u[12 + o], d = 0; d < 3; ++d)p += u[4 * d + o] * this.lightPosition[d];
                                    c.lightPosition[o] = p / f;
                                }
                                if (this.triangleCount > 0) {
                                    var m = this.triShader;
                                    m.bind(), m.uniforms = c, this.triangleVAO.bind(), e1.drawArrays(e1.TRIANGLES, 0, 3 * this.triangleCount), this.triangleVAO.unbind();
                                }
                            }, p.drawPick = function(t1) {
                                t1 = t1 || {};
                                for(var e1 = this.gl, r = t1.model || h, n = t1.view || h, i = t1.projection || h, a = [
                                    [
                                        -1000000,
                                        -1000000,
                                        -1000000
                                    ],
                                    [
                                        1e6,
                                        1e6,
                                        1e6
                                    ]
                                ], o = 0; o < 3; ++o)a[0][o] = Math.max(a[0][o], this.clipBounds[0][o]), a[1][o] = Math.min(a[1][o], this.clipBounds[1][o]);
                                this._model = [].slice.call(r), this._view = [].slice.call(n), this._projection = [].slice.call(i), this._resolution = [
                                    e1.drawingBufferWidth,
                                    e1.drawingBufferHeight
                                ];
                                var s = {
                                    model: r,
                                    view: n,
                                    projection: i,
                                    clipBounds: a,
                                    tubeScale: this.tubeScale,
                                    vectorScale: this.vectorScale,
                                    coneScale: this.coneScale,
                                    coneOffset: this.coneOffset,
                                    pickId: this.pickId / 255
                                }, l = this.pickShader;
                                l.bind(), l.uniforms = s, this.triangleCount > 0 && (this.triangleVAO.bind(), e1.drawArrays(e1.TRIANGLES, 0, 3 * this.triangleCount), this.triangleVAO.unbind());
                            }, p.pick = function(t1) {
                                if (!t1) return null;
                                if (t1.id !== this.pickId) return null;
                                var e1 = t1.value[0] + 256 * t1.value[1] + 65536 * t1.value[2], r = this.cells[e1], n = this.positions[r[1]].slice(0, 3), i = {
                                    position: n,
                                    dataCoordinate: n,
                                    index: Math.floor(r[1] / 48)
                                };
                                return "cone" === this.traceType ? i.index = Math.floor(r[1] / 48) : "streamtube" === this.traceType && (i.intensity = this.intensity[r[1]], i.velocity = this.vectors[r[1]].slice(0, 3), i.divergence = this.vectors[r[1]][3], i.index = e1), i;
                            }, p.dispose = function() {
                                this.texture.dispose(), this.triShader.dispose(), this.pickShader.dispose(), this.triangleVAO.dispose(), this.trianglePositions.dispose(), this.triangleVectors.dispose(), this.triangleColors.dispose(), this.triangleUVs.dispose(), this.triangleIds.dispose();
                            }, t1.exports = function(t1, e1, r) {
                                var s = r.shaders;
                                1 === arguments.length && (t1 = (e1 = t1).gl);
                                var l = function(t1, e1) {
                                    var r = n(t1, e1.meshShader.vertex, e1.meshShader.fragment, null, e1.meshShader.attributes);
                                    return r.attributes.position.location = 0, r.attributes.color.location = 2, r.attributes.uv.location = 3, r.attributes.vector.location = 4, r;
                                }(t1, s), u = function(t1, e1) {
                                    var r = n(t1, e1.pickShader.vertex, e1.pickShader.fragment, null, e1.pickShader.attributes);
                                    return r.attributes.position.location = 0, r.attributes.id.location = 1, r.attributes.vector.location = 4, r;
                                }(t1, s), h = o(t1, c(new Uint8Array([
                                    255,
                                    255,
                                    255,
                                    255
                                ]), [
                                    1,
                                    1,
                                    4
                                ]));
                                h.generateMipmap(), h.minFilter = t1.LINEAR_MIPMAP_LINEAR, h.magFilter = t1.LINEAR;
                                var p = i(t1), d = i(t1), m = i(t1), g = i(t1), y = i(t1), v = new f(t1, h, l, u, p, d, y, m, g, a(t1, [
                                    {
                                        buffer: p,
                                        type: t1.FLOAT,
                                        size: 4
                                    },
                                    {
                                        buffer: y,
                                        type: t1.UNSIGNED_BYTE,
                                        size: 4,
                                        normalized: !0
                                    },
                                    {
                                        buffer: m,
                                        type: t1.FLOAT,
                                        size: 4
                                    },
                                    {
                                        buffer: g,
                                        type: t1.FLOAT,
                                        size: 2
                                    },
                                    {
                                        buffer: d,
                                        type: t1.FLOAT,
                                        size: 4
                                    }
                                ]), r.traceType || "cone");
                                return v.update(e1), v;
                            };
                        },
                        614: function(t1, e1, r) {
                            var n = r(3236), i = n([
                                "precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the cone vertex and normal at the given index.\n//\n// The returned vertex is for a cone with its top at origin and height of 1.0,\n// pointing in the direction of the vector attribute.\n//\n// Each cone is made up of a top vertex, a center base vertex and base perimeter vertices.\n// These vertices are used to make up the triangles of the cone by the following:\n//   segment + 0 top vertex\n//   segment + 1 perimeter vertex a+1\n//   segment + 2 perimeter vertex a\n//   segment + 3 center base vertex\n//   segment + 4 perimeter vertex a\n//   segment + 5 perimeter vertex a+1\n// Where segment is the number of the radial segment * 6 and a is the angle at that radial segment.\n// To go from index to segment, floor(index / 6)\n// To go from segment to angle, 2*pi * (segment/segmentCount)\n// To go from index to segment index, index - (segment*6)\n//\nvec3 getConePosition(vec3 d, float rawIndex, float coneOffset, out vec3 normal) {\n\n  const float segmentCount = 8.0;\n\n  float index = rawIndex - floor(rawIndex /\n    (segmentCount * 6.0)) *\n    (segmentCount * 6.0);\n\n  float segment = floor(0.001 + index/6.0);\n  float segmentIndex = index - (segment*6.0);\n\n  normal = -normalize(d);\n\n  if (segmentIndex > 2.99 && segmentIndex < 3.01) {\n    return mix(vec3(0.0), -d, coneOffset);\n  }\n\n  float nextAngle = (\n    (segmentIndex > 0.99 &&  segmentIndex < 1.01) ||\n    (segmentIndex > 4.99 &&  segmentIndex < 5.01)\n  ) ? 1.0 : 0.0;\n  float angle = 2.0 * 3.14159 * ((segment + nextAngle) / segmentCount);\n\n  vec3 v1 = mix(d, vec3(0.0), coneOffset);\n  vec3 v2 = v1 - d;\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d)*0.25;\n  vec3 y = v * sin(angle) * length(d)*0.25;\n  vec3 v3 = v2 + x + y;\n  if (segmentIndex < 3.0) {\n    vec3 tx = u * sin(angle);\n    vec3 ty = v * -cos(angle);\n    vec3 tangent = tx + ty;\n    normal = normalize(cross(v3 - v1, tangent));\n  }\n\n  if (segmentIndex == 0.0) {\n    return mix(d, vec3(0.0), coneOffset);\n  }\n  return v3;\n}\n\nattribute vec3 vector;\nattribute vec4 color, position;\nattribute vec2 uv;\n\nuniform float vectorScale, coneScale, coneOffset;\nuniform mat4 model, view, projection, inverseModel;\nuniform vec3 eyePosition, lightPosition;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  // Scale the vector magnitude to stay constant with\n  // model & view changes.\n  vec3 normal;\n  vec3 XYZ = getConePosition(mat3(model) * ((vectorScale * coneScale) * vector), position.w, coneOffset, normal);\n  vec4 conePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * conePosition;\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  f_lightDirection = lightPosition - cameraCoordinate.xyz;\n  f_eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  f_normal = normalize((vec4(normal, 0.0) * inverseModel).xyz);\n\n  // vec4 m_position  = model * vec4(conePosition, 1.0);\n  vec4 t_position  = view * conePosition;\n  gl_Position      = projection * t_position;\n\n  f_color          = color;\n  f_data           = conePosition.xyz;\n  f_position       = position.xyz;\n  f_uv             = uv;\n}\n"
                            ]), a = n([
                                "#extension GL_OES_standard_derivatives : enable\n\nprecision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat cookTorranceSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness,\n  float fresnel) {\n\n  float VdotN = max(dot(viewDirection, surfaceNormal), 0.0);\n  float LdotN = max(dot(lightDirection, surfaceNormal), 0.0);\n\n  //Half angle vector\n  vec3 H = normalize(lightDirection + viewDirection);\n\n  //Geometric term\n  float NdotH = max(dot(surfaceNormal, H), 0.0);\n  float VdotH = max(dot(viewDirection, H), 0.000001);\n  float LdotH = max(dot(lightDirection, H), 0.000001);\n  float G1 = (2.0 * NdotH * VdotN) / VdotH;\n  float G2 = (2.0 * NdotH * LdotN) / LdotH;\n  float G = min(1.0, min(G1, G2));\n  \n  //Distribution term\n  float D = beckmannDistribution(NdotH, roughness);\n\n  //Fresnel term\n  float F = pow(1.0 - VdotN, fresnel);\n\n  //Multiply terms and done\n  return  G * F * D / max(3.14159265 * VdotN, 0.000001);\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float roughness, fresnel, kambient, kdiffuse, kspecular, opacity;\nuniform sampler2D texture;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n  vec3 N = normalize(f_normal);\n  vec3 L = normalize(f_lightDirection);\n  vec3 V = normalize(f_eyeDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = min(1.0, max(0.0, cookTorranceSpecular(L, V, N, roughness, fresnel)));\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  vec4 surfaceColor = f_color * texture2D(texture, f_uv);\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = litColor * opacity;\n}\n"
                            ]), o = n([
                                "precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the cone vertex and normal at the given index.\n//\n// The returned vertex is for a cone with its top at origin and height of 1.0,\n// pointing in the direction of the vector attribute.\n//\n// Each cone is made up of a top vertex, a center base vertex and base perimeter vertices.\n// These vertices are used to make up the triangles of the cone by the following:\n//   segment + 0 top vertex\n//   segment + 1 perimeter vertex a+1\n//   segment + 2 perimeter vertex a\n//   segment + 3 center base vertex\n//   segment + 4 perimeter vertex a\n//   segment + 5 perimeter vertex a+1\n// Where segment is the number of the radial segment * 6 and a is the angle at that radial segment.\n// To go from index to segment, floor(index / 6)\n// To go from segment to angle, 2*pi * (segment/segmentCount)\n// To go from index to segment index, index - (segment*6)\n//\nvec3 getConePosition(vec3 d, float rawIndex, float coneOffset, out vec3 normal) {\n\n  const float segmentCount = 8.0;\n\n  float index = rawIndex - floor(rawIndex /\n    (segmentCount * 6.0)) *\n    (segmentCount * 6.0);\n\n  float segment = floor(0.001 + index/6.0);\n  float segmentIndex = index - (segment*6.0);\n\n  normal = -normalize(d);\n\n  if (segmentIndex > 2.99 && segmentIndex < 3.01) {\n    return mix(vec3(0.0), -d, coneOffset);\n  }\n\n  float nextAngle = (\n    (segmentIndex > 0.99 &&  segmentIndex < 1.01) ||\n    (segmentIndex > 4.99 &&  segmentIndex < 5.01)\n  ) ? 1.0 : 0.0;\n  float angle = 2.0 * 3.14159 * ((segment + nextAngle) / segmentCount);\n\n  vec3 v1 = mix(d, vec3(0.0), coneOffset);\n  vec3 v2 = v1 - d;\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d)*0.25;\n  vec3 y = v * sin(angle) * length(d)*0.25;\n  vec3 v3 = v2 + x + y;\n  if (segmentIndex < 3.0) {\n    vec3 tx = u * sin(angle);\n    vec3 ty = v * -cos(angle);\n    vec3 tangent = tx + ty;\n    normal = normalize(cross(v3 - v1, tangent));\n  }\n\n  if (segmentIndex == 0.0) {\n    return mix(d, vec3(0.0), coneOffset);\n  }\n  return v3;\n}\n\nattribute vec4 vector;\nattribute vec4 position;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\nuniform float vectorScale, coneScale, coneOffset;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  vec3 normal;\n  vec3 XYZ = getConePosition(mat3(model) * ((vectorScale * coneScale) * vector.xyz), position.w, coneOffset, normal);\n  vec4 conePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n  gl_Position = projection * (view * conePosition);\n  f_id        = id;\n  f_position  = position.xyz;\n}\n"
                            ]), s = n([
                                "precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3  clipBounds[2];\nuniform float pickId;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n\n  gl_FragColor = vec4(pickId, f_id.xyz);\n}"
                            ]);
                            e1.meshShader = {
                                vertex: i,
                                fragment: a,
                                attributes: [
                                    {
                                        name: "position",
                                        type: "vec4"
                                    },
                                    {
                                        name: "color",
                                        type: "vec4"
                                    },
                                    {
                                        name: "uv",
                                        type: "vec2"
                                    },
                                    {
                                        name: "vector",
                                        type: "vec3"
                                    }
                                ]
                            }, e1.pickShader = {
                                vertex: o,
                                fragment: s,
                                attributes: [
                                    {
                                        name: "position",
                                        type: "vec4"
                                    },
                                    {
                                        name: "id",
                                        type: "vec4"
                                    },
                                    {
                                        name: "vector",
                                        type: "vec3"
                                    }
                                ]
                            };
                        },
                        737: function(t1) {
                            t1.exports = {
                                0: "NONE",
                                1: "ONE",
                                2: "LINE_LOOP",
                                3: "LINE_STRIP",
                                4: "TRIANGLES",
                                5: "TRIANGLE_STRIP",
                                6: "TRIANGLE_FAN",
                                256: "DEPTH_BUFFER_BIT",
                                512: "NEVER",
                                513: "LESS",
                                514: "EQUAL",
                                515: "LEQUAL",
                                516: "GREATER",
                                517: "NOTEQUAL",
                                518: "GEQUAL",
                                519: "ALWAYS",
                                768: "SRC_COLOR",
                                769: "ONE_MINUS_SRC_COLOR",
                                770: "SRC_ALPHA",
                                771: "ONE_MINUS_SRC_ALPHA",
                                772: "DST_ALPHA",
                                773: "ONE_MINUS_DST_ALPHA",
                                774: "DST_COLOR",
                                775: "ONE_MINUS_DST_COLOR",
                                776: "SRC_ALPHA_SATURATE",
                                1024: "STENCIL_BUFFER_BIT",
                                1028: "FRONT",
                                1029: "BACK",
                                1032: "FRONT_AND_BACK",
                                1280: "INVALID_ENUM",
                                1281: "INVALID_VALUE",
                                1282: "INVALID_OPERATION",
                                1285: "OUT_OF_MEMORY",
                                1286: "INVALID_FRAMEBUFFER_OPERATION",
                                2304: "CW",
                                2305: "CCW",
                                2849: "LINE_WIDTH",
                                2884: "CULL_FACE",
                                2885: "CULL_FACE_MODE",
                                2886: "FRONT_FACE",
                                2928: "DEPTH_RANGE",
                                2929: "DEPTH_TEST",
                                2930: "DEPTH_WRITEMASK",
                                2931: "DEPTH_CLEAR_VALUE",
                                2932: "DEPTH_FUNC",
                                2960: "STENCIL_TEST",
                                2961: "STENCIL_CLEAR_VALUE",
                                2962: "STENCIL_FUNC",
                                2963: "STENCIL_VALUE_MASK",
                                2964: "STENCIL_FAIL",
                                2965: "STENCIL_PASS_DEPTH_FAIL",
                                2966: "STENCIL_PASS_DEPTH_PASS",
                                2967: "STENCIL_REF",
                                2968: "STENCIL_WRITEMASK",
                                2978: "VIEWPORT",
                                3024: "DITHER",
                                3042: "BLEND",
                                3088: "SCISSOR_BOX",
                                3089: "SCISSOR_TEST",
                                3106: "COLOR_CLEAR_VALUE",
                                3107: "COLOR_WRITEMASK",
                                3317: "UNPACK_ALIGNMENT",
                                3333: "PACK_ALIGNMENT",
                                3379: "MAX_TEXTURE_SIZE",
                                3386: "MAX_VIEWPORT_DIMS",
                                3408: "SUBPIXEL_BITS",
                                3410: "RED_BITS",
                                3411: "GREEN_BITS",
                                3412: "BLUE_BITS",
                                3413: "ALPHA_BITS",
                                3414: "DEPTH_BITS",
                                3415: "STENCIL_BITS",
                                3553: "TEXTURE_2D",
                                4352: "DONT_CARE",
                                4353: "FASTEST",
                                4354: "NICEST",
                                5120: "BYTE",
                                5121: "UNSIGNED_BYTE",
                                5122: "SHORT",
                                5123: "UNSIGNED_SHORT",
                                5124: "INT",
                                5125: "UNSIGNED_INT",
                                5126: "FLOAT",
                                5386: "INVERT",
                                5890: "TEXTURE",
                                6401: "STENCIL_INDEX",
                                6402: "DEPTH_COMPONENT",
                                6406: "ALPHA",
                                6407: "RGB",
                                6408: "RGBA",
                                6409: "LUMINANCE",
                                6410: "LUMINANCE_ALPHA",
                                7680: "KEEP",
                                7681: "REPLACE",
                                7682: "INCR",
                                7683: "DECR",
                                7936: "VENDOR",
                                7937: "RENDERER",
                                7938: "VERSION",
                                9728: "NEAREST",
                                9729: "LINEAR",
                                9984: "NEAREST_MIPMAP_NEAREST",
                                9985: "LINEAR_MIPMAP_NEAREST",
                                9986: "NEAREST_MIPMAP_LINEAR",
                                9987: "LINEAR_MIPMAP_LINEAR",
                                10240: "TEXTURE_MAG_FILTER",
                                10241: "TEXTURE_MIN_FILTER",
                                10242: "TEXTURE_WRAP_S",
                                10243: "TEXTURE_WRAP_T",
                                10497: "REPEAT",
                                10752: "POLYGON_OFFSET_UNITS",
                                16384: "COLOR_BUFFER_BIT",
                                32769: "CONSTANT_COLOR",
                                32770: "ONE_MINUS_CONSTANT_COLOR",
                                32771: "CONSTANT_ALPHA",
                                32772: "ONE_MINUS_CONSTANT_ALPHA",
                                32773: "BLEND_COLOR",
                                32774: "FUNC_ADD",
                                32777: "BLEND_EQUATION_RGB",
                                32778: "FUNC_SUBTRACT",
                                32779: "FUNC_REVERSE_SUBTRACT",
                                32819: "UNSIGNED_SHORT_4_4_4_4",
                                32820: "UNSIGNED_SHORT_5_5_5_1",
                                32823: "POLYGON_OFFSET_FILL",
                                32824: "POLYGON_OFFSET_FACTOR",
                                32854: "RGBA4",
                                32855: "RGB5_A1",
                                32873: "TEXTURE_BINDING_2D",
                                32926: "SAMPLE_ALPHA_TO_COVERAGE",
                                32928: "SAMPLE_COVERAGE",
                                32936: "SAMPLE_BUFFERS",
                                32937: "SAMPLES",
                                32938: "SAMPLE_COVERAGE_VALUE",
                                32939: "SAMPLE_COVERAGE_INVERT",
                                32968: "BLEND_DST_RGB",
                                32969: "BLEND_SRC_RGB",
                                32970: "BLEND_DST_ALPHA",
                                32971: "BLEND_SRC_ALPHA",
                                33071: "CLAMP_TO_EDGE",
                                33170: "GENERATE_MIPMAP_HINT",
                                33189: "DEPTH_COMPONENT16",
                                33306: "DEPTH_STENCIL_ATTACHMENT",
                                33635: "UNSIGNED_SHORT_5_6_5",
                                33648: "MIRRORED_REPEAT",
                                33901: "ALIASED_POINT_SIZE_RANGE",
                                33902: "ALIASED_LINE_WIDTH_RANGE",
                                33984: "TEXTURE0",
                                33985: "TEXTURE1",
                                33986: "TEXTURE2",
                                33987: "TEXTURE3",
                                33988: "TEXTURE4",
                                33989: "TEXTURE5",
                                33990: "TEXTURE6",
                                33991: "TEXTURE7",
                                33992: "TEXTURE8",
                                33993: "TEXTURE9",
                                33994: "TEXTURE10",
                                33995: "TEXTURE11",
                                33996: "TEXTURE12",
                                33997: "TEXTURE13",
                                33998: "TEXTURE14",
                                33999: "TEXTURE15",
                                34e3: "TEXTURE16",
                                34001: "TEXTURE17",
                                34002: "TEXTURE18",
                                34003: "TEXTURE19",
                                34004: "TEXTURE20",
                                34005: "TEXTURE21",
                                34006: "TEXTURE22",
                                34007: "TEXTURE23",
                                34008: "TEXTURE24",
                                34009: "TEXTURE25",
                                34010: "TEXTURE26",
                                34011: "TEXTURE27",
                                34012: "TEXTURE28",
                                34013: "TEXTURE29",
                                34014: "TEXTURE30",
                                34015: "TEXTURE31",
                                34016: "ACTIVE_TEXTURE",
                                34024: "MAX_RENDERBUFFER_SIZE",
                                34041: "DEPTH_STENCIL",
                                34055: "INCR_WRAP",
                                34056: "DECR_WRAP",
                                34067: "TEXTURE_CUBE_MAP",
                                34068: "TEXTURE_BINDING_CUBE_MAP",
                                34069: "TEXTURE_CUBE_MAP_POSITIVE_X",
                                34070: "TEXTURE_CUBE_MAP_NEGATIVE_X",
                                34071: "TEXTURE_CUBE_MAP_POSITIVE_Y",
                                34072: "TEXTURE_CUBE_MAP_NEGATIVE_Y",
                                34073: "TEXTURE_CUBE_MAP_POSITIVE_Z",
                                34074: "TEXTURE_CUBE_MAP_NEGATIVE_Z",
                                34076: "MAX_CUBE_MAP_TEXTURE_SIZE",
                                34338: "VERTEX_ATTRIB_ARRAY_ENABLED",
                                34339: "VERTEX_ATTRIB_ARRAY_SIZE",
                                34340: "VERTEX_ATTRIB_ARRAY_STRIDE",
                                34341: "VERTEX_ATTRIB_ARRAY_TYPE",
                                34342: "CURRENT_VERTEX_ATTRIB",
                                34373: "VERTEX_ATTRIB_ARRAY_POINTER",
                                34466: "NUM_COMPRESSED_TEXTURE_FORMATS",
                                34467: "COMPRESSED_TEXTURE_FORMATS",
                                34660: "BUFFER_SIZE",
                                34661: "BUFFER_USAGE",
                                34816: "STENCIL_BACK_FUNC",
                                34817: "STENCIL_BACK_FAIL",
                                34818: "STENCIL_BACK_PASS_DEPTH_FAIL",
                                34819: "STENCIL_BACK_PASS_DEPTH_PASS",
                                34877: "BLEND_EQUATION_ALPHA",
                                34921: "MAX_VERTEX_ATTRIBS",
                                34922: "VERTEX_ATTRIB_ARRAY_NORMALIZED",
                                34930: "MAX_TEXTURE_IMAGE_UNITS",
                                34962: "ARRAY_BUFFER",
                                34963: "ELEMENT_ARRAY_BUFFER",
                                34964: "ARRAY_BUFFER_BINDING",
                                34965: "ELEMENT_ARRAY_BUFFER_BINDING",
                                34975: "VERTEX_ATTRIB_ARRAY_BUFFER_BINDING",
                                35040: "STREAM_DRAW",
                                35044: "STATIC_DRAW",
                                35048: "DYNAMIC_DRAW",
                                35632: "FRAGMENT_SHADER",
                                35633: "VERTEX_SHADER",
                                35660: "MAX_VERTEX_TEXTURE_IMAGE_UNITS",
                                35661: "MAX_COMBINED_TEXTURE_IMAGE_UNITS",
                                35663: "SHADER_TYPE",
                                35664: "FLOAT_VEC2",
                                35665: "FLOAT_VEC3",
                                35666: "FLOAT_VEC4",
                                35667: "INT_VEC2",
                                35668: "INT_VEC3",
                                35669: "INT_VEC4",
                                35670: "BOOL",
                                35671: "BOOL_VEC2",
                                35672: "BOOL_VEC3",
                                35673: "BOOL_VEC4",
                                35674: "FLOAT_MAT2",
                                35675: "FLOAT_MAT3",
                                35676: "FLOAT_MAT4",
                                35678: "SAMPLER_2D",
                                35680: "SAMPLER_CUBE",
                                35712: "DELETE_STATUS",
                                35713: "COMPILE_STATUS",
                                35714: "LINK_STATUS",
                                35715: "VALIDATE_STATUS",
                                35716: "INFO_LOG_LENGTH",
                                35717: "ATTACHED_SHADERS",
                                35718: "ACTIVE_UNIFORMS",
                                35719: "ACTIVE_UNIFORM_MAX_LENGTH",
                                35720: "SHADER_SOURCE_LENGTH",
                                35721: "ACTIVE_ATTRIBUTES",
                                35722: "ACTIVE_ATTRIBUTE_MAX_LENGTH",
                                35724: "SHADING_LANGUAGE_VERSION",
                                35725: "CURRENT_PROGRAM",
                                36003: "STENCIL_BACK_REF",
                                36004: "STENCIL_BACK_VALUE_MASK",
                                36005: "STENCIL_BACK_WRITEMASK",
                                36006: "FRAMEBUFFER_BINDING",
                                36007: "RENDERBUFFER_BINDING",
                                36048: "FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE",
                                36049: "FRAMEBUFFER_ATTACHMENT_OBJECT_NAME",
                                36050: "FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL",
                                36051: "FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE",
                                36053: "FRAMEBUFFER_COMPLETE",
                                36054: "FRAMEBUFFER_INCOMPLETE_ATTACHMENT",
                                36055: "FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT",
                                36057: "FRAMEBUFFER_INCOMPLETE_DIMENSIONS",
                                36061: "FRAMEBUFFER_UNSUPPORTED",
                                36064: "COLOR_ATTACHMENT0",
                                36096: "DEPTH_ATTACHMENT",
                                36128: "STENCIL_ATTACHMENT",
                                36160: "FRAMEBUFFER",
                                36161: "RENDERBUFFER",
                                36162: "RENDERBUFFER_WIDTH",
                                36163: "RENDERBUFFER_HEIGHT",
                                36164: "RENDERBUFFER_INTERNAL_FORMAT",
                                36168: "STENCIL_INDEX8",
                                36176: "RENDERBUFFER_RED_SIZE",
                                36177: "RENDERBUFFER_GREEN_SIZE",
                                36178: "RENDERBUFFER_BLUE_SIZE",
                                36179: "RENDERBUFFER_ALPHA_SIZE",
                                36180: "RENDERBUFFER_DEPTH_SIZE",
                                36181: "RENDERBUFFER_STENCIL_SIZE",
                                36194: "RGB565",
                                36336: "LOW_FLOAT",
                                36337: "MEDIUM_FLOAT",
                                36338: "HIGH_FLOAT",
                                36339: "LOW_INT",
                                36340: "MEDIUM_INT",
                                36341: "HIGH_INT",
                                36346: "SHADER_COMPILER",
                                36347: "MAX_VERTEX_UNIFORM_VECTORS",
                                36348: "MAX_VARYING_VECTORS",
                                36349: "MAX_FRAGMENT_UNIFORM_VECTORS",
                                37440: "UNPACK_FLIP_Y_WEBGL",
                                37441: "UNPACK_PREMULTIPLY_ALPHA_WEBGL",
                                37442: "CONTEXT_LOST_WEBGL",
                                37443: "UNPACK_COLORSPACE_CONVERSION_WEBGL",
                                37444: "BROWSER_DEFAULT_WEBGL"
                            };
                        },
                        5171: function(t1, e1, r) {
                            var n = r(737);
                            t1.exports = function(t1) {
                                return n[t1];
                            };
                        },
                        9165: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1) {
                                var e1 = t1.gl, r = n(e1), o = i(e1, [
                                    {
                                        buffer: r,
                                        type: e1.FLOAT,
                                        size: 3,
                                        offset: 0,
                                        stride: 40
                                    },
                                    {
                                        buffer: r,
                                        type: e1.FLOAT,
                                        size: 4,
                                        offset: 12,
                                        stride: 40
                                    },
                                    {
                                        buffer: r,
                                        type: e1.FLOAT,
                                        size: 3,
                                        offset: 28,
                                        stride: 40
                                    }
                                ]), l = a(e1);
                                l.attributes.position.location = 0, l.attributes.color.location = 1, l.attributes.offset.location = 2;
                                var c = new s(e1, r, o, l);
                                return c.update(t1), c;
                            };
                            var n = r(2762), i = r(8116), a = r(3436), o = [
                                1,
                                0,
                                0,
                                0,
                                0,
                                1,
                                0,
                                0,
                                0,
                                0,
                                1,
                                0,
                                0,
                                0,
                                0,
                                1
                            ];
                            function s(t1, e1, r, n) {
                                this.gl = t1, this.shader = n, this.buffer = e1, this.vao = r, this.pixelRatio = 1, this.bounds = [
                                    [
                                        1 / 0,
                                        1 / 0,
                                        1 / 0
                                    ],
                                    [
                                        -1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ]
                                ], this.clipBounds = [
                                    [
                                        -1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ],
                                    [
                                        1 / 0,
                                        1 / 0,
                                        1 / 0
                                    ]
                                ], this.lineWidth = [
                                    1,
                                    1,
                                    1
                                ], this.capSize = [
                                    10,
                                    10,
                                    10
                                ], this.lineCount = [
                                    0,
                                    0,
                                    0
                                ], this.lineOffset = [
                                    0,
                                    0,
                                    0
                                ], this.opacity = 1, this.hasAlpha = !1;
                            }
                            var l = s.prototype;
                            function c(t1, e1) {
                                for(var r = 0; r < 3; ++r)t1[0][r] = Math.min(t1[0][r], e1[r]), t1[1][r] = Math.max(t1[1][r], e1[r]);
                            }
                            l.isOpaque = function() {
                                return !this.hasAlpha;
                            }, l.isTransparent = function() {
                                return this.hasAlpha;
                            }, l.drawTransparent = l.draw = function(t1) {
                                var e1 = this.gl, r = this.shader.uniforms;
                                this.shader.bind();
                                var n = r.view = t1.view || o, i = r.projection = t1.projection || o;
                                r.model = t1.model || o, r.clipBounds = this.clipBounds, r.opacity = this.opacity;
                                var a = n[12], s = n[13], l = n[14], c = n[15], u = (t1._ortho ? 2 : 1) * this.pixelRatio * (i[3] * a + i[7] * s + i[11] * l + i[15] * c) / e1.drawingBufferHeight;
                                this.vao.bind();
                                for(var h = 0; h < 3; ++h)e1.lineWidth(this.lineWidth[h] * this.pixelRatio), r.capSize = this.capSize[h] * u, this.lineCount[h] && e1.drawArrays(e1.LINES, this.lineOffset[h], this.lineCount[h]);
                                this.vao.unbind();
                            };
                            var u = function() {
                                for(var t1 = new Array(3), e1 = 0; e1 < 3; ++e1){
                                    for(var r = [], n = 1; n <= 2; ++n)for(var i = -1; i <= 1; i += 2){
                                        var a = [
                                            0,
                                            0,
                                            0
                                        ];
                                        a[(n + e1) % 3] = i, r.push(a);
                                    }
                                    t1[e1] = r;
                                }
                                return t1;
                            }();
                            function h(t1, e1, r, n) {
                                for(var i = u[n], a = 0; a < i.length; ++a){
                                    var o = i[a];
                                    t1.push(e1[0], e1[1], e1[2], r[0], r[1], r[2], r[3], o[0], o[1], o[2]);
                                }
                                return i.length;
                            }
                            l.update = function(t1) {
                                "lineWidth" in (t1 = t1 || {}) && (this.lineWidth = t1.lineWidth, Array.isArray(this.lineWidth) || (this.lineWidth = [
                                    this.lineWidth,
                                    this.lineWidth,
                                    this.lineWidth
                                ])), "capSize" in t1 && (this.capSize = t1.capSize, Array.isArray(this.capSize) || (this.capSize = [
                                    this.capSize,
                                    this.capSize,
                                    this.capSize
                                ])), this.hasAlpha = !1, "opacity" in t1 && (this.opacity = +t1.opacity, this.opacity < 1 && (this.hasAlpha = !0));
                                var e1 = t1.color || [
                                    [
                                        0,
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0,
                                        0
                                    ]
                                ], r = t1.position, n = t1.error;
                                if (Array.isArray(e1[0]) || (e1 = [
                                    e1,
                                    e1,
                                    e1
                                ]), r && n) {
                                    var i = [], a = r.length, o = 0;
                                    this.bounds = [
                                        [
                                            1 / 0,
                                            1 / 0,
                                            1 / 0
                                        ],
                                        [
                                            -1 / 0,
                                            -1 / 0,
                                            -1 / 0
                                        ]
                                    ], this.lineCount = [
                                        0,
                                        0,
                                        0
                                    ];
                                    for(var s = 0; s < 3; ++s){
                                        this.lineOffset[s] = o;
                                        t: for(var l = 0; l < a; ++l){
                                            for(var u = r[l], f = 0; f < 3; ++f)if (isNaN(u[f]) || !isFinite(u[f])) continue t;
                                            var p, d = n[l], m = e1[s];
                                            if (Array.isArray(m[0]) && (m = e1[l]), 3 === m.length ? m = [
                                                m[0],
                                                m[1],
                                                m[2],
                                                1
                                            ] : 4 === m.length && (m = [
                                                m[0],
                                                m[1],
                                                m[2],
                                                m[3]
                                            ], !this.hasAlpha && m[3] < 1 && (this.hasAlpha = !0)), !isNaN(d[0][s]) && !isNaN(d[1][s])) d[0][s] < 0 && ((p = u.slice())[s] += d[0][s], i.push(u[0], u[1], u[2], m[0], m[1], m[2], m[3], 0, 0, 0, p[0], p[1], p[2], m[0], m[1], m[2], m[3], 0, 0, 0), c(this.bounds, p), o += 2 + h(i, p, m, s)), d[1][s] > 0 && ((p = u.slice())[s] += d[1][s], i.push(u[0], u[1], u[2], m[0], m[1], m[2], m[3], 0, 0, 0, p[0], p[1], p[2], m[0], m[1], m[2], m[3], 0, 0, 0), c(this.bounds, p), o += 2 + h(i, p, m, s));
                                        }
                                        this.lineCount[s] = o - this.lineOffset[s];
                                    }
                                    this.buffer.update(i);
                                }
                            }, l.dispose = function() {
                                this.shader.dispose(), this.buffer.dispose(), this.vao.dispose();
                            };
                        },
                        3436: function(t1, e1, r) {
                            "use strict";
                            var n = r(3236), i = r(9405), a = n([
                                "precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position, offset;\nattribute vec4 color;\nuniform mat4 model, view, projection;\nuniform float capSize;\nvarying vec4 fragColor;\nvarying vec3 fragPosition;\n\nvoid main() {\n  vec4 worldPosition  = model * vec4(position, 1.0);\n  worldPosition       = (worldPosition / worldPosition.w) + vec4(capSize * offset, 0.0);\n  gl_Position         = projection * (view * worldPosition);\n  fragColor           = color;\n  fragPosition        = position;\n}"
                            ]), o = n([
                                "precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float opacity;\nvarying vec3 fragPosition;\nvarying vec4 fragColor;\n\nvoid main() {\n  if (\n    outOfRange(clipBounds[0], clipBounds[1], fragPosition) ||\n    fragColor.a * opacity == 0.\n  ) discard;\n\n  gl_FragColor = opacity * fragColor;\n}"
                            ]);
                            t1.exports = function(t1) {
                                return i(t1, a, o, null, [
                                    {
                                        name: "position",
                                        type: "vec3"
                                    },
                                    {
                                        name: "color",
                                        type: "vec4"
                                    },
                                    {
                                        name: "offset",
                                        type: "vec3"
                                    }
                                ]);
                            };
                        },
                        2260: function(t1, e1, r) {
                            "use strict";
                            var n = r(7766);
                            t1.exports = function(t1, e1, r, n) {
                                i || (i = t1.FRAMEBUFFER_UNSUPPORTED, a = t1.FRAMEBUFFER_INCOMPLETE_ATTACHMENT, o = t1.FRAMEBUFFER_INCOMPLETE_DIMENSIONS, s = t1.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT);
                                var c = t1.getExtension("WEBGL_draw_buffers");
                                if (!l && c && function(t1, e1) {
                                    var r = t1.getParameter(e1.MAX_COLOR_ATTACHMENTS_WEBGL);
                                    l = new Array(r + 1);
                                    for(var n = 0; n <= r; ++n){
                                        for(var i = new Array(r), a = 0; a < n; ++a)i[a] = t1.COLOR_ATTACHMENT0 + a;
                                        for(a = n; a < r; ++a)i[a] = t1.NONE;
                                        l[n] = i;
                                    }
                                }(t1, c), Array.isArray(e1) && (n = r, r = 0 | e1[1], e1 = 0 | e1[0]), "number" != typeof e1) throw new Error("gl-fbo: Missing shape parameter");
                                var u = t1.getParameter(t1.MAX_RENDERBUFFER_SIZE);
                                if (e1 < 0 || e1 > u || r < 0 || r > u) throw new Error("gl-fbo: Parameters are too large for FBO");
                                var h = 1;
                                if ("color" in (n = n || {})) {
                                    if ((h = Math.max(0 | n.color, 0)) < 0) throw new Error("gl-fbo: Must specify a nonnegative number of colors");
                                    if (h > 1) {
                                        if (!c) throw new Error("gl-fbo: Multiple draw buffer extension not supported");
                                        if (h > t1.getParameter(c.MAX_COLOR_ATTACHMENTS_WEBGL)) throw new Error("gl-fbo: Context does not support " + h + " draw buffers");
                                    }
                                }
                                var f = t1.UNSIGNED_BYTE, p = t1.getExtension("OES_texture_float");
                                if (n.float && h > 0) {
                                    if (!p) throw new Error("gl-fbo: Context does not support floating point textures");
                                    f = t1.FLOAT;
                                } else n.preferFloat && h > 0 && p && (f = t1.FLOAT);
                                var m = !0;
                                "depth" in n && (m = !!n.depth);
                                var g = !1;
                                return "stencil" in n && (g = !!n.stencil), new d(t1, e1, r, f, h, m, g, c);
                            };
                            var i, a, o, s, l = null;
                            function c(t1) {
                                return [
                                    t1.getParameter(t1.FRAMEBUFFER_BINDING),
                                    t1.getParameter(t1.RENDERBUFFER_BINDING),
                                    t1.getParameter(t1.TEXTURE_BINDING_2D)
                                ];
                            }
                            function u(t1, e1) {
                                t1.bindFramebuffer(t1.FRAMEBUFFER, e1[0]), t1.bindRenderbuffer(t1.RENDERBUFFER, e1[1]), t1.bindTexture(t1.TEXTURE_2D, e1[2]);
                            }
                            function h(t1) {
                                switch(t1){
                                    case i:
                                        throw new Error("gl-fbo: Framebuffer unsupported");
                                    case a:
                                        throw new Error("gl-fbo: Framebuffer incomplete attachment");
                                    case o:
                                        throw new Error("gl-fbo: Framebuffer incomplete dimensions");
                                    case s:
                                        throw new Error("gl-fbo: Framebuffer incomplete missing attachment");
                                    default:
                                        throw new Error("gl-fbo: Framebuffer failed for unspecified reason");
                                }
                            }
                            function f(t1, e1, r, i, a, o) {
                                if (!i) return null;
                                var s = n(t1, e1, r, a, i);
                                return s.magFilter = t1.NEAREST, s.minFilter = t1.NEAREST, s.mipSamples = 1, s.bind(), t1.framebufferTexture2D(t1.FRAMEBUFFER, o, t1.TEXTURE_2D, s.handle, 0), s;
                            }
                            function p(t1, e1, r, n, i) {
                                var a = t1.createRenderbuffer();
                                return t1.bindRenderbuffer(t1.RENDERBUFFER, a), t1.renderbufferStorage(t1.RENDERBUFFER, n, e1, r), t1.framebufferRenderbuffer(t1.FRAMEBUFFER, i, t1.RENDERBUFFER, a), a;
                            }
                            function d(t1, e1, r, n, i, a, o, s) {
                                this.gl = t1, this._shape = [
                                    0 | e1,
                                    0 | r
                                ], this._destroyed = !1, this._ext = s, this.color = new Array(i);
                                for(var d = 0; d < i; ++d)this.color[d] = null;
                                this._color_rb = null, this.depth = null, this._depth_rb = null, this._colorType = n, this._useDepth = a, this._useStencil = o;
                                var m = this, g = [
                                    0 | e1,
                                    0 | r
                                ];
                                Object.defineProperties(g, {
                                    0: {
                                        get: function() {
                                            return m._shape[0];
                                        },
                                        set: function(t1) {
                                            return m.width = t1;
                                        }
                                    },
                                    1: {
                                        get: function() {
                                            return m._shape[1];
                                        },
                                        set: function(t1) {
                                            return m.height = t1;
                                        }
                                    }
                                }), this._shapeVector = g, function(t1) {
                                    var e1 = c(t1.gl), r = t1.gl, n = t1.handle = r.createFramebuffer(), i = t1._shape[0], a = t1._shape[1], o = t1.color.length, s = t1._ext, d = t1._useStencil, m = t1._useDepth, g = t1._colorType;
                                    r.bindFramebuffer(r.FRAMEBUFFER, n);
                                    for(var y = 0; y < o; ++y)t1.color[y] = f(r, i, a, g, r.RGBA, r.COLOR_ATTACHMENT0 + y);
                                    0 === o ? (t1._color_rb = p(r, i, a, r.RGBA4, r.COLOR_ATTACHMENT0), s && s.drawBuffersWEBGL(l[0])) : o > 1 && s.drawBuffersWEBGL(l[o]);
                                    var v = r.getExtension("WEBGL_depth_texture");
                                    v ? d ? t1.depth = f(r, i, a, v.UNSIGNED_INT_24_8_WEBGL, r.DEPTH_STENCIL, r.DEPTH_STENCIL_ATTACHMENT) : m && (t1.depth = f(r, i, a, r.UNSIGNED_SHORT, r.DEPTH_COMPONENT, r.DEPTH_ATTACHMENT)) : m && d ? t1._depth_rb = p(r, i, a, r.DEPTH_STENCIL, r.DEPTH_STENCIL_ATTACHMENT) : m ? t1._depth_rb = p(r, i, a, r.DEPTH_COMPONENT16, r.DEPTH_ATTACHMENT) : d && (t1._depth_rb = p(r, i, a, r.STENCIL_INDEX, r.STENCIL_ATTACHMENT));
                                    var x = r.checkFramebufferStatus(r.FRAMEBUFFER);
                                    if (x !== r.FRAMEBUFFER_COMPLETE) {
                                        for(t1._destroyed = !0, r.bindFramebuffer(r.FRAMEBUFFER, null), r.deleteFramebuffer(t1.handle), t1.handle = null, t1.depth && (t1.depth.dispose(), t1.depth = null), t1._depth_rb && (r.deleteRenderbuffer(t1._depth_rb), t1._depth_rb = null), y = 0; y < t1.color.length; ++y)t1.color[y].dispose(), t1.color[y] = null;
                                        t1._color_rb && (r.deleteRenderbuffer(t1._color_rb), t1._color_rb = null), u(r, e1), h(x);
                                    }
                                    u(r, e1);
                                }(this);
                            }
                            var m = d.prototype;
                            function g(t1, e1, r) {
                                if (t1._destroyed) throw new Error("gl-fbo: Can't resize destroyed FBO");
                                if (t1._shape[0] !== e1 || t1._shape[1] !== r) {
                                    var n = t1.gl, i = n.getParameter(n.MAX_RENDERBUFFER_SIZE);
                                    if (e1 < 0 || e1 > i || r < 0 || r > i) throw new Error("gl-fbo: Can't resize FBO, invalid dimensions");
                                    t1._shape[0] = e1, t1._shape[1] = r;
                                    for(var a = c(n), o = 0; o < t1.color.length; ++o)t1.color[o].shape = t1._shape;
                                    t1._color_rb && (n.bindRenderbuffer(n.RENDERBUFFER, t1._color_rb), n.renderbufferStorage(n.RENDERBUFFER, n.RGBA4, t1._shape[0], t1._shape[1])), t1.depth && (t1.depth.shape = t1._shape), t1._depth_rb && (n.bindRenderbuffer(n.RENDERBUFFER, t1._depth_rb), t1._useDepth && t1._useStencil ? n.renderbufferStorage(n.RENDERBUFFER, n.DEPTH_STENCIL, t1._shape[0], t1._shape[1]) : t1._useDepth ? n.renderbufferStorage(n.RENDERBUFFER, n.DEPTH_COMPONENT16, t1._shape[0], t1._shape[1]) : t1._useStencil && n.renderbufferStorage(n.RENDERBUFFER, n.STENCIL_INDEX, t1._shape[0], t1._shape[1])), n.bindFramebuffer(n.FRAMEBUFFER, t1.handle);
                                    var s = n.checkFramebufferStatus(n.FRAMEBUFFER);
                                    s !== n.FRAMEBUFFER_COMPLETE && (t1.dispose(), u(n, a), h(s)), u(n, a);
                                }
                            }
                            Object.defineProperties(m, {
                                shape: {
                                    get: function() {
                                        return this._destroyed ? [
                                            0,
                                            0
                                        ] : this._shapeVector;
                                    },
                                    set: function(t1) {
                                        if (Array.isArray(t1) || (t1 = [
                                            0 | t1,
                                            0 | t1
                                        ]), 2 !== t1.length) throw new Error("gl-fbo: Shape vector must be length 2");
                                        var e1 = 0 | t1[0], r = 0 | t1[1];
                                        return g(this, e1, r), [
                                            e1,
                                            r
                                        ];
                                    },
                                    enumerable: !1
                                },
                                width: {
                                    get: function() {
                                        return this._destroyed ? 0 : this._shape[0];
                                    },
                                    set: function(t1) {
                                        return g(this, t1 |= 0, this._shape[1]), t1;
                                    },
                                    enumerable: !1
                                },
                                height: {
                                    get: function() {
                                        return this._destroyed ? 0 : this._shape[1];
                                    },
                                    set: function(t1) {
                                        return t1 |= 0, g(this, this._shape[0], t1), t1;
                                    },
                                    enumerable: !1
                                }
                            }), m.bind = function() {
                                if (!this._destroyed) {
                                    var t1 = this.gl;
                                    t1.bindFramebuffer(t1.FRAMEBUFFER, this.handle), t1.viewport(0, 0, this._shape[0], this._shape[1]);
                                }
                            }, m.dispose = function() {
                                if (!this._destroyed) {
                                    this._destroyed = !0;
                                    var t1 = this.gl;
                                    t1.deleteFramebuffer(this.handle), this.handle = null, this.depth && (this.depth.dispose(), this.depth = null), this._depth_rb && (t1.deleteRenderbuffer(this._depth_rb), this._depth_rb = null);
                                    for(var e1 = 0; e1 < this.color.length; ++e1)this.color[e1].dispose(), this.color[e1] = null;
                                    this._color_rb && (t1.deleteRenderbuffer(this._color_rb), this._color_rb = null);
                                }
                            };
                        },
                        2992: function(t1, e1, r) {
                            var n = r(3387).sprintf, i = r(5171), a = r(1848), o = r(1085);
                            t1.exports = function(t1, e1, r) {
                                "use strict";
                                var s = a(e1) || "of unknown name (see npm glsl-shader-name)", l = "unknown type";
                                void 0 !== r && (l = r === i.FRAGMENT_SHADER ? "fragment" : "vertex");
                                for(var c = n("Error compiling %s shader %s:\n", l, s), u = n("%s%s", c, t1), h = t1.split("\n"), f = {}, p = 0; p < h.length; p++){
                                    var d = h[p];
                                    if ("" !== d && "\0" !== d) {
                                        var m = parseInt(d.split(":")[2]);
                                        if (isNaN(m)) throw new Error(n("Could not parse error: %s", d));
                                        f[m] = d;
                                    }
                                }
                                var g = o(e1).split("\n");
                                for(p = 0; p < g.length; p++)if ((f[p + 3] || f[p + 2] || f[p + 1]) && (c += g[p] + "\n", f[p + 1])) {
                                    var y = f[p + 1];
                                    y = y.substr(y.split(":", 3).join(":").length + 1).trim(), c += n("^^^ %s\n\n", y);
                                }
                                return {
                                    long: c.trim(),
                                    short: u.trim()
                                };
                            };
                        },
                        2510: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1) {
                                var r = t1.gl, n = new c(t1, o(r, l.vertex, l.fragment), o(r, l.pickVertex, l.pickFragment), s(r), s(r), s(r), s(r));
                                return n.update(e1), t1.addObject(n), n;
                            };
                            var n = r(2478), i = r(7762), a = r(1888), o = r(9405), s = r(2762), l = r(6768);
                            function c(t1, e1, r, n, i, a, o) {
                                this.plot = t1, this.shader = e1, this.pickShader = r, this.positionBuffer = n, this.weightBuffer = i, this.colorBuffer = a, this.idBuffer = o, this.xData = [], this.yData = [], this.shape = [
                                    0,
                                    0
                                ], this.bounds = [
                                    1 / 0,
                                    1 / 0,
                                    -1 / 0,
                                    -1 / 0
                                ], this.pickOffset = 0;
                            }
                            var u, h = c.prototype, f = [
                                0,
                                0,
                                1,
                                0,
                                0,
                                1,
                                1,
                                0,
                                1,
                                1,
                                0,
                                1
                            ];
                            h.draw = (u = [
                                1,
                                0,
                                0,
                                0,
                                1,
                                0,
                                0,
                                0,
                                1
                            ], function() {
                                var t1 = this.plot, e1 = this.shader, r = this.bounds, n = this.numVertices;
                                if (!(n <= 0)) {
                                    var i = t1.gl, a = t1.dataBox, o = r[2] - r[0], s = r[3] - r[1], l = a[2] - a[0], c = a[3] - a[1];
                                    u[0] = 2 * o / l, u[4] = 2 * s / c, u[6] = 2 * (r[0] - a[0]) / l - 1, u[7] = 2 * (r[1] - a[1]) / c - 1, e1.bind();
                                    var h = e1.uniforms;
                                    h.viewTransform = u, h.shape = this.shape;
                                    var f = e1.attributes;
                                    this.positionBuffer.bind(), f.position.pointer(), this.weightBuffer.bind(), f.weight.pointer(i.UNSIGNED_BYTE, !1), this.colorBuffer.bind(), f.color.pointer(i.UNSIGNED_BYTE, !0), i.drawArrays(i.TRIANGLES, 0, n);
                                }
                            }), h.drawPick = function() {
                                var t1 = [
                                    1,
                                    0,
                                    0,
                                    0,
                                    1,
                                    0,
                                    0,
                                    0,
                                    1
                                ], e1 = [
                                    0,
                                    0,
                                    0,
                                    0
                                ];
                                return function(r) {
                                    var n = this.plot, i = this.pickShader, a = this.bounds, o = this.numVertices;
                                    if (!(o <= 0)) {
                                        var s = n.gl, l = n.dataBox, c = a[2] - a[0], u = a[3] - a[1], h = l[2] - l[0], f = l[3] - l[1];
                                        t1[0] = 2 * c / h, t1[4] = 2 * u / f, t1[6] = 2 * (a[0] - l[0]) / h - 1, t1[7] = 2 * (a[1] - l[1]) / f - 1;
                                        for(var p = 0; p < 4; ++p)e1[p] = r >> 8 * p & 255;
                                        this.pickOffset = r, i.bind();
                                        var d = i.uniforms;
                                        d.viewTransform = t1, d.pickOffset = e1, d.shape = this.shape;
                                        var m = i.attributes;
                                        return this.positionBuffer.bind(), m.position.pointer(), this.weightBuffer.bind(), m.weight.pointer(s.UNSIGNED_BYTE, !1), this.idBuffer.bind(), m.pickId.pointer(s.UNSIGNED_BYTE, !1), s.drawArrays(s.TRIANGLES, 0, o), r + this.shape[0] * this.shape[1];
                                    }
                                };
                            }(), h.pick = function(t1, e1, r) {
                                var n = this.pickOffset, i = this.shape[0] * this.shape[1];
                                if (r < n || r >= n + i) return null;
                                var a = r - n, o = this.xData, s = this.yData;
                                return {
                                    object: this,
                                    pointId: a,
                                    dataCoord: [
                                        o[a % this.shape[0]],
                                        s[a / this.shape[0] | 0]
                                    ]
                                };
                            }, h.update = function(t1) {
                                var e1 = (t1 = t1 || {}).shape || [
                                    0,
                                    0
                                ], r = t1.x || i(e1[0]), o = t1.y || i(e1[1]), s = t1.z || new Float32Array(e1[0] * e1[1]), l = !1 !== t1.zsmooth;
                                this.xData = r, this.yData = o;
                                var c, u, h, p, d = t1.colorLevels || [
                                    0
                                ], m = t1.colorValues || [
                                    0,
                                    0,
                                    0,
                                    1
                                ], g = d.length, y = this.bounds;
                                l ? (c = y[0] = r[0], u = y[1] = o[0], h = y[2] = r[r.length - 1], p = y[3] = o[o.length - 1]) : (c = y[0] = r[0] + (r[1] - r[0]) / 2, u = y[1] = o[0] + (o[1] - o[0]) / 2, h = y[2] = r[r.length - 1] + (r[r.length - 1] - r[r.length - 2]) / 2, p = y[3] = o[o.length - 1] + (o[o.length - 1] - o[o.length - 2]) / 2);
                                var v = 1 / (h - c), x = 1 / (p - u), _ = e1[0], b = e1[1];
                                this.shape = [
                                    _,
                                    b
                                ];
                                var w = (l ? (_ - 1) * (b - 1) : _ * b) * (f.length >>> 1);
                                this.numVertices = w;
                                for(var T = a.mallocUint8(4 * w), k = a.mallocFloat32(2 * w), A = a.mallocUint8(2 * w), M = a.mallocUint32(w), S = 0, E = l ? _ - 1 : _, C = l ? b - 1 : b, L = 0; L < C; ++L){
                                    var I, P;
                                    l ? (I = x * (o[L] - u), P = x * (o[L + 1] - u)) : (I = L < b - 1 ? x * (o[L] - (o[L + 1] - o[L]) / 2 - u) : x * (o[L] - (o[L] - o[L - 1]) / 2 - u), P = L < b - 1 ? x * (o[L] + (o[L + 1] - o[L]) / 2 - u) : x * (o[L] + (o[L] - o[L - 1]) / 2 - u));
                                    for(var z = 0; z < E; ++z){
                                        var O, D;
                                        l ? (O = v * (r[z] - c), D = v * (r[z + 1] - c)) : (O = z < _ - 1 ? v * (r[z] - (r[z + 1] - r[z]) / 2 - c) : v * (r[z] - (r[z] - r[z - 1]) / 2 - c), D = z < _ - 1 ? v * (r[z] + (r[z + 1] - r[z]) / 2 - c) : v * (r[z] + (r[z] - r[z - 1]) / 2 - c));
                                        for(var R = 0; R < f.length; R += 2){
                                            var F, B, N, j, U = f[R], V = f[R + 1], q = s[l ? (L + V) * _ + (z + U) : L * _ + z], H = n.le(d, q);
                                            if (H < 0) F = m[0], B = m[1], N = m[2], j = m[3];
                                            else if (H === g - 1) F = m[4 * g - 4], B = m[4 * g - 3], N = m[4 * g - 2], j = m[4 * g - 1];
                                            else {
                                                var G = (q - d[H]) / (d[H + 1] - d[H]), Z = 1 - G, W = 4 * H, Y = 4 * (H + 1);
                                                F = Z * m[W] + G * m[Y], B = Z * m[W + 1] + G * m[Y + 1], N = Z * m[W + 2] + G * m[Y + 2], j = Z * m[W + 3] + G * m[Y + 3];
                                            }
                                            T[4 * S] = 255 * F, T[4 * S + 1] = 255 * B, T[4 * S + 2] = 255 * N, T[4 * S + 3] = 255 * j, k[2 * S] = .5 * O + .5 * D, k[2 * S + 1] = .5 * I + .5 * P, A[2 * S] = U, A[2 * S + 1] = V, M[S] = L * _ + z, S += 1;
                                        }
                                    }
                                }
                                this.positionBuffer.update(k), this.weightBuffer.update(A), this.colorBuffer.update(T), this.idBuffer.update(M), a.free(k), a.free(T), a.free(A), a.free(M);
                            }, h.dispose = function() {
                                this.shader.dispose(), this.pickShader.dispose(), this.positionBuffer.dispose(), this.weightBuffer.dispose(), this.colorBuffer.dispose(), this.idBuffer.dispose(), this.plot.removeObject(this);
                            };
                        },
                        6768: function(t1, e1, r) {
                            "use strict";
                            var n = r(3236);
                            t1.exports = {
                                fragment: n([
                                    "precision lowp float;\n#define GLSLIFY 1\nvarying vec4 fragColor;\nvoid main() {\n  gl_FragColor = vec4(fragColor.rgb * fragColor.a, fragColor.a);\n}\n"
                                ]),
                                vertex: n([
                                    "precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 position;\nattribute vec4 color;\nattribute vec2 weight;\n\nuniform vec2 shape;\nuniform mat3 viewTransform;\n\nvarying vec4 fragColor;\n\nvoid main() {\n  vec3 vPosition = viewTransform * vec3( position + (weight-.5)/(shape-1.) , 1.0);\n  fragColor = color;\n  gl_Position = vec4(vPosition.xy, 0, vPosition.z);\n}\n"
                                ]),
                                pickFragment: n([
                                    "precision mediump float;\n#define GLSLIFY 1\n\nvarying vec4 fragId;\nvarying vec2 vWeight;\n\nuniform vec2 shape;\nuniform vec4 pickOffset;\n\nvoid main() {\n  vec2 d = step(.5, vWeight);\n  vec4 id = fragId + pickOffset;\n  id.x += d.x + d.y*shape.x;\n\n  id.y += floor(id.x / 256.0);\n  id.x -= floor(id.x / 256.0) * 256.0;\n\n  id.z += floor(id.y / 256.0);\n  id.y -= floor(id.y / 256.0) * 256.0;\n\n  id.w += floor(id.z / 256.0);\n  id.z -= floor(id.z / 256.0) * 256.0;\n\n  gl_FragColor = id/255.;\n}\n"
                                ]),
                                pickVertex: n([
                                    "precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 position;\nattribute vec4 pickId;\nattribute vec2 weight;\n\nuniform vec2 shape;\nuniform mat3 viewTransform;\n\nvarying vec4 fragId;\nvarying vec2 vWeight;\n\nvoid main() {\n  vWeight = weight;\n\n  fragId = pickId;\n\n  vec3 vPosition = viewTransform * vec3( position + (weight-.5)/(shape-1.) , 1.0);\n  gl_Position = vec4(vPosition.xy, 0, vPosition.z);\n}\n"
                                ])
                            };
                        },
                        7319: function(t1, e1, r) {
                            var n = r(3236), i = r(9405), a = n([
                                "precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position, nextPosition;\nattribute float arcLength, lineWidth;\nattribute vec4 color;\n\nuniform vec2 screenShape;\nuniform float pixelRatio;\nuniform mat4 model, view, projection;\n\nvarying vec4 fragColor;\nvarying vec3 worldPosition;\nvarying float pixelArcLength;\n\nvec4 project(vec3 p) {\n  return projection * (view * (model * vec4(p, 1.0)));\n}\n\nvoid main() {\n  vec4 startPoint = project(position);\n  vec4 endPoint   = project(nextPosition);\n\n  vec2 A = startPoint.xy / startPoint.w;\n  vec2 B =   endPoint.xy /   endPoint.w;\n\n  float clipAngle = atan(\n    (B.y - A.y) * screenShape.y,\n    (B.x - A.x) * screenShape.x\n  );\n\n  vec2 offset = 0.5 * pixelRatio * lineWidth * vec2(\n    sin(clipAngle),\n    -cos(clipAngle)\n  ) / screenShape;\n\n  gl_Position = vec4(startPoint.xy + startPoint.w * offset, startPoint.zw);\n\n  worldPosition = position;\n  pixelArcLength = arcLength;\n  fragColor = color;\n}\n"
                            ]), o = n([
                                "precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3      clipBounds[2];\nuniform sampler2D dashTexture;\nuniform float     dashScale;\nuniform float     opacity;\n\nvarying vec3    worldPosition;\nvarying float   pixelArcLength;\nvarying vec4    fragColor;\n\nvoid main() {\n  if (\n    outOfRange(clipBounds[0], clipBounds[1], worldPosition) ||\n    fragColor.a * opacity == 0.\n  ) discard;\n\n  float dashWeight = texture2D(dashTexture, vec2(dashScale * pixelArcLength, 0)).r;\n  if(dashWeight < 0.5) {\n    discard;\n  }\n  gl_FragColor = fragColor * opacity;\n}\n"
                            ]), s = n([
                                "precision highp float;\n#define GLSLIFY 1\n\n#define FLOAT_MAX  1.70141184e38\n#define FLOAT_MIN  1.17549435e-38\n\n// https://github.com/mikolalysenko/glsl-read-float/blob/master/index.glsl\nvec4 packFloat(float v) {\n  float av = abs(v);\n\n  //Handle special cases\n  if(av < FLOAT_MIN) {\n    return vec4(0.0, 0.0, 0.0, 0.0);\n  } else if(v > FLOAT_MAX) {\n    return vec4(127.0, 128.0, 0.0, 0.0) / 255.0;\n  } else if(v < -FLOAT_MAX) {\n    return vec4(255.0, 128.0, 0.0, 0.0) / 255.0;\n  }\n\n  vec4 c = vec4(0,0,0,0);\n\n  //Compute exponent and mantissa\n  float e = floor(log2(av));\n  float m = av * pow(2.0, -e) - 1.0;\n\n  //Unpack mantissa\n  c[1] = floor(128.0 * m);\n  m -= c[1] / 128.0;\n  c[2] = floor(32768.0 * m);\n  m -= c[2] / 32768.0;\n  c[3] = floor(8388608.0 * m);\n\n  //Unpack exponent\n  float ebias = e + 127.0;\n  c[0] = floor(ebias / 2.0);\n  ebias -= c[0] * 2.0;\n  c[1] += floor(ebias) * 128.0;\n\n  //Unpack sign bit\n  c[0] += 128.0 * step(0.0, -v);\n\n  //Scale back to range\n  return c / 255.0;\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform float pickId;\nuniform vec3 clipBounds[2];\n\nvarying vec3 worldPosition;\nvarying float pixelArcLength;\nvarying vec4 fragColor;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], worldPosition)) discard;\n\n  gl_FragColor = vec4(pickId/255.0, packFloat(pixelArcLength).xyz);\n}"
                            ]), l = [
                                {
                                    name: "position",
                                    type: "vec3"
                                },
                                {
                                    name: "nextPosition",
                                    type: "vec3"
                                },
                                {
                                    name: "arcLength",
                                    type: "float"
                                },
                                {
                                    name: "lineWidth",
                                    type: "float"
                                },
                                {
                                    name: "color",
                                    type: "vec4"
                                }
                            ];
                            e1.createShader = function(t1) {
                                return i(t1, a, o, null, l);
                            }, e1.createPickShader = function(t1) {
                                return i(t1, a, s, null, l);
                            };
                        },
                        5714: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1) {
                                var e1 = t1.gl || t1.scene && t1.scene.gl, r = h(e1);
                                r.attributes.position.location = 0, r.attributes.nextPosition.location = 1, r.attributes.arcLength.location = 2, r.attributes.lineWidth.location = 3, r.attributes.color.location = 4;
                                var o = f(e1);
                                o.attributes.position.location = 0, o.attributes.nextPosition.location = 1, o.attributes.arcLength.location = 2, o.attributes.lineWidth.location = 3, o.attributes.color.location = 4;
                                for(var s = n(e1), l = i(e1, [
                                    {
                                        buffer: s,
                                        size: 3,
                                        offset: 0,
                                        stride: 48
                                    },
                                    {
                                        buffer: s,
                                        size: 3,
                                        offset: 12,
                                        stride: 48
                                    },
                                    {
                                        buffer: s,
                                        size: 1,
                                        offset: 24,
                                        stride: 48
                                    },
                                    {
                                        buffer: s,
                                        size: 1,
                                        offset: 28,
                                        stride: 48
                                    },
                                    {
                                        buffer: s,
                                        size: 4,
                                        offset: 32,
                                        stride: 48
                                    }
                                ]), u = c(new Array(1024), [
                                    256,
                                    1,
                                    4
                                ]), p = 0; p < 1024; ++p)u.data[p] = 255;
                                var d = a(e1, u);
                                d.wrap = e1.REPEAT;
                                var m = new y(e1, r, o, s, l, d);
                                return m.update(t1), m;
                            };
                            var n = r(2762), i = r(8116), a = r(7766), o = new Uint8Array(4), s = new Float32Array(o.buffer), l = r(2478), c = r(9618), u = r(7319), h = u.createShader, f = u.createPickShader, p = [
                                1,
                                0,
                                0,
                                0,
                                0,
                                1,
                                0,
                                0,
                                0,
                                0,
                                1,
                                0,
                                0,
                                0,
                                0,
                                1
                            ];
                            function d(t1, e1) {
                                for(var r = 0, n = 0; n < 3; ++n){
                                    var i = t1[n] - e1[n];
                                    r += i * i;
                                }
                                return Math.sqrt(r);
                            }
                            function m(t1) {
                                for(var e1 = [
                                    [
                                        -1000000,
                                        -1000000,
                                        -1000000
                                    ],
                                    [
                                        1e6,
                                        1e6,
                                        1e6
                                    ]
                                ], r = 0; r < 3; ++r)e1[0][r] = Math.max(t1[0][r], e1[0][r]), e1[1][r] = Math.min(t1[1][r], e1[1][r]);
                                return e1;
                            }
                            function g(t1, e1, r, n) {
                                this.arcLength = t1, this.position = e1, this.index = r, this.dataCoordinate = n;
                            }
                            function y(t1, e1, r, n, i, a) {
                                this.gl = t1, this.shader = e1, this.pickShader = r, this.buffer = n, this.vao = i, this.clipBounds = [
                                    [
                                        -1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ],
                                    [
                                        1 / 0,
                                        1 / 0,
                                        1 / 0
                                    ]
                                ], this.points = [], this.arcLength = [], this.vertexCount = 0, this.bounds = [
                                    [
                                        0,
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0,
                                        0
                                    ]
                                ], this.pickId = 0, this.lineWidth = 1, this.texture = a, this.dashScale = 1, this.opacity = 1, this.hasAlpha = !1, this.dirty = !0, this.pixelRatio = 1;
                            }
                            var v = y.prototype;
                            v.isTransparent = function() {
                                return this.hasAlpha;
                            }, v.isOpaque = function() {
                                return !this.hasAlpha;
                            }, v.pickSlots = 1, v.setPickBase = function(t1) {
                                this.pickId = t1;
                            }, v.drawTransparent = v.draw = function(t1) {
                                if (this.vertexCount) {
                                    var e1 = this.gl, r = this.shader, n = this.vao;
                                    r.bind(), r.uniforms = {
                                        model: t1.model || p,
                                        view: t1.view || p,
                                        projection: t1.projection || p,
                                        clipBounds: m(this.clipBounds),
                                        dashTexture: this.texture.bind(),
                                        dashScale: this.dashScale / this.arcLength[this.arcLength.length - 1],
                                        opacity: this.opacity,
                                        screenShape: [
                                            e1.drawingBufferWidth,
                                            e1.drawingBufferHeight
                                        ],
                                        pixelRatio: this.pixelRatio
                                    }, n.bind(), n.draw(e1.TRIANGLE_STRIP, this.vertexCount), n.unbind();
                                }
                            }, v.drawPick = function(t1) {
                                if (this.vertexCount) {
                                    var e1 = this.gl, r = this.pickShader, n = this.vao;
                                    r.bind(), r.uniforms = {
                                        model: t1.model || p,
                                        view: t1.view || p,
                                        projection: t1.projection || p,
                                        pickId: this.pickId,
                                        clipBounds: m(this.clipBounds),
                                        screenShape: [
                                            e1.drawingBufferWidth,
                                            e1.drawingBufferHeight
                                        ],
                                        pixelRatio: this.pixelRatio
                                    }, n.bind(), n.draw(e1.TRIANGLE_STRIP, this.vertexCount), n.unbind();
                                }
                            }, v.update = function(t1) {
                                var e1, r;
                                this.dirty = !0;
                                var n = !!t1.connectGaps;
                                "dashScale" in t1 && (this.dashScale = t1.dashScale), this.hasAlpha = !1, "opacity" in t1 && (this.opacity = +t1.opacity, this.opacity < 1 && (this.hasAlpha = !0));
                                var i = [], a = [], o = [], s = 0, u = 0, h = [
                                    [
                                        1 / 0,
                                        1 / 0,
                                        1 / 0
                                    ],
                                    [
                                        -1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ]
                                ], f = t1.position || t1.positions;
                                if (f) {
                                    var p = t1.color || t1.colors || [
                                        0,
                                        0,
                                        0,
                                        1
                                    ], m = t1.lineWidth || 1, g = !1;
                                    t: for(e1 = 1; e1 < f.length; ++e1){
                                        var y, v, x, _ = f[e1 - 1], b = f[e1];
                                        for(a.push(s), o.push(_.slice()), r = 0; r < 3; ++r){
                                            if (isNaN(_[r]) || isNaN(b[r]) || !isFinite(_[r]) || !isFinite(b[r])) {
                                                if (!n && i.length > 0) {
                                                    for(var w = 0; w < 24; ++w)i.push(i[i.length - 12]);
                                                    u += 2, g = !0;
                                                }
                                                continue t;
                                            }
                                            h[0][r] = Math.min(h[0][r], _[r], b[r]), h[1][r] = Math.max(h[1][r], _[r], b[r]);
                                        }
                                        Array.isArray(p[0]) ? (y = p.length > e1 - 1 ? p[e1 - 1] : p.length > 0 ? p[p.length - 1] : [
                                            0,
                                            0,
                                            0,
                                            1
                                        ], v = p.length > e1 ? p[e1] : p.length > 0 ? p[p.length - 1] : [
                                            0,
                                            0,
                                            0,
                                            1
                                        ]) : y = v = p, 3 === y.length && (y = [
                                            y[0],
                                            y[1],
                                            y[2],
                                            1
                                        ]), 3 === v.length && (v = [
                                            v[0],
                                            v[1],
                                            v[2],
                                            1
                                        ]), !this.hasAlpha && y[3] < 1 && (this.hasAlpha = !0), x = Array.isArray(m) ? m.length > e1 - 1 ? m[e1 - 1] : m.length > 0 ? m[m.length - 1] : [
                                            0,
                                            0,
                                            0,
                                            1
                                        ] : m;
                                        var T = s;
                                        if (s += d(_, b), g) {
                                            for(r = 0; r < 2; ++r)i.push(_[0], _[1], _[2], b[0], b[1], b[2], T, x, y[0], y[1], y[2], y[3]);
                                            u += 2, g = !1;
                                        }
                                        i.push(_[0], _[1], _[2], b[0], b[1], b[2], T, x, y[0], y[1], y[2], y[3], _[0], _[1], _[2], b[0], b[1], b[2], T, -x, y[0], y[1], y[2], y[3], b[0], b[1], b[2], _[0], _[1], _[2], s, -x, v[0], v[1], v[2], v[3], b[0], b[1], b[2], _[0], _[1], _[2], s, x, v[0], v[1], v[2], v[3]), u += 4;
                                    }
                                }
                                if (this.buffer.update(i), a.push(s), o.push(f[f.length - 1].slice()), this.bounds = h, this.vertexCount = u, this.points = o, this.arcLength = a, "dashes" in t1) {
                                    var k = t1.dashes.slice();
                                    for(k.unshift(0), e1 = 1; e1 < k.length; ++e1)k[e1] = k[e1 - 1] + k[e1];
                                    var A = c(new Array(1024), [
                                        256,
                                        1,
                                        4
                                    ]);
                                    for(e1 = 0; e1 < 256; ++e1){
                                        for(r = 0; r < 4; ++r)A.set(e1, 0, r, 0);
                                        1 & l.le(k, k[k.length - 1] * e1 / 255) ? A.set(e1, 0, 0, 0) : A.set(e1, 0, 0, 255);
                                    }
                                    this.texture.setPixels(A);
                                }
                            }, v.dispose = function() {
                                this.shader.dispose(), this.vao.dispose(), this.buffer.dispose();
                            }, v.pick = function(t1) {
                                if (!t1) return null;
                                if (t1.id !== this.pickId) return null;
                                var e1 = function(t1, e1, r, n) {
                                    return o[0] = 0, o[1] = r, o[2] = e1, o[3] = t1, s[0];
                                }(t1.value[0], t1.value[1], t1.value[2]), r = l.le(this.arcLength, e1);
                                if (r < 0) return null;
                                if (r === this.arcLength.length - 1) return new g(this.arcLength[this.arcLength.length - 1], this.points[this.points.length - 1].slice(), r);
                                for(var n = this.points[r], i = this.points[Math.min(r + 1, this.points.length - 1)], a = (e1 - this.arcLength[r]) / (this.arcLength[r + 1] - this.arcLength[r]), c = 1 - a, u = [
                                    0,
                                    0,
                                    0
                                ], h = 0; h < 3; ++h)u[h] = c * n[h] + a * i[h];
                                var f = Math.min(a < .5 ? r : r + 1, this.points.length - 1);
                                return new g(e1, u, f, this.points[f]);
                            };
                        },
                        1903: function(t1) {
                            t1.exports = function(t1) {
                                var e1 = new Float32Array(16);
                                return e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1[3] = t1[3], e1[4] = t1[4], e1[5] = t1[5], e1[6] = t1[6], e1[7] = t1[7], e1[8] = t1[8], e1[9] = t1[9], e1[10] = t1[10], e1[11] = t1[11], e1[12] = t1[12], e1[13] = t1[13], e1[14] = t1[14], e1[15] = t1[15], e1;
                            };
                        },
                        6864: function(t1) {
                            t1.exports = function() {
                                var t1 = new Float32Array(16);
                                return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = 1, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 1, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
                            };
                        },
                        9921: function(t1) {
                            t1.exports = function(t1) {
                                var e1 = t1[0], r = t1[1], n = t1[2], i = t1[3], a = t1[4], o = t1[5], s = t1[6], l = t1[7], c = t1[8], u = t1[9], h = t1[10], f = t1[11], p = t1[12], d = t1[13], m = t1[14], g = t1[15];
                                return (e1 * o - r * a) * (h * g - f * m) - (e1 * s - n * a) * (u * g - f * d) + (e1 * l - i * a) * (u * m - h * d) + (r * s - n * o) * (c * g - f * p) - (r * l - i * o) * (c * m - h * p) + (n * l - i * s) * (c * d - u * p);
                            };
                        },
                        7399: function(t1) {
                            t1.exports = function(t1, e1) {
                                var r = e1[0], n = e1[1], i = e1[2], a = e1[3], o = r + r, s = n + n, l = i + i, c = r * o, u = n * o, h = n * s, f = i * o, p = i * s, d = i * l, m = a * o, g = a * s, y = a * l;
                                return t1[0] = 1 - h - d, t1[1] = u + y, t1[2] = f - g, t1[3] = 0, t1[4] = u - y, t1[5] = 1 - c - d, t1[6] = p + m, t1[7] = 0, t1[8] = f + g, t1[9] = p - m, t1[10] = 1 - c - h, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
                            };
                        },
                        6743: function(t1) {
                            t1.exports = function(t1, e1, r) {
                                var n = e1[0], i = e1[1], a = e1[2], o = e1[3], s = n + n, l = i + i, c = a + a, u = n * s, h = n * l, f = n * c, p = i * l, d = i * c, m = a * c, g = o * s, y = o * l, v = o * c;
                                return t1[0] = 1 - (p + m), t1[1] = h + v, t1[2] = f - y, t1[3] = 0, t1[4] = h - v, t1[5] = 1 - (u + m), t1[6] = d + g, t1[7] = 0, t1[8] = f + y, t1[9] = d - g, t1[10] = 1 - (u + p), t1[11] = 0, t1[12] = r[0], t1[13] = r[1], t1[14] = r[2], t1[15] = 1, t1;
                            };
                        },
                        7894: function(t1) {
                            t1.exports = function(t1) {
                                return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = 1, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 1, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
                            };
                        },
                        7608: function(t1) {
                            t1.exports = function(t1, e1) {
                                var r = e1[0], n = e1[1], i = e1[2], a = e1[3], o = e1[4], s = e1[5], l = e1[6], c = e1[7], u = e1[8], h = e1[9], f = e1[10], p = e1[11], d = e1[12], m = e1[13], g = e1[14], y = e1[15], v = r * s - n * o, x = r * l - i * o, _ = r * c - a * o, b = n * l - i * s, w = n * c - a * s, T = i * c - a * l, k = u * m - h * d, A = u * g - f * d, M = u * y - p * d, S = h * g - f * m, E = h * y - p * m, C = f * y - p * g, L = v * C - x * E + _ * S + b * M - w * A + T * k;
                                return L ? (L = 1 / L, t1[0] = (s * C - l * E + c * S) * L, t1[1] = (i * E - n * C - a * S) * L, t1[2] = (m * T - g * w + y * b) * L, t1[3] = (f * w - h * T - p * b) * L, t1[4] = (l * M - o * C - c * A) * L, t1[5] = (r * C - i * M + a * A) * L, t1[6] = (g * _ - d * T - y * x) * L, t1[7] = (u * T - f * _ + p * x) * L, t1[8] = (o * E - s * M + c * k) * L, t1[9] = (n * M - r * E - a * k) * L, t1[10] = (d * w - m * _ + y * v) * L, t1[11] = (h * _ - u * w - p * v) * L, t1[12] = (s * A - o * S - l * k) * L, t1[13] = (r * S - n * A + i * k) * L, t1[14] = (m * x - d * b - g * v) * L, t1[15] = (u * b - h * x + f * v) * L, t1) : null;
                            };
                        },
                        6582: function(t1, e1, r) {
                            var n = r(7894);
                            t1.exports = function(t1, e1, r, i) {
                                var a, o, s, l, c, u, h, f, p, d, m = e1[0], g = e1[1], y = e1[2], v = i[0], x = i[1], _ = i[2], b = r[0], w = r[1], T = r[2];
                                return Math.abs(m - b) < 1e-6 && Math.abs(g - w) < 1e-6 && Math.abs(y - T) < 1e-6 ? n(t1) : (h = m - b, f = g - w, p = y - T, a = x * (p *= d = 1 / Math.sqrt(h * h + f * f + p * p)) - _ * (f *= d), o = _ * (h *= d) - v * p, s = v * f - x * h, (d = Math.sqrt(a * a + o * o + s * s)) ? (a *= d = 1 / d, o *= d, s *= d) : (a = 0, o = 0, s = 0), l = f * s - p * o, c = p * a - h * s, u = h * o - f * a, (d = Math.sqrt(l * l + c * c + u * u)) ? (l *= d = 1 / d, c *= d, u *= d) : (l = 0, c = 0, u = 0), t1[0] = a, t1[1] = l, t1[2] = h, t1[3] = 0, t1[4] = o, t1[5] = c, t1[6] = f, t1[7] = 0, t1[8] = s, t1[9] = u, t1[10] = p, t1[11] = 0, t1[12] = -(a * m + o * g + s * y), t1[13] = -(l * m + c * g + u * y), t1[14] = -(h * m + f * g + p * y), t1[15] = 1, t1);
                            };
                        },
                        6760: function(t1) {
                            t1.exports = function(t1, e1, r) {
                                var n = e1[0], i = e1[1], a = e1[2], o = e1[3], s = e1[4], l = e1[5], c = e1[6], u = e1[7], h = e1[8], f = e1[9], p = e1[10], d = e1[11], m = e1[12], g = e1[13], y = e1[14], v = e1[15], x = r[0], _ = r[1], b = r[2], w = r[3];
                                return t1[0] = x * n + _ * s + b * h + w * m, t1[1] = x * i + _ * l + b * f + w * g, t1[2] = x * a + _ * c + b * p + w * y, t1[3] = x * o + _ * u + b * d + w * v, x = r[4], _ = r[5], b = r[6], w = r[7], t1[4] = x * n + _ * s + b * h + w * m, t1[5] = x * i + _ * l + b * f + w * g, t1[6] = x * a + _ * c + b * p + w * y, t1[7] = x * o + _ * u + b * d + w * v, x = r[8], _ = r[9], b = r[10], w = r[11], t1[8] = x * n + _ * s + b * h + w * m, t1[9] = x * i + _ * l + b * f + w * g, t1[10] = x * a + _ * c + b * p + w * y, t1[11] = x * o + _ * u + b * d + w * v, x = r[12], _ = r[13], b = r[14], w = r[15], t1[12] = x * n + _ * s + b * h + w * m, t1[13] = x * i + _ * l + b * f + w * g, t1[14] = x * a + _ * c + b * p + w * y, t1[15] = x * o + _ * u + b * d + w * v, t1;
                            };
                        },
                        4040: function(t1) {
                            t1.exports = function(t1, e1, r, n, i, a, o) {
                                var s = 1 / (e1 - r), l = 1 / (n - i), c = 1 / (a - o);
                                return t1[0] = -2 * s, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = -2 * l, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 2 * c, t1[11] = 0, t1[12] = (e1 + r) * s, t1[13] = (i + n) * l, t1[14] = (o + a) * c, t1[15] = 1, t1;
                            };
                        },
                        4772: function(t1) {
                            t1.exports = function(t1, e1, r, n, i) {
                                var a = 1 / Math.tan(e1 / 2), o = 1 / (n - i);
                                return t1[0] = a / r, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = a, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = (i + n) * o, t1[11] = -1, t1[12] = 0, t1[13] = 0, t1[14] = 2 * i * n * o, t1[15] = 0, t1;
                            };
                        },
                        6079: function(t1) {
                            t1.exports = function(t1, e1, r, n) {
                                var i, a, o, s, l, c, u, h, f, p, d, m, g, y, v, x, _, b, w, T, k, A, M, S, E = n[0], C = n[1], L = n[2], I = Math.sqrt(E * E + C * C + L * L);
                                return Math.abs(I) < 1e-6 ? null : (E *= I = 1 / I, C *= I, L *= I, i = Math.sin(r), o = 1 - (a = Math.cos(r)), s = e1[0], l = e1[1], c = e1[2], u = e1[3], h = e1[4], f = e1[5], p = e1[6], d = e1[7], m = e1[8], g = e1[9], y = e1[10], v = e1[11], x = E * E * o + a, _ = C * E * o + L * i, b = L * E * o - C * i, w = E * C * o - L * i, T = C * C * o + a, k = L * C * o + E * i, A = E * L * o + C * i, M = C * L * o - E * i, S = L * L * o + a, t1[0] = s * x + h * _ + m * b, t1[1] = l * x + f * _ + g * b, t1[2] = c * x + p * _ + y * b, t1[3] = u * x + d * _ + v * b, t1[4] = s * w + h * T + m * k, t1[5] = l * w + f * T + g * k, t1[6] = c * w + p * T + y * k, t1[7] = u * w + d * T + v * k, t1[8] = s * A + h * M + m * S, t1[9] = l * A + f * M + g * S, t1[10] = c * A + p * M + y * S, t1[11] = u * A + d * M + v * S, e1 !== t1 && (t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]), t1);
                            };
                        },
                        5567: function(t1) {
                            t1.exports = function(t1, e1, r) {
                                var n = Math.sin(r), i = Math.cos(r), a = e1[4], o = e1[5], s = e1[6], l = e1[7], c = e1[8], u = e1[9], h = e1[10], f = e1[11];
                                return e1 !== t1 && (t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1[3] = e1[3], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]), t1[4] = a * i + c * n, t1[5] = o * i + u * n, t1[6] = s * i + h * n, t1[7] = l * i + f * n, t1[8] = c * i - a * n, t1[9] = u * i - o * n, t1[10] = h * i - s * n, t1[11] = f * i - l * n, t1;
                            };
                        },
                        2408: function(t1) {
                            t1.exports = function(t1, e1, r) {
                                var n = Math.sin(r), i = Math.cos(r), a = e1[0], o = e1[1], s = e1[2], l = e1[3], c = e1[8], u = e1[9], h = e1[10], f = e1[11];
                                return e1 !== t1 && (t1[4] = e1[4], t1[5] = e1[5], t1[6] = e1[6], t1[7] = e1[7], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]), t1[0] = a * i - c * n, t1[1] = o * i - u * n, t1[2] = s * i - h * n, t1[3] = l * i - f * n, t1[8] = a * n + c * i, t1[9] = o * n + u * i, t1[10] = s * n + h * i, t1[11] = l * n + f * i, t1;
                            };
                        },
                        7089: function(t1) {
                            t1.exports = function(t1, e1, r) {
                                var n = Math.sin(r), i = Math.cos(r), a = e1[0], o = e1[1], s = e1[2], l = e1[3], c = e1[4], u = e1[5], h = e1[6], f = e1[7];
                                return e1 !== t1 && (t1[8] = e1[8], t1[9] = e1[9], t1[10] = e1[10], t1[11] = e1[11], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]), t1[0] = a * i + c * n, t1[1] = o * i + u * n, t1[2] = s * i + h * n, t1[3] = l * i + f * n, t1[4] = c * i - a * n, t1[5] = u * i - o * n, t1[6] = h * i - s * n, t1[7] = f * i - l * n, t1;
                            };
                        },
                        2504: function(t1) {
                            t1.exports = function(t1, e1, r) {
                                var n = r[0], i = r[1], a = r[2];
                                return t1[0] = e1[0] * n, t1[1] = e1[1] * n, t1[2] = e1[2] * n, t1[3] = e1[3] * n, t1[4] = e1[4] * i, t1[5] = e1[5] * i, t1[6] = e1[6] * i, t1[7] = e1[7] * i, t1[8] = e1[8] * a, t1[9] = e1[9] * a, t1[10] = e1[10] * a, t1[11] = e1[11] * a, t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15], t1;
                            };
                        },
                        7656: function(t1) {
                            t1.exports = function(t1, e1, r) {
                                var n, i, a, o, s, l, c, u, h, f, p, d, m = r[0], g = r[1], y = r[2];
                                return e1 === t1 ? (t1[12] = e1[0] * m + e1[4] * g + e1[8] * y + e1[12], t1[13] = e1[1] * m + e1[5] * g + e1[9] * y + e1[13], t1[14] = e1[2] * m + e1[6] * g + e1[10] * y + e1[14], t1[15] = e1[3] * m + e1[7] * g + e1[11] * y + e1[15]) : (n = e1[0], i = e1[1], a = e1[2], o = e1[3], s = e1[4], l = e1[5], c = e1[6], u = e1[7], h = e1[8], f = e1[9], p = e1[10], d = e1[11], t1[0] = n, t1[1] = i, t1[2] = a, t1[3] = o, t1[4] = s, t1[5] = l, t1[6] = c, t1[7] = u, t1[8] = h, t1[9] = f, t1[10] = p, t1[11] = d, t1[12] = n * m + s * g + h * y + e1[12], t1[13] = i * m + l * g + f * y + e1[13], t1[14] = a * m + c * g + p * y + e1[14], t1[15] = o * m + u * g + d * y + e1[15]), t1;
                            };
                        },
                        5665: function(t1) {
                            t1.exports = function(t1, e1) {
                                if (t1 === e1) {
                                    var r = e1[1], n = e1[2], i = e1[3], a = e1[6], o = e1[7], s = e1[11];
                                    t1[1] = e1[4], t1[2] = e1[8], t1[3] = e1[12], t1[4] = r, t1[6] = e1[9], t1[7] = e1[13], t1[8] = n, t1[9] = a, t1[11] = e1[14], t1[12] = i, t1[13] = o, t1[14] = s;
                                } else t1[0] = e1[0], t1[1] = e1[4], t1[2] = e1[8], t1[3] = e1[12], t1[4] = e1[1], t1[5] = e1[5], t1[6] = e1[9], t1[7] = e1[13], t1[8] = e1[2], t1[9] = e1[6], t1[10] = e1[10], t1[11] = e1[14], t1[12] = e1[3], t1[13] = e1[7], t1[14] = e1[11], t1[15] = e1[15];
                                return t1;
                            };
                        },
                        7626: function(t1, e1, r) {
                            "use strict";
                            var n = r(2642), i = r(9346);
                            function a(t1, e1) {
                                for(var r = [
                                    0,
                                    0,
                                    0,
                                    0
                                ], n = 0; n < 4; ++n)for(var i = 0; i < 4; ++i)r[i] += t1[4 * n + i] * e1[n];
                                return r;
                            }
                            function o(t1, e1, r, n, i) {
                                for(var o = a(n, a(r, a(e1, [
                                    t1[0],
                                    t1[1],
                                    t1[2],
                                    1
                                ]))), s = 0; s < 3; ++s)o[s] /= o[3];
                                return [
                                    .5 * i[0] * (1 + o[0]),
                                    .5 * i[1] * (1 - o[1])
                                ];
                            }
                            function s(t1, e1) {
                                for(var r = [
                                    0,
                                    0,
                                    0
                                ], n = 0; n < t1.length; ++n)for(var i = t1[n], a = e1[n], o = 0; o < 3; ++o)r[o] += a * i[o];
                                return r;
                            }
                            t1.exports = function(t1, e1, r, a, l, c) {
                                if (1 === t1.length) return [
                                    0,
                                    t1[0].slice()
                                ];
                                for(var u = new Array(t1.length), h = 0; h < t1.length; ++h)u[h] = o(t1[h], r, a, l, c);
                                var f = 0, p = 1 / 0;
                                for(h = 0; h < u.length; ++h){
                                    for(var d = 0, m = 0; m < 2; ++m)d += Math.pow(u[h][m] - e1[m], 2);
                                    d < p && (p = d, f = h);
                                }
                                var g = function(t1, e1) {
                                    if (2 === t1.length) {
                                        for(var r = 0, a = 0, o = 0; o < 2; ++o)r += Math.pow(e1[o] - t1[0][o], 2), a += Math.pow(e1[o] - t1[1][o], 2);
                                        return (r = Math.sqrt(r)) + (a = Math.sqrt(a)) < 1e-6 ? [
                                            1,
                                            0
                                        ] : [
                                            a / (r + a),
                                            r / (a + r)
                                        ];
                                    }
                                    if (3 === t1.length) {
                                        var s = [
                                            0,
                                            0
                                        ];
                                        return i(t1[0], t1[1], t1[2], e1, s), n(t1, s);
                                    }
                                    return [];
                                }(u, e1), y = 0;
                                for(h = 0; h < 3; ++h){
                                    if (g[h] < -0.001 || g[h] > 1.0001) return null;
                                    y += g[h];
                                }
                                return Math.abs(y - 1) > .001 ? null : [
                                    f,
                                    s(t1, g),
                                    g
                                ];
                            };
                        },
                        840: function(t1, e1, r) {
                            var n = r(3236), i = n([
                                "precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position, normal;\nattribute vec4 color;\nattribute vec2 uv;\n\nuniform mat4 model\n           , view\n           , projection\n           , inverseModel;\nuniform vec3 eyePosition\n           , lightPosition;\n\nvarying vec3 f_normal\n           , f_lightDirection\n           , f_eyeDirection\n           , f_data;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvec4 project(vec3 p) {\n  return projection * (view * (model * vec4(p, 1.0)));\n}\n\nvoid main() {\n  gl_Position      = project(position);\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * vec4(position , 1.0);\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  f_lightDirection = lightPosition - cameraCoordinate.xyz;\n  f_eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  f_normal  = normalize((vec4(normal, 0.0) * inverseModel).xyz);\n\n  f_color          = color;\n  f_data           = position;\n  f_uv             = uv;\n}\n"
                            ]), a = n([
                                "#extension GL_OES_standard_derivatives : enable\n\nprecision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat cookTorranceSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness,\n  float fresnel) {\n\n  float VdotN = max(dot(viewDirection, surfaceNormal), 0.0);\n  float LdotN = max(dot(lightDirection, surfaceNormal), 0.0);\n\n  //Half angle vector\n  vec3 H = normalize(lightDirection + viewDirection);\n\n  //Geometric term\n  float NdotH = max(dot(surfaceNormal, H), 0.0);\n  float VdotH = max(dot(viewDirection, H), 0.000001);\n  float LdotH = max(dot(lightDirection, H), 0.000001);\n  float G1 = (2.0 * NdotH * VdotN) / VdotH;\n  float G2 = (2.0 * NdotH * LdotN) / LdotH;\n  float G = min(1.0, min(G1, G2));\n  \n  //Distribution term\n  float D = beckmannDistribution(NdotH, roughness);\n\n  //Fresnel term\n  float F = pow(1.0 - VdotN, fresnel);\n\n  //Multiply terms and done\n  return  G * F * D / max(3.14159265 * VdotN, 0.000001);\n}\n\n//#pragma glslify: beckmann = require(glsl-specular-beckmann) // used in gl-surface3d\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float roughness\n            , fresnel\n            , kambient\n            , kdiffuse\n            , kspecular;\nuniform sampler2D texture;\n\nvarying vec3 f_normal\n           , f_lightDirection\n           , f_eyeDirection\n           , f_data;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (f_color.a == 0.0 ||\n    outOfRange(clipBounds[0], clipBounds[1], f_data)\n  ) discard;\n\n  vec3 N = normalize(f_normal);\n  vec3 L = normalize(f_lightDirection);\n  vec3 V = normalize(f_eyeDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = min(1.0, max(0.0, cookTorranceSpecular(L, V, N, roughness, fresnel)));\n  //float specular = max(0.0, beckmann(L, V, N, roughness)); // used in gl-surface3d\n\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  vec4 surfaceColor = vec4(f_color.rgb, 1.0) * texture2D(texture, f_uv);\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = litColor * f_color.a;\n}\n"
                            ]), o = n([
                                "precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 uv;\n\nuniform mat4 model, view, projection;\n\nvarying vec4 f_color;\nvarying vec3 f_data;\nvarying vec2 f_uv;\n\nvoid main() {\n  gl_Position = projection * (view * (model * vec4(position, 1.0)));\n  f_color = color;\n  f_data  = position;\n  f_uv    = uv;\n}"
                            ]), s = n([
                                "precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform sampler2D texture;\nuniform float opacity;\n\nvarying vec4 f_color;\nvarying vec3 f_data;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_data)) discard;\n\n  gl_FragColor = f_color * texture2D(texture, f_uv) * opacity;\n}"
                            ]), l = n([
                                "precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 uv;\nattribute float pointSize;\n\nuniform mat4 model, view, projection;\nuniform vec3 clipBounds[2];\n\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0.0, 0.0 ,0.0 ,0.0);\n  } else {\n    gl_Position = projection * (view * (model * vec4(position, 1.0)));\n  }\n  gl_PointSize = pointSize;\n  f_color = color;\n  f_uv = uv;\n}"
                            ]), c = n([
                                "precision highp float;\n#define GLSLIFY 1\n\nuniform sampler2D texture;\nuniform float opacity;\n\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  vec2 pointR = gl_PointCoord.xy - vec2(0.5, 0.5);\n  if(dot(pointR, pointR) > 0.25) {\n    discard;\n  }\n  gl_FragColor = f_color * texture2D(texture, f_uv) * opacity;\n}"
                            ]), u = n([
                                "precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  gl_Position = projection * (view * (model * vec4(position, 1.0)));\n  f_id        = id;\n  f_position  = position;\n}"
                            ]), h = n([
                                "precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3  clipBounds[2];\nuniform float pickId;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n\n  gl_FragColor = vec4(pickId, f_id.xyz);\n}"
                            ]), f = n([
                                "precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3  position;\nattribute float pointSize;\nattribute vec4  id;\n\nuniform mat4 model, view, projection;\nuniform vec3 clipBounds[2];\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0.0, 0.0, 0.0, 0.0);\n  } else {\n    gl_Position  = projection * (view * (model * vec4(position, 1.0)));\n    gl_PointSize = pointSize;\n  }\n  f_id         = id;\n  f_position   = position;\n}"
                            ]), p = n([
                                "precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\n\nuniform mat4 model, view, projection;\n\nvoid main() {\n  gl_Position = projection * (view * (model * vec4(position, 1.0)));\n}"
                            ]), d = n([
                                "precision highp float;\n#define GLSLIFY 1\n\nuniform vec3 contourColor;\n\nvoid main() {\n  gl_FragColor = vec4(contourColor, 1.0);\n}\n"
                            ]);
                            e1.meshShader = {
                                vertex: i,
                                fragment: a,
                                attributes: [
                                    {
                                        name: "position",
                                        type: "vec3"
                                    },
                                    {
                                        name: "normal",
                                        type: "vec3"
                                    },
                                    {
                                        name: "color",
                                        type: "vec4"
                                    },
                                    {
                                        name: "uv",
                                        type: "vec2"
                                    }
                                ]
                            }, e1.wireShader = {
                                vertex: o,
                                fragment: s,
                                attributes: [
                                    {
                                        name: "position",
                                        type: "vec3"
                                    },
                                    {
                                        name: "color",
                                        type: "vec4"
                                    },
                                    {
                                        name: "uv",
                                        type: "vec2"
                                    }
                                ]
                            }, e1.pointShader = {
                                vertex: l,
                                fragment: c,
                                attributes: [
                                    {
                                        name: "position",
                                        type: "vec3"
                                    },
                                    {
                                        name: "color",
                                        type: "vec4"
                                    },
                                    {
                                        name: "uv",
                                        type: "vec2"
                                    },
                                    {
                                        name: "pointSize",
                                        type: "float"
                                    }
                                ]
                            }, e1.pickShader = {
                                vertex: u,
                                fragment: h,
                                attributes: [
                                    {
                                        name: "position",
                                        type: "vec3"
                                    },
                                    {
                                        name: "id",
                                        type: "vec4"
                                    }
                                ]
                            }, e1.pointPickShader = {
                                vertex: f,
                                fragment: h,
                                attributes: [
                                    {
                                        name: "position",
                                        type: "vec3"
                                    },
                                    {
                                        name: "pointSize",
                                        type: "float"
                                    },
                                    {
                                        name: "id",
                                        type: "vec4"
                                    }
                                ]
                            }, e1.contourShader = {
                                vertex: p,
                                fragment: d,
                                attributes: [
                                    {
                                        name: "position",
                                        type: "vec3"
                                    }
                                ]
                            };
                        },
                        7201: function(t1, e1, r) {
                            "use strict";
                            var n = r(9405), i = r(2762), a = r(8116), o = r(7766), s = r(8406), l = r(6760), c = r(7608), u = r(9618), h = r(6729), f = r(7765), p = r(1888), d = r(840), m = r(7626), g = d.meshShader, y = d.wireShader, v = d.pointShader, x = d.pickShader, _ = d.pointPickShader, b = d.contourShader, w = [
                                1,
                                0,
                                0,
                                0,
                                0,
                                1,
                                0,
                                0,
                                0,
                                0,
                                1,
                                0,
                                0,
                                0,
                                0,
                                1
                            ];
                            function T(t1, e1, r, n, i, a, o, s, l, c, u, h, f, p, d, m, g, y, v, x, _, b, T, k, A, M, S) {
                                this.gl = t1, this.pixelRatio = 1, this.cells = [], this.positions = [], this.intensity = [], this.texture = e1, this.dirty = !0, this.triShader = r, this.lineShader = n, this.pointShader = i, this.pickShader = a, this.pointPickShader = o, this.contourShader = s, this.trianglePositions = l, this.triangleColors = u, this.triangleNormals = f, this.triangleUVs = h, this.triangleIds = c, this.triangleVAO = p, this.triangleCount = 0, this.lineWidth = 1, this.edgePositions = d, this.edgeColors = g, this.edgeUVs = y, this.edgeIds = m, this.edgeVAO = v, this.edgeCount = 0, this.pointPositions = x, this.pointColors = b, this.pointUVs = T, this.pointSizes = k, this.pointIds = _, this.pointVAO = A, this.pointCount = 0, this.contourLineWidth = 1, this.contourPositions = M, this.contourVAO = S, this.contourCount = 0, this.contourColor = [
                                    0,
                                    0,
                                    0
                                ], this.contourEnable = !0, this.pickVertex = !0, this.pickId = 1, this.bounds = [
                                    [
                                        1 / 0,
                                        1 / 0,
                                        1 / 0
                                    ],
                                    [
                                        -1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ]
                                ], this.clipBounds = [
                                    [
                                        -1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ],
                                    [
                                        1 / 0,
                                        1 / 0,
                                        1 / 0
                                    ]
                                ], this.lightPosition = [
                                    1e5,
                                    1e5,
                                    0
                                ], this.ambientLight = .8, this.diffuseLight = .8, this.specularLight = 2, this.roughness = .5, this.fresnel = 1.5, this.opacity = 1, this.hasAlpha = !1, this.opacityscale = !1, this._model = w, this._view = w, this._projection = w, this._resolution = [
                                    1,
                                    1
                                ];
                            }
                            var k = T.prototype;
                            function A(t1, e1) {
                                if (!e1) return 1;
                                if (!e1.length) return 1;
                                for(var r = 0; r < e1.length; ++r){
                                    if (e1.length < 2) return 1;
                                    if (e1[r][0] === t1) return e1[r][1];
                                    if (e1[r][0] > t1 && r > 0) {
                                        var n = (e1[r][0] - t1) / (e1[r][0] - e1[r - 1][0]);
                                        return e1[r][1] * (1 - n) + n * e1[r - 1][1];
                                    }
                                }
                                return 1;
                            }
                            function M(t1) {
                                var e1 = n(t1, v.vertex, v.fragment);
                                return e1.attributes.position.location = 0, e1.attributes.color.location = 2, e1.attributes.uv.location = 3, e1.attributes.pointSize.location = 4, e1;
                            }
                            function S(t1) {
                                var e1 = n(t1, x.vertex, x.fragment);
                                return e1.attributes.position.location = 0, e1.attributes.id.location = 1, e1;
                            }
                            function E(t1) {
                                var e1 = n(t1, _.vertex, _.fragment);
                                return e1.attributes.position.location = 0, e1.attributes.id.location = 1, e1.attributes.pointSize.location = 4, e1;
                            }
                            function C(t1) {
                                var e1 = n(t1, b.vertex, b.fragment);
                                return e1.attributes.position.location = 0, e1;
                            }
                            k.isOpaque = function() {
                                return !this.hasAlpha;
                            }, k.isTransparent = function() {
                                return this.hasAlpha;
                            }, k.pickSlots = 1, k.setPickBase = function(t1) {
                                this.pickId = t1;
                            }, k.highlight = function(t1) {
                                if (t1 && this.contourEnable) {
                                    for(var e1 = f(this.cells, this.intensity, t1.intensity), r = e1.cells, n = e1.vertexIds, i = e1.vertexWeights, a = r.length, o = p.mallocFloat32(6 * a), s = 0, l = 0; l < a; ++l)for(var c = r[l], u = 0; u < 2; ++u){
                                        var h = c[0];
                                        2 === c.length && (h = c[u]);
                                        for(var d = n[h][0], m = n[h][1], g = i[h], y = 1 - g, v = this.positions[d], x = this.positions[m], _ = 0; _ < 3; ++_)o[s++] = g * v[_] + y * x[_];
                                    }
                                    this.contourCount = s / 3 | 0, this.contourPositions.update(o.subarray(0, s)), p.free(o);
                                } else this.contourCount = 0;
                            }, k.update = function(t1) {
                                t1 = t1 || {};
                                var e1 = this.gl;
                                this.dirty = !0, "contourEnable" in t1 && (this.contourEnable = t1.contourEnable), "contourColor" in t1 && (this.contourColor = t1.contourColor), "lineWidth" in t1 && (this.lineWidth = t1.lineWidth), "lightPosition" in t1 && (this.lightPosition = t1.lightPosition), this.hasAlpha = !1, "opacity" in t1 && (this.opacity = t1.opacity, this.opacity < 1 && (this.hasAlpha = !0)), "opacityscale" in t1 && (this.opacityscale = t1.opacityscale, this.hasAlpha = !0), "ambient" in t1 && (this.ambientLight = t1.ambient), "diffuse" in t1 && (this.diffuseLight = t1.diffuse), "specular" in t1 && (this.specularLight = t1.specular), "roughness" in t1 && (this.roughness = t1.roughness), "fresnel" in t1 && (this.fresnel = t1.fresnel), t1.texture ? (this.texture.dispose(), this.texture = o(e1, t1.texture)) : t1.colormap && (this.texture.shape = [
                                    256,
                                    256
                                ], this.texture.minFilter = e1.LINEAR_MIPMAP_LINEAR, this.texture.magFilter = e1.LINEAR, this.texture.setPixels(function(t1, e1) {
                                    for(var r = h({
                                        colormap: t1,
                                        nshades: 256,
                                        format: "rgba"
                                    }), n = new Uint8Array(1024), i = 0; i < 256; ++i){
                                        for(var a = r[i], o = 0; o < 3; ++o)n[4 * i + o] = a[o];
                                        n[4 * i + 3] = e1 ? 255 * A(i / 255, e1) : 255 * a[3];
                                    }
                                    return u(n, [
                                        256,
                                        256,
                                        4
                                    ], [
                                        4,
                                        0,
                                        1
                                    ]);
                                }(t1.colormap, this.opacityscale)), this.texture.generateMipmap());
                                var r = t1.cells, n = t1.positions;
                                if (n && r) {
                                    var i = [], a = [], l = [], c = [], f = [], p = [], d = [], m = [], g = [], y = [], v = [], x = [], _ = [], b = [];
                                    this.cells = r, this.positions = n;
                                    var w = t1.vertexNormals, T = t1.cellNormals, k = void 0 === t1.vertexNormalsEpsilon ? 1e-6 : t1.vertexNormalsEpsilon, M = void 0 === t1.faceNormalsEpsilon ? 1e-6 : t1.faceNormalsEpsilon;
                                    t1.useFacetNormals && !T && (T = s.faceNormals(r, n, M)), T || w || (w = s.vertexNormals(r, n, k));
                                    var S = t1.vertexColors, E = t1.cellColors, C = t1.meshColor || [
                                        1,
                                        1,
                                        1,
                                        1
                                    ], L = t1.vertexUVs, I = t1.vertexIntensity, P = t1.cellUVs, z = t1.cellIntensity, O = 1 / 0, D = -1 / 0;
                                    if (!L && !P) {
                                        if (I) {
                                            if (t1.vertexIntensityBounds) O = +t1.vertexIntensityBounds[0], D = +t1.vertexIntensityBounds[1];
                                            else for(var R = 0; R < I.length; ++R){
                                                var F = I[R];
                                                O = Math.min(O, F), D = Math.max(D, F);
                                            }
                                        } else if (z) {
                                            if (t1.cellIntensityBounds) O = +t1.cellIntensityBounds[0], D = +t1.cellIntensityBounds[1];
                                            else for(R = 0; R < z.length; ++R)F = z[R], O = Math.min(O, F), D = Math.max(D, F);
                                        } else for(R = 0; R < n.length; ++R)F = n[R][2], O = Math.min(O, F), D = Math.max(D, F);
                                    }
                                    this.intensity = I || z || function(t1) {
                                        for(var e1 = t1.length, r = new Array(e1), n = 0; n < e1; ++n)r[n] = t1[n][2];
                                        return r;
                                    }(n), this.pickVertex = !(z || E);
                                    var B = t1.pointSizes, N = t1.pointSize || 1;
                                    for(this.bounds = [
                                        [
                                            1 / 0,
                                            1 / 0,
                                            1 / 0
                                        ],
                                        [
                                            -1 / 0,
                                            -1 / 0,
                                            -1 / 0
                                        ]
                                    ], R = 0; R < n.length; ++R)for(var j = n[R], U = 0; U < 3; ++U)!isNaN(j[U]) && isFinite(j[U]) && (this.bounds[0][U] = Math.min(this.bounds[0][U], j[U]), this.bounds[1][U] = Math.max(this.bounds[1][U], j[U]));
                                    var V = 0, q = 0, H = 0;
                                    t: for(R = 0; R < r.length; ++R){
                                        var G = r[R];
                                        switch(G.length){
                                            case 1:
                                                for(j = n[W = G[0]], U = 0; U < 3; ++U)if (isNaN(j[U]) || !isFinite(j[U])) continue t;
                                                y.push(j[0], j[1], j[2]), Y = S ? S[W] : E ? E[R] : C, this.opacityscale && I ? a.push(Y[0], Y[1], Y[2], this.opacity * A((I[W] - O) / (D - O), this.opacityscale)) : 3 === Y.length ? v.push(Y[0], Y[1], Y[2], this.opacity) : (v.push(Y[0], Y[1], Y[2], Y[3] * this.opacity), Y[3] < 1 && (this.hasAlpha = !0)), X = L ? L[W] : I ? [
                                                    (I[W] - O) / (D - O),
                                                    0
                                                ] : P ? P[R] : z ? [
                                                    (z[R] - O) / (D - O),
                                                    0
                                                ] : [
                                                    (j[2] - O) / (D - O),
                                                    0
                                                ], x.push(X[0], X[1]), B ? _.push(B[W]) : _.push(N), b.push(R), H += 1;
                                                break;
                                            case 2:
                                                for(U = 0; U < 2; ++U){
                                                    j = n[W = G[U]];
                                                    for(var Z = 0; Z < 3; ++Z)if (isNaN(j[Z]) || !isFinite(j[Z])) continue t;
                                                }
                                                for(U = 0; U < 2; ++U)j = n[W = G[U]], p.push(j[0], j[1], j[2]), Y = S ? S[W] : E ? E[R] : C, this.opacityscale && I ? a.push(Y[0], Y[1], Y[2], this.opacity * A((I[W] - O) / (D - O), this.opacityscale)) : 3 === Y.length ? d.push(Y[0], Y[1], Y[2], this.opacity) : (d.push(Y[0], Y[1], Y[2], Y[3] * this.opacity), Y[3] < 1 && (this.hasAlpha = !0)), X = L ? L[W] : I ? [
                                                    (I[W] - O) / (D - O),
                                                    0
                                                ] : P ? P[R] : z ? [
                                                    (z[R] - O) / (D - O),
                                                    0
                                                ] : [
                                                    (j[2] - O) / (D - O),
                                                    0
                                                ], m.push(X[0], X[1]), g.push(R);
                                                q += 1;
                                                break;
                                            case 3:
                                                for(U = 0; U < 3; ++U)for(j = n[W = G[U]], Z = 0; Z < 3; ++Z)if (isNaN(j[Z]) || !isFinite(j[Z])) continue t;
                                                for(U = 0; U < 3; ++U){
                                                    var W, Y, X, $;
                                                    j = n[W = G[2 - U]], i.push(j[0], j[1], j[2]), (Y = S ? S[W] : E ? E[R] : C) ? this.opacityscale && I ? a.push(Y[0], Y[1], Y[2], this.opacity * A((I[W] - O) / (D - O), this.opacityscale)) : 3 === Y.length ? a.push(Y[0], Y[1], Y[2], this.opacity) : (a.push(Y[0], Y[1], Y[2], Y[3] * this.opacity), Y[3] < 1 && (this.hasAlpha = !0)) : a.push(.5, .5, .5, 1), X = L ? L[W] : I ? [
                                                        (I[W] - O) / (D - O),
                                                        0
                                                    ] : P ? P[R] : z ? [
                                                        (z[R] - O) / (D - O),
                                                        0
                                                    ] : [
                                                        (j[2] - O) / (D - O),
                                                        0
                                                    ], c.push(X[0], X[1]), $ = w ? w[W] : T[R], l.push($[0], $[1], $[2]), f.push(R);
                                                }
                                                V += 1;
                                        }
                                    }
                                    this.pointCount = H, this.edgeCount = q, this.triangleCount = V, this.pointPositions.update(y), this.pointColors.update(v), this.pointUVs.update(x), this.pointSizes.update(_), this.pointIds.update(new Uint32Array(b)), this.edgePositions.update(p), this.edgeColors.update(d), this.edgeUVs.update(m), this.edgeIds.update(new Uint32Array(g)), this.trianglePositions.update(i), this.triangleColors.update(a), this.triangleUVs.update(c), this.triangleNormals.update(l), this.triangleIds.update(new Uint32Array(f));
                                }
                            }, k.drawTransparent = k.draw = function(t1) {
                                t1 = t1 || {};
                                for(var e1 = this.gl, r = t1.model || w, n = t1.view || w, i = t1.projection || w, a = [
                                    [
                                        -1000000,
                                        -1000000,
                                        -1000000
                                    ],
                                    [
                                        1e6,
                                        1e6,
                                        1e6
                                    ]
                                ], o = 0; o < 3; ++o)a[0][o] = Math.max(a[0][o], this.clipBounds[0][o]), a[1][o] = Math.min(a[1][o], this.clipBounds[1][o]);
                                var s = {
                                    model: r,
                                    view: n,
                                    projection: i,
                                    inverseModel: w.slice(),
                                    clipBounds: a,
                                    kambient: this.ambientLight,
                                    kdiffuse: this.diffuseLight,
                                    kspecular: this.specularLight,
                                    roughness: this.roughness,
                                    fresnel: this.fresnel,
                                    eyePosition: [
                                        0,
                                        0,
                                        0
                                    ],
                                    lightPosition: [
                                        0,
                                        0,
                                        0
                                    ],
                                    contourColor: this.contourColor,
                                    texture: 0
                                };
                                s.inverseModel = c(s.inverseModel, s.model), e1.disable(e1.CULL_FACE), this.texture.bind(0);
                                var u = new Array(16);
                                for(l(u, s.view, s.model), l(u, s.projection, u), c(u, u), o = 0; o < 3; ++o)s.eyePosition[o] = u[12 + o] / u[15];
                                var h, f = u[15];
                                for(o = 0; o < 3; ++o)f += this.lightPosition[o] * u[4 * o + 3];
                                for(o = 0; o < 3; ++o){
                                    for(var p = u[12 + o], d = 0; d < 3; ++d)p += u[4 * d + o] * this.lightPosition[d];
                                    s.lightPosition[o] = p / f;
                                }
                                this.triangleCount > 0 && ((h = this.triShader).bind(), h.uniforms = s, this.triangleVAO.bind(), e1.drawArrays(e1.TRIANGLES, 0, 3 * this.triangleCount), this.triangleVAO.unbind()), this.edgeCount > 0 && this.lineWidth > 0 && ((h = this.lineShader).bind(), h.uniforms = s, this.edgeVAO.bind(), e1.lineWidth(this.lineWidth * this.pixelRatio), e1.drawArrays(e1.LINES, 0, 2 * this.edgeCount), this.edgeVAO.unbind()), this.pointCount > 0 && ((h = this.pointShader).bind(), h.uniforms = s, this.pointVAO.bind(), e1.drawArrays(e1.POINTS, 0, this.pointCount), this.pointVAO.unbind()), this.contourEnable && this.contourCount > 0 && this.contourLineWidth > 0 && ((h = this.contourShader).bind(), h.uniforms = s, this.contourVAO.bind(), e1.drawArrays(e1.LINES, 0, this.contourCount), this.contourVAO.unbind());
                            }, k.drawPick = function(t1) {
                                t1 = t1 || {};
                                for(var e1 = this.gl, r = t1.model || w, n = t1.view || w, i = t1.projection || w, a = [
                                    [
                                        -1000000,
                                        -1000000,
                                        -1000000
                                    ],
                                    [
                                        1e6,
                                        1e6,
                                        1e6
                                    ]
                                ], o = 0; o < 3; ++o)a[0][o] = Math.max(a[0][o], this.clipBounds[0][o]), a[1][o] = Math.min(a[1][o], this.clipBounds[1][o]);
                                this._model = [].slice.call(r), this._view = [].slice.call(n), this._projection = [].slice.call(i), this._resolution = [
                                    e1.drawingBufferWidth,
                                    e1.drawingBufferHeight
                                ];
                                var s, l = {
                                    model: r,
                                    view: n,
                                    projection: i,
                                    clipBounds: a,
                                    pickId: this.pickId / 255
                                };
                                (s = this.pickShader).bind(), s.uniforms = l, this.triangleCount > 0 && (this.triangleVAO.bind(), e1.drawArrays(e1.TRIANGLES, 0, 3 * this.triangleCount), this.triangleVAO.unbind()), this.edgeCount > 0 && (this.edgeVAO.bind(), e1.lineWidth(this.lineWidth * this.pixelRatio), e1.drawArrays(e1.LINES, 0, 2 * this.edgeCount), this.edgeVAO.unbind()), this.pointCount > 0 && ((s = this.pointPickShader).bind(), s.uniforms = l, this.pointVAO.bind(), e1.drawArrays(e1.POINTS, 0, this.pointCount), this.pointVAO.unbind());
                            }, k.pick = function(t1) {
                                if (!t1) return null;
                                if (t1.id !== this.pickId) return null;
                                for(var e1 = t1.value[0] + 256 * t1.value[1] + 65536 * t1.value[2], r = this.cells[e1], n = this.positions, i = new Array(r.length), a = 0; a < r.length; ++a)i[a] = n[r[a]];
                                var o = t1.coord[0], s = t1.coord[1];
                                if (!this.pickVertex) {
                                    var l = this.positions[r[0]], c = this.positions[r[1]], u = this.positions[r[2]], h = [
                                        (l[0] + c[0] + u[0]) / 3,
                                        (l[1] + c[1] + u[1]) / 3,
                                        (l[2] + c[2] + u[2]) / 3
                                    ];
                                    return {
                                        _cellCenter: !0,
                                        position: [
                                            o,
                                            s
                                        ],
                                        index: e1,
                                        cell: r,
                                        cellId: e1,
                                        intensity: this.intensity[e1],
                                        dataCoordinate: h
                                    };
                                }
                                var f = m(i, [
                                    o * this.pixelRatio,
                                    this._resolution[1] - s * this.pixelRatio
                                ], this._model, this._view, this._projection, this._resolution);
                                if (!f) return null;
                                var p = f[2], d = 0;
                                for(a = 0; a < r.length; ++a)d += p[a] * this.intensity[r[a]];
                                return {
                                    position: f[1],
                                    index: r[f[0]],
                                    cell: r,
                                    cellId: e1,
                                    intensity: d,
                                    dataCoordinate: this.positions[r[f[0]]]
                                };
                            }, k.dispose = function() {
                                this.texture.dispose(), this.triShader.dispose(), this.lineShader.dispose(), this.pointShader.dispose(), this.pickShader.dispose(), this.pointPickShader.dispose(), this.triangleVAO.dispose(), this.trianglePositions.dispose(), this.triangleColors.dispose(), this.triangleUVs.dispose(), this.triangleNormals.dispose(), this.triangleIds.dispose(), this.edgeVAO.dispose(), this.edgePositions.dispose(), this.edgeColors.dispose(), this.edgeUVs.dispose(), this.edgeIds.dispose(), this.pointVAO.dispose(), this.pointPositions.dispose(), this.pointColors.dispose(), this.pointUVs.dispose(), this.pointSizes.dispose(), this.pointIds.dispose(), this.contourVAO.dispose(), this.contourPositions.dispose(), this.contourShader.dispose();
                            }, t1.exports = function(t1, e1) {
                                if (1 === arguments.length && (t1 = (e1 = t1).gl), !(t1.getExtension("OES_standard_derivatives") || t1.getExtension("MOZ_OES_standard_derivatives") || t1.getExtension("WEBKIT_OES_standard_derivatives"))) throw new Error("derivatives not supported");
                                var r = function(t1) {
                                    var e1 = n(t1, g.vertex, g.fragment);
                                    return e1.attributes.position.location = 0, e1.attributes.color.location = 2, e1.attributes.uv.location = 3, e1.attributes.normal.location = 4, e1;
                                }(t1), s = function(t1) {
                                    var e1 = n(t1, y.vertex, y.fragment);
                                    return e1.attributes.position.location = 0, e1.attributes.color.location = 2, e1.attributes.uv.location = 3, e1;
                                }(t1), l = M(t1), c = S(t1), h = E(t1), f = C(t1), p = o(t1, u(new Uint8Array([
                                    255,
                                    255,
                                    255,
                                    255
                                ]), [
                                    1,
                                    1,
                                    4
                                ]));
                                p.generateMipmap(), p.minFilter = t1.LINEAR_MIPMAP_LINEAR, p.magFilter = t1.LINEAR;
                                var d = i(t1), m = i(t1), v = i(t1), x = i(t1), _ = i(t1), b = a(t1, [
                                    {
                                        buffer: d,
                                        type: t1.FLOAT,
                                        size: 3
                                    },
                                    {
                                        buffer: _,
                                        type: t1.UNSIGNED_BYTE,
                                        size: 4,
                                        normalized: !0
                                    },
                                    {
                                        buffer: m,
                                        type: t1.FLOAT,
                                        size: 4
                                    },
                                    {
                                        buffer: v,
                                        type: t1.FLOAT,
                                        size: 2
                                    },
                                    {
                                        buffer: x,
                                        type: t1.FLOAT,
                                        size: 3
                                    }
                                ]), w = i(t1), k = i(t1), A = i(t1), L = i(t1), I = a(t1, [
                                    {
                                        buffer: w,
                                        type: t1.FLOAT,
                                        size: 3
                                    },
                                    {
                                        buffer: L,
                                        type: t1.UNSIGNED_BYTE,
                                        size: 4,
                                        normalized: !0
                                    },
                                    {
                                        buffer: k,
                                        type: t1.FLOAT,
                                        size: 4
                                    },
                                    {
                                        buffer: A,
                                        type: t1.FLOAT,
                                        size: 2
                                    }
                                ]), P = i(t1), z = i(t1), O = i(t1), D = i(t1), R = i(t1), F = a(t1, [
                                    {
                                        buffer: P,
                                        type: t1.FLOAT,
                                        size: 3
                                    },
                                    {
                                        buffer: R,
                                        type: t1.UNSIGNED_BYTE,
                                        size: 4,
                                        normalized: !0
                                    },
                                    {
                                        buffer: z,
                                        type: t1.FLOAT,
                                        size: 4
                                    },
                                    {
                                        buffer: O,
                                        type: t1.FLOAT,
                                        size: 2
                                    },
                                    {
                                        buffer: D,
                                        type: t1.FLOAT,
                                        size: 1
                                    }
                                ]), B = i(t1), N = new T(t1, p, r, s, l, c, h, f, d, _, m, v, x, b, w, L, k, A, I, P, R, z, O, D, F, B, a(t1, [
                                    {
                                        buffer: B,
                                        type: t1.FLOAT,
                                        size: 3
                                    }
                                ]));
                                return N.update(e1), N;
                            };
                        },
                        8120: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1) {
                                var e1 = t1.gl;
                                return new o(t1, n(e1, [
                                    0,
                                    0,
                                    0,
                                    1,
                                    1,
                                    0,
                                    1,
                                    1
                                ]), i(e1, a.boxVert, a.lineFrag));
                            };
                            var n = r(2762), i = r(9405), a = r(3603);
                            function o(t1, e1, r) {
                                this.plot = t1, this.vbo = e1, this.shader = r;
                            }
                            var s, l, c = o.prototype;
                            c.bind = function() {
                                var t1 = this.shader;
                                this.vbo.bind(), this.shader.bind(), t1.attributes.coord.pointer(), t1.uniforms.screenBox = this.plot.screenBox;
                            }, c.drawBox = (s = [
                                0,
                                0
                            ], l = [
                                0,
                                0
                            ], function(t1, e1, r, n, i) {
                                var a = this.plot, o = this.shader, c = a.gl;
                                s[0] = t1, s[1] = e1, l[0] = r, l[1] = n, o.uniforms.lo = s, o.uniforms.hi = l, o.uniforms.color = i, c.drawArrays(c.TRIANGLE_STRIP, 0, 4);
                            }), c.dispose = function() {
                                this.vbo.dispose(), this.shader.dispose();
                            };
                        },
                        1913: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1) {
                                var e1 = t1.gl;
                                return new s(t1, n(e1), i(e1, o.gridVert, o.gridFrag), i(e1, o.tickVert, o.gridFrag));
                            };
                            var n = r(2762), i = r(9405), a = r(2478), o = r(3603);
                            function s(t1, e1, r, n) {
                                this.plot = t1, this.vbo = e1, this.shader = r, this.tickShader = n, this.ticks = [
                                    [],
                                    []
                                ];
                            }
                            function l(t1, e1) {
                                return t1 - e1;
                            }
                            var c, u, h, f, p, d = s.prototype;
                            d.draw = (c = [
                                0,
                                0
                            ], u = [
                                0,
                                0
                            ], h = [
                                0,
                                0
                            ], function() {
                                for(var t1 = this.plot, e1 = this.vbo, r = this.shader, n = this.ticks, i = t1.gl, a = t1._tickBounds, o = t1.dataBox, s = t1.viewBox, l = t1.gridLineWidth, f = t1.gridLineColor, p = t1.gridLineEnable, d = t1.pixelRatio, m = 0; m < 2; ++m){
                                    var g = a[m], y = a[m + 2] - g, v = .5 * (o[m + 2] + o[m]), x = o[m + 2] - o[m];
                                    u[m] = 2 * y / x, c[m] = 2 * (g - v) / x;
                                }
                                r.bind(), e1.bind(), r.attributes.dataCoord.pointer(), r.uniforms.dataShift = c, r.uniforms.dataScale = u;
                                var _ = 0;
                                for(m = 0; m < 2; ++m){
                                    h[0] = h[1] = 0, h[m] = 1, r.uniforms.dataAxis = h, r.uniforms.lineWidth = l[m] / (s[m + 2] - s[m]) * d, r.uniforms.color = f[m];
                                    var b = 6 * n[m].length;
                                    p[m] && b && i.drawArrays(i.TRIANGLES, _, b), _ += b;
                                }
                            }), d.drawTickMarks = function() {
                                var t1 = [
                                    0,
                                    0
                                ], e1 = [
                                    0,
                                    0
                                ], r = [
                                    1,
                                    0
                                ], n = [
                                    0,
                                    1
                                ], i = [
                                    0,
                                    0
                                ], o = [
                                    0,
                                    0
                                ];
                                return function() {
                                    for(var s = this.plot, c = this.vbo, u = this.tickShader, h = this.ticks, f = s.gl, p = s._tickBounds, d = s.dataBox, m = s.viewBox, g = s.pixelRatio, y = s.screenBox, v = y[2] - y[0], x = y[3] - y[1], _ = m[2] - m[0], b = m[3] - m[1], w = 0; w < 2; ++w){
                                        var T = p[w], k = p[w + 2] - T, A = .5 * (d[w + 2] + d[w]), M = d[w + 2] - d[w];
                                        e1[w] = 2 * k / M, t1[w] = 2 * (T - A) / M;
                                    }
                                    e1[0] *= _ / v, t1[0] *= _ / v, e1[1] *= b / x, t1[1] *= b / x, u.bind(), c.bind(), u.attributes.dataCoord.pointer();
                                    var S = u.uniforms;
                                    S.dataShift = t1, S.dataScale = e1;
                                    var E = s.tickMarkLength, C = s.tickMarkWidth, L = s.tickMarkColor, I = 6 * h[0].length, P = Math.min(a.ge(h[0], (d[0] - p[0]) / (p[2] - p[0]), l), h[0].length), z = Math.min(a.gt(h[0], (d[2] - p[0]) / (p[2] - p[0]), l), h[0].length), O = 0 + 6 * P, D = 6 * Math.max(0, z - P), R = Math.min(a.ge(h[1], (d[1] - p[1]) / (p[3] - p[1]), l), h[1].length), F = Math.min(a.gt(h[1], (d[3] - p[1]) / (p[3] - p[1]), l), h[1].length), B = I + 6 * R, N = 6 * Math.max(0, F - R);
                                    i[0] = 2 * (m[0] - E[1]) / v - 1, i[1] = (m[3] + m[1]) / x - 1, o[0] = E[1] * g / v, o[1] = C[1] * g / x, N && (S.color = L[1], S.tickScale = o, S.dataAxis = n, S.screenOffset = i, f.drawArrays(f.TRIANGLES, B, N)), i[0] = (m[2] + m[0]) / v - 1, i[1] = 2 * (m[1] - E[0]) / x - 1, o[0] = C[0] * g / v, o[1] = E[0] * g / x, D && (S.color = L[0], S.tickScale = o, S.dataAxis = r, S.screenOffset = i, f.drawArrays(f.TRIANGLES, O, D)), i[0] = 2 * (m[2] + E[3]) / v - 1, i[1] = (m[3] + m[1]) / x - 1, o[0] = E[3] * g / v, o[1] = C[3] * g / x, N && (S.color = L[3], S.tickScale = o, S.dataAxis = n, S.screenOffset = i, f.drawArrays(f.TRIANGLES, B, N)), i[0] = (m[2] + m[0]) / v - 1, i[1] = 2 * (m[3] + E[2]) / x - 1, o[0] = C[2] * g / v, o[1] = E[2] * g / x, D && (S.color = L[2], S.tickScale = o, S.dataAxis = r, S.screenOffset = i, f.drawArrays(f.TRIANGLES, O, D));
                                };
                            }(), d.update = (f = [
                                1,
                                1,
                                -1,
                                -1,
                                1,
                                -1
                            ], p = [
                                1,
                                -1,
                                1,
                                1,
                                -1,
                                -1
                            ], function(t1) {
                                for(var e1 = t1.ticks, r = t1.bounds, n = new Float32Array(18 * (e1[0].length + e1[1].length)), i = (this.plot.zeroLineEnable, 0), a = [
                                    [],
                                    []
                                ], o = 0; o < 2; ++o)for(var s = a[o], l = e1[o], c = r[o], u = r[o + 2], h = 0; h < l.length; ++h){
                                    var d = (l[h].x - c) / (u - c);
                                    s.push(d);
                                    for(var m = 0; m < 6; ++m)n[i++] = d, n[i++] = f[m], n[i++] = p[m];
                                }
                                this.ticks = a, this.vbo.update(n);
                            }), d.dispose = function() {
                                this.vbo.dispose(), this.shader.dispose(), this.tickShader.dispose();
                            };
                        },
                        4747: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1) {
                                var e1 = t1.gl;
                                return new o(t1, n(e1, [
                                    -1,
                                    -1,
                                    -1,
                                    1,
                                    1,
                                    -1,
                                    1,
                                    1
                                ]), i(e1, a.lineVert, a.lineFrag));
                            };
                            var n = r(2762), i = r(9405), a = r(3603);
                            function o(t1, e1, r) {
                                this.plot = t1, this.vbo = e1, this.shader = r;
                            }
                            var s, l, c = o.prototype;
                            c.bind = function() {
                                var t1 = this.shader;
                                this.vbo.bind(), this.shader.bind(), t1.attributes.coord.pointer(), t1.uniforms.screenBox = this.plot.screenBox;
                            }, c.drawLine = (s = [
                                0,
                                0
                            ], l = [
                                0,
                                0
                            ], function(t1, e1, r, n, i, a) {
                                var o = this.plot, c = this.shader, u = o.gl;
                                s[0] = t1, s[1] = e1, l[0] = r, l[1] = n, c.uniforms.start = s, c.uniforms.end = l, c.uniforms.width = i * o.pixelRatio, c.uniforms.color = a, u.drawArrays(u.TRIANGLE_STRIP, 0, 4);
                            }), c.dispose = function() {
                                this.vbo.dispose(), this.shader.dispose();
                            };
                        },
                        3603: function(t1, e1, r) {
                            "use strict";
                            var n = r(3236), i = n([
                                "precision lowp float;\n#define GLSLIFY 1\nuniform vec4 color;\nvoid main() {\n  gl_FragColor = vec4(color.xyz * color.w, color.w);\n}\n"
                            ]);
                            t1.exports = {
                                lineVert: n([
                                    "precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 coord;\n\nuniform vec4 screenBox;\nuniform vec2 start, end;\nuniform float width;\n\nvec2 perp(vec2 v) {\n  return vec2(v.y, -v.x);\n}\n\nvec2 screen(vec2 v) {\n  return 2.0 * (v - screenBox.xy) / (screenBox.zw - screenBox.xy) - 1.0;\n}\n\nvoid main() {\n  vec2 delta = normalize(perp(start - end));\n  vec2 offset = mix(start, end, 0.5 * (coord.y+1.0));\n  gl_Position = vec4(screen(offset + 0.5 * width * delta * coord.x), 0, 1);\n}\n"
                                ]),
                                lineFrag: i,
                                textVert: n([
                                    "#define GLSLIFY 1\nattribute vec3 textCoordinate;\n\nuniform vec2 dataScale, dataShift, dataAxis, screenOffset, textScale;\nuniform float angle;\n\nvoid main() {\n  float dataOffset  = textCoordinate.z;\n  vec2 glyphOffset  = textCoordinate.xy;\n  mat2 glyphMatrix = mat2(cos(angle), sin(angle), -sin(angle), cos(angle));\n  vec2 screenCoordinate = dataAxis * (dataScale * dataOffset + dataShift) +\n    glyphMatrix * glyphOffset * textScale + screenOffset;\n  gl_Position = vec4(screenCoordinate, 0, 1);\n}\n"
                                ]),
                                textFrag: i,
                                gridVert: n([
                                    "precision mediump float;\n#define GLSLIFY 1\n\nattribute vec3 dataCoord;\n\nuniform vec2 dataAxis, dataShift, dataScale;\nuniform float lineWidth;\n\nvoid main() {\n  vec2 pos = dataAxis * (dataScale * dataCoord.x + dataShift);\n  pos += 10.0 * dataCoord.y * vec2(dataAxis.y, -dataAxis.x) + dataCoord.z * lineWidth;\n  gl_Position = vec4(pos, 0, 1);\n}\n"
                                ]),
                                gridFrag: i,
                                boxVert: n([
                                    "precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 coord;\n\nuniform vec4 screenBox;\nuniform vec2 lo, hi;\n\nvec2 screen(vec2 v) {\n  return 2.0 * (v - screenBox.xy) / (screenBox.zw - screenBox.xy) - 1.0;\n}\n\nvoid main() {\n  gl_Position = vec4(screen(mix(lo, hi, coord)), 0, 1);\n}\n"
                                ]),
                                tickVert: n([
                                    "precision mediump float;\n#define GLSLIFY 1\n\nattribute vec3 dataCoord;\n\nuniform vec2 dataAxis, dataShift, dataScale, screenOffset, tickScale;\n\nvoid main() {\n  vec2 pos = dataAxis * (dataScale * dataCoord.x + dataShift);\n  gl_Position = vec4(pos + tickScale*dataCoord.yz + screenOffset, 0, 1);\n}\n"
                                ])
                            };
                        },
                        2142: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1) {
                                var e1 = t1.gl;
                                return new l(t1, n(e1), i(e1, s.textVert, s.textFrag));
                            };
                            var n = r(2762), i = r(9405), a = r(529), o = r(2478), s = r(3603);
                            function l(t1, e1, r) {
                                this.plot = t1, this.vbo = e1, this.shader = r, this.tickOffset = [
                                    [],
                                    []
                                ], this.tickX = [
                                    [],
                                    []
                                ], this.labelOffset = [
                                    0,
                                    0
                                ], this.labelCount = [
                                    0,
                                    0
                                ];
                            }
                            var c, u, h, f, p, d, m = l.prototype;
                            m.drawTicks = (c = [
                                0,
                                0
                            ], u = [
                                0,
                                0
                            ], h = [
                                0,
                                0
                            ], function(t1) {
                                var e1 = this.plot, r = this.shader, n = this.tickX[t1], i = this.tickOffset[t1], a = e1.gl, s = e1.viewBox, l = e1.dataBox, f = e1.screenBox, p = e1.pixelRatio, d = e1.tickEnable, m = e1.tickPad, g = e1.tickColor, y = e1.tickAngle, v = e1.labelEnable, x = e1.labelPad, _ = e1.labelColor, b = e1.labelAngle, w = this.labelOffset[t1], T = this.labelCount[t1], k = o.lt(n, l[t1]), A = o.le(n, l[t1 + 2]);
                                c[0] = c[1] = 0, c[t1] = 1, u[t1] = (s[2 + t1] + s[t1]) / (f[2 + t1] - f[t1]) - 1;
                                var M = 2 / f[2 + (1 ^ t1)] - f[1 ^ t1];
                                u[1 ^ t1] = M * s[1 ^ t1] - 1, d[t1] && (u[1 ^ t1] -= M * p * m[t1], k < A && i[A] > i[k] && (r.uniforms.dataAxis = c, r.uniforms.screenOffset = u, r.uniforms.color = g[t1], r.uniforms.angle = y[t1], a.drawArrays(a.TRIANGLES, i[k], i[A] - i[k]))), v[t1] && T && (u[1 ^ t1] -= M * p * x[t1], r.uniforms.dataAxis = h, r.uniforms.screenOffset = u, r.uniforms.color = _[t1], r.uniforms.angle = b[t1], a.drawArrays(a.TRIANGLES, w, T)), u[1 ^ t1] = M * s[2 + (1 ^ t1)] - 1, d[t1 + 2] && (u[1 ^ t1] += M * p * m[t1 + 2], k < A && i[A] > i[k] && (r.uniforms.dataAxis = c, r.uniforms.screenOffset = u, r.uniforms.color = g[t1 + 2], r.uniforms.angle = y[t1 + 2], a.drawArrays(a.TRIANGLES, i[k], i[A] - i[k]))), v[t1 + 2] && T && (u[1 ^ t1] += M * p * x[t1 + 2], r.uniforms.dataAxis = h, r.uniforms.screenOffset = u, r.uniforms.color = _[t1 + 2], r.uniforms.angle = b[t1 + 2], a.drawArrays(a.TRIANGLES, w, T));
                            }), m.drawTitle = function() {
                                var t1 = [
                                    0,
                                    0
                                ], e1 = [
                                    0,
                                    0
                                ];
                                return function() {
                                    var r = this.plot, n = this.shader, i = r.gl, a = r.screenBox, o = r.titleCenter, s = r.titleAngle, l = r.titleColor, c = r.pixelRatio;
                                    if (this.titleCount) {
                                        for(var u = 0; u < 2; ++u)e1[u] = 2 * (o[u] * c - a[u]) / (a[2 + u] - a[u]) - 1;
                                        n.bind(), n.uniforms.dataAxis = t1, n.uniforms.screenOffset = e1, n.uniforms.angle = s, n.uniforms.color = l, i.drawArrays(i.TRIANGLES, this.titleOffset, this.titleCount);
                                    }
                                };
                            }(), m.bind = (f = [
                                0,
                                0
                            ], p = [
                                0,
                                0
                            ], d = [
                                0,
                                0
                            ], function() {
                                var t1 = this.plot, e1 = this.shader, r = t1._tickBounds, n = t1.dataBox, i = t1.screenBox, a = t1.viewBox;
                                e1.bind();
                                for(var o = 0; o < 2; ++o){
                                    var s = r[o], l = r[o + 2] - s, c = .5 * (n[o + 2] + n[o]), u = n[o + 2] - n[o], h = a[o], m = a[o + 2] - h, g = i[o], y = i[o + 2] - g;
                                    p[o] = 2 * l / u * m / y, f[o] = 2 * (s - c) / u * m / y;
                                }
                                d[1] = 2 * t1.pixelRatio / (i[3] - i[1]), d[0] = d[1] * (i[3] - i[1]) / (i[2] - i[0]), e1.uniforms.dataScale = p, e1.uniforms.dataShift = f, e1.uniforms.textScale = d, this.vbo.bind(), e1.attributes.textCoordinate.pointer();
                            }), m.update = function(t1) {
                                var e1, r, n, i, o, s = [], l = t1.ticks, c = t1.bounds;
                                for(o = 0; o < 2; ++o){
                                    var u = [
                                        Math.floor(s.length / 3)
                                    ], h = [
                                        -1 / 0
                                    ], f = l[o];
                                    for(e1 = 0; e1 < f.length; ++e1){
                                        var p = f[e1], d = p.x, m = p.text, g = p.font || "sans-serif", y = p.fontStyle || "normal", v = p.fontWeight || "normal", x = p.fontVariant || "normal";
                                        i = p.fontSize || 12;
                                        for(var _ = 1 / (c[o + 2] - c[o]), b = c[o], w = m.split("\n"), T = 0; T < w.length; T++)for(n = a(g, w[T], {
                                            fontStyle: y,
                                            fontWeight: v,
                                            fontVariant: x
                                        }).data, r = 0; r < n.length; r += 2)s.push(n[r] * i, -n[r + 1] * i - T * i * 1.2, (d - b) * _);
                                        u.push(Math.floor(s.length / 3)), h.push(d);
                                    }
                                    this.tickOffset[o] = u, this.tickX[o] = h;
                                }
                                for(o = 0; o < 2; ++o){
                                    for(this.labelOffset[o] = Math.floor(s.length / 3), n = a(t1.labelFont[o], t1.labels[o], {
                                        fontStyle: t1.labelFontStyle[o],
                                        fontWeight: t1.labelFontWeight[o],
                                        fontVariant: t1.labelFontVariant[o],
                                        textAlign: "center"
                                    }).data, i = t1.labelSize[o], e1 = 0; e1 < n.length; e1 += 2)s.push(n[e1] * i, -n[e1 + 1] * i, 0);
                                    this.labelCount[o] = Math.floor(s.length / 3) - this.labelOffset[o];
                                }
                                for(this.titleOffset = Math.floor(s.length / 3), n = a(t1.titleFont, t1.title, {
                                    fontStyle: t1.titleFontStyle,
                                    fontWeight: t1.titleFontWeight,
                                    fontVariant: t1.titleFontVariant
                                }).data, i = t1.titleSize, e1 = 0; e1 < n.length; e1 += 2)s.push(n[e1] * i, -n[e1 + 1] * i, 0);
                                this.titleCount = Math.floor(s.length / 3) - this.titleOffset, this.vbo.update(s);
                            }, m.dispose = function() {
                                this.vbo.dispose(), this.shader.dispose();
                            };
                        },
                        1850: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1) {
                                var e1 = t1.gl, r = new l(e1, n(e1, [
                                    e1.drawingBufferWidth,
                                    e1.drawingBufferHeight
                                ]));
                                return r.grid = i(r), r.text = a(r), r.line = o(r), r.box = s(r), r.update(t1), r;
                            };
                            var n = r(3589), i = r(1913), a = r(2142), o = r(4747), s = r(8120);
                            function l(t1, e1) {
                                this.gl = t1, this.pickBuffer = e1, this.screenBox = [
                                    0,
                                    0,
                                    t1.drawingBufferWidth,
                                    t1.drawingBufferHeight
                                ], this.viewBox = [
                                    0,
                                    0,
                                    0,
                                    0
                                ], this.dataBox = [
                                    -10,
                                    -10,
                                    10,
                                    10
                                ], this.gridLineEnable = [
                                    !0,
                                    !0
                                ], this.gridLineWidth = [
                                    1,
                                    1
                                ], this.gridLineColor = [
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ]
                                ], this.pixelRatio = 1, this.tickMarkLength = [
                                    0,
                                    0,
                                    0,
                                    0
                                ], this.tickMarkWidth = [
                                    0,
                                    0,
                                    0,
                                    0
                                ], this.tickMarkColor = [
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ]
                                ], this.tickPad = [
                                    15,
                                    15,
                                    15,
                                    15
                                ], this.tickAngle = [
                                    0,
                                    0,
                                    0,
                                    0
                                ], this.tickEnable = [
                                    !0,
                                    !0,
                                    !0,
                                    !0
                                ], this.tickColor = [
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ]
                                ], this.labelPad = [
                                    15,
                                    15,
                                    15,
                                    15
                                ], this.labelAngle = [
                                    0,
                                    Math.PI / 2,
                                    0,
                                    3 * Math.PI / 2
                                ], this.labelEnable = [
                                    !0,
                                    !0,
                                    !0,
                                    !0
                                ], this.labelColor = [
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ]
                                ], this.titleCenter = [
                                    0,
                                    0
                                ], this.titleEnable = !0, this.titleAngle = 0, this.titleColor = [
                                    0,
                                    0,
                                    0,
                                    1
                                ], this.borderColor = [
                                    0,
                                    0,
                                    0,
                                    0
                                ], this.backgroundColor = [
                                    0,
                                    0,
                                    0,
                                    0
                                ], this.zeroLineEnable = [
                                    !0,
                                    !0
                                ], this.zeroLineWidth = [
                                    4,
                                    4
                                ], this.zeroLineColor = [
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ]
                                ], this.borderLineEnable = [
                                    !0,
                                    !0,
                                    !0,
                                    !0
                                ], this.borderLineWidth = [
                                    2,
                                    2,
                                    2,
                                    2
                                ], this.borderLineColor = [
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ]
                                ], this.grid = null, this.text = null, this.line = null, this.box = null, this.objects = [], this.overlays = [], this._tickBounds = [
                                    1 / 0,
                                    1 / 0,
                                    -1 / 0,
                                    -1 / 0
                                ], this.static = !1, this.dirty = !1, this.pickDirty = !1, this.pickDelay = 120, this.pickRadius = 10, this._pickTimeout = null, this._drawPick = this.drawPick.bind(this), this._depthCounter = 0;
                            }
                            var c = l.prototype;
                            function u(t1) {
                                for(var e1 = t1.slice(), r = 0; r < e1.length; ++r)e1[r] = e1[r].slice();
                                return e1;
                            }
                            function h(t1, e1) {
                                return t1.x - e1.x;
                            }
                            c.setDirty = function() {
                                this.dirty = this.pickDirty = !0;
                            }, c.setOverlayDirty = function() {
                                this.dirty = !0;
                            }, c.nextDepthValue = function() {
                                return this._depthCounter++ / 65536;
                            }, c.draw = function() {
                                var t1 = this.gl, e1 = this.screenBox, r = this.viewBox, n = this.dataBox, i = this.pixelRatio, a = this.grid, o = this.line, s = this.text, l = this.objects;
                                if (this._depthCounter = 0, this.pickDirty && (this._pickTimeout && clearTimeout(this._pickTimeout), this.pickDirty = !1, this._pickTimeout = setTimeout(this._drawPick, this.pickDelay)), this.dirty) {
                                    if (this.dirty = !1, t1.bindFramebuffer(t1.FRAMEBUFFER, null), t1.enable(t1.SCISSOR_TEST), t1.disable(t1.DEPTH_TEST), t1.depthFunc(t1.LESS), t1.depthMask(!1), t1.enable(t1.BLEND), t1.blendEquation(t1.FUNC_ADD, t1.FUNC_ADD), t1.blendFunc(t1.ONE, t1.ONE_MINUS_SRC_ALPHA), this.borderColor) {
                                        t1.scissor(e1[0], e1[1], e1[2] - e1[0], e1[3] - e1[1]);
                                        var c = this.borderColor;
                                        t1.clearColor(c[0] * c[3], c[1] * c[3], c[2] * c[3], c[3]), t1.clear(t1.COLOR_BUFFER_BIT | t1.DEPTH_BUFFER_BIT);
                                    }
                                    t1.scissor(r[0], r[1], r[2] - r[0], r[3] - r[1]), t1.viewport(r[0], r[1], r[2] - r[0], r[3] - r[1]);
                                    var u = this.backgroundColor;
                                    t1.clearColor(u[0] * u[3], u[1] * u[3], u[2] * u[3], u[3]), t1.clear(t1.COLOR_BUFFER_BIT), a.draw();
                                    var h = this.zeroLineEnable, f = this.zeroLineColor, p = this.zeroLineWidth;
                                    if (h[0] || h[1]) {
                                        o.bind();
                                        for(var d = 0; d < 2; ++d)if (h[d] && n[d] <= 0 && n[d + 2] >= 0) {
                                            var m = e1[d] - n[d] * (e1[d + 2] - e1[d]) / (n[d + 2] - n[d]);
                                            0 === d ? o.drawLine(m, e1[1], m, e1[3], p[d], f[d]) : o.drawLine(e1[0], m, e1[2], m, p[d], f[d]);
                                        }
                                    }
                                    for(d = 0; d < l.length; ++d)l[d].draw();
                                    t1.viewport(e1[0], e1[1], e1[2] - e1[0], e1[3] - e1[1]), t1.scissor(e1[0], e1[1], e1[2] - e1[0], e1[3] - e1[1]), this.grid.drawTickMarks(), o.bind();
                                    var g = this.borderLineEnable, y = this.borderLineWidth, v = this.borderLineColor;
                                    for(g[1] && o.drawLine(r[0], r[1] - .5 * y[1] * i, r[0], r[3] + .5 * y[3] * i, y[1], v[1]), g[0] && o.drawLine(r[0] - .5 * y[0] * i, r[1], r[2] + .5 * y[2] * i, r[1], y[0], v[0]), g[3] && o.drawLine(r[2], r[1] - .5 * y[1] * i, r[2], r[3] + .5 * y[3] * i, y[3], v[3]), g[2] && o.drawLine(r[0] - .5 * y[0] * i, r[3], r[2] + .5 * y[2] * i, r[3], y[2], v[2]), s.bind(), d = 0; d < 2; ++d)s.drawTicks(d);
                                    this.titleEnable && s.drawTitle();
                                    var x = this.overlays;
                                    for(d = 0; d < x.length; ++d)x[d].draw();
                                    t1.disable(t1.SCISSOR_TEST), t1.disable(t1.BLEND), t1.depthMask(!0);
                                }
                            }, c.drawPick = function() {
                                if (!this.static) {
                                    var t1 = this.pickBuffer;
                                    this.gl, this._pickTimeout = null, t1.begin();
                                    for(var e1 = 1, r = this.objects, n = 0; n < r.length; ++n)e1 = r[n].drawPick(e1);
                                    t1.end();
                                }
                            }, c.pick = function(t1, e1) {
                                if (!this.static) {
                                    var r = this.pixelRatio, n = this.pickPixelRatio, i = this.viewBox, a = 0 | Math.round((t1 - i[0] / r) * n), o = 0 | Math.round((e1 - i[1] / r) * n), s = this.pickBuffer.query(a, o, this.pickRadius);
                                    if (!s) return null;
                                    for(var l = s.id + (s.value[0] << 8) + (s.value[1] << 16) + (s.value[2] << 24), c = this.objects, u = 0; u < c.length; ++u){
                                        var h = c[u].pick(a, o, l);
                                        if (h) return h;
                                    }
                                    return null;
                                }
                            }, c.setScreenBox = function(t1) {
                                var e1 = this.screenBox, r = this.pixelRatio;
                                e1[0] = 0 | Math.round(t1[0] * r), e1[1] = 0 | Math.round(t1[1] * r), e1[2] = 0 | Math.round(t1[2] * r), e1[3] = 0 | Math.round(t1[3] * r), this.setDirty();
                            }, c.setDataBox = function(t1) {
                                var e1 = this.dataBox;
                                (e1[0] !== t1[0] || e1[1] !== t1[1] || e1[2] !== t1[2] || e1[3] !== t1[3]) && (e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1[3] = t1[3], this.setDirty());
                            }, c.setViewBox = function(t1) {
                                var e1 = this.pixelRatio, r = this.viewBox;
                                r[0] = 0 | Math.round(t1[0] * e1), r[1] = 0 | Math.round(t1[1] * e1), r[2] = 0 | Math.round(t1[2] * e1), r[3] = 0 | Math.round(t1[3] * e1);
                                var n = this.pickPixelRatio;
                                this.pickBuffer.shape = [
                                    0 | Math.round((t1[2] - t1[0]) * n),
                                    0 | Math.round((t1[3] - t1[1]) * n)
                                ], this.setDirty();
                            }, c.update = function(t1) {
                                t1 = t1 || {};
                                var e1 = this.gl;
                                this.pixelRatio = t1.pixelRatio || 1;
                                var r = this.pixelRatio;
                                this.pickPixelRatio = Math.max(r, 1), this.setScreenBox(t1.screenBox || [
                                    0,
                                    0,
                                    e1.drawingBufferWidth / r,
                                    e1.drawingBufferHeight / r
                                ]), this.screenBox, this.setViewBox(t1.viewBox || [
                                    .125 * (this.screenBox[2] - this.screenBox[0]) / r,
                                    .125 * (this.screenBox[3] - this.screenBox[1]) / r,
                                    .875 * (this.screenBox[2] - this.screenBox[0]) / r,
                                    .875 * (this.screenBox[3] - this.screenBox[1]) / r
                                ]);
                                var n = this.viewBox, i = (n[2] - n[0]) / (n[3] - n[1]);
                                this.setDataBox(t1.dataBox || [
                                    -10,
                                    -10 / i,
                                    10,
                                    10 / i
                                ]), this.borderColor = !1 !== t1.borderColor && (t1.borderColor || [
                                    0,
                                    0,
                                    0,
                                    0
                                ]).slice(), this.backgroundColor = (t1.backgroundColor || [
                                    0,
                                    0,
                                    0,
                                    0
                                ]).slice(), this.gridLineEnable = (t1.gridLineEnable || [
                                    !0,
                                    !0
                                ]).slice(), this.gridLineWidth = (t1.gridLineWidth || [
                                    1,
                                    1
                                ]).slice(), this.gridLineColor = u(t1.gridLineColor || [
                                    [
                                        .5,
                                        .5,
                                        .5,
                                        1
                                    ],
                                    [
                                        .5,
                                        .5,
                                        .5,
                                        1
                                    ]
                                ]), this.zeroLineEnable = (t1.zeroLineEnable || [
                                    !0,
                                    !0
                                ]).slice(), this.zeroLineWidth = (t1.zeroLineWidth || [
                                    4,
                                    4
                                ]).slice(), this.zeroLineColor = u(t1.zeroLineColor || [
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ]
                                ]), this.tickMarkLength = (t1.tickMarkLength || [
                                    0,
                                    0,
                                    0,
                                    0
                                ]).slice(), this.tickMarkWidth = (t1.tickMarkWidth || [
                                    0,
                                    0,
                                    0,
                                    0
                                ]).slice(), this.tickMarkColor = u(t1.tickMarkColor || [
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ]
                                ]), this.titleCenter = (t1.titleCenter || [
                                    .5 * (n[0] + n[2]) / r,
                                    (n[3] + 120) / r
                                ]).slice(), this.titleEnable = !("titleEnable" in t1) || !!t1.titleEnable, this.titleAngle = t1.titleAngle || 0, this.titleColor = (t1.titleColor || [
                                    0,
                                    0,
                                    0,
                                    1
                                ]).slice(), this.labelPad = (t1.labelPad || [
                                    15,
                                    15,
                                    15,
                                    15
                                ]).slice(), this.labelAngle = (t1.labelAngle || [
                                    0,
                                    Math.PI / 2,
                                    0,
                                    3 * Math.PI / 2
                                ]).slice(), this.labelEnable = (t1.labelEnable || [
                                    !0,
                                    !0,
                                    !0,
                                    !0
                                ]).slice(), this.labelColor = u(t1.labelColor || [
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ]
                                ]), this.tickPad = (t1.tickPad || [
                                    15,
                                    15,
                                    15,
                                    15
                                ]).slice(), this.tickAngle = (t1.tickAngle || [
                                    0,
                                    0,
                                    0,
                                    0
                                ]).slice(), this.tickEnable = (t1.tickEnable || [
                                    !0,
                                    !0,
                                    !0,
                                    !0
                                ]).slice(), this.tickColor = u(t1.tickColor || [
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ]
                                ]), this.borderLineEnable = (t1.borderLineEnable || [
                                    !0,
                                    !0,
                                    !0,
                                    !0
                                ]).slice(), this.borderLineWidth = (t1.borderLineWidth || [
                                    2,
                                    2,
                                    2,
                                    2
                                ]).slice(), this.borderLineColor = u(t1.borderLineColor || [
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ]
                                ]);
                                var a = t1.ticks || [
                                    [],
                                    []
                                ], o = this._tickBounds;
                                o[0] = o[1] = 1 / 0, o[2] = o[3] = -1 / 0;
                                for(var s = 0; s < 2; ++s){
                                    var l = a[s].slice(0);
                                    0 !== l.length && (l.sort(h), o[s] = Math.min(o[s], l[0].x), o[s + 2] = Math.max(o[s + 2], l[l.length - 1].x));
                                }
                                this.grid.update({
                                    bounds: o,
                                    ticks: a
                                }), this.text.update({
                                    bounds: o,
                                    ticks: a,
                                    labels: t1.labels || [
                                        "x",
                                        "y"
                                    ],
                                    labelSize: t1.labelSize || [
                                        12,
                                        12
                                    ],
                                    labelFont: t1.labelFont || [
                                        "sans-serif",
                                        "sans-serif"
                                    ],
                                    labelFontStyle: t1.labelFontStyle || [
                                        "normal",
                                        "normal"
                                    ],
                                    labelFontWeight: t1.labelFontWeight || [
                                        "normal",
                                        "normal"
                                    ],
                                    labelFontVariant: t1.labelFontVariant || [
                                        "normal",
                                        "normal"
                                    ],
                                    title: t1.title || "",
                                    titleSize: t1.titleSize || 18,
                                    titleFont: t1.titleFont || "sans-serif",
                                    titleFontStyle: t1.titleFontStyle || "normal",
                                    titleFontWeight: t1.titleFontWeight || "normal",
                                    titleFontVariant: t1.titleFontVariant || "normal"
                                }), this.static = !!t1.static, this.setDirty();
                            }, c.dispose = function() {
                                this.box.dispose(), this.grid.dispose(), this.text.dispose(), this.line.dispose();
                                for(var t1 = this.objects.length - 1; t1 >= 0; --t1)this.objects[t1].dispose();
                                for(this.objects.length = 0, t1 = this.overlays.length - 1; t1 >= 0; --t1)this.overlays[t1].dispose();
                                this.overlays.length = 0, this.gl = null;
                            }, c.addObject = function(t1) {
                                this.objects.indexOf(t1) < 0 && (this.objects.push(t1), this.setDirty());
                            }, c.removeObject = function(t1) {
                                for(var e1 = this.objects, r = 0; r < e1.length; ++r)if (e1[r] === t1) {
                                    e1.splice(r, 1), this.setDirty();
                                    break;
                                }
                            }, c.addOverlay = function(t1) {
                                this.overlays.indexOf(t1) < 0 && (this.overlays.push(t1), this.setOverlayDirty());
                            }, c.removeOverlay = function(t1) {
                                for(var e1 = this.overlays, r = 0; r < e1.length; ++r)if (e1[r] === t1) {
                                    e1.splice(r, 1), this.setOverlayDirty();
                                    break;
                                }
                            };
                        },
                        4437: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1) {
                                t1 = t1 || document.body;
                                var r = [
                                    .01,
                                    1 / 0
                                ];
                                "distanceLimits" in (e1 = e1 || {}) && (r[0] = e1.distanceLimits[0], r[1] = e1.distanceLimits[1]), "zoomMin" in e1 && (r[0] = e1.zoomMin), "zoomMax" in e1 && (r[1] = e1.zoomMax);
                                var c = i({
                                    center: e1.center || [
                                        0,
                                        0,
                                        0
                                    ],
                                    up: e1.up || [
                                        0,
                                        1,
                                        0
                                    ],
                                    eye: e1.eye || [
                                        0,
                                        0,
                                        10
                                    ],
                                    mode: e1.mode || "orbit",
                                    distanceLimits: r
                                }), u = [
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0
                                ], h = 0, f = t1.clientWidth, p = t1.clientHeight, d = {
                                    keyBindingMode: "rotate",
                                    enableWheel: !0,
                                    view: c,
                                    element: t1,
                                    delay: e1.delay || 16,
                                    rotateSpeed: e1.rotateSpeed || 1,
                                    zoomSpeed: e1.zoomSpeed || 1,
                                    translateSpeed: e1.translateSpeed || 1,
                                    flipX: !!e1.flipX,
                                    flipY: !!e1.flipY,
                                    modes: c.modes,
                                    _ortho: e1._ortho || e1.projection && "orthographic" === e1.projection.type || !1,
                                    tick: function() {
                                        var e1 = n(), r = this.delay, i = e1 - 2 * r;
                                        c.idle(e1 - r), c.recalcMatrix(i), c.flush(e1 - (100 + 2 * r));
                                        for(var a = !0, o = c.computedMatrix, s = 0; s < 16; ++s)a = a && u[s] === o[s], u[s] = o[s];
                                        var l = t1.clientWidth === f && t1.clientHeight === p;
                                        return f = t1.clientWidth, p = t1.clientHeight, a ? !l : (h = Math.exp(c.computedRadius[0]), !0);
                                    },
                                    lookAt: function(t1, e1, r) {
                                        c.lookAt(c.lastT(), t1, e1, r);
                                    },
                                    rotate: function(t1, e1, r) {
                                        c.rotate(c.lastT(), t1, e1, r);
                                    },
                                    pan: function(t1, e1, r) {
                                        c.pan(c.lastT(), t1, e1, r);
                                    },
                                    translate: function(t1, e1, r) {
                                        c.translate(c.lastT(), t1, e1, r);
                                    }
                                };
                                return Object.defineProperties(d, {
                                    matrix: {
                                        get: function() {
                                            return c.computedMatrix;
                                        },
                                        set: function(t1) {
                                            return c.setMatrix(c.lastT(), t1), c.computedMatrix;
                                        },
                                        enumerable: !0
                                    },
                                    mode: {
                                        get: function() {
                                            return c.getMode();
                                        },
                                        set: function(t1) {
                                            var e1 = c.computedUp.slice(), r = c.computedEye.slice(), i = c.computedCenter.slice();
                                            if (c.setMode(t1), "turntable" === t1) {
                                                var a = n();
                                                c._active.lookAt(a, r, i, e1), c._active.lookAt(a + 500, r, i, [
                                                    0,
                                                    0,
                                                    1
                                                ]), c._active.flush(a);
                                            }
                                            return c.getMode();
                                        },
                                        enumerable: !0
                                    },
                                    center: {
                                        get: function() {
                                            return c.computedCenter;
                                        },
                                        set: function(t1) {
                                            return c.lookAt(c.lastT(), null, t1), c.computedCenter;
                                        },
                                        enumerable: !0
                                    },
                                    eye: {
                                        get: function() {
                                            return c.computedEye;
                                        },
                                        set: function(t1) {
                                            return c.lookAt(c.lastT(), t1), c.computedEye;
                                        },
                                        enumerable: !0
                                    },
                                    up: {
                                        get: function() {
                                            return c.computedUp;
                                        },
                                        set: function(t1) {
                                            return c.lookAt(c.lastT(), null, null, t1), c.computedUp;
                                        },
                                        enumerable: !0
                                    },
                                    distance: {
                                        get: function() {
                                            return h;
                                        },
                                        set: function(t1) {
                                            return c.setDistance(c.lastT(), t1), t1;
                                        },
                                        enumerable: !0
                                    },
                                    distanceLimits: {
                                        get: function() {
                                            return c.getDistanceLimits(r);
                                        },
                                        set: function(t1) {
                                            return c.setDistanceLimits(t1), t1;
                                        },
                                        enumerable: !0
                                    }
                                }), t1.addEventListener("contextmenu", function(t1) {
                                    return t1.preventDefault(), !1;
                                }), d._lastX = -1, d._lastY = -1, d._lastMods = {
                                    shift: !1,
                                    control: !1,
                                    alt: !1,
                                    meta: !1
                                }, d.enableMouseListeners = function() {
                                    function e1(e1, r, i, a) {
                                        var o = d.keyBindingMode;
                                        if (!1 !== o) {
                                            var s = "rotate" === o, l = "pan" === o, u = "zoom" === o, f = !!a.control, p = !!a.alt, m = !!a.shift, g = !!(1 & e1), y = !!(2 & e1), v = !!(4 & e1), x = 1 / t1.clientHeight, _ = x * (r - d._lastX), b = x * (i - d._lastY), w = d.flipX ? 1 : -1, T = d.flipY ? 1 : -1, k = Math.PI * d.rotateSpeed, A = n();
                                            if (-1 !== d._lastX && -1 !== d._lastY && ((s && g && !f && !p && !m || g && !f && !p && m) && c.rotate(A, w * k * _, -T * k * b, 0), (l && g && !f && !p && !m || y || g && f && !p && !m) && c.pan(A, -d.translateSpeed * _ * h, d.translateSpeed * b * h, 0), u && g && !f && !p && !m || v || g && !f && p && !m)) {
                                                var M = -d.zoomSpeed * b / window.innerHeight * (A - c.lastT()) * 100;
                                                c.pan(A, 0, 0, h * (Math.exp(M) - 1));
                                            }
                                            return d._lastX = r, d._lastY = i, d._lastMods = a, !0;
                                        }
                                    }
                                    d.mouseListener = a(t1, e1), t1.addEventListener("touchstart", function(r) {
                                        var n = s(r.changedTouches[0], t1);
                                        e1(0, n[0], n[1], d._lastMods), e1(1, n[0], n[1], d._lastMods);
                                    }, !!l && {
                                        passive: !0
                                    }), t1.addEventListener("touchmove", function(r) {
                                        var n = s(r.changedTouches[0], t1);
                                        e1(1, n[0], n[1], d._lastMods), r.preventDefault();
                                    }, !!l && {
                                        passive: !1
                                    }), t1.addEventListener("touchend", function(t1) {
                                        e1(0, d._lastX, d._lastY, d._lastMods);
                                    }, !!l && {
                                        passive: !0
                                    }), d.wheelListener = o(t1, function(t1, e1) {
                                        if (!1 !== d.keyBindingMode && d.enableWheel) {
                                            var r = d.flipX ? 1 : -1, i = d.flipY ? 1 : -1, a = n();
                                            if (Math.abs(t1) > Math.abs(e1)) c.rotate(a, 0, 0, -t1 * r * Math.PI * d.rotateSpeed / window.innerWidth);
                                            else if (!d._ortho) {
                                                var o = -d.zoomSpeed * i * e1 / window.innerHeight * (a - c.lastT()) / 20;
                                                c.pan(a, 0, 0, h * (Math.exp(o) - 1));
                                            }
                                        }
                                    }, !0);
                                }, d.enableMouseListeners(), d;
                            };
                            var n = r(3025), i = r(6296), a = r(351), o = r(8512), s = r(24), l = r(7520);
                        },
                        799: function(t1, e1, r) {
                            var n = r(3236), i = r(9405), a = n([
                                "precision mediump float;\n#define GLSLIFY 1\nattribute vec2 position;\nvarying vec2 uv;\nvoid main() {\n  uv = position;\n  gl_Position = vec4(position, 0, 1);\n}"
                            ]), o = n([
                                "precision mediump float;\n#define GLSLIFY 1\n\nuniform sampler2D accumBuffer;\nvarying vec2 uv;\n\nvoid main() {\n  vec4 accum = texture2D(accumBuffer, 0.5 * (uv + 1.0));\n  gl_FragColor = min(vec4(1,1,1,1), accum);\n}"
                            ]);
                            t1.exports = function(t1) {
                                return i(t1, a, o, null, [
                                    {
                                        name: "position",
                                        type: "vec2"
                                    }
                                ]);
                            };
                        },
                        4100: function(t1, e1, r) {
                            "use strict";
                            var n = r(4437), i = r(3837), a = r(5445), o = r(4449), s = r(3589), l = r(2260), c = r(7169), u = r(351), h = r(4772), f = r(4040), p = r(799), d = r(9216)({
                                tablet: !0,
                                featureDetect: !0
                            });
                            function m() {
                                this.mouse = [
                                    -1,
                                    -1
                                ], this.screen = null, this.distance = 1 / 0, this.index = null, this.dataCoordinate = null, this.dataPosition = null, this.object = null, this.data = null;
                            }
                            function g(t1) {
                                var e1 = Math.round(Math.log(Math.abs(t1)) / Math.log(10));
                                if (e1 < 0) {
                                    var r = Math.round(Math.pow(10, -e1));
                                    return Math.ceil(t1 * r) / r;
                                }
                                return e1 > 0 ? (r = Math.round(Math.pow(10, e1)), Math.ceil(t1 / r) * r) : Math.ceil(t1);
                            }
                            function y(t1) {
                                return "boolean" != typeof t1 || t1;
                            }
                            t1.exports = {
                                createScene: function(t1) {
                                    (t1 = t1 || {}).camera = t1.camera || {};
                                    var e1 = t1.canvas;
                                    e1 || (e1 = document.createElement("canvas"), t1.container ? t1.container.appendChild(e1) : document.body.appendChild(e1));
                                    var r = t1.gl;
                                    if (r || (t1.glOptions && (d = !!t1.glOptions.preserveDrawingBuffer), r = function(t1, e1) {
                                        var r = null;
                                        try {
                                            (r = t1.getContext("webgl", e1)) || (r = t1.getContext("experimental-webgl", e1));
                                        } catch (t1) {
                                            return null;
                                        }
                                        return r;
                                    }(e1, t1.glOptions || {
                                        premultipliedAlpha: !0,
                                        antialias: !0,
                                        preserveDrawingBuffer: d
                                    })), !r) throw new Error("webgl not supported");
                                    var v = t1.bounds || [
                                        [
                                            -10,
                                            -10,
                                            -10
                                        ],
                                        [
                                            10,
                                            10,
                                            10
                                        ]
                                    ], x = new m, _ = l(r, r.drawingBufferWidth, r.drawingBufferHeight, {
                                        preferFloat: !d
                                    }), b = p(r), w = t1.cameraObject && !0 === t1.cameraObject._ortho || t1.camera.projection && "orthographic" === t1.camera.projection.type || !1, T = {
                                        eye: t1.camera.eye || [
                                            2,
                                            0,
                                            0
                                        ],
                                        center: t1.camera.center || [
                                            0,
                                            0,
                                            0
                                        ],
                                        up: t1.camera.up || [
                                            0,
                                            1,
                                            0
                                        ],
                                        zoomMin: t1.camera.zoomMax || .1,
                                        zoomMax: t1.camera.zoomMin || 100,
                                        mode: t1.camera.mode || "turntable",
                                        _ortho: w
                                    }, k = t1.axes || {}, A = i(r, k);
                                    A.enable = !k.disable;
                                    var M = t1.spikes || {}, S = o(r, M), E = [], C = [], L = [], I = [], P = !0, z = !0, O = {
                                        view: null,
                                        projection: new Array(16),
                                        model: new Array(16),
                                        _ortho: !1
                                    }, D = (z = !0, [
                                        r.drawingBufferWidth,
                                        r.drawingBufferHeight
                                    ]), R = t1.cameraObject || n(e1, T), F = {
                                        gl: r,
                                        contextLost: !1,
                                        pixelRatio: t1.pixelRatio || 1,
                                        canvas: e1,
                                        selection: x,
                                        camera: R,
                                        axes: A,
                                        axesPixels: null,
                                        spikes: S,
                                        bounds: v,
                                        objects: E,
                                        shape: D,
                                        aspect: t1.aspectRatio || [
                                            1,
                                            1,
                                            1
                                        ],
                                        pickRadius: t1.pickRadius || 10,
                                        zNear: t1.zNear || .01,
                                        zFar: t1.zFar || 1e3,
                                        fovy: t1.fovy || Math.PI / 4,
                                        clearColor: t1.clearColor || [
                                            0,
                                            0,
                                            0,
                                            0
                                        ],
                                        autoResize: y(t1.autoResize),
                                        autoBounds: y(t1.autoBounds),
                                        autoScale: !!t1.autoScale,
                                        autoCenter: y(t1.autoCenter),
                                        clipToBounds: y(t1.clipToBounds),
                                        snapToData: !!t1.snapToData,
                                        onselect: t1.onselect || null,
                                        onrender: t1.onrender || null,
                                        onclick: t1.onclick || null,
                                        cameraParams: O,
                                        oncontextloss: null,
                                        mouseListener: null,
                                        _stopped: !1,
                                        getAspectratio: function() {
                                            return {
                                                x: this.aspect[0],
                                                y: this.aspect[1],
                                                z: this.aspect[2]
                                            };
                                        },
                                        setAspectratio: function(t1) {
                                            this.aspect[0] = t1.x, this.aspect[1] = t1.y, this.aspect[2] = t1.z, z = !0;
                                        },
                                        setBounds: function(t1, e1) {
                                            this.bounds[0][t1] = e1.min, this.bounds[1][t1] = e1.max;
                                        },
                                        setClearColor: function(t1) {
                                            this.clearColor = t1;
                                        },
                                        clearRGBA: function() {
                                            this.gl.clearColor(this.clearColor[0], this.clearColor[1], this.clearColor[2], this.clearColor[3]), this.gl.clear(this.gl.COLOR_BUFFER_BIT | this.gl.DEPTH_BUFFER_BIT);
                                        }
                                    }, B = [
                                        r.drawingBufferWidth / F.pixelRatio | 0,
                                        r.drawingBufferHeight / F.pixelRatio | 0
                                    ];
                                    function N() {
                                        if (!F._stopped && F.autoResize) {
                                            var t1 = e1.parentNode, r = 1, n = 1;
                                            t1 && t1 !== document.body ? (r = t1.clientWidth, n = t1.clientHeight) : (r = window.innerWidth, n = window.innerHeight);
                                            var i = 0 | Math.ceil(r * F.pixelRatio), a = 0 | Math.ceil(n * F.pixelRatio);
                                            if (i !== e1.width || a !== e1.height) {
                                                e1.width = i, e1.height = a;
                                                var o = e1.style;
                                                o.position = o.position || "absolute", o.left = "0px", o.top = "0px", o.width = r + "px", o.height = n + "px", P = !0;
                                            }
                                        }
                                    }
                                    function j() {
                                        for(var t1 = E.length, e1 = I.length, n = 0; n < e1; ++n)L[n] = 0;
                                        t: for(n = 0; n < t1; ++n){
                                            var i = E[n], a = i.pickSlots;
                                            if (a) {
                                                for(var o = 0; o < e1; ++o)if (L[o] + a < 255) {
                                                    C[n] = o, i.setPickBase(L[o] + 1), L[o] += a;
                                                    continue t;
                                                }
                                                var l = s(r, D);
                                                C[n] = e1, I.push(l), L.push(a), i.setPickBase(1), e1 += 1;
                                            } else C[n] = -1;
                                        }
                                        for(; e1 > 0 && 0 === L[e1 - 1];)L.pop(), I.pop().dispose();
                                    }
                                    function U() {
                                        if (F.contextLost) return !0;
                                        r.isContextLost() && (F.contextLost = !0, F.mouseListener.enabled = !1, F.selection.object = null, F.oncontextloss && F.oncontextloss());
                                    }
                                    F.autoResize && N(), window.addEventListener("resize", N), F.update = function(t1) {
                                        F._stopped || (t1 = t1 || {}, P = !0, z = !0);
                                    }, F.add = function(t1) {
                                        F._stopped || (t1.axes = A, E.push(t1), C.push(-1), P = !0, z = !0, j());
                                    }, F.remove = function(t1) {
                                        if (!F._stopped) {
                                            var e1 = E.indexOf(t1);
                                            e1 < 0 || (E.splice(e1, 1), C.pop(), P = !0, z = !0, j());
                                        }
                                    }, F.dispose = function() {
                                        if (!F._stopped && (F._stopped = !0, window.removeEventListener("resize", N), e1.removeEventListener("webglcontextlost", U), F.mouseListener.enabled = !1, !F.contextLost)) {
                                            A.dispose(), S.dispose();
                                            for(var t1 = 0; t1 < E.length; ++t1)E[t1].dispose();
                                            for(_.dispose(), t1 = 0; t1 < I.length; ++t1)I[t1].dispose();
                                            b.dispose(), r = null, A = null, S = null, E = [];
                                        }
                                    }, F._mouseRotating = !1, F._prevButtons = 0, F.enableMouseListeners = function() {
                                        F.mouseListener = u(e1, function(t1, e1, r) {
                                            if (!F._stopped) {
                                                var n = I.length, i = E.length, a = x.object;
                                                x.distance = 1 / 0, x.mouse[0] = e1, x.mouse[1] = r, x.object = null, x.screen = null, x.dataCoordinate = x.dataPosition = null;
                                                var o = !1;
                                                if (t1 && F._prevButtons) F._mouseRotating = !0;
                                                else {
                                                    F._mouseRotating && (z = !0), F._mouseRotating = !1;
                                                    for(var s = 0; s < n; ++s){
                                                        var l = I[s].query(e1, B[1] - r - 1, F.pickRadius);
                                                        if (l) {
                                                            if (l.distance > x.distance) continue;
                                                            for(var c = 0; c < i; ++c){
                                                                var u = E[c];
                                                                if (C[c] === s) {
                                                                    var h = u.pick(l);
                                                                    h && (x.buttons = t1, x.screen = l.coord, x.distance = l.distance, x.object = u, x.index = h.distance, x.dataPosition = h.position, x.dataCoordinate = h.dataCoordinate, x.data = h, o = !0);
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                a && a !== x.object && (a.highlight && a.highlight(null), P = !0), x.object && (x.object.highlight && x.object.highlight(x.data), P = !0), (o = o || x.object !== a) && F.onselect && F.onselect(x), 1 & t1 && !(1 & F._prevButtons) && F.onclick && F.onclick(x), F._prevButtons = t1;
                                            }
                                        });
                                    }, e1.addEventListener("webglcontextlost", U);
                                    var V = [
                                        [
                                            1 / 0,
                                            1 / 0,
                                            1 / 0
                                        ],
                                        [
                                            -1 / 0,
                                            -1 / 0,
                                            -1 / 0
                                        ]
                                    ], q = [
                                        V[0].slice(),
                                        V[1].slice()
                                    ];
                                    function H() {
                                        if (!U()) {
                                            N();
                                            var t1 = F.camera.tick();
                                            O.view = F.camera.matrix, P = P || t1, z = z || t1, A.pixelRatio = F.pixelRatio, S.pixelRatio = F.pixelRatio;
                                            var e1 = E.length, n = V[0], i = V[1];
                                            n[0] = n[1] = n[2] = 1 / 0, i[0] = i[1] = i[2] = -1 / 0;
                                            for(var o = 0; o < e1; ++o){
                                                (L = E[o]).pixelRatio = F.pixelRatio, L.axes = F.axes, P = P || !!L.dirty, z = z || !!L.dirty;
                                                var s = L.bounds;
                                                if (s) for(var l = s[0], u = s[1], p = 0; p < 3; ++p)n[p] = Math.min(n[p], l[p]), i[p] = Math.max(i[p], u[p]);
                                            }
                                            var d = F.bounds;
                                            if (F.autoBounds) for(p = 0; p < 3; ++p){
                                                if (i[p] < n[p]) n[p] = -1, i[p] = 1;
                                                else {
                                                    n[p] === i[p] && (n[p] -= 1, i[p] += 1);
                                                    var m = .05 * (i[p] - n[p]);
                                                    n[p] = n[p] - m, i[p] = i[p] + m;
                                                }
                                                d[0][p] = n[p], d[1][p] = i[p];
                                            }
                                            var y = !1;
                                            for(p = 0; p < 3; ++p)y = y || q[0][p] !== d[0][p] || q[1][p] !== d[1][p], q[0][p] = d[0][p], q[1][p] = d[1][p];
                                            if (z = z || y, P = P || y) {
                                                if (y) {
                                                    var v = [
                                                        0,
                                                        0,
                                                        0
                                                    ];
                                                    for(o = 0; o < 3; ++o)v[o] = g((d[1][o] - d[0][o]) / 10);
                                                    A.autoTicks ? A.update({
                                                        bounds: d,
                                                        tickSpacing: v
                                                    }) : A.update({
                                                        bounds: d
                                                    });
                                                }
                                                var T = r.drawingBufferWidth, k = r.drawingBufferHeight;
                                                for(D[0] = T, D[1] = k, B[0] = 0 | Math.max(T / F.pixelRatio, 1), B[1] = 0 | Math.max(k / F.pixelRatio, 1), function(t1, e1) {
                                                    var r = t1.bounds, n = t1.cameraParams, i = n.projection, a = n.model, o = t1.gl.drawingBufferWidth, s = t1.gl.drawingBufferHeight, l = t1.zNear, c = t1.zFar, u = t1.fovy, p = o / s;
                                                    e1 ? (f(i, -p, p, -1, 1, l, c), n._ortho = !0) : (h(i, u, p, l, c), n._ortho = !1);
                                                    for(var d = 0; d < 16; ++d)a[d] = 0;
                                                    a[15] = 1;
                                                    var m = 0;
                                                    for(d = 0; d < 3; ++d)m = Math.max(m, r[1][d] - r[0][d]);
                                                    for(d = 0; d < 3; ++d)t1.autoScale ? a[5 * d] = t1.aspect[d] / (r[1][d] - r[0][d]) : a[5 * d] = 1 / m, t1.autoCenter && (a[12 + d] = .5 * -a[5 * d] * (r[0][d] + r[1][d]));
                                                }(F, w), o = 0; o < e1; ++o)(L = E[o]).axesBounds = d, F.clipToBounds && (L.clipBounds = d);
                                                x.object && (F.snapToData ? S.position = x.dataCoordinate : S.position = x.dataPosition, S.bounds = d), z && (z = !1, function() {
                                                    if (!U()) {
                                                        r.colorMask(!0, !0, !0, !0), r.depthMask(!0), r.disable(r.BLEND), r.enable(r.DEPTH_TEST), r.depthFunc(r.LEQUAL);
                                                        for(var t1 = E.length, e1 = I.length, n = 0; n < e1; ++n){
                                                            var i = I[n];
                                                            i.shape = B, i.begin();
                                                            for(var a = 0; a < t1; ++a)if (C[a] === n) {
                                                                var o = E[a];
                                                                o.drawPick && (o.pixelRatio = 1, o.drawPick(O));
                                                            }
                                                            i.end();
                                                        }
                                                    }
                                                }()), F.axesPixels = a(F.axes, O, T, k), F.onrender && F.onrender(), r.bindFramebuffer(r.FRAMEBUFFER, null), r.viewport(0, 0, T, k), F.clearRGBA(), r.depthMask(!0), r.colorMask(!0, !0, !0, !0), r.enable(r.DEPTH_TEST), r.depthFunc(r.LEQUAL), r.disable(r.BLEND), r.disable(r.CULL_FACE);
                                                var M = !1;
                                                for(A.enable && (M = M || A.isTransparent(), A.draw(O)), S.axes = A, x.object && S.draw(O), r.disable(r.CULL_FACE), o = 0; o < e1; ++o)(L = E[o]).axes = A, L.pixelRatio = F.pixelRatio, L.isOpaque && L.isOpaque() && L.draw(O), L.isTransparent && L.isTransparent() && (M = !0);
                                                if (M) {
                                                    for(_.shape = D, _.bind(), r.clear(r.DEPTH_BUFFER_BIT), r.colorMask(!1, !1, !1, !1), r.depthMask(!0), r.depthFunc(r.LESS), A.enable && A.isTransparent() && A.drawTransparent(O), o = 0; o < e1; ++o)(L = E[o]).isOpaque && L.isOpaque() && L.draw(O);
                                                    for(r.enable(r.BLEND), r.blendEquation(r.FUNC_ADD), r.blendFunc(r.ONE, r.ONE_MINUS_SRC_ALPHA), r.colorMask(!0, !0, !0, !0), r.depthMask(!1), r.clearColor(0, 0, 0, 0), r.clear(r.COLOR_BUFFER_BIT), A.isTransparent() && A.drawTransparent(O), o = 0; o < e1; ++o){
                                                        var L;
                                                        (L = E[o]).isTransparent && L.isTransparent() && L.drawTransparent(O);
                                                    }
                                                    r.bindFramebuffer(r.FRAMEBUFFER, null), r.blendFunc(r.ONE, r.ONE_MINUS_SRC_ALPHA), r.disable(r.DEPTH_TEST), b.bind(), _.color[0].bind(0), b.uniforms.accumBuffer = 0, c(r), r.disable(r.BLEND);
                                                }
                                                for(P = !1, o = 0; o < e1; ++o)E[o].dirty = !1;
                                            }
                                        }
                                    }
                                    return F.enableMouseListeners(), function t1() {
                                        F._stopped || F.contextLost || (H(), requestAnimationFrame(t1));
                                    }(), F.redraw = function() {
                                        F._stopped || (P = !0, H());
                                    }, F;
                                },
                                createCamera: n
                            };
                        },
                        6640: function(t1, e1, r) {
                            var n = r(3236);
                            e1.pointVertex = n([
                                "precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 position;\n\nuniform mat3 matrix;\nuniform float pointSize;\nuniform float pointCloud;\n\nhighp float rand(vec2 co) {\n  highp float a = 12.9898;\n  highp float b = 78.233;\n  highp float c = 43758.5453;\n  highp float d = dot(co.xy, vec2(a, b));\n  highp float e = mod(d, 3.14);\n  return fract(sin(e) * c);\n}\n\nvoid main() {\n  vec3 hgPosition = matrix * vec3(position, 1);\n  gl_Position  = vec4(hgPosition.xy, 0, hgPosition.z);\n    // if we don't jitter the point size a bit, overall point cloud\n    // saturation 'jumps' on zooming, which is disturbing and confusing\n  gl_PointSize = pointSize * ((19.5 + rand(position)) / 20.0);\n  if(pointCloud != 0.0) { // pointCloud is truthy\n    // get the same square surface as circle would be\n    gl_PointSize *= 0.886;\n  }\n}"
                            ]), e1.pointFragment = n([
                                "precision mediump float;\n#define GLSLIFY 1\n\nuniform vec4 color, borderColor;\nuniform float centerFraction;\nuniform float pointCloud;\n\nvoid main() {\n  float radius;\n  vec4 baseColor;\n  if(pointCloud != 0.0) { // pointCloud is truthy\n    if(centerFraction == 1.0) {\n      gl_FragColor = color;\n    } else {\n      gl_FragColor = mix(borderColor, color, centerFraction);\n    }\n  } else {\n    radius = length(2.0 * gl_PointCoord.xy - 1.0);\n    if(radius > 1.0) {\n      discard;\n    }\n    baseColor = mix(borderColor, color, step(radius, centerFraction));\n    gl_FragColor = vec4(baseColor.rgb * baseColor.a, baseColor.a);\n  }\n}\n"
                            ]), e1.pickVertex = n([
                                "precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 position;\nattribute vec4 pickId;\n\nuniform mat3 matrix;\nuniform float pointSize;\nuniform vec4 pickOffset;\n\nvarying vec4 fragId;\n\nvoid main() {\n  vec3 hgPosition = matrix * vec3(position, 1);\n  gl_Position  = vec4(hgPosition.xy, 0, hgPosition.z);\n  gl_PointSize = pointSize;\n\n  vec4 id = pickId + pickOffset;\n  id.y += floor(id.x / 256.0);\n  id.x -= floor(id.x / 256.0) * 256.0;\n\n  id.z += floor(id.y / 256.0);\n  id.y -= floor(id.y / 256.0) * 256.0;\n\n  id.w += floor(id.z / 256.0);\n  id.z -= floor(id.z / 256.0) * 256.0;\n\n  fragId = id;\n}\n"
                            ]), e1.pickFragment = n([
                                "precision mediump float;\n#define GLSLIFY 1\n\nvarying vec4 fragId;\n\nvoid main() {\n  float radius = length(2.0 * gl_PointCoord.xy - 1.0);\n  if(radius > 1.0) {\n    discard;\n  }\n  gl_FragColor = fragId / 255.0;\n}\n"
                            ]);
                        },
                        4696: function(t1, e1, r) {
                            "use strict";
                            var n = r(9405), i = r(2762), a = r(1888), o = r(6640);
                            function s(t1, e1, r, n, i) {
                                this.plot = t1, this.offsetBuffer = e1, this.pickBuffer = r, this.shader = n, this.pickShader = i, this.sizeMin = .5, this.sizeMinCap = 2, this.sizeMax = 20, this.areaRatio = 1, this.pointCount = 0, this.color = [
                                    1,
                                    0,
                                    0,
                                    1
                                ], this.borderColor = [
                                    0,
                                    0,
                                    0,
                                    1
                                ], this.blend = !1, this.pickOffset = 0, this.points = null;
                            }
                            t1.exports = function(t1, e1) {
                                var r = t1.gl, a = new s(t1, i(r), i(r), n(r, o.pointVertex, o.pointFragment), n(r, o.pickVertex, o.pickFragment));
                                return a.update(e1), t1.addObject(a), a;
                            };
                            var l, c, u = s.prototype;
                            u.dispose = function() {
                                this.shader.dispose(), this.pickShader.dispose(), this.offsetBuffer.dispose(), this.pickBuffer.dispose(), this.plot.removeObject(this);
                            }, u.update = function(t1) {
                                var e1;
                                function r(e1, r) {
                                    return e1 in t1 ? t1[e1] : r;
                                }
                                t1 = t1 || {}, this.sizeMin = r("sizeMin", .5), this.sizeMax = r("sizeMax", 20), this.color = r("color", [
                                    1,
                                    0,
                                    0,
                                    1
                                ]).slice(), this.areaRatio = r("areaRatio", 1), this.borderColor = r("borderColor", [
                                    0,
                                    0,
                                    0,
                                    1
                                ]).slice(), this.blend = r("blend", !1);
                                var n = t1.positions.length >>> 1, i = t1.positions instanceof Float32Array, o = t1.idToIndex instanceof Int32Array && t1.idToIndex.length >= n, s = t1.positions, l = i ? s : a.mallocFloat32(s.length), c = o ? t1.idToIndex : a.mallocInt32(n);
                                if (i || l.set(s), !o) for(l.set(s), e1 = 0; e1 < n; e1++)c[e1] = e1;
                                this.points = s, this.offsetBuffer.update(l), this.pickBuffer.update(c), i || a.free(l), o || a.free(c), this.pointCount = n, this.pickOffset = 0;
                            }, u.unifiedDraw = (l = [
                                1,
                                0,
                                0,
                                0,
                                1,
                                0,
                                0,
                                0,
                                1
                            ], c = [
                                0,
                                0,
                                0,
                                0
                            ], function(t1) {
                                var e1 = void 0 !== t1, r = e1 ? this.pickShader : this.shader, n = this.plot.gl, i = this.plot.dataBox;
                                if (0 === this.pointCount) return t1;
                                var a = i[2] - i[0], o = i[3] - i[1], s = function(t1, e1) {
                                    var r, n = 0, i = t1.length >>> 1;
                                    for(r = 0; r < i; r++){
                                        var a = t1[2 * r], o = t1[2 * r + 1];
                                        a >= e1[0] && a <= e1[2] && o >= e1[1] && o <= e1[3] && n++;
                                    }
                                    return n;
                                }(this.points, i), u = this.plot.pickPixelRatio * Math.max(Math.min(this.sizeMinCap, this.sizeMin), Math.min(this.sizeMax, this.sizeMax / Math.pow(s, .33333)));
                                l[0] = 2 / a, l[4] = 2 / o, l[6] = -2 * i[0] / a - 1, l[7] = -2 * i[1] / o - 1, this.offsetBuffer.bind(), r.bind(), r.attributes.position.pointer(), r.uniforms.matrix = l, r.uniforms.color = this.color, r.uniforms.borderColor = this.borderColor, r.uniforms.pointCloud = u < 5, r.uniforms.pointSize = u, r.uniforms.centerFraction = Math.min(1, Math.max(0, Math.sqrt(1 - this.areaRatio))), e1 && (c[0] = 255 & t1, c[1] = t1 >> 8 & 255, c[2] = t1 >> 16 & 255, c[3] = t1 >> 24 & 255, this.pickBuffer.bind(), r.attributes.pickId.pointer(n.UNSIGNED_BYTE), r.uniforms.pickOffset = c, this.pickOffset = t1);
                                var h = n.getParameter(n.BLEND), f = n.getParameter(n.DITHER);
                                return h && !this.blend && n.disable(n.BLEND), f && n.disable(n.DITHER), n.drawArrays(n.POINTS, 0, this.pointCount), h && !this.blend && n.enable(n.BLEND), f && n.enable(n.DITHER), t1 + this.pointCount;
                            }), u.draw = u.unifiedDraw, u.drawPick = u.unifiedDraw, u.pick = function(t1, e1, r) {
                                var n = this.pickOffset, i = this.pointCount;
                                if (r < n || r >= n + i) return null;
                                var a = r - n, o = this.points;
                                return {
                                    object: this,
                                    pointId: a,
                                    dataCoord: [
                                        o[2 * a],
                                        o[2 * a + 1]
                                    ]
                                };
                            };
                        },
                        783: function(t1) {
                            t1.exports = function(t1, e1, r, n) {
                                var i, a, o, s, l, c = e1[0], u = e1[1], h = e1[2], f = e1[3], p = r[0], d = r[1], m = r[2], g = r[3];
                                return (a = c * p + u * d + h * m + f * g) < 0 && (a = -a, p = -p, d = -d, m = -m, g = -g), 1 - a > 1e-6 ? (i = Math.acos(a), o = Math.sin(i), s = Math.sin((1 - n) * i) / o, l = Math.sin(n * i) / o) : (s = 1 - n, l = n), t1[0] = s * c + l * p, t1[1] = s * u + l * d, t1[2] = s * h + l * m, t1[3] = s * f + l * g, t1;
                            };
                        },
                        5964: function(t1) {
                            "use strict";
                            t1.exports = function(t1) {
                                return t1 || 0 === t1 ? t1.toString() : "";
                            };
                        },
                        9366: function(t1, e1, r) {
                            "use strict";
                            var n = r(4359);
                            t1.exports = function(t1, e1, r) {
                                var a = [
                                    e1.style,
                                    e1.weight,
                                    e1.variant,
                                    e1.family
                                ].join("_"), o = i[a];
                                if (o || (o = i[a] = {}), t1 in o) return o[t1];
                                var s = {
                                    textAlign: "center",
                                    textBaseline: "middle",
                                    lineHeight: 1,
                                    font: e1.family,
                                    fontStyle: e1.style,
                                    fontWeight: e1.weight,
                                    fontVariant: e1.variant,
                                    lineSpacing: 1.25,
                                    styletags: {
                                        breaklines: !0,
                                        bolds: !0,
                                        italics: !0,
                                        subscripts: !0,
                                        superscripts: !0
                                    },
                                    triangles: !0
                                }, l = n(t1, s);
                                s.triangles = !1;
                                var c, u, h = n(t1, s);
                                if (r && 1 !== r) {
                                    for(c = 0; c < l.positions.length; ++c)for(u = 0; u < l.positions[c].length; ++u)l.positions[c][u] /= r;
                                    for(c = 0; c < h.positions.length; ++c)for(u = 0; u < h.positions[c].length; ++u)h.positions[c][u] /= r;
                                }
                                var f = [
                                    [
                                        1 / 0,
                                        1 / 0
                                    ],
                                    [
                                        -1 / 0,
                                        -1 / 0
                                    ]
                                ], p = h.positions.length;
                                for(c = 0; c < p; ++c){
                                    var d = h.positions[c];
                                    for(u = 0; u < 2; ++u)f[0][u] = Math.min(f[0][u], d[u]), f[1][u] = Math.max(f[1][u], d[u]);
                                }
                                return o[t1] = [
                                    l,
                                    h,
                                    f
                                ];
                            };
                            var i = {};
                        },
                        1283: function(t1, e1, r) {
                            var n = r(9405), i = r(3236), a = i([
                                "precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 glyph;\nattribute vec4 id;\n\nuniform vec4 highlightId;\nuniform float highlightScale;\nuniform mat4 model, view, projection;\nuniform vec3 clipBounds[2];\n\nvarying vec4 interpColor;\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0,0,0,0);\n  } else {\n    float scale = 1.0;\n    if(distance(highlightId, id) < 0.0001) {\n      scale = highlightScale;\n    }\n\n    vec4 worldPosition = model * vec4(position, 1);\n    vec4 viewPosition = view * worldPosition;\n    viewPosition = viewPosition / viewPosition.w;\n    vec4 clipPosition = projection * (viewPosition + scale * vec4(glyph.x, -glyph.y, 0, 0));\n\n    gl_Position = clipPosition;\n    interpColor = color;\n    pickId = id;\n    dataCoordinate = position;\n  }\n}"
                            ]), o = i([
                                "precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 glyph;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\nuniform vec2 screenSize;\nuniform vec3 clipBounds[2];\nuniform float highlightScale, pixelRatio;\nuniform vec4 highlightId;\n\nvarying vec4 interpColor;\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0,0,0,0);\n  } else {\n    float scale = pixelRatio;\n    if(distance(highlightId.bgr, id.bgr) < 0.001) {\n      scale *= highlightScale;\n    }\n\n    vec4 worldPosition = model * vec4(position, 1.0);\n    vec4 viewPosition = view * worldPosition;\n    vec4 clipPosition = projection * viewPosition;\n    clipPosition /= clipPosition.w;\n\n    gl_Position = clipPosition + vec4(screenSize * scale * vec2(glyph.x, -glyph.y), 0.0, 0.0);\n    interpColor = color;\n    pickId = id;\n    dataCoordinate = position;\n  }\n}"
                            ]), s = i([
                                "precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 glyph;\nattribute vec4 id;\n\nuniform float highlightScale;\nuniform vec4 highlightId;\nuniform vec3 axes[2];\nuniform mat4 model, view, projection;\nuniform vec2 screenSize;\nuniform vec3 clipBounds[2];\nuniform float scale, pixelRatio;\n\nvarying vec4 interpColor;\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0,0,0,0);\n  } else {\n    float lscale = pixelRatio * scale;\n    if(distance(highlightId, id) < 0.0001) {\n      lscale *= highlightScale;\n    }\n\n    vec4 clipCenter   = projection * (view * (model * vec4(position, 1)));\n    vec3 dataPosition = position + 0.5*lscale*(axes[0] * glyph.x + axes[1] * glyph.y) * clipCenter.w * screenSize.y;\n    vec4 clipPosition = projection * (view * (model * vec4(dataPosition, 1)));\n\n    gl_Position = clipPosition;\n    interpColor = color;\n    pickId = id;\n    dataCoordinate = dataPosition;\n  }\n}\n"
                            ]), l = i([
                                "precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 fragClipBounds[2];\nuniform float opacity;\n\nvarying vec4 interpColor;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (\n    outOfRange(fragClipBounds[0], fragClipBounds[1], dataCoordinate) ||\n    interpColor.a * opacity == 0.\n  ) discard;\n  gl_FragColor = interpColor * opacity;\n}\n"
                            ]), c = i([
                                "precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 fragClipBounds[2];\nuniform float pickGroup;\n\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(fragClipBounds[0], fragClipBounds[1], dataCoordinate)) discard;\n\n  gl_FragColor = vec4(pickGroup, pickId.bgr);\n}"
                            ]), u = [
                                {
                                    name: "position",
                                    type: "vec3"
                                },
                                {
                                    name: "color",
                                    type: "vec4"
                                },
                                {
                                    name: "glyph",
                                    type: "vec2"
                                },
                                {
                                    name: "id",
                                    type: "vec4"
                                }
                            ], h = {
                                vertex: a,
                                fragment: l,
                                attributes: u
                            }, f = {
                                vertex: o,
                                fragment: l,
                                attributes: u
                            }, p = {
                                vertex: s,
                                fragment: l,
                                attributes: u
                            }, d = {
                                vertex: a,
                                fragment: c,
                                attributes: u
                            }, m = {
                                vertex: o,
                                fragment: c,
                                attributes: u
                            }, g = {
                                vertex: s,
                                fragment: c,
                                attributes: u
                            };
                            function y(t1, e1) {
                                var r = n(t1, e1), i = r.attributes;
                                return i.position.location = 0, i.color.location = 1, i.glyph.location = 2, i.id.location = 3, r;
                            }
                            e1.createPerspective = function(t1) {
                                return y(t1, h);
                            }, e1.createOrtho = function(t1) {
                                return y(t1, f);
                            }, e1.createProject = function(t1) {
                                return y(t1, p);
                            }, e1.createPickPerspective = function(t1) {
                                return y(t1, d);
                            }, e1.createPickOrtho = function(t1) {
                                return y(t1, m);
                            }, e1.createPickProject = function(t1) {
                                return y(t1, g);
                            };
                        },
                        8418: function(t1, e1, r) {
                            "use strict";
                            var n = r(5219), i = r(2762), a = r(8116), o = r(1888), s = r(6760), l = r(1283), c = r(9366), u = r(5964), h = [
                                1,
                                0,
                                0,
                                0,
                                0,
                                1,
                                0,
                                0,
                                0,
                                0,
                                1,
                                0,
                                0,
                                0,
                                0,
                                1
                            ], f = ArrayBuffer, p = DataView;
                            function d(t1) {
                                return Array.isArray(t1) || function(t1) {
                                    return f.isView(t1) && !(t1 instanceof p);
                                }(t1);
                            }
                            function m(t1, e1) {
                                var r = t1[0], n = t1[1], i = t1[2], a = t1[3];
                                return t1[0] = e1[0] * r + e1[4] * n + e1[8] * i + e1[12] * a, t1[1] = e1[1] * r + e1[5] * n + e1[9] * i + e1[13] * a, t1[2] = e1[2] * r + e1[6] * n + e1[10] * i + e1[14] * a, t1[3] = e1[3] * r + e1[7] * n + e1[11] * i + e1[15] * a, t1;
                            }
                            function g(t1, e1, r, n) {
                                return m(n, n), m(n, n), m(n, n);
                            }
                            function y(t1, e1) {
                                this.index = t1, this.dataCoordinate = this.position = e1;
                            }
                            function v(t1) {
                                return !0 === t1 || t1 > 1 ? 1 : t1;
                            }
                            function x(t1, e1, r, n, i, a, o, s, l, c, u, h) {
                                this.gl = t1, this.pixelRatio = 1, this.shader = e1, this.orthoShader = r, this.projectShader = n, this.pointBuffer = i, this.colorBuffer = a, this.glyphBuffer = o, this.idBuffer = s, this.vao = l, this.vertexCount = 0, this.lineVertexCount = 0, this.opacity = 1, this.hasAlpha = !1, this.lineWidth = 0, this.projectScale = [
                                    2 / 3,
                                    2 / 3,
                                    2 / 3
                                ], this.projectOpacity = [
                                    1,
                                    1,
                                    1
                                ], this.projectHasAlpha = !1, this.pickId = 0, this.pickPerspectiveShader = c, this.pickOrthoShader = u, this.pickProjectShader = h, this.points = [], this._selectResult = new y(0, [
                                    0,
                                    0,
                                    0
                                ]), this.useOrtho = !0, this.bounds = [
                                    [
                                        1 / 0,
                                        1 / 0,
                                        1 / 0
                                    ],
                                    [
                                        -1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ]
                                ], this.axesProject = [
                                    !0,
                                    !0,
                                    !0
                                ], this.axesBounds = [
                                    [
                                        -1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ],
                                    [
                                        1 / 0,
                                        1 / 0,
                                        1 / 0
                                    ]
                                ], this.highlightId = [
                                    1,
                                    1,
                                    1,
                                    1
                                ], this.highlightScale = 2, this.clipBounds = [
                                    [
                                        -1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ],
                                    [
                                        1 / 0,
                                        1 / 0,
                                        1 / 0
                                    ]
                                ], this.dirty = !0;
                            }
                            t1.exports = function(t1) {
                                var e1 = t1.gl, r = l.createPerspective(e1), n = l.createOrtho(e1), o = l.createProject(e1), s = l.createPickPerspective(e1), c = l.createPickOrtho(e1), u = l.createPickProject(e1), h = i(e1), f = i(e1), p = i(e1), d = i(e1), m = new x(e1, r, n, o, h, f, p, d, a(e1, [
                                    {
                                        buffer: h,
                                        size: 3,
                                        type: e1.FLOAT
                                    },
                                    {
                                        buffer: f,
                                        size: 4,
                                        type: e1.FLOAT
                                    },
                                    {
                                        buffer: p,
                                        size: 2,
                                        type: e1.FLOAT
                                    },
                                    {
                                        buffer: d,
                                        size: 4,
                                        type: e1.UNSIGNED_BYTE,
                                        normalized: !0
                                    }
                                ]), s, c, u);
                                return m.update(t1), m;
                            };
                            var _ = x.prototype;
                            _.pickSlots = 1, _.setPickBase = function(t1) {
                                this.pickId = t1;
                            }, _.isTransparent = function() {
                                if (this.hasAlpha) return !0;
                                for(var t1 = 0; t1 < 3; ++t1)if (this.axesProject[t1] && this.projectHasAlpha) return !0;
                                return !1;
                            }, _.isOpaque = function() {
                                if (!this.hasAlpha) return !0;
                                for(var t1 = 0; t1 < 3; ++t1)if (this.axesProject[t1] && !this.projectHasAlpha) return !0;
                                return !1;
                            };
                            var b = [
                                0,
                                0
                            ], w = [
                                0,
                                0,
                                0
                            ], T = [
                                0,
                                0,
                                0
                            ], k = [
                                0,
                                0,
                                0,
                                1
                            ], A = [
                                0,
                                0,
                                0,
                                1
                            ], M = h.slice(), S = [
                                0,
                                0,
                                0
                            ], E = [
                                [
                                    0,
                                    0,
                                    0
                                ],
                                [
                                    0,
                                    0,
                                    0
                                ]
                            ];
                            function C(t1) {
                                return t1[0] = t1[1] = t1[2] = 0, t1;
                            }
                            function L(t1, e1) {
                                return t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1[3] = 1, t1;
                            }
                            function I(t1, e1, r, n) {
                                return t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1[r] = n, t1;
                            }
                            var P = [
                                [
                                    -100000000,
                                    -100000000,
                                    -100000000
                                ],
                                [
                                    1e8,
                                    1e8,
                                    1e8
                                ]
                            ];
                            function z(t1, e1, r, n, i, a, o) {
                                var l = r.gl;
                                if ((a === r.projectHasAlpha || o) && function(t1, e1, r, n) {
                                    var i, a = e1.axesProject, o = e1.gl, l = t1.uniforms, c = r.model || h, u = r.view || h, f = r.projection || h, p = e1.axesBounds, d = function(t1) {
                                        for(var e1 = E, r = 0; r < 2; ++r)for(var n = 0; n < 3; ++n)e1[r][n] = Math.max(Math.min(t1[r][n], 1e8), -100000000);
                                        return e1;
                                    }(e1.clipBounds);
                                    i = e1.axes && e1.axes.lastCubeProps ? e1.axes.lastCubeProps.axis : [
                                        1,
                                        1,
                                        1
                                    ], b[0] = 2 / o.drawingBufferWidth, b[1] = 2 / o.drawingBufferHeight, t1.bind(), l.view = u, l.projection = f, l.screenSize = b, l.highlightId = e1.highlightId, l.highlightScale = e1.highlightScale, l.clipBounds = d, l.pickGroup = e1.pickId / 255, l.pixelRatio = n;
                                    for(var m = 0; m < 3; ++m)if (a[m]) {
                                        l.scale = e1.projectScale[m], l.opacity = e1.projectOpacity[m];
                                        for(var y = M, v = 0; v < 16; ++v)y[v] = 0;
                                        for(v = 0; v < 4; ++v)y[5 * v] = 1;
                                        y[5 * m] = 0, i[m] < 0 ? y[12 + m] = p[0][m] : y[12 + m] = p[1][m], s(y, c, y), l.model = y;
                                        var x = (m + 1) % 3, _ = (m + 2) % 3, P = C(w), z = C(T);
                                        P[x] = 1, z[_] = 1;
                                        var O = g(0, 0, 0, L(k, P)), D = g(0, 0, 0, L(A, z));
                                        if (Math.abs(O[1]) > Math.abs(D[1])) {
                                            var R = O;
                                            O = D, D = R, R = P, P = z, z = R;
                                            var F = x;
                                            x = _, _ = F;
                                        }
                                        O[0] < 0 && (P[x] = -1), D[1] > 0 && (z[_] = -1);
                                        var B = 0, N = 0;
                                        for(v = 0; v < 4; ++v)B += Math.pow(c[4 * x + v], 2), N += Math.pow(c[4 * _ + v], 2);
                                        P[x] /= Math.sqrt(B), z[_] /= Math.sqrt(N), l.axes[0] = P, l.axes[1] = z, l.fragClipBounds[0] = I(S, d[0], m, -100000000), l.fragClipBounds[1] = I(S, d[1], m, 1e8), e1.vao.bind(), e1.vao.draw(o.TRIANGLES, e1.vertexCount), e1.lineWidth > 0 && (o.lineWidth(e1.lineWidth * n), e1.vao.draw(o.LINES, e1.lineVertexCount, e1.vertexCount)), e1.vao.unbind();
                                    }
                                }(e1, r, n, i), a === r.hasAlpha || o) {
                                    t1.bind();
                                    var c = t1.uniforms;
                                    c.model = n.model || h, c.view = n.view || h, c.projection = n.projection || h, b[0] = 2 / l.drawingBufferWidth, b[1] = 2 / l.drawingBufferHeight, c.screenSize = b, c.highlightId = r.highlightId, c.highlightScale = r.highlightScale, c.fragClipBounds = P, c.clipBounds = r.axes.bounds, c.opacity = r.opacity, c.pickGroup = r.pickId / 255, c.pixelRatio = i, r.vao.bind(), r.vao.draw(l.TRIANGLES, r.vertexCount), r.lineWidth > 0 && (l.lineWidth(r.lineWidth * i), r.vao.draw(l.LINES, r.lineVertexCount, r.vertexCount)), r.vao.unbind();
                                }
                            }
                            function O(t1, e1, r, i) {
                                var a;
                                a = d(t1) ? e1 < t1.length ? t1[e1] : void 0 : t1, a = u(a);
                                var o = !0;
                                n(a) && (a = "\u25BC", o = !1), r || (r = {});
                                var s = r.family;
                                d(s) && (s = s[e1]), s || (s = "normal");
                                var l = r.weight;
                                d(l) && (l = l[e1]), l || (l = "normal");
                                var h = r.style;
                                d(h) && (h = h[e1]), h || (h = "normal");
                                var f = r.variant;
                                d(f) && (f = f[e1]), f || (f = "normal");
                                var p = c(a, {
                                    family: s,
                                    weight: l,
                                    style: h,
                                    variant: f
                                }, i);
                                return {
                                    mesh: (p = c(a, r, i))[0],
                                    lines: p[1],
                                    bounds: p[2],
                                    visible: o
                                };
                            }
                            _.draw = function(t1) {
                                z(this.useOrtho ? this.orthoShader : this.shader, this.projectShader, this, t1, this.pixelRatio, !1, !1);
                            }, _.drawTransparent = function(t1) {
                                z(this.useOrtho ? this.orthoShader : this.shader, this.projectShader, this, t1, this.pixelRatio, !0, !1);
                            }, _.drawPick = function(t1) {
                                z(this.useOrtho ? this.pickOrthoShader : this.pickPerspectiveShader, this.pickProjectShader, this, t1, 1, !0, !0);
                            }, _.pick = function(t1) {
                                if (!t1) return null;
                                if (t1.id !== this.pickId) return null;
                                var e1 = t1.value[2] + (t1.value[1] << 8) + (t1.value[0] << 16);
                                if (e1 >= this.pointCount || e1 < 0) return null;
                                var r = this.points[e1], n = this._selectResult;
                                n.index = e1;
                                for(var i = 0; i < 3; ++i)n.position[i] = n.dataCoordinate[i] = r[i];
                                return n;
                            }, _.highlight = function(t1) {
                                if (t1) {
                                    var e1 = t1.index, r = 255 & e1, n = e1 >> 8 & 255, i = e1 >> 16 & 255;
                                    this.highlightId = [
                                        r / 255,
                                        n / 255,
                                        i / 255,
                                        0
                                    ];
                                } else this.highlightId = [
                                    1,
                                    1,
                                    1,
                                    1
                                ];
                            }, _.update = function(t1) {
                                if ("perspective" in (t1 = t1 || {}) && (this.useOrtho = !t1.perspective), "orthographic" in t1 && (this.useOrtho = !!t1.orthographic), "lineWidth" in t1 && (this.lineWidth = t1.lineWidth), "project" in t1) {
                                    if (d(t1.project)) this.axesProject = t1.project;
                                    else {
                                        var e1 = !!t1.project;
                                        this.axesProject = [
                                            e1,
                                            e1,
                                            e1
                                        ];
                                    }
                                }
                                if ("projectScale" in t1) {
                                    if (d(t1.projectScale)) this.projectScale = t1.projectScale.slice();
                                    else {
                                        var r = +t1.projectScale;
                                        this.projectScale = [
                                            r,
                                            r,
                                            r
                                        ];
                                    }
                                }
                                if (this.projectHasAlpha = !1, "projectOpacity" in t1) {
                                    d(t1.projectOpacity) ? this.projectOpacity = t1.projectOpacity.slice() : (r = +t1.projectOpacity, this.projectOpacity = [
                                        r,
                                        r,
                                        r
                                    ]);
                                    for(var n = 0; n < 3; ++n)this.projectOpacity[n] = v(this.projectOpacity[n]), this.projectOpacity[n] < 1 && (this.projectHasAlpha = !0);
                                }
                                this.hasAlpha = !1, "opacity" in t1 && (this.opacity = v(t1.opacity), this.opacity < 1 && (this.hasAlpha = !0)), this.dirty = !0;
                                var i, a, s = t1.position, l = {
                                    family: t1.font || "normal",
                                    style: t1.fontStyle || "normal",
                                    weight: t1.fontWeight || "normal",
                                    variant: t1.fontVariant || "normal"
                                }, c = t1.alignment || [
                                    0,
                                    0
                                ];
                                if (2 === c.length) i = c[0], a = c[1];
                                else for(i = [], a = [], n = 0; n < c.length; ++n)i[n] = c[n][0], a[n] = c[n][1];
                                var u = [
                                    1 / 0,
                                    1 / 0,
                                    1 / 0
                                ], h = [
                                    -1 / 0,
                                    -1 / 0,
                                    -1 / 0
                                ], f = t1.glyph, p = t1.color, m = t1.size, g = t1.angle, y = t1.lineColor, x = -1, _ = 0, b = 0, w = 0;
                                if (s.length) {
                                    w = s.length;
                                    t: for(n = 0; n < w; ++n){
                                        for(var T = s[n], k = 0; k < 3; ++k)if (isNaN(T[k]) || !isFinite(T[k])) continue t;
                                        var A = (j = O(f, n, l, this.pixelRatio)).mesh, M = j.lines, S = j.bounds;
                                        _ += 3 * A.cells.length, b += 2 * M.edges.length;
                                    }
                                }
                                var E = _ + b, C = o.mallocFloat(3 * E), L = o.mallocFloat(4 * E), I = o.mallocFloat(2 * E), P = o.mallocUint32(E);
                                if (E > 0) {
                                    var z = 0, D = _, R = [
                                        0,
                                        0,
                                        0,
                                        1
                                    ], F = [
                                        0,
                                        0,
                                        0,
                                        1
                                    ], B = d(p) && d(p[0]), N = d(y) && d(y[0]);
                                    t: for(n = 0; n < w; ++n){
                                        for(x += 1, T = s[n], k = 0; k < 3; ++k){
                                            if (isNaN(T[k]) || !isFinite(T[k])) continue t;
                                            h[k] = Math.max(h[k], T[k]), u[k] = Math.min(u[k], T[k]);
                                        }
                                        A = (j = O(f, n, l, this.pixelRatio)).mesh, M = j.lines, S = j.bounds;
                                        var j, U = j.visible;
                                        if (U) {
                                            if (d(p)) {
                                                if (3 === (V = B ? n < p.length ? p[n] : [
                                                    0,
                                                    0,
                                                    0,
                                                    0
                                                ] : p).length) {
                                                    for(k = 0; k < 3; ++k)R[k] = V[k];
                                                    R[3] = 1;
                                                } else if (4 === V.length) {
                                                    for(k = 0; k < 4; ++k)R[k] = V[k];
                                                    !this.hasAlpha && V[3] < 1 && (this.hasAlpha = !0);
                                                }
                                            } else R[0] = R[1] = R[2] = 0, R[3] = 1;
                                        } else R = [
                                            1,
                                            1,
                                            1,
                                            0
                                        ];
                                        if (U) {
                                            if (d(y)) {
                                                var V;
                                                if (3 === (V = N ? n < y.length ? y[n] : [
                                                    0,
                                                    0,
                                                    0,
                                                    0
                                                ] : y).length) {
                                                    for(k = 0; k < 3; ++k)F[k] = V[k];
                                                    F[k] = 1;
                                                } else if (4 === V.length) {
                                                    for(k = 0; k < 4; ++k)F[k] = V[k];
                                                    !this.hasAlpha && V[3] < 1 && (this.hasAlpha = !0);
                                                }
                                            } else F[0] = F[1] = F[2] = 0, F[3] = 1;
                                        } else F = [
                                            1,
                                            1,
                                            1,
                                            0
                                        ];
                                        var q = .5;
                                        U ? d(m) ? q = n < m.length ? +m[n] : 12 : m ? q = +m : this.useOrtho && (q = 12) : q = 0;
                                        var H = 0;
                                        d(g) ? H = n < g.length ? +g[n] : 0 : g && (H = +g);
                                        var G = Math.cos(H), Z = Math.sin(H);
                                        for(T = s[n], k = 0; k < 3; ++k)h[k] = Math.max(h[k], T[k]), u[k] = Math.min(u[k], T[k]);
                                        var W = i, Y = a;
                                        W = 0, d(i) ? W = n < i.length ? i[n] : 0 : i && (W = i), Y = 0, d(a) ? Y = n < a.length ? a[n] : 0 : a && (Y = a);
                                        var X = [
                                            W *= W > 0 ? 1 - S[0][0] : W < 0 ? 1 + S[1][0] : 1,
                                            Y *= Y > 0 ? 1 - S[0][1] : Y < 0 ? 1 + S[1][1] : 1
                                        ], $ = A.cells || [], J = A.positions || [];
                                        for(k = 0; k < $.length; ++k)for(var K = $[k], Q = 0; Q < 3; ++Q){
                                            for(var tt = 0; tt < 3; ++tt)C[3 * z + tt] = T[tt];
                                            for(tt = 0; tt < 4; ++tt)L[4 * z + tt] = R[tt];
                                            P[z] = x;
                                            var et = J[K[Q]];
                                            I[2 * z] = q * (G * et[0] - Z * et[1] + X[0]), I[2 * z + 1] = q * (Z * et[0] + G * et[1] + X[1]), z += 1;
                                        }
                                        for($ = M.edges, J = M.positions, k = 0; k < $.length; ++k)for(K = $[k], Q = 0; Q < 2; ++Q){
                                            for(tt = 0; tt < 3; ++tt)C[3 * D + tt] = T[tt];
                                            for(tt = 0; tt < 4; ++tt)L[4 * D + tt] = F[tt];
                                            P[D] = x, et = J[K[Q]], I[2 * D] = q * (G * et[0] - Z * et[1] + X[0]), I[2 * D + 1] = q * (Z * et[0] + G * et[1] + X[1]), D += 1;
                                        }
                                    }
                                }
                                this.bounds = [
                                    u,
                                    h
                                ], this.points = s, this.pointCount = s.length, this.vertexCount = _, this.lineVertexCount = b, this.pointBuffer.update(C), this.colorBuffer.update(L), this.glyphBuffer.update(I), this.idBuffer.update(P), o.free(C), o.free(L), o.free(I), o.free(P);
                            }, _.dispose = function() {
                                this.shader.dispose(), this.orthoShader.dispose(), this.pickPerspectiveShader.dispose(), this.pickOrthoShader.dispose(), this.vao.dispose(), this.pointBuffer.dispose(), this.colorBuffer.dispose(), this.glyphBuffer.dispose(), this.idBuffer.dispose();
                            };
                        },
                        4298: function(t1, e1, r) {
                            "use strict";
                            var n = r(3236);
                            e1.boxVertex = n([
                                "precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 vertex;\n\nuniform vec2 cornerA, cornerB;\n\nvoid main() {\n  gl_Position = vec4(mix(cornerA, cornerB, vertex), 0, 1);\n}\n"
                            ]), e1.boxFragment = n([
                                "precision mediump float;\n#define GLSLIFY 1\n\nuniform vec4 color;\n\nvoid main() {\n  gl_FragColor = color;\n}\n"
                            ]);
                        },
                        3161: function(t1, e1, r) {
                            "use strict";
                            var n = r(9405), i = r(2762), a = r(4298);
                            function o(t1, e1, r) {
                                this.plot = t1, this.boxBuffer = e1, this.boxShader = r, this.enabled = !0, this.selectBox = [
                                    1 / 0,
                                    1 / 0,
                                    -1 / 0,
                                    -1 / 0
                                ], this.borderColor = [
                                    0,
                                    0,
                                    0,
                                    1
                                ], this.innerFill = !1, this.innerColor = [
                                    0,
                                    0,
                                    0,
                                    .25
                                ], this.outerFill = !0, this.outerColor = [
                                    0,
                                    0,
                                    0,
                                    .5
                                ], this.borderWidth = 10;
                            }
                            t1.exports = function(t1, e1) {
                                var r = t1.gl, s = new o(t1, i(r, [
                                    0,
                                    0,
                                    0,
                                    1,
                                    1,
                                    0,
                                    1,
                                    1
                                ]), n(r, a.boxVertex, a.boxFragment));
                                return s.update(e1), t1.addOverlay(s), s;
                            };
                            var s = o.prototype;
                            s.draw = function() {
                                if (this.enabled) {
                                    var t1 = this.plot, e1 = this.selectBox, r = this.borderWidth, n = (this.innerFill, this.innerColor), i = (this.outerFill, this.outerColor), a = this.borderColor, o = t1.box, s = t1.screenBox, l = t1.dataBox, c = t1.viewBox, u = t1.pixelRatio, h = (e1[0] - l[0]) * (c[2] - c[0]) / (l[2] - l[0]) + c[0], f = (e1[1] - l[1]) * (c[3] - c[1]) / (l[3] - l[1]) + c[1], p = (e1[2] - l[0]) * (c[2] - c[0]) / (l[2] - l[0]) + c[0], d = (e1[3] - l[1]) * (c[3] - c[1]) / (l[3] - l[1]) + c[1];
                                    if (h = Math.max(h, c[0]), f = Math.max(f, c[1]), p = Math.min(p, c[2]), d = Math.min(d, c[3]), !(p < h || d < f)) {
                                        o.bind();
                                        var m = s[2] - s[0], g = s[3] - s[1];
                                        if (this.outerFill && (o.drawBox(0, 0, m, f, i), o.drawBox(0, f, h, d, i), o.drawBox(0, d, m, g, i), o.drawBox(p, f, m, d, i)), this.innerFill && o.drawBox(h, f, p, d, n), r > 0) {
                                            var y = r * u;
                                            o.drawBox(h - y, f - y, p + y, f + y, a), o.drawBox(h - y, d - y, p + y, d + y, a), o.drawBox(h - y, f - y, h + y, d + y, a), o.drawBox(p - y, f - y, p + y, d + y, a);
                                        }
                                    }
                                }
                            }, s.update = function(t1) {
                                t1 = t1 || {}, this.innerFill = !!t1.innerFill, this.outerFill = !!t1.outerFill, this.innerColor = (t1.innerColor || [
                                    0,
                                    0,
                                    0,
                                    .5
                                ]).slice(), this.outerColor = (t1.outerColor || [
                                    0,
                                    0,
                                    0,
                                    .5
                                ]).slice(), this.borderColor = (t1.borderColor || [
                                    0,
                                    0,
                                    0,
                                    1
                                ]).slice(), this.borderWidth = t1.borderWidth || 0, this.selectBox = (t1.selectBox || this.selectBox).slice();
                            }, s.dispose = function() {
                                this.boxBuffer.dispose(), this.boxShader.dispose(), this.plot.removeOverlay(this);
                            };
                        },
                        3589: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1) {
                                var r = e1[0], a = e1[1];
                                return new l(t1, n(t1, r, a, {}), i.mallocUint8(r * a * 4));
                            };
                            var n = r(2260), i = r(1888), a = r(9618), o = r(8828).nextPow2;
                            function s(t1, e1, r, n, i) {
                                this.coord = [
                                    t1,
                                    e1
                                ], this.id = r, this.value = n, this.distance = i;
                            }
                            function l(t1, e1, r) {
                                this.gl = t1, this.fbo = e1, this.buffer = r, this._readTimeout = null;
                                var n = this;
                                this._readCallback = function() {
                                    n.gl && (e1.bind(), t1.readPixels(0, 0, e1.shape[0], e1.shape[1], t1.RGBA, t1.UNSIGNED_BYTE, n.buffer), n._readTimeout = null);
                                };
                            }
                            var c = l.prototype;
                            Object.defineProperty(c, "shape", {
                                get: function() {
                                    return this.gl ? this.fbo.shape.slice() : [
                                        0,
                                        0
                                    ];
                                },
                                set: function(t1) {
                                    if (this.gl) {
                                        this.fbo.shape = t1;
                                        var e1 = this.fbo.shape[0], r = this.fbo.shape[1];
                                        if (r * e1 * 4 > this.buffer.length) {
                                            i.free(this.buffer);
                                            for(var n = this.buffer = i.mallocUint8(o(r * e1 * 4)), a = 0; a < r * e1 * 4; ++a)n[a] = 255;
                                        }
                                        return t1;
                                    }
                                }
                            }), c.begin = function() {
                                var t1 = this.gl;
                                this.shape, t1 && (this.fbo.bind(), t1.clearColor(1, 1, 1, 1), t1.clear(t1.COLOR_BUFFER_BIT | t1.DEPTH_BUFFER_BIT));
                            }, c.end = function() {
                                var t1 = this.gl;
                                t1 && (t1.bindFramebuffer(t1.FRAMEBUFFER, null), this._readTimeout || clearTimeout(this._readTimeout), this._readTimeout = setTimeout(this._readCallback, 1));
                            }, c.query = function(t1, e1, r) {
                                if (!this.gl) return null;
                                var n = this.fbo.shape.slice();
                                t1 |= 0, e1 |= 0, "number" != typeof r && (r = 1);
                                var i = 0 | Math.min(Math.max(t1 - r, 0), n[0]), o = 0 | Math.min(Math.max(t1 + r, 0), n[0]), l = 0 | Math.min(Math.max(e1 - r, 0), n[1]), c = 0 | Math.min(Math.max(e1 + r, 0), n[1]);
                                if (o <= i || c <= l) return null;
                                var u = [
                                    o - i,
                                    c - l
                                ], h = a(this.buffer, [
                                    u[0],
                                    u[1],
                                    4
                                ], [
                                    4,
                                    4 * n[0],
                                    1
                                ], 4 * (i + n[0] * l)), f = function(t1, e1, r) {
                                    for(var n = 1e8, i = -1, a = -1, o = t1.shape[0], s = t1.shape[1], l = 0; l < o; l++)for(var c = 0; c < s; c++){
                                        var u = t1.get(l, c, 0), h = t1.get(l, c, 1), f = t1.get(l, c, 2), p = t1.get(l, c, 3);
                                        if (u < 255 || h < 255 || f < 255 || p < 255) {
                                            var d = e1 - l, m = r - c, g = d * d + m * m;
                                            g < n && (n = g, i = l, a = c);
                                        }
                                    }
                                    return [
                                        i,
                                        a,
                                        n
                                    ];
                                }(h.hi(u[0], u[1], 1), r, r), p = f[0], d = f[1];
                                return p < 0 || Math.pow(this.radius, 2) < f[2] ? null : new s(p + i | 0, d + l | 0, h.get(p, d, 0), [
                                    h.get(p, d, 1),
                                    h.get(p, d, 2),
                                    h.get(p, d, 3)
                                ], Math.sqrt(f[2]));
                            }, c.dispose = function() {
                                this.gl && (this.fbo.dispose(), i.free(this.buffer), this.gl = null, this._readTimeout && clearTimeout(this._readTimeout));
                            };
                        },
                        9405: function(t1, e1, r) {
                            "use strict";
                            var n = r(3327), i = r(8731), a = r(216), o = r(5091), s = r(2145), l = r(8866);
                            function c(t1) {
                                this.gl = t1, this.gl.lastAttribCount = 0, this._vref = this._fref = this._relink = this.vertShader = this.fragShader = this.program = this.attributes = this.uniforms = this.types = null;
                            }
                            var u = c.prototype;
                            function h(t1, e1) {
                                return t1.name < e1.name ? -1 : 1;
                            }
                            u.bind = function() {
                                var t1;
                                this.program || this._relink();
                                var e1 = this.gl.getProgramParameter(this.program, this.gl.ACTIVE_ATTRIBUTES), r = this.gl.lastAttribCount;
                                if (e1 > r) for(t1 = r; t1 < e1; t1++)this.gl.enableVertexAttribArray(t1);
                                else if (r > e1) for(t1 = e1; t1 < r; t1++)this.gl.disableVertexAttribArray(t1);
                                this.gl.lastAttribCount = e1, this.gl.useProgram(this.program);
                            }, u.dispose = function() {
                                for(var t1 = this.gl.lastAttribCount, e1 = 0; e1 < t1; e1++)this.gl.disableVertexAttribArray(e1);
                                this.gl.lastAttribCount = 0, this._fref && this._fref.dispose(), this._vref && this._vref.dispose(), this.attributes = this.types = this.vertShader = this.fragShader = this.program = this._relink = this._fref = this._vref = null;
                            }, u.update = function(t1, e1, r, c) {
                                if (!e1 || 1 === arguments.length) {
                                    var u = t1;
                                    t1 = u.vertex, e1 = u.fragment, r = u.uniforms, c = u.attributes;
                                }
                                var f = this, p = f.gl, d = f._vref;
                                f._vref = o.shader(p, p.VERTEX_SHADER, t1), d && d.dispose(), f.vertShader = f._vref.shader;
                                var m = this._fref;
                                if (f._fref = o.shader(p, p.FRAGMENT_SHADER, e1), m && m.dispose(), f.fragShader = f._fref.shader, !r || !c) {
                                    var g = p.createProgram();
                                    if (p.attachShader(g, f.fragShader), p.attachShader(g, f.vertShader), p.linkProgram(g), !p.getProgramParameter(g, p.LINK_STATUS)) {
                                        var y = p.getProgramInfoLog(g);
                                        throw new l(y, "Error linking program:" + y);
                                    }
                                    r = r || s.uniforms(p, g), c = c || s.attributes(p, g), p.deleteProgram(g);
                                }
                                (c = c.slice()).sort(h);
                                var v, x = [], _ = [], b = [];
                                for(v = 0; v < c.length; ++v){
                                    var w = c[v];
                                    if (w.type.indexOf("mat") >= 0) {
                                        for(var T = 0 | w.type.charAt(w.type.length - 1), k = new Array(T), A = 0; A < T; ++A)k[A] = b.length, _.push(w.name + "[" + A + "]"), "number" == typeof w.location ? b.push(w.location + A) : Array.isArray(w.location) && w.location.length === T && "number" == typeof w.location[A] ? b.push(0 | w.location[A]) : b.push(-1);
                                        x.push({
                                            name: w.name,
                                            type: w.type,
                                            locations: k
                                        });
                                    } else x.push({
                                        name: w.name,
                                        type: w.type,
                                        locations: [
                                            b.length
                                        ]
                                    }), _.push(w.name), "number" == typeof w.location ? b.push(0 | w.location) : b.push(-1);
                                }
                                var M = 0;
                                for(v = 0; v < b.length; ++v)if (b[v] < 0) {
                                    for(; b.indexOf(M) >= 0;)M += 1;
                                    b[v] = M;
                                }
                                var S = new Array(r.length);
                                function E() {
                                    f.program = o.program(p, f._vref, f._fref, _, b);
                                    for(var t1 = 0; t1 < r.length; ++t1)S[t1] = p.getUniformLocation(f.program, r[t1].name);
                                }
                                E(), f._relink = E, f.types = {
                                    uniforms: a(r),
                                    attributes: a(c)
                                }, f.attributes = i(p, f, x, b), Object.defineProperty(f, "uniforms", n(p, f, r, S));
                            }, t1.exports = function(t1, e1, r, n, i) {
                                var a = new c(t1);
                                return a.update(e1, r, n, i), a;
                            };
                        },
                        8866: function(t1) {
                            function e1(t1, e1, r) {
                                this.shortMessage = e1 || "", this.longMessage = r || "", this.rawError = t1 || "", this.message = "gl-shader: " + (e1 || t1 || "") + (r ? "\n" + r : ""), this.stack = (new Error).stack;
                            }
                            e1.prototype = new Error, e1.prototype.name = "GLError", e1.prototype.constructor = e1, t1.exports = e1;
                        },
                        8731: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1, r, i) {
                                for(var a = {}, o = 0, c = r.length; o < c; ++o){
                                    var u = r[o], h = u.name, f = u.type, p = u.locations;
                                    switch(f){
                                        case "bool":
                                        case "int":
                                        case "float":
                                            s(t1, e1, p[0], i, 1, a, h);
                                            break;
                                        default:
                                            if (f.indexOf("vec") >= 0) {
                                                if ((d = f.charCodeAt(f.length - 1) - 48) < 2 || d > 4) throw new n("", "Invalid data type for attribute " + h + ": " + f);
                                                s(t1, e1, p[0], i, d, a, h);
                                            } else {
                                                if (!(f.indexOf("mat") >= 0)) throw new n("", "Unknown data type for attribute " + h + ": " + f);
                                                var d;
                                                if ((d = f.charCodeAt(f.length - 1) - 48) < 2 || d > 4) throw new n("", "Invalid data type for attribute " + h + ": " + f);
                                                l(t1, e1, p, i, d, a, h);
                                            }
                                    }
                                }
                                return a;
                            };
                            var n = r(8866);
                            function i(t1, e1, r, n, i, a) {
                                this._gl = t1, this._wrapper = e1, this._index = r, this._locations = n, this._dimension = i, this._constFunc = a;
                            }
                            var a = i.prototype;
                            a.pointer = function(t1, e1, r, n) {
                                var i = this, a = i._gl, o = i._locations[i._index];
                                a.vertexAttribPointer(o, i._dimension, t1 || a.FLOAT, !!e1, r || 0, n || 0), a.enableVertexAttribArray(o);
                            }, a.set = function(t1, e1, r, n) {
                                return this._constFunc(this._locations[this._index], t1, e1, r, n);
                            }, Object.defineProperty(a, "location", {
                                get: function() {
                                    return this._locations[this._index];
                                },
                                set: function(t1) {
                                    return t1 !== this._locations[this._index] && (this._locations[this._index] = 0 | t1, this._wrapper.program = null), 0 | t1;
                                }
                            });
                            var o = [
                                function(t1, e1, r) {
                                    return void 0 === r.length ? t1.vertexAttrib1f(e1, r) : t1.vertexAttrib1fv(e1, r);
                                },
                                function(t1, e1, r, n) {
                                    return void 0 === r.length ? t1.vertexAttrib2f(e1, r, n) : t1.vertexAttrib2fv(e1, r);
                                },
                                function(t1, e1, r, n, i) {
                                    return void 0 === r.length ? t1.vertexAttrib3f(e1, r, n, i) : t1.vertexAttrib3fv(e1, r);
                                },
                                function(t1, e1, r, n, i, a) {
                                    return void 0 === r.length ? t1.vertexAttrib4f(e1, r, n, i, a) : t1.vertexAttrib4fv(e1, r);
                                }
                            ];
                            function s(t1, e1, r, n, a, s, l) {
                                var c = o[a], u = new i(t1, e1, r, n, a, c);
                                Object.defineProperty(s, l, {
                                    set: function(e1) {
                                        return t1.disableVertexAttribArray(n[r]), c(t1, n[r], e1), e1;
                                    },
                                    get: function() {
                                        return u;
                                    },
                                    enumerable: !0
                                });
                            }
                            function l(t1, e1, r, n, i, a, o) {
                                for(var l = new Array(i), c = new Array(i), u = 0; u < i; ++u)s(t1, e1, r[u], n, i, l, u), c[u] = l[u];
                                Object.defineProperty(l, "location", {
                                    set: function(t1) {
                                        if (Array.isArray(t1)) for(var e1 = 0; e1 < i; ++e1)c[e1].location = t1[e1];
                                        else for(e1 = 0; e1 < i; ++e1)c[e1].location = t1 + e1;
                                        return t1;
                                    },
                                    get: function() {
                                        for(var t1 = new Array(i), e1 = 0; e1 < i; ++e1)t1[e1] = n[r[e1]];
                                        return t1;
                                    },
                                    enumerable: !0
                                }), l.pointer = function(e1, a, o, s) {
                                    e1 = e1 || t1.FLOAT, a = !!a, o = o || i * i, s = s || 0;
                                    for(var l = 0; l < i; ++l){
                                        var c = n[r[l]];
                                        t1.vertexAttribPointer(c, i, e1, a, o, s + l * i), t1.enableVertexAttribArray(c);
                                    }
                                };
                                var h = new Array(i), f = t1["vertexAttrib" + i + "fv"];
                                Object.defineProperty(a, o, {
                                    set: function(e1) {
                                        for(var a = 0; a < i; ++a){
                                            var o = n[r[a]];
                                            if (t1.disableVertexAttribArray(o), Array.isArray(e1[0])) f.call(t1, o, e1[a]);
                                            else {
                                                for(var s = 0; s < i; ++s)h[s] = e1[i * a + s];
                                                f.call(t1, o, h);
                                            }
                                        }
                                        return e1;
                                    },
                                    get: function() {
                                        return l;
                                    },
                                    enumerable: !0
                                });
                            }
                        },
                        3327: function(t1, e1, r) {
                            "use strict";
                            var n = r(216), i = r(8866);
                            function a(t1) {
                                return function() {
                                    return t1;
                                };
                            }
                            function o(t1, e1) {
                                for(var r = new Array(t1), n = 0; n < t1; ++n)r[n] = e1;
                                return r;
                            }
                            t1.exports = function(t1, e1, r, s) {
                                function l(e1) {
                                    return function(n) {
                                        for(var a = c("", e1), o = 0; o < a.length; ++o){
                                            var l = a[o], u = l[0], h = l[1];
                                            if (s[h]) {
                                                var f = n;
                                                if ("string" == typeof u && (0 === u.indexOf(".") || 0 === u.indexOf("["))) {
                                                    var p = u;
                                                    if (0 === u.indexOf(".") && (p = u.slice(1)), p.indexOf("]") === p.length - 1) {
                                                        var d = p.indexOf("["), m = p.slice(0, d), g = p.slice(d + 1, p.length - 1);
                                                        f = m ? n[m][g] : n[g];
                                                    } else f = n[p];
                                                }
                                                var y, v = r[h].type;
                                                switch(v){
                                                    case "bool":
                                                    case "int":
                                                    case "sampler2D":
                                                    case "samplerCube":
                                                        t1.uniform1i(s[h], f);
                                                        break;
                                                    case "float":
                                                        t1.uniform1f(s[h], f);
                                                        break;
                                                    default:
                                                        var x = v.indexOf("vec");
                                                        if (!(0 <= x && x <= 1 && v.length === 4 + x)) {
                                                            if (0 === v.indexOf("mat") && 4 === v.length) {
                                                                if ((y = v.charCodeAt(v.length - 1) - 48) < 2 || y > 4) throw new i("", "Invalid uniform dimension type for matrix " + name + ": " + v);
                                                                t1["uniformMatrix" + y + "fv"](s[h], !1, f);
                                                                break;
                                                            }
                                                            throw new i("", "Unknown uniform data type for " + name + ": " + v);
                                                        }
                                                        if ((y = v.charCodeAt(v.length - 1) - 48) < 2 || y > 4) throw new i("", "Invalid data type");
                                                        switch(v.charAt(0)){
                                                            case "b":
                                                            case "i":
                                                                t1["uniform" + y + "iv"](s[h], f);
                                                                break;
                                                            case "v":
                                                                t1["uniform" + y + "fv"](s[h], f);
                                                                break;
                                                            default:
                                                                throw new i("", "Unrecognized data type for vector " + name + ": " + v);
                                                        }
                                                }
                                            }
                                        }
                                    };
                                }
                                function c(t1, e1) {
                                    if ("object" != typeof e1) return [
                                        [
                                            t1,
                                            e1
                                        ]
                                    ];
                                    var r = [];
                                    for(var n in e1){
                                        var i = e1[n], a = t1;
                                        parseInt(n) + "" === n ? a += "[" + n + "]" : a += "." + n, "object" == typeof i ? r.push.apply(r, c(a, i)) : r.push([
                                            a,
                                            i
                                        ]);
                                    }
                                    return r;
                                }
                                function u(t1, e1, n) {
                                    if ("object" == typeof n) {
                                        var c = h(n);
                                        Object.defineProperty(t1, e1, {
                                            get: a(c),
                                            set: l(n),
                                            enumerable: !0,
                                            configurable: !1
                                        });
                                    } else s[n] ? Object.defineProperty(t1, e1, {
                                        get: (u = n, function(t1, e1, r) {
                                            return t1.getUniform(e1.program, r[u]);
                                        }),
                                        set: l(n),
                                        enumerable: !0,
                                        configurable: !1
                                    }) : t1[e1] = function(t1) {
                                        switch(t1){
                                            case "bool":
                                                return !1;
                                            case "int":
                                            case "sampler2D":
                                            case "samplerCube":
                                            case "float":
                                                return 0;
                                            default:
                                                var e1 = t1.indexOf("vec");
                                                if (0 <= e1 && e1 <= 1 && t1.length === 4 + e1) {
                                                    if ((r = t1.charCodeAt(t1.length - 1) - 48) < 2 || r > 4) throw new i("", "Invalid data type");
                                                    return "b" === t1.charAt(0) ? o(r, !1) : o(r, 0);
                                                }
                                                if (0 === t1.indexOf("mat") && 4 === t1.length) {
                                                    var r;
                                                    if ((r = t1.charCodeAt(t1.length - 1) - 48) < 2 || r > 4) throw new i("", "Invalid uniform dimension type for matrix " + name + ": " + t1);
                                                    return o(r * r, 0);
                                                }
                                                throw new i("", "Unknown uniform data type for " + name + ": " + t1);
                                        }
                                    }(r[n].type);
                                    var u;
                                }
                                function h(t1) {
                                    var e1;
                                    if (Array.isArray(t1)) {
                                        e1 = new Array(t1.length);
                                        for(var r = 0; r < t1.length; ++r)u(e1, r, t1[r]);
                                    } else for(var n in e1 = {}, t1)u(e1, n, t1[n]);
                                    return e1;
                                }
                                var f = n(r, !0);
                                return {
                                    get: a(h(f)),
                                    set: l(f),
                                    enumerable: !0,
                                    configurable: !0
                                };
                            };
                        },
                        216: function(t1) {
                            "use strict";
                            t1.exports = function(t1, e1) {
                                for(var r = {}, n = 0; n < t1.length; ++n)for(var i = t1[n].name.split("."), a = r, o = 0; o < i.length; ++o){
                                    var s = i[o].split("[");
                                    if (s.length > 1) {
                                        s[0] in a || (a[s[0]] = []), a = a[s[0]];
                                        for(var l = 1; l < s.length; ++l){
                                            var c = parseInt(s[l]);
                                            l < s.length - 1 || o < i.length - 1 ? (c in a || (l < s.length - 1 ? a[c] = [] : a[c] = {}), a = a[c]) : a[c] = e1 ? n : t1[n].type;
                                        }
                                    } else o < i.length - 1 ? (s[0] in a || (a[s[0]] = {}), a = a[s[0]]) : a[s[0]] = e1 ? n : t1[n].type;
                                }
                                return r;
                            };
                        },
                        2145: function(t1, e1) {
                            "use strict";
                            e1.uniforms = function(t1, e1) {
                                for(var r = t1.getProgramParameter(e1, t1.ACTIVE_UNIFORMS), n = [], a = 0; a < r; ++a){
                                    var o = t1.getActiveUniform(e1, a);
                                    if (o) {
                                        var s = i(t1, o.type);
                                        if (o.size > 1) for(var l = 0; l < o.size; ++l)n.push({
                                            name: o.name.replace("[0]", "[" + l + "]"),
                                            type: s
                                        });
                                        else n.push({
                                            name: o.name,
                                            type: s
                                        });
                                    }
                                }
                                return n;
                            }, e1.attributes = function(t1, e1) {
                                for(var r = t1.getProgramParameter(e1, t1.ACTIVE_ATTRIBUTES), n = [], a = 0; a < r; ++a){
                                    var o = t1.getActiveAttrib(e1, a);
                                    o && n.push({
                                        name: o.name,
                                        type: i(t1, o.type)
                                    });
                                }
                                return n;
                            };
                            var r = {
                                FLOAT: "float",
                                FLOAT_VEC2: "vec2",
                                FLOAT_VEC3: "vec3",
                                FLOAT_VEC4: "vec4",
                                INT: "int",
                                INT_VEC2: "ivec2",
                                INT_VEC3: "ivec3",
                                INT_VEC4: "ivec4",
                                BOOL: "bool",
                                BOOL_VEC2: "bvec2",
                                BOOL_VEC3: "bvec3",
                                BOOL_VEC4: "bvec4",
                                FLOAT_MAT2: "mat2",
                                FLOAT_MAT3: "mat3",
                                FLOAT_MAT4: "mat4",
                                SAMPLER_2D: "sampler2D",
                                SAMPLER_CUBE: "samplerCube"
                            }, n = null;
                            function i(t1, e1) {
                                if (!n) {
                                    var i = Object.keys(r);
                                    n = {};
                                    for(var a = 0; a < i.length; ++a){
                                        var o = i[a];
                                        n[t1[o]] = r[o];
                                    }
                                }
                                return n[e1];
                            }
                        },
                        5091: function(t1, e1, r) {
                            "use strict";
                            e1.shader = function(t1, e1, r) {
                                return u(t1).getShaderReference(e1, r);
                            }, e1.program = function(t1, e1, r, n, i) {
                                return u(t1).getProgram(e1, r, n, i);
                            };
                            var n = r(8866), i = r(2992), a = new ("undefined" == typeof WeakMap ? r(606) : WeakMap), o = 0;
                            function s(t1, e1, r, n, i, a, o) {
                                this.id = t1, this.src = e1, this.type = r, this.shader = n, this.count = a, this.programs = [], this.cache = o;
                            }
                            function l(t1) {
                                this.gl = t1, this.shaders = [
                                    {},
                                    {}
                                ], this.programs = {};
                            }
                            s.prototype.dispose = function() {
                                if (0 == --this.count) {
                                    for(var t1 = this.cache, e1 = t1.gl, r = this.programs, n = 0, i = r.length; n < i; ++n){
                                        var a = t1.programs[r[n]];
                                        a && (delete t1.programs[n], e1.deleteProgram(a));
                                    }
                                    e1.deleteShader(this.shader), delete t1.shaders[this.type === e1.FRAGMENT_SHADER | 0][this.src];
                                }
                            };
                            var c = l.prototype;
                            function u(t1) {
                                var e1 = a.get(t1);
                                return e1 || (e1 = new l(t1), a.set(t1, e1)), e1;
                            }
                            c.getShaderReference = function(t1, e1) {
                                var r = this.gl, a = this.shaders[t1 === r.FRAGMENT_SHADER | 0], l = a[e1];
                                if (l && r.isShader(l.shader)) l.count += 1;
                                else {
                                    var c = function(t1, e1, r) {
                                        var a = t1.createShader(e1);
                                        if (t1.shaderSource(a, r), t1.compileShader(a), !t1.getShaderParameter(a, t1.COMPILE_STATUS)) {
                                            var o = t1.getShaderInfoLog(a);
                                            try {
                                                var s = i(o, r, e1);
                                            } catch (t1) {
                                                throw console.warn("Failed to format compiler error: " + t1), new n(o, "Error compiling shader:\n" + o);
                                            }
                                            throw new n(o, s.short, s.long);
                                        }
                                        return a;
                                    }(r, t1, e1);
                                    l = a[e1] = new s(o++, e1, t1, c, [], 1, this);
                                }
                                return l;
                            }, c.getProgram = function(t1, e1, r, i) {
                                var a = [
                                    t1.id,
                                    e1.id,
                                    r.join(":"),
                                    i.join(":")
                                ].join("@"), o = this.programs[a];
                                return o && this.gl.isProgram(o) || (this.programs[a] = o = function(t1, e1, r, i, a) {
                                    var o = t1.createProgram();
                                    t1.attachShader(o, e1), t1.attachShader(o, r);
                                    for(var s = 0; s < i.length; ++s)t1.bindAttribLocation(o, a[s], i[s]);
                                    if (t1.linkProgram(o), !t1.getProgramParameter(o, t1.LINK_STATUS)) {
                                        var l = t1.getProgramInfoLog(o);
                                        throw new n(l, "Error linking program: " + l);
                                    }
                                    return o;
                                }(this.gl, t1.shader, e1.shader, r, i), t1.programs.push(a), e1.programs.push(a)), o;
                            };
                        },
                        4098: function(t1) {
                            "use strict";
                            function e1(t1) {
                                this.plot = t1, this.enable = [
                                    !0,
                                    !0,
                                    !1,
                                    !1
                                ], this.width = [
                                    1,
                                    1,
                                    1,
                                    1
                                ], this.color = [
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ]
                                ], this.center = [
                                    1 / 0,
                                    1 / 0
                                ];
                            }
                            t1.exports = function(t1, r) {
                                var n = new e1(t1);
                                return n.update(r), t1.addOverlay(n), n;
                            };
                            var r = e1.prototype;
                            r.update = function(t1) {
                                t1 = t1 || {}, this.enable = (t1.enable || [
                                    !0,
                                    !0,
                                    !1,
                                    !1
                                ]).slice(), this.width = (t1.width || [
                                    1,
                                    1,
                                    1,
                                    1
                                ]).slice(), this.color = (t1.color || [
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ]
                                ]).map(function(t1) {
                                    return t1.slice();
                                }), this.center = (t1.center || [
                                    1 / 0,
                                    1 / 0
                                ]).slice(), this.plot.setOverlayDirty();
                            }, r.draw = function() {
                                var t1 = this.enable, e1 = this.width, r = this.color, n = this.center, i = this.plot, a = i.line, o = i.dataBox, s = i.viewBox;
                                if (a.bind(), o[0] <= n[0] && n[0] <= o[2] && o[1] <= n[1] && n[1] <= o[3]) {
                                    var l = s[0] + (n[0] - o[0]) / (o[2] - o[0]) * (s[2] - s[0]), c = s[1] + (n[1] - o[1]) / (o[3] - o[1]) * (s[3] - s[1]);
                                    t1[0] && a.drawLine(l, c, s[0], c, e1[0], r[0]), t1[1] && a.drawLine(l, c, l, s[1], e1[1], r[1]), t1[2] && a.drawLine(l, c, s[2], c, e1[2], r[2]), t1[3] && a.drawLine(l, c, l, s[3], e1[3], r[3]);
                                }
                            }, r.dispose = function() {
                                this.plot.removeOverlay(this);
                            };
                        },
                        1493: function(t1, e1, r) {
                            "use strict";
                            var n = r(3236), i = r(9405), a = n([
                                "precision mediump float;\n#define GLSLIFY 1\n\nattribute vec3 position, color;\nattribute float weight;\n\nuniform mat4 model, view, projection;\nuniform vec3 coordinates[3];\nuniform vec4 colors[3];\nuniform vec2 screenShape;\nuniform float lineWidth;\n\nvarying vec4 fragColor;\n\nvoid main() {\n  vec3 vertexPosition = mix(coordinates[0],\n    mix(coordinates[2], coordinates[1], 0.5 * (position + 1.0)), abs(position));\n\n  vec4 clipPos = projection * (view * (model * vec4(vertexPosition, 1.0)));\n  vec2 clipOffset = (projection * (view * (model * vec4(color, 0.0)))).xy;\n  vec2 delta = weight * clipOffset * screenShape;\n  vec2 lineOffset = normalize(vec2(delta.y, -delta.x)) / screenShape;\n\n  gl_Position   = vec4(clipPos.xy + clipPos.w * 0.5 * lineWidth * lineOffset, clipPos.z, clipPos.w);\n  fragColor     = color.x * colors[0] + color.y * colors[1] + color.z * colors[2];\n}\n"
                            ]), o = n([
                                "precision mediump float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor;\n\nvoid main() {\n  gl_FragColor = fragColor;\n}"
                            ]);
                            t1.exports = function(t1) {
                                return i(t1, a, o, null, [
                                    {
                                        name: "position",
                                        type: "vec3"
                                    },
                                    {
                                        name: "color",
                                        type: "vec3"
                                    },
                                    {
                                        name: "weight",
                                        type: "float"
                                    }
                                ]);
                            };
                        },
                        4449: function(t1, e1, r) {
                            "use strict";
                            var n = r(2762), i = r(8116), a = r(1493);
                            t1.exports = function(t1, e1) {
                                var r = [];
                                function o(t1, e1, n, i, a, o) {
                                    var s = [
                                        t1,
                                        e1,
                                        n,
                                        0,
                                        0,
                                        0,
                                        1
                                    ];
                                    s[i + 3] = 1, s[i] = a, r.push.apply(r, s), s[6] = -1, r.push.apply(r, s), s[i] = o, r.push.apply(r, s), r.push.apply(r, s), s[6] = 1, r.push.apply(r, s), s[i] = a, r.push.apply(r, s);
                                }
                                o(0, 0, 0, 0, 0, 1), o(0, 0, 0, 1, 0, 1), o(0, 0, 0, 2, 0, 1), o(1, 0, 0, 1, -1, 1), o(1, 0, 0, 2, -1, 1), o(0, 1, 0, 0, -1, 1), o(0, 1, 0, 2, -1, 1), o(0, 0, 1, 0, -1, 1), o(0, 0, 1, 1, -1, 1);
                                var l = n(t1, r), c = i(t1, [
                                    {
                                        type: t1.FLOAT,
                                        buffer: l,
                                        size: 3,
                                        offset: 0,
                                        stride: 28
                                    },
                                    {
                                        type: t1.FLOAT,
                                        buffer: l,
                                        size: 3,
                                        offset: 12,
                                        stride: 28
                                    },
                                    {
                                        type: t1.FLOAT,
                                        buffer: l,
                                        size: 1,
                                        offset: 24,
                                        stride: 28
                                    }
                                ]), u = a(t1);
                                u.attributes.position.location = 0, u.attributes.color.location = 1, u.attributes.weight.location = 2;
                                var h = new s(t1, l, c, u);
                                return h.update(e1), h;
                            };
                            var o = [
                                1,
                                0,
                                0,
                                0,
                                0,
                                1,
                                0,
                                0,
                                0,
                                0,
                                1,
                                0,
                                0,
                                0,
                                0,
                                1
                            ];
                            function s(t1, e1, r, n) {
                                this.gl = t1, this.buffer = e1, this.vao = r, this.shader = n, this.pixelRatio = 1, this.bounds = [
                                    [
                                        -1000,
                                        -1000,
                                        -1000
                                    ],
                                    [
                                        1e3,
                                        1e3,
                                        1e3
                                    ]
                                ], this.position = [
                                    0,
                                    0,
                                    0
                                ], this.lineWidth = [
                                    2,
                                    2,
                                    2
                                ], this.colors = [
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ]
                                ], this.enabled = [
                                    !0,
                                    !0,
                                    !0
                                ], this.drawSides = [
                                    !0,
                                    !0,
                                    !0
                                ], this.axes = null;
                            }
                            var l = s.prototype, c = [
                                0,
                                0,
                                0
                            ], u = [
                                0,
                                0,
                                0
                            ], h = [
                                0,
                                0
                            ];
                            l.isTransparent = function() {
                                return !1;
                            }, l.drawTransparent = function(t1) {}, l.draw = function(t1) {
                                var e1 = this.gl, r = this.vao, n = this.shader;
                                r.bind(), n.bind();
                                var i, a = t1.model || o, s = t1.view || o, l = t1.projection || o;
                                this.axes && (i = this.axes.lastCubeProps.axis);
                                for(var f = c, p = u, d = 0; d < 3; ++d)i && i[d] < 0 ? (f[d] = this.bounds[0][d], p[d] = this.bounds[1][d]) : (f[d] = this.bounds[1][d], p[d] = this.bounds[0][d]);
                                for(h[0] = e1.drawingBufferWidth, h[1] = e1.drawingBufferHeight, n.uniforms.model = a, n.uniforms.view = s, n.uniforms.projection = l, n.uniforms.coordinates = [
                                    this.position,
                                    f,
                                    p
                                ], n.uniforms.colors = this.colors, n.uniforms.screenShape = h, d = 0; d < 3; ++d)n.uniforms.lineWidth = this.lineWidth[d] * this.pixelRatio, this.enabled[d] && (r.draw(e1.TRIANGLES, 6, 6 * d), this.drawSides[d] && r.draw(e1.TRIANGLES, 12, 18 + 12 * d));
                                r.unbind();
                            }, l.update = function(t1) {
                                t1 && ("bounds" in t1 && (this.bounds = t1.bounds), "position" in t1 && (this.position = t1.position), "lineWidth" in t1 && (this.lineWidth = t1.lineWidth), "colors" in t1 && (this.colors = t1.colors), "enabled" in t1 && (this.enabled = t1.enabled), "drawSides" in t1 && (this.drawSides = t1.drawSides));
                            }, l.dispose = function() {
                                this.vao.dispose(), this.buffer.dispose(), this.shader.dispose();
                            };
                        },
                        6740: function(t1, e1, r) {
                            var n = r(3236), i = n([
                                "precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the tube vertex and normal at the given index.\n//\n// The returned vertex is for a tube ring with its center at origin, radius of length(d), pointing in the direction of d.\n//\n// Each tube segment is made up of a ring of vertices.\n// These vertices are used to make up the triangles of the tube by connecting them together in the vertex array.\n// The indexes of tube segments run from 0 to 8.\n//\nvec3 getTubePosition(vec3 d, float index, out vec3 normal) {\n  float segmentCount = 8.0;\n\n  float angle = 2.0 * 3.14159 * (index / segmentCount);\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d);\n  vec3 y = v * sin(angle) * length(d);\n  vec3 v3 = x + y;\n\n  normal = normalize(v3);\n\n  return v3;\n}\n\nattribute vec4 vector;\nattribute vec4 color, position;\nattribute vec2 uv;\n\nuniform float vectorScale, tubeScale;\nuniform mat4 model, view, projection, inverseModel;\nuniform vec3 eyePosition, lightPosition;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  // Scale the vector magnitude to stay constant with\n  // model & view changes.\n  vec3 normal;\n  vec3 XYZ = getTubePosition(mat3(model) * (tubeScale * vector.w * normalize(vector.xyz)), position.w, normal);\n  vec4 tubePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * tubePosition;\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  f_lightDirection = lightPosition - cameraCoordinate.xyz;\n  f_eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  f_normal = normalize((vec4(normal, 0.0) * inverseModel).xyz);\n\n  // vec4 m_position  = model * vec4(tubePosition, 1.0);\n  vec4 t_position  = view * tubePosition;\n  gl_Position      = projection * t_position;\n\n  f_color          = color;\n  f_data           = tubePosition.xyz;\n  f_position       = position.xyz;\n  f_uv             = uv;\n}\n"
                            ]), a = n([
                                "#extension GL_OES_standard_derivatives : enable\n\nprecision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat cookTorranceSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness,\n  float fresnel) {\n\n  float VdotN = max(dot(viewDirection, surfaceNormal), 0.0);\n  float LdotN = max(dot(lightDirection, surfaceNormal), 0.0);\n\n  //Half angle vector\n  vec3 H = normalize(lightDirection + viewDirection);\n\n  //Geometric term\n  float NdotH = max(dot(surfaceNormal, H), 0.0);\n  float VdotH = max(dot(viewDirection, H), 0.000001);\n  float LdotH = max(dot(lightDirection, H), 0.000001);\n  float G1 = (2.0 * NdotH * VdotN) / VdotH;\n  float G2 = (2.0 * NdotH * LdotN) / LdotH;\n  float G = min(1.0, min(G1, G2));\n  \n  //Distribution term\n  float D = beckmannDistribution(NdotH, roughness);\n\n  //Fresnel term\n  float F = pow(1.0 - VdotN, fresnel);\n\n  //Multiply terms and done\n  return  G * F * D / max(3.14159265 * VdotN, 0.000001);\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float roughness, fresnel, kambient, kdiffuse, kspecular, opacity;\nuniform sampler2D texture;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n  vec3 N = normalize(f_normal);\n  vec3 L = normalize(f_lightDirection);\n  vec3 V = normalize(f_eyeDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = min(1.0, max(0.0, cookTorranceSpecular(L, V, N, roughness, fresnel)));\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  vec4 surfaceColor = f_color * texture2D(texture, f_uv);\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = litColor * opacity;\n}\n"
                            ]), o = n([
                                "precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the tube vertex and normal at the given index.\n//\n// The returned vertex is for a tube ring with its center at origin, radius of length(d), pointing in the direction of d.\n//\n// Each tube segment is made up of a ring of vertices.\n// These vertices are used to make up the triangles of the tube by connecting them together in the vertex array.\n// The indexes of tube segments run from 0 to 8.\n//\nvec3 getTubePosition(vec3 d, float index, out vec3 normal) {\n  float segmentCount = 8.0;\n\n  float angle = 2.0 * 3.14159 * (index / segmentCount);\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d);\n  vec3 y = v * sin(angle) * length(d);\n  vec3 v3 = x + y;\n\n  normal = normalize(v3);\n\n  return v3;\n}\n\nattribute vec4 vector;\nattribute vec4 position;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\nuniform float tubeScale;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  vec3 normal;\n  vec3 XYZ = getTubePosition(mat3(model) * (tubeScale * vector.w * normalize(vector.xyz)), position.w, normal);\n  vec4 tubePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n\n  gl_Position = projection * (view * tubePosition);\n  f_id        = id;\n  f_position  = position.xyz;\n}\n"
                            ]), s = n([
                                "precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3  clipBounds[2];\nuniform float pickId;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n\n  gl_FragColor = vec4(pickId, f_id.xyz);\n}"
                            ]);
                            e1.meshShader = {
                                vertex: i,
                                fragment: a,
                                attributes: [
                                    {
                                        name: "position",
                                        type: "vec4"
                                    },
                                    {
                                        name: "color",
                                        type: "vec4"
                                    },
                                    {
                                        name: "uv",
                                        type: "vec2"
                                    },
                                    {
                                        name: "vector",
                                        type: "vec4"
                                    }
                                ]
                            }, e1.pickShader = {
                                vertex: o,
                                fragment: s,
                                attributes: [
                                    {
                                        name: "position",
                                        type: "vec4"
                                    },
                                    {
                                        name: "id",
                                        type: "vec4"
                                    },
                                    {
                                        name: "vector",
                                        type: "vec4"
                                    }
                                ]
                            };
                        },
                        7815: function(t1, e1, r) {
                            "use strict";
                            var n = r(2931), i = r(9970), a = [
                                "xyz",
                                "xzy",
                                "yxz",
                                "yzx",
                                "zxy",
                                "zyx"
                            ], o = function(t1, e1) {
                                var r, n = t1.length;
                                for(r = 0; r < n; r++){
                                    var i = t1[r];
                                    if (i === e1) return r;
                                    if (i > e1) return r - 1;
                                }
                                return r;
                            }, s = function(t1, e1, r) {
                                return t1 < e1 ? e1 : t1 > r ? r : t1;
                            }, l = function(t1) {
                                var e1 = 1 / 0;
                                t1.sort(function(t1, e1) {
                                    return t1 - e1;
                                });
                                for(var r = t1.length, n = 1; n < r; n++){
                                    var i = Math.abs(t1[n] - t1[n - 1]);
                                    i < e1 && (e1 = i);
                                }
                                return e1;
                            };
                            t1.exports = function(t1, e1) {
                                var r = t1.startingPositions, c = t1.maxLength || 1e3, u = t1.tubeSize || 1, h = t1.absoluteTubeSize, f = t1.gridFill || "+x+y+z", p = {};
                                -1 !== f.indexOf("-x") && (p.reversedX = !0), -1 !== f.indexOf("-y") && (p.reversedY = !0), -1 !== f.indexOf("-z") && (p.reversedZ = !0), p.filled = a.indexOf(f.replace(/-/g, "").replace(/\+/g, ""));
                                var d = t1.getVelocity || function(e1) {
                                    return function(t1, e1, r) {
                                        var i = e1.vectors, a = e1.meshgrid, l = t1[0], c = t1[1], u = t1[2], h = a[0].length, f = a[1].length, p = a[2].length, d = o(a[0], l), m = o(a[1], c), g = o(a[2], u), y = d + 1, v = m + 1, x = g + 1;
                                        if (d = s(d, 0, h - 1), y = s(y, 0, h - 1), m = s(m, 0, f - 1), v = s(v, 0, f - 1), g = s(g, 0, p - 1), x = s(x, 0, p - 1), d < 0 || m < 0 || g < 0 || y > h - 1 || v > f - 1 || x > p - 1) return n.create();
                                        var _, b, w, T, k, A, M = a[0][d], S = a[0][y], E = a[1][m], C = a[1][v], L = a[2][g], I = (l - M) / (S - M), P = (c - E) / (C - E), z = (u - L) / (a[2][x] - L);
                                        switch(isFinite(I) || (I = .5), isFinite(P) || (P = .5), isFinite(z) || (z = .5), r.reversedX && (d = h - 1 - d, y = h - 1 - y), r.reversedY && (m = f - 1 - m, v = f - 1 - v), r.reversedZ && (g = p - 1 - g, x = p - 1 - x), r.filled){
                                            case 5:
                                                k = g, A = x, w = m * p, T = v * p, _ = d * p * f, b = y * p * f;
                                                break;
                                            case 4:
                                                k = g, A = x, _ = d * p, b = y * p, w = m * p * h, T = v * p * h;
                                                break;
                                            case 3:
                                                w = m, T = v, k = g * f, A = x * f, _ = d * f * p, b = y * f * p;
                                                break;
                                            case 2:
                                                w = m, T = v, _ = d * f, b = y * f, k = g * f * h, A = x * f * h;
                                                break;
                                            case 1:
                                                _ = d, b = y, k = g * h, A = x * h, w = m * h * p, T = v * h * p;
                                                break;
                                            default:
                                                _ = d, b = y, w = m * h, T = v * h, k = g * h * f, A = x * h * f;
                                        }
                                        var O = i[_ + w + k], D = i[_ + w + A], R = i[_ + T + k], F = i[_ + T + A], B = i[b + w + k], N = i[b + w + A], j = i[b + T + k], U = i[b + T + A], V = n.create(), q = n.create(), H = n.create(), G = n.create();
                                        n.lerp(V, O, B, I), n.lerp(q, D, N, I), n.lerp(H, R, j, I), n.lerp(G, F, U, I);
                                        var Z = n.create(), W = n.create();
                                        n.lerp(Z, V, H, P), n.lerp(W, q, G, P);
                                        var Y = n.create();
                                        return n.lerp(Y, Z, W, z), Y;
                                    }(e1, t1, p);
                                }, m = t1.getDivergence || function(t1, e1) {
                                    var r = n.create(), i = 1e-4;
                                    n.add(r, t1, [
                                        i,
                                        0,
                                        0
                                    ]);
                                    var a = d(r);
                                    n.subtract(a, a, e1), n.scale(a, a, 1 / i), n.add(r, t1, [
                                        0,
                                        i,
                                        0
                                    ]);
                                    var o = d(r);
                                    n.subtract(o, o, e1), n.scale(o, o, 1 / i), n.add(r, t1, [
                                        0,
                                        0,
                                        i
                                    ]);
                                    var s = d(r);
                                    return n.subtract(s, s, e1), n.scale(s, s, 1 / i), n.add(r, a, o), n.add(r, r, s), r;
                                }, g = [], y = e1[0][0], v = e1[0][1], x = e1[0][2], _ = e1[1][0], b = e1[1][1], w = e1[1][2], T = function(t1) {
                                    var e1 = t1[0], r = t1[1], n = t1[2];
                                    return !(e1 < y || e1 > _ || r < v || r > b || n < x || n > w);
                                }, k = 10 * n.distance(e1[0], e1[1]) / c, A = k * k, M = 1, S = 0, E = r.length;
                                E > 1 && (M = function(t1) {
                                    for(var e1 = [], r = [], n = [], i = {}, a = {}, o = {}, s = t1.length, c = 0; c < s; c++){
                                        var u = t1[c], h = u[0], f = u[1], p = u[2];
                                        i[h] || (e1.push(h), i[h] = !0), a[f] || (r.push(f), a[f] = !0), o[p] || (n.push(p), o[p] = !0);
                                    }
                                    var d = l(e1), m = l(r), g = l(n), y = Math.min(d, m, g);
                                    return isFinite(y) ? y : 1;
                                }(r));
                                for(var C = 0; C < E; C++){
                                    var L = n.create();
                                    n.copy(L, r[C]);
                                    var I = [
                                        L
                                    ], P = [], z = d(L), O = L;
                                    P.push(z);
                                    var D = [], R = m(L, z), F = n.length(R);
                                    isFinite(F) && F > S && (S = F), D.push(F), g.push({
                                        points: I,
                                        velocities: P,
                                        divergences: D
                                    });
                                    for(var B = 0; B < 100 * c && I.length < c && T(L);){
                                        B++;
                                        var N = n.clone(z), j = n.squaredLength(N);
                                        if (0 === j) break;
                                        j > A && n.scale(N, N, k / Math.sqrt(j)), n.add(N, N, L), z = d(N), n.squaredDistance(O, N) - A > -0.0001 * A && (I.push(N), O = N, P.push(z), R = m(N, z), F = n.length(R), isFinite(F) && F > S && (S = F), D.push(F)), L = N;
                                    }
                                }
                                var U = function(t1, e1, r, a) {
                                    for(var o = 0, s = 0; s < t1.length; s++)for(var l = t1[s].velocities, c = 0; c < l.length; c++)o = Math.max(o, n.length(l[c]));
                                    var u = t1.map(function(t1) {
                                        return function(t1, e1, r, a) {
                                            for(var o = t1.points, s = t1.velocities, l = t1.divergences, c = [], u = [], h = [], f = [], p = [], d = [], m = 0, g = 0, y = i.create(), v = i.create(), x = 0; x < o.length; x++){
                                                var _ = o[x], b = s[x], w = l[x];
                                                0 === e1 && (w = .05 * r), g = n.length(b) / a, y = i.create(), n.copy(y, b), y[3] = w;
                                                for(var T = 0; T < 8; T++)p[T] = [
                                                    _[0],
                                                    _[1],
                                                    _[2],
                                                    T
                                                ];
                                                if (f.length > 0) for(T = 0; T < 8; T++){
                                                    var k = (T + 1) % 8;
                                                    c.push(f[T], p[T], p[k], p[k], f[k], f[T]), h.push(v, y, y, y, v, v), d.push(m, g, g, g, m, m);
                                                    var A = c.length;
                                                    u.push([
                                                        A - 6,
                                                        A - 5,
                                                        A - 4
                                                    ], [
                                                        A - 3,
                                                        A - 2,
                                                        A - 1
                                                    ]);
                                                }
                                                var M = f;
                                                f = p, p = M;
                                                var S = v;
                                                v = y, y = S;
                                                var E = m;
                                                m = g, g = E;
                                            }
                                            return {
                                                positions: c,
                                                cells: u,
                                                vectors: h,
                                                vertexIntensity: d
                                            };
                                        }(t1, r, a, o);
                                    }), h = [], f = [], p = [], d = [];
                                    for(s = 0; s < u.length; s++){
                                        var m = u[s], g = h.length;
                                        for(h = h.concat(m.positions), p = p.concat(m.vectors), d = d.concat(m.vertexIntensity), c = 0; c < m.cells.length; c++){
                                            var y = m.cells[c], v = [];
                                            f.push(v);
                                            for(var x = 0; x < y.length; x++)v.push(y[x] + g);
                                        }
                                    }
                                    return {
                                        positions: h,
                                        cells: f,
                                        vectors: p,
                                        vertexIntensity: d,
                                        colormap: e1
                                    };
                                }(g, t1.colormap, S, M);
                                return h ? U.tubeScale = h : (0 === S && (S = 1), U.tubeScale = .5 * u * M / S), U;
                            };
                            var c = r(6740), u = r(6405).createMesh;
                            t1.exports.createTubeMesh = function(t1, e1) {
                                return u(t1, e1, {
                                    shaders: c,
                                    traceType: "streamtube"
                                });
                            };
                        },
                        990: function(t1, e1, r) {
                            var n = r(9405), i = r(3236), a = i([
                                "precision highp float;\n#define GLSLIFY 1\n\nattribute vec4 uv;\nattribute vec3 f;\nattribute vec3 normal;\n\nuniform vec3 objectOffset;\nuniform mat4 model, view, projection, inverseModel;\nuniform vec3 lightPosition, eyePosition;\nuniform sampler2D colormap;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec2 planeCoordinate;\nvarying vec3 lightDirection, eyeDirection, surfaceNormal;\nvarying vec4 vColor;\n\nvoid main() {\n  vec3 localCoordinate = vec3(uv.zw, f.x);\n  worldCoordinate = objectOffset + localCoordinate;\n  mat4 objectOffsetTranslation = mat4(1.0) + mat4(vec4(0), vec4(0), vec4(0), vec4(objectOffset, 0));\n  vec4 worldPosition = (model * objectOffsetTranslation) * vec4(localCoordinate, 1.0);\n  vec4 clipPosition = projection * (view * worldPosition);\n  gl_Position = clipPosition;\n  kill = f.y;\n  value = f.z;\n  planeCoordinate = uv.xy;\n\n  vColor = texture2D(colormap, vec2(value, value));\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * worldPosition;\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  lightDirection = lightPosition - cameraCoordinate.xyz;\n  eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  surfaceNormal  = normalize((vec4(normal,0) * inverseModel).xyz);\n}\n"
                            ]), o = i([
                                "precision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat beckmannSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness) {\n  return beckmannDistribution(dot(surfaceNormal, normalize(lightDirection + viewDirection)), roughness);\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 lowerBound, upperBound;\nuniform float contourTint;\nuniform vec4 contourColor;\nuniform sampler2D colormap;\nuniform vec3 clipBounds[2];\nuniform float roughness, fresnel, kambient, kdiffuse, kspecular, opacity;\nuniform float vertexColor;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec3 lightDirection, eyeDirection, surfaceNormal;\nvarying vec4 vColor;\n\nvoid main() {\n  if (\n    kill > 0.0 ||\n    vColor.a == 0.0 ||\n    outOfRange(clipBounds[0], clipBounds[1], worldCoordinate)\n  ) discard;\n\n  vec3 N = normalize(surfaceNormal);\n  vec3 V = normalize(eyeDirection);\n  vec3 L = normalize(lightDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = max(beckmannSpecular(L, V, N, roughness), 0.);\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  //decide how to interpolate color \u2014 in vertex or in fragment\n  vec4 surfaceColor =\n    step(vertexColor, .5) * texture2D(colormap, vec2(value, value)) +\n    step(.5, vertexColor) * vColor;\n\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = mix(litColor, contourColor, contourTint) * opacity;\n}\n"
                            ]), s = i([
                                "precision highp float;\n#define GLSLIFY 1\n\nattribute vec4 uv;\nattribute float f;\n\nuniform vec3 objectOffset;\nuniform mat3 permutation;\nuniform mat4 model, view, projection;\nuniform float height, zOffset;\nuniform sampler2D colormap;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec2 planeCoordinate;\nvarying vec3 lightDirection, eyeDirection, surfaceNormal;\nvarying vec4 vColor;\n\nvoid main() {\n  vec3 dataCoordinate = permutation * vec3(uv.xy, height);\n  worldCoordinate = objectOffset + dataCoordinate;\n  mat4 objectOffsetTranslation = mat4(1.0) + mat4(vec4(0), vec4(0), vec4(0), vec4(objectOffset, 0));\n  vec4 worldPosition = (model * objectOffsetTranslation) * vec4(dataCoordinate, 1.0);\n\n  vec4 clipPosition = projection * (view * worldPosition);\n  clipPosition.z += zOffset;\n\n  gl_Position = clipPosition;\n  value = f + objectOffset.z;\n  kill = -1.0;\n  planeCoordinate = uv.zw;\n\n  vColor = texture2D(colormap, vec2(value, value));\n\n  //Don't do lighting for contours\n  surfaceNormal   = vec3(1,0,0);\n  eyeDirection    = vec3(0,1,0);\n  lightDirection  = vec3(0,0,1);\n}\n"
                            ]), l = i([
                                "precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec2 shape;\nuniform vec3 clipBounds[2];\nuniform float pickId;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec2 planeCoordinate;\nvarying vec3 surfaceNormal;\n\nvec2 splitFloat(float v) {\n  float vh = 255.0 * v;\n  float upper = floor(vh);\n  float lower = fract(vh);\n  return vec2(upper / 255.0, floor(lower * 16.0) / 16.0);\n}\n\nvoid main() {\n  if ((kill > 0.0) ||\n      (outOfRange(clipBounds[0], clipBounds[1], worldCoordinate))) discard;\n\n  vec2 ux = splitFloat(planeCoordinate.x / shape.x);\n  vec2 uy = splitFloat(planeCoordinate.y / shape.y);\n  gl_FragColor = vec4(pickId, ux.x, uy.x, ux.y + (uy.y/16.0));\n}\n"
                            ]);
                            e1.createShader = function(t1) {
                                var e1 = n(t1, a, o, null, [
                                    {
                                        name: "uv",
                                        type: "vec4"
                                    },
                                    {
                                        name: "f",
                                        type: "vec3"
                                    },
                                    {
                                        name: "normal",
                                        type: "vec3"
                                    }
                                ]);
                                return e1.attributes.uv.location = 0, e1.attributes.f.location = 1, e1.attributes.normal.location = 2, e1;
                            }, e1.createPickShader = function(t1) {
                                var e1 = n(t1, a, l, null, [
                                    {
                                        name: "uv",
                                        type: "vec4"
                                    },
                                    {
                                        name: "f",
                                        type: "vec3"
                                    },
                                    {
                                        name: "normal",
                                        type: "vec3"
                                    }
                                ]);
                                return e1.attributes.uv.location = 0, e1.attributes.f.location = 1, e1.attributes.normal.location = 2, e1;
                            }, e1.createContourShader = function(t1) {
                                var e1 = n(t1, s, o, null, [
                                    {
                                        name: "uv",
                                        type: "vec4"
                                    },
                                    {
                                        name: "f",
                                        type: "float"
                                    }
                                ]);
                                return e1.attributes.uv.location = 0, e1.attributes.f.location = 1, e1;
                            }, e1.createPickContourShader = function(t1) {
                                var e1 = n(t1, s, l, null, [
                                    {
                                        name: "uv",
                                        type: "vec4"
                                    },
                                    {
                                        name: "f",
                                        type: "float"
                                    }
                                ]);
                                return e1.attributes.uv.location = 0, e1.attributes.f.location = 1, e1;
                            };
                        },
                        9499: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1) {
                                var e1 = t1.gl, r = v(e1), n = _(e1), s = x(e1), l = b(e1), c = i(e1), u = a(e1, [
                                    {
                                        buffer: c,
                                        size: 4,
                                        stride: w,
                                        offset: 0
                                    },
                                    {
                                        buffer: c,
                                        size: 3,
                                        stride: w,
                                        offset: 16
                                    },
                                    {
                                        buffer: c,
                                        size: 3,
                                        stride: w,
                                        offset: 28
                                    }
                                ]), h = i(e1), f = a(e1, [
                                    {
                                        buffer: h,
                                        size: 4,
                                        stride: 20,
                                        offset: 0
                                    },
                                    {
                                        buffer: h,
                                        size: 1,
                                        stride: 20,
                                        offset: 16
                                    }
                                ]), p = i(e1), d = a(e1, [
                                    {
                                        buffer: p,
                                        size: 2,
                                        type: e1.FLOAT
                                    }
                                ]), m = o(e1, 1, S, e1.RGBA, e1.UNSIGNED_BYTE);
                                m.minFilter = e1.LINEAR, m.magFilter = e1.LINEAR;
                                var g = new E(e1, [
                                    0,
                                    0
                                ], [
                                    [
                                        0,
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0,
                                        0
                                    ]
                                ], r, n, c, u, m, s, l, h, f, p, d, [
                                    0,
                                    0,
                                    0
                                ]), y = {
                                    levels: [
                                        [],
                                        [],
                                        []
                                    ]
                                };
                                for(var T in t1)y[T] = t1[T];
                                return y.colormap = y.colormap || "jet", g.update(y), g;
                            };
                            var n = r(8828), i = r(2762), a = r(8116), o = r(7766), s = r(1888), l = r(6729), c = r(5298), u = r(9994), h = r(9618), f = r(3711), p = r(6760), d = r(7608), m = r(2478), g = r(6199), y = r(990), v = y.createShader, x = y.createContourShader, _ = y.createPickShader, b = y.createPickContourShader, w = 40, T = [
                                1,
                                0,
                                0,
                                0,
                                0,
                                1,
                                0,
                                0,
                                0,
                                0,
                                1,
                                0,
                                0,
                                0,
                                0,
                                1
                            ], k = [
                                [
                                    0,
                                    0
                                ],
                                [
                                    0,
                                    1
                                ],
                                [
                                    1,
                                    0
                                ],
                                [
                                    1,
                                    1
                                ],
                                [
                                    1,
                                    0
                                ],
                                [
                                    0,
                                    1
                                ]
                            ], A = [
                                [
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0
                                ],
                                [
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0
                                ],
                                [
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0
                                ]
                            ];
                            function M(t1, e1, r, n, i) {
                                this.position = t1, this.index = e1, this.uv = r, this.level = n, this.dataCoordinate = i;
                            }
                            !function() {
                                for(var t1 = 0; t1 < 3; ++t1){
                                    var e1 = A[t1], r = (t1 + 2) % 3;
                                    e1[(t1 + 1) % 3 + 0] = 1, e1[r + 3] = 1, e1[t1 + 6] = 1;
                                }
                            }();
                            var S = 256;
                            function E(t1, e1, r, n, i, a, o, l, c, u, f, p, d, m, g) {
                                this.gl = t1, this.shape = e1, this.bounds = r, this.objectOffset = g, this.intensityBounds = [], this._shader = n, this._pickShader = i, this._coordinateBuffer = a, this._vao = o, this._colorMap = l, this._contourShader = c, this._contourPickShader = u, this._contourBuffer = f, this._contourVAO = p, this._contourOffsets = [
                                    [],
                                    [],
                                    []
                                ], this._contourCounts = [
                                    [],
                                    [],
                                    []
                                ], this._vertexCount = 0, this._pickResult = new M([
                                    0,
                                    0,
                                    0
                                ], [
                                    0,
                                    0
                                ], [
                                    0,
                                    0
                                ], [
                                    0,
                                    0,
                                    0
                                ], [
                                    0,
                                    0,
                                    0
                                ]), this._dynamicBuffer = d, this._dynamicVAO = m, this._dynamicOffsets = [
                                    0,
                                    0,
                                    0
                                ], this._dynamicCounts = [
                                    0,
                                    0,
                                    0
                                ], this.contourWidth = [
                                    1,
                                    1,
                                    1
                                ], this.contourLevels = [
                                    [
                                        1
                                    ],
                                    [
                                        1
                                    ],
                                    [
                                        1
                                    ]
                                ], this.contourTint = [
                                    0,
                                    0,
                                    0
                                ], this.contourColor = [
                                    [
                                        .5,
                                        .5,
                                        .5,
                                        1
                                    ],
                                    [
                                        .5,
                                        .5,
                                        .5,
                                        1
                                    ],
                                    [
                                        .5,
                                        .5,
                                        .5,
                                        1
                                    ]
                                ], this.showContour = !0, this.showSurface = !0, this.enableHighlight = [
                                    !0,
                                    !0,
                                    !0
                                ], this.highlightColor = [
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ]
                                ], this.highlightTint = [
                                    1,
                                    1,
                                    1
                                ], this.highlightLevel = [
                                    -1,
                                    -1,
                                    -1
                                ], this.enableDynamic = [
                                    !0,
                                    !0,
                                    !0
                                ], this.dynamicLevel = [
                                    NaN,
                                    NaN,
                                    NaN
                                ], this.dynamicColor = [
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        0,
                                        0,
                                        1
                                    ]
                                ], this.dynamicTint = [
                                    1,
                                    1,
                                    1
                                ], this.dynamicWidth = [
                                    1,
                                    1,
                                    1
                                ], this.axesBounds = [
                                    [
                                        1 / 0,
                                        1 / 0,
                                        1 / 0
                                    ],
                                    [
                                        -1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ]
                                ], this.surfaceProject = [
                                    !1,
                                    !1,
                                    !1
                                ], this.contourProject = [
                                    [
                                        !1,
                                        !1,
                                        !1
                                    ],
                                    [
                                        !1,
                                        !1,
                                        !1
                                    ],
                                    [
                                        !1,
                                        !1,
                                        !1
                                    ]
                                ], this.colorBounds = [
                                    !1,
                                    !1
                                ], this._field = [
                                    h(s.mallocFloat(1024), [
                                        0,
                                        0
                                    ]),
                                    h(s.mallocFloat(1024), [
                                        0,
                                        0
                                    ]),
                                    h(s.mallocFloat(1024), [
                                        0,
                                        0
                                    ])
                                ], this.pickId = 1, this.clipBounds = [
                                    [
                                        -1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ],
                                    [
                                        1 / 0,
                                        1 / 0,
                                        1 / 0
                                    ]
                                ], this.snapToData = !1, this.pixelRatio = 1, this.opacity = 1, this.lightPosition = [
                                    10,
                                    1e4,
                                    0
                                ], this.ambientLight = .8, this.diffuseLight = .8, this.specularLight = 2, this.roughness = .5, this.fresnel = 1.5, this.vertexColor = 0, this.dirty = !0;
                            }
                            var C = E.prototype;
                            C.genColormap = function(t1, e1) {
                                var r = !1, n = u([
                                    l({
                                        colormap: t1,
                                        nshades: S,
                                        format: "rgba"
                                    }).map(function(t1, n) {
                                        var i = e1 ? function(t1, e1) {
                                            if (!e1) return 1;
                                            if (!e1.length) return 1;
                                            for(var r = 0; r < e1.length; ++r){
                                                if (e1.length < 2) return 1;
                                                if (e1[r][0] === t1) return e1[r][1];
                                                if (e1[r][0] > t1 && r > 0) {
                                                    var n = (e1[r][0] - t1) / (e1[r][0] - e1[r - 1][0]);
                                                    return e1[r][1] * (1 - n) + n * e1[r - 1][1];
                                                }
                                            }
                                            return 1;
                                        }(n / 255, e1) : t1[3];
                                        return i < 1 && (r = !0), [
                                            t1[0],
                                            t1[1],
                                            t1[2],
                                            255 * i
                                        ];
                                    })
                                ]);
                                return c.divseq(n, 255), this.hasAlphaScale = r, n;
                            }, C.isTransparent = function() {
                                return this.opacity < 1 || this.hasAlphaScale;
                            }, C.isOpaque = function() {
                                return !this.isTransparent();
                            }, C.pickSlots = 1, C.setPickBase = function(t1) {
                                this.pickId = t1;
                            };
                            var L = [
                                0,
                                0,
                                0
                            ], I = {
                                showSurface: !1,
                                showContour: !1,
                                projections: [
                                    T.slice(),
                                    T.slice(),
                                    T.slice()
                                ],
                                clipBounds: [
                                    [
                                        [
                                            0,
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0,
                                            0
                                        ]
                                    ],
                                    [
                                        [
                                            0,
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0,
                                            0
                                        ]
                                    ],
                                    [
                                        [
                                            0,
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0,
                                            0
                                        ]
                                    ]
                                ]
                            };
                            function P(t1, e1) {
                                var r, n, i, a = e1.axes && e1.axes.lastCubeProps.axis || L, o = e1.showSurface, s = e1.showContour;
                                for(r = 0; r < 3; ++r)for(o = o || e1.surfaceProject[r], n = 0; n < 3; ++n)s = s || e1.contourProject[r][n];
                                for(r = 0; r < 3; ++r){
                                    var l = I.projections[r];
                                    for(n = 0; n < 16; ++n)l[n] = 0;
                                    for(n = 0; n < 4; ++n)l[5 * n] = 1;
                                    l[5 * r] = 0, l[12 + r] = e1.axesBounds[+(a[r] > 0)][r], p(l, t1.model, l);
                                    var c = I.clipBounds[r];
                                    for(i = 0; i < 2; ++i)for(n = 0; n < 3; ++n)c[i][n] = t1.clipBounds[i][n];
                                    c[0][r] = -100000000, c[1][r] = 1e8;
                                }
                                return I.showSurface = o, I.showContour = s, I;
                            }
                            var z = {
                                model: T,
                                view: T,
                                projection: T,
                                inverseModel: T.slice(),
                                lowerBound: [
                                    0,
                                    0,
                                    0
                                ],
                                upperBound: [
                                    0,
                                    0,
                                    0
                                ],
                                colorMap: 0,
                                clipBounds: [
                                    [
                                        0,
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0,
                                        0
                                    ]
                                ],
                                height: 0,
                                contourTint: 0,
                                contourColor: [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                permutation: [
                                    1,
                                    0,
                                    0,
                                    0,
                                    1,
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                zOffset: -0.0001,
                                objectOffset: [
                                    0,
                                    0,
                                    0
                                ],
                                kambient: 1,
                                kdiffuse: 1,
                                kspecular: 1,
                                lightPosition: [
                                    1e3,
                                    1e3,
                                    1e3
                                ],
                                eyePosition: [
                                    0,
                                    0,
                                    0
                                ],
                                roughness: 1,
                                fresnel: 1,
                                opacity: 1,
                                vertexColor: 0
                            }, O = T.slice(), D = [
                                1,
                                0,
                                0,
                                0,
                                1,
                                0,
                                0,
                                0,
                                1
                            ];
                            function R(t1, e1) {
                                t1 = t1 || {};
                                var r = this.gl;
                                r.disable(r.CULL_FACE), this._colorMap.bind(0);
                                var n = z;
                                n.model = t1.model || T, n.view = t1.view || T, n.projection = t1.projection || T, n.lowerBound = [
                                    this.bounds[0][0],
                                    this.bounds[0][1],
                                    this.colorBounds[0] || this.bounds[0][2]
                                ], n.upperBound = [
                                    this.bounds[1][0],
                                    this.bounds[1][1],
                                    this.colorBounds[1] || this.bounds[1][2]
                                ], n.objectOffset = this.objectOffset, n.contourColor = this.contourColor[0], n.inverseModel = d(n.inverseModel, n.model);
                                for(var i = 0; i < 2; ++i)for(var a = n.clipBounds[i], o = 0; o < 3; ++o)a[o] = Math.min(Math.max(this.clipBounds[i][o], -100000000), 1e8);
                                n.kambient = this.ambientLight, n.kdiffuse = this.diffuseLight, n.kspecular = this.specularLight, n.roughness = this.roughness, n.fresnel = this.fresnel, n.opacity = this.opacity, n.height = 0, n.permutation = D, n.vertexColor = this.vertexColor;
                                var s = O;
                                for(p(s, n.view, n.model), p(s, n.projection, s), d(s, s), i = 0; i < 3; ++i)n.eyePosition[i] = s[12 + i] / s[15];
                                var l = s[15];
                                for(i = 0; i < 3; ++i)l += this.lightPosition[i] * s[4 * i + 3];
                                for(i = 0; i < 3; ++i){
                                    var c = s[12 + i];
                                    for(o = 0; o < 3; ++o)c += s[4 * o + i] * this.lightPosition[o];
                                    n.lightPosition[i] = c / l;
                                }
                                var u = P(n, this);
                                if (u.showSurface) {
                                    for(this._shader.bind(), this._shader.uniforms = n, this._vao.bind(), this.showSurface && this._vertexCount && this._vao.draw(r.TRIANGLES, this._vertexCount), i = 0; i < 3; ++i)this.surfaceProject[i] && this.vertexCount && (this._shader.uniforms.model = u.projections[i], this._shader.uniforms.clipBounds = u.clipBounds[i], this._vao.draw(r.TRIANGLES, this._vertexCount));
                                    this._vao.unbind();
                                }
                                if (u.showContour) {
                                    var h = this._contourShader;
                                    n.kambient = 1, n.kdiffuse = 0, n.kspecular = 0, n.opacity = 1, h.bind(), h.uniforms = n;
                                    var f = this._contourVAO;
                                    for(f.bind(), i = 0; i < 3; ++i)for(h.uniforms.permutation = A[i], r.lineWidth(this.contourWidth[i] * this.pixelRatio), o = 0; o < this.contourLevels[i].length; ++o)o === this.highlightLevel[i] ? (h.uniforms.contourColor = this.highlightColor[i], h.uniforms.contourTint = this.highlightTint[i]) : 0 !== o && o - 1 !== this.highlightLevel[i] || (h.uniforms.contourColor = this.contourColor[i], h.uniforms.contourTint = this.contourTint[i]), this._contourCounts[i][o] && (h.uniforms.height = this.contourLevels[i][o], f.draw(r.LINES, this._contourCounts[i][o], this._contourOffsets[i][o]));
                                    for(i = 0; i < 3; ++i)for(h.uniforms.model = u.projections[i], h.uniforms.clipBounds = u.clipBounds[i], o = 0; o < 3; ++o)if (this.contourProject[i][o]) {
                                        h.uniforms.permutation = A[o], r.lineWidth(this.contourWidth[o] * this.pixelRatio);
                                        for(var m = 0; m < this.contourLevels[o].length; ++m)m === this.highlightLevel[o] ? (h.uniforms.contourColor = this.highlightColor[o], h.uniforms.contourTint = this.highlightTint[o]) : 0 !== m && m - 1 !== this.highlightLevel[o] || (h.uniforms.contourColor = this.contourColor[o], h.uniforms.contourTint = this.contourTint[o]), this._contourCounts[o][m] && (h.uniforms.height = this.contourLevels[o][m], f.draw(r.LINES, this._contourCounts[o][m], this._contourOffsets[o][m]));
                                    }
                                    for(f.unbind(), (f = this._dynamicVAO).bind(), i = 0; i < 3; ++i)if (0 !== this._dynamicCounts[i]) for(h.uniforms.model = n.model, h.uniforms.clipBounds = n.clipBounds, h.uniforms.permutation = A[i], r.lineWidth(this.dynamicWidth[i] * this.pixelRatio), h.uniforms.contourColor = this.dynamicColor[i], h.uniforms.contourTint = this.dynamicTint[i], h.uniforms.height = this.dynamicLevel[i], f.draw(r.LINES, this._dynamicCounts[i], this._dynamicOffsets[i]), o = 0; o < 3; ++o)this.contourProject[o][i] && (h.uniforms.model = u.projections[o], h.uniforms.clipBounds = u.clipBounds[o], f.draw(r.LINES, this._dynamicCounts[i], this._dynamicOffsets[i]));
                                    f.unbind();
                                }
                            }
                            C.draw = function(t1) {
                                return R.call(this, t1, !1);
                            }, C.drawTransparent = function(t1) {
                                return R.call(this, t1, !0);
                            };
                            var F = {
                                model: T,
                                view: T,
                                projection: T,
                                inverseModel: T,
                                clipBounds: [
                                    [
                                        0,
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0,
                                        0
                                    ]
                                ],
                                height: 0,
                                shape: [
                                    0,
                                    0
                                ],
                                pickId: 0,
                                lowerBound: [
                                    0,
                                    0,
                                    0
                                ],
                                upperBound: [
                                    0,
                                    0,
                                    0
                                ],
                                zOffset: 0,
                                objectOffset: [
                                    0,
                                    0,
                                    0
                                ],
                                permutation: [
                                    1,
                                    0,
                                    0,
                                    0,
                                    1,
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                lightPosition: [
                                    0,
                                    0,
                                    0
                                ],
                                eyePosition: [
                                    0,
                                    0,
                                    0
                                ]
                            };
                            function B(t1, e1) {
                                return Array.isArray(t1) ? [
                                    e1(t1[0]),
                                    e1(t1[1]),
                                    e1(t1[2])
                                ] : [
                                    e1(t1),
                                    e1(t1),
                                    e1(t1)
                                ];
                            }
                            function N(t1) {
                                return Array.isArray(t1) ? 3 === t1.length ? [
                                    t1[0],
                                    t1[1],
                                    t1[2],
                                    1
                                ] : [
                                    t1[0],
                                    t1[1],
                                    t1[2],
                                    t1[3]
                                ] : [
                                    0,
                                    0,
                                    0,
                                    1
                                ];
                            }
                            function j(t1) {
                                if (Array.isArray(t1)) {
                                    if (Array.isArray(t1)) return [
                                        N(t1[0]),
                                        N(t1[1]),
                                        N(t1[2])
                                    ];
                                    var e1 = N(t1);
                                    return [
                                        e1.slice(),
                                        e1.slice(),
                                        e1.slice()
                                    ];
                                }
                            }
                            C.drawPick = function(t1) {
                                t1 = t1 || {};
                                var e1 = this.gl;
                                e1.disable(e1.CULL_FACE);
                                var r = F;
                                r.model = t1.model || T, r.view = t1.view || T, r.projection = t1.projection || T, r.shape = this._field[2].shape, r.pickId = this.pickId / 255, r.lowerBound = this.bounds[0], r.upperBound = this.bounds[1], r.objectOffset = this.objectOffset, r.permutation = D;
                                for(var n = 0; n < 2; ++n)for(var i = r.clipBounds[n], a = 0; a < 3; ++a)i[a] = Math.min(Math.max(this.clipBounds[n][a], -100000000), 1e8);
                                var o = P(r, this);
                                if (o.showSurface) {
                                    for(this._pickShader.bind(), this._pickShader.uniforms = r, this._vao.bind(), this._vao.draw(e1.TRIANGLES, this._vertexCount), n = 0; n < 3; ++n)this.surfaceProject[n] && (this._pickShader.uniforms.model = o.projections[n], this._pickShader.uniforms.clipBounds = o.clipBounds[n], this._vao.draw(e1.TRIANGLES, this._vertexCount));
                                    this._vao.unbind();
                                }
                                if (o.showContour) {
                                    var s = this._contourPickShader;
                                    s.bind(), s.uniforms = r;
                                    var l = this._contourVAO;
                                    for(l.bind(), a = 0; a < 3; ++a)for(e1.lineWidth(this.contourWidth[a] * this.pixelRatio), s.uniforms.permutation = A[a], n = 0; n < this.contourLevels[a].length; ++n)this._contourCounts[a][n] && (s.uniforms.height = this.contourLevels[a][n], l.draw(e1.LINES, this._contourCounts[a][n], this._contourOffsets[a][n]));
                                    for(n = 0; n < 3; ++n)for(s.uniforms.model = o.projections[n], s.uniforms.clipBounds = o.clipBounds[n], a = 0; a < 3; ++a)if (this.contourProject[n][a]) {
                                        s.uniforms.permutation = A[a], e1.lineWidth(this.contourWidth[a] * this.pixelRatio);
                                        for(var c = 0; c < this.contourLevels[a].length; ++c)this._contourCounts[a][c] && (s.uniforms.height = this.contourLevels[a][c], l.draw(e1.LINES, this._contourCounts[a][c], this._contourOffsets[a][c]));
                                    }
                                    l.unbind();
                                }
                            }, C.pick = function(t1) {
                                if (!t1) return null;
                                if (t1.id !== this.pickId) return null;
                                var e1 = this._field[2].shape, r = this._pickResult, n = e1[0] * (t1.value[0] + (t1.value[2] >> 4) / 16) / 255, i = Math.floor(n), a = n - i, o = e1[1] * (t1.value[1] + (15 & t1.value[2]) / 16) / 255, s = Math.floor(o), l = o - s;
                                i += 1, s += 1;
                                var c = r.position;
                                c[0] = c[1] = c[2] = 0;
                                for(var u = 0; u < 2; ++u)for(var h = u ? a : 1 - a, f = 0; f < 2; ++f)for(var p = i + u, d = s + f, g = h * (f ? l : 1 - l), y = 0; y < 3; ++y)c[y] += this._field[y].get(p, d) * g;
                                for(var v = this._pickResult.level, x = 0; x < 3; ++x)if (v[x] = m.le(this.contourLevels[x], c[x]), v[x] < 0) this.contourLevels[x].length > 0 && (v[x] = 0);
                                else if (v[x] < this.contourLevels[x].length - 1) {
                                    var _ = this.contourLevels[x][v[x]], b = this.contourLevels[x][v[x] + 1];
                                    Math.abs(_ - c[x]) > Math.abs(b - c[x]) && (v[x] += 1);
                                }
                                for(r.index[0] = a < .5 ? i : i + 1, r.index[1] = l < .5 ? s : s + 1, r.uv[0] = n / e1[0], r.uv[1] = o / e1[1], y = 0; y < 3; ++y)r.dataCoordinate[y] = this._field[y].get(r.index[0], r.index[1]);
                                return r;
                            }, C.padField = function(t1, e1) {
                                var r = e1.shape.slice(), n = t1.shape.slice();
                                c.assign(t1.lo(1, 1).hi(r[0], r[1]), e1), c.assign(t1.lo(1).hi(r[0], 1), e1.hi(r[0], 1)), c.assign(t1.lo(1, n[1] - 1).hi(r[0], 1), e1.lo(0, r[1] - 1).hi(r[0], 1)), c.assign(t1.lo(0, 1).hi(1, r[1]), e1.hi(1)), c.assign(t1.lo(n[0] - 1, 1).hi(1, r[1]), e1.lo(r[0] - 1)), t1.set(0, 0, e1.get(0, 0)), t1.set(0, n[1] - 1, e1.get(0, r[1] - 1)), t1.set(n[0] - 1, 0, e1.get(r[0] - 1, 0)), t1.set(n[0] - 1, n[1] - 1, e1.get(r[0] - 1, r[1] - 1));
                            }, C.update = function(t1) {
                                t1 = t1 || {}, this.objectOffset = t1.objectOffset || this.objectOffset, this.dirty = !0, "contourWidth" in t1 && (this.contourWidth = B(t1.contourWidth, Number)), "showContour" in t1 && (this.showContour = B(t1.showContour, Boolean)), "showSurface" in t1 && (this.showSurface = !!t1.showSurface), "contourTint" in t1 && (this.contourTint = B(t1.contourTint, Boolean)), "contourColor" in t1 && (this.contourColor = j(t1.contourColor)), "contourProject" in t1 && (this.contourProject = B(t1.contourProject, function(t1) {
                                    return B(t1, Boolean);
                                })), "surfaceProject" in t1 && (this.surfaceProject = t1.surfaceProject), "dynamicColor" in t1 && (this.dynamicColor = j(t1.dynamicColor)), "dynamicTint" in t1 && (this.dynamicTint = B(t1.dynamicTint, Number)), "dynamicWidth" in t1 && (this.dynamicWidth = B(t1.dynamicWidth, Number)), "opacity" in t1 && (this.opacity = t1.opacity), "opacityscale" in t1 && (this.opacityscale = t1.opacityscale), "colorBounds" in t1 && (this.colorBounds = t1.colorBounds), "vertexColor" in t1 && (this.vertexColor = t1.vertexColor ? 1 : 0), "colormap" in t1 && this._colorMap.setPixels(this.genColormap(t1.colormap, this.opacityscale));
                                var e1 = t1.field || t1.coords && t1.coords[2] || null, r = !1;
                                if (e1 || (e1 = this._field[2].shape[0] || this._field[2].shape[2] ? this._field[2].lo(1, 1).hi(this._field[2].shape[0] - 2, this._field[2].shape[1] - 2) : this._field[2].hi(0, 0)), "field" in t1 || "coords" in t1) {
                                    var i = (e1.shape[0] + 2) * (e1.shape[1] + 2);
                                    i > this._field[2].data.length && (s.freeFloat(this._field[2].data), this._field[2].data = s.mallocFloat(n.nextPow2(i))), this._field[2] = h(this._field[2].data, [
                                        e1.shape[0] + 2,
                                        e1.shape[1] + 2
                                    ]), this.padField(this._field[2], e1), this.shape = e1.shape.slice();
                                    for(var a = this.shape, o = 0; o < 2; ++o)this._field[2].size > this._field[o].data.length && (s.freeFloat(this._field[o].data), this._field[o].data = s.mallocFloat(this._field[2].size)), this._field[o] = h(this._field[o].data, [
                                        a[0] + 2,
                                        a[1] + 2
                                    ]);
                                    if (t1.coords) {
                                        var l = t1.coords;
                                        if (!Array.isArray(l) || 3 !== l.length) throw new Error("gl-surface: invalid coordinates for x/y");
                                        for(o = 0; o < 2; ++o){
                                            var c = l[o];
                                            for(y = 0; y < 2; ++y)if (c.shape[y] !== a[y]) throw new Error("gl-surface: coords have incorrect shape");
                                            this.padField(this._field[o], c);
                                        }
                                    } else if (t1.ticks) {
                                        var u = t1.ticks;
                                        if (!Array.isArray(u) || 2 !== u.length) throw new Error("gl-surface: invalid ticks");
                                        for(o = 0; o < 2; ++o){
                                            var p = u[o];
                                            if ((Array.isArray(p) || p.length) && (p = h(p)), p.shape[0] !== a[o]) throw new Error("gl-surface: invalid tick length");
                                            var d = h(p.data, a);
                                            d.stride[o] = p.stride[0], d.stride[1 ^ o] = 0, this.padField(this._field[o], d);
                                        }
                                    } else {
                                        for(o = 0; o < 2; ++o){
                                            var m = [
                                                0,
                                                0
                                            ];
                                            m[o] = 1, this._field[o] = h(this._field[o].data, [
                                                a[0] + 2,
                                                a[1] + 2
                                            ], m, 0);
                                        }
                                        this._field[0].set(0, 0, 0);
                                        for(var y = 0; y < a[0]; ++y)this._field[0].set(y + 1, 0, y);
                                        for(this._field[0].set(a[0] + 1, 0, a[0] - 1), this._field[1].set(0, 0, 0), y = 0; y < a[1]; ++y)this._field[1].set(0, y + 1, y);
                                        this._field[1].set(0, a[1] + 1, a[1] - 1);
                                    }
                                    var v = this._field, x = h(s.mallocFloat(3 * v[2].size * 2), [
                                        3,
                                        a[0] + 2,
                                        a[1] + 2,
                                        2
                                    ]);
                                    for(o = 0; o < 3; ++o)g(x.pick(o), v[o], "mirror");
                                    var _ = h(s.mallocFloat(3 * v[2].size), [
                                        a[0] + 2,
                                        a[1] + 2,
                                        3
                                    ]);
                                    for(o = 0; o < a[0] + 2; ++o)for(y = 0; y < a[1] + 2; ++y){
                                        var b = x.get(0, o, y, 0), w = x.get(0, o, y, 1), T = x.get(1, o, y, 0), A = x.get(1, o, y, 1), M = x.get(2, o, y, 0), S = x.get(2, o, y, 1), E = T * S - A * M, C = M * w - S * b, L = b * A - w * T, I = Math.sqrt(E * E + C * C + L * L);
                                        I < 1e-8 ? (I = Math.max(Math.abs(E), Math.abs(C), Math.abs(L))) < 1e-8 ? (L = 1, C = E = 0, I = 1) : I = 1 / I : I = 1 / Math.sqrt(I), _.set(o, y, 0, E * I), _.set(o, y, 1, C * I), _.set(o, y, 2, L * I);
                                    }
                                    s.free(x.data);
                                    var P = [
                                        1 / 0,
                                        1 / 0,
                                        1 / 0
                                    ], z = [
                                        -1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ], O = 1 / 0, D = -1 / 0, R = (a[0] - 1) * (a[1] - 1) * 6, F = s.mallocFloat(n.nextPow2(10 * R)), N = 0, U = 0;
                                    for(o = 0; o < a[0] - 1; ++o)t: for(y = 0; y < a[1] - 1; ++y){
                                        for(var V = 0; V < 2; ++V)for(var q = 0; q < 2; ++q)for(var H = 0; H < 3; ++H){
                                            var G = this._field[H].get(1 + o + V, 1 + y + q);
                                            if (isNaN(G) || !isFinite(G)) continue t;
                                        }
                                        for(H = 0; H < 6; ++H){
                                            var Z = o + k[H][0], W = y + k[H][1], Y = this._field[0].get(Z + 1, W + 1), X = this._field[1].get(Z + 1, W + 1);
                                            G = this._field[2].get(Z + 1, W + 1), E = _.get(Z + 1, W + 1, 0), C = _.get(Z + 1, W + 1, 1), L = _.get(Z + 1, W + 1, 2), t1.intensity && ($ = t1.intensity.get(Z, W));
                                            var $ = t1.intensity ? t1.intensity.get(Z, W) : G + this.objectOffset[2];
                                            F[N++] = Z, F[N++] = W, F[N++] = Y, F[N++] = X, F[N++] = G, F[N++] = 0, F[N++] = $, F[N++] = E, F[N++] = C, F[N++] = L, P[0] = Math.min(P[0], Y + this.objectOffset[0]), P[1] = Math.min(P[1], X + this.objectOffset[1]), P[2] = Math.min(P[2], G + this.objectOffset[2]), O = Math.min(O, $), z[0] = Math.max(z[0], Y + this.objectOffset[0]), z[1] = Math.max(z[1], X + this.objectOffset[1]), z[2] = Math.max(z[2], G + this.objectOffset[2]), D = Math.max(D, $), U += 1;
                                        }
                                    }
                                    for(t1.intensityBounds && (O = +t1.intensityBounds[0], D = +t1.intensityBounds[1]), o = 6; o < N; o += 10)F[o] = (F[o] - O) / (D - O);
                                    this._vertexCount = U, this._coordinateBuffer.update(F.subarray(0, N)), s.freeFloat(F), s.free(_.data), this.bounds = [
                                        P,
                                        z
                                    ], this.intensity = t1.intensity || this._field[2], this.intensityBounds[0] === O && this.intensityBounds[1] === D || (r = !0), this.intensityBounds = [
                                        O,
                                        D
                                    ];
                                }
                                if ("levels" in t1) {
                                    var J = t1.levels;
                                    for(J = Array.isArray(J[0]) ? J.slice() : [
                                        [],
                                        [],
                                        J
                                    ], o = 0; o < 3; ++o)J[o] = J[o].slice(), J[o].sort(function(t1, e1) {
                                        return t1 - e1;
                                    });
                                    for(o = 0; o < 3; ++o)for(y = 0; y < J[o].length; ++y)J[o][y] -= this.objectOffset[o];
                                    t: for(o = 0; o < 3; ++o){
                                        if (J[o].length !== this.contourLevels[o].length) {
                                            r = !0;
                                            break;
                                        }
                                        for(y = 0; y < J[o].length; ++y)if (J[o][y] !== this.contourLevels[o][y]) {
                                            r = !0;
                                            break t;
                                        }
                                    }
                                    this.contourLevels = J;
                                }
                                if (r) {
                                    v = this._field, a = this.shape;
                                    for(var K = [], Q = 0; Q < 3; ++Q){
                                        var tt = this.contourLevels[Q], et = [], rt = [], nt = [
                                            0,
                                            0,
                                            0
                                        ];
                                        for(o = 0; o < tt.length; ++o){
                                            var it = f(this._field[Q], tt[o]);
                                            et.push(K.length / 5 | 0), U = 0;
                                            t: for(y = 0; y < it.cells.length; ++y){
                                                var at = it.cells[y];
                                                for(H = 0; H < 2; ++H){
                                                    var ot = it.positions[at[H]], st = ot[0], lt = 0 | Math.floor(st), ct = st - lt, ut = ot[1], ht = 0 | Math.floor(ut), ft = ut - ht, pt = !1;
                                                    e: for(var dt = 0; dt < 3; ++dt){
                                                        nt[dt] = 0;
                                                        var mt = (Q + dt + 1) % 3;
                                                        for(V = 0; V < 2; ++V){
                                                            var gt = V ? ct : 1 - ct;
                                                            for(Z = 0 | Math.min(Math.max(lt + V, 0), a[0]), q = 0; q < 2; ++q){
                                                                var yt = q ? ft : 1 - ft;
                                                                if (W = 0 | Math.min(Math.max(ht + q, 0), a[1]), G = dt < 2 ? this._field[mt].get(Z, W) : (this.intensity.get(Z, W) - this.intensityBounds[0]) / (this.intensityBounds[1] - this.intensityBounds[0]), !isFinite(G) || isNaN(G)) {
                                                                    pt = !0;
                                                                    break e;
                                                                }
                                                                var vt = gt * yt;
                                                                nt[dt] += vt * G;
                                                            }
                                                        }
                                                    }
                                                    if (pt) {
                                                        if (H > 0) {
                                                            for(var xt = 0; xt < 5; ++xt)K.pop();
                                                            U -= 1;
                                                        }
                                                        continue t;
                                                    }
                                                    K.push(nt[0], nt[1], ot[0], ot[1], nt[2]), U += 1;
                                                }
                                            }
                                            rt.push(U);
                                        }
                                        this._contourOffsets[Q] = et, this._contourCounts[Q] = rt;
                                    }
                                    var _t = s.mallocFloat(K.length);
                                    for(o = 0; o < K.length; ++o)_t[o] = K[o];
                                    this._contourBuffer.update(_t), s.freeFloat(_t);
                                }
                            }, C.dispose = function() {
                                this._shader.dispose(), this._vao.dispose(), this._coordinateBuffer.dispose(), this._colorMap.dispose(), this._contourBuffer.dispose(), this._contourVAO.dispose(), this._contourShader.dispose(), this._contourPickShader.dispose(), this._dynamicBuffer.dispose(), this._dynamicVAO.dispose();
                                for(var t1 = 0; t1 < 3; ++t1)s.freeFloat(this._field[t1].data);
                            }, C.highlight = function(t1) {
                                var e1, r;
                                if (!t1) return this._dynamicCounts = [
                                    0,
                                    0,
                                    0
                                ], this.dyanamicLevel = [
                                    NaN,
                                    NaN,
                                    NaN
                                ], void (this.highlightLevel = [
                                    -1,
                                    -1,
                                    -1
                                ]);
                                for(e1 = 0; e1 < 3; ++e1)this.enableHighlight[e1] ? this.highlightLevel[e1] = t1.level[e1] : this.highlightLevel[e1] = -1;
                                for(r = this.snapToData ? t1.dataCoordinate : t1.position, e1 = 0; e1 < 3; ++e1)r[e1] -= this.objectOffset[e1];
                                if (this.enableDynamic[0] && r[0] !== this.dynamicLevel[0] || this.enableDynamic[1] && r[1] !== this.dynamicLevel[1] || this.enableDynamic[2] && r[2] !== this.dynamicLevel[2]) {
                                    for(var n = 0, i = this.shape, a = s.mallocFloat(12 * i[0] * i[1]), o = 0; o < 3; ++o)if (this.enableDynamic[o]) {
                                        this.dynamicLevel[o] = r[o];
                                        var l = (o + 1) % 3, c = (o + 2) % 3, u = this._field[o], h = this._field[l], p = this._field[c], d = f(u, r[o]), m = d.cells, g = d.positions;
                                        for(this._dynamicOffsets[o] = n, e1 = 0; e1 < m.length; ++e1)for(var y = m[e1], v = 0; v < 2; ++v){
                                            var x = g[y[v]], _ = +x[0], b = 0 | _, w = 0 | Math.min(b + 1, i[0]), T = _ - b, k = 1 - T, A = +x[1], M = 0 | A, S = 0 | Math.min(M + 1, i[1]), E = A - M, C = 1 - E, L = k * C, I = k * E, P = T * C, z = T * E, O = L * h.get(b, M) + I * h.get(b, S) + P * h.get(w, M) + z * h.get(w, S), D = L * p.get(b, M) + I * p.get(b, S) + P * p.get(w, M) + z * p.get(w, S);
                                            if (isNaN(O) || isNaN(D)) {
                                                v && (n -= 1);
                                                break;
                                            }
                                            a[2 * n + 0] = O, a[2 * n + 1] = D, n += 1;
                                        }
                                        this._dynamicCounts[o] = n - this._dynamicOffsets[o];
                                    } else this.dynamicLevel[o] = NaN, this._dynamicCounts[o] = 0;
                                    this._dynamicBuffer.update(a.subarray(0, 2 * n)), s.freeFloat(a);
                                }
                            };
                        },
                        7766: function(t1, e1, r) {
                            "use strict";
                            var n = r(9618), i = r(5298), a = r(1888);
                            t1.exports = function(t1) {
                                if (arguments.length <= 1) throw new Error("gl-texture2d: Missing arguments for texture2d constructor");
                                if (o || function(t1) {
                                    o = [
                                        t1.LINEAR,
                                        t1.NEAREST_MIPMAP_LINEAR,
                                        t1.LINEAR_MIPMAP_NEAREST,
                                        t1.LINEAR_MIPMAP_NEAREST
                                    ], s = [
                                        t1.NEAREST,
                                        t1.LINEAR,
                                        t1.NEAREST_MIPMAP_NEAREST,
                                        t1.NEAREST_MIPMAP_LINEAR,
                                        t1.LINEAR_MIPMAP_NEAREST,
                                        t1.LINEAR_MIPMAP_LINEAR
                                    ], l = [
                                        t1.REPEAT,
                                        t1.CLAMP_TO_EDGE,
                                        t1.MIRRORED_REPEAT
                                    ];
                                }(t1), "number" == typeof arguments[1]) return g(t1, arguments[1], arguments[2], arguments[3] || t1.RGBA, arguments[4] || t1.UNSIGNED_BYTE);
                                if (Array.isArray(arguments[1])) return g(t1, 0 | arguments[1][0], 0 | arguments[1][1], arguments[2] || t1.RGBA, arguments[3] || t1.UNSIGNED_BYTE);
                                if ("object" == typeof arguments[1]) {
                                    var e1 = arguments[1], r = c(e1) ? e1 : e1.raw;
                                    if (r) return function(t1, e1, r, n, i, a) {
                                        var o = m(t1);
                                        return t1.texImage2D(t1.TEXTURE_2D, 0, i, i, a, e1), new f(t1, o, r, n, i, a);
                                    }(t1, r, 0 | e1.width, 0 | e1.height, arguments[2] || t1.RGBA, arguments[3] || t1.UNSIGNED_BYTE);
                                    if (e1.shape && e1.data && e1.stride) return function(t1, e1) {
                                        var r = e1.dtype, o = e1.shape.slice(), s = t1.getParameter(t1.MAX_TEXTURE_SIZE);
                                        if (o[0] < 0 || o[0] > s || o[1] < 0 || o[1] > s) throw new Error("gl-texture2d: Invalid texture size");
                                        var l = d(o, e1.stride.slice()), c = 0;
                                        "float32" === r ? c = t1.FLOAT : "float64" === r ? (c = t1.FLOAT, l = !1, r = "float32") : "uint8" === r ? c = t1.UNSIGNED_BYTE : (c = t1.UNSIGNED_BYTE, l = !1, r = "uint8");
                                        var h, p, g = 0;
                                        if (2 === o.length) g = t1.LUMINANCE, o = [
                                            o[0],
                                            o[1],
                                            1
                                        ], e1 = n(e1.data, o, [
                                            e1.stride[0],
                                            e1.stride[1],
                                            1
                                        ], e1.offset);
                                        else {
                                            if (3 !== o.length) throw new Error("gl-texture2d: Invalid shape for texture");
                                            if (1 === o[2]) g = t1.ALPHA;
                                            else if (2 === o[2]) g = t1.LUMINANCE_ALPHA;
                                            else if (3 === o[2]) g = t1.RGB;
                                            else {
                                                if (4 !== o[2]) throw new Error("gl-texture2d: Invalid shape for pixel coords");
                                                g = t1.RGBA;
                                            }
                                        }
                                        c !== t1.FLOAT || t1.getExtension("OES_texture_float") || (c = t1.UNSIGNED_BYTE, l = !1);
                                        var y = e1.size;
                                        if (l) h = 0 === e1.offset && e1.data.length === y ? e1.data : e1.data.subarray(e1.offset, e1.offset + y);
                                        else {
                                            var v = [
                                                o[2],
                                                o[2] * o[0],
                                                1
                                            ];
                                            p = a.malloc(y, r);
                                            var x = n(p, o, v, 0);
                                            "float32" !== r && "float64" !== r || c !== t1.UNSIGNED_BYTE ? i.assign(x, e1) : u(x, e1), h = p.subarray(0, y);
                                        }
                                        var _ = m(t1);
                                        return t1.texImage2D(t1.TEXTURE_2D, 0, g, o[0], o[1], 0, g, c, h), l || a.free(p), new f(t1, _, o[0], o[1], g, c);
                                    }(t1, e1);
                                }
                                throw new Error("gl-texture2d: Invalid arguments for texture2d constructor");
                            };
                            var o = null, s = null, l = null;
                            function c(t1) {
                                return "undefined" != typeof HTMLCanvasElement && t1 instanceof HTMLCanvasElement || "undefined" != typeof HTMLImageElement && t1 instanceof HTMLImageElement || "undefined" != typeof HTMLVideoElement && t1 instanceof HTMLVideoElement || "undefined" != typeof ImageData && t1 instanceof ImageData;
                            }
                            var u = function(t1, e1) {
                                i.muls(t1, e1, 255);
                            };
                            function h(t1, e1, r) {
                                var n = t1.gl, i = n.getParameter(n.MAX_TEXTURE_SIZE);
                                if (e1 < 0 || e1 > i || r < 0 || r > i) throw new Error("gl-texture2d: Invalid texture size");
                                return t1._shape = [
                                    e1,
                                    r
                                ], t1.bind(), n.texImage2D(n.TEXTURE_2D, 0, t1.format, e1, r, 0, t1.format, t1.type, null), t1._mipLevels = [
                                    0
                                ], t1;
                            }
                            function f(t1, e1, r, n, i, a) {
                                this.gl = t1, this.handle = e1, this.format = i, this.type = a, this._shape = [
                                    r,
                                    n
                                ], this._mipLevels = [
                                    0
                                ], this._magFilter = t1.NEAREST, this._minFilter = t1.NEAREST, this._wrapS = t1.CLAMP_TO_EDGE, this._wrapT = t1.CLAMP_TO_EDGE, this._anisoSamples = 1;
                                var o = this, s = [
                                    this._wrapS,
                                    this._wrapT
                                ];
                                Object.defineProperties(s, [
                                    {
                                        get: function() {
                                            return o._wrapS;
                                        },
                                        set: function(t1) {
                                            return o.wrapS = t1;
                                        }
                                    },
                                    {
                                        get: function() {
                                            return o._wrapT;
                                        },
                                        set: function(t1) {
                                            return o.wrapT = t1;
                                        }
                                    }
                                ]), this._wrapVector = s;
                                var l = [
                                    this._shape[0],
                                    this._shape[1]
                                ];
                                Object.defineProperties(l, [
                                    {
                                        get: function() {
                                            return o._shape[0];
                                        },
                                        set: function(t1) {
                                            return o.width = t1;
                                        }
                                    },
                                    {
                                        get: function() {
                                            return o._shape[1];
                                        },
                                        set: function(t1) {
                                            return o.height = t1;
                                        }
                                    }
                                ]), this._shapeVector = l;
                            }
                            var p = f.prototype;
                            function d(t1, e1) {
                                return 3 === t1.length ? 1 === e1[2] && e1[1] === t1[0] * t1[2] && e1[0] === t1[2] : 1 === e1[0] && e1[1] === t1[0];
                            }
                            function m(t1) {
                                var e1 = t1.createTexture();
                                return t1.bindTexture(t1.TEXTURE_2D, e1), t1.texParameteri(t1.TEXTURE_2D, t1.TEXTURE_MIN_FILTER, t1.NEAREST), t1.texParameteri(t1.TEXTURE_2D, t1.TEXTURE_MAG_FILTER, t1.NEAREST), t1.texParameteri(t1.TEXTURE_2D, t1.TEXTURE_WRAP_S, t1.CLAMP_TO_EDGE), t1.texParameteri(t1.TEXTURE_2D, t1.TEXTURE_WRAP_T, t1.CLAMP_TO_EDGE), e1;
                            }
                            function g(t1, e1, r, n, i) {
                                var a = t1.getParameter(t1.MAX_TEXTURE_SIZE);
                                if (e1 < 0 || e1 > a || r < 0 || r > a) throw new Error("gl-texture2d: Invalid texture shape");
                                if (i === t1.FLOAT && !t1.getExtension("OES_texture_float")) throw new Error("gl-texture2d: Floating point textures not supported on this platform");
                                var o = m(t1);
                                return t1.texImage2D(t1.TEXTURE_2D, 0, n, e1, r, 0, n, i, null), new f(t1, o, e1, r, n, i);
                            }
                            Object.defineProperties(p, {
                                minFilter: {
                                    get: function() {
                                        return this._minFilter;
                                    },
                                    set: function(t1) {
                                        this.bind();
                                        var e1 = this.gl;
                                        if (this.type === e1.FLOAT && o.indexOf(t1) >= 0 && (e1.getExtension("OES_texture_float_linear") || (t1 = e1.NEAREST)), s.indexOf(t1) < 0) throw new Error("gl-texture2d: Unknown filter mode " + t1);
                                        return e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_MIN_FILTER, t1), this._minFilter = t1;
                                    }
                                },
                                magFilter: {
                                    get: function() {
                                        return this._magFilter;
                                    },
                                    set: function(t1) {
                                        this.bind();
                                        var e1 = this.gl;
                                        if (this.type === e1.FLOAT && o.indexOf(t1) >= 0 && (e1.getExtension("OES_texture_float_linear") || (t1 = e1.NEAREST)), s.indexOf(t1) < 0) throw new Error("gl-texture2d: Unknown filter mode " + t1);
                                        return e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_MAG_FILTER, t1), this._magFilter = t1;
                                    }
                                },
                                mipSamples: {
                                    get: function() {
                                        return this._anisoSamples;
                                    },
                                    set: function(t1) {
                                        var e1 = this._anisoSamples;
                                        if (this._anisoSamples = 0 | Math.max(t1, 1), e1 !== this._anisoSamples) {
                                            var r = this.gl.getExtension("EXT_texture_filter_anisotropic");
                                            r && this.gl.texParameterf(this.gl.TEXTURE_2D, r.TEXTURE_MAX_ANISOTROPY_EXT, this._anisoSamples);
                                        }
                                        return this._anisoSamples;
                                    }
                                },
                                wrapS: {
                                    get: function() {
                                        return this._wrapS;
                                    },
                                    set: function(t1) {
                                        if (this.bind(), l.indexOf(t1) < 0) throw new Error("gl-texture2d: Unknown wrap mode " + t1);
                                        return this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_S, t1), this._wrapS = t1;
                                    }
                                },
                                wrapT: {
                                    get: function() {
                                        return this._wrapT;
                                    },
                                    set: function(t1) {
                                        if (this.bind(), l.indexOf(t1) < 0) throw new Error("gl-texture2d: Unknown wrap mode " + t1);
                                        return this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_T, t1), this._wrapT = t1;
                                    }
                                },
                                wrap: {
                                    get: function() {
                                        return this._wrapVector;
                                    },
                                    set: function(t1) {
                                        if (Array.isArray(t1) || (t1 = [
                                            t1,
                                            t1
                                        ]), 2 !== t1.length) throw new Error("gl-texture2d: Must specify wrap mode for rows and columns");
                                        for(var e1 = 0; e1 < 2; ++e1)if (l.indexOf(t1[e1]) < 0) throw new Error("gl-texture2d: Unknown wrap mode " + t1);
                                        this._wrapS = t1[0], this._wrapT = t1[1];
                                        var r = this.gl;
                                        return this.bind(), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_S, this._wrapS), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_T, this._wrapT), t1;
                                    }
                                },
                                shape: {
                                    get: function() {
                                        return this._shapeVector;
                                    },
                                    set: function(t1) {
                                        if (Array.isArray(t1)) {
                                            if (2 !== t1.length) throw new Error("gl-texture2d: Invalid texture shape");
                                        } else t1 = [
                                            0 | t1,
                                            0 | t1
                                        ];
                                        return h(this, 0 | t1[0], 0 | t1[1]), [
                                            0 | t1[0],
                                            0 | t1[1]
                                        ];
                                    }
                                },
                                width: {
                                    get: function() {
                                        return this._shape[0];
                                    },
                                    set: function(t1) {
                                        return h(this, t1 |= 0, this._shape[1]), t1;
                                    }
                                },
                                height: {
                                    get: function() {
                                        return this._shape[1];
                                    },
                                    set: function(t1) {
                                        return t1 |= 0, h(this, this._shape[0], t1), t1;
                                    }
                                }
                            }), p.bind = function(t1) {
                                var e1 = this.gl;
                                return void 0 !== t1 && e1.activeTexture(e1.TEXTURE0 + (0 | t1)), e1.bindTexture(e1.TEXTURE_2D, this.handle), void 0 !== t1 ? 0 | t1 : e1.getParameter(e1.ACTIVE_TEXTURE) - e1.TEXTURE0;
                            }, p.dispose = function() {
                                this.gl.deleteTexture(this.handle);
                            }, p.generateMipmap = function() {
                                this.bind(), this.gl.generateMipmap(this.gl.TEXTURE_2D);
                                for(var t1 = Math.min(this._shape[0], this._shape[1]), e1 = 0; t1 > 0; ++e1, t1 >>>= 1)this._mipLevels.indexOf(e1) < 0 && this._mipLevels.push(e1);
                            }, p.setPixels = function(t1, e1, r, o) {
                                var s = this.gl;
                                this.bind(), Array.isArray(e1) ? (o = r, r = 0 | e1[1], e1 = 0 | e1[0]) : (e1 = e1 || 0, r = r || 0), o = o || 0;
                                var l = c(t1) ? t1 : t1.raw;
                                if (l) this._mipLevels.indexOf(o) < 0 ? (s.texImage2D(s.TEXTURE_2D, 0, this.format, this.format, this.type, l), this._mipLevels.push(o)) : s.texSubImage2D(s.TEXTURE_2D, o, e1, r, this.format, this.type, l);
                                else {
                                    if (!(t1.shape && t1.stride && t1.data)) throw new Error("gl-texture2d: Unsupported data type");
                                    if (t1.shape.length < 2 || e1 + t1.shape[1] > this._shape[1] >>> o || r + t1.shape[0] > this._shape[0] >>> o || e1 < 0 || r < 0) throw new Error("gl-texture2d: Texture dimensions are out of bounds");
                                    !function(t1, e1, r, o, s, l, c, h) {
                                        var f = h.dtype, p = h.shape.slice();
                                        if (p.length < 2 || p.length > 3) throw new Error("gl-texture2d: Invalid ndarray, must be 2d or 3d");
                                        var m = 0, g = 0, y = d(p, h.stride.slice());
                                        if ("float32" === f ? m = t1.FLOAT : "float64" === f ? (m = t1.FLOAT, y = !1, f = "float32") : "uint8" === f ? m = t1.UNSIGNED_BYTE : (m = t1.UNSIGNED_BYTE, y = !1, f = "uint8"), 2 === p.length) g = t1.LUMINANCE, p = [
                                            p[0],
                                            p[1],
                                            1
                                        ], h = n(h.data, p, [
                                            h.stride[0],
                                            h.stride[1],
                                            1
                                        ], h.offset);
                                        else {
                                            if (3 !== p.length) throw new Error("gl-texture2d: Invalid shape for texture");
                                            if (1 === p[2]) g = t1.ALPHA;
                                            else if (2 === p[2]) g = t1.LUMINANCE_ALPHA;
                                            else if (3 === p[2]) g = t1.RGB;
                                            else {
                                                if (4 !== p[2]) throw new Error("gl-texture2d: Invalid shape for pixel coords");
                                                g = t1.RGBA;
                                            }
                                            p[2];
                                        }
                                        if (g !== t1.LUMINANCE && g !== t1.ALPHA || s !== t1.LUMINANCE && s !== t1.ALPHA || (g = s), g !== s) throw new Error("gl-texture2d: Incompatible texture format for setPixels");
                                        var v = h.size, x = c.indexOf(o) < 0;
                                        if (x && c.push(o), m === l && y) 0 === h.offset && h.data.length === v ? x ? t1.texImage2D(t1.TEXTURE_2D, o, s, p[0], p[1], 0, s, l, h.data) : t1.texSubImage2D(t1.TEXTURE_2D, o, e1, r, p[0], p[1], s, l, h.data) : x ? t1.texImage2D(t1.TEXTURE_2D, o, s, p[0], p[1], 0, s, l, h.data.subarray(h.offset, h.offset + v)) : t1.texSubImage2D(t1.TEXTURE_2D, o, e1, r, p[0], p[1], s, l, h.data.subarray(h.offset, h.offset + v));
                                        else {
                                            var _;
                                            _ = l === t1.FLOAT ? a.mallocFloat32(v) : a.mallocUint8(v);
                                            var b = n(_, p, [
                                                p[2],
                                                p[2] * p[0],
                                                1
                                            ]);
                                            m === t1.FLOAT && l === t1.UNSIGNED_BYTE ? u(b, h) : i.assign(b, h), x ? t1.texImage2D(t1.TEXTURE_2D, o, s, p[0], p[1], 0, s, l, _.subarray(0, v)) : t1.texSubImage2D(t1.TEXTURE_2D, o, e1, r, p[0], p[1], s, l, _.subarray(0, v)), l === t1.FLOAT ? a.freeFloat32(_) : a.freeUint8(_);
                                        }
                                    }(s, e1, r, o, this.format, this.type, this._mipLevels, t1);
                                }
                            };
                        },
                        1433: function(t1) {
                            "use strict";
                            t1.exports = function(t1, e1, r) {
                                e1 ? e1.bind() : t1.bindBuffer(t1.ELEMENT_ARRAY_BUFFER, null);
                                var n = 0 | t1.getParameter(t1.MAX_VERTEX_ATTRIBS);
                                if (r) {
                                    if (r.length > n) throw new Error("gl-vao: Too many vertex attributes");
                                    for(var i = 0; i < r.length; ++i){
                                        var a = r[i];
                                        if (a.buffer) {
                                            var o = a.buffer, s = a.size || 4, l = a.type || t1.FLOAT, c = !!a.normalized, u = a.stride || 0, h = a.offset || 0;
                                            o.bind(), t1.enableVertexAttribArray(i), t1.vertexAttribPointer(i, s, l, c, u, h);
                                        } else {
                                            if ("number" == typeof a) t1.vertexAttrib1f(i, a);
                                            else if (1 === a.length) t1.vertexAttrib1f(i, a[0]);
                                            else if (2 === a.length) t1.vertexAttrib2f(i, a[0], a[1]);
                                            else if (3 === a.length) t1.vertexAttrib3f(i, a[0], a[1], a[2]);
                                            else {
                                                if (4 !== a.length) throw new Error("gl-vao: Invalid vertex attribute");
                                                t1.vertexAttrib4f(i, a[0], a[1], a[2], a[3]);
                                            }
                                            t1.disableVertexAttribArray(i);
                                        }
                                    }
                                    for(; i < n; ++i)t1.disableVertexAttribArray(i);
                                } else for(t1.bindBuffer(t1.ARRAY_BUFFER, null), i = 0; i < n; ++i)t1.disableVertexAttribArray(i);
                            };
                        },
                        870: function(t1, e1, r) {
                            "use strict";
                            var n = r(1433);
                            function i(t1) {
                                this.gl = t1, this._elements = null, this._attributes = null, this._elementsType = t1.UNSIGNED_SHORT;
                            }
                            i.prototype.bind = function() {
                                n(this.gl, this._elements, this._attributes);
                            }, i.prototype.update = function(t1, e1, r) {
                                this._elements = e1, this._attributes = t1, this._elementsType = r || this.gl.UNSIGNED_SHORT;
                            }, i.prototype.dispose = function() {}, i.prototype.unbind = function() {}, i.prototype.draw = function(t1, e1, r) {
                                r = r || 0;
                                var n = this.gl;
                                this._elements ? n.drawElements(t1, e1, this._elementsType, r) : n.drawArrays(t1, r, e1);
                            }, t1.exports = function(t1) {
                                return new i(t1);
                            };
                        },
                        7518: function(t1, e1, r) {
                            "use strict";
                            var n = r(1433);
                            function i(t1, e1, r, n, i, a) {
                                this.location = t1, this.dimension = e1, this.a = r, this.b = n, this.c = i, this.d = a;
                            }
                            function a(t1, e1, r) {
                                this.gl = t1, this._ext = e1, this.handle = r, this._attribs = [], this._useElements = !1, this._elementsType = t1.UNSIGNED_SHORT;
                            }
                            i.prototype.bind = function(t1) {
                                switch(this.dimension){
                                    case 1:
                                        t1.vertexAttrib1f(this.location, this.a);
                                        break;
                                    case 2:
                                        t1.vertexAttrib2f(this.location, this.a, this.b);
                                        break;
                                    case 3:
                                        t1.vertexAttrib3f(this.location, this.a, this.b, this.c);
                                        break;
                                    case 4:
                                        t1.vertexAttrib4f(this.location, this.a, this.b, this.c, this.d);
                                }
                            }, a.prototype.bind = function() {
                                this._ext.bindVertexArrayOES(this.handle);
                                for(var t1 = 0; t1 < this._attribs.length; ++t1)this._attribs[t1].bind(this.gl);
                            }, a.prototype.unbind = function() {
                                this._ext.bindVertexArrayOES(null);
                            }, a.prototype.dispose = function() {
                                this._ext.deleteVertexArrayOES(this.handle);
                            }, a.prototype.update = function(t1, e1, r) {
                                if (this.bind(), n(this.gl, e1, t1), this.unbind(), this._attribs.length = 0, t1) for(var a = 0; a < t1.length; ++a){
                                    var o = t1[a];
                                    "number" == typeof o ? this._attribs.push(new i(a, 1, o)) : Array.isArray(o) && this._attribs.push(new i(a, o.length, o[0], o[1], o[2], o[3]));
                                }
                                this._useElements = !!e1, this._elementsType = r || this.gl.UNSIGNED_SHORT;
                            }, a.prototype.draw = function(t1, e1, r) {
                                r = r || 0;
                                var n = this.gl;
                                this._useElements ? n.drawElements(t1, e1, this._elementsType, r) : n.drawArrays(t1, r, e1);
                            }, t1.exports = function(t1, e1) {
                                return new a(t1, e1, e1.createVertexArrayOES());
                            };
                        },
                        8116: function(t1, e1, r) {
                            "use strict";
                            var n = r(7518), i = r(870);
                            function a(t1) {
                                this.bindVertexArrayOES = t1.bindVertexArray.bind(t1), this.createVertexArrayOES = t1.createVertexArray.bind(t1), this.deleteVertexArrayOES = t1.deleteVertexArray.bind(t1);
                            }
                            t1.exports = function(t1, e1, r, o) {
                                var s, l = t1.createVertexArray ? new a(t1) : t1.getExtension("OES_vertex_array_object");
                                return (s = l ? n(t1, l) : i(t1)).update(e1, r, o), s;
                            };
                        },
                        5632: function(t1) {
                            t1.exports = function(t1, e1, r) {
                                return t1[0] = e1[0] + r[0], t1[1] = e1[1] + r[1], t1[2] = e1[2] + r[2], t1;
                            };
                        },
                        8192: function(t1, e1, r) {
                            t1.exports = function(t1, e1) {
                                var r = n(t1[0], t1[1], t1[2]), o = n(e1[0], e1[1], e1[2]);
                                i(r, r), i(o, o);
                                var s = a(r, o);
                                return s > 1 ? 0 : Math.acos(s);
                            };
                            var n = r(2825), i = r(3536), a = r(244);
                        },
                        9226: function(t1) {
                            t1.exports = function(t1, e1) {
                                return t1[0] = Math.ceil(e1[0]), t1[1] = Math.ceil(e1[1]), t1[2] = Math.ceil(e1[2]), t1;
                            };
                        },
                        3126: function(t1) {
                            t1.exports = function(t1) {
                                var e1 = new Float32Array(3);
                                return e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1;
                            };
                        },
                        3990: function(t1) {
                            t1.exports = function(t1, e1) {
                                return t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1;
                            };
                        },
                        1091: function(t1) {
                            t1.exports = function() {
                                var t1 = new Float32Array(3);
                                return t1[0] = 0, t1[1] = 0, t1[2] = 0, t1;
                            };
                        },
                        5911: function(t1) {
                            t1.exports = function(t1, e1, r) {
                                var n = e1[0], i = e1[1], a = e1[2], o = r[0], s = r[1], l = r[2];
                                return t1[0] = i * l - a * s, t1[1] = a * o - n * l, t1[2] = n * s - i * o, t1;
                            };
                        },
                        5455: function(t1, e1, r) {
                            t1.exports = r(7056);
                        },
                        7056: function(t1) {
                            t1.exports = function(t1, e1) {
                                var r = e1[0] - t1[0], n = e1[1] - t1[1], i = e1[2] - t1[2];
                                return Math.sqrt(r * r + n * n + i * i);
                            };
                        },
                        4008: function(t1, e1, r) {
                            t1.exports = r(6690);
                        },
                        6690: function(t1) {
                            t1.exports = function(t1, e1, r) {
                                return t1[0] = e1[0] / r[0], t1[1] = e1[1] / r[1], t1[2] = e1[2] / r[2], t1;
                            };
                        },
                        244: function(t1) {
                            t1.exports = function(t1, e1) {
                                return t1[0] * e1[0] + t1[1] * e1[1] + t1[2] * e1[2];
                            };
                        },
                        2613: function(t1) {
                            t1.exports = 1e-6;
                        },
                        9922: function(t1, e1, r) {
                            t1.exports = function(t1, e1) {
                                var r = t1[0], i = t1[1], a = t1[2], o = e1[0], s = e1[1], l = e1[2];
                                return Math.abs(r - o) <= n * Math.max(1, Math.abs(r), Math.abs(o)) && Math.abs(i - s) <= n * Math.max(1, Math.abs(i), Math.abs(s)) && Math.abs(a - l) <= n * Math.max(1, Math.abs(a), Math.abs(l));
                            };
                            var n = r(2613);
                        },
                        9265: function(t1) {
                            t1.exports = function(t1, e1) {
                                return t1[0] === e1[0] && t1[1] === e1[1] && t1[2] === e1[2];
                            };
                        },
                        2681: function(t1) {
                            t1.exports = function(t1, e1) {
                                return t1[0] = Math.floor(e1[0]), t1[1] = Math.floor(e1[1]), t1[2] = Math.floor(e1[2]), t1;
                            };
                        },
                        5137: function(t1, e1, r) {
                            t1.exports = function(t1, e1, r, i, a, o) {
                                var s, l;
                                for(e1 || (e1 = 3), r || (r = 0), l = i ? Math.min(i * e1 + r, t1.length) : t1.length, s = r; s < l; s += e1)n[0] = t1[s], n[1] = t1[s + 1], n[2] = t1[s + 2], a(n, n, o), t1[s] = n[0], t1[s + 1] = n[1], t1[s + 2] = n[2];
                                return t1;
                            };
                            var n = r(1091)();
                        },
                        2825: function(t1) {
                            t1.exports = function(t1, e1, r) {
                                var n = new Float32Array(3);
                                return n[0] = t1, n[1] = e1, n[2] = r, n;
                            };
                        },
                        2931: function(t1, e1, r) {
                            t1.exports = {
                                EPSILON: r(2613),
                                create: r(1091),
                                clone: r(3126),
                                angle: r(8192),
                                fromValues: r(2825),
                                copy: r(3990),
                                set: r(1463),
                                equals: r(9922),
                                exactEquals: r(9265),
                                add: r(5632),
                                subtract: r(6843),
                                sub: r(2229),
                                multiply: r(5847),
                                mul: r(4505),
                                divide: r(6690),
                                div: r(4008),
                                min: r(8107),
                                max: r(7417),
                                floor: r(2681),
                                ceil: r(9226),
                                round: r(2447),
                                scale: r(6621),
                                scaleAndAdd: r(8489),
                                distance: r(7056),
                                dist: r(5455),
                                squaredDistance: r(2953),
                                sqrDist: r(6141),
                                length: r(1387),
                                len: r(868),
                                squaredLength: r(3066),
                                sqrLen: r(5486),
                                negate: r(5093),
                                inverse: r(811),
                                normalize: r(3536),
                                dot: r(244),
                                cross: r(5911),
                                lerp: r(6658),
                                random: r(7636),
                                transformMat4: r(5673),
                                transformMat3: r(492),
                                transformQuat: r(264),
                                rotateX: r(6894),
                                rotateY: r(109),
                                rotateZ: r(8692),
                                forEach: r(5137)
                            };
                        },
                        811: function(t1) {
                            t1.exports = function(t1, e1) {
                                return t1[0] = 1 / e1[0], t1[1] = 1 / e1[1], t1[2] = 1 / e1[2], t1;
                            };
                        },
                        868: function(t1, e1, r) {
                            t1.exports = r(1387);
                        },
                        1387: function(t1) {
                            t1.exports = function(t1) {
                                var e1 = t1[0], r = t1[1], n = t1[2];
                                return Math.sqrt(e1 * e1 + r * r + n * n);
                            };
                        },
                        6658: function(t1) {
                            t1.exports = function(t1, e1, r, n) {
                                var i = e1[0], a = e1[1], o = e1[2];
                                return t1[0] = i + n * (r[0] - i), t1[1] = a + n * (r[1] - a), t1[2] = o + n * (r[2] - o), t1;
                            };
                        },
                        7417: function(t1) {
                            t1.exports = function(t1, e1, r) {
                                return t1[0] = Math.max(e1[0], r[0]), t1[1] = Math.max(e1[1], r[1]), t1[2] = Math.max(e1[2], r[2]), t1;
                            };
                        },
                        8107: function(t1) {
                            t1.exports = function(t1, e1, r) {
                                return t1[0] = Math.min(e1[0], r[0]), t1[1] = Math.min(e1[1], r[1]), t1[2] = Math.min(e1[2], r[2]), t1;
                            };
                        },
                        4505: function(t1, e1, r) {
                            t1.exports = r(5847);
                        },
                        5847: function(t1) {
                            t1.exports = function(t1, e1, r) {
                                return t1[0] = e1[0] * r[0], t1[1] = e1[1] * r[1], t1[2] = e1[2] * r[2], t1;
                            };
                        },
                        5093: function(t1) {
                            t1.exports = function(t1, e1) {
                                return t1[0] = -e1[0], t1[1] = -e1[1], t1[2] = -e1[2], t1;
                            };
                        },
                        3536: function(t1) {
                            t1.exports = function(t1, e1) {
                                var r = e1[0], n = e1[1], i = e1[2], a = r * r + n * n + i * i;
                                return a > 0 && (a = 1 / Math.sqrt(a), t1[0] = e1[0] * a, t1[1] = e1[1] * a, t1[2] = e1[2] * a), t1;
                            };
                        },
                        7636: function(t1) {
                            t1.exports = function(t1, e1) {
                                e1 = e1 || 1;
                                var r = 2 * Math.random() * Math.PI, n = 2 * Math.random() - 1, i = Math.sqrt(1 - n * n) * e1;
                                return t1[0] = Math.cos(r) * i, t1[1] = Math.sin(r) * i, t1[2] = n * e1, t1;
                            };
                        },
                        6894: function(t1) {
                            t1.exports = function(t1, e1, r, n) {
                                var i = r[1], a = r[2], o = e1[1] - i, s = e1[2] - a, l = Math.sin(n), c = Math.cos(n);
                                return t1[0] = e1[0], t1[1] = i + o * c - s * l, t1[2] = a + o * l + s * c, t1;
                            };
                        },
                        109: function(t1) {
                            t1.exports = function(t1, e1, r, n) {
                                var i = r[0], a = r[2], o = e1[0] - i, s = e1[2] - a, l = Math.sin(n), c = Math.cos(n);
                                return t1[0] = i + s * l + o * c, t1[1] = e1[1], t1[2] = a + s * c - o * l, t1;
                            };
                        },
                        8692: function(t1) {
                            t1.exports = function(t1, e1, r, n) {
                                var i = r[0], a = r[1], o = e1[0] - i, s = e1[1] - a, l = Math.sin(n), c = Math.cos(n);
                                return t1[0] = i + o * c - s * l, t1[1] = a + o * l + s * c, t1[2] = e1[2], t1;
                            };
                        },
                        2447: function(t1) {
                            t1.exports = function(t1, e1) {
                                return t1[0] = Math.round(e1[0]), t1[1] = Math.round(e1[1]), t1[2] = Math.round(e1[2]), t1;
                            };
                        },
                        6621: function(t1) {
                            t1.exports = function(t1, e1, r) {
                                return t1[0] = e1[0] * r, t1[1] = e1[1] * r, t1[2] = e1[2] * r, t1;
                            };
                        },
                        8489: function(t1) {
                            t1.exports = function(t1, e1, r, n) {
                                return t1[0] = e1[0] + r[0] * n, t1[1] = e1[1] + r[1] * n, t1[2] = e1[2] + r[2] * n, t1;
                            };
                        },
                        1463: function(t1) {
                            t1.exports = function(t1, e1, r, n) {
                                return t1[0] = e1, t1[1] = r, t1[2] = n, t1;
                            };
                        },
                        6141: function(t1, e1, r) {
                            t1.exports = r(2953);
                        },
                        5486: function(t1, e1, r) {
                            t1.exports = r(3066);
                        },
                        2953: function(t1) {
                            t1.exports = function(t1, e1) {
                                var r = e1[0] - t1[0], n = e1[1] - t1[1], i = e1[2] - t1[2];
                                return r * r + n * n + i * i;
                            };
                        },
                        3066: function(t1) {
                            t1.exports = function(t1) {
                                var e1 = t1[0], r = t1[1], n = t1[2];
                                return e1 * e1 + r * r + n * n;
                            };
                        },
                        2229: function(t1, e1, r) {
                            t1.exports = r(6843);
                        },
                        6843: function(t1) {
                            t1.exports = function(t1, e1, r) {
                                return t1[0] = e1[0] - r[0], t1[1] = e1[1] - r[1], t1[2] = e1[2] - r[2], t1;
                            };
                        },
                        492: function(t1) {
                            t1.exports = function(t1, e1, r) {
                                var n = e1[0], i = e1[1], a = e1[2];
                                return t1[0] = n * r[0] + i * r[3] + a * r[6], t1[1] = n * r[1] + i * r[4] + a * r[7], t1[2] = n * r[2] + i * r[5] + a * r[8], t1;
                            };
                        },
                        5673: function(t1) {
                            t1.exports = function(t1, e1, r) {
                                var n = e1[0], i = e1[1], a = e1[2], o = r[3] * n + r[7] * i + r[11] * a + r[15];
                                return o = o || 1, t1[0] = (r[0] * n + r[4] * i + r[8] * a + r[12]) / o, t1[1] = (r[1] * n + r[5] * i + r[9] * a + r[13]) / o, t1[2] = (r[2] * n + r[6] * i + r[10] * a + r[14]) / o, t1;
                            };
                        },
                        264: function(t1) {
                            t1.exports = function(t1, e1, r) {
                                var n = e1[0], i = e1[1], a = e1[2], o = r[0], s = r[1], l = r[2], c = r[3], u = c * n + s * a - l * i, h = c * i + l * n - o * a, f = c * a + o * i - s * n, p = -o * n - s * i - l * a;
                                return t1[0] = u * c + p * -o + h * -l - f * -s, t1[1] = h * c + p * -s + f * -o - u * -l, t1[2] = f * c + p * -l + u * -s - h * -o, t1;
                            };
                        },
                        4361: function(t1) {
                            t1.exports = function(t1, e1, r) {
                                return t1[0] = e1[0] + r[0], t1[1] = e1[1] + r[1], t1[2] = e1[2] + r[2], t1[3] = e1[3] + r[3], t1;
                            };
                        },
                        2335: function(t1) {
                            t1.exports = function(t1) {
                                var e1 = new Float32Array(4);
                                return e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1[3] = t1[3], e1;
                            };
                        },
                        2933: function(t1) {
                            t1.exports = function(t1, e1) {
                                return t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1[3] = e1[3], t1;
                            };
                        },
                        7536: function(t1) {
                            t1.exports = function() {
                                var t1 = new Float32Array(4);
                                return t1[0] = 0, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1;
                            };
                        },
                        4691: function(t1) {
                            t1.exports = function(t1, e1) {
                                var r = e1[0] - t1[0], n = e1[1] - t1[1], i = e1[2] - t1[2], a = e1[3] - t1[3];
                                return Math.sqrt(r * r + n * n + i * i + a * a);
                            };
                        },
                        1373: function(t1) {
                            t1.exports = function(t1, e1, r) {
                                return t1[0] = e1[0] / r[0], t1[1] = e1[1] / r[1], t1[2] = e1[2] / r[2], t1[3] = e1[3] / r[3], t1;
                            };
                        },
                        3750: function(t1) {
                            t1.exports = function(t1, e1) {
                                return t1[0] * e1[0] + t1[1] * e1[1] + t1[2] * e1[2] + t1[3] * e1[3];
                            };
                        },
                        3390: function(t1) {
                            t1.exports = function(t1, e1, r, n) {
                                var i = new Float32Array(4);
                                return i[0] = t1, i[1] = e1, i[2] = r, i[3] = n, i;
                            };
                        },
                        9970: function(t1, e1, r) {
                            t1.exports = {
                                create: r(7536),
                                clone: r(2335),
                                fromValues: r(3390),
                                copy: r(2933),
                                set: r(4578),
                                add: r(4361),
                                subtract: r(6860),
                                multiply: r(3576),
                                divide: r(1373),
                                min: r(2334),
                                max: r(160),
                                scale: r(9288),
                                scaleAndAdd: r(4844),
                                distance: r(4691),
                                squaredDistance: r(7960),
                                length: r(6808),
                                squaredLength: r(483),
                                negate: r(1498),
                                inverse: r(4494),
                                normalize: r(5177),
                                dot: r(3750),
                                lerp: r(2573),
                                random: r(9131),
                                transformMat4: r(5352),
                                transformQuat: r(4041)
                            };
                        },
                        4494: function(t1) {
                            t1.exports = function(t1, e1) {
                                return t1[0] = 1 / e1[0], t1[1] = 1 / e1[1], t1[2] = 1 / e1[2], t1[3] = 1 / e1[3], t1;
                            };
                        },
                        6808: function(t1) {
                            t1.exports = function(t1) {
                                var e1 = t1[0], r = t1[1], n = t1[2], i = t1[3];
                                return Math.sqrt(e1 * e1 + r * r + n * n + i * i);
                            };
                        },
                        2573: function(t1) {
                            t1.exports = function(t1, e1, r, n) {
                                var i = e1[0], a = e1[1], o = e1[2], s = e1[3];
                                return t1[0] = i + n * (r[0] - i), t1[1] = a + n * (r[1] - a), t1[2] = o + n * (r[2] - o), t1[3] = s + n * (r[3] - s), t1;
                            };
                        },
                        160: function(t1) {
                            t1.exports = function(t1, e1, r) {
                                return t1[0] = Math.max(e1[0], r[0]), t1[1] = Math.max(e1[1], r[1]), t1[2] = Math.max(e1[2], r[2]), t1[3] = Math.max(e1[3], r[3]), t1;
                            };
                        },
                        2334: function(t1) {
                            t1.exports = function(t1, e1, r) {
                                return t1[0] = Math.min(e1[0], r[0]), t1[1] = Math.min(e1[1], r[1]), t1[2] = Math.min(e1[2], r[2]), t1[3] = Math.min(e1[3], r[3]), t1;
                            };
                        },
                        3576: function(t1) {
                            t1.exports = function(t1, e1, r) {
                                return t1[0] = e1[0] * r[0], t1[1] = e1[1] * r[1], t1[2] = e1[2] * r[2], t1[3] = e1[3] * r[3], t1;
                            };
                        },
                        1498: function(t1) {
                            t1.exports = function(t1, e1) {
                                return t1[0] = -e1[0], t1[1] = -e1[1], t1[2] = -e1[2], t1[3] = -e1[3], t1;
                            };
                        },
                        5177: function(t1) {
                            t1.exports = function(t1, e1) {
                                var r = e1[0], n = e1[1], i = e1[2], a = e1[3], o = r * r + n * n + i * i + a * a;
                                return o > 0 && (o = 1 / Math.sqrt(o), t1[0] = r * o, t1[1] = n * o, t1[2] = i * o, t1[3] = a * o), t1;
                            };
                        },
                        9131: function(t1, e1, r) {
                            var n = r(5177), i = r(9288);
                            t1.exports = function(t1, e1) {
                                return e1 = e1 || 1, t1[0] = Math.random(), t1[1] = Math.random(), t1[2] = Math.random(), t1[3] = Math.random(), n(t1, t1), i(t1, t1, e1), t1;
                            };
                        },
                        9288: function(t1) {
                            t1.exports = function(t1, e1, r) {
                                return t1[0] = e1[0] * r, t1[1] = e1[1] * r, t1[2] = e1[2] * r, t1[3] = e1[3] * r, t1;
                            };
                        },
                        4844: function(t1) {
                            t1.exports = function(t1, e1, r, n) {
                                return t1[0] = e1[0] + r[0] * n, t1[1] = e1[1] + r[1] * n, t1[2] = e1[2] + r[2] * n, t1[3] = e1[3] + r[3] * n, t1;
                            };
                        },
                        4578: function(t1) {
                            t1.exports = function(t1, e1, r, n, i) {
                                return t1[0] = e1, t1[1] = r, t1[2] = n, t1[3] = i, t1;
                            };
                        },
                        7960: function(t1) {
                            t1.exports = function(t1, e1) {
                                var r = e1[0] - t1[0], n = e1[1] - t1[1], i = e1[2] - t1[2], a = e1[3] - t1[3];
                                return r * r + n * n + i * i + a * a;
                            };
                        },
                        483: function(t1) {
                            t1.exports = function(t1) {
                                var e1 = t1[0], r = t1[1], n = t1[2], i = t1[3];
                                return e1 * e1 + r * r + n * n + i * i;
                            };
                        },
                        6860: function(t1) {
                            t1.exports = function(t1, e1, r) {
                                return t1[0] = e1[0] - r[0], t1[1] = e1[1] - r[1], t1[2] = e1[2] - r[2], t1[3] = e1[3] - r[3], t1;
                            };
                        },
                        5352: function(t1) {
                            t1.exports = function(t1, e1, r) {
                                var n = e1[0], i = e1[1], a = e1[2], o = e1[3];
                                return t1[0] = r[0] * n + r[4] * i + r[8] * a + r[12] * o, t1[1] = r[1] * n + r[5] * i + r[9] * a + r[13] * o, t1[2] = r[2] * n + r[6] * i + r[10] * a + r[14] * o, t1[3] = r[3] * n + r[7] * i + r[11] * a + r[15] * o, t1;
                            };
                        },
                        4041: function(t1) {
                            t1.exports = function(t1, e1, r) {
                                var n = e1[0], i = e1[1], a = e1[2], o = r[0], s = r[1], l = r[2], c = r[3], u = c * n + s * a - l * i, h = c * i + l * n - o * a, f = c * a + o * i - s * n, p = -o * n - s * i - l * a;
                                return t1[0] = u * c + p * -o + h * -l - f * -s, t1[1] = h * c + p * -s + f * -o - u * -l, t1[2] = f * c + p * -l + u * -s - h * -o, t1[3] = e1[3], t1;
                            };
                        },
                        1848: function(t1, e1, r) {
                            var n = r(4905), i = r(6468);
                            t1.exports = function(t1) {
                                for(var e1 = Array.isArray(t1) ? t1 : n(t1), r = 0; r < e1.length; r++){
                                    var a = e1[r];
                                    if ("preprocessor" === a.type) {
                                        var o = a.data.match(/\#define\s+SHADER_NAME(_B64)?\s+(.+)$/);
                                        if (o && o[2]) {
                                            var s = o[1], l = o[2];
                                            return (s ? i(l) : l).trim();
                                        }
                                    }
                                }
                            };
                        },
                        5874: function(t1, e1, r) {
                            t1.exports = function(t1) {
                                var e1, r, T, k = 0, A = 0, M = l, S = [], E = [], C = 1, L = 0, I = 0, P = !1, z = !1, O = "", D = a, R = n;
                                "300 es" === (t1 = t1 || {}).version && (D = s, R = o);
                                var F = {}, B = {};
                                for(k = 0; k < D.length; k++)F[D[k]] = !0;
                                for(k = 0; k < R.length; k++)B[R[k]] = !0;
                                return function(t1) {
                                    return E = [], null !== t1 ? function(t1) {
                                        var r;
                                        for(k = 0, t1.toString && (t1 = t1.toString()), O += t1.replace(/\r\n/g, "\n"), T = O.length; e1 = O[k], k < T;){
                                            switch(r = k, M){
                                                case u:
                                                    k = q();
                                                    break;
                                                case h:
                                                case f:
                                                    k = V();
                                                    break;
                                                case p:
                                                    k = H();
                                                    break;
                                                case d:
                                                    k = W();
                                                    break;
                                                case b:
                                                    k = Z();
                                                    break;
                                                case m:
                                                    k = Y();
                                                    break;
                                                case c:
                                                    k = X();
                                                    break;
                                                case x:
                                                    k = U();
                                                    break;
                                                case l:
                                                    k = j();
                                            }
                                            r !== k && ("\n" === O[r] ? (L = 0, ++C) : ++L);
                                        }
                                        return A += k, O = O.slice(k), E;
                                    }(t1) : (S.length && N(S.join("")), M = _, N("(eof)"), E);
                                };
                                function N(t1) {
                                    t1.length && E.push({
                                        type: w[M],
                                        data: t1,
                                        position: I,
                                        line: C,
                                        column: L
                                    });
                                }
                                function j() {
                                    return S = S.length ? [] : S, "/" === r && "*" === e1 ? (I = A + k - 1, M = u, r = e1, k + 1) : "/" === r && "/" === e1 ? (I = A + k - 1, M = h, r = e1, k + 1) : "#" === e1 ? (M = f, I = A + k, k) : /\s/.test(e1) ? (M = x, I = A + k, k) : (P = /\d/.test(e1), z = /[^\w_]/.test(e1), I = A + k, M = P ? d : z ? p : c, k);
                                }
                                function U() {
                                    return /[^\s]/g.test(e1) ? (N(S.join("")), M = l, k) : (S.push(e1), r = e1, k + 1);
                                }
                                function V() {
                                    return "\r" !== e1 && "\n" !== e1 || "\\" === r ? (S.push(e1), r = e1, k + 1) : (N(S.join("")), M = l, k);
                                }
                                function q() {
                                    return "/" === e1 && "*" === r ? (S.push(e1), N(S.join("")), M = l, k + 1) : (S.push(e1), r = e1, k + 1);
                                }
                                function H() {
                                    if ("." === r && /\d/.test(e1)) return M = m, k;
                                    if ("/" === r && "*" === e1) return M = u, k;
                                    if ("/" === r && "/" === e1) return M = h, k;
                                    if ("." === e1 && S.length) {
                                        for(; G(S););
                                        return M = m, k;
                                    }
                                    if (";" === e1 || ")" === e1 || "(" === e1) {
                                        if (S.length) for(; G(S););
                                        return N(e1), M = l, k + 1;
                                    }
                                    var t1 = 2 === S.length && "=" !== e1;
                                    if (/[\w_\d\s]/.test(e1) || t1) {
                                        for(; G(S););
                                        return M = l, k;
                                    }
                                    return S.push(e1), r = e1, k + 1;
                                }
                                function G(t1) {
                                    for(var e1, r, n = 0;;){
                                        if (e1 = i.indexOf(t1.slice(0, t1.length + n).join("")), r = i[e1], -1 === e1) {
                                            if (n-- + t1.length > 0) continue;
                                            r = t1.slice(0, 1).join("");
                                        }
                                        return N(r), I += r.length, (S = S.slice(r.length)).length;
                                    }
                                }
                                function Z() {
                                    return /[^a-fA-F0-9]/.test(e1) ? (N(S.join("")), M = l, k) : (S.push(e1), r = e1, k + 1);
                                }
                                function W() {
                                    return "." === e1 || /[eE]/.test(e1) ? (S.push(e1), M = m, r = e1, k + 1) : "x" === e1 && 1 === S.length && "0" === S[0] ? (M = b, S.push(e1), r = e1, k + 1) : /[^\d]/.test(e1) ? (N(S.join("")), M = l, k) : (S.push(e1), r = e1, k + 1);
                                }
                                function Y() {
                                    return "f" === e1 && (S.push(e1), r = e1, k += 1), /[eE]/.test(e1) ? (S.push(e1), r = e1, k + 1) : ("-" !== e1 && "+" !== e1 || !/[eE]/.test(r)) && /[^\d]/.test(e1) ? (N(S.join("")), M = l, k) : (S.push(e1), r = e1, k + 1);
                                }
                                function X() {
                                    if (/[^\d\w_]/.test(e1)) {
                                        var t1 = S.join("");
                                        return M = B[t1] ? v : F[t1] ? y : g, N(S.join("")), M = l, k;
                                    }
                                    return S.push(e1), r = e1, k + 1;
                                }
                            };
                            var n = r(620), i = r(7827), a = r(6852), o = r(7932), s = r(3508), l = 999, c = 9999, u = 0, h = 1, f = 2, p = 3, d = 4, m = 5, g = 6, y = 7, v = 8, x = 9, _ = 10, b = 11, w = [
                                "block-comment",
                                "line-comment",
                                "preprocessor",
                                "operator",
                                "integer",
                                "float",
                                "ident",
                                "builtin",
                                "keyword",
                                "whitespace",
                                "eof",
                                "integer"
                            ];
                        },
                        3508: function(t1, e1, r) {
                            var n = r(6852);
                            n = n.slice().filter(function(t1) {
                                return !/^(gl\_|texture)/.test(t1);
                            }), t1.exports = n.concat([
                                "gl_VertexID",
                                "gl_InstanceID",
                                "gl_Position",
                                "gl_PointSize",
                                "gl_FragCoord",
                                "gl_FrontFacing",
                                "gl_FragDepth",
                                "gl_PointCoord",
                                "gl_MaxVertexAttribs",
                                "gl_MaxVertexUniformVectors",
                                "gl_MaxVertexOutputVectors",
                                "gl_MaxFragmentInputVectors",
                                "gl_MaxVertexTextureImageUnits",
                                "gl_MaxCombinedTextureImageUnits",
                                "gl_MaxTextureImageUnits",
                                "gl_MaxFragmentUniformVectors",
                                "gl_MaxDrawBuffers",
                                "gl_MinProgramTexelOffset",
                                "gl_MaxProgramTexelOffset",
                                "gl_DepthRangeParameters",
                                "gl_DepthRange",
                                "trunc",
                                "round",
                                "roundEven",
                                "isnan",
                                "isinf",
                                "floatBitsToInt",
                                "floatBitsToUint",
                                "intBitsToFloat",
                                "uintBitsToFloat",
                                "packSnorm2x16",
                                "unpackSnorm2x16",
                                "packUnorm2x16",
                                "unpackUnorm2x16",
                                "packHalf2x16",
                                "unpackHalf2x16",
                                "outerProduct",
                                "transpose",
                                "determinant",
                                "inverse",
                                "texture",
                                "textureSize",
                                "textureProj",
                                "textureLod",
                                "textureOffset",
                                "texelFetch",
                                "texelFetchOffset",
                                "textureProjOffset",
                                "textureLodOffset",
                                "textureProjLod",
                                "textureProjLodOffset",
                                "textureGrad",
                                "textureGradOffset",
                                "textureProjGrad",
                                "textureProjGradOffset"
                            ]);
                        },
                        6852: function(t1) {
                            t1.exports = [
                                "abs",
                                "acos",
                                "all",
                                "any",
                                "asin",
                                "atan",
                                "ceil",
                                "clamp",
                                "cos",
                                "cross",
                                "dFdx",
                                "dFdy",
                                "degrees",
                                "distance",
                                "dot",
                                "equal",
                                "exp",
                                "exp2",
                                "faceforward",
                                "floor",
                                "fract",
                                "gl_BackColor",
                                "gl_BackLightModelProduct",
                                "gl_BackLightProduct",
                                "gl_BackMaterial",
                                "gl_BackSecondaryColor",
                                "gl_ClipPlane",
                                "gl_ClipVertex",
                                "gl_Color",
                                "gl_DepthRange",
                                "gl_DepthRangeParameters",
                                "gl_EyePlaneQ",
                                "gl_EyePlaneR",
                                "gl_EyePlaneS",
                                "gl_EyePlaneT",
                                "gl_Fog",
                                "gl_FogCoord",
                                "gl_FogFragCoord",
                                "gl_FogParameters",
                                "gl_FragColor",
                                "gl_FragCoord",
                                "gl_FragData",
                                "gl_FragDepth",
                                "gl_FragDepthEXT",
                                "gl_FrontColor",
                                "gl_FrontFacing",
                                "gl_FrontLightModelProduct",
                                "gl_FrontLightProduct",
                                "gl_FrontMaterial",
                                "gl_FrontSecondaryColor",
                                "gl_LightModel",
                                "gl_LightModelParameters",
                                "gl_LightModelProducts",
                                "gl_LightProducts",
                                "gl_LightSource",
                                "gl_LightSourceParameters",
                                "gl_MaterialParameters",
                                "gl_MaxClipPlanes",
                                "gl_MaxCombinedTextureImageUnits",
                                "gl_MaxDrawBuffers",
                                "gl_MaxFragmentUniformComponents",
                                "gl_MaxLights",
                                "gl_MaxTextureCoords",
                                "gl_MaxTextureImageUnits",
                                "gl_MaxTextureUnits",
                                "gl_MaxVaryingFloats",
                                "gl_MaxVertexAttribs",
                                "gl_MaxVertexTextureImageUnits",
                                "gl_MaxVertexUniformComponents",
                                "gl_ModelViewMatrix",
                                "gl_ModelViewMatrixInverse",
                                "gl_ModelViewMatrixInverseTranspose",
                                "gl_ModelViewMatrixTranspose",
                                "gl_ModelViewProjectionMatrix",
                                "gl_ModelViewProjectionMatrixInverse",
                                "gl_ModelViewProjectionMatrixInverseTranspose",
                                "gl_ModelViewProjectionMatrixTranspose",
                                "gl_MultiTexCoord0",
                                "gl_MultiTexCoord1",
                                "gl_MultiTexCoord2",
                                "gl_MultiTexCoord3",
                                "gl_MultiTexCoord4",
                                "gl_MultiTexCoord5",
                                "gl_MultiTexCoord6",
                                "gl_MultiTexCoord7",
                                "gl_Normal",
                                "gl_NormalMatrix",
                                "gl_NormalScale",
                                "gl_ObjectPlaneQ",
                                "gl_ObjectPlaneR",
                                "gl_ObjectPlaneS",
                                "gl_ObjectPlaneT",
                                "gl_Point",
                                "gl_PointCoord",
                                "gl_PointParameters",
                                "gl_PointSize",
                                "gl_Position",
                                "gl_ProjectionMatrix",
                                "gl_ProjectionMatrixInverse",
                                "gl_ProjectionMatrixInverseTranspose",
                                "gl_ProjectionMatrixTranspose",
                                "gl_SecondaryColor",
                                "gl_TexCoord",
                                "gl_TextureEnvColor",
                                "gl_TextureMatrix",
                                "gl_TextureMatrixInverse",
                                "gl_TextureMatrixInverseTranspose",
                                "gl_TextureMatrixTranspose",
                                "gl_Vertex",
                                "greaterThan",
                                "greaterThanEqual",
                                "inversesqrt",
                                "length",
                                "lessThan",
                                "lessThanEqual",
                                "log",
                                "log2",
                                "matrixCompMult",
                                "max",
                                "min",
                                "mix",
                                "mod",
                                "normalize",
                                "not",
                                "notEqual",
                                "pow",
                                "radians",
                                "reflect",
                                "refract",
                                "sign",
                                "sin",
                                "smoothstep",
                                "sqrt",
                                "step",
                                "tan",
                                "texture2D",
                                "texture2DLod",
                                "texture2DProj",
                                "texture2DProjLod",
                                "textureCube",
                                "textureCubeLod",
                                "texture2DLodEXT",
                                "texture2DProjLodEXT",
                                "textureCubeLodEXT",
                                "texture2DGradEXT",
                                "texture2DProjGradEXT",
                                "textureCubeGradEXT"
                            ];
                        },
                        7932: function(t1, e1, r) {
                            var n = r(620);
                            t1.exports = n.slice().concat([
                                "layout",
                                "centroid",
                                "smooth",
                                "case",
                                "mat2x2",
                                "mat2x3",
                                "mat2x4",
                                "mat3x2",
                                "mat3x3",
                                "mat3x4",
                                "mat4x2",
                                "mat4x3",
                                "mat4x4",
                                "uvec2",
                                "uvec3",
                                "uvec4",
                                "samplerCubeShadow",
                                "sampler2DArray",
                                "sampler2DArrayShadow",
                                "isampler2D",
                                "isampler3D",
                                "isamplerCube",
                                "isampler2DArray",
                                "usampler2D",
                                "usampler3D",
                                "usamplerCube",
                                "usampler2DArray",
                                "coherent",
                                "restrict",
                                "readonly",
                                "writeonly",
                                "resource",
                                "atomic_uint",
                                "noperspective",
                                "patch",
                                "sample",
                                "subroutine",
                                "common",
                                "partition",
                                "active",
                                "filter",
                                "image1D",
                                "image2D",
                                "image3D",
                                "imageCube",
                                "iimage1D",
                                "iimage2D",
                                "iimage3D",
                                "iimageCube",
                                "uimage1D",
                                "uimage2D",
                                "uimage3D",
                                "uimageCube",
                                "image1DArray",
                                "image2DArray",
                                "iimage1DArray",
                                "iimage2DArray",
                                "uimage1DArray",
                                "uimage2DArray",
                                "image1DShadow",
                                "image2DShadow",
                                "image1DArrayShadow",
                                "image2DArrayShadow",
                                "imageBuffer",
                                "iimageBuffer",
                                "uimageBuffer",
                                "sampler1DArray",
                                "sampler1DArrayShadow",
                                "isampler1D",
                                "isampler1DArray",
                                "usampler1D",
                                "usampler1DArray",
                                "isampler2DRect",
                                "usampler2DRect",
                                "samplerBuffer",
                                "isamplerBuffer",
                                "usamplerBuffer",
                                "sampler2DMS",
                                "isampler2DMS",
                                "usampler2DMS",
                                "sampler2DMSArray",
                                "isampler2DMSArray",
                                "usampler2DMSArray"
                            ]);
                        },
                        620: function(t1) {
                            t1.exports = [
                                "precision",
                                "highp",
                                "mediump",
                                "lowp",
                                "attribute",
                                "const",
                                "uniform",
                                "varying",
                                "break",
                                "continue",
                                "do",
                                "for",
                                "while",
                                "if",
                                "else",
                                "in",
                                "out",
                                "inout",
                                "float",
                                "int",
                                "uint",
                                "void",
                                "bool",
                                "true",
                                "false",
                                "discard",
                                "return",
                                "mat2",
                                "mat3",
                                "mat4",
                                "vec2",
                                "vec3",
                                "vec4",
                                "ivec2",
                                "ivec3",
                                "ivec4",
                                "bvec2",
                                "bvec3",
                                "bvec4",
                                "sampler1D",
                                "sampler2D",
                                "sampler3D",
                                "samplerCube",
                                "sampler1DShadow",
                                "sampler2DShadow",
                                "struct",
                                "asm",
                                "class",
                                "union",
                                "enum",
                                "typedef",
                                "template",
                                "this",
                                "packed",
                                "goto",
                                "switch",
                                "default",
                                "inline",
                                "noinline",
                                "volatile",
                                "public",
                                "static",
                                "extern",
                                "external",
                                "interface",
                                "long",
                                "short",
                                "double",
                                "half",
                                "fixed",
                                "unsigned",
                                "input",
                                "output",
                                "hvec2",
                                "hvec3",
                                "hvec4",
                                "dvec2",
                                "dvec3",
                                "dvec4",
                                "fvec2",
                                "fvec3",
                                "fvec4",
                                "sampler2DRect",
                                "sampler3DRect",
                                "sampler2DRectShadow",
                                "sizeof",
                                "cast",
                                "namespace",
                                "using"
                            ];
                        },
                        7827: function(t1) {
                            t1.exports = [
                                "<<=",
                                ">>=",
                                "++",
                                "--",
                                "<<",
                                ">>",
                                "<=",
                                ">=",
                                "==",
                                "!=",
                                "&&",
                                "||",
                                "+=",
                                "-=",
                                "*=",
                                "/=",
                                "%=",
                                "&=",
                                "^^",
                                "^=",
                                "|=",
                                "(",
                                ")",
                                "[",
                                "]",
                                ".",
                                "!",
                                "~",
                                "*",
                                "/",
                                "%",
                                "+",
                                "-",
                                "<",
                                ">",
                                "&",
                                "^",
                                "|",
                                "?",
                                ":",
                                "=",
                                ",",
                                ";",
                                "{",
                                "}"
                            ];
                        },
                        4905: function(t1, e1, r) {
                            var n = r(5874);
                            t1.exports = function(t1, e1) {
                                var r = n(e1), i = [];
                                return (i = i.concat(r(t1))).concat(r(null));
                            };
                        },
                        3236: function(t1) {
                            t1.exports = function(t1) {
                                "string" == typeof t1 && (t1 = [
                                    t1
                                ]);
                                for(var e1 = [].slice.call(arguments, 1), r = [], n = 0; n < t1.length - 1; n++)r.push(t1[n], e1[n] || "");
                                return r.push(t1[n]), r.join("");
                            };
                        },
                        7520: function(t1, e1, r) {
                            "use strict";
                            var n = r(9507);
                            t1.exports = n && function() {
                                var t1 = !1;
                                try {
                                    var e1 = Object.defineProperty({}, "passive", {
                                        get: function() {
                                            t1 = !0;
                                        }
                                    });
                                    window.addEventListener("test", null, e1), window.removeEventListener("test", null, e1);
                                } catch (e1) {
                                    t1 = !1;
                                }
                                return t1;
                            }();
                        },
                        3778: function(t1, e1) {
                            e1.read = function(t1, e1, r, n, i) {
                                var a, o, s = 8 * i - n - 1, l = (1 << s) - 1, c = l >> 1, u = -7, h = r ? i - 1 : 0, f = r ? -1 : 1, p = t1[e1 + h];
                                for(h += f, a = p & (1 << -u) - 1, p >>= -u, u += s; u > 0; a = 256 * a + t1[e1 + h], h += f, u -= 8);
                                for(o = a & (1 << -u) - 1, a >>= -u, u += n; u > 0; o = 256 * o + t1[e1 + h], h += f, u -= 8);
                                if (0 === a) a = 1 - c;
                                else {
                                    if (a === l) return o ? NaN : 1 / 0 * (p ? -1 : 1);
                                    o += Math.pow(2, n), a -= c;
                                }
                                return (p ? -1 : 1) * o * Math.pow(2, a - n);
                            }, e1.write = function(t1, e1, r, n, i, a) {
                                var o, s, l, c = 8 * a - i - 1, u = (1 << c) - 1, h = u >> 1, f = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, p = n ? 0 : a - 1, d = n ? 1 : -1, m = e1 < 0 || 0 === e1 && 1 / e1 < 0 ? 1 : 0;
                                for(e1 = Math.abs(e1), isNaN(e1) || e1 === 1 / 0 ? (s = isNaN(e1) ? 1 : 0, o = u) : (o = Math.floor(Math.log(e1) / Math.LN2), e1 * (l = Math.pow(2, -o)) < 1 && (o--, l *= 2), (e1 += o + h >= 1 ? f / l : f * Math.pow(2, 1 - h)) * l >= 2 && (o++, l /= 2), o + h >= u ? (s = 0, o = u) : o + h >= 1 ? (s = (e1 * l - 1) * Math.pow(2, i), o += h) : (s = e1 * Math.pow(2, h - 1) * Math.pow(2, i), o = 0)); i >= 8; t1[r + p] = 255 & s, p += d, s /= 256, i -= 8);
                                for(o = o << i | s, c += i; c > 0; t1[r + p] = 255 & o, p += d, o /= 256, c -= 8);
                                t1[r + p - d] |= 128 * m;
                            };
                        },
                        8954: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1) {
                                var r = t1.length;
                                if (0 === r) throw new Error("Must have at least d+1 points");
                                var i = t1[0].length;
                                if (r <= i) throw new Error("Must input at least d+1 points");
                                var o = t1.slice(0, i + 1), s = n.apply(void 0, o);
                                if (0 === s) throw new Error("Input not in general position");
                                for(var l = new Array(i + 1), u = 0; u <= i; ++u)l[u] = u;
                                s < 0 && (l[0] = 1, l[1] = 0);
                                var h = new a(l, new Array(i + 1), !1), f = h.adjacent, p = new Array(i + 2);
                                for(u = 0; u <= i; ++u){
                                    for(var d = l.slice(), m = 0; m <= i; ++m)m === u && (d[m] = -1);
                                    var g = d[0];
                                    d[0] = d[1], d[1] = g;
                                    var y = new a(d, new Array(i + 1), !0);
                                    f[u] = y, p[u] = y;
                                }
                                for(p[i + 1] = h, u = 0; u <= i; ++u){
                                    d = f[u].vertices;
                                    var v = f[u].adjacent;
                                    for(m = 0; m <= i; ++m){
                                        var x = d[m];
                                        if (x < 0) v[m] = h;
                                        else for(var _ = 0; _ <= i; ++_)f[_].vertices.indexOf(x) < 0 && (v[m] = f[_]);
                                    }
                                }
                                var b = new c(i, o, p), w = !!e1;
                                for(u = i + 1; u < r; ++u)b.insert(t1[u], w);
                                return b.boundary();
                            };
                            var n = r(3250), i = r(6803).Fw;
                            function a(t1, e1, r) {
                                this.vertices = t1, this.adjacent = e1, this.boundary = r, this.lastVisited = -1;
                            }
                            function o(t1, e1, r) {
                                this.vertices = t1, this.cell = e1, this.index = r;
                            }
                            function s(t1, e1) {
                                return i(t1.vertices, e1.vertices);
                            }
                            a.prototype.flip = function() {
                                var t1 = this.vertices[0];
                                this.vertices[0] = this.vertices[1], this.vertices[1] = t1;
                                var e1 = this.adjacent[0];
                                this.adjacent[0] = this.adjacent[1], this.adjacent[1] = e1;
                            };
                            var l = [];
                            function c(t1, e1, r) {
                                this.dimension = t1, this.vertices = e1, this.simplices = r, this.interior = r.filter(function(t1) {
                                    return !t1.boundary;
                                }), this.tuple = new Array(t1 + 1);
                                for(var i = 0; i <= t1; ++i)this.tuple[i] = this.vertices[i];
                                var a, o = l[t1];
                                o || (o = l[t1] = ((a = n[t1 + 1]) || (a = n), function(t1) {
                                    return function() {
                                        var e1 = this.tuple;
                                        return t1.apply(this, e1);
                                    };
                                }(a))), this.orient = o;
                            }
                            var u = c.prototype;
                            u.handleBoundaryDegeneracy = function(t1, e1) {
                                var r = this.dimension, n = this.vertices.length - 1, i = this.tuple, a = this.vertices, o = [
                                    t1
                                ];
                                for(t1.lastVisited = -n; o.length > 0;)for(var s = (t1 = o.pop()).adjacent, l = 0; l <= r; ++l){
                                    var c = s[l];
                                    if (c.boundary && !(c.lastVisited <= -n)) {
                                        for(var u = c.vertices, h = 0; h <= r; ++h){
                                            var f = u[h];
                                            i[h] = f < 0 ? e1 : a[f];
                                        }
                                        var p = this.orient();
                                        if (p > 0) return c;
                                        c.lastVisited = -n, 0 === p && o.push(c);
                                    }
                                }
                                return null;
                            }, u.walk = function(t1, e1) {
                                var r = this.vertices.length - 1, n = this.dimension, i = this.vertices, a = this.tuple, o = e1 ? this.interior.length * Math.random() | 0 : this.interior.length - 1, s = this.interior[o];
                                t: for(; !s.boundary;){
                                    for(var l = s.vertices, c = s.adjacent, u = 0; u <= n; ++u)a[u] = i[l[u]];
                                    for(s.lastVisited = r, u = 0; u <= n; ++u){
                                        var h = c[u];
                                        if (!(h.lastVisited >= r)) {
                                            var f = a[u];
                                            a[u] = t1;
                                            var p = this.orient();
                                            if (a[u] = f, p < 0) {
                                                s = h;
                                                continue t;
                                            }
                                            h.boundary ? h.lastVisited = -r : h.lastVisited = r;
                                        }
                                    }
                                    return;
                                }
                                return s;
                            }, u.addPeaks = function(t1, e1) {
                                var r = this.vertices.length - 1, n = this.dimension, i = this.vertices, l = this.tuple, c = this.interior, u = this.simplices, h = [
                                    e1
                                ];
                                e1.lastVisited = r, e1.vertices[e1.vertices.indexOf(-1)] = r, e1.boundary = !1, c.push(e1);
                                for(var f = []; h.length > 0;){
                                    var p = (e1 = h.pop()).vertices, d = e1.adjacent, m = p.indexOf(r);
                                    if (!(m < 0)) {
                                        for(var g = 0; g <= n; ++g)if (g !== m) {
                                            var y = d[g];
                                            if (y.boundary && !(y.lastVisited >= r)) {
                                                var v = y.vertices;
                                                if (y.lastVisited !== -r) {
                                                    for(var x = 0, _ = 0; _ <= n; ++_)v[_] < 0 ? (x = _, l[_] = t1) : l[_] = i[v[_]];
                                                    if (this.orient() > 0) {
                                                        v[x] = r, y.boundary = !1, c.push(y), h.push(y), y.lastVisited = r;
                                                        continue;
                                                    }
                                                    y.lastVisited = -r;
                                                }
                                                var b = y.adjacent, w = p.slice(), T = d.slice(), k = new a(w, T, !0);
                                                u.push(k);
                                                var A = b.indexOf(e1);
                                                if (!(A < 0)) for(b[A] = k, T[m] = y, w[g] = -1, T[g] = e1, d[g] = k, k.flip(), _ = 0; _ <= n; ++_){
                                                    var M = w[_];
                                                    if (!(M < 0 || M === r)) {
                                                        for(var S = new Array(n - 1), E = 0, C = 0; C <= n; ++C){
                                                            var L = w[C];
                                                            L < 0 || C === _ || (S[E++] = L);
                                                        }
                                                        f.push(new o(S, k, _));
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                for(f.sort(s), g = 0; g + 1 < f.length; g += 2){
                                    var I = f[g], P = f[g + 1], z = I.index, O = P.index;
                                    z < 0 || O < 0 || (I.cell.adjacent[I.index] = P.cell, P.cell.adjacent[P.index] = I.cell);
                                }
                            }, u.insert = function(t1, e1) {
                                var r = this.vertices;
                                r.push(t1);
                                var n = this.walk(t1, e1);
                                if (n) {
                                    for(var i = this.dimension, a = this.tuple, o = 0; o <= i; ++o){
                                        var s = n.vertices[o];
                                        a[o] = s < 0 ? t1 : r[s];
                                    }
                                    var l = this.orient(a);
                                    l < 0 || (0 !== l || (n = this.handleBoundaryDegeneracy(n, t1))) && this.addPeaks(t1, n);
                                }
                            }, u.boundary = function() {
                                for(var t1 = this.dimension, e1 = [], r = this.simplices, n = r.length, i = 0; i < n; ++i){
                                    var a = r[i];
                                    if (a.boundary) {
                                        for(var o = new Array(t1), s = a.vertices, l = 0, c = 0, u = 0; u <= t1; ++u)s[u] >= 0 ? o[l++] = s[u] : c = 1 & u;
                                        if (c === (1 & t1)) {
                                            var h = o[0];
                                            o[0] = o[1], o[1] = h;
                                        }
                                        e1.push(o);
                                    }
                                }
                                return e1;
                            };
                        },
                        3352: function(t1, e1, r) {
                            "use strict";
                            var n = r(2478);
                            function i(t1, e1, r, n, i) {
                                this.mid = t1, this.left = e1, this.right = r, this.leftPoints = n, this.rightPoints = i, this.count = (e1 ? e1.count : 0) + (r ? r.count : 0) + n.length;
                            }
                            t1.exports = function(t1) {
                                return t1 && 0 !== t1.length ? new y(g(t1)) : new y(null);
                            };
                            var a = i.prototype;
                            function o(t1, e1) {
                                t1.mid = e1.mid, t1.left = e1.left, t1.right = e1.right, t1.leftPoints = e1.leftPoints, t1.rightPoints = e1.rightPoints, t1.count = e1.count;
                            }
                            function s(t1, e1) {
                                var r = g(e1);
                                t1.mid = r.mid, t1.left = r.left, t1.right = r.right, t1.leftPoints = r.leftPoints, t1.rightPoints = r.rightPoints, t1.count = r.count;
                            }
                            function l(t1, e1) {
                                var r = t1.intervals([]);
                                r.push(e1), s(t1, r);
                            }
                            function c(t1, e1) {
                                var r = t1.intervals([]), n = r.indexOf(e1);
                                return n < 0 ? 0 : (r.splice(n, 1), s(t1, r), 1);
                            }
                            function u(t1, e1, r) {
                                for(var n = 0; n < t1.length && t1[n][0] <= e1; ++n){
                                    var i = r(t1[n]);
                                    if (i) return i;
                                }
                            }
                            function h(t1, e1, r) {
                                for(var n = t1.length - 1; n >= 0 && t1[n][1] >= e1; --n){
                                    var i = r(t1[n]);
                                    if (i) return i;
                                }
                            }
                            function f(t1, e1) {
                                for(var r = 0; r < t1.length; ++r){
                                    var n = e1(t1[r]);
                                    if (n) return n;
                                }
                            }
                            function p(t1, e1) {
                                return t1 - e1;
                            }
                            function d(t1, e1) {
                                return t1[0] - e1[0] || t1[1] - e1[1];
                            }
                            function m(t1, e1) {
                                return t1[1] - e1[1] || t1[0] - e1[0];
                            }
                            function g(t1) {
                                if (0 === t1.length) return null;
                                for(var e1 = [], r = 0; r < t1.length; ++r)e1.push(t1[r][0], t1[r][1]);
                                e1.sort(p);
                                var n = e1[e1.length >> 1], a = [], o = [], s = [];
                                for(r = 0; r < t1.length; ++r){
                                    var l = t1[r];
                                    l[1] < n ? a.push(l) : n < l[0] ? o.push(l) : s.push(l);
                                }
                                var c = s, u = s.slice();
                                return c.sort(d), u.sort(m), new i(n, g(a), g(o), c, u);
                            }
                            function y(t1) {
                                this.root = t1;
                            }
                            a.intervals = function(t1) {
                                return t1.push.apply(t1, this.leftPoints), this.left && this.left.intervals(t1), this.right && this.right.intervals(t1), t1;
                            }, a.insert = function(t1) {
                                var e1 = this.count - this.leftPoints.length;
                                if (this.count += 1, t1[1] < this.mid) this.left ? 4 * (this.left.count + 1) > 3 * (e1 + 1) ? l(this, t1) : this.left.insert(t1) : this.left = g([
                                    t1
                                ]);
                                else if (t1[0] > this.mid) this.right ? 4 * (this.right.count + 1) > 3 * (e1 + 1) ? l(this, t1) : this.right.insert(t1) : this.right = g([
                                    t1
                                ]);
                                else {
                                    var r = n.ge(this.leftPoints, t1, d), i = n.ge(this.rightPoints, t1, m);
                                    this.leftPoints.splice(r, 0, t1), this.rightPoints.splice(i, 0, t1);
                                }
                            }, a.remove = function(t1) {
                                var e1 = this.count - this.leftPoints;
                                if (t1[1] < this.mid) return this.left ? 4 * (this.right ? this.right.count : 0) > 3 * (e1 - 1) ? c(this, t1) : 2 === (s = this.left.remove(t1)) ? (this.left = null, this.count -= 1, 1) : (1 === s && (this.count -= 1), s) : 0;
                                if (t1[0] > this.mid) return this.right ? 4 * (this.left ? this.left.count : 0) > 3 * (e1 - 1) ? c(this, t1) : 2 === (s = this.right.remove(t1)) ? (this.right = null, this.count -= 1, 1) : (1 === s && (this.count -= 1), s) : 0;
                                if (1 === this.count) return this.leftPoints[0] === t1 ? 2 : 0;
                                if (1 === this.leftPoints.length && this.leftPoints[0] === t1) {
                                    if (this.left && this.right) {
                                        for(var r = this, i = this.left; i.right;)r = i, i = i.right;
                                        if (r === this) i.right = this.right;
                                        else {
                                            var a = this.left, s = this.right;
                                            r.count -= i.count, r.right = i.left, i.left = a, i.right = s;
                                        }
                                        o(this, i), this.count = (this.left ? this.left.count : 0) + (this.right ? this.right.count : 0) + this.leftPoints.length;
                                    } else this.left ? o(this, this.left) : o(this, this.right);
                                    return 1;
                                }
                                for(a = n.ge(this.leftPoints, t1, d); a < this.leftPoints.length && this.leftPoints[a][0] === t1[0]; ++a)if (this.leftPoints[a] === t1) {
                                    for(this.count -= 1, this.leftPoints.splice(a, 1), s = n.ge(this.rightPoints, t1, m); s < this.rightPoints.length && this.rightPoints[s][1] === t1[1]; ++s)if (this.rightPoints[s] === t1) return this.rightPoints.splice(s, 1), 1;
                                }
                                return 0;
                            }, a.queryPoint = function(t1, e1) {
                                var r;
                                return t1 < this.mid ? this.left && (r = this.left.queryPoint(t1, e1)) ? r : u(this.leftPoints, t1, e1) : t1 > this.mid ? this.right && (r = this.right.queryPoint(t1, e1)) ? r : h(this.rightPoints, t1, e1) : f(this.leftPoints, e1);
                            }, a.queryInterval = function(t1, e1, r) {
                                var n;
                                return t1 < this.mid && this.left && (n = this.left.queryInterval(t1, e1, r)) || e1 > this.mid && this.right && (n = this.right.queryInterval(t1, e1, r)) ? n : e1 < this.mid ? u(this.leftPoints, e1, r) : t1 > this.mid ? h(this.rightPoints, t1, r) : f(this.leftPoints, r);
                            };
                            var v = y.prototype;
                            v.insert = function(t1) {
                                this.root ? this.root.insert(t1) : this.root = new i(t1[0], null, null, [
                                    t1
                                ], [
                                    t1
                                ]);
                            }, v.remove = function(t1) {
                                if (this.root) {
                                    var e1 = this.root.remove(t1);
                                    return 2 === e1 && (this.root = null), 0 !== e1;
                                }
                                return !1;
                            }, v.queryPoint = function(t1, e1) {
                                if (this.root) return this.root.queryPoint(t1, e1);
                            }, v.queryInterval = function(t1, e1, r) {
                                if (t1 <= e1 && this.root) return this.root.queryInterval(t1, e1, r);
                            }, Object.defineProperty(v, "count", {
                                get: function() {
                                    return this.root ? this.root.count : 0;
                                }
                            }), Object.defineProperty(v, "intervals", {
                                get: function() {
                                    return this.root ? this.root.intervals([]) : [];
                                }
                            });
                        },
                        7762: function(t1) {
                            "use strict";
                            t1.exports = function(t1) {
                                for(var e1 = new Array(t1), r = 0; r < t1; ++r)e1[r] = r;
                                return e1;
                            };
                        },
                        9507: function(t1) {
                            t1.exports = !0;
                        },
                        7163: function(t1) {
                            function e1(t1) {
                                return !!t1.constructor && "function" == typeof t1.constructor.isBuffer && t1.constructor.isBuffer(t1);
                            }
                            t1.exports = function(t1) {
                                return null != t1 && (e1(t1) || function(t1) {
                                    return "function" == typeof t1.readFloatLE && "function" == typeof t1.slice && e1(t1.slice(0, 0));
                                }(t1) || !!t1._isBuffer);
                            };
                        },
                        5219: function(t1) {
                            "use strict";
                            t1.exports = function(t1) {
                                for(var e1, r = t1.length, n = 0; n < r; n++)if (((e1 = t1.charCodeAt(n)) < 9 || e1 > 13) && 32 !== e1 && 133 !== e1 && 160 !== e1 && 5760 !== e1 && 6158 !== e1 && (e1 < 8192 || e1 > 8205) && 8232 !== e1 && 8233 !== e1 && 8239 !== e1 && 8287 !== e1 && 8288 !== e1 && 12288 !== e1 && 65279 !== e1) return !1;
                                return !0;
                            };
                        },
                        395: function(t1) {
                            t1.exports = function(t1, e1, r) {
                                return t1 * (1 - r) + e1 * r;
                            };
                        },
                        2652: function(t1, e1, r) {
                            var n = r(4335), i = r(6864), a = r(1903), o = r(9921), s = r(7608), l = r(5665), c = {
                                length: r(1387),
                                normalize: r(3536),
                                dot: r(244),
                                cross: r(5911)
                            }, u = i(), h = i(), f = [
                                0,
                                0,
                                0,
                                0
                            ], p = [
                                [
                                    0,
                                    0,
                                    0
                                ],
                                [
                                    0,
                                    0,
                                    0
                                ],
                                [
                                    0,
                                    0,
                                    0
                                ]
                            ], d = [
                                0,
                                0,
                                0
                            ];
                            function m(t1, e1, r, n, i) {
                                t1[0] = e1[0] * n + r[0] * i, t1[1] = e1[1] * n + r[1] * i, t1[2] = e1[2] * n + r[2] * i;
                            }
                            t1.exports = function(t1, e1, r, i, g, y) {
                                if (e1 || (e1 = [
                                    0,
                                    0,
                                    0
                                ]), r || (r = [
                                    0,
                                    0,
                                    0
                                ]), i || (i = [
                                    0,
                                    0,
                                    0
                                ]), g || (g = [
                                    0,
                                    0,
                                    0,
                                    1
                                ]), y || (y = [
                                    0,
                                    0,
                                    0,
                                    1
                                ]), !n(u, t1)) return !1;
                                if (a(h, u), h[3] = 0, h[7] = 0, h[11] = 0, h[15] = 1, Math.abs(o(h) < 1e-8)) return !1;
                                var v, x, _, b, w, T, k, A = u[3], M = u[7], S = u[11], E = u[12], C = u[13], L = u[14], I = u[15];
                                if (0 !== A || 0 !== M || 0 !== S) {
                                    if (f[0] = A, f[1] = M, f[2] = S, f[3] = I, !s(h, h)) return !1;
                                    l(h, h), v = g, _ = h, b = (x = f)[0], w = x[1], T = x[2], k = x[3], v[0] = _[0] * b + _[4] * w + _[8] * T + _[12] * k, v[1] = _[1] * b + _[5] * w + _[9] * T + _[13] * k, v[2] = _[2] * b + _[6] * w + _[10] * T + _[14] * k, v[3] = _[3] * b + _[7] * w + _[11] * T + _[15] * k;
                                } else g[0] = g[1] = g[2] = 0, g[3] = 1;
                                if (e1[0] = E, e1[1] = C, e1[2] = L, function(t1, e1) {
                                    t1[0][0] = e1[0], t1[0][1] = e1[1], t1[0][2] = e1[2], t1[1][0] = e1[4], t1[1][1] = e1[5], t1[1][2] = e1[6], t1[2][0] = e1[8], t1[2][1] = e1[9], t1[2][2] = e1[10];
                                }(p, u), r[0] = c.length(p[0]), c.normalize(p[0], p[0]), i[0] = c.dot(p[0], p[1]), m(p[1], p[1], p[0], 1, -i[0]), r[1] = c.length(p[1]), c.normalize(p[1], p[1]), i[0] /= r[1], i[1] = c.dot(p[0], p[2]), m(p[2], p[2], p[0], 1, -i[1]), i[2] = c.dot(p[1], p[2]), m(p[2], p[2], p[1], 1, -i[2]), r[2] = c.length(p[2]), c.normalize(p[2], p[2]), i[1] /= r[2], i[2] /= r[2], c.cross(d, p[1], p[2]), c.dot(p[0], d) < 0) for(var P = 0; P < 3; P++)r[P] *= -1, p[P][0] *= -1, p[P][1] *= -1, p[P][2] *= -1;
                                return y[0] = .5 * Math.sqrt(Math.max(1 + p[0][0] - p[1][1] - p[2][2], 0)), y[1] = .5 * Math.sqrt(Math.max(1 - p[0][0] + p[1][1] - p[2][2], 0)), y[2] = .5 * Math.sqrt(Math.max(1 - p[0][0] - p[1][1] + p[2][2], 0)), y[3] = .5 * Math.sqrt(Math.max(1 + p[0][0] + p[1][1] + p[2][2], 0)), p[2][1] > p[1][2] && (y[0] = -y[0]), p[0][2] > p[2][0] && (y[1] = -y[1]), p[1][0] > p[0][1] && (y[2] = -y[2]), !0;
                            };
                        },
                        4335: function(t1) {
                            t1.exports = function(t1, e1) {
                                var r = e1[15];
                                if (0 === r) return !1;
                                for(var n = 1 / r, i = 0; i < 16; i++)t1[i] = e1[i] * n;
                                return !0;
                            };
                        },
                        7442: function(t1, e1, r) {
                            var n = r(6658), i = r(7182), a = r(2652), o = r(9921), s = r(8648), l = h(), c = h(), u = h();
                            function h() {
                                return {
                                    translate: f(),
                                    scale: f(1),
                                    skew: f(),
                                    perspective: [
                                        0,
                                        0,
                                        0,
                                        1
                                    ],
                                    quaternion: [
                                        0,
                                        0,
                                        0,
                                        1
                                    ]
                                };
                            }
                            function f(t1) {
                                return [
                                    t1 || 0,
                                    t1 || 0,
                                    t1 || 0
                                ];
                            }
                            t1.exports = function(t1, e1, r, h) {
                                if (0 === o(e1) || 0 === o(r)) return !1;
                                var f = a(e1, l.translate, l.scale, l.skew, l.perspective, l.quaternion), p = a(r, c.translate, c.scale, c.skew, c.perspective, c.quaternion);
                                return !(!f || !p || (n(u.translate, l.translate, c.translate, h), n(u.skew, l.skew, c.skew, h), n(u.scale, l.scale, c.scale, h), n(u.perspective, l.perspective, c.perspective, h), s(u.quaternion, l.quaternion, c.quaternion, h), i(t1, u.translate, u.scale, u.skew, u.perspective, u.quaternion), 0));
                            };
                        },
                        7182: function(t1, e1, r) {
                            var n = {
                                identity: r(7894),
                                translate: r(7656),
                                multiply: r(6760),
                                create: r(6864),
                                scale: r(2504),
                                fromRotationTranslation: r(6743)
                            }, i = (n.create(), n.create());
                            t1.exports = function(t1, e1, r, a, o, s) {
                                return n.identity(t1), n.fromRotationTranslation(t1, s, e1), t1[3] = o[0], t1[7] = o[1], t1[11] = o[2], t1[15] = o[3], n.identity(i), 0 !== a[2] && (i[9] = a[2], n.multiply(t1, t1, i)), 0 !== a[1] && (i[9] = 0, i[8] = a[1], n.multiply(t1, t1, i)), 0 !== a[0] && (i[8] = 0, i[4] = a[0], n.multiply(t1, t1, i)), n.scale(t1, t1, r), t1;
                            };
                        },
                        4192: function(t1, e1, r) {
                            "use strict";
                            var n = r(2478), i = r(7442), a = r(7608), o = r(5567), s = r(2408), l = r(7089), c = r(6582), u = r(7656), h = (r(2504), r(3536)), f = [
                                0,
                                0,
                                0
                            ];
                            function p(t1) {
                                this._components = t1.slice(), this._time = [
                                    0
                                ], this.prevMatrix = t1.slice(), this.nextMatrix = t1.slice(), this.computedMatrix = t1.slice(), this.computedInverse = t1.slice(), this.computedEye = [
                                    0,
                                    0,
                                    0
                                ], this.computedUp = [
                                    0,
                                    0,
                                    0
                                ], this.computedCenter = [
                                    0,
                                    0,
                                    0
                                ], this.computedRadius = [
                                    0
                                ], this._limits = [
                                    -1 / 0,
                                    1 / 0
                                ];
                            }
                            t1.exports = function(t1) {
                                return new p((t1 = t1 || {}).matrix || [
                                    1,
                                    0,
                                    0,
                                    0,
                                    0,
                                    1,
                                    0,
                                    0,
                                    0,
                                    0,
                                    1,
                                    0,
                                    0,
                                    0,
                                    0,
                                    1
                                ]);
                            };
                            var d = p.prototype;
                            d.recalcMatrix = function(t1) {
                                var e1 = this._time, r = n.le(e1, t1), o = this.computedMatrix;
                                if (!(r < 0)) {
                                    var s = this._components;
                                    if (r === e1.length - 1) for(var l = 16 * r, c = 0; c < 16; ++c)o[c] = s[l++];
                                    else {
                                        var u = e1[r + 1] - e1[r], f = (l = 16 * r, this.prevMatrix), p = !0;
                                        for(c = 0; c < 16; ++c)f[c] = s[l++];
                                        var d = this.nextMatrix;
                                        for(c = 0; c < 16; ++c)d[c] = s[l++], p = p && f[c] === d[c];
                                        if (u < 1e-6 || p) for(c = 0; c < 16; ++c)o[c] = f[c];
                                        else i(o, f, d, (t1 - e1[r]) / u);
                                    }
                                    var m = this.computedUp;
                                    m[0] = o[1], m[1] = o[5], m[2] = o[9], h(m, m);
                                    var g = this.computedInverse;
                                    a(g, o);
                                    var y = this.computedEye, v = g[15];
                                    y[0] = g[12] / v, y[1] = g[13] / v, y[2] = g[14] / v;
                                    var x = this.computedCenter, _ = Math.exp(this.computedRadius[0]);
                                    for(c = 0; c < 3; ++c)x[c] = y[c] - o[2 + 4 * c] * _;
                                }
                            }, d.idle = function(t1) {
                                if (!(t1 < this.lastT())) {
                                    for(var e1 = this._components, r = e1.length - 16, n = 0; n < 16; ++n)e1.push(e1[r++]);
                                    this._time.push(t1);
                                }
                            }, d.flush = function(t1) {
                                var e1 = n.gt(this._time, t1) - 2;
                                e1 < 0 || (this._time.splice(0, e1), this._components.splice(0, 16 * e1));
                            }, d.lastT = function() {
                                return this._time[this._time.length - 1];
                            }, d.lookAt = function(t1, e1, r, n) {
                                this.recalcMatrix(t1), e1 = e1 || this.computedEye, r = r || f, n = n || this.computedUp, this.setMatrix(t1, c(this.computedMatrix, e1, r, n));
                                for(var i = 0, a = 0; a < 3; ++a)i += Math.pow(r[a] - e1[a], 2);
                                i = Math.log(Math.sqrt(i)), this.computedRadius[0] = i;
                            }, d.rotate = function(t1, e1, r, n) {
                                this.recalcMatrix(t1);
                                var i = this.computedInverse;
                                e1 && s(i, i, e1), r && o(i, i, r), n && l(i, i, n), this.setMatrix(t1, a(this.computedMatrix, i));
                            };
                            var m = [
                                0,
                                0,
                                0
                            ];
                            d.pan = function(t1, e1, r, n) {
                                m[0] = -(e1 || 0), m[1] = -(r || 0), m[2] = -(n || 0), this.recalcMatrix(t1);
                                var i = this.computedInverse;
                                u(i, i, m), this.setMatrix(t1, a(i, i));
                            }, d.translate = function(t1, e1, r, n) {
                                m[0] = e1 || 0, m[1] = r || 0, m[2] = n || 0, this.recalcMatrix(t1);
                                var i = this.computedMatrix;
                                u(i, i, m), this.setMatrix(t1, i);
                            }, d.setMatrix = function(t1, e1) {
                                if (!(t1 < this.lastT())) {
                                    this._time.push(t1);
                                    for(var r = 0; r < 16; ++r)this._components.push(e1[r]);
                                }
                            }, d.setDistance = function(t1, e1) {
                                this.computedRadius[0] = e1;
                            }, d.setDistanceLimits = function(t1, e1) {
                                var r = this._limits;
                                r[0] = t1, r[1] = e1;
                            }, d.getDistanceLimits = function(t1) {
                                var e1 = this._limits;
                                return t1 ? (t1[0] = e1[0], t1[1] = e1[1], t1) : e1;
                            };
                        },
                        3090: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1) {
                                var e1 = t1.length;
                                if (e1 < 3) {
                                    for(var r = new Array(e1), i = 0; i < e1; ++i)r[i] = i;
                                    return 2 === e1 && t1[0][0] === t1[1][0] && t1[0][1] === t1[1][1] ? [
                                        0
                                    ] : r;
                                }
                                var a = new Array(e1);
                                for(i = 0; i < e1; ++i)a[i] = i;
                                a.sort(function(e1, r) {
                                    return t1[e1][0] - t1[r][0] || t1[e1][1] - t1[r][1];
                                });
                                var o = [
                                    a[0],
                                    a[1]
                                ], s = [
                                    a[0],
                                    a[1]
                                ];
                                for(i = 2; i < e1; ++i){
                                    for(var l = a[i], c = t1[l], u = o.length; u > 1 && n(t1[o[u - 2]], t1[o[u - 1]], c) <= 0;)u -= 1, o.pop();
                                    for(o.push(l), u = s.length; u > 1 && n(t1[s[u - 2]], t1[s[u - 1]], c) >= 0;)u -= 1, s.pop();
                                    s.push(l);
                                }
                                r = new Array(s.length + o.length - 2);
                                for(var h = 0, f = (i = 0, o.length); i < f; ++i)r[h++] = o[i];
                                for(var p = s.length - 2; p > 0; --p)r[h++] = s[p];
                                return r;
                            };
                            var n = r(3250)[3];
                        },
                        351: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1) {
                                e1 || (e1 = t1, t1 = window);
                                var r = 0, i = 0, a = 0, o = {
                                    shift: !1,
                                    alt: !1,
                                    control: !1,
                                    meta: !1
                                }, s = !1;
                                function l(t1) {
                                    var e1 = !1;
                                    return "altKey" in t1 && (e1 = e1 || t1.altKey !== o.alt, o.alt = !!t1.altKey), "shiftKey" in t1 && (e1 = e1 || t1.shiftKey !== o.shift, o.shift = !!t1.shiftKey), "ctrlKey" in t1 && (e1 = e1 || t1.ctrlKey !== o.control, o.control = !!t1.ctrlKey), "metaKey" in t1 && (e1 = e1 || t1.metaKey !== o.meta, o.meta = !!t1.metaKey), e1;
                                }
                                function c(t1, s) {
                                    var c = n.x(s), u = n.y(s);
                                    "buttons" in s && (t1 = 0 | s.buttons), (t1 !== r || c !== i || u !== a || l(s)) && (r = 0 | t1, i = c || 0, a = u || 0, e1 && e1(r, i, a, o));
                                }
                                function u(t1) {
                                    c(0, t1);
                                }
                                function h() {
                                    (r || i || a || o.shift || o.alt || o.meta || o.control) && (i = a = 0, r = 0, o.shift = o.alt = o.control = o.meta = !1, e1 && e1(0, 0, 0, o));
                                }
                                function f(t1) {
                                    l(t1) && e1 && e1(r, i, a, o);
                                }
                                function p(t1) {
                                    0 === n.buttons(t1) ? c(0, t1) : c(r, t1);
                                }
                                function d(t1) {
                                    c(r | n.buttons(t1), t1);
                                }
                                function m(t1) {
                                    c(r & ~n.buttons(t1), t1);
                                }
                                function g() {
                                    s || (s = !0, t1.addEventListener("mousemove", p), t1.addEventListener("mousedown", d), t1.addEventListener("mouseup", m), t1.addEventListener("mouseleave", u), t1.addEventListener("mouseenter", u), t1.addEventListener("mouseout", u), t1.addEventListener("mouseover", u), t1.addEventListener("blur", h), t1.addEventListener("keyup", f), t1.addEventListener("keydown", f), t1.addEventListener("keypress", f), t1 !== window && (window.addEventListener("blur", h), window.addEventListener("keyup", f), window.addEventListener("keydown", f), window.addEventListener("keypress", f)));
                                }
                                g();
                                var y = {
                                    element: t1
                                };
                                return Object.defineProperties(y, {
                                    enabled: {
                                        get: function() {
                                            return s;
                                        },
                                        set: function(e1) {
                                            e1 ? g() : s && (s = !1, t1.removeEventListener("mousemove", p), t1.removeEventListener("mousedown", d), t1.removeEventListener("mouseup", m), t1.removeEventListener("mouseleave", u), t1.removeEventListener("mouseenter", u), t1.removeEventListener("mouseout", u), t1.removeEventListener("mouseover", u), t1.removeEventListener("blur", h), t1.removeEventListener("keyup", f), t1.removeEventListener("keydown", f), t1.removeEventListener("keypress", f), t1 !== window && (window.removeEventListener("blur", h), window.removeEventListener("keyup", f), window.removeEventListener("keydown", f), window.removeEventListener("keypress", f)));
                                        },
                                        enumerable: !0
                                    },
                                    buttons: {
                                        get: function() {
                                            return r;
                                        },
                                        enumerable: !0
                                    },
                                    x: {
                                        get: function() {
                                            return i;
                                        },
                                        enumerable: !0
                                    },
                                    y: {
                                        get: function() {
                                            return a;
                                        },
                                        enumerable: !0
                                    },
                                    mods: {
                                        get: function() {
                                            return o;
                                        },
                                        enumerable: !0
                                    }
                                }), y;
                            };
                            var n = r(4687);
                        },
                        24: function(t1) {
                            var e1 = {
                                left: 0,
                                top: 0
                            };
                            t1.exports = function(t1, r, n) {
                                r = r || t1.currentTarget || t1.srcElement, Array.isArray(n) || (n = [
                                    0,
                                    0
                                ]);
                                var i, a = t1.clientX || 0, o = t1.clientY || 0, s = (i = r) === window || i === document || i === document.body ? e1 : i.getBoundingClientRect();
                                return n[0] = a - s.left, n[1] = o - s.top, n;
                            };
                        },
                        4687: function(t1, e1) {
                            "use strict";
                            function r(t1) {
                                return t1.target || t1.srcElement || window;
                            }
                            e1.buttons = function(t1) {
                                if ("object" == typeof t1) {
                                    if ("buttons" in t1) return t1.buttons;
                                    if ("which" in t1) {
                                        if (2 === (e1 = t1.which)) return 4;
                                        if (3 === e1) return 2;
                                        if (e1 > 0) return 1 << e1 - 1;
                                    } else if ("button" in t1) {
                                        var e1;
                                        if (1 === (e1 = t1.button)) return 4;
                                        if (2 === e1) return 2;
                                        if (e1 >= 0) return 1 << e1;
                                    }
                                }
                                return 0;
                            }, e1.element = r, e1.x = function(t1) {
                                if ("object" == typeof t1) {
                                    if ("offsetX" in t1) return t1.offsetX;
                                    var e1 = r(t1).getBoundingClientRect();
                                    return t1.clientX - e1.left;
                                }
                                return 0;
                            }, e1.y = function(t1) {
                                if ("object" == typeof t1) {
                                    if ("offsetY" in t1) return t1.offsetY;
                                    var e1 = r(t1).getBoundingClientRect();
                                    return t1.clientY - e1.top;
                                }
                                return 0;
                            };
                        },
                        8512: function(t1, e1, r) {
                            "use strict";
                            var n = r(665);
                            t1.exports = function(t1, e1, r) {
                                "function" == typeof t1 && (r = !!e1, e1 = t1, t1 = window);
                                var i = n("ex", t1), a = function(t1) {
                                    r && t1.preventDefault();
                                    var n = t1.deltaX || 0, a = t1.deltaY || 0, o = t1.deltaZ || 0, s = 1;
                                    switch(t1.deltaMode){
                                        case 1:
                                            s = i;
                                            break;
                                        case 2:
                                            s = window.innerHeight;
                                    }
                                    if (a *= s, o *= s, (n *= s) || a || o) return e1(n, a, o, t1);
                                };
                                return t1.addEventListener("wheel", a), a;
                            };
                        },
                        2640: function(t1, e1, r) {
                            "use strict";
                            var n = r(1888);
                            t1.exports = function(t1) {
                                function e1(t1) {
                                    throw new Error("ndarray-extract-contour: " + t1);
                                }
                                "object" != typeof t1 && e1("Must specify arguments");
                                var r = t1.order;
                                Array.isArray(r) || e1("Must specify order");
                                var a = t1.arrayArguments || 1;
                                a < 1 && e1("Must have at least one array argument"), (t1.scalarArguments || 0) < 0 && e1("Scalar arg count must be > 0"), "function" != typeof t1.vertex && e1("Must specify vertex creation function"), "function" != typeof t1.cell && e1("Must specify cell creation function"), "function" != typeof t1.phase && e1("Must specify phase function");
                                for(var o = t1.getters || [], s = new Array(a), l = 0; l < a; ++l)o.indexOf(l) >= 0 ? s[l] = !0 : s[l] = !1;
                                return function(t1, e1, r, a, o, s) {
                                    var l = [
                                        s,
                                        o
                                    ].join(",");
                                    return (0, i[l])(t1, e1, r, n.mallocUint32, n.freeUint32);
                                }(t1.vertex, t1.cell, t1.phase, 0, r, s);
                            };
                            var i = {
                                "false,0,1": function(t1, e1, r, n, i) {
                                    return function(a, o, s, l) {
                                        var c, u = 0 | a.shape[0], h = 0 | a.shape[1], f = a.data, p = 0 | a.offset, d = 0 | a.stride[0], m = 0 | a.stride[1], g = p, y = 0 | -d, v = 0, x = 0 | -m, _ = 0, b = -d - m | 0, w = 0, T = 0 | d, k = m - d * u | 0, A = 0, M = 0, S = 0, E = 2 * u | 0, C = n(E), L = n(E), I = 0, P = 0, z = -1, O = -1, D = 0, R = 0 | -u, F = 0 | u, B = 0, N = -u - 1 | 0, j = u - 1 | 0, U = 0, V = 0, q = 0;
                                        for(A = 0; A < u; ++A)C[I++] = r(f[g], o, s, l), g += T;
                                        if (g += k, h > 0) {
                                            if (M = 1, C[I++] = r(f[g], o, s, l), g += T, u > 0) for(A = 1, c = f[g], P = C[I] = r(c, o, s, l), D = C[I + z], B = C[I + R], U = C[I + N], P === D && P === B && P === U || (v = f[g + y], _ = f[g + x], w = f[g + b], t1(A, M, c, v, _, w, P, D, B, U, o, s, l), V = L[I] = S++), I += 1, g += T, A = 2; A < u; ++A)c = f[g], P = C[I] = r(c, o, s, l), D = C[I + z], B = C[I + R], U = C[I + N], P === D && P === B && P === U || (v = f[g + y], _ = f[g + x], w = f[g + b], t1(A, M, c, v, _, w, P, D, B, U, o, s, l), V = L[I] = S++, U !== D && e1(L[I + z], V, w, v, U, D, o, s, l)), I += 1, g += T;
                                            for(g += k, I = 0, q = z, z = O, O = q, q = R, R = F, F = q, q = N, N = j, j = q, M = 2; M < h; ++M){
                                                if (C[I++] = r(f[g], o, s, l), g += T, u > 0) for(A = 1, c = f[g], P = C[I] = r(c, o, s, l), D = C[I + z], B = C[I + R], U = C[I + N], P === D && P === B && P === U || (v = f[g + y], _ = f[g + x], w = f[g + b], t1(A, M, c, v, _, w, P, D, B, U, o, s, l), V = L[I] = S++, U !== B && e1(L[I + R], V, _, w, B, U, o, s, l)), I += 1, g += T, A = 2; A < u; ++A)c = f[g], P = C[I] = r(c, o, s, l), D = C[I + z], B = C[I + R], U = C[I + N], P === D && P === B && P === U || (v = f[g + y], _ = f[g + x], w = f[g + b], t1(A, M, c, v, _, w, P, D, B, U, o, s, l), V = L[I] = S++, U !== B && e1(L[I + R], V, _, w, B, U, o, s, l), U !== D && e1(L[I + z], V, w, v, U, D, o, s, l)), I += 1, g += T;
                                                1 & M && (I = 0), q = z, z = O, O = q, q = R, R = F, F = q, q = N, N = j, j = q, g += k;
                                            }
                                        }
                                        i(L), i(C);
                                    };
                                },
                                "false,1,0": function(t1, e1, r, n, i) {
                                    return function(a, o, s, l) {
                                        var c, u = 0 | a.shape[0], h = 0 | a.shape[1], f = a.data, p = 0 | a.offset, d = 0 | a.stride[0], m = 0 | a.stride[1], g = p, y = 0 | -d, v = 0, x = 0 | -m, _ = 0, b = -d - m | 0, w = 0, T = 0 | m, k = d - m * h | 0, A = 0, M = 0, S = 0, E = 2 * h | 0, C = n(E), L = n(E), I = 0, P = 0, z = -1, O = -1, D = 0, R = 0 | -h, F = 0 | h, B = 0, N = -h - 1 | 0, j = h - 1 | 0, U = 0, V = 0, q = 0;
                                        for(M = 0; M < h; ++M)C[I++] = r(f[g], o, s, l), g += T;
                                        if (g += k, u > 0) {
                                            if (A = 1, C[I++] = r(f[g], o, s, l), g += T, h > 0) for(M = 1, c = f[g], P = C[I] = r(c, o, s, l), B = C[I + R], D = C[I + z], U = C[I + N], P === B && P === D && P === U || (v = f[g + y], _ = f[g + x], w = f[g + b], t1(A, M, c, v, _, w, P, B, D, U, o, s, l), V = L[I] = S++), I += 1, g += T, M = 2; M < h; ++M)c = f[g], P = C[I] = r(c, o, s, l), B = C[I + R], D = C[I + z], U = C[I + N], P === B && P === D && P === U || (v = f[g + y], _ = f[g + x], w = f[g + b], t1(A, M, c, v, _, w, P, B, D, U, o, s, l), V = L[I] = S++, U !== D && e1(L[I + z], V, _, w, D, U, o, s, l)), I += 1, g += T;
                                            for(g += k, I = 0, q = R, R = F, F = q, q = z, z = O, O = q, q = N, N = j, j = q, A = 2; A < u; ++A){
                                                if (C[I++] = r(f[g], o, s, l), g += T, h > 0) for(M = 1, c = f[g], P = C[I] = r(c, o, s, l), B = C[I + R], D = C[I + z], U = C[I + N], P === B && P === D && P === U || (v = f[g + y], _ = f[g + x], w = f[g + b], t1(A, M, c, v, _, w, P, B, D, U, o, s, l), V = L[I] = S++, U !== B && e1(L[I + R], V, w, v, U, B, o, s, l)), I += 1, g += T, M = 2; M < h; ++M)c = f[g], P = C[I] = r(c, o, s, l), B = C[I + R], D = C[I + z], U = C[I + N], P === B && P === D && P === U || (v = f[g + y], _ = f[g + x], w = f[g + b], t1(A, M, c, v, _, w, P, B, D, U, o, s, l), V = L[I] = S++, U !== D && e1(L[I + z], V, _, w, D, U, o, s, l), U !== B && e1(L[I + R], V, w, v, U, B, o, s, l)), I += 1, g += T;
                                                1 & A && (I = 0), q = R, R = F, F = q, q = z, z = O, O = q, q = N, N = j, j = q, g += k;
                                            }
                                        }
                                        i(L), i(C);
                                    };
                                }
                            };
                        },
                        6199: function(t1, e1, r) {
                            "use strict";
                            var n = r(1338), i = {
                                zero: function(t1, e1, r, n) {
                                    var i = t1[0];
                                    n |= 0;
                                    var a = 0, o = r[0];
                                    for(a = 0; a < i; ++a)e1[n] = 0, n += o;
                                },
                                fdTemplate1: function(t1, e1, r, n, i, a, o) {
                                    var s = t1[0], l = r[0], c = -1 * l, u = l;
                                    n |= 0, o |= 0;
                                    var h = 0, f = l, p = a[0];
                                    for(h = 0; h < s; ++h)i[o] = .5 * (e1[n + c] - e1[n + u]), n += f, o += p;
                                },
                                fdTemplate2: function(t1, e1, r, n, i, a, o, s, l, c) {
                                    var u = t1[0], h = t1[1], f = r[0], p = r[1], d = a[0], m = a[1], g = l[0], y = l[1], v = -1 * f, x = f, _ = -1 * p, b = p;
                                    n |= 0, o |= 0, c |= 0;
                                    var w = 0, T = 0, k = p, A = f - h * p, M = m, S = d - h * m, E = y, C = g - h * y;
                                    for(T = 0; T < u; ++T){
                                        for(w = 0; w < h; ++w)i[o] = .5 * (e1[n + v] - e1[n + x]), s[c] = .5 * (e1[n + _] - e1[n + b]), n += k, o += M, c += E;
                                        n += A, o += S, c += C;
                                    }
                                }
                            }, a = {
                                cdiff: function(t1) {
                                    var e1 = {};
                                    return function(r, n, i) {
                                        var a = r.dtype, o = r.order, s = n.dtype, l = n.order, c = i.dtype, u = i.order, h = [
                                            a,
                                            o.join(),
                                            s,
                                            l.join(),
                                            c,
                                            u.join()
                                        ].join(), f = e1[h];
                                        return f || (e1[h] = f = t1([
                                            a,
                                            o,
                                            s,
                                            l,
                                            c,
                                            u
                                        ])), f(r.shape.slice(0), r.data, r.stride, 0 | r.offset, n.data, n.stride, 0 | n.offset, i.data, i.stride, 0 | i.offset);
                                    };
                                },
                                zero: function(t1) {
                                    var e1 = {};
                                    return function(r) {
                                        var n = r.dtype, i = r.order, a = [
                                            n,
                                            i.join()
                                        ].join(), o = e1[a];
                                        return o || (e1[a] = o = t1([
                                            n,
                                            i
                                        ])), o(r.shape.slice(0), r.data, r.stride, 0 | r.offset);
                                    };
                                },
                                fdTemplate1: function(t1) {
                                    var e1 = {};
                                    return function(r, n) {
                                        var i = r.dtype, a = r.order, o = n.dtype, s = n.order, l = [
                                            i,
                                            a.join(),
                                            o,
                                            s.join()
                                        ].join(), c = e1[l];
                                        return c || (e1[l] = c = t1([
                                            i,
                                            a,
                                            o,
                                            s
                                        ])), c(r.shape.slice(0), r.data, r.stride, 0 | r.offset, n.data, n.stride, 0 | n.offset);
                                    };
                                },
                                fdTemplate2: function(t1) {
                                    var e1 = {};
                                    return function(r, n, i) {
                                        var a = r.dtype, o = r.order, s = n.dtype, l = n.order, c = i.dtype, u = i.order, h = [
                                            a,
                                            o.join(),
                                            s,
                                            l.join(),
                                            c,
                                            u.join()
                                        ].join(), f = e1[h];
                                        return f || (e1[h] = f = t1([
                                            a,
                                            o,
                                            s,
                                            l,
                                            c,
                                            u
                                        ])), f(r.shape.slice(0), r.data, r.stride, 0 | r.offset, n.data, n.stride, 0 | n.offset, i.data, i.stride, 0 | i.offset);
                                    };
                                }
                            };
                            function o(t1) {
                                return (0, a[t1.funcName])(s.bind(void 0, t1));
                            }
                            function s(t1) {
                                return i[t1.funcName];
                            }
                            function l(t1) {
                                return o({
                                    funcName: t1.funcName
                                });
                            }
                            var c = {}, u = {}, h = l({
                                funcName: "cdiff"
                            }), f = l({
                                funcName: "zero"
                            });
                            function p(t1) {
                                return t1 in c ? c[t1] : c[t1] = l({
                                    funcName: "fdTemplate" + t1
                                });
                            }
                            function d(t1, e1, r, n) {
                                return function(t1, i) {
                                    var a = i.shape.slice();
                                    return a[0] > 2 && a[1] > 2 && n(i.pick(-1, -1).lo(1, 1).hi(a[0] - 2, a[1] - 2), t1.pick(-1, -1, 0).lo(1, 1).hi(a[0] - 2, a[1] - 2), t1.pick(-1, -1, 1).lo(1, 1).hi(a[0] - 2, a[1] - 2)), a[1] > 2 && (r(i.pick(0, -1).lo(1).hi(a[1] - 2), t1.pick(0, -1, 1).lo(1).hi(a[1] - 2)), e1(t1.pick(0, -1, 0).lo(1).hi(a[1] - 2))), a[1] > 2 && (r(i.pick(a[0] - 1, -1).lo(1).hi(a[1] - 2), t1.pick(a[0] - 1, -1, 1).lo(1).hi(a[1] - 2)), e1(t1.pick(a[0] - 1, -1, 0).lo(1).hi(a[1] - 2))), a[0] > 2 && (r(i.pick(-1, 0).lo(1).hi(a[0] - 2), t1.pick(-1, 0, 0).lo(1).hi(a[0] - 2)), e1(t1.pick(-1, 0, 1).lo(1).hi(a[0] - 2))), a[0] > 2 && (r(i.pick(-1, a[1] - 1).lo(1).hi(a[0] - 2), t1.pick(-1, a[1] - 1, 0).lo(1).hi(a[0] - 2)), e1(t1.pick(-1, a[1] - 1, 1).lo(1).hi(a[0] - 2))), t1.set(0, 0, 0, 0), t1.set(0, 0, 1, 0), t1.set(a[0] - 1, 0, 0, 0), t1.set(a[0] - 1, 0, 1, 0), t1.set(0, a[1] - 1, 0, 0), t1.set(0, a[1] - 1, 1, 0), t1.set(a[0] - 1, a[1] - 1, 0, 0), t1.set(a[0] - 1, a[1] - 1, 1, 0), t1;
                                };
                            }
                            t1.exports = function(t1, e1, r) {
                                return Array.isArray(r) || (r = n(e1.dimension, "string" == typeof r ? r : "clamp")), 0 === e1.size ? t1 : 0 === e1.dimension ? (t1.set(0), t1) : (function(t1) {
                                    var e1 = t1.join();
                                    if (a = u[e1]) return a;
                                    for(var r = t1.length, n = [
                                        h,
                                        f
                                    ], i = 1; i <= r; ++i)n.push(p(i));
                                    var a = d.apply(void 0, n);
                                    return u[e1] = a, a;
                                })(r)(t1, e1);
                            };
                        },
                        4317: function(t1) {
                            "use strict";
                            function e1(t1, e1) {
                                var r = Math.floor(e1), n = e1 - r, i = 0 <= r && r < t1.shape[0], a = 0 <= r + 1 && r + 1 < t1.shape[0];
                                return (1 - n) * (i ? +t1.get(r) : 0) + n * (a ? +t1.get(r + 1) : 0);
                            }
                            function r(t1, e1, r) {
                                var n = Math.floor(e1), i = e1 - n, a = 0 <= n && n < t1.shape[0], o = 0 <= n + 1 && n + 1 < t1.shape[0], s = Math.floor(r), l = r - s, c = 0 <= s && s < t1.shape[1], u = 0 <= s + 1 && s + 1 < t1.shape[1], h = a && c ? t1.get(n, s) : 0, f = a && u ? t1.get(n, s + 1) : 0;
                                return (1 - l) * ((1 - i) * h + i * (o && c ? t1.get(n + 1, s) : 0)) + l * ((1 - i) * f + i * (o && u ? t1.get(n + 1, s + 1) : 0));
                            }
                            function n(t1, e1, r, n) {
                                var i = Math.floor(e1), a = e1 - i, o = 0 <= i && i < t1.shape[0], s = 0 <= i + 1 && i + 1 < t1.shape[0], l = Math.floor(r), c = r - l, u = 0 <= l && l < t1.shape[1], h = 0 <= l + 1 && l + 1 < t1.shape[1], f = Math.floor(n), p = n - f, d = 0 <= f && f < t1.shape[2], m = 0 <= f + 1 && f + 1 < t1.shape[2], g = o && u && d ? t1.get(i, l, f) : 0, y = o && h && d ? t1.get(i, l + 1, f) : 0, v = s && u && d ? t1.get(i + 1, l, f) : 0, x = s && h && d ? t1.get(i + 1, l + 1, f) : 0, _ = o && u && m ? t1.get(i, l, f + 1) : 0, b = o && h && m ? t1.get(i, l + 1, f + 1) : 0;
                                return (1 - p) * ((1 - c) * ((1 - a) * g + a * v) + c * ((1 - a) * y + a * x)) + p * ((1 - c) * ((1 - a) * _ + a * (s && u && m ? t1.get(i + 1, l, f + 1) : 0)) + c * ((1 - a) * b + a * (s && h && m ? t1.get(i + 1, l + 1, f + 1) : 0)));
                            }
                            function i(t1) {
                                var e1, r, n = 0 | t1.shape.length, i = new Array(n), a = new Array(n), o = new Array(n), s = new Array(n);
                                for(e1 = 0; e1 < n; ++e1)r = +arguments[e1 + 1], i[e1] = Math.floor(r), a[e1] = r - i[e1], o[e1] = 0 <= i[e1] && i[e1] < t1.shape[e1], s[e1] = 0 <= i[e1] + 1 && i[e1] + 1 < t1.shape[e1];
                                var l, c, u, h = 0;
                                t: for(e1 = 0; e1 < 1 << n; ++e1){
                                    for(c = 1, u = t1.offset, l = 0; l < n; ++l)if (e1 & 1 << l) {
                                        if (!s[l]) continue t;
                                        c *= a[l], u += t1.stride[l] * (i[l] + 1);
                                    } else {
                                        if (!o[l]) continue t;
                                        c *= 1 - a[l], u += t1.stride[l] * i[l];
                                    }
                                    h += c * t1.data[u];
                                }
                                return h;
                            }
                            t1.exports = function(t1, a, o, s) {
                                switch(t1.shape.length){
                                    case 0:
                                        return 0;
                                    case 1:
                                        return e1(t1, a);
                                    case 2:
                                        return r(t1, a, o);
                                    case 3:
                                        return n(t1, a, o, s);
                                    default:
                                        return i.apply(void 0, arguments);
                                }
                            }, t1.exports.d1 = e1, t1.exports.d2 = r, t1.exports.d3 = n;
                        },
                        5298: function(t1, e1) {
                            "use strict";
                            var r = {
                                "float64,2,1,0": function() {
                                    return function(t1, e1, r, n, i) {
                                        var a = t1[0], o = t1[1], s = t1[2], l = r[0], c = r[1], u = r[2];
                                        n |= 0;
                                        var h = 0, f = 0, p = 0, d = u, m = c - s * u, g = l - o * c;
                                        for(p = 0; p < a; ++p){
                                            for(f = 0; f < o; ++f){
                                                for(h = 0; h < s; ++h)e1[n] /= i, n += d;
                                                n += m;
                                            }
                                            n += g;
                                        }
                                    };
                                },
                                "uint8,2,0,1,float64,2,1,0": function() {
                                    return function(t1, e1, r, n, i, a, o, s) {
                                        for(var l = t1[0], c = t1[1], u = t1[2], h = r[0], f = r[1], p = r[2], d = a[0], m = a[1], g = a[2], y = n |= 0, v = o |= 0, x = 0 | t1[0]; x > 0;){
                                            x < 64 ? (l = x, x = 0) : (l = 64, x -= 64);
                                            for(var _ = 0 | t1[1]; _ > 0;){
                                                _ < 64 ? (c = _, _ = 0) : (c = 64, _ -= 64), n = y + x * h + _ * f, o = v + x * d + _ * m;
                                                var b = 0, w = 0, T = 0, k = p, A = h - u * p, M = f - l * h, S = g, E = d - u * g, C = m - l * d;
                                                for(T = 0; T < c; ++T){
                                                    for(w = 0; w < l; ++w){
                                                        for(b = 0; b < u; ++b)e1[n] = i[o] * s, n += k, o += S;
                                                        n += A, o += E;
                                                    }
                                                    n += M, o += C;
                                                }
                                            }
                                        }
                                    };
                                },
                                "float32,1,0,float32,1,0": function() {
                                    return function(t1, e1, r, n, i, a, o) {
                                        var s = t1[0], l = t1[1], c = r[0], u = r[1], h = a[0], f = a[1];
                                        n |= 0, o |= 0;
                                        var p = 0, d = 0, m = u, g = c - l * u, y = f, v = h - l * f;
                                        for(d = 0; d < s; ++d){
                                            for(p = 0; p < l; ++p)e1[n] = i[o], n += m, o += y;
                                            n += g, o += v;
                                        }
                                    };
                                },
                                "float32,1,0,float32,0,1": function() {
                                    return function(t1, e1, r, n, i, a, o) {
                                        for(var s = t1[0], l = t1[1], c = r[0], u = r[1], h = a[0], f = a[1], p = n |= 0, d = o |= 0, m = 0 | t1[1]; m > 0;){
                                            m < 64 ? (l = m, m = 0) : (l = 64, m -= 64);
                                            for(var g = 0 | t1[0]; g > 0;){
                                                g < 64 ? (s = g, g = 0) : (s = 64, g -= 64), n = p + m * u + g * c, o = d + m * f + g * h;
                                                var y = 0, v = 0, x = u, _ = c - l * u, b = f, w = h - l * f;
                                                for(v = 0; v < s; ++v){
                                                    for(y = 0; y < l; ++y)e1[n] = i[o], n += x, o += b;
                                                    n += _, o += w;
                                                }
                                            }
                                        }
                                    };
                                },
                                "uint8,2,0,1,uint8,1,2,0": function() {
                                    return function(t1, e1, r, n, i, a, o) {
                                        for(var s = t1[0], l = t1[1], c = t1[2], u = r[0], h = r[1], f = r[2], p = a[0], d = a[1], m = a[2], g = n |= 0, y = o |= 0, v = 0 | t1[2]; v > 0;){
                                            v < 64 ? (c = v, v = 0) : (c = 64, v -= 64);
                                            for(var x = 0 | t1[0]; x > 0;){
                                                x < 64 ? (s = x, x = 0) : (s = 64, x -= 64);
                                                for(var _ = 0 | t1[1]; _ > 0;){
                                                    _ < 64 ? (l = _, _ = 0) : (l = 64, _ -= 64), n = g + v * f + x * u + _ * h, o = y + v * m + x * p + _ * d;
                                                    var b = 0, w = 0, T = 0, k = f, A = u - c * f, M = h - s * u, S = m, E = p - c * m, C = d - s * p;
                                                    for(T = 0; T < l; ++T){
                                                        for(w = 0; w < s; ++w){
                                                            for(b = 0; b < c; ++b)e1[n] = i[o], n += k, o += S;
                                                            n += A, o += E;
                                                        }
                                                        n += M, o += C;
                                                    }
                                                }
                                            }
                                        }
                                    };
                                },
                                "uint8,2,0,1,array,2,0,1": function() {
                                    return function(t1, e1, r, n, i, a, o) {
                                        var s = t1[0], l = t1[1], c = t1[2], u = r[0], h = r[1], f = r[2], p = a[0], d = a[1], m = a[2];
                                        n |= 0, o |= 0;
                                        var g = 0, y = 0, v = 0, x = f, _ = u - c * f, b = h - s * u, w = m, T = p - c * m, k = d - s * p;
                                        for(v = 0; v < l; ++v){
                                            for(y = 0; y < s; ++y){
                                                for(g = 0; g < c; ++g)e1[n] = i[o], n += x, o += w;
                                                n += _, o += T;
                                            }
                                            n += b, o += k;
                                        }
                                    };
                                }
                            }, n = function(t1, e1) {
                                var n = e1.join(",");
                                return (0, r[n])();
                            }, i = {
                                mul: function(t1) {
                                    var e1 = {};
                                    return function(r, n, i) {
                                        var a = r.dtype, o = r.order, s = n.dtype, l = n.order, c = i.dtype, u = i.order, h = [
                                            a,
                                            o.join(),
                                            s,
                                            l.join(),
                                            c,
                                            u.join()
                                        ].join(), f = e1[h];
                                        return f || (e1[h] = f = t1([
                                            a,
                                            o,
                                            s,
                                            l,
                                            c,
                                            u
                                        ])), f(r.shape.slice(0), r.data, r.stride, 0 | r.offset, n.data, n.stride, 0 | n.offset, i.data, i.stride, 0 | i.offset);
                                    };
                                },
                                muls: function(t1) {
                                    var e1 = {};
                                    return function(r, n, i) {
                                        var a = r.dtype, o = r.order, s = n.dtype, l = n.order, c = [
                                            a,
                                            o.join(),
                                            s,
                                            l.join()
                                        ].join(), u = e1[c];
                                        return u || (e1[c] = u = t1([
                                            a,
                                            o,
                                            s,
                                            l
                                        ])), u(r.shape.slice(0), r.data, r.stride, 0 | r.offset, n.data, n.stride, 0 | n.offset, i);
                                    };
                                },
                                mulseq: function(t1) {
                                    var e1 = {};
                                    return function(r, n) {
                                        var i = r.dtype, a = r.order, o = [
                                            i,
                                            a.join()
                                        ].join(), s = e1[o];
                                        return s || (e1[o] = s = t1([
                                            i,
                                            a
                                        ])), s(r.shape.slice(0), r.data, r.stride, 0 | r.offset, n);
                                    };
                                },
                                div: function(t1) {
                                    var e1 = {};
                                    return function(r, n, i) {
                                        var a = r.dtype, o = r.order, s = n.dtype, l = n.order, c = i.dtype, u = i.order, h = [
                                            a,
                                            o.join(),
                                            s,
                                            l.join(),
                                            c,
                                            u.join()
                                        ].join(), f = e1[h];
                                        return f || (e1[h] = f = t1([
                                            a,
                                            o,
                                            s,
                                            l,
                                            c,
                                            u
                                        ])), f(r.shape.slice(0), r.data, r.stride, 0 | r.offset, n.data, n.stride, 0 | n.offset, i.data, i.stride, 0 | i.offset);
                                    };
                                },
                                divs: function(t1) {
                                    var e1 = {};
                                    return function(r, n, i) {
                                        var a = r.dtype, o = r.order, s = n.dtype, l = n.order, c = [
                                            a,
                                            o.join(),
                                            s,
                                            l.join()
                                        ].join(), u = e1[c];
                                        return u || (e1[c] = u = t1([
                                            a,
                                            o,
                                            s,
                                            l
                                        ])), u(r.shape.slice(0), r.data, r.stride, 0 | r.offset, n.data, n.stride, 0 | n.offset, i);
                                    };
                                },
                                divseq: function(t1) {
                                    var e1 = {};
                                    return function(r, n) {
                                        var i = r.dtype, a = r.order, o = [
                                            i,
                                            a.join()
                                        ].join(), s = e1[o];
                                        return s || (e1[o] = s = t1([
                                            i,
                                            a
                                        ])), s(r.shape.slice(0), r.data, r.stride, 0 | r.offset, n);
                                    };
                                },
                                assign: function(t1) {
                                    var e1 = {};
                                    return function(r, n) {
                                        var i = r.dtype, a = r.order, o = n.dtype, s = n.order, l = [
                                            i,
                                            a.join(),
                                            o,
                                            s.join()
                                        ].join(), c = e1[l];
                                        return c || (e1[l] = c = t1([
                                            i,
                                            a,
                                            o,
                                            s
                                        ])), c(r.shape.slice(0), r.data, r.stride, 0 | r.offset, n.data, n.stride, 0 | n.offset);
                                    };
                                }
                            };
                            function a(t1) {
                                var e1;
                                return e1 = {
                                    funcName: t1.funcName
                                }, (0, i[e1.funcName])(n.bind(void 0, e1));
                            }
                            var o = {
                                mul: "*",
                                div: "/"
                            };
                            !function() {
                                for(var t1 in o)e1[t1] = a({
                                    funcName: t1
                                }), e1[t1 + "s"] = a({
                                    funcName: t1 + "s"
                                }), e1[t1 + "seq"] = a({
                                    funcName: t1 + "seq"
                                });
                            }(), e1.assign = a({
                                funcName: "assign"
                            });
                        },
                        9994: function(t1, e1, r) {
                            "use strict";
                            var n = r(9618), i = r(8277);
                            t1.exports = function(t1, e1) {
                                for(var r = [], a = t1, o = 1; Array.isArray(a);)r.push(a.length), o *= a.length, a = a[0];
                                return 0 === r.length ? n() : (e1 || (e1 = n(new Float64Array(o), r)), i(e1, t1), e1);
                            };
                        },
                        8277: function(t1) {
                            "use strict";
                            t1.exports = function(t1) {
                                var e1 = {};
                                return function(r, n) {
                                    var i = r.dtype, a = r.order, o = [
                                        i,
                                        a.join()
                                    ].join(), s = e1[o];
                                    return s || (e1[o] = s = t1([
                                        i,
                                        a
                                    ])), s(r.shape.slice(0), r.data, r.stride, 0 | r.offset, n);
                                };
                            }((function() {
                                return function(t1, e1, r, n, i) {
                                    var a = t1[0], o = t1[1], s = t1[2], l = r[0], c = r[1], u = r[2], h = [
                                        0,
                                        0,
                                        0
                                    ];
                                    n |= 0;
                                    var f = 0, p = 0, d = 0, m = u, g = c - s * u, y = l - o * c;
                                    for(d = 0; d < a; ++d){
                                        for(p = 0; p < o; ++p){
                                            for(f = 0; f < s; ++f){
                                                var v, x = i;
                                                for(v = 0; v < h.length - 1; ++v)x = x[h[v]];
                                                e1[n] = x[h[h.length - 1]], n += m, ++h[2];
                                            }
                                            n += g, h[2] -= s, ++h[1];
                                        }
                                        n += y, h[1] -= o, ++h[0];
                                    }
                                };
                            }).bind(void 0, {
                                funcName: "convert"
                            }));
                        },
                        7640: function(t1, e1, r) {
                            "use strict";
                            var n = r(1888);
                            function i(t1) {
                                return "uint32" === t1 ? [
                                    n.mallocUint32,
                                    n.freeUint32
                                ] : null;
                            }
                            var a = {
                                "uint32,1,0": function(t1, e1) {
                                    return function(r, n, i, a, o, s, l, c, u, h, f) {
                                        var p, d, m, g, y, v, x, _, b = r * o + a, w = t1(c);
                                        for(p = r + 1; p <= n; ++p){
                                            for(d = p, m = b += o, y = 0, v = b, g = 0; g < c; ++g)w[y++] = i[v], v += u;
                                            t: for(; d-- > r;){
                                                y = 0, v = m - o;
                                                e: for(g = 0; g < c; ++g){
                                                    if ((x = i[v]) < (_ = w[y])) break t;
                                                    if (x > _) break e;
                                                    v += h, y += f;
                                                }
                                                for(y = m, v = m - o, g = 0; g < c; ++g)i[y] = i[v], y += u, v += u;
                                                m -= o;
                                            }
                                            for(y = m, v = 0, g = 0; g < c; ++g)i[y] = w[v++], y += u;
                                        }
                                        e1(w);
                                    };
                                }
                            }, o = {
                                "uint32,1,0": function(t1, e1, r) {
                                    return function n(i, a, o, s, l, c, u, h, f, p, d) {
                                        var m, g, y, v, x, _, b, w, T, k, A, M, S, E, C, L, I, P, z, O, D, R, F, B, N, j = (a - i + 1) / 6 | 0, U = i + j, V = a - j, q = i + a >> 1, H = q - j, G = q + j, Z = U, W = H, Y = q, X = G, $ = V, J = i + 1, K = a - 1, Q = !0, tt = 0, et = 0, rt = 0, nt = h, it = e1(nt), at = e1(nt);
                                        A = l * Z, M = l * W, N = s;
                                        t: for(k = 0; k < h; ++k){
                                            if (w = M + N, (rt = o[b = A + N] - o[w]) > 0) {
                                                g = Z, Z = W, W = g;
                                                break t;
                                            }
                                            if (rt < 0) break t;
                                            N += p;
                                        }
                                        A = l * X, M = l * $, N = s;
                                        t: for(k = 0; k < h; ++k){
                                            if (w = M + N, (rt = o[b = A + N] - o[w]) > 0) {
                                                g = X, X = $, $ = g;
                                                break t;
                                            }
                                            if (rt < 0) break t;
                                            N += p;
                                        }
                                        A = l * Z, M = l * Y, N = s;
                                        t: for(k = 0; k < h; ++k){
                                            if (w = M + N, (rt = o[b = A + N] - o[w]) > 0) {
                                                g = Z, Z = Y, Y = g;
                                                break t;
                                            }
                                            if (rt < 0) break t;
                                            N += p;
                                        }
                                        A = l * W, M = l * Y, N = s;
                                        t: for(k = 0; k < h; ++k){
                                            if (w = M + N, (rt = o[b = A + N] - o[w]) > 0) {
                                                g = W, W = Y, Y = g;
                                                break t;
                                            }
                                            if (rt < 0) break t;
                                            N += p;
                                        }
                                        A = l * Z, M = l * X, N = s;
                                        t: for(k = 0; k < h; ++k){
                                            if (w = M + N, (rt = o[b = A + N] - o[w]) > 0) {
                                                g = Z, Z = X, X = g;
                                                break t;
                                            }
                                            if (rt < 0) break t;
                                            N += p;
                                        }
                                        A = l * Y, M = l * X, N = s;
                                        t: for(k = 0; k < h; ++k){
                                            if (w = M + N, (rt = o[b = A + N] - o[w]) > 0) {
                                                g = Y, Y = X, X = g;
                                                break t;
                                            }
                                            if (rt < 0) break t;
                                            N += p;
                                        }
                                        A = l * W, M = l * $, N = s;
                                        t: for(k = 0; k < h; ++k){
                                            if (w = M + N, (rt = o[b = A + N] - o[w]) > 0) {
                                                g = W, W = $, $ = g;
                                                break t;
                                            }
                                            if (rt < 0) break t;
                                            N += p;
                                        }
                                        A = l * W, M = l * Y, N = s;
                                        t: for(k = 0; k < h; ++k){
                                            if (w = M + N, (rt = o[b = A + N] - o[w]) > 0) {
                                                g = W, W = Y, Y = g;
                                                break t;
                                            }
                                            if (rt < 0) break t;
                                            N += p;
                                        }
                                        A = l * X, M = l * $, N = s;
                                        t: for(k = 0; k < h; ++k){
                                            if (w = M + N, (rt = o[b = A + N] - o[w]) > 0) {
                                                g = X, X = $, $ = g;
                                                break t;
                                            }
                                            if (rt < 0) break t;
                                            N += p;
                                        }
                                        for(A = l * Z, M = l * W, S = l * Y, E = l * X, C = l * $, L = l * U, I = l * q, P = l * V, B = 0, N = s, k = 0; k < h; ++k)b = A + N, w = M + N, T = S + N, z = E + N, O = C + N, D = L + N, R = I + N, F = P + N, it[B] = o[w], at[B] = o[z], Q = Q && it[B] === at[B], y = o[b], v = o[T], x = o[O], o[D] = y, o[R] = v, o[F] = x, ++B, N += f;
                                        for(A = l * H, M = l * i, N = s, k = 0; k < h; ++k)w = M + N, o[b = A + N] = o[w], N += f;
                                        for(A = l * G, M = l * a, N = s, k = 0; k < h; ++k)w = M + N, o[b = A + N] = o[w], N += f;
                                        if (Q) for(_ = J; _ <= K; ++_){
                                            for(b = s + _ * l, B = 0, k = 0; k < h && 0 == (rt = o[b] - it[B]); ++k)B += d, b += p;
                                            if (0 !== rt) {
                                                if (rt < 0) {
                                                    if (_ !== J) for(A = l * _, M = l * J, N = s, k = 0; k < h; ++k)w = M + N, m = o[b = A + N], o[b] = o[w], o[w] = m, N += f;
                                                    ++J;
                                                } else for(;;){
                                                    for(b = s + K * l, B = 0, k = 0; k < h && 0 == (rt = o[b] - it[B]); ++k)B += d, b += p;
                                                    if (!(rt > 0)) {
                                                        if (rt < 0) {
                                                            for(A = l * _, M = l * J, S = l * K, N = s, k = 0; k < h; ++k)w = M + N, T = S + N, m = o[b = A + N], o[b] = o[w], o[w] = o[T], o[T] = m, N += f;
                                                            ++J, --K;
                                                            break;
                                                        }
                                                        for(A = l * _, M = l * K, N = s, k = 0; k < h; ++k)w = M + N, m = o[b = A + N], o[b] = o[w], o[w] = m, N += f;
                                                        --K;
                                                        break;
                                                    }
                                                    K--;
                                                }
                                            }
                                        }
                                        else for(_ = J; _ <= K; ++_){
                                            for(b = s + _ * l, B = 0, k = 0; k < h && 0 == (tt = o[b] - it[B]); ++k)B += d, b += p;
                                            if (tt < 0) {
                                                if (_ !== J) for(A = l * _, M = l * J, N = s, k = 0; k < h; ++k)w = M + N, m = o[b = A + N], o[b] = o[w], o[w] = m, N += f;
                                                ++J;
                                            } else {
                                                for(b = s + _ * l, B = 0, k = 0; k < h && 0 == (et = o[b] - at[B]); ++k)B += d, b += p;
                                                if (et > 0) for(;;){
                                                    for(b = s + K * l, B = 0, k = 0; k < h && 0 == (rt = o[b] - at[B]); ++k)B += d, b += p;
                                                    if (!(rt > 0)) {
                                                        for(b = s + K * l, B = 0, k = 0; k < h && 0 == (rt = o[b] - it[B]); ++k)B += d, b += p;
                                                        if (rt < 0) {
                                                            for(A = l * _, M = l * J, S = l * K, N = s, k = 0; k < h; ++k)w = M + N, T = S + N, m = o[b = A + N], o[b] = o[w], o[w] = o[T], o[T] = m, N += f;
                                                            ++J, --K;
                                                        } else {
                                                            for(A = l * _, M = l * K, N = s, k = 0; k < h; ++k)w = M + N, m = o[b = A + N], o[b] = o[w], o[w] = m, N += f;
                                                            --K;
                                                        }
                                                        break;
                                                    }
                                                    if (--K < _) break;
                                                }
                                            }
                                        }
                                        for(A = l * i, M = l * (J - 1), B = 0, N = s, k = 0; k < h; ++k)w = M + N, o[b = A + N] = o[w], o[w] = it[B], ++B, N += f;
                                        for(A = l * a, M = l * (K + 1), B = 0, N = s, k = 0; k < h; ++k)w = M + N, o[b = A + N] = o[w], o[w] = at[B], ++B, N += f;
                                        if (J - 2 - i <= 32 ? t1(i, J - 2, o, s, l, c, u, h, f, p, d) : n(i, J - 2, o, s, l, c, u, h, f, p, d), a - (K + 2) <= 32 ? t1(K + 2, a, o, s, l, c, u, h, f, p, d) : n(K + 2, a, o, s, l, c, u, h, f, p, d), Q) return r(it), void r(at);
                                        if (J < U && K > V) {
                                            t: for(;;){
                                                for(b = s + J * l, B = 0, N = s, k = 0; k < h; ++k){
                                                    if (o[b] !== it[B]) break t;
                                                    ++B, b += f;
                                                }
                                                ++J;
                                            }
                                            t: for(;;){
                                                for(b = s + K * l, B = 0, N = s, k = 0; k < h; ++k){
                                                    if (o[b] !== at[B]) break t;
                                                    ++B, b += f;
                                                }
                                                --K;
                                            }
                                            for(_ = J; _ <= K; ++_){
                                                for(b = s + _ * l, B = 0, k = 0; k < h && 0 == (tt = o[b] - it[B]); ++k)B += d, b += p;
                                                if (0 === tt) {
                                                    if (_ !== J) for(A = l * _, M = l * J, N = s, k = 0; k < h; ++k)w = M + N, m = o[b = A + N], o[b] = o[w], o[w] = m, N += f;
                                                    ++J;
                                                } else {
                                                    for(b = s + _ * l, B = 0, k = 0; k < h && 0 == (et = o[b] - at[B]); ++k)B += d, b += p;
                                                    if (0 === et) for(;;){
                                                        for(b = s + K * l, B = 0, k = 0; k < h && 0 == (rt = o[b] - at[B]); ++k)B += d, b += p;
                                                        if (0 !== rt) {
                                                            for(b = s + K * l, B = 0, k = 0; k < h && 0 == (rt = o[b] - it[B]); ++k)B += d, b += p;
                                                            if (rt < 0) {
                                                                for(A = l * _, M = l * J, S = l * K, N = s, k = 0; k < h; ++k)w = M + N, T = S + N, m = o[b = A + N], o[b] = o[w], o[w] = o[T], o[T] = m, N += f;
                                                                ++J, --K;
                                                            } else {
                                                                for(A = l * _, M = l * K, N = s, k = 0; k < h; ++k)w = M + N, m = o[b = A + N], o[b] = o[w], o[w] = m, N += f;
                                                                --K;
                                                            }
                                                            break;
                                                        }
                                                        if (--K < _) break;
                                                    }
                                                }
                                            }
                                        }
                                        r(it), r(at), K - J <= 32 ? t1(J, K, o, s, l, c, u, h, f, p, d) : n(J, K, o, s, l, c, u, h, f, p, d);
                                    };
                                }
                            }, s = {
                                "uint32,1,0": function(t1, e1) {
                                    return function(r) {
                                        var n = r.data, i = 0 | r.offset, a = r.shape, o = r.stride, s = 0 | o[0], l = 0 | a[0], c = 0 | o[1], u = 0 | a[1], h = c, f = c;
                                        l <= 32 ? t1(0, l - 1, n, i, s, c, l, u, h, f, 1) : e1(0, l - 1, n, i, s, c, l, u, h, f, 1);
                                    };
                                }
                            };
                            t1.exports = function(t1, e1) {
                                var r = [
                                    e1,
                                    t1
                                ].join(","), n = s[r], l = function(t1, e1) {
                                    var r = i(e1), n = [
                                        e1,
                                        t1
                                    ].join(","), o = a[n];
                                    return r ? o(r[0], r[1]) : o();
                                }(t1, e1), c = function(t1, e1, r) {
                                    var n = i(e1), a = [
                                        e1,
                                        t1
                                    ].join(","), s = o[a];
                                    return t1.length > 1 && n ? s(r, n[0], n[1]) : s(r);
                                }(t1, e1, l);
                                return n(l, c);
                            };
                        },
                        446: function(t1, e1, r) {
                            "use strict";
                            var n = r(7640), i = {};
                            t1.exports = function(t1) {
                                var e1 = t1.order, r = t1.dtype, a = [
                                    e1,
                                    r
                                ].join(":"), o = i[a];
                                return o || (i[a] = o = n(e1, r)), o(t1), t1;
                            };
                        },
                        9618: function(t1, e1, r) {
                            var n = r(7163), i = "undefined" != typeof Float64Array;
                            function a(t1, e1) {
                                return t1[0] - e1[0];
                            }
                            function o() {
                                var t1, e1 = this.stride, r = new Array(e1.length);
                                for(t1 = 0; t1 < r.length; ++t1)r[t1] = [
                                    Math.abs(e1[t1]),
                                    t1
                                ];
                                r.sort(a);
                                var n = new Array(r.length);
                                for(t1 = 0; t1 < n.length; ++t1)n[t1] = r[t1][1];
                                return n;
                            }
                            var s = {
                                T: function(t1) {
                                    function e1(t1) {
                                        this.data = t1;
                                    }
                                    var r = e1.prototype;
                                    return r.dtype = t1, r.index = function() {
                                        return -1;
                                    }, r.size = 0, r.dimension = -1, r.shape = r.stride = r.order = [], r.lo = r.hi = r.transpose = r.step = function() {
                                        return new e1(this.data);
                                    }, r.get = r.set = function() {}, r.pick = function() {
                                        return null;
                                    }, function(t1) {
                                        return new e1(t1);
                                    };
                                },
                                0: function(t1, e1) {
                                    function r(t1, e1) {
                                        this.data = t1, this.offset = e1;
                                    }
                                    var n = r.prototype;
                                    return n.dtype = t1, n.index = function() {
                                        return this.offset;
                                    }, n.dimension = 0, n.size = 1, n.shape = n.stride = n.order = [], n.lo = n.hi = n.transpose = n.step = function() {
                                        return new r(this.data, this.offset);
                                    }, n.pick = function() {
                                        return e1(this.data);
                                    }, n.valueOf = n.get = function() {
                                        return "generic" === t1 ? this.data.get(this.offset) : this.data[this.offset];
                                    }, n.set = function(e1) {
                                        return "generic" === t1 ? this.data.set(this.offset, e1) : this.data[this.offset] = e1;
                                    }, function(t1, e1, n, i) {
                                        return new r(t1, i);
                                    };
                                },
                                1: function(t1, e1, r) {
                                    function n(t1, e1, r, n) {
                                        this.data = t1, this.shape = [
                                            e1
                                        ], this.stride = [
                                            r
                                        ], this.offset = 0 | n;
                                    }
                                    var i = n.prototype;
                                    return i.dtype = t1, i.dimension = 1, Object.defineProperty(i, "size", {
                                        get: function() {
                                            return this.shape[0];
                                        }
                                    }), i.order = [
                                        0
                                    ], i.set = function(e1, r) {
                                        return "generic" === t1 ? this.data.set(this.offset + this.stride[0] * e1, r) : this.data[this.offset + this.stride[0] * e1] = r;
                                    }, i.get = function(e1) {
                                        return "generic" === t1 ? this.data.get(this.offset + this.stride[0] * e1) : this.data[this.offset + this.stride[0] * e1];
                                    }, i.index = function(t1) {
                                        return this.offset + this.stride[0] * t1;
                                    }, i.hi = function(t1) {
                                        return new n(this.data, "number" != typeof t1 || t1 < 0 ? this.shape[0] : 0 | t1, this.stride[0], this.offset);
                                    }, i.lo = function(t1) {
                                        var e1 = this.offset, r = 0, i = this.shape[0], a = this.stride[0];
                                        return "number" == typeof t1 && t1 >= 0 && (e1 += a * (r = 0 | t1), i -= r), new n(this.data, i, a, e1);
                                    }, i.step = function(t1) {
                                        var e1 = this.shape[0], r = this.stride[0], i = this.offset, a = 0, o = Math.ceil;
                                        return "number" == typeof t1 && ((a = 0 | t1) < 0 ? (i += r * (e1 - 1), e1 = o(-e1 / a)) : e1 = o(e1 / a), r *= a), new n(this.data, e1, r, i);
                                    }, i.transpose = function(t1) {
                                        t1 = void 0 === t1 ? 0 : 0 | t1;
                                        var e1 = this.shape, r = this.stride;
                                        return new n(this.data, e1[t1], r[t1], this.offset);
                                    }, i.pick = function(t1) {
                                        var r = [], n = [], i = this.offset;
                                        return "number" == typeof t1 && t1 >= 0 ? i = i + this.stride[0] * t1 | 0 : (r.push(this.shape[0]), n.push(this.stride[0])), (0, e1[r.length + 1])(this.data, r, n, i);
                                    }, function(t1, e1, r, i) {
                                        return new n(t1, e1[0], r[0], i);
                                    };
                                },
                                2: function(t1, e1, r) {
                                    function n(t1, e1, r, n, i, a) {
                                        this.data = t1, this.shape = [
                                            e1,
                                            r
                                        ], this.stride = [
                                            n,
                                            i
                                        ], this.offset = 0 | a;
                                    }
                                    var i = n.prototype;
                                    return i.dtype = t1, i.dimension = 2, Object.defineProperty(i, "size", {
                                        get: function() {
                                            return this.shape[0] * this.shape[1];
                                        }
                                    }), Object.defineProperty(i, "order", {
                                        get: function() {
                                            return Math.abs(this.stride[0]) > Math.abs(this.stride[1]) ? [
                                                1,
                                                0
                                            ] : [
                                                0,
                                                1
                                            ];
                                        }
                                    }), i.set = function(e1, r, n) {
                                        return "generic" === t1 ? this.data.set(this.offset + this.stride[0] * e1 + this.stride[1] * r, n) : this.data[this.offset + this.stride[0] * e1 + this.stride[1] * r] = n;
                                    }, i.get = function(e1, r) {
                                        return "generic" === t1 ? this.data.get(this.offset + this.stride[0] * e1 + this.stride[1] * r) : this.data[this.offset + this.stride[0] * e1 + this.stride[1] * r];
                                    }, i.index = function(t1, e1) {
                                        return this.offset + this.stride[0] * t1 + this.stride[1] * e1;
                                    }, i.hi = function(t1, e1) {
                                        return new n(this.data, "number" != typeof t1 || t1 < 0 ? this.shape[0] : 0 | t1, "number" != typeof e1 || e1 < 0 ? this.shape[1] : 0 | e1, this.stride[0], this.stride[1], this.offset);
                                    }, i.lo = function(t1, e1) {
                                        var r = this.offset, i = 0, a = this.shape[0], o = this.shape[1], s = this.stride[0], l = this.stride[1];
                                        return "number" == typeof t1 && t1 >= 0 && (r += s * (i = 0 | t1), a -= i), "number" == typeof e1 && e1 >= 0 && (r += l * (i = 0 | e1), o -= i), new n(this.data, a, o, s, l, r);
                                    }, i.step = function(t1, e1) {
                                        var r = this.shape[0], i = this.shape[1], a = this.stride[0], o = this.stride[1], s = this.offset, l = 0, c = Math.ceil;
                                        return "number" == typeof t1 && ((l = 0 | t1) < 0 ? (s += a * (r - 1), r = c(-r / l)) : r = c(r / l), a *= l), "number" == typeof e1 && ((l = 0 | e1) < 0 ? (s += o * (i - 1), i = c(-i / l)) : i = c(i / l), o *= l), new n(this.data, r, i, a, o, s);
                                    }, i.transpose = function(t1, e1) {
                                        t1 = void 0 === t1 ? 0 : 0 | t1, e1 = void 0 === e1 ? 1 : 0 | e1;
                                        var r = this.shape, i = this.stride;
                                        return new n(this.data, r[t1], r[e1], i[t1], i[e1], this.offset);
                                    }, i.pick = function(t1, r) {
                                        var n = [], i = [], a = this.offset;
                                        return "number" == typeof t1 && t1 >= 0 ? a = a + this.stride[0] * t1 | 0 : (n.push(this.shape[0]), i.push(this.stride[0])), "number" == typeof r && r >= 0 ? a = a + this.stride[1] * r | 0 : (n.push(this.shape[1]), i.push(this.stride[1])), (0, e1[n.length + 1])(this.data, n, i, a);
                                    }, function(t1, e1, r, i) {
                                        return new n(t1, e1[0], e1[1], r[0], r[1], i);
                                    };
                                },
                                3: function(t1, e1, r) {
                                    function n(t1, e1, r, n, i, a, o, s) {
                                        this.data = t1, this.shape = [
                                            e1,
                                            r,
                                            n
                                        ], this.stride = [
                                            i,
                                            a,
                                            o
                                        ], this.offset = 0 | s;
                                    }
                                    var i = n.prototype;
                                    return i.dtype = t1, i.dimension = 3, Object.defineProperty(i, "size", {
                                        get: function() {
                                            return this.shape[0] * this.shape[1] * this.shape[2];
                                        }
                                    }), Object.defineProperty(i, "order", {
                                        get: function() {
                                            var t1 = Math.abs(this.stride[0]), e1 = Math.abs(this.stride[1]), r = Math.abs(this.stride[2]);
                                            return t1 > e1 ? e1 > r ? [
                                                2,
                                                1,
                                                0
                                            ] : t1 > r ? [
                                                1,
                                                2,
                                                0
                                            ] : [
                                                1,
                                                0,
                                                2
                                            ] : t1 > r ? [
                                                2,
                                                0,
                                                1
                                            ] : r > e1 ? [
                                                0,
                                                1,
                                                2
                                            ] : [
                                                0,
                                                2,
                                                1
                                            ];
                                        }
                                    }), i.set = function(e1, r, n, i) {
                                        return "generic" === t1 ? this.data.set(this.offset + this.stride[0] * e1 + this.stride[1] * r + this.stride[2] * n, i) : this.data[this.offset + this.stride[0] * e1 + this.stride[1] * r + this.stride[2] * n] = i;
                                    }, i.get = function(e1, r, n) {
                                        return "generic" === t1 ? this.data.get(this.offset + this.stride[0] * e1 + this.stride[1] * r + this.stride[2] * n) : this.data[this.offset + this.stride[0] * e1 + this.stride[1] * r + this.stride[2] * n];
                                    }, i.index = function(t1, e1, r) {
                                        return this.offset + this.stride[0] * t1 + this.stride[1] * e1 + this.stride[2] * r;
                                    }, i.hi = function(t1, e1, r) {
                                        return new n(this.data, "number" != typeof t1 || t1 < 0 ? this.shape[0] : 0 | t1, "number" != typeof e1 || e1 < 0 ? this.shape[1] : 0 | e1, "number" != typeof r || r < 0 ? this.shape[2] : 0 | r, this.stride[0], this.stride[1], this.stride[2], this.offset);
                                    }, i.lo = function(t1, e1, r) {
                                        var i = this.offset, a = 0, o = this.shape[0], s = this.shape[1], l = this.shape[2], c = this.stride[0], u = this.stride[1], h = this.stride[2];
                                        return "number" == typeof t1 && t1 >= 0 && (i += c * (a = 0 | t1), o -= a), "number" == typeof e1 && e1 >= 0 && (i += u * (a = 0 | e1), s -= a), "number" == typeof r && r >= 0 && (i += h * (a = 0 | r), l -= a), new n(this.data, o, s, l, c, u, h, i);
                                    }, i.step = function(t1, e1, r) {
                                        var i = this.shape[0], a = this.shape[1], o = this.shape[2], s = this.stride[0], l = this.stride[1], c = this.stride[2], u = this.offset, h = 0, f = Math.ceil;
                                        return "number" == typeof t1 && ((h = 0 | t1) < 0 ? (u += s * (i - 1), i = f(-i / h)) : i = f(i / h), s *= h), "number" == typeof e1 && ((h = 0 | e1) < 0 ? (u += l * (a - 1), a = f(-a / h)) : a = f(a / h), l *= h), "number" == typeof r && ((h = 0 | r) < 0 ? (u += c * (o - 1), o = f(-o / h)) : o = f(o / h), c *= h), new n(this.data, i, a, o, s, l, c, u);
                                    }, i.transpose = function(t1, e1, r) {
                                        t1 = void 0 === t1 ? 0 : 0 | t1, e1 = void 0 === e1 ? 1 : 0 | e1, r = void 0 === r ? 2 : 0 | r;
                                        var i = this.shape, a = this.stride;
                                        return new n(this.data, i[t1], i[e1], i[r], a[t1], a[e1], a[r], this.offset);
                                    }, i.pick = function(t1, r, n) {
                                        var i = [], a = [], o = this.offset;
                                        return "number" == typeof t1 && t1 >= 0 ? o = o + this.stride[0] * t1 | 0 : (i.push(this.shape[0]), a.push(this.stride[0])), "number" == typeof r && r >= 0 ? o = o + this.stride[1] * r | 0 : (i.push(this.shape[1]), a.push(this.stride[1])), "number" == typeof n && n >= 0 ? o = o + this.stride[2] * n | 0 : (i.push(this.shape[2]), a.push(this.stride[2])), (0, e1[i.length + 1])(this.data, i, a, o);
                                    }, function(t1, e1, r, i) {
                                        return new n(t1, e1[0], e1[1], e1[2], r[0], r[1], r[2], i);
                                    };
                                },
                                4: function(t1, e1, r) {
                                    function n(t1, e1, r, n, i, a, o, s, l, c) {
                                        this.data = t1, this.shape = [
                                            e1,
                                            r,
                                            n,
                                            i
                                        ], this.stride = [
                                            a,
                                            o,
                                            s,
                                            l
                                        ], this.offset = 0 | c;
                                    }
                                    var i = n.prototype;
                                    return i.dtype = t1, i.dimension = 4, Object.defineProperty(i, "size", {
                                        get: function() {
                                            return this.shape[0] * this.shape[1] * this.shape[2] * this.shape[3];
                                        }
                                    }), Object.defineProperty(i, "order", {
                                        get: r
                                    }), i.set = function(e1, r, n, i, a) {
                                        return "generic" === t1 ? this.data.set(this.offset + this.stride[0] * e1 + this.stride[1] * r + this.stride[2] * n + this.stride[3] * i, a) : this.data[this.offset + this.stride[0] * e1 + this.stride[1] * r + this.stride[2] * n + this.stride[3] * i] = a;
                                    }, i.get = function(e1, r, n, i) {
                                        return "generic" === t1 ? this.data.get(this.offset + this.stride[0] * e1 + this.stride[1] * r + this.stride[2] * n + this.stride[3] * i) : this.data[this.offset + this.stride[0] * e1 + this.stride[1] * r + this.stride[2] * n + this.stride[3] * i];
                                    }, i.index = function(t1, e1, r, n) {
                                        return this.offset + this.stride[0] * t1 + this.stride[1] * e1 + this.stride[2] * r + this.stride[3] * n;
                                    }, i.hi = function(t1, e1, r, i) {
                                        return new n(this.data, "number" != typeof t1 || t1 < 0 ? this.shape[0] : 0 | t1, "number" != typeof e1 || e1 < 0 ? this.shape[1] : 0 | e1, "number" != typeof r || r < 0 ? this.shape[2] : 0 | r, "number" != typeof i || i < 0 ? this.shape[3] : 0 | i, this.stride[0], this.stride[1], this.stride[2], this.stride[3], this.offset);
                                    }, i.lo = function(t1, e1, r, i) {
                                        var a = this.offset, o = 0, s = this.shape[0], l = this.shape[1], c = this.shape[2], u = this.shape[3], h = this.stride[0], f = this.stride[1], p = this.stride[2], d = this.stride[3];
                                        return "number" == typeof t1 && t1 >= 0 && (a += h * (o = 0 | t1), s -= o), "number" == typeof e1 && e1 >= 0 && (a += f * (o = 0 | e1), l -= o), "number" == typeof r && r >= 0 && (a += p * (o = 0 | r), c -= o), "number" == typeof i && i >= 0 && (a += d * (o = 0 | i), u -= o), new n(this.data, s, l, c, u, h, f, p, d, a);
                                    }, i.step = function(t1, e1, r, i) {
                                        var a = this.shape[0], o = this.shape[1], s = this.shape[2], l = this.shape[3], c = this.stride[0], u = this.stride[1], h = this.stride[2], f = this.stride[3], p = this.offset, d = 0, m = Math.ceil;
                                        return "number" == typeof t1 && ((d = 0 | t1) < 0 ? (p += c * (a - 1), a = m(-a / d)) : a = m(a / d), c *= d), "number" == typeof e1 && ((d = 0 | e1) < 0 ? (p += u * (o - 1), o = m(-o / d)) : o = m(o / d), u *= d), "number" == typeof r && ((d = 0 | r) < 0 ? (p += h * (s - 1), s = m(-s / d)) : s = m(s / d), h *= d), "number" == typeof i && ((d = 0 | i) < 0 ? (p += f * (l - 1), l = m(-l / d)) : l = m(l / d), f *= d), new n(this.data, a, o, s, l, c, u, h, f, p);
                                    }, i.transpose = function(t1, e1, r, i) {
                                        t1 = void 0 === t1 ? 0 : 0 | t1, e1 = void 0 === e1 ? 1 : 0 | e1, r = void 0 === r ? 2 : 0 | r, i = void 0 === i ? 3 : 0 | i;
                                        var a = this.shape, o = this.stride;
                                        return new n(this.data, a[t1], a[e1], a[r], a[i], o[t1], o[e1], o[r], o[i], this.offset);
                                    }, i.pick = function(t1, r, n, i) {
                                        var a = [], o = [], s = this.offset;
                                        return "number" == typeof t1 && t1 >= 0 ? s = s + this.stride[0] * t1 | 0 : (a.push(this.shape[0]), o.push(this.stride[0])), "number" == typeof r && r >= 0 ? s = s + this.stride[1] * r | 0 : (a.push(this.shape[1]), o.push(this.stride[1])), "number" == typeof n && n >= 0 ? s = s + this.stride[2] * n | 0 : (a.push(this.shape[2]), o.push(this.stride[2])), "number" == typeof i && i >= 0 ? s = s + this.stride[3] * i | 0 : (a.push(this.shape[3]), o.push(this.stride[3])), (0, e1[a.length + 1])(this.data, a, o, s);
                                    }, function(t1, e1, r, i) {
                                        return new n(t1, e1[0], e1[1], e1[2], e1[3], r[0], r[1], r[2], r[3], i);
                                    };
                                },
                                5: function(t1, e1, r) {
                                    function n(t1, e1, r, n, i, a, o, s, l, c, u, h) {
                                        this.data = t1, this.shape = [
                                            e1,
                                            r,
                                            n,
                                            i,
                                            a
                                        ], this.stride = [
                                            o,
                                            s,
                                            l,
                                            c,
                                            u
                                        ], this.offset = 0 | h;
                                    }
                                    var i = n.prototype;
                                    return i.dtype = t1, i.dimension = 5, Object.defineProperty(i, "size", {
                                        get: function() {
                                            return this.shape[0] * this.shape[1] * this.shape[2] * this.shape[3] * this.shape[4];
                                        }
                                    }), Object.defineProperty(i, "order", {
                                        get: r
                                    }), i.set = function(e1, r, n, i, a, o) {
                                        return "generic" === t1 ? this.data.set(this.offset + this.stride[0] * e1 + this.stride[1] * r + this.stride[2] * n + this.stride[3] * i + this.stride[4] * a, o) : this.data[this.offset + this.stride[0] * e1 + this.stride[1] * r + this.stride[2] * n + this.stride[3] * i + this.stride[4] * a] = o;
                                    }, i.get = function(e1, r, n, i, a) {
                                        return "generic" === t1 ? this.data.get(this.offset + this.stride[0] * e1 + this.stride[1] * r + this.stride[2] * n + this.stride[3] * i + this.stride[4] * a) : this.data[this.offset + this.stride[0] * e1 + this.stride[1] * r + this.stride[2] * n + this.stride[3] * i + this.stride[4] * a];
                                    }, i.index = function(t1, e1, r, n, i) {
                                        return this.offset + this.stride[0] * t1 + this.stride[1] * e1 + this.stride[2] * r + this.stride[3] * n + this.stride[4] * i;
                                    }, i.hi = function(t1, e1, r, i, a) {
                                        return new n(this.data, "number" != typeof t1 || t1 < 0 ? this.shape[0] : 0 | t1, "number" != typeof e1 || e1 < 0 ? this.shape[1] : 0 | e1, "number" != typeof r || r < 0 ? this.shape[2] : 0 | r, "number" != typeof i || i < 0 ? this.shape[3] : 0 | i, "number" != typeof a || a < 0 ? this.shape[4] : 0 | a, this.stride[0], this.stride[1], this.stride[2], this.stride[3], this.stride[4], this.offset);
                                    }, i.lo = function(t1, e1, r, i, a) {
                                        var o = this.offset, s = 0, l = this.shape[0], c = this.shape[1], u = this.shape[2], h = this.shape[3], f = this.shape[4], p = this.stride[0], d = this.stride[1], m = this.stride[2], g = this.stride[3], y = this.stride[4];
                                        return "number" == typeof t1 && t1 >= 0 && (o += p * (s = 0 | t1), l -= s), "number" == typeof e1 && e1 >= 0 && (o += d * (s = 0 | e1), c -= s), "number" == typeof r && r >= 0 && (o += m * (s = 0 | r), u -= s), "number" == typeof i && i >= 0 && (o += g * (s = 0 | i), h -= s), "number" == typeof a && a >= 0 && (o += y * (s = 0 | a), f -= s), new n(this.data, l, c, u, h, f, p, d, m, g, y, o);
                                    }, i.step = function(t1, e1, r, i, a) {
                                        var o = this.shape[0], s = this.shape[1], l = this.shape[2], c = this.shape[3], u = this.shape[4], h = this.stride[0], f = this.stride[1], p = this.stride[2], d = this.stride[3], m = this.stride[4], g = this.offset, y = 0, v = Math.ceil;
                                        return "number" == typeof t1 && ((y = 0 | t1) < 0 ? (g += h * (o - 1), o = v(-o / y)) : o = v(o / y), h *= y), "number" == typeof e1 && ((y = 0 | e1) < 0 ? (g += f * (s - 1), s = v(-s / y)) : s = v(s / y), f *= y), "number" == typeof r && ((y = 0 | r) < 0 ? (g += p * (l - 1), l = v(-l / y)) : l = v(l / y), p *= y), "number" == typeof i && ((y = 0 | i) < 0 ? (g += d * (c - 1), c = v(-c / y)) : c = v(c / y), d *= y), "number" == typeof a && ((y = 0 | a) < 0 ? (g += m * (u - 1), u = v(-u / y)) : u = v(u / y), m *= y), new n(this.data, o, s, l, c, u, h, f, p, d, m, g);
                                    }, i.transpose = function(t1, e1, r, i, a) {
                                        t1 = void 0 === t1 ? 0 : 0 | t1, e1 = void 0 === e1 ? 1 : 0 | e1, r = void 0 === r ? 2 : 0 | r, i = void 0 === i ? 3 : 0 | i, a = void 0 === a ? 4 : 0 | a;
                                        var o = this.shape, s = this.stride;
                                        return new n(this.data, o[t1], o[e1], o[r], o[i], o[a], s[t1], s[e1], s[r], s[i], s[a], this.offset);
                                    }, i.pick = function(t1, r, n, i, a) {
                                        var o = [], s = [], l = this.offset;
                                        return "number" == typeof t1 && t1 >= 0 ? l = l + this.stride[0] * t1 | 0 : (o.push(this.shape[0]), s.push(this.stride[0])), "number" == typeof r && r >= 0 ? l = l + this.stride[1] * r | 0 : (o.push(this.shape[1]), s.push(this.stride[1])), "number" == typeof n && n >= 0 ? l = l + this.stride[2] * n | 0 : (o.push(this.shape[2]), s.push(this.stride[2])), "number" == typeof i && i >= 0 ? l = l + this.stride[3] * i | 0 : (o.push(this.shape[3]), s.push(this.stride[3])), "number" == typeof a && a >= 0 ? l = l + this.stride[4] * a | 0 : (o.push(this.shape[4]), s.push(this.stride[4])), (0, e1[o.length + 1])(this.data, o, s, l);
                                    }, function(t1, e1, r, i) {
                                        return new n(t1, e1[0], e1[1], e1[2], e1[3], e1[4], r[0], r[1], r[2], r[3], r[4], i);
                                    };
                                }
                            };
                            function l(t1, e1) {
                                var r = -1 === e1 ? "T" : String(e1), n = s[r];
                                return -1 === e1 ? n(t1) : 0 === e1 ? n(t1, c[t1][0]) : n(t1, c[t1], o);
                            }
                            var c = {
                                generic: [],
                                buffer: [],
                                array: [],
                                float32: [],
                                float64: [],
                                int8: [],
                                int16: [],
                                int32: [],
                                uint8_clamped: [],
                                uint8: [],
                                uint16: [],
                                uint32: [],
                                bigint64: [],
                                biguint64: []
                            };
                            t1.exports = function(t1, e1, r, a) {
                                if (void 0 === t1) return (0, c.array[0])([]);
                                "number" == typeof t1 && (t1 = [
                                    t1
                                ]), void 0 === e1 && (e1 = [
                                    t1.length
                                ]);
                                var o = e1.length;
                                if (void 0 === r) {
                                    r = new Array(o);
                                    for(var s = o - 1, u = 1; s >= 0; --s)r[s] = u, u *= e1[s];
                                }
                                if (void 0 === a) for(a = 0, s = 0; s < o; ++s)r[s] < 0 && (a -= (e1[s] - 1) * r[s]);
                                for(var h = function(t1) {
                                    if (n(t1)) return "buffer";
                                    if (i) switch(Object.prototype.toString.call(t1)){
                                        case "[object Float64Array]":
                                            return "float64";
                                        case "[object Float32Array]":
                                            return "float32";
                                        case "[object Int8Array]":
                                            return "int8";
                                        case "[object Int16Array]":
                                            return "int16";
                                        case "[object Int32Array]":
                                            return "int32";
                                        case "[object Uint8ClampedArray]":
                                            return "uint8_clamped";
                                        case "[object Uint8Array]":
                                            return "uint8";
                                        case "[object Uint16Array]":
                                            return "uint16";
                                        case "[object Uint32Array]":
                                            return "uint32";
                                        case "[object BigInt64Array]":
                                            return "bigint64";
                                        case "[object BigUint64Array]":
                                            return "biguint64";
                                    }
                                    return Array.isArray(t1) ? "array" : "generic";
                                }(t1), f = c[h]; f.length <= o + 1;)f.push(l(h, f.length - 1));
                                return (0, f[o + 1])(t1, e1, r, a);
                            };
                        },
                        1278: function(t1, e1, r) {
                            "use strict";
                            var n = r(2361), i = Math.pow(2, -1074), a = 4294967295;
                            t1.exports = function(t1, e1) {
                                if (isNaN(t1) || isNaN(e1)) return NaN;
                                if (t1 === e1) return t1;
                                if (0 === t1) return e1 < 0 ? -i : i;
                                var r = n.hi(t1), o = n.lo(t1);
                                return e1 > t1 == t1 > 0 ? o === a ? (r += 1, o = 0) : o += 1 : 0 === o ? (o = a, r -= 1) : o -= 1, n.pack(o, r);
                            };
                        },
                        8406: function(t1, e1) {
                            e1.vertexNormals = function(t1, e1, r) {
                                for(var n = e1.length, i = new Array(n), a = void 0 === r ? 1e-6 : r, o = 0; o < n; ++o)i[o] = [
                                    0,
                                    0,
                                    0
                                ];
                                for(o = 0; o < t1.length; ++o)for(var s = t1[o], l = 0, c = s[s.length - 1], u = s[0], h = 0; h < s.length; ++h){
                                    l = c, c = u, u = s[(h + 1) % s.length];
                                    for(var f = e1[l], p = e1[c], d = e1[u], m = new Array(3), g = 0, y = new Array(3), v = 0, x = 0; x < 3; ++x)m[x] = f[x] - p[x], g += m[x] * m[x], y[x] = d[x] - p[x], v += y[x] * y[x];
                                    if (g * v > a) {
                                        var _ = i[c], b = 1 / Math.sqrt(g * v);
                                        for(x = 0; x < 3; ++x){
                                            var w = (x + 1) % 3, T = (x + 2) % 3;
                                            _[x] += b * (y[w] * m[T] - y[T] * m[w]);
                                        }
                                    }
                                }
                                for(o = 0; o < n; ++o){
                                    _ = i[o];
                                    var k = 0;
                                    for(x = 0; x < 3; ++x)k += _[x] * _[x];
                                    if (k > a) for(b = 1 / Math.sqrt(k), x = 0; x < 3; ++x)_[x] *= b;
                                    else for(x = 0; x < 3; ++x)_[x] = 0;
                                }
                                return i;
                            }, e1.faceNormals = function(t1, e1, r) {
                                for(var n = t1.length, i = new Array(n), a = void 0 === r ? 1e-6 : r, o = 0; o < n; ++o){
                                    for(var s = t1[o], l = new Array(3), c = 0; c < 3; ++c)l[c] = e1[s[c]];
                                    var u = new Array(3), h = new Array(3);
                                    for(c = 0; c < 3; ++c)u[c] = l[1][c] - l[0][c], h[c] = l[2][c] - l[0][c];
                                    var f = new Array(3), p = 0;
                                    for(c = 0; c < 3; ++c){
                                        var d = (c + 1) % 3, m = (c + 2) % 3;
                                        f[c] = u[d] * h[m] - u[m] * h[d], p += f[c] * f[c];
                                    }
                                    for(p = p > a ? 1 / Math.sqrt(p) : 0, c = 0; c < 3; ++c)f[c] *= p;
                                    i[o] = f;
                                }
                                return i;
                            };
                        },
                        4081: function(t1) {
                            "use strict";
                            t1.exports = function(t1, e1, r, n, i, a, o, s, l, c) {
                                var u = e1 + a + c;
                                if (h > 0) {
                                    var h = Math.sqrt(u + 1);
                                    t1[0] = .5 * (o - l) / h, t1[1] = .5 * (s - n) / h, t1[2] = .5 * (r - a) / h, t1[3] = .5 * h;
                                } else {
                                    var f = Math.max(e1, a, c);
                                    h = Math.sqrt(2 * f - u + 1), e1 >= f ? (t1[0] = .5 * h, t1[1] = .5 * (i + r) / h, t1[2] = .5 * (s + n) / h, t1[3] = .5 * (o - l) / h) : a >= f ? (t1[0] = .5 * (r + i) / h, t1[1] = .5 * h, t1[2] = .5 * (l + o) / h, t1[3] = .5 * (s - n) / h) : (t1[0] = .5 * (n + s) / h, t1[1] = .5 * (o + l) / h, t1[2] = .5 * h, t1[3] = .5 * (r - i) / h);
                                }
                                return t1;
                            };
                        },
                        9977: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1) {
                                var e1 = (t1 = t1 || {}).center || [
                                    0,
                                    0,
                                    0
                                ], r = t1.rotation || [
                                    0,
                                    0,
                                    0,
                                    1
                                ], n = t1.radius || 1;
                                e1 = [].slice.call(e1, 0, 3), u(r = [].slice.call(r, 0, 4), r);
                                var i = new h(r, e1, Math.log(n));
                                return i.setDistanceLimits(t1.zoomMin, t1.zoomMax), ("eye" in t1 || "up" in t1) && i.lookAt(0, t1.eye, t1.center, t1.up), i;
                            };
                            var n = r(9215), i = r(6582), a = r(7399), o = r(7608), s = r(4081);
                            function l(t1, e1, r) {
                                return Math.sqrt(Math.pow(t1, 2) + Math.pow(e1, 2) + Math.pow(r, 2));
                            }
                            function c(t1, e1, r, n) {
                                return Math.sqrt(Math.pow(t1, 2) + Math.pow(e1, 2) + Math.pow(r, 2) + Math.pow(n, 2));
                            }
                            function u(t1, e1) {
                                var r = e1[0], n = e1[1], i = e1[2], a = e1[3], o = c(r, n, i, a);
                                o > 1e-6 ? (t1[0] = r / o, t1[1] = n / o, t1[2] = i / o, t1[3] = a / o) : (t1[0] = t1[1] = t1[2] = 0, t1[3] = 1);
                            }
                            function h(t1, e1, r) {
                                this.radius = n([
                                    r
                                ]), this.center = n(e1), this.rotation = n(t1), this.computedRadius = this.radius.curve(0), this.computedCenter = this.center.curve(0), this.computedRotation = this.rotation.curve(0), this.computedUp = [
                                    .1,
                                    0,
                                    0
                                ], this.computedEye = [
                                    .1,
                                    0,
                                    0
                                ], this.computedMatrix = [
                                    .1,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0
                                ], this.recalcMatrix(0);
                            }
                            var f = h.prototype;
                            f.lastT = function() {
                                return Math.max(this.radius.lastT(), this.center.lastT(), this.rotation.lastT());
                            }, f.recalcMatrix = function(t1) {
                                this.radius.curve(t1), this.center.curve(t1), this.rotation.curve(t1);
                                var e1 = this.computedRotation;
                                u(e1, e1);
                                var r = this.computedMatrix;
                                a(r, e1);
                                var n = this.computedCenter, i = this.computedEye, o = this.computedUp, s = Math.exp(this.computedRadius[0]);
                                i[0] = n[0] + s * r[2], i[1] = n[1] + s * r[6], i[2] = n[2] + s * r[10], o[0] = r[1], o[1] = r[5], o[2] = r[9];
                                for(var l = 0; l < 3; ++l){
                                    for(var c = 0, h = 0; h < 3; ++h)c += r[l + 4 * h] * i[h];
                                    r[12 + l] = -c;
                                }
                            }, f.getMatrix = function(t1, e1) {
                                this.recalcMatrix(t1);
                                var r = this.computedMatrix;
                                if (e1) {
                                    for(var n = 0; n < 16; ++n)e1[n] = r[n];
                                    return e1;
                                }
                                return r;
                            }, f.idle = function(t1) {
                                this.center.idle(t1), this.radius.idle(t1), this.rotation.idle(t1);
                            }, f.flush = function(t1) {
                                this.center.flush(t1), this.radius.flush(t1), this.rotation.flush(t1);
                            }, f.pan = function(t1, e1, r, n) {
                                e1 = e1 || 0, r = r || 0, n = n || 0, this.recalcMatrix(t1);
                                var i = this.computedMatrix, a = i[1], o = i[5], s = i[9], c = l(a, o, s);
                                a /= c, o /= c, s /= c;
                                var u = i[0], h = i[4], f = i[8], p = u * a + h * o + f * s, d = l(u -= a * p, h -= o * p, f -= s * p);
                                u /= d, h /= d, f /= d;
                                var m = i[2], g = i[6], y = i[10], v = m * a + g * o + y * s, x = m * u + g * h + y * f, _ = l(m -= v * a + x * u, g -= v * o + x * h, y -= v * s + x * f);
                                m /= _, g /= _, y /= _;
                                var b = u * e1 + a * r, w = h * e1 + o * r, T = f * e1 + s * r;
                                this.center.move(t1, b, w, T);
                                var k = Math.exp(this.computedRadius[0]);
                                k = Math.max(1e-4, k + n), this.radius.set(t1, Math.log(k));
                            }, f.rotate = function(t1, e1, r, n) {
                                this.recalcMatrix(t1), e1 = e1 || 0, r = r || 0;
                                var i = this.computedMatrix, a = i[0], o = i[4], s = i[8], u = i[1], h = i[5], f = i[9], p = i[2], d = i[6], m = i[10], g = e1 * a + r * u, y = e1 * o + r * h, v = e1 * s + r * f, x = -(d * v - m * y), _ = -(m * g - p * v), b = -(p * y - d * g), w = Math.sqrt(Math.max(0, 1 - Math.pow(x, 2) - Math.pow(_, 2) - Math.pow(b, 2))), T = c(x, _, b, w);
                                T > 1e-6 ? (x /= T, _ /= T, b /= T, w /= T) : (x = _ = b = 0, w = 1);
                                var k = this.computedRotation, A = k[0], M = k[1], S = k[2], E = k[3], C = A * w + E * x + M * b - S * _, L = M * w + E * _ + S * x - A * b, I = S * w + E * b + A * _ - M * x, P = E * w - A * x - M * _ - S * b;
                                if (n) {
                                    x = p, _ = d, b = m;
                                    var z = Math.sin(n) / l(x, _, b);
                                    x *= z, _ *= z, b *= z, P = P * (w = Math.cos(e1)) - (C = C * w + P * x + L * b - I * _) * x - (L = L * w + P * _ + I * x - C * b) * _ - (I = I * w + P * b + C * _ - L * x) * b;
                                }
                                var O = c(C, L, I, P);
                                O > 1e-6 ? (C /= O, L /= O, I /= O, P /= O) : (C = L = I = 0, P = 1), this.rotation.set(t1, C, L, I, P);
                            }, f.lookAt = function(t1, e1, r, n) {
                                this.recalcMatrix(t1), r = r || this.computedCenter, e1 = e1 || this.computedEye, n = n || this.computedUp;
                                var a = this.computedMatrix;
                                i(a, e1, r, n);
                                var o = this.computedRotation;
                                s(o, a[0], a[1], a[2], a[4], a[5], a[6], a[8], a[9], a[10]), u(o, o), this.rotation.set(t1, o[0], o[1], o[2], o[3]);
                                for(var l = 0, c = 0; c < 3; ++c)l += Math.pow(r[c] - e1[c], 2);
                                this.radius.set(t1, .5 * Math.log(Math.max(l, 1e-6))), this.center.set(t1, r[0], r[1], r[2]);
                            }, f.translate = function(t1, e1, r, n) {
                                this.center.move(t1, e1 || 0, r || 0, n || 0);
                            }, f.setMatrix = function(t1, e1) {
                                var r = this.computedRotation;
                                s(r, e1[0], e1[1], e1[2], e1[4], e1[5], e1[6], e1[8], e1[9], e1[10]), u(r, r), this.rotation.set(t1, r[0], r[1], r[2], r[3]);
                                var n = this.computedMatrix;
                                o(n, e1);
                                var i = n[15];
                                if (Math.abs(i) > 1e-6) {
                                    var a = n[12] / i, l = n[13] / i, c = n[14] / i;
                                    this.recalcMatrix(t1);
                                    var h = Math.exp(this.computedRadius[0]);
                                    this.center.set(t1, a - n[2] * h, l - n[6] * h, c - n[10] * h), this.radius.idle(t1);
                                } else this.center.idle(t1), this.radius.idle(t1);
                            }, f.setDistance = function(t1, e1) {
                                e1 > 0 && this.radius.set(t1, Math.log(e1));
                            }, f.setDistanceLimits = function(t1, e1) {
                                t1 = t1 > 0 ? Math.log(t1) : -1 / 0, e1 = e1 > 0 ? Math.log(e1) : 1 / 0, e1 = Math.max(e1, t1), this.radius.bounds[0][0] = t1, this.radius.bounds[1][0] = e1;
                            }, f.getDistanceLimits = function(t1) {
                                var e1 = this.radius.bounds;
                                return t1 ? (t1[0] = Math.exp(e1[0][0]), t1[1] = Math.exp(e1[1][0]), t1) : [
                                    Math.exp(e1[0][0]),
                                    Math.exp(e1[1][0])
                                ];
                            }, f.toJSON = function() {
                                return this.recalcMatrix(this.lastT()), {
                                    center: this.computedCenter.slice(),
                                    rotation: this.computedRotation.slice(),
                                    distance: Math.log(this.computedRadius[0]),
                                    zoomMin: this.radius.bounds[0][0],
                                    zoomMax: this.radius.bounds[1][0]
                                };
                            }, f.fromJSON = function(t1) {
                                var e1 = this.lastT(), r = t1.center;
                                r && this.center.set(e1, r[0], r[1], r[2]);
                                var n = t1.rotation;
                                n && this.rotation.set(e1, n[0], n[1], n[2], n[3]);
                                var i = t1.distance;
                                i && i > 0 && this.radius.set(e1, Math.log(i)), this.setDistanceLimits(t1.zoomMin, t1.zoomMax);
                            };
                        },
                        1371: function(t1, e1, r) {
                            "use strict";
                            var n = r(3233);
                            t1.exports = function(t1, e1, r) {
                                return n(r = void 0 !== r ? r + "" : " ", e1) + t1;
                            };
                        },
                        3202: function(t1) {
                            t1.exports = function(t1, e1) {
                                e1 || (e1 = [
                                    0,
                                    ""
                                ]), t1 = String(t1);
                                var r = parseFloat(t1, 10);
                                return e1[0] = r, e1[1] = t1.match(/[\d.\-\+]*\s*(.*)/)[1] || "", e1;
                            };
                        },
                        3088: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1) {
                                for(var r = 0 | e1.length, i = t1.length, a = [
                                    new Array(r),
                                    new Array(r)
                                ], o = 0; o < r; ++o)a[0][o] = [], a[1][o] = [];
                                for(o = 0; o < i; ++o){
                                    var s = t1[o];
                                    a[0][s[0]].push(s), a[1][s[1]].push(s);
                                }
                                var l = [];
                                for(o = 0; o < r; ++o)a[0][o].length + a[1][o].length === 0 && l.push([
                                    o
                                ]);
                                function c(t1, e1) {
                                    var r = a[e1][t1[e1]];
                                    r.splice(r.indexOf(t1), 1);
                                }
                                function u(t1, r, i) {
                                    for(var o, s, l, u = 0; u < 2; ++u)if (a[u][r].length > 0) {
                                        o = a[u][r][0], l = u;
                                        break;
                                    }
                                    s = o[1 ^ l];
                                    for(var h = 0; h < 2; ++h)for(var f = a[h][r], p = 0; p < f.length; ++p){
                                        var d = f[p], m = d[1 ^ h];
                                        n(e1[t1], e1[r], e1[s], e1[m]) > 0 && (o = d, s = m, l = h);
                                    }
                                    return i || o && c(o, l), s;
                                }
                                function h(t1, r) {
                                    var i = a[r][t1][0], o = [
                                        t1
                                    ];
                                    c(i, r);
                                    for(var s = i[1 ^ r];;){
                                        for(; s !== t1;)o.push(s), s = u(o[o.length - 2], s, !1);
                                        if (a[0][t1].length + a[1][t1].length === 0) break;
                                        var l = o[o.length - 1], h = t1, f = o[1], p = u(l, h, !0);
                                        if (n(e1[l], e1[h], e1[f], e1[p]) < 0) break;
                                        o.push(t1), s = u(l, h);
                                    }
                                    return o;
                                }
                                function f(t1, e1) {
                                    return e1[1] === e1[e1.length - 1];
                                }
                                for(o = 0; o < r; ++o)for(var p = 0; p < 2; ++p){
                                    for(var d = []; a[p][o].length > 0;){
                                        a[0][o].length;
                                        var m = h(o, p);
                                        f(0, m) ? d.push.apply(d, m) : (d.length > 0 && l.push(d), d = m);
                                    }
                                    d.length > 0 && l.push(d);
                                }
                                return l;
                            };
                            var n = r(3140);
                        },
                        5609: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1) {
                                for(var r = n(t1, e1.length), i = new Array(e1.length), a = new Array(e1.length), o = [], s = 0; s < e1.length; ++s){
                                    var l = r[s].length;
                                    a[s] = l, i[s] = !0, l <= 1 && o.push(s);
                                }
                                for(; o.length > 0;){
                                    i[p = o.pop()] = !1;
                                    var c = r[p];
                                    for(s = 0; s < c.length; ++s){
                                        var u = c[s];
                                        0 == --a[u] && o.push(u);
                                    }
                                }
                                var h = new Array(e1.length), f = [];
                                for(s = 0; s < e1.length; ++s)if (i[s]) {
                                    var p = f.length;
                                    h[s] = p, f.push(e1[s]);
                                } else h[s] = -1;
                                var d = [];
                                for(s = 0; s < t1.length; ++s){
                                    var m = t1[s];
                                    i[m[0]] && i[m[1]] && d.push([
                                        h[m[0]],
                                        h[m[1]]
                                    ]);
                                }
                                return [
                                    d,
                                    f
                                ];
                            };
                            var n = r(3134);
                        },
                        2095: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1) {
                                var r = c(t1, e1);
                                t1 = r[0];
                                for(var h = (e1 = r[1]).length, f = (t1.length, n(t1, e1.length)), p = 0; p < h; ++p)if (f[p].length % 2 == 1) throw new Error("planar-graph-to-polyline: graph must be manifold");
                                var d = i(t1, e1), m = (d = d.filter(function(t1) {
                                    for(var r = t1.length, n = [
                                        0
                                    ], i = 0; i < r; ++i){
                                        var a = e1[t1[i]], l = e1[t1[(i + 1) % r]], c = o(-a[0], a[1]), u = o(-a[0], l[1]), h = o(l[0], a[1]), f = o(l[0], l[1]);
                                        n = s(n, s(s(c, u), s(h, f)));
                                    }
                                    return n[n.length - 1] > 0;
                                })).length, g = new Array(m), y = new Array(m);
                                for(p = 0; p < m; ++p){
                                    g[p] = p;
                                    var v = new Array(m), x = d[p].map(function(t1) {
                                        return e1[t1];
                                    }), _ = a([
                                        x
                                    ]), b = 0;
                                    t: for(var w = 0; w < m; ++w)if (v[w] = 0, p !== w) {
                                        for(var T = (q = d[w]).length, k = 0; k < T; ++k){
                                            var A = _(e1[q[k]]);
                                            if (0 !== A) {
                                                A < 0 && (v[w] = 1, b += 1);
                                                continue t;
                                            }
                                        }
                                        v[w] = 1, b += 1;
                                    }
                                    y[p] = [
                                        b,
                                        p,
                                        v
                                    ];
                                }
                                for(y.sort(function(t1, e1) {
                                    return e1[0] - t1[0];
                                }), p = 0; p < m; ++p){
                                    var M = (v = y[p])[1], S = v[2];
                                    for(w = 0; w < m; ++w)S[w] && (g[w] = M);
                                }
                                var E = function(t1) {
                                    for(var e1 = new Array(t1), r = 0; r < t1; ++r)e1[r] = [];
                                    return e1;
                                }(m);
                                for(p = 0; p < m; ++p)E[p].push(g[p]), E[g[p]].push(p);
                                var C = {}, L = u(h, !1);
                                for(p = 0; p < m; ++p)for(T = (q = d[p]).length, w = 0; w < T; ++w){
                                    var I = q[w], P = q[(w + 1) % T], z = Math.min(I, P) + ":" + Math.max(I, P);
                                    if (z in C) {
                                        var O = C[z];
                                        E[O].push(p), E[p].push(O), L[I] = L[P] = !0;
                                    } else C[z] = p;
                                }
                                function D(t1) {
                                    for(var e1 = t1.length, r = 0; r < e1; ++r)if (!L[t1[r]]) return !1;
                                    return !0;
                                }
                                var R = [], F = u(m, -1);
                                for(p = 0; p < m; ++p)g[p] !== p || D(d[p]) ? F[p] = -1 : (R.push(p), F[p] = 0);
                                for(r = []; R.length > 0;){
                                    var B = R.pop(), N = E[B];
                                    l(N, function(t1, e1) {
                                        return t1 - e1;
                                    });
                                    var j, U = N.length, V = F[B];
                                    for(0 === V && (j = [
                                        q = d[B]
                                    ]), p = 0; p < U; ++p){
                                        var q, H = N[p];
                                        F[H] >= 0 || (F[H] = 1 ^ V, R.push(H), 0 === V && (D(q = d[H]) || (q.reverse(), j.push(q))));
                                    }
                                    0 === V && r.push(j);
                                }
                                return r;
                            };
                            var n = r(3134), i = r(3088), a = r(5085), o = r(5250), s = r(8210), l = r(1682), c = r(5609);
                            function u(t1, e1) {
                                for(var r = new Array(t1), n = 0; n < t1; ++n)r[n] = e1;
                                return r;
                            }
                        },
                        5085: function(t1, e1, r) {
                            t1.exports = function(t1) {
                                for(var e1 = t1.length, r = [], a = [], s = 0; s < e1; ++s)for(var u = t1[s], h = u.length, f = h - 1, p = 0; p < h; f = p++){
                                    var d = u[f], m = u[p];
                                    d[0] === m[0] ? a.push([
                                        d,
                                        m
                                    ]) : r.push([
                                        d,
                                        m
                                    ]);
                                }
                                if (0 === r.length) return 0 === a.length ? c : (g = l(a), function(t1) {
                                    return g(t1[0], t1[1]) ? 0 : 1;
                                });
                                var g, y = i(r), v = function(t1, e1) {
                                    return function(r) {
                                        var i = o.le(e1, r[0]);
                                        if (i < 0) return 1;
                                        var a = t1[i];
                                        if (!a) {
                                            if (!(i > 0 && e1[i] === r[0])) return 1;
                                            a = t1[i - 1];
                                        }
                                        for(var s = 1; a;){
                                            var l = a.key, c = n(r, l[0], l[1]);
                                            if (l[0][0] < l[1][0]) {
                                                if (c < 0) a = a.left;
                                                else {
                                                    if (!(c > 0)) return 0;
                                                    s = -1, a = a.right;
                                                }
                                            } else if (c > 0) a = a.left;
                                            else {
                                                if (!(c < 0)) return 0;
                                                s = 1, a = a.right;
                                            }
                                        }
                                        return s;
                                    };
                                }(y.slabs, y.coordinates);
                                return 0 === a.length ? v : function(t1, e1) {
                                    return function(r) {
                                        return t1(r[0], r[1]) ? 0 : e1(r);
                                    };
                                }(l(a), v);
                            };
                            var n = r(3250)[3], i = r(4209), a = r(3352), o = r(2478);
                            function s() {
                                return !0;
                            }
                            function l(t1) {
                                for(var e1 = {}, r = 0; r < t1.length; ++r){
                                    var n = t1[r], i = n[0][0], o = n[0][1], l = n[1][1], c = [
                                        Math.min(o, l),
                                        Math.max(o, l)
                                    ];
                                    i in e1 ? e1[i].push(c) : e1[i] = [
                                        c
                                    ];
                                }
                                var u = {}, h = Object.keys(e1);
                                for(r = 0; r < h.length; ++r){
                                    var f = e1[h[r]];
                                    u[h[r]] = a(f);
                                }
                                return function(t1) {
                                    return function(e1, r) {
                                        var n = t1[e1];
                                        return !!n && !!n.queryPoint(r, s);
                                    };
                                }(u);
                            }
                            function c(t1) {
                                return 1;
                            }
                        },
                        9346: function(t1) {
                            "use strict";
                            var e1 = new Float64Array(4), r = new Float64Array(4), n = new Float64Array(4);
                            t1.exports = function(t1, i, a, o, s) {
                                e1.length < o.length && (e1 = new Float64Array(o.length), r = new Float64Array(o.length), n = new Float64Array(o.length));
                                for(var l = 0; l < o.length; ++l)e1[l] = t1[l] - o[l], r[l] = i[l] - t1[l], n[l] = a[l] - t1[l];
                                var c = 0, u = 0, h = 0, f = 0, p = 0, d = 0;
                                for(l = 0; l < o.length; ++l){
                                    var m = r[l], g = n[l], y = e1[l];
                                    c += m * m, u += m * g, h += g * g, f += y * m, p += y * g, d += y * y;
                                }
                                var v, x, _, b, w, T = Math.abs(c * h - u * u), k = u * p - h * f, A = u * f - c * p;
                                if (k + A <= T) {
                                    if (k < 0) A < 0 && f < 0 ? (A = 0, -f >= c ? (k = 1, v = c + 2 * f + d) : v = f * (k = -f / c) + d) : (k = 0, p >= 0 ? (A = 0, v = d) : -p >= h ? (A = 1, v = h + 2 * p + d) : v = p * (A = -p / h) + d);
                                    else if (A < 0) A = 0, f >= 0 ? (k = 0, v = d) : -f >= c ? (k = 1, v = c + 2 * f + d) : v = f * (k = -f / c) + d;
                                    else {
                                        var M = 1 / T;
                                        v = (k *= M) * (c * k + u * (A *= M) + 2 * f) + A * (u * k + h * A + 2 * p) + d;
                                    }
                                } else k < 0 ? (_ = h + p) > (x = u + f) ? (b = _ - x) >= (w = c - 2 * u + h) ? (k = 1, A = 0, v = c + 2 * f + d) : v = (k = b / w) * (c * k + u * (A = 1 - k) + 2 * f) + A * (u * k + h * A + 2 * p) + d : (k = 0, _ <= 0 ? (A = 1, v = h + 2 * p + d) : p >= 0 ? (A = 0, v = d) : v = p * (A = -p / h) + d) : A < 0 ? (_ = c + f) > (x = u + p) ? (b = _ - x) >= (w = c - 2 * u + h) ? (A = 1, k = 0, v = h + 2 * p + d) : v = (k = 1 - (A = b / w)) * (c * k + u * A + 2 * f) + A * (u * k + h * A + 2 * p) + d : (A = 0, _ <= 0 ? (k = 1, v = c + 2 * f + d) : f >= 0 ? (k = 0, v = d) : v = f * (k = -f / c) + d) : (b = h + p - u - f) <= 0 ? (k = 0, A = 1, v = h + 2 * p + d) : b >= (w = c - 2 * u + h) ? (k = 1, A = 0, v = c + 2 * f + d) : v = (k = b / w) * (c * k + u * (A = 1 - k) + 2 * f) + A * (u * k + h * A + 2 * p) + d;
                                var S = 1 - k - A;
                                for(l = 0; l < o.length; ++l)s[l] = S * t1[l] + k * i[l] + A * a[l];
                                return v < 0 ? 0 : v;
                            };
                        },
                        8648: function(t1, e1, r) {
                            t1.exports = r(783);
                        },
                        2653: function(t1, e1, r) {
                            "use strict";
                            var n = r(3865);
                            t1.exports = function(t1, e1) {
                                for(var r = t1.length, i = new Array(r), a = 0; a < r; ++a)i[a] = n(t1[a], e1[a]);
                                return i;
                            };
                        },
                        5838: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1) {
                                for(var e1 = new Array(t1.length), r = 0; r < t1.length; ++r)e1[r] = n(t1[r]);
                                return e1;
                            };
                            var n = r(7842);
                        },
                        8987: function(t1, e1, r) {
                            "use strict";
                            var n = r(7842), i = r(6504);
                            t1.exports = function(t1, e1) {
                                for(var r = n(e1), a = t1.length, o = new Array(a), s = 0; s < a; ++s)o[s] = i(t1[s], r);
                                return o;
                            };
                        },
                        544: function(t1, e1, r) {
                            "use strict";
                            var n = r(5572);
                            t1.exports = function(t1, e1) {
                                for(var r = t1.length, i = new Array(r), a = 0; a < r; ++a)i[a] = n(t1[a], e1[a]);
                                return i;
                            };
                        },
                        5771: function(t1, e1, r) {
                            "use strict";
                            var n = r(8507), i = r(3788), a = r(2419);
                            t1.exports = function(t1) {
                                t1.sort(i);
                                for(var e1 = t1.length, r = 0, o = 0; o < e1; ++o){
                                    var s = t1[o], l = a(s);
                                    if (0 !== l) {
                                        if (r > 0) {
                                            var c = t1[r - 1];
                                            if (0 === n(s, c) && a(c) !== l) {
                                                r -= 1;
                                                continue;
                                            }
                                        }
                                        t1[r++] = s;
                                    }
                                }
                                return t1.length = r, t1;
                            };
                        },
                        3233: function(t1) {
                            "use strict";
                            var e1, r = "";
                            t1.exports = function(t1, n) {
                                if ("string" != typeof t1) throw new TypeError("expected a string");
                                if (1 === n) return t1;
                                if (2 === n) return t1 + t1;
                                var i = t1.length * n;
                                if (e1 !== t1 || void 0 === e1) e1 = t1, r = "";
                                else if (r.length >= i) return r.substr(0, i);
                                for(; i > r.length && n > 1;)1 & n && (r += t1), n >>= 1, t1 += t1;
                                return r = (r += t1).substr(0, i);
                            };
                        },
                        3025: function(t1, e1, r) {
                            t1.exports = r.g.performance && r.g.performance.now ? function() {
                                return performance.now();
                            } : Date.now || function() {
                                return +new Date;
                            };
                        },
                        7004: function(t1) {
                            "use strict";
                            t1.exports = function(t1) {
                                for(var e1 = t1.length, r = t1[t1.length - 1], n = e1, i = e1 - 2; i >= 0; --i){
                                    var a = r;
                                    (l = (s = t1[i]) - ((r = a + s) - a)) && (t1[--n] = r, r = l);
                                }
                                var o = 0;
                                for(i = n; i < e1; ++i){
                                    var s, l;
                                    (l = (s = r) - ((r = (a = t1[i]) + s) - a)) && (t1[o++] = l);
                                }
                                return t1[o++] = r, t1.length = o, t1;
                            };
                        },
                        2962: function(t1, e1, r) {
                            "use strict";
                            var n = r(5250), i = r(8210), a = r(3012), o = r(7004);
                            function s(t1, e1, r, n) {
                                return function(e1) {
                                    return n(t1(r(e1[0][0], e1[1][1]), r(-e1[0][1], e1[1][0])));
                                };
                            }
                            function l(t1, e1, r, n) {
                                return function(i) {
                                    return n(t1(e1(t1(r(i[1][1], i[2][2]), r(-i[1][2], i[2][1])), i[0][0]), t1(e1(t1(r(i[1][0], i[2][2]), r(-i[1][2], i[2][0])), -i[0][1]), e1(t1(r(i[1][0], i[2][1]), r(-i[1][1], i[2][0])), i[0][2]))));
                                };
                            }
                            function c(t1, e1, r, n) {
                                return function(i) {
                                    return n(t1(t1(e1(t1(e1(t1(r(i[2][2], i[3][3]), r(-i[2][3], i[3][2])), i[1][1]), t1(e1(t1(r(i[2][1], i[3][3]), r(-i[2][3], i[3][1])), -i[1][2]), e1(t1(r(i[2][1], i[3][2]), r(-i[2][2], i[3][1])), i[1][3]))), i[0][0]), e1(t1(e1(t1(r(i[2][2], i[3][3]), r(-i[2][3], i[3][2])), i[1][0]), t1(e1(t1(r(i[2][0], i[3][3]), r(-i[2][3], i[3][0])), -i[1][2]), e1(t1(r(i[2][0], i[3][2]), r(-i[2][2], i[3][0])), i[1][3]))), -i[0][1])), t1(e1(t1(e1(t1(r(i[2][1], i[3][3]), r(-i[2][3], i[3][1])), i[1][0]), t1(e1(t1(r(i[2][0], i[3][3]), r(-i[2][3], i[3][0])), -i[1][1]), e1(t1(r(i[2][0], i[3][1]), r(-i[2][1], i[3][0])), i[1][3]))), i[0][2]), e1(t1(e1(t1(r(i[2][1], i[3][2]), r(-i[2][2], i[3][1])), i[1][0]), t1(e1(t1(r(i[2][0], i[3][2]), r(-i[2][2], i[3][0])), -i[1][1]), e1(t1(r(i[2][0], i[3][1]), r(-i[2][1], i[3][0])), i[1][2]))), -i[0][3]))));
                                };
                            }
                            function u(t1, e1, r, n) {
                                return function(i) {
                                    return n(t1(t1(e1(t1(t1(e1(t1(e1(t1(r(i[3][3], i[4][4]), r(-i[3][4], i[4][3])), i[2][2]), t1(e1(t1(r(i[3][2], i[4][4]), r(-i[3][4], i[4][2])), -i[2][3]), e1(t1(r(i[3][2], i[4][3]), r(-i[3][3], i[4][2])), i[2][4]))), i[1][1]), e1(t1(e1(t1(r(i[3][3], i[4][4]), r(-i[3][4], i[4][3])), i[2][1]), t1(e1(t1(r(i[3][1], i[4][4]), r(-i[3][4], i[4][1])), -i[2][3]), e1(t1(r(i[3][1], i[4][3]), r(-i[3][3], i[4][1])), i[2][4]))), -i[1][2])), t1(e1(t1(e1(t1(r(i[3][2], i[4][4]), r(-i[3][4], i[4][2])), i[2][1]), t1(e1(t1(r(i[3][1], i[4][4]), r(-i[3][4], i[4][1])), -i[2][2]), e1(t1(r(i[3][1], i[4][2]), r(-i[3][2], i[4][1])), i[2][4]))), i[1][3]), e1(t1(e1(t1(r(i[3][2], i[4][3]), r(-i[3][3], i[4][2])), i[2][1]), t1(e1(t1(r(i[3][1], i[4][3]), r(-i[3][3], i[4][1])), -i[2][2]), e1(t1(r(i[3][1], i[4][2]), r(-i[3][2], i[4][1])), i[2][3]))), -i[1][4]))), i[0][0]), e1(t1(t1(e1(t1(e1(t1(r(i[3][3], i[4][4]), r(-i[3][4], i[4][3])), i[2][2]), t1(e1(t1(r(i[3][2], i[4][4]), r(-i[3][4], i[4][2])), -i[2][3]), e1(t1(r(i[3][2], i[4][3]), r(-i[3][3], i[4][2])), i[2][4]))), i[1][0]), e1(t1(e1(t1(r(i[3][3], i[4][4]), r(-i[3][4], i[4][3])), i[2][0]), t1(e1(t1(r(i[3][0], i[4][4]), r(-i[3][4], i[4][0])), -i[2][3]), e1(t1(r(i[3][0], i[4][3]), r(-i[3][3], i[4][0])), i[2][4]))), -i[1][2])), t1(e1(t1(e1(t1(r(i[3][2], i[4][4]), r(-i[3][4], i[4][2])), i[2][0]), t1(e1(t1(r(i[3][0], i[4][4]), r(-i[3][4], i[4][0])), -i[2][2]), e1(t1(r(i[3][0], i[4][2]), r(-i[3][2], i[4][0])), i[2][4]))), i[1][3]), e1(t1(e1(t1(r(i[3][2], i[4][3]), r(-i[3][3], i[4][2])), i[2][0]), t1(e1(t1(r(i[3][0], i[4][3]), r(-i[3][3], i[4][0])), -i[2][2]), e1(t1(r(i[3][0], i[4][2]), r(-i[3][2], i[4][0])), i[2][3]))), -i[1][4]))), -i[0][1])), t1(e1(t1(t1(e1(t1(e1(t1(r(i[3][3], i[4][4]), r(-i[3][4], i[4][3])), i[2][1]), t1(e1(t1(r(i[3][1], i[4][4]), r(-i[3][4], i[4][1])), -i[2][3]), e1(t1(r(i[3][1], i[4][3]), r(-i[3][3], i[4][1])), i[2][4]))), i[1][0]), e1(t1(e1(t1(r(i[3][3], i[4][4]), r(-i[3][4], i[4][3])), i[2][0]), t1(e1(t1(r(i[3][0], i[4][4]), r(-i[3][4], i[4][0])), -i[2][3]), e1(t1(r(i[3][0], i[4][3]), r(-i[3][3], i[4][0])), i[2][4]))), -i[1][1])), t1(e1(t1(e1(t1(r(i[3][1], i[4][4]), r(-i[3][4], i[4][1])), i[2][0]), t1(e1(t1(r(i[3][0], i[4][4]), r(-i[3][4], i[4][0])), -i[2][1]), e1(t1(r(i[3][0], i[4][1]), r(-i[3][1], i[4][0])), i[2][4]))), i[1][3]), e1(t1(e1(t1(r(i[3][1], i[4][3]), r(-i[3][3], i[4][1])), i[2][0]), t1(e1(t1(r(i[3][0], i[4][3]), r(-i[3][3], i[4][0])), -i[2][1]), e1(t1(r(i[3][0], i[4][1]), r(-i[3][1], i[4][0])), i[2][3]))), -i[1][4]))), i[0][2]), t1(e1(t1(t1(e1(t1(e1(t1(r(i[3][2], i[4][4]), r(-i[3][4], i[4][2])), i[2][1]), t1(e1(t1(r(i[3][1], i[4][4]), r(-i[3][4], i[4][1])), -i[2][2]), e1(t1(r(i[3][1], i[4][2]), r(-i[3][2], i[4][1])), i[2][4]))), i[1][0]), e1(t1(e1(t1(r(i[3][2], i[4][4]), r(-i[3][4], i[4][2])), i[2][0]), t1(e1(t1(r(i[3][0], i[4][4]), r(-i[3][4], i[4][0])), -i[2][2]), e1(t1(r(i[3][0], i[4][2]), r(-i[3][2], i[4][0])), i[2][4]))), -i[1][1])), t1(e1(t1(e1(t1(r(i[3][1], i[4][4]), r(-i[3][4], i[4][1])), i[2][0]), t1(e1(t1(r(i[3][0], i[4][4]), r(-i[3][4], i[4][0])), -i[2][1]), e1(t1(r(i[3][0], i[4][1]), r(-i[3][1], i[4][0])), i[2][4]))), i[1][2]), e1(t1(e1(t1(r(i[3][1], i[4][2]), r(-i[3][2], i[4][1])), i[2][0]), t1(e1(t1(r(i[3][0], i[4][2]), r(-i[3][2], i[4][0])), -i[2][1]), e1(t1(r(i[3][0], i[4][1]), r(-i[3][1], i[4][0])), i[2][2]))), -i[1][4]))), -i[0][3]), e1(t1(t1(e1(t1(e1(t1(r(i[3][2], i[4][3]), r(-i[3][3], i[4][2])), i[2][1]), t1(e1(t1(r(i[3][1], i[4][3]), r(-i[3][3], i[4][1])), -i[2][2]), e1(t1(r(i[3][1], i[4][2]), r(-i[3][2], i[4][1])), i[2][3]))), i[1][0]), e1(t1(e1(t1(r(i[3][2], i[4][3]), r(-i[3][3], i[4][2])), i[2][0]), t1(e1(t1(r(i[3][0], i[4][3]), r(-i[3][3], i[4][0])), -i[2][2]), e1(t1(r(i[3][0], i[4][2]), r(-i[3][2], i[4][0])), i[2][3]))), -i[1][1])), t1(e1(t1(e1(t1(r(i[3][1], i[4][3]), r(-i[3][3], i[4][1])), i[2][0]), t1(e1(t1(r(i[3][0], i[4][3]), r(-i[3][3], i[4][0])), -i[2][1]), e1(t1(r(i[3][0], i[4][1]), r(-i[3][1], i[4][0])), i[2][3]))), i[1][2]), e1(t1(e1(t1(r(i[3][1], i[4][2]), r(-i[3][2], i[4][1])), i[2][0]), t1(e1(t1(r(i[3][0], i[4][2]), r(-i[3][2], i[4][0])), -i[2][1]), e1(t1(r(i[3][0], i[4][1]), r(-i[3][1], i[4][0])), i[2][2]))), -i[1][3]))), i[0][4])))));
                                };
                            }
                            function h(t1) {
                                return (2 === t1 ? s : 3 === t1 ? l : 4 === t1 ? c : 5 === t1 ? u : void 0)(i, a, n, o);
                            }
                            var f = [
                                function() {
                                    return [
                                        0
                                    ];
                                },
                                function(t1) {
                                    return [
                                        t1[0][0]
                                    ];
                                }
                            ];
                            function p(t1, e1, r, n, i, a, o, s) {
                                return function(l) {
                                    switch(l.length){
                                        case 0:
                                            return t1(l);
                                        case 1:
                                            return e1(l);
                                        case 2:
                                            return r(l);
                                        case 3:
                                            return n(l);
                                        case 4:
                                            return i(l);
                                        case 5:
                                            return a(l);
                                    }
                                    var c = o[l.length];
                                    return c || (c = o[l.length] = s(l.length)), c(l);
                                };
                            }
                            !function() {
                                for(; f.length < 6;)f.push(h(f.length));
                                t1.exports = p.apply(void 0, f.concat([
                                    f,
                                    h
                                ]));
                                for(var e1 = 0; e1 < f.length; ++e1)t1.exports[e1] = f[e1];
                            }();
                        },
                        1944: function(t1, e1, r) {
                            "use strict";
                            var n = r(5250), i = r(8210);
                            t1.exports = function(t1, e1) {
                                for(var r = n(t1[0], e1[0]), a = 1; a < t1.length; ++a)r = i(r, n(t1[a], e1[a]));
                                return r;
                            };
                        },
                        2646: function(t1, e1, r) {
                            "use strict";
                            var n = r(5250), i = r(8210), a = r(8545), o = r(3012);
                            function s(t1) {
                                return (3 === t1 ? l : 4 === t1 ? c : 5 === t1 ? u : h)(i, a, n, o);
                            }
                            function l(t1, e1, r, n) {
                                return function(i, a, o) {
                                    var s = r(i[0], i[0]), l = n(s, a[0]), c = n(s, o[0]), u = r(a[0], a[0]), h = n(u, i[0]), f = n(u, o[0]), p = r(o[0], o[0]), d = n(p, i[0]), m = n(p, a[0]), g = t1(e1(m, f), e1(h, l)), y = e1(d, c), v = e1(g, y);
                                    return v[v.length - 1];
                                };
                            }
                            function c(t1, e1, r, n) {
                                return function(i, a, o, s) {
                                    var l = t1(r(i[0], i[0]), r(i[1], i[1])), c = n(l, a[0]), u = n(l, o[0]), h = n(l, s[0]), f = t1(r(a[0], a[0]), r(a[1], a[1])), p = n(f, i[0]), d = n(f, o[0]), m = n(f, s[0]), g = t1(r(o[0], o[0]), r(o[1], o[1])), y = n(g, i[0]), v = n(g, a[0]), x = n(g, s[0]), _ = t1(r(s[0], s[0]), r(s[1], s[1])), b = n(_, i[0]), w = n(_, a[0]), T = n(_, o[0]), k = t1(t1(n(e1(T, x), a[1]), t1(n(e1(w, m), -o[1]), n(e1(v, d), s[1]))), t1(n(e1(w, m), i[1]), t1(n(e1(b, h), -a[1]), n(e1(p, c), s[1])))), A = t1(t1(n(e1(T, x), i[1]), t1(n(e1(b, h), -o[1]), n(e1(y, u), s[1]))), t1(n(e1(v, d), i[1]), t1(n(e1(y, u), -a[1]), n(e1(p, c), o[1])))), M = e1(k, A);
                                    return M[M.length - 1];
                                };
                            }
                            function u(t1, e1, r, n) {
                                return function(i, a, o, s, l) {
                                    var c = t1(r(i[0], i[0]), t1(r(i[1], i[1]), r(i[2], i[2]))), u = n(c, a[0]), h = n(c, o[0]), f = n(c, s[0]), p = n(c, l[0]), d = t1(r(a[0], a[0]), t1(r(a[1], a[1]), r(a[2], a[2]))), m = n(d, i[0]), g = n(d, o[0]), y = n(d, s[0]), v = n(d, l[0]), x = t1(r(o[0], o[0]), t1(r(o[1], o[1]), r(o[2], o[2]))), _ = n(x, i[0]), b = n(x, a[0]), w = n(x, s[0]), T = n(x, l[0]), k = t1(r(s[0], s[0]), t1(r(s[1], s[1]), r(s[2], s[2]))), A = n(k, i[0]), M = n(k, a[0]), S = n(k, o[0]), E = n(k, l[0]), C = t1(r(l[0], l[0]), t1(r(l[1], l[1]), r(l[2], l[2]))), L = n(C, i[0]), I = n(C, a[0]), P = n(C, o[0]), z = n(C, s[0]), O = t1(t1(t1(n(t1(n(e1(z, E), o[1]), t1(n(e1(P, T), -s[1]), n(e1(S, w), l[1]))), a[2]), t1(n(t1(n(e1(z, E), a[1]), t1(n(e1(I, v), -s[1]), n(e1(M, y), l[1]))), -o[2]), n(t1(n(e1(P, T), a[1]), t1(n(e1(I, v), -o[1]), n(e1(b, g), l[1]))), s[2]))), t1(n(t1(n(e1(S, w), a[1]), t1(n(e1(M, y), -o[1]), n(e1(b, g), s[1]))), -l[2]), t1(n(t1(n(e1(z, E), a[1]), t1(n(e1(I, v), -s[1]), n(e1(M, y), l[1]))), i[2]), n(t1(n(e1(z, E), i[1]), t1(n(e1(L, p), -s[1]), n(e1(A, f), l[1]))), -a[2])))), t1(t1(n(t1(n(e1(I, v), i[1]), t1(n(e1(L, p), -a[1]), n(e1(m, u), l[1]))), s[2]), t1(n(t1(n(e1(M, y), i[1]), t1(n(e1(A, f), -a[1]), n(e1(m, u), s[1]))), -l[2]), n(t1(n(e1(S, w), a[1]), t1(n(e1(M, y), -o[1]), n(e1(b, g), s[1]))), i[2]))), t1(n(t1(n(e1(S, w), i[1]), t1(n(e1(A, f), -o[1]), n(e1(_, h), s[1]))), -a[2]), t1(n(t1(n(e1(M, y), i[1]), t1(n(e1(A, f), -a[1]), n(e1(m, u), s[1]))), o[2]), n(t1(n(e1(b, g), i[1]), t1(n(e1(_, h), -a[1]), n(e1(m, u), o[1]))), -s[2]))))), D = t1(t1(t1(n(t1(n(e1(z, E), o[1]), t1(n(e1(P, T), -s[1]), n(e1(S, w), l[1]))), i[2]), n(t1(n(e1(z, E), i[1]), t1(n(e1(L, p), -s[1]), n(e1(A, f), l[1]))), -o[2])), t1(n(t1(n(e1(P, T), i[1]), t1(n(e1(L, p), -o[1]), n(e1(_, h), l[1]))), s[2]), n(t1(n(e1(S, w), i[1]), t1(n(e1(A, f), -o[1]), n(e1(_, h), s[1]))), -l[2]))), t1(t1(n(t1(n(e1(P, T), a[1]), t1(n(e1(I, v), -o[1]), n(e1(b, g), l[1]))), i[2]), n(t1(n(e1(P, T), i[1]), t1(n(e1(L, p), -o[1]), n(e1(_, h), l[1]))), -a[2])), t1(n(t1(n(e1(I, v), i[1]), t1(n(e1(L, p), -a[1]), n(e1(m, u), l[1]))), o[2]), n(t1(n(e1(b, g), i[1]), t1(n(e1(_, h), -a[1]), n(e1(m, u), o[1]))), -l[2])))), R = e1(O, D);
                                    return R[R.length - 1];
                                };
                            }
                            function h(t1, e1, r, n) {
                                return function(i, a, o, s, l, c) {
                                    var u = t1(t1(r(i[0], i[0]), r(i[1], i[1])), t1(r(i[2], i[2]), r(i[3], i[3]))), h = n(u, a[0]), f = n(u, o[0]), p = n(u, s[0]), d = n(u, l[0]), m = n(u, c[0]), g = t1(t1(r(a[0], a[0]), r(a[1], a[1])), t1(r(a[2], a[2]), r(a[3], a[3]))), y = n(g, i[0]), v = n(g, o[0]), x = n(g, s[0]), _ = n(g, l[0]), b = n(g, c[0]), w = t1(t1(r(o[0], o[0]), r(o[1], o[1])), t1(r(o[2], o[2]), r(o[3], o[3]))), T = n(w, i[0]), k = n(w, a[0]), A = n(w, s[0]), M = n(w, l[0]), S = n(w, c[0]), E = t1(t1(r(s[0], s[0]), r(s[1], s[1])), t1(r(s[2], s[2]), r(s[3], s[3]))), C = n(E, i[0]), L = n(E, a[0]), I = n(E, o[0]), P = n(E, l[0]), z = n(E, c[0]), O = t1(t1(r(l[0], l[0]), r(l[1], l[1])), t1(r(l[2], l[2]), r(l[3], l[3]))), D = n(O, i[0]), R = n(O, a[0]), F = n(O, o[0]), B = n(O, s[0]), N = n(O, c[0]), j = t1(t1(r(c[0], c[0]), r(c[1], c[1])), t1(r(c[2], c[2]), r(c[3], c[3]))), U = n(j, i[0]), V = n(j, a[0]), q = n(j, o[0]), H = n(j, s[0]), G = n(j, l[0]), Z = t1(t1(t1(n(t1(t1(n(t1(n(e1(G, N), s[1]), t1(n(e1(H, z), -l[1]), n(e1(B, P), c[1]))), o[2]), n(t1(n(e1(G, N), o[1]), t1(n(e1(q, S), -l[1]), n(e1(F, M), c[1]))), -s[2])), t1(n(t1(n(e1(H, z), o[1]), t1(n(e1(q, S), -s[1]), n(e1(I, A), c[1]))), l[2]), n(t1(n(e1(B, P), o[1]), t1(n(e1(F, M), -s[1]), n(e1(I, A), l[1]))), -c[2]))), a[3]), t1(n(t1(t1(n(t1(n(e1(G, N), s[1]), t1(n(e1(H, z), -l[1]), n(e1(B, P), c[1]))), a[2]), n(t1(n(e1(G, N), a[1]), t1(n(e1(V, b), -l[1]), n(e1(R, _), c[1]))), -s[2])), t1(n(t1(n(e1(H, z), a[1]), t1(n(e1(V, b), -s[1]), n(e1(L, x), c[1]))), l[2]), n(t1(n(e1(B, P), a[1]), t1(n(e1(R, _), -s[1]), n(e1(L, x), l[1]))), -c[2]))), -o[3]), n(t1(t1(n(t1(n(e1(G, N), o[1]), t1(n(e1(q, S), -l[1]), n(e1(F, M), c[1]))), a[2]), n(t1(n(e1(G, N), a[1]), t1(n(e1(V, b), -l[1]), n(e1(R, _), c[1]))), -o[2])), t1(n(t1(n(e1(q, S), a[1]), t1(n(e1(V, b), -o[1]), n(e1(k, v), c[1]))), l[2]), n(t1(n(e1(F, M), a[1]), t1(n(e1(R, _), -o[1]), n(e1(k, v), l[1]))), -c[2]))), s[3]))), t1(t1(n(t1(t1(n(t1(n(e1(H, z), o[1]), t1(n(e1(q, S), -s[1]), n(e1(I, A), c[1]))), a[2]), n(t1(n(e1(H, z), a[1]), t1(n(e1(V, b), -s[1]), n(e1(L, x), c[1]))), -o[2])), t1(n(t1(n(e1(q, S), a[1]), t1(n(e1(V, b), -o[1]), n(e1(k, v), c[1]))), s[2]), n(t1(n(e1(I, A), a[1]), t1(n(e1(L, x), -o[1]), n(e1(k, v), s[1]))), -c[2]))), -l[3]), n(t1(t1(n(t1(n(e1(B, P), o[1]), t1(n(e1(F, M), -s[1]), n(e1(I, A), l[1]))), a[2]), n(t1(n(e1(B, P), a[1]), t1(n(e1(R, _), -s[1]), n(e1(L, x), l[1]))), -o[2])), t1(n(t1(n(e1(F, M), a[1]), t1(n(e1(R, _), -o[1]), n(e1(k, v), l[1]))), s[2]), n(t1(n(e1(I, A), a[1]), t1(n(e1(L, x), -o[1]), n(e1(k, v), s[1]))), -l[2]))), c[3])), t1(n(t1(t1(n(t1(n(e1(G, N), s[1]), t1(n(e1(H, z), -l[1]), n(e1(B, P), c[1]))), a[2]), n(t1(n(e1(G, N), a[1]), t1(n(e1(V, b), -l[1]), n(e1(R, _), c[1]))), -s[2])), t1(n(t1(n(e1(H, z), a[1]), t1(n(e1(V, b), -s[1]), n(e1(L, x), c[1]))), l[2]), n(t1(n(e1(B, P), a[1]), t1(n(e1(R, _), -s[1]), n(e1(L, x), l[1]))), -c[2]))), i[3]), n(t1(t1(n(t1(n(e1(G, N), s[1]), t1(n(e1(H, z), -l[1]), n(e1(B, P), c[1]))), i[2]), n(t1(n(e1(G, N), i[1]), t1(n(e1(U, m), -l[1]), n(e1(D, d), c[1]))), -s[2])), t1(n(t1(n(e1(H, z), i[1]), t1(n(e1(U, m), -s[1]), n(e1(C, p), c[1]))), l[2]), n(t1(n(e1(B, P), i[1]), t1(n(e1(D, d), -s[1]), n(e1(C, p), l[1]))), -c[2]))), -a[3])))), t1(t1(t1(n(t1(t1(n(t1(n(e1(G, N), a[1]), t1(n(e1(V, b), -l[1]), n(e1(R, _), c[1]))), i[2]), n(t1(n(e1(G, N), i[1]), t1(n(e1(U, m), -l[1]), n(e1(D, d), c[1]))), -a[2])), t1(n(t1(n(e1(V, b), i[1]), t1(n(e1(U, m), -a[1]), n(e1(y, h), c[1]))), l[2]), n(t1(n(e1(R, _), i[1]), t1(n(e1(D, d), -a[1]), n(e1(y, h), l[1]))), -c[2]))), s[3]), n(t1(t1(n(t1(n(e1(H, z), a[1]), t1(n(e1(V, b), -s[1]), n(e1(L, x), c[1]))), i[2]), n(t1(n(e1(H, z), i[1]), t1(n(e1(U, m), -s[1]), n(e1(C, p), c[1]))), -a[2])), t1(n(t1(n(e1(V, b), i[1]), t1(n(e1(U, m), -a[1]), n(e1(y, h), c[1]))), s[2]), n(t1(n(e1(L, x), i[1]), t1(n(e1(C, p), -a[1]), n(e1(y, h), s[1]))), -c[2]))), -l[3])), t1(n(t1(t1(n(t1(n(e1(B, P), a[1]), t1(n(e1(R, _), -s[1]), n(e1(L, x), l[1]))), i[2]), n(t1(n(e1(B, P), i[1]), t1(n(e1(D, d), -s[1]), n(e1(C, p), l[1]))), -a[2])), t1(n(t1(n(e1(R, _), i[1]), t1(n(e1(D, d), -a[1]), n(e1(y, h), l[1]))), s[2]), n(t1(n(e1(L, x), i[1]), t1(n(e1(C, p), -a[1]), n(e1(y, h), s[1]))), -l[2]))), c[3]), n(t1(t1(n(t1(n(e1(H, z), o[1]), t1(n(e1(q, S), -s[1]), n(e1(I, A), c[1]))), a[2]), n(t1(n(e1(H, z), a[1]), t1(n(e1(V, b), -s[1]), n(e1(L, x), c[1]))), -o[2])), t1(n(t1(n(e1(q, S), a[1]), t1(n(e1(V, b), -o[1]), n(e1(k, v), c[1]))), s[2]), n(t1(n(e1(I, A), a[1]), t1(n(e1(L, x), -o[1]), n(e1(k, v), s[1]))), -c[2]))), i[3]))), t1(t1(n(t1(t1(n(t1(n(e1(H, z), o[1]), t1(n(e1(q, S), -s[1]), n(e1(I, A), c[1]))), i[2]), n(t1(n(e1(H, z), i[1]), t1(n(e1(U, m), -s[1]), n(e1(C, p), c[1]))), -o[2])), t1(n(t1(n(e1(q, S), i[1]), t1(n(e1(U, m), -o[1]), n(e1(T, f), c[1]))), s[2]), n(t1(n(e1(I, A), i[1]), t1(n(e1(C, p), -o[1]), n(e1(T, f), s[1]))), -c[2]))), -a[3]), n(t1(t1(n(t1(n(e1(H, z), a[1]), t1(n(e1(V, b), -s[1]), n(e1(L, x), c[1]))), i[2]), n(t1(n(e1(H, z), i[1]), t1(n(e1(U, m), -s[1]), n(e1(C, p), c[1]))), -a[2])), t1(n(t1(n(e1(V, b), i[1]), t1(n(e1(U, m), -a[1]), n(e1(y, h), c[1]))), s[2]), n(t1(n(e1(L, x), i[1]), t1(n(e1(C, p), -a[1]), n(e1(y, h), s[1]))), -c[2]))), o[3])), t1(n(t1(t1(n(t1(n(e1(q, S), a[1]), t1(n(e1(V, b), -o[1]), n(e1(k, v), c[1]))), i[2]), n(t1(n(e1(q, S), i[1]), t1(n(e1(U, m), -o[1]), n(e1(T, f), c[1]))), -a[2])), t1(n(t1(n(e1(V, b), i[1]), t1(n(e1(U, m), -a[1]), n(e1(y, h), c[1]))), o[2]), n(t1(n(e1(k, v), i[1]), t1(n(e1(T, f), -a[1]), n(e1(y, h), o[1]))), -c[2]))), -s[3]), n(t1(t1(n(t1(n(e1(I, A), a[1]), t1(n(e1(L, x), -o[1]), n(e1(k, v), s[1]))), i[2]), n(t1(n(e1(I, A), i[1]), t1(n(e1(C, p), -o[1]), n(e1(T, f), s[1]))), -a[2])), t1(n(t1(n(e1(L, x), i[1]), t1(n(e1(C, p), -a[1]), n(e1(y, h), s[1]))), o[2]), n(t1(n(e1(k, v), i[1]), t1(n(e1(T, f), -a[1]), n(e1(y, h), o[1]))), -s[2]))), c[3]))))), W = t1(t1(t1(n(t1(t1(n(t1(n(e1(G, N), s[1]), t1(n(e1(H, z), -l[1]), n(e1(B, P), c[1]))), o[2]), n(t1(n(e1(G, N), o[1]), t1(n(e1(q, S), -l[1]), n(e1(F, M), c[1]))), -s[2])), t1(n(t1(n(e1(H, z), o[1]), t1(n(e1(q, S), -s[1]), n(e1(I, A), c[1]))), l[2]), n(t1(n(e1(B, P), o[1]), t1(n(e1(F, M), -s[1]), n(e1(I, A), l[1]))), -c[2]))), i[3]), t1(n(t1(t1(n(t1(n(e1(G, N), s[1]), t1(n(e1(H, z), -l[1]), n(e1(B, P), c[1]))), i[2]), n(t1(n(e1(G, N), i[1]), t1(n(e1(U, m), -l[1]), n(e1(D, d), c[1]))), -s[2])), t1(n(t1(n(e1(H, z), i[1]), t1(n(e1(U, m), -s[1]), n(e1(C, p), c[1]))), l[2]), n(t1(n(e1(B, P), i[1]), t1(n(e1(D, d), -s[1]), n(e1(C, p), l[1]))), -c[2]))), -o[3]), n(t1(t1(n(t1(n(e1(G, N), o[1]), t1(n(e1(q, S), -l[1]), n(e1(F, M), c[1]))), i[2]), n(t1(n(e1(G, N), i[1]), t1(n(e1(U, m), -l[1]), n(e1(D, d), c[1]))), -o[2])), t1(n(t1(n(e1(q, S), i[1]), t1(n(e1(U, m), -o[1]), n(e1(T, f), c[1]))), l[2]), n(t1(n(e1(F, M), i[1]), t1(n(e1(D, d), -o[1]), n(e1(T, f), l[1]))), -c[2]))), s[3]))), t1(t1(n(t1(t1(n(t1(n(e1(H, z), o[1]), t1(n(e1(q, S), -s[1]), n(e1(I, A), c[1]))), i[2]), n(t1(n(e1(H, z), i[1]), t1(n(e1(U, m), -s[1]), n(e1(C, p), c[1]))), -o[2])), t1(n(t1(n(e1(q, S), i[1]), t1(n(e1(U, m), -o[1]), n(e1(T, f), c[1]))), s[2]), n(t1(n(e1(I, A), i[1]), t1(n(e1(C, p), -o[1]), n(e1(T, f), s[1]))), -c[2]))), -l[3]), n(t1(t1(n(t1(n(e1(B, P), o[1]), t1(n(e1(F, M), -s[1]), n(e1(I, A), l[1]))), i[2]), n(t1(n(e1(B, P), i[1]), t1(n(e1(D, d), -s[1]), n(e1(C, p), l[1]))), -o[2])), t1(n(t1(n(e1(F, M), i[1]), t1(n(e1(D, d), -o[1]), n(e1(T, f), l[1]))), s[2]), n(t1(n(e1(I, A), i[1]), t1(n(e1(C, p), -o[1]), n(e1(T, f), s[1]))), -l[2]))), c[3])), t1(n(t1(t1(n(t1(n(e1(G, N), o[1]), t1(n(e1(q, S), -l[1]), n(e1(F, M), c[1]))), a[2]), n(t1(n(e1(G, N), a[1]), t1(n(e1(V, b), -l[1]), n(e1(R, _), c[1]))), -o[2])), t1(n(t1(n(e1(q, S), a[1]), t1(n(e1(V, b), -o[1]), n(e1(k, v), c[1]))), l[2]), n(t1(n(e1(F, M), a[1]), t1(n(e1(R, _), -o[1]), n(e1(k, v), l[1]))), -c[2]))), i[3]), n(t1(t1(n(t1(n(e1(G, N), o[1]), t1(n(e1(q, S), -l[1]), n(e1(F, M), c[1]))), i[2]), n(t1(n(e1(G, N), i[1]), t1(n(e1(U, m), -l[1]), n(e1(D, d), c[1]))), -o[2])), t1(n(t1(n(e1(q, S), i[1]), t1(n(e1(U, m), -o[1]), n(e1(T, f), c[1]))), l[2]), n(t1(n(e1(F, M), i[1]), t1(n(e1(D, d), -o[1]), n(e1(T, f), l[1]))), -c[2]))), -a[3])))), t1(t1(t1(n(t1(t1(n(t1(n(e1(G, N), a[1]), t1(n(e1(V, b), -l[1]), n(e1(R, _), c[1]))), i[2]), n(t1(n(e1(G, N), i[1]), t1(n(e1(U, m), -l[1]), n(e1(D, d), c[1]))), -a[2])), t1(n(t1(n(e1(V, b), i[1]), t1(n(e1(U, m), -a[1]), n(e1(y, h), c[1]))), l[2]), n(t1(n(e1(R, _), i[1]), t1(n(e1(D, d), -a[1]), n(e1(y, h), l[1]))), -c[2]))), o[3]), n(t1(t1(n(t1(n(e1(q, S), a[1]), t1(n(e1(V, b), -o[1]), n(e1(k, v), c[1]))), i[2]), n(t1(n(e1(q, S), i[1]), t1(n(e1(U, m), -o[1]), n(e1(T, f), c[1]))), -a[2])), t1(n(t1(n(e1(V, b), i[1]), t1(n(e1(U, m), -a[1]), n(e1(y, h), c[1]))), o[2]), n(t1(n(e1(k, v), i[1]), t1(n(e1(T, f), -a[1]), n(e1(y, h), o[1]))), -c[2]))), -l[3])), t1(n(t1(t1(n(t1(n(e1(F, M), a[1]), t1(n(e1(R, _), -o[1]), n(e1(k, v), l[1]))), i[2]), n(t1(n(e1(F, M), i[1]), t1(n(e1(D, d), -o[1]), n(e1(T, f), l[1]))), -a[2])), t1(n(t1(n(e1(R, _), i[1]), t1(n(e1(D, d), -a[1]), n(e1(y, h), l[1]))), o[2]), n(t1(n(e1(k, v), i[1]), t1(n(e1(T, f), -a[1]), n(e1(y, h), o[1]))), -l[2]))), c[3]), n(t1(t1(n(t1(n(e1(B, P), o[1]), t1(n(e1(F, M), -s[1]), n(e1(I, A), l[1]))), a[2]), n(t1(n(e1(B, P), a[1]), t1(n(e1(R, _), -s[1]), n(e1(L, x), l[1]))), -o[2])), t1(n(t1(n(e1(F, M), a[1]), t1(n(e1(R, _), -o[1]), n(e1(k, v), l[1]))), s[2]), n(t1(n(e1(I, A), a[1]), t1(n(e1(L, x), -o[1]), n(e1(k, v), s[1]))), -l[2]))), i[3]))), t1(t1(n(t1(t1(n(t1(n(e1(B, P), o[1]), t1(n(e1(F, M), -s[1]), n(e1(I, A), l[1]))), i[2]), n(t1(n(e1(B, P), i[1]), t1(n(e1(D, d), -s[1]), n(e1(C, p), l[1]))), -o[2])), t1(n(t1(n(e1(F, M), i[1]), t1(n(e1(D, d), -o[1]), n(e1(T, f), l[1]))), s[2]), n(t1(n(e1(I, A), i[1]), t1(n(e1(C, p), -o[1]), n(e1(T, f), s[1]))), -l[2]))), -a[3]), n(t1(t1(n(t1(n(e1(B, P), a[1]), t1(n(e1(R, _), -s[1]), n(e1(L, x), l[1]))), i[2]), n(t1(n(e1(B, P), i[1]), t1(n(e1(D, d), -s[1]), n(e1(C, p), l[1]))), -a[2])), t1(n(t1(n(e1(R, _), i[1]), t1(n(e1(D, d), -a[1]), n(e1(y, h), l[1]))), s[2]), n(t1(n(e1(L, x), i[1]), t1(n(e1(C, p), -a[1]), n(e1(y, h), s[1]))), -l[2]))), o[3])), t1(n(t1(t1(n(t1(n(e1(F, M), a[1]), t1(n(e1(R, _), -o[1]), n(e1(k, v), l[1]))), i[2]), n(t1(n(e1(F, M), i[1]), t1(n(e1(D, d), -o[1]), n(e1(T, f), l[1]))), -a[2])), t1(n(t1(n(e1(R, _), i[1]), t1(n(e1(D, d), -a[1]), n(e1(y, h), l[1]))), o[2]), n(t1(n(e1(k, v), i[1]), t1(n(e1(T, f), -a[1]), n(e1(y, h), o[1]))), -l[2]))), -s[3]), n(t1(t1(n(t1(n(e1(I, A), a[1]), t1(n(e1(L, x), -o[1]), n(e1(k, v), s[1]))), i[2]), n(t1(n(e1(I, A), i[1]), t1(n(e1(C, p), -o[1]), n(e1(T, f), s[1]))), -a[2])), t1(n(t1(n(e1(L, x), i[1]), t1(n(e1(C, p), -a[1]), n(e1(y, h), s[1]))), o[2]), n(t1(n(e1(k, v), i[1]), t1(n(e1(T, f), -a[1]), n(e1(y, h), o[1]))), -s[2]))), l[3]))))), Y = e1(Z, W);
                                    return Y[Y.length - 1];
                                };
                            }
                            var f = [
                                function() {
                                    return 0;
                                },
                                function() {
                                    return 0;
                                },
                                function() {
                                    return 0;
                                }
                            ];
                            function p(t1) {
                                var e1 = f[t1.length];
                                return e1 || (e1 = f[t1.length] = s(t1.length)), e1.apply(void 0, t1);
                            }
                            function d(t1, e1, r, n, i, a, o, s) {
                                return function(e1, r, l, c, u, h) {
                                    switch(arguments.length){
                                        case 0:
                                        case 1:
                                            return 0;
                                        case 2:
                                            return n(e1, r);
                                        case 3:
                                            return i(e1, r, l);
                                        case 4:
                                            return a(e1, r, l, c);
                                        case 5:
                                            return o(e1, r, l, c, u);
                                        case 6:
                                            return s(e1, r, l, c, u, h);
                                    }
                                    for(var f = new Array(arguments.length), p = 0; p < arguments.length; ++p)f[p] = arguments[p];
                                    return t1(f);
                                };
                            }
                            !function() {
                                for(; f.length <= 6;)f.push(s(f.length));
                                t1.exports = d.apply(void 0, [
                                    p
                                ].concat(f));
                                for(var e1 = 0; e1 <= 6; ++e1)t1.exports[e1] = f[e1];
                            }();
                        },
                        727: function(t1, e1, r) {
                            "use strict";
                            var n = r(2962);
                            function i(t1) {
                                return (2 === t1 ? a : 3 === t1 ? o : 4 === t1 ? s : 5 === t1 ? l : c)(t1 < 6 ? n[t1] : n);
                            }
                            function a(t1) {
                                return function(e1, r) {
                                    return [
                                        t1([
                                            [
                                                +r[0],
                                                +e1[0][1]
                                            ],
                                            [
                                                +r[1],
                                                +e1[1][1]
                                            ]
                                        ]),
                                        t1([
                                            [
                                                +e1[0][0],
                                                +r[0]
                                            ],
                                            [
                                                +e1[1][0],
                                                +r[1]
                                            ]
                                        ]),
                                        t1(e1)
                                    ];
                                };
                            }
                            function o(t1) {
                                return function(e1, r) {
                                    return [
                                        t1([
                                            [
                                                +r[0],
                                                +e1[0][1],
                                                +e1[0][2]
                                            ],
                                            [
                                                +r[1],
                                                +e1[1][1],
                                                +e1[1][2]
                                            ],
                                            [
                                                +r[2],
                                                +e1[2][1],
                                                +e1[2][2]
                                            ]
                                        ]),
                                        t1([
                                            [
                                                +e1[0][0],
                                                +r[0],
                                                +e1[0][2]
                                            ],
                                            [
                                                +e1[1][0],
                                                +r[1],
                                                +e1[1][2]
                                            ],
                                            [
                                                +e1[2][0],
                                                +r[2],
                                                +e1[2][2]
                                            ]
                                        ]),
                                        t1([
                                            [
                                                +e1[0][0],
                                                +e1[0][1],
                                                +r[0]
                                            ],
                                            [
                                                +e1[1][0],
                                                +e1[1][1],
                                                +r[1]
                                            ],
                                            [
                                                +e1[2][0],
                                                +e1[2][1],
                                                +r[2]
                                            ]
                                        ]),
                                        t1(e1)
                                    ];
                                };
                            }
                            function s(t1) {
                                return function(e1, r) {
                                    return [
                                        t1([
                                            [
                                                +r[0],
                                                +e1[0][1],
                                                +e1[0][2],
                                                +e1[0][3]
                                            ],
                                            [
                                                +r[1],
                                                +e1[1][1],
                                                +e1[1][2],
                                                +e1[1][3]
                                            ],
                                            [
                                                +r[2],
                                                +e1[2][1],
                                                +e1[2][2],
                                                +e1[2][3]
                                            ],
                                            [
                                                +r[3],
                                                +e1[3][1],
                                                +e1[3][2],
                                                +e1[3][3]
                                            ]
                                        ]),
                                        t1([
                                            [
                                                +e1[0][0],
                                                +r[0],
                                                +e1[0][2],
                                                +e1[0][3]
                                            ],
                                            [
                                                +e1[1][0],
                                                +r[1],
                                                +e1[1][2],
                                                +e1[1][3]
                                            ],
                                            [
                                                +e1[2][0],
                                                +r[2],
                                                +e1[2][2],
                                                +e1[2][3]
                                            ],
                                            [
                                                +e1[3][0],
                                                +r[3],
                                                +e1[3][2],
                                                +e1[3][3]
                                            ]
                                        ]),
                                        t1([
                                            [
                                                +e1[0][0],
                                                +e1[0][1],
                                                +r[0],
                                                +e1[0][3]
                                            ],
                                            [
                                                +e1[1][0],
                                                +e1[1][1],
                                                +r[1],
                                                +e1[1][3]
                                            ],
                                            [
                                                +e1[2][0],
                                                +e1[2][1],
                                                +r[2],
                                                +e1[2][3]
                                            ],
                                            [
                                                +e1[3][0],
                                                +e1[3][1],
                                                +r[3],
                                                +e1[3][3]
                                            ]
                                        ]),
                                        t1([
                                            [
                                                +e1[0][0],
                                                +e1[0][1],
                                                +e1[0][2],
                                                +r[0]
                                            ],
                                            [
                                                +e1[1][0],
                                                +e1[1][1],
                                                +e1[1][2],
                                                +r[1]
                                            ],
                                            [
                                                +e1[2][0],
                                                +e1[2][1],
                                                +e1[2][2],
                                                +r[2]
                                            ],
                                            [
                                                +e1[3][0],
                                                +e1[3][1],
                                                +e1[3][2],
                                                +r[3]
                                            ]
                                        ]),
                                        t1(e1)
                                    ];
                                };
                            }
                            function l(t1) {
                                return function(e1, r) {
                                    return [
                                        t1([
                                            [
                                                +r[0],
                                                +e1[0][1],
                                                +e1[0][2],
                                                +e1[0][3],
                                                +e1[0][4]
                                            ],
                                            [
                                                +r[1],
                                                +e1[1][1],
                                                +e1[1][2],
                                                +e1[1][3],
                                                +e1[1][4]
                                            ],
                                            [
                                                +r[2],
                                                +e1[2][1],
                                                +e1[2][2],
                                                +e1[2][3],
                                                +e1[2][4]
                                            ],
                                            [
                                                +r[3],
                                                +e1[3][1],
                                                +e1[3][2],
                                                +e1[3][3],
                                                +e1[3][4]
                                            ],
                                            [
                                                +r[4],
                                                +e1[4][1],
                                                +e1[4][2],
                                                +e1[4][3],
                                                +e1[4][4]
                                            ]
                                        ]),
                                        t1([
                                            [
                                                +e1[0][0],
                                                +r[0],
                                                +e1[0][2],
                                                +e1[0][3],
                                                +e1[0][4]
                                            ],
                                            [
                                                +e1[1][0],
                                                +r[1],
                                                +e1[1][2],
                                                +e1[1][3],
                                                +e1[1][4]
                                            ],
                                            [
                                                +e1[2][0],
                                                +r[2],
                                                +e1[2][2],
                                                +e1[2][3],
                                                +e1[2][4]
                                            ],
                                            [
                                                +e1[3][0],
                                                +r[3],
                                                +e1[3][2],
                                                +e1[3][3],
                                                +e1[3][4]
                                            ],
                                            [
                                                +e1[4][0],
                                                +r[4],
                                                +e1[4][2],
                                                +e1[4][3],
                                                +e1[4][4]
                                            ]
                                        ]),
                                        t1([
                                            [
                                                +e1[0][0],
                                                +e1[0][1],
                                                +r[0],
                                                +e1[0][3],
                                                +e1[0][4]
                                            ],
                                            [
                                                +e1[1][0],
                                                +e1[1][1],
                                                +r[1],
                                                +e1[1][3],
                                                +e1[1][4]
                                            ],
                                            [
                                                +e1[2][0],
                                                +e1[2][1],
                                                +r[2],
                                                +e1[2][3],
                                                +e1[2][4]
                                            ],
                                            [
                                                +e1[3][0],
                                                +e1[3][1],
                                                +r[3],
                                                +e1[3][3],
                                                +e1[3][4]
                                            ],
                                            [
                                                +e1[4][0],
                                                +e1[4][1],
                                                +r[4],
                                                +e1[4][3],
                                                +e1[4][4]
                                            ]
                                        ]),
                                        t1([
                                            [
                                                +e1[0][0],
                                                +e1[0][1],
                                                +e1[0][2],
                                                +r[0],
                                                +e1[0][4]
                                            ],
                                            [
                                                +e1[1][0],
                                                +e1[1][1],
                                                +e1[1][2],
                                                +r[1],
                                                +e1[1][4]
                                            ],
                                            [
                                                +e1[2][0],
                                                +e1[2][1],
                                                +e1[2][2],
                                                +r[2],
                                                +e1[2][4]
                                            ],
                                            [
                                                +e1[3][0],
                                                +e1[3][1],
                                                +e1[3][2],
                                                +r[3],
                                                +e1[3][4]
                                            ],
                                            [
                                                +e1[4][0],
                                                +e1[4][1],
                                                +e1[4][2],
                                                +r[4],
                                                +e1[4][4]
                                            ]
                                        ]),
                                        t1([
                                            [
                                                +e1[0][0],
                                                +e1[0][1],
                                                +e1[0][2],
                                                +e1[0][3],
                                                +r[0]
                                            ],
                                            [
                                                +e1[1][0],
                                                +e1[1][1],
                                                +e1[1][2],
                                                +e1[1][3],
                                                +r[1]
                                            ],
                                            [
                                                +e1[2][0],
                                                +e1[2][1],
                                                +e1[2][2],
                                                +e1[2][3],
                                                +r[2]
                                            ],
                                            [
                                                +e1[3][0],
                                                +e1[3][1],
                                                +e1[3][2],
                                                +e1[3][3],
                                                +r[3]
                                            ],
                                            [
                                                +e1[4][0],
                                                +e1[4][1],
                                                +e1[4][2],
                                                +e1[4][3],
                                                +r[4]
                                            ]
                                        ]),
                                        t1(e1)
                                    ];
                                };
                            }
                            function c(t1) {
                                return function(e1, r) {
                                    return [
                                        t1([
                                            [
                                                +r[0],
                                                +e1[0][1],
                                                +e1[0][2],
                                                +e1[0][3],
                                                +e1[0][4],
                                                +e1[0][5]
                                            ],
                                            [
                                                +r[1],
                                                +e1[1][1],
                                                +e1[1][2],
                                                +e1[1][3],
                                                +e1[1][4],
                                                +e1[1][5]
                                            ],
                                            [
                                                +r[2],
                                                +e1[2][1],
                                                +e1[2][2],
                                                +e1[2][3],
                                                +e1[2][4],
                                                +e1[2][5]
                                            ],
                                            [
                                                +r[3],
                                                +e1[3][1],
                                                +e1[3][2],
                                                +e1[3][3],
                                                +e1[3][4],
                                                +e1[3][5]
                                            ],
                                            [
                                                +r[4],
                                                +e1[4][1],
                                                +e1[4][2],
                                                +e1[4][3],
                                                +e1[4][4],
                                                +e1[4][5]
                                            ],
                                            [
                                                +r[5],
                                                +e1[5][1],
                                                +e1[5][2],
                                                +e1[5][3],
                                                +e1[5][4],
                                                +e1[5][5]
                                            ]
                                        ]),
                                        t1([
                                            [
                                                +e1[0][0],
                                                +r[0],
                                                +e1[0][2],
                                                +e1[0][3],
                                                +e1[0][4],
                                                +e1[0][5]
                                            ],
                                            [
                                                +e1[1][0],
                                                +r[1],
                                                +e1[1][2],
                                                +e1[1][3],
                                                +e1[1][4],
                                                +e1[1][5]
                                            ],
                                            [
                                                +e1[2][0],
                                                +r[2],
                                                +e1[2][2],
                                                +e1[2][3],
                                                +e1[2][4],
                                                +e1[2][5]
                                            ],
                                            [
                                                +e1[3][0],
                                                +r[3],
                                                +e1[3][2],
                                                +e1[3][3],
                                                +e1[3][4],
                                                +e1[3][5]
                                            ],
                                            [
                                                +e1[4][0],
                                                +r[4],
                                                +e1[4][2],
                                                +e1[4][3],
                                                +e1[4][4],
                                                +e1[4][5]
                                            ],
                                            [
                                                +e1[5][0],
                                                +r[5],
                                                +e1[5][2],
                                                +e1[5][3],
                                                +e1[5][4],
                                                +e1[5][5]
                                            ]
                                        ]),
                                        t1([
                                            [
                                                +e1[0][0],
                                                +e1[0][1],
                                                +r[0],
                                                +e1[0][3],
                                                +e1[0][4],
                                                +e1[0][5]
                                            ],
                                            [
                                                +e1[1][0],
                                                +e1[1][1],
                                                +r[1],
                                                +e1[1][3],
                                                +e1[1][4],
                                                +e1[1][5]
                                            ],
                                            [
                                                +e1[2][0],
                                                +e1[2][1],
                                                +r[2],
                                                +e1[2][3],
                                                +e1[2][4],
                                                +e1[2][5]
                                            ],
                                            [
                                                +e1[3][0],
                                                +e1[3][1],
                                                +r[3],
                                                +e1[3][3],
                                                +e1[3][4],
                                                +e1[3][5]
                                            ],
                                            [
                                                +e1[4][0],
                                                +e1[4][1],
                                                +r[4],
                                                +e1[4][3],
                                                +e1[4][4],
                                                +e1[4][5]
                                            ],
                                            [
                                                +e1[5][0],
                                                +e1[5][1],
                                                +r[5],
                                                +e1[5][3],
                                                +e1[5][4],
                                                +e1[5][5]
                                            ]
                                        ]),
                                        t1([
                                            [
                                                +e1[0][0],
                                                +e1[0][1],
                                                +e1[0][2],
                                                +r[0],
                                                +e1[0][4],
                                                +e1[0][5]
                                            ],
                                            [
                                                +e1[1][0],
                                                +e1[1][1],
                                                +e1[1][2],
                                                +r[1],
                                                +e1[1][4],
                                                +e1[1][5]
                                            ],
                                            [
                                                +e1[2][0],
                                                +e1[2][1],
                                                +e1[2][2],
                                                +r[2],
                                                +e1[2][4],
                                                +e1[2][5]
                                            ],
                                            [
                                                +e1[3][0],
                                                +e1[3][1],
                                                +e1[3][2],
                                                +r[3],
                                                +e1[3][4],
                                                +e1[3][5]
                                            ],
                                            [
                                                +e1[4][0],
                                                +e1[4][1],
                                                +e1[4][2],
                                                +r[4],
                                                +e1[4][4],
                                                +e1[4][5]
                                            ],
                                            [
                                                +e1[5][0],
                                                +e1[5][1],
                                                +e1[5][2],
                                                +r[5],
                                                +e1[5][4],
                                                +e1[5][5]
                                            ]
                                        ]),
                                        t1([
                                            [
                                                +e1[0][0],
                                                +e1[0][1],
                                                +e1[0][2],
                                                +e1[0][3],
                                                +r[0],
                                                +e1[0][5]
                                            ],
                                            [
                                                +e1[1][0],
                                                +e1[1][1],
                                                +e1[1][2],
                                                +e1[1][3],
                                                +r[1],
                                                +e1[1][5]
                                            ],
                                            [
                                                +e1[2][0],
                                                +e1[2][1],
                                                +e1[2][2],
                                                +e1[2][3],
                                                +r[2],
                                                +e1[2][5]
                                            ],
                                            [
                                                +e1[3][0],
                                                +e1[3][1],
                                                +e1[3][2],
                                                +e1[3][3],
                                                +r[3],
                                                +e1[3][5]
                                            ],
                                            [
                                                +e1[4][0],
                                                +e1[4][1],
                                                +e1[4][2],
                                                +e1[4][3],
                                                +r[4],
                                                +e1[4][5]
                                            ],
                                            [
                                                +e1[5][0],
                                                +e1[5][1],
                                                +e1[5][2],
                                                +e1[5][3],
                                                +r[5],
                                                +e1[5][5]
                                            ]
                                        ]),
                                        t1([
                                            [
                                                +e1[0][0],
                                                +e1[0][1],
                                                +e1[0][2],
                                                +e1[0][3],
                                                +e1[0][4],
                                                +r[0]
                                            ],
                                            [
                                                +e1[1][0],
                                                +e1[1][1],
                                                +e1[1][2],
                                                +e1[1][3],
                                                +e1[1][4],
                                                +r[1]
                                            ],
                                            [
                                                +e1[2][0],
                                                +e1[2][1],
                                                +e1[2][2],
                                                +e1[2][3],
                                                +e1[2][4],
                                                +r[2]
                                            ],
                                            [
                                                +e1[3][0],
                                                +e1[3][1],
                                                +e1[3][2],
                                                +e1[3][3],
                                                +e1[3][4],
                                                +r[3]
                                            ],
                                            [
                                                +e1[4][0],
                                                +e1[4][1],
                                                +e1[4][2],
                                                +e1[4][3],
                                                +e1[4][4],
                                                +r[4]
                                            ],
                                            [
                                                +e1[5][0],
                                                +e1[5][1],
                                                +e1[5][2],
                                                +e1[5][3],
                                                +e1[5][4],
                                                +r[5]
                                            ]
                                        ]),
                                        t1(e1)
                                    ];
                                };
                            }
                            var u = [
                                function() {
                                    return [
                                        [
                                            0
                                        ]
                                    ];
                                },
                                function(t1, e1) {
                                    return [
                                        [
                                            e1[0]
                                        ],
                                        [
                                            t1[0][0]
                                        ]
                                    ];
                                }
                            ];
                            function h(t1, e1, r, n, i, a, o, s) {
                                return function(l, c) {
                                    switch(l.length){
                                        case 0:
                                            return t1(l, c);
                                        case 1:
                                            return e1(l, c);
                                        case 2:
                                            return r(l, c);
                                        case 3:
                                            return n(l, c);
                                        case 4:
                                            return i(l, c);
                                        case 5:
                                            return a(l, c);
                                    }
                                    var u = o[l.length];
                                    return u || (u = o[l.length] = s(l.length)), u(l, c);
                                };
                            }
                            !function() {
                                for(; u.length < 6;)u.push(i(u.length));
                                t1.exports = h.apply(void 0, u.concat([
                                    u,
                                    i
                                ]));
                                for(var e1 = 0; e1 < 6; ++e1)t1.exports[e1] = u[e1];
                            }();
                        },
                        3250: function(t1, e1, r) {
                            "use strict";
                            var n = r(5250), i = r(8210), a = r(3012), o = r(8545);
                            function s(t1, e1, r, n) {
                                return function(r, i, a) {
                                    var o = t1(t1(e1(i[1], a[0]), e1(-a[1], i[0])), t1(e1(r[1], i[0]), e1(-i[1], r[0]))), s = t1(e1(r[1], a[0]), e1(-a[1], r[0])), l = n(o, s);
                                    return l[l.length - 1];
                                };
                            }
                            function l(t1, e1, r, n) {
                                return function(i, a, o, s) {
                                    var l = t1(t1(r(t1(e1(o[1], s[0]), e1(-s[1], o[0])), a[2]), t1(r(t1(e1(a[1], s[0]), e1(-s[1], a[0])), -o[2]), r(t1(e1(a[1], o[0]), e1(-o[1], a[0])), s[2]))), t1(r(t1(e1(a[1], s[0]), e1(-s[1], a[0])), i[2]), t1(r(t1(e1(i[1], s[0]), e1(-s[1], i[0])), -a[2]), r(t1(e1(i[1], a[0]), e1(-a[1], i[0])), s[2])))), c = t1(t1(r(t1(e1(o[1], s[0]), e1(-s[1], o[0])), i[2]), t1(r(t1(e1(i[1], s[0]), e1(-s[1], i[0])), -o[2]), r(t1(e1(i[1], o[0]), e1(-o[1], i[0])), s[2]))), t1(r(t1(e1(a[1], o[0]), e1(-o[1], a[0])), i[2]), t1(r(t1(e1(i[1], o[0]), e1(-o[1], i[0])), -a[2]), r(t1(e1(i[1], a[0]), e1(-a[1], i[0])), o[2])))), u = n(l, c);
                                    return u[u.length - 1];
                                };
                            }
                            function c(t1, e1, r, n) {
                                return function(i, a, o, s, l) {
                                    var c = t1(t1(t1(r(t1(r(t1(e1(s[1], l[0]), e1(-l[1], s[0])), o[2]), t1(r(t1(e1(o[1], l[0]), e1(-l[1], o[0])), -s[2]), r(t1(e1(o[1], s[0]), e1(-s[1], o[0])), l[2]))), a[3]), t1(r(t1(r(t1(e1(s[1], l[0]), e1(-l[1], s[0])), a[2]), t1(r(t1(e1(a[1], l[0]), e1(-l[1], a[0])), -s[2]), r(t1(e1(a[1], s[0]), e1(-s[1], a[0])), l[2]))), -o[3]), r(t1(r(t1(e1(o[1], l[0]), e1(-l[1], o[0])), a[2]), t1(r(t1(e1(a[1], l[0]), e1(-l[1], a[0])), -o[2]), r(t1(e1(a[1], o[0]), e1(-o[1], a[0])), l[2]))), s[3]))), t1(r(t1(r(t1(e1(o[1], s[0]), e1(-s[1], o[0])), a[2]), t1(r(t1(e1(a[1], s[0]), e1(-s[1], a[0])), -o[2]), r(t1(e1(a[1], o[0]), e1(-o[1], a[0])), s[2]))), -l[3]), t1(r(t1(r(t1(e1(s[1], l[0]), e1(-l[1], s[0])), a[2]), t1(r(t1(e1(a[1], l[0]), e1(-l[1], a[0])), -s[2]), r(t1(e1(a[1], s[0]), e1(-s[1], a[0])), l[2]))), i[3]), r(t1(r(t1(e1(s[1], l[0]), e1(-l[1], s[0])), i[2]), t1(r(t1(e1(i[1], l[0]), e1(-l[1], i[0])), -s[2]), r(t1(e1(i[1], s[0]), e1(-s[1], i[0])), l[2]))), -a[3])))), t1(t1(r(t1(r(t1(e1(a[1], l[0]), e1(-l[1], a[0])), i[2]), t1(r(t1(e1(i[1], l[0]), e1(-l[1], i[0])), -a[2]), r(t1(e1(i[1], a[0]), e1(-a[1], i[0])), l[2]))), s[3]), t1(r(t1(r(t1(e1(a[1], s[0]), e1(-s[1], a[0])), i[2]), t1(r(t1(e1(i[1], s[0]), e1(-s[1], i[0])), -a[2]), r(t1(e1(i[1], a[0]), e1(-a[1], i[0])), s[2]))), -l[3]), r(t1(r(t1(e1(o[1], s[0]), e1(-s[1], o[0])), a[2]), t1(r(t1(e1(a[1], s[0]), e1(-s[1], a[0])), -o[2]), r(t1(e1(a[1], o[0]), e1(-o[1], a[0])), s[2]))), i[3]))), t1(r(t1(r(t1(e1(o[1], s[0]), e1(-s[1], o[0])), i[2]), t1(r(t1(e1(i[1], s[0]), e1(-s[1], i[0])), -o[2]), r(t1(e1(i[1], o[0]), e1(-o[1], i[0])), s[2]))), -a[3]), t1(r(t1(r(t1(e1(a[1], s[0]), e1(-s[1], a[0])), i[2]), t1(r(t1(e1(i[1], s[0]), e1(-s[1], i[0])), -a[2]), r(t1(e1(i[1], a[0]), e1(-a[1], i[0])), s[2]))), o[3]), r(t1(r(t1(e1(a[1], o[0]), e1(-o[1], a[0])), i[2]), t1(r(t1(e1(i[1], o[0]), e1(-o[1], i[0])), -a[2]), r(t1(e1(i[1], a[0]), e1(-a[1], i[0])), o[2]))), -s[3]))))), u = t1(t1(t1(r(t1(r(t1(e1(s[1], l[0]), e1(-l[1], s[0])), o[2]), t1(r(t1(e1(o[1], l[0]), e1(-l[1], o[0])), -s[2]), r(t1(e1(o[1], s[0]), e1(-s[1], o[0])), l[2]))), i[3]), r(t1(r(t1(e1(s[1], l[0]), e1(-l[1], s[0])), i[2]), t1(r(t1(e1(i[1], l[0]), e1(-l[1], i[0])), -s[2]), r(t1(e1(i[1], s[0]), e1(-s[1], i[0])), l[2]))), -o[3])), t1(r(t1(r(t1(e1(o[1], l[0]), e1(-l[1], o[0])), i[2]), t1(r(t1(e1(i[1], l[0]), e1(-l[1], i[0])), -o[2]), r(t1(e1(i[1], o[0]), e1(-o[1], i[0])), l[2]))), s[3]), r(t1(r(t1(e1(o[1], s[0]), e1(-s[1], o[0])), i[2]), t1(r(t1(e1(i[1], s[0]), e1(-s[1], i[0])), -o[2]), r(t1(e1(i[1], o[0]), e1(-o[1], i[0])), s[2]))), -l[3]))), t1(t1(r(t1(r(t1(e1(o[1], l[0]), e1(-l[1], o[0])), a[2]), t1(r(t1(e1(a[1], l[0]), e1(-l[1], a[0])), -o[2]), r(t1(e1(a[1], o[0]), e1(-o[1], a[0])), l[2]))), i[3]), r(t1(r(t1(e1(o[1], l[0]), e1(-l[1], o[0])), i[2]), t1(r(t1(e1(i[1], l[0]), e1(-l[1], i[0])), -o[2]), r(t1(e1(i[1], o[0]), e1(-o[1], i[0])), l[2]))), -a[3])), t1(r(t1(r(t1(e1(a[1], l[0]), e1(-l[1], a[0])), i[2]), t1(r(t1(e1(i[1], l[0]), e1(-l[1], i[0])), -a[2]), r(t1(e1(i[1], a[0]), e1(-a[1], i[0])), l[2]))), o[3]), r(t1(r(t1(e1(a[1], o[0]), e1(-o[1], a[0])), i[2]), t1(r(t1(e1(i[1], o[0]), e1(-o[1], i[0])), -a[2]), r(t1(e1(i[1], a[0]), e1(-a[1], i[0])), o[2]))), -l[3])))), h = n(c, u);
                                    return h[h.length - 1];
                                };
                            }
                            function u(t1) {
                                return (3 === t1 ? s : 4 === t1 ? l : c)(i, n, a, o);
                            }
                            var h = u(3), f = u(4), p = [
                                function() {
                                    return 0;
                                },
                                function() {
                                    return 0;
                                },
                                function(t1, e1) {
                                    return e1[0] - t1[0];
                                },
                                function(t1, e1, r) {
                                    var n, i = (t1[1] - r[1]) * (e1[0] - r[0]), a = (t1[0] - r[0]) * (e1[1] - r[1]), o = i - a;
                                    if (i > 0) {
                                        if (a <= 0) return o;
                                        n = i + a;
                                    } else {
                                        if (!(i < 0)) return o;
                                        if (a >= 0) return o;
                                        n = -(i + a);
                                    }
                                    var s = 33306690738754716e-32 * n;
                                    return o >= s || o <= -s ? o : h(t1, e1, r);
                                },
                                function(t1, e1, r, n) {
                                    var i = t1[0] - n[0], a = e1[0] - n[0], o = r[0] - n[0], s = t1[1] - n[1], l = e1[1] - n[1], c = r[1] - n[1], u = t1[2] - n[2], h = e1[2] - n[2], p = r[2] - n[2], d = a * c, m = o * l, g = o * s, y = i * c, v = i * l, x = a * s, _ = u * (d - m) + h * (g - y) + p * (v - x), b = 7771561172376103e-31 * ((Math.abs(d) + Math.abs(m)) * Math.abs(u) + (Math.abs(g) + Math.abs(y)) * Math.abs(h) + (Math.abs(v) + Math.abs(x)) * Math.abs(p));
                                    return _ > b || -_ > b ? _ : f(t1, e1, r, n);
                                }
                            ];
                            function d(t1) {
                                var e1 = p[t1.length];
                                return e1 || (e1 = p[t1.length] = u(t1.length)), e1.apply(void 0, t1);
                            }
                            function m(t1, e1, r, n, i, a, o) {
                                return function(e1, r, s, l, c) {
                                    switch(arguments.length){
                                        case 0:
                                        case 1:
                                            return 0;
                                        case 2:
                                            return n(e1, r);
                                        case 3:
                                            return i(e1, r, s);
                                        case 4:
                                            return a(e1, r, s, l);
                                        case 5:
                                            return o(e1, r, s, l, c);
                                    }
                                    for(var u = new Array(arguments.length), h = 0; h < arguments.length; ++h)u[h] = arguments[h];
                                    return t1(u);
                                };
                            }
                            !function() {
                                for(; p.length <= 5;)p.push(u(p.length));
                                t1.exports = m.apply(void 0, [
                                    d
                                ].concat(p));
                                for(var e1 = 0; e1 <= 5; ++e1)t1.exports[e1] = p[e1];
                            }();
                        },
                        5382: function(t1, e1, r) {
                            "use strict";
                            var n = r(8210), i = r(3012);
                            t1.exports = function(t1, e1) {
                                if (1 === t1.length) return i(e1, t1[0]);
                                if (1 === e1.length) return i(t1, e1[0]);
                                if (0 === t1.length || 0 === e1.length) return [
                                    0
                                ];
                                var r = [
                                    0
                                ];
                                if (t1.length < e1.length) for(var a = 0; a < t1.length; ++a)r = n(r, i(e1, t1[a]));
                                else for(a = 0; a < e1.length; ++a)r = n(r, i(t1, e1[a]));
                                return r;
                            };
                        },
                        3012: function(t1, e1, r) {
                            "use strict";
                            var n = r(5250), i = r(9362);
                            t1.exports = function(t1, e1) {
                                var r = t1.length;
                                if (1 === r) {
                                    var a = n(t1[0], e1);
                                    return a[0] ? a : [
                                        a[1]
                                    ];
                                }
                                var o = new Array(2 * r), s = [
                                    .1,
                                    .1
                                ], l = [
                                    .1,
                                    .1
                                ], c = 0;
                                n(t1[0], e1, s), s[0] && (o[c++] = s[0]);
                                for(var u = 1; u < r; ++u){
                                    n(t1[u], e1, l);
                                    var h = s[1];
                                    i(h, l[0], s), s[0] && (o[c++] = s[0]);
                                    var f = l[1], p = s[1], d = f + p, m = p - (d - f);
                                    s[1] = d, m && (o[c++] = m);
                                }
                                return s[1] && (o[c++] = s[1]), 0 === c && (o[c++] = 0), o.length = c, o;
                            };
                        },
                        1125: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1, r, i) {
                                var a = n(t1, r, i), o = n(e1, r, i);
                                if (a > 0 && o > 0 || a < 0 && o < 0) return !1;
                                var s = n(r, t1, e1), l = n(i, t1, e1);
                                return !(s > 0 && l > 0 || s < 0 && l < 0) && (0 !== a || 0 !== o || 0 !== s || 0 !== l || function(t1, e1, r, n) {
                                    for(var i = 0; i < 2; ++i){
                                        var a = t1[i], o = e1[i], s = Math.min(a, o), l = Math.max(a, o), c = r[i], u = n[i], h = Math.min(c, u);
                                        if (Math.max(c, u) < s || l < h) return !1;
                                    }
                                    return !0;
                                }(t1, e1, r, i));
                            };
                            var n = r(3250)[3];
                        },
                        8545: function(t1) {
                            "use strict";
                            t1.exports = function(t1, e1) {
                                var r = 0 | t1.length, n = 0 | e1.length;
                                if (1 === r && 1 === n) return function(t1, e1) {
                                    var r = t1 + e1, n = r - t1, i = t1 - (r - n) + (e1 - n);
                                    return i ? [
                                        i,
                                        r
                                    ] : [
                                        r
                                    ];
                                }(t1[0], -e1[0]);
                                var i, a, o = new Array(r + n), s = 0, l = 0, c = 0, u = Math.abs, h = t1[l], f = u(h), p = -e1[c], d = u(p);
                                f < d ? (a = h, (l += 1) < r && (f = u(h = t1[l]))) : (a = p, (c += 1) < n && (d = u(p = -e1[c]))), l < r && f < d || c >= n ? (i = h, (l += 1) < r && (f = u(h = t1[l]))) : (i = p, (c += 1) < n && (d = u(p = -e1[c])));
                                for(var m, g, y = i + a, v = y - i, x = a - v, _ = x, b = y; l < r && c < n;)f < d ? (i = h, (l += 1) < r && (f = u(h = t1[l]))) : (i = p, (c += 1) < n && (d = u(p = -e1[c]))), (x = (a = _) - (v = (y = i + a) - i)) && (o[s++] = x), _ = b - ((m = b + y) - (g = m - b)) + (y - g), b = m;
                                for(; l < r;)(x = (a = _) - (v = (y = (i = h) + a) - i)) && (o[s++] = x), _ = b - ((m = b + y) - (g = m - b)) + (y - g), b = m, (l += 1) < r && (h = t1[l]);
                                for(; c < n;)(x = (a = _) - (v = (y = (i = p) + a) - i)) && (o[s++] = x), _ = b - ((m = b + y) - (g = m - b)) + (y - g), b = m, (c += 1) < n && (p = -e1[c]);
                                return _ && (o[s++] = _), b && (o[s++] = b), s || (o[s++] = 0), o.length = s, o;
                            };
                        },
                        8210: function(t1) {
                            "use strict";
                            t1.exports = function(t1, e1) {
                                var r = 0 | t1.length, n = 0 | e1.length;
                                if (1 === r && 1 === n) return function(t1, e1) {
                                    var r = t1 + e1, n = r - t1, i = t1 - (r - n) + (e1 - n);
                                    return i ? [
                                        i,
                                        r
                                    ] : [
                                        r
                                    ];
                                }(t1[0], e1[0]);
                                var i, a, o = new Array(r + n), s = 0, l = 0, c = 0, u = Math.abs, h = t1[l], f = u(h), p = e1[c], d = u(p);
                                f < d ? (a = h, (l += 1) < r && (f = u(h = t1[l]))) : (a = p, (c += 1) < n && (d = u(p = e1[c]))), l < r && f < d || c >= n ? (i = h, (l += 1) < r && (f = u(h = t1[l]))) : (i = p, (c += 1) < n && (d = u(p = e1[c])));
                                for(var m, g, y = i + a, v = y - i, x = a - v, _ = x, b = y; l < r && c < n;)f < d ? (i = h, (l += 1) < r && (f = u(h = t1[l]))) : (i = p, (c += 1) < n && (d = u(p = e1[c]))), (x = (a = _) - (v = (y = i + a) - i)) && (o[s++] = x), _ = b - ((m = b + y) - (g = m - b)) + (y - g), b = m;
                                for(; l < r;)(x = (a = _) - (v = (y = (i = h) + a) - i)) && (o[s++] = x), _ = b - ((m = b + y) - (g = m - b)) + (y - g), b = m, (l += 1) < r && (h = t1[l]);
                                for(; c < n;)(x = (a = _) - (v = (y = (i = p) + a) - i)) && (o[s++] = x), _ = b - ((m = b + y) - (g = m - b)) + (y - g), b = m, (c += 1) < n && (p = e1[c]);
                                return _ && (o[s++] = _), b && (o[s++] = b), s || (o[s++] = 0), o.length = s, o;
                            };
                        },
                        9127: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1) {
                                return i(n(t1));
                            };
                            var n = r(6204), i = r(5771);
                        },
                        7765: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1, r, s) {
                                if (r = r || 0, void 0 === s && (s = function(t1) {
                                    for(var e1 = t1.length, r = 0, n = 0; n < e1; ++n)r = 0 | Math.max(r, t1[n].length);
                                    return r - 1;
                                }(t1)), 0 === t1.length || s < 1) return {
                                    cells: [],
                                    vertexIds: [],
                                    vertexWeights: []
                                };
                                var l = function(t1, e1) {
                                    for(var r = t1.length, n = i.mallocUint8(r), a = 0; a < r; ++a)n[a] = t1[a] < e1 | 0;
                                    return n;
                                }(e1, +r), c = function(t1, e1) {
                                    for(var r = t1.length, o = e1 * (e1 + 1) / 2 * r | 0, s = i.mallocUint32(2 * o), l = 0, c = 0; c < r; ++c)for(var u = t1[c], h = (e1 = u.length, 0); h < e1; ++h)for(var f = 0; f < h; ++f){
                                        var p = u[f], d = u[h];
                                        s[l++] = 0 | Math.min(p, d), s[l++] = 0 | Math.max(p, d);
                                    }
                                    a(n(s, [
                                        l / 2 | 0,
                                        2
                                    ]));
                                    var m = 2;
                                    for(c = 2; c < l; c += 2)s[c - 2] === s[c] && s[c - 1] === s[c + 1] || (s[m++] = s[c], s[m++] = s[c + 1]);
                                    return n(s, [
                                        m / 2 | 0,
                                        2
                                    ]);
                                }(t1, s), u = function(t1, e1, r, a) {
                                    for(var o = t1.data, s = t1.shape[0], l = i.mallocDouble(s), c = 0, u = 0; u < s; ++u){
                                        var h = o[2 * u], f = o[2 * u + 1];
                                        if (r[h] !== r[f]) {
                                            var p = e1[h], d = e1[f];
                                            o[2 * c] = h, o[2 * c + 1] = f, l[c++] = (d - a) / (d - p);
                                        }
                                    }
                                    return t1.shape[0] = c, n(l, [
                                        c
                                    ]);
                                }(c, e1, l, +r), h = function(t1, e1) {
                                    var r = i.mallocInt32(2 * e1), n = t1.shape[0], a = t1.data;
                                    r[0] = 0;
                                    for(var o = 0, s = 0; s < n; ++s){
                                        var l = a[2 * s];
                                        if (l !== o) {
                                            for(r[2 * o + 1] = s; ++o < l;)r[2 * o] = s, r[2 * o + 1] = s;
                                            r[2 * o] = s;
                                        }
                                    }
                                    for(r[2 * o + 1] = n; ++o < e1;)r[2 * o] = r[2 * o + 1] = n;
                                    return r;
                                }(c, 0 | e1.length), f = o(s)(t1, c.data, h, l), p = function(t1) {
                                    for(var e1 = 0 | t1.shape[0], r = t1.data, n = new Array(e1), i = 0; i < e1; ++i)n[i] = [
                                        r[2 * i],
                                        r[2 * i + 1]
                                    ];
                                    return n;
                                }(c), d = [].slice.call(u.data, 0, u.shape[0]);
                                return i.free(l), i.free(c.data), i.free(u.data), i.free(h), {
                                    cells: f,
                                    vertexIds: p,
                                    vertexWeights: d
                                };
                            };
                            var n = r(9618), i = r(1888), a = r(446), o = r(1570);
                        },
                        1570: function(t1) {
                            "use strict";
                            t1.exports = function(t1) {
                                return e1[t1]();
                            };
                            var e1 = [
                                function() {
                                    return function(t1, e1, r, n) {
                                        for(var i = t1.length, a = 0; a < i; ++a)t1[a].length;
                                        return [];
                                    };
                                },
                                function() {
                                    function t1(t1, e1, r, n) {
                                        for(var i = 0 | Math.min(r, n), a = 0 | Math.max(r, n), o = t1[2 * i], s = t1[2 * i + 1]; o < s;){
                                            var l = o + s >> 1, c = e1[2 * l + 1];
                                            if (c === a) return l;
                                            a < c ? s = l : o = l + 1;
                                        }
                                        return o;
                                    }
                                    return function(e1, r, n, i) {
                                        for(var a = e1.length, o = [], s = 0; s < a; ++s){
                                            var l = e1[s];
                                            if (2 === l.length) {
                                                var c = (i[l[0]] << 0) + (i[l[1]] << 1);
                                                if (0 === c || 3 === c) continue;
                                                switch(c){
                                                    case 0:
                                                    case 3:
                                                        break;
                                                    case 1:
                                                        o.push([
                                                            t1(n, r, l[0], l[1])
                                                        ]);
                                                        break;
                                                    case 2:
                                                        o.push([
                                                            t1(n, r, l[1], l[0])
                                                        ]);
                                                }
                                            }
                                        }
                                        return o;
                                    };
                                },
                                function() {
                                    function t1(t1, e1, r, n) {
                                        for(var i = 0 | Math.min(r, n), a = 0 | Math.max(r, n), o = t1[2 * i], s = t1[2 * i + 1]; o < s;){
                                            var l = o + s >> 1, c = e1[2 * l + 1];
                                            if (c === a) return l;
                                            a < c ? s = l : o = l + 1;
                                        }
                                        return o;
                                    }
                                    return function(e1, r, n, i) {
                                        for(var a = e1.length, o = [], s = 0; s < a; ++s){
                                            var l = e1[s], c = l.length;
                                            if (3 === c) {
                                                if (0 == (u = (i[l[0]] << 0) + (i[l[1]] << 1) + (i[l[2]] << 2)) || 7 === u) continue;
                                                switch(u){
                                                    case 0:
                                                    case 7:
                                                        break;
                                                    case 1:
                                                        o.push([
                                                            t1(n, r, l[0], l[2]),
                                                            t1(n, r, l[0], l[1])
                                                        ]);
                                                        break;
                                                    case 2:
                                                        o.push([
                                                            t1(n, r, l[1], l[0]),
                                                            t1(n, r, l[1], l[2])
                                                        ]);
                                                        break;
                                                    case 3:
                                                        o.push([
                                                            t1(n, r, l[0], l[2]),
                                                            t1(n, r, l[1], l[2])
                                                        ]);
                                                        break;
                                                    case 4:
                                                        o.push([
                                                            t1(n, r, l[2], l[1]),
                                                            t1(n, r, l[2], l[0])
                                                        ]);
                                                        break;
                                                    case 5:
                                                        o.push([
                                                            t1(n, r, l[2], l[1]),
                                                            t1(n, r, l[0], l[1])
                                                        ]);
                                                        break;
                                                    case 6:
                                                        o.push([
                                                            t1(n, r, l[1], l[0]),
                                                            t1(n, r, l[2], l[0])
                                                        ]);
                                                }
                                            } else if (2 === c) {
                                                var u;
                                                if (0 == (u = (i[l[0]] << 0) + (i[l[1]] << 1)) || 3 === u) continue;
                                                switch(u){
                                                    case 0:
                                                    case 3:
                                                        break;
                                                    case 1:
                                                        o.push([
                                                            t1(n, r, l[0], l[1])
                                                        ]);
                                                        break;
                                                    case 2:
                                                        o.push([
                                                            t1(n, r, l[1], l[0])
                                                        ]);
                                                }
                                            }
                                        }
                                        return o;
                                    };
                                },
                                function() {
                                    function t1(t1, e1, r, n) {
                                        for(var i = 0 | Math.min(r, n), a = 0 | Math.max(r, n), o = t1[2 * i], s = t1[2 * i + 1]; o < s;){
                                            var l = o + s >> 1, c = e1[2 * l + 1];
                                            if (c === a) return l;
                                            a < c ? s = l : o = l + 1;
                                        }
                                        return o;
                                    }
                                    return function(e1, r, n, i) {
                                        for(var a = e1.length, o = [], s = 0; s < a; ++s){
                                            var l = e1[s], c = l.length;
                                            if (4 === c) {
                                                if (0 == (u = (i[l[0]] << 0) + (i[l[1]] << 1) + (i[l[2]] << 2) + (i[l[3]] << 3)) || 15 === u) continue;
                                                switch(u){
                                                    case 0:
                                                    case 15:
                                                        break;
                                                    case 1:
                                                        o.push([
                                                            t1(n, r, l[0], l[1]),
                                                            t1(n, r, l[0], l[2]),
                                                            t1(n, r, l[0], l[3])
                                                        ]);
                                                        break;
                                                    case 2:
                                                        o.push([
                                                            t1(n, r, l[1], l[2]),
                                                            t1(n, r, l[1], l[0]),
                                                            t1(n, r, l[1], l[3])
                                                        ]);
                                                        break;
                                                    case 3:
                                                        o.push([
                                                            t1(n, r, l[1], l[2]),
                                                            t1(n, r, l[0], l[2]),
                                                            t1(n, r, l[0], l[3])
                                                        ], [
                                                            t1(n, r, l[1], l[3]),
                                                            t1(n, r, l[1], l[2]),
                                                            t1(n, r, l[0], l[3])
                                                        ]);
                                                        break;
                                                    case 4:
                                                        o.push([
                                                            t1(n, r, l[2], l[0]),
                                                            t1(n, r, l[2], l[1]),
                                                            t1(n, r, l[2], l[3])
                                                        ]);
                                                        break;
                                                    case 5:
                                                        o.push([
                                                            t1(n, r, l[0], l[1]),
                                                            t1(n, r, l[2], l[1]),
                                                            t1(n, r, l[0], l[3])
                                                        ], [
                                                            t1(n, r, l[2], l[1]),
                                                            t1(n, r, l[2], l[3]),
                                                            t1(n, r, l[0], l[3])
                                                        ]);
                                                        break;
                                                    case 6:
                                                        o.push([
                                                            t1(n, r, l[2], l[0]),
                                                            t1(n, r, l[1], l[0]),
                                                            t1(n, r, l[1], l[3])
                                                        ], [
                                                            t1(n, r, l[2], l[3]),
                                                            t1(n, r, l[2], l[0]),
                                                            t1(n, r, l[1], l[3])
                                                        ]);
                                                        break;
                                                    case 7:
                                                        o.push([
                                                            t1(n, r, l[0], l[3]),
                                                            t1(n, r, l[1], l[3]),
                                                            t1(n, r, l[2], l[3])
                                                        ]);
                                                        break;
                                                    case 8:
                                                        o.push([
                                                            t1(n, r, l[3], l[1]),
                                                            t1(n, r, l[3], l[0]),
                                                            t1(n, r, l[3], l[2])
                                                        ]);
                                                        break;
                                                    case 9:
                                                        o.push([
                                                            t1(n, r, l[3], l[1]),
                                                            t1(n, r, l[0], l[1]),
                                                            t1(n, r, l[0], l[2])
                                                        ], [
                                                            t1(n, r, l[3], l[2]),
                                                            t1(n, r, l[3], l[1]),
                                                            t1(n, r, l[0], l[2])
                                                        ]);
                                                        break;
                                                    case 10:
                                                        o.push([
                                                            t1(n, r, l[1], l[0]),
                                                            t1(n, r, l[3], l[0]),
                                                            t1(n, r, l[1], l[2])
                                                        ], [
                                                            t1(n, r, l[3], l[0]),
                                                            t1(n, r, l[3], l[2]),
                                                            t1(n, r, l[1], l[2])
                                                        ]);
                                                        break;
                                                    case 11:
                                                        o.push([
                                                            t1(n, r, l[1], l[2]),
                                                            t1(n, r, l[0], l[2]),
                                                            t1(n, r, l[3], l[2])
                                                        ]);
                                                        break;
                                                    case 12:
                                                        o.push([
                                                            t1(n, r, l[3], l[0]),
                                                            t1(n, r, l[2], l[0]),
                                                            t1(n, r, l[2], l[1])
                                                        ], [
                                                            t1(n, r, l[3], l[1]),
                                                            t1(n, r, l[3], l[0]),
                                                            t1(n, r, l[2], l[1])
                                                        ]);
                                                        break;
                                                    case 13:
                                                        o.push([
                                                            t1(n, r, l[0], l[1]),
                                                            t1(n, r, l[2], l[1]),
                                                            t1(n, r, l[3], l[1])
                                                        ]);
                                                        break;
                                                    case 14:
                                                        o.push([
                                                            t1(n, r, l[2], l[0]),
                                                            t1(n, r, l[1], l[0]),
                                                            t1(n, r, l[3], l[0])
                                                        ]);
                                                }
                                            } else if (3 === c) {
                                                if (0 == (u = (i[l[0]] << 0) + (i[l[1]] << 1) + (i[l[2]] << 2)) || 7 === u) continue;
                                                switch(u){
                                                    case 0:
                                                    case 7:
                                                        break;
                                                    case 1:
                                                        o.push([
                                                            t1(n, r, l[0], l[2]),
                                                            t1(n, r, l[0], l[1])
                                                        ]);
                                                        break;
                                                    case 2:
                                                        o.push([
                                                            t1(n, r, l[1], l[0]),
                                                            t1(n, r, l[1], l[2])
                                                        ]);
                                                        break;
                                                    case 3:
                                                        o.push([
                                                            t1(n, r, l[0], l[2]),
                                                            t1(n, r, l[1], l[2])
                                                        ]);
                                                        break;
                                                    case 4:
                                                        o.push([
                                                            t1(n, r, l[2], l[1]),
                                                            t1(n, r, l[2], l[0])
                                                        ]);
                                                        break;
                                                    case 5:
                                                        o.push([
                                                            t1(n, r, l[2], l[1]),
                                                            t1(n, r, l[0], l[1])
                                                        ]);
                                                        break;
                                                    case 6:
                                                        o.push([
                                                            t1(n, r, l[1], l[0]),
                                                            t1(n, r, l[2], l[0])
                                                        ]);
                                                }
                                            } else if (2 === c) {
                                                var u;
                                                if (0 == (u = (i[l[0]] << 0) + (i[l[1]] << 1)) || 3 === u) continue;
                                                switch(u){
                                                    case 0:
                                                    case 3:
                                                        break;
                                                    case 1:
                                                        o.push([
                                                            t1(n, r, l[0], l[1])
                                                        ]);
                                                        break;
                                                    case 2:
                                                        o.push([
                                                            t1(n, r, l[1], l[0])
                                                        ]);
                                                }
                                            }
                                        }
                                        return o;
                                    };
                                }
                            ];
                        },
                        6803: function(t1, e1, r) {
                            "use strict";
                            r(8828), r(1755);
                            function n(t1, e1) {
                                var r = t1.length, n = t1.length - e1.length, i = Math.min;
                                if (n) return n;
                                switch(r){
                                    case 0:
                                        return 0;
                                    case 1:
                                        return t1[0] - e1[0];
                                    case 2:
                                        return (s = t1[0] + t1[1] - e1[0] - e1[1]) || i(t1[0], t1[1]) - i(e1[0], e1[1]);
                                    case 3:
                                        var a = t1[0] + t1[1], o = e1[0] + e1[1];
                                        if (s = a + t1[2] - (o + e1[2])) return s;
                                        var s, l = i(t1[0], t1[1]), c = i(e1[0], e1[1]);
                                        return (s = i(l, t1[2]) - i(c, e1[2])) || i(l + t1[2], a) - i(c + e1[2], o);
                                    default:
                                        var u = t1.slice(0);
                                        u.sort();
                                        var h = e1.slice(0);
                                        h.sort();
                                        for(var f = 0; f < r; ++f)if (n = u[f] - h[f]) return n;
                                        return 0;
                                }
                            }
                            e1.Fw = n;
                        },
                        3105: function(t1, e1) {
                            "use strict";
                            function r(t1) {
                                var e1 = 32;
                                return (t1 &= -t1) && e1--, 65535 & t1 && (e1 -= 16), 16711935 & t1 && (e1 -= 8), 252645135 & t1 && (e1 -= 4), 858993459 & t1 && (e1 -= 2), 1431655765 & t1 && (e1 -= 1), e1;
                            }
                            e1.INT_BITS = 32, e1.INT_MAX = 2147483647, e1.INT_MIN = -2147483648, e1.sign = function(t1) {
                                return (t1 > 0) - (t1 < 0);
                            }, e1.abs = function(t1) {
                                var e1 = t1 >> 31;
                                return (t1 ^ e1) - e1;
                            }, e1.min = function(t1, e1) {
                                return e1 ^ (t1 ^ e1) & -(t1 < e1);
                            }, e1.max = function(t1, e1) {
                                return t1 ^ (t1 ^ e1) & -(t1 < e1);
                            }, e1.isPow2 = function(t1) {
                                return !(t1 & t1 - 1 || !t1);
                            }, e1.log2 = function(t1) {
                                var e1, r;
                                return e1 = (t1 > 65535) << 4, e1 |= r = ((t1 >>>= e1) > 255) << 3, e1 |= r = ((t1 >>>= r) > 15) << 2, (e1 |= r = ((t1 >>>= r) > 3) << 1) | (t1 >>>= r) >> 1;
                            }, e1.log10 = function(t1) {
                                return t1 >= 1e9 ? 9 : t1 >= 1e8 ? 8 : t1 >= 1e7 ? 7 : t1 >= 1e6 ? 6 : t1 >= 1e5 ? 5 : t1 >= 1e4 ? 4 : t1 >= 1e3 ? 3 : t1 >= 100 ? 2 : t1 >= 10 ? 1 : 0;
                            }, e1.popCount = function(t1) {
                                return 16843009 * ((t1 = (858993459 & (t1 -= t1 >>> 1 & 1431655765)) + (t1 >>> 2 & 858993459)) + (t1 >>> 4) & 252645135) >>> 24;
                            }, e1.countTrailingZeros = r, e1.nextPow2 = function(t1) {
                                return t1 += 0 === t1, --t1, t1 |= t1 >>> 1, t1 |= t1 >>> 2, t1 |= t1 >>> 4, t1 |= t1 >>> 8, 1 + (t1 |= t1 >>> 16);
                            }, e1.prevPow2 = function(t1) {
                                return t1 |= t1 >>> 1, t1 |= t1 >>> 2, t1 |= t1 >>> 4, t1 |= t1 >>> 8, (t1 |= t1 >>> 16) - (t1 >>> 1);
                            }, e1.parity = function(t1) {
                                return t1 ^= t1 >>> 16, t1 ^= t1 >>> 8, t1 ^= t1 >>> 4, 27030 >>> (t1 &= 15) & 1;
                            };
                            var n = new Array(256);
                            !function(t1) {
                                for(var e1 = 0; e1 < 256; ++e1){
                                    var r = e1, n = e1, i = 7;
                                    for(r >>>= 1; r; r >>>= 1)n <<= 1, n |= 1 & r, --i;
                                    t1[e1] = n << i & 255;
                                }
                            }(n), e1.reverse = function(t1) {
                                return n[255 & t1] << 24 | n[t1 >>> 8 & 255] << 16 | n[t1 >>> 16 & 255] << 8 | n[t1 >>> 24 & 255];
                            }, e1.interleave2 = function(t1, e1) {
                                return (t1 = 1431655765 & ((t1 = 858993459 & ((t1 = 252645135 & ((t1 = 16711935 & ((t1 &= 65535) | t1 << 8)) | t1 << 4)) | t1 << 2)) | t1 << 1)) | (e1 = 1431655765 & ((e1 = 858993459 & ((e1 = 252645135 & ((e1 = 16711935 & ((e1 &= 65535) | e1 << 8)) | e1 << 4)) | e1 << 2)) | e1 << 1)) << 1;
                            }, e1.deinterleave2 = function(t1, e1) {
                                return (t1 = 65535 & ((t1 = 16711935 & ((t1 = 252645135 & ((t1 = 858993459 & ((t1 = t1 >>> e1 & 1431655765) | t1 >>> 1)) | t1 >>> 2)) | t1 >>> 4)) | t1 >>> 16)) << 16 >> 16;
                            }, e1.interleave3 = function(t1, e1, r) {
                                return t1 = 1227133513 & ((t1 = 3272356035 & ((t1 = 251719695 & ((t1 = 4278190335 & ((t1 &= 1023) | t1 << 16)) | t1 << 8)) | t1 << 4)) | t1 << 2), (t1 |= (e1 = 1227133513 & ((e1 = 3272356035 & ((e1 = 251719695 & ((e1 = 4278190335 & ((e1 &= 1023) | e1 << 16)) | e1 << 8)) | e1 << 4)) | e1 << 2)) << 1) | (r = 1227133513 & ((r = 3272356035 & ((r = 251719695 & ((r = 4278190335 & ((r &= 1023) | r << 16)) | r << 8)) | r << 4)) | r << 2)) << 2;
                            }, e1.deinterleave3 = function(t1, e1) {
                                return (t1 = 1023 & ((t1 = 4278190335 & ((t1 = 251719695 & ((t1 = 3272356035 & ((t1 = t1 >>> e1 & 1227133513) | t1 >>> 2)) | t1 >>> 4)) | t1 >>> 8)) | t1 >>> 16)) << 22 >> 22;
                            }, e1.nextCombination = function(t1) {
                                var e1 = t1 | t1 - 1;
                                return e1 + 1 | (~e1 & -~e1) - 1 >>> r(t1) + 1;
                            };
                        },
                        2014: function(t1, e1, r) {
                            "use strict";
                            var n = r(3105), i = r(4623);
                            function a(t1, e1) {
                                var r = t1.length, n = t1.length - e1.length, i = Math.min;
                                if (n) return n;
                                switch(r){
                                    case 0:
                                        return 0;
                                    case 1:
                                        return t1[0] - e1[0];
                                    case 2:
                                        return (s = t1[0] + t1[1] - e1[0] - e1[1]) || i(t1[0], t1[1]) - i(e1[0], e1[1]);
                                    case 3:
                                        var a = t1[0] + t1[1], o = e1[0] + e1[1];
                                        if (s = a + t1[2] - (o + e1[2])) return s;
                                        var s, l = i(t1[0], t1[1]), c = i(e1[0], e1[1]);
                                        return (s = i(l, t1[2]) - i(c, e1[2])) || i(l + t1[2], a) - i(c + e1[2], o);
                                    default:
                                        var u = t1.slice(0);
                                        u.sort();
                                        var h = e1.slice(0);
                                        h.sort();
                                        for(var f = 0; f < r; ++f)if (n = u[f] - h[f]) return n;
                                        return 0;
                                }
                            }
                            function o(t1, e1) {
                                return a(t1[0], e1[0]);
                            }
                            function s(t1, e1) {
                                if (e1) {
                                    for(var r = t1.length, n = new Array(r), i = 0; i < r; ++i)n[i] = [
                                        t1[i],
                                        e1[i]
                                    ];
                                    for(n.sort(o), i = 0; i < r; ++i)t1[i] = n[i][0], e1[i] = n[i][1];
                                    return t1;
                                }
                                return t1.sort(a), t1;
                            }
                            function l(t1) {
                                if (0 === t1.length) return [];
                                for(var e1 = 1, r = t1.length, n = 1; n < r; ++n){
                                    var i = t1[n];
                                    if (a(i, t1[n - 1])) {
                                        if (n === e1) {
                                            e1++;
                                            continue;
                                        }
                                        t1[e1++] = i;
                                    }
                                }
                                return t1.length = e1, t1;
                            }
                            function c(t1, e1) {
                                for(var r = 0, n = t1.length - 1, i = -1; r <= n;){
                                    var o = r + n >> 1, s = a(t1[o], e1);
                                    s <= 0 ? (0 === s && (i = o), r = o + 1) : s > 0 && (n = o - 1);
                                }
                                return i;
                            }
                            function u(t1, e1) {
                                for(var r = new Array(t1.length), i = 0, o = r.length; i < o; ++i)r[i] = [];
                                for(var s = [], l = (i = 0, e1.length); i < l; ++i)for(var u = e1[i], h = u.length, f = 1, p = 1 << h; f < p; ++f){
                                    s.length = n.popCount(f);
                                    for(var d = 0, m = 0; m < h; ++m)f & 1 << m && (s[d++] = u[m]);
                                    var g = c(t1, s);
                                    if (!(g < 0)) for(; r[g++].push(i), !(g >= t1.length || 0 !== a(t1[g], s)););
                                }
                                return r;
                            }
                            function h(t1, e1) {
                                if (e1 < 0) return [];
                                for(var r = [], i = (1 << e1 + 1) - 1, a = 0; a < t1.length; ++a)for(var o = t1[a], l = i; l < 1 << o.length; l = n.nextCombination(l)){
                                    for(var c = new Array(e1 + 1), u = 0, h = 0; h < o.length; ++h)l & 1 << h && (c[u++] = o[h]);
                                    r.push(c);
                                }
                                return s(r);
                            }
                            e1.dimension = function(t1) {
                                for(var e1 = 0, r = Math.max, n = 0, i = t1.length; n < i; ++n)e1 = r(e1, t1[n].length);
                                return e1 - 1;
                            }, e1.countVertices = function(t1) {
                                for(var e1 = -1, r = Math.max, n = 0, i = t1.length; n < i; ++n)for(var a = t1[n], o = 0, s = a.length; o < s; ++o)e1 = r(e1, a[o]);
                                return e1 + 1;
                            }, e1.cloneCells = function(t1) {
                                for(var e1 = new Array(t1.length), r = 0, n = t1.length; r < n; ++r)e1[r] = t1[r].slice(0);
                                return e1;
                            }, e1.compareCells = a, e1.normalize = s, e1.unique = l, e1.findCell = c, e1.incidence = u, e1.dual = function(t1, e1) {
                                if (!e1) return u(l(h(t1, 0)), t1);
                                for(var r = new Array(e1), n = 0; n < e1; ++n)r[n] = [];
                                n = 0;
                                for(var i = t1.length; n < i; ++n)for(var a = t1[n], o = 0, s = a.length; o < s; ++o)r[a[o]].push(n);
                                return r;
                            }, e1.explode = function(t1) {
                                for(var e1 = [], r = 0, n = t1.length; r < n; ++r)for(var i = t1[r], a = 0 | i.length, o = 1, l = 1 << a; o < l; ++o){
                                    for(var c = [], u = 0; u < a; ++u)o >>> u & 1 && c.push(i[u]);
                                    e1.push(c);
                                }
                                return s(e1);
                            }, e1.skeleton = h, e1.boundary = function(t1) {
                                for(var e1 = [], r = 0, n = t1.length; r < n; ++r)for(var i = t1[r], a = 0, o = i.length; a < o; ++a){
                                    for(var l = new Array(i.length - 1), c = 0, u = 0; c < o; ++c)c !== a && (l[u++] = i[c]);
                                    e1.push(l);
                                }
                                return s(e1);
                            }, e1.connectedComponents = function(t1, e1) {
                                return e1 ? function(t1, e1) {
                                    for(var r = new i(e1), n = 0; n < t1.length; ++n)for(var a = t1[n], o = 0; o < a.length; ++o)for(var s = o + 1; s < a.length; ++s)r.link(a[o], a[s]);
                                    var l = [], c = r.ranks;
                                    for(n = 0; n < c.length; ++n)c[n] = -1;
                                    for(n = 0; n < t1.length; ++n){
                                        var u = r.find(t1[n][0]);
                                        c[u] < 0 ? (c[u] = l.length, l.push([
                                            t1[n].slice(0)
                                        ])) : l[c[u]].push(t1[n].slice(0));
                                    }
                                    return l;
                                }(t1, e1) : function(t1) {
                                    for(var e1 = l(s(h(t1, 0))), r = new i(e1.length), n = 0; n < t1.length; ++n)for(var a = t1[n], o = 0; o < a.length; ++o)for(var u = c(e1, [
                                        a[o]
                                    ]), f = o + 1; f < a.length; ++f)r.link(u, c(e1, [
                                        a[f]
                                    ]));
                                    var p = [], d = r.ranks;
                                    for(n = 0; n < d.length; ++n)d[n] = -1;
                                    for(n = 0; n < t1.length; ++n){
                                        var m = r.find(c(e1, [
                                            t1[n][0]
                                        ]));
                                        d[m] < 0 ? (d[m] = p.length, p.push([
                                            t1[n].slice(0)
                                        ])) : p[d[m]].push(t1[n].slice(0));
                                    }
                                    return p;
                                }(t1);
                            };
                        },
                        4623: function(t1) {
                            "use strict";
                            function e1(t1) {
                                this.roots = new Array(t1), this.ranks = new Array(t1);
                                for(var e1 = 0; e1 < t1; ++e1)this.roots[e1] = e1, this.ranks[e1] = 0;
                            }
                            t1.exports = e1, e1.prototype.length = function() {
                                return this.roots.length;
                            }, e1.prototype.makeSet = function() {
                                var t1 = this.roots.length;
                                return this.roots.push(t1), this.ranks.push(0), t1;
                            }, e1.prototype.find = function(t1) {
                                for(var e1 = this.roots; e1[t1] !== t1;){
                                    var r = e1[t1];
                                    e1[t1] = e1[r], t1 = r;
                                }
                                return t1;
                            }, e1.prototype.link = function(t1, e1) {
                                var r = this.find(t1), n = this.find(e1);
                                if (r !== n) {
                                    var i = this.ranks, a = this.roots, o = i[r], s = i[n];
                                    o < s ? a[r] = n : s < o ? a[n] = r : (a[n] = r, ++i[r]);
                                }
                            };
                        },
                        5878: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1, r) {
                                for(var a = e1.length, o = t1.length, s = new Array(a), l = new Array(a), c = new Array(a), u = new Array(a), h = 0; h < a; ++h)s[h] = l[h] = -1, c[h] = 1 / 0, u[h] = !1;
                                for(h = 0; h < o; ++h){
                                    var f = t1[h];
                                    if (2 !== f.length) throw new Error("Input must be a graph");
                                    var p = f[1], d = f[0];
                                    -1 !== l[d] ? l[d] = -2 : l[d] = p, -1 !== s[p] ? s[p] = -2 : s[p] = d;
                                }
                                function m(t1) {
                                    if (u[t1]) return 1 / 0;
                                    var r, i, a, o = s[t1], c = l[t1];
                                    return o < 0 || c < 0 ? 1 / 0 : (r = e1[t1], i = e1[o], a = e1[c], Math.abs(n(r, i, a)) / Math.sqrt(Math.pow(i[0] - a[0], 2) + Math.pow(i[1] - a[1], 2)));
                                }
                                function g(t1, e1) {
                                    var r = k[t1], n = k[e1];
                                    k[t1] = n, k[e1] = r, A[r] = e1, A[n] = t1;
                                }
                                function y(t1) {
                                    return c[k[t1]];
                                }
                                function v(t1) {
                                    return 1 & t1 ? t1 - 1 >> 1 : (t1 >> 1) - 1;
                                }
                                function x(t1) {
                                    for(var e1 = y(t1);;){
                                        var r = e1, n = 2 * t1 + 1, i = 2 * (t1 + 1), a = t1;
                                        if (n < M) {
                                            var o = y(n);
                                            o < r && (a = n, r = o);
                                        }
                                        if (i < M && y(i) < r && (a = i), a === t1) return t1;
                                        g(t1, a), t1 = a;
                                    }
                                }
                                function _(t1) {
                                    for(var e1 = y(t1); t1 > 0;){
                                        var r = v(t1);
                                        if (!(r >= 0 && e1 < y(r))) return t1;
                                        g(t1, r), t1 = r;
                                    }
                                }
                                function b() {
                                    if (M > 0) {
                                        var t1 = k[0];
                                        return g(0, M - 1), M -= 1, x(0), t1;
                                    }
                                    return -1;
                                }
                                function w(t1, e1) {
                                    var r = k[t1];
                                    return c[r] === e1 ? t1 : (c[r] = -1 / 0, _(t1), b(), c[r] = e1, _((M += 1) - 1));
                                }
                                function T(t1) {
                                    if (!u[t1]) {
                                        u[t1] = !0;
                                        var e1 = s[t1], r = l[t1];
                                        s[r] >= 0 && (s[r] = e1), l[e1] >= 0 && (l[e1] = r), A[e1] >= 0 && w(A[e1], m(e1)), A[r] >= 0 && w(A[r], m(r));
                                    }
                                }
                                var k = [], A = new Array(a);
                                for(h = 0; h < a; ++h)(c[h] = m(h)) < 1 / 0 ? (A[h] = k.length, k.push(h)) : A[h] = -1;
                                var M = k.length;
                                for(h = M >> 1; h >= 0; --h)x(h);
                                for(;;){
                                    var S = b();
                                    if (S < 0 || c[S] > r) break;
                                    T(S);
                                }
                                var E = [];
                                for(h = 0; h < a; ++h)u[h] || (A[h] = E.length, E.push(e1[h].slice()));
                                function C(t1, e1) {
                                    if (t1[e1] < 0) return e1;
                                    var r = e1, n = e1;
                                    do {
                                        var i = t1[n];
                                        if (!u[n] || i < 0 || i === n) break;
                                        if (i = t1[n = i], !u[n] || i < 0 || i === n) break;
                                        n = i, r = t1[r];
                                    }while (r !== n);
                                    for(var a = e1; a !== n; a = t1[a])t1[a] = n;
                                    return n;
                                }
                                E.length;
                                var L = [];
                                return t1.forEach(function(t1) {
                                    var e1 = C(s, t1[0]), r = C(l, t1[1]);
                                    if (e1 >= 0 && r >= 0 && e1 !== r) {
                                        var n = A[e1], i = A[r];
                                        n !== i && L.push([
                                            n,
                                            i
                                        ]);
                                    }
                                }), i.unique(i.normalize(L)), {
                                    positions: E,
                                    edges: L
                                };
                            };
                            var n = r(3250), i = r(2014);
                        },
                        1303: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1) {
                                var r, a, o, s;
                                if (e1[0][0] < e1[1][0]) r = e1[0], a = e1[1];
                                else {
                                    if (!(e1[0][0] > e1[1][0])) return i(e1, t1);
                                    r = e1[1], a = e1[0];
                                }
                                if (t1[0][0] < t1[1][0]) o = t1[0], s = t1[1];
                                else {
                                    if (!(t1[0][0] > t1[1][0])) return -i(t1, e1);
                                    o = t1[1], s = t1[0];
                                }
                                var l = n(r, a, s), c = n(r, a, o);
                                if (l < 0) {
                                    if (c <= 0) return l;
                                } else if (l > 0) {
                                    if (c >= 0) return l;
                                } else if (c) return c;
                                if (l = n(s, o, a), c = n(s, o, r), l < 0) {
                                    if (c <= 0) return l;
                                } else if (l > 0) {
                                    if (c >= 0) return l;
                                } else if (c) return c;
                                return a[0] - s[0];
                            };
                            var n = r(3250);
                            function i(t1, e1) {
                                var r, i, a, o;
                                if (e1[0][0] < e1[1][0]) r = e1[0], i = e1[1];
                                else {
                                    if (!(e1[0][0] > e1[1][0])) {
                                        var s = Math.min(t1[0][1], t1[1][1]), l = Math.max(t1[0][1], t1[1][1]), c = Math.min(e1[0][1], e1[1][1]), u = Math.max(e1[0][1], e1[1][1]);
                                        return l < c ? l - c : s > u ? s - u : l - u;
                                    }
                                    r = e1[1], i = e1[0];
                                }
                                t1[0][1] < t1[1][1] ? (a = t1[0], o = t1[1]) : (a = t1[1], o = t1[0]);
                                var h = n(i, r, a);
                                return h || (h = n(i, r, o)) || o - i;
                            }
                        },
                        4209: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1) {
                                for(var e1 = t1.length, r = 2 * e1, n = new Array(r), a = 0; a < e1; ++a){
                                    var l = t1[a], c = l[0][0] < l[1][0];
                                    n[2 * a] = new h(l[0][0], l, c, a), n[2 * a + 1] = new h(l[1][0], l, !c, a);
                                }
                                n.sort(function(t1, e1) {
                                    var r = t1.x - e1.x;
                                    return r || (r = t1.create - e1.create) || Math.min(t1.segment[0][1], t1.segment[1][1]) - Math.min(e1.segment[0][1], e1.segment[1][1]);
                                });
                                var f = i(o), p = [], d = [], m = [];
                                for(a = 0; a < r;){
                                    for(var g = n[a].x, y = []; a < r;){
                                        var v = n[a];
                                        if (v.x !== g) break;
                                        a += 1, v.segment[0][0] === v.x && v.segment[1][0] === v.x ? v.create && (v.segment[0][1] < v.segment[1][1] ? (y.push(new u(v.segment[0][1], v.index, !0, !0)), y.push(new u(v.segment[1][1], v.index, !1, !1))) : (y.push(new u(v.segment[1][1], v.index, !0, !1)), y.push(new u(v.segment[0][1], v.index, !1, !0)))) : f = v.create ? f.insert(v.segment, v.index) : f.remove(v.segment);
                                    }
                                    p.push(f.root), d.push(g), m.push(y);
                                }
                                return new s(p, d, m);
                            };
                            var n = r(2478), i = r(3840), a = r(3250), o = r(1303);
                            function s(t1, e1, r) {
                                this.slabs = t1, this.coordinates = e1, this.horizontal = r;
                            }
                            function l(t1, e1) {
                                return t1.y - e1;
                            }
                            function c(t1, e1) {
                                for(var r = null; t1;){
                                    var n, i, o = t1.key;
                                    o[0][0] < o[1][0] ? (n = o[0], i = o[1]) : (n = o[1], i = o[0]);
                                    var s = a(n, i, e1);
                                    if (s < 0) t1 = t1.left;
                                    else if (s > 0) {
                                        if (e1[0] !== o[1][0]) r = t1, t1 = t1.right;
                                        else {
                                            if (l = c(t1.right, e1)) return l;
                                            t1 = t1.left;
                                        }
                                    } else {
                                        if (e1[0] !== o[1][0]) return t1;
                                        var l;
                                        if (l = c(t1.right, e1)) return l;
                                        t1 = t1.left;
                                    }
                                }
                                return r;
                            }
                            function u(t1, e1, r, n) {
                                this.y = t1, this.index = e1, this.start = r, this.closed = n;
                            }
                            function h(t1, e1, r, n) {
                                this.x = t1, this.segment = e1, this.create = r, this.index = n;
                            }
                            s.prototype.castUp = function(t1) {
                                var e1 = n.le(this.coordinates, t1[0]);
                                if (e1 < 0) return -1;
                                this.slabs[e1];
                                var r = c(this.slabs[e1], t1), i = -1;
                                if (r && (i = r.value), this.coordinates[e1] === t1[0]) {
                                    var s = null;
                                    if (r && (s = r.key), e1 > 0) {
                                        var u = c(this.slabs[e1 - 1], t1);
                                        u && (s ? o(u.key, s) > 0 && (s = u.key, i = u.value) : (i = u.value, s = u.key));
                                    }
                                    var h = this.horizontal[e1];
                                    if (h.length > 0) {
                                        var f = n.ge(h, t1[1], l);
                                        if (f < h.length) {
                                            var p = h[f];
                                            if (t1[1] === p.y) {
                                                if (p.closed) return p.index;
                                                for(; f < h.length - 1 && h[f + 1].y === t1[1];)if ((p = h[f += 1]).closed) return p.index;
                                                if (p.y === t1[1] && !p.start) {
                                                    if ((f += 1) >= h.length) return i;
                                                    p = h[f];
                                                }
                                            }
                                            if (p.start) {
                                                if (s) {
                                                    var d = a(s[0], s[1], [
                                                        t1[0],
                                                        p.y
                                                    ]);
                                                    s[0][0] > s[1][0] && (d = -d), d > 0 && (i = p.index);
                                                } else i = p.index;
                                            } else p.y !== t1[1] && (i = p.index);
                                        }
                                    }
                                }
                                return i;
                            };
                        },
                        5202: function(t1, e1, r) {
                            "use strict";
                            var n = r(1944), i = r(8210);
                            function a(t1, e1) {
                                var r = i(n(t1, e1), [
                                    e1[e1.length - 1]
                                ]);
                                return r[r.length - 1];
                            }
                            function o(t1, e1, r, n) {
                                var i = -e1 / (n - e1);
                                i < 0 ? i = 0 : i > 1 && (i = 1);
                                for(var a = 1 - i, o = t1.length, s = new Array(o), l = 0; l < o; ++l)s[l] = i * t1[l] + a * r[l];
                                return s;
                            }
                            t1.exports = function(t1, e1) {
                                for(var r = [], n = [], i = a(t1[t1.length - 1], e1), s = t1[t1.length - 1], l = t1[0], c = 0; c < t1.length; ++c, s = l){
                                    var u = a(l = t1[c], e1);
                                    if (i < 0 && u > 0 || i > 0 && u < 0) {
                                        var h = o(s, u, l, i);
                                        r.push(h), n.push(h.slice());
                                    }
                                    u < 0 ? n.push(l.slice()) : u > 0 ? r.push(l.slice()) : (r.push(l.slice()), n.push(l.slice())), i = u;
                                }
                                return {
                                    positive: r,
                                    negative: n
                                };
                            }, t1.exports.positive = function(t1, e1) {
                                for(var r = [], n = a(t1[t1.length - 1], e1), i = t1[t1.length - 1], s = t1[0], l = 0; l < t1.length; ++l, i = s){
                                    var c = a(s = t1[l], e1);
                                    (n < 0 && c > 0 || n > 0 && c < 0) && r.push(o(i, c, s, n)), c >= 0 && r.push(s.slice()), n = c;
                                }
                                return r;
                            }, t1.exports.negative = function(t1, e1) {
                                for(var r = [], n = a(t1[t1.length - 1], e1), i = t1[t1.length - 1], s = t1[0], l = 0; l < t1.length; ++l, i = s){
                                    var c = a(s = t1[l], e1);
                                    (n < 0 && c > 0 || n > 0 && c < 0) && r.push(o(i, c, s, n)), c <= 0 && r.push(s.slice()), n = c;
                                }
                                return r;
                            };
                        },
                        3387: function(t1, e1, r) {
                            var n;
                            !function() {
                                "use strict";
                                var i = {
                                    not_string: /[^s]/,
                                    not_bool: /[^t]/,
                                    not_type: /[^T]/,
                                    not_primitive: /[^v]/,
                                    number: /[diefg]/,
                                    numeric_arg: /[bcdiefguxX]/,
                                    json: /[j]/,
                                    not_json: /[^j]/,
                                    text: /^[^\x25]+/,
                                    modulo: /^\x25{2}/,
                                    placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
                                    key: /^([a-z_][a-z_\d]*)/i,
                                    key_access: /^\.([a-z_][a-z_\d]*)/i,
                                    index_access: /^\[(\d+)\]/,
                                    sign: /^[+-]/
                                };
                                function a(t1) {
                                    return function(t1, e1) {
                                        var r, n, o, s, l, c, u, h, f, p = 1, d = t1.length, m = "";
                                        for(n = 0; n < d; n++)if ("string" == typeof t1[n]) m += t1[n];
                                        else if ("object" == typeof t1[n]) {
                                            if ((s = t1[n]).keys) for(r = e1[p], o = 0; o < s.keys.length; o++){
                                                if (null == r) throw new Error(a('[sprintf] Cannot access property "%s" of undefined value "%s"', s.keys[o], s.keys[o - 1]));
                                                r = r[s.keys[o]];
                                            }
                                            else r = s.param_no ? e1[s.param_no] : e1[p++];
                                            if (i.not_type.test(s.type) && i.not_primitive.test(s.type) && r instanceof Function && (r = r()), i.numeric_arg.test(s.type) && "number" != typeof r && isNaN(r)) throw new TypeError(a("[sprintf] expecting number but found %T", r));
                                            switch(i.number.test(s.type) && (h = r >= 0), s.type){
                                                case "b":
                                                    r = parseInt(r, 10).toString(2);
                                                    break;
                                                case "c":
                                                    r = String.fromCharCode(parseInt(r, 10));
                                                    break;
                                                case "d":
                                                case "i":
                                                    r = parseInt(r, 10);
                                                    break;
                                                case "j":
                                                    r = JSON.stringify(r, null, s.width ? parseInt(s.width) : 0);
                                                    break;
                                                case "e":
                                                    r = s.precision ? parseFloat(r).toExponential(s.precision) : parseFloat(r).toExponential();
                                                    break;
                                                case "f":
                                                    r = s.precision ? parseFloat(r).toFixed(s.precision) : parseFloat(r);
                                                    break;
                                                case "g":
                                                    r = s.precision ? String(Number(r.toPrecision(s.precision))) : parseFloat(r);
                                                    break;
                                                case "o":
                                                    r = (parseInt(r, 10) >>> 0).toString(8);
                                                    break;
                                                case "s":
                                                    r = String(r), r = s.precision ? r.substring(0, s.precision) : r;
                                                    break;
                                                case "t":
                                                    r = String(!!r), r = s.precision ? r.substring(0, s.precision) : r;
                                                    break;
                                                case "T":
                                                    r = Object.prototype.toString.call(r).slice(8, -1).toLowerCase(), r = s.precision ? r.substring(0, s.precision) : r;
                                                    break;
                                                case "u":
                                                    r = parseInt(r, 10) >>> 0;
                                                    break;
                                                case "v":
                                                    r = r.valueOf(), r = s.precision ? r.substring(0, s.precision) : r;
                                                    break;
                                                case "x":
                                                    r = (parseInt(r, 10) >>> 0).toString(16);
                                                    break;
                                                case "X":
                                                    r = (parseInt(r, 10) >>> 0).toString(16).toUpperCase();
                                            }
                                            i.json.test(s.type) ? m += r : (!i.number.test(s.type) || h && !s.sign ? f = "" : (f = h ? "+" : "-", r = r.toString().replace(i.sign, "")), c = s.pad_char ? "0" === s.pad_char ? "0" : s.pad_char.charAt(1) : " ", u = s.width - (f + r).length, l = s.width && u > 0 ? c.repeat(u) : "", m += s.align ? f + r + l : "0" === c ? f + l + r : l + f + r);
                                        }
                                        return m;
                                    }(function(t1) {
                                        if (s[t1]) return s[t1];
                                        for(var e1, r = t1, n = [], a = 0; r;){
                                            if (null !== (e1 = i.text.exec(r))) n.push(e1[0]);
                                            else if (null !== (e1 = i.modulo.exec(r))) n.push("%");
                                            else {
                                                if (null === (e1 = i.placeholder.exec(r))) throw new SyntaxError("[sprintf] unexpected placeholder");
                                                if (e1[2]) {
                                                    a |= 1;
                                                    var o = [], l = e1[2], c = [];
                                                    if (null === (c = i.key.exec(l))) throw new SyntaxError("[sprintf] failed to parse named argument key");
                                                    for(o.push(c[1]); "" !== (l = l.substring(c[0].length));)if (null !== (c = i.key_access.exec(l))) o.push(c[1]);
                                                    else {
                                                        if (null === (c = i.index_access.exec(l))) throw new SyntaxError("[sprintf] failed to parse named argument key");
                                                        o.push(c[1]);
                                                    }
                                                    e1[2] = o;
                                                } else a |= 2;
                                                if (3 === a) throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported");
                                                n.push({
                                                    placeholder: e1[0],
                                                    param_no: e1[1],
                                                    keys: e1[2],
                                                    sign: e1[3],
                                                    pad_char: e1[4],
                                                    align: e1[5],
                                                    width: e1[6],
                                                    precision: e1[7],
                                                    type: e1[8]
                                                });
                                            }
                                            r = r.substring(e1[0].length);
                                        }
                                        return s[t1] = n;
                                    }(t1), arguments);
                                }
                                function o(t1, e1) {
                                    return a.apply(null, [
                                        t1
                                    ].concat(e1 || []));
                                }
                                var s = Object.create(null);
                                e1.sprintf = a, e1.vsprintf = o, "undefined" != typeof window && (window.sprintf = a, window.vsprintf = o, void 0 === (n = (function() {
                                    return {
                                        sprintf: a,
                                        vsprintf: o
                                    };
                                }).call(e1, r, e1, t1)) || (t1.exports = n));
                            }();
                        },
                        3711: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1) {
                                if (t1.dimension <= 0) return {
                                    positions: [],
                                    cells: []
                                };
                                if (1 === t1.dimension) return function(t1, e1) {
                                    for(var r = i(t1, e1), n = r.length, a = new Array(n), o = new Array(n), s = 0; s < n; ++s)a[s] = [
                                        r[s]
                                    ], o[s] = [
                                        s
                                    ];
                                    return {
                                        positions: a,
                                        cells: o
                                    };
                                }(t1, e1);
                                var r = t1.order.join() + "-" + t1.dtype, s = o[r];
                                return e1 = +e1 || 0, s || (s = o[r] = function(t1, e1) {
                                    var r = t1.length + "d", i = a[r];
                                    if (i) return i(n, t1, e1);
                                }(t1.order, t1.dtype)), s(t1, e1);
                            };
                            var n = r(2640), i = r(781), a = {
                                "2d": function(t1, e1, r) {
                                    var n = t1({
                                        order: e1,
                                        scalarArguments: 3,
                                        getters: "generic" === r ? [
                                            0
                                        ] : void 0,
                                        phase: function(t1, e1, r, n) {
                                            return t1 > n | 0;
                                        },
                                        vertex: function(t1, e1, r, n, i, a, o, s, l, c, u, h, f) {
                                            var p = (o << 0) + (s << 1) + (l << 2) + (c << 3) | 0;
                                            if (0 !== p && 15 !== p) switch(p){
                                                case 0:
                                                case 15:
                                                    u.push([
                                                        t1 - .5,
                                                        e1 - .5
                                                    ]);
                                                    break;
                                                case 1:
                                                    u.push([
                                                        t1 - .25 - .25 * (n + r - 2 * f) / (r - n),
                                                        e1 - .25 - .25 * (i + r - 2 * f) / (r - i)
                                                    ]);
                                                    break;
                                                case 2:
                                                    u.push([
                                                        t1 - .75 - .25 * (-n - r + 2 * f) / (n - r),
                                                        e1 - .25 - .25 * (a + n - 2 * f) / (n - a)
                                                    ]);
                                                    break;
                                                case 3:
                                                    u.push([
                                                        t1 - .5,
                                                        e1 - .5 - .5 * (i + r + a + n - 4 * f) / (r - i + n - a)
                                                    ]);
                                                    break;
                                                case 4:
                                                    u.push([
                                                        t1 - .25 - .25 * (a + i - 2 * f) / (i - a),
                                                        e1 - .75 - .25 * (-i - r + 2 * f) / (i - r)
                                                    ]);
                                                    break;
                                                case 5:
                                                    u.push([
                                                        t1 - .5 - .5 * (n + r + a + i - 4 * f) / (r - n + i - a),
                                                        e1 - .5
                                                    ]);
                                                    break;
                                                case 6:
                                                    u.push([
                                                        t1 - .5 - .25 * (-n - r + a + i) / (n - r + i - a),
                                                        e1 - .5 - .25 * (-i - r + a + n) / (i - r + n - a)
                                                    ]);
                                                    break;
                                                case 7:
                                                    u.push([
                                                        t1 - .75 - .25 * (a + i - 2 * f) / (i - a),
                                                        e1 - .75 - .25 * (a + n - 2 * f) / (n - a)
                                                    ]);
                                                    break;
                                                case 8:
                                                    u.push([
                                                        t1 - .75 - .25 * (-a - i + 2 * f) / (a - i),
                                                        e1 - .75 - .25 * (-a - n + 2 * f) / (a - n)
                                                    ]);
                                                    break;
                                                case 9:
                                                    u.push([
                                                        t1 - .5 - .25 * (n + r + -a - i) / (r - n + a - i),
                                                        e1 - .5 - .25 * (i + r + -a - n) / (r - i + a - n)
                                                    ]);
                                                    break;
                                                case 10:
                                                    u.push([
                                                        t1 - .5 - .5 * (-n - r - a - i + 4 * f) / (n - r + a - i),
                                                        e1 - .5
                                                    ]);
                                                    break;
                                                case 11:
                                                    u.push([
                                                        t1 - .25 - .25 * (-a - i + 2 * f) / (a - i),
                                                        e1 - .75 - .25 * (i + r - 2 * f) / (r - i)
                                                    ]);
                                                    break;
                                                case 12:
                                                    u.push([
                                                        t1 - .5,
                                                        e1 - .5 - .5 * (-i - r - a - n + 4 * f) / (i - r + a - n)
                                                    ]);
                                                    break;
                                                case 13:
                                                    u.push([
                                                        t1 - .75 - .25 * (n + r - 2 * f) / (r - n),
                                                        e1 - .25 - .25 * (-a - n + 2 * f) / (a - n)
                                                    ]);
                                                    break;
                                                case 14:
                                                    u.push([
                                                        t1 - .25 - .25 * (-n - r + 2 * f) / (n - r),
                                                        e1 - .25 - .25 * (-i - r + 2 * f) / (i - r)
                                                    ]);
                                            }
                                        },
                                        cell: function(t1, e1, r, n, i, a, o, s, l) {
                                            i ? s.push([
                                                t1,
                                                e1
                                            ]) : s.push([
                                                e1,
                                                t1
                                            ]);
                                        }
                                    });
                                    return function(t1, e1) {
                                        var r = [], i = [];
                                        return n(t1, r, i, e1), {
                                            positions: r,
                                            cells: i
                                        };
                                    };
                                }
                            }, o = {};
                        },
                        529: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function t1(e1, r, i) {
                                var a = (i = i || {}).fontStyle || "normal", s = i.fontWeight || "normal", l = i.fontVariant || "normal", c = [
                                    a,
                                    s,
                                    l,
                                    e1
                                ].join("_"), u = o[c];
                                u || (u = o[c] = {
                                    " ": {
                                        data: new Float32Array(0),
                                        shape: .2
                                    }
                                });
                                var h = u[r];
                                if (!h) {
                                    if (r.length <= 1 || !/\d/.test(r)) h = u[r] = function(t1) {
                                        for(var e1 = t1.cells, r = t1.positions, n = new Float32Array(6 * e1.length), i = 0, a = 0, o = 0; o < e1.length; ++o)for(var s = e1[o], l = 0; l < 3; ++l){
                                            var c = r[s[l]];
                                            n[i++] = c[0], n[i++] = c[1] + 1.4, a = Math.max(c[0], a);
                                        }
                                        return {
                                            data: n,
                                            shape: a
                                        };
                                    }(n(r, {
                                        triangles: !0,
                                        font: e1,
                                        fontStyle: a,
                                        fontWeight: s,
                                        fontVariant: l,
                                        textAlign: i.textAlign || "left",
                                        textBaseline: "alphabetic",
                                        styletags: {
                                            breaklines: !0,
                                            bolds: !0,
                                            italics: !0,
                                            subscripts: !0,
                                            superscripts: !0
                                        }
                                    }));
                                    else {
                                        for(var f = r.split(/(\d|\s)/), p = new Array(f.length), d = 0, m = 0, g = 0; g < f.length; ++g)p[g] = t1(e1, f[g]), d += p[g].data.length, m += p[g].shape, g > 0 && (m += .02);
                                        var y = new Float32Array(d), v = 0, x = -0.5 * m;
                                        for(g = 0; g < p.length; ++g){
                                            for(var _ = p[g].data, b = 0; b < _.length; b += 2)y[v++] = _[b] + x, y[v++] = _[b + 1];
                                            x += p[g].shape + .02;
                                        }
                                        h = u[r] = {
                                            data: y,
                                            shape: m
                                        };
                                    }
                                }
                                return h;
                            };
                            var n = r(4359), a = window || i.global || {}, o = a.__TEXT_CACHE || {};
                            a.__TEXT_CACHE = {};
                        },
                        665: function(t1, e1, r) {
                            "use strict";
                            var n = r(3202);
                            t1.exports = o;
                            var i = 96;
                            function a(t1, e1) {
                                var r = n(getComputedStyle(t1).getPropertyValue(e1));
                                return r[0] * o(r[1], t1);
                            }
                            function o(t1, e1) {
                                switch(e1 = e1 || document.body, t1 = (t1 || "px").trim().toLowerCase(), e1 !== window && e1 !== document || (e1 = document.body), t1){
                                    case "%":
                                        return e1.clientHeight / 100;
                                    case "ch":
                                    case "ex":
                                        return function(t1, e1) {
                                            var r = document.createElement("div");
                                            r.style["font-size"] = "128" + t1, e1.appendChild(r);
                                            var n = a(r, "font-size") / 128;
                                            return e1.removeChild(r), n;
                                        }(t1, e1);
                                    case "em":
                                        return a(e1, "font-size");
                                    case "rem":
                                        return a(document.body, "font-size");
                                    case "vw":
                                        return window.innerWidth / 100;
                                    case "vh":
                                        return window.innerHeight / 100;
                                    case "vmin":
                                        return Math.min(window.innerWidth, window.innerHeight) / 100;
                                    case "vmax":
                                        return Math.max(window.innerWidth, window.innerHeight) / 100;
                                    case "in":
                                        return i;
                                    case "cm":
                                        return i / 2.54;
                                    case "mm":
                                        return i / 25.4;
                                    case "pt":
                                        return i / 72;
                                    case "pc":
                                        return i / 6;
                                }
                                return 1;
                            }
                        },
                        7261: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1) {
                                var e1 = (t1 = t1 || {}).center || [
                                    0,
                                    0,
                                    0
                                ], r = t1.up || [
                                    0,
                                    1,
                                    0
                                ], n = t1.right || h(r), i = t1.radius || 1, a = t1.theta || 0, u = t1.phi || 0;
                                if (e1 = [].slice.call(e1, 0, 3), r = [].slice.call(r, 0, 3), s(r, r), n = [].slice.call(n, 0, 3), s(n, n), "eye" in t1) {
                                    var p = t1.eye, d = [
                                        p[0] - e1[0],
                                        p[1] - e1[1],
                                        p[2] - e1[2]
                                    ];
                                    o(n, d, r), c(n[0], n[1], n[2]) < 1e-6 ? n = h(r) : s(n, n), i = c(d[0], d[1], d[2]);
                                    var m = l(r, d) / i, g = l(n, d) / i;
                                    u = Math.acos(m), a = Math.acos(g);
                                }
                                return i = Math.log(i), new f(t1.zoomMin, t1.zoomMax, e1, r, n, i, a, u);
                            };
                            var n = r(9215), i = r(7608), a = r(6079), o = r(5911), s = r(3536), l = r(244);
                            function c(t1, e1, r) {
                                return Math.sqrt(Math.pow(t1, 2) + Math.pow(e1, 2) + Math.pow(r, 2));
                            }
                            function u(t1) {
                                return Math.min(1, Math.max(-1, t1));
                            }
                            function h(t1) {
                                var e1 = Math.abs(t1[0]), r = Math.abs(t1[1]), n = Math.abs(t1[2]), i = [
                                    0,
                                    0,
                                    0
                                ];
                                e1 > Math.max(r, n) ? i[2] = 1 : r > Math.max(e1, n) ? i[0] = 1 : i[1] = 1;
                                for(var a = 0, o = 0, l = 0; l < 3; ++l)a += t1[l] * t1[l], o += i[l] * t1[l];
                                for(l = 0; l < 3; ++l)i[l] -= o / a * t1[l];
                                return s(i, i), i;
                            }
                            function f(t1, e1, r, i, a, o, s, l) {
                                this.center = n(r), this.up = n(i), this.right = n(a), this.radius = n([
                                    o
                                ]), this.angle = n([
                                    s,
                                    l
                                ]), this.angle.bounds = [
                                    [
                                        -1 / 0,
                                        -Math.PI / 2
                                    ],
                                    [
                                        1 / 0,
                                        Math.PI / 2
                                    ]
                                ], this.setDistanceLimits(t1, e1), this.computedCenter = this.center.curve(0), this.computedUp = this.up.curve(0), this.computedRight = this.right.curve(0), this.computedRadius = this.radius.curve(0), this.computedAngle = this.angle.curve(0), this.computedToward = [
                                    0,
                                    0,
                                    0
                                ], this.computedEye = [
                                    0,
                                    0,
                                    0
                                ], this.computedMatrix = new Array(16);
                                for(var c = 0; c < 16; ++c)this.computedMatrix[c] = .5;
                                this.recalcMatrix(0);
                            }
                            var p = f.prototype;
                            p.setDistanceLimits = function(t1, e1) {
                                t1 = t1 > 0 ? Math.log(t1) : -1 / 0, e1 = e1 > 0 ? Math.log(e1) : 1 / 0, e1 = Math.max(e1, t1), this.radius.bounds[0][0] = t1, this.radius.bounds[1][0] = e1;
                            }, p.getDistanceLimits = function(t1) {
                                var e1 = this.radius.bounds[0];
                                return t1 ? (t1[0] = Math.exp(e1[0][0]), t1[1] = Math.exp(e1[1][0]), t1) : [
                                    Math.exp(e1[0][0]),
                                    Math.exp(e1[1][0])
                                ];
                            }, p.recalcMatrix = function(t1) {
                                this.center.curve(t1), this.up.curve(t1), this.right.curve(t1), this.radius.curve(t1), this.angle.curve(t1);
                                for(var e1 = this.computedUp, r = this.computedRight, n = 0, i = 0, a = 0; a < 3; ++a)i += e1[a] * r[a], n += e1[a] * e1[a];
                                var l = Math.sqrt(n), u = 0;
                                for(a = 0; a < 3; ++a)r[a] -= e1[a] * i / n, u += r[a] * r[a], e1[a] /= l;
                                var h = Math.sqrt(u);
                                for(a = 0; a < 3; ++a)r[a] /= h;
                                var f = this.computedToward;
                                o(f, e1, r), s(f, f);
                                var p = Math.exp(this.computedRadius[0]), d = this.computedAngle[0], m = this.computedAngle[1], g = Math.cos(d), y = Math.sin(d), v = Math.cos(m), x = Math.sin(m), _ = this.computedCenter, b = g * v, w = y * v, T = x, k = -g * x, A = -y * x, M = v, S = this.computedEye, E = this.computedMatrix;
                                for(a = 0; a < 3; ++a){
                                    var C = b * r[a] + w * f[a] + T * e1[a];
                                    E[4 * a + 1] = k * r[a] + A * f[a] + M * e1[a], E[4 * a + 2] = C, E[4 * a + 3] = 0;
                                }
                                var L = E[1], I = E[5], P = E[9], z = E[2], O = E[6], D = E[10], R = I * D - P * O, F = P * z - L * D, B = L * O - I * z, N = c(R, F, B);
                                for(R /= N, F /= N, B /= N, E[0] = R, E[4] = F, E[8] = B, a = 0; a < 3; ++a)S[a] = _[a] + E[2 + 4 * a] * p;
                                for(a = 0; a < 3; ++a){
                                    u = 0;
                                    for(var j = 0; j < 3; ++j)u += E[a + 4 * j] * S[j];
                                    E[12 + a] = -u;
                                }
                                E[15] = 1;
                            }, p.getMatrix = function(t1, e1) {
                                this.recalcMatrix(t1);
                                var r = this.computedMatrix;
                                if (e1) {
                                    for(var n = 0; n < 16; ++n)e1[n] = r[n];
                                    return e1;
                                }
                                return r;
                            };
                            var d = [
                                0,
                                0,
                                0
                            ];
                            p.rotate = function(t1, e1, r, n) {
                                if (this.angle.move(t1, e1, r), n) {
                                    this.recalcMatrix(t1);
                                    var i = this.computedMatrix;
                                    d[0] = i[2], d[1] = i[6], d[2] = i[10];
                                    for(var o = this.computedUp, s = this.computedRight, l = this.computedToward, c = 0; c < 3; ++c)i[4 * c] = o[c], i[4 * c + 1] = s[c], i[4 * c + 2] = l[c];
                                    for(a(i, i, n, d), c = 0; c < 3; ++c)o[c] = i[4 * c], s[c] = i[4 * c + 1];
                                    this.up.set(t1, o[0], o[1], o[2]), this.right.set(t1, s[0], s[1], s[2]);
                                }
                            }, p.pan = function(t1, e1, r, n) {
                                e1 = e1 || 0, r = r || 0, n = n || 0, this.recalcMatrix(t1);
                                var i = this.computedMatrix, a = (Math.exp(this.computedRadius[0]), i[1]), o = i[5], s = i[9], l = c(a, o, s);
                                a /= l, o /= l, s /= l;
                                var u = i[0], h = i[4], f = i[8], p = u * a + h * o + f * s, d = c(u -= a * p, h -= o * p, f -= s * p), m = (u /= d) * e1 + a * r, g = (h /= d) * e1 + o * r, y = (f /= d) * e1 + s * r;
                                this.center.move(t1, m, g, y);
                                var v = Math.exp(this.computedRadius[0]);
                                v = Math.max(1e-4, v + n), this.radius.set(t1, Math.log(v));
                            }, p.translate = function(t1, e1, r, n) {
                                this.center.move(t1, e1 || 0, r || 0, n || 0);
                            }, p.setMatrix = function(t1, e1, r, n) {
                                var a = 1;
                                "number" == typeof r && (a = 0 | r), (a < 0 || a > 3) && (a = 1);
                                var o = (a + 2) % 3;
                                e1 || (this.recalcMatrix(t1), e1 = this.computedMatrix);
                                var s = e1[a], l = e1[a + 4], h = e1[a + 8];
                                if (n) {
                                    var f = Math.abs(s), p = Math.abs(l), d = Math.abs(h), m = Math.max(f, p, d);
                                    f === m ? (s = s < 0 ? -1 : 1, l = h = 0) : d === m ? (h = h < 0 ? -1 : 1, s = l = 0) : (l = l < 0 ? -1 : 1, s = h = 0);
                                } else {
                                    var g = c(s, l, h);
                                    s /= g, l /= g, h /= g;
                                }
                                var y, v, x = e1[o], _ = e1[o + 4], b = e1[o + 8], w = x * s + _ * l + b * h, T = c(x -= s * w, _ -= l * w, b -= h * w), k = l * (b /= T) - h * (_ /= T), A = h * (x /= T) - s * b, M = s * _ - l * x, S = c(k, A, M);
                                if (k /= S, A /= S, M /= S, this.center.jump(t1, H, G, Z), this.radius.idle(t1), this.up.jump(t1, s, l, h), this.right.jump(t1, x, _, b), 2 === a) {
                                    var E = e1[1], C = e1[5], L = e1[9], I = E * x + C * _ + L * b, P = E * k + C * A + L * M;
                                    y = R < 0 ? -Math.PI / 2 : Math.PI / 2, v = Math.atan2(P, I);
                                } else {
                                    var z = e1[2], O = e1[6], D = e1[10], R = z * s + O * l + D * h, F = z * x + O * _ + D * b, B = z * k + O * A + D * M;
                                    y = Math.asin(u(R)), v = Math.atan2(B, F);
                                }
                                this.angle.jump(t1, v, y), this.recalcMatrix(t1);
                                var N = e1[2], j = e1[6], U = e1[10], V = this.computedMatrix;
                                i(V, e1);
                                var q = V[15], H = V[12] / q, G = V[13] / q, Z = V[14] / q, W = Math.exp(this.computedRadius[0]);
                                this.center.jump(t1, H - N * W, G - j * W, Z - U * W);
                            }, p.lastT = function() {
                                return Math.max(this.center.lastT(), this.up.lastT(), this.right.lastT(), this.radius.lastT(), this.angle.lastT());
                            }, p.idle = function(t1) {
                                this.center.idle(t1), this.up.idle(t1), this.right.idle(t1), this.radius.idle(t1), this.angle.idle(t1);
                            }, p.flush = function(t1) {
                                this.center.flush(t1), this.up.flush(t1), this.right.flush(t1), this.radius.flush(t1), this.angle.flush(t1);
                            }, p.setDistance = function(t1, e1) {
                                e1 > 0 && this.radius.set(t1, Math.log(e1));
                            }, p.lookAt = function(t1, e1, r, n) {
                                this.recalcMatrix(t1), e1 = e1 || this.computedEye, r = r || this.computedCenter;
                                var i = (n = n || this.computedUp)[0], a = n[1], o = n[2], s = c(i, a, o);
                                if (!(s < 1e-6)) {
                                    i /= s, a /= s, o /= s;
                                    var l = e1[0] - r[0], h = e1[1] - r[1], f = e1[2] - r[2], p = c(l, h, f);
                                    if (!(p < 1e-6)) {
                                        l /= p, h /= p, f /= p;
                                        var d = this.computedRight, m = d[0], g = d[1], y = d[2], v = i * m + a * g + o * y, x = c(m -= v * i, g -= v * a, y -= v * o);
                                        if (!(x < .01 && (x = c(m = a * f - o * h, g = o * l - i * f, y = i * h - a * l)) < 1e-6)) {
                                            m /= x, g /= x, y /= x, this.up.set(t1, i, a, o), this.right.set(t1, m, g, y), this.center.set(t1, r[0], r[1], r[2]), this.radius.set(t1, Math.log(p));
                                            var _ = a * y - o * g, b = o * m - i * y, w = i * g - a * m, T = c(_, b, w), k = i * l + a * h + o * f, A = m * l + g * h + y * f, M = (_ /= T) * l + (b /= T) * h + (w /= T) * f, S = Math.asin(u(k)), E = Math.atan2(M, A), C = this.angle._state, L = C[C.length - 1], I = C[C.length - 2];
                                            L %= 2 * Math.PI;
                                            var P = Math.abs(L + 2 * Math.PI - E), z = Math.abs(L - E), O = Math.abs(L - 2 * Math.PI - E);
                                            P < z && (L += 2 * Math.PI), O < z && (L -= 2 * Math.PI), this.angle.jump(this.angle.lastT(), L, I), this.angle.set(t1, E, S);
                                        }
                                    }
                                }
                            };
                        },
                        5250: function(t1) {
                            "use strict";
                            t1.exports = function(t1, r, n) {
                                var i = t1 * r, a = e1 * t1, o = a - (a - t1), s = t1 - o, l = e1 * r, c = l - (l - r), u = r - c, h = s * u - (i - o * c - s * c - o * u);
                                return n ? (n[0] = h, n[1] = i, n) : [
                                    h,
                                    i
                                ];
                            };
                            var e1 = +(Math.pow(2, 27) + 1);
                        },
                        9362: function(t1) {
                            "use strict";
                            t1.exports = function(t1, e1, r) {
                                var n = t1 + e1, i = n - t1, a = e1 - i, o = t1 - (n - i);
                                return r ? (r[0] = o + a, r[1] = n, r) : [
                                    o + a,
                                    n
                                ];
                            };
                        },
                        1888: function(t1, e1, r) {
                            "use strict";
                            var n = r(8828), i = r(1338), a = r(4793).hp;
                            r.g.__TYPEDARRAY_POOL || (r.g.__TYPEDARRAY_POOL = {
                                UINT8: i([
                                    32,
                                    0
                                ]),
                                UINT16: i([
                                    32,
                                    0
                                ]),
                                UINT32: i([
                                    32,
                                    0
                                ]),
                                BIGUINT64: i([
                                    32,
                                    0
                                ]),
                                INT8: i([
                                    32,
                                    0
                                ]),
                                INT16: i([
                                    32,
                                    0
                                ]),
                                INT32: i([
                                    32,
                                    0
                                ]),
                                BIGINT64: i([
                                    32,
                                    0
                                ]),
                                FLOAT: i([
                                    32,
                                    0
                                ]),
                                DOUBLE: i([
                                    32,
                                    0
                                ]),
                                DATA: i([
                                    32,
                                    0
                                ]),
                                UINT8C: i([
                                    32,
                                    0
                                ]),
                                BUFFER: i([
                                    32,
                                    0
                                ])
                            });
                            var o = "undefined" != typeof Uint8ClampedArray, s = "undefined" != typeof BigUint64Array, l = "undefined" != typeof BigInt64Array, c = r.g.__TYPEDARRAY_POOL;
                            c.UINT8C || (c.UINT8C = i([
                                32,
                                0
                            ])), c.BIGUINT64 || (c.BIGUINT64 = i([
                                32,
                                0
                            ])), c.BIGINT64 || (c.BIGINT64 = i([
                                32,
                                0
                            ])), c.BUFFER || (c.BUFFER = i([
                                32,
                                0
                            ]));
                            var u = c.DATA, h = c.BUFFER;
                            function f(t1) {
                                if (t1) {
                                    var e1 = t1.length || t1.byteLength, r = n.log2(e1);
                                    u[r].push(t1);
                                }
                            }
                            function p(t1) {
                                t1 = n.nextPow2(t1);
                                var e1 = n.log2(t1), r = u[e1];
                                return r.length > 0 ? r.pop() : new ArrayBuffer(t1);
                            }
                            function d(t1) {
                                return new Uint8Array(p(t1), 0, t1);
                            }
                            function m(t1) {
                                return new Uint16Array(p(2 * t1), 0, t1);
                            }
                            function g(t1) {
                                return new Uint32Array(p(4 * t1), 0, t1);
                            }
                            function y(t1) {
                                return new Int8Array(p(t1), 0, t1);
                            }
                            function v(t1) {
                                return new Int16Array(p(2 * t1), 0, t1);
                            }
                            function x(t1) {
                                return new Int32Array(p(4 * t1), 0, t1);
                            }
                            function _(t1) {
                                return new Float32Array(p(4 * t1), 0, t1);
                            }
                            function b(t1) {
                                return new Float64Array(p(8 * t1), 0, t1);
                            }
                            function w(t1) {
                                return o ? new Uint8ClampedArray(p(t1), 0, t1) : d(t1);
                            }
                            function T(t1) {
                                return s ? new BigUint64Array(p(8 * t1), 0, t1) : null;
                            }
                            function k(t1) {
                                return l ? new BigInt64Array(p(8 * t1), 0, t1) : null;
                            }
                            function A(t1) {
                                return new DataView(p(t1), 0, t1);
                            }
                            function M(t1) {
                                t1 = n.nextPow2(t1);
                                var e1 = n.log2(t1), r = h[e1];
                                return r.length > 0 ? r.pop() : new a(t1);
                            }
                            e1.free = function(t1) {
                                if (a.isBuffer(t1)) h[n.log2(t1.length)].push(t1);
                                else {
                                    if ("[object ArrayBuffer]" !== Object.prototype.toString.call(t1) && (t1 = t1.buffer), !t1) return;
                                    var e1 = t1.length || t1.byteLength, r = 0 | n.log2(e1);
                                    u[r].push(t1);
                                }
                            }, e1.freeUint8 = e1.freeUint16 = e1.freeUint32 = e1.freeBigUint64 = e1.freeInt8 = e1.freeInt16 = e1.freeInt32 = e1.freeBigInt64 = e1.freeFloat32 = e1.freeFloat = e1.freeFloat64 = e1.freeDouble = e1.freeUint8Clamped = e1.freeDataView = function(t1) {
                                f(t1.buffer);
                            }, e1.freeArrayBuffer = f, e1.freeBuffer = function(t1) {
                                h[n.log2(t1.length)].push(t1);
                            }, e1.malloc = function(t1, e1) {
                                if (void 0 === e1 || "arraybuffer" === e1) return p(t1);
                                switch(e1){
                                    case "uint8":
                                        return d(t1);
                                    case "uint16":
                                        return m(t1);
                                    case "uint32":
                                        return g(t1);
                                    case "int8":
                                        return y(t1);
                                    case "int16":
                                        return v(t1);
                                    case "int32":
                                        return x(t1);
                                    case "float":
                                    case "float32":
                                        return _(t1);
                                    case "double":
                                    case "float64":
                                        return b(t1);
                                    case "uint8_clamped":
                                        return w(t1);
                                    case "bigint64":
                                        return k(t1);
                                    case "biguint64":
                                        return T(t1);
                                    case "buffer":
                                        return M(t1);
                                    case "data":
                                    case "dataview":
                                        return A(t1);
                                    default:
                                        return null;
                                }
                                return null;
                            }, e1.mallocArrayBuffer = p, e1.mallocUint8 = d, e1.mallocUint16 = m, e1.mallocUint32 = g, e1.mallocInt8 = y, e1.mallocInt16 = v, e1.mallocInt32 = x, e1.mallocFloat32 = e1.mallocFloat = _, e1.mallocFloat64 = e1.mallocDouble = b, e1.mallocUint8Clamped = w, e1.mallocBigUint64 = T, e1.mallocBigInt64 = k, e1.mallocDataView = A, e1.mallocBuffer = M, e1.clearCache = function() {
                                for(var t1 = 0; t1 < 32; ++t1)c.UINT8[t1].length = 0, c.UINT16[t1].length = 0, c.UINT32[t1].length = 0, c.INT8[t1].length = 0, c.INT16[t1].length = 0, c.INT32[t1].length = 0, c.FLOAT[t1].length = 0, c.DOUBLE[t1].length = 0, c.BIGUINT64[t1].length = 0, c.BIGINT64[t1].length = 0, c.UINT8C[t1].length = 0, u[t1].length = 0, h[t1].length = 0;
                            };
                        },
                        1755: function(t1) {
                            "use strict";
                            function e1(t1) {
                                this.roots = new Array(t1), this.ranks = new Array(t1);
                                for(var e1 = 0; e1 < t1; ++e1)this.roots[e1] = e1, this.ranks[e1] = 0;
                            }
                            t1.exports = e1;
                            var r = e1.prototype;
                            Object.defineProperty(r, "length", {
                                get: function() {
                                    return this.roots.length;
                                }
                            }), r.makeSet = function() {
                                var t1 = this.roots.length;
                                return this.roots.push(t1), this.ranks.push(0), t1;
                            }, r.find = function(t1) {
                                for(var e1 = t1, r = this.roots; r[t1] !== t1;)t1 = r[t1];
                                for(; r[e1] !== t1;){
                                    var n = r[e1];
                                    r[e1] = t1, e1 = n;
                                }
                                return t1;
                            }, r.link = function(t1, e1) {
                                var r = this.find(t1), n = this.find(e1);
                                if (r !== n) {
                                    var i = this.ranks, a = this.roots, o = i[r], s = i[n];
                                    o < s ? a[r] = n : s < o ? a[n] = r : (a[n] = r, ++i[r]);
                                }
                            };
                        },
                        1682: function(t1) {
                            "use strict";
                            t1.exports = function(t1, e1, r) {
                                return 0 === t1.length ? t1 : e1 ? (r || t1.sort(e1), function(t1, e1) {
                                    for(var r = 1, n = t1.length, i = t1[0], a = t1[0], o = 1; o < n; ++o)if (a = i, e1(i = t1[o], a)) {
                                        if (o === r) {
                                            r++;
                                            continue;
                                        }
                                        t1[r++] = i;
                                    }
                                    return t1.length = r, t1;
                                }(t1, e1)) : (r || t1.sort(), function(t1) {
                                    for(var e1 = 1, r = t1.length, n = t1[0], i = t1[0], a = 1; a < r; ++a, i = n)if (i = n, (n = t1[a]) !== i) {
                                        if (a === e1) {
                                            e1++;
                                            continue;
                                        }
                                        t1[e1++] = n;
                                    }
                                    return t1.length = e1, t1;
                                }(t1));
                            };
                        },
                        4359: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1) {
                                return "object" == typeof e1 && null !== e1 || (e1 = {}), n(t1, e1.canvas || i, e1.context || a, e1);
                            };
                            var n = r(7718), i = null, a = null;
                            "undefined" != typeof document && ((i = document.createElement("canvas")).width = 8192, i.height = 1024, a = i.getContext("2d"));
                        },
                        7718: function(t1, e1, r) {
                            t1.exports = function(t1, e1, r, n) {
                                var a = 64, o = 1.25, s = {
                                    breaklines: !1,
                                    bolds: !1,
                                    italics: !1,
                                    subscripts: !1,
                                    superscripts: !1
                                };
                                return n && (n.size && n.size > 0 && (a = n.size), n.lineSpacing && n.lineSpacing > 0 && (o = n.lineSpacing), n.styletags && n.styletags.breaklines && (s.breaklines = !!n.styletags.breaklines), n.styletags && n.styletags.bolds && (s.bolds = !!n.styletags.bolds), n.styletags && n.styletags.italics && (s.italics = !!n.styletags.italics), n.styletags && n.styletags.subscripts && (s.subscripts = !!n.styletags.subscripts), n.styletags && n.styletags.superscripts && (s.superscripts = !!n.styletags.superscripts)), r.font = [
                                    n.fontStyle,
                                    n.fontVariant,
                                    n.fontWeight,
                                    a + "px",
                                    n.font
                                ].filter(function(t1) {
                                    return t1;
                                }).join(" "), r.textAlign = "start", r.textBaseline = "alphabetic", r.direction = "ltr", w(function(t1, e1, r, n, a, o) {
                                    r = r.replace(/\n/g, ""), r = !0 === o.breaklines ? r.replace(/\<br\>/g, "\n") : r.replace(/\<br\>/g, " ");
                                    var s = "", l = [];
                                    for(T = 0; T < r.length; ++T)l[T] = s;
                                    !0 === o.bolds && (l = x(c, u, r, l)), !0 === o.italics && (l = x(h, f, r, l)), !0 === o.superscripts && (l = x(p, m, r, l)), !0 === o.subscripts && (l = x(g, v, r, l));
                                    var _ = [], b = "";
                                    for(T = 0; T < r.length; ++T)null !== l[T] && (b += r[T], _.push(l[T]));
                                    var w, T, k, A, M, S = b.split("\n"), E = S.length, C = Math.round(a * n), L = n, I = 2 * n, P = 0, z = E * C + I;
                                    t1.height < z && (t1.height = z), e1.fillStyle = "#000", e1.fillRect(0, 0, t1.width, t1.height), e1.fillStyle = "#fff";
                                    var O = 0, D = "";
                                    function R() {
                                        if ("" !== D) {
                                            var t1 = e1.measureText(D).width;
                                            e1.fillText(D, L + k, I + A), k += t1;
                                        }
                                    }
                                    function F() {
                                        return Math.round(M) + "px ";
                                    }
                                    function B(t1, r) {
                                        var n = "" + e1.font;
                                        if (!0 === o.subscripts) {
                                            var i = t1.indexOf(y), a = r.indexOf(y), s = i > -1 ? parseInt(t1[1 + i]) : 0, l = a > -1 ? parseInt(r[1 + a]) : 0;
                                            s !== l && (n = n.replace(F(), "?px "), M *= Math.pow(.75, l - s), n = n.replace("?px ", F())), A += .25 * C * (l - s);
                                        }
                                        if (!0 === o.superscripts) {
                                            var c = t1.indexOf(d), h = r.indexOf(d), p = c > -1 ? parseInt(t1[1 + c]) : 0, m = h > -1 ? parseInt(r[1 + h]) : 0;
                                            p !== m && (n = n.replace(F(), "?px "), M *= Math.pow(.75, m - p), n = n.replace("?px ", F())), A -= .25 * C * (m - p);
                                        }
                                        if (!0 === o.bolds) {
                                            var g = t1.indexOf(u) > -1, v = r.indexOf(u) > -1;
                                            !g && v && (n = x ? n.replace("italic ", "italic bold ") : "bold " + n), g && !v && (n = n.replace("bold ", ""));
                                        }
                                        if (!0 === o.italics) {
                                            var x = t1.indexOf(f) > -1, _ = r.indexOf(f) > -1;
                                            !x && _ && (n = "italic " + n), x && !_ && (n = n.replace("italic ", ""));
                                        }
                                        e1.font = n;
                                    }
                                    for(w = 0; w < E; ++w){
                                        var N = S[w] + "\n";
                                        for(k = 0, A = w * C, M = n, D = "", T = 0; T < N.length; ++T){
                                            var j = T + O < _.length ? _[T + O] : _[_.length - 1];
                                            s === j ? D += N[T] : (R(), D = N[T], void 0 !== j && (B(s, j), s = j));
                                        }
                                        R(), O += N.length;
                                        var U = 0 | Math.round(k + 2 * L);
                                        P < U && (P = U);
                                    }
                                    var V = P, q = I + C * E;
                                    return i(e1.getImageData(0, 0, V, q).data, [
                                        q,
                                        V,
                                        4
                                    ]).pick(-1, -1, 0).transpose(1, 0);
                                }(e1, r, t1, a, o, s), n, a);
                            }, t1.exports.processPixels = w;
                            var n = r(3711), i = r(9618), a = r(5878), o = r(332), s = r(2538), l = r(2095), c = "b", u = "b|", h = "i", f = "i|", p = "sup", d = "+", m = "+1", g = "sub", y = "-", v = "-1";
                            function x(t1, e1, r, n) {
                                for(var i = "<" + t1 + ">", a = "</" + t1 + ">", o = i.length, s = a.length, l = e1[0] === d || e1[0] === y, c = 0, u = -s; c > -1 && -1 !== (c = r.indexOf(i, c)) && -1 !== (u = r.indexOf(a, c + o)) && !(u <= c);){
                                    for(var h = c; h < u + s; ++h)if (h < c + o || h >= u) n[h] = null, r = r.substr(0, h) + " " + r.substr(h + 1);
                                    else if (null !== n[h]) {
                                        var f = n[h].indexOf(e1[0]);
                                        -1 === f ? n[h] += e1 : l && (n[h] = n[h].substr(0, f + 1) + (1 + parseInt(n[h][f + 1])) + n[h].substr(f + 2));
                                    }
                                    var p = c + o, m = r.substr(p, u - p).indexOf(i);
                                    c = -1 !== m ? m : u + s;
                                }
                                return n;
                            }
                            function _(t1, e1) {
                                var r = n(t1, 128);
                                return e1 ? a(r.cells, r.positions, .25) : {
                                    edges: r.cells,
                                    positions: r.positions
                                };
                            }
                            function b(t1, e1, r, n) {
                                var i = _(t1, n), a = function(t1, e1, r) {
                                    for(var n = e1.textAlign || "start", i = e1.textBaseline || "alphabetic", a = [
                                        1073741824,
                                        1073741824
                                    ], o = [
                                        0,
                                        0
                                    ], s = t1.length, l = 0; l < s; ++l)for(var c = t1[l], u = 0; u < 2; ++u)a[u] = 0 | Math.min(a[u], c[u]), o[u] = 0 | Math.max(o[u], c[u]);
                                    var h = 0;
                                    switch(n){
                                        case "center":
                                            h = -0.5 * (a[0] + o[0]);
                                            break;
                                        case "right":
                                        case "end":
                                            h = -o[0];
                                            break;
                                        case "left":
                                        case "start":
                                            h = -a[0];
                                            break;
                                        default:
                                            throw new Error("vectorize-text: Unrecognized textAlign: '" + n + "'");
                                    }
                                    var f = 0;
                                    switch(i){
                                        case "hanging":
                                        case "top":
                                            f = -a[1];
                                            break;
                                        case "middle":
                                            f = -0.5 * (a[1] + o[1]);
                                            break;
                                        case "alphabetic":
                                        case "ideographic":
                                            f = -3 * r;
                                            break;
                                        case "bottom":
                                            f = -o[1];
                                            break;
                                        default:
                                            throw new Error("vectorize-text: Unrecoginized textBaseline: '" + i + "'");
                                    }
                                    var p = 1 / r;
                                    return "lineHeight" in e1 ? p *= +e1.lineHeight : "width" in e1 ? p = e1.width / (o[0] - a[0]) : "height" in e1 && (p = e1.height / (o[1] - a[1])), t1.map(function(t1) {
                                        return [
                                            p * (t1[0] + h),
                                            p * (t1[1] + f)
                                        ];
                                    });
                                }(i.positions, e1, r), c = i.edges, u = "ccw" === e1.orientation;
                                if (o(a, c), e1.polygons || e1.polygon || e1.polyline) {
                                    for(var h = l(c, a), f = new Array(h.length), p = 0; p < h.length; ++p){
                                        for(var d = h[p], m = new Array(d.length), g = 0; g < d.length; ++g){
                                            for(var y = d[g], v = new Array(y.length), x = 0; x < y.length; ++x)v[x] = a[y[x]].slice();
                                            u && v.reverse(), m[g] = v;
                                        }
                                        f[p] = m;
                                    }
                                    return f;
                                }
                                return e1.triangles || e1.triangulate || e1.triangle ? {
                                    cells: s(a, c, {
                                        delaunay: !1,
                                        exterior: !1,
                                        interior: !0
                                    }),
                                    positions: a
                                } : {
                                    edges: c,
                                    positions: a
                                };
                            }
                            function w(t1, e1, r) {
                                try {
                                    return b(t1, e1, r, !0);
                                } catch (t1) {}
                                try {
                                    return b(t1, e1, r, !1);
                                } catch (t1) {}
                                return e1.polygons || e1.polyline || e1.polygon ? [] : e1.triangles || e1.triangulate || e1.triangle ? {
                                    cells: [],
                                    positions: []
                                } : {
                                    edges: [],
                                    positions: []
                                };
                            }
                        },
                        1538: function(t1) {
                            !function() {
                                "use strict";
                                if ("undefined" == typeof ses || !ses.ok || ses.ok()) {
                                    "undefined" != typeof ses && (ses.weakMapPermitHostObjects = g);
                                    var e1 = !1;
                                    if ("function" == typeof WeakMap) {
                                        var r = WeakMap;
                                        if ("undefined" != typeof navigator && /Firefox/.test(navigator.userAgent)) ;
                                        else {
                                            var n = new r, i = Object.freeze({});
                                            if (n.set(i, 1), 1 === n.get(i)) return void (t1.exports = WeakMap);
                                            e1 = !0;
                                        }
                                    }
                                    Object.prototype.hasOwnProperty;
                                    var a = Object.getOwnPropertyNames, o = Object.defineProperty, s = Object.isExtensible, l = "weakmap:", c = l + "ident:" + Math.random() + "___";
                                    if ("undefined" != typeof crypto && "function" == typeof crypto.getRandomValues && "function" == typeof ArrayBuffer && "function" == typeof Uint8Array) {
                                        var u = new ArrayBuffer(25), h = new Uint8Array(u);
                                        crypto.getRandomValues(h), c = l + "rand:" + Array.prototype.map.call(h, function(t1) {
                                            return (t1 % 36).toString(36);
                                        }).join("") + "___";
                                    }
                                    if (o(Object, "getOwnPropertyNames", {
                                        value: function(t1) {
                                            return a(t1).filter(y);
                                        }
                                    }), "getPropertyNames" in Object) {
                                        var f = Object.getPropertyNames;
                                        o(Object, "getPropertyNames", {
                                            value: function(t1) {
                                                return f(t1).filter(y);
                                            }
                                        });
                                    }
                                    !function() {
                                        var t1 = Object.freeze;
                                        o(Object, "freeze", {
                                            value: function(e1) {
                                                return v(e1), t1(e1);
                                            }
                                        });
                                        var e1 = Object.seal;
                                        o(Object, "seal", {
                                            value: function(t1) {
                                                return v(t1), e1(t1);
                                            }
                                        });
                                        var r = Object.preventExtensions;
                                        o(Object, "preventExtensions", {
                                            value: function(t1) {
                                                return v(t1), r(t1);
                                            }
                                        });
                                    }();
                                    var p = !1, d = 0, m = function() {
                                        this instanceof m || _();
                                        var t1 = [], e1 = [], r = d++;
                                        return Object.create(m.prototype, {
                                            get___: {
                                                value: x(function(n, i) {
                                                    var a, o = v(n);
                                                    return o ? r in o ? o[r] : i : (a = t1.indexOf(n)) >= 0 ? e1[a] : i;
                                                })
                                            },
                                            has___: {
                                                value: x(function(e1) {
                                                    var n = v(e1);
                                                    return n ? r in n : t1.indexOf(e1) >= 0;
                                                })
                                            },
                                            set___: {
                                                value: x(function(n, i) {
                                                    var a, o = v(n);
                                                    return o ? o[r] = i : (a = t1.indexOf(n)) >= 0 ? e1[a] = i : (a = t1.length, e1[a] = i, t1[a] = n), this;
                                                })
                                            },
                                            delete___: {
                                                value: x(function(n) {
                                                    var i, a, o = v(n);
                                                    return o ? r in o && delete o[r] : !((i = t1.indexOf(n)) < 0 || (a = t1.length - 1, t1[i] = void 0, e1[i] = e1[a], t1[i] = t1[a], t1.length = a, e1.length = a, 0));
                                                })
                                            }
                                        });
                                    };
                                    m.prototype = Object.create(Object.prototype, {
                                        get: {
                                            value: function(t1, e1) {
                                                return this.get___(t1, e1);
                                            },
                                            writable: !0,
                                            configurable: !0
                                        },
                                        has: {
                                            value: function(t1) {
                                                return this.has___(t1);
                                            },
                                            writable: !0,
                                            configurable: !0
                                        },
                                        set: {
                                            value: function(t1, e1) {
                                                return this.set___(t1, e1);
                                            },
                                            writable: !0,
                                            configurable: !0
                                        },
                                        delete: {
                                            value: function(t1) {
                                                return this.delete___(t1);
                                            },
                                            writable: !0,
                                            configurable: !0
                                        }
                                    }), "function" == typeof r ? function() {
                                        function n() {
                                            this instanceof m || _();
                                            var t1, n = new r, i = void 0, a = !1;
                                            return t1 = e1 ? function(t1, e1) {
                                                return n.set(t1, e1), n.has(t1) || (i || (i = new m), i.set(t1, e1)), this;
                                            } : function(t1, e1) {
                                                if (a) try {
                                                    n.set(t1, e1);
                                                } catch (r) {
                                                    i || (i = new m), i.set___(t1, e1);
                                                }
                                                else n.set(t1, e1);
                                                return this;
                                            }, Object.create(m.prototype, {
                                                get___: {
                                                    value: x(function(t1, e1) {
                                                        return i ? n.has(t1) ? n.get(t1) : i.get___(t1, e1) : n.get(t1, e1);
                                                    })
                                                },
                                                has___: {
                                                    value: x(function(t1) {
                                                        return n.has(t1) || !!i && i.has___(t1);
                                                    })
                                                },
                                                set___: {
                                                    value: x(t1)
                                                },
                                                delete___: {
                                                    value: x(function(t1) {
                                                        var e1 = !!n.delete(t1);
                                                        return i && i.delete___(t1) || e1;
                                                    })
                                                },
                                                permitHostObjects___: {
                                                    value: x(function(t1) {
                                                        if (t1 !== g) throw new Error("bogus call to permitHostObjects___");
                                                        a = !0;
                                                    })
                                                }
                                            });
                                        }
                                        e1 && "undefined" != typeof Proxy && (Proxy = void 0), n.prototype = m.prototype, t1.exports = n, Object.defineProperty(WeakMap.prototype, "constructor", {
                                            value: WeakMap,
                                            enumerable: !1,
                                            configurable: !0,
                                            writable: !0
                                        });
                                    }() : ("undefined" != typeof Proxy && (Proxy = void 0), t1.exports = m);
                                }
                                function g(t1) {
                                    t1.permitHostObjects___ && t1.permitHostObjects___(g);
                                }
                                function y(t1) {
                                    return !(t1.substr(0, 8) == l && "___" === t1.substr(t1.length - 3));
                                }
                                function v(t1) {
                                    if (t1 !== Object(t1)) throw new TypeError("Not an object: " + t1);
                                    var e1 = t1[c];
                                    if (e1 && e1.key === t1) return e1;
                                    if (s(t1)) {
                                        e1 = {
                                            key: t1
                                        };
                                        try {
                                            return o(t1, c, {
                                                value: e1,
                                                writable: !1,
                                                enumerable: !1,
                                                configurable: !1
                                            }), e1;
                                        } catch (t1) {
                                            return;
                                        }
                                    }
                                }
                                function x(t1) {
                                    return t1.prototype = null, Object.freeze(t1);
                                }
                                function _() {
                                    p || "undefined" == typeof console || (p = !0, console.warn("WeakMap should be invoked as new WeakMap(), not WeakMap(). This will be an error in the future."));
                                }
                            }();
                        },
                        236: function(t1, e1, r) {
                            var n = r(8284);
                            t1.exports = function() {
                                var t1 = {};
                                return function(e1) {
                                    if (("object" != typeof e1 || null === e1) && "function" != typeof e1) throw new Error("Weakmap-shim: Key must be object");
                                    var r = e1.valueOf(t1);
                                    return r && r.identity === t1 ? r : n(e1, t1);
                                };
                            };
                        },
                        8284: function(t1) {
                            t1.exports = function(t1, e1) {
                                var r = {
                                    identity: e1
                                }, n = t1.valueOf;
                                return Object.defineProperty(t1, "valueOf", {
                                    value: function(t1) {
                                        return t1 !== e1 ? n.apply(this, arguments) : r;
                                    },
                                    writable: !0
                                }), r;
                            };
                        },
                        606: function(t1, e1, r) {
                            var n = r(236);
                            t1.exports = function() {
                                var t1 = n();
                                return {
                                    get: function(e1, r) {
                                        var n = t1(e1);
                                        return n.hasOwnProperty("value") ? n.value : r;
                                    },
                                    set: function(e1, r) {
                                        return t1(e1).value = r, this;
                                    },
                                    has: function(e1) {
                                        return "value" in t1(e1);
                                    },
                                    delete: function(e1) {
                                        return delete t1(e1).value;
                                    }
                                };
                            };
                        },
                        3349: function(t1) {
                            "use strict";
                            t1.exports = function(t1) {
                                var e1 = {};
                                return function(r, n, i) {
                                    var a = r.dtype, o = r.order, s = [
                                        a,
                                        o.join()
                                    ].join(), l = e1[s];
                                    return l || (e1[s] = l = t1([
                                        a,
                                        o
                                    ])), l(r.shape.slice(0), r.data, r.stride, 0 | r.offset, n, i);
                                };
                            }((function() {
                                return function(t1, e1, r, n, i, a) {
                                    var o = t1[0], s = r[0], l = [
                                        0
                                    ], c = s;
                                    n |= 0;
                                    var u = 0, h = s;
                                    for(u = 0; u < o; ++u){
                                        var f = e1[n] - a, p = e1[n + c] - a;
                                        f >= 0 != p >= 0 && i.push(l[0] + .5 + .5 * (f + p) / (f - p)), n += h, ++l[0];
                                    }
                                };
                            }).bind(void 0, {
                                funcName: "zeroCrossings"
                            }));
                        },
                        781: function(t1, e1, r) {
                            "use strict";
                            t1.exports = function(t1, e1) {
                                var r = [];
                                return e1 = +e1 || 0, n(t1.hi(t1.shape[0] - 1), r, e1), r;
                            };
                            var n = r(3349);
                        },
                        7790: function() {}
                    }, r = {};
                    function a(t1) {
                        var n = r[t1];
                        if (void 0 !== n) return n.exports;
                        var i = r[t1] = {
                            id: t1,
                            loaded: !1,
                            exports: {}
                        };
                        return e1[t1].call(i.exports, i, i.exports, a), i.loaded = !0, i.exports;
                    }
                    a.g = function() {
                        if ("object" == typeof globalThis) return globalThis;
                        try {
                            return this || new Function("return this")();
                        } catch (t1) {
                            if ("object" == typeof window) return window;
                        }
                    }(), a.nmd = function(t1) {
                        return t1.paths = [], t1.children || (t1.children = []), t1;
                    };
                    var o = a(1964);
                    t1.exports = o;
                }();
            },
            45708: function(t1, e1, r) {
                "use strict";
                function n(t1, e1) {
                    for(var r = 0; r < e1.length; r++){
                        var n = e1[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t1, i(n.key), n);
                    }
                }
                function i(t1) {
                    var e1 = function(t1, e1) {
                        if ("object" != c(t1) || !t1) return t1;
                        var r = t1[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(t1, "string");
                            if ("object" != c(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t1);
                    }(t1);
                    return "symbol" == c(e1) ? e1 : e1 + "";
                }
                function a() {
                    try {
                        var t1 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (t1) {}
                    return (a = function() {
                        return !!t1;
                    })();
                }
                function o(t1) {
                    return o = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t1) {
                        return t1.__proto__ || Object.getPrototypeOf(t1);
                    }, o(t1);
                }
                function s(t1) {
                    if (void 0 === t1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return t1;
                }
                function l(t1, e1) {
                    return l = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t1, e1) {
                        return t1.__proto__ = e1, t1;
                    }, l(t1, e1);
                }
                function c(t1) {
                    return c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                        return typeof t1;
                    } : function(t1) {
                        return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                    }, c(t1);
                }
                var u = r(76226), h = r(27415), f = "function" == typeof Symbol && "function" == typeof Symbol.for ? Symbol.for("nodejs.util.inspect.custom") : null;
                e1.Buffer = m, e1.SlowBuffer = function(t1) {
                    return +t1 != t1 && (t1 = 0), m.alloc(+t1);
                }, e1.INSPECT_MAX_BYTES = 50;
                var p = 2147483647;
                function d(t1) {
                    if (t1 > p) throw new RangeError('The value "' + t1 + '" is invalid for option "size"');
                    var e1 = new Uint8Array(t1);
                    return Object.setPrototypeOf(e1, m.prototype), e1;
                }
                function m(t1, e1, r) {
                    if ("number" == typeof t1) {
                        if ("string" == typeof e1) throw new TypeError('The "string" argument must be of type string. Received type number');
                        return v(t1);
                    }
                    return g(t1, e1, r);
                }
                function g(t1, e1, r) {
                    if ("string" == typeof t1) return function(t1, e1) {
                        if ("string" == typeof e1 && "" !== e1 || (e1 = "utf8"), !m.isEncoding(e1)) throw new TypeError("Unknown encoding: " + e1);
                        var r = 0 | w(t1, e1), n = d(r), i = n.write(t1, e1);
                        return i !== r && (n = n.slice(0, i)), n;
                    }(t1, e1);
                    if (ArrayBuffer.isView(t1)) return function(t1) {
                        if (rt(t1, Uint8Array)) {
                            var e1 = new Uint8Array(t1);
                            return _(e1.buffer, e1.byteOffset, e1.byteLength);
                        }
                        return x(t1);
                    }(t1);
                    if (null == t1) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + c(t1));
                    if (rt(t1, ArrayBuffer) || t1 && rt(t1.buffer, ArrayBuffer)) return _(t1, e1, r);
                    if ("undefined" != typeof SharedArrayBuffer && (rt(t1, SharedArrayBuffer) || t1 && rt(t1.buffer, SharedArrayBuffer))) return _(t1, e1, r);
                    if ("number" == typeof t1) throw new TypeError('The "value" argument must not be of type number. Received type number');
                    var n = t1.valueOf && t1.valueOf();
                    if (null != n && n !== t1) return m.from(n, e1, r);
                    var i = function(t1) {
                        if (m.isBuffer(t1)) {
                            var e1 = 0 | b(t1.length), r = d(e1);
                            return 0 === r.length || t1.copy(r, 0, 0, e1), r;
                        }
                        return void 0 !== t1.length ? "number" != typeof t1.length || nt(t1.length) ? d(0) : x(t1) : "Buffer" === t1.type && Array.isArray(t1.data) ? x(t1.data) : void 0;
                    }(t1);
                    if (i) return i;
                    if ("undefined" != typeof Symbol && null != Symbol.toPrimitive && "function" == typeof t1[Symbol.toPrimitive]) return m.from(t1[Symbol.toPrimitive]("string"), e1, r);
                    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + c(t1));
                }
                function y(t1) {
                    if ("number" != typeof t1) throw new TypeError('"size" argument must be of type number');
                    if (t1 < 0) throw new RangeError('The value "' + t1 + '" is invalid for option "size"');
                }
                function v(t1) {
                    return y(t1), d(t1 < 0 ? 0 : 0 | b(t1));
                }
                function x(t1) {
                    for(var e1 = t1.length < 0 ? 0 : 0 | b(t1.length), r = d(e1), n = 0; n < e1; n += 1)r[n] = 255 & t1[n];
                    return r;
                }
                function _(t1, e1, r) {
                    if (e1 < 0 || t1.byteLength < e1) throw new RangeError('"offset" is outside of buffer bounds');
                    if (t1.byteLength < e1 + (r || 0)) throw new RangeError('"length" is outside of buffer bounds');
                    var n;
                    return n = void 0 === e1 && void 0 === r ? new Uint8Array(t1) : void 0 === r ? new Uint8Array(t1, e1) : new Uint8Array(t1, e1, r), Object.setPrototypeOf(n, m.prototype), n;
                }
                function b(t1) {
                    if (t1 >= p) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + p.toString(16) + " bytes");
                    return 0 | t1;
                }
                function w(t1, e1) {
                    if (m.isBuffer(t1)) return t1.length;
                    if (ArrayBuffer.isView(t1) || rt(t1, ArrayBuffer)) return t1.byteLength;
                    if ("string" != typeof t1) throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + c(t1));
                    var r = t1.length, n = arguments.length > 2 && !0 === arguments[2];
                    if (!n && 0 === r) return 0;
                    for(var i = !1;;)switch(e1){
                        case "ascii":
                        case "latin1":
                        case "binary":
                            return r;
                        case "utf8":
                        case "utf-8":
                            return Q(t1).length;
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return 2 * r;
                        case "hex":
                            return r >>> 1;
                        case "base64":
                            return tt(t1).length;
                        default:
                            if (i) return n ? -1 : Q(t1).length;
                            e1 = ("" + e1).toLowerCase(), i = !0;
                    }
                }
                function T(t1, e1, r) {
                    var n = !1;
                    if ((void 0 === e1 || e1 < 0) && (e1 = 0), e1 > this.length) return "";
                    if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
                    if ((r >>>= 0) <= (e1 >>>= 0)) return "";
                    for(t1 || (t1 = "utf8");;)switch(t1){
                        case "hex":
                            return F(this, e1, r);
                        case "utf8":
                        case "utf-8":
                            return z(this, e1, r);
                        case "ascii":
                            return D(this, e1, r);
                        case "latin1":
                        case "binary":
                            return R(this, e1, r);
                        case "base64":
                            return P(this, e1, r);
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return B(this, e1, r);
                        default:
                            if (n) throw new TypeError("Unknown encoding: " + t1);
                            t1 = (t1 + "").toLowerCase(), n = !0;
                    }
                }
                function k(t1, e1, r) {
                    var n = t1[e1];
                    t1[e1] = t1[r], t1[r] = n;
                }
                function A(t1, e1, r, n, i) {
                    if (0 === t1.length) return -1;
                    if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), nt(r = +r) && (r = i ? 0 : t1.length - 1), r < 0 && (r = t1.length + r), r >= t1.length) {
                        if (i) return -1;
                        r = t1.length - 1;
                    } else if (r < 0) {
                        if (!i) return -1;
                        r = 0;
                    }
                    if ("string" == typeof e1 && (e1 = m.from(e1, n)), m.isBuffer(e1)) return 0 === e1.length ? -1 : M(t1, e1, r, n, i);
                    if ("number" == typeof e1) return e1 &= 255, "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(t1, e1, r) : Uint8Array.prototype.lastIndexOf.call(t1, e1, r) : M(t1, [
                        e1
                    ], r, n, i);
                    throw new TypeError("val must be string, number or Buffer");
                }
                function M(t1, e1, r, n, i) {
                    var a, o = 1, s = t1.length, l = e1.length;
                    if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
                        if (t1.length < 2 || e1.length < 2) return -1;
                        o = 2, s /= 2, l /= 2, r /= 2;
                    }
                    function c(t1, e1) {
                        return 1 === o ? t1[e1] : t1.readUInt16BE(e1 * o);
                    }
                    if (i) {
                        var u = -1;
                        for(a = r; a < s; a++)if (c(t1, a) === c(e1, -1 === u ? 0 : a - u)) {
                            if (-1 === u && (u = a), a - u + 1 === l) return u * o;
                        } else -1 !== u && (a -= a - u), u = -1;
                    } else for(r + l > s && (r = s - l), a = r; a >= 0; a--){
                        for(var h = !0, f = 0; f < l; f++)if (c(t1, a + f) !== c(e1, f)) {
                            h = !1;
                            break;
                        }
                        if (h) return a;
                    }
                    return -1;
                }
                function S(t1, e1, r, n) {
                    r = Number(r) || 0;
                    var i = t1.length - r;
                    n ? (n = Number(n)) > i && (n = i) : n = i;
                    var a, o = e1.length;
                    for(n > o / 2 && (n = o / 2), a = 0; a < n; ++a){
                        var s = parseInt(e1.substr(2 * a, 2), 16);
                        if (nt(s)) return a;
                        t1[r + a] = s;
                    }
                    return a;
                }
                function E(t1, e1, r, n) {
                    return et(Q(e1, t1.length - r), t1, r, n);
                }
                function C(t1, e1, r, n) {
                    return et(function(t1) {
                        for(var e1 = [], r = 0; r < t1.length; ++r)e1.push(255 & t1.charCodeAt(r));
                        return e1;
                    }(e1), t1, r, n);
                }
                function L(t1, e1, r, n) {
                    return et(tt(e1), t1, r, n);
                }
                function I(t1, e1, r, n) {
                    return et(function(t1, e1) {
                        for(var r, n, i, a = [], o = 0; o < t1.length && !((e1 -= 2) < 0); ++o)n = (r = t1.charCodeAt(o)) >> 8, i = r % 256, a.push(i), a.push(n);
                        return a;
                    }(e1, t1.length - r), t1, r, n);
                }
                function P(t1, e1, r) {
                    return 0 === e1 && r === t1.length ? u.fromByteArray(t1) : u.fromByteArray(t1.slice(e1, r));
                }
                function z(t1, e1, r) {
                    r = Math.min(t1.length, r);
                    for(var n = [], i = e1; i < r;){
                        var a = t1[i], o = null, s = a > 239 ? 4 : a > 223 ? 3 : a > 191 ? 2 : 1;
                        if (i + s <= r) {
                            var l = void 0, c = void 0, u = void 0, h = void 0;
                            switch(s){
                                case 1:
                                    a < 128 && (o = a);
                                    break;
                                case 2:
                                    128 == (192 & (l = t1[i + 1])) && (h = (31 & a) << 6 | 63 & l) > 127 && (o = h);
                                    break;
                                case 3:
                                    l = t1[i + 1], c = t1[i + 2], 128 == (192 & l) && 128 == (192 & c) && (h = (15 & a) << 12 | (63 & l) << 6 | 63 & c) > 2047 && (h < 55296 || h > 57343) && (o = h);
                                    break;
                                case 4:
                                    l = t1[i + 1], c = t1[i + 2], u = t1[i + 3], 128 == (192 & l) && 128 == (192 & c) && 128 == (192 & u) && (h = (15 & a) << 18 | (63 & l) << 12 | (63 & c) << 6 | 63 & u) > 65535 && h < 1114112 && (o = h);
                            }
                        }
                        null === o ? (o = 65533, s = 1) : o > 65535 && (o -= 65536, n.push(o >>> 10 & 1023 | 55296), o = 56320 | 1023 & o), n.push(o), i += s;
                    }
                    return function(t1) {
                        var e1 = t1.length;
                        if (e1 <= O) return String.fromCharCode.apply(String, t1);
                        for(var r = "", n = 0; n < e1;)r += String.fromCharCode.apply(String, t1.slice(n, n += O));
                        return r;
                    }(n);
                }
                e1.kMaxLength = p, m.TYPED_ARRAY_SUPPORT = function() {
                    try {
                        var t1 = new Uint8Array(1), e1 = {
                            foo: function() {
                                return 42;
                            }
                        };
                        return Object.setPrototypeOf(e1, Uint8Array.prototype), Object.setPrototypeOf(t1, e1), 42 === t1.foo();
                    } catch (t1) {
                        return !1;
                    }
                }(), m.TYPED_ARRAY_SUPPORT || "undefined" == typeof console || "function" != typeof console.error || console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."), Object.defineProperty(m.prototype, "parent", {
                    enumerable: !0,
                    get: function() {
                        if (m.isBuffer(this)) return this.buffer;
                    }
                }), Object.defineProperty(m.prototype, "offset", {
                    enumerable: !0,
                    get: function() {
                        if (m.isBuffer(this)) return this.byteOffset;
                    }
                }), m.poolSize = 8192, m.from = function(t1, e1, r) {
                    return g(t1, e1, r);
                }, Object.setPrototypeOf(m.prototype, Uint8Array.prototype), Object.setPrototypeOf(m, Uint8Array), m.alloc = function(t1, e1, r) {
                    return function(t1, e1, r) {
                        return y(t1), t1 <= 0 ? d(t1) : void 0 !== e1 ? "string" == typeof r ? d(t1).fill(e1, r) : d(t1).fill(e1) : d(t1);
                    }(t1, e1, r);
                }, m.allocUnsafe = function(t1) {
                    return v(t1);
                }, m.allocUnsafeSlow = function(t1) {
                    return v(t1);
                }, m.isBuffer = function(t1) {
                    return null != t1 && !0 === t1._isBuffer && t1 !== m.prototype;
                }, m.compare = function(t1, e1) {
                    if (rt(t1, Uint8Array) && (t1 = m.from(t1, t1.offset, t1.byteLength)), rt(e1, Uint8Array) && (e1 = m.from(e1, e1.offset, e1.byteLength)), !m.isBuffer(t1) || !m.isBuffer(e1)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
                    if (t1 === e1) return 0;
                    for(var r = t1.length, n = e1.length, i = 0, a = Math.min(r, n); i < a; ++i)if (t1[i] !== e1[i]) {
                        r = t1[i], n = e1[i];
                        break;
                    }
                    return r < n ? -1 : n < r ? 1 : 0;
                }, m.isEncoding = function(t1) {
                    switch(String(t1).toLowerCase()){
                        case "hex":
                        case "utf8":
                        case "utf-8":
                        case "ascii":
                        case "latin1":
                        case "binary":
                        case "base64":
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return !0;
                        default:
                            return !1;
                    }
                }, m.concat = function(t1, e1) {
                    if (!Array.isArray(t1)) throw new TypeError('"list" argument must be an Array of Buffers');
                    if (0 === t1.length) return m.alloc(0);
                    var r;
                    if (void 0 === e1) for(e1 = 0, r = 0; r < t1.length; ++r)e1 += t1[r].length;
                    var n = m.allocUnsafe(e1), i = 0;
                    for(r = 0; r < t1.length; ++r){
                        var a = t1[r];
                        if (rt(a, Uint8Array)) i + a.length > n.length ? (m.isBuffer(a) || (a = m.from(a)), a.copy(n, i)) : Uint8Array.prototype.set.call(n, a, i);
                        else {
                            if (!m.isBuffer(a)) throw new TypeError('"list" argument must be an Array of Buffers');
                            a.copy(n, i);
                        }
                        i += a.length;
                    }
                    return n;
                }, m.byteLength = w, m.prototype._isBuffer = !0, m.prototype.swap16 = function() {
                    var t1 = this.length;
                    if (t1 % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
                    for(var e1 = 0; e1 < t1; e1 += 2)k(this, e1, e1 + 1);
                    return this;
                }, m.prototype.swap32 = function() {
                    var t1 = this.length;
                    if (t1 % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
                    for(var e1 = 0; e1 < t1; e1 += 4)k(this, e1, e1 + 3), k(this, e1 + 1, e1 + 2);
                    return this;
                }, m.prototype.swap64 = function() {
                    var t1 = this.length;
                    if (t1 % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
                    for(var e1 = 0; e1 < t1; e1 += 8)k(this, e1, e1 + 7), k(this, e1 + 1, e1 + 6), k(this, e1 + 2, e1 + 5), k(this, e1 + 3, e1 + 4);
                    return this;
                }, m.prototype.toString = function() {
                    var t1 = this.length;
                    return 0 === t1 ? "" : 0 === arguments.length ? z(this, 0, t1) : T.apply(this, arguments);
                }, m.prototype.toLocaleString = m.prototype.toString, m.prototype.equals = function(t1) {
                    if (!m.isBuffer(t1)) throw new TypeError("Argument must be a Buffer");
                    return this === t1 || 0 === m.compare(this, t1);
                }, m.prototype.inspect = function() {
                    var t1 = "", r = e1.INSPECT_MAX_BYTES;
                    return t1 = this.toString("hex", 0, r).replace(/(.{2})/g, "$1 ").trim(), this.length > r && (t1 += " ... "), "<Buffer " + t1 + ">";
                }, f && (m.prototype[f] = m.prototype.inspect), m.prototype.compare = function(t1, e1, r, n, i) {
                    if (rt(t1, Uint8Array) && (t1 = m.from(t1, t1.offset, t1.byteLength)), !m.isBuffer(t1)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + c(t1));
                    if (void 0 === e1 && (e1 = 0), void 0 === r && (r = t1 ? t1.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), e1 < 0 || r > t1.length || n < 0 || i > this.length) throw new RangeError("out of range index");
                    if (n >= i && e1 >= r) return 0;
                    if (n >= i) return -1;
                    if (e1 >= r) return 1;
                    if (this === t1) return 0;
                    for(var a = (i >>>= 0) - (n >>>= 0), o = (r >>>= 0) - (e1 >>>= 0), s = Math.min(a, o), l = this.slice(n, i), u = t1.slice(e1, r), h = 0; h < s; ++h)if (l[h] !== u[h]) {
                        a = l[h], o = u[h];
                        break;
                    }
                    return a < o ? -1 : o < a ? 1 : 0;
                }, m.prototype.includes = function(t1, e1, r) {
                    return -1 !== this.indexOf(t1, e1, r);
                }, m.prototype.indexOf = function(t1, e1, r) {
                    return A(this, t1, e1, r, !0);
                }, m.prototype.lastIndexOf = function(t1, e1, r) {
                    return A(this, t1, e1, r, !1);
                }, m.prototype.write = function(t1, e1, r, n) {
                    if (void 0 === e1) n = "utf8", r = this.length, e1 = 0;
                    else if (void 0 === r && "string" == typeof e1) n = e1, r = this.length, e1 = 0;
                    else {
                        if (!isFinite(e1)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                        e1 >>>= 0, isFinite(r) ? (r >>>= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
                    }
                    var i = this.length - e1;
                    if ((void 0 === r || r > i) && (r = i), t1.length > 0 && (r < 0 || e1 < 0) || e1 > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                    n || (n = "utf8");
                    for(var a = !1;;)switch(n){
                        case "hex":
                            return S(this, t1, e1, r);
                        case "utf8":
                        case "utf-8":
                            return E(this, t1, e1, r);
                        case "ascii":
                        case "latin1":
                        case "binary":
                            return C(this, t1, e1, r);
                        case "base64":
                            return L(this, t1, e1, r);
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return I(this, t1, e1, r);
                        default:
                            if (a) throw new TypeError("Unknown encoding: " + n);
                            n = ("" + n).toLowerCase(), a = !0;
                    }
                }, m.prototype.toJSON = function() {
                    return {
                        type: "Buffer",
                        data: Array.prototype.slice.call(this._arr || this, 0)
                    };
                };
                var O = 4096;
                function D(t1, e1, r) {
                    var n = "";
                    r = Math.min(t1.length, r);
                    for(var i = e1; i < r; ++i)n += String.fromCharCode(127 & t1[i]);
                    return n;
                }
                function R(t1, e1, r) {
                    var n = "";
                    r = Math.min(t1.length, r);
                    for(var i = e1; i < r; ++i)n += String.fromCharCode(t1[i]);
                    return n;
                }
                function F(t1, e1, r) {
                    var n = t1.length;
                    (!e1 || e1 < 0) && (e1 = 0), (!r || r < 0 || r > n) && (r = n);
                    for(var i = "", a = e1; a < r; ++a)i += it[t1[a]];
                    return i;
                }
                function B(t1, e1, r) {
                    for(var n = t1.slice(e1, r), i = "", a = 0; a < n.length - 1; a += 2)i += String.fromCharCode(n[a] + 256 * n[a + 1]);
                    return i;
                }
                function N(t1, e1, r) {
                    if (t1 % 1 != 0 || t1 < 0) throw new RangeError("offset is not uint");
                    if (t1 + e1 > r) throw new RangeError("Trying to access beyond buffer length");
                }
                function j(t1, e1, r, n, i, a) {
                    if (!m.isBuffer(t1)) throw new TypeError('"buffer" argument must be a Buffer instance');
                    if (e1 > i || e1 < a) throw new RangeError('"value" argument is out of bounds');
                    if (r + n > t1.length) throw new RangeError("Index out of range");
                }
                function U(t1, e1, r, n, i) {
                    X(e1, n, i, t1, r, 7);
                    var a = Number(e1 & BigInt(4294967295));
                    t1[r++] = a, a >>= 8, t1[r++] = a, a >>= 8, t1[r++] = a, a >>= 8, t1[r++] = a;
                    var o = Number(e1 >> BigInt(32) & BigInt(4294967295));
                    return t1[r++] = o, o >>= 8, t1[r++] = o, o >>= 8, t1[r++] = o, o >>= 8, t1[r++] = o, r;
                }
                function V(t1, e1, r, n, i) {
                    X(e1, n, i, t1, r, 7);
                    var a = Number(e1 & BigInt(4294967295));
                    t1[r + 7] = a, a >>= 8, t1[r + 6] = a, a >>= 8, t1[r + 5] = a, a >>= 8, t1[r + 4] = a;
                    var o = Number(e1 >> BigInt(32) & BigInt(4294967295));
                    return t1[r + 3] = o, o >>= 8, t1[r + 2] = o, o >>= 8, t1[r + 1] = o, o >>= 8, t1[r] = o, r + 8;
                }
                function q(t1, e1, r, n, i, a) {
                    if (r + n > t1.length) throw new RangeError("Index out of range");
                    if (r < 0) throw new RangeError("Index out of range");
                }
                function H(t1, e1, r, n, i) {
                    return e1 = +e1, r >>>= 0, i || q(t1, 0, r, 4), h.write(t1, e1, r, n, 23, 4), r + 4;
                }
                function G(t1, e1, r, n, i) {
                    return e1 = +e1, r >>>= 0, i || q(t1, 0, r, 8), h.write(t1, e1, r, n, 52, 8), r + 8;
                }
                m.prototype.slice = function(t1, e1) {
                    var r = this.length;
                    (t1 = ~~t1) < 0 ? (t1 += r) < 0 && (t1 = 0) : t1 > r && (t1 = r), (e1 = void 0 === e1 ? r : ~~e1) < 0 ? (e1 += r) < 0 && (e1 = 0) : e1 > r && (e1 = r), e1 < t1 && (e1 = t1);
                    var n = this.subarray(t1, e1);
                    return Object.setPrototypeOf(n, m.prototype), n;
                }, m.prototype.readUintLE = m.prototype.readUIntLE = function(t1, e1, r) {
                    t1 >>>= 0, e1 >>>= 0, r || N(t1, e1, this.length);
                    for(var n = this[t1], i = 1, a = 0; ++a < e1 && (i *= 256);)n += this[t1 + a] * i;
                    return n;
                }, m.prototype.readUintBE = m.prototype.readUIntBE = function(t1, e1, r) {
                    t1 >>>= 0, e1 >>>= 0, r || N(t1, e1, this.length);
                    for(var n = this[t1 + --e1], i = 1; e1 > 0 && (i *= 256);)n += this[t1 + --e1] * i;
                    return n;
                }, m.prototype.readUint8 = m.prototype.readUInt8 = function(t1, e1) {
                    return t1 >>>= 0, e1 || N(t1, 1, this.length), this[t1];
                }, m.prototype.readUint16LE = m.prototype.readUInt16LE = function(t1, e1) {
                    return t1 >>>= 0, e1 || N(t1, 2, this.length), this[t1] | this[t1 + 1] << 8;
                }, m.prototype.readUint16BE = m.prototype.readUInt16BE = function(t1, e1) {
                    return t1 >>>= 0, e1 || N(t1, 2, this.length), this[t1] << 8 | this[t1 + 1];
                }, m.prototype.readUint32LE = m.prototype.readUInt32LE = function(t1, e1) {
                    return t1 >>>= 0, e1 || N(t1, 4, this.length), (this[t1] | this[t1 + 1] << 8 | this[t1 + 2] << 16) + 16777216 * this[t1 + 3];
                }, m.prototype.readUint32BE = m.prototype.readUInt32BE = function(t1, e1) {
                    return t1 >>>= 0, e1 || N(t1, 4, this.length), 16777216 * this[t1] + (this[t1 + 1] << 16 | this[t1 + 2] << 8 | this[t1 + 3]);
                }, m.prototype.readBigUInt64LE = at(function(t1) {
                    $(t1 >>>= 0, "offset");
                    var e1 = this[t1], r = this[t1 + 7];
                    void 0 !== e1 && void 0 !== r || J(t1, this.length - 8);
                    var n = e1 + this[++t1] * Math.pow(2, 8) + this[++t1] * Math.pow(2, 16) + this[++t1] * Math.pow(2, 24), i = this[++t1] + this[++t1] * Math.pow(2, 8) + this[++t1] * Math.pow(2, 16) + r * Math.pow(2, 24);
                    return BigInt(n) + (BigInt(i) << BigInt(32));
                }), m.prototype.readBigUInt64BE = at(function(t1) {
                    $(t1 >>>= 0, "offset");
                    var e1 = this[t1], r = this[t1 + 7];
                    void 0 !== e1 && void 0 !== r || J(t1, this.length - 8);
                    var n = e1 * Math.pow(2, 24) + this[++t1] * Math.pow(2, 16) + this[++t1] * Math.pow(2, 8) + this[++t1], i = this[++t1] * Math.pow(2, 24) + this[++t1] * Math.pow(2, 16) + this[++t1] * Math.pow(2, 8) + r;
                    return (BigInt(n) << BigInt(32)) + BigInt(i);
                }), m.prototype.readIntLE = function(t1, e1, r) {
                    t1 >>>= 0, e1 >>>= 0, r || N(t1, e1, this.length);
                    for(var n = this[t1], i = 1, a = 0; ++a < e1 && (i *= 256);)n += this[t1 + a] * i;
                    return n >= (i *= 128) && (n -= Math.pow(2, 8 * e1)), n;
                }, m.prototype.readIntBE = function(t1, e1, r) {
                    t1 >>>= 0, e1 >>>= 0, r || N(t1, e1, this.length);
                    for(var n = e1, i = 1, a = this[t1 + --n]; n > 0 && (i *= 256);)a += this[t1 + --n] * i;
                    return a >= (i *= 128) && (a -= Math.pow(2, 8 * e1)), a;
                }, m.prototype.readInt8 = function(t1, e1) {
                    return t1 >>>= 0, e1 || N(t1, 1, this.length), 128 & this[t1] ? -1 * (255 - this[t1] + 1) : this[t1];
                }, m.prototype.readInt16LE = function(t1, e1) {
                    t1 >>>= 0, e1 || N(t1, 2, this.length);
                    var r = this[t1] | this[t1 + 1] << 8;
                    return 32768 & r ? 4294901760 | r : r;
                }, m.prototype.readInt16BE = function(t1, e1) {
                    t1 >>>= 0, e1 || N(t1, 2, this.length);
                    var r = this[t1 + 1] | this[t1] << 8;
                    return 32768 & r ? 4294901760 | r : r;
                }, m.prototype.readInt32LE = function(t1, e1) {
                    return t1 >>>= 0, e1 || N(t1, 4, this.length), this[t1] | this[t1 + 1] << 8 | this[t1 + 2] << 16 | this[t1 + 3] << 24;
                }, m.prototype.readInt32BE = function(t1, e1) {
                    return t1 >>>= 0, e1 || N(t1, 4, this.length), this[t1] << 24 | this[t1 + 1] << 16 | this[t1 + 2] << 8 | this[t1 + 3];
                }, m.prototype.readBigInt64LE = at(function(t1) {
                    $(t1 >>>= 0, "offset");
                    var e1 = this[t1], r = this[t1 + 7];
                    void 0 !== e1 && void 0 !== r || J(t1, this.length - 8);
                    var n = this[t1 + 4] + this[t1 + 5] * Math.pow(2, 8) + this[t1 + 6] * Math.pow(2, 16) + (r << 24);
                    return (BigInt(n) << BigInt(32)) + BigInt(e1 + this[++t1] * Math.pow(2, 8) + this[++t1] * Math.pow(2, 16) + this[++t1] * Math.pow(2, 24));
                }), m.prototype.readBigInt64BE = at(function(t1) {
                    $(t1 >>>= 0, "offset");
                    var e1 = this[t1], r = this[t1 + 7];
                    void 0 !== e1 && void 0 !== r || J(t1, this.length - 8);
                    var n = (e1 << 24) + this[++t1] * Math.pow(2, 16) + this[++t1] * Math.pow(2, 8) + this[++t1];
                    return (BigInt(n) << BigInt(32)) + BigInt(this[++t1] * Math.pow(2, 24) + this[++t1] * Math.pow(2, 16) + this[++t1] * Math.pow(2, 8) + r);
                }), m.prototype.readFloatLE = function(t1, e1) {
                    return t1 >>>= 0, e1 || N(t1, 4, this.length), h.read(this, t1, !0, 23, 4);
                }, m.prototype.readFloatBE = function(t1, e1) {
                    return t1 >>>= 0, e1 || N(t1, 4, this.length), h.read(this, t1, !1, 23, 4);
                }, m.prototype.readDoubleLE = function(t1, e1) {
                    return t1 >>>= 0, e1 || N(t1, 8, this.length), h.read(this, t1, !0, 52, 8);
                }, m.prototype.readDoubleBE = function(t1, e1) {
                    return t1 >>>= 0, e1 || N(t1, 8, this.length), h.read(this, t1, !1, 52, 8);
                }, m.prototype.writeUintLE = m.prototype.writeUIntLE = function(t1, e1, r, n) {
                    t1 = +t1, e1 >>>= 0, r >>>= 0, n || j(this, t1, e1, r, Math.pow(2, 8 * r) - 1, 0);
                    var i = 1, a = 0;
                    for(this[e1] = 255 & t1; ++a < r && (i *= 256);)this[e1 + a] = t1 / i & 255;
                    return e1 + r;
                }, m.prototype.writeUintBE = m.prototype.writeUIntBE = function(t1, e1, r, n) {
                    t1 = +t1, e1 >>>= 0, r >>>= 0, n || j(this, t1, e1, r, Math.pow(2, 8 * r) - 1, 0);
                    var i = r - 1, a = 1;
                    for(this[e1 + i] = 255 & t1; --i >= 0 && (a *= 256);)this[e1 + i] = t1 / a & 255;
                    return e1 + r;
                }, m.prototype.writeUint8 = m.prototype.writeUInt8 = function(t1, e1, r) {
                    return t1 = +t1, e1 >>>= 0, r || j(this, t1, e1, 1, 255, 0), this[e1] = 255 & t1, e1 + 1;
                }, m.prototype.writeUint16LE = m.prototype.writeUInt16LE = function(t1, e1, r) {
                    return t1 = +t1, e1 >>>= 0, r || j(this, t1, e1, 2, 65535, 0), this[e1] = 255 & t1, this[e1 + 1] = t1 >>> 8, e1 + 2;
                }, m.prototype.writeUint16BE = m.prototype.writeUInt16BE = function(t1, e1, r) {
                    return t1 = +t1, e1 >>>= 0, r || j(this, t1, e1, 2, 65535, 0), this[e1] = t1 >>> 8, this[e1 + 1] = 255 & t1, e1 + 2;
                }, m.prototype.writeUint32LE = m.prototype.writeUInt32LE = function(t1, e1, r) {
                    return t1 = +t1, e1 >>>= 0, r || j(this, t1, e1, 4, 4294967295, 0), this[e1 + 3] = t1 >>> 24, this[e1 + 2] = t1 >>> 16, this[e1 + 1] = t1 >>> 8, this[e1] = 255 & t1, e1 + 4;
                }, m.prototype.writeUint32BE = m.prototype.writeUInt32BE = function(t1, e1, r) {
                    return t1 = +t1, e1 >>>= 0, r || j(this, t1, e1, 4, 4294967295, 0), this[e1] = t1 >>> 24, this[e1 + 1] = t1 >>> 16, this[e1 + 2] = t1 >>> 8, this[e1 + 3] = 255 & t1, e1 + 4;
                }, m.prototype.writeBigUInt64LE = at(function(t1) {
                    return U(this, t1, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, BigInt(0), BigInt("0xffffffffffffffff"));
                }), m.prototype.writeBigUInt64BE = at(function(t1) {
                    return V(this, t1, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, BigInt(0), BigInt("0xffffffffffffffff"));
                }), m.prototype.writeIntLE = function(t1, e1, r, n) {
                    if (t1 = +t1, e1 >>>= 0, !n) {
                        var i = Math.pow(2, 8 * r - 1);
                        j(this, t1, e1, r, i - 1, -i);
                    }
                    var a = 0, o = 1, s = 0;
                    for(this[e1] = 255 & t1; ++a < r && (o *= 256);)t1 < 0 && 0 === s && 0 !== this[e1 + a - 1] && (s = 1), this[e1 + a] = (t1 / o >> 0) - s & 255;
                    return e1 + r;
                }, m.prototype.writeIntBE = function(t1, e1, r, n) {
                    if (t1 = +t1, e1 >>>= 0, !n) {
                        var i = Math.pow(2, 8 * r - 1);
                        j(this, t1, e1, r, i - 1, -i);
                    }
                    var a = r - 1, o = 1, s = 0;
                    for(this[e1 + a] = 255 & t1; --a >= 0 && (o *= 256);)t1 < 0 && 0 === s && 0 !== this[e1 + a + 1] && (s = 1), this[e1 + a] = (t1 / o >> 0) - s & 255;
                    return e1 + r;
                }, m.prototype.writeInt8 = function(t1, e1, r) {
                    return t1 = +t1, e1 >>>= 0, r || j(this, t1, e1, 1, 127, -128), t1 < 0 && (t1 = 255 + t1 + 1), this[e1] = 255 & t1, e1 + 1;
                }, m.prototype.writeInt16LE = function(t1, e1, r) {
                    return t1 = +t1, e1 >>>= 0, r || j(this, t1, e1, 2, 32767, -32768), this[e1] = 255 & t1, this[e1 + 1] = t1 >>> 8, e1 + 2;
                }, m.prototype.writeInt16BE = function(t1, e1, r) {
                    return t1 = +t1, e1 >>>= 0, r || j(this, t1, e1, 2, 32767, -32768), this[e1] = t1 >>> 8, this[e1 + 1] = 255 & t1, e1 + 2;
                }, m.prototype.writeInt32LE = function(t1, e1, r) {
                    return t1 = +t1, e1 >>>= 0, r || j(this, t1, e1, 4, 2147483647, -2147483648), this[e1] = 255 & t1, this[e1 + 1] = t1 >>> 8, this[e1 + 2] = t1 >>> 16, this[e1 + 3] = t1 >>> 24, e1 + 4;
                }, m.prototype.writeInt32BE = function(t1, e1, r) {
                    return t1 = +t1, e1 >>>= 0, r || j(this, t1, e1, 4, 2147483647, -2147483648), t1 < 0 && (t1 = 4294967295 + t1 + 1), this[e1] = t1 >>> 24, this[e1 + 1] = t1 >>> 16, this[e1 + 2] = t1 >>> 8, this[e1 + 3] = 255 & t1, e1 + 4;
                }, m.prototype.writeBigInt64LE = at(function(t1) {
                    return U(this, t1, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
                }), m.prototype.writeBigInt64BE = at(function(t1) {
                    return V(this, t1, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
                }), m.prototype.writeFloatLE = function(t1, e1, r) {
                    return H(this, t1, e1, !0, r);
                }, m.prototype.writeFloatBE = function(t1, e1, r) {
                    return H(this, t1, e1, !1, r);
                }, m.prototype.writeDoubleLE = function(t1, e1, r) {
                    return G(this, t1, e1, !0, r);
                }, m.prototype.writeDoubleBE = function(t1, e1, r) {
                    return G(this, t1, e1, !1, r);
                }, m.prototype.copy = function(t1, e1, r, n) {
                    if (!m.isBuffer(t1)) throw new TypeError("argument should be a Buffer");
                    if (r || (r = 0), n || 0 === n || (n = this.length), e1 >= t1.length && (e1 = t1.length), e1 || (e1 = 0), n > 0 && n < r && (n = r), n === r) return 0;
                    if (0 === t1.length || 0 === this.length) return 0;
                    if (e1 < 0) throw new RangeError("targetStart out of bounds");
                    if (r < 0 || r >= this.length) throw new RangeError("Index out of range");
                    if (n < 0) throw new RangeError("sourceEnd out of bounds");
                    n > this.length && (n = this.length), t1.length - e1 < n - r && (n = t1.length - e1 + r);
                    var i = n - r;
                    return this === t1 && "function" == typeof Uint8Array.prototype.copyWithin ? this.copyWithin(e1, r, n) : Uint8Array.prototype.set.call(t1, this.subarray(r, n), e1), i;
                }, m.prototype.fill = function(t1, e1, r, n) {
                    if ("string" == typeof t1) {
                        if ("string" == typeof e1 ? (n = e1, e1 = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
                        if ("string" == typeof n && !m.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
                        if (1 === t1.length) {
                            var i = t1.charCodeAt(0);
                            ("utf8" === n && i < 128 || "latin1" === n) && (t1 = i);
                        }
                    } else "number" == typeof t1 ? t1 &= 255 : "boolean" == typeof t1 && (t1 = Number(t1));
                    if (e1 < 0 || this.length < e1 || this.length < r) throw new RangeError("Out of range index");
                    if (r <= e1) return this;
                    var a;
                    if (e1 >>>= 0, r = void 0 === r ? this.length : r >>> 0, t1 || (t1 = 0), "number" == typeof t1) for(a = e1; a < r; ++a)this[a] = t1;
                    else {
                        var o = m.isBuffer(t1) ? t1 : m.from(t1, n), s = o.length;
                        if (0 === s) throw new TypeError('The value "' + t1 + '" is invalid for argument "value"');
                        for(a = 0; a < r - e1; ++a)this[a + e1] = o[a % s];
                    }
                    return this;
                };
                var Z = {};
                function W(t1, e1, r) {
                    Z[t1] = function(r) {
                        function i() {
                            var r;
                            return function(t1, e1) {
                                if (!(t1 instanceof e1)) throw new TypeError("Cannot call a class as a function");
                            }(this, i), r = function(t1, e1, r) {
                                return e1 = o(e1), function(t1, e1) {
                                    if (e1 && ("object" == c(e1) || "function" == typeof e1)) return e1;
                                    if (void 0 !== e1) throw new TypeError("Derived constructors may only return object or undefined");
                                    return s(t1);
                                }(t1, a() ? Reflect.construct(e1, r || [], o(t1).constructor) : e1.apply(t1, r));
                            }(this, i), Object.defineProperty(s(r), "message", {
                                value: e1.apply(s(r), arguments),
                                writable: !0,
                                configurable: !0
                            }), r.name = "".concat(r.name, " [").concat(t1, "]"), r.stack, delete r.name, r;
                        }
                        var u, h;
                        return function(t1, e1) {
                            if ("function" != typeof e1 && null !== e1) throw new TypeError("Super expression must either be null or a function");
                            t1.prototype = Object.create(e1 && e1.prototype, {
                                constructor: {
                                    value: t1,
                                    writable: !0,
                                    configurable: !0
                                }
                            }), Object.defineProperty(t1, "prototype", {
                                writable: !1
                            }), e1 && l(t1, e1);
                        }(i, r), u = i, h = [
                            {
                                key: "code",
                                get: function() {
                                    return t1;
                                },
                                set: function(t1) {
                                    Object.defineProperty(this, "code", {
                                        configurable: !0,
                                        enumerable: !0,
                                        value: t1,
                                        writable: !0
                                    });
                                }
                            },
                            {
                                key: "toString",
                                value: function() {
                                    return "".concat(this.name, " [").concat(t1, "]: ").concat(this.message);
                                }
                            }
                        ], n(u.prototype, h), Object.defineProperty(u, "prototype", {
                            writable: !1
                        }), i;
                    }(r);
                }
                function Y(t1) {
                    for(var e1 = "", r = t1.length, n = "-" === t1[0] ? 1 : 0; r >= n + 4; r -= 3)e1 = "_".concat(t1.slice(r - 3, r)).concat(e1);
                    return "".concat(t1.slice(0, r)).concat(e1);
                }
                function X(t1, e1, r, n, i, a) {
                    if (t1 > r || t1 < e1) {
                        var o, s = "bigint" == typeof e1 ? "n" : "";
                        throw o = a > 3 ? 0 === e1 || e1 === BigInt(0) ? ">= 0".concat(s, " and < 2").concat(s, " ** ").concat(8 * (a + 1)).concat(s) : ">= -(2".concat(s, " ** ").concat(8 * (a + 1) - 1).concat(s, ") and < 2 ** ") + "".concat(8 * (a + 1) - 1).concat(s) : ">= ".concat(e1).concat(s, " and <= ").concat(r).concat(s), new Z.ERR_OUT_OF_RANGE("value", o, t1);
                    }
                    !function(t1, e1, r) {
                        $(e1, "offset"), void 0 !== t1[e1] && void 0 !== t1[e1 + r] || J(e1, t1.length - (r + 1));
                    }(n, i, a);
                }
                function $(t1, e1) {
                    if ("number" != typeof t1) throw new Z.ERR_INVALID_ARG_TYPE(e1, "number", t1);
                }
                function J(t1, e1, r) {
                    if (Math.floor(t1) !== t1) throw $(t1, r), new Z.ERR_OUT_OF_RANGE(r || "offset", "an integer", t1);
                    if (e1 < 0) throw new Z.ERR_BUFFER_OUT_OF_BOUNDS;
                    throw new Z.ERR_OUT_OF_RANGE(r || "offset", ">= ".concat(r ? 1 : 0, " and <= ").concat(e1), t1);
                }
                W("ERR_BUFFER_OUT_OF_BOUNDS", function(t1) {
                    return t1 ? "".concat(t1, " is outside of buffer bounds") : "Attempt to access memory outside buffer bounds";
                }, RangeError), W("ERR_INVALID_ARG_TYPE", function(t1, e1) {
                    return 'The "'.concat(t1, '" argument must be of type number. Received type ').concat(c(e1));
                }, TypeError), W("ERR_OUT_OF_RANGE", function(t1, e1, r) {
                    var n = 'The value of "'.concat(t1, '" is out of range.'), i = r;
                    return Number.isInteger(r) && Math.abs(r) > Math.pow(2, 32) ? i = Y(String(r)) : "bigint" == typeof r && (i = String(r), (r > Math.pow(BigInt(2), BigInt(32)) || r < -Math.pow(BigInt(2), BigInt(32))) && (i = Y(i)), i += "n"), n + " It must be ".concat(e1, ". Received ").concat(i);
                }, RangeError);
                var K = /[^+/0-9A-Za-z-_]/g;
                function Q(t1, e1) {
                    var r;
                    e1 = e1 || 1 / 0;
                    for(var n = t1.length, i = null, a = [], o = 0; o < n; ++o){
                        if ((r = t1.charCodeAt(o)) > 55295 && r < 57344) {
                            if (!i) {
                                if (r > 56319) {
                                    (e1 -= 3) > -1 && a.push(239, 191, 189);
                                    continue;
                                }
                                if (o + 1 === n) {
                                    (e1 -= 3) > -1 && a.push(239, 191, 189);
                                    continue;
                                }
                                i = r;
                                continue;
                            }
                            if (r < 56320) {
                                (e1 -= 3) > -1 && a.push(239, 191, 189), i = r;
                                continue;
                            }
                            r = 65536 + (i - 55296 << 10 | r - 56320);
                        } else i && (e1 -= 3) > -1 && a.push(239, 191, 189);
                        if (i = null, r < 128) {
                            if ((e1 -= 1) < 0) break;
                            a.push(r);
                        } else if (r < 2048) {
                            if ((e1 -= 2) < 0) break;
                            a.push(r >> 6 | 192, 63 & r | 128);
                        } else if (r < 65536) {
                            if ((e1 -= 3) < 0) break;
                            a.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
                        } else {
                            if (!(r < 1114112)) throw new Error("Invalid code point");
                            if ((e1 -= 4) < 0) break;
                            a.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
                        }
                    }
                    return a;
                }
                function tt(t1) {
                    return u.toByteArray(function(t1) {
                        if ((t1 = (t1 = t1.split("=")[0]).trim().replace(K, "")).length < 2) return "";
                        for(; t1.length % 4 != 0;)t1 += "=";
                        return t1;
                    }(t1));
                }
                function et(t1, e1, r, n) {
                    var i;
                    for(i = 0; i < n && !(i + r >= e1.length || i >= t1.length); ++i)e1[i + r] = t1[i];
                    return i;
                }
                function rt(t1, e1) {
                    return t1 instanceof e1 || null != t1 && null != t1.constructor && null != t1.constructor.name && t1.constructor.name === e1.name;
                }
                function nt(t1) {
                    return t1 != t1;
                }
                var it = function() {
                    for(var t1 = "0123456789abcdef", e1 = new Array(256), r = 0; r < 16; ++r)for(var n = 16 * r, i = 0; i < 16; ++i)e1[n + i] = t1[r] + t1[i];
                    return e1;
                }();
                function at(t1) {
                    return "undefined" == typeof BigInt ? ot : t1;
                }
                function ot() {
                    throw new Error("BigInt not supported");
                }
            },
            13087: function(t1) {
                "use strict";
                t1.exports = i, t1.exports.isMobile = i, t1.exports.default = i;
                var e1 = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser.*mobile|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i, r = /CrOS/, n = /android|ipad|playbook|silk/i;
                function i(t1) {
                    t1 || (t1 = {});
                    var i = t1.ua;
                    if (i || "undefined" == typeof navigator || (i = navigator.userAgent), i && i.headers && "string" == typeof i.headers["user-agent"] && (i = i.headers["user-agent"]), "string" != typeof i) return !1;
                    var a = e1.test(i) && !r.test(i) || !!t1.tablet && n.test(i);
                    return !a && t1.tablet && t1.featureDetect && navigator && navigator.maxTouchPoints > 1 && -1 !== i.indexOf("Macintosh") && -1 !== i.indexOf("Safari") && (a = !0), a;
                }
            },
            5955: function(t1, e1, r) {
                "use strict";
                var n = r(22413), i = r.n(n), a = r(51070), o = r.n(a), s = r(62133), l = r.n(s), c = new URL(r(77035), r.b), u = new URL(r(43470), r.b), h = new URL(r(68164), r.b), f = new URL(r(64665), r.b), p = new URL(r(4890), r.b), d = new URL(r(13363), r.b), m = new URL(r(13490), r.b), g = new URL(r(47603), r.b), y = new URL(r(13913), r.b), v = new URL(r(91413), r.b), x = new URL(r(64643), r.b), _ = new URL(r(80216), r.b), b = new URL(r(61907), r.b), w = new URL(r(68605), r.b), T = new URL(r(25446), r.b), k = new URL(r(56694), r.b), A = new URL(r(24420), r.b), M = new URL(r(75796), r.b), S = new URL(r(92228), r.b), E = new URL(r(9819), r.b), C = new URL(r(47695), r.b), L = new URL(r(28869), r.b), I = new URL(r(30557), r.b), P = new URL(r(48460), r.b), z = new URL(r(56539), r.b), O = new URL(r(43737), r.b), D = new URL(r(47914), r.b), R = new URL(r(26117), r.b), F = new URL(r(66311), r.b), B = o()(i()), N = l()(c), j = l()(u), U = l()(h), V = l()(f), q = l()(p), H = l()(d), G = l()(m), Z = l()(g), W = l()(y), Y = l()(v), X = l()(x), $ = l()(_), J = l()(b), K = l()(w), Q = l()(T), tt = l()(k), et = l()(A), rt = l()(M), nt = l()(S), it = l()(E), at = l()(C), ot = l()(L), st = l()(I), lt = l()(P), ct = l()(z), ut = l()(O), ht = l()(D), ft = l()(R), pt = l()(F);
                B.push([
                    t1.id,
                    ".maplibregl-map{font:12px/20px Helvetica Neue,Arial,Helvetica,sans-serif;overflow:hidden;position:relative;-webkit-tap-highlight-color:rgb(0 0 0/0)}.maplibregl-canvas{left:0;position:absolute;top:0}.maplibregl-map:fullscreen{height:100%;width:100%}.maplibregl-ctrl-group button.maplibregl-ctrl-compass{touch-action:none}.maplibregl-canvas-container.maplibregl-interactive,.maplibregl-ctrl-group button.maplibregl-ctrl-compass{cursor:grab;-webkit-user-select:none;-moz-user-select:none;user-select:none}.maplibregl-canvas-container.maplibregl-interactive.maplibregl-track-pointer{cursor:pointer}.maplibregl-canvas-container.maplibregl-interactive:active,.maplibregl-ctrl-group button.maplibregl-ctrl-compass:active{cursor:grabbing}.maplibregl-canvas-container.maplibregl-touch-zoom-rotate,.maplibregl-canvas-container.maplibregl-touch-zoom-rotate .maplibregl-canvas{touch-action:pan-x pan-y}.maplibregl-canvas-container.maplibregl-touch-drag-pan,.maplibregl-canvas-container.maplibregl-touch-drag-pan .maplibregl-canvas{touch-action:pinch-zoom}.maplibregl-canvas-container.maplibregl-touch-zoom-rotate.maplibregl-touch-drag-pan,.maplibregl-canvas-container.maplibregl-touch-zoom-rotate.maplibregl-touch-drag-pan .maplibregl-canvas{touch-action:none}.maplibregl-canvas-container.maplibregl-touch-drag-pan.maplibregl-cooperative-gestures,.maplibregl-canvas-container.maplibregl-touch-drag-pan.maplibregl-cooperative-gestures .maplibregl-canvas{touch-action:pan-x pan-y}.maplibregl-ctrl-bottom-left,.maplibregl-ctrl-bottom-right,.maplibregl-ctrl-top-left,.maplibregl-ctrl-top-right{pointer-events:none;position:absolute;z-index:2}.maplibregl-ctrl-top-left{left:0;top:0}.maplibregl-ctrl-top-right{right:0;top:0}.maplibregl-ctrl-bottom-left{bottom:0;left:0}.maplibregl-ctrl-bottom-right{bottom:0;right:0}.maplibregl-ctrl{clear:both;pointer-events:auto;transform:translate(0)}.maplibregl-ctrl-top-left .maplibregl-ctrl{float:left;margin:10px 0 0 10px}.maplibregl-ctrl-top-right .maplibregl-ctrl{float:right;margin:10px 10px 0 0}.maplibregl-ctrl-bottom-left .maplibregl-ctrl{float:left;margin:0 0 10px 10px}.maplibregl-ctrl-bottom-right .maplibregl-ctrl{float:right;margin:0 10px 10px 0}.maplibregl-ctrl-group{background:#fff;border-radius:4px}.maplibregl-ctrl-group:not(:empty){box-shadow:0 0 0 2px rgba(0,0,0,.1)}@media (forced-colors:active){.maplibregl-ctrl-group:not(:empty){box-shadow:0 0 0 2px ButtonText}}.maplibregl-ctrl-group button{background-color:transparent;border:0;box-sizing:border-box;cursor:pointer;display:block;height:29px;outline:none;padding:0;width:29px}.maplibregl-ctrl-group button+button{border-top:1px solid #ddd}.maplibregl-ctrl button .maplibregl-ctrl-icon{background-position:50%;background-repeat:no-repeat;display:block;height:100%;width:100%}@media (forced-colors:active){.maplibregl-ctrl-icon{background-color:transparent}.maplibregl-ctrl-group button+button{border-top:1px solid ButtonText}}.maplibregl-ctrl button::-moz-focus-inner{border:0;padding:0}.maplibregl-ctrl-attrib-button:focus,.maplibregl-ctrl-group button:focus{box-shadow:0 0 2px 2px #0096ff}.maplibregl-ctrl button:disabled{cursor:not-allowed}.maplibregl-ctrl button:disabled .maplibregl-ctrl-icon{opacity:.25}.maplibregl-ctrl button:not(:disabled):hover{background-color:rgb(0 0 0/5%)}.maplibregl-ctrl-group button:focus:focus-visible{box-shadow:0 0 2px 2px #0096ff}.maplibregl-ctrl-group button:focus:not(:focus-visible){box-shadow:none}.maplibregl-ctrl-group button:focus:first-child{border-radius:4px 4px 0 0}.maplibregl-ctrl-group button:focus:last-child{border-radius:0 0 4px 4px}.maplibregl-ctrl-group button:focus:only-child{border-radius:inherit}.maplibregl-ctrl button.maplibregl-ctrl-zoom-out .maplibregl-ctrl-icon{background-image:url(" + N + ")}.maplibregl-ctrl button.maplibregl-ctrl-zoom-in .maplibregl-ctrl-icon{background-image:url(" + j + ")}@media (forced-colors:active){.maplibregl-ctrl button.maplibregl-ctrl-zoom-out .maplibregl-ctrl-icon{background-image:url(" + U + ")}.maplibregl-ctrl button.maplibregl-ctrl-zoom-in .maplibregl-ctrl-icon{background-image:url(" + V + ")}}@media (forced-colors:active) and (prefers-color-scheme:light){.maplibregl-ctrl button.maplibregl-ctrl-zoom-out .maplibregl-ctrl-icon{background-image:url(" + q + ")}.maplibregl-ctrl button.maplibregl-ctrl-zoom-in .maplibregl-ctrl-icon{background-image:url(" + H + ")}}.maplibregl-ctrl button.maplibregl-ctrl-fullscreen .maplibregl-ctrl-icon{background-image:url(" + G + ")}.maplibregl-ctrl button.maplibregl-ctrl-shrink .maplibregl-ctrl-icon{background-image:url(" + Z + ")}@media (forced-colors:active){.maplibregl-ctrl button.maplibregl-ctrl-fullscreen .maplibregl-ctrl-icon{background-image:url(" + W + ")}.maplibregl-ctrl button.maplibregl-ctrl-shrink .maplibregl-ctrl-icon{background-image:url(" + Y + ")}}@media (forced-colors:active) and (prefers-color-scheme:light){.maplibregl-ctrl button.maplibregl-ctrl-fullscreen .maplibregl-ctrl-icon{background-image:url(" + X + ")}.maplibregl-ctrl button.maplibregl-ctrl-shrink .maplibregl-ctrl-icon{background-image:url(" + Z + ")}}.maplibregl-ctrl button.maplibregl-ctrl-compass .maplibregl-ctrl-icon{background-image:url(" + $ + ")}@media (forced-colors:active){.maplibregl-ctrl button.maplibregl-ctrl-compass .maplibregl-ctrl-icon{background-image:url(" + J + ")}}@media (forced-colors:active) and (prefers-color-scheme:light){.maplibregl-ctrl button.maplibregl-ctrl-compass .maplibregl-ctrl-icon{background-image:url(" + K + ")}}.maplibregl-ctrl button.maplibregl-ctrl-terrain .maplibregl-ctrl-icon{background-image:url(" + Q + ")}.maplibregl-ctrl button.maplibregl-ctrl-terrain-enabled .maplibregl-ctrl-icon{background-image:url(" + tt + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate .maplibregl-ctrl-icon{background-image:url(" + et + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate:disabled .maplibregl-ctrl-icon{background-image:url(" + rt + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-active .maplibregl-ctrl-icon{background-image:url(" + nt + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-active-error .maplibregl-ctrl-icon{background-image:url(" + it + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-background .maplibregl-ctrl-icon{background-image:url(" + at + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-background-error .maplibregl-ctrl-icon{background-image:url(" + ot + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-waiting .maplibregl-ctrl-icon{animation:maplibregl-spin 2s linear infinite}@media (forced-colors:active){.maplibregl-ctrl button.maplibregl-ctrl-geolocate .maplibregl-ctrl-icon{background-image:url(" + st + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate:disabled .maplibregl-ctrl-icon{background-image:url(" + lt + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-active .maplibregl-ctrl-icon{background-image:url(" + nt + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-active-error .maplibregl-ctrl-icon{background-image:url(" + it + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-background .maplibregl-ctrl-icon{background-image:url(" + at + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-background-error .maplibregl-ctrl-icon{background-image:url(" + ot + ")}}@media (forced-colors:active) and (prefers-color-scheme:light){.maplibregl-ctrl button.maplibregl-ctrl-geolocate .maplibregl-ctrl-icon{background-image:url(" + ct + ")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate:disabled .maplibregl-ctrl-icon{background-image:url(" + ut + ")}}@keyframes maplibregl-spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}a.maplibregl-ctrl-logo{background-image:url(" + ht + ");background-repeat:no-repeat;cursor:pointer;display:block;height:23px;margin:0 0 -4px -4px;overflow:hidden;width:88px}a.maplibregl-ctrl-logo.maplibregl-compact{width:14px}@media (forced-colors:active){a.maplibregl-ctrl-logo{background-color:transparent;background-image:url(" + ht + ")}}@media (forced-colors:active) and (prefers-color-scheme:light){a.maplibregl-ctrl-logo{background-image:url(" + ht + ")}}.maplibregl-ctrl.maplibregl-ctrl-attrib{background-color:hsla(0,0%,100%,.5);margin:0;padding:0 5px}@media screen{.maplibregl-ctrl-attrib.maplibregl-compact{background-color:#fff;border-radius:12px;box-sizing:content-box;color:#000;margin:10px;min-height:20px;padding:2px 24px 2px 0;position:relative}.maplibregl-ctrl-attrib.maplibregl-compact-show{padding:2px 28px 2px 8px;visibility:visible}.maplibregl-ctrl-bottom-left>.maplibregl-ctrl-attrib.maplibregl-compact-show,.maplibregl-ctrl-top-left>.maplibregl-ctrl-attrib.maplibregl-compact-show{border-radius:12px;padding:2px 8px 2px 28px}.maplibregl-ctrl-attrib.maplibregl-compact .maplibregl-ctrl-attrib-inner{display:none}.maplibregl-ctrl-attrib-button{background-color:hsla(0,0%,100%,.5);background-image:url(" + ft + ");border:0;border-radius:12px;box-sizing:border-box;cursor:pointer;display:none;height:24px;outline:none;position:absolute;right:0;top:0;width:24px}.maplibregl-ctrl-attrib summary.maplibregl-ctrl-attrib-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;list-style:none}.maplibregl-ctrl-attrib summary.maplibregl-ctrl-attrib-button::-webkit-details-marker{display:none}.maplibregl-ctrl-bottom-left .maplibregl-ctrl-attrib-button,.maplibregl-ctrl-top-left .maplibregl-ctrl-attrib-button{left:0}.maplibregl-ctrl-attrib.maplibregl-compact .maplibregl-ctrl-attrib-button,.maplibregl-ctrl-attrib.maplibregl-compact-show .maplibregl-ctrl-attrib-inner{display:block}.maplibregl-ctrl-attrib.maplibregl-compact-show .maplibregl-ctrl-attrib-button{background-color:rgb(0 0 0/5%)}.maplibregl-ctrl-bottom-right>.maplibregl-ctrl-attrib.maplibregl-compact:after{bottom:0;right:0}.maplibregl-ctrl-top-right>.maplibregl-ctrl-attrib.maplibregl-compact:after{right:0;top:0}.maplibregl-ctrl-top-left>.maplibregl-ctrl-attrib.maplibregl-compact:after{left:0;top:0}.maplibregl-ctrl-bottom-left>.maplibregl-ctrl-attrib.maplibregl-compact:after{bottom:0;left:0}}@media screen and (forced-colors:active){.maplibregl-ctrl-attrib.maplibregl-compact:after{background-image:url(" + pt + ")}}@media screen and (forced-colors:active) and (prefers-color-scheme:light){.maplibregl-ctrl-attrib.maplibregl-compact:after{background-image:url(" + ft + ')}}.maplibregl-ctrl-attrib a{color:rgba(0,0,0,.75);text-decoration:none}.maplibregl-ctrl-attrib a:hover{color:inherit;text-decoration:underline}.maplibregl-attrib-empty{display:none}.maplibregl-ctrl-scale{background-color:hsla(0,0%,100%,.75);border:2px solid #333;border-top:#333;box-sizing:border-box;color:#333;font-size:10px;padding:0 5px}.maplibregl-popup{display:flex;left:0;pointer-events:none;position:absolute;top:0;will-change:transform}.maplibregl-popup-anchor-top,.maplibregl-popup-anchor-top-left,.maplibregl-popup-anchor-top-right{flex-direction:column}.maplibregl-popup-anchor-bottom,.maplibregl-popup-anchor-bottom-left,.maplibregl-popup-anchor-bottom-right{flex-direction:column-reverse}.maplibregl-popup-anchor-left{flex-direction:row}.maplibregl-popup-anchor-right{flex-direction:row-reverse}.maplibregl-popup-tip{border:10px solid transparent;height:0;width:0;z-index:1}.maplibregl-popup-anchor-top .maplibregl-popup-tip{align-self:center;border-bottom-color:#fff;border-top:none}.maplibregl-popup-anchor-top-left .maplibregl-popup-tip{align-self:flex-start;border-bottom-color:#fff;border-left:none;border-top:none}.maplibregl-popup-anchor-top-right .maplibregl-popup-tip{align-self:flex-end;border-bottom-color:#fff;border-right:none;border-top:none}.maplibregl-popup-anchor-bottom .maplibregl-popup-tip{align-self:center;border-bottom:none;border-top-color:#fff}.maplibregl-popup-anchor-bottom-left .maplibregl-popup-tip{align-self:flex-start;border-bottom:none;border-left:none;border-top-color:#fff}.maplibregl-popup-anchor-bottom-right .maplibregl-popup-tip{align-self:flex-end;border-bottom:none;border-right:none;border-top-color:#fff}.maplibregl-popup-anchor-left .maplibregl-popup-tip{align-self:center;border-left:none;border-right-color:#fff}.maplibregl-popup-anchor-right .maplibregl-popup-tip{align-self:center;border-left-color:#fff;border-right:none}.maplibregl-popup-close-button{background-color:transparent;border:0;border-radius:0 3px 0 0;cursor:pointer;position:absolute;right:0;top:0}.maplibregl-popup-close-button:hover{background-color:rgb(0 0 0/5%)}.maplibregl-popup-content{background:#fff;border-radius:3px;box-shadow:0 1px 2px rgba(0,0,0,.1);padding:15px 10px;pointer-events:auto;position:relative}.maplibregl-popup-anchor-top-left .maplibregl-popup-content{border-top-left-radius:0}.maplibregl-popup-anchor-top-right .maplibregl-popup-content{border-top-right-radius:0}.maplibregl-popup-anchor-bottom-left .maplibregl-popup-content{border-bottom-left-radius:0}.maplibregl-popup-anchor-bottom-right .maplibregl-popup-content{border-bottom-right-radius:0}.maplibregl-popup-track-pointer{display:none}.maplibregl-popup-track-pointer *{pointer-events:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.maplibregl-map:hover .maplibregl-popup-track-pointer{display:flex}.maplibregl-map:active .maplibregl-popup-track-pointer{display:none}.maplibregl-marker{left:0;position:absolute;top:0;transition:opacity .2s;will-change:transform}.maplibregl-user-location-dot,.maplibregl-user-location-dot:before{background-color:#1da1f2;border-radius:50%;height:15px;width:15px}.maplibregl-user-location-dot:before{animation:maplibregl-user-location-dot-pulse 2s infinite;content:"";position:absolute}.maplibregl-user-location-dot:after{border:2px solid #fff;border-radius:50%;box-shadow:0 0 3px rgba(0,0,0,.35);box-sizing:border-box;content:"";height:19px;left:-2px;position:absolute;top:-2px;width:19px}@keyframes maplibregl-user-location-dot-pulse{0%{opacity:1;transform:scale(1)}70%{opacity:0;transform:scale(3)}to{opacity:0;transform:scale(1)}}.maplibregl-user-location-dot-stale{background-color:#aaa}.maplibregl-user-location-dot-stale:after{display:none}.maplibregl-user-location-accuracy-circle{background-color:#1da1f233;border-radius:100%;height:1px;width:1px}.maplibregl-crosshair,.maplibregl-crosshair .maplibregl-interactive,.maplibregl-crosshair .maplibregl-interactive:active{cursor:crosshair}.maplibregl-boxzoom{background:#fff;border:2px dotted #202020;height:0;left:0;opacity:.5;position:absolute;top:0;width:0}.maplibregl-cooperative-gesture-screen{align-items:center;background:rgba(0,0,0,.4);color:#fff;display:flex;font-size:1.4em;inset:0;justify-content:center;line-height:1.2;opacity:0;padding:1rem;pointer-events:none;position:absolute;transition:opacity 1s ease 1s;z-index:99999}.maplibregl-cooperative-gesture-screen.maplibregl-show{opacity:1;transition:opacity .05s}.maplibregl-cooperative-gesture-screen .maplibregl-mobile-message{display:none}@media (hover:none),(width <= 480px){.maplibregl-cooperative-gesture-screen .maplibregl-desktop-message{display:none}.maplibregl-cooperative-gesture-screen .maplibregl-mobile-message{display:block}}.maplibregl-pseudo-fullscreen{height:100%!important;left:0!important;position:fixed!important;top:0!important;width:100%!important;z-index:99999}',
                    ""
                ]), e1.A = B;
            },
            68735: function(t1, e1, r) {
                "use strict";
                r.r(e1), r.d(e1, {
                    sankeyCenter: function() {
                        return f;
                    },
                    sankeyCircular: function() {
                        return L;
                    },
                    sankeyJustify: function() {
                        return h;
                    },
                    sankeyLeft: function() {
                        return c;
                    },
                    sankeyRight: function() {
                        return u;
                    }
                });
                var n = r(29725), i = r(4575), a = r(48544), o = r(96143), s = r.n(o);
                function l(t1) {
                    return t1.target.depth;
                }
                function c(t1) {
                    return t1.depth;
                }
                function u(t1, e1) {
                    return e1 - 1 - t1.height;
                }
                function h(t1, e1) {
                    return t1.sourceLinks.length ? t1.depth : e1 - 1;
                }
                function f(t1) {
                    return t1.targetLinks.length ? t1.depth : t1.sourceLinks.length ? (0, n.jk)(t1.sourceLinks, l) - 1 : 0;
                }
                function p(t1) {
                    return function() {
                        return t1;
                    };
                }
                var d = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                    return typeof t1;
                } : function(t1) {
                    return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                };
                function m(t1, e1) {
                    return y(t1.source, e1.source) || t1.index - e1.index;
                }
                function g(t1, e1) {
                    return y(t1.target, e1.target) || t1.index - e1.index;
                }
                function y(t1, e1) {
                    return t1.partOfCycle === e1.partOfCycle ? t1.y0 - e1.y0 : "top" === t1.circularLinkType || "bottom" === e1.circularLinkType ? -1 : 1;
                }
                function v(t1) {
                    return t1.value;
                }
                function x(t1) {
                    return (t1.y0 + t1.y1) / 2;
                }
                function _(t1) {
                    return x(t1.source);
                }
                function b(t1) {
                    return x(t1.target);
                }
                function w(t1) {
                    return t1.index;
                }
                function T(t1) {
                    return t1.nodes;
                }
                function k(t1) {
                    return t1.links;
                }
                function A(t1, e1) {
                    var r = t1.get(e1);
                    if (!r) throw new Error("missing: " + e1);
                    return r;
                }
                function M(t1, e1) {
                    return e1(t1);
                }
                var S = 25, E = 10, C = .3;
                function L() {
                    var t1, e1, r = 0, a = 0, o = 1, l = 1, c = 24, u = w, f = h, M = T, L = k, P = 32, O = 2, D = null;
                    function F() {
                        var h = {
                            nodes: M.apply(null, arguments),
                            links: L.apply(null, arguments)
                        };
                        !function(t1) {
                            t1.nodes.forEach(function(t1, e1) {
                                t1.index = e1, t1.sourceLinks = [], t1.targetLinks = [];
                            });
                            var e1 = (0, i.Tj)(t1.nodes, u);
                            t1.links.forEach(function(t1, r) {
                                t1.index = r;
                                var n = t1.source, i = t1.target;
                                "object" !== (void 0 === n ? "undefined" : d(n)) && (n = t1.source = A(e1, n)), "object" !== (void 0 === i ? "undefined" : d(i)) && (i = t1.target = A(e1, i)), n.sourceLinks.push(t1), i.targetLinks.push(t1);
                            });
                        }(h), function(t1, e1, r) {
                            var n = 0;
                            if (null === r) {
                                for(var i = [], a = 0; a < t1.links.length; a++){
                                    var o = t1.links[a], l = o.source.index, c = o.target.index;
                                    i[l] || (i[l] = []), i[c] || (i[c] = []), -1 === i[l].indexOf(c) && i[l].push(c);
                                }
                                var u = s()(i);
                                u.sort(function(t1, e1) {
                                    return t1.length - e1.length;
                                });
                                var h = {};
                                for(a = 0; a < u.length; a++){
                                    var f = u[a].slice(-2);
                                    h[f[0]] || (h[f[0]] = {}), h[f[0]][f[1]] = !0;
                                }
                                t1.links.forEach(function(t1) {
                                    var e1 = t1.target.index, r = t1.source.index;
                                    e1 === r || h[r] && h[r][e1] ? (t1.circular = !0, t1.circularLinkID = n, n += 1) : t1.circular = !1;
                                });
                            } else t1.links.forEach(function(t1) {
                                t1.source[r] < t1.target[r] ? t1.circular = !1 : (t1.circular = !0, t1.circularLinkID = n, n += 1);
                            });
                        }(h, 0, D), function(t1) {
                            t1.nodes.forEach(function(t1) {
                                t1.partOfCycle = !1, t1.value = Math.max((0, n.cz)(t1.sourceLinks, v), (0, n.cz)(t1.targetLinks, v)), t1.sourceLinks.forEach(function(e1) {
                                    e1.circular && (t1.partOfCycle = !0, t1.circularLinkType = e1.circularLinkType);
                                }), t1.targetLinks.forEach(function(e1) {
                                    e1.circular && (t1.partOfCycle = !0, t1.circularLinkType = e1.circularLinkType);
                                });
                            });
                        }(h), function(t1) {
                            var e1, r, n;
                            for(e1 = t1.nodes, r = [], n = 0; e1.length; ++n, e1 = r, r = [])e1.forEach(function(t1) {
                                t1.depth = n, t1.sourceLinks.forEach(function(t1) {
                                    r.indexOf(t1.target) < 0 && !t1.circular && r.push(t1.target);
                                });
                            });
                            for(e1 = t1.nodes, r = [], n = 0; e1.length; ++n, e1 = r, r = [])e1.forEach(function(t1) {
                                t1.height = n, t1.targetLinks.forEach(function(t1) {
                                    r.indexOf(t1.source) < 0 && !t1.circular && r.push(t1.source);
                                });
                            });
                            t1.nodes.forEach(function(t1) {
                                t1.column = Math.floor(f.call(null, t1, n));
                            });
                        }(h), I(h, u), function(s, u, h) {
                            var f = (0, i.$I)().key(function(t1) {
                                return t1.column;
                            }).sortKeys(n.V_).entries(s.nodes).map(function(t1) {
                                return t1.values;
                            });
                            (function(i) {
                                if (e1) {
                                    var u = 1 / 0;
                                    f.forEach(function(t1) {
                                        var r = l * e1 / (t1.length + 1);
                                        u = r < u ? r : u;
                                    }), t1 = u;
                                }
                                var h = (0, n.jk)(f, function(e1) {
                                    return (l - a - (e1.length - 1) * t1) / (0, n.cz)(e1, v);
                                });
                                h *= C, s.links.forEach(function(t1) {
                                    t1.width = t1.value * h;
                                });
                                var p = function(t1) {
                                    var e1 = 0, r = 0, i = 0, a = 0, o = (0, n.T9)(t1.nodes, function(t1) {
                                        return t1.column;
                                    });
                                    return t1.links.forEach(function(t1) {
                                        t1.circular && ("top" == t1.circularLinkType ? e1 += t1.width : r += t1.width, 0 == t1.target.column && (a += t1.width), t1.source.column == o && (i += t1.width));
                                    }), {
                                        top: e1 = e1 > 0 ? e1 + S + E : e1,
                                        bottom: r = r > 0 ? r + S + E : r,
                                        left: a = a > 0 ? a + S + E : a,
                                        right: i = i > 0 ? i + S + E : i
                                    };
                                }(s), d = function(t1, e1) {
                                    var i = (0, n.T9)(t1.nodes, function(t1) {
                                        return t1.column;
                                    }), s = o - r, u = l - a, h = s / (s + e1.right + e1.left), f = u / (u + e1.top + e1.bottom);
                                    return r = r * h + e1.left, o = 0 == e1.right ? o : o * h, a = a * f + e1.top, l *= f, t1.nodes.forEach(function(t1) {
                                        t1.x0 = r + t1.column * ((o - r - c) / i), t1.x1 = t1.x0 + c;
                                    }), f;
                                }(s, p);
                                h *= d, s.links.forEach(function(t1) {
                                    t1.width = t1.value * h;
                                }), f.forEach(function(t1) {
                                    var e1 = t1.length;
                                    t1.forEach(function(t1, r) {
                                        t1.depth == f.length - 1 && 1 == e1 || 0 == t1.depth && 1 == e1 ? (t1.y0 = l / 2 - t1.value * h, t1.y1 = t1.y0 + t1.value * h) : t1.partOfCycle ? 0 == z(t1, i) ? (t1.y0 = l / 2 + r, t1.y1 = t1.y0 + t1.value * h) : "top" == t1.circularLinkType ? (t1.y0 = a + r, t1.y1 = t1.y0 + t1.value * h) : (t1.y0 = l - t1.value * h - r, t1.y1 = t1.y0 + t1.value * h) : 0 == p.top || 0 == p.bottom ? (t1.y0 = (l - a) / e1 * r, t1.y1 = t1.y0 + t1.value * h) : (t1.y0 = (l - a) / 2 - e1 / 2 + r, t1.y1 = t1.y0 + t1.value * h);
                                    });
                                });
                            })(h), g();
                            for(var p = 1, d = u; d > 0; --d)m(p *= .99, h), g();
                            function m(t1, e1) {
                                var r = f.length;
                                f.forEach(function(i) {
                                    var a = i.length, o = i[0].depth;
                                    i.forEach(function(i) {
                                        var s;
                                        if (i.sourceLinks.length || i.targetLinks.length) {
                                            if (i.partOfCycle && z(i, e1) > 0) ;
                                            else if (0 == o && 1 == a) s = i.y1 - i.y0, i.y0 = l / 2 - s / 2, i.y1 = l / 2 + s / 2;
                                            else if (o == r - 1 && 1 == a) s = i.y1 - i.y0, i.y0 = l / 2 - s / 2, i.y1 = l / 2 + s / 2;
                                            else {
                                                var c = (0, n.i2)(i.sourceLinks, b), u = (0, n.i2)(i.targetLinks, _), h = ((c && u ? (c + u) / 2 : c || u) - x(i)) * t1;
                                                i.y0 += h, i.y1 += h;
                                            }
                                        }
                                    });
                                });
                            }
                            function g() {
                                f.forEach(function(e1) {
                                    var r, n, i, o = a, s = e1.length;
                                    for(e1.sort(y), i = 0; i < s; ++i)(n = o - (r = e1[i]).y0) > 0 && (r.y0 += n, r.y1 += n), o = r.y1 + t1;
                                    if ((n = o - t1 - l) > 0) for(o = r.y0 -= n, r.y1 -= n, i = s - 2; i >= 0; --i)(n = (r = e1[i]).y1 + t1 - o) > 0 && (r.y0 -= n, r.y1 -= n), o = r.y0;
                                });
                            }
                        }(h, P, u), B(h);
                        for(var p = 0; p < 4; p++)Y(h, l, u), X(h, 0, u), Z(h, a, l, u), Y(h, l, u), X(h, 0, u);
                        return function(t1, e1, r) {
                            var i = t1.nodes, a = t1.links, o = !1, s = !1;
                            if (a.forEach(function(t1) {
                                "top" == t1.circularLinkType ? o = !0 : "bottom" == t1.circularLinkType && (s = !0);
                            }), 0 == o || 0 == s) {
                                var l = (0, n.jk)(i, function(t1) {
                                    return t1.y0;
                                }), c = (r - e1) / ((0, n.T9)(i, function(t1) {
                                    return t1.y1;
                                }) - l);
                                i.forEach(function(t1) {
                                    var e1 = (t1.y1 - t1.y0) * c;
                                    t1.y0 = (t1.y0 - l) * c, t1.y1 = t1.y0 + e1;
                                }), a.forEach(function(t1) {
                                    t1.y0 = (t1.y0 - l) * c, t1.y1 = (t1.y1 - l) * c, t1.width = t1.width * c;
                                });
                            }
                        }(h, a, l), R(h, O, l, u), h;
                    }
                    function B(t1) {
                        t1.nodes.forEach(function(t1) {
                            t1.sourceLinks.sort(g), t1.targetLinks.sort(m);
                        }), t1.nodes.forEach(function(t1) {
                            var e1 = t1.y0, r = e1, n = t1.y1, i = n;
                            t1.sourceLinks.forEach(function(t1) {
                                t1.circular ? (t1.y0 = n - t1.width / 2, n -= t1.width) : (t1.y0 = e1 + t1.width / 2, e1 += t1.width);
                            }), t1.targetLinks.forEach(function(t1) {
                                t1.circular ? (t1.y1 = i - t1.width / 2, i -= t1.width) : (t1.y1 = r + t1.width / 2, r += t1.width);
                            });
                        });
                    }
                    return F.nodeId = function(t1) {
                        return arguments.length ? (u = "function" == typeof t1 ? t1 : p(t1), F) : u;
                    }, F.nodeAlign = function(t1) {
                        return arguments.length ? (f = "function" == typeof t1 ? t1 : p(t1), F) : f;
                    }, F.nodeWidth = function(t1) {
                        return arguments.length ? (c = +t1, F) : c;
                    }, F.nodePadding = function(e1) {
                        return arguments.length ? (t1 = +e1, F) : t1;
                    }, F.nodes = function(t1) {
                        return arguments.length ? (M = "function" == typeof t1 ? t1 : p(t1), F) : M;
                    }, F.links = function(t1) {
                        return arguments.length ? (L = "function" == typeof t1 ? t1 : p(t1), F) : L;
                    }, F.size = function(t1) {
                        return arguments.length ? (r = a = 0, o = +t1[0], l = +t1[1], F) : [
                            o - r,
                            l - a
                        ];
                    }, F.extent = function(t1) {
                        return arguments.length ? (r = +t1[0][0], o = +t1[1][0], a = +t1[0][1], l = +t1[1][1], F) : [
                            [
                                r,
                                a
                            ],
                            [
                                o,
                                l
                            ]
                        ];
                    }, F.iterations = function(t1) {
                        return arguments.length ? (P = +t1, F) : P;
                    }, F.circularLinkGap = function(t1) {
                        return arguments.length ? (O = +t1, F) : O;
                    }, F.nodePaddingRatio = function(t1) {
                        return arguments.length ? (e1 = +t1, F) : e1;
                    }, F.sortNodes = function(t1) {
                        return arguments.length ? (D = t1, F) : D;
                    }, F.update = function(t1) {
                        return I(t1, u), B(t1), t1.links.forEach(function(t1) {
                            t1.circular && (t1.circularLinkType = t1.y0 + t1.y1 < l ? "top" : "bottom", t1.source.circularLinkType = t1.circularLinkType, t1.target.circularLinkType = t1.circularLinkType);
                        }), Y(t1, l, u, !1), X(t1, 0, u), R(t1, O, l, u), t1;
                    }, F;
                }
                function I(t1, e1) {
                    var r = 0, n = 0;
                    t1.links.forEach(function(i) {
                        i.circular && (i.source.circularLinkType || i.target.circularLinkType ? i.circularLinkType = i.source.circularLinkType ? i.source.circularLinkType : i.target.circularLinkType : i.circularLinkType = r < n ? "top" : "bottom", "top" == i.circularLinkType ? r += 1 : n += 1, t1.nodes.forEach(function(t1) {
                            M(t1, e1) != M(i.source, e1) && M(t1, e1) != M(i.target, e1) || (t1.circularLinkType = i.circularLinkType);
                        }));
                    }), t1.links.forEach(function(t1) {
                        t1.circular && (t1.source.circularLinkType == t1.target.circularLinkType && (t1.circularLinkType = t1.source.circularLinkType), K(t1, e1) && (t1.circularLinkType = t1.source.circularLinkType));
                    });
                }
                function P(t1) {
                    var e1 = Math.abs(t1.y1 - t1.y0), r = Math.abs(t1.target.x0 - t1.source.x1);
                    return Math.atan(r / e1);
                }
                function z(t1, e1) {
                    var r = 0;
                    t1.sourceLinks.forEach(function(t1) {
                        r = t1.circular && !K(t1, e1) ? r + 1 : r;
                    });
                    var n = 0;
                    return t1.targetLinks.forEach(function(t1) {
                        n = t1.circular && !K(t1, e1) ? n + 1 : n;
                    }), r + n;
                }
                function O(t1) {
                    var e1 = t1.source.sourceLinks, r = 0;
                    e1.forEach(function(t1) {
                        r = t1.circular ? r + 1 : r;
                    });
                    var n = t1.target.targetLinks, i = 0;
                    return n.forEach(function(t1) {
                        i = t1.circular ? i + 1 : i;
                    }), !(r > 1 || i > 1);
                }
                function D(t1, e1, r) {
                    return t1.sort(F), t1.forEach(function(n, i) {
                        var a, o, s = 0;
                        if (K(n, r) && O(n)) n.circularPathData.verticalBuffer = s + n.width / 2;
                        else {
                            for(var l = 0; l < i; l++)if (a = t1[i], o = t1[l], !(a.source.column < o.target.column || a.target.column > o.source.column)) {
                                var c = t1[l].circularPathData.verticalBuffer + t1[l].width / 2 + e1;
                                s = c > s ? c : s;
                            }
                            n.circularPathData.verticalBuffer = s + n.width / 2;
                        }
                    }), t1;
                }
                function R(t1, e1, r, i) {
                    var o = (0, n.jk)(t1.links, function(t1) {
                        return t1.source.y0;
                    });
                    t1.links.forEach(function(t1) {
                        t1.circular && (t1.circularPathData = {});
                    }), D(t1.links.filter(function(t1) {
                        return "top" == t1.circularLinkType;
                    }), e1, i), D(t1.links.filter(function(t1) {
                        return "bottom" == t1.circularLinkType;
                    }), e1, i), t1.links.forEach(function(n) {
                        if (n.circular) {
                            if (n.circularPathData.arcRadius = n.width + E, n.circularPathData.leftNodeBuffer = 5, n.circularPathData.rightNodeBuffer = 5, n.circularPathData.sourceWidth = n.source.x1 - n.source.x0, n.circularPathData.sourceX = n.source.x0 + n.circularPathData.sourceWidth, n.circularPathData.targetX = n.target.x0, n.circularPathData.sourceY = n.y0, n.circularPathData.targetY = n.y1, K(n, i) && O(n)) n.circularPathData.leftSmallArcRadius = E + n.width / 2, n.circularPathData.leftLargeArcRadius = E + n.width / 2, n.circularPathData.rightSmallArcRadius = E + n.width / 2, n.circularPathData.rightLargeArcRadius = E + n.width / 2, "bottom" == n.circularLinkType ? (n.circularPathData.verticalFullExtent = n.source.y1 + S + n.circularPathData.verticalBuffer, n.circularPathData.verticalLeftInnerExtent = n.circularPathData.verticalFullExtent - n.circularPathData.leftLargeArcRadius, n.circularPathData.verticalRightInnerExtent = n.circularPathData.verticalFullExtent - n.circularPathData.rightLargeArcRadius) : (n.circularPathData.verticalFullExtent = n.source.y0 - S - n.circularPathData.verticalBuffer, n.circularPathData.verticalLeftInnerExtent = n.circularPathData.verticalFullExtent + n.circularPathData.leftLargeArcRadius, n.circularPathData.verticalRightInnerExtent = n.circularPathData.verticalFullExtent + n.circularPathData.rightLargeArcRadius);
                            else {
                                var s = n.source.column, l = n.circularLinkType, c = t1.links.filter(function(t1) {
                                    return t1.source.column == s && t1.circularLinkType == l;
                                });
                                "bottom" == n.circularLinkType ? c.sort(N) : c.sort(B);
                                var u = 0;
                                c.forEach(function(t1, r) {
                                    t1.circularLinkID == n.circularLinkID && (n.circularPathData.leftSmallArcRadius = E + n.width / 2 + u, n.circularPathData.leftLargeArcRadius = E + n.width / 2 + r * e1 + u), u += t1.width;
                                }), s = n.target.column, c = t1.links.filter(function(t1) {
                                    return t1.target.column == s && t1.circularLinkType == l;
                                }), "bottom" == n.circularLinkType ? c.sort(U) : c.sort(j), u = 0, c.forEach(function(t1, r) {
                                    t1.circularLinkID == n.circularLinkID && (n.circularPathData.rightSmallArcRadius = E + n.width / 2 + u, n.circularPathData.rightLargeArcRadius = E + n.width / 2 + r * e1 + u), u += t1.width;
                                }), "bottom" == n.circularLinkType ? (n.circularPathData.verticalFullExtent = Math.max(r, n.source.y1, n.target.y1) + S + n.circularPathData.verticalBuffer, n.circularPathData.verticalLeftInnerExtent = n.circularPathData.verticalFullExtent - n.circularPathData.leftLargeArcRadius, n.circularPathData.verticalRightInnerExtent = n.circularPathData.verticalFullExtent - n.circularPathData.rightLargeArcRadius) : (n.circularPathData.verticalFullExtent = o - S - n.circularPathData.verticalBuffer, n.circularPathData.verticalLeftInnerExtent = n.circularPathData.verticalFullExtent + n.circularPathData.leftLargeArcRadius, n.circularPathData.verticalRightInnerExtent = n.circularPathData.verticalFullExtent + n.circularPathData.rightLargeArcRadius);
                            }
                            n.circularPathData.leftInnerExtent = n.circularPathData.sourceX + n.circularPathData.leftNodeBuffer, n.circularPathData.rightInnerExtent = n.circularPathData.targetX - n.circularPathData.rightNodeBuffer, n.circularPathData.leftFullExtent = n.circularPathData.sourceX + n.circularPathData.leftLargeArcRadius + n.circularPathData.leftNodeBuffer, n.circularPathData.rightFullExtent = n.circularPathData.targetX - n.circularPathData.rightLargeArcRadius - n.circularPathData.rightNodeBuffer;
                        }
                        if (n.circular) n.path = function(t1) {
                            return "top" == t1.circularLinkType ? "M" + t1.circularPathData.sourceX + " " + t1.circularPathData.sourceY + " L" + t1.circularPathData.leftInnerExtent + " " + t1.circularPathData.sourceY + " A" + t1.circularPathData.leftLargeArcRadius + " " + t1.circularPathData.leftSmallArcRadius + " 0 0 0 " + t1.circularPathData.leftFullExtent + " " + (t1.circularPathData.sourceY - t1.circularPathData.leftSmallArcRadius) + " L" + t1.circularPathData.leftFullExtent + " " + t1.circularPathData.verticalLeftInnerExtent + " A" + t1.circularPathData.leftLargeArcRadius + " " + t1.circularPathData.leftLargeArcRadius + " 0 0 0 " + t1.circularPathData.leftInnerExtent + " " + t1.circularPathData.verticalFullExtent + " L" + t1.circularPathData.rightInnerExtent + " " + t1.circularPathData.verticalFullExtent + " A" + t1.circularPathData.rightLargeArcRadius + " " + t1.circularPathData.rightLargeArcRadius + " 0 0 0 " + t1.circularPathData.rightFullExtent + " " + t1.circularPathData.verticalRightInnerExtent + " L" + t1.circularPathData.rightFullExtent + " " + (t1.circularPathData.targetY - t1.circularPathData.rightSmallArcRadius) + " A" + t1.circularPathData.rightLargeArcRadius + " " + t1.circularPathData.rightSmallArcRadius + " 0 0 0 " + t1.circularPathData.rightInnerExtent + " " + t1.circularPathData.targetY + " L" + t1.circularPathData.targetX + " " + t1.circularPathData.targetY : "M" + t1.circularPathData.sourceX + " " + t1.circularPathData.sourceY + " L" + t1.circularPathData.leftInnerExtent + " " + t1.circularPathData.sourceY + " A" + t1.circularPathData.leftLargeArcRadius + " " + t1.circularPathData.leftSmallArcRadius + " 0 0 1 " + t1.circularPathData.leftFullExtent + " " + (t1.circularPathData.sourceY + t1.circularPathData.leftSmallArcRadius) + " L" + t1.circularPathData.leftFullExtent + " " + t1.circularPathData.verticalLeftInnerExtent + " A" + t1.circularPathData.leftLargeArcRadius + " " + t1.circularPathData.leftLargeArcRadius + " 0 0 1 " + t1.circularPathData.leftInnerExtent + " " + t1.circularPathData.verticalFullExtent + " L" + t1.circularPathData.rightInnerExtent + " " + t1.circularPathData.verticalFullExtent + " A" + t1.circularPathData.rightLargeArcRadius + " " + t1.circularPathData.rightLargeArcRadius + " 0 0 1 " + t1.circularPathData.rightFullExtent + " " + t1.circularPathData.verticalRightInnerExtent + " L" + t1.circularPathData.rightFullExtent + " " + (t1.circularPathData.targetY + t1.circularPathData.rightSmallArcRadius) + " A" + t1.circularPathData.rightLargeArcRadius + " " + t1.circularPathData.rightSmallArcRadius + " 0 0 1 " + t1.circularPathData.rightInnerExtent + " " + t1.circularPathData.targetY + " L" + t1.circularPathData.targetX + " " + t1.circularPathData.targetY;
                        }(n);
                        else {
                            var h = (0, a.pq)().source(function(t1) {
                                return [
                                    t1.source.x0 + (t1.source.x1 - t1.source.x0),
                                    t1.y0
                                ];
                            }).target(function(t1) {
                                return [
                                    t1.target.x0,
                                    t1.y1
                                ];
                            });
                            n.path = h(n);
                        }
                    });
                }
                function F(t1, e1) {
                    return V(t1) == V(e1) ? "bottom" == t1.circularLinkType ? N(t1, e1) : B(t1, e1) : V(e1) - V(t1);
                }
                function B(t1, e1) {
                    return t1.y0 - e1.y0;
                }
                function N(t1, e1) {
                    return e1.y0 - t1.y0;
                }
                function j(t1, e1) {
                    return t1.y1 - e1.y1;
                }
                function U(t1, e1) {
                    return e1.y1 - t1.y1;
                }
                function V(t1) {
                    return t1.target.column - t1.source.column;
                }
                function q(t1) {
                    return t1.target.x0 - t1.source.x1;
                }
                function H(t1, e1) {
                    var r = P(t1), n = q(e1) / Math.tan(r);
                    return "up" == J(t1) ? t1.y1 + n : t1.y1 - n;
                }
                function G(t1, e1) {
                    var r = P(t1), n = q(e1) / Math.tan(r);
                    return "up" == J(t1) ? t1.y1 - n : t1.y1 + n;
                }
                function Z(t1, e1, r, n) {
                    t1.links.forEach(function(i) {
                        if (!i.circular && i.target.column - i.source.column > 1) {
                            var a = i.source.column + 1, o = i.target.column - 1, s = 1, l = o - a + 1;
                            for(s = 1; a <= o; a++, s++)t1.nodes.forEach(function(o) {
                                if (o.column == a) {
                                    var c, u = s / (l + 1), h = Math.pow(1 - u, 3), f = 3 * u * Math.pow(1 - u, 2), p = 3 * Math.pow(u, 2) * (1 - u), d = Math.pow(u, 3), m = h * i.y0 + f * i.y0 + p * i.y1 + d * i.y1, g = m - i.width / 2, y = m + i.width / 2;
                                    g > o.y0 && g < o.y1 ? (c = o.y1 - g + 10, c = "bottom" == o.circularLinkType ? c : -c, o = W(o, c, e1, r), t1.nodes.forEach(function(t1) {
                                        var i, a;
                                        M(t1, n) != M(o, n) && t1.column == o.column && (a = t1, (i = o).y0 > a.y0 && i.y0 < a.y1 || i.y1 > a.y0 && i.y1 < a.y1 || i.y0 < a.y0 && i.y1 > a.y1) && W(t1, c, e1, r);
                                    })) : (y > o.y0 && y < o.y1 || g < o.y0 && y > o.y1) && (c = y - o.y0 + 10, o = W(o, c, e1, r), t1.nodes.forEach(function(t1) {
                                        M(t1, n) != M(o, n) && t1.column == o.column && t1.y0 < o.y1 && t1.y1 > o.y1 && W(t1, c, e1, r);
                                    }));
                                }
                            });
                        }
                    });
                }
                function W(t1, e1, r, n) {
                    return t1.y0 + e1 >= r && t1.y1 + e1 <= n && (t1.y0 = t1.y0 + e1, t1.y1 = t1.y1 + e1, t1.targetLinks.forEach(function(t1) {
                        t1.y1 = t1.y1 + e1;
                    }), t1.sourceLinks.forEach(function(t1) {
                        t1.y0 = t1.y0 + e1;
                    })), t1;
                }
                function Y(t1, e1, r, n) {
                    t1.nodes.forEach(function(i) {
                        n && i.y + (i.y1 - i.y0) > e1 && (i.y = i.y - (i.y + (i.y1 - i.y0) - e1));
                        var a = t1.links.filter(function(t1) {
                            return M(t1.source, r) == M(i, r);
                        }), o = a.length;
                        o > 1 && a.sort(function(t1, e1) {
                            if (!t1.circular && !e1.circular) {
                                if (t1.target.column == e1.target.column) return t1.y1 - e1.y1;
                                if (!$(t1, e1)) return t1.y1 - e1.y1;
                                if (t1.target.column > e1.target.column) {
                                    var r = G(e1, t1);
                                    return t1.y1 - r;
                                }
                                if (e1.target.column > t1.target.column) return G(t1, e1) - e1.y1;
                            }
                            return t1.circular && !e1.circular ? "top" == t1.circularLinkType ? -1 : 1 : e1.circular && !t1.circular ? "top" == e1.circularLinkType ? 1 : -1 : t1.circular && e1.circular ? t1.circularLinkType === e1.circularLinkType && "top" == t1.circularLinkType ? t1.target.column === e1.target.column ? t1.target.y1 - e1.target.y1 : e1.target.column - t1.target.column : t1.circularLinkType === e1.circularLinkType && "bottom" == t1.circularLinkType ? t1.target.column === e1.target.column ? e1.target.y1 - t1.target.y1 : t1.target.column - e1.target.column : "top" == t1.circularLinkType ? -1 : 1 : void 0;
                        });
                        var s = i.y0;
                        a.forEach(function(t1) {
                            t1.y0 = s + t1.width / 2, s += t1.width;
                        }), a.forEach(function(t1, e1) {
                            if ("bottom" == t1.circularLinkType) {
                                for(var r = e1 + 1, n = 0; r < o; r++)n += a[r].width;
                                t1.y0 = i.y1 - n - t1.width / 2;
                            }
                        });
                    });
                }
                function X(t1, e1, r) {
                    t1.nodes.forEach(function(e1) {
                        var n = t1.links.filter(function(t1) {
                            return M(t1.target, r) == M(e1, r);
                        }), i = n.length;
                        i > 1 && n.sort(function(t1, e1) {
                            if (!t1.circular && !e1.circular) {
                                if (t1.source.column == e1.source.column) return t1.y0 - e1.y0;
                                if (!$(t1, e1)) return t1.y0 - e1.y0;
                                if (e1.source.column < t1.source.column) {
                                    var r = H(e1, t1);
                                    return t1.y0 - r;
                                }
                                if (t1.source.column < e1.source.column) return H(t1, e1) - e1.y0;
                            }
                            return t1.circular && !e1.circular ? "top" == t1.circularLinkType ? -1 : 1 : e1.circular && !t1.circular ? "top" == e1.circularLinkType ? 1 : -1 : t1.circular && e1.circular ? t1.circularLinkType === e1.circularLinkType && "top" == t1.circularLinkType ? t1.source.column === e1.source.column ? t1.source.y1 - e1.source.y1 : t1.source.column - e1.source.column : t1.circularLinkType === e1.circularLinkType && "bottom" == t1.circularLinkType ? t1.source.column === e1.source.column ? t1.source.y1 - e1.source.y1 : e1.source.column - t1.source.column : "top" == t1.circularLinkType ? -1 : 1 : void 0;
                        });
                        var a = e1.y0;
                        n.forEach(function(t1) {
                            t1.y1 = a + t1.width / 2, a += t1.width;
                        }), n.forEach(function(t1, r) {
                            if ("bottom" == t1.circularLinkType) {
                                for(var a = r + 1, o = 0; a < i; a++)o += n[a].width;
                                t1.y1 = e1.y1 - o - t1.width / 2;
                            }
                        });
                    });
                }
                function $(t1, e1) {
                    return J(t1) == J(e1);
                }
                function J(t1) {
                    return t1.y0 - t1.y1 > 0 ? "up" : "down";
                }
                function K(t1, e1) {
                    return M(t1.source, e1) == M(t1.target, e1);
                }
            },
            62369: function(t1, e1, r) {
                "use strict";
                r.r(e1), r.d(e1, {
                    sankey: function() {
                        return w;
                    },
                    sankeyCenter: function() {
                        return c;
                    },
                    sankeyJustify: function() {
                        return l;
                    },
                    sankeyLeft: function() {
                        return o;
                    },
                    sankeyLinkHorizontal: function() {
                        return M;
                    },
                    sankeyRight: function() {
                        return s;
                    }
                });
                var n = r(29725), i = r(4575);
                function a(t1) {
                    return t1.target.depth;
                }
                function o(t1) {
                    return t1.depth;
                }
                function s(t1, e1) {
                    return e1 - 1 - t1.height;
                }
                function l(t1, e1) {
                    return t1.sourceLinks.length ? t1.depth : e1 - 1;
                }
                function c(t1) {
                    return t1.targetLinks.length ? t1.depth : t1.sourceLinks.length ? (0, n.jk)(t1.sourceLinks, a) - 1 : 0;
                }
                function u(t1) {
                    return function() {
                        return t1;
                    };
                }
                function h(t1, e1) {
                    return p(t1.source, e1.source) || t1.index - e1.index;
                }
                function f(t1, e1) {
                    return p(t1.target, e1.target) || t1.index - e1.index;
                }
                function p(t1, e1) {
                    return t1.y0 - e1.y0;
                }
                function d(t1) {
                    return t1.value;
                }
                function m(t1) {
                    return (t1.y0 + t1.y1) / 2;
                }
                function g(t1) {
                    return m(t1.source) * t1.value;
                }
                function y(t1) {
                    return m(t1.target) * t1.value;
                }
                function v(t1) {
                    return t1.index;
                }
                function x(t1) {
                    return t1.nodes;
                }
                function _(t1) {
                    return t1.links;
                }
                function b(t1, e1) {
                    var r = t1.get(e1);
                    if (!r) throw new Error("missing: " + e1);
                    return r;
                }
                function w() {
                    var t1 = 0, e1 = 0, r = 1, a = 1, o = 24, s = 8, c = v, w = l, T = x, k = _, A = 32;
                    function M() {
                        var l = {
                            nodes: T.apply(null, arguments),
                            links: k.apply(null, arguments)
                        };
                        return function(t1) {
                            t1.nodes.forEach(function(t1, e1) {
                                t1.index = e1, t1.sourceLinks = [], t1.targetLinks = [];
                            });
                            var e1 = (0, i.Tj)(t1.nodes, c);
                            t1.links.forEach(function(t1, r) {
                                t1.index = r;
                                var n = t1.source, i = t1.target;
                                "object" != typeof n && (n = t1.source = b(e1, n)), "object" != typeof i && (i = t1.target = b(e1, i)), n.sourceLinks.push(t1), i.targetLinks.push(t1);
                            });
                        }(l), function(t1) {
                            t1.nodes.forEach(function(t1) {
                                t1.value = Math.max((0, n.cz)(t1.sourceLinks, d), (0, n.cz)(t1.targetLinks, d));
                            });
                        }(l), function(e1) {
                            var n, i, a;
                            for(n = e1.nodes, i = [], a = 0; n.length; ++a, n = i, i = [])n.forEach(function(t1) {
                                t1.depth = a, t1.sourceLinks.forEach(function(t1) {
                                    i.indexOf(t1.target) < 0 && i.push(t1.target);
                                });
                            });
                            for(n = e1.nodes, i = [], a = 0; n.length; ++a, n = i, i = [])n.forEach(function(t1) {
                                t1.height = a, t1.targetLinks.forEach(function(t1) {
                                    i.indexOf(t1.source) < 0 && i.push(t1.source);
                                });
                            });
                            var s = (r - t1 - o) / (a - 1);
                            e1.nodes.forEach(function(e1) {
                                e1.x1 = (e1.x0 = t1 + Math.max(0, Math.min(a - 1, Math.floor(w.call(null, e1, a)))) * s) + o;
                            });
                        }(l), function(t1) {
                            var r = (0, i.$I)().key(function(t1) {
                                return t1.x0;
                            }).sortKeys(n.V_).entries(t1.nodes).map(function(t1) {
                                return t1.values;
                            });
                            (function() {
                                var i = (0, n.T9)(r, function(t1) {
                                    return t1.length;
                                }), o = .6666666666666666 * (a - e1) / (i - 1);
                                s > o && (s = o);
                                var l = (0, n.jk)(r, function(t1) {
                                    return (a - e1 - (t1.length - 1) * s) / (0, n.cz)(t1, d);
                                });
                                r.forEach(function(t1) {
                                    t1.forEach(function(t1, e1) {
                                        t1.y1 = (t1.y0 = e1) + t1.value * l;
                                    });
                                }), t1.links.forEach(function(t1) {
                                    t1.width = t1.value * l;
                                });
                            })(), h();
                            for(var o = 1, l = A; l > 0; --l)u(o *= .99), h(), c(o), h();
                            function c(t1) {
                                r.forEach(function(e1) {
                                    e1.forEach(function(e1) {
                                        if (e1.targetLinks.length) {
                                            var r = ((0, n.cz)(e1.targetLinks, g) / (0, n.cz)(e1.targetLinks, d) - m(e1)) * t1;
                                            e1.y0 += r, e1.y1 += r;
                                        }
                                    });
                                });
                            }
                            function u(t1) {
                                r.slice().reverse().forEach(function(e1) {
                                    e1.forEach(function(e1) {
                                        if (e1.sourceLinks.length) {
                                            var r = ((0, n.cz)(e1.sourceLinks, y) / (0, n.cz)(e1.sourceLinks, d) - m(e1)) * t1;
                                            e1.y0 += r, e1.y1 += r;
                                        }
                                    });
                                });
                            }
                            function h() {
                                r.forEach(function(t1) {
                                    var r, n, i, o = e1, l = t1.length;
                                    for(t1.sort(p), i = 0; i < l; ++i)(n = o - (r = t1[i]).y0) > 0 && (r.y0 += n, r.y1 += n), o = r.y1 + s;
                                    if ((n = o - s - a) > 0) for(o = r.y0 -= n, r.y1 -= n, i = l - 2; i >= 0; --i)(n = (r = t1[i]).y1 + s - o) > 0 && (r.y0 -= n, r.y1 -= n), o = r.y0;
                                });
                            }
                        }(l), S(l), l;
                    }
                    function S(t1) {
                        t1.nodes.forEach(function(t1) {
                            t1.sourceLinks.sort(f), t1.targetLinks.sort(h);
                        }), t1.nodes.forEach(function(t1) {
                            var e1 = t1.y0, r = e1;
                            t1.sourceLinks.forEach(function(t1) {
                                t1.y0 = e1 + t1.width / 2, e1 += t1.width;
                            }), t1.targetLinks.forEach(function(t1) {
                                t1.y1 = r + t1.width / 2, r += t1.width;
                            });
                        });
                    }
                    return M.update = function(t1) {
                        return S(t1), t1;
                    }, M.nodeId = function(t1) {
                        return arguments.length ? (c = "function" == typeof t1 ? t1 : u(t1), M) : c;
                    }, M.nodeAlign = function(t1) {
                        return arguments.length ? (w = "function" == typeof t1 ? t1 : u(t1), M) : w;
                    }, M.nodeWidth = function(t1) {
                        return arguments.length ? (o = +t1, M) : o;
                    }, M.nodePadding = function(t1) {
                        return arguments.length ? (s = +t1, M) : s;
                    }, M.nodes = function(t1) {
                        return arguments.length ? (T = "function" == typeof t1 ? t1 : u(t1), M) : T;
                    }, M.links = function(t1) {
                        return arguments.length ? (k = "function" == typeof t1 ? t1 : u(t1), M) : k;
                    }, M.size = function(n) {
                        return arguments.length ? (t1 = e1 = 0, r = +n[0], a = +n[1], M) : [
                            r - t1,
                            a - e1
                        ];
                    }, M.extent = function(n) {
                        return arguments.length ? (t1 = +n[0][0], r = +n[1][0], e1 = +n[0][1], a = +n[1][1], M) : [
                            [
                                t1,
                                e1
                            ],
                            [
                                r,
                                a
                            ]
                        ];
                    }, M.iterations = function(t1) {
                        return arguments.length ? (A = +t1, M) : A;
                    }, M;
                }
                var T = r(48544);
                function k(t1) {
                    return [
                        t1.source.x1,
                        t1.y0
                    ];
                }
                function A(t1) {
                    return [
                        t1.target.x0,
                        t1.y1
                    ];
                }
                function M() {
                    return (0, T.pq)().source(k).target(A);
                }
            },
            45568: function(t1, e1, r) {
                var n, i;
                (function() {
                    var a = {
                        version: "3.8.2"
                    }, o = [].slice, s = function(t1) {
                        return o.call(t1);
                    }, l = self.document;
                    function c(t1) {
                        return t1 && (t1.ownerDocument || t1.document || t1).documentElement;
                    }
                    function u(t1) {
                        return t1 && (t1.ownerDocument && t1.ownerDocument.defaultView || t1.document && t1 || t1.defaultView);
                    }
                    if (l) try {
                        s(l.documentElement.childNodes)[0].nodeType;
                    } catch (t1) {
                        s = function(t1) {
                            for(var e1 = t1.length, r = new Array(e1); e1--;)r[e1] = t1[e1];
                            return r;
                        };
                    }
                    if (Date.now || (Date.now = function() {
                        return +new Date;
                    }), l) try {
                        l.createElement("DIV").style.setProperty("opacity", 0, "");
                    } catch (t1) {
                        var h = this.Element.prototype, f = h.setAttribute, p = h.setAttributeNS, d = this.CSSStyleDeclaration.prototype, m = d.setProperty;
                        h.setAttribute = function(t1, e1) {
                            f.call(this, t1, e1 + "");
                        }, h.setAttributeNS = function(t1, e1, r) {
                            p.call(this, t1, e1, r + "");
                        }, d.setProperty = function(t1, e1, r) {
                            m.call(this, t1, e1 + "", r);
                        };
                    }
                    function g(t1, e1) {
                        return t1 < e1 ? -1 : t1 > e1 ? 1 : t1 >= e1 ? 0 : NaN;
                    }
                    function y(t1) {
                        return null === t1 ? NaN : +t1;
                    }
                    function v(t1) {
                        return !isNaN(t1);
                    }
                    function x(t1) {
                        return {
                            left: function(e1, r, n, i) {
                                for(arguments.length < 3 && (n = 0), arguments.length < 4 && (i = e1.length); n < i;){
                                    var a = n + i >>> 1;
                                    t1(e1[a], r) < 0 ? n = a + 1 : i = a;
                                }
                                return n;
                            },
                            right: function(e1, r, n, i) {
                                for(arguments.length < 3 && (n = 0), arguments.length < 4 && (i = e1.length); n < i;){
                                    var a = n + i >>> 1;
                                    t1(e1[a], r) > 0 ? i = a : n = a + 1;
                                }
                                return n;
                            }
                        };
                    }
                    a.ascending = g, a.descending = function(t1, e1) {
                        return e1 < t1 ? -1 : e1 > t1 ? 1 : e1 >= t1 ? 0 : NaN;
                    }, a.min = function(t1, e1) {
                        var r, n, i = -1, a = t1.length;
                        if (1 === arguments.length) {
                            for(; ++i < a;)if (null != (n = t1[i]) && n >= n) {
                                r = n;
                                break;
                            }
                            for(; ++i < a;)null != (n = t1[i]) && r > n && (r = n);
                        } else {
                            for(; ++i < a;)if (null != (n = e1.call(t1, t1[i], i)) && n >= n) {
                                r = n;
                                break;
                            }
                            for(; ++i < a;)null != (n = e1.call(t1, t1[i], i)) && r > n && (r = n);
                        }
                        return r;
                    }, a.max = function(t1, e1) {
                        var r, n, i = -1, a = t1.length;
                        if (1 === arguments.length) {
                            for(; ++i < a;)if (null != (n = t1[i]) && n >= n) {
                                r = n;
                                break;
                            }
                            for(; ++i < a;)null != (n = t1[i]) && n > r && (r = n);
                        } else {
                            for(; ++i < a;)if (null != (n = e1.call(t1, t1[i], i)) && n >= n) {
                                r = n;
                                break;
                            }
                            for(; ++i < a;)null != (n = e1.call(t1, t1[i], i)) && n > r && (r = n);
                        }
                        return r;
                    }, a.extent = function(t1, e1) {
                        var r, n, i, a = -1, o = t1.length;
                        if (1 === arguments.length) {
                            for(; ++a < o;)if (null != (n = t1[a]) && n >= n) {
                                r = i = n;
                                break;
                            }
                            for(; ++a < o;)null != (n = t1[a]) && (r > n && (r = n), i < n && (i = n));
                        } else {
                            for(; ++a < o;)if (null != (n = e1.call(t1, t1[a], a)) && n >= n) {
                                r = i = n;
                                break;
                            }
                            for(; ++a < o;)null != (n = e1.call(t1, t1[a], a)) && (r > n && (r = n), i < n && (i = n));
                        }
                        return [
                            r,
                            i
                        ];
                    }, a.sum = function(t1, e1) {
                        var r, n = 0, i = t1.length, a = -1;
                        if (1 === arguments.length) for(; ++a < i;)v(r = +t1[a]) && (n += r);
                        else for(; ++a < i;)v(r = +e1.call(t1, t1[a], a)) && (n += r);
                        return n;
                    }, a.mean = function(t1, e1) {
                        var r, n = 0, i = t1.length, a = -1, o = i;
                        if (1 === arguments.length) for(; ++a < i;)v(r = y(t1[a])) ? n += r : --o;
                        else for(; ++a < i;)v(r = y(e1.call(t1, t1[a], a))) ? n += r : --o;
                        if (o) return n / o;
                    }, a.quantile = function(t1, e1) {
                        var r = (t1.length - 1) * e1 + 1, n = Math.floor(r), i = +t1[n - 1], a = r - n;
                        return a ? i + a * (t1[n] - i) : i;
                    }, a.median = function(t1, e1) {
                        var r, n = [], i = t1.length, o = -1;
                        if (1 === arguments.length) for(; ++o < i;)v(r = y(t1[o])) && n.push(r);
                        else for(; ++o < i;)v(r = y(e1.call(t1, t1[o], o))) && n.push(r);
                        if (n.length) return a.quantile(n.sort(g), .5);
                    }, a.variance = function(t1, e1) {
                        var r, n, i = t1.length, a = 0, o = 0, s = -1, l = 0;
                        if (1 === arguments.length) for(; ++s < i;)v(r = y(t1[s])) && (o += (n = r - a) * (r - (a += n / ++l)));
                        else for(; ++s < i;)v(r = y(e1.call(t1, t1[s], s))) && (o += (n = r - a) * (r - (a += n / ++l)));
                        if (l > 1) return o / (l - 1);
                    }, a.deviation = function() {
                        var t1 = a.variance.apply(this, arguments);
                        return t1 ? Math.sqrt(t1) : t1;
                    };
                    var _ = x(g);
                    function b(t1) {
                        return t1.length;
                    }
                    a.bisectLeft = _.left, a.bisect = a.bisectRight = _.right, a.bisector = function(t1) {
                        return x(1 === t1.length ? function(e1, r) {
                            return g(t1(e1), r);
                        } : t1);
                    }, a.shuffle = function(t1, e1, r) {
                        (a = arguments.length) < 3 && (r = t1.length, a < 2 && (e1 = 0));
                        for(var n, i, a = r - e1; a;)i = Math.random() * a-- | 0, n = t1[a + e1], t1[a + e1] = t1[i + e1], t1[i + e1] = n;
                        return t1;
                    }, a.permute = function(t1, e1) {
                        for(var r = e1.length, n = new Array(r); r--;)n[r] = t1[e1[r]];
                        return n;
                    }, a.pairs = function(t1) {
                        for(var e1 = 0, r = t1.length - 1, n = t1[0], i = new Array(r < 0 ? 0 : r); e1 < r;)i[e1] = [
                            n,
                            n = t1[++e1]
                        ];
                        return i;
                    }, a.transpose = function(t1) {
                        if (!(i = t1.length)) return [];
                        for(var e1 = -1, r = a.min(t1, b), n = new Array(r); ++e1 < r;)for(var i, o = -1, s = n[e1] = new Array(i); ++o < i;)s[o] = t1[o][e1];
                        return n;
                    }, a.zip = function() {
                        return a.transpose(arguments);
                    }, a.keys = function(t1) {
                        var e1 = [];
                        for(var r in t1)e1.push(r);
                        return e1;
                    }, a.values = function(t1) {
                        var e1 = [];
                        for(var r in t1)e1.push(t1[r]);
                        return e1;
                    }, a.entries = function(t1) {
                        var e1 = [];
                        for(var r in t1)e1.push({
                            key: r,
                            value: t1[r]
                        });
                        return e1;
                    }, a.merge = function(t1) {
                        for(var e1, r, n, i = t1.length, a = -1, o = 0; ++a < i;)o += t1[a].length;
                        for(r = new Array(o); --i >= 0;)for(e1 = (n = t1[i]).length; --e1 >= 0;)r[--o] = n[e1];
                        return r;
                    };
                    var w = Math.abs;
                    function T(t1, e1) {
                        for(var r in e1)Object.defineProperty(t1.prototype, r, {
                            value: e1[r],
                            enumerable: !1
                        });
                    }
                    function k() {
                        this._ = Object.create(null);
                    }
                    a.range = function(t1, e1, r) {
                        if (arguments.length < 3 && (r = 1, arguments.length < 2 && (e1 = t1, t1 = 0)), (e1 - t1) / r == 1 / 0) throw new Error("infinite range");
                        var n, i = [], a = function(t1) {
                            for(var e1 = 1; t1 * e1 % 1;)e1 *= 10;
                            return e1;
                        }(w(r)), o = -1;
                        if (t1 *= a, e1 *= a, (r *= a) < 0) for(; (n = t1 + r * ++o) > e1;)i.push(n / a);
                        else for(; (n = t1 + r * ++o) < e1;)i.push(n / a);
                        return i;
                    }, a.map = function(t1, e1) {
                        var r = new k;
                        if (t1 instanceof k) t1.forEach(function(t1, e1) {
                            r.set(t1, e1);
                        });
                        else if (Array.isArray(t1)) {
                            var n, i = -1, a = t1.length;
                            if (1 === arguments.length) for(; ++i < a;)r.set(i, t1[i]);
                            else for(; ++i < a;)r.set(e1.call(t1, n = t1[i], i), n);
                        } else for(var o in t1)r.set(o, t1[o]);
                        return r;
                    };
                    var A = "__proto__", M = "\0";
                    function S(t1) {
                        return (t1 += "") === A || t1[0] === M ? M + t1 : t1;
                    }
                    function E(t1) {
                        return (t1 += "")[0] === M ? t1.slice(1) : t1;
                    }
                    function C(t1) {
                        return S(t1) in this._;
                    }
                    function L(t1) {
                        return (t1 = S(t1)) in this._ && delete this._[t1];
                    }
                    function I() {
                        var t1 = [];
                        for(var e1 in this._)t1.push(E(e1));
                        return t1;
                    }
                    function P() {
                        var t1 = 0;
                        for(var e1 in this._)++t1;
                        return t1;
                    }
                    function z() {
                        for(var t1 in this._)return !1;
                        return !0;
                    }
                    function O() {
                        this._ = Object.create(null);
                    }
                    function D(t1) {
                        return t1;
                    }
                    function R(t1, e1, r) {
                        return function() {
                            var n = r.apply(e1, arguments);
                            return n === e1 ? t1 : n;
                        };
                    }
                    function F(t1, e1) {
                        if (e1 in t1) return e1;
                        e1 = e1.charAt(0).toUpperCase() + e1.slice(1);
                        for(var r = 0, n = B.length; r < n; ++r){
                            var i = B[r] + e1;
                            if (i in t1) return i;
                        }
                    }
                    T(k, {
                        has: C,
                        get: function(t1) {
                            return this._[S(t1)];
                        },
                        set: function(t1, e1) {
                            return this._[S(t1)] = e1;
                        },
                        remove: L,
                        keys: I,
                        values: function() {
                            var t1 = [];
                            for(var e1 in this._)t1.push(this._[e1]);
                            return t1;
                        },
                        entries: function() {
                            var t1 = [];
                            for(var e1 in this._)t1.push({
                                key: E(e1),
                                value: this._[e1]
                            });
                            return t1;
                        },
                        size: P,
                        empty: z,
                        forEach: function(t1) {
                            for(var e1 in this._)t1.call(this, E(e1), this._[e1]);
                        }
                    }), a.nest = function() {
                        var t1, e1, r = {}, n = [], i = [];
                        function o(i, a, s) {
                            if (s >= n.length) return e1 ? e1.call(r, a) : t1 ? a.sort(t1) : a;
                            for(var l, c, u, h, f = -1, p = a.length, d = n[s++], m = new k; ++f < p;)(h = m.get(l = d(c = a[f]))) ? h.push(c) : m.set(l, [
                                c
                            ]);
                            return i ? (c = i(), u = function(t1, e1) {
                                c.set(t1, o(i, e1, s));
                            }) : (c = {}, u = function(t1, e1) {
                                c[t1] = o(i, e1, s);
                            }), m.forEach(u), c;
                        }
                        function s(t1, e1) {
                            if (e1 >= n.length) return t1;
                            var r = [], a = i[e1++];
                            return t1.forEach(function(t1, n) {
                                r.push({
                                    key: t1,
                                    values: s(n, e1)
                                });
                            }), a ? r.sort(function(t1, e1) {
                                return a(t1.key, e1.key);
                            }) : r;
                        }
                        return r.map = function(t1, e1) {
                            return o(e1, t1, 0);
                        }, r.entries = function(t1) {
                            return s(o(a.map, t1, 0), 0);
                        }, r.key = function(t1) {
                            return n.push(t1), r;
                        }, r.sortKeys = function(t1) {
                            return i[n.length - 1] = t1, r;
                        }, r.sortValues = function(e1) {
                            return t1 = e1, r;
                        }, r.rollup = function(t1) {
                            return e1 = t1, r;
                        }, r;
                    }, a.set = function(t1) {
                        var e1 = new O;
                        if (t1) for(var r = 0, n = t1.length; r < n; ++r)e1.add(t1[r]);
                        return e1;
                    }, T(O, {
                        has: C,
                        add: function(t1) {
                            return this._[S(t1 += "")] = !0, t1;
                        },
                        remove: L,
                        values: I,
                        size: P,
                        empty: z,
                        forEach: function(t1) {
                            for(var e1 in this._)t1.call(this, E(e1));
                        }
                    }), a.behavior = {}, a.rebind = function(t1, e1) {
                        for(var r, n = 1, i = arguments.length; ++n < i;)t1[r = arguments[n]] = R(t1, e1, e1[r]);
                        return t1;
                    };
                    var B = [
                        "webkit",
                        "ms",
                        "moz",
                        "Moz",
                        "o",
                        "O"
                    ];
                    function N() {}
                    function j() {}
                    function U(t1) {
                        var e1 = [], r = new k;
                        function n() {
                            for(var r, n = e1, i = -1, a = n.length; ++i < a;)(r = n[i].on) && r.apply(this, arguments);
                            return t1;
                        }
                        return n.on = function(n, i) {
                            var a, o = r.get(n);
                            return arguments.length < 2 ? o && o.on : (o && (o.on = null, e1 = e1.slice(0, a = e1.indexOf(o)).concat(e1.slice(a + 1)), r.remove(n)), i && e1.push(r.set(n, {
                                on: i
                            })), t1);
                        }, n;
                    }
                    function V() {
                        a.event.preventDefault();
                    }
                    function q() {
                        for(var t1, e1 = a.event; t1 = e1.sourceEvent;)e1 = t1;
                        return e1;
                    }
                    function H(t1) {
                        for(var e1 = new j, r = 0, n = arguments.length; ++r < n;)e1[arguments[r]] = U(e1);
                        return e1.of = function(r, n) {
                            return function(i) {
                                try {
                                    var o = i.sourceEvent = a.event;
                                    i.target = t1, a.event = i, e1[i.type].apply(r, n);
                                } finally{
                                    a.event = o;
                                }
                            };
                        }, e1;
                    }
                    a.dispatch = function() {
                        for(var t1 = new j, e1 = -1, r = arguments.length; ++e1 < r;)t1[arguments[e1]] = U(t1);
                        return t1;
                    }, j.prototype.on = function(t1, e1) {
                        var r = t1.indexOf("."), n = "";
                        if (r >= 0 && (n = t1.slice(r + 1), t1 = t1.slice(0, r)), t1) return arguments.length < 2 ? this[t1].on(n) : this[t1].on(n, e1);
                        if (2 === arguments.length) {
                            if (null == e1) for(t1 in this)this.hasOwnProperty(t1) && this[t1].on(n, null);
                            return this;
                        }
                    }, a.event = null, a.requote = function(t1) {
                        return t1.replace(G, "\\$&");
                    };
                    var G = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g, Z = {}.__proto__ ? function(t1, e1) {
                        t1.__proto__ = e1;
                    } : function(t1, e1) {
                        for(var r in e1)t1[r] = e1[r];
                    };
                    function W(t1) {
                        return Z(t1, J), t1;
                    }
                    var Y = function(t1, e1) {
                        return e1.querySelector(t1);
                    }, X = function(t1, e1) {
                        return e1.querySelectorAll(t1);
                    }, $ = function(t1, e1) {
                        var r = t1.matches || t1[F(t1, "matchesSelector")];
                        return $ = function(t1, e1) {
                            return r.call(t1, e1);
                        }, $(t1, e1);
                    };
                    "function" == typeof Sizzle && (Y = function(t1, e1) {
                        return Sizzle(t1, e1)[0] || null;
                    }, X = Sizzle, $ = Sizzle.matchesSelector), a.selection = function() {
                        return a.select(l.documentElement);
                    };
                    var J = a.selection.prototype = [];
                    function K(t1) {
                        return "function" == typeof t1 ? t1 : function() {
                            return Y(t1, this);
                        };
                    }
                    function Q(t1) {
                        return "function" == typeof t1 ? t1 : function() {
                            return X(t1, this);
                        };
                    }
                    J.select = function(t1) {
                        var e1, r, n, i, a = [];
                        t1 = K(t1);
                        for(var o = -1, s = this.length; ++o < s;){
                            a.push(e1 = []), e1.parentNode = (n = this[o]).parentNode;
                            for(var l = -1, c = n.length; ++l < c;)(i = n[l]) ? (e1.push(r = t1.call(i, i.__data__, l, o)), r && "__data__" in i && (r.__data__ = i.__data__)) : e1.push(null);
                        }
                        return W(a);
                    }, J.selectAll = function(t1) {
                        var e1, r, n = [];
                        t1 = Q(t1);
                        for(var i = -1, a = this.length; ++i < a;)for(var o = this[i], l = -1, c = o.length; ++l < c;)(r = o[l]) && (n.push(e1 = s(t1.call(r, r.__data__, l, i))), e1.parentNode = r);
                        return W(n);
                    };
                    var tt = "http://www.w3.org/1999/xhtml", et = {
                        svg: "http://www.w3.org/2000/svg",
                        xhtml: tt,
                        xlink: "http://www.w3.org/1999/xlink",
                        xml: "http://www.w3.org/XML/1998/namespace",
                        xmlns: "http://www.w3.org/2000/xmlns/"
                    };
                    function rt(t1, e1) {
                        return t1 = a.ns.qualify(t1), null == e1 ? t1.local ? function() {
                            this.removeAttributeNS(t1.space, t1.local);
                        } : function() {
                            this.removeAttribute(t1);
                        } : "function" == typeof e1 ? t1.local ? function() {
                            var r = e1.apply(this, arguments);
                            null == r ? this.removeAttributeNS(t1.space, t1.local) : this.setAttributeNS(t1.space, t1.local, r);
                        } : function() {
                            var r = e1.apply(this, arguments);
                            null == r ? this.removeAttribute(t1) : this.setAttribute(t1, r);
                        } : t1.local ? function() {
                            this.setAttributeNS(t1.space, t1.local, e1);
                        } : function() {
                            this.setAttribute(t1, e1);
                        };
                    }
                    function nt(t1) {
                        return t1.trim().replace(/\s+/g, " ");
                    }
                    function it(t1) {
                        return new RegExp("(?:^|\\s+)" + a.requote(t1) + "(?:\\s+|$)", "g");
                    }
                    function at(t1) {
                        return (t1 + "").trim().split(/^|\s+/);
                    }
                    function ot(t1, e1) {
                        var r = (t1 = at(t1).map(st)).length;
                        return "function" == typeof e1 ? function() {
                            for(var n = -1, i = e1.apply(this, arguments); ++n < r;)t1[n](this, i);
                        } : function() {
                            for(var n = -1; ++n < r;)t1[n](this, e1);
                        };
                    }
                    function st(t1) {
                        var e1 = it(t1);
                        return function(r, n) {
                            if (i = r.classList) return n ? i.add(t1) : i.remove(t1);
                            var i = r.getAttribute("class") || "";
                            n ? (e1.lastIndex = 0, e1.test(i) || r.setAttribute("class", nt(i + " " + t1))) : r.setAttribute("class", nt(i.replace(e1, " ")));
                        };
                    }
                    function lt(t1, e1, r) {
                        return null == e1 ? function() {
                            this.style.removeProperty(t1);
                        } : "function" == typeof e1 ? function() {
                            var n = e1.apply(this, arguments);
                            null == n ? this.style.removeProperty(t1) : this.style.setProperty(t1, n, r);
                        } : function() {
                            this.style.setProperty(t1, e1, r);
                        };
                    }
                    function ct(t1, e1) {
                        return null == e1 ? function() {
                            delete this[t1];
                        } : "function" == typeof e1 ? function() {
                            var r = e1.apply(this, arguments);
                            null == r ? delete this[t1] : this[t1] = r;
                        } : function() {
                            this[t1] = e1;
                        };
                    }
                    function ut(t1) {
                        return "function" == typeof t1 ? t1 : (t1 = a.ns.qualify(t1)).local ? function() {
                            return this.ownerDocument.createElementNS(t1.space, t1.local);
                        } : function() {
                            var e1 = this.ownerDocument, r = this.namespaceURI;
                            return r === tt && e1.documentElement.namespaceURI === tt ? e1.createElement(t1) : e1.createElementNS(r, t1);
                        };
                    }
                    function ht() {
                        var t1 = this.parentNode;
                        t1 && t1.removeChild(this);
                    }
                    function ft(t1) {
                        return {
                            __data__: t1
                        };
                    }
                    function pt(t1) {
                        return function() {
                            return $(this, t1);
                        };
                    }
                    function dt(t1) {
                        return arguments.length || (t1 = g), function(e1, r) {
                            return e1 && r ? t1(e1.__data__, r.__data__) : !e1 - !r;
                        };
                    }
                    function mt(t1, e1) {
                        for(var r = 0, n = t1.length; r < n; r++)for(var i, a = t1[r], o = 0, s = a.length; o < s; o++)(i = a[o]) && e1(i, o, r);
                        return t1;
                    }
                    function gt(t1) {
                        return Z(t1, yt), t1;
                    }
                    a.ns = {
                        prefix: et,
                        qualify: function(t1) {
                            var e1 = t1.indexOf(":"), r = t1;
                            return e1 >= 0 && "xmlns" !== (r = t1.slice(0, e1)) && (t1 = t1.slice(e1 + 1)), et.hasOwnProperty(r) ? {
                                space: et[r],
                                local: t1
                            } : t1;
                        }
                    }, J.attr = function(t1, e1) {
                        if (arguments.length < 2) {
                            if ("string" == typeof t1) {
                                var r = this.node();
                                return (t1 = a.ns.qualify(t1)).local ? r.getAttributeNS(t1.space, t1.local) : r.getAttribute(t1);
                            }
                            for(e1 in t1)this.each(rt(e1, t1[e1]));
                            return this;
                        }
                        return this.each(rt(t1, e1));
                    }, J.classed = function(t1, e1) {
                        if (arguments.length < 2) {
                            if ("string" == typeof t1) {
                                var r = this.node(), n = (t1 = at(t1)).length, i = -1;
                                if (e1 = r.classList) {
                                    for(; ++i < n;)if (!e1.contains(t1[i])) return !1;
                                } else for(e1 = r.getAttribute("class"); ++i < n;)if (!it(t1[i]).test(e1)) return !1;
                                return !0;
                            }
                            for(e1 in t1)this.each(ot(e1, t1[e1]));
                            return this;
                        }
                        return this.each(ot(t1, e1));
                    }, J.style = function(t1, e1, r) {
                        var n = arguments.length;
                        if (n < 3) {
                            if ("string" != typeof t1) {
                                for(r in n < 2 && (e1 = ""), t1)this.each(lt(r, t1[r], e1));
                                return this;
                            }
                            if (n < 2) {
                                var i = this.node();
                                return u(i).getComputedStyle(i, null).getPropertyValue(t1);
                            }
                            r = "";
                        }
                        return this.each(lt(t1, e1, r));
                    }, J.property = function(t1, e1) {
                        if (arguments.length < 2) {
                            if ("string" == typeof t1) return this.node()[t1];
                            for(e1 in t1)this.each(ct(e1, t1[e1]));
                            return this;
                        }
                        return this.each(ct(t1, e1));
                    }, J.text = function(t1) {
                        return arguments.length ? this.each("function" == typeof t1 ? function() {
                            var e1 = t1.apply(this, arguments);
                            this.textContent = null == e1 ? "" : e1;
                        } : null == t1 ? function() {
                            this.textContent = "";
                        } : function() {
                            this.textContent = t1;
                        }) : this.node().textContent;
                    }, J.html = function(t1) {
                        return arguments.length ? this.each("function" == typeof t1 ? function() {
                            var e1 = t1.apply(this, arguments);
                            this.innerHTML = null == e1 ? "" : e1;
                        } : null == t1 ? function() {
                            this.innerHTML = "";
                        } : function() {
                            this.innerHTML = t1;
                        }) : this.node().innerHTML;
                    }, J.append = function(t1) {
                        return t1 = ut(t1), this.select(function() {
                            return this.appendChild(t1.apply(this, arguments));
                        });
                    }, J.insert = function(t1, e1) {
                        return t1 = ut(t1), e1 = K(e1), this.select(function() {
                            return this.insertBefore(t1.apply(this, arguments), e1.apply(this, arguments) || null);
                        });
                    }, J.remove = function() {
                        return this.each(ht);
                    }, J.data = function(t1, e1) {
                        var r, n, i = -1, a = this.length;
                        if (!arguments.length) {
                            for(t1 = new Array(a = (r = this[0]).length); ++i < a;)(n = r[i]) && (t1[i] = n.__data__);
                            return t1;
                        }
                        function o(t1, r) {
                            var n, i, a, o = t1.length, u = r.length, h = Math.min(o, u), f = new Array(u), p = new Array(u), d = new Array(o);
                            if (e1) {
                                var m, g = new k, y = new Array(o);
                                for(n = -1; ++n < o;)(i = t1[n]) && (g.has(m = e1.call(i, i.__data__, n)) ? d[n] = i : g.set(m, i), y[n] = m);
                                for(n = -1; ++n < u;)(i = g.get(m = e1.call(r, a = r[n], n))) ? !0 !== i && (f[n] = i, i.__data__ = a) : p[n] = ft(a), g.set(m, !0);
                                for(n = -1; ++n < o;)n in y && !0 !== g.get(y[n]) && (d[n] = t1[n]);
                            } else {
                                for(n = -1; ++n < h;)i = t1[n], a = r[n], i ? (i.__data__ = a, f[n] = i) : p[n] = ft(a);
                                for(; n < u; ++n)p[n] = ft(r[n]);
                                for(; n < o; ++n)d[n] = t1[n];
                            }
                            p.update = f, p.parentNode = f.parentNode = d.parentNode = t1.parentNode, s.push(p), l.push(f), c.push(d);
                        }
                        var s = gt([]), l = W([]), c = W([]);
                        if ("function" == typeof t1) for(; ++i < a;)o(r = this[i], t1.call(r, r.parentNode.__data__, i));
                        else for(; ++i < a;)o(r = this[i], t1);
                        return l.enter = function() {
                            return s;
                        }, l.exit = function() {
                            return c;
                        }, l;
                    }, J.datum = function(t1) {
                        return arguments.length ? this.property("__data__", t1) : this.property("__data__");
                    }, J.filter = function(t1) {
                        var e1, r, n, i = [];
                        "function" != typeof t1 && (t1 = pt(t1));
                        for(var a = 0, o = this.length; a < o; a++){
                            i.push(e1 = []), e1.parentNode = (r = this[a]).parentNode;
                            for(var s = 0, l = r.length; s < l; s++)(n = r[s]) && t1.call(n, n.__data__, s, a) && e1.push(n);
                        }
                        return W(i);
                    }, J.order = function() {
                        for(var t1 = -1, e1 = this.length; ++t1 < e1;)for(var r, n = this[t1], i = n.length - 1, a = n[i]; --i >= 0;)(r = n[i]) && (a && a !== r.nextSibling && a.parentNode.insertBefore(r, a), a = r);
                        return this;
                    }, J.sort = function(t1) {
                        t1 = dt.apply(this, arguments);
                        for(var e1 = -1, r = this.length; ++e1 < r;)this[e1].sort(t1);
                        return this.order();
                    }, J.each = function(t1) {
                        return mt(this, function(e1, r, n) {
                            t1.call(e1, e1.__data__, r, n);
                        });
                    }, J.call = function(t1) {
                        var e1 = s(arguments);
                        return t1.apply(e1[0] = this, e1), this;
                    }, J.empty = function() {
                        return !this.node();
                    }, J.node = function() {
                        for(var t1 = 0, e1 = this.length; t1 < e1; t1++)for(var r = this[t1], n = 0, i = r.length; n < i; n++){
                            var a = r[n];
                            if (a) return a;
                        }
                        return null;
                    }, J.size = function() {
                        var t1 = 0;
                        return mt(this, function() {
                            ++t1;
                        }), t1;
                    };
                    var yt = [];
                    function vt(t1, e1, r) {
                        var n = "__on" + t1, i = t1.indexOf("."), o = _t;
                        i > 0 && (t1 = t1.slice(0, i));
                        var l = xt.get(t1);
                        function c() {
                            var e1 = this[n];
                            e1 && (this.removeEventListener(t1, e1, e1.$), delete this[n]);
                        }
                        return l && (t1 = l, o = bt), i ? e1 ? function() {
                            var i = o(e1, s(arguments));
                            c.call(this), this.addEventListener(t1, this[n] = i, i.$ = r), i._ = e1;
                        } : c : e1 ? N : function() {
                            var e1, r = new RegExp("^__on([^.]+)" + a.requote(t1) + "$");
                            for(var n in this)if (e1 = n.match(r)) {
                                var i = this[n];
                                this.removeEventListener(e1[1], i, i.$), delete this[n];
                            }
                        };
                    }
                    a.selection.enter = gt, a.selection.enter.prototype = yt, yt.append = J.append, yt.empty = J.empty, yt.node = J.node, yt.call = J.call, yt.size = J.size, yt.select = function(t1) {
                        for(var e1, r, n, i, a, o = [], s = -1, l = this.length; ++s < l;){
                            n = (i = this[s]).update, o.push(e1 = []), e1.parentNode = i.parentNode;
                            for(var c = -1, u = i.length; ++c < u;)(a = i[c]) ? (e1.push(n[c] = r = t1.call(i.parentNode, a.__data__, c, s)), r.__data__ = a.__data__) : e1.push(null);
                        }
                        return W(o);
                    }, yt.insert = function(t1, e1) {
                        var r, n, i;
                        return arguments.length < 2 && (r = this, e1 = function(t1, e1, a) {
                            var o, s = r[a].update, l = s.length;
                            for(a != i && (i = a, n = 0), e1 >= n && (n = e1 + 1); !(o = s[n]) && ++n < l;);
                            return o;
                        }), J.insert.call(this, t1, e1);
                    }, a.select = function(t1) {
                        var e1;
                        return "string" == typeof t1 ? (e1 = [
                            Y(t1, l)
                        ]).parentNode = l.documentElement : (e1 = [
                            t1
                        ]).parentNode = c(t1), W([
                            e1
                        ]);
                    }, a.selectAll = function(t1) {
                        var e1;
                        return "string" == typeof t1 ? (e1 = s(X(t1, l))).parentNode = l.documentElement : (e1 = s(t1)).parentNode = null, W([
                            e1
                        ]);
                    }, J.on = function(t1, e1, r) {
                        var n = arguments.length;
                        if (n < 3) {
                            if ("string" != typeof t1) {
                                for(r in n < 2 && (e1 = !1), t1)this.each(vt(r, t1[r], e1));
                                return this;
                            }
                            if (n < 2) return (n = this.node()["__on" + t1]) && n._;
                            r = !1;
                        }
                        return this.each(vt(t1, e1, r));
                    };
                    var xt = a.map({
                        mouseenter: "mouseover",
                        mouseleave: "mouseout"
                    });
                    function _t(t1, e1) {
                        return function(r) {
                            var n = a.event;
                            a.event = r, e1[0] = this.__data__;
                            try {
                                t1.apply(this, e1);
                            } finally{
                                a.event = n;
                            }
                        };
                    }
                    function bt(t1, e1) {
                        var r = _t(t1, e1);
                        return function(t1) {
                            var e1 = this, n = t1.relatedTarget;
                            n && (n === e1 || 8 & n.compareDocumentPosition(e1)) || r.call(e1, t1);
                        };
                    }
                    l && xt.forEach(function(t1) {
                        "on" + t1 in l && xt.remove(t1);
                    });
                    var wt, Tt = 0;
                    function kt(t1) {
                        var e1 = ".dragsuppress-" + ++Tt, r = "click" + e1, n = a.select(u(t1)).on("touchmove" + e1, V).on("dragstart" + e1, V).on("selectstart" + e1, V);
                        if (null == wt && (wt = !("onselectstart" in t1) && F(t1.style, "userSelect")), wt) {
                            var i = c(t1).style, o = i[wt];
                            i[wt] = "none";
                        }
                        return function(t1) {
                            if (n.on(e1, null), wt && (i[wt] = o), t1) {
                                var a = function() {
                                    n.on(r, null);
                                };
                                n.on(r, function() {
                                    V(), a();
                                }, !0), setTimeout(a, 0);
                            }
                        };
                    }
                    a.mouse = function(t1) {
                        return Mt(t1, q());
                    };
                    var At = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
                    function Mt(t1, e1) {
                        e1.changedTouches && (e1 = e1.changedTouches[0]);
                        var r = t1.ownerSVGElement || t1;
                        if (r.createSVGPoint) {
                            var n = r.createSVGPoint();
                            if (At < 0) {
                                var i = u(t1);
                                if (i.scrollX || i.scrollY) {
                                    var o = (r = a.select("body").append("svg").style({
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        margin: 0,
                                        padding: 0,
                                        border: "none"
                                    }, "important"))[0][0].getScreenCTM();
                                    At = !(o.f || o.e), r.remove();
                                }
                            }
                            return At ? (n.x = e1.pageX, n.y = e1.pageY) : (n.x = e1.clientX, n.y = e1.clientY), [
                                (n = n.matrixTransform(t1.getScreenCTM().inverse())).x,
                                n.y
                            ];
                        }
                        var s = t1.getBoundingClientRect();
                        return [
                            e1.clientX - s.left - t1.clientLeft,
                            e1.clientY - s.top - t1.clientTop
                        ];
                    }
                    function St() {
                        return a.event.changedTouches[0].identifier;
                    }
                    a.touch = function(t1, e1, r) {
                        if (arguments.length < 3 && (r = e1, e1 = q().changedTouches), e1) {
                            for(var n, i = 0, a = e1.length; i < a; ++i)if ((n = e1[i]).identifier === r) return Mt(t1, n);
                        }
                    }, a.behavior.drag = function() {
                        var t1 = H(i, "drag", "dragstart", "dragend"), e1 = null, r = o(N, a.mouse, u, "mousemove", "mouseup"), n = o(St, a.touch, D, "touchmove", "touchend");
                        function i() {
                            this.on("mousedown.drag", r).on("touchstart.drag", n);
                        }
                        function o(r, n, i, o, s) {
                            return function() {
                                var l, c = this, u = a.event.target.correspondingElement || a.event.target, h = c.parentNode, f = t1.of(c, arguments), p = 0, d = r(), m = ".drag" + (null == d ? "" : "-" + d), g = a.select(i(u)).on(o + m, function() {
                                    var t1, e1, r = n(h, d);
                                    r && (t1 = r[0] - v[0], e1 = r[1] - v[1], p |= t1 | e1, v = r, f({
                                        type: "drag",
                                        x: r[0] + l[0],
                                        y: r[1] + l[1],
                                        dx: t1,
                                        dy: e1
                                    }));
                                }).on(s + m, function() {
                                    n(h, d) && (g.on(o + m, null).on(s + m, null), y(p), f({
                                        type: "dragend"
                                    }));
                                }), y = kt(u), v = n(h, d);
                                l = e1 ? [
                                    (l = e1.apply(c, arguments)).x - v[0],
                                    l.y - v[1]
                                ] : [
                                    0,
                                    0
                                ], f({
                                    type: "dragstart"
                                });
                            };
                        }
                        return i.origin = function(t1) {
                            return arguments.length ? (e1 = t1, i) : e1;
                        }, a.rebind(i, t1, "on");
                    }, a.touches = function(t1, e1) {
                        return arguments.length < 2 && (e1 = q().touches), e1 ? s(e1).map(function(e1) {
                            var r = Mt(t1, e1);
                            return r.identifier = e1.identifier, r;
                        }) : [];
                    };
                    var Et = 1e-6, Ct = Et * Et, Lt = Math.PI, It = 2 * Lt, Pt = It - Et, zt = Lt / 2, Ot = Lt / 180, Dt = 180 / Lt;
                    function Rt(t1) {
                        return t1 > 1 ? zt : t1 < -1 ? -zt : Math.asin(t1);
                    }
                    function Ft(t1) {
                        return ((t1 = Math.exp(t1)) + 1 / t1) / 2;
                    }
                    var Bt = Math.SQRT2;
                    a.interpolateZoom = function(t1, e1) {
                        var r, n, i = t1[0], a = t1[1], o = t1[2], s = e1[0], l = e1[1], c = e1[2], u = s - i, h = l - a, f = u * u + h * h;
                        if (f < Ct) n = Math.log(c / o) / Bt, r = function(t1) {
                            return [
                                i + t1 * u,
                                a + t1 * h,
                                o * Math.exp(Bt * t1 * n)
                            ];
                        };
                        else {
                            var p = Math.sqrt(f), d = (c * c - o * o + 4 * f) / (2 * o * 2 * p), m = (c * c - o * o - 4 * f) / (2 * c * 2 * p), g = Math.log(Math.sqrt(d * d + 1) - d), y = Math.log(Math.sqrt(m * m + 1) - m);
                            n = (y - g) / Bt, r = function(t1) {
                                var e1, r = t1 * n, s = Ft(g), l = o / (2 * p) * (s * (e1 = Bt * r + g, ((e1 = Math.exp(2 * e1)) - 1) / (e1 + 1)) - function(t1) {
                                    return ((t1 = Math.exp(t1)) - 1 / t1) / 2;
                                }(g));
                                return [
                                    i + l * u,
                                    a + l * h,
                                    o * s / Ft(Bt * r + g)
                                ];
                            };
                        }
                        return r.duration = 1e3 * n, r;
                    }, a.behavior.zoom = function() {
                        var t1, e1, r, n, i, o, s, c, h, f = {
                            x: 0,
                            y: 0,
                            k: 1
                        }, p = [
                            960,
                            500
                        ], d = Ut, m = 250, g = 0, y = "mousedown.zoom", v = "mousemove.zoom", x = "mouseup.zoom", _ = "touchstart.zoom", b = H(w, "zoomstart", "zoom", "zoomend");
                        function w(t1) {
                            t1.on(y, I).on(jt + ".zoom", z).on("dblclick.zoom", O).on(_, P);
                        }
                        function T(t1) {
                            return [
                                (t1[0] - f.x) / f.k,
                                (t1[1] - f.y) / f.k
                            ];
                        }
                        function k(t1) {
                            f.k = Math.max(d[0], Math.min(d[1], t1));
                        }
                        function A(t1, e1) {
                            e1 = function(t1) {
                                return [
                                    t1[0] * f.k + f.x,
                                    t1[1] * f.k + f.y
                                ];
                            }(e1), f.x += t1[0] - e1[0], f.y += t1[1] - e1[1];
                        }
                        function M(t1, r, n, i) {
                            t1.__chart__ = {
                                x: f.x,
                                y: f.y,
                                k: f.k
                            }, k(Math.pow(2, i)), A(e1 = r, n), t1 = a.select(t1), m > 0 && (t1 = t1.transition().duration(m)), t1.call(w.event);
                        }
                        function S() {
                            s && s.domain(o.range().map(function(t1) {
                                return (t1 - f.x) / f.k;
                            }).map(o.invert)), h && h.domain(c.range().map(function(t1) {
                                return (t1 - f.y) / f.k;
                            }).map(c.invert));
                        }
                        function E(t1) {
                            g++ || t1({
                                type: "zoomstart"
                            });
                        }
                        function C(t1) {
                            S(), t1({
                                type: "zoom",
                                scale: f.k,
                                translate: [
                                    f.x,
                                    f.y
                                ]
                            });
                        }
                        function L(t1) {
                            --g || (t1({
                                type: "zoomend"
                            }), e1 = null);
                        }
                        function I() {
                            var t1 = this, e1 = b.of(t1, arguments), r = 0, n = a.select(u(t1)).on(v, function() {
                                r = 1, A(a.mouse(t1), i), C(e1);
                            }).on(x, function() {
                                n.on(v, null).on(x, null), o(r), L(e1);
                            }), i = T(a.mouse(t1)), o = kt(t1);
                            $i.call(t1), E(e1);
                        }
                        function P() {
                            var t1, e1 = this, r = b.of(e1, arguments), n = {}, o = 0, s = ".zoom-" + a.event.changedTouches[0].identifier, l = "touchmove" + s, c = "touchend" + s, u = [], h = a.select(e1), p = kt(e1);
                            function d() {
                                var r = a.touches(e1);
                                return t1 = f.k, r.forEach(function(t1) {
                                    t1.identifier in n && (n[t1.identifier] = T(t1));
                                }), r;
                            }
                            function m() {
                                var t1 = a.event.target;
                                a.select(t1).on(l, g).on(c, v), u.push(t1);
                                for(var r = a.event.changedTouches, s = 0, h = r.length; s < h; ++s)n[r[s].identifier] = null;
                                var p = d(), m = Date.now();
                                if (1 === p.length) {
                                    if (m - i < 500) {
                                        var y = p[0];
                                        M(e1, y, n[y.identifier], Math.floor(Math.log(f.k) / Math.LN2) + 1), V();
                                    }
                                    i = m;
                                } else if (p.length > 1) {
                                    y = p[0];
                                    var x = p[1], _ = y[0] - x[0], b = y[1] - x[1];
                                    o = _ * _ + b * b;
                                }
                            }
                            function g() {
                                var s, l, c, u, h = a.touches(e1);
                                $i.call(e1);
                                for(var f = 0, p = h.length; f < p; ++f, u = null)if (c = h[f], u = n[c.identifier]) {
                                    if (l) break;
                                    s = c, l = u;
                                }
                                if (u) {
                                    var d = (d = c[0] - s[0]) * d + (d = c[1] - s[1]) * d, m = o && Math.sqrt(d / o);
                                    s = [
                                        (s[0] + c[0]) / 2,
                                        (s[1] + c[1]) / 2
                                    ], l = [
                                        (l[0] + u[0]) / 2,
                                        (l[1] + u[1]) / 2
                                    ], k(m * t1);
                                }
                                i = null, A(s, l), C(r);
                            }
                            function v() {
                                if (a.event.touches.length) {
                                    for(var t1 = a.event.changedTouches, e1 = 0, i = t1.length; e1 < i; ++e1)delete n[t1[e1].identifier];
                                    for(var o in n)return void d();
                                }
                                a.selectAll(u).on(s, null), h.on(y, I).on(_, P), p(), L(r);
                            }
                            m(), E(r), h.on(y, null).on(_, m);
                        }
                        function z() {
                            var i = b.of(this, arguments);
                            n ? clearTimeout(n) : ($i.call(this), t1 = T(e1 = r || a.mouse(this)), E(i)), n = setTimeout(function() {
                                n = null, L(i);
                            }, 50), V(), k(Math.pow(2, .002 * Nt()) * f.k), A(e1, t1), C(i);
                        }
                        function O() {
                            var t1 = a.mouse(this), e1 = Math.log(f.k) / Math.LN2;
                            M(this, t1, T(t1), a.event.shiftKey ? Math.ceil(e1) - 1 : Math.floor(e1) + 1);
                        }
                        return jt || (jt = "onwheel" in l ? (Nt = function() {
                            return -a.event.deltaY * (a.event.deltaMode ? 120 : 1);
                        }, "wheel") : "onmousewheel" in l ? (Nt = function() {
                            return a.event.wheelDelta;
                        }, "mousewheel") : (Nt = function() {
                            return -a.event.detail;
                        }, "MozMousePixelScroll")), w.event = function(t1) {
                            t1.each(function() {
                                var t1 = b.of(this, arguments), r = f;
                                Qi ? a.select(this).transition().each("start.zoom", function() {
                                    f = this.__chart__ || {
                                        x: 0,
                                        y: 0,
                                        k: 1
                                    }, E(t1);
                                }).tween("zoom:zoom", function() {
                                    var n = p[0], i = p[1], o = e1 ? e1[0] : n / 2, s = e1 ? e1[1] : i / 2, l = a.interpolateZoom([
                                        (o - f.x) / f.k,
                                        (s - f.y) / f.k,
                                        n / f.k
                                    ], [
                                        (o - r.x) / r.k,
                                        (s - r.y) / r.k,
                                        n / r.k
                                    ]);
                                    return function(e1) {
                                        var r = l(e1), i = n / r[2];
                                        this.__chart__ = f = {
                                            x: o - r[0] * i,
                                            y: s - r[1] * i,
                                            k: i
                                        }, C(t1);
                                    };
                                }).each("interrupt.zoom", function() {
                                    L(t1);
                                }).each("end.zoom", function() {
                                    L(t1);
                                }) : (this.__chart__ = f, E(t1), C(t1), L(t1));
                            });
                        }, w.translate = function(t1) {
                            return arguments.length ? (f = {
                                x: +t1[0],
                                y: +t1[1],
                                k: f.k
                            }, S(), w) : [
                                f.x,
                                f.y
                            ];
                        }, w.scale = function(t1) {
                            return arguments.length ? (f = {
                                x: f.x,
                                y: f.y,
                                k: null
                            }, k(+t1), S(), w) : f.k;
                        }, w.scaleExtent = function(t1) {
                            return arguments.length ? (d = null == t1 ? Ut : [
                                +t1[0],
                                +t1[1]
                            ], w) : d;
                        }, w.center = function(t1) {
                            return arguments.length ? (r = t1 && [
                                +t1[0],
                                +t1[1]
                            ], w) : r;
                        }, w.size = function(t1) {
                            return arguments.length ? (p = t1 && [
                                +t1[0],
                                +t1[1]
                            ], w) : p;
                        }, w.duration = function(t1) {
                            return arguments.length ? (m = +t1, w) : m;
                        }, w.x = function(t1) {
                            return arguments.length ? (s = t1, o = t1.copy(), f = {
                                x: 0,
                                y: 0,
                                k: 1
                            }, w) : s;
                        }, w.y = function(t1) {
                            return arguments.length ? (h = t1, c = t1.copy(), f = {
                                x: 0,
                                y: 0,
                                k: 1
                            }, w) : h;
                        }, a.rebind(w, b, "on");
                    };
                    var Nt, jt, Ut = [
                        0,
                        1 / 0
                    ];
                    function Vt() {}
                    function qt(t1, e1, r) {
                        return this instanceof qt ? (this.h = +t1, this.s = +e1, void (this.l = +r)) : arguments.length < 2 ? t1 instanceof qt ? new qt(t1.h, t1.s, t1.l) : ue("" + t1, he, qt) : new qt(t1, e1, r);
                    }
                    a.color = Vt, Vt.prototype.toString = function() {
                        return this.rgb() + "";
                    }, a.hsl = qt;
                    var Ht = qt.prototype = new Vt;
                    function Gt(t1, e1, r) {
                        var n, i;
                        function a(t1) {
                            return Math.round(255 * function(t1) {
                                return t1 > 360 ? t1 -= 360 : t1 < 0 && (t1 += 360), t1 < 60 ? n + (i - n) * t1 / 60 : t1 < 180 ? i : t1 < 240 ? n + (i - n) * (240 - t1) / 60 : n;
                            }(t1));
                        }
                        return t1 = isNaN(t1) ? 0 : (t1 %= 360) < 0 ? t1 + 360 : t1, e1 = isNaN(e1) || e1 < 0 ? 0 : e1 > 1 ? 1 : e1, n = 2 * (r = r < 0 ? 0 : r > 1 ? 1 : r) - (i = r <= .5 ? r * (1 + e1) : r + e1 - r * e1), new ae(a(t1 + 120), a(t1), a(t1 - 120));
                    }
                    function Zt(t1, e1, r) {
                        return this instanceof Zt ? (this.h = +t1, this.c = +e1, void (this.l = +r)) : arguments.length < 2 ? t1 instanceof Zt ? new Zt(t1.h, t1.c, t1.l) : function(t1, e1, r) {
                            return t1 > 0 ? new Zt(Math.atan2(r, e1) * Dt, Math.sqrt(e1 * e1 + r * r), t1) : new Zt(NaN, NaN, t1);
                        }(t1 instanceof Xt ? t1.l : (t1 = fe((t1 = a.rgb(t1)).r, t1.g, t1.b)).l, t1.a, t1.b) : new Zt(t1, e1, r);
                    }
                    Ht.brighter = function(t1) {
                        return t1 = Math.pow(.7, arguments.length ? t1 : 1), new qt(this.h, this.s, this.l / t1);
                    }, Ht.darker = function(t1) {
                        return t1 = Math.pow(.7, arguments.length ? t1 : 1), new qt(this.h, this.s, t1 * this.l);
                    }, Ht.rgb = function() {
                        return Gt(this.h, this.s, this.l);
                    }, a.hcl = Zt;
                    var Wt = Zt.prototype = new Vt;
                    function Yt(t1, e1, r) {
                        return isNaN(t1) && (t1 = 0), isNaN(e1) && (e1 = 0), new Xt(r, Math.cos(t1 *= Ot) * e1, Math.sin(t1) * e1);
                    }
                    function Xt(t1, e1, r) {
                        return this instanceof Xt ? (this.l = +t1, this.a = +e1, void (this.b = +r)) : arguments.length < 2 ? t1 instanceof Xt ? new Xt(t1.l, t1.a, t1.b) : t1 instanceof Zt ? Yt(t1.h, t1.c, t1.l) : fe((t1 = ae(t1)).r, t1.g, t1.b) : new Xt(t1, e1, r);
                    }
                    Wt.brighter = function(t1) {
                        return new Zt(this.h, this.c, Math.min(100, this.l + $t * (arguments.length ? t1 : 1)));
                    }, Wt.darker = function(t1) {
                        return new Zt(this.h, this.c, Math.max(0, this.l - $t * (arguments.length ? t1 : 1)));
                    }, Wt.rgb = function() {
                        return Yt(this.h, this.c, this.l).rgb();
                    }, a.lab = Xt;
                    var $t = 18, Jt = .95047, Kt = 1, Qt = 1.08883, te = Xt.prototype = new Vt;
                    function ee(t1, e1, r) {
                        var n = (t1 + 16) / 116, i = n + e1 / 500, a = n - r / 200;
                        return new ae(ie(3.2404542 * (i = re(i) * Jt) - 1.5371385 * (n = re(n) * Kt) - .4985314 * (a = re(a) * Qt)), ie(-0.969266 * i + 1.8760108 * n + .041556 * a), ie(.0556434 * i - .2040259 * n + 1.0572252 * a));
                    }
                    function re(t1) {
                        return t1 > .206893034 ? t1 * t1 * t1 : (t1 - 4 / 29) / 7.787037;
                    }
                    function ne(t1) {
                        return t1 > .008856 ? Math.pow(t1, 1 / 3) : 7.787037 * t1 + 4 / 29;
                    }
                    function ie(t1) {
                        return Math.round(255 * (t1 <= .00304 ? 12.92 * t1 : 1.055 * Math.pow(t1, 1 / 2.4) - .055));
                    }
                    function ae(t1, e1, r) {
                        return this instanceof ae ? (this.r = ~~t1, this.g = ~~e1, void (this.b = ~~r)) : arguments.length < 2 ? t1 instanceof ae ? new ae(t1.r, t1.g, t1.b) : ue("" + t1, ae, Gt) : new ae(t1, e1, r);
                    }
                    function oe(t1) {
                        return new ae(t1 >> 16, t1 >> 8 & 255, 255 & t1);
                    }
                    function se(t1) {
                        return oe(t1) + "";
                    }
                    te.brighter = function(t1) {
                        return new Xt(Math.min(100, this.l + $t * (arguments.length ? t1 : 1)), this.a, this.b);
                    }, te.darker = function(t1) {
                        return new Xt(Math.max(0, this.l - $t * (arguments.length ? t1 : 1)), this.a, this.b);
                    }, te.rgb = function() {
                        return ee(this.l, this.a, this.b);
                    }, a.rgb = ae;
                    var le = ae.prototype = new Vt;
                    function ce(t1) {
                        return t1 < 16 ? "0" + Math.max(0, t1).toString(16) : Math.min(255, t1).toString(16);
                    }
                    function ue(t1, e1, r) {
                        var n, i, a, o = 0, s = 0, l = 0;
                        if (n = /([a-z]+)\((.*)\)/.exec(t1 = t1.toLowerCase())) switch(i = n[2].split(","), n[1]){
                            case "hsl":
                                return r(parseFloat(i[0]), parseFloat(i[1]) / 100, parseFloat(i[2]) / 100);
                            case "rgb":
                                return e1(de(i[0]), de(i[1]), de(i[2]));
                        }
                        return (a = me.get(t1)) ? e1(a.r, a.g, a.b) : (null == t1 || "#" !== t1.charAt(0) || isNaN(a = parseInt(t1.slice(1), 16)) || (4 === t1.length ? (o = (3840 & a) >> 4, o |= o >> 4, s = 240 & a, s |= s >> 4, l = 15 & a, l |= l << 4) : 7 === t1.length && (o = (16711680 & a) >> 16, s = (65280 & a) >> 8, l = 255 & a)), e1(o, s, l));
                    }
                    function he(t1, e1, r) {
                        var n, i, a = Math.min(t1 /= 255, e1 /= 255, r /= 255), o = Math.max(t1, e1, r), s = o - a, l = (o + a) / 2;
                        return s ? (i = l < .5 ? s / (o + a) : s / (2 - o - a), n = t1 == o ? (e1 - r) / s + (e1 < r ? 6 : 0) : e1 == o ? (r - t1) / s + 2 : (t1 - e1) / s + 4, n *= 60) : (n = NaN, i = l > 0 && l < 1 ? 0 : n), new qt(n, i, l);
                    }
                    function fe(t1, e1, r) {
                        var n = ne((.4124564 * (t1 = pe(t1)) + .3575761 * (e1 = pe(e1)) + .1804375 * (r = pe(r))) / Jt), i = ne((.2126729 * t1 + .7151522 * e1 + .072175 * r) / Kt);
                        return Xt(116 * i - 16, 500 * (n - i), 200 * (i - ne((.0193339 * t1 + .119192 * e1 + .9503041 * r) / Qt)));
                    }
                    function pe(t1) {
                        return (t1 /= 255) <= .04045 ? t1 / 12.92 : Math.pow((t1 + .055) / 1.055, 2.4);
                    }
                    function de(t1) {
                        var e1 = parseFloat(t1);
                        return "%" === t1.charAt(t1.length - 1) ? Math.round(2.55 * e1) : e1;
                    }
                    le.brighter = function(t1) {
                        t1 = Math.pow(.7, arguments.length ? t1 : 1);
                        var e1 = this.r, r = this.g, n = this.b, i = 30;
                        return e1 || r || n ? (e1 && e1 < i && (e1 = i), r && r < i && (r = i), n && n < i && (n = i), new ae(Math.min(255, e1 / t1), Math.min(255, r / t1), Math.min(255, n / t1))) : new ae(i, i, i);
                    }, le.darker = function(t1) {
                        return new ae((t1 = Math.pow(.7, arguments.length ? t1 : 1)) * this.r, t1 * this.g, t1 * this.b);
                    }, le.hsl = function() {
                        return he(this.r, this.g, this.b);
                    }, le.toString = function() {
                        return "#" + ce(this.r) + ce(this.g) + ce(this.b);
                    };
                    var me = a.map({
                        aliceblue: 15792383,
                        antiquewhite: 16444375,
                        aqua: 65535,
                        aquamarine: 8388564,
                        azure: 15794175,
                        beige: 16119260,
                        bisque: 16770244,
                        black: 0,
                        blanchedalmond: 16772045,
                        blue: 255,
                        blueviolet: 9055202,
                        brown: 10824234,
                        burlywood: 14596231,
                        cadetblue: 6266528,
                        chartreuse: 8388352,
                        chocolate: 13789470,
                        coral: 16744272,
                        cornflowerblue: 6591981,
                        cornsilk: 16775388,
                        crimson: 14423100,
                        cyan: 65535,
                        darkblue: 139,
                        darkcyan: 35723,
                        darkgoldenrod: 12092939,
                        darkgray: 11119017,
                        darkgreen: 25600,
                        darkgrey: 11119017,
                        darkkhaki: 12433259,
                        darkmagenta: 9109643,
                        darkolivegreen: 5597999,
                        darkorange: 16747520,
                        darkorchid: 10040012,
                        darkred: 9109504,
                        darksalmon: 15308410,
                        darkseagreen: 9419919,
                        darkslateblue: 4734347,
                        darkslategray: 3100495,
                        darkslategrey: 3100495,
                        darkturquoise: 52945,
                        darkviolet: 9699539,
                        deeppink: 16716947,
                        deepskyblue: 49151,
                        dimgray: 6908265,
                        dimgrey: 6908265,
                        dodgerblue: 2003199,
                        firebrick: 11674146,
                        floralwhite: 16775920,
                        forestgreen: 2263842,
                        fuchsia: 16711935,
                        gainsboro: 14474460,
                        ghostwhite: 16316671,
                        gold: 16766720,
                        goldenrod: 14329120,
                        gray: 8421504,
                        green: 32768,
                        greenyellow: 11403055,
                        grey: 8421504,
                        honeydew: 15794160,
                        hotpink: 16738740,
                        indianred: 13458524,
                        indigo: 4915330,
                        ivory: 16777200,
                        khaki: 15787660,
                        lavender: 15132410,
                        lavenderblush: 16773365,
                        lawngreen: 8190976,
                        lemonchiffon: 16775885,
                        lightblue: 11393254,
                        lightcoral: 15761536,
                        lightcyan: 14745599,
                        lightgoldenrodyellow: 16448210,
                        lightgray: 13882323,
                        lightgreen: 9498256,
                        lightgrey: 13882323,
                        lightpink: 16758465,
                        lightsalmon: 16752762,
                        lightseagreen: 2142890,
                        lightskyblue: 8900346,
                        lightslategray: 7833753,
                        lightslategrey: 7833753,
                        lightsteelblue: 11584734,
                        lightyellow: 16777184,
                        lime: 65280,
                        limegreen: 3329330,
                        linen: 16445670,
                        magenta: 16711935,
                        maroon: 8388608,
                        mediumaquamarine: 6737322,
                        mediumblue: 205,
                        mediumorchid: 12211667,
                        mediumpurple: 9662683,
                        mediumseagreen: 3978097,
                        mediumslateblue: 8087790,
                        mediumspringgreen: 64154,
                        mediumturquoise: 4772300,
                        mediumvioletred: 13047173,
                        midnightblue: 1644912,
                        mintcream: 16121850,
                        mistyrose: 16770273,
                        moccasin: 16770229,
                        navajowhite: 16768685,
                        navy: 128,
                        oldlace: 16643558,
                        olive: 8421376,
                        olivedrab: 7048739,
                        orange: 16753920,
                        orangered: 16729344,
                        orchid: 14315734,
                        palegoldenrod: 15657130,
                        palegreen: 10025880,
                        paleturquoise: 11529966,
                        palevioletred: 14381203,
                        papayawhip: 16773077,
                        peachpuff: 16767673,
                        peru: 13468991,
                        pink: 16761035,
                        plum: 14524637,
                        powderblue: 11591910,
                        purple: 8388736,
                        rebeccapurple: 6697881,
                        red: 16711680,
                        rosybrown: 12357519,
                        royalblue: 4286945,
                        saddlebrown: 9127187,
                        salmon: 16416882,
                        sandybrown: 16032864,
                        seagreen: 3050327,
                        seashell: 16774638,
                        sienna: 10506797,
                        silver: 12632256,
                        skyblue: 8900331,
                        slateblue: 6970061,
                        slategray: 7372944,
                        slategrey: 7372944,
                        snow: 16775930,
                        springgreen: 65407,
                        steelblue: 4620980,
                        tan: 13808780,
                        teal: 32896,
                        thistle: 14204888,
                        tomato: 16737095,
                        turquoise: 4251856,
                        violet: 15631086,
                        wheat: 16113331,
                        white: 16777215,
                        whitesmoke: 16119285,
                        yellow: 16776960,
                        yellowgreen: 10145074
                    });
                    function ge(t1) {
                        return "function" == typeof t1 ? t1 : function() {
                            return t1;
                        };
                    }
                    function ye(t1) {
                        return function(e1, r, n) {
                            return 2 === arguments.length && "function" == typeof r && (n = r, r = null), ve(e1, r, t1, n);
                        };
                    }
                    function ve(t1, e1, r, n) {
                        var i = {}, o = a.dispatch("beforesend", "progress", "load", "error"), l = {}, c = new XMLHttpRequest, u = null;
                        function h() {
                            var t1, e1 = c.status;
                            if (!e1 && function(t1) {
                                var e1 = t1.responseType;
                                return e1 && "text" !== e1 ? t1.response : t1.responseText;
                            }(c) || e1 >= 200 && e1 < 300 || 304 === e1) {
                                try {
                                    t1 = r.call(i, c);
                                } catch (t1) {
                                    return void o.error.call(i, t1);
                                }
                                o.load.call(i, t1);
                            } else o.error.call(i, c);
                        }
                        return self.XDomainRequest && !("withCredentials" in c) && /^(http(s)?:)?\/\//.test(t1) && (c = new XDomainRequest), "onload" in c ? c.onload = c.onerror = h : c.onreadystatechange = function() {
                            c.readyState > 3 && h();
                        }, c.onprogress = function(t1) {
                            var e1 = a.event;
                            a.event = t1;
                            try {
                                o.progress.call(i, c);
                            } finally{
                                a.event = e1;
                            }
                        }, i.header = function(t1, e1) {
                            return t1 = (t1 + "").toLowerCase(), arguments.length < 2 ? l[t1] : (null == e1 ? delete l[t1] : l[t1] = e1 + "", i);
                        }, i.mimeType = function(t1) {
                            return arguments.length ? (e1 = null == t1 ? null : t1 + "", i) : e1;
                        }, i.responseType = function(t1) {
                            return arguments.length ? (u = t1, i) : u;
                        }, i.response = function(t1) {
                            return r = t1, i;
                        }, [
                            "get",
                            "post"
                        ].forEach(function(t1) {
                            i[t1] = function() {
                                return i.send.apply(i, [
                                    t1
                                ].concat(s(arguments)));
                            };
                        }), i.send = function(r, n, a) {
                            if (2 === arguments.length && "function" == typeof n && (a = n, n = null), c.open(r, t1, !0), null == e1 || "accept" in l || (l.accept = e1 + ",*/*"), c.setRequestHeader) for(var s in l)c.setRequestHeader(s, l[s]);
                            return null != e1 && c.overrideMimeType && c.overrideMimeType(e1), null != u && (c.responseType = u), null != a && i.on("error", a).on("load", function(t1) {
                                a(null, t1);
                            }), o.beforesend.call(i, c), c.send(null == n ? null : n), i;
                        }, i.abort = function() {
                            return c.abort(), i;
                        }, a.rebind(i, o, "on"), null == n ? i : i.get(function(t1) {
                            return 1 === t1.length ? function(e1, r) {
                                t1(null == e1 ? r : null);
                            } : t1;
                        }(n));
                    }
                    me.forEach(function(t1, e1) {
                        me.set(t1, oe(e1));
                    }), a.functor = ge, a.xhr = ye(D), a.dsv = function(t1, e1) {
                        var r = new RegExp('["' + t1 + "\n]"), n = t1.charCodeAt(0);
                        function i(t1, r, n) {
                            arguments.length < 3 && (n = r, r = null);
                            var i = ve(t1, e1, null == r ? a : o(r), n);
                            return i.row = function(t1) {
                                return arguments.length ? i.response(null == (r = t1) ? a : o(t1)) : r;
                            }, i;
                        }
                        function a(t1) {
                            return i.parse(t1.responseText);
                        }
                        function o(t1) {
                            return function(e1) {
                                return i.parse(e1.responseText, t1);
                            };
                        }
                        function s(e1) {
                            return e1.map(l).join(t1);
                        }
                        function l(t1) {
                            return r.test(t1) ? '"' + t1.replace(/\"/g, '""') + '"' : t1;
                        }
                        return i.parse = function(t1, e1) {
                            var r;
                            return i.parseRows(t1, function(t1, n) {
                                if (r) return r(t1, n - 1);
                                var i = function(e1) {
                                    for(var r = {}, n = t1.length, i = 0; i < n; ++i)r[t1[i]] = e1[i];
                                    return r;
                                };
                                r = e1 ? function(t1, r) {
                                    return e1(i(t1), r);
                                } : i;
                            });
                        }, i.parseRows = function(t1, e1) {
                            var r, i, a = {}, o = {}, s = [], l = t1.length, c = 0, u = 0;
                            function h() {
                                if (c >= l) return o;
                                if (i) return i = !1, a;
                                var e1 = c;
                                if (34 === t1.charCodeAt(e1)) {
                                    for(var r = e1; r++ < l;)if (34 === t1.charCodeAt(r)) {
                                        if (34 !== t1.charCodeAt(r + 1)) break;
                                        ++r;
                                    }
                                    return c = r + 2, 13 === (s = t1.charCodeAt(r + 1)) ? (i = !0, 10 === t1.charCodeAt(r + 2) && ++c) : 10 === s && (i = !0), t1.slice(e1 + 1, r).replace(/""/g, '"');
                                }
                                for(; c < l;){
                                    var s, u = 1;
                                    if (10 === (s = t1.charCodeAt(c++))) i = !0;
                                    else if (13 === s) i = !0, 10 === t1.charCodeAt(c) && (++c, ++u);
                                    else if (s !== n) continue;
                                    return t1.slice(e1, c - u);
                                }
                                return t1.slice(e1);
                            }
                            for(; (r = h()) !== o;){
                                for(var f = []; r !== a && r !== o;)f.push(r), r = h();
                                e1 && null == (f = e1(f, u++)) || s.push(f);
                            }
                            return s;
                        }, i.format = function(e1) {
                            if (Array.isArray(e1[0])) return i.formatRows(e1);
                            var r = new O, n = [];
                            return e1.forEach(function(t1) {
                                for(var e1 in t1)r.has(e1) || n.push(r.add(e1));
                            }), [
                                n.map(l).join(t1)
                            ].concat(e1.map(function(e1) {
                                return n.map(function(t1) {
                                    return l(e1[t1]);
                                }).join(t1);
                            })).join("\n");
                        }, i.formatRows = function(t1) {
                            return t1.map(s).join("\n");
                        }, i;
                    }, a.csv = a.dsv(",", "text/csv"), a.tsv = a.dsv("	", "text/tab-separated-values");
                    var xe, _e, be, we, Te = this[F(this, "requestAnimationFrame")] || function(t1) {
                        setTimeout(t1, 17);
                    };
                    function ke(t1, e1, r) {
                        var n = arguments.length;
                        n < 2 && (e1 = 0), n < 3 && (r = Date.now());
                        var i = {
                            c: t1,
                            t: r + e1,
                            n: null
                        };
                        return _e ? _e.n = i : xe = i, _e = i, be || (we = clearTimeout(we), be = 1, Te(Ae)), i;
                    }
                    function Ae() {
                        var t1 = Me(), e1 = Se() - t1;
                        e1 > 24 ? (isFinite(e1) && (clearTimeout(we), we = setTimeout(Ae, e1)), be = 0) : (be = 1, Te(Ae));
                    }
                    function Me() {
                        for(var t1 = Date.now(), e1 = xe; e1;)t1 >= e1.t && e1.c(t1 - e1.t) && (e1.c = null), e1 = e1.n;
                        return t1;
                    }
                    function Se() {
                        for(var t1, e1 = xe, r = 1 / 0; e1;)e1.c ? (e1.t < r && (r = e1.t), e1 = (t1 = e1).n) : e1 = t1 ? t1.n = e1.n : xe = e1.n;
                        return _e = t1, r;
                    }
                    function Ee(t1) {
                        return t1[0];
                    }
                    function Ce(t1) {
                        return t1[1];
                    }
                    function Le(t1) {
                        for(var e1, r, n, i = t1.length, a = [
                            0,
                            1
                        ], o = 2, s = 2; s < i; s++){
                            for(; o > 1 && (e1 = t1[a[o - 2]], r = t1[a[o - 1]], n = t1[s], (r[0] - e1[0]) * (n[1] - e1[1]) - (r[1] - e1[1]) * (n[0] - e1[0]) <= 0);)--o;
                            a[o++] = s;
                        }
                        return a.slice(0, o);
                    }
                    function Ie(t1, e1) {
                        return t1[0] - e1[0] || t1[1] - e1[1];
                    }
                    a.timer = function() {
                        ke.apply(this, arguments);
                    }, a.timer.flush = function() {
                        Me(), Se();
                    }, a.round = function(t1, e1) {
                        return e1 ? Math.round(t1 * (e1 = Math.pow(10, e1))) / e1 : Math.round(t1);
                    }, a.geom = {}, a.geom.hull = function(t1) {
                        var e1 = Ee, r = Ce;
                        if (arguments.length) return n(t1);
                        function n(t1) {
                            if (t1.length < 3) return [];
                            var n, i = ge(e1), a = ge(r), o = t1.length, s = [], l = [];
                            for(n = 0; n < o; n++)s.push([
                                +i.call(this, t1[n], n),
                                +a.call(this, t1[n], n),
                                n
                            ]);
                            for(s.sort(Ie), n = 0; n < o; n++)l.push([
                                s[n][0],
                                -s[n][1]
                            ]);
                            var c = Le(s), u = Le(l), h = u[0] === c[0], f = u[u.length - 1] === c[c.length - 1], p = [];
                            for(n = c.length - 1; n >= 0; --n)p.push(t1[s[c[n]][2]]);
                            for(n = +h; n < u.length - f; ++n)p.push(t1[s[u[n]][2]]);
                            return p;
                        }
                        return n.x = function(t1) {
                            return arguments.length ? (e1 = t1, n) : e1;
                        }, n.y = function(t1) {
                            return arguments.length ? (r = t1, n) : r;
                        }, n;
                    }, a.geom.polygon = function(t1) {
                        return Z(t1, Pe), t1;
                    };
                    var Pe = a.geom.polygon.prototype = [];
                    function ze(t1, e1, r) {
                        return (r[0] - e1[0]) * (t1[1] - e1[1]) < (r[1] - e1[1]) * (t1[0] - e1[0]);
                    }
                    function Oe(t1, e1, r, n) {
                        var i = t1[0], a = r[0], o = e1[0] - i, s = n[0] - a, l = t1[1], c = r[1], u = e1[1] - l, h = n[1] - c, f = (s * (l - c) - h * (i - a)) / (h * o - s * u);
                        return [
                            i + f * o,
                            l + f * u
                        ];
                    }
                    function De(t1) {
                        var e1 = t1[0], r = t1[t1.length - 1];
                        return !(e1[0] - r[0] || e1[1] - r[1]);
                    }
                    Pe.area = function() {
                        for(var t1, e1 = -1, r = this.length, n = this[r - 1], i = 0; ++e1 < r;)t1 = n, n = this[e1], i += t1[1] * n[0] - t1[0] * n[1];
                        return .5 * i;
                    }, Pe.centroid = function(t1) {
                        var e1, r, n = -1, i = this.length, a = 0, o = 0, s = this[i - 1];
                        for(arguments.length || (t1 = -1 / (6 * this.area())); ++n < i;)e1 = s, s = this[n], r = e1[0] * s[1] - s[0] * e1[1], a += (e1[0] + s[0]) * r, o += (e1[1] + s[1]) * r;
                        return [
                            a * t1,
                            o * t1
                        ];
                    }, Pe.clip = function(t1) {
                        for(var e1, r, n, i, a, o, s = De(t1), l = -1, c = this.length - De(this), u = this[c - 1]; ++l < c;){
                            for(e1 = t1.slice(), t1.length = 0, i = this[l], a = e1[(n = e1.length - s) - 1], r = -1; ++r < n;)ze(o = e1[r], u, i) ? (ze(a, u, i) || t1.push(Oe(a, o, u, i)), t1.push(o)) : ze(a, u, i) && t1.push(Oe(a, o, u, i)), a = o;
                            s && t1.push(t1[0]), u = i;
                        }
                        return t1;
                    };
                    var Re, Fe, Be, Ne, je, Ue = [], Ve = [];
                    function qe() {
                        sr(this), this.edge = this.site = this.circle = null;
                    }
                    function He(t1) {
                        var e1 = Ue.pop() || new qe;
                        return e1.site = t1, e1;
                    }
                    function Ge(t1) {
                        tr(t1), Be.remove(t1), Ue.push(t1), sr(t1);
                    }
                    function Ze(t1) {
                        var e1 = t1.circle, r = e1.x, n = e1.cy, i = {
                            x: r,
                            y: n
                        }, a = t1.P, o = t1.N, s = [
                            t1
                        ];
                        Ge(t1);
                        for(var l = a; l.circle && w(r - l.circle.x) < Et && w(n - l.circle.cy) < Et;)a = l.P, s.unshift(l), Ge(l), l = a;
                        s.unshift(l), tr(l);
                        for(var c = o; c.circle && w(r - c.circle.x) < Et && w(n - c.circle.cy) < Et;)o = c.N, s.push(c), Ge(c), c = o;
                        s.push(c), tr(c);
                        var u, h = s.length;
                        for(u = 1; u < h; ++u)c = s[u], l = s[u - 1], ir(c.edge, l.site, c.site, i);
                        l = s[0], (c = s[h - 1]).edge = nr(l.site, c.site, null, i), Qe(l), Qe(c);
                    }
                    function We(t1) {
                        for(var e1, r, n, i, a = t1.x, o = t1.y, s = Be._; s;)if ((n = Ye(s, o) - a) > Et) s = s.L;
                        else {
                            if (!((i = a - Xe(s, o)) > Et)) {
                                n > -Et ? (e1 = s.P, r = s) : i > -Et ? (e1 = s, r = s.N) : e1 = r = s;
                                break;
                            }
                            if (!s.R) {
                                e1 = s;
                                break;
                            }
                            s = s.R;
                        }
                        var l = He(t1);
                        if (Be.insert(e1, l), e1 || r) {
                            if (e1 === r) return tr(e1), r = He(e1.site), Be.insert(l, r), l.edge = r.edge = nr(e1.site, l.site), Qe(e1), void Qe(r);
                            if (r) {
                                tr(e1), tr(r);
                                var c = e1.site, u = c.x, h = c.y, f = t1.x - u, p = t1.y - h, d = r.site, m = d.x - u, g = d.y - h, y = 2 * (f * g - p * m), v = f * f + p * p, x = m * m + g * g, _ = {
                                    x: (g * v - p * x) / y + u,
                                    y: (f * x - m * v) / y + h
                                };
                                ir(r.edge, c, d, _), l.edge = nr(c, t1, null, _), r.edge = nr(t1, d, null, _), Qe(e1), Qe(r);
                            } else l.edge = nr(e1.site, l.site);
                        }
                    }
                    function Ye(t1, e1) {
                        var r = t1.site, n = r.x, i = r.y, a = i - e1;
                        if (!a) return n;
                        var o = t1.P;
                        if (!o) return -1 / 0;
                        var s = (r = o.site).x, l = r.y, c = l - e1;
                        if (!c) return s;
                        var u = s - n, h = 1 / a - 1 / c, f = u / c;
                        return h ? (-f + Math.sqrt(f * f - 2 * h * (u * u / (-2 * c) - l + c / 2 + i - a / 2))) / h + n : (n + s) / 2;
                    }
                    function Xe(t1, e1) {
                        var r = t1.N;
                        if (r) return Ye(r, e1);
                        var n = t1.site;
                        return n.y === e1 ? n.x : 1 / 0;
                    }
                    function $e(t1) {
                        this.site = t1, this.edges = [];
                    }
                    function Je(t1, e1) {
                        return e1.angle - t1.angle;
                    }
                    function Ke() {
                        sr(this), this.x = this.y = this.arc = this.site = this.cy = null;
                    }
                    function Qe(t1) {
                        var e1 = t1.P, r = t1.N;
                        if (e1 && r) {
                            var n = e1.site, i = t1.site, a = r.site;
                            if (n !== a) {
                                var o = i.x, s = i.y, l = n.x - o, c = n.y - s, u = a.x - o, h = 2 * (l * (g = a.y - s) - c * u);
                                if (!(h >= -Ct)) {
                                    var f = l * l + c * c, p = u * u + g * g, d = (g * f - c * p) / h, m = (l * p - u * f) / h, g = m + s, y = Ve.pop() || new Ke;
                                    y.arc = t1, y.site = i, y.x = d + o, y.y = g + Math.sqrt(d * d + m * m), y.cy = g, t1.circle = y;
                                    for(var v = null, x = je._; x;)if (y.y < x.y || y.y === x.y && y.x <= x.x) {
                                        if (!x.L) {
                                            v = x.P;
                                            break;
                                        }
                                        x = x.L;
                                    } else {
                                        if (!x.R) {
                                            v = x;
                                            break;
                                        }
                                        x = x.R;
                                    }
                                    je.insert(v, y), v || (Ne = y);
                                }
                            }
                        }
                    }
                    function tr(t1) {
                        var e1 = t1.circle;
                        e1 && (e1.P || (Ne = e1.N), je.remove(e1), Ve.push(e1), sr(e1), t1.circle = null);
                    }
                    function er(t1, e1) {
                        var r = t1.b;
                        if (r) return !0;
                        var n, i, a = t1.a, o = e1[0][0], s = e1[1][0], l = e1[0][1], c = e1[1][1], u = t1.l, h = t1.r, f = u.x, p = u.y, d = h.x, m = h.y, g = (f + d) / 2, y = (p + m) / 2;
                        if (m === p) {
                            if (g < o || g >= s) return;
                            if (f > d) {
                                if (a) {
                                    if (a.y >= c) return;
                                } else a = {
                                    x: g,
                                    y: l
                                };
                                r = {
                                    x: g,
                                    y: c
                                };
                            } else {
                                if (a) {
                                    if (a.y < l) return;
                                } else a = {
                                    x: g,
                                    y: c
                                };
                                r = {
                                    x: g,
                                    y: l
                                };
                            }
                        } else if (i = y - (n = (f - d) / (m - p)) * g, n < -1 || n > 1) {
                            if (f > d) {
                                if (a) {
                                    if (a.y >= c) return;
                                } else a = {
                                    x: (l - i) / n,
                                    y: l
                                };
                                r = {
                                    x: (c - i) / n,
                                    y: c
                                };
                            } else {
                                if (a) {
                                    if (a.y < l) return;
                                } else a = {
                                    x: (c - i) / n,
                                    y: c
                                };
                                r = {
                                    x: (l - i) / n,
                                    y: l
                                };
                            }
                        } else if (p < m) {
                            if (a) {
                                if (a.x >= s) return;
                            } else a = {
                                x: o,
                                y: n * o + i
                            };
                            r = {
                                x: s,
                                y: n * s + i
                            };
                        } else {
                            if (a) {
                                if (a.x < o) return;
                            } else a = {
                                x: s,
                                y: n * s + i
                            };
                            r = {
                                x: o,
                                y: n * o + i
                            };
                        }
                        return t1.a = a, t1.b = r, !0;
                    }
                    function rr(t1, e1) {
                        this.l = t1, this.r = e1, this.a = this.b = null;
                    }
                    function nr(t1, e1, r, n) {
                        var i = new rr(t1, e1);
                        return Re.push(i), r && ir(i, t1, e1, r), n && ir(i, e1, t1, n), Fe[t1.i].edges.push(new ar(i, t1, e1)), Fe[e1.i].edges.push(new ar(i, e1, t1)), i;
                    }
                    function ir(t1, e1, r, n) {
                        t1.a || t1.b ? t1.l === r ? t1.b = n : t1.a = n : (t1.a = n, t1.l = e1, t1.r = r);
                    }
                    function ar(t1, e1, r) {
                        var n = t1.a, i = t1.b;
                        this.edge = t1, this.site = e1, this.angle = r ? Math.atan2(r.y - e1.y, r.x - e1.x) : t1.l === e1 ? Math.atan2(i.x - n.x, n.y - i.y) : Math.atan2(n.x - i.x, i.y - n.y);
                    }
                    function or() {
                        this._ = null;
                    }
                    function sr(t1) {
                        t1.U = t1.C = t1.L = t1.R = t1.P = t1.N = null;
                    }
                    function lr(t1, e1) {
                        var r = e1, n = e1.R, i = r.U;
                        i ? i.L === r ? i.L = n : i.R = n : t1._ = n, n.U = i, r.U = n, r.R = n.L, r.R && (r.R.U = r), n.L = r;
                    }
                    function cr(t1, e1) {
                        var r = e1, n = e1.L, i = r.U;
                        i ? i.L === r ? i.L = n : i.R = n : t1._ = n, n.U = i, r.U = n, r.L = n.R, r.L && (r.L.U = r), n.R = r;
                    }
                    function ur(t1) {
                        for(; t1.L;)t1 = t1.L;
                        return t1;
                    }
                    function hr(t1, e1) {
                        var r, n, i, a = t1.sort(fr).pop();
                        for(Re = [], Fe = new Array(t1.length), Be = new or, je = new or;;)if (i = Ne, a && (!i || a.y < i.y || a.y === i.y && a.x < i.x)) a.x === r && a.y === n || (Fe[a.i] = new $e(a), We(a), r = a.x, n = a.y), a = t1.pop();
                        else {
                            if (!i) break;
                            Ze(i.arc);
                        }
                        e1 && (function(t1) {
                            for(var e1, r, n, i, a, o = Re, s = (r = t1[0][0], n = t1[0][1], i = t1[1][0], a = t1[1][1], function(t1) {
                                var e1, o = t1.a, s = t1.b, l = o.x, c = o.y, u = 0, h = 1, f = s.x - l, p = s.y - c;
                                if (e1 = r - l, f || !(e1 > 0)) {
                                    if (e1 /= f, f < 0) {
                                        if (e1 < u) return;
                                        e1 < h && (h = e1);
                                    } else if (f > 0) {
                                        if (e1 > h) return;
                                        e1 > u && (u = e1);
                                    }
                                    if (e1 = i - l, f || !(e1 < 0)) {
                                        if (e1 /= f, f < 0) {
                                            if (e1 > h) return;
                                            e1 > u && (u = e1);
                                        } else if (f > 0) {
                                            if (e1 < u) return;
                                            e1 < h && (h = e1);
                                        }
                                        if (e1 = n - c, p || !(e1 > 0)) {
                                            if (e1 /= p, p < 0) {
                                                if (e1 < u) return;
                                                e1 < h && (h = e1);
                                            } else if (p > 0) {
                                                if (e1 > h) return;
                                                e1 > u && (u = e1);
                                            }
                                            if (e1 = a - c, p || !(e1 < 0)) {
                                                if (e1 /= p, p < 0) {
                                                    if (e1 > h) return;
                                                    e1 > u && (u = e1);
                                                } else if (p > 0) {
                                                    if (e1 < u) return;
                                                    e1 < h && (h = e1);
                                                }
                                                return u > 0 && (t1.a = {
                                                    x: l + u * f,
                                                    y: c + u * p
                                                }), h < 1 && (t1.b = {
                                                    x: l + h * f,
                                                    y: c + h * p
                                                }), t1;
                                            }
                                        }
                                    }
                                }
                            }), l = o.length; l--;)(!er(e1 = o[l], t1) || !s(e1) || w(e1.a.x - e1.b.x) < Et && w(e1.a.y - e1.b.y) < Et) && (e1.a = e1.b = null, o.splice(l, 1));
                        }(e1), function(t1) {
                            for(var e1, r, n, i, a, o, s, l, c, u, h = t1[0][0], f = t1[1][0], p = t1[0][1], d = t1[1][1], m = Fe, g = m.length; g--;)if ((a = m[g]) && a.prepare()) for(l = (s = a.edges).length, o = 0; o < l;)n = (u = s[o].end()).x, i = u.y, e1 = (c = s[++o % l].start()).x, r = c.y, (w(n - e1) > Et || w(i - r) > Et) && (s.splice(o, 0, new ar((y = a.site, v = u, x = w(n - h) < Et && d - i > Et ? {
                                x: h,
                                y: w(e1 - h) < Et ? r : d
                            } : w(i - d) < Et && f - n > Et ? {
                                x: w(r - d) < Et ? e1 : f,
                                y: d
                            } : w(n - f) < Et && i - p > Et ? {
                                x: f,
                                y: w(e1 - f) < Et ? r : p
                            } : w(i - p) < Et && n - h > Et ? {
                                x: w(r - p) < Et ? e1 : h,
                                y: p
                            } : null, _ = void 0, (_ = new rr(y, null)).a = v, _.b = x, Re.push(_), _), a.site, null)), ++l);
                            var y, v, x, _;
                        }(e1));
                        var o = {
                            cells: Fe,
                            edges: Re
                        };
                        return Be = je = Re = Fe = null, o;
                    }
                    function fr(t1, e1) {
                        return e1.y - t1.y || e1.x - t1.x;
                    }
                    $e.prototype.prepare = function() {
                        for(var t1, e1 = this.edges, r = e1.length; r--;)(t1 = e1[r].edge).b && t1.a || e1.splice(r, 1);
                        return e1.sort(Je), e1.length;
                    }, ar.prototype = {
                        start: function() {
                            return this.edge.l === this.site ? this.edge.a : this.edge.b;
                        },
                        end: function() {
                            return this.edge.l === this.site ? this.edge.b : this.edge.a;
                        }
                    }, or.prototype = {
                        insert: function(t1, e1) {
                            var r, n, i;
                            if (t1) {
                                if (e1.P = t1, e1.N = t1.N, t1.N && (t1.N.P = e1), t1.N = e1, t1.R) {
                                    for(t1 = t1.R; t1.L;)t1 = t1.L;
                                    t1.L = e1;
                                } else t1.R = e1;
                                r = t1;
                            } else this._ ? (t1 = ur(this._), e1.P = null, e1.N = t1, t1.P = t1.L = e1, r = t1) : (e1.P = e1.N = null, this._ = e1, r = null);
                            for(e1.L = e1.R = null, e1.U = r, e1.C = !0, t1 = e1; r && r.C;)r === (n = r.U).L ? (i = n.R) && i.C ? (r.C = i.C = !1, n.C = !0, t1 = n) : (t1 === r.R && (lr(this, r), r = (t1 = r).U), r.C = !1, n.C = !0, cr(this, n)) : (i = n.L) && i.C ? (r.C = i.C = !1, n.C = !0, t1 = n) : (t1 === r.L && (cr(this, r), r = (t1 = r).U), r.C = !1, n.C = !0, lr(this, n)), r = t1.U;
                            this._.C = !1;
                        },
                        remove: function(t1) {
                            t1.N && (t1.N.P = t1.P), t1.P && (t1.P.N = t1.N), t1.N = t1.P = null;
                            var e1, r, n, i = t1.U, a = t1.L, o = t1.R;
                            if (r = a ? o ? ur(o) : a : o, i ? i.L === t1 ? i.L = r : i.R = r : this._ = r, a && o ? (n = r.C, r.C = t1.C, r.L = a, a.U = r, r !== o ? (i = r.U, r.U = t1.U, t1 = r.R, i.L = t1, r.R = o, o.U = r) : (r.U = i, i = r, t1 = r.R)) : (n = t1.C, t1 = r), t1 && (t1.U = i), !n) {
                                if (t1 && t1.C) t1.C = !1;
                                else {
                                    do {
                                        if (t1 === this._) break;
                                        if (t1 === i.L) {
                                            if ((e1 = i.R).C && (e1.C = !1, i.C = !0, lr(this, i), e1 = i.R), e1.L && e1.L.C || e1.R && e1.R.C) {
                                                e1.R && e1.R.C || (e1.L.C = !1, e1.C = !0, cr(this, e1), e1 = i.R), e1.C = i.C, i.C = e1.R.C = !1, lr(this, i), t1 = this._;
                                                break;
                                            }
                                        } else if ((e1 = i.L).C && (e1.C = !1, i.C = !0, cr(this, i), e1 = i.L), e1.L && e1.L.C || e1.R && e1.R.C) {
                                            e1.L && e1.L.C || (e1.R.C = !1, e1.C = !0, lr(this, e1), e1 = i.L), e1.C = i.C, i.C = e1.L.C = !1, cr(this, i), t1 = this._;
                                            break;
                                        }
                                        e1.C = !0, t1 = i, i = i.U;
                                    }while (!t1.C);
                                    t1 && (t1.C = !1);
                                }
                            }
                        }
                    }, a.geom.voronoi = function(t1) {
                        var e1 = Ee, r = Ce, n = e1, i = r, a = pr;
                        if (t1) return o(t1);
                        function o(t1) {
                            var e1 = new Array(t1.length), r = a[0][0], n = a[0][1], i = a[1][0], o = a[1][1];
                            return hr(s(t1), a).cells.forEach(function(a, s) {
                                var l = a.edges, c = a.site;
                                (e1[s] = l.length ? l.map(function(t1) {
                                    var e1 = t1.start();
                                    return [
                                        e1.x,
                                        e1.y
                                    ];
                                }) : c.x >= r && c.x <= i && c.y >= n && c.y <= o ? [
                                    [
                                        r,
                                        o
                                    ],
                                    [
                                        i,
                                        o
                                    ],
                                    [
                                        i,
                                        n
                                    ],
                                    [
                                        r,
                                        n
                                    ]
                                ] : []).point = t1[s];
                            }), e1;
                        }
                        function s(t1) {
                            return t1.map(function(t1, e1) {
                                return {
                                    x: Math.round(n(t1, e1) / Et) * Et,
                                    y: Math.round(i(t1, e1) / Et) * Et,
                                    i: e1
                                };
                            });
                        }
                        return o.links = function(t1) {
                            return hr(s(t1)).edges.filter(function(t1) {
                                return t1.l && t1.r;
                            }).map(function(e1) {
                                return {
                                    source: t1[e1.l.i],
                                    target: t1[e1.r.i]
                                };
                            });
                        }, o.triangles = function(t1) {
                            var e1 = [];
                            return hr(s(t1)).cells.forEach(function(r, n) {
                                for(var i, a, o, s, l = r.site, c = r.edges.sort(Je), u = -1, h = c.length, f = c[h - 1].edge, p = f.l === l ? f.r : f.l; ++u < h;)i = p, p = (f = c[u].edge).l === l ? f.r : f.l, n < i.i && n < p.i && (o = i, s = p, ((a = l).x - s.x) * (o.y - a.y) - (a.x - o.x) * (s.y - a.y) < 0) && e1.push([
                                    t1[n],
                                    t1[i.i],
                                    t1[p.i]
                                ]);
                            }), e1;
                        }, o.x = function(t1) {
                            return arguments.length ? (n = ge(e1 = t1), o) : e1;
                        }, o.y = function(t1) {
                            return arguments.length ? (i = ge(r = t1), o) : r;
                        }, o.clipExtent = function(t1) {
                            return arguments.length ? (a = null == t1 ? pr : t1, o) : a === pr ? null : a;
                        }, o.size = function(t1) {
                            return arguments.length ? o.clipExtent(t1 && [
                                [
                                    0,
                                    0
                                ],
                                t1
                            ]) : a === pr ? null : a && a[1];
                        }, o;
                    };
                    var pr = [
                        [
                            -1000000,
                            -1000000
                        ],
                        [
                            1e6,
                            1e6
                        ]
                    ];
                    function dr(t1) {
                        return t1.x;
                    }
                    function mr(t1) {
                        return t1.y;
                    }
                    function gr(t1, e1, r, n, i, a) {
                        if (!t1(e1, r, n, i, a)) {
                            var o = .5 * (r + i), s = .5 * (n + a), l = e1.nodes;
                            l[0] && gr(t1, l[0], r, n, o, s), l[1] && gr(t1, l[1], o, n, i, s), l[2] && gr(t1, l[2], r, s, o, a), l[3] && gr(t1, l[3], o, s, i, a);
                        }
                    }
                    function yr(t1, e1) {
                        t1 = a.rgb(t1), e1 = a.rgb(e1);
                        var r = t1.r, n = t1.g, i = t1.b, o = e1.r - r, s = e1.g - n, l = e1.b - i;
                        return function(t1) {
                            return "#" + ce(Math.round(r + o * t1)) + ce(Math.round(n + s * t1)) + ce(Math.round(i + l * t1));
                        };
                    }
                    function vr(t1, e1) {
                        var r, n = {}, i = {};
                        for(r in t1)r in e1 ? n[r] = Tr(t1[r], e1[r]) : i[r] = t1[r];
                        for(r in e1)r in t1 || (i[r] = e1[r]);
                        return function(t1) {
                            for(r in n)i[r] = n[r](t1);
                            return i;
                        };
                    }
                    function xr(t1, e1) {
                        return t1 = +t1, e1 = +e1, function(r) {
                            return t1 * (1 - r) + e1 * r;
                        };
                    }
                    function _r(t1, e1) {
                        var r, n, i, a = br.lastIndex = wr.lastIndex = 0, o = -1, s = [], l = [];
                        for(t1 += "", e1 += ""; (r = br.exec(t1)) && (n = wr.exec(e1));)(i = n.index) > a && (i = e1.slice(a, i), s[o] ? s[o] += i : s[++o] = i), (r = r[0]) === (n = n[0]) ? s[o] ? s[o] += n : s[++o] = n : (s[++o] = null, l.push({
                            i: o,
                            x: xr(r, n)
                        })), a = wr.lastIndex;
                        return a < e1.length && (i = e1.slice(a), s[o] ? s[o] += i : s[++o] = i), s.length < 2 ? l[0] ? (e1 = l[0].x, function(t1) {
                            return e1(t1) + "";
                        }) : function() {
                            return e1;
                        } : (e1 = l.length, function(t1) {
                            for(var r, n = 0; n < e1; ++n)s[(r = l[n]).i] = r.x(t1);
                            return s.join("");
                        });
                    }
                    a.geom.delaunay = function(t1) {
                        return a.geom.voronoi().triangles(t1);
                    }, a.geom.quadtree = function(t1, e1, r, n, i) {
                        var a, o = Ee, s = Ce;
                        if (a = arguments.length) return o = dr, s = mr, 3 === a && (i = r, n = e1, r = e1 = 0), l(t1);
                        function l(t1) {
                            var l, c, u, h, f, p, d, m, g, y = ge(o), v = ge(s);
                            if (null != e1) p = e1, d = r, m = n, g = i;
                            else if (m = g = -(p = d = 1 / 0), c = [], u = [], f = t1.length, a) for(h = 0; h < f; ++h)(l = t1[h]).x < p && (p = l.x), l.y < d && (d = l.y), l.x > m && (m = l.x), l.y > g && (g = l.y), c.push(l.x), u.push(l.y);
                            else for(h = 0; h < f; ++h){
                                var x = +y(l = t1[h], h), _ = +v(l, h);
                                x < p && (p = x), _ < d && (d = _), x > m && (m = x), _ > g && (g = _), c.push(x), u.push(_);
                            }
                            var b = m - p, T = g - d;
                            function k(t1, e1, r, n, i, a, o, s) {
                                if (!isNaN(r) && !isNaN(n)) {
                                    if (t1.leaf) {
                                        var l = t1.x, c = t1.y;
                                        if (null != l) {
                                            if (w(l - r) + w(c - n) < .01) A(t1, e1, r, n, i, a, o, s);
                                            else {
                                                var u = t1.point;
                                                t1.x = t1.y = t1.point = null, A(t1, u, l, c, i, a, o, s), A(t1, e1, r, n, i, a, o, s);
                                            }
                                        } else t1.x = r, t1.y = n, t1.point = e1;
                                    } else A(t1, e1, r, n, i, a, o, s);
                                }
                            }
                            function A(t1, e1, r, n, i, a, o, s) {
                                var l = .5 * (i + o), c = .5 * (a + s), u = r >= l, h = n >= c, f = h << 1 | u;
                                t1.leaf = !1, u ? i = l : o = l, h ? a = c : s = c, k(t1 = t1.nodes[f] || (t1.nodes[f] = {
                                    leaf: !0,
                                    nodes: [],
                                    point: null,
                                    x: null,
                                    y: null
                                }), e1, r, n, i, a, o, s);
                            }
                            b > T ? g = d + b : m = p + T;
                            var M = {
                                leaf: !0,
                                nodes: [],
                                point: null,
                                x: null,
                                y: null,
                                add: function(t1) {
                                    k(M, t1, +y(t1, ++h), +v(t1, h), p, d, m, g);
                                }
                            };
                            if (M.visit = function(t1) {
                                gr(t1, M, p, d, m, g);
                            }, M.find = function(t1) {
                                return function(t1, e1, r, n, i, a, o) {
                                    var s, l = 1 / 0;
                                    return function t1(c, u, h, f, p) {
                                        if (!(u > a || h > o || f < n || p < i)) {
                                            if (d = c.point) {
                                                var d, m = e1 - c.x, g = r - c.y, y = m * m + g * g;
                                                if (y < l) {
                                                    var v = Math.sqrt(l = y);
                                                    n = e1 - v, i = r - v, a = e1 + v, o = r + v, s = d;
                                                }
                                            }
                                            for(var x = c.nodes, _ = .5 * (u + f), b = .5 * (h + p), w = (r >= b) << 1 | e1 >= _, T = w + 4; w < T; ++w)if (c = x[3 & w]) switch(3 & w){
                                                case 0:
                                                    t1(c, u, h, _, b);
                                                    break;
                                                case 1:
                                                    t1(c, _, h, f, b);
                                                    break;
                                                case 2:
                                                    t1(c, u, b, _, p);
                                                    break;
                                                case 3:
                                                    t1(c, _, b, f, p);
                                            }
                                        }
                                    }(t1, n, i, a, o), s;
                                }(M, t1[0], t1[1], p, d, m, g);
                            }, h = -1, null == e1) {
                                for(; ++h < f;)k(M, t1[h], c[h], u[h], p, d, m, g);
                                --h;
                            } else t1.forEach(M.add);
                            return c = u = t1 = l = null, M;
                        }
                        return l.x = function(t1) {
                            return arguments.length ? (o = t1, l) : o;
                        }, l.y = function(t1) {
                            return arguments.length ? (s = t1, l) : s;
                        }, l.extent = function(t1) {
                            return arguments.length ? (null == t1 ? e1 = r = n = i = null : (e1 = +t1[0][0], r = +t1[0][1], n = +t1[1][0], i = +t1[1][1]), l) : null == e1 ? null : [
                                [
                                    e1,
                                    r
                                ],
                                [
                                    n,
                                    i
                                ]
                            ];
                        }, l.size = function(t1) {
                            return arguments.length ? (null == t1 ? e1 = r = n = i = null : (e1 = r = 0, n = +t1[0], i = +t1[1]), l) : null == e1 ? null : [
                                n - e1,
                                i - r
                            ];
                        }, l;
                    }, a.interpolateRgb = yr, a.interpolateObject = vr, a.interpolateNumber = xr, a.interpolateString = _r;
                    var br = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, wr = new RegExp(br.source, "g");
                    function Tr(t1, e1) {
                        for(var r, n = a.interpolators.length; --n >= 0 && !(r = a.interpolators[n](t1, e1)););
                        return r;
                    }
                    function kr(t1, e1) {
                        var r, n = [], i = [], a = t1.length, o = e1.length, s = Math.min(t1.length, e1.length);
                        for(r = 0; r < s; ++r)n.push(Tr(t1[r], e1[r]));
                        for(; r < a; ++r)i[r] = t1[r];
                        for(; r < o; ++r)i[r] = e1[r];
                        return function(t1) {
                            for(r = 0; r < s; ++r)i[r] = n[r](t1);
                            return i;
                        };
                    }
                    a.interpolate = Tr, a.interpolators = [
                        function(t1, e1) {
                            var r = typeof e1;
                            return ("string" === r ? me.has(e1.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(e1) ? yr : _r : e1 instanceof Vt ? yr : Array.isArray(e1) ? kr : "object" === r && isNaN(e1) ? vr : xr)(t1, e1);
                        }
                    ], a.interpolateArray = kr;
                    var Ar = function() {
                        return D;
                    }, Mr = a.map({
                        linear: Ar,
                        poly: function(t1) {
                            return function(e1) {
                                return Math.pow(e1, t1);
                            };
                        },
                        quad: function() {
                            return Lr;
                        },
                        cubic: function() {
                            return Ir;
                        },
                        sin: function() {
                            return zr;
                        },
                        exp: function() {
                            return Or;
                        },
                        circle: function() {
                            return Dr;
                        },
                        elastic: function(t1, e1) {
                            var r;
                            return arguments.length < 2 && (e1 = .45), arguments.length ? r = e1 / It * Math.asin(1 / t1) : (t1 = 1, r = e1 / 4), function(n) {
                                return 1 + t1 * Math.pow(2, -10 * n) * Math.sin((n - r) * It / e1);
                            };
                        },
                        back: function(t1) {
                            return t1 || (t1 = 1.70158), function(e1) {
                                return e1 * e1 * ((t1 + 1) * e1 - t1);
                            };
                        },
                        bounce: function() {
                            return Rr;
                        }
                    }), Sr = a.map({
                        in: D,
                        out: Er,
                        "in-out": Cr,
                        "out-in": function(t1) {
                            return Cr(Er(t1));
                        }
                    });
                    function Er(t1) {
                        return function(e1) {
                            return 1 - t1(1 - e1);
                        };
                    }
                    function Cr(t1) {
                        return function(e1) {
                            return .5 * (e1 < .5 ? t1(2 * e1) : 2 - t1(2 - 2 * e1));
                        };
                    }
                    function Lr(t1) {
                        return t1 * t1;
                    }
                    function Ir(t1) {
                        return t1 * t1 * t1;
                    }
                    function Pr(t1) {
                        if (t1 <= 0) return 0;
                        if (t1 >= 1) return 1;
                        var e1 = t1 * t1, r = e1 * t1;
                        return 4 * (t1 < .5 ? r : 3 * (t1 - e1) + r - .75);
                    }
                    function zr(t1) {
                        return 1 - Math.cos(t1 * zt);
                    }
                    function Or(t1) {
                        return Math.pow(2, 10 * (t1 - 1));
                    }
                    function Dr(t1) {
                        return 1 - Math.sqrt(1 - t1 * t1);
                    }
                    function Rr(t1) {
                        return t1 < 1 / 2.75 ? 7.5625 * t1 * t1 : t1 < 2 / 2.75 ? 7.5625 * (t1 -= 1.5 / 2.75) * t1 + .75 : t1 < 2.5 / 2.75 ? 7.5625 * (t1 -= 2.25 / 2.75) * t1 + .9375 : 7.5625 * (t1 -= 2.625 / 2.75) * t1 + .984375;
                    }
                    function Fr(t1, e1) {
                        return e1 -= t1, function(r) {
                            return Math.round(t1 + e1 * r);
                        };
                    }
                    function Br(t1) {
                        var e1, r, n, i = [
                            t1.a,
                            t1.b
                        ], a = [
                            t1.c,
                            t1.d
                        ], o = jr(i), s = Nr(i, a), l = jr(((e1 = a)[0] += (n = -s) * (r = i)[0], e1[1] += n * r[1], e1)) || 0;
                        i[0] * a[1] < a[0] * i[1] && (i[0] *= -1, i[1] *= -1, o *= -1, s *= -1), this.rotate = (o ? Math.atan2(i[1], i[0]) : Math.atan2(-a[0], a[1])) * Dt, this.translate = [
                            t1.e,
                            t1.f
                        ], this.scale = [
                            o,
                            l
                        ], this.skew = l ? Math.atan2(s, l) * Dt : 0;
                    }
                    function Nr(t1, e1) {
                        return t1[0] * e1[0] + t1[1] * e1[1];
                    }
                    function jr(t1) {
                        var e1 = Math.sqrt(Nr(t1, t1));
                        return e1 && (t1[0] /= e1, t1[1] /= e1), e1;
                    }
                    a.ease = function(t1) {
                        var e1, r = t1.indexOf("-"), n = r >= 0 ? t1.slice(0, r) : t1, i = r >= 0 ? t1.slice(r + 1) : "in";
                        return n = Mr.get(n) || Ar, i = Sr.get(i) || D, e1 = i(n.apply(null, o.call(arguments, 1))), function(t1) {
                            return t1 <= 0 ? 0 : t1 >= 1 ? 1 : e1(t1);
                        };
                    }, a.interpolateHcl = function(t1, e1) {
                        t1 = a.hcl(t1), e1 = a.hcl(e1);
                        var r = t1.h, n = t1.c, i = t1.l, o = e1.h - r, s = e1.c - n, l = e1.l - i;
                        return isNaN(s) && (s = 0, n = isNaN(n) ? e1.c : n), isNaN(o) ? (o = 0, r = isNaN(r) ? e1.h : r) : o > 180 ? o -= 360 : o < -180 && (o += 360), function(t1) {
                            return Yt(r + o * t1, n + s * t1, i + l * t1) + "";
                        };
                    }, a.interpolateHsl = function(t1, e1) {
                        t1 = a.hsl(t1), e1 = a.hsl(e1);
                        var r = t1.h, n = t1.s, i = t1.l, o = e1.h - r, s = e1.s - n, l = e1.l - i;
                        return isNaN(s) && (s = 0, n = isNaN(n) ? e1.s : n), isNaN(o) ? (o = 0, r = isNaN(r) ? e1.h : r) : o > 180 ? o -= 360 : o < -180 && (o += 360), function(t1) {
                            return Gt(r + o * t1, n + s * t1, i + l * t1) + "";
                        };
                    }, a.interpolateLab = function(t1, e1) {
                        t1 = a.lab(t1), e1 = a.lab(e1);
                        var r = t1.l, n = t1.a, i = t1.b, o = e1.l - r, s = e1.a - n, l = e1.b - i;
                        return function(t1) {
                            return ee(r + o * t1, n + s * t1, i + l * t1) + "";
                        };
                    }, a.interpolateRound = Fr, a.transform = function(t1) {
                        var e1 = l.createElementNS(a.ns.prefix.svg, "g");
                        return (a.transform = function(t1) {
                            if (null != t1) {
                                e1.setAttribute("transform", t1);
                                var r = e1.transform.baseVal.consolidate();
                            }
                            return new Br(r ? r.matrix : Ur);
                        })(t1);
                    }, Br.prototype.toString = function() {
                        return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
                    };
                    var Ur = {
                        a: 1,
                        b: 0,
                        c: 0,
                        d: 1,
                        e: 0,
                        f: 0
                    };
                    function Vr(t1) {
                        return t1.length ? t1.pop() + "," : "";
                    }
                    function qr(t1, e1) {
                        var r = [], n = [];
                        return t1 = a.transform(t1), e1 = a.transform(e1), function(t1, e1, r, n) {
                            if (t1[0] !== e1[0] || t1[1] !== e1[1]) {
                                var i = r.push("translate(", null, ",", null, ")");
                                n.push({
                                    i: i - 4,
                                    x: xr(t1[0], e1[0])
                                }, {
                                    i: i - 2,
                                    x: xr(t1[1], e1[1])
                                });
                            } else (e1[0] || e1[1]) && r.push("translate(" + e1 + ")");
                        }(t1.translate, e1.translate, r, n), function(t1, e1, r, n) {
                            t1 !== e1 ? (t1 - e1 > 180 ? e1 += 360 : e1 - t1 > 180 && (t1 += 360), n.push({
                                i: r.push(Vr(r) + "rotate(", null, ")") - 2,
                                x: xr(t1, e1)
                            })) : e1 && r.push(Vr(r) + "rotate(" + e1 + ")");
                        }(t1.rotate, e1.rotate, r, n), function(t1, e1, r, n) {
                            t1 !== e1 ? n.push({
                                i: r.push(Vr(r) + "skewX(", null, ")") - 2,
                                x: xr(t1, e1)
                            }) : e1 && r.push(Vr(r) + "skewX(" + e1 + ")");
                        }(t1.skew, e1.skew, r, n), function(t1, e1, r, n) {
                            if (t1[0] !== e1[0] || t1[1] !== e1[1]) {
                                var i = r.push(Vr(r) + "scale(", null, ",", null, ")");
                                n.push({
                                    i: i - 4,
                                    x: xr(t1[0], e1[0])
                                }, {
                                    i: i - 2,
                                    x: xr(t1[1], e1[1])
                                });
                            } else 1 === e1[0] && 1 === e1[1] || r.push(Vr(r) + "scale(" + e1 + ")");
                        }(t1.scale, e1.scale, r, n), t1 = e1 = null, function(t1) {
                            for(var e1, i = -1, a = n.length; ++i < a;)r[(e1 = n[i]).i] = e1.x(t1);
                            return r.join("");
                        };
                    }
                    function Hr(t1, e1) {
                        return e1 = (e1 -= t1 = +t1) || 1 / e1, function(r) {
                            return (r - t1) / e1;
                        };
                    }
                    function Gr(t1, e1) {
                        return e1 = (e1 -= t1 = +t1) || 1 / e1, function(r) {
                            return Math.max(0, Math.min(1, (r - t1) / e1));
                        };
                    }
                    function Zr(t1) {
                        for(var e1 = t1.source, r = t1.target, n = function(t1, e1) {
                            if (t1 === e1) return t1;
                            for(var r = Wr(t1), n = Wr(e1), i = r.pop(), a = n.pop(), o = null; i === a;)o = i, i = r.pop(), a = n.pop();
                            return o;
                        }(e1, r), i = [
                            e1
                        ]; e1 !== n;)e1 = e1.parent, i.push(e1);
                        for(var a = i.length; r !== n;)i.splice(a, 0, r), r = r.parent;
                        return i;
                    }
                    function Wr(t1) {
                        for(var e1 = [], r = t1.parent; null != r;)e1.push(t1), t1 = r, r = r.parent;
                        return e1.push(t1), e1;
                    }
                    function Yr(t1) {
                        t1.fixed |= 2;
                    }
                    function Xr(t1) {
                        t1.fixed &= -7;
                    }
                    function $r(t1) {
                        t1.fixed |= 4, t1.px = t1.x, t1.py = t1.y;
                    }
                    function Jr(t1) {
                        t1.fixed &= -5;
                    }
                    function Kr(t1, e1, r) {
                        var n = 0, i = 0;
                        if (t1.charge = 0, !t1.leaf) for(var a, o = t1.nodes, s = o.length, l = -1; ++l < s;)null != (a = o[l]) && (Kr(a, e1, r), t1.charge += a.charge, n += a.charge * a.cx, i += a.charge * a.cy);
                        if (t1.point) {
                            t1.leaf || (t1.point.x += Math.random() - .5, t1.point.y += Math.random() - .5);
                            var c = e1 * r[t1.point.index];
                            t1.charge += t1.pointCharge = c, n += c * t1.point.x, i += c * t1.point.y;
                        }
                        t1.cx = n / t1.charge, t1.cy = i / t1.charge;
                    }
                    a.interpolateTransform = qr, a.layout = {}, a.layout.bundle = function() {
                        return function(t1) {
                            for(var e1 = [], r = -1, n = t1.length; ++r < n;)e1.push(Zr(t1[r]));
                            return e1;
                        };
                    }, a.layout.chord = function() {
                        var t1, e1, r, n, i, o, s, l = {}, c = 0;
                        function u() {
                            var l, u, f, p, d, m = {}, g = [], y = a.range(n), v = [];
                            for(t1 = [], e1 = [], l = 0, p = -1; ++p < n;){
                                for(u = 0, d = -1; ++d < n;)u += r[p][d];
                                g.push(u), v.push(a.range(n)), l += u;
                            }
                            for(i && y.sort(function(t1, e1) {
                                return i(g[t1], g[e1]);
                            }), o && v.forEach(function(t1, e1) {
                                t1.sort(function(t1, n) {
                                    return o(r[e1][t1], r[e1][n]);
                                });
                            }), l = (It - c * n) / l, u = 0, p = -1; ++p < n;){
                                for(f = u, d = -1; ++d < n;){
                                    var x = y[p], _ = v[x][d], b = r[x][_], w = u, T = u += b * l;
                                    m[x + "-" + _] = {
                                        index: x,
                                        subindex: _,
                                        startAngle: w,
                                        endAngle: T,
                                        value: b
                                    };
                                }
                                e1[x] = {
                                    index: x,
                                    startAngle: f,
                                    endAngle: u,
                                    value: g[x]
                                }, u += c;
                            }
                            for(p = -1; ++p < n;)for(d = p - 1; ++d < n;){
                                var k = m[p + "-" + d], A = m[d + "-" + p];
                                (k.value || A.value) && t1.push(k.value < A.value ? {
                                    source: A,
                                    target: k
                                } : {
                                    source: k,
                                    target: A
                                });
                            }
                            s && h();
                        }
                        function h() {
                            t1.sort(function(t1, e1) {
                                return s((t1.source.value + t1.target.value) / 2, (e1.source.value + e1.target.value) / 2);
                            });
                        }
                        return l.matrix = function(i) {
                            return arguments.length ? (n = (r = i) && r.length, t1 = e1 = null, l) : r;
                        }, l.padding = function(r) {
                            return arguments.length ? (c = r, t1 = e1 = null, l) : c;
                        }, l.sortGroups = function(r) {
                            return arguments.length ? (i = r, t1 = e1 = null, l) : i;
                        }, l.sortSubgroups = function(e1) {
                            return arguments.length ? (o = e1, t1 = null, l) : o;
                        }, l.sortChords = function(e1) {
                            return arguments.length ? (s = e1, t1 && h(), l) : s;
                        }, l.chords = function() {
                            return t1 || u(), t1;
                        }, l.groups = function() {
                            return e1 || u(), e1;
                        }, l;
                    }, a.layout.force = function() {
                        var t1, e1, r, n, i, o, s = {}, l = a.dispatch("start", "tick", "end"), c = [
                            1,
                            1
                        ], u = .9, h = Qr, f = tn, p = -30, d = en, m = .1, g = .64, y = [], v = [];
                        function x(t1) {
                            return function(e1, r, n, i) {
                                if (e1.point !== t1) {
                                    var a = e1.cx - t1.x, o = e1.cy - t1.y, s = i - r, l = a * a + o * o;
                                    if (s * s / g < l) {
                                        if (l < d) {
                                            var c = e1.charge / l;
                                            t1.px -= a * c, t1.py -= o * c;
                                        }
                                        return !0;
                                    }
                                    e1.point && l && l < d && (c = e1.pointCharge / l, t1.px -= a * c, t1.py -= o * c);
                                }
                                return !e1.charge;
                            };
                        }
                        function _(t1) {
                            t1.px = a.event.x, t1.py = a.event.y, s.resume();
                        }
                        return s.tick = function() {
                            if ((r *= .99) < .005) return t1 = null, l.end({
                                type: "end",
                                alpha: r = 0
                            }), !0;
                            var e1, s, h, f, d, g, _, b, w, T = y.length, k = v.length;
                            for(s = 0; s < k; ++s)f = (h = v[s]).source, (g = (b = (d = h.target).x - f.x) * b + (w = d.y - f.y) * w) && (b *= g = r * i[s] * ((g = Math.sqrt(g)) - n[s]) / g, w *= g, d.x -= b * (_ = f.weight + d.weight ? f.weight / (f.weight + d.weight) : .5), d.y -= w * _, f.x += b * (_ = 1 - _), f.y += w * _);
                            if ((_ = r * m) && (b = c[0] / 2, w = c[1] / 2, s = -1, _)) for(; ++s < T;)(h = y[s]).x += (b - h.x) * _, h.y += (w - h.y) * _;
                            if (p) for(Kr(e1 = a.geom.quadtree(y), r, o), s = -1; ++s < T;)(h = y[s]).fixed || e1.visit(x(h));
                            for(s = -1; ++s < T;)(h = y[s]).fixed ? (h.x = h.px, h.y = h.py) : (h.x -= (h.px - (h.px = h.x)) * u, h.y -= (h.py - (h.py = h.y)) * u);
                            l.tick({
                                type: "tick",
                                alpha: r
                            });
                        }, s.nodes = function(t1) {
                            return arguments.length ? (y = t1, s) : y;
                        }, s.links = function(t1) {
                            return arguments.length ? (v = t1, s) : v;
                        }, s.size = function(t1) {
                            return arguments.length ? (c = t1, s) : c;
                        }, s.linkDistance = function(t1) {
                            return arguments.length ? (h = "function" == typeof t1 ? t1 : +t1, s) : h;
                        }, s.distance = s.linkDistance, s.linkStrength = function(t1) {
                            return arguments.length ? (f = "function" == typeof t1 ? t1 : +t1, s) : f;
                        }, s.friction = function(t1) {
                            return arguments.length ? (u = +t1, s) : u;
                        }, s.charge = function(t1) {
                            return arguments.length ? (p = "function" == typeof t1 ? t1 : +t1, s) : p;
                        }, s.chargeDistance = function(t1) {
                            return arguments.length ? (d = t1 * t1, s) : Math.sqrt(d);
                        }, s.gravity = function(t1) {
                            return arguments.length ? (m = +t1, s) : m;
                        }, s.theta = function(t1) {
                            return arguments.length ? (g = t1 * t1, s) : Math.sqrt(g);
                        }, s.alpha = function(e1) {
                            return arguments.length ? (e1 = +e1, r ? e1 > 0 ? r = e1 : (t1.c = null, t1.t = NaN, t1 = null, l.end({
                                type: "end",
                                alpha: r = 0
                            })) : e1 > 0 && (l.start({
                                type: "start",
                                alpha: r = e1
                            }), t1 = ke(s.tick)), s) : r;
                        }, s.start = function() {
                            var t1, e1, r, a = y.length, l = v.length, u = c[0], d = c[1];
                            for(t1 = 0; t1 < a; ++t1)(r = y[t1]).index = t1, r.weight = 0;
                            for(t1 = 0; t1 < l; ++t1)"number" == typeof (r = v[t1]).source && (r.source = y[r.source]), "number" == typeof r.target && (r.target = y[r.target]), ++r.source.weight, ++r.target.weight;
                            for(t1 = 0; t1 < a; ++t1)r = y[t1], isNaN(r.x) && (r.x = m("x", u)), isNaN(r.y) && (r.y = m("y", d)), isNaN(r.px) && (r.px = r.x), isNaN(r.py) && (r.py = r.y);
                            if (n = [], "function" == typeof h) for(t1 = 0; t1 < l; ++t1)n[t1] = +h.call(this, v[t1], t1);
                            else for(t1 = 0; t1 < l; ++t1)n[t1] = h;
                            if (i = [], "function" == typeof f) for(t1 = 0; t1 < l; ++t1)i[t1] = +f.call(this, v[t1], t1);
                            else for(t1 = 0; t1 < l; ++t1)i[t1] = f;
                            if (o = [], "function" == typeof p) for(t1 = 0; t1 < a; ++t1)o[t1] = +p.call(this, y[t1], t1);
                            else for(t1 = 0; t1 < a; ++t1)o[t1] = p;
                            function m(r, n) {
                                if (!e1) {
                                    for(e1 = new Array(a), c = 0; c < a; ++c)e1[c] = [];
                                    for(c = 0; c < l; ++c){
                                        var i = v[c];
                                        e1[i.source.index].push(i.target), e1[i.target.index].push(i.source);
                                    }
                                }
                                for(var o, s = e1[t1], c = -1, u = s.length; ++c < u;)if (!isNaN(o = s[c][r])) return o;
                                return Math.random() * n;
                            }
                            return s.resume();
                        }, s.resume = function() {
                            return s.alpha(.1);
                        }, s.stop = function() {
                            return s.alpha(0);
                        }, s.drag = function() {
                            if (e1 || (e1 = a.behavior.drag().origin(D).on("dragstart.force", Yr).on("drag.force", _).on("dragend.force", Xr)), !arguments.length) return e1;
                            this.on("mouseover.force", $r).on("mouseout.force", Jr).call(e1);
                        }, a.rebind(s, l, "on");
                    };
                    var Qr = 20, tn = 1, en = 1 / 0;
                    function rn(t1, e1) {
                        return a.rebind(t1, e1, "sort", "children", "value"), t1.nodes = t1, t1.links = cn, t1;
                    }
                    function nn(t1, e1) {
                        for(var r = [
                            t1
                        ]; null != (t1 = r.pop());)if (e1(t1), (i = t1.children) && (n = i.length)) for(var n, i; --n >= 0;)r.push(i[n]);
                    }
                    function an(t1, e1) {
                        for(var r = [
                            t1
                        ], n = []; null != (t1 = r.pop());)if (n.push(t1), (a = t1.children) && (i = a.length)) for(var i, a, o = -1; ++o < i;)r.push(a[o]);
                        for(; null != (t1 = n.pop());)e1(t1);
                    }
                    function on(t1) {
                        return t1.children;
                    }
                    function sn(t1) {
                        return t1.value;
                    }
                    function ln(t1, e1) {
                        return e1.value - t1.value;
                    }
                    function cn(t1) {
                        return a.merge(t1.map(function(t1) {
                            return (t1.children || []).map(function(e1) {
                                return {
                                    source: t1,
                                    target: e1
                                };
                            });
                        }));
                    }
                    a.layout.hierarchy = function() {
                        var t1 = ln, e1 = on, r = sn;
                        function n(i) {
                            var a, o = [
                                i
                            ], s = [];
                            for(i.depth = 0; null != (a = o.pop());)if (s.push(a), (c = e1.call(n, a, a.depth)) && (l = c.length)) {
                                for(var l, c, u; --l >= 0;)o.push(u = c[l]), u.parent = a, u.depth = a.depth + 1;
                                r && (a.value = 0), a.children = c;
                            } else r && (a.value = +r.call(n, a, a.depth) || 0), delete a.children;
                            return an(i, function(e1) {
                                var n, i;
                                t1 && (n = e1.children) && n.sort(t1), r && (i = e1.parent) && (i.value += e1.value);
                            }), s;
                        }
                        return n.sort = function(e1) {
                            return arguments.length ? (t1 = e1, n) : t1;
                        }, n.children = function(t1) {
                            return arguments.length ? (e1 = t1, n) : e1;
                        }, n.value = function(t1) {
                            return arguments.length ? (r = t1, n) : r;
                        }, n.revalue = function(t1) {
                            return r && (nn(t1, function(t1) {
                                t1.children && (t1.value = 0);
                            }), an(t1, function(t1) {
                                var e1;
                                t1.children || (t1.value = +r.call(n, t1, t1.depth) || 0), (e1 = t1.parent) && (e1.value += t1.value);
                            })), t1;
                        }, n;
                    }, a.layout.partition = function() {
                        var t1 = a.layout.hierarchy(), e1 = [
                            1,
                            1
                        ];
                        function r(t1, e1, n, i) {
                            var a = t1.children;
                            if (t1.x = e1, t1.y = t1.depth * i, t1.dx = n, t1.dy = i, a && (o = a.length)) {
                                var o, s, l, c = -1;
                                for(n = t1.value ? n / t1.value : 0; ++c < o;)r(s = a[c], e1, l = s.value * n, i), e1 += l;
                            }
                        }
                        function n(t1) {
                            var e1 = t1.children, r = 0;
                            if (e1 && (i = e1.length)) for(var i, a = -1; ++a < i;)r = Math.max(r, n(e1[a]));
                            return 1 + r;
                        }
                        function i(i, a) {
                            var o = t1.call(this, i, a);
                            return r(o[0], 0, e1[0], e1[1] / n(o[0])), o;
                        }
                        return i.size = function(t1) {
                            return arguments.length ? (e1 = t1, i) : e1;
                        }, rn(i, t1);
                    }, a.layout.pie = function() {
                        var t1 = Number, e1 = un, r = 0, n = It, i = 0;
                        function o(s) {
                            var l, c = s.length, u = s.map(function(e1, r) {
                                return +t1.call(o, e1, r);
                            }), h = +("function" == typeof r ? r.apply(this, arguments) : r), f = ("function" == typeof n ? n.apply(this, arguments) : n) - h, p = Math.min(Math.abs(f) / c, +("function" == typeof i ? i.apply(this, arguments) : i)), d = p * (f < 0 ? -1 : 1), m = a.sum(u), g = m ? (f - c * d) / m : 0, y = a.range(c), v = [];
                            return null != e1 && y.sort(e1 === un ? function(t1, e1) {
                                return u[e1] - u[t1];
                            } : function(t1, r) {
                                return e1(s[t1], s[r]);
                            }), y.forEach(function(t1) {
                                v[t1] = {
                                    data: s[t1],
                                    value: l = u[t1],
                                    startAngle: h,
                                    endAngle: h += l * g + d,
                                    padAngle: p
                                };
                            }), v;
                        }
                        return o.value = function(e1) {
                            return arguments.length ? (t1 = e1, o) : t1;
                        }, o.sort = function(t1) {
                            return arguments.length ? (e1 = t1, o) : e1;
                        }, o.startAngle = function(t1) {
                            return arguments.length ? (r = t1, o) : r;
                        }, o.endAngle = function(t1) {
                            return arguments.length ? (n = t1, o) : n;
                        }, o.padAngle = function(t1) {
                            return arguments.length ? (i = t1, o) : i;
                        }, o;
                    };
                    var un = {};
                    function hn(t1) {
                        return t1.x;
                    }
                    function fn(t1) {
                        return t1.y;
                    }
                    function pn(t1, e1, r) {
                        t1.y0 = e1, t1.y = r;
                    }
                    a.layout.stack = function() {
                        var t1 = D, e1 = gn, r = yn, n = pn, i = hn, o = fn;
                        function s(l, c) {
                            if (!(p = l.length)) return l;
                            var u = l.map(function(e1, r) {
                                return t1.call(s, e1, r);
                            }), h = u.map(function(t1) {
                                return t1.map(function(t1, e1) {
                                    return [
                                        i.call(s, t1, e1),
                                        o.call(s, t1, e1)
                                    ];
                                });
                            }), f = e1.call(s, h, c);
                            u = a.permute(u, f), h = a.permute(h, f);
                            var p, d, m, g, y = r.call(s, h, c), v = u[0].length;
                            for(m = 0; m < v; ++m)for(n.call(s, u[0][m], g = y[m], h[0][m][1]), d = 1; d < p; ++d)n.call(s, u[d][m], g += h[d - 1][m][1], h[d][m][1]);
                            return l;
                        }
                        return s.values = function(e1) {
                            return arguments.length ? (t1 = e1, s) : t1;
                        }, s.order = function(t1) {
                            return arguments.length ? (e1 = "function" == typeof t1 ? t1 : dn.get(t1) || gn, s) : e1;
                        }, s.offset = function(t1) {
                            return arguments.length ? (r = "function" == typeof t1 ? t1 : mn.get(t1) || yn, s) : r;
                        }, s.x = function(t1) {
                            return arguments.length ? (i = t1, s) : i;
                        }, s.y = function(t1) {
                            return arguments.length ? (o = t1, s) : o;
                        }, s.out = function(t1) {
                            return arguments.length ? (n = t1, s) : n;
                        }, s;
                    };
                    var dn = a.map({
                        "inside-out": function(t1) {
                            var e1, r, n = t1.length, i = t1.map(vn), o = t1.map(xn), s = a.range(n).sort(function(t1, e1) {
                                return i[t1] - i[e1];
                            }), l = 0, c = 0, u = [], h = [];
                            for(e1 = 0; e1 < n; ++e1)r = s[e1], l < c ? (l += o[r], u.push(r)) : (c += o[r], h.push(r));
                            return h.reverse().concat(u);
                        },
                        reverse: function(t1) {
                            return a.range(t1.length).reverse();
                        },
                        default: gn
                    }), mn = a.map({
                        silhouette: function(t1) {
                            var e1, r, n, i = t1.length, a = t1[0].length, o = [], s = 0, l = [];
                            for(r = 0; r < a; ++r){
                                for(e1 = 0, n = 0; e1 < i; e1++)n += t1[e1][r][1];
                                n > s && (s = n), o.push(n);
                            }
                            for(r = 0; r < a; ++r)l[r] = (s - o[r]) / 2;
                            return l;
                        },
                        wiggle: function(t1) {
                            var e1, r, n, i, a, o, s, l, c, u = t1.length, h = t1[0], f = h.length, p = [];
                            for(p[0] = l = c = 0, r = 1; r < f; ++r){
                                for(e1 = 0, i = 0; e1 < u; ++e1)i += t1[e1][r][1];
                                for(e1 = 0, a = 0, s = h[r][0] - h[r - 1][0]; e1 < u; ++e1){
                                    for(n = 0, o = (t1[e1][r][1] - t1[e1][r - 1][1]) / (2 * s); n < e1; ++n)o += (t1[n][r][1] - t1[n][r - 1][1]) / s;
                                    a += o * t1[e1][r][1];
                                }
                                p[r] = l -= i ? a / i * s : 0, l < c && (c = l);
                            }
                            for(r = 0; r < f; ++r)p[r] -= c;
                            return p;
                        },
                        expand: function(t1) {
                            var e1, r, n, i = t1.length, a = t1[0].length, o = 1 / i, s = [];
                            for(r = 0; r < a; ++r){
                                for(e1 = 0, n = 0; e1 < i; e1++)n += t1[e1][r][1];
                                if (n) for(e1 = 0; e1 < i; e1++)t1[e1][r][1] /= n;
                                else for(e1 = 0; e1 < i; e1++)t1[e1][r][1] = o;
                            }
                            for(r = 0; r < a; ++r)s[r] = 0;
                            return s;
                        },
                        zero: yn
                    });
                    function gn(t1) {
                        return a.range(t1.length);
                    }
                    function yn(t1) {
                        for(var e1 = -1, r = t1[0].length, n = []; ++e1 < r;)n[e1] = 0;
                        return n;
                    }
                    function vn(t1) {
                        for(var e1, r = 1, n = 0, i = t1[0][1], a = t1.length; r < a; ++r)(e1 = t1[r][1]) > i && (n = r, i = e1);
                        return n;
                    }
                    function xn(t1) {
                        return t1.reduce(_n, 0);
                    }
                    function _n(t1, e1) {
                        return t1 + e1[1];
                    }
                    function bn(t1, e1) {
                        return wn(t1, Math.ceil(Math.log(e1.length) / Math.LN2 + 1));
                    }
                    function wn(t1, e1) {
                        for(var r = -1, n = +t1[0], i = (t1[1] - n) / e1, a = []; ++r <= e1;)a[r] = i * r + n;
                        return a;
                    }
                    function Tn(t1) {
                        return [
                            a.min(t1),
                            a.max(t1)
                        ];
                    }
                    function kn(t1, e1) {
                        return t1.value - e1.value;
                    }
                    function An(t1, e1) {
                        var r = t1._pack_next;
                        t1._pack_next = e1, e1._pack_prev = t1, e1._pack_next = r, r._pack_prev = e1;
                    }
                    function Mn(t1, e1) {
                        t1._pack_next = e1, e1._pack_prev = t1;
                    }
                    function Sn(t1, e1) {
                        var r = e1.x - t1.x, n = e1.y - t1.y, i = t1.r + e1.r;
                        return .999 * i * i > r * r + n * n;
                    }
                    function En(t1) {
                        if ((e1 = t1.children) && (l = e1.length)) {
                            var e1, r, n, i, a, o, s, l, c = 1 / 0, u = -1 / 0, h = 1 / 0, f = -1 / 0;
                            if (e1.forEach(Cn), (r = e1[0]).x = -r.r, r.y = 0, x(r), l > 1 && ((n = e1[1]).x = n.r, n.y = 0, x(n), l > 2)) for(Pn(r, n, i = e1[2]), x(i), An(r, i), r._pack_prev = i, An(i, n), n = r._pack_next, a = 3; a < l; a++){
                                Pn(r, n, i = e1[a]);
                                var p = 0, d = 1, m = 1;
                                for(o = n._pack_next; o !== n; o = o._pack_next, d++)if (Sn(o, i)) {
                                    p = 1;
                                    break;
                                }
                                if (1 == p) for(s = r._pack_prev; s !== o._pack_prev && !Sn(s, i); s = s._pack_prev, m++);
                                p ? (d < m || d == m && n.r < r.r ? Mn(r, n = o) : Mn(r = s, n), a--) : (An(r, i), n = i, x(i));
                            }
                            var g = (c + u) / 2, y = (h + f) / 2, v = 0;
                            for(a = 0; a < l; a++)(i = e1[a]).x -= g, i.y -= y, v = Math.max(v, i.r + Math.sqrt(i.x * i.x + i.y * i.y));
                            t1.r = v, e1.forEach(Ln);
                        }
                        function x(t1) {
                            c = Math.min(t1.x - t1.r, c), u = Math.max(t1.x + t1.r, u), h = Math.min(t1.y - t1.r, h), f = Math.max(t1.y + t1.r, f);
                        }
                    }
                    function Cn(t1) {
                        t1._pack_next = t1._pack_prev = t1;
                    }
                    function Ln(t1) {
                        delete t1._pack_next, delete t1._pack_prev;
                    }
                    function In(t1, e1, r, n) {
                        var i = t1.children;
                        if (t1.x = e1 += n * t1.x, t1.y = r += n * t1.y, t1.r *= n, i) for(var a = -1, o = i.length; ++a < o;)In(i[a], e1, r, n);
                    }
                    function Pn(t1, e1, r) {
                        var n = t1.r + r.r, i = e1.x - t1.x, a = e1.y - t1.y;
                        if (n && (i || a)) {
                            var o = e1.r + r.r, s = i * i + a * a, l = .5 + ((n *= n) - (o *= o)) / (2 * s), c = Math.sqrt(Math.max(0, 2 * o * (n + s) - (n -= s) * n - o * o)) / (2 * s);
                            r.x = t1.x + l * i + c * a, r.y = t1.y + l * a - c * i;
                        } else r.x = t1.x + n, r.y = t1.y;
                    }
                    function zn(t1, e1) {
                        return t1.parent == e1.parent ? 1 : 2;
                    }
                    function On(t1) {
                        var e1 = t1.children;
                        return e1.length ? e1[0] : t1.t;
                    }
                    function Dn(t1) {
                        var e1, r = t1.children;
                        return (e1 = r.length) ? r[e1 - 1] : t1.t;
                    }
                    function Rn(t1, e1, r) {
                        var n = r / (e1.i - t1.i);
                        e1.c -= n, e1.s += r, t1.c += n, e1.z += r, e1.m += r;
                    }
                    function Fn(t1, e1, r) {
                        return t1.a.parent === e1.parent ? t1.a : r;
                    }
                    function Bn(t1) {
                        var e1 = t1.children;
                        return e1 && e1.length ? Bn(e1[0]) : t1;
                    }
                    function Nn(t1) {
                        var e1, r = t1.children;
                        return r && (e1 = r.length) ? Nn(r[e1 - 1]) : t1;
                    }
                    function jn(t1) {
                        return {
                            x: t1.x,
                            y: t1.y,
                            dx: t1.dx,
                            dy: t1.dy
                        };
                    }
                    function Un(t1, e1) {
                        var r = t1.x + e1[3], n = t1.y + e1[0], i = t1.dx - e1[1] - e1[3], a = t1.dy - e1[0] - e1[2];
                        return i < 0 && (r += i / 2, i = 0), a < 0 && (n += a / 2, a = 0), {
                            x: r,
                            y: n,
                            dx: i,
                            dy: a
                        };
                    }
                    function Vn(t1) {
                        var e1 = t1[0], r = t1[t1.length - 1];
                        return e1 < r ? [
                            e1,
                            r
                        ] : [
                            r,
                            e1
                        ];
                    }
                    function qn(t1) {
                        return t1.rangeExtent ? t1.rangeExtent() : Vn(t1.range());
                    }
                    function Hn(t1, e1, r, n) {
                        var i = r(t1[0], t1[1]), a = n(e1[0], e1[1]);
                        return function(t1) {
                            return a(i(t1));
                        };
                    }
                    function Gn(t1, e1) {
                        var r, n = 0, i = t1.length - 1, a = t1[n], o = t1[i];
                        return o < a && (r = n, n = i, i = r, r = a, a = o, o = r), t1[n] = e1.floor(a), t1[i] = e1.ceil(o), t1;
                    }
                    function Zn(t1) {
                        return t1 ? {
                            floor: function(e1) {
                                return Math.floor(e1 / t1) * t1;
                            },
                            ceil: function(e1) {
                                return Math.ceil(e1 / t1) * t1;
                            }
                        } : Wn;
                    }
                    a.layout.histogram = function() {
                        var t1 = !0, e1 = Number, r = Tn, n = bn;
                        function i(i, o) {
                            for(var s, l, c = [], u = i.map(e1, this), h = r.call(this, u, o), f = n.call(this, h, u, o), p = (o = -1, u.length), d = f.length - 1, m = t1 ? 1 : 1 / p; ++o < d;)(s = c[o] = []).dx = f[o + 1] - (s.x = f[o]), s.y = 0;
                            if (d > 0) for(o = -1; ++o < p;)(l = u[o]) >= h[0] && l <= h[1] && ((s = c[a.bisect(f, l, 1, d) - 1]).y += m, s.push(i[o]));
                            return c;
                        }
                        return i.value = function(t1) {
                            return arguments.length ? (e1 = t1, i) : e1;
                        }, i.range = function(t1) {
                            return arguments.length ? (r = ge(t1), i) : r;
                        }, i.bins = function(t1) {
                            return arguments.length ? (n = "number" == typeof t1 ? function(e1) {
                                return wn(e1, t1);
                            } : ge(t1), i) : n;
                        }, i.frequency = function(e1) {
                            return arguments.length ? (t1 = !!e1, i) : t1;
                        }, i;
                    }, a.layout.pack = function() {
                        var t1, e1 = a.layout.hierarchy().sort(kn), r = 0, n = [
                            1,
                            1
                        ];
                        function i(i, a) {
                            var o = e1.call(this, i, a), s = o[0], l = n[0], c = n[1], u = null == t1 ? Math.sqrt : "function" == typeof t1 ? t1 : function() {
                                return t1;
                            };
                            if (s.x = s.y = 0, an(s, function(t1) {
                                t1.r = +u(t1.value);
                            }), an(s, En), r) {
                                var h = r * (t1 ? 1 : Math.max(2 * s.r / l, 2 * s.r / c)) / 2;
                                an(s, function(t1) {
                                    t1.r += h;
                                }), an(s, En), an(s, function(t1) {
                                    t1.r -= h;
                                });
                            }
                            return In(s, l / 2, c / 2, t1 ? 1 : 1 / Math.max(2 * s.r / l, 2 * s.r / c)), o;
                        }
                        return i.size = function(t1) {
                            return arguments.length ? (n = t1, i) : n;
                        }, i.radius = function(e1) {
                            return arguments.length ? (t1 = null == e1 || "function" == typeof e1 ? e1 : +e1, i) : t1;
                        }, i.padding = function(t1) {
                            return arguments.length ? (r = +t1, i) : r;
                        }, rn(i, e1);
                    }, a.layout.tree = function() {
                        var t1 = a.layout.hierarchy().sort(null).value(null), e1 = zn, r = [
                            1,
                            1
                        ], n = null;
                        function i(i, a) {
                            var c = t1.call(this, i, a), u = c[0], h = function(t1) {
                                for(var e1, r = {
                                    A: null,
                                    children: [
                                        t1
                                    ]
                                }, n = [
                                    r
                                ]; null != (e1 = n.pop());)for(var i, a = e1.children, o = 0, s = a.length; o < s; ++o)n.push((a[o] = i = {
                                    _: a[o],
                                    parent: e1,
                                    children: (i = a[o].children) && i.slice() || [],
                                    A: null,
                                    a: null,
                                    z: 0,
                                    m: 0,
                                    c: 0,
                                    s: 0,
                                    t: null,
                                    i: o
                                }).a = i);
                                return r.children[0];
                            }(u);
                            if (an(h, o), h.parent.m = -h.z, nn(h, s), n) nn(u, l);
                            else {
                                var f = u, p = u, d = u;
                                nn(u, function(t1) {
                                    t1.x < f.x && (f = t1), t1.x > p.x && (p = t1), t1.depth > d.depth && (d = t1);
                                });
                                var m = e1(f, p) / 2 - f.x, g = r[0] / (p.x + e1(p, f) / 2 + m), y = r[1] / (d.depth || 1);
                                nn(u, function(t1) {
                                    t1.x = (t1.x + m) * g, t1.y = t1.depth * y;
                                });
                            }
                            return c;
                        }
                        function o(t1) {
                            var r = t1.children, n = t1.parent.children, i = t1.i ? n[t1.i - 1] : null;
                            if (r.length) {
                                !function(t1) {
                                    for(var e1, r = 0, n = 0, i = t1.children, a = i.length; --a >= 0;)(e1 = i[a]).z += r, e1.m += r, r += e1.s + (n += e1.c);
                                }(t1);
                                var a = (r[0].z + r[r.length - 1].z) / 2;
                                i ? (t1.z = i.z + e1(t1._, i._), t1.m = t1.z - a) : t1.z = a;
                            } else i && (t1.z = i.z + e1(t1._, i._));
                            t1.parent.A = function(t1, r, n) {
                                if (r) {
                                    for(var i, a = t1, o = t1, s = r, l = a.parent.children[0], c = a.m, u = o.m, h = s.m, f = l.m; s = Dn(s), a = On(a), s && a;)l = On(l), (o = Dn(o)).a = t1, (i = s.z + h - a.z - c + e1(s._, a._)) > 0 && (Rn(Fn(s, t1, n), t1, i), c += i, u += i), h += s.m, c += a.m, f += l.m, u += o.m;
                                    s && !Dn(o) && (o.t = s, o.m += h - u), a && !On(l) && (l.t = a, l.m += c - f, n = t1);
                                }
                                return n;
                            }(t1, i, t1.parent.A || n[0]);
                        }
                        function s(t1) {
                            t1._.x = t1.z + t1.parent.m, t1.m += t1.parent.m;
                        }
                        function l(t1) {
                            t1.x *= r[0], t1.y = t1.depth * r[1];
                        }
                        return i.separation = function(t1) {
                            return arguments.length ? (e1 = t1, i) : e1;
                        }, i.size = function(t1) {
                            return arguments.length ? (n = null == (r = t1) ? l : null, i) : n ? null : r;
                        }, i.nodeSize = function(t1) {
                            return arguments.length ? (n = null == (r = t1) ? null : l, i) : n ? r : null;
                        }, rn(i, t1);
                    }, a.layout.cluster = function() {
                        var t1 = a.layout.hierarchy().sort(null).value(null), e1 = zn, r = [
                            1,
                            1
                        ], n = !1;
                        function i(i, o) {
                            var s, l = t1.call(this, i, o), c = l[0], u = 0;
                            an(c, function(t1) {
                                var r = t1.children;
                                r && r.length ? (t1.x = function(t1) {
                                    return t1.reduce(function(t1, e1) {
                                        return t1 + e1.x;
                                    }, 0) / t1.length;
                                }(r), t1.y = function(t1) {
                                    return 1 + a.max(t1, function(t1) {
                                        return t1.y;
                                    });
                                }(r)) : (t1.x = s ? u += e1(t1, s) : 0, t1.y = 0, s = t1);
                            });
                            var h = Bn(c), f = Nn(c), p = h.x - e1(h, f) / 2, d = f.x + e1(f, h) / 2;
                            return an(c, n ? function(t1) {
                                t1.x = (t1.x - c.x) * r[0], t1.y = (c.y - t1.y) * r[1];
                            } : function(t1) {
                                t1.x = (t1.x - p) / (d - p) * r[0], t1.y = (1 - (c.y ? t1.y / c.y : 1)) * r[1];
                            }), l;
                        }
                        return i.separation = function(t1) {
                            return arguments.length ? (e1 = t1, i) : e1;
                        }, i.size = function(t1) {
                            return arguments.length ? (n = null == (r = t1), i) : n ? null : r;
                        }, i.nodeSize = function(t1) {
                            return arguments.length ? (n = null != (r = t1), i) : n ? r : null;
                        }, rn(i, t1);
                    }, a.layout.treemap = function() {
                        var t1, e1 = a.layout.hierarchy(), r = Math.round, n = [
                            1,
                            1
                        ], i = null, o = jn, s = !1, l = "squarify", c = .5 * (1 + Math.sqrt(5));
                        function u(t1, e1) {
                            for(var r, n, i = -1, a = t1.length; ++i < a;)n = (r = t1[i]).value * (e1 < 0 ? 0 : e1), r.area = isNaN(n) || n <= 0 ? 0 : n;
                        }
                        function h(t1) {
                            var e1 = t1.children;
                            if (e1 && e1.length) {
                                var r, n, i, a = o(t1), s = [], c = e1.slice(), f = 1 / 0, m = "slice" === l ? a.dx : "dice" === l ? a.dy : "slice-dice" === l ? 1 & t1.depth ? a.dy : a.dx : Math.min(a.dx, a.dy);
                                for(u(c, a.dx * a.dy / t1.value), s.area = 0; (i = c.length) > 0;)s.push(r = c[i - 1]), s.area += r.area, "squarify" !== l || (n = p(s, m)) <= f ? (c.pop(), f = n) : (s.area -= s.pop().area, d(s, m, a, !1), m = Math.min(a.dx, a.dy), s.length = s.area = 0, f = 1 / 0);
                                s.length && (d(s, m, a, !0), s.length = s.area = 0), e1.forEach(h);
                            }
                        }
                        function f(t1) {
                            var e1 = t1.children;
                            if (e1 && e1.length) {
                                var r, n = o(t1), i = e1.slice(), a = [];
                                for(u(i, n.dx * n.dy / t1.value), a.area = 0; r = i.pop();)a.push(r), a.area += r.area, null != r.z && (d(a, r.z ? n.dx : n.dy, n, !i.length), a.length = a.area = 0);
                                e1.forEach(f);
                            }
                        }
                        function p(t1, e1) {
                            for(var r, n = t1.area, i = 0, a = 1 / 0, o = -1, s = t1.length; ++o < s;)(r = t1[o].area) && (r < a && (a = r), r > i && (i = r));
                            return e1 *= e1, (n *= n) ? Math.max(e1 * i * c / n, n / (e1 * a * c)) : 1 / 0;
                        }
                        function d(t1, e1, n, i) {
                            var a, o = -1, s = t1.length, l = n.x, c = n.y, u = e1 ? r(t1.area / e1) : 0;
                            if (e1 == n.dx) {
                                for((i || u > n.dy) && (u = n.dy); ++o < s;)(a = t1[o]).x = l, a.y = c, a.dy = u, l += a.dx = Math.min(n.x + n.dx - l, u ? r(a.area / u) : 0);
                                a.z = !0, a.dx += n.x + n.dx - l, n.y += u, n.dy -= u;
                            } else {
                                for((i || u > n.dx) && (u = n.dx); ++o < s;)(a = t1[o]).x = l, a.y = c, a.dx = u, c += a.dy = Math.min(n.y + n.dy - c, u ? r(a.area / u) : 0);
                                a.z = !1, a.dy += n.y + n.dy - c, n.x += u, n.dx -= u;
                            }
                        }
                        function m(r) {
                            var i = t1 || e1(r), a = i[0];
                            return a.x = a.y = 0, a.value ? (a.dx = n[0], a.dy = n[1]) : a.dx = a.dy = 0, t1 && e1.revalue(a), u([
                                a
                            ], a.dx * a.dy / a.value), (t1 ? f : h)(a), s && (t1 = i), i;
                        }
                        return m.size = function(t1) {
                            return arguments.length ? (n = t1, m) : n;
                        }, m.padding = function(t1) {
                            if (!arguments.length) return i;
                            function e1(e1) {
                                return Un(e1, t1);
                            }
                            var r;
                            return o = null == (i = t1) ? jn : "function" == (r = typeof t1) ? function(e1) {
                                var r = t1.call(m, e1, e1.depth);
                                return null == r ? jn(e1) : Un(e1, "number" == typeof r ? [
                                    r,
                                    r,
                                    r,
                                    r
                                ] : r);
                            } : "number" === r ? (t1 = [
                                t1,
                                t1,
                                t1,
                                t1
                            ], e1) : e1, m;
                        }, m.round = function(t1) {
                            return arguments.length ? (r = t1 ? Math.round : Number, m) : r != Number;
                        }, m.sticky = function(e1) {
                            return arguments.length ? (s = e1, t1 = null, m) : s;
                        }, m.ratio = function(t1) {
                            return arguments.length ? (c = t1, m) : c;
                        }, m.mode = function(t1) {
                            return arguments.length ? (l = t1 + "", m) : l;
                        }, rn(m, e1);
                    }, a.random = {
                        normal: function(t1, e1) {
                            var r = arguments.length;
                            return r < 2 && (e1 = 1), r < 1 && (t1 = 0), function() {
                                var r, n, i;
                                do i = (r = 2 * Math.random() - 1) * r + (n = 2 * Math.random() - 1) * n;
                                while (!i || i > 1);
                                return t1 + e1 * r * Math.sqrt(-2 * Math.log(i) / i);
                            };
                        },
                        logNormal: function() {
                            var t1 = a.random.normal.apply(a, arguments);
                            return function() {
                                return Math.exp(t1());
                            };
                        },
                        bates: function(t1) {
                            var e1 = a.random.irwinHall(t1);
                            return function() {
                                return e1() / t1;
                            };
                        },
                        irwinHall: function(t1) {
                            return function() {
                                for(var e1 = 0, r = 0; r < t1; r++)e1 += Math.random();
                                return e1;
                            };
                        }
                    }, a.scale = {};
                    var Wn = {
                        floor: D,
                        ceil: D
                    };
                    function Yn(t1, e1, r, n) {
                        var i = [], o = [], s = 0, l = Math.min(t1.length, e1.length) - 1;
                        for(t1[l] < t1[0] && (t1 = t1.slice().reverse(), e1 = e1.slice().reverse()); ++s <= l;)i.push(r(t1[s - 1], t1[s])), o.push(n(e1[s - 1], e1[s]));
                        return function(e1) {
                            var r = a.bisect(t1, e1, 1, l) - 1;
                            return o[r](i[r](e1));
                        };
                    }
                    function Xn(t1, e1, r, n) {
                        var i, a;
                        function o() {
                            var o = Math.min(t1.length, e1.length) > 2 ? Yn : Hn, l = n ? Gr : Hr;
                            return i = o(t1, e1, l, r), a = o(e1, t1, l, Tr), s;
                        }
                        function s(t1) {
                            return i(t1);
                        }
                        return s.invert = function(t1) {
                            return a(t1);
                        }, s.domain = function(e1) {
                            return arguments.length ? (t1 = e1.map(Number), o()) : t1;
                        }, s.range = function(t1) {
                            return arguments.length ? (e1 = t1, o()) : e1;
                        }, s.rangeRound = function(t1) {
                            return s.range(t1).interpolate(Fr);
                        }, s.clamp = function(t1) {
                            return arguments.length ? (n = t1, o()) : n;
                        }, s.interpolate = function(t1) {
                            return arguments.length ? (r = t1, o()) : r;
                        }, s.ticks = function(e1) {
                            return Qn(t1, e1);
                        }, s.tickFormat = function(e1, r) {
                            return d3_scale_linearTickFormat(t1, e1, r);
                        }, s.nice = function(e1) {
                            return Jn(t1, e1), o();
                        }, s.copy = function() {
                            return Xn(t1, e1, r, n);
                        }, o();
                    }
                    function $n(t1, e1) {
                        return a.rebind(t1, e1, "range", "rangeRound", "interpolate", "clamp");
                    }
                    function Jn(t1, e1) {
                        return Gn(t1, Zn(Kn(t1, e1)[2])), Gn(t1, Zn(Kn(t1, e1)[2])), t1;
                    }
                    function Kn(t1, e1) {
                        null == e1 && (e1 = 10);
                        var r = Vn(t1), n = r[1] - r[0], i = Math.pow(10, Math.floor(Math.log(n / e1) / Math.LN10)), a = e1 / n * i;
                        return a <= .15 ? i *= 10 : a <= .35 ? i *= 5 : a <= .75 && (i *= 2), r[0] = Math.ceil(r[0] / i) * i, r[1] = Math.floor(r[1] / i) * i + .5 * i, r[2] = i, r;
                    }
                    function Qn(t1, e1) {
                        return a.range.apply(a, Kn(t1, e1));
                    }
                    function ti(t1, e1, r, n) {
                        function i(t1) {
                            return (r ? Math.log(t1 < 0 ? 0 : t1) : -Math.log(t1 > 0 ? 0 : -t1)) / Math.log(e1);
                        }
                        function a(t1) {
                            return r ? Math.pow(e1, t1) : -Math.pow(e1, -t1);
                        }
                        function o(e1) {
                            return t1(i(e1));
                        }
                        return o.invert = function(e1) {
                            return a(t1.invert(e1));
                        }, o.domain = function(e1) {
                            return arguments.length ? (r = e1[0] >= 0, t1.domain((n = e1.map(Number)).map(i)), o) : n;
                        }, o.base = function(r) {
                            return arguments.length ? (e1 = +r, t1.domain(n.map(i)), o) : e1;
                        }, o.nice = function() {
                            var e1 = Gn(n.map(i), r ? Math : ei);
                            return t1.domain(e1), n = e1.map(a), o;
                        }, o.ticks = function() {
                            var t1 = Vn(n), o = [], s = t1[0], l = t1[1], c = Math.floor(i(s)), u = Math.ceil(i(l)), h = e1 % 1 ? 2 : e1;
                            if (isFinite(u - c)) {
                                if (r) {
                                    for(; c < u; c++)for(var f = 1; f < h; f++)o.push(a(c) * f);
                                    o.push(a(c));
                                } else for(o.push(a(c)); c++ < u;)for(f = h - 1; f > 0; f--)o.push(a(c) * f);
                                for(c = 0; o[c] < s; c++);
                                for(u = o.length; o[u - 1] > l; u--);
                                o = o.slice(c, u);
                            }
                            return o;
                        }, o.copy = function() {
                            return ti(t1.copy(), e1, r, n);
                        }, $n(o, t1);
                    }
                    a.scale.linear = function() {
                        return Xn([
                            0,
                            1
                        ], [
                            0,
                            1
                        ], Tr, !1);
                    }, a.scale.log = function() {
                        return ti(a.scale.linear().domain([
                            0,
                            1
                        ]), 10, !0, [
                            1,
                            10
                        ]);
                    };
                    var ei = {
                        floor: function(t1) {
                            return -Math.ceil(-t1);
                        },
                        ceil: function(t1) {
                            return -Math.floor(-t1);
                        }
                    };
                    function ri(t1, e1, r) {
                        var n = ni(e1), i = ni(1 / e1);
                        function a(e1) {
                            return t1(n(e1));
                        }
                        return a.invert = function(e1) {
                            return i(t1.invert(e1));
                        }, a.domain = function(e1) {
                            return arguments.length ? (t1.domain((r = e1.map(Number)).map(n)), a) : r;
                        }, a.ticks = function(t1) {
                            return Qn(r, t1);
                        }, a.tickFormat = function(t1, e1) {
                            return d3_scale_linearTickFormat(r, t1, e1);
                        }, a.nice = function(t1) {
                            return a.domain(Jn(r, t1));
                        }, a.exponent = function(o) {
                            return arguments.length ? (n = ni(e1 = o), i = ni(1 / e1), t1.domain(r.map(n)), a) : e1;
                        }, a.copy = function() {
                            return ri(t1.copy(), e1, r);
                        }, $n(a, t1);
                    }
                    function ni(t1) {
                        return function(e1) {
                            return e1 < 0 ? -Math.pow(-e1, t1) : Math.pow(e1, t1);
                        };
                    }
                    function ii(t1, e1) {
                        var r, n, i;
                        function o(i) {
                            return n[((r.get(i) || ("range" === e1.t ? r.set(i, t1.push(i)) : NaN)) - 1) % n.length];
                        }
                        function s(e1, r) {
                            return a.range(t1.length).map(function(t1) {
                                return e1 + r * t1;
                            });
                        }
                        return o.domain = function(n) {
                            if (!arguments.length) return t1;
                            t1 = [], r = new k;
                            for(var i, a = -1, s = n.length; ++a < s;)r.has(i = n[a]) || r.set(i, t1.push(i));
                            return o[e1.t].apply(o, e1.a);
                        }, o.range = function(t1) {
                            return arguments.length ? (n = t1, i = 0, e1 = {
                                t: "range",
                                a: arguments
                            }, o) : n;
                        }, o.rangePoints = function(r, a) {
                            arguments.length < 2 && (a = 0);
                            var l = r[0], c = r[1], u = t1.length < 2 ? (l = (l + c) / 2, 0) : (c - l) / (t1.length - 1 + a);
                            return n = s(l + u * a / 2, u), i = 0, e1 = {
                                t: "rangePoints",
                                a: arguments
                            }, o;
                        }, o.rangeRoundPoints = function(r, a) {
                            arguments.length < 2 && (a = 0);
                            var l = r[0], c = r[1], u = t1.length < 2 ? (l = c = Math.round((l + c) / 2), 0) : (c - l) / (t1.length - 1 + a) | 0;
                            return n = s(l + Math.round(u * a / 2 + (c - l - (t1.length - 1 + a) * u) / 2), u), i = 0, e1 = {
                                t: "rangeRoundPoints",
                                a: arguments
                            }, o;
                        }, o.rangeBands = function(r, a, l) {
                            arguments.length < 2 && (a = 0), arguments.length < 3 && (l = a);
                            var c = r[1] < r[0], u = r[c - 0], h = (r[1 - c] - u) / (t1.length - a + 2 * l);
                            return n = s(u + h * l, h), c && n.reverse(), i = h * (1 - a), e1 = {
                                t: "rangeBands",
                                a: arguments
                            }, o;
                        }, o.rangeRoundBands = function(r, a, l) {
                            arguments.length < 2 && (a = 0), arguments.length < 3 && (l = a);
                            var c = r[1] < r[0], u = r[c - 0], h = r[1 - c], f = Math.floor((h - u) / (t1.length - a + 2 * l));
                            return n = s(u + Math.round((h - u - (t1.length - a) * f) / 2), f), c && n.reverse(), i = Math.round(f * (1 - a)), e1 = {
                                t: "rangeRoundBands",
                                a: arguments
                            }, o;
                        }, o.rangeBand = function() {
                            return i;
                        }, o.rangeExtent = function() {
                            return Vn(e1.a[0]);
                        }, o.copy = function() {
                            return ii(t1, e1);
                        }, o.domain(t1);
                    }
                    a.scale.pow = function() {
                        return ri(a.scale.linear(), 1, [
                            0,
                            1
                        ]);
                    }, a.scale.sqrt = function() {
                        return a.scale.pow().exponent(.5);
                    }, a.scale.ordinal = function() {
                        return ii([], {
                            t: "range",
                            a: [
                                []
                            ]
                        });
                    }, a.scale.category10 = function() {
                        return a.scale.ordinal().range(ai);
                    }, a.scale.category20 = function() {
                        return a.scale.ordinal().range(oi);
                    }, a.scale.category20b = function() {
                        return a.scale.ordinal().range(si);
                    }, a.scale.category20c = function() {
                        return a.scale.ordinal().range(li);
                    };
                    var ai = [
                        2062260,
                        16744206,
                        2924588,
                        14034728,
                        9725885,
                        9197131,
                        14907330,
                        8355711,
                        12369186,
                        1556175
                    ].map(se), oi = [
                        2062260,
                        11454440,
                        16744206,
                        16759672,
                        2924588,
                        10018698,
                        14034728,
                        16750742,
                        9725885,
                        12955861,
                        9197131,
                        12885140,
                        14907330,
                        16234194,
                        8355711,
                        13092807,
                        12369186,
                        14408589,
                        1556175,
                        10410725
                    ].map(se), si = [
                        3750777,
                        5395619,
                        7040719,
                        10264286,
                        6519097,
                        9216594,
                        11915115,
                        13556636,
                        9202993,
                        12426809,
                        15186514,
                        15190932,
                        8666169,
                        11356490,
                        14049643,
                        15177372,
                        8077683,
                        10834324,
                        13528509,
                        14589654
                    ].map(se), li = [
                        3244733,
                        7057110,
                        10406625,
                        13032431,
                        15095053,
                        16616764,
                        16625259,
                        16634018,
                        3253076,
                        7652470,
                        10607003,
                        13101504,
                        7695281,
                        10394312,
                        12369372,
                        14342891,
                        6513507,
                        9868950,
                        12434877,
                        14277081
                    ].map(se);
                    function ci(t1, e1) {
                        var r;
                        function n() {
                            var n = 0, o = e1.length;
                            for(r = []; ++n < o;)r[n - 1] = a.quantile(t1, n / o);
                            return i;
                        }
                        function i(t1) {
                            if (!isNaN(t1 = +t1)) return e1[a.bisect(r, t1)];
                        }
                        return i.domain = function(e1) {
                            return arguments.length ? (t1 = e1.map(y).filter(v).sort(g), n()) : t1;
                        }, i.range = function(t1) {
                            return arguments.length ? (e1 = t1, n()) : e1;
                        }, i.quantiles = function() {
                            return r;
                        }, i.invertExtent = function(n) {
                            return (n = e1.indexOf(n)) < 0 ? [
                                NaN,
                                NaN
                            ] : [
                                n > 0 ? r[n - 1] : t1[0],
                                n < r.length ? r[n] : t1[t1.length - 1]
                            ];
                        }, i.copy = function() {
                            return ci(t1, e1);
                        }, n();
                    }
                    function ui(t1, e1, r) {
                        var n, i;
                        function a(e1) {
                            return r[Math.max(0, Math.min(i, Math.floor(n * (e1 - t1))))];
                        }
                        function o() {
                            return n = r.length / (e1 - t1), i = r.length - 1, a;
                        }
                        return a.domain = function(r) {
                            return arguments.length ? (t1 = +r[0], e1 = +r[r.length - 1], o()) : [
                                t1,
                                e1
                            ];
                        }, a.range = function(t1) {
                            return arguments.length ? (r = t1, o()) : r;
                        }, a.invertExtent = function(e1) {
                            return [
                                e1 = (e1 = r.indexOf(e1)) < 0 ? NaN : e1 / n + t1,
                                e1 + 1 / n
                            ];
                        }, a.copy = function() {
                            return ui(t1, e1, r);
                        }, o();
                    }
                    function hi(t1, e1) {
                        function r(r) {
                            if (r <= r) return e1[a.bisect(t1, r)];
                        }
                        return r.domain = function(e1) {
                            return arguments.length ? (t1 = e1, r) : t1;
                        }, r.range = function(t1) {
                            return arguments.length ? (e1 = t1, r) : e1;
                        }, r.invertExtent = function(r) {
                            return r = e1.indexOf(r), [
                                t1[r - 1],
                                t1[r]
                            ];
                        }, r.copy = function() {
                            return hi(t1, e1);
                        }, r;
                    }
                    function fi(t1) {
                        function e1(t1) {
                            return +t1;
                        }
                        return e1.invert = e1, e1.domain = e1.range = function(r) {
                            return arguments.length ? (t1 = r.map(e1), e1) : t1;
                        }, e1.ticks = function(e1) {
                            return Qn(t1, e1);
                        }, e1.tickFormat = function(e1, r) {
                            return d3_scale_linearTickFormat(t1, e1, r);
                        }, e1.copy = function() {
                            return fi(t1);
                        }, e1;
                    }
                    function pi() {
                        return 0;
                    }
                    a.scale.quantile = function() {
                        return ci([], []);
                    }, a.scale.quantize = function() {
                        return ui(0, 1, [
                            0,
                            1
                        ]);
                    }, a.scale.threshold = function() {
                        return hi([
                            .5
                        ], [
                            0,
                            1
                        ]);
                    }, a.scale.identity = function() {
                        return fi([
                            0,
                            1
                        ]);
                    }, a.svg = {}, a.svg.arc = function() {
                        var t1 = mi, e1 = gi, r = pi, n = di, i = yi, a = vi, o = xi;
                        function s() {
                            var s = Math.max(0, +t1.apply(this, arguments)), c = Math.max(0, +e1.apply(this, arguments)), u = i.apply(this, arguments) - zt, h = a.apply(this, arguments) - zt, f = Math.abs(h - u), p = u > h ? 0 : 1;
                            if (c < s && (d = c, c = s, s = d), f >= Pt) return l(c, p) + (s ? l(s, 1 - p) : "") + "Z";
                            var d, m, g, y, v, x, _, b, w, T, k, A, M = 0, S = 0, E = [];
                            if ((y = (+o.apply(this, arguments) || 0) / 2) && (g = n === di ? Math.sqrt(s * s + c * c) : +n.apply(this, arguments), p || (S *= -1), c && (S = Rt(g / c * Math.sin(y))), s && (M = Rt(g / s * Math.sin(y)))), c) {
                                v = c * Math.cos(u + S), x = c * Math.sin(u + S), _ = c * Math.cos(h - S), b = c * Math.sin(h - S);
                                var C = Math.abs(h - u - 2 * S) <= Lt ? 0 : 1;
                                if (S && _i(v, x, _, b) === p ^ C) {
                                    var L = (u + h) / 2;
                                    v = c * Math.cos(L), x = c * Math.sin(L), _ = b = null;
                                }
                            } else v = x = 0;
                            if (s) {
                                w = s * Math.cos(h - M), T = s * Math.sin(h - M), k = s * Math.cos(u + M), A = s * Math.sin(u + M);
                                var I = Math.abs(u - h + 2 * M) <= Lt ? 0 : 1;
                                if (M && _i(w, T, k, A) === 1 - p ^ I) {
                                    var P = (u + h) / 2;
                                    w = s * Math.cos(P), T = s * Math.sin(P), k = A = null;
                                }
                            } else w = T = 0;
                            if (f > Et && (d = Math.min(Math.abs(c - s) / 2, +r.apply(this, arguments))) > .001) {
                                m = s < c ^ p ? 0 : 1;
                                var z = d, O = d;
                                if (f < Lt) {
                                    var D = null == k ? [
                                        w,
                                        T
                                    ] : null == _ ? [
                                        v,
                                        x
                                    ] : Oe([
                                        v,
                                        x
                                    ], [
                                        k,
                                        A
                                    ], [
                                        _,
                                        b
                                    ], [
                                        w,
                                        T
                                    ]), R = v - D[0], F = x - D[1], B = _ - D[0], N = b - D[1], j = 1 / Math.sin(Math.acos((R * B + F * N) / (Math.sqrt(R * R + F * F) * Math.sqrt(B * B + N * N))) / 2), U = Math.sqrt(D[0] * D[0] + D[1] * D[1]);
                                    O = Math.min(d, (s - U) / (j - 1)), z = Math.min(d, (c - U) / (j + 1));
                                }
                                if (null != _) {
                                    var V = bi(null == k ? [
                                        w,
                                        T
                                    ] : [
                                        k,
                                        A
                                    ], [
                                        v,
                                        x
                                    ], c, z, p), q = bi([
                                        _,
                                        b
                                    ], [
                                        w,
                                        T
                                    ], c, z, p);
                                    d === z ? E.push("M", V[0], "A", z, ",", z, " 0 0,", m, " ", V[1], "A", c, ",", c, " 0 ", 1 - p ^ _i(V[1][0], V[1][1], q[1][0], q[1][1]), ",", p, " ", q[1], "A", z, ",", z, " 0 0,", m, " ", q[0]) : E.push("M", V[0], "A", z, ",", z, " 0 1,", m, " ", q[0]);
                                } else E.push("M", v, ",", x);
                                if (null != k) {
                                    var H = bi([
                                        v,
                                        x
                                    ], [
                                        k,
                                        A
                                    ], s, -O, p), G = bi([
                                        w,
                                        T
                                    ], null == _ ? [
                                        v,
                                        x
                                    ] : [
                                        _,
                                        b
                                    ], s, -O, p);
                                    d === O ? E.push("L", G[0], "A", O, ",", O, " 0 0,", m, " ", G[1], "A", s, ",", s, " 0 ", p ^ _i(G[1][0], G[1][1], H[1][0], H[1][1]), ",", 1 - p, " ", H[1], "A", O, ",", O, " 0 0,", m, " ", H[0]) : E.push("L", G[0], "A", O, ",", O, " 0 0,", m, " ", H[0]);
                                } else E.push("L", w, ",", T);
                            } else E.push("M", v, ",", x), null != _ && E.push("A", c, ",", c, " 0 ", C, ",", p, " ", _, ",", b), E.push("L", w, ",", T), null != k && E.push("A", s, ",", s, " 0 ", I, ",", 1 - p, " ", k, ",", A);
                            return E.push("Z"), E.join("");
                        }
                        function l(t1, e1) {
                            return "M0," + t1 + "A" + t1 + "," + t1 + " 0 1," + e1 + " 0," + -t1 + "A" + t1 + "," + t1 + " 0 1," + e1 + " 0," + t1;
                        }
                        return s.innerRadius = function(e1) {
                            return arguments.length ? (t1 = ge(e1), s) : t1;
                        }, s.outerRadius = function(t1) {
                            return arguments.length ? (e1 = ge(t1), s) : e1;
                        }, s.cornerRadius = function(t1) {
                            return arguments.length ? (r = ge(t1), s) : r;
                        }, s.padRadius = function(t1) {
                            return arguments.length ? (n = t1 == di ? di : ge(t1), s) : n;
                        }, s.startAngle = function(t1) {
                            return arguments.length ? (i = ge(t1), s) : i;
                        }, s.endAngle = function(t1) {
                            return arguments.length ? (a = ge(t1), s) : a;
                        }, s.padAngle = function(t1) {
                            return arguments.length ? (o = ge(t1), s) : o;
                        }, s.centroid = function() {
                            var r = (+t1.apply(this, arguments) + +e1.apply(this, arguments)) / 2, n = (+i.apply(this, arguments) + +a.apply(this, arguments)) / 2 - zt;
                            return [
                                Math.cos(n) * r,
                                Math.sin(n) * r
                            ];
                        }, s;
                    };
                    var di = "auto";
                    function mi(t1) {
                        return t1.innerRadius;
                    }
                    function gi(t1) {
                        return t1.outerRadius;
                    }
                    function yi(t1) {
                        return t1.startAngle;
                    }
                    function vi(t1) {
                        return t1.endAngle;
                    }
                    function xi(t1) {
                        return t1 && t1.padAngle;
                    }
                    function _i(t1, e1, r, n) {
                        return (t1 - r) * e1 - (e1 - n) * t1 > 0 ? 0 : 1;
                    }
                    function bi(t1, e1, r, n, i) {
                        var a = t1[0] - e1[0], o = t1[1] - e1[1], s = (i ? n : -n) / Math.sqrt(a * a + o * o), l = s * o, c = -s * a, u = t1[0] + l, h = t1[1] + c, f = e1[0] + l, p = e1[1] + c, d = (u + f) / 2, m = (h + p) / 2, g = f - u, y = p - h, v = g * g + y * y, x = r - n, _ = u * p - f * h, b = (y < 0 ? -1 : 1) * Math.sqrt(Math.max(0, x * x * v - _ * _)), w = (_ * y - g * b) / v, T = (-_ * g - y * b) / v, k = (_ * y + g * b) / v, A = (-_ * g + y * b) / v, M = w - d, S = T - m, E = k - d, C = A - m;
                        return M * M + S * S > E * E + C * C && (w = k, T = A), [
                            [
                                w - l,
                                T - c
                            ],
                            [
                                w * r / x,
                                T * r / x
                            ]
                        ];
                    }
                    function wi() {
                        return !0;
                    }
                    function Ti(t1) {
                        var e1 = Ee, r = Ce, n = wi, i = Ai, a = i.key, o = .7;
                        function s(a) {
                            var s, l = [], c = [], u = -1, h = a.length, f = ge(e1), p = ge(r);
                            function d() {
                                l.push("M", i(t1(c), o));
                            }
                            for(; ++u < h;)n.call(this, s = a[u], u) ? c.push([
                                +f.call(this, s, u),
                                +p.call(this, s, u)
                            ]) : c.length && (d(), c = []);
                            return c.length && d(), l.length ? l.join("") : null;
                        }
                        return s.x = function(t1) {
                            return arguments.length ? (e1 = t1, s) : e1;
                        }, s.y = function(t1) {
                            return arguments.length ? (r = t1, s) : r;
                        }, s.defined = function(t1) {
                            return arguments.length ? (n = t1, s) : n;
                        }, s.interpolate = function(t1) {
                            return arguments.length ? (a = "function" == typeof t1 ? i = t1 : (i = ki.get(t1) || Ai).key, s) : a;
                        }, s.tension = function(t1) {
                            return arguments.length ? (o = t1, s) : o;
                        }, s;
                    }
                    a.svg.line = function() {
                        return Ti(D);
                    };
                    var ki = a.map({
                        linear: Ai,
                        "linear-closed": Mi,
                        step: function(t1) {
                            for(var e1 = 0, r = t1.length, n = t1[0], i = [
                                n[0],
                                ",",
                                n[1]
                            ]; ++e1 < r;)i.push("H", (n[0] + (n = t1[e1])[0]) / 2, "V", n[1]);
                            return r > 1 && i.push("H", n[0]), i.join("");
                        },
                        "step-before": Si,
                        "step-after": Ei,
                        basis: Ii,
                        "basis-open": function(t1) {
                            if (t1.length < 4) return Ai(t1);
                            for(var e1, r = [], n = -1, i = t1.length, a = [
                                0
                            ], o = [
                                0
                            ]; ++n < 3;)e1 = t1[n], a.push(e1[0]), o.push(e1[1]);
                            for(r.push(Pi(Di, a) + "," + Pi(Di, o)), --n; ++n < i;)e1 = t1[n], a.shift(), a.push(e1[0]), o.shift(), o.push(e1[1]), Ri(r, a, o);
                            return r.join("");
                        },
                        "basis-closed": function(t1) {
                            for(var e1, r, n = -1, i = t1.length, a = i + 4, o = [], s = []; ++n < 4;)r = t1[n % i], o.push(r[0]), s.push(r[1]);
                            for(e1 = [
                                Pi(Di, o),
                                ",",
                                Pi(Di, s)
                            ], --n; ++n < a;)r = t1[n % i], o.shift(), o.push(r[0]), s.shift(), s.push(r[1]), Ri(e1, o, s);
                            return e1.join("");
                        },
                        bundle: function(t1, e1) {
                            var r = t1.length - 1;
                            if (r) for(var n, i, a = t1[0][0], o = t1[0][1], s = t1[r][0] - a, l = t1[r][1] - o, c = -1; ++c <= r;)i = c / r, (n = t1[c])[0] = e1 * n[0] + (1 - e1) * (a + i * s), n[1] = e1 * n[1] + (1 - e1) * (o + i * l);
                            return Ii(t1);
                        },
                        cardinal: function(t1, e1) {
                            return t1.length < 3 ? Ai(t1) : t1[0] + Ci(t1, Li(t1, e1));
                        },
                        "cardinal-open": function(t1, e1) {
                            return t1.length < 4 ? Ai(t1) : t1[1] + Ci(t1.slice(1, -1), Li(t1, e1));
                        },
                        "cardinal-closed": function(t1, e1) {
                            return t1.length < 3 ? Mi(t1) : t1[0] + Ci((t1.push(t1[0]), t1), Li([
                                t1[t1.length - 2]
                            ].concat(t1, [
                                t1[1]
                            ]), e1));
                        },
                        monotone: function(t1) {
                            return t1.length < 3 ? Ai(t1) : t1[0] + Ci(t1, function(t1) {
                                for(var e1, r, n, i, a = [], o = function(t1) {
                                    for(var e1 = 0, r = t1.length - 1, n = [], i = t1[0], a = t1[1], o = n[0] = Fi(i, a); ++e1 < r;)n[e1] = (o + (o = Fi(i = a, a = t1[e1 + 1]))) / 2;
                                    return n[e1] = o, n;
                                }(t1), s = -1, l = t1.length - 1; ++s < l;)e1 = Fi(t1[s], t1[s + 1]), w(e1) < Et ? o[s] = o[s + 1] = 0 : (i = (r = o[s] / e1) * r + (n = o[s + 1] / e1) * n) > 9 && (i = 3 * e1 / Math.sqrt(i), o[s] = i * r, o[s + 1] = i * n);
                                for(s = -1; ++s <= l;)i = (t1[Math.min(l, s + 1)][0] - t1[Math.max(0, s - 1)][0]) / (6 * (1 + o[s] * o[s])), a.push([
                                    i || 0,
                                    o[s] * i || 0
                                ]);
                                return a;
                            }(t1));
                        }
                    });
                    function Ai(t1) {
                        return t1.length > 1 ? t1.join("L") : t1 + "Z";
                    }
                    function Mi(t1) {
                        return t1.join("L") + "Z";
                    }
                    function Si(t1) {
                        for(var e1 = 0, r = t1.length, n = t1[0], i = [
                            n[0],
                            ",",
                            n[1]
                        ]; ++e1 < r;)i.push("V", (n = t1[e1])[1], "H", n[0]);
                        return i.join("");
                    }
                    function Ei(t1) {
                        for(var e1 = 0, r = t1.length, n = t1[0], i = [
                            n[0],
                            ",",
                            n[1]
                        ]; ++e1 < r;)i.push("H", (n = t1[e1])[0], "V", n[1]);
                        return i.join("");
                    }
                    function Ci(t1, e1) {
                        if (e1.length < 1 || t1.length != e1.length && t1.length != e1.length + 2) return Ai(t1);
                        var r = t1.length != e1.length, n = "", i = t1[0], a = t1[1], o = e1[0], s = o, l = 1;
                        if (r && (n += "Q" + (a[0] - 2 * o[0] / 3) + "," + (a[1] - 2 * o[1] / 3) + "," + a[0] + "," + a[1], i = t1[1], l = 2), e1.length > 1) {
                            s = e1[1], a = t1[l], l++, n += "C" + (i[0] + o[0]) + "," + (i[1] + o[1]) + "," + (a[0] - s[0]) + "," + (a[1] - s[1]) + "," + a[0] + "," + a[1];
                            for(var c = 2; c < e1.length; c++, l++)a = t1[l], s = e1[c], n += "S" + (a[0] - s[0]) + "," + (a[1] - s[1]) + "," + a[0] + "," + a[1];
                        }
                        if (r) {
                            var u = t1[l];
                            n += "Q" + (a[0] + 2 * s[0] / 3) + "," + (a[1] + 2 * s[1] / 3) + "," + u[0] + "," + u[1];
                        }
                        return n;
                    }
                    function Li(t1, e1) {
                        for(var r, n = [], i = (1 - e1) / 2, a = t1[0], o = t1[1], s = 1, l = t1.length; ++s < l;)r = a, a = o, o = t1[s], n.push([
                            i * (o[0] - r[0]),
                            i * (o[1] - r[1])
                        ]);
                        return n;
                    }
                    function Ii(t1) {
                        if (t1.length < 3) return Ai(t1);
                        var e1 = 1, r = t1.length, n = t1[0], i = n[0], a = n[1], o = [
                            i,
                            i,
                            i,
                            (n = t1[1])[0]
                        ], s = [
                            a,
                            a,
                            a,
                            n[1]
                        ], l = [
                            i,
                            ",",
                            a,
                            "L",
                            Pi(Di, o),
                            ",",
                            Pi(Di, s)
                        ];
                        for(t1.push(t1[r - 1]); ++e1 <= r;)n = t1[e1], o.shift(), o.push(n[0]), s.shift(), s.push(n[1]), Ri(l, o, s);
                        return t1.pop(), l.push("L", n), l.join("");
                    }
                    function Pi(t1, e1) {
                        return t1[0] * e1[0] + t1[1] * e1[1] + t1[2] * e1[2] + t1[3] * e1[3];
                    }
                    ki.forEach(function(t1, e1) {
                        e1.key = t1, e1.closed = /-closed$/.test(t1);
                    });
                    var zi = [
                        0,
                        2 / 3,
                        1 / 3,
                        0
                    ], Oi = [
                        0,
                        1 / 3,
                        2 / 3,
                        0
                    ], Di = [
                        0,
                        1 / 6,
                        2 / 3,
                        1 / 6
                    ];
                    function Ri(t1, e1, r) {
                        t1.push("C", Pi(zi, e1), ",", Pi(zi, r), ",", Pi(Oi, e1), ",", Pi(Oi, r), ",", Pi(Di, e1), ",", Pi(Di, r));
                    }
                    function Fi(t1, e1) {
                        return (e1[1] - t1[1]) / (e1[0] - t1[0]);
                    }
                    function Bi(t1) {
                        for(var e1, r, n, i = -1, a = t1.length; ++i < a;)r = (e1 = t1[i])[0], n = e1[1] - zt, e1[0] = r * Math.cos(n), e1[1] = r * Math.sin(n);
                        return t1;
                    }
                    function Ni(t1) {
                        var e1 = Ee, r = Ee, n = 0, i = Ce, a = wi, o = Ai, s = o.key, l = o, c = "L", u = .7;
                        function h(s) {
                            var h, f, p, d = [], m = [], g = [], y = -1, v = s.length, x = ge(e1), _ = ge(n), b = e1 === r ? function() {
                                return f;
                            } : ge(r), w = n === i ? function() {
                                return p;
                            } : ge(i);
                            function T() {
                                d.push("M", o(t1(g), u), c, l(t1(m.reverse()), u), "Z");
                            }
                            for(; ++y < v;)a.call(this, h = s[y], y) ? (m.push([
                                f = +x.call(this, h, y),
                                p = +_.call(this, h, y)
                            ]), g.push([
                                +b.call(this, h, y),
                                +w.call(this, h, y)
                            ])) : m.length && (T(), m = [], g = []);
                            return m.length && T(), d.length ? d.join("") : null;
                        }
                        return h.x = function(t1) {
                            return arguments.length ? (e1 = r = t1, h) : r;
                        }, h.x0 = function(t1) {
                            return arguments.length ? (e1 = t1, h) : e1;
                        }, h.x1 = function(t1) {
                            return arguments.length ? (r = t1, h) : r;
                        }, h.y = function(t1) {
                            return arguments.length ? (n = i = t1, h) : i;
                        }, h.y0 = function(t1) {
                            return arguments.length ? (n = t1, h) : n;
                        }, h.y1 = function(t1) {
                            return arguments.length ? (i = t1, h) : i;
                        }, h.defined = function(t1) {
                            return arguments.length ? (a = t1, h) : a;
                        }, h.interpolate = function(t1) {
                            return arguments.length ? (s = "function" == typeof t1 ? o = t1 : (o = ki.get(t1) || Ai).key, l = o.reverse || o, c = o.closed ? "M" : "L", h) : s;
                        }, h.tension = function(t1) {
                            return arguments.length ? (u = t1, h) : u;
                        }, h;
                    }
                    function ji(t1) {
                        return t1.source;
                    }
                    function Ui(t1) {
                        return t1.target;
                    }
                    function Vi(t1) {
                        return t1.radius;
                    }
                    function qi(t1) {
                        return [
                            t1.x,
                            t1.y
                        ];
                    }
                    function Hi() {
                        return 64;
                    }
                    function Gi() {
                        return "circle";
                    }
                    function Zi(t1) {
                        var e1 = Math.sqrt(t1 / Lt);
                        return "M0," + e1 + "A" + e1 + "," + e1 + " 0 1,1 0," + -e1 + "A" + e1 + "," + e1 + " 0 1,1 0," + e1 + "Z";
                    }
                    a.svg.line.radial = function() {
                        var t1 = Ti(Bi);
                        return t1.radius = t1.x, delete t1.x, t1.angle = t1.y, delete t1.y, t1;
                    }, Si.reverse = Ei, Ei.reverse = Si, a.svg.area = function() {
                        return Ni(D);
                    }, a.svg.area.radial = function() {
                        var t1 = Ni(Bi);
                        return t1.radius = t1.x, delete t1.x, t1.innerRadius = t1.x0, delete t1.x0, t1.outerRadius = t1.x1, delete t1.x1, t1.angle = t1.y, delete t1.y, t1.startAngle = t1.y0, delete t1.y0, t1.endAngle = t1.y1, delete t1.y1, t1;
                    }, a.svg.chord = function() {
                        var t1 = ji, e1 = Ui, r = Vi, n = yi, i = vi;
                        function a(r, n) {
                            var i, a, c = o(this, t1, r, n), u = o(this, e1, r, n);
                            return "M" + c.p0 + s(c.r, c.p1, c.a1 - c.a0) + (a = u, ((i = c).a0 == a.a0 && i.a1 == a.a1 ? l(c.r, c.p1, c.r, c.p0) : l(c.r, c.p1, u.r, u.p0) + s(u.r, u.p1, u.a1 - u.a0) + l(u.r, u.p1, c.r, c.p0)) + "Z");
                        }
                        function o(t1, e1, a, o) {
                            var s = e1.call(t1, a, o), l = r.call(t1, s, o), c = n.call(t1, s, o) - zt, u = i.call(t1, s, o) - zt;
                            return {
                                r: l,
                                a0: c,
                                a1: u,
                                p0: [
                                    l * Math.cos(c),
                                    l * Math.sin(c)
                                ],
                                p1: [
                                    l * Math.cos(u),
                                    l * Math.sin(u)
                                ]
                            };
                        }
                        function s(t1, e1, r) {
                            return "A" + t1 + "," + t1 + " 0 " + +(r > Lt) + ",1 " + e1;
                        }
                        function l(t1, e1, r, n) {
                            return "Q 0,0 " + n;
                        }
                        return a.radius = function(t1) {
                            return arguments.length ? (r = ge(t1), a) : r;
                        }, a.source = function(e1) {
                            return arguments.length ? (t1 = ge(e1), a) : t1;
                        }, a.target = function(t1) {
                            return arguments.length ? (e1 = ge(t1), a) : e1;
                        }, a.startAngle = function(t1) {
                            return arguments.length ? (n = ge(t1), a) : n;
                        }, a.endAngle = function(t1) {
                            return arguments.length ? (i = ge(t1), a) : i;
                        }, a;
                    }, a.svg.diagonal = function() {
                        var t1 = ji, e1 = Ui, r = qi;
                        function n(n, i) {
                            var a = t1.call(this, n, i), o = e1.call(this, n, i), s = (a.y + o.y) / 2, l = [
                                a,
                                {
                                    x: a.x,
                                    y: s
                                },
                                {
                                    x: o.x,
                                    y: s
                                },
                                o
                            ];
                            return "M" + (l = l.map(r))[0] + "C" + l[1] + " " + l[2] + " " + l[3];
                        }
                        return n.source = function(e1) {
                            return arguments.length ? (t1 = ge(e1), n) : t1;
                        }, n.target = function(t1) {
                            return arguments.length ? (e1 = ge(t1), n) : e1;
                        }, n.projection = function(t1) {
                            return arguments.length ? (r = t1, n) : r;
                        }, n;
                    }, a.svg.diagonal.radial = function() {
                        var t1 = a.svg.diagonal(), e1 = qi, r = t1.projection;
                        return t1.projection = function(t1) {
                            return arguments.length ? r(function(t1) {
                                return function() {
                                    var e1 = t1.apply(this, arguments), r = e1[0], n = e1[1] - zt;
                                    return [
                                        r * Math.cos(n),
                                        r * Math.sin(n)
                                    ];
                                };
                            }(e1 = t1)) : e1;
                        }, t1;
                    }, a.svg.symbol = function() {
                        var t1 = Gi, e1 = Hi;
                        function r(r, n) {
                            return (Wi.get(t1.call(this, r, n)) || Zi)(e1.call(this, r, n));
                        }
                        return r.type = function(e1) {
                            return arguments.length ? (t1 = ge(e1), r) : t1;
                        }, r.size = function(t1) {
                            return arguments.length ? (e1 = ge(t1), r) : e1;
                        }, r;
                    };
                    var Wi = a.map({
                        circle: Zi,
                        cross: function(t1) {
                            var e1 = Math.sqrt(t1 / 5) / 2;
                            return "M" + -3 * e1 + "," + -e1 + "H" + -e1 + "V" + -3 * e1 + "H" + e1 + "V" + -e1 + "H" + 3 * e1 + "V" + e1 + "H" + e1 + "V" + 3 * e1 + "H" + -e1 + "V" + e1 + "H" + -3 * e1 + "Z";
                        },
                        diamond: function(t1) {
                            var e1 = Math.sqrt(t1 / (2 * Xi)), r = e1 * Xi;
                            return "M0," + -e1 + "L" + r + ",0 0," + e1 + " " + -r + ",0Z";
                        },
                        square: function(t1) {
                            var e1 = Math.sqrt(t1) / 2;
                            return "M" + -e1 + "," + -e1 + "L" + e1 + "," + -e1 + " " + e1 + "," + e1 + " " + -e1 + "," + e1 + "Z";
                        },
                        "triangle-down": function(t1) {
                            var e1 = Math.sqrt(t1 / Yi), r = e1 * Yi / 2;
                            return "M0," + r + "L" + e1 + "," + -r + " " + -e1 + "," + -r + "Z";
                        },
                        "triangle-up": function(t1) {
                            var e1 = Math.sqrt(t1 / Yi), r = e1 * Yi / 2;
                            return "M0," + -r + "L" + e1 + "," + r + " " + -e1 + "," + r + "Z";
                        }
                    });
                    a.svg.symbolTypes = Wi.keys();
                    var Yi = Math.sqrt(3), Xi = Math.tan(30 * Ot);
                    J.transition = function(t1) {
                        for(var e1, r, n = Qi || ++ra, i = aa(t1), a = [], o = ta || {
                            time: Date.now(),
                            ease: Pr,
                            delay: 0,
                            duration: 250
                        }, s = -1, l = this.length; ++s < l;){
                            a.push(e1 = []);
                            for(var c = this[s], u = -1, h = c.length; ++u < h;)(r = c[u]) && oa(r, u, i, n, o), e1.push(r);
                        }
                        return Ki(a, i, n);
                    }, J.interrupt = function(t1) {
                        return this.each(null == t1 ? $i : Ji(aa(t1)));
                    };
                    var $i = Ji(aa());
                    function Ji(t1) {
                        return function() {
                            var e1, r, n;
                            (e1 = this[t1]) && (n = e1[r = e1.active]) && (n.timer.c = null, n.timer.t = NaN, --e1.count ? delete e1[r] : delete this[t1], e1.active += .5, n.event && n.event.interrupt.call(this, this.__data__, n.index));
                        };
                    }
                    function Ki(t1, e1, r) {
                        return Z(t1, ea), t1.namespace = e1, t1.id = r, t1;
                    }
                    var Qi, ta, ea = [], ra = 0;
                    function na(t1, e1, r, n) {
                        var i = t1.id, a = t1.namespace;
                        return mt(t1, "function" == typeof r ? function(t1, o, s) {
                            t1[a][i].tween.set(e1, n(r.call(t1, t1.__data__, o, s)));
                        } : (r = n(r), function(t1) {
                            t1[a][i].tween.set(e1, r);
                        }));
                    }
                    function ia(t1) {
                        return null == t1 && (t1 = ""), function() {
                            this.textContent = t1;
                        };
                    }
                    function aa(t1) {
                        return null == t1 ? "__transition__" : "__transition_" + t1 + "__";
                    }
                    function oa(t1, e1, r, n, i) {
                        var a, o, s, l, c, u = t1[r] || (t1[r] = {
                            active: 0,
                            count: 0
                        }), h = u[n];
                        function f(r) {
                            var i = u.active, f = u[i];
                            for(var d in f && (f.timer.c = null, f.timer.t = NaN, --u.count, delete u[i], f.event && f.event.interrupt.call(t1, t1.__data__, f.index)), u)if (+d < n) {
                                var m = u[d];
                                m.timer.c = null, m.timer.t = NaN, --u.count, delete u[d];
                            }
                            o.c = p, ke(function() {
                                return o.c && p(r || 1) && (o.c = null, o.t = NaN), 1;
                            }, 0, a), u.active = n, h.event && h.event.start.call(t1, t1.__data__, e1), c = [], h.tween.forEach(function(r, n) {
                                (n = n.call(t1, t1.__data__, e1)) && c.push(n);
                            }), l = h.ease, s = h.duration;
                        }
                        function p(i) {
                            for(var a = i / s, o = l(a), f = c.length; f > 0;)c[--f].call(t1, o);
                            if (a >= 1) return h.event && h.event.end.call(t1, t1.__data__, e1), --u.count ? delete u[n] : delete t1[r], 1;
                        }
                        h || (a = i.time, o = ke(function(t1) {
                            var e1 = h.delay;
                            if (o.t = e1 + a, e1 <= t1) return f(t1 - e1);
                            o.c = f;
                        }, 0, a), h = u[n] = {
                            tween: new k,
                            time: a,
                            timer: o,
                            delay: i.delay,
                            duration: i.duration,
                            ease: i.ease,
                            index: e1
                        }, i = null, ++u.count);
                    }
                    ea.call = J.call, ea.empty = J.empty, ea.node = J.node, ea.size = J.size, a.transition = function(t1, e1) {
                        return t1 && t1.transition ? Qi ? t1.transition(e1) : t1 : a.selection().transition(t1);
                    }, a.transition.prototype = ea, ea.select = function(t1) {
                        var e1, r, n, i = this.id, a = this.namespace, o = [];
                        t1 = K(t1);
                        for(var s = -1, l = this.length; ++s < l;){
                            o.push(e1 = []);
                            for(var c = this[s], u = -1, h = c.length; ++u < h;)(n = c[u]) && (r = t1.call(n, n.__data__, u, s)) ? ("__data__" in n && (r.__data__ = n.__data__), oa(r, u, a, i, n[a][i]), e1.push(r)) : e1.push(null);
                        }
                        return Ki(o, a, i);
                    }, ea.selectAll = function(t1) {
                        var e1, r, n, i, a, o = this.id, s = this.namespace, l = [];
                        t1 = Q(t1);
                        for(var c = -1, u = this.length; ++c < u;)for(var h = this[c], f = -1, p = h.length; ++f < p;)if (n = h[f]) {
                            a = n[s][o], r = t1.call(n, n.__data__, f, c), l.push(e1 = []);
                            for(var d = -1, m = r.length; ++d < m;)(i = r[d]) && oa(i, d, s, o, a), e1.push(i);
                        }
                        return Ki(l, s, o);
                    }, ea.filter = function(t1) {
                        var e1, r, n = [];
                        "function" != typeof t1 && (t1 = pt(t1));
                        for(var i = 0, a = this.length; i < a; i++){
                            n.push(e1 = []);
                            for(var o, s = 0, l = (o = this[i]).length; s < l; s++)(r = o[s]) && t1.call(r, r.__data__, s, i) && e1.push(r);
                        }
                        return Ki(n, this.namespace, this.id);
                    }, ea.tween = function(t1, e1) {
                        var r = this.id, n = this.namespace;
                        return arguments.length < 2 ? this.node()[n][r].tween.get(t1) : mt(this, null == e1 ? function(e1) {
                            e1[n][r].tween.remove(t1);
                        } : function(i) {
                            i[n][r].tween.set(t1, e1);
                        });
                    }, ea.attr = function(t1, e1) {
                        if (arguments.length < 2) {
                            for(e1 in t1)this.attr(e1, t1[e1]);
                            return this;
                        }
                        var r = "transform" == t1 ? qr : Tr, n = a.ns.qualify(t1);
                        function i() {
                            this.removeAttribute(n);
                        }
                        function o() {
                            this.removeAttributeNS(n.space, n.local);
                        }
                        return na(this, "attr." + t1, e1, n.local ? function(t1) {
                            return null == t1 ? o : (t1 += "", function() {
                                var e1, i = this.getAttributeNS(n.space, n.local);
                                return i !== t1 && (e1 = r(i, t1), function(t1) {
                                    this.setAttributeNS(n.space, n.local, e1(t1));
                                });
                            });
                        } : function(t1) {
                            return null == t1 ? i : (t1 += "", function() {
                                var e1, i = this.getAttribute(n);
                                return i !== t1 && (e1 = r(i, t1), function(t1) {
                                    this.setAttribute(n, e1(t1));
                                });
                            });
                        });
                    }, ea.attrTween = function(t1, e1) {
                        var r = a.ns.qualify(t1);
                        return this.tween("attr." + t1, r.local ? function(t1, n) {
                            var i = e1.call(this, t1, n, this.getAttributeNS(r.space, r.local));
                            return i && function(t1) {
                                this.setAttributeNS(r.space, r.local, i(t1));
                            };
                        } : function(t1, n) {
                            var i = e1.call(this, t1, n, this.getAttribute(r));
                            return i && function(t1) {
                                this.setAttribute(r, i(t1));
                            };
                        });
                    }, ea.style = function(t1, e1, r) {
                        var n = arguments.length;
                        if (n < 3) {
                            if ("string" != typeof t1) {
                                for(r in n < 2 && (e1 = ""), t1)this.style(r, t1[r], e1);
                                return this;
                            }
                            r = "";
                        }
                        function i() {
                            this.style.removeProperty(t1);
                        }
                        return na(this, "style." + t1, e1, function(e1) {
                            return null == e1 ? i : (e1 += "", function() {
                                var n, i = u(this).getComputedStyle(this, null).getPropertyValue(t1);
                                return i !== e1 && (n = Tr(i, e1), function(e1) {
                                    this.style.setProperty(t1, n(e1), r);
                                });
                            });
                        });
                    }, ea.styleTween = function(t1, e1, r) {
                        return arguments.length < 3 && (r = ""), this.tween("style." + t1, function(n, i) {
                            var a = e1.call(this, n, i, u(this).getComputedStyle(this, null).getPropertyValue(t1));
                            return a && function(e1) {
                                this.style.setProperty(t1, a(e1), r);
                            };
                        });
                    }, ea.text = function(t1) {
                        return na(this, "text", t1, ia);
                    }, ea.remove = function() {
                        var t1 = this.namespace;
                        return this.each("end.transition", function() {
                            var e1;
                            this[t1].count < 2 && (e1 = this.parentNode) && e1.removeChild(this);
                        });
                    }, ea.ease = function(t1) {
                        var e1 = this.id, r = this.namespace;
                        return arguments.length < 1 ? this.node()[r][e1].ease : ("function" != typeof t1 && (t1 = a.ease.apply(a, arguments)), mt(this, function(n) {
                            n[r][e1].ease = t1;
                        }));
                    }, ea.delay = function(t1) {
                        var e1 = this.id, r = this.namespace;
                        return arguments.length < 1 ? this.node()[r][e1].delay : mt(this, "function" == typeof t1 ? function(n, i, a) {
                            n[r][e1].delay = +t1.call(n, n.__data__, i, a);
                        } : (t1 = +t1, function(n) {
                            n[r][e1].delay = t1;
                        }));
                    }, ea.duration = function(t1) {
                        var e1 = this.id, r = this.namespace;
                        return arguments.length < 1 ? this.node()[r][e1].duration : mt(this, "function" == typeof t1 ? function(n, i, a) {
                            n[r][e1].duration = Math.max(1, t1.call(n, n.__data__, i, a));
                        } : (t1 = Math.max(1, t1), function(n) {
                            n[r][e1].duration = t1;
                        }));
                    }, ea.each = function(t1, e1) {
                        var r = this.id, n = this.namespace;
                        if (arguments.length < 2) {
                            var i = ta, o = Qi;
                            try {
                                Qi = r, mt(this, function(e1, i, a) {
                                    ta = e1[n][r], t1.call(e1, e1.__data__, i, a);
                                });
                            } finally{
                                ta = i, Qi = o;
                            }
                        } else mt(this, function(i) {
                            var o = i[n][r];
                            (o.event || (o.event = a.dispatch("start", "end", "interrupt"))).on(t1, e1);
                        });
                        return this;
                    }, ea.transition = function() {
                        for(var t1, e1, r, n = this.id, i = ++ra, a = this.namespace, o = [], s = 0, l = this.length; s < l; s++){
                            o.push(t1 = []);
                            for(var c, u = 0, h = (c = this[s]).length; u < h; u++)(e1 = c[u]) && oa(e1, u, a, i, {
                                time: (r = e1[a][n]).time,
                                ease: r.ease,
                                delay: r.delay + r.duration,
                                duration: r.duration
                            }), t1.push(e1);
                        }
                        return Ki(o, a, i);
                    }, a.svg.axis = function() {
                        var t1, e1 = a.scale.linear(), r = sa, n = 6, i = 6, o = 3, l = [
                            10
                        ], c = null;
                        function u(s) {
                            s.each(function() {
                                var s, u = a.select(this), h = this.__chart__ || e1, f = this.__chart__ = e1.copy(), p = null == c ? f.ticks ? f.ticks.apply(f, l) : f.domain() : c, d = null == t1 ? f.tickFormat ? f.tickFormat.apply(f, l) : D : t1, m = u.selectAll(".tick").data(p, f), g = m.enter().insert("g", ".domain").attr("class", "tick").style("opacity", Et), y = a.transition(m.exit()).style("opacity", Et).remove(), v = a.transition(m.order()).style("opacity", 1), x = Math.max(n, 0) + o, _ = qn(f), b = u.selectAll(".domain").data([
                                    0
                                ]), w = (b.enter().append("path").attr("class", "domain"), a.transition(b));
                                g.append("line"), g.append("text");
                                var T, k, A, M, S = g.select("line"), E = v.select("line"), C = m.select("text").text(d), L = g.select("text"), I = v.select("text"), P = "top" === r || "left" === r ? -1 : 1;
                                if ("bottom" === r || "top" === r ? (s = ca, T = "x", A = "y", k = "x2", M = "y2", C.attr("dy", P < 0 ? "0em" : ".71em").style("text-anchor", "middle"), w.attr("d", "M" + _[0] + "," + P * i + "V0H" + _[1] + "V" + P * i)) : (s = ua, T = "y", A = "x", k = "y2", M = "x2", C.attr("dy", ".32em").style("text-anchor", P < 0 ? "end" : "start"), w.attr("d", "M" + P * i + "," + _[0] + "H0V" + _[1] + "H" + P * i)), S.attr(M, P * n), L.attr(A, P * x), E.attr(k, 0).attr(M, P * n), I.attr(T, 0).attr(A, P * x), f.rangeBand) {
                                    var z = f, O = z.rangeBand() / 2;
                                    h = f = function(t1) {
                                        return z(t1) + O;
                                    };
                                } else h.rangeBand ? h = f : y.call(s, f, h);
                                g.call(s, h, f), v.call(s, f, f);
                            });
                        }
                        return u.scale = function(t1) {
                            return arguments.length ? (e1 = t1, u) : e1;
                        }, u.orient = function(t1) {
                            return arguments.length ? (r = t1 in la ? t1 + "" : sa, u) : r;
                        }, u.ticks = function() {
                            return arguments.length ? (l = s(arguments), u) : l;
                        }, u.tickValues = function(t1) {
                            return arguments.length ? (c = t1, u) : c;
                        }, u.tickFormat = function(e1) {
                            return arguments.length ? (t1 = e1, u) : t1;
                        }, u.tickSize = function(t1) {
                            var e1 = arguments.length;
                            return e1 ? (n = +t1, i = +arguments[e1 - 1], u) : n;
                        }, u.innerTickSize = function(t1) {
                            return arguments.length ? (n = +t1, u) : n;
                        }, u.outerTickSize = function(t1) {
                            return arguments.length ? (i = +t1, u) : i;
                        }, u.tickPadding = function(t1) {
                            return arguments.length ? (o = +t1, u) : o;
                        }, u.tickSubdivide = function() {
                            return arguments.length && u;
                        }, u;
                    };
                    var sa = "bottom", la = {
                        top: 1,
                        right: 1,
                        bottom: 1,
                        left: 1
                    };
                    function ca(t1, e1, r) {
                        t1.attr("transform", function(t1) {
                            var n = e1(t1);
                            return "translate(" + (isFinite(n) ? n : r(t1)) + ",0)";
                        });
                    }
                    function ua(t1, e1, r) {
                        t1.attr("transform", function(t1) {
                            var n = e1(t1);
                            return "translate(0," + (isFinite(n) ? n : r(t1)) + ")";
                        });
                    }
                    a.svg.brush = function() {
                        var t1, e1, r = H(f, "brushstart", "brush", "brushend"), n = null, i = null, o = [
                            0,
                            0
                        ], s = [
                            0,
                            0
                        ], l = !0, c = !0, h = fa[0];
                        function f(t1) {
                            t1.each(function() {
                                var t1 = a.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", g).on("touchstart.brush", g), e1 = t1.selectAll(".background").data([
                                    0
                                ]);
                                e1.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair"), t1.selectAll(".extent").data([
                                    0
                                ]).enter().append("rect").attr("class", "extent").style("cursor", "move");
                                var r = t1.selectAll(".resize").data(h, D);
                                r.exit().remove(), r.enter().append("g").attr("class", function(t1) {
                                    return "resize " + t1;
                                }).style("cursor", function(t1) {
                                    return ha[t1];
                                }).append("rect").attr("x", function(t1) {
                                    return /[ew]$/.test(t1) ? -3 : null;
                                }).attr("y", function(t1) {
                                    return /^[ns]/.test(t1) ? -3 : null;
                                }).attr("width", 6).attr("height", 6).style("visibility", "hidden"), r.style("display", f.empty() ? "none" : null);
                                var o, s = a.transition(t1), l = a.transition(e1);
                                n && (o = qn(n), l.attr("x", o[0]).attr("width", o[1] - o[0]), d(s)), i && (o = qn(i), l.attr("y", o[0]).attr("height", o[1] - o[0]), m(s)), p(s);
                            });
                        }
                        function p(t1) {
                            t1.selectAll(".resize").attr("transform", function(t1) {
                                return "translate(" + o[+/e$/.test(t1)] + "," + s[+/^s/.test(t1)] + ")";
                            });
                        }
                        function d(t1) {
                            t1.select(".extent").attr("x", o[0]), t1.selectAll(".extent,.n>rect,.s>rect").attr("width", o[1] - o[0]);
                        }
                        function m(t1) {
                            t1.select(".extent").attr("y", s[0]), t1.selectAll(".extent,.e>rect,.w>rect").attr("height", s[1] - s[0]);
                        }
                        function g() {
                            var h, g, y = this, v = a.select(a.event.target), x = r.of(y, arguments), _ = a.select(y), b = v.datum(), w = !/^(n|s)$/.test(b) && n, T = !/^(e|w)$/.test(b) && i, k = v.classed("extent"), A = kt(y), M = a.mouse(y), S = a.select(u(y)).on("keydown.brush", function() {
                                32 == a.event.keyCode && (k || (h = null, M[0] -= o[1], M[1] -= s[1], k = 2), V());
                            }).on("keyup.brush", function() {
                                32 == a.event.keyCode && 2 == k && (M[0] += o[1], M[1] += s[1], k = 0, V());
                            });
                            if (a.event.changedTouches ? S.on("touchmove.brush", L).on("touchend.brush", P) : S.on("mousemove.brush", L).on("mouseup.brush", P), _.interrupt().selectAll("*").interrupt(), k) M[0] = o[0] - M[0], M[1] = s[0] - M[1];
                            else if (b) {
                                var E = +/w$/.test(b), C = +/^n/.test(b);
                                g = [
                                    o[1 - E] - M[0],
                                    s[1 - C] - M[1]
                                ], M[0] = o[E], M[1] = s[C];
                            } else a.event.altKey && (h = M.slice());
                            function L() {
                                var t1 = a.mouse(y), e1 = !1;
                                g && (t1[0] += g[0], t1[1] += g[1]), k || (a.event.altKey ? (h || (h = [
                                    (o[0] + o[1]) / 2,
                                    (s[0] + s[1]) / 2
                                ]), M[0] = o[+(t1[0] < h[0])], M[1] = s[+(t1[1] < h[1])]) : h = null), w && I(t1, n, 0) && (d(_), e1 = !0), T && I(t1, i, 1) && (m(_), e1 = !0), e1 && (p(_), x({
                                    type: "brush",
                                    mode: k ? "move" : "resize"
                                }));
                            }
                            function I(r, n, i) {
                                var a, u, f = qn(n), p = f[0], d = f[1], m = M[i], g = i ? s : o, y = g[1] - g[0];
                                if (k && (p -= m, d -= y + m), a = (i ? c : l) ? Math.max(p, Math.min(d, r[i])) : r[i], k ? u = (a += m) + y : (h && (m = Math.max(p, Math.min(d, 2 * h[i] - a))), m < a ? (u = a, a = m) : u = m), g[0] != a || g[1] != u) return i ? e1 = null : t1 = null, g[0] = a, g[1] = u, !0;
                            }
                            function P() {
                                L(), _.style("pointer-events", "all").selectAll(".resize").style("display", f.empty() ? "none" : null), a.select("body").style("cursor", null), S.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null), A(), x({
                                    type: "brushend"
                                });
                            }
                            _.style("pointer-events", "none").selectAll(".resize").style("display", null), a.select("body").style("cursor", v.style("cursor")), x({
                                type: "brushstart"
                            }), L();
                        }
                        return f.event = function(n) {
                            n.each(function() {
                                var n = r.of(this, arguments), i = {
                                    x: o,
                                    y: s,
                                    i: t1,
                                    j: e1
                                }, l = this.__chart__ || i;
                                this.__chart__ = i, Qi ? a.select(this).transition().each("start.brush", function() {
                                    t1 = l.i, e1 = l.j, o = l.x, s = l.y, n({
                                        type: "brushstart"
                                    });
                                }).tween("brush:brush", function() {
                                    var r = kr(o, i.x), a = kr(s, i.y);
                                    return t1 = e1 = null, function(t1) {
                                        o = i.x = r(t1), s = i.y = a(t1), n({
                                            type: "brush",
                                            mode: "resize"
                                        });
                                    };
                                }).each("end.brush", function() {
                                    t1 = i.i, e1 = i.j, n({
                                        type: "brush",
                                        mode: "resize"
                                    }), n({
                                        type: "brushend"
                                    });
                                }) : (n({
                                    type: "brushstart"
                                }), n({
                                    type: "brush",
                                    mode: "resize"
                                }), n({
                                    type: "brushend"
                                }));
                            });
                        }, f.x = function(t1) {
                            return arguments.length ? (h = fa[!(n = t1) << 1 | !i], f) : n;
                        }, f.y = function(t1) {
                            return arguments.length ? (h = fa[!n << 1 | !(i = t1)], f) : i;
                        }, f.clamp = function(t1) {
                            return arguments.length ? (n && i ? (l = !!t1[0], c = !!t1[1]) : n ? l = !!t1 : i && (c = !!t1), f) : n && i ? [
                                l,
                                c
                            ] : n ? l : i ? c : null;
                        }, f.extent = function(r) {
                            var a, l, c, u, h;
                            return arguments.length ? (n && (a = r[0], l = r[1], i && (a = a[0], l = l[0]), t1 = [
                                a,
                                l
                            ], n.invert && (a = n(a), l = n(l)), l < a && (h = a, a = l, l = h), a == o[0] && l == o[1] || (o = [
                                a,
                                l
                            ])), i && (c = r[0], u = r[1], n && (c = c[1], u = u[1]), e1 = [
                                c,
                                u
                            ], i.invert && (c = i(c), u = i(u)), u < c && (h = c, c = u, u = h), c == s[0] && u == s[1] || (s = [
                                c,
                                u
                            ])), f) : (n && (t1 ? (a = t1[0], l = t1[1]) : (a = o[0], l = o[1], n.invert && (a = n.invert(a), l = n.invert(l)), l < a && (h = a, a = l, l = h))), i && (e1 ? (c = e1[0], u = e1[1]) : (c = s[0], u = s[1], i.invert && (c = i.invert(c), u = i.invert(u)), u < c && (h = c, c = u, u = h))), n && i ? [
                                [
                                    a,
                                    c
                                ],
                                [
                                    l,
                                    u
                                ]
                            ] : n ? [
                                a,
                                l
                            ] : i && [
                                c,
                                u
                            ]);
                        }, f.clear = function() {
                            return f.empty() || (o = [
                                0,
                                0
                            ], s = [
                                0,
                                0
                            ], t1 = e1 = null), f;
                        }, f.empty = function() {
                            return !!n && o[0] == o[1] || !!i && s[0] == s[1];
                        }, a.rebind(f, r, "on");
                    };
                    var ha = {
                        n: "ns-resize",
                        e: "ew-resize",
                        s: "ns-resize",
                        w: "ew-resize",
                        nw: "nwse-resize",
                        ne: "nesw-resize",
                        se: "nwse-resize",
                        sw: "nesw-resize"
                    }, fa = [
                        [
                            "n",
                            "e",
                            "s",
                            "w",
                            "nw",
                            "ne",
                            "se",
                            "sw"
                        ],
                        [
                            "e",
                            "w"
                        ],
                        [
                            "n",
                            "s"
                        ],
                        []
                    ];
                    function pa(t1) {
                        return JSON.parse(t1.responseText);
                    }
                    function da(t1) {
                        var e1 = l.createRange();
                        return e1.selectNode(l.body), e1.createContextualFragment(t1.responseText);
                    }
                    a.text = ye(function(t1) {
                        return t1.responseText;
                    }), a.json = function(t1, e1) {
                        return ve(t1, "application/json", pa, e1);
                    }, a.html = function(t1, e1) {
                        return ve(t1, "text/html", da, e1);
                    }, a.xml = ye(function(t1) {
                        return t1.responseXML;
                    }), void 0 === (i = "function" == typeof (n = a) ? n.call(e1, r, e1, t1) : n) || (t1.exports = i);
                }).apply(self);
            },
            32280: function(t1) {
                t1.exports = function() {
                    "use strict";
                    var t1, e1, r;
                    function n(n, i) {
                        if (t1) {
                            if (e1) {
                                var a = "var sharedChunk = {}; (" + t1 + ")(sharedChunk); (" + e1 + ")(sharedChunk);", o = {};
                                t1(o), r = i(o), "undefined" != typeof window && (r.workerUrl = window.URL.createObjectURL(new Blob([
                                    a
                                ], {
                                    type: "text/javascript"
                                })));
                            } else e1 = i;
                        } else t1 = i;
                    }
                    return n(0, function(t1) {
                        function e1(t1, e1) {
                            return t1(e1 = {
                                exports: {}
                            }, e1.exports), e1.exports;
                        }
                        var r = "1.13.4", n = i;
                        function i(t1, e1, r, n) {
                            this.cx = 3 * t1, this.bx = 3 * (r - t1) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * e1, this.by = 3 * (n - e1) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = t1, this.p1y = n, this.p2x = r, this.p2y = n;
                        }
                        i.prototype.sampleCurveX = function(t1) {
                            return ((this.ax * t1 + this.bx) * t1 + this.cx) * t1;
                        }, i.prototype.sampleCurveY = function(t1) {
                            return ((this.ay * t1 + this.by) * t1 + this.cy) * t1;
                        }, i.prototype.sampleCurveDerivativeX = function(t1) {
                            return (3 * this.ax * t1 + 2 * this.bx) * t1 + this.cx;
                        }, i.prototype.solveCurveX = function(t1, e1) {
                            var r, n, i, a, o;
                            for(void 0 === e1 && (e1 = 1e-6), i = t1, o = 0; o < 8; o++){
                                if (a = this.sampleCurveX(i) - t1, Math.abs(a) < e1) return i;
                                var s = this.sampleCurveDerivativeX(i);
                                if (Math.abs(s) < 1e-6) break;
                                i -= a / s;
                            }
                            if ((i = t1) < (r = 0)) return r;
                            if (i > (n = 1)) return n;
                            for(; r < n;){
                                if (a = this.sampleCurveX(i), Math.abs(a - t1) < e1) return i;
                                t1 > a ? r = i : n = i, i = .5 * (n - r) + r;
                            }
                            return i;
                        }, i.prototype.solve = function(t1, e1) {
                            return this.sampleCurveY(this.solveCurveX(t1, e1));
                        };
                        var a = o;
                        function o(t1, e1) {
                            this.x = t1, this.y = e1;
                        }
                        o.prototype = {
                            clone: function() {
                                return new o(this.x, this.y);
                            },
                            add: function(t1) {
                                return this.clone()._add(t1);
                            },
                            sub: function(t1) {
                                return this.clone()._sub(t1);
                            },
                            multByPoint: function(t1) {
                                return this.clone()._multByPoint(t1);
                            },
                            divByPoint: function(t1) {
                                return this.clone()._divByPoint(t1);
                            },
                            mult: function(t1) {
                                return this.clone()._mult(t1);
                            },
                            div: function(t1) {
                                return this.clone()._div(t1);
                            },
                            rotate: function(t1) {
                                return this.clone()._rotate(t1);
                            },
                            rotateAround: function(t1, e1) {
                                return this.clone()._rotateAround(t1, e1);
                            },
                            matMult: function(t1) {
                                return this.clone()._matMult(t1);
                            },
                            unit: function() {
                                return this.clone()._unit();
                            },
                            perp: function() {
                                return this.clone()._perp();
                            },
                            round: function() {
                                return this.clone()._round();
                            },
                            mag: function() {
                                return Math.sqrt(this.x * this.x + this.y * this.y);
                            },
                            equals: function(t1) {
                                return this.x === t1.x && this.y === t1.y;
                            },
                            dist: function(t1) {
                                return Math.sqrt(this.distSqr(t1));
                            },
                            distSqr: function(t1) {
                                var e1 = t1.x - this.x, r = t1.y - this.y;
                                return e1 * e1 + r * r;
                            },
                            angle: function() {
                                return Math.atan2(this.y, this.x);
                            },
                            angleTo: function(t1) {
                                return Math.atan2(this.y - t1.y, this.x - t1.x);
                            },
                            angleWith: function(t1) {
                                return this.angleWithSep(t1.x, t1.y);
                            },
                            angleWithSep: function(t1, e1) {
                                return Math.atan2(this.x * e1 - this.y * t1, this.x * t1 + this.y * e1);
                            },
                            _matMult: function(t1) {
                                var e1 = t1[0] * this.x + t1[1] * this.y, r = t1[2] * this.x + t1[3] * this.y;
                                return this.x = e1, this.y = r, this;
                            },
                            _add: function(t1) {
                                return this.x += t1.x, this.y += t1.y, this;
                            },
                            _sub: function(t1) {
                                return this.x -= t1.x, this.y -= t1.y, this;
                            },
                            _mult: function(t1) {
                                return this.x *= t1, this.y *= t1, this;
                            },
                            _div: function(t1) {
                                return this.x /= t1, this.y /= t1, this;
                            },
                            _multByPoint: function(t1) {
                                return this.x *= t1.x, this.y *= t1.y, this;
                            },
                            _divByPoint: function(t1) {
                                return this.x /= t1.x, this.y /= t1.y, this;
                            },
                            _unit: function() {
                                return this._div(this.mag()), this;
                            },
                            _perp: function() {
                                var t1 = this.y;
                                return this.y = this.x, this.x = -t1, this;
                            },
                            _rotate: function(t1) {
                                var e1 = Math.cos(t1), r = Math.sin(t1), n = e1 * this.x - r * this.y, i = r * this.x + e1 * this.y;
                                return this.x = n, this.y = i, this;
                            },
                            _rotateAround: function(t1, e1) {
                                var r = Math.cos(t1), n = Math.sin(t1), i = e1.x + r * (this.x - e1.x) - n * (this.y - e1.y), a = e1.y + n * (this.x - e1.x) + r * (this.y - e1.y);
                                return this.x = i, this.y = a, this;
                            },
                            _round: function() {
                                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
                            }
                        }, o.convert = function(t1) {
                            return t1 instanceof o ? t1 : Array.isArray(t1) ? new o(t1[0], t1[1]) : t1;
                        };
                        var s = "undefined" != typeof self ? self : {};
                        var l = Math.pow(2, 53) - 1;
                        function c(t1, e1, r, i) {
                            var a = new n(t1, e1, r, i);
                            return function(t1) {
                                return a.solve(t1);
                            };
                        }
                        var u = c(.25, .1, .25, 1);
                        function h(t1, e1, r) {
                            return Math.min(r, Math.max(e1, t1));
                        }
                        function f(t1, e1, r) {
                            var n = r - e1, i = ((t1 - e1) % n + n) % n + e1;
                            return i === e1 ? r : i;
                        }
                        function p(t1) {
                            for(var e1 = [], r = arguments.length - 1; r-- > 0;)e1[r] = arguments[r + 1];
                            for(var n = 0, i = e1; n < i.length; n += 1){
                                var a = i[n];
                                for(var o in a)t1[o] = a[o];
                            }
                            return t1;
                        }
                        var d = 1;
                        function m() {
                            return d++;
                        }
                        function g() {
                            return function t1(e1) {
                                return e1 ? (e1 ^ 16 * Math.random() >> e1 / 4).toString(16) : ([
                                    1e7
                                ] + -[
                                    1e3
                                ] + -4000 + -8000 + -100000000000).replace(/[018]/g, t1);
                            }();
                        }
                        function y(t1) {
                            return !!t1 && /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(t1);
                        }
                        function v(t1, e1) {
                            t1.forEach(function(t1) {
                                e1[t1] && (e1[t1] = e1[t1].bind(e1));
                            });
                        }
                        function x(t1, e1) {
                            return -1 !== t1.indexOf(e1, t1.length - e1.length);
                        }
                        function _(t1, e1, r) {
                            var n = {};
                            for(var i in t1)n[i] = e1.call(r || this, t1[i], i, t1);
                            return n;
                        }
                        function b(t1, e1, r) {
                            var n = {};
                            for(var i in t1)e1.call(r || this, t1[i], i, t1) && (n[i] = t1[i]);
                            return n;
                        }
                        function w(t1) {
                            return Array.isArray(t1) ? t1.map(w) : "object" == typeof t1 && t1 ? _(t1, w) : t1;
                        }
                        var T = {};
                        function k(t1) {
                            T[t1] || ("undefined" != typeof console && console.warn(t1), T[t1] = !0);
                        }
                        function A(t1, e1, r) {
                            return (r.y - t1.y) * (e1.x - t1.x) > (e1.y - t1.y) * (r.x - t1.x);
                        }
                        function M(t1) {
                            for(var e1 = 0, r = 0, n = t1.length, i = n - 1, a = void 0, o = void 0; r < n; i = r++)a = t1[r], e1 += ((o = t1[i]).x - a.x) * (a.y + o.y);
                            return e1;
                        }
                        function S() {
                            return "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope;
                        }
                        function E(t1) {
                            var e1 = {};
                            if (t1.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, function(t1, r, n, i) {
                                var a = n || i;
                                return e1[r] = !a || a.toLowerCase(), "";
                            }), e1["max-age"]) {
                                var r = parseInt(e1["max-age"], 10);
                                isNaN(r) ? delete e1["max-age"] : e1["max-age"] = r;
                            }
                            return e1;
                        }
                        var C = null;
                        function L(t1) {
                            if (null == C) {
                                var e1 = t1.navigator ? t1.navigator.userAgent : null;
                                C = !!t1.safari || !(!e1 || !(/\b(iPad|iPhone|iPod)\b/.test(e1) || e1.match("Safari") && !e1.match("Chrome")));
                            }
                            return C;
                        }
                        function I(t1) {
                            try {
                                var e1 = s[t1];
                                return e1.setItem("_mapbox_test_", 1), e1.removeItem("_mapbox_test_"), !0;
                            } catch (t1) {
                                return !1;
                            }
                        }
                        var P, z, O, D, R = s.performance && s.performance.now ? s.performance.now.bind(s.performance) : Date.now.bind(Date), F = s.requestAnimationFrame || s.mozRequestAnimationFrame || s.webkitRequestAnimationFrame || s.msRequestAnimationFrame, B = s.cancelAnimationFrame || s.mozCancelAnimationFrame || s.webkitCancelAnimationFrame || s.msCancelAnimationFrame, N = {
                            now: R,
                            frame: function(t1) {
                                var e1 = F(t1);
                                return {
                                    cancel: function() {
                                        return B(e1);
                                    }
                                };
                            },
                            getImageData: function(t1, e1) {
                                void 0 === e1 && (e1 = 0);
                                var r = s.document.createElement("canvas"), n = r.getContext("2d");
                                if (!n) throw new Error("failed to create canvas 2d context");
                                return r.width = t1.width, r.height = t1.height, n.drawImage(t1, 0, 0, t1.width, t1.height), n.getImageData(-e1, -e1, t1.width + 2 * e1, t1.height + 2 * e1);
                            },
                            resolveURL: function(t1) {
                                return P || (P = s.document.createElement("a")), P.href = t1, P.href;
                            },
                            hardwareConcurrency: s.navigator && s.navigator.hardwareConcurrency || 4,
                            get devicePixelRatio () {
                                return s.devicePixelRatio;
                            },
                            get prefersReducedMotion () {
                                return !!s.matchMedia && (null == z && (z = s.matchMedia("(prefers-reduced-motion: reduce)")), z.matches);
                            }
                        }, j = {
                            API_URL: "https://api.mapbox.com",
                            get EVENTS_URL () {
                                return this.API_URL ? 0 === this.API_URL.indexOf("https://api.mapbox.cn") ? "https://events.mapbox.cn/events/v2" : 0 === this.API_URL.indexOf("https://api.mapbox.com") ? "https://events.mapbox.com/events/v2" : null : null;
                            },
                            FEEDBACK_URL: "https://apps.mapbox.com/feedback",
                            REQUIRE_ACCESS_TOKEN: !0,
                            ACCESS_TOKEN: null,
                            MAX_PARALLEL_IMAGE_REQUESTS: 16
                        }, U = {
                            supported: !1,
                            testSupport: function(t1) {
                                !V && D && (q ? H(t1) : O = t1);
                            }
                        }, V = !1, q = !1;
                        function H(t1) {
                            var e1 = t1.createTexture();
                            t1.bindTexture(t1.TEXTURE_2D, e1);
                            try {
                                if (t1.texImage2D(t1.TEXTURE_2D, 0, t1.RGBA, t1.RGBA, t1.UNSIGNED_BYTE, D), t1.isContextLost()) return;
                                U.supported = !0;
                            } catch (t1) {}
                            t1.deleteTexture(e1), V = !0;
                        }
                        s.document && ((D = s.document.createElement("img")).onload = function() {
                            O && H(O), O = null, q = !0;
                        }, D.onerror = function() {
                            V = !0, O = null;
                        }, D.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=");
                        var G = "01";
                        var Z = function(t1, e1) {
                            this._transformRequestFn = t1, this._customAccessToken = e1, this._createSkuToken();
                        };
                        function W(t1) {
                            return 0 === t1.indexOf("mapbox:");
                        }
                        Z.prototype._createSkuToken = function() {
                            var t1 = function() {
                                for(var t1 = "", e1 = 0; e1 < 10; e1++)t1 += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62 * Math.random())];
                                return {
                                    token: [
                                        "1",
                                        G,
                                        t1
                                    ].join(""),
                                    tokenExpiresAt: Date.now() + 432e5
                                };
                            }();
                            this._skuToken = t1.token, this._skuTokenExpiresAt = t1.tokenExpiresAt;
                        }, Z.prototype._isSkuTokenExpired = function() {
                            return Date.now() > this._skuTokenExpiresAt;
                        }, Z.prototype.transformRequest = function(t1, e1) {
                            return this._transformRequestFn && this._transformRequestFn(t1, e1) || {
                                url: t1
                            };
                        }, Z.prototype.normalizeStyleURL = function(t1, e1) {
                            if (!W(t1)) return t1;
                            var r = J(t1);
                            return r.path = "/styles/v1" + r.path, this._makeAPIURL(r, this._customAccessToken || e1);
                        }, Z.prototype.normalizeGlyphsURL = function(t1, e1) {
                            if (!W(t1)) return t1;
                            var r = J(t1);
                            return r.path = "/fonts/v1" + r.path, this._makeAPIURL(r, this._customAccessToken || e1);
                        }, Z.prototype.normalizeSourceURL = function(t1, e1) {
                            if (!W(t1)) return t1;
                            var r = J(t1);
                            return r.path = "/v4/" + r.authority + ".json", r.params.push("secure"), this._makeAPIURL(r, this._customAccessToken || e1);
                        }, Z.prototype.normalizeSpriteURL = function(t1, e1, r, n) {
                            var i = J(t1);
                            return W(t1) ? (i.path = "/styles/v1" + i.path + "/sprite" + e1 + r, this._makeAPIURL(i, this._customAccessToken || n)) : (i.path += "" + e1 + r, K(i));
                        }, Z.prototype.normalizeTileURL = function(t1, e1) {
                            if (this._isSkuTokenExpired() && this._createSkuToken(), t1 && !W(t1)) return t1;
                            var r = J(t1), n = N.devicePixelRatio >= 2 || 512 === e1 ? "@2x" : "", i = U.supported ? ".webp" : "$1";
                            r.path = r.path.replace(/(\.(png|jpg)\d*)(?=$)/, "" + n + i), r.path = r.path.replace(/^.+\/v4\//, "/"), r.path = "/v4" + r.path;
                            var a = this._customAccessToken || function(t1) {
                                for(var e1 = 0, r = t1; e1 < r.length; e1 += 1){
                                    var n = r[e1].match(/^access_token=(.*)$/);
                                    if (n) return n[1];
                                }
                                return null;
                            }(r.params) || j.ACCESS_TOKEN;
                            return j.REQUIRE_ACCESS_TOKEN && a && this._skuToken && r.params.push("sku=" + this._skuToken), this._makeAPIURL(r, a);
                        }, Z.prototype.canonicalizeTileURL = function(t1, e1) {
                            var r = J(t1);
                            if (!r.path.match(/(^\/v4\/)/) || !r.path.match(/\.[\w]+$/)) return t1;
                            var n = "mapbox://tiles/";
                            n += r.path.replace("/v4/", "");
                            var i = r.params;
                            return e1 && (i = i.filter(function(t1) {
                                return !t1.match(/^access_token=/);
                            })), i.length && (n += "?" + i.join("&")), n;
                        }, Z.prototype.canonicalizeTileset = function(t1, e1) {
                            for(var r = !!e1 && W(e1), n = [], i = 0, a = t1.tiles || []; i < a.length; i += 1){
                                var o = a[i];
                                X(o) ? n.push(this.canonicalizeTileURL(o, r)) : n.push(o);
                            }
                            return n;
                        }, Z.prototype._makeAPIURL = function(t1, e1) {
                            var r = "See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes", n = J(j.API_URL);
                            if (t1.protocol = n.protocol, t1.authority = n.authority, "http" === t1.protocol) {
                                var i = t1.params.indexOf("secure");
                                i >= 0 && t1.params.splice(i, 1);
                            }
                            if ("/" !== n.path && (t1.path = "" + n.path + t1.path), !j.REQUIRE_ACCESS_TOKEN) return K(t1);
                            if (!(e1 = e1 || j.ACCESS_TOKEN)) throw new Error("An API access token is required to use Mapbox GL. " + r);
                            if ("s" === e1[0]) throw new Error("Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). " + r);
                            return t1.params = t1.params.filter(function(t1) {
                                return -1 === t1.indexOf("access_token");
                            }), t1.params.push("access_token=" + e1), K(t1);
                        };
                        var Y = /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i;
                        function X(t1) {
                            return Y.test(t1);
                        }
                        var $ = /^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;
                        function J(t1) {
                            var e1 = t1.match($);
                            if (!e1) throw new Error("Unable to parse URL object");
                            return {
                                protocol: e1[1],
                                authority: e1[2],
                                path: e1[3] || "/",
                                params: e1[4] ? e1[4].split("&") : []
                            };
                        }
                        function K(t1) {
                            var e1 = t1.params.length ? "?" + t1.params.join("&") : "";
                            return t1.protocol + "://" + t1.authority + t1.path + e1;
                        }
                        var Q = "mapbox.eventData";
                        function tt(t1) {
                            if (!t1) return null;
                            var e1, r = t1.split(".");
                            if (!r || 3 !== r.length) return null;
                            try {
                                return JSON.parse((e1 = r[1], decodeURIComponent(s.atob(e1).split("").map(function(t1) {
                                    return "%" + ("00" + t1.charCodeAt(0).toString(16)).slice(-2);
                                }).join(""))));
                            } catch (t1) {
                                return null;
                            }
                        }
                        var et = function(t1) {
                            this.type = t1, this.anonId = null, this.eventData = {}, this.queue = [], this.pendingRequest = null;
                        };
                        et.prototype.getStorageKey = function(t1) {
                            var e1, r, n = tt(j.ACCESS_TOKEN);
                            return e1 = n && n.u ? (r = n.u, s.btoa(encodeURIComponent(r).replace(/%([0-9A-F]{2})/g, function(t1, e1) {
                                return String.fromCharCode(Number("0x" + e1));
                            }))) : j.ACCESS_TOKEN || "", t1 ? Q + "." + t1 + ":" + e1 : Q + ":" + e1;
                        }, et.prototype.fetchEventData = function() {
                            var t1 = I("localStorage"), e1 = this.getStorageKey(), r = this.getStorageKey("uuid");
                            if (t1) try {
                                var n = s.localStorage.getItem(e1);
                                n && (this.eventData = JSON.parse(n));
                                var i = s.localStorage.getItem(r);
                                i && (this.anonId = i);
                            } catch (t1) {
                                k("Unable to read from LocalStorage");
                            }
                        }, et.prototype.saveEventData = function() {
                            var t1 = I("localStorage"), e1 = this.getStorageKey(), r = this.getStorageKey("uuid");
                            if (t1) try {
                                s.localStorage.setItem(r, this.anonId), Object.keys(this.eventData).length >= 1 && s.localStorage.setItem(e1, JSON.stringify(this.eventData));
                            } catch (t1) {
                                k("Unable to write to LocalStorage");
                            }
                        }, et.prototype.processRequests = function(t1) {}, et.prototype.postEvent = function(t1, e1, n, i) {
                            var a = this;
                            if (j.EVENTS_URL) {
                                var o = J(j.EVENTS_URL);
                                o.params.push("access_token=" + (i || j.ACCESS_TOKEN || ""));
                                var s = {
                                    event: this.type,
                                    created: new Date(t1).toISOString(),
                                    sdkIdentifier: "mapbox-gl-js",
                                    sdkVersion: r,
                                    skuId: G,
                                    userId: this.anonId
                                }, l = e1 ? p(s, e1) : s, c = {
                                    url: K(o),
                                    headers: {
                                        "Content-Type": "text/plain"
                                    },
                                    body: JSON.stringify([
                                        l
                                    ])
                                };
                                this.pendingRequest = St(c, function(t1) {
                                    a.pendingRequest = null, n(t1), a.saveEventData(), a.processRequests(i);
                                });
                            }
                        }, et.prototype.queueRequest = function(t1, e1) {
                            this.queue.push(t1), this.processRequests(e1);
                        };
                        var rt, nt, it = function(t1) {
                            function e1() {
                                t1.call(this, "map.load"), this.success = {}, this.skuToken = "";
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.postMapLoadEvent = function(t1, e1, r, n) {
                                this.skuToken = r, (j.EVENTS_URL && n || j.ACCESS_TOKEN && Array.isArray(t1) && t1.some(function(t1) {
                                    return W(t1) || X(t1);
                                })) && this.queueRequest({
                                    id: e1,
                                    timestamp: Date.now()
                                }, n);
                            }, e1.prototype.processRequests = function(t1) {
                                var e1 = this;
                                if (!this.pendingRequest && 0 !== this.queue.length) {
                                    var r = this.queue.shift(), n = r.id, i = r.timestamp;
                                    n && this.success[n] || (this.anonId || this.fetchEventData(), y(this.anonId) || (this.anonId = g()), this.postEvent(i, {
                                        skuToken: this.skuToken
                                    }, function(t1) {
                                        t1 || n && (e1.success[n] = !0);
                                    }, t1));
                                }
                            }, e1;
                        }(et), at = function(t1) {
                            function e1(e1) {
                                t1.call(this, "appUserTurnstile"), this._customAccessToken = e1;
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.postTurnstileEvent = function(t1, e1) {
                                j.EVENTS_URL && j.ACCESS_TOKEN && Array.isArray(t1) && t1.some(function(t1) {
                                    return W(t1) || X(t1);
                                }) && this.queueRequest(Date.now(), e1);
                            }, e1.prototype.processRequests = function(t1) {
                                var e1 = this;
                                if (!this.pendingRequest && 0 !== this.queue.length) {
                                    this.anonId && this.eventData.lastSuccess && this.eventData.tokenU || this.fetchEventData();
                                    var r = tt(j.ACCESS_TOKEN), n = r ? r.u : j.ACCESS_TOKEN, i = n !== this.eventData.tokenU;
                                    y(this.anonId) || (this.anonId = g(), i = !0);
                                    var a = this.queue.shift();
                                    if (this.eventData.lastSuccess) {
                                        var o = new Date(this.eventData.lastSuccess), s = new Date(a), l = (a - this.eventData.lastSuccess) / 864e5;
                                        i = i || l >= 1 || l < -1 || o.getDate() !== s.getDate();
                                    } else i = !0;
                                    if (!i) return this.processRequests();
                                    this.postEvent(a, {
                                        "enabled.telemetry": !1
                                    }, function(t1) {
                                        t1 || (e1.eventData.lastSuccess = a, e1.eventData.tokenU = n);
                                    }, t1);
                                }
                            }, e1;
                        }(et), ot = new at, st = ot.postTurnstileEvent.bind(ot), lt = new it, ct = lt.postMapLoadEvent.bind(lt), ut = "mapbox-tiles", ht = 500, ft = 50, pt = 42e4;
                        function dt() {
                            s.caches && !rt && (rt = s.caches.open(ut));
                        }
                        function mt(t1, e1, r) {
                            if (dt(), rt) {
                                var n = {
                                    status: e1.status,
                                    statusText: e1.statusText,
                                    headers: new s.Headers
                                };
                                e1.headers.forEach(function(t1, e1) {
                                    return n.headers.set(e1, t1);
                                });
                                var i = E(e1.headers.get("Cache-Control") || "");
                                i["no-store"] || (i["max-age"] && n.headers.set("Expires", new Date(r + 1e3 * i["max-age"]).toUTCString()), new Date(n.headers.get("Expires")).getTime() - r < pt || function(t1, e1) {
                                    if (void 0 === nt) try {
                                        new Response(new ReadableStream), nt = !0;
                                    } catch (t1) {
                                        nt = !1;
                                    }
                                    nt ? e1(t1.body) : t1.blob().then(e1);
                                }(e1, function(e1) {
                                    var r = new s.Response(e1, n);
                                    dt(), rt && rt.then(function(e1) {
                                        return e1.put(gt(t1.url), r);
                                    }).catch(function(t1) {
                                        return k(t1.message);
                                    });
                                }));
                            }
                        }
                        function gt(t1) {
                            var e1 = t1.indexOf("?");
                            return e1 < 0 ? t1 : t1.slice(0, e1);
                        }
                        function yt(t1, e1) {
                            if (dt(), !rt) return e1(null);
                            var r = gt(t1.url);
                            rt.then(function(t1) {
                                t1.match(r).then(function(n) {
                                    var i = function(t1) {
                                        if (!t1) return !1;
                                        var e1 = new Date(t1.headers.get("Expires") || 0), r = E(t1.headers.get("Cache-Control") || "");
                                        return e1 > Date.now() && !r["no-cache"];
                                    }(n);
                                    t1.delete(r), i && t1.put(r, n.clone()), e1(null, n, i);
                                }).catch(e1);
                            }).catch(e1);
                        }
                        var vt, xt = 1 / 0;
                        function _t() {
                            return null == vt && (vt = s.OffscreenCanvas && new s.OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof s.createImageBitmap), vt;
                        }
                        var bt = {
                            Unknown: "Unknown",
                            Style: "Style",
                            Source: "Source",
                            Tile: "Tile",
                            Glyphs: "Glyphs",
                            SpriteImage: "SpriteImage",
                            SpriteJSON: "SpriteJSON",
                            Image: "Image"
                        };
                        "function" == typeof Object.freeze && Object.freeze(bt);
                        var wt = function(t1) {
                            function e1(e1, r, n) {
                                401 === r && X(n) && (e1 += ": you may have provided an invalid Mapbox access token. See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes"), t1.call(this, e1), this.status = r, this.url = n, this.name = this.constructor.name, this.message = e1;
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.toString = function() {
                                return this.name + ": " + this.message + " (" + this.status + "): " + this.url;
                            }, e1;
                        }(Error), Tt = S() ? function() {
                            return self.worker && self.worker.referrer;
                        } : function() {
                            return ("blob:" === s.location.protocol ? s.parent : s).location.href;
                        };
                        function kt(t1, e1) {
                            var r, n = new s.AbortController, i = new s.Request(t1.url, {
                                method: t1.method || "GET",
                                body: t1.body,
                                credentials: t1.credentials,
                                headers: t1.headers,
                                referrer: Tt(),
                                signal: n.signal
                            }), a = !1, o = !1, l = (r = i.url).indexOf("sku=") > 0 && X(r);
                            "json" === t1.type && i.headers.set("Accept", "application/json");
                            var c = function(r, n, a) {
                                if (!o) {
                                    if (r && "SecurityError" !== r.message && k(r), n && a) return u(n);
                                    var c = Date.now();
                                    s.fetch(i).then(function(r) {
                                        if (r.ok) {
                                            var n = l ? r.clone() : null;
                                            return u(r, n, c);
                                        }
                                        return e1(new wt(r.statusText, r.status, t1.url));
                                    }).catch(function(t1) {
                                        20 !== t1.code && e1(new Error(t1.message));
                                    });
                                }
                            }, u = function(r, n, s) {
                                ("arrayBuffer" === t1.type ? r.arrayBuffer() : "json" === t1.type ? r.json() : r.text()).then(function(t1) {
                                    o || (n && s && mt(i, n, s), a = !0, e1(null, t1, r.headers.get("Cache-Control"), r.headers.get("Expires")));
                                }).catch(function(t1) {
                                    o || e1(new Error(t1.message));
                                });
                            };
                            return l ? yt(i, c) : c(null, null), {
                                cancel: function() {
                                    o = !0, a || n.abort();
                                }
                            };
                        }
                        var At = function(t1, e1) {
                            if (r = t1.url, !(/^file:/.test(r) || /^file:/.test(Tt()) && !/^\w+:/.test(r))) {
                                if (s.fetch && s.Request && s.AbortController && s.Request.prototype.hasOwnProperty("signal")) return kt(t1, e1);
                                if (S() && self.worker && self.worker.actor) return self.worker.actor.send("getResource", t1, e1, void 0, !0);
                            }
                            var r;
                            return function(t1, e1) {
                                var r = new s.XMLHttpRequest;
                                for(var n in r.open(t1.method || "GET", t1.url, !0), "arrayBuffer" === t1.type && (r.responseType = "arraybuffer"), t1.headers)r.setRequestHeader(n, t1.headers[n]);
                                return "json" === t1.type && (r.responseType = "text", r.setRequestHeader("Accept", "application/json")), r.withCredentials = "include" === t1.credentials, r.onerror = function() {
                                    e1(new Error(r.statusText));
                                }, r.onload = function() {
                                    if ((r.status >= 200 && r.status < 300 || 0 === r.status) && null !== r.response) {
                                        var n = r.response;
                                        if ("json" === t1.type) try {
                                            n = JSON.parse(r.response);
                                        } catch (t1) {
                                            return e1(t1);
                                        }
                                        e1(null, n, r.getResponseHeader("Cache-Control"), r.getResponseHeader("Expires"));
                                    } else e1(new wt(r.statusText, r.status, t1.url));
                                }, r.send(t1.body), {
                                    cancel: function() {
                                        return r.abort();
                                    }
                                };
                            }(t1, e1);
                        }, Mt = function(t1, e1) {
                            return At(p(t1, {
                                type: "arrayBuffer"
                            }), e1);
                        }, St = function(t1, e1) {
                            return At(p(t1, {
                                method: "POST"
                            }), e1);
                        };
                        var Et, Ct, Lt = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
                        Et = [], Ct = 0;
                        var It = function(t1, e1) {
                            if (U.supported && (t1.headers || (t1.headers = {}), t1.headers.accept = "image/webp,*/*"), Ct >= j.MAX_PARALLEL_IMAGE_REQUESTS) {
                                var r = {
                                    requestParameters: t1,
                                    callback: e1,
                                    cancelled: !1,
                                    cancel: function() {
                                        this.cancelled = !0;
                                    }
                                };
                                return Et.push(r), r;
                            }
                            Ct++;
                            var n = !1, i = function() {
                                if (!n) for(n = !0, Ct--; Et.length && Ct < j.MAX_PARALLEL_IMAGE_REQUESTS;){
                                    var t1 = Et.shift(), e1 = t1.requestParameters, r = t1.callback;
                                    t1.cancelled || (t1.cancel = It(e1, r).cancel);
                                }
                            }, a = Mt(t1, function(t1, r, n, a) {
                                i(), t1 ? e1(t1) : r && (_t() ? function(t1, e1) {
                                    var r = new s.Blob([
                                        new Uint8Array(t1)
                                    ], {
                                        type: "image/png"
                                    });
                                    s.createImageBitmap(r).then(function(t1) {
                                        e1(null, t1);
                                    }).catch(function(t1) {
                                        e1(new Error("Could not load image because of " + t1.message + ". Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                                    });
                                }(r, e1) : function(t1, e1, r, n) {
                                    var i = new s.Image, a = s.URL;
                                    i.onload = function() {
                                        e1(null, i), a.revokeObjectURL(i.src), i.onload = null, s.requestAnimationFrame(function() {
                                            i.src = Lt;
                                        });
                                    }, i.onerror = function() {
                                        return e1(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                                    };
                                    var o = new s.Blob([
                                        new Uint8Array(t1)
                                    ], {
                                        type: "image/png"
                                    });
                                    i.cacheControl = r, i.expires = n, i.src = t1.byteLength ? a.createObjectURL(o) : Lt;
                                }(r, e1, n, a));
                            });
                            return {
                                cancel: function() {
                                    a.cancel(), i();
                                }
                            };
                        };
                        function Pt(t1, e1, r) {
                            r[t1] && -1 !== r[t1].indexOf(e1) || (r[t1] = r[t1] || [], r[t1].push(e1));
                        }
                        function zt(t1, e1, r) {
                            if (r && r[t1]) {
                                var n = r[t1].indexOf(e1);
                                -1 !== n && r[t1].splice(n, 1);
                            }
                        }
                        var Ot = function(t1, e1) {
                            void 0 === e1 && (e1 = {}), p(this, e1), this.type = t1;
                        }, Dt = function(t1) {
                            function e1(e1, r) {
                                void 0 === r && (r = {}), t1.call(this, "error", p({
                                    error: e1
                                }, r));
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1;
                        }(Ot), Rt = function() {};
                        Rt.prototype.on = function(t1, e1) {
                            return this._listeners = this._listeners || {}, Pt(t1, e1, this._listeners), this;
                        }, Rt.prototype.off = function(t1, e1) {
                            return zt(t1, e1, this._listeners), zt(t1, e1, this._oneTimeListeners), this;
                        }, Rt.prototype.once = function(t1, e1) {
                            return this._oneTimeListeners = this._oneTimeListeners || {}, Pt(t1, e1, this._oneTimeListeners), this;
                        }, Rt.prototype.fire = function(t1, e1) {
                            "string" == typeof t1 && (t1 = new Ot(t1, e1 || {}));
                            var r = t1.type;
                            if (this.listens(r)) {
                                t1.target = this;
                                for(var n = 0, i = this._listeners && this._listeners[r] ? this._listeners[r].slice() : []; n < i.length; n += 1)i[n].call(this, t1);
                                for(var a = 0, o = this._oneTimeListeners && this._oneTimeListeners[r] ? this._oneTimeListeners[r].slice() : []; a < o.length; a += 1){
                                    var s = o[a];
                                    zt(r, s, this._oneTimeListeners), s.call(this, t1);
                                }
                                var l = this._eventedParent;
                                l && (p(t1, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), l.fire(t1));
                            } else t1 instanceof Dt && console.error(t1.error);
                            return this;
                        }, Rt.prototype.listens = function(t1) {
                            return this._listeners && this._listeners[t1] && this._listeners[t1].length > 0 || this._oneTimeListeners && this._oneTimeListeners[t1] && this._oneTimeListeners[t1].length > 0 || this._eventedParent && this._eventedParent.listens(t1);
                        }, Rt.prototype.setEventedParent = function(t1, e1) {
                            return this._eventedParent = t1, this._eventedParentData = e1, this;
                        };
                        var Ft = {
                            $version: 8,
                            $root: {
                                version: {
                                    required: !0,
                                    type: "enum",
                                    values: [
                                        8
                                    ]
                                },
                                name: {
                                    type: "string"
                                },
                                metadata: {
                                    type: "*"
                                },
                                center: {
                                    type: "array",
                                    value: "number"
                                },
                                zoom: {
                                    type: "number"
                                },
                                bearing: {
                                    type: "number",
                                    default: 0,
                                    period: 360,
                                    units: "degrees"
                                },
                                pitch: {
                                    type: "number",
                                    default: 0,
                                    units: "degrees"
                                },
                                light: {
                                    type: "light"
                                },
                                sources: {
                                    required: !0,
                                    type: "sources"
                                },
                                sprite: {
                                    type: "string"
                                },
                                glyphs: {
                                    type: "string"
                                },
                                transition: {
                                    type: "transition"
                                },
                                layers: {
                                    required: !0,
                                    type: "array",
                                    value: "layer"
                                }
                            },
                            sources: {
                                "*": {
                                    type: "source"
                                }
                            },
                            source: [
                                "source_vector",
                                "source_raster",
                                "source_raster_dem",
                                "source_geojson",
                                "source_video",
                                "source_image"
                            ],
                            source_vector: {
                                type: {
                                    required: !0,
                                    type: "enum",
                                    values: {
                                        vector: {}
                                    }
                                },
                                url: {
                                    type: "string"
                                },
                                tiles: {
                                    type: "array",
                                    value: "string"
                                },
                                bounds: {
                                    type: "array",
                                    value: "number",
                                    length: 4,
                                    default: [
                                        -180,
                                        -85.051129,
                                        180,
                                        85.051129
                                    ]
                                },
                                scheme: {
                                    type: "enum",
                                    values: {
                                        xyz: {},
                                        tms: {}
                                    },
                                    default: "xyz"
                                },
                                minzoom: {
                                    type: "number",
                                    default: 0
                                },
                                maxzoom: {
                                    type: "number",
                                    default: 22
                                },
                                attribution: {
                                    type: "string"
                                },
                                promoteId: {
                                    type: "promoteId"
                                },
                                volatile: {
                                    type: "boolean",
                                    default: !1
                                },
                                "*": {
                                    type: "*"
                                }
                            },
                            source_raster: {
                                type: {
                                    required: !0,
                                    type: "enum",
                                    values: {
                                        raster: {}
                                    }
                                },
                                url: {
                                    type: "string"
                                },
                                tiles: {
                                    type: "array",
                                    value: "string"
                                },
                                bounds: {
                                    type: "array",
                                    value: "number",
                                    length: 4,
                                    default: [
                                        -180,
                                        -85.051129,
                                        180,
                                        85.051129
                                    ]
                                },
                                minzoom: {
                                    type: "number",
                                    default: 0
                                },
                                maxzoom: {
                                    type: "number",
                                    default: 22
                                },
                                tileSize: {
                                    type: "number",
                                    default: 512,
                                    units: "pixels"
                                },
                                scheme: {
                                    type: "enum",
                                    values: {
                                        xyz: {},
                                        tms: {}
                                    },
                                    default: "xyz"
                                },
                                attribution: {
                                    type: "string"
                                },
                                volatile: {
                                    type: "boolean",
                                    default: !1
                                },
                                "*": {
                                    type: "*"
                                }
                            },
                            source_raster_dem: {
                                type: {
                                    required: !0,
                                    type: "enum",
                                    values: {
                                        "raster-dem": {}
                                    }
                                },
                                url: {
                                    type: "string"
                                },
                                tiles: {
                                    type: "array",
                                    value: "string"
                                },
                                bounds: {
                                    type: "array",
                                    value: "number",
                                    length: 4,
                                    default: [
                                        -180,
                                        -85.051129,
                                        180,
                                        85.051129
                                    ]
                                },
                                minzoom: {
                                    type: "number",
                                    default: 0
                                },
                                maxzoom: {
                                    type: "number",
                                    default: 22
                                },
                                tileSize: {
                                    type: "number",
                                    default: 512,
                                    units: "pixels"
                                },
                                attribution: {
                                    type: "string"
                                },
                                encoding: {
                                    type: "enum",
                                    values: {
                                        terrarium: {},
                                        mapbox: {}
                                    },
                                    default: "mapbox"
                                },
                                volatile: {
                                    type: "boolean",
                                    default: !1
                                },
                                "*": {
                                    type: "*"
                                }
                            },
                            source_geojson: {
                                type: {
                                    required: !0,
                                    type: "enum",
                                    values: {
                                        geojson: {}
                                    }
                                },
                                data: {
                                    type: "*"
                                },
                                maxzoom: {
                                    type: "number",
                                    default: 18
                                },
                                attribution: {
                                    type: "string"
                                },
                                buffer: {
                                    type: "number",
                                    default: 128,
                                    maximum: 512,
                                    minimum: 0
                                },
                                filter: {
                                    type: "*"
                                },
                                tolerance: {
                                    type: "number",
                                    default: .375
                                },
                                cluster: {
                                    type: "boolean",
                                    default: !1
                                },
                                clusterRadius: {
                                    type: "number",
                                    default: 50,
                                    minimum: 0
                                },
                                clusterMaxZoom: {
                                    type: "number"
                                },
                                clusterMinPoints: {
                                    type: "number"
                                },
                                clusterProperties: {
                                    type: "*"
                                },
                                lineMetrics: {
                                    type: "boolean",
                                    default: !1
                                },
                                generateId: {
                                    type: "boolean",
                                    default: !1
                                },
                                promoteId: {
                                    type: "promoteId"
                                }
                            },
                            source_video: {
                                type: {
                                    required: !0,
                                    type: "enum",
                                    values: {
                                        video: {}
                                    }
                                },
                                urls: {
                                    required: !0,
                                    type: "array",
                                    value: "string"
                                },
                                coordinates: {
                                    required: !0,
                                    type: "array",
                                    length: 4,
                                    value: {
                                        type: "array",
                                        length: 2,
                                        value: "number"
                                    }
                                }
                            },
                            source_image: {
                                type: {
                                    required: !0,
                                    type: "enum",
                                    values: {
                                        image: {}
                                    }
                                },
                                url: {
                                    required: !0,
                                    type: "string"
                                },
                                coordinates: {
                                    required: !0,
                                    type: "array",
                                    length: 4,
                                    value: {
                                        type: "array",
                                        length: 2,
                                        value: "number"
                                    }
                                }
                            },
                            layer: {
                                id: {
                                    type: "string",
                                    required: !0
                                },
                                type: {
                                    type: "enum",
                                    values: {
                                        fill: {},
                                        line: {},
                                        symbol: {},
                                        circle: {},
                                        heatmap: {},
                                        "fill-extrusion": {},
                                        raster: {},
                                        hillshade: {},
                                        background: {}
                                    },
                                    required: !0
                                },
                                metadata: {
                                    type: "*"
                                },
                                source: {
                                    type: "string"
                                },
                                "source-layer": {
                                    type: "string"
                                },
                                minzoom: {
                                    type: "number",
                                    minimum: 0,
                                    maximum: 24
                                },
                                maxzoom: {
                                    type: "number",
                                    minimum: 0,
                                    maximum: 24
                                },
                                filter: {
                                    type: "filter"
                                },
                                layout: {
                                    type: "layout"
                                },
                                paint: {
                                    type: "paint"
                                }
                            },
                            layout: [
                                "layout_fill",
                                "layout_line",
                                "layout_circle",
                                "layout_heatmap",
                                "layout_fill-extrusion",
                                "layout_symbol",
                                "layout_raster",
                                "layout_hillshade",
                                "layout_background"
                            ],
                            layout_background: {
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            layout_fill: {
                                "fill-sort-key": {
                                    type: "number",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            layout_circle: {
                                "circle-sort-key": {
                                    type: "number",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            layout_heatmap: {
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            "layout_fill-extrusion": {
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            layout_line: {
                                "line-cap": {
                                    type: "enum",
                                    values: {
                                        butt: {},
                                        round: {},
                                        square: {}
                                    },
                                    default: "butt",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "line-join": {
                                    type: "enum",
                                    values: {
                                        bevel: {},
                                        round: {},
                                        miter: {}
                                    },
                                    default: "miter",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-miter-limit": {
                                    type: "number",
                                    default: 2,
                                    requires: [
                                        {
                                            "line-join": "miter"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "line-round-limit": {
                                    type: "number",
                                    default: 1.05,
                                    requires: [
                                        {
                                            "line-join": "round"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "line-sort-key": {
                                    type: "number",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            layout_symbol: {
                                "symbol-placement": {
                                    type: "enum",
                                    values: {
                                        point: {},
                                        line: {},
                                        "line-center": {}
                                    },
                                    default: "point",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "symbol-spacing": {
                                    type: "number",
                                    default: 250,
                                    minimum: 1,
                                    units: "pixels",
                                    requires: [
                                        {
                                            "symbol-placement": "line"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "symbol-avoid-edges": {
                                    type: "boolean",
                                    default: !1,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "symbol-sort-key": {
                                    type: "number",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "symbol-z-order": {
                                    type: "enum",
                                    values: {
                                        auto: {},
                                        "viewport-y": {},
                                        source: {}
                                    },
                                    default: "auto",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-allow-overlap": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-ignore-placement": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-optional": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "icon-image",
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-rotation-alignment": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {},
                                        auto: {}
                                    },
                                    default: "auto",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-size": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    units: "factor of the original icon size",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-text-fit": {
                                    type: "enum",
                                    values: {
                                        none: {},
                                        width: {},
                                        height: {},
                                        both: {}
                                    },
                                    default: "none",
                                    requires: [
                                        "icon-image",
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-text-fit-padding": {
                                    type: "array",
                                    value: "number",
                                    length: 4,
                                    default: [
                                        0,
                                        0,
                                        0,
                                        0
                                    ],
                                    units: "pixels",
                                    requires: [
                                        "icon-image",
                                        "text-field",
                                        {
                                            "icon-text-fit": [
                                                "both",
                                                "width",
                                                "height"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-image": {
                                    type: "resolvedImage",
                                    tokens: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-rotate": {
                                    type: "number",
                                    default: 0,
                                    period: 360,
                                    units: "degrees",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-padding": {
                                    type: "number",
                                    default: 2,
                                    minimum: 0,
                                    units: "pixels",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-keep-upright": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "icon-image",
                                        {
                                            "icon-rotation-alignment": "map"
                                        },
                                        {
                                            "symbol-placement": [
                                                "line",
                                                "line-center"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-offset": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-anchor": {
                                    type: "enum",
                                    values: {
                                        center: {},
                                        left: {},
                                        right: {},
                                        top: {},
                                        bottom: {},
                                        "top-left": {},
                                        "top-right": {},
                                        "bottom-left": {},
                                        "bottom-right": {}
                                    },
                                    default: "center",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-pitch-alignment": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {},
                                        auto: {}
                                    },
                                    default: "auto",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-pitch-alignment": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {},
                                        auto: {}
                                    },
                                    default: "auto",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-rotation-alignment": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {},
                                        auto: {}
                                    },
                                    default: "auto",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-field": {
                                    type: "formatted",
                                    default: "",
                                    tokens: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-font": {
                                    type: "array",
                                    value: "string",
                                    default: [
                                        "Open Sans Regular",
                                        "Arial Unicode MS Regular"
                                    ],
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-size": {
                                    type: "number",
                                    default: 16,
                                    minimum: 0,
                                    units: "pixels",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-max-width": {
                                    type: "number",
                                    default: 10,
                                    minimum: 0,
                                    units: "ems",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-line-height": {
                                    type: "number",
                                    default: 1.2,
                                    units: "ems",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-letter-spacing": {
                                    type: "number",
                                    default: 0,
                                    units: "ems",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-justify": {
                                    type: "enum",
                                    values: {
                                        auto: {},
                                        left: {},
                                        center: {},
                                        right: {}
                                    },
                                    default: "center",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-radial-offset": {
                                    type: "number",
                                    units: "ems",
                                    default: 0,
                                    requires: [
                                        "text-field"
                                    ],
                                    "property-type": "data-driven",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    }
                                },
                                "text-variable-anchor": {
                                    type: "array",
                                    value: "enum",
                                    values: {
                                        center: {},
                                        left: {},
                                        right: {},
                                        top: {},
                                        bottom: {},
                                        "top-left": {},
                                        "top-right": {},
                                        "bottom-left": {},
                                        "bottom-right": {}
                                    },
                                    requires: [
                                        "text-field",
                                        {
                                            "symbol-placement": [
                                                "point"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-anchor": {
                                    type: "enum",
                                    values: {
                                        center: {},
                                        left: {},
                                        right: {},
                                        top: {},
                                        bottom: {},
                                        "top-left": {},
                                        "top-right": {},
                                        "bottom-left": {},
                                        "bottom-right": {}
                                    },
                                    default: "center",
                                    requires: [
                                        "text-field",
                                        {
                                            "!": "text-variable-anchor"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-max-angle": {
                                    type: "number",
                                    default: 45,
                                    units: "degrees",
                                    requires: [
                                        "text-field",
                                        {
                                            "symbol-placement": [
                                                "line",
                                                "line-center"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-writing-mode": {
                                    type: "array",
                                    value: "enum",
                                    values: {
                                        horizontal: {},
                                        vertical: {}
                                    },
                                    requires: [
                                        "text-field",
                                        {
                                            "symbol-placement": [
                                                "point"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-rotate": {
                                    type: "number",
                                    default: 0,
                                    period: 360,
                                    units: "degrees",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-padding": {
                                    type: "number",
                                    default: 2,
                                    minimum: 0,
                                    units: "pixels",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-keep-upright": {
                                    type: "boolean",
                                    default: !0,
                                    requires: [
                                        "text-field",
                                        {
                                            "text-rotation-alignment": "map"
                                        },
                                        {
                                            "symbol-placement": [
                                                "line",
                                                "line-center"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-transform": {
                                    type: "enum",
                                    values: {
                                        none: {},
                                        uppercase: {},
                                        lowercase: {}
                                    },
                                    default: "none",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-offset": {
                                    type: "array",
                                    value: "number",
                                    units: "ems",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    requires: [
                                        "text-field",
                                        {
                                            "!": "text-radial-offset"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-allow-overlap": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-ignore-placement": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-optional": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "text-field",
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            layout_raster: {
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            layout_hillshade: {
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            filter: {
                                type: "array",
                                value: "*"
                            },
                            filter_operator: {
                                type: "enum",
                                values: {
                                    "==": {},
                                    "!=": {},
                                    ">": {},
                                    ">=": {},
                                    "<": {},
                                    "<=": {},
                                    in: {},
                                    "!in": {},
                                    all: {},
                                    any: {},
                                    none: {},
                                    has: {},
                                    "!has": {},
                                    within: {}
                                }
                            },
                            geometry_type: {
                                type: "enum",
                                values: {
                                    Point: {},
                                    LineString: {},
                                    Polygon: {}
                                }
                            },
                            function: {
                                expression: {
                                    type: "expression"
                                },
                                stops: {
                                    type: "array",
                                    value: "function_stop"
                                },
                                base: {
                                    type: "number",
                                    default: 1,
                                    minimum: 0
                                },
                                property: {
                                    type: "string",
                                    default: "$zoom"
                                },
                                type: {
                                    type: "enum",
                                    values: {
                                        identity: {},
                                        exponential: {},
                                        interval: {},
                                        categorical: {}
                                    },
                                    default: "exponential"
                                },
                                colorSpace: {
                                    type: "enum",
                                    values: {
                                        rgb: {},
                                        lab: {},
                                        hcl: {}
                                    },
                                    default: "rgb"
                                },
                                default: {
                                    type: "*",
                                    required: !1
                                }
                            },
                            function_stop: {
                                type: "array",
                                minimum: 0,
                                maximum: 24,
                                value: [
                                    "number",
                                    "color"
                                ],
                                length: 2
                            },
                            expression: {
                                type: "array",
                                value: "*",
                                minimum: 1
                            },
                            light: {
                                anchor: {
                                    type: "enum",
                                    default: "viewport",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    "property-type": "data-constant",
                                    transition: !1,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    }
                                },
                                position: {
                                    type: "array",
                                    default: [
                                        1.15,
                                        210,
                                        30
                                    ],
                                    length: 3,
                                    value: "number",
                                    "property-type": "data-constant",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    }
                                },
                                color: {
                                    type: "color",
                                    "property-type": "data-constant",
                                    default: "#ffffff",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    transition: !0
                                },
                                intensity: {
                                    type: "number",
                                    "property-type": "data-constant",
                                    default: .5,
                                    minimum: 0,
                                    maximum: 1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    transition: !0
                                }
                            },
                            paint: [
                                "paint_fill",
                                "paint_line",
                                "paint_circle",
                                "paint_heatmap",
                                "paint_fill-extrusion",
                                "paint_symbol",
                                "paint_raster",
                                "paint_hillshade",
                                "paint_background"
                            ],
                            paint_fill: {
                                "fill-antialias": {
                                    type: "boolean",
                                    default: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "fill-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "fill-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    requires: [
                                        {
                                            "!": "fill-pattern"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "fill-outline-color": {
                                    type: "color",
                                    transition: !0,
                                    requires: [
                                        {
                                            "!": "fill-pattern"
                                        },
                                        {
                                            "fill-antialias": !0
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "fill-translate": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "fill-translate-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    requires: [
                                        "fill-translate"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "fill-pattern": {
                                    type: "resolvedImage",
                                    transition: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "cross-faded-data-driven"
                                }
                            },
                            "paint_fill-extrusion": {
                                "fill-extrusion-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "fill-extrusion-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    requires: [
                                        {
                                            "!": "fill-extrusion-pattern"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "fill-extrusion-translate": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "fill-extrusion-translate-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    requires: [
                                        "fill-extrusion-translate"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "fill-extrusion-pattern": {
                                    type: "resolvedImage",
                                    transition: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "cross-faded-data-driven"
                                },
                                "fill-extrusion-height": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    units: "meters",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "fill-extrusion-base": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    units: "meters",
                                    transition: !0,
                                    requires: [
                                        "fill-extrusion-height"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "fill-extrusion-vertical-gradient": {
                                    type: "boolean",
                                    default: !0,
                                    transition: !1,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            paint_line: {
                                "line-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    requires: [
                                        {
                                            "!": "line-pattern"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-translate": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "line-translate-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    requires: [
                                        "line-translate"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "line-width": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-gap-width": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-offset": {
                                    type: "number",
                                    default: 0,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-blur": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-dasharray": {
                                    type: "array",
                                    value: "number",
                                    minimum: 0,
                                    transition: !0,
                                    units: "line widths",
                                    requires: [
                                        {
                                            "!": "line-pattern"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "cross-faded"
                                },
                                "line-pattern": {
                                    type: "resolvedImage",
                                    transition: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "cross-faded-data-driven"
                                },
                                "line-gradient": {
                                    type: "color",
                                    transition: !1,
                                    requires: [
                                        {
                                            "!": "line-dasharray"
                                        },
                                        {
                                            "!": "line-pattern"
                                        },
                                        {
                                            source: "geojson",
                                            has: {
                                                lineMetrics: !0
                                            }
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "line-progress"
                                        ]
                                    },
                                    "property-type": "color-ramp"
                                }
                            },
                            paint_circle: {
                                "circle-radius": {
                                    type: "number",
                                    default: 5,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "circle-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "circle-blur": {
                                    type: "number",
                                    default: 0,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "circle-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "circle-translate": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "circle-translate-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    requires: [
                                        "circle-translate"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "circle-pitch-scale": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "circle-pitch-alignment": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "viewport",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "circle-stroke-width": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "circle-stroke-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "circle-stroke-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                }
                            },
                            paint_heatmap: {
                                "heatmap-radius": {
                                    type: "number",
                                    default: 30,
                                    minimum: 1,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "heatmap-weight": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    transition: !1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "heatmap-intensity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "heatmap-color": {
                                    type: "color",
                                    default: [
                                        "interpolate",
                                        [
                                            "linear"
                                        ],
                                        [
                                            "heatmap-density"
                                        ],
                                        0,
                                        "rgba(0, 0, 255, 0)",
                                        .1,
                                        "royalblue",
                                        .3,
                                        "cyan",
                                        .5,
                                        "lime",
                                        .7,
                                        "yellow",
                                        1,
                                        "red"
                                    ],
                                    transition: !1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "heatmap-density"
                                        ]
                                    },
                                    "property-type": "color-ramp"
                                },
                                "heatmap-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            paint_symbol: {
                                "icon-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-halo-color": {
                                    type: "color",
                                    default: "rgba(0, 0, 0, 0)",
                                    transition: !0,
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-halo-width": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-halo-blur": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-translate": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    transition: !0,
                                    units: "pixels",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-translate-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    requires: [
                                        "icon-image",
                                        "icon-translate"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    overridable: !0,
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-halo-color": {
                                    type: "color",
                                    default: "rgba(0, 0, 0, 0)",
                                    transition: !0,
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-halo-width": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-halo-blur": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-translate": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    transition: !0,
                                    units: "pixels",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-translate-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    requires: [
                                        "text-field",
                                        "text-translate"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            paint_raster: {
                                "raster-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-hue-rotate": {
                                    type: "number",
                                    default: 0,
                                    period: 360,
                                    transition: !0,
                                    units: "degrees",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-brightness-min": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-brightness-max": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-saturation": {
                                    type: "number",
                                    default: 0,
                                    minimum: -1,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-contrast": {
                                    type: "number",
                                    default: 0,
                                    minimum: -1,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-resampling": {
                                    type: "enum",
                                    values: {
                                        linear: {},
                                        nearest: {}
                                    },
                                    default: "linear",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-fade-duration": {
                                    type: "number",
                                    default: 300,
                                    minimum: 0,
                                    transition: !1,
                                    units: "milliseconds",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            paint_hillshade: {
                                "hillshade-illumination-direction": {
                                    type: "number",
                                    default: 335,
                                    minimum: 0,
                                    maximum: 359,
                                    transition: !1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "hillshade-illumination-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "viewport",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "hillshade-exaggeration": {
                                    type: "number",
                                    default: .5,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "hillshade-shadow-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "hillshade-highlight-color": {
                                    type: "color",
                                    default: "#FFFFFF",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "hillshade-accent-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            paint_background: {
                                "background-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    requires: [
                                        {
                                            "!": "background-pattern"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "background-pattern": {
                                    type: "resolvedImage",
                                    transition: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "cross-faded"
                                },
                                "background-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            transition: {
                                duration: {
                                    type: "number",
                                    default: 300,
                                    minimum: 0,
                                    units: "milliseconds"
                                },
                                delay: {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    units: "milliseconds"
                                }
                            },
                            "property-type": {
                                "data-driven": {
                                    type: "property-type"
                                },
                                "cross-faded": {
                                    type: "property-type"
                                },
                                "cross-faded-data-driven": {
                                    type: "property-type"
                                },
                                "color-ramp": {
                                    type: "property-type"
                                },
                                "data-constant": {
                                    type: "property-type"
                                },
                                constant: {
                                    type: "property-type"
                                }
                            },
                            promoteId: {
                                "*": {
                                    type: "string"
                                }
                            }
                        }, Bt = function(t1, e1, r, n) {
                            this.message = (t1 ? t1 + ": " : "") + r, n && (this.identifier = n), null != e1 && e1.__line__ && (this.line = e1.__line__);
                        };
                        function Nt(t1) {
                            var e1 = t1.key, r = t1.value;
                            return r ? [
                                new Bt(e1, r, "constants have been deprecated as of v8")
                            ] : [];
                        }
                        function jt(t1) {
                            for(var e1 = [], r = arguments.length - 1; r-- > 0;)e1[r] = arguments[r + 1];
                            for(var n = 0, i = e1; n < i.length; n += 1){
                                var a = i[n];
                                for(var o in a)t1[o] = a[o];
                            }
                            return t1;
                        }
                        function Ut(t1) {
                            return t1 instanceof Number || t1 instanceof String || t1 instanceof Boolean ? t1.valueOf() : t1;
                        }
                        function Vt(t1) {
                            if (Array.isArray(t1)) return t1.map(Vt);
                            if (t1 instanceof Object && !(t1 instanceof Number || t1 instanceof String || t1 instanceof Boolean)) {
                                var e1 = {};
                                for(var r in t1)e1[r] = Vt(t1[r]);
                                return e1;
                            }
                            return Ut(t1);
                        }
                        var qt = function(t1) {
                            function e1(e1, r) {
                                t1.call(this, r), this.message = r, this.key = e1;
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1;
                        }(Error), Ht = function(t1, e1) {
                            void 0 === e1 && (e1 = []), this.parent = t1, this.bindings = {};
                            for(var r = 0, n = e1; r < n.length; r += 1){
                                var i = n[r], a = i[0], o = i[1];
                                this.bindings[a] = o;
                            }
                        };
                        Ht.prototype.concat = function(t1) {
                            return new Ht(this, t1);
                        }, Ht.prototype.get = function(t1) {
                            if (this.bindings[t1]) return this.bindings[t1];
                            if (this.parent) return this.parent.get(t1);
                            throw new Error(t1 + " not found in scope.");
                        }, Ht.prototype.has = function(t1) {
                            return !!this.bindings[t1] || !!this.parent && this.parent.has(t1);
                        };
                        var Gt = {
                            kind: "null"
                        }, Zt = {
                            kind: "number"
                        }, Wt = {
                            kind: "string"
                        }, Yt = {
                            kind: "boolean"
                        }, Xt = {
                            kind: "color"
                        }, $t = {
                            kind: "object"
                        }, Jt = {
                            kind: "value"
                        }, Kt = {
                            kind: "collator"
                        }, Qt = {
                            kind: "formatted"
                        }, te = {
                            kind: "resolvedImage"
                        };
                        function ee(t1, e1) {
                            return {
                                kind: "array",
                                itemType: t1,
                                N: e1
                            };
                        }
                        function re(t1) {
                            if ("array" === t1.kind) {
                                var e1 = re(t1.itemType);
                                return "number" == typeof t1.N ? "array<" + e1 + ", " + t1.N + ">" : "value" === t1.itemType.kind ? "array" : "array<" + e1 + ">";
                            }
                            return t1.kind;
                        }
                        var ne = [
                            Gt,
                            Zt,
                            Wt,
                            Yt,
                            Xt,
                            Qt,
                            $t,
                            ee(Jt),
                            te
                        ];
                        function ie(t1, e1) {
                            if ("error" === e1.kind) return null;
                            if ("array" === t1.kind) {
                                if ("array" === e1.kind && (0 === e1.N && "value" === e1.itemType.kind || !ie(t1.itemType, e1.itemType)) && ("number" != typeof t1.N || t1.N === e1.N)) return null;
                            } else {
                                if (t1.kind === e1.kind) return null;
                                if ("value" === t1.kind) {
                                    for(var r = 0, n = ne; r < n.length; r += 1)if (!ie(n[r], e1)) return null;
                                }
                            }
                            return "Expected " + re(t1) + " but found " + re(e1) + " instead.";
                        }
                        function ae(t1, e1) {
                            return e1.some(function(e1) {
                                return e1.kind === t1.kind;
                            });
                        }
                        function oe(t1, e1) {
                            return e1.some(function(e1) {
                                return "null" === e1 ? null === t1 : "array" === e1 ? Array.isArray(t1) : "object" === e1 ? t1 && !Array.isArray(t1) && "object" == typeof t1 : e1 === typeof t1;
                            });
                        }
                        var se = e1(function(t1, e1) {
                            var r = {
                                transparent: [
                                    0,
                                    0,
                                    0,
                                    0
                                ],
                                aliceblue: [
                                    240,
                                    248,
                                    255,
                                    1
                                ],
                                antiquewhite: [
                                    250,
                                    235,
                                    215,
                                    1
                                ],
                                aqua: [
                                    0,
                                    255,
                                    255,
                                    1
                                ],
                                aquamarine: [
                                    127,
                                    255,
                                    212,
                                    1
                                ],
                                azure: [
                                    240,
                                    255,
                                    255,
                                    1
                                ],
                                beige: [
                                    245,
                                    245,
                                    220,
                                    1
                                ],
                                bisque: [
                                    255,
                                    228,
                                    196,
                                    1
                                ],
                                black: [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                blanchedalmond: [
                                    255,
                                    235,
                                    205,
                                    1
                                ],
                                blue: [
                                    0,
                                    0,
                                    255,
                                    1
                                ],
                                blueviolet: [
                                    138,
                                    43,
                                    226,
                                    1
                                ],
                                brown: [
                                    165,
                                    42,
                                    42,
                                    1
                                ],
                                burlywood: [
                                    222,
                                    184,
                                    135,
                                    1
                                ],
                                cadetblue: [
                                    95,
                                    158,
                                    160,
                                    1
                                ],
                                chartreuse: [
                                    127,
                                    255,
                                    0,
                                    1
                                ],
                                chocolate: [
                                    210,
                                    105,
                                    30,
                                    1
                                ],
                                coral: [
                                    255,
                                    127,
                                    80,
                                    1
                                ],
                                cornflowerblue: [
                                    100,
                                    149,
                                    237,
                                    1
                                ],
                                cornsilk: [
                                    255,
                                    248,
                                    220,
                                    1
                                ],
                                crimson: [
                                    220,
                                    20,
                                    60,
                                    1
                                ],
                                cyan: [
                                    0,
                                    255,
                                    255,
                                    1
                                ],
                                darkblue: [
                                    0,
                                    0,
                                    139,
                                    1
                                ],
                                darkcyan: [
                                    0,
                                    139,
                                    139,
                                    1
                                ],
                                darkgoldenrod: [
                                    184,
                                    134,
                                    11,
                                    1
                                ],
                                darkgray: [
                                    169,
                                    169,
                                    169,
                                    1
                                ],
                                darkgreen: [
                                    0,
                                    100,
                                    0,
                                    1
                                ],
                                darkgrey: [
                                    169,
                                    169,
                                    169,
                                    1
                                ],
                                darkkhaki: [
                                    189,
                                    183,
                                    107,
                                    1
                                ],
                                darkmagenta: [
                                    139,
                                    0,
                                    139,
                                    1
                                ],
                                darkolivegreen: [
                                    85,
                                    107,
                                    47,
                                    1
                                ],
                                darkorange: [
                                    255,
                                    140,
                                    0,
                                    1
                                ],
                                darkorchid: [
                                    153,
                                    50,
                                    204,
                                    1
                                ],
                                darkred: [
                                    139,
                                    0,
                                    0,
                                    1
                                ],
                                darksalmon: [
                                    233,
                                    150,
                                    122,
                                    1
                                ],
                                darkseagreen: [
                                    143,
                                    188,
                                    143,
                                    1
                                ],
                                darkslateblue: [
                                    72,
                                    61,
                                    139,
                                    1
                                ],
                                darkslategray: [
                                    47,
                                    79,
                                    79,
                                    1
                                ],
                                darkslategrey: [
                                    47,
                                    79,
                                    79,
                                    1
                                ],
                                darkturquoise: [
                                    0,
                                    206,
                                    209,
                                    1
                                ],
                                darkviolet: [
                                    148,
                                    0,
                                    211,
                                    1
                                ],
                                deeppink: [
                                    255,
                                    20,
                                    147,
                                    1
                                ],
                                deepskyblue: [
                                    0,
                                    191,
                                    255,
                                    1
                                ],
                                dimgray: [
                                    105,
                                    105,
                                    105,
                                    1
                                ],
                                dimgrey: [
                                    105,
                                    105,
                                    105,
                                    1
                                ],
                                dodgerblue: [
                                    30,
                                    144,
                                    255,
                                    1
                                ],
                                firebrick: [
                                    178,
                                    34,
                                    34,
                                    1
                                ],
                                floralwhite: [
                                    255,
                                    250,
                                    240,
                                    1
                                ],
                                forestgreen: [
                                    34,
                                    139,
                                    34,
                                    1
                                ],
                                fuchsia: [
                                    255,
                                    0,
                                    255,
                                    1
                                ],
                                gainsboro: [
                                    220,
                                    220,
                                    220,
                                    1
                                ],
                                ghostwhite: [
                                    248,
                                    248,
                                    255,
                                    1
                                ],
                                gold: [
                                    255,
                                    215,
                                    0,
                                    1
                                ],
                                goldenrod: [
                                    218,
                                    165,
                                    32,
                                    1
                                ],
                                gray: [
                                    128,
                                    128,
                                    128,
                                    1
                                ],
                                green: [
                                    0,
                                    128,
                                    0,
                                    1
                                ],
                                greenyellow: [
                                    173,
                                    255,
                                    47,
                                    1
                                ],
                                grey: [
                                    128,
                                    128,
                                    128,
                                    1
                                ],
                                honeydew: [
                                    240,
                                    255,
                                    240,
                                    1
                                ],
                                hotpink: [
                                    255,
                                    105,
                                    180,
                                    1
                                ],
                                indianred: [
                                    205,
                                    92,
                                    92,
                                    1
                                ],
                                indigo: [
                                    75,
                                    0,
                                    130,
                                    1
                                ],
                                ivory: [
                                    255,
                                    255,
                                    240,
                                    1
                                ],
                                khaki: [
                                    240,
                                    230,
                                    140,
                                    1
                                ],
                                lavender: [
                                    230,
                                    230,
                                    250,
                                    1
                                ],
                                lavenderblush: [
                                    255,
                                    240,
                                    245,
                                    1
                                ],
                                lawngreen: [
                                    124,
                                    252,
                                    0,
                                    1
                                ],
                                lemonchiffon: [
                                    255,
                                    250,
                                    205,
                                    1
                                ],
                                lightblue: [
                                    173,
                                    216,
                                    230,
                                    1
                                ],
                                lightcoral: [
                                    240,
                                    128,
                                    128,
                                    1
                                ],
                                lightcyan: [
                                    224,
                                    255,
                                    255,
                                    1
                                ],
                                lightgoldenrodyellow: [
                                    250,
                                    250,
                                    210,
                                    1
                                ],
                                lightgray: [
                                    211,
                                    211,
                                    211,
                                    1
                                ],
                                lightgreen: [
                                    144,
                                    238,
                                    144,
                                    1
                                ],
                                lightgrey: [
                                    211,
                                    211,
                                    211,
                                    1
                                ],
                                lightpink: [
                                    255,
                                    182,
                                    193,
                                    1
                                ],
                                lightsalmon: [
                                    255,
                                    160,
                                    122,
                                    1
                                ],
                                lightseagreen: [
                                    32,
                                    178,
                                    170,
                                    1
                                ],
                                lightskyblue: [
                                    135,
                                    206,
                                    250,
                                    1
                                ],
                                lightslategray: [
                                    119,
                                    136,
                                    153,
                                    1
                                ],
                                lightslategrey: [
                                    119,
                                    136,
                                    153,
                                    1
                                ],
                                lightsteelblue: [
                                    176,
                                    196,
                                    222,
                                    1
                                ],
                                lightyellow: [
                                    255,
                                    255,
                                    224,
                                    1
                                ],
                                lime: [
                                    0,
                                    255,
                                    0,
                                    1
                                ],
                                limegreen: [
                                    50,
                                    205,
                                    50,
                                    1
                                ],
                                linen: [
                                    250,
                                    240,
                                    230,
                                    1
                                ],
                                magenta: [
                                    255,
                                    0,
                                    255,
                                    1
                                ],
                                maroon: [
                                    128,
                                    0,
                                    0,
                                    1
                                ],
                                mediumaquamarine: [
                                    102,
                                    205,
                                    170,
                                    1
                                ],
                                mediumblue: [
                                    0,
                                    0,
                                    205,
                                    1
                                ],
                                mediumorchid: [
                                    186,
                                    85,
                                    211,
                                    1
                                ],
                                mediumpurple: [
                                    147,
                                    112,
                                    219,
                                    1
                                ],
                                mediumseagreen: [
                                    60,
                                    179,
                                    113,
                                    1
                                ],
                                mediumslateblue: [
                                    123,
                                    104,
                                    238,
                                    1
                                ],
                                mediumspringgreen: [
                                    0,
                                    250,
                                    154,
                                    1
                                ],
                                mediumturquoise: [
                                    72,
                                    209,
                                    204,
                                    1
                                ],
                                mediumvioletred: [
                                    199,
                                    21,
                                    133,
                                    1
                                ],
                                midnightblue: [
                                    25,
                                    25,
                                    112,
                                    1
                                ],
                                mintcream: [
                                    245,
                                    255,
                                    250,
                                    1
                                ],
                                mistyrose: [
                                    255,
                                    228,
                                    225,
                                    1
                                ],
                                moccasin: [
                                    255,
                                    228,
                                    181,
                                    1
                                ],
                                navajowhite: [
                                    255,
                                    222,
                                    173,
                                    1
                                ],
                                navy: [
                                    0,
                                    0,
                                    128,
                                    1
                                ],
                                oldlace: [
                                    253,
                                    245,
                                    230,
                                    1
                                ],
                                olive: [
                                    128,
                                    128,
                                    0,
                                    1
                                ],
                                olivedrab: [
                                    107,
                                    142,
                                    35,
                                    1
                                ],
                                orange: [
                                    255,
                                    165,
                                    0,
                                    1
                                ],
                                orangered: [
                                    255,
                                    69,
                                    0,
                                    1
                                ],
                                orchid: [
                                    218,
                                    112,
                                    214,
                                    1
                                ],
                                palegoldenrod: [
                                    238,
                                    232,
                                    170,
                                    1
                                ],
                                palegreen: [
                                    152,
                                    251,
                                    152,
                                    1
                                ],
                                paleturquoise: [
                                    175,
                                    238,
                                    238,
                                    1
                                ],
                                palevioletred: [
                                    219,
                                    112,
                                    147,
                                    1
                                ],
                                papayawhip: [
                                    255,
                                    239,
                                    213,
                                    1
                                ],
                                peachpuff: [
                                    255,
                                    218,
                                    185,
                                    1
                                ],
                                peru: [
                                    205,
                                    133,
                                    63,
                                    1
                                ],
                                pink: [
                                    255,
                                    192,
                                    203,
                                    1
                                ],
                                plum: [
                                    221,
                                    160,
                                    221,
                                    1
                                ],
                                powderblue: [
                                    176,
                                    224,
                                    230,
                                    1
                                ],
                                purple: [
                                    128,
                                    0,
                                    128,
                                    1
                                ],
                                rebeccapurple: [
                                    102,
                                    51,
                                    153,
                                    1
                                ],
                                red: [
                                    255,
                                    0,
                                    0,
                                    1
                                ],
                                rosybrown: [
                                    188,
                                    143,
                                    143,
                                    1
                                ],
                                royalblue: [
                                    65,
                                    105,
                                    225,
                                    1
                                ],
                                saddlebrown: [
                                    139,
                                    69,
                                    19,
                                    1
                                ],
                                salmon: [
                                    250,
                                    128,
                                    114,
                                    1
                                ],
                                sandybrown: [
                                    244,
                                    164,
                                    96,
                                    1
                                ],
                                seagreen: [
                                    46,
                                    139,
                                    87,
                                    1
                                ],
                                seashell: [
                                    255,
                                    245,
                                    238,
                                    1
                                ],
                                sienna: [
                                    160,
                                    82,
                                    45,
                                    1
                                ],
                                silver: [
                                    192,
                                    192,
                                    192,
                                    1
                                ],
                                skyblue: [
                                    135,
                                    206,
                                    235,
                                    1
                                ],
                                slateblue: [
                                    106,
                                    90,
                                    205,
                                    1
                                ],
                                slategray: [
                                    112,
                                    128,
                                    144,
                                    1
                                ],
                                slategrey: [
                                    112,
                                    128,
                                    144,
                                    1
                                ],
                                snow: [
                                    255,
                                    250,
                                    250,
                                    1
                                ],
                                springgreen: [
                                    0,
                                    255,
                                    127,
                                    1
                                ],
                                steelblue: [
                                    70,
                                    130,
                                    180,
                                    1
                                ],
                                tan: [
                                    210,
                                    180,
                                    140,
                                    1
                                ],
                                teal: [
                                    0,
                                    128,
                                    128,
                                    1
                                ],
                                thistle: [
                                    216,
                                    191,
                                    216,
                                    1
                                ],
                                tomato: [
                                    255,
                                    99,
                                    71,
                                    1
                                ],
                                turquoise: [
                                    64,
                                    224,
                                    208,
                                    1
                                ],
                                violet: [
                                    238,
                                    130,
                                    238,
                                    1
                                ],
                                wheat: [
                                    245,
                                    222,
                                    179,
                                    1
                                ],
                                white: [
                                    255,
                                    255,
                                    255,
                                    1
                                ],
                                whitesmoke: [
                                    245,
                                    245,
                                    245,
                                    1
                                ],
                                yellow: [
                                    255,
                                    255,
                                    0,
                                    1
                                ],
                                yellowgreen: [
                                    154,
                                    205,
                                    50,
                                    1
                                ]
                            };
                            function n(t1) {
                                return (t1 = Math.round(t1)) < 0 ? 0 : t1 > 255 ? 255 : t1;
                            }
                            function i(t1) {
                                return t1 < 0 ? 0 : t1 > 1 ? 1 : t1;
                            }
                            function a(t1) {
                                return "%" === t1[t1.length - 1] ? n(parseFloat(t1) / 100 * 255) : n(parseInt(t1));
                            }
                            function o(t1) {
                                return "%" === t1[t1.length - 1] ? i(parseFloat(t1) / 100) : i(parseFloat(t1));
                            }
                            function s(t1, e1, r) {
                                return r < 0 ? r += 1 : r > 1 && (r -= 1), 6 * r < 1 ? t1 + (e1 - t1) * r * 6 : 2 * r < 1 ? e1 : 3 * r < 2 ? t1 + (e1 - t1) * (2 / 3 - r) * 6 : t1;
                            }
                            try {
                                e1.parseCSSColor = function(t1) {
                                    var e1, i = t1.replace(/ /g, "").toLowerCase();
                                    if (i in r) return r[i].slice();
                                    if ("#" === i[0]) return 4 === i.length ? (e1 = parseInt(i.substr(1), 16)) >= 0 && e1 <= 4095 ? [
                                        (3840 & e1) >> 4 | (3840 & e1) >> 8,
                                        240 & e1 | (240 & e1) >> 4,
                                        15 & e1 | (15 & e1) << 4,
                                        1
                                    ] : null : 7 === i.length && (e1 = parseInt(i.substr(1), 16)) >= 0 && e1 <= 16777215 ? [
                                        (16711680 & e1) >> 16,
                                        (65280 & e1) >> 8,
                                        255 & e1,
                                        1
                                    ] : null;
                                    var l = i.indexOf("("), c = i.indexOf(")");
                                    if (-1 !== l && c + 1 === i.length) {
                                        var u = i.substr(0, l), h = i.substr(l + 1, c - (l + 1)).split(","), f = 1;
                                        switch(u){
                                            case "rgba":
                                                if (4 !== h.length) return null;
                                                f = o(h.pop());
                                            case "rgb":
                                                return 3 !== h.length ? null : [
                                                    a(h[0]),
                                                    a(h[1]),
                                                    a(h[2]),
                                                    f
                                                ];
                                            case "hsla":
                                                if (4 !== h.length) return null;
                                                f = o(h.pop());
                                            case "hsl":
                                                if (3 !== h.length) return null;
                                                var p = (parseFloat(h[0]) % 360 + 360) % 360 / 360, d = o(h[1]), m = o(h[2]), g = m <= .5 ? m * (d + 1) : m + d - m * d, y = 2 * m - g;
                                                return [
                                                    n(255 * s(y, g, p + 1 / 3)),
                                                    n(255 * s(y, g, p)),
                                                    n(255 * s(y, g, p - 1 / 3)),
                                                    f
                                                ];
                                            default:
                                                return null;
                                        }
                                    }
                                    return null;
                                };
                            } catch (t1) {}
                        }), le = se.parseCSSColor, ce = function(t1, e1, r, n) {
                            void 0 === n && (n = 1), this.r = t1, this.g = e1, this.b = r, this.a = n;
                        };
                        ce.parse = function(t1) {
                            if (t1) {
                                if (t1 instanceof ce) return t1;
                                if ("string" == typeof t1) {
                                    var e1 = le(t1);
                                    if (e1) return new ce(e1[0] / 255 * e1[3], e1[1] / 255 * e1[3], e1[2] / 255 * e1[3], e1[3]);
                                }
                            }
                        }, ce.prototype.toString = function() {
                            var t1 = this.toArray(), e1 = t1[0], r = t1[1], n = t1[2], i = t1[3];
                            return "rgba(" + Math.round(e1) + "," + Math.round(r) + "," + Math.round(n) + "," + i + ")";
                        }, ce.prototype.toArray = function() {
                            var t1 = this, e1 = t1.r, r = t1.g, n = t1.b, i = t1.a;
                            return 0 === i ? [
                                0,
                                0,
                                0,
                                0
                            ] : [
                                255 * e1 / i,
                                255 * r / i,
                                255 * n / i,
                                i
                            ];
                        }, ce.black = new ce(0, 0, 0, 1), ce.white = new ce(1, 1, 1, 1), ce.transparent = new ce(0, 0, 0, 0), ce.red = new ce(1, 0, 0, 1);
                        var ue = function(t1, e1, r) {
                            this.sensitivity = t1 ? e1 ? "variant" : "case" : e1 ? "accent" : "base", this.locale = r, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                                sensitivity: this.sensitivity,
                                usage: "search"
                            });
                        };
                        ue.prototype.compare = function(t1, e1) {
                            return this.collator.compare(t1, e1);
                        }, ue.prototype.resolvedLocale = function() {
                            return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
                        };
                        var he = function(t1, e1, r, n, i) {
                            this.text = t1, this.image = e1, this.scale = r, this.fontStack = n, this.textColor = i;
                        }, fe = function(t1) {
                            this.sections = t1;
                        };
                        fe.fromString = function(t1) {
                            return new fe([
                                new he(t1, null, null, null, null)
                            ]);
                        }, fe.prototype.isEmpty = function() {
                            return 0 === this.sections.length || !this.sections.some(function(t1) {
                                return 0 !== t1.text.length || t1.image && 0 !== t1.image.name.length;
                            });
                        }, fe.factory = function(t1) {
                            return t1 instanceof fe ? t1 : fe.fromString(t1);
                        }, fe.prototype.toString = function() {
                            return 0 === this.sections.length ? "" : this.sections.map(function(t1) {
                                return t1.text;
                            }).join("");
                        }, fe.prototype.serialize = function() {
                            for(var t1 = [
                                "format"
                            ], e1 = 0, r = this.sections; e1 < r.length; e1 += 1){
                                var n = r[e1];
                                if (n.image) t1.push([
                                    "image",
                                    n.image.name
                                ]);
                                else {
                                    t1.push(n.text);
                                    var i = {};
                                    n.fontStack && (i["text-font"] = [
                                        "literal",
                                        n.fontStack.split(",")
                                    ]), n.scale && (i["font-scale"] = n.scale), n.textColor && (i["text-color"] = [
                                        "rgba"
                                    ].concat(n.textColor.toArray())), t1.push(i);
                                }
                            }
                            return t1;
                        };
                        var pe = function(t1) {
                            this.name = t1.name, this.available = t1.available;
                        };
                        function de(t1, e1, r, n) {
                            return "number" == typeof t1 && t1 >= 0 && t1 <= 255 && "number" == typeof e1 && e1 >= 0 && e1 <= 255 && "number" == typeof r && r >= 0 && r <= 255 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : "Invalid rgba value [" + [
                                t1,
                                e1,
                                r,
                                n
                            ].join(", ") + "]: 'a' must be between 0 and 1." : "Invalid rgba value [" + ("number" == typeof n ? [
                                t1,
                                e1,
                                r,
                                n
                            ] : [
                                t1,
                                e1,
                                r
                            ]).join(", ") + "]: 'r', 'g', and 'b' must be between 0 and 255.";
                        }
                        function me(t1) {
                            if (null === t1) return !0;
                            if ("string" == typeof t1) return !0;
                            if ("boolean" == typeof t1) return !0;
                            if ("number" == typeof t1) return !0;
                            if (t1 instanceof ce) return !0;
                            if (t1 instanceof ue) return !0;
                            if (t1 instanceof fe) return !0;
                            if (t1 instanceof pe) return !0;
                            if (Array.isArray(t1)) {
                                for(var e1 = 0, r = t1; e1 < r.length; e1 += 1)if (!me(r[e1])) return !1;
                                return !0;
                            }
                            if ("object" == typeof t1) {
                                for(var n in t1)if (!me(t1[n])) return !1;
                                return !0;
                            }
                            return !1;
                        }
                        function ge(t1) {
                            if (null === t1) return Gt;
                            if ("string" == typeof t1) return Wt;
                            if ("boolean" == typeof t1) return Yt;
                            if ("number" == typeof t1) return Zt;
                            if (t1 instanceof ce) return Xt;
                            if (t1 instanceof ue) return Kt;
                            if (t1 instanceof fe) return Qt;
                            if (t1 instanceof pe) return te;
                            if (Array.isArray(t1)) {
                                for(var e1, r = t1.length, n = 0, i = t1; n < i.length; n += 1){
                                    var a = ge(i[n]);
                                    if (e1) {
                                        if (e1 === a) continue;
                                        e1 = Jt;
                                        break;
                                    }
                                    e1 = a;
                                }
                                return ee(e1 || Jt, r);
                            }
                            return $t;
                        }
                        function ye(t1) {
                            var e1 = typeof t1;
                            return null === t1 ? "" : "string" === e1 || "number" === e1 || "boolean" === e1 ? String(t1) : t1 instanceof ce || t1 instanceof fe || t1 instanceof pe ? t1.toString() : JSON.stringify(t1);
                        }
                        pe.prototype.toString = function() {
                            return this.name;
                        }, pe.fromString = function(t1) {
                            return t1 ? new pe({
                                name: t1,
                                available: !1
                            }) : null;
                        }, pe.prototype.serialize = function() {
                            return [
                                "image",
                                this.name
                            ];
                        };
                        var ve = function(t1, e1) {
                            this.type = t1, this.value = e1;
                        };
                        ve.parse = function(t1, e1) {
                            if (2 !== t1.length) return e1.error("'literal' expression requires exactly one argument, but found " + (t1.length - 1) + " instead.");
                            if (!me(t1[1])) return e1.error("invalid value");
                            var r = t1[1], n = ge(r), i = e1.expectedType;
                            return "array" !== n.kind || 0 !== n.N || !i || "array" !== i.kind || "number" == typeof i.N && 0 !== i.N || (n = i), new ve(n, r);
                        }, ve.prototype.evaluate = function() {
                            return this.value;
                        }, ve.prototype.eachChild = function() {}, ve.prototype.outputDefined = function() {
                            return !0;
                        }, ve.prototype.serialize = function() {
                            return "array" === this.type.kind || "object" === this.type.kind ? [
                                "literal",
                                this.value
                            ] : this.value instanceof ce ? [
                                "rgba"
                            ].concat(this.value.toArray()) : this.value instanceof fe ? this.value.serialize() : this.value;
                        };
                        var xe = function(t1) {
                            this.name = "ExpressionEvaluationError", this.message = t1;
                        };
                        xe.prototype.toJSON = function() {
                            return this.message;
                        };
                        var _e = {
                            string: Wt,
                            number: Zt,
                            boolean: Yt,
                            object: $t
                        }, be = function(t1, e1) {
                            this.type = t1, this.args = e1;
                        };
                        be.parse = function(t1, e1) {
                            if (t1.length < 2) return e1.error("Expected at least one argument.");
                            var r, n = 1, i = t1[0];
                            if ("array" === i) {
                                var a, o;
                                if (t1.length > 2) {
                                    var s = t1[1];
                                    if ("string" != typeof s || !(s in _e) || "object" === s) return e1.error('The item type argument of "array" must be one of string, number, boolean', 1);
                                    a = _e[s], n++;
                                } else a = Jt;
                                if (t1.length > 3) {
                                    if (null !== t1[2] && ("number" != typeof t1[2] || t1[2] < 0 || t1[2] !== Math.floor(t1[2]))) return e1.error('The length argument to "array" must be a positive integer literal', 2);
                                    o = t1[2], n++;
                                }
                                r = ee(a, o);
                            } else r = _e[i];
                            for(var l = []; n < t1.length; n++){
                                var c = e1.parse(t1[n], n, Jt);
                                if (!c) return null;
                                l.push(c);
                            }
                            return new be(r, l);
                        }, be.prototype.evaluate = function(t1) {
                            for(var e1 = 0; e1 < this.args.length; e1++){
                                var r = this.args[e1].evaluate(t1);
                                if (!ie(this.type, ge(r))) return r;
                                if (e1 === this.args.length - 1) throw new xe("Expected value to be of type " + re(this.type) + ", but found " + re(ge(r)) + " instead.");
                            }
                            return null;
                        }, be.prototype.eachChild = function(t1) {
                            this.args.forEach(t1);
                        }, be.prototype.outputDefined = function() {
                            return this.args.every(function(t1) {
                                return t1.outputDefined();
                            });
                        }, be.prototype.serialize = function() {
                            var t1 = this.type, e1 = [
                                t1.kind
                            ];
                            if ("array" === t1.kind) {
                                var r = t1.itemType;
                                if ("string" === r.kind || "number" === r.kind || "boolean" === r.kind) {
                                    e1.push(r.kind);
                                    var n = t1.N;
                                    ("number" == typeof n || this.args.length > 1) && e1.push(n);
                                }
                            }
                            return e1.concat(this.args.map(function(t1) {
                                return t1.serialize();
                            }));
                        };
                        var we = function(t1) {
                            this.type = Qt, this.sections = t1;
                        };
                        we.parse = function(t1, e1) {
                            if (t1.length < 2) return e1.error("Expected at least one argument.");
                            var r = t1[1];
                            if (!Array.isArray(r) && "object" == typeof r) return e1.error("First argument must be an image or text section.");
                            for(var n = [], i = !1, a = 1; a <= t1.length - 1; ++a){
                                var o = t1[a];
                                if (i && "object" == typeof o && !Array.isArray(o)) {
                                    i = !1;
                                    var s = null;
                                    if (o["font-scale"] && !(s = e1.parse(o["font-scale"], 1, Zt))) return null;
                                    var l = null;
                                    if (o["text-font"] && !(l = e1.parse(o["text-font"], 1, ee(Wt)))) return null;
                                    var c = null;
                                    if (o["text-color"] && !(c = e1.parse(o["text-color"], 1, Xt))) return null;
                                    var u = n[n.length - 1];
                                    u.scale = s, u.font = l, u.textColor = c;
                                } else {
                                    var h = e1.parse(t1[a], 1, Jt);
                                    if (!h) return null;
                                    var f = h.type.kind;
                                    if ("string" !== f && "value" !== f && "null" !== f && "resolvedImage" !== f) return e1.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                                    i = !0, n.push({
                                        content: h,
                                        scale: null,
                                        font: null,
                                        textColor: null
                                    });
                                }
                            }
                            return new we(n);
                        }, we.prototype.evaluate = function(t1) {
                            return new fe(this.sections.map(function(e1) {
                                var r = e1.content.evaluate(t1);
                                return ge(r) === te ? new he("", r, null, null, null) : new he(ye(r), null, e1.scale ? e1.scale.evaluate(t1) : null, e1.font ? e1.font.evaluate(t1).join(",") : null, e1.textColor ? e1.textColor.evaluate(t1) : null);
                            }));
                        }, we.prototype.eachChild = function(t1) {
                            for(var e1 = 0, r = this.sections; e1 < r.length; e1 += 1){
                                var n = r[e1];
                                t1(n.content), n.scale && t1(n.scale), n.font && t1(n.font), n.textColor && t1(n.textColor);
                            }
                        }, we.prototype.outputDefined = function() {
                            return !1;
                        }, we.prototype.serialize = function() {
                            for(var t1 = [
                                "format"
                            ], e1 = 0, r = this.sections; e1 < r.length; e1 += 1){
                                var n = r[e1];
                                t1.push(n.content.serialize());
                                var i = {};
                                n.scale && (i["font-scale"] = n.scale.serialize()), n.font && (i["text-font"] = n.font.serialize()), n.textColor && (i["text-color"] = n.textColor.serialize()), t1.push(i);
                            }
                            return t1;
                        };
                        var Te = function(t1) {
                            this.type = te, this.input = t1;
                        };
                        Te.parse = function(t1, e1) {
                            if (2 !== t1.length) return e1.error("Expected two arguments.");
                            var r = e1.parse(t1[1], 1, Wt);
                            return r ? new Te(r) : e1.error("No image name provided.");
                        }, Te.prototype.evaluate = function(t1) {
                            var e1 = this.input.evaluate(t1), r = pe.fromString(e1);
                            return r && t1.availableImages && (r.available = t1.availableImages.indexOf(e1) > -1), r;
                        }, Te.prototype.eachChild = function(t1) {
                            t1(this.input);
                        }, Te.prototype.outputDefined = function() {
                            return !1;
                        }, Te.prototype.serialize = function() {
                            return [
                                "image",
                                this.input.serialize()
                            ];
                        };
                        var ke = {
                            "to-boolean": Yt,
                            "to-color": Xt,
                            "to-number": Zt,
                            "to-string": Wt
                        }, Ae = function(t1, e1) {
                            this.type = t1, this.args = e1;
                        };
                        Ae.parse = function(t1, e1) {
                            if (t1.length < 2) return e1.error("Expected at least one argument.");
                            var r = t1[0];
                            if (("to-boolean" === r || "to-string" === r) && 2 !== t1.length) return e1.error("Expected one argument.");
                            for(var n = ke[r], i = [], a = 1; a < t1.length; a++){
                                var o = e1.parse(t1[a], a, Jt);
                                if (!o) return null;
                                i.push(o);
                            }
                            return new Ae(n, i);
                        }, Ae.prototype.evaluate = function(t1) {
                            if ("boolean" === this.type.kind) return Boolean(this.args[0].evaluate(t1));
                            if ("color" === this.type.kind) {
                                for(var e1, r, n = 0, i = this.args; n < i.length; n += 1){
                                    if (r = null, (e1 = i[n].evaluate(t1)) instanceof ce) return e1;
                                    if ("string" == typeof e1) {
                                        var a = t1.parseColor(e1);
                                        if (a) return a;
                                    } else if (Array.isArray(e1) && !(r = e1.length < 3 || e1.length > 4 ? "Invalid rbga value " + JSON.stringify(e1) + ": expected an array containing either three or four numeric values." : de(e1[0], e1[1], e1[2], e1[3]))) return new ce(e1[0] / 255, e1[1] / 255, e1[2] / 255, e1[3]);
                                }
                                throw new xe(r || "Could not parse color from value '" + ("string" == typeof e1 ? e1 : String(JSON.stringify(e1))) + "'");
                            }
                            if ("number" === this.type.kind) {
                                for(var o = null, s = 0, l = this.args; s < l.length; s += 1){
                                    if (null === (o = l[s].evaluate(t1))) return 0;
                                    var c = Number(o);
                                    if (!isNaN(c)) return c;
                                }
                                throw new xe("Could not convert " + JSON.stringify(o) + " to number.");
                            }
                            return "formatted" === this.type.kind ? fe.fromString(ye(this.args[0].evaluate(t1))) : "resolvedImage" === this.type.kind ? pe.fromString(ye(this.args[0].evaluate(t1))) : ye(this.args[0].evaluate(t1));
                        }, Ae.prototype.eachChild = function(t1) {
                            this.args.forEach(t1);
                        }, Ae.prototype.outputDefined = function() {
                            return this.args.every(function(t1) {
                                return t1.outputDefined();
                            });
                        }, Ae.prototype.serialize = function() {
                            if ("formatted" === this.type.kind) return new we([
                                {
                                    content: this.args[0],
                                    scale: null,
                                    font: null,
                                    textColor: null
                                }
                            ]).serialize();
                            if ("resolvedImage" === this.type.kind) return new Te(this.args[0]).serialize();
                            var t1 = [
                                "to-" + this.type.kind
                            ];
                            return this.eachChild(function(e1) {
                                t1.push(e1.serialize());
                            }), t1;
                        };
                        var Me = [
                            "Unknown",
                            "Point",
                            "LineString",
                            "Polygon"
                        ], Se = function() {
                            this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null;
                        };
                        Se.prototype.id = function() {
                            return this.feature && "id" in this.feature ? this.feature.id : null;
                        }, Se.prototype.geometryType = function() {
                            return this.feature ? "number" == typeof this.feature.type ? Me[this.feature.type] : this.feature.type : null;
                        }, Se.prototype.geometry = function() {
                            return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
                        }, Se.prototype.canonicalID = function() {
                            return this.canonical;
                        }, Se.prototype.properties = function() {
                            return this.feature && this.feature.properties || {};
                        }, Se.prototype.parseColor = function(t1) {
                            var e1 = this._parseColorCache[t1];
                            return e1 || (e1 = this._parseColorCache[t1] = ce.parse(t1)), e1;
                        };
                        var Ee = function(t1, e1, r, n) {
                            this.name = t1, this.type = e1, this._evaluate = r, this.args = n;
                        };
                        Ee.prototype.evaluate = function(t1) {
                            return this._evaluate(t1, this.args);
                        }, Ee.prototype.eachChild = function(t1) {
                            this.args.forEach(t1);
                        }, Ee.prototype.outputDefined = function() {
                            return !1;
                        }, Ee.prototype.serialize = function() {
                            return [
                                this.name
                            ].concat(this.args.map(function(t1) {
                                return t1.serialize();
                            }));
                        }, Ee.parse = function(t1, e1) {
                            var r, n = t1[0], i = Ee.definitions[n];
                            if (!i) return e1.error('Unknown expression "' + n + '". If you wanted a literal array, use ["literal", [...]].', 0);
                            for(var a = Array.isArray(i) ? i[0] : i.type, o = Array.isArray(i) ? [
                                [
                                    i[1],
                                    i[2]
                                ]
                            ] : i.overloads, s = o.filter(function(e1) {
                                var r = e1[0];
                                return !Array.isArray(r) || r.length === t1.length - 1;
                            }), l = null, c = 0, u = s; c < u.length; c += 1){
                                var h = u[c], f = h[0], p = h[1];
                                l = new Je(e1.registry, e1.path, null, e1.scope);
                                for(var d = [], m = !1, g = 1; g < t1.length; g++){
                                    var y = t1[g], v = Array.isArray(f) ? f[g - 1] : f.type, x = l.parse(y, 1 + d.length, v);
                                    if (!x) {
                                        m = !0;
                                        break;
                                    }
                                    d.push(x);
                                }
                                if (!m) {
                                    if (Array.isArray(f) && f.length !== d.length) l.error("Expected " + f.length + " arguments, but found " + d.length + " instead.");
                                    else {
                                        for(var _ = 0; _ < d.length; _++){
                                            var b = Array.isArray(f) ? f[_] : f.type, w = d[_];
                                            l.concat(_ + 1).checkSubtype(b, w.type);
                                        }
                                        if (0 === l.errors.length) return new Ee(n, a, p, d);
                                    }
                                }
                            }
                            if (1 === s.length) (r = e1.errors).push.apply(r, l.errors);
                            else {
                                for(var T = (s.length ? s : o).map(function(t1) {
                                    var e1;
                                    return e1 = t1[0], Array.isArray(e1) ? "(" + e1.map(re).join(", ") + ")" : "(" + re(e1.type) + "...)";
                                }).join(" | "), k = [], A = 1; A < t1.length; A++){
                                    var M = e1.parse(t1[A], 1 + k.length);
                                    if (!M) return null;
                                    k.push(re(M.type));
                                }
                                e1.error("Expected arguments of type " + T + ", but found (" + k.join(", ") + ") instead.");
                            }
                            return null;
                        }, Ee.register = function(t1, e1) {
                            for(var r in Ee.definitions = e1, e1)t1[r] = Ee;
                        };
                        var Ce = function(t1, e1, r) {
                            this.type = Kt, this.locale = r, this.caseSensitive = t1, this.diacriticSensitive = e1;
                        };
                        Ce.parse = function(t1, e1) {
                            if (2 !== t1.length) return e1.error("Expected one argument.");
                            var r = t1[1];
                            if ("object" != typeof r || Array.isArray(r)) return e1.error("Collator options argument must be an object.");
                            var n = e1.parse(void 0 !== r["case-sensitive"] && r["case-sensitive"], 1, Yt);
                            if (!n) return null;
                            var i = e1.parse(void 0 !== r["diacritic-sensitive"] && r["diacritic-sensitive"], 1, Yt);
                            if (!i) return null;
                            var a = null;
                            return r.locale && !(a = e1.parse(r.locale, 1, Wt)) ? null : new Ce(n, i, a);
                        }, Ce.prototype.evaluate = function(t1) {
                            return new ue(this.caseSensitive.evaluate(t1), this.diacriticSensitive.evaluate(t1), this.locale ? this.locale.evaluate(t1) : null);
                        }, Ce.prototype.eachChild = function(t1) {
                            t1(this.caseSensitive), t1(this.diacriticSensitive), this.locale && t1(this.locale);
                        }, Ce.prototype.outputDefined = function() {
                            return !1;
                        }, Ce.prototype.serialize = function() {
                            var t1 = {};
                            return t1["case-sensitive"] = this.caseSensitive.serialize(), t1["diacritic-sensitive"] = this.diacriticSensitive.serialize(), this.locale && (t1.locale = this.locale.serialize()), [
                                "collator",
                                t1
                            ];
                        };
                        var Le = 8192;
                        function Ie(t1, e1) {
                            t1[0] = Math.min(t1[0], e1[0]), t1[1] = Math.min(t1[1], e1[1]), t1[2] = Math.max(t1[2], e1[0]), t1[3] = Math.max(t1[3], e1[1]);
                        }
                        function Pe(t1, e1) {
                            return !(t1[0] <= e1[0] || t1[2] >= e1[2] || t1[1] <= e1[1] || t1[3] >= e1[3]);
                        }
                        function ze(t1, e1) {
                            var r, n = (180 + t1[0]) / 360, i = (r = t1[1], (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + r * Math.PI / 360))) / 360), a = Math.pow(2, e1.z);
                            return [
                                Math.round(n * a * Le),
                                Math.round(i * a * Le)
                            ];
                        }
                        function Oe(t1, e1, r) {
                            return e1[1] > t1[1] != r[1] > t1[1] && t1[0] < (r[0] - e1[0]) * (t1[1] - e1[1]) / (r[1] - e1[1]) + e1[0];
                        }
                        function De(t1, e1) {
                            for(var r = !1, n = 0, i = e1.length; n < i; n++)for(var a = e1[n], o = 0, s = a.length; o < s - 1; o++){
                                if (l = t1, c = a[o], u = a[o + 1], h = void 0, f = void 0, p = void 0, d = void 0, h = l[0] - c[0], f = l[1] - c[1], p = l[0] - u[0], d = l[1] - u[1], h * d - p * f == 0 && h * p <= 0 && f * d <= 0) return !1;
                                Oe(t1, a[o], a[o + 1]) && (r = !r);
                            }
                            var l, c, u, h, f, p, d;
                            return r;
                        }
                        function Re(t1, e1) {
                            for(var r = 0; r < e1.length; r++)if (De(t1, e1[r])) return !0;
                            return !1;
                        }
                        function Fe(t1, e1, r, n) {
                            var i = t1[0] - r[0], a = t1[1] - r[1], o = e1[0] - r[0], s = e1[1] - r[1], l = n[0] - r[0], c = n[1] - r[1], u = i * c - l * a, h = o * c - l * s;
                            return u > 0 && h < 0 || u < 0 && h > 0;
                        }
                        function Be(t1, e1, r) {
                            for(var n = 0, i = r; n < i.length; n += 1)for(var a = i[n], o = 0; o < a.length - 1; ++o)if (s = t1, l = e1, c = a[o], u = a[o + 1], h = void 0, f = void 0, p = void 0, p = [
                                l[0] - s[0],
                                l[1] - s[1]
                            ], 0 != (h = [
                                u[0] - c[0],
                                u[1] - c[1]
                            ], f = p, h[0] * f[1] - h[1] * f[0]) && Fe(s, l, c, u) && Fe(c, u, s, l)) return !0;
                            var s, l, c, u, h, f, p;
                            return !1;
                        }
                        function Ne(t1, e1) {
                            for(var r = 0; r < t1.length; ++r)if (!De(t1[r], e1)) return !1;
                            for(var n = 0; n < t1.length - 1; ++n)if (Be(t1[n], t1[n + 1], e1)) return !1;
                            return !0;
                        }
                        function je(t1, e1) {
                            for(var r = 0; r < e1.length; r++)if (Ne(t1, e1[r])) return !0;
                            return !1;
                        }
                        function Ue(t1, e1, r) {
                            for(var n = [], i = 0; i < t1.length; i++){
                                for(var a = [], o = 0; o < t1[i].length; o++){
                                    var s = ze(t1[i][o], r);
                                    Ie(e1, s), a.push(s);
                                }
                                n.push(a);
                            }
                            return n;
                        }
                        function Ve(t1, e1, r) {
                            for(var n = [], i = 0; i < t1.length; i++){
                                var a = Ue(t1[i], e1, r);
                                n.push(a);
                            }
                            return n;
                        }
                        function qe(t1, e1, r, n) {
                            if (t1[0] < r[0] || t1[0] > r[2]) {
                                var i = .5 * n, a = t1[0] - r[0] > i ? -n : r[0] - t1[0] > i ? n : 0;
                                0 === a && (a = t1[0] - r[2] > i ? -n : r[2] - t1[0] > i ? n : 0), t1[0] += a;
                            }
                            Ie(e1, t1);
                        }
                        function He(t1, e1, r, n) {
                            for(var i = Math.pow(2, n.z) * Le, a = [
                                n.x * Le,
                                n.y * Le
                            ], o = [], s = 0, l = t1; s < l.length; s += 1)for(var c = 0, u = l[s]; c < u.length; c += 1){
                                var h = u[c], f = [
                                    h.x + a[0],
                                    h.y + a[1]
                                ];
                                qe(f, e1, r, i), o.push(f);
                            }
                            return o;
                        }
                        function Ge(t1, e1, r, n) {
                            for(var i = Math.pow(2, n.z) * Le, a = [
                                n.x * Le,
                                n.y * Le
                            ], o = [], s = 0, l = t1; s < l.length; s += 1){
                                for(var c = [], u = 0, h = l[s]; u < h.length; u += 1){
                                    var f = h[u], p = [
                                        f.x + a[0],
                                        f.y + a[1]
                                    ];
                                    Ie(e1, p), c.push(p);
                                }
                                o.push(c);
                            }
                            if (e1[2] - e1[0] <= i / 2) {
                                (v = e1)[0] = v[1] = 1 / 0, v[2] = v[3] = -1 / 0;
                                for(var d = 0, m = o; d < m.length; d += 1)for(var g = 0, y = m[d]; g < y.length; g += 1)qe(y[g], e1, r, i);
                            }
                            var v;
                            return o;
                        }
                        var Ze = function(t1, e1) {
                            this.type = Yt, this.geojson = t1, this.geometries = e1;
                        };
                        function We(t1) {
                            if (t1 instanceof Ee) {
                                if ("get" === t1.name && 1 === t1.args.length) return !1;
                                if ("feature-state" === t1.name) return !1;
                                if ("has" === t1.name && 1 === t1.args.length) return !1;
                                if ("properties" === t1.name || "geometry-type" === t1.name || "id" === t1.name) return !1;
                                if (/^filter-/.test(t1.name)) return !1;
                            }
                            if (t1 instanceof Ze) return !1;
                            var e1 = !0;
                            return t1.eachChild(function(t1) {
                                e1 && !We(t1) && (e1 = !1);
                            }), e1;
                        }
                        function Ye(t1) {
                            if (t1 instanceof Ee && "feature-state" === t1.name) return !1;
                            var e1 = !0;
                            return t1.eachChild(function(t1) {
                                e1 && !Ye(t1) && (e1 = !1);
                            }), e1;
                        }
                        function Xe(t1, e1) {
                            if (t1 instanceof Ee && e1.indexOf(t1.name) >= 0) return !1;
                            var r = !0;
                            return t1.eachChild(function(t1) {
                                r && !Xe(t1, e1) && (r = !1);
                            }), r;
                        }
                        Ze.parse = function(t1, e1) {
                            if (2 !== t1.length) return e1.error("'within' expression requires exactly one argument, but found " + (t1.length - 1) + " instead.");
                            if (me(t1[1])) {
                                var r = t1[1];
                                if ("FeatureCollection" === r.type) for(var n = 0; n < r.features.length; ++n){
                                    var i = r.features[n].geometry.type;
                                    if ("Polygon" === i || "MultiPolygon" === i) return new Ze(r, r.features[n].geometry);
                                }
                                else if ("Feature" === r.type) {
                                    var a = r.geometry.type;
                                    if ("Polygon" === a || "MultiPolygon" === a) return new Ze(r, r.geometry);
                                } else if ("Polygon" === r.type || "MultiPolygon" === r.type) return new Ze(r, r);
                            }
                            return e1.error("'within' expression requires valid geojson object that contains polygon geometry type.");
                        }, Ze.prototype.evaluate = function(t1) {
                            if (null != t1.geometry() && null != t1.canonicalID()) {
                                if ("Point" === t1.geometryType()) return function(t1, e1) {
                                    var r = [
                                        1 / 0,
                                        1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ], n = [
                                        1 / 0,
                                        1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ], i = t1.canonicalID();
                                    if ("Polygon" === e1.type) {
                                        var a = Ue(e1.coordinates, n, i), o = He(t1.geometry(), r, n, i);
                                        if (!Pe(r, n)) return !1;
                                        for(var s = 0, l = o; s < l.length; s += 1)if (!De(l[s], a)) return !1;
                                    }
                                    if ("MultiPolygon" === e1.type) {
                                        var c = Ve(e1.coordinates, n, i), u = He(t1.geometry(), r, n, i);
                                        if (!Pe(r, n)) return !1;
                                        for(var h = 0, f = u; h < f.length; h += 1)if (!Re(f[h], c)) return !1;
                                    }
                                    return !0;
                                }(t1, this.geometries);
                                if ("LineString" === t1.geometryType()) return function(t1, e1) {
                                    var r = [
                                        1 / 0,
                                        1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ], n = [
                                        1 / 0,
                                        1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ], i = t1.canonicalID();
                                    if ("Polygon" === e1.type) {
                                        var a = Ue(e1.coordinates, n, i), o = Ge(t1.geometry(), r, n, i);
                                        if (!Pe(r, n)) return !1;
                                        for(var s = 0, l = o; s < l.length; s += 1)if (!Ne(l[s], a)) return !1;
                                    }
                                    if ("MultiPolygon" === e1.type) {
                                        var c = Ve(e1.coordinates, n, i), u = Ge(t1.geometry(), r, n, i);
                                        if (!Pe(r, n)) return !1;
                                        for(var h = 0, f = u; h < f.length; h += 1)if (!je(f[h], c)) return !1;
                                    }
                                    return !0;
                                }(t1, this.geometries);
                            }
                            return !1;
                        }, Ze.prototype.eachChild = function() {}, Ze.prototype.outputDefined = function() {
                            return !0;
                        }, Ze.prototype.serialize = function() {
                            return [
                                "within",
                                this.geojson
                            ];
                        };
                        var $e = function(t1, e1) {
                            this.type = e1.type, this.name = t1, this.boundExpression = e1;
                        };
                        $e.parse = function(t1, e1) {
                            if (2 !== t1.length || "string" != typeof t1[1]) return e1.error("'var' expression requires exactly one string literal argument.");
                            var r = t1[1];
                            return e1.scope.has(r) ? new $e(r, e1.scope.get(r)) : e1.error('Unknown variable "' + r + '". Make sure "' + r + '" has been bound in an enclosing "let" expression before using it.', 1);
                        }, $e.prototype.evaluate = function(t1) {
                            return this.boundExpression.evaluate(t1);
                        }, $e.prototype.eachChild = function() {}, $e.prototype.outputDefined = function() {
                            return !1;
                        }, $e.prototype.serialize = function() {
                            return [
                                "var",
                                this.name
                            ];
                        };
                        var Je = function(t1, e1, r, n, i) {
                            void 0 === e1 && (e1 = []), void 0 === n && (n = new Ht), void 0 === i && (i = []), this.registry = t1, this.path = e1, this.key = e1.map(function(t1) {
                                return "[" + t1 + "]";
                            }).join(""), this.scope = n, this.errors = i, this.expectedType = r;
                        };
                        function Ke(t1) {
                            if (t1 instanceof $e) return Ke(t1.boundExpression);
                            if (t1 instanceof Ee && "error" === t1.name) return !1;
                            if (t1 instanceof Ce) return !1;
                            if (t1 instanceof Ze) return !1;
                            var e1 = t1 instanceof Ae || t1 instanceof be, r = !0;
                            return t1.eachChild(function(t1) {
                                r = e1 ? r && Ke(t1) : r && t1 instanceof ve;
                            }), !!r && We(t1) && Xe(t1, [
                                "zoom",
                                "heatmap-density",
                                "line-progress",
                                "accumulated",
                                "is-supported-script"
                            ]);
                        }
                        function Qe(t1, e1) {
                            for(var r, n, i = t1.length - 1, a = 0, o = i, s = 0; a <= o;)if (r = t1[s = Math.floor((a + o) / 2)], n = t1[s + 1], r <= e1) {
                                if (s === i || e1 < n) return s;
                                a = s + 1;
                            } else {
                                if (!(r > e1)) throw new xe("Input is not a number.");
                                o = s - 1;
                            }
                            return 0;
                        }
                        Je.prototype.parse = function(t1, e1, r, n, i) {
                            return void 0 === i && (i = {}), e1 ? this.concat(e1, r, n)._parse(t1, i) : this._parse(t1, i);
                        }, Je.prototype._parse = function(t1, e1) {
                            function r(t1, e1, r) {
                                return "assert" === r ? new be(e1, [
                                    t1
                                ]) : "coerce" === r ? new Ae(e1, [
                                    t1
                                ]) : t1;
                            }
                            if (null !== t1 && "string" != typeof t1 && "boolean" != typeof t1 && "number" != typeof t1 || (t1 = [
                                "literal",
                                t1
                            ]), Array.isArray(t1)) {
                                if (0 === t1.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                                var n = t1[0];
                                if ("string" != typeof n) return this.error("Expression name must be a string, but found " + typeof n + ' instead. If you wanted a literal array, use ["literal", [...]].', 0), null;
                                var i = this.registry[n];
                                if (i) {
                                    var a = i.parse(t1, this);
                                    if (!a) return null;
                                    if (this.expectedType) {
                                        var o = this.expectedType, s = a.type;
                                        if ("string" !== o.kind && "number" !== o.kind && "boolean" !== o.kind && "object" !== o.kind && "array" !== o.kind || "value" !== s.kind) {
                                            if ("color" !== o.kind && "formatted" !== o.kind && "resolvedImage" !== o.kind || "value" !== s.kind && "string" !== s.kind) {
                                                if (this.checkSubtype(o, s)) return null;
                                            } else a = r(a, o, e1.typeAnnotation || "coerce");
                                        } else a = r(a, o, e1.typeAnnotation || "assert");
                                    }
                                    if (!(a instanceof ve) && "resolvedImage" !== a.type.kind && Ke(a)) {
                                        var l = new Se;
                                        try {
                                            a = new ve(a.type, a.evaluate(l));
                                        } catch (t1) {
                                            return this.error(t1.message), null;
                                        }
                                    }
                                    return a;
                                }
                                return this.error('Unknown expression "' + n + '". If you wanted a literal array, use ["literal", [...]].', 0);
                            }
                            return void 0 === t1 ? this.error("'undefined' value invalid. Use null instead.") : "object" == typeof t1 ? this.error('Bare objects invalid. Use ["literal", {...}] instead.') : this.error("Expected an array, but found " + typeof t1 + " instead.");
                        }, Je.prototype.concat = function(t1, e1, r) {
                            var n = "number" == typeof t1 ? this.path.concat(t1) : this.path, i = r ? this.scope.concat(r) : this.scope;
                            return new Je(this.registry, n, e1 || null, i, this.errors);
                        }, Je.prototype.error = function(t1) {
                            for(var e1 = [], r = arguments.length - 1; r-- > 0;)e1[r] = arguments[r + 1];
                            var n = "" + this.key + e1.map(function(t1) {
                                return "[" + t1 + "]";
                            }).join("");
                            this.errors.push(new qt(n, t1));
                        }, Je.prototype.checkSubtype = function(t1, e1) {
                            var r = ie(t1, e1);
                            return r && this.error(r), r;
                        };
                        var tr = function(t1, e1, r) {
                            this.type = t1, this.input = e1, this.labels = [], this.outputs = [];
                            for(var n = 0, i = r; n < i.length; n += 1){
                                var a = i[n], o = a[0], s = a[1];
                                this.labels.push(o), this.outputs.push(s);
                            }
                        };
                        function er(t1, e1, r) {
                            return t1 * (1 - r) + e1 * r;
                        }
                        tr.parse = function(t1, e1) {
                            if (t1.length - 1 < 4) return e1.error("Expected at least 4 arguments, but found only " + (t1.length - 1) + ".");
                            if ((t1.length - 1) % 2 != 0) return e1.error("Expected an even number of arguments.");
                            var r = e1.parse(t1[1], 1, Zt);
                            if (!r) return null;
                            var n = [], i = null;
                            e1.expectedType && "value" !== e1.expectedType.kind && (i = e1.expectedType);
                            for(var a = 1; a < t1.length; a += 2){
                                var o = 1 === a ? -1 / 0 : t1[a], s = t1[a + 1], l = a, c = a + 1;
                                if ("number" != typeof o) return e1.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', l);
                                if (n.length && n[n.length - 1][0] >= o) return e1.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', l);
                                var u = e1.parse(s, c, i);
                                if (!u) return null;
                                i = i || u.type, n.push([
                                    o,
                                    u
                                ]);
                            }
                            return new tr(i, r, n);
                        }, tr.prototype.evaluate = function(t1) {
                            var e1 = this.labels, r = this.outputs;
                            if (1 === e1.length) return r[0].evaluate(t1);
                            var n = this.input.evaluate(t1);
                            if (n <= e1[0]) return r[0].evaluate(t1);
                            var i = e1.length;
                            return n >= e1[i - 1] ? r[i - 1].evaluate(t1) : r[Qe(e1, n)].evaluate(t1);
                        }, tr.prototype.eachChild = function(t1) {
                            t1(this.input);
                            for(var e1 = 0, r = this.outputs; e1 < r.length; e1 += 1)t1(r[e1]);
                        }, tr.prototype.outputDefined = function() {
                            return this.outputs.every(function(t1) {
                                return t1.outputDefined();
                            });
                        }, tr.prototype.serialize = function() {
                            for(var t1 = [
                                "step",
                                this.input.serialize()
                            ], e1 = 0; e1 < this.labels.length; e1++)e1 > 0 && t1.push(this.labels[e1]), t1.push(this.outputs[e1].serialize());
                            return t1;
                        };
                        var rr = Object.freeze({
                            __proto__: null,
                            number: er,
                            color: function(t1, e1, r) {
                                return new ce(er(t1.r, e1.r, r), er(t1.g, e1.g, r), er(t1.b, e1.b, r), er(t1.a, e1.a, r));
                            },
                            array: function(t1, e1, r) {
                                return t1.map(function(t1, n) {
                                    return er(t1, e1[n], r);
                                });
                            }
                        }), nr = .95047, ir = 1, ar = 1.08883, or = 4 / 29, sr = 6 / 29, lr = 3 * sr * sr, cr = sr * sr * sr, ur = Math.PI / 180, hr = 180 / Math.PI;
                        function fr(t1) {
                            return t1 > cr ? Math.pow(t1, 1 / 3) : t1 / lr + or;
                        }
                        function pr(t1) {
                            return t1 > sr ? t1 * t1 * t1 : lr * (t1 - or);
                        }
                        function dr(t1) {
                            return 255 * (t1 <= .0031308 ? 12.92 * t1 : 1.055 * Math.pow(t1, 1 / 2.4) - .055);
                        }
                        function mr(t1) {
                            return (t1 /= 255) <= .04045 ? t1 / 12.92 : Math.pow((t1 + .055) / 1.055, 2.4);
                        }
                        function gr(t1) {
                            var e1 = mr(t1.r), r = mr(t1.g), n = mr(t1.b), i = fr((.4124564 * e1 + .3575761 * r + .1804375 * n) / nr), a = fr((.2126729 * e1 + .7151522 * r + .072175 * n) / ir);
                            return {
                                l: 116 * a - 16,
                                a: 500 * (i - a),
                                b: 200 * (a - fr((.0193339 * e1 + .119192 * r + .9503041 * n) / ar)),
                                alpha: t1.a
                            };
                        }
                        function yr(t1) {
                            var e1 = (t1.l + 16) / 116, r = isNaN(t1.a) ? e1 : e1 + t1.a / 500, n = isNaN(t1.b) ? e1 : e1 - t1.b / 200;
                            return e1 = ir * pr(e1), r = nr * pr(r), n = ar * pr(n), new ce(dr(3.2404542 * r - 1.5371385 * e1 - .4985314 * n), dr(-0.969266 * r + 1.8760108 * e1 + .041556 * n), dr(.0556434 * r - .2040259 * e1 + 1.0572252 * n), t1.alpha);
                        }
                        function vr(t1, e1, r) {
                            var n = e1 - t1;
                            return t1 + r * (n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n);
                        }
                        var xr = {
                            forward: gr,
                            reverse: yr,
                            interpolate: function(t1, e1, r) {
                                return {
                                    l: er(t1.l, e1.l, r),
                                    a: er(t1.a, e1.a, r),
                                    b: er(t1.b, e1.b, r),
                                    alpha: er(t1.alpha, e1.alpha, r)
                                };
                            }
                        }, _r = {
                            forward: function(t1) {
                                var e1 = gr(t1), r = e1.l, n = e1.a, i = e1.b, a = Math.atan2(i, n) * hr;
                                return {
                                    h: a < 0 ? a + 360 : a,
                                    c: Math.sqrt(n * n + i * i),
                                    l: r,
                                    alpha: t1.a
                                };
                            },
                            reverse: function(t1) {
                                var e1 = t1.h * ur, r = t1.c;
                                return yr({
                                    l: t1.l,
                                    a: Math.cos(e1) * r,
                                    b: Math.sin(e1) * r,
                                    alpha: t1.alpha
                                });
                            },
                            interpolate: function(t1, e1, r) {
                                return {
                                    h: vr(t1.h, e1.h, r),
                                    c: er(t1.c, e1.c, r),
                                    l: er(t1.l, e1.l, r),
                                    alpha: er(t1.alpha, e1.alpha, r)
                                };
                            }
                        }, br = Object.freeze({
                            __proto__: null,
                            lab: xr,
                            hcl: _r
                        }), wr = function(t1, e1, r, n, i) {
                            this.type = t1, this.operator = e1, this.interpolation = r, this.input = n, this.labels = [], this.outputs = [];
                            for(var a = 0, o = i; a < o.length; a += 1){
                                var s = o[a], l = s[0], c = s[1];
                                this.labels.push(l), this.outputs.push(c);
                            }
                        };
                        function Tr(t1, e1, r, n) {
                            var i = n - r, a = t1 - r;
                            return 0 === i ? 0 : 1 === e1 ? a / i : (Math.pow(e1, a) - 1) / (Math.pow(e1, i) - 1);
                        }
                        wr.interpolationFactor = function(t1, e1, r, i) {
                            var a = 0;
                            if ("exponential" === t1.name) a = Tr(e1, t1.base, r, i);
                            else if ("linear" === t1.name) a = Tr(e1, 1, r, i);
                            else if ("cubic-bezier" === t1.name) {
                                var o = t1.controlPoints;
                                a = new n(o[0], o[1], o[2], o[3]).solve(Tr(e1, 1, r, i));
                            }
                            return a;
                        }, wr.parse = function(t1, e1) {
                            var r = t1[0], n = t1[1], i = t1[2], a = t1.slice(3);
                            if (!Array.isArray(n) || 0 === n.length) return e1.error("Expected an interpolation type expression.", 1);
                            if ("linear" === n[0]) n = {
                                name: "linear"
                            };
                            else if ("exponential" === n[0]) {
                                var o = n[1];
                                if ("number" != typeof o) return e1.error("Exponential interpolation requires a numeric base.", 1, 1);
                                n = {
                                    name: "exponential",
                                    base: o
                                };
                            } else {
                                if ("cubic-bezier" !== n[0]) return e1.error("Unknown interpolation type " + String(n[0]), 1, 0);
                                var s = n.slice(1);
                                if (4 !== s.length || s.some(function(t1) {
                                    return "number" != typeof t1 || t1 < 0 || t1 > 1;
                                })) return e1.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                                n = {
                                    name: "cubic-bezier",
                                    controlPoints: s
                                };
                            }
                            if (t1.length - 1 < 4) return e1.error("Expected at least 4 arguments, but found only " + (t1.length - 1) + ".");
                            if ((t1.length - 1) % 2 != 0) return e1.error("Expected an even number of arguments.");
                            if (!(i = e1.parse(i, 2, Zt))) return null;
                            var l = [], c = null;
                            "interpolate-hcl" === r || "interpolate-lab" === r ? c = Xt : e1.expectedType && "value" !== e1.expectedType.kind && (c = e1.expectedType);
                            for(var u = 0; u < a.length; u += 2){
                                var h = a[u], f = a[u + 1], p = u + 3, d = u + 4;
                                if ("number" != typeof h) return e1.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', p);
                                if (l.length && l[l.length - 1][0] >= h) return e1.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', p);
                                var m = e1.parse(f, d, c);
                                if (!m) return null;
                                c = c || m.type, l.push([
                                    h,
                                    m
                                ]);
                            }
                            return "number" === c.kind || "color" === c.kind || "array" === c.kind && "number" === c.itemType.kind && "number" == typeof c.N ? new wr(c, r, n, i, l) : e1.error("Type " + re(c) + " is not interpolatable.");
                        }, wr.prototype.evaluate = function(t1) {
                            var e1 = this.labels, r = this.outputs;
                            if (1 === e1.length) return r[0].evaluate(t1);
                            var n = this.input.evaluate(t1);
                            if (n <= e1[0]) return r[0].evaluate(t1);
                            var i = e1.length;
                            if (n >= e1[i - 1]) return r[i - 1].evaluate(t1);
                            var a = Qe(e1, n), o = e1[a], s = e1[a + 1], l = wr.interpolationFactor(this.interpolation, n, o, s), c = r[a].evaluate(t1), u = r[a + 1].evaluate(t1);
                            return "interpolate" === this.operator ? rr[this.type.kind.toLowerCase()](c, u, l) : "interpolate-hcl" === this.operator ? _r.reverse(_r.interpolate(_r.forward(c), _r.forward(u), l)) : xr.reverse(xr.interpolate(xr.forward(c), xr.forward(u), l));
                        }, wr.prototype.eachChild = function(t1) {
                            t1(this.input);
                            for(var e1 = 0, r = this.outputs; e1 < r.length; e1 += 1)t1(r[e1]);
                        }, wr.prototype.outputDefined = function() {
                            return this.outputs.every(function(t1) {
                                return t1.outputDefined();
                            });
                        }, wr.prototype.serialize = function() {
                            var t1;
                            t1 = "linear" === this.interpolation.name ? [
                                "linear"
                            ] : "exponential" === this.interpolation.name ? 1 === this.interpolation.base ? [
                                "linear"
                            ] : [
                                "exponential",
                                this.interpolation.base
                            ] : [
                                "cubic-bezier"
                            ].concat(this.interpolation.controlPoints);
                            for(var e1 = [
                                this.operator,
                                t1,
                                this.input.serialize()
                            ], r = 0; r < this.labels.length; r++)e1.push(this.labels[r], this.outputs[r].serialize());
                            return e1;
                        };
                        var kr = function(t1, e1) {
                            this.type = t1, this.args = e1;
                        };
                        kr.parse = function(t1, e1) {
                            if (t1.length < 2) return e1.error("Expectected at least one argument.");
                            var r = null, n = e1.expectedType;
                            n && "value" !== n.kind && (r = n);
                            for(var i = [], a = 0, o = t1.slice(1); a < o.length; a += 1){
                                var s = o[a], l = e1.parse(s, 1 + i.length, r, void 0, {
                                    typeAnnotation: "omit"
                                });
                                if (!l) return null;
                                r = r || l.type, i.push(l);
                            }
                            var c = n && i.some(function(t1) {
                                return ie(n, t1.type);
                            });
                            return new kr(c ? Jt : r, i);
                        }, kr.prototype.evaluate = function(t1) {
                            for(var e1, r = null, n = 0, i = 0, a = this.args; i < a.length && (n++, (r = a[i].evaluate(t1)) && r instanceof pe && !r.available && (e1 || (e1 = r.name), r = null, n === this.args.length && (r = e1)), null === r); i += 1);
                            return r;
                        }, kr.prototype.eachChild = function(t1) {
                            this.args.forEach(t1);
                        }, kr.prototype.outputDefined = function() {
                            return this.args.every(function(t1) {
                                return t1.outputDefined();
                            });
                        }, kr.prototype.serialize = function() {
                            var t1 = [
                                "coalesce"
                            ];
                            return this.eachChild(function(e1) {
                                t1.push(e1.serialize());
                            }), t1;
                        };
                        var Ar = function(t1, e1) {
                            this.type = e1.type, this.bindings = [].concat(t1), this.result = e1;
                        };
                        Ar.prototype.evaluate = function(t1) {
                            return this.result.evaluate(t1);
                        }, Ar.prototype.eachChild = function(t1) {
                            for(var e1 = 0, r = this.bindings; e1 < r.length; e1 += 1)t1(r[e1][1]);
                            t1(this.result);
                        }, Ar.parse = function(t1, e1) {
                            if (t1.length < 4) return e1.error("Expected at least 3 arguments, but found " + (t1.length - 1) + " instead.");
                            for(var r = [], n = 1; n < t1.length - 1; n += 2){
                                var i = t1[n];
                                if ("string" != typeof i) return e1.error("Expected string, but found " + typeof i + " instead.", n);
                                if (/[^a-zA-Z0-9_]/.test(i)) return e1.error("Variable names must contain only alphanumeric characters or '_'.", n);
                                var a = e1.parse(t1[n + 1], n + 1);
                                if (!a) return null;
                                r.push([
                                    i,
                                    a
                                ]);
                            }
                            var o = e1.parse(t1[t1.length - 1], t1.length - 1, e1.expectedType, r);
                            return o ? new Ar(r, o) : null;
                        }, Ar.prototype.outputDefined = function() {
                            return this.result.outputDefined();
                        }, Ar.prototype.serialize = function() {
                            for(var t1 = [
                                "let"
                            ], e1 = 0, r = this.bindings; e1 < r.length; e1 += 1){
                                var n = r[e1], i = n[0], a = n[1];
                                t1.push(i, a.serialize());
                            }
                            return t1.push(this.result.serialize()), t1;
                        };
                        var Mr = function(t1, e1, r) {
                            this.type = t1, this.index = e1, this.input = r;
                        };
                        Mr.parse = function(t1, e1) {
                            if (3 !== t1.length) return e1.error("Expected 2 arguments, but found " + (t1.length - 1) + " instead.");
                            var r = e1.parse(t1[1], 1, Zt), n = e1.parse(t1[2], 2, ee(e1.expectedType || Jt));
                            if (!r || !n) return null;
                            var i = n.type;
                            return new Mr(i.itemType, r, n);
                        }, Mr.prototype.evaluate = function(t1) {
                            var e1 = this.index.evaluate(t1), r = this.input.evaluate(t1);
                            if (e1 < 0) throw new xe("Array index out of bounds: " + e1 + " < 0.");
                            if (e1 >= r.length) throw new xe("Array index out of bounds: " + e1 + " > " + (r.length - 1) + ".");
                            if (e1 !== Math.floor(e1)) throw new xe("Array index must be an integer, but found " + e1 + " instead.");
                            return r[e1];
                        }, Mr.prototype.eachChild = function(t1) {
                            t1(this.index), t1(this.input);
                        }, Mr.prototype.outputDefined = function() {
                            return !1;
                        }, Mr.prototype.serialize = function() {
                            return [
                                "at",
                                this.index.serialize(),
                                this.input.serialize()
                            ];
                        };
                        var Sr = function(t1, e1) {
                            this.type = Yt, this.needle = t1, this.haystack = e1;
                        };
                        Sr.parse = function(t1, e1) {
                            if (3 !== t1.length) return e1.error("Expected 2 arguments, but found " + (t1.length - 1) + " instead.");
                            var r = e1.parse(t1[1], 1, Jt), n = e1.parse(t1[2], 2, Jt);
                            return r && n ? ae(r.type, [
                                Yt,
                                Wt,
                                Zt,
                                Gt,
                                Jt
                            ]) ? new Sr(r, n) : e1.error("Expected first argument to be of type boolean, string, number or null, but found " + re(r.type) + " instead") : null;
                        }, Sr.prototype.evaluate = function(t1) {
                            var e1 = this.needle.evaluate(t1), r = this.haystack.evaluate(t1);
                            if (!r) return !1;
                            if (!oe(e1, [
                                "boolean",
                                "string",
                                "number",
                                "null"
                            ])) throw new xe("Expected first argument to be of type boolean, string, number or null, but found " + re(ge(e1)) + " instead.");
                            if (!oe(r, [
                                "string",
                                "array"
                            ])) throw new xe("Expected second argument to be of type array or string, but found " + re(ge(r)) + " instead.");
                            return r.indexOf(e1) >= 0;
                        }, Sr.prototype.eachChild = function(t1) {
                            t1(this.needle), t1(this.haystack);
                        }, Sr.prototype.outputDefined = function() {
                            return !0;
                        }, Sr.prototype.serialize = function() {
                            return [
                                "in",
                                this.needle.serialize(),
                                this.haystack.serialize()
                            ];
                        };
                        var Er = function(t1, e1, r) {
                            this.type = Zt, this.needle = t1, this.haystack = e1, this.fromIndex = r;
                        };
                        Er.parse = function(t1, e1) {
                            if (t1.length <= 2 || t1.length >= 5) return e1.error("Expected 3 or 4 arguments, but found " + (t1.length - 1) + " instead.");
                            var r = e1.parse(t1[1], 1, Jt), n = e1.parse(t1[2], 2, Jt);
                            if (!r || !n) return null;
                            if (!ae(r.type, [
                                Yt,
                                Wt,
                                Zt,
                                Gt,
                                Jt
                            ])) return e1.error("Expected first argument to be of type boolean, string, number or null, but found " + re(r.type) + " instead");
                            if (4 === t1.length) {
                                var i = e1.parse(t1[3], 3, Zt);
                                return i ? new Er(r, n, i) : null;
                            }
                            return new Er(r, n);
                        }, Er.prototype.evaluate = function(t1) {
                            var e1 = this.needle.evaluate(t1), r = this.haystack.evaluate(t1);
                            if (!oe(e1, [
                                "boolean",
                                "string",
                                "number",
                                "null"
                            ])) throw new xe("Expected first argument to be of type boolean, string, number or null, but found " + re(ge(e1)) + " instead.");
                            if (!oe(r, [
                                "string",
                                "array"
                            ])) throw new xe("Expected second argument to be of type array or string, but found " + re(ge(r)) + " instead.");
                            if (this.fromIndex) {
                                var n = this.fromIndex.evaluate(t1);
                                return r.indexOf(e1, n);
                            }
                            return r.indexOf(e1);
                        }, Er.prototype.eachChild = function(t1) {
                            t1(this.needle), t1(this.haystack), this.fromIndex && t1(this.fromIndex);
                        }, Er.prototype.outputDefined = function() {
                            return !1;
                        }, Er.prototype.serialize = function() {
                            if (null != this.fromIndex && void 0 !== this.fromIndex) {
                                var t1 = this.fromIndex.serialize();
                                return [
                                    "index-of",
                                    this.needle.serialize(),
                                    this.haystack.serialize(),
                                    t1
                                ];
                            }
                            return [
                                "index-of",
                                this.needle.serialize(),
                                this.haystack.serialize()
                            ];
                        };
                        var Cr = function(t1, e1, r, n, i, a) {
                            this.inputType = t1, this.type = e1, this.input = r, this.cases = n, this.outputs = i, this.otherwise = a;
                        };
                        Cr.parse = function(t1, e1) {
                            if (t1.length < 5) return e1.error("Expected at least 4 arguments, but found only " + (t1.length - 1) + ".");
                            if (t1.length % 2 != 1) return e1.error("Expected an even number of arguments.");
                            var r, n;
                            e1.expectedType && "value" !== e1.expectedType.kind && (n = e1.expectedType);
                            for(var i = {}, a = [], o = 2; o < t1.length - 1; o += 2){
                                var s = t1[o], l = t1[o + 1];
                                Array.isArray(s) || (s = [
                                    s
                                ]);
                                var c = e1.concat(o);
                                if (0 === s.length) return c.error("Expected at least one branch label.");
                                for(var u = 0, h = s; u < h.length; u += 1){
                                    var f = h[u];
                                    if ("number" != typeof f && "string" != typeof f) return c.error("Branch labels must be numbers or strings.");
                                    if ("number" == typeof f && Math.abs(f) > Number.MAX_SAFE_INTEGER) return c.error("Branch labels must be integers no larger than " + Number.MAX_SAFE_INTEGER + ".");
                                    if ("number" == typeof f && Math.floor(f) !== f) return c.error("Numeric branch labels must be integer values.");
                                    if (r) {
                                        if (c.checkSubtype(r, ge(f))) return null;
                                    } else r = ge(f);
                                    if (void 0 !== i[String(f)]) return c.error("Branch labels must be unique.");
                                    i[String(f)] = a.length;
                                }
                                var p = e1.parse(l, o, n);
                                if (!p) return null;
                                n = n || p.type, a.push(p);
                            }
                            var d = e1.parse(t1[1], 1, Jt);
                            if (!d) return null;
                            var m = e1.parse(t1[t1.length - 1], t1.length - 1, n);
                            return m ? "value" !== d.type.kind && e1.concat(1).checkSubtype(r, d.type) ? null : new Cr(r, n, d, i, a, m) : null;
                        }, Cr.prototype.evaluate = function(t1) {
                            var e1 = this.input.evaluate(t1);
                            return (ge(e1) === this.inputType && this.outputs[this.cases[e1]] || this.otherwise).evaluate(t1);
                        }, Cr.prototype.eachChild = function(t1) {
                            t1(this.input), this.outputs.forEach(t1), t1(this.otherwise);
                        }, Cr.prototype.outputDefined = function() {
                            return this.outputs.every(function(t1) {
                                return t1.outputDefined();
                            }) && this.otherwise.outputDefined();
                        }, Cr.prototype.serialize = function() {
                            for(var t1 = this, e1 = [
                                "match",
                                this.input.serialize()
                            ], r = [], n = {}, i = 0, a = Object.keys(this.cases).sort(); i < a.length; i += 1){
                                var o = a[i];
                                void 0 === (h = n[this.cases[o]]) ? (n[this.cases[o]] = r.length, r.push([
                                    this.cases[o],
                                    [
                                        o
                                    ]
                                ])) : r[h][1].push(o);
                            }
                            for(var s = function(e1) {
                                return "number" === t1.inputType.kind ? Number(e1) : e1;
                            }, l = 0, c = r; l < c.length; l += 1){
                                var u = c[l], h = u[0], f = u[1];
                                1 === f.length ? e1.push(s(f[0])) : e1.push(f.map(s)), e1.push(this.outputs[outputIndex$1].serialize());
                            }
                            return e1.push(this.otherwise.serialize()), e1;
                        };
                        var Lr = function(t1, e1, r) {
                            this.type = t1, this.branches = e1, this.otherwise = r;
                        };
                        Lr.parse = function(t1, e1) {
                            if (t1.length < 4) return e1.error("Expected at least 3 arguments, but found only " + (t1.length - 1) + ".");
                            if (t1.length % 2 != 0) return e1.error("Expected an odd number of arguments.");
                            var r;
                            e1.expectedType && "value" !== e1.expectedType.kind && (r = e1.expectedType);
                            for(var n = [], i = 1; i < t1.length - 1; i += 2){
                                var a = e1.parse(t1[i], i, Yt);
                                if (!a) return null;
                                var o = e1.parse(t1[i + 1], i + 1, r);
                                if (!o) return null;
                                n.push([
                                    a,
                                    o
                                ]), r = r || o.type;
                            }
                            var s = e1.parse(t1[t1.length - 1], t1.length - 1, r);
                            return s ? new Lr(r, n, s) : null;
                        }, Lr.prototype.evaluate = function(t1) {
                            for(var e1 = 0, r = this.branches; e1 < r.length; e1 += 1){
                                var n = r[e1], i = n[0], a = n[1];
                                if (i.evaluate(t1)) return a.evaluate(t1);
                            }
                            return this.otherwise.evaluate(t1);
                        }, Lr.prototype.eachChild = function(t1) {
                            for(var e1 = 0, r = this.branches; e1 < r.length; e1 += 1){
                                var n = r[e1], i = n[0], a = n[1];
                                t1(i), t1(a);
                            }
                            t1(this.otherwise);
                        }, Lr.prototype.outputDefined = function() {
                            return this.branches.every(function(t1) {
                                return t1[0], t1[1].outputDefined();
                            }) && this.otherwise.outputDefined();
                        }, Lr.prototype.serialize = function() {
                            var t1 = [
                                "case"
                            ];
                            return this.eachChild(function(e1) {
                                t1.push(e1.serialize());
                            }), t1;
                        };
                        var Ir = function(t1, e1, r, n) {
                            this.type = t1, this.input = e1, this.beginIndex = r, this.endIndex = n;
                        };
                        function Pr(t1, e1) {
                            return "==" === t1 || "!=" === t1 ? "boolean" === e1.kind || "string" === e1.kind || "number" === e1.kind || "null" === e1.kind || "value" === e1.kind : "string" === e1.kind || "number" === e1.kind || "value" === e1.kind;
                        }
                        function zr(t1, e1, r, n) {
                            return 0 === n.compare(e1, r);
                        }
                        function Or(t1, e1, r) {
                            var n = "==" !== t1 && "!=" !== t1;
                            return function() {
                                function i(t1, e1, r) {
                                    this.type = Yt, this.lhs = t1, this.rhs = e1, this.collator = r, this.hasUntypedArgument = "value" === t1.type.kind || "value" === e1.type.kind;
                                }
                                return i.parse = function(t1, e1) {
                                    if (3 !== t1.length && 4 !== t1.length) return e1.error("Expected two or three arguments.");
                                    var r = t1[0], a = e1.parse(t1[1], 1, Jt);
                                    if (!a) return null;
                                    if (!Pr(r, a.type)) return e1.concat(1).error('"' + r + "\" comparisons are not supported for type '" + re(a.type) + "'.");
                                    var o = e1.parse(t1[2], 2, Jt);
                                    if (!o) return null;
                                    if (!Pr(r, o.type)) return e1.concat(2).error('"' + r + "\" comparisons are not supported for type '" + re(o.type) + "'.");
                                    if (a.type.kind !== o.type.kind && "value" !== a.type.kind && "value" !== o.type.kind) return e1.error("Cannot compare types '" + re(a.type) + "' and '" + re(o.type) + "'.");
                                    n && ("value" === a.type.kind && "value" !== o.type.kind ? a = new be(o.type, [
                                        a
                                    ]) : "value" !== a.type.kind && "value" === o.type.kind && (o = new be(a.type, [
                                        o
                                    ])));
                                    var s = null;
                                    if (4 === t1.length) {
                                        if ("string" !== a.type.kind && "string" !== o.type.kind && "value" !== a.type.kind && "value" !== o.type.kind) return e1.error("Cannot use collator to compare non-string types.");
                                        if (!(s = e1.parse(t1[3], 3, Kt))) return null;
                                    }
                                    return new i(a, o, s);
                                }, i.prototype.evaluate = function(i) {
                                    var a = this.lhs.evaluate(i), o = this.rhs.evaluate(i);
                                    if (n && this.hasUntypedArgument) {
                                        var s = ge(a), l = ge(o);
                                        if (s.kind !== l.kind || "string" !== s.kind && "number" !== s.kind) throw new xe('Expected arguments for "' + t1 + '" to be (string, string) or (number, number), but found (' + s.kind + ", " + l.kind + ") instead.");
                                    }
                                    if (this.collator && !n && this.hasUntypedArgument) {
                                        var c = ge(a), u = ge(o);
                                        if ("string" !== c.kind || "string" !== u.kind) return e1(i, a, o);
                                    }
                                    return this.collator ? r(i, a, o, this.collator.evaluate(i)) : e1(i, a, o);
                                }, i.prototype.eachChild = function(t1) {
                                    t1(this.lhs), t1(this.rhs), this.collator && t1(this.collator);
                                }, i.prototype.outputDefined = function() {
                                    return !0;
                                }, i.prototype.serialize = function() {
                                    var e1 = [
                                        t1
                                    ];
                                    return this.eachChild(function(t1) {
                                        e1.push(t1.serialize());
                                    }), e1;
                                }, i;
                            }();
                        }
                        Ir.parse = function(t1, e1) {
                            if (t1.length <= 2 || t1.length >= 5) return e1.error("Expected 3 or 4 arguments, but found " + (t1.length - 1) + " instead.");
                            var r = e1.parse(t1[1], 1, Jt), n = e1.parse(t1[2], 2, Zt);
                            if (!r || !n) return null;
                            if (!ae(r.type, [
                                ee(Jt),
                                Wt,
                                Jt
                            ])) return e1.error("Expected first argument to be of type array or string, but found " + re(r.type) + " instead");
                            if (4 === t1.length) {
                                var i = e1.parse(t1[3], 3, Zt);
                                return i ? new Ir(r.type, r, n, i) : null;
                            }
                            return new Ir(r.type, r, n);
                        }, Ir.prototype.evaluate = function(t1) {
                            var e1 = this.input.evaluate(t1), r = this.beginIndex.evaluate(t1);
                            if (!oe(e1, [
                                "string",
                                "array"
                            ])) throw new xe("Expected first argument to be of type array or string, but found " + re(ge(e1)) + " instead.");
                            if (this.endIndex) {
                                var n = this.endIndex.evaluate(t1);
                                return e1.slice(r, n);
                            }
                            return e1.slice(r);
                        }, Ir.prototype.eachChild = function(t1) {
                            t1(this.input), t1(this.beginIndex), this.endIndex && t1(this.endIndex);
                        }, Ir.prototype.outputDefined = function() {
                            return !1;
                        }, Ir.prototype.serialize = function() {
                            if (null != this.endIndex && void 0 !== this.endIndex) {
                                var t1 = this.endIndex.serialize();
                                return [
                                    "slice",
                                    this.input.serialize(),
                                    this.beginIndex.serialize(),
                                    t1
                                ];
                            }
                            return [
                                "slice",
                                this.input.serialize(),
                                this.beginIndex.serialize()
                            ];
                        };
                        var Dr = Or("==", function(t1, e1, r) {
                            return e1 === r;
                        }, zr), Rr = Or("!=", function(t1, e1, r) {
                            return e1 !== r;
                        }, function(t1, e1, r, n) {
                            return !zr(0, e1, r, n);
                        }), Fr = Or("<", function(t1, e1, r) {
                            return e1 < r;
                        }, function(t1, e1, r, n) {
                            return n.compare(e1, r) < 0;
                        }), Br = Or(">", function(t1, e1, r) {
                            return e1 > r;
                        }, function(t1, e1, r, n) {
                            return n.compare(e1, r) > 0;
                        }), Nr = Or("<=", function(t1, e1, r) {
                            return e1 <= r;
                        }, function(t1, e1, r, n) {
                            return n.compare(e1, r) <= 0;
                        }), jr = Or(">=", function(t1, e1, r) {
                            return e1 >= r;
                        }, function(t1, e1, r, n) {
                            return n.compare(e1, r) >= 0;
                        }), Ur = function(t1, e1, r, n, i) {
                            this.type = Wt, this.number = t1, this.locale = e1, this.currency = r, this.minFractionDigits = n, this.maxFractionDigits = i;
                        };
                        Ur.parse = function(t1, e1) {
                            if (3 !== t1.length) return e1.error("Expected two arguments.");
                            var r = e1.parse(t1[1], 1, Zt);
                            if (!r) return null;
                            var n = t1[2];
                            if ("object" != typeof n || Array.isArray(n)) return e1.error("NumberFormat options argument must be an object.");
                            var i = null;
                            if (n.locale && !(i = e1.parse(n.locale, 1, Wt))) return null;
                            var a = null;
                            if (n.currency && !(a = e1.parse(n.currency, 1, Wt))) return null;
                            var o = null;
                            if (n["min-fraction-digits"] && !(o = e1.parse(n["min-fraction-digits"], 1, Zt))) return null;
                            var s = null;
                            return n["max-fraction-digits"] && !(s = e1.parse(n["max-fraction-digits"], 1, Zt)) ? null : new Ur(r, i, a, o, s);
                        }, Ur.prototype.evaluate = function(t1) {
                            return new Intl.NumberFormat(this.locale ? this.locale.evaluate(t1) : [], {
                                style: this.currency ? "currency" : "decimal",
                                currency: this.currency ? this.currency.evaluate(t1) : void 0,
                                minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(t1) : void 0,
                                maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(t1) : void 0
                            }).format(this.number.evaluate(t1));
                        }, Ur.prototype.eachChild = function(t1) {
                            t1(this.number), this.locale && t1(this.locale), this.currency && t1(this.currency), this.minFractionDigits && t1(this.minFractionDigits), this.maxFractionDigits && t1(this.maxFractionDigits);
                        }, Ur.prototype.outputDefined = function() {
                            return !1;
                        }, Ur.prototype.serialize = function() {
                            var t1 = {};
                            return this.locale && (t1.locale = this.locale.serialize()), this.currency && (t1.currency = this.currency.serialize()), this.minFractionDigits && (t1["min-fraction-digits"] = this.minFractionDigits.serialize()), this.maxFractionDigits && (t1["max-fraction-digits"] = this.maxFractionDigits.serialize()), [
                                "number-format",
                                this.number.serialize(),
                                t1
                            ];
                        };
                        var Vr = function(t1) {
                            this.type = Zt, this.input = t1;
                        };
                        Vr.parse = function(t1, e1) {
                            if (2 !== t1.length) return e1.error("Expected 1 argument, but found " + (t1.length - 1) + " instead.");
                            var r = e1.parse(t1[1], 1);
                            return r ? "array" !== r.type.kind && "string" !== r.type.kind && "value" !== r.type.kind ? e1.error("Expected argument of type string or array, but found " + re(r.type) + " instead.") : new Vr(r) : null;
                        }, Vr.prototype.evaluate = function(t1) {
                            var e1 = this.input.evaluate(t1);
                            if ("string" == typeof e1) return e1.length;
                            if (Array.isArray(e1)) return e1.length;
                            throw new xe("Expected value to be of type string or array, but found " + re(ge(e1)) + " instead.");
                        }, Vr.prototype.eachChild = function(t1) {
                            t1(this.input);
                        }, Vr.prototype.outputDefined = function() {
                            return !1;
                        }, Vr.prototype.serialize = function() {
                            var t1 = [
                                "length"
                            ];
                            return this.eachChild(function(e1) {
                                t1.push(e1.serialize());
                            }), t1;
                        };
                        var qr = {
                            "==": Dr,
                            "!=": Rr,
                            ">": Br,
                            "<": Fr,
                            ">=": jr,
                            "<=": Nr,
                            array: be,
                            at: Mr,
                            boolean: be,
                            case: Lr,
                            coalesce: kr,
                            collator: Ce,
                            format: we,
                            image: Te,
                            in: Sr,
                            "index-of": Er,
                            interpolate: wr,
                            "interpolate-hcl": wr,
                            "interpolate-lab": wr,
                            length: Vr,
                            let: Ar,
                            literal: ve,
                            match: Cr,
                            number: be,
                            "number-format": Ur,
                            object: be,
                            slice: Ir,
                            step: tr,
                            string: be,
                            "to-boolean": Ae,
                            "to-color": Ae,
                            "to-number": Ae,
                            "to-string": Ae,
                            var: $e,
                            within: Ze
                        };
                        function Hr(t1, e1) {
                            var r = e1[0], n = e1[1], i = e1[2], a = e1[3];
                            r = r.evaluate(t1), n = n.evaluate(t1), i = i.evaluate(t1);
                            var o = a ? a.evaluate(t1) : 1, s = de(r, n, i, o);
                            if (s) throw new xe(s);
                            return new ce(r / 255 * o, n / 255 * o, i / 255 * o, o);
                        }
                        function Gr(t1, e1) {
                            return t1 in e1;
                        }
                        function Zr(t1, e1) {
                            var r = e1[t1];
                            return void 0 === r ? null : r;
                        }
                        function Wr(t1) {
                            return {
                                type: t1
                            };
                        }
                        function Yr(t1) {
                            return {
                                result: "success",
                                value: t1
                            };
                        }
                        function Xr(t1) {
                            return {
                                result: "error",
                                value: t1
                            };
                        }
                        function $r(t1) {
                            return "data-driven" === t1["property-type"] || "cross-faded-data-driven" === t1["property-type"];
                        }
                        function Jr(t1) {
                            return !!t1.expression && t1.expression.parameters.indexOf("zoom") > -1;
                        }
                        function Kr(t1) {
                            return !!t1.expression && t1.expression.interpolated;
                        }
                        function Qr(t1) {
                            return t1 instanceof Number ? "number" : t1 instanceof String ? "string" : t1 instanceof Boolean ? "boolean" : Array.isArray(t1) ? "array" : null === t1 ? "null" : typeof t1;
                        }
                        function tn(t1) {
                            return "object" == typeof t1 && null !== t1 && !Array.isArray(t1);
                        }
                        function en(t1) {
                            return t1;
                        }
                        function rn(t1, e1) {
                            var r, n, i, a = "color" === e1.type, o = t1.stops && "object" == typeof t1.stops[0][0], s = o || void 0 !== t1.property, l = o || !s, c = t1.type || (Kr(e1) ? "exponential" : "interval");
                            if (a && ((t1 = jt({}, t1)).stops && (t1.stops = t1.stops.map(function(t1) {
                                return [
                                    t1[0],
                                    ce.parse(t1[1])
                                ];
                            })), t1.default ? t1.default = ce.parse(t1.default) : t1.default = ce.parse(e1.default)), t1.colorSpace && "rgb" !== t1.colorSpace && !br[t1.colorSpace]) throw new Error("Unknown color space: " + t1.colorSpace);
                            if ("exponential" === c) r = sn;
                            else if ("interval" === c) r = on;
                            else if ("categorical" === c) {
                                r = an, n = Object.create(null);
                                for(var u = 0, h = t1.stops; u < h.length; u += 1){
                                    var f = h[u];
                                    n[f[0]] = f[1];
                                }
                                i = typeof t1.stops[0][0];
                            } else {
                                if ("identity" !== c) throw new Error('Unknown function type "' + c + '"');
                                r = ln;
                            }
                            if (o) {
                                for(var p = {}, d = [], m = 0; m < t1.stops.length; m++){
                                    var g = t1.stops[m], y = g[0].zoom;
                                    void 0 === p[y] && (p[y] = {
                                        zoom: y,
                                        type: t1.type,
                                        property: t1.property,
                                        default: t1.default,
                                        stops: []
                                    }, d.push(y)), p[y].stops.push([
                                        g[0].value,
                                        g[1]
                                    ]);
                                }
                                for(var v = [], x = 0, _ = d; x < _.length; x += 1){
                                    var b = _[x];
                                    v.push([
                                        p[b].zoom,
                                        rn(p[b], e1)
                                    ]);
                                }
                                var w = {
                                    name: "linear"
                                };
                                return {
                                    kind: "composite",
                                    interpolationType: w,
                                    interpolationFactor: wr.interpolationFactor.bind(void 0, w),
                                    zoomStops: v.map(function(t1) {
                                        return t1[0];
                                    }),
                                    evaluate: function(r, n) {
                                        var i = r.zoom;
                                        return sn({
                                            stops: v,
                                            base: t1.base
                                        }, e1, i).evaluate(i, n);
                                    }
                                };
                            }
                            if (l) {
                                var T = "exponential" === c ? {
                                    name: "exponential",
                                    base: void 0 !== t1.base ? t1.base : 1
                                } : null;
                                return {
                                    kind: "camera",
                                    interpolationType: T,
                                    interpolationFactor: wr.interpolationFactor.bind(void 0, T),
                                    zoomStops: t1.stops.map(function(t1) {
                                        return t1[0];
                                    }),
                                    evaluate: function(a) {
                                        var o = a.zoom;
                                        return r(t1, e1, o, n, i);
                                    }
                                };
                            }
                            return {
                                kind: "source",
                                evaluate: function(a, o) {
                                    var s = o && o.properties ? o.properties[t1.property] : void 0;
                                    return void 0 === s ? nn(t1.default, e1.default) : r(t1, e1, s, n, i);
                                }
                            };
                        }
                        function nn(t1, e1, r) {
                            return void 0 !== t1 ? t1 : void 0 !== e1 ? e1 : void 0 !== r ? r : void 0;
                        }
                        function an(t1, e1, r, n, i) {
                            return nn(typeof r === i ? n[r] : void 0, t1.default, e1.default);
                        }
                        function on(t1, e1, r) {
                            if ("number" !== Qr(r)) return nn(t1.default, e1.default);
                            var n = t1.stops.length;
                            if (1 === n) return t1.stops[0][1];
                            if (r <= t1.stops[0][0]) return t1.stops[0][1];
                            if (r >= t1.stops[n - 1][0]) return t1.stops[n - 1][1];
                            var i = Qe(t1.stops.map(function(t1) {
                                return t1[0];
                            }), r);
                            return t1.stops[i][1];
                        }
                        function sn(t1, e1, r) {
                            var n = void 0 !== t1.base ? t1.base : 1;
                            if ("number" !== Qr(r)) return nn(t1.default, e1.default);
                            var i = t1.stops.length;
                            if (1 === i) return t1.stops[0][1];
                            if (r <= t1.stops[0][0]) return t1.stops[0][1];
                            if (r >= t1.stops[i - 1][0]) return t1.stops[i - 1][1];
                            var a = Qe(t1.stops.map(function(t1) {
                                return t1[0];
                            }), r), o = function(t1, e1, r, n) {
                                var i = n - r, a = t1 - r;
                                return 0 === i ? 0 : 1 === e1 ? a / i : (Math.pow(e1, a) - 1) / (Math.pow(e1, i) - 1);
                            }(r, n, t1.stops[a][0], t1.stops[a + 1][0]), s = t1.stops[a][1], l = t1.stops[a + 1][1], c = rr[e1.type] || en;
                            if (t1.colorSpace && "rgb" !== t1.colorSpace) {
                                var u = br[t1.colorSpace];
                                c = function(t1, e1) {
                                    return u.reverse(u.interpolate(u.forward(t1), u.forward(e1), o));
                                };
                            }
                            return "function" == typeof s.evaluate ? {
                                evaluate: function() {
                                    for(var t1 = [], e1 = arguments.length; e1--;)t1[e1] = arguments[e1];
                                    var r = s.evaluate.apply(void 0, t1), n = l.evaluate.apply(void 0, t1);
                                    if (void 0 !== r && void 0 !== n) return c(r, n, o);
                                }
                            } : c(s, l, o);
                        }
                        function ln(t1, e1, r) {
                            return "color" === e1.type ? r = ce.parse(r) : "formatted" === e1.type ? r = fe.fromString(r.toString()) : "resolvedImage" === e1.type ? r = pe.fromString(r.toString()) : Qr(r) === e1.type || "enum" === e1.type && e1.values[r] || (r = void 0), nn(r, t1.default, e1.default);
                        }
                        Ee.register(qr, {
                            error: [
                                {
                                    kind: "error"
                                },
                                [
                                    Wt
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    throw new xe(r.evaluate(t1));
                                }
                            ],
                            typeof: [
                                Wt,
                                [
                                    Jt
                                ],
                                function(t1, e1) {
                                    return re(ge(e1[0].evaluate(t1)));
                                }
                            ],
                            "to-rgba": [
                                ee(Zt, 4),
                                [
                                    Xt
                                ],
                                function(t1, e1) {
                                    return e1[0].evaluate(t1).toArray();
                                }
                            ],
                            rgb: [
                                Xt,
                                [
                                    Zt,
                                    Zt,
                                    Zt
                                ],
                                Hr
                            ],
                            rgba: [
                                Xt,
                                [
                                    Zt,
                                    Zt,
                                    Zt,
                                    Zt
                                ],
                                Hr
                            ],
                            has: {
                                type: Yt,
                                overloads: [
                                    [
                                        [
                                            Wt
                                        ],
                                        function(t1, e1) {
                                            return Gr(e1[0].evaluate(t1), t1.properties());
                                        }
                                    ],
                                    [
                                        [
                                            Wt,
                                            $t
                                        ],
                                        function(t1, e1) {
                                            var r = e1[0], n = e1[1];
                                            return Gr(r.evaluate(t1), n.evaluate(t1));
                                        }
                                    ]
                                ]
                            },
                            get: {
                                type: Jt,
                                overloads: [
                                    [
                                        [
                                            Wt
                                        ],
                                        function(t1, e1) {
                                            return Zr(e1[0].evaluate(t1), t1.properties());
                                        }
                                    ],
                                    [
                                        [
                                            Wt,
                                            $t
                                        ],
                                        function(t1, e1) {
                                            var r = e1[0], n = e1[1];
                                            return Zr(r.evaluate(t1), n.evaluate(t1));
                                        }
                                    ]
                                ]
                            },
                            "feature-state": [
                                Jt,
                                [
                                    Wt
                                ],
                                function(t1, e1) {
                                    return Zr(e1[0].evaluate(t1), t1.featureState || {});
                                }
                            ],
                            properties: [
                                $t,
                                [],
                                function(t1) {
                                    return t1.properties();
                                }
                            ],
                            "geometry-type": [
                                Wt,
                                [],
                                function(t1) {
                                    return t1.geometryType();
                                }
                            ],
                            id: [
                                Jt,
                                [],
                                function(t1) {
                                    return t1.id();
                                }
                            ],
                            zoom: [
                                Zt,
                                [],
                                function(t1) {
                                    return t1.globals.zoom;
                                }
                            ],
                            "heatmap-density": [
                                Zt,
                                [],
                                function(t1) {
                                    return t1.globals.heatmapDensity || 0;
                                }
                            ],
                            "line-progress": [
                                Zt,
                                [],
                                function(t1) {
                                    return t1.globals.lineProgress || 0;
                                }
                            ],
                            accumulated: [
                                Jt,
                                [],
                                function(t1) {
                                    return void 0 === t1.globals.accumulated ? null : t1.globals.accumulated;
                                }
                            ],
                            "+": [
                                Zt,
                                Wr(Zt),
                                function(t1, e1) {
                                    for(var r = 0, n = 0, i = e1; n < i.length; n += 1)r += i[n].evaluate(t1);
                                    return r;
                                }
                            ],
                            "*": [
                                Zt,
                                Wr(Zt),
                                function(t1, e1) {
                                    for(var r = 1, n = 0, i = e1; n < i.length; n += 1)r *= i[n].evaluate(t1);
                                    return r;
                                }
                            ],
                            "-": {
                                type: Zt,
                                overloads: [
                                    [
                                        [
                                            Zt,
                                            Zt
                                        ],
                                        function(t1, e1) {
                                            var r = e1[0], n = e1[1];
                                            return r.evaluate(t1) - n.evaluate(t1);
                                        }
                                    ],
                                    [
                                        [
                                            Zt
                                        ],
                                        function(t1, e1) {
                                            return -e1[0].evaluate(t1);
                                        }
                                    ]
                                ]
                            },
                            "/": [
                                Zt,
                                [
                                    Zt,
                                    Zt
                                ],
                                function(t1, e1) {
                                    var r = e1[0], n = e1[1];
                                    return r.evaluate(t1) / n.evaluate(t1);
                                }
                            ],
                            "%": [
                                Zt,
                                [
                                    Zt,
                                    Zt
                                ],
                                function(t1, e1) {
                                    var r = e1[0], n = e1[1];
                                    return r.evaluate(t1) % n.evaluate(t1);
                                }
                            ],
                            ln2: [
                                Zt,
                                [],
                                function() {
                                    return Math.LN2;
                                }
                            ],
                            pi: [
                                Zt,
                                [],
                                function() {
                                    return Math.PI;
                                }
                            ],
                            e: [
                                Zt,
                                [],
                                function() {
                                    return Math.E;
                                }
                            ],
                            "^": [
                                Zt,
                                [
                                    Zt,
                                    Zt
                                ],
                                function(t1, e1) {
                                    var r = e1[0], n = e1[1];
                                    return Math.pow(r.evaluate(t1), n.evaluate(t1));
                                }
                            ],
                            sqrt: [
                                Zt,
                                [
                                    Zt
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return Math.sqrt(r.evaluate(t1));
                                }
                            ],
                            log10: [
                                Zt,
                                [
                                    Zt
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return Math.log(r.evaluate(t1)) / Math.LN10;
                                }
                            ],
                            ln: [
                                Zt,
                                [
                                    Zt
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return Math.log(r.evaluate(t1));
                                }
                            ],
                            log2: [
                                Zt,
                                [
                                    Zt
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return Math.log(r.evaluate(t1)) / Math.LN2;
                                }
                            ],
                            sin: [
                                Zt,
                                [
                                    Zt
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return Math.sin(r.evaluate(t1));
                                }
                            ],
                            cos: [
                                Zt,
                                [
                                    Zt
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return Math.cos(r.evaluate(t1));
                                }
                            ],
                            tan: [
                                Zt,
                                [
                                    Zt
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return Math.tan(r.evaluate(t1));
                                }
                            ],
                            asin: [
                                Zt,
                                [
                                    Zt
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return Math.asin(r.evaluate(t1));
                                }
                            ],
                            acos: [
                                Zt,
                                [
                                    Zt
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return Math.acos(r.evaluate(t1));
                                }
                            ],
                            atan: [
                                Zt,
                                [
                                    Zt
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return Math.atan(r.evaluate(t1));
                                }
                            ],
                            min: [
                                Zt,
                                Wr(Zt),
                                function(t1, e1) {
                                    return Math.min.apply(Math, e1.map(function(e1) {
                                        return e1.evaluate(t1);
                                    }));
                                }
                            ],
                            max: [
                                Zt,
                                Wr(Zt),
                                function(t1, e1) {
                                    return Math.max.apply(Math, e1.map(function(e1) {
                                        return e1.evaluate(t1);
                                    }));
                                }
                            ],
                            abs: [
                                Zt,
                                [
                                    Zt
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return Math.abs(r.evaluate(t1));
                                }
                            ],
                            round: [
                                Zt,
                                [
                                    Zt
                                ],
                                function(t1, e1) {
                                    var r = e1[0].evaluate(t1);
                                    return r < 0 ? -Math.round(-r) : Math.round(r);
                                }
                            ],
                            floor: [
                                Zt,
                                [
                                    Zt
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return Math.floor(r.evaluate(t1));
                                }
                            ],
                            ceil: [
                                Zt,
                                [
                                    Zt
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return Math.ceil(r.evaluate(t1));
                                }
                            ],
                            "filter-==": [
                                Yt,
                                [
                                    Wt,
                                    Jt
                                ],
                                function(t1, e1) {
                                    var r = e1[0], n = e1[1];
                                    return t1.properties()[r.value] === n.value;
                                }
                            ],
                            "filter-id-==": [
                                Yt,
                                [
                                    Jt
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return t1.id() === r.value;
                                }
                            ],
                            "filter-type-==": [
                                Yt,
                                [
                                    Wt
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return t1.geometryType() === r.value;
                                }
                            ],
                            "filter-<": [
                                Yt,
                                [
                                    Wt,
                                    Jt
                                ],
                                function(t1, e1) {
                                    var r = e1[0], n = e1[1], i = t1.properties()[r.value], a = n.value;
                                    return typeof i == typeof a && i < a;
                                }
                            ],
                            "filter-id-<": [
                                Yt,
                                [
                                    Jt
                                ],
                                function(t1, e1) {
                                    var r = e1[0], n = t1.id(), i = r.value;
                                    return typeof n == typeof i && n < i;
                                }
                            ],
                            "filter->": [
                                Yt,
                                [
                                    Wt,
                                    Jt
                                ],
                                function(t1, e1) {
                                    var r = e1[0], n = e1[1], i = t1.properties()[r.value], a = n.value;
                                    return typeof i == typeof a && i > a;
                                }
                            ],
                            "filter-id->": [
                                Yt,
                                [
                                    Jt
                                ],
                                function(t1, e1) {
                                    var r = e1[0], n = t1.id(), i = r.value;
                                    return typeof n == typeof i && n > i;
                                }
                            ],
                            "filter-<=": [
                                Yt,
                                [
                                    Wt,
                                    Jt
                                ],
                                function(t1, e1) {
                                    var r = e1[0], n = e1[1], i = t1.properties()[r.value], a = n.value;
                                    return typeof i == typeof a && i <= a;
                                }
                            ],
                            "filter-id-<=": [
                                Yt,
                                [
                                    Jt
                                ],
                                function(t1, e1) {
                                    var r = e1[0], n = t1.id(), i = r.value;
                                    return typeof n == typeof i && n <= i;
                                }
                            ],
                            "filter->=": [
                                Yt,
                                [
                                    Wt,
                                    Jt
                                ],
                                function(t1, e1) {
                                    var r = e1[0], n = e1[1], i = t1.properties()[r.value], a = n.value;
                                    return typeof i == typeof a && i >= a;
                                }
                            ],
                            "filter-id->=": [
                                Yt,
                                [
                                    Jt
                                ],
                                function(t1, e1) {
                                    var r = e1[0], n = t1.id(), i = r.value;
                                    return typeof n == typeof i && n >= i;
                                }
                            ],
                            "filter-has": [
                                Yt,
                                [
                                    Jt
                                ],
                                function(t1, e1) {
                                    return e1[0].value in t1.properties();
                                }
                            ],
                            "filter-has-id": [
                                Yt,
                                [],
                                function(t1) {
                                    return null !== t1.id() && void 0 !== t1.id();
                                }
                            ],
                            "filter-type-in": [
                                Yt,
                                [
                                    ee(Wt)
                                ],
                                function(t1, e1) {
                                    return e1[0].value.indexOf(t1.geometryType()) >= 0;
                                }
                            ],
                            "filter-id-in": [
                                Yt,
                                [
                                    ee(Jt)
                                ],
                                function(t1, e1) {
                                    return e1[0].value.indexOf(t1.id()) >= 0;
                                }
                            ],
                            "filter-in-small": [
                                Yt,
                                [
                                    Wt,
                                    ee(Jt)
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return e1[1].value.indexOf(t1.properties()[r.value]) >= 0;
                                }
                            ],
                            "filter-in-large": [
                                Yt,
                                [
                                    Wt,
                                    ee(Jt)
                                ],
                                function(t1, e1) {
                                    var r = e1[0], n = e1[1];
                                    return function(t1, e1, r, n) {
                                        for(; r <= n;){
                                            var i = r + n >> 1;
                                            if (e1[i] === t1) return !0;
                                            e1[i] > t1 ? n = i - 1 : r = i + 1;
                                        }
                                        return !1;
                                    }(t1.properties()[r.value], n.value, 0, n.value.length - 1);
                                }
                            ],
                            all: {
                                type: Yt,
                                overloads: [
                                    [
                                        [
                                            Yt,
                                            Yt
                                        ],
                                        function(t1, e1) {
                                            var r = e1[0], n = e1[1];
                                            return r.evaluate(t1) && n.evaluate(t1);
                                        }
                                    ],
                                    [
                                        Wr(Yt),
                                        function(t1, e1) {
                                            for(var r = 0, n = e1; r < n.length; r += 1)if (!n[r].evaluate(t1)) return !1;
                                            return !0;
                                        }
                                    ]
                                ]
                            },
                            any: {
                                type: Yt,
                                overloads: [
                                    [
                                        [
                                            Yt,
                                            Yt
                                        ],
                                        function(t1, e1) {
                                            var r = e1[0], n = e1[1];
                                            return r.evaluate(t1) || n.evaluate(t1);
                                        }
                                    ],
                                    [
                                        Wr(Yt),
                                        function(t1, e1) {
                                            for(var r = 0, n = e1; r < n.length; r += 1)if (n[r].evaluate(t1)) return !0;
                                            return !1;
                                        }
                                    ]
                                ]
                            },
                            "!": [
                                Yt,
                                [
                                    Yt
                                ],
                                function(t1, e1) {
                                    return !e1[0].evaluate(t1);
                                }
                            ],
                            "is-supported-script": [
                                Yt,
                                [
                                    Wt
                                ],
                                function(t1, e1) {
                                    var r = e1[0], n = t1.globals && t1.globals.isSupportedScript;
                                    return !n || n(r.evaluate(t1));
                                }
                            ],
                            upcase: [
                                Wt,
                                [
                                    Wt
                                ],
                                function(t1, e1) {
                                    return e1[0].evaluate(t1).toUpperCase();
                                }
                            ],
                            downcase: [
                                Wt,
                                [
                                    Wt
                                ],
                                function(t1, e1) {
                                    return e1[0].evaluate(t1).toLowerCase();
                                }
                            ],
                            concat: [
                                Wt,
                                Wr(Jt),
                                function(t1, e1) {
                                    return e1.map(function(e1) {
                                        return ye(e1.evaluate(t1));
                                    }).join("");
                                }
                            ],
                            "resolved-locale": [
                                Wt,
                                [
                                    Kt
                                ],
                                function(t1, e1) {
                                    return e1[0].evaluate(t1).resolvedLocale();
                                }
                            ]
                        });
                        var cn = function(t1, e1) {
                            this.expression = t1, this._warningHistory = {}, this._evaluator = new Se, this._defaultValue = e1 ? function(t1) {
                                return "color" === t1.type && tn(t1.default) ? new ce(0, 0, 0, 0) : "color" === t1.type ? ce.parse(t1.default) || null : void 0 === t1.default ? null : t1.default;
                            }(e1) : null, this._enumValues = e1 && "enum" === e1.type ? e1.values : null;
                        };
                        function un(t1) {
                            return Array.isArray(t1) && t1.length > 0 && "string" == typeof t1[0] && t1[0] in qr;
                        }
                        function hn(t1, e1) {
                            var r = new Je(qr, [], e1 ? function(t1) {
                                var e1 = {
                                    color: Xt,
                                    string: Wt,
                                    number: Zt,
                                    enum: Wt,
                                    boolean: Yt,
                                    formatted: Qt,
                                    resolvedImage: te
                                };
                                return "array" === t1.type ? ee(e1[t1.value] || Jt, t1.length) : e1[t1.type];
                            }(e1) : void 0), n = r.parse(t1, void 0, void 0, void 0, e1 && "string" === e1.type ? {
                                typeAnnotation: "coerce"
                            } : void 0);
                            return n ? Yr(new cn(n, e1)) : Xr(r.errors);
                        }
                        cn.prototype.evaluateWithoutErrorHandling = function(t1, e1, r, n, i, a) {
                            return this._evaluator.globals = t1, this._evaluator.feature = e1, this._evaluator.featureState = r, this._evaluator.canonical = n, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = a, this.expression.evaluate(this._evaluator);
                        }, cn.prototype.evaluate = function(t1, e1, r, n, i, a) {
                            this._evaluator.globals = t1, this._evaluator.feature = e1 || null, this._evaluator.featureState = r || null, this._evaluator.canonical = n, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = a || null;
                            try {
                                var o = this.expression.evaluate(this._evaluator);
                                if (null == o || "number" == typeof o && o != o) return this._defaultValue;
                                if (this._enumValues && !(o in this._enumValues)) throw new xe("Expected value to be one of " + Object.keys(this._enumValues).map(function(t1) {
                                    return JSON.stringify(t1);
                                }).join(", ") + ", but found " + JSON.stringify(o) + " instead.");
                                return o;
                            } catch (t1) {
                                return this._warningHistory[t1.message] || (this._warningHistory[t1.message] = !0, "undefined" != typeof console && console.warn(t1.message)), this._defaultValue;
                            }
                        };
                        var fn = function(t1, e1) {
                            this.kind = t1, this._styleExpression = e1, this.isStateDependent = "constant" !== t1 && !Ye(e1.expression);
                        };
                        fn.prototype.evaluateWithoutErrorHandling = function(t1, e1, r, n, i, a) {
                            return this._styleExpression.evaluateWithoutErrorHandling(t1, e1, r, n, i, a);
                        }, fn.prototype.evaluate = function(t1, e1, r, n, i, a) {
                            return this._styleExpression.evaluate(t1, e1, r, n, i, a);
                        };
                        var pn = function(t1, e1, r, n) {
                            this.kind = t1, this.zoomStops = r, this._styleExpression = e1, this.isStateDependent = "camera" !== t1 && !Ye(e1.expression), this.interpolationType = n;
                        };
                        function dn(t1, e1) {
                            if ("error" === (t1 = hn(t1, e1)).result) return t1;
                            var r = t1.value.expression, n = We(r);
                            if (!n && !$r(e1)) return Xr([
                                new qt("", "data expressions not supported")
                            ]);
                            var i = Xe(r, [
                                "zoom"
                            ]);
                            if (!i && !Jr(e1)) return Xr([
                                new qt("", "zoom expressions not supported")
                            ]);
                            var a = gn(r);
                            if (!a && !i) return Xr([
                                new qt("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')
                            ]);
                            if (a instanceof qt) return Xr([
                                a
                            ]);
                            if (a instanceof wr && !Kr(e1)) return Xr([
                                new qt("", '"interpolate" expressions cannot be used with this property')
                            ]);
                            if (!a) return Yr(new fn(n ? "constant" : "source", t1.value));
                            var o = a instanceof wr ? a.interpolation : void 0;
                            return Yr(new pn(n ? "camera" : "composite", t1.value, a.labels, o));
                        }
                        pn.prototype.evaluateWithoutErrorHandling = function(t1, e1, r, n, i, a) {
                            return this._styleExpression.evaluateWithoutErrorHandling(t1, e1, r, n, i, a);
                        }, pn.prototype.evaluate = function(t1, e1, r, n, i, a) {
                            return this._styleExpression.evaluate(t1, e1, r, n, i, a);
                        }, pn.prototype.interpolationFactor = function(t1, e1, r) {
                            return this.interpolationType ? wr.interpolationFactor(this.interpolationType, t1, e1, r) : 0;
                        };
                        var mn = function(t1, e1) {
                            this._parameters = t1, this._specification = e1, jt(this, rn(this._parameters, this._specification));
                        };
                        function gn(t1) {
                            var e1 = null;
                            if (t1 instanceof Ar) e1 = gn(t1.result);
                            else if (t1 instanceof kr) for(var r = 0, n = t1.args; r < n.length; r += 1){
                                var i = n[r];
                                if (e1 = gn(i)) break;
                            }
                            else (t1 instanceof tr || t1 instanceof wr) && t1.input instanceof Ee && "zoom" === t1.input.name && (e1 = t1);
                            return e1 instanceof qt || t1.eachChild(function(t1) {
                                var r = gn(t1);
                                r instanceof qt ? e1 = r : !e1 && r ? e1 = new qt("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.') : e1 && r && e1 !== r && (e1 = new qt("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
                            }), e1;
                        }
                        function yn(t1) {
                            var e1 = t1.key, r = t1.value, n = t1.valueSpec || {}, i = t1.objectElementValidators || {}, a = t1.style, o = t1.styleSpec, s = [], l = Qr(r);
                            if ("object" !== l) return [
                                new Bt(e1, r, "object expected, " + l + " found")
                            ];
                            for(var c in r){
                                var u = c.split(".")[0], h = n[u] || n["*"], f = void 0;
                                if (i[u]) f = i[u];
                                else if (n[u]) f = Hn;
                                else if (i["*"]) f = i["*"];
                                else {
                                    if (!n["*"]) {
                                        s.push(new Bt(e1, r[c], 'unknown property "' + c + '"'));
                                        continue;
                                    }
                                    f = Hn;
                                }
                                s = s.concat(f({
                                    key: (e1 ? e1 + "." : e1) + c,
                                    value: r[c],
                                    valueSpec: h,
                                    style: a,
                                    styleSpec: o,
                                    object: r,
                                    objectKey: c
                                }, r));
                            }
                            for(var p in n)i[p] || n[p].required && void 0 === n[p].default && void 0 === r[p] && s.push(new Bt(e1, r, 'missing required property "' + p + '"'));
                            return s;
                        }
                        function vn(t1) {
                            var e1 = t1.value, r = t1.valueSpec, n = t1.style, i = t1.styleSpec, a = t1.key, o = t1.arrayElementValidator || Hn;
                            if ("array" !== Qr(e1)) return [
                                new Bt(a, e1, "array expected, " + Qr(e1) + " found")
                            ];
                            if (r.length && e1.length !== r.length) return [
                                new Bt(a, e1, "array length " + r.length + " expected, length " + e1.length + " found")
                            ];
                            if (r["min-length"] && e1.length < r["min-length"]) return [
                                new Bt(a, e1, "array length at least " + r["min-length"] + " expected, length " + e1.length + " found")
                            ];
                            var s = {
                                type: r.value,
                                values: r.values
                            };
                            i.$version < 7 && (s.function = r.function), "object" === Qr(r.value) && (s = r.value);
                            for(var l = [], c = 0; c < e1.length; c++)l = l.concat(o({
                                array: e1,
                                arrayIndex: c,
                                value: e1[c],
                                valueSpec: s,
                                style: n,
                                styleSpec: i,
                                key: a + "[" + c + "]"
                            }));
                            return l;
                        }
                        function xn(t1) {
                            var e1 = t1.key, r = t1.value, n = t1.valueSpec, i = Qr(r);
                            return "number" === i && r != r && (i = "NaN"), "number" !== i ? [
                                new Bt(e1, r, "number expected, " + i + " found")
                            ] : "minimum" in n && r < n.minimum ? [
                                new Bt(e1, r, r + " is less than the minimum value " + n.minimum)
                            ] : "maximum" in n && r > n.maximum ? [
                                new Bt(e1, r, r + " is greater than the maximum value " + n.maximum)
                            ] : [];
                        }
                        function _n(t1) {
                            var e1, r, n, i = t1.valueSpec, a = Ut(t1.value.type), o = {}, s = "categorical" !== a && void 0 === t1.value.property, l = !s, c = "array" === Qr(t1.value.stops) && "array" === Qr(t1.value.stops[0]) && "object" === Qr(t1.value.stops[0][0]), u = yn({
                                key: t1.key,
                                value: t1.value,
                                valueSpec: t1.styleSpec.function,
                                style: t1.style,
                                styleSpec: t1.styleSpec,
                                objectElementValidators: {
                                    stops: function(t1) {
                                        if ("identity" === a) return [
                                            new Bt(t1.key, t1.value, 'identity function may not have a "stops" property')
                                        ];
                                        var e1 = [], r = t1.value;
                                        return e1 = e1.concat(vn({
                                            key: t1.key,
                                            value: r,
                                            valueSpec: t1.valueSpec,
                                            style: t1.style,
                                            styleSpec: t1.styleSpec,
                                            arrayElementValidator: h
                                        })), "array" === Qr(r) && 0 === r.length && e1.push(new Bt(t1.key, r, "array must have at least one stop")), e1;
                                    },
                                    default: function(t1) {
                                        return Hn({
                                            key: t1.key,
                                            value: t1.value,
                                            valueSpec: i,
                                            style: t1.style,
                                            styleSpec: t1.styleSpec
                                        });
                                    }
                                }
                            });
                            return "identity" === a && s && u.push(new Bt(t1.key, t1.value, 'missing required property "property"')), "identity" === a || t1.value.stops || u.push(new Bt(t1.key, t1.value, 'missing required property "stops"')), "exponential" === a && t1.valueSpec.expression && !Kr(t1.valueSpec) && u.push(new Bt(t1.key, t1.value, "exponential functions not supported")), t1.styleSpec.$version >= 8 && (l && !$r(t1.valueSpec) ? u.push(new Bt(t1.key, t1.value, "property functions not supported")) : s && !Jr(t1.valueSpec) && u.push(new Bt(t1.key, t1.value, "zoom functions not supported"))), "categorical" !== a && !c || void 0 !== t1.value.property || u.push(new Bt(t1.key, t1.value, '"property" property is required')), u;
                            function h(t1) {
                                var e1 = [], a = t1.value, s = t1.key;
                                if ("array" !== Qr(a)) return [
                                    new Bt(s, a, "array expected, " + Qr(a) + " found")
                                ];
                                if (2 !== a.length) return [
                                    new Bt(s, a, "array length 2 expected, length " + a.length + " found")
                                ];
                                if (c) {
                                    if ("object" !== Qr(a[0])) return [
                                        new Bt(s, a, "object expected, " + Qr(a[0]) + " found")
                                    ];
                                    if (void 0 === a[0].zoom) return [
                                        new Bt(s, a, "object stop key must have zoom")
                                    ];
                                    if (void 0 === a[0].value) return [
                                        new Bt(s, a, "object stop key must have value")
                                    ];
                                    if (n && n > Ut(a[0].zoom)) return [
                                        new Bt(s, a[0].zoom, "stop zoom values must appear in ascending order")
                                    ];
                                    Ut(a[0].zoom) !== n && (n = Ut(a[0].zoom), r = void 0, o = {}), e1 = e1.concat(yn({
                                        key: s + "[0]",
                                        value: a[0],
                                        valueSpec: {
                                            zoom: {}
                                        },
                                        style: t1.style,
                                        styleSpec: t1.styleSpec,
                                        objectElementValidators: {
                                            zoom: xn,
                                            value: f
                                        }
                                    }));
                                } else e1 = e1.concat(f({
                                    key: s + "[0]",
                                    value: a[0],
                                    valueSpec: {},
                                    style: t1.style,
                                    styleSpec: t1.styleSpec
                                }, a));
                                return un(Vt(a[1])) ? e1.concat([
                                    new Bt(s + "[1]", a[1], "expressions are not allowed in function stops.")
                                ]) : e1.concat(Hn({
                                    key: s + "[1]",
                                    value: a[1],
                                    valueSpec: i,
                                    style: t1.style,
                                    styleSpec: t1.styleSpec
                                }));
                            }
                            function f(t1, n) {
                                var s = Qr(t1.value), l = Ut(t1.value), c = null !== t1.value ? t1.value : n;
                                if (e1) {
                                    if (s !== e1) return [
                                        new Bt(t1.key, c, s + " stop domain type must match previous stop domain type " + e1)
                                    ];
                                } else e1 = s;
                                if ("number" !== s && "string" !== s && "boolean" !== s) return [
                                    new Bt(t1.key, c, "stop domain value must be a number, string, or boolean")
                                ];
                                if ("number" !== s && "categorical" !== a) {
                                    var u = "number expected, " + s + " found";
                                    return $r(i) && void 0 === a && (u += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                                        new Bt(t1.key, c, u)
                                    ];
                                }
                                return "categorical" !== a || "number" !== s || isFinite(l) && Math.floor(l) === l ? "categorical" !== a && "number" === s && void 0 !== r && l < r ? [
                                    new Bt(t1.key, c, "stop domain values must appear in ascending order")
                                ] : (r = l, "categorical" === a && l in o ? [
                                    new Bt(t1.key, c, "stop domain values must be unique")
                                ] : (o[l] = !0, [])) : [
                                    new Bt(t1.key, c, "integer expected, found " + l)
                                ];
                            }
                        }
                        function bn(t1) {
                            var e1 = ("property" === t1.expressionContext ? dn : hn)(Vt(t1.value), t1.valueSpec);
                            if ("error" === e1.result) return e1.value.map(function(e1) {
                                return new Bt("" + t1.key + e1.key, t1.value, e1.message);
                            });
                            var r = e1.value.expression || e1.value._styleExpression.expression;
                            if ("property" === t1.expressionContext && "text-font" === t1.propertyKey && !r.outputDefined()) return [
                                new Bt(t1.key, t1.value, 'Invalid data expression for "' + t1.propertyKey + '". Output values must be contained as literals within the expression.')
                            ];
                            if ("property" === t1.expressionContext && "layout" === t1.propertyType && !Ye(r)) return [
                                new Bt(t1.key, t1.value, '"feature-state" data expressions are not supported with layout properties.')
                            ];
                            if ("filter" === t1.expressionContext && !Ye(r)) return [
                                new Bt(t1.key, t1.value, '"feature-state" data expressions are not supported with filters.')
                            ];
                            if (t1.expressionContext && 0 === t1.expressionContext.indexOf("cluster")) {
                                if (!Xe(r, [
                                    "zoom",
                                    "feature-state"
                                ])) return [
                                    new Bt(t1.key, t1.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
                                ];
                                if ("cluster-initial" === t1.expressionContext && !We(r)) return [
                                    new Bt(t1.key, t1.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
                                ];
                            }
                            return [];
                        }
                        function wn(t1) {
                            var e1 = t1.key, r = t1.value, n = t1.valueSpec, i = [];
                            return Array.isArray(n.values) ? -1 === n.values.indexOf(Ut(r)) && i.push(new Bt(e1, r, "expected one of [" + n.values.join(", ") + "], " + JSON.stringify(r) + " found")) : -1 === Object.keys(n.values).indexOf(Ut(r)) && i.push(new Bt(e1, r, "expected one of [" + Object.keys(n.values).join(", ") + "], " + JSON.stringify(r) + " found")), i;
                        }
                        function Tn(t1) {
                            if (!0 === t1 || !1 === t1) return !0;
                            if (!Array.isArray(t1) || 0 === t1.length) return !1;
                            switch(t1[0]){
                                case "has":
                                    return t1.length >= 2 && "$id" !== t1[1] && "$type" !== t1[1];
                                case "in":
                                    return t1.length >= 3 && ("string" != typeof t1[1] || Array.isArray(t1[2]));
                                case "!in":
                                case "!has":
                                case "none":
                                    return !1;
                                case "==":
                                case "!=":
                                case ">":
                                case ">=":
                                case "<":
                                case "<=":
                                    return 3 !== t1.length || Array.isArray(t1[1]) || Array.isArray(t1[2]);
                                case "any":
                                case "all":
                                    for(var e1 = 0, r = t1.slice(1); e1 < r.length; e1 += 1){
                                        var n = r[e1];
                                        if (!Tn(n) && "boolean" != typeof n) return !1;
                                    }
                                    return !0;
                                default:
                                    return !0;
                            }
                        }
                        mn.deserialize = function(t1) {
                            return new mn(t1._parameters, t1._specification);
                        }, mn.serialize = function(t1) {
                            return {
                                _parameters: t1._parameters,
                                _specification: t1._specification
                            };
                        };
                        var kn = {
                            type: "boolean",
                            default: !1,
                            transition: !1,
                            "property-type": "data-driven",
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom",
                                    "feature"
                                ]
                            }
                        };
                        function An(t1) {
                            if (null == t1) return {
                                filter: function() {
                                    return !0;
                                },
                                needGeometry: !1
                            };
                            Tn(t1) || (t1 = En(t1));
                            var e1 = hn(t1, kn);
                            if ("error" === e1.result) throw new Error(e1.value.map(function(t1) {
                                return t1.key + ": " + t1.message;
                            }).join(", "));
                            return {
                                filter: function(t1, r, n) {
                                    return e1.value.evaluate(t1, r, {}, n);
                                },
                                needGeometry: Sn(t1)
                            };
                        }
                        function Mn(t1, e1) {
                            return t1 < e1 ? -1 : t1 > e1 ? 1 : 0;
                        }
                        function Sn(t1) {
                            if (!Array.isArray(t1)) return !1;
                            if ("within" === t1[0]) return !0;
                            for(var e1 = 1; e1 < t1.length; e1++)if (Sn(t1[e1])) return !0;
                            return !1;
                        }
                        function En(t1) {
                            if (!t1) return !0;
                            var e1, r = t1[0];
                            return t1.length <= 1 ? "any" !== r : "==" === r ? Cn(t1[1], t1[2], "==") : "!=" === r ? Pn(Cn(t1[1], t1[2], "==")) : "<" === r || ">" === r || "<=" === r || ">=" === r ? Cn(t1[1], t1[2], r) : "any" === r ? (e1 = t1.slice(1), [
                                "any"
                            ].concat(e1.map(En))) : "all" === r ? [
                                "all"
                            ].concat(t1.slice(1).map(En)) : "none" === r ? [
                                "all"
                            ].concat(t1.slice(1).map(En).map(Pn)) : "in" === r ? Ln(t1[1], t1.slice(2)) : "!in" === r ? Pn(Ln(t1[1], t1.slice(2))) : "has" === r ? In(t1[1]) : "!has" === r ? Pn(In(t1[1])) : "within" !== r || t1;
                        }
                        function Cn(t1, e1, r) {
                            switch(t1){
                                case "$type":
                                    return [
                                        "filter-type-" + r,
                                        e1
                                    ];
                                case "$id":
                                    return [
                                        "filter-id-" + r,
                                        e1
                                    ];
                                default:
                                    return [
                                        "filter-" + r,
                                        t1,
                                        e1
                                    ];
                            }
                        }
                        function Ln(t1, e1) {
                            if (0 === e1.length) return !1;
                            switch(t1){
                                case "$type":
                                    return [
                                        "filter-type-in",
                                        [
                                            "literal",
                                            e1
                                        ]
                                    ];
                                case "$id":
                                    return [
                                        "filter-id-in",
                                        [
                                            "literal",
                                            e1
                                        ]
                                    ];
                                default:
                                    return e1.length > 200 && !e1.some(function(t1) {
                                        return typeof t1 != typeof e1[0];
                                    }) ? [
                                        "filter-in-large",
                                        t1,
                                        [
                                            "literal",
                                            e1.sort(Mn)
                                        ]
                                    ] : [
                                        "filter-in-small",
                                        t1,
                                        [
                                            "literal",
                                            e1
                                        ]
                                    ];
                            }
                        }
                        function In(t1) {
                            switch(t1){
                                case "$type":
                                    return !0;
                                case "$id":
                                    return [
                                        "filter-has-id"
                                    ];
                                default:
                                    return [
                                        "filter-has",
                                        t1
                                    ];
                            }
                        }
                        function Pn(t1) {
                            return [
                                "!",
                                t1
                            ];
                        }
                        function zn(t1) {
                            return Tn(Vt(t1.value)) ? bn(jt({}, t1, {
                                expressionContext: "filter",
                                valueSpec: {
                                    value: "boolean"
                                }
                            })) : On(t1);
                        }
                        function On(t1) {
                            var e1 = t1.value, r = t1.key;
                            if ("array" !== Qr(e1)) return [
                                new Bt(r, e1, "array expected, " + Qr(e1) + " found")
                            ];
                            var n, i = t1.styleSpec, a = [];
                            if (e1.length < 1) return [
                                new Bt(r, e1, "filter array must have at least 1 element")
                            ];
                            switch(a = a.concat(wn({
                                key: r + "[0]",
                                value: e1[0],
                                valueSpec: i.filter_operator,
                                style: t1.style,
                                styleSpec: t1.styleSpec
                            })), Ut(e1[0])){
                                case "<":
                                case "<=":
                                case ">":
                                case ">=":
                                    e1.length >= 2 && "$type" === Ut(e1[1]) && a.push(new Bt(r, e1, '"$type" cannot be use with operator "' + e1[0] + '"'));
                                case "==":
                                case "!=":
                                    3 !== e1.length && a.push(new Bt(r, e1, 'filter array for operator "' + e1[0] + '" must have 3 elements'));
                                case "in":
                                case "!in":
                                    e1.length >= 2 && "string" !== (n = Qr(e1[1])) && a.push(new Bt(r + "[1]", e1[1], "string expected, " + n + " found"));
                                    for(var o = 2; o < e1.length; o++)n = Qr(e1[o]), "$type" === Ut(e1[1]) ? a = a.concat(wn({
                                        key: r + "[" + o + "]",
                                        value: e1[o],
                                        valueSpec: i.geometry_type,
                                        style: t1.style,
                                        styleSpec: t1.styleSpec
                                    })) : "string" !== n && "number" !== n && "boolean" !== n && a.push(new Bt(r + "[" + o + "]", e1[o], "string, number, or boolean expected, " + n + " found"));
                                    break;
                                case "any":
                                case "all":
                                case "none":
                                    for(var s = 1; s < e1.length; s++)a = a.concat(On({
                                        key: r + "[" + s + "]",
                                        value: e1[s],
                                        style: t1.style,
                                        styleSpec: t1.styleSpec
                                    }));
                                    break;
                                case "has":
                                case "!has":
                                    n = Qr(e1[1]), 2 !== e1.length ? a.push(new Bt(r, e1, 'filter array for "' + e1[0] + '" operator must have 2 elements')) : "string" !== n && a.push(new Bt(r + "[1]", e1[1], "string expected, " + n + " found"));
                                    break;
                                case "within":
                                    n = Qr(e1[1]), 2 !== e1.length ? a.push(new Bt(r, e1, 'filter array for "' + e1[0] + '" operator must have 2 elements')) : "object" !== n && a.push(new Bt(r + "[1]", e1[1], "object expected, " + n + " found"));
                            }
                            return a;
                        }
                        function Dn(t1, e1) {
                            var r = t1.key, n = t1.style, i = t1.styleSpec, a = t1.value, o = t1.objectKey, s = i[e1 + "_" + t1.layerType];
                            if (!s) return [];
                            var l = o.match(/^(.*)-transition$/);
                            if ("paint" === e1 && l && s[l[1]] && s[l[1]].transition) return Hn({
                                key: r,
                                value: a,
                                valueSpec: i.transition,
                                style: n,
                                styleSpec: i
                            });
                            var c, u = t1.valueSpec || s[o];
                            if (!u) return [
                                new Bt(r, a, 'unknown property "' + o + '"')
                            ];
                            if ("string" === Qr(a) && $r(u) && !u.tokens && (c = /^{([^}]+)}$/.exec(a))) return [
                                new Bt(r, a, '"' + o + '" does not support interpolation syntax\nUse an identity property function instead: `{ "type": "identity", "property": ' + JSON.stringify(c[1]) + " }`.")
                            ];
                            var h = [];
                            return "symbol" === t1.layerType && ("text-field" === o && n && !n.glyphs && h.push(new Bt(r, a, 'use of "text-field" requires a style "glyphs" property')), "text-font" === o && tn(Vt(a)) && "identity" === Ut(a.type) && h.push(new Bt(r, a, '"text-font" does not support identity functions'))), h.concat(Hn({
                                key: t1.key,
                                value: a,
                                valueSpec: u,
                                style: n,
                                styleSpec: i,
                                expressionContext: "property",
                                propertyType: e1,
                                propertyKey: o
                            }));
                        }
                        function Rn(t1) {
                            return Dn(t1, "paint");
                        }
                        function Fn(t1) {
                            return Dn(t1, "layout");
                        }
                        function Bn(t1) {
                            var e1 = [], r = t1.value, n = t1.key, i = t1.style, a = t1.styleSpec;
                            r.type || r.ref || e1.push(new Bt(n, r, 'either "type" or "ref" is required'));
                            var o, s = Ut(r.type), l = Ut(r.ref);
                            if (r.id) for(var c = Ut(r.id), u = 0; u < t1.arrayIndex; u++){
                                var h = i.layers[u];
                                Ut(h.id) === c && e1.push(new Bt(n, r.id, 'duplicate layer id "' + r.id + '", previously used at line ' + h.id.__line__));
                            }
                            if ("ref" in r) [
                                "type",
                                "source",
                                "source-layer",
                                "filter",
                                "layout"
                            ].forEach(function(t1) {
                                t1 in r && e1.push(new Bt(n, r[t1], '"' + t1 + '" is prohibited for ref layers'));
                            }), i.layers.forEach(function(t1) {
                                Ut(t1.id) === l && (o = t1);
                            }), o ? o.ref ? e1.push(new Bt(n, r.ref, "ref cannot reference another ref layer")) : s = Ut(o.type) : e1.push(new Bt(n, r.ref, 'ref layer "' + l + '" not found'));
                            else if ("background" !== s) {
                                if (r.source) {
                                    var f = i.sources && i.sources[r.source], p = f && Ut(f.type);
                                    f ? "vector" === p && "raster" === s ? e1.push(new Bt(n, r.source, 'layer "' + r.id + '" requires a raster source')) : "raster" === p && "raster" !== s ? e1.push(new Bt(n, r.source, 'layer "' + r.id + '" requires a vector source')) : "vector" !== p || r["source-layer"] ? "raster-dem" === p && "hillshade" !== s ? e1.push(new Bt(n, r.source, "raster-dem source can only be used with layer type 'hillshade'.")) : "line" !== s || !r.paint || !r.paint["line-gradient"] || "geojson" === p && f.lineMetrics || e1.push(new Bt(n, r, 'layer "' + r.id + '" specifies a line-gradient, which requires a GeoJSON source with `lineMetrics` enabled.')) : e1.push(new Bt(n, r, 'layer "' + r.id + '" must specify a "source-layer"')) : e1.push(new Bt(n, r.source, 'source "' + r.source + '" not found'));
                                } else e1.push(new Bt(n, r, 'missing required property "source"'));
                            }
                            return e1 = e1.concat(yn({
                                key: n,
                                value: r,
                                valueSpec: a.layer,
                                style: t1.style,
                                styleSpec: t1.styleSpec,
                                objectElementValidators: {
                                    "*": function() {
                                        return [];
                                    },
                                    type: function() {
                                        return Hn({
                                            key: n + ".type",
                                            value: r.type,
                                            valueSpec: a.layer.type,
                                            style: t1.style,
                                            styleSpec: t1.styleSpec,
                                            object: r,
                                            objectKey: "type"
                                        });
                                    },
                                    filter: zn,
                                    layout: function(t1) {
                                        return yn({
                                            layer: r,
                                            key: t1.key,
                                            value: t1.value,
                                            style: t1.style,
                                            styleSpec: t1.styleSpec,
                                            objectElementValidators: {
                                                "*": function(t1) {
                                                    return Fn(jt({
                                                        layerType: s
                                                    }, t1));
                                                }
                                            }
                                        });
                                    },
                                    paint: function(t1) {
                                        return yn({
                                            layer: r,
                                            key: t1.key,
                                            value: t1.value,
                                            style: t1.style,
                                            styleSpec: t1.styleSpec,
                                            objectElementValidators: {
                                                "*": function(t1) {
                                                    return Rn(jt({
                                                        layerType: s
                                                    }, t1));
                                                }
                                            }
                                        });
                                    }
                                }
                            })), e1;
                        }
                        function Nn(t1) {
                            var e1 = t1.value, r = t1.key, n = Qr(e1);
                            return "string" !== n ? [
                                new Bt(r, e1, "string expected, " + n + " found")
                            ] : [];
                        }
                        var jn = {
                            promoteId: function(t1) {
                                var e1 = t1.key, r = t1.value;
                                if ("string" === Qr(r)) return Nn({
                                    key: e1,
                                    value: r
                                });
                                var n = [];
                                for(var i in r)n.push.apply(n, Nn({
                                    key: e1 + "." + i,
                                    value: r[i]
                                }));
                                return n;
                            }
                        };
                        function Un(t1) {
                            var e1 = t1.value, r = t1.key, n = t1.styleSpec, i = t1.style;
                            if (!e1.type) return [
                                new Bt(r, e1, '"type" is required')
                            ];
                            var a, o = Ut(e1.type);
                            switch(o){
                                case "vector":
                                case "raster":
                                case "raster-dem":
                                    return yn({
                                        key: r,
                                        value: e1,
                                        valueSpec: n["source_" + o.replace("-", "_")],
                                        style: t1.style,
                                        styleSpec: n,
                                        objectElementValidators: jn
                                    });
                                case "geojson":
                                    if (a = yn({
                                        key: r,
                                        value: e1,
                                        valueSpec: n.source_geojson,
                                        style: i,
                                        styleSpec: n,
                                        objectElementValidators: jn
                                    }), e1.cluster) for(var s in e1.clusterProperties){
                                        var l = e1.clusterProperties[s], c = l[0], u = l[1], h = "string" == typeof c ? [
                                            c,
                                            [
                                                "accumulated"
                                            ],
                                            [
                                                "get",
                                                s
                                            ]
                                        ] : c;
                                        a.push.apply(a, bn({
                                            key: r + "." + s + ".map",
                                            value: u,
                                            expressionContext: "cluster-map"
                                        })), a.push.apply(a, bn({
                                            key: r + "." + s + ".reduce",
                                            value: h,
                                            expressionContext: "cluster-reduce"
                                        }));
                                    }
                                    return a;
                                case "video":
                                    return yn({
                                        key: r,
                                        value: e1,
                                        valueSpec: n.source_video,
                                        style: i,
                                        styleSpec: n
                                    });
                                case "image":
                                    return yn({
                                        key: r,
                                        value: e1,
                                        valueSpec: n.source_image,
                                        style: i,
                                        styleSpec: n
                                    });
                                case "canvas":
                                    return [
                                        new Bt(r, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
                                    ];
                                default:
                                    return wn({
                                        key: r + ".type",
                                        value: e1.type,
                                        valueSpec: {
                                            values: [
                                                "vector",
                                                "raster",
                                                "raster-dem",
                                                "geojson",
                                                "video",
                                                "image"
                                            ]
                                        },
                                        style: i,
                                        styleSpec: n
                                    });
                            }
                        }
                        function Vn(t1) {
                            var e1 = t1.value, r = t1.styleSpec, n = r.light, i = t1.style, a = [], o = Qr(e1);
                            if (void 0 === e1) return a;
                            if ("object" !== o) return a.concat([
                                new Bt("light", e1, "object expected, " + o + " found")
                            ]);
                            for(var s in e1){
                                var l = s.match(/^(.*)-transition$/);
                                a = l && n[l[1]] && n[l[1]].transition ? a.concat(Hn({
                                    key: s,
                                    value: e1[s],
                                    valueSpec: r.transition,
                                    style: i,
                                    styleSpec: r
                                })) : n[s] ? a.concat(Hn({
                                    key: s,
                                    value: e1[s],
                                    valueSpec: n[s],
                                    style: i,
                                    styleSpec: r
                                })) : a.concat([
                                    new Bt(s, e1[s], 'unknown property "' + s + '"')
                                ]);
                            }
                            return a;
                        }
                        var qn = {
                            "*": function() {
                                return [];
                            },
                            array: vn,
                            boolean: function(t1) {
                                var e1 = t1.value, r = t1.key, n = Qr(e1);
                                return "boolean" !== n ? [
                                    new Bt(r, e1, "boolean expected, " + n + " found")
                                ] : [];
                            },
                            number: xn,
                            color: function(t1) {
                                var e1 = t1.key, r = t1.value, n = Qr(r);
                                return "string" !== n ? [
                                    new Bt(e1, r, "color expected, " + n + " found")
                                ] : null === le(r) ? [
                                    new Bt(e1, r, 'color expected, "' + r + '" found')
                                ] : [];
                            },
                            constants: Nt,
                            enum: wn,
                            filter: zn,
                            function: _n,
                            layer: Bn,
                            object: yn,
                            source: Un,
                            light: Vn,
                            string: Nn,
                            formatted: function(t1) {
                                return 0 === Nn(t1).length ? [] : bn(t1);
                            },
                            resolvedImage: function(t1) {
                                return 0 === Nn(t1).length ? [] : bn(t1);
                            }
                        };
                        function Hn(t1) {
                            var e1 = t1.value, r = t1.valueSpec, n = t1.styleSpec;
                            return r.expression && tn(Ut(e1)) ? _n(t1) : r.expression && un(Vt(e1)) ? bn(t1) : r.type && qn[r.type] ? qn[r.type](t1) : yn(jt({}, t1, {
                                valueSpec: r.type ? n[r.type] : r
                            }));
                        }
                        function Gn(t1) {
                            var e1 = t1.value, r = t1.key, n = Nn(t1);
                            return n.length || (-1 === e1.indexOf("{fontstack}") && n.push(new Bt(r, e1, '"glyphs" url must include a "{fontstack}" token')), -1 === e1.indexOf("{range}") && n.push(new Bt(r, e1, '"glyphs" url must include a "{range}" token'))), n;
                        }
                        function Zn(t1, e1) {
                            void 0 === e1 && (e1 = Ft);
                            var r = [];
                            return r = r.concat(Hn({
                                key: "",
                                value: t1,
                                valueSpec: e1.$root,
                                styleSpec: e1,
                                style: t1,
                                objectElementValidators: {
                                    glyphs: Gn,
                                    "*": function() {
                                        return [];
                                    }
                                }
                            })), t1.constants && (r = r.concat(Nt({
                                key: "constants",
                                value: t1.constants,
                                style: t1,
                                styleSpec: e1
                            }))), Wn(r);
                        }
                        function Wn(t1) {
                            return [].concat(t1).sort(function(t1, e1) {
                                return t1.line - e1.line;
                            });
                        }
                        function Yn(t1) {
                            return function() {
                                for(var e1 = [], r = arguments.length; r--;)e1[r] = arguments[r];
                                return Wn(t1.apply(this, e1));
                            };
                        }
                        Zn.source = Yn(Un), Zn.light = Yn(Vn), Zn.layer = Yn(Bn), Zn.filter = Yn(zn), Zn.paintProperty = Yn(Rn), Zn.layoutProperty = Yn(Fn);
                        var Xn = Zn, $n = Xn.light, Jn = Xn.paintProperty, Kn = Xn.layoutProperty;
                        function Qn(t1, e1) {
                            var r = !1;
                            if (e1 && e1.length) for(var n = 0, i = e1; n < i.length; n += 1){
                                var a = i[n];
                                t1.fire(new Dt(new Error(a.message))), r = !0;
                            }
                            return r;
                        }
                        var ti = ri, ei = 3;
                        function ri(t1, e1, r) {
                            var n = this.cells = [];
                            if (t1 instanceof ArrayBuffer) {
                                this.arrayBuffer = t1;
                                var i = new Int32Array(this.arrayBuffer);
                                t1 = i[0], e1 = i[1], r = i[2], this.d = e1 + 2 * r;
                                for(var a = 0; a < this.d * this.d; a++){
                                    var o = i[ei + a], s = i[ei + a + 1];
                                    n.push(o === s ? null : i.subarray(o, s));
                                }
                                var l = i[ei + n.length], c = i[ei + n.length + 1];
                                this.keys = i.subarray(l, c), this.bboxes = i.subarray(c), this.insert = this._insertReadonly;
                            } else {
                                this.d = e1 + 2 * r;
                                for(var u = 0; u < this.d * this.d; u++)n.push([]);
                                this.keys = [], this.bboxes = [];
                            }
                            this.n = e1, this.extent = t1, this.padding = r, this.scale = e1 / t1, this.uid = 0;
                            var h = r / e1 * t1;
                            this.min = -h, this.max = t1 + h;
                        }
                        ri.prototype.insert = function(t1, e1, r, n, i) {
                            this._forEachCell(e1, r, n, i, this._insertCell, this.uid++), this.keys.push(t1), this.bboxes.push(e1), this.bboxes.push(r), this.bboxes.push(n), this.bboxes.push(i);
                        }, ri.prototype._insertReadonly = function() {
                            throw "Cannot insert into a GridIndex created from an ArrayBuffer.";
                        }, ri.prototype._insertCell = function(t1, e1, r, n, i, a) {
                            this.cells[i].push(a);
                        }, ri.prototype.query = function(t1, e1, r, n, i) {
                            var a = this.min, o = this.max;
                            if (t1 <= a && e1 <= a && o <= r && o <= n && !i) return Array.prototype.slice.call(this.keys);
                            var s = [];
                            return this._forEachCell(t1, e1, r, n, this._queryCell, s, {}, i), s;
                        }, ri.prototype._queryCell = function(t1, e1, r, n, i, a, o, s) {
                            var l = this.cells[i];
                            if (null !== l) for(var c = this.keys, u = this.bboxes, h = 0; h < l.length; h++){
                                var f = l[h];
                                if (void 0 === o[f]) {
                                    var p = 4 * f;
                                    (s ? s(u[p + 0], u[p + 1], u[p + 2], u[p + 3]) : t1 <= u[p + 2] && e1 <= u[p + 3] && r >= u[p + 0] && n >= u[p + 1]) ? (o[f] = !0, a.push(c[f])) : o[f] = !1;
                                }
                            }
                        }, ri.prototype._forEachCell = function(t1, e1, r, n, i, a, o, s) {
                            for(var l = this._convertToCellCoord(t1), c = this._convertToCellCoord(e1), u = this._convertToCellCoord(r), h = this._convertToCellCoord(n), f = l; f <= u; f++)for(var p = c; p <= h; p++){
                                var d = this.d * p + f;
                                if ((!s || s(this._convertFromCellCoord(f), this._convertFromCellCoord(p), this._convertFromCellCoord(f + 1), this._convertFromCellCoord(p + 1))) && i.call(this, t1, e1, r, n, d, a, o, s)) return;
                            }
                        }, ri.prototype._convertFromCellCoord = function(t1) {
                            return (t1 - this.padding) / this.scale;
                        }, ri.prototype._convertToCellCoord = function(t1) {
                            return Math.max(0, Math.min(this.d - 1, Math.floor(t1 * this.scale) + this.padding));
                        }, ri.prototype.toArrayBuffer = function() {
                            if (this.arrayBuffer) return this.arrayBuffer;
                            for(var t1 = this.cells, e1 = ei + this.cells.length + 1 + 1, r = 0, n = 0; n < this.cells.length; n++)r += this.cells[n].length;
                            var i = new Int32Array(e1 + r + this.keys.length + this.bboxes.length);
                            i[0] = this.extent, i[1] = this.n, i[2] = this.padding;
                            for(var a = e1, o = 0; o < t1.length; o++){
                                var s = t1[o];
                                i[ei + o] = a, i.set(s, a), a += s.length;
                            }
                            return i[ei + t1.length] = a, i.set(this.keys, a), a += this.keys.length, i[ei + t1.length + 1] = a, i.set(this.bboxes, a), a += this.bboxes.length, i.buffer;
                        };
                        var ni = s.ImageData, ii = s.ImageBitmap, ai = {};
                        function oi(t1, e1, r) {
                            void 0 === r && (r = {}), Object.defineProperty(e1, "_classRegistryKey", {
                                value: t1,
                                writeable: !1
                            }), ai[t1] = {
                                klass: e1,
                                omit: r.omit || [],
                                shallow: r.shallow || []
                            };
                        }
                        for(var si in oi("Object", Object), ti.serialize = function(t1, e1) {
                            var r = t1.toArrayBuffer();
                            return e1 && e1.push(r), {
                                buffer: r
                            };
                        }, ti.deserialize = function(t1) {
                            return new ti(t1.buffer);
                        }, oi("Grid", ti), oi("Color", ce), oi("Error", Error), oi("ResolvedImage", pe), oi("StylePropertyFunction", mn), oi("StyleExpression", cn, {
                            omit: [
                                "_evaluator"
                            ]
                        }), oi("ZoomDependentExpression", pn), oi("ZoomConstantExpression", fn), oi("CompoundExpression", Ee, {
                            omit: [
                                "_evaluate"
                            ]
                        }), qr)qr[si]._classRegistryKey || oi("Expression_" + si, qr[si]);
                        function li(t1) {
                            return t1 && "undefined" != typeof ArrayBuffer && (t1 instanceof ArrayBuffer || t1.constructor && "ArrayBuffer" === t1.constructor.name);
                        }
                        function ci(t1) {
                            return ii && t1 instanceof ii;
                        }
                        function ui(t1, e1) {
                            if (null == t1 || "boolean" == typeof t1 || "number" == typeof t1 || "string" == typeof t1 || t1 instanceof Boolean || t1 instanceof Number || t1 instanceof String || t1 instanceof Date || t1 instanceof RegExp) return t1;
                            if (li(t1) || ci(t1)) return e1 && e1.push(t1), t1;
                            if (ArrayBuffer.isView(t1)) {
                                var r = t1;
                                return e1 && e1.push(r.buffer), r;
                            }
                            if (t1 instanceof ni) return e1 && e1.push(t1.data.buffer), t1;
                            if (Array.isArray(t1)) {
                                for(var n = [], i = 0, a = t1; i < a.length; i += 1){
                                    var o = a[i];
                                    n.push(ui(o, e1));
                                }
                                return n;
                            }
                            if ("object" == typeof t1) {
                                var s = t1.constructor, l = s._classRegistryKey;
                                if (!l) throw new Error("can't serialize object of unregistered class");
                                var c = s.serialize ? s.serialize(t1, e1) : {};
                                if (!s.serialize) {
                                    for(var u in t1)if (t1.hasOwnProperty(u) && !(ai[l].omit.indexOf(u) >= 0)) {
                                        var h = t1[u];
                                        c[u] = ai[l].shallow.indexOf(u) >= 0 ? h : ui(h, e1);
                                    }
                                    t1 instanceof Error && (c.message = t1.message);
                                }
                                if (c.$name) throw new Error("$name property is reserved for worker serialization logic.");
                                return "Object" !== l && (c.$name = l), c;
                            }
                            throw new Error("can't serialize object of type " + typeof t1);
                        }
                        function hi(t1) {
                            if (null == t1 || "boolean" == typeof t1 || "number" == typeof t1 || "string" == typeof t1 || t1 instanceof Boolean || t1 instanceof Number || t1 instanceof String || t1 instanceof Date || t1 instanceof RegExp || li(t1) || ci(t1) || ArrayBuffer.isView(t1) || t1 instanceof ni) return t1;
                            if (Array.isArray(t1)) return t1.map(hi);
                            if ("object" == typeof t1) {
                                var e1 = t1.$name || "Object", r = ai[e1].klass;
                                if (!r) throw new Error("can't deserialize unregistered class " + e1);
                                if (r.deserialize) return r.deserialize(t1);
                                for(var n = Object.create(r.prototype), i = 0, a = Object.keys(t1); i < a.length; i += 1){
                                    var o = a[i];
                                    if ("$name" !== o) {
                                        var s = t1[o];
                                        n[o] = ai[e1].shallow.indexOf(o) >= 0 ? s : hi(s);
                                    }
                                }
                                return n;
                            }
                            throw new Error("can't deserialize object of type " + typeof t1);
                        }
                        var fi = function() {
                            this.first = !0;
                        };
                        fi.prototype.update = function(t1, e1) {
                            var r = Math.floor(t1);
                            return this.first ? (this.first = !1, this.lastIntegerZoom = r, this.lastIntegerZoomTime = 0, this.lastZoom = t1, this.lastFloorZoom = r, !0) : (this.lastFloorZoom > r ? (this.lastIntegerZoom = r + 1, this.lastIntegerZoomTime = e1) : this.lastFloorZoom < r && (this.lastIntegerZoom = r, this.lastIntegerZoomTime = e1), t1 !== this.lastZoom && (this.lastZoom = t1, this.lastFloorZoom = r, !0));
                        };
                        var pi = {
                            "Latin-1 Supplement": function(t1) {
                                return t1 >= 128 && t1 <= 255;
                            },
                            Arabic: function(t1) {
                                return t1 >= 1536 && t1 <= 1791;
                            },
                            "Arabic Supplement": function(t1) {
                                return t1 >= 1872 && t1 <= 1919;
                            },
                            "Arabic Extended-A": function(t1) {
                                return t1 >= 2208 && t1 <= 2303;
                            },
                            "Hangul Jamo": function(t1) {
                                return t1 >= 4352 && t1 <= 4607;
                            },
                            "Unified Canadian Aboriginal Syllabics": function(t1) {
                                return t1 >= 5120 && t1 <= 5759;
                            },
                            Khmer: function(t1) {
                                return t1 >= 6016 && t1 <= 6143;
                            },
                            "Unified Canadian Aboriginal Syllabics Extended": function(t1) {
                                return t1 >= 6320 && t1 <= 6399;
                            },
                            "General Punctuation": function(t1) {
                                return t1 >= 8192 && t1 <= 8303;
                            },
                            "Letterlike Symbols": function(t1) {
                                return t1 >= 8448 && t1 <= 8527;
                            },
                            "Number Forms": function(t1) {
                                return t1 >= 8528 && t1 <= 8591;
                            },
                            "Miscellaneous Technical": function(t1) {
                                return t1 >= 8960 && t1 <= 9215;
                            },
                            "Control Pictures": function(t1) {
                                return t1 >= 9216 && t1 <= 9279;
                            },
                            "Optical Character Recognition": function(t1) {
                                return t1 >= 9280 && t1 <= 9311;
                            },
                            "Enclosed Alphanumerics": function(t1) {
                                return t1 >= 9312 && t1 <= 9471;
                            },
                            "Geometric Shapes": function(t1) {
                                return t1 >= 9632 && t1 <= 9727;
                            },
                            "Miscellaneous Symbols": function(t1) {
                                return t1 >= 9728 && t1 <= 9983;
                            },
                            "Miscellaneous Symbols and Arrows": function(t1) {
                                return t1 >= 11008 && t1 <= 11263;
                            },
                            "CJK Radicals Supplement": function(t1) {
                                return t1 >= 11904 && t1 <= 12031;
                            },
                            "Kangxi Radicals": function(t1) {
                                return t1 >= 12032 && t1 <= 12255;
                            },
                            "Ideographic Description Characters": function(t1) {
                                return t1 >= 12272 && t1 <= 12287;
                            },
                            "CJK Symbols and Punctuation": function(t1) {
                                return t1 >= 12288 && t1 <= 12351;
                            },
                            Hiragana: function(t1) {
                                return t1 >= 12352 && t1 <= 12447;
                            },
                            Katakana: function(t1) {
                                return t1 >= 12448 && t1 <= 12543;
                            },
                            Bopomofo: function(t1) {
                                return t1 >= 12544 && t1 <= 12591;
                            },
                            "Hangul Compatibility Jamo": function(t1) {
                                return t1 >= 12592 && t1 <= 12687;
                            },
                            Kanbun: function(t1) {
                                return t1 >= 12688 && t1 <= 12703;
                            },
                            "Bopomofo Extended": function(t1) {
                                return t1 >= 12704 && t1 <= 12735;
                            },
                            "CJK Strokes": function(t1) {
                                return t1 >= 12736 && t1 <= 12783;
                            },
                            "Katakana Phonetic Extensions": function(t1) {
                                return t1 >= 12784 && t1 <= 12799;
                            },
                            "Enclosed CJK Letters and Months": function(t1) {
                                return t1 >= 12800 && t1 <= 13055;
                            },
                            "CJK Compatibility": function(t1) {
                                return t1 >= 13056 && t1 <= 13311;
                            },
                            "CJK Unified Ideographs Extension A": function(t1) {
                                return t1 >= 13312 && t1 <= 19903;
                            },
                            "Yijing Hexagram Symbols": function(t1) {
                                return t1 >= 19904 && t1 <= 19967;
                            },
                            "CJK Unified Ideographs": function(t1) {
                                return t1 >= 19968 && t1 <= 40959;
                            },
                            "Yi Syllables": function(t1) {
                                return t1 >= 40960 && t1 <= 42127;
                            },
                            "Yi Radicals": function(t1) {
                                return t1 >= 42128 && t1 <= 42191;
                            },
                            "Hangul Jamo Extended-A": function(t1) {
                                return t1 >= 43360 && t1 <= 43391;
                            },
                            "Hangul Syllables": function(t1) {
                                return t1 >= 44032 && t1 <= 55215;
                            },
                            "Hangul Jamo Extended-B": function(t1) {
                                return t1 >= 55216 && t1 <= 55295;
                            },
                            "Private Use Area": function(t1) {
                                return t1 >= 57344 && t1 <= 63743;
                            },
                            "CJK Compatibility Ideographs": function(t1) {
                                return t1 >= 63744 && t1 <= 64255;
                            },
                            "Arabic Presentation Forms-A": function(t1) {
                                return t1 >= 64336 && t1 <= 65023;
                            },
                            "Vertical Forms": function(t1) {
                                return t1 >= 65040 && t1 <= 65055;
                            },
                            "CJK Compatibility Forms": function(t1) {
                                return t1 >= 65072 && t1 <= 65103;
                            },
                            "Small Form Variants": function(t1) {
                                return t1 >= 65104 && t1 <= 65135;
                            },
                            "Arabic Presentation Forms-B": function(t1) {
                                return t1 >= 65136 && t1 <= 65279;
                            },
                            "Halfwidth and Fullwidth Forms": function(t1) {
                                return t1 >= 65280 && t1 <= 65519;
                            }
                        };
                        function di(t1) {
                            for(var e1 = 0, r = t1; e1 < r.length; e1 += 1)if (mi(r[e1].charCodeAt(0))) return !0;
                            return !1;
                        }
                        function mi(t1) {
                            return !(746 !== t1 && 747 !== t1 && (t1 < 4352 || !(pi["Bopomofo Extended"](t1) || pi.Bopomofo(t1) || pi["CJK Compatibility Forms"](t1) && !(t1 >= 65097 && t1 <= 65103) || pi["CJK Compatibility Ideographs"](t1) || pi["CJK Compatibility"](t1) || pi["CJK Radicals Supplement"](t1) || pi["CJK Strokes"](t1) || !(!pi["CJK Symbols and Punctuation"](t1) || t1 >= 12296 && t1 <= 12305 || t1 >= 12308 && t1 <= 12319 || 12336 === t1) || pi["CJK Unified Ideographs Extension A"](t1) || pi["CJK Unified Ideographs"](t1) || pi["Enclosed CJK Letters and Months"](t1) || pi["Hangul Compatibility Jamo"](t1) || pi["Hangul Jamo Extended-A"](t1) || pi["Hangul Jamo Extended-B"](t1) || pi["Hangul Jamo"](t1) || pi["Hangul Syllables"](t1) || pi.Hiragana(t1) || pi["Ideographic Description Characters"](t1) || pi.Kanbun(t1) || pi["Kangxi Radicals"](t1) || pi["Katakana Phonetic Extensions"](t1) || pi.Katakana(t1) && 12540 !== t1 || !(!pi["Halfwidth and Fullwidth Forms"](t1) || 65288 === t1 || 65289 === t1 || 65293 === t1 || t1 >= 65306 && t1 <= 65310 || 65339 === t1 || 65341 === t1 || 65343 === t1 || t1 >= 65371 && t1 <= 65503 || 65507 === t1 || t1 >= 65512 && t1 <= 65519) || !(!pi["Small Form Variants"](t1) || t1 >= 65112 && t1 <= 65118 || t1 >= 65123 && t1 <= 65126) || pi["Unified Canadian Aboriginal Syllabics"](t1) || pi["Unified Canadian Aboriginal Syllabics Extended"](t1) || pi["Vertical Forms"](t1) || pi["Yijing Hexagram Symbols"](t1) || pi["Yi Syllables"](t1) || pi["Yi Radicals"](t1))));
                        }
                        function gi(t1) {
                            return !(mi(t1) || function(t1) {
                                return !!(pi["Latin-1 Supplement"](t1) && (167 === t1 || 169 === t1 || 174 === t1 || 177 === t1 || 188 === t1 || 189 === t1 || 190 === t1 || 215 === t1 || 247 === t1) || pi["General Punctuation"](t1) && (8214 === t1 || 8224 === t1 || 8225 === t1 || 8240 === t1 || 8241 === t1 || 8251 === t1 || 8252 === t1 || 8258 === t1 || 8263 === t1 || 8264 === t1 || 8265 === t1 || 8273 === t1) || pi["Letterlike Symbols"](t1) || pi["Number Forms"](t1) || pi["Miscellaneous Technical"](t1) && (t1 >= 8960 && t1 <= 8967 || t1 >= 8972 && t1 <= 8991 || t1 >= 8996 && t1 <= 9e3 || 9003 === t1 || t1 >= 9085 && t1 <= 9114 || t1 >= 9150 && t1 <= 9165 || 9167 === t1 || t1 >= 9169 && t1 <= 9179 || t1 >= 9186 && t1 <= 9215) || pi["Control Pictures"](t1) && 9251 !== t1 || pi["Optical Character Recognition"](t1) || pi["Enclosed Alphanumerics"](t1) || pi["Geometric Shapes"](t1) || pi["Miscellaneous Symbols"](t1) && !(t1 >= 9754 && t1 <= 9759) || pi["Miscellaneous Symbols and Arrows"](t1) && (t1 >= 11026 && t1 <= 11055 || t1 >= 11088 && t1 <= 11097 || t1 >= 11192 && t1 <= 11243) || pi["CJK Symbols and Punctuation"](t1) || pi.Katakana(t1) || pi["Private Use Area"](t1) || pi["CJK Compatibility Forms"](t1) || pi["Small Form Variants"](t1) || pi["Halfwidth and Fullwidth Forms"](t1) || 8734 === t1 || 8756 === t1 || 8757 === t1 || t1 >= 9984 && t1 <= 10087 || t1 >= 10102 && t1 <= 10131 || 65532 === t1 || 65533 === t1);
                            }(t1));
                        }
                        function yi(t1) {
                            return pi.Arabic(t1) || pi["Arabic Supplement"](t1) || pi["Arabic Extended-A"](t1) || pi["Arabic Presentation Forms-A"](t1) || pi["Arabic Presentation Forms-B"](t1);
                        }
                        function vi(t1) {
                            return t1 >= 1424 && t1 <= 2303 || pi["Arabic Presentation Forms-A"](t1) || pi["Arabic Presentation Forms-B"](t1);
                        }
                        function xi(t1, e1) {
                            return !(!e1 && vi(t1) || t1 >= 2304 && t1 <= 3583 || t1 >= 3840 && t1 <= 4255 || pi.Khmer(t1));
                        }
                        function _i(t1) {
                            for(var e1 = 0, r = t1; e1 < r.length; e1 += 1)if (vi(r[e1].charCodeAt(0))) return !0;
                            return !1;
                        }
                        var bi = "deferred", wi = "loading", Ti = "loaded", ki = "error", Ai = null, Mi = "unavailable", Si = null, Ei = function(t1) {
                            t1 && "string" == typeof t1 && t1.indexOf("NetworkError") > -1 && (Mi = ki), Ai && Ai(t1);
                        };
                        function Ci() {
                            Li.fire(new Ot("pluginStateChange", {
                                pluginStatus: Mi,
                                pluginURL: Si
                            }));
                        }
                        var Li = new Rt, Ii = function() {
                            return Mi;
                        }, Pi = function() {
                            if (Mi !== bi || !Si) throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");
                            Mi = wi, Ci(), Si && Mt({
                                url: Si
                            }, function(t1) {
                                t1 ? Ei(t1) : (Mi = Ti, Ci());
                            });
                        }, zi = {
                            applyArabicShaping: null,
                            processBidirectionalText: null,
                            processStyledBidirectionalText: null,
                            isLoaded: function() {
                                return Mi === Ti || null != zi.applyArabicShaping;
                            },
                            isLoading: function() {
                                return Mi === wi;
                            },
                            setState: function(t1) {
                                Mi = t1.pluginStatus, Si = t1.pluginURL;
                            },
                            isParsed: function() {
                                return null != zi.applyArabicShaping && null != zi.processBidirectionalText && null != zi.processStyledBidirectionalText;
                            },
                            getPluginURL: function() {
                                return Si;
                            }
                        }, Oi = function(t1, e1) {
                            this.zoom = t1, e1 ? (this.now = e1.now, this.fadeDuration = e1.fadeDuration, this.zoomHistory = e1.zoomHistory, this.transition = e1.transition) : (this.now = 0, this.fadeDuration = 0, this.zoomHistory = new fi, this.transition = {});
                        };
                        Oi.prototype.isSupportedScript = function(t1) {
                            return function(t1, e1) {
                                for(var r = 0, n = t1; r < n.length; r += 1)if (!xi(n[r].charCodeAt(0), e1)) return !1;
                                return !0;
                            }(t1, zi.isLoaded());
                        }, Oi.prototype.crossFadingFactor = function() {
                            return 0 === this.fadeDuration ? 1 : Math.min((this.now - this.zoomHistory.lastIntegerZoomTime) / this.fadeDuration, 1);
                        }, Oi.prototype.getCrossfadeParameters = function() {
                            var t1 = this.zoom, e1 = t1 - Math.floor(t1), r = this.crossFadingFactor();
                            return t1 > this.zoomHistory.lastIntegerZoom ? {
                                fromScale: 2,
                                toScale: 1,
                                t: e1 + (1 - e1) * r
                            } : {
                                fromScale: .5,
                                toScale: 1,
                                t: 1 - (1 - r) * e1
                            };
                        };
                        var Di = function(t1, e1) {
                            this.property = t1, this.value = e1, this.expression = function(t1, e1) {
                                if (tn(t1)) return new mn(t1, e1);
                                if (un(t1)) {
                                    var r = dn(t1, e1);
                                    if ("error" === r.result) throw new Error(r.value.map(function(t1) {
                                        return t1.key + ": " + t1.message;
                                    }).join(", "));
                                    return r.value;
                                }
                                var n = t1;
                                return "string" == typeof t1 && "color" === e1.type && (n = ce.parse(t1)), {
                                    kind: "constant",
                                    evaluate: function() {
                                        return n;
                                    }
                                };
                            }(void 0 === e1 ? t1.specification.default : e1, t1.specification);
                        };
                        Di.prototype.isDataDriven = function() {
                            return "source" === this.expression.kind || "composite" === this.expression.kind;
                        }, Di.prototype.possiblyEvaluate = function(t1, e1, r) {
                            return this.property.possiblyEvaluate(this, t1, e1, r);
                        };
                        var Ri = function(t1) {
                            this.property = t1, this.value = new Di(t1, void 0);
                        };
                        Ri.prototype.transitioned = function(t1, e1) {
                            return new Bi(this.property, this.value, e1, p({}, t1.transition, this.transition), t1.now);
                        }, Ri.prototype.untransitioned = function() {
                            return new Bi(this.property, this.value, null, {}, 0);
                        };
                        var Fi = function(t1) {
                            this._properties = t1, this._values = Object.create(t1.defaultTransitionablePropertyValues);
                        };
                        Fi.prototype.getValue = function(t1) {
                            return w(this._values[t1].value.value);
                        }, Fi.prototype.setValue = function(t1, e1) {
                            this._values.hasOwnProperty(t1) || (this._values[t1] = new Ri(this._values[t1].property)), this._values[t1].value = new Di(this._values[t1].property, null === e1 ? void 0 : w(e1));
                        }, Fi.prototype.getTransition = function(t1) {
                            return w(this._values[t1].transition);
                        }, Fi.prototype.setTransition = function(t1, e1) {
                            this._values.hasOwnProperty(t1) || (this._values[t1] = new Ri(this._values[t1].property)), this._values[t1].transition = w(e1) || void 0;
                        }, Fi.prototype.serialize = function() {
                            for(var t1 = {}, e1 = 0, r = Object.keys(this._values); e1 < r.length; e1 += 1){
                                var n = r[e1], i = this.getValue(n);
                                void 0 !== i && (t1[n] = i);
                                var a = this.getTransition(n);
                                void 0 !== a && (t1[n + "-transition"] = a);
                            }
                            return t1;
                        }, Fi.prototype.transitioned = function(t1, e1) {
                            for(var r = new Ni(this._properties), n = 0, i = Object.keys(this._values); n < i.length; n += 1){
                                var a = i[n];
                                r._values[a] = this._values[a].transitioned(t1, e1._values[a]);
                            }
                            return r;
                        }, Fi.prototype.untransitioned = function() {
                            for(var t1 = new Ni(this._properties), e1 = 0, r = Object.keys(this._values); e1 < r.length; e1 += 1){
                                var n = r[e1];
                                t1._values[n] = this._values[n].untransitioned();
                            }
                            return t1;
                        };
                        var Bi = function(t1, e1, r, n, i) {
                            this.property = t1, this.value = e1, this.begin = i + n.delay || 0, this.end = this.begin + n.duration || 0, t1.specification.transition && (n.delay || n.duration) && (this.prior = r);
                        };
                        Bi.prototype.possiblyEvaluate = function(t1, e1, r) {
                            var n = t1.now || 0, i = this.value.possiblyEvaluate(t1, e1, r), a = this.prior;
                            if (a) {
                                if (n > this.end) return this.prior = null, i;
                                if (this.value.isDataDriven()) return this.prior = null, i;
                                if (n < this.begin) return a.possiblyEvaluate(t1, e1, r);
                                var o = (n - this.begin) / (this.end - this.begin);
                                return this.property.interpolate(a.possiblyEvaluate(t1, e1, r), i, function(t1) {
                                    if (t1 <= 0) return 0;
                                    if (t1 >= 1) return 1;
                                    var e1 = t1 * t1, r = e1 * t1;
                                    return 4 * (t1 < .5 ? r : 3 * (t1 - e1) + r - .75);
                                }(o));
                            }
                            return i;
                        };
                        var Ni = function(t1) {
                            this._properties = t1, this._values = Object.create(t1.defaultTransitioningPropertyValues);
                        };
                        Ni.prototype.possiblyEvaluate = function(t1, e1, r) {
                            for(var n = new Vi(this._properties), i = 0, a = Object.keys(this._values); i < a.length; i += 1){
                                var o = a[i];
                                n._values[o] = this._values[o].possiblyEvaluate(t1, e1, r);
                            }
                            return n;
                        }, Ni.prototype.hasTransition = function() {
                            for(var t1 = 0, e1 = Object.keys(this._values); t1 < e1.length; t1 += 1){
                                var r = e1[t1];
                                if (this._values[r].prior) return !0;
                            }
                            return !1;
                        };
                        var ji = function(t1) {
                            this._properties = t1, this._values = Object.create(t1.defaultPropertyValues);
                        };
                        ji.prototype.getValue = function(t1) {
                            return w(this._values[t1].value);
                        }, ji.prototype.setValue = function(t1, e1) {
                            this._values[t1] = new Di(this._values[t1].property, null === e1 ? void 0 : w(e1));
                        }, ji.prototype.serialize = function() {
                            for(var t1 = {}, e1 = 0, r = Object.keys(this._values); e1 < r.length; e1 += 1){
                                var n = r[e1], i = this.getValue(n);
                                void 0 !== i && (t1[n] = i);
                            }
                            return t1;
                        }, ji.prototype.possiblyEvaluate = function(t1, e1, r) {
                            for(var n = new Vi(this._properties), i = 0, a = Object.keys(this._values); i < a.length; i += 1){
                                var o = a[i];
                                n._values[o] = this._values[o].possiblyEvaluate(t1, e1, r);
                            }
                            return n;
                        };
                        var Ui = function(t1, e1, r) {
                            this.property = t1, this.value = e1, this.parameters = r;
                        };
                        Ui.prototype.isConstant = function() {
                            return "constant" === this.value.kind;
                        }, Ui.prototype.constantOr = function(t1) {
                            return "constant" === this.value.kind ? this.value.value : t1;
                        }, Ui.prototype.evaluate = function(t1, e1, r, n) {
                            return this.property.evaluate(this.value, this.parameters, t1, e1, r, n);
                        };
                        var Vi = function(t1) {
                            this._properties = t1, this._values = Object.create(t1.defaultPossiblyEvaluatedValues);
                        };
                        Vi.prototype.get = function(t1) {
                            return this._values[t1];
                        };
                        var qi = function(t1) {
                            this.specification = t1;
                        };
                        qi.prototype.possiblyEvaluate = function(t1, e1) {
                            return t1.expression.evaluate(e1);
                        }, qi.prototype.interpolate = function(t1, e1, r) {
                            var n = rr[this.specification.type];
                            return n ? n(t1, e1, r) : t1;
                        };
                        var Hi = function(t1, e1) {
                            this.specification = t1, this.overrides = e1;
                        };
                        Hi.prototype.possiblyEvaluate = function(t1, e1, r, n) {
                            return "constant" === t1.expression.kind || "camera" === t1.expression.kind ? new Ui(this, {
                                kind: "constant",
                                value: t1.expression.evaluate(e1, null, {}, r, n)
                            }, e1) : new Ui(this, t1.expression, e1);
                        }, Hi.prototype.interpolate = function(t1, e1, r) {
                            if ("constant" !== t1.value.kind || "constant" !== e1.value.kind) return t1;
                            if (void 0 === t1.value.value || void 0 === e1.value.value) return new Ui(this, {
                                kind: "constant",
                                value: void 0
                            }, t1.parameters);
                            var n = rr[this.specification.type];
                            return n ? new Ui(this, {
                                kind: "constant",
                                value: n(t1.value.value, e1.value.value, r)
                            }, t1.parameters) : t1;
                        }, Hi.prototype.evaluate = function(t1, e1, r, n, i, a) {
                            return "constant" === t1.kind ? t1.value : t1.evaluate(e1, r, n, i, a);
                        };
                        var Gi = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.possiblyEvaluate = function(t1, e1, r, n) {
                                if (void 0 === t1.value) return new Ui(this, {
                                    kind: "constant",
                                    value: void 0
                                }, e1);
                                if ("constant" === t1.expression.kind) {
                                    var i = t1.expression.evaluate(e1, null, {}, r, n), a = "resolvedImage" === t1.property.specification.type && "string" != typeof i ? i.name : i, o = this._calculate(a, a, a, e1);
                                    return new Ui(this, {
                                        kind: "constant",
                                        value: o
                                    }, e1);
                                }
                                if ("camera" === t1.expression.kind) {
                                    var s = this._calculate(t1.expression.evaluate({
                                        zoom: e1.zoom - 1
                                    }), t1.expression.evaluate({
                                        zoom: e1.zoom
                                    }), t1.expression.evaluate({
                                        zoom: e1.zoom + 1
                                    }), e1);
                                    return new Ui(this, {
                                        kind: "constant",
                                        value: s
                                    }, e1);
                                }
                                return new Ui(this, t1.expression, e1);
                            }, e1.prototype.evaluate = function(t1, e1, r, n, i, a) {
                                if ("source" === t1.kind) {
                                    var o = t1.evaluate(e1, r, n, i, a);
                                    return this._calculate(o, o, o, e1);
                                }
                                return "composite" === t1.kind ? this._calculate(t1.evaluate({
                                    zoom: Math.floor(e1.zoom) - 1
                                }, r, n), t1.evaluate({
                                    zoom: Math.floor(e1.zoom)
                                }, r, n), t1.evaluate({
                                    zoom: Math.floor(e1.zoom) + 1
                                }, r, n), e1) : t1.value;
                            }, e1.prototype._calculate = function(t1, e1, r, n) {
                                return n.zoom > n.zoomHistory.lastIntegerZoom ? {
                                    from: t1,
                                    to: e1
                                } : {
                                    from: r,
                                    to: e1
                                };
                            }, e1.prototype.interpolate = function(t1) {
                                return t1;
                            }, e1;
                        }(Hi), Zi = function(t1) {
                            this.specification = t1;
                        };
                        Zi.prototype.possiblyEvaluate = function(t1, e1, r, n) {
                            if (void 0 !== t1.value) {
                                if ("constant" === t1.expression.kind) {
                                    var i = t1.expression.evaluate(e1, null, {}, r, n);
                                    return this._calculate(i, i, i, e1);
                                }
                                return this._calculate(t1.expression.evaluate(new Oi(Math.floor(e1.zoom - 1), e1)), t1.expression.evaluate(new Oi(Math.floor(e1.zoom), e1)), t1.expression.evaluate(new Oi(Math.floor(e1.zoom + 1), e1)), e1);
                            }
                        }, Zi.prototype._calculate = function(t1, e1, r, n) {
                            return n.zoom > n.zoomHistory.lastIntegerZoom ? {
                                from: t1,
                                to: e1
                            } : {
                                from: r,
                                to: e1
                            };
                        }, Zi.prototype.interpolate = function(t1) {
                            return t1;
                        };
                        var Wi = function(t1) {
                            this.specification = t1;
                        };
                        Wi.prototype.possiblyEvaluate = function(t1, e1, r, n) {
                            return !!t1.expression.evaluate(e1, null, {}, r, n);
                        }, Wi.prototype.interpolate = function() {
                            return !1;
                        };
                        var Yi = function(t1) {
                            for(var e1 in this.properties = t1, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [], t1){
                                var r = t1[e1];
                                r.specification.overridable && this.overridableProperties.push(e1);
                                var n = this.defaultPropertyValues[e1] = new Di(r, void 0), i = this.defaultTransitionablePropertyValues[e1] = new Ri(r);
                                this.defaultTransitioningPropertyValues[e1] = i.untransitioned(), this.defaultPossiblyEvaluatedValues[e1] = n.possiblyEvaluate({});
                            }
                        };
                        oi("DataDrivenProperty", Hi), oi("DataConstantProperty", qi), oi("CrossFadedDataDrivenProperty", Gi), oi("CrossFadedProperty", Zi), oi("ColorRampProperty", Wi);
                        var Xi = "-transition", $i = function(t1) {
                            function e1(e1, r) {
                                if (t1.call(this), this.id = e1.id, this.type = e1.type, this._featureFilter = {
                                    filter: function() {
                                        return !0;
                                    },
                                    needGeometry: !1
                                }, "custom" !== e1.type && (this.metadata = e1.metadata, this.minzoom = e1.minzoom, this.maxzoom = e1.maxzoom, "background" !== e1.type && (this.source = e1.source, this.sourceLayer = e1["source-layer"], this.filter = e1.filter), r.layout && (this._unevaluatedLayout = new ji(r.layout)), r.paint)) {
                                    for(var n in this._transitionablePaint = new Fi(r.paint), e1.paint)this.setPaintProperty(n, e1.paint[n], {
                                        validate: !1
                                    });
                                    for(var i in e1.layout)this.setLayoutProperty(i, e1.layout[i], {
                                        validate: !1
                                    });
                                    this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new Vi(r.paint);
                                }
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getCrossfadeParameters = function() {
                                return this._crossfadeParameters;
                            }, e1.prototype.getLayoutProperty = function(t1) {
                                return "visibility" === t1 ? this.visibility : this._unevaluatedLayout.getValue(t1);
                            }, e1.prototype.setLayoutProperty = function(t1, e1, r) {
                                if (void 0 === r && (r = {}), null != e1) {
                                    var n = "layers." + this.id + ".layout." + t1;
                                    if (this._validate(Kn, n, t1, e1, r)) return;
                                }
                                "visibility" !== t1 ? this._unevaluatedLayout.setValue(t1, e1) : this.visibility = e1;
                            }, e1.prototype.getPaintProperty = function(t1) {
                                return x(t1, Xi) ? this._transitionablePaint.getTransition(t1.slice(0, -11)) : this._transitionablePaint.getValue(t1);
                            }, e1.prototype.setPaintProperty = function(t1, e1, r) {
                                if (void 0 === r && (r = {}), null != e1) {
                                    var n = "layers." + this.id + ".paint." + t1;
                                    if (this._validate(Jn, n, t1, e1, r)) return !1;
                                }
                                if (x(t1, Xi)) return this._transitionablePaint.setTransition(t1.slice(0, -11), e1 || void 0), !1;
                                var i = this._transitionablePaint._values[t1], a = "cross-faded-data-driven" === i.property.specification["property-type"], o = i.value.isDataDriven(), s = i.value;
                                this._transitionablePaint.setValue(t1, e1), this._handleSpecialPaintPropertyUpdate(t1);
                                var l = this._transitionablePaint._values[t1].value;
                                return l.isDataDriven() || o || a || this._handleOverridablePaintPropertyUpdate(t1, s, l);
                            }, e1.prototype._handleSpecialPaintPropertyUpdate = function(t1) {}, e1.prototype._handleOverridablePaintPropertyUpdate = function(t1, e1, r) {
                                return !1;
                            }, e1.prototype.isHidden = function(t1) {
                                return !!(this.minzoom && t1 < this.minzoom) || !!(this.maxzoom && t1 >= this.maxzoom) || "none" === this.visibility;
                            }, e1.prototype.updateTransitions = function(t1) {
                                this._transitioningPaint = this._transitionablePaint.transitioned(t1, this._transitioningPaint);
                            }, e1.prototype.hasTransition = function() {
                                return this._transitioningPaint.hasTransition();
                            }, e1.prototype.recalculate = function(t1, e1) {
                                t1.getCrossfadeParameters && (this._crossfadeParameters = t1.getCrossfadeParameters()), this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(t1, void 0, e1)), this.paint = this._transitioningPaint.possiblyEvaluate(t1, void 0, e1);
                            }, e1.prototype.serialize = function() {
                                var t1 = {
                                    id: this.id,
                                    type: this.type,
                                    source: this.source,
                                    "source-layer": this.sourceLayer,
                                    metadata: this.metadata,
                                    minzoom: this.minzoom,
                                    maxzoom: this.maxzoom,
                                    filter: this.filter,
                                    layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
                                    paint: this._transitionablePaint && this._transitionablePaint.serialize()
                                };
                                return this.visibility && (t1.layout = t1.layout || {}, t1.layout.visibility = this.visibility), b(t1, function(t1, e1) {
                                    return !(void 0 === t1 || "layout" === e1 && !Object.keys(t1).length || "paint" === e1 && !Object.keys(t1).length);
                                });
                            }, e1.prototype._validate = function(t1, e1, r, n, i) {
                                return void 0 === i && (i = {}), (!i || !1 !== i.validate) && Qn(this, t1.call(Xn, {
                                    key: e1,
                                    layerType: this.type,
                                    objectKey: r,
                                    value: n,
                                    styleSpec: Ft,
                                    style: {
                                        glyphs: !0,
                                        sprite: !0
                                    }
                                }));
                            }, e1.prototype.is3D = function() {
                                return !1;
                            }, e1.prototype.isTileClipped = function() {
                                return !1;
                            }, e1.prototype.hasOffscreenPass = function() {
                                return !1;
                            }, e1.prototype.resize = function() {}, e1.prototype.isStateDependent = function() {
                                for(var t1 in this.paint._values){
                                    var e1 = this.paint.get(t1);
                                    if (e1 instanceof Ui && $r(e1.property.specification) && ("source" === e1.value.kind || "composite" === e1.value.kind) && e1.value.isStateDependent) return !0;
                                }
                                return !1;
                            }, e1;
                        }(Rt), Ji = {
                            Int8: Int8Array,
                            Uint8: Uint8Array,
                            Int16: Int16Array,
                            Uint16: Uint16Array,
                            Int32: Int32Array,
                            Uint32: Uint32Array,
                            Float32: Float32Array
                        }, Ki = function(t1, e1) {
                            this._structArray = t1, this._pos1 = e1 * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
                        }, Qi = function() {
                            this.isTransferred = !1, this.capacity = -1, this.resize(0);
                        };
                        function ta(t1, e1) {
                            void 0 === e1 && (e1 = 1);
                            var r = 0, n = 0;
                            return {
                                members: t1.map(function(t1) {
                                    var i, a = (i = t1.type, Ji[i].BYTES_PER_ELEMENT), o = r = ea(r, Math.max(e1, a)), s = t1.components || 1;
                                    return n = Math.max(n, a), r += a * s, {
                                        name: t1.name,
                                        type: t1.type,
                                        components: s,
                                        offset: o
                                    };
                                }),
                                size: ea(r, Math.max(n, e1)),
                                alignment: e1
                            };
                        }
                        function ea(t1, e1) {
                            return Math.ceil(t1 / e1) * e1;
                        }
                        Qi.serialize = function(t1, e1) {
                            return t1._trim(), e1 && (t1.isTransferred = !0, e1.push(t1.arrayBuffer)), {
                                length: t1.length,
                                arrayBuffer: t1.arrayBuffer
                            };
                        }, Qi.deserialize = function(t1) {
                            var e1 = Object.create(this.prototype);
                            return e1.arrayBuffer = t1.arrayBuffer, e1.length = t1.length, e1.capacity = t1.arrayBuffer.byteLength / e1.bytesPerElement, e1._refreshViews(), e1;
                        }, Qi.prototype._trim = function() {
                            this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
                        }, Qi.prototype.clear = function() {
                            this.length = 0;
                        }, Qi.prototype.resize = function(t1) {
                            this.reserve(t1), this.length = t1;
                        }, Qi.prototype.reserve = function(t1) {
                            if (t1 > this.capacity) {
                                this.capacity = Math.max(t1, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                                var e1 = this.uint8;
                                this._refreshViews(), e1 && this.uint8.set(e1);
                            }
                        }, Qi.prototype._refreshViews = function() {
                            throw new Error("_refreshViews() must be implemented by each concrete StructArray layout");
                        };
                        var ra = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1) {
                                var r = this.length;
                                return this.resize(r + 1), this.emplace(r, t1, e1);
                            }, e1.prototype.emplace = function(t1, e1, r) {
                                var n = 2 * t1;
                                return this.int16[n + 0] = e1, this.int16[n + 1] = r, t1;
                            }, e1;
                        }(Qi);
                        ra.prototype.bytesPerElement = 4, oi("StructArrayLayout2i4", ra);
                        var na = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r, n) {
                                var i = this.length;
                                return this.resize(i + 1), this.emplace(i, t1, e1, r, n);
                            }, e1.prototype.emplace = function(t1, e1, r, n, i) {
                                var a = 4 * t1;
                                return this.int16[a + 0] = e1, this.int16[a + 1] = r, this.int16[a + 2] = n, this.int16[a + 3] = i, t1;
                            }, e1;
                        }(Qi);
                        na.prototype.bytesPerElement = 8, oi("StructArrayLayout4i8", na);
                        var ia = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a) {
                                var o = this.length;
                                return this.resize(o + 1), this.emplace(o, t1, e1, r, n, i, a);
                            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o) {
                                var s = 6 * t1;
                                return this.int16[s + 0] = e1, this.int16[s + 1] = r, this.int16[s + 2] = n, this.int16[s + 3] = i, this.int16[s + 4] = a, this.int16[s + 5] = o, t1;
                            }, e1;
                        }(Qi);
                        ia.prototype.bytesPerElement = 12, oi("StructArrayLayout2i4i12", ia);
                        var aa = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a) {
                                var o = this.length;
                                return this.resize(o + 1), this.emplace(o, t1, e1, r, n, i, a);
                            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o) {
                                var s = 4 * t1, l = 8 * t1;
                                return this.int16[s + 0] = e1, this.int16[s + 1] = r, this.uint8[l + 4] = n, this.uint8[l + 5] = i, this.uint8[l + 6] = a, this.uint8[l + 7] = o, t1;
                            }, e1;
                        }(Qi);
                        aa.prototype.bytesPerElement = 8, oi("StructArrayLayout2i4ub8", aa);
                        var oa = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1) {
                                var r = this.length;
                                return this.resize(r + 1), this.emplace(r, t1, e1);
                            }, e1.prototype.emplace = function(t1, e1, r) {
                                var n = 2 * t1;
                                return this.float32[n + 0] = e1, this.float32[n + 1] = r, t1;
                            }, e1;
                        }(Qi);
                        oa.prototype.bytesPerElement = 8, oi("StructArrayLayout2f8", oa);
                        var sa = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a, o, s, l, c) {
                                var u = this.length;
                                return this.resize(u + 1), this.emplace(u, t1, e1, r, n, i, a, o, s, l, c);
                            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o, s, l, c, u) {
                                var h = 10 * t1;
                                return this.uint16[h + 0] = e1, this.uint16[h + 1] = r, this.uint16[h + 2] = n, this.uint16[h + 3] = i, this.uint16[h + 4] = a, this.uint16[h + 5] = o, this.uint16[h + 6] = s, this.uint16[h + 7] = l, this.uint16[h + 8] = c, this.uint16[h + 9] = u, t1;
                            }, e1;
                        }(Qi);
                        sa.prototype.bytesPerElement = 20, oi("StructArrayLayout10ui20", sa);
                        var la = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a, o, s, l, c, u, h) {
                                var f = this.length;
                                return this.resize(f + 1), this.emplace(f, t1, e1, r, n, i, a, o, s, l, c, u, h);
                            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o, s, l, c, u, h, f) {
                                var p = 12 * t1;
                                return this.int16[p + 0] = e1, this.int16[p + 1] = r, this.int16[p + 2] = n, this.int16[p + 3] = i, this.uint16[p + 4] = a, this.uint16[p + 5] = o, this.uint16[p + 6] = s, this.uint16[p + 7] = l, this.int16[p + 8] = c, this.int16[p + 9] = u, this.int16[p + 10] = h, this.int16[p + 11] = f, t1;
                            }, e1;
                        }(Qi);
                        la.prototype.bytesPerElement = 24, oi("StructArrayLayout4i4ui4i24", la);
                        var ca = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r) {
                                var n = this.length;
                                return this.resize(n + 1), this.emplace(n, t1, e1, r);
                            }, e1.prototype.emplace = function(t1, e1, r, n) {
                                var i = 3 * t1;
                                return this.float32[i + 0] = e1, this.float32[i + 1] = r, this.float32[i + 2] = n, t1;
                            }, e1;
                        }(Qi);
                        ca.prototype.bytesPerElement = 12, oi("StructArrayLayout3f12", ca);
                        var ua = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1) {
                                var e1 = this.length;
                                return this.resize(e1 + 1), this.emplace(e1, t1);
                            }, e1.prototype.emplace = function(t1, e1) {
                                var r = 1 * t1;
                                return this.uint32[r + 0] = e1, t1;
                            }, e1;
                        }(Qi);
                        ua.prototype.bytesPerElement = 4, oi("StructArrayLayout1ul4", ua);
                        var ha = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a, o, s, l) {
                                var c = this.length;
                                return this.resize(c + 1), this.emplace(c, t1, e1, r, n, i, a, o, s, l);
                            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o, s, l, c) {
                                var u = 10 * t1, h = 5 * t1;
                                return this.int16[u + 0] = e1, this.int16[u + 1] = r, this.int16[u + 2] = n, this.int16[u + 3] = i, this.int16[u + 4] = a, this.int16[u + 5] = o, this.uint32[h + 3] = s, this.uint16[u + 8] = l, this.uint16[u + 9] = c, t1;
                            }, e1;
                        }(Qi);
                        ha.prototype.bytesPerElement = 20, oi("StructArrayLayout6i1ul2ui20", ha);
                        var fa = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a) {
                                var o = this.length;
                                return this.resize(o + 1), this.emplace(o, t1, e1, r, n, i, a);
                            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o) {
                                var s = 6 * t1;
                                return this.int16[s + 0] = e1, this.int16[s + 1] = r, this.int16[s + 2] = n, this.int16[s + 3] = i, this.int16[s + 4] = a, this.int16[s + 5] = o, t1;
                            }, e1;
                        }(Qi);
                        fa.prototype.bytesPerElement = 12, oi("StructArrayLayout2i2i2i12", fa);
                        var pa = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i) {
                                var a = this.length;
                                return this.resize(a + 1), this.emplace(a, t1, e1, r, n, i);
                            }, e1.prototype.emplace = function(t1, e1, r, n, i, a) {
                                var o = 4 * t1, s = 8 * t1;
                                return this.float32[o + 0] = e1, this.float32[o + 1] = r, this.float32[o + 2] = n, this.int16[s + 6] = i, this.int16[s + 7] = a, t1;
                            }, e1;
                        }(Qi);
                        pa.prototype.bytesPerElement = 16, oi("StructArrayLayout2f1f2i16", pa);
                        var da = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r, n) {
                                var i = this.length;
                                return this.resize(i + 1), this.emplace(i, t1, e1, r, n);
                            }, e1.prototype.emplace = function(t1, e1, r, n, i) {
                                var a = 12 * t1, o = 3 * t1;
                                return this.uint8[a + 0] = e1, this.uint8[a + 1] = r, this.float32[o + 1] = n, this.float32[o + 2] = i, t1;
                            }, e1;
                        }(Qi);
                        da.prototype.bytesPerElement = 12, oi("StructArrayLayout2ub2f12", da);
                        var ma = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r) {
                                var n = this.length;
                                return this.resize(n + 1), this.emplace(n, t1, e1, r);
                            }, e1.prototype.emplace = function(t1, e1, r, n) {
                                var i = 3 * t1;
                                return this.uint16[i + 0] = e1, this.uint16[i + 1] = r, this.uint16[i + 2] = n, t1;
                            }, e1;
                        }(Qi);
                        ma.prototype.bytesPerElement = 6, oi("StructArrayLayout3ui6", ma);
                        var ga = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a, o, s, l, c, u, h, f, p, d, m, g) {
                                var y = this.length;
                                return this.resize(y + 1), this.emplace(y, t1, e1, r, n, i, a, o, s, l, c, u, h, f, p, d, m, g);
                            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o, s, l, c, u, h, f, p, d, m, g, y) {
                                var v = 24 * t1, x = 12 * t1, _ = 48 * t1;
                                return this.int16[v + 0] = e1, this.int16[v + 1] = r, this.uint16[v + 2] = n, this.uint16[v + 3] = i, this.uint32[x + 2] = a, this.uint32[x + 3] = o, this.uint32[x + 4] = s, this.uint16[v + 10] = l, this.uint16[v + 11] = c, this.uint16[v + 12] = u, this.float32[x + 7] = h, this.float32[x + 8] = f, this.uint8[_ + 36] = p, this.uint8[_ + 37] = d, this.uint8[_ + 38] = m, this.uint32[x + 10] = g, this.int16[v + 22] = y, t1;
                            }, e1;
                        }(Qi);
                        ga.prototype.bytesPerElement = 48, oi("StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48", ga);
                        var ya = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a, o, s, l, c, u, h, f, p, d, m, g, y, v, x, _, b, w, T, k, A, M, S) {
                                var E = this.length;
                                return this.resize(E + 1), this.emplace(E, t1, e1, r, n, i, a, o, s, l, c, u, h, f, p, d, m, g, y, v, x, _, b, w, T, k, A, M, S);
                            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o, s, l, c, u, h, f, p, d, m, g, y, v, x, _, b, w, T, k, A, M, S, E) {
                                var C = 34 * t1, L = 17 * t1;
                                return this.int16[C + 0] = e1, this.int16[C + 1] = r, this.int16[C + 2] = n, this.int16[C + 3] = i, this.int16[C + 4] = a, this.int16[C + 5] = o, this.int16[C + 6] = s, this.int16[C + 7] = l, this.uint16[C + 8] = c, this.uint16[C + 9] = u, this.uint16[C + 10] = h, this.uint16[C + 11] = f, this.uint16[C + 12] = p, this.uint16[C + 13] = d, this.uint16[C + 14] = m, this.uint16[C + 15] = g, this.uint16[C + 16] = y, this.uint16[C + 17] = v, this.uint16[C + 18] = x, this.uint16[C + 19] = _, this.uint16[C + 20] = b, this.uint16[C + 21] = w, this.uint16[C + 22] = T, this.uint32[L + 12] = k, this.float32[L + 13] = A, this.float32[L + 14] = M, this.float32[L + 15] = S, this.float32[L + 16] = E, t1;
                            }, e1;
                        }(Qi);
                        ya.prototype.bytesPerElement = 68, oi("StructArrayLayout8i15ui1ul4f68", ya);
                        var va = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1) {
                                var e1 = this.length;
                                return this.resize(e1 + 1), this.emplace(e1, t1);
                            }, e1.prototype.emplace = function(t1, e1) {
                                var r = 1 * t1;
                                return this.float32[r + 0] = e1, t1;
                            }, e1;
                        }(Qi);
                        va.prototype.bytesPerElement = 4, oi("StructArrayLayout1f4", va);
                        var xa = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r) {
                                var n = this.length;
                                return this.resize(n + 1), this.emplace(n, t1, e1, r);
                            }, e1.prototype.emplace = function(t1, e1, r, n) {
                                var i = 3 * t1;
                                return this.int16[i + 0] = e1, this.int16[i + 1] = r, this.int16[i + 2] = n, t1;
                            }, e1;
                        }(Qi);
                        xa.prototype.bytesPerElement = 6, oi("StructArrayLayout3i6", xa);
                        var _a = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r) {
                                var n = this.length;
                                return this.resize(n + 1), this.emplace(n, t1, e1, r);
                            }, e1.prototype.emplace = function(t1, e1, r, n) {
                                var i = 2 * t1, a = 4 * t1;
                                return this.uint32[i + 0] = e1, this.uint16[a + 2] = r, this.uint16[a + 3] = n, t1;
                            }, e1;
                        }(Qi);
                        _a.prototype.bytesPerElement = 8, oi("StructArrayLayout1ul2ui8", _a);
                        var ba = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1) {
                                var r = this.length;
                                return this.resize(r + 1), this.emplace(r, t1, e1);
                            }, e1.prototype.emplace = function(t1, e1, r) {
                                var n = 2 * t1;
                                return this.uint16[n + 0] = e1, this.uint16[n + 1] = r, t1;
                            }, e1;
                        }(Qi);
                        ba.prototype.bytesPerElement = 4, oi("StructArrayLayout2ui4", ba);
                        var wa = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1) {
                                var e1 = this.length;
                                return this.resize(e1 + 1), this.emplace(e1, t1);
                            }, e1.prototype.emplace = function(t1, e1) {
                                var r = 1 * t1;
                                return this.uint16[r + 0] = e1, t1;
                            }, e1;
                        }(Qi);
                        wa.prototype.bytesPerElement = 2, oi("StructArrayLayout1ui2", wa);
                        var Ta = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r, n) {
                                var i = this.length;
                                return this.resize(i + 1), this.emplace(i, t1, e1, r, n);
                            }, e1.prototype.emplace = function(t1, e1, r, n, i) {
                                var a = 4 * t1;
                                return this.float32[a + 0] = e1, this.float32[a + 1] = r, this.float32[a + 2] = n, this.float32[a + 3] = i, t1;
                            }, e1;
                        }(Qi);
                        Ta.prototype.bytesPerElement = 16, oi("StructArrayLayout4f16", Ta);
                        var ka = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1;
                            var r = {
                                anchorPointX: {
                                    configurable: !0
                                },
                                anchorPointY: {
                                    configurable: !0
                                },
                                x1: {
                                    configurable: !0
                                },
                                y1: {
                                    configurable: !0
                                },
                                x2: {
                                    configurable: !0
                                },
                                y2: {
                                    configurable: !0
                                },
                                featureIndex: {
                                    configurable: !0
                                },
                                sourceLayerIndex: {
                                    configurable: !0
                                },
                                bucketIndex: {
                                    configurable: !0
                                },
                                anchorPoint: {
                                    configurable: !0
                                }
                            };
                            return r.anchorPointX.get = function() {
                                return this._structArray.int16[this._pos2 + 0];
                            }, r.anchorPointY.get = function() {
                                return this._structArray.int16[this._pos2 + 1];
                            }, r.x1.get = function() {
                                return this._structArray.int16[this._pos2 + 2];
                            }, r.y1.get = function() {
                                return this._structArray.int16[this._pos2 + 3];
                            }, r.x2.get = function() {
                                return this._structArray.int16[this._pos2 + 4];
                            }, r.y2.get = function() {
                                return this._structArray.int16[this._pos2 + 5];
                            }, r.featureIndex.get = function() {
                                return this._structArray.uint32[this._pos4 + 3];
                            }, r.sourceLayerIndex.get = function() {
                                return this._structArray.uint16[this._pos2 + 8];
                            }, r.bucketIndex.get = function() {
                                return this._structArray.uint16[this._pos2 + 9];
                            }, r.anchorPoint.get = function() {
                                return new a(this.anchorPointX, this.anchorPointY);
                            }, Object.defineProperties(e1.prototype, r), e1;
                        }(Ki);
                        ka.prototype.size = 20;
                        var Aa = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.get = function(t1) {
                                return new ka(this, t1);
                            }, e1;
                        }(ha);
                        oi("CollisionBoxArray", Aa);
                        var Ma = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1;
                            var r = {
                                anchorX: {
                                    configurable: !0
                                },
                                anchorY: {
                                    configurable: !0
                                },
                                glyphStartIndex: {
                                    configurable: !0
                                },
                                numGlyphs: {
                                    configurable: !0
                                },
                                vertexStartIndex: {
                                    configurable: !0
                                },
                                lineStartIndex: {
                                    configurable: !0
                                },
                                lineLength: {
                                    configurable: !0
                                },
                                segment: {
                                    configurable: !0
                                },
                                lowerSize: {
                                    configurable: !0
                                },
                                upperSize: {
                                    configurable: !0
                                },
                                lineOffsetX: {
                                    configurable: !0
                                },
                                lineOffsetY: {
                                    configurable: !0
                                },
                                writingMode: {
                                    configurable: !0
                                },
                                placedOrientation: {
                                    configurable: !0
                                },
                                hidden: {
                                    configurable: !0
                                },
                                crossTileID: {
                                    configurable: !0
                                },
                                associatedIconIndex: {
                                    configurable: !0
                                }
                            };
                            return r.anchorX.get = function() {
                                return this._structArray.int16[this._pos2 + 0];
                            }, r.anchorY.get = function() {
                                return this._structArray.int16[this._pos2 + 1];
                            }, r.glyphStartIndex.get = function() {
                                return this._structArray.uint16[this._pos2 + 2];
                            }, r.numGlyphs.get = function() {
                                return this._structArray.uint16[this._pos2 + 3];
                            }, r.vertexStartIndex.get = function() {
                                return this._structArray.uint32[this._pos4 + 2];
                            }, r.lineStartIndex.get = function() {
                                return this._structArray.uint32[this._pos4 + 3];
                            }, r.lineLength.get = function() {
                                return this._structArray.uint32[this._pos4 + 4];
                            }, r.segment.get = function() {
                                return this._structArray.uint16[this._pos2 + 10];
                            }, r.lowerSize.get = function() {
                                return this._structArray.uint16[this._pos2 + 11];
                            }, r.upperSize.get = function() {
                                return this._structArray.uint16[this._pos2 + 12];
                            }, r.lineOffsetX.get = function() {
                                return this._structArray.float32[this._pos4 + 7];
                            }, r.lineOffsetY.get = function() {
                                return this._structArray.float32[this._pos4 + 8];
                            }, r.writingMode.get = function() {
                                return this._structArray.uint8[this._pos1 + 36];
                            }, r.placedOrientation.get = function() {
                                return this._structArray.uint8[this._pos1 + 37];
                            }, r.placedOrientation.set = function(t1) {
                                this._structArray.uint8[this._pos1 + 37] = t1;
                            }, r.hidden.get = function() {
                                return this._structArray.uint8[this._pos1 + 38];
                            }, r.hidden.set = function(t1) {
                                this._structArray.uint8[this._pos1 + 38] = t1;
                            }, r.crossTileID.get = function() {
                                return this._structArray.uint32[this._pos4 + 10];
                            }, r.crossTileID.set = function(t1) {
                                this._structArray.uint32[this._pos4 + 10] = t1;
                            }, r.associatedIconIndex.get = function() {
                                return this._structArray.int16[this._pos2 + 22];
                            }, Object.defineProperties(e1.prototype, r), e1;
                        }(Ki);
                        Ma.prototype.size = 48;
                        var Sa = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.get = function(t1) {
                                return new Ma(this, t1);
                            }, e1;
                        }(ga);
                        oi("PlacedSymbolArray", Sa);
                        var Ea = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1;
                            var r = {
                                anchorX: {
                                    configurable: !0
                                },
                                anchorY: {
                                    configurable: !0
                                },
                                rightJustifiedTextSymbolIndex: {
                                    configurable: !0
                                },
                                centerJustifiedTextSymbolIndex: {
                                    configurable: !0
                                },
                                leftJustifiedTextSymbolIndex: {
                                    configurable: !0
                                },
                                verticalPlacedTextSymbolIndex: {
                                    configurable: !0
                                },
                                placedIconSymbolIndex: {
                                    configurable: !0
                                },
                                verticalPlacedIconSymbolIndex: {
                                    configurable: !0
                                },
                                key: {
                                    configurable: !0
                                },
                                textBoxStartIndex: {
                                    configurable: !0
                                },
                                textBoxEndIndex: {
                                    configurable: !0
                                },
                                verticalTextBoxStartIndex: {
                                    configurable: !0
                                },
                                verticalTextBoxEndIndex: {
                                    configurable: !0
                                },
                                iconBoxStartIndex: {
                                    configurable: !0
                                },
                                iconBoxEndIndex: {
                                    configurable: !0
                                },
                                verticalIconBoxStartIndex: {
                                    configurable: !0
                                },
                                verticalIconBoxEndIndex: {
                                    configurable: !0
                                },
                                featureIndex: {
                                    configurable: !0
                                },
                                numHorizontalGlyphVertices: {
                                    configurable: !0
                                },
                                numVerticalGlyphVertices: {
                                    configurable: !0
                                },
                                numIconVertices: {
                                    configurable: !0
                                },
                                numVerticalIconVertices: {
                                    configurable: !0
                                },
                                useRuntimeCollisionCircles: {
                                    configurable: !0
                                },
                                crossTileID: {
                                    configurable: !0
                                },
                                textBoxScale: {
                                    configurable: !0
                                },
                                textOffset0: {
                                    configurable: !0
                                },
                                textOffset1: {
                                    configurable: !0
                                },
                                collisionCircleDiameter: {
                                    configurable: !0
                                }
                            };
                            return r.anchorX.get = function() {
                                return this._structArray.int16[this._pos2 + 0];
                            }, r.anchorY.get = function() {
                                return this._structArray.int16[this._pos2 + 1];
                            }, r.rightJustifiedTextSymbolIndex.get = function() {
                                return this._structArray.int16[this._pos2 + 2];
                            }, r.centerJustifiedTextSymbolIndex.get = function() {
                                return this._structArray.int16[this._pos2 + 3];
                            }, r.leftJustifiedTextSymbolIndex.get = function() {
                                return this._structArray.int16[this._pos2 + 4];
                            }, r.verticalPlacedTextSymbolIndex.get = function() {
                                return this._structArray.int16[this._pos2 + 5];
                            }, r.placedIconSymbolIndex.get = function() {
                                return this._structArray.int16[this._pos2 + 6];
                            }, r.verticalPlacedIconSymbolIndex.get = function() {
                                return this._structArray.int16[this._pos2 + 7];
                            }, r.key.get = function() {
                                return this._structArray.uint16[this._pos2 + 8];
                            }, r.textBoxStartIndex.get = function() {
                                return this._structArray.uint16[this._pos2 + 9];
                            }, r.textBoxEndIndex.get = function() {
                                return this._structArray.uint16[this._pos2 + 10];
                            }, r.verticalTextBoxStartIndex.get = function() {
                                return this._structArray.uint16[this._pos2 + 11];
                            }, r.verticalTextBoxEndIndex.get = function() {
                                return this._structArray.uint16[this._pos2 + 12];
                            }, r.iconBoxStartIndex.get = function() {
                                return this._structArray.uint16[this._pos2 + 13];
                            }, r.iconBoxEndIndex.get = function() {
                                return this._structArray.uint16[this._pos2 + 14];
                            }, r.verticalIconBoxStartIndex.get = function() {
                                return this._structArray.uint16[this._pos2 + 15];
                            }, r.verticalIconBoxEndIndex.get = function() {
                                return this._structArray.uint16[this._pos2 + 16];
                            }, r.featureIndex.get = function() {
                                return this._structArray.uint16[this._pos2 + 17];
                            }, r.numHorizontalGlyphVertices.get = function() {
                                return this._structArray.uint16[this._pos2 + 18];
                            }, r.numVerticalGlyphVertices.get = function() {
                                return this._structArray.uint16[this._pos2 + 19];
                            }, r.numIconVertices.get = function() {
                                return this._structArray.uint16[this._pos2 + 20];
                            }, r.numVerticalIconVertices.get = function() {
                                return this._structArray.uint16[this._pos2 + 21];
                            }, r.useRuntimeCollisionCircles.get = function() {
                                return this._structArray.uint16[this._pos2 + 22];
                            }, r.crossTileID.get = function() {
                                return this._structArray.uint32[this._pos4 + 12];
                            }, r.crossTileID.set = function(t1) {
                                this._structArray.uint32[this._pos4 + 12] = t1;
                            }, r.textBoxScale.get = function() {
                                return this._structArray.float32[this._pos4 + 13];
                            }, r.textOffset0.get = function() {
                                return this._structArray.float32[this._pos4 + 14];
                            }, r.textOffset1.get = function() {
                                return this._structArray.float32[this._pos4 + 15];
                            }, r.collisionCircleDiameter.get = function() {
                                return this._structArray.float32[this._pos4 + 16];
                            }, Object.defineProperties(e1.prototype, r), e1;
                        }(Ki);
                        Ea.prototype.size = 68;
                        var Ca = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.get = function(t1) {
                                return new Ea(this, t1);
                            }, e1;
                        }(ya);
                        oi("SymbolInstanceArray", Ca);
                        var La = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getoffsetX = function(t1) {
                                return this.float32[1 * t1 + 0];
                            }, e1;
                        }(va);
                        oi("GlyphOffsetArray", La);
                        var Ia = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getx = function(t1) {
                                return this.int16[3 * t1 + 0];
                            }, e1.prototype.gety = function(t1) {
                                return this.int16[3 * t1 + 1];
                            }, e1.prototype.gettileUnitDistanceFromAnchor = function(t1) {
                                return this.int16[3 * t1 + 2];
                            }, e1;
                        }(xa);
                        oi("SymbolLineVertexArray", Ia);
                        var Pa = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1;
                            var r = {
                                featureIndex: {
                                    configurable: !0
                                },
                                sourceLayerIndex: {
                                    configurable: !0
                                },
                                bucketIndex: {
                                    configurable: !0
                                }
                            };
                            return r.featureIndex.get = function() {
                                return this._structArray.uint32[this._pos4 + 0];
                            }, r.sourceLayerIndex.get = function() {
                                return this._structArray.uint16[this._pos2 + 2];
                            }, r.bucketIndex.get = function() {
                                return this._structArray.uint16[this._pos2 + 3];
                            }, Object.defineProperties(e1.prototype, r), e1;
                        }(Ki);
                        Pa.prototype.size = 8;
                        var za = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.get = function(t1) {
                                return new Pa(this, t1);
                            }, e1;
                        }(_a);
                        oi("FeatureIndexArray", za);
                        var Oa = ta([
                            {
                                name: "a_pos",
                                components: 2,
                                type: "Int16"
                            }
                        ], 4).members, Da = function(t1) {
                            void 0 === t1 && (t1 = []), this.segments = t1;
                        };
                        function Ra(t1, e1) {
                            return 256 * (t1 = h(Math.floor(t1), 0, 255)) + h(Math.floor(e1), 0, 255);
                        }
                        Da.prototype.prepareSegment = function(t1, e1, r, n) {
                            var i = this.segments[this.segments.length - 1];
                            return t1 > Da.MAX_VERTEX_ARRAY_LENGTH && k("Max vertices per segment is " + Da.MAX_VERTEX_ARRAY_LENGTH + ": bucket requested " + t1), (!i || i.vertexLength + t1 > Da.MAX_VERTEX_ARRAY_LENGTH || i.sortKey !== n) && (i = {
                                vertexOffset: e1.length,
                                primitiveOffset: r.length,
                                vertexLength: 0,
                                primitiveLength: 0
                            }, void 0 !== n && (i.sortKey = n), this.segments.push(i)), i;
                        }, Da.prototype.get = function() {
                            return this.segments;
                        }, Da.prototype.destroy = function() {
                            for(var t1 = 0, e1 = this.segments; t1 < e1.length; t1 += 1){
                                var r = e1[t1];
                                for(var n in r.vaos)r.vaos[n].destroy();
                            }
                        }, Da.simpleSegment = function(t1, e1, r, n) {
                            return new Da([
                                {
                                    vertexOffset: t1,
                                    primitiveOffset: e1,
                                    vertexLength: r,
                                    primitiveLength: n,
                                    vaos: {},
                                    sortKey: 0
                                }
                            ]);
                        }, Da.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, oi("SegmentVector", Da);
                        var Fa = ta([
                            {
                                name: "a_pattern_from",
                                components: 4,
                                type: "Uint16"
                            },
                            {
                                name: "a_pattern_to",
                                components: 4,
                                type: "Uint16"
                            },
                            {
                                name: "a_pixel_ratio_from",
                                components: 1,
                                type: "Uint16"
                            },
                            {
                                name: "a_pixel_ratio_to",
                                components: 1,
                                type: "Uint16"
                            }
                        ]), Ba = e1(function(t1) {
                            t1.exports = function(t1, e1) {
                                var r, n, i, a, o, s, l, c;
                                for(r = 3 & t1.length, n = t1.length - r, i = e1, o = 3432918353, s = 461845907, c = 0; c < n;)l = 255 & t1.charCodeAt(c) | (255 & t1.charCodeAt(++c)) << 8 | (255 & t1.charCodeAt(++c)) << 16 | (255 & t1.charCodeAt(++c)) << 24, ++c, i = 27492 + (65535 & (a = 5 * (65535 & (i = (i ^= l = (65535 & (l = (l = (65535 & l) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * s + (((l >>> 16) * s & 65535) << 16) & 4294967295) << 13 | i >>> 19)) + ((5 * (i >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (a >>> 16) & 65535) << 16);
                                switch(l = 0, r){
                                    case 3:
                                        l ^= (255 & t1.charCodeAt(c + 2)) << 16;
                                    case 2:
                                        l ^= (255 & t1.charCodeAt(c + 1)) << 8;
                                    case 1:
                                        i ^= l = (65535 & (l = (l = (65535 & (l ^= 255 & t1.charCodeAt(c))) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * s + (((l >>> 16) * s & 65535) << 16) & 4294967295;
                                }
                                return i ^= t1.length, i = 2246822507 * (65535 & (i ^= i >>> 16)) + ((2246822507 * (i >>> 16) & 65535) << 16) & 4294967295, i = 3266489909 * (65535 & (i ^= i >>> 13)) + ((3266489909 * (i >>> 16) & 65535) << 16) & 4294967295, (i ^= i >>> 16) >>> 0;
                            };
                        }), Na = e1(function(t1) {
                            t1.exports = function(t1, e1) {
                                for(var r, n = t1.length, i = e1 ^ n, a = 0; n >= 4;)r = 1540483477 * (65535 & (r = 255 & t1.charCodeAt(a) | (255 & t1.charCodeAt(++a)) << 8 | (255 & t1.charCodeAt(++a)) << 16 | (255 & t1.charCodeAt(++a)) << 24)) + ((1540483477 * (r >>> 16) & 65535) << 16), i = 1540483477 * (65535 & i) + ((1540483477 * (i >>> 16) & 65535) << 16) ^ (r = 1540483477 * (65535 & (r ^= r >>> 24)) + ((1540483477 * (r >>> 16) & 65535) << 16)), n -= 4, ++a;
                                switch(n){
                                    case 3:
                                        i ^= (255 & t1.charCodeAt(a + 2)) << 16;
                                    case 2:
                                        i ^= (255 & t1.charCodeAt(a + 1)) << 8;
                                    case 1:
                                        i = 1540483477 * (65535 & (i ^= 255 & t1.charCodeAt(a))) + ((1540483477 * (i >>> 16) & 65535) << 16);
                                }
                                return i = 1540483477 * (65535 & (i ^= i >>> 13)) + ((1540483477 * (i >>> 16) & 65535) << 16), (i ^= i >>> 15) >>> 0;
                            };
                        }), ja = Ba, Ua = Ba, Va = Na;
                        ja.murmur3 = Ua, ja.murmur2 = Va;
                        var qa = function() {
                            this.ids = [], this.positions = [], this.indexed = !1;
                        };
                        qa.prototype.add = function(t1, e1, r, n) {
                            this.ids.push(Ga(t1)), this.positions.push(e1, r, n);
                        }, qa.prototype.getPositions = function(t1) {
                            for(var e1 = Ga(t1), r = 0, n = this.ids.length - 1; r < n;){
                                var i = r + n >> 1;
                                this.ids[i] >= e1 ? n = i : r = i + 1;
                            }
                            for(var a = []; this.ids[r] === e1;){
                                var o = this.positions[3 * r], s = this.positions[3 * r + 1], l = this.positions[3 * r + 2];
                                a.push({
                                    index: o,
                                    start: s,
                                    end: l
                                }), r++;
                            }
                            return a;
                        }, qa.serialize = function(t1, e1) {
                            var r = new Float64Array(t1.ids), n = new Uint32Array(t1.positions);
                            return Za(r, n, 0, r.length - 1), e1 && e1.push(r.buffer, n.buffer), {
                                ids: r,
                                positions: n
                            };
                        }, qa.deserialize = function(t1) {
                            var e1 = new qa;
                            return e1.ids = t1.ids, e1.positions = t1.positions, e1.indexed = !0, e1;
                        };
                        var Ha = Math.pow(2, 53) - 1;
                        function Ga(t1) {
                            var e1 = +t1;
                            return !isNaN(e1) && e1 <= Ha ? e1 : ja(String(t1));
                        }
                        function Za(t1, e1, r, n) {
                            for(; r < n;){
                                for(var i = t1[r + n >> 1], a = r - 1, o = n + 1;;){
                                    do a++;
                                    while (t1[a] < i);
                                    do o--;
                                    while (t1[o] > i);
                                    if (a >= o) break;
                                    Wa(t1, a, o), Wa(e1, 3 * a, 3 * o), Wa(e1, 3 * a + 1, 3 * o + 1), Wa(e1, 3 * a + 2, 3 * o + 2);
                                }
                                o - r < n - o ? (Za(t1, e1, r, o), r = o + 1) : (Za(t1, e1, o + 1, n), n = o);
                            }
                        }
                        function Wa(t1, e1, r) {
                            var n = t1[e1];
                            t1[e1] = t1[r], t1[r] = n;
                        }
                        oi("FeaturePositionMap", qa);
                        var Ya = function(t1, e1) {
                            this.gl = t1.gl, this.location = e1;
                        }, Xa = function(t1) {
                            function e1(e1, r) {
                                t1.call(this, e1, r), this.current = 0;
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.set = function(t1) {
                                this.current !== t1 && (this.current = t1, this.gl.uniform1i(this.location, t1));
                            }, e1;
                        }(Ya), $a = function(t1) {
                            function e1(e1, r) {
                                t1.call(this, e1, r), this.current = 0;
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.set = function(t1) {
                                this.current !== t1 && (this.current = t1, this.gl.uniform1f(this.location, t1));
                            }, e1;
                        }(Ya), Ja = function(t1) {
                            function e1(e1, r) {
                                t1.call(this, e1, r), this.current = [
                                    0,
                                    0
                                ];
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.set = function(t1) {
                                t1[0] === this.current[0] && t1[1] === this.current[1] || (this.current = t1, this.gl.uniform2f(this.location, t1[0], t1[1]));
                            }, e1;
                        }(Ya), Ka = function(t1) {
                            function e1(e1, r) {
                                t1.call(this, e1, r), this.current = [
                                    0,
                                    0,
                                    0
                                ];
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.set = function(t1) {
                                t1[0] === this.current[0] && t1[1] === this.current[1] && t1[2] === this.current[2] || (this.current = t1, this.gl.uniform3f(this.location, t1[0], t1[1], t1[2]));
                            }, e1;
                        }(Ya), Qa = function(t1) {
                            function e1(e1, r) {
                                t1.call(this, e1, r), this.current = [
                                    0,
                                    0,
                                    0,
                                    0
                                ];
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.set = function(t1) {
                                t1[0] === this.current[0] && t1[1] === this.current[1] && t1[2] === this.current[2] && t1[3] === this.current[3] || (this.current = t1, this.gl.uniform4f(this.location, t1[0], t1[1], t1[2], t1[3]));
                            }, e1;
                        }(Ya), to = function(t1) {
                            function e1(e1, r) {
                                t1.call(this, e1, r), this.current = ce.transparent;
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.set = function(t1) {
                                t1.r === this.current.r && t1.g === this.current.g && t1.b === this.current.b && t1.a === this.current.a || (this.current = t1, this.gl.uniform4f(this.location, t1.r, t1.g, t1.b, t1.a));
                            }, e1;
                        }(Ya), eo = new Float32Array(16), ro = function(t1) {
                            function e1(e1, r) {
                                t1.call(this, e1, r), this.current = eo;
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.set = function(t1) {
                                if (t1[12] !== this.current[12] || t1[0] !== this.current[0]) return this.current = t1, void this.gl.uniformMatrix4fv(this.location, !1, t1);
                                for(var e1 = 1; e1 < 16; e1++)if (t1[e1] !== this.current[e1]) {
                                    this.current = t1, this.gl.uniformMatrix4fv(this.location, !1, t1);
                                    break;
                                }
                            }, e1;
                        }(Ya);
                        function no(t1) {
                            return [
                                Ra(255 * t1.r, 255 * t1.g),
                                Ra(255 * t1.b, 255 * t1.a)
                            ];
                        }
                        var io = function(t1, e1, r) {
                            this.value = t1, this.uniformNames = e1.map(function(t1) {
                                return "u_" + t1;
                            }), this.type = r;
                        };
                        io.prototype.setUniform = function(t1, e1, r) {
                            t1.set(r.constantOr(this.value));
                        }, io.prototype.getBinding = function(t1, e1, r) {
                            return "color" === this.type ? new to(t1, e1) : new $a(t1, e1);
                        };
                        var ao = function(t1, e1) {
                            this.uniformNames = e1.map(function(t1) {
                                return "u_" + t1;
                            }), this.patternFrom = null, this.patternTo = null, this.pixelRatioFrom = 1, this.pixelRatioTo = 1;
                        };
                        ao.prototype.setConstantPatternPositions = function(t1, e1) {
                            this.pixelRatioFrom = e1.pixelRatio, this.pixelRatioTo = t1.pixelRatio, this.patternFrom = e1.tlbr, this.patternTo = t1.tlbr;
                        }, ao.prototype.setUniform = function(t1, e1, r, n) {
                            var i = "u_pattern_to" === n ? this.patternTo : "u_pattern_from" === n ? this.patternFrom : "u_pixel_ratio_to" === n ? this.pixelRatioTo : "u_pixel_ratio_from" === n ? this.pixelRatioFrom : null;
                            i && t1.set(i);
                        }, ao.prototype.getBinding = function(t1, e1, r) {
                            return "u_pattern" === r.substr(0, 9) ? new Qa(t1, e1) : new $a(t1, e1);
                        };
                        var oo = function(t1, e1, r, n) {
                            this.expression = t1, this.type = r, this.maxValue = 0, this.paintVertexAttributes = e1.map(function(t1) {
                                return {
                                    name: "a_" + t1,
                                    type: "Float32",
                                    components: "color" === r ? 2 : 1,
                                    offset: 0
                                };
                            }), this.paintVertexArray = new n;
                        };
                        oo.prototype.populatePaintArray = function(t1, e1, r, n, i) {
                            var a = this.paintVertexArray.length, o = this.expression.evaluate(new Oi(0), e1, {}, n, [], i);
                            this.paintVertexArray.resize(t1), this._setPaintValue(a, t1, o);
                        }, oo.prototype.updatePaintArray = function(t1, e1, r, n) {
                            var i = this.expression.evaluate({
                                zoom: 0
                            }, r, n);
                            this._setPaintValue(t1, e1, i);
                        }, oo.prototype._setPaintValue = function(t1, e1, r) {
                            if ("color" === this.type) for(var n = no(r), i = t1; i < e1; i++)this.paintVertexArray.emplace(i, n[0], n[1]);
                            else {
                                for(var a = t1; a < e1; a++)this.paintVertexArray.emplace(a, r);
                                this.maxValue = Math.max(this.maxValue, Math.abs(r));
                            }
                        }, oo.prototype.upload = function(t1) {
                            this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
                        }, oo.prototype.destroy = function() {
                            this.paintVertexBuffer && this.paintVertexBuffer.destroy();
                        };
                        var so = function(t1, e1, r, n, i, a) {
                            this.expression = t1, this.uniformNames = e1.map(function(t1) {
                                return "u_" + t1 + "_t";
                            }), this.type = r, this.useIntegerZoom = n, this.zoom = i, this.maxValue = 0, this.paintVertexAttributes = e1.map(function(t1) {
                                return {
                                    name: "a_" + t1,
                                    type: "Float32",
                                    components: "color" === r ? 4 : 2,
                                    offset: 0
                                };
                            }), this.paintVertexArray = new a;
                        };
                        so.prototype.populatePaintArray = function(t1, e1, r, n, i) {
                            var a = this.expression.evaluate(new Oi(this.zoom), e1, {}, n, [], i), o = this.expression.evaluate(new Oi(this.zoom + 1), e1, {}, n, [], i), s = this.paintVertexArray.length;
                            this.paintVertexArray.resize(t1), this._setPaintValue(s, t1, a, o);
                        }, so.prototype.updatePaintArray = function(t1, e1, r, n) {
                            var i = this.expression.evaluate({
                                zoom: this.zoom
                            }, r, n), a = this.expression.evaluate({
                                zoom: this.zoom + 1
                            }, r, n);
                            this._setPaintValue(t1, e1, i, a);
                        }, so.prototype._setPaintValue = function(t1, e1, r, n) {
                            if ("color" === this.type) for(var i = no(r), a = no(n), o = t1; o < e1; o++)this.paintVertexArray.emplace(o, i[0], i[1], a[0], a[1]);
                            else {
                                for(var s = t1; s < e1; s++)this.paintVertexArray.emplace(s, r, n);
                                this.maxValue = Math.max(this.maxValue, Math.abs(r), Math.abs(n));
                            }
                        }, so.prototype.upload = function(t1) {
                            this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
                        }, so.prototype.destroy = function() {
                            this.paintVertexBuffer && this.paintVertexBuffer.destroy();
                        }, so.prototype.setUniform = function(t1, e1) {
                            var r = this.useIntegerZoom ? Math.floor(e1.zoom) : e1.zoom, n = h(this.expression.interpolationFactor(r, this.zoom, this.zoom + 1), 0, 1);
                            t1.set(n);
                        }, so.prototype.getBinding = function(t1, e1, r) {
                            return new $a(t1, e1);
                        };
                        var lo = function(t1, e1, r, n, i, a) {
                            this.expression = t1, this.type = e1, this.useIntegerZoom = r, this.zoom = n, this.layerId = a, this.zoomInPaintVertexArray = new i, this.zoomOutPaintVertexArray = new i;
                        };
                        lo.prototype.populatePaintArray = function(t1, e1, r) {
                            var n = this.zoomInPaintVertexArray.length;
                            this.zoomInPaintVertexArray.resize(t1), this.zoomOutPaintVertexArray.resize(t1), this._setPaintValues(n, t1, e1.patterns && e1.patterns[this.layerId], r);
                        }, lo.prototype.updatePaintArray = function(t1, e1, r, n, i) {
                            this._setPaintValues(t1, e1, r.patterns && r.patterns[this.layerId], i);
                        }, lo.prototype._setPaintValues = function(t1, e1, r, n) {
                            if (n && r) {
                                var i = r.min, a = r.mid, o = r.max, s = n[i], l = n[a], c = n[o];
                                if (s && l && c) for(var u = t1; u < e1; u++)this.zoomInPaintVertexArray.emplace(u, l.tl[0], l.tl[1], l.br[0], l.br[1], s.tl[0], s.tl[1], s.br[0], s.br[1], l.pixelRatio, s.pixelRatio), this.zoomOutPaintVertexArray.emplace(u, l.tl[0], l.tl[1], l.br[0], l.br[1], c.tl[0], c.tl[1], c.br[0], c.br[1], l.pixelRatio, c.pixelRatio);
                            }
                        }, lo.prototype.upload = function(t1) {
                            this.zoomInPaintVertexArray && this.zoomInPaintVertexArray.arrayBuffer && this.zoomOutPaintVertexArray && this.zoomOutPaintVertexArray.arrayBuffer && (this.zoomInPaintVertexBuffer = t1.createVertexBuffer(this.zoomInPaintVertexArray, Fa.members, this.expression.isStateDependent), this.zoomOutPaintVertexBuffer = t1.createVertexBuffer(this.zoomOutPaintVertexArray, Fa.members, this.expression.isStateDependent));
                        }, lo.prototype.destroy = function() {
                            this.zoomOutPaintVertexBuffer && this.zoomOutPaintVertexBuffer.destroy(), this.zoomInPaintVertexBuffer && this.zoomInPaintVertexBuffer.destroy();
                        };
                        var co = function(t1, e1, r) {
                            this.binders = {}, this._buffers = [];
                            var n = [];
                            for(var i in t1.paint._values)if (r(i)) {
                                var a = t1.paint.get(i);
                                if (a instanceof Ui && $r(a.property.specification)) {
                                    var o = ho(i, t1.type), s = a.value, l = a.property.specification.type, c = a.property.useIntegerZoom, u = a.property.specification["property-type"], h = "cross-faded" === u || "cross-faded-data-driven" === u;
                                    if ("constant" === s.kind) this.binders[i] = h ? new ao(s.value, o) : new io(s.value, o, l), n.push("/u_" + i);
                                    else if ("source" === s.kind || h) {
                                        var f = fo(i, l, "source");
                                        this.binders[i] = h ? new lo(s, l, c, e1, f, t1.id) : new oo(s, o, l, f), n.push("/a_" + i);
                                    } else {
                                        var p = fo(i, l, "composite");
                                        this.binders[i] = new so(s, o, l, c, e1, p), n.push("/z_" + i);
                                    }
                                }
                            }
                            this.cacheKey = n.sort().join("");
                        };
                        co.prototype.getMaxValue = function(t1) {
                            var e1 = this.binders[t1];
                            return e1 instanceof oo || e1 instanceof so ? e1.maxValue : 0;
                        }, co.prototype.populatePaintArrays = function(t1, e1, r, n, i) {
                            for(var a in this.binders){
                                var o = this.binders[a];
                                (o instanceof oo || o instanceof so || o instanceof lo) && o.populatePaintArray(t1, e1, r, n, i);
                            }
                        }, co.prototype.setConstantPatternPositions = function(t1, e1) {
                            for(var r in this.binders){
                                var n = this.binders[r];
                                n instanceof ao && n.setConstantPatternPositions(t1, e1);
                            }
                        }, co.prototype.updatePaintArrays = function(t1, e1, r, n, i) {
                            var a = !1;
                            for(var o in t1)for(var s = 0, l = e1.getPositions(o); s < l.length; s += 1){
                                var c = l[s], u = r.feature(c.index);
                                for(var h in this.binders){
                                    var f = this.binders[h];
                                    if ((f instanceof oo || f instanceof so || f instanceof lo) && !0 === f.expression.isStateDependent) {
                                        var p = n.paint.get(h);
                                        f.expression = p.value, f.updatePaintArray(c.start, c.end, u, t1[o], i), a = !0;
                                    }
                                }
                            }
                            return a;
                        }, co.prototype.defines = function() {
                            var t1 = [];
                            for(var e1 in this.binders){
                                var r = this.binders[e1];
                                (r instanceof io || r instanceof ao) && t1.push.apply(t1, r.uniformNames.map(function(t1) {
                                    return "#define HAS_UNIFORM_" + t1;
                                }));
                            }
                            return t1;
                        }, co.prototype.getBinderAttributes = function() {
                            var t1 = [];
                            for(var e1 in this.binders){
                                var r = this.binders[e1];
                                if (r instanceof oo || r instanceof so) for(var n = 0; n < r.paintVertexAttributes.length; n++)t1.push(r.paintVertexAttributes[n].name);
                                else if (r instanceof lo) for(var i = 0; i < Fa.members.length; i++)t1.push(Fa.members[i].name);
                            }
                            return t1;
                        }, co.prototype.getBinderUniforms = function() {
                            var t1 = [];
                            for(var e1 in this.binders){
                                var r = this.binders[e1];
                                if (r instanceof io || r instanceof ao || r instanceof so) for(var n = 0, i = r.uniformNames; n < i.length; n += 1){
                                    var a = i[n];
                                    t1.push(a);
                                }
                            }
                            return t1;
                        }, co.prototype.getPaintVertexBuffers = function() {
                            return this._buffers;
                        }, co.prototype.getUniforms = function(t1, e1) {
                            var r = [];
                            for(var n in this.binders){
                                var i = this.binders[n];
                                if (i instanceof io || i instanceof ao || i instanceof so) for(var a = 0, o = i.uniformNames; a < o.length; a += 1){
                                    var s = o[a];
                                    if (e1[s]) {
                                        var l = i.getBinding(t1, e1[s], s);
                                        r.push({
                                            name: s,
                                            property: n,
                                            binding: l
                                        });
                                    }
                                }
                            }
                            return r;
                        }, co.prototype.setUniforms = function(t1, e1, r, n) {
                            for(var i = 0, a = e1; i < a.length; i += 1){
                                var o = a[i], s = o.name, l = o.property, c = o.binding;
                                this.binders[l].setUniform(c, n, r.get(l), s);
                            }
                        }, co.prototype.updatePaintBuffers = function(t1) {
                            for(var e1 in this._buffers = [], this.binders){
                                var r = this.binders[e1];
                                if (t1 && r instanceof lo) {
                                    var n = 2 === t1.fromScale ? r.zoomInPaintVertexBuffer : r.zoomOutPaintVertexBuffer;
                                    n && this._buffers.push(n);
                                } else (r instanceof oo || r instanceof so) && r.paintVertexBuffer && this._buffers.push(r.paintVertexBuffer);
                            }
                        }, co.prototype.upload = function(t1) {
                            for(var e1 in this.binders){
                                var r = this.binders[e1];
                                (r instanceof oo || r instanceof so || r instanceof lo) && r.upload(t1);
                            }
                            this.updatePaintBuffers();
                        }, co.prototype.destroy = function() {
                            for(var t1 in this.binders){
                                var e1 = this.binders[t1];
                                (e1 instanceof oo || e1 instanceof so || e1 instanceof lo) && e1.destroy();
                            }
                        };
                        var uo = function(t1, e1, r) {
                            void 0 === r && (r = function() {
                                return !0;
                            }), this.programConfigurations = {};
                            for(var n = 0, i = t1; n < i.length; n += 1){
                                var a = i[n];
                                this.programConfigurations[a.id] = new co(a, e1, r);
                            }
                            this.needsUpload = !1, this._featureMap = new qa, this._bufferOffset = 0;
                        };
                        function ho(t1, e1) {
                            return ({
                                "text-opacity": [
                                    "opacity"
                                ],
                                "icon-opacity": [
                                    "opacity"
                                ],
                                "text-color": [
                                    "fill_color"
                                ],
                                "icon-color": [
                                    "fill_color"
                                ],
                                "text-halo-color": [
                                    "halo_color"
                                ],
                                "icon-halo-color": [
                                    "halo_color"
                                ],
                                "text-halo-blur": [
                                    "halo_blur"
                                ],
                                "icon-halo-blur": [
                                    "halo_blur"
                                ],
                                "text-halo-width": [
                                    "halo_width"
                                ],
                                "icon-halo-width": [
                                    "halo_width"
                                ],
                                "line-gap-width": [
                                    "gapwidth"
                                ],
                                "line-pattern": [
                                    "pattern_to",
                                    "pattern_from",
                                    "pixel_ratio_to",
                                    "pixel_ratio_from"
                                ],
                                "fill-pattern": [
                                    "pattern_to",
                                    "pattern_from",
                                    "pixel_ratio_to",
                                    "pixel_ratio_from"
                                ],
                                "fill-extrusion-pattern": [
                                    "pattern_to",
                                    "pattern_from",
                                    "pixel_ratio_to",
                                    "pixel_ratio_from"
                                ]
                            })[t1] || [
                                t1.replace(e1 + "-", "").replace(/-/g, "_")
                            ];
                        }
                        function fo(t1, e1, r) {
                            var n = {
                                color: {
                                    source: oa,
                                    composite: Ta
                                },
                                number: {
                                    source: va,
                                    composite: oa
                                }
                            }, i = function(t1) {
                                return ({
                                    "line-pattern": {
                                        source: sa,
                                        composite: sa
                                    },
                                    "fill-pattern": {
                                        source: sa,
                                        composite: sa
                                    },
                                    "fill-extrusion-pattern": {
                                        source: sa,
                                        composite: sa
                                    }
                                })[t1];
                            }(t1);
                            return i && i[r] || n[e1][r];
                        }
                        uo.prototype.populatePaintArrays = function(t1, e1, r, n, i, a) {
                            for(var o in this.programConfigurations)this.programConfigurations[o].populatePaintArrays(t1, e1, n, i, a);
                            void 0 !== e1.id && this._featureMap.add(e1.id, r, this._bufferOffset, t1), this._bufferOffset = t1, this.needsUpload = !0;
                        }, uo.prototype.updatePaintArrays = function(t1, e1, r, n) {
                            for(var i = 0, a = r; i < a.length; i += 1){
                                var o = a[i];
                                this.needsUpload = this.programConfigurations[o.id].updatePaintArrays(t1, this._featureMap, e1, o, n) || this.needsUpload;
                            }
                        }, uo.prototype.get = function(t1) {
                            return this.programConfigurations[t1];
                        }, uo.prototype.upload = function(t1) {
                            if (this.needsUpload) {
                                for(var e1 in this.programConfigurations)this.programConfigurations[e1].upload(t1);
                                this.needsUpload = !1;
                            }
                        }, uo.prototype.destroy = function() {
                            for(var t1 in this.programConfigurations)this.programConfigurations[t1].destroy();
                        }, oi("ConstantBinder", io), oi("CrossFadedConstantBinder", ao), oi("SourceExpressionBinder", oo), oi("CrossFadedCompositeBinder", lo), oi("CompositeExpressionBinder", so), oi("ProgramConfiguration", co, {
                            omit: [
                                "_buffers"
                            ]
                        }), oi("ProgramConfigurationSet", uo);
                        var po = 8192, mo = Math.pow(2, 14) - 1, go = -mo - 1;
                        function yo(t1) {
                            for(var e1 = po / t1.extent, r = t1.loadGeometry(), n = 0; n < r.length; n++)for(var i = r[n], a = 0; a < i.length; a++){
                                var o = i[a], s = Math.round(o.x * e1), l = Math.round(o.y * e1);
                                o.x = h(s, go, mo), o.y = h(l, go, mo), (s < o.x || s > o.x + 1 || l < o.y || l > o.y + 1) && k("Geometry exceeds allowed extent, reduce your vector tile buffer size");
                            }
                            return r;
                        }
                        function vo(t1, e1) {
                            return {
                                type: t1.type,
                                id: t1.id,
                                properties: t1.properties,
                                geometry: e1 ? yo(t1) : []
                            };
                        }
                        function xo(t1, e1, r, n, i) {
                            t1.emplaceBack(2 * e1 + (n + 1) / 2, 2 * r + (i + 1) / 2);
                        }
                        var _o = function(t1) {
                            this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map(function(t1) {
                                return t1.id;
                            }), this.index = t1.index, this.hasPattern = !1, this.layoutVertexArray = new ra, this.indexArray = new ma, this.segments = new Da, this.programConfigurations = new uo(t1.layers, t1.zoom), this.stateDependentLayerIds = this.layers.filter(function(t1) {
                                return t1.isStateDependent();
                            }).map(function(t1) {
                                return t1.id;
                            });
                        };
                        function bo(t1, e1) {
                            for(var r = 0; r < t1.length; r++)if (Lo(e1, t1[r])) return !0;
                            for(var n = 0; n < e1.length; n++)if (Lo(t1, e1[n])) return !0;
                            return !!Ao(t1, e1);
                        }
                        function wo(t1, e1, r) {
                            return !!Lo(t1, e1) || !!So(e1, t1, r);
                        }
                        function To(t1, e1) {
                            if (1 === t1.length) return Co(e1, t1[0]);
                            for(var r = 0; r < e1.length; r++)for(var n = e1[r], i = 0; i < n.length; i++)if (Lo(t1, n[i])) return !0;
                            for(var a = 0; a < t1.length; a++)if (Co(e1, t1[a])) return !0;
                            for(var o = 0; o < e1.length; o++)if (Ao(t1, e1[o])) return !0;
                            return !1;
                        }
                        function ko(t1, e1, r) {
                            if (t1.length > 1) {
                                if (Ao(t1, e1)) return !0;
                                for(var n = 0; n < e1.length; n++)if (So(e1[n], t1, r)) return !0;
                            }
                            for(var i = 0; i < t1.length; i++)if (So(t1[i], e1, r)) return !0;
                            return !1;
                        }
                        function Ao(t1, e1) {
                            if (0 === t1.length || 0 === e1.length) return !1;
                            for(var r = 0; r < t1.length - 1; r++)for(var n = t1[r], i = t1[r + 1], a = 0; a < e1.length - 1; a++)if (Mo(n, i, e1[a], e1[a + 1])) return !0;
                            return !1;
                        }
                        function Mo(t1, e1, r, n) {
                            return A(t1, r, n) !== A(e1, r, n) && A(t1, e1, r) !== A(t1, e1, n);
                        }
                        function So(t1, e1, r) {
                            var n = r * r;
                            if (1 === e1.length) return t1.distSqr(e1[0]) < n;
                            for(var i = 1; i < e1.length; i++)if (Eo(t1, e1[i - 1], e1[i]) < n) return !0;
                            return !1;
                        }
                        function Eo(t1, e1, r) {
                            var n = e1.distSqr(r);
                            if (0 === n) return t1.distSqr(e1);
                            var i = ((t1.x - e1.x) * (r.x - e1.x) + (t1.y - e1.y) * (r.y - e1.y)) / n;
                            return i < 0 ? t1.distSqr(e1) : i > 1 ? t1.distSqr(r) : t1.distSqr(r.sub(e1)._mult(i)._add(e1));
                        }
                        function Co(t1, e1) {
                            for(var r, n, i, a = !1, o = 0; o < t1.length; o++)for(var s = 0, l = (r = t1[o]).length - 1; s < r.length; l = s++)n = r[s], i = r[l], n.y > e1.y != i.y > e1.y && e1.x < (i.x - n.x) * (e1.y - n.y) / (i.y - n.y) + n.x && (a = !a);
                            return a;
                        }
                        function Lo(t1, e1) {
                            for(var r = !1, n = 0, i = t1.length - 1; n < t1.length; i = n++){
                                var a = t1[n], o = t1[i];
                                a.y > e1.y != o.y > e1.y && e1.x < (o.x - a.x) * (e1.y - a.y) / (o.y - a.y) + a.x && (r = !r);
                            }
                            return r;
                        }
                        function Io(t1, e1, r) {
                            var n = r[0], i = r[2];
                            if (t1.x < n.x && e1.x < n.x || t1.x > i.x && e1.x > i.x || t1.y < n.y && e1.y < n.y || t1.y > i.y && e1.y > i.y) return !1;
                            var a = A(t1, e1, r[0]);
                            return a !== A(t1, e1, r[1]) || a !== A(t1, e1, r[2]) || a !== A(t1, e1, r[3]);
                        }
                        function Po(t1, e1, r) {
                            var n = e1.paint.get(t1).value;
                            return "constant" === n.kind ? n.value : r.programConfigurations.get(e1.id).getMaxValue(t1);
                        }
                        function zo(t1) {
                            return Math.sqrt(t1[0] * t1[0] + t1[1] * t1[1]);
                        }
                        function Oo(t1, e1, r, n, i) {
                            if (!e1[0] && !e1[1]) return t1;
                            var o = a.convert(e1)._mult(i);
                            "viewport" === r && o._rotate(-n);
                            for(var s = [], l = 0; l < t1.length; l++){
                                var c = t1[l];
                                s.push(c.sub(o));
                            }
                            return s;
                        }
                        _o.prototype.populate = function(t1, e1, r) {
                            var n = this.layers[0], i = [], a = null;
                            "circle" === n.type && (a = n.layout.get("circle-sort-key"));
                            for(var o = 0, s = t1; o < s.length; o += 1){
                                var l = s[o], c = l.feature, u = l.id, h = l.index, f = l.sourceLayerIndex, p = this.layers[0]._featureFilter.needGeometry, d = vo(c, p);
                                if (this.layers[0]._featureFilter.filter(new Oi(this.zoom), d, r)) {
                                    var m = a ? a.evaluate(d, {}, r) : void 0, g = {
                                        id: u,
                                        properties: c.properties,
                                        type: c.type,
                                        sourceLayerIndex: f,
                                        index: h,
                                        geometry: p ? d.geometry : yo(c),
                                        patterns: {},
                                        sortKey: m
                                    };
                                    i.push(g);
                                }
                            }
                            a && i.sort(function(t1, e1) {
                                return t1.sortKey - e1.sortKey;
                            });
                            for(var y = 0, v = i; y < v.length; y += 1){
                                var x = v[y], _ = x, b = _.geometry, w = _.index, T = _.sourceLayerIndex, k = t1[w].feature;
                                this.addFeature(x, b, w, r), e1.featureIndex.insert(k, b, w, T, this.index);
                            }
                        }, _o.prototype.update = function(t1, e1, r) {
                            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r);
                        }, _o.prototype.isEmpty = function() {
                            return 0 === this.layoutVertexArray.length;
                        }, _o.prototype.uploadPending = function() {
                            return !this.uploaded || this.programConfigurations.needsUpload;
                        }, _o.prototype.upload = function(t1) {
                            this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, Oa), this.indexBuffer = t1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t1), this.uploaded = !0;
                        }, _o.prototype.destroy = function() {
                            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
                        }, _o.prototype.addFeature = function(t1, e1, r, n) {
                            for(var i = 0, a = e1; i < a.length; i += 1)for(var o = 0, s = a[i]; o < s.length; o += 1){
                                var l = s[o], c = l.x, u = l.y;
                                if (!(c < 0 || c >= po || u < 0 || u >= po)) {
                                    var h = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, t1.sortKey), f = h.vertexLength;
                                    xo(this.layoutVertexArray, c, u, -1, -1), xo(this.layoutVertexArray, c, u, 1, -1), xo(this.layoutVertexArray, c, u, 1, 1), xo(this.layoutVertexArray, c, u, -1, 1), this.indexArray.emplaceBack(f, f + 1, f + 2), this.indexArray.emplaceBack(f, f + 3, f + 2), h.vertexLength += 4, h.primitiveLength += 2;
                                }
                            }
                            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, {}, n);
                        }, oi("CircleBucket", _o, {
                            omit: [
                                "layers"
                            ]
                        });
                        var Do = new Yi({
                            "circle-sort-key": new Hi(Ft.layout_circle["circle-sort-key"])
                        }), Ro = {
                            paint: new Yi({
                                "circle-radius": new Hi(Ft.paint_circle["circle-radius"]),
                                "circle-color": new Hi(Ft.paint_circle["circle-color"]),
                                "circle-blur": new Hi(Ft.paint_circle["circle-blur"]),
                                "circle-opacity": new Hi(Ft.paint_circle["circle-opacity"]),
                                "circle-translate": new qi(Ft.paint_circle["circle-translate"]),
                                "circle-translate-anchor": new qi(Ft.paint_circle["circle-translate-anchor"]),
                                "circle-pitch-scale": new qi(Ft.paint_circle["circle-pitch-scale"]),
                                "circle-pitch-alignment": new qi(Ft.paint_circle["circle-pitch-alignment"]),
                                "circle-stroke-width": new Hi(Ft.paint_circle["circle-stroke-width"]),
                                "circle-stroke-color": new Hi(Ft.paint_circle["circle-stroke-color"]),
                                "circle-stroke-opacity": new Hi(Ft.paint_circle["circle-stroke-opacity"])
                            }),
                            layout: Do
                        }, Fo = "undefined" != typeof Float32Array ? Float32Array : Array;
                        function Bo(t1) {
                            return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = 1, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 1, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
                        }
                        function No(t1, e1, r) {
                            var n = e1[0], i = e1[1], a = e1[2], o = e1[3], s = e1[4], l = e1[5], c = e1[6], u = e1[7], h = e1[8], f = e1[9], p = e1[10], d = e1[11], m = e1[12], g = e1[13], y = e1[14], v = e1[15], x = r[0], _ = r[1], b = r[2], w = r[3];
                            return t1[0] = x * n + _ * s + b * h + w * m, t1[1] = x * i + _ * l + b * f + w * g, t1[2] = x * a + _ * c + b * p + w * y, t1[3] = x * o + _ * u + b * d + w * v, x = r[4], _ = r[5], b = r[6], w = r[7], t1[4] = x * n + _ * s + b * h + w * m, t1[5] = x * i + _ * l + b * f + w * g, t1[6] = x * a + _ * c + b * p + w * y, t1[7] = x * o + _ * u + b * d + w * v, x = r[8], _ = r[9], b = r[10], w = r[11], t1[8] = x * n + _ * s + b * h + w * m, t1[9] = x * i + _ * l + b * f + w * g, t1[10] = x * a + _ * c + b * p + w * y, t1[11] = x * o + _ * u + b * d + w * v, x = r[12], _ = r[13], b = r[14], w = r[15], t1[12] = x * n + _ * s + b * h + w * m, t1[13] = x * i + _ * l + b * f + w * g, t1[14] = x * a + _ * c + b * p + w * y, t1[15] = x * o + _ * u + b * d + w * v, t1;
                        }
                        Math.hypot || (Math.hypot = function() {
                            for(var t1 = arguments, e1 = 0, r = arguments.length; r--;)e1 += t1[r] * t1[r];
                            return Math.sqrt(e1);
                        });
                        var jo = No;
                        var Uo, Vo = function(t1, e1, r) {
                            return t1[0] = e1[0] - r[0], t1[1] = e1[1] - r[1], t1[2] = e1[2] - r[2], t1;
                        };
                        function qo(t1, e1, r) {
                            var n = e1[0], i = e1[1], a = e1[2], o = e1[3];
                            return t1[0] = r[0] * n + r[4] * i + r[8] * a + r[12] * o, t1[1] = r[1] * n + r[5] * i + r[9] * a + r[13] * o, t1[2] = r[2] * n + r[6] * i + r[10] * a + r[14] * o, t1[3] = r[3] * n + r[7] * i + r[11] * a + r[15] * o, t1;
                        }
                        Uo = new Fo(3), Fo != Float32Array && (Uo[0] = 0, Uo[1] = 0, Uo[2] = 0), function() {
                            var t1 = new Fo(4);
                            Fo != Float32Array && (t1[0] = 0, t1[1] = 0, t1[2] = 0, t1[3] = 0);
                        }();
                        var Ho = function(t1) {
                            var e1 = t1[0], r = t1[1];
                            return e1 * e1 + r * r;
                        }, Go = (function() {
                            var t1 = new Fo(2);
                            Fo != Float32Array && (t1[0] = 0, t1[1] = 0);
                        }(), function(t1) {
                            function e1(e1) {
                                t1.call(this, e1, Ro);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.createBucket = function(t1) {
                                return new _o(t1);
                            }, e1.prototype.queryRadius = function(t1) {
                                var e1 = t1;
                                return Po("circle-radius", this, e1) + Po("circle-stroke-width", this, e1) + zo(this.paint.get("circle-translate"));
                            }, e1.prototype.queryIntersectsFeature = function(t1, e1, r, n, i, a, o, s) {
                                for(var l = Oo(t1, this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), a.angle, o), c = this.paint.get("circle-radius").evaluate(e1, r) + this.paint.get("circle-stroke-width").evaluate(e1, r), u = "map" === this.paint.get("circle-pitch-alignment"), h = u ? l : function(t1, e1) {
                                    return t1.map(function(t1) {
                                        return Zo(t1, e1);
                                    });
                                }(l, s), f = u ? c * o : c, p = 0, d = n; p < d.length; p += 1)for(var m = 0, g = d[p]; m < g.length; m += 1){
                                    var y = g[m], v = u ? y : Zo(y, s), x = f, _ = qo([], [
                                        y.x,
                                        y.y,
                                        0,
                                        1
                                    ], s);
                                    if ("viewport" === this.paint.get("circle-pitch-scale") && "map" === this.paint.get("circle-pitch-alignment") ? x *= _[3] / a.cameraToCenterDistance : "map" === this.paint.get("circle-pitch-scale") && "viewport" === this.paint.get("circle-pitch-alignment") && (x *= a.cameraToCenterDistance / _[3]), wo(h, v, x)) return !0;
                                }
                                return !1;
                            }, e1;
                        }($i));
                        function Zo(t1, e1) {
                            var r = qo([], [
                                t1.x,
                                t1.y,
                                0,
                                1
                            ], e1);
                            return new a(r[0] / r[3], r[1] / r[3]);
                        }
                        var Wo = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1;
                        }(_o);
                        function Yo(t1, e1, r, n) {
                            var i = e1.width, a = e1.height;
                            if (n) {
                                if (n instanceof Uint8ClampedArray) n = new Uint8Array(n.buffer);
                                else if (n.length !== i * a * r) throw new RangeError("mismatched image size");
                            } else n = new Uint8Array(i * a * r);
                            return t1.width = i, t1.height = a, t1.data = n, t1;
                        }
                        function Xo(t1, e1, r) {
                            var n = e1.width, i = e1.height;
                            if (n !== t1.width || i !== t1.height) {
                                var a = Yo({}, {
                                    width: n,
                                    height: i
                                }, r);
                                $o(t1, a, {
                                    x: 0,
                                    y: 0
                                }, {
                                    x: 0,
                                    y: 0
                                }, {
                                    width: Math.min(t1.width, n),
                                    height: Math.min(t1.height, i)
                                }, r), t1.width = n, t1.height = i, t1.data = a.data;
                            }
                        }
                        function $o(t1, e1, r, n, i, a) {
                            if (0 === i.width || 0 === i.height) return e1;
                            if (i.width > t1.width || i.height > t1.height || r.x > t1.width - i.width || r.y > t1.height - i.height) throw new RangeError("out of range source coordinates for image copy");
                            if (i.width > e1.width || i.height > e1.height || n.x > e1.width - i.width || n.y > e1.height - i.height) throw new RangeError("out of range destination coordinates for image copy");
                            for(var o = t1.data, s = e1.data, l = 0; l < i.height; l++)for(var c = ((r.y + l) * t1.width + r.x) * a, u = ((n.y + l) * e1.width + n.x) * a, h = 0; h < i.width * a; h++)s[u + h] = o[c + h];
                            return e1;
                        }
                        oi("HeatmapBucket", Wo, {
                            omit: [
                                "layers"
                            ]
                        });
                        var Jo = function(t1, e1) {
                            Yo(this, t1, 1, e1);
                        };
                        Jo.prototype.resize = function(t1) {
                            Xo(this, t1, 1);
                        }, Jo.prototype.clone = function() {
                            return new Jo({
                                width: this.width,
                                height: this.height
                            }, new Uint8Array(this.data));
                        }, Jo.copy = function(t1, e1, r, n, i) {
                            $o(t1, e1, r, n, i, 1);
                        };
                        var Ko = function(t1, e1) {
                            Yo(this, t1, 4, e1);
                        };
                        Ko.prototype.resize = function(t1) {
                            Xo(this, t1, 4);
                        }, Ko.prototype.replace = function(t1, e1) {
                            e1 ? this.data.set(t1) : t1 instanceof Uint8ClampedArray ? this.data = new Uint8Array(t1.buffer) : this.data = t1;
                        }, Ko.prototype.clone = function() {
                            return new Ko({
                                width: this.width,
                                height: this.height
                            }, new Uint8Array(this.data));
                        }, Ko.copy = function(t1, e1, r, n, i) {
                            $o(t1, e1, r, n, i, 4);
                        }, oi("AlphaImage", Jo), oi("RGBAImage", Ko);
                        var Qo = {
                            paint: new Yi({
                                "heatmap-radius": new Hi(Ft.paint_heatmap["heatmap-radius"]),
                                "heatmap-weight": new Hi(Ft.paint_heatmap["heatmap-weight"]),
                                "heatmap-intensity": new qi(Ft.paint_heatmap["heatmap-intensity"]),
                                "heatmap-color": new Wi(Ft.paint_heatmap["heatmap-color"]),
                                "heatmap-opacity": new qi(Ft.paint_heatmap["heatmap-opacity"])
                            })
                        };
                        function ts(t1) {
                            var e1 = {}, r = t1.resolution || 256, n = t1.clips ? t1.clips.length : 1, i = t1.image || new Ko({
                                width: r,
                                height: n
                            }), a = function(r, n, a) {
                                e1[t1.evaluationKey] = a;
                                var o = t1.expression.evaluate(e1);
                                i.data[r + n + 0] = Math.floor(255 * o.r / o.a), i.data[r + n + 1] = Math.floor(255 * o.g / o.a), i.data[r + n + 2] = Math.floor(255 * o.b / o.a), i.data[r + n + 3] = Math.floor(255 * o.a);
                            };
                            if (t1.clips) for(var o = 0, s = 0; o < n; ++o, s += 4 * r)for(var l = 0, c = 0; l < r; l++, c += 4){
                                var u = l / (r - 1), h = t1.clips[o];
                                a(s, c, h.start * (1 - u) + h.end * u);
                            }
                            else for(var f = 0, p = 0; f < r; f++, p += 4)a(0, p, f / (r - 1));
                            return i;
                        }
                        var es = function(t1) {
                            function e1(e1) {
                                t1.call(this, e1, Qo), this._updateColorRamp();
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.createBucket = function(t1) {
                                return new Wo(t1);
                            }, e1.prototype._handleSpecialPaintPropertyUpdate = function(t1) {
                                "heatmap-color" === t1 && this._updateColorRamp();
                            }, e1.prototype._updateColorRamp = function() {
                                var t1 = this._transitionablePaint._values["heatmap-color"].value.expression;
                                this.colorRamp = ts({
                                    expression: t1,
                                    evaluationKey: "heatmapDensity",
                                    image: this.colorRamp
                                }), this.colorRampTexture = null;
                            }, e1.prototype.resize = function() {
                                this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null);
                            }, e1.prototype.queryRadius = function() {
                                return 0;
                            }, e1.prototype.queryIntersectsFeature = function() {
                                return !1;
                            }, e1.prototype.hasOffscreenPass = function() {
                                return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility;
                            }, e1;
                        }($i), rs = {
                            paint: new Yi({
                                "hillshade-illumination-direction": new qi(Ft.paint_hillshade["hillshade-illumination-direction"]),
                                "hillshade-illumination-anchor": new qi(Ft.paint_hillshade["hillshade-illumination-anchor"]),
                                "hillshade-exaggeration": new qi(Ft.paint_hillshade["hillshade-exaggeration"]),
                                "hillshade-shadow-color": new qi(Ft.paint_hillshade["hillshade-shadow-color"]),
                                "hillshade-highlight-color": new qi(Ft.paint_hillshade["hillshade-highlight-color"]),
                                "hillshade-accent-color": new qi(Ft.paint_hillshade["hillshade-accent-color"])
                            })
                        }, ns = function(t1) {
                            function e1(e1) {
                                t1.call(this, e1, rs);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.hasOffscreenPass = function() {
                                return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility;
                            }, e1;
                        }($i), is = ta([
                            {
                                name: "a_pos",
                                components: 2,
                                type: "Int16"
                            }
                        ], 4).members, as = ss, os = ss;
                        function ss(t1, e1, r) {
                            r = r || 2;
                            var n, i, a, o, s, l, c, u = e1 && e1.length, h = u ? e1[0] * r : t1.length, f = ls(t1, 0, h, r, !0), p = [];
                            if (!f || f.next === f.prev) return p;
                            if (u && (f = function(t1, e1, r, n) {
                                var i, a, o, s = [];
                                for(i = 0, a = e1.length; i < a; i++)(o = ls(t1, e1[i] * n, i < a - 1 ? e1[i + 1] * n : t1.length, n, !1)) === o.next && (o.steiner = !0), s.push(xs(o));
                                for(s.sort(ms), i = 0; i < s.length; i++)gs(s[i], r), r = cs(r, r.next);
                                return r;
                            }(t1, e1, f, r)), t1.length > 80 * r) {
                                n = a = t1[0], i = o = t1[1];
                                for(var d = r; d < h; d += r)(s = t1[d]) < n && (n = s), (l = t1[d + 1]) < i && (i = l), s > a && (a = s), l > o && (o = l);
                                c = 0 !== (c = Math.max(a - n, o - i)) ? 1 / c : 0;
                            }
                            return us(f, p, r, n, i, c), p;
                        }
                        function ls(t1, e1, r, n, i) {
                            var a, o;
                            if (i === Ps(t1, e1, r, n) > 0) for(a = e1; a < r; a += n)o = Cs(a, t1[a], t1[a + 1], o);
                            else for(a = r - n; a >= e1; a -= n)o = Cs(a, t1[a], t1[a + 1], o);
                            return o && Ts(o, o.next) && (Ls(o), o = o.next), o;
                        }
                        function cs(t1, e1) {
                            if (!t1) return t1;
                            e1 || (e1 = t1);
                            var r, n = t1;
                            do if (r = !1, n.steiner || !Ts(n, n.next) && 0 !== ws(n.prev, n, n.next)) n = n.next;
                            else {
                                if (Ls(n), (n = e1 = n.prev) === n.next) break;
                                r = !0;
                            }
                            while (r || n !== e1);
                            return e1;
                        }
                        function us(t1, e1, r, n, i, a, o) {
                            if (t1) {
                                !o && a && function(t1, e1, r, n) {
                                    var i = t1;
                                    do null === i.z && (i.z = vs(i.x, i.y, e1, r, n)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
                                    while (i !== t1);
                                    i.prevZ.nextZ = null, i.prevZ = null, function(t1) {
                                        var e1, r, n, i, a, o, s, l, c = 1;
                                        do {
                                            for(r = t1, t1 = null, a = null, o = 0; r;){
                                                for(o++, n = r, s = 0, e1 = 0; e1 < c && (s++, n = n.nextZ); e1++);
                                                for(l = c; s > 0 || l > 0 && n;)0 !== s && (0 === l || !n || r.z <= n.z) ? (i = r, r = r.nextZ, s--) : (i = n, n = n.nextZ, l--), a ? a.nextZ = i : t1 = i, i.prevZ = a, a = i;
                                                r = n;
                                            }
                                            a.nextZ = null, c *= 2;
                                        }while (o > 1);
                                    }(i);
                                }(t1, n, i, a);
                                for(var s, l, c = t1; t1.prev !== t1.next;)if (s = t1.prev, l = t1.next, a ? fs(t1, n, i, a) : hs(t1)) e1.push(s.i / r), e1.push(t1.i / r), e1.push(l.i / r), Ls(t1), t1 = l.next, c = l.next;
                                else if ((t1 = l) === c) {
                                    o ? 1 === o ? us(t1 = ps(cs(t1), e1, r), e1, r, n, i, a, 2) : 2 === o && ds(t1, e1, r, n, i, a) : us(cs(t1), e1, r, n, i, a, 1);
                                    break;
                                }
                            }
                        }
                        function hs(t1) {
                            var e1 = t1.prev, r = t1, n = t1.next;
                            if (ws(e1, r, n) >= 0) return !1;
                            for(var i = t1.next.next; i !== t1.prev;){
                                if (_s(e1.x, e1.y, r.x, r.y, n.x, n.y, i.x, i.y) && ws(i.prev, i, i.next) >= 0) return !1;
                                i = i.next;
                            }
                            return !0;
                        }
                        function fs(t1, e1, r, n) {
                            var i = t1.prev, a = t1, o = t1.next;
                            if (ws(i, a, o) >= 0) return !1;
                            for(var s = i.x < a.x ? i.x < o.x ? i.x : o.x : a.x < o.x ? a.x : o.x, l = i.y < a.y ? i.y < o.y ? i.y : o.y : a.y < o.y ? a.y : o.y, c = i.x > a.x ? i.x > o.x ? i.x : o.x : a.x > o.x ? a.x : o.x, u = i.y > a.y ? i.y > o.y ? i.y : o.y : a.y > o.y ? a.y : o.y, h = vs(s, l, e1, r, n), f = vs(c, u, e1, r, n), p = t1.prevZ, d = t1.nextZ; p && p.z >= h && d && d.z <= f;){
                                if (p !== t1.prev && p !== t1.next && _s(i.x, i.y, a.x, a.y, o.x, o.y, p.x, p.y) && ws(p.prev, p, p.next) >= 0) return !1;
                                if (p = p.prevZ, d !== t1.prev && d !== t1.next && _s(i.x, i.y, a.x, a.y, o.x, o.y, d.x, d.y) && ws(d.prev, d, d.next) >= 0) return !1;
                                d = d.nextZ;
                            }
                            for(; p && p.z >= h;){
                                if (p !== t1.prev && p !== t1.next && _s(i.x, i.y, a.x, a.y, o.x, o.y, p.x, p.y) && ws(p.prev, p, p.next) >= 0) return !1;
                                p = p.prevZ;
                            }
                            for(; d && d.z <= f;){
                                if (d !== t1.prev && d !== t1.next && _s(i.x, i.y, a.x, a.y, o.x, o.y, d.x, d.y) && ws(d.prev, d, d.next) >= 0) return !1;
                                d = d.nextZ;
                            }
                            return !0;
                        }
                        function ps(t1, e1, r) {
                            var n = t1;
                            do {
                                var i = n.prev, a = n.next.next;
                                !Ts(i, a) && ks(i, n, n.next, a) && Ss(i, a) && Ss(a, i) && (e1.push(i.i / r), e1.push(n.i / r), e1.push(a.i / r), Ls(n), Ls(n.next), n = t1 = a), n = n.next;
                            }while (n !== t1);
                            return cs(n);
                        }
                        function ds(t1, e1, r, n, i, a) {
                            var o = t1;
                            do {
                                for(var s = o.next.next; s !== o.prev;){
                                    if (o.i !== s.i && bs(o, s)) {
                                        var l = Es(o, s);
                                        return o = cs(o, o.next), l = cs(l, l.next), us(o, e1, r, n, i, a), void us(l, e1, r, n, i, a);
                                    }
                                    s = s.next;
                                }
                                o = o.next;
                            }while (o !== t1);
                        }
                        function ms(t1, e1) {
                            return t1.x - e1.x;
                        }
                        function gs(t1, e1) {
                            if (e1 = function(t1, e1) {
                                var r, n = e1, i = t1.x, a = t1.y, o = -1 / 0;
                                do {
                                    if (a <= n.y && a >= n.next.y && n.next.y !== n.y) {
                                        var s = n.x + (a - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
                                        if (s <= i && s > o) {
                                            if (o = s, s === i) {
                                                if (a === n.y) return n;
                                                if (a === n.next.y) return n.next;
                                            }
                                            r = n.x < n.next.x ? n : n.next;
                                        }
                                    }
                                    n = n.next;
                                }while (n !== e1);
                                if (!r) return null;
                                if (i === o) return r;
                                var l, c = r, u = r.x, h = r.y, f = 1 / 0;
                                n = r;
                                do i >= n.x && n.x >= u && i !== n.x && _s(a < h ? i : o, a, u, h, a < h ? o : i, a, n.x, n.y) && (l = Math.abs(a - n.y) / (i - n.x), Ss(n, t1) && (l < f || l === f && (n.x > r.x || n.x === r.x && ys(r, n))) && (r = n, f = l)), n = n.next;
                                while (n !== c);
                                return r;
                            }(t1, e1)) {
                                var r = Es(e1, t1);
                                cs(e1, e1.next), cs(r, r.next);
                            }
                        }
                        function ys(t1, e1) {
                            return ws(t1.prev, t1, e1.prev) < 0 && ws(e1.next, t1, t1.next) < 0;
                        }
                        function vs(t1, e1, r, n, i) {
                            return (t1 = 1431655765 & ((t1 = 858993459 & ((t1 = 252645135 & ((t1 = 16711935 & ((t1 = 32767 * (t1 - r) * i) | t1 << 8)) | t1 << 4)) | t1 << 2)) | t1 << 1)) | (e1 = 1431655765 & ((e1 = 858993459 & ((e1 = 252645135 & ((e1 = 16711935 & ((e1 = 32767 * (e1 - n) * i) | e1 << 8)) | e1 << 4)) | e1 << 2)) | e1 << 1)) << 1;
                        }
                        function xs(t1) {
                            var e1 = t1, r = t1;
                            do (e1.x < r.x || e1.x === r.x && e1.y < r.y) && (r = e1), e1 = e1.next;
                            while (e1 !== t1);
                            return r;
                        }
                        function _s(t1, e1, r, n, i, a, o, s) {
                            return (i - o) * (e1 - s) - (t1 - o) * (a - s) >= 0 && (t1 - o) * (n - s) - (r - o) * (e1 - s) >= 0 && (r - o) * (a - s) - (i - o) * (n - s) >= 0;
                        }
                        function bs(t1, e1) {
                            return t1.next.i !== e1.i && t1.prev.i !== e1.i && !function(t1, e1) {
                                var r = t1;
                                do {
                                    if (r.i !== t1.i && r.next.i !== t1.i && r.i !== e1.i && r.next.i !== e1.i && ks(r, r.next, t1, e1)) return !0;
                                    r = r.next;
                                }while (r !== t1);
                                return !1;
                            }(t1, e1) && (Ss(t1, e1) && Ss(e1, t1) && function(t1, e1) {
                                var r = t1, n = !1, i = (t1.x + e1.x) / 2, a = (t1.y + e1.y) / 2;
                                do r.y > a != r.next.y > a && r.next.y !== r.y && i < (r.next.x - r.x) * (a - r.y) / (r.next.y - r.y) + r.x && (n = !n), r = r.next;
                                while (r !== t1);
                                return n;
                            }(t1, e1) && (ws(t1.prev, t1, e1.prev) || ws(t1, e1.prev, e1)) || Ts(t1, e1) && ws(t1.prev, t1, t1.next) > 0 && ws(e1.prev, e1, e1.next) > 0);
                        }
                        function ws(t1, e1, r) {
                            return (e1.y - t1.y) * (r.x - e1.x) - (e1.x - t1.x) * (r.y - e1.y);
                        }
                        function Ts(t1, e1) {
                            return t1.x === e1.x && t1.y === e1.y;
                        }
                        function ks(t1, e1, r, n) {
                            var i = Ms(ws(t1, e1, r)), a = Ms(ws(t1, e1, n)), o = Ms(ws(r, n, t1)), s = Ms(ws(r, n, e1));
                            return i !== a && o !== s || !(0 !== i || !As(t1, r, e1)) || !(0 !== a || !As(t1, n, e1)) || !(0 !== o || !As(r, t1, n)) || !(0 !== s || !As(r, e1, n));
                        }
                        function As(t1, e1, r) {
                            return e1.x <= Math.max(t1.x, r.x) && e1.x >= Math.min(t1.x, r.x) && e1.y <= Math.max(t1.y, r.y) && e1.y >= Math.min(t1.y, r.y);
                        }
                        function Ms(t1) {
                            return t1 > 0 ? 1 : t1 < 0 ? -1 : 0;
                        }
                        function Ss(t1, e1) {
                            return ws(t1.prev, t1, t1.next) < 0 ? ws(t1, e1, t1.next) >= 0 && ws(t1, t1.prev, e1) >= 0 : ws(t1, e1, t1.prev) < 0 || ws(t1, t1.next, e1) < 0;
                        }
                        function Es(t1, e1) {
                            var r = new Is(t1.i, t1.x, t1.y), n = new Is(e1.i, e1.x, e1.y), i = t1.next, a = e1.prev;
                            return t1.next = e1, e1.prev = t1, r.next = i, i.prev = r, n.next = r, r.prev = n, a.next = n, n.prev = a, n;
                        }
                        function Cs(t1, e1, r, n) {
                            var i = new Is(t1, e1, r);
                            return n ? (i.next = n.next, i.prev = n, n.next.prev = i, n.next = i) : (i.prev = i, i.next = i), i;
                        }
                        function Ls(t1) {
                            t1.next.prev = t1.prev, t1.prev.next = t1.next, t1.prevZ && (t1.prevZ.nextZ = t1.nextZ), t1.nextZ && (t1.nextZ.prevZ = t1.prevZ);
                        }
                        function Is(t1, e1, r) {
                            this.i = t1, this.x = e1, this.y = r, this.prev = null, this.next = null, this.z = null, this.prevZ = null, this.nextZ = null, this.steiner = !1;
                        }
                        function Ps(t1, e1, r, n) {
                            for(var i = 0, a = e1, o = r - n; a < r; a += n)i += (t1[o] - t1[a]) * (t1[a + 1] + t1[o + 1]), o = a;
                            return i;
                        }
                        function zs(t1, e1, r, n, i) {
                            Os(t1, e1, r || 0, n || t1.length - 1, i || Rs);
                        }
                        function Os(t1, e1, r, n, i) {
                            for(; n > r;){
                                if (n - r > 600) {
                                    var a = n - r + 1, o = e1 - r + 1, s = Math.log(a), l = .5 * Math.exp(2 * s / 3), c = .5 * Math.sqrt(s * l * (a - l) / a) * (o - a / 2 < 0 ? -1 : 1);
                                    Os(t1, e1, Math.max(r, Math.floor(e1 - o * l / a + c)), Math.min(n, Math.floor(e1 + (a - o) * l / a + c)), i);
                                }
                                var u = t1[e1], h = r, f = n;
                                for(Ds(t1, r, e1), i(t1[n], u) > 0 && Ds(t1, r, n); h < f;){
                                    for(Ds(t1, h, f), h++, f--; i(t1[h], u) < 0;)h++;
                                    for(; i(t1[f], u) > 0;)f--;
                                }
                                0 === i(t1[r], u) ? Ds(t1, r, f) : Ds(t1, ++f, n), f <= e1 && (r = f + 1), e1 <= f && (n = f - 1);
                            }
                        }
                        function Ds(t1, e1, r) {
                            var n = t1[e1];
                            t1[e1] = t1[r], t1[r] = n;
                        }
                        function Rs(t1, e1) {
                            return t1 < e1 ? -1 : t1 > e1 ? 1 : 0;
                        }
                        function Fs(t1, e1) {
                            var r = t1.length;
                            if (r <= 1) return [
                                t1
                            ];
                            for(var n, i, a = [], o = 0; o < r; o++){
                                var s = M(t1[o]);
                                0 !== s && (t1[o].area = Math.abs(s), void 0 === i && (i = s < 0), i === s < 0 ? (n && a.push(n), n = [
                                    t1[o]
                                ]) : n.push(t1[o]));
                            }
                            if (n && a.push(n), e1 > 1) for(var l = 0; l < a.length; l++)a[l].length <= e1 || (zs(a[l], e1, 1, a[l].length - 1, Bs), a[l] = a[l].slice(0, e1));
                            return a;
                        }
                        function Bs(t1, e1) {
                            return e1.area - t1.area;
                        }
                        function Ns(t1, e1, r) {
                            for(var n = r.patternDependencies, i = !1, a = 0, o = e1; a < o.length; a += 1){
                                var s = o[a].paint.get(t1 + "-pattern");
                                s.isConstant() || (i = !0);
                                var l = s.constantOr(null);
                                l && (i = !0, n[l.to] = !0, n[l.from] = !0);
                            }
                            return i;
                        }
                        function js(t1, e1, r, n, i) {
                            for(var a = i.patternDependencies, o = 0, s = e1; o < s.length; o += 1){
                                var l = s[o], c = l.paint.get(t1 + "-pattern").value;
                                if ("constant" !== c.kind) {
                                    var u = c.evaluate({
                                        zoom: n - 1
                                    }, r, {}, i.availableImages), h = c.evaluate({
                                        zoom: n
                                    }, r, {}, i.availableImages), f = c.evaluate({
                                        zoom: n + 1
                                    }, r, {}, i.availableImages);
                                    u = u && u.name ? u.name : u, h = h && h.name ? h.name : h, f = f && f.name ? f.name : f, a[u] = !0, a[h] = !0, a[f] = !0, r.patterns[l.id] = {
                                        min: u,
                                        mid: h,
                                        max: f
                                    };
                                }
                            }
                            return r;
                        }
                        ss.deviation = function(t1, e1, r, n) {
                            var i = e1 && e1.length, a = i ? e1[0] * r : t1.length, o = Math.abs(Ps(t1, 0, a, r));
                            if (i) for(var s = 0, l = e1.length; s < l; s++){
                                var c = e1[s] * r, u = s < l - 1 ? e1[s + 1] * r : t1.length;
                                o -= Math.abs(Ps(t1, c, u, r));
                            }
                            var h = 0;
                            for(s = 0; s < n.length; s += 3){
                                var f = n[s] * r, p = n[s + 1] * r, d = n[s + 2] * r;
                                h += Math.abs((t1[f] - t1[d]) * (t1[p + 1] - t1[f + 1]) - (t1[f] - t1[p]) * (t1[d + 1] - t1[f + 1]));
                            }
                            return 0 === o && 0 === h ? 0 : Math.abs((h - o) / o);
                        }, ss.flatten = function(t1) {
                            for(var e1 = t1[0][0].length, r = {
                                vertices: [],
                                holes: [],
                                dimensions: e1
                            }, n = 0, i = 0; i < t1.length; i++){
                                for(var a = 0; a < t1[i].length; a++)for(var o = 0; o < e1; o++)r.vertices.push(t1[i][a][o]);
                                i > 0 && (n += t1[i - 1].length, r.holes.push(n));
                            }
                            return r;
                        }, as.default = os;
                        var Us = function(t1) {
                            this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map(function(t1) {
                                return t1.id;
                            }), this.index = t1.index, this.hasPattern = !1, this.patternFeatures = [], this.layoutVertexArray = new ra, this.indexArray = new ma, this.indexArray2 = new ba, this.programConfigurations = new uo(t1.layers, t1.zoom), this.segments = new Da, this.segments2 = new Da, this.stateDependentLayerIds = this.layers.filter(function(t1) {
                                return t1.isStateDependent();
                            }).map(function(t1) {
                                return t1.id;
                            });
                        };
                        Us.prototype.populate = function(t1, e1, r) {
                            this.hasPattern = Ns("fill", this.layers, e1);
                            for(var n = this.layers[0].layout.get("fill-sort-key"), i = [], a = 0, o = t1; a < o.length; a += 1){
                                var s = o[a], l = s.feature, c = s.id, u = s.index, h = s.sourceLayerIndex, f = this.layers[0]._featureFilter.needGeometry, p = vo(l, f);
                                if (this.layers[0]._featureFilter.filter(new Oi(this.zoom), p, r)) {
                                    var d = n ? n.evaluate(p, {}, r, e1.availableImages) : void 0, m = {
                                        id: c,
                                        properties: l.properties,
                                        type: l.type,
                                        sourceLayerIndex: h,
                                        index: u,
                                        geometry: f ? p.geometry : yo(l),
                                        patterns: {},
                                        sortKey: d
                                    };
                                    i.push(m);
                                }
                            }
                            n && i.sort(function(t1, e1) {
                                return t1.sortKey - e1.sortKey;
                            });
                            for(var g = 0, y = i; g < y.length; g += 1){
                                var v = y[g], x = v, _ = x.geometry, b = x.index, w = x.sourceLayerIndex;
                                if (this.hasPattern) {
                                    var T = js("fill", this.layers, v, this.zoom, e1);
                                    this.patternFeatures.push(T);
                                } else this.addFeature(v, _, b, r, {});
                                var k = t1[b].feature;
                                e1.featureIndex.insert(k, _, b, w, this.index);
                            }
                        }, Us.prototype.update = function(t1, e1, r) {
                            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r);
                        }, Us.prototype.addFeatures = function(t1, e1, r) {
                            for(var n = 0, i = this.patternFeatures; n < i.length; n += 1){
                                var a = i[n];
                                this.addFeature(a, a.geometry, a.index, e1, r);
                            }
                        }, Us.prototype.isEmpty = function() {
                            return 0 === this.layoutVertexArray.length;
                        }, Us.prototype.uploadPending = function() {
                            return !this.uploaded || this.programConfigurations.needsUpload;
                        }, Us.prototype.upload = function(t1) {
                            this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, is), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.indexBuffer2 = t1.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(t1), this.uploaded = !0;
                        }, Us.prototype.destroy = function() {
                            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
                        }, Us.prototype.addFeature = function(t1, e1, r, n, i) {
                            for(var a = 0, o = Fs(e1, 500); a < o.length; a += 1){
                                for(var s = o[a], l = 0, c = 0, u = s; c < u.length; c += 1)l += u[c].length;
                                for(var h = this.segments.prepareSegment(l, this.layoutVertexArray, this.indexArray), f = h.vertexLength, p = [], d = [], m = 0, g = s; m < g.length; m += 1){
                                    var y = g[m];
                                    if (0 !== y.length) {
                                        y !== s[0] && d.push(p.length / 2);
                                        var v = this.segments2.prepareSegment(y.length, this.layoutVertexArray, this.indexArray2), x = v.vertexLength;
                                        this.layoutVertexArray.emplaceBack(y[0].x, y[0].y), this.indexArray2.emplaceBack(x + y.length - 1, x), p.push(y[0].x), p.push(y[0].y);
                                        for(var _ = 1; _ < y.length; _++)this.layoutVertexArray.emplaceBack(y[_].x, y[_].y), this.indexArray2.emplaceBack(x + _ - 1, x + _), p.push(y[_].x), p.push(y[_].y);
                                        v.vertexLength += y.length, v.primitiveLength += y.length;
                                    }
                                }
                                for(var b = as(p, d), w = 0; w < b.length; w += 3)this.indexArray.emplaceBack(f + b[w], f + b[w + 1], f + b[w + 2]);
                                h.vertexLength += l, h.primitiveLength += b.length / 3;
                            }
                            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, n);
                        }, oi("FillBucket", Us, {
                            omit: [
                                "layers",
                                "patternFeatures"
                            ]
                        });
                        var Vs = new Yi({
                            "fill-sort-key": new Hi(Ft.layout_fill["fill-sort-key"])
                        }), qs = {
                            paint: new Yi({
                                "fill-antialias": new qi(Ft.paint_fill["fill-antialias"]),
                                "fill-opacity": new Hi(Ft.paint_fill["fill-opacity"]),
                                "fill-color": new Hi(Ft.paint_fill["fill-color"]),
                                "fill-outline-color": new Hi(Ft.paint_fill["fill-outline-color"]),
                                "fill-translate": new qi(Ft.paint_fill["fill-translate"]),
                                "fill-translate-anchor": new qi(Ft.paint_fill["fill-translate-anchor"]),
                                "fill-pattern": new Gi(Ft.paint_fill["fill-pattern"])
                            }),
                            layout: Vs
                        }, Hs = function(t1) {
                            function e1(e1) {
                                t1.call(this, e1, qs);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.recalculate = function(e1, r) {
                                t1.prototype.recalculate.call(this, e1, r);
                                var n = this.paint._values["fill-outline-color"];
                                "constant" === n.value.kind && void 0 === n.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
                            }, e1.prototype.createBucket = function(t1) {
                                return new Us(t1);
                            }, e1.prototype.queryRadius = function() {
                                return zo(this.paint.get("fill-translate"));
                            }, e1.prototype.queryIntersectsFeature = function(t1, e1, r, n, i, a, o) {
                                return To(Oo(t1, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), a.angle, o), n);
                            }, e1.prototype.isTileClipped = function() {
                                return !0;
                            }, e1;
                        }($i), Gs = ta([
                            {
                                name: "a_pos",
                                components: 2,
                                type: "Int16"
                            },
                            {
                                name: "a_normal_ed",
                                components: 4,
                                type: "Int16"
                            }
                        ], 4).members, Zs = Ws;
                        function Ws(t1, e1, r, n, i) {
                            this.properties = {}, this.extent = r, this.type = 0, this._pbf = t1, this._geometry = -1, this._keys = n, this._values = i, t1.readFields(Ys, this, e1);
                        }
                        function Ys(t1, e1, r) {
                            1 == t1 ? e1.id = r.readVarint() : 2 == t1 ? function(t1, e1) {
                                for(var r = t1.readVarint() + t1.pos; t1.pos < r;){
                                    var n = e1._keys[t1.readVarint()], i = e1._values[t1.readVarint()];
                                    e1.properties[n] = i;
                                }
                            }(r, e1) : 3 == t1 ? e1.type = r.readVarint() : 4 == t1 && (e1._geometry = r.pos);
                        }
                        function Xs(t1) {
                            for(var e1, r, n = 0, i = 0, a = t1.length, o = a - 1; i < a; o = i++)e1 = t1[i], n += ((r = t1[o]).x - e1.x) * (e1.y + r.y);
                            return n;
                        }
                        Ws.types = [
                            "Unknown",
                            "Point",
                            "LineString",
                            "Polygon"
                        ], Ws.prototype.loadGeometry = function() {
                            var t1 = this._pbf;
                            t1.pos = this._geometry;
                            for(var e1, r = t1.readVarint() + t1.pos, n = 1, i = 0, o = 0, s = 0, l = []; t1.pos < r;){
                                if (i <= 0) {
                                    var c = t1.readVarint();
                                    n = 7 & c, i = c >> 3;
                                }
                                if (i--, 1 === n || 2 === n) o += t1.readSVarint(), s += t1.readSVarint(), 1 === n && (e1 && l.push(e1), e1 = []), e1.push(new a(o, s));
                                else {
                                    if (7 !== n) throw new Error("unknown command " + n);
                                    e1 && e1.push(e1[0].clone());
                                }
                            }
                            return e1 && l.push(e1), l;
                        }, Ws.prototype.bbox = function() {
                            var t1 = this._pbf;
                            t1.pos = this._geometry;
                            for(var e1 = t1.readVarint() + t1.pos, r = 1, n = 0, i = 0, a = 0, o = 1 / 0, s = -1 / 0, l = 1 / 0, c = -1 / 0; t1.pos < e1;){
                                if (n <= 0) {
                                    var u = t1.readVarint();
                                    r = 7 & u, n = u >> 3;
                                }
                                if (n--, 1 === r || 2 === r) (i += t1.readSVarint()) < o && (o = i), i > s && (s = i), (a += t1.readSVarint()) < l && (l = a), a > c && (c = a);
                                else if (7 !== r) throw new Error("unknown command " + r);
                            }
                            return [
                                o,
                                l,
                                s,
                                c
                            ];
                        }, Ws.prototype.toGeoJSON = function(t1, e1, r) {
                            var n, i, a = this.extent * Math.pow(2, r), o = this.extent * t1, s = this.extent * e1, l = this.loadGeometry(), c = Ws.types[this.type];
                            function u(t1) {
                                for(var e1 = 0; e1 < t1.length; e1++){
                                    var r = t1[e1], n = 180 - 360 * (r.y + s) / a;
                                    t1[e1] = [
                                        360 * (r.x + o) / a - 180,
                                        360 / Math.PI * Math.atan(Math.exp(n * Math.PI / 180)) - 90
                                    ];
                                }
                            }
                            switch(this.type){
                                case 1:
                                    var h = [];
                                    for(n = 0; n < l.length; n++)h[n] = l[n][0];
                                    u(l = h);
                                    break;
                                case 2:
                                    for(n = 0; n < l.length; n++)u(l[n]);
                                    break;
                                case 3:
                                    for(l = function(t1) {
                                        var e1 = t1.length;
                                        if (e1 <= 1) return [
                                            t1
                                        ];
                                        for(var r, n, i = [], a = 0; a < e1; a++){
                                            var o = Xs(t1[a]);
                                            0 !== o && (void 0 === n && (n = o < 0), n === o < 0 ? (r && i.push(r), r = [
                                                t1[a]
                                            ]) : r.push(t1[a]));
                                        }
                                        return r && i.push(r), i;
                                    }(l), n = 0; n < l.length; n++)for(i = 0; i < l[n].length; i++)u(l[n][i]);
                            }
                            1 === l.length ? l = l[0] : c = "Multi" + c;
                            var f = {
                                type: "Feature",
                                geometry: {
                                    type: c,
                                    coordinates: l
                                },
                                properties: this.properties
                            };
                            return "id" in this && (f.id = this.id), f;
                        };
                        var $s = Js;
                        function Js(t1, e1) {
                            this.version = 1, this.name = null, this.extent = 4096, this.length = 0, this._pbf = t1, this._keys = [], this._values = [], this._features = [], t1.readFields(Ks, this, e1), this.length = this._features.length;
                        }
                        function Ks(t1, e1, r) {
                            15 === t1 ? e1.version = r.readVarint() : 1 === t1 ? e1.name = r.readString() : 5 === t1 ? e1.extent = r.readVarint() : 2 === t1 ? e1._features.push(r.pos) : 3 === t1 ? e1._keys.push(r.readString()) : 4 === t1 && e1._values.push(function(t1) {
                                for(var e1 = null, r = t1.readVarint() + t1.pos; t1.pos < r;){
                                    var n = t1.readVarint() >> 3;
                                    e1 = 1 === n ? t1.readString() : 2 === n ? t1.readFloat() : 3 === n ? t1.readDouble() : 4 === n ? t1.readVarint64() : 5 === n ? t1.readVarint() : 6 === n ? t1.readSVarint() : 7 === n ? t1.readBoolean() : null;
                                }
                                return e1;
                            }(r));
                        }
                        function Qs(t1, e1, r) {
                            if (3 === t1) {
                                var n = new $s(r, r.readVarint() + r.pos);
                                n.length && (e1[n.name] = n);
                            }
                        }
                        Js.prototype.feature = function(t1) {
                            if (t1 < 0 || t1 >= this._features.length) throw new Error("feature index out of bounds");
                            this._pbf.pos = this._features[t1];
                            var e1 = this._pbf.readVarint() + this._pbf.pos;
                            return new Zs(this._pbf, e1, this.extent, this._keys, this._values);
                        };
                        var tl = {
                            VectorTile: function(t1, e1) {
                                this.layers = t1.readFields(Qs, {}, e1);
                            },
                            VectorTileFeature: Zs,
                            VectorTileLayer: $s
                        }, el = tl.VectorTileFeature.types, rl = Math.pow(2, 13);
                        function nl(t1, e1, r, n, i, a, o, s) {
                            t1.emplaceBack(e1, r, 2 * Math.floor(n * rl) + o, i * rl * 2, a * rl * 2, Math.round(s));
                        }
                        var il = function(t1) {
                            this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map(function(t1) {
                                return t1.id;
                            }), this.index = t1.index, this.hasPattern = !1, this.layoutVertexArray = new ia, this.indexArray = new ma, this.programConfigurations = new uo(t1.layers, t1.zoom), this.segments = new Da, this.stateDependentLayerIds = this.layers.filter(function(t1) {
                                return t1.isStateDependent();
                            }).map(function(t1) {
                                return t1.id;
                            });
                        };
                        function al(t1, e1) {
                            return t1.x === e1.x && (t1.x < 0 || t1.x > po) || t1.y === e1.y && (t1.y < 0 || t1.y > po);
                        }
                        il.prototype.populate = function(t1, e1, r) {
                            this.features = [], this.hasPattern = Ns("fill-extrusion", this.layers, e1);
                            for(var n = 0, i = t1; n < i.length; n += 1){
                                var a = i[n], o = a.feature, s = a.id, l = a.index, c = a.sourceLayerIndex, u = this.layers[0]._featureFilter.needGeometry, h = vo(o, u);
                                if (this.layers[0]._featureFilter.filter(new Oi(this.zoom), h, r)) {
                                    var f = {
                                        id: s,
                                        sourceLayerIndex: c,
                                        index: l,
                                        geometry: u ? h.geometry : yo(o),
                                        properties: o.properties,
                                        type: o.type,
                                        patterns: {}
                                    };
                                    this.hasPattern ? this.features.push(js("fill-extrusion", this.layers, f, this.zoom, e1)) : this.addFeature(f, f.geometry, l, r, {}), e1.featureIndex.insert(o, f.geometry, l, c, this.index, !0);
                                }
                            }
                        }, il.prototype.addFeatures = function(t1, e1, r) {
                            for(var n = 0, i = this.features; n < i.length; n += 1){
                                var a = i[n], o = a.geometry;
                                this.addFeature(a, o, a.index, e1, r);
                            }
                        }, il.prototype.update = function(t1, e1, r) {
                            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r);
                        }, il.prototype.isEmpty = function() {
                            return 0 === this.layoutVertexArray.length;
                        }, il.prototype.uploadPending = function() {
                            return !this.uploaded || this.programConfigurations.needsUpload;
                        }, il.prototype.upload = function(t1) {
                            this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, Gs), this.indexBuffer = t1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t1), this.uploaded = !0;
                        }, il.prototype.destroy = function() {
                            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
                        }, il.prototype.addFeature = function(t1, e1, r, n, i) {
                            for(var a = 0, o = Fs(e1, 500); a < o.length; a += 1){
                                for(var s = o[a], l = 0, c = 0, u = s; c < u.length; c += 1)l += u[c].length;
                                for(var h = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray), f = 0, p = s; f < p.length; f += 1){
                                    var d = p[f];
                                    if (0 !== d.length && !((P = d).every(function(t1) {
                                        return t1.x < 0;
                                    }) || P.every(function(t1) {
                                        return t1.x > po;
                                    }) || P.every(function(t1) {
                                        return t1.y < 0;
                                    }) || P.every(function(t1) {
                                        return t1.y > po;
                                    }))) for(var m = 0, g = 0; g < d.length; g++){
                                        var y = d[g];
                                        if (g >= 1) {
                                            var v = d[g - 1];
                                            if (!al(y, v)) {
                                                h.vertexLength + 4 > Da.MAX_VERTEX_ARRAY_LENGTH && (h = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray));
                                                var x = y.sub(v)._perp()._unit(), _ = v.dist(y);
                                                m + _ > 32768 && (m = 0), nl(this.layoutVertexArray, y.x, y.y, x.x, x.y, 0, 0, m), nl(this.layoutVertexArray, y.x, y.y, x.x, x.y, 0, 1, m), m += _, nl(this.layoutVertexArray, v.x, v.y, x.x, x.y, 0, 0, m), nl(this.layoutVertexArray, v.x, v.y, x.x, x.y, 0, 1, m);
                                                var b = h.vertexLength;
                                                this.indexArray.emplaceBack(b, b + 2, b + 1), this.indexArray.emplaceBack(b + 1, b + 2, b + 3), h.vertexLength += 4, h.primitiveLength += 2;
                                            }
                                        }
                                    }
                                }
                                if (h.vertexLength + l > Da.MAX_VERTEX_ARRAY_LENGTH && (h = this.segments.prepareSegment(l, this.layoutVertexArray, this.indexArray)), "Polygon" === el[t1.type]) {
                                    for(var w = [], T = [], k = h.vertexLength, A = 0, M = s; A < M.length; A += 1){
                                        var S = M[A];
                                        if (0 !== S.length) {
                                            S !== s[0] && T.push(w.length / 2);
                                            for(var E = 0; E < S.length; E++){
                                                var C = S[E];
                                                nl(this.layoutVertexArray, C.x, C.y, 0, 0, 1, 1, 0), w.push(C.x), w.push(C.y);
                                            }
                                        }
                                    }
                                    for(var L = as(w, T), I = 0; I < L.length; I += 3)this.indexArray.emplaceBack(k + L[I], k + L[I + 2], k + L[I + 1]);
                                    h.primitiveLength += L.length / 3, h.vertexLength += l;
                                }
                            }
                            var P;
                            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, n);
                        }, oi("FillExtrusionBucket", il, {
                            omit: [
                                "layers",
                                "features"
                            ]
                        });
                        var ol = {
                            paint: new Yi({
                                "fill-extrusion-opacity": new qi(Ft["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                                "fill-extrusion-color": new Hi(Ft["paint_fill-extrusion"]["fill-extrusion-color"]),
                                "fill-extrusion-translate": new qi(Ft["paint_fill-extrusion"]["fill-extrusion-translate"]),
                                "fill-extrusion-translate-anchor": new qi(Ft["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                                "fill-extrusion-pattern": new Gi(Ft["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                                "fill-extrusion-height": new Hi(Ft["paint_fill-extrusion"]["fill-extrusion-height"]),
                                "fill-extrusion-base": new Hi(Ft["paint_fill-extrusion"]["fill-extrusion-base"]),
                                "fill-extrusion-vertical-gradient": new qi(Ft["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"])
                            })
                        }, sl = function(t1) {
                            function e1(e1) {
                                t1.call(this, e1, ol);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.createBucket = function(t1) {
                                return new il(t1);
                            }, e1.prototype.queryRadius = function() {
                                return zo(this.paint.get("fill-extrusion-translate"));
                            }, e1.prototype.is3D = function() {
                                return !0;
                            }, e1.prototype.queryIntersectsFeature = function(t1, e1, r, n, i, o, s, l) {
                                var c = Oo(t1, this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), o.angle, s), u = this.paint.get("fill-extrusion-height").evaluate(e1, r), h = this.paint.get("fill-extrusion-base").evaluate(e1, r), f = function(t1, e1, r, n) {
                                    for(var i = [], o = 0, s = t1; o < s.length; o += 1){
                                        var l = s[o], c = [
                                            l.x,
                                            l.y,
                                            n,
                                            1
                                        ];
                                        qo(c, c, e1), i.push(new a(c[0] / c[3], c[1] / c[3]));
                                    }
                                    return i;
                                }(c, l, 0, 0), p = function(t1, e1, r, n) {
                                    for(var i = [], o = [], s = n[8] * e1, l = n[9] * e1, c = n[10] * e1, u = n[11] * e1, h = n[8] * r, f = n[9] * r, p = n[10] * r, d = n[11] * r, m = 0, g = t1; m < g.length; m += 1){
                                        for(var y = [], v = [], x = 0, _ = g[m]; x < _.length; x += 1){
                                            var b = _[x], w = b.x, T = b.y, k = n[0] * w + n[4] * T + n[12], A = n[1] * w + n[5] * T + n[13], M = n[2] * w + n[6] * T + n[14], S = n[3] * w + n[7] * T + n[15], E = M + c, C = S + u, L = k + h, I = A + f, P = M + p, z = S + d, O = new a((k + s) / C, (A + l) / C);
                                            O.z = E / C, y.push(O);
                                            var D = new a(L / z, I / z);
                                            D.z = P / z, v.push(D);
                                        }
                                        i.push(y), o.push(v);
                                    }
                                    return [
                                        i,
                                        o
                                    ];
                                }(n, h, u, l);
                                return function(t1, e1, r) {
                                    var n = 1 / 0;
                                    To(r, e1) && (n = cl(r, e1[0]));
                                    for(var i = 0; i < e1.length; i++)for(var a = e1[i], o = t1[i], s = 0; s < a.length - 1; s++){
                                        var l = a[s], c = a[s + 1], u = o[s], h = [
                                            l,
                                            c,
                                            o[s + 1],
                                            u,
                                            l
                                        ];
                                        bo(r, h) && (n = Math.min(n, cl(r, h)));
                                    }
                                    return n !== 1 / 0 && n;
                                }(p[0], p[1], f);
                            }, e1;
                        }($i);
                        function ll(t1, e1) {
                            return t1.x * e1.x + t1.y * e1.y;
                        }
                        function cl(t1, e1) {
                            if (1 === t1.length) {
                                for(var r, n = 0, i = e1[n++]; !r || i.equals(r);)if (!(r = e1[n++])) return 1 / 0;
                                for(; n < e1.length; n++){
                                    var a = e1[n], o = t1[0], s = r.sub(i), l = a.sub(i), c = o.sub(i), u = ll(s, s), h = ll(s, l), f = ll(l, l), p = ll(c, s), d = ll(c, l), m = u * f - h * h, g = (f * p - h * d) / m, y = (u * d - h * p) / m, v = 1 - g - y, x = i.z * v + r.z * g + a.z * y;
                                    if (isFinite(x)) return x;
                                }
                                return 1 / 0;
                            }
                            for(var _ = 1 / 0, b = 0, w = e1; b < w.length; b += 1){
                                var T = w[b];
                                _ = Math.min(_, T.z);
                            }
                            return _;
                        }
                        var ul = ta([
                            {
                                name: "a_pos_normal",
                                components: 2,
                                type: "Int16"
                            },
                            {
                                name: "a_data",
                                components: 4,
                                type: "Uint8"
                            }
                        ], 4).members, hl = ta([
                            {
                                name: "a_uv_x",
                                components: 1,
                                type: "Float32"
                            },
                            {
                                name: "a_split_index",
                                components: 1,
                                type: "Float32"
                            }
                        ]).members, fl = tl.VectorTileFeature.types, pl = Math.cos(Math.PI / 180 * 37.5), dl = Math.pow(2, 14) / .5, ml = function(t1) {
                            var e1 = this;
                            this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map(function(t1) {
                                return t1.id;
                            }), this.index = t1.index, this.hasPattern = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach(function(t1) {
                                e1.gradients[t1.id] = {};
                            }), this.layoutVertexArray = new aa, this.layoutVertexArray2 = new oa, this.indexArray = new ma, this.programConfigurations = new uo(t1.layers, t1.zoom), this.segments = new Da, this.maxLineLength = 0, this.stateDependentLayerIds = this.layers.filter(function(t1) {
                                return t1.isStateDependent();
                            }).map(function(t1) {
                                return t1.id;
                            });
                        };
                        ml.prototype.populate = function(t1, e1, r) {
                            this.hasPattern = Ns("line", this.layers, e1);
                            for(var n = this.layers[0].layout.get("line-sort-key"), i = [], a = 0, o = t1; a < o.length; a += 1){
                                var s = o[a], l = s.feature, c = s.id, u = s.index, h = s.sourceLayerIndex, f = this.layers[0]._featureFilter.needGeometry, p = vo(l, f);
                                if (this.layers[0]._featureFilter.filter(new Oi(this.zoom), p, r)) {
                                    var d = n ? n.evaluate(p, {}, r) : void 0, m = {
                                        id: c,
                                        properties: l.properties,
                                        type: l.type,
                                        sourceLayerIndex: h,
                                        index: u,
                                        geometry: f ? p.geometry : yo(l),
                                        patterns: {},
                                        sortKey: d
                                    };
                                    i.push(m);
                                }
                            }
                            n && i.sort(function(t1, e1) {
                                return t1.sortKey - e1.sortKey;
                            });
                            for(var g = 0, y = i; g < y.length; g += 1){
                                var v = y[g], x = v, _ = x.geometry, b = x.index, w = x.sourceLayerIndex;
                                if (this.hasPattern) {
                                    var T = js("line", this.layers, v, this.zoom, e1);
                                    this.patternFeatures.push(T);
                                } else this.addFeature(v, _, b, r, {});
                                var k = t1[b].feature;
                                e1.featureIndex.insert(k, _, b, w, this.index);
                            }
                        }, ml.prototype.update = function(t1, e1, r) {
                            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r);
                        }, ml.prototype.addFeatures = function(t1, e1, r) {
                            for(var n = 0, i = this.patternFeatures; n < i.length; n += 1){
                                var a = i[n];
                                this.addFeature(a, a.geometry, a.index, e1, r);
                            }
                        }, ml.prototype.isEmpty = function() {
                            return 0 === this.layoutVertexArray.length;
                        }, ml.prototype.uploadPending = function() {
                            return !this.uploaded || this.programConfigurations.needsUpload;
                        }, ml.prototype.upload = function(t1) {
                            this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = t1.createVertexBuffer(this.layoutVertexArray2, hl)), this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, ul), this.indexBuffer = t1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t1), this.uploaded = !0;
                        }, ml.prototype.destroy = function() {
                            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
                        }, ml.prototype.lineFeatureClips = function(t1) {
                            if (t1.properties && t1.properties.hasOwnProperty("mapbox_clip_start") && t1.properties.hasOwnProperty("mapbox_clip_end")) return {
                                start: +t1.properties.mapbox_clip_start,
                                end: +t1.properties.mapbox_clip_end
                            };
                        }, ml.prototype.addFeature = function(t1, e1, r, n, i) {
                            var a = this.layers[0].layout, o = a.get("line-join").evaluate(t1, {}), s = a.get("line-cap"), l = a.get("line-miter-limit"), c = a.get("line-round-limit");
                            this.lineClips = this.lineFeatureClips(t1);
                            for(var u = 0, h = e1; u < h.length; u += 1){
                                var f = h[u];
                                this.addLine(f, t1, o, s, l, c);
                            }
                            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, n);
                        }, ml.prototype.addLine = function(t1, e1, r, n, i, a) {
                            if (this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, this.lineClips) {
                                this.lineClipsArray.push(this.lineClips);
                                for(var o = 0; o < t1.length - 1; o++)this.totalDistance += t1[o].dist(t1[o + 1]);
                                this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
                            }
                            for(var s = "Polygon" === fl[e1.type], l = t1.length; l >= 2 && t1[l - 1].equals(t1[l - 2]);)l--;
                            for(var c = 0; c < l - 1 && t1[c].equals(t1[c + 1]);)c++;
                            if (!(l < (s ? 3 : 2))) {
                                "bevel" === r && (i = 1.05);
                                var u, h = this.overscaling <= 16 ? 15 * po / (512 * this.overscaling) : 0, f = this.segments.prepareSegment(10 * l, this.layoutVertexArray, this.indexArray), p = void 0, d = void 0, m = void 0, g = void 0;
                                this.e1 = this.e2 = -1, s && (u = t1[l - 2], g = t1[c].sub(u)._unit()._perp());
                                for(var y = c; y < l; y++)if (!(d = y === l - 1 ? s ? t1[c + 1] : void 0 : t1[y + 1]) || !t1[y].equals(d)) {
                                    g && (m = g), u && (p = u), u = t1[y], g = d ? d.sub(u)._unit()._perp() : m;
                                    var v = (m = m || g).add(g);
                                    0 === v.x && 0 === v.y || v._unit();
                                    var x = m.x * g.x + m.y * g.y, _ = v.x * g.x + v.y * g.y, b = 0 !== _ ? 1 / _ : 1 / 0, w = 2 * Math.sqrt(2 - 2 * _), T = _ < pl && p && d, k = m.x * g.y - m.y * g.x > 0;
                                    if (T && y > c) {
                                        var A = u.dist(p);
                                        if (A > 2 * h) {
                                            var M = u.sub(u.sub(p)._mult(h / A)._round());
                                            this.updateDistance(p, M), this.addCurrentVertex(M, m, 0, 0, f), p = M;
                                        }
                                    }
                                    var S = p && d, E = S ? r : s ? "butt" : n;
                                    if (S && "round" === E && (b < a ? E = "miter" : b <= 2 && (E = "fakeround")), "miter" === E && b > i && (E = "bevel"), "bevel" === E && (b > 2 && (E = "flipbevel"), b < i && (E = "miter")), p && this.updateDistance(p, u), "miter" === E) v._mult(b), this.addCurrentVertex(u, v, 0, 0, f);
                                    else if ("flipbevel" === E) {
                                        if (b > 100) v = g.mult(-1);
                                        else {
                                            var C = b * m.add(g).mag() / m.sub(g).mag();
                                            v._perp()._mult(C * (k ? -1 : 1));
                                        }
                                        this.addCurrentVertex(u, v, 0, 0, f), this.addCurrentVertex(u, v.mult(-1), 0, 0, f);
                                    } else if ("bevel" === E || "fakeround" === E) {
                                        var L = -Math.sqrt(b * b - 1), I = k ? L : 0, P = k ? 0 : L;
                                        if (p && this.addCurrentVertex(u, m, I, P, f), "fakeround" === E) for(var z = Math.round(180 * w / Math.PI / 20), O = 1; O < z; O++){
                                            var D = O / z;
                                            if (.5 !== D) {
                                                var R = D - .5;
                                                D += D * R * (D - 1) * ((1.0904 + x * (x * (3.55645 - 1.43519 * x) - 3.2452)) * R * R + (.848013 + x * (.215638 * x - 1.06021)));
                                            }
                                            var F = g.sub(m)._mult(D)._add(m)._unit()._mult(k ? -1 : 1);
                                            this.addHalfVertex(u, F.x, F.y, !1, k, 0, f);
                                        }
                                        d && this.addCurrentVertex(u, g, -I, -P, f);
                                    } else if ("butt" === E) this.addCurrentVertex(u, v, 0, 0, f);
                                    else if ("square" === E) {
                                        var B = p ? 1 : -1;
                                        this.addCurrentVertex(u, v, B, B, f);
                                    } else "round" === E && (p && (this.addCurrentVertex(u, m, 0, 0, f), this.addCurrentVertex(u, m, 1, 1, f, !0)), d && (this.addCurrentVertex(u, g, -1, -1, f, !0), this.addCurrentVertex(u, g, 0, 0, f)));
                                    if (T && y < l - 1) {
                                        var N = u.dist(d);
                                        if (N > 2 * h) {
                                            var j = u.add(d.sub(u)._mult(h / N)._round());
                                            this.updateDistance(u, j), this.addCurrentVertex(j, g, 0, 0, f), u = j;
                                        }
                                    }
                                }
                            }
                        }, ml.prototype.addCurrentVertex = function(t1, e1, r, n, i, a) {
                            void 0 === a && (a = !1);
                            var o = e1.x + e1.y * r, s = e1.y - e1.x * r, l = -e1.x + e1.y * n, c = -e1.y - e1.x * n;
                            this.addHalfVertex(t1, o, s, a, !1, r, i), this.addHalfVertex(t1, l, c, a, !0, -n, i), this.distance > dl / 2 && 0 === this.totalDistance && (this.distance = 0, this.addCurrentVertex(t1, e1, r, n, i, a));
                        }, ml.prototype.addHalfVertex = function(t1, e1, r, n, i, a, o) {
                            var s = t1.x, l = t1.y, c = .5 * (this.lineClips ? this.scaledDistance * (dl - 1) : this.scaledDistance);
                            if (this.layoutVertexArray.emplaceBack((s << 1) + (n ? 1 : 0), (l << 1) + (i ? 1 : 0), Math.round(63 * e1) + 128, Math.round(63 * r) + 128, 1 + (0 === a ? 0 : a < 0 ? -1 : 1) | (63 & c) << 2, c >> 6), this.lineClips) {
                                var u = (this.scaledDistance - this.lineClips.start) / (this.lineClips.end - this.lineClips.start);
                                this.layoutVertexArray2.emplaceBack(u, this.lineClipsArray.length);
                            }
                            var h = o.vertexLength++;
                            this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, this.e2, h), o.primitiveLength++), i ? this.e2 = h : this.e1 = h;
                        }, ml.prototype.updateScaledDistance = function() {
                            this.scaledDistance = this.lineClips ? this.lineClips.start + (this.lineClips.end - this.lineClips.start) * this.distance / this.totalDistance : this.distance;
                        }, ml.prototype.updateDistance = function(t1, e1) {
                            this.distance += t1.dist(e1), this.updateScaledDistance();
                        }, oi("LineBucket", ml, {
                            omit: [
                                "layers",
                                "patternFeatures"
                            ]
                        });
                        var gl1 = new Yi({
                            "line-cap": new qi(Ft.layout_line["line-cap"]),
                            "line-join": new Hi(Ft.layout_line["line-join"]),
                            "line-miter-limit": new qi(Ft.layout_line["line-miter-limit"]),
                            "line-round-limit": new qi(Ft.layout_line["line-round-limit"]),
                            "line-sort-key": new Hi(Ft.layout_line["line-sort-key"])
                        }), yl = {
                            paint: new Yi({
                                "line-opacity": new Hi(Ft.paint_line["line-opacity"]),
                                "line-color": new Hi(Ft.paint_line["line-color"]),
                                "line-translate": new qi(Ft.paint_line["line-translate"]),
                                "line-translate-anchor": new qi(Ft.paint_line["line-translate-anchor"]),
                                "line-width": new Hi(Ft.paint_line["line-width"]),
                                "line-gap-width": new Hi(Ft.paint_line["line-gap-width"]),
                                "line-offset": new Hi(Ft.paint_line["line-offset"]),
                                "line-blur": new Hi(Ft.paint_line["line-blur"]),
                                "line-dasharray": new Zi(Ft.paint_line["line-dasharray"]),
                                "line-pattern": new Gi(Ft.paint_line["line-pattern"]),
                                "line-gradient": new Wi(Ft.paint_line["line-gradient"])
                            }),
                            layout: gl1
                        }, vl = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.possiblyEvaluate = function(e1, r) {
                                return r = new Oi(Math.floor(r.zoom), {
                                    now: r.now,
                                    fadeDuration: r.fadeDuration,
                                    zoomHistory: r.zoomHistory,
                                    transition: r.transition
                                }), t1.prototype.possiblyEvaluate.call(this, e1, r);
                            }, e1.prototype.evaluate = function(e1, r, n, i) {
                                return r = p({}, r, {
                                    zoom: Math.floor(r.zoom)
                                }), t1.prototype.evaluate.call(this, e1, r, n, i);
                            }, e1;
                        }(Hi), xl = new vl(yl.paint.properties["line-width"].specification);
                        xl.useIntegerZoom = !0;
                        var _l = function(t1) {
                            function e1(e1) {
                                t1.call(this, e1, yl), this.gradientVersion = 0;
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._handleSpecialPaintPropertyUpdate = function(t1) {
                                if ("line-gradient" === t1) {
                                    var e1 = this._transitionablePaint._values["line-gradient"].value.expression;
                                    this.stepInterpolant = e1._styleExpression.expression instanceof tr, this.gradientVersion = (this.gradientVersion + 1) % l;
                                }
                            }, e1.prototype.gradientExpression = function() {
                                return this._transitionablePaint._values["line-gradient"].value.expression;
                            }, e1.prototype.recalculate = function(e1, r) {
                                t1.prototype.recalculate.call(this, e1, r), this.paint._values["line-floorwidth"] = xl.possiblyEvaluate(this._transitioningPaint._values["line-width"].value, e1);
                            }, e1.prototype.createBucket = function(t1) {
                                return new ml(t1);
                            }, e1.prototype.queryRadius = function(t1) {
                                var e1 = t1, r = bl(Po("line-width", this, e1), Po("line-gap-width", this, e1)), n = Po("line-offset", this, e1);
                                return r / 2 + Math.abs(n) + zo(this.paint.get("line-translate"));
                            }, e1.prototype.queryIntersectsFeature = function(t1, e1, r, n, i, o, s) {
                                var l = Oo(t1, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), o.angle, s), c = s / 2 * bl(this.paint.get("line-width").evaluate(e1, r), this.paint.get("line-gap-width").evaluate(e1, r)), u = this.paint.get("line-offset").evaluate(e1, r);
                                return u && (n = function(t1, e1) {
                                    for(var r = [], n = new a(0, 0), i = 0; i < t1.length; i++){
                                        for(var o = t1[i], s = [], l = 0; l < o.length; l++){
                                            var c = o[l - 1], u = o[l], h = o[l + 1], f = 0 === l ? n : u.sub(c)._unit()._perp(), p = l === o.length - 1 ? n : h.sub(u)._unit()._perp(), d = f._add(p)._unit(), m = d.x * p.x + d.y * p.y;
                                            d._mult(1 / m), s.push(d._mult(e1)._add(u));
                                        }
                                        r.push(s);
                                    }
                                    return r;
                                }(n, u * s)), function(t1, e1, r) {
                                    for(var n = 0; n < e1.length; n++){
                                        var i = e1[n];
                                        if (t1.length >= 3) {
                                            for(var a = 0; a < i.length; a++)if (Lo(t1, i[a])) return !0;
                                        }
                                        if (ko(t1, i, r)) return !0;
                                    }
                                    return !1;
                                }(l, n, c);
                            }, e1.prototype.isTileClipped = function() {
                                return !0;
                            }, e1;
                        }($i);
                        function bl(t1, e1) {
                            return e1 > 0 ? e1 + 2 * t1 : t1;
                        }
                        var wl = ta([
                            {
                                name: "a_pos_offset",
                                components: 4,
                                type: "Int16"
                            },
                            {
                                name: "a_data",
                                components: 4,
                                type: "Uint16"
                            },
                            {
                                name: "a_pixeloffset",
                                components: 4,
                                type: "Int16"
                            }
                        ], 4), Tl = ta([
                            {
                                name: "a_projected_pos",
                                components: 3,
                                type: "Float32"
                            }
                        ], 4), kl = (ta([
                            {
                                name: "a_fade_opacity",
                                components: 1,
                                type: "Uint32"
                            }
                        ], 4), ta([
                            {
                                name: "a_placed",
                                components: 2,
                                type: "Uint8"
                            },
                            {
                                name: "a_shift",
                                components: 2,
                                type: "Float32"
                            }
                        ])), Al = (ta([
                            {
                                type: "Int16",
                                name: "anchorPointX"
                            },
                            {
                                type: "Int16",
                                name: "anchorPointY"
                            },
                            {
                                type: "Int16",
                                name: "x1"
                            },
                            {
                                type: "Int16",
                                name: "y1"
                            },
                            {
                                type: "Int16",
                                name: "x2"
                            },
                            {
                                type: "Int16",
                                name: "y2"
                            },
                            {
                                type: "Uint32",
                                name: "featureIndex"
                            },
                            {
                                type: "Uint16",
                                name: "sourceLayerIndex"
                            },
                            {
                                type: "Uint16",
                                name: "bucketIndex"
                            }
                        ]), ta([
                            {
                                name: "a_pos",
                                components: 2,
                                type: "Int16"
                            },
                            {
                                name: "a_anchor_pos",
                                components: 2,
                                type: "Int16"
                            },
                            {
                                name: "a_extrude",
                                components: 2,
                                type: "Int16"
                            }
                        ], 4)), Ml = ta([
                            {
                                name: "a_pos",
                                components: 2,
                                type: "Float32"
                            },
                            {
                                name: "a_radius",
                                components: 1,
                                type: "Float32"
                            },
                            {
                                name: "a_flags",
                                components: 2,
                                type: "Int16"
                            }
                        ], 4);
                        function Sl(t1, e1, r) {
                            return t1.sections.forEach(function(t1) {
                                t1.text = function(t1, e1, r) {
                                    var n = e1.layout.get("text-transform").evaluate(r, {});
                                    return "uppercase" === n ? t1 = t1.toLocaleUpperCase() : "lowercase" === n && (t1 = t1.toLocaleLowerCase()), zi.applyArabicShaping && (t1 = zi.applyArabicShaping(t1)), t1;
                                }(t1.text, e1, r);
                            }), t1;
                        }
                        ta([
                            {
                                name: "triangle",
                                components: 3,
                                type: "Uint16"
                            }
                        ]), ta([
                            {
                                type: "Int16",
                                name: "anchorX"
                            },
                            {
                                type: "Int16",
                                name: "anchorY"
                            },
                            {
                                type: "Uint16",
                                name: "glyphStartIndex"
                            },
                            {
                                type: "Uint16",
                                name: "numGlyphs"
                            },
                            {
                                type: "Uint32",
                                name: "vertexStartIndex"
                            },
                            {
                                type: "Uint32",
                                name: "lineStartIndex"
                            },
                            {
                                type: "Uint32",
                                name: "lineLength"
                            },
                            {
                                type: "Uint16",
                                name: "segment"
                            },
                            {
                                type: "Uint16",
                                name: "lowerSize"
                            },
                            {
                                type: "Uint16",
                                name: "upperSize"
                            },
                            {
                                type: "Float32",
                                name: "lineOffsetX"
                            },
                            {
                                type: "Float32",
                                name: "lineOffsetY"
                            },
                            {
                                type: "Uint8",
                                name: "writingMode"
                            },
                            {
                                type: "Uint8",
                                name: "placedOrientation"
                            },
                            {
                                type: "Uint8",
                                name: "hidden"
                            },
                            {
                                type: "Uint32",
                                name: "crossTileID"
                            },
                            {
                                type: "Int16",
                                name: "associatedIconIndex"
                            }
                        ]), ta([
                            {
                                type: "Int16",
                                name: "anchorX"
                            },
                            {
                                type: "Int16",
                                name: "anchorY"
                            },
                            {
                                type: "Int16",
                                name: "rightJustifiedTextSymbolIndex"
                            },
                            {
                                type: "Int16",
                                name: "centerJustifiedTextSymbolIndex"
                            },
                            {
                                type: "Int16",
                                name: "leftJustifiedTextSymbolIndex"
                            },
                            {
                                type: "Int16",
                                name: "verticalPlacedTextSymbolIndex"
                            },
                            {
                                type: "Int16",
                                name: "placedIconSymbolIndex"
                            },
                            {
                                type: "Int16",
                                name: "verticalPlacedIconSymbolIndex"
                            },
                            {
                                type: "Uint16",
                                name: "key"
                            },
                            {
                                type: "Uint16",
                                name: "textBoxStartIndex"
                            },
                            {
                                type: "Uint16",
                                name: "textBoxEndIndex"
                            },
                            {
                                type: "Uint16",
                                name: "verticalTextBoxStartIndex"
                            },
                            {
                                type: "Uint16",
                                name: "verticalTextBoxEndIndex"
                            },
                            {
                                type: "Uint16",
                                name: "iconBoxStartIndex"
                            },
                            {
                                type: "Uint16",
                                name: "iconBoxEndIndex"
                            },
                            {
                                type: "Uint16",
                                name: "verticalIconBoxStartIndex"
                            },
                            {
                                type: "Uint16",
                                name: "verticalIconBoxEndIndex"
                            },
                            {
                                type: "Uint16",
                                name: "featureIndex"
                            },
                            {
                                type: "Uint16",
                                name: "numHorizontalGlyphVertices"
                            },
                            {
                                type: "Uint16",
                                name: "numVerticalGlyphVertices"
                            },
                            {
                                type: "Uint16",
                                name: "numIconVertices"
                            },
                            {
                                type: "Uint16",
                                name: "numVerticalIconVertices"
                            },
                            {
                                type: "Uint16",
                                name: "useRuntimeCollisionCircles"
                            },
                            {
                                type: "Uint32",
                                name: "crossTileID"
                            },
                            {
                                type: "Float32",
                                name: "textBoxScale"
                            },
                            {
                                type: "Float32",
                                components: 2,
                                name: "textOffset"
                            },
                            {
                                type: "Float32",
                                name: "collisionCircleDiameter"
                            }
                        ]), ta([
                            {
                                type: "Float32",
                                name: "offsetX"
                            }
                        ]), ta([
                            {
                                type: "Int16",
                                name: "x"
                            },
                            {
                                type: "Int16",
                                name: "y"
                            },
                            {
                                type: "Int16",
                                name: "tileUnitDistanceFromAnchor"
                            }
                        ]);
                        var El = {
                            "!": "\uFE15",
                            "#": "\uFF03",
                            $: "\uFF04",
                            "%": "\uFF05",
                            "&": "\uFF06",
                            "(": "\uFE35",
                            ")": "\uFE36",
                            "*": "\uFF0A",
                            "+": "\uFF0B",
                            ",": "\uFE10",
                            "-": "\uFE32",
                            ".": "\u30FB",
                            "/": "\uFF0F",
                            ":": "\uFE13",
                            ";": "\uFE14",
                            "<": "\uFE3F",
                            "=": "\uFF1D",
                            ">": "\uFE40",
                            "?": "\uFE16",
                            "@": "\uFF20",
                            "[": "\uFE47",
                            "\\": "\uFF3C",
                            "]": "\uFE48",
                            "^": "\uFF3E",
                            _: "\uFE33",
                            "`": "\uFF40",
                            "{": "\uFE37",
                            "|": "\u2015",
                            "}": "\uFE38",
                            "~": "\uFF5E",
                            "\xa2": "\uFFE0",
                            "\xa3": "\uFFE1",
                            "\xa5": "\uFFE5",
                            "\xa6": "\uFFE4",
                            "\xac": "\uFFE2",
                            "\xaf": "\uFFE3",
                            "\u2013": "\uFE32",
                            "\u2014": "\uFE31",
                            "\u2018": "\uFE43",
                            "\u2019": "\uFE44",
                            "\u201C": "\uFE41",
                            "\u201D": "\uFE42",
                            "\u2026": "\uFE19",
                            "\u2027": "\u30FB",
                            "\u20A9": "\uFFE6",
                            "\u3001": "\uFE11",
                            "\u3002": "\uFE12",
                            "\u3008": "\uFE3F",
                            "\u3009": "\uFE40",
                            "\u300A": "\uFE3D",
                            "\u300B": "\uFE3E",
                            "\u300C": "\uFE41",
                            "\u300D": "\uFE42",
                            "\u300E": "\uFE43",
                            "\u300F": "\uFE44",
                            "\u3010": "\uFE3B",
                            "\u3011": "\uFE3C",
                            "\u3014": "\uFE39",
                            "\u3015": "\uFE3A",
                            "\u3016": "\uFE17",
                            "\u3017": "\uFE18",
                            "\uFF01": "\uFE15",
                            "\uFF08": "\uFE35",
                            "\uFF09": "\uFE36",
                            "\uFF0C": "\uFE10",
                            "\uFF0D": "\uFE32",
                            "\uFF0E": "\u30FB",
                            "\uFF1A": "\uFE13",
                            "\uFF1B": "\uFE14",
                            "\uFF1C": "\uFE3F",
                            "\uFF1E": "\uFE40",
                            "\uFF1F": "\uFE16",
                            "\uFF3B": "\uFE47",
                            "\uFF3D": "\uFE48",
                            "\uFF3F": "\uFE33",
                            "\uFF5B": "\uFE37",
                            "\uFF5C": "\u2015",
                            "\uFF5D": "\uFE38",
                            "\uFF5F": "\uFE35",
                            "\uFF60": "\uFE36",
                            "\uFF61": "\uFE12",
                            "\uFF62": "\uFE41",
                            "\uFF63": "\uFE42"
                        };
                        var Cl = 24, Ll = function(t1, e1, r, n, i) {
                            var a, o, s = 8 * i - n - 1, l = (1 << s) - 1, c = l >> 1, u = -7, h = r ? i - 1 : 0, f = r ? -1 : 1, p = t1[e1 + h];
                            for(h += f, a = p & (1 << -u) - 1, p >>= -u, u += s; u > 0; a = 256 * a + t1[e1 + h], h += f, u -= 8);
                            for(o = a & (1 << -u) - 1, a >>= -u, u += n; u > 0; o = 256 * o + t1[e1 + h], h += f, u -= 8);
                            if (0 === a) a = 1 - c;
                            else {
                                if (a === l) return o ? NaN : 1 / 0 * (p ? -1 : 1);
                                o += Math.pow(2, n), a -= c;
                            }
                            return (p ? -1 : 1) * o * Math.pow(2, a - n);
                        }, Il = function(t1, e1, r, n, i, a) {
                            var o, s, l, c = 8 * a - i - 1, u = (1 << c) - 1, h = u >> 1, f = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, p = n ? 0 : a - 1, d = n ? 1 : -1, m = e1 < 0 || 0 === e1 && 1 / e1 < 0 ? 1 : 0;
                            for(e1 = Math.abs(e1), isNaN(e1) || e1 === 1 / 0 ? (s = isNaN(e1) ? 1 : 0, o = u) : (o = Math.floor(Math.log(e1) / Math.LN2), e1 * (l = Math.pow(2, -o)) < 1 && (o--, l *= 2), (e1 += o + h >= 1 ? f / l : f * Math.pow(2, 1 - h)) * l >= 2 && (o++, l /= 2), o + h >= u ? (s = 0, o = u) : o + h >= 1 ? (s = (e1 * l - 1) * Math.pow(2, i), o += h) : (s = e1 * Math.pow(2, h - 1) * Math.pow(2, i), o = 0)); i >= 8; t1[r + p] = 255 & s, p += d, s /= 256, i -= 8);
                            for(o = o << i | s, c += i; c > 0; t1[r + p] = 255 & o, p += d, o /= 256, c -= 8);
                            t1[r + p - d] |= 128 * m;
                        }, Pl = zl;
                        function zl(t1) {
                            this.buf = ArrayBuffer.isView && ArrayBuffer.isView(t1) ? t1 : new Uint8Array(t1 || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
                        }
                        zl.Varint = 0, zl.Fixed64 = 1, zl.Bytes = 2, zl.Fixed32 = 5;
                        var Ol = 4294967296, Dl = 1 / Ol, Rl = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf8");
                        function Fl(t1) {
                            return t1.type === zl.Bytes ? t1.readVarint() + t1.pos : t1.pos + 1;
                        }
                        function Bl(t1, e1, r) {
                            return r ? 4294967296 * e1 + (t1 >>> 0) : 4294967296 * (e1 >>> 0) + (t1 >>> 0);
                        }
                        function Nl(t1, e1, r) {
                            var n = e1 <= 16383 ? 1 : e1 <= 2097151 ? 2 : e1 <= 268435455 ? 3 : Math.floor(Math.log(e1) / (7 * Math.LN2));
                            r.realloc(n);
                            for(var i = r.pos - 1; i >= t1; i--)r.buf[i + n] = r.buf[i];
                        }
                        function jl(t1, e1) {
                            for(var r = 0; r < t1.length; r++)e1.writeVarint(t1[r]);
                        }
                        function Ul(t1, e1) {
                            for(var r = 0; r < t1.length; r++)e1.writeSVarint(t1[r]);
                        }
                        function Vl(t1, e1) {
                            for(var r = 0; r < t1.length; r++)e1.writeFloat(t1[r]);
                        }
                        function ql(t1, e1) {
                            for(var r = 0; r < t1.length; r++)e1.writeDouble(t1[r]);
                        }
                        function Hl(t1, e1) {
                            for(var r = 0; r < t1.length; r++)e1.writeBoolean(t1[r]);
                        }
                        function Gl(t1, e1) {
                            for(var r = 0; r < t1.length; r++)e1.writeFixed32(t1[r]);
                        }
                        function Zl(t1, e1) {
                            for(var r = 0; r < t1.length; r++)e1.writeSFixed32(t1[r]);
                        }
                        function Wl(t1, e1) {
                            for(var r = 0; r < t1.length; r++)e1.writeFixed64(t1[r]);
                        }
                        function Yl(t1, e1) {
                            for(var r = 0; r < t1.length; r++)e1.writeSFixed64(t1[r]);
                        }
                        function Xl(t1, e1) {
                            return (t1[e1] | t1[e1 + 1] << 8 | t1[e1 + 2] << 16) + 16777216 * t1[e1 + 3];
                        }
                        function $l(t1, e1, r) {
                            t1[r] = e1, t1[r + 1] = e1 >>> 8, t1[r + 2] = e1 >>> 16, t1[r + 3] = e1 >>> 24;
                        }
                        function Jl(t1, e1) {
                            return (t1[e1] | t1[e1 + 1] << 8 | t1[e1 + 2] << 16) + (t1[e1 + 3] << 24);
                        }
                        zl.prototype = {
                            destroy: function() {
                                this.buf = null;
                            },
                            readFields: function(t1, e1, r) {
                                for(r = r || this.length; this.pos < r;){
                                    var n = this.readVarint(), i = n >> 3, a = this.pos;
                                    this.type = 7 & n, t1(i, e1, this), this.pos === a && this.skip(n);
                                }
                                return e1;
                            },
                            readMessage: function(t1, e1) {
                                return this.readFields(t1, e1, this.readVarint() + this.pos);
                            },
                            readFixed32: function() {
                                var t1 = Xl(this.buf, this.pos);
                                return this.pos += 4, t1;
                            },
                            readSFixed32: function() {
                                var t1 = Jl(this.buf, this.pos);
                                return this.pos += 4, t1;
                            },
                            readFixed64: function() {
                                var t1 = Xl(this.buf, this.pos) + Xl(this.buf, this.pos + 4) * Ol;
                                return this.pos += 8, t1;
                            },
                            readSFixed64: function() {
                                var t1 = Xl(this.buf, this.pos) + Jl(this.buf, this.pos + 4) * Ol;
                                return this.pos += 8, t1;
                            },
                            readFloat: function() {
                                var t1 = Ll(this.buf, this.pos, !0, 23, 4);
                                return this.pos += 4, t1;
                            },
                            readDouble: function() {
                                var t1 = Ll(this.buf, this.pos, !0, 52, 8);
                                return this.pos += 8, t1;
                            },
                            readVarint: function(t1) {
                                var e1, r, n = this.buf;
                                return e1 = 127 & (r = n[this.pos++]), r < 128 ? e1 : (e1 |= (127 & (r = n[this.pos++])) << 7, r < 128 ? e1 : (e1 |= (127 & (r = n[this.pos++])) << 14, r < 128 ? e1 : (e1 |= (127 & (r = n[this.pos++])) << 21, r < 128 ? e1 : function(t1, e1, r) {
                                    var n, i, a = r.buf;
                                    if (n = (112 & (i = a[r.pos++])) >> 4, i < 128) return Bl(t1, n, e1);
                                    if (n |= (127 & (i = a[r.pos++])) << 3, i < 128) return Bl(t1, n, e1);
                                    if (n |= (127 & (i = a[r.pos++])) << 10, i < 128) return Bl(t1, n, e1);
                                    if (n |= (127 & (i = a[r.pos++])) << 17, i < 128) return Bl(t1, n, e1);
                                    if (n |= (127 & (i = a[r.pos++])) << 24, i < 128) return Bl(t1, n, e1);
                                    if (n |= (1 & (i = a[r.pos++])) << 31, i < 128) return Bl(t1, n, e1);
                                    throw new Error("Expected varint not more than 10 bytes");
                                }(e1 |= (15 & (r = n[this.pos])) << 28, t1, this))));
                            },
                            readVarint64: function() {
                                return this.readVarint(!0);
                            },
                            readSVarint: function() {
                                var t1 = this.readVarint();
                                return t1 % 2 == 1 ? (t1 + 1) / -2 : t1 / 2;
                            },
                            readBoolean: function() {
                                return Boolean(this.readVarint());
                            },
                            readString: function() {
                                var t1 = this.readVarint() + this.pos, e1 = this.pos;
                                return this.pos = t1, t1 - e1 >= 12 && Rl ? function(t1, e1, r) {
                                    return Rl.decode(t1.subarray(e1, r));
                                }(this.buf, e1, t1) : function(t1, e1, r) {
                                    for(var n = "", i = e1; i < r;){
                                        var a, o, s, l = t1[i], c = null, u = l > 239 ? 4 : l > 223 ? 3 : l > 191 ? 2 : 1;
                                        if (i + u > r) break;
                                        1 === u ? l < 128 && (c = l) : 2 === u ? 128 == (192 & (a = t1[i + 1])) && (c = (31 & l) << 6 | 63 & a) <= 127 && (c = null) : 3 === u ? (a = t1[i + 1], o = t1[i + 2], 128 == (192 & a) && 128 == (192 & o) && ((c = (15 & l) << 12 | (63 & a) << 6 | 63 & o) <= 2047 || c >= 55296 && c <= 57343) && (c = null)) : 4 === u && (a = t1[i + 1], o = t1[i + 2], s = t1[i + 3], 128 == (192 & a) && 128 == (192 & o) && 128 == (192 & s) && ((c = (15 & l) << 18 | (63 & a) << 12 | (63 & o) << 6 | 63 & s) <= 65535 || c >= 1114112) && (c = null)), null === c ? (c = 65533, u = 1) : c > 65535 && (c -= 65536, n += String.fromCharCode(c >>> 10 & 1023 | 55296), c = 56320 | 1023 & c), n += String.fromCharCode(c), i += u;
                                    }
                                    return n;
                                }(this.buf, e1, t1);
                            },
                            readBytes: function() {
                                var t1 = this.readVarint() + this.pos, e1 = this.buf.subarray(this.pos, t1);
                                return this.pos = t1, e1;
                            },
                            readPackedVarint: function(t1, e1) {
                                if (this.type !== zl.Bytes) return t1.push(this.readVarint(e1));
                                var r = Fl(this);
                                for(t1 = t1 || []; this.pos < r;)t1.push(this.readVarint(e1));
                                return t1;
                            },
                            readPackedSVarint: function(t1) {
                                if (this.type !== zl.Bytes) return t1.push(this.readSVarint());
                                var e1 = Fl(this);
                                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readSVarint());
                                return t1;
                            },
                            readPackedBoolean: function(t1) {
                                if (this.type !== zl.Bytes) return t1.push(this.readBoolean());
                                var e1 = Fl(this);
                                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readBoolean());
                                return t1;
                            },
                            readPackedFloat: function(t1) {
                                if (this.type !== zl.Bytes) return t1.push(this.readFloat());
                                var e1 = Fl(this);
                                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readFloat());
                                return t1;
                            },
                            readPackedDouble: function(t1) {
                                if (this.type !== zl.Bytes) return t1.push(this.readDouble());
                                var e1 = Fl(this);
                                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readDouble());
                                return t1;
                            },
                            readPackedFixed32: function(t1) {
                                if (this.type !== zl.Bytes) return t1.push(this.readFixed32());
                                var e1 = Fl(this);
                                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readFixed32());
                                return t1;
                            },
                            readPackedSFixed32: function(t1) {
                                if (this.type !== zl.Bytes) return t1.push(this.readSFixed32());
                                var e1 = Fl(this);
                                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readSFixed32());
                                return t1;
                            },
                            readPackedFixed64: function(t1) {
                                if (this.type !== zl.Bytes) return t1.push(this.readFixed64());
                                var e1 = Fl(this);
                                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readFixed64());
                                return t1;
                            },
                            readPackedSFixed64: function(t1) {
                                if (this.type !== zl.Bytes) return t1.push(this.readSFixed64());
                                var e1 = Fl(this);
                                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readSFixed64());
                                return t1;
                            },
                            skip: function(t1) {
                                var e1 = 7 & t1;
                                if (e1 === zl.Varint) for(; this.buf[this.pos++] > 127;);
                                else if (e1 === zl.Bytes) this.pos = this.readVarint() + this.pos;
                                else if (e1 === zl.Fixed32) this.pos += 4;
                                else {
                                    if (e1 !== zl.Fixed64) throw new Error("Unimplemented type: " + e1);
                                    this.pos += 8;
                                }
                            },
                            writeTag: function(t1, e1) {
                                this.writeVarint(t1 << 3 | e1);
                            },
                            realloc: function(t1) {
                                for(var e1 = this.length || 16; e1 < this.pos + t1;)e1 *= 2;
                                if (e1 !== this.length) {
                                    var r = new Uint8Array(e1);
                                    r.set(this.buf), this.buf = r, this.length = e1;
                                }
                            },
                            finish: function() {
                                return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
                            },
                            writeFixed32: function(t1) {
                                this.realloc(4), $l(this.buf, t1, this.pos), this.pos += 4;
                            },
                            writeSFixed32: function(t1) {
                                this.realloc(4), $l(this.buf, t1, this.pos), this.pos += 4;
                            },
                            writeFixed64: function(t1) {
                                this.realloc(8), $l(this.buf, -1 & t1, this.pos), $l(this.buf, Math.floor(t1 * Dl), this.pos + 4), this.pos += 8;
                            },
                            writeSFixed64: function(t1) {
                                this.realloc(8), $l(this.buf, -1 & t1, this.pos), $l(this.buf, Math.floor(t1 * Dl), this.pos + 4), this.pos += 8;
                            },
                            writeVarint: function(t1) {
                                (t1 = +t1 || 0) > 268435455 || t1 < 0 ? function(t1, e1) {
                                    var r, n;
                                    if (t1 >= 0 ? (r = t1 % 4294967296 | 0, n = t1 / 4294967296 | 0) : (n = ~(-t1 / 4294967296), 4294967295 ^ (r = ~(-t1 % 4294967296)) ? r = r + 1 | 0 : (r = 0, n = n + 1 | 0)), t1 >= 0x10000000000000000 || t1 < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                                    e1.realloc(10), function(t1, e1, r) {
                                        r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos] = 127 & t1;
                                    }(r, 0, e1), function(t1, e1) {
                                        var r = (7 & t1) << 4;
                                        e1.buf[e1.pos++] |= r | ((t1 >>>= 3) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1)))));
                                    }(n, e1);
                                }(t1, this) : (this.realloc(4), this.buf[this.pos++] = 127 & t1 | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = 127 & (t1 >>>= 7) | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = 127 & (t1 >>>= 7) | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = t1 >>> 7 & 127))));
                            },
                            writeSVarint: function(t1) {
                                this.writeVarint(t1 < 0 ? 2 * -t1 - 1 : 2 * t1);
                            },
                            writeBoolean: function(t1) {
                                this.writeVarint(Boolean(t1));
                            },
                            writeString: function(t1) {
                                t1 = String(t1), this.realloc(4 * t1.length), this.pos++;
                                var e1 = this.pos;
                                this.pos = function(t1, e1, r) {
                                    for(var n, i, a = 0; a < e1.length; a++){
                                        if ((n = e1.charCodeAt(a)) > 55295 && n < 57344) {
                                            if (!i) {
                                                n > 56319 || a + 1 === e1.length ? (t1[r++] = 239, t1[r++] = 191, t1[r++] = 189) : i = n;
                                                continue;
                                            }
                                            if (n < 56320) {
                                                t1[r++] = 239, t1[r++] = 191, t1[r++] = 189, i = n;
                                                continue;
                                            }
                                            n = i - 55296 << 10 | n - 56320 | 65536, i = null;
                                        } else i && (t1[r++] = 239, t1[r++] = 191, t1[r++] = 189, i = null);
                                        n < 128 ? t1[r++] = n : (n < 2048 ? t1[r++] = n >> 6 | 192 : (n < 65536 ? t1[r++] = n >> 12 | 224 : (t1[r++] = n >> 18 | 240, t1[r++] = n >> 12 & 63 | 128), t1[r++] = n >> 6 & 63 | 128), t1[r++] = 63 & n | 128);
                                    }
                                    return r;
                                }(this.buf, t1, this.pos);
                                var r = this.pos - e1;
                                r >= 128 && Nl(e1, r, this), this.pos = e1 - 1, this.writeVarint(r), this.pos += r;
                            },
                            writeFloat: function(t1) {
                                this.realloc(4), Il(this.buf, t1, this.pos, !0, 23, 4), this.pos += 4;
                            },
                            writeDouble: function(t1) {
                                this.realloc(8), Il(this.buf, t1, this.pos, !0, 52, 8), this.pos += 8;
                            },
                            writeBytes: function(t1) {
                                var e1 = t1.length;
                                this.writeVarint(e1), this.realloc(e1);
                                for(var r = 0; r < e1; r++)this.buf[this.pos++] = t1[r];
                            },
                            writeRawMessage: function(t1, e1) {
                                this.pos++;
                                var r = this.pos;
                                t1(e1, this);
                                var n = this.pos - r;
                                n >= 128 && Nl(r, n, this), this.pos = r - 1, this.writeVarint(n), this.pos += n;
                            },
                            writeMessage: function(t1, e1, r) {
                                this.writeTag(t1, zl.Bytes), this.writeRawMessage(e1, r);
                            },
                            writePackedVarint: function(t1, e1) {
                                e1.length && this.writeMessage(t1, jl, e1);
                            },
                            writePackedSVarint: function(t1, e1) {
                                e1.length && this.writeMessage(t1, Ul, e1);
                            },
                            writePackedBoolean: function(t1, e1) {
                                e1.length && this.writeMessage(t1, Hl, e1);
                            },
                            writePackedFloat: function(t1, e1) {
                                e1.length && this.writeMessage(t1, Vl, e1);
                            },
                            writePackedDouble: function(t1, e1) {
                                e1.length && this.writeMessage(t1, ql, e1);
                            },
                            writePackedFixed32: function(t1, e1) {
                                e1.length && this.writeMessage(t1, Gl, e1);
                            },
                            writePackedSFixed32: function(t1, e1) {
                                e1.length && this.writeMessage(t1, Zl, e1);
                            },
                            writePackedFixed64: function(t1, e1) {
                                e1.length && this.writeMessage(t1, Wl, e1);
                            },
                            writePackedSFixed64: function(t1, e1) {
                                e1.length && this.writeMessage(t1, Yl, e1);
                            },
                            writeBytesField: function(t1, e1) {
                                this.writeTag(t1, zl.Bytes), this.writeBytes(e1);
                            },
                            writeFixed32Field: function(t1, e1) {
                                this.writeTag(t1, zl.Fixed32), this.writeFixed32(e1);
                            },
                            writeSFixed32Field: function(t1, e1) {
                                this.writeTag(t1, zl.Fixed32), this.writeSFixed32(e1);
                            },
                            writeFixed64Field: function(t1, e1) {
                                this.writeTag(t1, zl.Fixed64), this.writeFixed64(e1);
                            },
                            writeSFixed64Field: function(t1, e1) {
                                this.writeTag(t1, zl.Fixed64), this.writeSFixed64(e1);
                            },
                            writeVarintField: function(t1, e1) {
                                this.writeTag(t1, zl.Varint), this.writeVarint(e1);
                            },
                            writeSVarintField: function(t1, e1) {
                                this.writeTag(t1, zl.Varint), this.writeSVarint(e1);
                            },
                            writeStringField: function(t1, e1) {
                                this.writeTag(t1, zl.Bytes), this.writeString(e1);
                            },
                            writeFloatField: function(t1, e1) {
                                this.writeTag(t1, zl.Fixed32), this.writeFloat(e1);
                            },
                            writeDoubleField: function(t1, e1) {
                                this.writeTag(t1, zl.Fixed64), this.writeDouble(e1);
                            },
                            writeBooleanField: function(t1, e1) {
                                this.writeVarintField(t1, Boolean(e1));
                            }
                        };
                        var Kl = 3;
                        function Ql(t1, e1, r) {
                            1 === t1 && r.readMessage(tc, e1);
                        }
                        function tc(t1, e1, r) {
                            if (3 === t1) {
                                var n = r.readMessage(ec, {}), i = n.id, a = n.bitmap, o = n.width, s = n.height, l = n.left, c = n.top, u = n.advance;
                                e1.push({
                                    id: i,
                                    bitmap: new Jo({
                                        width: o + 2 * Kl,
                                        height: s + 2 * Kl
                                    }, a),
                                    metrics: {
                                        width: o,
                                        height: s,
                                        left: l,
                                        top: c,
                                        advance: u
                                    }
                                });
                            }
                        }
                        function ec(t1, e1, r) {
                            1 === t1 ? e1.id = r.readVarint() : 2 === t1 ? e1.bitmap = r.readBytes() : 3 === t1 ? e1.width = r.readVarint() : 4 === t1 ? e1.height = r.readVarint() : 5 === t1 ? e1.left = r.readSVarint() : 6 === t1 ? e1.top = r.readSVarint() : 7 === t1 && (e1.advance = r.readVarint());
                        }
                        var rc = Kl;
                        function nc(t1) {
                            for(var e1 = 0, r = 0, n = 0, i = t1; n < i.length; n += 1){
                                var a = i[n];
                                e1 += a.w * a.h, r = Math.max(r, a.w);
                            }
                            t1.sort(function(t1, e1) {
                                return e1.h - t1.h;
                            });
                            for(var o = [
                                {
                                    x: 0,
                                    y: 0,
                                    w: Math.max(Math.ceil(Math.sqrt(e1 / .95)), r),
                                    h: 1 / 0
                                }
                            ], s = 0, l = 0, c = 0, u = t1; c < u.length; c += 1)for(var h = u[c], f = o.length - 1; f >= 0; f--){
                                var p = o[f];
                                if (!(h.w > p.w || h.h > p.h)) {
                                    if (h.x = p.x, h.y = p.y, l = Math.max(l, h.y + h.h), s = Math.max(s, h.x + h.w), h.w === p.w && h.h === p.h) {
                                        var d = o.pop();
                                        f < o.length && (o[f] = d);
                                    } else h.h === p.h ? (p.x += h.w, p.w -= h.w) : h.w === p.w ? (p.y += h.h, p.h -= h.h) : (o.push({
                                        x: p.x + h.w,
                                        y: p.y,
                                        w: p.w - h.w,
                                        h: h.h
                                    }), p.y += h.h, p.h -= h.h);
                                    break;
                                }
                            }
                            return {
                                w: s,
                                h: l,
                                fill: e1 / (s * l) || 0
                            };
                        }
                        var ic = 1, ac = function(t1, e1) {
                            var r = e1.pixelRatio, n = e1.version, i = e1.stretchX, a = e1.stretchY, o = e1.content;
                            this.paddedRect = t1, this.pixelRatio = r, this.stretchX = i, this.stretchY = a, this.content = o, this.version = n;
                        }, oc = {
                            tl: {
                                configurable: !0
                            },
                            br: {
                                configurable: !0
                            },
                            tlbr: {
                                configurable: !0
                            },
                            displaySize: {
                                configurable: !0
                            }
                        };
                        oc.tl.get = function() {
                            return [
                                this.paddedRect.x + ic,
                                this.paddedRect.y + ic
                            ];
                        }, oc.br.get = function() {
                            return [
                                this.paddedRect.x + this.paddedRect.w - ic,
                                this.paddedRect.y + this.paddedRect.h - ic
                            ];
                        }, oc.tlbr.get = function() {
                            return this.tl.concat(this.br);
                        }, oc.displaySize.get = function() {
                            return [
                                (this.paddedRect.w - 2 * ic) / this.pixelRatio,
                                (this.paddedRect.h - 2 * ic) / this.pixelRatio
                            ];
                        }, Object.defineProperties(ac.prototype, oc);
                        var sc = function(t1, e1) {
                            var r = {}, n = {};
                            this.haveRenderCallbacks = [];
                            var i = [];
                            this.addImages(t1, r, i), this.addImages(e1, n, i);
                            var a = nc(i), o = a.w, s = a.h, l = new Ko({
                                width: o || 1,
                                height: s || 1
                            });
                            for(var c in t1){
                                var u = t1[c], h = r[c].paddedRect;
                                Ko.copy(u.data, l, {
                                    x: 0,
                                    y: 0
                                }, {
                                    x: h.x + ic,
                                    y: h.y + ic
                                }, u.data);
                            }
                            for(var f in e1){
                                var p = e1[f], d = n[f].paddedRect, m = d.x + ic, g = d.y + ic, y = p.data.width, v = p.data.height;
                                Ko.copy(p.data, l, {
                                    x: 0,
                                    y: 0
                                }, {
                                    x: m,
                                    y: g
                                }, p.data), Ko.copy(p.data, l, {
                                    x: 0,
                                    y: v - 1
                                }, {
                                    x: m,
                                    y: g - 1
                                }, {
                                    width: y,
                                    height: 1
                                }), Ko.copy(p.data, l, {
                                    x: 0,
                                    y: 0
                                }, {
                                    x: m,
                                    y: g + v
                                }, {
                                    width: y,
                                    height: 1
                                }), Ko.copy(p.data, l, {
                                    x: y - 1,
                                    y: 0
                                }, {
                                    x: m - 1,
                                    y: g
                                }, {
                                    width: 1,
                                    height: v
                                }), Ko.copy(p.data, l, {
                                    x: 0,
                                    y: 0
                                }, {
                                    x: m + y,
                                    y: g
                                }, {
                                    width: 1,
                                    height: v
                                });
                            }
                            this.image = l, this.iconPositions = r, this.patternPositions = n;
                        };
                        sc.prototype.addImages = function(t1, e1, r) {
                            for(var n in t1){
                                var i = t1[n], a = {
                                    x: 0,
                                    y: 0,
                                    w: i.data.width + 2 * ic,
                                    h: i.data.height + 2 * ic
                                };
                                r.push(a), e1[n] = new ac(a, i), i.hasRenderCallback && this.haveRenderCallbacks.push(n);
                            }
                        }, sc.prototype.patchUpdatedImages = function(t1, e1) {
                            for(var r in t1.dispatchRenderCallbacks(this.haveRenderCallbacks), t1.updatedImages)this.patchUpdatedImage(this.iconPositions[r], t1.getImage(r), e1), this.patchUpdatedImage(this.patternPositions[r], t1.getImage(r), e1);
                        }, sc.prototype.patchUpdatedImage = function(t1, e1, r) {
                            if (t1 && e1 && t1.version !== e1.version) {
                                t1.version = e1.version;
                                var n = t1.tl, i = n[0], a = n[1];
                                r.update(e1.data, void 0, {
                                    x: i,
                                    y: a
                                });
                            }
                        }, oi("ImagePosition", ac), oi("ImageAtlas", sc);
                        var lc = {
                            horizontal: 1,
                            vertical: 2,
                            horizontalOnly: 3
                        }, cc = -17;
                        var uc = function() {
                            this.scale = 1, this.fontStack = "", this.imageName = null;
                        };
                        uc.forText = function(t1, e1) {
                            var r = new uc;
                            return r.scale = t1 || 1, r.fontStack = e1, r;
                        }, uc.forImage = function(t1) {
                            var e1 = new uc;
                            return e1.imageName = t1, e1;
                        };
                        var hc = function() {
                            this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
                        };
                        function fc(t1, e1, r, n, i, a, o, s, l, c, u, h, f, p, d, m) {
                            var g, y = hc.fromFeature(t1, i);
                            h === lc.vertical && y.verticalizePunctuation();
                            var v = zi.processBidirectionalText, x = zi.processStyledBidirectionalText;
                            if (v && 1 === y.sections.length) {
                                g = [];
                                for(var _ = 0, b = v(y.toString(), _c(y, c, a, e1, n, p, d)); _ < b.length; _ += 1){
                                    var w = b[_], T = new hc;
                                    T.text = w, T.sections = y.sections;
                                    for(var k = 0; k < w.length; k++)T.sectionIndex.push(0);
                                    g.push(T);
                                }
                            } else if (x) {
                                g = [];
                                for(var A = 0, M = x(y.text, y.sectionIndex, _c(y, c, a, e1, n, p, d)); A < M.length; A += 1){
                                    var S = M[A], E = new hc;
                                    E.text = S[0], E.sectionIndex = S[1], E.sections = y.sections, g.push(E);
                                }
                            } else g = function(t1, e1) {
                                for(var r = [], n = t1.text, i = 0, a = 0, o = e1; a < o.length; a += 1){
                                    var s = o[a];
                                    r.push(t1.substring(i, s)), i = s;
                                }
                                return i < n.length && r.push(t1.substring(i, n.length)), r;
                            }(y, _c(y, c, a, e1, n, p, d));
                            var C = [], L = {
                                positionedLines: C,
                                text: y.toString(),
                                top: u[1],
                                bottom: u[1],
                                left: u[0],
                                right: u[0],
                                writingMode: h,
                                iconsInText: !1,
                                verticalizable: !1
                            };
                            return function(t1, e1, r, n, i, a, o, s, l, c, u, h) {
                                for(var f = 0, p = cc, d = 0, m = 0, g = "right" === s ? 1 : "left" === s ? 0 : .5, y = 0, v = 0, x = i; v < x.length; v += 1){
                                    var _ = x[v];
                                    _.trim();
                                    var b = _.getMaxScale(), w = (b - 1) * Cl, T = {
                                        positionedGlyphs: [],
                                        lineOffset: 0
                                    };
                                    t1.positionedLines[y] = T;
                                    var k = T.positionedGlyphs, A = 0;
                                    if (_.length()) {
                                        for(var M = 0; M < _.length(); M++){
                                            var S = _.getSection(M), E = _.getSectionIndex(M), C = _.getCharCode(M), L = 0, I = null, P = null, z = null, O = Cl, D = !(l === lc.horizontal || !u && !mi(C) || u && (pc[C] || yi(C)));
                                            if (S.imageName) {
                                                var R = n[S.imageName];
                                                if (!R) continue;
                                                z = S.imageName, t1.iconsInText = t1.iconsInText || !0, P = R.paddedRect;
                                                var F = R.displaySize;
                                                S.scale = S.scale * Cl / h, I = {
                                                    width: F[0],
                                                    height: F[1],
                                                    left: ic,
                                                    top: -rc,
                                                    advance: D ? F[1] : F[0]
                                                }, L = w + (Cl - F[1] * S.scale), O = I.advance;
                                                var B = D ? F[0] * S.scale - Cl * b : F[1] * S.scale - Cl * b;
                                                B > 0 && B > A && (A = B);
                                            } else {
                                                var N = r[S.fontStack], j = N && N[C];
                                                if (j && j.rect) P = j.rect, I = j.metrics;
                                                else {
                                                    var U = e1[S.fontStack], V = U && U[C];
                                                    if (!V) continue;
                                                    I = V.metrics;
                                                }
                                                L = (b - S.scale) * Cl;
                                            }
                                            D ? (t1.verticalizable = !0, k.push({
                                                glyph: C,
                                                imageName: z,
                                                x: f,
                                                y: p + L,
                                                vertical: D,
                                                scale: S.scale,
                                                fontStack: S.fontStack,
                                                sectionIndex: E,
                                                metrics: I,
                                                rect: P
                                            }), f += O * S.scale + c) : (k.push({
                                                glyph: C,
                                                imageName: z,
                                                x: f,
                                                y: p + L,
                                                vertical: D,
                                                scale: S.scale,
                                                fontStack: S.fontStack,
                                                sectionIndex: E,
                                                metrics: I,
                                                rect: P
                                            }), f += I.advance * S.scale + c);
                                        }
                                        if (0 !== k.length) {
                                            var q = f - c;
                                            d = Math.max(q, d), wc(k, 0, k.length - 1, g, A);
                                        }
                                        f = 0;
                                        var H = a * b + A;
                                        T.lineOffset = Math.max(A, w), p += H, m = Math.max(H, m), ++y;
                                    } else p += a, ++y;
                                }
                                var G = p - cc, Z = bc(o), W = Z.horizontalAlign, Y = Z.verticalAlign;
                                (function(t1, e1, r, n, i, a, o, s, l) {
                                    var c = (e1 - r) * i, u = 0;
                                    u = a !== o ? -s * n - cc : (-n * l + .5) * o;
                                    for(var h = 0, f = t1; h < f.length; h += 1)for(var p = 0, d = f[h].positionedGlyphs; p < d.length; p += 1){
                                        var m = d[p];
                                        m.x += c, m.y += u;
                                    }
                                })(t1.positionedLines, g, W, Y, d, m, a, G, i.length), t1.top += -Y * G, t1.bottom = t1.top + G, t1.left += -W * d, t1.right = t1.left + d;
                            }(L, e1, r, n, g, o, s, l, h, c, f, m), !function(t1) {
                                for(var e1 = 0, r = t1; e1 < r.length; e1 += 1)if (0 !== r[e1].positionedGlyphs.length) return !1;
                                return !0;
                            }(C) && L;
                        }
                        hc.fromFeature = function(t1, e1) {
                            for(var r = new hc, n = 0; n < t1.sections.length; n++){
                                var i = t1.sections[n];
                                i.image ? r.addImageSection(i) : r.addTextSection(i, e1);
                            }
                            return r;
                        }, hc.prototype.length = function() {
                            return this.text.length;
                        }, hc.prototype.getSection = function(t1) {
                            return this.sections[this.sectionIndex[t1]];
                        }, hc.prototype.getSectionIndex = function(t1) {
                            return this.sectionIndex[t1];
                        }, hc.prototype.getCharCode = function(t1) {
                            return this.text.charCodeAt(t1);
                        }, hc.prototype.verticalizePunctuation = function() {
                            this.text = function(t1) {
                                for(var e1 = "", r = 0; r < t1.length; r++){
                                    var n = t1.charCodeAt(r + 1) || null, i = t1.charCodeAt(r - 1) || null;
                                    n && gi(n) && !El[t1[r + 1]] || i && gi(i) && !El[t1[r - 1]] || !El[t1[r]] ? e1 += t1[r] : e1 += El[t1[r]];
                                }
                                return e1;
                            }(this.text);
                        }, hc.prototype.trim = function() {
                            for(var t1 = 0, e1 = 0; e1 < this.text.length && pc[this.text.charCodeAt(e1)]; e1++)t1++;
                            for(var r = this.text.length, n = this.text.length - 1; n >= 0 && n >= t1 && pc[this.text.charCodeAt(n)]; n--)r--;
                            this.text = this.text.substring(t1, r), this.sectionIndex = this.sectionIndex.slice(t1, r);
                        }, hc.prototype.substring = function(t1, e1) {
                            var r = new hc;
                            return r.text = this.text.substring(t1, e1), r.sectionIndex = this.sectionIndex.slice(t1, e1), r.sections = this.sections, r;
                        }, hc.prototype.toString = function() {
                            return this.text;
                        }, hc.prototype.getMaxScale = function() {
                            var t1 = this;
                            return this.sectionIndex.reduce(function(e1, r) {
                                return Math.max(e1, t1.sections[r].scale);
                            }, 0);
                        }, hc.prototype.addTextSection = function(t1, e1) {
                            this.text += t1.text, this.sections.push(uc.forText(t1.scale, t1.fontStack || e1));
                            for(var r = this.sections.length - 1, n = 0; n < t1.text.length; ++n)this.sectionIndex.push(r);
                        }, hc.prototype.addImageSection = function(t1) {
                            var e1 = t1.image ? t1.image.name : "";
                            if (0 !== e1.length) {
                                var r = this.getNextImageSectionCharCode();
                                r ? (this.text += String.fromCharCode(r), this.sections.push(uc.forImage(e1)), this.sectionIndex.push(this.sections.length - 1)) : k("Reached maximum number of images 6401");
                            } else k("Can't add FormattedSection with an empty image.");
                        }, hc.prototype.getNextImageSectionCharCode = function() {
                            return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
                        };
                        var pc = {
                            9: !0,
                            10: !0,
                            11: !0,
                            12: !0,
                            13: !0,
                            32: !0
                        }, dc = {};
                        function mc(t1, e1, r, n, i, a) {
                            if (e1.imageName) {
                                var o = n[e1.imageName];
                                return o ? o.displaySize[0] * e1.scale * Cl / a + i : 0;
                            }
                            var s = r[e1.fontStack], l = s && s[t1];
                            return l ? l.metrics.advance * e1.scale + i : 0;
                        }
                        function gc(t1, e1, r, n) {
                            var i = Math.pow(t1 - e1, 2);
                            return n ? t1 < e1 ? i / 2 : 2 * i : i + Math.abs(r) * r;
                        }
                        function yc(t1, e1, r) {
                            var n = 0;
                            return 10 === t1 && (n -= 1e4), r && (n += 150), 40 !== t1 && 65288 !== t1 || (n += 50), 41 !== e1 && 65289 !== e1 || (n += 50), n;
                        }
                        function vc(t1, e1, r, n, i, a) {
                            for(var o = null, s = gc(e1, r, i, a), l = 0, c = n; l < c.length; l += 1){
                                var u = c[l], h = gc(e1 - u.x, r, i, a) + u.badness;
                                h <= s && (o = u, s = h);
                            }
                            return {
                                index: t1,
                                x: e1,
                                priorBreak: o,
                                badness: s
                            };
                        }
                        function xc(t1) {
                            return t1 ? xc(t1.priorBreak).concat(t1.index) : [];
                        }
                        function _c(t1, e1, r, n, i, a, o) {
                            if ("point" !== a) return [];
                            if (!t1) return [];
                            for(var s = [], l = function(t1, e1, r, n, i, a) {
                                for(var o = 0, s = 0; s < t1.length(); s++){
                                    var l = t1.getSection(s);
                                    o += mc(t1.getCharCode(s), l, n, i, e1, a);
                                }
                                return o / Math.max(1, Math.ceil(o / r));
                            }(t1, e1, r, n, i, o), c = t1.text.indexOf("\u200B") >= 0, u = 0, h = 0; h < t1.length(); h++){
                                var f = t1.getSection(h), p = t1.getCharCode(h);
                                if (pc[p] || (u += mc(p, f, n, i, e1, o)), h < t1.length() - 1) {
                                    var d = !((m = p) < 11904 || !(pi["Bopomofo Extended"](m) || pi.Bopomofo(m) || pi["CJK Compatibility Forms"](m) || pi["CJK Compatibility Ideographs"](m) || pi["CJK Compatibility"](m) || pi["CJK Radicals Supplement"](m) || pi["CJK Strokes"](m) || pi["CJK Symbols and Punctuation"](m) || pi["CJK Unified Ideographs Extension A"](m) || pi["CJK Unified Ideographs"](m) || pi["Enclosed CJK Letters and Months"](m) || pi["Halfwidth and Fullwidth Forms"](m) || pi.Hiragana(m) || pi["Ideographic Description Characters"](m) || pi["Kangxi Radicals"](m) || pi["Katakana Phonetic Extensions"](m) || pi.Katakana(m) || pi["Vertical Forms"](m) || pi["Yi Radicals"](m) || pi["Yi Syllables"](m)));
                                    (dc[p] || d || f.imageName) && s.push(vc(h + 1, u, l, s, yc(p, t1.getCharCode(h + 1), d && c), !1));
                                }
                            }
                            var m;
                            return xc(vc(t1.length(), u, l, s, 0, !0));
                        }
                        function bc(t1) {
                            var e1 = .5, r = .5;
                            switch(t1){
                                case "right":
                                case "top-right":
                                case "bottom-right":
                                    e1 = 1;
                                    break;
                                case "left":
                                case "top-left":
                                case "bottom-left":
                                    e1 = 0;
                            }
                            switch(t1){
                                case "bottom":
                                case "bottom-right":
                                case "bottom-left":
                                    r = 1;
                                    break;
                                case "top":
                                case "top-right":
                                case "top-left":
                                    r = 0;
                            }
                            return {
                                horizontalAlign: e1,
                                verticalAlign: r
                            };
                        }
                        function wc(t1, e1, r, n, i) {
                            if (n || i) for(var a = t1[r], o = a.metrics.advance * a.scale, s = (t1[r].x + o) * n, l = e1; l <= r; l++)t1[l].x -= s, t1[l].y += i;
                        }
                        function Tc(t1, e1, r, n, i, a) {
                            var o, s = t1.image;
                            if (s.content) {
                                var l = s.content, c = s.pixelRatio || 1;
                                o = [
                                    l[0] / c,
                                    l[1] / c,
                                    s.displaySize[0] - l[2] / c,
                                    s.displaySize[1] - l[3] / c
                                ];
                            }
                            var u, h, f, p, d = e1.left * a, m = e1.right * a;
                            "width" === r || "both" === r ? (p = i[0] + d - n[3], h = i[0] + m + n[1]) : h = (p = i[0] + (d + m - s.displaySize[0]) / 2) + s.displaySize[0];
                            var g = e1.top * a, y = e1.bottom * a;
                            return "height" === r || "both" === r ? (u = i[1] + g - n[0], f = i[1] + y + n[2]) : f = (u = i[1] + (g + y - s.displaySize[1]) / 2) + s.displaySize[1], {
                                image: s,
                                top: u,
                                right: h,
                                bottom: f,
                                left: p,
                                collisionPadding: o
                            };
                        }
                        dc[10] = !0, dc[32] = !0, dc[38] = !0, dc[40] = !0, dc[41] = !0, dc[43] = !0, dc[45] = !0, dc[47] = !0, dc[173] = !0, dc[183] = !0, dc[8203] = !0, dc[8208] = !0, dc[8211] = !0, dc[8231] = !0;
                        var kc = function(t1) {
                            function e1(e1, r, n, i) {
                                t1.call(this, e1, r), this.angle = n, void 0 !== i && (this.segment = i);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.clone = function() {
                                return new e1(this.x, this.y, this.angle, this.segment);
                            }, e1;
                        }(a);
                        oi("Anchor", kc);
                        var Ac = 128;
                        function Mc(t1, e1) {
                            var r = e1.expression;
                            if ("constant" === r.kind) return {
                                kind: "constant",
                                layoutSize: r.evaluate(new Oi(t1 + 1))
                            };
                            if ("source" === r.kind) return {
                                kind: "source"
                            };
                            for(var n = r.zoomStops, i = r.interpolationType, a = 0; a < n.length && n[a] <= t1;)a++;
                            for(var o = a = Math.max(0, a - 1); o < n.length && n[o] < t1 + 1;)o++;
                            o = Math.min(n.length - 1, o);
                            var s = n[a], l = n[o];
                            return "composite" === r.kind ? {
                                kind: "composite",
                                minZoom: s,
                                maxZoom: l,
                                interpolationType: i
                            } : {
                                kind: "camera",
                                minZoom: s,
                                maxZoom: l,
                                minSize: r.evaluate(new Oi(s)),
                                maxSize: r.evaluate(new Oi(l)),
                                interpolationType: i
                            };
                        }
                        function Sc(t1, e1, r) {
                            var n = e1.uSize, i = e1.uSizeT, a = r.lowerSize, o = r.upperSize;
                            return "source" === t1.kind ? a / Ac : "composite" === t1.kind ? er(a / Ac, o / Ac, i) : n;
                        }
                        function Ec(t1, e1) {
                            var r = 0, n = 0;
                            if ("constant" === t1.kind) n = t1.layoutSize;
                            else if ("source" !== t1.kind) {
                                var i = t1.interpolationType, a = t1.minZoom, o = t1.maxZoom, s = i ? h(wr.interpolationFactor(i, e1, a, o), 0, 1) : 0;
                                "camera" === t1.kind ? n = er(t1.minSize, t1.maxSize, s) : r = s;
                            }
                            return {
                                uSizeT: r,
                                uSize: n
                            };
                        }
                        var Cc = Object.freeze({
                            __proto__: null,
                            getSizeData: Mc,
                            evaluateSizeForFeature: Sc,
                            evaluateSizeForZoom: Ec,
                            SIZE_PACK_FACTOR: Ac
                        });
                        function Lc(t1, e1, r, n, i) {
                            if (void 0 === e1.segment) return !0;
                            for(var a = e1, o = e1.segment + 1, s = 0; s > -r / 2;){
                                if (--o < 0) return !1;
                                s -= t1[o].dist(a), a = t1[o];
                            }
                            s += t1[o].dist(t1[o + 1]), o++;
                            for(var l = [], c = 0; s < r / 2;){
                                var u = t1[o - 1], h = t1[o], f = t1[o + 1];
                                if (!f) return !1;
                                var p = u.angleTo(h) - h.angleTo(f);
                                for(p = Math.abs((p + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l.push({
                                    distance: s,
                                    angleDelta: p
                                }), c += p; s - l[0].distance > n;)c -= l.shift().angleDelta;
                                if (c > i) return !1;
                                o++, s += h.dist(f);
                            }
                            return !0;
                        }
                        function Ic(t1) {
                            for(var e1 = 0, r = 0; r < t1.length - 1; r++)e1 += t1[r].dist(t1[r + 1]);
                            return e1;
                        }
                        function Pc(t1, e1, r) {
                            return t1 ? .6 * e1 * r : 0;
                        }
                        function zc(t1, e1) {
                            return Math.max(t1 ? t1.right - t1.left : 0, e1 ? e1.right - e1.left : 0);
                        }
                        function Oc(t1, e1, r, n, i, a) {
                            for(var o = Pc(r, i, a), s = zc(r, n) * a, l = 0, c = Ic(t1) / 2, u = 0; u < t1.length - 1; u++){
                                var h = t1[u], f = t1[u + 1], p = h.dist(f);
                                if (l + p > c) {
                                    var d = (c - l) / p, m = er(h.x, f.x, d), g = er(h.y, f.y, d), y = new kc(m, g, f.angleTo(h), u);
                                    return y._round(), !o || Lc(t1, y, s, o, e1) ? y : void 0;
                                }
                                l += p;
                            }
                        }
                        function Dc(t1, e1, r, n, i, a, o, s, l) {
                            var c = Pc(n, a, o), u = zc(n, i), h = u * o, f = 0 === t1[0].x || t1[0].x === l || 0 === t1[0].y || t1[0].y === l;
                            return e1 - h < e1 / 4 && (e1 = h + e1 / 4), Rc(t1, f ? e1 / 2 * s % e1 : (u / 2 + 2 * a) * o * s % e1, e1, c, r, h, f, !1, l);
                        }
                        function Rc(t1, e1, r, n, i, a, o, s, l) {
                            for(var c = a / 2, u = Ic(t1), h = 0, f = e1 - r, p = [], d = 0; d < t1.length - 1; d++){
                                for(var m = t1[d], g = t1[d + 1], y = m.dist(g), v = g.angleTo(m); f + r < h + y;){
                                    var x = ((f += r) - h) / y, _ = er(m.x, g.x, x), b = er(m.y, g.y, x);
                                    if (_ >= 0 && _ < l && b >= 0 && b < l && f - c >= 0 && f + c <= u) {
                                        var w = new kc(_, b, v, d);
                                        w._round(), n && !Lc(t1, w, a, n, i) || p.push(w);
                                    }
                                }
                                h += y;
                            }
                            return s || p.length || o || (p = Rc(t1, h / 2, r, n, i, a, o, !0, l)), p;
                        }
                        function Fc(t1, e1, r, n, i) {
                            for(var o = [], s = 0; s < t1.length; s++)for(var l = t1[s], c = void 0, u = 0; u < l.length - 1; u++){
                                var h = l[u], f = l[u + 1];
                                h.x < e1 && f.x < e1 || (h.x < e1 ? h = new a(e1, h.y + (f.y - h.y) * ((e1 - h.x) / (f.x - h.x)))._round() : f.x < e1 && (f = new a(e1, h.y + (f.y - h.y) * ((e1 - h.x) / (f.x - h.x)))._round()), h.y < r && f.y < r || (h.y < r ? h = new a(h.x + (f.x - h.x) * ((r - h.y) / (f.y - h.y)), r)._round() : f.y < r && (f = new a(h.x + (f.x - h.x) * ((r - h.y) / (f.y - h.y)), r)._round()), h.x >= n && f.x >= n || (h.x >= n ? h = new a(n, h.y + (f.y - h.y) * ((n - h.x) / (f.x - h.x)))._round() : f.x >= n && (f = new a(n, h.y + (f.y - h.y) * ((n - h.x) / (f.x - h.x)))._round()), h.y >= i && f.y >= i || (h.y >= i ? h = new a(h.x + (f.x - h.x) * ((i - h.y) / (f.y - h.y)), i)._round() : f.y >= i && (f = new a(h.x + (f.x - h.x) * ((i - h.y) / (f.y - h.y)), i)._round()), c && h.equals(c[c.length - 1]) || (c = [
                                    h
                                ], o.push(c)), c.push(f)))));
                            }
                            return o;
                        }
                        var Bc = ic;
                        function Nc(t1, e1, r, n) {
                            var i = [], o = t1.image, s = o.pixelRatio, l = o.paddedRect.w - 2 * Bc, c = o.paddedRect.h - 2 * Bc, u = t1.right - t1.left, h = t1.bottom - t1.top, f = o.stretchX || [
                                [
                                    0,
                                    l
                                ]
                            ], p = o.stretchY || [
                                [
                                    0,
                                    c
                                ]
                            ], d = function(t1, e1) {
                                return t1 + e1[1] - e1[0];
                            }, m = f.reduce(d, 0), g = p.reduce(d, 0), y = l - m, v = c - g, x = 0, _ = m, b = 0, w = g, T = 0, k = y, A = 0, M = v;
                            if (o.content && n) {
                                var S = o.content;
                                x = jc(f, 0, S[0]), b = jc(p, 0, S[1]), _ = jc(f, S[0], S[2]), w = jc(p, S[1], S[3]), T = S[0] - x, A = S[1] - b, k = S[2] - S[0] - _, M = S[3] - S[1] - w;
                            }
                            var E = function(n, i, l, c) {
                                var f = Vc(n.stretch - x, _, u, t1.left), p = qc(n.fixed - T, k, n.stretch, m), d = Vc(i.stretch - b, w, h, t1.top), y = qc(i.fixed - A, M, i.stretch, g), v = Vc(l.stretch - x, _, u, t1.left), S = qc(l.fixed - T, k, l.stretch, m), E = Vc(c.stretch - b, w, h, t1.top), C = qc(c.fixed - A, M, c.stretch, g), L = new a(f, d), I = new a(v, d), P = new a(v, E), z = new a(f, E), O = new a(p / s, y / s), D = new a(S / s, C / s), R = e1 * Math.PI / 180;
                                if (R) {
                                    var F = Math.sin(R), B = Math.cos(R), N = [
                                        B,
                                        -F,
                                        F,
                                        B
                                    ];
                                    L._matMult(N), I._matMult(N), z._matMult(N), P._matMult(N);
                                }
                                var j = n.stretch + n.fixed, U = l.stretch + l.fixed, V = i.stretch + i.fixed, q = c.stretch + c.fixed;
                                return {
                                    tl: L,
                                    tr: I,
                                    bl: z,
                                    br: P,
                                    tex: {
                                        x: o.paddedRect.x + Bc + j,
                                        y: o.paddedRect.y + Bc + V,
                                        w: U - j,
                                        h: q - V
                                    },
                                    writingMode: void 0,
                                    glyphOffset: [
                                        0,
                                        0
                                    ],
                                    sectionIndex: 0,
                                    pixelOffsetTL: O,
                                    pixelOffsetBR: D,
                                    minFontScaleX: k / s / u,
                                    minFontScaleY: M / s / h,
                                    isSDF: r
                                };
                            };
                            if (n && (o.stretchX || o.stretchY)) for(var C = Uc(f, y, m), L = Uc(p, v, g), I = 0; I < C.length - 1; I++)for(var P = C[I], z = C[I + 1], O = 0; O < L.length - 1; O++){
                                var D = L[O], R = L[O + 1];
                                i.push(E(P, D, z, R));
                            }
                            else i.push(E({
                                fixed: 0,
                                stretch: -1
                            }, {
                                fixed: 0,
                                stretch: -1
                            }, {
                                fixed: 0,
                                stretch: l + 1
                            }, {
                                fixed: 0,
                                stretch: c + 1
                            }));
                            return i;
                        }
                        function jc(t1, e1, r) {
                            for(var n = 0, i = 0, a = t1; i < a.length; i += 1){
                                var o = a[i];
                                n += Math.max(e1, Math.min(r, o[1])) - Math.max(e1, Math.min(r, o[0]));
                            }
                            return n;
                        }
                        function Uc(t1, e1, r) {
                            for(var n = [
                                {
                                    fixed: -Bc,
                                    stretch: 0
                                }
                            ], i = 0, a = t1; i < a.length; i += 1){
                                var o = a[i], s = o[0], l = o[1], c = n[n.length - 1];
                                n.push({
                                    fixed: s - c.stretch,
                                    stretch: c.stretch
                                }), n.push({
                                    fixed: s - c.stretch,
                                    stretch: c.stretch + (l - s)
                                });
                            }
                            return n.push({
                                fixed: e1 + Bc,
                                stretch: r
                            }), n;
                        }
                        function Vc(t1, e1, r, n) {
                            return t1 / e1 * r + n;
                        }
                        function qc(t1, e1, r, n) {
                            return t1 - e1 * r / n;
                        }
                        var Hc = function(t1, e1, r, n, i, o, s, l, c, u) {
                            if (this.boxStartIndex = t1.length, c) {
                                var h = o.top, f = o.bottom, p = o.collisionPadding;
                                p && (h -= p[1], f += p[3]);
                                var d = f - h;
                                d > 0 && (d = Math.max(10, d), this.circleDiameter = d);
                            } else {
                                var m = o.top * s - l, g = o.bottom * s + l, y = o.left * s - l, v = o.right * s + l, x = o.collisionPadding;
                                if (x && (y -= x[0] * s, m -= x[1] * s, v += x[2] * s, g += x[3] * s), u) {
                                    var _ = new a(y, m), b = new a(v, m), w = new a(y, g), T = new a(v, g), k = u * Math.PI / 180;
                                    _._rotate(k), b._rotate(k), w._rotate(k), T._rotate(k), y = Math.min(_.x, b.x, w.x, T.x), v = Math.max(_.x, b.x, w.x, T.x), m = Math.min(_.y, b.y, w.y, T.y), g = Math.max(_.y, b.y, w.y, T.y);
                                }
                                t1.emplaceBack(e1.x, e1.y, y, m, v, g, r, n, i);
                            }
                            this.boxEndIndex = t1.length;
                        }, Gc = function(t1, e1) {
                            if (void 0 === t1 && (t1 = []), void 0 === e1 && (e1 = Zc), this.data = t1, this.length = this.data.length, this.compare = e1, this.length > 0) for(var r = (this.length >> 1) - 1; r >= 0; r--)this._down(r);
                        };
                        function Zc(t1, e1) {
                            return t1 < e1 ? -1 : t1 > e1 ? 1 : 0;
                        }
                        function Wc(t1, e1, r) {
                            void 0 === e1 && (e1 = 1), void 0 === r && (r = !1);
                            for(var n = 1 / 0, i = 1 / 0, o = -1 / 0, s = -1 / 0, l = t1[0], c = 0; c < l.length; c++){
                                var u = l[c];
                                (!c || u.x < n) && (n = u.x), (!c || u.y < i) && (i = u.y), (!c || u.x > o) && (o = u.x), (!c || u.y > s) && (s = u.y);
                            }
                            var h = o - n, f = s - i, p = Math.min(h, f), d = p / 2, m = new Gc([], Yc);
                            if (0 === p) return new a(n, i);
                            for(var g = n; g < o; g += p)for(var y = i; y < s; y += p)m.push(new Xc(g + d, y + d, d, t1));
                            for(var v = function(t1) {
                                for(var e1 = 0, r = 0, n = 0, i = t1[0], a = 0, o = i.length, s = o - 1; a < o; s = a++){
                                    var l = i[a], c = i[s], u = l.x * c.y - c.x * l.y;
                                    r += (l.x + c.x) * u, n += (l.y + c.y) * u, e1 += 3 * u;
                                }
                                return new Xc(r / e1, n / e1, 0, t1);
                            }(t1), x = m.length; m.length;){
                                var _ = m.pop();
                                (_.d > v.d || !v.d) && (v = _, r && console.log("found best %d after %d probes", Math.round(1e4 * _.d) / 1e4, x)), _.max - v.d <= e1 || (d = _.h / 2, m.push(new Xc(_.p.x - d, _.p.y - d, d, t1)), m.push(new Xc(_.p.x + d, _.p.y - d, d, t1)), m.push(new Xc(_.p.x - d, _.p.y + d, d, t1)), m.push(new Xc(_.p.x + d, _.p.y + d, d, t1)), x += 4);
                            }
                            return r && (console.log("num probes: " + x), console.log("best distance: " + v.d)), v.p;
                        }
                        function Yc(t1, e1) {
                            return e1.max - t1.max;
                        }
                        function Xc(t1, e1, r, n) {
                            this.p = new a(t1, e1), this.h = r, this.d = function(t1, e1) {
                                for(var r = !1, n = 1 / 0, i = 0; i < e1.length; i++)for(var a = e1[i], o = 0, s = a.length, l = s - 1; o < s; l = o++){
                                    var c = a[o], u = a[l];
                                    c.y > t1.y != u.y > t1.y && t1.x < (u.x - c.x) * (t1.y - c.y) / (u.y - c.y) + c.x && (r = !r), n = Math.min(n, Eo(t1, c, u));
                                }
                                return (r ? 1 : -1) * Math.sqrt(n);
                            }(this.p, n), this.max = this.d + this.h * Math.SQRT2;
                        }
                        Gc.prototype.push = function(t1) {
                            this.data.push(t1), this.length++, this._up(this.length - 1);
                        }, Gc.prototype.pop = function() {
                            if (0 !== this.length) {
                                var t1 = this.data[0], e1 = this.data.pop();
                                return this.length--, this.length > 0 && (this.data[0] = e1, this._down(0)), t1;
                            }
                        }, Gc.prototype.peek = function() {
                            return this.data[0];
                        }, Gc.prototype._up = function(t1) {
                            for(var e1 = this.data, r = this.compare, n = e1[t1]; t1 > 0;){
                                var i = t1 - 1 >> 1, a = e1[i];
                                if (r(n, a) >= 0) break;
                                e1[t1] = a, t1 = i;
                            }
                            e1[t1] = n;
                        }, Gc.prototype._down = function(t1) {
                            for(var e1 = this.data, r = this.compare, n = this.length >> 1, i = e1[t1]; t1 < n;){
                                var a = 1 + (t1 << 1), o = e1[a], s = a + 1;
                                if (s < this.length && r(e1[s], o) < 0 && (a = s, o = e1[s]), r(o, i) >= 0) break;
                                e1[t1] = o, t1 = a;
                            }
                            e1[t1] = i;
                        };
                        var $c = 7, Jc = Number.POSITIVE_INFINITY;
                        function Kc(t1, e1) {
                            return e1[1] !== Jc ? function(t1, e1, r) {
                                var n = 0, i = 0;
                                switch(e1 = Math.abs(e1), r = Math.abs(r), t1){
                                    case "top-right":
                                    case "top-left":
                                    case "top":
                                        i = r - $c;
                                        break;
                                    case "bottom-right":
                                    case "bottom-left":
                                    case "bottom":
                                        i = -r + $c;
                                }
                                switch(t1){
                                    case "top-right":
                                    case "bottom-right":
                                    case "right":
                                        n = -e1;
                                        break;
                                    case "top-left":
                                    case "bottom-left":
                                    case "left":
                                        n = e1;
                                }
                                return [
                                    n,
                                    i
                                ];
                            }(t1, e1[0], e1[1]) : function(t1, e1) {
                                var r = 0, n = 0;
                                e1 < 0 && (e1 = 0);
                                var i = e1 / Math.sqrt(2);
                                switch(t1){
                                    case "top-right":
                                    case "top-left":
                                        n = i - $c;
                                        break;
                                    case "bottom-right":
                                    case "bottom-left":
                                        n = -i + $c;
                                        break;
                                    case "bottom":
                                        n = -e1 + $c;
                                        break;
                                    case "top":
                                        n = e1 - $c;
                                }
                                switch(t1){
                                    case "top-right":
                                    case "bottom-right":
                                        r = -i;
                                        break;
                                    case "top-left":
                                    case "bottom-left":
                                        r = i;
                                        break;
                                    case "left":
                                        r = e1;
                                        break;
                                    case "right":
                                        r = -e1;
                                }
                                return [
                                    r,
                                    n
                                ];
                            }(t1, e1[0]);
                        }
                        function Qc(t1) {
                            switch(t1){
                                case "right":
                                case "top-right":
                                case "bottom-right":
                                    return "right";
                                case "left":
                                case "top-left":
                                case "bottom-left":
                                    return "left";
                            }
                            return "center";
                        }
                        var tu = 255, eu = tu * Ac;
                        function ru(t1, e1, r, n, i, o, s, l, c, u, h, f, p, d, m) {
                            var g = function(t1, e1, r, n, i, o, s, l) {
                                for(var c = n.layout.get("text-rotate").evaluate(o, {}) * Math.PI / 180, u = [], h = 0, f = e1.positionedLines; h < f.length; h += 1)for(var p = f[h], d = 0, m = p.positionedGlyphs; d < m.length; d += 1){
                                    var g = m[d];
                                    if (g.rect) {
                                        var y = g.rect || {}, v = rc + 1, x = !0, _ = 1, b = 0, w = (i || l) && g.vertical, T = g.metrics.advance * g.scale / 2;
                                        if (l && e1.verticalizable) {
                                            var k = (g.scale - 1) * Cl, A = (Cl - g.metrics.width * g.scale) / 2;
                                            b = p.lineOffset / 2 - (g.imageName ? -A : k);
                                        }
                                        if (g.imageName) {
                                            var M = s[g.imageName];
                                            x = M.sdf, _ = M.pixelRatio, v = ic / _;
                                        }
                                        var S = i ? [
                                            g.x + T,
                                            g.y
                                        ] : [
                                            0,
                                            0
                                        ], E = i ? [
                                            0,
                                            0
                                        ] : [
                                            g.x + T + r[0],
                                            g.y + r[1] - b
                                        ], C = [
                                            0,
                                            0
                                        ];
                                        w && (C = E, E = [
                                            0,
                                            0
                                        ]);
                                        var L = (g.metrics.left - v) * g.scale - T + E[0], I = (-g.metrics.top - v) * g.scale + E[1], P = L + y.w * g.scale / _, z = I + y.h * g.scale / _, O = new a(L, I), D = new a(P, I), R = new a(L, z), F = new a(P, z);
                                        if (w) {
                                            var B = new a(-T, T - cc), N = -Math.PI / 2, j = Cl / 2 - T, U = g.imageName ? j : 0, V = new a(5 - cc - j, -U), q = new (Function.prototype.bind.apply(a, [
                                                null
                                            ].concat(C)));
                                            O._rotateAround(N, B)._add(V)._add(q), D._rotateAround(N, B)._add(V)._add(q), R._rotateAround(N, B)._add(V)._add(q), F._rotateAround(N, B)._add(V)._add(q);
                                        }
                                        if (c) {
                                            var H = Math.sin(c), G = Math.cos(c), Z = [
                                                G,
                                                -H,
                                                H,
                                                G
                                            ];
                                            O._matMult(Z), D._matMult(Z), R._matMult(Z), F._matMult(Z);
                                        }
                                        var W = new a(0, 0), Y = new a(0, 0);
                                        u.push({
                                            tl: O,
                                            tr: D,
                                            bl: R,
                                            br: F,
                                            tex: y,
                                            writingMode: e1.writingMode,
                                            glyphOffset: S,
                                            sectionIndex: g.sectionIndex,
                                            isSDF: x,
                                            pixelOffsetTL: W,
                                            pixelOffsetBR: Y,
                                            minFontScaleX: 0,
                                            minFontScaleY: 0
                                        });
                                    }
                                }
                                return u;
                            }(0, r, l, i, o, s, n, t1.allowVerticalPlacement), y = t1.textSizeData, v = null;
                            "source" === y.kind ? (v = [
                                Ac * i.layout.get("text-size").evaluate(s, {})
                            ])[0] > eu && k(t1.layerIds[0] + ': Value for "text-size" is >= ' + tu + '. Reduce your "text-size".') : "composite" === y.kind && ((v = [
                                Ac * d.compositeTextSizes[0].evaluate(s, {}, m),
                                Ac * d.compositeTextSizes[1].evaluate(s, {}, m)
                            ])[0] > eu || v[1] > eu) && k(t1.layerIds[0] + ': Value for "text-size" is >= ' + tu + '. Reduce your "text-size".'), t1.addSymbols(t1.text, g, v, l, o, s, u, e1, c.lineStartIndex, c.lineLength, p, m);
                            for(var x = 0, _ = h; x < _.length; x += 1)f[_[x]] = t1.text.placedSymbolArray.length - 1;
                            return 4 * g.length;
                        }
                        function nu(t1) {
                            for(var e1 in t1)return t1[e1];
                            return null;
                        }
                        function iu(t1, e1, r, n) {
                            var i = t1.compareText;
                            if (e1 in i) {
                                for(var a = i[e1], o = a.length - 1; o >= 0; o--)if (n.dist(a[o]) < r) return !0;
                            } else i[e1] = [];
                            return i[e1].push(n), !1;
                        }
                        var au = tl.VectorTileFeature.types, ou = [
                            {
                                name: "a_fade_opacity",
                                components: 1,
                                type: "Uint8",
                                offset: 0
                            }
                        ];
                        function su(t1, e1, r, n, i, a, o, s, l, c, u, h, f) {
                            var p = s ? Math.min(eu, Math.round(s[0])) : 0, d = s ? Math.min(eu, Math.round(s[1])) : 0;
                            t1.emplaceBack(e1, r, Math.round(32 * n), Math.round(32 * i), a, o, (p << 1) + (l ? 1 : 0), d, 16 * c, 16 * u, 256 * h, 256 * f);
                        }
                        function lu(t1, e1, r) {
                            t1.emplaceBack(e1.x, e1.y, r), t1.emplaceBack(e1.x, e1.y, r), t1.emplaceBack(e1.x, e1.y, r), t1.emplaceBack(e1.x, e1.y, r);
                        }
                        function cu(t1) {
                            for(var e1 = 0, r = t1.sections; e1 < r.length; e1 += 1)if (_i(r[e1].text)) return !0;
                            return !1;
                        }
                        var uu = function(t1) {
                            this.layoutVertexArray = new la, this.indexArray = new ma, this.programConfigurations = t1, this.segments = new Da, this.dynamicLayoutVertexArray = new ca, this.opacityVertexArray = new ua, this.placedSymbolArray = new Sa;
                        };
                        uu.prototype.isEmpty = function() {
                            return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length;
                        }, uu.prototype.upload = function(t1, e1, r, n) {
                            this.isEmpty() || (r && (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, wl.members), this.indexBuffer = t1.createIndexBuffer(this.indexArray, e1), this.dynamicLayoutVertexBuffer = t1.createVertexBuffer(this.dynamicLayoutVertexArray, Tl.members, !0), this.opacityVertexBuffer = t1.createVertexBuffer(this.opacityVertexArray, ou, !0), this.opacityVertexBuffer.itemSize = 1), (r || n) && this.programConfigurations.upload(t1));
                        }, uu.prototype.destroy = function() {
                            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy());
                        }, oi("SymbolBuffers", uu);
                        var hu = function(t1, e1, r) {
                            this.layoutVertexArray = new t1, this.layoutAttributes = e1, this.indexArray = new r, this.segments = new Da, this.collisionVertexArray = new da;
                        };
                        hu.prototype.upload = function(t1) {
                            this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = t1.createVertexBuffer(this.collisionVertexArray, kl.members, !0);
                        }, hu.prototype.destroy = function() {
                            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy());
                        }, oi("CollisionBuffers", hu);
                        var fu = function(t1) {
                            this.collisionBoxArray = t1.collisionBoxArray, this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map(function(t1) {
                                return t1.id;
                            }), this.index = t1.index, this.pixelRatio = t1.pixelRatio, this.sourceLayerIndex = t1.sourceLayerIndex, this.hasPattern = !1, this.hasRTLText = !1, this.sortKeyRanges = [], this.collisionCircleArray = [], this.placementInvProjMatrix = Bo([]), this.placementViewportMatrix = Bo([]);
                            var e1 = this.layers[0]._unevaluatedLayout._values;
                            this.textSizeData = Mc(this.zoom, e1["text-size"]), this.iconSizeData = Mc(this.zoom, e1["icon-size"]);
                            var r = this.layers[0].layout, n = r.get("symbol-sort-key"), i = r.get("symbol-z-order");
                            this.canOverlap = r.get("text-allow-overlap") || r.get("icon-allow-overlap") || r.get("text-ignore-placement") || r.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== i && void 0 !== n.constantOr(1);
                            var a = "viewport-y" === i || "auto" === i && !this.sortFeaturesByKey;
                            this.sortFeaturesByY = a && this.canOverlap, "point" === r.get("symbol-placement") && (this.writingModes = r.get("text-writing-mode").map(function(t1) {
                                return lc[t1];
                            })), this.stateDependentLayerIds = this.layers.filter(function(t1) {
                                return t1.isStateDependent();
                            }).map(function(t1) {
                                return t1.id;
                            }), this.sourceID = t1.sourceID;
                        };
                        fu.prototype.createArrays = function() {
                            this.text = new uu(new uo(this.layers, this.zoom, function(t1) {
                                return /^text/.test(t1);
                            })), this.icon = new uu(new uo(this.layers, this.zoom, function(t1) {
                                return /^icon/.test(t1);
                            })), this.glyphOffsetArray = new La, this.lineVertexArray = new Ia, this.symbolInstances = new Ca;
                        }, fu.prototype.calculateGlyphDependencies = function(t1, e1, r, n, i) {
                            for(var a = 0; a < t1.length; a++)if (e1[t1.charCodeAt(a)] = !0, (r || n) && i) {
                                var o = El[t1.charAt(a)];
                                o && (e1[o.charCodeAt(0)] = !0);
                            }
                        }, fu.prototype.populate = function(t1, e1, r) {
                            var n = this.layers[0], i = n.layout, a = i.get("text-font"), o = i.get("text-field"), s = i.get("icon-image"), l = ("constant" !== o.value.kind || o.value.value instanceof fe && !o.value.value.isEmpty() || o.value.value.toString().length > 0) && ("constant" !== a.value.kind || a.value.value.length > 0), c = "constant" !== s.value.kind || !!s.value.value || Object.keys(s.parameters).length > 0, u = i.get("symbol-sort-key");
                            if (this.features = [], l || c) {
                                for(var h = e1.iconDependencies, f = e1.glyphDependencies, p = e1.availableImages, d = new Oi(this.zoom), m = 0, g = t1; m < g.length; m += 1){
                                    var y = g[m], v = y.feature, x = y.id, _ = y.index, b = y.sourceLayerIndex, w = n._featureFilter.needGeometry, T = vo(v, w);
                                    if (n._featureFilter.filter(d, T, r)) {
                                        w || (T.geometry = yo(v));
                                        var k = void 0;
                                        if (l) {
                                            var A = n.getValueAndResolveTokens("text-field", T, r, p), M = fe.factory(A);
                                            cu(M) && (this.hasRTLText = !0), (!this.hasRTLText || "unavailable" === Ii() || this.hasRTLText && zi.isParsed()) && (k = Sl(M, n, T));
                                        }
                                        var S = void 0;
                                        if (c) {
                                            var E = n.getValueAndResolveTokens("icon-image", T, r, p);
                                            S = E instanceof pe ? E : pe.fromString(E);
                                        }
                                        if (k || S) {
                                            var C = this.sortFeaturesByKey ? u.evaluate(T, {}, r) : void 0, L = {
                                                id: x,
                                                text: k,
                                                icon: S,
                                                index: _,
                                                sourceLayerIndex: b,
                                                geometry: T.geometry,
                                                properties: v.properties,
                                                type: au[v.type],
                                                sortKey: C
                                            };
                                            if (this.features.push(L), S && (h[S.name] = !0), k) {
                                                var I = a.evaluate(T, {}, r).join(","), P = "map" === i.get("text-rotation-alignment") && "point" !== i.get("symbol-placement");
                                                this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(lc.vertical) >= 0;
                                                for(var z = 0, O = k.sections; z < O.length; z += 1){
                                                    var D = O[z];
                                                    if (D.image) h[D.image.name] = !0;
                                                    else {
                                                        var R = di(k.toString()), F = D.fontStack || I, B = f[F] = f[F] || {};
                                                        this.calculateGlyphDependencies(D.text, B, P, this.allowVerticalPlacement, R);
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                "line" === i.get("symbol-placement") && (this.features = function(t1) {
                                    var e1 = {}, r = {}, n = [], i = 0;
                                    function a(e1) {
                                        n.push(t1[e1]), i++;
                                    }
                                    function o(t1, e1, i) {
                                        var a = r[t1];
                                        return delete r[t1], r[e1] = a, n[a].geometry[0].pop(), n[a].geometry[0] = n[a].geometry[0].concat(i[0]), a;
                                    }
                                    function s(t1, r, i) {
                                        var a = e1[r];
                                        return delete e1[r], e1[t1] = a, n[a].geometry[0].shift(), n[a].geometry[0] = i[0].concat(n[a].geometry[0]), a;
                                    }
                                    function l(t1, e1, r) {
                                        var n = r ? e1[0][e1[0].length - 1] : e1[0][0];
                                        return t1 + ":" + n.x + ":" + n.y;
                                    }
                                    for(var c = 0; c < t1.length; c++){
                                        var u = t1[c], h = u.geometry, f = u.text ? u.text.toString() : null;
                                        if (f) {
                                            var p = l(f, h), d = l(f, h, !0);
                                            if (p in r && d in e1 && r[p] !== e1[d]) {
                                                var m = s(p, d, h), g = o(p, d, n[m].geometry);
                                                delete e1[p], delete r[d], r[l(f, n[g].geometry, !0)] = g, n[m].geometry = null;
                                            } else p in r ? o(p, d, h) : d in e1 ? s(p, d, h) : (a(c), e1[p] = i - 1, r[d] = i - 1);
                                        } else a(c);
                                    }
                                    return n.filter(function(t1) {
                                        return t1.geometry;
                                    });
                                }(this.features)), this.sortFeaturesByKey && this.features.sort(function(t1, e1) {
                                    return t1.sortKey - e1.sortKey;
                                });
                            }
                        }, fu.prototype.update = function(t1, e1, r) {
                            this.stateDependentLayers.length && (this.text.programConfigurations.updatePaintArrays(t1, e1, this.layers, r), this.icon.programConfigurations.updatePaintArrays(t1, e1, this.layers, r));
                        }, fu.prototype.isEmpty = function() {
                            return 0 === this.symbolInstances.length && !this.hasRTLText;
                        }, fu.prototype.uploadPending = function() {
                            return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
                        }, fu.prototype.upload = function(t1) {
                            !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(t1), this.iconCollisionBox.upload(t1)), this.text.upload(t1, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload), this.icon.upload(t1, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload), this.uploaded = !0;
                        }, fu.prototype.destroyDebugData = function() {
                            this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
                        }, fu.prototype.destroy = function() {
                            this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
                        }, fu.prototype.addToLineVertexArray = function(t1, e1) {
                            var r = this.lineVertexArray.length;
                            if (void 0 !== t1.segment) {
                                for(var n = t1.dist(e1[t1.segment + 1]), i = t1.dist(e1[t1.segment]), a = {}, o = t1.segment + 1; o < e1.length; o++)a[o] = {
                                    x: e1[o].x,
                                    y: e1[o].y,
                                    tileUnitDistanceFromAnchor: n
                                }, o < e1.length - 1 && (n += e1[o + 1].dist(e1[o]));
                                for(var s = t1.segment || 0; s >= 0; s--)a[s] = {
                                    x: e1[s].x,
                                    y: e1[s].y,
                                    tileUnitDistanceFromAnchor: i
                                }, s > 0 && (i += e1[s - 1].dist(e1[s]));
                                for(var l = 0; l < e1.length; l++){
                                    var c = a[l];
                                    this.lineVertexArray.emplaceBack(c.x, c.y, c.tileUnitDistanceFromAnchor);
                                }
                            }
                            return {
                                lineStartIndex: r,
                                lineLength: this.lineVertexArray.length - r
                            };
                        }, fu.prototype.addSymbols = function(t1, e1, r, n, i, a, o, s, l, c, u, h) {
                            for(var f = t1.indexArray, p = t1.layoutVertexArray, d = t1.segments.prepareSegment(4 * e1.length, p, f, this.canOverlap ? a.sortKey : void 0), m = this.glyphOffsetArray.length, g = d.vertexLength, y = this.allowVerticalPlacement && o === lc.vertical ? Math.PI / 2 : 0, v = a.text && a.text.sections, x = 0; x < e1.length; x++){
                                var _ = e1[x], b = _.tl, w = _.tr, T = _.bl, k = _.br, A = _.tex, M = _.pixelOffsetTL, S = _.pixelOffsetBR, E = _.minFontScaleX, C = _.minFontScaleY, L = _.glyphOffset, I = _.isSDF, P = _.sectionIndex, z = d.vertexLength, O = L[1];
                                su(p, s.x, s.y, b.x, O + b.y, A.x, A.y, r, I, M.x, M.y, E, C), su(p, s.x, s.y, w.x, O + w.y, A.x + A.w, A.y, r, I, S.x, M.y, E, C), su(p, s.x, s.y, T.x, O + T.y, A.x, A.y + A.h, r, I, M.x, S.y, E, C), su(p, s.x, s.y, k.x, O + k.y, A.x + A.w, A.y + A.h, r, I, S.x, S.y, E, C), lu(t1.dynamicLayoutVertexArray, s, y), f.emplaceBack(z, z + 1, z + 2), f.emplaceBack(z + 1, z + 2, z + 3), d.vertexLength += 4, d.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(L[0]), x !== e1.length - 1 && P === e1[x + 1].sectionIndex || t1.programConfigurations.populatePaintArrays(p.length, a, a.index, {}, h, v && v[P]);
                            }
                            t1.placedSymbolArray.emplaceBack(s.x, s.y, m, this.glyphOffsetArray.length - m, g, l, c, s.segment, r ? r[0] : 0, r ? r[1] : 0, n[0], n[1], o, 0, !1, 0, u);
                        }, fu.prototype._addCollisionDebugVertex = function(t1, e1, r, n, i, a) {
                            return e1.emplaceBack(0, 0), t1.emplaceBack(r.x, r.y, n, i, Math.round(a.x), Math.round(a.y));
                        }, fu.prototype.addCollisionDebugVertices = function(t1, e1, r, n, i, o, s) {
                            var l = i.segments.prepareSegment(4, i.layoutVertexArray, i.indexArray), c = l.vertexLength, u = i.layoutVertexArray, h = i.collisionVertexArray, f = s.anchorX, p = s.anchorY;
                            this._addCollisionDebugVertex(u, h, o, f, p, new a(t1, e1)), this._addCollisionDebugVertex(u, h, o, f, p, new a(r, e1)), this._addCollisionDebugVertex(u, h, o, f, p, new a(r, n)), this._addCollisionDebugVertex(u, h, o, f, p, new a(t1, n)), l.vertexLength += 4;
                            var d = i.indexArray;
                            d.emplaceBack(c, c + 1), d.emplaceBack(c + 1, c + 2), d.emplaceBack(c + 2, c + 3), d.emplaceBack(c + 3, c), l.primitiveLength += 4;
                        }, fu.prototype.addDebugCollisionBoxes = function(t1, e1, r, n) {
                            for(var i = t1; i < e1; i++){
                                var a = this.collisionBoxArray.get(i), o = a.x1, s = a.y1, l = a.x2, c = a.y2;
                                this.addCollisionDebugVertices(o, s, l, c, n ? this.textCollisionBox : this.iconCollisionBox, a.anchorPoint, r);
                            }
                        }, fu.prototype.generateCollisionDebugBuffers = function() {
                            this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new hu(fa, Al.members, ba), this.iconCollisionBox = new hu(fa, Al.members, ba);
                            for(var t1 = 0; t1 < this.symbolInstances.length; t1++){
                                var e1 = this.symbolInstances.get(t1);
                                this.addDebugCollisionBoxes(e1.textBoxStartIndex, e1.textBoxEndIndex, e1, !0), this.addDebugCollisionBoxes(e1.verticalTextBoxStartIndex, e1.verticalTextBoxEndIndex, e1, !0), this.addDebugCollisionBoxes(e1.iconBoxStartIndex, e1.iconBoxEndIndex, e1, !1), this.addDebugCollisionBoxes(e1.verticalIconBoxStartIndex, e1.verticalIconBoxEndIndex, e1, !1);
                            }
                        }, fu.prototype._deserializeCollisionBoxesForSymbol = function(t1, e1, r, n, i, a, o, s, l) {
                            for(var c = {}, u = e1; u < r; u++){
                                var h = t1.get(u);
                                c.textBox = {
                                    x1: h.x1,
                                    y1: h.y1,
                                    x2: h.x2,
                                    y2: h.y2,
                                    anchorPointX: h.anchorPointX,
                                    anchorPointY: h.anchorPointY
                                }, c.textFeatureIndex = h.featureIndex;
                                break;
                            }
                            for(var f = n; f < i; f++){
                                var p = t1.get(f);
                                c.verticalTextBox = {
                                    x1: p.x1,
                                    y1: p.y1,
                                    x2: p.x2,
                                    y2: p.y2,
                                    anchorPointX: p.anchorPointX,
                                    anchorPointY: p.anchorPointY
                                }, c.verticalTextFeatureIndex = p.featureIndex;
                                break;
                            }
                            for(var d = a; d < o; d++){
                                var m = t1.get(d);
                                c.iconBox = {
                                    x1: m.x1,
                                    y1: m.y1,
                                    x2: m.x2,
                                    y2: m.y2,
                                    anchorPointX: m.anchorPointX,
                                    anchorPointY: m.anchorPointY
                                }, c.iconFeatureIndex = m.featureIndex;
                                break;
                            }
                            for(var g = s; g < l; g++){
                                var y = t1.get(g);
                                c.verticalIconBox = {
                                    x1: y.x1,
                                    y1: y.y1,
                                    x2: y.x2,
                                    y2: y.y2,
                                    anchorPointX: y.anchorPointX,
                                    anchorPointY: y.anchorPointY
                                }, c.verticalIconFeatureIndex = y.featureIndex;
                                break;
                            }
                            return c;
                        }, fu.prototype.deserializeCollisionBoxes = function(t1) {
                            this.collisionArrays = [];
                            for(var e1 = 0; e1 < this.symbolInstances.length; e1++){
                                var r = this.symbolInstances.get(e1);
                                this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t1, r.textBoxStartIndex, r.textBoxEndIndex, r.verticalTextBoxStartIndex, r.verticalTextBoxEndIndex, r.iconBoxStartIndex, r.iconBoxEndIndex, r.verticalIconBoxStartIndex, r.verticalIconBoxEndIndex));
                            }
                        }, fu.prototype.hasTextData = function() {
                            return this.text.segments.get().length > 0;
                        }, fu.prototype.hasIconData = function() {
                            return this.icon.segments.get().length > 0;
                        }, fu.prototype.hasDebugData = function() {
                            return this.textCollisionBox && this.iconCollisionBox;
                        }, fu.prototype.hasTextCollisionBoxData = function() {
                            return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
                        }, fu.prototype.hasIconCollisionBoxData = function() {
                            return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
                        }, fu.prototype.addIndicesForPlacedSymbol = function(t1, e1) {
                            for(var r = t1.placedSymbolArray.get(e1), n = r.vertexStartIndex + 4 * r.numGlyphs, i = r.vertexStartIndex; i < n; i += 4)t1.indexArray.emplaceBack(i, i + 1, i + 2), t1.indexArray.emplaceBack(i + 1, i + 2, i + 3);
                        }, fu.prototype.getSortedSymbolIndexes = function(t1) {
                            if (this.sortedAngle === t1 && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
                            for(var e1 = Math.sin(t1), r = Math.cos(t1), n = [], i = [], a = [], o = 0; o < this.symbolInstances.length; ++o){
                                a.push(o);
                                var s = this.symbolInstances.get(o);
                                n.push(0 | Math.round(e1 * s.anchorX + r * s.anchorY)), i.push(s.featureIndex);
                            }
                            return a.sort(function(t1, e1) {
                                return n[t1] - n[e1] || i[e1] - i[t1];
                            }), a;
                        }, fu.prototype.addToSortKeyRanges = function(t1, e1) {
                            var r = this.sortKeyRanges[this.sortKeyRanges.length - 1];
                            r && r.sortKey === e1 ? r.symbolInstanceEnd = t1 + 1 : this.sortKeyRanges.push({
                                sortKey: e1,
                                symbolInstanceStart: t1,
                                symbolInstanceEnd: t1 + 1
                            });
                        }, fu.prototype.sortFeatures = function(t1) {
                            var e1 = this;
                            if (this.sortFeaturesByY && this.sortedAngle !== t1 && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
                                this.symbolInstanceIndexes = this.getSortedSymbolIndexes(t1), this.sortedAngle = t1, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                                for(var r = 0, n = this.symbolInstanceIndexes; r < n.length; r += 1){
                                    var i = n[r], a = this.symbolInstances.get(i);
                                    this.featureSortOrder.push(a.featureIndex), [
                                        a.rightJustifiedTextSymbolIndex,
                                        a.centerJustifiedTextSymbolIndex,
                                        a.leftJustifiedTextSymbolIndex
                                    ].forEach(function(t1, r, n) {
                                        t1 >= 0 && n.indexOf(t1) === r && e1.addIndicesForPlacedSymbol(e1.text, t1);
                                    }), a.verticalPlacedTextSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.text, a.verticalPlacedTextSymbolIndex), a.placedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, a.placedIconSymbolIndex), a.verticalPlacedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, a.verticalPlacedIconSymbolIndex);
                                }
                                this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
                            }
                        }, oi("SymbolBucket", fu, {
                            omit: [
                                "layers",
                                "collisionBoxArray",
                                "features",
                                "compareText"
                            ]
                        }), fu.MAX_GLYPHS = 65535, fu.addDynamicAttributes = lu;
                        var pu = new Yi({
                            "symbol-placement": new qi(Ft.layout_symbol["symbol-placement"]),
                            "symbol-spacing": new qi(Ft.layout_symbol["symbol-spacing"]),
                            "symbol-avoid-edges": new qi(Ft.layout_symbol["symbol-avoid-edges"]),
                            "symbol-sort-key": new Hi(Ft.layout_symbol["symbol-sort-key"]),
                            "symbol-z-order": new qi(Ft.layout_symbol["symbol-z-order"]),
                            "icon-allow-overlap": new qi(Ft.layout_symbol["icon-allow-overlap"]),
                            "icon-ignore-placement": new qi(Ft.layout_symbol["icon-ignore-placement"]),
                            "icon-optional": new qi(Ft.layout_symbol["icon-optional"]),
                            "icon-rotation-alignment": new qi(Ft.layout_symbol["icon-rotation-alignment"]),
                            "icon-size": new Hi(Ft.layout_symbol["icon-size"]),
                            "icon-text-fit": new qi(Ft.layout_symbol["icon-text-fit"]),
                            "icon-text-fit-padding": new qi(Ft.layout_symbol["icon-text-fit-padding"]),
                            "icon-image": new Hi(Ft.layout_symbol["icon-image"]),
                            "icon-rotate": new Hi(Ft.layout_symbol["icon-rotate"]),
                            "icon-padding": new qi(Ft.layout_symbol["icon-padding"]),
                            "icon-keep-upright": new qi(Ft.layout_symbol["icon-keep-upright"]),
                            "icon-offset": new Hi(Ft.layout_symbol["icon-offset"]),
                            "icon-anchor": new Hi(Ft.layout_symbol["icon-anchor"]),
                            "icon-pitch-alignment": new qi(Ft.layout_symbol["icon-pitch-alignment"]),
                            "text-pitch-alignment": new qi(Ft.layout_symbol["text-pitch-alignment"]),
                            "text-rotation-alignment": new qi(Ft.layout_symbol["text-rotation-alignment"]),
                            "text-field": new Hi(Ft.layout_symbol["text-field"]),
                            "text-font": new Hi(Ft.layout_symbol["text-font"]),
                            "text-size": new Hi(Ft.layout_symbol["text-size"]),
                            "text-max-width": new Hi(Ft.layout_symbol["text-max-width"]),
                            "text-line-height": new qi(Ft.layout_symbol["text-line-height"]),
                            "text-letter-spacing": new Hi(Ft.layout_symbol["text-letter-spacing"]),
                            "text-justify": new Hi(Ft.layout_symbol["text-justify"]),
                            "text-radial-offset": new Hi(Ft.layout_symbol["text-radial-offset"]),
                            "text-variable-anchor": new qi(Ft.layout_symbol["text-variable-anchor"]),
                            "text-anchor": new Hi(Ft.layout_symbol["text-anchor"]),
                            "text-max-angle": new qi(Ft.layout_symbol["text-max-angle"]),
                            "text-writing-mode": new qi(Ft.layout_symbol["text-writing-mode"]),
                            "text-rotate": new Hi(Ft.layout_symbol["text-rotate"]),
                            "text-padding": new qi(Ft.layout_symbol["text-padding"]),
                            "text-keep-upright": new qi(Ft.layout_symbol["text-keep-upright"]),
                            "text-transform": new Hi(Ft.layout_symbol["text-transform"]),
                            "text-offset": new Hi(Ft.layout_symbol["text-offset"]),
                            "text-allow-overlap": new qi(Ft.layout_symbol["text-allow-overlap"]),
                            "text-ignore-placement": new qi(Ft.layout_symbol["text-ignore-placement"]),
                            "text-optional": new qi(Ft.layout_symbol["text-optional"])
                        }), du = {
                            paint: new Yi({
                                "icon-opacity": new Hi(Ft.paint_symbol["icon-opacity"]),
                                "icon-color": new Hi(Ft.paint_symbol["icon-color"]),
                                "icon-halo-color": new Hi(Ft.paint_symbol["icon-halo-color"]),
                                "icon-halo-width": new Hi(Ft.paint_symbol["icon-halo-width"]),
                                "icon-halo-blur": new Hi(Ft.paint_symbol["icon-halo-blur"]),
                                "icon-translate": new qi(Ft.paint_symbol["icon-translate"]),
                                "icon-translate-anchor": new qi(Ft.paint_symbol["icon-translate-anchor"]),
                                "text-opacity": new Hi(Ft.paint_symbol["text-opacity"]),
                                "text-color": new Hi(Ft.paint_symbol["text-color"], {
                                    runtimeType: Xt,
                                    getOverride: function(t1) {
                                        return t1.textColor;
                                    },
                                    hasOverride: function(t1) {
                                        return !!t1.textColor;
                                    }
                                }),
                                "text-halo-color": new Hi(Ft.paint_symbol["text-halo-color"]),
                                "text-halo-width": new Hi(Ft.paint_symbol["text-halo-width"]),
                                "text-halo-blur": new Hi(Ft.paint_symbol["text-halo-blur"]),
                                "text-translate": new qi(Ft.paint_symbol["text-translate"]),
                                "text-translate-anchor": new qi(Ft.paint_symbol["text-translate-anchor"])
                            }),
                            layout: pu
                        }, mu = function(t1) {
                            this.type = t1.property.overrides ? t1.property.overrides.runtimeType : Gt, this.defaultValue = t1;
                        };
                        mu.prototype.evaluate = function(t1) {
                            if (t1.formattedSection) {
                                var e1 = this.defaultValue.property.overrides;
                                if (e1 && e1.hasOverride(t1.formattedSection)) return e1.getOverride(t1.formattedSection);
                            }
                            return t1.feature && t1.featureState ? this.defaultValue.evaluate(t1.feature, t1.featureState) : this.defaultValue.property.specification.default;
                        }, mu.prototype.eachChild = function(t1) {
                            this.defaultValue.isConstant() || t1(this.defaultValue.value._styleExpression.expression);
                        }, mu.prototype.outputDefined = function() {
                            return !1;
                        }, mu.prototype.serialize = function() {
                            return null;
                        }, oi("FormatSectionOverride", mu, {
                            omit: [
                                "defaultValue"
                            ]
                        });
                        var gu = function(t1) {
                            function e1(e1) {
                                t1.call(this, e1, du);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.recalculate = function(e1, r) {
                                if (t1.prototype.recalculate.call(this, e1, r), "auto" === this.layout.get("icon-rotation-alignment") && ("point" !== this.layout.get("symbol-placement") ? this.layout._values["icon-rotation-alignment"] = "map" : this.layout._values["icon-rotation-alignment"] = "viewport"), "auto" === this.layout.get("text-rotation-alignment") && ("point" !== this.layout.get("symbol-placement") ? this.layout._values["text-rotation-alignment"] = "map" : this.layout._values["text-rotation-alignment"] = "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = this.layout.get("text-rotation-alignment")), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment")), "point" === this.layout.get("symbol-placement")) {
                                    var n = this.layout.get("text-writing-mode");
                                    if (n) {
                                        for(var i = [], a = 0, o = n; a < o.length; a += 1){
                                            var s = o[a];
                                            i.indexOf(s) < 0 && i.push(s);
                                        }
                                        this.layout._values["text-writing-mode"] = i;
                                    } else this.layout._values["text-writing-mode"] = [
                                        "horizontal"
                                    ];
                                }
                                this._setPaintOverrides();
                            }, e1.prototype.getValueAndResolveTokens = function(t1, e1, r, n) {
                                var i = this.layout.get(t1).evaluate(e1, {}, r, n), a = this._unevaluatedLayout._values[t1];
                                return a.isDataDriven() || un(a.value) || !i ? i : function(t1, e1) {
                                    return e1.replace(/{([^{}]+)}/g, function(e1, r) {
                                        return r in t1 ? String(t1[r]) : "";
                                    });
                                }(e1.properties, i);
                            }, e1.prototype.createBucket = function(t1) {
                                return new fu(t1);
                            }, e1.prototype.queryRadius = function() {
                                return 0;
                            }, e1.prototype.queryIntersectsFeature = function() {
                                return !1;
                            }, e1.prototype._setPaintOverrides = function() {
                                for(var t1 = 0, r = du.paint.overridableProperties; t1 < r.length; t1 += 1){
                                    var n = r[t1];
                                    if (e1.hasPaintOverride(this.layout, n)) {
                                        var i, a = this.paint.get(n), o = new mu(a), s = new cn(o, a.property.specification);
                                        i = "constant" === a.value.kind || "source" === a.value.kind ? new fn("source", s) : new pn("composite", s, a.value.zoomStops, a.value._interpolationType), this.paint._values[n] = new Ui(a.property, i, a.parameters);
                                    }
                                }
                            }, e1.prototype._handleOverridablePaintPropertyUpdate = function(t1, r, n) {
                                return !(!this.layout || r.isDataDriven() || n.isDataDriven()) && e1.hasPaintOverride(this.layout, t1);
                            }, e1.hasPaintOverride = function(t1, e1) {
                                var r = t1.get("text-field"), n = du.paint.properties[e1], i = !1, a = function(t1) {
                                    for(var e1 = 0, r = t1; e1 < r.length; e1 += 1){
                                        var a = r[e1];
                                        if (n.overrides && n.overrides.hasOverride(a)) return void (i = !0);
                                    }
                                };
                                if ("constant" === r.value.kind && r.value.value instanceof fe) a(r.value.value.sections);
                                else if ("source" === r.value.kind) {
                                    var o = function(t1) {
                                        if (!i) {
                                            if (t1 instanceof ve && ge(t1.value) === Qt) {
                                                var e1 = t1.value;
                                                a(e1.sections);
                                            } else t1 instanceof we ? a(t1.sections) : t1.eachChild(o);
                                        }
                                    }, s = r.value;
                                    s._styleExpression && o(s._styleExpression.expression);
                                }
                                return i;
                            }, e1;
                        }($i), yu = {
                            paint: new Yi({
                                "background-color": new qi(Ft.paint_background["background-color"]),
                                "background-pattern": new Zi(Ft.paint_background["background-pattern"]),
                                "background-opacity": new qi(Ft.paint_background["background-opacity"])
                            })
                        }, vu = function(t1) {
                            function e1(e1) {
                                t1.call(this, e1, yu);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1;
                        }($i), xu = {
                            paint: new Yi({
                                "raster-opacity": new qi(Ft.paint_raster["raster-opacity"]),
                                "raster-hue-rotate": new qi(Ft.paint_raster["raster-hue-rotate"]),
                                "raster-brightness-min": new qi(Ft.paint_raster["raster-brightness-min"]),
                                "raster-brightness-max": new qi(Ft.paint_raster["raster-brightness-max"]),
                                "raster-saturation": new qi(Ft.paint_raster["raster-saturation"]),
                                "raster-contrast": new qi(Ft.paint_raster["raster-contrast"]),
                                "raster-resampling": new qi(Ft.paint_raster["raster-resampling"]),
                                "raster-fade-duration": new qi(Ft.paint_raster["raster-fade-duration"])
                            })
                        }, _u = function(t1) {
                            function e1(e1) {
                                t1.call(this, e1, xu);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1;
                        }($i);
                        var bu = function(t1) {
                            function e1(e1) {
                                t1.call(this, e1, {}), this.implementation = e1;
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.is3D = function() {
                                return "3d" === this.implementation.renderingMode;
                            }, e1.prototype.hasOffscreenPass = function() {
                                return void 0 !== this.implementation.prerender;
                            }, e1.prototype.recalculate = function() {}, e1.prototype.updateTransitions = function() {}, e1.prototype.hasTransition = function() {}, e1.prototype.serialize = function() {}, e1.prototype.onAdd = function(t1) {
                                this.implementation.onAdd && this.implementation.onAdd(t1, t1.painter.context.gl);
                            }, e1.prototype.onRemove = function(t1) {
                                this.implementation.onRemove && this.implementation.onRemove(t1, t1.painter.context.gl);
                            }, e1;
                        }($i), wu = {
                            circle: Go,
                            heatmap: es,
                            hillshade: ns,
                            fill: Hs,
                            "fill-extrusion": sl,
                            line: _l,
                            symbol: gu,
                            background: vu,
                            raster: _u
                        };
                        var Tu = s.HTMLImageElement, ku = s.HTMLCanvasElement, Au = s.HTMLVideoElement, Mu = s.ImageData, Su = s.ImageBitmap, Eu = function(t1, e1, r, n) {
                            this.context = t1, this.format = r, this.texture = t1.gl.createTexture(), this.update(e1, n);
                        };
                        Eu.prototype.update = function(t1, e1, r) {
                            var n = t1.width, i = t1.height, a = !(this.size && this.size[0] === n && this.size[1] === i || r), o = this.context, s = o.gl;
                            if (this.useMipmap = Boolean(e1 && e1.useMipmap), s.bindTexture(s.TEXTURE_2D, this.texture), o.pixelStoreUnpackFlipY.set(!1), o.pixelStoreUnpack.set(1), o.pixelStoreUnpackPremultiplyAlpha.set(this.format === s.RGBA && (!e1 || !1 !== e1.premultiply)), a) this.size = [
                                n,
                                i
                            ], t1 instanceof Tu || t1 instanceof ku || t1 instanceof Au || t1 instanceof Mu || Su && t1 instanceof Su ? s.texImage2D(s.TEXTURE_2D, 0, this.format, this.format, s.UNSIGNED_BYTE, t1) : s.texImage2D(s.TEXTURE_2D, 0, this.format, n, i, 0, this.format, s.UNSIGNED_BYTE, t1.data);
                            else {
                                var l = r || {
                                    x: 0,
                                    y: 0
                                }, c = l.x, u = l.y;
                                t1 instanceof Tu || t1 instanceof ku || t1 instanceof Au || t1 instanceof Mu || Su && t1 instanceof Su ? s.texSubImage2D(s.TEXTURE_2D, 0, c, u, s.RGBA, s.UNSIGNED_BYTE, t1) : s.texSubImage2D(s.TEXTURE_2D, 0, c, u, n, i, s.RGBA, s.UNSIGNED_BYTE, t1.data);
                            }
                            this.useMipmap && this.isSizePowerOfTwo() && s.generateMipmap(s.TEXTURE_2D);
                        }, Eu.prototype.bind = function(t1, e1, r) {
                            var n = this.context.gl;
                            n.bindTexture(n.TEXTURE_2D, this.texture), r !== n.LINEAR_MIPMAP_NEAREST || this.isSizePowerOfTwo() || (r = n.LINEAR), t1 !== this.filter && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MAG_FILTER, t1), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, r || t1), this.filter = t1), e1 !== this.wrap && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_S, e1), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_T, e1), this.wrap = e1);
                        }, Eu.prototype.isSizePowerOfTwo = function() {
                            return this.size[0] === this.size[1] && Math.log(this.size[0]) / Math.LN2 % 1 == 0;
                        }, Eu.prototype.destroy = function() {
                            this.context.gl.deleteTexture(this.texture), this.texture = null;
                        };
                        var Cu = function(t1) {
                            var e1 = this;
                            this._callback = t1, this._triggered = !1, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel, this._channel.port2.onmessage = function() {
                                e1._triggered = !1, e1._callback();
                            });
                        };
                        Cu.prototype.trigger = function() {
                            var t1 = this;
                            this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(function() {
                                t1._triggered = !1, t1._callback();
                            }, 0));
                        }, Cu.prototype.remove = function() {
                            delete this._channel, this._callback = function() {};
                        };
                        var Lu = function(t1, e1, r) {
                            this.target = t1, this.parent = e1, this.mapId = r, this.callbacks = {}, this.tasks = {}, this.taskQueue = [], this.cancelCallbacks = {}, v([
                                "receive",
                                "process"
                            ], this), this.invoker = new Cu(this.process), this.target.addEventListener("message", this.receive, !1), this.globalScope = S() ? t1 : s;
                        };
                        function Iu(t1, e1, r) {
                            var n = 2 * Math.PI * 6378137 / 256 / Math.pow(2, r);
                            return [
                                t1 * n - 2 * Math.PI * 6378137 / 2,
                                e1 * n - 2 * Math.PI * 6378137 / 2
                            ];
                        }
                        Lu.prototype.send = function(t1, e1, r, n, i) {
                            var a = this;
                            void 0 === i && (i = !1);
                            var o = Math.round(1e18 * Math.random()).toString(36).substring(0, 10);
                            r && (this.callbacks[o] = r);
                            var s = L(this.globalScope) ? void 0 : [];
                            return this.target.postMessage({
                                id: o,
                                type: t1,
                                hasCallback: !!r,
                                targetMapId: n,
                                mustQueue: i,
                                sourceMapId: this.mapId,
                                data: ui(e1, s)
                            }, s), {
                                cancel: function() {
                                    r && delete a.callbacks[o], a.target.postMessage({
                                        id: o,
                                        type: "<cancel>",
                                        targetMapId: n,
                                        sourceMapId: a.mapId
                                    });
                                }
                            };
                        }, Lu.prototype.receive = function(t1) {
                            var e1 = t1.data, r = e1.id;
                            if (r && (!e1.targetMapId || this.mapId === e1.targetMapId)) {
                                if ("<cancel>" === e1.type) {
                                    delete this.tasks[r];
                                    var n = this.cancelCallbacks[r];
                                    delete this.cancelCallbacks[r], n && n();
                                } else S() || e1.mustQueue ? (this.tasks[r] = e1, this.taskQueue.push(r), this.invoker.trigger()) : this.processTask(r, e1);
                            }
                        }, Lu.prototype.process = function() {
                            if (this.taskQueue.length) {
                                var t1 = this.taskQueue.shift(), e1 = this.tasks[t1];
                                delete this.tasks[t1], this.taskQueue.length && this.invoker.trigger(), e1 && this.processTask(t1, e1);
                            }
                        }, Lu.prototype.processTask = function(t1, e1) {
                            var r = this;
                            if ("<response>" === e1.type) {
                                var n = this.callbacks[t1];
                                delete this.callbacks[t1], n && (e1.error ? n(hi(e1.error)) : n(null, hi(e1.data)));
                            } else {
                                var i = !1, a = L(this.globalScope) ? void 0 : [], o = e1.hasCallback ? function(e1, n) {
                                    i = !0, delete r.cancelCallbacks[t1], r.target.postMessage({
                                        id: t1,
                                        type: "<response>",
                                        sourceMapId: r.mapId,
                                        error: e1 ? ui(e1) : null,
                                        data: ui(n, a)
                                    }, a);
                                } : function(t1) {
                                    i = !0;
                                }, s = null, l = hi(e1.data);
                                if (this.parent[e1.type]) s = this.parent[e1.type](e1.sourceMapId, l, o);
                                else if (this.parent.getWorkerSource) {
                                    var c = e1.type.split(".");
                                    s = this.parent.getWorkerSource(e1.sourceMapId, c[0], l.source)[c[1]](l, o);
                                } else o(new Error("Could not find function " + e1.type));
                                !i && s && s.cancel && (this.cancelCallbacks[t1] = s.cancel);
                            }
                        }, Lu.prototype.remove = function() {
                            this.invoker.remove(), this.target.removeEventListener("message", this.receive, !1);
                        };
                        var Pu = function(t1, e1) {
                            t1 && (e1 ? this.setSouthWest(t1).setNorthEast(e1) : 4 === t1.length ? this.setSouthWest([
                                t1[0],
                                t1[1]
                            ]).setNorthEast([
                                t1[2],
                                t1[3]
                            ]) : this.setSouthWest(t1[0]).setNorthEast(t1[1]));
                        };
                        Pu.prototype.setNorthEast = function(t1) {
                            return this._ne = t1 instanceof Ou ? new Ou(t1.lng, t1.lat) : Ou.convert(t1), this;
                        }, Pu.prototype.setSouthWest = function(t1) {
                            return this._sw = t1 instanceof Ou ? new Ou(t1.lng, t1.lat) : Ou.convert(t1), this;
                        }, Pu.prototype.extend = function(t1) {
                            var e1, r, n = this._sw, i = this._ne;
                            if (t1 instanceof Ou) e1 = t1, r = t1;
                            else {
                                if (!(t1 instanceof Pu)) {
                                    if (Array.isArray(t1)) {
                                        if (4 === t1.length || t1.every(Array.isArray)) {
                                            var a = t1;
                                            return this.extend(Pu.convert(a));
                                        }
                                        var o = t1;
                                        return this.extend(Ou.convert(o));
                                    }
                                    return this;
                                }
                                if (e1 = t1._sw, r = t1._ne, !e1 || !r) return this;
                            }
                            return n || i ? (n.lng = Math.min(e1.lng, n.lng), n.lat = Math.min(e1.lat, n.lat), i.lng = Math.max(r.lng, i.lng), i.lat = Math.max(r.lat, i.lat)) : (this._sw = new Ou(e1.lng, e1.lat), this._ne = new Ou(r.lng, r.lat)), this;
                        }, Pu.prototype.getCenter = function() {
                            return new Ou((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
                        }, Pu.prototype.getSouthWest = function() {
                            return this._sw;
                        }, Pu.prototype.getNorthEast = function() {
                            return this._ne;
                        }, Pu.prototype.getNorthWest = function() {
                            return new Ou(this.getWest(), this.getNorth());
                        }, Pu.prototype.getSouthEast = function() {
                            return new Ou(this.getEast(), this.getSouth());
                        }, Pu.prototype.getWest = function() {
                            return this._sw.lng;
                        }, Pu.prototype.getSouth = function() {
                            return this._sw.lat;
                        }, Pu.prototype.getEast = function() {
                            return this._ne.lng;
                        }, Pu.prototype.getNorth = function() {
                            return this._ne.lat;
                        }, Pu.prototype.toArray = function() {
                            return [
                                this._sw.toArray(),
                                this._ne.toArray()
                            ];
                        }, Pu.prototype.toString = function() {
                            return "LngLatBounds(" + this._sw.toString() + ", " + this._ne.toString() + ")";
                        }, Pu.prototype.isEmpty = function() {
                            return !(this._sw && this._ne);
                        }, Pu.prototype.contains = function(t1) {
                            var e1 = Ou.convert(t1), r = e1.lng, n = e1.lat, i = this._sw.lat <= n && n <= this._ne.lat, a = this._sw.lng <= r && r <= this._ne.lng;
                            return this._sw.lng > this._ne.lng && (a = this._sw.lng >= r && r >= this._ne.lng), i && a;
                        }, Pu.convert = function(t1) {
                            return !t1 || t1 instanceof Pu ? t1 : new Pu(t1);
                        };
                        var zu = 6371008.8, Ou = function(t1, e1) {
                            if (isNaN(t1) || isNaN(e1)) throw new Error("Invalid LngLat object: (" + t1 + ", " + e1 + ")");
                            if (this.lng = +t1, this.lat = +e1, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
                        };
                        Ou.prototype.wrap = function() {
                            return new Ou(f(this.lng, -180, 180), this.lat);
                        }, Ou.prototype.toArray = function() {
                            return [
                                this.lng,
                                this.lat
                            ];
                        }, Ou.prototype.toString = function() {
                            return "LngLat(" + this.lng + ", " + this.lat + ")";
                        }, Ou.prototype.distanceTo = function(t1) {
                            var e1 = Math.PI / 180, r = this.lat * e1, n = t1.lat * e1, i = Math.sin(r) * Math.sin(n) + Math.cos(r) * Math.cos(n) * Math.cos((t1.lng - this.lng) * e1);
                            return zu * Math.acos(Math.min(i, 1));
                        }, Ou.prototype.toBounds = function(t1) {
                            void 0 === t1 && (t1 = 0);
                            var e1 = 360 * t1 / 40075017, r = e1 / Math.cos(Math.PI / 180 * this.lat);
                            return new Pu(new Ou(this.lng - r, this.lat - e1), new Ou(this.lng + r, this.lat + e1));
                        }, Ou.convert = function(t1) {
                            if (t1 instanceof Ou) return t1;
                            if (Array.isArray(t1) && (2 === t1.length || 3 === t1.length)) return new Ou(Number(t1[0]), Number(t1[1]));
                            if (!Array.isArray(t1) && "object" == typeof t1 && null !== t1) return new Ou(Number("lng" in t1 ? t1.lng : t1.lon), Number(t1.lat));
                            throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
                        };
                        var Du = 2 * Math.PI * zu;
                        function Ru(t1) {
                            return Du * Math.cos(t1 * Math.PI / 180);
                        }
                        function Fu(t1) {
                            return (180 + t1) / 360;
                        }
                        function Bu(t1) {
                            return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t1 * Math.PI / 360))) / 360;
                        }
                        function Nu(t1, e1) {
                            return t1 / Ru(e1);
                        }
                        function ju(t1) {
                            var e1 = 180 - 360 * t1;
                            return 360 / Math.PI * Math.atan(Math.exp(e1 * Math.PI / 180)) - 90;
                        }
                        var Uu = function(t1, e1, r) {
                            void 0 === r && (r = 0), this.x = +t1, this.y = +e1, this.z = +r;
                        };
                        Uu.fromLngLat = function(t1, e1) {
                            void 0 === e1 && (e1 = 0);
                            var r = Ou.convert(t1);
                            return new Uu(Fu(r.lng), Bu(r.lat), Nu(e1, r.lat));
                        }, Uu.prototype.toLngLat = function() {
                            return new Ou(360 * this.x - 180, ju(this.y));
                        }, Uu.prototype.toAltitude = function() {
                            var t1, e1;
                            return t1 = this.z, e1 = this.y, t1 * Ru(ju(e1));
                        }, Uu.prototype.meterInMercatorCoordinateUnits = function() {
                            var t1;
                            return 1 / Du * (t1 = ju(this.y), 1 / Math.cos(t1 * Math.PI / 180));
                        };
                        var Vu = function(t1, e1, r) {
                            this.z = t1, this.x = e1, this.y = r, this.key = Gu(0, t1, t1, e1, r);
                        };
                        Vu.prototype.equals = function(t1) {
                            return this.z === t1.z && this.x === t1.x && this.y === t1.y;
                        }, Vu.prototype.url = function(t1, e1) {
                            var r, n, i, a, o, s = (r = this.x, n = this.y, i = this.z, a = Iu(256 * r, 256 * (n = Math.pow(2, i) - n - 1), i), o = Iu(256 * (r + 1), 256 * (n + 1), i), a[0] + "," + a[1] + "," + o[0] + "," + o[1]), l = function(t1, e1, r) {
                                for(var n, i = "", a = t1; a > 0; a--)i += (e1 & (n = 1 << a - 1) ? 1 : 0) + (r & n ? 2 : 0);
                                return i;
                            }(this.z, this.x, this.y);
                            return t1[(this.x + this.y) % t1.length].replace("{prefix}", (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace("{z}", String(this.z)).replace("{x}", String(this.x)).replace("{y}", String("tms" === e1 ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace("{quadkey}", l).replace("{bbox-epsg-3857}", s);
                        }, Vu.prototype.getTilePoint = function(t1) {
                            var e1 = Math.pow(2, this.z);
                            return new a((t1.x * e1 - this.x) * po, (t1.y * e1 - this.y) * po);
                        }, Vu.prototype.toString = function() {
                            return this.z + "/" + this.x + "/" + this.y;
                        };
                        var qu = function(t1, e1) {
                            this.wrap = t1, this.canonical = e1, this.key = Gu(t1, e1.z, e1.z, e1.x, e1.y);
                        }, Hu = function(t1, e1, r, n, i) {
                            this.overscaledZ = t1, this.wrap = e1, this.canonical = new Vu(r, +n, +i), this.key = Gu(e1, t1, r, n, i);
                        };
                        function Gu(t1, e1, r, n, i) {
                            (t1 *= 2) < 0 && (t1 = -1 * t1 - 1);
                            var a = 1 << r;
                            return (a * a * t1 + a * i + n).toString(36) + r.toString(36) + e1.toString(36);
                        }
                        Hu.prototype.equals = function(t1) {
                            return this.overscaledZ === t1.overscaledZ && this.wrap === t1.wrap && this.canonical.equals(t1.canonical);
                        }, Hu.prototype.scaledTo = function(t1) {
                            var e1 = this.canonical.z - t1;
                            return t1 > this.canonical.z ? new Hu(t1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new Hu(t1, this.wrap, t1, this.canonical.x >> e1, this.canonical.y >> e1);
                        }, Hu.prototype.calculateScaledKey = function(t1, e1) {
                            var r = this.canonical.z - t1;
                            return t1 > this.canonical.z ? Gu(this.wrap * +e1, t1, this.canonical.z, this.canonical.x, this.canonical.y) : Gu(this.wrap * +e1, t1, t1, this.canonical.x >> r, this.canonical.y >> r);
                        }, Hu.prototype.isChildOf = function(t1) {
                            if (t1.wrap !== this.wrap) return !1;
                            var e1 = this.canonical.z - t1.canonical.z;
                            return 0 === t1.overscaledZ || t1.overscaledZ < this.overscaledZ && t1.canonical.x === this.canonical.x >> e1 && t1.canonical.y === this.canonical.y >> e1;
                        }, Hu.prototype.children = function(t1) {
                            if (this.overscaledZ >= t1) return [
                                new Hu(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
                            ];
                            var e1 = this.canonical.z + 1, r = 2 * this.canonical.x, n = 2 * this.canonical.y;
                            return [
                                new Hu(e1, this.wrap, e1, r, n),
                                new Hu(e1, this.wrap, e1, r + 1, n),
                                new Hu(e1, this.wrap, e1, r, n + 1),
                                new Hu(e1, this.wrap, e1, r + 1, n + 1)
                            ];
                        }, Hu.prototype.isLessThan = function(t1) {
                            return this.wrap < t1.wrap || !(this.wrap > t1.wrap) && (this.overscaledZ < t1.overscaledZ || !(this.overscaledZ > t1.overscaledZ) && (this.canonical.x < t1.canonical.x || !(this.canonical.x > t1.canonical.x) && this.canonical.y < t1.canonical.y));
                        }, Hu.prototype.wrapped = function() {
                            return new Hu(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
                        }, Hu.prototype.unwrapTo = function(t1) {
                            return new Hu(this.overscaledZ, t1, this.canonical.z, this.canonical.x, this.canonical.y);
                        }, Hu.prototype.overscaleFactor = function() {
                            return Math.pow(2, this.overscaledZ - this.canonical.z);
                        }, Hu.prototype.toUnwrapped = function() {
                            return new qu(this.wrap, this.canonical);
                        }, Hu.prototype.toString = function() {
                            return this.overscaledZ + "/" + this.canonical.x + "/" + this.canonical.y;
                        }, Hu.prototype.getTilePoint = function(t1) {
                            return this.canonical.getTilePoint(new Uu(t1.x - this.wrap, t1.y));
                        }, oi("CanonicalTileID", Vu), oi("OverscaledTileID", Hu, {
                            omit: [
                                "posMatrix"
                            ]
                        });
                        var Zu = function(t1, e1, r) {
                            if (this.uid = t1, e1.height !== e1.width) throw new RangeError("DEM tiles must be square");
                            if (r && "mapbox" !== r && "terrarium" !== r) return k('"' + r + '" is not a valid encoding type. Valid types include "mapbox" and "terrarium".');
                            this.stride = e1.height;
                            var n = this.dim = e1.height - 2;
                            this.data = new Uint32Array(e1.data.buffer), this.encoding = r || "mapbox";
                            for(var i = 0; i < n; i++)this.data[this._idx(-1, i)] = this.data[this._idx(0, i)], this.data[this._idx(n, i)] = this.data[this._idx(n - 1, i)], this.data[this._idx(i, -1)] = this.data[this._idx(i, 0)], this.data[this._idx(i, n)] = this.data[this._idx(i, n - 1)];
                            this.data[this._idx(-1, -1)] = this.data[this._idx(0, 0)], this.data[this._idx(n, -1)] = this.data[this._idx(n - 1, 0)], this.data[this._idx(-1, n)] = this.data[this._idx(0, n - 1)], this.data[this._idx(n, n)] = this.data[this._idx(n - 1, n - 1)];
                        };
                        Zu.prototype.get = function(t1, e1) {
                            var r = new Uint8Array(this.data.buffer), n = 4 * this._idx(t1, e1);
                            return ("terrarium" === this.encoding ? this._unpackTerrarium : this._unpackMapbox)(r[n], r[n + 1], r[n + 2]);
                        }, Zu.prototype.getUnpackVector = function() {
                            return "terrarium" === this.encoding ? [
                                256,
                                1,
                                1 / 256,
                                32768
                            ] : [
                                6553.6,
                                25.6,
                                .1,
                                1e4
                            ];
                        }, Zu.prototype._idx = function(t1, e1) {
                            if (t1 < -1 || t1 >= this.dim + 1 || e1 < -1 || e1 >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
                            return (e1 + 1) * this.stride + (t1 + 1);
                        }, Zu.prototype._unpackMapbox = function(t1, e1, r) {
                            return (256 * t1 * 256 + 256 * e1 + r) / 10 - 1e4;
                        }, Zu.prototype._unpackTerrarium = function(t1, e1, r) {
                            return 256 * t1 + e1 + r / 256 - 32768;
                        }, Zu.prototype.getPixels = function() {
                            return new Ko({
                                width: this.stride,
                                height: this.stride
                            }, new Uint8Array(this.data.buffer));
                        }, Zu.prototype.backfillBorder = function(t1, e1, r) {
                            if (this.dim !== t1.dim) throw new Error("dem dimension mismatch");
                            var n = e1 * this.dim, i = e1 * this.dim + this.dim, a = r * this.dim, o = r * this.dim + this.dim;
                            switch(e1){
                                case -1:
                                    n = i - 1;
                                    break;
                                case 1:
                                    i = n + 1;
                            }
                            switch(r){
                                case -1:
                                    a = o - 1;
                                    break;
                                case 1:
                                    o = a + 1;
                            }
                            for(var s = -e1 * this.dim, l = -r * this.dim, c = a; c < o; c++)for(var u = n; u < i; u++)this.data[this._idx(u, c)] = t1.data[this._idx(u + s, c + l)];
                        }, oi("DEMData", Zu);
                        var Wu = function(t1) {
                            this._stringToNumber = {}, this._numberToString = [];
                            for(var e1 = 0; e1 < t1.length; e1++){
                                var r = t1[e1];
                                this._stringToNumber[r] = e1, this._numberToString[e1] = r;
                            }
                        };
                        Wu.prototype.encode = function(t1) {
                            return this._stringToNumber[t1];
                        }, Wu.prototype.decode = function(t1) {
                            return this._numberToString[t1];
                        };
                        var Yu = function(t1, e1, r, n, i) {
                            this.type = "Feature", this._vectorTileFeature = t1, t1._z = e1, t1._x = r, t1._y = n, this.properties = t1.properties, this.id = i;
                        }, Xu = {
                            geometry: {
                                configurable: !0
                            }
                        };
                        Xu.geometry.get = function() {
                            return void 0 === this._geometry && (this._geometry = this._vectorTileFeature.toGeoJSON(this._vectorTileFeature._x, this._vectorTileFeature._y, this._vectorTileFeature._z).geometry), this._geometry;
                        }, Xu.geometry.set = function(t1) {
                            this._geometry = t1;
                        }, Yu.prototype.toJSON = function() {
                            var t1 = {
                                geometry: this.geometry
                            };
                            for(var e1 in this)"_geometry" !== e1 && "_vectorTileFeature" !== e1 && (t1[e1] = this[e1]);
                            return t1;
                        }, Object.defineProperties(Yu.prototype, Xu);
                        var $u = function() {
                            this.state = {}, this.stateChanges = {}, this.deletedStates = {};
                        };
                        $u.prototype.updateState = function(t1, e1, r) {
                            var n = String(e1);
                            if (this.stateChanges[t1] = this.stateChanges[t1] || {}, this.stateChanges[t1][n] = this.stateChanges[t1][n] || {}, p(this.stateChanges[t1][n], r), null === this.deletedStates[t1]) for(var i in this.deletedStates[t1] = {}, this.state[t1])i !== n && (this.deletedStates[t1][i] = null);
                            else if (this.deletedStates[t1] && null === this.deletedStates[t1][n]) for(var a in this.deletedStates[t1][n] = {}, this.state[t1][n])r[a] || (this.deletedStates[t1][n][a] = null);
                            else for(var o in r)this.deletedStates[t1] && this.deletedStates[t1][n] && null === this.deletedStates[t1][n][o] && delete this.deletedStates[t1][n][o];
                        }, $u.prototype.removeFeatureState = function(t1, e1, r) {
                            if (null !== this.deletedStates[t1]) {
                                var n = String(e1);
                                if (this.deletedStates[t1] = this.deletedStates[t1] || {}, r && void 0 !== e1) null !== this.deletedStates[t1][n] && (this.deletedStates[t1][n] = this.deletedStates[t1][n] || {}, this.deletedStates[t1][n][r] = null);
                                else if (void 0 !== e1) {
                                    if (this.stateChanges[t1] && this.stateChanges[t1][n]) for(r in this.deletedStates[t1][n] = {}, this.stateChanges[t1][n])this.deletedStates[t1][n][r] = null;
                                    else this.deletedStates[t1][n] = null;
                                } else this.deletedStates[t1] = null;
                            }
                        }, $u.prototype.getState = function(t1, e1) {
                            var r = String(e1), n = this.state[t1] || {}, i = this.stateChanges[t1] || {}, a = p({}, n[r], i[r]);
                            if (null === this.deletedStates[t1]) return {};
                            if (this.deletedStates[t1]) {
                                var o = this.deletedStates[t1][e1];
                                if (null === o) return {};
                                for(var s in o)delete a[s];
                            }
                            return a;
                        }, $u.prototype.initializeTileState = function(t1, e1) {
                            t1.setFeatureState(this.state, e1);
                        }, $u.prototype.coalesceChanges = function(t1, e1) {
                            var r = {};
                            for(var n in this.stateChanges){
                                this.state[n] = this.state[n] || {};
                                var i = {};
                                for(var a in this.stateChanges[n])this.state[n][a] || (this.state[n][a] = {}), p(this.state[n][a], this.stateChanges[n][a]), i[a] = this.state[n][a];
                                r[n] = i;
                            }
                            for(var o in this.deletedStates){
                                this.state[o] = this.state[o] || {};
                                var s = {};
                                if (null === this.deletedStates[o]) for(var l in this.state[o])s[l] = {}, this.state[o][l] = {};
                                else for(var c in this.deletedStates[o]){
                                    if (null === this.deletedStates[o][c]) this.state[o][c] = {};
                                    else for(var u = 0, h = Object.keys(this.deletedStates[o][c]); u < h.length; u += 1){
                                        var f = h[u];
                                        delete this.state[o][c][f];
                                    }
                                    s[c] = this.state[o][c];
                                }
                                r[o] = r[o] || {}, p(r[o], s);
                            }
                            if (this.stateChanges = {}, this.deletedStates = {}, 0 !== Object.keys(r).length) for(var d in t1)t1[d].setFeatureState(r, e1);
                        };
                        var Ju = function(t1, e1) {
                            this.tileID = t1, this.x = t1.canonical.x, this.y = t1.canonical.y, this.z = t1.canonical.z, this.grid = new ti(po, 16, 0), this.grid3D = new ti(po, 16, 0), this.featureIndexArray = new za, this.promoteId = e1;
                        };
                        function Ku(t1, e1, r, n, i) {
                            return _(t1, function(t1, a) {
                                var o = e1 instanceof Vi ? e1.get(a) : null;
                                return o && o.evaluate ? o.evaluate(r, n, i) : o;
                            });
                        }
                        function Qu(t1) {
                            for(var e1 = 1 / 0, r = 1 / 0, n = -1 / 0, i = -1 / 0, a = 0, o = t1; a < o.length; a += 1){
                                var s = o[a];
                                e1 = Math.min(e1, s.x), r = Math.min(r, s.y), n = Math.max(n, s.x), i = Math.max(i, s.y);
                            }
                            return {
                                minX: e1,
                                minY: r,
                                maxX: n,
                                maxY: i
                            };
                        }
                        function th(t1, e1) {
                            return e1 - t1;
                        }
                        Ju.prototype.insert = function(t1, e1, r, n, i, a) {
                            var o = this.featureIndexArray.length;
                            this.featureIndexArray.emplaceBack(r, n, i);
                            for(var s = a ? this.grid3D : this.grid, l = 0; l < e1.length; l++){
                                for(var c = e1[l], u = [
                                    1 / 0,
                                    1 / 0,
                                    -1 / 0,
                                    -1 / 0
                                ], h = 0; h < c.length; h++){
                                    var f = c[h];
                                    u[0] = Math.min(u[0], f.x), u[1] = Math.min(u[1], f.y), u[2] = Math.max(u[2], f.x), u[3] = Math.max(u[3], f.y);
                                }
                                u[0] < po && u[1] < po && u[2] >= 0 && u[3] >= 0 && s.insert(o, u[0], u[1], u[2], u[3]);
                            }
                        }, Ju.prototype.loadVTLayers = function() {
                            return this.vtLayers || (this.vtLayers = new tl.VectorTile(new Pl(this.rawTileData)).layers, this.sourceLayerCoder = new Wu(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                                "_geojsonTileLayer"
                            ])), this.vtLayers;
                        }, Ju.prototype.query = function(t1, e1, r, n) {
                            var i = this;
                            this.loadVTLayers();
                            for(var o = t1.params || {}, s = po / t1.tileSize / t1.scale, l = An(o.filter), c = t1.queryGeometry, u = t1.queryPadding * s, h = Qu(c), f = this.grid.query(h.minX - u, h.minY - u, h.maxX + u, h.maxY + u), p = Qu(t1.cameraQueryGeometry), d = 0, m = this.grid3D.query(p.minX - u, p.minY - u, p.maxX + u, p.maxY + u, function(e1, r, n, i) {
                                return function(t1, e1, r, n, i) {
                                    for(var o = 0, s = t1; o < s.length; o += 1){
                                        var l = s[o];
                                        if (e1 <= l.x && r <= l.y && n >= l.x && i >= l.y) return !0;
                                    }
                                    var c = [
                                        new a(e1, r),
                                        new a(e1, i),
                                        new a(n, i),
                                        new a(n, r)
                                    ];
                                    if (t1.length > 2) {
                                        for(var u = 0, h = c; u < h.length; u += 1)if (Lo(t1, h[u])) return !0;
                                    }
                                    for(var f = 0; f < t1.length - 1; f++)if (Io(t1[f], t1[f + 1], c)) return !0;
                                    return !1;
                                }(t1.cameraQueryGeometry, e1 - u, r - u, n + u, i + u);
                            }); d < m.length; d += 1){
                                var g = m[d];
                                f.push(g);
                            }
                            f.sort(th);
                            for(var y, v = {}, x = function(a) {
                                var u = f[a];
                                if (u !== y) {
                                    y = u;
                                    var h = i.featureIndexArray.get(u), p = null;
                                    i.loadMatchingFeature(v, h.bucketIndex, h.sourceLayerIndex, h.featureIndex, l, o.layers, o.availableImages, e1, r, n, function(e1, r, n) {
                                        return p || (p = yo(e1)), r.queryIntersectsFeature(c, e1, n, p, i.z, t1.transform, s, t1.pixelPosMatrix);
                                    });
                                }
                            }, _ = 0; _ < f.length; _++)x(_);
                            return v;
                        }, Ju.prototype.loadMatchingFeature = function(t1, e1, r, n, i, a, o, s, l, c, u) {
                            var h = this.bucketLayerIDs[e1];
                            if (!a || function(t1, e1) {
                                for(var r = 0; r < t1.length; r++)if (e1.indexOf(t1[r]) >= 0) return !0;
                                return !1;
                            }(a, h)) {
                                var f = this.sourceLayerCoder.decode(r), d = this.vtLayers[f].feature(n);
                                if (i.needGeometry) {
                                    var m = vo(d, !0);
                                    if (!i.filter(new Oi(this.tileID.overscaledZ), m, this.tileID.canonical)) return;
                                } else if (!i.filter(new Oi(this.tileID.overscaledZ), d)) return;
                                for(var g = this.getId(d, f), y = 0; y < h.length; y++){
                                    var v = h[y];
                                    if (!(a && a.indexOf(v) < 0)) {
                                        var x = s[v];
                                        if (x) {
                                            var _ = {};
                                            void 0 !== g && c && (_ = c.getState(x.sourceLayer || "_geojsonTileLayer", g));
                                            var b = p({}, l[v]);
                                            b.paint = Ku(b.paint, x.paint, d, _, o), b.layout = Ku(b.layout, x.layout, d, _, o);
                                            var w = !u || u(d, x, _);
                                            if (w) {
                                                var T = new Yu(d, this.z, this.x, this.y, g);
                                                T.layer = b;
                                                var k = t1[v];
                                                void 0 === k && (k = t1[v] = []), k.push({
                                                    featureIndex: n,
                                                    feature: T,
                                                    intersectionZ: w
                                                });
                                            }
                                        }
                                    }
                                }
                            }
                        }, Ju.prototype.lookupSymbolFeatures = function(t1, e1, r, n, i, a, o, s) {
                            var l = {};
                            this.loadVTLayers();
                            for(var c = An(i), u = 0, h = t1; u < h.length; u += 1){
                                var f = h[u];
                                this.loadMatchingFeature(l, r, n, f, c, a, o, s, e1);
                            }
                            return l;
                        }, Ju.prototype.hasLayer = function(t1) {
                            for(var e1 = 0, r = this.bucketLayerIDs; e1 < r.length; e1 += 1)for(var n = 0, i = r[e1]; n < i.length; n += 1)if (t1 === i[n]) return !0;
                            return !1;
                        }, Ju.prototype.getId = function(t1, e1) {
                            var r = t1.id;
                            if (this.promoteId) {
                                var n = "string" == typeof this.promoteId ? this.promoteId : this.promoteId[e1];
                                "boolean" == typeof (r = t1.properties[n]) && (r = Number(r));
                            }
                            return r;
                        }, oi("FeatureIndex", Ju, {
                            omit: [
                                "rawTileData",
                                "sourceLayerCoder"
                            ]
                        });
                        var eh = function(t1, e1) {
                            this.tileID = t1, this.uid = m(), this.uses = 0, this.tileSize = e1, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.expiredRequestCount = 0, this.state = "loading";
                        };
                        eh.prototype.registerFadeDuration = function(t1) {
                            var e1 = t1 + this.timeAdded;
                            e1 < N.now() || this.fadeEndTime && e1 < this.fadeEndTime || (this.fadeEndTime = e1);
                        }, eh.prototype.wasRequested = function() {
                            return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
                        }, eh.prototype.loadVectorData = function(t1, e1, r) {
                            if (this.hasData() && this.unloadVectorData(), this.state = "loaded", t1) {
                                for(var n in t1.featureIndex && (this.latestFeatureIndex = t1.featureIndex, t1.rawTileData ? (this.latestRawTileData = t1.rawTileData, this.latestFeatureIndex.rawTileData = t1.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = t1.collisionBoxArray, this.buckets = function(t1, e1) {
                                    var r = {};
                                    if (!e1) return r;
                                    for(var n = function() {
                                        var t1 = a[i], n = t1.layerIds.map(function(t1) {
                                            return e1.getLayer(t1);
                                        }).filter(Boolean);
                                        if (0 !== n.length) {
                                            t1.layers = n, t1.stateDependentLayerIds && (t1.stateDependentLayers = t1.stateDependentLayerIds.map(function(t1) {
                                                return n.filter(function(e1) {
                                                    return e1.id === t1;
                                                })[0];
                                            }));
                                            for(var o = 0, s = n; o < s.length; o += 1){
                                                var l = s[o];
                                                r[l.id] = t1;
                                            }
                                        }
                                    }, i = 0, a = t1; i < a.length; i += 1)n();
                                    return r;
                                }(t1.buckets, e1.style), this.hasSymbolBuckets = !1, this.buckets){
                                    var i = this.buckets[n];
                                    if (i instanceof fu) {
                                        if (this.hasSymbolBuckets = !0, !r) break;
                                        i.justReloaded = !0;
                                    }
                                }
                                if (this.hasRTLText = !1, this.hasSymbolBuckets) for(var a in this.buckets){
                                    var o = this.buckets[a];
                                    if (o instanceof fu && o.hasRTLText) {
                                        this.hasRTLText = !0, zi.isLoading() || zi.isLoaded() || "deferred" !== Ii() || Pi();
                                        break;
                                    }
                                }
                                for(var s in this.queryPadding = 0, this.buckets){
                                    var l = this.buckets[s];
                                    this.queryPadding = Math.max(this.queryPadding, e1.style.getLayer(s).queryRadius(l));
                                }
                                t1.imageAtlas && (this.imageAtlas = t1.imageAtlas), t1.glyphAtlasImage && (this.glyphAtlasImage = t1.glyphAtlasImage);
                            } else this.collisionBoxArray = new Aa;
                        }, eh.prototype.unloadVectorData = function() {
                            for(var t1 in this.buckets)this.buckets[t1].destroy();
                            this.buckets = {}, this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.imageAtlas && (this.imageAtlas = null), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.latestFeatureIndex = null, this.state = "unloaded";
                        }, eh.prototype.getBucket = function(t1) {
                            return this.buckets[t1.id];
                        }, eh.prototype.upload = function(t1) {
                            for(var e1 in this.buckets){
                                var r = this.buckets[e1];
                                r.uploadPending() && r.upload(t1);
                            }
                            var n = t1.gl;
                            this.imageAtlas && !this.imageAtlas.uploaded && (this.imageAtlasTexture = new Eu(t1, this.imageAtlas.image, n.RGBA), this.imageAtlas.uploaded = !0), this.glyphAtlasImage && (this.glyphAtlasTexture = new Eu(t1, this.glyphAtlasImage, n.ALPHA), this.glyphAtlasImage = null);
                        }, eh.prototype.prepare = function(t1) {
                            this.imageAtlas && this.imageAtlas.patchUpdatedImages(t1, this.imageAtlasTexture);
                        }, eh.prototype.queryRenderedFeatures = function(t1, e1, r, n, i, a, o, s, l, c) {
                            return this.latestFeatureIndex && this.latestFeatureIndex.rawTileData ? this.latestFeatureIndex.query({
                                queryGeometry: n,
                                cameraQueryGeometry: i,
                                scale: a,
                                tileSize: this.tileSize,
                                pixelPosMatrix: c,
                                transform: s,
                                params: o,
                                queryPadding: this.queryPadding * l
                            }, t1, e1, r) : {};
                        }, eh.prototype.querySourceFeatures = function(t1, e1) {
                            var r = this.latestFeatureIndex;
                            if (r && r.rawTileData) {
                                var n = r.loadVTLayers(), i = e1 ? e1.sourceLayer : "", a = n._geojsonTileLayer || n[i];
                                if (a) for(var o = An(e1 && e1.filter), s = this.tileID.canonical, l = s.z, c = s.x, u = s.y, h = {
                                    z: l,
                                    x: c,
                                    y: u
                                }, f = 0; f < a.length; f++){
                                    var p = a.feature(f);
                                    if (o.needGeometry) {
                                        var d = vo(p, !0);
                                        if (!o.filter(new Oi(this.tileID.overscaledZ), d, this.tileID.canonical)) continue;
                                    } else if (!o.filter(new Oi(this.tileID.overscaledZ), p)) continue;
                                    var m = r.getId(p, i), g = new Yu(p, l, c, u, m);
                                    g.tile = h, t1.push(g);
                                }
                            }
                        }, eh.prototype.hasData = function() {
                            return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
                        }, eh.prototype.patternsLoaded = function() {
                            return this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
                        }, eh.prototype.setExpiryData = function(t1) {
                            var e1 = this.expirationTime;
                            if (t1.cacheControl) {
                                var r = E(t1.cacheControl);
                                r["max-age"] && (this.expirationTime = Date.now() + 1e3 * r["max-age"]);
                            } else t1.expires && (this.expirationTime = new Date(t1.expires).getTime());
                            if (this.expirationTime) {
                                var n = Date.now(), i = !1;
                                if (this.expirationTime > n) i = !1;
                                else if (e1) {
                                    if (this.expirationTime < e1) i = !0;
                                    else {
                                        var a = this.expirationTime - e1;
                                        a ? this.expirationTime = n + Math.max(a, 3e4) : i = !0;
                                    }
                                } else i = !0;
                                i ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
                            }
                        }, eh.prototype.getExpiryTimeout = function() {
                            if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (new Date).getTime(), Math.pow(2, 31) - 1);
                        }, eh.prototype.setFeatureState = function(t1, e1) {
                            if (this.latestFeatureIndex && this.latestFeatureIndex.rawTileData && 0 !== Object.keys(t1).length) {
                                var r = this.latestFeatureIndex.loadVTLayers();
                                for(var n in this.buckets)if (e1.style.hasLayer(n)) {
                                    var i = this.buckets[n], a = i.layers[0].sourceLayer || "_geojsonTileLayer", o = r[a], s = t1[a];
                                    if (o && s && 0 !== Object.keys(s).length) {
                                        i.update(s, o, this.imageAtlas && this.imageAtlas.patternPositions || {});
                                        var l = e1 && e1.style && e1.style.getLayer(n);
                                        l && (this.queryPadding = Math.max(this.queryPadding, l.queryRadius(i)));
                                    }
                                }
                            }
                        }, eh.prototype.holdingForFade = function() {
                            return void 0 !== this.symbolFadeHoldUntil;
                        }, eh.prototype.symbolFadeFinished = function() {
                            return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < N.now();
                        }, eh.prototype.clearFadeHold = function() {
                            this.symbolFadeHoldUntil = void 0;
                        }, eh.prototype.setHoldDuration = function(t1) {
                            this.symbolFadeHoldUntil = N.now() + t1;
                        }, eh.prototype.setDependencies = function(t1, e1) {
                            for(var r = {}, n = 0, i = e1; n < i.length; n += 1)r[i[n]] = !0;
                            this.dependencies[t1] = r;
                        }, eh.prototype.hasDependency = function(t1, e1) {
                            for(var r = 0, n = t1; r < n.length; r += 1){
                                var i = n[r], a = this.dependencies[i];
                                if (a) {
                                    for(var o = 0, s = e1; o < s.length; o += 1)if (a[s[o]]) return !0;
                                }
                            }
                            return !1;
                        };
                        var rh = s.performance, nh = function(t1) {
                            this._marks = {
                                start: [
                                    t1.url,
                                    "start"
                                ].join("#"),
                                end: [
                                    t1.url,
                                    "end"
                                ].join("#"),
                                measure: t1.url.toString()
                            }, rh.mark(this._marks.start);
                        };
                        nh.prototype.finish = function() {
                            rh.mark(this._marks.end);
                            var t1 = rh.getEntriesByName(this._marks.measure);
                            return 0 === t1.length && (rh.measure(this._marks.measure, this._marks.start, this._marks.end), t1 = rh.getEntriesByName(this._marks.measure), rh.clearMarks(this._marks.start), rh.clearMarks(this._marks.end), rh.clearMeasures(this._marks.measure)), t1;
                        }, t1.Actor = Lu, t1.AlphaImage = Jo, t1.CanonicalTileID = Vu, t1.CollisionBoxArray = Aa, t1.Color = ce, t1.DEMData = Zu, t1.DataConstantProperty = qi, t1.DictionaryCoder = Wu, t1.EXTENT = po, t1.ErrorEvent = Dt, t1.EvaluationParameters = Oi, t1.Event = Ot, t1.Evented = Rt, t1.FeatureIndex = Ju, t1.FillBucket = Us, t1.FillExtrusionBucket = il, t1.ImageAtlas = sc, t1.ImagePosition = ac, t1.LineBucket = ml, t1.LngLat = Ou, t1.LngLatBounds = Pu, t1.MercatorCoordinate = Uu, t1.ONE_EM = Cl, t1.OverscaledTileID = Hu, t1.Point = a, t1.Point$1 = a, t1.Properties = Yi, t1.Protobuf = Pl, t1.RGBAImage = Ko, t1.RequestManager = Z, t1.RequestPerformance = nh, t1.ResourceType = bt, t1.SegmentVector = Da, t1.SourceFeatureState = $u, t1.StructArrayLayout1ui2 = wa, t1.StructArrayLayout2f1f2i16 = pa, t1.StructArrayLayout2i4 = ra, t1.StructArrayLayout3ui6 = ma, t1.StructArrayLayout4i8 = na, t1.SymbolBucket = fu, t1.Texture = Eu, t1.Tile = eh, t1.Transitionable = Fi, t1.Uniform1f = $a, t1.Uniform1i = Xa, t1.Uniform2f = Ja, t1.Uniform3f = Ka, t1.Uniform4f = Qa, t1.UniformColor = to, t1.UniformMatrix4f = ro, t1.UnwrappedTileID = qu, t1.ValidationError = Bt, t1.WritingMode = lc, t1.ZoomHistory = fi, t1.add = function(t1, e1, r) {
                            return t1[0] = e1[0] + r[0], t1[1] = e1[1] + r[1], t1[2] = e1[2] + r[2], t1;
                        }, t1.addDynamicAttributes = lu, t1.asyncAll = function(t1, e1, r) {
                            if (!t1.length) return r(null, []);
                            var n = t1.length, i = new Array(t1.length), a = null;
                            t1.forEach(function(t1, o) {
                                e1(t1, function(t1, e1) {
                                    t1 && (a = t1), i[o] = e1, 0 == --n && r(a, i);
                                });
                            });
                        }, t1.bezier = c, t1.bindAll = v, t1.browser = N, t1.cacheEntryPossiblyAdded = function(t1) {
                            ++xt > ft && (t1.getActor().send("enforceCacheSizeLimit", ht), xt = 0);
                        }, t1.clamp = h, t1.clearTileCache = function(t1) {
                            var e1 = s.caches.delete(ut);
                            t1 && e1.catch(t1).then(function() {
                                return t1();
                            });
                        }, t1.clipLine = Fc, t1.clone = function(t1) {
                            var e1 = new Fo(16);
                            return e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1[3] = t1[3], e1[4] = t1[4], e1[5] = t1[5], e1[6] = t1[6], e1[7] = t1[7], e1[8] = t1[8], e1[9] = t1[9], e1[10] = t1[10], e1[11] = t1[11], e1[12] = t1[12], e1[13] = t1[13], e1[14] = t1[14], e1[15] = t1[15], e1;
                        }, t1.clone$1 = w, t1.clone$2 = function(t1) {
                            var e1 = new Fo(3);
                            return e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1;
                        }, t1.collisionCircleLayout = Ml, t1.config = j, t1.create = function() {
                            var t1 = new Fo(16);
                            return Fo != Float32Array && (t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0), t1[0] = 1, t1[5] = 1, t1[10] = 1, t1[15] = 1, t1;
                        }, t1.create$1 = function() {
                            var t1 = new Fo(9);
                            return Fo != Float32Array && (t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[5] = 0, t1[6] = 0, t1[7] = 0), t1[0] = 1, t1[4] = 1, t1[8] = 1, t1;
                        }, t1.create$2 = function() {
                            var t1 = new Fo(4);
                            return Fo != Float32Array && (t1[1] = 0, t1[2] = 0), t1[0] = 1, t1[3] = 1, t1;
                        }, t1.createCommonjsModule = e1, t1.createExpression = hn, t1.createLayout = ta, t1.createStyleLayer = function(t1) {
                            return "custom" === t1.type ? new bu(t1) : new wu[t1.type](t1);
                        }, t1.cross = function(t1, e1, r) {
                            var n = e1[0], i = e1[1], a = e1[2], o = r[0], s = r[1], l = r[2];
                            return t1[0] = i * l - a * s, t1[1] = a * o - n * l, t1[2] = n * s - i * o, t1;
                        }, t1.deepEqual = function t1(e1, r) {
                            if (Array.isArray(e1)) {
                                if (!Array.isArray(r) || e1.length !== r.length) return !1;
                                for(var n = 0; n < e1.length; n++)if (!t1(e1[n], r[n])) return !1;
                                return !0;
                            }
                            if ("object" == typeof e1 && null !== e1 && null !== r) {
                                if ("object" != typeof r) return !1;
                                if (Object.keys(e1).length !== Object.keys(r).length) return !1;
                                for(var i in e1)if (!t1(e1[i], r[i])) return !1;
                                return !0;
                            }
                            return e1 === r;
                        }, t1.dot = function(t1, e1) {
                            return t1[0] * e1[0] + t1[1] * e1[1] + t1[2] * e1[2];
                        }, t1.dot$1 = function(t1, e1) {
                            return t1[0] * e1[0] + t1[1] * e1[1] + t1[2] * e1[2] + t1[3] * e1[3];
                        }, t1.ease = u, t1.emitValidationErrors = Qn, t1.endsWith = x, t1.enforceCacheSizeLimit = function(t1) {
                            dt(), rt && rt.then(function(e1) {
                                e1.keys().then(function(r) {
                                    for(var n = 0; n < r.length - t1; n++)e1.delete(r[n]);
                                });
                            });
                        }, t1.evaluateSizeForFeature = Sc, t1.evaluateSizeForZoom = Ec, t1.evaluateVariableOffset = Kc, t1.evented = Li, t1.extend = p, t1.featureFilter = An, t1.filterObject = b, t1.fromRotation = function(t1, e1) {
                            var r = Math.sin(e1), n = Math.cos(e1);
                            return t1[0] = n, t1[1] = r, t1[2] = 0, t1[3] = -r, t1[4] = n, t1[5] = 0, t1[6] = 0, t1[7] = 0, t1[8] = 1, t1;
                        }, t1.getAnchorAlignment = bc, t1.getAnchorJustification = Qc, t1.getArrayBuffer = Mt, t1.getImage = It, t1.getJSON = function(t1, e1) {
                            return At(p(t1, {
                                type: "json"
                            }), e1);
                        }, t1.getRTLTextPluginStatus = Ii, t1.getReferrer = Tt, t1.getVideo = function(t1, e1) {
                            var r, n, i = s.document.createElement("video");
                            i.muted = !0, i.onloadstart = function() {
                                e1(null, i);
                            };
                            for(var a = 0; a < t1.length; a++){
                                var o = s.document.createElement("source");
                                r = t1[a], n = void 0, (n = s.document.createElement("a")).href = r, n.protocol === s.document.location.protocol && n.host === s.document.location.host || (i.crossOrigin = "Anonymous"), o.src = t1[a], i.appendChild(o);
                            }
                            return {
                                cancel: function() {}
                            };
                        }, t1.identity = Bo, t1.invert = function(t1, e1) {
                            var r = e1[0], n = e1[1], i = e1[2], a = e1[3], o = e1[4], s = e1[5], l = e1[6], c = e1[7], u = e1[8], h = e1[9], f = e1[10], p = e1[11], d = e1[12], m = e1[13], g = e1[14], y = e1[15], v = r * s - n * o, x = r * l - i * o, _ = r * c - a * o, b = n * l - i * s, w = n * c - a * s, T = i * c - a * l, k = u * m - h * d, A = u * g - f * d, M = u * y - p * d, S = h * g - f * m, E = h * y - p * m, C = f * y - p * g, L = v * C - x * E + _ * S + b * M - w * A + T * k;
                            return L ? (L = 1 / L, t1[0] = (s * C - l * E + c * S) * L, t1[1] = (i * E - n * C - a * S) * L, t1[2] = (m * T - g * w + y * b) * L, t1[3] = (f * w - h * T - p * b) * L, t1[4] = (l * M - o * C - c * A) * L, t1[5] = (r * C - i * M + a * A) * L, t1[6] = (g * _ - d * T - y * x) * L, t1[7] = (u * T - f * _ + p * x) * L, t1[8] = (o * E - s * M + c * k) * L, t1[9] = (n * M - r * E - a * k) * L, t1[10] = (d * w - m * _ + y * v) * L, t1[11] = (h * _ - u * w - p * v) * L, t1[12] = (s * A - o * S - l * k) * L, t1[13] = (r * S - n * A + i * k) * L, t1[14] = (m * x - d * b - g * v) * L, t1[15] = (u * b - h * x + f * v) * L, t1) : null;
                        }, t1.isChar = pi, t1.isMapboxURL = W, t1.keysDifference = function(t1, e1) {
                            var r = [];
                            for(var n in t1)n in e1 || r.push(n);
                            return r;
                        }, t1.makeRequest = At, t1.mapObject = _, t1.mercatorXfromLng = Fu, t1.mercatorYfromLat = Bu, t1.mercatorZfromAltitude = Nu, t1.mul = jo, t1.multiply = No, t1.mvt = tl, t1.nextPowerOfTwo = function(t1) {
                            return t1 <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(t1) / Math.LN2));
                        }, t1.normalize = function(t1, e1) {
                            var r = e1[0], n = e1[1], i = e1[2], a = r * r + n * n + i * i;
                            return a > 0 && (a = 1 / Math.sqrt(a)), t1[0] = e1[0] * a, t1[1] = e1[1] * a, t1[2] = e1[2] * a, t1;
                        }, t1.number = er, t1.offscreenCanvasSupported = _t, t1.ortho = function(t1, e1, r, n, i, a, o) {
                            var s = 1 / (e1 - r), l = 1 / (n - i), c = 1 / (a - o);
                            return t1[0] = -2 * s, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = -2 * l, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 2 * c, t1[11] = 0, t1[12] = (e1 + r) * s, t1[13] = (i + n) * l, t1[14] = (o + a) * c, t1[15] = 1, t1;
                        }, t1.parseGlyphPBF = function(t1) {
                            return new Pl(t1).readFields(Ql, []);
                        }, t1.pbf = Pl, t1.performSymbolLayout = function(t1, e1, r, n, i, a, o) {
                            t1.createArrays();
                            var s = 512 * t1.overscaling;
                            t1.tilePixelRatio = po / s, t1.compareText = {}, t1.iconsNeedLinear = !1;
                            var l = t1.layers[0].layout, c = t1.layers[0]._unevaluatedLayout._values, u = {};
                            if ("composite" === t1.textSizeData.kind) {
                                var h = t1.textSizeData, f = h.minZoom, p = h.maxZoom;
                                u.compositeTextSizes = [
                                    c["text-size"].possiblyEvaluate(new Oi(f), o),
                                    c["text-size"].possiblyEvaluate(new Oi(p), o)
                                ];
                            }
                            if ("composite" === t1.iconSizeData.kind) {
                                var d = t1.iconSizeData, m = d.minZoom, g = d.maxZoom;
                                u.compositeIconSizes = [
                                    c["icon-size"].possiblyEvaluate(new Oi(m), o),
                                    c["icon-size"].possiblyEvaluate(new Oi(g), o)
                                ];
                            }
                            u.layoutTextSize = c["text-size"].possiblyEvaluate(new Oi(t1.zoom + 1), o), u.layoutIconSize = c["icon-size"].possiblyEvaluate(new Oi(t1.zoom + 1), o), u.textMaxSize = c["text-size"].possiblyEvaluate(new Oi(18));
                            for(var y = l.get("text-line-height") * Cl, v = "map" === l.get("text-rotation-alignment") && "point" !== l.get("symbol-placement"), x = l.get("text-keep-upright"), _ = l.get("text-size"), b = function() {
                                var a = T[w], s = l.get("text-font").evaluate(a, {}, o).join(","), c = _.evaluate(a, {}, o), h = u.layoutTextSize.evaluate(a, {}, o), f = u.layoutIconSize.evaluate(a, {}, o), p = {
                                    horizontal: {},
                                    vertical: void 0
                                }, d = a.text, m = [
                                    0,
                                    0
                                ];
                                if (d) {
                                    var g = d.toString(), b = l.get("text-letter-spacing").evaluate(a, {}, o) * Cl, A = function(t1) {
                                        for(var e1 = 0, r = t1; e1 < r.length; e1 += 1)if (n = r[e1].charCodeAt(0), pi.Arabic(n) || pi["Arabic Supplement"](n) || pi["Arabic Extended-A"](n) || pi["Arabic Presentation Forms-A"](n) || pi["Arabic Presentation Forms-B"](n)) return !1;
                                        var n;
                                        return !0;
                                    }(g) ? b : 0, M = l.get("text-anchor").evaluate(a, {}, o), S = l.get("text-variable-anchor");
                                    if (!S) {
                                        var E = l.get("text-radial-offset").evaluate(a, {}, o);
                                        m = E ? Kc(M, [
                                            E * Cl,
                                            Jc
                                        ]) : l.get("text-offset").evaluate(a, {}, o).map(function(t1) {
                                            return t1 * Cl;
                                        });
                                    }
                                    var C = v ? "center" : l.get("text-justify").evaluate(a, {}, o), L = l.get("symbol-placement"), I = "point" === L ? l.get("text-max-width").evaluate(a, {}, o) * Cl : 0, P = function() {
                                        t1.allowVerticalPlacement && di(g) && (p.vertical = fc(d, e1, r, i, s, I, y, M, "left", A, m, lc.vertical, !0, L, h, c));
                                    };
                                    if (!v && S) {
                                        for(var z = "auto" === C ? S.map(function(t1) {
                                            return Qc(t1);
                                        }) : [
                                            C
                                        ], O = !1, D = 0; D < z.length; D++){
                                            var R = z[D];
                                            if (!p.horizontal[R]) {
                                                if (O) p.horizontal[R] = p.horizontal[0];
                                                else {
                                                    var F = fc(d, e1, r, i, s, I, y, "center", R, A, m, lc.horizontal, !1, L, h, c);
                                                    F && (p.horizontal[R] = F, O = 1 === F.positionedLines.length);
                                                }
                                            }
                                        }
                                        P();
                                    } else {
                                        "auto" === C && (C = Qc(M));
                                        var B = fc(d, e1, r, i, s, I, y, M, C, A, m, lc.horizontal, !1, L, h, c);
                                        B && (p.horizontal[C] = B), P(), di(g) && v && x && (p.vertical = fc(d, e1, r, i, s, I, y, M, C, A, m, lc.vertical, !1, L, h, c));
                                    }
                                }
                                var N = void 0, j = !1;
                                if (a.icon && a.icon.name) {
                                    var U = n[a.icon.name];
                                    U && (N = function(t1, e1, r) {
                                        var n = bc(r), i = n.horizontalAlign, a = n.verticalAlign, o = e1[0], s = e1[1], l = o - t1.displaySize[0] * i, c = l + t1.displaySize[0], u = s - t1.displaySize[1] * a;
                                        return {
                                            image: t1,
                                            top: u,
                                            bottom: u + t1.displaySize[1],
                                            left: l,
                                            right: c
                                        };
                                    }(i[a.icon.name], l.get("icon-offset").evaluate(a, {}, o), l.get("icon-anchor").evaluate(a, {}, o)), j = U.sdf, void 0 === t1.sdfIcons ? t1.sdfIcons = U.sdf : t1.sdfIcons !== U.sdf && k("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (U.pixelRatio !== t1.pixelRatio || 0 !== l.get("icon-rotate").constantOr(1)) && (t1.iconsNeedLinear = !0));
                                }
                                var V = nu(p.horizontal) || p.vertical;
                                t1.iconsInText = !!V && V.iconsInText, (V || N) && function(t1, e1, r, n, i, a, o, s, l, c, u) {
                                    var h = a.textMaxSize.evaluate(e1, {});
                                    void 0 === h && (h = o);
                                    var f, p = t1.layers[0].layout, d = p.get("icon-offset").evaluate(e1, {}, u), m = nu(r.horizontal), g = 24, y = o / g, v = t1.tilePixelRatio * y, x = t1.tilePixelRatio * h / g, _ = t1.tilePixelRatio * s, b = t1.tilePixelRatio * p.get("symbol-spacing"), w = p.get("text-padding") * t1.tilePixelRatio, T = p.get("icon-padding") * t1.tilePixelRatio, A = p.get("text-max-angle") / 180 * Math.PI, M = "map" === p.get("text-rotation-alignment") && "point" !== p.get("symbol-placement"), S = "map" === p.get("icon-rotation-alignment") && "point" !== p.get("symbol-placement"), E = p.get("symbol-placement"), C = b / 2, L = p.get("icon-text-fit");
                                    n && "none" !== L && (t1.allowVerticalPlacement && r.vertical && (f = Tc(n, r.vertical, L, p.get("icon-text-fit-padding"), d, y)), m && (n = Tc(n, m, L, p.get("icon-text-fit-padding"), d, y)));
                                    var I = function(s, h) {
                                        h.x < 0 || h.x >= po || h.y < 0 || h.y >= po || function(t1, e1, r, n, i, a, o, s, l, c, u, h, f, p, d, m, g, y, v, x, _, b, w, T, A) {
                                            var M, S, E, C, L, I = t1.addToLineVertexArray(e1, r), P = 0, z = 0, O = 0, D = 0, R = -1, F = -1, B = {}, N = ja(""), j = 0, U = 0;
                                            if (void 0 === s._unevaluatedLayout.getValue("text-radial-offset") ? (j = (M = s.layout.get("text-offset").evaluate(_, {}, T).map(function(t1) {
                                                return t1 * Cl;
                                            }))[0], U = M[1]) : (j = s.layout.get("text-radial-offset").evaluate(_, {}, T) * Cl, U = Jc), t1.allowVerticalPlacement && n.vertical) {
                                                var V = s.layout.get("text-rotate").evaluate(_, {}, T) + 90, q = n.vertical;
                                                C = new Hc(l, e1, c, u, h, q, f, p, d, V), o && (L = new Hc(l, e1, c, u, h, o, g, y, d, V));
                                            }
                                            if (i) {
                                                var H = s.layout.get("icon-rotate").evaluate(_, {}), G = "none" !== s.layout.get("icon-text-fit"), Z = Nc(i, H, w, G), W = o ? Nc(o, H, w, G) : void 0;
                                                E = new Hc(l, e1, c, u, h, i, g, y, !1, H), P = 4 * Z.length;
                                                var Y = t1.iconSizeData, X = null;
                                                "source" === Y.kind ? (X = [
                                                    Ac * s.layout.get("icon-size").evaluate(_, {})
                                                ])[0] > eu && k(t1.layerIds[0] + ': Value for "icon-size" is >= ' + tu + '. Reduce your "icon-size".') : "composite" === Y.kind && ((X = [
                                                    Ac * b.compositeIconSizes[0].evaluate(_, {}, T),
                                                    Ac * b.compositeIconSizes[1].evaluate(_, {}, T)
                                                ])[0] > eu || X[1] > eu) && k(t1.layerIds[0] + ': Value for "icon-size" is >= ' + tu + '. Reduce your "icon-size".'), t1.addSymbols(t1.icon, Z, X, x, v, _, !1, e1, I.lineStartIndex, I.lineLength, -1, T), R = t1.icon.placedSymbolArray.length - 1, W && (z = 4 * W.length, t1.addSymbols(t1.icon, W, X, x, v, _, lc.vertical, e1, I.lineStartIndex, I.lineLength, -1, T), F = t1.icon.placedSymbolArray.length - 1);
                                            }
                                            for(var $ in n.horizontal){
                                                var J = n.horizontal[$];
                                                if (!S) {
                                                    N = ja(J.text);
                                                    var K = s.layout.get("text-rotate").evaluate(_, {}, T);
                                                    S = new Hc(l, e1, c, u, h, J, f, p, d, K);
                                                }
                                                var Q = 1 === J.positionedLines.length;
                                                if (O += ru(t1, e1, J, a, s, d, _, m, I, n.vertical ? lc.horizontal : lc.horizontalOnly, Q ? Object.keys(n.horizontal) : [
                                                    $
                                                ], B, R, b, T), Q) break;
                                            }
                                            n.vertical && (D += ru(t1, e1, n.vertical, a, s, d, _, m, I, lc.vertical, [
                                                "vertical"
                                            ], B, F, b, T));
                                            var tt = S ? S.boxStartIndex : t1.collisionBoxArray.length, et = S ? S.boxEndIndex : t1.collisionBoxArray.length, rt = C ? C.boxStartIndex : t1.collisionBoxArray.length, nt = C ? C.boxEndIndex : t1.collisionBoxArray.length, it = E ? E.boxStartIndex : t1.collisionBoxArray.length, at = E ? E.boxEndIndex : t1.collisionBoxArray.length, ot = L ? L.boxStartIndex : t1.collisionBoxArray.length, st = L ? L.boxEndIndex : t1.collisionBoxArray.length, lt = -1, ct = function(t1, e1) {
                                                return t1 && t1.circleDiameter ? Math.max(t1.circleDiameter, e1) : e1;
                                            };
                                            lt = ct(S, lt), lt = ct(C, lt), lt = ct(E, lt);
                                            var ut = (lt = ct(L, lt)) > -1 ? 1 : 0;
                                            ut && (lt *= A / Cl), t1.glyphOffsetArray.length >= fu.MAX_GLYPHS && k("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== _.sortKey && t1.addToSortKeyRanges(t1.symbolInstances.length, _.sortKey), t1.symbolInstances.emplaceBack(e1.x, e1.y, B.right >= 0 ? B.right : -1, B.center >= 0 ? B.center : -1, B.left >= 0 ? B.left : -1, B.vertical || -1, R, F, N, tt, et, rt, nt, it, at, ot, st, c, O, D, P, z, ut, 0, f, j, U, lt);
                                        }(t1, h, s, r, n, i, f, t1.layers[0], t1.collisionBoxArray, e1.index, e1.sourceLayerIndex, t1.index, v, w, M, l, _, T, S, d, e1, a, c, u, o);
                                    };
                                    if ("line" === E) for(var P = 0, z = Fc(e1.geometry, 0, 0, po, po); P < z.length; P += 1)for(var O = z[P], D = 0, R = Dc(O, b, A, r.vertical || m, n, g, x, t1.overscaling, po); D < R.length; D += 1){
                                        var F = R[D];
                                        m && iu(t1, m.text, C, F) || I(O, F);
                                    }
                                    else if ("line-center" === E) for(var B = 0, N = e1.geometry; B < N.length; B += 1){
                                        var j = N[B];
                                        if (j.length > 1) {
                                            var U = Oc(j, A, r.vertical || m, n, g, x);
                                            U && I(j, U);
                                        }
                                    }
                                    else if ("Polygon" === e1.type) for(var V = 0, q = Fs(e1.geometry, 0); V < q.length; V += 1){
                                        var H = q[V], G = Wc(H, 16);
                                        I(H[0], new kc(G.x, G.y, 0));
                                    }
                                    else if ("LineString" === e1.type) for(var Z = 0, W = e1.geometry; Z < W.length; Z += 1){
                                        var Y = W[Z];
                                        I(Y, new kc(Y[0].x, Y[0].y, 0));
                                    }
                                    else if ("Point" === e1.type) for(var X = 0, $ = e1.geometry; X < $.length; X += 1)for(var J = 0, K = $[X]; J < K.length; J += 1){
                                        var Q = K[J];
                                        I([
                                            Q
                                        ], new kc(Q.x, Q.y, 0));
                                    }
                                }(t1, a, p, N, n, u, h, f, m, j, o);
                            }, w = 0, T = t1.features; w < T.length; w += 1)b();
                            a && t1.generateCollisionDebugBuffers();
                        }, t1.perspective = function(t1, e1, r, n, i) {
                            var a, o = 1 / Math.tan(e1 / 2);
                            return t1[0] = o / r, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = o, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[11] = -1, t1[12] = 0, t1[13] = 0, t1[15] = 0, null != i && i !== 1 / 0 ? (a = 1 / (n - i), t1[10] = (i + n) * a, t1[14] = 2 * i * n * a) : (t1[10] = -1, t1[14] = -2 * n), t1;
                        }, t1.pick = function(t1, e1) {
                            for(var r = {}, n = 0; n < e1.length; n++){
                                var i = e1[n];
                                i in t1 && (r[i] = t1[i]);
                            }
                            return r;
                        }, t1.plugin = zi, t1.polygonIntersectsPolygon = bo, t1.postMapLoadEvent = ct, t1.postTurnstileEvent = st, t1.potpack = nc, t1.refProperties = [
                            "type",
                            "source",
                            "source-layer",
                            "minzoom",
                            "maxzoom",
                            "filter",
                            "layout"
                        ], t1.register = oi, t1.registerForPluginStateChange = function(t1) {
                            return t1({
                                pluginStatus: Mi,
                                pluginURL: Si
                            }), Li.on("pluginStateChange", t1), t1;
                        }, t1.renderColorRamp = ts, t1.rotate = function(t1, e1, r) {
                            var n = e1[0], i = e1[1], a = e1[2], o = e1[3], s = Math.sin(r), l = Math.cos(r);
                            return t1[0] = n * l + a * s, t1[1] = i * l + o * s, t1[2] = n * -s + a * l, t1[3] = i * -s + o * l, t1;
                        }, t1.rotateX = function(t1, e1, r) {
                            var n = Math.sin(r), i = Math.cos(r), a = e1[4], o = e1[5], s = e1[6], l = e1[7], c = e1[8], u = e1[9], h = e1[10], f = e1[11];
                            return e1 !== t1 && (t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1[3] = e1[3], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]), t1[4] = a * i + c * n, t1[5] = o * i + u * n, t1[6] = s * i + h * n, t1[7] = l * i + f * n, t1[8] = c * i - a * n, t1[9] = u * i - o * n, t1[10] = h * i - s * n, t1[11] = f * i - l * n, t1;
                        }, t1.rotateZ = function(t1, e1, r) {
                            var n = Math.sin(r), i = Math.cos(r), a = e1[0], o = e1[1], s = e1[2], l = e1[3], c = e1[4], u = e1[5], h = e1[6], f = e1[7];
                            return e1 !== t1 && (t1[8] = e1[8], t1[9] = e1[9], t1[10] = e1[10], t1[11] = e1[11], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]), t1[0] = a * i + c * n, t1[1] = o * i + u * n, t1[2] = s * i + h * n, t1[3] = l * i + f * n, t1[4] = c * i - a * n, t1[5] = u * i - o * n, t1[6] = h * i - s * n, t1[7] = f * i - l * n, t1;
                        }, t1.scale = function(t1, e1, r) {
                            var n = r[0], i = r[1], a = r[2];
                            return t1[0] = e1[0] * n, t1[1] = e1[1] * n, t1[2] = e1[2] * n, t1[3] = e1[3] * n, t1[4] = e1[4] * i, t1[5] = e1[5] * i, t1[6] = e1[6] * i, t1[7] = e1[7] * i, t1[8] = e1[8] * a, t1[9] = e1[9] * a, t1[10] = e1[10] * a, t1[11] = e1[11] * a, t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15], t1;
                        }, t1.scale$1 = function(t1, e1, r) {
                            return t1[0] = e1[0] * r, t1[1] = e1[1] * r, t1[2] = e1[2] * r, t1[3] = e1[3] * r, t1;
                        }, t1.scale$2 = function(t1, e1, r) {
                            return t1[0] = e1[0] * r, t1[1] = e1[1] * r, t1[2] = e1[2] * r, t1;
                        }, t1.setCacheLimits = function(t1, e1) {
                            ht = t1, ft = e1;
                        }, t1.setRTLTextPlugin = function(t1, e1, r) {
                            if (void 0 === r && (r = !1), Mi === bi || Mi === wi || Mi === Ti) throw new Error("setRTLTextPlugin cannot be called multiple times.");
                            Si = N.resolveURL(t1), Mi = bi, Ai = e1, Ci(), r || Pi();
                        }, t1.sphericalToCartesian = function(t1) {
                            var e1 = t1[0], r = t1[1], n = t1[2];
                            return r += 90, r *= Math.PI / 180, n *= Math.PI / 180, {
                                x: e1 * Math.cos(r) * Math.sin(n),
                                y: e1 * Math.sin(r) * Math.sin(n),
                                z: e1 * Math.cos(n)
                            };
                        }, t1.sqrLen = Ho, t1.styleSpec = Ft, t1.sub = Vo, t1.symbolSize = Cc, t1.transformMat3 = function(t1, e1, r) {
                            var n = e1[0], i = e1[1], a = e1[2];
                            return t1[0] = n * r[0] + i * r[3] + a * r[6], t1[1] = n * r[1] + i * r[4] + a * r[7], t1[2] = n * r[2] + i * r[5] + a * r[8], t1;
                        }, t1.transformMat4 = qo, t1.translate = function(t1, e1, r) {
                            var n, i, a, o, s, l, c, u, h, f, p, d, m = r[0], g = r[1], y = r[2];
                            return e1 === t1 ? (t1[12] = e1[0] * m + e1[4] * g + e1[8] * y + e1[12], t1[13] = e1[1] * m + e1[5] * g + e1[9] * y + e1[13], t1[14] = e1[2] * m + e1[6] * g + e1[10] * y + e1[14], t1[15] = e1[3] * m + e1[7] * g + e1[11] * y + e1[15]) : (n = e1[0], i = e1[1], a = e1[2], o = e1[3], s = e1[4], l = e1[5], c = e1[6], u = e1[7], h = e1[8], f = e1[9], p = e1[10], d = e1[11], t1[0] = n, t1[1] = i, t1[2] = a, t1[3] = o, t1[4] = s, t1[5] = l, t1[6] = c, t1[7] = u, t1[8] = h, t1[9] = f, t1[10] = p, t1[11] = d, t1[12] = n * m + s * g + h * y + e1[12], t1[13] = i * m + l * g + f * y + e1[13], t1[14] = a * m + c * g + p * y + e1[14], t1[15] = o * m + u * g + d * y + e1[15]), t1;
                        }, t1.triggerPluginCompletionEvent = Ei, t1.uniqueId = m, t1.validateCustomStyleLayer = function(t1) {
                            var e1 = [], r = t1.id;
                            return void 0 === r && e1.push({
                                message: "layers." + r + ': missing required property "id"'
                            }), void 0 === t1.render && e1.push({
                                message: "layers." + r + ': missing required method "render"'
                            }), t1.renderingMode && "2d" !== t1.renderingMode && "3d" !== t1.renderingMode && e1.push({
                                message: "layers." + r + ': property "renderingMode" must be either "2d" or "3d"'
                            }), e1;
                        }, t1.validateLight = $n, t1.validateStyle = Xn, t1.values = function(t1) {
                            var e1 = [];
                            for(var r in t1)e1.push(t1[r]);
                            return e1;
                        }, t1.vectorTile = tl, t1.version = r, t1.warnOnce = k, t1.webpSupported = U, t1.window = s, t1.wrap = f;
                    }), n(0, function(t1) {
                        function e1(t1) {
                            var r = typeof t1;
                            if ("number" === r || "boolean" === r || "string" === r || null == t1) return JSON.stringify(t1);
                            if (Array.isArray(t1)) {
                                for(var n = "[", i = 0, a = t1; i < a.length; i += 1)n += e1(a[i]) + ",";
                                return n + "]";
                            }
                            for(var o = Object.keys(t1).sort(), s = "{", l = 0; l < o.length; l++)s += JSON.stringify(o[l]) + ":" + e1(t1[o[l]]) + ",";
                            return s + "}";
                        }
                        function r(r) {
                            for(var n = "", i = 0, a = t1.refProperties; i < a.length; i += 1)n += "/" + e1(r[a[i]]);
                            return n;
                        }
                        var n = function(t1) {
                            this.keyCache = {}, t1 && this.replace(t1);
                        };
                        n.prototype.replace = function(t1) {
                            this._layerConfigs = {}, this._layers = {}, this.update(t1, []);
                        }, n.prototype.update = function(e1, n) {
                            for(var i = this, a = 0, o = e1; a < o.length; a += 1){
                                var s = o[a];
                                this._layerConfigs[s.id] = s;
                                var l = this._layers[s.id] = t1.createStyleLayer(s);
                                l._featureFilter = t1.featureFilter(l.filter), this.keyCache[s.id] && delete this.keyCache[s.id];
                            }
                            for(var c = 0, u = n; c < u.length; c += 1){
                                var h = u[c];
                                delete this.keyCache[h], delete this._layerConfigs[h], delete this._layers[h];
                            }
                            this.familiesBySource = {};
                            for(var f = 0, p = function(t1, e1) {
                                for(var n = {}, i = 0; i < t1.length; i++){
                                    var a = e1 && e1[t1[i].id] || r(t1[i]);
                                    e1 && (e1[t1[i].id] = a);
                                    var o = n[a];
                                    o || (o = n[a] = []), o.push(t1[i]);
                                }
                                var s = [];
                                for(var l in n)s.push(n[l]);
                                return s;
                            }(t1.values(this._layerConfigs), this.keyCache); f < p.length; f += 1){
                                var d = p[f].map(function(t1) {
                                    return i._layers[t1.id];
                                }), m = d[0];
                                if ("none" !== m.visibility) {
                                    var g = m.source || "", y = this.familiesBySource[g];
                                    y || (y = this.familiesBySource[g] = {});
                                    var v = m.sourceLayer || "_geojsonTileLayer", x = y[v];
                                    x || (x = y[v] = []), x.push(d);
                                }
                            }
                        };
                        var i = function(e1) {
                            var r = {}, n = [];
                            for(var i in e1){
                                var a = e1[i], o = r[i] = {};
                                for(var s in a){
                                    var l = a[+s];
                                    if (l && 0 !== l.bitmap.width && 0 !== l.bitmap.height) {
                                        var c = {
                                            x: 0,
                                            y: 0,
                                            w: l.bitmap.width + 2,
                                            h: l.bitmap.height + 2
                                        };
                                        n.push(c), o[s] = {
                                            rect: c,
                                            metrics: l.metrics
                                        };
                                    }
                                }
                            }
                            var u = t1.potpack(n), h = u.w, f = u.h, p = new t1.AlphaImage({
                                width: h || 1,
                                height: f || 1
                            });
                            for(var d in e1){
                                var m = e1[d];
                                for(var g in m){
                                    var y = m[+g];
                                    if (y && 0 !== y.bitmap.width && 0 !== y.bitmap.height) {
                                        var v = r[d][g].rect;
                                        t1.AlphaImage.copy(y.bitmap, p, {
                                            x: 0,
                                            y: 0
                                        }, {
                                            x: v.x + 1,
                                            y: v.y + 1
                                        }, y.bitmap);
                                    }
                                }
                            }
                            this.image = p, this.positions = r;
                        };
                        t1.register("GlyphAtlas", i);
                        var a = function(e1) {
                            this.tileID = new t1.OverscaledTileID(e1.tileID.overscaledZ, e1.tileID.wrap, e1.tileID.canonical.z, e1.tileID.canonical.x, e1.tileID.canonical.y), this.uid = e1.uid, this.zoom = e1.zoom, this.pixelRatio = e1.pixelRatio, this.tileSize = e1.tileSize, this.source = e1.source, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = e1.showCollisionBoxes, this.collectResourceTiming = !!e1.collectResourceTiming, this.returnDependencies = !!e1.returnDependencies, this.promoteId = e1.promoteId;
                        };
                        function o(e1, r, n) {
                            for(var i = new t1.EvaluationParameters(r), a = 0, o = e1; a < o.length; a += 1)o[a].recalculate(i, n);
                        }
                        function s(e1, r) {
                            var n = t1.getArrayBuffer(e1.request, function(e1, n, i, a) {
                                e1 ? r(e1) : n && r(null, {
                                    vectorTile: new t1.vectorTile.VectorTile(new t1.pbf(n)),
                                    rawData: n,
                                    cacheControl: i,
                                    expires: a
                                });
                            });
                            return function() {
                                n.cancel(), r();
                            };
                        }
                        a.prototype.parse = function(e1, r, n, a, s) {
                            var l = this;
                            this.status = "parsing", this.data = e1, this.collisionBoxArray = new t1.CollisionBoxArray;
                            var c = new t1.DictionaryCoder(Object.keys(e1.layers).sort()), u = new t1.FeatureIndex(this.tileID, this.promoteId);
                            u.bucketLayerIDs = [];
                            var h, f, p, d, m = {}, g = {
                                featureIndex: u,
                                iconDependencies: {},
                                patternDependencies: {},
                                glyphDependencies: {},
                                availableImages: n
                            }, y = r.familiesBySource[this.source];
                            for(var v in y){
                                var x = e1.layers[v];
                                if (x) {
                                    1 === x.version && t1.warnOnce('Vector tile source "' + this.source + '" layer "' + v + '" does not use vector tile spec v2 and therefore may have some rendering errors.');
                                    for(var _ = c.encode(v), b = [], w = 0; w < x.length; w++){
                                        var T = x.feature(w), k = u.getId(T, v);
                                        b.push({
                                            feature: T,
                                            id: k,
                                            index: w,
                                            sourceLayerIndex: _
                                        });
                                    }
                                    for(var A = 0, M = y[v]; A < M.length; A += 1){
                                        var S = M[A], E = S[0];
                                        E.minzoom && this.zoom < Math.floor(E.minzoom) || E.maxzoom && this.zoom >= E.maxzoom || "none" !== E.visibility && (o(S, this.zoom, n), (m[E.id] = E.createBucket({
                                            index: u.bucketLayerIDs.length,
                                            layers: S,
                                            zoom: this.zoom,
                                            pixelRatio: this.pixelRatio,
                                            overscaling: this.overscaling,
                                            collisionBoxArray: this.collisionBoxArray,
                                            sourceLayerIndex: _,
                                            sourceID: this.source
                                        })).populate(b, g, this.tileID.canonical), u.bucketLayerIDs.push(S.map(function(t1) {
                                            return t1.id;
                                        })));
                                    }
                                }
                            }
                            var C = t1.mapObject(g.glyphDependencies, function(t1) {
                                return Object.keys(t1).map(Number);
                            });
                            Object.keys(C).length ? a.send("getGlyphs", {
                                uid: this.uid,
                                stacks: C
                            }, function(t1, e1) {
                                h || (h = t1, f = e1, P.call(l));
                            }) : f = {};
                            var L = Object.keys(g.iconDependencies);
                            L.length ? a.send("getImages", {
                                icons: L,
                                source: this.source,
                                tileID: this.tileID,
                                type: "icons"
                            }, function(t1, e1) {
                                h || (h = t1, p = e1, P.call(l));
                            }) : p = {};
                            var I = Object.keys(g.patternDependencies);
                            function P() {
                                if (h) return s(h);
                                if (f && p && d) {
                                    var e1 = new i(f), r = new t1.ImageAtlas(p, d);
                                    for(var a in m){
                                        var l = m[a];
                                        l instanceof t1.SymbolBucket ? (o(l.layers, this.zoom, n), t1.performSymbolLayout(l, f, e1.positions, p, r.iconPositions, this.showCollisionBoxes, this.tileID.canonical)) : l.hasPattern && (l instanceof t1.LineBucket || l instanceof t1.FillBucket || l instanceof t1.FillExtrusionBucket) && (o(l.layers, this.zoom, n), l.addFeatures(g, this.tileID.canonical, r.patternPositions));
                                    }
                                    this.status = "done", s(null, {
                                        buckets: t1.values(m).filter(function(t1) {
                                            return !t1.isEmpty();
                                        }),
                                        featureIndex: u,
                                        collisionBoxArray: this.collisionBoxArray,
                                        glyphAtlasImage: e1.image,
                                        imageAtlas: r,
                                        glyphMap: this.returnDependencies ? f : null,
                                        iconMap: this.returnDependencies ? p : null,
                                        glyphPositions: this.returnDependencies ? e1.positions : null
                                    });
                                }
                            }
                            I.length ? a.send("getImages", {
                                icons: I,
                                source: this.source,
                                tileID: this.tileID,
                                type: "patterns"
                            }, function(t1, e1) {
                                h || (h = t1, d = e1, P.call(l));
                            }) : d = {}, P.call(this);
                        };
                        var l = function(t1, e1, r, n) {
                            this.actor = t1, this.layerIndex = e1, this.availableImages = r, this.loadVectorData = n || s, this.loading = {}, this.loaded = {};
                        };
                        l.prototype.loadTile = function(e1, r) {
                            var n = this, i = e1.uid;
                            this.loading || (this.loading = {});
                            var o = !!(e1 && e1.request && e1.request.collectResourceTiming) && new t1.RequestPerformance(e1.request), s = this.loading[i] = new a(e1);
                            s.abort = this.loadVectorData(e1, function(e1, a) {
                                if (delete n.loading[i], e1 || !a) return s.status = "done", n.loaded[i] = s, r(e1);
                                var l = a.rawData, c = {};
                                a.expires && (c.expires = a.expires), a.cacheControl && (c.cacheControl = a.cacheControl);
                                var u = {};
                                if (o) {
                                    var h = o.finish();
                                    h && (u.resourceTiming = JSON.parse(JSON.stringify(h)));
                                }
                                s.vectorTile = a.vectorTile, s.parse(a.vectorTile, n.layerIndex, n.availableImages, n.actor, function(e1, n) {
                                    if (e1 || !n) return r(e1);
                                    r(null, t1.extend({
                                        rawTileData: l.slice(0)
                                    }, n, c, u));
                                }), n.loaded = n.loaded || {}, n.loaded[i] = s;
                            });
                        }, l.prototype.reloadTile = function(t1, e1) {
                            var r = this, n = this.loaded, i = t1.uid, a = this;
                            if (n && n[i]) {
                                var o = n[i];
                                o.showCollisionBoxes = t1.showCollisionBoxes;
                                var s = function(t1, n) {
                                    var i = o.reloadCallback;
                                    i && (delete o.reloadCallback, o.parse(o.vectorTile, a.layerIndex, r.availableImages, a.actor, i)), e1(t1, n);
                                };
                                "parsing" === o.status ? o.reloadCallback = s : "done" === o.status && (o.vectorTile ? o.parse(o.vectorTile, this.layerIndex, this.availableImages, this.actor, s) : s());
                            }
                        }, l.prototype.abortTile = function(t1, e1) {
                            var r = this.loading, n = t1.uid;
                            r && r[n] && r[n].abort && (r[n].abort(), delete r[n]), e1();
                        }, l.prototype.removeTile = function(t1, e1) {
                            var r = this.loaded, n = t1.uid;
                            r && r[n] && delete r[n], e1();
                        };
                        var c = t1.window.ImageBitmap, u = function() {
                            this.loaded = {};
                        };
                        u.prototype.loadTile = function(e1, r) {
                            var n = e1.uid, i = e1.encoding, a = e1.rawImageData, o = c && a instanceof c ? this.getImageData(a) : a, s = new t1.DEMData(n, o, i);
                            this.loaded = this.loaded || {}, this.loaded[n] = s, r(null, s);
                        }, u.prototype.getImageData = function(e1) {
                            this.offscreenCanvas && this.offscreenCanvasContext || (this.offscreenCanvas = new OffscreenCanvas(e1.width, e1.height), this.offscreenCanvasContext = this.offscreenCanvas.getContext("2d")), this.offscreenCanvas.width = e1.width, this.offscreenCanvas.height = e1.height, this.offscreenCanvasContext.drawImage(e1, 0, 0, e1.width, e1.height);
                            var r = this.offscreenCanvasContext.getImageData(-1, -1, e1.width + 2, e1.height + 2);
                            return this.offscreenCanvasContext.clearRect(0, 0, this.offscreenCanvas.width, this.offscreenCanvas.height), new t1.RGBAImage({
                                width: r.width,
                                height: r.height
                            }, r.data);
                        }, u.prototype.removeTile = function(t1) {
                            var e1 = this.loaded, r = t1.uid;
                            e1 && e1[r] && delete e1[r];
                        };
                        var h = function t1(e1, r) {
                            var n, i = e1 && e1.type;
                            if ("FeatureCollection" === i) for(n = 0; n < e1.features.length; n++)t1(e1.features[n], r);
                            else if ("GeometryCollection" === i) for(n = 0; n < e1.geometries.length; n++)t1(e1.geometries[n], r);
                            else if ("Feature" === i) t1(e1.geometry, r);
                            else if ("Polygon" === i) f(e1.coordinates, r);
                            else if ("MultiPolygon" === i) for(n = 0; n < e1.coordinates.length; n++)f(e1.coordinates[n], r);
                            return e1;
                        };
                        function f(t1, e1) {
                            if (0 !== t1.length) {
                                p(t1[0], e1);
                                for(var r = 1; r < t1.length; r++)p(t1[r], !e1);
                            }
                        }
                        function p(t1, e1) {
                            for(var r = 0, n = 0, i = t1.length, a = i - 1; n < i; a = n++)r += (t1[n][0] - t1[a][0]) * (t1[a][1] + t1[n][1]);
                            r >= 0 != !!e1 && t1.reverse();
                        }
                        var d = t1.vectorTile.VectorTileFeature.prototype.toGeoJSON, m = function(e1) {
                            this._feature = e1, this.extent = t1.EXTENT, this.type = e1.type, this.properties = e1.tags, "id" in e1 && !isNaN(e1.id) && (this.id = parseInt(e1.id, 10));
                        };
                        m.prototype.loadGeometry = function() {
                            if (1 === this._feature.type) {
                                for(var e1 = [], r = 0, n = this._feature.geometry; r < n.length; r += 1){
                                    var i = n[r];
                                    e1.push([
                                        new t1.Point$1(i[0], i[1])
                                    ]);
                                }
                                return e1;
                            }
                            for(var a = [], o = 0, s = this._feature.geometry; o < s.length; o += 1){
                                for(var l = [], c = 0, u = s[o]; c < u.length; c += 1){
                                    var h = u[c];
                                    l.push(new t1.Point$1(h[0], h[1]));
                                }
                                a.push(l);
                            }
                            return a;
                        }, m.prototype.toGeoJSON = function(t1, e1, r) {
                            return d.call(this, t1, e1, r);
                        };
                        var g = function(e1) {
                            this.layers = {
                                _geojsonTileLayer: this
                            }, this.name = "_geojsonTileLayer", this.extent = t1.EXTENT, this.length = e1.length, this._features = e1;
                        };
                        g.prototype.feature = function(t1) {
                            return new m(this._features[t1]);
                        };
                        var y = t1.vectorTile.VectorTileFeature, v = x;
                        function x(t1, e1) {
                            this.options = e1 || {}, this.features = t1, this.length = t1.length;
                        }
                        function _(t1, e1) {
                            this.id = "number" == typeof t1.id ? t1.id : void 0, this.type = t1.type, this.rawGeometry = 1 === t1.type ? [
                                t1.geometry
                            ] : t1.geometry, this.properties = t1.tags, this.extent = e1 || 4096;
                        }
                        x.prototype.feature = function(t1) {
                            return new _(this.features[t1], this.options.extent);
                        }, _.prototype.loadGeometry = function() {
                            var e1 = this.rawGeometry;
                            this.geometry = [];
                            for(var r = 0; r < e1.length; r++){
                                for(var n = e1[r], i = [], a = 0; a < n.length; a++)i.push(new t1.Point$1(n[a][0], n[a][1]));
                                this.geometry.push(i);
                            }
                            return this.geometry;
                        }, _.prototype.bbox = function() {
                            this.geometry || this.loadGeometry();
                            for(var t1 = this.geometry, e1 = 1 / 0, r = -1 / 0, n = 1 / 0, i = -1 / 0, a = 0; a < t1.length; a++)for(var o = t1[a], s = 0; s < o.length; s++){
                                var l = o[s];
                                e1 = Math.min(e1, l.x), r = Math.max(r, l.x), n = Math.min(n, l.y), i = Math.max(i, l.y);
                            }
                            return [
                                e1,
                                n,
                                r,
                                i
                            ];
                        }, _.prototype.toGeoJSON = y.prototype.toGeoJSON;
                        var b = A, w = A, T = function(t1, e1) {
                            e1 = e1 || {};
                            var r = {};
                            for(var n in t1)r[n] = new v(t1[n].features, e1), r[n].name = n, r[n].version = e1.version, r[n].extent = e1.extent;
                            return A({
                                layers: r
                            });
                        }, k = v;
                        function A(e1) {
                            var r = new t1.pbf;
                            return function(t1, e1) {
                                for(var r in t1.layers)e1.writeMessage(3, M, t1.layers[r]);
                            }(e1, r), r.finish();
                        }
                        function M(t1, e1) {
                            var r;
                            e1.writeVarintField(15, t1.version || 1), e1.writeStringField(1, t1.name || ""), e1.writeVarintField(5, t1.extent || 4096);
                            var n = {
                                keys: [],
                                values: [],
                                keycache: {},
                                valuecache: {}
                            };
                            for(r = 0; r < t1.length; r++)n.feature = t1.feature(r), e1.writeMessage(2, S, n);
                            var i = n.keys;
                            for(r = 0; r < i.length; r++)e1.writeStringField(3, i[r]);
                            var a = n.values;
                            for(r = 0; r < a.length; r++)e1.writeMessage(4, P, a[r]);
                        }
                        function S(t1, e1) {
                            var r = t1.feature;
                            void 0 !== r.id && e1.writeVarintField(1, r.id), e1.writeMessage(2, E, t1), e1.writeVarintField(3, r.type), e1.writeMessage(4, I, r);
                        }
                        function E(t1, e1) {
                            var r = t1.feature, n = t1.keys, i = t1.values, a = t1.keycache, o = t1.valuecache;
                            for(var s in r.properties){
                                var l = a[s];
                                void 0 === l && (n.push(s), l = n.length - 1, a[s] = l), e1.writeVarint(l);
                                var c = r.properties[s], u = typeof c;
                                "string" !== u && "boolean" !== u && "number" !== u && (c = JSON.stringify(c));
                                var h = u + ":" + c, f = o[h];
                                void 0 === f && (i.push(c), f = i.length - 1, o[h] = f), e1.writeVarint(f);
                            }
                        }
                        function C(t1, e1) {
                            return (e1 << 3) + (7 & t1);
                        }
                        function L(t1) {
                            return t1 << 1 ^ t1 >> 31;
                        }
                        function I(t1, e1) {
                            for(var r = t1.loadGeometry(), n = t1.type, i = 0, a = 0, o = r.length, s = 0; s < o; s++){
                                var l = r[s], c = 1;
                                1 === n && (c = l.length), e1.writeVarint(C(1, c));
                                for(var u = 3 === n ? l.length - 1 : l.length, h = 0; h < u; h++){
                                    1 === h && 1 !== n && e1.writeVarint(C(2, u - 1));
                                    var f = l[h].x - i, p = l[h].y - a;
                                    e1.writeVarint(L(f)), e1.writeVarint(L(p)), i += f, a += p;
                                }
                                3 === n && e1.writeVarint(C(7, 1));
                            }
                        }
                        function P(t1, e1) {
                            var r = typeof t1;
                            "string" === r ? e1.writeStringField(1, t1) : "boolean" === r ? e1.writeBooleanField(7, t1) : "number" === r && (t1 % 1 != 0 ? e1.writeDoubleField(3, t1) : t1 < 0 ? e1.writeSVarintField(6, t1) : e1.writeVarintField(5, t1));
                        }
                        function z(t1, e1, r, n, i, a) {
                            if (!(i - n <= r)) {
                                var o = n + i >> 1;
                                O(t1, e1, o, n, i, a % 2), z(t1, e1, r, n, o - 1, a + 1), z(t1, e1, r, o + 1, i, a + 1);
                            }
                        }
                        function O(t1, e1, r, n, i, a) {
                            for(; i > n;){
                                if (i - n > 600) {
                                    var o = i - n + 1, s = r - n + 1, l = Math.log(o), c = .5 * Math.exp(2 * l / 3), u = .5 * Math.sqrt(l * c * (o - c) / o) * (s - o / 2 < 0 ? -1 : 1);
                                    O(t1, e1, r, Math.max(n, Math.floor(r - s * c / o + u)), Math.min(i, Math.floor(r + (o - s) * c / o + u)), a);
                                }
                                var h = e1[2 * r + a], f = n, p = i;
                                for(D(t1, e1, n, r), e1[2 * i + a] > h && D(t1, e1, n, i); f < p;){
                                    for(D(t1, e1, f, p), f++, p--; e1[2 * f + a] < h;)f++;
                                    for(; e1[2 * p + a] > h;)p--;
                                }
                                e1[2 * n + a] === h ? D(t1, e1, n, p) : D(t1, e1, ++p, i), p <= r && (n = p + 1), r <= p && (i = p - 1);
                            }
                        }
                        function D(t1, e1, r, n) {
                            R(t1, r, n), R(e1, 2 * r, 2 * n), R(e1, 2 * r + 1, 2 * n + 1);
                        }
                        function R(t1, e1, r) {
                            var n = t1[e1];
                            t1[e1] = t1[r], t1[r] = n;
                        }
                        function F(t1, e1, r, n) {
                            var i = t1 - r, a = e1 - n;
                            return i * i + a * a;
                        }
                        b.fromVectorTileJs = w, b.fromGeojsonVt = T, b.GeoJSONWrapper = k;
                        var B = function(t1) {
                            return t1[0];
                        }, N = function(t1) {
                            return t1[1];
                        }, j = function(t1, e1, r, n, i) {
                            void 0 === e1 && (e1 = B), void 0 === r && (r = N), void 0 === n && (n = 64), void 0 === i && (i = Float64Array), this.nodeSize = n, this.points = t1;
                            for(var a = t1.length < 65536 ? Uint16Array : Uint32Array, o = this.ids = new a(t1.length), s = this.coords = new i(2 * t1.length), l = 0; l < t1.length; l++)o[l] = l, s[2 * l] = e1(t1[l]), s[2 * l + 1] = r(t1[l]);
                            z(o, s, n, 0, o.length - 1, 0);
                        };
                        j.prototype.range = function(t1, e1, r, n) {
                            return function(t1, e1, r, n, i, a, o) {
                                for(var s, l, c = [
                                    0,
                                    t1.length - 1,
                                    0
                                ], u = []; c.length;){
                                    var h = c.pop(), f = c.pop(), p = c.pop();
                                    if (f - p <= o) for(var d = p; d <= f; d++)s = e1[2 * d], l = e1[2 * d + 1], s >= r && s <= i && l >= n && l <= a && u.push(t1[d]);
                                    else {
                                        var m = Math.floor((p + f) / 2);
                                        s = e1[2 * m], l = e1[2 * m + 1], s >= r && s <= i && l >= n && l <= a && u.push(t1[m]);
                                        var g = (h + 1) % 2;
                                        (0 === h ? r <= s : n <= l) && (c.push(p), c.push(m - 1), c.push(g)), (0 === h ? i >= s : a >= l) && (c.push(m + 1), c.push(f), c.push(g));
                                    }
                                }
                                return u;
                            }(this.ids, this.coords, t1, e1, r, n, this.nodeSize);
                        }, j.prototype.within = function(t1, e1, r) {
                            return function(t1, e1, r, n, i, a) {
                                for(var o = [
                                    0,
                                    t1.length - 1,
                                    0
                                ], s = [], l = i * i; o.length;){
                                    var c = o.pop(), u = o.pop(), h = o.pop();
                                    if (u - h <= a) for(var f = h; f <= u; f++)F(e1[2 * f], e1[2 * f + 1], r, n) <= l && s.push(t1[f]);
                                    else {
                                        var p = Math.floor((h + u) / 2), d = e1[2 * p], m = e1[2 * p + 1];
                                        F(d, m, r, n) <= l && s.push(t1[p]);
                                        var g = (c + 1) % 2;
                                        (0 === c ? r - i <= d : n - i <= m) && (o.push(h), o.push(p - 1), o.push(g)), (0 === c ? r + i >= d : n + i >= m) && (o.push(p + 1), o.push(u), o.push(g));
                                    }
                                }
                                return s;
                            }(this.ids, this.coords, t1, e1, r, this.nodeSize);
                        };
                        var U = {
                            minZoom: 0,
                            maxZoom: 16,
                            minPoints: 2,
                            radius: 40,
                            extent: 512,
                            nodeSize: 64,
                            log: !1,
                            generateId: !1,
                            reduce: null,
                            map: function(t1) {
                                return t1;
                            }
                        }, V = function(t1) {
                            this.options = X(Object.create(U), t1), this.trees = new Array(this.options.maxZoom + 1);
                        };
                        function q(t1, e1, r, n, i) {
                            return {
                                x: t1,
                                y: e1,
                                zoom: 1 / 0,
                                id: r,
                                parentId: -1,
                                numPoints: n,
                                properties: i
                            };
                        }
                        function H(t1, e1) {
                            var r = t1.geometry.coordinates, n = r[0], i = r[1];
                            return {
                                x: W(n),
                                y: Y(i),
                                zoom: 1 / 0,
                                index: e1,
                                parentId: -1
                            };
                        }
                        function G(t1) {
                            var e1, r, n;
                            return {
                                type: "Feature",
                                id: t1.id,
                                properties: Z(t1),
                                geometry: {
                                    type: "Point",
                                    coordinates: [
                                        (n = t1.x, 360 * (n - .5)),
                                        (e1 = t1.y, r = (180 - 360 * e1) * Math.PI / 180, 360 * Math.atan(Math.exp(r)) / Math.PI - 90)
                                    ]
                                }
                            };
                        }
                        function Z(t1) {
                            var e1 = t1.numPoints, r = e1 >= 1e4 ? Math.round(e1 / 1e3) + "k" : e1 >= 1e3 ? Math.round(e1 / 100) / 10 + "k" : e1;
                            return X(X({}, t1.properties), {
                                cluster: !0,
                                cluster_id: t1.id,
                                point_count: e1,
                                point_count_abbreviated: r
                            });
                        }
                        function W(t1) {
                            return t1 / 360 + .5;
                        }
                        function Y(t1) {
                            var e1 = Math.sin(t1 * Math.PI / 180), r = .5 - .25 * Math.log((1 + e1) / (1 - e1)) / Math.PI;
                            return r < 0 ? 0 : r > 1 ? 1 : r;
                        }
                        function X(t1, e1) {
                            for(var r in e1)t1[r] = e1[r];
                            return t1;
                        }
                        function $(t1) {
                            return t1.x;
                        }
                        function J(t1) {
                            return t1.y;
                        }
                        function K(t1, e1, r, n) {
                            for(var i, a = n, o = r - e1 >> 1, s = r - e1, l = t1[e1], c = t1[e1 + 1], u = t1[r], h = t1[r + 1], f = e1 + 3; f < r; f += 3){
                                var p = Q(t1[f], t1[f + 1], l, c, u, h);
                                if (p > a) i = f, a = p;
                                else if (p === a) {
                                    var d = Math.abs(f - o);
                                    d < s && (i = f, s = d);
                                }
                            }
                            a > n && (i - e1 > 3 && K(t1, e1, i, n), t1[i + 2] = a, r - i > 3 && K(t1, i, r, n));
                        }
                        function Q(t1, e1, r, n, i, a) {
                            var o = i - r, s = a - n;
                            if (0 !== o || 0 !== s) {
                                var l = ((t1 - r) * o + (e1 - n) * s) / (o * o + s * s);
                                l > 1 ? (r = i, n = a) : l > 0 && (r += o * l, n += s * l);
                            }
                            return (o = t1 - r) * o + (s = e1 - n) * s;
                        }
                        function tt(t1, e1, r, n) {
                            var i = {
                                id: void 0 === t1 ? null : t1,
                                type: e1,
                                geometry: r,
                                tags: n,
                                minX: 1 / 0,
                                minY: 1 / 0,
                                maxX: -1 / 0,
                                maxY: -1 / 0
                            };
                            return function(t1) {
                                var e1 = t1.geometry, r = t1.type;
                                if ("Point" === r || "MultiPoint" === r || "LineString" === r) et(t1, e1);
                                else if ("Polygon" === r || "MultiLineString" === r) for(var n = 0; n < e1.length; n++)et(t1, e1[n]);
                                else if ("MultiPolygon" === r) for(n = 0; n < e1.length; n++)for(var i = 0; i < e1[n].length; i++)et(t1, e1[n][i]);
                            }(i), i;
                        }
                        function et(t1, e1) {
                            for(var r = 0; r < e1.length; r += 3)t1.minX = Math.min(t1.minX, e1[r]), t1.minY = Math.min(t1.minY, e1[r + 1]), t1.maxX = Math.max(t1.maxX, e1[r]), t1.maxY = Math.max(t1.maxY, e1[r + 1]);
                        }
                        function rt(t1, e1, r, n) {
                            if (e1.geometry) {
                                var i = e1.geometry.coordinates, a = e1.geometry.type, o = Math.pow(r.tolerance / ((1 << r.maxZoom) * r.extent), 2), s = [], l = e1.id;
                                if (r.promoteId ? l = e1.properties[r.promoteId] : r.generateId && (l = n || 0), "Point" === a) nt(i, s);
                                else if ("MultiPoint" === a) for(var c = 0; c < i.length; c++)nt(i[c], s);
                                else if ("LineString" === a) it(i, s, o, !1);
                                else if ("MultiLineString" === a) {
                                    if (r.lineMetrics) {
                                        for(c = 0; c < i.length; c++)s = [], it(i[c], s, o, !1), t1.push(tt(l, "LineString", s, e1.properties));
                                        return;
                                    }
                                    at(i, s, o, !1);
                                } else if ("Polygon" === a) at(i, s, o, !0);
                                else {
                                    if ("MultiPolygon" !== a) {
                                        if ("GeometryCollection" === a) {
                                            for(c = 0; c < e1.geometry.geometries.length; c++)rt(t1, {
                                                id: l,
                                                geometry: e1.geometry.geometries[c],
                                                properties: e1.properties
                                            }, r, n);
                                            return;
                                        }
                                        throw new Error("Input data is not a valid GeoJSON object.");
                                    }
                                    for(c = 0; c < i.length; c++){
                                        var u = [];
                                        at(i[c], u, o, !0), s.push(u);
                                    }
                                }
                                t1.push(tt(l, a, s, e1.properties));
                            }
                        }
                        function nt(t1, e1) {
                            e1.push(ot(t1[0])), e1.push(st(t1[1])), e1.push(0);
                        }
                        function it(t1, e1, r, n) {
                            for(var i, a, o = 0, s = 0; s < t1.length; s++){
                                var l = ot(t1[s][0]), c = st(t1[s][1]);
                                e1.push(l), e1.push(c), e1.push(0), s > 0 && (o += n ? (i * c - l * a) / 2 : Math.sqrt(Math.pow(l - i, 2) + Math.pow(c - a, 2))), i = l, a = c;
                            }
                            var u = e1.length - 3;
                            e1[2] = 1, K(e1, 0, u, r), e1[u + 2] = 1, e1.size = Math.abs(o), e1.start = 0, e1.end = e1.size;
                        }
                        function at(t1, e1, r, n) {
                            for(var i = 0; i < t1.length; i++){
                                var a = [];
                                it(t1[i], a, r, n), e1.push(a);
                            }
                        }
                        function ot(t1) {
                            return t1 / 360 + .5;
                        }
                        function st(t1) {
                            var e1 = Math.sin(t1 * Math.PI / 180), r = .5 - .25 * Math.log((1 + e1) / (1 - e1)) / Math.PI;
                            return r < 0 ? 0 : r > 1 ? 1 : r;
                        }
                        function lt(t1, e1, r, n, i, a, o, s) {
                            if (n /= e1, a >= (r /= e1) && o < n) return t1;
                            if (o < r || a >= n) return null;
                            for(var l = [], c = 0; c < t1.length; c++){
                                var u = t1[c], h = u.geometry, f = u.type, p = 0 === i ? u.minX : u.minY, d = 0 === i ? u.maxX : u.maxY;
                                if (p >= r && d < n) l.push(u);
                                else if (!(d < r || p >= n)) {
                                    var m = [];
                                    if ("Point" === f || "MultiPoint" === f) ct(h, m, r, n, i);
                                    else if ("LineString" === f) ut(h, m, r, n, i, !1, s.lineMetrics);
                                    else if ("MultiLineString" === f) ft(h, m, r, n, i, !1);
                                    else if ("Polygon" === f) ft(h, m, r, n, i, !0);
                                    else if ("MultiPolygon" === f) for(var g = 0; g < h.length; g++){
                                        var y = [];
                                        ft(h[g], y, r, n, i, !0), y.length && m.push(y);
                                    }
                                    if (m.length) {
                                        if (s.lineMetrics && "LineString" === f) {
                                            for(g = 0; g < m.length; g++)l.push(tt(u.id, f, m[g], u.tags));
                                            continue;
                                        }
                                        "LineString" !== f && "MultiLineString" !== f || (1 === m.length ? (f = "LineString", m = m[0]) : f = "MultiLineString"), "Point" !== f && "MultiPoint" !== f || (f = 3 === m.length ? "Point" : "MultiPoint"), l.push(tt(u.id, f, m, u.tags));
                                    }
                                }
                            }
                            return l.length ? l : null;
                        }
                        function ct(t1, e1, r, n, i) {
                            for(var a = 0; a < t1.length; a += 3){
                                var o = t1[a + i];
                                o >= r && o <= n && (e1.push(t1[a]), e1.push(t1[a + 1]), e1.push(t1[a + 2]));
                            }
                        }
                        function ut(t1, e1, r, n, i, a, o) {
                            for(var s, l, c = ht(t1), u = 0 === i ? dt : mt, h = t1.start, f = 0; f < t1.length - 3; f += 3){
                                var p = t1[f], d = t1[f + 1], m = t1[f + 2], g = t1[f + 3], y = t1[f + 4], v = 0 === i ? p : d, x = 0 === i ? g : y, _ = !1;
                                o && (s = Math.sqrt(Math.pow(p - g, 2) + Math.pow(d - y, 2))), v < r ? x > r && (l = u(c, p, d, g, y, r), o && (c.start = h + s * l)) : v > n ? x < n && (l = u(c, p, d, g, y, n), o && (c.start = h + s * l)) : pt(c, p, d, m), x < r && v >= r && (l = u(c, p, d, g, y, r), _ = !0), x > n && v <= n && (l = u(c, p, d, g, y, n), _ = !0), !a && _ && (o && (c.end = h + s * l), e1.push(c), c = ht(t1)), o && (h += s);
                            }
                            var b = t1.length - 3;
                            p = t1[b], d = t1[b + 1], m = t1[b + 2], (v = 0 === i ? p : d) >= r && v <= n && pt(c, p, d, m), b = c.length - 3, a && b >= 3 && (c[b] !== c[0] || c[b + 1] !== c[1]) && pt(c, c[0], c[1], c[2]), c.length && e1.push(c);
                        }
                        function ht(t1) {
                            var e1 = [];
                            return e1.size = t1.size, e1.start = t1.start, e1.end = t1.end, e1;
                        }
                        function ft(t1, e1, r, n, i, a) {
                            for(var o = 0; o < t1.length; o++)ut(t1[o], e1, r, n, i, a, !1);
                        }
                        function pt(t1, e1, r, n) {
                            t1.push(e1), t1.push(r), t1.push(n);
                        }
                        function dt(t1, e1, r, n, i, a) {
                            var o = (a - e1) / (n - e1);
                            return t1.push(a), t1.push(r + (i - r) * o), t1.push(1), o;
                        }
                        function mt(t1, e1, r, n, i, a) {
                            var o = (a - r) / (i - r);
                            return t1.push(e1 + (n - e1) * o), t1.push(a), t1.push(1), o;
                        }
                        function gt(t1, e1) {
                            for(var r = [], n = 0; n < t1.length; n++){
                                var i, a = t1[n], o = a.type;
                                if ("Point" === o || "MultiPoint" === o || "LineString" === o) i = yt(a.geometry, e1);
                                else if ("MultiLineString" === o || "Polygon" === o) {
                                    i = [];
                                    for(var s = 0; s < a.geometry.length; s++)i.push(yt(a.geometry[s], e1));
                                } else if ("MultiPolygon" === o) for(i = [], s = 0; s < a.geometry.length; s++){
                                    for(var l = [], c = 0; c < a.geometry[s].length; c++)l.push(yt(a.geometry[s][c], e1));
                                    i.push(l);
                                }
                                r.push(tt(a.id, o, i, a.tags));
                            }
                            return r;
                        }
                        function yt(t1, e1) {
                            var r = [];
                            r.size = t1.size, void 0 !== t1.start && (r.start = t1.start, r.end = t1.end);
                            for(var n = 0; n < t1.length; n += 3)r.push(t1[n] + e1, t1[n + 1], t1[n + 2]);
                            return r;
                        }
                        function vt(t1, e1) {
                            if (t1.transformed) return t1;
                            var r, n, i, a = 1 << t1.z, o = t1.x, s = t1.y;
                            for(r = 0; r < t1.features.length; r++){
                                var l = t1.features[r], c = l.geometry, u = l.type;
                                if (l.geometry = [], 1 === u) for(n = 0; n < c.length; n += 2)l.geometry.push(xt(c[n], c[n + 1], e1, a, o, s));
                                else for(n = 0; n < c.length; n++){
                                    var h = [];
                                    for(i = 0; i < c[n].length; i += 2)h.push(xt(c[n][i], c[n][i + 1], e1, a, o, s));
                                    l.geometry.push(h);
                                }
                            }
                            return t1.transformed = !0, t1;
                        }
                        function xt(t1, e1, r, n, i, a) {
                            return [
                                Math.round(r * (t1 * n - i)),
                                Math.round(r * (e1 * n - a))
                            ];
                        }
                        function _t(t1, e1, r, n, i) {
                            for(var a = e1 === i.maxZoom ? 0 : i.tolerance / ((1 << e1) * i.extent), o = {
                                features: [],
                                numPoints: 0,
                                numSimplified: 0,
                                numFeatures: 0,
                                source: null,
                                x: r,
                                y: n,
                                z: e1,
                                transformed: !1,
                                minX: 2,
                                minY: 1,
                                maxX: -1,
                                maxY: 0
                            }, s = 0; s < t1.length; s++){
                                o.numFeatures++, bt(o, t1[s], a, i);
                                var l = t1[s].minX, c = t1[s].minY, u = t1[s].maxX, h = t1[s].maxY;
                                l < o.minX && (o.minX = l), c < o.minY && (o.minY = c), u > o.maxX && (o.maxX = u), h > o.maxY && (o.maxY = h);
                            }
                            return o;
                        }
                        function bt(t1, e1, r, n) {
                            var i = e1.geometry, a = e1.type, o = [];
                            if ("Point" === a || "MultiPoint" === a) for(var s = 0; s < i.length; s += 3)o.push(i[s]), o.push(i[s + 1]), t1.numPoints++, t1.numSimplified++;
                            else if ("LineString" === a) wt(o, i, t1, r, !1, !1);
                            else if ("MultiLineString" === a || "Polygon" === a) for(s = 0; s < i.length; s++)wt(o, i[s], t1, r, "Polygon" === a, 0 === s);
                            else if ("MultiPolygon" === a) for(var l = 0; l < i.length; l++){
                                var c = i[l];
                                for(s = 0; s < c.length; s++)wt(o, c[s], t1, r, !0, 0 === s);
                            }
                            if (o.length) {
                                var u = e1.tags || null;
                                if ("LineString" === a && n.lineMetrics) {
                                    for(var h in u = {}, e1.tags)u[h] = e1.tags[h];
                                    u.mapbox_clip_start = i.start / i.size, u.mapbox_clip_end = i.end / i.size;
                                }
                                var f = {
                                    geometry: o,
                                    type: "Polygon" === a || "MultiPolygon" === a ? 3 : "LineString" === a || "MultiLineString" === a ? 2 : 1,
                                    tags: u
                                };
                                null !== e1.id && (f.id = e1.id), t1.features.push(f);
                            }
                        }
                        function wt(t1, e1, r, n, i, a) {
                            var o = n * n;
                            if (n > 0 && e1.size < (i ? o : n)) r.numPoints += e1.length / 3;
                            else {
                                for(var s = [], l = 0; l < e1.length; l += 3)(0 === n || e1[l + 2] > o) && (r.numSimplified++, s.push(e1[l]), s.push(e1[l + 1])), r.numPoints++;
                                i && function(t1, e1) {
                                    for(var r = 0, n = 0, i = t1.length, a = i - 2; n < i; a = n, n += 2)r += (t1[n] - t1[a]) * (t1[n + 1] + t1[a + 1]);
                                    if (r > 0 === e1) for(n = 0, i = t1.length; n < i / 2; n += 2){
                                        var o = t1[n], s = t1[n + 1];
                                        t1[n] = t1[i - 2 - n], t1[n + 1] = t1[i - 1 - n], t1[i - 2 - n] = o, t1[i - 1 - n] = s;
                                    }
                                }(s, a), t1.push(s);
                            }
                        }
                        function Tt(t1, e1) {
                            var r = (e1 = this.options = function(t1, e1) {
                                for(var r in e1)t1[r] = e1[r];
                                return t1;
                            }(Object.create(this.options), e1)).debug;
                            if (r && console.time("preprocess data"), e1.maxZoom < 0 || e1.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
                            if (e1.promoteId && e1.generateId) throw new Error("promoteId and generateId cannot be used together.");
                            var n = function(t1, e1) {
                                var r = [];
                                if ("FeatureCollection" === t1.type) for(var n = 0; n < t1.features.length; n++)rt(r, t1.features[n], e1, n);
                                else "Feature" === t1.type ? rt(r, t1, e1) : rt(r, {
                                    geometry: t1
                                }, e1);
                                return r;
                            }(t1, e1);
                            this.tiles = {}, this.tileCoords = [], r && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", e1.indexMaxZoom, e1.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), (n = function(t1, e1) {
                                var r = e1.buffer / e1.extent, n = t1, i = lt(t1, 1, -1 - r, r, 0, -1, 2, e1), a = lt(t1, 1, 1 - r, 2 + r, 0, -1, 2, e1);
                                return (i || a) && (n = lt(t1, 1, -r, 1 + r, 0, -1, 2, e1) || [], i && (n = gt(i, 1).concat(n)), a && (n = n.concat(gt(a, -1)))), n;
                            }(n, e1)).length && this.splitTile(n, 0, 0, 0), r && (n.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
                        }
                        function kt(t1, e1, r) {
                            return 32 * ((1 << t1) * r + e1) + t1;
                        }
                        function At(t1, e1) {
                            var r = t1.tileID.canonical;
                            if (!this._geoJSONIndex) return e1(null, null);
                            var n = this._geoJSONIndex.getTile(r.z, r.x, r.y);
                            if (!n) return e1(null, null);
                            var i = new g(n.features), a = b(i);
                            0 === a.byteOffset && a.byteLength === a.buffer.byteLength || (a = new Uint8Array(a)), e1(null, {
                                vectorTile: i,
                                rawData: a.buffer
                            });
                        }
                        V.prototype.load = function(t1) {
                            var e1 = this.options, r = e1.log, n = e1.minZoom, i = e1.maxZoom, a = e1.nodeSize;
                            r && console.time("total time");
                            var o = "prepare " + t1.length + " points";
                            r && console.time(o), this.points = t1;
                            for(var s = [], l = 0; l < t1.length; l++)t1[l].geometry && s.push(H(t1[l], l));
                            this.trees[i + 1] = new j(s, $, J, a, Float32Array), r && console.timeEnd(o);
                            for(var c = i; c >= n; c--){
                                var u = +Date.now();
                                s = this._cluster(s, c), this.trees[c] = new j(s, $, J, a, Float32Array), r && console.log("z%d: %d clusters in %dms", c, s.length, +Date.now() - u);
                            }
                            return r && console.timeEnd("total time"), this;
                        }, V.prototype.getClusters = function(t1, e1) {
                            var r = ((t1[0] + 180) % 360 + 360) % 360 - 180, n = Math.max(-90, Math.min(90, t1[1])), i = 180 === t1[2] ? 180 : ((t1[2] + 180) % 360 + 360) % 360 - 180, a = Math.max(-90, Math.min(90, t1[3]));
                            if (t1[2] - t1[0] >= 360) r = -180, i = 180;
                            else if (r > i) {
                                var o = this.getClusters([
                                    r,
                                    n,
                                    180,
                                    a
                                ], e1), s = this.getClusters([
                                    -180,
                                    n,
                                    i,
                                    a
                                ], e1);
                                return o.concat(s);
                            }
                            for(var l = this.trees[this._limitZoom(e1)], c = [], u = 0, h = l.range(W(r), Y(a), W(i), Y(n)); u < h.length; u += 1){
                                var f = h[u], p = l.points[f];
                                c.push(p.numPoints ? G(p) : this.points[p.index]);
                            }
                            return c;
                        }, V.prototype.getChildren = function(t1) {
                            var e1 = this._getOriginId(t1), r = this._getOriginZoom(t1), n = "No cluster with the specified id.", i = this.trees[r];
                            if (!i) throw new Error(n);
                            var a = i.points[e1];
                            if (!a) throw new Error(n);
                            for(var o = this.options.radius / (this.options.extent * Math.pow(2, r - 1)), s = [], l = 0, c = i.within(a.x, a.y, o); l < c.length; l += 1){
                                var u = c[l], h = i.points[u];
                                h.parentId === t1 && s.push(h.numPoints ? G(h) : this.points[h.index]);
                            }
                            if (0 === s.length) throw new Error(n);
                            return s;
                        }, V.prototype.getLeaves = function(t1, e1, r) {
                            e1 = e1 || 10, r = r || 0;
                            var n = [];
                            return this._appendLeaves(n, t1, e1, r, 0), n;
                        }, V.prototype.getTile = function(t1, e1, r) {
                            var n = this.trees[this._limitZoom(t1)], i = Math.pow(2, t1), a = this.options, o = a.extent, s = a.radius / o, l = (r - s) / i, c = (r + 1 + s) / i, u = {
                                features: []
                            };
                            return this._addTileFeatures(n.range((e1 - s) / i, l, (e1 + 1 + s) / i, c), n.points, e1, r, i, u), 0 === e1 && this._addTileFeatures(n.range(1 - s / i, l, 1, c), n.points, i, r, i, u), e1 === i - 1 && this._addTileFeatures(n.range(0, l, s / i, c), n.points, -1, r, i, u), u.features.length ? u : null;
                        }, V.prototype.getClusterExpansionZoom = function(t1) {
                            for(var e1 = this._getOriginZoom(t1) - 1; e1 <= this.options.maxZoom;){
                                var r = this.getChildren(t1);
                                if (e1++, 1 !== r.length) break;
                                t1 = r[0].properties.cluster_id;
                            }
                            return e1;
                        }, V.prototype._appendLeaves = function(t1, e1, r, n, i) {
                            for(var a = 0, o = this.getChildren(e1); a < o.length; a += 1){
                                var s = o[a], l = s.properties;
                                if (l && l.cluster ? i + l.point_count <= n ? i += l.point_count : i = this._appendLeaves(t1, l.cluster_id, r, n, i) : i < n ? i++ : t1.push(s), t1.length === r) break;
                            }
                            return i;
                        }, V.prototype._addTileFeatures = function(t1, e1, r, n, i, a) {
                            for(var o = 0, s = t1; o < s.length; o += 1){
                                var l = e1[s[o]], c = l.numPoints, u = {
                                    type: 1,
                                    geometry: [
                                        [
                                            Math.round(this.options.extent * (l.x * i - r)),
                                            Math.round(this.options.extent * (l.y * i - n))
                                        ]
                                    ],
                                    tags: c ? Z(l) : this.points[l.index].properties
                                }, h = void 0;
                                c ? h = l.id : this.options.generateId ? h = l.index : this.points[l.index].id && (h = this.points[l.index].id), void 0 !== h && (u.id = h), a.features.push(u);
                            }
                        }, V.prototype._limitZoom = function(t1) {
                            return Math.max(this.options.minZoom, Math.min(+t1, this.options.maxZoom + 1));
                        }, V.prototype._cluster = function(t1, e1) {
                            for(var r = [], n = this.options, i = n.radius, a = n.extent, o = n.reduce, s = n.minPoints, l = i / (a * Math.pow(2, e1)), c = 0; c < t1.length; c++){
                                var u = t1[c];
                                if (!(u.zoom <= e1)) {
                                    u.zoom = e1;
                                    for(var h = this.trees[e1 + 1], f = h.within(u.x, u.y, l), p = u.numPoints || 1, d = p, m = 0, g = f; m < g.length; m += 1){
                                        var y = g[m], v = h.points[y];
                                        v.zoom > e1 && (d += v.numPoints || 1);
                                    }
                                    if (d >= s) {
                                        for(var x = u.x * p, _ = u.y * p, b = o && p > 1 ? this._map(u, !0) : null, w = (c << 5) + (e1 + 1) + this.points.length, T = 0, k = f; T < k.length; T += 1){
                                            var A = k[T], M = h.points[A];
                                            if (!(M.zoom <= e1)) {
                                                M.zoom = e1;
                                                var S = M.numPoints || 1;
                                                x += M.x * S, _ += M.y * S, M.parentId = w, o && (b || (b = this._map(u, !0)), o(b, this._map(M)));
                                            }
                                        }
                                        u.parentId = w, r.push(q(x / d, _ / d, w, d, b));
                                    } else if (r.push(u), d > 1) for(var E = 0, C = f; E < C.length; E += 1){
                                        var L = C[E], I = h.points[L];
                                        I.zoom <= e1 || (I.zoom = e1, r.push(I));
                                    }
                                }
                            }
                            return r;
                        }, V.prototype._getOriginId = function(t1) {
                            return t1 - this.points.length >> 5;
                        }, V.prototype._getOriginZoom = function(t1) {
                            return (t1 - this.points.length) % 32;
                        }, V.prototype._map = function(t1, e1) {
                            if (t1.numPoints) return e1 ? X({}, t1.properties) : t1.properties;
                            var r = this.points[t1.index].properties, n = this.options.map(r);
                            return e1 && n === r ? X({}, n) : n;
                        }, Tt.prototype.options = {
                            maxZoom: 14,
                            indexMaxZoom: 5,
                            indexMaxPoints: 1e5,
                            tolerance: 3,
                            extent: 4096,
                            buffer: 64,
                            lineMetrics: !1,
                            promoteId: null,
                            generateId: !1,
                            debug: 0
                        }, Tt.prototype.splitTile = function(t1, e1, r, n, i, a, o) {
                            for(var s = [
                                t1,
                                e1,
                                r,
                                n
                            ], l = this.options, c = l.debug; s.length;){
                                n = s.pop(), r = s.pop(), e1 = s.pop(), t1 = s.pop();
                                var u = 1 << e1, h = kt(e1, r, n), f = this.tiles[h];
                                if (!f && (c > 1 && console.time("creation"), f = this.tiles[h] = _t(t1, e1, r, n, l), this.tileCoords.push({
                                    z: e1,
                                    x: r,
                                    y: n
                                }), c)) {
                                    c > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", e1, r, n, f.numFeatures, f.numPoints, f.numSimplified), console.timeEnd("creation"));
                                    var p = "z" + e1;
                                    this.stats[p] = (this.stats[p] || 0) + 1, this.total++;
                                }
                                if (f.source = t1, i) {
                                    if (e1 === l.maxZoom || e1 === i) continue;
                                    var d = 1 << i - e1;
                                    if (r !== Math.floor(a / d) || n !== Math.floor(o / d)) continue;
                                } else if (e1 === l.indexMaxZoom || f.numPoints <= l.indexMaxPoints) continue;
                                if (f.source = null, 0 !== t1.length) {
                                    c > 1 && console.time("clipping");
                                    var m, g, y, v, x, _, b = .5 * l.buffer / l.extent, w = .5 - b, T = .5 + b, k = 1 + b;
                                    m = g = y = v = null, x = lt(t1, u, r - b, r + T, 0, f.minX, f.maxX, l), _ = lt(t1, u, r + w, r + k, 0, f.minX, f.maxX, l), t1 = null, x && (m = lt(x, u, n - b, n + T, 1, f.minY, f.maxY, l), g = lt(x, u, n + w, n + k, 1, f.minY, f.maxY, l), x = null), _ && (y = lt(_, u, n - b, n + T, 1, f.minY, f.maxY, l), v = lt(_, u, n + w, n + k, 1, f.minY, f.maxY, l), _ = null), c > 1 && console.timeEnd("clipping"), s.push(m || [], e1 + 1, 2 * r, 2 * n), s.push(g || [], e1 + 1, 2 * r, 2 * n + 1), s.push(y || [], e1 + 1, 2 * r + 1, 2 * n), s.push(v || [], e1 + 1, 2 * r + 1, 2 * n + 1);
                                }
                            }
                        }, Tt.prototype.getTile = function(t1, e1, r) {
                            var n = this.options, i = n.extent, a = n.debug;
                            if (t1 < 0 || t1 > 24) return null;
                            var o = 1 << t1, s = kt(t1, e1 = (e1 % o + o) % o, r);
                            if (this.tiles[s]) return vt(this.tiles[s], i);
                            a > 1 && console.log("drilling down to z%d-%d-%d", t1, e1, r);
                            for(var l, c = t1, u = e1, h = r; !l && c > 0;)c--, u = Math.floor(u / 2), h = Math.floor(h / 2), l = this.tiles[kt(c, u, h)];
                            return l && l.source ? (a > 1 && console.log("found parent tile z%d-%d-%d", c, u, h), a > 1 && console.time("drilling down"), this.splitTile(l.source, c, u, h, t1, e1, r), a > 1 && console.timeEnd("drilling down"), this.tiles[s] ? vt(this.tiles[s], i) : null) : null;
                        };
                        var Mt = function(e1) {
                            function r(t1, r, n, i) {
                                e1.call(this, t1, r, n, At), i && (this.loadGeoJSON = i);
                            }
                            return e1 && (r.__proto__ = e1), r.prototype = Object.create(e1 && e1.prototype), r.prototype.constructor = r, r.prototype.loadData = function(t1, e1) {
                                this._pendingCallback && this._pendingCallback(null, {
                                    abandoned: !0
                                }), this._pendingCallback = e1, this._pendingLoadDataParams = t1, this._state && "Idle" !== this._state ? this._state = "NeedsLoadData" : (this._state = "Coalescing", this._loadData());
                            }, r.prototype._loadData = function() {
                                var e1 = this;
                                if (this._pendingCallback && this._pendingLoadDataParams) {
                                    var r = this._pendingCallback, n = this._pendingLoadDataParams;
                                    delete this._pendingCallback, delete this._pendingLoadDataParams;
                                    var i = !!(n && n.request && n.request.collectResourceTiming) && new t1.RequestPerformance(n.request);
                                    this.loadGeoJSON(n, function(a, o) {
                                        if (a || !o) return r(a);
                                        if ("object" != typeof o) return r(new Error("Input data given to '" + n.source + "' is not a valid GeoJSON object."));
                                        h(o, !0);
                                        try {
                                            if (n.filter) {
                                                var s = t1.createExpression(n.filter, {
                                                    type: "boolean",
                                                    "property-type": "data-driven",
                                                    overridable: !1,
                                                    transition: !1
                                                });
                                                if ("error" === s.result) throw new Error(s.value.map(function(t1) {
                                                    return t1.key + ": " + t1.message;
                                                }).join(", "));
                                                var l = o.features.filter(function(t1) {
                                                    return s.value.evaluate({
                                                        zoom: 0
                                                    }, t1);
                                                });
                                                o = {
                                                    type: "FeatureCollection",
                                                    features: l
                                                };
                                            }
                                            e1._geoJSONIndex = n.cluster ? new V(function(e1) {
                                                var r = e1.superclusterOptions, n = e1.clusterProperties;
                                                if (!n || !r) return r;
                                                for(var i = {}, a = {}, o = {
                                                    accumulated: null,
                                                    zoom: 0
                                                }, s = {
                                                    properties: null
                                                }, l = Object.keys(n), c = 0, u = l; c < u.length; c += 1){
                                                    var h = u[c], f = n[h], p = f[0], d = f[1], m = t1.createExpression(d), g = t1.createExpression("string" == typeof p ? [
                                                        p,
                                                        [
                                                            "accumulated"
                                                        ],
                                                        [
                                                            "get",
                                                            h
                                                        ]
                                                    ] : p);
                                                    i[h] = m.value, a[h] = g.value;
                                                }
                                                return r.map = function(t1) {
                                                    s.properties = t1;
                                                    for(var e1 = {}, r = 0, n = l; r < n.length; r += 1){
                                                        var a = n[r];
                                                        e1[a] = i[a].evaluate(o, s);
                                                    }
                                                    return e1;
                                                }, r.reduce = function(t1, e1) {
                                                    s.properties = e1;
                                                    for(var r = 0, n = l; r < n.length; r += 1){
                                                        var i = n[r];
                                                        o.accumulated = t1[i], t1[i] = a[i].evaluate(o, s);
                                                    }
                                                }, r;
                                            }(n)).load(o.features) : function(t1, e1) {
                                                return new Tt(t1, e1);
                                            }(o, n.geojsonVtOptions);
                                        } catch (a) {
                                            return r(a);
                                        }
                                        e1.loaded = {};
                                        var c = {};
                                        if (i) {
                                            var u = i.finish();
                                            u && (c.resourceTiming = {}, c.resourceTiming[n.source] = JSON.parse(JSON.stringify(u)));
                                        }
                                        r(null, c);
                                    });
                                }
                            }, r.prototype.coalesce = function() {
                                "Coalescing" === this._state ? this._state = "Idle" : "NeedsLoadData" === this._state && (this._state = "Coalescing", this._loadData());
                            }, r.prototype.reloadTile = function(t1, r) {
                                var n = this.loaded, i = t1.uid;
                                return n && n[i] ? e1.prototype.reloadTile.call(this, t1, r) : this.loadTile(t1, r);
                            }, r.prototype.loadGeoJSON = function(e1, r) {
                                if (e1.request) t1.getJSON(e1.request, r);
                                else {
                                    if ("string" != typeof e1.data) return r(new Error("Input data given to '" + e1.source + "' is not a valid GeoJSON object."));
                                    try {
                                        return r(null, JSON.parse(e1.data));
                                    } catch (t1) {
                                        return r(new Error("Input data given to '" + e1.source + "' is not a valid GeoJSON object."));
                                    }
                                }
                            }, r.prototype.removeSource = function(t1, e1) {
                                this._pendingCallback && this._pendingCallback(null, {
                                    abandoned: !0
                                }), e1();
                            }, r.prototype.getClusterExpansionZoom = function(t1, e1) {
                                try {
                                    e1(null, this._geoJSONIndex.getClusterExpansionZoom(t1.clusterId));
                                } catch (t1) {
                                    e1(t1);
                                }
                            }, r.prototype.getClusterChildren = function(t1, e1) {
                                try {
                                    e1(null, this._geoJSONIndex.getChildren(t1.clusterId));
                                } catch (t1) {
                                    e1(t1);
                                }
                            }, r.prototype.getClusterLeaves = function(t1, e1) {
                                try {
                                    e1(null, this._geoJSONIndex.getLeaves(t1.clusterId, t1.limit, t1.offset));
                                } catch (t1) {
                                    e1(t1);
                                }
                            }, r;
                        }(l);
                        var St = function(e1) {
                            var r = this;
                            this.self = e1, this.actor = new t1.Actor(e1, this), this.layerIndexes = {}, this.availableImages = {}, this.workerSourceTypes = {
                                vector: l,
                                geojson: Mt
                            }, this.workerSources = {}, this.demWorkerSources = {}, this.self.registerWorkerSource = function(t1, e1) {
                                if (r.workerSourceTypes[t1]) throw new Error('Worker source with name "' + t1 + '" already registered.');
                                r.workerSourceTypes[t1] = e1;
                            }, this.self.registerRTLTextPlugin = function(e1) {
                                if (t1.plugin.isParsed()) throw new Error("RTL text plugin already registered.");
                                t1.plugin.applyArabicShaping = e1.applyArabicShaping, t1.plugin.processBidirectionalText = e1.processBidirectionalText, t1.plugin.processStyledBidirectionalText = e1.processStyledBidirectionalText;
                            };
                        };
                        return St.prototype.setReferrer = function(t1, e1) {
                            this.referrer = e1;
                        }, St.prototype.setImages = function(t1, e1, r) {
                            for(var n in this.availableImages[t1] = e1, this.workerSources[t1]){
                                var i = this.workerSources[t1][n];
                                for(var a in i)i[a].availableImages = e1;
                            }
                            r();
                        }, St.prototype.setLayers = function(t1, e1, r) {
                            this.getLayerIndex(t1).replace(e1), r();
                        }, St.prototype.updateLayers = function(t1, e1, r) {
                            this.getLayerIndex(t1).update(e1.layers, e1.removedIds), r();
                        }, St.prototype.loadTile = function(t1, e1, r) {
                            this.getWorkerSource(t1, e1.type, e1.source).loadTile(e1, r);
                        }, St.prototype.loadDEMTile = function(t1, e1, r) {
                            this.getDEMWorkerSource(t1, e1.source).loadTile(e1, r);
                        }, St.prototype.reloadTile = function(t1, e1, r) {
                            this.getWorkerSource(t1, e1.type, e1.source).reloadTile(e1, r);
                        }, St.prototype.abortTile = function(t1, e1, r) {
                            this.getWorkerSource(t1, e1.type, e1.source).abortTile(e1, r);
                        }, St.prototype.removeTile = function(t1, e1, r) {
                            this.getWorkerSource(t1, e1.type, e1.source).removeTile(e1, r);
                        }, St.prototype.removeDEMTile = function(t1, e1) {
                            this.getDEMWorkerSource(t1, e1.source).removeTile(e1);
                        }, St.prototype.removeSource = function(t1, e1, r) {
                            if (this.workerSources[t1] && this.workerSources[t1][e1.type] && this.workerSources[t1][e1.type][e1.source]) {
                                var n = this.workerSources[t1][e1.type][e1.source];
                                delete this.workerSources[t1][e1.type][e1.source], void 0 !== n.removeSource ? n.removeSource(e1, r) : r();
                            }
                        }, St.prototype.loadWorkerSource = function(t1, e1, r) {
                            try {
                                this.self.importScripts(e1.url), r();
                            } catch (t1) {
                                r(t1.toString());
                            }
                        }, St.prototype.syncRTLPluginState = function(e1, r, n) {
                            try {
                                t1.plugin.setState(r);
                                var i = t1.plugin.getPluginURL();
                                if (t1.plugin.isLoaded() && !t1.plugin.isParsed() && null != i) {
                                    this.self.importScripts(i);
                                    var a = t1.plugin.isParsed();
                                    n(a ? void 0 : new Error("RTL Text Plugin failed to import scripts from " + i), a);
                                }
                            } catch (t1) {
                                n(t1.toString());
                            }
                        }, St.prototype.getAvailableImages = function(t1) {
                            var e1 = this.availableImages[t1];
                            return e1 || (e1 = []), e1;
                        }, St.prototype.getLayerIndex = function(t1) {
                            var e1 = this.layerIndexes[t1];
                            return e1 || (e1 = this.layerIndexes[t1] = new n), e1;
                        }, St.prototype.getWorkerSource = function(t1, e1, r) {
                            var n = this;
                            if (this.workerSources[t1] || (this.workerSources[t1] = {}), this.workerSources[t1][e1] || (this.workerSources[t1][e1] = {}), !this.workerSources[t1][e1][r]) {
                                var i = {
                                    send: function(e1, r, i) {
                                        n.actor.send(e1, r, i, t1);
                                    }
                                };
                                this.workerSources[t1][e1][r] = new this.workerSourceTypes[e1](i, this.getLayerIndex(t1), this.getAvailableImages(t1));
                            }
                            return this.workerSources[t1][e1][r];
                        }, St.prototype.getDEMWorkerSource = function(t1, e1) {
                            return this.demWorkerSources[t1] || (this.demWorkerSources[t1] = {}), this.demWorkerSources[t1][e1] || (this.demWorkerSources[t1][e1] = new u), this.demWorkerSources[t1][e1];
                        }, St.prototype.enforceCacheSizeLimit = function(e1, r) {
                            t1.enforceCacheSizeLimit(r);
                        }, "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope && (self.worker = new St(self)), St;
                    }), n(0, function(t1) {
                        var e1 = t1.createCommonjsModule(function(t1) {
                            function e1(t1) {
                                return !r(t1);
                            }
                            function r(t1) {
                                var r;
                                return "undefined" != typeof window && "undefined" != typeof document ? Array.prototype && Array.prototype.every && Array.prototype.filter && Array.prototype.forEach && Array.prototype.indexOf && Array.prototype.lastIndexOf && Array.prototype.map && Array.prototype.some && Array.prototype.reduce && Array.prototype.reduceRight && Array.isArray ? Function.prototype && Function.prototype.bind ? Object.keys && Object.create && Object.getPrototypeOf && Object.getOwnPropertyNames && Object.isSealed && Object.isFrozen && Object.isExtensible && Object.getOwnPropertyDescriptor && Object.defineProperty && Object.defineProperties && Object.seal && Object.freeze && Object.preventExtensions ? "JSON" in window && "parse" in JSON && "stringify" in JSON ? function() {
                                    if (!("Worker" in window && "Blob" in window && "URL" in window)) return !1;
                                    var t1, e1, r = new Blob([
                                        ""
                                    ], {
                                        type: "text/javascript"
                                    }), n = URL.createObjectURL(r);
                                    try {
                                        e1 = new Worker(n), t1 = !0;
                                    } catch (e1) {
                                        t1 = !1;
                                    }
                                    return e1 && e1.terminate(), URL.revokeObjectURL(n), t1;
                                }() ? "Uint8ClampedArray" in window ? ArrayBuffer.isView ? function() {
                                    var t1 = document.createElement("canvas");
                                    t1.width = t1.height = 1;
                                    var e1 = t1.getContext("2d");
                                    if (!e1) return !1;
                                    var r = e1.getImageData(0, 0, 1, 1);
                                    return r && r.width === t1.width;
                                }() ? (r = t1 && t1.failIfMajorPerformanceCaveat, void 0 === n[r] && (n[r] = function(t1) {
                                    var r = function(t1) {
                                        var r = document.createElement("canvas"), n = Object.create(e1.webGLContextAttributes);
                                        return n.failIfMajorPerformanceCaveat = t1, r.probablySupportsContext ? r.probablySupportsContext("webgl", n) || r.probablySupportsContext("experimental-webgl", n) : r.supportsContext ? r.supportsContext("webgl", n) || r.supportsContext("experimental-webgl", n) : r.getContext("webgl", n) || r.getContext("experimental-webgl", n);
                                    }(t1);
                                    if (!r) return !1;
                                    var n = r.createShader(r.VERTEX_SHADER);
                                    return !(!n || r.isContextLost()) && (r.shaderSource(n, "void main() {}"), r.compileShader(n), !0 === r.getShaderParameter(n, r.COMPILE_STATUS));
                                }(r)), n[r] ? void 0 : "insufficient WebGL support") : "insufficient Canvas/getImageData support" : "insufficient ArrayBuffer support" : "insufficient Uint8ClampedArray support" : "insufficient worker support" : "insufficient JSON support" : "insufficient Object support" : "insufficient Function support" : "insufficent Array support" : "not a browser";
                            }
                            t1.exports ? t1.exports = e1 : window && (window.mapboxgl = window.mapboxgl || {}, window.mapboxgl.supported = e1, window.mapboxgl.notSupportedReason = r);
                            var n = {};
                            e1.webGLContextAttributes = {
                                antialias: !1,
                                alpha: !0,
                                stencil: !0,
                                depth: !0
                            };
                        }), r = {
                            create: function(e1, r, n) {
                                var i = t1.window.document.createElement(e1);
                                return void 0 !== r && (i.className = r), n && n.appendChild(i), i;
                            },
                            createNS: function(e1, r) {
                                return t1.window.document.createElementNS(e1, r);
                            }
                        }, n = t1.window.document && t1.window.document.documentElement.style;
                        function i(t1) {
                            if (!n) return t1[0];
                            for(var e1 = 0; e1 < t1.length; e1++)if (t1[e1] in n) return t1[e1];
                            return t1[0];
                        }
                        var a, o = i([
                            "userSelect",
                            "MozUserSelect",
                            "WebkitUserSelect",
                            "msUserSelect"
                        ]);
                        r.disableDrag = function() {
                            n && o && (a = n[o], n[o] = "none");
                        }, r.enableDrag = function() {
                            n && o && (n[o] = a);
                        };
                        var s = i([
                            "transform",
                            "WebkitTransform"
                        ]);
                        r.setTransform = function(t1, e1) {
                            t1.style[s] = e1;
                        };
                        var l = !1;
                        try {
                            var c = Object.defineProperty({}, "passive", {
                                get: function() {
                                    l = !0;
                                }
                            });
                            t1.window.addEventListener("test", c, c), t1.window.removeEventListener("test", c, c);
                        } catch (t1) {
                            l = !1;
                        }
                        r.addEventListener = function(t1, e1, r, n) {
                            void 0 === n && (n = {}), "passive" in n && l ? t1.addEventListener(e1, r, n) : t1.addEventListener(e1, r, n.capture);
                        }, r.removeEventListener = function(t1, e1, r, n) {
                            void 0 === n && (n = {}), "passive" in n && l ? t1.removeEventListener(e1, r, n) : t1.removeEventListener(e1, r, n.capture);
                        };
                        var u = function(e1) {
                            e1.preventDefault(), e1.stopPropagation(), t1.window.removeEventListener("click", u, !0);
                        };
                        function h(t1) {
                            var e1 = t1.userImage;
                            return !!(e1 && e1.render && e1.render()) && (t1.data.replace(new Uint8Array(e1.data.buffer)), !0);
                        }
                        r.suppressClick = function() {
                            t1.window.addEventListener("click", u, !0), t1.window.setTimeout(function() {
                                t1.window.removeEventListener("click", u, !0);
                            }, 0);
                        }, r.mousePos = function(e1, r) {
                            var n = e1.getBoundingClientRect();
                            return new t1.Point(r.clientX - n.left - e1.clientLeft, r.clientY - n.top - e1.clientTop);
                        }, r.touchPos = function(e1, r) {
                            for(var n = e1.getBoundingClientRect(), i = [], a = 0; a < r.length; a++)i.push(new t1.Point(r[a].clientX - n.left - e1.clientLeft, r[a].clientY - n.top - e1.clientTop));
                            return i;
                        }, r.mouseButton = function(e1) {
                            return void 0 !== t1.window.InstallTrigger && 2 === e1.button && e1.ctrlKey && t1.window.navigator.platform.toUpperCase().indexOf("MAC") >= 0 ? 0 : e1.button;
                        }, r.remove = function(t1) {
                            t1.parentNode && t1.parentNode.removeChild(t1);
                        };
                        var f = function(e1) {
                            function r() {
                                e1.call(this), this.images = {}, this.updatedImages = {}, this.callbackDispatchedThisFrame = {}, this.loaded = !1, this.requestors = [], this.patterns = {}, this.atlasImage = new t1.RGBAImage({
                                    width: 1,
                                    height: 1
                                }), this.dirty = !0;
                            }
                            return e1 && (r.__proto__ = e1), r.prototype = Object.create(e1 && e1.prototype), r.prototype.constructor = r, r.prototype.isLoaded = function() {
                                return this.loaded;
                            }, r.prototype.setLoaded = function(t1) {
                                if (this.loaded !== t1 && (this.loaded = t1, t1)) {
                                    for(var e1 = 0, r = this.requestors; e1 < r.length; e1 += 1){
                                        var n = r[e1], i = n.ids, a = n.callback;
                                        this._notify(i, a);
                                    }
                                    this.requestors = [];
                                }
                            }, r.prototype.getImage = function(t1) {
                                return this.images[t1];
                            }, r.prototype.addImage = function(t1, e1) {
                                this._validate(t1, e1) && (this.images[t1] = e1);
                            }, r.prototype._validate = function(e1, r) {
                                var n = !0;
                                return this._validateStretch(r.stretchX, r.data && r.data.width) || (this.fire(new t1.ErrorEvent(new Error('Image "' + e1 + '" has invalid "stretchX" value'))), n = !1), this._validateStretch(r.stretchY, r.data && r.data.height) || (this.fire(new t1.ErrorEvent(new Error('Image "' + e1 + '" has invalid "stretchY" value'))), n = !1), this._validateContent(r.content, r) || (this.fire(new t1.ErrorEvent(new Error('Image "' + e1 + '" has invalid "content" value'))), n = !1), n;
                            }, r.prototype._validateStretch = function(t1, e1) {
                                if (!t1) return !0;
                                for(var r = 0, n = 0, i = t1; n < i.length; n += 1){
                                    var a = i[n];
                                    if (a[0] < r || a[1] < a[0] || e1 < a[1]) return !1;
                                    r = a[1];
                                }
                                return !0;
                            }, r.prototype._validateContent = function(t1, e1) {
                                return !(t1 && (4 !== t1.length || t1[0] < 0 || e1.data.width < t1[0] || t1[1] < 0 || e1.data.height < t1[1] || t1[2] < 0 || e1.data.width < t1[2] || t1[3] < 0 || e1.data.height < t1[3] || t1[2] < t1[0] || t1[3] < t1[1]));
                            }, r.prototype.updateImage = function(t1, e1) {
                                var r = this.images[t1];
                                e1.version = r.version + 1, this.images[t1] = e1, this.updatedImages[t1] = !0;
                            }, r.prototype.removeImage = function(t1) {
                                var e1 = this.images[t1];
                                delete this.images[t1], delete this.patterns[t1], e1.userImage && e1.userImage.onRemove && e1.userImage.onRemove();
                            }, r.prototype.listImages = function() {
                                return Object.keys(this.images);
                            }, r.prototype.getImages = function(t1, e1) {
                                var r = !0;
                                if (!this.isLoaded()) for(var n = 0, i = t1; n < i.length; n += 1){
                                    var a = i[n];
                                    this.images[a] || (r = !1);
                                }
                                this.isLoaded() || r ? this._notify(t1, e1) : this.requestors.push({
                                    ids: t1,
                                    callback: e1
                                });
                            }, r.prototype._notify = function(e1, r) {
                                for(var n = {}, i = 0, a = e1; i < a.length; i += 1){
                                    var o = a[i];
                                    this.images[o] || this.fire(new t1.Event("styleimagemissing", {
                                        id: o
                                    }));
                                    var s = this.images[o];
                                    s ? n[o] = {
                                        data: s.data.clone(),
                                        pixelRatio: s.pixelRatio,
                                        sdf: s.sdf,
                                        version: s.version,
                                        stretchX: s.stretchX,
                                        stretchY: s.stretchY,
                                        content: s.content,
                                        hasRenderCallback: Boolean(s.userImage && s.userImage.render)
                                    } : t1.warnOnce('Image "' + o + '" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.');
                                }
                                r(null, n);
                            }, r.prototype.getPixelSize = function() {
                                var t1 = this.atlasImage;
                                return {
                                    width: t1.width,
                                    height: t1.height
                                };
                            }, r.prototype.getPattern = function(e1) {
                                var r = this.patterns[e1], n = this.getImage(e1);
                                if (!n) return null;
                                if (r && r.position.version === n.version) return r.position;
                                if (r) r.position.version = n.version;
                                else {
                                    var i = {
                                        w: n.data.width + 2,
                                        h: n.data.height + 2,
                                        x: 0,
                                        y: 0
                                    }, a = new t1.ImagePosition(i, n);
                                    this.patterns[e1] = {
                                        bin: i,
                                        position: a
                                    };
                                }
                                return this._updatePatternAtlas(), this.patterns[e1].position;
                            }, r.prototype.bind = function(e1) {
                                var r = e1.gl;
                                this.atlasTexture ? this.dirty && (this.atlasTexture.update(this.atlasImage), this.dirty = !1) : this.atlasTexture = new t1.Texture(e1, this.atlasImage, r.RGBA), this.atlasTexture.bind(r.LINEAR, r.CLAMP_TO_EDGE);
                            }, r.prototype._updatePatternAtlas = function() {
                                var e1 = [];
                                for(var r in this.patterns)e1.push(this.patterns[r].bin);
                                var n = t1.potpack(e1), i = n.w, a = n.h, o = this.atlasImage;
                                for(var s in o.resize({
                                    width: i || 1,
                                    height: a || 1
                                }), this.patterns){
                                    var l = this.patterns[s].bin, c = l.x + 1, u = l.y + 1, h = this.images[s].data, f = h.width, p = h.height;
                                    t1.RGBAImage.copy(h, o, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        x: c,
                                        y: u
                                    }, {
                                        width: f,
                                        height: p
                                    }), t1.RGBAImage.copy(h, o, {
                                        x: 0,
                                        y: p - 1
                                    }, {
                                        x: c,
                                        y: u - 1
                                    }, {
                                        width: f,
                                        height: 1
                                    }), t1.RGBAImage.copy(h, o, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        x: c,
                                        y: u + p
                                    }, {
                                        width: f,
                                        height: 1
                                    }), t1.RGBAImage.copy(h, o, {
                                        x: f - 1,
                                        y: 0
                                    }, {
                                        x: c - 1,
                                        y: u
                                    }, {
                                        width: 1,
                                        height: p
                                    }), t1.RGBAImage.copy(h, o, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        x: c + f,
                                        y: u
                                    }, {
                                        width: 1,
                                        height: p
                                    });
                                }
                                this.dirty = !0;
                            }, r.prototype.beginFrame = function() {
                                this.callbackDispatchedThisFrame = {};
                            }, r.prototype.dispatchRenderCallbacks = function(t1) {
                                for(var e1 = 0, r = t1; e1 < r.length; e1 += 1){
                                    var n = r[e1];
                                    if (!this.callbackDispatchedThisFrame[n]) {
                                        this.callbackDispatchedThisFrame[n] = !0;
                                        var i = this.images[n];
                                        h(i) && this.updateImage(n, i);
                                    }
                                }
                            }, r;
                        }(t1.Evented);
                        var p = g, d = g, m = 1e20;
                        function g(t1, e1, r, n, i, a) {
                            this.fontSize = t1 || 24, this.buffer = void 0 === e1 ? 3 : e1, this.cutoff = n || .25, this.fontFamily = i || "sans-serif", this.fontWeight = a || "normal", this.radius = r || 8;
                            var o = this.size = this.fontSize + 2 * this.buffer;
                            this.canvas = document.createElement("canvas"), this.canvas.width = this.canvas.height = o, this.ctx = this.canvas.getContext("2d"), this.ctx.font = this.fontWeight + " " + this.fontSize + "px " + this.fontFamily, this.ctx.textBaseline = "middle", this.ctx.fillStyle = "black", this.gridOuter = new Float64Array(o * o), this.gridInner = new Float64Array(o * o), this.f = new Float64Array(o), this.d = new Float64Array(o), this.z = new Float64Array(o + 1), this.v = new Int16Array(o), this.middle = Math.round(o / 2 * (navigator.userAgent.indexOf("Gecko/") >= 0 ? 1.2 : 1));
                        }
                        function y(t1, e1, r, n, i, a, o) {
                            for(var s = 0; s < e1; s++){
                                for(var l = 0; l < r; l++)n[l] = t1[l * e1 + s];
                                for(v(n, i, a, o, r), l = 0; l < r; l++)t1[l * e1 + s] = i[l];
                            }
                            for(l = 0; l < r; l++){
                                for(s = 0; s < e1; s++)n[s] = t1[l * e1 + s];
                                for(v(n, i, a, o, e1), s = 0; s < e1; s++)t1[l * e1 + s] = Math.sqrt(i[s]);
                            }
                        }
                        function v(t1, e1, r, n, i) {
                            r[0] = 0, n[0] = -m, n[1] = +m;
                            for(var a = 1, o = 0; a < i; a++){
                                for(var s = (t1[a] + a * a - (t1[r[o]] + r[o] * r[o])) / (2 * a - 2 * r[o]); s <= n[o];)o--, s = (t1[a] + a * a - (t1[r[o]] + r[o] * r[o])) / (2 * a - 2 * r[o]);
                                r[++o] = a, n[o] = s, n[o + 1] = +m;
                            }
                            for(a = 0, o = 0; a < i; a++){
                                for(; n[o + 1] < a;)o++;
                                e1[a] = (a - r[o]) * (a - r[o]) + t1[r[o]];
                            }
                        }
                        g.prototype.draw = function(t1) {
                            this.ctx.clearRect(0, 0, this.size, this.size), this.ctx.fillText(t1, this.buffer, this.middle);
                            for(var e1 = this.ctx.getImageData(0, 0, this.size, this.size), r = new Uint8ClampedArray(this.size * this.size), n = 0; n < this.size * this.size; n++){
                                var i = e1.data[4 * n + 3] / 255;
                                this.gridOuter[n] = 1 === i ? 0 : 0 === i ? m : Math.pow(Math.max(0, .5 - i), 2), this.gridInner[n] = 1 === i ? m : 0 === i ? 0 : Math.pow(Math.max(0, i - .5), 2);
                            }
                            for(y(this.gridOuter, this.size, this.size, this.f, this.d, this.v, this.z), y(this.gridInner, this.size, this.size, this.f, this.d, this.v, this.z), n = 0; n < this.size * this.size; n++){
                                var a = this.gridOuter[n] - this.gridInner[n];
                                r[n] = Math.max(0, Math.min(255, Math.round(255 - 255 * (a / this.radius + this.cutoff))));
                            }
                            return r;
                        }, p.default = d;
                        var x = function(t1, e1) {
                            this.requestManager = t1, this.localIdeographFontFamily = e1, this.entries = {};
                        };
                        x.prototype.setURL = function(t1) {
                            this.url = t1;
                        }, x.prototype.getGlyphs = function(e1, r) {
                            var n = this, i = [];
                            for(var a in e1)for(var o = 0, s = e1[a]; o < s.length; o += 1){
                                var l = s[o];
                                i.push({
                                    stack: a,
                                    id: l
                                });
                            }
                            t1.asyncAll(i, function(t1, e1) {
                                var r = t1.stack, i = t1.id, a = n.entries[r];
                                a || (a = n.entries[r] = {
                                    glyphs: {},
                                    requests: {},
                                    ranges: {}
                                });
                                var o = a.glyphs[i];
                                if (void 0 === o) {
                                    if (o = n._tinySDF(a, r, i)) return a.glyphs[i] = o, void e1(null, {
                                        stack: r,
                                        id: i,
                                        glyph: o
                                    });
                                    var s = Math.floor(i / 256);
                                    if (256 * s > 65535) e1(new Error("glyphs > 65535 not supported"));
                                    else if (a.ranges[s]) e1(null, {
                                        stack: r,
                                        id: i,
                                        glyph: o
                                    });
                                    else {
                                        var l = a.requests[s];
                                        l || (l = a.requests[s] = [], x.loadGlyphRange(r, s, n.url, n.requestManager, function(t1, e1) {
                                            if (e1) {
                                                for(var r in e1)n._doesCharSupportLocalGlyph(+r) || (a.glyphs[+r] = e1[+r]);
                                                a.ranges[s] = !0;
                                            }
                                            for(var i = 0, o = l; i < o.length; i += 1)(0, o[i])(t1, e1);
                                            delete a.requests[s];
                                        })), l.push(function(t1, n) {
                                            t1 ? e1(t1) : n && e1(null, {
                                                stack: r,
                                                id: i,
                                                glyph: n[i] || null
                                            });
                                        });
                                    }
                                } else e1(null, {
                                    stack: r,
                                    id: i,
                                    glyph: o
                                });
                            }, function(t1, e1) {
                                if (t1) r(t1);
                                else if (e1) {
                                    for(var n = {}, i = 0, a = e1; i < a.length; i += 1){
                                        var o = a[i], s = o.stack, l = o.id, c = o.glyph;
                                        (n[s] || (n[s] = {}))[l] = c && {
                                            id: c.id,
                                            bitmap: c.bitmap.clone(),
                                            metrics: c.metrics
                                        };
                                    }
                                    r(null, n);
                                }
                            });
                        }, x.prototype._doesCharSupportLocalGlyph = function(e1) {
                            return !!this.localIdeographFontFamily && (t1.isChar["CJK Unified Ideographs"](e1) || t1.isChar["Hangul Syllables"](e1) || t1.isChar.Hiragana(e1) || t1.isChar.Katakana(e1));
                        }, x.prototype._tinySDF = function(e1, r, n) {
                            var i = this.localIdeographFontFamily;
                            if (i && this._doesCharSupportLocalGlyph(n)) {
                                var a = e1.tinySDF;
                                if (!a) {
                                    var o = "400";
                                    /bold/i.test(r) ? o = "900" : /medium/i.test(r) ? o = "500" : /light/i.test(r) && (o = "200"), a = e1.tinySDF = new x.TinySDF(24, 3, 8, .25, i, o);
                                }
                                return {
                                    id: n,
                                    bitmap: new t1.AlphaImage({
                                        width: 30,
                                        height: 30
                                    }, a.draw(String.fromCharCode(n))),
                                    metrics: {
                                        width: 24,
                                        height: 24,
                                        left: 0,
                                        top: -8,
                                        advance: 24
                                    }
                                };
                            }
                        }, x.loadGlyphRange = function(e1, r, n, i, a) {
                            var o = 256 * r, s = o + 255, l = i.transformRequest(i.normalizeGlyphsURL(n).replace("{fontstack}", e1).replace("{range}", o + "-" + s), t1.ResourceType.Glyphs);
                            t1.getArrayBuffer(l, function(e1, r) {
                                if (e1) a(e1);
                                else if (r) {
                                    for(var n = {}, i = 0, o = t1.parseGlyphPBF(r); i < o.length; i += 1){
                                        var s = o[i];
                                        n[s.id] = s;
                                    }
                                    a(null, n);
                                }
                            });
                        }, x.TinySDF = p;
                        var _ = function() {
                            this.specification = t1.styleSpec.light.position;
                        };
                        _.prototype.possiblyEvaluate = function(e1, r) {
                            return t1.sphericalToCartesian(e1.expression.evaluate(r));
                        }, _.prototype.interpolate = function(e1, r, n) {
                            return {
                                x: t1.number(e1.x, r.x, n),
                                y: t1.number(e1.y, r.y, n),
                                z: t1.number(e1.z, r.z, n)
                            };
                        };
                        var b = new t1.Properties({
                            anchor: new t1.DataConstantProperty(t1.styleSpec.light.anchor),
                            position: new _,
                            color: new t1.DataConstantProperty(t1.styleSpec.light.color),
                            intensity: new t1.DataConstantProperty(t1.styleSpec.light.intensity)
                        }), w = "-transition", T = function(e1) {
                            function r(r) {
                                e1.call(this), this._transitionable = new t1.Transitionable(b), this.setLight(r), this._transitioning = this._transitionable.untransitioned();
                            }
                            return e1 && (r.__proto__ = e1), r.prototype = Object.create(e1 && e1.prototype), r.prototype.constructor = r, r.prototype.getLight = function() {
                                return this._transitionable.serialize();
                            }, r.prototype.setLight = function(e1, r) {
                                if (void 0 === r && (r = {}), !this._validate(t1.validateLight, e1, r)) for(var n in e1){
                                    var i = e1[n];
                                    t1.endsWith(n, w) ? this._transitionable.setTransition(n.slice(0, -11), i) : this._transitionable.setValue(n, i);
                                }
                            }, r.prototype.updateTransitions = function(t1) {
                                this._transitioning = this._transitionable.transitioned(t1, this._transitioning);
                            }, r.prototype.hasTransition = function() {
                                return this._transitioning.hasTransition();
                            }, r.prototype.recalculate = function(t1) {
                                this.properties = this._transitioning.possiblyEvaluate(t1);
                            }, r.prototype._validate = function(e1, r, n) {
                                return (!n || !1 !== n.validate) && t1.emitValidationErrors(this, e1.call(t1.validateStyle, t1.extend({
                                    value: r,
                                    style: {
                                        glyphs: !0,
                                        sprite: !0
                                    },
                                    styleSpec: t1.styleSpec
                                })));
                            }, r;
                        }(t1.Evented), k = function(t1, e1) {
                            this.width = t1, this.height = e1, this.nextRow = 0, this.data = new Uint8Array(this.width * this.height), this.dashEntry = {};
                        };
                        k.prototype.getDash = function(t1, e1) {
                            var r = t1.join(",") + String(e1);
                            return this.dashEntry[r] || (this.dashEntry[r] = this.addDash(t1, e1)), this.dashEntry[r];
                        }, k.prototype.getDashRanges = function(t1, e1, r) {
                            var n = [], i = t1.length % 2 == 1 ? -t1[t1.length - 1] * r : 0, a = t1[0] * r, o = !0;
                            n.push({
                                left: i,
                                right: a,
                                isDash: o,
                                zeroLength: 0 === t1[0]
                            });
                            for(var s = t1[0], l = 1; l < t1.length; l++){
                                o = !o;
                                var c = t1[l];
                                i = s * r, a = (s += c) * r, n.push({
                                    left: i,
                                    right: a,
                                    isDash: o,
                                    zeroLength: 0 === c
                                });
                            }
                            return n;
                        }, k.prototype.addRoundDash = function(t1, e1, r) {
                            for(var n = e1 / 2, i = -r; i <= r; i++)for(var a = this.nextRow + r + i, o = this.width * a, s = 0, l = t1[s], c = 0; c < this.width; c++){
                                c / l.right > 1 && (l = t1[++s]);
                                var u = Math.abs(c - l.left), h = Math.abs(c - l.right), f = Math.min(u, h), p = void 0, d = i / r * (n + 1);
                                if (l.isDash) {
                                    var m = n - Math.abs(d);
                                    p = Math.sqrt(f * f + m * m);
                                } else p = n - Math.sqrt(f * f + d * d);
                                this.data[o + c] = Math.max(0, Math.min(255, p + 128));
                            }
                        }, k.prototype.addRegularDash = function(t1) {
                            for(var e1 = t1.length - 1; e1 >= 0; --e1){
                                var r = t1[e1], n = t1[e1 + 1];
                                r.zeroLength ? t1.splice(e1, 1) : n && n.isDash === r.isDash && (n.left = r.left, t1.splice(e1, 1));
                            }
                            var i = t1[0], a = t1[t1.length - 1];
                            i.isDash === a.isDash && (i.left = a.left - this.width, a.right = i.right + this.width);
                            for(var o = this.width * this.nextRow, s = 0, l = t1[s], c = 0; c < this.width; c++){
                                c / l.right > 1 && (l = t1[++s]);
                                var u = Math.abs(c - l.left), h = Math.abs(c - l.right), f = Math.min(u, h), p = l.isDash ? f : -f;
                                this.data[o + c] = Math.max(0, Math.min(255, p + 128));
                            }
                        }, k.prototype.addDash = function(e1, r) {
                            var n = r ? 7 : 0, i = 2 * n + 1;
                            if (this.nextRow + i > this.height) return t1.warnOnce("LineAtlas out of space"), null;
                            for(var a = 0, o = 0; o < e1.length; o++)a += e1[o];
                            if (0 !== a) {
                                var s = this.width / a, l = this.getDashRanges(e1, this.width, s);
                                r ? this.addRoundDash(l, s, n) : this.addRegularDash(l);
                            }
                            var c = {
                                y: (this.nextRow + n + .5) / this.height,
                                height: 2 * n / this.height,
                                width: a
                            };
                            return this.nextRow += i, this.dirty = !0, c;
                        }, k.prototype.bind = function(t1) {
                            var e1 = t1.gl;
                            this.texture ? (e1.bindTexture(e1.TEXTURE_2D, this.texture), this.dirty && (this.dirty = !1, e1.texSubImage2D(e1.TEXTURE_2D, 0, 0, 0, this.width, this.height, e1.ALPHA, e1.UNSIGNED_BYTE, this.data))) : (this.texture = e1.createTexture(), e1.bindTexture(e1.TEXTURE_2D, this.texture), e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_WRAP_S, e1.REPEAT), e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_WRAP_T, e1.REPEAT), e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_MIN_FILTER, e1.LINEAR), e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_MAG_FILTER, e1.LINEAR), e1.texImage2D(e1.TEXTURE_2D, 0, e1.ALPHA, this.width, this.height, 0, e1.ALPHA, e1.UNSIGNED_BYTE, this.data));
                        };
                        var A = function e1(r, n) {
                            this.workerPool = r, this.actors = [], this.currentActor = 0, this.id = t1.uniqueId();
                            for(var i = this.workerPool.acquire(this.id), a = 0; a < i.length; a++){
                                var o = i[a], s = new e1.Actor(o, n, this.id);
                                s.name = "Worker " + a, this.actors.push(s);
                            }
                        };
                        function M(e1, r, n) {
                            var i = function(i, a) {
                                if (i) return n(i);
                                if (a) {
                                    var o = t1.pick(t1.extend(a, e1), [
                                        "tiles",
                                        "minzoom",
                                        "maxzoom",
                                        "attribution",
                                        "mapbox_logo",
                                        "bounds",
                                        "scheme",
                                        "tileSize",
                                        "encoding"
                                    ]);
                                    a.vector_layers && (o.vectorLayers = a.vector_layers, o.vectorLayerIds = o.vectorLayers.map(function(t1) {
                                        return t1.id;
                                    })), o.tiles = r.canonicalizeTileset(o, e1.url), n(null, o);
                                }
                            };
                            return e1.url ? t1.getJSON(r.transformRequest(r.normalizeSourceURL(e1.url), t1.ResourceType.Source), i) : t1.browser.frame(function() {
                                return i(null, e1);
                            });
                        }
                        A.prototype.broadcast = function(e1, r, n) {
                            n = n || function() {}, t1.asyncAll(this.actors, function(t1, n) {
                                t1.send(e1, r, n);
                            }, n);
                        }, A.prototype.getActor = function() {
                            return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
                        }, A.prototype.remove = function() {
                            this.actors.forEach(function(t1) {
                                t1.remove();
                            }), this.actors = [], this.workerPool.release(this.id);
                        }, A.Actor = t1.Actor;
                        var S = function(e1, r, n) {
                            this.bounds = t1.LngLatBounds.convert(this.validateBounds(e1)), this.minzoom = r || 0, this.maxzoom = n || 24;
                        };
                        S.prototype.validateBounds = function(t1) {
                            return Array.isArray(t1) && 4 === t1.length ? [
                                Math.max(-180, t1[0]),
                                Math.max(-90, t1[1]),
                                Math.min(180, t1[2]),
                                Math.min(90, t1[3])
                            ] : [
                                -180,
                                -90,
                                180,
                                90
                            ];
                        }, S.prototype.contains = function(e1) {
                            var r = Math.pow(2, e1.z), n = Math.floor(t1.mercatorXfromLng(this.bounds.getWest()) * r), i = Math.floor(t1.mercatorYfromLat(this.bounds.getNorth()) * r), a = Math.ceil(t1.mercatorXfromLng(this.bounds.getEast()) * r), o = Math.ceil(t1.mercatorYfromLat(this.bounds.getSouth()) * r);
                            return e1.x >= n && e1.x < a && e1.y >= i && e1.y < o;
                        };
                        var E = function(e1) {
                            function r(r, n, i, a) {
                                if (e1.call(this), this.id = r, this.dispatcher = i, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, t1.extend(this, t1.pick(n, [
                                    "url",
                                    "scheme",
                                    "tileSize",
                                    "promoteId"
                                ])), this._options = t1.extend({
                                    type: "vector"
                                }, n), this._collectResourceTiming = n.collectResourceTiming, 512 !== this.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
                                this.setEventedParent(a);
                            }
                            return e1 && (r.__proto__ = e1), r.prototype = Object.create(e1 && e1.prototype), r.prototype.constructor = r, r.prototype.load = function() {
                                var e1 = this;
                                this._loaded = !1, this.fire(new t1.Event("dataloading", {
                                    dataType: "source"
                                })), this._tileJSONRequest = M(this._options, this.map._requestManager, function(r, n) {
                                    e1._tileJSONRequest = null, e1._loaded = !0, r ? e1.fire(new t1.ErrorEvent(r)) : n && (t1.extend(e1, n), n.bounds && (e1.tileBounds = new S(n.bounds, e1.minzoom, e1.maxzoom)), t1.postTurnstileEvent(n.tiles, e1.map._requestManager._customAccessToken), t1.postMapLoadEvent(n.tiles, e1.map._getMapId(), e1.map._requestManager._skuToken, e1.map._requestManager._customAccessToken), e1.fire(new t1.Event("data", {
                                        dataType: "source",
                                        sourceDataType: "metadata"
                                    })), e1.fire(new t1.Event("data", {
                                        dataType: "source",
                                        sourceDataType: "content"
                                    })));
                                });
                            }, r.prototype.loaded = function() {
                                return this._loaded;
                            }, r.prototype.hasTile = function(t1) {
                                return !this.tileBounds || this.tileBounds.contains(t1.canonical);
                            }, r.prototype.onAdd = function(t1) {
                                this.map = t1, this.load();
                            }, r.prototype.setSourceProperty = function(t1) {
                                this._tileJSONRequest && this._tileJSONRequest.cancel(), t1(), this.map.style.sourceCaches[this.id].clearTiles(), this.load();
                            }, r.prototype.setTiles = function(t1) {
                                var e1 = this;
                                return this.setSourceProperty(function() {
                                    e1._options.tiles = t1;
                                }), this;
                            }, r.prototype.setUrl = function(t1) {
                                var e1 = this;
                                return this.setSourceProperty(function() {
                                    e1.url = t1, e1._options.url = t1;
                                }), this;
                            }, r.prototype.onRemove = function() {
                                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
                            }, r.prototype.serialize = function() {
                                return t1.extend({}, this._options);
                            }, r.prototype.loadTile = function(e1, r) {
                                var n = this.map._requestManager.normalizeTileURL(e1.tileID.canonical.url(this.tiles, this.scheme)), i = {
                                    request: this.map._requestManager.transformRequest(n, t1.ResourceType.Tile),
                                    uid: e1.uid,
                                    tileID: e1.tileID,
                                    zoom: e1.tileID.overscaledZ,
                                    tileSize: this.tileSize * e1.tileID.overscaleFactor(),
                                    type: this.type,
                                    source: this.id,
                                    pixelRatio: t1.browser.devicePixelRatio,
                                    showCollisionBoxes: this.map.showCollisionBoxes,
                                    promoteId: this.promoteId
                                };
                                function a(n, i) {
                                    return delete e1.request, e1.aborted ? r(null) : n && 404 !== n.status ? r(n) : (i && i.resourceTiming && (e1.resourceTiming = i.resourceTiming), this.map._refreshExpiredTiles && i && e1.setExpiryData(i), e1.loadVectorData(i, this.map.painter), t1.cacheEntryPossiblyAdded(this.dispatcher), r(null), void (e1.reloadCallback && (this.loadTile(e1, e1.reloadCallback), e1.reloadCallback = null)));
                                }
                                i.request.collectResourceTiming = this._collectResourceTiming, e1.actor && "expired" !== e1.state ? "loading" === e1.state ? e1.reloadCallback = r : e1.request = e1.actor.send("reloadTile", i, a.bind(this)) : (e1.actor = this.dispatcher.getActor(), e1.request = e1.actor.send("loadTile", i, a.bind(this)));
                            }, r.prototype.abortTile = function(t1) {
                                t1.request && (t1.request.cancel(), delete t1.request), t1.actor && t1.actor.send("abortTile", {
                                    uid: t1.uid,
                                    type: this.type,
                                    source: this.id
                                }, void 0);
                            }, r.prototype.unloadTile = function(t1) {
                                t1.unloadVectorData(), t1.actor && t1.actor.send("removeTile", {
                                    uid: t1.uid,
                                    type: this.type,
                                    source: this.id
                                }, void 0);
                            }, r.prototype.hasTransition = function() {
                                return !1;
                            }, r;
                        }(t1.Evented), C = function(e1) {
                            function r(r, n, i, a) {
                                e1.call(this), this.id = r, this.dispatcher = i, this.setEventedParent(a), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._options = t1.extend({
                                    type: "raster"
                                }, n), t1.extend(this, t1.pick(n, [
                                    "url",
                                    "scheme",
                                    "tileSize"
                                ]));
                            }
                            return e1 && (r.__proto__ = e1), r.prototype = Object.create(e1 && e1.prototype), r.prototype.constructor = r, r.prototype.load = function() {
                                var e1 = this;
                                this._loaded = !1, this.fire(new t1.Event("dataloading", {
                                    dataType: "source"
                                })), this._tileJSONRequest = M(this._options, this.map._requestManager, function(r, n) {
                                    e1._tileJSONRequest = null, e1._loaded = !0, r ? e1.fire(new t1.ErrorEvent(r)) : n && (t1.extend(e1, n), n.bounds && (e1.tileBounds = new S(n.bounds, e1.minzoom, e1.maxzoom)), t1.postTurnstileEvent(n.tiles), t1.postMapLoadEvent(n.tiles, e1.map._getMapId(), e1.map._requestManager._skuToken), e1.fire(new t1.Event("data", {
                                        dataType: "source",
                                        sourceDataType: "metadata"
                                    })), e1.fire(new t1.Event("data", {
                                        dataType: "source",
                                        sourceDataType: "content"
                                    })));
                                });
                            }, r.prototype.loaded = function() {
                                return this._loaded;
                            }, r.prototype.onAdd = function(t1) {
                                this.map = t1, this.load();
                            }, r.prototype.onRemove = function() {
                                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
                            }, r.prototype.serialize = function() {
                                return t1.extend({}, this._options);
                            }, r.prototype.hasTile = function(t1) {
                                return !this.tileBounds || this.tileBounds.contains(t1.canonical);
                            }, r.prototype.loadTile = function(e1, r) {
                                var n = this, i = this.map._requestManager.normalizeTileURL(e1.tileID.canonical.url(this.tiles, this.scheme), this.tileSize);
                                e1.request = t1.getImage(this.map._requestManager.transformRequest(i, t1.ResourceType.Tile), function(i, a) {
                                    if (delete e1.request, e1.aborted) e1.state = "unloaded", r(null);
                                    else if (i) e1.state = "errored", r(i);
                                    else if (a) {
                                        n.map._refreshExpiredTiles && e1.setExpiryData(a), delete a.cacheControl, delete a.expires;
                                        var o = n.map.painter.context, s = o.gl;
                                        e1.texture = n.map.painter.getTileTexture(a.width), e1.texture ? e1.texture.update(a, {
                                            useMipmap: !0
                                        }) : (e1.texture = new t1.Texture(o, a, s.RGBA, {
                                            useMipmap: !0
                                        }), e1.texture.bind(s.LINEAR, s.CLAMP_TO_EDGE, s.LINEAR_MIPMAP_NEAREST), o.extTextureFilterAnisotropic && s.texParameterf(s.TEXTURE_2D, o.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, o.extTextureFilterAnisotropicMax)), e1.state = "loaded", t1.cacheEntryPossiblyAdded(n.dispatcher), r(null);
                                    }
                                });
                            }, r.prototype.abortTile = function(t1, e1) {
                                t1.request && (t1.request.cancel(), delete t1.request), e1();
                            }, r.prototype.unloadTile = function(t1, e1) {
                                t1.texture && this.map.painter.saveTileTexture(t1.texture), e1();
                            }, r.prototype.hasTransition = function() {
                                return !1;
                            }, r;
                        }(t1.Evented), L = function(e1) {
                            function r(r, n, i, a) {
                                e1.call(this, r, n, i, a), this.type = "raster-dem", this.maxzoom = 22, this._options = t1.extend({
                                    type: "raster-dem"
                                }, n), this.encoding = n.encoding || "mapbox";
                            }
                            return e1 && (r.__proto__ = e1), r.prototype = Object.create(e1 && e1.prototype), r.prototype.constructor = r, r.prototype.serialize = function() {
                                return {
                                    type: "raster-dem",
                                    url: this.url,
                                    tileSize: this.tileSize,
                                    tiles: this.tiles,
                                    bounds: this.bounds,
                                    encoding: this.encoding
                                };
                            }, r.prototype.loadTile = function(e1, r) {
                                var n = this.map._requestManager.normalizeTileURL(e1.tileID.canonical.url(this.tiles, this.scheme), this.tileSize);
                                function i(t1, n) {
                                    t1 && (e1.state = "errored", r(t1)), n && (e1.dem = n, e1.needsHillshadePrepare = !0, e1.state = "loaded", r(null));
                                }
                                e1.request = t1.getImage(this.map._requestManager.transformRequest(n, t1.ResourceType.Tile), (function(n, a) {
                                    if (delete e1.request, e1.aborted) e1.state = "unloaded", r(null);
                                    else if (n) e1.state = "errored", r(n);
                                    else if (a) {
                                        this.map._refreshExpiredTiles && e1.setExpiryData(a), delete a.cacheControl, delete a.expires;
                                        var o = t1.window.ImageBitmap && a instanceof t1.window.ImageBitmap && t1.offscreenCanvasSupported() ? a : t1.browser.getImageData(a, 1), s = {
                                            uid: e1.uid,
                                            coord: e1.tileID,
                                            source: this.id,
                                            rawImageData: o,
                                            encoding: this.encoding
                                        };
                                        e1.actor && "expired" !== e1.state || (e1.actor = this.dispatcher.getActor(), e1.actor.send("loadDEMTile", s, i.bind(this)));
                                    }
                                }).bind(this)), e1.neighboringTiles = this._getNeighboringTiles(e1.tileID);
                            }, r.prototype._getNeighboringTiles = function(e1) {
                                var r = e1.canonical, n = Math.pow(2, r.z), i = (r.x - 1 + n) % n, a = 0 === r.x ? e1.wrap - 1 : e1.wrap, o = (r.x + 1 + n) % n, s = r.x + 1 === n ? e1.wrap + 1 : e1.wrap, l = {};
                                return l[new t1.OverscaledTileID(e1.overscaledZ, a, r.z, i, r.y).key] = {
                                    backfilled: !1
                                }, l[new t1.OverscaledTileID(e1.overscaledZ, s, r.z, o, r.y).key] = {
                                    backfilled: !1
                                }, r.y > 0 && (l[new t1.OverscaledTileID(e1.overscaledZ, a, r.z, i, r.y - 1).key] = {
                                    backfilled: !1
                                }, l[new t1.OverscaledTileID(e1.overscaledZ, e1.wrap, r.z, r.x, r.y - 1).key] = {
                                    backfilled: !1
                                }, l[new t1.OverscaledTileID(e1.overscaledZ, s, r.z, o, r.y - 1).key] = {
                                    backfilled: !1
                                }), r.y + 1 < n && (l[new t1.OverscaledTileID(e1.overscaledZ, a, r.z, i, r.y + 1).key] = {
                                    backfilled: !1
                                }, l[new t1.OverscaledTileID(e1.overscaledZ, e1.wrap, r.z, r.x, r.y + 1).key] = {
                                    backfilled: !1
                                }, l[new t1.OverscaledTileID(e1.overscaledZ, s, r.z, o, r.y + 1).key] = {
                                    backfilled: !1
                                }), l;
                            }, r.prototype.unloadTile = function(t1) {
                                t1.demTexture && this.map.painter.saveTileTexture(t1.demTexture), t1.fbo && (t1.fbo.destroy(), delete t1.fbo), t1.dem && delete t1.dem, delete t1.neighboringTiles, t1.state = "unloaded", t1.actor && t1.actor.send("removeDEMTile", {
                                    uid: t1.uid,
                                    source: this.id
                                });
                            }, r;
                        }(C), I = function(e1) {
                            function r(r, n, i, a) {
                                e1.call(this), this.id = r, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._removed = !1, this._loaded = !1, this.actor = i.getActor(), this.setEventedParent(a), this._data = n.data, this._options = t1.extend({}, n), this._collectResourceTiming = n.collectResourceTiming, this._resourceTiming = [], void 0 !== n.maxzoom && (this.maxzoom = n.maxzoom), n.type && (this.type = n.type), n.attribution && (this.attribution = n.attribution), this.promoteId = n.promoteId;
                                var o = t1.EXTENT / this.tileSize;
                                this.workerOptions = t1.extend({
                                    source: this.id,
                                    cluster: n.cluster || !1,
                                    geojsonVtOptions: {
                                        buffer: (void 0 !== n.buffer ? n.buffer : 128) * o,
                                        tolerance: (void 0 !== n.tolerance ? n.tolerance : .375) * o,
                                        extent: t1.EXTENT,
                                        maxZoom: this.maxzoom,
                                        lineMetrics: n.lineMetrics || !1,
                                        generateId: n.generateId || !1
                                    },
                                    superclusterOptions: {
                                        maxZoom: void 0 !== n.clusterMaxZoom ? Math.min(n.clusterMaxZoom, this.maxzoom - 1) : this.maxzoom - 1,
                                        minPoints: Math.max(2, n.clusterMinPoints || 2),
                                        extent: t1.EXTENT,
                                        radius: (n.clusterRadius || 50) * o,
                                        log: !1,
                                        generateId: n.generateId || !1
                                    },
                                    clusterProperties: n.clusterProperties,
                                    filter: n.filter
                                }, n.workerOptions);
                            }
                            return e1 && (r.__proto__ = e1), r.prototype = Object.create(e1 && e1.prototype), r.prototype.constructor = r, r.prototype.load = function() {
                                var e1 = this;
                                this.fire(new t1.Event("dataloading", {
                                    dataType: "source"
                                })), this._updateWorkerData(function(r) {
                                    if (r) e1.fire(new t1.ErrorEvent(r));
                                    else {
                                        var n = {
                                            dataType: "source",
                                            sourceDataType: "metadata"
                                        };
                                        e1._collectResourceTiming && e1._resourceTiming && e1._resourceTiming.length > 0 && (n.resourceTiming = e1._resourceTiming, e1._resourceTiming = []), e1.fire(new t1.Event("data", n));
                                    }
                                });
                            }, r.prototype.onAdd = function(t1) {
                                this.map = t1, this.load();
                            }, r.prototype.setData = function(e1) {
                                var r = this;
                                return this._data = e1, this.fire(new t1.Event("dataloading", {
                                    dataType: "source"
                                })), this._updateWorkerData(function(e1) {
                                    if (e1) r.fire(new t1.ErrorEvent(e1));
                                    else {
                                        var n = {
                                            dataType: "source",
                                            sourceDataType: "content"
                                        };
                                        r._collectResourceTiming && r._resourceTiming && r._resourceTiming.length > 0 && (n.resourceTiming = r._resourceTiming, r._resourceTiming = []), r.fire(new t1.Event("data", n));
                                    }
                                }), this;
                            }, r.prototype.getClusterExpansionZoom = function(t1, e1) {
                                return this.actor.send("geojson.getClusterExpansionZoom", {
                                    clusterId: t1,
                                    source: this.id
                                }, e1), this;
                            }, r.prototype.getClusterChildren = function(t1, e1) {
                                return this.actor.send("geojson.getClusterChildren", {
                                    clusterId: t1,
                                    source: this.id
                                }, e1), this;
                            }, r.prototype.getClusterLeaves = function(t1, e1, r, n) {
                                return this.actor.send("geojson.getClusterLeaves", {
                                    source: this.id,
                                    clusterId: t1,
                                    limit: e1,
                                    offset: r
                                }, n), this;
                            }, r.prototype._updateWorkerData = function(e1) {
                                var r = this;
                                this._loaded = !1;
                                var n = t1.extend({}, this.workerOptions), i = this._data;
                                "string" == typeof i ? (n.request = this.map._requestManager.transformRequest(t1.browser.resolveURL(i), t1.ResourceType.Source), n.request.collectResourceTiming = this._collectResourceTiming) : n.data = JSON.stringify(i), this.actor.send(this.type + ".loadData", n, function(t1, i) {
                                    r._removed || i && i.abandoned || (r._loaded = !0, i && i.resourceTiming && i.resourceTiming[r.id] && (r._resourceTiming = i.resourceTiming[r.id].slice(0)), r.actor.send(r.type + ".coalesce", {
                                        source: n.source
                                    }, null), e1(t1));
                                });
                            }, r.prototype.loaded = function() {
                                return this._loaded;
                            }, r.prototype.loadTile = function(e1, r) {
                                var n = this, i = e1.actor ? "reloadTile" : "loadTile";
                                e1.actor = this.actor;
                                var a = {
                                    type: this.type,
                                    uid: e1.uid,
                                    tileID: e1.tileID,
                                    zoom: e1.tileID.overscaledZ,
                                    maxZoom: this.maxzoom,
                                    tileSize: this.tileSize,
                                    source: this.id,
                                    pixelRatio: t1.browser.devicePixelRatio,
                                    showCollisionBoxes: this.map.showCollisionBoxes,
                                    promoteId: this.promoteId
                                };
                                e1.request = this.actor.send(i, a, function(t1, a) {
                                    return delete e1.request, e1.unloadVectorData(), e1.aborted ? r(null) : t1 ? r(t1) : (e1.loadVectorData(a, n.map.painter, "reloadTile" === i), r(null));
                                });
                            }, r.prototype.abortTile = function(t1) {
                                t1.request && (t1.request.cancel(), delete t1.request), t1.aborted = !0;
                            }, r.prototype.unloadTile = function(t1) {
                                t1.unloadVectorData(), this.actor.send("removeTile", {
                                    uid: t1.uid,
                                    type: this.type,
                                    source: this.id
                                });
                            }, r.prototype.onRemove = function() {
                                this._removed = !0, this.actor.send("removeSource", {
                                    type: this.type,
                                    source: this.id
                                });
                            }, r.prototype.serialize = function() {
                                return t1.extend({}, this._options, {
                                    type: this.type,
                                    data: this._data
                                });
                            }, r.prototype.hasTransition = function() {
                                return !1;
                            }, r;
                        }(t1.Evented), P = t1.createLayout([
                            {
                                name: "a_pos",
                                type: "Int16",
                                components: 2
                            },
                            {
                                name: "a_texture_pos",
                                type: "Int16",
                                components: 2
                            }
                        ]), z = function(e1) {
                            function r(t1, r, n, i) {
                                e1.call(this), this.id = t1, this.dispatcher = n, this.coordinates = r.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.setEventedParent(i), this.options = r;
                            }
                            return e1 && (r.__proto__ = e1), r.prototype = Object.create(e1 && e1.prototype), r.prototype.constructor = r, r.prototype.load = function(e1, r) {
                                var n = this;
                                this._loaded = !1, this.fire(new t1.Event("dataloading", {
                                    dataType: "source"
                                })), this.url = this.options.url, t1.getImage(this.map._requestManager.transformRequest(this.url, t1.ResourceType.Image), function(i, a) {
                                    n._loaded = !0, i ? n.fire(new t1.ErrorEvent(i)) : a && (n.image = a, e1 && (n.coordinates = e1), r && r(), n._finishLoading());
                                });
                            }, r.prototype.loaded = function() {
                                return this._loaded;
                            }, r.prototype.updateImage = function(t1) {
                                var e1 = this;
                                return this.image && t1.url ? (this.options.url = t1.url, this.load(t1.coordinates, function() {
                                    e1.texture = null;
                                }), this) : this;
                            }, r.prototype._finishLoading = function() {
                                this.map && (this.setCoordinates(this.coordinates), this.fire(new t1.Event("data", {
                                    dataType: "source",
                                    sourceDataType: "metadata"
                                })));
                            }, r.prototype.onAdd = function(t1) {
                                this.map = t1, this.load();
                            }, r.prototype.setCoordinates = function(e1) {
                                var r = this;
                                this.coordinates = e1;
                                var n = e1.map(t1.MercatorCoordinate.fromLngLat);
                                this.tileID = function(e1) {
                                    for(var r = 1 / 0, n = 1 / 0, i = -1 / 0, a = -1 / 0, o = 0, s = e1; o < s.length; o += 1){
                                        var l = s[o];
                                        r = Math.min(r, l.x), n = Math.min(n, l.y), i = Math.max(i, l.x), a = Math.max(a, l.y);
                                    }
                                    var c = i - r, u = a - n, h = Math.max(c, u), f = Math.max(0, Math.floor(-Math.log(h) / Math.LN2)), p = Math.pow(2, f);
                                    return new t1.CanonicalTileID(f, Math.floor((r + i) / 2 * p), Math.floor((n + a) / 2 * p));
                                }(n), this.minzoom = this.maxzoom = this.tileID.z;
                                var i = n.map(function(t1) {
                                    return r.tileID.getTilePoint(t1)._round();
                                });
                                return this._boundsArray = new t1.StructArrayLayout4i8, this._boundsArray.emplaceBack(i[0].x, i[0].y, 0, 0), this._boundsArray.emplaceBack(i[1].x, i[1].y, t1.EXTENT, 0), this._boundsArray.emplaceBack(i[3].x, i[3].y, 0, t1.EXTENT), this._boundsArray.emplaceBack(i[2].x, i[2].y, t1.EXTENT, t1.EXTENT), this.boundsBuffer && (this.boundsBuffer.destroy(), delete this.boundsBuffer), this.fire(new t1.Event("data", {
                                    dataType: "source",
                                    sourceDataType: "content"
                                })), this;
                            }, r.prototype.prepare = function() {
                                if (0 !== Object.keys(this.tiles).length && this.image) {
                                    var e1 = this.map.painter.context, r = e1.gl;
                                    for(var n in this.boundsBuffer || (this.boundsBuffer = e1.createVertexBuffer(this._boundsArray, P.members)), this.boundsSegments || (this.boundsSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2)), this.texture || (this.texture = new t1.Texture(e1, this.image, r.RGBA), this.texture.bind(r.LINEAR, r.CLAMP_TO_EDGE)), this.tiles){
                                        var i = this.tiles[n];
                                        "loaded" !== i.state && (i.state = "loaded", i.texture = this.texture);
                                    }
                                }
                            }, r.prototype.loadTile = function(t1, e1) {
                                this.tileID && this.tileID.equals(t1.tileID.canonical) ? (this.tiles[String(t1.tileID.wrap)] = t1, t1.buckets = {}, e1(null)) : (t1.state = "errored", e1(null));
                            }, r.prototype.serialize = function() {
                                return {
                                    type: "image",
                                    url: this.options.url,
                                    coordinates: this.coordinates
                                };
                            }, r.prototype.hasTransition = function() {
                                return !1;
                            }, r;
                        }(t1.Evented);
                        var O = function(e1) {
                            function r(t1, r, n, i) {
                                e1.call(this, t1, r, n, i), this.roundZoom = !0, this.type = "video", this.options = r;
                            }
                            return e1 && (r.__proto__ = e1), r.prototype = Object.create(e1 && e1.prototype), r.prototype.constructor = r, r.prototype.load = function() {
                                var e1 = this;
                                this._loaded = !1;
                                var r = this.options;
                                this.urls = [];
                                for(var n = 0, i = r.urls; n < i.length; n += 1){
                                    var a = i[n];
                                    this.urls.push(this.map._requestManager.transformRequest(a, t1.ResourceType.Source).url);
                                }
                                t1.getVideo(this.urls, function(r, n) {
                                    e1._loaded = !0, r ? e1.fire(new t1.ErrorEvent(r)) : n && (e1.video = n, e1.video.loop = !0, e1.video.addEventListener("playing", function() {
                                        e1.map.triggerRepaint();
                                    }), e1.map && e1.video.play(), e1._finishLoading());
                                });
                            }, r.prototype.pause = function() {
                                this.video && this.video.pause();
                            }, r.prototype.play = function() {
                                this.video && this.video.play();
                            }, r.prototype.seek = function(e1) {
                                if (this.video) {
                                    var r = this.video.seekable;
                                    e1 < r.start(0) || e1 > r.end(0) ? this.fire(new t1.ErrorEvent(new t1.ValidationError("sources." + this.id, null, "Playback for this video can be set only between the " + r.start(0) + " and " + r.end(0) + "-second mark."))) : this.video.currentTime = e1;
                                }
                            }, r.prototype.getVideo = function() {
                                return this.video;
                            }, r.prototype.onAdd = function(t1) {
                                this.map || (this.map = t1, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
                            }, r.prototype.prepare = function() {
                                if (!(0 === Object.keys(this.tiles).length || this.video.readyState < 2)) {
                                    var e1 = this.map.painter.context, r = e1.gl;
                                    for(var n in this.boundsBuffer || (this.boundsBuffer = e1.createVertexBuffer(this._boundsArray, P.members)), this.boundsSegments || (this.boundsSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2)), this.texture ? this.video.paused || (this.texture.bind(r.LINEAR, r.CLAMP_TO_EDGE), r.texSubImage2D(r.TEXTURE_2D, 0, 0, 0, r.RGBA, r.UNSIGNED_BYTE, this.video)) : (this.texture = new t1.Texture(e1, this.video, r.RGBA), this.texture.bind(r.LINEAR, r.CLAMP_TO_EDGE)), this.tiles){
                                        var i = this.tiles[n];
                                        "loaded" !== i.state && (i.state = "loaded", i.texture = this.texture);
                                    }
                                }
                            }, r.prototype.serialize = function() {
                                return {
                                    type: "video",
                                    urls: this.urls,
                                    coordinates: this.coordinates
                                };
                            }, r.prototype.hasTransition = function() {
                                return this.video && !this.video.paused;
                            }, r;
                        }(z), D = function(e1) {
                            function r(r, n, i, a) {
                                e1.call(this, r, n, i, a), n.coordinates ? Array.isArray(n.coordinates) && 4 === n.coordinates.length && !n.coordinates.some(function(t1) {
                                    return !Array.isArray(t1) || 2 !== t1.length || t1.some(function(t1) {
                                        return "number" != typeof t1;
                                    });
                                }) || this.fire(new t1.ErrorEvent(new t1.ValidationError("sources." + r, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new t1.ErrorEvent(new t1.ValidationError("sources." + r, null, 'missing required property "coordinates"'))), n.animate && "boolean" != typeof n.animate && this.fire(new t1.ErrorEvent(new t1.ValidationError("sources." + r, null, 'optional "animate" property must be a boolean value'))), n.canvas ? "string" == typeof n.canvas || n.canvas instanceof t1.window.HTMLCanvasElement || this.fire(new t1.ErrorEvent(new t1.ValidationError("sources." + r, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new t1.ErrorEvent(new t1.ValidationError("sources." + r, null, 'missing required property "canvas"'))), this.options = n, this.animate = void 0 === n.animate || n.animate;
                            }
                            return e1 && (r.__proto__ = e1), r.prototype = Object.create(e1 && e1.prototype), r.prototype.constructor = r, r.prototype.load = function() {
                                this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof t1.window.HTMLCanvasElement ? this.options.canvas : t1.window.document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new t1.ErrorEvent(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
                                    this._playing = !0, this.map.triggerRepaint();
                                }, this.pause = function() {
                                    this._playing && (this.prepare(), this._playing = !1);
                                }, this._finishLoading());
                            }, r.prototype.getCanvas = function() {
                                return this.canvas;
                            }, r.prototype.onAdd = function(t1) {
                                this.map = t1, this.load(), this.canvas && this.animate && this.play();
                            }, r.prototype.onRemove = function() {
                                this.pause();
                            }, r.prototype.prepare = function() {
                                var e1 = !1;
                                if (this.canvas.width !== this.width && (this.width = this.canvas.width, e1 = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, e1 = !0), !this._hasInvalidDimensions() && 0 !== Object.keys(this.tiles).length) {
                                    var r = this.map.painter.context, n = r.gl;
                                    for(var i in this.boundsBuffer || (this.boundsBuffer = r.createVertexBuffer(this._boundsArray, P.members)), this.boundsSegments || (this.boundsSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2)), this.texture ? (e1 || this._playing) && this.texture.update(this.canvas, {
                                        premultiply: !0
                                    }) : this.texture = new t1.Texture(r, this.canvas, n.RGBA, {
                                        premultiply: !0
                                    }), this.tiles){
                                        var a = this.tiles[i];
                                        "loaded" !== a.state && (a.state = "loaded", a.texture = this.texture);
                                    }
                                }
                            }, r.prototype.serialize = function() {
                                return {
                                    type: "canvas",
                                    coordinates: this.coordinates
                                };
                            }, r.prototype.hasTransition = function() {
                                return this._playing;
                            }, r.prototype._hasInvalidDimensions = function() {
                                for(var t1 = 0, e1 = [
                                    this.canvas.width,
                                    this.canvas.height
                                ]; t1 < e1.length; t1 += 1){
                                    var r = e1[t1];
                                    if (isNaN(r) || r <= 0) return !0;
                                }
                                return !1;
                            }, r;
                        }(z), R = {
                            vector: E,
                            raster: C,
                            "raster-dem": L,
                            geojson: I,
                            video: O,
                            image: z,
                            canvas: D
                        };
                        function F(e1, r) {
                            var n = t1.identity([]);
                            return t1.translate(n, n, [
                                1,
                                1,
                                0
                            ]), t1.scale(n, n, [
                                .5 * e1.width,
                                .5 * e1.height,
                                1
                            ]), t1.multiply(n, n, e1.calculatePosMatrix(r.toUnwrapped()));
                        }
                        function B(t1, e1, r, n, i, a) {
                            var o = function(t1, e1, r) {
                                if (t1) for(var n = 0, i = t1; n < i.length; n += 1){
                                    var a = e1[i[n]];
                                    if (a && a.source === r && "fill-extrusion" === a.type) return !0;
                                }
                                else for(var o in e1){
                                    var s = e1[o];
                                    if (s.source === r && "fill-extrusion" === s.type) return !0;
                                }
                                return !1;
                            }(i && i.layers, e1, t1.id), s = a.maxPitchScaleFactor(), l = t1.tilesIn(n, s, o);
                            l.sort(N);
                            for(var c = [], u = 0, h = l; u < h.length; u += 1){
                                var f = h[u];
                                c.push({
                                    wrappedTileID: f.tileID.wrapped().key,
                                    queryResults: f.tile.queryRenderedFeatures(e1, r, t1._state, f.queryGeometry, f.cameraQueryGeometry, f.scale, i, a, s, F(t1.transform, f.tileID))
                                });
                            }
                            var p = function(t1) {
                                for(var e1 = {}, r = {}, n = 0, i = t1; n < i.length; n += 1){
                                    var a = i[n], o = a.queryResults, s = a.wrappedTileID, l = r[s] = r[s] || {};
                                    for(var c in o)for(var u = o[c], h = l[c] = l[c] || {}, f = e1[c] = e1[c] || [], p = 0, d = u; p < d.length; p += 1){
                                        var m = d[p];
                                        h[m.featureIndex] || (h[m.featureIndex] = !0, f.push(m));
                                    }
                                }
                                return e1;
                            }(c);
                            for(var d in p)p[d].forEach(function(e1) {
                                var r = e1.feature, n = t1.getFeatureState(r.layer["source-layer"], r.id);
                                r.source = r.layer.source, r.layer["source-layer"] && (r.sourceLayer = r.layer["source-layer"]), r.state = n;
                            });
                            return p;
                        }
                        function N(t1, e1) {
                            var r = t1.tileID, n = e1.tileID;
                            return r.overscaledZ - n.overscaledZ || r.canonical.y - n.canonical.y || r.wrap - n.wrap || r.canonical.x - n.canonical.x;
                        }
                        var j = function(t1, e1) {
                            this.max = t1, this.onRemove = e1, this.reset();
                        };
                        j.prototype.reset = function() {
                            for(var t1 in this.data)for(var e1 = 0, r = this.data[t1]; e1 < r.length; e1 += 1){
                                var n = r[e1];
                                n.timeout && clearTimeout(n.timeout), this.onRemove(n.value);
                            }
                            return this.data = {}, this.order = [], this;
                        }, j.prototype.add = function(t1, e1, r) {
                            var n = this, i = t1.wrapped().key;
                            void 0 === this.data[i] && (this.data[i] = []);
                            var a = {
                                value: e1,
                                timeout: void 0
                            };
                            if (void 0 !== r && (a.timeout = setTimeout(function() {
                                n.remove(t1, a);
                            }, r)), this.data[i].push(a), this.order.push(i), this.order.length > this.max) {
                                var o = this._getAndRemoveByKey(this.order[0]);
                                o && this.onRemove(o);
                            }
                            return this;
                        }, j.prototype.has = function(t1) {
                            return t1.wrapped().key in this.data;
                        }, j.prototype.getAndRemove = function(t1) {
                            return this.has(t1) ? this._getAndRemoveByKey(t1.wrapped().key) : null;
                        }, j.prototype._getAndRemoveByKey = function(t1) {
                            var e1 = this.data[t1].shift();
                            return e1.timeout && clearTimeout(e1.timeout), 0 === this.data[t1].length && delete this.data[t1], this.order.splice(this.order.indexOf(t1), 1), e1.value;
                        }, j.prototype.getByKey = function(t1) {
                            var e1 = this.data[t1];
                            return e1 ? e1[0].value : null;
                        }, j.prototype.get = function(t1) {
                            return this.has(t1) ? this.data[t1.wrapped().key][0].value : null;
                        }, j.prototype.remove = function(t1, e1) {
                            if (!this.has(t1)) return this;
                            var r = t1.wrapped().key, n = void 0 === e1 ? 0 : this.data[r].indexOf(e1), i = this.data[r][n];
                            return this.data[r].splice(n, 1), i.timeout && clearTimeout(i.timeout), 0 === this.data[r].length && delete this.data[r], this.onRemove(i.value), this.order.splice(this.order.indexOf(r), 1), this;
                        }, j.prototype.setMaxSize = function(t1) {
                            for(this.max = t1; this.order.length > this.max;){
                                var e1 = this._getAndRemoveByKey(this.order[0]);
                                e1 && this.onRemove(e1);
                            }
                            return this;
                        }, j.prototype.filter = function(t1) {
                            var e1 = [];
                            for(var r in this.data)for(var n = 0, i = this.data[r]; n < i.length; n += 1){
                                var a = i[n];
                                t1(a.value) || e1.push(a);
                            }
                            for(var o = 0, s = e1; o < s.length; o += 1){
                                var l = s[o];
                                this.remove(l.value.tileID, l);
                            }
                        };
                        var U = function(t1, e1, r) {
                            this.context = t1;
                            var n = t1.gl;
                            this.buffer = n.createBuffer(), this.dynamicDraw = Boolean(r), this.context.unbindVAO(), t1.bindElementBuffer.set(this.buffer), n.bufferData(n.ELEMENT_ARRAY_BUFFER, e1.arrayBuffer, this.dynamicDraw ? n.DYNAMIC_DRAW : n.STATIC_DRAW), this.dynamicDraw || delete e1.arrayBuffer;
                        };
                        U.prototype.bind = function() {
                            this.context.bindElementBuffer.set(this.buffer);
                        }, U.prototype.updateData = function(t1) {
                            var e1 = this.context.gl;
                            this.context.unbindVAO(), this.bind(), e1.bufferSubData(e1.ELEMENT_ARRAY_BUFFER, 0, t1.arrayBuffer);
                        }, U.prototype.destroy = function() {
                            var t1 = this.context.gl;
                            this.buffer && (t1.deleteBuffer(this.buffer), delete this.buffer);
                        };
                        var V = {
                            Int8: "BYTE",
                            Uint8: "UNSIGNED_BYTE",
                            Int16: "SHORT",
                            Uint16: "UNSIGNED_SHORT",
                            Int32: "INT",
                            Uint32: "UNSIGNED_INT",
                            Float32: "FLOAT"
                        }, q = function(t1, e1, r, n) {
                            this.length = e1.length, this.attributes = r, this.itemSize = e1.bytesPerElement, this.dynamicDraw = n, this.context = t1;
                            var i = t1.gl;
                            this.buffer = i.createBuffer(), t1.bindVertexBuffer.set(this.buffer), i.bufferData(i.ARRAY_BUFFER, e1.arrayBuffer, this.dynamicDraw ? i.DYNAMIC_DRAW : i.STATIC_DRAW), this.dynamicDraw || delete e1.arrayBuffer;
                        };
                        q.prototype.bind = function() {
                            this.context.bindVertexBuffer.set(this.buffer);
                        }, q.prototype.updateData = function(t1) {
                            var e1 = this.context.gl;
                            this.bind(), e1.bufferSubData(e1.ARRAY_BUFFER, 0, t1.arrayBuffer);
                        }, q.prototype.enableAttributes = function(t1, e1) {
                            for(var r = 0; r < this.attributes.length; r++){
                                var n = this.attributes[r], i = e1.attributes[n.name];
                                void 0 !== i && t1.enableVertexAttribArray(i);
                            }
                        }, q.prototype.setVertexAttribPointers = function(t1, e1, r) {
                            for(var n = 0; n < this.attributes.length; n++){
                                var i = this.attributes[n], a = e1.attributes[i.name];
                                void 0 !== a && t1.vertexAttribPointer(a, i.components, t1[V[i.type]], !1, this.itemSize, i.offset + this.itemSize * (r || 0));
                            }
                        }, q.prototype.destroy = function() {
                            var t1 = this.context.gl;
                            this.buffer && (t1.deleteBuffer(this.buffer), delete this.buffer);
                        };
                        var H = function(t1) {
                            this.gl = t1.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
                        };
                        H.prototype.get = function() {
                            return this.current;
                        }, H.prototype.set = function(t1) {}, H.prototype.getDefault = function() {
                            return this.default;
                        }, H.prototype.setDefault = function() {
                            this.set(this.default);
                        };
                        var G = function(e1) {
                            function r() {
                                e1.apply(this, arguments);
                            }
                            return e1 && (r.__proto__ = e1), r.prototype = Object.create(e1 && e1.prototype), r.prototype.constructor = r, r.prototype.getDefault = function() {
                                return t1.Color.transparent;
                            }, r.prototype.set = function(t1) {
                                var e1 = this.current;
                                (t1.r !== e1.r || t1.g !== e1.g || t1.b !== e1.b || t1.a !== e1.a || this.dirty) && (this.gl.clearColor(t1.r, t1.g, t1.b, t1.a), this.current = t1, this.dirty = !1);
                            }, r;
                        }(H), Z = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return 1;
                            }, e1.prototype.set = function(t1) {
                                (t1 !== this.current || this.dirty) && (this.gl.clearDepth(t1), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), W = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return 0;
                            }, e1.prototype.set = function(t1) {
                                (t1 !== this.current || this.dirty) && (this.gl.clearStencil(t1), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), Y = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return [
                                    !0,
                                    !0,
                                    !0,
                                    !0
                                ];
                            }, e1.prototype.set = function(t1) {
                                var e1 = this.current;
                                (t1[0] !== e1[0] || t1[1] !== e1[1] || t1[2] !== e1[2] || t1[3] !== e1[3] || this.dirty) && (this.gl.colorMask(t1[0], t1[1], t1[2], t1[3]), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), X = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return !0;
                            }, e1.prototype.set = function(t1) {
                                (t1 !== this.current || this.dirty) && (this.gl.depthMask(t1), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), $ = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return 255;
                            }, e1.prototype.set = function(t1) {
                                (t1 !== this.current || this.dirty) && (this.gl.stencilMask(t1), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), J = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return {
                                    func: this.gl.ALWAYS,
                                    ref: 0,
                                    mask: 255
                                };
                            }, e1.prototype.set = function(t1) {
                                var e1 = this.current;
                                (t1.func !== e1.func || t1.ref !== e1.ref || t1.mask !== e1.mask || this.dirty) && (this.gl.stencilFunc(t1.func, t1.ref, t1.mask), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), K = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                var t1 = this.gl;
                                return [
                                    t1.KEEP,
                                    t1.KEEP,
                                    t1.KEEP
                                ];
                            }, e1.prototype.set = function(t1) {
                                var e1 = this.current;
                                (t1[0] !== e1[0] || t1[1] !== e1[1] || t1[2] !== e1[2] || this.dirty) && (this.gl.stencilOp(t1[0], t1[1], t1[2]), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), Q = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return !1;
                            }, e1.prototype.set = function(t1) {
                                if (t1 !== this.current || this.dirty) {
                                    var e1 = this.gl;
                                    t1 ? e1.enable(e1.STENCIL_TEST) : e1.disable(e1.STENCIL_TEST), this.current = t1, this.dirty = !1;
                                }
                            }, e1;
                        }(H), tt = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return [
                                    0,
                                    1
                                ];
                            }, e1.prototype.set = function(t1) {
                                var e1 = this.current;
                                (t1[0] !== e1[0] || t1[1] !== e1[1] || this.dirty) && (this.gl.depthRange(t1[0], t1[1]), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), et = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return !1;
                            }, e1.prototype.set = function(t1) {
                                if (t1 !== this.current || this.dirty) {
                                    var e1 = this.gl;
                                    t1 ? e1.enable(e1.DEPTH_TEST) : e1.disable(e1.DEPTH_TEST), this.current = t1, this.dirty = !1;
                                }
                            }, e1;
                        }(H), rt = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return this.gl.LESS;
                            }, e1.prototype.set = function(t1) {
                                (t1 !== this.current || this.dirty) && (this.gl.depthFunc(t1), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), nt = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return !1;
                            }, e1.prototype.set = function(t1) {
                                if (t1 !== this.current || this.dirty) {
                                    var e1 = this.gl;
                                    t1 ? e1.enable(e1.BLEND) : e1.disable(e1.BLEND), this.current = t1, this.dirty = !1;
                                }
                            }, e1;
                        }(H), it = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                var t1 = this.gl;
                                return [
                                    t1.ONE,
                                    t1.ZERO
                                ];
                            }, e1.prototype.set = function(t1) {
                                var e1 = this.current;
                                (t1[0] !== e1[0] || t1[1] !== e1[1] || this.dirty) && (this.gl.blendFunc(t1[0], t1[1]), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), at = function(e1) {
                            function r() {
                                e1.apply(this, arguments);
                            }
                            return e1 && (r.__proto__ = e1), r.prototype = Object.create(e1 && e1.prototype), r.prototype.constructor = r, r.prototype.getDefault = function() {
                                return t1.Color.transparent;
                            }, r.prototype.set = function(t1) {
                                var e1 = this.current;
                                (t1.r !== e1.r || t1.g !== e1.g || t1.b !== e1.b || t1.a !== e1.a || this.dirty) && (this.gl.blendColor(t1.r, t1.g, t1.b, t1.a), this.current = t1, this.dirty = !1);
                            }, r;
                        }(H), ot = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return this.gl.FUNC_ADD;
                            }, e1.prototype.set = function(t1) {
                                (t1 !== this.current || this.dirty) && (this.gl.blendEquation(t1), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), st = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return !1;
                            }, e1.prototype.set = function(t1) {
                                if (t1 !== this.current || this.dirty) {
                                    var e1 = this.gl;
                                    t1 ? e1.enable(e1.CULL_FACE) : e1.disable(e1.CULL_FACE), this.current = t1, this.dirty = !1;
                                }
                            }, e1;
                        }(H), lt = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return this.gl.BACK;
                            }, e1.prototype.set = function(t1) {
                                (t1 !== this.current || this.dirty) && (this.gl.cullFace(t1), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), ct = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return this.gl.CCW;
                            }, e1.prototype.set = function(t1) {
                                (t1 !== this.current || this.dirty) && (this.gl.frontFace(t1), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), ut = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return null;
                            }, e1.prototype.set = function(t1) {
                                (t1 !== this.current || this.dirty) && (this.gl.useProgram(t1), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), ht = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return this.gl.TEXTURE0;
                            }, e1.prototype.set = function(t1) {
                                (t1 !== this.current || this.dirty) && (this.gl.activeTexture(t1), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), ft = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                var t1 = this.gl;
                                return [
                                    0,
                                    0,
                                    t1.drawingBufferWidth,
                                    t1.drawingBufferHeight
                                ];
                            }, e1.prototype.set = function(t1) {
                                var e1 = this.current;
                                (t1[0] !== e1[0] || t1[1] !== e1[1] || t1[2] !== e1[2] || t1[3] !== e1[3] || this.dirty) && (this.gl.viewport(t1[0], t1[1], t1[2], t1[3]), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), pt = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return null;
                            }, e1.prototype.set = function(t1) {
                                if (t1 !== this.current || this.dirty) {
                                    var e1 = this.gl;
                                    e1.bindFramebuffer(e1.FRAMEBUFFER, t1), this.current = t1, this.dirty = !1;
                                }
                            }, e1;
                        }(H), dt = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return null;
                            }, e1.prototype.set = function(t1) {
                                if (t1 !== this.current || this.dirty) {
                                    var e1 = this.gl;
                                    e1.bindRenderbuffer(e1.RENDERBUFFER, t1), this.current = t1, this.dirty = !1;
                                }
                            }, e1;
                        }(H), mt = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return null;
                            }, e1.prototype.set = function(t1) {
                                if (t1 !== this.current || this.dirty) {
                                    var e1 = this.gl;
                                    e1.bindTexture(e1.TEXTURE_2D, t1), this.current = t1, this.dirty = !1;
                                }
                            }, e1;
                        }(H), gt = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return null;
                            }, e1.prototype.set = function(t1) {
                                if (t1 !== this.current || this.dirty) {
                                    var e1 = this.gl;
                                    e1.bindBuffer(e1.ARRAY_BUFFER, t1), this.current = t1, this.dirty = !1;
                                }
                            }, e1;
                        }(H), yt = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return null;
                            }, e1.prototype.set = function(t1) {
                                var e1 = this.gl;
                                e1.bindBuffer(e1.ELEMENT_ARRAY_BUFFER, t1), this.current = t1, this.dirty = !1;
                            }, e1;
                        }(H), vt = function(t1) {
                            function e1(e1) {
                                t1.call(this, e1), this.vao = e1.extVertexArrayObject;
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return null;
                            }, e1.prototype.set = function(t1) {
                                this.vao && (t1 !== this.current || this.dirty) && (this.vao.bindVertexArrayOES(t1), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), xt = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return 4;
                            }, e1.prototype.set = function(t1) {
                                if (t1 !== this.current || this.dirty) {
                                    var e1 = this.gl;
                                    e1.pixelStorei(e1.UNPACK_ALIGNMENT, t1), this.current = t1, this.dirty = !1;
                                }
                            }, e1;
                        }(H), _t = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return !1;
                            }, e1.prototype.set = function(t1) {
                                if (t1 !== this.current || this.dirty) {
                                    var e1 = this.gl;
                                    e1.pixelStorei(e1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, t1), this.current = t1, this.dirty = !1;
                                }
                            }, e1;
                        }(H), bt = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return !1;
                            }, e1.prototype.set = function(t1) {
                                if (t1 !== this.current || this.dirty) {
                                    var e1 = this.gl;
                                    e1.pixelStorei(e1.UNPACK_FLIP_Y_WEBGL, t1), this.current = t1, this.dirty = !1;
                                }
                            }, e1;
                        }(H), wt = function(t1) {
                            function e1(e1, r) {
                                t1.call(this, e1), this.context = e1, this.parent = r;
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return null;
                            }, e1;
                        }(H), Tt = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.setDirty = function() {
                                this.dirty = !0;
                            }, e1.prototype.set = function(t1) {
                                if (t1 !== this.current || this.dirty) {
                                    this.context.bindFramebuffer.set(this.parent);
                                    var e1 = this.gl;
                                    e1.framebufferTexture2D(e1.FRAMEBUFFER, e1.COLOR_ATTACHMENT0, e1.TEXTURE_2D, t1, 0), this.current = t1, this.dirty = !1;
                                }
                            }, e1;
                        }(wt), kt = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.set = function(t1) {
                                if (t1 !== this.current || this.dirty) {
                                    this.context.bindFramebuffer.set(this.parent);
                                    var e1 = this.gl;
                                    e1.framebufferRenderbuffer(e1.FRAMEBUFFER, e1.DEPTH_ATTACHMENT, e1.RENDERBUFFER, t1), this.current = t1, this.dirty = !1;
                                }
                            }, e1;
                        }(wt), At = function(t1, e1, r, n) {
                            this.context = t1, this.width = e1, this.height = r;
                            var i = t1.gl, a = this.framebuffer = i.createFramebuffer();
                            this.colorAttachment = new Tt(t1, a), n && (this.depthAttachment = new kt(t1, a));
                        };
                        At.prototype.destroy = function() {
                            var t1 = this.context.gl, e1 = this.colorAttachment.get();
                            if (e1 && t1.deleteTexture(e1), this.depthAttachment) {
                                var r = this.depthAttachment.get();
                                r && t1.deleteRenderbuffer(r);
                            }
                            t1.deleteFramebuffer(this.framebuffer);
                        };
                        var Mt = function(t1, e1, r) {
                            this.func = t1, this.mask = e1, this.range = r;
                        };
                        Mt.ReadOnly = !1, Mt.ReadWrite = !0, Mt.disabled = new Mt(519, Mt.ReadOnly, [
                            0,
                            1
                        ]);
                        var St = 7680, Et = function(t1, e1, r, n, i, a) {
                            this.test = t1, this.ref = e1, this.mask = r, this.fail = n, this.depthFail = i, this.pass = a;
                        };
                        Et.disabled = new Et({
                            func: 519,
                            mask: 0
                        }, 0, 0, St, St, St);
                        var Ct = function(t1, e1, r) {
                            this.blendFunction = t1, this.blendColor = e1, this.mask = r;
                        };
                        Ct.Replace = [
                            1,
                            0
                        ], Ct.disabled = new Ct(Ct.Replace, t1.Color.transparent, [
                            !1,
                            !1,
                            !1,
                            !1
                        ]), Ct.unblended = new Ct(Ct.Replace, t1.Color.transparent, [
                            !0,
                            !0,
                            !0,
                            !0
                        ]), Ct.alphaBlended = new Ct([
                            1,
                            771
                        ], t1.Color.transparent, [
                            !0,
                            !0,
                            !0,
                            !0
                        ]);
                        var Lt = function(t1, e1, r) {
                            this.enable = t1, this.mode = e1, this.frontFace = r;
                        };
                        Lt.disabled = new Lt(!1, 1029, 2305), Lt.backCCW = new Lt(!0, 1029, 2305);
                        var It = function(t1) {
                            this.gl = t1, this.extVertexArrayObject = this.gl.getExtension("OES_vertex_array_object"), this.clearColor = new G(this), this.clearDepth = new Z(this), this.clearStencil = new W(this), this.colorMask = new Y(this), this.depthMask = new X(this), this.stencilMask = new $(this), this.stencilFunc = new J(this), this.stencilOp = new K(this), this.stencilTest = new Q(this), this.depthRange = new tt(this), this.depthTest = new et(this), this.depthFunc = new rt(this), this.blend = new nt(this), this.blendFunc = new it(this), this.blendColor = new at(this), this.blendEquation = new ot(this), this.cullFace = new st(this), this.cullFaceSide = new lt(this), this.frontFace = new ct(this), this.program = new ut(this), this.activeTexture = new ht(this), this.viewport = new ft(this), this.bindFramebuffer = new pt(this), this.bindRenderbuffer = new dt(this), this.bindTexture = new mt(this), this.bindVertexBuffer = new gt(this), this.bindElementBuffer = new yt(this), this.bindVertexArrayOES = this.extVertexArrayObject && new vt(this), this.pixelStoreUnpack = new xt(this), this.pixelStoreUnpackPremultiplyAlpha = new _t(this), this.pixelStoreUnpackFlipY = new bt(this), this.extTextureFilterAnisotropic = t1.getExtension("EXT_texture_filter_anisotropic") || t1.getExtension("MOZ_EXT_texture_filter_anisotropic") || t1.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = t1.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)), this.extTextureHalfFloat = t1.getExtension("OES_texture_half_float"), this.extTextureHalfFloat && (t1.getExtension("OES_texture_half_float_linear"), this.extRenderToTextureHalfFloat = t1.getExtension("EXT_color_buffer_half_float")), this.extTimerQuery = t1.getExtension("EXT_disjoint_timer_query"), this.maxTextureSize = t1.getParameter(t1.MAX_TEXTURE_SIZE);
                        };
                        It.prototype.setDefault = function() {
                            this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
                        }, It.prototype.setDirty = function() {
                            this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.extVertexArrayObject && (this.bindVertexArrayOES.dirty = !0), this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
                        }, It.prototype.createIndexBuffer = function(t1, e1) {
                            return new U(this, t1, e1);
                        }, It.prototype.createVertexBuffer = function(t1, e1, r) {
                            return new q(this, t1, e1, r);
                        }, It.prototype.createRenderbuffer = function(t1, e1, r) {
                            var n = this.gl, i = n.createRenderbuffer();
                            return this.bindRenderbuffer.set(i), n.renderbufferStorage(n.RENDERBUFFER, t1, e1, r), this.bindRenderbuffer.set(null), i;
                        }, It.prototype.createFramebuffer = function(t1, e1, r) {
                            return new At(this, t1, e1, r);
                        }, It.prototype.clear = function(t1) {
                            var e1 = t1.color, r = t1.depth, n = this.gl, i = 0;
                            e1 && (i |= n.COLOR_BUFFER_BIT, this.clearColor.set(e1), this.colorMask.set([
                                !0,
                                !0,
                                !0,
                                !0
                            ])), void 0 !== r && (i |= n.DEPTH_BUFFER_BIT, this.depthRange.set([
                                0,
                                1
                            ]), this.clearDepth.set(r), this.depthMask.set(!0)), n.clear(i);
                        }, It.prototype.setCullFace = function(t1) {
                            !1 === t1.enable ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(t1.mode), this.frontFace.set(t1.frontFace));
                        }, It.prototype.setDepthMode = function(t1) {
                            t1.func !== this.gl.ALWAYS || t1.mask ? (this.depthTest.set(!0), this.depthFunc.set(t1.func), this.depthMask.set(t1.mask), this.depthRange.set(t1.range)) : this.depthTest.set(!1);
                        }, It.prototype.setStencilMode = function(t1) {
                            t1.test.func !== this.gl.ALWAYS || t1.mask ? (this.stencilTest.set(!0), this.stencilMask.set(t1.mask), this.stencilOp.set([
                                t1.fail,
                                t1.depthFail,
                                t1.pass
                            ]), this.stencilFunc.set({
                                func: t1.test.func,
                                ref: t1.ref,
                                mask: t1.test.mask
                            })) : this.stencilTest.set(!1);
                        }, It.prototype.setColorMode = function(e1) {
                            t1.deepEqual(e1.blendFunction, Ct.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(e1.blendFunction), this.blendColor.set(e1.blendColor)), this.colorMask.set(e1.mask);
                        }, It.prototype.unbindVAO = function() {
                            this.extVertexArrayObject && this.bindVertexArrayOES.set(null);
                        };
                        var Pt = function(e1) {
                            function r(r, n, i) {
                                var a = this;
                                e1.call(this), this.id = r, this.dispatcher = i, this.on("data", function(t1) {
                                    "source" === t1.dataType && "metadata" === t1.sourceDataType && (a._sourceLoaded = !0), a._sourceLoaded && !a._paused && "source" === t1.dataType && "content" === t1.sourceDataType && (a.reload(), a.transform && a.update(a.transform));
                                }), this.on("error", function() {
                                    a._sourceErrored = !0;
                                }), this._source = function(e1, r, n, i) {
                                    var a = new R[r.type](e1, r, n, i);
                                    if (a.id !== e1) throw new Error("Expected Source id to be " + e1 + " instead of " + a.id);
                                    return t1.bindAll([
                                        "load",
                                        "abort",
                                        "unload",
                                        "serialize",
                                        "prepare"
                                    ], a), a;
                                }(r, n, i, this), this._tiles = {}, this._cache = new j(0, this._unloadTile.bind(this)), this._timers = {}, this._cacheTimers = {}, this._maxTileCacheSize = null, this._loadedParentTiles = {}, this._coveredTiles = {}, this._state = new t1.SourceFeatureState;
                            }
                            return e1 && (r.__proto__ = e1), r.prototype = Object.create(e1 && e1.prototype), r.prototype.constructor = r, r.prototype.onAdd = function(t1) {
                                this.map = t1, this._maxTileCacheSize = t1 ? t1._maxTileCacheSize : null, this._source && this._source.onAdd && this._source.onAdd(t1);
                            }, r.prototype.onRemove = function(t1) {
                                this._source && this._source.onRemove && this._source.onRemove(t1);
                            }, r.prototype.loaded = function() {
                                if (this._sourceErrored) return !0;
                                if (!this._sourceLoaded) return !1;
                                if (!this._source.loaded()) return !1;
                                for(var t1 in this._tiles){
                                    var e1 = this._tiles[t1];
                                    if ("loaded" !== e1.state && "errored" !== e1.state) return !1;
                                }
                                return !0;
                            }, r.prototype.getSource = function() {
                                return this._source;
                            }, r.prototype.pause = function() {
                                this._paused = !0;
                            }, r.prototype.resume = function() {
                                if (this._paused) {
                                    var t1 = this._shouldReloadOnResume;
                                    this._paused = !1, this._shouldReloadOnResume = !1, t1 && this.reload(), this.transform && this.update(this.transform);
                                }
                            }, r.prototype._loadTile = function(t1, e1) {
                                return this._source.loadTile(t1, e1);
                            }, r.prototype._unloadTile = function(t1) {
                                if (this._source.unloadTile) return this._source.unloadTile(t1, function() {});
                            }, r.prototype._abortTile = function(t1) {
                                if (this._source.abortTile) return this._source.abortTile(t1, function() {});
                            }, r.prototype.serialize = function() {
                                return this._source.serialize();
                            }, r.prototype.prepare = function(t1) {
                                for(var e1 in this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null), this._tiles){
                                    var r = this._tiles[e1];
                                    r.upload(t1), r.prepare(this.map.style.imageManager);
                                }
                            }, r.prototype.getIds = function() {
                                return t1.values(this._tiles).map(function(t1) {
                                    return t1.tileID;
                                }).sort(zt).map(function(t1) {
                                    return t1.key;
                                });
                            }, r.prototype.getRenderableIds = function(e1) {
                                var r = this, n = [];
                                for(var i in this._tiles)this._isIdRenderable(i, e1) && n.push(this._tiles[i]);
                                return e1 ? n.sort(function(e1, n) {
                                    var i = e1.tileID, a = n.tileID, o = new t1.Point(i.canonical.x, i.canonical.y)._rotate(r.transform.angle), s = new t1.Point(a.canonical.x, a.canonical.y)._rotate(r.transform.angle);
                                    return i.overscaledZ - a.overscaledZ || s.y - o.y || s.x - o.x;
                                }).map(function(t1) {
                                    return t1.tileID.key;
                                }) : n.map(function(t1) {
                                    return t1.tileID;
                                }).sort(zt).map(function(t1) {
                                    return t1.key;
                                });
                            }, r.prototype.hasRenderableParent = function(t1) {
                                var e1 = this.findLoadedParent(t1, 0);
                                return !!e1 && this._isIdRenderable(e1.tileID.key);
                            }, r.prototype._isIdRenderable = function(t1, e1) {
                                return this._tiles[t1] && this._tiles[t1].hasData() && !this._coveredTiles[t1] && (e1 || !this._tiles[t1].holdingForFade());
                            }, r.prototype.reload = function() {
                                if (this._paused) this._shouldReloadOnResume = !0;
                                else for(var t1 in this._cache.reset(), this._tiles)"errored" !== this._tiles[t1].state && this._reloadTile(t1, "reloading");
                            }, r.prototype._reloadTile = function(t1, e1) {
                                var r = this._tiles[t1];
                                r && ("loading" !== r.state && (r.state = e1), this._loadTile(r, this._tileLoaded.bind(this, r, t1, e1)));
                            }, r.prototype._tileLoaded = function(e1, r, n, i) {
                                if (i) return e1.state = "errored", void (404 !== i.status ? this._source.fire(new t1.ErrorEvent(i, {
                                    tile: e1
                                })) : this.update(this.transform));
                                e1.timeAdded = t1.browser.now(), "expired" === n && (e1.refreshedUponExpiration = !0), this._setTileReloadTimer(r, e1), "raster-dem" === this.getSource().type && e1.dem && this._backfillDEM(e1), this._state.initializeTileState(e1, this.map ? this.map.painter : null), this._source.fire(new t1.Event("data", {
                                    dataType: "source",
                                    tile: e1,
                                    coord: e1.tileID
                                }));
                            }, r.prototype._backfillDEM = function(t1) {
                                for(var e1 = this.getRenderableIds(), r = 0; r < e1.length; r++){
                                    var n = e1[r];
                                    if (t1.neighboringTiles && t1.neighboringTiles[n]) {
                                        var i = this.getTileByID(n);
                                        a(t1, i), a(i, t1);
                                    }
                                }
                                function a(t1, e1) {
                                    t1.needsHillshadePrepare = !0;
                                    var r = e1.tileID.canonical.x - t1.tileID.canonical.x, n = e1.tileID.canonical.y - t1.tileID.canonical.y, i = Math.pow(2, t1.tileID.canonical.z), a = e1.tileID.key;
                                    0 === r && 0 === n || Math.abs(n) > 1 || (Math.abs(r) > 1 && (1 === Math.abs(r + i) ? r += i : 1 === Math.abs(r - i) && (r -= i)), e1.dem && t1.dem && (t1.dem.backfillBorder(e1.dem, r, n), t1.neighboringTiles && t1.neighboringTiles[a] && (t1.neighboringTiles[a].backfilled = !0)));
                                }
                            }, r.prototype.getTile = function(t1) {
                                return this.getTileByID(t1.key);
                            }, r.prototype.getTileByID = function(t1) {
                                return this._tiles[t1];
                            }, r.prototype._retainLoadedChildren = function(t1, e1, r, n) {
                                for(var i in this._tiles){
                                    var a = this._tiles[i];
                                    if (!(n[i] || !a.hasData() || a.tileID.overscaledZ <= e1 || a.tileID.overscaledZ > r)) {
                                        for(var o = a.tileID; a && a.tileID.overscaledZ > e1 + 1;){
                                            var s = a.tileID.scaledTo(a.tileID.overscaledZ - 1);
                                            (a = this._tiles[s.key]) && a.hasData() && (o = s);
                                        }
                                        for(var l = o; l.overscaledZ > e1;)if (t1[(l = l.scaledTo(l.overscaledZ - 1)).key]) {
                                            n[o.key] = o;
                                            break;
                                        }
                                    }
                                }
                            }, r.prototype.findLoadedParent = function(t1, e1) {
                                if (t1.key in this._loadedParentTiles) {
                                    var r = this._loadedParentTiles[t1.key];
                                    return r && r.tileID.overscaledZ >= e1 ? r : null;
                                }
                                for(var n = t1.overscaledZ - 1; n >= e1; n--){
                                    var i = t1.scaledTo(n), a = this._getLoadedTile(i);
                                    if (a) return a;
                                }
                            }, r.prototype._getLoadedTile = function(t1) {
                                var e1 = this._tiles[t1.key];
                                return e1 && e1.hasData() ? e1 : this._cache.getByKey(t1.wrapped().key);
                            }, r.prototype.updateCacheSize = function(t1) {
                                var e1 = (Math.ceil(t1.width / this._source.tileSize) + 1) * (Math.ceil(t1.height / this._source.tileSize) + 1), r = Math.floor(5 * e1), n = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, r) : r;
                                this._cache.setMaxSize(n);
                            }, r.prototype.handleWrapJump = function(t1) {
                                var e1 = (t1 - (void 0 === this._prevLng ? t1 : this._prevLng)) / 360, r = Math.round(e1);
                                if (this._prevLng = t1, r) {
                                    var n = {};
                                    for(var i in this._tiles){
                                        var a = this._tiles[i];
                                        a.tileID = a.tileID.unwrapTo(a.tileID.wrap + r), n[a.tileID.key] = a;
                                    }
                                    for(var o in this._tiles = n, this._timers)clearTimeout(this._timers[o]), delete this._timers[o];
                                    for(var s in this._tiles){
                                        var l = this._tiles[s];
                                        this._setTileReloadTimer(s, l);
                                    }
                                }
                            }, r.prototype.update = function(e1) {
                                var n = this;
                                if (this.transform = e1, this._sourceLoaded && !this._paused) {
                                    var i;
                                    this.updateCacheSize(e1), this.handleWrapJump(this.transform.center.lng), this._coveredTiles = {}, this.used ? this._source.tileID ? i = e1.getVisibleUnwrappedCoordinates(this._source.tileID).map(function(e1) {
                                        return new t1.OverscaledTileID(e1.canonical.z, e1.wrap, e1.canonical.z, e1.canonical.x, e1.canonical.y);
                                    }) : (i = e1.coveringTiles({
                                        tileSize: this._source.tileSize,
                                        minzoom: this._source.minzoom,
                                        maxzoom: this._source.maxzoom,
                                        roundZoom: this._source.roundZoom,
                                        reparseOverscaled: this._source.reparseOverscaled
                                    }), this._source.hasTile && (i = i.filter(function(t1) {
                                        return n._source.hasTile(t1);
                                    }))) : i = [];
                                    var a = e1.coveringZoomLevel(this._source), o = Math.max(a - r.maxOverzooming, this._source.minzoom), s = Math.max(a + r.maxUnderzooming, this._source.minzoom), l = this._updateRetainedTiles(i, a);
                                    if (Ot(this._source.type)) {
                                        for(var c = {}, u = {}, h = 0, f = Object.keys(l); h < f.length; h += 1){
                                            var p = f[h], d = l[p], m = this._tiles[p];
                                            if (m && !(m.fadeEndTime && m.fadeEndTime <= t1.browser.now())) {
                                                var g = this.findLoadedParent(d, o);
                                                g && (this._addTile(g.tileID), c[g.tileID.key] = g.tileID), u[p] = d;
                                            }
                                        }
                                        for(var y in this._retainLoadedChildren(u, a, s, l), c)l[y] || (this._coveredTiles[y] = !0, l[y] = c[y]);
                                    }
                                    for(var v in l)this._tiles[v].clearFadeHold();
                                    for(var x = 0, _ = t1.keysDifference(this._tiles, l); x < _.length; x += 1){
                                        var b = _[x], w = this._tiles[b];
                                        w.hasSymbolBuckets && !w.holdingForFade() ? w.setHoldDuration(this.map._fadeDuration) : w.hasSymbolBuckets && !w.symbolFadeFinished() || this._removeTile(b);
                                    }
                                    this._updateLoadedParentTileCache();
                                }
                            }, r.prototype.releaseSymbolFadeTiles = function() {
                                for(var t1 in this._tiles)this._tiles[t1].holdingForFade() && this._removeTile(t1);
                            }, r.prototype._updateRetainedTiles = function(t1, e1) {
                                for(var n = {}, i = {}, a = Math.max(e1 - r.maxOverzooming, this._source.minzoom), o = Math.max(e1 + r.maxUnderzooming, this._source.minzoom), s = {}, l = 0, c = t1; l < c.length; l += 1){
                                    var u = c[l], h = this._addTile(u);
                                    n[u.key] = u, h.hasData() || e1 < this._source.maxzoom && (s[u.key] = u);
                                }
                                this._retainLoadedChildren(s, e1, o, n);
                                for(var f = 0, p = t1; f < p.length; f += 1){
                                    var d = p[f], m = this._tiles[d.key];
                                    if (!m.hasData()) {
                                        if (e1 + 1 > this._source.maxzoom) {
                                            var g = d.children(this._source.maxzoom)[0], y = this.getTile(g);
                                            if (y && y.hasData()) {
                                                n[g.key] = g;
                                                continue;
                                            }
                                        } else {
                                            var v = d.children(this._source.maxzoom);
                                            if (n[v[0].key] && n[v[1].key] && n[v[2].key] && n[v[3].key]) continue;
                                        }
                                        for(var x = m.wasRequested(), _ = d.overscaledZ - 1; _ >= a; --_){
                                            var b = d.scaledTo(_);
                                            if (i[b.key]) break;
                                            if (i[b.key] = !0, !(m = this.getTile(b)) && x && (m = this._addTile(b)), m && (n[b.key] = b, x = m.wasRequested(), m.hasData())) break;
                                        }
                                    }
                                }
                                return n;
                            }, r.prototype._updateLoadedParentTileCache = function() {
                                for(var t1 in this._loadedParentTiles = {}, this._tiles){
                                    for(var e1 = [], r = void 0, n = this._tiles[t1].tileID; n.overscaledZ > 0;){
                                        if (n.key in this._loadedParentTiles) {
                                            r = this._loadedParentTiles[n.key];
                                            break;
                                        }
                                        e1.push(n.key);
                                        var i = n.scaledTo(n.overscaledZ - 1);
                                        if (r = this._getLoadedTile(i)) break;
                                        n = i;
                                    }
                                    for(var a = 0, o = e1; a < o.length; a += 1){
                                        var s = o[a];
                                        this._loadedParentTiles[s] = r;
                                    }
                                }
                            }, r.prototype._addTile = function(e1) {
                                var r = this._tiles[e1.key];
                                if (r) return r;
                                (r = this._cache.getAndRemove(e1)) && (this._setTileReloadTimer(e1.key, r), r.tileID = e1, this._state.initializeTileState(r, this.map ? this.map.painter : null), this._cacheTimers[e1.key] && (clearTimeout(this._cacheTimers[e1.key]), delete this._cacheTimers[e1.key], this._setTileReloadTimer(e1.key, r)));
                                var n = Boolean(r);
                                return n || (r = new t1.Tile(e1, this._source.tileSize * e1.overscaleFactor()), this._loadTile(r, this._tileLoaded.bind(this, r, e1.key, r.state))), r ? (r.uses++, this._tiles[e1.key] = r, n || this._source.fire(new t1.Event("dataloading", {
                                    tile: r,
                                    coord: r.tileID,
                                    dataType: "source"
                                })), r) : null;
                            }, r.prototype._setTileReloadTimer = function(t1, e1) {
                                var r = this;
                                t1 in this._timers && (clearTimeout(this._timers[t1]), delete this._timers[t1]);
                                var n = e1.getExpiryTimeout();
                                n && (this._timers[t1] = setTimeout(function() {
                                    r._reloadTile(t1, "expired"), delete r._timers[t1];
                                }, n));
                            }, r.prototype._removeTile = function(t1) {
                                var e1 = this._tiles[t1];
                                e1 && (e1.uses--, delete this._tiles[t1], this._timers[t1] && (clearTimeout(this._timers[t1]), delete this._timers[t1]), e1.uses > 0 || (e1.hasData() && "reloading" !== e1.state ? this._cache.add(e1.tileID, e1, e1.getExpiryTimeout()) : (e1.aborted = !0, this._abortTile(e1), this._unloadTile(e1))));
                            }, r.prototype.clearTiles = function() {
                                for(var t1 in this._shouldReloadOnResume = !1, this._paused = !1, this._tiles)this._removeTile(t1);
                                this._cache.reset();
                            }, r.prototype.tilesIn = function(e1, r, n) {
                                var i = this, a = [], o = this.transform;
                                if (!o) return a;
                                for(var s = n ? o.getCameraQueryGeometry(e1) : e1, l = e1.map(function(t1) {
                                    return o.pointCoordinate(t1);
                                }), c = s.map(function(t1) {
                                    return o.pointCoordinate(t1);
                                }), u = this.getIds(), h = 1 / 0, f = 1 / 0, p = -1 / 0, d = -1 / 0, m = 0, g = c; m < g.length; m += 1){
                                    var y = g[m];
                                    h = Math.min(h, y.x), f = Math.min(f, y.y), p = Math.max(p, y.x), d = Math.max(d, y.y);
                                }
                                for(var v = function(e1) {
                                    var n = i._tiles[u[e1]];
                                    if (!n.holdingForFade()) {
                                        var s = n.tileID, m = Math.pow(2, o.zoom - n.tileID.overscaledZ), g = r * n.queryPadding * t1.EXTENT / n.tileSize / m, y = [
                                            s.getTilePoint(new t1.MercatorCoordinate(h, f)),
                                            s.getTilePoint(new t1.MercatorCoordinate(p, d))
                                        ];
                                        if (y[0].x - g < t1.EXTENT && y[0].y - g < t1.EXTENT && y[1].x + g >= 0 && y[1].y + g >= 0) {
                                            var v = l.map(function(t1) {
                                                return s.getTilePoint(t1);
                                            }), x = c.map(function(t1) {
                                                return s.getTilePoint(t1);
                                            });
                                            a.push({
                                                tile: n,
                                                tileID: s,
                                                queryGeometry: v,
                                                cameraQueryGeometry: x,
                                                scale: m
                                            });
                                        }
                                    }
                                }, x = 0; x < u.length; x++)v(x);
                                return a;
                            }, r.prototype.getVisibleCoordinates = function(t1) {
                                for(var e1 = this, r = this.getRenderableIds(t1).map(function(t1) {
                                    return e1._tiles[t1].tileID;
                                }), n = 0, i = r; n < i.length; n += 1){
                                    var a = i[n];
                                    a.posMatrix = this.transform.calculatePosMatrix(a.toUnwrapped());
                                }
                                return r;
                            }, r.prototype.hasTransition = function() {
                                if (this._source.hasTransition()) return !0;
                                if (Ot(this._source.type)) for(var e1 in this._tiles){
                                    var r = this._tiles[e1];
                                    if (void 0 !== r.fadeEndTime && r.fadeEndTime >= t1.browser.now()) return !0;
                                }
                                return !1;
                            }, r.prototype.setFeatureState = function(t1, e1, r) {
                                t1 = t1 || "_geojsonTileLayer", this._state.updateState(t1, e1, r);
                            }, r.prototype.removeFeatureState = function(t1, e1, r) {
                                t1 = t1 || "_geojsonTileLayer", this._state.removeFeatureState(t1, e1, r);
                            }, r.prototype.getFeatureState = function(t1, e1) {
                                return t1 = t1 || "_geojsonTileLayer", this._state.getState(t1, e1);
                            }, r.prototype.setDependencies = function(t1, e1, r) {
                                var n = this._tiles[t1];
                                n && n.setDependencies(e1, r);
                            }, r.prototype.reloadTilesForDependencies = function(t1, e1) {
                                for(var r in this._tiles)this._tiles[r].hasDependency(t1, e1) && this._reloadTile(r, "reloading");
                                this._cache.filter(function(r) {
                                    return !r.hasDependency(t1, e1);
                                });
                            }, r;
                        }(t1.Evented);
                        function zt(t1, e1) {
                            var r = Math.abs(2 * t1.wrap) - +(t1.wrap < 0), n = Math.abs(2 * e1.wrap) - +(e1.wrap < 0);
                            return t1.overscaledZ - e1.overscaledZ || n - r || e1.canonical.y - t1.canonical.y || e1.canonical.x - t1.canonical.x;
                        }
                        function Ot(t1) {
                            return "raster" === t1 || "image" === t1 || "video" === t1;
                        }
                        function Dt() {
                            return new t1.window.Worker(oa.workerUrl);
                        }
                        Pt.maxOverzooming = 10, Pt.maxUnderzooming = 3;
                        var Rt = "mapboxgl_preloaded_worker_pool", Ft = function() {
                            this.active = {};
                        };
                        Ft.prototype.acquire = function(t1) {
                            if (!this.workers) for(this.workers = []; this.workers.length < Ft.workerCount;)this.workers.push(new Dt);
                            return this.active[t1] = !0, this.workers.slice();
                        }, Ft.prototype.release = function(t1) {
                            delete this.active[t1], 0 === this.numActive() && (this.workers.forEach(function(t1) {
                                t1.terminate();
                            }), this.workers = null);
                        }, Ft.prototype.isPreloaded = function() {
                            return !!this.active[Rt];
                        }, Ft.prototype.numActive = function() {
                            return Object.keys(this.active).length;
                        };
                        var Bt, Nt = Math.floor(t1.browser.hardwareConcurrency / 2);
                        function jt() {
                            return Bt || (Bt = new Ft), Bt;
                        }
                        function Ut(e1, r) {
                            var n = {};
                            for(var i in e1)"ref" !== i && (n[i] = e1[i]);
                            return t1.refProperties.forEach(function(t1) {
                                t1 in r && (n[t1] = r[t1]);
                            }), n;
                        }
                        function Vt(t1) {
                            t1 = t1.slice();
                            for(var e1 = Object.create(null), r = 0; r < t1.length; r++)e1[t1[r].id] = t1[r];
                            for(var n = 0; n < t1.length; n++)"ref" in t1[n] && (t1[n] = Ut(t1[n], e1[t1[n].ref]));
                            return t1;
                        }
                        Ft.workerCount = Math.max(Math.min(Nt, 6), 1);
                        var qt = {
                            setStyle: "setStyle",
                            addLayer: "addLayer",
                            removeLayer: "removeLayer",
                            setPaintProperty: "setPaintProperty",
                            setLayoutProperty: "setLayoutProperty",
                            setFilter: "setFilter",
                            addSource: "addSource",
                            removeSource: "removeSource",
                            setGeoJSONSourceData: "setGeoJSONSourceData",
                            setLayerZoomRange: "setLayerZoomRange",
                            setLayerProperty: "setLayerProperty",
                            setCenter: "setCenter",
                            setZoom: "setZoom",
                            setBearing: "setBearing",
                            setPitch: "setPitch",
                            setSprite: "setSprite",
                            setGlyphs: "setGlyphs",
                            setTransition: "setTransition",
                            setLight: "setLight"
                        };
                        function Ht(t1, e1, r) {
                            r.push({
                                command: qt.addSource,
                                args: [
                                    t1,
                                    e1[t1]
                                ]
                            });
                        }
                        function Gt(t1, e1, r) {
                            e1.push({
                                command: qt.removeSource,
                                args: [
                                    t1
                                ]
                            }), r[t1] = !0;
                        }
                        function Zt(t1, e1, r, n) {
                            Gt(t1, r, n), Ht(t1, e1, r);
                        }
                        function Wt(e1, r, n) {
                            var i;
                            for(i in e1[n])if (e1[n].hasOwnProperty(i) && "data" !== i && !t1.deepEqual(e1[n][i], r[n][i])) return !1;
                            for(i in r[n])if (r[n].hasOwnProperty(i) && "data" !== i && !t1.deepEqual(e1[n][i], r[n][i])) return !1;
                            return !0;
                        }
                        function Yt(e1, r, n, i, a, o) {
                            var s;
                            for(s in r = r || {}, e1 = e1 || {})e1.hasOwnProperty(s) && (t1.deepEqual(e1[s], r[s]) || n.push({
                                command: o,
                                args: [
                                    i,
                                    s,
                                    r[s],
                                    a
                                ]
                            }));
                            for(s in r)r.hasOwnProperty(s) && !e1.hasOwnProperty(s) && (t1.deepEqual(e1[s], r[s]) || n.push({
                                command: o,
                                args: [
                                    i,
                                    s,
                                    r[s],
                                    a
                                ]
                            }));
                        }
                        function Xt(t1) {
                            return t1.id;
                        }
                        function $t(t1, e1) {
                            return t1[e1.id] = e1, t1;
                        }
                        function Jt(e1, r) {
                            if (!e1) return [
                                {
                                    command: qt.setStyle,
                                    args: [
                                        r
                                    ]
                                }
                            ];
                            var n = [];
                            try {
                                if (!t1.deepEqual(e1.version, r.version)) return [
                                    {
                                        command: qt.setStyle,
                                        args: [
                                            r
                                        ]
                                    }
                                ];
                                t1.deepEqual(e1.center, r.center) || n.push({
                                    command: qt.setCenter,
                                    args: [
                                        r.center
                                    ]
                                }), t1.deepEqual(e1.zoom, r.zoom) || n.push({
                                    command: qt.setZoom,
                                    args: [
                                        r.zoom
                                    ]
                                }), t1.deepEqual(e1.bearing, r.bearing) || n.push({
                                    command: qt.setBearing,
                                    args: [
                                        r.bearing
                                    ]
                                }), t1.deepEqual(e1.pitch, r.pitch) || n.push({
                                    command: qt.setPitch,
                                    args: [
                                        r.pitch
                                    ]
                                }), t1.deepEqual(e1.sprite, r.sprite) || n.push({
                                    command: qt.setSprite,
                                    args: [
                                        r.sprite
                                    ]
                                }), t1.deepEqual(e1.glyphs, r.glyphs) || n.push({
                                    command: qt.setGlyphs,
                                    args: [
                                        r.glyphs
                                    ]
                                }), t1.deepEqual(e1.transition, r.transition) || n.push({
                                    command: qt.setTransition,
                                    args: [
                                        r.transition
                                    ]
                                }), t1.deepEqual(e1.light, r.light) || n.push({
                                    command: qt.setLight,
                                    args: [
                                        r.light
                                    ]
                                });
                                var i = {}, a = [];
                                !function(e1, r, n, i) {
                                    var a;
                                    for(a in r = r || {}, e1 = e1 || {})e1.hasOwnProperty(a) && (r.hasOwnProperty(a) || Gt(a, n, i));
                                    for(a in r)r.hasOwnProperty(a) && (e1.hasOwnProperty(a) ? t1.deepEqual(e1[a], r[a]) || ("geojson" === e1[a].type && "geojson" === r[a].type && Wt(e1, r, a) ? n.push({
                                        command: qt.setGeoJSONSourceData,
                                        args: [
                                            a,
                                            r[a].data
                                        ]
                                    }) : Zt(a, r, n, i)) : Ht(a, r, n));
                                }(e1.sources, r.sources, a, i);
                                var o = [];
                                e1.layers && e1.layers.forEach(function(t1) {
                                    i[t1.source] ? n.push({
                                        command: qt.removeLayer,
                                        args: [
                                            t1.id
                                        ]
                                    }) : o.push(t1);
                                }), n = n.concat(a), function(e1, r, n) {
                                    r = r || [];
                                    var i, a, o, s, l, c, u, h = (e1 = e1 || []).map(Xt), f = r.map(Xt), p = e1.reduce($t, {}), d = r.reduce($t, {}), m = h.slice(), g = Object.create(null);
                                    for(i = 0, a = 0; i < h.length; i++)o = h[i], d.hasOwnProperty(o) ? a++ : (n.push({
                                        command: qt.removeLayer,
                                        args: [
                                            o
                                        ]
                                    }), m.splice(m.indexOf(o, a), 1));
                                    for(i = 0, a = 0; i < f.length; i++)o = f[f.length - 1 - i], m[m.length - 1 - i] !== o && (p.hasOwnProperty(o) ? (n.push({
                                        command: qt.removeLayer,
                                        args: [
                                            o
                                        ]
                                    }), m.splice(m.lastIndexOf(o, m.length - a), 1)) : a++, c = m[m.length - i], n.push({
                                        command: qt.addLayer,
                                        args: [
                                            d[o],
                                            c
                                        ]
                                    }), m.splice(m.length - i, 0, o), g[o] = !0);
                                    for(i = 0; i < f.length; i++)if (s = p[o = f[i]], l = d[o], !g[o] && !t1.deepEqual(s, l)) {
                                        if (t1.deepEqual(s.source, l.source) && t1.deepEqual(s["source-layer"], l["source-layer"]) && t1.deepEqual(s.type, l.type)) {
                                            for(u in Yt(s.layout, l.layout, n, o, null, qt.setLayoutProperty), Yt(s.paint, l.paint, n, o, null, qt.setPaintProperty), t1.deepEqual(s.filter, l.filter) || n.push({
                                                command: qt.setFilter,
                                                args: [
                                                    o,
                                                    l.filter
                                                ]
                                            }), t1.deepEqual(s.minzoom, l.minzoom) && t1.deepEqual(s.maxzoom, l.maxzoom) || n.push({
                                                command: qt.setLayerZoomRange,
                                                args: [
                                                    o,
                                                    l.minzoom,
                                                    l.maxzoom
                                                ]
                                            }), s)s.hasOwnProperty(u) && "layout" !== u && "paint" !== u && "filter" !== u && "metadata" !== u && "minzoom" !== u && "maxzoom" !== u && (0 === u.indexOf("paint.") ? Yt(s[u], l[u], n, o, u.slice(6), qt.setPaintProperty) : t1.deepEqual(s[u], l[u]) || n.push({
                                                command: qt.setLayerProperty,
                                                args: [
                                                    o,
                                                    u,
                                                    l[u]
                                                ]
                                            }));
                                            for(u in l)l.hasOwnProperty(u) && !s.hasOwnProperty(u) && "layout" !== u && "paint" !== u && "filter" !== u && "metadata" !== u && "minzoom" !== u && "maxzoom" !== u && (0 === u.indexOf("paint.") ? Yt(s[u], l[u], n, o, u.slice(6), qt.setPaintProperty) : t1.deepEqual(s[u], l[u]) || n.push({
                                                command: qt.setLayerProperty,
                                                args: [
                                                    o,
                                                    u,
                                                    l[u]
                                                ]
                                            }));
                                        } else n.push({
                                            command: qt.removeLayer,
                                            args: [
                                                o
                                            ]
                                        }), c = m[m.lastIndexOf(o) + 1], n.push({
                                            command: qt.addLayer,
                                            args: [
                                                l,
                                                c
                                            ]
                                        });
                                    }
                                }(o, r.layers, n);
                            } catch (t1) {
                                console.warn("Unable to compute style diff:", t1), n = [
                                    {
                                        command: qt.setStyle,
                                        args: [
                                            r
                                        ]
                                    }
                                ];
                            }
                            return n;
                        }
                        var Kt = function(t1, e1) {
                            this.reset(t1, e1);
                        };
                        Kt.prototype.reset = function(t1, e1) {
                            this.points = t1 || [], this._distances = [
                                0
                            ];
                            for(var r = 1; r < this.points.length; r++)this._distances[r] = this._distances[r - 1] + this.points[r].dist(this.points[r - 1]);
                            this.length = this._distances[this._distances.length - 1], this.padding = Math.min(e1 || 0, .5 * this.length), this.paddedLength = this.length - 2 * this.padding;
                        }, Kt.prototype.lerp = function(e1) {
                            if (1 === this.points.length) return this.points[0];
                            e1 = t1.clamp(e1, 0, 1);
                            for(var r = 1, n = this._distances[r], i = e1 * this.paddedLength + this.padding; n < i && r < this._distances.length;)n = this._distances[++r];
                            var a = r - 1, o = this._distances[a], s = n - o, l = s > 0 ? (i - o) / s : 0;
                            return this.points[a].mult(1 - l).add(this.points[r].mult(l));
                        };
                        var Qt = function(t1, e1, r) {
                            var n = this.boxCells = [], i = this.circleCells = [];
                            this.xCellCount = Math.ceil(t1 / r), this.yCellCount = Math.ceil(e1 / r);
                            for(var a = 0; a < this.xCellCount * this.yCellCount; a++)n.push([]), i.push([]);
                            this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = t1, this.height = e1, this.xScale = this.xCellCount / t1, this.yScale = this.yCellCount / e1, this.boxUid = 0, this.circleUid = 0;
                        };
                        function te(e1, r, n, i, a) {
                            var o = t1.create();
                            return r ? (t1.scale(o, o, [
                                1 / a,
                                1 / a,
                                1
                            ]), n || t1.rotateZ(o, o, i.angle)) : t1.multiply(o, i.labelPlaneMatrix, e1), o;
                        }
                        function ee(e1, r, n, i, a) {
                            if (r) {
                                var o = t1.clone(e1);
                                return t1.scale(o, o, [
                                    a,
                                    a,
                                    1
                                ]), n || t1.rotateZ(o, o, -i.angle), o;
                            }
                            return i.glCoordMatrix;
                        }
                        function re(e1, r) {
                            var n = [
                                e1.x,
                                e1.y,
                                0,
                                1
                            ];
                            pe(n, n, r);
                            var i = n[3];
                            return {
                                point: new t1.Point(n[0] / i, n[1] / i),
                                signedDistanceFromCamera: i
                            };
                        }
                        function ne(t1, e1) {
                            return .5 + t1 / e1 * .5;
                        }
                        function ie(t1, e1) {
                            var r = t1[0] / t1[3], n = t1[1] / t1[3];
                            return r >= -e1[0] && r <= e1[0] && n >= -e1[1] && n <= e1[1];
                        }
                        function ae(e1, r, n, i, a, o, s, l) {
                            var c = i ? e1.textSizeData : e1.iconSizeData, u = t1.evaluateSizeForZoom(c, n.transform.zoom), h = [
                                256 / n.width * 2 + 1,
                                256 / n.height * 2 + 1
                            ], f = i ? e1.text.dynamicLayoutVertexArray : e1.icon.dynamicLayoutVertexArray;
                            f.clear();
                            for(var p = e1.lineVertexArray, d = i ? e1.text.placedSymbolArray : e1.icon.placedSymbolArray, m = n.transform.width / n.transform.height, g = !1, y = 0; y < d.length; y++){
                                var v = d.get(y);
                                if (v.hidden || v.writingMode === t1.WritingMode.vertical && !g) fe(v.numGlyphs, f);
                                else {
                                    g = !1;
                                    var x = [
                                        v.anchorX,
                                        v.anchorY,
                                        0,
                                        1
                                    ];
                                    if (t1.transformMat4(x, x, r), ie(x, h)) {
                                        var _ = x[3], b = ne(n.transform.cameraToCenterDistance, _), w = t1.evaluateSizeForFeature(c, u, v), T = s ? w / b : w * b, k = new t1.Point(v.anchorX, v.anchorY), A = re(k, a).point, M = {}, S = le(v, T, !1, l, r, a, o, e1.glyphOffsetArray, p, f, A, k, M, m);
                                        g = S.useVertical, (S.notEnoughRoom || g || S.needsFlipping && le(v, T, !0, l, r, a, o, e1.glyphOffsetArray, p, f, A, k, M, m).notEnoughRoom) && fe(v.numGlyphs, f);
                                    } else fe(v.numGlyphs, f);
                                }
                            }
                            i ? e1.text.dynamicLayoutVertexBuffer.updateData(f) : e1.icon.dynamicLayoutVertexBuffer.updateData(f);
                        }
                        function oe(t1, e1, r, n, i, a, o, s, l, c, u) {
                            var h = s.glyphStartIndex + s.numGlyphs, f = s.lineStartIndex, p = s.lineStartIndex + s.lineLength, d = e1.getoffsetX(s.glyphStartIndex), m = e1.getoffsetX(h - 1), g = ue(t1 * d, r, n, i, a, o, s.segment, f, p, l, c, u);
                            if (!g) return null;
                            var y = ue(t1 * m, r, n, i, a, o, s.segment, f, p, l, c, u);
                            return y ? {
                                first: g,
                                last: y
                            } : null;
                        }
                        function se(e1, r, n, i) {
                            return e1 === t1.WritingMode.horizontal && Math.abs(n.y - r.y) > Math.abs(n.x - r.x) * i ? {
                                useVertical: !0
                            } : (e1 === t1.WritingMode.vertical ? r.y < n.y : r.x > n.x) ? {
                                needsFlipping: !0
                            } : null;
                        }
                        function le(e1, r, n, i, a, o, s, l, c, u, h, f, p, d) {
                            var m, g = r / 24, y = e1.lineOffsetX * g, v = e1.lineOffsetY * g;
                            if (e1.numGlyphs > 1) {
                                var x = e1.glyphStartIndex + e1.numGlyphs, _ = e1.lineStartIndex, b = e1.lineStartIndex + e1.lineLength, w = oe(g, l, y, v, n, h, f, e1, c, o, p);
                                if (!w) return {
                                    notEnoughRoom: !0
                                };
                                var T = re(w.first.point, s).point, k = re(w.last.point, s).point;
                                if (i && !n) {
                                    var A = se(e1.writingMode, T, k, d);
                                    if (A) return A;
                                }
                                m = [
                                    w.first
                                ];
                                for(var M = e1.glyphStartIndex + 1; M < x - 1; M++)m.push(ue(g * l.getoffsetX(M), y, v, n, h, f, e1.segment, _, b, c, o, p));
                                m.push(w.last);
                            } else {
                                if (i && !n) {
                                    var S = re(f, a).point, E = e1.lineStartIndex + e1.segment + 1, C = new t1.Point(c.getx(E), c.gety(E)), L = re(C, a), I = L.signedDistanceFromCamera > 0 ? L.point : ce(f, C, S, 1, a), P = se(e1.writingMode, S, I, d);
                                    if (P) return P;
                                }
                                var z = ue(g * l.getoffsetX(e1.glyphStartIndex), y, v, n, h, f, e1.segment, e1.lineStartIndex, e1.lineStartIndex + e1.lineLength, c, o, p);
                                if (!z) return {
                                    notEnoughRoom: !0
                                };
                                m = [
                                    z
                                ];
                            }
                            for(var O = 0, D = m; O < D.length; O += 1){
                                var R = D[O];
                                t1.addDynamicAttributes(u, R.point, R.angle);
                            }
                            return {};
                        }
                        function ce(t1, e1, r, n, i) {
                            var a = re(t1.add(t1.sub(e1)._unit()), i).point, o = r.sub(a);
                            return r.add(o._mult(n / o.mag()));
                        }
                        function ue(e1, r, n, i, a, o, s, l, c, u, h, f) {
                            var p = i ? e1 - r : e1 + r, d = p > 0 ? 1 : -1, m = 0;
                            i && (d *= -1, m = Math.PI), d < 0 && (m += Math.PI);
                            for(var g = d > 0 ? l + s : l + s + 1, y = a, v = a, x = 0, _ = 0, b = Math.abs(p), w = []; x + _ <= b;){
                                if ((g += d) < l || g >= c) return null;
                                if (v = y, w.push(y), void 0 === (y = f[g])) {
                                    var T = new t1.Point(u.getx(g), u.gety(g)), k = re(T, h);
                                    if (k.signedDistanceFromCamera > 0) y = f[g] = k.point;
                                    else {
                                        var A = g - d;
                                        y = ce(0 === x ? o : new t1.Point(u.getx(A), u.gety(A)), T, v, b - x + 1, h);
                                    }
                                }
                                x += _, _ = v.dist(y);
                            }
                            var M = (b - x) / _, S = y.sub(v), E = S.mult(M)._add(v);
                            E._add(S._unit()._perp()._mult(n * d));
                            var C = m + Math.atan2(y.y - v.y, y.x - v.x);
                            return w.push(E), {
                                point: E,
                                angle: C,
                                path: w
                            };
                        }
                        Qt.prototype.keysLength = function() {
                            return this.boxKeys.length + this.circleKeys.length;
                        }, Qt.prototype.insert = function(t1, e1, r, n, i) {
                            this._forEachCell(e1, r, n, i, this._insertBoxCell, this.boxUid++), this.boxKeys.push(t1), this.bboxes.push(e1), this.bboxes.push(r), this.bboxes.push(n), this.bboxes.push(i);
                        }, Qt.prototype.insertCircle = function(t1, e1, r, n) {
                            this._forEachCell(e1 - n, r - n, e1 + n, r + n, this._insertCircleCell, this.circleUid++), this.circleKeys.push(t1), this.circles.push(e1), this.circles.push(r), this.circles.push(n);
                        }, Qt.prototype._insertBoxCell = function(t1, e1, r, n, i, a) {
                            this.boxCells[i].push(a);
                        }, Qt.prototype._insertCircleCell = function(t1, e1, r, n, i, a) {
                            this.circleCells[i].push(a);
                        }, Qt.prototype._query = function(t1, e1, r, n, i, a) {
                            if (r < 0 || t1 > this.width || n < 0 || e1 > this.height) return !i && [];
                            var o = [];
                            if (t1 <= 0 && e1 <= 0 && this.width <= r && this.height <= n) {
                                if (i) return !0;
                                for(var s = 0; s < this.boxKeys.length; s++)o.push({
                                    key: this.boxKeys[s],
                                    x1: this.bboxes[4 * s],
                                    y1: this.bboxes[4 * s + 1],
                                    x2: this.bboxes[4 * s + 2],
                                    y2: this.bboxes[4 * s + 3]
                                });
                                for(var l = 0; l < this.circleKeys.length; l++){
                                    var c = this.circles[3 * l], u = this.circles[3 * l + 1], h = this.circles[3 * l + 2];
                                    o.push({
                                        key: this.circleKeys[l],
                                        x1: c - h,
                                        y1: u - h,
                                        x2: c + h,
                                        y2: u + h
                                    });
                                }
                                return a ? o.filter(a) : o;
                            }
                            var f = {
                                hitTest: i,
                                seenUids: {
                                    box: {},
                                    circle: {}
                                }
                            };
                            return this._forEachCell(t1, e1, r, n, this._queryCell, o, f, a), i ? o.length > 0 : o;
                        }, Qt.prototype._queryCircle = function(t1, e1, r, n, i) {
                            var a = t1 - r, o = t1 + r, s = e1 - r, l = e1 + r;
                            if (o < 0 || a > this.width || l < 0 || s > this.height) return !n && [];
                            var c = [], u = {
                                hitTest: n,
                                circle: {
                                    x: t1,
                                    y: e1,
                                    radius: r
                                },
                                seenUids: {
                                    box: {},
                                    circle: {}
                                }
                            };
                            return this._forEachCell(a, s, o, l, this._queryCellCircle, c, u, i), n ? c.length > 0 : c;
                        }, Qt.prototype.query = function(t1, e1, r, n, i) {
                            return this._query(t1, e1, r, n, !1, i);
                        }, Qt.prototype.hitTest = function(t1, e1, r, n, i) {
                            return this._query(t1, e1, r, n, !0, i);
                        }, Qt.prototype.hitTestCircle = function(t1, e1, r, n) {
                            return this._queryCircle(t1, e1, r, !0, n);
                        }, Qt.prototype._queryCell = function(t1, e1, r, n, i, a, o, s) {
                            var l = o.seenUids, c = this.boxCells[i];
                            if (null !== c) for(var u = this.bboxes, h = 0, f = c; h < f.length; h += 1){
                                var p = f[h];
                                if (!l.box[p]) {
                                    l.box[p] = !0;
                                    var d = 4 * p;
                                    if (t1 <= u[d + 2] && e1 <= u[d + 3] && r >= u[d + 0] && n >= u[d + 1] && (!s || s(this.boxKeys[p]))) {
                                        if (o.hitTest) return a.push(!0), !0;
                                        a.push({
                                            key: this.boxKeys[p],
                                            x1: u[d],
                                            y1: u[d + 1],
                                            x2: u[d + 2],
                                            y2: u[d + 3]
                                        });
                                    }
                                }
                            }
                            var m = this.circleCells[i];
                            if (null !== m) for(var g = this.circles, y = 0, v = m; y < v.length; y += 1){
                                var x = v[y];
                                if (!l.circle[x]) {
                                    l.circle[x] = !0;
                                    var _ = 3 * x;
                                    if (this._circleAndRectCollide(g[_], g[_ + 1], g[_ + 2], t1, e1, r, n) && (!s || s(this.circleKeys[x]))) {
                                        if (o.hitTest) return a.push(!0), !0;
                                        var b = g[_], w = g[_ + 1], T = g[_ + 2];
                                        a.push({
                                            key: this.circleKeys[x],
                                            x1: b - T,
                                            y1: w - T,
                                            x2: b + T,
                                            y2: w + T
                                        });
                                    }
                                }
                            }
                        }, Qt.prototype._queryCellCircle = function(t1, e1, r, n, i, a, o, s) {
                            var l = o.circle, c = o.seenUids, u = this.boxCells[i];
                            if (null !== u) for(var h = this.bboxes, f = 0, p = u; f < p.length; f += 1){
                                var d = p[f];
                                if (!c.box[d]) {
                                    c.box[d] = !0;
                                    var m = 4 * d;
                                    if (this._circleAndRectCollide(l.x, l.y, l.radius, h[m + 0], h[m + 1], h[m + 2], h[m + 3]) && (!s || s(this.boxKeys[d]))) return a.push(!0), !0;
                                }
                            }
                            var g = this.circleCells[i];
                            if (null !== g) for(var y = this.circles, v = 0, x = g; v < x.length; v += 1){
                                var _ = x[v];
                                if (!c.circle[_]) {
                                    c.circle[_] = !0;
                                    var b = 3 * _;
                                    if (this._circlesCollide(y[b], y[b + 1], y[b + 2], l.x, l.y, l.radius) && (!s || s(this.circleKeys[_]))) return a.push(!0), !0;
                                }
                            }
                        }, Qt.prototype._forEachCell = function(t1, e1, r, n, i, a, o, s) {
                            for(var l = this._convertToXCellCoord(t1), c = this._convertToYCellCoord(e1), u = this._convertToXCellCoord(r), h = this._convertToYCellCoord(n), f = l; f <= u; f++)for(var p = c; p <= h; p++){
                                var d = this.xCellCount * p + f;
                                if (i.call(this, t1, e1, r, n, d, a, o, s)) return;
                            }
                        }, Qt.prototype._convertToXCellCoord = function(t1) {
                            return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(t1 * this.xScale)));
                        }, Qt.prototype._convertToYCellCoord = function(t1) {
                            return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(t1 * this.yScale)));
                        }, Qt.prototype._circlesCollide = function(t1, e1, r, n, i, a) {
                            var o = n - t1, s = i - e1, l = r + a;
                            return l * l > o * o + s * s;
                        }, Qt.prototype._circleAndRectCollide = function(t1, e1, r, n, i, a, o) {
                            var s = (a - n) / 2, l = Math.abs(t1 - (n + s));
                            if (l > s + r) return !1;
                            var c = (o - i) / 2, u = Math.abs(e1 - (i + c));
                            if (u > c + r) return !1;
                            if (l <= s || u <= c) return !0;
                            var h = l - s, f = u - c;
                            return h * h + f * f <= r * r;
                        };
                        var he = new Float32Array([
                            -1 / 0,
                            -1 / 0,
                            0,
                            -1 / 0,
                            -1 / 0,
                            0,
                            -1 / 0,
                            -1 / 0,
                            0,
                            -1 / 0,
                            -1 / 0,
                            0
                        ]);
                        function fe(t1, e1) {
                            for(var r = 0; r < t1; r++){
                                var n = e1.length;
                                e1.resize(n + 4), e1.float32.set(he, 3 * n);
                            }
                        }
                        function pe(t1, e1, r) {
                            var n = e1[0], i = e1[1];
                            return t1[0] = r[0] * n + r[4] * i + r[12], t1[1] = r[1] * n + r[5] * i + r[13], t1[3] = r[3] * n + r[7] * i + r[15], t1;
                        }
                        var de = 100, me = function(t1, e1, r) {
                            void 0 === e1 && (e1 = new Qt(t1.width + 200, t1.height + 200, 25)), void 0 === r && (r = new Qt(t1.width + 200, t1.height + 200, 25)), this.transform = t1, this.grid = e1, this.ignoredGrid = r, this.pitchfactor = Math.cos(t1._pitch) * t1.cameraToCenterDistance, this.screenRightBoundary = t1.width + de, this.screenBottomBoundary = t1.height + de, this.gridRightBoundary = t1.width + 200, this.gridBottomBoundary = t1.height + 200;
                        };
                        function ge(e1, r, n) {
                            return r * (t1.EXTENT / (e1.tileSize * Math.pow(2, n - e1.tileID.overscaledZ)));
                        }
                        me.prototype.placeCollisionBox = function(t1, e1, r, n, i) {
                            var a = this.projectAndGetPerspectiveRatio(n, t1.anchorPointX, t1.anchorPointY), o = r * a.perspectiveRatio, s = t1.x1 * o + a.point.x, l = t1.y1 * o + a.point.y, c = t1.x2 * o + a.point.x, u = t1.y2 * o + a.point.y;
                            return !this.isInsideGrid(s, l, c, u) || !e1 && this.grid.hitTest(s, l, c, u, i) ? {
                                box: [],
                                offscreen: !1
                            } : {
                                box: [
                                    s,
                                    l,
                                    c,
                                    u
                                ],
                                offscreen: this.isOffscreen(s, l, c, u)
                            };
                        }, me.prototype.placeCollisionCircles = function(e1, r, n, i, a, o, s, l, c, u, h, f, p) {
                            var d = [], m = new t1.Point(r.anchorX, r.anchorY), g = re(m, o), y = ne(this.transform.cameraToCenterDistance, g.signedDistanceFromCamera), v = (u ? a / y : a * y) / t1.ONE_EM, x = re(m, s).point, _ = oe(v, i, r.lineOffsetX * v, r.lineOffsetY * v, !1, x, m, r, n, s, {}), b = !1, w = !1, T = !0;
                            if (_) {
                                for(var k = .5 * f * y + p, A = new t1.Point(-100, -100), M = new t1.Point(this.screenRightBoundary, this.screenBottomBoundary), S = new Kt, E = _.first, C = _.last, L = [], I = E.path.length - 1; I >= 1; I--)L.push(E.path[I]);
                                for(var P = 1; P < C.path.length; P++)L.push(C.path[P]);
                                var z = 2.5 * k;
                                if (l) {
                                    var O = L.map(function(t1) {
                                        return re(t1, l);
                                    });
                                    L = O.some(function(t1) {
                                        return t1.signedDistanceFromCamera <= 0;
                                    }) ? [] : O.map(function(t1) {
                                        return t1.point;
                                    });
                                }
                                var D = [];
                                if (L.length > 0) {
                                    for(var R = L[0].clone(), F = L[0].clone(), B = 1; B < L.length; B++)R.x = Math.min(R.x, L[B].x), R.y = Math.min(R.y, L[B].y), F.x = Math.max(F.x, L[B].x), F.y = Math.max(F.y, L[B].y);
                                    D = R.x >= A.x && F.x <= M.x && R.y >= A.y && F.y <= M.y ? [
                                        L
                                    ] : F.x < A.x || R.x > M.x || F.y < A.y || R.y > M.y ? [] : t1.clipLine([
                                        L
                                    ], A.x, A.y, M.x, M.y);
                                }
                                for(var N = 0, j = D; N < j.length; N += 1){
                                    var U = j[N];
                                    S.reset(U, .25 * k);
                                    var V;
                                    V = S.length <= .5 * k ? 1 : Math.ceil(S.paddedLength / z) + 1;
                                    for(var q = 0; q < V; q++){
                                        var H = q / Math.max(V - 1, 1), G = S.lerp(H), Z = G.x + de, W = G.y + de;
                                        d.push(Z, W, k, 0);
                                        var Y = Z - k, X = W - k, $ = Z + k, J = W + k;
                                        if (T = T && this.isOffscreen(Y, X, $, J), w = w || this.isInsideGrid(Y, X, $, J), !e1 && this.grid.hitTestCircle(Z, W, k, h) && (b = !0, !c)) return {
                                            circles: [],
                                            offscreen: !1,
                                            collisionDetected: b
                                        };
                                    }
                                }
                            }
                            return {
                                circles: !c && b || !w ? [] : d,
                                offscreen: T,
                                collisionDetected: b
                            };
                        }, me.prototype.queryRenderedSymbols = function(e1) {
                            if (0 === e1.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
                            for(var r = [], n = 1 / 0, i = 1 / 0, a = -1 / 0, o = -1 / 0, s = 0, l = e1; s < l.length; s += 1){
                                var c = l[s], u = new t1.Point(c.x + de, c.y + de);
                                n = Math.min(n, u.x), i = Math.min(i, u.y), a = Math.max(a, u.x), o = Math.max(o, u.y), r.push(u);
                            }
                            for(var h = {}, f = {}, p = 0, d = this.grid.query(n, i, a, o).concat(this.ignoredGrid.query(n, i, a, o)); p < d.length; p += 1){
                                var m = d[p], g = m.key;
                                if (void 0 === h[g.bucketInstanceId] && (h[g.bucketInstanceId] = {}), !h[g.bucketInstanceId][g.featureIndex]) {
                                    var y = [
                                        new t1.Point(m.x1, m.y1),
                                        new t1.Point(m.x2, m.y1),
                                        new t1.Point(m.x2, m.y2),
                                        new t1.Point(m.x1, m.y2)
                                    ];
                                    t1.polygonIntersectsPolygon(r, y) && (h[g.bucketInstanceId][g.featureIndex] = !0, void 0 === f[g.bucketInstanceId] && (f[g.bucketInstanceId] = []), f[g.bucketInstanceId].push(g.featureIndex));
                                }
                            }
                            return f;
                        }, me.prototype.insertCollisionBox = function(t1, e1, r, n, i) {
                            var a = {
                                bucketInstanceId: r,
                                featureIndex: n,
                                collisionGroupID: i
                            };
                            (e1 ? this.ignoredGrid : this.grid).insert(a, t1[0], t1[1], t1[2], t1[3]);
                        }, me.prototype.insertCollisionCircles = function(t1, e1, r, n, i) {
                            for(var a = e1 ? this.ignoredGrid : this.grid, o = {
                                bucketInstanceId: r,
                                featureIndex: n,
                                collisionGroupID: i
                            }, s = 0; s < t1.length; s += 4)a.insertCircle(o, t1[s], t1[s + 1], t1[s + 2]);
                        }, me.prototype.projectAndGetPerspectiveRatio = function(e1, r, n) {
                            var i = [
                                r,
                                n,
                                0,
                                1
                            ];
                            return pe(i, i, e1), {
                                point: new t1.Point((i[0] / i[3] + 1) / 2 * this.transform.width + de, (-i[1] / i[3] + 1) / 2 * this.transform.height + de),
                                perspectiveRatio: .5 + this.transform.cameraToCenterDistance / i[3] * .5
                            };
                        }, me.prototype.isOffscreen = function(t1, e1, r, n) {
                            return r < de || t1 >= this.screenRightBoundary || n < de || e1 > this.screenBottomBoundary;
                        }, me.prototype.isInsideGrid = function(t1, e1, r, n) {
                            return r >= 0 && t1 < this.gridRightBoundary && n >= 0 && e1 < this.gridBottomBoundary;
                        }, me.prototype.getViewportMatrix = function() {
                            var e1 = t1.identity([]);
                            return t1.translate(e1, e1, [
                                -100,
                                -100,
                                0
                            ]), e1;
                        };
                        var ye = function(t1, e1, r, n) {
                            this.opacity = t1 ? Math.max(0, Math.min(1, t1.opacity + (t1.placed ? e1 : -e1))) : n && r ? 1 : 0, this.placed = r;
                        };
                        ye.prototype.isHidden = function() {
                            return 0 === this.opacity && !this.placed;
                        };
                        var ve = function(t1, e1, r, n, i) {
                            this.text = new ye(t1 ? t1.text : null, e1, r, i), this.icon = new ye(t1 ? t1.icon : null, e1, n, i);
                        };
                        ve.prototype.isHidden = function() {
                            return this.text.isHidden() && this.icon.isHidden();
                        };
                        var xe = function(t1, e1, r) {
                            this.text = t1, this.icon = e1, this.skipFade = r;
                        }, _e = function() {
                            this.invProjMatrix = t1.create(), this.viewportMatrix = t1.create(), this.circles = [];
                        }, be = function(t1, e1, r, n, i) {
                            this.bucketInstanceId = t1, this.featureIndex = e1, this.sourceLayerIndex = r, this.bucketIndex = n, this.tileID = i;
                        }, we = function(t1) {
                            this.crossSourceCollisions = t1, this.maxGroupID = 0, this.collisionGroups = {};
                        };
                        function Te(e1, r, n, i, a) {
                            var o = t1.getAnchorAlignment(e1), s = -(o.horizontalAlign - .5) * r, l = -(o.verticalAlign - .5) * n, c = t1.evaluateVariableOffset(e1, i);
                            return new t1.Point(s + c[0] * a, l + c[1] * a);
                        }
                        function ke(e1, r, n, i, a, o) {
                            var s = e1.x1, l = e1.x2, c = e1.y1, u = e1.y2, h = e1.anchorPointX, f = e1.anchorPointY, p = new t1.Point(r, n);
                            return i && p._rotate(a ? o : -o), {
                                x1: s + p.x,
                                y1: c + p.y,
                                x2: l + p.x,
                                y2: u + p.y,
                                anchorPointX: h,
                                anchorPointY: f
                            };
                        }
                        we.prototype.get = function(t1) {
                            if (this.crossSourceCollisions) return {
                                ID: 0,
                                predicate: null
                            };
                            if (!this.collisionGroups[t1]) {
                                var e1 = ++this.maxGroupID;
                                this.collisionGroups[t1] = {
                                    ID: e1,
                                    predicate: function(t1) {
                                        return t1.collisionGroupID === e1;
                                    }
                                };
                            }
                            return this.collisionGroups[t1];
                        };
                        var Ae = function(t1, e1, r, n) {
                            this.transform = t1.clone(), this.collisionIndex = new me(this.transform), this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = e1, this.retainedQueryData = {}, this.collisionGroups = new we(r), this.collisionCircleArrays = {}, this.prevPlacement = n, n && (n.prevPlacement = void 0), this.placedOrientations = {};
                        };
                        function Me(t1, e1, r, n, i) {
                            t1.emplaceBack(e1 ? 1 : 0, r ? 1 : 0, n || 0, i || 0), t1.emplaceBack(e1 ? 1 : 0, r ? 1 : 0, n || 0, i || 0), t1.emplaceBack(e1 ? 1 : 0, r ? 1 : 0, n || 0, i || 0), t1.emplaceBack(e1 ? 1 : 0, r ? 1 : 0, n || 0, i || 0);
                        }
                        Ae.prototype.getBucketParts = function(e1, r, n, i) {
                            var a = n.getBucket(r), o = n.latestFeatureIndex;
                            if (a && o && r.id === a.layerIds[0]) {
                                var s = n.collisionBoxArray, l = a.layers[0].layout, c = Math.pow(2, this.transform.zoom - n.tileID.overscaledZ), u = n.tileSize / t1.EXTENT, h = this.transform.calculatePosMatrix(n.tileID.toUnwrapped()), f = "map" === l.get("text-pitch-alignment"), p = "map" === l.get("text-rotation-alignment"), d = ge(n, 1, this.transform.zoom), m = te(h, f, p, this.transform, d), g = null;
                                if (f) {
                                    var y = ee(h, f, p, this.transform, d);
                                    g = t1.multiply([], this.transform.labelPlaneMatrix, y);
                                }
                                this.retainedQueryData[a.bucketInstanceId] = new be(a.bucketInstanceId, o, a.sourceLayerIndex, a.index, n.tileID);
                                var v = {
                                    bucket: a,
                                    layout: l,
                                    posMatrix: h,
                                    textLabelPlaneMatrix: m,
                                    labelToScreenMatrix: g,
                                    scale: c,
                                    textPixelRatio: u,
                                    holdingForFade: n.holdingForFade(),
                                    collisionBoxArray: s,
                                    partiallyEvaluatedTextSize: t1.evaluateSizeForZoom(a.textSizeData, this.transform.zoom),
                                    collisionGroup: this.collisionGroups.get(a.sourceID)
                                };
                                if (i) for(var x = 0, _ = a.sortKeyRanges; x < _.length; x += 1){
                                    var b = _[x], w = b.sortKey, T = b.symbolInstanceStart, k = b.symbolInstanceEnd;
                                    e1.push({
                                        sortKey: w,
                                        symbolInstanceStart: T,
                                        symbolInstanceEnd: k,
                                        parameters: v
                                    });
                                }
                                else e1.push({
                                    symbolInstanceStart: 0,
                                    symbolInstanceEnd: a.symbolInstances.length,
                                    parameters: v
                                });
                            }
                        }, Ae.prototype.attemptAnchorPlacement = function(t1, e1, r, n, i, a, o, s, l, c, u, h, f, p, d) {
                            var m, g = [
                                h.textOffset0,
                                h.textOffset1
                            ], y = Te(t1, r, n, g, i), v = this.collisionIndex.placeCollisionBox(ke(e1, y.x, y.y, a, o, this.transform.angle), u, s, l, c.predicate);
                            if (!d || 0 !== this.collisionIndex.placeCollisionBox(ke(d, y.x, y.y, a, o, this.transform.angle), u, s, l, c.predicate).box.length) return v.box.length > 0 ? (this.prevPlacement && this.prevPlacement.variableOffsets[h.crossTileID] && this.prevPlacement.placements[h.crossTileID] && this.prevPlacement.placements[h.crossTileID].text && (m = this.prevPlacement.variableOffsets[h.crossTileID].anchor), this.variableOffsets[h.crossTileID] = {
                                textOffset: g,
                                width: r,
                                height: n,
                                anchor: t1,
                                textBoxScale: i,
                                prevAnchor: m
                            }, this.markUsedJustification(f, t1, h, p), f.allowVerticalPlacement && (this.markUsedOrientation(f, p, h), this.placedOrientations[h.crossTileID] = p), {
                                shift: y,
                                placedGlyphBoxes: v
                            }) : void 0;
                        }, Ae.prototype.placeLayerBucketPart = function(e1, r, n) {
                            var i = this, a = e1.parameters, o = a.bucket, s = a.layout, l = a.posMatrix, c = a.textLabelPlaneMatrix, u = a.labelToScreenMatrix, h = a.textPixelRatio, f = a.holdingForFade, p = a.collisionBoxArray, d = a.partiallyEvaluatedTextSize, m = a.collisionGroup, g = s.get("text-optional"), y = s.get("icon-optional"), v = s.get("text-allow-overlap"), x = s.get("icon-allow-overlap"), _ = "map" === s.get("text-rotation-alignment"), b = "map" === s.get("text-pitch-alignment"), w = "none" !== s.get("icon-text-fit"), T = "viewport-y" === s.get("symbol-z-order"), k = v && (x || !o.hasIconData() || y), A = x && (v || !o.hasTextData() || g);
                            !o.collisionArrays && p && o.deserializeCollisionBoxes(p);
                            var M = function(e1, a) {
                                if (!r[e1.crossTileID]) {
                                    if (f) i.placements[e1.crossTileID] = new xe(!1, !1, !1);
                                    else {
                                        var p, T = !1, M = !1, S = !0, E = null, C = {
                                            box: null,
                                            offscreen: null
                                        }, L = {
                                            box: null,
                                            offscreen: null
                                        }, I = null, P = null, z = 0, O = 0, D = 0;
                                        a.textFeatureIndex ? z = a.textFeatureIndex : e1.useRuntimeCollisionCircles && (z = e1.featureIndex), a.verticalTextFeatureIndex && (O = a.verticalTextFeatureIndex);
                                        var R = a.textBox;
                                        if (R) {
                                            var F = function(r) {
                                                var n = t1.WritingMode.horizontal;
                                                if (o.allowVerticalPlacement && !r && i.prevPlacement) {
                                                    var a = i.prevPlacement.placedOrientations[e1.crossTileID];
                                                    a && (i.placedOrientations[e1.crossTileID] = a, n = a, i.markUsedOrientation(o, n, e1));
                                                }
                                                return n;
                                            }, B = function(r, n) {
                                                if (o.allowVerticalPlacement && e1.numVerticalGlyphVertices > 0 && a.verticalTextBox) for(var i = 0, s = o.writingModes; i < s.length && (s[i] === t1.WritingMode.vertical ? (C = n(), L = C) : C = r(), !(C && C.box && C.box.length)); i += 1);
                                                else C = r();
                                            };
                                            if (s.get("text-variable-anchor")) {
                                                var N = s.get("text-variable-anchor");
                                                if (i.prevPlacement && i.prevPlacement.variableOffsets[e1.crossTileID]) {
                                                    var j = i.prevPlacement.variableOffsets[e1.crossTileID];
                                                    N.indexOf(j.anchor) > 0 && (N = N.filter(function(t1) {
                                                        return t1 !== j.anchor;
                                                    })).unshift(j.anchor);
                                                }
                                                var U = function(t1, r, n) {
                                                    for(var a = t1.x2 - t1.x1, s = t1.y2 - t1.y1, c = e1.textBoxScale, u = w && !x ? r : null, f = {
                                                        box: [],
                                                        offscreen: !1
                                                    }, p = v ? 2 * N.length : N.length, d = 0; d < p; ++d){
                                                        var g = N[d % N.length], y = d >= N.length, k = i.attemptAnchorPlacement(g, t1, a, s, c, _, b, h, l, m, y, e1, o, n, u);
                                                        if (k && (f = k.placedGlyphBoxes) && f.box && f.box.length) {
                                                            T = !0, E = k.shift;
                                                            break;
                                                        }
                                                    }
                                                    return f;
                                                };
                                                B(function() {
                                                    return U(R, a.iconBox, t1.WritingMode.horizontal);
                                                }, function() {
                                                    var r = a.verticalTextBox, n = C && C.box && C.box.length;
                                                    return o.allowVerticalPlacement && !n && e1.numVerticalGlyphVertices > 0 && r ? U(r, a.verticalIconBox, t1.WritingMode.vertical) : {
                                                        box: null,
                                                        offscreen: null
                                                    };
                                                }), C && (T = C.box, S = C.offscreen);
                                                var V = F(C && C.box);
                                                if (!T && i.prevPlacement) {
                                                    var q = i.prevPlacement.variableOffsets[e1.crossTileID];
                                                    q && (i.variableOffsets[e1.crossTileID] = q, i.markUsedJustification(o, q.anchor, e1, V));
                                                }
                                            } else {
                                                var H = function(t1, r) {
                                                    var n = i.collisionIndex.placeCollisionBox(t1, v, h, l, m.predicate);
                                                    return n && n.box && n.box.length && (i.markUsedOrientation(o, r, e1), i.placedOrientations[e1.crossTileID] = r), n;
                                                };
                                                B(function() {
                                                    return H(R, t1.WritingMode.horizontal);
                                                }, function() {
                                                    var r = a.verticalTextBox;
                                                    return o.allowVerticalPlacement && e1.numVerticalGlyphVertices > 0 && r ? H(r, t1.WritingMode.vertical) : {
                                                        box: null,
                                                        offscreen: null
                                                    };
                                                }), F(C && C.box && C.box.length);
                                            }
                                        }
                                        if (T = (p = C) && p.box && p.box.length > 0, S = p && p.offscreen, e1.useRuntimeCollisionCircles) {
                                            var G = o.text.placedSymbolArray.get(e1.centerJustifiedTextSymbolIndex), Z = t1.evaluateSizeForFeature(o.textSizeData, d, G), W = s.get("text-padding"), Y = e1.collisionCircleDiameter;
                                            I = i.collisionIndex.placeCollisionCircles(v, G, o.lineVertexArray, o.glyphOffsetArray, Z, l, c, u, n, b, m.predicate, Y, W), T = v || I.circles.length > 0 && !I.collisionDetected, S = S && I.offscreen;
                                        }
                                        if (a.iconFeatureIndex && (D = a.iconFeatureIndex), a.iconBox) {
                                            var X = function(t1) {
                                                var e1 = w && E ? ke(t1, E.x, E.y, _, b, i.transform.angle) : t1;
                                                return i.collisionIndex.placeCollisionBox(e1, x, h, l, m.predicate);
                                            };
                                            M = L && L.box && L.box.length && a.verticalIconBox ? (P = X(a.verticalIconBox)).box.length > 0 : (P = X(a.iconBox)).box.length > 0, S = S && P.offscreen;
                                        }
                                        var $ = g || 0 === e1.numHorizontalGlyphVertices && 0 === e1.numVerticalGlyphVertices, J = y || 0 === e1.numIconVertices;
                                        if ($ || J ? J ? $ || (M = M && T) : T = M && T : M = T = M && T, T && p && p.box && (L && L.box && O ? i.collisionIndex.insertCollisionBox(p.box, s.get("text-ignore-placement"), o.bucketInstanceId, O, m.ID) : i.collisionIndex.insertCollisionBox(p.box, s.get("text-ignore-placement"), o.bucketInstanceId, z, m.ID)), M && P && i.collisionIndex.insertCollisionBox(P.box, s.get("icon-ignore-placement"), o.bucketInstanceId, D, m.ID), I && (T && i.collisionIndex.insertCollisionCircles(I.circles, s.get("text-ignore-placement"), o.bucketInstanceId, z, m.ID), n)) {
                                            var K = o.bucketInstanceId, Q = i.collisionCircleArrays[K];
                                            void 0 === Q && (Q = i.collisionCircleArrays[K] = new _e);
                                            for(var tt = 0; tt < I.circles.length; tt += 4)Q.circles.push(I.circles[tt + 0]), Q.circles.push(I.circles[tt + 1]), Q.circles.push(I.circles[tt + 2]), Q.circles.push(I.collisionDetected ? 1 : 0);
                                        }
                                        i.placements[e1.crossTileID] = new xe(T || k, M || A, S || o.justReloaded), r[e1.crossTileID] = !0;
                                    }
                                }
                            };
                            if (T) for(var S = o.getSortedSymbolIndexes(this.transform.angle), E = S.length - 1; E >= 0; --E){
                                var C = S[E];
                                M(o.symbolInstances.get(C), o.collisionArrays[C]);
                            }
                            else for(var L = e1.symbolInstanceStart; L < e1.symbolInstanceEnd; L++)M(o.symbolInstances.get(L), o.collisionArrays[L]);
                            if (n && o.bucketInstanceId in this.collisionCircleArrays) {
                                var I = this.collisionCircleArrays[o.bucketInstanceId];
                                t1.invert(I.invProjMatrix, l), I.viewportMatrix = this.collisionIndex.getViewportMatrix();
                            }
                            o.justReloaded = !1;
                        }, Ae.prototype.markUsedJustification = function(e1, r, n, i) {
                            var a, o = {
                                left: n.leftJustifiedTextSymbolIndex,
                                center: n.centerJustifiedTextSymbolIndex,
                                right: n.rightJustifiedTextSymbolIndex
                            };
                            a = i === t1.WritingMode.vertical ? n.verticalPlacedTextSymbolIndex : o[t1.getAnchorJustification(r)];
                            for(var s = 0, l = [
                                n.leftJustifiedTextSymbolIndex,
                                n.centerJustifiedTextSymbolIndex,
                                n.rightJustifiedTextSymbolIndex,
                                n.verticalPlacedTextSymbolIndex
                            ]; s < l.length; s += 1){
                                var c = l[s];
                                c >= 0 && (e1.text.placedSymbolArray.get(c).crossTileID = a >= 0 && c !== a ? 0 : n.crossTileID);
                            }
                        }, Ae.prototype.markUsedOrientation = function(e1, r, n) {
                            for(var i = r === t1.WritingMode.horizontal || r === t1.WritingMode.horizontalOnly ? r : 0, a = r === t1.WritingMode.vertical ? r : 0, o = 0, s = [
                                n.leftJustifiedTextSymbolIndex,
                                n.centerJustifiedTextSymbolIndex,
                                n.rightJustifiedTextSymbolIndex
                            ]; o < s.length; o += 1){
                                var l = s[o];
                                e1.text.placedSymbolArray.get(l).placedOrientation = i;
                            }
                            n.verticalPlacedTextSymbolIndex && (e1.text.placedSymbolArray.get(n.verticalPlacedTextSymbolIndex).placedOrientation = a);
                        }, Ae.prototype.commit = function(t1) {
                            this.commitTime = t1, this.zoomAtLastRecencyCheck = this.transform.zoom;
                            var e1 = this.prevPlacement, r = !1;
                            this.prevZoomAdjustment = e1 ? e1.zoomAdjustment(this.transform.zoom) : 0;
                            var n = e1 ? e1.symbolFadeChange(t1) : 1, i = e1 ? e1.opacities : {}, a = e1 ? e1.variableOffsets : {}, o = e1 ? e1.placedOrientations : {};
                            for(var s in this.placements){
                                var l = this.placements[s], c = i[s];
                                c ? (this.opacities[s] = new ve(c, n, l.text, l.icon), r = r || l.text !== c.text.placed || l.icon !== c.icon.placed) : (this.opacities[s] = new ve(null, n, l.text, l.icon, l.skipFade), r = r || l.text || l.icon);
                            }
                            for(var u in i){
                                var h = i[u];
                                if (!this.opacities[u]) {
                                    var f = new ve(h, n, !1, !1);
                                    f.isHidden() || (this.opacities[u] = f, r = r || h.text.placed || h.icon.placed);
                                }
                            }
                            for(var p in a)this.variableOffsets[p] || !this.opacities[p] || this.opacities[p].isHidden() || (this.variableOffsets[p] = a[p]);
                            for(var d in o)this.placedOrientations[d] || !this.opacities[d] || this.opacities[d].isHidden() || (this.placedOrientations[d] = o[d]);
                            r ? this.lastPlacementChangeTime = t1 : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = e1 ? e1.lastPlacementChangeTime : t1);
                        }, Ae.prototype.updateLayerOpacities = function(t1, e1) {
                            for(var r = {}, n = 0, i = e1; n < i.length; n += 1){
                                var a = i[n], o = a.getBucket(t1);
                                o && a.latestFeatureIndex && t1.id === o.layerIds[0] && this.updateBucketOpacities(o, r, a.collisionBoxArray);
                            }
                        }, Ae.prototype.updateBucketOpacities = function(e1, r, n) {
                            var i = this;
                            e1.hasTextData() && e1.text.opacityVertexArray.clear(), e1.hasIconData() && e1.icon.opacityVertexArray.clear(), e1.hasIconCollisionBoxData() && e1.iconCollisionBox.collisionVertexArray.clear(), e1.hasTextCollisionBoxData() && e1.textCollisionBox.collisionVertexArray.clear();
                            var a = e1.layers[0].layout, o = new ve(null, 0, !1, !1, !0), s = a.get("text-allow-overlap"), l = a.get("icon-allow-overlap"), c = a.get("text-variable-anchor"), u = "map" === a.get("text-rotation-alignment"), h = "map" === a.get("text-pitch-alignment"), f = "none" !== a.get("icon-text-fit"), p = new ve(null, 0, s && (l || !e1.hasIconData() || a.get("icon-optional")), l && (s || !e1.hasTextData() || a.get("text-optional")), !0);
                            !e1.collisionArrays && n && (e1.hasIconCollisionBoxData() || e1.hasTextCollisionBoxData()) && e1.deserializeCollisionBoxes(n);
                            for(var d = function(t1, e1, r) {
                                for(var n = 0; n < e1 / 4; n++)t1.opacityVertexArray.emplaceBack(r);
                            }, m = function(n) {
                                var a = e1.symbolInstances.get(n), s = a.numHorizontalGlyphVertices, l = a.numVerticalGlyphVertices, m = a.crossTileID, g = r[m], y = i.opacities[m];
                                g ? y = o : y || (y = p, i.opacities[m] = y), r[m] = !0;
                                var v = s > 0 || l > 0, x = a.numIconVertices > 0, _ = i.placedOrientations[a.crossTileID], b = _ === t1.WritingMode.vertical, w = _ === t1.WritingMode.horizontal || _ === t1.WritingMode.horizontalOnly;
                                if (v) {
                                    var T = Oe(y.text), k = b ? De : T;
                                    d(e1.text, s, k);
                                    var A = w ? De : T;
                                    d(e1.text, l, A);
                                    var M = y.text.isHidden();
                                    [
                                        a.rightJustifiedTextSymbolIndex,
                                        a.centerJustifiedTextSymbolIndex,
                                        a.leftJustifiedTextSymbolIndex
                                    ].forEach(function(t1) {
                                        t1 >= 0 && (e1.text.placedSymbolArray.get(t1).hidden = M || b ? 1 : 0);
                                    }), a.verticalPlacedTextSymbolIndex >= 0 && (e1.text.placedSymbolArray.get(a.verticalPlacedTextSymbolIndex).hidden = M || w ? 1 : 0);
                                    var S = i.variableOffsets[a.crossTileID];
                                    S && i.markUsedJustification(e1, S.anchor, a, _);
                                    var E = i.placedOrientations[a.crossTileID];
                                    E && (i.markUsedJustification(e1, "left", a, E), i.markUsedOrientation(e1, E, a));
                                }
                                if (x) {
                                    var C = Oe(y.icon), L = !(f && a.verticalPlacedIconSymbolIndex && b);
                                    if (a.placedIconSymbolIndex >= 0) {
                                        var I = L ? C : De;
                                        d(e1.icon, a.numIconVertices, I), e1.icon.placedSymbolArray.get(a.placedIconSymbolIndex).hidden = y.icon.isHidden();
                                    }
                                    if (a.verticalPlacedIconSymbolIndex >= 0) {
                                        var P = L ? De : C;
                                        d(e1.icon, a.numVerticalIconVertices, P), e1.icon.placedSymbolArray.get(a.verticalPlacedIconSymbolIndex).hidden = y.icon.isHidden();
                                    }
                                }
                                if (e1.hasIconCollisionBoxData() || e1.hasTextCollisionBoxData()) {
                                    var z = e1.collisionArrays[n];
                                    if (z) {
                                        var O = new t1.Point(0, 0);
                                        if (z.textBox || z.verticalTextBox) {
                                            var D = !0;
                                            if (c) {
                                                var R = i.variableOffsets[m];
                                                R ? (O = Te(R.anchor, R.width, R.height, R.textOffset, R.textBoxScale), u && O._rotate(h ? i.transform.angle : -i.transform.angle)) : D = !1;
                                            }
                                            z.textBox && Me(e1.textCollisionBox.collisionVertexArray, y.text.placed, !D || b, O.x, O.y), z.verticalTextBox && Me(e1.textCollisionBox.collisionVertexArray, y.text.placed, !D || w, O.x, O.y);
                                        }
                                        var F = Boolean(!w && z.verticalIconBox);
                                        z.iconBox && Me(e1.iconCollisionBox.collisionVertexArray, y.icon.placed, F, f ? O.x : 0, f ? O.y : 0), z.verticalIconBox && Me(e1.iconCollisionBox.collisionVertexArray, y.icon.placed, !F, f ? O.x : 0, f ? O.y : 0);
                                    }
                                }
                            }, g = 0; g < e1.symbolInstances.length; g++)m(g);
                            if (e1.sortFeatures(this.transform.angle), this.retainedQueryData[e1.bucketInstanceId] && (this.retainedQueryData[e1.bucketInstanceId].featureSortOrder = e1.featureSortOrder), e1.hasTextData() && e1.text.opacityVertexBuffer && e1.text.opacityVertexBuffer.updateData(e1.text.opacityVertexArray), e1.hasIconData() && e1.icon.opacityVertexBuffer && e1.icon.opacityVertexBuffer.updateData(e1.icon.opacityVertexArray), e1.hasIconCollisionBoxData() && e1.iconCollisionBox.collisionVertexBuffer && e1.iconCollisionBox.collisionVertexBuffer.updateData(e1.iconCollisionBox.collisionVertexArray), e1.hasTextCollisionBoxData() && e1.textCollisionBox.collisionVertexBuffer && e1.textCollisionBox.collisionVertexBuffer.updateData(e1.textCollisionBox.collisionVertexArray), e1.bucketInstanceId in this.collisionCircleArrays) {
                                var y = this.collisionCircleArrays[e1.bucketInstanceId];
                                e1.placementInvProjMatrix = y.invProjMatrix, e1.placementViewportMatrix = y.viewportMatrix, e1.collisionCircleArray = y.circles, delete this.collisionCircleArrays[e1.bucketInstanceId];
                            }
                        }, Ae.prototype.symbolFadeChange = function(t1) {
                            return 0 === this.fadeDuration ? 1 : (t1 - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
                        }, Ae.prototype.zoomAdjustment = function(t1) {
                            return Math.max(0, (this.transform.zoom - t1) / 1.5);
                        }, Ae.prototype.hasTransitions = function(t1) {
                            return this.stale || t1 - this.lastPlacementChangeTime < this.fadeDuration;
                        }, Ae.prototype.stillRecent = function(t1, e1) {
                            var r = this.zoomAtLastRecencyCheck === e1 ? 1 - this.zoomAdjustment(e1) : 1;
                            return this.zoomAtLastRecencyCheck = e1, this.commitTime + this.fadeDuration * r > t1;
                        }, Ae.prototype.setStale = function() {
                            this.stale = !0;
                        };
                        var Se = Math.pow(2, 25), Ee = Math.pow(2, 24), Ce = Math.pow(2, 17), Le = Math.pow(2, 16), Ie = Math.pow(2, 9), Pe = Math.pow(2, 8), ze = Math.pow(2, 1);
                        function Oe(t1) {
                            if (0 === t1.opacity && !t1.placed) return 0;
                            if (1 === t1.opacity && t1.placed) return 4294967295;
                            var e1 = t1.placed ? 1 : 0, r = Math.floor(127 * t1.opacity);
                            return r * Se + e1 * Ee + r * Ce + e1 * Le + r * Ie + e1 * Pe + r * ze + e1;
                        }
                        var De = 0, Re = function(t1) {
                            this._sortAcrossTiles = "viewport-y" !== t1.layout.get("symbol-z-order") && void 0 !== t1.layout.get("symbol-sort-key").constantOr(1), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = {}, this._bucketParts = [];
                        };
                        Re.prototype.continuePlacement = function(t1, e1, r, n, i) {
                            for(var a = this._bucketParts; this._currentTileIndex < t1.length;){
                                var o = t1[this._currentTileIndex];
                                if (e1.getBucketParts(a, n, o, this._sortAcrossTiles), this._currentTileIndex++, i()) return !0;
                            }
                            for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, a.sort(function(t1, e1) {
                                return t1.sortKey - e1.sortKey;
                            })); this._currentPartIndex < a.length;){
                                var s = a[this._currentPartIndex];
                                if (e1.placeLayerBucketPart(s, this._seenCrossTileIDs, r), this._currentPartIndex++, i()) return !0;
                            }
                            return !1;
                        };
                        var Fe = function(t1, e1, r, n, i, a, o) {
                            this.placement = new Ae(t1, i, a, o), this._currentPlacementIndex = e1.length - 1, this._forceFullPlacement = r, this._showCollisionBoxes = n, this._done = !1;
                        };
                        Fe.prototype.isDone = function() {
                            return this._done;
                        }, Fe.prototype.continuePlacement = function(e1, r, n) {
                            for(var i = this, a = t1.browser.now(), o = function() {
                                var e1 = t1.browser.now() - a;
                                return !i._forceFullPlacement && e1 > 2;
                            }; this._currentPlacementIndex >= 0;){
                                var s = r[e1[this._currentPlacementIndex]], l = this.placement.collisionIndex.transform.zoom;
                                if ("symbol" === s.type && (!s.minzoom || s.minzoom <= l) && (!s.maxzoom || s.maxzoom > l)) {
                                    if (this._inProgressLayer || (this._inProgressLayer = new Re(s)), this._inProgressLayer.continuePlacement(n[s.source], this.placement, this._showCollisionBoxes, s, o)) return;
                                    delete this._inProgressLayer;
                                }
                                this._currentPlacementIndex--;
                            }
                            this._done = !0;
                        }, Fe.prototype.commit = function(t1) {
                            return this.placement.commit(t1), this.placement;
                        };
                        var Be = 512 / t1.EXTENT / 2, Ne = function(t1, e1, r) {
                            this.tileID = t1, this.indexedSymbolInstances = {}, this.bucketInstanceId = r;
                            for(var n = 0; n < e1.length; n++){
                                var i = e1.get(n), a = i.key;
                                this.indexedSymbolInstances[a] || (this.indexedSymbolInstances[a] = []), this.indexedSymbolInstances[a].push({
                                    crossTileID: i.crossTileID,
                                    coord: this.getScaledCoordinates(i, t1)
                                });
                            }
                        };
                        Ne.prototype.getScaledCoordinates = function(e1, r) {
                            var n = r.canonical.z - this.tileID.canonical.z, i = Be / Math.pow(2, n);
                            return {
                                x: Math.floor((r.canonical.x * t1.EXTENT + e1.anchorX) * i),
                                y: Math.floor((r.canonical.y * t1.EXTENT + e1.anchorY) * i)
                            };
                        }, Ne.prototype.findMatches = function(t1, e1, r) {
                            for(var n = this.tileID.canonical.z < e1.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - e1.canonical.z), i = 0; i < t1.length; i++){
                                var a = t1.get(i);
                                if (!a.crossTileID) {
                                    var o = this.indexedSymbolInstances[a.key];
                                    if (o) for(var s = this.getScaledCoordinates(a, e1), l = 0, c = o; l < c.length; l += 1){
                                        var u = c[l];
                                        if (Math.abs(u.coord.x - s.x) <= n && Math.abs(u.coord.y - s.y) <= n && !r[u.crossTileID]) {
                                            r[u.crossTileID] = !0, a.crossTileID = u.crossTileID;
                                            break;
                                        }
                                    }
                                }
                            }
                        };
                        var je = function() {
                            this.maxCrossTileID = 0;
                        };
                        je.prototype.generate = function() {
                            return ++this.maxCrossTileID;
                        };
                        var Ue = function() {
                            this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
                        };
                        Ue.prototype.handleWrapJump = function(t1) {
                            var e1 = Math.round((t1 - this.lng) / 360);
                            if (0 !== e1) for(var r in this.indexes){
                                var n = this.indexes[r], i = {};
                                for(var a in n){
                                    var o = n[a];
                                    o.tileID = o.tileID.unwrapTo(o.tileID.wrap + e1), i[o.tileID.key] = o;
                                }
                                this.indexes[r] = i;
                            }
                            this.lng = t1;
                        }, Ue.prototype.addBucket = function(t1, e1, r) {
                            if (this.indexes[t1.overscaledZ] && this.indexes[t1.overscaledZ][t1.key]) {
                                if (this.indexes[t1.overscaledZ][t1.key].bucketInstanceId === e1.bucketInstanceId) return !1;
                                this.removeBucketCrossTileIDs(t1.overscaledZ, this.indexes[t1.overscaledZ][t1.key]);
                            }
                            for(var n = 0; n < e1.symbolInstances.length; n++)e1.symbolInstances.get(n).crossTileID = 0;
                            this.usedCrossTileIDs[t1.overscaledZ] || (this.usedCrossTileIDs[t1.overscaledZ] = {});
                            var i = this.usedCrossTileIDs[t1.overscaledZ];
                            for(var a in this.indexes){
                                var o = this.indexes[a];
                                if (Number(a) > t1.overscaledZ) for(var s in o){
                                    var l = o[s];
                                    l.tileID.isChildOf(t1) && l.findMatches(e1.symbolInstances, t1, i);
                                }
                                else {
                                    var c = o[t1.scaledTo(Number(a)).key];
                                    c && c.findMatches(e1.symbolInstances, t1, i);
                                }
                            }
                            for(var u = 0; u < e1.symbolInstances.length; u++){
                                var h = e1.symbolInstances.get(u);
                                h.crossTileID || (h.crossTileID = r.generate(), i[h.crossTileID] = !0);
                            }
                            return void 0 === this.indexes[t1.overscaledZ] && (this.indexes[t1.overscaledZ] = {}), this.indexes[t1.overscaledZ][t1.key] = new Ne(t1, e1.symbolInstances, e1.bucketInstanceId), !0;
                        }, Ue.prototype.removeBucketCrossTileIDs = function(t1, e1) {
                            for(var r in e1.indexedSymbolInstances)for(var n = 0, i = e1.indexedSymbolInstances[r]; n < i.length; n += 1){
                                var a = i[n];
                                delete this.usedCrossTileIDs[t1][a.crossTileID];
                            }
                        }, Ue.prototype.removeStaleBuckets = function(t1) {
                            var e1 = !1;
                            for(var r in this.indexes){
                                var n = this.indexes[r];
                                for(var i in n)t1[n[i].bucketInstanceId] || (this.removeBucketCrossTileIDs(r, n[i]), delete n[i], e1 = !0);
                            }
                            return e1;
                        };
                        var Ve = function() {
                            this.layerIndexes = {}, this.crossTileIDs = new je, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
                        };
                        Ve.prototype.addLayer = function(t1, e1, r) {
                            var n = this.layerIndexes[t1.id];
                            void 0 === n && (n = this.layerIndexes[t1.id] = new Ue);
                            var i = !1, a = {};
                            n.handleWrapJump(r);
                            for(var o = 0, s = e1; o < s.length; o += 1){
                                var l = s[o], c = l.getBucket(t1);
                                c && t1.id === c.layerIds[0] && (c.bucketInstanceId || (c.bucketInstanceId = ++this.maxBucketInstanceId), n.addBucket(l.tileID, c, this.crossTileIDs) && (i = !0), a[c.bucketInstanceId] = !0);
                            }
                            return n.removeStaleBuckets(a) && (i = !0), i;
                        }, Ve.prototype.pruneUnusedLayers = function(t1) {
                            var e1 = {};
                            for(var r in t1.forEach(function(t1) {
                                e1[t1] = !0;
                            }), this.layerIndexes)e1[r] || delete this.layerIndexes[r];
                        };
                        var qe = function(e1, r) {
                            return t1.emitValidationErrors(e1, r && r.filter(function(t1) {
                                return "source.canvas" !== t1.identifier;
                            }));
                        }, He = t1.pick(qt, [
                            "addLayer",
                            "removeLayer",
                            "setPaintProperty",
                            "setLayoutProperty",
                            "setFilter",
                            "addSource",
                            "removeSource",
                            "setLayerZoomRange",
                            "setLight",
                            "setTransition",
                            "setGeoJSONSourceData"
                        ]), Ge = t1.pick(qt, [
                            "setCenter",
                            "setZoom",
                            "setBearing",
                            "setPitch"
                        ]), Ze = function() {
                            var e1 = {}, r = t1.styleSpec.$version;
                            for(var n in t1.styleSpec.$root){
                                var i = t1.styleSpec.$root[n];
                                if (i.required) {
                                    var a;
                                    null != (a = "version" === n ? r : "array" === i.type ? [] : {}) && (e1[n] = a);
                                }
                            }
                            return e1;
                        }(), We = function(e1) {
                            function r(n, i) {
                                var a = this;
                                void 0 === i && (i = {}), e1.call(this), this.map = n, this.dispatcher = new A(jt(), this), this.imageManager = new f, this.imageManager.setEventedParent(this), this.glyphManager = new x(n._requestManager, i.localIdeographFontFamily), this.lineAtlas = new k(256, 512), this.crossTileSymbolIndex = new Ve, this._layers = {}, this._serializedLayers = {}, this._order = [], this.sourceCaches = {}, this.zoomHistory = new t1.ZoomHistory, this._loaded = !1, this._availableImages = [], this._resetUpdates(), this.dispatcher.broadcast("setReferrer", t1.getReferrer());
                                var o = this;
                                this._rtlTextPluginCallback = r.registerForPluginStateChange(function(e1) {
                                    var r = {
                                        pluginStatus: e1.pluginStatus,
                                        pluginURL: e1.pluginURL
                                    };
                                    o.dispatcher.broadcast("syncRTLPluginState", r, function(e1, r) {
                                        if (t1.triggerPluginCompletionEvent(e1), r && r.every(function(t1) {
                                            return t1;
                                        })) for(var n in o.sourceCaches)o.sourceCaches[n].reload();
                                    });
                                }), this.on("data", function(t1) {
                                    if ("source" === t1.dataType && "metadata" === t1.sourceDataType) {
                                        var e1 = a.sourceCaches[t1.sourceId];
                                        if (e1) {
                                            var r = e1.getSource();
                                            if (r && r.vectorLayerIds) for(var n in a._layers){
                                                var i = a._layers[n];
                                                i.source === r.id && a._validateLayer(i);
                                            }
                                        }
                                    }
                                });
                            }
                            return e1 && (r.__proto__ = e1), r.prototype = Object.create(e1 && e1.prototype), r.prototype.constructor = r, r.prototype.loadURL = function(e1, r) {
                                var n = this;
                                void 0 === r && (r = {}), this.fire(new t1.Event("dataloading", {
                                    dataType: "style"
                                }));
                                var i = "boolean" == typeof r.validate ? r.validate : !t1.isMapboxURL(e1);
                                e1 = this.map._requestManager.normalizeStyleURL(e1, r.accessToken);
                                var a = this.map._requestManager.transformRequest(e1, t1.ResourceType.Style);
                                this._request = t1.getJSON(a, function(e1, r) {
                                    n._request = null, e1 ? n.fire(new t1.ErrorEvent(e1)) : r && n._load(r, i);
                                });
                            }, r.prototype.loadJSON = function(e1, r) {
                                var n = this;
                                void 0 === r && (r = {}), this.fire(new t1.Event("dataloading", {
                                    dataType: "style"
                                })), this._request = t1.browser.frame(function() {
                                    n._request = null, n._load(e1, !1 !== r.validate);
                                });
                            }, r.prototype.loadEmpty = function() {
                                this.fire(new t1.Event("dataloading", {
                                    dataType: "style"
                                })), this._load(Ze, !1);
                            }, r.prototype._load = function(e1, r) {
                                if (!r || !qe(this, t1.validateStyle(e1))) {
                                    for(var n in this._loaded = !0, this.stylesheet = e1, e1.sources)this.addSource(n, e1.sources[n], {
                                        validate: !1
                                    });
                                    e1.sprite ? this._loadSprite(e1.sprite) : this.imageManager.setLoaded(!0), this.glyphManager.setURL(e1.glyphs);
                                    var i = Vt(this.stylesheet.layers);
                                    this._order = i.map(function(t1) {
                                        return t1.id;
                                    }), this._layers = {}, this._serializedLayers = {};
                                    for(var a = 0, o = i; a < o.length; a += 1){
                                        var s = o[a];
                                        (s = t1.createStyleLayer(s)).setEventedParent(this, {
                                            layer: {
                                                id: s.id
                                            }
                                        }), this._layers[s.id] = s, this._serializedLayers[s.id] = s.serialize();
                                    }
                                    this.dispatcher.broadcast("setLayers", this._serializeLayers(this._order)), this.light = new T(this.stylesheet.light), this.fire(new t1.Event("data", {
                                        dataType: "style"
                                    })), this.fire(new t1.Event("style.load"));
                                }
                            }, r.prototype._loadSprite = function(e1) {
                                var r = this;
                                this._spriteRequest = function(e1, r, n) {
                                    var i, a, o, s = t1.browser.devicePixelRatio > 1 ? "@2x" : "", l = t1.getJSON(r.transformRequest(r.normalizeSpriteURL(e1, s, ".json"), t1.ResourceType.SpriteJSON), function(t1, e1) {
                                        l = null, o || (o = t1, i = e1, u());
                                    }), c = t1.getImage(r.transformRequest(r.normalizeSpriteURL(e1, s, ".png"), t1.ResourceType.SpriteImage), function(t1, e1) {
                                        c = null, o || (o = t1, a = e1, u());
                                    });
                                    function u() {
                                        if (o) n(o);
                                        else if (i && a) {
                                            var e1 = t1.browser.getImageData(a), r = {};
                                            for(var s in i){
                                                var l = i[s], c = l.width, u = l.height, h = l.x, f = l.y, p = l.sdf, d = l.pixelRatio, m = l.stretchX, g = l.stretchY, y = l.content, v = new t1.RGBAImage({
                                                    width: c,
                                                    height: u
                                                });
                                                t1.RGBAImage.copy(e1, v, {
                                                    x: h,
                                                    y: f
                                                }, {
                                                    x: 0,
                                                    y: 0
                                                }, {
                                                    width: c,
                                                    height: u
                                                }), r[s] = {
                                                    data: v,
                                                    pixelRatio: d,
                                                    sdf: p,
                                                    stretchX: m,
                                                    stretchY: g,
                                                    content: y
                                                };
                                            }
                                            n(null, r);
                                        }
                                    }
                                    return {
                                        cancel: function() {
                                            l && (l.cancel(), l = null), c && (c.cancel(), c = null);
                                        }
                                    };
                                }(e1, this.map._requestManager, function(e1, n) {
                                    if (r._spriteRequest = null, e1) r.fire(new t1.ErrorEvent(e1));
                                    else if (n) for(var i in n)r.imageManager.addImage(i, n[i]);
                                    r.imageManager.setLoaded(!0), r._availableImages = r.imageManager.listImages(), r.dispatcher.broadcast("setImages", r._availableImages), r.fire(new t1.Event("data", {
                                        dataType: "style"
                                    }));
                                });
                            }, r.prototype._validateLayer = function(e1) {
                                var r = this.sourceCaches[e1.source];
                                if (r) {
                                    var n = e1.sourceLayer;
                                    if (n) {
                                        var i = r.getSource();
                                        ("geojson" === i.type || i.vectorLayerIds && -1 === i.vectorLayerIds.indexOf(n)) && this.fire(new t1.ErrorEvent(new Error('Source layer "' + n + '" does not exist on source "' + i.id + '" as specified by style layer "' + e1.id + '"')));
                                    }
                                }
                            }, r.prototype.loaded = function() {
                                if (!this._loaded) return !1;
                                if (Object.keys(this._updatedSources).length) return !1;
                                for(var t1 in this.sourceCaches)if (!this.sourceCaches[t1].loaded()) return !1;
                                return !!this.imageManager.isLoaded();
                            }, r.prototype._serializeLayers = function(t1) {
                                for(var e1 = [], r = 0, n = t1; r < n.length; r += 1){
                                    var i = n[r], a = this._layers[i];
                                    "custom" !== a.type && e1.push(a.serialize());
                                }
                                return e1;
                            }, r.prototype.hasTransitions = function() {
                                if (this.light && this.light.hasTransition()) return !0;
                                for(var t1 in this.sourceCaches)if (this.sourceCaches[t1].hasTransition()) return !0;
                                for(var e1 in this._layers)if (this._layers[e1].hasTransition()) return !0;
                                return !1;
                            }, r.prototype._checkLoaded = function() {
                                if (!this._loaded) throw new Error("Style is not done loading");
                            }, r.prototype.update = function(e1) {
                                if (this._loaded) {
                                    var r = this._changed;
                                    if (this._changed) {
                                        var n = Object.keys(this._updatedLayers), i = Object.keys(this._removedLayers);
                                        for(var a in (n.length || i.length) && this._updateWorkerLayers(n, i), this._updatedSources){
                                            var o = this._updatedSources[a];
                                            "reload" === o ? this._reloadSource(a) : "clear" === o && this._clearSource(a);
                                        }
                                        for(var s in this._updateTilesForChangedImages(), this._updatedPaintProps)this._layers[s].updateTransitions(e1);
                                        this.light.updateTransitions(e1), this._resetUpdates();
                                    }
                                    var l = {};
                                    for(var c in this.sourceCaches){
                                        var u = this.sourceCaches[c];
                                        l[c] = u.used, u.used = !1;
                                    }
                                    for(var h = 0, f = this._order; h < f.length; h += 1){
                                        var p = f[h], d = this._layers[p];
                                        d.recalculate(e1, this._availableImages), !d.isHidden(e1.zoom) && d.source && (this.sourceCaches[d.source].used = !0);
                                    }
                                    for(var m in l){
                                        var g = this.sourceCaches[m];
                                        l[m] !== g.used && g.fire(new t1.Event("data", {
                                            sourceDataType: "visibility",
                                            dataType: "source",
                                            sourceId: m
                                        }));
                                    }
                                    this.light.recalculate(e1), this.z = e1.zoom, r && this.fire(new t1.Event("data", {
                                        dataType: "style"
                                    }));
                                }
                            }, r.prototype._updateTilesForChangedImages = function() {
                                var t1 = Object.keys(this._changedImages);
                                if (t1.length) {
                                    for(var e1 in this.sourceCaches)this.sourceCaches[e1].reloadTilesForDependencies([
                                        "icons",
                                        "patterns"
                                    ], t1);
                                    this._changedImages = {};
                                }
                            }, r.prototype._updateWorkerLayers = function(t1, e1) {
                                this.dispatcher.broadcast("updateLayers", {
                                    layers: this._serializeLayers(t1),
                                    removedIds: e1
                                });
                            }, r.prototype._resetUpdates = function() {
                                this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSources = {}, this._updatedPaintProps = {}, this._changedImages = {};
                            }, r.prototype.setState = function(e1) {
                                var r = this;
                                if (this._checkLoaded(), qe(this, t1.validateStyle(e1))) return !1;
                                (e1 = t1.clone$1(e1)).layers = Vt(e1.layers);
                                var n = Jt(this.serialize(), e1).filter(function(t1) {
                                    return !(t1.command in Ge);
                                });
                                if (0 === n.length) return !1;
                                var i = n.filter(function(t1) {
                                    return !(t1.command in He);
                                });
                                if (i.length > 0) throw new Error("Unimplemented: " + i.map(function(t1) {
                                    return t1.command;
                                }).join(", ") + ".");
                                return n.forEach(function(t1) {
                                    "setTransition" !== t1.command && r[t1.command].apply(r, t1.args);
                                }), this.stylesheet = e1, !0;
                            }, r.prototype.addImage = function(e1, r) {
                                if (this.getImage(e1)) return this.fire(new t1.ErrorEvent(new Error("An image with this name already exists.")));
                                this.imageManager.addImage(e1, r), this._afterImageUpdated(e1);
                            }, r.prototype.updateImage = function(t1, e1) {
                                this.imageManager.updateImage(t1, e1);
                            }, r.prototype.getImage = function(t1) {
                                return this.imageManager.getImage(t1);
                            }, r.prototype.removeImage = function(e1) {
                                if (!this.getImage(e1)) return this.fire(new t1.ErrorEvent(new Error("No image with this name exists.")));
                                this.imageManager.removeImage(e1), this._afterImageUpdated(e1);
                            }, r.prototype._afterImageUpdated = function(e1) {
                                this._availableImages = this.imageManager.listImages(), this._changedImages[e1] = !0, this._changed = !0, this.dispatcher.broadcast("setImages", this._availableImages), this.fire(new t1.Event("data", {
                                    dataType: "style"
                                }));
                            }, r.prototype.listImages = function() {
                                return this._checkLoaded(), this.imageManager.listImages();
                            }, r.prototype.addSource = function(e1, r, n) {
                                var i = this;
                                if (void 0 === n && (n = {}), this._checkLoaded(), void 0 !== this.sourceCaches[e1]) throw new Error("There is already a source with this ID");
                                if (!r.type) throw new Error("The type property must be defined, but only the following properties were given: " + Object.keys(r).join(", ") + ".");
                                if (!([
                                    "vector",
                                    "raster",
                                    "geojson",
                                    "video",
                                    "image"
                                ].indexOf(r.type) >= 0 && this._validate(t1.validateStyle.source, "sources." + e1, r, null, n))) {
                                    this.map && this.map._collectResourceTiming && (r.collectResourceTiming = !0);
                                    var a = this.sourceCaches[e1] = new Pt(e1, r, this.dispatcher);
                                    a.style = this, a.setEventedParent(this, function() {
                                        return {
                                            isSourceLoaded: i.loaded(),
                                            source: a.serialize(),
                                            sourceId: e1
                                        };
                                    }), a.onAdd(this.map), this._changed = !0;
                                }
                            }, r.prototype.removeSource = function(e1) {
                                if (this._checkLoaded(), void 0 === this.sourceCaches[e1]) throw new Error("There is no source with this ID");
                                for(var r in this._layers)if (this._layers[r].source === e1) return this.fire(new t1.ErrorEvent(new Error('Source "' + e1 + '" cannot be removed while layer "' + r + '" is using it.')));
                                var n = this.sourceCaches[e1];
                                delete this.sourceCaches[e1], delete this._updatedSources[e1], n.fire(new t1.Event("data", {
                                    sourceDataType: "metadata",
                                    dataType: "source",
                                    sourceId: e1
                                })), n.setEventedParent(null), n.clearTiles(), n.onRemove && n.onRemove(this.map), this._changed = !0;
                            }, r.prototype.setGeoJSONSourceData = function(t1, e1) {
                                this._checkLoaded(), this.sourceCaches[t1].getSource().setData(e1), this._changed = !0;
                            }, r.prototype.getSource = function(t1) {
                                return this.sourceCaches[t1] && this.sourceCaches[t1].getSource();
                            }, r.prototype.addLayer = function(e1, r, n) {
                                void 0 === n && (n = {}), this._checkLoaded();
                                var i = e1.id;
                                if (this.getLayer(i)) this.fire(new t1.ErrorEvent(new Error('Layer with id "' + i + '" already exists on this map')));
                                else {
                                    var a;
                                    if ("custom" === e1.type) {
                                        if (qe(this, t1.validateCustomStyleLayer(e1))) return;
                                        a = t1.createStyleLayer(e1);
                                    } else {
                                        if ("object" == typeof e1.source && (this.addSource(i, e1.source), e1 = t1.clone$1(e1), e1 = t1.extend(e1, {
                                            source: i
                                        })), this._validate(t1.validateStyle.layer, "layers." + i, e1, {
                                            arrayIndex: -1
                                        }, n)) return;
                                        a = t1.createStyleLayer(e1), this._validateLayer(a), a.setEventedParent(this, {
                                            layer: {
                                                id: i
                                            }
                                        }), this._serializedLayers[a.id] = a.serialize();
                                    }
                                    var o = r ? this._order.indexOf(r) : this._order.length;
                                    if (r && -1 === o) this.fire(new t1.ErrorEvent(new Error('Layer with id "' + r + '" does not exist on this map.')));
                                    else {
                                        if (this._order.splice(o, 0, i), this._layerOrderChanged = !0, this._layers[i] = a, this._removedLayers[i] && a.source && "custom" !== a.type) {
                                            var s = this._removedLayers[i];
                                            delete this._removedLayers[i], s.type !== a.type ? this._updatedSources[a.source] = "clear" : (this._updatedSources[a.source] = "reload", this.sourceCaches[a.source].pause());
                                        }
                                        this._updateLayer(a), a.onAdd && a.onAdd(this.map);
                                    }
                                }
                            }, r.prototype.moveLayer = function(e1, r) {
                                if (this._checkLoaded(), this._changed = !0, this._layers[e1]) {
                                    if (e1 !== r) {
                                        var n = this._order.indexOf(e1);
                                        this._order.splice(n, 1);
                                        var i = r ? this._order.indexOf(r) : this._order.length;
                                        r && -1 === i ? this.fire(new t1.ErrorEvent(new Error('Layer with id "' + r + '" does not exist on this map.'))) : (this._order.splice(i, 0, e1), this._layerOrderChanged = !0);
                                    }
                                } else this.fire(new t1.ErrorEvent(new Error("The layer '" + e1 + "' does not exist in the map's style and cannot be moved.")));
                            }, r.prototype.removeLayer = function(e1) {
                                this._checkLoaded();
                                var r = this._layers[e1];
                                if (r) {
                                    r.setEventedParent(null);
                                    var n = this._order.indexOf(e1);
                                    this._order.splice(n, 1), this._layerOrderChanged = !0, this._changed = !0, this._removedLayers[e1] = r, delete this._layers[e1], delete this._serializedLayers[e1], delete this._updatedLayers[e1], delete this._updatedPaintProps[e1], r.onRemove && r.onRemove(this.map);
                                } else this.fire(new t1.ErrorEvent(new Error("The layer '" + e1 + "' does not exist in the map's style and cannot be removed.")));
                            }, r.prototype.getLayer = function(t1) {
                                return this._layers[t1];
                            }, r.prototype.hasLayer = function(t1) {
                                return t1 in this._layers;
                            }, r.prototype.setLayerZoomRange = function(e1, r, n) {
                                this._checkLoaded();
                                var i = this.getLayer(e1);
                                i ? i.minzoom === r && i.maxzoom === n || (null != r && (i.minzoom = r), null != n && (i.maxzoom = n), this._updateLayer(i)) : this.fire(new t1.ErrorEvent(new Error("The layer '" + e1 + "' does not exist in the map's style and cannot have zoom extent.")));
                            }, r.prototype.setFilter = function(e1, r, n) {
                                void 0 === n && (n = {}), this._checkLoaded();
                                var i = this.getLayer(e1);
                                if (i) {
                                    if (!t1.deepEqual(i.filter, r)) return null == r ? (i.filter = void 0, void this._updateLayer(i)) : void (this._validate(t1.validateStyle.filter, "layers." + i.id + ".filter", r, null, n) || (i.filter = t1.clone$1(r), this._updateLayer(i)));
                                } else this.fire(new t1.ErrorEvent(new Error("The layer '" + e1 + "' does not exist in the map's style and cannot be filtered.")));
                            }, r.prototype.getFilter = function(e1) {
                                return t1.clone$1(this.getLayer(e1).filter);
                            }, r.prototype.setLayoutProperty = function(e1, r, n, i) {
                                void 0 === i && (i = {}), this._checkLoaded();
                                var a = this.getLayer(e1);
                                a ? t1.deepEqual(a.getLayoutProperty(r), n) || (a.setLayoutProperty(r, n, i), this._updateLayer(a)) : this.fire(new t1.ErrorEvent(new Error("The layer '" + e1 + "' does not exist in the map's style and cannot be styled.")));
                            }, r.prototype.getLayoutProperty = function(e1, r) {
                                var n = this.getLayer(e1);
                                if (n) return n.getLayoutProperty(r);
                                this.fire(new t1.ErrorEvent(new Error("The layer '" + e1 + "' does not exist in the map's style.")));
                            }, r.prototype.setPaintProperty = function(e1, r, n, i) {
                                void 0 === i && (i = {}), this._checkLoaded();
                                var a = this.getLayer(e1);
                                a ? t1.deepEqual(a.getPaintProperty(r), n) || (a.setPaintProperty(r, n, i) && this._updateLayer(a), this._changed = !0, this._updatedPaintProps[e1] = !0) : this.fire(new t1.ErrorEvent(new Error("The layer '" + e1 + "' does not exist in the map's style and cannot be styled.")));
                            }, r.prototype.getPaintProperty = function(t1, e1) {
                                return this.getLayer(t1).getPaintProperty(e1);
                            }, r.prototype.setFeatureState = function(e1, r) {
                                this._checkLoaded();
                                var n = e1.source, i = e1.sourceLayer, a = this.sourceCaches[n];
                                if (void 0 !== a) {
                                    var o = a.getSource().type;
                                    "geojson" === o && i ? this.fire(new t1.ErrorEvent(new Error("GeoJSON sources cannot have a sourceLayer parameter."))) : "vector" !== o || i ? (void 0 === e1.id && this.fire(new t1.ErrorEvent(new Error("The feature id parameter must be provided."))), a.setFeatureState(i, e1.id, r)) : this.fire(new t1.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
                                } else this.fire(new t1.ErrorEvent(new Error("The source '" + n + "' does not exist in the map's style.")));
                            }, r.prototype.removeFeatureState = function(e1, r) {
                                this._checkLoaded();
                                var n = e1.source, i = this.sourceCaches[n];
                                if (void 0 !== i) {
                                    var a = i.getSource().type, o = "vector" === a ? e1.sourceLayer : void 0;
                                    "vector" !== a || o ? r && "string" != typeof e1.id && "number" != typeof e1.id ? this.fire(new t1.ErrorEvent(new Error("A feature id is required to remove its specific state property."))) : i.removeFeatureState(o, e1.id, r) : this.fire(new t1.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
                                } else this.fire(new t1.ErrorEvent(new Error("The source '" + n + "' does not exist in the map's style.")));
                            }, r.prototype.getFeatureState = function(e1) {
                                this._checkLoaded();
                                var r = e1.source, n = e1.sourceLayer, i = this.sourceCaches[r];
                                if (void 0 !== i) {
                                    if ("vector" !== i.getSource().type || n) return void 0 === e1.id && this.fire(new t1.ErrorEvent(new Error("The feature id parameter must be provided."))), i.getFeatureState(n, e1.id);
                                    this.fire(new t1.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
                                } else this.fire(new t1.ErrorEvent(new Error("The source '" + r + "' does not exist in the map's style.")));
                            }, r.prototype.getTransition = function() {
                                return t1.extend({
                                    duration: 300,
                                    delay: 0
                                }, this.stylesheet && this.stylesheet.transition);
                            }, r.prototype.serialize = function() {
                                return t1.filterObject({
                                    version: this.stylesheet.version,
                                    name: this.stylesheet.name,
                                    metadata: this.stylesheet.metadata,
                                    light: this.stylesheet.light,
                                    center: this.stylesheet.center,
                                    zoom: this.stylesheet.zoom,
                                    bearing: this.stylesheet.bearing,
                                    pitch: this.stylesheet.pitch,
                                    sprite: this.stylesheet.sprite,
                                    glyphs: this.stylesheet.glyphs,
                                    transition: this.stylesheet.transition,
                                    sources: t1.mapObject(this.sourceCaches, function(t1) {
                                        return t1.serialize();
                                    }),
                                    layers: this._serializeLayers(this._order)
                                }, function(t1) {
                                    return void 0 !== t1;
                                });
                            }, r.prototype._updateLayer = function(t1) {
                                this._updatedLayers[t1.id] = !0, t1.source && !this._updatedSources[t1.source] && "raster" !== this.sourceCaches[t1.source].getSource().type && (this._updatedSources[t1.source] = "reload", this.sourceCaches[t1.source].pause()), this._changed = !0;
                            }, r.prototype._flattenAndSortRenderedFeatures = function(t1) {
                                for(var e1 = this, r = function(t1) {
                                    return "fill-extrusion" === e1._layers[t1].type;
                                }, n = {}, i = [], a = this._order.length - 1; a >= 0; a--){
                                    var o = this._order[a];
                                    if (r(o)) {
                                        n[o] = a;
                                        for(var s = 0, l = t1; s < l.length; s += 1){
                                            var c = l[s][o];
                                            if (c) for(var u = 0, h = c; u < h.length; u += 1){
                                                var f = h[u];
                                                i.push(f);
                                            }
                                        }
                                    }
                                }
                                i.sort(function(t1, e1) {
                                    return e1.intersectionZ - t1.intersectionZ;
                                });
                                for(var p = [], d = this._order.length - 1; d >= 0; d--){
                                    var m = this._order[d];
                                    if (r(m)) for(var g = i.length - 1; g >= 0; g--){
                                        var y = i[g].feature;
                                        if (n[y.layer.id] < d) break;
                                        p.push(y), i.pop();
                                    }
                                    else for(var v = 0, x = t1; v < x.length; v += 1){
                                        var _ = x[v][m];
                                        if (_) for(var b = 0, w = _; b < w.length; b += 1){
                                            var T = w[b];
                                            p.push(T.feature);
                                        }
                                    }
                                }
                                return p;
                            }, r.prototype.queryRenderedFeatures = function(e1, r, n) {
                                r && r.filter && this._validate(t1.validateStyle.filter, "queryRenderedFeatures.filter", r.filter, null, r);
                                var i = {};
                                if (r && r.layers) {
                                    if (!Array.isArray(r.layers)) return this.fire(new t1.ErrorEvent(new Error("parameters.layers must be an Array."))), [];
                                    for(var a = 0, o = r.layers; a < o.length; a += 1){
                                        var s = o[a], l = this._layers[s];
                                        if (!l) return this.fire(new t1.ErrorEvent(new Error("The layer '" + s + "' does not exist in the map's style and cannot be queried for features."))), [];
                                        i[l.source] = !0;
                                    }
                                }
                                var c = [];
                                for(var u in r.availableImages = this._availableImages, this.sourceCaches)r.layers && !i[u] || c.push(B(this.sourceCaches[u], this._layers, this._serializedLayers, e1, r, n));
                                return this.placement && c.push(function(t1, e1, r, n, i, a, o) {
                                    for(var s = {}, l = a.queryRenderedSymbols(n), c = [], u = 0, h = Object.keys(l).map(Number); u < h.length; u += 1){
                                        var f = h[u];
                                        c.push(o[f]);
                                    }
                                    c.sort(N);
                                    for(var p = function() {
                                        var r = m[d], n = r.featureIndex.lookupSymbolFeatures(l[r.bucketInstanceId], e1, r.bucketIndex, r.sourceLayerIndex, i.filter, i.layers, i.availableImages, t1);
                                        for(var a in n){
                                            var o = s[a] = s[a] || [], c = n[a];
                                            c.sort(function(t1, e1) {
                                                var n = r.featureSortOrder;
                                                if (n) {
                                                    var i = n.indexOf(t1.featureIndex);
                                                    return n.indexOf(e1.featureIndex) - i;
                                                }
                                                return e1.featureIndex - t1.featureIndex;
                                            });
                                            for(var u = 0, h = c; u < h.length; u += 1){
                                                var f = h[u];
                                                o.push(f);
                                            }
                                        }
                                    }, d = 0, m = c; d < m.length; d += 1)p();
                                    var g = function(e1) {
                                        s[e1].forEach(function(n) {
                                            var i = n.feature, a = t1[e1], o = r[a.source].getFeatureState(i.layer["source-layer"], i.id);
                                            i.source = i.layer.source, i.layer["source-layer"] && (i.sourceLayer = i.layer["source-layer"]), i.state = o;
                                        });
                                    };
                                    for(var y in s)g(y);
                                    return s;
                                }(this._layers, this._serializedLayers, this.sourceCaches, e1, r, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(c);
                            }, r.prototype.querySourceFeatures = function(e1, r) {
                                r && r.filter && this._validate(t1.validateStyle.filter, "querySourceFeatures.filter", r.filter, null, r);
                                var n = this.sourceCaches[e1];
                                return n ? function(t1, e1) {
                                    for(var r = t1.getRenderableIds().map(function(e1) {
                                        return t1.getTileByID(e1);
                                    }), n = [], i = {}, a = 0; a < r.length; a++){
                                        var o = r[a], s = o.tileID.canonical.key;
                                        i[s] || (i[s] = !0, o.querySourceFeatures(n, e1));
                                    }
                                    return n;
                                }(n, r) : [];
                            }, r.prototype.addSourceType = function(t1, e1, n) {
                                return r.getSourceType(t1) ? n(new Error('A source type called "' + t1 + '" already exists.')) : (r.setSourceType(t1, e1), e1.workerSourceURL ? void this.dispatcher.broadcast("loadWorkerSource", {
                                    name: t1,
                                    url: e1.workerSourceURL
                                }, n) : n(null, null));
                            }, r.prototype.getLight = function() {
                                return this.light.getLight();
                            }, r.prototype.setLight = function(e1, r) {
                                void 0 === r && (r = {}), this._checkLoaded();
                                var n = this.light.getLight(), i = !1;
                                for(var a in e1)if (!t1.deepEqual(e1[a], n[a])) {
                                    i = !0;
                                    break;
                                }
                                if (i) {
                                    var o = {
                                        now: t1.browser.now(),
                                        transition: t1.extend({
                                            duration: 300,
                                            delay: 0
                                        }, this.stylesheet.transition)
                                    };
                                    this.light.setLight(e1, r), this.light.updateTransitions(o);
                                }
                            }, r.prototype._validate = function(e1, r, n, i, a) {
                                return void 0 === a && (a = {}), (!a || !1 !== a.validate) && qe(this, e1.call(t1.validateStyle, t1.extend({
                                    key: r,
                                    style: this.serialize(),
                                    value: n,
                                    styleSpec: t1.styleSpec
                                }, i)));
                            }, r.prototype._remove = function() {
                                for(var e1 in this._request && (this._request.cancel(), this._request = null), this._spriteRequest && (this._spriteRequest.cancel(), this._spriteRequest = null), t1.evented.off("pluginStateChange", this._rtlTextPluginCallback), this._layers)this._layers[e1].setEventedParent(null);
                                for(var r in this.sourceCaches)this.sourceCaches[r].clearTiles(), this.sourceCaches[r].setEventedParent(null);
                                this.imageManager.setEventedParent(null), this.setEventedParent(null), this.dispatcher.remove();
                            }, r.prototype._clearSource = function(t1) {
                                this.sourceCaches[t1].clearTiles();
                            }, r.prototype._reloadSource = function(t1) {
                                this.sourceCaches[t1].resume(), this.sourceCaches[t1].reload();
                            }, r.prototype._updateSources = function(t1) {
                                for(var e1 in this.sourceCaches)this.sourceCaches[e1].update(t1);
                            }, r.prototype._generateCollisionBoxes = function() {
                                for(var t1 in this.sourceCaches)this._reloadSource(t1);
                            }, r.prototype._updatePlacement = function(e1, r, n, i, a) {
                                void 0 === a && (a = !1);
                                for(var o = !1, s = !1, l = {}, c = 0, u = this._order; c < u.length; c += 1){
                                    var h = u[c], f = this._layers[h];
                                    if ("symbol" === f.type) {
                                        if (!l[f.source]) {
                                            var p = this.sourceCaches[f.source];
                                            l[f.source] = p.getRenderableIds(!0).map(function(t1) {
                                                return p.getTileByID(t1);
                                            }).sort(function(t1, e1) {
                                                return e1.tileID.overscaledZ - t1.tileID.overscaledZ || (t1.tileID.isLessThan(e1.tileID) ? -1 : 1);
                                            });
                                        }
                                        var d = this.crossTileSymbolIndex.addLayer(f, l[f.source], e1.center.lng);
                                        o = o || d;
                                    }
                                }
                                if (this.crossTileSymbolIndex.pruneUnusedLayers(this._order), ((a = a || this._layerOrderChanged || 0 === n) || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(t1.browser.now(), e1.zoom)) && (this.pauseablePlacement = new Fe(e1, this._order, a, r, n, i, this.placement), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._order, this._layers, l), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(t1.browser.now()), s = !0), o && this.pauseablePlacement.placement.setStale()), s || o) for(var m = 0, g = this._order; m < g.length; m += 1){
                                    var y = g[m], v = this._layers[y];
                                    "symbol" === v.type && this.placement.updateLayerOpacities(v, l[v.source]);
                                }
                                return !this.pauseablePlacement.isDone() || this.placement.hasTransitions(t1.browser.now());
                            }, r.prototype._releaseSymbolFadeTiles = function() {
                                for(var t1 in this.sourceCaches)this.sourceCaches[t1].releaseSymbolFadeTiles();
                            }, r.prototype.getImages = function(t1, e1, r) {
                                this.imageManager.getImages(e1.icons, r), this._updateTilesForChangedImages();
                                var n = this.sourceCaches[e1.source];
                                n && n.setDependencies(e1.tileID.key, e1.type, e1.icons);
                            }, r.prototype.getGlyphs = function(t1, e1, r) {
                                this.glyphManager.getGlyphs(e1.stacks, r);
                            }, r.prototype.getResource = function(e1, r, n) {
                                return t1.makeRequest(r, n);
                            }, r;
                        }(t1.Evented);
                        We.getSourceType = function(t1) {
                            return R[t1];
                        }, We.setSourceType = function(t1, e1) {
                            R[t1] = e1;
                        }, We.registerForPluginStateChange = t1.registerForPluginStateChange;
                        var Ye = t1.createLayout([
                            {
                                name: "a_pos",
                                type: "Int16",
                                components: 2
                            }
                        ]), Xe = br("#ifdef GL_ES\nprecision mediump float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif", "#ifdef GL_ES\nprecision highp float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}"), $e = br("uniform vec4 u_color;uniform float u_opacity;void main() {gl_FragColor=u_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"), Je = br("uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_mix)*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}"), Ke = br("varying vec3 v_data;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);lowp float antialiasblur=v_data.z;float antialiased_blur=-max(blur,antialiasblur);float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));gl_FragColor=opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;attribute vec2 a_pos;varying vec3 v_data;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);if (u_pitch_with_map) {vec2 corner_position=circle_center;if (u_scale_with_map) {corner_position+=extrude*(radius+stroke_width)*u_extrude_scale;} else {vec4 projected_center=u_matrix*vec4(circle_center,0,1);corner_position+=extrude*(radius+stroke_width)*u_extrude_scale*(projected_center.w/u_camera_to_center_distance);}gl_Position=u_matrix*vec4(corner_position,0,1);} else {gl_Position=u_matrix*vec4(circle_center,0,1);if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);}"), Qe = br("void main() {gl_FragColor=vec4(1.0);}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"), tr = br("uniform highp float u_intensity;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);gl_FragColor=vec4(val,1.0,1.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;attribute vec2 a_pos;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec4 pos=vec4(floor(a_pos*0.5)+extrude,0,1);gl_Position=u_matrix*pos;}"), er = br("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;varying vec2 v_pos;void main() {float t=texture2D(u_image,v_pos).r;vec4 color=texture2D(u_color_ramp,vec2(t,0.5));gl_FragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(0.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}"), rr = br("varying float v_placed;varying float v_notUsed;void main() {float alpha=0.5;gl_FragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {gl_FragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {gl_FragColor*=.1;}}", "attribute vec2 a_pos;attribute vec2 a_anchor_pos;attribute vec2 a_extrude;attribute vec2 a_placed;attribute vec2 a_shift;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;varying float v_placed;varying float v_notUsed;void main() {vec4 projectedPoint=u_matrix*vec4(a_anchor_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);gl_Position=u_matrix*vec4(a_pos,0.0,1.0);gl_Position.xy+=(a_extrude+a_shift)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}"), nr = br("varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);gl_FragColor=color*alpha*opacity_t;}", "attribute vec2 a_pos;attribute float a_radius;attribute vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(mix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"), ir = br("uniform highp vec4 u_color;uniform sampler2D u_overlay;varying vec2 v_uv;void main() {vec4 overlay_color=texture2D(u_overlay,v_uv);gl_FragColor=mix(u_color,overlay_color,overlay_color.a);}", "attribute vec2 a_pos;varying vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {v_uv=a_pos/8192.0;gl_Position=u_matrix*vec4(a_pos*u_overlay_scale,0,1);}"), ar = br("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_FragColor=color*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);}"), or = br("varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=outline_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"), sr = br("uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=mix(color1,color2,u_fade)*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"), lr = br("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_fade)*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}"), cr = br("varying vec4 v_color;void main() {gl_FragColor=v_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;attribute vec2 a_pos;attribute vec4 a_normal_ed;varying vec4 v_color;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec3 normal=a_normal_ed.xyz;base=max(0.0,base);height=max(0.0,height);float t=mod(normal.x,2.0);gl_Position=u_matrix*vec4(a_pos,t > 0.0 ? height : base,1);float colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;float directional=clamp(dot(normal/16384.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}"), ur = br("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);gl_FragColor=mixedColor*v_lighting;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;attribute vec2 a_pos;attribute vec4 a_normal_ed;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec3 normal=a_normal_ed.xyz;float edgedistance=a_normal_ed.w;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;base=max(0.0,base);height=max(0.0,height);float t=mod(normal.x,2.0);float z=t > 0.0 ? height : base;gl_Position=u_matrix*vec4(a_pos,z,1);vec2 pos=normal.x==1.0 && normal.y==0.0 && normal.z==16384.0\n? a_pos\n: vec2(edgedistance,z*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}"), hr = br("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform vec4 u_unpack;float getElevation(vec2 coord,float bias) {vec4 data=texture2D(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack)/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y),0.0);float b=getElevation(v_pos+vec2(0,-epsilon.y),0.0);float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y),0.0);float d=getElevation(v_pos+vec2(-epsilon.x,0),0.0);float e=getElevation(v_pos,0.0);float f=getElevation(v_pos+vec2(epsilon.x,0),0.0);float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y),0.0);float h=getElevation(v_pos+vec2(0,epsilon.y),0.0);float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y),0.0);float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))/pow(2.0,exaggeration+(19.2562-u_zoom));gl_FragColor=clamp(vec4(deriv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_dimension;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"), fr = br("uniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;\n#define PI 3.141592653589793\nvoid main() {vec4 pixel=texture2D(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);gl_FragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;}"), pr = br("uniform lowp float u_device_pixel_ratio;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp float v_linesofar;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_width2=vec2(outset,inset);}"), dr = br("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;varying highp vec2 v_uv;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture2D(u_image,v_uv);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;attribute float a_uv_x;attribute float a_split_index;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_image_height;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp vec2 v_uv;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;highp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_width2=vec2(outset,inset);}"), mr = br("uniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture2D(u_image,pos_a),texture2D(u_image,pos_b),u_fade);gl_FragColor=color*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform vec2 u_units_to_pixels;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;}"), gr = br("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;uniform float u_sdfgamma;uniform float u_mix;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture2D(u_image,v_tex_a).a;float sdfdist_b=texture2D(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);alpha*=smoothstep(0.5-u_sdfgamma/floorwidth,0.5+u_sdfgamma/floorwidth,sdfdist);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_patternscale_a;uniform float u_tex_y_a;uniform vec2 u_patternscale_b;uniform float u_tex_y_b;uniform vec2 u_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_tex_a=vec2(a_linesofar*u_patternscale_a.x/floorwidth,normal.y*u_patternscale_a.y+u_tex_y_a);v_tex_b=vec2(a_linesofar*u_patternscale_b.x/floorwidth,normal.y*u_patternscale_b.y+u_tex_y_b);v_width2=vec2(outset,inset);}"), yr = br("uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;varying vec2 v_pos0;varying vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture2D(u_image0,v_pos0);vec4 color1=texture2D(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);gl_FragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos0;varying vec2 v_pos1;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos0=(((a_texture_pos/8192.0)-0.5)/u_buffer_scale )+0.5;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}"), vr = br("uniform sampler2D u_texture;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nlowp float alpha=opacity*v_fade_opacity;gl_FragColor=texture2D(u_texture,v_tex)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0),0.0,1.0);v_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;v_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));}"), xr = br("#define SDF_PX 8.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset),0.0,1.0);float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,interpolated_fade_opacity);}"), _r = br("#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;gl_FragColor=texture2D(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale),0.0,1.0);float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,interpolated_fade_opacity,is_sdf);}");
                        function br(t1, e1) {
                            var r = /#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g, n = e1.match(/attribute ([\w]+) ([\w]+)/g), i = t1.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), a = e1.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), o = a ? a.concat(i) : i, s = {};
                            return {
                                fragmentSource: t1 = t1.replace(r, function(t1, e1, r, n, i) {
                                    return s[i] = !0, "define" === e1 ? "\n#ifndef HAS_UNIFORM_u_" + i + "\nvarying " + r + " " + n + " " + i + ";\n#else\nuniform " + r + " " + n + " u_" + i + ";\n#endif\n" : "\n#ifdef HAS_UNIFORM_u_" + i + "\n    " + r + " " + n + " " + i + " = u_" + i + ";\n#endif\n";
                                }),
                                vertexSource: e1 = e1.replace(r, function(t1, e1, r, n, i) {
                                    var a = "float" === n ? "vec2" : "vec4", o = i.match(/color/) ? "color" : a;
                                    return s[i] ? "define" === e1 ? "\n#ifndef HAS_UNIFORM_u_" + i + "\nuniform lowp float u_" + i + "_t;\nattribute " + r + " " + a + " a_" + i + ";\nvarying " + r + " " + n + " " + i + ";\n#else\nuniform " + r + " " + n + " u_" + i + ";\n#endif\n" : "vec4" === o ? "\n#ifndef HAS_UNIFORM_u_" + i + "\n    " + i + " = a_" + i + ";\n#else\n    " + r + " " + n + " " + i + " = u_" + i + ";\n#endif\n" : "\n#ifndef HAS_UNIFORM_u_" + i + "\n    " + i + " = unpack_mix_" + o + "(a_" + i + ", u_" + i + "_t);\n#else\n    " + r + " " + n + " " + i + " = u_" + i + ";\n#endif\n" : "define" === e1 ? "\n#ifndef HAS_UNIFORM_u_" + i + "\nuniform lowp float u_" + i + "_t;\nattribute " + r + " " + a + " a_" + i + ";\n#else\nuniform " + r + " " + n + " u_" + i + ";\n#endif\n" : "vec4" === o ? "\n#ifndef HAS_UNIFORM_u_" + i + "\n    " + r + " " + n + " " + i + " = a_" + i + ";\n#else\n    " + r + " " + n + " " + i + " = u_" + i + ";\n#endif\n" : "\n#ifndef HAS_UNIFORM_u_" + i + "\n    " + r + " " + n + " " + i + " = unpack_mix_" + o + "(a_" + i + ", u_" + i + "_t);\n#else\n    " + r + " " + n + " " + i + " = u_" + i + ";\n#endif\n";
                                }),
                                staticAttributes: n,
                                staticUniforms: o
                            };
                        }
                        var wr = Object.freeze({
                            __proto__: null,
                            prelude: Xe,
                            background: $e,
                            backgroundPattern: Je,
                            circle: Ke,
                            clippingMask: Qe,
                            heatmap: tr,
                            heatmapTexture: er,
                            collisionBox: rr,
                            collisionCircle: nr,
                            debug: ir,
                            fill: ar,
                            fillOutline: or,
                            fillOutlinePattern: sr,
                            fillPattern: lr,
                            fillExtrusion: cr,
                            fillExtrusionPattern: ur,
                            hillshadePrepare: hr,
                            hillshade: fr,
                            line: pr,
                            lineGradient: dr,
                            linePattern: mr,
                            lineSDF: gr,
                            raster: yr,
                            symbolIcon: vr,
                            symbolSDF: xr,
                            symbolTextAndIcon: _r
                        }), Tr = function() {
                            this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffer = null, this.vao = null;
                        };
                        function kr(t1) {
                            for(var e1 = [], r = 0; r < t1.length; r++)if (null !== t1[r]) {
                                var n = t1[r].split(" ");
                                e1.push(n.pop());
                            }
                            return e1;
                        }
                        Tr.prototype.bind = function(t1, e1, r, n, i, a, o, s) {
                            this.context = t1;
                            for(var l = this.boundPaintVertexBuffers.length !== n.length, c = 0; !l && c < n.length; c++)this.boundPaintVertexBuffers[c] !== n[c] && (l = !0);
                            var u = !this.vao || this.boundProgram !== e1 || this.boundLayoutVertexBuffer !== r || l || this.boundIndexBuffer !== i || this.boundVertexOffset !== a || this.boundDynamicVertexBuffer !== o || this.boundDynamicVertexBuffer2 !== s;
                            !t1.extVertexArrayObject || u ? this.freshBind(e1, r, n, i, a, o, s) : (t1.bindVertexArrayOES.set(this.vao), o && o.bind(), i && i.dynamicDraw && i.bind(), s && s.bind());
                        }, Tr.prototype.freshBind = function(t1, e1, r, n, i, a, o) {
                            var s, l = t1.numAttributes, c = this.context, u = c.gl;
                            if (c.extVertexArrayObject) this.vao && this.destroy(), this.vao = c.extVertexArrayObject.createVertexArrayOES(), c.bindVertexArrayOES.set(this.vao), s = 0, this.boundProgram = t1, this.boundLayoutVertexBuffer = e1, this.boundPaintVertexBuffers = r, this.boundIndexBuffer = n, this.boundVertexOffset = i, this.boundDynamicVertexBuffer = a, this.boundDynamicVertexBuffer2 = o;
                            else {
                                s = c.currentNumAttributes || 0;
                                for(var h = l; h < s; h++)u.disableVertexAttribArray(h);
                            }
                            e1.enableAttributes(u, t1);
                            for(var f = 0, p = r; f < p.length; f += 1)p[f].enableAttributes(u, t1);
                            a && a.enableAttributes(u, t1), o && o.enableAttributes(u, t1), e1.bind(), e1.setVertexAttribPointers(u, t1, i);
                            for(var d = 0, m = r; d < m.length; d += 1){
                                var g = m[d];
                                g.bind(), g.setVertexAttribPointers(u, t1, i);
                            }
                            a && (a.bind(), a.setVertexAttribPointers(u, t1, i)), n && n.bind(), o && (o.bind(), o.setVertexAttribPointers(u, t1, i)), c.currentNumAttributes = l;
                        }, Tr.prototype.destroy = function() {
                            this.vao && (this.context.extVertexArrayObject.deleteVertexArrayOES(this.vao), this.vao = null);
                        };
                        var Ar = function(t1, e1, r, n, i, a) {
                            var o = t1.gl;
                            this.program = o.createProgram();
                            for(var s = kr(r.staticAttributes), l = n ? n.getBinderAttributes() : [], c = s.concat(l), u = r.staticUniforms ? kr(r.staticUniforms) : [], h = n ? n.getBinderUniforms() : [], f = [], p = 0, d = u.concat(h); p < d.length; p += 1){
                                var m = d[p];
                                f.indexOf(m) < 0 && f.push(m);
                            }
                            var g = n ? n.defines() : [];
                            a && g.push("#define OVERDRAW_INSPECTOR;");
                            var y = g.concat(Xe.fragmentSource, r.fragmentSource).join("\n"), v = g.concat(Xe.vertexSource, r.vertexSource).join("\n"), x = o.createShader(o.FRAGMENT_SHADER);
                            if (o.isContextLost()) this.failedToCreate = !0;
                            else {
                                o.shaderSource(x, y), o.compileShader(x), o.attachShader(this.program, x);
                                var _ = o.createShader(o.VERTEX_SHADER);
                                if (o.isContextLost()) this.failedToCreate = !0;
                                else {
                                    o.shaderSource(_, v), o.compileShader(_), o.attachShader(this.program, _), this.attributes = {};
                                    var b = {};
                                    this.numAttributes = c.length;
                                    for(var w = 0; w < this.numAttributes; w++)c[w] && (o.bindAttribLocation(this.program, w, c[w]), this.attributes[c[w]] = w);
                                    o.linkProgram(this.program), o.deleteShader(_), o.deleteShader(x);
                                    for(var T = 0; T < f.length; T++){
                                        var k = f[T];
                                        if (k && !b[k]) {
                                            var A = o.getUniformLocation(this.program, k);
                                            A && (b[k] = A);
                                        }
                                    }
                                    this.fixedUniforms = i(t1, b), this.binderUniforms = n ? n.getUniforms(t1, b) : [];
                                }
                            }
                        };
                        function Mr(t1, e1, r) {
                            var n = 1 / ge(r, 1, e1.transform.tileZoom), i = Math.pow(2, r.tileID.overscaledZ), a = r.tileSize * Math.pow(2, e1.transform.tileZoom) / i, o = a * (r.tileID.canonical.x + r.tileID.wrap * i), s = a * r.tileID.canonical.y;
                            return {
                                u_image: 0,
                                u_texsize: r.imageAtlasTexture.size,
                                u_scale: [
                                    n,
                                    t1.fromScale,
                                    t1.toScale
                                ],
                                u_fade: t1.t,
                                u_pixel_coord_upper: [
                                    o >> 16,
                                    s >> 16
                                ],
                                u_pixel_coord_lower: [
                                    65535 & o,
                                    65535 & s
                                ]
                            };
                        }
                        Ar.prototype.draw = function(t1, e1, r, n, i, a, o, s, l, c, u, h, f, p, d, m) {
                            var g, y = t1.gl;
                            if (!this.failedToCreate) {
                                for(var v in t1.program.set(this.program), t1.setDepthMode(r), t1.setStencilMode(n), t1.setColorMode(i), t1.setCullFace(a), this.fixedUniforms)this.fixedUniforms[v].set(o[v]);
                                p && p.setUniforms(t1, this.binderUniforms, h, {
                                    zoom: f
                                });
                                for(var x = (g = {}, g[y.LINES] = 2, g[y.TRIANGLES] = 3, g[y.LINE_STRIP] = 1, g)[e1], _ = 0, b = u.get(); _ < b.length; _ += 1){
                                    var w = b[_], T = w.vaos || (w.vaos = {});
                                    (T[s] || (T[s] = new Tr)).bind(t1, this, l, p ? p.getPaintVertexBuffers() : [], c, w.vertexOffset, d, m), y.drawElements(e1, w.primitiveLength * x, y.UNSIGNED_SHORT, w.primitiveOffset * x * 2);
                                }
                            }
                        };
                        var Sr = function(e1, r, n, i) {
                            var a = r.style.light, o = a.properties.get("position"), s = [
                                o.x,
                                o.y,
                                o.z
                            ], l = t1.create$1();
                            "viewport" === a.properties.get("anchor") && t1.fromRotation(l, -r.transform.angle), t1.transformMat3(s, s, l);
                            var c = a.properties.get("color");
                            return {
                                u_matrix: e1,
                                u_lightpos: s,
                                u_lightintensity: a.properties.get("intensity"),
                                u_lightcolor: [
                                    c.r,
                                    c.g,
                                    c.b
                                ],
                                u_vertical_gradient: +n,
                                u_opacity: i
                            };
                        }, Er = function(e1, r, n, i, a, o, s) {
                            return t1.extend(Sr(e1, r, n, i), Mr(o, r, s), {
                                u_height_factor: -Math.pow(2, a.overscaledZ) / s.tileSize / 8
                            });
                        }, Cr = function(t1) {
                            return {
                                u_matrix: t1
                            };
                        }, Lr = function(e1, r, n, i) {
                            return t1.extend(Cr(e1), Mr(n, r, i));
                        }, Ir = function(t1, e1) {
                            return {
                                u_matrix: t1,
                                u_world: e1
                            };
                        }, Pr = function(e1, r, n, i, a) {
                            return t1.extend(Lr(e1, r, n, i), {
                                u_world: a
                            });
                        }, zr = function(e1, r, n, i) {
                            var a, o, s = e1.transform;
                            if ("map" === i.paint.get("circle-pitch-alignment")) {
                                var l = ge(n, 1, s.zoom);
                                a = !0, o = [
                                    l,
                                    l
                                ];
                            } else a = !1, o = s.pixelsToGLUnits;
                            return {
                                u_camera_to_center_distance: s.cameraToCenterDistance,
                                u_scale_with_map: +("map" === i.paint.get("circle-pitch-scale")),
                                u_matrix: e1.translatePosMatrix(r.posMatrix, n, i.paint.get("circle-translate"), i.paint.get("circle-translate-anchor")),
                                u_pitch_with_map: +a,
                                u_device_pixel_ratio: t1.browser.devicePixelRatio,
                                u_extrude_scale: o
                            };
                        }, Or = function(t1, e1, r) {
                            var n = ge(r, 1, e1.zoom), i = Math.pow(2, e1.zoom - r.tileID.overscaledZ), a = r.tileID.overscaleFactor();
                            return {
                                u_matrix: t1,
                                u_camera_to_center_distance: e1.cameraToCenterDistance,
                                u_pixels_to_tile_units: n,
                                u_extrude_scale: [
                                    e1.pixelsToGLUnits[0] / (n * i),
                                    e1.pixelsToGLUnits[1] / (n * i)
                                ],
                                u_overscale_factor: a
                            };
                        }, Dr = function(t1, e1, r) {
                            return {
                                u_matrix: t1,
                                u_inv_matrix: e1,
                                u_camera_to_center_distance: r.cameraToCenterDistance,
                                u_viewport_size: [
                                    r.width,
                                    r.height
                                ]
                            };
                        }, Rr = function(t1, e1, r) {
                            return void 0 === r && (r = 1), {
                                u_matrix: t1,
                                u_color: e1,
                                u_overlay: 0,
                                u_overlay_scale: r
                            };
                        }, Fr = function(t1) {
                            return {
                                u_matrix: t1
                            };
                        }, Br = function(t1, e1, r, n) {
                            return {
                                u_matrix: t1,
                                u_extrude_scale: ge(e1, 1, r),
                                u_intensity: n
                            };
                        }, Nr = function(e1, r, n, i) {
                            var a = t1.create();
                            t1.ortho(a, 0, e1.width, e1.height, 0, 0, 1);
                            var o = e1.context.gl;
                            return {
                                u_matrix: a,
                                u_world: [
                                    o.drawingBufferWidth,
                                    o.drawingBufferHeight
                                ],
                                u_image: n,
                                u_color_ramp: i,
                                u_opacity: r.paint.get("heatmap-opacity")
                            };
                        }, jr = function(e1, r, n) {
                            var i = n.paint.get("hillshade-shadow-color"), a = n.paint.get("hillshade-highlight-color"), o = n.paint.get("hillshade-accent-color"), s = n.paint.get("hillshade-illumination-direction") * (Math.PI / 180);
                            "viewport" === n.paint.get("hillshade-illumination-anchor") && (s -= e1.transform.angle);
                            var l, c, u, h = !e1.options.moving;
                            return {
                                u_matrix: e1.transform.calculatePosMatrix(r.tileID.toUnwrapped(), h),
                                u_image: 0,
                                u_latrange: (l = r.tileID, c = Math.pow(2, l.canonical.z), u = l.canonical.y, [
                                    new t1.MercatorCoordinate(0, u / c).toLngLat().lat,
                                    new t1.MercatorCoordinate(0, (u + 1) / c).toLngLat().lat
                                ]),
                                u_light: [
                                    n.paint.get("hillshade-exaggeration"),
                                    s
                                ],
                                u_shadow: i,
                                u_highlight: a,
                                u_accent: o
                            };
                        }, Ur = function(e1, r) {
                            var n = r.stride, i = t1.create();
                            return t1.ortho(i, 0, t1.EXTENT, -t1.EXTENT, 0, 0, 1), t1.translate(i, i, [
                                0,
                                -t1.EXTENT,
                                0
                            ]), {
                                u_matrix: i,
                                u_image: 1,
                                u_dimension: [
                                    n,
                                    n
                                ],
                                u_zoom: e1.overscaledZ,
                                u_unpack: r.getUnpackVector()
                            };
                        };
                        var Vr = function(e1, r, n) {
                            var i = e1.transform;
                            return {
                                u_matrix: Wr(e1, r, n),
                                u_ratio: 1 / ge(r, 1, i.zoom),
                                u_device_pixel_ratio: t1.browser.devicePixelRatio,
                                u_units_to_pixels: [
                                    1 / i.pixelsToGLUnits[0],
                                    1 / i.pixelsToGLUnits[1]
                                ]
                            };
                        }, qr = function(e1, r, n, i) {
                            return t1.extend(Vr(e1, r, n), {
                                u_image: 0,
                                u_image_height: i
                            });
                        }, Hr = function(e1, r, n, i) {
                            var a = e1.transform, o = Zr(r, a);
                            return {
                                u_matrix: Wr(e1, r, n),
                                u_texsize: r.imageAtlasTexture.size,
                                u_ratio: 1 / ge(r, 1, a.zoom),
                                u_device_pixel_ratio: t1.browser.devicePixelRatio,
                                u_image: 0,
                                u_scale: [
                                    o,
                                    i.fromScale,
                                    i.toScale
                                ],
                                u_fade: i.t,
                                u_units_to_pixels: [
                                    1 / a.pixelsToGLUnits[0],
                                    1 / a.pixelsToGLUnits[1]
                                ]
                            };
                        }, Gr = function(e1, r, n, i, a) {
                            var o = e1.transform, s = e1.lineAtlas, l = Zr(r, o), c = "round" === n.layout.get("line-cap"), u = s.getDash(i.from, c), h = s.getDash(i.to, c), f = u.width * a.fromScale, p = h.width * a.toScale;
                            return t1.extend(Vr(e1, r, n), {
                                u_patternscale_a: [
                                    l / f,
                                    -u.height / 2
                                ],
                                u_patternscale_b: [
                                    l / p,
                                    -h.height / 2
                                ],
                                u_sdfgamma: s.width / (256 * Math.min(f, p) * t1.browser.devicePixelRatio) / 2,
                                u_image: 0,
                                u_tex_y_a: u.y,
                                u_tex_y_b: h.y,
                                u_mix: a.t
                            });
                        };
                        function Zr(t1, e1) {
                            return 1 / ge(t1, 1, e1.tileZoom);
                        }
                        function Wr(t1, e1, r) {
                            return t1.translatePosMatrix(e1.tileID.posMatrix, e1, r.paint.get("line-translate"), r.paint.get("line-translate-anchor"));
                        }
                        var Yr = function(t1, e1, r, n, i) {
                            var a, o;
                            return {
                                u_matrix: t1,
                                u_tl_parent: e1,
                                u_scale_parent: r,
                                u_buffer_scale: 1,
                                u_fade_t: n.mix,
                                u_opacity: n.opacity * i.paint.get("raster-opacity"),
                                u_image0: 0,
                                u_image1: 1,
                                u_brightness_low: i.paint.get("raster-brightness-min"),
                                u_brightness_high: i.paint.get("raster-brightness-max"),
                                u_saturation_factor: (o = i.paint.get("raster-saturation"), o > 0 ? 1 - 1 / (1.001 - o) : -o),
                                u_contrast_factor: (a = i.paint.get("raster-contrast"), a > 0 ? 1 / (1 - a) : 1 + a),
                                u_spin_weights: Xr(i.paint.get("raster-hue-rotate"))
                            };
                        };
                        function Xr(t1) {
                            t1 *= Math.PI / 180;
                            var e1 = Math.sin(t1), r = Math.cos(t1);
                            return [
                                (2 * r + 1) / 3,
                                (-Math.sqrt(3) * e1 - r + 1) / 3,
                                (Math.sqrt(3) * e1 - r + 1) / 3
                            ];
                        }
                        var $r, Jr = function(t1, e1, r, n, i, a, o, s, l, c) {
                            var u = i.transform;
                            return {
                                u_is_size_zoom_constant: +("constant" === t1 || "source" === t1),
                                u_is_size_feature_constant: +("constant" === t1 || "camera" === t1),
                                u_size_t: e1 ? e1.uSizeT : 0,
                                u_size: e1 ? e1.uSize : 0,
                                u_camera_to_center_distance: u.cameraToCenterDistance,
                                u_pitch: u.pitch / 360 * 2 * Math.PI,
                                u_rotate_symbol: +r,
                                u_aspect_ratio: u.width / u.height,
                                u_fade_change: i.options.fadeDuration ? i.symbolFadeChange : 1,
                                u_matrix: a,
                                u_label_plane_matrix: o,
                                u_coord_matrix: s,
                                u_is_text: +l,
                                u_pitch_with_map: +n,
                                u_texsize: c,
                                u_texture: 0
                            };
                        }, Kr = function(e1, r, n, i, a, o, s, l, c, u, h) {
                            var f = a.transform;
                            return t1.extend(Jr(e1, r, n, i, a, o, s, l, c, u), {
                                u_gamma_scale: i ? Math.cos(f._pitch) * f.cameraToCenterDistance : 1,
                                u_device_pixel_ratio: t1.browser.devicePixelRatio,
                                u_is_halo: +h
                            });
                        }, Qr = function(e1, r, n, i, a, o, s, l, c, u) {
                            return t1.extend(Kr(e1, r, n, i, a, o, s, l, !0, c, !0), {
                                u_texsize_icon: u,
                                u_texture_icon: 1
                            });
                        }, tn = function(t1, e1, r) {
                            return {
                                u_matrix: t1,
                                u_opacity: e1,
                                u_color: r
                            };
                        }, en = function(e1, r, n, i, a, o) {
                            return t1.extend(function(t1, e1, r, n) {
                                var i = r.imageManager.getPattern(t1.from.toString()), a = r.imageManager.getPattern(t1.to.toString()), o = r.imageManager.getPixelSize(), s = o.width, l = o.height, c = Math.pow(2, n.tileID.overscaledZ), u = n.tileSize * Math.pow(2, r.transform.tileZoom) / c, h = u * (n.tileID.canonical.x + n.tileID.wrap * c), f = u * n.tileID.canonical.y;
                                return {
                                    u_image: 0,
                                    u_pattern_tl_a: i.tl,
                                    u_pattern_br_a: i.br,
                                    u_pattern_tl_b: a.tl,
                                    u_pattern_br_b: a.br,
                                    u_texsize: [
                                        s,
                                        l
                                    ],
                                    u_mix: e1.t,
                                    u_pattern_size_a: i.displaySize,
                                    u_pattern_size_b: a.displaySize,
                                    u_scale_a: e1.fromScale,
                                    u_scale_b: e1.toScale,
                                    u_tile_units_to_pixels: 1 / ge(n, 1, r.transform.tileZoom),
                                    u_pixel_coord_upper: [
                                        h >> 16,
                                        f >> 16
                                    ],
                                    u_pixel_coord_lower: [
                                        65535 & h,
                                        65535 & f
                                    ]
                                };
                            }(i, o, n, a), {
                                u_matrix: e1,
                                u_opacity: r
                            });
                        }, rn = {
                            fillExtrusion: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_lightpos: new t1.Uniform3f(e1, r.u_lightpos),
                                    u_lightintensity: new t1.Uniform1f(e1, r.u_lightintensity),
                                    u_lightcolor: new t1.Uniform3f(e1, r.u_lightcolor),
                                    u_vertical_gradient: new t1.Uniform1f(e1, r.u_vertical_gradient),
                                    u_opacity: new t1.Uniform1f(e1, r.u_opacity)
                                };
                            },
                            fillExtrusionPattern: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_lightpos: new t1.Uniform3f(e1, r.u_lightpos),
                                    u_lightintensity: new t1.Uniform1f(e1, r.u_lightintensity),
                                    u_lightcolor: new t1.Uniform3f(e1, r.u_lightcolor),
                                    u_vertical_gradient: new t1.Uniform1f(e1, r.u_vertical_gradient),
                                    u_height_factor: new t1.Uniform1f(e1, r.u_height_factor),
                                    u_image: new t1.Uniform1i(e1, r.u_image),
                                    u_texsize: new t1.Uniform2f(e1, r.u_texsize),
                                    u_pixel_coord_upper: new t1.Uniform2f(e1, r.u_pixel_coord_upper),
                                    u_pixel_coord_lower: new t1.Uniform2f(e1, r.u_pixel_coord_lower),
                                    u_scale: new t1.Uniform3f(e1, r.u_scale),
                                    u_fade: new t1.Uniform1f(e1, r.u_fade),
                                    u_opacity: new t1.Uniform1f(e1, r.u_opacity)
                                };
                            },
                            fill: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix)
                                };
                            },
                            fillPattern: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_image: new t1.Uniform1i(e1, r.u_image),
                                    u_texsize: new t1.Uniform2f(e1, r.u_texsize),
                                    u_pixel_coord_upper: new t1.Uniform2f(e1, r.u_pixel_coord_upper),
                                    u_pixel_coord_lower: new t1.Uniform2f(e1, r.u_pixel_coord_lower),
                                    u_scale: new t1.Uniform3f(e1, r.u_scale),
                                    u_fade: new t1.Uniform1f(e1, r.u_fade)
                                };
                            },
                            fillOutline: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_world: new t1.Uniform2f(e1, r.u_world)
                                };
                            },
                            fillOutlinePattern: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_world: new t1.Uniform2f(e1, r.u_world),
                                    u_image: new t1.Uniform1i(e1, r.u_image),
                                    u_texsize: new t1.Uniform2f(e1, r.u_texsize),
                                    u_pixel_coord_upper: new t1.Uniform2f(e1, r.u_pixel_coord_upper),
                                    u_pixel_coord_lower: new t1.Uniform2f(e1, r.u_pixel_coord_lower),
                                    u_scale: new t1.Uniform3f(e1, r.u_scale),
                                    u_fade: new t1.Uniform1f(e1, r.u_fade)
                                };
                            },
                            circle: function(e1, r) {
                                return {
                                    u_camera_to_center_distance: new t1.Uniform1f(e1, r.u_camera_to_center_distance),
                                    u_scale_with_map: new t1.Uniform1i(e1, r.u_scale_with_map),
                                    u_pitch_with_map: new t1.Uniform1i(e1, r.u_pitch_with_map),
                                    u_extrude_scale: new t1.Uniform2f(e1, r.u_extrude_scale),
                                    u_device_pixel_ratio: new t1.Uniform1f(e1, r.u_device_pixel_ratio),
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix)
                                };
                            },
                            collisionBox: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_camera_to_center_distance: new t1.Uniform1f(e1, r.u_camera_to_center_distance),
                                    u_pixels_to_tile_units: new t1.Uniform1f(e1, r.u_pixels_to_tile_units),
                                    u_extrude_scale: new t1.Uniform2f(e1, r.u_extrude_scale),
                                    u_overscale_factor: new t1.Uniform1f(e1, r.u_overscale_factor)
                                };
                            },
                            collisionCircle: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_inv_matrix: new t1.UniformMatrix4f(e1, r.u_inv_matrix),
                                    u_camera_to_center_distance: new t1.Uniform1f(e1, r.u_camera_to_center_distance),
                                    u_viewport_size: new t1.Uniform2f(e1, r.u_viewport_size)
                                };
                            },
                            debug: function(e1, r) {
                                return {
                                    u_color: new t1.UniformColor(e1, r.u_color),
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_overlay: new t1.Uniform1i(e1, r.u_overlay),
                                    u_overlay_scale: new t1.Uniform1f(e1, r.u_overlay_scale)
                                };
                            },
                            clippingMask: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix)
                                };
                            },
                            heatmap: function(e1, r) {
                                return {
                                    u_extrude_scale: new t1.Uniform1f(e1, r.u_extrude_scale),
                                    u_intensity: new t1.Uniform1f(e1, r.u_intensity),
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix)
                                };
                            },
                            heatmapTexture: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_world: new t1.Uniform2f(e1, r.u_world),
                                    u_image: new t1.Uniform1i(e1, r.u_image),
                                    u_color_ramp: new t1.Uniform1i(e1, r.u_color_ramp),
                                    u_opacity: new t1.Uniform1f(e1, r.u_opacity)
                                };
                            },
                            hillshade: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_image: new t1.Uniform1i(e1, r.u_image),
                                    u_latrange: new t1.Uniform2f(e1, r.u_latrange),
                                    u_light: new t1.Uniform2f(e1, r.u_light),
                                    u_shadow: new t1.UniformColor(e1, r.u_shadow),
                                    u_highlight: new t1.UniformColor(e1, r.u_highlight),
                                    u_accent: new t1.UniformColor(e1, r.u_accent)
                                };
                            },
                            hillshadePrepare: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_image: new t1.Uniform1i(e1, r.u_image),
                                    u_dimension: new t1.Uniform2f(e1, r.u_dimension),
                                    u_zoom: new t1.Uniform1f(e1, r.u_zoom),
                                    u_unpack: new t1.Uniform4f(e1, r.u_unpack)
                                };
                            },
                            line: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_ratio: new t1.Uniform1f(e1, r.u_ratio),
                                    u_device_pixel_ratio: new t1.Uniform1f(e1, r.u_device_pixel_ratio),
                                    u_units_to_pixels: new t1.Uniform2f(e1, r.u_units_to_pixels)
                                };
                            },
                            lineGradient: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_ratio: new t1.Uniform1f(e1, r.u_ratio),
                                    u_device_pixel_ratio: new t1.Uniform1f(e1, r.u_device_pixel_ratio),
                                    u_units_to_pixels: new t1.Uniform2f(e1, r.u_units_to_pixels),
                                    u_image: new t1.Uniform1i(e1, r.u_image),
                                    u_image_height: new t1.Uniform1f(e1, r.u_image_height)
                                };
                            },
                            linePattern: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_texsize: new t1.Uniform2f(e1, r.u_texsize),
                                    u_ratio: new t1.Uniform1f(e1, r.u_ratio),
                                    u_device_pixel_ratio: new t1.Uniform1f(e1, r.u_device_pixel_ratio),
                                    u_image: new t1.Uniform1i(e1, r.u_image),
                                    u_units_to_pixels: new t1.Uniform2f(e1, r.u_units_to_pixels),
                                    u_scale: new t1.Uniform3f(e1, r.u_scale),
                                    u_fade: new t1.Uniform1f(e1, r.u_fade)
                                };
                            },
                            lineSDF: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_ratio: new t1.Uniform1f(e1, r.u_ratio),
                                    u_device_pixel_ratio: new t1.Uniform1f(e1, r.u_device_pixel_ratio),
                                    u_units_to_pixels: new t1.Uniform2f(e1, r.u_units_to_pixels),
                                    u_patternscale_a: new t1.Uniform2f(e1, r.u_patternscale_a),
                                    u_patternscale_b: new t1.Uniform2f(e1, r.u_patternscale_b),
                                    u_sdfgamma: new t1.Uniform1f(e1, r.u_sdfgamma),
                                    u_image: new t1.Uniform1i(e1, r.u_image),
                                    u_tex_y_a: new t1.Uniform1f(e1, r.u_tex_y_a),
                                    u_tex_y_b: new t1.Uniform1f(e1, r.u_tex_y_b),
                                    u_mix: new t1.Uniform1f(e1, r.u_mix)
                                };
                            },
                            raster: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_tl_parent: new t1.Uniform2f(e1, r.u_tl_parent),
                                    u_scale_parent: new t1.Uniform1f(e1, r.u_scale_parent),
                                    u_buffer_scale: new t1.Uniform1f(e1, r.u_buffer_scale),
                                    u_fade_t: new t1.Uniform1f(e1, r.u_fade_t),
                                    u_opacity: new t1.Uniform1f(e1, r.u_opacity),
                                    u_image0: new t1.Uniform1i(e1, r.u_image0),
                                    u_image1: new t1.Uniform1i(e1, r.u_image1),
                                    u_brightness_low: new t1.Uniform1f(e1, r.u_brightness_low),
                                    u_brightness_high: new t1.Uniform1f(e1, r.u_brightness_high),
                                    u_saturation_factor: new t1.Uniform1f(e1, r.u_saturation_factor),
                                    u_contrast_factor: new t1.Uniform1f(e1, r.u_contrast_factor),
                                    u_spin_weights: new t1.Uniform3f(e1, r.u_spin_weights)
                                };
                            },
                            symbolIcon: function(e1, r) {
                                return {
                                    u_is_size_zoom_constant: new t1.Uniform1i(e1, r.u_is_size_zoom_constant),
                                    u_is_size_feature_constant: new t1.Uniform1i(e1, r.u_is_size_feature_constant),
                                    u_size_t: new t1.Uniform1f(e1, r.u_size_t),
                                    u_size: new t1.Uniform1f(e1, r.u_size),
                                    u_camera_to_center_distance: new t1.Uniform1f(e1, r.u_camera_to_center_distance),
                                    u_pitch: new t1.Uniform1f(e1, r.u_pitch),
                                    u_rotate_symbol: new t1.Uniform1i(e1, r.u_rotate_symbol),
                                    u_aspect_ratio: new t1.Uniform1f(e1, r.u_aspect_ratio),
                                    u_fade_change: new t1.Uniform1f(e1, r.u_fade_change),
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_label_plane_matrix: new t1.UniformMatrix4f(e1, r.u_label_plane_matrix),
                                    u_coord_matrix: new t1.UniformMatrix4f(e1, r.u_coord_matrix),
                                    u_is_text: new t1.Uniform1i(e1, r.u_is_text),
                                    u_pitch_with_map: new t1.Uniform1i(e1, r.u_pitch_with_map),
                                    u_texsize: new t1.Uniform2f(e1, r.u_texsize),
                                    u_texture: new t1.Uniform1i(e1, r.u_texture)
                                };
                            },
                            symbolSDF: function(e1, r) {
                                return {
                                    u_is_size_zoom_constant: new t1.Uniform1i(e1, r.u_is_size_zoom_constant),
                                    u_is_size_feature_constant: new t1.Uniform1i(e1, r.u_is_size_feature_constant),
                                    u_size_t: new t1.Uniform1f(e1, r.u_size_t),
                                    u_size: new t1.Uniform1f(e1, r.u_size),
                                    u_camera_to_center_distance: new t1.Uniform1f(e1, r.u_camera_to_center_distance),
                                    u_pitch: new t1.Uniform1f(e1, r.u_pitch),
                                    u_rotate_symbol: new t1.Uniform1i(e1, r.u_rotate_symbol),
                                    u_aspect_ratio: new t1.Uniform1f(e1, r.u_aspect_ratio),
                                    u_fade_change: new t1.Uniform1f(e1, r.u_fade_change),
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_label_plane_matrix: new t1.UniformMatrix4f(e1, r.u_label_plane_matrix),
                                    u_coord_matrix: new t1.UniformMatrix4f(e1, r.u_coord_matrix),
                                    u_is_text: new t1.Uniform1i(e1, r.u_is_text),
                                    u_pitch_with_map: new t1.Uniform1i(e1, r.u_pitch_with_map),
                                    u_texsize: new t1.Uniform2f(e1, r.u_texsize),
                                    u_texture: new t1.Uniform1i(e1, r.u_texture),
                                    u_gamma_scale: new t1.Uniform1f(e1, r.u_gamma_scale),
                                    u_device_pixel_ratio: new t1.Uniform1f(e1, r.u_device_pixel_ratio),
                                    u_is_halo: new t1.Uniform1i(e1, r.u_is_halo)
                                };
                            },
                            symbolTextAndIcon: function(e1, r) {
                                return {
                                    u_is_size_zoom_constant: new t1.Uniform1i(e1, r.u_is_size_zoom_constant),
                                    u_is_size_feature_constant: new t1.Uniform1i(e1, r.u_is_size_feature_constant),
                                    u_size_t: new t1.Uniform1f(e1, r.u_size_t),
                                    u_size: new t1.Uniform1f(e1, r.u_size),
                                    u_camera_to_center_distance: new t1.Uniform1f(e1, r.u_camera_to_center_distance),
                                    u_pitch: new t1.Uniform1f(e1, r.u_pitch),
                                    u_rotate_symbol: new t1.Uniform1i(e1, r.u_rotate_symbol),
                                    u_aspect_ratio: new t1.Uniform1f(e1, r.u_aspect_ratio),
                                    u_fade_change: new t1.Uniform1f(e1, r.u_fade_change),
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_label_plane_matrix: new t1.UniformMatrix4f(e1, r.u_label_plane_matrix),
                                    u_coord_matrix: new t1.UniformMatrix4f(e1, r.u_coord_matrix),
                                    u_is_text: new t1.Uniform1i(e1, r.u_is_text),
                                    u_pitch_with_map: new t1.Uniform1i(e1, r.u_pitch_with_map),
                                    u_texsize: new t1.Uniform2f(e1, r.u_texsize),
                                    u_texsize_icon: new t1.Uniform2f(e1, r.u_texsize_icon),
                                    u_texture: new t1.Uniform1i(e1, r.u_texture),
                                    u_texture_icon: new t1.Uniform1i(e1, r.u_texture_icon),
                                    u_gamma_scale: new t1.Uniform1f(e1, r.u_gamma_scale),
                                    u_device_pixel_ratio: new t1.Uniform1f(e1, r.u_device_pixel_ratio),
                                    u_is_halo: new t1.Uniform1i(e1, r.u_is_halo)
                                };
                            },
                            background: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_opacity: new t1.Uniform1f(e1, r.u_opacity),
                                    u_color: new t1.UniformColor(e1, r.u_color)
                                };
                            },
                            backgroundPattern: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_opacity: new t1.Uniform1f(e1, r.u_opacity),
                                    u_image: new t1.Uniform1i(e1, r.u_image),
                                    u_pattern_tl_a: new t1.Uniform2f(e1, r.u_pattern_tl_a),
                                    u_pattern_br_a: new t1.Uniform2f(e1, r.u_pattern_br_a),
                                    u_pattern_tl_b: new t1.Uniform2f(e1, r.u_pattern_tl_b),
                                    u_pattern_br_b: new t1.Uniform2f(e1, r.u_pattern_br_b),
                                    u_texsize: new t1.Uniform2f(e1, r.u_texsize),
                                    u_mix: new t1.Uniform1f(e1, r.u_mix),
                                    u_pattern_size_a: new t1.Uniform2f(e1, r.u_pattern_size_a),
                                    u_pattern_size_b: new t1.Uniform2f(e1, r.u_pattern_size_b),
                                    u_scale_a: new t1.Uniform1f(e1, r.u_scale_a),
                                    u_scale_b: new t1.Uniform1f(e1, r.u_scale_b),
                                    u_pixel_coord_upper: new t1.Uniform2f(e1, r.u_pixel_coord_upper),
                                    u_pixel_coord_lower: new t1.Uniform2f(e1, r.u_pixel_coord_lower),
                                    u_tile_units_to_pixels: new t1.Uniform1f(e1, r.u_tile_units_to_pixels)
                                };
                            }
                        };
                        function nn(e1, r, n, i, a, o, s) {
                            for(var l = e1.context, c = l.gl, u = e1.useProgram("collisionBox"), h = [], f = 0, p = 0, d = 0; d < i.length; d++){
                                var m = i[d], g = r.getTile(m), y = g.getBucket(n);
                                if (y) {
                                    var v = m.posMatrix;
                                    0 === a[0] && 0 === a[1] || (v = e1.translatePosMatrix(m.posMatrix, g, a, o));
                                    var x = s ? y.textCollisionBox : y.iconCollisionBox, _ = y.collisionCircleArray;
                                    if (_.length > 0) {
                                        var b = t1.create(), w = v;
                                        t1.mul(b, y.placementInvProjMatrix, e1.transform.glCoordMatrix), t1.mul(b, b, y.placementViewportMatrix), h.push({
                                            circleArray: _,
                                            circleOffset: p,
                                            transform: w,
                                            invTransform: b
                                        }), p = f += _.length / 4;
                                    }
                                    x && u.draw(l, c.LINES, Mt.disabled, Et.disabled, e1.colorModeForRenderPass(), Lt.disabled, Or(v, e1.transform, g), n.id, x.layoutVertexBuffer, x.indexBuffer, x.segments, null, e1.transform.zoom, null, null, x.collisionVertexBuffer);
                                }
                            }
                            if (s && h.length) {
                                var T = e1.useProgram("collisionCircle"), k = new t1.StructArrayLayout2f1f2i16;
                                k.resize(4 * f), k._trim();
                                for(var A = 0, M = 0, S = h; M < S.length; M += 1)for(var E = S[M], C = 0; C < E.circleArray.length / 4; C++){
                                    var L = 4 * C, I = E.circleArray[L + 0], P = E.circleArray[L + 1], z = E.circleArray[L + 2], O = E.circleArray[L + 3];
                                    k.emplace(A++, I, P, z, O, 0), k.emplace(A++, I, P, z, O, 1), k.emplace(A++, I, P, z, O, 2), k.emplace(A++, I, P, z, O, 3);
                                }
                                (!$r || $r.length < 2 * f) && ($r = function(e1) {
                                    var r = 2 * e1, n = new t1.StructArrayLayout3ui6;
                                    n.resize(r), n._trim();
                                    for(var i = 0; i < r; i++){
                                        var a = 6 * i;
                                        n.uint16[a + 0] = 4 * i + 0, n.uint16[a + 1] = 4 * i + 1, n.uint16[a + 2] = 4 * i + 2, n.uint16[a + 3] = 4 * i + 2, n.uint16[a + 4] = 4 * i + 3, n.uint16[a + 5] = 4 * i + 0;
                                    }
                                    return n;
                                }(f));
                                for(var D = l.createIndexBuffer($r, !0), R = l.createVertexBuffer(k, t1.collisionCircleLayout.members, !0), F = 0, B = h; F < B.length; F += 1){
                                    var N = B[F], j = Dr(N.transform, N.invTransform, e1.transform);
                                    T.draw(l, c.TRIANGLES, Mt.disabled, Et.disabled, e1.colorModeForRenderPass(), Lt.disabled, j, n.id, R, D, t1.SegmentVector.simpleSegment(0, 2 * N.circleOffset, N.circleArray.length, N.circleArray.length / 2), null, e1.transform.zoom, null, null, null);
                                }
                                R.destroy(), D.destroy();
                            }
                        }
                        var an = t1.identity(new Float32Array(16));
                        function on(e1, r, n, i, a, o) {
                            var s = t1.getAnchorAlignment(e1), l = -(s.horizontalAlign - .5) * r, c = -(s.verticalAlign - .5) * n, u = t1.evaluateVariableOffset(e1, i);
                            return new t1.Point((l / a + u[0]) * o, (c / a + u[1]) * o);
                        }
                        function sn(e1, r, n, i, a, o, s, l, c, u, h) {
                            var f = e1.text.placedSymbolArray, p = e1.text.dynamicLayoutVertexArray, d = e1.icon.dynamicLayoutVertexArray, m = {};
                            p.clear();
                            for(var g = 0; g < f.length; g++){
                                var y = f.get(g), v = e1.allowVerticalPlacement && !y.placedOrientation, x = y.hidden || !y.crossTileID || v ? null : i[y.crossTileID];
                                if (x) {
                                    var _ = new t1.Point(y.anchorX, y.anchorY), b = re(_, n ? l : s), w = ne(o.cameraToCenterDistance, b.signedDistanceFromCamera), T = a.evaluateSizeForFeature(e1.textSizeData, u, y) * w / t1.ONE_EM;
                                    n && (T *= e1.tilePixelRatio / c);
                                    for(var k = x.width, A = x.height, M = on(x.anchor, k, A, x.textOffset, x.textBoxScale, T), S = n ? re(_.add(M), s).point : b.point.add(r ? M.rotate(-o.angle) : M), E = e1.allowVerticalPlacement && y.placedOrientation === t1.WritingMode.vertical ? Math.PI / 2 : 0, C = 0; C < y.numGlyphs; C++)t1.addDynamicAttributes(p, S, E);
                                    h && y.associatedIconIndex >= 0 && (m[y.associatedIconIndex] = {
                                        shiftedAnchor: S,
                                        angle: E
                                    });
                                } else fe(y.numGlyphs, p);
                            }
                            if (h) {
                                d.clear();
                                for(var L = e1.icon.placedSymbolArray, I = 0; I < L.length; I++){
                                    var P = L.get(I);
                                    if (P.hidden) fe(P.numGlyphs, d);
                                    else {
                                        var z = m[I];
                                        if (z) for(var O = 0; O < P.numGlyphs; O++)t1.addDynamicAttributes(d, z.shiftedAnchor, z.angle);
                                        else fe(P.numGlyphs, d);
                                    }
                                }
                                e1.icon.dynamicLayoutVertexBuffer.updateData(d);
                            }
                            e1.text.dynamicLayoutVertexBuffer.updateData(p);
                        }
                        function ln(t1, e1, r) {
                            return r.iconsInText && e1 ? "symbolTextAndIcon" : t1 ? "symbolSDF" : "symbolIcon";
                        }
                        function cn(e1, r, n, i, a, o, s, l, c, u, h, f) {
                            for(var p = e1.context, d = p.gl, m = e1.transform, g = "map" === l, y = "map" === c, v = g && "point" !== n.layout.get("symbol-placement"), x = g && !y && !v, _ = void 0 !== n.layout.get("symbol-sort-key").constantOr(1), b = !1, w = e1.depthModeForSublayer(0, Mt.ReadOnly), T = n.layout.get("text-variable-anchor"), k = [], A = 0, M = i; A < M.length; A += 1){
                                var S = M[A], E = r.getTile(S), C = E.getBucket(n);
                                if (C) {
                                    var L = a ? C.text : C.icon;
                                    if (L && L.segments.get().length) {
                                        var I = L.programConfigurations.get(n.id), P = a || C.sdfIcons, z = a ? C.textSizeData : C.iconSizeData, O = y || 0 !== m.pitch, D = e1.useProgram(ln(P, a, C), I), R = t1.evaluateSizeForZoom(z, m.zoom), F = void 0, B = [
                                            0,
                                            0
                                        ], N = void 0, j = void 0, U = null, V = void 0;
                                        if (a) {
                                            if (N = E.glyphAtlasTexture, j = d.LINEAR, F = E.glyphAtlasTexture.size, C.iconsInText) {
                                                B = E.imageAtlasTexture.size, U = E.imageAtlasTexture;
                                                var q = "composite" === z.kind || "camera" === z.kind;
                                                V = O || e1.options.rotating || e1.options.zooming || q ? d.LINEAR : d.NEAREST;
                                            }
                                        } else {
                                            var H = 1 !== n.layout.get("icon-size").constantOr(0) || C.iconsNeedLinear;
                                            N = E.imageAtlasTexture, j = P || e1.options.rotating || e1.options.zooming || H || O ? d.LINEAR : d.NEAREST, F = E.imageAtlasTexture.size;
                                        }
                                        var G = ge(E, 1, e1.transform.zoom), Z = te(S.posMatrix, y, g, e1.transform, G), W = ee(S.posMatrix, y, g, e1.transform, G), Y = T && C.hasTextData(), X = "none" !== n.layout.get("icon-text-fit") && Y && C.hasIconData();
                                        v && ae(C, S.posMatrix, e1, a, Z, W, y, u);
                                        var $ = e1.translatePosMatrix(S.posMatrix, E, o, s), J = v || a && T || X ? an : Z, K = e1.translatePosMatrix(W, E, o, s, !0), Q = P && 0 !== n.paint.get(a ? "text-halo-width" : "icon-halo-width").constantOr(1), tt = {
                                            program: D,
                                            buffers: L,
                                            uniformValues: P ? C.iconsInText ? Qr(z.kind, R, x, y, e1, $, J, K, F, B) : Kr(z.kind, R, x, y, e1, $, J, K, a, F, !0) : Jr(z.kind, R, x, y, e1, $, J, K, a, F),
                                            atlasTexture: N,
                                            atlasTextureIcon: U,
                                            atlasInterpolation: j,
                                            atlasInterpolationIcon: V,
                                            isSDF: P,
                                            hasHalo: Q
                                        };
                                        if (_ && C.canOverlap) {
                                            b = !0;
                                            for(var et = 0, rt = L.segments.get(); et < rt.length; et += 1){
                                                var nt = rt[et];
                                                k.push({
                                                    segments: new t1.SegmentVector([
                                                        nt
                                                    ]),
                                                    sortKey: nt.sortKey,
                                                    state: tt
                                                });
                                            }
                                        } else k.push({
                                            segments: L.segments,
                                            sortKey: 0,
                                            state: tt
                                        });
                                    }
                                }
                            }
                            b && k.sort(function(t1, e1) {
                                return t1.sortKey - e1.sortKey;
                            });
                            for(var it = 0, at = k; it < at.length; it += 1){
                                var ot = at[it], st = ot.state;
                                if (p.activeTexture.set(d.TEXTURE0), st.atlasTexture.bind(st.atlasInterpolation, d.CLAMP_TO_EDGE), st.atlasTextureIcon && (p.activeTexture.set(d.TEXTURE1), st.atlasTextureIcon && st.atlasTextureIcon.bind(st.atlasInterpolationIcon, d.CLAMP_TO_EDGE)), st.isSDF) {
                                    var lt = st.uniformValues;
                                    st.hasHalo && (lt.u_is_halo = 1, un(st.buffers, ot.segments, n, e1, st.program, w, h, f, lt)), lt.u_is_halo = 0;
                                }
                                un(st.buffers, ot.segments, n, e1, st.program, w, h, f, st.uniformValues);
                            }
                        }
                        function un(t1, e1, r, n, i, a, o, s, l) {
                            var c = n.context, u = c.gl;
                            i.draw(c, u.TRIANGLES, a, o, s, Lt.disabled, l, r.id, t1.layoutVertexBuffer, t1.indexBuffer, e1, r.paint, n.transform.zoom, t1.programConfigurations.get(r.id), t1.dynamicLayoutVertexBuffer, t1.opacityVertexBuffer);
                        }
                        function hn(t1, e1, r, n, i, a, o) {
                            var s, l, c, u, h, f = t1.context.gl, p = r.paint.get("fill-pattern"), d = p && p.constantOr(1), m = r.getCrossfadeParameters();
                            o ? (l = d && !r.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", s = f.LINES) : (l = d ? "fillPattern" : "fill", s = f.TRIANGLES);
                            for(var g = 0, y = n; g < y.length; g += 1){
                                var v = y[g], x = e1.getTile(v);
                                if (!d || x.patternsLoaded()) {
                                    var _ = x.getBucket(r);
                                    if (_) {
                                        var b = _.programConfigurations.get(r.id), w = t1.useProgram(l, b);
                                        d && (t1.context.activeTexture.set(f.TEXTURE0), x.imageAtlasTexture.bind(f.LINEAR, f.CLAMP_TO_EDGE), b.updatePaintBuffers(m));
                                        var T = p.constantOr(null);
                                        if (T && x.imageAtlas) {
                                            var k = x.imageAtlas, A = k.patternPositions[T.to.toString()], M = k.patternPositions[T.from.toString()];
                                            A && M && b.setConstantPatternPositions(A, M);
                                        }
                                        var S = t1.translatePosMatrix(v.posMatrix, x, r.paint.get("fill-translate"), r.paint.get("fill-translate-anchor"));
                                        if (o) {
                                            u = _.indexBuffer2, h = _.segments2;
                                            var E = [
                                                f.drawingBufferWidth,
                                                f.drawingBufferHeight
                                            ];
                                            c = "fillOutlinePattern" === l && d ? Pr(S, t1, m, x, E) : Ir(S, E);
                                        } else u = _.indexBuffer, h = _.segments, c = d ? Lr(S, t1, m, x) : Cr(S);
                                        w.draw(t1.context, s, i, t1.stencilModeForClipping(v), a, Lt.disabled, c, r.id, _.layoutVertexBuffer, u, h, r.paint, t1.transform.zoom, b);
                                    }
                                }
                            }
                        }
                        function fn(t1, e1, r, n, i, a, o) {
                            for(var s = t1.context, l = s.gl, c = r.paint.get("fill-extrusion-pattern"), u = c.constantOr(1), h = r.getCrossfadeParameters(), f = r.paint.get("fill-extrusion-opacity"), p = 0, d = n; p < d.length; p += 1){
                                var m = d[p], g = e1.getTile(m), y = g.getBucket(r);
                                if (y) {
                                    var v = y.programConfigurations.get(r.id), x = t1.useProgram(u ? "fillExtrusionPattern" : "fillExtrusion", v);
                                    u && (t1.context.activeTexture.set(l.TEXTURE0), g.imageAtlasTexture.bind(l.LINEAR, l.CLAMP_TO_EDGE), v.updatePaintBuffers(h));
                                    var _ = c.constantOr(null);
                                    if (_ && g.imageAtlas) {
                                        var b = g.imageAtlas, w = b.patternPositions[_.to.toString()], T = b.patternPositions[_.from.toString()];
                                        w && T && v.setConstantPatternPositions(w, T);
                                    }
                                    var k = t1.translatePosMatrix(m.posMatrix, g, r.paint.get("fill-extrusion-translate"), r.paint.get("fill-extrusion-translate-anchor")), A = r.paint.get("fill-extrusion-vertical-gradient"), M = u ? Er(k, t1, A, f, m, h, g) : Sr(k, t1, A, f);
                                    x.draw(s, s.gl.TRIANGLES, i, a, o, Lt.backCCW, M, r.id, y.layoutVertexBuffer, y.indexBuffer, y.segments, r.paint, t1.transform.zoom, v);
                                }
                            }
                        }
                        function pn(t1, e1, r, n, i, a) {
                            var o = t1.context, s = o.gl, l = e1.fbo;
                            if (l) {
                                var c = t1.useProgram("hillshade");
                                o.activeTexture.set(s.TEXTURE0), s.bindTexture(s.TEXTURE_2D, l.colorAttachment.get());
                                var u = jr(t1, e1, r);
                                c.draw(o, s.TRIANGLES, n, i, a, Lt.disabled, u, r.id, t1.rasterBoundsBuffer, t1.quadTriangleIndexBuffer, t1.rasterBoundsSegments);
                            }
                        }
                        function dn(e1, r, n, i, a, o) {
                            var s = e1.context, l = s.gl, c = r.dem;
                            if (c && c.data) {
                                var u = c.dim, h = c.stride, f = c.getPixels();
                                if (s.activeTexture.set(l.TEXTURE1), s.pixelStoreUnpackPremultiplyAlpha.set(!1), r.demTexture = r.demTexture || e1.getTileTexture(h), r.demTexture) {
                                    var p = r.demTexture;
                                    p.update(f, {
                                        premultiply: !1
                                    }), p.bind(l.NEAREST, l.CLAMP_TO_EDGE);
                                } else r.demTexture = new t1.Texture(s, f, l.RGBA, {
                                    premultiply: !1
                                }), r.demTexture.bind(l.NEAREST, l.CLAMP_TO_EDGE);
                                s.activeTexture.set(l.TEXTURE0);
                                var d = r.fbo;
                                if (!d) {
                                    var m = new t1.Texture(s, {
                                        width: u,
                                        height: u,
                                        data: null
                                    }, l.RGBA);
                                    m.bind(l.LINEAR, l.CLAMP_TO_EDGE), (d = r.fbo = s.createFramebuffer(u, u, !0)).colorAttachment.set(m.texture);
                                }
                                s.bindFramebuffer.set(d.framebuffer), s.viewport.set([
                                    0,
                                    0,
                                    u,
                                    u
                                ]), e1.useProgram("hillshadePrepare").draw(s, l.TRIANGLES, i, a, o, Lt.disabled, Ur(r.tileID, c), n.id, e1.rasterBoundsBuffer, e1.quadTriangleIndexBuffer, e1.rasterBoundsSegments), r.needsHillshadePrepare = !1;
                            }
                        }
                        function mn(e1, r, n, i, a) {
                            var o = i.paint.get("raster-fade-duration");
                            if (o > 0) {
                                var s = t1.browser.now(), l = (s - e1.timeAdded) / o, c = r ? (s - r.timeAdded) / o : -1, u = n.getSource(), h = a.coveringZoomLevel({
                                    tileSize: u.tileSize,
                                    roundZoom: u.roundZoom
                                }), f = !r || Math.abs(r.tileID.overscaledZ - h) > Math.abs(e1.tileID.overscaledZ - h), p = f && e1.refreshedUponExpiration ? 1 : t1.clamp(f ? l : 1 - c, 0, 1);
                                return e1.refreshedUponExpiration && l >= 1 && (e1.refreshedUponExpiration = !1), r ? {
                                    opacity: 1,
                                    mix: 1 - p
                                } : {
                                    opacity: p,
                                    mix: 0
                                };
                            }
                            return {
                                opacity: 1,
                                mix: 0
                            };
                        }
                        var gn = new t1.Color(1, 0, 0, 1), yn = new t1.Color(0, 1, 0, 1), vn = new t1.Color(0, 0, 1, 1), xn = new t1.Color(1, 0, 1, 1), _n = new t1.Color(0, 1, 1, 1);
                        function bn(t1) {
                            var e1 = t1.transform.padding;
                            wn(t1, t1.transform.height - (e1.top || 0), 3, gn), wn(t1, e1.bottom || 0, 3, yn), Tn(t1, e1.left || 0, 3, vn), Tn(t1, t1.transform.width - (e1.right || 0), 3, xn);
                            var r = t1.transform.centerPoint;
                            !function(t1, e1, r, n) {
                                var i = 20, a = 2;
                                kn(t1, e1 - a / 2, r - i / 2, a, i, n), kn(t1, e1 - i / 2, r - a / 2, i, a, n);
                            }(t1, r.x, t1.transform.height - r.y, _n);
                        }
                        function wn(t1, e1, r, n) {
                            kn(t1, 0, e1 + r / 2, t1.transform.width, r, n);
                        }
                        function Tn(t1, e1, r, n) {
                            kn(t1, e1 - r / 2, 0, r, t1.transform.height, n);
                        }
                        function kn(e1, r, n, i, a, o) {
                            var s = e1.context, l = s.gl;
                            l.enable(l.SCISSOR_TEST), l.scissor(r * t1.browser.devicePixelRatio, n * t1.browser.devicePixelRatio, i * t1.browser.devicePixelRatio, a * t1.browser.devicePixelRatio), s.clear({
                                color: o
                            }), l.disable(l.SCISSOR_TEST);
                        }
                        function An(e1, r, n) {
                            var i = e1.context, a = i.gl, o = n.posMatrix, s = e1.useProgram("debug"), l = Mt.disabled, c = Et.disabled, u = e1.colorModeForRenderPass(), h = "$debug";
                            i.activeTexture.set(a.TEXTURE0), e1.emptyTexture.bind(a.LINEAR, a.CLAMP_TO_EDGE), s.draw(i, a.LINE_STRIP, l, c, u, Lt.disabled, Rr(o, t1.Color.red), h, e1.debugBuffer, e1.tileBorderIndexBuffer, e1.debugSegments);
                            var f = r.getTileByID(n.key).latestRawTileData, p = f && f.byteLength || 0, d = Math.floor(p / 1024), m = r.getTile(n).tileSize, g = 512 / Math.min(m, 512) * (n.overscaledZ / e1.transform.zoom) * .5, y = n.canonical.toString();
                            n.overscaledZ !== n.canonical.z && (y += " => " + n.overscaledZ), function(t1, e1) {
                                t1.initDebugOverlayCanvas();
                                var r = t1.debugOverlayCanvas, n = t1.context.gl, i = t1.debugOverlayCanvas.getContext("2d");
                                i.clearRect(0, 0, r.width, r.height), i.shadowColor = "white", i.shadowBlur = 2, i.lineWidth = 1.5, i.strokeStyle = "white", i.textBaseline = "top", i.font = "bold 36px Open Sans, sans-serif", i.fillText(e1, 5, 5), i.strokeText(e1, 5, 5), t1.debugOverlayTexture.update(r), t1.debugOverlayTexture.bind(n.LINEAR, n.CLAMP_TO_EDGE);
                            }(e1, y + " " + d + "kb"), s.draw(i, a.TRIANGLES, l, c, Ct.alphaBlended, Lt.disabled, Rr(o, t1.Color.transparent, g), h, e1.debugBuffer, e1.quadTriangleIndexBuffer, e1.debugSegments);
                        }
                        var Mn = {
                            symbol: function(e1, r, n, i, a) {
                                if ("translucent" === e1.renderPass) {
                                    var o = Et.disabled, s = e1.colorModeForRenderPass();
                                    n.layout.get("text-variable-anchor") && function(e1, r, n, i, a, o, s) {
                                        for(var l = r.transform, c = "map" === a, u = "map" === o, h = 0, f = e1; h < f.length; h += 1){
                                            var p = f[h], d = i.getTile(p), m = d.getBucket(n);
                                            if (m && m.text && m.text.segments.get().length) {
                                                var g = m.textSizeData, y = t1.evaluateSizeForZoom(g, l.zoom), v = ge(d, 1, r.transform.zoom), x = te(p.posMatrix, u, c, r.transform, v), _ = "none" !== n.layout.get("icon-text-fit") && m.hasIconData();
                                                if (y) {
                                                    var b = Math.pow(2, l.zoom - d.tileID.overscaledZ);
                                                    sn(m, c, u, s, t1.symbolSize, l, x, p.posMatrix, b, y, _);
                                                }
                                            }
                                        }
                                    }(i, e1, n, r, n.layout.get("text-rotation-alignment"), n.layout.get("text-pitch-alignment"), a), 0 !== n.paint.get("icon-opacity").constantOr(1) && cn(e1, r, n, i, !1, n.paint.get("icon-translate"), n.paint.get("icon-translate-anchor"), n.layout.get("icon-rotation-alignment"), n.layout.get("icon-pitch-alignment"), n.layout.get("icon-keep-upright"), o, s), 0 !== n.paint.get("text-opacity").constantOr(1) && cn(e1, r, n, i, !0, n.paint.get("text-translate"), n.paint.get("text-translate-anchor"), n.layout.get("text-rotation-alignment"), n.layout.get("text-pitch-alignment"), n.layout.get("text-keep-upright"), o, s), r.map.showCollisionBoxes && (nn(e1, r, n, i, n.paint.get("text-translate"), n.paint.get("text-translate-anchor"), !0), nn(e1, r, n, i, n.paint.get("icon-translate"), n.paint.get("icon-translate-anchor"), !1));
                                }
                            },
                            circle: function(e1, r, n, i) {
                                if ("translucent" === e1.renderPass) {
                                    var a = n.paint.get("circle-opacity"), o = n.paint.get("circle-stroke-width"), s = n.paint.get("circle-stroke-opacity"), l = void 0 !== n.layout.get("circle-sort-key").constantOr(1);
                                    if (0 !== a.constantOr(1) || 0 !== o.constantOr(1) && 0 !== s.constantOr(1)) {
                                        for(var c = e1.context, u = c.gl, h = e1.depthModeForSublayer(0, Mt.ReadOnly), f = Et.disabled, p = e1.colorModeForRenderPass(), d = [], m = 0; m < i.length; m++){
                                            var g = i[m], y = r.getTile(g), v = y.getBucket(n);
                                            if (v) {
                                                var x = v.programConfigurations.get(n.id), _ = {
                                                    programConfiguration: x,
                                                    program: e1.useProgram("circle", x),
                                                    layoutVertexBuffer: v.layoutVertexBuffer,
                                                    indexBuffer: v.indexBuffer,
                                                    uniformValues: zr(e1, g, y, n)
                                                };
                                                if (l) for(var b = 0, w = v.segments.get(); b < w.length; b += 1){
                                                    var T = w[b];
                                                    d.push({
                                                        segments: new t1.SegmentVector([
                                                            T
                                                        ]),
                                                        sortKey: T.sortKey,
                                                        state: _
                                                    });
                                                }
                                                else d.push({
                                                    segments: v.segments,
                                                    sortKey: 0,
                                                    state: _
                                                });
                                            }
                                        }
                                        l && d.sort(function(t1, e1) {
                                            return t1.sortKey - e1.sortKey;
                                        });
                                        for(var k = 0, A = d; k < A.length; k += 1){
                                            var M = A[k], S = M.state, E = S.programConfiguration, C = S.program, L = S.layoutVertexBuffer, I = S.indexBuffer, P = S.uniformValues, z = M.segments;
                                            C.draw(c, u.TRIANGLES, h, f, p, Lt.disabled, P, n.id, L, I, z, n.paint, e1.transform.zoom, E);
                                        }
                                    }
                                }
                            },
                            heatmap: function(e1, r, n, i) {
                                if (0 !== n.paint.get("heatmap-opacity")) {
                                    if ("offscreen" === e1.renderPass) {
                                        var a = e1.context, o = a.gl, s = Et.disabled, l = new Ct([
                                            o.ONE,
                                            o.ONE
                                        ], t1.Color.transparent, [
                                            !0,
                                            !0,
                                            !0,
                                            !0
                                        ]);
                                        (function(t1, e1, r) {
                                            var n = t1.gl;
                                            t1.activeTexture.set(n.TEXTURE1), t1.viewport.set([
                                                0,
                                                0,
                                                e1.width / 4,
                                                e1.height / 4
                                            ]);
                                            var i = r.heatmapFbo;
                                            if (i) n.bindTexture(n.TEXTURE_2D, i.colorAttachment.get()), t1.bindFramebuffer.set(i.framebuffer);
                                            else {
                                                var a = n.createTexture();
                                                n.bindTexture(n.TEXTURE_2D, a), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_S, n.CLAMP_TO_EDGE), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_T, n.CLAMP_TO_EDGE), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, n.LINEAR), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MAG_FILTER, n.LINEAR), i = r.heatmapFbo = t1.createFramebuffer(e1.width / 4, e1.height / 4, !1), function(t1, e1, r, n) {
                                                    var i = t1.gl, a = t1.extRenderToTextureHalfFloat ? t1.extTextureHalfFloat.HALF_FLOAT_OES : i.UNSIGNED_BYTE;
                                                    i.texImage2D(i.TEXTURE_2D, 0, i.RGBA, e1.width / 4, e1.height / 4, 0, i.RGBA, a, null), n.colorAttachment.set(r);
                                                }(t1, e1, a, i);
                                            }
                                        })(a, e1, n), a.clear({
                                            color: t1.Color.transparent
                                        });
                                        for(var c = 0; c < i.length; c++){
                                            var u = i[c];
                                            if (!r.hasRenderableParent(u)) {
                                                var h = r.getTile(u), f = h.getBucket(n);
                                                if (f) {
                                                    var p = f.programConfigurations.get(n.id), d = e1.useProgram("heatmap", p), m = e1.transform.zoom;
                                                    d.draw(a, o.TRIANGLES, Mt.disabled, s, l, Lt.disabled, Br(u.posMatrix, h, m, n.paint.get("heatmap-intensity")), n.id, f.layoutVertexBuffer, f.indexBuffer, f.segments, n.paint, e1.transform.zoom, p);
                                                }
                                            }
                                        }
                                        a.viewport.set([
                                            0,
                                            0,
                                            e1.width,
                                            e1.height
                                        ]);
                                    } else "translucent" === e1.renderPass && (e1.context.setColorMode(e1.colorModeForRenderPass()), function(e1, r) {
                                        var n = e1.context, i = n.gl, a = r.heatmapFbo;
                                        if (a) {
                                            n.activeTexture.set(i.TEXTURE0), i.bindTexture(i.TEXTURE_2D, a.colorAttachment.get()), n.activeTexture.set(i.TEXTURE1);
                                            var o = r.colorRampTexture;
                                            o || (o = r.colorRampTexture = new t1.Texture(n, r.colorRamp, i.RGBA)), o.bind(i.LINEAR, i.CLAMP_TO_EDGE), e1.useProgram("heatmapTexture").draw(n, i.TRIANGLES, Mt.disabled, Et.disabled, e1.colorModeForRenderPass(), Lt.disabled, Nr(e1, r, 0, 1), r.id, e1.viewportBuffer, e1.quadTriangleIndexBuffer, e1.viewportSegments, r.paint, e1.transform.zoom);
                                        }
                                    }(e1, n));
                                }
                            },
                            line: function(e1, r, n, i) {
                                if ("translucent" === e1.renderPass) {
                                    var a = n.paint.get("line-opacity"), o = n.paint.get("line-width");
                                    if (0 !== a.constantOr(1) && 0 !== o.constantOr(1)) for(var s = e1.depthModeForSublayer(0, Mt.ReadOnly), l = e1.colorModeForRenderPass(), c = n.paint.get("line-dasharray"), u = n.paint.get("line-pattern"), h = u.constantOr(1), f = n.paint.get("line-gradient"), p = n.getCrossfadeParameters(), d = h ? "linePattern" : c ? "lineSDF" : f ? "lineGradient" : "line", m = e1.context, g = m.gl, y = !0, v = 0, x = i; v < x.length; v += 1){
                                        var _ = x[v], b = r.getTile(_);
                                        if (!h || b.patternsLoaded()) {
                                            var w = b.getBucket(n);
                                            if (w) {
                                                var T = w.programConfigurations.get(n.id), k = e1.context.program.get(), A = e1.useProgram(d, T), M = y || A.program !== k, S = u.constantOr(null);
                                                if (S && b.imageAtlas) {
                                                    var E = b.imageAtlas, C = E.patternPositions[S.to.toString()], L = E.patternPositions[S.from.toString()];
                                                    C && L && T.setConstantPatternPositions(C, L);
                                                }
                                                var I = h ? Hr(e1, b, n, p) : c ? Gr(e1, b, n, c, p) : f ? qr(e1, b, n, w.lineClipsArray.length) : Vr(e1, b, n);
                                                if (h) m.activeTexture.set(g.TEXTURE0), b.imageAtlasTexture.bind(g.LINEAR, g.CLAMP_TO_EDGE), T.updatePaintBuffers(p);
                                                else if (c && (M || e1.lineAtlas.dirty)) m.activeTexture.set(g.TEXTURE0), e1.lineAtlas.bind(m);
                                                else if (f) {
                                                    var P = w.gradients[n.id], z = P.texture;
                                                    if (n.gradientVersion !== P.version) {
                                                        var O = 256;
                                                        if (n.stepInterpolant) {
                                                            var D = r.getSource().maxzoom, R = _.canonical.z === D ? Math.ceil(1 << e1.transform.maxZoom - _.canonical.z) : 1, F = w.maxLineLength / t1.EXTENT * 1024 * R;
                                                            O = t1.clamp(t1.nextPowerOfTwo(F), 256, m.maxTextureSize);
                                                        }
                                                        P.gradient = t1.renderColorRamp({
                                                            expression: n.gradientExpression(),
                                                            evaluationKey: "lineProgress",
                                                            resolution: O,
                                                            image: P.gradient || void 0,
                                                            clips: w.lineClipsArray
                                                        }), P.texture ? P.texture.update(P.gradient) : P.texture = new t1.Texture(m, P.gradient, g.RGBA), P.version = n.gradientVersion, z = P.texture;
                                                    }
                                                    m.activeTexture.set(g.TEXTURE0), z.bind(n.stepInterpolant ? g.NEAREST : g.LINEAR, g.CLAMP_TO_EDGE);
                                                }
                                                A.draw(m, g.TRIANGLES, s, e1.stencilModeForClipping(_), l, Lt.disabled, I, n.id, w.layoutVertexBuffer, w.indexBuffer, w.segments, n.paint, e1.transform.zoom, T, w.layoutVertexBuffer2), y = !1;
                                            }
                                        }
                                    }
                                }
                            },
                            fill: function(e1, r, n, i) {
                                var a = n.paint.get("fill-color"), o = n.paint.get("fill-opacity");
                                if (0 !== o.constantOr(1)) {
                                    var s = e1.colorModeForRenderPass(), l = n.paint.get("fill-pattern"), c = e1.opaquePassEnabledForLayer() && !l.constantOr(1) && 1 === a.constantOr(t1.Color.transparent).a && 1 === o.constantOr(0) ? "opaque" : "translucent";
                                    if (e1.renderPass === c) {
                                        var u = e1.depthModeForSublayer(1, "opaque" === e1.renderPass ? Mt.ReadWrite : Mt.ReadOnly);
                                        hn(e1, r, n, i, u, s, !1);
                                    }
                                    if ("translucent" === e1.renderPass && n.paint.get("fill-antialias")) {
                                        var h = e1.depthModeForSublayer(n.getPaintProperty("fill-outline-color") ? 2 : 0, Mt.ReadOnly);
                                        hn(e1, r, n, i, h, s, !0);
                                    }
                                }
                            },
                            "fill-extrusion": function(t1, e1, r, n) {
                                var i = r.paint.get("fill-extrusion-opacity");
                                if (0 !== i && "translucent" === t1.renderPass) {
                                    var a = new Mt(t1.context.gl.LEQUAL, Mt.ReadWrite, t1.depthRangeFor3D);
                                    if (1 !== i || r.paint.get("fill-extrusion-pattern").constantOr(1)) fn(t1, e1, r, n, a, Et.disabled, Ct.disabled), fn(t1, e1, r, n, a, t1.stencilModeFor3D(), t1.colorModeForRenderPass());
                                    else {
                                        var o = t1.colorModeForRenderPass();
                                        fn(t1, e1, r, n, a, Et.disabled, o);
                                    }
                                }
                            },
                            hillshade: function(t1, e1, r, n) {
                                if ("offscreen" === t1.renderPass || "translucent" === t1.renderPass) {
                                    for(var i = t1.context, a = t1.depthModeForSublayer(0, Mt.ReadOnly), o = t1.colorModeForRenderPass(), s = "translucent" === t1.renderPass ? t1.stencilConfigForOverlap(n) : [
                                        {},
                                        n
                                    ], l = s[0], c = 0, u = s[1]; c < u.length; c += 1){
                                        var h = u[c], f = e1.getTile(h);
                                        f.needsHillshadePrepare && "offscreen" === t1.renderPass ? dn(t1, f, r, a, Et.disabled, o) : "translucent" === t1.renderPass && pn(t1, f, r, a, l[h.overscaledZ], o);
                                    }
                                    i.viewport.set([
                                        0,
                                        0,
                                        t1.width,
                                        t1.height
                                    ]);
                                }
                            },
                            raster: function(t1, e1, r, n) {
                                if ("translucent" === t1.renderPass && 0 !== r.paint.get("raster-opacity") && n.length) for(var i = t1.context, a = i.gl, o = e1.getSource(), s = t1.useProgram("raster"), l = t1.colorModeForRenderPass(), c = o instanceof z ? [
                                    {},
                                    n
                                ] : t1.stencilConfigForOverlap(n), u = c[0], h = c[1], f = h[h.length - 1].overscaledZ, p = !t1.options.moving, d = 0, m = h; d < m.length; d += 1){
                                    var g = m[d], y = t1.depthModeForSublayer(g.overscaledZ - f, 1 === r.paint.get("raster-opacity") ? Mt.ReadWrite : Mt.ReadOnly, a.LESS), v = e1.getTile(g), x = t1.transform.calculatePosMatrix(g.toUnwrapped(), p);
                                    v.registerFadeDuration(r.paint.get("raster-fade-duration"));
                                    var _ = e1.findLoadedParent(g, 0), b = mn(v, _, e1, r, t1.transform), w = void 0, T = void 0, k = "nearest" === r.paint.get("raster-resampling") ? a.NEAREST : a.LINEAR;
                                    i.activeTexture.set(a.TEXTURE0), v.texture.bind(k, a.CLAMP_TO_EDGE, a.LINEAR_MIPMAP_NEAREST), i.activeTexture.set(a.TEXTURE1), _ ? (_.texture.bind(k, a.CLAMP_TO_EDGE, a.LINEAR_MIPMAP_NEAREST), w = Math.pow(2, _.tileID.overscaledZ - v.tileID.overscaledZ), T = [
                                        v.tileID.canonical.x * w % 1,
                                        v.tileID.canonical.y * w % 1
                                    ]) : v.texture.bind(k, a.CLAMP_TO_EDGE, a.LINEAR_MIPMAP_NEAREST);
                                    var A = Yr(x, T || [
                                        0,
                                        0
                                    ], w || 1, b, r);
                                    o instanceof z ? s.draw(i, a.TRIANGLES, y, Et.disabled, l, Lt.disabled, A, r.id, o.boundsBuffer, t1.quadTriangleIndexBuffer, o.boundsSegments) : s.draw(i, a.TRIANGLES, y, u[g.overscaledZ], l, Lt.disabled, A, r.id, t1.rasterBoundsBuffer, t1.quadTriangleIndexBuffer, t1.rasterBoundsSegments);
                                }
                            },
                            background: function(t1, e1, r) {
                                var n = r.paint.get("background-color"), i = r.paint.get("background-opacity");
                                if (0 !== i) {
                                    var a = t1.context, o = a.gl, s = t1.transform, l = s.tileSize, c = r.paint.get("background-pattern");
                                    if (!t1.isPatternMissing(c)) {
                                        var u = !c && 1 === n.a && 1 === i && t1.opaquePassEnabledForLayer() ? "opaque" : "translucent";
                                        if (t1.renderPass === u) {
                                            var h = Et.disabled, f = t1.depthModeForSublayer(0, "opaque" === u ? Mt.ReadWrite : Mt.ReadOnly), p = t1.colorModeForRenderPass(), d = t1.useProgram(c ? "backgroundPattern" : "background"), m = s.coveringTiles({
                                                tileSize: l
                                            });
                                            c && (a.activeTexture.set(o.TEXTURE0), t1.imageManager.bind(t1.context));
                                            for(var g = r.getCrossfadeParameters(), y = 0, v = m; y < v.length; y += 1){
                                                var x = v[y], _ = t1.transform.calculatePosMatrix(x.toUnwrapped()), b = c ? en(_, i, t1, c, {
                                                    tileID: x,
                                                    tileSize: l
                                                }, g) : tn(_, i, n);
                                                d.draw(a, o.TRIANGLES, f, h, p, Lt.disabled, b, r.id, t1.tileExtentBuffer, t1.quadTriangleIndexBuffer, t1.tileExtentSegments);
                                            }
                                        }
                                    }
                                }
                            },
                            debug: function(t1, e1, r) {
                                for(var n = 0; n < r.length; n++)An(t1, e1, r[n]);
                            },
                            custom: function(t1, e1, r) {
                                var n = t1.context, i = r.implementation;
                                if ("offscreen" === t1.renderPass) {
                                    var a = i.prerender;
                                    a && (t1.setCustomLayerDefaults(), n.setColorMode(t1.colorModeForRenderPass()), a.call(i, n.gl, t1.transform.customLayerMatrix()), n.setDirty(), t1.setBaseState());
                                } else if ("translucent" === t1.renderPass) {
                                    t1.setCustomLayerDefaults(), n.setColorMode(t1.colorModeForRenderPass()), n.setStencilMode(Et.disabled);
                                    var o = "3d" === i.renderingMode ? new Mt(t1.context.gl.LEQUAL, Mt.ReadWrite, t1.depthRangeFor3D) : t1.depthModeForSublayer(0, Mt.ReadOnly);
                                    n.setDepthMode(o), i.render(n.gl, t1.transform.customLayerMatrix()), n.setDirty(), t1.setBaseState(), n.bindFramebuffer.set(null);
                                }
                            }
                        }, Sn = function(t1, e1) {
                            this.context = new It(t1), this.transform = e1, this._tileTextures = {}, this.setup(), this.numSublayers = Pt.maxUnderzooming + Pt.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.crossTileSymbolIndex = new Ve, this.gpuTimers = {};
                        };
                        Sn.prototype.resize = function(e1, r) {
                            if (this.width = e1 * t1.browser.devicePixelRatio, this.height = r * t1.browser.devicePixelRatio, this.context.viewport.set([
                                0,
                                0,
                                this.width,
                                this.height
                            ]), this.style) for(var n = 0, i = this.style._order; n < i.length; n += 1){
                                var a = i[n];
                                this.style._layers[a].resize();
                            }
                        }, Sn.prototype.setup = function() {
                            var e1 = this.context, r = new t1.StructArrayLayout2i4;
                            r.emplaceBack(0, 0), r.emplaceBack(t1.EXTENT, 0), r.emplaceBack(0, t1.EXTENT), r.emplaceBack(t1.EXTENT, t1.EXTENT), this.tileExtentBuffer = e1.createVertexBuffer(r, Ye.members), this.tileExtentSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2);
                            var n = new t1.StructArrayLayout2i4;
                            n.emplaceBack(0, 0), n.emplaceBack(t1.EXTENT, 0), n.emplaceBack(0, t1.EXTENT), n.emplaceBack(t1.EXTENT, t1.EXTENT), this.debugBuffer = e1.createVertexBuffer(n, Ye.members), this.debugSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 5);
                            var i = new t1.StructArrayLayout4i8;
                            i.emplaceBack(0, 0, 0, 0), i.emplaceBack(t1.EXTENT, 0, t1.EXTENT, 0), i.emplaceBack(0, t1.EXTENT, 0, t1.EXTENT), i.emplaceBack(t1.EXTENT, t1.EXTENT, t1.EXTENT, t1.EXTENT), this.rasterBoundsBuffer = e1.createVertexBuffer(i, P.members), this.rasterBoundsSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2);
                            var a = new t1.StructArrayLayout2i4;
                            a.emplaceBack(0, 0), a.emplaceBack(1, 0), a.emplaceBack(0, 1), a.emplaceBack(1, 1), this.viewportBuffer = e1.createVertexBuffer(a, Ye.members), this.viewportSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2);
                            var o = new t1.StructArrayLayout1ui2;
                            o.emplaceBack(0), o.emplaceBack(1), o.emplaceBack(3), o.emplaceBack(2), o.emplaceBack(0), this.tileBorderIndexBuffer = e1.createIndexBuffer(o);
                            var s = new t1.StructArrayLayout3ui6;
                            s.emplaceBack(0, 1, 2), s.emplaceBack(2, 1, 3), this.quadTriangleIndexBuffer = e1.createIndexBuffer(s), this.emptyTexture = new t1.Texture(e1, {
                                width: 1,
                                height: 1,
                                data: new Uint8Array([
                                    0,
                                    0,
                                    0,
                                    0
                                ])
                            }, e1.gl.RGBA);
                            var l = this.context.gl;
                            this.stencilClearMode = new Et({
                                func: l.ALWAYS,
                                mask: 0
                            }, 0, 255, l.ZERO, l.ZERO, l.ZERO);
                        }, Sn.prototype.clearStencil = function() {
                            var e1 = this.context, r = e1.gl;
                            this.nextStencilID = 1, this.currentStencilSource = void 0;
                            var n = t1.create();
                            t1.ortho(n, 0, this.width, this.height, 0, 0, 1), t1.scale(n, n, [
                                r.drawingBufferWidth,
                                r.drawingBufferHeight,
                                0
                            ]), this.useProgram("clippingMask").draw(e1, r.TRIANGLES, Mt.disabled, this.stencilClearMode, Ct.disabled, Lt.disabled, Fr(n), "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
                        }, Sn.prototype._renderTileClippingMasks = function(t1, e1) {
                            if (this.currentStencilSource !== t1.source && t1.isTileClipped() && e1 && e1.length) {
                                this.currentStencilSource = t1.source;
                                var r = this.context, n = r.gl;
                                this.nextStencilID + e1.length > 256 && this.clearStencil(), r.setColorMode(Ct.disabled), r.setDepthMode(Mt.disabled);
                                var i = this.useProgram("clippingMask");
                                this._tileClippingMaskIDs = {};
                                for(var a = 0, o = e1; a < o.length; a += 1){
                                    var s = o[a], l = this._tileClippingMaskIDs[s.key] = this.nextStencilID++;
                                    i.draw(r, n.TRIANGLES, Mt.disabled, new Et({
                                        func: n.ALWAYS,
                                        mask: 0
                                    }, l, 255, n.KEEP, n.KEEP, n.REPLACE), Ct.disabled, Lt.disabled, Fr(s.posMatrix), "$clipping", this.tileExtentBuffer, this.quadTriangleIndexBuffer, this.tileExtentSegments);
                                }
                            }
                        }, Sn.prototype.stencilModeFor3D = function() {
                            this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
                            var t1 = this.nextStencilID++, e1 = this.context.gl;
                            return new Et({
                                func: e1.NOTEQUAL,
                                mask: 255
                            }, t1, 255, e1.KEEP, e1.KEEP, e1.REPLACE);
                        }, Sn.prototype.stencilModeForClipping = function(t1) {
                            var e1 = this.context.gl;
                            return new Et({
                                func: e1.EQUAL,
                                mask: 255
                            }, this._tileClippingMaskIDs[t1.key], 0, e1.KEEP, e1.KEEP, e1.REPLACE);
                        }, Sn.prototype.stencilConfigForOverlap = function(t1) {
                            var e1, r = this.context.gl, n = t1.sort(function(t1, e1) {
                                return e1.overscaledZ - t1.overscaledZ;
                            }), i = n[n.length - 1].overscaledZ, a = n[0].overscaledZ - i + 1;
                            if (a > 1) {
                                this.currentStencilSource = void 0, this.nextStencilID + a > 256 && this.clearStencil();
                                for(var o = {}, s = 0; s < a; s++)o[s + i] = new Et({
                                    func: r.GEQUAL,
                                    mask: 255
                                }, s + this.nextStencilID, 255, r.KEEP, r.KEEP, r.REPLACE);
                                return this.nextStencilID += a, [
                                    o,
                                    n
                                ];
                            }
                            return [
                                (e1 = {}, e1[i] = Et.disabled, e1),
                                n
                            ];
                        }, Sn.prototype.colorModeForRenderPass = function() {
                            var e1 = this.context.gl;
                            if (this._showOverdrawInspector) {
                                var r = 1 / 8;
                                return new Ct([
                                    e1.CONSTANT_COLOR,
                                    e1.ONE
                                ], new t1.Color(r, r, r, 0), [
                                    !0,
                                    !0,
                                    !0,
                                    !0
                                ]);
                            }
                            return "opaque" === this.renderPass ? Ct.unblended : Ct.alphaBlended;
                        }, Sn.prototype.depthModeForSublayer = function(t1, e1, r) {
                            if (!this.opaquePassEnabledForLayer()) return Mt.disabled;
                            var n = 1 - ((1 + this.currentLayer) * this.numSublayers + t1) * this.depthEpsilon;
                            return new Mt(r || this.context.gl.LEQUAL, e1, [
                                n,
                                n
                            ]);
                        }, Sn.prototype.opaquePassEnabledForLayer = function() {
                            return this.currentLayer < this.opaquePassCutoff;
                        }, Sn.prototype.render = function(e1, r) {
                            var n = this;
                            this.style = e1, this.options = r, this.lineAtlas = e1.lineAtlas, this.imageManager = e1.imageManager, this.glyphManager = e1.glyphManager, this.symbolFadeChange = e1.placement.symbolFadeChange(t1.browser.now()), this.imageManager.beginFrame();
                            var i = this.style._order, a = this.style.sourceCaches;
                            for(var o in a){
                                var s = a[o];
                                s.used && s.prepare(this.context);
                            }
                            var l, c, u = {}, h = {}, f = {};
                            for(var p in a){
                                var d = a[p];
                                u[p] = d.getVisibleCoordinates(), h[p] = u[p].slice().reverse(), f[p] = d.getVisibleCoordinates(!0).reverse();
                            }
                            this.opaquePassCutoff = 1 / 0;
                            for(var m = 0; m < i.length; m++){
                                var g = i[m];
                                if (this.style._layers[g].is3D()) {
                                    this.opaquePassCutoff = m;
                                    break;
                                }
                            }
                            this.renderPass = "offscreen";
                            for(var y = 0, v = i; y < v.length; y += 1){
                                var x = v[y], _ = this.style._layers[x];
                                if (_.hasOffscreenPass() && !_.isHidden(this.transform.zoom)) {
                                    var b = h[_.source];
                                    ("custom" === _.type || b.length) && this.renderLayer(this, a[_.source], _, b);
                                }
                            }
                            for(this.context.bindFramebuffer.set(null), this.context.clear({
                                color: r.showOverdrawInspector ? t1.Color.black : t1.Color.transparent,
                                depth: 1
                            }), this.clearStencil(), this._showOverdrawInspector = r.showOverdrawInspector, this.depthRangeFor3D = [
                                0,
                                1 - (e1._order.length + 2) * this.numSublayers * this.depthEpsilon
                            ], this.renderPass = "opaque", this.currentLayer = i.length - 1; this.currentLayer >= 0; this.currentLayer--){
                                var w = this.style._layers[i[this.currentLayer]], T = a[w.source], k = u[w.source];
                                this._renderTileClippingMasks(w, k), this.renderLayer(this, T, w, k);
                            }
                            for(this.renderPass = "translucent", this.currentLayer = 0; this.currentLayer < i.length; this.currentLayer++){
                                var A = this.style._layers[i[this.currentLayer]], M = a[A.source], S = ("symbol" === A.type ? f : h)[A.source];
                                this._renderTileClippingMasks(A, u[A.source]), this.renderLayer(this, M, A, S);
                            }
                            this.options.showTileBoundaries && (t1.values(this.style._layers).forEach(function(t1) {
                                t1.source && !t1.isHidden(n.transform.zoom) && (t1.source !== (c && c.id) && (c = n.style.sourceCaches[t1.source]), (!l || l.getSource().maxzoom < c.getSource().maxzoom) && (l = c));
                            }), l && Mn.debug(this, l, l.getVisibleCoordinates())), this.options.showPadding && bn(this), this.context.setDefault();
                        }, Sn.prototype.renderLayer = function(t1, e1, r, n) {
                            r.isHidden(this.transform.zoom) || ("background" === r.type || "custom" === r.type || n.length) && (this.id = r.id, this.gpuTimingStart(r), Mn[r.type](t1, e1, r, n, this.style.placement.variableOffsets), this.gpuTimingEnd());
                        }, Sn.prototype.gpuTimingStart = function(t1) {
                            if (this.options.gpuTiming) {
                                var e1 = this.context.extTimerQuery, r = this.gpuTimers[t1.id];
                                r || (r = this.gpuTimers[t1.id] = {
                                    calls: 0,
                                    cpuTime: 0,
                                    query: e1.createQueryEXT()
                                }), r.calls++, e1.beginQueryEXT(e1.TIME_ELAPSED_EXT, r.query);
                            }
                        }, Sn.prototype.gpuTimingEnd = function() {
                            if (this.options.gpuTiming) {
                                var t1 = this.context.extTimerQuery;
                                t1.endQueryEXT(t1.TIME_ELAPSED_EXT);
                            }
                        }, Sn.prototype.collectGpuTimers = function() {
                            var t1 = this.gpuTimers;
                            return this.gpuTimers = {}, t1;
                        }, Sn.prototype.queryGpuTimers = function(t1) {
                            var e1 = {};
                            for(var r in t1){
                                var n = t1[r], i = this.context.extTimerQuery, a = i.getQueryObjectEXT(n.query, i.QUERY_RESULT_EXT) / 1e6;
                                i.deleteQueryEXT(n.query), e1[r] = a;
                            }
                            return e1;
                        }, Sn.prototype.translatePosMatrix = function(e1, r, n, i, a) {
                            if (!n[0] && !n[1]) return e1;
                            var o = a ? "map" === i ? this.transform.angle : 0 : "viewport" === i ? -this.transform.angle : 0;
                            if (o) {
                                var s = Math.sin(o), l = Math.cos(o);
                                n = [
                                    n[0] * l - n[1] * s,
                                    n[0] * s + n[1] * l
                                ];
                            }
                            var c = [
                                a ? n[0] : ge(r, n[0], this.transform.zoom),
                                a ? n[1] : ge(r, n[1], this.transform.zoom),
                                0
                            ], u = new Float32Array(16);
                            return t1.translate(u, e1, c), u;
                        }, Sn.prototype.saveTileTexture = function(t1) {
                            var e1 = this._tileTextures[t1.size[0]];
                            e1 ? e1.push(t1) : this._tileTextures[t1.size[0]] = [
                                t1
                            ];
                        }, Sn.prototype.getTileTexture = function(t1) {
                            var e1 = this._tileTextures[t1];
                            return e1 && e1.length > 0 ? e1.pop() : null;
                        }, Sn.prototype.isPatternMissing = function(t1) {
                            if (!t1) return !1;
                            if (!t1.from || !t1.to) return !0;
                            var e1 = this.imageManager.getPattern(t1.from.toString()), r = this.imageManager.getPattern(t1.to.toString());
                            return !e1 || !r;
                        }, Sn.prototype.useProgram = function(t1, e1) {
                            this.cache = this.cache || {};
                            var r = "" + t1 + (e1 ? e1.cacheKey : "") + (this._showOverdrawInspector ? "/overdraw" : "");
                            return this.cache[r] || (this.cache[r] = new Ar(this.context, t1, wr[t1], e1, rn[t1], this._showOverdrawInspector)), this.cache[r];
                        }, Sn.prototype.setCustomLayerDefaults = function() {
                            this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
                        }, Sn.prototype.setBaseState = function() {
                            var t1 = this.context.gl;
                            this.context.cullFace.set(!1), this.context.viewport.set([
                                0,
                                0,
                                this.width,
                                this.height
                            ]), this.context.blendEquation.set(t1.FUNC_ADD);
                        }, Sn.prototype.initDebugOverlayCanvas = function() {
                            if (null == this.debugOverlayCanvas) {
                                this.debugOverlayCanvas = t1.window.document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512;
                                var e1 = this.context.gl;
                                this.debugOverlayTexture = new t1.Texture(this.context, this.debugOverlayCanvas, e1.RGBA);
                            }
                        }, Sn.prototype.destroy = function() {
                            this.emptyTexture.destroy(), this.debugOverlayTexture && this.debugOverlayTexture.destroy();
                        };
                        var En = function(t1, e1) {
                            this.points = t1, this.planes = e1;
                        };
                        En.fromInvProjectionMatrix = function(e1, r, n) {
                            var i = Math.pow(2, n), a = [
                                [
                                    -1,
                                    1,
                                    -1,
                                    1
                                ],
                                [
                                    1,
                                    1,
                                    -1,
                                    1
                                ],
                                [
                                    1,
                                    -1,
                                    -1,
                                    1
                                ],
                                [
                                    -1,
                                    -1,
                                    -1,
                                    1
                                ],
                                [
                                    -1,
                                    1,
                                    1,
                                    1
                                ],
                                [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                [
                                    1,
                                    -1,
                                    1,
                                    1
                                ],
                                [
                                    -1,
                                    -1,
                                    1,
                                    1
                                ]
                            ].map(function(r) {
                                return t1.transformMat4([], r, e1);
                            }).map(function(e1) {
                                return t1.scale$1([], e1, 1 / e1[3] / r * i);
                            }), o = [
                                [
                                    0,
                                    1,
                                    2
                                ],
                                [
                                    6,
                                    5,
                                    4
                                ],
                                [
                                    0,
                                    3,
                                    7
                                ],
                                [
                                    2,
                                    1,
                                    5
                                ],
                                [
                                    3,
                                    2,
                                    6
                                ],
                                [
                                    0,
                                    4,
                                    5
                                ]
                            ].map(function(e1) {
                                var r = t1.sub([], a[e1[0]], a[e1[1]]), n = t1.sub([], a[e1[2]], a[e1[1]]), i = t1.normalize([], t1.cross([], r, n)), o = -t1.dot(i, a[e1[1]]);
                                return i.concat(o);
                            });
                            return new En(a, o);
                        };
                        var Cn = function(e1, r) {
                            this.min = e1, this.max = r, this.center = t1.scale$2([], t1.add([], this.min, this.max), .5);
                        };
                        Cn.prototype.quadrant = function(e1) {
                            for(var r = [
                                e1 % 2 == 0,
                                e1 < 2
                            ], n = t1.clone$2(this.min), i = t1.clone$2(this.max), a = 0; a < r.length; a++)n[a] = r[a] ? this.min[a] : this.center[a], i[a] = r[a] ? this.center[a] : this.max[a];
                            return i[2] = this.max[2], new Cn(n, i);
                        }, Cn.prototype.distanceX = function(t1) {
                            return Math.max(Math.min(this.max[0], t1[0]), this.min[0]) - t1[0];
                        }, Cn.prototype.distanceY = function(t1) {
                            return Math.max(Math.min(this.max[1], t1[1]), this.min[1]) - t1[1];
                        }, Cn.prototype.intersects = function(e1) {
                            for(var r = [
                                [
                                    this.min[0],
                                    this.min[1],
                                    0,
                                    1
                                ],
                                [
                                    this.max[0],
                                    this.min[1],
                                    0,
                                    1
                                ],
                                [
                                    this.max[0],
                                    this.max[1],
                                    0,
                                    1
                                ],
                                [
                                    this.min[0],
                                    this.max[1],
                                    0,
                                    1
                                ]
                            ], n = !0, i = 0; i < e1.planes.length; i++){
                                for(var a = e1.planes[i], o = 0, s = 0; s < r.length; s++)o += t1.dot$1(a, r[s]) >= 0;
                                if (0 === o) return 0;
                                o !== r.length && (n = !1);
                            }
                            if (n) return 2;
                            for(var l = 0; l < 3; l++){
                                for(var c = Number.MAX_VALUE, u = -Number.MAX_VALUE, h = 0; h < e1.points.length; h++){
                                    var f = e1.points[h][l] - this.min[l];
                                    c = Math.min(c, f), u = Math.max(u, f);
                                }
                                if (u < 0 || c > this.max[l] - this.min[l]) return 0;
                            }
                            return 1;
                        };
                        var Ln = function(t1, e1, r, n) {
                            if (void 0 === t1 && (t1 = 0), void 0 === e1 && (e1 = 0), void 0 === r && (r = 0), void 0 === n && (n = 0), isNaN(t1) || t1 < 0 || isNaN(e1) || e1 < 0 || isNaN(r) || r < 0 || isNaN(n) || n < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
                            this.top = t1, this.bottom = e1, this.left = r, this.right = n;
                        };
                        Ln.prototype.interpolate = function(e1, r, n) {
                            return null != r.top && null != e1.top && (this.top = t1.number(e1.top, r.top, n)), null != r.bottom && null != e1.bottom && (this.bottom = t1.number(e1.bottom, r.bottom, n)), null != r.left && null != e1.left && (this.left = t1.number(e1.left, r.left, n)), null != r.right && null != e1.right && (this.right = t1.number(e1.right, r.right, n)), this;
                        }, Ln.prototype.getCenter = function(e1, r) {
                            var n = t1.clamp((this.left + e1 - this.right) / 2, 0, e1), i = t1.clamp((this.top + r - this.bottom) / 2, 0, r);
                            return new t1.Point(n, i);
                        }, Ln.prototype.equals = function(t1) {
                            return this.top === t1.top && this.bottom === t1.bottom && this.left === t1.left && this.right === t1.right;
                        }, Ln.prototype.clone = function() {
                            return new Ln(this.top, this.bottom, this.left, this.right);
                        }, Ln.prototype.toJSON = function() {
                            return {
                                top: this.top,
                                bottom: this.bottom,
                                left: this.left,
                                right: this.right
                            };
                        };
                        var In = function(e1, r, n, i, a) {
                            this.tileSize = 512, this.maxValidLatitude = 85.051129, this._renderWorldCopies = void 0 === a || a, this._minZoom = e1 || 0, this._maxZoom = r || 22, this._minPitch = null == n ? 0 : n, this._maxPitch = null == i ? 60 : i, this.setMaxBounds(), this.width = 0, this.height = 0, this._center = new t1.LngLat(0, 0), this.zoom = 0, this.angle = 0, this._fov = .6435011087932844, this._pitch = 0, this._unmodified = !0, this._edgeInsets = new Ln, this._posMatrixCache = {}, this._alignedPosMatrixCache = {};
                        }, Pn = {
                            minZoom: {
                                configurable: !0
                            },
                            maxZoom: {
                                configurable: !0
                            },
                            minPitch: {
                                configurable: !0
                            },
                            maxPitch: {
                                configurable: !0
                            },
                            renderWorldCopies: {
                                configurable: !0
                            },
                            worldSize: {
                                configurable: !0
                            },
                            centerOffset: {
                                configurable: !0
                            },
                            size: {
                                configurable: !0
                            },
                            bearing: {
                                configurable: !0
                            },
                            pitch: {
                                configurable: !0
                            },
                            fov: {
                                configurable: !0
                            },
                            zoom: {
                                configurable: !0
                            },
                            center: {
                                configurable: !0
                            },
                            padding: {
                                configurable: !0
                            },
                            centerPoint: {
                                configurable: !0
                            },
                            unmodified: {
                                configurable: !0
                            },
                            point: {
                                configurable: !0
                            }
                        };
                        In.prototype.clone = function() {
                            var t1 = new In(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies);
                            return t1.tileSize = this.tileSize, t1.latRange = this.latRange, t1.width = this.width, t1.height = this.height, t1._center = this._center, t1.zoom = this.zoom, t1.angle = this.angle, t1._fov = this._fov, t1._pitch = this._pitch, t1._unmodified = this._unmodified, t1._edgeInsets = this._edgeInsets.clone(), t1._calcMatrices(), t1;
                        }, Pn.minZoom.get = function() {
                            return this._minZoom;
                        }, Pn.minZoom.set = function(t1) {
                            this._minZoom !== t1 && (this._minZoom = t1, this.zoom = Math.max(this.zoom, t1));
                        }, Pn.maxZoom.get = function() {
                            return this._maxZoom;
                        }, Pn.maxZoom.set = function(t1) {
                            this._maxZoom !== t1 && (this._maxZoom = t1, this.zoom = Math.min(this.zoom, t1));
                        }, Pn.minPitch.get = function() {
                            return this._minPitch;
                        }, Pn.minPitch.set = function(t1) {
                            this._minPitch !== t1 && (this._minPitch = t1, this.pitch = Math.max(this.pitch, t1));
                        }, Pn.maxPitch.get = function() {
                            return this._maxPitch;
                        }, Pn.maxPitch.set = function(t1) {
                            this._maxPitch !== t1 && (this._maxPitch = t1, this.pitch = Math.min(this.pitch, t1));
                        }, Pn.renderWorldCopies.get = function() {
                            return this._renderWorldCopies;
                        }, Pn.renderWorldCopies.set = function(t1) {
                            void 0 === t1 ? t1 = !0 : null === t1 && (t1 = !1), this._renderWorldCopies = t1;
                        }, Pn.worldSize.get = function() {
                            return this.tileSize * this.scale;
                        }, Pn.centerOffset.get = function() {
                            return this.centerPoint._sub(this.size._div(2));
                        }, Pn.size.get = function() {
                            return new t1.Point(this.width, this.height);
                        }, Pn.bearing.get = function() {
                            return -this.angle / Math.PI * 180;
                        }, Pn.bearing.set = function(e1) {
                            var r = -t1.wrap(e1, -180, 180) * Math.PI / 180;
                            this.angle !== r && (this._unmodified = !1, this.angle = r, this._calcMatrices(), this.rotationMatrix = t1.create$2(), t1.rotate(this.rotationMatrix, this.rotationMatrix, this.angle));
                        }, Pn.pitch.get = function() {
                            return this._pitch / Math.PI * 180;
                        }, Pn.pitch.set = function(e1) {
                            var r = t1.clamp(e1, this.minPitch, this.maxPitch) / 180 * Math.PI;
                            this._pitch !== r && (this._unmodified = !1, this._pitch = r, this._calcMatrices());
                        }, Pn.fov.get = function() {
                            return this._fov / Math.PI * 180;
                        }, Pn.fov.set = function(t1) {
                            t1 = Math.max(.01, Math.min(60, t1)), this._fov !== t1 && (this._unmodified = !1, this._fov = t1 / 180 * Math.PI, this._calcMatrices());
                        }, Pn.zoom.get = function() {
                            return this._zoom;
                        }, Pn.zoom.set = function(t1) {
                            var e1 = Math.min(Math.max(t1, this.minZoom), this.maxZoom);
                            this._zoom !== e1 && (this._unmodified = !1, this._zoom = e1, this.scale = this.zoomScale(e1), this.tileZoom = Math.floor(e1), this.zoomFraction = e1 - this.tileZoom, this._constrain(), this._calcMatrices());
                        }, Pn.center.get = function() {
                            return this._center;
                        }, Pn.center.set = function(t1) {
                            t1.lat === this._center.lat && t1.lng === this._center.lng || (this._unmodified = !1, this._center = t1, this._constrain(), this._calcMatrices());
                        }, Pn.padding.get = function() {
                            return this._edgeInsets.toJSON();
                        }, Pn.padding.set = function(t1) {
                            this._edgeInsets.equals(t1) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, t1, 1), this._calcMatrices());
                        }, Pn.centerPoint.get = function() {
                            return this._edgeInsets.getCenter(this.width, this.height);
                        }, In.prototype.isPaddingEqual = function(t1) {
                            return this._edgeInsets.equals(t1);
                        }, In.prototype.interpolatePadding = function(t1, e1, r) {
                            this._unmodified = !1, this._edgeInsets.interpolate(t1, e1, r), this._constrain(), this._calcMatrices();
                        }, In.prototype.coveringZoomLevel = function(t1) {
                            var e1 = (t1.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / t1.tileSize));
                            return Math.max(0, e1);
                        }, In.prototype.getVisibleUnwrappedCoordinates = function(e1) {
                            var r = [
                                new t1.UnwrappedTileID(0, e1)
                            ];
                            if (this._renderWorldCopies) for(var n = this.pointCoordinate(new t1.Point(0, 0)), i = this.pointCoordinate(new t1.Point(this.width, 0)), a = this.pointCoordinate(new t1.Point(this.width, this.height)), o = this.pointCoordinate(new t1.Point(0, this.height)), s = Math.floor(Math.min(n.x, i.x, a.x, o.x)), l = Math.floor(Math.max(n.x, i.x, a.x, o.x)), c = s - 1; c <= l + 1; c++)0 !== c && r.push(new t1.UnwrappedTileID(c, e1));
                            return r;
                        }, In.prototype.coveringTiles = function(e1) {
                            var r = this.coveringZoomLevel(e1), n = r;
                            if (void 0 !== e1.minzoom && r < e1.minzoom) return [];
                            void 0 !== e1.maxzoom && r > e1.maxzoom && (r = e1.maxzoom);
                            var i = t1.MercatorCoordinate.fromLngLat(this.center), a = Math.pow(2, r), o = [
                                a * i.x,
                                a * i.y,
                                0
                            ], s = En.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, r), l = e1.minzoom || 0;
                            this.pitch <= 60 && this._edgeInsets.top < .1 && (l = r);
                            var c = function(t1) {
                                return {
                                    aabb: new Cn([
                                        t1 * a,
                                        0,
                                        0
                                    ], [
                                        (t1 + 1) * a,
                                        a,
                                        0
                                    ]),
                                    zoom: 0,
                                    x: 0,
                                    y: 0,
                                    wrap: t1,
                                    fullyVisible: !1
                                };
                            }, u = [], h = [], f = r, p = e1.reparseOverscaled ? n : r;
                            if (this._renderWorldCopies) for(var d = 1; d <= 3; d++)u.push(c(-d)), u.push(c(d));
                            for(u.push(c(0)); u.length > 0;){
                                var m = u.pop(), g = m.x, y = m.y, v = m.fullyVisible;
                                if (!v) {
                                    var x = m.aabb.intersects(s);
                                    if (0 === x) continue;
                                    v = 2 === x;
                                }
                                var _ = m.aabb.distanceX(o), b = m.aabb.distanceY(o), w = Math.max(Math.abs(_), Math.abs(b)), T = 3 + (1 << f - m.zoom) - 2;
                                if (m.zoom === f || w > T && m.zoom >= l) h.push({
                                    tileID: new t1.OverscaledTileID(m.zoom === f ? p : m.zoom, m.wrap, m.zoom, g, y),
                                    distanceSq: t1.sqrLen([
                                        o[0] - .5 - g,
                                        o[1] - .5 - y
                                    ])
                                });
                                else for(var k = 0; k < 4; k++){
                                    var A = (g << 1) + k % 2, M = (y << 1) + (k >> 1);
                                    u.push({
                                        aabb: m.aabb.quadrant(k),
                                        zoom: m.zoom + 1,
                                        x: A,
                                        y: M,
                                        wrap: m.wrap,
                                        fullyVisible: v
                                    });
                                }
                            }
                            return h.sort(function(t1, e1) {
                                return t1.distanceSq - e1.distanceSq;
                            }).map(function(t1) {
                                return t1.tileID;
                            });
                        }, In.prototype.resize = function(t1, e1) {
                            this.width = t1, this.height = e1, this.pixelsToGLUnits = [
                                2 / t1,
                                -2 / e1
                            ], this._constrain(), this._calcMatrices();
                        }, Pn.unmodified.get = function() {
                            return this._unmodified;
                        }, In.prototype.zoomScale = function(t1) {
                            return Math.pow(2, t1);
                        }, In.prototype.scaleZoom = function(t1) {
                            return Math.log(t1) / Math.LN2;
                        }, In.prototype.project = function(e1) {
                            var r = t1.clamp(e1.lat, -this.maxValidLatitude, this.maxValidLatitude);
                            return new t1.Point(t1.mercatorXfromLng(e1.lng) * this.worldSize, t1.mercatorYfromLat(r) * this.worldSize);
                        }, In.prototype.unproject = function(e1) {
                            return new t1.MercatorCoordinate(e1.x / this.worldSize, e1.y / this.worldSize).toLngLat();
                        }, Pn.point.get = function() {
                            return this.project(this.center);
                        }, In.prototype.setLocationAtPoint = function(e1, r) {
                            var n = this.pointCoordinate(r), i = this.pointCoordinate(this.centerPoint), a = this.locationCoordinate(e1), o = new t1.MercatorCoordinate(a.x - (n.x - i.x), a.y - (n.y - i.y));
                            this.center = this.coordinateLocation(o), this._renderWorldCopies && (this.center = this.center.wrap());
                        }, In.prototype.locationPoint = function(t1) {
                            return this.coordinatePoint(this.locationCoordinate(t1));
                        }, In.prototype.pointLocation = function(t1) {
                            return this.coordinateLocation(this.pointCoordinate(t1));
                        }, In.prototype.locationCoordinate = function(e1) {
                            return t1.MercatorCoordinate.fromLngLat(e1);
                        }, In.prototype.coordinateLocation = function(t1) {
                            return t1.toLngLat();
                        }, In.prototype.pointCoordinate = function(e1) {
                            var r = [
                                e1.x,
                                e1.y,
                                0,
                                1
                            ], n = [
                                e1.x,
                                e1.y,
                                1,
                                1
                            ];
                            t1.transformMat4(r, r, this.pixelMatrixInverse), t1.transformMat4(n, n, this.pixelMatrixInverse);
                            var i = r[3], a = n[3], o = r[0] / i, s = n[0] / a, l = r[1] / i, c = n[1] / a, u = r[2] / i, h = n[2] / a, f = u === h ? 0 : (0 - u) / (h - u);
                            return new t1.MercatorCoordinate(t1.number(o, s, f) / this.worldSize, t1.number(l, c, f) / this.worldSize);
                        }, In.prototype.coordinatePoint = function(e1) {
                            var r = [
                                e1.x * this.worldSize,
                                e1.y * this.worldSize,
                                0,
                                1
                            ];
                            return t1.transformMat4(r, r, this.pixelMatrix), new t1.Point(r[0] / r[3], r[1] / r[3]);
                        }, In.prototype.getBounds = function() {
                            return (new t1.LngLatBounds).extend(this.pointLocation(new t1.Point(0, 0))).extend(this.pointLocation(new t1.Point(this.width, 0))).extend(this.pointLocation(new t1.Point(this.width, this.height))).extend(this.pointLocation(new t1.Point(0, this.height)));
                        }, In.prototype.getMaxBounds = function() {
                            return this.latRange && 2 === this.latRange.length && this.lngRange && 2 === this.lngRange.length ? new t1.LngLatBounds([
                                this.lngRange[0],
                                this.latRange[0]
                            ], [
                                this.lngRange[1],
                                this.latRange[1]
                            ]) : null;
                        }, In.prototype.setMaxBounds = function(t1) {
                            t1 ? (this.lngRange = [
                                t1.getWest(),
                                t1.getEast()
                            ], this.latRange = [
                                t1.getSouth(),
                                t1.getNorth()
                            ], this._constrain()) : (this.lngRange = null, this.latRange = [
                                -this.maxValidLatitude,
                                this.maxValidLatitude
                            ]);
                        }, In.prototype.calculatePosMatrix = function(e1, r) {
                            void 0 === r && (r = !1);
                            var n = e1.key, i = r ? this._alignedPosMatrixCache : this._posMatrixCache;
                            if (i[n]) return i[n];
                            var a = e1.canonical, o = this.worldSize / this.zoomScale(a.z), s = a.x + Math.pow(2, a.z) * e1.wrap, l = t1.identity(new Float64Array(16));
                            return t1.translate(l, l, [
                                s * o,
                                a.y * o,
                                0
                            ]), t1.scale(l, l, [
                                o / t1.EXTENT,
                                o / t1.EXTENT,
                                1
                            ]), t1.multiply(l, r ? this.alignedProjMatrix : this.projMatrix, l), i[n] = new Float32Array(l), i[n];
                        }, In.prototype.customLayerMatrix = function() {
                            return this.mercatorMatrix.slice();
                        }, In.prototype._constrain = function() {
                            if (this.center && this.width && this.height && !this._constraining) {
                                this._constraining = !0;
                                var e1, r, n, i, a = -90, o = 90, s = -180, l = 180, c = this.size, u = this._unmodified;
                                if (this.latRange) {
                                    var h = this.latRange;
                                    a = t1.mercatorYfromLat(h[1]) * this.worldSize, e1 = (o = t1.mercatorYfromLat(h[0]) * this.worldSize) - a < c.y ? c.y / (o - a) : 0;
                                }
                                if (this.lngRange) {
                                    var f = this.lngRange;
                                    s = t1.mercatorXfromLng(f[0]) * this.worldSize, r = (l = t1.mercatorXfromLng(f[1]) * this.worldSize) - s < c.x ? c.x / (l - s) : 0;
                                }
                                var p = this.point, d = Math.max(r || 0, e1 || 0);
                                if (d) return this.center = this.unproject(new t1.Point(r ? (l + s) / 2 : p.x, e1 ? (o + a) / 2 : p.y)), this.zoom += this.scaleZoom(d), this._unmodified = u, void (this._constraining = !1);
                                if (this.latRange) {
                                    var m = p.y, g = c.y / 2;
                                    m - g < a && (i = a + g), m + g > o && (i = o - g);
                                }
                                if (this.lngRange) {
                                    var y = p.x, v = c.x / 2;
                                    y - v < s && (n = s + v), y + v > l && (n = l - v);
                                }
                                void 0 === n && void 0 === i || (this.center = this.unproject(new t1.Point(void 0 !== n ? n : p.x, void 0 !== i ? i : p.y))), this._unmodified = u, this._constraining = !1;
                            }
                        }, In.prototype._calcMatrices = function() {
                            if (this.height) {
                                var e1 = this._fov / 2, r = this.centerOffset;
                                this.cameraToCenterDistance = .5 / Math.tan(e1) * this.height;
                                var n = Math.PI / 2 + this._pitch, i = this._fov * (.5 + r.y / this.height), a = Math.sin(i) * this.cameraToCenterDistance / Math.sin(t1.clamp(Math.PI - n - i, .01, Math.PI - .01)), o = this.point, s = o.x, l = o.y, c = 1.01 * (Math.cos(Math.PI / 2 - this._pitch) * a + this.cameraToCenterDistance), u = this.height / 50, h = new Float64Array(16);
                                t1.perspective(h, this._fov, this.width / this.height, u, c), h[8] = 2 * -r.x / this.width, h[9] = 2 * r.y / this.height, t1.scale(h, h, [
                                    1,
                                    -1,
                                    1
                                ]), t1.translate(h, h, [
                                    0,
                                    0,
                                    -this.cameraToCenterDistance
                                ]), t1.rotateX(h, h, this._pitch), t1.rotateZ(h, h, this.angle), t1.translate(h, h, [
                                    -s,
                                    -l,
                                    0
                                ]), this.mercatorMatrix = t1.scale([], h, [
                                    this.worldSize,
                                    this.worldSize,
                                    this.worldSize
                                ]), t1.scale(h, h, [
                                    1,
                                    1,
                                    t1.mercatorZfromAltitude(1, this.center.lat) * this.worldSize,
                                    1
                                ]), this.projMatrix = h, this.invProjMatrix = t1.invert([], this.projMatrix);
                                var f = this.width % 2 / 2, p = this.height % 2 / 2, d = Math.cos(this.angle), m = Math.sin(this.angle), g = s - Math.round(s) + d * f + m * p, y = l - Math.round(l) + d * p + m * f, v = new Float64Array(h);
                                if (t1.translate(v, v, [
                                    g > .5 ? g - 1 : g,
                                    y > .5 ? y - 1 : y,
                                    0
                                ]), this.alignedProjMatrix = v, h = t1.create(), t1.scale(h, h, [
                                    this.width / 2,
                                    -this.height / 2,
                                    1
                                ]), t1.translate(h, h, [
                                    1,
                                    -1,
                                    0
                                ]), this.labelPlaneMatrix = h, h = t1.create(), t1.scale(h, h, [
                                    1,
                                    -1,
                                    1
                                ]), t1.translate(h, h, [
                                    -1,
                                    -1,
                                    0
                                ]), t1.scale(h, h, [
                                    2 / this.width,
                                    2 / this.height,
                                    1
                                ]), this.glCoordMatrix = h, this.pixelMatrix = t1.multiply(new Float64Array(16), this.labelPlaneMatrix, this.projMatrix), !(h = t1.invert(new Float64Array(16), this.pixelMatrix))) throw new Error("failed to invert matrix");
                                this.pixelMatrixInverse = h, this._posMatrixCache = {}, this._alignedPosMatrixCache = {};
                            }
                        }, In.prototype.maxPitchScaleFactor = function() {
                            if (!this.pixelMatrixInverse) return 1;
                            var e1 = this.pointCoordinate(new t1.Point(0, 0)), r = [
                                e1.x * this.worldSize,
                                e1.y * this.worldSize,
                                0,
                                1
                            ];
                            return t1.transformMat4(r, r, this.pixelMatrix)[3] / this.cameraToCenterDistance;
                        }, In.prototype.getCameraPoint = function() {
                            var e1 = this._pitch, r = Math.tan(e1) * (this.cameraToCenterDistance || 1);
                            return this.centerPoint.add(new t1.Point(0, r));
                        }, In.prototype.getCameraQueryGeometry = function(e1) {
                            var r = this.getCameraPoint();
                            if (1 === e1.length) return [
                                e1[0],
                                r
                            ];
                            for(var n = r.x, i = r.y, a = r.x, o = r.y, s = 0, l = e1; s < l.length; s += 1){
                                var c = l[s];
                                n = Math.min(n, c.x), i = Math.min(i, c.y), a = Math.max(a, c.x), o = Math.max(o, c.y);
                            }
                            return [
                                new t1.Point(n, i),
                                new t1.Point(a, i),
                                new t1.Point(a, o),
                                new t1.Point(n, o),
                                new t1.Point(n, i)
                            ];
                        }, Object.defineProperties(In.prototype, Pn);
                        var zn = function(e1) {
                            var r, n, i, a, o;
                            this._hashName = e1 && encodeURIComponent(e1), t1.bindAll([
                                "_getCurrentHash",
                                "_onHashChange",
                                "_updateHash"
                            ], this), this._updateHash = (r = this._updateHashUnthrottled.bind(this), n = 300, i = !1, a = null, o = function() {
                                a = null, i && (r(), a = setTimeout(o, n), i = !1);
                            }, function() {
                                return i = !0, a || o(), a;
                            });
                        };
                        zn.prototype.addTo = function(e1) {
                            return this._map = e1, t1.window.addEventListener("hashchange", this._onHashChange, !1), this._map.on("moveend", this._updateHash), this;
                        }, zn.prototype.remove = function() {
                            return t1.window.removeEventListener("hashchange", this._onHashChange, !1), this._map.off("moveend", this._updateHash), clearTimeout(this._updateHash()), delete this._map, this;
                        }, zn.prototype.getHashString = function(e1) {
                            var r = this._map.getCenter(), n = Math.round(100 * this._map.getZoom()) / 100, i = Math.ceil((n * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), a = Math.pow(10, i), o = Math.round(r.lng * a) / a, s = Math.round(r.lat * a) / a, l = this._map.getBearing(), c = this._map.getPitch(), u = "";
                            if (u += e1 ? "/" + o + "/" + s + "/" + n : n + "/" + s + "/" + o, (l || c) && (u += "/" + Math.round(10 * l) / 10), c && (u += "/" + Math.round(c)), this._hashName) {
                                var h = this._hashName, f = !1, p = t1.window.location.hash.slice(1).split("&").map(function(t1) {
                                    var e1 = t1.split("=")[0];
                                    return e1 === h ? (f = !0, e1 + "=" + u) : t1;
                                }).filter(function(t1) {
                                    return t1;
                                });
                                return f || p.push(h + "=" + u), "#" + p.join("&");
                            }
                            return "#" + u;
                        }, zn.prototype._getCurrentHash = function() {
                            var e1, r = this, n = t1.window.location.hash.replace("#", "");
                            return this._hashName ? (n.split("&").map(function(t1) {
                                return t1.split("=");
                            }).forEach(function(t1) {
                                t1[0] === r._hashName && (e1 = t1);
                            }), (e1 && e1[1] || "").split("/")) : n.split("/");
                        }, zn.prototype._onHashChange = function() {
                            var t1 = this._getCurrentHash();
                            if (t1.length >= 3 && !t1.some(function(t1) {
                                return isNaN(t1);
                            })) {
                                var e1 = this._map.dragRotate.isEnabled() && this._map.touchZoomRotate.isEnabled() ? +(t1[3] || 0) : this._map.getBearing();
                                return this._map.jumpTo({
                                    center: [
                                        +t1[2],
                                        +t1[1]
                                    ],
                                    zoom: +t1[0],
                                    bearing: e1,
                                    pitch: +(t1[4] || 0)
                                }), !0;
                            }
                            return !1;
                        }, zn.prototype._updateHashUnthrottled = function() {
                            var e1 = t1.window.location.href.replace(/(#.+)?$/, this.getHashString());
                            try {
                                t1.window.history.replaceState(t1.window.history.state, null, e1);
                            } catch (t1) {}
                        };
                        var On = {
                            linearity: .3,
                            easing: t1.bezier(0, 0, .3, 1)
                        }, Dn = t1.extend({
                            deceleration: 2500,
                            maxSpeed: 1400
                        }, On), Rn = t1.extend({
                            deceleration: 20,
                            maxSpeed: 1400
                        }, On), Fn = t1.extend({
                            deceleration: 1e3,
                            maxSpeed: 360
                        }, On), Bn = t1.extend({
                            deceleration: 1e3,
                            maxSpeed: 90
                        }, On), Nn = function(t1) {
                            this._map = t1, this.clear();
                        };
                        function jn(t1, e1) {
                            (!t1.duration || t1.duration < e1.duration) && (t1.duration = e1.duration, t1.easing = e1.easing);
                        }
                        function Un(e1, r, n) {
                            var i = n.maxSpeed, a = n.linearity, o = n.deceleration, s = t1.clamp(e1 * a / (r / 1e3), -i, i), l = Math.abs(s) / (o * a);
                            return {
                                easing: n.easing,
                                duration: 1e3 * l,
                                amount: s * (l / 2)
                            };
                        }
                        Nn.prototype.clear = function() {
                            this._inertiaBuffer = [];
                        }, Nn.prototype.record = function(e1) {
                            this._drainInertiaBuffer(), this._inertiaBuffer.push({
                                time: t1.browser.now(),
                                settings: e1
                            });
                        }, Nn.prototype._drainInertiaBuffer = function() {
                            for(var e1 = this._inertiaBuffer, r = t1.browser.now(); e1.length > 0 && r - e1[0].time > 160;)e1.shift();
                        }, Nn.prototype._onMoveEnd = function(e1) {
                            if (this._drainInertiaBuffer(), !(this._inertiaBuffer.length < 2)) {
                                for(var r = {
                                    zoom: 0,
                                    bearing: 0,
                                    pitch: 0,
                                    pan: new t1.Point(0, 0),
                                    pinchAround: void 0,
                                    around: void 0
                                }, n = 0, i = this._inertiaBuffer; n < i.length; n += 1){
                                    var a = i[n].settings;
                                    r.zoom += a.zoomDelta || 0, r.bearing += a.bearingDelta || 0, r.pitch += a.pitchDelta || 0, a.panDelta && r.pan._add(a.panDelta), a.around && (r.around = a.around), a.pinchAround && (r.pinchAround = a.pinchAround);
                                }
                                var o = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, s = {};
                                if (r.pan.mag()) {
                                    var l = Un(r.pan.mag(), o, t1.extend({}, Dn, e1 || {}));
                                    s.offset = r.pan.mult(l.amount / r.pan.mag()), s.center = this._map.transform.center, jn(s, l);
                                }
                                if (r.zoom) {
                                    var c = Un(r.zoom, o, Rn);
                                    s.zoom = this._map.transform.zoom + c.amount, jn(s, c);
                                }
                                if (r.bearing) {
                                    var u = Un(r.bearing, o, Fn);
                                    s.bearing = this._map.transform.bearing + t1.clamp(u.amount, -179, 179), jn(s, u);
                                }
                                if (r.pitch) {
                                    var h = Un(r.pitch, o, Bn);
                                    s.pitch = this._map.transform.pitch + h.amount, jn(s, h);
                                }
                                if (s.zoom || s.bearing) {
                                    var f = void 0 === r.pinchAround ? r.around : r.pinchAround;
                                    s.around = f ? this._map.unproject(f) : this._map.getCenter();
                                }
                                return this.clear(), t1.extend(s, {
                                    noMoveStart: !0
                                });
                            }
                        };
                        var Vn = function(e1) {
                            function n(n, i, a, o) {
                                void 0 === o && (o = {});
                                var s = r.mousePos(i.getCanvasContainer(), a), l = i.unproject(s);
                                e1.call(this, n, t1.extend({
                                    point: s,
                                    lngLat: l,
                                    originalEvent: a
                                }, o)), this._defaultPrevented = !1, this.target = i;
                            }
                            e1 && (n.__proto__ = e1), n.prototype = Object.create(e1 && e1.prototype), n.prototype.constructor = n;
                            var i = {
                                defaultPrevented: {
                                    configurable: !0
                                }
                            };
                            return n.prototype.preventDefault = function() {
                                this._defaultPrevented = !0;
                            }, i.defaultPrevented.get = function() {
                                return this._defaultPrevented;
                            }, Object.defineProperties(n.prototype, i), n;
                        }(t1.Event), qn = function(e1) {
                            function n(n, i, a) {
                                var o = "touchend" === n ? a.changedTouches : a.touches, s = r.touchPos(i.getCanvasContainer(), o), l = s.map(function(t1) {
                                    return i.unproject(t1);
                                }), c = s.reduce(function(t1, e1, r, n) {
                                    return t1.add(e1.div(n.length));
                                }, new t1.Point(0, 0)), u = i.unproject(c);
                                e1.call(this, n, {
                                    points: s,
                                    point: c,
                                    lngLats: l,
                                    lngLat: u,
                                    originalEvent: a
                                }), this._defaultPrevented = !1;
                            }
                            e1 && (n.__proto__ = e1), n.prototype = Object.create(e1 && e1.prototype), n.prototype.constructor = n;
                            var i = {
                                defaultPrevented: {
                                    configurable: !0
                                }
                            };
                            return n.prototype.preventDefault = function() {
                                this._defaultPrevented = !0;
                            }, i.defaultPrevented.get = function() {
                                return this._defaultPrevented;
                            }, Object.defineProperties(n.prototype, i), n;
                        }(t1.Event), Hn = function(t1) {
                            function e1(e1, r, n) {
                                t1.call(this, e1, {
                                    originalEvent: n
                                }), this._defaultPrevented = !1;
                            }
                            t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1;
                            var r = {
                                defaultPrevented: {
                                    configurable: !0
                                }
                            };
                            return e1.prototype.preventDefault = function() {
                                this._defaultPrevented = !0;
                            }, r.defaultPrevented.get = function() {
                                return this._defaultPrevented;
                            }, Object.defineProperties(e1.prototype, r), e1;
                        }(t1.Event), Gn = function(t1, e1) {
                            this._map = t1, this._clickTolerance = e1.clickTolerance;
                        };
                        Gn.prototype.reset = function() {
                            delete this._mousedownPos;
                        }, Gn.prototype.wheel = function(t1) {
                            return this._firePreventable(new Hn(t1.type, this._map, t1));
                        }, Gn.prototype.mousedown = function(t1, e1) {
                            return this._mousedownPos = e1, this._firePreventable(new Vn(t1.type, this._map, t1));
                        }, Gn.prototype.mouseup = function(t1) {
                            this._map.fire(new Vn(t1.type, this._map, t1));
                        }, Gn.prototype.click = function(t1, e1) {
                            this._mousedownPos && this._mousedownPos.dist(e1) >= this._clickTolerance || this._map.fire(new Vn(t1.type, this._map, t1));
                        }, Gn.prototype.dblclick = function(t1) {
                            return this._firePreventable(new Vn(t1.type, this._map, t1));
                        }, Gn.prototype.mouseover = function(t1) {
                            this._map.fire(new Vn(t1.type, this._map, t1));
                        }, Gn.prototype.mouseout = function(t1) {
                            this._map.fire(new Vn(t1.type, this._map, t1));
                        }, Gn.prototype.touchstart = function(t1) {
                            return this._firePreventable(new qn(t1.type, this._map, t1));
                        }, Gn.prototype.touchmove = function(t1) {
                            this._map.fire(new qn(t1.type, this._map, t1));
                        }, Gn.prototype.touchend = function(t1) {
                            this._map.fire(new qn(t1.type, this._map, t1));
                        }, Gn.prototype.touchcancel = function(t1) {
                            this._map.fire(new qn(t1.type, this._map, t1));
                        }, Gn.prototype._firePreventable = function(t1) {
                            if (this._map.fire(t1), t1.defaultPrevented) return {};
                        }, Gn.prototype.isEnabled = function() {
                            return !0;
                        }, Gn.prototype.isActive = function() {
                            return !1;
                        }, Gn.prototype.enable = function() {}, Gn.prototype.disable = function() {};
                        var Zn = function(t1) {
                            this._map = t1;
                        };
                        Zn.prototype.reset = function() {
                            this._delayContextMenu = !1, delete this._contextMenuEvent;
                        }, Zn.prototype.mousemove = function(t1) {
                            this._map.fire(new Vn(t1.type, this._map, t1));
                        }, Zn.prototype.mousedown = function() {
                            this._delayContextMenu = !0;
                        }, Zn.prototype.mouseup = function() {
                            this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new Vn("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
                        }, Zn.prototype.contextmenu = function(t1) {
                            this._delayContextMenu ? this._contextMenuEvent = t1 : this._map.fire(new Vn(t1.type, this._map, t1)), this._map.listens("contextmenu") && t1.preventDefault();
                        }, Zn.prototype.isEnabled = function() {
                            return !0;
                        }, Zn.prototype.isActive = function() {
                            return !1;
                        }, Zn.prototype.enable = function() {}, Zn.prototype.disable = function() {};
                        var Wn = function(t1, e1) {
                            this._map = t1, this._el = t1.getCanvasContainer(), this._container = t1.getContainer(), this._clickTolerance = e1.clickTolerance || 1;
                        };
                        function Yn(t1, e1) {
                            for(var r = {}, n = 0; n < t1.length; n++)r[t1[n].identifier] = e1[n];
                            return r;
                        }
                        Wn.prototype.isEnabled = function() {
                            return !!this._enabled;
                        }, Wn.prototype.isActive = function() {
                            return !!this._active;
                        }, Wn.prototype.enable = function() {
                            this.isEnabled() || (this._enabled = !0);
                        }, Wn.prototype.disable = function() {
                            this.isEnabled() && (this._enabled = !1);
                        }, Wn.prototype.mousedown = function(t1, e1) {
                            this.isEnabled() && t1.shiftKey && 0 === t1.button && (r.disableDrag(), this._startPos = this._lastPos = e1, this._active = !0);
                        }, Wn.prototype.mousemoveWindow = function(t1, e1) {
                            if (this._active) {
                                var n = e1;
                                if (!(this._lastPos.equals(n) || !this._box && n.dist(this._startPos) < this._clickTolerance)) {
                                    var i = this._startPos;
                                    this._lastPos = n, this._box || (this._box = r.create("div", "mapboxgl-boxzoom", this._container), this._container.classList.add("mapboxgl-crosshair"), this._fireEvent("boxzoomstart", t1));
                                    var a = Math.min(i.x, n.x), o = Math.max(i.x, n.x), s = Math.min(i.y, n.y), l = Math.max(i.y, n.y);
                                    r.setTransform(this._box, "translate(" + a + "px," + s + "px)"), this._box.style.width = o - a + "px", this._box.style.height = l - s + "px";
                                }
                            }
                        }, Wn.prototype.mouseupWindow = function(e1, n) {
                            var i = this;
                            if (this._active && 0 === e1.button) {
                                var a = this._startPos, o = n;
                                if (this.reset(), r.suppressClick(), a.x !== o.x || a.y !== o.y) return this._map.fire(new t1.Event("boxzoomend", {
                                    originalEvent: e1
                                })), {
                                    cameraAnimation: function(t1) {
                                        return t1.fitScreenCoordinates(a, o, i._map.getBearing(), {
                                            linear: !0
                                        });
                                    }
                                };
                                this._fireEvent("boxzoomcancel", e1);
                            }
                        }, Wn.prototype.keydown = function(t1) {
                            this._active && 27 === t1.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", t1));
                        }, Wn.prototype.reset = function() {
                            this._active = !1, this._container.classList.remove("mapboxgl-crosshair"), this._box && (r.remove(this._box), this._box = null), r.enableDrag(), delete this._startPos, delete this._lastPos;
                        }, Wn.prototype._fireEvent = function(e1, r) {
                            return this._map.fire(new t1.Event(e1, {
                                originalEvent: r
                            }));
                        };
                        var Xn = function(t1) {
                            this.reset(), this.numTouches = t1.numTouches;
                        };
                        Xn.prototype.reset = function() {
                            delete this.centroid, delete this.startTime, delete this.touches, this.aborted = !1;
                        }, Xn.prototype.touchstart = function(e1, r, n) {
                            (this.centroid || n.length > this.numTouches) && (this.aborted = !0), this.aborted || (void 0 === this.startTime && (this.startTime = e1.timeStamp), n.length === this.numTouches && (this.centroid = function(e1) {
                                for(var r = new t1.Point(0, 0), n = 0, i = e1; n < i.length; n += 1){
                                    var a = i[n];
                                    r._add(a);
                                }
                                return r.div(e1.length);
                            }(r), this.touches = Yn(n, r)));
                        }, Xn.prototype.touchmove = function(t1, e1, r) {
                            if (!this.aborted && this.centroid) {
                                var n = Yn(r, e1);
                                for(var i in this.touches){
                                    var a = this.touches[i], o = n[i];
                                    (!o || o.dist(a) > 30) && (this.aborted = !0);
                                }
                            }
                        }, Xn.prototype.touchend = function(t1, e1, r) {
                            if ((!this.centroid || t1.timeStamp - this.startTime > 500) && (this.aborted = !0), 0 === r.length) {
                                var n = !this.aborted && this.centroid;
                                if (this.reset(), n) return n;
                            }
                        };
                        var $n = function(t1) {
                            this.singleTap = new Xn(t1), this.numTaps = t1.numTaps, this.reset();
                        };
                        $n.prototype.reset = function() {
                            this.lastTime = 1 / 0, delete this.lastTap, this.count = 0, this.singleTap.reset();
                        }, $n.prototype.touchstart = function(t1, e1, r) {
                            this.singleTap.touchstart(t1, e1, r);
                        }, $n.prototype.touchmove = function(t1, e1, r) {
                            this.singleTap.touchmove(t1, e1, r);
                        }, $n.prototype.touchend = function(t1, e1, r) {
                            var n = this.singleTap.touchend(t1, e1, r);
                            if (n) {
                                var i = t1.timeStamp - this.lastTime < 500, a = !this.lastTap || this.lastTap.dist(n) < 30;
                                if (i && a || this.reset(), this.count++, this.lastTime = t1.timeStamp, this.lastTap = n, this.count === this.numTaps) return this.reset(), n;
                            }
                        };
                        var Jn = function() {
                            this._zoomIn = new $n({
                                numTouches: 1,
                                numTaps: 2
                            }), this._zoomOut = new $n({
                                numTouches: 2,
                                numTaps: 1
                            }), this.reset();
                        };
                        Jn.prototype.reset = function() {
                            this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
                        }, Jn.prototype.touchstart = function(t1, e1, r) {
                            this._zoomIn.touchstart(t1, e1, r), this._zoomOut.touchstart(t1, e1, r);
                        }, Jn.prototype.touchmove = function(t1, e1, r) {
                            this._zoomIn.touchmove(t1, e1, r), this._zoomOut.touchmove(t1, e1, r);
                        }, Jn.prototype.touchend = function(t1, e1, r) {
                            var n = this, i = this._zoomIn.touchend(t1, e1, r), a = this._zoomOut.touchend(t1, e1, r);
                            return i ? (this._active = !0, t1.preventDefault(), setTimeout(function() {
                                return n.reset();
                            }, 0), {
                                cameraAnimation: function(e1) {
                                    return e1.easeTo({
                                        duration: 300,
                                        zoom: e1.getZoom() + 1,
                                        around: e1.unproject(i)
                                    }, {
                                        originalEvent: t1
                                    });
                                }
                            }) : a ? (this._active = !0, t1.preventDefault(), setTimeout(function() {
                                return n.reset();
                            }, 0), {
                                cameraAnimation: function(e1) {
                                    return e1.easeTo({
                                        duration: 300,
                                        zoom: e1.getZoom() - 1,
                                        around: e1.unproject(a)
                                    }, {
                                        originalEvent: t1
                                    });
                                }
                            }) : void 0;
                        }, Jn.prototype.touchcancel = function() {
                            this.reset();
                        }, Jn.prototype.enable = function() {
                            this._enabled = !0;
                        }, Jn.prototype.disable = function() {
                            this._enabled = !1, this.reset();
                        }, Jn.prototype.isEnabled = function() {
                            return this._enabled;
                        }, Jn.prototype.isActive = function() {
                            return this._active;
                        };
                        var Kn = {};
                        Kn[0] = 1, Kn[2] = 2;
                        var Qn = function(t1) {
                            this.reset(), this._clickTolerance = t1.clickTolerance || 1;
                        };
                        Qn.prototype.reset = function() {
                            this._active = !1, this._moved = !1, delete this._lastPoint, delete this._eventButton;
                        }, Qn.prototype._correctButton = function(t1, e1) {
                            return !1;
                        }, Qn.prototype._move = function(t1, e1) {
                            return {};
                        }, Qn.prototype.mousedown = function(t1, e1) {
                            if (!this._lastPoint) {
                                var n = r.mouseButton(t1);
                                this._correctButton(t1, n) && (this._lastPoint = e1, this._eventButton = n);
                            }
                        }, Qn.prototype.mousemoveWindow = function(t1, e1) {
                            var r = this._lastPoint;
                            if (r) {
                                if (t1.preventDefault(), function(t1, e1) {
                                    var r = Kn[e1];
                                    return void 0 === t1.buttons || (t1.buttons & r) !== r;
                                }(t1, this._eventButton)) this.reset();
                                else if (this._moved || !(e1.dist(r) < this._clickTolerance)) return this._moved = !0, this._lastPoint = e1, this._move(r, e1);
                            }
                        }, Qn.prototype.mouseupWindow = function(t1) {
                            this._lastPoint && r.mouseButton(t1) === this._eventButton && (this._moved && r.suppressClick(), this.reset());
                        }, Qn.prototype.enable = function() {
                            this._enabled = !0;
                        }, Qn.prototype.disable = function() {
                            this._enabled = !1, this.reset();
                        }, Qn.prototype.isEnabled = function() {
                            return this._enabled;
                        }, Qn.prototype.isActive = function() {
                            return this._active;
                        };
                        var ti = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.mousedown = function(e1, r) {
                                t1.prototype.mousedown.call(this, e1, r), this._lastPoint && (this._active = !0);
                            }, e1.prototype._correctButton = function(t1, e1) {
                                return 0 === e1 && !t1.ctrlKey;
                            }, e1.prototype._move = function(t1, e1) {
                                return {
                                    around: e1,
                                    panDelta: e1.sub(t1)
                                };
                            }, e1;
                        }(Qn), ei = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._correctButton = function(t1, e1) {
                                return 0 === e1 && t1.ctrlKey || 2 === e1;
                            }, e1.prototype._move = function(t1, e1) {
                                var r = .8 * (e1.x - t1.x);
                                if (r) return this._active = !0, {
                                    bearingDelta: r
                                };
                            }, e1.prototype.contextmenu = function(t1) {
                                t1.preventDefault();
                            }, e1;
                        }(Qn), ri = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._correctButton = function(t1, e1) {
                                return 0 === e1 && t1.ctrlKey || 2 === e1;
                            }, e1.prototype._move = function(t1, e1) {
                                var r = -0.5 * (e1.y - t1.y);
                                if (r) return this._active = !0, {
                                    pitchDelta: r
                                };
                            }, e1.prototype.contextmenu = function(t1) {
                                t1.preventDefault();
                            }, e1;
                        }(Qn), ni = function(t1) {
                            this._minTouches = 1, this._clickTolerance = t1.clickTolerance || 1, this.reset();
                        };
                        ni.prototype.reset = function() {
                            this._active = !1, this._touches = {}, this._sum = new t1.Point(0, 0);
                        }, ni.prototype.touchstart = function(t1, e1, r) {
                            return this._calculateTransform(t1, e1, r);
                        }, ni.prototype.touchmove = function(t1, e1, r) {
                            if (this._active && !(r.length < this._minTouches)) return t1.preventDefault(), this._calculateTransform(t1, e1, r);
                        }, ni.prototype.touchend = function(t1, e1, r) {
                            this._calculateTransform(t1, e1, r), this._active && r.length < this._minTouches && this.reset();
                        }, ni.prototype.touchcancel = function() {
                            this.reset();
                        }, ni.prototype._calculateTransform = function(e1, r, n) {
                            n.length > 0 && (this._active = !0);
                            var i = Yn(n, r), a = new t1.Point(0, 0), o = new t1.Point(0, 0), s = 0;
                            for(var l in i){
                                var c = i[l], u = this._touches[l];
                                u && (a._add(c), o._add(c.sub(u)), s++, i[l] = c);
                            }
                            if (this._touches = i, !(s < this._minTouches) && o.mag()) {
                                var h = o.div(s);
                                if (this._sum._add(h), !(this._sum.mag() < this._clickTolerance)) return {
                                    around: a.div(s),
                                    panDelta: h
                                };
                            }
                        }, ni.prototype.enable = function() {
                            this._enabled = !0;
                        }, ni.prototype.disable = function() {
                            this._enabled = !1, this.reset();
                        }, ni.prototype.isEnabled = function() {
                            return this._enabled;
                        }, ni.prototype.isActive = function() {
                            return this._active;
                        };
                        var ii = function() {
                            this.reset();
                        };
                        function ai(t1, e1, r) {
                            for(var n = 0; n < t1.length; n++)if (t1[n].identifier === r) return e1[n];
                        }
                        ii.prototype.reset = function() {
                            this._active = !1, delete this._firstTwoTouches;
                        }, ii.prototype._start = function(t1) {}, ii.prototype._move = function(t1, e1, r) {
                            return {};
                        }, ii.prototype.touchstart = function(t1, e1, r) {
                            this._firstTwoTouches || r.length < 2 || (this._firstTwoTouches = [
                                r[0].identifier,
                                r[1].identifier
                            ], this._start([
                                e1[0],
                                e1[1]
                            ]));
                        }, ii.prototype.touchmove = function(t1, e1, r) {
                            if (this._firstTwoTouches) {
                                t1.preventDefault();
                                var n = this._firstTwoTouches, i = n[0], a = n[1], o = ai(r, e1, i), s = ai(r, e1, a);
                                if (o && s) {
                                    var l = this._aroundCenter ? null : o.add(s).div(2);
                                    return this._move([
                                        o,
                                        s
                                    ], l, t1);
                                }
                            }
                        }, ii.prototype.touchend = function(t1, e1, n) {
                            if (this._firstTwoTouches) {
                                var i = this._firstTwoTouches, a = i[0], o = i[1], s = ai(n, e1, a), l = ai(n, e1, o);
                                s && l || (this._active && r.suppressClick(), this.reset());
                            }
                        }, ii.prototype.touchcancel = function() {
                            this.reset();
                        }, ii.prototype.enable = function(t1) {
                            this._enabled = !0, this._aroundCenter = !!t1 && "center" === t1.around;
                        }, ii.prototype.disable = function() {
                            this._enabled = !1, this.reset();
                        }, ii.prototype.isEnabled = function() {
                            return this._enabled;
                        }, ii.prototype.isActive = function() {
                            return this._active;
                        };
                        function oi(t1, e1) {
                            return Math.log(t1 / e1) / Math.LN2;
                        }
                        var si = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.reset = function() {
                                t1.prototype.reset.call(this), delete this._distance, delete this._startDistance;
                            }, e1.prototype._start = function(t1) {
                                this._startDistance = this._distance = t1[0].dist(t1[1]);
                            }, e1.prototype._move = function(t1, e1) {
                                var r = this._distance;
                                if (this._distance = t1[0].dist(t1[1]), this._active || !(Math.abs(oi(this._distance, this._startDistance)) < .1)) return this._active = !0, {
                                    zoomDelta: oi(this._distance, r),
                                    pinchAround: e1
                                };
                            }, e1;
                        }(ii);
                        function li(t1, e1) {
                            return 180 * t1.angleWith(e1) / Math.PI;
                        }
                        var ci = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.reset = function() {
                                t1.prototype.reset.call(this), delete this._minDiameter, delete this._startVector, delete this._vector;
                            }, e1.prototype._start = function(t1) {
                                this._startVector = this._vector = t1[0].sub(t1[1]), this._minDiameter = t1[0].dist(t1[1]);
                            }, e1.prototype._move = function(t1, e1) {
                                var r = this._vector;
                                if (this._vector = t1[0].sub(t1[1]), this._active || !this._isBelowThreshold(this._vector)) return this._active = !0, {
                                    bearingDelta: li(this._vector, r),
                                    pinchAround: e1
                                };
                            }, e1.prototype._isBelowThreshold = function(t1) {
                                this._minDiameter = Math.min(this._minDiameter, t1.mag());
                                var e1 = 25 / (Math.PI * this._minDiameter) * 360, r = li(t1, this._startVector);
                                return Math.abs(r) < e1;
                            }, e1;
                        }(ii);
                        function ui(t1) {
                            return Math.abs(t1.y) > Math.abs(t1.x);
                        }
                        var hi = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.reset = function() {
                                t1.prototype.reset.call(this), this._valid = void 0, delete this._firstMove, delete this._lastPoints;
                            }, e1.prototype._start = function(t1) {
                                this._lastPoints = t1, ui(t1[0].sub(t1[1])) && (this._valid = !1);
                            }, e1.prototype._move = function(t1, e1, r) {
                                var n = t1[0].sub(this._lastPoints[0]), i = t1[1].sub(this._lastPoints[1]);
                                if (this._valid = this.gestureBeginsVertically(n, i, r.timeStamp), this._valid) return this._lastPoints = t1, this._active = !0, {
                                    pitchDelta: (n.y + i.y) / 2 * -0.5
                                };
                            }, e1.prototype.gestureBeginsVertically = function(t1, e1, r) {
                                if (void 0 !== this._valid) return this._valid;
                                var n = t1.mag() >= 2, i = e1.mag() >= 2;
                                if (n || i) {
                                    if (!n || !i) return void 0 === this._firstMove && (this._firstMove = r), r - this._firstMove < 100 && void 0;
                                    var a = t1.y > 0 == e1.y > 0;
                                    return ui(t1) && ui(e1) && a;
                                }
                            }, e1;
                        }(ii), fi = {
                            panStep: 100,
                            bearingStep: 15,
                            pitchStep: 10
                        }, pi = function() {
                            var t1 = fi;
                            this._panStep = t1.panStep, this._bearingStep = t1.bearingStep, this._pitchStep = t1.pitchStep, this._rotationDisabled = !1;
                        };
                        function di(t1) {
                            return t1 * (2 - t1);
                        }
                        pi.prototype.reset = function() {
                            this._active = !1;
                        }, pi.prototype.keydown = function(t1) {
                            var e1 = this;
                            if (!(t1.altKey || t1.ctrlKey || t1.metaKey)) {
                                var r = 0, n = 0, i = 0, a = 0, o = 0;
                                switch(t1.keyCode){
                                    case 61:
                                    case 107:
                                    case 171:
                                    case 187:
                                        r = 1;
                                        break;
                                    case 189:
                                    case 109:
                                    case 173:
                                        r = -1;
                                        break;
                                    case 37:
                                        t1.shiftKey ? n = -1 : (t1.preventDefault(), a = -1);
                                        break;
                                    case 39:
                                        t1.shiftKey ? n = 1 : (t1.preventDefault(), a = 1);
                                        break;
                                    case 38:
                                        t1.shiftKey ? i = 1 : (t1.preventDefault(), o = -1);
                                        break;
                                    case 40:
                                        t1.shiftKey ? i = -1 : (t1.preventDefault(), o = 1);
                                        break;
                                    default:
                                        return;
                                }
                                return this._rotationDisabled && (n = 0, i = 0), {
                                    cameraAnimation: function(s) {
                                        var l = s.getZoom();
                                        s.easeTo({
                                            duration: 300,
                                            easeId: "keyboardHandler",
                                            easing: di,
                                            zoom: r ? Math.round(l) + r * (t1.shiftKey ? 2 : 1) : l,
                                            bearing: s.getBearing() + n * e1._bearingStep,
                                            pitch: s.getPitch() + i * e1._pitchStep,
                                            offset: [
                                                -a * e1._panStep,
                                                -o * e1._panStep
                                            ],
                                            center: s.getCenter()
                                        }, {
                                            originalEvent: t1
                                        });
                                    }
                                };
                            }
                        }, pi.prototype.enable = function() {
                            this._enabled = !0;
                        }, pi.prototype.disable = function() {
                            this._enabled = !1, this.reset();
                        }, pi.prototype.isEnabled = function() {
                            return this._enabled;
                        }, pi.prototype.isActive = function() {
                            return this._active;
                        }, pi.prototype.disableRotation = function() {
                            this._rotationDisabled = !0;
                        }, pi.prototype.enableRotation = function() {
                            this._rotationDisabled = !1;
                        };
                        var mi = 4.000244140625, gi = function(e1, r) {
                            this._map = e1, this._el = e1.getCanvasContainer(), this._handler = r, this._delta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = .0022222222222222222, t1.bindAll([
                                "_onTimeout"
                            ], this);
                        };
                        gi.prototype.setZoomRate = function(t1) {
                            this._defaultZoomRate = t1;
                        }, gi.prototype.setWheelZoomRate = function(t1) {
                            this._wheelZoomRate = t1;
                        }, gi.prototype.isEnabled = function() {
                            return !!this._enabled;
                        }, gi.prototype.isActive = function() {
                            return !!this._active || void 0 !== this._finishTimeout;
                        }, gi.prototype.isZooming = function() {
                            return !!this._zooming;
                        }, gi.prototype.enable = function(t1) {
                            this.isEnabled() || (this._enabled = !0, this._aroundCenter = t1 && "center" === t1.around);
                        }, gi.prototype.disable = function() {
                            this.isEnabled() && (this._enabled = !1);
                        }, gi.prototype.wheel = function(e1) {
                            if (this.isEnabled()) {
                                var r = e1.deltaMode === t1.window.WheelEvent.DOM_DELTA_LINE ? 40 * e1.deltaY : e1.deltaY, n = t1.browser.now(), i = n - (this._lastWheelEventTime || 0);
                                this._lastWheelEventTime = n, 0 !== r && r % mi == 0 ? this._type = "wheel" : 0 !== r && Math.abs(r) < 4 ? this._type = "trackpad" : i > 400 ? (this._type = null, this._lastValue = r, this._timeout = setTimeout(this._onTimeout, 40, e1)) : this._type || (this._type = Math.abs(i * r) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, r += this._lastValue)), e1.shiftKey && r && (r /= 4), this._type && (this._lastWheelEvent = e1, this._delta -= r, this._active || this._start(e1)), e1.preventDefault();
                            }
                        }, gi.prototype._onTimeout = function(t1) {
                            this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(t1);
                        }, gi.prototype._start = function(e1) {
                            if (this._delta) {
                                this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                                var n = r.mousePos(this._el, e1);
                                this._around = t1.LngLat.convert(this._aroundCenter ? this._map.getCenter() : this._map.unproject(n)), this._aroundPoint = this._map.transform.locationPoint(this._around), this._frameId || (this._frameId = !0, this._handler._triggerRenderFrame());
                            }
                        }, gi.prototype.renderFrame = function() {
                            var e1 = this;
                            if (this._frameId && (this._frameId = null, this.isActive())) {
                                var r = this._map.transform;
                                if (0 !== this._delta) {
                                    var n = "wheel" === this._type && Math.abs(this._delta) > mi ? this._wheelZoomRate : this._defaultZoomRate, i = 2 / (1 + Math.exp(-Math.abs(this._delta * n)));
                                    this._delta < 0 && 0 !== i && (i = 1 / i);
                                    var a = "number" == typeof this._targetZoom ? r.zoomScale(this._targetZoom) : r.scale;
                                    this._targetZoom = Math.min(r.maxZoom, Math.max(r.minZoom, r.scaleZoom(a * i))), "wheel" === this._type && (this._startZoom = r.zoom, this._easing = this._smoothOutEasing(200)), this._delta = 0;
                                }
                                var o, s = "number" == typeof this._targetZoom ? this._targetZoom : r.zoom, l = this._startZoom, c = this._easing, u = !1;
                                if ("wheel" === this._type && l && c) {
                                    var h = Math.min((t1.browser.now() - this._lastWheelEventTime) / 200, 1), f = c(h);
                                    o = t1.number(l, s, f), h < 1 ? this._frameId || (this._frameId = !0) : u = !0;
                                } else o = s, u = !0;
                                return this._active = !0, u && (this._active = !1, this._finishTimeout = setTimeout(function() {
                                    e1._zooming = !1, e1._handler._triggerRenderFrame(), delete e1._targetZoom, delete e1._finishTimeout;
                                }, 200)), {
                                    noInertia: !0,
                                    needsRenderFrame: !u,
                                    zoomDelta: o - r.zoom,
                                    around: this._aroundPoint,
                                    originalEvent: this._lastWheelEvent
                                };
                            }
                        }, gi.prototype._smoothOutEasing = function(e1) {
                            var r = t1.ease;
                            if (this._prevEase) {
                                var n = this._prevEase, i = (t1.browser.now() - n.start) / n.duration, a = n.easing(i + .01) - n.easing(i), o = .27 / Math.sqrt(a * a + 1e-4) * .01, s = Math.sqrt(.0729 - o * o);
                                r = t1.bezier(o, s, .25, 1);
                            }
                            return this._prevEase = {
                                start: t1.browser.now(),
                                duration: e1,
                                easing: r
                            }, r;
                        }, gi.prototype.reset = function() {
                            this._active = !1;
                        };
                        var yi = function(t1, e1) {
                            this._clickZoom = t1, this._tapZoom = e1;
                        };
                        yi.prototype.enable = function() {
                            this._clickZoom.enable(), this._tapZoom.enable();
                        }, yi.prototype.disable = function() {
                            this._clickZoom.disable(), this._tapZoom.disable();
                        }, yi.prototype.isEnabled = function() {
                            return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
                        }, yi.prototype.isActive = function() {
                            return this._clickZoom.isActive() || this._tapZoom.isActive();
                        };
                        var vi = function() {
                            this.reset();
                        };
                        vi.prototype.reset = function() {
                            this._active = !1;
                        }, vi.prototype.dblclick = function(t1, e1) {
                            return t1.preventDefault(), {
                                cameraAnimation: function(r) {
                                    r.easeTo({
                                        duration: 300,
                                        zoom: r.getZoom() + (t1.shiftKey ? -1 : 1),
                                        around: r.unproject(e1)
                                    }, {
                                        originalEvent: t1
                                    });
                                }
                            };
                        }, vi.prototype.enable = function() {
                            this._enabled = !0;
                        }, vi.prototype.disable = function() {
                            this._enabled = !1, this.reset();
                        }, vi.prototype.isEnabled = function() {
                            return this._enabled;
                        }, vi.prototype.isActive = function() {
                            return this._active;
                        };
                        var xi = function() {
                            this._tap = new $n({
                                numTouches: 1,
                                numTaps: 1
                            }), this.reset();
                        };
                        xi.prototype.reset = function() {
                            this._active = !1, delete this._swipePoint, delete this._swipeTouch, delete this._tapTime, this._tap.reset();
                        }, xi.prototype.touchstart = function(t1, e1, r) {
                            this._swipePoint || (this._tapTime && t1.timeStamp - this._tapTime > 500 && this.reset(), this._tapTime ? r.length > 0 && (this._swipePoint = e1[0], this._swipeTouch = r[0].identifier) : this._tap.touchstart(t1, e1, r));
                        }, xi.prototype.touchmove = function(t1, e1, r) {
                            if (this._tapTime) {
                                if (this._swipePoint) {
                                    if (r[0].identifier !== this._swipeTouch) return;
                                    var n = e1[0], i = n.y - this._swipePoint.y;
                                    return this._swipePoint = n, t1.preventDefault(), this._active = !0, {
                                        zoomDelta: i / 128
                                    };
                                }
                            } else this._tap.touchmove(t1, e1, r);
                        }, xi.prototype.touchend = function(t1, e1, r) {
                            this._tapTime ? this._swipePoint && 0 === r.length && this.reset() : this._tap.touchend(t1, e1, r) && (this._tapTime = t1.timeStamp);
                        }, xi.prototype.touchcancel = function() {
                            this.reset();
                        }, xi.prototype.enable = function() {
                            this._enabled = !0;
                        }, xi.prototype.disable = function() {
                            this._enabled = !1, this.reset();
                        }, xi.prototype.isEnabled = function() {
                            return this._enabled;
                        }, xi.prototype.isActive = function() {
                            return this._active;
                        };
                        var _i = function(t1, e1, r) {
                            this._el = t1, this._mousePan = e1, this._touchPan = r;
                        };
                        _i.prototype.enable = function(t1) {
                            this._inertiaOptions = t1 || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("mapboxgl-touch-drag-pan");
                        }, _i.prototype.disable = function() {
                            this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("mapboxgl-touch-drag-pan");
                        }, _i.prototype.isEnabled = function() {
                            return this._mousePan.isEnabled() && this._touchPan.isEnabled();
                        }, _i.prototype.isActive = function() {
                            return this._mousePan.isActive() || this._touchPan.isActive();
                        };
                        var bi = function(t1, e1, r) {
                            this._pitchWithRotate = t1.pitchWithRotate, this._mouseRotate = e1, this._mousePitch = r;
                        };
                        bi.prototype.enable = function() {
                            this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable();
                        }, bi.prototype.disable = function() {
                            this._mouseRotate.disable(), this._mousePitch.disable();
                        }, bi.prototype.isEnabled = function() {
                            return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
                        }, bi.prototype.isActive = function() {
                            return this._mouseRotate.isActive() || this._mousePitch.isActive();
                        };
                        var wi = function(t1, e1, r, n) {
                            this._el = t1, this._touchZoom = e1, this._touchRotate = r, this._tapDragZoom = n, this._rotationDisabled = !1, this._enabled = !0;
                        };
                        wi.prototype.enable = function(t1) {
                            this._touchZoom.enable(t1), this._rotationDisabled || this._touchRotate.enable(t1), this._tapDragZoom.enable(), this._el.classList.add("mapboxgl-touch-zoom-rotate");
                        }, wi.prototype.disable = function() {
                            this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("mapboxgl-touch-zoom-rotate");
                        }, wi.prototype.isEnabled = function() {
                            return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
                        }, wi.prototype.isActive = function() {
                            return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
                        }, wi.prototype.disableRotation = function() {
                            this._rotationDisabled = !0, this._touchRotate.disable();
                        }, wi.prototype.enableRotation = function() {
                            this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
                        };
                        var Ti = function(t1) {
                            return t1.zoom || t1.drag || t1.pitch || t1.rotate;
                        }, ki = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1;
                        }(t1.Event);
                        function Ai(t1) {
                            return t1.panDelta && t1.panDelta.mag() || t1.zoomDelta || t1.bearingDelta || t1.pitchDelta;
                        }
                        var Mi = function(e1, n) {
                            this._map = e1, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new Nn(e1), this._bearingSnap = n.bearingSnap, this._previousActiveHandlers = {}, this._eventsInProgress = {}, this._addDefaultHandlers(n), t1.bindAll([
                                "handleEvent",
                                "handleWindowEvent"
                            ], this);
                            var i = this._el;
                            this._listeners = [
                                [
                                    i,
                                    "touchstart",
                                    {
                                        passive: !0
                                    }
                                ],
                                [
                                    i,
                                    "touchmove",
                                    {
                                        passive: !1
                                    }
                                ],
                                [
                                    i,
                                    "touchend",
                                    void 0
                                ],
                                [
                                    i,
                                    "touchcancel",
                                    void 0
                                ],
                                [
                                    i,
                                    "mousedown",
                                    void 0
                                ],
                                [
                                    i,
                                    "mousemove",
                                    void 0
                                ],
                                [
                                    i,
                                    "mouseup",
                                    void 0
                                ],
                                [
                                    t1.window.document,
                                    "mousemove",
                                    {
                                        capture: !0
                                    }
                                ],
                                [
                                    t1.window.document,
                                    "mouseup",
                                    void 0
                                ],
                                [
                                    i,
                                    "mouseover",
                                    void 0
                                ],
                                [
                                    i,
                                    "mouseout",
                                    void 0
                                ],
                                [
                                    i,
                                    "dblclick",
                                    void 0
                                ],
                                [
                                    i,
                                    "click",
                                    void 0
                                ],
                                [
                                    i,
                                    "keydown",
                                    {
                                        capture: !1
                                    }
                                ],
                                [
                                    i,
                                    "keyup",
                                    void 0
                                ],
                                [
                                    i,
                                    "wheel",
                                    {
                                        passive: !1
                                    }
                                ],
                                [
                                    i,
                                    "contextmenu",
                                    void 0
                                ],
                                [
                                    t1.window,
                                    "blur",
                                    void 0
                                ]
                            ];
                            for(var a = 0, o = this._listeners; a < o.length; a += 1){
                                var s = o[a], l = s[0], c = s[1], u = s[2];
                                r.addEventListener(l, c, l === t1.window.document ? this.handleWindowEvent : this.handleEvent, u);
                            }
                        };
                        Mi.prototype.destroy = function() {
                            for(var e1 = 0, n = this._listeners; e1 < n.length; e1 += 1){
                                var i = n[e1], a = i[0], o = i[1], s = i[2];
                                r.removeEventListener(a, o, a === t1.window.document ? this.handleWindowEvent : this.handleEvent, s);
                            }
                        }, Mi.prototype._addDefaultHandlers = function(t1) {
                            var e1 = this._map, r = e1.getCanvasContainer();
                            this._add("mapEvent", new Gn(e1, t1));
                            var n = e1.boxZoom = new Wn(e1, t1);
                            this._add("boxZoom", n);
                            var i = new Jn, a = new vi;
                            e1.doubleClickZoom = new yi(a, i), this._add("tapZoom", i), this._add("clickZoom", a);
                            var o = new xi;
                            this._add("tapDragZoom", o);
                            var s = e1.touchPitch = new hi;
                            this._add("touchPitch", s);
                            var l = new ei(t1), c = new ri(t1);
                            e1.dragRotate = new bi(t1, l, c), this._add("mouseRotate", l, [
                                "mousePitch"
                            ]), this._add("mousePitch", c, [
                                "mouseRotate"
                            ]);
                            var u = new ti(t1), h = new ni(t1);
                            e1.dragPan = new _i(r, u, h), this._add("mousePan", u), this._add("touchPan", h, [
                                "touchZoom",
                                "touchRotate"
                            ]);
                            var f = new ci, p = new si;
                            e1.touchZoomRotate = new wi(r, p, f, o), this._add("touchRotate", f, [
                                "touchPan",
                                "touchZoom"
                            ]), this._add("touchZoom", p, [
                                "touchPan",
                                "touchRotate"
                            ]);
                            var d = e1.scrollZoom = new gi(e1, this);
                            this._add("scrollZoom", d, [
                                "mousePan"
                            ]);
                            var m = e1.keyboard = new pi;
                            this._add("keyboard", m), this._add("blockableMapEvent", new Zn(e1));
                            for(var g = 0, y = [
                                "boxZoom",
                                "doubleClickZoom",
                                "tapDragZoom",
                                "touchPitch",
                                "dragRotate",
                                "dragPan",
                                "touchZoomRotate",
                                "scrollZoom",
                                "keyboard"
                            ]; g < y.length; g += 1){
                                var v = y[g];
                                t1.interactive && t1[v] && e1[v].enable(t1[v]);
                            }
                        }, Mi.prototype._add = function(t1, e1, r) {
                            this._handlers.push({
                                handlerName: t1,
                                handler: e1,
                                allowed: r
                            }), this._handlersById[t1] = e1;
                        }, Mi.prototype.stop = function(t1) {
                            if (!this._updatingCamera) {
                                for(var e1 = 0, r = this._handlers; e1 < r.length; e1 += 1)r[e1].handler.reset();
                                this._inertia.clear(), this._fireEvents({}, {}, t1), this._changes = [];
                            }
                        }, Mi.prototype.isActive = function() {
                            for(var t1 = 0, e1 = this._handlers; t1 < e1.length; t1 += 1)if (e1[t1].handler.isActive()) return !0;
                            return !1;
                        }, Mi.prototype.isZooming = function() {
                            return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
                        }, Mi.prototype.isRotating = function() {
                            return !!this._eventsInProgress.rotate;
                        }, Mi.prototype.isMoving = function() {
                            return Boolean(Ti(this._eventsInProgress)) || this.isZooming();
                        }, Mi.prototype._blockedByActive = function(t1, e1, r) {
                            for(var n in t1)if (n !== r && (!e1 || e1.indexOf(n) < 0)) return !0;
                            return !1;
                        }, Mi.prototype.handleWindowEvent = function(t1) {
                            this.handleEvent(t1, t1.type + "Window");
                        }, Mi.prototype._getMapTouches = function(t1) {
                            for(var e1 = [], r = 0, n = t1; r < n.length; r += 1){
                                var i = n[r], a = i.target;
                                this._el.contains(a) && e1.push(i);
                            }
                            return e1;
                        }, Mi.prototype.handleEvent = function(t1, e1) {
                            if ("blur" !== t1.type) {
                                this._updatingCamera = !0;
                                for(var n = "renderFrame" === t1.type ? void 0 : t1, i = {
                                    needsRenderFrame: !1
                                }, a = {}, o = {}, s = t1.touches ? this._getMapTouches(t1.touches) : void 0, l = s ? r.touchPos(this._el, s) : r.mousePos(this._el, t1), c = 0, u = this._handlers; c < u.length; c += 1){
                                    var h = u[c], f = h.handlerName, p = h.handler, d = h.allowed;
                                    if (p.isEnabled()) {
                                        var m = void 0;
                                        this._blockedByActive(o, d, f) ? p.reset() : p[e1 || t1.type] && (m = p[e1 || t1.type](t1, l, s), this.mergeHandlerResult(i, a, m, f, n), m && m.needsRenderFrame && this._triggerRenderFrame()), (m || p.isActive()) && (o[f] = p);
                                    }
                                }
                                var g = {};
                                for(var y in this._previousActiveHandlers)o[y] || (g[y] = n);
                                this._previousActiveHandlers = o, (Object.keys(g).length || Ai(i)) && (this._changes.push([
                                    i,
                                    a,
                                    g
                                ]), this._triggerRenderFrame()), (Object.keys(o).length || Ai(i)) && this._map._stop(!0), this._updatingCamera = !1;
                                var v = i.cameraAnimation;
                                v && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], v(this._map));
                            } else this.stop(!0);
                        }, Mi.prototype.mergeHandlerResult = function(e1, r, n, i, a) {
                            if (n) {
                                t1.extend(e1, n);
                                var o = {
                                    handlerName: i,
                                    originalEvent: n.originalEvent || a
                                };
                                void 0 !== n.zoomDelta && (r.zoom = o), void 0 !== n.panDelta && (r.drag = o), void 0 !== n.pitchDelta && (r.pitch = o), void 0 !== n.bearingDelta && (r.rotate = o);
                            }
                        }, Mi.prototype._applyChanges = function() {
                            for(var e1 = {}, r = {}, n = {}, i = 0, a = this._changes; i < a.length; i += 1){
                                var o = a[i], s = o[0], l = o[1], c = o[2];
                                s.panDelta && (e1.panDelta = (e1.panDelta || new t1.Point(0, 0))._add(s.panDelta)), s.zoomDelta && (e1.zoomDelta = (e1.zoomDelta || 0) + s.zoomDelta), s.bearingDelta && (e1.bearingDelta = (e1.bearingDelta || 0) + s.bearingDelta), s.pitchDelta && (e1.pitchDelta = (e1.pitchDelta || 0) + s.pitchDelta), void 0 !== s.around && (e1.around = s.around), void 0 !== s.pinchAround && (e1.pinchAround = s.pinchAround), s.noInertia && (e1.noInertia = s.noInertia), t1.extend(r, l), t1.extend(n, c);
                            }
                            this._updateMapTransform(e1, r, n), this._changes = [];
                        }, Mi.prototype._updateMapTransform = function(t1, e1, r) {
                            var n = this._map, i = n.transform;
                            if (!Ai(t1)) return this._fireEvents(e1, r, !0);
                            var a = t1.panDelta, o = t1.zoomDelta, s = t1.bearingDelta, l = t1.pitchDelta, c = t1.around, u = t1.pinchAround;
                            void 0 !== u && (c = u), n._stop(!0), c = c || n.transform.centerPoint;
                            var h = i.pointLocation(a ? c.sub(a) : c);
                            s && (i.bearing += s), l && (i.pitch += l), o && (i.zoom += o), i.setLocationAtPoint(h, c), this._map._update(), t1.noInertia || this._inertia.record(t1), this._fireEvents(e1, r, !0);
                        }, Mi.prototype._fireEvents = function(e1, r, n) {
                            var i = this, a = Ti(this._eventsInProgress), o = Ti(e1), s = {};
                            for(var l in e1){
                                var c = e1[l].originalEvent;
                                this._eventsInProgress[l] || (s[l + "start"] = c), this._eventsInProgress[l] = e1[l];
                            }
                            for(var u in !a && o && this._fireEvent("movestart", o.originalEvent), s)this._fireEvent(u, s[u]);
                            for(var h in o && this._fireEvent("move", o.originalEvent), e1){
                                var f = e1[h].originalEvent;
                                this._fireEvent(h, f);
                            }
                            var p, d = {};
                            for(var m in this._eventsInProgress){
                                var g = this._eventsInProgress[m], y = g.handlerName, v = g.originalEvent;
                                this._handlersById[y].isActive() || (delete this._eventsInProgress[m], p = r[y] || v, d[m + "end"] = p);
                            }
                            for(var x in d)this._fireEvent(x, d[x]);
                            var _ = Ti(this._eventsInProgress);
                            if (n && (a || o) && !_) {
                                this._updatingCamera = !0;
                                var b = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), w = function(t1) {
                                    return 0 !== t1 && -i._bearingSnap < t1 && t1 < i._bearingSnap;
                                };
                                b ? (w(b.bearing || this._map.getBearing()) && (b.bearing = 0), this._map.easeTo(b, {
                                    originalEvent: p
                                })) : (this._map.fire(new t1.Event("moveend", {
                                    originalEvent: p
                                })), w(this._map.getBearing()) && this._map.resetNorth()), this._updatingCamera = !1;
                            }
                        }, Mi.prototype._fireEvent = function(e1, r) {
                            this._map.fire(new t1.Event(e1, r ? {
                                originalEvent: r
                            } : {}));
                        }, Mi.prototype._requestFrame = function() {
                            var t1 = this;
                            return this._map.triggerRepaint(), this._map._renderTaskQueue.add(function(e1) {
                                delete t1._frameId, t1.handleEvent(new ki("renderFrame", {
                                    timeStamp: e1
                                })), t1._applyChanges();
                            });
                        }, Mi.prototype._triggerRenderFrame = function() {
                            void 0 === this._frameId && (this._frameId = this._requestFrame());
                        };
                        var Si = function(e1) {
                            function r(r, n) {
                                e1.call(this), this._moving = !1, this._zooming = !1, this.transform = r, this._bearingSnap = n.bearingSnap, t1.bindAll([
                                    "_renderFrameCallback"
                                ], this);
                            }
                            return e1 && (r.__proto__ = e1), r.prototype = Object.create(e1 && e1.prototype), r.prototype.constructor = r, r.prototype.getCenter = function() {
                                return new t1.LngLat(this.transform.center.lng, this.transform.center.lat);
                            }, r.prototype.setCenter = function(t1, e1) {
                                return this.jumpTo({
                                    center: t1
                                }, e1);
                            }, r.prototype.panBy = function(e1, r, n) {
                                return e1 = t1.Point.convert(e1).mult(-1), this.panTo(this.transform.center, t1.extend({
                                    offset: e1
                                }, r), n);
                            }, r.prototype.panTo = function(e1, r, n) {
                                return this.easeTo(t1.extend({
                                    center: e1
                                }, r), n);
                            }, r.prototype.getZoom = function() {
                                return this.transform.zoom;
                            }, r.prototype.setZoom = function(t1, e1) {
                                return this.jumpTo({
                                    zoom: t1
                                }, e1), this;
                            }, r.prototype.zoomTo = function(e1, r, n) {
                                return this.easeTo(t1.extend({
                                    zoom: e1
                                }, r), n);
                            }, r.prototype.zoomIn = function(t1, e1) {
                                return this.zoomTo(this.getZoom() + 1, t1, e1), this;
                            }, r.prototype.zoomOut = function(t1, e1) {
                                return this.zoomTo(this.getZoom() - 1, t1, e1), this;
                            }, r.prototype.getBearing = function() {
                                return this.transform.bearing;
                            }, r.prototype.setBearing = function(t1, e1) {
                                return this.jumpTo({
                                    bearing: t1
                                }, e1), this;
                            }, r.prototype.getPadding = function() {
                                return this.transform.padding;
                            }, r.prototype.setPadding = function(t1, e1) {
                                return this.jumpTo({
                                    padding: t1
                                }, e1), this;
                            }, r.prototype.rotateTo = function(e1, r, n) {
                                return this.easeTo(t1.extend({
                                    bearing: e1
                                }, r), n);
                            }, r.prototype.resetNorth = function(e1, r) {
                                return this.rotateTo(0, t1.extend({
                                    duration: 1e3
                                }, e1), r), this;
                            }, r.prototype.resetNorthPitch = function(e1, r) {
                                return this.easeTo(t1.extend({
                                    bearing: 0,
                                    pitch: 0,
                                    duration: 1e3
                                }, e1), r), this;
                            }, r.prototype.snapToNorth = function(t1, e1) {
                                return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(t1, e1) : this;
                            }, r.prototype.getPitch = function() {
                                return this.transform.pitch;
                            }, r.prototype.setPitch = function(t1, e1) {
                                return this.jumpTo({
                                    pitch: t1
                                }, e1), this;
                            }, r.prototype.cameraForBounds = function(e1, r) {
                                e1 = t1.LngLatBounds.convert(e1);
                                var n = r && r.bearing || 0;
                                return this._cameraForBoxAndBearing(e1.getNorthWest(), e1.getSouthEast(), n, r);
                            }, r.prototype._cameraForBoxAndBearing = function(e1, r, n, i) {
                                var a = {
                                    top: 0,
                                    bottom: 0,
                                    right: 0,
                                    left: 0
                                };
                                if ("number" == typeof (i = t1.extend({
                                    padding: a,
                                    offset: [
                                        0,
                                        0
                                    ],
                                    maxZoom: this.transform.maxZoom
                                }, i)).padding) {
                                    var o = i.padding;
                                    i.padding = {
                                        top: o,
                                        bottom: o,
                                        right: o,
                                        left: o
                                    };
                                }
                                i.padding = t1.extend(a, i.padding);
                                var s = this.transform, l = s.padding, c = s.project(t1.LngLat.convert(e1)), u = s.project(t1.LngLat.convert(r)), h = c.rotate(-n * Math.PI / 180), f = u.rotate(-n * Math.PI / 180), p = new t1.Point(Math.max(h.x, f.x), Math.max(h.y, f.y)), d = new t1.Point(Math.min(h.x, f.x), Math.min(h.y, f.y)), m = p.sub(d), g = (s.width - (l.left + l.right + i.padding.left + i.padding.right)) / m.x, y = (s.height - (l.top + l.bottom + i.padding.top + i.padding.bottom)) / m.y;
                                if (!(y < 0 || g < 0)) {
                                    var v = Math.min(s.scaleZoom(s.scale * Math.min(g, y)), i.maxZoom), x = "number" == typeof i.offset.x ? new t1.Point(i.offset.x, i.offset.y) : t1.Point.convert(i.offset), _ = (i.padding.left - i.padding.right) / 2, b = (i.padding.top - i.padding.bottom) / 2, w = new t1.Point(_, b).rotate(n * Math.PI / 180), T = x.add(w).mult(s.scale / s.zoomScale(v));
                                    return {
                                        center: s.unproject(c.add(u).div(2).sub(T)),
                                        zoom: v,
                                        bearing: n
                                    };
                                }
                                t1.warnOnce("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
                            }, r.prototype.fitBounds = function(t1, e1, r) {
                                return this._fitInternal(this.cameraForBounds(t1, e1), e1, r);
                            }, r.prototype.fitScreenCoordinates = function(e1, r, n, i, a) {
                                return this._fitInternal(this._cameraForBoxAndBearing(this.transform.pointLocation(t1.Point.convert(e1)), this.transform.pointLocation(t1.Point.convert(r)), n, i), i, a);
                            }, r.prototype._fitInternal = function(e1, r, n) {
                                return e1 ? (delete (r = t1.extend(e1, r)).padding, r.linear ? this.easeTo(r, n) : this.flyTo(r, n)) : this;
                            }, r.prototype.jumpTo = function(e1, r) {
                                this.stop();
                                var n = this.transform, i = !1, a = !1, o = !1;
                                return "zoom" in e1 && n.zoom !== +e1.zoom && (i = !0, n.zoom = +e1.zoom), void 0 !== e1.center && (n.center = t1.LngLat.convert(e1.center)), "bearing" in e1 && n.bearing !== +e1.bearing && (a = !0, n.bearing = +e1.bearing), "pitch" in e1 && n.pitch !== +e1.pitch && (o = !0, n.pitch = +e1.pitch), null == e1.padding || n.isPaddingEqual(e1.padding) || (n.padding = e1.padding), this.fire(new t1.Event("movestart", r)).fire(new t1.Event("move", r)), i && this.fire(new t1.Event("zoomstart", r)).fire(new t1.Event("zoom", r)).fire(new t1.Event("zoomend", r)), a && this.fire(new t1.Event("rotatestart", r)).fire(new t1.Event("rotate", r)).fire(new t1.Event("rotateend", r)), o && this.fire(new t1.Event("pitchstart", r)).fire(new t1.Event("pitch", r)).fire(new t1.Event("pitchend", r)), this.fire(new t1.Event("moveend", r));
                            }, r.prototype.easeTo = function(e1, r) {
                                var n = this;
                                this._stop(!1, e1.easeId), (!1 === (e1 = t1.extend({
                                    offset: [
                                        0,
                                        0
                                    ],
                                    duration: 500,
                                    easing: t1.ease
                                }, e1)).animate || !e1.essential && t1.browser.prefersReducedMotion) && (e1.duration = 0);
                                var i = this.transform, a = this.getZoom(), o = this.getBearing(), s = this.getPitch(), l = this.getPadding(), c = "zoom" in e1 ? +e1.zoom : a, u = "bearing" in e1 ? this._normalizeBearing(e1.bearing, o) : o, h = "pitch" in e1 ? +e1.pitch : s, f = "padding" in e1 ? e1.padding : i.padding, p = t1.Point.convert(e1.offset), d = i.centerPoint.add(p), m = i.pointLocation(d), g = t1.LngLat.convert(e1.center || m);
                                this._normalizeCenter(g);
                                var y, v, x = i.project(m), _ = i.project(g).sub(x), b = i.zoomScale(c - a);
                                e1.around && (y = t1.LngLat.convert(e1.around), v = i.locationPoint(y));
                                var w = {
                                    moving: this._moving,
                                    zooming: this._zooming,
                                    rotating: this._rotating,
                                    pitching: this._pitching
                                };
                                return this._zooming = this._zooming || c !== a, this._rotating = this._rotating || o !== u, this._pitching = this._pitching || h !== s, this._padding = !i.isPaddingEqual(f), this._easeId = e1.easeId, this._prepareEase(r, e1.noMoveStart, w), this._ease(function(e1) {
                                    if (n._zooming && (i.zoom = t1.number(a, c, e1)), n._rotating && (i.bearing = t1.number(o, u, e1)), n._pitching && (i.pitch = t1.number(s, h, e1)), n._padding && (i.interpolatePadding(l, f, e1), d = i.centerPoint.add(p)), y) i.setLocationAtPoint(y, v);
                                    else {
                                        var m = i.zoomScale(i.zoom - a), g = c > a ? Math.min(2, b) : Math.max(.5, b), w = Math.pow(g, 1 - e1), T = i.unproject(x.add(_.mult(e1 * w)).mult(m));
                                        i.setLocationAtPoint(i.renderWorldCopies ? T.wrap() : T, d);
                                    }
                                    n._fireMoveEvents(r);
                                }, function(t1) {
                                    n._afterEase(r, t1);
                                }, e1), this;
                            }, r.prototype._prepareEase = function(e1, r, n) {
                                void 0 === n && (n = {}), this._moving = !0, r || n.moving || this.fire(new t1.Event("movestart", e1)), this._zooming && !n.zooming && this.fire(new t1.Event("zoomstart", e1)), this._rotating && !n.rotating && this.fire(new t1.Event("rotatestart", e1)), this._pitching && !n.pitching && this.fire(new t1.Event("pitchstart", e1));
                            }, r.prototype._fireMoveEvents = function(e1) {
                                this.fire(new t1.Event("move", e1)), this._zooming && this.fire(new t1.Event("zoom", e1)), this._rotating && this.fire(new t1.Event("rotate", e1)), this._pitching && this.fire(new t1.Event("pitch", e1));
                            }, r.prototype._afterEase = function(e1, r) {
                                if (!this._easeId || !r || this._easeId !== r) {
                                    delete this._easeId;
                                    var n = this._zooming, i = this._rotating, a = this._pitching;
                                    this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._padding = !1, n && this.fire(new t1.Event("zoomend", e1)), i && this.fire(new t1.Event("rotateend", e1)), a && this.fire(new t1.Event("pitchend", e1)), this.fire(new t1.Event("moveend", e1));
                                }
                            }, r.prototype.flyTo = function(e1, r) {
                                var n = this;
                                if (!e1.essential && t1.browser.prefersReducedMotion) {
                                    var i = t1.pick(e1, [
                                        "center",
                                        "zoom",
                                        "bearing",
                                        "pitch",
                                        "around"
                                    ]);
                                    return this.jumpTo(i, r);
                                }
                                this.stop(), e1 = t1.extend({
                                    offset: [
                                        0,
                                        0
                                    ],
                                    speed: 1.2,
                                    curve: 1.42,
                                    easing: t1.ease
                                }, e1);
                                var a = this.transform, o = this.getZoom(), s = this.getBearing(), l = this.getPitch(), c = this.getPadding(), u = "zoom" in e1 ? t1.clamp(+e1.zoom, a.minZoom, a.maxZoom) : o, h = "bearing" in e1 ? this._normalizeBearing(e1.bearing, s) : s, f = "pitch" in e1 ? +e1.pitch : l, p = "padding" in e1 ? e1.padding : a.padding, d = a.zoomScale(u - o), m = t1.Point.convert(e1.offset), g = a.centerPoint.add(m), y = a.pointLocation(g), v = t1.LngLat.convert(e1.center || y);
                                this._normalizeCenter(v);
                                var x = a.project(y), _ = a.project(v).sub(x), b = e1.curve, w = Math.max(a.width, a.height), T = w / d, k = _.mag();
                                if ("minZoom" in e1) {
                                    var A = t1.clamp(Math.min(e1.minZoom, o, u), a.minZoom, a.maxZoom), M = w / a.zoomScale(A - o);
                                    b = Math.sqrt(M / k * 2);
                                }
                                var S = b * b;
                                function E(t1) {
                                    var e1 = (T * T - w * w + (t1 ? -1 : 1) * S * S * k * k) / (2 * (t1 ? T : w) * S * k);
                                    return Math.log(Math.sqrt(e1 * e1 + 1) - e1);
                                }
                                function C(t1) {
                                    return (Math.exp(t1) - Math.exp(-t1)) / 2;
                                }
                                function L(t1) {
                                    return (Math.exp(t1) + Math.exp(-t1)) / 2;
                                }
                                var I = E(0), P = function(t1) {
                                    return L(I) / L(I + b * t1);
                                }, z = function(t1) {
                                    var e1;
                                    return w * ((L(I) * (C(e1 = I + b * t1) / L(e1)) - C(I)) / S) / k;
                                }, O = (E(1) - I) / b;
                                if (Math.abs(k) < 1e-6 || !isFinite(O)) {
                                    if (Math.abs(w - T) < 1e-6) return this.easeTo(e1, r);
                                    var D = T < w ? -1 : 1;
                                    O = Math.abs(Math.log(T / w)) / b, z = function() {
                                        return 0;
                                    }, P = function(t1) {
                                        return Math.exp(D * b * t1);
                                    };
                                }
                                if ("duration" in e1) e1.duration = +e1.duration;
                                else {
                                    var R = "screenSpeed" in e1 ? +e1.screenSpeed / b : +e1.speed;
                                    e1.duration = 1e3 * O / R;
                                }
                                return e1.maxDuration && e1.duration > e1.maxDuration && (e1.duration = 0), this._zooming = !0, this._rotating = s !== h, this._pitching = f !== l, this._padding = !a.isPaddingEqual(p), this._prepareEase(r, !1), this._ease(function(e1) {
                                    var i = e1 * O, d = 1 / P(i);
                                    a.zoom = 1 === e1 ? u : o + a.scaleZoom(d), n._rotating && (a.bearing = t1.number(s, h, e1)), n._pitching && (a.pitch = t1.number(l, f, e1)), n._padding && (a.interpolatePadding(c, p, e1), g = a.centerPoint.add(m));
                                    var y = 1 === e1 ? v : a.unproject(x.add(_.mult(z(i))).mult(d));
                                    a.setLocationAtPoint(a.renderWorldCopies ? y.wrap() : y, g), n._fireMoveEvents(r);
                                }, function() {
                                    return n._afterEase(r);
                                }, e1), this;
                            }, r.prototype.isEasing = function() {
                                return !!this._easeFrameId;
                            }, r.prototype.stop = function() {
                                return this._stop();
                            }, r.prototype._stop = function(t1, e1) {
                                if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), delete this._easeFrameId, delete this._onEaseFrame), this._onEaseEnd) {
                                    var r = this._onEaseEnd;
                                    delete this._onEaseEnd, r.call(this, e1);
                                }
                                if (!t1) {
                                    var n = this.handlers;
                                    n && n.stop(!1);
                                }
                                return this;
                            }, r.prototype._ease = function(e1, r, n) {
                                !1 === n.animate || 0 === n.duration ? (e1(1), r()) : (this._easeStart = t1.browser.now(), this._easeOptions = n, this._onEaseFrame = e1, this._onEaseEnd = r, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
                            }, r.prototype._renderFrameCallback = function() {
                                var e1 = Math.min((t1.browser.now() - this._easeStart) / this._easeOptions.duration, 1);
                                this._onEaseFrame(this._easeOptions.easing(e1)), e1 < 1 ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
                            }, r.prototype._normalizeBearing = function(e1, r) {
                                e1 = t1.wrap(e1, -180, 180);
                                var n = Math.abs(e1 - r);
                                return Math.abs(e1 - 360 - r) < n && (e1 -= 360), Math.abs(e1 + 360 - r) < n && (e1 += 360), e1;
                            }, r.prototype._normalizeCenter = function(t1) {
                                var e1 = this.transform;
                                if (e1.renderWorldCopies && !e1.lngRange) {
                                    var r = t1.lng - e1.center.lng;
                                    t1.lng += r > 180 ? -360 : r < -180 ? 360 : 0;
                                }
                            }, r;
                        }(t1.Evented), Ei = function(e1) {
                            void 0 === e1 && (e1 = {}), this.options = e1, t1.bindAll([
                                "_toggleAttribution",
                                "_updateEditLink",
                                "_updateData",
                                "_updateCompact"
                            ], this);
                        };
                        Ei.prototype.getDefaultPosition = function() {
                            return "bottom-right";
                        }, Ei.prototype.onAdd = function(t1) {
                            var e1 = this.options && this.options.compact;
                            return this._map = t1, this._container = r.create("div", "mapboxgl-ctrl mapboxgl-ctrl-attrib"), this._compactButton = r.create("button", "mapboxgl-ctrl-attrib-button", this._container), this._compactButton.addEventListener("click", this._toggleAttribution), this._setElementTitle(this._compactButton, "ToggleAttribution"), this._innerContainer = r.create("div", "mapboxgl-ctrl-attrib-inner", this._container), this._innerContainer.setAttribute("role", "list"), e1 && this._container.classList.add("mapboxgl-compact"), this._updateAttributions(), this._updateEditLink(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("moveend", this._updateEditLink), void 0 === e1 && (this._map.on("resize", this._updateCompact), this._updateCompact()), this._container;
                        }, Ei.prototype.onRemove = function() {
                            r.remove(this._container), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("moveend", this._updateEditLink), this._map.off("resize", this._updateCompact), this._map = void 0, this._attribHTML = void 0;
                        }, Ei.prototype._setElementTitle = function(t1, e1) {
                            var r = this._map._getUIString("AttributionControl." + e1);
                            t1.title = r, t1.setAttribute("aria-label", r);
                        }, Ei.prototype._toggleAttribution = function() {
                            this._container.classList.contains("mapboxgl-compact-show") ? (this._container.classList.remove("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-pressed", "false")) : (this._container.classList.add("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-pressed", "true"));
                        }, Ei.prototype._updateEditLink = function() {
                            var e1 = this._editLink;
                            e1 || (e1 = this._editLink = this._container.querySelector(".mapbox-improve-map"));
                            var r = [
                                {
                                    key: "owner",
                                    value: this.styleOwner
                                },
                                {
                                    key: "id",
                                    value: this.styleId
                                },
                                {
                                    key: "access_token",
                                    value: this._map._requestManager._customAccessToken || t1.config.ACCESS_TOKEN
                                }
                            ];
                            if (e1) {
                                var n = r.reduce(function(t1, e1, n) {
                                    return e1.value && (t1 += e1.key + "=" + e1.value + (n < r.length - 1 ? "&" : "")), t1;
                                }, "?");
                                e1.href = t1.config.FEEDBACK_URL + "/" + n + (this._map._hash ? this._map._hash.getHashString(!0) : ""), e1.rel = "noopener nofollow", this._setElementTitle(e1, "MapFeedback");
                            }
                        }, Ei.prototype._updateData = function(t1) {
                            !t1 || "metadata" !== t1.sourceDataType && "visibility" !== t1.sourceDataType && "style" !== t1.dataType || (this._updateAttributions(), this._updateEditLink());
                        }, Ei.prototype._updateAttributions = function() {
                            if (this._map.style) {
                                var t1 = [];
                                if (this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? t1 = t1.concat(this.options.customAttribution.map(function(t1) {
                                    return "string" != typeof t1 ? "" : t1;
                                })) : "string" == typeof this.options.customAttribution && t1.push(this.options.customAttribution)), this._map.style.stylesheet) {
                                    var e1 = this._map.style.stylesheet;
                                    this.styleOwner = e1.owner, this.styleId = e1.id;
                                }
                                var r = this._map.style.sourceCaches;
                                for(var n in r){
                                    var i = r[n];
                                    if (i.used) {
                                        var a = i.getSource();
                                        a.attribution && t1.indexOf(a.attribution) < 0 && t1.push(a.attribution);
                                    }
                                }
                                t1.sort(function(t1, e1) {
                                    return t1.length - e1.length;
                                });
                                var o = (t1 = t1.filter(function(e1, r) {
                                    for(var n = r + 1; n < t1.length; n++)if (t1[n].indexOf(e1) >= 0) return !1;
                                    return !0;
                                })).join(" | ");
                                o !== this._attribHTML && (this._attribHTML = o, t1.length ? (this._innerContainer.innerHTML = o, this._container.classList.remove("mapboxgl-attrib-empty")) : this._container.classList.add("mapboxgl-attrib-empty"), this._editLink = null);
                            }
                        }, Ei.prototype._updateCompact = function() {
                            this._map.getCanvasContainer().offsetWidth <= 640 ? this._container.classList.add("mapboxgl-compact") : this._container.classList.remove("mapboxgl-compact", "mapboxgl-compact-show");
                        };
                        var Ci = function() {
                            t1.bindAll([
                                "_updateLogo"
                            ], this), t1.bindAll([
                                "_updateCompact"
                            ], this);
                        };
                        Ci.prototype.onAdd = function(t1) {
                            this._map = t1, this._container = r.create("div", "mapboxgl-ctrl");
                            var e1 = r.create("a", "mapboxgl-ctrl-logo");
                            return e1.target = "_blank", e1.rel = "noopener nofollow", e1.href = "https://www.mapbox.com/", e1.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), e1.setAttribute("rel", "noopener nofollow"), this._container.appendChild(e1), this._container.style.display = "none", this._map.on("sourcedata", this._updateLogo), this._updateLogo(), this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
                        }, Ci.prototype.onRemove = function() {
                            r.remove(this._container), this._map.off("sourcedata", this._updateLogo), this._map.off("resize", this._updateCompact);
                        }, Ci.prototype.getDefaultPosition = function() {
                            return "bottom-left";
                        }, Ci.prototype._updateLogo = function(t1) {
                            t1 && "metadata" !== t1.sourceDataType || (this._container.style.display = this._logoRequired() ? "block" : "none");
                        }, Ci.prototype._logoRequired = function() {
                            if (this._map.style) {
                                var t1 = this._map.style.sourceCaches;
                                for(var e1 in t1)if (t1[e1].getSource().mapbox_logo) return !0;
                                return !1;
                            }
                        }, Ci.prototype._updateCompact = function() {
                            var t1 = this._container.children;
                            if (t1.length) {
                                var e1 = t1[0];
                                this._map.getCanvasContainer().offsetWidth < 250 ? e1.classList.add("mapboxgl-compact") : e1.classList.remove("mapboxgl-compact");
                            }
                        };
                        var Li = function() {
                            this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
                        };
                        Li.prototype.add = function(t1) {
                            var e1 = ++this._id;
                            return this._queue.push({
                                callback: t1,
                                id: e1,
                                cancelled: !1
                            }), e1;
                        }, Li.prototype.remove = function(t1) {
                            for(var e1 = this._currentlyRunning, r = 0, n = e1 ? this._queue.concat(e1) : this._queue; r < n.length; r += 1){
                                var i = n[r];
                                if (i.id === t1) return void (i.cancelled = !0);
                            }
                        }, Li.prototype.run = function(t1) {
                            void 0 === t1 && (t1 = 0);
                            var e1 = this._currentlyRunning = this._queue;
                            this._queue = [];
                            for(var r = 0, n = e1; r < n.length; r += 1){
                                var i = n[r];
                                if (!i.cancelled && (i.callback(t1), this._cleared)) break;
                            }
                            this._cleared = !1, this._currentlyRunning = !1;
                        }, Li.prototype.clear = function() {
                            this._currentlyRunning && (this._cleared = !0), this._queue = [];
                        };
                        var Ii = {
                            "AttributionControl.ToggleAttribution": "Toggle attribution",
                            "AttributionControl.MapFeedback": "Map feedback",
                            "FullscreenControl.Enter": "Enter fullscreen",
                            "FullscreenControl.Exit": "Exit fullscreen",
                            "GeolocateControl.FindMyLocation": "Find my location",
                            "GeolocateControl.LocationNotAvailable": "Location not available",
                            "LogoControl.Title": "Mapbox logo",
                            "NavigationControl.ResetBearing": "Reset bearing to north",
                            "NavigationControl.ZoomIn": "Zoom in",
                            "NavigationControl.ZoomOut": "Zoom out",
                            "ScaleControl.Feet": "ft",
                            "ScaleControl.Meters": "m",
                            "ScaleControl.Kilometers": "km",
                            "ScaleControl.Miles": "mi",
                            "ScaleControl.NauticalMiles": "nm"
                        }, Pi = t1.window.HTMLImageElement, zi = t1.window.HTMLElement, Oi = t1.window.ImageBitmap, Di = 60, Ri = {
                            center: [
                                0,
                                0
                            ],
                            zoom: 0,
                            bearing: 0,
                            pitch: 0,
                            minZoom: -2,
                            maxZoom: 22,
                            minPitch: 0,
                            maxPitch: Di,
                            interactive: !0,
                            scrollZoom: !0,
                            boxZoom: !0,
                            dragRotate: !0,
                            dragPan: !0,
                            keyboard: !0,
                            doubleClickZoom: !0,
                            touchZoomRotate: !0,
                            touchPitch: !0,
                            bearingSnap: 7,
                            clickTolerance: 3,
                            pitchWithRotate: !0,
                            hash: !1,
                            attributionControl: !0,
                            failIfMajorPerformanceCaveat: !1,
                            preserveDrawingBuffer: !1,
                            trackResize: !0,
                            renderWorldCopies: !0,
                            refreshExpiredTiles: !0,
                            maxTileCacheSize: null,
                            localIdeographFontFamily: "sans-serif",
                            transformRequest: null,
                            accessToken: null,
                            fadeDuration: 300,
                            crossSourceCollisions: !0
                        }, Fi = function(n) {
                            function i(e1) {
                                var r = this;
                                if (null != (e1 = t1.extend({}, Ri, e1)).minZoom && null != e1.maxZoom && e1.minZoom > e1.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
                                if (null != e1.minPitch && null != e1.maxPitch && e1.minPitch > e1.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
                                if (null != e1.minPitch && e1.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
                                if (null != e1.maxPitch && e1.maxPitch > Di) throw new Error("maxPitch must be less than or equal to 60");
                                var i = new In(e1.minZoom, e1.maxZoom, e1.minPitch, e1.maxPitch, e1.renderWorldCopies);
                                if (n.call(this, i, e1), this._interactive = e1.interactive, this._maxTileCacheSize = e1.maxTileCacheSize, this._failIfMajorPerformanceCaveat = e1.failIfMajorPerformanceCaveat, this._preserveDrawingBuffer = e1.preserveDrawingBuffer, this._antialias = e1.antialias, this._trackResize = e1.trackResize, this._bearingSnap = e1.bearingSnap, this._refreshExpiredTiles = e1.refreshExpiredTiles, this._fadeDuration = e1.fadeDuration, this._crossSourceCollisions = e1.crossSourceCollisions, this._crossFadingFactor = 1, this._collectResourceTiming = e1.collectResourceTiming, this._renderTaskQueue = new Li, this._controls = [], this._mapId = t1.uniqueId(), this._locale = t1.extend({}, Ii, e1.locale), this._clickTolerance = e1.clickTolerance, this._requestManager = new t1.RequestManager(e1.transformRequest, e1.accessToken), "string" == typeof e1.container) {
                                    if (this._container = t1.window.document.getElementById(e1.container), !this._container) throw new Error("Container '" + e1.container + "' not found.");
                                } else {
                                    if (!(e1.container instanceof zi)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
                                    this._container = e1.container;
                                }
                                if (e1.maxBounds && this.setMaxBounds(e1.maxBounds), t1.bindAll([
                                    "_onWindowOnline",
                                    "_onWindowResize",
                                    "_onMapScroll",
                                    "_contextLost",
                                    "_contextRestored"
                                ], this), this._setupContainer(), this._setupPainter(), void 0 === this.painter) throw new Error("Failed to initialize WebGL.");
                                this.on("move", function() {
                                    return r._update(!1);
                                }), this.on("moveend", function() {
                                    return r._update(!1);
                                }), this.on("zoom", function() {
                                    return r._update(!0);
                                }), void 0 !== t1.window && (t1.window.addEventListener("online", this._onWindowOnline, !1), t1.window.addEventListener("resize", this._onWindowResize, !1), t1.window.addEventListener("orientationchange", this._onWindowResize, !1)), this.handlers = new Mi(this, e1);
                                var a = "string" == typeof e1.hash && e1.hash || void 0;
                                this._hash = e1.hash && new zn(a).addTo(this), this._hash && this._hash._onHashChange() || (this.jumpTo({
                                    center: e1.center,
                                    zoom: e1.zoom,
                                    bearing: e1.bearing,
                                    pitch: e1.pitch
                                }), e1.bounds && (this.resize(), this.fitBounds(e1.bounds, t1.extend({}, e1.fitBoundsOptions, {
                                    duration: 0
                                })))), this.resize(), this._localIdeographFontFamily = e1.localIdeographFontFamily, e1.style && this.setStyle(e1.style, {
                                    localIdeographFontFamily: e1.localIdeographFontFamily
                                }), e1.attributionControl && this.addControl(new Ei({
                                    customAttribution: e1.customAttribution
                                })), this.addControl(new Ci, e1.logoPosition), this.on("style.load", function() {
                                    r.transform.unmodified && r.jumpTo(r.style.stylesheet);
                                }), this.on("data", function(e1) {
                                    r._update("style" === e1.dataType), r.fire(new t1.Event(e1.dataType + "data", e1));
                                }), this.on("dataloading", function(e1) {
                                    r.fire(new t1.Event(e1.dataType + "dataloading", e1));
                                });
                            }
                            n && (i.__proto__ = n), i.prototype = Object.create(n && n.prototype), i.prototype.constructor = i;
                            var a = {
                                showTileBoundaries: {
                                    configurable: !0
                                },
                                showPadding: {
                                    configurable: !0
                                },
                                showCollisionBoxes: {
                                    configurable: !0
                                },
                                showOverdrawInspector: {
                                    configurable: !0
                                },
                                repaint: {
                                    configurable: !0
                                },
                                vertices: {
                                    configurable: !0
                                },
                                version: {
                                    configurable: !0
                                }
                            };
                            return i.prototype._getMapId = function() {
                                return this._mapId;
                            }, i.prototype.addControl = function(e1, r) {
                                if (void 0 === r && (r = e1.getDefaultPosition ? e1.getDefaultPosition() : "top-right"), !e1 || !e1.onAdd) return this.fire(new t1.ErrorEvent(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
                                var n = e1.onAdd(this);
                                this._controls.push(e1);
                                var i = this._controlPositions[r];
                                return -1 !== r.indexOf("bottom") ? i.insertBefore(n, i.firstChild) : i.appendChild(n), this;
                            }, i.prototype.removeControl = function(e1) {
                                if (!e1 || !e1.onRemove) return this.fire(new t1.ErrorEvent(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
                                var r = this._controls.indexOf(e1);
                                return r > -1 && this._controls.splice(r, 1), e1.onRemove(this), this;
                            }, i.prototype.hasControl = function(t1) {
                                return this._controls.indexOf(t1) > -1;
                            }, i.prototype.resize = function(e1) {
                                var r = this._containerDimensions(), n = r[0], i = r[1];
                                this._resizeCanvas(n, i), this.transform.resize(n, i), this.painter.resize(n, i);
                                var a = !this._moving;
                                return a && (this.stop(), this.fire(new t1.Event("movestart", e1)).fire(new t1.Event("move", e1))), this.fire(new t1.Event("resize", e1)), a && this.fire(new t1.Event("moveend", e1)), this;
                            }, i.prototype.getBounds = function() {
                                return this.transform.getBounds();
                            }, i.prototype.getMaxBounds = function() {
                                return this.transform.getMaxBounds();
                            }, i.prototype.setMaxBounds = function(e1) {
                                return this.transform.setMaxBounds(t1.LngLatBounds.convert(e1)), this._update();
                            }, i.prototype.setMinZoom = function(t1) {
                                if ((t1 = null == t1 ? -2 : t1) >= -2 && t1 <= this.transform.maxZoom) return this.transform.minZoom = t1, this._update(), this.getZoom() < t1 && this.setZoom(t1), this;
                                throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
                            }, i.prototype.getMinZoom = function() {
                                return this.transform.minZoom;
                            }, i.prototype.setMaxZoom = function(t1) {
                                if ((t1 = null == t1 ? 22 : t1) >= this.transform.minZoom) return this.transform.maxZoom = t1, this._update(), this.getZoom() > t1 && this.setZoom(t1), this;
                                throw new Error("maxZoom must be greater than the current minZoom");
                            }, i.prototype.getMaxZoom = function() {
                                return this.transform.maxZoom;
                            }, i.prototype.setMinPitch = function(t1) {
                                if ((t1 = null == t1 ? 0 : t1) < 0) throw new Error("minPitch must be greater than or equal to 0");
                                if (t1 >= 0 && t1 <= this.transform.maxPitch) return this.transform.minPitch = t1, this._update(), this.getPitch() < t1 && this.setPitch(t1), this;
                                throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
                            }, i.prototype.getMinPitch = function() {
                                return this.transform.minPitch;
                            }, i.prototype.setMaxPitch = function(t1) {
                                if ((t1 = null == t1 ? Di : t1) > Di) throw new Error("maxPitch must be less than or equal to 60");
                                if (t1 >= this.transform.minPitch) return this.transform.maxPitch = t1, this._update(), this.getPitch() > t1 && this.setPitch(t1), this;
                                throw new Error("maxPitch must be greater than the current minPitch");
                            }, i.prototype.getMaxPitch = function() {
                                return this.transform.maxPitch;
                            }, i.prototype.getRenderWorldCopies = function() {
                                return this.transform.renderWorldCopies;
                            }, i.prototype.setRenderWorldCopies = function(t1) {
                                return this.transform.renderWorldCopies = t1, this._update();
                            }, i.prototype.project = function(e1) {
                                return this.transform.locationPoint(t1.LngLat.convert(e1));
                            }, i.prototype.unproject = function(e1) {
                                return this.transform.pointLocation(t1.Point.convert(e1));
                            }, i.prototype.isMoving = function() {
                                return this._moving || this.handlers.isMoving();
                            }, i.prototype.isZooming = function() {
                                return this._zooming || this.handlers.isZooming();
                            }, i.prototype.isRotating = function() {
                                return this._rotating || this.handlers.isRotating();
                            }, i.prototype._createDelegatedListener = function(t1, e1, r) {
                                var n, i = this;
                                if ("mouseenter" === t1 || "mouseover" === t1) {
                                    var a = !1;
                                    return {
                                        layer: e1,
                                        listener: r,
                                        delegates: {
                                            mousemove: function(n) {
                                                var o = i.getLayer(e1) ? i.queryRenderedFeatures(n.point, {
                                                    layers: [
                                                        e1
                                                    ]
                                                }) : [];
                                                o.length ? a || (a = !0, r.call(i, new Vn(t1, i, n.originalEvent, {
                                                    features: o
                                                }))) : a = !1;
                                            },
                                            mouseout: function() {
                                                a = !1;
                                            }
                                        }
                                    };
                                }
                                if ("mouseleave" === t1 || "mouseout" === t1) {
                                    var o = !1;
                                    return {
                                        layer: e1,
                                        listener: r,
                                        delegates: {
                                            mousemove: function(n) {
                                                (i.getLayer(e1) ? i.queryRenderedFeatures(n.point, {
                                                    layers: [
                                                        e1
                                                    ]
                                                }) : []).length ? o = !0 : o && (o = !1, r.call(i, new Vn(t1, i, n.originalEvent)));
                                            },
                                            mouseout: function(e1) {
                                                o && (o = !1, r.call(i, new Vn(t1, i, e1.originalEvent)));
                                            }
                                        }
                                    };
                                }
                                return {
                                    layer: e1,
                                    listener: r,
                                    delegates: (n = {}, n[t1] = function(t1) {
                                        var n = i.getLayer(e1) ? i.queryRenderedFeatures(t1.point, {
                                            layers: [
                                                e1
                                            ]
                                        }) : [];
                                        n.length && (t1.features = n, r.call(i, t1), delete t1.features);
                                    }, n)
                                };
                            }, i.prototype.on = function(t1, e1, r) {
                                if (void 0 === r) return n.prototype.on.call(this, t1, e1);
                                var i = this._createDelegatedListener(t1, e1, r);
                                for(var a in this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[t1] = this._delegatedListeners[t1] || [], this._delegatedListeners[t1].push(i), i.delegates)this.on(a, i.delegates[a]);
                                return this;
                            }, i.prototype.once = function(t1, e1, r) {
                                if (void 0 === r) return n.prototype.once.call(this, t1, e1);
                                var i = this._createDelegatedListener(t1, e1, r);
                                for(var a in i.delegates)this.once(a, i.delegates[a]);
                                return this;
                            }, i.prototype.off = function(t1, e1, r) {
                                var i = this;
                                if (void 0 === r) return n.prototype.off.call(this, t1, e1);
                                return this._delegatedListeners && this._delegatedListeners[t1] && function(n) {
                                    for(var a = n[t1], o = 0; o < a.length; o++){
                                        var s = a[o];
                                        if (s.layer === e1 && s.listener === r) {
                                            for(var l in s.delegates)i.off(l, s.delegates[l]);
                                            return a.splice(o, 1), i;
                                        }
                                    }
                                }(this._delegatedListeners), this;
                            }, i.prototype.queryRenderedFeatures = function(e1, r) {
                                if (!this.style) return [];
                                var n;
                                if (void 0 !== r || void 0 === e1 || e1 instanceof t1.Point || Array.isArray(e1) || (r = e1, e1 = void 0), r = r || {}, (e1 = e1 || [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        this.transform.width,
                                        this.transform.height
                                    ]
                                ]) instanceof t1.Point || "number" == typeof e1[0]) n = [
                                    t1.Point.convert(e1)
                                ];
                                else {
                                    var i = t1.Point.convert(e1[0]), a = t1.Point.convert(e1[1]);
                                    n = [
                                        i,
                                        new t1.Point(a.x, i.y),
                                        a,
                                        new t1.Point(i.x, a.y),
                                        i
                                    ];
                                }
                                return this.style.queryRenderedFeatures(n, r, this.transform);
                            }, i.prototype.querySourceFeatures = function(t1, e1) {
                                return this.style.querySourceFeatures(t1, e1);
                            }, i.prototype.setStyle = function(e1, r) {
                                return !1 !== (r = t1.extend({}, {
                                    localIdeographFontFamily: this._localIdeographFontFamily
                                }, r)).diff && r.localIdeographFontFamily === this._localIdeographFontFamily && this.style && e1 ? (this._diffStyle(e1, r), this) : (this._localIdeographFontFamily = r.localIdeographFontFamily, this._updateStyle(e1, r));
                            }, i.prototype._getUIString = function(t1) {
                                var e1 = this._locale[t1];
                                if (null == e1) throw new Error("Missing UI string '" + t1 + "'");
                                return e1;
                            }, i.prototype._updateStyle = function(t1, e1) {
                                return this.style && (this.style.setEventedParent(null), this.style._remove()), t1 ? (this.style = new We(this, e1 || {}), this.style.setEventedParent(this, {
                                    style: this.style
                                }), "string" == typeof t1 ? this.style.loadURL(t1) : this.style.loadJSON(t1), this) : (delete this.style, this);
                            }, i.prototype._lazyInitEmptyStyle = function() {
                                this.style || (this.style = new We(this, {}), this.style.setEventedParent(this, {
                                    style: this.style
                                }), this.style.loadEmpty());
                            }, i.prototype._diffStyle = function(e1, r) {
                                var n = this;
                                if ("string" == typeof e1) {
                                    var i = this._requestManager.normalizeStyleURL(e1), a = this._requestManager.transformRequest(i, t1.ResourceType.Style);
                                    t1.getJSON(a, function(e1, i) {
                                        e1 ? n.fire(new t1.ErrorEvent(e1)) : i && n._updateDiff(i, r);
                                    });
                                } else "object" == typeof e1 && this._updateDiff(e1, r);
                            }, i.prototype._updateDiff = function(e1, r) {
                                try {
                                    this.style.setState(e1) && this._update(!0);
                                } catch (n) {
                                    t1.warnOnce("Unable to perform style diff: " + (n.message || n.error || n) + ".  Rebuilding the style from scratch."), this._updateStyle(e1, r);
                                }
                            }, i.prototype.getStyle = function() {
                                if (this.style) return this.style.serialize();
                            }, i.prototype.isStyleLoaded = function() {
                                return this.style ? this.style.loaded() : t1.warnOnce("There is no style added to the map.");
                            }, i.prototype.addSource = function(t1, e1) {
                                return this._lazyInitEmptyStyle(), this.style.addSource(t1, e1), this._update(!0);
                            }, i.prototype.isSourceLoaded = function(e1) {
                                var r = this.style && this.style.sourceCaches[e1];
                                if (void 0 !== r) return r.loaded();
                                this.fire(new t1.ErrorEvent(new Error("There is no source with ID '" + e1 + "'")));
                            }, i.prototype.areTilesLoaded = function() {
                                var t1 = this.style && this.style.sourceCaches;
                                for(var e1 in t1){
                                    var r = t1[e1]._tiles;
                                    for(var n in r){
                                        var i = r[n];
                                        if ("loaded" !== i.state && "errored" !== i.state) return !1;
                                    }
                                }
                                return !0;
                            }, i.prototype.addSourceType = function(t1, e1, r) {
                                return this._lazyInitEmptyStyle(), this.style.addSourceType(t1, e1, r);
                            }, i.prototype.removeSource = function(t1) {
                                return this.style.removeSource(t1), this._update(!0);
                            }, i.prototype.getSource = function(t1) {
                                return this.style.getSource(t1);
                            }, i.prototype.addImage = function(e1, r, n) {
                                void 0 === n && (n = {});
                                var i = n.pixelRatio;
                                void 0 === i && (i = 1);
                                var a = n.sdf;
                                void 0 === a && (a = !1);
                                var o = n.stretchX, s = n.stretchY, l = n.content;
                                this._lazyInitEmptyStyle();
                                if (r instanceof Pi || Oi && r instanceof Oi) {
                                    var c = t1.browser.getImageData(r), u = c.width, h = c.height, f = c.data;
                                    this.style.addImage(e1, {
                                        data: new t1.RGBAImage({
                                            width: u,
                                            height: h
                                        }, f),
                                        pixelRatio: i,
                                        stretchX: o,
                                        stretchY: s,
                                        content: l,
                                        sdf: a,
                                        version: 0
                                    });
                                } else {
                                    if (void 0 === r.width || void 0 === r.height) return this.fire(new t1.ErrorEvent(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                                    var p = r.width, d = r.height, m = r.data, g = r;
                                    this.style.addImage(e1, {
                                        data: new t1.RGBAImage({
                                            width: p,
                                            height: d
                                        }, new Uint8Array(m)),
                                        pixelRatio: i,
                                        stretchX: o,
                                        stretchY: s,
                                        content: l,
                                        sdf: a,
                                        version: 0,
                                        userImage: g
                                    }), g.onAdd && g.onAdd(this, e1);
                                }
                            }, i.prototype.updateImage = function(e1, r) {
                                var n = this.style.getImage(e1);
                                if (!n) return this.fire(new t1.ErrorEvent(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
                                var i = r instanceof Pi || Oi && r instanceof Oi ? t1.browser.getImageData(r) : r, a = i.width, o = i.height, s = i.data;
                                if (void 0 === a || void 0 === o) return this.fire(new t1.ErrorEvent(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                                if (a !== n.data.width || o !== n.data.height) return this.fire(new t1.ErrorEvent(new Error("The width and height of the updated image must be that same as the previous version of the image")));
                                var l = !(r instanceof Pi || Oi && r instanceof Oi);
                                n.data.replace(s, l), this.style.updateImage(e1, n);
                            }, i.prototype.hasImage = function(e1) {
                                return e1 ? !!this.style.getImage(e1) : (this.fire(new t1.ErrorEvent(new Error("Missing required image id"))), !1);
                            }, i.prototype.removeImage = function(t1) {
                                this.style.removeImage(t1);
                            }, i.prototype.loadImage = function(e1, r) {
                                t1.getImage(this._requestManager.transformRequest(e1, t1.ResourceType.Image), r);
                            }, i.prototype.listImages = function() {
                                return this.style.listImages();
                            }, i.prototype.addLayer = function(t1, e1) {
                                return this._lazyInitEmptyStyle(), this.style.addLayer(t1, e1), this._update(!0);
                            }, i.prototype.moveLayer = function(t1, e1) {
                                return this.style.moveLayer(t1, e1), this._update(!0);
                            }, i.prototype.removeLayer = function(t1) {
                                return this.style.removeLayer(t1), this._update(!0);
                            }, i.prototype.getLayer = function(t1) {
                                return this.style.getLayer(t1);
                            }, i.prototype.setLayerZoomRange = function(t1, e1, r) {
                                return this.style.setLayerZoomRange(t1, e1, r), this._update(!0);
                            }, i.prototype.setFilter = function(t1, e1, r) {
                                return void 0 === r && (r = {}), this.style.setFilter(t1, e1, r), this._update(!0);
                            }, i.prototype.getFilter = function(t1) {
                                return this.style.getFilter(t1);
                            }, i.prototype.setPaintProperty = function(t1, e1, r, n) {
                                return void 0 === n && (n = {}), this.style.setPaintProperty(t1, e1, r, n), this._update(!0);
                            }, i.prototype.getPaintProperty = function(t1, e1) {
                                return this.style.getPaintProperty(t1, e1);
                            }, i.prototype.setLayoutProperty = function(t1, e1, r, n) {
                                return void 0 === n && (n = {}), this.style.setLayoutProperty(t1, e1, r, n), this._update(!0);
                            }, i.prototype.getLayoutProperty = function(t1, e1) {
                                return this.style.getLayoutProperty(t1, e1);
                            }, i.prototype.setLight = function(t1, e1) {
                                return void 0 === e1 && (e1 = {}), this._lazyInitEmptyStyle(), this.style.setLight(t1, e1), this._update(!0);
                            }, i.prototype.getLight = function() {
                                return this.style.getLight();
                            }, i.prototype.setFeatureState = function(t1, e1) {
                                return this.style.setFeatureState(t1, e1), this._update();
                            }, i.prototype.removeFeatureState = function(t1, e1) {
                                return this.style.removeFeatureState(t1, e1), this._update();
                            }, i.prototype.getFeatureState = function(t1) {
                                return this.style.getFeatureState(t1);
                            }, i.prototype.getContainer = function() {
                                return this._container;
                            }, i.prototype.getCanvasContainer = function() {
                                return this._canvasContainer;
                            }, i.prototype.getCanvas = function() {
                                return this._canvas;
                            }, i.prototype._containerDimensions = function() {
                                var t1 = 0, e1 = 0;
                                return this._container && (t1 = this._container.clientWidth || 400, e1 = this._container.clientHeight || 300), [
                                    t1,
                                    e1
                                ];
                            }, i.prototype._detectMissingCSS = function() {
                                "rgb(250, 128, 114)" !== t1.window.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color") && t1.warnOnce("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.");
                            }, i.prototype._setupContainer = function() {
                                var t1 = this._container;
                                t1.classList.add("mapboxgl-map"), (this._missingCSSCanary = r.create("div", "mapboxgl-canary", t1)).style.visibility = "hidden", this._detectMissingCSS();
                                var e1 = this._canvasContainer = r.create("div", "mapboxgl-canvas-container", t1);
                                this._interactive && e1.classList.add("mapboxgl-interactive"), this._canvas = r.create("canvas", "mapboxgl-canvas", e1), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("tabindex", "0"), this._canvas.setAttribute("aria-label", "Map"), this._canvas.setAttribute("role", "region");
                                var n = this._containerDimensions();
                                this._resizeCanvas(n[0], n[1]);
                                var i = this._controlContainer = r.create("div", "mapboxgl-control-container", t1), a = this._controlPositions = {};
                                [
                                    "top-left",
                                    "top-right",
                                    "bottom-left",
                                    "bottom-right"
                                ].forEach(function(t1) {
                                    a[t1] = r.create("div", "mapboxgl-ctrl-" + t1, i);
                                }), this._container.addEventListener("scroll", this._onMapScroll, !1);
                            }, i.prototype._resizeCanvas = function(e1, r) {
                                var n = t1.browser.devicePixelRatio || 1;
                                this._canvas.width = n * e1, this._canvas.height = n * r, this._canvas.style.width = e1 + "px", this._canvas.style.height = r + "px";
                            }, i.prototype._setupPainter = function() {
                                var r = t1.extend({}, e1.webGLContextAttributes, {
                                    failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat,
                                    preserveDrawingBuffer: this._preserveDrawingBuffer,
                                    antialias: this._antialias || !1
                                }), n = this._canvas.getContext("webgl", r) || this._canvas.getContext("experimental-webgl", r);
                                n ? (this.painter = new Sn(n, this.transform), t1.webpSupported.testSupport(n)) : this.fire(new t1.ErrorEvent(new Error("Failed to initialize WebGL")));
                            }, i.prototype._contextLost = function(e1) {
                                e1.preventDefault(), this._frame && (this._frame.cancel(), this._frame = null), this.fire(new t1.Event("webglcontextlost", {
                                    originalEvent: e1
                                }));
                            }, i.prototype._contextRestored = function(e1) {
                                this._setupPainter(), this.resize(), this._update(), this.fire(new t1.Event("webglcontextrestored", {
                                    originalEvent: e1
                                }));
                            }, i.prototype._onMapScroll = function(t1) {
                                if (t1.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
                            }, i.prototype.loaded = function() {
                                return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
                            }, i.prototype._update = function(t1) {
                                return this.style ? (this._styleDirty = this._styleDirty || t1, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
                            }, i.prototype._requestRenderFrame = function(t1) {
                                return this._update(), this._renderTaskQueue.add(t1);
                            }, i.prototype._cancelRenderFrame = function(t1) {
                                this._renderTaskQueue.remove(t1);
                            }, i.prototype._render = function(e1) {
                                var r, n = this, i = 0, a = this.painter.context.extTimerQuery;
                                if (this.listens("gpu-timing-frame") && (r = a.createQueryEXT(), a.beginQueryEXT(a.TIME_ELAPSED_EXT, r), i = t1.browser.now()), this.painter.context.setDirty(), this.painter.setBaseState(), this._renderTaskQueue.run(e1), !this._removed) {
                                    var o = !1;
                                    if (this.style && this._styleDirty) {
                                        this._styleDirty = !1;
                                        var s = this.transform.zoom, l = t1.browser.now();
                                        this.style.zoomHistory.update(s, l);
                                        var c = new t1.EvaluationParameters(s, {
                                            now: l,
                                            fadeDuration: this._fadeDuration,
                                            zoomHistory: this.style.zoomHistory,
                                            transition: this.style.getTransition()
                                        }), u = c.crossFadingFactor();
                                        1 === u && u === this._crossFadingFactor || (o = !0, this._crossFadingFactor = u), this.style.update(c);
                                    }
                                    if (this.style && this._sourcesDirty && (this._sourcesDirty = !1, this.style._updateSources(this.transform)), this._placementDirty = this.style && this.style._updatePlacement(this.painter.transform, this.showCollisionBoxes, this._fadeDuration, this._crossSourceCollisions), this.painter.render(this.style, {
                                        showTileBoundaries: this.showTileBoundaries,
                                        showOverdrawInspector: this._showOverdrawInspector,
                                        rotating: this.isRotating(),
                                        zooming: this.isZooming(),
                                        moving: this.isMoving(),
                                        fadeDuration: this._fadeDuration,
                                        showPadding: this.showPadding,
                                        gpuTiming: !!this.listens("gpu-timing-layer")
                                    }), this.fire(new t1.Event("render")), this.loaded() && !this._loaded && (this._loaded = !0, this.fire(new t1.Event("load"))), this.style && (this.style.hasTransitions() || o) && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles(), this.listens("gpu-timing-frame")) {
                                        var h = t1.browser.now() - i;
                                        a.endQueryEXT(a.TIME_ELAPSED_EXT, r), setTimeout(function() {
                                            var e1 = a.getQueryObjectEXT(r, a.QUERY_RESULT_EXT) / 1e6;
                                            a.deleteQueryEXT(r), n.fire(new t1.Event("gpu-timing-frame", {
                                                cpuTime: h,
                                                gpuTime: e1
                                            }));
                                        }, 50);
                                    }
                                    if (this.listens("gpu-timing-layer")) {
                                        var f = this.painter.collectGpuTimers();
                                        setTimeout(function() {
                                            var e1 = n.painter.queryGpuTimers(f);
                                            n.fire(new t1.Event("gpu-timing-layer", {
                                                layerTimes: e1
                                            }));
                                        }, 50);
                                    }
                                    var p = this._sourcesDirty || this._styleDirty || this._placementDirty;
                                    return p || this._repaint ? this.triggerRepaint() : !this.isMoving() && this.loaded() && this.fire(new t1.Event("idle")), !this._loaded || this._fullyLoaded || p || (this._fullyLoaded = !0), this;
                                }
                            }, i.prototype.remove = function() {
                                this._hash && this._hash.remove();
                                for(var e1 = 0, r = this._controls; e1 < r.length; e1 += 1)r[e1].onRemove(this);
                                this._controls = [], this._frame && (this._frame.cancel(), this._frame = null), this._renderTaskQueue.clear(), this.painter.destroy(), this.handlers.destroy(), delete this.handlers, this.setStyle(null), void 0 !== t1.window && (t1.window.removeEventListener("resize", this._onWindowResize, !1), t1.window.removeEventListener("orientationchange", this._onWindowResize, !1), t1.window.removeEventListener("online", this._onWindowOnline, !1));
                                var n = this.painter.context.gl.getExtension("WEBGL_lose_context");
                                n && n.loseContext && n.loseContext(), Bi(this._canvasContainer), Bi(this._controlContainer), Bi(this._missingCSSCanary), this._container.classList.remove("mapboxgl-map"), this._removed = !0, this.fire(new t1.Event("remove"));
                            }, i.prototype.triggerRepaint = function() {
                                var e1 = this;
                                this.style && !this._frame && (this._frame = t1.browser.frame(function(t1) {
                                    e1._frame = null, e1._render(t1);
                                }));
                            }, i.prototype._onWindowOnline = function() {
                                this._update();
                            }, i.prototype._onWindowResize = function(t1) {
                                this._trackResize && this.resize({
                                    originalEvent: t1
                                })._update();
                            }, a.showTileBoundaries.get = function() {
                                return !!this._showTileBoundaries;
                            }, a.showTileBoundaries.set = function(t1) {
                                this._showTileBoundaries !== t1 && (this._showTileBoundaries = t1, this._update());
                            }, a.showPadding.get = function() {
                                return !!this._showPadding;
                            }, a.showPadding.set = function(t1) {
                                this._showPadding !== t1 && (this._showPadding = t1, this._update());
                            }, a.showCollisionBoxes.get = function() {
                                return !!this._showCollisionBoxes;
                            }, a.showCollisionBoxes.set = function(t1) {
                                this._showCollisionBoxes !== t1 && (this._showCollisionBoxes = t1, t1 ? this.style._generateCollisionBoxes() : this._update());
                            }, a.showOverdrawInspector.get = function() {
                                return !!this._showOverdrawInspector;
                            }, a.showOverdrawInspector.set = function(t1) {
                                this._showOverdrawInspector !== t1 && (this._showOverdrawInspector = t1, this._update());
                            }, a.repaint.get = function() {
                                return !!this._repaint;
                            }, a.repaint.set = function(t1) {
                                this._repaint !== t1 && (this._repaint = t1, this.triggerRepaint());
                            }, a.vertices.get = function() {
                                return !!this._vertices;
                            }, a.vertices.set = function(t1) {
                                this._vertices = t1, this._update();
                            }, i.prototype._setCacheLimits = function(e1, r) {
                                t1.setCacheLimits(e1, r);
                            }, a.version.get = function() {
                                return t1.version;
                            }, Object.defineProperties(i.prototype, a), i;
                        }(Si);
                        function Bi(t1) {
                            t1.parentNode && t1.parentNode.removeChild(t1);
                        }
                        var Ni = {
                            showCompass: !0,
                            showZoom: !0,
                            visualizePitch: !1
                        }, ji = function(e1) {
                            var n = this;
                            this.options = t1.extend({}, Ni, e1), this._container = r.create("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._container.addEventListener("contextmenu", function(t1) {
                                return t1.preventDefault();
                            }), this.options.showZoom && (t1.bindAll([
                                "_setButtonTitle",
                                "_updateZoomButtons"
                            ], this), this._zoomInButton = this._createButton("mapboxgl-ctrl-zoom-in", function(t1) {
                                return n._map.zoomIn({}, {
                                    originalEvent: t1
                                });
                            }), r.create("span", "mapboxgl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", !0), this._zoomOutButton = this._createButton("mapboxgl-ctrl-zoom-out", function(t1) {
                                return n._map.zoomOut({}, {
                                    originalEvent: t1
                                });
                            }), r.create("span", "mapboxgl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", !0)), this.options.showCompass && (t1.bindAll([
                                "_rotateCompassArrow"
                            ], this), this._compass = this._createButton("mapboxgl-ctrl-compass", function(t1) {
                                n.options.visualizePitch ? n._map.resetNorthPitch({}, {
                                    originalEvent: t1
                                }) : n._map.resetNorth({}, {
                                    originalEvent: t1
                                });
                            }), this._compassIcon = r.create("span", "mapboxgl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", !0));
                        };
                        ji.prototype._updateZoomButtons = function() {
                            var t1 = this._map.getZoom(), e1 = t1 === this._map.getMaxZoom(), r = t1 === this._map.getMinZoom();
                            this._zoomInButton.disabled = e1, this._zoomOutButton.disabled = r, this._zoomInButton.setAttribute("aria-disabled", e1.toString()), this._zoomOutButton.setAttribute("aria-disabled", r.toString());
                        }, ji.prototype._rotateCompassArrow = function() {
                            var t1 = this.options.visualizePitch ? "scale(" + 1 / Math.pow(Math.cos(this._map.transform.pitch * (Math.PI / 180)), .5) + ") rotateX(" + this._map.transform.pitch + "deg) rotateZ(" + this._map.transform.angle * (180 / Math.PI) + "deg)" : "rotate(" + this._map.transform.angle * (180 / Math.PI) + "deg)";
                            this._compassIcon.style.transform = t1;
                        }, ji.prototype.onAdd = function(t1) {
                            return this._map = t1, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), this._map.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && this._map.on("pitch", this._rotateCompassArrow), this._map.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new Ui(this._map, this._compass, this.options.visualizePitch)), this._container;
                        }, ji.prototype.onRemove = function() {
                            r.remove(this._container), this.options.showZoom && this._map.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && this._map.off("pitch", this._rotateCompassArrow), this._map.off("rotate", this._rotateCompassArrow), this._handler.off(), delete this._handler), delete this._map;
                        }, ji.prototype._createButton = function(t1, e1) {
                            var n = r.create("button", t1, this._container);
                            return n.type = "button", n.addEventListener("click", e1), n;
                        }, ji.prototype._setButtonTitle = function(t1, e1) {
                            var r = this._map._getUIString("NavigationControl." + e1);
                            t1.title = r, t1.setAttribute("aria-label", r);
                        };
                        var Ui = function(e1, n, i) {
                            void 0 === i && (i = !1), this._clickTolerance = 10, this.element = n, this.mouseRotate = new ei({
                                clickTolerance: e1.dragRotate._mouseRotate._clickTolerance
                            }), this.map = e1, i && (this.mousePitch = new ri({
                                clickTolerance: e1.dragRotate._mousePitch._clickTolerance
                            })), t1.bindAll([
                                "mousedown",
                                "mousemove",
                                "mouseup",
                                "touchstart",
                                "touchmove",
                                "touchend",
                                "reset"
                            ], this), r.addEventListener(n, "mousedown", this.mousedown), r.addEventListener(n, "touchstart", this.touchstart, {
                                passive: !1
                            }), r.addEventListener(n, "touchmove", this.touchmove), r.addEventListener(n, "touchend", this.touchend), r.addEventListener(n, "touchcancel", this.reset);
                        };
                        function Vi(e1, r, n) {
                            if (e1 = new t1.LngLat(e1.lng, e1.lat), r) {
                                var i = new t1.LngLat(e1.lng - 360, e1.lat), a = new t1.LngLat(e1.lng + 360, e1.lat), o = n.locationPoint(e1).distSqr(r);
                                n.locationPoint(i).distSqr(r) < o ? e1 = i : n.locationPoint(a).distSqr(r) < o && (e1 = a);
                            }
                            for(; Math.abs(e1.lng - n.center.lng) > 180;){
                                var s = n.locationPoint(e1);
                                if (s.x >= 0 && s.y >= 0 && s.x <= n.width && s.y <= n.height) break;
                                e1.lng > n.center.lng ? e1.lng -= 360 : e1.lng += 360;
                            }
                            return e1;
                        }
                        Ui.prototype.down = function(t1, e1) {
                            this.mouseRotate.mousedown(t1, e1), this.mousePitch && this.mousePitch.mousedown(t1, e1), r.disableDrag();
                        }, Ui.prototype.move = function(t1, e1) {
                            var r = this.map, n = this.mouseRotate.mousemoveWindow(t1, e1);
                            if (n && n.bearingDelta && r.setBearing(r.getBearing() + n.bearingDelta), this.mousePitch) {
                                var i = this.mousePitch.mousemoveWindow(t1, e1);
                                i && i.pitchDelta && r.setPitch(r.getPitch() + i.pitchDelta);
                            }
                        }, Ui.prototype.off = function() {
                            var t1 = this.element;
                            r.removeEventListener(t1, "mousedown", this.mousedown), r.removeEventListener(t1, "touchstart", this.touchstart, {
                                passive: !1
                            }), r.removeEventListener(t1, "touchmove", this.touchmove), r.removeEventListener(t1, "touchend", this.touchend), r.removeEventListener(t1, "touchcancel", this.reset), this.offTemp();
                        }, Ui.prototype.offTemp = function() {
                            r.enableDrag(), r.removeEventListener(t1.window, "mousemove", this.mousemove), r.removeEventListener(t1.window, "mouseup", this.mouseup);
                        }, Ui.prototype.mousedown = function(e1) {
                            this.down(t1.extend({}, e1, {
                                ctrlKey: !0,
                                preventDefault: function() {
                                    return e1.preventDefault();
                                }
                            }), r.mousePos(this.element, e1)), r.addEventListener(t1.window, "mousemove", this.mousemove), r.addEventListener(t1.window, "mouseup", this.mouseup);
                        }, Ui.prototype.mousemove = function(t1) {
                            this.move(t1, r.mousePos(this.element, t1));
                        }, Ui.prototype.mouseup = function(t1) {
                            this.mouseRotate.mouseupWindow(t1), this.mousePitch && this.mousePitch.mouseupWindow(t1), this.offTemp();
                        }, Ui.prototype.touchstart = function(t1) {
                            1 !== t1.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = r.touchPos(this.element, t1.targetTouches)[0], this.down({
                                type: "mousedown",
                                button: 0,
                                ctrlKey: !0,
                                preventDefault: function() {
                                    return t1.preventDefault();
                                }
                            }, this._startPos));
                        }, Ui.prototype.touchmove = function(t1) {
                            1 !== t1.targetTouches.length ? this.reset() : (this._lastPos = r.touchPos(this.element, t1.targetTouches)[0], this.move({
                                preventDefault: function() {
                                    return t1.preventDefault();
                                }
                            }, this._lastPos));
                        }, Ui.prototype.touchend = function(t1) {
                            0 === t1.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), this.reset();
                        }, Ui.prototype.reset = function() {
                            this.mouseRotate.reset(), this.mousePitch && this.mousePitch.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
                        };
                        var qi = {
                            center: "translate(-50%,-50%)",
                            top: "translate(-50%,0)",
                            "top-left": "translate(0,0)",
                            "top-right": "translate(-100%,0)",
                            bottom: "translate(-50%,-100%)",
                            "bottom-left": "translate(0,-100%)",
                            "bottom-right": "translate(-100%,-100%)",
                            left: "translate(0,-50%)",
                            right: "translate(-100%,-50%)"
                        };
                        function Hi(t1, e1, r) {
                            var n = t1.classList;
                            for(var i in qi)n.remove("mapboxgl-" + r + "-anchor-" + i);
                            n.add("mapboxgl-" + r + "-anchor-" + e1);
                        }
                        var Gi, Zi = function(e1) {
                            function n(n, i) {
                                if (e1.call(this), (n instanceof t1.window.HTMLElement || i) && (n = t1.extend({
                                    element: n
                                }, i)), t1.bindAll([
                                    "_update",
                                    "_onMove",
                                    "_onUp",
                                    "_addDragHandler",
                                    "_onMapClick",
                                    "_onKeyPress"
                                ], this), this._anchor = n && n.anchor || "center", this._color = n && n.color || "#3FB1CE", this._scale = n && n.scale || 1, this._draggable = n && n.draggable || !1, this._clickTolerance = n && n.clickTolerance || 0, this._isDragging = !1, this._state = "inactive", this._rotation = n && n.rotation || 0, this._rotationAlignment = n && n.rotationAlignment || "auto", this._pitchAlignment = n && n.pitchAlignment && "auto" !== n.pitchAlignment ? n.pitchAlignment : this._rotationAlignment, n && n.element) this._element = n.element, this._offset = t1.Point.convert(n && n.offset || [
                                    0,
                                    0
                                ]);
                                else {
                                    this._defaultMarker = !0, this._element = r.create("div"), this._element.setAttribute("aria-label", "Map marker");
                                    var a = r.createNS("http://www.w3.org/2000/svg", "svg");
                                    a.setAttributeNS(null, "display", "block"), a.setAttributeNS(null, "height", "41px"), a.setAttributeNS(null, "width", "27px"), a.setAttributeNS(null, "viewBox", "0 0 27 41");
                                    var o = r.createNS("http://www.w3.org/2000/svg", "g");
                                    o.setAttributeNS(null, "stroke", "none"), o.setAttributeNS(null, "stroke-width", "1"), o.setAttributeNS(null, "fill", "none"), o.setAttributeNS(null, "fill-rule", "evenodd");
                                    var s = r.createNS("http://www.w3.org/2000/svg", "g");
                                    s.setAttributeNS(null, "fill-rule", "nonzero");
                                    var l = r.createNS("http://www.w3.org/2000/svg", "g");
                                    l.setAttributeNS(null, "transform", "translate(3.0, 29.0)"), l.setAttributeNS(null, "fill", "#000000");
                                    for(var c = 0, u = [
                                        {
                                            rx: "10.5",
                                            ry: "5.25002273"
                                        },
                                        {
                                            rx: "10.5",
                                            ry: "5.25002273"
                                        },
                                        {
                                            rx: "9.5",
                                            ry: "4.77275007"
                                        },
                                        {
                                            rx: "8.5",
                                            ry: "4.29549936"
                                        },
                                        {
                                            rx: "7.5",
                                            ry: "3.81822308"
                                        },
                                        {
                                            rx: "6.5",
                                            ry: "3.34094679"
                                        },
                                        {
                                            rx: "5.5",
                                            ry: "2.86367051"
                                        },
                                        {
                                            rx: "4.5",
                                            ry: "2.38636864"
                                        }
                                    ]; c < u.length; c += 1){
                                        var h = u[c], f = r.createNS("http://www.w3.org/2000/svg", "ellipse");
                                        f.setAttributeNS(null, "opacity", "0.04"), f.setAttributeNS(null, "cx", "10.5"), f.setAttributeNS(null, "cy", "5.80029008"), f.setAttributeNS(null, "rx", h.rx), f.setAttributeNS(null, "ry", h.ry), l.appendChild(f);
                                    }
                                    var p = r.createNS("http://www.w3.org/2000/svg", "g");
                                    p.setAttributeNS(null, "fill", this._color);
                                    var d = r.createNS("http://www.w3.org/2000/svg", "path");
                                    d.setAttributeNS(null, "d", "M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"), p.appendChild(d);
                                    var m = r.createNS("http://www.w3.org/2000/svg", "g");
                                    m.setAttributeNS(null, "opacity", "0.25"), m.setAttributeNS(null, "fill", "#000000");
                                    var g = r.createNS("http://www.w3.org/2000/svg", "path");
                                    g.setAttributeNS(null, "d", "M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"), m.appendChild(g);
                                    var y = r.createNS("http://www.w3.org/2000/svg", "g");
                                    y.setAttributeNS(null, "transform", "translate(6.0, 7.0)"), y.setAttributeNS(null, "fill", "#FFFFFF");
                                    var v = r.createNS("http://www.w3.org/2000/svg", "g");
                                    v.setAttributeNS(null, "transform", "translate(8.0, 8.0)");
                                    var x = r.createNS("http://www.w3.org/2000/svg", "circle");
                                    x.setAttributeNS(null, "fill", "#000000"), x.setAttributeNS(null, "opacity", "0.25"), x.setAttributeNS(null, "cx", "5.5"), x.setAttributeNS(null, "cy", "5.5"), x.setAttributeNS(null, "r", "5.4999962");
                                    var _ = r.createNS("http://www.w3.org/2000/svg", "circle");
                                    _.setAttributeNS(null, "fill", "#FFFFFF"), _.setAttributeNS(null, "cx", "5.5"), _.setAttributeNS(null, "cy", "5.5"), _.setAttributeNS(null, "r", "5.4999962"), v.appendChild(x), v.appendChild(_), s.appendChild(l), s.appendChild(p), s.appendChild(m), s.appendChild(y), s.appendChild(v), a.appendChild(s), a.setAttributeNS(null, "height", 41 * this._scale + "px"), a.setAttributeNS(null, "width", 27 * this._scale + "px"), this._element.appendChild(a), this._offset = t1.Point.convert(n && n.offset || [
                                        0,
                                        -14
                                    ]);
                                }
                                this._element.classList.add("mapboxgl-marker"), this._element.addEventListener("dragstart", function(t1) {
                                    t1.preventDefault();
                                }), this._element.addEventListener("mousedown", function(t1) {
                                    t1.preventDefault();
                                }), Hi(this._element, this._anchor, "marker"), this._popup = null;
                            }
                            return e1 && (n.__proto__ = e1), n.prototype = Object.create(e1 && e1.prototype), n.prototype.constructor = n, n.prototype.addTo = function(t1) {
                                return this.remove(), this._map = t1, t1.getCanvasContainer().appendChild(this._element), t1.on("move", this._update), t1.on("moveend", this._update), this.setDraggable(this._draggable), this._update(), this._map.on("click", this._onMapClick), this;
                            }, n.prototype.remove = function() {
                                return this._map && (this._map.off("click", this._onMapClick), this._map.off("move", this._update), this._map.off("moveend", this._update), this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler), this._map.off("mouseup", this._onUp), this._map.off("touchend", this._onUp), this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), delete this._map), r.remove(this._element), this._popup && this._popup.remove(), this;
                            }, n.prototype.getLngLat = function() {
                                return this._lngLat;
                            }, n.prototype.setLngLat = function(e1) {
                                return this._lngLat = t1.LngLat.convert(e1), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(), this;
                            }, n.prototype.getElement = function() {
                                return this._element;
                            }, n.prototype.setPopup = function(t1) {
                                if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), t1) {
                                    if (!("offset" in t1.options)) {
                                        var e1 = 13.5, r = Math.sqrt(Math.pow(e1, 2) / 2);
                                        t1.options.offset = this._defaultMarker ? {
                                            top: [
                                                0,
                                                0
                                            ],
                                            "top-left": [
                                                0,
                                                0
                                            ],
                                            "top-right": [
                                                0,
                                                0
                                            ],
                                            bottom: [
                                                0,
                                                -38.1
                                            ],
                                            "bottom-left": [
                                                r,
                                                -1 * (24.6 + r)
                                            ],
                                            "bottom-right": [
                                                -r,
                                                -1 * (24.6 + r)
                                            ],
                                            left: [
                                                e1,
                                                -24.6
                                            ],
                                            right: [
                                                -13.5,
                                                -24.6
                                            ]
                                        } : this._offset;
                                    }
                                    this._popup = t1, this._lngLat && this._popup.setLngLat(this._lngLat), this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress);
                                }
                                return this;
                            }, n.prototype._onKeyPress = function(t1) {
                                var e1 = t1.code, r = t1.charCode || t1.keyCode;
                                "Space" !== e1 && "Enter" !== e1 && 32 !== r && 13 !== r || this.togglePopup();
                            }, n.prototype._onMapClick = function(t1) {
                                var e1 = t1.originalEvent.target, r = this._element;
                                this._popup && (e1 === r || r.contains(e1)) && this.togglePopup();
                            }, n.prototype.getPopup = function() {
                                return this._popup;
                            }, n.prototype.togglePopup = function() {
                                var t1 = this._popup;
                                return t1 ? (t1.isOpen() ? t1.remove() : t1.addTo(this._map), this) : this;
                            }, n.prototype._update = function(t1) {
                                if (this._map) {
                                    this._map.transform.renderWorldCopies && (this._lngLat = Vi(this._lngLat, this._pos, this._map.transform)), this._pos = this._map.project(this._lngLat)._add(this._offset);
                                    var e1 = "";
                                    "viewport" === this._rotationAlignment || "auto" === this._rotationAlignment ? e1 = "rotateZ(" + this._rotation + "deg)" : "map" === this._rotationAlignment && (e1 = "rotateZ(" + (this._rotation - this._map.getBearing()) + "deg)");
                                    var n = "";
                                    "viewport" === this._pitchAlignment || "auto" === this._pitchAlignment ? n = "rotateX(0deg)" : "map" === this._pitchAlignment && (n = "rotateX(" + this._map.getPitch() + "deg)"), t1 && "moveend" !== t1.type || (this._pos = this._pos.round()), r.setTransform(this._element, qi[this._anchor] + " translate(" + this._pos.x + "px, " + this._pos.y + "px) " + n + " " + e1);
                                }
                            }, n.prototype.getOffset = function() {
                                return this._offset;
                            }, n.prototype.setOffset = function(e1) {
                                return this._offset = t1.Point.convert(e1), this._update(), this;
                            }, n.prototype._onMove = function(e1) {
                                if (!this._isDragging) {
                                    var r = this._clickTolerance || this._map._clickTolerance;
                                    this._isDragging = e1.point.dist(this._pointerdownPos) >= r;
                                }
                                this._isDragging && (this._pos = e1.point.sub(this._positionDelta), this._lngLat = this._map.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new t1.Event("dragstart"))), this.fire(new t1.Event("drag")));
                            }, n.prototype._onUp = function() {
                                this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1, this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), "active" === this._state && this.fire(new t1.Event("dragend")), this._state = "inactive";
                            }, n.prototype._addDragHandler = function(t1) {
                                this._element.contains(t1.originalEvent.target) && (t1.preventDefault(), this._positionDelta = t1.point.sub(this._pos).add(this._offset), this._pointerdownPos = t1.point, this._state = "pending", this._map.on("mousemove", this._onMove), this._map.on("touchmove", this._onMove), this._map.once("mouseup", this._onUp), this._map.once("touchend", this._onUp));
                            }, n.prototype.setDraggable = function(t1) {
                                return this._draggable = !!t1, this._map && (t1 ? (this._map.on("mousedown", this._addDragHandler), this._map.on("touchstart", this._addDragHandler)) : (this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler))), this;
                            }, n.prototype.isDraggable = function() {
                                return this._draggable;
                            }, n.prototype.setRotation = function(t1) {
                                return this._rotation = t1 || 0, this._update(), this;
                            }, n.prototype.getRotation = function() {
                                return this._rotation;
                            }, n.prototype.setRotationAlignment = function(t1) {
                                return this._rotationAlignment = t1 || "auto", this._update(), this;
                            }, n.prototype.getRotationAlignment = function() {
                                return this._rotationAlignment;
                            }, n.prototype.setPitchAlignment = function(t1) {
                                return this._pitchAlignment = t1 && "auto" !== t1 ? t1 : this._rotationAlignment, this._update(), this;
                            }, n.prototype.getPitchAlignment = function() {
                                return this._pitchAlignment;
                            }, n;
                        }(t1.Evented), Wi = {
                            positionOptions: {
                                enableHighAccuracy: !1,
                                maximumAge: 0,
                                timeout: 6e3
                            },
                            fitBoundsOptions: {
                                maxZoom: 15
                            },
                            trackUserLocation: !1,
                            showAccuracyCircle: !0,
                            showUserLocation: !0
                        };
                        var Yi = 0, Xi = !1, $i = function(e1) {
                            function n(r) {
                                e1.call(this), this.options = t1.extend({}, Wi, r), t1.bindAll([
                                    "_onSuccess",
                                    "_onError",
                                    "_onZoom",
                                    "_finish",
                                    "_setupUI",
                                    "_updateCamera",
                                    "_updateMarker"
                                ], this);
                            }
                            return e1 && (n.__proto__ = e1), n.prototype = Object.create(e1 && e1.prototype), n.prototype.constructor = n, n.prototype.onAdd = function(e1) {
                                var n;
                                return this._map = e1, this._container = r.create("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), n = this._setupUI, void 0 !== Gi ? n(Gi) : void 0 !== t1.window.navigator.permissions ? t1.window.navigator.permissions.query({
                                    name: "geolocation"
                                }).then(function(t1) {
                                    Gi = "denied" !== t1.state, n(Gi);
                                }) : (Gi = !!t1.window.navigator.geolocation, n(Gi)), this._container;
                            }, n.prototype.onRemove = function() {
                                void 0 !== this._geolocationWatchID && (t1.window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), r.remove(this._container), this._map.off("zoom", this._onZoom), this._map = void 0, Yi = 0, Xi = !1;
                            }, n.prototype._isOutOfMapMaxBounds = function(t1) {
                                var e1 = this._map.getMaxBounds(), r = t1.coords;
                                return e1 && (r.longitude < e1.getWest() || r.longitude > e1.getEast() || r.latitude < e1.getSouth() || r.latitude > e1.getNorth());
                            }, n.prototype._setErrorState = function() {
                                switch(this._watchState){
                                    case "WAITING_ACTIVE":
                                        this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                                        break;
                                    case "ACTIVE_LOCK":
                                        this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                                        break;
                                    case "BACKGROUND":
                                        this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                                }
                            }, n.prototype._onSuccess = function(e1) {
                                if (this._map) {
                                    if (this._isOutOfMapMaxBounds(e1)) return this._setErrorState(), this.fire(new t1.Event("outofmaxbounds", e1)), this._updateMarker(), void this._finish();
                                    if (this.options.trackUserLocation) switch(this._lastKnownPosition = e1, this._watchState){
                                        case "WAITING_ACTIVE":
                                        case "ACTIVE_LOCK":
                                        case "ACTIVE_ERROR":
                                            this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                            break;
                                        case "BACKGROUND":
                                        case "BACKGROUND_ERROR":
                                            this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                                    }
                                    this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(e1), this.options.trackUserLocation && "ACTIVE_LOCK" !== this._watchState || this._updateCamera(e1), this.options.showUserLocation && this._dotElement.classList.remove("mapboxgl-user-location-dot-stale"), this.fire(new t1.Event("geolocate", e1)), this._finish();
                                }
                            }, n.prototype._updateCamera = function(e1) {
                                var r = new t1.LngLat(e1.coords.longitude, e1.coords.latitude), n = e1.coords.accuracy, i = this._map.getBearing(), a = t1.extend({
                                    bearing: i
                                }, this.options.fitBoundsOptions);
                                this._map.fitBounds(r.toBounds(n), a, {
                                    geolocateSource: !0
                                });
                            }, n.prototype._updateMarker = function(e1) {
                                if (e1) {
                                    var r = new t1.LngLat(e1.coords.longitude, e1.coords.latitude);
                                    this._accuracyCircleMarker.setLngLat(r).addTo(this._map), this._userLocationDotMarker.setLngLat(r).addTo(this._map), this._accuracy = e1.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                                } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
                            }, n.prototype._updateCircleRadius = function() {
                                var t1 = this._map._container.clientHeight / 2, e1 = this._map.unproject([
                                    0,
                                    t1
                                ]), r = this._map.unproject([
                                    1,
                                    t1
                                ]), n = e1.distanceTo(r), i = Math.ceil(2 * this._accuracy / n);
                                this._circleElement.style.width = i + "px", this._circleElement.style.height = i + "px";
                            }, n.prototype._onZoom = function() {
                                this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                            }, n.prototype._onError = function(e1) {
                                if (this._map) {
                                    if (this.options.trackUserLocation) {
                                        if (1 === e1.code) {
                                            this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = !0;
                                            var r = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                                            this._geolocateButton.title = r, this._geolocateButton.setAttribute("aria-label", r), void 0 !== this._geolocationWatchID && this._clearWatch();
                                        } else {
                                            if (3 === e1.code && Xi) return;
                                            this._setErrorState();
                                        }
                                    }
                                    "OFF" !== this._watchState && this.options.showUserLocation && this._dotElement.classList.add("mapboxgl-user-location-dot-stale"), this.fire(new t1.Event("error", e1)), this._finish();
                                }
                            }, n.prototype._finish = function() {
                                this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
                            }, n.prototype._setupUI = function(e1) {
                                var n = this;
                                if (this._container.addEventListener("contextmenu", function(t1) {
                                    return t1.preventDefault();
                                }), this._geolocateButton = r.create("button", "mapboxgl-ctrl-geolocate", this._container), r.create("span", "mapboxgl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", !0), this._geolocateButton.type = "button", !1 === e1) {
                                    t1.warnOnce("Geolocation support is not available so the GeolocateControl will be disabled.");
                                    var i = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                                    this._geolocateButton.disabled = !0, this._geolocateButton.title = i, this._geolocateButton.setAttribute("aria-label", i);
                                } else {
                                    var a = this._map._getUIString("GeolocateControl.FindMyLocation");
                                    this._geolocateButton.title = a, this._geolocateButton.setAttribute("aria-label", a);
                                }
                                this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = r.create("div", "mapboxgl-user-location-dot"), this._userLocationDotMarker = new Zi(this._dotElement), this._circleElement = r.create("div", "mapboxgl-user-location-accuracy-circle"), this._accuracyCircleMarker = new Zi({
                                    element: this._circleElement,
                                    pitchAlignment: "map"
                                }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", this.trigger.bind(this)), this._setup = !0, this.options.trackUserLocation && this._map.on("movestart", function(e1) {
                                    var r = e1.originalEvent && "resize" === e1.originalEvent.type;
                                    e1.geolocateSource || "ACTIVE_LOCK" !== n._watchState || r || (n._watchState = "BACKGROUND", n._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"), n._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), n.fire(new t1.Event("trackuserlocationend")));
                                });
                            }, n.prototype.trigger = function() {
                                if (!this._setup) return t1.warnOnce("Geolocate control triggered before added to a map"), !1;
                                if (this.options.trackUserLocation) {
                                    switch(this._watchState){
                                        case "OFF":
                                            this._watchState = "WAITING_ACTIVE", this.fire(new t1.Event("trackuserlocationstart"));
                                            break;
                                        case "WAITING_ACTIVE":
                                        case "ACTIVE_LOCK":
                                        case "ACTIVE_ERROR":
                                        case "BACKGROUND_ERROR":
                                            Yi--, Xi = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this.fire(new t1.Event("trackuserlocationend"));
                                            break;
                                        case "BACKGROUND":
                                            this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new t1.Event("trackuserlocationstart"));
                                    }
                                    switch(this._watchState){
                                        case "WAITING_ACTIVE":
                                            this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                            break;
                                        case "ACTIVE_LOCK":
                                            this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                            break;
                                        case "ACTIVE_ERROR":
                                            this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                                            break;
                                        case "BACKGROUND":
                                            this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                                            break;
                                        case "BACKGROUND_ERROR":
                                            this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error");
                                    }
                                    if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();
                                    else if (void 0 === this._geolocationWatchID) {
                                        var e1;
                                        this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), ++Yi > 1 ? (e1 = {
                                            maximumAge: 6e5,
                                            timeout: 0
                                        }, Xi = !0) : (e1 = this.options.positionOptions, Xi = !1), this._geolocationWatchID = t1.window.navigator.geolocation.watchPosition(this._onSuccess, this._onError, e1);
                                    }
                                } else t1.window.navigator.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = setTimeout(this._finish, 1e4);
                                return !0;
                            }, n.prototype._clearWatch = function() {
                                t1.window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
                            }, n;
                        }(t1.Evented), Ji = {
                            maxWidth: 100,
                            unit: "metric"
                        }, Ki = function(e1) {
                            this.options = t1.extend({}, Ji, e1), t1.bindAll([
                                "_onMove",
                                "setUnit"
                            ], this);
                        };
                        function Qi(t1, e1, r) {
                            var n = r && r.maxWidth || 100, i = t1._container.clientHeight / 2, a = t1.unproject([
                                0,
                                i
                            ]), o = t1.unproject([
                                n,
                                i
                            ]), s = a.distanceTo(o);
                            if (r && "imperial" === r.unit) {
                                var l = 3.2808 * s;
                                l > 5280 ? ta(e1, n, l / 5280, t1._getUIString("ScaleControl.Miles")) : ta(e1, n, l, t1._getUIString("ScaleControl.Feet"));
                            } else r && "nautical" === r.unit ? ta(e1, n, s / 1852, t1._getUIString("ScaleControl.NauticalMiles")) : s >= 1e3 ? ta(e1, n, s / 1e3, t1._getUIString("ScaleControl.Kilometers")) : ta(e1, n, s, t1._getUIString("ScaleControl.Meters"));
                        }
                        function ta(t1, e1, r, n) {
                            var i, a, o, s = (i = r, (a = Math.pow(10, ("" + Math.floor(i)).length - 1)) * ((o = i / a) >= 10 ? 10 : o >= 5 ? 5 : o >= 3 ? 3 : o >= 2 ? 2 : o >= 1 ? 1 : function(t1) {
                                var e1 = Math.pow(10, Math.ceil(-Math.log(t1) / Math.LN10));
                                return Math.round(t1 * e1) / e1;
                            }(o))), l = s / r;
                            t1.style.width = e1 * l + "px", t1.innerHTML = s + "&nbsp;" + n;
                        }
                        Ki.prototype.getDefaultPosition = function() {
                            return "bottom-left";
                        }, Ki.prototype._onMove = function() {
                            Qi(this._map, this._container, this.options);
                        }, Ki.prototype.onAdd = function(t1) {
                            return this._map = t1, this._container = r.create("div", "mapboxgl-ctrl mapboxgl-ctrl-scale", t1.getContainer()), this._map.on("move", this._onMove), this._onMove(), this._container;
                        }, Ki.prototype.onRemove = function() {
                            r.remove(this._container), this._map.off("move", this._onMove), this._map = void 0;
                        }, Ki.prototype.setUnit = function(t1) {
                            this.options.unit = t1, Qi(this._map, this._container, this.options);
                        };
                        var ea = function(e1) {
                            this._fullscreen = !1, e1 && e1.container && (e1.container instanceof t1.window.HTMLElement ? this._container = e1.container : t1.warnOnce("Full screen control 'container' must be a DOM element.")), t1.bindAll([
                                "_onClickFullscreen",
                                "_changeIcon"
                            ], this), "onfullscreenchange" in t1.window.document ? this._fullscreenchange = "fullscreenchange" : "onmozfullscreenchange" in t1.window.document ? this._fullscreenchange = "mozfullscreenchange" : "onwebkitfullscreenchange" in t1.window.document ? this._fullscreenchange = "webkitfullscreenchange" : "onmsfullscreenchange" in t1.window.document && (this._fullscreenchange = "MSFullscreenChange");
                        };
                        ea.prototype.onAdd = function(e1) {
                            return this._map = e1, this._container || (this._container = this._map.getContainer()), this._controlContainer = r.create("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkFullscreenSupport() ? this._setupUI() : (this._controlContainer.style.display = "none", t1.warnOnce("This device does not support fullscreen mode.")), this._controlContainer;
                        }, ea.prototype.onRemove = function() {
                            r.remove(this._controlContainer), this._map = null, t1.window.document.removeEventListener(this._fullscreenchange, this._changeIcon);
                        }, ea.prototype._checkFullscreenSupport = function() {
                            return !!(t1.window.document.fullscreenEnabled || t1.window.document.mozFullScreenEnabled || t1.window.document.msFullscreenEnabled || t1.window.document.webkitFullscreenEnabled);
                        }, ea.prototype._setupUI = function() {
                            var e1 = this._fullscreenButton = r.create("button", "mapboxgl-ctrl-fullscreen", this._controlContainer);
                            r.create("span", "mapboxgl-ctrl-icon", e1).setAttribute("aria-hidden", !0), e1.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), t1.window.document.addEventListener(this._fullscreenchange, this._changeIcon);
                        }, ea.prototype._updateTitle = function() {
                            var t1 = this._getTitle();
                            this._fullscreenButton.setAttribute("aria-label", t1), this._fullscreenButton.title = t1;
                        }, ea.prototype._getTitle = function() {
                            return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
                        }, ea.prototype._isFullscreen = function() {
                            return this._fullscreen;
                        }, ea.prototype._changeIcon = function() {
                            (t1.window.document.fullscreenElement || t1.window.document.mozFullScreenElement || t1.window.document.webkitFullscreenElement || t1.window.document.msFullscreenElement) === this._container !== this._fullscreen && (this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("mapboxgl-ctrl-shrink"), this._fullscreenButton.classList.toggle("mapboxgl-ctrl-fullscreen"), this._updateTitle());
                        }, ea.prototype._onClickFullscreen = function() {
                            this._isFullscreen() ? t1.window.document.exitFullscreen ? t1.window.document.exitFullscreen() : t1.window.document.mozCancelFullScreen ? t1.window.document.mozCancelFullScreen() : t1.window.document.msExitFullscreen ? t1.window.document.msExitFullscreen() : t1.window.document.webkitCancelFullScreen && t1.window.document.webkitCancelFullScreen() : this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.mozRequestFullScreen ? this._container.mozRequestFullScreen() : this._container.msRequestFullscreen ? this._container.msRequestFullscreen() : this._container.webkitRequestFullscreen && this._container.webkitRequestFullscreen();
                        };
                        var ra = {
                            closeButton: !0,
                            closeOnClick: !0,
                            focusAfterOpen: !0,
                            className: "",
                            maxWidth: "240px"
                        }, na = [
                            "a[href]",
                            "[tabindex]:not([tabindex='-1'])",
                            "[contenteditable]:not([contenteditable='false'])",
                            "button:not([disabled])",
                            "input:not([disabled])",
                            "select:not([disabled])",
                            "textarea:not([disabled])"
                        ].join(", "), ia = function(e1) {
                            function n(r) {
                                e1.call(this), this.options = t1.extend(Object.create(ra), r), t1.bindAll([
                                    "_update",
                                    "_onClose",
                                    "remove",
                                    "_onMouseMove",
                                    "_onMouseUp",
                                    "_onDrag"
                                ], this);
                            }
                            return e1 && (n.__proto__ = e1), n.prototype = Object.create(e1 && e1.prototype), n.prototype.constructor = n, n.prototype.addTo = function(e1) {
                                return this._map && this.remove(), this._map = e1, this.options.closeOnClick && this._map.on("click", this._onClose), this.options.closeOnMove && this._map.on("move", this._onClose), this._map.on("remove", this.remove), this._update(), this._focusFirstElement(), this._trackPointer ? (this._map.on("mousemove", this._onMouseMove), this._map.on("mouseup", this._onMouseUp), this._container && this._container.classList.add("mapboxgl-popup-track-pointer"), this._map._canvasContainer.classList.add("mapboxgl-track-pointer")) : this._map.on("move", this._update), this.fire(new t1.Event("open")), this;
                            }, n.prototype.isOpen = function() {
                                return !!this._map;
                            }, n.prototype.remove = function() {
                                return this._content && r.remove(this._content), this._container && (r.remove(this._container), delete this._container), this._map && (this._map.off("move", this._update), this._map.off("move", this._onClose), this._map.off("click", this._onClose), this._map.off("remove", this.remove), this._map.off("mousemove", this._onMouseMove), this._map.off("mouseup", this._onMouseUp), this._map.off("drag", this._onDrag), delete this._map), this.fire(new t1.Event("close")), this;
                            }, n.prototype.getLngLat = function() {
                                return this._lngLat;
                            }, n.prototype.setLngLat = function(e1) {
                                return this._lngLat = t1.LngLat.convert(e1), this._pos = null, this._trackPointer = !1, this._update(), this._map && (this._map.on("move", this._update), this._map.off("mousemove", this._onMouseMove), this._container && this._container.classList.remove("mapboxgl-popup-track-pointer"), this._map._canvasContainer.classList.remove("mapboxgl-track-pointer")), this;
                            }, n.prototype.trackPointer = function() {
                                return this._trackPointer = !0, this._pos = null, this._update(), this._map && (this._map.off("move", this._update), this._map.on("mousemove", this._onMouseMove), this._map.on("drag", this._onDrag), this._container && this._container.classList.add("mapboxgl-popup-track-pointer"), this._map._canvasContainer.classList.add("mapboxgl-track-pointer")), this;
                            }, n.prototype.getElement = function() {
                                return this._container;
                            }, n.prototype.setText = function(e1) {
                                return this.setDOMContent(t1.window.document.createTextNode(e1));
                            }, n.prototype.setHTML = function(e1) {
                                var r, n = t1.window.document.createDocumentFragment(), i = t1.window.document.createElement("body");
                                for(i.innerHTML = e1; r = i.firstChild;)n.appendChild(r);
                                return this.setDOMContent(n);
                            }, n.prototype.getMaxWidth = function() {
                                return this._container && this._container.style.maxWidth;
                            }, n.prototype.setMaxWidth = function(t1) {
                                return this.options.maxWidth = t1, this._update(), this;
                            }, n.prototype.setDOMContent = function(t1) {
                                if (this._content) for(; this._content.hasChildNodes();)this._content.firstChild && this._content.removeChild(this._content.firstChild);
                                else this._content = r.create("div", "mapboxgl-popup-content", this._container);
                                return this._content.appendChild(t1), this._createCloseButton(), this._update(), this._focusFirstElement(), this;
                            }, n.prototype.addClassName = function(t1) {
                                this._container && this._container.classList.add(t1);
                            }, n.prototype.removeClassName = function(t1) {
                                this._container && this._container.classList.remove(t1);
                            }, n.prototype.setOffset = function(t1) {
                                return this.options.offset = t1, this._update(), this;
                            }, n.prototype.toggleClassName = function(t1) {
                                if (this._container) return this._container.classList.toggle(t1);
                            }, n.prototype._createCloseButton = function() {
                                this.options.closeButton && (this._closeButton = r.create("button", "mapboxgl-popup-close-button", this._content), this._closeButton.type = "button", this._closeButton.setAttribute("aria-label", "Close popup"), this._closeButton.innerHTML = "&#215;", this._closeButton.addEventListener("click", this._onClose));
                            }, n.prototype._onMouseUp = function(t1) {
                                this._update(t1.point);
                            }, n.prototype._onMouseMove = function(t1) {
                                this._update(t1.point);
                            }, n.prototype._onDrag = function(t1) {
                                this._update(t1.point);
                            }, n.prototype._update = function(t1) {
                                var e1 = this, n = this._lngLat || this._trackPointer;
                                if (this._map && n && this._content && (this._container || (this._container = r.create("div", "mapboxgl-popup", this._map.getContainer()), this._tip = r.create("div", "mapboxgl-popup-tip", this._container), this._container.appendChild(this._content), this.options.className && this.options.className.split(" ").forEach(function(t1) {
                                    return e1._container.classList.add(t1);
                                }), this._trackPointer && this._container.classList.add("mapboxgl-popup-track-pointer")), this.options.maxWidth && this._container.style.maxWidth !== this.options.maxWidth && (this._container.style.maxWidth = this.options.maxWidth), this._map.transform.renderWorldCopies && !this._trackPointer && (this._lngLat = Vi(this._lngLat, this._pos, this._map.transform)), !this._trackPointer || t1)) {
                                    var i = this._pos = this._trackPointer && t1 ? t1 : this._map.project(this._lngLat), a = this.options.anchor, o = aa(this.options.offset);
                                    if (!a) {
                                        var s, l = this._container.offsetWidth, c = this._container.offsetHeight;
                                        s = i.y + o.bottom.y < c ? [
                                            "top"
                                        ] : i.y > this._map.transform.height - c ? [
                                            "bottom"
                                        ] : [], i.x < l / 2 ? s.push("left") : i.x > this._map.transform.width - l / 2 && s.push("right"), a = 0 === s.length ? "bottom" : s.join("-");
                                    }
                                    var u = i.add(o[a]).round();
                                    r.setTransform(this._container, qi[a] + " translate(" + u.x + "px," + u.y + "px)"), Hi(this._container, a, "popup");
                                }
                            }, n.prototype._focusFirstElement = function() {
                                if (this.options.focusAfterOpen && this._container) {
                                    var t1 = this._container.querySelector(na);
                                    t1 && t1.focus();
                                }
                            }, n.prototype._onClose = function() {
                                this.remove();
                            }, n;
                        }(t1.Evented);
                        function aa(e1) {
                            if (e1) {
                                if ("number" == typeof e1) {
                                    var r = Math.round(Math.sqrt(.5 * Math.pow(e1, 2)));
                                    return {
                                        center: new t1.Point(0, 0),
                                        top: new t1.Point(0, e1),
                                        "top-left": new t1.Point(r, r),
                                        "top-right": new t1.Point(-r, r),
                                        bottom: new t1.Point(0, -e1),
                                        "bottom-left": new t1.Point(r, -r),
                                        "bottom-right": new t1.Point(-r, -r),
                                        left: new t1.Point(e1, 0),
                                        right: new t1.Point(-e1, 0)
                                    };
                                }
                                if (e1 instanceof t1.Point || Array.isArray(e1)) {
                                    var n = t1.Point.convert(e1);
                                    return {
                                        center: n,
                                        top: n,
                                        "top-left": n,
                                        "top-right": n,
                                        bottom: n,
                                        "bottom-left": n,
                                        "bottom-right": n,
                                        left: n,
                                        right: n
                                    };
                                }
                                return {
                                    center: t1.Point.convert(e1.center || [
                                        0,
                                        0
                                    ]),
                                    top: t1.Point.convert(e1.top || [
                                        0,
                                        0
                                    ]),
                                    "top-left": t1.Point.convert(e1["top-left"] || [
                                        0,
                                        0
                                    ]),
                                    "top-right": t1.Point.convert(e1["top-right"] || [
                                        0,
                                        0
                                    ]),
                                    bottom: t1.Point.convert(e1.bottom || [
                                        0,
                                        0
                                    ]),
                                    "bottom-left": t1.Point.convert(e1["bottom-left"] || [
                                        0,
                                        0
                                    ]),
                                    "bottom-right": t1.Point.convert(e1["bottom-right"] || [
                                        0,
                                        0
                                    ]),
                                    left: t1.Point.convert(e1.left || [
                                        0,
                                        0
                                    ]),
                                    right: t1.Point.convert(e1.right || [
                                        0,
                                        0
                                    ])
                                };
                            }
                            return aa(new t1.Point(0, 0));
                        }
                        var oa = {
                            version: t1.version,
                            supported: e1,
                            setRTLTextPlugin: t1.setRTLTextPlugin,
                            getRTLTextPluginStatus: t1.getRTLTextPluginStatus,
                            Map: Fi,
                            NavigationControl: ji,
                            GeolocateControl: $i,
                            AttributionControl: Ei,
                            ScaleControl: Ki,
                            FullscreenControl: ea,
                            Popup: ia,
                            Marker: Zi,
                            Style: We,
                            LngLat: t1.LngLat,
                            LngLatBounds: t1.LngLatBounds,
                            Point: t1.Point,
                            MercatorCoordinate: t1.MercatorCoordinate,
                            Evented: t1.Evented,
                            config: t1.config,
                            prewarm: function() {
                                jt().acquire(Rt);
                            },
                            clearPrewarmedResources: function() {
                                var t1 = Bt;
                                t1 && (t1.isPreloaded() && 1 === t1.numActive() ? (t1.release(Rt), Bt = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
                            },
                            get accessToken () {
                                return t1.config.ACCESS_TOKEN;
                            },
                            set accessToken (e){
                                t1.config.ACCESS_TOKEN = e;
                            },
                            get baseApiUrl () {
                                return t1.config.API_URL;
                            },
                            set baseApiUrl (e){
                                t1.config.API_URL = e;
                            },
                            get workerCount () {
                                return Ft.workerCount;
                            },
                            set workerCount (t){
                                Ft.workerCount = t;
                            },
                            get maxParallelImageRequests () {
                                return t1.config.MAX_PARALLEL_IMAGE_REQUESTS;
                            },
                            set maxParallelImageRequests (e){
                                t1.config.MAX_PARALLEL_IMAGE_REQUESTS = e;
                            },
                            clearStorage: function(e1) {
                                t1.clearTileCache(e1);
                            },
                            workerUrl: ""
                        };
                        return oa;
                    }), r;
                }();
            },
            27549: function(t1, e1, r) {
                "use strict";
                t1.exports = r(55366);
            },
            55366: function(t1, e1, r) {
                "use strict";
                var n = r(31625), i = r(75144), a = r(5137), o = r(78112), s = r(6807), l = r(68650), c = r(83473), u = r(60201), h = r(10275), f = r(62914);
                function p(t1, e1) {
                    for(var r = e1[0], n = e1[1], a = 1 / (e1[2] - r), o = 1 / (e1[3] - n), s = new Array(t1.length), l = 0, c = t1.length / 2; l < c; l++)s[2 * l] = i((t1[2 * l] - r) * a, 0, 1), s[2 * l + 1] = i((t1[2 * l + 1] - n) * o, 0, 1);
                    return s;
                }
                t1.exports = function(t1, e1) {
                    e1 || (e1 = {}), t1 = c(t1, "float64"), e1 = s(e1, {
                        bounds: "range bounds dataBox databox",
                        maxDepth: "depth maxDepth maxdepth level maxLevel maxlevel levels",
                        dtype: "type dtype format out dst output destination"
                    });
                    var r = l(e1.maxDepth, 255), i = l(e1.bounds, o(t1, 2));
                    i[0] === i[2] && i[2]++, i[1] === i[3] && i[3]++;
                    var d, m = p(t1, i), g = t1.length >>> 1;
                    e1.dtype || (e1.dtype = "array"), "string" == typeof e1.dtype ? d = new (h(e1.dtype))(g) : e1.dtype && (d = e1.dtype, Array.isArray(d) && (d.length = g));
                    for(var y = 0; y < g; ++y)d[y] = y;
                    var v = [], x = [], _ = [], b = [];
                    !function t1(e1, n, i, a, o, s) {
                        if (!a.length) return null;
                        var l = v[o] || (v[o] = []), c = _[o] || (_[o] = []), u = x[o] || (x[o] = []), h = l.length;
                        if (++o > r || s > 1073741824) {
                            for(var f = 0; f < a.length; f++)l.push(a[f]), c.push(s), u.push(null, null, null, null);
                            return h;
                        }
                        if (l.push(a[0]), c.push(s), a.length <= 1) return u.push(null, null, null, null), h;
                        for(var p = .5 * i, d = e1 + p, g = n + p, y = [], b = [], w = [], T = [], k = 1, A = a.length; k < A; k++){
                            var M = a[k], S = m[2 * M], E = m[2 * M + 1];
                            S < d ? E < g ? y.push(M) : b.push(M) : E < g ? w.push(M) : T.push(M);
                        }
                        return s <<= 2, u.push(t1(e1, n, p, y, o, s), t1(e1, g, p, b, o, s + 1), t1(d, n, p, w, o, s + 2), t1(d, g, p, T, o, s + 3)), h;
                    }(0, 0, 1, d, 0, 1);
                    for(var w = 0, T = 0; T < v.length; T++){
                        var k = v[T];
                        if (d.set) d.set(k, w);
                        else for(var A = 0, M = k.length; A < M; A++)d[A + w] = k[A];
                        var S = w + v[T].length;
                        b[T] = [
                            w,
                            S
                        ], w = S;
                    }
                    return d.range = function() {
                        for(var e1, r = [], o = arguments.length; o--;)r[o] = arguments[o];
                        if (u(r[r.length - 1])) {
                            var c = r.pop();
                            r.length || null == c.x && null == c.l && null == c.left || (r = [
                                c
                            ], e1 = {}), e1 = s(c, {
                                level: "level maxLevel",
                                d: "d diam diameter r radius px pxSize pixel pixelSize maxD size minSize",
                                lod: "lod details ranges offsets"
                            });
                        } else e1 = {};
                        r.length || (r = i);
                        var h, d = a.apply(void 0, r), m = [
                            Math.min(d.x, d.x + d.width),
                            Math.min(d.y, d.y + d.height),
                            Math.max(d.x, d.x + d.width),
                            Math.max(d.y, d.y + d.height)
                        ], g = m[0], y = m[1], w = m[2], T = m[3], k = p([
                            g,
                            y,
                            w,
                            T
                        ], i), A = k[0], M = k[1], S = k[2], C = k[3], L = l(e1.level, v.length);
                        null != e1.d && ("number" == typeof e1.d ? h = [
                            e1.d,
                            e1.d
                        ] : e1.d.length && (h = e1.d), L = Math.min(Math.max(Math.ceil(-f(Math.abs(h[0]) / (i[2] - i[0]))), Math.ceil(-f(Math.abs(h[1]) / (i[3] - i[1])))), L));
                        if (L = Math.min(L, v.length), e1.lod) return function(t1, e1, r, i, a) {
                            for(var o = [], s = 0; s < a; s++){
                                var l = _[s], c = b[s][0], u = E(t1, e1, s), h = E(r, i, s), f = n.ge(l, u), p = n.gt(l, h, f, l.length - 1);
                                o[s] = [
                                    f + c,
                                    p + c
                                ];
                            }
                            return o;
                        }(A, M, S, C, L);
                        var I = [];
                        return function e1(r, n, i, a, o, s) {
                            if (null !== o && null !== s && !(A > r + i || M > n + i || S < r || C < n || a >= L || o === s)) {
                                var l = v[a];
                                void 0 === s && (s = l.length);
                                for(var c = o; c < s; c++){
                                    var u = l[c], h = t1[2 * u], f = t1[2 * u + 1];
                                    h >= g && h <= w && f >= y && f <= T && I.push(u);
                                }
                                var p = x[a], d = p[4 * o + 0], m = p[4 * o + 1], _ = p[4 * o + 2], b = p[4 * o + 3], k = function(t1, e1) {
                                    for(var r = null, n = 0; null === r;)if (r = t1[4 * e1 + n], ++n > t1.length) return null;
                                    return r;
                                }(p, o + 1), E = .5 * i, P = a + 1;
                                e1(r, n, E, P, d, m || _ || b || k), e1(r, n + E, E, P, m, _ || b || k), e1(r + E, n, E, P, _, b || k), e1(r + E, n + E, E, P, b, k);
                            }
                        }(0, 0, 1, 0, 0, 1), I;
                    }, d;
                    function E(t1, e1, r) {
                        for(var n = 1, i = .5, a = .5, o = .5, s = 0; s < r; s++)n <<= 2, n += t1 < i ? e1 < a ? 0 : 1 : e1 < a ? 2 : 3, o *= .5, i += t1 < i ? -o : o, a += e1 < a ? -o : o;
                        return n;
                    }
                };
            },
            16844: function(t1) {
                t1.exports = function(t1) {
                    var e1 = 0, r = 0, n = 0, i = 0;
                    return t1.map(function(t1) {
                        var a = (t1 = t1.slice())[0], o = a.toUpperCase();
                        if (a != o) switch(t1[0] = o, a){
                            case "a":
                                t1[6] += n, t1[7] += i;
                                break;
                            case "v":
                                t1[1] += i;
                                break;
                            case "h":
                                t1[1] += n;
                                break;
                            default:
                                for(var s = 1; s < t1.length;)t1[s++] += n, t1[s++] += i;
                        }
                        switch(o){
                            case "Z":
                                n = e1, i = r;
                                break;
                            case "H":
                                n = t1[1];
                                break;
                            case "V":
                                i = t1[1];
                                break;
                            case "M":
                                n = e1 = t1[1], i = r = t1[2];
                                break;
                            default:
                                n = t1[t1.length - 2], i = t1[t1.length - 1];
                        }
                        return t1;
                    });
                };
            },
            78112: function(t1) {
                "use strict";
                t1.exports = function(t1, e1) {
                    if (!t1 || null == t1.length) throw Error("Argument should be an array");
                    e1 = null == e1 ? 1 : Math.floor(e1);
                    for(var r = Array(2 * e1), n = 0; n < e1; n++){
                        for(var i = -1 / 0, a = 1 / 0, o = n, s = t1.length; o < s; o += e1)t1[o] > i && (i = t1[o]), t1[o] < a && (a = t1[o]);
                        r[n] = a, r[e1 + n] = i;
                    }
                    return r;
                };
            },
            33055: function(t1) {
                "use strict";
                t1.exports = function(t1, e1, r) {
                    if ("function" == typeof Array.prototype.findIndex) return t1.findIndex(e1, r);
                    if ("function" != typeof e1) throw new TypeError("predicate must be a function");
                    var n = Object(t1), i = n.length;
                    if (0 === i) return -1;
                    for(var a = 0; a < i; a++)if (e1.call(r, n[a], a, n)) return a;
                    return -1;
                };
            },
            90956: function(t1, e1, r) {
                "use strict";
                var n = r(78112);
                t1.exports = function(t1, e1, r) {
                    if (!t1 || null == t1.length) throw Error("Argument should be an array");
                    null == e1 && (e1 = 1), null == r && (r = n(t1, e1));
                    for(var i = 0; i < e1; i++){
                        var a = r[e1 + i], o = r[i], s = i, l = t1.length;
                        if (a === 1 / 0 && o === -1 / 0) for(s = i; s < l; s += e1)t1[s] = t1[s] === a ? 1 : t1[s] === o ? 0 : .5;
                        else if (a === 1 / 0) for(s = i; s < l; s += e1)t1[s] = t1[s] === a ? 1 : 0;
                        else if (o === -1 / 0) for(s = i; s < l; s += e1)t1[s] = t1[s] === o ? 0 : 1;
                        else {
                            var c = a - o;
                            for(s = i; s < l; s += e1)isNaN(t1[s]) || (t1[s] = 0 === c ? .5 : (t1[s] - o) / c);
                        }
                    }
                    return t1;
                };
            },
            27902: function(t1) {
                t1.exports = function(t1, e1) {
                    var r = "number" == typeof t1, n = "number" == typeof e1;
                    r && !n ? (e1 = t1, t1 = 0) : r || n || (t1 = 0, e1 = 0);
                    var i = (e1 |= 0) - (t1 |= 0);
                    if (i < 0) throw new Error("array length must be positive");
                    for(var a = new Array(i), o = 0, s = t1; o < i; o++, s++)a[o] = s;
                    return a;
                };
            },
            85672: function(t1, e1, r) {
                "use strict";
                var n = r(33282);
                function i(t1) {
                    return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                        return typeof t1;
                    } : function(t1) {
                        return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                    }, i(t1);
                }
                function a(t1, e1) {
                    for(var r = 0; r < e1.length; r++){
                        var n = e1[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t1, (a = function(t1, e1) {
                            if ("object" !== i(t1) || null === t1) return t1;
                            var r = t1[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(t1, "string");
                                if ("object" !== i(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return String(t1);
                        }(n.key), "symbol" === i(a) ? a : String(a)), n);
                    }
                    var a;
                }
                function o(t1, e1, r) {
                    return e1 && a(t1.prototype, e1), r && a(t1, r), Object.defineProperty(t1, "prototype", {
                        writable: !1
                    }), t1;
                }
                var s, l, c = r(34585).codes, u = c.ERR_AMBIGUOUS_ARGUMENT, h = c.ERR_INVALID_ARG_TYPE, f = c.ERR_INVALID_ARG_VALUE, p = c.ERR_INVALID_RETURN_VALUE, d = c.ERR_MISSING_ARGS, m = r(68586), g = r(56557).inspect, y = r(56557).types, v = y.isPromise, x = y.isRegExp, _ = r(68686)(), b = r(9622)(), w = r(63063)("RegExp.prototype.test");
                function T() {
                    var t1 = r(23879);
                    s = t1.isDeepEqual, l = t1.isDeepStrictEqual;
                }
                new Map;
                var k = !1, A = t1.exports = C, M = {};
                function S(t1) {
                    if (t1.message instanceof Error) throw t1.message;
                    throw new m(t1);
                }
                function E(t1, e1, r, n) {
                    if (!r) {
                        var i = !1;
                        if (0 === e1) i = !0, n = "No value argument passed to `assert.ok()`";
                        else if (n instanceof Error) throw n;
                        var a = new m({
                            actual: r,
                            expected: !0,
                            message: n,
                            operator: "==",
                            stackStartFn: t1
                        });
                        throw a.generatedMessage = i, a;
                    }
                }
                function C() {
                    for(var t1 = arguments.length, e1 = new Array(t1), r = 0; r < t1; r++)e1[r] = arguments[r];
                    E.apply(void 0, [
                        C,
                        e1.length
                    ].concat(e1));
                }
                A.fail = function t1(e1, r, i, a, o) {
                    var s, l = arguments.length;
                    if (0 === l ? s = "Failed" : 1 === l ? (i = e1, e1 = void 0) : (!1 === k && (k = !0, (n.emitWarning ? n.emitWarning : console.warn.bind(console))("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094")), 2 === l && (a = "!=")), i instanceof Error) throw i;
                    var c = {
                        actual: e1,
                        expected: r,
                        operator: void 0 === a ? "fail" : a,
                        stackStartFn: o || t1
                    };
                    void 0 !== i && (c.message = i);
                    var u = new m(c);
                    throw s && (u.message = s, u.generatedMessage = !0), u;
                }, A.AssertionError = m, A.ok = C, A.equal = function t1(e1, r, n) {
                    if (arguments.length < 2) throw new d("actual", "expected");
                    e1 != r && S({
                        actual: e1,
                        expected: r,
                        message: n,
                        operator: "==",
                        stackStartFn: t1
                    });
                }, A.notEqual = function t1(e1, r, n) {
                    if (arguments.length < 2) throw new d("actual", "expected");
                    e1 == r && S({
                        actual: e1,
                        expected: r,
                        message: n,
                        operator: "!=",
                        stackStartFn: t1
                    });
                }, A.deepEqual = function t1(e1, r, n) {
                    if (arguments.length < 2) throw new d("actual", "expected");
                    void 0 === s && T(), s(e1, r) || S({
                        actual: e1,
                        expected: r,
                        message: n,
                        operator: "deepEqual",
                        stackStartFn: t1
                    });
                }, A.notDeepEqual = function t1(e1, r, n) {
                    if (arguments.length < 2) throw new d("actual", "expected");
                    void 0 === s && T(), s(e1, r) && S({
                        actual: e1,
                        expected: r,
                        message: n,
                        operator: "notDeepEqual",
                        stackStartFn: t1
                    });
                }, A.deepStrictEqual = function t1(e1, r, n) {
                    if (arguments.length < 2) throw new d("actual", "expected");
                    void 0 === s && T(), l(e1, r) || S({
                        actual: e1,
                        expected: r,
                        message: n,
                        operator: "deepStrictEqual",
                        stackStartFn: t1
                    });
                }, A.notDeepStrictEqual = function t1(e1, r, n) {
                    if (arguments.length < 2) throw new d("actual", "expected");
                    void 0 === s && T(), l(e1, r) && S({
                        actual: e1,
                        expected: r,
                        message: n,
                        operator: "notDeepStrictEqual",
                        stackStartFn: t1
                    });
                }, A.strictEqual = function t1(e1, r, n) {
                    if (arguments.length < 2) throw new d("actual", "expected");
                    b(e1, r) || S({
                        actual: e1,
                        expected: r,
                        message: n,
                        operator: "strictEqual",
                        stackStartFn: t1
                    });
                }, A.notStrictEqual = function t1(e1, r, n) {
                    if (arguments.length < 2) throw new d("actual", "expected");
                    b(e1, r) && S({
                        actual: e1,
                        expected: r,
                        message: n,
                        operator: "notStrictEqual",
                        stackStartFn: t1
                    });
                };
                var L = o(function t1(e1, r, n) {
                    var i = this;
                    !function(t1, e1) {
                        if (!(t1 instanceof e1)) throw new TypeError("Cannot call a class as a function");
                    }(this, t1), r.forEach(function(t1) {
                        t1 in e1 && (void 0 !== n && "string" == typeof n[t1] && x(e1[t1]) && w(e1[t1], n[t1]) ? i[t1] = n[t1] : i[t1] = e1[t1]);
                    });
                });
                function I(t1, e1, r, n) {
                    if ("function" != typeof e1) {
                        if (x(e1)) return w(e1, t1);
                        if (2 === arguments.length) throw new h("expected", [
                            "Function",
                            "RegExp"
                        ], e1);
                        if ("object" !== i(t1) || null === t1) {
                            var a = new m({
                                actual: t1,
                                expected: e1,
                                message: r,
                                operator: "deepStrictEqual",
                                stackStartFn: n
                            });
                            throw a.operator = n.name, a;
                        }
                        var o = Object.keys(e1);
                        if (e1 instanceof Error) o.push("name", "message");
                        else if (0 === o.length) throw new f("error", e1, "may not be an empty object");
                        return void 0 === s && T(), o.forEach(function(i) {
                            "string" == typeof t1[i] && x(e1[i]) && w(e1[i], t1[i]) || function(t1, e1, r, n, i, a) {
                                if (!(r in t1) || !l(t1[r], e1[r])) {
                                    if (!n) {
                                        var o = new L(t1, i), s = new L(e1, i, t1), c = new m({
                                            actual: o,
                                            expected: s,
                                            operator: "deepStrictEqual",
                                            stackStartFn: a
                                        });
                                        throw c.actual = t1, c.expected = e1, c.operator = a.name, c;
                                    }
                                    S({
                                        actual: t1,
                                        expected: e1,
                                        message: n,
                                        operator: a.name,
                                        stackStartFn: a
                                    });
                                }
                            }(t1, e1, i, r, o, n);
                        }), !0;
                    }
                    return void 0 !== e1.prototype && t1 instanceof e1 || !Error.isPrototypeOf(e1) && !0 === e1.call({}, t1);
                }
                function P(t1) {
                    if ("function" != typeof t1) throw new h("fn", "Function", t1);
                    try {
                        t1();
                    } catch (t1) {
                        return t1;
                    }
                    return M;
                }
                function z(t1) {
                    return v(t1) || null !== t1 && "object" === i(t1) && "function" == typeof t1.then && "function" == typeof t1.catch;
                }
                function O(t1) {
                    return Promise.resolve().then(function() {
                        var e1;
                        if ("function" == typeof t1) {
                            if (!z(e1 = t1())) throw new p("instance of Promise", "promiseFn", e1);
                        } else {
                            if (!z(t1)) throw new h("promiseFn", [
                                "Function",
                                "Promise"
                            ], t1);
                            e1 = t1;
                        }
                        return Promise.resolve().then(function() {
                            return e1;
                        }).then(function() {
                            return M;
                        }).catch(function(t1) {
                            return t1;
                        });
                    });
                }
                function D(t1, e1, r, n) {
                    if ("string" == typeof r) {
                        if (4 === arguments.length) throw new h("error", [
                            "Object",
                            "Error",
                            "Function",
                            "RegExp"
                        ], r);
                        if ("object" === i(e1) && null !== e1) {
                            if (e1.message === r) throw new u("error/message", 'The error message "'.concat(e1.message, '" is identical to the message.'));
                        } else if (e1 === r) throw new u("error/message", 'The error "'.concat(e1, '" is identical to the message.'));
                        n = r, r = void 0;
                    } else if (null != r && "object" !== i(r) && "function" != typeof r) throw new h("error", [
                        "Object",
                        "Error",
                        "Function",
                        "RegExp"
                    ], r);
                    if (e1 === M) {
                        var a = "";
                        r && r.name && (a += " (".concat(r.name, ")")), a += n ? ": ".concat(n) : ".";
                        var o = "rejects" === t1.name ? "rejection" : "exception";
                        S({
                            actual: void 0,
                            expected: r,
                            operator: t1.name,
                            message: "Missing expected ".concat(o).concat(a),
                            stackStartFn: t1
                        });
                    }
                    if (r && !I(e1, r, n, t1)) throw e1;
                }
                function R(t1, e1, r, n) {
                    if (e1 !== M) {
                        if ("string" == typeof r && (n = r, r = void 0), !r || I(e1, r)) {
                            var i = n ? ": ".concat(n) : ".", a = "doesNotReject" === t1.name ? "rejection" : "exception";
                            S({
                                actual: e1,
                                expected: r,
                                operator: t1.name,
                                message: "Got unwanted ".concat(a).concat(i, "\n") + 'Actual message: "'.concat(e1 && e1.message, '"'),
                                stackStartFn: t1
                            });
                        }
                        throw e1;
                    }
                }
                function F(t1, e1, r, n, a) {
                    if (!x(e1)) throw new h("regexp", "RegExp", e1);
                    var o = "match" === a;
                    if ("string" != typeof t1 || w(e1, t1) !== o) {
                        if (r instanceof Error) throw r;
                        var s = !r;
                        r = r || ("string" != typeof t1 ? 'The "string" argument must be of type string. Received type ' + "".concat(i(t1), " (").concat(g(t1), ")") : (o ? "The input did not match the regular expression " : "The input was expected to not match the regular expression ") + "".concat(g(e1), ". Input:\n\n").concat(g(t1), "\n"));
                        var l = new m({
                            actual: t1,
                            expected: e1,
                            message: r,
                            operator: a,
                            stackStartFn: n
                        });
                        throw l.generatedMessage = s, l;
                    }
                }
                function B() {
                    for(var t1 = arguments.length, e1 = new Array(t1), r = 0; r < t1; r++)e1[r] = arguments[r];
                    E.apply(void 0, [
                        B,
                        e1.length
                    ].concat(e1));
                }
                A.throws = function t1(e1) {
                    for(var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)n[i - 1] = arguments[i];
                    D.apply(void 0, [
                        t1,
                        P(e1)
                    ].concat(n));
                }, A.rejects = function t1(e1) {
                    for(var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)n[i - 1] = arguments[i];
                    return O(e1).then(function(e1) {
                        return D.apply(void 0, [
                            t1,
                            e1
                        ].concat(n));
                    });
                }, A.doesNotThrow = function t1(e1) {
                    for(var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)n[i - 1] = arguments[i];
                    R.apply(void 0, [
                        t1,
                        P(e1)
                    ].concat(n));
                }, A.doesNotReject = function t1(e1) {
                    for(var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)n[i - 1] = arguments[i];
                    return O(e1).then(function(e1) {
                        return R.apply(void 0, [
                            t1,
                            e1
                        ].concat(n));
                    });
                }, A.ifError = function t1(e1) {
                    if (null != e1) {
                        var r = "ifError got unwanted exception: ";
                        "object" === i(e1) && "string" == typeof e1.message ? 0 === e1.message.length && e1.constructor ? r += e1.constructor.name : r += e1.message : r += g(e1);
                        var n = new m({
                            actual: e1,
                            expected: null,
                            operator: "ifError",
                            message: r,
                            stackStartFn: t1
                        }), a = e1.stack;
                        if ("string" == typeof a) {
                            var o = a.split("\n");
                            o.shift();
                            for(var s = n.stack.split("\n"), l = 0; l < o.length; l++){
                                var c = s.indexOf(o[l]);
                                if (-1 !== c) {
                                    s = s.slice(0, c);
                                    break;
                                }
                            }
                            n.stack = "".concat(s.join("\n"), "\n").concat(o.join("\n"));
                        }
                        throw n;
                    }
                }, A.match = function t1(e1, r, n) {
                    F(e1, r, n, t1, "match");
                }, A.doesNotMatch = function t1(e1, r, n) {
                    F(e1, r, n, t1, "doesNotMatch");
                }, A.strict = _(B, A, {
                    equal: A.strictEqual,
                    deepEqual: A.deepStrictEqual,
                    notEqual: A.notStrictEqual,
                    notDeepEqual: A.notDeepStrictEqual
                }), A.strict.strict = A.strict;
            },
            68586: function(t1, e1, r) {
                "use strict";
                var n = r(33282);
                function i(t1, e1) {
                    var r = Object.keys(t1);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(t1);
                        e1 && (n = n.filter(function(e1) {
                            return Object.getOwnPropertyDescriptor(t1, e1).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function a(t1) {
                    for(var e1 = 1; e1 < arguments.length; e1++){
                        var r = null != arguments[e1] ? arguments[e1] : {};
                        e1 % 2 ? i(Object(r), !0).forEach(function(e1) {
                            var n, i, a;
                            n = t1, i = e1, a = r[e1], (i = s(i)) in n ? Object.defineProperty(n, i, {
                                value: a,
                                enumerable: !0,
                                configurable: !0,
                                writable: !0
                            }) : n[i] = a;
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t1, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(e1) {
                            Object.defineProperty(t1, e1, Object.getOwnPropertyDescriptor(r, e1));
                        });
                    }
                    return t1;
                }
                function o(t1, e1) {
                    for(var r = 0; r < e1.length; r++){
                        var n = e1[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t1, s(n.key), n);
                    }
                }
                function s(t1) {
                    var e1 = function(t1, e1) {
                        if ("object" !== m(t1) || null === t1) return t1;
                        var r = t1[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(t1, "string");
                            if ("object" !== m(n)) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(t1);
                    }(t1);
                    return "symbol" === m(e1) ? e1 : String(e1);
                }
                function l(t1, e1) {
                    if (e1 && ("object" === m(e1) || "function" == typeof e1)) return e1;
                    if (void 0 !== e1) throw new TypeError("Derived constructors may only return object or undefined");
                    return c(t1);
                }
                function c(t1) {
                    if (void 0 === t1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return t1;
                }
                function u(t1) {
                    var e1 = "function" == typeof Map ? new Map : void 0;
                    return u = function(t1) {
                        if (null === t1 || (r = t1, -1 === Function.toString.call(r).indexOf("[native code]"))) return t1;
                        var r;
                        if ("function" != typeof t1) throw new TypeError("Super expression must either be null or a function");
                        if (void 0 !== e1) {
                            if (e1.has(t1)) return e1.get(t1);
                            e1.set(t1, n);
                        }
                        function n() {
                            return h(t1, arguments, d(this).constructor);
                        }
                        return n.prototype = Object.create(t1.prototype, {
                            constructor: {
                                value: n,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), p(n, t1);
                    }, u(t1);
                }
                function h(t1, e1, r) {
                    return h = f() ? Reflect.construct.bind() : function(t1, e1, r) {
                        var n = [
                            null
                        ];
                        n.push.apply(n, e1);
                        var i = new (Function.bind.apply(t1, n));
                        return r && p(i, r.prototype), i;
                    }, h.apply(null, arguments);
                }
                function f() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (t1) {
                        return !1;
                    }
                }
                function p(t1, e1) {
                    return p = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t1, e1) {
                        return t1.__proto__ = e1, t1;
                    }, p(t1, e1);
                }
                function d(t1) {
                    return d = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t1) {
                        return t1.__proto__ || Object.getPrototypeOf(t1);
                    }, d(t1);
                }
                function m(t1) {
                    return m = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                        return typeof t1;
                    } : function(t1) {
                        return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                    }, m(t1);
                }
                var g = r(56557).inspect, y = r(34585).codes.ERR_INVALID_ARG_TYPE;
                function v(t1, e1, r) {
                    return (void 0 === r || r > t1.length) && (r = t1.length), t1.substring(r - e1.length, r) === e1;
                }
                var x = "", _ = "", b = "", w = "", T = {
                    deepStrictEqual: "Expected values to be strictly deep-equal:",
                    strictEqual: "Expected values to be strictly equal:",
                    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
                    deepEqual: "Expected values to be loosely deep-equal:",
                    equal: "Expected values to be loosely equal:",
                    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
                    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
                    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
                    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
                    notEqual: 'Expected "actual" to be loosely unequal to:',
                    notIdentical: "Values identical but not reference-equal:"
                };
                function k(t1) {
                    var e1 = Object.keys(t1), r = Object.create(Object.getPrototypeOf(t1));
                    return e1.forEach(function(e1) {
                        r[e1] = t1[e1];
                    }), Object.defineProperty(r, "message", {
                        value: t1.message
                    }), r;
                }
                function A(t1) {
                    return g(t1, {
                        compact: !1,
                        customInspect: !1,
                        depth: 1e3,
                        maxArrayLength: 1 / 0,
                        showHidden: !1,
                        breakLength: 1 / 0,
                        showProxy: !1,
                        sorted: !0,
                        getters: !0
                    });
                }
                var M = function(t1, e1) {
                    !function(t1, e1) {
                        if ("function" != typeof e1 && null !== e1) throw new TypeError("Super expression must either be null or a function");
                        t1.prototype = Object.create(e1 && e1.prototype, {
                            constructor: {
                                value: t1,
                                writable: !0,
                                configurable: !0
                            }
                        }), Object.defineProperty(t1, "prototype", {
                            writable: !1
                        }), e1 && p(t1, e1);
                    }(M, t1);
                    var r, i, s, u, h = (r = M, i = f(), function() {
                        var t1, e1 = d(r);
                        if (i) {
                            var n = d(this).constructor;
                            t1 = Reflect.construct(e1, arguments, n);
                        } else t1 = e1.apply(this, arguments);
                        return l(this, t1);
                    });
                    function M(t1) {
                        var e1;
                        if (function(t1, e1) {
                            if (!(t1 instanceof e1)) throw new TypeError("Cannot call a class as a function");
                        }(this, M), "object" !== m(t1) || null === t1) throw new y("options", "Object", t1);
                        var r = t1.message, i = t1.operator, a = t1.stackStartFn, o = t1.actual, s = t1.expected, u = Error.stackTraceLimit;
                        if (Error.stackTraceLimit = 0, null != r) e1 = h.call(this, String(r));
                        else if (n.stderr && n.stderr.isTTY && (n.stderr && n.stderr.getColorDepth && 1 !== n.stderr.getColorDepth() ? (x = "\x1b[34m", _ = "\x1b[32m", w = "\x1b[39m", b = "\x1b[31m") : (x = "", _ = "", w = "", b = "")), "object" === m(o) && null !== o && "object" === m(s) && null !== s && "stack" in o && o instanceof Error && "stack" in s && s instanceof Error && (o = k(o), s = k(s)), "deepStrictEqual" === i || "strictEqual" === i) e1 = h.call(this, function(t1, e1, r) {
                            var i = "", a = "", o = 0, s = "", l = !1, c = A(t1), u = c.split("\n"), h = A(e1).split("\n"), f = 0, p = "";
                            if ("strictEqual" === r && "object" === m(t1) && "object" === m(e1) && null !== t1 && null !== e1 && (r = "strictEqualObject"), 1 === u.length && 1 === h.length && u[0] !== h[0]) {
                                var d = u[0].length + h[0].length;
                                if (d <= 10) {
                                    if (!("object" === m(t1) && null !== t1 || "object" === m(e1) && null !== e1 || 0 === t1 && 0 === e1)) return "".concat(T[r], "\n\n") + "".concat(u[0], " !== ").concat(h[0], "\n");
                                } else if ("strictEqualObject" !== r && d < (n.stderr && n.stderr.isTTY ? n.stderr.columns : 80)) {
                                    for(; u[0][f] === h[0][f];)f++;
                                    f > 2 && (p = "\n  ".concat(function(t1, e1) {
                                        if (e1 = Math.floor(e1), 0 == t1.length || 0 == e1) return "";
                                        var r = t1.length * e1;
                                        for(e1 = Math.floor(Math.log(e1) / Math.log(2)); e1;)t1 += t1, e1--;
                                        return t1 + t1.substring(0, r - t1.length);
                                    }(" ", f), "^"), f = 0);
                                }
                            }
                            for(var g = u[u.length - 1], y = h[h.length - 1]; g === y && (f++ < 2 ? s = "\n  ".concat(g).concat(s) : i = g, u.pop(), h.pop(), 0 !== u.length && 0 !== h.length);)g = u[u.length - 1], y = h[h.length - 1];
                            var k = Math.max(u.length, h.length);
                            if (0 === k) {
                                var M = c.split("\n");
                                if (M.length > 30) for(M[26] = "".concat(x, "...").concat(w); M.length > 27;)M.pop();
                                return "".concat(T.notIdentical, "\n\n").concat(M.join("\n"), "\n");
                            }
                            f > 3 && (s = "\n".concat(x, "...").concat(w).concat(s), l = !0), "" !== i && (s = "\n  ".concat(i).concat(s), i = "");
                            var S = 0, E = T[r] + "\n".concat(_, "+ actual").concat(w, " ").concat(b, "- expected").concat(w), C = " ".concat(x, "...").concat(w, " Lines skipped");
                            for(f = 0; f < k; f++){
                                var L = f - o;
                                if (u.length < f + 1) L > 1 && f > 2 && (L > 4 ? (a += "\n".concat(x, "...").concat(w), l = !0) : L > 3 && (a += "\n  ".concat(h[f - 2]), S++), a += "\n  ".concat(h[f - 1]), S++), o = f, i += "\n".concat(b, "-").concat(w, " ").concat(h[f]), S++;
                                else if (h.length < f + 1) L > 1 && f > 2 && (L > 4 ? (a += "\n".concat(x, "...").concat(w), l = !0) : L > 3 && (a += "\n  ".concat(u[f - 2]), S++), a += "\n  ".concat(u[f - 1]), S++), o = f, a += "\n".concat(_, "+").concat(w, " ").concat(u[f]), S++;
                                else {
                                    var I = h[f], P = u[f], z = P !== I && (!v(P, ",") || P.slice(0, -1) !== I);
                                    z && v(I, ",") && I.slice(0, -1) === P && (z = !1, P += ","), z ? (L > 1 && f > 2 && (L > 4 ? (a += "\n".concat(x, "...").concat(w), l = !0) : L > 3 && (a += "\n  ".concat(u[f - 2]), S++), a += "\n  ".concat(u[f - 1]), S++), o = f, a += "\n".concat(_, "+").concat(w, " ").concat(P), i += "\n".concat(b, "-").concat(w, " ").concat(I), S += 2) : (a += i, i = "", 1 !== L && 0 !== f || (a += "\n  ".concat(P), S++));
                                }
                                if (S > 20 && f < k - 2) return "".concat(E).concat(C, "\n").concat(a, "\n").concat(x, "...").concat(w).concat(i, "\n") + "".concat(x, "...").concat(w);
                            }
                            return "".concat(E).concat(l ? C : "", "\n").concat(a).concat(i).concat(s).concat(p);
                        }(o, s, i));
                        else if ("notDeepStrictEqual" === i || "notStrictEqual" === i) {
                            var f = T[i], p = A(o).split("\n");
                            if ("notStrictEqual" === i && "object" === m(o) && null !== o && (f = T.notStrictEqualObject), p.length > 30) for(p[26] = "".concat(x, "...").concat(w); p.length > 27;)p.pop();
                            e1 = 1 === p.length ? h.call(this, "".concat(f, " ").concat(p[0])) : h.call(this, "".concat(f, "\n\n").concat(p.join("\n"), "\n"));
                        } else {
                            var d = A(o), g = "", S = T[i];
                            "notDeepEqual" === i || "notEqual" === i ? (d = "".concat(T[i], "\n\n").concat(d)).length > 1024 && (d = "".concat(d.slice(0, 1021), "...")) : (g = "".concat(A(s)), d.length > 512 && (d = "".concat(d.slice(0, 509), "...")), g.length > 512 && (g = "".concat(g.slice(0, 509), "...")), "deepEqual" === i || "equal" === i ? d = "".concat(S, "\n\n").concat(d, "\n\nshould equal\n\n") : g = " ".concat(i, " ").concat(g)), e1 = h.call(this, "".concat(d).concat(g));
                        }
                        return Error.stackTraceLimit = u, e1.generatedMessage = !r, Object.defineProperty(c(e1), "name", {
                            value: "AssertionError [ERR_ASSERTION]",
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }), e1.code = "ERR_ASSERTION", e1.actual = o, e1.expected = s, e1.operator = i, Error.captureStackTrace && Error.captureStackTrace(c(e1), a), e1.stack, e1.name = "AssertionError", l(e1);
                    }
                    return s = M, u = [
                        {
                            key: "toString",
                            value: function() {
                                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
                            }
                        },
                        {
                            key: e1,
                            value: function(t1, e1) {
                                return g(this, a(a({}, e1), {}, {
                                    customInspect: !1,
                                    depth: 0
                                }));
                            }
                        }
                    ], o(s.prototype, u), Object.defineProperty(s, "prototype", {
                        writable: !1
                    }), M;
                }(u(Error), g.custom);
                t1.exports = M;
            },
            34585: function(t1, e1, r) {
                "use strict";
                function n(t1) {
                    return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                        return typeof t1;
                    } : function(t1) {
                        return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                    }, n(t1);
                }
                function i(t1, e1) {
                    return i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t1, e1) {
                        return t1.__proto__ = e1, t1;
                    }, i(t1, e1);
                }
                function a(t1) {
                    return a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t1) {
                        return t1.__proto__ || Object.getPrototypeOf(t1);
                    }, a(t1);
                }
                var o, s, l = {};
                function c(t1, e1, r) {
                    r || (r = Error);
                    var o = function(r) {
                        !function(t1, e1) {
                            if ("function" != typeof e1 && null !== e1) throw new TypeError("Super expression must either be null or a function");
                            t1.prototype = Object.create(e1 && e1.prototype, {
                                constructor: {
                                    value: t1,
                                    writable: !0,
                                    configurable: !0
                                }
                            }), Object.defineProperty(t1, "prototype", {
                                writable: !1
                            }), e1 && i(t1, e1);
                        }(u, r);
                        var o, s, l, c = (s = u, l = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (t1) {
                                return !1;
                            }
                        }(), function() {
                            var t1, e1 = a(s);
                            if (l) {
                                var r = a(this).constructor;
                                t1 = Reflect.construct(e1, arguments, r);
                            } else t1 = e1.apply(this, arguments);
                            return function(t1, e1) {
                                if (e1 && ("object" === n(e1) || "function" == typeof e1)) return e1;
                                if (void 0 !== e1) throw new TypeError("Derived constructors may only return object or undefined");
                                return function(t1) {
                                    if (void 0 === t1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                    return t1;
                                }(t1);
                            }(this, t1);
                        });
                        function u(r, n, i) {
                            var a;
                            return function(t1, e1) {
                                if (!(t1 instanceof e1)) throw new TypeError("Cannot call a class as a function");
                            }(this, u), a = c.call(this, function(t1, r, n) {
                                return "string" == typeof e1 ? e1 : e1(t1, r, n);
                            }(r, n, i)), a.code = t1, a;
                        }
                        return o = u, Object.defineProperty(o, "prototype", {
                            writable: !1
                        }), o;
                    }(r);
                    l[t1] = o;
                }
                function u(t1, e1) {
                    if (Array.isArray(t1)) {
                        var r = t1.length;
                        return t1 = t1.map(function(t1) {
                            return String(t1);
                        }), r > 2 ? "one of ".concat(e1, " ").concat(t1.slice(0, r - 1).join(", "), ", or ") + t1[r - 1] : 2 === r ? "one of ".concat(e1, " ").concat(t1[0], " or ").concat(t1[1]) : "of ".concat(e1, " ").concat(t1[0]);
                    }
                    return "of ".concat(e1, " ").concat(String(t1));
                }
                c("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError), c("ERR_INVALID_ARG_TYPE", function(t1, e1, i) {
                    var a, s, l, c, h;
                    if (void 0 === o && (o = r(85672)), o("string" == typeof t1, "'name' must be a string"), "string" == typeof e1 && (s = "not ", e1.substr(0, 4) === s) ? (a = "must not be", e1 = e1.replace(/^not /, "")) : a = "must be", function(t1, e1, r) {
                        return (void 0 === r || r > t1.length) && (r = t1.length), t1.substring(r - 9, r) === e1;
                    }(t1, " argument")) l = "The ".concat(t1, " ").concat(a, " ").concat(u(e1, "type"));
                    else {
                        var f = ("number" != typeof h && (h = 0), h + 1 > (c = t1).length || -1 === c.indexOf(".", h) ? "argument" : "property");
                        l = 'The "'.concat(t1, '" ').concat(f, " ").concat(a, " ").concat(u(e1, "type"));
                    }
                    return l + ". Received type ".concat(n(i));
                }, TypeError), c("ERR_INVALID_ARG_VALUE", function(t1, e1) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "is invalid";
                    void 0 === s && (s = r(56557));
                    var i = s.inspect(e1);
                    return i.length > 128 && (i = "".concat(i.slice(0, 128), "...")), "The argument '".concat(t1, "' ").concat(n, ". Received ").concat(i);
                }, TypeError, RangeError), c("ERR_INVALID_RETURN_VALUE", function(t1, e1, r) {
                    var i;
                    return i = r && r.constructor && r.constructor.name ? "instance of ".concat(r.constructor.name) : "type ".concat(n(r)), "Expected ".concat(t1, ' to be returned from the "').concat(e1, '"') + " function but got ".concat(i, ".");
                }, TypeError), c("ERR_MISSING_ARGS", function() {
                    for(var t1 = arguments.length, e1 = new Array(t1), n = 0; n < t1; n++)e1[n] = arguments[n];
                    void 0 === o && (o = r(85672)), o(e1.length > 0, "At least one arg needs to be specified");
                    var i = "The ", a = e1.length;
                    switch(e1 = e1.map(function(t1) {
                        return '"'.concat(t1, '"');
                    }), a){
                        case 1:
                            i += "".concat(e1[0], " argument");
                            break;
                        case 2:
                            i += "".concat(e1[0], " and ").concat(e1[1], " arguments");
                            break;
                        default:
                            i += e1.slice(0, a - 1).join(", "), i += ", and ".concat(e1[a - 1], " arguments");
                    }
                    return "".concat(i, " must be specified");
                }, TypeError), t1.exports.codes = l;
            },
            23879: function(t1, e1, r) {
                "use strict";
                function n(t1, e1) {
                    return function(t1) {
                        if (Array.isArray(t1)) return t1;
                    }(t1) || function(t1, e1) {
                        var r = null == t1 ? null : "undefined" != typeof Symbol && t1[Symbol.iterator] || t1["@@iterator"];
                        if (null != r) {
                            var n, i, a, o, s = [], l = !0, c = !1;
                            try {
                                if (a = (r = r.call(t1)).next, 0 === e1) {
                                    if (Object(r) !== r) return;
                                    l = !1;
                                } else for(; !(l = (n = a.call(r)).done) && (s.push(n.value), s.length !== e1); l = !0);
                            } catch (t1) {
                                c = !0, i = t1;
                            } finally{
                                try {
                                    if (!l && null != r.return && (o = r.return(), Object(o) !== o)) return;
                                } finally{
                                    if (c) throw i;
                                }
                            }
                            return s;
                        }
                    }(t1, e1) || function(t1, e1) {
                        if (t1) {
                            if ("string" == typeof t1) return i(t1, e1);
                            var r = Object.prototype.toString.call(t1).slice(8, -1);
                            return "Object" === r && t1.constructor && (r = t1.constructor.name), "Map" === r || "Set" === r ? Array.from(t1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? i(t1, e1) : void 0;
                        }
                    }(t1, e1) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function i(t1, e1) {
                    (null == e1 || e1 > t1.length) && (e1 = t1.length);
                    for(var r = 0, n = new Array(e1); r < e1; r++)n[r] = t1[r];
                    return n;
                }
                function a(t1) {
                    return a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                        return typeof t1;
                    } : function(t1) {
                        return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                    }, a(t1);
                }
                var o = void 0 !== /a/g.flags, s = function(t1) {
                    var e1 = [];
                    return t1.forEach(function(t1) {
                        return e1.push(t1);
                    }), e1;
                }, l = function(t1) {
                    var e1 = [];
                    return t1.forEach(function(t1, r) {
                        return e1.push([
                            r,
                            t1
                        ]);
                    }), e1;
                }, c = Object.is ? Object.is : r(13969), u = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
                    return [];
                }, h = Number.isNaN ? Number.isNaN : r(63057);
                function f(t1) {
                    return t1.call.bind(t1);
                }
                var p = f(Object.prototype.hasOwnProperty), d = f(Object.prototype.propertyIsEnumerable), m = f(Object.prototype.toString), g = r(56557).types, y = g.isAnyArrayBuffer, v = g.isArrayBufferView, x = g.isDate, _ = g.isMap, b = g.isRegExp, w = g.isSet, T = g.isNativeError, k = g.isBoxedPrimitive, A = g.isNumberObject, M = g.isStringObject, S = g.isBooleanObject, E = g.isBigIntObject, C = g.isSymbolObject, L = g.isFloat32Array, I = g.isFloat64Array;
                function P(t1) {
                    if (0 === t1.length || t1.length > 10) return !0;
                    for(var e1 = 0; e1 < t1.length; e1++){
                        var r = t1.charCodeAt(e1);
                        if (r < 48 || r > 57) return !0;
                    }
                    return 10 === t1.length && t1 >= Math.pow(2, 32);
                }
                function z(t1) {
                    return Object.keys(t1).filter(P).concat(u(t1).filter(Object.prototype.propertyIsEnumerable.bind(t1)));
                }
                function O(t1, e1) {
                    if (t1 === e1) return 0;
                    for(var r = t1.length, n = e1.length, i = 0, a = Math.min(r, n); i < a; ++i)if (t1[i] !== e1[i]) {
                        r = t1[i], n = e1[i];
                        break;
                    }
                    return r < n ? -1 : n < r ? 1 : 0;
                }
                var D = 0, R = 1, F = 2, B = 3;
                function N(t1, e1, r, n) {
                    if (t1 === e1) return 0 !== t1 || !r || c(t1, e1);
                    if (r) {
                        if ("object" !== a(t1)) return "number" == typeof t1 && h(t1) && h(e1);
                        if ("object" !== a(e1) || null === t1 || null === e1) return !1;
                        if (Object.getPrototypeOf(t1) !== Object.getPrototypeOf(e1)) return !1;
                    } else {
                        if (null === t1 || "object" !== a(t1)) return (null === e1 || "object" !== a(e1)) && t1 == e1;
                        if (null === e1 || "object" !== a(e1)) return !1;
                    }
                    var i, s, l, u, f = m(t1);
                    if (f !== m(e1)) return !1;
                    if (Array.isArray(t1)) {
                        if (t1.length !== e1.length) return !1;
                        var p = z(t1), d = z(e1);
                        return p.length === d.length && U(t1, e1, r, n, R, p);
                    }
                    if ("[object Object]" === f && (!_(t1) && _(e1) || !w(t1) && w(e1))) return !1;
                    if (x(t1)) {
                        if (!x(e1) || Date.prototype.getTime.call(t1) !== Date.prototype.getTime.call(e1)) return !1;
                    } else if (b(t1)) {
                        if (!b(e1) || (l = t1, u = e1, !(o ? l.source === u.source && l.flags === u.flags : RegExp.prototype.toString.call(l) === RegExp.prototype.toString.call(u)))) return !1;
                    } else if (T(t1) || t1 instanceof Error) {
                        if (t1.message !== e1.message || t1.name !== e1.name) return !1;
                    } else {
                        if (v(t1)) {
                            if (r || !L(t1) && !I(t1)) {
                                if (!function(t1, e1) {
                                    return t1.byteLength === e1.byteLength && 0 === O(new Uint8Array(t1.buffer, t1.byteOffset, t1.byteLength), new Uint8Array(e1.buffer, e1.byteOffset, e1.byteLength));
                                }(t1, e1)) return !1;
                            } else if (!function(t1, e1) {
                                if (t1.byteLength !== e1.byteLength) return !1;
                                for(var r = 0; r < t1.byteLength; r++)if (t1[r] !== e1[r]) return !1;
                                return !0;
                            }(t1, e1)) return !1;
                            var g = z(t1), P = z(e1);
                            return g.length === P.length && U(t1, e1, r, n, D, g);
                        }
                        if (w(t1)) return !(!w(e1) || t1.size !== e1.size) && U(t1, e1, r, n, F);
                        if (_(t1)) return !(!_(e1) || t1.size !== e1.size) && U(t1, e1, r, n, B);
                        if (y(t1)) {
                            if (s = e1, (i = t1).byteLength !== s.byteLength || 0 !== O(new Uint8Array(i), new Uint8Array(s))) return !1;
                        } else if (k(t1) && !function(t1, e1) {
                            return A(t1) ? A(e1) && c(Number.prototype.valueOf.call(t1), Number.prototype.valueOf.call(e1)) : M(t1) ? M(e1) && String.prototype.valueOf.call(t1) === String.prototype.valueOf.call(e1) : S(t1) ? S(e1) && Boolean.prototype.valueOf.call(t1) === Boolean.prototype.valueOf.call(e1) : E(t1) ? E(e1) && BigInt.prototype.valueOf.call(t1) === BigInt.prototype.valueOf.call(e1) : C(e1) && Symbol.prototype.valueOf.call(t1) === Symbol.prototype.valueOf.call(e1);
                        }(t1, e1)) return !1;
                    }
                    return U(t1, e1, r, n, D);
                }
                function j(t1, e1) {
                    return e1.filter(function(e1) {
                        return d(t1, e1);
                    });
                }
                function U(t1, e1, r, i, o, c) {
                    if (5 === arguments.length) {
                        c = Object.keys(t1);
                        var h = Object.keys(e1);
                        if (c.length !== h.length) return !1;
                    }
                    for(var f = 0; f < c.length; f++)if (!p(e1, c[f])) return !1;
                    if (r && 5 === arguments.length) {
                        var m = u(t1);
                        if (0 !== m.length) {
                            var g = 0;
                            for(f = 0; f < m.length; f++){
                                var y = m[f];
                                if (d(t1, y)) {
                                    if (!d(e1, y)) return !1;
                                    c.push(y), g++;
                                } else if (d(e1, y)) return !1;
                            }
                            var v = u(e1);
                            if (m.length !== v.length && j(e1, v).length !== g) return !1;
                        } else {
                            var x = u(e1);
                            if (0 !== x.length && 0 !== j(e1, x).length) return !1;
                        }
                    }
                    if (0 === c.length && (o === D || o === R && 0 === t1.length || 0 === t1.size)) return !0;
                    if (void 0 === i) i = {
                        val1: new Map,
                        val2: new Map,
                        position: 0
                    };
                    else {
                        var _ = i.val1.get(t1);
                        if (void 0 !== _) {
                            var b = i.val2.get(e1);
                            if (void 0 !== b) return _ === b;
                        }
                        i.position++;
                    }
                    i.val1.set(t1, i.position), i.val2.set(e1, i.position);
                    var w = function(t1, e1, r, i, o, c) {
                        var u = 0;
                        if (c === F) {
                            if (!function(t1, e1, r, n) {
                                for(var i = null, o = s(t1), l = 0; l < o.length; l++){
                                    var c = o[l];
                                    if ("object" === a(c) && null !== c) null === i && (i = new Set), i.add(c);
                                    else if (!e1.has(c)) {
                                        if (r) return !1;
                                        if (!H(t1, e1, c)) return !1;
                                        null === i && (i = new Set), i.add(c);
                                    }
                                }
                                if (null !== i) {
                                    for(var u = s(e1), h = 0; h < u.length; h++){
                                        var f = u[h];
                                        if ("object" === a(f) && null !== f) {
                                            if (!V(i, f, r, n)) return !1;
                                        } else if (!r && !t1.has(f) && !V(i, f, r, n)) return !1;
                                    }
                                    return 0 === i.size;
                                }
                                return !0;
                            }(t1, e1, r, o)) return !1;
                        } else if (c === B) {
                            if (!function(t1, e1, r, i) {
                                for(var o = null, s = l(t1), c = 0; c < s.length; c++){
                                    var u = n(s[c], 2), h = u[0], f = u[1];
                                    if ("object" === a(h) && null !== h) null === o && (o = new Set), o.add(h);
                                    else {
                                        var p = e1.get(h);
                                        if (void 0 === p && !e1.has(h) || !N(f, p, r, i)) {
                                            if (r) return !1;
                                            if (!G(t1, e1, h, f, i)) return !1;
                                            null === o && (o = new Set), o.add(h);
                                        }
                                    }
                                }
                                if (null !== o) {
                                    for(var d = l(e1), m = 0; m < d.length; m++){
                                        var g = n(d[m], 2), y = g[0], v = g[1];
                                        if ("object" === a(y) && null !== y) {
                                            if (!Z(o, t1, y, v, r, i)) return !1;
                                        } else if (!(r || t1.has(y) && N(t1.get(y), v, !1, i) || Z(o, t1, y, v, !1, i))) return !1;
                                    }
                                    return 0 === o.size;
                                }
                                return !0;
                            }(t1, e1, r, o)) return !1;
                        } else if (c === R) for(; u < t1.length; u++){
                            if (!p(t1, u)) {
                                if (p(e1, u)) return !1;
                                for(var h = Object.keys(t1); u < h.length; u++){
                                    var f = h[u];
                                    if (!p(e1, f) || !N(t1[f], e1[f], r, o)) return !1;
                                }
                                return h.length === Object.keys(e1).length;
                            }
                            if (!p(e1, u) || !N(t1[u], e1[u], r, o)) return !1;
                        }
                        for(u = 0; u < i.length; u++){
                            var d = i[u];
                            if (!N(t1[d], e1[d], r, o)) return !1;
                        }
                        return !0;
                    }(t1, e1, r, c, i, o);
                    return i.val1.delete(t1), i.val2.delete(e1), w;
                }
                function V(t1, e1, r, n) {
                    for(var i = s(t1), a = 0; a < i.length; a++){
                        var o = i[a];
                        if (N(e1, o, r, n)) return t1.delete(o), !0;
                    }
                    return !1;
                }
                function q(t1) {
                    switch(a(t1)){
                        case "undefined":
                            return null;
                        case "object":
                            return;
                        case "symbol":
                            return !1;
                        case "string":
                            t1 = +t1;
                        case "number":
                            if (h(t1)) return !1;
                    }
                    return !0;
                }
                function H(t1, e1, r) {
                    var n = q(r);
                    return null != n ? n : e1.has(n) && !t1.has(n);
                }
                function G(t1, e1, r, n, i) {
                    var a = q(r);
                    if (null != a) return a;
                    var o = e1.get(a);
                    return !(void 0 === o && !e1.has(a) || !N(n, o, !1, i)) && !t1.has(a) && N(n, o, !1, i);
                }
                function Z(t1, e1, r, n, i, a) {
                    for(var o = s(t1), l = 0; l < o.length; l++){
                        var c = o[l];
                        if (N(r, c, i, a) && N(n, e1.get(c), i, a)) return t1.delete(c), !0;
                    }
                    return !1;
                }
                t1.exports = {
                    isDeepEqual: function(t1, e1) {
                        return N(t1, e1, !1);
                    },
                    isDeepStrictEqual: function(t1, e1) {
                        return N(t1, e1, !0);
                    }
                };
            },
            93229: function(t1, e1, r) {
                "use strict";
                r.r(e1), r.d(e1, {
                    decode: function() {
                        return s;
                    },
                    encode: function() {
                        return o;
                    }
                });
                for(var n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", i = "undefined" == typeof Uint8Array ? [] : new Uint8Array(256), a = 0; a < 64; a++)i[n.charCodeAt(a)] = a;
                var o = function(t1) {
                    var e1, r = new Uint8Array(t1), i = r.length, a = "";
                    for(e1 = 0; e1 < i; e1 += 3)a += n[r[e1] >> 2], a += n[(3 & r[e1]) << 4 | r[e1 + 1] >> 4], a += n[(15 & r[e1 + 1]) << 2 | r[e1 + 2] >> 6], a += n[63 & r[e1 + 2]];
                    return i % 3 == 2 ? a = a.substring(0, a.length - 1) + "=" : i % 3 == 1 && (a = a.substring(0, a.length - 2) + "=="), a;
                }, s = function(t1) {
                    var e1, r, n, a, o, s = .75 * t1.length, l = t1.length, c = 0;
                    "=" === t1[t1.length - 1] && (s--, "=" === t1[t1.length - 2] && s--);
                    var u = new ArrayBuffer(s), h = new Uint8Array(u);
                    for(e1 = 0; e1 < l; e1 += 4)r = i[t1.charCodeAt(e1)], n = i[t1.charCodeAt(e1 + 1)], a = i[t1.charCodeAt(e1 + 2)], o = i[t1.charCodeAt(e1 + 3)], h[c++] = r << 2 | n >> 4, h[c++] = (15 & n) << 4 | a >> 2, h[c++] = (3 & a) << 6 | 63 & o;
                    return u;
                };
            },
            76226: function(t1, e1) {
                "use strict";
                e1.byteLength = function(t1) {
                    var e1 = s(t1), r = e1[0], n = e1[1];
                    return 3 * (r + n) / 4 - n;
                }, e1.toByteArray = function(t1) {
                    var e1, r, a = s(t1), o = a[0], l = a[1], c = new i(function(t1, e1, r) {
                        return 3 * (e1 + r) / 4 - r;
                    }(0, o, l)), u = 0, h = l > 0 ? o - 4 : o;
                    for(r = 0; r < h; r += 4)e1 = n[t1.charCodeAt(r)] << 18 | n[t1.charCodeAt(r + 1)] << 12 | n[t1.charCodeAt(r + 2)] << 6 | n[t1.charCodeAt(r + 3)], c[u++] = e1 >> 16 & 255, c[u++] = e1 >> 8 & 255, c[u++] = 255 & e1;
                    return 2 === l && (e1 = n[t1.charCodeAt(r)] << 2 | n[t1.charCodeAt(r + 1)] >> 4, c[u++] = 255 & e1), 1 === l && (e1 = n[t1.charCodeAt(r)] << 10 | n[t1.charCodeAt(r + 1)] << 4 | n[t1.charCodeAt(r + 2)] >> 2, c[u++] = e1 >> 8 & 255, c[u++] = 255 & e1), c;
                }, e1.fromByteArray = function(t1) {
                    for(var e1, n = t1.length, i = n % 3, a = [], o = 16383, s = 0, c = n - i; s < c; s += o)a.push(l(t1, s, s + o > c ? c : s + o));
                    return 1 === i ? (e1 = t1[n - 1], a.push(r[e1 >> 2] + r[e1 << 4 & 63] + "==")) : 2 === i && (e1 = (t1[n - 2] << 8) + t1[n - 1], a.push(r[e1 >> 10] + r[e1 >> 4 & 63] + r[e1 << 2 & 63] + "=")), a.join("");
                };
                for(var r = [], n = [], i = "undefined" != typeof Uint8Array ? Uint8Array : Array, a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", o = 0; o < 64; ++o)r[o] = a[o], n[a.charCodeAt(o)] = o;
                function s(t1) {
                    var e1 = t1.length;
                    if (e1 % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
                    var r = t1.indexOf("=");
                    return -1 === r && (r = e1), [
                        r,
                        r === e1 ? 0 : 4 - r % 4
                    ];
                }
                function l(t1, e1, n) {
                    for(var i, a, o = [], s = e1; s < n; s += 3)i = (t1[s] << 16 & 16711680) + (t1[s + 1] << 8 & 65280) + (255 & t1[s + 2]), o.push(r[(a = i) >> 18 & 63] + r[a >> 12 & 63] + r[a >> 6 & 63] + r[63 & a]);
                    return o.join("");
                }
                n["-".charCodeAt(0)] = 62, n["_".charCodeAt(0)] = 63;
            },
            31625: function(t1) {
                "use strict";
                function e1(t1, e1, r, n, i) {
                    for(var a = i + 1; n <= i;){
                        var o = n + i >>> 1, s = t1[o];
                        (void 0 !== r ? r(s, e1) : s - e1) >= 0 ? (a = o, i = o - 1) : n = o + 1;
                    }
                    return a;
                }
                function r(t1, e1, r, n, i) {
                    for(var a = i + 1; n <= i;){
                        var o = n + i >>> 1, s = t1[o];
                        (void 0 !== r ? r(s, e1) : s - e1) > 0 ? (a = o, i = o - 1) : n = o + 1;
                    }
                    return a;
                }
                function n(t1, e1, r, n, i) {
                    for(var a = n - 1; n <= i;){
                        var o = n + i >>> 1, s = t1[o];
                        (void 0 !== r ? r(s, e1) : s - e1) < 0 ? (a = o, n = o + 1) : i = o - 1;
                    }
                    return a;
                }
                function i(t1, e1, r, n, i) {
                    for(var a = n - 1; n <= i;){
                        var o = n + i >>> 1, s = t1[o];
                        (void 0 !== r ? r(s, e1) : s - e1) <= 0 ? (a = o, n = o + 1) : i = o - 1;
                    }
                    return a;
                }
                function a(t1, e1, r, n, i) {
                    for(; n <= i;){
                        var a = n + i >>> 1, o = t1[a], s = void 0 !== r ? r(o, e1) : o - e1;
                        if (0 === s) return a;
                        s <= 0 ? n = a + 1 : i = a - 1;
                    }
                    return -1;
                }
                function o(t1, e1, r, n, i, a) {
                    return "function" == typeof r ? a(t1, e1, r, void 0 === n ? 0 : 0 | n, void 0 === i ? t1.length - 1 : 0 | i) : a(t1, e1, void 0, void 0 === r ? 0 : 0 | r, void 0 === n ? t1.length - 1 : 0 | n);
                }
                t1.exports = {
                    ge: function(t1, r, n, i, a) {
                        return o(t1, r, n, i, a, e1);
                    },
                    gt: function(t1, e1, n, i, a) {
                        return o(t1, e1, n, i, a, r);
                    },
                    lt: function(t1, e1, r, i, a) {
                        return o(t1, e1, r, i, a, n);
                    },
                    le: function(t1, e1, r, n, a) {
                        return o(t1, e1, r, n, a, i);
                    },
                    eq: function(t1, e1, r, n, i) {
                        return o(t1, e1, r, n, i, a);
                    }
                };
            },
            54689: function(t1, e1) {
                "use strict";
                function r(t1) {
                    var e1 = 32;
                    return (t1 &= -t1) && e1--, 65535 & t1 && (e1 -= 16), 16711935 & t1 && (e1 -= 8), 252645135 & t1 && (e1 -= 4), 858993459 & t1 && (e1 -= 2), 1431655765 & t1 && (e1 -= 1), e1;
                }
                e1.INT_BITS = 32, e1.INT_MAX = 2147483647, e1.INT_MIN = -2147483648, e1.sign = function(t1) {
                    return (t1 > 0) - (t1 < 0);
                }, e1.abs = function(t1) {
                    var e1 = t1 >> 31;
                    return (t1 ^ e1) - e1;
                }, e1.min = function(t1, e1) {
                    return e1 ^ (t1 ^ e1) & -(t1 < e1);
                }, e1.max = function(t1, e1) {
                    return t1 ^ (t1 ^ e1) & -(t1 < e1);
                }, e1.isPow2 = function(t1) {
                    return !(t1 & t1 - 1 || !t1);
                }, e1.log2 = function(t1) {
                    var e1, r;
                    return e1 = (t1 > 65535) << 4, e1 |= r = ((t1 >>>= e1) > 255) << 3, e1 |= r = ((t1 >>>= r) > 15) << 2, (e1 |= r = ((t1 >>>= r) > 3) << 1) | (t1 >>>= r) >> 1;
                }, e1.log10 = function(t1) {
                    return t1 >= 1e9 ? 9 : t1 >= 1e8 ? 8 : t1 >= 1e7 ? 7 : t1 >= 1e6 ? 6 : t1 >= 1e5 ? 5 : t1 >= 1e4 ? 4 : t1 >= 1e3 ? 3 : t1 >= 100 ? 2 : t1 >= 10 ? 1 : 0;
                }, e1.popCount = function(t1) {
                    return 16843009 * ((t1 = (858993459 & (t1 -= t1 >>> 1 & 1431655765)) + (t1 >>> 2 & 858993459)) + (t1 >>> 4) & 252645135) >>> 24;
                }, e1.countTrailingZeros = r, e1.nextPow2 = function(t1) {
                    return t1 += 0 === t1, --t1, t1 |= t1 >>> 1, t1 |= t1 >>> 2, t1 |= t1 >>> 4, t1 |= t1 >>> 8, 1 + (t1 |= t1 >>> 16);
                }, e1.prevPow2 = function(t1) {
                    return t1 |= t1 >>> 1, t1 |= t1 >>> 2, t1 |= t1 >>> 4, t1 |= t1 >>> 8, (t1 |= t1 >>> 16) - (t1 >>> 1);
                }, e1.parity = function(t1) {
                    return t1 ^= t1 >>> 16, t1 ^= t1 >>> 8, t1 ^= t1 >>> 4, 27030 >>> (t1 &= 15) & 1;
                };
                var n = new Array(256);
                !function(t1) {
                    for(var e1 = 0; e1 < 256; ++e1){
                        var r = e1, n = e1, i = 7;
                        for(r >>>= 1; r; r >>>= 1)n <<= 1, n |= 1 & r, --i;
                        t1[e1] = n << i & 255;
                    }
                }(n), e1.reverse = function(t1) {
                    return n[255 & t1] << 24 | n[t1 >>> 8 & 255] << 16 | n[t1 >>> 16 & 255] << 8 | n[t1 >>> 24 & 255];
                }, e1.interleave2 = function(t1, e1) {
                    return (t1 = 1431655765 & ((t1 = 858993459 & ((t1 = 252645135 & ((t1 = 16711935 & ((t1 &= 65535) | t1 << 8)) | t1 << 4)) | t1 << 2)) | t1 << 1)) | (e1 = 1431655765 & ((e1 = 858993459 & ((e1 = 252645135 & ((e1 = 16711935 & ((e1 &= 65535) | e1 << 8)) | e1 << 4)) | e1 << 2)) | e1 << 1)) << 1;
                }, e1.deinterleave2 = function(t1, e1) {
                    return (t1 = 65535 & ((t1 = 16711935 & ((t1 = 252645135 & ((t1 = 858993459 & ((t1 = t1 >>> e1 & 1431655765) | t1 >>> 1)) | t1 >>> 2)) | t1 >>> 4)) | t1 >>> 16)) << 16 >> 16;
                }, e1.interleave3 = function(t1, e1, r) {
                    return t1 = 1227133513 & ((t1 = 3272356035 & ((t1 = 251719695 & ((t1 = 4278190335 & ((t1 &= 1023) | t1 << 16)) | t1 << 8)) | t1 << 4)) | t1 << 2), (t1 |= (e1 = 1227133513 & ((e1 = 3272356035 & ((e1 = 251719695 & ((e1 = 4278190335 & ((e1 &= 1023) | e1 << 16)) | e1 << 8)) | e1 << 4)) | e1 << 2)) << 1) | (r = 1227133513 & ((r = 3272356035 & ((r = 251719695 & ((r = 4278190335 & ((r &= 1023) | r << 16)) | r << 8)) | r << 4)) | r << 2)) << 2;
                }, e1.deinterleave3 = function(t1, e1) {
                    return (t1 = 1023 & ((t1 = 4278190335 & ((t1 = 251719695 & ((t1 = 3272356035 & ((t1 = t1 >>> e1 & 1227133513) | t1 >>> 2)) | t1 >>> 4)) | t1 >>> 8)) | t1 >>> 16)) << 22 >> 22;
                }, e1.nextCombination = function(t1) {
                    var e1 = t1 | t1 - 1;
                    return e1 + 1 | (~e1 & -~e1) - 1 >>> r(t1) + 1;
                };
            },
            88772: function(t1, e1, r) {
                "use strict";
                var n = r(75144);
                t1.exports = function(t1, e1) {
                    e1 || (e1 = {});
                    var r, o, s, l, c, u, h, f, p, d, m, g = null == e1.cutoff ? .25 : e1.cutoff, y = null == e1.radius ? 8 : e1.radius, v = e1.channel || 0;
                    if (ArrayBuffer.isView(t1) || Array.isArray(t1)) {
                        if (!e1.width || !e1.height) throw Error("For raw data width and height should be provided by options");
                        r = e1.width, o = e1.height, l = t1, u = e1.stride ? e1.stride : Math.floor(t1.length / r / o);
                    } else window.HTMLCanvasElement && t1 instanceof window.HTMLCanvasElement ? (h = (f = t1).getContext("2d"), r = f.width, o = f.height, l = (p = h.getImageData(0, 0, r, o)).data, u = 4) : window.CanvasRenderingContext2D && t1 instanceof window.CanvasRenderingContext2D ? (h = t1, r = (f = t1.canvas).width, o = f.height, l = (p = h.getImageData(0, 0, r, o)).data, u = 4) : window.ImageData && t1 instanceof window.ImageData && (p = t1, r = t1.width, o = t1.height, l = p.data, u = 4);
                    if (s = Math.max(r, o), window.Uint8ClampedArray && l instanceof window.Uint8ClampedArray || window.Uint8Array && l instanceof window.Uint8Array) for(c = l, l = Array(r * o), d = 0, m = c.length; d < m; d++)l[d] = c[d * u + v] / 255;
                    else if (1 !== u) throw Error("Raw data can have only 1 value per pixel");
                    var x = Array(r * o), _ = Array(r * o), b = Array(s), w = Array(s), T = Array(s + 1), k = Array(s);
                    for(d = 0, m = r * o; d < m; d++){
                        var A = l[d];
                        x[d] = 1 === A ? 0 : 0 === A ? i : Math.pow(Math.max(0, .5 - A), 2), _[d] = 1 === A ? i : 0 === A ? 0 : Math.pow(Math.max(0, A - .5), 2);
                    }
                    a(x, r, o, b, w, k, T), a(_, r, o, b, w, k, T);
                    var M = window.Float32Array ? new Float32Array(r * o) : new Array(r * o);
                    for(d = 0, m = r * o; d < m; d++)M[d] = n(1 - ((x[d] - _[d]) / y + g), 0, 1);
                    return M;
                };
                var i = 1e20;
                function a(t1, e1, r, n, i, a, s) {
                    for(var l = 0; l < e1; l++){
                        for(var c = 0; c < r; c++)n[c] = t1[c * e1 + l];
                        for(o(n, i, a, s, r), c = 0; c < r; c++)t1[c * e1 + l] = i[c];
                    }
                    for(c = 0; c < r; c++){
                        for(l = 0; l < e1; l++)n[l] = t1[c * e1 + l];
                        for(o(n, i, a, s, e1), l = 0; l < e1; l++)t1[c * e1 + l] = Math.sqrt(i[l]);
                    }
                }
                function o(t1, e1, r, n, a) {
                    r[0] = 0, n[0] = -i, n[1] = +i;
                    for(var o = 1, s = 0; o < a; o++){
                        for(var l = (t1[o] + o * o - (t1[r[s]] + r[s] * r[s])) / (2 * o - 2 * r[s]); l <= n[s];)s--, l = (t1[o] + o * o - (t1[r[s]] + r[s] * r[s])) / (2 * o - 2 * r[s]);
                        r[++s] = o, n[s] = l, n[s + 1] = +i;
                    }
                    for(o = 0, s = 0; o < a; o++){
                        for(; n[s + 1] < o;)s++;
                        e1[o] = (o - r[s]) * (o - r[s]) + t1[r[s]];
                    }
                }
            },
            63063: function(t1, e1, r) {
                "use strict";
                var n = r(71129), i = r(87227), a = i(n("String.prototype.indexOf"));
                t1.exports = function(t1, e1) {
                    var r = n(t1, !!e1);
                    return "function" == typeof r && a(t1, ".prototype.") > -1 ? i(r) : r;
                };
            },
            87227: function(t1, e1, r) {
                "use strict";
                var n = r(87547), i = r(71129), a = r(73285), o = r(48631), s = i("%Function.prototype.apply%"), l = i("%Function.prototype.call%"), c = i("%Reflect.apply%", !0) || n.call(l, s), u = r(40891), h = i("%Math.max%");
                t1.exports = function(t1) {
                    if ("function" != typeof t1) throw new o("a function is required");
                    var e1 = c(n, l, arguments);
                    return a(e1, 1 + h(0, t1.length - (arguments.length - 1)), !0);
                };
                var f = function() {
                    return c(n, s, arguments);
                };
                u ? u(t1.exports, "apply", {
                    value: f
                }) : t1.exports.apply = f;
            },
            75144: function(t1) {
                t1.exports = function(t1, e1, r) {
                    return e1 < r ? t1 < e1 ? e1 : t1 > r ? r : t1 : t1 < r ? r : t1 > e1 ? e1 : t1;
                };
            },
            46762: function(t1, e1, r) {
                "use strict";
                var n = r(75144);
                function i(t1, e1) {
                    null == e1 && (e1 = !0);
                    var r = t1[0], i = t1[1], a = t1[2], o = t1[3];
                    return null == o && (o = e1 ? 1 : 255), e1 && (r *= 255, i *= 255, a *= 255, o *= 255), 16777216 * (r = 255 & n(r, 0, 255)) + ((i = 255 & n(i, 0, 255)) << 16) + ((a = 255 & n(a, 0, 255)) << 8) + (255 & n(o, 0, 255));
                }
                t1.exports = i, t1.exports.to = i, t1.exports.from = function(t1, e1) {
                    var r = (t1 = +t1) >>> 24, n = (16711680 & t1) >>> 16, i = (65280 & t1) >>> 8, a = 255 & t1;
                    return !1 === e1 ? [
                        r,
                        n,
                        i,
                        a
                    ] : [
                        r / 255,
                        n / 255,
                        i / 255,
                        a / 255
                    ];
                };
            },
            86040: function(t1) {
                "use strict";
                t1.exports = {
                    aliceblue: [
                        240,
                        248,
                        255
                    ],
                    antiquewhite: [
                        250,
                        235,
                        215
                    ],
                    aqua: [
                        0,
                        255,
                        255
                    ],
                    aquamarine: [
                        127,
                        255,
                        212
                    ],
                    azure: [
                        240,
                        255,
                        255
                    ],
                    beige: [
                        245,
                        245,
                        220
                    ],
                    bisque: [
                        255,
                        228,
                        196
                    ],
                    black: [
                        0,
                        0,
                        0
                    ],
                    blanchedalmond: [
                        255,
                        235,
                        205
                    ],
                    blue: [
                        0,
                        0,
                        255
                    ],
                    blueviolet: [
                        138,
                        43,
                        226
                    ],
                    brown: [
                        165,
                        42,
                        42
                    ],
                    burlywood: [
                        222,
                        184,
                        135
                    ],
                    cadetblue: [
                        95,
                        158,
                        160
                    ],
                    chartreuse: [
                        127,
                        255,
                        0
                    ],
                    chocolate: [
                        210,
                        105,
                        30
                    ],
                    coral: [
                        255,
                        127,
                        80
                    ],
                    cornflowerblue: [
                        100,
                        149,
                        237
                    ],
                    cornsilk: [
                        255,
                        248,
                        220
                    ],
                    crimson: [
                        220,
                        20,
                        60
                    ],
                    cyan: [
                        0,
                        255,
                        255
                    ],
                    darkblue: [
                        0,
                        0,
                        139
                    ],
                    darkcyan: [
                        0,
                        139,
                        139
                    ],
                    darkgoldenrod: [
                        184,
                        134,
                        11
                    ],
                    darkgray: [
                        169,
                        169,
                        169
                    ],
                    darkgreen: [
                        0,
                        100,
                        0
                    ],
                    darkgrey: [
                        169,
                        169,
                        169
                    ],
                    darkkhaki: [
                        189,
                        183,
                        107
                    ],
                    darkmagenta: [
                        139,
                        0,
                        139
                    ],
                    darkolivegreen: [
                        85,
                        107,
                        47
                    ],
                    darkorange: [
                        255,
                        140,
                        0
                    ],
                    darkorchid: [
                        153,
                        50,
                        204
                    ],
                    darkred: [
                        139,
                        0,
                        0
                    ],
                    darksalmon: [
                        233,
                        150,
                        122
                    ],
                    darkseagreen: [
                        143,
                        188,
                        143
                    ],
                    darkslateblue: [
                        72,
                        61,
                        139
                    ],
                    darkslategray: [
                        47,
                        79,
                        79
                    ],
                    darkslategrey: [
                        47,
                        79,
                        79
                    ],
                    darkturquoise: [
                        0,
                        206,
                        209
                    ],
                    darkviolet: [
                        148,
                        0,
                        211
                    ],
                    deeppink: [
                        255,
                        20,
                        147
                    ],
                    deepskyblue: [
                        0,
                        191,
                        255
                    ],
                    dimgray: [
                        105,
                        105,
                        105
                    ],
                    dimgrey: [
                        105,
                        105,
                        105
                    ],
                    dodgerblue: [
                        30,
                        144,
                        255
                    ],
                    firebrick: [
                        178,
                        34,
                        34
                    ],
                    floralwhite: [
                        255,
                        250,
                        240
                    ],
                    forestgreen: [
                        34,
                        139,
                        34
                    ],
                    fuchsia: [
                        255,
                        0,
                        255
                    ],
                    gainsboro: [
                        220,
                        220,
                        220
                    ],
                    ghostwhite: [
                        248,
                        248,
                        255
                    ],
                    gold: [
                        255,
                        215,
                        0
                    ],
                    goldenrod: [
                        218,
                        165,
                        32
                    ],
                    gray: [
                        128,
                        128,
                        128
                    ],
                    green: [
                        0,
                        128,
                        0
                    ],
                    greenyellow: [
                        173,
                        255,
                        47
                    ],
                    grey: [
                        128,
                        128,
                        128
                    ],
                    honeydew: [
                        240,
                        255,
                        240
                    ],
                    hotpink: [
                        255,
                        105,
                        180
                    ],
                    indianred: [
                        205,
                        92,
                        92
                    ],
                    indigo: [
                        75,
                        0,
                        130
                    ],
                    ivory: [
                        255,
                        255,
                        240
                    ],
                    khaki: [
                        240,
                        230,
                        140
                    ],
                    lavender: [
                        230,
                        230,
                        250
                    ],
                    lavenderblush: [
                        255,
                        240,
                        245
                    ],
                    lawngreen: [
                        124,
                        252,
                        0
                    ],
                    lemonchiffon: [
                        255,
                        250,
                        205
                    ],
                    lightblue: [
                        173,
                        216,
                        230
                    ],
                    lightcoral: [
                        240,
                        128,
                        128
                    ],
                    lightcyan: [
                        224,
                        255,
                        255
                    ],
                    lightgoldenrodyellow: [
                        250,
                        250,
                        210
                    ],
                    lightgray: [
                        211,
                        211,
                        211
                    ],
                    lightgreen: [
                        144,
                        238,
                        144
                    ],
                    lightgrey: [
                        211,
                        211,
                        211
                    ],
                    lightpink: [
                        255,
                        182,
                        193
                    ],
                    lightsalmon: [
                        255,
                        160,
                        122
                    ],
                    lightseagreen: [
                        32,
                        178,
                        170
                    ],
                    lightskyblue: [
                        135,
                        206,
                        250
                    ],
                    lightslategray: [
                        119,
                        136,
                        153
                    ],
                    lightslategrey: [
                        119,
                        136,
                        153
                    ],
                    lightsteelblue: [
                        176,
                        196,
                        222
                    ],
                    lightyellow: [
                        255,
                        255,
                        224
                    ],
                    lime: [
                        0,
                        255,
                        0
                    ],
                    limegreen: [
                        50,
                        205,
                        50
                    ],
                    linen: [
                        250,
                        240,
                        230
                    ],
                    magenta: [
                        255,
                        0,
                        255
                    ],
                    maroon: [
                        128,
                        0,
                        0
                    ],
                    mediumaquamarine: [
                        102,
                        205,
                        170
                    ],
                    mediumblue: [
                        0,
                        0,
                        205
                    ],
                    mediumorchid: [
                        186,
                        85,
                        211
                    ],
                    mediumpurple: [
                        147,
                        112,
                        219
                    ],
                    mediumseagreen: [
                        60,
                        179,
                        113
                    ],
                    mediumslateblue: [
                        123,
                        104,
                        238
                    ],
                    mediumspringgreen: [
                        0,
                        250,
                        154
                    ],
                    mediumturquoise: [
                        72,
                        209,
                        204
                    ],
                    mediumvioletred: [
                        199,
                        21,
                        133
                    ],
                    midnightblue: [
                        25,
                        25,
                        112
                    ],
                    mintcream: [
                        245,
                        255,
                        250
                    ],
                    mistyrose: [
                        255,
                        228,
                        225
                    ],
                    moccasin: [
                        255,
                        228,
                        181
                    ],
                    navajowhite: [
                        255,
                        222,
                        173
                    ],
                    navy: [
                        0,
                        0,
                        128
                    ],
                    oldlace: [
                        253,
                        245,
                        230
                    ],
                    olive: [
                        128,
                        128,
                        0
                    ],
                    olivedrab: [
                        107,
                        142,
                        35
                    ],
                    orange: [
                        255,
                        165,
                        0
                    ],
                    orangered: [
                        255,
                        69,
                        0
                    ],
                    orchid: [
                        218,
                        112,
                        214
                    ],
                    palegoldenrod: [
                        238,
                        232,
                        170
                    ],
                    palegreen: [
                        152,
                        251,
                        152
                    ],
                    paleturquoise: [
                        175,
                        238,
                        238
                    ],
                    palevioletred: [
                        219,
                        112,
                        147
                    ],
                    papayawhip: [
                        255,
                        239,
                        213
                    ],
                    peachpuff: [
                        255,
                        218,
                        185
                    ],
                    peru: [
                        205,
                        133,
                        63
                    ],
                    pink: [
                        255,
                        192,
                        203
                    ],
                    plum: [
                        221,
                        160,
                        221
                    ],
                    powderblue: [
                        176,
                        224,
                        230
                    ],
                    purple: [
                        128,
                        0,
                        128
                    ],
                    rebeccapurple: [
                        102,
                        51,
                        153
                    ],
                    red: [
                        255,
                        0,
                        0
                    ],
                    rosybrown: [
                        188,
                        143,
                        143
                    ],
                    royalblue: [
                        65,
                        105,
                        225
                    ],
                    saddlebrown: [
                        139,
                        69,
                        19
                    ],
                    salmon: [
                        250,
                        128,
                        114
                    ],
                    sandybrown: [
                        244,
                        164,
                        96
                    ],
                    seagreen: [
                        46,
                        139,
                        87
                    ],
                    seashell: [
                        255,
                        245,
                        238
                    ],
                    sienna: [
                        160,
                        82,
                        45
                    ],
                    silver: [
                        192,
                        192,
                        192
                    ],
                    skyblue: [
                        135,
                        206,
                        235
                    ],
                    slateblue: [
                        106,
                        90,
                        205
                    ],
                    slategray: [
                        112,
                        128,
                        144
                    ],
                    slategrey: [
                        112,
                        128,
                        144
                    ],
                    snow: [
                        255,
                        250,
                        250
                    ],
                    springgreen: [
                        0,
                        255,
                        127
                    ],
                    steelblue: [
                        70,
                        130,
                        180
                    ],
                    tan: [
                        210,
                        180,
                        140
                    ],
                    teal: [
                        0,
                        128,
                        128
                    ],
                    thistle: [
                        216,
                        191,
                        216
                    ],
                    tomato: [
                        255,
                        99,
                        71
                    ],
                    turquoise: [
                        64,
                        224,
                        208
                    ],
                    violet: [
                        238,
                        130,
                        238
                    ],
                    wheat: [
                        245,
                        222,
                        179
                    ],
                    white: [
                        255,
                        255,
                        255
                    ],
                    whitesmoke: [
                        245,
                        245,
                        245
                    ],
                    yellow: [
                        255,
                        255,
                        0
                    ],
                    yellowgreen: [
                        154,
                        205,
                        50
                    ]
                };
            },
            162: function(t1, e1, r) {
                "use strict";
                var n = r(16401), i = r(75144), a = r(10275);
                t1.exports = function(t1, e1) {
                    "float" !== e1 && e1 || (e1 = "array"), "uint" === e1 && (e1 = "uint8"), "uint_clamped" === e1 && (e1 = "uint8_clamped");
                    var r = new (a(e1))(4), o = "uint8" !== e1 && "uint8_clamped" !== e1;
                    return t1.length && "string" != typeof t1 || ((t1 = n(t1))[0] /= 255, t1[1] /= 255, t1[2] /= 255), function(t1) {
                        return t1 instanceof Uint8Array || t1 instanceof Uint8ClampedArray || !!(Array.isArray(t1) && (t1[0] > 1 || 0 === t1[0]) && (t1[1] > 1 || 0 === t1[1]) && (t1[2] > 1 || 0 === t1[2]) && (!t1[3] || t1[3] > 1));
                    }(t1) ? (r[0] = t1[0], r[1] = t1[1], r[2] = t1[2], r[3] = null != t1[3] ? t1[3] : 255, o && (r[0] /= 255, r[1] /= 255, r[2] /= 255, r[3] /= 255), r) : (o ? (r[0] = t1[0], r[1] = t1[1], r[2] = t1[2], r[3] = null != t1[3] ? t1[3] : 1) : (r[0] = i(Math.floor(255 * t1[0]), 0, 255), r[1] = i(Math.floor(255 * t1[1]), 0, 255), r[2] = i(Math.floor(255 * t1[2]), 0, 255), r[3] = null == t1[3] ? 255 : i(Math.floor(255 * t1[3]), 0, 255)), r);
                };
            },
            16401: function(t1, e1, r) {
                "use strict";
                var n = r(10826), i = r(52132), a = r(75144);
                t1.exports = function(t1) {
                    var e1, r = n(t1);
                    return r.space ? ((e1 = Array(3))[0] = a(r.values[0], 0, 255), e1[1] = a(r.values[1], 0, 255), e1[2] = a(r.values[2], 0, 255), "h" === r.space[0] && (e1 = i.rgb(e1)), e1.push(a(r.alpha, 0, 1)), e1) : [];
                };
            },
            10826: function(t1, e1, r) {
                "use strict";
                var n = r(86040);
                t1.exports = function(t1) {
                    var e1, r, a = [], o = 1;
                    if ("string" == typeof t1) {
                        if (t1 = t1.toLowerCase(), n[t1]) a = n[t1].slice(), r = "rgb";
                        else if ("transparent" === t1) o = 0, r = "rgb", a = [
                            0,
                            0,
                            0
                        ];
                        else if (/^#[A-Fa-f0-9]+$/.test(t1)) {
                            var s = t1.slice(1);
                            o = 1, (u = s.length) <= 4 ? (a = [
                                parseInt(s[0] + s[0], 16),
                                parseInt(s[1] + s[1], 16),
                                parseInt(s[2] + s[2], 16)
                            ], 4 === u && (o = parseInt(s[3] + s[3], 16) / 255)) : (a = [
                                parseInt(s[0] + s[1], 16),
                                parseInt(s[2] + s[3], 16),
                                parseInt(s[4] + s[5], 16)
                            ], 8 === u && (o = parseInt(s[6] + s[7], 16) / 255)), a[0] || (a[0] = 0), a[1] || (a[1] = 0), a[2] || (a[2] = 0), r = "rgb";
                        } else if (e1 = /^((?:rgb|hs[lvb]|hwb|cmyk?|xy[zy]|gray|lab|lchu?v?|[ly]uv|lms)a?)\s*\(([^\)]*)\)/.exec(t1)) {
                            var l = e1[1], c = "rgb" === l;
                            r = s = l.replace(/a$/, "");
                            var u = "cmyk" === s ? 4 : "gray" === s ? 1 : 3;
                            a = e1[2].trim().split(/\s*[,\/]\s*|\s+/).map(function(t1, e1) {
                                if (/%$/.test(t1)) return e1 === u ? parseFloat(t1) / 100 : "rgb" === s ? 255 * parseFloat(t1) / 100 : parseFloat(t1);
                                if ("h" === s[e1]) {
                                    if (/deg$/.test(t1)) return parseFloat(t1);
                                    if (void 0 !== i[t1]) return i[t1];
                                }
                                return parseFloat(t1);
                            }), l === s && a.push(1), o = c || void 0 === a[u] ? 1 : a[u], a = a.slice(0, u);
                        } else t1.length > 10 && /[0-9](?:\s|\/)/.test(t1) && (a = t1.match(/([0-9]+)/g).map(function(t1) {
                            return parseFloat(t1);
                        }), r = t1.match(/([a-z])/gi).join("").toLowerCase());
                    } else isNaN(t1) ? Array.isArray(t1) || t1.length ? (a = [
                        t1[0],
                        t1[1],
                        t1[2]
                    ], r = "rgb", o = 4 === t1.length ? t1[3] : 1) : t1 instanceof Object && (null != t1.r || null != t1.red || null != t1.R ? (r = "rgb", a = [
                        t1.r || t1.red || t1.R || 0,
                        t1.g || t1.green || t1.G || 0,
                        t1.b || t1.blue || t1.B || 0
                    ]) : (r = "hsl", a = [
                        t1.h || t1.hue || t1.H || 0,
                        t1.s || t1.saturation || t1.S || 0,
                        t1.l || t1.lightness || t1.L || t1.b || t1.brightness
                    ]), o = t1.a || t1.alpha || t1.opacity || 1, null != t1.opacity && (o /= 100)) : (r = "rgb", a = [
                        t1 >>> 16,
                        (65280 & t1) >>> 8,
                        255 & t1
                    ]);
                    return {
                        space: r,
                        values: a,
                        alpha: o
                    };
                };
                var i = {
                    red: 0,
                    orange: 60,
                    yellow: 120,
                    green: 180,
                    blue: 240,
                    purple: 300
                };
            },
            52132: function(t1, e1, r) {
                "use strict";
                var n = r(10520);
                t1.exports = {
                    name: "hsl",
                    min: [
                        0,
                        0,
                        0
                    ],
                    max: [
                        360,
                        100,
                        100
                    ],
                    channel: [
                        "hue",
                        "saturation",
                        "lightness"
                    ],
                    alias: [
                        "HSL"
                    ],
                    rgb: function(t1) {
                        var e1, r, n, i, a, o = t1[0] / 360, s = t1[1] / 100, l = t1[2] / 100;
                        if (0 === s) return [
                            a = 255 * l,
                            a,
                            a
                        ];
                        e1 = 2 * l - (r = l < .5 ? l * (1 + s) : l + s - l * s), i = [
                            0,
                            0,
                            0
                        ];
                        for(var c = 0; c < 3; c++)(n = o + 1 / 3 * -(c - 1)) < 0 ? n++ : n > 1 && n--, a = 6 * n < 1 ? e1 + 6 * (r - e1) * n : 2 * n < 1 ? r : 3 * n < 2 ? e1 + (r - e1) * (2 / 3 - n) * 6 : e1, i[c] = 255 * a;
                        return i;
                    }
                }, n.hsl = function(t1) {
                    var e1, r, n = t1[0] / 255, i = t1[1] / 255, a = t1[2] / 255, o = Math.min(n, i, a), s = Math.max(n, i, a), l = s - o;
                    return s === o ? e1 = 0 : n === s ? e1 = (i - a) / l : i === s ? e1 = 2 + (a - n) / l : a === s && (e1 = 4 + (n - i) / l), (e1 = Math.min(60 * e1, 360)) < 0 && (e1 += 360), r = (o + s) / 2, [
                        e1,
                        100 * (s === o ? 0 : r <= .5 ? l / (s + o) : l / (2 - s - o)),
                        100 * r
                    ];
                };
            },
            10520: function(t1) {
                "use strict";
                t1.exports = {
                    name: "rgb",
                    min: [
                        0,
                        0,
                        0
                    ],
                    max: [
                        255,
                        255,
                        255
                    ],
                    channel: [
                        "red",
                        "green",
                        "blue"
                    ],
                    alias: [
                        "RGB"
                    ]
                };
            },
            78171: function(t1) {
                t1.exports = {
                    AFG: "afghan",
                    ALA: "\\b\\wland",
                    ALB: "albania",
                    DZA: "algeria",
                    ASM: "^(?=.*americ).*samoa",
                    AND: "andorra",
                    AGO: "angola",
                    AIA: "anguill?a",
                    ATA: "antarctica",
                    ATG: "antigua",
                    ARG: "argentin",
                    ARM: "armenia",
                    ABW: "^(?!.*bonaire).*\\baruba",
                    AUS: "australia",
                    AUT: "^(?!.*hungary).*austria|\\baustri.*\\bemp",
                    AZE: "azerbaijan",
                    BHS: "bahamas",
                    BHR: "bahrain",
                    BGD: "bangladesh|^(?=.*east).*paki?stan",
                    BRB: "barbados",
                    BLR: "belarus|byelo",
                    BEL: "^(?!.*luxem).*belgium",
                    BLZ: "belize|^(?=.*british).*honduras",
                    BEN: "benin|dahome",
                    BMU: "bermuda",
                    BTN: "bhutan",
                    BOL: "bolivia",
                    BES: "^(?=.*bonaire).*eustatius|^(?=.*carib).*netherlands|\\bbes.?islands",
                    BIH: "herzegovina|bosnia",
                    BWA: "botswana|bechuana",
                    BVT: "bouvet",
                    BRA: "brazil",
                    IOT: "british.?indian.?ocean",
                    BRN: "brunei",
                    BGR: "bulgaria",
                    BFA: "burkina|\\bfaso|upper.?volta",
                    BDI: "burundi",
                    CPV: "verde",
                    KHM: "cambodia|kampuchea|khmer",
                    CMR: "cameroon",
                    CAN: "canada",
                    CYM: "cayman",
                    CAF: "\\bcentral.african.republic",
                    TCD: "\\bchad",
                    CHL: "\\bchile",
                    CHN: "^(?!.*\\bmac)(?!.*\\bhong)(?!.*\\btai)(?!.*\\brep).*china|^(?=.*peo)(?=.*rep).*china",
                    CXR: "christmas",
                    CCK: "\\bcocos|keeling",
                    COL: "colombia",
                    COM: "comoro",
                    COG: "^(?!.*\\bdem)(?!.*\\bd[\\.]?r)(?!.*kinshasa)(?!.*zaire)(?!.*belg)(?!.*l.opoldville)(?!.*free).*\\bcongo",
                    COK: "\\bcook",
                    CRI: "costa.?rica",
                    CIV: "ivoire|ivory",
                    HRV: "croatia",
                    CUB: "\\bcuba",
                    CUW: "^(?!.*bonaire).*\\bcura(c|\xe7)ao",
                    CYP: "cyprus",
                    CSK: "czechoslovakia",
                    CZE: "^(?=.*rep).*czech|czechia|bohemia",
                    COD: "\\bdem.*congo|congo.*\\bdem|congo.*\\bd[\\.]?r|\\bd[\\.]?r.*congo|belgian.?congo|congo.?free.?state|kinshasa|zaire|l.opoldville|drc|droc|rdc",
                    DNK: "denmark",
                    DJI: "djibouti",
                    DMA: "dominica(?!n)",
                    DOM: "dominican.rep",
                    ECU: "ecuador",
                    EGY: "egypt",
                    SLV: "el.?salvador",
                    GNQ: "guine.*eq|eq.*guine|^(?=.*span).*guinea",
                    ERI: "eritrea",
                    EST: "estonia",
                    ETH: "ethiopia|abyssinia",
                    FLK: "falkland|malvinas",
                    FRO: "faroe|faeroe",
                    FJI: "fiji",
                    FIN: "finland",
                    FRA: "^(?!.*\\bdep)(?!.*martinique).*france|french.?republic|\\bgaul",
                    GUF: "^(?=.*french).*guiana",
                    PYF: "french.?polynesia|tahiti",
                    ATF: "french.?southern",
                    GAB: "gabon",
                    GMB: "gambia",
                    GEO: "^(?!.*south).*georgia",
                    DDR: "german.?democratic.?republic|democratic.?republic.*germany|east.germany",
                    DEU: "^(?!.*east).*germany|^(?=.*\\bfed.*\\brep).*german",
                    GHA: "ghana|gold.?coast",
                    GIB: "gibraltar",
                    GRC: "greece|hellenic|hellas",
                    GRL: "greenland",
                    GRD: "grenada",
                    GLP: "guadeloupe",
                    GUM: "\\bguam",
                    GTM: "guatemala",
                    GGY: "guernsey",
                    GIN: "^(?!.*eq)(?!.*span)(?!.*bissau)(?!.*portu)(?!.*new).*guinea",
                    GNB: "bissau|^(?=.*portu).*guinea",
                    GUY: "guyana|british.?guiana",
                    HTI: "haiti",
                    HMD: "heard.*mcdonald",
                    VAT: "holy.?see|vatican|papal.?st",
                    HND: "^(?!.*brit).*honduras",
                    HKG: "hong.?kong",
                    HUN: "^(?!.*austr).*hungary",
                    ISL: "iceland",
                    IND: "india(?!.*ocea)",
                    IDN: "indonesia",
                    IRN: "\\biran|persia",
                    IRQ: "\\biraq|mesopotamia",
                    IRL: "(^ireland)|(^republic.*ireland)",
                    IMN: "^(?=.*isle).*\\bman",
                    ISR: "israel",
                    ITA: "italy",
                    JAM: "jamaica",
                    JPN: "japan",
                    JEY: "jersey",
                    JOR: "jordan",
                    KAZ: "kazak",
                    KEN: "kenya|british.?east.?africa|east.?africa.?prot",
                    KIR: "kiribati",
                    PRK: "^(?=.*democrat|people|north|d.*p.*.r).*\\bkorea|dprk|korea.*(d.*p.*r)",
                    KWT: "kuwait",
                    KGZ: "kyrgyz|kirghiz",
                    LAO: "\\blaos?\\b",
                    LVA: "latvia",
                    LBN: "lebanon",
                    LSO: "lesotho|basuto",
                    LBR: "liberia",
                    LBY: "libya",
                    LIE: "liechtenstein",
                    LTU: "lithuania",
                    LUX: "^(?!.*belg).*luxem",
                    MAC: "maca(o|u)",
                    MDG: "madagascar|malagasy",
                    MWI: "malawi|nyasa",
                    MYS: "malaysia",
                    MDV: "maldive",
                    MLI: "\\bmali\\b",
                    MLT: "\\bmalta",
                    MHL: "marshall",
                    MTQ: "martinique",
                    MRT: "mauritania",
                    MUS: "mauritius",
                    MYT: "\\bmayotte",
                    MEX: "\\bmexic",
                    FSM: "fed.*micronesia|micronesia.*fed",
                    MCO: "monaco",
                    MNG: "mongolia",
                    MNE: "^(?!.*serbia).*montenegro",
                    MSR: "montserrat",
                    MAR: "morocco|\\bmaroc",
                    MOZ: "mozambique",
                    MMR: "myanmar|burma",
                    NAM: "namibia",
                    NRU: "nauru",
                    NPL: "nepal",
                    NLD: "^(?!.*\\bant)(?!.*\\bcarib).*netherlands",
                    ANT: "^(?=.*\\bant).*(nether|dutch)",
                    NCL: "new.?caledonia",
                    NZL: "new.?zealand",
                    NIC: "nicaragua",
                    NER: "\\bniger(?!ia)",
                    NGA: "nigeria",
                    NIU: "niue",
                    NFK: "norfolk",
                    MNP: "mariana",
                    NOR: "norway",
                    OMN: "\\boman|trucial",
                    PAK: "^(?!.*east).*paki?stan",
                    PLW: "palau",
                    PSE: "palestin|\\bgaza|west.?bank",
                    PAN: "panama",
                    PNG: "papua|new.?guinea",
                    PRY: "paraguay",
                    PER: "peru",
                    PHL: "philippines",
                    PCN: "pitcairn",
                    POL: "poland",
                    PRT: "portugal",
                    PRI: "puerto.?rico",
                    QAT: "qatar",
                    KOR: "^(?!.*d.*p.*r)(?!.*democrat)(?!.*people)(?!.*north).*\\bkorea(?!.*d.*p.*r)",
                    MDA: "moldov|b(a|e)ssarabia",
                    REU: "r(e|\xe9)union",
                    ROU: "r(o|u|ou)mania",
                    RUS: "\\brussia|soviet.?union|u\\.?s\\.?s\\.?r|socialist.?republics",
                    RWA: "rwanda",
                    BLM: "barth(e|\xe9)lemy",
                    SHN: "helena",
                    KNA: "kitts|\\bnevis",
                    LCA: "\\blucia",
                    MAF: "^(?=.*collectivity).*martin|^(?=.*france).*martin(?!ique)|^(?=.*french).*martin(?!ique)",
                    SPM: "miquelon",
                    VCT: "vincent",
                    WSM: "^(?!.*amer).*samoa",
                    SMR: "san.?marino",
                    STP: "\\bs(a|\xe3)o.?tom(e|\xe9)",
                    SAU: "\\bsa\\w*.?arabia",
                    SEN: "senegal",
                    SRB: "^(?!.*monte).*serbia",
                    SYC: "seychell",
                    SLE: "sierra",
                    SGP: "singapore",
                    SXM: "^(?!.*martin)(?!.*saba).*maarten",
                    SVK: "^(?!.*cze).*slovak",
                    SVN: "slovenia",
                    SLB: "solomon",
                    SOM: "somali",
                    ZAF: "south.africa|s\\\\..?africa",
                    SGS: "south.?georgia|sandwich",
                    SSD: "\\bs\\w*.?sudan",
                    ESP: "spain",
                    LKA: "sri.?lanka|ceylon",
                    SDN: "^(?!.*\\bs(?!u)).*sudan",
                    SUR: "surinam|dutch.?guiana",
                    SJM: "svalbard",
                    SWZ: "swaziland",
                    SWE: "sweden",
                    CHE: "switz|swiss",
                    SYR: "syria",
                    TWN: "taiwan|taipei|formosa|^(?!.*peo)(?=.*rep).*china",
                    TJK: "tajik",
                    THA: "thailand|\\bsiam",
                    MKD: "macedonia|fyrom",
                    TLS: "^(?=.*leste).*timor|^(?=.*east).*timor",
                    TGO: "togo",
                    TKL: "tokelau",
                    TON: "tonga",
                    TTO: "trinidad|tobago",
                    TUN: "tunisia",
                    TUR: "turkey",
                    TKM: "turkmen",
                    TCA: "turks",
                    TUV: "tuvalu",
                    UGA: "uganda",
                    UKR: "ukrain",
                    ARE: "emirates|^u\\.?a\\.?e\\.?$|united.?arab.?em",
                    GBR: "united.?kingdom|britain|^u\\.?k\\.?$",
                    TZA: "tanzania",
                    USA: "united.?states\\b(?!.*islands)|\\bu\\.?s\\.?a\\.?\\b|^\\s*u\\.?s\\.?\\b(?!.*islands)",
                    UMI: "minor.?outlying.?is",
                    URY: "uruguay",
                    UZB: "uzbek",
                    VUT: "vanuatu|new.?hebrides",
                    VEN: "venezuela",
                    VNM: "^(?!.*republic).*viet.?nam|^(?=.*socialist).*viet.?nam",
                    VGB: "^(?=.*\\bu\\.?\\s?k).*virgin|^(?=.*brit).*virgin|^(?=.*kingdom).*virgin",
                    VIR: "^(?=.*\\bu\\.?\\s?s).*virgin|^(?=.*states).*virgin",
                    WLF: "futuna|wallis",
                    ESH: "western.sahara",
                    YEM: "^(?!.*arab)(?!.*north)(?!.*sana)(?!.*peo)(?!.*dem)(?!.*south)(?!.*aden)(?!.*\\bp\\.?d\\.?r).*yemen",
                    YMD: "^(?=.*peo).*yemen|^(?!.*rep)(?=.*dem).*yemen|^(?=.*south).*yemen|^(?=.*aden).*yemen|^(?=.*\\bp\\.?d\\.?r).*yemen",
                    YUG: "yugoslavia",
                    ZMB: "zambia|northern.?rhodesia",
                    EAZ: "zanzibar",
                    ZWE: "zimbabwe|^(?!.*northern).*rhodesia"
                };
            },
            59518: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    parse: r(86029),
                    stringify: r(38211)
                };
            },
            87724: function(t1, e1, r) {
                "use strict";
                var n = r(23648);
                t1.exports = {
                    isSize: function(t1) {
                        return /^[\d\.]/.test(t1) || -1 !== t1.indexOf("/") || -1 !== n.indexOf(t1);
                    }
                };
            },
            86029: function(t1, e1, r) {
                "use strict";
                var n = r(80886), i = r(54324), a = r(94316), o = r(99803), s = r(87486), l = r(2362), c = r(28089), u = r(87724).isSize;
                t1.exports = f;
                var h = f.cache = {};
                function f(t1) {
                    if ("string" != typeof t1) throw new Error("Font argument must be a string.");
                    if (h[t1]) return h[t1];
                    if ("" === t1) throw new Error("Cannot parse an empty string.");
                    if (-1 !== a.indexOf(t1)) return h[t1] = {
                        system: t1
                    };
                    for(var e1, r = {
                        style: "normal",
                        variant: "normal",
                        weight: "normal",
                        stretch: "normal",
                        lineHeight: "normal",
                        size: "1rem",
                        family: [
                            "serif"
                        ]
                    }, f = c(t1, /\s+/); e1 = f.shift();){
                        if (-1 !== i.indexOf(e1)) return [
                            "style",
                            "variant",
                            "weight",
                            "stretch"
                        ].forEach(function(t1) {
                            r[t1] = e1;
                        }), h[t1] = r;
                        if (-1 === s.indexOf(e1)) {
                            if ("normal" !== e1 && "small-caps" !== e1) {
                                if (-1 === l.indexOf(e1)) {
                                    if (-1 === o.indexOf(e1)) {
                                        if (u(e1)) {
                                            var d = c(e1, "/");
                                            if (r.size = d[0], null != d[1] ? r.lineHeight = p(d[1]) : "/" === f[0] && (f.shift(), r.lineHeight = p(f.shift())), !f.length) throw new Error("Missing required font-family.");
                                            return r.family = c(f.join(" "), /\s*,\s*/).map(n), h[t1] = r;
                                        }
                                        throw new Error("Unknown or unsupported font token: " + e1);
                                    }
                                    r.weight = e1;
                                } else r.stretch = e1;
                            } else r.variant = e1;
                        } else r.style = e1;
                    }
                    throw new Error("Missing required font-size.");
                }
                function p(t1) {
                    var e1 = parseFloat(t1);
                    return e1.toString() === t1 ? e1 : t1;
                }
            },
            38211: function(t1, e1, r) {
                "use strict";
                var n = r(6807), i = r(87724).isSize, a = d(r(54324)), o = d(r(94316)), s = d(r(99803)), l = d(r(87486)), c = d(r(2362)), u = {
                    normal: 1,
                    "small-caps": 1
                }, h = {
                    serif: 1,
                    "sans-serif": 1,
                    monospace: 1,
                    cursive: 1,
                    fantasy: 1,
                    "system-ui": 1
                }, f = "serif";
                function p(t1, e1) {
                    if (t1 && !e1[t1] && !a[t1]) throw Error("Unknown keyword `" + t1 + "`");
                    return t1;
                }
                function d(t1) {
                    for(var e1 = {}, r = 0; r < t1.length; r++)e1[t1[r]] = 1;
                    return e1;
                }
                t1.exports = function(t1) {
                    if ((t1 = n(t1, {
                        style: "style fontstyle fontStyle font-style slope distinction",
                        variant: "variant font-variant fontVariant fontvariant var capitalization",
                        weight: "weight w font-weight fontWeight fontweight",
                        stretch: "stretch font-stretch fontStretch fontstretch width",
                        size: "size s font-size fontSize fontsize height em emSize",
                        lineHeight: "lh line-height lineHeight lineheight leading",
                        family: "font family fontFamily font-family fontfamily type typeface face",
                        system: "system reserved default global"
                    })).system) return t1.system && p(t1.system, o), t1.system;
                    if (p(t1.style, l), p(t1.variant, u), p(t1.weight, s), p(t1.stretch, c), null == t1.size && (t1.size = "1rem"), "number" == typeof t1.size && (t1.size += "px"), !i) throw Error("Bad size value `" + t1.size + "`");
                    t1.family || (t1.family = f), Array.isArray(t1.family) && (t1.family.length || (t1.family = [
                        f
                    ]), t1.family = t1.family.map(function(t1) {
                        return h[t1] ? t1 : '"' + t1 + '"';
                    }).join(", "));
                    var e1 = [];
                    return e1.push(t1.style), t1.variant !== t1.style && e1.push(t1.variant), t1.weight !== t1.variant && t1.weight !== t1.style && e1.push(t1.weight), t1.stretch !== t1.weight && t1.stretch !== t1.variant && t1.stretch !== t1.style && e1.push(t1.stretch), e1.push(t1.size + (null == t1.lineHeight || "normal" === t1.lineHeight || t1.lineHeight + "" == "1" ? "" : "/" + t1.lineHeight)), e1.push(t1.family), e1.filter(Boolean).join(" ");
                };
            },
            51070: function(t1) {
                "use strict";
                t1.exports = function(t1) {
                    var e1 = [];
                    return e1.toString = function() {
                        return this.map(function(e1) {
                            var r = "", n = void 0 !== e1[5];
                            return e1[4] && (r += "@supports (".concat(e1[4], ") {")), e1[2] && (r += "@media ".concat(e1[2], " {")), n && (r += "@layer".concat(e1[5].length > 0 ? " ".concat(e1[5]) : "", " {")), r += t1(e1), n && (r += "}"), e1[2] && (r += "}"), e1[4] && (r += "}"), r;
                        }).join("");
                    }, e1.i = function(t1, r, n, i, a) {
                        "string" == typeof t1 && (t1 = [
                            [
                                null,
                                t1,
                                void 0
                            ]
                        ]);
                        var o = {};
                        if (n) for(var s = 0; s < this.length; s++){
                            var l = this[s][0];
                            null != l && (o[l] = !0);
                        }
                        for(var c = 0; c < t1.length; c++){
                            var u = [].concat(t1[c]);
                            n && o[u[0]] || (void 0 !== a && (void 0 === u[5] || (u[1] = "@layer".concat(u[5].length > 0 ? " ".concat(u[5]) : "", " {").concat(u[1], "}")), u[5] = a), r && (u[2] ? (u[1] = "@media ".concat(u[2], " {").concat(u[1], "}"), u[2] = r) : u[2] = r), i && (u[4] ? (u[1] = "@supports (".concat(u[4], ") {").concat(u[1], "}"), u[4] = i) : u[4] = "".concat(i)), e1.push(u));
                        }
                    }, e1;
                };
            },
            62133: function(t1) {
                "use strict";
                t1.exports = function(t1, e1) {
                    return e1 || (e1 = {}), t1 ? (t1 = String(t1.__esModule ? t1.default : t1), /^['"].*['"]$/.test(t1) && (t1 = t1.slice(1, -1)), e1.hash && (t1 += e1.hash), /["'() \t\n]|(%20)/.test(t1) || e1.needQuotes ? '"'.concat(t1.replace(/"/g, '\\"').replace(/\n/g, "\\n"), '"') : t1) : t1;
                };
            },
            22413: function(t1) {
                "use strict";
                t1.exports = function(t1) {
                    return t1[1];
                };
            },
            84510: function(t1, e1, r) {
                "use strict";
                var n, i = r(80299), a = r(9557), o = r(6887), s = r(86591), l = r(76504), c = r(29854), u = Function.prototype.bind, h = Object.defineProperty, f = Object.prototype.hasOwnProperty;
                n = function(t1, e1, r) {
                    var n, i = a(e1) && o(e1.value);
                    return delete (n = s(e1)).writable, delete n.value, n.get = function() {
                        return !r.overwriteDefinition && f.call(this, t1) ? i : (e1.value = u.call(i, r.resolveContext ? r.resolveContext(this) : this), h(this, t1, e1), this[t1]);
                    }, n;
                }, t1.exports = function(t1) {
                    var e1 = l(arguments[1]);
                    return i(e1.resolveContext) && o(e1.resolveContext), c(t1, function(t1, r) {
                        return n(r, t1, e1);
                    });
                };
            },
            91819: function(t1, e1, r) {
                "use strict";
                var n = r(80299), i = r(63461), a = r(1920), o = r(76504), s = r(2338), l = t1.exports = function(t1, e1) {
                    var r, i, l, c, u;
                    return arguments.length < 2 || "string" != typeof t1 ? (c = e1, e1 = t1, t1 = null) : c = arguments[2], n(t1) ? (r = s.call(t1, "c"), i = s.call(t1, "e"), l = s.call(t1, "w")) : (r = l = !0, i = !1), u = {
                        value: e1,
                        configurable: r,
                        enumerable: i,
                        writable: l
                    }, c ? a(o(c), u) : u;
                };
                l.gs = function(t1, e1, r) {
                    var l, c, u, h;
                    return "string" != typeof t1 ? (u = r, r = e1, e1 = t1, t1 = null) : u = arguments[3], n(e1) ? i(e1) ? n(r) ? i(r) || (u = r, r = void 0) : r = void 0 : (u = e1, e1 = r = void 0) : e1 = void 0, n(t1) ? (l = s.call(t1, "c"), c = s.call(t1, "e")) : (l = !0, c = !1), h = {
                        get: e1,
                        set: r,
                        configurable: l,
                        enumerable: c
                    }, u ? a(o(u), h) : h;
                };
            },
            29725: function(t1, e1, r) {
                "use strict";
                function n(t1, e1) {
                    return t1 < e1 ? -1 : t1 > e1 ? 1 : t1 >= e1 ? 0 : NaN;
                }
                r.d(e1, {
                    V_: function() {
                        return n;
                    },
                    T9: function() {
                        return s;
                    },
                    i2: function() {
                        return c;
                    },
                    Am: function() {
                        return u;
                    },
                    jk: function() {
                        return h;
                    },
                    y1: function() {
                        return f;
                    },
                    cz: function() {
                        return p;
                    }
                }), 1 === (i = n).length && (a = i, i = function(t1, e1) {
                    return n(a(t1), e1);
                });
                var i, a, o = Array.prototype;
                function s(t1, e1) {
                    var r, n, i = t1.length, a = -1;
                    if (null == e1) {
                        for(; ++a < i;)if (null != (r = t1[a]) && r >= r) for(n = r; ++a < i;)null != (r = t1[a]) && r > n && (n = r);
                    } else for(; ++a < i;)if (null != (r = e1(t1[a], a, t1)) && r >= r) for(n = r; ++a < i;)null != (r = e1(t1[a], a, t1)) && r > n && (n = r);
                    return n;
                }
                function l(t1) {
                    return null === t1 ? NaN : +t1;
                }
                function c(t1, e1) {
                    var r, n = t1.length, i = n, a = -1, o = 0;
                    if (null == e1) for(; ++a < n;)isNaN(r = l(t1[a])) ? --i : o += r;
                    else for(; ++a < n;)isNaN(r = l(e1(t1[a], a, t1))) ? --i : o += r;
                    if (i) return o / i;
                }
                function u(t1) {
                    for(var e1, r, n, i = t1.length, a = -1, o = 0; ++a < i;)o += t1[a].length;
                    for(r = new Array(o); --i >= 0;)for(e1 = (n = t1[i]).length; --e1 >= 0;)r[--o] = n[e1];
                    return r;
                }
                function h(t1, e1) {
                    var r, n, i = t1.length, a = -1;
                    if (null == e1) {
                        for(; ++a < i;)if (null != (r = t1[a]) && r >= r) for(n = r; ++a < i;)null != (r = t1[a]) && n > r && (n = r);
                    } else for(; ++a < i;)if (null != (r = e1(t1[a], a, t1)) && r >= r) for(n = r; ++a < i;)null != (r = e1(t1[a], a, t1)) && n > r && (n = r);
                    return n;
                }
                function f(t1, e1, r) {
                    t1 = +t1, e1 = +e1, r = (i = arguments.length) < 2 ? (e1 = t1, t1 = 0, 1) : i < 3 ? 1 : +r;
                    for(var n = -1, i = 0 | Math.max(0, Math.ceil((e1 - t1) / r)), a = new Array(i); ++n < i;)a[n] = t1 + n * r;
                    return a;
                }
                function p(t1, e1) {
                    var r, n = t1.length, i = -1, a = 0;
                    if (null == e1) for(; ++i < n;)(r = +t1[i]) && (a += r);
                    else for(; ++i < n;)(r = +e1(t1[i], i, t1)) && (a += r);
                    return a;
                }
                o.slice, o.map;
            },
            4575: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    Tj: function() {
                        return o;
                    },
                    $I: function() {
                        return s;
                    }
                });
                var n = "$";
                function i() {}
                function a(t1, e1) {
                    var r = new i;
                    if (t1 instanceof i) t1.each(function(t1, e1) {
                        r.set(e1, t1);
                    });
                    else if (Array.isArray(t1)) {
                        var n, a = -1, o = t1.length;
                        if (null == e1) for(; ++a < o;)r.set(a, t1[a]);
                        else for(; ++a < o;)r.set(e1(n = t1[a], a, t1), n);
                    } else if (t1) for(var s in t1)r.set(s, t1[s]);
                    return r;
                }
                i.prototype = a.prototype = {
                    constructor: i,
                    has: function(t1) {
                        return n + t1 in this;
                    },
                    get: function(t1) {
                        return this[n + t1];
                    },
                    set: function(t1, e1) {
                        return this[n + t1] = e1, this;
                    },
                    remove: function(t1) {
                        var e1 = n + t1;
                        return e1 in this && delete this[e1];
                    },
                    clear: function() {
                        for(var t1 in this)t1[0] === n && delete this[t1];
                    },
                    keys: function() {
                        var t1 = [];
                        for(var e1 in this)e1[0] === n && t1.push(e1.slice(1));
                        return t1;
                    },
                    values: function() {
                        var t1 = [];
                        for(var e1 in this)e1[0] === n && t1.push(this[e1]);
                        return t1;
                    },
                    entries: function() {
                        var t1 = [];
                        for(var e1 in this)e1[0] === n && t1.push({
                            key: e1.slice(1),
                            value: this[e1]
                        });
                        return t1;
                    },
                    size: function() {
                        var t1 = 0;
                        for(var e1 in this)e1[0] === n && ++t1;
                        return t1;
                    },
                    empty: function() {
                        for(var t1 in this)if (t1[0] === n) return !1;
                        return !0;
                    },
                    each: function(t1) {
                        for(var e1 in this)e1[0] === n && t1(this[e1], e1.slice(1), this);
                    }
                };
                var o = a;
                function s() {
                    var t1, e1, r, n = [], i = [];
                    function a(r, i, s, l) {
                        if (i >= n.length) return null != t1 && r.sort(t1), null != e1 ? e1(r) : r;
                        for(var c, u, h, f = -1, p = r.length, d = n[i++], m = o(), g = s(); ++f < p;)(h = m.get(c = d(u = r[f]) + "")) ? h.push(u) : m.set(c, [
                            u
                        ]);
                        return m.each(function(t1, e1) {
                            l(g, e1, a(t1, i, s, l));
                        }), g;
                    }
                    function s(t1, r) {
                        if (++r > n.length) return t1;
                        var a, o = i[r - 1];
                        return null != e1 && r >= n.length ? a = t1.entries() : (a = [], t1.each(function(t1, e1) {
                            a.push({
                                key: e1,
                                values: s(t1, r)
                            });
                        })), null != o ? a.sort(function(t1, e1) {
                            return o(t1.key, e1.key);
                        }) : a;
                    }
                    return r = {
                        object: function(t1) {
                            return a(t1, 0, l, c);
                        },
                        map: function(t1) {
                            return a(t1, 0, u, h);
                        },
                        entries: function(t1) {
                            return s(a(t1, 0, u, h), 0);
                        },
                        key: function(t1) {
                            return n.push(t1), r;
                        },
                        sortKeys: function(t1) {
                            return i[n.length - 1] = t1, r;
                        },
                        sortValues: function(e1) {
                            return t1 = e1, r;
                        },
                        rollup: function(t1) {
                            return e1 = t1, r;
                        }
                    };
                }
                function l() {
                    return {};
                }
                function c(t1, e1, r) {
                    t1[e1] = r;
                }
                function u() {
                    return o();
                }
                function h(t1, e1, r) {
                    t1.set(e1, r);
                }
                function f() {}
                var p = o.prototype;
                f.prototype = (function(t1, e1) {
                    var r = new f;
                    if (t1 instanceof f) t1.each(function(t1) {
                        r.add(t1);
                    });
                    else if (t1) {
                        var n = -1, i = t1.length;
                        if (null == e1) for(; ++n < i;)r.add(t1[n]);
                        else for(; ++n < i;)r.add(e1(t1[n], n, t1));
                    }
                    return r;
                }).prototype = {
                    constructor: f,
                    has: p.has,
                    add: function(t1) {
                        return this[n + (t1 += "")] = t1, this;
                    },
                    remove: p.remove,
                    clear: p.clear,
                    values: p.keys,
                    size: p.size,
                    empty: p.empty,
                    each: p.each
                };
            },
            32702: function(t1, e1, r) {
                "use strict";
                function n(t1, e1) {
                    var r;
                    function n() {
                        var n, i, a = r.length, o = 0, s = 0;
                        for(n = 0; n < a; ++n)o += (i = r[n]).x, s += i.y;
                        for(o = o / a - t1, s = s / a - e1, n = 0; n < a; ++n)(i = r[n]).x -= o, i.y -= s;
                    }
                    return null == t1 && (t1 = 0), null == e1 && (e1 = 0), n.initialize = function(t1) {
                        r = t1;
                    }, n.x = function(e1) {
                        return arguments.length ? (t1 = +e1, n) : t1;
                    }, n.y = function(t1) {
                        return arguments.length ? (e1 = +t1, n) : e1;
                    }, n;
                }
                function i(t1) {
                    return function() {
                        return t1;
                    };
                }
                function a() {
                    return 1e-6 * (Math.random() - .5);
                }
                function o(t1, e1, r, n) {
                    if (isNaN(e1) || isNaN(r)) return t1;
                    var i, a, o, s, l, c, u, h, f, p = t1._root, d = {
                        data: n
                    }, m = t1._x0, g = t1._y0, y = t1._x1, v = t1._y1;
                    if (!p) return t1._root = d, t1;
                    for(; p.length;)if ((c = e1 >= (a = (m + y) / 2)) ? m = a : y = a, (u = r >= (o = (g + v) / 2)) ? g = o : v = o, i = p, !(p = p[h = u << 1 | c])) return i[h] = d, t1;
                    if (s = +t1._x.call(null, p.data), l = +t1._y.call(null, p.data), e1 === s && r === l) return d.next = p, i ? i[h] = d : t1._root = d, t1;
                    do i = i ? i[h] = new Array(4) : t1._root = new Array(4), (c = e1 >= (a = (m + y) / 2)) ? m = a : y = a, (u = r >= (o = (g + v) / 2)) ? g = o : v = o;
                    while ((h = u << 1 | c) == (f = (l >= o) << 1 | s >= a));
                    return i[f] = p, i[h] = d, t1;
                }
                function s(t1, e1, r, n, i) {
                    this.node = t1, this.x0 = e1, this.y0 = r, this.x1 = n, this.y1 = i;
                }
                function l(t1) {
                    return t1[0];
                }
                function c(t1) {
                    return t1[1];
                }
                function u(t1, e1, r) {
                    var n = new h(null == e1 ? l : e1, null == r ? c : r, NaN, NaN, NaN, NaN);
                    return null == t1 ? n : n.addAll(t1);
                }
                function h(t1, e1, r, n, i, a) {
                    this._x = t1, this._y = e1, this._x0 = r, this._y0 = n, this._x1 = i, this._y1 = a, this._root = void 0;
                }
                function f(t1) {
                    for(var e1 = {
                        data: t1.data
                    }, r = e1; t1 = t1.next;)r = r.next = {
                        data: t1.data
                    };
                    return e1;
                }
                r.r(e1), r.d(e1, {
                    forceCenter: function() {
                        return n;
                    },
                    forceCollide: function() {
                        return g;
                    },
                    forceLink: function() {
                        return _;
                    },
                    forceManyBody: function() {
                        return $;
                    },
                    forceRadial: function() {
                        return J;
                    },
                    forceSimulation: function() {
                        return X;
                    },
                    forceX: function() {
                        return K;
                    },
                    forceY: function() {
                        return Q;
                    }
                });
                var p = u.prototype = h.prototype;
                function d(t1) {
                    return t1.x + t1.vx;
                }
                function m(t1) {
                    return t1.y + t1.vy;
                }
                function g(t1) {
                    var e1, r, n = 1, o = 1;
                    function s() {
                        for(var t1, i, s, c, h, f, p, g = e1.length, y = 0; y < o; ++y)for(i = u(e1, d, m).visitAfter(l), t1 = 0; t1 < g; ++t1)s = e1[t1], f = r[s.index], p = f * f, c = s.x + s.vx, h = s.y + s.vy, i.visit(v);
                        function v(t1, e1, r, i, o) {
                            var l = t1.data, u = t1.r, d = f + u;
                            if (!l) return e1 > c + d || i < c - d || r > h + d || o < h - d;
                            if (l.index > s.index) {
                                var m = c - l.x - l.vx, g = h - l.y - l.vy, y = m * m + g * g;
                                y < d * d && (0 === m && (y += (m = a()) * m), 0 === g && (y += (g = a()) * g), y = (d - (y = Math.sqrt(y))) / y * n, s.vx += (m *= y) * (d = (u *= u) / (p + u)), s.vy += (g *= y) * d, l.vx -= m * (d = 1 - d), l.vy -= g * d);
                            }
                        }
                    }
                    function l(t1) {
                        if (t1.data) return t1.r = r[t1.data.index];
                        for(var e1 = t1.r = 0; e1 < 4; ++e1)t1[e1] && t1[e1].r > t1.r && (t1.r = t1[e1].r);
                    }
                    function c() {
                        if (e1) {
                            var n, i, a = e1.length;
                            for(r = new Array(a), n = 0; n < a; ++n)i = e1[n], r[i.index] = +t1(i, n, e1);
                        }
                    }
                    return "function" != typeof t1 && (t1 = i(null == t1 ? 1 : +t1)), s.initialize = function(t1) {
                        e1 = t1, c();
                    }, s.iterations = function(t1) {
                        return arguments.length ? (o = +t1, s) : o;
                    }, s.strength = function(t1) {
                        return arguments.length ? (n = +t1, s) : n;
                    }, s.radius = function(e1) {
                        return arguments.length ? (t1 = "function" == typeof e1 ? e1 : i(+e1), c(), s) : t1;
                    }, s;
                }
                p.copy = function() {
                    var t1, e1, r = new h(this._x, this._y, this._x0, this._y0, this._x1, this._y1), n = this._root;
                    if (!n) return r;
                    if (!n.length) return r._root = f(n), r;
                    for(t1 = [
                        {
                            source: n,
                            target: r._root = new Array(4)
                        }
                    ]; n = t1.pop();)for(var i = 0; i < 4; ++i)(e1 = n.source[i]) && (e1.length ? t1.push({
                        source: e1,
                        target: n.target[i] = new Array(4)
                    }) : n.target[i] = f(e1));
                    return r;
                }, p.add = function(t1) {
                    var e1 = +this._x.call(null, t1), r = +this._y.call(null, t1);
                    return o(this.cover(e1, r), e1, r, t1);
                }, p.addAll = function(t1) {
                    var e1, r, n, i, a = t1.length, s = new Array(a), l = new Array(a), c = 1 / 0, u = 1 / 0, h = -1 / 0, f = -1 / 0;
                    for(r = 0; r < a; ++r)isNaN(n = +this._x.call(null, e1 = t1[r])) || isNaN(i = +this._y.call(null, e1)) || (s[r] = n, l[r] = i, n < c && (c = n), n > h && (h = n), i < u && (u = i), i > f && (f = i));
                    if (c > h || u > f) return this;
                    for(this.cover(c, u).cover(h, f), r = 0; r < a; ++r)o(this, s[r], l[r], t1[r]);
                    return this;
                }, p.cover = function(t1, e1) {
                    if (isNaN(t1 = +t1) || isNaN(e1 = +e1)) return this;
                    var r = this._x0, n = this._y0, i = this._x1, a = this._y1;
                    if (isNaN(r)) i = (r = Math.floor(t1)) + 1, a = (n = Math.floor(e1)) + 1;
                    else {
                        for(var o, s, l = i - r, c = this._root; r > t1 || t1 >= i || n > e1 || e1 >= a;)switch(s = (e1 < n) << 1 | t1 < r, (o = new Array(4))[s] = c, c = o, l *= 2, s){
                            case 0:
                                i = r + l, a = n + l;
                                break;
                            case 1:
                                r = i - l, a = n + l;
                                break;
                            case 2:
                                i = r + l, n = a - l;
                                break;
                            case 3:
                                r = i - l, n = a - l;
                        }
                        this._root && this._root.length && (this._root = c);
                    }
                    return this._x0 = r, this._y0 = n, this._x1 = i, this._y1 = a, this;
                }, p.data = function() {
                    var t1 = [];
                    return this.visit(function(e1) {
                        if (!e1.length) do t1.push(e1.data);
                        while (e1 = e1.next);
                    }), t1;
                }, p.extent = function(t1) {
                    return arguments.length ? this.cover(+t1[0][0], +t1[0][1]).cover(+t1[1][0], +t1[1][1]) : isNaN(this._x0) ? void 0 : [
                        [
                            this._x0,
                            this._y0
                        ],
                        [
                            this._x1,
                            this._y1
                        ]
                    ];
                }, p.find = function(t1, e1, r) {
                    var n, i, a, o, l, c, u, h = this._x0, f = this._y0, p = this._x1, d = this._y1, m = [], g = this._root;
                    for(g && m.push(new s(g, h, f, p, d)), null == r ? r = 1 / 0 : (h = t1 - r, f = e1 - r, p = t1 + r, d = e1 + r, r *= r); c = m.pop();)if (!(!(g = c.node) || (i = c.x0) > p || (a = c.y0) > d || (o = c.x1) < h || (l = c.y1) < f)) {
                        if (g.length) {
                            var y = (i + o) / 2, v = (a + l) / 2;
                            m.push(new s(g[3], y, v, o, l), new s(g[2], i, v, y, l), new s(g[1], y, a, o, v), new s(g[0], i, a, y, v)), (u = (e1 >= v) << 1 | t1 >= y) && (c = m[m.length - 1], m[m.length - 1] = m[m.length - 1 - u], m[m.length - 1 - u] = c);
                        } else {
                            var x = t1 - +this._x.call(null, g.data), _ = e1 - +this._y.call(null, g.data), b = x * x + _ * _;
                            if (b < r) {
                                var w = Math.sqrt(r = b);
                                h = t1 - w, f = e1 - w, p = t1 + w, d = e1 + w, n = g.data;
                            }
                        }
                    }
                    return n;
                }, p.remove = function(t1) {
                    if (isNaN(a = +this._x.call(null, t1)) || isNaN(o = +this._y.call(null, t1))) return this;
                    var e1, r, n, i, a, o, s, l, c, u, h, f, p = this._root, d = this._x0, m = this._y0, g = this._x1, y = this._y1;
                    if (!p) return this;
                    if (p.length) for(;;){
                        if ((c = a >= (s = (d + g) / 2)) ? d = s : g = s, (u = o >= (l = (m + y) / 2)) ? m = l : y = l, e1 = p, !(p = p[h = u << 1 | c])) return this;
                        if (!p.length) break;
                        (e1[h + 1 & 3] || e1[h + 2 & 3] || e1[h + 3 & 3]) && (r = e1, f = h);
                    }
                    for(; p.data !== t1;)if (n = p, !(p = p.next)) return this;
                    return (i = p.next) && delete p.next, n ? (i ? n.next = i : delete n.next, this) : e1 ? (i ? e1[h] = i : delete e1[h], (p = e1[0] || e1[1] || e1[2] || e1[3]) && p === (e1[3] || e1[2] || e1[1] || e1[0]) && !p.length && (r ? r[f] = p : this._root = p), this) : (this._root = i, this);
                }, p.removeAll = function(t1) {
                    for(var e1 = 0, r = t1.length; e1 < r; ++e1)this.remove(t1[e1]);
                    return this;
                }, p.root = function() {
                    return this._root;
                }, p.size = function() {
                    var t1 = 0;
                    return this.visit(function(e1) {
                        if (!e1.length) do ++t1;
                        while (e1 = e1.next);
                    }), t1;
                }, p.visit = function(t1) {
                    var e1, r, n, i, a, o, l = [], c = this._root;
                    for(c && l.push(new s(c, this._x0, this._y0, this._x1, this._y1)); e1 = l.pop();)if (!t1(c = e1.node, n = e1.x0, i = e1.y0, a = e1.x1, o = e1.y1) && c.length) {
                        var u = (n + a) / 2, h = (i + o) / 2;
                        (r = c[3]) && l.push(new s(r, u, h, a, o)), (r = c[2]) && l.push(new s(r, n, h, u, o)), (r = c[1]) && l.push(new s(r, u, i, a, h)), (r = c[0]) && l.push(new s(r, n, i, u, h));
                    }
                    return this;
                }, p.visitAfter = function(t1) {
                    var e1, r = [], n = [];
                    for(this._root && r.push(new s(this._root, this._x0, this._y0, this._x1, this._y1)); e1 = r.pop();){
                        var i = e1.node;
                        if (i.length) {
                            var a, o = e1.x0, l = e1.y0, c = e1.x1, u = e1.y1, h = (o + c) / 2, f = (l + u) / 2;
                            (a = i[0]) && r.push(new s(a, o, l, h, f)), (a = i[1]) && r.push(new s(a, h, l, c, f)), (a = i[2]) && r.push(new s(a, o, f, h, u)), (a = i[3]) && r.push(new s(a, h, f, c, u));
                        }
                        n.push(e1);
                    }
                    for(; e1 = n.pop();)t1(e1.node, e1.x0, e1.y0, e1.x1, e1.y1);
                    return this;
                }, p.x = function(t1) {
                    return arguments.length ? (this._x = t1, this) : this._x;
                }, p.y = function(t1) {
                    return arguments.length ? (this._y = t1, this) : this._y;
                };
                var y = r(4575);
                function v(t1) {
                    return t1.index;
                }
                function x(t1, e1) {
                    var r = t1.get(e1);
                    if (!r) throw new Error("missing: " + e1);
                    return r;
                }
                function _(t1) {
                    var e1, r, n, o, s, l = v, c = function(t1) {
                        return 1 / Math.min(o[t1.source.index], o[t1.target.index]);
                    }, u = i(30), h = 1;
                    function f(n) {
                        for(var i = 0, o = t1.length; i < h; ++i)for(var l, c, u, f, p, d, m, g = 0; g < o; ++g)c = (l = t1[g]).source, f = (u = l.target).x + u.vx - c.x - c.vx || a(), p = u.y + u.vy - c.y - c.vy || a(), f *= d = ((d = Math.sqrt(f * f + p * p)) - r[g]) / d * n * e1[g], p *= d, u.vx -= f * (m = s[g]), u.vy -= p * m, c.vx += f * (m = 1 - m), c.vy += p * m;
                    }
                    function p() {
                        if (n) {
                            var i, a, c = n.length, u = t1.length, h = (0, y.Tj)(n, l);
                            for(i = 0, o = new Array(c); i < u; ++i)(a = t1[i]).index = i, "object" != typeof a.source && (a.source = x(h, a.source)), "object" != typeof a.target && (a.target = x(h, a.target)), o[a.source.index] = (o[a.source.index] || 0) + 1, o[a.target.index] = (o[a.target.index] || 0) + 1;
                            for(i = 0, s = new Array(u); i < u; ++i)a = t1[i], s[i] = o[a.source.index] / (o[a.source.index] + o[a.target.index]);
                            e1 = new Array(u), d(), r = new Array(u), m();
                        }
                    }
                    function d() {
                        if (n) for(var r = 0, i = t1.length; r < i; ++r)e1[r] = +c(t1[r], r, t1);
                    }
                    function m() {
                        if (n) for(var e1 = 0, i = t1.length; e1 < i; ++e1)r[e1] = +u(t1[e1], e1, t1);
                    }
                    return null == t1 && (t1 = []), f.initialize = function(t1) {
                        n = t1, p();
                    }, f.links = function(e1) {
                        return arguments.length ? (t1 = e1, p(), f) : t1;
                    }, f.id = function(t1) {
                        return arguments.length ? (l = t1, f) : l;
                    }, f.iterations = function(t1) {
                        return arguments.length ? (h = +t1, f) : h;
                    }, f.strength = function(t1) {
                        return arguments.length ? (c = "function" == typeof t1 ? t1 : i(+t1), d(), f) : c;
                    }, f.distance = function(t1) {
                        return arguments.length ? (u = "function" == typeof t1 ? t1 : i(+t1), m(), f) : u;
                    }, f;
                }
                var b = {
                    value: function() {}
                };
                function w() {
                    for(var t1, e1 = 0, r = arguments.length, n = {}; e1 < r; ++e1){
                        if (!(t1 = arguments[e1] + "") || t1 in n || /[\s.]/.test(t1)) throw new Error("illegal type: " + t1);
                        n[t1] = [];
                    }
                    return new T(n);
                }
                function T(t1) {
                    this._ = t1;
                }
                function k(t1, e1) {
                    for(var r, n = 0, i = t1.length; n < i; ++n)if ((r = t1[n]).name === e1) return r.value;
                }
                function A(t1, e1, r) {
                    for(var n = 0, i = t1.length; n < i; ++n)if (t1[n].name === e1) {
                        t1[n] = b, t1 = t1.slice(0, n).concat(t1.slice(n + 1));
                        break;
                    }
                    return null != r && t1.push({
                        name: e1,
                        value: r
                    }), t1;
                }
                T.prototype = w.prototype = {
                    constructor: T,
                    on: function(t1, e1) {
                        var r, n, i = this._, a = (n = i, (t1 + "").trim().split(/^|\s+/).map(function(t1) {
                            var e1 = "", r = t1.indexOf(".");
                            if (r >= 0 && (e1 = t1.slice(r + 1), t1 = t1.slice(0, r)), t1 && !n.hasOwnProperty(t1)) throw new Error("unknown type: " + t1);
                            return {
                                type: t1,
                                name: e1
                            };
                        })), o = -1, s = a.length;
                        if (!(arguments.length < 2)) {
                            if (null != e1 && "function" != typeof e1) throw new Error("invalid callback: " + e1);
                            for(; ++o < s;)if (r = (t1 = a[o]).type) i[r] = A(i[r], t1.name, e1);
                            else if (null == e1) for(r in i)i[r] = A(i[r], t1.name, null);
                            return this;
                        }
                        for(; ++o < s;)if ((r = (t1 = a[o]).type) && (r = k(i[r], t1.name))) return r;
                    },
                    copy: function() {
                        var t1 = {}, e1 = this._;
                        for(var r in e1)t1[r] = e1[r].slice();
                        return new T(t1);
                    },
                    call: function(t1, e1) {
                        if ((r = arguments.length - 2) > 0) for(var r, n, i = new Array(r), a = 0; a < r; ++a)i[a] = arguments[a + 2];
                        if (!this._.hasOwnProperty(t1)) throw new Error("unknown type: " + t1);
                        for(a = 0, r = (n = this._[t1]).length; a < r; ++a)n[a].value.apply(e1, i);
                    },
                    apply: function(t1, e1, r) {
                        if (!this._.hasOwnProperty(t1)) throw new Error("unknown type: " + t1);
                        for(var n = this._[t1], i = 0, a = n.length; i < a; ++i)n[i].value.apply(e1, r);
                    }
                };
                var M, S, E = w, C = 0, L = 0, I = 0, P = 1e3, z = 0, O = 0, D = 0, R = "object" == typeof performance && performance.now ? performance : Date, F = "object" == typeof window && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(t1) {
                    setTimeout(t1, 17);
                };
                function B() {
                    return O || (F(N), O = R.now() + D);
                }
                function N() {
                    O = 0;
                }
                function j() {
                    this._call = this._time = this._next = null;
                }
                function U(t1, e1, r) {
                    var n = new j;
                    return n.restart(t1, e1, r), n;
                }
                function V() {
                    O = (z = R.now()) + D, C = L = 0;
                    try {
                        !function() {
                            B(), ++C;
                            for(var t1, e1 = M; e1;)(t1 = O - e1._time) >= 0 && e1._call.call(null, t1), e1 = e1._next;
                            --C;
                        }();
                    } finally{
                        C = 0, function() {
                            for(var t1, e1, r = M, n = 1 / 0; r;)r._call ? (n > r._time && (n = r._time), t1 = r, r = r._next) : (e1 = r._next, r._next = null, r = t1 ? t1._next = e1 : M = e1);
                            S = t1, H(n);
                        }(), O = 0;
                    }
                }
                function q() {
                    var t1 = R.now(), e1 = t1 - z;
                    e1 > P && (D -= e1, z = t1);
                }
                function H(t1) {
                    C || (L && (L = clearTimeout(L)), t1 - O > 24 ? (t1 < 1 / 0 && (L = setTimeout(V, t1 - R.now() - D)), I && (I = clearInterval(I))) : (I || (z = R.now(), I = setInterval(q, P)), C = 1, F(V)));
                }
                function G(t1) {
                    return t1.x;
                }
                function Z(t1) {
                    return t1.y;
                }
                j.prototype = U.prototype = {
                    constructor: j,
                    restart: function(t1, e1, r) {
                        if ("function" != typeof t1) throw new TypeError("callback is not a function");
                        r = (null == r ? B() : +r) + (null == e1 ? 0 : +e1), this._next || S === this || (S ? S._next = this : M = this, S = this), this._call = t1, this._time = r, H();
                    },
                    stop: function() {
                        this._call && (this._call = null, this._time = 1 / 0, H());
                    }
                };
                var W = 10, Y = Math.PI * (3 - Math.sqrt(5));
                function X(t1) {
                    var e1, r = 1, n = .001, i = 1 - Math.pow(n, 1 / 300), a = 0, o = .6, s = (0, y.Tj)(), l = U(u), c = E("tick", "end");
                    function u() {
                        h(), c.call("tick", e1), r < n && (l.stop(), c.call("end", e1));
                    }
                    function h(n) {
                        var l, c, u = t1.length;
                        void 0 === n && (n = 1);
                        for(var h = 0; h < n; ++h)for(r += (a - r) * i, s.each(function(t1) {
                            t1(r);
                        }), l = 0; l < u; ++l)null == (c = t1[l]).fx ? c.x += c.vx *= o : (c.x = c.fx, c.vx = 0), null == c.fy ? c.y += c.vy *= o : (c.y = c.fy, c.vy = 0);
                        return e1;
                    }
                    function f() {
                        for(var e1, r = 0, n = t1.length; r < n; ++r){
                            if ((e1 = t1[r]).index = r, null != e1.fx && (e1.x = e1.fx), null != e1.fy && (e1.y = e1.fy), isNaN(e1.x) || isNaN(e1.y)) {
                                var i = W * Math.sqrt(r), a = r * Y;
                                e1.x = i * Math.cos(a), e1.y = i * Math.sin(a);
                            }
                            (isNaN(e1.vx) || isNaN(e1.vy)) && (e1.vx = e1.vy = 0);
                        }
                    }
                    function p(e1) {
                        return e1.initialize && e1.initialize(t1), e1;
                    }
                    return null == t1 && (t1 = []), f(), e1 = {
                        tick: h,
                        restart: function() {
                            return l.restart(u), e1;
                        },
                        stop: function() {
                            return l.stop(), e1;
                        },
                        nodes: function(r) {
                            return arguments.length ? (t1 = r, f(), s.each(p), e1) : t1;
                        },
                        alpha: function(t1) {
                            return arguments.length ? (r = +t1, e1) : r;
                        },
                        alphaMin: function(t1) {
                            return arguments.length ? (n = +t1, e1) : n;
                        },
                        alphaDecay: function(t1) {
                            return arguments.length ? (i = +t1, e1) : +i;
                        },
                        alphaTarget: function(t1) {
                            return arguments.length ? (a = +t1, e1) : a;
                        },
                        velocityDecay: function(t1) {
                            return arguments.length ? (o = 1 - t1, e1) : 1 - o;
                        },
                        force: function(t1, r) {
                            return arguments.length > 1 ? (null == r ? s.remove(t1) : s.set(t1, p(r)), e1) : s.get(t1);
                        },
                        find: function(e1, r, n) {
                            var i, a, o, s, l, c = 0, u = t1.length;
                            for(null == n ? n = 1 / 0 : n *= n, c = 0; c < u; ++c)(o = (i = e1 - (s = t1[c]).x) * i + (a = r - s.y) * a) < n && (l = s, n = o);
                            return l;
                        },
                        on: function(t1, r) {
                            return arguments.length > 1 ? (c.on(t1, r), e1) : c.on(t1);
                        }
                    };
                }
                function $() {
                    var t1, e1, r, n, o = i(-30), s = 1, l = 1 / 0, c = .81;
                    function h(n) {
                        var i, a = t1.length, o = u(t1, G, Z).visitAfter(p);
                        for(r = n, i = 0; i < a; ++i)e1 = t1[i], o.visit(d);
                    }
                    function f() {
                        if (t1) {
                            var e1, r, i = t1.length;
                            for(n = new Array(i), e1 = 0; e1 < i; ++e1)r = t1[e1], n[r.index] = +o(r, e1, t1);
                        }
                    }
                    function p(t1) {
                        var e1, r, i, a, o, s = 0, l = 0;
                        if (t1.length) {
                            for(i = a = o = 0; o < 4; ++o)(e1 = t1[o]) && (r = Math.abs(e1.value)) && (s += e1.value, l += r, i += r * e1.x, a += r * e1.y);
                            t1.x = i / l, t1.y = a / l;
                        } else {
                            (e1 = t1).x = e1.data.x, e1.y = e1.data.y;
                            do s += n[e1.data.index];
                            while (e1 = e1.next);
                        }
                        t1.value = s;
                    }
                    function d(t1, i, o, u) {
                        if (!t1.value) return !0;
                        var h = t1.x - e1.x, f = t1.y - e1.y, p = u - i, d = h * h + f * f;
                        if (p * p / c < d) return d < l && (0 === h && (d += (h = a()) * h), 0 === f && (d += (f = a()) * f), d < s && (d = Math.sqrt(s * d)), e1.vx += h * t1.value * r / d, e1.vy += f * t1.value * r / d), !0;
                        if (!(t1.length || d >= l)) {
                            (t1.data !== e1 || t1.next) && (0 === h && (d += (h = a()) * h), 0 === f && (d += (f = a()) * f), d < s && (d = Math.sqrt(s * d)));
                            do t1.data !== e1 && (p = n[t1.data.index] * r / d, e1.vx += h * p, e1.vy += f * p);
                            while (t1 = t1.next);
                        }
                    }
                    return h.initialize = function(e1) {
                        t1 = e1, f();
                    }, h.strength = function(t1) {
                        return arguments.length ? (o = "function" == typeof t1 ? t1 : i(+t1), f(), h) : o;
                    }, h.distanceMin = function(t1) {
                        return arguments.length ? (s = t1 * t1, h) : Math.sqrt(s);
                    }, h.distanceMax = function(t1) {
                        return arguments.length ? (l = t1 * t1, h) : Math.sqrt(l);
                    }, h.theta = function(t1) {
                        return arguments.length ? (c = t1 * t1, h) : Math.sqrt(c);
                    }, h;
                }
                function J(t1, e1, r) {
                    var n, a, o, s = i(.1);
                    function l(t1) {
                        for(var i = 0, s = n.length; i < s; ++i){
                            var l = n[i], c = l.x - e1 || 1e-6, u = l.y - r || 1e-6, h = Math.sqrt(c * c + u * u), f = (o[i] - h) * a[i] * t1 / h;
                            l.vx += c * f, l.vy += u * f;
                        }
                    }
                    function c() {
                        if (n) {
                            var e1, r = n.length;
                            for(a = new Array(r), o = new Array(r), e1 = 0; e1 < r; ++e1)o[e1] = +t1(n[e1], e1, n), a[e1] = isNaN(o[e1]) ? 0 : +s(n[e1], e1, n);
                        }
                    }
                    return "function" != typeof t1 && (t1 = i(+t1)), null == e1 && (e1 = 0), null == r && (r = 0), l.initialize = function(t1) {
                        n = t1, c();
                    }, l.strength = function(t1) {
                        return arguments.length ? (s = "function" == typeof t1 ? t1 : i(+t1), c(), l) : s;
                    }, l.radius = function(e1) {
                        return arguments.length ? (t1 = "function" == typeof e1 ? e1 : i(+e1), c(), l) : t1;
                    }, l.x = function(t1) {
                        return arguments.length ? (e1 = +t1, l) : e1;
                    }, l.y = function(t1) {
                        return arguments.length ? (r = +t1, l) : r;
                    }, l;
                }
                function K(t1) {
                    var e1, r, n, a = i(.1);
                    function o(t1) {
                        for(var i, a = 0, o = e1.length; a < o; ++a)(i = e1[a]).vx += (n[a] - i.x) * r[a] * t1;
                    }
                    function s() {
                        if (e1) {
                            var i, o = e1.length;
                            for(r = new Array(o), n = new Array(o), i = 0; i < o; ++i)r[i] = isNaN(n[i] = +t1(e1[i], i, e1)) ? 0 : +a(e1[i], i, e1);
                        }
                    }
                    return "function" != typeof t1 && (t1 = i(null == t1 ? 0 : +t1)), o.initialize = function(t1) {
                        e1 = t1, s();
                    }, o.strength = function(t1) {
                        return arguments.length ? (a = "function" == typeof t1 ? t1 : i(+t1), s(), o) : a;
                    }, o.x = function(e1) {
                        return arguments.length ? (t1 = "function" == typeof e1 ? e1 : i(+e1), s(), o) : t1;
                    }, o;
                }
                function Q(t1) {
                    var e1, r, n, a = i(.1);
                    function o(t1) {
                        for(var i, a = 0, o = e1.length; a < o; ++a)(i = e1[a]).vy += (n[a] - i.y) * r[a] * t1;
                    }
                    function s() {
                        if (e1) {
                            var i, o = e1.length;
                            for(r = new Array(o), n = new Array(o), i = 0; i < o; ++i)r[i] = isNaN(n[i] = +t1(e1[i], i, e1)) ? 0 : +a(e1[i], i, e1);
                        }
                    }
                    return "function" != typeof t1 && (t1 = i(null == t1 ? 0 : +t1)), o.initialize = function(t1) {
                        e1 = t1, s();
                    }, o.strength = function(t1) {
                        return arguments.length ? (a = "function" == typeof t1 ? t1 : i(+t1), s(), o) : a;
                    }, o.y = function(e1) {
                        return arguments.length ? (t1 = "function" == typeof e1 ? e1 : i(+e1), s(), o) : t1;
                    }, o;
                }
            },
            36464: function(t1, e1, r) {
                "use strict";
                function n(t1, e1) {
                    if ((r = (t1 = e1 ? t1.toExponential(e1 - 1) : t1.toExponential()).indexOf("e")) < 0) return null;
                    var r, n = t1.slice(0, r);
                    return [
                        n.length > 1 ? n[0] + n.slice(2) : n,
                        +t1.slice(r + 1)
                    ];
                }
                r.d(e1, {
                    GP: function() {
                        return f;
                    },
                    OE: function() {
                        return m;
                    }
                });
                var i, a = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
                function o(t1) {
                    if (!(e1 = a.exec(t1))) throw new Error("invalid format: " + t1);
                    var e1;
                    return new s({
                        fill: e1[1],
                        align: e1[2],
                        sign: e1[3],
                        symbol: e1[4],
                        zero: e1[5],
                        width: e1[6],
                        comma: e1[7],
                        precision: e1[8] && e1[8].slice(1),
                        trim: e1[9],
                        type: e1[10]
                    });
                }
                function s(t1) {
                    this.fill = void 0 === t1.fill ? " " : t1.fill + "", this.align = void 0 === t1.align ? ">" : t1.align + "", this.sign = void 0 === t1.sign ? "-" : t1.sign + "", this.symbol = void 0 === t1.symbol ? "" : t1.symbol + "", this.zero = !!t1.zero, this.width = void 0 === t1.width ? void 0 : +t1.width, this.comma = !!t1.comma, this.precision = void 0 === t1.precision ? void 0 : +t1.precision, this.trim = !!t1.trim, this.type = void 0 === t1.type ? "" : t1.type + "";
                }
                function l(t1, e1) {
                    var r = n(t1, e1);
                    if (!r) return t1 + "";
                    var i = r[0], a = r[1];
                    return a < 0 ? "0." + new Array(-a).join("0") + i : i.length > a + 1 ? i.slice(0, a + 1) + "." + i.slice(a + 1) : i + new Array(a - i.length + 2).join("0");
                }
                o.prototype = s.prototype, s.prototype.toString = function() {
                    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (void 0 === this.width ? "" : Math.max(1, 0 | this.width)) + (this.comma ? "," : "") + (void 0 === this.precision ? "" : "." + Math.max(0, 0 | this.precision)) + (this.trim ? "~" : "") + this.type;
                };
                var c = {
                    "%": function(t1, e1) {
                        return (100 * t1).toFixed(e1);
                    },
                    b: function(t1) {
                        return Math.round(t1).toString(2);
                    },
                    c: function(t1) {
                        return t1 + "";
                    },
                    d: function(t1) {
                        return Math.abs(t1 = Math.round(t1)) >= 1e21 ? t1.toLocaleString("en").replace(/,/g, "") : t1.toString(10);
                    },
                    e: function(t1, e1) {
                        return t1.toExponential(e1);
                    },
                    f: function(t1, e1) {
                        return t1.toFixed(e1);
                    },
                    g: function(t1, e1) {
                        return t1.toPrecision(e1);
                    },
                    o: function(t1) {
                        return Math.round(t1).toString(8);
                    },
                    p: function(t1, e1) {
                        return l(100 * t1, e1);
                    },
                    r: l,
                    s: function(t1, e1) {
                        var r = n(t1, e1);
                        if (!r) return t1 + "";
                        var a = r[0], o = r[1], s = o - (i = 3 * Math.max(-8, Math.min(8, Math.floor(o / 3)))) + 1, l = a.length;
                        return s === l ? a : s > l ? a + new Array(s - l + 1).join("0") : s > 0 ? a.slice(0, s) + "." + a.slice(s) : "0." + new Array(1 - s).join("0") + n(t1, Math.max(0, e1 + s - 1))[0];
                    },
                    X: function(t1) {
                        return Math.round(t1).toString(16).toUpperCase();
                    },
                    x: function(t1) {
                        return Math.round(t1).toString(16);
                    }
                };
                function u(t1) {
                    return t1;
                }
                var h, f, p = Array.prototype.map, d = [
                    "y",
                    "z",
                    "a",
                    "f",
                    "p",
                    "n",
                    "\xb5",
                    "m",
                    "",
                    "k",
                    "M",
                    "G",
                    "T",
                    "P",
                    "E",
                    "Z",
                    "Y"
                ];
                function m(t1) {
                    var e1, r, a = void 0 === t1.grouping || void 0 === t1.thousands ? u : (e1 = p.call(t1.grouping, Number), r = t1.thousands + "", function(t1, n) {
                        for(var i = t1.length, a = [], o = 0, s = e1[0], l = 0; i > 0 && s > 0 && (l + s + 1 > n && (s = Math.max(1, n - l)), a.push(t1.substring(i -= s, i + s)), !((l += s + 1) > n));)s = e1[o = (o + 1) % e1.length];
                        return a.reverse().join(r);
                    }), s = void 0 === t1.currency ? "" : t1.currency[0] + "", l = void 0 === t1.currency ? "" : t1.currency[1] + "", h = void 0 === t1.decimal ? "." : t1.decimal + "", f = void 0 === t1.numerals ? u : function(t1) {
                        return function(e1) {
                            return e1.replace(/[0-9]/g, function(e1) {
                                return t1[+e1];
                            });
                        };
                    }(p.call(t1.numerals, String)), m = void 0 === t1.percent ? "%" : t1.percent + "", g = void 0 === t1.minus ? "-" : t1.minus + "", y = void 0 === t1.nan ? "NaN" : t1.nan + "";
                    function v(t1) {
                        var e1 = (t1 = o(t1)).fill, r = t1.align, n = t1.sign, u = t1.symbol, p = t1.zero, v = t1.width, x = t1.comma, _ = t1.precision, b = t1.trim, w = t1.type;
                        "n" === w ? (x = !0, w = "g") : c[w] || (void 0 === _ && (_ = 12), b = !0, w = "g"), (p || "0" === e1 && "=" === r) && (p = !0, e1 = "0", r = "=");
                        var T = "$" === u ? s : "#" === u && /[boxX]/.test(w) ? "0" + w.toLowerCase() : "", k = "$" === u ? l : /[%p]/.test(w) ? m : "", A = c[w], M = /[defgprs%]/.test(w);
                        function S(t1) {
                            var o, s, l, c = T, u = k;
                            if ("c" === w) u = A(t1) + u, t1 = "";
                            else {
                                var m = (t1 = +t1) < 0 || 1 / t1 < 0;
                                if (t1 = isNaN(t1) ? y : A(Math.abs(t1), _), b && (t1 = function(t1) {
                                    t: for(var e1, r = t1.length, n = 1, i = -1; n < r; ++n)switch(t1[n]){
                                        case ".":
                                            i = e1 = n;
                                            break;
                                        case "0":
                                            0 === i && (i = n), e1 = n;
                                            break;
                                        default:
                                            if (!+t1[n]) break t;
                                            i > 0 && (i = 0);
                                    }
                                    return i > 0 ? t1.slice(0, i) + t1.slice(e1 + 1) : t1;
                                }(t1)), m && 0 == +t1 && "+" !== n && (m = !1), c = (m ? "(" === n ? n : g : "-" === n || "(" === n ? "" : n) + c, u = ("s" === w ? d[8 + i / 3] : "") + u + (m && "(" === n ? ")" : ""), M) {
                                    for(o = -1, s = t1.length; ++o < s;)if (48 > (l = t1.charCodeAt(o)) || l > 57) {
                                        u = (46 === l ? h + t1.slice(o + 1) : t1.slice(o)) + u, t1 = t1.slice(0, o);
                                        break;
                                    }
                                }
                            }
                            x && !p && (t1 = a(t1, 1 / 0));
                            var S = c.length + t1.length + u.length, E = S < v ? new Array(v - S + 1).join(e1) : "";
                            switch(x && p && (t1 = a(E + t1, E.length ? v - u.length : 1 / 0), E = ""), r){
                                case "<":
                                    t1 = c + t1 + u + E;
                                    break;
                                case "=":
                                    t1 = c + E + t1 + u;
                                    break;
                                case "^":
                                    t1 = E.slice(0, S = E.length >> 1) + c + t1 + u + E.slice(S);
                                    break;
                                default:
                                    t1 = E + c + t1 + u;
                            }
                            return f(t1);
                        }
                        return _ = void 0 === _ ? 6 : /[gprs]/.test(w) ? Math.max(1, Math.min(21, _)) : Math.max(0, Math.min(20, _)), S.toString = function() {
                            return t1 + "";
                        }, S;
                    }
                    return {
                        format: v,
                        formatPrefix: function(t1, e1) {
                            var r, i = v(((t1 = o(t1)).type = "f", t1)), a = 3 * Math.max(-8, Math.min(8, Math.floor((r = e1, ((r = n(Math.abs(r))) ? r[1] : NaN) / 3)))), s = Math.pow(10, -a), l = d[8 + a / 3];
                            return function(t1) {
                                return i(s * t1) + l;
                            };
                        }
                    };
                }
                h = m({
                    decimal: ".",
                    thousands: ",",
                    grouping: [
                        3
                    ],
                    currency: [
                        "$",
                        ""
                    ],
                    minus: "-"
                }), f = h.format, h.formatPrefix;
            },
            75987: function(t1, e1, r) {
                "use strict";
                r.r(e1), r.d(e1, {
                    geoAiry: function() {
                        return D;
                    },
                    geoAiryRaw: function() {
                        return O;
                    },
                    geoAitoff: function() {
                        return F;
                    },
                    geoAitoffRaw: function() {
                        return R;
                    },
                    geoArmadillo: function() {
                        return N;
                    },
                    geoArmadilloRaw: function() {
                        return B;
                    },
                    geoAugust: function() {
                        return U;
                    },
                    geoAugustRaw: function() {
                        return j;
                    },
                    geoBaker: function() {
                        return G;
                    },
                    geoBakerRaw: function() {
                        return H;
                    },
                    geoBerghaus: function() {
                        return Y;
                    },
                    geoBerghausRaw: function() {
                        return W;
                    },
                    geoBertin1953: function() {
                        return rt;
                    },
                    geoBertin1953Raw: function() {
                        return et;
                    },
                    geoBoggs: function() {
                        return ut;
                    },
                    geoBoggsRaw: function() {
                        return ct;
                    },
                    geoBonne: function() {
                        return mt;
                    },
                    geoBonneRaw: function() {
                        return dt;
                    },
                    geoBottomley: function() {
                        return yt;
                    },
                    geoBottomleyRaw: function() {
                        return gt;
                    },
                    geoBromley: function() {
                        return xt;
                    },
                    geoBromleyRaw: function() {
                        return vt;
                    },
                    geoChamberlin: function() {
                        return Et;
                    },
                    geoChamberlinAfrica: function() {
                        return St;
                    },
                    geoChamberlinRaw: function() {
                        return At;
                    },
                    geoCollignon: function() {
                        return Lt;
                    },
                    geoCollignonRaw: function() {
                        return Ct;
                    },
                    geoCraig: function() {
                        return Pt;
                    },
                    geoCraigRaw: function() {
                        return It;
                    },
                    geoCraster: function() {
                        return Dt;
                    },
                    geoCrasterRaw: function() {
                        return Ot;
                    },
                    geoCylindricalEqualArea: function() {
                        return Ft;
                    },
                    geoCylindricalEqualAreaRaw: function() {
                        return Rt;
                    },
                    geoCylindricalStereographic: function() {
                        return Nt;
                    },
                    geoCylindricalStereographicRaw: function() {
                        return Bt;
                    },
                    geoEckert1: function() {
                        return Ut;
                    },
                    geoEckert1Raw: function() {
                        return jt;
                    },
                    geoEckert2: function() {
                        return qt;
                    },
                    geoEckert2Raw: function() {
                        return Vt;
                    },
                    geoEckert3: function() {
                        return Gt;
                    },
                    geoEckert3Raw: function() {
                        return Ht;
                    },
                    geoEckert4: function() {
                        return Wt;
                    },
                    geoEckert4Raw: function() {
                        return Zt;
                    },
                    geoEckert5: function() {
                        return Xt;
                    },
                    geoEckert5Raw: function() {
                        return Yt;
                    },
                    geoEckert6: function() {
                        return Jt;
                    },
                    geoEckert6Raw: function() {
                        return $t;
                    },
                    geoEisenlohr: function() {
                        return te;
                    },
                    geoEisenlohrRaw: function() {
                        return Qt;
                    },
                    geoFahey: function() {
                        return ne;
                    },
                    geoFaheyRaw: function() {
                        return re;
                    },
                    geoFoucaut: function() {
                        return ae;
                    },
                    geoFoucautRaw: function() {
                        return ie;
                    },
                    geoFoucautSinusoidal: function() {
                        return se;
                    },
                    geoFoucautSinusoidalRaw: function() {
                        return oe;
                    },
                    geoGilbert: function() {
                        return fe;
                    },
                    geoGingery: function() {
                        return ge;
                    },
                    geoGingeryRaw: function() {
                        return pe;
                    },
                    geoGinzburg4: function() {
                        return xe;
                    },
                    geoGinzburg4Raw: function() {
                        return ve;
                    },
                    geoGinzburg5: function() {
                        return be;
                    },
                    geoGinzburg5Raw: function() {
                        return _e;
                    },
                    geoGinzburg6: function() {
                        return Te;
                    },
                    geoGinzburg6Raw: function() {
                        return we;
                    },
                    geoGinzburg8: function() {
                        return Ae;
                    },
                    geoGinzburg8Raw: function() {
                        return ke;
                    },
                    geoGinzburg9: function() {
                        return Se;
                    },
                    geoGinzburg9Raw: function() {
                        return Me;
                    },
                    geoGringorten: function() {
                        return Le;
                    },
                    geoGringortenQuincuncial: function() {
                        return ii;
                    },
                    geoGringortenRaw: function() {
                        return Ce;
                    },
                    geoGuyou: function() {
                        return Oe;
                    },
                    geoGuyouRaw: function() {
                        return ze;
                    },
                    geoHammer: function() {
                        return K;
                    },
                    geoHammerRaw: function() {
                        return $;
                    },
                    geoHammerRetroazimuthal: function() {
                        return Be;
                    },
                    geoHammerRetroazimuthalRaw: function() {
                        return Re;
                    },
                    geoHealpix: function() {
                        return We;
                    },
                    geoHealpixRaw: function() {
                        return qe;
                    },
                    geoHill: function() {
                        return Xe;
                    },
                    geoHillRaw: function() {
                        return Ye;
                    },
                    geoHomolosine: function() {
                        return er;
                    },
                    geoHomolosineRaw: function() {
                        return tr;
                    },
                    geoHufnagel: function() {
                        return nr;
                    },
                    geoHufnagelRaw: function() {
                        return rr;
                    },
                    geoHyperelliptical: function() {
                        return sr;
                    },
                    geoHyperellipticalRaw: function() {
                        return or;
                    },
                    geoInterrupt: function() {
                        return ur;
                    },
                    geoInterruptedBoggs: function() {
                        return fr;
                    },
                    geoInterruptedHomolosine: function() {
                        return dr;
                    },
                    geoInterruptedMollweide: function() {
                        return gr;
                    },
                    geoInterruptedMollweideHemispheres: function() {
                        return vr;
                    },
                    geoInterruptedQuarticAuthalic: function() {
                        return hn;
                    },
                    geoInterruptedSinuMollweide: function() {
                        return _r;
                    },
                    geoInterruptedSinusoidal: function() {
                        return wr;
                    },
                    geoKavrayskiy7: function() {
                        return kr;
                    },
                    geoKavrayskiy7Raw: function() {
                        return Tr;
                    },
                    geoLagrange: function() {
                        return Mr;
                    },
                    geoLagrangeRaw: function() {
                        return Ar;
                    },
                    geoLarrivee: function() {
                        return Cr;
                    },
                    geoLarriveeRaw: function() {
                        return Er;
                    },
                    geoLaskowski: function() {
                        return Ir;
                    },
                    geoLaskowskiRaw: function() {
                        return Lr;
                    },
                    geoLittrow: function() {
                        return zr;
                    },
                    geoLittrowRaw: function() {
                        return Pr;
                    },
                    geoLoximuthal: function() {
                        return Dr;
                    },
                    geoLoximuthalRaw: function() {
                        return Or;
                    },
                    geoMiller: function() {
                        return Fr;
                    },
                    geoMillerRaw: function() {
                        return Rr;
                    },
                    geoModifiedStereographic: function() {
                        return Xr;
                    },
                    geoModifiedStereographicAlaska: function() {
                        return Hr;
                    },
                    geoModifiedStereographicGs48: function() {
                        return Gr;
                    },
                    geoModifiedStereographicGs50: function() {
                        return Zr;
                    },
                    geoModifiedStereographicLee: function() {
                        return Yr;
                    },
                    geoModifiedStereographicMiller: function() {
                        return Wr;
                    },
                    geoModifiedStereographicRaw: function() {
                        return Br;
                    },
                    geoMollweide: function() {
                        return ot;
                    },
                    geoMollweideRaw: function() {
                        return at;
                    },
                    geoMtFlatPolarParabolic: function() {
                        return Qr;
                    },
                    geoMtFlatPolarParabolicRaw: function() {
                        return Kr;
                    },
                    geoMtFlatPolarQuartic: function() {
                        return en;
                    },
                    geoMtFlatPolarQuarticRaw: function() {
                        return tn;
                    },
                    geoMtFlatPolarSinusoidal: function() {
                        return nn;
                    },
                    geoMtFlatPolarSinusoidalRaw: function() {
                        return rn;
                    },
                    geoNaturalEarth: function() {
                        return an.A;
                    },
                    geoNaturalEarth2: function() {
                        return sn;
                    },
                    geoNaturalEarth2Raw: function() {
                        return on;
                    },
                    geoNaturalEarthRaw: function() {
                        return an.P;
                    },
                    geoNellHammer: function() {
                        return cn;
                    },
                    geoNellHammerRaw: function() {
                        return ln;
                    },
                    geoNicolosi: function() {
                        return pn;
                    },
                    geoNicolosiRaw: function() {
                        return fn;
                    },
                    geoPatterson: function() {
                        return kn;
                    },
                    geoPattersonRaw: function() {
                        return Tn;
                    },
                    geoPeirceQuincuncial: function() {
                        return ai;
                    },
                    geoPierceQuincuncial: function() {
                        return ai;
                    },
                    geoPolyconic: function() {
                        return Mn;
                    },
                    geoPolyconicRaw: function() {
                        return An;
                    },
                    geoPolyhedral: function() {
                        return Pn;
                    },
                    geoPolyhedralButterfly: function() {
                        return Nn;
                    },
                    geoPolyhedralCollignon: function() {
                        return Vn;
                    },
                    geoPolyhedralWaterman: function() {
                        return qn;
                    },
                    geoProject: function() {
                        return Yn;
                    },
                    geoQuantize: function() {
                        return oi;
                    },
                    geoQuincuncial: function() {
                        return ni;
                    },
                    geoRectangularPolyconic: function() {
                        return li;
                    },
                    geoRectangularPolyconicRaw: function() {
                        return si;
                    },
                    geoRobinson: function() {
                        return hi;
                    },
                    geoRobinsonRaw: function() {
                        return ui;
                    },
                    geoSatellite: function() {
                        return pi;
                    },
                    geoSatelliteRaw: function() {
                        return fi;
                    },
                    geoSinuMollweide: function() {
                        return Qe;
                    },
                    geoSinuMollweideRaw: function() {
                        return Ke;
                    },
                    geoSinusoidal: function() {
                        return pt;
                    },
                    geoSinusoidalRaw: function() {
                        return ft;
                    },
                    geoStitch: function() {
                        return Pi;
                    },
                    geoTimes: function() {
                        return Oi;
                    },
                    geoTimesRaw: function() {
                        return zi;
                    },
                    geoTwoPointAzimuthal: function() {
                        return Bi;
                    },
                    geoTwoPointAzimuthalRaw: function() {
                        return Ri;
                    },
                    geoTwoPointAzimuthalUsa: function() {
                        return Fi;
                    },
                    geoTwoPointEquidistant: function() {
                        return Ui;
                    },
                    geoTwoPointEquidistantRaw: function() {
                        return Ni;
                    },
                    geoTwoPointEquidistantUsa: function() {
                        return ji;
                    },
                    geoVanDerGrinten: function() {
                        return qi;
                    },
                    geoVanDerGrinten2: function() {
                        return Gi;
                    },
                    geoVanDerGrinten2Raw: function() {
                        return Hi;
                    },
                    geoVanDerGrinten3: function() {
                        return Wi;
                    },
                    geoVanDerGrinten3Raw: function() {
                        return Zi;
                    },
                    geoVanDerGrinten4: function() {
                        return Xi;
                    },
                    geoVanDerGrinten4Raw: function() {
                        return Yi;
                    },
                    geoVanDerGrintenRaw: function() {
                        return Vi;
                    },
                    geoWagner: function() {
                        return Ji;
                    },
                    geoWagner4: function() {
                        return ra;
                    },
                    geoWagner4Raw: function() {
                        return ea;
                    },
                    geoWagner6: function() {
                        return ia;
                    },
                    geoWagner6Raw: function() {
                        return na;
                    },
                    geoWagner7: function() {
                        return Ki;
                    },
                    geoWagnerRaw: function() {
                        return $i;
                    },
                    geoWiechel: function() {
                        return oa;
                    },
                    geoWiechelRaw: function() {
                        return aa;
                    },
                    geoWinkel3: function() {
                        return la;
                    },
                    geoWinkel3Raw: function() {
                        return sa;
                    }
                });
                var n = r(94684), i = Math.abs, a = Math.atan, o = Math.atan2, s = (Math.ceil, Math.cos), l = Math.exp, c = Math.floor, u = Math.log, h = Math.max, f = Math.min, p = Math.pow, d = Math.round, m = Math.sign || function(t1) {
                    return t1 > 0 ? 1 : t1 < 0 ? -1 : 0;
                }, g = Math.sin, y = Math.tan, v = 1e-6, x = 1e-12, _ = Math.PI, b = _ / 2, w = _ / 4, T = Math.SQRT1_2, k = I(2), A = I(_), M = 2 * _, S = 180 / _, E = _ / 180;
                function C(t1) {
                    return t1 > 1 ? b : t1 < -1 ? -b : Math.asin(t1);
                }
                function L(t1) {
                    return t1 > 1 ? 0 : t1 < -1 ? _ : Math.acos(t1);
                }
                function I(t1) {
                    return t1 > 0 ? Math.sqrt(t1) : 0;
                }
                function P(t1) {
                    return (l(t1) - l(-t1)) / 2;
                }
                function z(t1) {
                    return (l(t1) + l(-t1)) / 2;
                }
                function O(t1) {
                    var e1 = y(t1 / 2), r = 2 * u(s(t1 / 2)) / (e1 * e1);
                    function n(t1, e1) {
                        var n = s(t1), i = s(e1), a = g(e1), o = i * n, l = -((1 - o ? u((1 + o) / 2) / (1 - o) : -0.5) + r / (1 + o));
                        return [
                            l * i * g(t1),
                            l * a
                        ];
                    }
                    return n.invert = function(e1, n) {
                        var a, l = I(e1 * e1 + n * n), c = -t1 / 2, h = 50;
                        if (!l) return [
                            0,
                            0
                        ];
                        do {
                            var f = c / 2, p = s(f), d = g(f), m = d / p, y = -u(i(p));
                            c -= a = (2 / m * y - r * m - l) / (-y / (d * d) + 1 - r / (2 * p * p)) * (p < 0 ? .7 : 1);
                        }while (i(a) > v && --h > 0);
                        var x = g(c);
                        return [
                            o(e1 * x, l * s(c)),
                            C(n * x / l)
                        ];
                    }, n;
                }
                function D() {
                    var t1 = b, e1 = (0, n.U)(O), r = e1(t1);
                    return r.radius = function(r) {
                        return arguments.length ? e1(t1 = r * E) : t1 * S;
                    }, r.scale(179.976).clipAngle(147);
                }
                function R(t1, e1) {
                    var r = s(e1), n = function(t1) {
                        return t1 ? t1 / Math.sin(t1) : 1;
                    }(L(r * s(t1 /= 2)));
                    return [
                        2 * r * g(t1) * n,
                        g(e1) * n
                    ];
                }
                function F() {
                    return (0, n.A)(R).scale(152.63);
                }
                function B(t1) {
                    var e1 = g(t1), r = s(t1), n = t1 >= 0 ? 1 : -1, a = y(n * t1), l = (1 + e1 - r) / 2;
                    function c(t1, i) {
                        var c = s(i), u = s(t1 /= 2);
                        return [
                            (1 + c) * g(t1),
                            (n * i > -o(u, a) - .001 ? 0 : 10 * -n) + l + g(i) * r - (1 + c) * e1 * u
                        ];
                    }
                    return c.invert = function(t1, c) {
                        var u = 0, h = 0, f = 50;
                        do {
                            var p = s(u), d = g(u), m = s(h), y = g(h), x = 1 + m, _ = x * d - t1, b = l + y * r - x * e1 * p - c, w = x * p / 2, T = -d * y, k = e1 * x * d / 2, A = r * m + e1 * p * y, M = T * k - A * w, S = (b * T - _ * A) / M / 2, E = (_ * k - b * w) / M;
                            i(E) > 2 && (E /= 2), u -= S, h -= E;
                        }while ((i(S) > v || i(E) > v) && --f > 0);
                        return n * h > -o(s(u), a) - .001 ? [
                            2 * u,
                            h
                        ] : null;
                    }, c;
                }
                function N() {
                    var t1 = 20 * E, e1 = t1 >= 0 ? 1 : -1, r = y(e1 * t1), i = (0, n.U)(B), a = i(t1), l = a.stream;
                    return a.parallel = function(n) {
                        return arguments.length ? (r = y((e1 = (t1 = n * E) >= 0 ? 1 : -1) * t1), i(t1)) : t1 * S;
                    }, a.stream = function(n) {
                        var i = a.rotate(), c = l(n), u = (a.rotate([
                            0,
                            0
                        ]), l(n)), h = a.precision();
                        return a.rotate(i), c.sphere = function() {
                            u.polygonStart(), u.lineStart();
                            for(var n = -180 * e1; e1 * n < 180; n += 90 * e1)u.point(n, 90 * e1);
                            if (t1) for(; e1 * (n -= 3 * e1 * h) >= -180;)u.point(n, e1 * -o(s(n * E / 2), r) * S);
                            u.lineEnd(), u.polygonEnd();
                        }, c;
                    }, a.scale(218.695).center([
                        0,
                        28.0974
                    ]);
                }
                function j(t1, e1) {
                    var r = y(e1 / 2), n = I(1 - r * r), i = 1 + n * s(t1 /= 2), a = g(t1) * n / i, o = r / i, l = a * a, c = o * o;
                    return [
                        4 / 3 * a * (3 + l - 3 * c),
                        4 / 3 * o * (3 + 3 * l - c)
                    ];
                }
                function U() {
                    return (0, n.A)(j).scale(66.1603);
                }
                R.invert = function(t1, e1) {
                    if (!(t1 * t1 + 4 * e1 * e1 > _ * _ + v)) {
                        var r = t1, n = e1, a = 25;
                        do {
                            var o, l = g(r), c = g(r / 2), u = s(r / 2), h = g(n), f = s(n), p = g(2 * n), d = h * h, m = f * f, y = c * c, x = 1 - m * u * u, b = x ? L(f * u) * I(o = 1 / x) : o = 0, w = 2 * b * f * c - t1, T = b * h - e1, k = o * (m * y + b * f * u * d), A = o * (.5 * l * p - 2 * b * h * c), M = .25 * o * (p * c - b * h * m * l), S = o * (d * u + b * y * f), E = A * M - S * k;
                            if (!E) break;
                            var C = (T * A - w * S) / E, P = (w * M - T * k) / E;
                            r -= C, n -= P;
                        }while ((i(C) > v || i(P) > v) && --a > 0);
                        return [
                            r,
                            n
                        ];
                    }
                }, j.invert = function(t1, e1) {
                    if (e1 *= 3 / 8, !(t1 *= 3 / 8) && i(e1) > 1) return null;
                    var r = 1 + t1 * t1 + e1 * e1, n = I((r - I(r * r - 4 * e1 * e1)) / 2), a = C(n) / 3, l = n ? function(t1) {
                        return u(t1 + I(t1 * t1 - 1));
                    }(i(e1 / n)) / 3 : function(t1) {
                        return u(t1 + I(t1 * t1 + 1));
                    }(i(t1)) / 3, c = s(a), h = z(l), f = h * h - c * c;
                    return [
                        2 * m(t1) * o(P(l) * c, .25 - f),
                        2 * m(e1) * o(h * g(a), .25 + f)
                    ];
                };
                var V = I(8), q = u(1 + k);
                function H(t1, e1) {
                    var r = i(e1);
                    return r < w ? [
                        t1,
                        u(y(w + e1 / 2))
                    ] : [
                        t1 * s(r) * (2 * k - 1 / g(r)),
                        m(e1) * (2 * k * (r - w) - u(y(r / 2)))
                    ];
                }
                function G() {
                    return (0, n.A)(H).scale(112.314);
                }
                H.invert = function(t1, e1) {
                    if ((n = i(e1)) < q) return [
                        t1,
                        2 * a(l(e1)) - b
                    ];
                    var r, n, o = w, c = 25;
                    do {
                        var h = s(o / 2), f = y(o / 2);
                        o -= r = (V * (o - w) - u(f) - n) / (V - h * h / (2 * f));
                    }while (i(r) > x && --c > 0);
                    return [
                        t1 / (s(o) * (V - 1 / g(o))),
                        m(e1) * o
                    ];
                };
                var Z = r(61957);
                function W(t1) {
                    var e1 = 2 * _ / t1;
                    function r(t1, r) {
                        var n = (0, Z.j)(t1, r);
                        if (i(t1) > b) {
                            var a = o(n[1], n[0]), l = I(n[0] * n[0] + n[1] * n[1]), c = e1 * d((a - b) / e1) + b, u = o(g(a -= c), 2 - s(a));
                            a = c + C(_ / l * g(u)) - u, n[0] = l * s(a), n[1] = l * g(a);
                        }
                        return n;
                    }
                    return r.invert = function(t1, r) {
                        var n = I(t1 * t1 + r * r);
                        if (n > b) {
                            var i = o(r, t1), l = e1 * d((i - b) / e1) + b, c = i > l ? -1 : 1, u = n * s(l - i), h = 1 / y(c * L((u - _) / I(_ * (_ - 2 * u) + n * n)));
                            i = l + 2 * a((h + c * I(h * h - 3)) / 3), t1 = n * s(i), r = n * g(i);
                        }
                        return Z.j.invert(t1, r);
                    }, r;
                }
                function Y() {
                    var t1 = 5, e1 = (0, n.U)(W), r = e1(t1), i = r.stream, a = .01, l = -s(a * E), c = g(a * E);
                    return r.lobes = function(r) {
                        return arguments.length ? e1(t1 = +r) : t1;
                    }, r.stream = function(e1) {
                        var n = r.rotate(), u = i(e1), h = (r.rotate([
                            0,
                            0
                        ]), i(e1));
                        return r.rotate(n), u.sphere = function() {
                            h.polygonStart(), h.lineStart();
                            for(var e1 = 0, r = 360 / t1, n = 2 * _ / t1, i = 90 - 180 / t1, u = b; e1 < t1; ++e1, i -= r, u -= n)h.point(o(c * s(u), l) * S, C(c * g(u)) * S), i < -90 ? (h.point(-90, -180 - i - a), h.point(-90, -180 - i + a)) : (h.point(90, i + a), h.point(90, i - a));
                            h.lineEnd(), h.polygonEnd();
                        }, u;
                    }, r.scale(87.8076).center([
                        0,
                        17.1875
                    ]).clipAngle(179.999);
                }
                var X = r(30729);
                function $(t1, e1) {
                    if (arguments.length < 2 && (e1 = t1), 1 === e1) return X.n;
                    if (e1 === 1 / 0) return J;
                    function r(r, n) {
                        var i = (0, X.n)(r / e1, n);
                        return i[0] *= t1, i;
                    }
                    return r.invert = function(r, n) {
                        var i = X.n.invert(r / t1, n);
                        return i[0] *= e1, i;
                    }, r;
                }
                function J(t1, e1) {
                    return [
                        t1 * s(e1) / s(e1 /= 2),
                        2 * g(e1)
                    ];
                }
                function K() {
                    var t1 = 2, e1 = (0, n.U)($), r = e1(t1);
                    return r.coefficient = function(r) {
                        return arguments.length ? e1(t1 = +r) : t1;
                    }, r.scale(169.529);
                }
                function Q(t1, e1, r) {
                    var n, a, o, s = 100;
                    r = void 0 === r ? 0 : +r, e1 = +e1;
                    do (a = t1(r)) === (o = t1(r + v)) && (o = a + v), r -= n = -1 * v * (a - e1) / (a - o);
                    while (s-- > 0 && i(n) > v);
                    return s < 0 ? NaN : r;
                }
                function tt(t1, e1, r) {
                    return void 0 === e1 && (e1 = 40), void 0 === r && (r = x), function(n, a, o, s) {
                        var l, c, u;
                        o = void 0 === o ? 0 : +o, s = void 0 === s ? 0 : +s;
                        for(var h = 0; h < e1; h++){
                            var f = t1(o, s), p = f[0] - n, d = f[1] - a;
                            if (i(p) < r && i(d) < r) break;
                            var m = p * p + d * d;
                            if (m > l) o -= c /= 2, s -= u /= 2;
                            else {
                                l = m;
                                var g = (o > 0 ? -1 : 1) * r, y = (s > 0 ? -1 : 1) * r, v = t1(o + g, s), x = t1(o, s + y), _ = (v[0] - f[0]) / g, b = (v[1] - f[1]) / g, w = (x[0] - f[0]) / y, T = (x[1] - f[1]) / y, k = T * _ - b * w, A = (i(k) < .5 ? .5 : 1) / k;
                                if (o += c = (d * w - p * T) * A, s += u = (p * b - d * _) * A, i(c) < r && i(u) < r) break;
                            }
                        }
                        return [
                            o,
                            s
                        ];
                    };
                }
                function et() {
                    var t1 = $(1.68, 2);
                    function e1(e1, r) {
                        if (e1 + r < -1.4) {
                            var n = (e1 - r + 1.6) * (e1 + r + 1.4) / 8;
                            e1 += n, r -= .8 * n * g(r + _ / 2);
                        }
                        var i = t1(e1, r), a = (1 - s(e1 * r)) / 12;
                        return i[1] < 0 && (i[0] *= 1 + a), i[1] > 0 && (i[1] *= 1 + a / 1.5 * i[0] * i[0]), i;
                    }
                    return e1.invert = tt(e1), e1;
                }
                function rt() {
                    return (0, n.A)(et()).rotate([
                        -16.5,
                        -42
                    ]).scale(176.57).center([
                        7.93,
                        .09
                    ]);
                }
                function nt(t1, e1) {
                    var r, n = t1 * g(e1), a = 30;
                    do e1 -= r = (e1 + g(e1) - n) / (1 + s(e1));
                    while (i(r) > v && --a > 0);
                    return e1 / 2;
                }
                function it(t1, e1, r) {
                    function n(n, i) {
                        return [
                            t1 * n * s(i = nt(r, i)),
                            e1 * g(i)
                        ];
                    }
                    return n.invert = function(n, i) {
                        return i = C(i / e1), [
                            n / (t1 * s(i)),
                            C((2 * i + g(2 * i)) / r)
                        ];
                    }, n;
                }
                J.invert = function(t1, e1) {
                    var r = 2 * C(e1 / 2);
                    return [
                        t1 * s(r / 2) / s(r),
                        r
                    ];
                };
                var at = it(k / b, k, _);
                function ot() {
                    return (0, n.A)(at).scale(169.529);
                }
                var st = 2.00276, lt = 1.11072;
                function ct(t1, e1) {
                    var r = nt(_, e1);
                    return [
                        st * t1 / (1 / s(e1) + lt / s(r)),
                        (e1 + k * g(r)) / st
                    ];
                }
                function ut() {
                    return (0, n.A)(ct).scale(160.857);
                }
                function ht(t1) {
                    var e1 = 0, r = (0, n.U)(t1), i = r(e1);
                    return i.parallel = function(t1) {
                        return arguments.length ? r(e1 = t1 * E) : e1 * S;
                    }, i;
                }
                function ft(t1, e1) {
                    return [
                        t1 * s(e1),
                        e1
                    ];
                }
                function pt() {
                    return (0, n.A)(ft).scale(152.63);
                }
                function dt(t1) {
                    if (!t1) return ft;
                    var e1 = 1 / y(t1);
                    function r(r, n) {
                        var i = e1 + t1 - n, a = i ? r * s(n) / i : i;
                        return [
                            i * g(a),
                            e1 - i * s(a)
                        ];
                    }
                    return r.invert = function(r, n) {
                        var i = I(r * r + (n = e1 - n) * n), a = e1 + t1 - i;
                        return [
                            i / s(a) * o(r, n),
                            a
                        ];
                    }, r;
                }
                function mt() {
                    return ht(dt).scale(123.082).center([
                        0,
                        26.1441
                    ]).parallel(45);
                }
                function gt(t1) {
                    function e1(e1, r) {
                        var n = b - r, i = n ? e1 * t1 * g(n) / n : n;
                        return [
                            n * g(i) / t1,
                            b - n * s(i)
                        ];
                    }
                    return e1.invert = function(e1, r) {
                        var n = e1 * t1, i = b - r, a = I(n * n + i * i), s = o(n, i);
                        return [
                            (a ? a / g(a) : 1) * s / t1,
                            b - a
                        ];
                    }, e1;
                }
                function yt() {
                    var t1 = .5, e1 = (0, n.U)(gt), r = e1(t1);
                    return r.fraction = function(r) {
                        return arguments.length ? e1(t1 = +r) : t1;
                    }, r.scale(158.837);
                }
                ct.invert = function(t1, e1) {
                    var r, n, a = st * e1, o = e1 < 0 ? -w : w, l = 25;
                    do n = a - k * g(o), o -= r = (g(2 * o) + 2 * o - _ * g(n)) / (2 * s(2 * o) + 2 + _ * s(n) * k * s(o));
                    while (i(r) > v && --l > 0);
                    return n = a - k * g(o), [
                        t1 * (1 / s(n) + lt / s(o)) / st,
                        n
                    ];
                }, ft.invert = function(t1, e1) {
                    return [
                        t1 / s(e1),
                        e1
                    ];
                };
                var vt = it(1, 4 / _, _);
                function xt() {
                    return (0, n.A)(vt).scale(152.63);
                }
                var _t = r(30021), bt = r(30915);
                function wt(t1, e1, r, n, a, l) {
                    var c, u = s(l);
                    if (i(t1) > 1 || i(l) > 1) c = L(r * a + e1 * n * u);
                    else {
                        var h = g(t1 / 2), f = g(l / 2);
                        c = 2 * C(I(h * h + e1 * n * f * f));
                    }
                    return i(c) > v ? [
                        c,
                        o(n * g(l), e1 * a - r * n * u)
                    ] : [
                        0,
                        0
                    ];
                }
                function Tt(t1, e1, r) {
                    return L((t1 * t1 + e1 * e1 - r * r) / (2 * t1 * e1));
                }
                function kt(t1) {
                    return t1 - 2 * _ * c((t1 + _) / (2 * _));
                }
                function At(t1, e1, r) {
                    for(var n, i = [
                        [
                            t1[0],
                            t1[1],
                            g(t1[1]),
                            s(t1[1])
                        ],
                        [
                            e1[0],
                            e1[1],
                            g(e1[1]),
                            s(e1[1])
                        ],
                        [
                            r[0],
                            r[1],
                            g(r[1]),
                            s(r[1])
                        ]
                    ], a = i[2], o = 0; o < 3; ++o, a = n)n = i[o], a.v = wt(n[1] - a[1], a[3], a[2], n[3], n[2], n[0] - a[0]), a.point = [
                        0,
                        0
                    ];
                    var l = Tt(i[0].v[0], i[2].v[0], i[1].v[0]), c = Tt(i[0].v[0], i[1].v[0], i[2].v[0]), u = _ - l;
                    i[2].point[1] = 0, i[0].point[0] = -(i[1].point[0] = i[0].v[0] / 2);
                    var h = [
                        i[2].point[0] = i[0].point[0] + i[2].v[0] * s(l),
                        2 * (i[0].point[1] = i[1].point[1] = i[2].v[0] * g(l))
                    ];
                    return function(t1, e1) {
                        var r, n = g(e1), a = s(e1), o = new Array(3);
                        for(r = 0; r < 3; ++r){
                            var l = i[r];
                            if (o[r] = wt(e1 - l[1], l[3], l[2], a, n, t1 - l[0]), !o[r][0]) return l.point;
                            o[r][1] = kt(o[r][1] - l.v[1]);
                        }
                        var f = h.slice();
                        for(r = 0; r < 3; ++r){
                            var p = 2 == r ? 0 : r + 1, d = Tt(i[r].v[0], o[r][0], o[p][0]);
                            o[r][1] < 0 && (d = -d), r ? 1 == r ? (d = c - d, f[0] -= o[r][0] * s(d), f[1] -= o[r][0] * g(d)) : (d = u - d, f[0] += o[r][0] * s(d), f[1] += o[r][0] * g(d)) : (f[0] += o[r][0] * s(d), f[1] -= o[r][0] * g(d));
                        }
                        return f[0] /= 3, f[1] /= 3, f;
                    };
                }
                function Mt(t1) {
                    return t1[0] *= E, t1[1] *= E, t1;
                }
                function St() {
                    return Et([
                        0,
                        22
                    ], [
                        45,
                        22
                    ], [
                        22.5,
                        -22
                    ]).scale(380).center([
                        22.5,
                        2
                    ]);
                }
                function Et(t1, e1, r) {
                    var i = (0, _t.A)({
                        type: "MultiPoint",
                        coordinates: [
                            t1,
                            e1,
                            r
                        ]
                    }), a = [
                        -i[0],
                        -i[1]
                    ], o = (0, bt.A)(a), s = At(Mt(o(t1)), Mt(o(e1)), Mt(o(r)));
                    s.invert = tt(s);
                    var l = (0, n.A)(s).rotate(a), c = l.center;
                    return delete l.rotate, l.center = function(t1) {
                        return arguments.length ? c(o(t1)) : o.invert(c());
                    }, l.clipAngle(90);
                }
                function Ct(t1, e1) {
                    var r = I(1 - g(e1));
                    return [
                        2 / A * t1 * r,
                        A * (1 - r)
                    ];
                }
                function Lt() {
                    return (0, n.A)(Ct).scale(95.6464).center([
                        0,
                        30
                    ]);
                }
                function It(t1) {
                    var e1 = y(t1);
                    function r(t1, r) {
                        return [
                            t1,
                            (t1 ? t1 / g(t1) : 1) * (g(r) * s(t1) - e1 * s(r))
                        ];
                    }
                    return r.invert = e1 ? function(t1, r) {
                        t1 && (r *= g(t1) / t1);
                        var n = s(t1);
                        return [
                            t1,
                            2 * o(I(n * n + e1 * e1 - r * r) - n, e1 - r)
                        ];
                    } : function(t1, e1) {
                        return [
                            t1,
                            C(t1 ? e1 * y(t1) / t1 : e1)
                        ];
                    }, r;
                }
                function Pt() {
                    return ht(It).scale(249.828).clipAngle(90);
                }
                Ct.invert = function(t1, e1) {
                    var r = (r = e1 / A - 1) * r;
                    return [
                        r > 0 ? t1 * I(_ / r) / 2 : 0,
                        C(1 - r)
                    ];
                };
                var zt = I(3);
                function Ot(t1, e1) {
                    return [
                        zt * t1 * (2 * s(2 * e1 / 3) - 1) / A,
                        zt * A * g(e1 / 3)
                    ];
                }
                function Dt() {
                    return (0, n.A)(Ot).scale(156.19);
                }
                function Rt(t1) {
                    var e1 = s(t1);
                    function r(t1, r) {
                        return [
                            t1 * e1,
                            g(r) / e1
                        ];
                    }
                    return r.invert = function(t1, r) {
                        return [
                            t1 / e1,
                            C(r * e1)
                        ];
                    }, r;
                }
                function Ft() {
                    return ht(Rt).parallel(38.58).scale(195.044);
                }
                function Bt(t1) {
                    var e1 = s(t1);
                    function r(t1, r) {
                        return [
                            t1 * e1,
                            (1 + e1) * y(r / 2)
                        ];
                    }
                    return r.invert = function(t1, r) {
                        return [
                            t1 / e1,
                            2 * a(r / (1 + e1))
                        ];
                    }, r;
                }
                function Nt() {
                    return ht(Bt).scale(124.75);
                }
                function jt(t1, e1) {
                    var r = I(8 / (3 * _));
                    return [
                        r * t1 * (1 - i(e1) / _),
                        r * e1
                    ];
                }
                function Ut() {
                    return (0, n.A)(jt).scale(165.664);
                }
                function Vt(t1, e1) {
                    var r = I(4 - 3 * g(i(e1)));
                    return [
                        2 / I(6 * _) * t1 * r,
                        m(e1) * I(2 * _ / 3) * (2 - r)
                    ];
                }
                function qt() {
                    return (0, n.A)(Vt).scale(165.664);
                }
                function Ht(t1, e1) {
                    var r = I(_ * (4 + _));
                    return [
                        2 / r * t1 * (1 + I(1 - 4 * e1 * e1 / (_ * _))),
                        4 / r * e1
                    ];
                }
                function Gt() {
                    return (0, n.A)(Ht).scale(180.739);
                }
                function Zt(t1, e1) {
                    var r = (2 + b) * g(e1);
                    e1 /= 2;
                    for(var n = 0, a = 1 / 0; n < 10 && i(a) > v; n++){
                        var o = s(e1);
                        e1 -= a = (e1 + g(e1) * (o + 2) - r) / (2 * o * (1 + o));
                    }
                    return [
                        2 / I(_ * (4 + _)) * t1 * (1 + s(e1)),
                        2 * I(_ / (4 + _)) * g(e1)
                    ];
                }
                function Wt() {
                    return (0, n.A)(Zt).scale(180.739);
                }
                function Yt(t1, e1) {
                    return [
                        t1 * (1 + s(e1)) / I(2 + _),
                        2 * e1 / I(2 + _)
                    ];
                }
                function Xt() {
                    return (0, n.A)(Yt).scale(173.044);
                }
                function $t(t1, e1) {
                    for(var r = (1 + b) * g(e1), n = 0, a = 1 / 0; n < 10 && i(a) > v; n++)e1 -= a = (e1 + g(e1) - r) / (1 + s(e1));
                    return r = I(2 + _), [
                        t1 * (1 + s(e1)) / r,
                        2 * e1 / r
                    ];
                }
                function Jt() {
                    return (0, n.A)($t).scale(173.044);
                }
                Ot.invert = function(t1, e1) {
                    var r = 3 * C(e1 / (zt * A));
                    return [
                        A * t1 / (zt * (2 * s(2 * r / 3) - 1)),
                        r
                    ];
                }, jt.invert = function(t1, e1) {
                    var r = I(8 / (3 * _)), n = e1 / r;
                    return [
                        t1 / (r * (1 - i(n) / _)),
                        n
                    ];
                }, Vt.invert = function(t1, e1) {
                    var r = 2 - i(e1) / I(2 * _ / 3);
                    return [
                        t1 * I(6 * _) / (2 * r),
                        m(e1) * C((4 - r * r) / 3)
                    ];
                }, Ht.invert = function(t1, e1) {
                    var r = I(_ * (4 + _)) / 2;
                    return [
                        t1 * r / (1 + I(1 - e1 * e1 * (4 + _) / (4 * _))),
                        e1 * r / 2
                    ];
                }, Zt.invert = function(t1, e1) {
                    var r = e1 * I((4 + _) / _) / 2, n = C(r), i = s(n);
                    return [
                        t1 / (2 / I(_ * (4 + _)) * (1 + i)),
                        C((n + r * (i + 2)) / (2 + b))
                    ];
                }, Yt.invert = function(t1, e1) {
                    var r = I(2 + _), n = e1 * r / 2;
                    return [
                        r * t1 / (1 + s(n)),
                        n
                    ];
                }, $t.invert = function(t1, e1) {
                    var r = 1 + b, n = I(r / 2);
                    return [
                        2 * t1 * n / (1 + s(e1 *= n)),
                        C((e1 + g(e1)) / r)
                    ];
                };
                var Kt = 3 + 2 * k;
                function Qt(t1, e1) {
                    var r = g(t1 /= 2), n = s(t1), i = I(s(e1)), o = s(e1 /= 2), l = g(e1) / (o + k * n * i), c = I(2 / (1 + l * l)), h = I((k * o + (n + r) * i) / (k * o + (n - r) * i));
                    return [
                        Kt * (c * (h - 1 / h) - 2 * u(h)),
                        Kt * (c * l * (h + 1 / h) - 2 * a(l))
                    ];
                }
                function te() {
                    return (0, n.A)(Qt).scale(62.5271);
                }
                Qt.invert = function(t1, e1) {
                    if (!(r = j.invert(t1 / 1.2, 1.065 * e1))) return null;
                    var r, n = r[0], o = r[1], l = 20;
                    t1 /= Kt, e1 /= Kt;
                    do {
                        var c = n / 2, p = o / 2, d = g(c), m = s(c), y = g(p), x = s(p), _ = s(o), w = I(_), A = y / (x + k * m * w), M = A * A, S = I(2 / (1 + M)), E = (k * x + (m + d) * w) / (k * x + (m - d) * w), C = I(E), L = C - 1 / C, P = C + 1 / C, z = S * L - 2 * u(C) - t1, O = S * A * P - 2 * a(A) - e1, D = y && T * w * d * M / y, R = (k * m * x + w) / (2 * (x + k * m * w) * (x + k * m * w) * w), F = -0.5 * A * S * S * S, B = F * D, N = F * R, U = (U = 2 * x + k * w * (m - d)) * U * C, V = (k * m * x * w + _) / U, q = -k * d * y / (w * U), H = L * B - 2 * V / C + S * (V + V / E), G = L * N - 2 * q / C + S * (q + q / E), Z = A * P * B - 2 * D / (1 + M) + S * P * D + S * A * (V - V / E), W = A * P * N - 2 * R / (1 + M) + S * P * R + S * A * (q - q / E), Y = G * Z - W * H;
                        if (!Y) break;
                        var X = (O * G - z * W) / Y, $ = (z * Z - O * H) / Y;
                        n -= X, o = h(-b, f(b, o - $));
                    }while ((i(X) > v || i($) > v) && --l > 0);
                    return i(i(o) - b) < v ? [
                        0,
                        o
                    ] : l && [
                        n,
                        o
                    ];
                };
                var ee = s(35 * E);
                function re(t1, e1) {
                    var r = y(e1 / 2);
                    return [
                        t1 * ee * I(1 - r * r),
                        (1 + ee) * r
                    ];
                }
                function ne() {
                    return (0, n.A)(re).scale(137.152);
                }
                function ie(t1, e1) {
                    var r = e1 / 2, n = s(r);
                    return [
                        2 * t1 / A * s(e1) * n * n,
                        A * y(r)
                    ];
                }
                function ae() {
                    return (0, n.A)(ie).scale(135.264);
                }
                function oe(t1) {
                    var e1 = 1 - t1, r = i(_, 0)[0] - i(-_, 0)[0], n = I(2 * (i(0, b)[1] - i(0, -b)[1]) / r);
                    function i(r, n) {
                        var i = s(n), a = g(n);
                        return [
                            i / (e1 + t1 * i) * r,
                            e1 * n + t1 * a
                        ];
                    }
                    function a(t1, e1) {
                        var r = i(t1, e1);
                        return [
                            r[0] * n,
                            r[1] / n
                        ];
                    }
                    function o(t1) {
                        return a(0, t1)[1];
                    }
                    return a.invert = function(r, i) {
                        var a = Q(o, i);
                        return [
                            r / n * (t1 + e1 / s(a)),
                            a
                        ];
                    }, a;
                }
                function se() {
                    var t1 = .5, e1 = (0, n.U)(oe), r = e1(t1);
                    return r.alpha = function(r) {
                        return arguments.length ? e1(t1 = +r) : t1;
                    }, r.scale(168.725);
                }
                re.invert = function(t1, e1) {
                    var r = e1 / (1 + ee);
                    return [
                        t1 && t1 / (ee * I(1 - r * r)),
                        2 * a(r)
                    ];
                }, ie.invert = function(t1, e1) {
                    var r = a(e1 / A), n = s(r), i = 2 * r;
                    return [
                        t1 * A / 2 / (s(i) * n * n),
                        i
                    ];
                };
                var le = r(53253), ce = r(18139);
                function ue(t1) {
                    return [
                        t1[0] / 2,
                        C(y(t1[1] / 2 * E)) * S
                    ];
                }
                function he(t1) {
                    return [
                        2 * t1[0],
                        2 * a(g(t1[1] * E)) * S
                    ];
                }
                function fe(t1) {
                    null == t1 && (t1 = le.A);
                    var e1 = t1(), r = (0, ce.A)().scale(S).precision(0).clipAngle(null).translate([
                        0,
                        0
                    ]);
                    function n(t1) {
                        return e1(ue(t1));
                    }
                    function i(t1) {
                        n[t1] = function() {
                            return arguments.length ? (e1[t1].apply(e1, arguments), n) : e1[t1]();
                        };
                    }
                    return e1.invert && (n.invert = function(t1) {
                        return he(e1.invert(t1));
                    }), n.stream = function(t1) {
                        var n = e1.stream(t1), i = r.stream({
                            point: function(t1, e1) {
                                n.point(t1 / 2, C(y(-e1 / 2 * E)) * S);
                            },
                            lineStart: function() {
                                n.lineStart();
                            },
                            lineEnd: function() {
                                n.lineEnd();
                            },
                            polygonStart: function() {
                                n.polygonStart();
                            },
                            polygonEnd: function() {
                                n.polygonEnd();
                            }
                        });
                        return i.sphere = n.sphere, i;
                    }, n.rotate = function(t1) {
                        return arguments.length ? (r.rotate(t1), n) : r.rotate();
                    }, n.center = function(t1) {
                        return arguments.length ? (e1.center(ue(t1)), n) : he(e1.center());
                    }, i("angle"), i("clipAngle"), i("clipExtent"), i("fitExtent"), i("fitHeight"), i("fitSize"), i("fitWidth"), i("scale"), i("translate"), i("precision"), n.scale(249.5);
                }
                function pe(t1, e1) {
                    var r = 2 * _ / e1, n = t1 * t1;
                    function a(e1, a) {
                        var l = (0, Z.j)(e1, a), c = l[0], u = l[1], h = c * c + u * u;
                        if (h > n) {
                            var f = I(h), p = o(u, c), m = r * d(p / r), y = p - m, x = t1 * s(y), w = (t1 * g(y) - y * g(x)) / (b - x), T = de(y, w), k = (_ - t1) / me(T, x, _);
                            c = f;
                            var A, M = 50;
                            do c -= A = (t1 + me(T, x, c) * k - f) / (T(c) * k);
                            while (i(A) > v && --M > 0);
                            u = y * g(c), c < b && (u -= w * (c - b));
                            var S = g(m), E = s(m);
                            l[0] = c * E - u * S, l[1] = c * S + u * E;
                        }
                        return l;
                    }
                    return a.invert = function(e1, a) {
                        var l = e1 * e1 + a * a;
                        if (l > n) {
                            var c = I(l), u = o(a, e1), h = r * d(u / r), f = u - h;
                            e1 = c * s(f), a = c * g(f);
                            for(var p = e1 - b, m = g(e1), y = a / m, v = e1 < b ? 1 / 0 : 0, w = 10;;){
                                var T = t1 * g(y), k = t1 * s(y), A = g(k), M = b - k, S = (T - y * A) / M, E = de(y, S);
                                if (i(v) < x || !--w) break;
                                y -= v = (y * m - S * p - a) / (m - 2 * p * (M * (k + y * T * s(k) - A) - T * (T - y * A)) / (M * M));
                            }
                            e1 = (c = t1 + me(E, k, e1) * (_ - t1) / me(E, k, _)) * s(u = h + y), a = c * g(u);
                        }
                        return Z.j.invert(e1, a);
                    }, a;
                }
                function de(t1, e1) {
                    return function(r) {
                        var n = t1 * s(r);
                        return r < b && (n -= e1), I(1 + n * n);
                    };
                }
                function me(t1, e1, r) {
                    for(var n = (r - e1) / 50, i = t1(e1) + t1(r), a = 1, o = e1; a < 50; ++a)i += 2 * t1(o += n);
                    return .5 * i * n;
                }
                function ge() {
                    var t1 = 6, e1 = 30 * E, r = s(e1), i = g(e1), a = (0, n.U)(pe), l = a(e1, t1), c = l.stream, u = -s(.01 * E), h = g(.01 * E);
                    return l.radius = function(n) {
                        return arguments.length ? (r = s(e1 = n * E), i = g(e1), a(e1, t1)) : e1 * S;
                    }, l.lobes = function(r) {
                        return arguments.length ? a(e1, t1 = +r) : t1;
                    }, l.stream = function(e1) {
                        var n = l.rotate(), a = c(e1), f = (l.rotate([
                            0,
                            0
                        ]), c(e1));
                        return l.rotate(n), a.sphere = function() {
                            f.polygonStart(), f.lineStart();
                            for(var e1 = 0, n = 2 * _ / t1, a = 0; e1 < t1; ++e1, a -= n)f.point(o(h * s(a), u) * S, C(h * g(a)) * S), f.point(o(i * s(a - n / 2), r) * S, C(i * g(a - n / 2)) * S);
                            f.lineEnd(), f.polygonEnd();
                        }, a;
                    }, l.rotate([
                        90,
                        -40
                    ]).scale(91.7095).clipAngle(179.999);
                }
                function ye(t1, e1, r, n, a, o, l, c) {
                    function u(i, u) {
                        if (!u) return [
                            t1 * i / _,
                            0
                        ];
                        var h = u * u, f = t1 + h * (e1 + h * (r + h * n)), p = u * (a - 1 + h * (o - c + h * l)), d = (f * f + p * p) / (2 * p), m = i * C(f / d) / _;
                        return [
                            d * g(m),
                            u * (1 + h * c) + d * (1 - s(m))
                        ];
                    }
                    return arguments.length < 8 && (c = 0), u.invert = function(u, h) {
                        var f, p, d = _ * u / t1, m = h, y = 50;
                        do {
                            var x = m * m, b = t1 + x * (e1 + x * (r + x * n)), w = m * (a - 1 + x * (o - c + x * l)), T = b * b + w * w, k = 2 * w, A = T / k, M = A * A, S = C(b / A) / _, E = d * S, L = b * b, P = (2 * e1 + x * (4 * r + 6 * x * n)) * m, z = a + x * (3 * o + 5 * x * l), O = (2 * (b * P + w * (z - 1)) * k - T * (2 * (z - 1))) / (k * k), D = s(E), R = g(E), F = A * D, B = A * R, N = d / _ * (1 / I(1 - L / M)) * (P * A - b * O) / M, j = B - u, U = m * (1 + x * c) + A - F - h, V = O * R + F * N, q = F * S, H = 1 + O - (O * D - B * N), G = B * S, Z = V * G - H * q;
                            if (!Z) break;
                            d -= f = (U * V - j * H) / Z, m -= p = (j * G - U * q) / Z;
                        }while ((i(f) > v || i(p) > v) && --y > 0);
                        return [
                            d,
                            m
                        ];
                    }, u;
                }
                var ve = ye(2.8284, -1.6988, .75432, -0.18071, 1.76003, -0.38914, .042555);
                function xe() {
                    return (0, n.A)(ve).scale(149.995);
                }
                var _e = ye(2.583819, -0.835827, .170354, -0.038094, 1.543313, -0.411435, .082742);
                function be() {
                    return (0, n.A)(_e).scale(153.93);
                }
                var we = ye(5 / 6 * _, -0.62636, -0.0344, 0, 1.3493, -0.05524, 0, .045);
                function Te() {
                    return (0, n.A)(we).scale(130.945);
                }
                function ke(t1, e1) {
                    var r = t1 * t1, n = e1 * e1;
                    return [
                        t1 * (1 - .162388 * n) * (.87 - 952426e-9 * r * r),
                        e1 * (1 + n / 12)
                    ];
                }
                function Ae() {
                    return (0, n.A)(ke).scale(131.747);
                }
                ke.invert = function(t1, e1) {
                    var r, n = t1, a = e1, o = 50;
                    do {
                        var s = a * a;
                        a -= r = (a * (1 + s / 12) - e1) / (1 + s / 4);
                    }while (i(r) > v && --o > 0);
                    o = 50, t1 /= 1 - .162388 * s;
                    do {
                        var l = (l = n * n) * l;
                        n -= r = (n * (.87 - 952426e-9 * l) - t1) / (.87 - .00476213 * l);
                    }while (i(r) > v && --o > 0);
                    return [
                        n,
                        a
                    ];
                };
                var Me = ye(2.6516, -0.76534, .19123, -0.047094, 1.36289, -0.13965, .031762);
                function Se() {
                    return (0, n.A)(Me).scale(131.087);
                }
                function Ee(t1) {
                    var e1 = t1(b, 0)[0] - t1(-b, 0)[0];
                    function r(r, n) {
                        var i = r > 0 ? -0.5 : .5, a = t1(r + i * _, n);
                        return a[0] -= i * e1, a;
                    }
                    return t1.invert && (r.invert = function(r, n) {
                        var i = r > 0 ? -0.5 : .5, a = t1.invert(r + i * e1, n), o = a[0] - i * _;
                        return o < -_ ? o += 2 * _ : o > _ && (o -= 2 * _), a[0] = o, a;
                    }), r;
                }
                function Ce(t1, e1) {
                    var r = m(t1), n = m(e1), a = s(e1), l = s(t1) * a, c = g(t1) * a, u = g(n * e1);
                    t1 = i(o(c, u)), e1 = C(l), i(t1 - b) > v && (t1 %= b);
                    var h = function(t1, e1) {
                        if (e1 === b) return [
                            0,
                            0
                        ];
                        var r, n, a = g(e1), o = a * a, l = o * o, c = 1 + l, u = 1 + 3 * l, h = 1 - l, f = C(1 / I(c)), p = h + o * c * f, d = (1 - a) / p, m = I(d), y = d * c, x = I(y), w = m * h;
                        if (0 === t1) return [
                            0,
                            -(w + o * x)
                        ];
                        var T, k = s(e1), A = 1 / k, M = 2 * a * k, S = (-p * k - (1 - a) * ((-3 * o + f * u) * M)) / (p * p), E = -A * M, L = -A * (o * c * S + d * u * M), P = -2 * A * (h * (.5 * S / m) - 2 * o * m * M), z = 4 * t1 / _;
                        if (t1 > .222 * _ || e1 < _ / 4 && t1 > .175 * _) {
                            if (r = (w + o * I(y * (1 + l) - w * w)) / (1 + l), t1 > _ / 4) return [
                                r,
                                r
                            ];
                            var O = r, D = .5 * r;
                            r = .5 * (D + O), n = 50;
                            do {
                                var R = r * (P + E * I(y - r * r)) + L * C(r / x) - z;
                                if (!R) break;
                                R < 0 ? D = r : O = r, r = .5 * (D + O);
                            }while (i(O - D) > v && --n > 0);
                        } else {
                            r = v, n = 25;
                            do {
                                var F = r * r, B = I(y - F), N = P + E * B, j = r * N + L * C(r / x) - z;
                                r -= T = B ? j / (N + (L - E * F) / B) : 0;
                            }while (i(T) > v && --n > 0);
                        }
                        return [
                            r,
                            -w - o * I(y - r * r)
                        ];
                    }(t1 > _ / 4 ? b - t1 : t1, e1);
                    return t1 > _ / 4 && (u = h[0], h[0] = -h[1], h[1] = -u), h[0] *= r, h[1] *= -n, h;
                }
                function Le() {
                    return (0, n.A)(Ee(Ce)).scale(239.75);
                }
                function Ie(t1, e1) {
                    var r, n, o, c, u, h;
                    if (e1 < v) return [
                        (c = g(t1)) - (r = e1 * (t1 - c * (n = s(t1))) / 4) * n,
                        n + r * c,
                        1 - e1 * c * c / 2,
                        t1 - r
                    ];
                    if (e1 >= 1 - v) return r = (1 - e1) / 4, o = 1 / (n = z(t1)), [
                        (c = ((h = l(2 * (h = t1))) - 1) / (h + 1)) + r * ((u = n * P(t1)) - t1) / (n * n),
                        o - r * c * o * (u - t1),
                        o + r * c * o * (u + t1),
                        2 * a(l(t1)) - b + r * (u - t1) / n
                    ];
                    var f = [
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ], p = [
                        I(e1),
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ], d = 0;
                    for(n = I(1 - e1), u = 1; i(p[d] / f[d]) > v && d < 8;)r = f[d++], p[d] = (r - n) / 2, f[d] = (r + n) / 2, n = I(r * n), u *= 2;
                    o = u * f[d] * t1;
                    do o = (C(c = p[d] * g(n = o) / f[d]) + o) / 2;
                    while (--d);
                    return [
                        g(o),
                        c = s(o),
                        c / s(o - n),
                        o
                    ];
                }
                function Pe(t1, e1) {
                    if (!e1) return t1;
                    if (1 === e1) return u(y(t1 / 2 + w));
                    for(var r = 1, n = I(1 - e1), o = I(e1), s = 0; i(o) > v; s++){
                        if (t1 % _) {
                            var l = a(n * y(t1) / r);
                            l < 0 && (l += _), t1 += l + ~~(t1 / _) * _;
                        } else t1 += t1;
                        o = (r + n) / 2, n = I(r * n), o = ((r = o) - n) / 2;
                    }
                    return t1 / (p(2, s) * r);
                }
                function ze(t1, e1) {
                    var r = (k - 1) / (k + 1), n = I(1 - r * r), c = Pe(b, n * n), h = u(y(_ / 4 + i(e1) / 2)), f = l(-1 * h) / I(r), p = function(t1, e1) {
                        var r = t1 * t1, n = e1 + 1, i = 1 - r - e1 * e1;
                        return [
                            .5 * ((t1 >= 0 ? b : -b) - o(i, 2 * t1)),
                            -0.25 * u(i * i + 4 * r) + .5 * u(n * n + r)
                        ];
                    }(f * s(-1 * t1), f * g(-1 * t1)), d = function(t1, e1, r) {
                        var n = i(t1), o = P(i(e1));
                        if (n) {
                            var s = 1 / g(n), l = 1 / (y(n) * y(n)), c = -(l + r * (o * o * s * s) - 1 + r), u = (-c + I(c * c - (r - 1) * l * 4)) / 2;
                            return [
                                Pe(a(1 / I(u)), r) * m(t1),
                                Pe(a(I((u / l - 1) / r)), 1 - r) * m(e1)
                            ];
                        }
                        return [
                            0,
                            Pe(a(o), 1 - r) * m(e1)
                        ];
                    }(p[0], p[1], n * n);
                    return [
                        -d[1],
                        (e1 >= 0 ? 1 : -1) * (.5 * c - d[0])
                    ];
                }
                function Oe() {
                    return (0, n.A)(Ee(ze)).scale(151.496);
                }
                Ce.invert = function(t1, e1) {
                    i(t1) > 1 && (t1 = 2 * m(t1) - t1), i(e1) > 1 && (e1 = 2 * m(e1) - e1);
                    var r = m(t1), n = m(e1), a = -r * t1, l = -n * e1, c = l / a < 1, u = function(t1, e1) {
                        for(var r = 0, n = 1, a = .5, o = 50;;){
                            var l = a * a, c = I(a), u = C(1 / I(1 + l)), h = 1 - l + a * (1 + l) * u, f = (1 - c) / h, p = I(f), d = f * (1 + l), m = p * (1 - l), g = I(d - t1 * t1), y = e1 + m + a * g;
                            if (i(n - r) < x || 0 == --o || 0 === y) break;
                            y > 0 ? r = a : n = a, a = .5 * (r + n);
                        }
                        if (!o) return null;
                        var v = C(c), b = s(v), w = 1 / b, T = 2 * c * b, k = (-h * b - (-3 * a + u * (1 + 3 * l)) * T * (1 - c)) / (h * h);
                        return [
                            _ / 4 * (t1 * (-2 * w * ((1 - l) * (.5 * k / p) - 2 * a * p * T) + -w * T * g) + -w * (a * (1 + l) * k + f * (1 + 3 * l) * T) * C(t1 / I(d))),
                            v
                        ];
                    }(c ? l : a, c ? a : l), h = u[0], f = u[1], p = s(f);
                    return c && (h = -b - h), [
                        r * (o(g(h) * p, -g(f)) + _),
                        n * C(s(h) * p)
                    ];
                }, ze.invert = function(t1, e1) {
                    var r, n, i, s, c, h, f = (k - 1) / (k + 1), p = I(1 - f * f), d = (n = -t1, i = p * p, (r = .5 * Pe(b, p * p) - e1) ? (s = Ie(r, i), n ? (h = (c = Ie(n, 1 - i))[1] * c[1] + i * s[0] * s[0] * c[0] * c[0], [
                        [
                            s[0] * c[2] / h,
                            s[1] * s[2] * c[0] * c[1] / h
                        ],
                        [
                            s[1] * c[1] / h,
                            -s[0] * s[2] * c[0] * c[2] / h
                        ],
                        [
                            s[2] * c[1] * c[2] / h,
                            -i * s[0] * s[1] * c[0] / h
                        ]
                    ]) : [
                        [
                            s[0],
                            0
                        ],
                        [
                            s[1],
                            0
                        ],
                        [
                            s[2],
                            0
                        ]
                    ]) : [
                        [
                            0,
                            (c = Ie(n, 1 - i))[0] / c[1]
                        ],
                        [
                            1 / c[1],
                            0
                        ],
                        [
                            c[2] / c[1],
                            0
                        ]
                    ]), m = function(t1, e1) {
                        var r = e1[0] * e1[0] + e1[1] * e1[1];
                        return [
                            (t1[0] * e1[0] + t1[1] * e1[1]) / r,
                            (t1[1] * e1[0] - t1[0] * e1[1]) / r
                        ];
                    }(d[0], d[1]);
                    return [
                        o(m[1], m[0]) / -1,
                        2 * a(l(-0.5 * u(f * m[0] * m[0] + f * m[1] * m[1]))) - b
                    ];
                };
                var De = r(39127);
                function Re(t1) {
                    var e1 = g(t1), r = s(t1), n = Fe(t1);
                    function a(t1, a) {
                        var o = n(t1, a);
                        t1 = o[0], a = o[1];
                        var l = g(a), c = s(a), u = s(t1), h = L(e1 * l + r * c * u), f = g(h), p = i(f) > v ? h / f : 1;
                        return [
                            p * r * g(t1),
                            (i(t1) > b ? p : -p) * (e1 * c - r * l * u)
                        ];
                    }
                    return n.invert = Fe(-t1), a.invert = function(t1, r) {
                        var i = I(t1 * t1 + r * r), a = -g(i), l = s(i), c = i * l, u = -r * a, h = i * e1, f = I(c * c + u * u - h * h), p = o(c * h + u * f, u * h - c * f), d = (i > b ? -1 : 1) * o(t1 * a, i * s(p) * l + r * g(p) * a);
                        return n.invert(d, p);
                    }, a;
                }
                function Fe(t1) {
                    var e1 = g(t1), r = s(t1);
                    return function(t1, n) {
                        var i = s(n), a = s(t1) * i, l = g(t1) * i, c = g(n);
                        return [
                            o(l, a * r - c * e1),
                            C(c * r + a * e1)
                        ];
                    };
                }
                function Be() {
                    var t1 = 0, e1 = (0, n.U)(Re), r = e1(t1), i = r.rotate, a = r.stream, o = (0, De.A)();
                    return r.parallel = function(n) {
                        if (!arguments.length) return t1 * S;
                        var i = r.rotate();
                        return e1(t1 = n * E).rotate(i);
                    }, r.rotate = function(e1) {
                        return arguments.length ? (i.call(r, [
                            e1[0],
                            e1[1] - t1 * S
                        ]), o.center([
                            -e1[0],
                            -e1[1]
                        ]), r) : ((e1 = i.call(r))[1] += t1 * S, e1);
                    }, r.stream = function(t1) {
                        return (t1 = a(t1)).sphere = function() {
                            t1.polygonStart();
                            var e1, r = o.radius(89.99)().coordinates[0], n = r.length - 1, i = -1;
                            for(t1.lineStart(); ++i < n;)t1.point((e1 = r[i])[0], e1[1]);
                            for(t1.lineEnd(), n = (r = o.radius(90.01)().coordinates[0]).length - 1, t1.lineStart(); --i >= 0;)t1.point((e1 = r[i])[0], e1[1]);
                            t1.lineEnd(), t1.polygonEnd();
                        }, t1;
                    }, r.scale(79.4187).parallel(45).clipAngle(179.999);
                }
                var Ne = r(29725), je = r(20465), Ue = C(1 - 1 / 3) * S, Ve = Rt(0);
                function qe(t1) {
                    var e1 = Ue * E, r = Ct(_, e1)[0] - Ct(-_, e1)[0], n = Ve(0, e1)[1], a = Ct(0, e1)[1], o = A - a, s = M / t1, l = 4 / M, u = n + o * o * 4 / M;
                    function p(p, d) {
                        var m, g = i(d);
                        if (g > e1) {
                            var y = f(t1 - 1, h(0, c((p + _) / s)));
                            (m = Ct(p += _ * (t1 - 1) / t1 - y * s, g))[0] = m[0] * M / r - M * (t1 - 1) / (2 * t1) + y * M / t1, m[1] = n + 4 * (m[1] - a) * o / M, d < 0 && (m[1] = -m[1]);
                        } else m = Ve(p, d);
                        return m[0] *= l, m[1] /= u, m;
                    }
                    return p.invert = function(e1, p) {
                        e1 /= l;
                        var d = i(p *= u);
                        if (d > n) {
                            var m = f(t1 - 1, h(0, c((e1 + _) / s)));
                            e1 = (e1 + _ * (t1 - 1) / t1 - m * s) * r / M;
                            var g = Ct.invert(e1, .25 * (d - n) * M / o + a);
                            return g[0] -= _ * (t1 - 1) / t1 - m * s, p < 0 && (g[1] = -g[1]), g;
                        }
                        return Ve.invert(e1, p);
                    }, p;
                }
                function He(t1, e1) {
                    return [
                        t1,
                        1 & e1 ? 90 - v : Ue
                    ];
                }
                function Ge(t1, e1) {
                    return [
                        t1,
                        1 & e1 ? -90 + v : -Ue
                    ];
                }
                function Ze(t1) {
                    return [
                        t1[0] * (1 - v),
                        t1[1]
                    ];
                }
                function We() {
                    var t1 = 4, e1 = (0, n.U)(qe), r = e1(t1), i = r.stream;
                    return r.lobes = function(r) {
                        return arguments.length ? e1(t1 = +r) : t1;
                    }, r.stream = function(e1) {
                        var n = r.rotate(), a = i(e1), o = (r.rotate([
                            0,
                            0
                        ]), i(e1));
                        return r.rotate(n), a.sphere = function() {
                            var e1, r;
                            (0, je.A)((e1 = 180 / t1, r = [].concat((0, Ne.y1)(-180, 180 + e1 / 2, e1).map(He), (0, Ne.y1)(180, -180 - e1 / 2, -e1).map(Ge)), {
                                type: "Polygon",
                                coordinates: [
                                    180 === e1 ? r.map(Ze) : r
                                ]
                            }), o);
                        }, a;
                    }, r.scale(239.75);
                }
                function Ye(t1) {
                    var e1, r = 1 + t1, n = C(g(1 / r)), a = 2 * I(_ / (e1 = _ + 4 * n * r)), l = .5 * a * (r + I(t1 * (2 + t1))), c = t1 * t1, u = r * r;
                    function h(h, f) {
                        var p, d, m = 1 - g(f);
                        if (m && m < 2) {
                            var y, v = b - f, w = 25;
                            do {
                                var T = g(v), k = s(v), A = n + o(T, r - k), M = 1 + u - 2 * r * k;
                                v -= y = (v - c * n - r * T + M * A - .5 * m * e1) / (2 * r * T * A);
                            }while (i(y) > x && --w > 0);
                            p = a * I(M), d = h * A / _;
                        } else p = a * (t1 + m), d = h * n / _;
                        return [
                            p * g(d),
                            l - p * s(d)
                        ];
                    }
                    return h.invert = function(t1, i) {
                        var s = t1 * t1 + (i -= l) * i, h = (1 + u - s / (a * a)) / (2 * r), f = L(h), p = g(f), d = n + o(p, r - h);
                        return [
                            C(t1 / I(s)) * _ / d,
                            C(1 - 2 * (f - c * n - r * p + (1 + u - 2 * r * h) * d) / e1)
                        ];
                    }, h;
                }
                function Xe() {
                    var t1 = 1, e1 = (0, n.U)(Ye), r = e1(t1);
                    return r.ratio = function(r) {
                        return arguments.length ? e1(t1 = +r) : t1;
                    }, r.scale(167.774).center([
                        0,
                        18.67
                    ]);
                }
                var $e = .7109889596207567, Je = .0528035274542;
                function Ke(t1, e1) {
                    return e1 > -$e ? ((t1 = at(t1, e1))[1] += Je, t1) : ft(t1, e1);
                }
                function Qe() {
                    return (0, n.A)(Ke).rotate([
                        -20,
                        -55
                    ]).scale(164.263).center([
                        0,
                        -5.4036
                    ]);
                }
                function tr(t1, e1) {
                    return i(e1) > $e ? ((t1 = at(t1, e1))[1] -= e1 > 0 ? Je : -Je, t1) : ft(t1, e1);
                }
                function er() {
                    return (0, n.A)(tr).scale(152.63);
                }
                function rr(t1, e1, r, n) {
                    var i = I(4 * _ / (2 * r + (1 + t1 - e1 / 2) * g(2 * r) + (t1 + e1) / 2 * g(4 * r) + e1 / 2 * g(6 * r))), a = I(n * g(r) * I((1 + t1 * s(2 * r) + e1 * s(4 * r)) / (1 + t1 + e1))), o = r * c(1);
                    function l(r) {
                        return I(1 + t1 * s(2 * r) + e1 * s(4 * r));
                    }
                    function c(n) {
                        var i = n * r;
                        return (2 * i + (1 + t1 - e1 / 2) * g(2 * i) + (t1 + e1) / 2 * g(4 * i) + e1 / 2 * g(6 * i)) / r;
                    }
                    function u(t1) {
                        return l(t1) * g(t1);
                    }
                    var h = function(t1, e1) {
                        var n = r * Q(c, o * g(e1) / r, e1 / _);
                        isNaN(n) && (n = r * m(e1));
                        var u = i * l(n);
                        return [
                            u * a * t1 / _ * s(n),
                            u / a * g(n)
                        ];
                    };
                    return h.invert = function(t1, e1) {
                        var n = Q(u, e1 * a / i);
                        return [
                            t1 * _ / (s(n) * i * a * l(n)),
                            C(r * c(n / r) / o)
                        ];
                    }, 0 === r && (i = I(n / _), (h = function(t1, e1) {
                        return [
                            t1 * i,
                            g(e1) / i
                        ];
                    }).invert = function(t1, e1) {
                        return [
                            t1 / i,
                            C(e1 * i)
                        ];
                    }), h;
                }
                function nr() {
                    var t1 = 1, e1 = 0, r = 45 * E, i = 2, a = (0, n.U)(rr), o = a(t1, e1, r, i);
                    return o.a = function(n) {
                        return arguments.length ? a(t1 = +n, e1, r, i) : t1;
                    }, o.b = function(n) {
                        return arguments.length ? a(t1, e1 = +n, r, i) : e1;
                    }, o.psiMax = function(n) {
                        return arguments.length ? a(t1, e1, r = +n * E, i) : r * S;
                    }, o.ratio = function(n) {
                        return arguments.length ? a(t1, e1, r, i = +n) : i;
                    }, o.scale(180.739);
                }
                function ir(t1, e1, r, n, i, a, o, s, l, c, u) {
                    if (u.nanEncountered) return NaN;
                    var h, f, p, d, m, g, y, v, x, _;
                    if (f = t1(e1 + .25 * (h = r - e1)), p = t1(r - .25 * h), isNaN(f)) u.nanEncountered = !0;
                    else {
                        if (!isNaN(p)) return _ = ((g = (d = h * (n + 4 * f + i) / 12) + (m = h * (i + 4 * p + a) / 12)) - o) / 15, c > l ? (u.maxDepthCount++, g + _) : Math.abs(_) < s ? g + _ : (v = ir(t1, e1, y = e1 + .5 * h, n, f, i, d, .5 * s, l, c + 1, u), isNaN(v) ? (u.nanEncountered = !0, NaN) : (x = ir(t1, y, r, i, p, a, m, .5 * s, l, c + 1, u), isNaN(x) ? (u.nanEncountered = !0, NaN) : v + x));
                        u.nanEncountered = !0;
                    }
                }
                function ar(t1, e1, r, n, i) {
                    void 0 === n && (n = 1e-8), void 0 === i && (i = 20);
                    var a = t1(e1), o = t1(.5 * (e1 + r)), s = t1(r);
                    return ir(t1, e1, r, a, o, s, (a + 4 * o + s) * (r - e1) / 6, n, i, 1, {
                        maxDepthCount: 0,
                        nanEncountered: !1
                    });
                }
                function or(t1, e1, r) {
                    function n(r) {
                        return t1 + (1 - t1) * p(1 - p(r, e1), 1 / e1);
                    }
                    function a(t1) {
                        return ar(n, 0, t1, 1e-4);
                    }
                    for(var o = 1 / a(1), s = 1e3, l = (1 + 1e-8) * o, c = [], u = 0; u <= s; u++)c.push(a(u / s) * l);
                    function h(t1) {
                        var e1 = 0, r = s, n = 500;
                        do c[n] > t1 ? r = n : e1 = n, n = e1 + r >> 1;
                        while (n > e1);
                        var i = c[n + 1] - c[n];
                        return i && (i = (t1 - c[n + 1]) / i), (n + 1 + i) / s;
                    }
                    var f = 2 * h(1) / _ * o / r, d = function(t1, e1) {
                        var r = h(i(g(e1))), a = n(r) * t1;
                        return r /= f, [
                            a,
                            e1 >= 0 ? r : -r
                        ];
                    };
                    return d.invert = function(t1, e1) {
                        var r;
                        return i(e1 *= f) < 1 && (r = m(e1) * C(a(i(e1)) * o)), [
                            t1 / n(i(e1)),
                            r
                        ];
                    }, d;
                }
                function sr() {
                    var t1 = 0, e1 = 2.5, r = 1.183136, i = (0, n.U)(or), a = i(t1, e1, r);
                    return a.alpha = function(n) {
                        return arguments.length ? i(t1 = +n, e1, r) : t1;
                    }, a.k = function(n) {
                        return arguments.length ? i(t1, e1 = +n, r) : e1;
                    }, a.gamma = function(n) {
                        return arguments.length ? i(t1, e1, r = +n) : r;
                    }, a.scale(152.63);
                }
                function lr(t1, e1) {
                    return i(t1[0] - e1[0]) < v && i(t1[1] - e1[1]) < v;
                }
                function cr(t1, e1) {
                    for(var r, n, i, a = -1, o = t1.length, s = t1[0], l = []; ++a < o;){
                        n = ((r = t1[a])[0] - s[0]) / e1, i = (r[1] - s[1]) / e1;
                        for(var c = 0; c < e1; ++c)l.push([
                            s[0] + c * n,
                            s[1] + c * i
                        ]);
                        s = r;
                    }
                    return l.push(r), l;
                }
                function ur(t1, e1, r) {
                    var i, a;
                    function o(r, n) {
                        for(var i = n < 0 ? -1 : 1, a = e1[+(n < 0)], o = 0, s = a.length - 1; o < s && r > a[o][2][0]; ++o);
                        var l = t1(r - a[o][1][0], n);
                        return l[0] += t1(a[o][1][0], i * n > i * a[o][0][1] ? a[o][0][1] : n)[0], l;
                    }
                    r ? o.invert = r(o) : t1.invert && (o.invert = function(r, n) {
                        for(var i = a[+(n < 0)], s = e1[+(n < 0)], l = 0, c = i.length; l < c; ++l){
                            var u = i[l];
                            if (u[0][0] <= r && r < u[1][0] && u[0][1] <= n && n < u[1][1]) {
                                var h = t1.invert(r - t1(s[l][1][0], 0)[0], n);
                                return h[0] += s[l][1][0], lr(o(h[0], h[1]), [
                                    r,
                                    n
                                ]) ? h : null;
                            }
                        }
                    });
                    var s = (0, n.A)(o), l = s.stream;
                    return s.stream = function(t1) {
                        var e1 = s.rotate(), r = l(t1), n = (s.rotate([
                            0,
                            0
                        ]), l(t1));
                        return s.rotate(e1), r.sphere = function() {
                            (0, je.A)(i, n);
                        }, r;
                    }, s.lobes = function(r) {
                        return arguments.length ? (i = function(t1) {
                            var e1, r, n, i, a, o, s, l = [], c = t1[0].length;
                            for(s = 0; s < c; ++s)r = (e1 = t1[0][s])[0][0], n = e1[0][1], i = e1[1][1], a = e1[2][0], o = e1[2][1], l.push(cr([
                                [
                                    r + v,
                                    n + v
                                ],
                                [
                                    r + v,
                                    i - v
                                ],
                                [
                                    a - v,
                                    i - v
                                ],
                                [
                                    a - v,
                                    o + v
                                ]
                            ], 30));
                            for(s = t1[1].length - 1; s >= 0; --s)r = (e1 = t1[1][s])[0][0], n = e1[0][1], i = e1[1][1], a = e1[2][0], o = e1[2][1], l.push(cr([
                                [
                                    a - v,
                                    o - v
                                ],
                                [
                                    a - v,
                                    i + v
                                ],
                                [
                                    r + v,
                                    i + v
                                ],
                                [
                                    r + v,
                                    n - v
                                ]
                            ], 30));
                            return {
                                type: "Polygon",
                                coordinates: [
                                    (0, Ne.Am)(l)
                                ]
                            };
                        }(r), e1 = r.map(function(t1) {
                            return t1.map(function(t1) {
                                return [
                                    [
                                        t1[0][0] * E,
                                        t1[0][1] * E
                                    ],
                                    [
                                        t1[1][0] * E,
                                        t1[1][1] * E
                                    ],
                                    [
                                        t1[2][0] * E,
                                        t1[2][1] * E
                                    ]
                                ];
                            });
                        }), a = e1.map(function(e1) {
                            return e1.map(function(e1) {
                                var r, n = t1(e1[0][0], e1[0][1])[0], i = t1(e1[2][0], e1[2][1])[0], a = t1(e1[1][0], e1[0][1])[1], o = t1(e1[1][0], e1[1][1])[1];
                                return a > o && (r = a, a = o, o = r), [
                                    [
                                        n,
                                        a
                                    ],
                                    [
                                        i,
                                        o
                                    ]
                                ];
                            });
                        }), s) : e1.map(function(t1) {
                            return t1.map(function(t1) {
                                return [
                                    [
                                        t1[0][0] * S,
                                        t1[0][1] * S
                                    ],
                                    [
                                        t1[1][0] * S,
                                        t1[1][1] * S
                                    ],
                                    [
                                        t1[2][0] * S,
                                        t1[2][1] * S
                                    ]
                                ];
                            });
                        });
                    }, null != e1 && s.lobes(e1), s;
                }
                Ke.invert = function(t1, e1) {
                    return e1 > -$e ? at.invert(t1, e1 - Je) : ft.invert(t1, e1);
                }, tr.invert = function(t1, e1) {
                    return i(e1) > $e ? at.invert(t1, e1 + (e1 > 0 ? Je : -Je)) : ft.invert(t1, e1);
                };
                var hr = [
                    [
                        [
                            [
                                -180,
                                0
                            ],
                            [
                                -100,
                                90
                            ],
                            [
                                -40,
                                0
                            ]
                        ],
                        [
                            [
                                -40,
                                0
                            ],
                            [
                                30,
                                90
                            ],
                            [
                                180,
                                0
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -180,
                                0
                            ],
                            [
                                -160,
                                -90
                            ],
                            [
                                -100,
                                0
                            ]
                        ],
                        [
                            [
                                -100,
                                0
                            ],
                            [
                                -60,
                                -90
                            ],
                            [
                                -20,
                                0
                            ]
                        ],
                        [
                            [
                                -20,
                                0
                            ],
                            [
                                20,
                                -90
                            ],
                            [
                                80,
                                0
                            ]
                        ],
                        [
                            [
                                80,
                                0
                            ],
                            [
                                140,
                                -90
                            ],
                            [
                                180,
                                0
                            ]
                        ]
                    ]
                ];
                function fr() {
                    return ur(ct, hr).scale(160.857);
                }
                var pr = [
                    [
                        [
                            [
                                -180,
                                0
                            ],
                            [
                                -100,
                                90
                            ],
                            [
                                -40,
                                0
                            ]
                        ],
                        [
                            [
                                -40,
                                0
                            ],
                            [
                                30,
                                90
                            ],
                            [
                                180,
                                0
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -180,
                                0
                            ],
                            [
                                -160,
                                -90
                            ],
                            [
                                -100,
                                0
                            ]
                        ],
                        [
                            [
                                -100,
                                0
                            ],
                            [
                                -60,
                                -90
                            ],
                            [
                                -20,
                                0
                            ]
                        ],
                        [
                            [
                                -20,
                                0
                            ],
                            [
                                20,
                                -90
                            ],
                            [
                                80,
                                0
                            ]
                        ],
                        [
                            [
                                80,
                                0
                            ],
                            [
                                140,
                                -90
                            ],
                            [
                                180,
                                0
                            ]
                        ]
                    ]
                ];
                function dr() {
                    return ur(tr, pr).scale(152.63);
                }
                var mr = [
                    [
                        [
                            [
                                -180,
                                0
                            ],
                            [
                                -100,
                                90
                            ],
                            [
                                -40,
                                0
                            ]
                        ],
                        [
                            [
                                -40,
                                0
                            ],
                            [
                                30,
                                90
                            ],
                            [
                                180,
                                0
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -180,
                                0
                            ],
                            [
                                -160,
                                -90
                            ],
                            [
                                -100,
                                0
                            ]
                        ],
                        [
                            [
                                -100,
                                0
                            ],
                            [
                                -60,
                                -90
                            ],
                            [
                                -20,
                                0
                            ]
                        ],
                        [
                            [
                                -20,
                                0
                            ],
                            [
                                20,
                                -90
                            ],
                            [
                                80,
                                0
                            ]
                        ],
                        [
                            [
                                80,
                                0
                            ],
                            [
                                140,
                                -90
                            ],
                            [
                                180,
                                0
                            ]
                        ]
                    ]
                ];
                function gr() {
                    return ur(at, mr).scale(169.529);
                }
                var yr = [
                    [
                        [
                            [
                                -180,
                                0
                            ],
                            [
                                -90,
                                90
                            ],
                            [
                                0,
                                0
                            ]
                        ],
                        [
                            [
                                0,
                                0
                            ],
                            [
                                90,
                                90
                            ],
                            [
                                180,
                                0
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -180,
                                0
                            ],
                            [
                                -90,
                                -90
                            ],
                            [
                                0,
                                0
                            ]
                        ],
                        [
                            [
                                0,
                                0
                            ],
                            [
                                90,
                                -90
                            ],
                            [
                                180,
                                0
                            ]
                        ]
                    ]
                ];
                function vr() {
                    return ur(at, yr).scale(169.529).rotate([
                        20,
                        0
                    ]);
                }
                var xr = [
                    [
                        [
                            [
                                -180,
                                35
                            ],
                            [
                                -30,
                                90
                            ],
                            [
                                0,
                                35
                            ]
                        ],
                        [
                            [
                                0,
                                35
                            ],
                            [
                                30,
                                90
                            ],
                            [
                                180,
                                35
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -180,
                                -10
                            ],
                            [
                                -102,
                                -90
                            ],
                            [
                                -65,
                                -10
                            ]
                        ],
                        [
                            [
                                -65,
                                -10
                            ],
                            [
                                5,
                                -90
                            ],
                            [
                                77,
                                -10
                            ]
                        ],
                        [
                            [
                                77,
                                -10
                            ],
                            [
                                103,
                                -90
                            ],
                            [
                                180,
                                -10
                            ]
                        ]
                    ]
                ];
                function _r() {
                    return ur(Ke, xr, tt).rotate([
                        -20,
                        -55
                    ]).scale(164.263).center([
                        0,
                        -5.4036
                    ]);
                }
                var br = [
                    [
                        [
                            [
                                -180,
                                0
                            ],
                            [
                                -110,
                                90
                            ],
                            [
                                -40,
                                0
                            ]
                        ],
                        [
                            [
                                -40,
                                0
                            ],
                            [
                                0,
                                90
                            ],
                            [
                                40,
                                0
                            ]
                        ],
                        [
                            [
                                40,
                                0
                            ],
                            [
                                110,
                                90
                            ],
                            [
                                180,
                                0
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -180,
                                0
                            ],
                            [
                                -110,
                                -90
                            ],
                            [
                                -40,
                                0
                            ]
                        ],
                        [
                            [
                                -40,
                                0
                            ],
                            [
                                0,
                                -90
                            ],
                            [
                                40,
                                0
                            ]
                        ],
                        [
                            [
                                40,
                                0
                            ],
                            [
                                110,
                                -90
                            ],
                            [
                                180,
                                0
                            ]
                        ]
                    ]
                ];
                function wr() {
                    return ur(ft, br).scale(152.63).rotate([
                        -20,
                        0
                    ]);
                }
                function Tr(t1, e1) {
                    return [
                        3 / M * t1 * I(_ * _ / 3 - e1 * e1),
                        e1
                    ];
                }
                function kr() {
                    return (0, n.A)(Tr).scale(158.837);
                }
                function Ar(t1) {
                    function e1(e1, r) {
                        if (i(i(r) - b) < v) return [
                            0,
                            r < 0 ? -2 : 2
                        ];
                        var n = g(r), a = p((1 + n) / (1 - n), t1 / 2), o = .5 * (a + 1 / a) + s(e1 *= t1);
                        return [
                            2 * g(e1) / o,
                            (a - 1 / a) / o
                        ];
                    }
                    return e1.invert = function(e1, r) {
                        var n = i(r);
                        if (i(n - 2) < v) return e1 ? null : [
                            0,
                            m(r) * b
                        ];
                        if (n > 2) return null;
                        var a = (e1 /= 2) * e1, s = (r /= 2) * r, l = 2 * r / (1 + a + s);
                        return l = p((1 + l) / (1 - l), 1 / t1), [
                            o(2 * e1, 1 - a - s) / t1,
                            C((l - 1) / (l + 1))
                        ];
                    }, e1;
                }
                function Mr() {
                    var t1 = .5, e1 = (0, n.U)(Ar), r = e1(t1);
                    return r.spacing = function(r) {
                        return arguments.length ? e1(t1 = +r) : t1;
                    }, r.scale(124.75);
                }
                Tr.invert = function(t1, e1) {
                    return [
                        M / 3 * t1 / I(_ * _ / 3 - e1 * e1),
                        e1
                    ];
                };
                var Sr = _ / k;
                function Er(t1, e1) {
                    return [
                        t1 * (1 + I(s(e1))) / 2,
                        e1 / (s(e1 / 2) * s(t1 / 6))
                    ];
                }
                function Cr() {
                    return (0, n.A)(Er).scale(97.2672);
                }
                function Lr(t1, e1) {
                    var r = t1 * t1, n = e1 * e1;
                    return [
                        t1 * (.975534 + n * (-0.0143059 * r - .119161 + -0.0547009 * n)),
                        e1 * (1.00384 + r * (.0802894 + -0.02855 * n + 199025e-9 * r) + n * (.0998909 + -0.0491032 * n))
                    ];
                }
                function Ir() {
                    return (0, n.A)(Lr).scale(139.98);
                }
                function Pr(t1, e1) {
                    return [
                        g(t1) / s(e1),
                        y(e1) * s(t1)
                    ];
                }
                function zr() {
                    return (0, n.A)(Pr).scale(144.049).clipAngle(89.999);
                }
                function Or(t1) {
                    var e1 = s(t1), r = y(w + t1 / 2);
                    function n(n, a) {
                        var o = a - t1, s = i(o) < v ? n * e1 : i(s = w + a / 2) < v || i(i(s) - b) < v ? 0 : n * o / u(y(s) / r);
                        return [
                            s,
                            o
                        ];
                    }
                    return n.invert = function(n, a) {
                        var o, s = a + t1;
                        return [
                            i(a) < v ? n / e1 : i(o = w + s / 2) < v || i(i(o) - b) < v ? 0 : n * u(y(o) / r) / a,
                            s
                        ];
                    }, n;
                }
                function Dr() {
                    return ht(Or).parallel(40).scale(158.837);
                }
                function Rr(t1, e1) {
                    return [
                        t1,
                        1.25 * u(y(w + .4 * e1))
                    ];
                }
                function Fr() {
                    return (0, n.A)(Rr).scale(108.318);
                }
                function Br(t1) {
                    var e1 = t1.length - 1;
                    function r(r, n) {
                        for(var i, a = s(n), o = 2 / (1 + a * s(r)), l = o * a * g(r), c = o * g(n), u = e1, h = t1[u], f = h[0], p = h[1]; --u >= 0;)f = (h = t1[u])[0] + l * (i = f) - c * p, p = h[1] + l * p + c * i;
                        return [
                            f = l * (i = f) - c * p,
                            p = l * p + c * i
                        ];
                    }
                    return r.invert = function(r, n) {
                        var l = 20, c = r, u = n;
                        do {
                            for(var h, f = e1, p = t1[f], d = p[0], m = p[1], y = 0, x = 0; --f >= 0;)y = d + c * (h = y) - u * x, x = m + c * x + u * h, d = (p = t1[f])[0] + c * (h = d) - u * m, m = p[1] + c * m + u * h;
                            var _, b, w = (y = d + c * (h = y) - u * x) * y + (x = m + c * x + u * h) * x;
                            c -= _ = ((d = c * (h = d) - u * m - r) * y + (m = c * m + u * h - n) * x) / w, u -= b = (m * y - d * x) / w;
                        }while (i(_) + i(b) > v * v && --l > 0);
                        if (l) {
                            var T = I(c * c + u * u), k = 2 * a(.5 * T), A = g(k);
                            return [
                                o(c * A, T * s(k)),
                                T ? C(u * A / T) : 0
                            ];
                        }
                    }, r;
                }
                Er.invert = function(t1, e1) {
                    var r = i(t1), n = i(e1), a = v, o = b;
                    n < Sr ? o *= n / Sr : a += 6 * L(Sr / n);
                    for(var l = 0; l < 25; l++){
                        var c = g(o), u = I(s(o)), h = g(o / 2), f = s(o / 2), p = g(a / 6), d = s(a / 6), m = .5 * a * (1 + u) - r, y = o / (f * d) - n, x = u ? -0.25 * a * c / u : 0, _ = .5 * (1 + u), w = (1 + .5 * o * h / f) / (f * d), T = o / f * (p / 6) / (d * d), k = x * T - w * _, A = (m * T - y * _) / k, M = (y * x - m * w) / k;
                        if (o -= A, a -= M, i(A) < v && i(M) < v) break;
                    }
                    return [
                        t1 < 0 ? -a : a,
                        e1 < 0 ? -o : o
                    ];
                }, Lr.invert = function(t1, e1) {
                    var r = m(t1) * _, n = e1 / 2, a = 50;
                    do {
                        var o = r * r, s = n * n, l = r * n, c = r * (.975534 + s * (-0.0143059 * o - .119161 + -0.0547009 * s)) - t1, u = n * (1.00384 + o * (.0802894 + -0.02855 * s + 199025e-9 * o) + s * (.0998909 + -0.0491032 * s)) - e1, h = .975534 - s * (.119161 + 3 * o * .0143059 + .0547009 * s), f = -l * (.238322 + .2188036 * s + .0286118 * o), p = l * (.1605788 + 7961e-7 * o + -0.0571 * s), d = 1.00384 + o * (.0802894 + 199025e-9 * o) + s * (3 * (.0998909 - .02855 * o) - .245516 * s), g = f * p - d * h, y = (u * f - c * d) / g, x = (c * p - u * h) / g;
                        r -= y, n -= x;
                    }while ((i(y) > v || i(x) > v) && --a > 0);
                    return a && [
                        r,
                        n
                    ];
                }, Pr.invert = function(t1, e1) {
                    var r = t1 * t1, n = e1 * e1 + 1, i = r + n, a = t1 ? T * I((i - I(i * i - 4 * r)) / r) : 1 / I(n);
                    return [
                        C(t1 * a),
                        m(e1) * L(a)
                    ];
                }, Rr.invert = function(t1, e1) {
                    return [
                        t1,
                        2.5 * a(l(.8 * e1)) - .625 * _
                    ];
                };
                var Nr = [
                    [
                        .9972523,
                        0
                    ],
                    [
                        .0052513,
                        -0.0041175
                    ],
                    [
                        .0074606,
                        .0048125
                    ],
                    [
                        -0.0153783,
                        -0.1968253
                    ],
                    [
                        .0636871,
                        -0.1408027
                    ],
                    [
                        .3660976,
                        -0.2937382
                    ]
                ], jr = [
                    [
                        .98879,
                        0
                    ],
                    [
                        0,
                        0
                    ],
                    [
                        -0.050909,
                        0
                    ],
                    [
                        0,
                        0
                    ],
                    [
                        .075528,
                        0
                    ]
                ], Ur = [
                    [
                        .984299,
                        0
                    ],
                    [
                        .0211642,
                        .0037608
                    ],
                    [
                        -0.1036018,
                        -0.0575102
                    ],
                    [
                        -0.0329095,
                        -0.0320119
                    ],
                    [
                        .0499471,
                        .1223335
                    ],
                    [
                        .026046,
                        .0899805
                    ],
                    [
                        7388e-7,
                        -0.1435792
                    ],
                    [
                        .0075848,
                        -0.1334108
                    ],
                    [
                        -0.0216473,
                        .0776645
                    ],
                    [
                        -0.0225161,
                        .0853673
                    ]
                ], Vr = [
                    [
                        .9245,
                        0
                    ],
                    [
                        0,
                        0
                    ],
                    [
                        .01943,
                        0
                    ]
                ], qr = [
                    [
                        .721316,
                        0
                    ],
                    [
                        0,
                        0
                    ],
                    [
                        -0.00881625,
                        -0.00617325
                    ]
                ];
                function Hr() {
                    return Xr(Nr, [
                        152,
                        -64
                    ]).scale(1400).center([
                        -160.908,
                        62.4864
                    ]).clipAngle(30).angle(7.8);
                }
                function Gr() {
                    return Xr(jr, [
                        95,
                        -38
                    ]).scale(1e3).clipAngle(55).center([
                        -96.5563,
                        38.8675
                    ]);
                }
                function Zr() {
                    return Xr(Ur, [
                        120,
                        -45
                    ]).scale(359.513).clipAngle(55).center([
                        -117.474,
                        53.0628
                    ]);
                }
                function Wr() {
                    return Xr(Vr, [
                        -20,
                        -18
                    ]).scale(209.091).center([
                        20,
                        16.7214
                    ]).clipAngle(82);
                }
                function Yr() {
                    return Xr(qr, [
                        165,
                        10
                    ]).scale(250).clipAngle(130).center([
                        -165,
                        -10
                    ]);
                }
                function Xr(t1, e1) {
                    var r = (0, n.A)(Br(t1)).rotate(e1).clipAngle(90), i = (0, bt.A)(e1), a = r.center;
                    return delete r.rotate, r.center = function(t1) {
                        return arguments.length ? a(i(t1)) : i.invert(a());
                    }, r;
                }
                var $r = I(6), Jr = I(7);
                function Kr(t1, e1) {
                    var r = C(7 * g(e1) / (3 * $r));
                    return [
                        $r * t1 * (2 * s(2 * r / 3) - 1) / Jr,
                        9 * g(r / 3) / Jr
                    ];
                }
                function Qr() {
                    return (0, n.A)(Kr).scale(164.859);
                }
                function tn(t1, e1) {
                    for(var r, n = (1 + T) * g(e1), a = e1, o = 0; o < 25 && (a -= r = (g(a / 2) + g(a) - n) / (.5 * s(a / 2) + s(a)), !(i(r) < v)); o++);
                    return [
                        t1 * (1 + 2 * s(a) / s(a / 2)) / (3 * k),
                        2 * I(3) * g(a / 2) / I(2 + k)
                    ];
                }
                function en() {
                    return (0, n.A)(tn).scale(188.209);
                }
                function rn(t1, e1) {
                    for(var r, n = I(6 / (4 + _)), a = (1 + _ / 4) * g(e1), o = e1 / 2, l = 0; l < 25 && (o -= r = (o / 2 + g(o) - a) / (.5 + s(o)), !(i(r) < v)); l++);
                    return [
                        n * (.5 + s(o)) * t1 / 1.5,
                        n * o
                    ];
                }
                function nn() {
                    return (0, n.A)(rn).scale(166.518);
                }
                Kr.invert = function(t1, e1) {
                    var r = 3 * C(e1 * Jr / 9);
                    return [
                        t1 * Jr / ($r * (2 * s(2 * r / 3) - 1)),
                        C(3 * g(r) * $r / 7)
                    ];
                }, tn.invert = function(t1, e1) {
                    var r = e1 * I(2 + k) / (2 * I(3)), n = 2 * C(r);
                    return [
                        3 * k * t1 / (1 + 2 * s(n) / s(n / 2)),
                        C((r + g(n)) / (1 + T))
                    ];
                }, rn.invert = function(t1, e1) {
                    var r = I(6 / (4 + _)), n = e1 / r;
                    return i(i(n) - b) < v && (n = n < 0 ? -b : b), [
                        1.5 * t1 / (r * (.5 + s(n))),
                        C((n / 2 + g(n)) / (1 + _ / 4))
                    ];
                };
                var an = r(57949);
                function on(t1, e1) {
                    var r = e1 * e1, n = r * r, i = r * n;
                    return [
                        t1 * (.84719 - .13063 * r + i * i * (.05494 * r - .04515 - .02326 * n + .00331 * i)),
                        e1 * (1.01183 + n * n * (.01926 * r - .02625 - .00396 * n))
                    ];
                }
                function sn() {
                    return (0, n.A)(on).scale(175.295);
                }
                function ln(t1, e1) {
                    return [
                        t1 * (1 + s(e1)) / 2,
                        2 * (e1 - y(e1 / 2))
                    ];
                }
                function cn() {
                    return (0, n.A)(ln).scale(152.63);
                }
                on.invert = function(t1, e1) {
                    var r, n, a, o, s = e1, l = 25;
                    do s -= r = (s * (1.01183 + (a = (n = s * s) * n) * a * (.01926 * n - .02625 - .00396 * a)) - e1) / (1.01183 + a * a * (.21186 * n - .23625 + -0.05148 * a));
                    while (i(r) > x && --l > 0);
                    return [
                        t1 / (.84719 - .13063 * (n = s * s) + (o = n * (a = n * n)) * o * (.05494 * n - .04515 - .02326 * a + .00331 * o)),
                        s
                    ];
                }, ln.invert = function(t1, e1) {
                    for(var r = e1 / 2, n = 0, a = 1 / 0; n < 10 && i(a) > v; ++n){
                        var o = s(e1 / 2);
                        e1 -= a = (e1 - y(e1 / 2) - r) / (1 - .5 / (o * o));
                    }
                    return [
                        2 * t1 / (1 + s(e1)),
                        e1
                    ];
                };
                var un = [
                    [
                        [
                            [
                                -180,
                                0
                            ],
                            [
                                -90,
                                90
                            ],
                            [
                                0,
                                0
                            ]
                        ],
                        [
                            [
                                0,
                                0
                            ],
                            [
                                90,
                                90
                            ],
                            [
                                180,
                                0
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -180,
                                0
                            ],
                            [
                                -90,
                                -90
                            ],
                            [
                                0,
                                0
                            ]
                        ],
                        [
                            [
                                0,
                                0
                            ],
                            [
                                90,
                                -90
                            ],
                            [
                                180,
                                0
                            ]
                        ]
                    ]
                ];
                function hn() {
                    return ur($(1 / 0), un).rotate([
                        20,
                        0
                    ]).scale(152.63);
                }
                function fn(t1, e1) {
                    var r = g(e1), n = s(e1), a = m(t1);
                    if (0 === t1 || i(e1) === b) return [
                        0,
                        e1
                    ];
                    if (0 === e1) return [
                        t1,
                        0
                    ];
                    if (i(t1) === b) return [
                        t1 * n,
                        b * r
                    ];
                    var o = _ / (2 * t1) - 2 * t1 / _, l = 2 * e1 / _, c = (1 - l * l) / (r - l), u = o * o, h = c * c, f = 1 + u / h, p = 1 + h / u, d = (o * r / c - o / 2) / f, y = (h * r / u + c / 2) / p, v = y * y - (h * r * r / u + c * r - 1) / p;
                    return [
                        b * (d + I(d * d + n * n / f) * a),
                        b * (y + I(v < 0 ? 0 : v) * m(-e1 * o) * a)
                    ];
                }
                function pn() {
                    return (0, n.A)(fn).scale(127.267);
                }
                fn.invert = function(t1, e1) {
                    var r = (t1 /= b) * t1, n = r + (e1 /= b) * e1, i = _ * _;
                    return [
                        t1 ? (n - 1 + I((1 - n) * (1 - n) + 4 * r)) / (2 * t1) * b : 0,
                        Q(function(t1) {
                            return n * (_ * g(t1) - 2 * t1) * _ + 4 * t1 * t1 * (e1 - g(t1)) + 2 * _ * t1 - i * e1;
                        }, 0)
                    ];
                };
                var dn = 1.0148, mn = .23185, gn = -0.14499, yn = .02406, vn = dn, xn = 5 * mn, _n = 7 * gn, bn = 9 * yn, wn = 1.790857183;
                function Tn(t1, e1) {
                    var r = e1 * e1;
                    return [
                        t1,
                        e1 * (dn + r * r * (mn + r * (gn + yn * r)))
                    ];
                }
                function kn() {
                    return (0, n.A)(Tn).scale(139.319);
                }
                function An(t1, e1) {
                    if (i(e1) < v) return [
                        t1,
                        0
                    ];
                    var r = y(e1), n = t1 * g(e1);
                    return [
                        g(n) / r,
                        e1 + (1 - s(n)) / r
                    ];
                }
                function Mn() {
                    return (0, n.A)(An).scale(103.74);
                }
                Tn.invert = function(t1, e1) {
                    e1 > wn ? e1 = wn : e1 < -1.790857183 && (e1 = -1.790857183);
                    var r, n = e1;
                    do {
                        var a = n * n;
                        n -= r = (n * (dn + a * a * (mn + a * (gn + yn * a))) - e1) / (vn + a * a * (xn + a * (_n + bn * a)));
                    }while (i(r) > v);
                    return [
                        t1,
                        n
                    ];
                }, An.invert = function(t1, e1) {
                    if (i(e1) < v) return [
                        t1,
                        0
                    ];
                    var r, n = t1 * t1 + e1 * e1, a = .5 * e1, o = 10;
                    do {
                        var l = y(a), c = 1 / s(a), u = n - 2 * e1 * a + a * a;
                        a -= r = (l * u + 2 * (a - e1)) / (2 + u * c * c + 2 * (a - e1) * l);
                    }while (i(r) > v && --o > 0);
                    return l = y(a), [
                        (i(e1) < i(a + 1 / l) ? C(t1 * l) : m(e1) * m(t1) * (L(i(t1 * l)) + b)) / g(a),
                        a
                    ];
                };
                var Sn = r(43212), En = r(81758);
                function Cn(t1, e1) {
                    return [
                        t1[0] * e1[0] + t1[1] * e1[3],
                        t1[0] * e1[1] + t1[1] * e1[4],
                        t1[0] * e1[2] + t1[1] * e1[5] + t1[2],
                        t1[3] * e1[0] + t1[4] * e1[3],
                        t1[3] * e1[1] + t1[4] * e1[4],
                        t1[3] * e1[2] + t1[4] * e1[5] + t1[5]
                    ];
                }
                function Ln(t1, e1) {
                    return [
                        t1[0] - e1[0],
                        t1[1] - e1[1]
                    ];
                }
                function In(t1) {
                    return I(t1[0] * t1[0] + t1[1] * t1[1]);
                }
                function Pn(t1, e1, r) {
                    function i(t1, r) {
                        var n, i = e1(t1, r), a = i.project([
                            t1 * S,
                            r * S
                        ]);
                        return (n = i.transform) ? [
                            n[0] * a[0] + n[1] * a[1] + n[2],
                            -(n[3] * a[0] + n[4] * a[1] + n[5])
                        ] : (a[1] = -a[1], a);
                    }
                    function a(t1, r) {
                        var n = t1.project.invert, i = t1.transform, o = r;
                        if (i && (i = function(t1) {
                            var e1 = 1 / (t1[0] * t1[4] - t1[1] * t1[3]);
                            return [
                                e1 * t1[4],
                                -e1 * t1[1],
                                e1 * (t1[1] * t1[5] - t1[2] * t1[4]),
                                -e1 * t1[3],
                                e1 * t1[0],
                                e1 * (t1[2] * t1[3] - t1[0] * t1[5])
                            ];
                        }(i), o = [
                            i[0] * o[0] + i[1] * o[1] + i[2],
                            i[3] * o[0] + i[4] * o[1] + i[5]
                        ]), n && t1 === function(t1) {
                            return e1(t1[0] * E, t1[1] * E);
                        }(s = n(o))) return s;
                        for(var s, l = t1.children, c = 0, u = l && l.length; c < u; ++c)if (s = a(l[c], r)) return s;
                    }
                    !function t1(e1, r) {
                        if (e1.edges = function(t1) {
                            for(var e1 = t1.length, r = [], n = t1[e1 - 1], i = 0; i < e1; ++i)r.push([
                                n,
                                n = t1[i]
                            ]);
                            return r;
                        }(e1.face), r.face) {
                            var n = e1.shared = function(t1, e1) {
                                for(var r, n, i = t1.length, a = null, o = 0; o < i; ++o){
                                    r = t1[o];
                                    for(var s = e1.length; --s >= 0;)if (n = e1[s], r[0] === n[0] && r[1] === n[1]) {
                                        if (a) return [
                                            a,
                                            r
                                        ];
                                        a = r;
                                    }
                                }
                            }(e1.face, r.face), i = (u = n.map(r.project), h = n.map(e1.project), f = Ln(u[1], u[0]), p = Ln(h[1], h[0]), d = function(t1, e1) {
                                return o(t1[0] * e1[1] - t1[1] * e1[0], t1[0] * e1[0] + t1[1] * e1[1]);
                            }(f, p), m = In(f) / In(p), Cn([
                                1,
                                0,
                                u[0][0],
                                0,
                                1,
                                u[0][1]
                            ], Cn([
                                m,
                                0,
                                0,
                                0,
                                m,
                                0
                            ], Cn([
                                s(d),
                                g(d),
                                0,
                                -g(d),
                                s(d),
                                0
                            ], [
                                1,
                                0,
                                -h[0][0],
                                0,
                                1,
                                -h[0][1]
                            ]))));
                            e1.transform = r.transform ? Cn(r.transform, i) : i;
                            for(var a = r.edges, l = 0, c = a.length; l < c; ++l)On(n[0], a[l][1]) && On(n[1], a[l][0]) && (a[l] = e1), On(n[0], a[l][0]) && On(n[1], a[l][1]) && (a[l] = e1);
                            for(l = 0, c = (a = e1.edges).length; l < c; ++l)On(n[0], a[l][0]) && On(n[1], a[l][1]) && (a[l] = r), On(n[0], a[l][1]) && On(n[1], a[l][0]) && (a[l] = r);
                        } else e1.transform = r.transform;
                        var u, h, f, p, d, m;
                        return e1.children && e1.children.forEach(function(r) {
                            t1(r, e1);
                        }), e1;
                    }(t1, {
                        transform: null
                    }), Dn(t1) && (i.invert = function(e1, r) {
                        var n = a(t1, [
                            e1,
                            -r
                        ]);
                        return n && (n[0] *= E, n[1] *= E, n);
                    });
                    var l = (0, n.A)(i), c = l.stream;
                    return l.stream = function(e1) {
                        var r = l.rotate(), n = c(e1), i = (l.rotate([
                            0,
                            0
                        ]), c(e1));
                        return l.rotate(r), n.sphere = function() {
                            i.polygonStart(), i.lineStart(), zn(i, t1), i.lineEnd(), i.polygonEnd();
                        }, n;
                    }, l.angle(null == r ? -30 : r * S);
                }
                function zn(t1, e1, r) {
                    var n, a, o = e1.edges, s = o.length, l = {
                        type: "MultiPoint",
                        coordinates: e1.face
                    }, c = e1.face.filter(function(t1) {
                        return 90 !== i(t1[1]);
                    }), u = (0, Sn.A)({
                        type: "MultiPoint",
                        coordinates: c
                    }), h = !1, f = -1, p = u[1][0] - u[0][0], d = 180 === p || 360 === p ? [
                        (u[0][0] + u[1][0]) / 2,
                        (u[0][1] + u[1][1]) / 2
                    ] : (0, _t.A)(l);
                    if (r) for(; ++f < s && o[f] !== r;);
                    ++f;
                    for(var m = 0; m < s; ++m)a = o[(m + f) % s], Array.isArray(a) ? (h || (t1.point((n = (0, En.A)(a[0], d)(v))[0], n[1]), h = !0), t1.point((n = (0, En.A)(a[1], d)(v))[0], n[1])) : (h = !1, a !== r && zn(t1, a, e1));
                }
                function On(t1, e1) {
                    return t1 && e1 && t1[0] === e1[0] && t1[1] === e1[1];
                }
                function Dn(t1) {
                    return t1.project.invert || t1.children && t1.children.some(Dn);
                }
                var Rn = r(48419), Fn = [
                    [
                        0,
                        90
                    ],
                    [
                        -90,
                        0
                    ],
                    [
                        0,
                        0
                    ],
                    [
                        90,
                        0
                    ],
                    [
                        180,
                        0
                    ],
                    [
                        0,
                        -90
                    ]
                ], Bn = [
                    [
                        0,
                        2,
                        1
                    ],
                    [
                        0,
                        3,
                        2
                    ],
                    [
                        5,
                        1,
                        2
                    ],
                    [
                        5,
                        2,
                        3
                    ],
                    [
                        0,
                        1,
                        4
                    ],
                    [
                        0,
                        4,
                        3
                    ],
                    [
                        5,
                        4,
                        1
                    ],
                    [
                        5,
                        3,
                        4
                    ]
                ].map(function(t1) {
                    return t1.map(function(t1) {
                        return Fn[t1];
                    });
                });
                function Nn(t1) {
                    t1 = t1 || function(t1) {
                        var e1 = (0, _t.A)({
                            type: "MultiPoint",
                            coordinates: t1
                        });
                        return (0, Rn.A)().scale(1).translate([
                            0,
                            0
                        ]).rotate([
                            -e1[0],
                            -e1[1]
                        ]);
                    };
                    var e1 = Bn.map(function(e1) {
                        return {
                            face: e1,
                            project: t1(e1)
                        };
                    });
                    return [
                        -1,
                        0,
                        0,
                        1,
                        0,
                        1,
                        4,
                        5
                    ].forEach(function(t1, r) {
                        var n = e1[t1];
                        n && (n.children || (n.children = [])).push(e1[r]);
                    }), Pn(e1[0], function(t1, r) {
                        return e1[t1 < -_ / 2 ? r < 0 ? 6 : 4 : t1 < 0 ? r < 0 ? 2 : 0 : t1 < _ / 2 ? r < 0 ? 3 : 1 : r < 0 ? 7 : 5];
                    }).angle(-30).scale(101.858).center([
                        0,
                        45
                    ]);
                }
                var jn = 2 / I(3);
                function Un(t1, e1) {
                    var r = Ct(t1, e1);
                    return [
                        r[0] * jn,
                        r[1]
                    ];
                }
                function Vn(t1) {
                    t1 = t1 || function(t1) {
                        var e1 = (0, _t.A)({
                            type: "MultiPoint",
                            coordinates: t1
                        });
                        return (0, n.A)(Un).translate([
                            0,
                            0
                        ]).scale(1).rotate(e1[1] > 0 ? [
                            -e1[0],
                            0
                        ] : [
                            180 - e1[0],
                            180
                        ]);
                    };
                    var e1 = Bn.map(function(e1) {
                        return {
                            face: e1,
                            project: t1(e1)
                        };
                    });
                    return [
                        -1,
                        0,
                        0,
                        1,
                        0,
                        1,
                        4,
                        5
                    ].forEach(function(t1, r) {
                        var n = e1[t1];
                        n && (n.children || (n.children = [])).push(e1[r]);
                    }), Pn(e1[0], function(t1, r) {
                        return e1[t1 < -_ / 2 ? r < 0 ? 6 : 4 : t1 < 0 ? r < 0 ? 2 : 0 : t1 < _ / 2 ? r < 0 ? 3 : 1 : r < 0 ? 7 : 5];
                    }).angle(-30).scale(121.906).center([
                        0,
                        48.5904
                    ]);
                }
                function qn(t1) {
                    t1 = t1 || function(t1) {
                        var e1 = 6 === t1.length ? (0, _t.A)({
                            type: "MultiPoint",
                            coordinates: t1
                        }) : t1[0];
                        return (0, Rn.A)().scale(1).translate([
                            0,
                            0
                        ]).rotate([
                            -e1[0],
                            -e1[1]
                        ]);
                    };
                    var e1 = Bn.map(function(t1) {
                        for(var e1, r = t1.map(Zn), n = r.length, i = r[n - 1], a = [], o = 0; o < n; ++o)e1 = r[o], a.push(Gn([
                            .9486832980505138 * i[0] + .31622776601683794 * e1[0],
                            .9486832980505138 * i[1] + .31622776601683794 * e1[1],
                            .9486832980505138 * i[2] + .31622776601683794 * e1[2]
                        ]), Gn([
                            .9486832980505138 * e1[0] + .31622776601683794 * i[0],
                            .9486832980505138 * e1[1] + .31622776601683794 * i[1],
                            .9486832980505138 * e1[2] + .31622776601683794 * i[2]
                        ])), i = e1;
                        return a;
                    }), r = [], n = [
                        -1,
                        0,
                        0,
                        1,
                        0,
                        1,
                        4,
                        5
                    ];
                    e1.forEach(function(t1, i) {
                        for(var a, o, s = Bn[i], l = s.length, c = r[i] = [], u = 0; u < l; ++u)e1.push([
                            s[u],
                            t1[(2 * u + 2) % (2 * l)],
                            t1[(2 * u + 1) % (2 * l)]
                        ]), n.push(i), c.push((a = Zn(t1[(2 * u + 2) % (2 * l)]), o = Zn(t1[(2 * u + 1) % (2 * l)]), [
                            a[1] * o[2] - a[2] * o[1],
                            a[2] * o[0] - a[0] * o[2],
                            a[0] * o[1] - a[1] * o[0]
                        ]));
                    });
                    var i = e1.map(function(e1) {
                        return {
                            project: t1(e1),
                            face: e1
                        };
                    });
                    return n.forEach(function(t1, e1) {
                        var r = i[t1];
                        r && (r.children || (r.children = [])).push(i[e1]);
                    }), Pn(i[0], function(t1, e1) {
                        var n = s(e1), a = [
                            n * s(t1),
                            n * g(t1),
                            g(e1)
                        ], o = t1 < -_ / 2 ? e1 < 0 ? 6 : 4 : t1 < 0 ? e1 < 0 ? 2 : 0 : t1 < _ / 2 ? e1 < 0 ? 3 : 1 : e1 < 0 ? 7 : 5, l = r[o];
                        return i[Hn(l[0], a) < 0 ? 8 + 3 * o : Hn(l[1], a) < 0 ? 8 + 3 * o + 1 : Hn(l[2], a) < 0 ? 8 + 3 * o + 2 : o];
                    }).angle(-30).scale(110.625).center([
                        0,
                        45
                    ]);
                }
                function Hn(t1, e1) {
                    for(var r = 0, n = t1.length, i = 0; r < n; ++r)i += t1[r] * e1[r];
                    return i;
                }
                function Gn(t1) {
                    return [
                        o(t1[1], t1[0]) * S,
                        C(h(-1, f(1, t1[2]))) * S
                    ];
                }
                function Zn(t1) {
                    var e1 = t1[0] * E, r = t1[1] * E, n = s(r);
                    return [
                        n * s(e1),
                        n * g(e1),
                        g(r)
                    ];
                }
                function Wn() {}
                function Yn(t1, e1) {
                    var r, n = e1.stream;
                    if (!n) throw new Error("invalid projection");
                    switch(t1 && t1.type){
                        case "Feature":
                            r = $n;
                            break;
                        case "FeatureCollection":
                            r = Xn;
                            break;
                        default:
                            r = Jn;
                    }
                    return r(t1, n);
                }
                function Xn(t1, e1) {
                    return {
                        type: "FeatureCollection",
                        features: t1.features.map(function(t1) {
                            return $n(t1, e1);
                        })
                    };
                }
                function $n(t1, e1) {
                    return {
                        type: "Feature",
                        id: t1.id,
                        properties: t1.properties,
                        geometry: Jn(t1.geometry, e1)
                    };
                }
                function Jn(t1, e1) {
                    if (!t1) return null;
                    if ("GeometryCollection" === t1.type) return function(t1, e1) {
                        return {
                            type: "GeometryCollection",
                            geometries: t1.geometries.map(function(t1) {
                                return Jn(t1, e1);
                            })
                        };
                    }(t1, e1);
                    var r;
                    switch(t1.type){
                        case "Point":
                        case "MultiPoint":
                            r = ti;
                            break;
                        case "LineString":
                        case "MultiLineString":
                            r = ei;
                            break;
                        case "Polygon":
                        case "MultiPolygon":
                        case "Sphere":
                            r = ri;
                            break;
                        default:
                            return null;
                    }
                    return (0, je.A)(t1, e1(r)), r.result();
                }
                Un.invert = function(t1, e1) {
                    return Ct.invert(t1 / jn, e1);
                };
                var Kn = [], Qn = [], ti = {
                    point: function(t1, e1) {
                        Kn.push([
                            t1,
                            e1
                        ]);
                    },
                    result: function() {
                        var t1 = Kn.length ? Kn.length < 2 ? {
                            type: "Point",
                            coordinates: Kn[0]
                        } : {
                            type: "MultiPoint",
                            coordinates: Kn
                        } : null;
                        return Kn = [], t1;
                    }
                }, ei = {
                    lineStart: Wn,
                    point: function(t1, e1) {
                        Kn.push([
                            t1,
                            e1
                        ]);
                    },
                    lineEnd: function() {
                        Kn.length && (Qn.push(Kn), Kn = []);
                    },
                    result: function() {
                        var t1 = Qn.length ? Qn.length < 2 ? {
                            type: "LineString",
                            coordinates: Qn[0]
                        } : {
                            type: "MultiLineString",
                            coordinates: Qn
                        } : null;
                        return Qn = [], t1;
                    }
                }, ri = {
                    polygonStart: Wn,
                    lineStart: Wn,
                    point: function(t1, e1) {
                        Kn.push([
                            t1,
                            e1
                        ]);
                    },
                    lineEnd: function() {
                        var t1 = Kn.length;
                        if (t1) {
                            do Kn.push(Kn[0].slice());
                            while (++t1 < 4);
                            Qn.push(Kn), Kn = [];
                        }
                    },
                    polygonEnd: Wn,
                    result: function() {
                        if (!Qn.length) return null;
                        var t1 = [], e1 = [];
                        return Qn.forEach(function(r) {
                            !function(t1) {
                                if ((e1 = t1.length) < 4) return !1;
                                for(var e1, r = 0, n = t1[e1 - 1][1] * t1[0][0] - t1[e1 - 1][0] * t1[0][1]; ++r < e1;)n += t1[r - 1][1] * t1[r][0] - t1[r - 1][0] * t1[r][1];
                                return n <= 0;
                            }(r) ? e1.push(r) : t1.push([
                                r
                            ]);
                        }), e1.forEach(function(e1) {
                            var r = e1[0];
                            t1.some(function(t1) {
                                if (function(t1, e1) {
                                    for(var r = e1[0], n = e1[1], i = !1, a = 0, o = t1.length, s = o - 1; a < o; s = a++){
                                        var l = t1[a], c = l[0], u = l[1], h = t1[s], f = h[0], p = h[1];
                                        u > n ^ p > n && r < (f - c) * (n - u) / (p - u) + c && (i = !i);
                                    }
                                    return i;
                                }(t1[0], r)) return t1.push(e1), !0;
                            }) || t1.push([
                                e1
                            ]);
                        }), Qn = [], t1.length ? t1.length > 1 ? {
                            type: "MultiPolygon",
                            coordinates: t1
                        } : {
                            type: "Polygon",
                            coordinates: t1[0]
                        } : null;
                    }
                };
                function ni(t1) {
                    var e1 = t1(b, 0)[0] - t1(-b, 0)[0];
                    function r(r, n) {
                        var a = i(r) < b, o = t1(a ? r : r > 0 ? r - _ : r + _, n), s = (o[0] - o[1]) * T, l = (o[0] + o[1]) * T;
                        if (a) return [
                            s,
                            l
                        ];
                        var c = e1 * T, u = s > 0 ^ l > 0 ? -1 : 1;
                        return [
                            u * s - m(l) * c,
                            u * l - m(s) * c
                        ];
                    }
                    return t1.invert && (r.invert = function(r, n) {
                        var a = (r + n) * T, o = (n - r) * T, s = i(a) < .5 * e1 && i(o) < .5 * e1;
                        if (!s) {
                            var l = e1 * T, c = a > 0 ^ o > 0 ? -1 : 1, u = -c * r + (o > 0 ? 1 : -1) * l, h = -c * n + (a > 0 ? 1 : -1) * l;
                            a = (-u - h) * T, o = (u - h) * T;
                        }
                        var f = t1.invert(a, o);
                        return s || (f[0] += a > 0 ? _ : -_), f;
                    }), (0, n.A)(r).rotate([
                        -90,
                        -90,
                        45
                    ]).clipAngle(179.999);
                }
                function ii() {
                    return ni(Ce).scale(176.423);
                }
                function ai() {
                    return ni(ze).scale(111.48);
                }
                function oi(t1, e1) {
                    if (!(0 <= (e1 = +e1) && e1 <= 20)) throw new Error("invalid digits");
                    function r(t1) {
                        var r = t1.length, n = 2, i = new Array(r);
                        for(i[0] = +t1[0].toFixed(e1), i[1] = +t1[1].toFixed(e1); n < r;)i[n] = t1[n], ++n;
                        return i;
                    }
                    function n(t1) {
                        return t1.map(r);
                    }
                    function i(t1) {
                        for(var e1 = r(t1[0]), n = [
                            e1
                        ], i = 1; i < t1.length; i++){
                            var a = r(t1[i]);
                            (a.length > 2 || a[0] != e1[0] || a[1] != e1[1]) && (n.push(a), e1 = a);
                        }
                        return 1 === n.length && t1.length > 1 && n.push(r(t1[t1.length - 1])), n;
                    }
                    function a(t1) {
                        return t1.map(i);
                    }
                    function o(t1) {
                        if (null == t1) return t1;
                        var e1;
                        switch(t1.type){
                            case "GeometryCollection":
                                e1 = {
                                    type: "GeometryCollection",
                                    geometries: t1.geometries.map(o)
                                };
                                break;
                            case "Point":
                                e1 = {
                                    type: "Point",
                                    coordinates: r(t1.coordinates)
                                };
                                break;
                            case "MultiPoint":
                                e1 = {
                                    type: t1.type,
                                    coordinates: n(t1.coordinates)
                                };
                                break;
                            case "LineString":
                                e1 = {
                                    type: t1.type,
                                    coordinates: i(t1.coordinates)
                                };
                                break;
                            case "MultiLineString":
                            case "Polygon":
                                e1 = {
                                    type: t1.type,
                                    coordinates: a(t1.coordinates)
                                };
                                break;
                            case "MultiPolygon":
                                e1 = {
                                    type: "MultiPolygon",
                                    coordinates: t1.coordinates.map(a)
                                };
                                break;
                            default:
                                return t1;
                        }
                        return null != t1.bbox && (e1.bbox = t1.bbox), e1;
                    }
                    function s(t1) {
                        var e1 = {
                            type: "Feature",
                            properties: t1.properties,
                            geometry: o(t1.geometry)
                        };
                        return null != t1.id && (e1.id = t1.id), null != t1.bbox && (e1.bbox = t1.bbox), e1;
                    }
                    if (null != t1) switch(t1.type){
                        case "Feature":
                            return s(t1);
                        case "FeatureCollection":
                            var l = {
                                type: "FeatureCollection",
                                features: t1.features.map(s)
                            };
                            return null != t1.bbox && (l.bbox = t1.bbox), l;
                        default:
                            return o(t1);
                    }
                    return t1;
                }
                function si(t1) {
                    var e1 = g(t1);
                    function r(r, n) {
                        var i = e1 ? y(r * e1 / 2) / e1 : r / 2;
                        if (!n) return [
                            2 * i,
                            -t1
                        ];
                        var o = 2 * a(i * g(n)), l = 1 / y(n);
                        return [
                            g(o) * l,
                            n + (1 - s(o)) * l - t1
                        ];
                    }
                    return r.invert = function(r, n) {
                        if (i(n += t1) < v) return [
                            e1 ? 2 * a(e1 * r / 2) / e1 : r,
                            0
                        ];
                        var o, l = r * r + n * n, c = 0, u = 10;
                        do {
                            var h = y(c), f = 1 / s(c), p = l - 2 * n * c + c * c;
                            c -= o = (h * p + 2 * (c - n)) / (2 + p * f * f + 2 * (c - n) * h);
                        }while (i(o) > v && --u > 0);
                        var d = r * (h = y(c)), m = y(i(n) < i(c + 1 / h) ? .5 * C(d) : .5 * L(d) + _ / 4) / g(c);
                        return [
                            e1 ? 2 * a(e1 * m) / e1 : 2 * m,
                            c
                        ];
                    }, r;
                }
                function li() {
                    return ht(si).scale(131.215);
                }
                var ci = [
                    [
                        .9986,
                        -0.062
                    ],
                    [
                        1,
                        0
                    ],
                    [
                        .9986,
                        .062
                    ],
                    [
                        .9954,
                        .124
                    ],
                    [
                        .99,
                        .186
                    ],
                    [
                        .9822,
                        .248
                    ],
                    [
                        .973,
                        .31
                    ],
                    [
                        .96,
                        .372
                    ],
                    [
                        .9427,
                        .434
                    ],
                    [
                        .9216,
                        .4958
                    ],
                    [
                        .8962,
                        .5571
                    ],
                    [
                        .8679,
                        .6176
                    ],
                    [
                        .835,
                        .6769
                    ],
                    [
                        .7986,
                        .7346
                    ],
                    [
                        .7597,
                        .7903
                    ],
                    [
                        .7186,
                        .8435
                    ],
                    [
                        .6732,
                        .8936
                    ],
                    [
                        .6213,
                        .9394
                    ],
                    [
                        .5722,
                        .9761
                    ],
                    [
                        .5322,
                        1
                    ]
                ];
                function ui(t1, e1) {
                    var r, n = f(18, 36 * i(e1) / _), a = c(n), o = n - a, s = (r = ci[a])[0], l = r[1], u = (r = ci[++a])[0], h = r[1], p = (r = ci[f(19, ++a)])[0], d = r[1];
                    return [
                        t1 * (u + o * (p - s) / 2 + o * o * (p - 2 * u + s) / 2),
                        (e1 > 0 ? b : -b) * (h + o * (d - l) / 2 + o * o * (d - 2 * h + l) / 2)
                    ];
                }
                function hi() {
                    return (0, n.A)(ui).scale(152.63);
                }
                function fi(t1, e1) {
                    var r = function(t1) {
                        function e1(e1, r) {
                            var n = s(r), i = (t1 - 1) / (t1 - n * s(e1));
                            return [
                                i * n * g(e1),
                                i * g(r)
                            ];
                        }
                        return e1.invert = function(e1, r) {
                            var n = e1 * e1 + r * r, i = I(n), a = (t1 - I(1 - n * (t1 + 1) / (t1 - 1))) / ((t1 - 1) / i + i / (t1 - 1));
                            return [
                                o(e1 * a, i * I(1 - a * a)),
                                i ? C(r * a / i) : 0
                            ];
                        }, e1;
                    }(t1);
                    if (!e1) return r;
                    var n = s(e1), i = g(e1);
                    function a(e1, a) {
                        var o = r(e1, a), s = o[1], l = s * i / (t1 - 1) + n;
                        return [
                            o[0] * n / l,
                            s / l
                        ];
                    }
                    return a.invert = function(e1, a) {
                        var o = (t1 - 1) / (t1 - 1 - a * i);
                        return r.invert(o * e1, o * a * n);
                    }, a;
                }
                function pi() {
                    var t1 = 2, e1 = 0, r = (0, n.U)(fi), i = r(t1, e1);
                    return i.distance = function(n) {
                        return arguments.length ? r(t1 = +n, e1) : t1;
                    }, i.tilt = function(n) {
                        return arguments.length ? r(t1, e1 = n * E) : e1 * S;
                    }, i.scale(432.147).clipAngle(L(1 / t1) * S - 1e-6);
                }
                ci.forEach(function(t1) {
                    t1[1] *= 1.0144;
                }), ui.invert = function(t1, e1) {
                    var r = e1 / b, n = 90 * r, a = f(18, i(n / 5)), o = h(0, c(a));
                    do {
                        var s = ci[o][1], l = ci[o + 1][1], u = ci[f(19, o + 2)][1], p = u - s, d = u - 2 * l + s, m = 2 * (i(r) - l) / p, g = d / p, y = m * (1 - g * m * (1 - 2 * g * m));
                        if (y >= 0 || 1 === o) {
                            n = (e1 >= 0 ? 5 : -5) * (y + a);
                            var v, _ = 50;
                            do y = (a = f(18, i(n) / 5)) - (o = c(a)), s = ci[o][1], l = ci[o + 1][1], u = ci[f(19, o + 2)][1], n -= (v = (e1 >= 0 ? b : -b) * (l + y * (u - s) / 2 + y * y * (u - 2 * l + s) / 2) - e1) * S;
                            while (i(v) > x && --_ > 0);
                            break;
                        }
                    }while (--o >= 0);
                    var w = ci[o][0], T = ci[o + 1][0], k = ci[f(19, o + 2)][0];
                    return [
                        t1 / (T + y * (k - w) / 2 + y * y * (k - 2 * T + w) / 2),
                        n * E
                    ];
                };
                var di = 1e-4, mi = 1e4, gi = -180, yi = gi + di, vi = 180, xi = vi - di, _i = -90, bi = _i + di, wi = 90, Ti = wi - di;
                function ki(t1) {
                    return t1.length > 0;
                }
                function Ai(t1) {
                    var e1;
                    return t1 === _i || t1 === wi ? [
                        0,
                        t1
                    ] : [
                        gi,
                        (e1 = t1, Math.floor(e1 * mi) / mi)
                    ];
                }
                function Mi(t1) {
                    var e1 = t1[0], r = t1[1], n = !1;
                    return e1 <= yi ? (e1 = gi, n = !0) : e1 >= xi && (e1 = vi, n = !0), r <= bi ? (r = _i, n = !0) : r >= Ti && (r = wi, n = !0), n ? [
                        e1,
                        r
                    ] : t1;
                }
                function Si(t1) {
                    return t1.map(Mi);
                }
                function Ei(t1, e1, r) {
                    for(var n = 0, i = t1.length; n < i; ++n){
                        var a = t1[n].slice();
                        r.push({
                            index: -1,
                            polygon: e1,
                            ring: a
                        });
                        for(var o = 0, s = a.length; o < s; ++o){
                            var l = a[o], c = l[0], u = l[1];
                            if (c <= yi || c >= xi || u <= bi || u >= Ti) {
                                a[o] = Mi(l);
                                for(var h = o + 1; h < s; ++h){
                                    var f = a[h], p = f[0], d = f[1];
                                    if (p > yi && p < xi && d > bi && d < Ti) break;
                                }
                                if (h === o + 1) continue;
                                if (o) {
                                    var m = {
                                        index: -1,
                                        polygon: e1,
                                        ring: a.slice(0, o + 1)
                                    };
                                    m.ring[m.ring.length - 1] = Ai(u), r[r.length - 1] = m;
                                } else r.pop();
                                if (h >= s) break;
                                r.push({
                                    index: -1,
                                    polygon: e1,
                                    ring: a = a.slice(h - 1)
                                }), a[0] = Ai(a[0][1]), o = -1, s = a.length;
                            }
                        }
                    }
                }
                function Ci(t1) {
                    var e1, r, n, i, a, o, s = t1.length, l = {}, c = {};
                    for(e1 = 0; e1 < s; ++e1)n = (r = t1[e1]).ring[0], a = r.ring[r.ring.length - 1], n[0] !== a[0] || n[1] !== a[1] ? (r.index = e1, l[n] = c[a] = r) : (r.polygon.push(r.ring), t1[e1] = null);
                    for(e1 = 0; e1 < s; ++e1)if (r = t1[e1]) {
                        if (n = r.ring[0], a = r.ring[r.ring.length - 1], i = c[n], o = l[a], delete l[n], delete c[a], n[0] === a[0] && n[1] === a[1]) {
                            r.polygon.push(r.ring);
                            continue;
                        }
                        i ? (delete c[n], delete l[i.ring[0]], i.ring.pop(), t1[i.index] = null, r = {
                            index: -1,
                            polygon: i.polygon,
                            ring: i.ring.concat(r.ring)
                        }, i === o ? r.polygon.push(r.ring) : (r.index = s++, t1.push(l[r.ring[0]] = c[r.ring[r.ring.length - 1]] = r))) : o ? (delete l[a], delete c[o.ring[o.ring.length - 1]], r.ring.pop(), r = {
                            index: s++,
                            polygon: o.polygon,
                            ring: r.ring.concat(o.ring)
                        }, t1[o.index] = null, t1.push(l[r.ring[0]] = c[r.ring[r.ring.length - 1]] = r)) : (r.ring.push(r.ring[0]), r.polygon.push(r.ring));
                    }
                }
                function Li(t1) {
                    var e1 = {
                        type: "Feature",
                        geometry: Ii(t1.geometry)
                    };
                    return null != t1.id && (e1.id = t1.id), null != t1.bbox && (e1.bbox = t1.bbox), null != t1.properties && (e1.properties = t1.properties), e1;
                }
                function Ii(t1) {
                    if (null == t1) return t1;
                    var e1, r, n, i;
                    switch(t1.type){
                        case "GeometryCollection":
                            e1 = {
                                type: "GeometryCollection",
                                geometries: t1.geometries.map(Ii)
                            };
                            break;
                        case "Point":
                            e1 = {
                                type: "Point",
                                coordinates: Mi(t1.coordinates)
                            };
                            break;
                        case "MultiPoint":
                        case "LineString":
                            e1 = {
                                type: t1.type,
                                coordinates: Si(t1.coordinates)
                            };
                            break;
                        case "MultiLineString":
                            e1 = {
                                type: "MultiLineString",
                                coordinates: t1.coordinates.map(Si)
                            };
                            break;
                        case "Polygon":
                            var a = [];
                            Ei(t1.coordinates, a, r = []), Ci(r), e1 = {
                                type: "Polygon",
                                coordinates: a
                            };
                            break;
                        case "MultiPolygon":
                            r = [], n = -1, i = t1.coordinates.length;
                            for(var o = new Array(i); ++n < i;)Ei(t1.coordinates[n], o[n] = [], r);
                            Ci(r), e1 = {
                                type: "MultiPolygon",
                                coordinates: o.filter(ki)
                            };
                            break;
                        default:
                            return t1;
                    }
                    return null != t1.bbox && (e1.bbox = t1.bbox), e1;
                }
                function Pi(t1) {
                    if (null == t1) return t1;
                    switch(t1.type){
                        case "Feature":
                            return Li(t1);
                        case "FeatureCollection":
                            var e1 = {
                                type: "FeatureCollection",
                                features: t1.features.map(Li)
                            };
                            return null != t1.bbox && (e1.bbox = t1.bbox), e1;
                        default:
                            return Ii(t1);
                    }
                }
                function zi(t1, e1) {
                    var r = y(e1 / 2), n = g(w * r);
                    return [
                        t1 * (.74482 - .34588 * n * n),
                        1.70711 * r
                    ];
                }
                function Oi() {
                    return (0, n.A)(zi).scale(146.153);
                }
                function Di(t1, e1, r) {
                    var i = (0, En.A)(e1, r), a = i(.5), o = (0, bt.A)([
                        -a[0],
                        -a[1]
                    ])(e1), s = i.distance / 2, l = -C(g(o[1] * E) / g(s)), c = [
                        -a[0],
                        -a[1],
                        -(o[0] > 0 ? _ - l : l) * S
                    ], u = (0, n.A)(t1(s)).rotate(c), h = (0, bt.A)(c), f = u.center;
                    return delete u.rotate, u.center = function(t1) {
                        return arguments.length ? f(h(t1)) : h.invert(f());
                    }, u.clipAngle(90);
                }
                function Ri(t1) {
                    var e1 = s(t1);
                    function r(t1, r) {
                        var n = (0, Rn.T)(t1, r);
                        return n[0] *= e1, n;
                    }
                    return r.invert = function(t1, r) {
                        return Rn.T.invert(t1 / e1, r);
                    }, r;
                }
                function Fi() {
                    return Bi([
                        -158,
                        21.5
                    ], [
                        -77,
                        39
                    ]).clipAngle(60).scale(400);
                }
                function Bi(t1, e1) {
                    return Di(Ri, t1, e1);
                }
                function Ni(t1) {
                    if (!(t1 *= 2)) return Z.j;
                    var e1 = -t1 / 2, r = -e1, n = t1 * t1, i = y(r), a = .5 / g(r);
                    function l(i, a) {
                        var o = L(s(a) * s(i - e1)), l = L(s(a) * s(i - r));
                        return [
                            ((o *= o) - (l *= l)) / (2 * t1),
                            (a < 0 ? -1 : 1) * I(4 * n * l - (n - o + l) * (n - o + l)) / (2 * t1)
                        ];
                    }
                    return l.invert = function(t1, n) {
                        var l, c, u = n * n, h = s(I(u + (l = t1 + e1) * l)), f = s(I(u + (l = t1 + r) * l));
                        return [
                            o(c = h - f, l = (h + f) * i),
                            (n < 0 ? -1 : 1) * L(I(l * l + c * c) * a)
                        ];
                    }, l;
                }
                function ji() {
                    return Ui([
                        -158,
                        21.5
                    ], [
                        -77,
                        39
                    ]).clipAngle(130).scale(122.571);
                }
                function Ui(t1, e1) {
                    return Di(Ni, t1, e1);
                }
                function Vi(t1, e1) {
                    if (i(e1) < v) return [
                        t1,
                        0
                    ];
                    var r = i(e1 / b), n = C(r);
                    if (i(t1) < v || i(i(e1) - b) < v) return [
                        0,
                        m(e1) * _ * y(n / 2)
                    ];
                    var a = s(n), o = i(_ / t1 - t1 / _) / 2, l = o * o, c = a / (r + a - 1), u = c * (2 / r - 1), h = u * u, f = h + l, p = c - h, d = l + c;
                    return [
                        m(t1) * _ * (o * p + I(l * p * p - f * (c * c - h))) / f,
                        m(e1) * _ * (u * d - o * I((l + 1) * f - d * d)) / f
                    ];
                }
                function qi() {
                    return (0, n.A)(Vi).scale(79.4183);
                }
                function Hi(t1, e1) {
                    if (i(e1) < v) return [
                        t1,
                        0
                    ];
                    var r = i(e1 / b), n = C(r);
                    if (i(t1) < v || i(i(e1) - b) < v) return [
                        0,
                        m(e1) * _ * y(n / 2)
                    ];
                    var a = s(n), o = i(_ / t1 - t1 / _) / 2, l = o * o, c = a * (I(1 + l) - o * a) / (1 + l * r * r);
                    return [
                        m(t1) * _ * c,
                        m(e1) * _ * I(1 - c * (2 * o + c))
                    ];
                }
                function Gi() {
                    return (0, n.A)(Hi).scale(79.4183);
                }
                function Zi(t1, e1) {
                    if (i(e1) < v) return [
                        t1,
                        0
                    ];
                    var r = e1 / b, n = C(r);
                    if (i(t1) < v || i(i(e1) - b) < v) return [
                        0,
                        _ * y(n / 2)
                    ];
                    var a = (_ / t1 - t1 / _) / 2, o = r / (1 + s(n));
                    return [
                        _ * (m(t1) * I(a * a + 1 - o * o) - a),
                        _ * o
                    ];
                }
                function Wi() {
                    return (0, n.A)(Zi).scale(79.4183);
                }
                function Yi(t1, e1) {
                    if (!e1) return [
                        t1,
                        0
                    ];
                    var r = i(e1);
                    if (!t1 || r === b) return [
                        0,
                        e1
                    ];
                    var n = r / b, a = n * n, o = (8 * n - a * (a + 2) - 5) / (2 * a * (n - 1)), s = o * o, l = n * o, c = a + s + 2 * l, u = n + 3 * o, h = t1 / b, f = h + 1 / h, p = m(i(t1) - b) * I(f * f - 4), d = p * p, g = (p * (c + s - 1) + 2 * I(c * (a + s * d - 1) + (1 - a) * (a * (u * u + 4 * s) + 12 * l * s + 4 * s * s))) / (4 * c + d);
                    return [
                        m(t1) * b * g,
                        m(e1) * b * I(1 + p * i(g) - g * g)
                    ];
                }
                function Xi() {
                    return (0, n.A)(Yi).scale(127.16);
                }
                function $i(t1, e1, r, n) {
                    var i = _ / 3;
                    t1 = h(t1, v), e1 = h(e1, v), t1 = f(t1, b), e1 = f(e1, _ - v), r = h(r, 0), r = f(r, 100 - v);
                    var a = (n = h(n, v)) / 100, l = L((r / 100 + 1) * s(i)) / i, c = g(t1) / g(l * b), u = e1 / _, p = I(a * g(t1 / 2) / g(e1 / 2));
                    return function(t1, e1, r, n, i) {
                        function a(a, o) {
                            var l = r * g(n * o), c = I(1 - l * l), u = I(2 / (1 + c * s(a *= i)));
                            return [
                                t1 * c * u * g(a),
                                e1 * l * u
                            ];
                        }
                        return a.invert = function(a, s) {
                            var l = a / t1, c = s / e1, u = I(l * l + c * c), h = 2 * C(u / 2);
                            return [
                                o(a * y(h), t1 * u) / i,
                                u && C(s * g(h) / (e1 * r * u)) / n
                            ];
                        }, a;
                    }(p / I(u * c * l), 1 / (p * I(u * c * l)), c, l, u);
                }
                function Ji() {
                    var t1 = 65 * E, e1 = 60 * E, r = 20, i = 200, a = (0, n.U)($i), o = a(t1, e1, r, i);
                    return o.poleline = function(n) {
                        return arguments.length ? a(t1 = +n * E, e1, r, i) : t1 * S;
                    }, o.parallels = function(n) {
                        return arguments.length ? a(t1, e1 = +n * E, r, i) : e1 * S;
                    }, o.inflation = function(n) {
                        return arguments.length ? a(t1, e1, r = +n, i) : r;
                    }, o.ratio = function(n) {
                        return arguments.length ? a(t1, e1, r, i = +n) : i;
                    }, o.scale(163.775);
                }
                function Ki() {
                    return Ji().poleline(65).parallels(60).inflation(0).ratio(200).scale(172.633);
                }
                zi.invert = function(t1, e1) {
                    var r = e1 / 1.70711, n = g(w * r);
                    return [
                        t1 / (.74482 - .34588 * n * n),
                        2 * a(r)
                    ];
                }, Vi.invert = function(t1, e1) {
                    if (i(e1) < v) return [
                        t1,
                        0
                    ];
                    if (i(t1) < v) return [
                        0,
                        b * g(2 * a(e1 / _))
                    ];
                    var r = (t1 /= _) * t1, n = (e1 /= _) * e1, o = r + n, l = o * o, c = -i(e1) * (1 + o), u = c - 2 * n + r, h = -2 * c + 1 + 2 * n + l, f = n / h + (2 * u * u * u / (h * h * h) - 9 * c * u / (h * h)) / 27, p = (c - u * u / (3 * h)) / h, d = 2 * I(-p / 3), y = L(3 * f / (p * d)) / 3;
                    return [
                        _ * (o - 1 + I(1 + 2 * (r - n) + l)) / (2 * t1),
                        m(e1) * _ * (-d * s(y + _ / 3) - u / (3 * h))
                    ];
                }, Hi.invert = function(t1, e1) {
                    if (!t1) return [
                        0,
                        b * g(2 * a(e1 / _))
                    ];
                    var r = i(t1 / _), n = (1 - r * r - (e1 /= _) * e1) / (2 * r), s = I(n * n + 1);
                    return [
                        m(t1) * _ * (s - n),
                        m(e1) * b * g(2 * o(I((1 - 2 * n * r) * (n + s) - r), I(s + n + r)))
                    ];
                }, Zi.invert = function(t1, e1) {
                    if (!e1) return [
                        t1,
                        0
                    ];
                    var r = e1 / _, n = (_ * _ * (1 - r * r) - t1 * t1) / (2 * _ * t1);
                    return [
                        t1 ? _ * (m(t1) * I(n * n + 1) - n) : 0,
                        b * g(2 * a(r))
                    ];
                }, Yi.invert = function(t1, e1) {
                    var r;
                    if (!t1 || !e1) return [
                        t1,
                        e1
                    ];
                    e1 /= _;
                    var n = m(t1) * t1 / b, a = (n * n - 1 + 4 * e1 * e1) / i(n), o = a * a, s = 2 * e1, l = 50;
                    do {
                        var c = s * s, u = (8 * s - c * (c + 2) - 5) / (2 * c * (s - 1)), h = (3 * s - c * s - 10) / (2 * c * s), f = u * u, p = s * u, d = s + u, g = d * d, y = s + 3 * u, x = -2 * d * (4 * p * f + (1 - 4 * c + 3 * c * c) * (1 + h) + f * (14 * c - 6 - o + (8 * c - 8 - 2 * o) * h) + p * (12 * c - 8 + (10 * c - 10 - o) * h)), w = I(g * (c + f * o - 1) + (1 - c) * (c * (y * y + 4 * f) + f * (12 * p + 4 * f)));
                        s -= r = (a * (g + f - 1) + 2 * w - n * (4 * g + o)) / (a * (2 * u * h + 2 * d * (1 + h)) + x / w - 8 * d * (a * (-1 + f + g) + 2 * w) * (1 + h) / (o + 4 * g));
                    }while (r > v && --l > 0);
                    return [
                        m(t1) * (I(a * a + 4) + a) * _ / 4,
                        b * s
                    ];
                };
                var Qi = 4 * _ + 3 * I(3), ta = 2 * I(2 * _ * I(3) / Qi), ea = it(ta * I(3) / _, ta, Qi / 6);
                function ra() {
                    return (0, n.A)(ea).scale(176.84);
                }
                function na(t1, e1) {
                    return [
                        t1 * I(1 - 3 * e1 * e1 / (_ * _)),
                        e1
                    ];
                }
                function ia() {
                    return (0, n.A)(na).scale(152.63);
                }
                function aa(t1, e1) {
                    var r = s(e1), n = s(t1) * r, i = 1 - n, a = s(t1 = o(g(t1) * r, -g(e1))), l = g(t1);
                    return [
                        l * (r = I(1 - n * n)) - a * i,
                        -a * r - l * i
                    ];
                }
                function oa() {
                    return (0, n.A)(aa).rotate([
                        0,
                        -90,
                        45
                    ]).scale(124.75).clipAngle(179.999);
                }
                function sa(t1, e1) {
                    var r = R(t1, e1);
                    return [
                        (r[0] + t1 / b) / 2,
                        (r[1] + e1) / 2
                    ];
                }
                function la() {
                    return (0, n.A)(sa).scale(158.837);
                }
                na.invert = function(t1, e1) {
                    return [
                        t1 / I(1 - 3 * e1 * e1 / (_ * _)),
                        e1
                    ];
                }, aa.invert = function(t1, e1) {
                    var r = (t1 * t1 + e1 * e1) / -2, n = I(-r * (2 + r)), i = e1 * r + t1 * n, a = t1 * r - e1 * n, s = I(a * a + i * i);
                    return [
                        o(n * i, s * (1 + r)),
                        s ? -C(n * a / s) : 0
                    ];
                }, sa.invert = function(t1, e1) {
                    var r = t1, n = e1, a = 25;
                    do {
                        var o, l = s(n), c = g(n), u = g(2 * n), h = c * c, f = l * l, p = g(r), d = s(r / 2), m = g(r / 2), y = m * m, x = 1 - f * d * d, _ = x ? L(l * d) * I(o = 1 / x) : o = 0, w = .5 * (2 * _ * l * m + r / b) - t1, T = .5 * (_ * c + n) - e1, k = .5 * o * (f * y + _ * l * d * h) + .5 / b, A = o * (p * u / 4 - _ * c * m), M = .125 * o * (u * m - _ * c * f * p), S = .5 * o * (h * d + _ * y * l) + .5, E = A * M - S * k, C = (T * A - w * S) / E, P = (w * M - T * k) / E;
                        r -= C, n -= P;
                    }while ((i(C) > v || i(P) > v) && --a > 0);
                    return [
                        r,
                        n
                    ];
                };
            },
            49353: function(t1, e1, r) {
                "use strict";
                function n() {
                    return new i;
                }
                function i() {
                    this.reset();
                }
                r.d(e1, {
                    A: function() {
                        return n;
                    }
                }), i.prototype = {
                    constructor: i,
                    reset: function() {
                        this.s = this.t = 0;
                    },
                    add: function(t1) {
                        o(a, t1, this.t), o(this, a.s, this.s), this.s ? this.t += a.t : this.s = a.t;
                    },
                    valueOf: function() {
                        return this.s;
                    }
                };
                var a = new i;
                function o(t1, e1, r) {
                    var n = t1.s = e1 + r, i = n - e1, a = n - i;
                    t1.t = e1 - a + (r - i);
                }
            },
            43976: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    Ay: function() {
                        return x;
                    },
                    B0: function() {
                        return f;
                    },
                    Y7: function() {
                        return d;
                    }
                });
                var n, i, a, o, s, l = r(49353), c = r(61323), u = r(53341), h = r(20465), f = (0, l.A)(), p = (0, l.A)(), d = {
                    point: u.A,
                    lineStart: u.A,
                    lineEnd: u.A,
                    polygonStart: function() {
                        f.reset(), d.lineStart = m, d.lineEnd = g;
                    },
                    polygonEnd: function() {
                        var t1 = +f;
                        p.add(t1 < 0 ? c.FA + t1 : t1), this.lineStart = this.lineEnd = this.point = u.A;
                    },
                    sphere: function() {
                        p.add(c.FA);
                    }
                };
                function m() {
                    d.point = y;
                }
                function g() {
                    v(n, i);
                }
                function y(t1, e1) {
                    d.point = v, n = t1, i = e1, t1 *= c.F2, e1 *= c.F2, a = t1, o = (0, c.gn)(e1 = e1 / 2 + c.gz), s = (0, c.F8)(e1);
                }
                function v(t1, e1) {
                    t1 *= c.F2, e1 = (e1 *= c.F2) / 2 + c.gz;
                    var r = t1 - a, n = r >= 0 ? 1 : -1, i = n * r, l = (0, c.gn)(e1), u = (0, c.F8)(e1), h = s * u, p = o * l + h * (0, c.gn)(i), d = h * n * (0, c.F8)(i);
                    f.add((0, c.FP)(d, p)), a = t1, o = l, s = u;
                }
                function x(t1) {
                    return p.reset(), (0, h.A)(t1, d), 2 * p;
                }
            },
            43212: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    A: function() {
                        return L;
                    }
                });
                var n, i, a, o, s, l, c, u, h, f, p = r(49353), d = r(43976), m = r(20375), g = r(61323), y = r(20465), v = (0, p.A)(), x = {
                    point: _,
                    lineStart: w,
                    lineEnd: T,
                    polygonStart: function() {
                        x.point = k, x.lineStart = A, x.lineEnd = M, v.reset(), d.Y7.polygonStart();
                    },
                    polygonEnd: function() {
                        d.Y7.polygonEnd(), x.point = _, x.lineStart = w, x.lineEnd = T, d.B0 < 0 ? (n = -(a = 180), i = -(o = 90)) : v > g.Ni ? o = 90 : v < -g.Ni && (i = -90), f[0] = n, f[1] = a;
                    },
                    sphere: function() {
                        n = -(a = 180), i = -(o = 90);
                    }
                };
                function _(t1, e1) {
                    h.push(f = [
                        n = t1,
                        a = t1
                    ]), e1 < i && (i = e1), e1 > o && (o = e1);
                }
                function b(t1, e1) {
                    var r = (0, m.jf)([
                        t1 * g.F2,
                        e1 * g.F2
                    ]);
                    if (u) {
                        var l = (0, m.r8)(u, r), c = [
                            l[1],
                            -l[0],
                            0
                        ], p = (0, m.r8)(c, l);
                        (0, m.Cx)(p), p = (0, m.EV)(p);
                        var d, y = t1 - s, v = y > 0 ? 1 : -1, x = p[0] * g.uj * v, _ = (0, g.tn)(y) > 180;
                        _ ^ (v * s < x && x < v * t1) ? (d = p[1] * g.uj) > o && (o = d) : _ ^ (v * s < (x = (x + 360) % 360 - 180) && x < v * t1) ? (d = -p[1] * g.uj) < i && (i = d) : (e1 < i && (i = e1), e1 > o && (o = e1)), _ ? t1 < s ? S(n, t1) > S(n, a) && (a = t1) : S(t1, a) > S(n, a) && (n = t1) : a >= n ? (t1 < n && (n = t1), t1 > a && (a = t1)) : t1 > s ? S(n, t1) > S(n, a) && (a = t1) : S(t1, a) > S(n, a) && (n = t1);
                    } else h.push(f = [
                        n = t1,
                        a = t1
                    ]);
                    e1 < i && (i = e1), e1 > o && (o = e1), u = r, s = t1;
                }
                function w() {
                    x.point = b;
                }
                function T() {
                    f[0] = n, f[1] = a, x.point = _, u = null;
                }
                function k(t1, e1) {
                    if (u) {
                        var r = t1 - s;
                        v.add((0, g.tn)(r) > 180 ? r + (r > 0 ? 360 : -360) : r);
                    } else l = t1, c = e1;
                    d.Y7.point(t1, e1), b(t1, e1);
                }
                function A() {
                    d.Y7.lineStart();
                }
                function M() {
                    k(l, c), d.Y7.lineEnd(), (0, g.tn)(v) > g.Ni && (n = -(a = 180)), f[0] = n, f[1] = a, u = null;
                }
                function S(t1, e1) {
                    return (e1 -= t1) < 0 ? e1 + 360 : e1;
                }
                function E(t1, e1) {
                    return t1[0] - e1[0];
                }
                function C(t1, e1) {
                    return t1[0] <= t1[1] ? t1[0] <= e1 && e1 <= t1[1] : e1 < t1[0] || t1[1] < e1;
                }
                function L(t1) {
                    var e1, r, s, l, c, u, p;
                    if (o = a = -(n = i = 1 / 0), h = [], (0, y.A)(t1, x), r = h.length) {
                        for(h.sort(E), e1 = 1, c = [
                            s = h[0]
                        ]; e1 < r; ++e1)C(s, (l = h[e1])[0]) || C(s, l[1]) ? (S(s[0], l[1]) > S(s[0], s[1]) && (s[1] = l[1]), S(l[0], s[1]) > S(s[0], s[1]) && (s[0] = l[0])) : c.push(s = l);
                        for(u = -1 / 0, e1 = 0, s = c[r = c.length - 1]; e1 <= r; s = l, ++e1)l = c[e1], (p = S(s[1], l[0])) > u && (u = p, n = l[0], a = s[1]);
                    }
                    return h = f = null, n === 1 / 0 || i === 1 / 0 ? [
                        [
                            NaN,
                            NaN
                        ],
                        [
                            NaN,
                            NaN
                        ]
                    ] : [
                        [
                            n,
                            i
                        ],
                        [
                            a,
                            o
                        ]
                    ];
                }
            },
            20375: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    Cx: function() {
                        return u;
                    },
                    EV: function() {
                        return i;
                    },
                    W8: function() {
                        return o;
                    },
                    ep: function() {
                        return l;
                    },
                    jf: function() {
                        return a;
                    },
                    ly: function() {
                        return c;
                    },
                    r8: function() {
                        return s;
                    }
                });
                var n = r(61323);
                function i(t1) {
                    return [
                        (0, n.FP)(t1[1], t1[0]),
                        (0, n.qR)(t1[2])
                    ];
                }
                function a(t1) {
                    var e1 = t1[0], r = t1[1], i = (0, n.gn)(r);
                    return [
                        i * (0, n.gn)(e1),
                        i * (0, n.F8)(e1),
                        (0, n.F8)(r)
                    ];
                }
                function o(t1, e1) {
                    return t1[0] * e1[0] + t1[1] * e1[1] + t1[2] * e1[2];
                }
                function s(t1, e1) {
                    return [
                        t1[1] * e1[2] - t1[2] * e1[1],
                        t1[2] * e1[0] - t1[0] * e1[2],
                        t1[0] * e1[1] - t1[1] * e1[0]
                    ];
                }
                function l(t1, e1) {
                    t1[0] += e1[0], t1[1] += e1[1], t1[2] += e1[2];
                }
                function c(t1, e1) {
                    return [
                        t1[0] * e1,
                        t1[1] * e1,
                        t1[2] * e1
                    ];
                }
                function u(t1) {
                    var e1 = (0, n.RZ)(t1[0] * t1[0] + t1[1] * t1[1] + t1[2] * t1[2]);
                    t1[0] /= e1, t1[1] /= e1, t1[2] /= e1;
                }
            },
            30021: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    A: function() {
                        return z;
                    }
                });
                var n, i, a, o, s, l, c, u, h, f, p, d, m, g, y, v, x = r(61323), _ = r(53341), b = r(20465), w = {
                    sphere: _.A,
                    point: T,
                    lineStart: A,
                    lineEnd: E,
                    polygonStart: function() {
                        w.lineStart = C, w.lineEnd = L;
                    },
                    polygonEnd: function() {
                        w.lineStart = A, w.lineEnd = E;
                    }
                };
                function T(t1, e1) {
                    t1 *= x.F2, e1 *= x.F2;
                    var r = (0, x.gn)(e1);
                    k(r * (0, x.gn)(t1), r * (0, x.F8)(t1), (0, x.F8)(e1));
                }
                function k(t1, e1, r) {
                    ++n, a += (t1 - a) / n, o += (e1 - o) / n, s += (r - s) / n;
                }
                function A() {
                    w.point = M;
                }
                function M(t1, e1) {
                    t1 *= x.F2, e1 *= x.F2;
                    var r = (0, x.gn)(e1);
                    g = r * (0, x.gn)(t1), y = r * (0, x.F8)(t1), v = (0, x.F8)(e1), w.point = S, k(g, y, v);
                }
                function S(t1, e1) {
                    t1 *= x.F2, e1 *= x.F2;
                    var r = (0, x.gn)(e1), n = r * (0, x.gn)(t1), a = r * (0, x.F8)(t1), o = (0, x.F8)(e1), s = (0, x.FP)((0, x.RZ)((s = y * o - v * a) * s + (s = v * n - g * o) * s + (s = g * a - y * n) * s), g * n + y * a + v * o);
                    i += s, l += s * (g + (g = n)), c += s * (y + (y = a)), u += s * (v + (v = o)), k(g, y, v);
                }
                function E() {
                    w.point = T;
                }
                function C() {
                    w.point = I;
                }
                function L() {
                    P(d, m), w.point = T;
                }
                function I(t1, e1) {
                    d = t1, m = e1, t1 *= x.F2, e1 *= x.F2, w.point = P;
                    var r = (0, x.gn)(e1);
                    g = r * (0, x.gn)(t1), y = r * (0, x.F8)(t1), v = (0, x.F8)(e1), k(g, y, v);
                }
                function P(t1, e1) {
                    t1 *= x.F2, e1 *= x.F2;
                    var r = (0, x.gn)(e1), n = r * (0, x.gn)(t1), a = r * (0, x.F8)(t1), o = (0, x.F8)(e1), s = y * o - v * a, d = v * n - g * o, m = g * a - y * n, _ = (0, x.RZ)(s * s + d * d + m * m), b = (0, x.qR)(_), w = _ && -b / _;
                    h += w * s, f += w * d, p += w * m, i += b, l += b * (g + (g = n)), c += b * (y + (y = a)), u += b * (v + (v = o)), k(g, y, v);
                }
                function z(t1) {
                    n = i = a = o = s = l = c = u = h = f = p = 0, (0, b.A)(t1, w);
                    var e1 = h, r = f, d = p, m = e1 * e1 + r * r + d * d;
                    return m < x.$t && (e1 = l, r = c, d = u, i < x.Ni && (e1 = a, r = o, d = s), (m = e1 * e1 + r * r + d * d) < x.$t) ? [
                        NaN,
                        NaN
                    ] : [
                        (0, x.FP)(r, e1) * x.uj,
                        (0, x.qR)(d / (0, x.RZ)(m)) * x.uj
                    ];
                }
            },
            39127: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    J: function() {
                        return s;
                    },
                    A: function() {
                        return c;
                    }
                });
                var n = r(20375);
                function i(t1) {
                    return function() {
                        return t1;
                    };
                }
                var a = r(61323), o = r(30915);
                function s(t1, e1, r, i, o, s) {
                    if (r) {
                        var c = (0, a.gn)(e1), u = (0, a.F8)(e1), h = i * r;
                        null == o ? (o = e1 + i * a.FA, s = e1 - h / 2) : (o = l(c, o), s = l(c, s), (i > 0 ? o < s : o > s) && (o += i * a.FA));
                        for(var f, p = o; i > 0 ? p > s : p < s; p -= h)f = (0, n.EV)([
                            c,
                            -u * (0, a.gn)(p),
                            -u * (0, a.F8)(p)
                        ]), t1.point(f[0], f[1]);
                    }
                }
                function l(t1, e1) {
                    (e1 = (0, n.jf)(e1))[0] -= t1, (0, n.Cx)(e1);
                    var r = (0, a.HQ)(-e1[1]);
                    return ((-e1[2] < 0 ? -r : r) + a.FA - a.Ni) % a.FA;
                }
                function c() {
                    var t1, e1, r = i([
                        0,
                        0
                    ]), n = i(90), l = i(6), c = {
                        point: function(r, n) {
                            t1.push(r = e1(r, n)), r[0] *= a.uj, r[1] *= a.uj;
                        }
                    };
                    function u() {
                        var i = r.apply(this, arguments), u = n.apply(this, arguments) * a.F2, h = l.apply(this, arguments) * a.F2;
                        return t1 = [], e1 = (0, o.y)(-i[0] * a.F2, -i[1] * a.F2, 0).invert, s(c, u, h, 1), i = {
                            type: "Polygon",
                            coordinates: [
                                t1
                            ]
                        }, t1 = e1 = null, i;
                    }
                    return u.center = function(t1) {
                        return arguments.length ? (r = "function" == typeof t1 ? t1 : i([
                            +t1[0],
                            +t1[1]
                        ]), u) : r;
                    }, u.radius = function(t1) {
                        return arguments.length ? (n = "function" == typeof t1 ? t1 : i(+t1), u) : n;
                    }, u.precision = function(t1) {
                        return arguments.length ? (l = "function" == typeof t1 ? t1 : i(+t1), u) : l;
                    }, u;
                }
            },
            42413: function(t1, e1, r) {
                "use strict";
                var n = r(13720), i = r(61323);
                e1.A = (0, n.A)(function() {
                    return !0;
                }, function(t1) {
                    var e1, r = NaN, n = NaN, a = NaN;
                    return {
                        lineStart: function() {
                            t1.lineStart(), e1 = 1;
                        },
                        point: function(o, s) {
                            var l = o > 0 ? i.pi : -i.pi, c = (0, i.tn)(o - r);
                            (0, i.tn)(c - i.pi) < i.Ni ? (t1.point(r, n = (n + s) / 2 > 0 ? i.TW : -i.TW), t1.point(a, n), t1.lineEnd(), t1.lineStart(), t1.point(l, n), t1.point(o, n), e1 = 0) : a !== l && c >= i.pi && ((0, i.tn)(r - a) < i.Ni && (r -= a * i.Ni), (0, i.tn)(o - l) < i.Ni && (o -= l * i.Ni), n = function(t1, e1, r, n) {
                                var a, o, s = (0, i.F8)(t1 - r);
                                return (0, i.tn)(s) > i.Ni ? (0, i.rY)(((0, i.F8)(e1) * (o = (0, i.gn)(n)) * (0, i.F8)(r) - (0, i.F8)(n) * (a = (0, i.gn)(e1)) * (0, i.F8)(t1)) / (a * o * s)) : (e1 + n) / 2;
                            }(r, n, o, s), t1.point(a, n), t1.lineEnd(), t1.lineStart(), t1.point(l, n), e1 = 0), t1.point(r = o, n = s), a = l;
                        },
                        lineEnd: function() {
                            t1.lineEnd(), r = n = NaN;
                        },
                        clean: function() {
                            return 2 - e1;
                        }
                    };
                }, function(t1, e1, r, n) {
                    var a;
                    if (null == t1) a = r * i.TW, n.point(-i.pi, a), n.point(0, a), n.point(i.pi, a), n.point(i.pi, 0), n.point(i.pi, -a), n.point(0, -a), n.point(-i.pi, -a), n.point(-i.pi, 0), n.point(-i.pi, a);
                    else if ((0, i.tn)(t1[0] - e1[0]) > i.Ni) {
                        var o = t1[0] < e1[0] ? i.pi : -i.pi;
                        a = r * o / 2, n.point(-o, a), n.point(0, a), n.point(o, a);
                    } else n.point(e1[0], e1[1]);
                }, [
                    -i.pi,
                    -i.TW
                ]);
            },
            39608: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    A: function() {
                        return i;
                    }
                });
                var n = r(53341);
                function i() {
                    var t1, e1 = [];
                    return {
                        point: function(e1, r, n) {
                            t1.push([
                                e1,
                                r,
                                n
                            ]);
                        },
                        lineStart: function() {
                            e1.push(t1 = []);
                        },
                        lineEnd: n.A,
                        rejoin: function() {
                            e1.length > 1 && e1.push(e1.pop().concat(e1.shift()));
                        },
                        result: function() {
                            var r = e1;
                            return e1 = [], t1 = null, r;
                        }
                    };
                }
            },
            47402: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    A: function() {
                        return l;
                    }
                });
                var n = r(20375), i = r(39127), a = r(61323), o = r(28759), s = r(13720);
                function l(t1) {
                    var e1 = (0, a.gn)(t1), r = 6 * a.F2, l = e1 > 0, c = (0, a.tn)(e1) > a.Ni;
                    function u(t1, r) {
                        return (0, a.gn)(t1) * (0, a.gn)(r) > e1;
                    }
                    function h(t1, r, i) {
                        var o = (0, n.jf)(t1), s = (0, n.jf)(r), l = [
                            1,
                            0,
                            0
                        ], c = (0, n.r8)(o, s), u = (0, n.W8)(c, c), h = c[0], f = u - h * h;
                        if (!f) return !i && t1;
                        var p = e1 * u / f, d = -e1 * h / f, m = (0, n.r8)(l, c), g = (0, n.ly)(l, p), y = (0, n.ly)(c, d);
                        (0, n.ep)(g, y);
                        var v = m, x = (0, n.W8)(g, v), _ = (0, n.W8)(v, v), b = x * x - _ * ((0, n.W8)(g, g) - 1);
                        if (!(b < 0)) {
                            var w = (0, a.RZ)(b), T = (0, n.ly)(v, (-x - w) / _);
                            if ((0, n.ep)(T, g), T = (0, n.EV)(T), !i) return T;
                            var k, A = t1[0], M = r[0], S = t1[1], E = r[1];
                            M < A && (k = A, A = M, M = k);
                            var C = M - A, L = (0, a.tn)(C - a.pi) < a.Ni;
                            if (!L && E < S && (k = S, S = E, E = k), L || C < a.Ni ? L ? S + E > 0 ^ T[1] < ((0, a.tn)(T[0] - A) < a.Ni ? S : E) : S <= T[1] && T[1] <= E : C > a.pi ^ (A <= T[0] && T[0] <= M)) {
                                var I = (0, n.ly)(v, (-x + w) / _);
                                return (0, n.ep)(I, g), [
                                    T,
                                    (0, n.EV)(I)
                                ];
                            }
                        }
                    }
                    function f(e1, r) {
                        var n = l ? t1 : a.pi - t1, i = 0;
                        return e1 < -n ? i |= 1 : e1 > n && (i |= 2), r < -n ? i |= 4 : r > n && (i |= 8), i;
                    }
                    return (0, s.A)(u, function(t1) {
                        var e1, r, n, i, s;
                        return {
                            lineStart: function() {
                                i = n = !1, s = 1;
                            },
                            point: function(p, d) {
                                var m, g = [
                                    p,
                                    d
                                ], y = u(p, d), v = l ? y ? 0 : f(p, d) : y ? f(p + (p < 0 ? a.pi : -a.pi), d) : 0;
                                if (!e1 && (i = n = y) && t1.lineStart(), y !== n && (!(m = h(e1, g)) || (0, o.A)(e1, m) || (0, o.A)(g, m)) && (g[2] = 1), y !== n) s = 0, y ? (t1.lineStart(), m = h(g, e1), t1.point(m[0], m[1])) : (m = h(e1, g), t1.point(m[0], m[1], 2), t1.lineEnd()), e1 = m;
                                else if (c && e1 && l ^ y) {
                                    var x;
                                    v & r || !(x = h(g, e1, !0)) || (s = 0, l ? (t1.lineStart(), t1.point(x[0][0], x[0][1]), t1.point(x[1][0], x[1][1]), t1.lineEnd()) : (t1.point(x[1][0], x[1][1]), t1.lineEnd(), t1.lineStart(), t1.point(x[0][0], x[0][1], 3)));
                                }
                                !y || e1 && (0, o.A)(e1, g) || t1.point(g[0], g[1]), e1 = g, n = y, r = v;
                            },
                            lineEnd: function() {
                                n && t1.lineEnd(), e1 = null;
                            },
                            clean: function() {
                                return s | (i && n) << 1;
                            }
                        };
                    }, function(e1, n, a, o) {
                        (0, i.J)(o, t1, r, a, e1, n);
                    }, l ? [
                        0,
                        -t1
                    ] : [
                        -a.pi,
                        t1 - a.pi
                    ]);
                }
            },
            13720: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    A: function() {
                        return l;
                    }
                });
                var n = r(39608), i = r(19119), a = r(61323), o = r(2274), s = r(29725);
                function l(t1, e1, r, a) {
                    return function(l) {
                        var h, f, p, d = e1(l), m = (0, n.A)(), g = e1(m), y = !1, v = {
                            point: x,
                            lineStart: b,
                            lineEnd: w,
                            polygonStart: function() {
                                v.point = T, v.lineStart = k, v.lineEnd = A, f = [], h = [];
                            },
                            polygonEnd: function() {
                                v.point = x, v.lineStart = b, v.lineEnd = w, f = (0, s.Am)(f);
                                var t1 = (0, o.A)(h, a);
                                f.length ? (y || (l.polygonStart(), y = !0), (0, i.A)(f, u, t1, r, l)) : t1 && (y || (l.polygonStart(), y = !0), l.lineStart(), r(null, null, 1, l), l.lineEnd()), y && (l.polygonEnd(), y = !1), f = h = null;
                            },
                            sphere: function() {
                                l.polygonStart(), l.lineStart(), r(null, null, 1, l), l.lineEnd(), l.polygonEnd();
                            }
                        };
                        function x(e1, r) {
                            t1(e1, r) && l.point(e1, r);
                        }
                        function _(t1, e1) {
                            d.point(t1, e1);
                        }
                        function b() {
                            v.point = _, d.lineStart();
                        }
                        function w() {
                            v.point = x, d.lineEnd();
                        }
                        function T(t1, e1) {
                            p.push([
                                t1,
                                e1
                            ]), g.point(t1, e1);
                        }
                        function k() {
                            g.lineStart(), p = [];
                        }
                        function A() {
                            T(p[0][0], p[0][1]), g.lineEnd();
                            var t1, e1, r, n, i = g.clean(), a = m.result(), o = a.length;
                            if (p.pop(), h.push(p), p = null, o) {
                                if (1 & i) {
                                    if ((e1 = (r = a[0]).length - 1) > 0) {
                                        for(y || (l.polygonStart(), y = !0), l.lineStart(), t1 = 0; t1 < e1; ++t1)l.point((n = r[t1])[0], n[1]);
                                        l.lineEnd();
                                    }
                                } else o > 1 && 2 & i && a.push(a.pop().concat(a.shift())), f.push(a.filter(c));
                            }
                        }
                        return v;
                    };
                }
                function c(t1) {
                    return t1.length > 1;
                }
                function u(t1, e1) {
                    return ((t1 = t1.x)[0] < 0 ? t1[1] - a.TW - a.Ni : a.TW - t1[1]) - ((e1 = e1.x)[0] < 0 ? e1[1] - a.TW - a.Ni : a.TW - e1[1]);
                }
            },
            21503: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    A: function() {
                        return c;
                    }
                });
                var n = r(61323), i = r(39608), a = r(19119), o = r(29725), s = 1e9, l = -s;
                function c(t1, e1, r, c) {
                    function u(n, i) {
                        return t1 <= n && n <= r && e1 <= i && i <= c;
                    }
                    function h(n, i, a, o) {
                        var s = 0, l = 0;
                        if (null == n || (s = f(n, a)) !== (l = f(i, a)) || d(n, i) < 0 ^ a > 0) do o.point(0 === s || 3 === s ? t1 : r, s > 1 ? c : e1);
                        while ((s = (s + a + 4) % 4) !== l);
                        else o.point(i[0], i[1]);
                    }
                    function f(i, a) {
                        return (0, n.tn)(i[0] - t1) < n.Ni ? a > 0 ? 0 : 3 : (0, n.tn)(i[0] - r) < n.Ni ? a > 0 ? 2 : 1 : (0, n.tn)(i[1] - e1) < n.Ni ? a > 0 ? 1 : 0 : a > 0 ? 3 : 2;
                    }
                    function p(t1, e1) {
                        return d(t1.x, e1.x);
                    }
                    function d(t1, e1) {
                        var r = f(t1, 1), n = f(e1, 1);
                        return r !== n ? r - n : 0 === r ? e1[1] - t1[1] : 1 === r ? t1[0] - e1[0] : 2 === r ? t1[1] - e1[1] : e1[0] - t1[0];
                    }
                    return function(n) {
                        var f, d, m, g, y, v, x, _, b, w, T, k = n, A = (0, i.A)(), M = {
                            point: S,
                            lineStart: function() {
                                M.point = E, d && d.push(m = []), w = !0, b = !1, x = _ = NaN;
                            },
                            lineEnd: function() {
                                f && (E(g, y), v && b && A.rejoin(), f.push(A.result())), M.point = S, b && k.lineEnd();
                            },
                            polygonStart: function() {
                                k = A, f = [], d = [], T = !0;
                            },
                            polygonEnd: function() {
                                var e1 = function() {
                                    for(var e1 = 0, r = 0, n = d.length; r < n; ++r)for(var i, a, o = d[r], s = 1, l = o.length, u = o[0], h = u[0], f = u[1]; s < l; ++s)i = h, a = f, h = (u = o[s])[0], f = u[1], a <= c ? f > c && (h - i) * (c - a) > (f - a) * (t1 - i) && ++e1 : f <= c && (h - i) * (c - a) < (f - a) * (t1 - i) && --e1;
                                    return e1;
                                }(), r = T && e1, i = (f = (0, o.Am)(f)).length;
                                (r || i) && (n.polygonStart(), r && (n.lineStart(), h(null, null, 1, n), n.lineEnd()), i && (0, a.A)(f, p, e1, h, n), n.polygonEnd()), k = n, f = d = m = null;
                            }
                        };
                        function S(t1, e1) {
                            u(t1, e1) && k.point(t1, e1);
                        }
                        function E(n, i) {
                            var a = u(n, i);
                            if (d && m.push([
                                n,
                                i
                            ]), w) g = n, y = i, v = a, w = !1, a && (k.lineStart(), k.point(n, i));
                            else if (a && b) k.point(n, i);
                            else {
                                var o = [
                                    x = Math.max(l, Math.min(s, x)),
                                    _ = Math.max(l, Math.min(s, _))
                                ], h = [
                                    n = Math.max(l, Math.min(s, n)),
                                    i = Math.max(l, Math.min(s, i))
                                ];
                                !function(t1, e1, r, n, i, a) {
                                    var o, s = t1[0], l = t1[1], c = 0, u = 1, h = e1[0] - s, f = e1[1] - l;
                                    if (o = r - s, h || !(o > 0)) {
                                        if (o /= h, h < 0) {
                                            if (o < c) return;
                                            o < u && (u = o);
                                        } else if (h > 0) {
                                            if (o > u) return;
                                            o > c && (c = o);
                                        }
                                        if (o = i - s, h || !(o < 0)) {
                                            if (o /= h, h < 0) {
                                                if (o > u) return;
                                                o > c && (c = o);
                                            } else if (h > 0) {
                                                if (o < c) return;
                                                o < u && (u = o);
                                            }
                                            if (o = n - l, f || !(o > 0)) {
                                                if (o /= f, f < 0) {
                                                    if (o < c) return;
                                                    o < u && (u = o);
                                                } else if (f > 0) {
                                                    if (o > u) return;
                                                    o > c && (c = o);
                                                }
                                                if (o = a - l, f || !(o < 0)) {
                                                    if (o /= f, f < 0) {
                                                        if (o > u) return;
                                                        o > c && (c = o);
                                                    } else if (f > 0) {
                                                        if (o < c) return;
                                                        o < u && (u = o);
                                                    }
                                                    return c > 0 && (t1[0] = s + c * h, t1[1] = l + c * f), u < 1 && (e1[0] = s + u * h, e1[1] = l + u * f), !0;
                                                }
                                            }
                                        }
                                    }
                                }(o, h, t1, e1, r, c) ? a && (k.lineStart(), k.point(n, i), T = !1) : (b || (k.lineStart(), k.point(o[0], o[1])), k.point(h[0], h[1]), a || k.lineEnd(), T = !1);
                            }
                            x = n, _ = i, b = a;
                        }
                        return M;
                    };
                }
            },
            19119: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    A: function() {
                        return o;
                    }
                });
                var n = r(28759), i = r(61323);
                function a(t1, e1, r, n) {
                    this.x = t1, this.z = e1, this.o = r, this.e = n, this.v = !1, this.n = this.p = null;
                }
                function o(t1, e1, r, o, l) {
                    var c, u, h = [], f = [];
                    if (t1.forEach(function(t1) {
                        if (!((e1 = t1.length - 1) <= 0)) {
                            var e1, r, o = t1[0], s = t1[e1];
                            if ((0, n.A)(o, s)) {
                                if (!o[2] && !s[2]) {
                                    for(l.lineStart(), c = 0; c < e1; ++c)l.point((o = t1[c])[0], o[1]);
                                    return void l.lineEnd();
                                }
                                s[0] += 2 * i.Ni;
                            }
                            h.push(r = new a(o, t1, null, !0)), f.push(r.o = new a(o, null, r, !1)), h.push(r = new a(s, t1, null, !1)), f.push(r.o = new a(s, null, r, !0));
                        }
                    }), h.length) {
                        for(f.sort(e1), s(h), s(f), c = 0, u = f.length; c < u; ++c)f[c].e = r = !r;
                        for(var p, d, m = h[0];;){
                            for(var g = m, y = !0; g.v;)if ((g = g.n) === m) return;
                            p = g.z, l.lineStart();
                            do {
                                if (g.v = g.o.v = !0, g.e) {
                                    if (y) for(c = 0, u = p.length; c < u; ++c)l.point((d = p[c])[0], d[1]);
                                    else o(g.x, g.n.x, 1, l);
                                    g = g.n;
                                } else {
                                    if (y) for(p = g.p.z, c = p.length - 1; c >= 0; --c)l.point((d = p[c])[0], d[1]);
                                    else o(g.x, g.p.x, -1, l);
                                    g = g.p;
                                }
                                p = (g = g.o).z, y = !y;
                            }while (!g.v);
                            l.lineEnd();
                        }
                    }
                }
                function s(t1) {
                    if (e1 = t1.length) {
                        for(var e1, r, n = 0, i = t1[0]; ++n < e1;)i.n = r = t1[n], r.p = i, i = r;
                        i.n = r = t1[0], r.p = i;
                    }
                }
            },
            19057: function(t1, e1, r) {
                "use strict";
                function n(t1, e1) {
                    function r(r, n) {
                        return r = t1(r, n), e1(r[0], r[1]);
                    }
                    return t1.invert && e1.invert && (r.invert = function(r, n) {
                        return (r = e1.invert(r, n)) && t1.invert(r[0], r[1]);
                    }), r;
                }
                r.d(e1, {
                    A: function() {
                        return n;
                    }
                });
            },
            26827: function(t1, e1, r) {
                "use strict";
                function n(t1) {
                    return t1;
                }
                r.d(e1, {
                    A: function() {
                        return n;
                    }
                });
            },
            70884: function(t1, e1, r) {
                "use strict";
                r.r(e1), r.d(e1, {
                    geoAlbers: function() {
                        return Gt;
                    },
                    geoAlbersUsa: function() {
                        return Wt;
                    },
                    geoArea: function() {
                        return n.Ay;
                    },
                    geoAzimuthalEqualArea: function() {
                        return Yt.A;
                    },
                    geoAzimuthalEqualAreaRaw: function() {
                        return Yt.n;
                    },
                    geoAzimuthalEquidistant: function() {
                        return Xt.A;
                    },
                    geoAzimuthalEquidistantRaw: function() {
                        return Xt.j;
                    },
                    geoBounds: function() {
                        return i.A;
                    },
                    geoCentroid: function() {
                        return a.A;
                    },
                    geoCircle: function() {
                        return o.A;
                    },
                    geoClipAntimeridian: function() {
                        return s.A;
                    },
                    geoClipCircle: function() {
                        return l.A;
                    },
                    geoClipExtent: function() {
                        return u;
                    },
                    geoClipRectangle: function() {
                        return c.A;
                    },
                    geoConicConformal: function() {
                        return re;
                    },
                    geoConicConformalRaw: function() {
                        return ee;
                    },
                    geoConicEqualArea: function() {
                        return Ht;
                    },
                    geoConicEqualAreaRaw: function() {
                        return qt;
                    },
                    geoConicEquidistant: function() {
                        return ae;
                    },
                    geoConicEquidistantRaw: function() {
                        return ie;
                    },
                    geoContains: function() {
                        return R;
                    },
                    geoDistance: function() {
                        return S;
                    },
                    geoEqualEarth: function() {
                        return fe;
                    },
                    geoEqualEarthRaw: function() {
                        return he;
                    },
                    geoEquirectangular: function() {
                        return ne.A;
                    },
                    geoEquirectangularRaw: function() {
                        return ne.f;
                    },
                    geoGnomonic: function() {
                        return pe.A;
                    },
                    geoGnomonicRaw: function() {
                        return pe.T;
                    },
                    geoGraticule: function() {
                        return j;
                    },
                    geoGraticule10: function() {
                        return U;
                    },
                    geoIdentity: function() {
                        return me;
                    },
                    geoInterpolate: function() {
                        return Z.A;
                    },
                    geoLength: function() {
                        return k;
                    },
                    geoMercator: function() {
                        return Kt;
                    },
                    geoMercatorRaw: function() {
                        return Jt;
                    },
                    geoNaturalEarth1: function() {
                        return ge.A;
                    },
                    geoNaturalEarth1Raw: function() {
                        return ge.P;
                    },
                    geoOrthographic: function() {
                        return ye.A;
                    },
                    geoOrthographicRaw: function() {
                        return ye.x;
                    },
                    geoPath: function() {
                        return jt;
                    },
                    geoProjection: function() {
                        return Ut.A;
                    },
                    geoProjectionMutator: function() {
                        return Ut.U;
                    },
                    geoRotation: function() {
                        return $t.A;
                    },
                    geoStereographic: function() {
                        return _e;
                    },
                    geoStereographicRaw: function() {
                        return xe;
                    },
                    geoStream: function() {
                        return v.A;
                    },
                    geoTransform: function() {
                        return de.A;
                    },
                    geoTransverseMercator: function() {
                        return we;
                    },
                    geoTransverseMercatorRaw: function() {
                        return be;
                    }
                });
                var n = r(43976), i = r(43212), a = r(30021), o = r(39127), s = r(42413), l = r(47402), c = r(21503);
                function u() {
                    var t1, e1, r, n = 0, i = 0, a = 960, o = 500;
                    return r = {
                        stream: function(r) {
                            return t1 && e1 === r ? t1 : t1 = (0, c.A)(n, i, a, o)(e1 = r);
                        },
                        extent: function(s) {
                            return arguments.length ? (n = +s[0][0], i = +s[0][1], a = +s[1][0], o = +s[1][1], t1 = e1 = null, r) : [
                                [
                                    n,
                                    i
                                ],
                                [
                                    a,
                                    o
                                ]
                            ];
                        }
                    };
                }
                var h, f, p, d = r(2274), m = r(49353), g = r(61323), y = r(53341), v = r(20465), x = (0, m.A)(), _ = {
                    sphere: y.A,
                    point: y.A,
                    lineStart: function() {
                        _.point = w, _.lineEnd = b;
                    },
                    lineEnd: y.A,
                    polygonStart: y.A,
                    polygonEnd: y.A
                };
                function b() {
                    _.point = _.lineEnd = y.A;
                }
                function w(t1, e1) {
                    t1 *= g.F2, e1 *= g.F2, h = t1, f = (0, g.F8)(e1), p = (0, g.gn)(e1), _.point = T;
                }
                function T(t1, e1) {
                    t1 *= g.F2, e1 *= g.F2;
                    var r = (0, g.F8)(e1), n = (0, g.gn)(e1), i = (0, g.tn)(t1 - h), a = (0, g.gn)(i), o = n * (0, g.F8)(i), s = p * r - f * n * a, l = f * r + p * n * a;
                    x.add((0, g.FP)((0, g.RZ)(o * o + s * s), l)), h = t1, f = r, p = n;
                }
                function k(t1) {
                    return x.reset(), (0, v.A)(t1, _), +x;
                }
                var A = [
                    null,
                    null
                ], M = {
                    type: "LineString",
                    coordinates: A
                };
                function S(t1, e1) {
                    return A[0] = t1, A[1] = e1, k(M);
                }
                var E = {
                    Feature: function(t1, e1) {
                        return L(t1.geometry, e1);
                    },
                    FeatureCollection: function(t1, e1) {
                        for(var r = t1.features, n = -1, i = r.length; ++n < i;)if (L(r[n].geometry, e1)) return !0;
                        return !1;
                    }
                }, C = {
                    Sphere: function() {
                        return !0;
                    },
                    Point: function(t1, e1) {
                        return I(t1.coordinates, e1);
                    },
                    MultiPoint: function(t1, e1) {
                        for(var r = t1.coordinates, n = -1, i = r.length; ++n < i;)if (I(r[n], e1)) return !0;
                        return !1;
                    },
                    LineString: function(t1, e1) {
                        return P(t1.coordinates, e1);
                    },
                    MultiLineString: function(t1, e1) {
                        for(var r = t1.coordinates, n = -1, i = r.length; ++n < i;)if (P(r[n], e1)) return !0;
                        return !1;
                    },
                    Polygon: function(t1, e1) {
                        return z(t1.coordinates, e1);
                    },
                    MultiPolygon: function(t1, e1) {
                        for(var r = t1.coordinates, n = -1, i = r.length; ++n < i;)if (z(r[n], e1)) return !0;
                        return !1;
                    },
                    GeometryCollection: function(t1, e1) {
                        for(var r = t1.geometries, n = -1, i = r.length; ++n < i;)if (L(r[n], e1)) return !0;
                        return !1;
                    }
                };
                function L(t1, e1) {
                    return !(!t1 || !C.hasOwnProperty(t1.type)) && C[t1.type](t1, e1);
                }
                function I(t1, e1) {
                    return 0 === S(t1, e1);
                }
                function P(t1, e1) {
                    for(var r, n, i, a = 0, o = t1.length; a < o; a++){
                        if (0 === (n = S(t1[a], e1))) return !0;
                        if (a > 0 && (i = S(t1[a], t1[a - 1])) > 0 && r <= i && n <= i && (r + n - i) * (1 - Math.pow((r - n) / i, 2)) < g.$t * i) return !0;
                        r = n;
                    }
                    return !1;
                }
                function z(t1, e1) {
                    return !!(0, d.A)(t1.map(O), D(e1));
                }
                function O(t1) {
                    return (t1 = t1.map(D)).pop(), t1;
                }
                function D(t1) {
                    return [
                        t1[0] * g.F2,
                        t1[1] * g.F2
                    ];
                }
                function R(t1, e1) {
                    return (t1 && E.hasOwnProperty(t1.type) ? E[t1.type] : L)(t1, e1);
                }
                var F = r(29725);
                function B(t1, e1, r) {
                    var n = (0, F.y1)(t1, e1 - g.Ni, r).concat(e1);
                    return function(t1) {
                        return n.map(function(e1) {
                            return [
                                t1,
                                e1
                            ];
                        });
                    };
                }
                function N(t1, e1, r) {
                    var n = (0, F.y1)(t1, e1 - g.Ni, r).concat(e1);
                    return function(t1) {
                        return n.map(function(e1) {
                            return [
                                e1,
                                t1
                            ];
                        });
                    };
                }
                function j() {
                    var t1, e1, r, n, i, a, o, s, l, c, u, h, f = 10, p = f, d = 90, m = 360, y = 2.5;
                    function v() {
                        return {
                            type: "MultiLineString",
                            coordinates: x()
                        };
                    }
                    function x() {
                        return (0, F.y1)((0, g.mk)(n / d) * d, r, d).map(u).concat((0, F.y1)((0, g.mk)(s / m) * m, o, m).map(h)).concat((0, F.y1)((0, g.mk)(e1 / f) * f, t1, f).filter(function(t1) {
                            return (0, g.tn)(t1 % d) > g.Ni;
                        }).map(l)).concat((0, F.y1)((0, g.mk)(a / p) * p, i, p).filter(function(t1) {
                            return (0, g.tn)(t1 % m) > g.Ni;
                        }).map(c));
                    }
                    return v.lines = function() {
                        return x().map(function(t1) {
                            return {
                                type: "LineString",
                                coordinates: t1
                            };
                        });
                    }, v.outline = function() {
                        return {
                            type: "Polygon",
                            coordinates: [
                                u(n).concat(h(o).slice(1), u(r).reverse().slice(1), h(s).reverse().slice(1))
                            ]
                        };
                    }, v.extent = function(t1) {
                        return arguments.length ? v.extentMajor(t1).extentMinor(t1) : v.extentMinor();
                    }, v.extentMajor = function(t1) {
                        return arguments.length ? (n = +t1[0][0], r = +t1[1][0], s = +t1[0][1], o = +t1[1][1], n > r && (t1 = n, n = r, r = t1), s > o && (t1 = s, s = o, o = t1), v.precision(y)) : [
                            [
                                n,
                                s
                            ],
                            [
                                r,
                                o
                            ]
                        ];
                    }, v.extentMinor = function(r) {
                        return arguments.length ? (e1 = +r[0][0], t1 = +r[1][0], a = +r[0][1], i = +r[1][1], e1 > t1 && (r = e1, e1 = t1, t1 = r), a > i && (r = a, a = i, i = r), v.precision(y)) : [
                            [
                                e1,
                                a
                            ],
                            [
                                t1,
                                i
                            ]
                        ];
                    }, v.step = function(t1) {
                        return arguments.length ? v.stepMajor(t1).stepMinor(t1) : v.stepMinor();
                    }, v.stepMajor = function(t1) {
                        return arguments.length ? (d = +t1[0], m = +t1[1], v) : [
                            d,
                            m
                        ];
                    }, v.stepMinor = function(t1) {
                        return arguments.length ? (f = +t1[0], p = +t1[1], v) : [
                            f,
                            p
                        ];
                    }, v.precision = function(f) {
                        return arguments.length ? (y = +f, l = B(a, i, 90), c = N(e1, t1, y), u = B(s, o, 90), h = N(n, r, y), v) : y;
                    }, v.extentMajor([
                        [
                            -180,
                            -90 + g.Ni
                        ],
                        [
                            180,
                            90 - g.Ni
                        ]
                    ]).extentMinor([
                        [
                            -180,
                            -80 - g.Ni
                        ],
                        [
                            180,
                            80 + g.Ni
                        ]
                    ]);
                }
                function U() {
                    return j()();
                }
                var V, q, H, G, Z = r(81758), W = r(26827), Y = (0, m.A)(), X = (0, m.A)(), $ = {
                    point: y.A,
                    lineStart: y.A,
                    lineEnd: y.A,
                    polygonStart: function() {
                        $.lineStart = J, $.lineEnd = tt;
                    },
                    polygonEnd: function() {
                        $.lineStart = $.lineEnd = $.point = y.A, Y.add((0, g.tn)(X)), X.reset();
                    },
                    result: function() {
                        var t1 = Y / 2;
                        return Y.reset(), t1;
                    }
                };
                function J() {
                    $.point = K;
                }
                function K(t1, e1) {
                    $.point = Q, V = H = t1, q = G = e1;
                }
                function Q(t1, e1) {
                    X.add(G * t1 - H * e1), H = t1, G = e1;
                }
                function tt() {
                    Q(V, q);
                }
                var et, rt, nt, it, at = $, ot = r(33028), st = 0, lt = 0, ct = 0, ut = 0, ht = 0, ft = 0, pt = 0, dt = 0, mt = 0, gt = {
                    point: yt,
                    lineStart: vt,
                    lineEnd: bt,
                    polygonStart: function() {
                        gt.lineStart = wt, gt.lineEnd = Tt;
                    },
                    polygonEnd: function() {
                        gt.point = yt, gt.lineStart = vt, gt.lineEnd = bt;
                    },
                    result: function() {
                        var t1 = mt ? [
                            pt / mt,
                            dt / mt
                        ] : ft ? [
                            ut / ft,
                            ht / ft
                        ] : ct ? [
                            st / ct,
                            lt / ct
                        ] : [
                            NaN,
                            NaN
                        ];
                        return st = lt = ct = ut = ht = ft = pt = dt = mt = 0, t1;
                    }
                };
                function yt(t1, e1) {
                    st += t1, lt += e1, ++ct;
                }
                function vt() {
                    gt.point = xt;
                }
                function xt(t1, e1) {
                    gt.point = _t, yt(nt = t1, it = e1);
                }
                function _t(t1, e1) {
                    var r = t1 - nt, n = e1 - it, i = (0, g.RZ)(r * r + n * n);
                    ut += i * (nt + t1) / 2, ht += i * (it + e1) / 2, ft += i, yt(nt = t1, it = e1);
                }
                function bt() {
                    gt.point = yt;
                }
                function wt() {
                    gt.point = kt;
                }
                function Tt() {
                    At(et, rt);
                }
                function kt(t1, e1) {
                    gt.point = At, yt(et = nt = t1, rt = it = e1);
                }
                function At(t1, e1) {
                    var r = t1 - nt, n = e1 - it, i = (0, g.RZ)(r * r + n * n);
                    ut += i * (nt + t1) / 2, ht += i * (it + e1) / 2, ft += i, pt += (i = it * t1 - nt * e1) * (nt + t1), dt += i * (it + e1), mt += 3 * i, yt(nt = t1, it = e1);
                }
                var Mt = gt;
                function St(t1) {
                    this._context = t1;
                }
                St.prototype = {
                    _radius: 4.5,
                    pointRadius: function(t1) {
                        return this._radius = t1, this;
                    },
                    polygonStart: function() {
                        this._line = 0;
                    },
                    polygonEnd: function() {
                        this._line = NaN;
                    },
                    lineStart: function() {
                        this._point = 0;
                    },
                    lineEnd: function() {
                        0 === this._line && this._context.closePath(), this._point = NaN;
                    },
                    point: function(t1, e1) {
                        switch(this._point){
                            case 0:
                                this._context.moveTo(t1, e1), this._point = 1;
                                break;
                            case 1:
                                this._context.lineTo(t1, e1);
                                break;
                            default:
                                this._context.moveTo(t1 + this._radius, e1), this._context.arc(t1, e1, this._radius, 0, g.FA);
                        }
                    },
                    result: y.A
                };
                var Et, Ct, Lt, It, Pt, zt = (0, m.A)(), Ot = {
                    point: y.A,
                    lineStart: function() {
                        Ot.point = Dt;
                    },
                    lineEnd: function() {
                        Et && Rt(Ct, Lt), Ot.point = y.A;
                    },
                    polygonStart: function() {
                        Et = !0;
                    },
                    polygonEnd: function() {
                        Et = null;
                    },
                    result: function() {
                        var t1 = +zt;
                        return zt.reset(), t1;
                    }
                };
                function Dt(t1, e1) {
                    Ot.point = Rt, Ct = It = t1, Lt = Pt = e1;
                }
                function Rt(t1, e1) {
                    It -= t1, Pt -= e1, zt.add((0, g.RZ)(It * It + Pt * Pt)), It = t1, Pt = e1;
                }
                var Ft = Ot;
                function Bt() {
                    this._string = [];
                }
                function Nt(t1) {
                    return "m0," + t1 + "a" + t1 + "," + t1 + " 0 1,1 0," + -2 * t1 + "a" + t1 + "," + t1 + " 0 1,1 0," + 2 * t1 + "z";
                }
                function jt(t1, e1) {
                    var r, n, i = 4.5;
                    function a(t1) {
                        return t1 && ("function" == typeof i && n.pointRadius(+i.apply(this, arguments)), (0, v.A)(t1, r(n))), n.result();
                    }
                    return a.area = function(t1) {
                        return (0, v.A)(t1, r(at)), at.result();
                    }, a.measure = function(t1) {
                        return (0, v.A)(t1, r(Ft)), Ft.result();
                    }, a.bounds = function(t1) {
                        return (0, v.A)(t1, r(ot.A)), ot.A.result();
                    }, a.centroid = function(t1) {
                        return (0, v.A)(t1, r(Mt)), Mt.result();
                    }, a.projection = function(e1) {
                        return arguments.length ? (r = null == e1 ? (t1 = null, W.A) : (t1 = e1).stream, a) : t1;
                    }, a.context = function(t1) {
                        return arguments.length ? (n = null == t1 ? (e1 = null, new Bt) : new St(e1 = t1), "function" != typeof i && n.pointRadius(i), a) : e1;
                    }, a.pointRadius = function(t1) {
                        return arguments.length ? (i = "function" == typeof t1 ? t1 : (n.pointRadius(+t1), +t1), a) : i;
                    }, a.projection(t1).context(e1);
                }
                Bt.prototype = {
                    _radius: 4.5,
                    _circle: Nt(4.5),
                    pointRadius: function(t1) {
                        return (t1 = +t1) !== this._radius && (this._radius = t1, this._circle = null), this;
                    },
                    polygonStart: function() {
                        this._line = 0;
                    },
                    polygonEnd: function() {
                        this._line = NaN;
                    },
                    lineStart: function() {
                        this._point = 0;
                    },
                    lineEnd: function() {
                        0 === this._line && this._string.push("Z"), this._point = NaN;
                    },
                    point: function(t1, e1) {
                        switch(this._point){
                            case 0:
                                this._string.push("M", t1, ",", e1), this._point = 1;
                                break;
                            case 1:
                                this._string.push("L", t1, ",", e1);
                                break;
                            default:
                                null == this._circle && (this._circle = Nt(this._radius)), this._string.push("M", t1, ",", e1, this._circle);
                        }
                    },
                    result: function() {
                        if (this._string.length) {
                            var t1 = this._string.join("");
                            return this._string = [], t1;
                        }
                        return null;
                    }
                };
                var Ut = r(94684);
                function Vt(t1) {
                    var e1 = 0, r = g.pi / 3, n = (0, Ut.U)(t1), i = n(e1, r);
                    return i.parallels = function(t1) {
                        return arguments.length ? n(e1 = t1[0] * g.F2, r = t1[1] * g.F2) : [
                            e1 * g.uj,
                            r * g.uj
                        ];
                    }, i;
                }
                function qt(t1, e1) {
                    var r = (0, g.F8)(t1), n = (r + (0, g.F8)(e1)) / 2;
                    if ((0, g.tn)(n) < g.Ni) return function(t1) {
                        var e1 = (0, g.gn)(t1);
                        function r(t1, r) {
                            return [
                                t1 * e1,
                                (0, g.F8)(r) / e1
                            ];
                        }
                        return r.invert = function(t1, r) {
                            return [
                                t1 / e1,
                                (0, g.qR)(r * e1)
                            ];
                        }, r;
                    }(t1);
                    var i = 1 + r * (2 * n - r), a = (0, g.RZ)(i) / n;
                    function o(t1, e1) {
                        var r = (0, g.RZ)(i - 2 * n * (0, g.F8)(e1)) / n;
                        return [
                            r * (0, g.F8)(t1 *= n),
                            a - r * (0, g.gn)(t1)
                        ];
                    }
                    return o.invert = function(t1, e1) {
                        var r = a - e1, o = (0, g.FP)(t1, (0, g.tn)(r)) * (0, g._S)(r);
                        return r * n < 0 && (o -= g.pi * (0, g._S)(t1) * (0, g._S)(r)), [
                            o / n,
                            (0, g.qR)((i - (t1 * t1 + r * r) * n * n) / (2 * n))
                        ];
                    }, o;
                }
                function Ht() {
                    return Vt(qt).scale(155.424).center([
                        0,
                        33.6442
                    ]);
                }
                function Gt() {
                    return Ht().parallels([
                        29.5,
                        45.5
                    ]).scale(1070).translate([
                        480,
                        250
                    ]).rotate([
                        96,
                        0
                    ]).center([
                        -0.6,
                        38.7
                    ]);
                }
                var Zt = r(7944);
                function Wt() {
                    var t1, e1, r, n, i, a, o = Gt(), s = Ht().rotate([
                        154,
                        0
                    ]).center([
                        -2,
                        58.5
                    ]).parallels([
                        55,
                        65
                    ]), l = Ht().rotate([
                        157,
                        0
                    ]).center([
                        -3,
                        19.9
                    ]).parallels([
                        8,
                        18
                    ]), c = {
                        point: function(t1, e1) {
                            a = [
                                t1,
                                e1
                            ];
                        }
                    };
                    function u(t1) {
                        var e1 = t1[0], o = t1[1];
                        return a = null, r.point(e1, o), a || (n.point(e1, o), a) || (i.point(e1, o), a);
                    }
                    function h() {
                        return t1 = e1 = null, u;
                    }
                    return u.invert = function(t1) {
                        var e1 = o.scale(), r = o.translate(), n = (t1[0] - r[0]) / e1, i = (t1[1] - r[1]) / e1;
                        return (i >= .12 && i < .234 && n >= -0.425 && n < -0.214 ? s : i >= .166 && i < .234 && n >= -0.214 && n < -0.115 ? l : o).invert(t1);
                    }, u.stream = function(r) {
                        var n, i;
                        return t1 && e1 === r ? t1 : (n = [
                            o.stream(e1 = r),
                            s.stream(r),
                            l.stream(r)
                        ], i = n.length, t1 = {
                            point: function(t1, e1) {
                                for(var r = -1; ++r < i;)n[r].point(t1, e1);
                            },
                            sphere: function() {
                                for(var t1 = -1; ++t1 < i;)n[t1].sphere();
                            },
                            lineStart: function() {
                                for(var t1 = -1; ++t1 < i;)n[t1].lineStart();
                            },
                            lineEnd: function() {
                                for(var t1 = -1; ++t1 < i;)n[t1].lineEnd();
                            },
                            polygonStart: function() {
                                for(var t1 = -1; ++t1 < i;)n[t1].polygonStart();
                            },
                            polygonEnd: function() {
                                for(var t1 = -1; ++t1 < i;)n[t1].polygonEnd();
                            }
                        });
                    }, u.precision = function(t1) {
                        return arguments.length ? (o.precision(t1), s.precision(t1), l.precision(t1), h()) : o.precision();
                    }, u.scale = function(t1) {
                        return arguments.length ? (o.scale(t1), s.scale(.35 * t1), l.scale(t1), u.translate(o.translate())) : o.scale();
                    }, u.translate = function(t1) {
                        if (!arguments.length) return o.translate();
                        var e1 = o.scale(), a = +t1[0], u = +t1[1];
                        return r = o.translate(t1).clipExtent([
                            [
                                a - .455 * e1,
                                u - .238 * e1
                            ],
                            [
                                a + .455 * e1,
                                u + .238 * e1
                            ]
                        ]).stream(c), n = s.translate([
                            a - .307 * e1,
                            u + .201 * e1
                        ]).clipExtent([
                            [
                                a - .425 * e1 + g.Ni,
                                u + .12 * e1 + g.Ni
                            ],
                            [
                                a - .214 * e1 - g.Ni,
                                u + .234 * e1 - g.Ni
                            ]
                        ]).stream(c), i = l.translate([
                            a - .205 * e1,
                            u + .212 * e1
                        ]).clipExtent([
                            [
                                a - .214 * e1 + g.Ni,
                                u + .166 * e1 + g.Ni
                            ],
                            [
                                a - .115 * e1 - g.Ni,
                                u + .234 * e1 - g.Ni
                            ]
                        ]).stream(c), h();
                    }, u.fitExtent = function(t1, e1) {
                        return (0, Zt.sp)(u, t1, e1);
                    }, u.fitSize = function(t1, e1) {
                        return (0, Zt.Hv)(u, t1, e1);
                    }, u.fitWidth = function(t1, e1) {
                        return (0, Zt.G0)(u, t1, e1);
                    }, u.fitHeight = function(t1, e1) {
                        return (0, Zt.FL)(u, t1, e1);
                    }, u.scale(1070);
                }
                var Yt = r(30729), Xt = r(61957), $t = r(30915);
                function Jt(t1, e1) {
                    return [
                        t1,
                        (0, g.Rm)((0, g.Ml)((g.TW + e1) / 2))
                    ];
                }
                function Kt() {
                    return Qt(Jt).scale(961 / g.FA);
                }
                function Qt(t1) {
                    var e1, r, n, i = (0, Ut.A)(t1), a = i.center, o = i.scale, s = i.translate, l = i.clipExtent, c = null;
                    function u() {
                        var a = g.pi * o(), s = i((0, $t.A)(i.rotate()).invert([
                            0,
                            0
                        ]));
                        return l(null == c ? [
                            [
                                s[0] - a,
                                s[1] - a
                            ],
                            [
                                s[0] + a,
                                s[1] + a
                            ]
                        ] : t1 === Jt ? [
                            [
                                Math.max(s[0] - a, c),
                                e1
                            ],
                            [
                                Math.min(s[0] + a, r),
                                n
                            ]
                        ] : [
                            [
                                c,
                                Math.max(s[1] - a, e1)
                            ],
                            [
                                r,
                                Math.min(s[1] + a, n)
                            ]
                        ]);
                    }
                    return i.scale = function(t1) {
                        return arguments.length ? (o(t1), u()) : o();
                    }, i.translate = function(t1) {
                        return arguments.length ? (s(t1), u()) : s();
                    }, i.center = function(t1) {
                        return arguments.length ? (a(t1), u()) : a();
                    }, i.clipExtent = function(t1) {
                        return arguments.length ? (null == t1 ? c = e1 = r = n = null : (c = +t1[0][0], e1 = +t1[0][1], r = +t1[1][0], n = +t1[1][1]), u()) : null == c ? null : [
                            [
                                c,
                                e1
                            ],
                            [
                                r,
                                n
                            ]
                        ];
                    }, u();
                }
                function te(t1) {
                    return (0, g.Ml)((g.TW + t1) / 2);
                }
                function ee(t1, e1) {
                    var r = (0, g.gn)(t1), n = t1 === e1 ? (0, g.F8)(t1) : (0, g.Rm)(r / (0, g.gn)(e1)) / (0, g.Rm)(te(e1) / te(t1)), i = r * (0, g.n7)(te(t1), n) / n;
                    if (!n) return Jt;
                    function a(t1, e1) {
                        i > 0 ? e1 < -g.TW + g.Ni && (e1 = -g.TW + g.Ni) : e1 > g.TW - g.Ni && (e1 = g.TW - g.Ni);
                        var r = i / (0, g.n7)(te(e1), n);
                        return [
                            r * (0, g.F8)(n * t1),
                            i - r * (0, g.gn)(n * t1)
                        ];
                    }
                    return a.invert = function(t1, e1) {
                        var r = i - e1, a = (0, g._S)(n) * (0, g.RZ)(t1 * t1 + r * r), o = (0, g.FP)(t1, (0, g.tn)(r)) * (0, g._S)(r);
                        return r * n < 0 && (o -= g.pi * (0, g._S)(t1) * (0, g._S)(r)), [
                            o / n,
                            2 * (0, g.rY)((0, g.n7)(i / a, 1 / n)) - g.TW
                        ];
                    }, a;
                }
                function re() {
                    return Vt(ee).scale(109.5).parallels([
                        30,
                        30
                    ]);
                }
                Jt.invert = function(t1, e1) {
                    return [
                        t1,
                        2 * (0, g.rY)((0, g.oN)(e1)) - g.TW
                    ];
                };
                var ne = r(18139);
                function ie(t1, e1) {
                    var r = (0, g.gn)(t1), n = t1 === e1 ? (0, g.F8)(t1) : (r - (0, g.gn)(e1)) / (e1 - t1), i = r / n + t1;
                    if ((0, g.tn)(n) < g.Ni) return ne.f;
                    function a(t1, e1) {
                        var r = i - e1, a = n * t1;
                        return [
                            r * (0, g.F8)(a),
                            i - r * (0, g.gn)(a)
                        ];
                    }
                    return a.invert = function(t1, e1) {
                        var r = i - e1, a = (0, g.FP)(t1, (0, g.tn)(r)) * (0, g._S)(r);
                        return r * n < 0 && (a -= g.pi * (0, g._S)(t1) * (0, g._S)(r)), [
                            a / n,
                            i - (0, g._S)(n) * (0, g.RZ)(t1 * t1 + r * r)
                        ];
                    }, a;
                }
                function ae() {
                    return Vt(ie).scale(131.154).center([
                        0,
                        13.9389
                    ]);
                }
                var oe = 1.340264, se = -0.081106, le = 893e-6, ce = .003796, ue = (0, g.RZ)(3) / 2;
                function he(t1, e1) {
                    var r = (0, g.qR)(ue * (0, g.F8)(e1)), n = r * r, i = n * n * n;
                    return [
                        t1 * (0, g.gn)(r) / (ue * (oe + 3 * se * n + i * (7 * le + 9 * ce * n))),
                        r * (oe + se * n + i * (le + ce * n))
                    ];
                }
                function fe() {
                    return (0, Ut.A)(he).scale(177.158);
                }
                he.invert = function(t1, e1) {
                    for(var r, n = e1, i = n * n, a = i * i * i, o = 0; o < 12 && (a = (i = (n -= r = (n * (oe + se * i + a * (le + ce * i)) - e1) / (oe + 3 * se * i + a * (7 * le + 9 * ce * i))) * n) * i * i, !((0, g.tn)(r) < g.$t)); ++o);
                    return [
                        ue * t1 * (oe + 3 * se * i + a * (7 * le + 9 * ce * i)) / (0, g.gn)(n),
                        (0, g.qR)((0, g.F8)(n) / ue)
                    ];
                };
                var pe = r(48419), de = r(913);
                function me() {
                    var t1, e1, r, n, i, a, o, s = 1, l = 0, u = 0, h = 1, f = 1, p = 0, d = null, m = 1, y = 1, v = (0, de.G)({
                        point: function(t1, e1) {
                            var r = b([
                                t1,
                                e1
                            ]);
                            this.stream.point(r[0], r[1]);
                        }
                    }), x = W.A;
                    function _() {
                        return m = s * h, y = s * f, a = o = null, b;
                    }
                    function b(r) {
                        var n = r[0] * m, i = r[1] * y;
                        if (p) {
                            var a = i * t1 - n * e1;
                            n = n * t1 + i * e1, i = a;
                        }
                        return [
                            n + l,
                            i + u
                        ];
                    }
                    return b.invert = function(r) {
                        var n = r[0] - l, i = r[1] - u;
                        if (p) {
                            var a = i * t1 + n * e1;
                            n = n * t1 - i * e1, i = a;
                        }
                        return [
                            n / m,
                            i / y
                        ];
                    }, b.stream = function(t1) {
                        return a && o === t1 ? a : a = v(x(o = t1));
                    }, b.postclip = function(t1) {
                        return arguments.length ? (x = t1, d = r = n = i = null, _()) : x;
                    }, b.clipExtent = function(t1) {
                        return arguments.length ? (x = null == t1 ? (d = r = n = i = null, W.A) : (0, c.A)(d = +t1[0][0], r = +t1[0][1], n = +t1[1][0], i = +t1[1][1]), _()) : null == d ? null : [
                            [
                                d,
                                r
                            ],
                            [
                                n,
                                i
                            ]
                        ];
                    }, b.scale = function(t1) {
                        return arguments.length ? (s = +t1, _()) : s;
                    }, b.translate = function(t1) {
                        return arguments.length ? (l = +t1[0], u = +t1[1], _()) : [
                            l,
                            u
                        ];
                    }, b.angle = function(r) {
                        return arguments.length ? (p = r % 360 * g.F2, e1 = (0, g.F8)(p), t1 = (0, g.gn)(p), _()) : p * g.uj;
                    }, b.reflectX = function(t1) {
                        return arguments.length ? (h = t1 ? -1 : 1, _()) : h < 0;
                    }, b.reflectY = function(t1) {
                        return arguments.length ? (f = t1 ? -1 : 1, _()) : f < 0;
                    }, b.fitExtent = function(t1, e1) {
                        return (0, Zt.sp)(b, t1, e1);
                    }, b.fitSize = function(t1, e1) {
                        return (0, Zt.Hv)(b, t1, e1);
                    }, b.fitWidth = function(t1, e1) {
                        return (0, Zt.G0)(b, t1, e1);
                    }, b.fitHeight = function(t1, e1) {
                        return (0, Zt.FL)(b, t1, e1);
                    }, b;
                }
                var ge = r(57949), ye = r(53253), ve = r(57738);
                function xe(t1, e1) {
                    var r = (0, g.gn)(e1), n = 1 + (0, g.gn)(t1) * r;
                    return [
                        r * (0, g.F8)(t1) / n,
                        (0, g.F8)(e1) / n
                    ];
                }
                function _e() {
                    return (0, Ut.A)(xe).scale(250).clipAngle(142);
                }
                function be(t1, e1) {
                    return [
                        (0, g.Rm)((0, g.Ml)((g.TW + e1) / 2)),
                        -t1
                    ];
                }
                function we() {
                    var t1 = Qt(be), e1 = t1.center, r = t1.rotate;
                    return t1.center = function(t1) {
                        return arguments.length ? e1([
                            -t1[1],
                            t1[0]
                        ]) : [
                            (t1 = e1())[1],
                            -t1[0]
                        ];
                    }, t1.rotate = function(t1) {
                        return arguments.length ? r([
                            t1[0],
                            t1[1],
                            t1.length > 2 ? t1[2] + 90 : 90
                        ]) : [
                            (t1 = r())[0],
                            t1[1],
                            t1[2] - 90
                        ];
                    }, r([
                        0,
                        0,
                        90
                    ]).scale(159.155);
                }
                xe.invert = (0, ve.I)(function(t1) {
                    return 2 * (0, g.rY)(t1);
                }), be.invert = function(t1, e1) {
                    return [
                        -e1,
                        2 * (0, g.rY)((0, g.oN)(t1)) - g.TW
                    ];
                };
            },
            81758: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    A: function() {
                        return i;
                    }
                });
                var n = r(61323);
                function i(t1, e1) {
                    var r = t1[0] * n.F2, i = t1[1] * n.F2, a = e1[0] * n.F2, o = e1[1] * n.F2, s = (0, n.gn)(i), l = (0, n.F8)(i), c = (0, n.gn)(o), u = (0, n.F8)(o), h = s * (0, n.gn)(r), f = s * (0, n.F8)(r), p = c * (0, n.gn)(a), d = c * (0, n.F8)(a), m = 2 * (0, n.qR)((0, n.RZ)((0, n.bo)(o - i) + s * c * (0, n.bo)(a - r))), g = (0, n.F8)(m), y = m ? function(t1) {
                        var e1 = (0, n.F8)(t1 *= m) / g, r = (0, n.F8)(m - t1) / g, i = r * h + e1 * p, a = r * f + e1 * d, o = r * l + e1 * u;
                        return [
                            (0, n.FP)(a, i) * n.uj,
                            (0, n.FP)(o, (0, n.RZ)(i * i + a * a)) * n.uj
                        ];
                    } : function() {
                        return [
                            r * n.uj,
                            i * n.uj
                        ];
                    };
                    return y.distance = m, y;
                }
            },
            61323: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    $t: function() {
                        return i;
                    },
                    F2: function() {
                        return u;
                    },
                    F8: function() {
                        return x;
                    },
                    FA: function() {
                        return l;
                    },
                    FP: function() {
                        return p;
                    },
                    HQ: function() {
                        return T;
                    },
                    Ml: function() {
                        return w;
                    },
                    Ni: function() {
                        return n;
                    },
                    RZ: function() {
                        return b;
                    },
                    Rm: function() {
                        return y;
                    },
                    TW: function() {
                        return o;
                    },
                    _S: function() {
                        return _;
                    },
                    bo: function() {
                        return A;
                    },
                    gn: function() {
                        return d;
                    },
                    gz: function() {
                        return s;
                    },
                    mk: function() {
                        return m;
                    },
                    n7: function() {
                        return v;
                    },
                    oN: function() {
                        return g;
                    },
                    pi: function() {
                        return a;
                    },
                    qR: function() {
                        return k;
                    },
                    rY: function() {
                        return f;
                    },
                    tn: function() {
                        return h;
                    },
                    uj: function() {
                        return c;
                    }
                });
                var n = 1e-6, i = 1e-12, a = Math.PI, o = a / 2, s = a / 4, l = 2 * a, c = 180 / a, u = a / 180, h = Math.abs, f = Math.atan, p = Math.atan2, d = Math.cos, m = Math.ceil, g = Math.exp, y = (Math.floor, Math.log), v = Math.pow, x = Math.sin, _ = Math.sign || function(t1) {
                    return t1 > 0 ? 1 : t1 < 0 ? -1 : 0;
                }, b = Math.sqrt, w = Math.tan;
                function T(t1) {
                    return t1 > 1 ? 0 : t1 < -1 ? a : Math.acos(t1);
                }
                function k(t1) {
                    return t1 > 1 ? o : t1 < -1 ? -o : Math.asin(t1);
                }
                function A(t1) {
                    return (t1 = x(t1 / 2)) * t1;
                }
            },
            53341: function(t1, e1, r) {
                "use strict";
                function n() {}
                r.d(e1, {
                    A: function() {
                        return n;
                    }
                });
            },
            33028: function(t1, e1, r) {
                "use strict";
                var n = r(53341), i = 1 / 0, a = i, o = -i, s = o, l = {
                    point: function(t1, e1) {
                        t1 < i && (i = t1), t1 > o && (o = t1), e1 < a && (a = e1), e1 > s && (s = e1);
                    },
                    lineStart: n.A,
                    lineEnd: n.A,
                    polygonStart: n.A,
                    polygonEnd: n.A,
                    result: function() {
                        var t1 = [
                            [
                                i,
                                a
                            ],
                            [
                                o,
                                s
                            ]
                        ];
                        return o = s = -(a = i = 1 / 0), t1;
                    }
                };
                e1.A = l;
            },
            28759: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    A: function() {
                        return i;
                    }
                });
                var n = r(61323);
                function i(t1, e1) {
                    return (0, n.tn)(t1[0] - e1[0]) < n.Ni && (0, n.tn)(t1[1] - e1[1]) < n.Ni;
                }
            },
            2274: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    A: function() {
                        return l;
                    }
                });
                var n = r(49353), i = r(20375), a = r(61323), o = (0, n.A)();
                function s(t1) {
                    return (0, a.tn)(t1[0]) <= a.pi ? t1[0] : (0, a._S)(t1[0]) * (((0, a.tn)(t1[0]) + a.pi) % a.FA - a.pi);
                }
                function l(t1, e1) {
                    var r = s(e1), n = e1[1], l = (0, a.F8)(n), c = [
                        (0, a.F8)(r),
                        -(0, a.gn)(r),
                        0
                    ], u = 0, h = 0;
                    o.reset(), 1 === l ? n = a.TW + a.Ni : -1 === l && (n = -a.TW - a.Ni);
                    for(var f = 0, p = t1.length; f < p; ++f)if (m = (d = t1[f]).length) for(var d, m, g = d[m - 1], y = s(g), v = g[1] / 2 + a.gz, x = (0, a.F8)(v), _ = (0, a.gn)(v), b = 0; b < m; ++b, y = T, x = A, _ = M, g = w){
                        var w = d[b], T = s(w), k = w[1] / 2 + a.gz, A = (0, a.F8)(k), M = (0, a.gn)(k), S = T - y, E = S >= 0 ? 1 : -1, C = E * S, L = C > a.pi, I = x * A;
                        if (o.add((0, a.FP)(I * E * (0, a.F8)(C), _ * M + I * (0, a.gn)(C))), u += L ? S + E * a.FA : S, L ^ y >= r ^ T >= r) {
                            var P = (0, i.r8)((0, i.jf)(g), (0, i.jf)(w));
                            (0, i.Cx)(P);
                            var z = (0, i.r8)(c, P);
                            (0, i.Cx)(z);
                            var O = (L ^ S >= 0 ? -1 : 1) * (0, a.qR)(z[2]);
                            (n > O || n === O && (P[0] || P[1])) && (h += L ^ S >= 0 ? 1 : -1);
                        }
                    }
                    return (u < -a.Ni || u < a.Ni && o < -a.Ni) ^ 1 & h;
                }
            },
            57738: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    I: function() {
                        return a;
                    },
                    c: function() {
                        return i;
                    }
                });
                var n = r(61323);
                function i(t1) {
                    return function(e1, r) {
                        var i = (0, n.gn)(e1), a = (0, n.gn)(r), o = t1(i * a);
                        return [
                            o * a * (0, n.F8)(e1),
                            o * (0, n.F8)(r)
                        ];
                    };
                }
                function a(t1) {
                    return function(e1, r) {
                        var i = (0, n.RZ)(e1 * e1 + r * r), a = t1(i), o = (0, n.F8)(a), s = (0, n.gn)(a);
                        return [
                            (0, n.FP)(e1 * o, i * s),
                            (0, n.qR)(i && r * o / i)
                        ];
                    };
                }
            },
            30729: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    A: function() {
                        return s;
                    },
                    n: function() {
                        return o;
                    }
                });
                var n = r(61323), i = r(57738), a = r(94684), o = (0, i.c)(function(t1) {
                    return (0, n.RZ)(2 / (1 + t1));
                });
                function s() {
                    return (0, a.A)(o).scale(124.75).clipAngle(179.999);
                }
                o.invert = (0, i.I)(function(t1) {
                    return 2 * (0, n.qR)(t1 / 2);
                });
            },
            61957: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    A: function() {
                        return s;
                    },
                    j: function() {
                        return o;
                    }
                });
                var n = r(61323), i = r(57738), a = r(94684), o = (0, i.c)(function(t1) {
                    return (t1 = (0, n.HQ)(t1)) && t1 / (0, n.F8)(t1);
                });
                function s() {
                    return (0, a.A)(o).scale(79.4188).clipAngle(179.999);
                }
                o.invert = (0, i.I)(function(t1) {
                    return t1;
                });
            },
            18139: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    A: function() {
                        return a;
                    },
                    f: function() {
                        return i;
                    }
                });
                var n = r(94684);
                function i(t1, e1) {
                    return [
                        t1,
                        e1
                    ];
                }
                function a() {
                    return (0, n.A)(i).scale(152.63);
                }
                i.invert = i;
            },
            7944: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    FL: function() {
                        return c;
                    },
                    G0: function() {
                        return l;
                    },
                    Hv: function() {
                        return s;
                    },
                    sp: function() {
                        return o;
                    }
                });
                var n = r(20465), i = r(33028);
                function a(t1, e1, r) {
                    var a = t1.clipExtent && t1.clipExtent();
                    return t1.scale(150).translate([
                        0,
                        0
                    ]), null != a && t1.clipExtent(null), (0, n.A)(r, t1.stream(i.A)), e1(i.A.result()), null != a && t1.clipExtent(a), t1;
                }
                function o(t1, e1, r) {
                    return a(t1, function(r) {
                        var n = e1[1][0] - e1[0][0], i = e1[1][1] - e1[0][1], a = Math.min(n / (r[1][0] - r[0][0]), i / (r[1][1] - r[0][1])), o = +e1[0][0] + (n - a * (r[1][0] + r[0][0])) / 2, s = +e1[0][1] + (i - a * (r[1][1] + r[0][1])) / 2;
                        t1.scale(150 * a).translate([
                            o,
                            s
                        ]);
                    }, r);
                }
                function s(t1, e1, r) {
                    return o(t1, [
                        [
                            0,
                            0
                        ],
                        e1
                    ], r);
                }
                function l(t1, e1, r) {
                    return a(t1, function(r) {
                        var n = +e1, i = n / (r[1][0] - r[0][0]), a = (n - i * (r[1][0] + r[0][0])) / 2, o = -i * r[0][1];
                        t1.scale(150 * i).translate([
                            a,
                            o
                        ]);
                    }, r);
                }
                function c(t1, e1, r) {
                    return a(t1, function(r) {
                        var n = +e1, i = n / (r[1][1] - r[0][1]), a = -i * r[0][0], o = (n - i * (r[1][1] + r[0][1])) / 2;
                        t1.scale(150 * i).translate([
                            a,
                            o
                        ]);
                    }, r);
                }
            },
            48419: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    A: function() {
                        return s;
                    },
                    T: function() {
                        return o;
                    }
                });
                var n = r(61323), i = r(57738), a = r(94684);
                function o(t1, e1) {
                    var r = (0, n.gn)(e1), i = (0, n.gn)(t1) * r;
                    return [
                        r * (0, n.F8)(t1) / i,
                        (0, n.F8)(e1) / i
                    ];
                }
                function s() {
                    return (0, a.A)(o).scale(144.049).clipAngle(60);
                }
                o.invert = (0, i.I)(n.rY);
            },
            94684: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    A: function() {
                        return x;
                    },
                    U: function() {
                        return _;
                    }
                });
                var n = r(42413), i = r(47402), a = r(21503), o = r(19057), s = r(26827), l = r(61323), c = r(30915), u = r(913), h = r(7944), f = r(20375), p = 16, d = (0, l.gn)(30 * l.F2);
                function m(t1, e1) {
                    return +e1 ? function(t1, e1) {
                        function r(n, i, a, o, s, c, u, h, f, p, m, g, y, v) {
                            var x = u - n, _ = h - i, b = x * x + _ * _;
                            if (b > 4 * e1 && y--) {
                                var w = o + p, T = s + m, k = c + g, A = (0, l.RZ)(w * w + T * T + k * k), M = (0, l.qR)(k /= A), S = (0, l.tn)((0, l.tn)(k) - 1) < l.Ni || (0, l.tn)(a - f) < l.Ni ? (a + f) / 2 : (0, l.FP)(T, w), E = t1(S, M), C = E[0], L = E[1], I = C - n, P = L - i, z = _ * I - x * P;
                                (z * z / b > e1 || (0, l.tn)((x * I + _ * P) / b - .5) > .3 || o * p + s * m + c * g < d) && (r(n, i, a, o, s, c, C, L, S, w /= A, T /= A, k, y, v), v.point(C, L), r(C, L, S, w, T, k, u, h, f, p, m, g, y, v));
                            }
                        }
                        return function(e1) {
                            var n, i, a, o, s, l, c, u, h, d, m, g, y = {
                                point: v,
                                lineStart: x,
                                lineEnd: b,
                                polygonStart: function() {
                                    e1.polygonStart(), y.lineStart = w;
                                },
                                polygonEnd: function() {
                                    e1.polygonEnd(), y.lineStart = x;
                                }
                            };
                            function v(r, n) {
                                r = t1(r, n), e1.point(r[0], r[1]);
                            }
                            function x() {
                                u = NaN, y.point = _, e1.lineStart();
                            }
                            function _(n, i) {
                                var a = (0, f.jf)([
                                    n,
                                    i
                                ]), o = t1(n, i);
                                r(u, h, c, d, m, g, u = o[0], h = o[1], c = n, d = a[0], m = a[1], g = a[2], p, e1), e1.point(u, h);
                            }
                            function b() {
                                y.point = v, e1.lineEnd();
                            }
                            function w() {
                                x(), y.point = T, y.lineEnd = k;
                            }
                            function T(t1, e1) {
                                _(n = t1, e1), i = u, a = h, o = d, s = m, l = g, y.point = _;
                            }
                            function k() {
                                r(u, h, c, d, m, g, i, a, n, o, s, l, p, e1), y.lineEnd = b, b();
                            }
                            return y;
                        };
                    }(t1, e1) : function(t1) {
                        return (0, u.G)({
                            point: function(e1, r) {
                                e1 = t1(e1, r), this.stream.point(e1[0], e1[1]);
                            }
                        });
                    }(t1);
                }
                var g = (0, u.G)({
                    point: function(t1, e1) {
                        this.stream.point(t1 * l.F2, e1 * l.F2);
                    }
                });
                function y(t1, e1, r, n, i) {
                    function a(a, o) {
                        return [
                            e1 + t1 * (a *= n),
                            r - t1 * (o *= i)
                        ];
                    }
                    return a.invert = function(a, o) {
                        return [
                            (a - e1) / t1 * n,
                            (r - o) / t1 * i
                        ];
                    }, a;
                }
                function v(t1, e1, r, n, i, a) {
                    var o = (0, l.gn)(a), s = (0, l.F8)(a), c = o * t1, u = s * t1, h = o / t1, f = s / t1, p = (s * r - o * e1) / t1, d = (s * e1 + o * r) / t1;
                    function m(t1, a) {
                        return [
                            c * (t1 *= n) - u * (a *= i) + e1,
                            r - u * t1 - c * a
                        ];
                    }
                    return m.invert = function(t1, e1) {
                        return [
                            n * (h * t1 - f * e1 + p),
                            i * (d - f * t1 - h * e1)
                        ];
                    }, m;
                }
                function x(t1) {
                    return _(function() {
                        return t1;
                    })();
                }
                function _(t1) {
                    var e1, r, f, p, d, x, _, b, w, T, k = 150, A = 480, M = 250, S = 0, E = 0, C = 0, L = 0, I = 0, P = 0, z = 1, O = 1, D = null, R = n.A, F = null, B = s.A, N = .5;
                    function j(t1) {
                        return b(t1[0] * l.F2, t1[1] * l.F2);
                    }
                    function U(t1) {
                        return (t1 = b.invert(t1[0], t1[1])) && [
                            t1[0] * l.uj,
                            t1[1] * l.uj
                        ];
                    }
                    function V() {
                        var t1 = v(k, 0, 0, z, O, P).apply(null, e1(S, E)), n = (P ? v : y)(k, A - t1[0], M - t1[1], z, O, P);
                        return r = (0, c.y)(C, L, I), _ = (0, o.A)(e1, n), b = (0, o.A)(r, _), x = m(_, N), q();
                    }
                    function q() {
                        return w = T = null, j;
                    }
                    return j.stream = function(t1) {
                        return w && T === t1 ? w : w = g((function(t1) {
                            return (0, u.G)({
                                point: function(e1, r) {
                                    var n = t1(e1, r);
                                    return this.stream.point(n[0], n[1]);
                                }
                            });
                        })(r)(R(x(B(T = t1)))));
                    }, j.preclip = function(t1) {
                        return arguments.length ? (R = t1, D = void 0, q()) : R;
                    }, j.postclip = function(t1) {
                        return arguments.length ? (B = t1, F = f = p = d = null, q()) : B;
                    }, j.clipAngle = function(t1) {
                        return arguments.length ? (R = +t1 ? (0, i.A)(D = t1 * l.F2) : (D = null, n.A), q()) : D * l.uj;
                    }, j.clipExtent = function(t1) {
                        return arguments.length ? (B = null == t1 ? (F = f = p = d = null, s.A) : (0, a.A)(F = +t1[0][0], f = +t1[0][1], p = +t1[1][0], d = +t1[1][1]), q()) : null == F ? null : [
                            [
                                F,
                                f
                            ],
                            [
                                p,
                                d
                            ]
                        ];
                    }, j.scale = function(t1) {
                        return arguments.length ? (k = +t1, V()) : k;
                    }, j.translate = function(t1) {
                        return arguments.length ? (A = +t1[0], M = +t1[1], V()) : [
                            A,
                            M
                        ];
                    }, j.center = function(t1) {
                        return arguments.length ? (S = t1[0] % 360 * l.F2, E = t1[1] % 360 * l.F2, V()) : [
                            S * l.uj,
                            E * l.uj
                        ];
                    }, j.rotate = function(t1) {
                        return arguments.length ? (C = t1[0] % 360 * l.F2, L = t1[1] % 360 * l.F2, I = t1.length > 2 ? t1[2] % 360 * l.F2 : 0, V()) : [
                            C * l.uj,
                            L * l.uj,
                            I * l.uj
                        ];
                    }, j.angle = function(t1) {
                        return arguments.length ? (P = t1 % 360 * l.F2, V()) : P * l.uj;
                    }, j.reflectX = function(t1) {
                        return arguments.length ? (z = t1 ? -1 : 1, V()) : z < 0;
                    }, j.reflectY = function(t1) {
                        return arguments.length ? (O = t1 ? -1 : 1, V()) : O < 0;
                    }, j.precision = function(t1) {
                        return arguments.length ? (x = m(_, N = t1 * t1), q()) : (0, l.RZ)(N);
                    }, j.fitExtent = function(t1, e1) {
                        return (0, h.sp)(j, t1, e1);
                    }, j.fitSize = function(t1, e1) {
                        return (0, h.Hv)(j, t1, e1);
                    }, j.fitWidth = function(t1, e1) {
                        return (0, h.G0)(j, t1, e1);
                    }, j.fitHeight = function(t1, e1) {
                        return (0, h.FL)(j, t1, e1);
                    }, function() {
                        return e1 = t1.apply(this, arguments), j.invert = e1.invert && U, V();
                    };
                }
            },
            57949: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    A: function() {
                        return o;
                    },
                    P: function() {
                        return a;
                    }
                });
                var n = r(94684), i = r(61323);
                function a(t1, e1) {
                    var r = e1 * e1, n = r * r;
                    return [
                        t1 * (.8707 - .131979 * r + n * (n * (.003971 * r - .001529 * n) - .013791)),
                        e1 * (1.007226 + r * (.015085 + n * (.028874 * r - .044475 - .005916 * n)))
                    ];
                }
                function o() {
                    return (0, n.A)(a).scale(175.295);
                }
                a.invert = function(t1, e1) {
                    var r, n = e1, a = 25;
                    do {
                        var o = n * n, s = o * o;
                        n -= r = (n * (1.007226 + o * (.015085 + s * (.028874 * o - .044475 - .005916 * s))) - e1) / (1.007226 + o * (.045255 + s * (.259866 * o - .311325 - .005916 * 11 * s)));
                    }while ((0, i.tn)(r) > i.Ni && --a > 0);
                    return [
                        t1 / (.8707 + (o = n * n) * (o * (o * o * o * (.003971 - .001529 * o) - .013791) - .131979)),
                        n
                    ];
                };
            },
            53253: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    A: function() {
                        return s;
                    },
                    x: function() {
                        return o;
                    }
                });
                var n = r(61323), i = r(57738), a = r(94684);
                function o(t1, e1) {
                    return [
                        (0, n.gn)(e1) * (0, n.F8)(t1),
                        (0, n.F8)(e1)
                    ];
                }
                function s() {
                    return (0, a.A)(o).scale(249.5).clipAngle(90 + n.Ni);
                }
                o.invert = (0, i.I)(n.qR);
            },
            30915: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    A: function() {
                        return u;
                    },
                    y: function() {
                        return o;
                    }
                });
                var n = r(19057), i = r(61323);
                function a(t1, e1) {
                    return [
                        (0, i.tn)(t1) > i.pi ? t1 + Math.round(-t1 / i.FA) * i.FA : t1,
                        e1
                    ];
                }
                function o(t1, e1, r) {
                    return (t1 %= i.FA) ? e1 || r ? (0, n.A)(l(t1), c(e1, r)) : l(t1) : e1 || r ? c(e1, r) : a;
                }
                function s(t1) {
                    return function(e1, r) {
                        return [
                            (e1 += t1) > i.pi ? e1 - i.FA : e1 < -i.pi ? e1 + i.FA : e1,
                            r
                        ];
                    };
                }
                function l(t1) {
                    var e1 = s(t1);
                    return e1.invert = s(-t1), e1;
                }
                function c(t1, e1) {
                    var r = (0, i.gn)(t1), n = (0, i.F8)(t1), a = (0, i.gn)(e1), o = (0, i.F8)(e1);
                    function s(t1, e1) {
                        var s = (0, i.gn)(e1), l = (0, i.gn)(t1) * s, c = (0, i.F8)(t1) * s, u = (0, i.F8)(e1), h = u * r + l * n;
                        return [
                            (0, i.FP)(c * a - h * o, l * r - u * n),
                            (0, i.qR)(h * a + c * o)
                        ];
                    }
                    return s.invert = function(t1, e1) {
                        var s = (0, i.gn)(e1), l = (0, i.gn)(t1) * s, c = (0, i.F8)(t1) * s, u = (0, i.F8)(e1), h = u * a - c * o;
                        return [
                            (0, i.FP)(c * a + u * o, l * r + h * n),
                            (0, i.qR)(h * r - l * n)
                        ];
                    }, s;
                }
                function u(t1) {
                    function e1(e1) {
                        return (e1 = t1(e1[0] * i.F2, e1[1] * i.F2))[0] *= i.uj, e1[1] *= i.uj, e1;
                    }
                    return t1 = o(t1[0] * i.F2, t1[1] * i.F2, t1.length > 2 ? t1[2] * i.F2 : 0), e1.invert = function(e1) {
                        return (e1 = t1.invert(e1[0] * i.F2, e1[1] * i.F2))[0] *= i.uj, e1[1] *= i.uj, e1;
                    }, e1;
                }
                a.invert = a;
            },
            20465: function(t1, e1, r) {
                "use strict";
                function n(t1, e1) {
                    t1 && a.hasOwnProperty(t1.type) && a[t1.type](t1, e1);
                }
                r.d(e1, {
                    A: function() {
                        return l;
                    }
                });
                var i = {
                    Feature: function(t1, e1) {
                        n(t1.geometry, e1);
                    },
                    FeatureCollection: function(t1, e1) {
                        for(var r = t1.features, i = -1, a = r.length; ++i < a;)n(r[i].geometry, e1);
                    }
                }, a = {
                    Sphere: function(t1, e1) {
                        e1.sphere();
                    },
                    Point: function(t1, e1) {
                        t1 = t1.coordinates, e1.point(t1[0], t1[1], t1[2]);
                    },
                    MultiPoint: function(t1, e1) {
                        for(var r = t1.coordinates, n = -1, i = r.length; ++n < i;)t1 = r[n], e1.point(t1[0], t1[1], t1[2]);
                    },
                    LineString: function(t1, e1) {
                        o(t1.coordinates, e1, 0);
                    },
                    MultiLineString: function(t1, e1) {
                        for(var r = t1.coordinates, n = -1, i = r.length; ++n < i;)o(r[n], e1, 0);
                    },
                    Polygon: function(t1, e1) {
                        s(t1.coordinates, e1);
                    },
                    MultiPolygon: function(t1, e1) {
                        for(var r = t1.coordinates, n = -1, i = r.length; ++n < i;)s(r[n], e1);
                    },
                    GeometryCollection: function(t1, e1) {
                        for(var r = t1.geometries, i = -1, a = r.length; ++i < a;)n(r[i], e1);
                    }
                };
                function o(t1, e1, r) {
                    var n, i = -1, a = t1.length - r;
                    for(e1.lineStart(); ++i < a;)n = t1[i], e1.point(n[0], n[1], n[2]);
                    e1.lineEnd();
                }
                function s(t1, e1) {
                    var r = -1, n = t1.length;
                    for(e1.polygonStart(); ++r < n;)o(t1[r], e1, 1);
                    e1.polygonEnd();
                }
                function l(t1, e1) {
                    t1 && i.hasOwnProperty(t1.type) ? i[t1.type](t1, e1) : n(t1, e1);
                }
            },
            913: function(t1, e1, r) {
                "use strict";
                function n(t1) {
                    return {
                        stream: i(t1)
                    };
                }
                function i(t1) {
                    return function(e1) {
                        var r = new a;
                        for(var n in t1)r[n] = t1[n];
                        return r.stream = e1, r;
                    };
                }
                function a() {}
                r.d(e1, {
                    A: function() {
                        return n;
                    },
                    G: function() {
                        return i;
                    }
                }), a.prototype = {
                    constructor: a,
                    point: function(t1, e1) {
                        this.stream.point(t1, e1);
                    },
                    sphere: function() {
                        this.stream.sphere();
                    },
                    lineStart: function() {
                        this.stream.lineStart();
                    },
                    lineEnd: function() {
                        this.stream.lineEnd();
                    },
                    polygonStart: function() {
                        this.stream.polygonStart();
                    },
                    polygonEnd: function() {
                        this.stream.polygonEnd();
                    }
                };
            },
            92264: function(t1, e1, r) {
                "use strict";
                function n(t1, e1) {
                    return t1.parent === e1.parent ? 1 : 2;
                }
                function i(t1, e1) {
                    return t1 + e1.x;
                }
                function a(t1, e1) {
                    return Math.max(t1, e1.y);
                }
                function o() {
                    var t1 = n, e1 = 1, r = 1, o = !1;
                    function s(n) {
                        var s, l = 0;
                        n.eachAfter(function(e1) {
                            var r = e1.children;
                            r ? (e1.x = function(t1) {
                                return t1.reduce(i, 0) / t1.length;
                            }(r), e1.y = function(t1) {
                                return 1 + t1.reduce(a, 0);
                            }(r)) : (e1.x = s ? l += t1(e1, s) : 0, e1.y = 0, s = e1);
                        });
                        var c = function(t1) {
                            for(var e1; e1 = t1.children;)t1 = e1[0];
                            return t1;
                        }(n), u = function(t1) {
                            for(var e1; e1 = t1.children;)t1 = e1[e1.length - 1];
                            return t1;
                        }(n), h = c.x - t1(c, u) / 2, f = u.x + t1(u, c) / 2;
                        return n.eachAfter(o ? function(t1) {
                            t1.x = (t1.x - n.x) * e1, t1.y = (n.y - t1.y) * r;
                        } : function(t1) {
                            t1.x = (t1.x - h) / (f - h) * e1, t1.y = (1 - (n.y ? t1.y / n.y : 1)) * r;
                        });
                    }
                    return s.separation = function(e1) {
                        return arguments.length ? (t1 = e1, s) : t1;
                    }, s.size = function(t1) {
                        return arguments.length ? (o = !1, e1 = +t1[0], r = +t1[1], s) : o ? null : [
                            e1,
                            r
                        ];
                    }, s.nodeSize = function(t1) {
                        return arguments.length ? (o = !0, e1 = +t1[0], r = +t1[1], s) : o ? [
                            e1,
                            r
                        ] : null;
                    }, s;
                }
                function s(t1) {
                    var e1 = 0, r = t1.children, n = r && r.length;
                    if (n) for(; --n >= 0;)e1 += r[n].value;
                    else e1 = 1;
                    t1.value = e1;
                }
                function l(t1, e1) {
                    var r, n, i, a, o, s = new f(t1), l = +t1.value && (s.value = t1.value), u = [
                        s
                    ];
                    for(null == e1 && (e1 = c); r = u.pop();)if (l && (r.value = +r.data.value), (i = e1(r.data)) && (o = i.length)) for(r.children = new Array(o), a = o - 1; a >= 0; --a)u.push(n = r.children[a] = new f(i[a])), n.parent = r, n.depth = r.depth + 1;
                    return s.eachBefore(h);
                }
                function c(t1) {
                    return t1.children;
                }
                function u(t1) {
                    t1.data = t1.data.data;
                }
                function h(t1) {
                    var e1 = 0;
                    do t1.height = e1;
                    while ((t1 = t1.parent) && t1.height < ++e1);
                }
                function f(t1) {
                    this.data = t1, this.depth = this.height = 0, this.parent = null;
                }
                r.r(e1), r.d(e1, {
                    cluster: function() {
                        return o;
                    },
                    hierarchy: function() {
                        return l;
                    },
                    pack: function() {
                        return P;
                    },
                    packEnclose: function() {
                        return d;
                    },
                    packSiblings: function() {
                        return S;
                    },
                    partition: function() {
                        return B;
                    },
                    stratify: function() {
                        return H;
                    },
                    tree: function() {
                        return J;
                    },
                    treemap: function() {
                        return rt;
                    },
                    treemapBinary: function() {
                        return nt;
                    },
                    treemapDice: function() {
                        return F;
                    },
                    treemapResquarify: function() {
                        return at;
                    },
                    treemapSlice: function() {
                        return K;
                    },
                    treemapSliceDice: function() {
                        return it;
                    },
                    treemapSquarify: function() {
                        return et;
                    }
                }), f.prototype = l.prototype = {
                    constructor: f,
                    count: function() {
                        return this.eachAfter(s);
                    },
                    each: function(t1) {
                        var e1, r, n, i, a = this, o = [
                            a
                        ];
                        do {
                            for(e1 = o.reverse(), o = []; a = e1.pop();)if (t1(a), r = a.children) for(n = 0, i = r.length; n < i; ++n)o.push(r[n]);
                        }while (o.length);
                        return this;
                    },
                    eachAfter: function(t1) {
                        for(var e1, r, n, i = this, a = [
                            i
                        ], o = []; i = a.pop();)if (o.push(i), e1 = i.children) for(r = 0, n = e1.length; r < n; ++r)a.push(e1[r]);
                        for(; i = o.pop();)t1(i);
                        return this;
                    },
                    eachBefore: function(t1) {
                        for(var e1, r, n = this, i = [
                            n
                        ]; n = i.pop();)if (t1(n), e1 = n.children) for(r = e1.length - 1; r >= 0; --r)i.push(e1[r]);
                        return this;
                    },
                    sum: function(t1) {
                        return this.eachAfter(function(e1) {
                            for(var r = +t1(e1.data) || 0, n = e1.children, i = n && n.length; --i >= 0;)r += n[i].value;
                            e1.value = r;
                        });
                    },
                    sort: function(t1) {
                        return this.eachBefore(function(e1) {
                            e1.children && e1.children.sort(t1);
                        });
                    },
                    path: function(t1) {
                        for(var e1 = this, r = function(t1, e1) {
                            if (t1 === e1) return t1;
                            var r = t1.ancestors(), n = e1.ancestors(), i = null;
                            for(t1 = r.pop(), e1 = n.pop(); t1 === e1;)i = t1, t1 = r.pop(), e1 = n.pop();
                            return i;
                        }(e1, t1), n = [
                            e1
                        ]; e1 !== r;)e1 = e1.parent, n.push(e1);
                        for(var i = n.length; t1 !== r;)n.splice(i, 0, t1), t1 = t1.parent;
                        return n;
                    },
                    ancestors: function() {
                        for(var t1 = this, e1 = [
                            t1
                        ]; t1 = t1.parent;)e1.push(t1);
                        return e1;
                    },
                    descendants: function() {
                        var t1 = [];
                        return this.each(function(e1) {
                            t1.push(e1);
                        }), t1;
                    },
                    leaves: function() {
                        var t1 = [];
                        return this.eachBefore(function(e1) {
                            e1.children || t1.push(e1);
                        }), t1;
                    },
                    links: function() {
                        var t1 = this, e1 = [];
                        return t1.each(function(r) {
                            r !== t1 && e1.push({
                                source: r.parent,
                                target: r
                            });
                        }), e1;
                    },
                    copy: function() {
                        return l(this).eachBefore(u);
                    }
                };
                var p = Array.prototype.slice;
                function d(t1) {
                    for(var e1, r, n = 0, i = (t1 = function(t1) {
                        for(var e1, r, n = t1.length; n;)r = Math.random() * n-- | 0, e1 = t1[n], t1[n] = t1[r], t1[r] = e1;
                        return t1;
                    }(p.call(t1))).length, a = []; n < i;)e1 = t1[n], r && y(r, e1) ? ++n : (r = x(a = m(a, e1)), n = 0);
                    return r;
                }
                function m(t1, e1) {
                    var r, n;
                    if (v(e1, t1)) return [
                        e1
                    ];
                    for(r = 0; r < t1.length; ++r)if (g(e1, t1[r]) && v(_(t1[r], e1), t1)) return [
                        t1[r],
                        e1
                    ];
                    for(r = 0; r < t1.length - 1; ++r)for(n = r + 1; n < t1.length; ++n)if (g(_(t1[r], t1[n]), e1) && g(_(t1[r], e1), t1[n]) && g(_(t1[n], e1), t1[r]) && v(b(t1[r], t1[n], e1), t1)) return [
                        t1[r],
                        t1[n],
                        e1
                    ];
                    throw new Error;
                }
                function g(t1, e1) {
                    var r = t1.r - e1.r, n = e1.x - t1.x, i = e1.y - t1.y;
                    return r < 0 || r * r < n * n + i * i;
                }
                function y(t1, e1) {
                    var r = t1.r - e1.r + 1e-6, n = e1.x - t1.x, i = e1.y - t1.y;
                    return r > 0 && r * r > n * n + i * i;
                }
                function v(t1, e1) {
                    for(var r = 0; r < e1.length; ++r)if (!y(t1, e1[r])) return !1;
                    return !0;
                }
                function x(t1) {
                    switch(t1.length){
                        case 1:
                            return {
                                x: (e1 = t1[0]).x,
                                y: e1.y,
                                r: e1.r
                            };
                        case 2:
                            return _(t1[0], t1[1]);
                        case 3:
                            return b(t1[0], t1[1], t1[2]);
                    }
                    var e1;
                }
                function _(t1, e1) {
                    var r = t1.x, n = t1.y, i = t1.r, a = e1.x, o = e1.y, s = e1.r, l = a - r, c = o - n, u = s - i, h = Math.sqrt(l * l + c * c);
                    return {
                        x: (r + a + l / h * u) / 2,
                        y: (n + o + c / h * u) / 2,
                        r: (h + i + s) / 2
                    };
                }
                function b(t1, e1, r) {
                    var n = t1.x, i = t1.y, a = t1.r, o = e1.x, s = e1.y, l = e1.r, c = r.x, u = r.y, h = r.r, f = n - o, p = n - c, d = i - s, m = i - u, g = l - a, y = h - a, v = n * n + i * i - a * a, x = v - o * o - s * s + l * l, _ = v - c * c - u * u + h * h, b = p * d - f * m, w = (d * _ - m * x) / (2 * b) - n, T = (m * g - d * y) / b, k = (p * x - f * _) / (2 * b) - i, A = (f * y - p * g) / b, M = T * T + A * A - 1, S = 2 * (a + w * T + k * A), E = w * w + k * k - a * a, C = -(M ? (S + Math.sqrt(S * S - 4 * M * E)) / (2 * M) : E / S);
                    return {
                        x: n + w + T * C,
                        y: i + k + A * C,
                        r: C
                    };
                }
                function w(t1, e1, r) {
                    var n, i, a, o, s = t1.x - e1.x, l = t1.y - e1.y, c = s * s + l * l;
                    c ? (i = e1.r + r.r, i *= i, o = t1.r + r.r, i > (o *= o) ? (n = (c + o - i) / (2 * c), a = Math.sqrt(Math.max(0, o / c - n * n)), r.x = t1.x - n * s - a * l, r.y = t1.y - n * l + a * s) : (n = (c + i - o) / (2 * c), a = Math.sqrt(Math.max(0, i / c - n * n)), r.x = e1.x + n * s - a * l, r.y = e1.y + n * l + a * s)) : (r.x = e1.x + r.r, r.y = e1.y);
                }
                function T(t1, e1) {
                    var r = t1.r + e1.r - 1e-6, n = e1.x - t1.x, i = e1.y - t1.y;
                    return r > 0 && r * r > n * n + i * i;
                }
                function k(t1) {
                    var e1 = t1._, r = t1.next._, n = e1.r + r.r, i = (e1.x * r.r + r.x * e1.r) / n, a = (e1.y * r.r + r.y * e1.r) / n;
                    return i * i + a * a;
                }
                function A(t1) {
                    this._ = t1, this.next = null, this.previous = null;
                }
                function M(t1) {
                    if (!(i = t1.length)) return 0;
                    var e1, r, n, i, a, o, s, l, c, u, h;
                    if ((e1 = t1[0]).x = 0, e1.y = 0, !(i > 1)) return e1.r;
                    if (r = t1[1], e1.x = -r.r, r.x = e1.r, r.y = 0, !(i > 2)) return e1.r + r.r;
                    w(r, e1, n = t1[2]), e1 = new A(e1), r = new A(r), n = new A(n), e1.next = n.previous = r, r.next = e1.previous = n, n.next = r.previous = e1;
                    t: for(s = 3; s < i; ++s){
                        w(e1._, r._, n = t1[s]), n = new A(n), l = r.next, c = e1.previous, u = r._.r, h = e1._.r;
                        do if (u <= h) {
                            if (T(l._, n._)) {
                                r = l, e1.next = r, r.previous = e1, --s;
                                continue t;
                            }
                            u += l._.r, l = l.next;
                        } else {
                            if (T(c._, n._)) {
                                (e1 = c).next = r, r.previous = e1, --s;
                                continue t;
                            }
                            h += c._.r, c = c.previous;
                        }
                        while (l !== c.next);
                        for(n.previous = e1, n.next = r, e1.next = r.previous = r = n, a = k(e1); (n = n.next) !== r;)(o = k(n)) < a && (e1 = n, a = o);
                        r = e1.next;
                    }
                    for(e1 = [
                        r._
                    ], n = r; (n = n.next) !== r;)e1.push(n._);
                    for(n = d(e1), s = 0; s < i; ++s)(e1 = t1[s]).x -= n.x, e1.y -= n.y;
                    return n.r;
                }
                function S(t1) {
                    return M(t1), t1;
                }
                function E(t1) {
                    if ("function" != typeof t1) throw new Error;
                    return t1;
                }
                function C() {
                    return 0;
                }
                function L(t1) {
                    return function() {
                        return t1;
                    };
                }
                function I(t1) {
                    return Math.sqrt(t1.value);
                }
                function P() {
                    var t1 = null, e1 = 1, r = 1, n = C;
                    function i(i) {
                        return i.x = e1 / 2, i.y = r / 2, t1 ? i.eachBefore(z(t1)).eachAfter(O(n, .5)).eachBefore(D(1)) : i.eachBefore(z(I)).eachAfter(O(C, 1)).eachAfter(O(n, i.r / Math.min(e1, r))).eachBefore(D(Math.min(e1, r) / (2 * i.r))), i;
                    }
                    return i.radius = function(e1) {
                        var r;
                        return arguments.length ? (t1 = null == (r = e1) ? null : E(r), i) : t1;
                    }, i.size = function(t1) {
                        return arguments.length ? (e1 = +t1[0], r = +t1[1], i) : [
                            e1,
                            r
                        ];
                    }, i.padding = function(t1) {
                        return arguments.length ? (n = "function" == typeof t1 ? t1 : L(+t1), i) : n;
                    }, i;
                }
                function z(t1) {
                    return function(e1) {
                        e1.children || (e1.r = Math.max(0, +t1(e1) || 0));
                    };
                }
                function O(t1, e1) {
                    return function(r) {
                        if (n = r.children) {
                            var n, i, a, o = n.length, s = t1(r) * e1 || 0;
                            if (s) for(i = 0; i < o; ++i)n[i].r += s;
                            if (a = M(n), s) for(i = 0; i < o; ++i)n[i].r -= s;
                            r.r = a + s;
                        }
                    };
                }
                function D(t1) {
                    return function(e1) {
                        var r = e1.parent;
                        e1.r *= t1, r && (e1.x = r.x + t1 * e1.x, e1.y = r.y + t1 * e1.y);
                    };
                }
                function R(t1) {
                    t1.x0 = Math.round(t1.x0), t1.y0 = Math.round(t1.y0), t1.x1 = Math.round(t1.x1), t1.y1 = Math.round(t1.y1);
                }
                function F(t1, e1, r, n, i) {
                    for(var a, o = t1.children, s = -1, l = o.length, c = t1.value && (n - e1) / t1.value; ++s < l;)(a = o[s]).y0 = r, a.y1 = i, a.x0 = e1, a.x1 = e1 += a.value * c;
                }
                function B() {
                    var t1 = 1, e1 = 1, r = 0, n = !1;
                    function i(i) {
                        var a = i.height + 1;
                        return i.x0 = i.y0 = r, i.x1 = t1, i.y1 = e1 / a, i.eachBefore(function(t1, e1) {
                            return function(n) {
                                n.children && F(n, n.x0, t1 * (n.depth + 1) / e1, n.x1, t1 * (n.depth + 2) / e1);
                                var i = n.x0, a = n.y0, o = n.x1 - r, s = n.y1 - r;
                                o < i && (i = o = (i + o) / 2), s < a && (a = s = (a + s) / 2), n.x0 = i, n.y0 = a, n.x1 = o, n.y1 = s;
                            };
                        }(e1, a)), n && i.eachBefore(R), i;
                    }
                    return i.round = function(t1) {
                        return arguments.length ? (n = !!t1, i) : n;
                    }, i.size = function(r) {
                        return arguments.length ? (t1 = +r[0], e1 = +r[1], i) : [
                            t1,
                            e1
                        ];
                    }, i.padding = function(t1) {
                        return arguments.length ? (r = +t1, i) : r;
                    }, i;
                }
                var N = "$", j = {
                    depth: -1
                }, U = {};
                function V(t1) {
                    return t1.id;
                }
                function q(t1) {
                    return t1.parentId;
                }
                function H() {
                    var t1 = V, e1 = q;
                    function r(r) {
                        var n, i, a, o, s, l, c, u = r.length, p = new Array(u), d = {};
                        for(i = 0; i < u; ++i)n = r[i], s = p[i] = new f(n), null != (l = t1(n, i, r)) && (l += "") && (d[c = N + (s.id = l)] = c in d ? U : s);
                        for(i = 0; i < u; ++i)if (s = p[i], null != (l = e1(r[i], i, r)) && (l += "")) {
                            if (!(o = d[N + l])) throw new Error("missing: " + l);
                            if (o === U) throw new Error("ambiguous: " + l);
                            o.children ? o.children.push(s) : o.children = [
                                s
                            ], s.parent = o;
                        } else {
                            if (a) throw new Error("multiple roots");
                            a = s;
                        }
                        if (!a) throw new Error("no root");
                        if (a.parent = j, a.eachBefore(function(t1) {
                            t1.depth = t1.parent.depth + 1, --u;
                        }).eachBefore(h), a.parent = null, u > 0) throw new Error("cycle");
                        return a;
                    }
                    return r.id = function(e1) {
                        return arguments.length ? (t1 = E(e1), r) : t1;
                    }, r.parentId = function(t1) {
                        return arguments.length ? (e1 = E(t1), r) : e1;
                    }, r;
                }
                function G(t1, e1) {
                    return t1.parent === e1.parent ? 1 : 2;
                }
                function Z(t1) {
                    var e1 = t1.children;
                    return e1 ? e1[0] : t1.t;
                }
                function W(t1) {
                    var e1 = t1.children;
                    return e1 ? e1[e1.length - 1] : t1.t;
                }
                function Y(t1, e1, r) {
                    var n = r / (e1.i - t1.i);
                    e1.c -= n, e1.s += r, t1.c += n, e1.z += r, e1.m += r;
                }
                function X(t1, e1, r) {
                    return t1.a.parent === e1.parent ? t1.a : r;
                }
                function $(t1, e1) {
                    this._ = t1, this.parent = null, this.children = null, this.A = null, this.a = this, this.z = 0, this.m = 0, this.c = 0, this.s = 0, this.t = null, this.i = e1;
                }
                function J() {
                    var t1 = G, e1 = 1, r = 1, n = null;
                    function i(i) {
                        var l = function(t1) {
                            for(var e1, r, n, i, a, o = new $(t1, 0), s = [
                                o
                            ]; e1 = s.pop();)if (n = e1._.children) for(e1.children = new Array(a = n.length), i = a - 1; i >= 0; --i)s.push(r = e1.children[i] = new $(n[i], i)), r.parent = e1;
                            return (o.parent = new $(null, 0)).children = [
                                o
                            ], o;
                        }(i);
                        if (l.eachAfter(a), l.parent.m = -l.z, l.eachBefore(o), n) i.eachBefore(s);
                        else {
                            var c = i, u = i, h = i;
                            i.eachBefore(function(t1) {
                                t1.x < c.x && (c = t1), t1.x > u.x && (u = t1), t1.depth > h.depth && (h = t1);
                            });
                            var f = c === u ? 1 : t1(c, u) / 2, p = f - c.x, d = e1 / (u.x + f + p), m = r / (h.depth || 1);
                            i.eachBefore(function(t1) {
                                t1.x = (t1.x + p) * d, t1.y = t1.depth * m;
                            });
                        }
                        return i;
                    }
                    function a(e1) {
                        var r = e1.children, n = e1.parent.children, i = e1.i ? n[e1.i - 1] : null;
                        if (r) {
                            !function(t1) {
                                for(var e1, r = 0, n = 0, i = t1.children, a = i.length; --a >= 0;)(e1 = i[a]).z += r, e1.m += r, r += e1.s + (n += e1.c);
                            }(e1);
                            var a = (r[0].z + r[r.length - 1].z) / 2;
                            i ? (e1.z = i.z + t1(e1._, i._), e1.m = e1.z - a) : e1.z = a;
                        } else i && (e1.z = i.z + t1(e1._, i._));
                        e1.parent.A = function(e1, r, n) {
                            if (r) {
                                for(var i, a = e1, o = e1, s = r, l = a.parent.children[0], c = a.m, u = o.m, h = s.m, f = l.m; s = W(s), a = Z(a), s && a;)l = Z(l), (o = W(o)).a = e1, (i = s.z + h - a.z - c + t1(s._, a._)) > 0 && (Y(X(s, e1, n), e1, i), c += i, u += i), h += s.m, c += a.m, f += l.m, u += o.m;
                                s && !W(o) && (o.t = s, o.m += h - u), a && !Z(l) && (l.t = a, l.m += c - f, n = e1);
                            }
                            return n;
                        }(e1, i, e1.parent.A || n[0]);
                    }
                    function o(t1) {
                        t1._.x = t1.z + t1.parent.m, t1.m += t1.parent.m;
                    }
                    function s(t1) {
                        t1.x *= e1, t1.y = t1.depth * r;
                    }
                    return i.separation = function(e1) {
                        return arguments.length ? (t1 = e1, i) : t1;
                    }, i.size = function(t1) {
                        return arguments.length ? (n = !1, e1 = +t1[0], r = +t1[1], i) : n ? null : [
                            e1,
                            r
                        ];
                    }, i.nodeSize = function(t1) {
                        return arguments.length ? (n = !0, e1 = +t1[0], r = +t1[1], i) : n ? [
                            e1,
                            r
                        ] : null;
                    }, i;
                }
                function K(t1, e1, r, n, i) {
                    for(var a, o = t1.children, s = -1, l = o.length, c = t1.value && (i - r) / t1.value; ++s < l;)(a = o[s]).x0 = e1, a.x1 = n, a.y0 = r, a.y1 = r += a.value * c;
                }
                $.prototype = Object.create(f.prototype);
                var Q = (1 + Math.sqrt(5)) / 2;
                function tt(t1, e1, r, n, i, a) {
                    for(var o, s, l, c, u, h, f, p, d, m, g, y = [], v = e1.children, x = 0, _ = 0, b = v.length, w = e1.value; x < b;){
                        l = i - r, c = a - n;
                        do u = v[_++].value;
                        while (!u && _ < b);
                        for(h = f = u, g = u * u * (m = Math.max(c / l, l / c) / (w * t1)), d = Math.max(f / g, g / h); _ < b; ++_){
                            if (u += s = v[_].value, s < h && (h = s), s > f && (f = s), g = u * u * m, (p = Math.max(f / g, g / h)) > d) {
                                u -= s;
                                break;
                            }
                            d = p;
                        }
                        y.push(o = {
                            value: u,
                            dice: l < c,
                            children: v.slice(x, _)
                        }), o.dice ? F(o, r, n, i, w ? n += c * u / w : a) : K(o, r, n, w ? r += l * u / w : i, a), w -= u, x = _;
                    }
                    return y;
                }
                var et = function t1(e1) {
                    function r(t1, r, n, i, a) {
                        tt(e1, t1, r, n, i, a);
                    }
                    return r.ratio = function(e1) {
                        return t1((e1 = +e1) > 1 ? e1 : 1);
                    }, r;
                }(Q);
                function rt() {
                    var t1 = et, e1 = !1, r = 1, n = 1, i = [
                        0
                    ], a = C, o = C, s = C, l = C, c = C;
                    function u(t1) {
                        return t1.x0 = t1.y0 = 0, t1.x1 = r, t1.y1 = n, t1.eachBefore(h), i = [
                            0
                        ], e1 && t1.eachBefore(R), t1;
                    }
                    function h(e1) {
                        var r = i[e1.depth], n = e1.x0 + r, u = e1.y0 + r, h = e1.x1 - r, f = e1.y1 - r;
                        h < n && (n = h = (n + h) / 2), f < u && (u = f = (u + f) / 2), e1.x0 = n, e1.y0 = u, e1.x1 = h, e1.y1 = f, e1.children && (r = i[e1.depth + 1] = a(e1) / 2, n += c(e1) - r, u += o(e1) - r, (h -= s(e1) - r) < n && (n = h = (n + h) / 2), (f -= l(e1) - r) < u && (u = f = (u + f) / 2), t1(e1, n, u, h, f));
                    }
                    return u.round = function(t1) {
                        return arguments.length ? (e1 = !!t1, u) : e1;
                    }, u.size = function(t1) {
                        return arguments.length ? (r = +t1[0], n = +t1[1], u) : [
                            r,
                            n
                        ];
                    }, u.tile = function(e1) {
                        return arguments.length ? (t1 = E(e1), u) : t1;
                    }, u.padding = function(t1) {
                        return arguments.length ? u.paddingInner(t1).paddingOuter(t1) : u.paddingInner();
                    }, u.paddingInner = function(t1) {
                        return arguments.length ? (a = "function" == typeof t1 ? t1 : L(+t1), u) : a;
                    }, u.paddingOuter = function(t1) {
                        return arguments.length ? u.paddingTop(t1).paddingRight(t1).paddingBottom(t1).paddingLeft(t1) : u.paddingTop();
                    }, u.paddingTop = function(t1) {
                        return arguments.length ? (o = "function" == typeof t1 ? t1 : L(+t1), u) : o;
                    }, u.paddingRight = function(t1) {
                        return arguments.length ? (s = "function" == typeof t1 ? t1 : L(+t1), u) : s;
                    }, u.paddingBottom = function(t1) {
                        return arguments.length ? (l = "function" == typeof t1 ? t1 : L(+t1), u) : l;
                    }, u.paddingLeft = function(t1) {
                        return arguments.length ? (c = "function" == typeof t1 ? t1 : L(+t1), u) : c;
                    }, u;
                }
                function nt(t1, e1, r, n, i) {
                    var a, o, s = t1.children, l = s.length, c = new Array(l + 1);
                    for(c[0] = o = a = 0; a < l; ++a)c[a + 1] = o += s[a].value;
                    !function t1(e1, r, n, i, a, o, l) {
                        if (e1 >= r - 1) {
                            var u = s[e1];
                            return u.x0 = i, u.y0 = a, u.x1 = o, void (u.y1 = l);
                        }
                        for(var h = c[e1], f = n / 2 + h, p = e1 + 1, d = r - 1; p < d;){
                            var m = p + d >>> 1;
                            c[m] < f ? p = m + 1 : d = m;
                        }
                        f - c[p - 1] < c[p] - f && e1 + 1 < p && --p;
                        var g = c[p] - h, y = n - g;
                        if (o - i > l - a) {
                            var v = (i * y + o * g) / n;
                            t1(e1, p, g, i, a, v, l), t1(p, r, y, v, a, o, l);
                        } else {
                            var x = (a * y + l * g) / n;
                            t1(e1, p, g, i, a, o, x), t1(p, r, y, i, x, o, l);
                        }
                    }(0, l, t1.value, e1, r, n, i);
                }
                function it(t1, e1, r, n, i) {
                    (1 & t1.depth ? K : F)(t1, e1, r, n, i);
                }
                var at = function t1(e1) {
                    function r(t1, r, n, i, a) {
                        if ((o = t1._squarify) && o.ratio === e1) for(var o, s, l, c, u, h = -1, f = o.length, p = t1.value; ++h < f;){
                            for(l = (s = o[h]).children, c = s.value = 0, u = l.length; c < u; ++c)s.value += l[c].value;
                            s.dice ? F(s, r, n, i, n += (a - n) * s.value / p) : K(s, r, n, r += (i - r) * s.value / p, a), p -= s.value;
                        }
                        else t1._squarify = o = tt(e1, t1, r, n, i, a), o.ratio = e1;
                    }
                    return r.ratio = function(e1) {
                        return t1((e1 = +e1) > 1 ? e1 : 1);
                    }, r;
                }(Q);
            },
            48544: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    pq: function() {
                        return y;
                    }
                });
                var n = Math.PI, i = 2 * n, a = 1e-6, o = i - a;
                function s() {
                    this._x0 = this._y0 = this._x1 = this._y1 = null, this._ = "";
                }
                function l() {
                    return new s;
                }
                s.prototype = l.prototype = {
                    constructor: s,
                    moveTo: function(t1, e1) {
                        this._ += "M" + (this._x0 = this._x1 = +t1) + "," + (this._y0 = this._y1 = +e1);
                    },
                    closePath: function() {
                        null !== this._x1 && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
                    },
                    lineTo: function(t1, e1) {
                        this._ += "L" + (this._x1 = +t1) + "," + (this._y1 = +e1);
                    },
                    quadraticCurveTo: function(t1, e1, r, n) {
                        this._ += "Q" + +t1 + "," + +e1 + "," + (this._x1 = +r) + "," + (this._y1 = +n);
                    },
                    bezierCurveTo: function(t1, e1, r, n, i, a) {
                        this._ += "C" + +t1 + "," + +e1 + "," + +r + "," + +n + "," + (this._x1 = +i) + "," + (this._y1 = +a);
                    },
                    arcTo: function(t1, e1, r, i, o) {
                        t1 = +t1, e1 = +e1, r = +r, i = +i, o = +o;
                        var s = this._x1, l = this._y1, c = r - t1, u = i - e1, h = s - t1, f = l - e1, p = h * h + f * f;
                        if (o < 0) throw new Error("negative radius: " + o);
                        if (null === this._x1) this._ += "M" + (this._x1 = t1) + "," + (this._y1 = e1);
                        else if (p > a) {
                            if (Math.abs(f * c - u * h) > a && o) {
                                var d = r - s, m = i - l, g = c * c + u * u, y = d * d + m * m, v = Math.sqrt(g), x = Math.sqrt(p), _ = o * Math.tan((n - Math.acos((g + p - y) / (2 * v * x))) / 2), b = _ / x, w = _ / v;
                                Math.abs(b - 1) > a && (this._ += "L" + (t1 + b * h) + "," + (e1 + b * f)), this._ += "A" + o + "," + o + ",0,0," + +(f * d > h * m) + "," + (this._x1 = t1 + w * c) + "," + (this._y1 = e1 + w * u);
                            } else this._ += "L" + (this._x1 = t1) + "," + (this._y1 = e1);
                        }
                    },
                    arc: function(t1, e1, r, s, l, c) {
                        t1 = +t1, e1 = +e1, c = !!c;
                        var u = (r = +r) * Math.cos(s), h = r * Math.sin(s), f = t1 + u, p = e1 + h, d = 1 ^ c, m = c ? s - l : l - s;
                        if (r < 0) throw new Error("negative radius: " + r);
                        null === this._x1 ? this._ += "M" + f + "," + p : (Math.abs(this._x1 - f) > a || Math.abs(this._y1 - p) > a) && (this._ += "L" + f + "," + p), r && (m < 0 && (m = m % i + i), m > o ? this._ += "A" + r + "," + r + ",0,1," + d + "," + (t1 - u) + "," + (e1 - h) + "A" + r + "," + r + ",0,1," + d + "," + (this._x1 = f) + "," + (this._y1 = p) : m > a && (this._ += "A" + r + "," + r + ",0," + +(m >= n) + "," + d + "," + (this._x1 = t1 + r * Math.cos(l)) + "," + (this._y1 = e1 + r * Math.sin(l))));
                    },
                    rect: function(t1, e1, r, n) {
                        this._ += "M" + (this._x0 = this._x1 = +t1) + "," + (this._y0 = this._y1 = +e1) + "h" + +r + "v" + +n + "h" + -r + "Z";
                    },
                    toString: function() {
                        return this._;
                    }
                };
                var c = l, u = Array.prototype.slice;
                function h(t1) {
                    return function() {
                        return t1;
                    };
                }
                function f(t1) {
                    return t1[0];
                }
                function p(t1) {
                    return t1[1];
                }
                function d(t1) {
                    return t1.source;
                }
                function m(t1) {
                    return t1.target;
                }
                function g(t1, e1, r, n, i) {
                    t1.moveTo(e1, r), t1.bezierCurveTo(e1 = (e1 + n) / 2, r, e1, i, n, i);
                }
                function y() {
                    return function(t1) {
                        var e1 = d, r = m, n = f, i = p, a = null;
                        function o() {
                            var o, s = u.call(arguments), l = e1.apply(this, s), h = r.apply(this, s);
                            if (a || (a = o = c()), t1(a, +n.apply(this, (s[0] = l, s)), +i.apply(this, s), +n.apply(this, (s[0] = h, s)), +i.apply(this, s)), o) return a = null, o + "" || null;
                        }
                        return o.source = function(t1) {
                            return arguments.length ? (e1 = t1, o) : e1;
                        }, o.target = function(t1) {
                            return arguments.length ? (r = t1, o) : r;
                        }, o.x = function(t1) {
                            return arguments.length ? (n = "function" == typeof t1 ? t1 : h(+t1), o) : n;
                        }, o.y = function(t1) {
                            return arguments.length ? (i = "function" == typeof t1 ? t1 : h(+t1), o) : i;
                        }, o.context = function(t1) {
                            return arguments.length ? (a = null == t1 ? null : t1, o) : a;
                        }, o;
                    }(g);
                }
            },
            42696: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    DC: function() {
                        return d;
                    },
                    de: function() {
                        return f;
                    },
                    aL: function() {
                        return m;
                    }
                });
                var n = r(1681), i = r(72543), a = r(55735), o = r(47265), s = r(9830), l = r(59764);
                function c(t1) {
                    if (0 <= t1.y && t1.y < 100) {
                        var e1 = new Date(-1, t1.m, t1.d, t1.H, t1.M, t1.S, t1.L);
                        return e1.setFullYear(t1.y), e1;
                    }
                    return new Date(t1.y, t1.m, t1.d, t1.H, t1.M, t1.S, t1.L);
                }
                function u(t1) {
                    if (0 <= t1.y && t1.y < 100) {
                        var e1 = new Date(Date.UTC(-1, t1.m, t1.d, t1.H, t1.M, t1.S, t1.L));
                        return e1.setUTCFullYear(t1.y), e1;
                    }
                    return new Date(Date.UTC(t1.y, t1.m, t1.d, t1.H, t1.M, t1.S, t1.L));
                }
                function h(t1, e1, r) {
                    return {
                        y: t1,
                        m: e1,
                        d: r,
                        H: 0,
                        M: 0,
                        S: 0,
                        L: 0
                    };
                }
                function f(t1) {
                    var e1 = t1.dateTime, r = t1.date, s = t1.time, l = t1.periods, f = t1.days, p = t1.shortDays, d = t1.months, m = t1.shortMonths, y = w(l), v = T(l), x = w(f), _ = T(f), b = w(p), St = T(p), Et = w(d), Ct = T(d), Lt = w(m), It = T(m), Pt = {
                        a: function(t1) {
                            return p[t1.getDay()];
                        },
                        A: function(t1) {
                            return f[t1.getDay()];
                        },
                        b: function(t1) {
                            return m[t1.getMonth()];
                        },
                        B: function(t1) {
                            return d[t1.getMonth()];
                        },
                        c: null,
                        d: H,
                        e: H,
                        f: X,
                        H: G,
                        I: Z,
                        j: W,
                        L: Y,
                        m: $,
                        M: J,
                        p: function(t1) {
                            return l[+(t1.getHours() >= 12)];
                        },
                        q: function(t1) {
                            return 1 + ~~(t1.getMonth() / 3);
                        },
                        Q: At,
                        s: Mt,
                        S: K,
                        u: Q,
                        U: tt,
                        V: et,
                        w: rt,
                        W: nt,
                        x: null,
                        X: null,
                        y: it,
                        Y: at,
                        Z: ot,
                        "%": kt
                    }, zt = {
                        a: function(t1) {
                            return p[t1.getUTCDay()];
                        },
                        A: function(t1) {
                            return f[t1.getUTCDay()];
                        },
                        b: function(t1) {
                            return m[t1.getUTCMonth()];
                        },
                        B: function(t1) {
                            return d[t1.getUTCMonth()];
                        },
                        c: null,
                        d: st,
                        e: st,
                        f: ft,
                        H: lt,
                        I: ct,
                        j: ut,
                        L: ht,
                        m: pt,
                        M: dt,
                        p: function(t1) {
                            return l[+(t1.getUTCHours() >= 12)];
                        },
                        q: function(t1) {
                            return 1 + ~~(t1.getUTCMonth() / 3);
                        },
                        Q: At,
                        s: Mt,
                        S: mt,
                        u: gt,
                        U: yt,
                        V: vt,
                        w: xt,
                        W: _t,
                        x: null,
                        X: null,
                        y: bt,
                        Y: wt,
                        Z: Tt,
                        "%": kt
                    }, Ot = {
                        a: function(t1, e1, r) {
                            var n = b.exec(e1.slice(r));
                            return n ? (t1.w = St[n[0].toLowerCase()], r + n[0].length) : -1;
                        },
                        A: function(t1, e1, r) {
                            var n = x.exec(e1.slice(r));
                            return n ? (t1.w = _[n[0].toLowerCase()], r + n[0].length) : -1;
                        },
                        b: function(t1, e1, r) {
                            var n = Lt.exec(e1.slice(r));
                            return n ? (t1.m = It[n[0].toLowerCase()], r + n[0].length) : -1;
                        },
                        B: function(t1, e1, r) {
                            var n = Et.exec(e1.slice(r));
                            return n ? (t1.m = Ct[n[0].toLowerCase()], r + n[0].length) : -1;
                        },
                        c: function(t1, r, n) {
                            return Ft(t1, e1, r, n);
                        },
                        d: O,
                        e: O,
                        f: j,
                        H: R,
                        I: R,
                        j: D,
                        L: N,
                        m: z,
                        M: F,
                        p: function(t1, e1, r) {
                            var n = y.exec(e1.slice(r));
                            return n ? (t1.p = v[n[0].toLowerCase()], r + n[0].length) : -1;
                        },
                        q: P,
                        Q: V,
                        s: q,
                        S: B,
                        u: A,
                        U: M,
                        V: S,
                        w: k,
                        W: E,
                        x: function(t1, e1, n) {
                            return Ft(t1, r, e1, n);
                        },
                        X: function(t1, e1, r) {
                            return Ft(t1, s, e1, r);
                        },
                        y: L,
                        Y: C,
                        Z: I,
                        "%": U
                    };
                    function Dt(t1, e1) {
                        return function(r) {
                            var n, i, a, o = [], s = -1, l = 0, c = t1.length;
                            for(r instanceof Date || (r = new Date(+r)); ++s < c;)37 === t1.charCodeAt(s) && (o.push(t1.slice(l, s)), null != (i = g[n = t1.charAt(++s)]) ? n = t1.charAt(++s) : i = "e" === n ? " " : "0", (a = e1[n]) && (n = a(r, i)), o.push(n), l = s + 1);
                            return o.push(t1.slice(l, s)), o.join("");
                        };
                    }
                    function Rt(t1, e1) {
                        return function(r) {
                            var s, l, f = h(1900, void 0, 1);
                            if (Ft(f, t1, r += "", 0) != r.length) return null;
                            if ("Q" in f) return new Date(f.Q);
                            if ("s" in f) return new Date(1e3 * f.s + ("L" in f ? f.L : 0));
                            if (e1 && !("Z" in f) && (f.Z = 0), "p" in f && (f.H = f.H % 12 + 12 * f.p), void 0 === f.m && (f.m = "q" in f ? f.q : 0), "V" in f) {
                                if (f.V < 1 || f.V > 53) return null;
                                "w" in f || (f.w = 1), "Z" in f ? (l = (s = u(h(f.y, 0, 1))).getUTCDay(), s = l > 4 || 0 === l ? n.rt.ceil(s) : (0, n.rt)(s), s = i.A.offset(s, 7 * (f.V - 1)), f.y = s.getUTCFullYear(), f.m = s.getUTCMonth(), f.d = s.getUTCDate() + (f.w + 6) % 7) : (l = (s = c(h(f.y, 0, 1))).getDay(), s = l > 4 || 0 === l ? a.By.ceil(s) : (0, a.By)(s), s = o.A.offset(s, 7 * (f.V - 1)), f.y = s.getFullYear(), f.m = s.getMonth(), f.d = s.getDate() + (f.w + 6) % 7);
                            } else ("W" in f || "U" in f) && ("w" in f || (f.w = "u" in f ? f.u % 7 : "W" in f ? 1 : 0), l = "Z" in f ? u(h(f.y, 0, 1)).getUTCDay() : c(h(f.y, 0, 1)).getDay(), f.m = 0, f.d = "W" in f ? (f.w + 6) % 7 + 7 * f.W - (l + 5) % 7 : f.w + 7 * f.U - (l + 6) % 7);
                            return "Z" in f ? (f.H += f.Z / 100 | 0, f.M += f.Z % 100, u(f)) : c(f);
                        };
                    }
                    function Ft(t1, e1, r, n) {
                        for(var i, a, o = 0, s = e1.length, l = r.length; o < s;){
                            if (n >= l) return -1;
                            if (37 === (i = e1.charCodeAt(o++))) {
                                if (i = e1.charAt(o++), !(a = Ot[i in g ? e1.charAt(o++) : i]) || (n = a(t1, r, n)) < 0) return -1;
                            } else if (i != r.charCodeAt(n++)) return -1;
                        }
                        return n;
                    }
                    return Pt.x = Dt(r, Pt), Pt.X = Dt(s, Pt), Pt.c = Dt(e1, Pt), zt.x = Dt(r, zt), zt.X = Dt(s, zt), zt.c = Dt(e1, zt), {
                        format: function(t1) {
                            var e1 = Dt(t1 += "", Pt);
                            return e1.toString = function() {
                                return t1;
                            }, e1;
                        },
                        parse: function(t1) {
                            var e1 = Rt(t1 += "", !1);
                            return e1.toString = function() {
                                return t1;
                            }, e1;
                        },
                        utcFormat: function(t1) {
                            var e1 = Dt(t1 += "", zt);
                            return e1.toString = function() {
                                return t1;
                            }, e1;
                        },
                        utcParse: function(t1) {
                            var e1 = Rt(t1 += "", !0);
                            return e1.toString = function() {
                                return t1;
                            }, e1;
                        }
                    };
                }
                var p, d, m, g = {
                    "-": "",
                    _: " ",
                    0: "0"
                }, y = /^\s*\d+/, v = /^%/, x = /[\\^$*+?|[\]().{}]/g;
                function _(t1, e1, r) {
                    var n = t1 < 0 ? "-" : "", i = (n ? -t1 : t1) + "", a = i.length;
                    return n + (a < r ? new Array(r - a + 1).join(e1) + i : i);
                }
                function b(t1) {
                    return t1.replace(x, "\\$&");
                }
                function w(t1) {
                    return new RegExp("^(?:" + t1.map(b).join("|") + ")", "i");
                }
                function T(t1) {
                    for(var e1 = {}, r = -1, n = t1.length; ++r < n;)e1[t1[r].toLowerCase()] = r;
                    return e1;
                }
                function k(t1, e1, r) {
                    var n = y.exec(e1.slice(r, r + 1));
                    return n ? (t1.w = +n[0], r + n[0].length) : -1;
                }
                function A(t1, e1, r) {
                    var n = y.exec(e1.slice(r, r + 1));
                    return n ? (t1.u = +n[0], r + n[0].length) : -1;
                }
                function M(t1, e1, r) {
                    var n = y.exec(e1.slice(r, r + 2));
                    return n ? (t1.U = +n[0], r + n[0].length) : -1;
                }
                function S(t1, e1, r) {
                    var n = y.exec(e1.slice(r, r + 2));
                    return n ? (t1.V = +n[0], r + n[0].length) : -1;
                }
                function E(t1, e1, r) {
                    var n = y.exec(e1.slice(r, r + 2));
                    return n ? (t1.W = +n[0], r + n[0].length) : -1;
                }
                function C(t1, e1, r) {
                    var n = y.exec(e1.slice(r, r + 4));
                    return n ? (t1.y = +n[0], r + n[0].length) : -1;
                }
                function L(t1, e1, r) {
                    var n = y.exec(e1.slice(r, r + 2));
                    return n ? (t1.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), r + n[0].length) : -1;
                }
                function I(t1, e1, r) {
                    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(e1.slice(r, r + 6));
                    return n ? (t1.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), r + n[0].length) : -1;
                }
                function P(t1, e1, r) {
                    var n = y.exec(e1.slice(r, r + 1));
                    return n ? (t1.q = 3 * n[0] - 3, r + n[0].length) : -1;
                }
                function z(t1, e1, r) {
                    var n = y.exec(e1.slice(r, r + 2));
                    return n ? (t1.m = n[0] - 1, r + n[0].length) : -1;
                }
                function O(t1, e1, r) {
                    var n = y.exec(e1.slice(r, r + 2));
                    return n ? (t1.d = +n[0], r + n[0].length) : -1;
                }
                function D(t1, e1, r) {
                    var n = y.exec(e1.slice(r, r + 3));
                    return n ? (t1.m = 0, t1.d = +n[0], r + n[0].length) : -1;
                }
                function R(t1, e1, r) {
                    var n = y.exec(e1.slice(r, r + 2));
                    return n ? (t1.H = +n[0], r + n[0].length) : -1;
                }
                function F(t1, e1, r) {
                    var n = y.exec(e1.slice(r, r + 2));
                    return n ? (t1.M = +n[0], r + n[0].length) : -1;
                }
                function B(t1, e1, r) {
                    var n = y.exec(e1.slice(r, r + 2));
                    return n ? (t1.S = +n[0], r + n[0].length) : -1;
                }
                function N(t1, e1, r) {
                    var n = y.exec(e1.slice(r, r + 3));
                    return n ? (t1.L = +n[0], r + n[0].length) : -1;
                }
                function j(t1, e1, r) {
                    var n = y.exec(e1.slice(r, r + 6));
                    return n ? (t1.L = Math.floor(n[0] / 1e3), r + n[0].length) : -1;
                }
                function U(t1, e1, r) {
                    var n = v.exec(e1.slice(r, r + 1));
                    return n ? r + n[0].length : -1;
                }
                function V(t1, e1, r) {
                    var n = y.exec(e1.slice(r));
                    return n ? (t1.Q = +n[0], r + n[0].length) : -1;
                }
                function q(t1, e1, r) {
                    var n = y.exec(e1.slice(r));
                    return n ? (t1.s = +n[0], r + n[0].length) : -1;
                }
                function H(t1, e1) {
                    return _(t1.getDate(), e1, 2);
                }
                function G(t1, e1) {
                    return _(t1.getHours(), e1, 2);
                }
                function Z(t1, e1) {
                    return _(t1.getHours() % 12 || 12, e1, 2);
                }
                function W(t1, e1) {
                    return _(1 + o.A.count((0, s.A)(t1), t1), e1, 3);
                }
                function Y(t1, e1) {
                    return _(t1.getMilliseconds(), e1, 3);
                }
                function X(t1, e1) {
                    return Y(t1, e1) + "000";
                }
                function $(t1, e1) {
                    return _(t1.getMonth() + 1, e1, 2);
                }
                function J(t1, e1) {
                    return _(t1.getMinutes(), e1, 2);
                }
                function K(t1, e1) {
                    return _(t1.getSeconds(), e1, 2);
                }
                function Q(t1) {
                    var e1 = t1.getDay();
                    return 0 === e1 ? 7 : e1;
                }
                function tt(t1, e1) {
                    return _(a.fz.count((0, s.A)(t1) - 1, t1), e1, 2);
                }
                function et(t1, e1) {
                    var r = t1.getDay();
                    return t1 = r >= 4 || 0 === r ? (0, a.dt)(t1) : a.dt.ceil(t1), _(a.dt.count((0, s.A)(t1), t1) + (4 === (0, s.A)(t1).getDay()), e1, 2);
                }
                function rt(t1) {
                    return t1.getDay();
                }
                function nt(t1, e1) {
                    return _(a.By.count((0, s.A)(t1) - 1, t1), e1, 2);
                }
                function it(t1, e1) {
                    return _(t1.getFullYear() % 100, e1, 2);
                }
                function at(t1, e1) {
                    return _(t1.getFullYear() % 1e4, e1, 4);
                }
                function ot(t1) {
                    var e1 = t1.getTimezoneOffset();
                    return (e1 > 0 ? "-" : (e1 *= -1, "+")) + _(e1 / 60 | 0, "0", 2) + _(e1 % 60, "0", 2);
                }
                function st(t1, e1) {
                    return _(t1.getUTCDate(), e1, 2);
                }
                function lt(t1, e1) {
                    return _(t1.getUTCHours(), e1, 2);
                }
                function ct(t1, e1) {
                    return _(t1.getUTCHours() % 12 || 12, e1, 2);
                }
                function ut(t1, e1) {
                    return _(1 + i.A.count((0, l.A)(t1), t1), e1, 3);
                }
                function ht(t1, e1) {
                    return _(t1.getUTCMilliseconds(), e1, 3);
                }
                function ft(t1, e1) {
                    return ht(t1, e1) + "000";
                }
                function pt(t1, e1) {
                    return _(t1.getUTCMonth() + 1, e1, 2);
                }
                function dt(t1, e1) {
                    return _(t1.getUTCMinutes(), e1, 2);
                }
                function mt(t1, e1) {
                    return _(t1.getUTCSeconds(), e1, 2);
                }
                function gt(t1) {
                    var e1 = t1.getUTCDay();
                    return 0 === e1 ? 7 : e1;
                }
                function yt(t1, e1) {
                    return _(n.Hl.count((0, l.A)(t1) - 1, t1), e1, 2);
                }
                function vt(t1, e1) {
                    var r = t1.getUTCDay();
                    return t1 = r >= 4 || 0 === r ? (0, n.pT)(t1) : n.pT.ceil(t1), _(n.pT.count((0, l.A)(t1), t1) + (4 === (0, l.A)(t1).getUTCDay()), e1, 2);
                }
                function xt(t1) {
                    return t1.getUTCDay();
                }
                function _t(t1, e1) {
                    return _(n.rt.count((0, l.A)(t1) - 1, t1), e1, 2);
                }
                function bt(t1, e1) {
                    return _(t1.getUTCFullYear() % 100, e1, 2);
                }
                function wt(t1, e1) {
                    return _(t1.getUTCFullYear() % 1e4, e1, 4);
                }
                function Tt() {
                    return "+0000";
                }
                function kt() {
                    return "%";
                }
                function At(t1) {
                    return +t1;
                }
                function Mt(t1) {
                    return Math.floor(+t1 / 1e3);
                }
                p = f({
                    dateTime: "%x, %X",
                    date: "%-m/%-d/%Y",
                    time: "%-I:%M:%S %p",
                    periods: [
                        "AM",
                        "PM"
                    ],
                    days: [
                        "Sunday",
                        "Monday",
                        "Tuesday",
                        "Wednesday",
                        "Thursday",
                        "Friday",
                        "Saturday"
                    ],
                    shortDays: [
                        "Sun",
                        "Mon",
                        "Tue",
                        "Wed",
                        "Thu",
                        "Fri",
                        "Sat"
                    ],
                    months: [
                        "January",
                        "February",
                        "March",
                        "April",
                        "May",
                        "June",
                        "July",
                        "August",
                        "September",
                        "October",
                        "November",
                        "December"
                    ],
                    shortMonths: [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec"
                    ]
                }), d = p.format, p.parse, m = p.utcFormat, p.utcParse;
            },
            47265: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    _: function() {
                        return o;
                    }
                });
                var n = r(53398), i = r(66291), a = (0, n.A)(function(t1) {
                    t1.setHours(0, 0, 0, 0);
                }, function(t1, e1) {
                    t1.setDate(t1.getDate() + e1);
                }, function(t1, e1) {
                    return (e1 - t1 - (e1.getTimezoneOffset() - t1.getTimezoneOffset()) * i.rR) / i.Nm;
                }, function(t1) {
                    return t1.getDate() - 1;
                });
                e1.A = a;
                var o = a.range;
            },
            66291: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    Fq: function() {
                        return s;
                    },
                    JJ: function() {
                        return a;
                    },
                    Nm: function() {
                        return o;
                    },
                    Tt: function() {
                        return n;
                    },
                    rR: function() {
                        return i;
                    }
                });
                var n = 1e3, i = 6e4, a = 36e5, o = 864e5, s = 6048e5;
            },
            50936: function(t1, e1, r) {
                "use strict";
                r.r(e1), r.d(e1, {
                    timeDay: function() {
                        return y.A;
                    },
                    timeDays: function() {
                        return y._;
                    },
                    timeFriday: function() {
                        return v.Sh;
                    },
                    timeFridays: function() {
                        return v.tz;
                    },
                    timeHour: function() {
                        return m;
                    },
                    timeHours: function() {
                        return g;
                    },
                    timeInterval: function() {
                        return n.A;
                    },
                    timeMillisecond: function() {
                        return a;
                    },
                    timeMilliseconds: function() {
                        return o;
                    },
                    timeMinute: function() {
                        return f;
                    },
                    timeMinutes: function() {
                        return p;
                    },
                    timeMonday: function() {
                        return v.By;
                    },
                    timeMondays: function() {
                        return v.KP;
                    },
                    timeMonth: function() {
                        return _;
                    },
                    timeMonths: function() {
                        return b;
                    },
                    timeSaturday: function() {
                        return v.kS;
                    },
                    timeSaturdays: function() {
                        return v.t$;
                    },
                    timeSecond: function() {
                        return c;
                    },
                    timeSeconds: function() {
                        return u;
                    },
                    timeSunday: function() {
                        return v.fz;
                    },
                    timeSundays: function() {
                        return v.se;
                    },
                    timeThursday: function() {
                        return v.dt;
                    },
                    timeThursdays: function() {
                        return v.Q$;
                    },
                    timeTuesday: function() {
                        return v.eQ;
                    },
                    timeTuesdays: function() {
                        return v.yW;
                    },
                    timeWednesday: function() {
                        return v.l3;
                    },
                    timeWednesdays: function() {
                        return v.gf;
                    },
                    timeWeek: function() {
                        return v.fz;
                    },
                    timeWeeks: function() {
                        return v.se;
                    },
                    timeYear: function() {
                        return w.A;
                    },
                    timeYears: function() {
                        return w.V;
                    },
                    utcDay: function() {
                        return C.A;
                    },
                    utcDays: function() {
                        return C.o;
                    },
                    utcFriday: function() {
                        return L.a1;
                    },
                    utcFridays: function() {
                        return L.Zn;
                    },
                    utcHour: function() {
                        return S;
                    },
                    utcHours: function() {
                        return E;
                    },
                    utcMillisecond: function() {
                        return a;
                    },
                    utcMilliseconds: function() {
                        return o;
                    },
                    utcMinute: function() {
                        return k;
                    },
                    utcMinutes: function() {
                        return A;
                    },
                    utcMonday: function() {
                        return L.rt;
                    },
                    utcMondays: function() {
                        return L.ON;
                    },
                    utcMonth: function() {
                        return P;
                    },
                    utcMonths: function() {
                        return z;
                    },
                    utcSaturday: function() {
                        return L.c8;
                    },
                    utcSaturdays: function() {
                        return L.Xo;
                    },
                    utcSecond: function() {
                        return c;
                    },
                    utcSeconds: function() {
                        return u;
                    },
                    utcSunday: function() {
                        return L.Hl;
                    },
                    utcSundays: function() {
                        return L.aZ;
                    },
                    utcThursday: function() {
                        return L.pT;
                    },
                    utcThursdays: function() {
                        return L.wr;
                    },
                    utcTuesday: function() {
                        return L.sr;
                    },
                    utcTuesdays: function() {
                        return L.jN;
                    },
                    utcWednesday: function() {
                        return L.z2;
                    },
                    utcWednesdays: function() {
                        return L.G6;
                    },
                    utcWeek: function() {
                        return L.Hl;
                    },
                    utcWeeks: function() {
                        return L.aZ;
                    },
                    utcYear: function() {
                        return O.A;
                    },
                    utcYears: function() {
                        return O.j;
                    }
                });
                var n = r(53398), i = (0, n.A)(function() {}, function(t1, e1) {
                    t1.setTime(+t1 + e1);
                }, function(t1, e1) {
                    return e1 - t1;
                });
                i.every = function(t1) {
                    return t1 = Math.floor(t1), isFinite(t1) && t1 > 0 ? t1 > 1 ? (0, n.A)(function(e1) {
                        e1.setTime(Math.floor(e1 / t1) * t1);
                    }, function(e1, r) {
                        e1.setTime(+e1 + r * t1);
                    }, function(e1, r) {
                        return (r - e1) / t1;
                    }) : i : null;
                };
                var a = i, o = i.range, s = r(66291), l = (0, n.A)(function(t1) {
                    t1.setTime(t1 - t1.getMilliseconds());
                }, function(t1, e1) {
                    t1.setTime(+t1 + e1 * s.Tt);
                }, function(t1, e1) {
                    return (e1 - t1) / s.Tt;
                }, function(t1) {
                    return t1.getUTCSeconds();
                }), c = l, u = l.range, h = (0, n.A)(function(t1) {
                    t1.setTime(t1 - t1.getMilliseconds() - t1.getSeconds() * s.Tt);
                }, function(t1, e1) {
                    t1.setTime(+t1 + e1 * s.rR);
                }, function(t1, e1) {
                    return (e1 - t1) / s.rR;
                }, function(t1) {
                    return t1.getMinutes();
                }), f = h, p = h.range, d = (0, n.A)(function(t1) {
                    t1.setTime(t1 - t1.getMilliseconds() - t1.getSeconds() * s.Tt - t1.getMinutes() * s.rR);
                }, function(t1, e1) {
                    t1.setTime(+t1 + e1 * s.JJ);
                }, function(t1, e1) {
                    return (e1 - t1) / s.JJ;
                }, function(t1) {
                    return t1.getHours();
                }), m = d, g = d.range, y = r(47265), v = r(55735), x = (0, n.A)(function(t1) {
                    t1.setDate(1), t1.setHours(0, 0, 0, 0);
                }, function(t1, e1) {
                    t1.setMonth(t1.getMonth() + e1);
                }, function(t1, e1) {
                    return e1.getMonth() - t1.getMonth() + 12 * (e1.getFullYear() - t1.getFullYear());
                }, function(t1) {
                    return t1.getMonth();
                }), _ = x, b = x.range, w = r(9830), T = (0, n.A)(function(t1) {
                    t1.setUTCSeconds(0, 0);
                }, function(t1, e1) {
                    t1.setTime(+t1 + e1 * s.rR);
                }, function(t1, e1) {
                    return (e1 - t1) / s.rR;
                }, function(t1) {
                    return t1.getUTCMinutes();
                }), k = T, A = T.range, M = (0, n.A)(function(t1) {
                    t1.setUTCMinutes(0, 0, 0);
                }, function(t1, e1) {
                    t1.setTime(+t1 + e1 * s.JJ);
                }, function(t1, e1) {
                    return (e1 - t1) / s.JJ;
                }, function(t1) {
                    return t1.getUTCHours();
                }), S = M, E = M.range, C = r(72543), L = r(1681), I = (0, n.A)(function(t1) {
                    t1.setUTCDate(1), t1.setUTCHours(0, 0, 0, 0);
                }, function(t1, e1) {
                    t1.setUTCMonth(t1.getUTCMonth() + e1);
                }, function(t1, e1) {
                    return e1.getUTCMonth() - t1.getUTCMonth() + 12 * (e1.getUTCFullYear() - t1.getUTCFullYear());
                }, function(t1) {
                    return t1.getUTCMonth();
                }), P = I, z = I.range, O = r(59764);
            },
            53398: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    A: function() {
                        return a;
                    }
                });
                var n = new Date, i = new Date;
                function a(t1, e1, r, o) {
                    function s(e1) {
                        return t1(e1 = 0 === arguments.length ? new Date : new Date(+e1)), e1;
                    }
                    return s.floor = function(e1) {
                        return t1(e1 = new Date(+e1)), e1;
                    }, s.ceil = function(r) {
                        return t1(r = new Date(r - 1)), e1(r, 1), t1(r), r;
                    }, s.round = function(t1) {
                        var e1 = s(t1), r = s.ceil(t1);
                        return t1 - e1 < r - t1 ? e1 : r;
                    }, s.offset = function(t1, r) {
                        return e1(t1 = new Date(+t1), null == r ? 1 : Math.floor(r)), t1;
                    }, s.range = function(r, n, i) {
                        var a, o = [];
                        if (r = s.ceil(r), i = null == i ? 1 : Math.floor(i), !(r < n && i > 0)) return o;
                        do o.push(a = new Date(+r)), e1(r, i), t1(r);
                        while (a < r && r < n);
                        return o;
                    }, s.filter = function(r) {
                        return a(function(e1) {
                            if (e1 >= e1) for(; t1(e1), !r(e1);)e1.setTime(e1 - 1);
                        }, function(t1, n) {
                            if (t1 >= t1) {
                                if (n < 0) for(; ++n <= 0;)for(; e1(t1, -1), !r(t1););
                                else for(; --n >= 0;)for(; e1(t1, 1), !r(t1););
                            }
                        });
                    }, r && (s.count = function(e1, a) {
                        return n.setTime(+e1), i.setTime(+a), t1(n), t1(i), Math.floor(r(n, i));
                    }, s.every = function(t1) {
                        return t1 = Math.floor(t1), isFinite(t1) && t1 > 0 ? t1 > 1 ? s.filter(o ? function(e1) {
                            return o(e1) % t1 == 0;
                        } : function(e1) {
                            return s.count(0, e1) % t1 == 0;
                        }) : s : null;
                    }), s;
                }
            },
            72543: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    o: function() {
                        return o;
                    }
                });
                var n = r(53398), i = r(66291), a = (0, n.A)(function(t1) {
                    t1.setUTCHours(0, 0, 0, 0);
                }, function(t1, e1) {
                    t1.setUTCDate(t1.getUTCDate() + e1);
                }, function(t1, e1) {
                    return (e1 - t1) / i.Nm;
                }, function(t1) {
                    return t1.getUTCDate() - 1;
                });
                e1.A = a;
                var o = a.range;
            },
            1681: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    G6: function() {
                        return g;
                    },
                    Hl: function() {
                        return o;
                    },
                    ON: function() {
                        return d;
                    },
                    Xo: function() {
                        return x;
                    },
                    Zn: function() {
                        return v;
                    },
                    a1: function() {
                        return h;
                    },
                    aZ: function() {
                        return p;
                    },
                    c8: function() {
                        return f;
                    },
                    jN: function() {
                        return m;
                    },
                    pT: function() {
                        return u;
                    },
                    rt: function() {
                        return s;
                    },
                    sr: function() {
                        return l;
                    },
                    wr: function() {
                        return y;
                    },
                    z2: function() {
                        return c;
                    }
                });
                var n = r(53398), i = r(66291);
                function a(t1) {
                    return (0, n.A)(function(e1) {
                        e1.setUTCDate(e1.getUTCDate() - (e1.getUTCDay() + 7 - t1) % 7), e1.setUTCHours(0, 0, 0, 0);
                    }, function(t1, e1) {
                        t1.setUTCDate(t1.getUTCDate() + 7 * e1);
                    }, function(t1, e1) {
                        return (e1 - t1) / i.Fq;
                    });
                }
                var o = a(0), s = a(1), l = a(2), c = a(3), u = a(4), h = a(5), f = a(6), p = o.range, d = s.range, m = l.range, g = c.range, y = u.range, v = h.range, x = f.range;
            },
            59764: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    j: function() {
                        return a;
                    }
                });
                var n = r(53398), i = (0, n.A)(function(t1) {
                    t1.setUTCMonth(0, 1), t1.setUTCHours(0, 0, 0, 0);
                }, function(t1, e1) {
                    t1.setUTCFullYear(t1.getUTCFullYear() + e1);
                }, function(t1, e1) {
                    return e1.getUTCFullYear() - t1.getUTCFullYear();
                }, function(t1) {
                    return t1.getUTCFullYear();
                });
                i.every = function(t1) {
                    return isFinite(t1 = Math.floor(t1)) && t1 > 0 ? (0, n.A)(function(e1) {
                        e1.setUTCFullYear(Math.floor(e1.getUTCFullYear() / t1) * t1), e1.setUTCMonth(0, 1), e1.setUTCHours(0, 0, 0, 0);
                    }, function(e1, r) {
                        e1.setUTCFullYear(e1.getUTCFullYear() + r * t1);
                    }) : null;
                }, e1.A = i;
                var a = i.range;
            },
            55735: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    By: function() {
                        return s;
                    },
                    KP: function() {
                        return d;
                    },
                    Q$: function() {
                        return y;
                    },
                    Sh: function() {
                        return h;
                    },
                    dt: function() {
                        return u;
                    },
                    eQ: function() {
                        return l;
                    },
                    fz: function() {
                        return o;
                    },
                    gf: function() {
                        return g;
                    },
                    kS: function() {
                        return f;
                    },
                    l3: function() {
                        return c;
                    },
                    se: function() {
                        return p;
                    },
                    t$: function() {
                        return x;
                    },
                    tz: function() {
                        return v;
                    },
                    yW: function() {
                        return m;
                    }
                });
                var n = r(53398), i = r(66291);
                function a(t1) {
                    return (0, n.A)(function(e1) {
                        e1.setDate(e1.getDate() - (e1.getDay() + 7 - t1) % 7), e1.setHours(0, 0, 0, 0);
                    }, function(t1, e1) {
                        t1.setDate(t1.getDate() + 7 * e1);
                    }, function(t1, e1) {
                        return (e1 - t1 - (e1.getTimezoneOffset() - t1.getTimezoneOffset()) * i.rR) / i.Fq;
                    });
                }
                var o = a(0), s = a(1), l = a(2), c = a(3), u = a(4), h = a(5), f = a(6), p = o.range, d = s.range, m = l.range, g = c.range, y = u.range, v = h.range, x = f.range;
            },
            9830: function(t1, e1, r) {
                "use strict";
                r.d(e1, {
                    V: function() {
                        return a;
                    }
                });
                var n = r(53398), i = (0, n.A)(function(t1) {
                    t1.setMonth(0, 1), t1.setHours(0, 0, 0, 0);
                }, function(t1, e1) {
                    t1.setFullYear(t1.getFullYear() + e1);
                }, function(t1, e1) {
                    return e1.getFullYear() - t1.getFullYear();
                }, function(t1) {
                    return t1.getFullYear();
                });
                i.every = function(t1) {
                    return isFinite(t1 = Math.floor(t1)) && t1 > 0 ? (0, n.A)(function(e1) {
                        e1.setFullYear(Math.floor(e1.getFullYear() / t1) * t1), e1.setMonth(0, 1), e1.setHours(0, 0, 0, 0);
                    }, function(e1, r) {
                        e1.setFullYear(e1.getFullYear() + r * t1);
                    }) : null;
                }, e1.A = i;
                var a = i.range;
            },
            70973: function(t1, e1, r) {
                "use strict";
                var n = r(40891), i = r(98800), a = r(48631), o = r(52991);
                t1.exports = function(t1, e1, r) {
                    if (!t1 || "object" != typeof t1 && "function" != typeof t1) throw new a("`obj` must be an object or a function`");
                    if ("string" != typeof e1 && "symbol" != typeof e1) throw new a("`property` must be a string or a symbol`");
                    if (arguments.length > 3 && "boolean" != typeof arguments[3] && null !== arguments[3]) throw new a("`nonEnumerable`, if provided, must be a boolean or null");
                    if (arguments.length > 4 && "boolean" != typeof arguments[4] && null !== arguments[4]) throw new a("`nonWritable`, if provided, must be a boolean or null");
                    if (arguments.length > 5 && "boolean" != typeof arguments[5] && null !== arguments[5]) throw new a("`nonConfigurable`, if provided, must be a boolean or null");
                    if (arguments.length > 6 && "boolean" != typeof arguments[6]) throw new a("`loose`, if provided, must be a boolean");
                    var s = arguments.length > 3 ? arguments[3] : null, l = arguments.length > 4 ? arguments[4] : null, c = arguments.length > 5 ? arguments[5] : null, u = arguments.length > 6 && arguments[6], h = !!o && o(t1, e1);
                    if (n) n(t1, e1, {
                        configurable: null === c && h ? h.configurable : !c,
                        enumerable: null === s && h ? h.enumerable : !s,
                        value: r,
                        writable: null === l && h ? h.writable : !l
                    });
                    else {
                        if (!u && (s || l || c)) throw new i("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
                        t1[e1] = r;
                    }
                };
            },
            97936: function(t1, e1, r) {
                "use strict";
                var n = r(99433), i = "function" == typeof Symbol && "symbol" == typeof Symbol("foo"), a = Object.prototype.toString, o = Array.prototype.concat, s = Object.defineProperty, l = r(74268)(), c = s && l, u = function(t1, e1, r, n) {
                    if (e1 in t1) {
                        if (!0 === n) {
                            if (t1[e1] === r) return;
                        } else if ("function" != typeof (i = n) || "[object Function]" !== a.call(i) || !n()) return;
                    }
                    var i;
                    c ? s(t1, e1, {
                        configurable: !0,
                        enumerable: !1,
                        value: r,
                        writable: !0
                    }) : t1[e1] = r;
                }, h = function(t1, e1) {
                    var r = arguments.length > 2 ? arguments[2] : {}, a = n(e1);
                    i && (a = o.call(a, Object.getOwnPropertySymbols(e1)));
                    for(var s = 0; s < a.length; s += 1)u(t1, a[s], e1[a[s]], r[a[s]]);
                };
                h.supportsDescriptors = !!c, t1.exports = h;
            },
            68650: function(t1) {
                t1.exports = function() {
                    for(var t1 = 0; t1 < arguments.length; t1++)if (void 0 !== arguments[t1]) return arguments[t1];
                };
            },
            44431: function(t1) {
                "use strict";
                t1.exports = n;
                var e1 = (n.canvas = document.createElement("canvas")).getContext("2d"), r = i([
                    32,
                    126
                ]);
                function n(t1, n) {
                    Array.isArray(t1) && (t1 = t1.join(", "));
                    var a, o = {}, s = 16, l = .05;
                    n && (2 === n.length && "number" == typeof n[0] ? a = i(n) : Array.isArray(n) ? a = n : (n.o ? a = i(n.o) : n.pairs && (a = n.pairs), n.fontSize && (s = n.fontSize), null != n.threshold && (l = n.threshold))), a || (a = r), e1.font = s + "px " + t1;
                    for(var c = 0; c < a.length; c++){
                        var u = a[c], h = e1.measureText(u[0]).width + e1.measureText(u[1]).width, f = e1.measureText(u).width;
                        if (Math.abs(h - f) > s * l) {
                            var p = (f - h) / s;
                            o[u] = 1e3 * p;
                        }
                    }
                    return o;
                }
                function i(t1) {
                    for(var e1 = [], r = t1[0]; r <= t1[1]; r++)for(var n = String.fromCharCode(r), i = t1[0]; i < t1[1]; i++){
                        var a = n + String.fromCharCode(i);
                        e1.push(a);
                    }
                    return e1;
                }
                n.createPairs = i, n.ascii = r;
            },
            95620: function(t1, e1, r) {
                var n = r(16844), i = r(60265), a = {
                    M: "moveTo",
                    C: "bezierCurveTo"
                };
                t1.exports = function(t1, e1) {
                    t1.beginPath(), i(n(e1)).forEach(function(e1) {
                        var r = e1[0], n = e1.slice(1);
                        t1[a[r]].apply(t1, n);
                    }), t1.closePath();
                };
            },
            10275: function(t1) {
                t1.exports = function(t1) {
                    switch(t1){
                        case "int8":
                            return Int8Array;
                        case "int16":
                            return Int16Array;
                        case "int32":
                            return Int32Array;
                        case "uint8":
                            return Uint8Array;
                        case "uint16":
                            return Uint16Array;
                        case "uint32":
                            return Uint32Array;
                        case "float32":
                            return Float32Array;
                        case "float64":
                            return Float64Array;
                        case "array":
                            return Array;
                        case "uint8_clamped":
                            return Uint8ClampedArray;
                    }
                };
            },
            49523: function(t1) {
                "use strict";
                function e1(t1, r, n) {
                    var i = 0 | t1[n];
                    if (i <= 0) return [];
                    var a, o = new Array(i);
                    if (n === t1.length - 1) for(a = 0; a < i; ++a)o[a] = r;
                    else for(a = 0; a < i; ++a)o[a] = e1(t1, r, n + 1);
                    return o;
                }
                t1.exports = function(t1, r) {
                    switch(void 0 === r && (r = 0), typeof t1){
                        case "number":
                            if (t1 > 0) return function(t1, e1) {
                                var r, n;
                                for(r = new Array(t1), n = 0; n < t1; ++n)r[n] = e1;
                                return r;
                            }(0 | t1, r);
                            break;
                        case "object":
                            if ("number" == typeof t1.length) return e1(t1, r, 0);
                    }
                    return [];
                };
            },
            25782: function(t1) {
                "use strict";
                function e1(t1, e1, n) {
                    n = n || 2;
                    var a, o, s, l, h, f, d, m = e1 && e1.length, g = m ? e1[0] * n : t1.length, y = r(t1, 0, g, n, !0), v = [];
                    if (!y || y.next === y.prev) return v;
                    if (m && (y = function(t1, e1, n, i) {
                        var a, o, s, l = [];
                        for(a = 0, o = e1.length; a < o; a++)(s = r(t1, e1[a] * i, a < o - 1 ? e1[a + 1] * i : t1.length, i, !1)) === s.next && (s.steiner = !0), l.push(p(s));
                        for(l.sort(c), a = 0; a < l.length; a++)n = u(l[a], n);
                        return n;
                    }(t1, e1, y, n)), t1.length > 80 * n) {
                        a = s = t1[0], o = l = t1[1];
                        for(var x = n; x < g; x += n)(h = t1[x]) < a && (a = h), (f = t1[x + 1]) < o && (o = f), h > s && (s = h), f > l && (l = f);
                        d = 0 !== (d = Math.max(s - a, l - o)) ? 32767 / d : 0;
                    }
                    return i(y, v, n, a, o, d, 0), v;
                }
                function r(t1, e1, r, n, i) {
                    var a, o;
                    if (i === M(t1, e1, r, n) > 0) for(a = e1; a < r; a += n)o = T(a, t1[a], t1[a + 1], o);
                    else for(a = r - n; a >= e1; a -= n)o = T(a, t1[a], t1[a + 1], o);
                    return o && y(o, o.next) && (k(o), o = o.next), o;
                }
                function n(t1, e1) {
                    if (!t1) return t1;
                    e1 || (e1 = t1);
                    var r, n = t1;
                    do if (r = !1, n.steiner || !y(n, n.next) && 0 !== g(n.prev, n, n.next)) n = n.next;
                    else {
                        if (k(n), (n = e1 = n.prev) === n.next) break;
                        r = !0;
                    }
                    while (r || n !== e1);
                    return e1;
                }
                function i(t1, e1, r, c, u, h, p) {
                    if (t1) {
                        !p && h && function(t1, e1, r, n) {
                            var i = t1;
                            do 0 === i.z && (i.z = f(i.x, i.y, e1, r, n)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
                            while (i !== t1);
                            i.prevZ.nextZ = null, i.prevZ = null, function(t1) {
                                var e1, r, n, i, a, o, s, l, c = 1;
                                do {
                                    for(r = t1, t1 = null, a = null, o = 0; r;){
                                        for(o++, n = r, s = 0, e1 = 0; e1 < c && (s++, n = n.nextZ); e1++);
                                        for(l = c; s > 0 || l > 0 && n;)0 !== s && (0 === l || !n || r.z <= n.z) ? (i = r, r = r.nextZ, s--) : (i = n, n = n.nextZ, l--), a ? a.nextZ = i : t1 = i, i.prevZ = a, a = i;
                                        r = n;
                                    }
                                    a.nextZ = null, c *= 2;
                                }while (o > 1);
                            }(i);
                        }(t1, c, u, h);
                        for(var d, m, g = t1; t1.prev !== t1.next;)if (d = t1.prev, m = t1.next, h ? o(t1, c, u, h) : a(t1)) e1.push(d.i / r | 0), e1.push(t1.i / r | 0), e1.push(m.i / r | 0), k(t1), t1 = m.next, g = m.next;
                        else if ((t1 = m) === g) {
                            p ? 1 === p ? i(t1 = s(n(t1), e1, r), e1, r, c, u, h, 2) : 2 === p && l(t1, e1, r, c, u, h) : i(n(t1), e1, r, c, u, h, 1);
                            break;
                        }
                    }
                }
                function a(t1) {
                    var e1 = t1.prev, r = t1, n = t1.next;
                    if (g(e1, r, n) >= 0) return !1;
                    for(var i = e1.x, a = r.x, o = n.x, s = e1.y, l = r.y, c = n.y, u = i < a ? i < o ? i : o : a < o ? a : o, h = s < l ? s < c ? s : c : l < c ? l : c, f = i > a ? i > o ? i : o : a > o ? a : o, p = s > l ? s > c ? s : c : l > c ? l : c, m = n.next; m !== e1;){
                        if (m.x >= u && m.x <= f && m.y >= h && m.y <= p && d(i, s, a, l, o, c, m.x, m.y) && g(m.prev, m, m.next) >= 0) return !1;
                        m = m.next;
                    }
                    return !0;
                }
                function o(t1, e1, r, n) {
                    var i = t1.prev, a = t1, o = t1.next;
                    if (g(i, a, o) >= 0) return !1;
                    for(var s = i.x, l = a.x, c = o.x, u = i.y, h = a.y, p = o.y, m = s < l ? s < c ? s : c : l < c ? l : c, y = u < h ? u < p ? u : p : h < p ? h : p, v = s > l ? s > c ? s : c : l > c ? l : c, x = u > h ? u > p ? u : p : h > p ? h : p, _ = f(m, y, e1, r, n), b = f(v, x, e1, r, n), w = t1.prevZ, T = t1.nextZ; w && w.z >= _ && T && T.z <= b;){
                        if (w.x >= m && w.x <= v && w.y >= y && w.y <= x && w !== i && w !== o && d(s, u, l, h, c, p, w.x, w.y) && g(w.prev, w, w.next) >= 0) return !1;
                        if (w = w.prevZ, T.x >= m && T.x <= v && T.y >= y && T.y <= x && T !== i && T !== o && d(s, u, l, h, c, p, T.x, T.y) && g(T.prev, T, T.next) >= 0) return !1;
                        T = T.nextZ;
                    }
                    for(; w && w.z >= _;){
                        if (w.x >= m && w.x <= v && w.y >= y && w.y <= x && w !== i && w !== o && d(s, u, l, h, c, p, w.x, w.y) && g(w.prev, w, w.next) >= 0) return !1;
                        w = w.prevZ;
                    }
                    for(; T && T.z <= b;){
                        if (T.x >= m && T.x <= v && T.y >= y && T.y <= x && T !== i && T !== o && d(s, u, l, h, c, p, T.x, T.y) && g(T.prev, T, T.next) >= 0) return !1;
                        T = T.nextZ;
                    }
                    return !0;
                }
                function s(t1, e1, r) {
                    var i = t1;
                    do {
                        var a = i.prev, o = i.next.next;
                        !y(a, o) && v(a, i, i.next, o) && b(a, o) && b(o, a) && (e1.push(a.i / r | 0), e1.push(i.i / r | 0), e1.push(o.i / r | 0), k(i), k(i.next), i = t1 = o), i = i.next;
                    }while (i !== t1);
                    return n(i);
                }
                function l(t1, e1, r, a, o, s) {
                    var l = t1;
                    do {
                        for(var c = l.next.next; c !== l.prev;){
                            if (l.i !== c.i && m(l, c)) {
                                var u = w(l, c);
                                return l = n(l, l.next), u = n(u, u.next), i(l, e1, r, a, o, s, 0), void i(u, e1, r, a, o, s, 0);
                            }
                            c = c.next;
                        }
                        l = l.next;
                    }while (l !== t1);
                }
                function c(t1, e1) {
                    return t1.x - e1.x;
                }
                function u(t1, e1) {
                    var r = function(t1, e1) {
                        var r, n = e1, i = t1.x, a = t1.y, o = -1 / 0;
                        do {
                            if (a <= n.y && a >= n.next.y && n.next.y !== n.y) {
                                var s = n.x + (a - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
                                if (s <= i && s > o && (o = s, r = n.x < n.next.x ? n : n.next, s === i)) return r;
                            }
                            n = n.next;
                        }while (n !== e1);
                        if (!r) return null;
                        var l, c = r, u = r.x, f = r.y, p = 1 / 0;
                        n = r;
                        do i >= n.x && n.x >= u && i !== n.x && d(a < f ? i : o, a, u, f, a < f ? o : i, a, n.x, n.y) && (l = Math.abs(a - n.y) / (i - n.x), b(n, t1) && (l < p || l === p && (n.x > r.x || n.x === r.x && h(r, n))) && (r = n, p = l)), n = n.next;
                        while (n !== c);
                        return r;
                    }(t1, e1);
                    if (!r) return e1;
                    var i = w(r, t1);
                    return n(i, i.next), n(r, r.next);
                }
                function h(t1, e1) {
                    return g(t1.prev, t1, e1.prev) < 0 && g(e1.next, t1, t1.next) < 0;
                }
                function f(t1, e1, r, n, i) {
                    return (t1 = 1431655765 & ((t1 = 858993459 & ((t1 = 252645135 & ((t1 = 16711935 & ((t1 = (t1 - r) * i | 0) | t1 << 8)) | t1 << 4)) | t1 << 2)) | t1 << 1)) | (e1 = 1431655765 & ((e1 = 858993459 & ((e1 = 252645135 & ((e1 = 16711935 & ((e1 = (e1 - n) * i | 0) | e1 << 8)) | e1 << 4)) | e1 << 2)) | e1 << 1)) << 1;
                }
                function p(t1) {
                    var e1 = t1, r = t1;
                    do (e1.x < r.x || e1.x === r.x && e1.y < r.y) && (r = e1), e1 = e1.next;
                    while (e1 !== t1);
                    return r;
                }
                function d(t1, e1, r, n, i, a, o, s) {
                    return (i - o) * (e1 - s) >= (t1 - o) * (a - s) && (t1 - o) * (n - s) >= (r - o) * (e1 - s) && (r - o) * (a - s) >= (i - o) * (n - s);
                }
                function m(t1, e1) {
                    return t1.next.i !== e1.i && t1.prev.i !== e1.i && !function(t1, e1) {
                        var r = t1;
                        do {
                            if (r.i !== t1.i && r.next.i !== t1.i && r.i !== e1.i && r.next.i !== e1.i && v(r, r.next, t1, e1)) return !0;
                            r = r.next;
                        }while (r !== t1);
                        return !1;
                    }(t1, e1) && (b(t1, e1) && b(e1, t1) && function(t1, e1) {
                        var r = t1, n = !1, i = (t1.x + e1.x) / 2, a = (t1.y + e1.y) / 2;
                        do r.y > a != r.next.y > a && r.next.y !== r.y && i < (r.next.x - r.x) * (a - r.y) / (r.next.y - r.y) + r.x && (n = !n), r = r.next;
                        while (r !== t1);
                        return n;
                    }(t1, e1) && (g(t1.prev, t1, e1.prev) || g(t1, e1.prev, e1)) || y(t1, e1) && g(t1.prev, t1, t1.next) > 0 && g(e1.prev, e1, e1.next) > 0);
                }
                function g(t1, e1, r) {
                    return (e1.y - t1.y) * (r.x - e1.x) - (e1.x - t1.x) * (r.y - e1.y);
                }
                function y(t1, e1) {
                    return t1.x === e1.x && t1.y === e1.y;
                }
                function v(t1, e1, r, n) {
                    var i = _(g(t1, e1, r)), a = _(g(t1, e1, n)), o = _(g(r, n, t1)), s = _(g(r, n, e1));
                    return i !== a && o !== s || !(0 !== i || !x(t1, r, e1)) || !(0 !== a || !x(t1, n, e1)) || !(0 !== o || !x(r, t1, n)) || !(0 !== s || !x(r, e1, n));
                }
                function x(t1, e1, r) {
                    return e1.x <= Math.max(t1.x, r.x) && e1.x >= Math.min(t1.x, r.x) && e1.y <= Math.max(t1.y, r.y) && e1.y >= Math.min(t1.y, r.y);
                }
                function _(t1) {
                    return t1 > 0 ? 1 : t1 < 0 ? -1 : 0;
                }
                function b(t1, e1) {
                    return g(t1.prev, t1, t1.next) < 0 ? g(t1, e1, t1.next) >= 0 && g(t1, t1.prev, e1) >= 0 : g(t1, e1, t1.prev) < 0 || g(t1, t1.next, e1) < 0;
                }
                function w(t1, e1) {
                    var r = new A(t1.i, t1.x, t1.y), n = new A(e1.i, e1.x, e1.y), i = t1.next, a = e1.prev;
                    return t1.next = e1, e1.prev = t1, r.next = i, i.prev = r, n.next = r, r.prev = n, a.next = n, n.prev = a, n;
                }
                function T(t1, e1, r, n) {
                    var i = new A(t1, e1, r);
                    return n ? (i.next = n.next, i.prev = n, n.next.prev = i, n.next = i) : (i.prev = i, i.next = i), i;
                }
                function k(t1) {
                    t1.next.prev = t1.prev, t1.prev.next = t1.next, t1.prevZ && (t1.prevZ.nextZ = t1.nextZ), t1.nextZ && (t1.nextZ.prevZ = t1.prevZ);
                }
                function A(t1, e1, r) {
                    this.i = t1, this.x = e1, this.y = r, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
                }
                function M(t1, e1, r, n) {
                    for(var i = 0, a = e1, o = r - n; a < r; a += n)i += (t1[o] - t1[a]) * (t1[a + 1] + t1[o + 1]), o = a;
                    return i;
                }
                t1.exports = e1, t1.exports.default = e1, e1.deviation = function(t1, e1, r, n) {
                    var i = e1 && e1.length, a = i ? e1[0] * r : t1.length, o = Math.abs(M(t1, 0, a, r));
                    if (i) for(var s = 0, l = e1.length; s < l; s++){
                        var c = e1[s] * r, u = s < l - 1 ? e1[s + 1] * r : t1.length;
                        o -= Math.abs(M(t1, c, u, r));
                    }
                    var h = 0;
                    for(s = 0; s < n.length; s += 3){
                        var f = n[s] * r, p = n[s + 1] * r, d = n[s + 2] * r;
                        h += Math.abs((t1[f] - t1[d]) * (t1[p + 1] - t1[f + 1]) - (t1[f] - t1[p]) * (t1[d + 1] - t1[f + 1]));
                    }
                    return 0 === o && 0 === h ? 0 : Math.abs((h - o) / o);
                }, e1.flatten = function(t1) {
                    for(var e1 = t1[0][0].length, r = {
                        vertices: [],
                        holes: [],
                        dimensions: e1
                    }, n = 0, i = 0; i < t1.length; i++){
                        for(var a = 0; a < t1[i].length; a++)for(var o = 0; o < e1; o++)r.vertices.push(t1[i][a][o]);
                        i > 0 && (n += t1[i - 1].length, r.holes.push(n));
                    }
                    return r;
                };
            },
            96143: function(t1, e1, r) {
                var n = r(26381);
                t1.exports = function(t1, e1) {
                    var r, i = [], a = [], o = [], s = {}, l = [];
                    function c(t1) {
                        o[t1] = !1, s.hasOwnProperty(t1) && Object.keys(s[t1]).forEach(function(e1) {
                            delete s[t1][e1], o[e1] && c(e1);
                        });
                    }
                    function u(t1) {
                        var e1, n, i = !1;
                        for(a.push(t1), o[t1] = !0, e1 = 0; e1 < l[t1].length; e1++)(n = l[t1][e1]) === r ? (h(r, a), i = !0) : o[n] || (i = u(n));
                        if (i) c(t1);
                        else for(e1 = 0; e1 < l[t1].length; e1++){
                            n = l[t1][e1];
                            var f = s[n];
                            f || (f = {}, s[n] = f), f[n] = !0;
                        }
                        return a.pop(), i;
                    }
                    function h(t1, r) {
                        var n = [].concat(r).concat(t1);
                        e1 ? e1(u) : i.push(n);
                    }
                    function f(e1) {
                        !function(e1) {
                            for(var r = 0; r < t1.length; r++)r < e1 && (t1[r] = []), t1[r] = t1[r].filter(function(t1) {
                                return t1 >= e1;
                            });
                        }(e1);
                        for(var r, i = n(t1).components.filter(function(t1) {
                            return t1.length > 1;
                        }), a = 1 / 0, o = 0; o < i.length; o++)for(var s = 0; s < i[o].length; s++)i[o][s] < a && (a = i[o][s], r = o);
                        var l = i[r];
                        if (!l) return !1;
                        var c = t1.map(function(t1, e1) {
                            return -1 === l.indexOf(e1) ? [] : t1.filter(function(t1) {
                                return -1 !== l.indexOf(t1);
                            });
                        });
                        return {
                            leastVertex: a,
                            adjList: c
                        };
                    }
                    r = 0;
                    for(var p = t1.length; r < p;){
                        var d = f(r);
                        if (r = d.leastVertex, l = d.adjList) {
                            for(var m = 0; m < l.length; m++)for(var g = 0; g < l[m].length; g++){
                                var y = l[m][g];
                                o[+y] = !1, s[y] = {};
                            }
                            u(r), r += 1;
                        } else r = p;
                    }
                    return e1 ? void 0 : i;
                };
            },
            40891: function(t1, e1, r) {
                "use strict";
                var n = r(71129)("%Object.defineProperty%", !0) || !1;
                if (n) try {
                    n({}, "a", {
                        value: 1
                    });
                } catch (t1) {
                    n = !1;
                }
                t1.exports = n;
            },
            35465: function(t1) {
                "use strict";
                t1.exports = EvalError;
            },
            77731: function(t1) {
                "use strict";
                t1.exports = Error;
            },
            30582: function(t1) {
                "use strict";
                t1.exports = RangeError;
            },
            50294: function(t1) {
                "use strict";
                t1.exports = ReferenceError;
            },
            98800: function(t1) {
                "use strict";
                t1.exports = SyntaxError;
            },
            48631: function(t1) {
                "use strict";
                t1.exports = TypeError;
            },
            33149: function(t1) {
                "use strict";
                t1.exports = URIError;
            },
            91445: function(t1, e1, r) {
                "use strict";
                var n = r(69746);
                t1.exports = function() {
                    return n(this).length = 0, this;
                };
            },
            82377: function(t1, e1, r) {
                "use strict";
                t1.exports = r(57712)() ? Array.from : r(33468);
            },
            57712: function(t1) {
                "use strict";
                t1.exports = function() {
                    var t1, e1, r = Array.from;
                    return "function" == typeof r && (e1 = r(t1 = [
                        "raz",
                        "dwa"
                    ]), Boolean(e1 && e1 !== t1 && "dwa" === e1[1]));
                };
            },
            33468: function(t1, e1, r) {
                "use strict";
                var n = r(63008).iterator, i = r(82262), a = r(59356), o = r(54653), s = r(52359), l = r(69746), c = r(1974), u = r(48488), h = Array.isArray, f = Function.prototype.call, p = {
                    configurable: !0,
                    enumerable: !0,
                    writable: !0,
                    value: null
                }, d = Object.defineProperty;
                t1.exports = function(t1) {
                    var e1, r, m, g, y, v, x, _, b, w, T = arguments[1], k = arguments[2];
                    if (t1 = Object(l(t1)), c(T) && s(T), this && this !== Array && a(this)) e1 = this;
                    else {
                        if (!T) {
                            if (i(t1)) return 1 !== (y = t1.length) ? Array.apply(null, t1) : ((g = new Array(1))[0] = t1[0], g);
                            if (h(t1)) {
                                for(g = new Array(y = t1.length), r = 0; r < y; ++r)g[r] = t1[r];
                                return g;
                            }
                        }
                        g = [];
                    }
                    if (!h(t1)) {
                        if (void 0 !== (b = t1[n])) {
                            for(x = s(b).call(t1), e1 && (g = new e1), _ = x.next(), r = 0; !_.done;)w = T ? f.call(T, k, _.value, r) : _.value, e1 ? (p.value = w, d(g, r, p)) : g[r] = w, _ = x.next(), ++r;
                            y = r;
                        } else if (u(t1)) {
                            for(y = t1.length, e1 && (g = new e1), r = 0, m = 0; r < y; ++r)w = t1[r], r + 1 < y && (v = w.charCodeAt(0)) >= 55296 && v <= 56319 && (w += t1[++r]), w = T ? f.call(T, k, w, m) : w, e1 ? (p.value = w, d(g, m, p)) : g[m] = w, ++m;
                            y = m;
                        }
                    }
                    if (void 0 === y) for(y = o(t1.length), e1 && (g = new e1(y)), r = 0; r < y; ++r)w = T ? f.call(T, k, t1[r], r) : t1[r], e1 ? (p.value = w, d(g, r, p)) : g[r] = w;
                    return e1 && (p.value = null, g.length = y), g;
                };
            },
            82262: function(t1) {
                "use strict";
                var e1 = Object.prototype.toString, r = e1.call(function() {
                    return arguments;
                }());
                t1.exports = function(t1) {
                    return e1.call(t1) === r;
                };
            },
            59356: function(t1) {
                "use strict";
                var e1 = Object.prototype.toString, r = RegExp.prototype.test.bind(/^[object [A-Za-z0-9]*Function]$/);
                t1.exports = function(t1) {
                    return "function" == typeof t1 && r(e1.call(t1));
                };
            },
            62039: function(t1) {
                "use strict";
                t1.exports = function() {};
            },
            53579: function(t1, e1, r) {
                "use strict";
                t1.exports = r(67394)() ? Math.sign : r(37122);
            },
            67394: function(t1) {
                "use strict";
                t1.exports = function() {
                    var t1 = Math.sign;
                    return "function" == typeof t1 && 1 === t1(10) && -1 === t1(-20);
                };
            },
            37122: function(t1) {
                "use strict";
                t1.exports = function(t1) {
                    return t1 = Number(t1), isNaN(t1) || 0 === t1 ? t1 : t1 > 0 ? 1 : -1;
                };
            },
            10226: function(t1, e1, r) {
                "use strict";
                var n = r(53579), i = Math.abs, a = Math.floor;
                t1.exports = function(t1) {
                    return isNaN(t1) ? 0 : 0 !== (t1 = Number(t1)) && isFinite(t1) ? n(t1) * a(i(t1)) : t1;
                };
            },
            54653: function(t1, e1, r) {
                "use strict";
                var n = r(10226), i = Math.max;
                t1.exports = function(t1) {
                    return i(0, n(t1));
                };
            },
            39395: function(t1, e1, r) {
                "use strict";
                var n = r(52359), i = r(69746), a = Function.prototype.bind, o = Function.prototype.call, s = Object.keys, l = Object.prototype.propertyIsEnumerable;
                t1.exports = function(t1, e1) {
                    return function(r, c) {
                        var u, h = arguments[2], f = arguments[3];
                        return r = Object(i(r)), n(c), u = s(r), f && u.sort("function" == typeof f ? a.call(f, r) : void 0), "function" != typeof t1 && (t1 = u[t1]), o.call(t1, u, function(t1, n) {
                            return l.call(r, t1) ? o.call(c, h, r[t1], t1, r, n) : e1;
                        });
                    };
                };
            },
            1920: function(t1, e1, r) {
                "use strict";
                t1.exports = r(41271)() ? Object.assign : r(26399);
            },
            41271: function(t1) {
                "use strict";
                t1.exports = function() {
                    var t1, e1 = Object.assign;
                    return "function" == typeof e1 && (e1(t1 = {
                        foo: "raz"
                    }, {
                        bar: "dwa"
                    }, {
                        trzy: "trzy"
                    }), t1.foo + t1.bar + t1.trzy === "razdwatrzy");
                };
            },
            26399: function(t1, e1, r) {
                "use strict";
                var n = r(36353), i = r(69746), a = Math.max;
                t1.exports = function(t1, e1) {
                    var r, o, s, l = a(arguments.length, 2);
                    for(t1 = Object(i(t1)), s = function(n) {
                        try {
                            t1[n] = e1[n];
                        } catch (t1) {
                            r || (r = t1);
                        }
                    }, o = 1; o < l; ++o)n(e1 = arguments[o]).forEach(s);
                    if (void 0 !== r) throw r;
                    return t1;
                };
            },
            86591: function(t1, e1, r) {
                "use strict";
                var n = r(82377), i = r(1920), a = r(69746);
                t1.exports = function(t1) {
                    var e1 = Object(a(t1)), r = arguments[1], o = Object(arguments[2]);
                    if (e1 !== t1 && !r) return e1;
                    var s = {};
                    return r ? n(r, function(e1) {
                        (o.ensure || e1 in t1) && (s[e1] = t1[e1]);
                    }) : i(s, t1), s;
                };
            },
            57842: function(t1, e1, r) {
                "use strict";
                var n, i, a, o, s = Object.create;
                r(90361)() || (n = r(45765)), t1.exports = n ? 1 !== n.level ? s : (i = {}, a = {}, o = {
                    configurable: !1,
                    enumerable: !1,
                    writable: !0,
                    value: void 0
                }, Object.getOwnPropertyNames(Object.prototype).forEach(function(t1) {
                    a[t1] = "__proto__" !== t1 ? o : {
                        configurable: !0,
                        enumerable: !1,
                        writable: !0,
                        value: void 0
                    };
                }), Object.defineProperties(i, a), Object.defineProperty(n, "nullPolyfill", {
                    configurable: !1,
                    enumerable: !1,
                    writable: !1,
                    value: i
                }), function(t1, e1) {
                    return s(null === t1 ? i : t1, e1);
                }) : s;
            },
            82813: function(t1, e1, r) {
                "use strict";
                t1.exports = r(39395)("forEach");
            },
            76064: function(t1, e1, r) {
                "use strict";
                var n = r(1974), i = {
                    function: !0,
                    object: !0
                };
                t1.exports = function(t1) {
                    return n(t1) && i[typeof t1] || !1;
                };
            },
            1974: function(t1, e1, r) {
                "use strict";
                var n = r(62039)();
                t1.exports = function(t1) {
                    return t1 !== n && null !== t1;
                };
            },
            36353: function(t1, e1, r) {
                "use strict";
                t1.exports = r(83800)() ? Object.keys : r(67044);
            },
            83800: function(t1) {
                "use strict";
                t1.exports = function() {
                    try {
                        return Object.keys("primitive"), !0;
                    } catch (t1) {
                        return !1;
                    }
                };
            },
            67044: function(t1, e1, r) {
                "use strict";
                var n = r(1974), i = Object.keys;
                t1.exports = function(t1) {
                    return i(n(t1) ? Object(t1) : t1);
                };
            },
            29854: function(t1, e1, r) {
                "use strict";
                var n = r(52359), i = r(82813), a = Function.prototype.call;
                t1.exports = function(t1, e1) {
                    var r = {}, o = arguments[2];
                    return n(e1), i(t1, function(t1, n, i, s) {
                        r[n] = a.call(e1, o, t1, n, i, s);
                    }), r;
                };
            },
            76504: function(t1, e1, r) {
                "use strict";
                var n = r(1974), i = Array.prototype.forEach, a = Object.create;
                t1.exports = function(t1) {
                    var e1 = a(null);
                    return i.call(arguments, function(t1) {
                        n(t1) && function(t1, e1) {
                            var r;
                            for(r in t1)e1[r] = t1[r];
                        }(Object(t1), e1);
                    }), e1;
                };
            },
            22834: function(t1, e1, r) {
                "use strict";
                t1.exports = r(90361)() ? Object.setPrototypeOf : r(45765);
            },
            90361: function(t1) {
                "use strict";
                var e1 = Object.create, r = Object.getPrototypeOf, n = {};
                t1.exports = function() {
                    var t1 = Object.setPrototypeOf;
                    return "function" == typeof t1 && r(t1((arguments[0] || e1)(null), n)) === n;
                };
            },
            45765: function(t1, e1, r) {
                "use strict";
                var n, i, a, o, s = r(76064), l = r(69746), c = Object.prototype.isPrototypeOf, u = Object.defineProperty, h = {
                    configurable: !0,
                    enumerable: !1,
                    writable: !0,
                    value: void 0
                };
                n = function(t1, e1) {
                    if (l(t1), null === e1 || s(e1)) return t1;
                    throw new TypeError("Prototype must be null or an object");
                }, t1.exports = (i = function() {
                    var t1, e1 = Object.create(null), r = {}, n = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__");
                    if (n) {
                        try {
                            (t1 = n.set).call(e1, r);
                        } catch (t1) {}
                        if (Object.getPrototypeOf(e1) === r) return {
                            set: t1,
                            level: 2
                        };
                    }
                    return e1.__proto__ = r, Object.getPrototypeOf(e1) === r ? {
                        level: 2
                    } : ((e1 = {}).__proto__ = r, Object.getPrototypeOf(e1) === r && {
                        level: 1
                    });
                }(), i ? (2 === i.level ? i.set ? (o = i.set, a = function(t1, e1) {
                    return o.call(n(t1, e1), e1), t1;
                }) : a = function(t1, e1) {
                    return n(t1, e1).__proto__ = e1, t1;
                } : a = function t1(e1, r) {
                    var i;
                    return n(e1, r), (i = c.call(t1.nullPolyfill, e1)) && delete t1.nullPolyfill.__proto__, null === r && (r = t1.nullPolyfill), e1.__proto__ = r, i && u(t1.nullPolyfill, "__proto__", h), e1;
                }, Object.defineProperty(a, "level", {
                    configurable: !1,
                    enumerable: !1,
                    writable: !1,
                    value: i.level
                })) : null), r(57842);
            },
            52359: function(t1) {
                "use strict";
                t1.exports = function(t1) {
                    if ("function" != typeof t1) throw new TypeError(t1 + " is not a function");
                    return t1;
                };
            },
            11004: function(t1, e1, r) {
                "use strict";
                var n = r(76064);
                t1.exports = function(t1) {
                    if (!n(t1)) throw new TypeError(t1 + " is not an Object");
                    return t1;
                };
            },
            69746: function(t1, e1, r) {
                "use strict";
                var n = r(1974);
                t1.exports = function(t1) {
                    if (!n(t1)) throw new TypeError("Cannot use null or undefined");
                    return t1;
                };
            },
            2338: function(t1, e1, r) {
                "use strict";
                t1.exports = r(65961)() ? String.prototype.contains : r(9461);
            },
            65961: function(t1) {
                "use strict";
                var e1 = "razdwatrzy";
                t1.exports = function() {
                    return "function" == typeof e1.contains && !0 === e1.contains("dwa") && !1 === e1.contains("foo");
                };
            },
            9461: function(t1) {
                "use strict";
                var e1 = String.prototype.indexOf;
                t1.exports = function(t1) {
                    return e1.call(this, t1, arguments[1]) > -1;
                };
            },
            48488: function(t1) {
                "use strict";
                var e1 = Object.prototype.toString, r = e1.call("");
                t1.exports = function(t1) {
                    return "string" == typeof t1 || t1 && "object" == typeof t1 && (t1 instanceof String || e1.call(t1) === r) || !1;
                };
            },
            43497: function(t1) {
                "use strict";
                var e1 = Object.create(null), r = Math.random;
                t1.exports = function() {
                    var t1;
                    do t1 = r().toString(36).slice(2);
                    while (e1[t1]);
                    return t1;
                };
            },
            71343: function(t1, e1, r) {
                "use strict";
                var n, i = r(22834), a = r(2338), o = r(91819), s = r(63008), l = r(85490), c = Object.defineProperty;
                n = t1.exports = function(t1, e1) {
                    if (!(this instanceof n)) throw new TypeError("Constructor requires 'new'");
                    l.call(this, t1), e1 = e1 ? a.call(e1, "key+value") ? "key+value" : a.call(e1, "key") ? "key" : "value" : "value", c(this, "__kind__", o("", e1));
                }, i && i(n, l), delete n.prototype.constructor, n.prototype = Object.create(l.prototype, {
                    _resolve: o(function(t1) {
                        return "value" === this.__kind__ ? this.__list__[t1] : "key+value" === this.__kind__ ? [
                            t1,
                            this.__list__[t1]
                        ] : t1;
                    })
                }), c(n.prototype, s.toStringTag, o("c", "Array Iterator"));
            },
            58755: function(t1, e1, r) {
                "use strict";
                var n = r(82262), i = r(52359), a = r(48488), o = r(34494), s = Array.isArray, l = Function.prototype.call, c = Array.prototype.some;
                t1.exports = function(t1, e1) {
                    var r, u, h, f, p, d, m, g, y = arguments[2];
                    if (s(t1) || n(t1) ? r = "array" : a(t1) ? r = "string" : t1 = o(t1), i(e1), h = function() {
                        f = !0;
                    }, "array" !== r) {
                        if ("string" !== r) for(u = t1.next(); !u.done;){
                            if (l.call(e1, y, u.value, h), f) return;
                            u = t1.next();
                        }
                        else for(d = t1.length, p = 0; p < d && (m = t1[p], p + 1 < d && (g = m.charCodeAt(0)) >= 55296 && g <= 56319 && (m += t1[++p]), l.call(e1, y, m, h), !f); ++p);
                    } else c.call(t1, function(t1) {
                        return l.call(e1, y, t1, h), f;
                    });
                };
            },
            34494: function(t1, e1, r) {
                "use strict";
                var n = r(82262), i = r(48488), a = r(71343), o = r(23417), s = r(82831), l = r(63008).iterator;
                t1.exports = function(t1) {
                    return "function" == typeof s(t1)[l] ? t1[l]() : n(t1) ? new a(t1) : i(t1) ? new o(t1) : new a(t1);
                };
            },
            85490: function(t1, e1, r) {
                "use strict";
                var n, i = r(91445), a = r(1920), o = r(52359), s = r(69746), l = r(91819), c = r(84510), u = r(63008), h = Object.defineProperty, f = Object.defineProperties;
                t1.exports = n = function(t1, e1) {
                    if (!(this instanceof n)) throw new TypeError("Constructor requires 'new'");
                    f(this, {
                        __list__: l("w", s(t1)),
                        __context__: l("w", e1),
                        __nextIndex__: l("w", 0)
                    }), e1 && (o(e1.on), e1.on("_add", this._onAdd), e1.on("_delete", this._onDelete), e1.on("_clear", this._onClear));
                }, delete n.prototype.constructor, f(n.prototype, a({
                    _next: l(function() {
                        var t1;
                        if (this.__list__) return this.__redo__ && void 0 !== (t1 = this.__redo__.shift()) ? t1 : this.__nextIndex__ < this.__list__.length ? this.__nextIndex__++ : void this._unBind();
                    }),
                    next: l(function() {
                        return this._createResult(this._next());
                    }),
                    _createResult: l(function(t1) {
                        return void 0 === t1 ? {
                            done: !0,
                            value: void 0
                        } : {
                            done: !1,
                            value: this._resolve(t1)
                        };
                    }),
                    _resolve: l(function(t1) {
                        return this.__list__[t1];
                    }),
                    _unBind: l(function() {
                        this.__list__ = null, delete this.__redo__, this.__context__ && (this.__context__.off("_add", this._onAdd), this.__context__.off("_delete", this._onDelete), this.__context__.off("_clear", this._onClear), this.__context__ = null);
                    }),
                    toString: l(function() {
                        return "[object " + (this[u.toStringTag] || "Object") + "]";
                    })
                }, c({
                    _onAdd: l(function(t1) {
                        t1 >= this.__nextIndex__ || (++this.__nextIndex__, this.__redo__ ? (this.__redo__.forEach(function(e1, r) {
                            e1 >= t1 && (this.__redo__[r] = ++e1);
                        }, this), this.__redo__.push(t1)) : h(this, "__redo__", l("c", [
                            t1
                        ])));
                    }),
                    _onDelete: l(function(t1) {
                        var e1;
                        t1 >= this.__nextIndex__ || (--this.__nextIndex__, this.__redo__ && (-1 !== (e1 = this.__redo__.indexOf(t1)) && this.__redo__.splice(e1, 1), this.__redo__.forEach(function(e1, r) {
                            e1 > t1 && (this.__redo__[r] = --e1);
                        }, this)));
                    }),
                    _onClear: l(function() {
                        this.__redo__ && i.call(this.__redo__), this.__nextIndex__ = 0;
                    })
                }))), h(n.prototype, u.iterator, l(function() {
                    return this;
                }));
            },
            50567: function(t1, e1, r) {
                "use strict";
                var n = r(82262), i = r(1974), a = r(48488), o = r(63008).iterator, s = Array.isArray;
                t1.exports = function(t1) {
                    return !(!i(t1) || !s(t1) && !a(t1) && !n(t1) && "function" != typeof t1[o]);
                };
            },
            23417: function(t1, e1, r) {
                "use strict";
                var n, i = r(22834), a = r(91819), o = r(63008), s = r(85490), l = Object.defineProperty;
                n = t1.exports = function(t1) {
                    if (!(this instanceof n)) throw new TypeError("Constructor requires 'new'");
                    t1 = String(t1), s.call(this, t1), l(this, "__length__", a("", t1.length));
                }, i && i(n, s), delete n.prototype.constructor, n.prototype = Object.create(s.prototype, {
                    _next: a(function() {
                        if (this.__list__) return this.__nextIndex__ < this.__length__ ? this.__nextIndex__++ : void this._unBind();
                    }),
                    _resolve: a(function(t1) {
                        var e1, r = this.__list__[t1];
                        return this.__nextIndex__ === this.__length__ ? r : (e1 = r.charCodeAt(0)) >= 55296 && e1 <= 56319 ? r + this.__list__[this.__nextIndex__++] : r;
                    })
                }), l(n.prototype, o.toStringTag, a("c", "String Iterator"));
            },
            82831: function(t1, e1, r) {
                "use strict";
                var n = r(50567);
                t1.exports = function(t1) {
                    if (!n(t1)) throw new TypeError(t1 + " is not iterable");
                    return t1;
                };
            },
            63008: function(t1, e1, r) {
                "use strict";
                t1.exports = r(25143)() ? r(64725).Symbol : r(81905);
            },
            25143: function(t1, e1, r) {
                "use strict";
                var n = r(64725), i = {
                    object: !0,
                    symbol: !0
                };
                t1.exports = function() {
                    var t1, e1 = n.Symbol;
                    if ("function" != typeof e1) return !1;
                    t1 = e1("test symbol");
                    try {
                        String(t1);
                    } catch (t1) {
                        return !1;
                    }
                    return !!i[typeof e1.iterator] && !!i[typeof e1.toPrimitive] && !!i[typeof e1.toStringTag];
                };
            },
            41707: function(t1) {
                "use strict";
                t1.exports = function(t1) {
                    return !!t1 && ("symbol" == typeof t1 || !!t1.constructor && "Symbol" === t1.constructor.name && "Symbol" === t1[t1.constructor.toStringTag]);
                };
            },
            74009: function(t1, e1, r) {
                "use strict";
                var n = r(91819), i = Object.create, a = Object.defineProperty, o = Object.prototype, s = i(null);
                t1.exports = function(t1) {
                    for(var e1, r, i = 0; s[t1 + (i || "")];)++i;
                    return s[t1 += i || ""] = !0, a(o, e1 = "@@" + t1, n.gs(null, function(t1) {
                        r || (r = !0, a(this, e1, n(t1)), r = !1);
                    })), e1;
                };
            },
            40313: function(t1, e1, r) {
                "use strict";
                var n = r(91819), i = r(64725).Symbol;
                t1.exports = function(t1) {
                    return Object.defineProperties(t1, {
                        hasInstance: n("", i && i.hasInstance || t1("hasInstance")),
                        isConcatSpreadable: n("", i && i.isConcatSpreadable || t1("isConcatSpreadable")),
                        iterator: n("", i && i.iterator || t1("iterator")),
                        match: n("", i && i.match || t1("match")),
                        replace: n("", i && i.replace || t1("replace")),
                        search: n("", i && i.search || t1("search")),
                        species: n("", i && i.species || t1("species")),
                        split: n("", i && i.split || t1("split")),
                        toPrimitive: n("", i && i.toPrimitive || t1("toPrimitive")),
                        toStringTag: n("", i && i.toStringTag || t1("toStringTag")),
                        unscopables: n("", i && i.unscopables || t1("unscopables"))
                    });
                };
            },
            21290: function(t1, e1, r) {
                "use strict";
                var n = r(91819), i = r(91765), a = Object.create(null);
                t1.exports = function(t1) {
                    return Object.defineProperties(t1, {
                        for: n(function(e1) {
                            return a[e1] ? a[e1] : a[e1] = t1(String(e1));
                        }),
                        keyFor: n(function(t1) {
                            var e1;
                            for(e1 in i(t1), a)if (a[e1] === t1) return e1;
                        })
                    });
                };
            },
            81905: function(t1, e1, r) {
                "use strict";
                var n, i, a, o = r(91819), s = r(91765), l = r(64725).Symbol, c = r(74009), u = r(40313), h = r(21290), f = Object.create, p = Object.defineProperties, d = Object.defineProperty;
                if ("function" == typeof l) try {
                    String(l()), a = !0;
                } catch (t1) {}
                else l = null;
                i = function(t1) {
                    if (this instanceof i) throw new TypeError("Symbol is not a constructor");
                    return n(t1);
                }, t1.exports = n = function t1(e1) {
                    var r;
                    if (this instanceof t1) throw new TypeError("Symbol is not a constructor");
                    return a ? l(e1) : (r = f(i.prototype), e1 = void 0 === e1 ? "" : String(e1), p(r, {
                        __description__: o("", e1),
                        __name__: o("", c(e1))
                    }));
                }, u(n), h(n), p(i.prototype, {
                    constructor: o(n),
                    toString: o("", function() {
                        return this.__name__;
                    })
                }), p(n.prototype, {
                    toString: o(function() {
                        return "Symbol (" + s(this).__description__ + ")";
                    }),
                    valueOf: o(function() {
                        return s(this);
                    })
                }), d(n.prototype, n.toPrimitive, o("", function() {
                    var t1 = s(this);
                    return "symbol" == typeof t1 ? t1 : t1.toString();
                })), d(n.prototype, n.toStringTag, o("c", "Symbol")), d(i.prototype, n.toStringTag, o("c", n.prototype[n.toStringTag])), d(i.prototype, n.toPrimitive, o("c", n.prototype[n.toPrimitive]));
            },
            91765: function(t1, e1, r) {
                "use strict";
                var n = r(41707);
                t1.exports = function(t1) {
                    if (!n(t1)) throw new TypeError(t1 + " is not a symbol");
                    return t1;
                };
            },
            93103: function(t1, e1, r) {
                "use strict";
                t1.exports = r(22742)() ? WeakMap : r(21780);
            },
            22742: function(t1) {
                "use strict";
                t1.exports = function() {
                    var t1, e1;
                    if ("function" != typeof WeakMap) return !1;
                    try {
                        t1 = new WeakMap([
                            [
                                e1 = {},
                                "one"
                            ],
                            [
                                {},
                                "two"
                            ],
                            [
                                {},
                                "three"
                            ]
                        ]);
                    } catch (t1) {
                        return !1;
                    }
                    return "[object WeakMap]" === String(t1) && "function" == typeof t1.set && t1.set({}, 1) === t1 && "function" == typeof t1.delete && "function" == typeof t1.has && "one" === t1.get(e1);
                };
            },
            81810: function(t1) {
                "use strict";
                t1.exports = "function" == typeof WeakMap && "[object WeakMap]" === Object.prototype.toString.call(new WeakMap);
            },
            21780: function(t1, e1, r) {
                "use strict";
                var n, i = r(1974), a = r(22834), o = r(11004), s = r(69746), l = r(43497), c = r(91819), u = r(34494), h = r(58755), f = r(63008).toStringTag, p = r(81810), d = Array.isArray, m = Object.defineProperty, g = Object.prototype.hasOwnProperty, y = Object.getPrototypeOf;
                t1.exports = n = function() {
                    var t1, e1 = arguments[0];
                    if (!(this instanceof n)) throw new TypeError("Constructor requires 'new'");
                    return t1 = p && a && WeakMap !== n ? a(new WeakMap, y(this)) : this, i(e1) && (d(e1) || (e1 = u(e1))), m(t1, "__weakMapData__", c("c", "$weakMap$" + l())), e1 ? (h(e1, function(e1) {
                        s(e1), t1.set(e1[0], e1[1]);
                    }), t1) : t1;
                }, p && (a && a(n, WeakMap), n.prototype = Object.create(WeakMap.prototype, {
                    constructor: c(n)
                })), Object.defineProperties(n.prototype, {
                    delete: c(function(t1) {
                        return !!g.call(o(t1), this.__weakMapData__) && (delete t1[this.__weakMapData__], !0);
                    }),
                    get: c(function(t1) {
                        if (g.call(o(t1), this.__weakMapData__)) return t1[this.__weakMapData__];
                    }),
                    has: c(function(t1) {
                        return g.call(o(t1), this.__weakMapData__);
                    }),
                    set: c(function(t1, e1) {
                        return m(o(t1), this.__weakMapData__, c("c", e1)), this;
                    }),
                    toString: c(function() {
                        return "[object WeakMap]";
                    })
                }), m(n.prototype, f, c("c", "WeakMap"));
            },
            7683: function(t1) {
                "use strict";
                var e1, r = "object" == typeof Reflect ? Reflect : null, n = r && "function" == typeof r.apply ? r.apply : function(t1, e1, r) {
                    return Function.prototype.apply.call(t1, e1, r);
                };
                e1 = r && "function" == typeof r.ownKeys ? r.ownKeys : Object.getOwnPropertySymbols ? function(t1) {
                    return Object.getOwnPropertyNames(t1).concat(Object.getOwnPropertySymbols(t1));
                } : function(t1) {
                    return Object.getOwnPropertyNames(t1);
                };
                var i = Number.isNaN || function(t1) {
                    return t1 != t1;
                };
                function a() {
                    a.init.call(this);
                }
                t1.exports = a, t1.exports.once = function(t1, e1) {
                    return new Promise(function(r, n) {
                        function i(r) {
                            t1.removeListener(e1, a), n(r);
                        }
                        function a() {
                            "function" == typeof t1.removeListener && t1.removeListener("error", i), r([].slice.call(arguments));
                        }
                        m(t1, e1, a, {
                            once: !0
                        }), "error" !== e1 && function(t1, e1, r) {
                            "function" == typeof t1.on && m(t1, "error", e1, {
                                once: !0
                            });
                        }(t1, i);
                    });
                }, a.EventEmitter = a, a.prototype._events = void 0, a.prototype._eventsCount = 0, a.prototype._maxListeners = void 0;
                var o = 10;
                function s(t1) {
                    if ("function" != typeof t1) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t1);
                }
                function l(t1) {
                    return void 0 === t1._maxListeners ? a.defaultMaxListeners : t1._maxListeners;
                }
                function c(t1, e1, r, n) {
                    var i, a, o, c;
                    if (s(r), void 0 === (a = t1._events) ? (a = t1._events = Object.create(null), t1._eventsCount = 0) : (void 0 !== a.newListener && (t1.emit("newListener", e1, r.listener ? r.listener : r), a = t1._events), o = a[e1]), void 0 === o) o = a[e1] = r, ++t1._eventsCount;
                    else if ("function" == typeof o ? o = a[e1] = n ? [
                        r,
                        o
                    ] : [
                        o,
                        r
                    ] : n ? o.unshift(r) : o.push(r), (i = l(t1)) > 0 && o.length > i && !o.warned) {
                        o.warned = !0;
                        var u = new Error("Possible EventEmitter memory leak detected. " + o.length + " " + String(e1) + " listeners added. Use emitter.setMaxListeners() to increase limit");
                        u.name = "MaxListenersExceededWarning", u.emitter = t1, u.type = e1, u.count = o.length, c = u, console && console.warn && console.warn(c);
                    }
                    return t1;
                }
                function u() {
                    if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
                }
                function h(t1, e1, r) {
                    var n = {
                        fired: !1,
                        wrapFn: void 0,
                        target: t1,
                        type: e1,
                        listener: r
                    }, i = u.bind(n);
                    return i.listener = r, n.wrapFn = i, i;
                }
                function f(t1, e1, r) {
                    var n = t1._events;
                    if (void 0 === n) return [];
                    var i = n[e1];
                    return void 0 === i ? [] : "function" == typeof i ? r ? [
                        i.listener || i
                    ] : [
                        i
                    ] : r ? function(t1) {
                        for(var e1 = new Array(t1.length), r = 0; r < e1.length; ++r)e1[r] = t1[r].listener || t1[r];
                        return e1;
                    }(i) : d(i, i.length);
                }
                function p(t1) {
                    var e1 = this._events;
                    if (void 0 !== e1) {
                        var r = e1[t1];
                        if ("function" == typeof r) return 1;
                        if (void 0 !== r) return r.length;
                    }
                    return 0;
                }
                function d(t1, e1) {
                    for(var r = new Array(e1), n = 0; n < e1; ++n)r[n] = t1[n];
                    return r;
                }
                function m(t1, e1, r, n) {
                    if ("function" == typeof t1.on) n.once ? t1.once(e1, r) : t1.on(e1, r);
                    else {
                        if ("function" != typeof t1.addEventListener) throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof t1);
                        t1.addEventListener(e1, function i(a) {
                            n.once && t1.removeEventListener(e1, i), r(a);
                        });
                    }
                }
                Object.defineProperty(a, "defaultMaxListeners", {
                    enumerable: !0,
                    get: function() {
                        return o;
                    },
                    set: function(t1) {
                        if ("number" != typeof t1 || t1 < 0 || i(t1)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t1 + ".");
                        o = t1;
                    }
                }), a.init = function() {
                    void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
                }, a.prototype.setMaxListeners = function(t1) {
                    if ("number" != typeof t1 || t1 < 0 || i(t1)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t1 + ".");
                    return this._maxListeners = t1, this;
                }, a.prototype.getMaxListeners = function() {
                    return l(this);
                }, a.prototype.emit = function(t1) {
                    for(var e1 = [], r = 1; r < arguments.length; r++)e1.push(arguments[r]);
                    var i = "error" === t1, a = this._events;
                    if (void 0 !== a) i = i && void 0 === a.error;
                    else if (!i) return !1;
                    if (i) {
                        var o;
                        if (e1.length > 0 && (o = e1[0]), o instanceof Error) throw o;
                        var s = new Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
                        throw s.context = o, s;
                    }
                    var l = a[t1];
                    if (void 0 === l) return !1;
                    if ("function" == typeof l) n(l, this, e1);
                    else {
                        var c = l.length, u = d(l, c);
                        for(r = 0; r < c; ++r)n(u[r], this, e1);
                    }
                    return !0;
                }, a.prototype.addListener = function(t1, e1) {
                    return c(this, t1, e1, !1);
                }, a.prototype.on = a.prototype.addListener, a.prototype.prependListener = function(t1, e1) {
                    return c(this, t1, e1, !0);
                }, a.prototype.once = function(t1, e1) {
                    return s(e1), this.on(t1, h(this, t1, e1)), this;
                }, a.prototype.prependOnceListener = function(t1, e1) {
                    return s(e1), this.prependListener(t1, h(this, t1, e1)), this;
                }, a.prototype.removeListener = function(t1, e1) {
                    var r, n, i, a, o;
                    if (s(e1), void 0 === (n = this._events)) return this;
                    if (void 0 === (r = n[t1])) return this;
                    if (r === e1 || r.listener === e1) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete n[t1], n.removeListener && this.emit("removeListener", t1, r.listener || e1));
                    else if ("function" != typeof r) {
                        for(i = -1, a = r.length - 1; a >= 0; a--)if (r[a] === e1 || r[a].listener === e1) {
                            o = r[a].listener, i = a;
                            break;
                        }
                        if (i < 0) return this;
                        0 === i ? r.shift() : function(t1, e1) {
                            for(; e1 + 1 < t1.length; e1++)t1[e1] = t1[e1 + 1];
                            t1.pop();
                        }(r, i), 1 === r.length && (n[t1] = r[0]), void 0 !== n.removeListener && this.emit("removeListener", t1, o || e1);
                    }
                    return this;
                }, a.prototype.off = a.prototype.removeListener, a.prototype.removeAllListeners = function(t1) {
                    var e1, r, n;
                    if (void 0 === (r = this._events)) return this;
                    if (void 0 === r.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== r[t1] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete r[t1]), this;
                    if (0 === arguments.length) {
                        var i, a = Object.keys(r);
                        for(n = 0; n < a.length; ++n)"removeListener" !== (i = a[n]) && this.removeAllListeners(i);
                        return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
                    }
                    if ("function" == typeof (e1 = r[t1])) this.removeListener(t1, e1);
                    else if (void 0 !== e1) for(n = e1.length - 1; n >= 0; n--)this.removeListener(t1, e1[n]);
                    return this;
                }, a.prototype.listeners = function(t1) {
                    return f(this, t1, !0);
                }, a.prototype.rawListeners = function(t1) {
                    return f(this, t1, !1);
                }, a.listenerCount = function(t1, e1) {
                    return "function" == typeof t1.listenerCount ? t1.listenerCount(e1) : p.call(t1, e1);
                }, a.prototype.listenerCount = p, a.prototype.eventNames = function() {
                    return this._eventsCount > 0 ? e1(this._events) : [];
                };
            },
            77083: function(t1) {
                var e1 = function() {
                    if ("object" == typeof self && self) return self;
                    if ("object" == typeof window && window) return window;
                    throw new Error("Unable to resolve global `this`");
                };
                t1.exports = function() {
                    if (this) return this;
                    try {
                        Object.defineProperty(Object.prototype, "__global__", {
                            get: function() {
                                return this;
                            },
                            configurable: !0
                        });
                    } catch (t1) {
                        return e1();
                    }
                    try {
                        return __global__ || e1();
                    } finally{
                        delete Object.prototype.__global__;
                    }
                }();
            },
            64725: function(t1, e1, r) {
                "use strict";
                t1.exports = r(17804)() ? globalThis : r(77083);
            },
            17804: function(t1) {
                "use strict";
                t1.exports = function() {
                    return "object" == typeof globalThis && !!globalThis && globalThis.Array === Array;
                };
            },
            10721: function(t1, e1, r) {
                "use strict";
                var n = r(9914);
                t1.exports = function(t1) {
                    var e1 = typeof t1;
                    if ("string" === e1) {
                        var r = t1;
                        if (0 == (t1 = +t1) && n(r)) return !1;
                    } else if ("number" !== e1) return !1;
                    return t1 - t1 < 1;
                };
            },
            83473: function(t1, e1, r) {
                var n = r(10275);
                t1.exports = function(t1, e1, r) {
                    if (!t1) throw new TypeError("must specify data as first parameter");
                    if (r = 0 | +(r || 0), Array.isArray(t1) && t1[0] && "number" == typeof t1[0][0]) {
                        var i, a, o, s, l = t1[0].length, c = t1.length * l;
                        e1 && "string" != typeof e1 || (e1 = new (n(e1 || "float32"))(c + r));
                        var u = e1.length - r;
                        if (c !== u) throw new Error("source length " + c + " (" + l + "x" + t1.length + ") does not match destination length " + u);
                        for(i = 0, o = r; i < t1.length; i++)for(a = 0; a < l; a++)e1[o++] = null === t1[i][a] ? NaN : t1[i][a];
                    } else if (e1 && "string" != typeof e1) e1.set(t1, r);
                    else {
                        var h = n(e1 || "float32");
                        if (Array.isArray(t1) || "array" === e1) for(i = 0, o = r, s = (e1 = new h(t1.length + r)).length; o < s; o++, i++)e1[o] = null === t1[i] ? NaN : t1[i];
                        else 0 === r ? e1 = new h(t1) : (e1 = new h(t1.length + r)).set(t1, r);
                    }
                    return e1;
                };
            },
            68950: function(t1, e1, r) {
                "use strict";
                var n = r(38211), i = [
                    32,
                    126
                ];
                t1.exports = function(t1) {
                    var e1 = (t1 = t1 || {}).shape ? t1.shape : t1.canvas ? [
                        t1.canvas.width,
                        t1.canvas.height
                    ] : [
                        512,
                        512
                    ], r = t1.canvas || document.createElement("canvas"), a = t1.font, o = "number" == typeof t1.step ? [
                        t1.step,
                        t1.step
                    ] : t1.step || [
                        32,
                        32
                    ], s = t1.chars || i;
                    if (a && "string" != typeof a && (a = n(a)), Array.isArray(s)) {
                        if (2 === s.length && "number" == typeof s[0] && "number" == typeof s[1]) {
                            for(var l = [], c = s[0], u = 0; c <= s[1]; c++)l[u++] = String.fromCharCode(c);
                            s = l;
                        }
                    } else s = String(s).split("");
                    e1 = e1.slice(), r.width = e1[0], r.height = e1[1];
                    var h = r.getContext("2d");
                    h.fillStyle = "#000", h.fillRect(0, 0, r.width, r.height), h.font = a, h.textAlign = "center", h.textBaseline = "middle", h.fillStyle = "#fff";
                    var f = o[0] / 2, p = o[1] / 2;
                    for(c = 0; c < s.length; c++)h.fillText(s[c], f, p), (f += o[0]) > e1[0] - o[0] / 2 && (f = o[0] / 2, p += o[1]);
                    return r;
                };
            },
            12673: function(t1) {
                "use strict";
                function e1(t1, a) {
                    a || (a = {}), ("string" == typeof t1 || Array.isArray(t1)) && (a.family = t1);
                    var o = Array.isArray(a.family) ? a.family.join(", ") : a.family;
                    if (!o) throw Error("`family` must be defined");
                    var s = a.size || a.fontSize || a.em || 48, l = a.weight || a.fontWeight || "", c = (t1 = [
                        a.style || a.fontStyle || "",
                        l,
                        s
                    ].join(" ") + "px " + o, a.origin || "top");
                    if (e1.cache[o] && s <= e1.cache[o].em) return r(e1.cache[o], c);
                    var u = a.canvas || e1.canvas, h = u.getContext("2d"), f = {
                        upper: void 0 !== a.upper ? a.upper : "H",
                        lower: void 0 !== a.lower ? a.lower : "x",
                        descent: void 0 !== a.descent ? a.descent : "p",
                        ascent: void 0 !== a.ascent ? a.ascent : "h",
                        tittle: void 0 !== a.tittle ? a.tittle : "i",
                        overshoot: void 0 !== a.overshoot ? a.overshoot : "O"
                    }, p = Math.ceil(1.5 * s);
                    u.height = p, u.width = .5 * p, h.font = t1;
                    var d = "H", m = {
                        top: 0
                    };
                    h.clearRect(0, 0, p, p), h.textBaseline = "top", h.fillStyle = "black", h.fillText(d, 0, 0);
                    var g = n(h.getImageData(0, 0, p, p));
                    h.clearRect(0, 0, p, p), h.textBaseline = "bottom", h.fillText(d, 0, p);
                    var y = n(h.getImageData(0, 0, p, p));
                    m.lineHeight = m.bottom = p - y + g, h.clearRect(0, 0, p, p), h.textBaseline = "alphabetic", h.fillText(d, 0, p);
                    var v = p - n(h.getImageData(0, 0, p, p)) - 1 + g;
                    m.baseline = m.alphabetic = v, h.clearRect(0, 0, p, p), h.textBaseline = "middle", h.fillText(d, 0, .5 * p);
                    var x = n(h.getImageData(0, 0, p, p));
                    m.median = m.middle = p - x - 1 + g - .5 * p, h.clearRect(0, 0, p, p), h.textBaseline = "hanging", h.fillText(d, 0, .5 * p);
                    var _ = n(h.getImageData(0, 0, p, p));
                    m.hanging = p - _ - 1 + g - .5 * p, h.clearRect(0, 0, p, p), h.textBaseline = "ideographic", h.fillText(d, 0, p);
                    var b = n(h.getImageData(0, 0, p, p));
                    if (m.ideographic = p - b - 1 + g, f.upper && (h.clearRect(0, 0, p, p), h.textBaseline = "top", h.fillText(f.upper, 0, 0), m.upper = n(h.getImageData(0, 0, p, p)), m.capHeight = m.baseline - m.upper), f.lower && (h.clearRect(0, 0, p, p), h.textBaseline = "top", h.fillText(f.lower, 0, 0), m.lower = n(h.getImageData(0, 0, p, p)), m.xHeight = m.baseline - m.lower), f.tittle && (h.clearRect(0, 0, p, p), h.textBaseline = "top", h.fillText(f.tittle, 0, 0), m.tittle = n(h.getImageData(0, 0, p, p))), f.ascent && (h.clearRect(0, 0, p, p), h.textBaseline = "top", h.fillText(f.ascent, 0, 0), m.ascent = n(h.getImageData(0, 0, p, p))), f.descent && (h.clearRect(0, 0, p, p), h.textBaseline = "top", h.fillText(f.descent, 0, 0), m.descent = i(h.getImageData(0, 0, p, p))), f.overshoot) {
                        h.clearRect(0, 0, p, p), h.textBaseline = "top", h.fillText(f.overshoot, 0, 0);
                        var w = i(h.getImageData(0, 0, p, p));
                        m.overshoot = w - v;
                    }
                    for(var T in m)m[T] /= s;
                    return m.em = s, e1.cache[o] = m, r(m, c);
                }
                function r(t1, e1) {
                    var r = {};
                    for(var n in "string" == typeof e1 && (e1 = t1[e1]), t1)"em" !== n && (r[n] = t1[n] - e1);
                    return r;
                }
                function n(t1) {
                    for(var e1 = t1.height, r = t1.data, n = 3; n < r.length; n += 4)if (0 !== r[n]) return Math.floor(.25 * (n - 3) / e1);
                }
                function i(t1) {
                    for(var e1 = t1.height, r = t1.data, n = r.length - 1; n > 0; n -= 4)if (0 !== r[n]) return Math.floor(.25 * (n - 3) / e1);
                }
                t1.exports = e1, e1.canvas = document.createElement("canvas"), e1.cache = {};
            },
            61262: function(t1, e1, r) {
                "use strict";
                var n = r(82756), i = Object.prototype.toString, a = Object.prototype.hasOwnProperty;
                t1.exports = function(t1, e1, r) {
                    if (!n(e1)) throw new TypeError("iterator must be a function");
                    var o;
                    arguments.length >= 3 && (o = r), "[object Array]" === i.call(t1) ? function(t1, e1, r) {
                        for(var n = 0, i = t1.length; n < i; n++)a.call(t1, n) && (null == r ? e1(t1[n], n, t1) : e1.call(r, t1[n], n, t1));
                    }(t1, e1, o) : "string" == typeof t1 ? function(t1, e1, r) {
                        for(var n = 0, i = t1.length; n < i; n++)null == r ? e1(t1.charAt(n), n, t1) : e1.call(r, t1.charAt(n), n, t1);
                    }(t1, e1, o) : function(t1, e1, r) {
                        for(var n in t1)a.call(t1, n) && (null == r ? e1(t1[n], n, t1) : e1.call(r, t1[n], n, t1));
                    }(t1, e1, o);
                };
            },
            31917: function(t1) {
                "use strict";
                var e1 = Object.prototype.toString, r = Math.max, n = function(t1, e1) {
                    for(var r = [], n = 0; n < t1.length; n += 1)r[n] = t1[n];
                    for(var i = 0; i < e1.length; i += 1)r[i + t1.length] = e1[i];
                    return r;
                };
                t1.exports = function(t1) {
                    var i = this;
                    if ("function" != typeof i || "[object Function]" !== e1.apply(i)) throw new TypeError("Function.prototype.bind called on incompatible " + i);
                    for(var a, o = function(t1, e1) {
                        for(var r = [], n = 1, i = 0; n < t1.length; n += 1, i += 1)r[i] = t1[n];
                        return r;
                    }(arguments), s = r(0, i.length - o.length), l = [], c = 0; c < s; c++)l[c] = "$" + c;
                    if (a = Function("binder", "return function (" + function(t1, e1) {
                        for(var r = "", n = 0; n < t1.length; n += 1)r += t1[n], n + 1 < t1.length && (r += ",");
                        return r;
                    }(l) + "){ return binder.apply(this,arguments); }")(function() {
                        if (this instanceof a) {
                            var e1 = i.apply(this, n(o, arguments));
                            return Object(e1) === e1 ? e1 : this;
                        }
                        return i.apply(t1, n(o, arguments));
                    }), i.prototype) {
                        var u = function() {};
                        u.prototype = i.prototype, a.prototype = new u, u.prototype = null;
                    }
                    return a;
                };
            },
            87547: function(t1, e1, r) {
                "use strict";
                var n = r(31917);
                t1.exports = Function.prototype.bind || n;
            },
            72880: function(t1) {
                t1.exports = function(t1, e1) {
                    if ("string" != typeof t1) throw new TypeError("must specify type string");
                    if (e1 = e1 || {}, "undefined" == typeof document && !e1.canvas) return null;
                    var r = e1.canvas || document.createElement("canvas");
                    "number" == typeof e1.width && (r.width = e1.width), "number" == typeof e1.height && (r.height = e1.height);
                    var n, i = e1;
                    try {
                        var a = [
                            t1
                        ];
                        0 === t1.indexOf("webgl") && a.push("experimental-" + t1);
                        for(var o = 0; o < a.length; o++)if (n = r.getContext(a[o], i)) return n;
                    } catch (t1) {
                        n = null;
                    }
                    return n || null;
                };
            },
            71129: function(t1, e1, r) {
                "use strict";
                var n, i = r(77731), a = r(35465), o = r(30582), s = r(50294), l = r(98800), c = r(48631), u = r(33149), h = Function, f = function(t1) {
                    try {
                        return h('"use strict"; return (' + t1 + ").constructor;")();
                    } catch (t1) {}
                }, p = Object.getOwnPropertyDescriptor;
                if (p) try {
                    p({}, "");
                } catch (t1) {
                    p = null;
                }
                var d = function() {
                    throw new c;
                }, m = p ? function() {
                    try {
                        return d;
                    } catch (t1) {
                        try {
                            return p(arguments, "callee").get;
                        } catch (t1) {
                            return d;
                        }
                    }
                }() : d, g = r(8771)(), y = r(58436)(), v = Object.getPrototypeOf || (y ? function(t1) {
                    return t1.__proto__;
                } : null), x = {}, _ = "undefined" != typeof Uint8Array && v ? v(Uint8Array) : n, b = {
                    __proto__: null,
                    "%AggregateError%": "undefined" == typeof AggregateError ? n : AggregateError,
                    "%Array%": Array,
                    "%ArrayBuffer%": "undefined" == typeof ArrayBuffer ? n : ArrayBuffer,
                    "%ArrayIteratorPrototype%": g && v ? v([][Symbol.iterator]()) : n,
                    "%AsyncFromSyncIteratorPrototype%": n,
                    "%AsyncFunction%": x,
                    "%AsyncGenerator%": x,
                    "%AsyncGeneratorFunction%": x,
                    "%AsyncIteratorPrototype%": x,
                    "%Atomics%": "undefined" == typeof Atomics ? n : Atomics,
                    "%BigInt%": "undefined" == typeof BigInt ? n : BigInt,
                    "%BigInt64Array%": "undefined" == typeof BigInt64Array ? n : BigInt64Array,
                    "%BigUint64Array%": "undefined" == typeof BigUint64Array ? n : BigUint64Array,
                    "%Boolean%": Boolean,
                    "%DataView%": "undefined" == typeof DataView ? n : DataView,
                    "%Date%": Date,
                    "%decodeURI%": decodeURI,
                    "%decodeURIComponent%": decodeURIComponent,
                    "%encodeURI%": encodeURI,
                    "%encodeURIComponent%": encodeURIComponent,
                    "%Error%": i,
                    "%eval%": eval,
                    "%EvalError%": a,
                    "%Float32Array%": "undefined" == typeof Float32Array ? n : Float32Array,
                    "%Float64Array%": "undefined" == typeof Float64Array ? n : Float64Array,
                    "%FinalizationRegistry%": "undefined" == typeof FinalizationRegistry ? n : FinalizationRegistry,
                    "%Function%": h,
                    "%GeneratorFunction%": x,
                    "%Int8Array%": "undefined" == typeof Int8Array ? n : Int8Array,
                    "%Int16Array%": "undefined" == typeof Int16Array ? n : Int16Array,
                    "%Int32Array%": "undefined" == typeof Int32Array ? n : Int32Array,
                    "%isFinite%": isFinite,
                    "%isNaN%": isNaN,
                    "%IteratorPrototype%": g && v ? v(v([][Symbol.iterator]())) : n,
                    "%JSON%": "object" == typeof JSON ? JSON : n,
                    "%Map%": "undefined" == typeof Map ? n : Map,
                    "%MapIteratorPrototype%": "undefined" != typeof Map && g && v ? v((new Map)[Symbol.iterator]()) : n,
                    "%Math%": Math,
                    "%Number%": Number,
                    "%Object%": Object,
                    "%parseFloat%": parseFloat,
                    "%parseInt%": parseInt,
                    "%Promise%": "undefined" == typeof Promise ? n : Promise,
                    "%Proxy%": "undefined" == typeof Proxy ? n : Proxy,
                    "%RangeError%": o,
                    "%ReferenceError%": s,
                    "%Reflect%": "undefined" == typeof Reflect ? n : Reflect,
                    "%RegExp%": RegExp,
                    "%Set%": "undefined" == typeof Set ? n : Set,
                    "%SetIteratorPrototype%": "undefined" != typeof Set && g && v ? v((new Set)[Symbol.iterator]()) : n,
                    "%SharedArrayBuffer%": "undefined" == typeof SharedArrayBuffer ? n : SharedArrayBuffer,
                    "%String%": String,
                    "%StringIteratorPrototype%": g && v ? v(""[Symbol.iterator]()) : n,
                    "%Symbol%": g ? Symbol : n,
                    "%SyntaxError%": l,
                    "%ThrowTypeError%": m,
                    "%TypedArray%": _,
                    "%TypeError%": c,
                    "%Uint8Array%": "undefined" == typeof Uint8Array ? n : Uint8Array,
                    "%Uint8ClampedArray%": "undefined" == typeof Uint8ClampedArray ? n : Uint8ClampedArray,
                    "%Uint16Array%": "undefined" == typeof Uint16Array ? n : Uint16Array,
                    "%Uint32Array%": "undefined" == typeof Uint32Array ? n : Uint32Array,
                    "%URIError%": u,
                    "%WeakMap%": "undefined" == typeof WeakMap ? n : WeakMap,
                    "%WeakRef%": "undefined" == typeof WeakRef ? n : WeakRef,
                    "%WeakSet%": "undefined" == typeof WeakSet ? n : WeakSet
                };
                if (v) try {
                    null.error;
                } catch (t1) {
                    var w = v(v(t1));
                    b["%Error.prototype%"] = w;
                }
                var T = function t1(e1) {
                    var r;
                    if ("%AsyncFunction%" === e1) r = f("async function () {}");
                    else if ("%GeneratorFunction%" === e1) r = f("function* () {}");
                    else if ("%AsyncGeneratorFunction%" === e1) r = f("async function* () {}");
                    else if ("%AsyncGenerator%" === e1) {
                        var n = t1("%AsyncGeneratorFunction%");
                        n && (r = n.prototype);
                    } else if ("%AsyncIteratorPrototype%" === e1) {
                        var i = t1("%AsyncGenerator%");
                        i && v && (r = v(i.prototype));
                    }
                    return b[e1] = r, r;
                }, k = {
                    __proto__: null,
                    "%ArrayBufferPrototype%": [
                        "ArrayBuffer",
                        "prototype"
                    ],
                    "%ArrayPrototype%": [
                        "Array",
                        "prototype"
                    ],
                    "%ArrayProto_entries%": [
                        "Array",
                        "prototype",
                        "entries"
                    ],
                    "%ArrayProto_forEach%": [
                        "Array",
                        "prototype",
                        "forEach"
                    ],
                    "%ArrayProto_keys%": [
                        "Array",
                        "prototype",
                        "keys"
                    ],
                    "%ArrayProto_values%": [
                        "Array",
                        "prototype",
                        "values"
                    ],
                    "%AsyncFunctionPrototype%": [
                        "AsyncFunction",
                        "prototype"
                    ],
                    "%AsyncGenerator%": [
                        "AsyncGeneratorFunction",
                        "prototype"
                    ],
                    "%AsyncGeneratorPrototype%": [
                        "AsyncGeneratorFunction",
                        "prototype",
                        "prototype"
                    ],
                    "%BooleanPrototype%": [
                        "Boolean",
                        "prototype"
                    ],
                    "%DataViewPrototype%": [
                        "DataView",
                        "prototype"
                    ],
                    "%DatePrototype%": [
                        "Date",
                        "prototype"
                    ],
                    "%ErrorPrototype%": [
                        "Error",
                        "prototype"
                    ],
                    "%EvalErrorPrototype%": [
                        "EvalError",
                        "prototype"
                    ],
                    "%Float32ArrayPrototype%": [
                        "Float32Array",
                        "prototype"
                    ],
                    "%Float64ArrayPrototype%": [
                        "Float64Array",
                        "prototype"
                    ],
                    "%FunctionPrototype%": [
                        "Function",
                        "prototype"
                    ],
                    "%Generator%": [
                        "GeneratorFunction",
                        "prototype"
                    ],
                    "%GeneratorPrototype%": [
                        "GeneratorFunction",
                        "prototype",
                        "prototype"
                    ],
                    "%Int8ArrayPrototype%": [
                        "Int8Array",
                        "prototype"
                    ],
                    "%Int16ArrayPrototype%": [
                        "Int16Array",
                        "prototype"
                    ],
                    "%Int32ArrayPrototype%": [
                        "Int32Array",
                        "prototype"
                    ],
                    "%JSONParse%": [
                        "JSON",
                        "parse"
                    ],
                    "%JSONStringify%": [
                        "JSON",
                        "stringify"
                    ],
                    "%MapPrototype%": [
                        "Map",
                        "prototype"
                    ],
                    "%NumberPrototype%": [
                        "Number",
                        "prototype"
                    ],
                    "%ObjectPrototype%": [
                        "Object",
                        "prototype"
                    ],
                    "%ObjProto_toString%": [
                        "Object",
                        "prototype",
                        "toString"
                    ],
                    "%ObjProto_valueOf%": [
                        "Object",
                        "prototype",
                        "valueOf"
                    ],
                    "%PromisePrototype%": [
                        "Promise",
                        "prototype"
                    ],
                    "%PromiseProto_then%": [
                        "Promise",
                        "prototype",
                        "then"
                    ],
                    "%Promise_all%": [
                        "Promise",
                        "all"
                    ],
                    "%Promise_reject%": [
                        "Promise",
                        "reject"
                    ],
                    "%Promise_resolve%": [
                        "Promise",
                        "resolve"
                    ],
                    "%RangeErrorPrototype%": [
                        "RangeError",
                        "prototype"
                    ],
                    "%ReferenceErrorPrototype%": [
                        "ReferenceError",
                        "prototype"
                    ],
                    "%RegExpPrototype%": [
                        "RegExp",
                        "prototype"
                    ],
                    "%SetPrototype%": [
                        "Set",
                        "prototype"
                    ],
                    "%SharedArrayBufferPrototype%": [
                        "SharedArrayBuffer",
                        "prototype"
                    ],
                    "%StringPrototype%": [
                        "String",
                        "prototype"
                    ],
                    "%SymbolPrototype%": [
                        "Symbol",
                        "prototype"
                    ],
                    "%SyntaxErrorPrototype%": [
                        "SyntaxError",
                        "prototype"
                    ],
                    "%TypedArrayPrototype%": [
                        "TypedArray",
                        "prototype"
                    ],
                    "%TypeErrorPrototype%": [
                        "TypeError",
                        "prototype"
                    ],
                    "%Uint8ArrayPrototype%": [
                        "Uint8Array",
                        "prototype"
                    ],
                    "%Uint8ClampedArrayPrototype%": [
                        "Uint8ClampedArray",
                        "prototype"
                    ],
                    "%Uint16ArrayPrototype%": [
                        "Uint16Array",
                        "prototype"
                    ],
                    "%Uint32ArrayPrototype%": [
                        "Uint32Array",
                        "prototype"
                    ],
                    "%URIErrorPrototype%": [
                        "URIError",
                        "prototype"
                    ],
                    "%WeakMapPrototype%": [
                        "WeakMap",
                        "prototype"
                    ],
                    "%WeakSetPrototype%": [
                        "WeakSet",
                        "prototype"
                    ]
                }, A = r(87547), M = r(80753), S = A.call(Function.call, Array.prototype.concat), E = A.call(Function.apply, Array.prototype.splice), C = A.call(Function.call, String.prototype.replace), L = A.call(Function.call, String.prototype.slice), I = A.call(Function.call, RegExp.prototype.exec), P = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, z = /\\(\\)?/g, O = function(t1, e1) {
                    var r, n = t1;
                    if (M(k, n) && (n = "%" + (r = k[n])[0] + "%"), M(b, n)) {
                        var i = b[n];
                        if (i === x && (i = T(n)), void 0 === i && !e1) throw new c("intrinsic " + t1 + " exists, but is not available. Please file an issue!");
                        return {
                            alias: r,
                            name: n,
                            value: i
                        };
                    }
                    throw new l("intrinsic " + t1 + " does not exist!");
                };
                t1.exports = function(t1, e1) {
                    if ("string" != typeof t1 || 0 === t1.length) throw new c("intrinsic name must be a non-empty string");
                    if (arguments.length > 1 && "boolean" != typeof e1) throw new c('"allowMissing" argument must be a boolean');
                    if (null === I(/^%?[^%]*%?$/, t1)) throw new l("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
                    var r = function(t1) {
                        var e1 = L(t1, 0, 1), r = L(t1, -1);
                        if ("%" === e1 && "%" !== r) throw new l("invalid intrinsic syntax, expected closing `%`");
                        if ("%" === r && "%" !== e1) throw new l("invalid intrinsic syntax, expected opening `%`");
                        var n = [];
                        return C(t1, P, function(t1, e1, r, i) {
                            n[n.length] = r ? C(i, z, "$1") : e1 || t1;
                        }), n;
                    }(t1), n = r.length > 0 ? r[0] : "", i = O("%" + n + "%", e1), a = i.name, o = i.value, s = !1, u = i.alias;
                    u && (n = u[0], E(r, S([
                        0,
                        1
                    ], u)));
                    for(var h = 1, f = !0; h < r.length; h += 1){
                        var d = r[h], m = L(d, 0, 1), g = L(d, -1);
                        if (('"' === m || "'" === m || "`" === m || '"' === g || "'" === g || "`" === g) && m !== g) throw new l("property names with quotes must have matching quotes");
                        if ("constructor" !== d && f || (s = !0), M(b, a = "%" + (n += "." + d) + "%")) o = b[a];
                        else if (null != o) {
                            if (!(d in o)) {
                                if (!e1) throw new c("base intrinsic for " + t1 + " exists, but the property is not available.");
                                return;
                            }
                            if (p && h + 1 >= r.length) {
                                var y = p(o, d);
                                o = (f = !!y) && "get" in y && !("originalValue" in y.get) ? y.get : o[d];
                            } else f = M(o, d), o = o[d];
                            f && !s && (b[a] = o);
                        }
                    }
                    return o;
                };
            },
            84840: function(t1) {
                t1.exports = function(t1, e1) {
                    var r = e1[0], n = e1[1], i = e1[2], a = e1[3], o = e1[4], s = e1[5], l = e1[6], c = e1[7], u = e1[8], h = e1[9], f = e1[10], p = e1[11], d = e1[12], m = e1[13], g = e1[14], y = e1[15];
                    return t1[0] = s * (f * y - p * g) - h * (l * y - c * g) + m * (l * p - c * f), t1[1] = -(n * (f * y - p * g) - h * (i * y - a * g) + m * (i * p - a * f)), t1[2] = n * (l * y - c * g) - s * (i * y - a * g) + m * (i * c - a * l), t1[3] = -(n * (l * p - c * f) - s * (i * p - a * f) + h * (i * c - a * l)), t1[4] = -(o * (f * y - p * g) - u * (l * y - c * g) + d * (l * p - c * f)), t1[5] = r * (f * y - p * g) - u * (i * y - a * g) + d * (i * p - a * f), t1[6] = -(r * (l * y - c * g) - o * (i * y - a * g) + d * (i * c - a * l)), t1[7] = r * (l * p - c * f) - o * (i * p - a * f) + u * (i * c - a * l), t1[8] = o * (h * y - p * m) - u * (s * y - c * m) + d * (s * p - c * h), t1[9] = -(r * (h * y - p * m) - u * (n * y - a * m) + d * (n * p - a * h)), t1[10] = r * (s * y - c * m) - o * (n * y - a * m) + d * (n * c - a * s), t1[11] = -(r * (s * p - c * h) - o * (n * p - a * h) + u * (n * c - a * s)), t1[12] = -(o * (h * g - f * m) - u * (s * g - l * m) + d * (s * f - l * h)), t1[13] = r * (h * g - f * m) - u * (n * g - i * m) + d * (n * f - i * h), t1[14] = -(r * (s * g - l * m) - o * (n * g - i * m) + d * (n * l - i * s)), t1[15] = r * (s * f - l * h) - o * (n * f - i * h) + u * (n * l - i * s), t1;
                };
            },
            99698: function(t1) {
                t1.exports = function(t1) {
                    var e1 = new Float32Array(16);
                    return e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1[3] = t1[3], e1[4] = t1[4], e1[5] = t1[5], e1[6] = t1[6], e1[7] = t1[7], e1[8] = t1[8], e1[9] = t1[9], e1[10] = t1[10], e1[11] = t1[11], e1[12] = t1[12], e1[13] = t1[13], e1[14] = t1[14], e1[15] = t1[15], e1;
                };
            },
            57938: function(t1) {
                t1.exports = function(t1, e1) {
                    return t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1[3] = e1[3], t1[4] = e1[4], t1[5] = e1[5], t1[6] = e1[6], t1[7] = e1[7], t1[8] = e1[8], t1[9] = e1[9], t1[10] = e1[10], t1[11] = e1[11], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15], t1;
                };
            },
            87519: function(t1) {
                t1.exports = function() {
                    var t1 = new Float32Array(16);
                    return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = 1, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 1, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
                };
            },
            6900: function(t1) {
                t1.exports = function(t1) {
                    var e1 = t1[0], r = t1[1], n = t1[2], i = t1[3], a = t1[4], o = t1[5], s = t1[6], l = t1[7], c = t1[8], u = t1[9], h = t1[10], f = t1[11], p = t1[12], d = t1[13], m = t1[14], g = t1[15];
                    return (e1 * o - r * a) * (h * g - f * m) - (e1 * s - n * a) * (u * g - f * d) + (e1 * l - i * a) * (u * m - h * d) + (r * s - n * o) * (c * g - f * p) - (r * l - i * o) * (c * m - h * p) + (n * l - i * s) * (c * d - u * p);
                };
            },
            36472: function(t1) {
                t1.exports = function(t1, e1) {
                    var r = e1[0], n = e1[1], i = e1[2], a = e1[3], o = r + r, s = n + n, l = i + i, c = r * o, u = n * o, h = n * s, f = i * o, p = i * s, d = i * l, m = a * o, g = a * s, y = a * l;
                    return t1[0] = 1 - h - d, t1[1] = u + y, t1[2] = f - g, t1[3] = 0, t1[4] = u - y, t1[5] = 1 - c - d, t1[6] = p + m, t1[7] = 0, t1[8] = f + g, t1[9] = p - m, t1[10] = 1 - c - h, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
                };
            },
            43061: function(t1) {
                t1.exports = function(t1, e1, r) {
                    var n, i, a, o = r[0], s = r[1], l = r[2], c = Math.sqrt(o * o + s * s + l * l);
                    return Math.abs(c) < 1e-6 ? null : (o *= c = 1 / c, s *= c, l *= c, n = Math.sin(e1), a = 1 - (i = Math.cos(e1)), t1[0] = o * o * a + i, t1[1] = s * o * a + l * n, t1[2] = l * o * a - s * n, t1[3] = 0, t1[4] = o * s * a - l * n, t1[5] = s * s * a + i, t1[6] = l * s * a + o * n, t1[7] = 0, t1[8] = o * l * a + s * n, t1[9] = s * l * a - o * n, t1[10] = l * l * a + i, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1);
                };
            },
            33606: function(t1) {
                t1.exports = function(t1, e1, r) {
                    var n = e1[0], i = e1[1], a = e1[2], o = e1[3], s = n + n, l = i + i, c = a + a, u = n * s, h = n * l, f = n * c, p = i * l, d = i * c, m = a * c, g = o * s, y = o * l, v = o * c;
                    return t1[0] = 1 - (p + m), t1[1] = h + v, t1[2] = f - y, t1[3] = 0, t1[4] = h - v, t1[5] = 1 - (u + m), t1[6] = d + g, t1[7] = 0, t1[8] = f + y, t1[9] = d - g, t1[10] = 1 - (u + p), t1[11] = 0, t1[12] = r[0], t1[13] = r[1], t1[14] = r[2], t1[15] = 1, t1;
                };
            },
            98698: function(t1) {
                t1.exports = function(t1, e1) {
                    return t1[0] = e1[0], t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = e1[1], t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = e1[2], t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
                };
            },
            6924: function(t1) {
                t1.exports = function(t1, e1) {
                    return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = 1, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 1, t1[11] = 0, t1[12] = e1[0], t1[13] = e1[1], t1[14] = e1[2], t1[15] = 1, t1;
                };
            },
            81181: function(t1) {
                t1.exports = function(t1, e1) {
                    var r = Math.sin(e1), n = Math.cos(e1);
                    return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = n, t1[6] = r, t1[7] = 0, t1[8] = 0, t1[9] = -r, t1[10] = n, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
                };
            },
            95258: function(t1) {
                t1.exports = function(t1, e1) {
                    var r = Math.sin(e1), n = Math.cos(e1);
                    return t1[0] = n, t1[1] = 0, t1[2] = -r, t1[3] = 0, t1[4] = 0, t1[5] = 1, t1[6] = 0, t1[7] = 0, t1[8] = r, t1[9] = 0, t1[10] = n, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
                };
            },
            94815: function(t1) {
                t1.exports = function(t1, e1) {
                    var r = Math.sin(e1), n = Math.cos(e1);
                    return t1[0] = n, t1[1] = r, t1[2] = 0, t1[3] = 0, t1[4] = -r, t1[5] = n, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 1, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
                };
            },
            87301: function(t1) {
                t1.exports = function(t1, e1, r, n, i, a, o) {
                    var s = 1 / (r - e1), l = 1 / (i - n), c = 1 / (a - o);
                    return t1[0] = 2 * a * s, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = 2 * a * l, t1[6] = 0, t1[7] = 0, t1[8] = (r + e1) * s, t1[9] = (i + n) * l, t1[10] = (o + a) * c, t1[11] = -1, t1[12] = 0, t1[13] = 0, t1[14] = o * a * 2 * c, t1[15] = 0, t1;
                };
            },
            87193: function(t1) {
                t1.exports = function(t1) {
                    return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = 1, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 1, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
                };
            },
            11191: function(t1, e1, r) {
                t1.exports = {
                    create: r(87519),
                    clone: r(99698),
                    copy: r(57938),
                    identity: r(87193),
                    transpose: r(10256),
                    invert: r(96559),
                    adjoint: r(84840),
                    determinant: r(6900),
                    multiply: r(14787),
                    translate: r(4165),
                    scale: r(8697),
                    rotate: r(32416),
                    rotateX: r(81066),
                    rotateY: r(54201),
                    rotateZ: r(33920),
                    fromRotation: r(43061),
                    fromRotationTranslation: r(33606),
                    fromScaling: r(98698),
                    fromTranslation: r(6924),
                    fromXRotation: r(81181),
                    fromYRotation: r(95258),
                    fromZRotation: r(94815),
                    fromQuat: r(36472),
                    frustum: r(87301),
                    perspective: r(5313),
                    perspectiveFromFieldOfView: r(22253),
                    ortho: r(4633),
                    lookAt: r(26645),
                    str: r(66992)
                };
            },
            96559: function(t1) {
                t1.exports = function(t1, e1) {
                    var r = e1[0], n = e1[1], i = e1[2], a = e1[3], o = e1[4], s = e1[5], l = e1[6], c = e1[7], u = e1[8], h = e1[9], f = e1[10], p = e1[11], d = e1[12], m = e1[13], g = e1[14], y = e1[15], v = r * s - n * o, x = r * l - i * o, _ = r * c - a * o, b = n * l - i * s, w = n * c - a * s, T = i * c - a * l, k = u * m - h * d, A = u * g - f * d, M = u * y - p * d, S = h * g - f * m, E = h * y - p * m, C = f * y - p * g, L = v * C - x * E + _ * S + b * M - w * A + T * k;
                    return L ? (L = 1 / L, t1[0] = (s * C - l * E + c * S) * L, t1[1] = (i * E - n * C - a * S) * L, t1[2] = (m * T - g * w + y * b) * L, t1[3] = (f * w - h * T - p * b) * L, t1[4] = (l * M - o * C - c * A) * L, t1[5] = (r * C - i * M + a * A) * L, t1[6] = (g * _ - d * T - y * x) * L, t1[7] = (u * T - f * _ + p * x) * L, t1[8] = (o * E - s * M + c * k) * L, t1[9] = (n * M - r * E - a * k) * L, t1[10] = (d * w - m * _ + y * v) * L, t1[11] = (h * _ - u * w - p * v) * L, t1[12] = (s * A - o * S - l * k) * L, t1[13] = (r * S - n * A + i * k) * L, t1[14] = (m * x - d * b - g * v) * L, t1[15] = (u * b - h * x + f * v) * L, t1) : null;
                };
            },
            26645: function(t1, e1, r) {
                var n = r(87193);
                t1.exports = function(t1, e1, r, i) {
                    var a, o, s, l, c, u, h, f, p, d, m = e1[0], g = e1[1], y = e1[2], v = i[0], x = i[1], _ = i[2], b = r[0], w = r[1], T = r[2];
                    return Math.abs(m - b) < 1e-6 && Math.abs(g - w) < 1e-6 && Math.abs(y - T) < 1e-6 ? n(t1) : (h = m - b, f = g - w, p = y - T, a = x * (p *= d = 1 / Math.sqrt(h * h + f * f + p * p)) - _ * (f *= d), o = _ * (h *= d) - v * p, s = v * f - x * h, (d = Math.sqrt(a * a + o * o + s * s)) ? (a *= d = 1 / d, o *= d, s *= d) : (a = 0, o = 0, s = 0), l = f * s - p * o, c = p * a - h * s, u = h * o - f * a, (d = Math.sqrt(l * l + c * c + u * u)) ? (l *= d = 1 / d, c *= d, u *= d) : (l = 0, c = 0, u = 0), t1[0] = a, t1[1] = l, t1[2] = h, t1[3] = 0, t1[4] = o, t1[5] = c, t1[6] = f, t1[7] = 0, t1[8] = s, t1[9] = u, t1[10] = p, t1[11] = 0, t1[12] = -(a * m + o * g + s * y), t1[13] = -(l * m + c * g + u * y), t1[14] = -(h * m + f * g + p * y), t1[15] = 1, t1);
                };
            },
            14787: function(t1) {
                t1.exports = function(t1, e1, r) {
                    var n = e1[0], i = e1[1], a = e1[2], o = e1[3], s = e1[4], l = e1[5], c = e1[6], u = e1[7], h = e1[8], f = e1[9], p = e1[10], d = e1[11], m = e1[12], g = e1[13], y = e1[14], v = e1[15], x = r[0], _ = r[1], b = r[2], w = r[3];
                    return t1[0] = x * n + _ * s + b * h + w * m, t1[1] = x * i + _ * l + b * f + w * g, t1[2] = x * a + _ * c + b * p + w * y, t1[3] = x * o + _ * u + b * d + w * v, x = r[4], _ = r[5], b = r[6], w = r[7], t1[4] = x * n + _ * s + b * h + w * m, t1[5] = x * i + _ * l + b * f + w * g, t1[6] = x * a + _ * c + b * p + w * y, t1[7] = x * o + _ * u + b * d + w * v, x = r[8], _ = r[9], b = r[10], w = r[11], t1[8] = x * n + _ * s + b * h + w * m, t1[9] = x * i + _ * l + b * f + w * g, t1[10] = x * a + _ * c + b * p + w * y, t1[11] = x * o + _ * u + b * d + w * v, x = r[12], _ = r[13], b = r[14], w = r[15], t1[12] = x * n + _ * s + b * h + w * m, t1[13] = x * i + _ * l + b * f + w * g, t1[14] = x * a + _ * c + b * p + w * y, t1[15] = x * o + _ * u + b * d + w * v, t1;
                };
            },
            4633: function(t1) {
                t1.exports = function(t1, e1, r, n, i, a, o) {
                    var s = 1 / (e1 - r), l = 1 / (n - i), c = 1 / (a - o);
                    return t1[0] = -2 * s, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = -2 * l, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 2 * c, t1[11] = 0, t1[12] = (e1 + r) * s, t1[13] = (i + n) * l, t1[14] = (o + a) * c, t1[15] = 1, t1;
                };
            },
            5313: function(t1) {
                t1.exports = function(t1, e1, r, n, i) {
                    var a = 1 / Math.tan(e1 / 2), o = 1 / (n - i);
                    return t1[0] = a / r, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = a, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = (i + n) * o, t1[11] = -1, t1[12] = 0, t1[13] = 0, t1[14] = 2 * i * n * o, t1[15] = 0, t1;
                };
            },
            22253: function(t1) {
                t1.exports = function(t1, e1, r, n) {
                    var i = Math.tan(e1.upDegrees * Math.PI / 180), a = Math.tan(e1.downDegrees * Math.PI / 180), o = Math.tan(e1.leftDegrees * Math.PI / 180), s = Math.tan(e1.rightDegrees * Math.PI / 180), l = 2 / (o + s), c = 2 / (i + a);
                    return t1[0] = l, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = c, t1[6] = 0, t1[7] = 0, t1[8] = -(o - s) * l * .5, t1[9] = (i - a) * c * .5, t1[10] = n / (r - n), t1[11] = -1, t1[12] = 0, t1[13] = 0, t1[14] = n * r / (r - n), t1[15] = 0, t1;
                };
            },
            32416: function(t1) {
                t1.exports = function(t1, e1, r, n) {
                    var i, a, o, s, l, c, u, h, f, p, d, m, g, y, v, x, _, b, w, T, k, A, M, S, E = n[0], C = n[1], L = n[2], I = Math.sqrt(E * E + C * C + L * L);
                    return Math.abs(I) < 1e-6 ? null : (E *= I = 1 / I, C *= I, L *= I, i = Math.sin(r), o = 1 - (a = Math.cos(r)), s = e1[0], l = e1[1], c = e1[2], u = e1[3], h = e1[4], f = e1[5], p = e1[6], d = e1[7], m = e1[8], g = e1[9], y = e1[10], v = e1[11], x = E * E * o + a, _ = C * E * o + L * i, b = L * E * o - C * i, w = E * C * o - L * i, T = C * C * o + a, k = L * C * o + E * i, A = E * L * o + C * i, M = C * L * o - E * i, S = L * L * o + a, t1[0] = s * x + h * _ + m * b, t1[1] = l * x + f * _ + g * b, t1[2] = c * x + p * _ + y * b, t1[3] = u * x + d * _ + v * b, t1[4] = s * w + h * T + m * k, t1[5] = l * w + f * T + g * k, t1[6] = c * w + p * T + y * k, t1[7] = u * w + d * T + v * k, t1[8] = s * A + h * M + m * S, t1[9] = l * A + f * M + g * S, t1[10] = c * A + p * M + y * S, t1[11] = u * A + d * M + v * S, e1 !== t1 && (t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]), t1);
                };
            },
            81066: function(t1) {
                t1.exports = function(t1, e1, r) {
                    var n = Math.sin(r), i = Math.cos(r), a = e1[4], o = e1[5], s = e1[6], l = e1[7], c = e1[8], u = e1[9], h = e1[10], f = e1[11];
                    return e1 !== t1 && (t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1[3] = e1[3], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]), t1[4] = a * i + c * n, t1[5] = o * i + u * n, t1[6] = s * i + h * n, t1[7] = l * i + f * n, t1[8] = c * i - a * n, t1[9] = u * i - o * n, t1[10] = h * i - s * n, t1[11] = f * i - l * n, t1;
                };
            },
            54201: function(t1) {
                t1.exports = function(t1, e1, r) {
                    var n = Math.sin(r), i = Math.cos(r), a = e1[0], o = e1[1], s = e1[2], l = e1[3], c = e1[8], u = e1[9], h = e1[10], f = e1[11];
                    return e1 !== t1 && (t1[4] = e1[4], t1[5] = e1[5], t1[6] = e1[6], t1[7] = e1[7], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]), t1[0] = a * i - c * n, t1[1] = o * i - u * n, t1[2] = s * i - h * n, t1[3] = l * i - f * n, t1[8] = a * n + c * i, t1[9] = o * n + u * i, t1[10] = s * n + h * i, t1[11] = l * n + f * i, t1;
                };
            },
            33920: function(t1) {
                t1.exports = function(t1, e1, r) {
                    var n = Math.sin(r), i = Math.cos(r), a = e1[0], o = e1[1], s = e1[2], l = e1[3], c = e1[4], u = e1[5], h = e1[6], f = e1[7];
                    return e1 !== t1 && (t1[8] = e1[8], t1[9] = e1[9], t1[10] = e1[10], t1[11] = e1[11], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]), t1[0] = a * i + c * n, t1[1] = o * i + u * n, t1[2] = s * i + h * n, t1[3] = l * i + f * n, t1[4] = c * i - a * n, t1[5] = u * i - o * n, t1[6] = h * i - s * n, t1[7] = f * i - l * n, t1;
                };
            },
            8697: function(t1) {
                t1.exports = function(t1, e1, r) {
                    var n = r[0], i = r[1], a = r[2];
                    return t1[0] = e1[0] * n, t1[1] = e1[1] * n, t1[2] = e1[2] * n, t1[3] = e1[3] * n, t1[4] = e1[4] * i, t1[5] = e1[5] * i, t1[6] = e1[6] * i, t1[7] = e1[7] * i, t1[8] = e1[8] * a, t1[9] = e1[9] * a, t1[10] = e1[10] * a, t1[11] = e1[11] * a, t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15], t1;
                };
            },
            66992: function(t1) {
                t1.exports = function(t1) {
                    return "mat4(" + t1[0] + ", " + t1[1] + ", " + t1[2] + ", " + t1[3] + ", " + t1[4] + ", " + t1[5] + ", " + t1[6] + ", " + t1[7] + ", " + t1[8] + ", " + t1[9] + ", " + t1[10] + ", " + t1[11] + ", " + t1[12] + ", " + t1[13] + ", " + t1[14] + ", " + t1[15] + ")";
                };
            },
            4165: function(t1) {
                t1.exports = function(t1, e1, r) {
                    var n, i, a, o, s, l, c, u, h, f, p, d, m = r[0], g = r[1], y = r[2];
                    return e1 === t1 ? (t1[12] = e1[0] * m + e1[4] * g + e1[8] * y + e1[12], t1[13] = e1[1] * m + e1[5] * g + e1[9] * y + e1[13], t1[14] = e1[2] * m + e1[6] * g + e1[10] * y + e1[14], t1[15] = e1[3] * m + e1[7] * g + e1[11] * y + e1[15]) : (n = e1[0], i = e1[1], a = e1[2], o = e1[3], s = e1[4], l = e1[5], c = e1[6], u = e1[7], h = e1[8], f = e1[9], p = e1[10], d = e1[11], t1[0] = n, t1[1] = i, t1[2] = a, t1[3] = o, t1[4] = s, t1[5] = l, t1[6] = c, t1[7] = u, t1[8] = h, t1[9] = f, t1[10] = p, t1[11] = d, t1[12] = n * m + s * g + h * y + e1[12], t1[13] = i * m + l * g + f * y + e1[13], t1[14] = a * m + c * g + p * y + e1[14], t1[15] = o * m + u * g + d * y + e1[15]), t1;
                };
            },
            10256: function(t1) {
                t1.exports = function(t1, e1) {
                    if (t1 === e1) {
                        var r = e1[1], n = e1[2], i = e1[3], a = e1[6], o = e1[7], s = e1[11];
                        t1[1] = e1[4], t1[2] = e1[8], t1[3] = e1[12], t1[4] = r, t1[6] = e1[9], t1[7] = e1[13], t1[8] = n, t1[9] = a, t1[11] = e1[14], t1[12] = i, t1[13] = o, t1[14] = s;
                    } else t1[0] = e1[0], t1[1] = e1[4], t1[2] = e1[8], t1[3] = e1[12], t1[4] = e1[1], t1[5] = e1[5], t1[6] = e1[9], t1[7] = e1[13], t1[8] = e1[2], t1[9] = e1[6], t1[10] = e1[10], t1[11] = e1[14], t1[12] = e1[3], t1[13] = e1[7], t1[14] = e1[11], t1[15] = e1[15];
                    return t1;
                };
            },
            74024: function(t1, e1, r) {
                "use strict";
                var n = r(59518), i = r(6807), a = r(81330), o = r(38862), s = r(93103), l = r(162), c = r(68950), u = r(66127), h = r(5137), f = r(29388), p = r(4957), d = r(44626), m = r(44431), g = r(27976), y = r(12673), v = r(83473), x = r(54689).nextPow2, _ = new s, b = !1;
                if (document.body) {
                    var w = document.body.appendChild(document.createElement("div"));
                    w.style.font = "italic small-caps bold condensed 16px/2 cursive", getComputedStyle(w).fontStretch && (b = !0), document.body.removeChild(w);
                }
                var T = function(t1) {
                    !function(t1) {
                        return "function" == typeof t1 && t1._gl && t1.prop && t1.texture && t1.buffer;
                    }(t1) ? this.gl = o(t1) : (t1 = {
                        regl: t1
                    }, this.gl = t1.regl._gl), this.shader = _.get(this.gl), this.shader ? this.regl = this.shader.regl : this.regl = t1.regl || a({
                        gl: this.gl
                    }), this.charBuffer = this.regl.buffer({
                        type: "uint8",
                        usage: "stream"
                    }), this.sizeBuffer = this.regl.buffer({
                        type: "float",
                        usage: "stream"
                    }), this.shader || (this.shader = this.createShader(), _.set(this.gl, this.shader)), this.batch = [], this.fontSize = [], this.font = [], this.fontAtlas = [], this.draw = this.shader.draw.bind(this), this.render = function() {
                        this.regl._refresh(), this.draw(this.batch);
                    }, this.canvas = this.gl.canvas, this.update(f(t1) ? t1 : {});
                };
                T.prototype.createShader = function() {
                    var t1 = this.regl, e1 = t1({
                        blend: {
                            enable: !0,
                            color: [
                                0,
                                0,
                                0,
                                1
                            ],
                            func: {
                                srcRGB: "src alpha",
                                dstRGB: "one minus src alpha",
                                srcAlpha: "one minus dst alpha",
                                dstAlpha: "one"
                            }
                        },
                        stencil: {
                            enable: !1
                        },
                        depth: {
                            enable: !1
                        },
                        count: t1.prop("count"),
                        offset: t1.prop("offset"),
                        attributes: {
                            charOffset: {
                                offset: 4,
                                stride: 8,
                                buffer: t1.this("sizeBuffer")
                            },
                            width: {
                                offset: 0,
                                stride: 8,
                                buffer: t1.this("sizeBuffer")
                            },
                            char: t1.this("charBuffer"),
                            position: t1.this("position")
                        },
                        uniforms: {
                            atlasSize: function(t1, e1) {
                                return [
                                    e1.atlas.width,
                                    e1.atlas.height
                                ];
                            },
                            atlasDim: function(t1, e1) {
                                return [
                                    e1.atlas.cols,
                                    e1.atlas.rows
                                ];
                            },
                            atlas: function(t1, e1) {
                                return e1.atlas.texture;
                            },
                            charStep: function(t1, e1) {
                                return e1.atlas.step;
                            },
                            em: function(t1, e1) {
                                return e1.atlas.em;
                            },
                            color: t1.prop("color"),
                            opacity: t1.prop("opacity"),
                            viewport: t1.this("viewportArray"),
                            scale: t1.this("scale"),
                            align: t1.prop("align"),
                            baseline: t1.prop("baseline"),
                            translate: t1.this("translate"),
                            positionOffset: t1.prop("positionOffset")
                        },
                        primitive: "points",
                        viewport: t1.this("viewport"),
                        vert: "\n			precision highp float;\n			attribute float width, charOffset, char;\n			attribute vec2 position;\n			uniform float fontSize, charStep, em, align, baseline;\n			uniform vec4 viewport;\n			uniform vec4 color;\n			uniform vec2 atlasSize, atlasDim, scale, translate, positionOffset;\n			varying vec2 charCoord, charId;\n			varying float charWidth;\n			varying vec4 fontColor;\n			void main () {\n				vec2 offset = floor(em * (vec2(align + charOffset, baseline)\n					+ vec2(positionOffset.x, -positionOffset.y)))\n					/ (viewport.zw * scale.xy);\n\n				vec2 position = (position + translate) * scale;\n				position += offset * scale;\n\n				charCoord = position * viewport.zw + viewport.xy;\n\n				gl_Position = vec4(position * 2. - 1., 0, 1);\n\n				gl_PointSize = charStep;\n\n				charId.x = mod(char, atlasDim.x);\n				charId.y = floor(char / atlasDim.x);\n\n				charWidth = width * em;\n\n				fontColor = color / 255.;\n			}",
                        frag: "\n			precision highp float;\n			uniform float fontSize, charStep, opacity;\n			uniform vec2 atlasSize;\n			uniform vec4 viewport;\n			uniform sampler2D atlas;\n			varying vec4 fontColor;\n			varying vec2 charCoord, charId;\n			varying float charWidth;\n\n			float lightness(vec4 color) {\n				return color.r * 0.299 + color.g * 0.587 + color.b * 0.114;\n			}\n\n			void main () {\n				vec2 uv = gl_FragCoord.xy - charCoord + charStep * .5;\n				float halfCharStep = floor(charStep * .5 + .5);\n\n				// invert y and shift by 1px (FF expecially needs that)\n				uv.y = charStep - uv.y;\n\n				// ignore points outside of character bounding box\n				float halfCharWidth = ceil(charWidth * .5);\n				if (floor(uv.x) > halfCharStep + halfCharWidth ||\n					floor(uv.x) < halfCharStep - halfCharWidth) return;\n\n				uv += charId * charStep;\n				uv = uv / atlasSize;\n\n				vec4 color = fontColor;\n				vec4 mask = texture2D(atlas, uv);\n\n				float maskY = lightness(mask);\n				// float colorY = lightness(color);\n				color.a *= maskY;\n				color.a *= opacity;\n\n				// color.a += .1;\n\n				// antialiasing, see yiq color space y-channel formula\n				// color.rgb += (1. - color.rgb) * (1. - mask.rgb);\n\n				gl_FragColor = color;\n			}"
                    });
                    return {
                        regl: t1,
                        draw: e1,
                        atlas: {}
                    };
                }, T.prototype.update = function(t1) {
                    var e1 = this;
                    if ("string" == typeof t1) t1 = {
                        text: t1
                    };
                    else if (!t1) return;
                    null != (t1 = i(t1, {
                        position: "position positions coord coords coordinates",
                        font: "font fontFace fontface typeface cssFont css-font family fontFamily",
                        fontSize: "fontSize fontsize size font-size",
                        text: "text texts chars characters value values symbols",
                        align: "align alignment textAlign textbaseline",
                        baseline: "baseline textBaseline textbaseline",
                        direction: "dir direction textDirection",
                        color: "color colour fill fill-color fillColor textColor textcolor",
                        kerning: "kerning kern",
                        range: "range dataBox",
                        viewport: "vp viewport viewBox viewbox viewPort",
                        opacity: "opacity alpha transparency visible visibility opaque",
                        offset: "offset positionOffset padding shift indent indentation"
                    }, !0)).opacity && (Array.isArray(t1.opacity) ? this.opacity = t1.opacity.map(function(t1) {
                        return parseFloat(t1);
                    }) : this.opacity = parseFloat(t1.opacity)), null != t1.viewport && (this.viewport = h(t1.viewport), this.viewportArray = [
                        this.viewport.x,
                        this.viewport.y,
                        this.viewport.width,
                        this.viewport.height
                    ]), null == this.viewport && (this.viewport = {
                        x: 0,
                        y: 0,
                        width: this.gl.drawingBufferWidth,
                        height: this.gl.drawingBufferHeight
                    }, this.viewportArray = [
                        this.viewport.x,
                        this.viewport.y,
                        this.viewport.width,
                        this.viewport.height
                    ]), null != t1.kerning && (this.kerning = t1.kerning), null != t1.offset && ("number" == typeof t1.offset && (t1.offset = [
                        t1.offset,
                        0
                    ]), this.positionOffset = v(t1.offset)), t1.direction && (this.direction = t1.direction), t1.range && (this.range = t1.range, this.scale = [
                        1 / (t1.range[2] - t1.range[0]),
                        1 / (t1.range[3] - t1.range[1])
                    ], this.translate = [
                        -t1.range[0],
                        -t1.range[1]
                    ]), t1.scale && (this.scale = t1.scale), t1.translate && (this.translate = t1.translate), this.scale || (this.scale = [
                        1 / this.viewport.width,
                        1 / this.viewport.height
                    ]), this.translate || (this.translate = [
                        0,
                        0
                    ]), this.font.length || t1.font || (t1.font = T.baseFontSize + "px sans-serif");
                    var r, a = !1, o = !1;
                    if (t1.font && (Array.isArray(t1.font) ? t1.font : [
                        t1.font
                    ]).forEach(function(t1, r) {
                        if ("string" == typeof t1) try {
                            t1 = n.parse(t1);
                        } catch (e1) {
                            t1 = n.parse(T.baseFontSize + "px " + t1);
                        }
                        else {
                            var i = t1.style, s = t1.weight, l = t1.stretch, c = t1.variant;
                            t1 = n.parse(n.stringify(t1)), i && (t1.style = i), s && (t1.weight = s), l && (t1.stretch = l), c && (t1.variant = c);
                        }
                        var u = n.stringify({
                            size: T.baseFontSize,
                            family: t1.family,
                            stretch: b ? t1.stretch : void 0,
                            variant: t1.variant,
                            weight: t1.weight,
                            style: t1.style
                        }), h = p(t1.size), f = Math.round(h[0] * d(h[1]));
                        if (f !== e1.fontSize[r] && (o = !0, e1.fontSize[r] = f), !(e1.font[r] && u == e1.font[r].baseString || (a = !0, e1.font[r] = T.fonts[u], e1.font[r]))) {
                            var m = t1.family.join(", "), g = [
                                t1.style
                            ];
                            t1.style != t1.variant && g.push(t1.variant), t1.variant != t1.weight && g.push(t1.weight), b && t1.weight != t1.stretch && g.push(t1.stretch), e1.font[r] = {
                                baseString: u,
                                family: m,
                                weight: t1.weight,
                                stretch: t1.stretch,
                                style: t1.style,
                                variant: t1.variant,
                                width: {},
                                kerning: {},
                                metrics: y(m, {
                                    origin: "top",
                                    fontSize: T.baseFontSize,
                                    fontStyle: g.join(" ")
                                })
                            }, T.fonts[u] = e1.font[r];
                        }
                    }), (a || o) && this.font.forEach(function(r, i) {
                        var a = n.stringify({
                            size: e1.fontSize[i],
                            family: r.family,
                            stretch: b ? r.stretch : void 0,
                            variant: r.variant,
                            weight: r.weight,
                            style: r.style
                        });
                        if (e1.fontAtlas[i] = e1.shader.atlas[a], !e1.fontAtlas[i]) {
                            var o = r.metrics;
                            e1.shader.atlas[a] = e1.fontAtlas[i] = {
                                fontString: a,
                                step: 2 * Math.ceil(e1.fontSize[i] * o.bottom * .5),
                                em: e1.fontSize[i],
                                cols: 0,
                                rows: 0,
                                height: 0,
                                width: 0,
                                chars: [],
                                ids: {},
                                texture: e1.regl.texture()
                            };
                        }
                        null == t1.text && (t1.text = e1.text);
                    }), "string" == typeof t1.text && t1.position && t1.position.length > 2) {
                        for(var s = Array(.5 * t1.position.length), f = 0; f < s.length; f++)s[f] = t1.text;
                        t1.text = s;
                    }
                    if (null != t1.text || a) {
                        if (this.textOffsets = [
                            0
                        ], Array.isArray(t1.text)) {
                            this.count = t1.text[0].length, this.counts = [
                                this.count
                            ];
                            for(var _ = 1; _ < t1.text.length; _++)this.textOffsets[_] = this.textOffsets[_ - 1] + t1.text[_ - 1].length, this.count += t1.text[_].length, this.counts.push(t1.text[_].length);
                            this.text = t1.text.join("");
                        } else this.text = t1.text, this.count = this.text.length, this.counts = [
                            this.count
                        ];
                        r = [], this.font.forEach(function(t1, n) {
                            T.atlasContext.font = t1.baseString;
                            for(var i = e1.fontAtlas[n], a = 0; a < e1.text.length; a++){
                                var o = e1.text.charAt(a);
                                if (null == i.ids[o] && (i.ids[o] = i.chars.length, i.chars.push(o), r.push(o)), null == t1.width[o] && (t1.width[o] = T.atlasContext.measureText(o).width / T.baseFontSize, e1.kerning)) {
                                    var s = [];
                                    for(var l in t1.width)s.push(l + o, o + l);
                                    g(t1.kerning, m(t1.family, {
                                        pairs: s
                                    }));
                                }
                            }
                        });
                    }
                    if (t1.position) {
                        if (t1.position.length > 2) {
                            for(var w = !t1.position[0].length, k = u.mallocFloat(2 * this.count), A = 0, M = 0; A < this.counts.length; A++){
                                var S = this.counts[A];
                                if (w) for(var E = 0; E < S; E++)k[M++] = t1.position[2 * A], k[M++] = t1.position[2 * A + 1];
                                else for(var C = 0; C < S; C++)k[M++] = t1.position[A][0], k[M++] = t1.position[A][1];
                            }
                            this.position.call ? this.position({
                                type: "float",
                                data: k
                            }) : this.position = this.regl.buffer({
                                type: "float",
                                data: k
                            }), u.freeFloat(k);
                        } else this.position.destroy && this.position.destroy(), this.position = {
                            constant: t1.position
                        };
                    }
                    if (t1.text || a) {
                        var L = u.mallocUint8(this.count), I = u.mallocFloat(2 * this.count);
                        this.textWidth = [];
                        for(var P = 0, z = 0; P < this.counts.length; P++){
                            for(var O = this.counts[P], D = this.font[P] || this.font[0], R = this.fontAtlas[P] || this.fontAtlas[0], F = 0; F < O; F++){
                                var B = this.text.charAt(z), N = this.text.charAt(z - 1);
                                if (L[z] = R.ids[B], I[2 * z] = D.width[B], F) {
                                    var j = I[2 * z - 2], U = I[2 * z], V = I[2 * z - 1] + .5 * j + .5 * U;
                                    if (this.kerning) {
                                        var q = D.kerning[N + B];
                                        q && (V += .001 * q);
                                    }
                                    I[2 * z + 1] = V;
                                } else I[2 * z + 1] = .5 * I[2 * z];
                                z++;
                            }
                            this.textWidth.push(I.length ? .5 * I[2 * z - 2] + I[2 * z - 1] : 0);
                        }
                        t1.align || (t1.align = this.align), this.charBuffer({
                            data: L,
                            type: "uint8",
                            usage: "stream"
                        }), this.sizeBuffer({
                            data: I,
                            type: "float",
                            usage: "stream"
                        }), u.freeUint8(L), u.freeFloat(I), r.length && this.font.forEach(function(t1, r) {
                            var n = e1.fontAtlas[r], i = n.step, a = Math.floor(T.maxAtlasSize / i), o = Math.min(a, n.chars.length), s = Math.ceil(n.chars.length / o), l = x(o * i), u = x(s * i);
                            n.width = l, n.height = u, n.rows = s, n.cols = o, n.em && n.texture({
                                data: c({
                                    canvas: T.atlasCanvas,
                                    font: n.fontString,
                                    chars: n.chars,
                                    shape: [
                                        l,
                                        u
                                    ],
                                    step: [
                                        i,
                                        i
                                    ]
                                })
                            });
                        });
                    }
                    if (t1.align && (this.align = t1.align, this.alignOffset = this.textWidth.map(function(t1, r) {
                        var n = Array.isArray(e1.align) ? e1.align.length > 1 ? e1.align[r] : e1.align[0] : e1.align;
                        if ("number" == typeof n) return n;
                        switch(n){
                            case "right":
                            case "end":
                                return -t1;
                            case "center":
                            case "centre":
                            case "middle":
                                return .5 * -t1;
                        }
                        return 0;
                    })), null == this.baseline && null == t1.baseline && (t1.baseline = 0), null != t1.baseline && (this.baseline = t1.baseline, Array.isArray(this.baseline) || (this.baseline = [
                        this.baseline
                    ]), this.baselineOffset = this.baseline.map(function(t1, r) {
                        var n = (e1.font[r] || e1.font[0]).metrics, i = 0;
                        return i += .5 * n.bottom, -1 * (i += "number" == typeof t1 ? t1 - n.baseline : -n[t1]);
                    })), null != t1.color) {
                        if (t1.color || (t1.color = "transparent"), "string" != typeof t1.color && isNaN(t1.color)) {
                            var H;
                            if ("number" == typeof t1.color[0] && t1.color.length > this.counts.length) {
                                var G = t1.color.length;
                                H = u.mallocUint8(G);
                                for(var Z = (t1.color.subarray || t1.color.slice).bind(t1.color), W = 0; W < G; W += 4)H.set(l(Z(W, W + 4), "uint8"), W);
                            } else {
                                var Y = t1.color.length;
                                H = u.mallocUint8(4 * Y);
                                for(var X = 0; X < Y; X++)H.set(l(t1.color[X] || 0, "uint8"), 4 * X);
                            }
                            this.color = H;
                        } else this.color = l(t1.color, "uint8");
                    }
                    if (t1.position || t1.text || t1.color || t1.baseline || t1.align || t1.font || t1.offset || t1.opacity) {
                        if (this.color.length > 4 || this.baselineOffset.length > 1 || this.align && this.align.length > 1 || this.fontAtlas.length > 1 || this.positionOffset.length > 2) {
                            var $ = Math.max(.5 * this.position.length || 0, .25 * this.color.length || 0, this.baselineOffset.length || 0, this.alignOffset.length || 0, this.font.length || 0, this.opacity.length || 0, .5 * this.positionOffset.length || 0);
                            this.batch = Array($);
                            for(var J = 0; J < this.batch.length; J++)this.batch[J] = {
                                count: this.counts.length > 1 ? this.counts[J] : this.counts[0],
                                offset: this.textOffsets.length > 1 ? this.textOffsets[J] : this.textOffsets[0],
                                color: this.color ? this.color.length <= 4 ? this.color : this.color.subarray(4 * J, 4 * J + 4) : [
                                    0,
                                    0,
                                    0,
                                    255
                                ],
                                opacity: Array.isArray(this.opacity) ? this.opacity[J] : this.opacity,
                                baseline: null != this.baselineOffset[J] ? this.baselineOffset[J] : this.baselineOffset[0],
                                align: this.align ? null != this.alignOffset[J] ? this.alignOffset[J] : this.alignOffset[0] : 0,
                                atlas: this.fontAtlas[J] || this.fontAtlas[0],
                                positionOffset: this.positionOffset.length > 2 ? this.positionOffset.subarray(2 * J, 2 * J + 2) : this.positionOffset
                            };
                        } else this.count ? this.batch = [
                            {
                                count: this.count,
                                offset: 0,
                                color: this.color || [
                                    0,
                                    0,
                                    0,
                                    255
                                ],
                                opacity: Array.isArray(this.opacity) ? this.opacity[0] : this.opacity,
                                baseline: this.baselineOffset[0],
                                align: this.alignOffset ? this.alignOffset[0] : 0,
                                atlas: this.fontAtlas[0],
                                positionOffset: this.positionOffset
                            }
                        ] : this.batch = [];
                    }
                }, T.prototype.destroy = function() {}, T.prototype.kerning = !0, T.prototype.position = {
                    constant: new Float32Array(2)
                }, T.prototype.translate = null, T.prototype.scale = null, T.prototype.font = null, T.prototype.text = "", T.prototype.positionOffset = [
                    0,
                    0
                ], T.prototype.opacity = 1, T.prototype.color = new Uint8Array([
                    0,
                    0,
                    0,
                    255
                ]), T.prototype.alignOffset = [
                    0,
                    0
                ], T.maxAtlasSize = 1024, T.atlasCanvas = document.createElement("canvas"), T.atlasContext = T.atlasCanvas.getContext("2d", {
                    alpha: !1
                }), T.baseFontSize = 64, T.fonts = {}, t1.exports = T;
            },
            38862: function(t1, e1, r) {
                "use strict";
                var n = r(6807);
                function i(t1) {
                    if (t1.container) {
                        if (t1.container == document.body) document.body.style.width || (t1.canvas.width = t1.width || t1.pixelRatio * r.g.innerWidth), document.body.style.height || (t1.canvas.height = t1.height || t1.pixelRatio * r.g.innerHeight);
                        else {
                            var e1 = t1.container.getBoundingClientRect();
                            t1.canvas.width = t1.width || e1.right - e1.left, t1.canvas.height = t1.height || e1.bottom - e1.top;
                        }
                    }
                }
                function a(t1) {
                    return "function" == typeof t1.getContext && "width" in t1 && "height" in t1;
                }
                function o() {
                    var t1 = document.createElement("canvas");
                    return t1.style.position = "absolute", t1.style.top = 0, t1.style.left = 0, t1;
                }
                t1.exports = function(t1) {
                    var e1;
                    if (t1 ? "string" == typeof t1 && (t1 = {
                        container: t1
                    }) : t1 = {}, (t1 = a(t1) || "string" == typeof (e1 = t1).nodeName && "function" == typeof e1.appendChild && "function" == typeof e1.getBoundingClientRect ? {
                        container: t1
                    } : function(t1) {
                        return "function" == typeof t1.drawArrays || "function" == typeof t1.drawElements;
                    }(t1) ? {
                        gl: t1
                    } : n(t1, {
                        container: "container target element el canvas holder parent parentNode wrapper use ref root node",
                        gl: "gl context webgl glContext",
                        attrs: "attributes attrs contextAttributes",
                        pixelRatio: "pixelRatio pxRatio px ratio pxratio pixelratio",
                        width: "w width",
                        height: "h height"
                    }, !0)).pixelRatio || (t1.pixelRatio = r.g.pixelRatio || 1), t1.gl) return t1.gl;
                    if (t1.canvas && (t1.container = t1.canvas.parentNode), t1.container) {
                        if ("string" == typeof t1.container) {
                            var s = document.querySelector(t1.container);
                            if (!s) throw Error("Element " + t1.container + " is not found");
                            t1.container = s;
                        }
                        a(t1.container) ? (t1.canvas = t1.container, t1.container = t1.canvas.parentNode) : t1.canvas || (t1.canvas = o(), t1.container.appendChild(t1.canvas), i(t1));
                    } else if (!t1.canvas) {
                        if ("undefined" == typeof document) throw Error("Not DOM environment. Use headless-gl.");
                        t1.container = document.body || document.documentElement, t1.canvas = o(), t1.container.appendChild(t1.canvas), i(t1);
                    }
                    return t1.gl || [
                        "webgl",
                        "experimental-webgl",
                        "webgl-experimental"
                    ].some(function(e1) {
                        try {
                            t1.gl = t1.canvas.getContext(e1, t1.attrs);
                        } catch (t1) {}
                        return t1.gl;
                    }), t1.gl;
                };
            },
            76765: function(t1) {
                t1.exports = function(t1) {
                    "string" == typeof t1 && (t1 = [
                        t1
                    ]);
                    for(var e1 = [].slice.call(arguments, 1), r = [], n = 0; n < t1.length - 1; n++)r.push(t1[n], e1[n] || "");
                    return r.push(t1[n]), r.join("");
                };
            },
            52991: function(t1, e1, r) {
                "use strict";
                var n = r(71129)("%Object.getOwnPropertyDescriptor%", !0);
                if (n) try {
                    n([], "length");
                } catch (t1) {
                    n = null;
                }
                t1.exports = n;
            },
            39784: function(t1, e1, r) {
                "use strict";
                var n, i = r(78253);
                n = "function" == typeof r.g.matchMedia ? !r.g.matchMedia("(hover: none)").matches : i, t1.exports = n;
            },
            74043: function(t1, e1, r) {
                "use strict";
                var n = r(78253);
                t1.exports = n && function() {
                    var t1 = !1;
                    try {
                        var e1 = Object.defineProperty({}, "passive", {
                            get: function() {
                                t1 = !0;
                            }
                        });
                        window.addEventListener("test", null, e1), window.removeEventListener("test", null, e1);
                    } catch (e1) {
                        t1 = !1;
                    }
                    return t1;
                }();
            },
            74268: function(t1, e1, r) {
                "use strict";
                var n = r(40891), i = function() {
                    return !!n;
                };
                i.hasArrayLengthDefineBug = function() {
                    if (!n) return null;
                    try {
                        return 1 !== n([], "length", {
                            value: 1
                        }).length;
                    } catch (t1) {
                        return !0;
                    }
                }, t1.exports = i;
            },
            58436: function(t1) {
                "use strict";
                var e1 = {
                    foo: {}
                }, r = Object;
                t1.exports = function() {
                    return ({
                        __proto__: e1
                    }).foo === e1.foo && !(({
                        __proto__: null
                    }) instanceof r);
                };
            },
            8771: function(t1, e1, r) {
                "use strict";
                var n = "undefined" != typeof Symbol && Symbol, i = r(59457);
                t1.exports = function() {
                    return "function" == typeof n && "function" == typeof Symbol && "symbol" == typeof n("foo") && "symbol" == typeof Symbol("bar") && i();
                };
            },
            59457: function(t1) {
                "use strict";
                t1.exports = function() {
                    if ("function" != typeof Symbol || "function" != typeof Object.getOwnPropertySymbols) return !1;
                    if ("symbol" == typeof Symbol.iterator) return !0;
                    var t1 = {}, e1 = Symbol("test"), r = Object(e1);
                    if ("string" == typeof e1) return !1;
                    if ("[object Symbol]" !== Object.prototype.toString.call(e1)) return !1;
                    if ("[object Symbol]" !== Object.prototype.toString.call(r)) return !1;
                    for(e1 in t1[e1] = 42, t1)return !1;
                    if ("function" == typeof Object.keys && 0 !== Object.keys(t1).length) return !1;
                    if ("function" == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(t1).length) return !1;
                    var n = Object.getOwnPropertySymbols(t1);
                    if (1 !== n.length || n[0] !== e1) return !1;
                    if (!Object.prototype.propertyIsEnumerable.call(t1, e1)) return !1;
                    if ("function" == typeof Object.getOwnPropertyDescriptor) {
                        var i = Object.getOwnPropertyDescriptor(t1, e1);
                        if (42 !== i.value || !0 !== i.enumerable) return !1;
                    }
                    return !0;
                };
            },
            36912: function(t1, e1, r) {
                "use strict";
                var n = r(59457);
                t1.exports = function() {
                    return n() && !!Symbol.toStringTag;
                };
            },
            80753: function(t1, e1, r) {
                "use strict";
                var n = Function.prototype.call, i = Object.prototype.hasOwnProperty, a = r(87547);
                t1.exports = a.call(n, i);
            },
            27415: function(t1, e1) {
                e1.read = function(t1, e1, r, n, i) {
                    var a, o, s = 8 * i - n - 1, l = (1 << s) - 1, c = l >> 1, u = -7, h = r ? i - 1 : 0, f = r ? -1 : 1, p = t1[e1 + h];
                    for(h += f, a = p & (1 << -u) - 1, p >>= -u, u += s; u > 0; a = 256 * a + t1[e1 + h], h += f, u -= 8);
                    for(o = a & (1 << -u) - 1, a >>= -u, u += n; u > 0; o = 256 * o + t1[e1 + h], h += f, u -= 8);
                    if (0 === a) a = 1 - c;
                    else {
                        if (a === l) return o ? NaN : 1 / 0 * (p ? -1 : 1);
                        o += Math.pow(2, n), a -= c;
                    }
                    return (p ? -1 : 1) * o * Math.pow(2, a - n);
                }, e1.write = function(t1, e1, r, n, i, a) {
                    var o, s, l, c = 8 * a - i - 1, u = (1 << c) - 1, h = u >> 1, f = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, p = n ? 0 : a - 1, d = n ? 1 : -1, m = e1 < 0 || 0 === e1 && 1 / e1 < 0 ? 1 : 0;
                    for(e1 = Math.abs(e1), isNaN(e1) || e1 === 1 / 0 ? (s = isNaN(e1) ? 1 : 0, o = u) : (o = Math.floor(Math.log(e1) / Math.LN2), e1 * (l = Math.pow(2, -o)) < 1 && (o--, l *= 2), (e1 += o + h >= 1 ? f / l : f * Math.pow(2, 1 - h)) * l >= 2 && (o++, l /= 2), o + h >= u ? (s = 0, o = u) : o + h >= 1 ? (s = (e1 * l - 1) * Math.pow(2, i), o += h) : (s = e1 * Math.pow(2, h - 1) * Math.pow(2, i), o = 0)); i >= 8; t1[r + p] = 255 & s, p += d, s /= 256, i -= 8);
                    for(o = o << i | s, c += i; c > 0; t1[r + p] = 255 & o, p += d, o /= 256, c -= 8);
                    t1[r + p - d] |= 128 * m;
                };
            },
            28062: function(t1) {
                "function" == typeof Object.create ? t1.exports = function(t1, e1) {
                    e1 && (t1.super_ = e1, t1.prototype = Object.create(e1.prototype, {
                        constructor: {
                            value: t1,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }));
                } : t1.exports = function(t1, e1) {
                    if (e1) {
                        t1.super_ = e1;
                        var r = function() {};
                        r.prototype = e1.prototype, t1.prototype = new r, t1.prototype.constructor = t1;
                    }
                };
            },
            40280: function(t1, e1, r) {
                "use strict";
                var n = r(36912)(), i = r(63063)("Object.prototype.toString"), a = function(t1) {
                    return !(n && t1 && "object" == typeof t1 && Symbol.toStringTag in t1) && "[object Arguments]" === i(t1);
                }, o = function(t1) {
                    return !!a(t1) || null !== t1 && "object" == typeof t1 && "number" == typeof t1.length && t1.length >= 0 && "[object Array]" !== i(t1) && "[object Function]" === i(t1.callee);
                }, s = function() {
                    return a(arguments);
                }();
                a.isLegacyArguments = o, t1.exports = s ? a : o;
            },
            78253: function(t1) {
                t1.exports = !0;
            },
            82756: function(t1) {
                "use strict";
                var e1, r, n = Function.prototype.toString, i = "object" == typeof Reflect && null !== Reflect && Reflect.apply;
                if ("function" == typeof i && "function" == typeof Object.defineProperty) try {
                    e1 = Object.defineProperty({}, "length", {
                        get: function() {
                            throw r;
                        }
                    }), r = {}, i(function() {
                        throw 42;
                    }, null, e1);
                } catch (t1) {
                    t1 !== r && (i = null);
                }
                else i = null;
                var a = /^\s*class\b/, o = function(t1) {
                    try {
                        var e1 = n.call(t1);
                        return a.test(e1);
                    } catch (t1) {
                        return !1;
                    }
                }, s = function(t1) {
                    try {
                        return !o(t1) && (n.call(t1), !0);
                    } catch (t1) {
                        return !1;
                    }
                }, l = Object.prototype.toString, c = "function" == typeof Symbol && !!Symbol.toStringTag, u = !(0 in [
                    , 
                ]), h = function() {
                    return !1;
                };
                if ("object" == typeof document) {
                    var f = document.all;
                    l.call(f) === l.call(document.all) && (h = function(t1) {
                        if ((u || !t1) && (void 0 === t1 || "object" == typeof t1)) try {
                            var e1 = l.call(t1);
                            return ("[object HTMLAllCollection]" === e1 || "[object HTML document.all class]" === e1 || "[object HTMLCollection]" === e1 || "[object Object]" === e1) && null == t1("");
                        } catch (t1) {}
                        return !1;
                    });
                }
                t1.exports = i ? function(t1) {
                    if (h(t1)) return !0;
                    if (!t1) return !1;
                    if ("function" != typeof t1 && "object" != typeof t1) return !1;
                    try {
                        i(t1, null, e1);
                    } catch (t1) {
                        if (t1 !== r) return !1;
                    }
                    return !o(t1) && s(t1);
                } : function(t1) {
                    if (h(t1)) return !0;
                    if (!t1) return !1;
                    if ("function" != typeof t1 && "object" != typeof t1) return !1;
                    if (c) return s(t1);
                    if (o(t1)) return !1;
                    var e1 = l.call(t1);
                    return !("[object Function]" !== e1 && "[object GeneratorFunction]" !== e1 && !/^\[object HTML/.test(e1)) && s(t1);
                };
            },
            80340: function(t1, e1, r) {
                "use strict";
                var n, i = Object.prototype.toString, a = Function.prototype.toString, o = /^\s*(?:function)?\*/, s = r(36912)(), l = Object.getPrototypeOf;
                t1.exports = function(t1) {
                    if ("function" != typeof t1) return !1;
                    if (o.test(a.call(t1))) return !0;
                    if (!s) return "[object GeneratorFunction]" === i.call(t1);
                    if (!l) return !1;
                    if (void 0 === n) {
                        var e1 = function() {
                            if (!s) return !1;
                            try {
                                return Function("return function*() {}")();
                            } catch (t1) {}
                        }();
                        n = !!e1 && l(e1);
                    }
                    return l(t1) === n;
                };
            },
            39488: function(t1) {
                "use strict";
                t1.exports = "undefined" != typeof navigator && (/MSIE/.test(navigator.userAgent) || /Trident\//.test(navigator.appVersion));
            },
            73287: function(t1) {
                "use strict";
                t1.exports = function(t1) {
                    return t1 != t1;
                };
            },
            63057: function(t1, e1, r) {
                "use strict";
                var n = r(87227), i = r(97936), a = r(73287), o = r(60758), s = r(85684), l = n(o(), Number);
                i(l, {
                    getPolyfill: o,
                    implementation: a,
                    shim: s
                }), t1.exports = l;
            },
            60758: function(t1, e1, r) {
                "use strict";
                var n = r(73287);
                t1.exports = function() {
                    return Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a") ? Number.isNaN : n;
                };
            },
            85684: function(t1, e1, r) {
                "use strict";
                var n = r(97936), i = r(60758);
                t1.exports = function() {
                    var t1 = i();
                    return n(Number, {
                        isNaN: t1
                    }, {
                        isNaN: function() {
                            return Number.isNaN !== t1;
                        }
                    }), t1;
                };
            },
            60201: function(t1) {
                "use strict";
                t1.exports = function(t1) {
                    var e1 = typeof t1;
                    return null !== t1 && ("object" === e1 || "function" === e1);
                };
            },
            29388: function(t1) {
                "use strict";
                var e1 = Object.prototype.toString;
                t1.exports = function(t1) {
                    var r;
                    return "[object Object]" === e1.call(t1) && (null === (r = Object.getPrototypeOf(t1)) || r === Object.getPrototypeOf({}));
                };
            },
            9914: function(t1) {
                "use strict";
                t1.exports = function(t1) {
                    for(var e1, r = t1.length, n = 0; n < r; n++)if (((e1 = t1.charCodeAt(n)) < 9 || e1 > 13) && 32 !== e1 && 133 !== e1 && 160 !== e1 && 5760 !== e1 && 6158 !== e1 && (e1 < 8192 || e1 > 8205) && 8232 !== e1 && 8233 !== e1 && 8239 !== e1 && 8287 !== e1 && 8288 !== e1 && 12288 !== e1 && 65279 !== e1) return !1;
                    return !0;
                };
            },
            13986: function(t1) {
                "use strict";
                t1.exports = function(t1) {
                    return "string" == typeof t1 && (t1 = t1.trim(), !!(/^[mzlhvcsqta]\s*[-+.0-9][^mlhvzcsqta]+/i.test(t1) && /[\dz]$/i.test(t1) && t1.length > 4));
                };
            },
            15628: function(t1, e1, r) {
                "use strict";
                var n = r(61262), i = r(70085), a = r(63063), o = a("Object.prototype.toString"), s = r(36912)(), l = r(52991), c = "undefined" == typeof globalThis ? r.g : globalThis, u = i(), h = a("Array.prototype.indexOf", !0) || function(t1, e1) {
                    for(var r = 0; r < t1.length; r += 1)if (t1[r] === e1) return r;
                    return -1;
                }, f = a("String.prototype.slice"), p = {}, d = Object.getPrototypeOf;
                s && l && d && n(u, function(t1) {
                    var e1 = new c[t1];
                    if (Symbol.toStringTag in e1) {
                        var r = d(e1), n = l(r, Symbol.toStringTag);
                        if (!n) {
                            var i = d(r);
                            n = l(i, Symbol.toStringTag);
                        }
                        p[t1] = n.get;
                    }
                }), t1.exports = function(t1) {
                    if (!t1 || "object" != typeof t1) return !1;
                    if (!s || !(Symbol.toStringTag in t1)) {
                        var e1 = f(o(t1), 8, -1);
                        return h(u, e1) > -1;
                    }
                    return !!l && function(t1) {
                        var e1 = !1;
                        return n(p, function(r, n) {
                            if (!e1) try {
                                e1 = r.call(t1) === n;
                            } catch (t1) {}
                        }), e1;
                    }(t1);
                };
            },
            62914: function(t1) {
                "use strict";
                t1.exports = Math.log2 || function(t1) {
                    return Math.log(t1) * Math.LOG2E;
                };
            },
            99978: function(t1, e1, r) {
                "use strict";
                t1.exports = function(t1, e1) {
                    e1 || (e1 = t1, t1 = window);
                    var r = 0, i = 0, a = 0, o = {
                        shift: !1,
                        alt: !1,
                        control: !1,
                        meta: !1
                    }, s = !1;
                    function l(t1) {
                        var e1 = !1;
                        return "altKey" in t1 && (e1 = e1 || t1.altKey !== o.alt, o.alt = !!t1.altKey), "shiftKey" in t1 && (e1 = e1 || t1.shiftKey !== o.shift, o.shift = !!t1.shiftKey), "ctrlKey" in t1 && (e1 = e1 || t1.ctrlKey !== o.control, o.control = !!t1.ctrlKey), "metaKey" in t1 && (e1 = e1 || t1.metaKey !== o.meta, o.meta = !!t1.metaKey), e1;
                    }
                    function c(t1, s) {
                        var c = n.x(s), u = n.y(s);
                        "buttons" in s && (t1 = 0 | s.buttons), (t1 !== r || c !== i || u !== a || l(s)) && (r = 0 | t1, i = c || 0, a = u || 0, e1 && e1(r, i, a, o));
                    }
                    function u(t1) {
                        c(0, t1);
                    }
                    function h() {
                        (r || i || a || o.shift || o.alt || o.meta || o.control) && (i = a = 0, r = 0, o.shift = o.alt = o.control = o.meta = !1, e1 && e1(0, 0, 0, o));
                    }
                    function f(t1) {
                        l(t1) && e1 && e1(r, i, a, o);
                    }
                    function p(t1) {
                        0 === n.buttons(t1) ? c(0, t1) : c(r, t1);
                    }
                    function d(t1) {
                        c(r | n.buttons(t1), t1);
                    }
                    function m(t1) {
                        c(r & ~n.buttons(t1), t1);
                    }
                    function g() {
                        s || (s = !0, t1.addEventListener("mousemove", p), t1.addEventListener("mousedown", d), t1.addEventListener("mouseup", m), t1.addEventListener("mouseleave", u), t1.addEventListener("mouseenter", u), t1.addEventListener("mouseout", u), t1.addEventListener("mouseover", u), t1.addEventListener("blur", h), t1.addEventListener("keyup", f), t1.addEventListener("keydown", f), t1.addEventListener("keypress", f), t1 !== window && (window.addEventListener("blur", h), window.addEventListener("keyup", f), window.addEventListener("keydown", f), window.addEventListener("keypress", f)));
                    }
                    g();
                    var y = {
                        element: t1
                    };
                    return Object.defineProperties(y, {
                        enabled: {
                            get: function() {
                                return s;
                            },
                            set: function(e1) {
                                e1 ? g() : s && (s = !1, t1.removeEventListener("mousemove", p), t1.removeEventListener("mousedown", d), t1.removeEventListener("mouseup", m), t1.removeEventListener("mouseleave", u), t1.removeEventListener("mouseenter", u), t1.removeEventListener("mouseout", u), t1.removeEventListener("mouseover", u), t1.removeEventListener("blur", h), t1.removeEventListener("keyup", f), t1.removeEventListener("keydown", f), t1.removeEventListener("keypress", f), t1 !== window && (window.removeEventListener("blur", h), window.removeEventListener("keyup", f), window.removeEventListener("keydown", f), window.removeEventListener("keypress", f)));
                            },
                            enumerable: !0
                        },
                        buttons: {
                            get: function() {
                                return r;
                            },
                            enumerable: !0
                        },
                        x: {
                            get: function() {
                                return i;
                            },
                            enumerable: !0
                        },
                        y: {
                            get: function() {
                                return a;
                            },
                            enumerable: !0
                        },
                        mods: {
                            get: function() {
                                return o;
                            },
                            enumerable: !0
                        }
                    }), y;
                };
                var n = r(41926);
            },
            44039: function(t1) {
                var e1 = {
                    left: 0,
                    top: 0
                };
                t1.exports = function(t1, r, n) {
                    r = r || t1.currentTarget || t1.srcElement, Array.isArray(n) || (n = [
                        0,
                        0
                    ]);
                    var i, a = t1.clientX || 0, o = t1.clientY || 0, s = (i = r) === window || i === document || i === document.body ? e1 : i.getBoundingClientRect();
                    return n[0] = a - s.left, n[1] = o - s.top, n;
                };
            },
            41926: function(t1, e1) {
                "use strict";
                function r(t1) {
                    return t1.target || t1.srcElement || window;
                }
                e1.buttons = function(t1) {
                    if ("object" == typeof t1) {
                        if ("buttons" in t1) return t1.buttons;
                        if ("which" in t1) {
                            if (2 === (e1 = t1.which)) return 4;
                            if (3 === e1) return 2;
                            if (e1 > 0) return 1 << e1 - 1;
                        } else if ("button" in t1) {
                            var e1;
                            if (1 === (e1 = t1.button)) return 4;
                            if (2 === e1) return 2;
                            if (e1 >= 0) return 1 << e1;
                        }
                    }
                    return 0;
                }, e1.element = r, e1.x = function(t1) {
                    if ("object" == typeof t1) {
                        if ("offsetX" in t1) return t1.offsetX;
                        var e1 = r(t1).getBoundingClientRect();
                        return t1.clientX - e1.left;
                    }
                    return 0;
                }, e1.y = function(t1) {
                    if ("object" == typeof t1) {
                        if ("offsetY" in t1) return t1.offsetY;
                        var e1 = r(t1).getBoundingClientRect();
                        return t1.clientY - e1.top;
                    }
                    return 0;
                };
            },
            20573: function(t1, e1, r) {
                "use strict";
                var n = r(44626);
                t1.exports = function(t1, e1, r) {
                    "function" == typeof t1 && (r = !!e1, e1 = t1, t1 = window);
                    var i = n("ex", t1), a = function(t1) {
                        r && t1.preventDefault();
                        var n = t1.deltaX || 0, a = t1.deltaY || 0, o = t1.deltaZ || 0, s = 1;
                        switch(t1.deltaMode){
                            case 1:
                                s = i;
                                break;
                            case 2:
                                s = window.innerHeight;
                        }
                        if (a *= s, o *= s, (n *= s) || a || o) return e1(n, a, o, t1);
                    };
                    return t1.addEventListener("wheel", a), a;
                };
            },
            71116: function(t1, e1, r) {
                var n;
                !function(i, a, o) {
                    a[i] = a[i] || function() {
                        "use strict";
                        var t1, e1, r, n = Object.prototype.toString, i = "undefined" != typeof setImmediate ? function(t1) {
                            return setImmediate(t1);
                        } : setTimeout;
                        try {
                            Object.defineProperty({}, "x", {}), t1 = function(t1, e1, r, n) {
                                return Object.defineProperty(t1, e1, {
                                    value: r,
                                    writable: !0,
                                    configurable: !1 !== n
                                });
                            };
                        } catch (e1) {
                            t1 = function(t1, e1, r) {
                                return t1[e1] = r, t1;
                            };
                        }
                        function a(t1, n) {
                            r.add(t1, n), e1 || (e1 = i(r.drain));
                        }
                        function o(t1) {
                            var e1, r = typeof t1;
                            return null == t1 || "object" != r && "function" != r || (e1 = t1.then), "function" == typeof e1 && e1;
                        }
                        function s() {
                            for(var t1 = 0; t1 < this.chain.length; t1++)l(this, 1 === this.state ? this.chain[t1].success : this.chain[t1].failure, this.chain[t1]);
                            this.chain.length = 0;
                        }
                        function l(t1, e1, r) {
                            var n, i;
                            try {
                                !1 === e1 ? r.reject(t1.msg) : (n = !0 === e1 ? t1.msg : e1.call(void 0, t1.msg)) === r.promise ? r.reject(TypeError("Promise-chain cycle")) : (i = o(n)) ? i.call(n, r.resolve, r.reject) : r.resolve(n);
                            } catch (t1) {
                                r.reject(t1);
                            }
                        }
                        function c(t1) {
                            var e1, r = this;
                            if (!r.triggered) {
                                r.triggered = !0, r.def && (r = r.def);
                                try {
                                    (e1 = o(t1)) ? a(function() {
                                        var n = new f(r);
                                        try {
                                            e1.call(t1, function() {
                                                c.apply(n, arguments);
                                            }, function() {
                                                u.apply(n, arguments);
                                            });
                                        } catch (t1) {
                                            u.call(n, t1);
                                        }
                                    }) : (r.msg = t1, r.state = 1, r.chain.length > 0 && a(s, r));
                                } catch (t1) {
                                    u.call(new f(r), t1);
                                }
                            }
                        }
                        function u(t1) {
                            var e1 = this;
                            e1.triggered || (e1.triggered = !0, e1.def && (e1 = e1.def), e1.msg = t1, e1.state = 2, e1.chain.length > 0 && a(s, e1));
                        }
                        function h(t1, e1, r, n) {
                            for(var i = 0; i < e1.length; i++)!function(i) {
                                t1.resolve(e1[i]).then(function(t1) {
                                    r(i, t1);
                                }, n);
                            }(i);
                        }
                        function f(t1) {
                            this.def = t1, this.triggered = !1;
                        }
                        function p(t1) {
                            this.promise = t1, this.state = 0, this.triggered = !1, this.chain = [], this.msg = void 0;
                        }
                        function d(t1) {
                            if ("function" != typeof t1) throw TypeError("Not a function");
                            if (0 !== this.__NPO__) throw TypeError("Not a promise");
                            this.__NPO__ = 1;
                            var e1 = new p(this);
                            this.then = function(t1, r) {
                                var n = {
                                    success: "function" != typeof t1 || t1,
                                    failure: "function" == typeof r && r
                                };
                                return n.promise = new this.constructor(function(t1, e1) {
                                    if ("function" != typeof t1 || "function" != typeof e1) throw TypeError("Not a function");
                                    n.resolve = t1, n.reject = e1;
                                }), e1.chain.push(n), 0 !== e1.state && a(s, e1), n.promise;
                            }, this.catch = function(t1) {
                                return this.then(void 0, t1);
                            };
                            try {
                                t1.call(void 0, function(t1) {
                                    c.call(e1, t1);
                                }, function(t1) {
                                    u.call(e1, t1);
                                });
                            } catch (t1) {
                                u.call(e1, t1);
                            }
                        }
                        r = function() {
                            var t1, r, n;
                            function i(t1, e1) {
                                this.fn = t1, this.self = e1, this.next = void 0;
                            }
                            return {
                                add: function(e1, a) {
                                    n = new i(e1, a), r ? r.next = n : t1 = n, r = n, n = void 0;
                                },
                                drain: function() {
                                    var n = t1;
                                    for(t1 = r = e1 = void 0; n;)n.fn.call(n.self), n = n.next;
                                }
                            };
                        }();
                        var m = t1({}, "constructor", d, !1);
                        return d.prototype = m, t1(m, "__NPO__", 0, !1), t1(d, "resolve", function(t1) {
                            return t1 && "object" == typeof t1 && 1 === t1.__NPO__ ? t1 : new this(function(e1, r) {
                                if ("function" != typeof e1 || "function" != typeof r) throw TypeError("Not a function");
                                e1(t1);
                            });
                        }), t1(d, "reject", function(t1) {
                            return new this(function(e1, r) {
                                if ("function" != typeof e1 || "function" != typeof r) throw TypeError("Not a function");
                                r(t1);
                            });
                        }), t1(d, "all", function(t1) {
                            var e1 = this;
                            return "[object Array]" != n.call(t1) ? e1.reject(TypeError("Not an array")) : 0 === t1.length ? e1.resolve([]) : new e1(function(r, n) {
                                if ("function" != typeof r || "function" != typeof n) throw TypeError("Not a function");
                                var i = t1.length, a = Array(i), o = 0;
                                h(e1, t1, function(t1, e1) {
                                    a[t1] = e1, ++o === i && r(a);
                                }, n);
                            });
                        }), t1(d, "race", function(t1) {
                            var e1 = this;
                            return "[object Array]" != n.call(t1) ? e1.reject(TypeError("Not an array")) : new e1(function(r, n) {
                                if ("function" != typeof r || "function" != typeof n) throw TypeError("Not a function");
                                h(e1, t1, function(t1, e1) {
                                    r(e1);
                                }, n);
                            });
                        }), d;
                    }(), t1.exports ? t1.exports = a[i] : void 0 === (n = (function() {
                        return a[i];
                    }).call(e1, r, e1, t1)) || (t1.exports = n);
                }("Promise", void 0 !== r.g ? r.g : this);
            },
            60265: function(t1) {
                var e1 = Math.PI, r = s(120);
                function n(t1, e1, r, n) {
                    return [
                        "C",
                        t1,
                        e1,
                        r,
                        n,
                        r,
                        n
                    ];
                }
                function i(t1, e1, r, n, i, a) {
                    return [
                        "C",
                        t1 / 3 + 2 / 3 * r,
                        e1 / 3 + 2 / 3 * n,
                        i / 3 + 2 / 3 * r,
                        a / 3 + 2 / 3 * n,
                        i,
                        a
                    ];
                }
                function a(t1, n, i, s, l, c, u, h, f, p) {
                    if (p) T = p[0], k = p[1], b = p[2], w = p[3];
                    else {
                        var d = o(t1, n, -l);
                        t1 = d.x, n = d.y;
                        var m = (t1 - (h = (d = o(h, f, -l)).x)) / 2, g = (n - (f = d.y)) / 2, y = m * m / (i * i) + g * g / (s * s);
                        y > 1 && (i *= y = Math.sqrt(y), s *= y);
                        var v = i * i, x = s * s, _ = (c == u ? -1 : 1) * Math.sqrt(Math.abs((v * x - v * g * g - x * m * m) / (v * g * g + x * m * m)));
                        _ == 1 / 0 && (_ = 1);
                        var b = _ * i * g / s + (t1 + h) / 2, w = _ * -s * m / i + (n + f) / 2, T = Math.asin(((n - w) / s).toFixed(9)), k = Math.asin(((f - w) / s).toFixed(9));
                        (T = t1 < b ? e1 - T : T) < 0 && (T = 2 * e1 + T), (k = h < b ? e1 - k : k) < 0 && (k = 2 * e1 + k), u && T > k && (T -= 2 * e1), !u && k > T && (k -= 2 * e1);
                    }
                    if (Math.abs(k - T) > r) {
                        var A = k, M = h, S = f;
                        k = T + r * (u && k > T ? 1 : -1);
                        var E = a(h = b + i * Math.cos(k), f = w + s * Math.sin(k), i, s, l, 0, u, M, S, [
                            k,
                            A,
                            b,
                            w
                        ]);
                    }
                    var C = Math.tan((k - T) / 4), L = 4 / 3 * i * C, I = 4 / 3 * s * C, P = [
                        2 * t1 - (t1 + L * Math.sin(T)),
                        2 * n - (n - I * Math.cos(T)),
                        h + L * Math.sin(k),
                        f - I * Math.cos(k),
                        h,
                        f
                    ];
                    if (p) return P;
                    E && (P = P.concat(E));
                    for(var z = 0; z < P.length;){
                        var O = o(P[z], P[z + 1], l);
                        P[z++] = O.x, P[z++] = O.y;
                    }
                    return P;
                }
                function o(t1, e1, r) {
                    return {
                        x: t1 * Math.cos(r) - e1 * Math.sin(r),
                        y: t1 * Math.sin(r) + e1 * Math.cos(r)
                    };
                }
                function s(t1) {
                    return t1 * (e1 / 180);
                }
                t1.exports = function(t1) {
                    for(var e1, r = [], o = 0, l = 0, c = 0, u = 0, h = null, f = null, p = 0, d = 0, m = 0, g = t1.length; m < g; m++){
                        var y = t1[m], v = y[0];
                        switch(v){
                            case "M":
                                c = y[1], u = y[2];
                                break;
                            case "A":
                                (y = a(p, d, y[1], y[2], s(y[3]), y[4], y[5], y[6], y[7])).unshift("C"), y.length > 7 && (r.push(y.splice(0, 7)), y.unshift("C"));
                                break;
                            case "S":
                                var x = p, _ = d;
                                "C" != e1 && "S" != e1 || (x += x - o, _ += _ - l), y = [
                                    "C",
                                    x,
                                    _,
                                    y[1],
                                    y[2],
                                    y[3],
                                    y[4]
                                ];
                                break;
                            case "T":
                                "Q" == e1 || "T" == e1 ? (h = 2 * p - h, f = 2 * d - f) : (h = p, f = d), y = i(p, d, h, f, y[1], y[2]);
                                break;
                            case "Q":
                                h = y[1], f = y[2], y = i(p, d, y[1], y[2], y[3], y[4]);
                                break;
                            case "L":
                                y = n(p, d, y[1], y[2]);
                                break;
                            case "H":
                                y = n(p, d, y[1], d);
                                break;
                            case "V":
                                y = n(p, d, p, y[1]);
                                break;
                            case "Z":
                                y = n(p, d, c, u);
                        }
                        e1 = v, p = y[y.length - 2], d = y[y.length - 1], y.length > 4 ? (o = y[y.length - 4], l = y[y.length - 3]) : (o = p, l = d), r.push(y);
                    }
                    return r;
                };
            },
            27976: function(t1) {
                "use strict";
                var e1 = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
                t1.exports = function() {
                    try {
                        if (!Object.assign) return !1;
                        var t1 = new String("abc");
                        if (t1[5] = "de", "5" === Object.getOwnPropertyNames(t1)[0]) return !1;
                        for(var e1 = {}, r = 0; r < 10; r++)e1["_" + String.fromCharCode(r)] = r;
                        if ("0123456789" !== Object.getOwnPropertyNames(e1).map(function(t1) {
                            return e1[t1];
                        }).join("")) return !1;
                        var n = {};
                        return "abcdefghijklmnopqrst".split("").forEach(function(t1) {
                            n[t1] = t1;
                        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n)).join("");
                    } catch (t1) {
                        return !1;
                    }
                }() ? Object.assign : function(t1, i) {
                    for(var a, o, s = function(t1) {
                        if (null == t1) throw new TypeError("Object.assign cannot be called with null or undefined");
                        return Object(t1);
                    }(t1), l = 1; l < arguments.length; l++){
                        for(var c in a = Object(arguments[l]))r.call(a, c) && (s[c] = a[c]);
                        if (e1) {
                            o = e1(a);
                            for(var u = 0; u < o.length; u++)n.call(a, o[u]) && (s[o[u]] = a[o[u]]);
                        }
                    }
                    return s;
                };
            },
            93063: function(t1) {
                "use strict";
                var e1 = function(t1) {
                    return t1 != t1;
                };
                t1.exports = function(t1, r) {
                    return 0 === t1 && 0 === r ? 1 / t1 == 1 / r : t1 === r || !(!e1(t1) || !e1(r));
                };
            },
            13969: function(t1, e1, r) {
                "use strict";
                var n = r(97936), i = r(87227), a = r(93063), o = r(9622), s = r(79796), l = i(o(), Object);
                n(l, {
                    getPolyfill: o,
                    implementation: a,
                    shim: s
                }), t1.exports = l;
            },
            9622: function(t1, e1, r) {
                "use strict";
                var n = r(93063);
                t1.exports = function() {
                    return "function" == typeof Object.is ? Object.is : n;
                };
            },
            79796: function(t1, e1, r) {
                "use strict";
                var n = r(9622), i = r(97936);
                t1.exports = function() {
                    var t1 = n();
                    return i(Object, {
                        is: t1
                    }, {
                        is: function() {
                            return Object.is !== t1;
                        }
                    }), t1;
                };
            },
            61663: function(t1, e1, r) {
                "use strict";
                var n;
                if (!Object.keys) {
                    var i = Object.prototype.hasOwnProperty, a = Object.prototype.toString, o = r(52385), s = Object.prototype.propertyIsEnumerable, l = !s.call({
                        toString: null
                    }, "toString"), c = s.call(function() {}, "prototype"), u = [
                        "toString",
                        "toLocaleString",
                        "valueOf",
                        "hasOwnProperty",
                        "isPrototypeOf",
                        "propertyIsEnumerable",
                        "constructor"
                    ], h = function(t1) {
                        var e1 = t1.constructor;
                        return e1 && e1.prototype === t1;
                    }, f = {
                        $applicationCache: !0,
                        $console: !0,
                        $external: !0,
                        $frame: !0,
                        $frameElement: !0,
                        $frames: !0,
                        $innerHeight: !0,
                        $innerWidth: !0,
                        $onmozfullscreenchange: !0,
                        $onmozfullscreenerror: !0,
                        $outerHeight: !0,
                        $outerWidth: !0,
                        $pageXOffset: !0,
                        $pageYOffset: !0,
                        $parent: !0,
                        $scrollLeft: !0,
                        $scrollTop: !0,
                        $scrollX: !0,
                        $scrollY: !0,
                        $self: !0,
                        $webkitIndexedDB: !0,
                        $webkitStorageInfo: !0,
                        $window: !0
                    }, p = function() {
                        if ("undefined" == typeof window) return !1;
                        for(var t1 in window)try {
                            if (!f["$" + t1] && i.call(window, t1) && null !== window[t1] && "object" == typeof window[t1]) try {
                                h(window[t1]);
                            } catch (t1) {
                                return !0;
                            }
                        } catch (t1) {
                            return !0;
                        }
                        return !1;
                    }();
                    n = function(t1) {
                        var e1 = null !== t1 && "object" == typeof t1, r = "[object Function]" === a.call(t1), n = o(t1), s = e1 && "[object String]" === a.call(t1), f = [];
                        if (!e1 && !r && !n) throw new TypeError("Object.keys called on a non-object");
                        var d = c && r;
                        if (s && t1.length > 0 && !i.call(t1, 0)) for(var m = 0; m < t1.length; ++m)f.push(String(m));
                        if (n && t1.length > 0) for(var g = 0; g < t1.length; ++g)f.push(String(g));
                        else for(var y in t1)d && "prototype" === y || !i.call(t1, y) || f.push(String(y));
                        if (l) for(var v = function(t1) {
                            if ("undefined" == typeof window || !p) return h(t1);
                            try {
                                return h(t1);
                            } catch (t1) {
                                return !1;
                            }
                        }(t1), x = 0; x < u.length; ++x)v && "constructor" === u[x] || !i.call(t1, u[x]) || f.push(u[x]);
                        return f;
                    };
                }
                t1.exports = n;
            },
            99433: function(t1, e1, r) {
                "use strict";
                var n = Array.prototype.slice, i = r(52385), a = Object.keys, o = a ? function(t1) {
                    return a(t1);
                } : r(61663), s = Object.keys;
                o.shim = function() {
                    if (Object.keys) {
                        var t1 = function() {
                            var t1 = Object.keys(arguments);
                            return t1 && t1.length === arguments.length;
                        }(1, 2);
                        t1 || (Object.keys = function(t1) {
                            return i(t1) ? s(n.call(t1)) : s(t1);
                        });
                    } else Object.keys = o;
                    return Object.keys || o;
                }, t1.exports = o;
            },
            52385: function(t1) {
                "use strict";
                var e1 = Object.prototype.toString;
                t1.exports = function(t1) {
                    var r = e1.call(t1), n = "[object Arguments]" === r;
                    return n || (n = "[object Array]" !== r && null !== t1 && "object" == typeof t1 && "number" == typeof t1.length && t1.length >= 0 && "[object Function]" === e1.call(t1.callee)), n;
                };
            },
            96927: function(t1, e1, r) {
                "use strict";
                var n = r(99433), i = r(59457)(), a = r(63063), o = Object, s = a("Array.prototype.push"), l = a("Object.prototype.propertyIsEnumerable"), c = i ? Object.getOwnPropertySymbols : null;
                t1.exports = function(t1, e1) {
                    if (null == t1) throw new TypeError("target must be an object");
                    var r = o(t1);
                    if (1 === arguments.length) return r;
                    for(var a = 1; a < arguments.length; ++a){
                        var u = o(arguments[a]), h = n(u), f = i && (Object.getOwnPropertySymbols || c);
                        if (f) for(var p = f(u), d = 0; d < p.length; ++d){
                            var m = p[d];
                            l(u, m) && s(h, m);
                        }
                        for(var g = 0; g < h.length; ++g){
                            var y = h[g];
                            if (l(u, y)) {
                                var v = u[y];
                                r[y] = v;
                            }
                        }
                    }
                    return r;
                };
            },
            68686: function(t1, e1, r) {
                "use strict";
                var n = r(96927);
                t1.exports = function() {
                    return Object.assign ? function() {
                        if (!Object.assign) return !1;
                        for(var t1 = "abcdefghijklmnopqrst", e1 = t1.split(""), r = {}, n = 0; n < e1.length; ++n)r[e1[n]] = e1[n];
                        var i = Object.assign({}, r), a = "";
                        for(var o in i)a += o;
                        return t1 !== a;
                    }() || function() {
                        if (!Object.assign || !Object.preventExtensions) return !1;
                        var t1 = Object.preventExtensions({
                            1: 2
                        });
                        try {
                            Object.assign(t1, "xy");
                        } catch (e1) {
                            return "y" === t1[1];
                        }
                        return !1;
                    }() ? n : Object.assign : n;
                };
            },
            59811: function(t1) {
                "use strict";
                function e1(t1, e1) {
                    if ("string" != typeof t1) return [
                        t1
                    ];
                    var r = [
                        t1
                    ];
                    "string" == typeof e1 || Array.isArray(e1) ? e1 = {
                        brackets: e1
                    } : e1 || (e1 = {});
                    var n = e1.brackets ? Array.isArray(e1.brackets) ? e1.brackets : [
                        e1.brackets
                    ] : [
                        "{}",
                        "[]",
                        "()"
                    ], i = e1.escape || "___", a = !!e1.flat;
                    n.forEach(function(t1) {
                        var e1 = new RegExp([
                            "\\",
                            t1[0],
                            "[^\\",
                            t1[0],
                            "\\",
                            t1[1],
                            "]*\\",
                            t1[1]
                        ].join("")), n = [];
                        function a(e1, a, o) {
                            var s = r.push(e1.slice(t1[0].length, -t1[1].length)) - 1;
                            return n.push(s), i + s + i;
                        }
                        r.forEach(function(t1, n) {
                            for(var i, o = 0; t1 != i;)if (i = t1, t1 = t1.replace(e1, a), o++ > 1e4) throw Error("References have circular dependency. Please, check them.");
                            r[n] = t1;
                        }), n = n.reverse(), r = r.map(function(e1) {
                            return n.forEach(function(r) {
                                e1 = e1.replace(new RegExp("(\\" + i + r + "\\" + i + ")", "g"), t1[0] + "$1" + t1[1]);
                            }), e1;
                        });
                    });
                    var o = new RegExp("\\" + i + "([0-9]+)\\" + i);
                    return a ? r : function t1(e1, r, n) {
                        for(var i, a = [], s = 0; i = o.exec(e1);){
                            if (s++ > 1e4) throw Error("Circular references in parenthesis");
                            a.push(e1.slice(0, i.index)), a.push(t1(r[i[1]], r)), e1 = e1.slice(i.index + i[0].length);
                        }
                        return a.push(e1), a;
                    }(r[0], r);
                }
                function r(t1, e1) {
                    if (e1 && e1.flat) {
                        var r, n = e1 && e1.escape || "___", i = t1[0];
                        if (!i) return "";
                        for(var a = new RegExp("\\" + n + "([0-9]+)\\" + n), o = 0; i != r;){
                            if (o++ > 1e4) throw Error("Circular references in " + t1);
                            r = i, i = i.replace(a, s);
                        }
                        return i;
                    }
                    return t1.reduce(function t1(e1, r) {
                        return Array.isArray(r) && (r = r.reduce(t1, "")), e1 + r;
                    }, "");
                    function s(e1, r) {
                        if (null == t1[r]) throw Error("Reference " + r + "is undefined");
                        return t1[r];
                    }
                }
                function n(t1, n) {
                    return Array.isArray(t1) ? r(t1, n) : e1(t1, n);
                }
                n.parse = e1, n.stringify = r, t1.exports = n;
            },
            5137: function(t1, e1, r) {
                "use strict";
                var n = r(6807);
                t1.exports = function(t1) {
                    var e1;
                    return arguments.length > 1 && (t1 = arguments), "string" == typeof t1 ? t1 = t1.split(/\s/).map(parseFloat) : "number" == typeof t1 && (t1 = [
                        t1
                    ]), t1.length && "number" == typeof t1[0] ? e1 = 1 === t1.length ? {
                        width: t1[0],
                        height: t1[0],
                        x: 0,
                        y: 0
                    } : 2 === t1.length ? {
                        width: t1[0],
                        height: t1[1],
                        x: 0,
                        y: 0
                    } : {
                        x: t1[0],
                        y: t1[1],
                        width: t1[2] - t1[0] || 0,
                        height: t1[3] - t1[1] || 0
                    } : t1 && (e1 = {
                        x: (t1 = n(t1, {
                            left: "x l left Left",
                            top: "y t top Top",
                            width: "w width W Width",
                            height: "h height W Width",
                            bottom: "b bottom Bottom",
                            right: "r right Right"
                        })).left || 0,
                        y: t1.top || 0
                    }, null == t1.width ? t1.right ? e1.width = t1.right - e1.x : e1.width = 0 : e1.width = t1.width, null == t1.height ? t1.bottom ? e1.height = t1.bottom - e1.y : e1.height = 0 : e1.height = t1.height), e1;
                };
            },
            26953: function(t1) {
                t1.exports = function(t1) {
                    var i = [];
                    return t1.replace(r, function(t1, r, a) {
                        var o = r.toLowerCase();
                        for(a = function(t1) {
                            var e1 = t1.match(n);
                            return e1 ? e1.map(Number) : [];
                        }(a), "m" == o && a.length > 2 && (i.push([
                            r
                        ].concat(a.splice(0, 2))), o = "l", r = "m" == r ? "l" : "L");;){
                            if (a.length == e1[o]) return a.unshift(r), i.push(a);
                            if (a.length < e1[o]) throw new Error("malformed path data");
                            i.push([
                                r
                            ].concat(a.splice(0, e1[o])));
                        }
                    }), i;
                };
                var e1 = {
                    a: 7,
                    c: 6,
                    h: 1,
                    l: 2,
                    m: 2,
                    q: 4,
                    s: 4,
                    t: 2,
                    v: 1,
                    z: 0
                }, r = /([astvzqmhlc])([^astvzqmhlc]*)/gi, n = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/gi;
            },
            4957: function(t1) {
                t1.exports = function(t1, e1) {
                    e1 || (e1 = [
                        0,
                        ""
                    ]), t1 = String(t1);
                    var r = parseFloat(t1, 10);
                    return e1[0] = r, e1[1] = t1.match(/[\d.\-\+]*\s*(.*)/)[1] || "", e1;
                };
            },
            71879: function(t1, e1, r) {
                var n = r(33282);
                (function() {
                    var e1, r, i, a, o, s;
                    "undefined" != typeof performance && null !== performance && performance.now ? t1.exports = function() {
                        return performance.now();
                    } : null != n && n.hrtime ? (t1.exports = function() {
                        return (e1() - o) / 1e6;
                    }, r = n.hrtime, a = (e1 = function() {
                        var t1;
                        return 1e9 * (t1 = r())[0] + t1[1];
                    })(), s = 1e9 * n.uptime(), o = a - s) : Date.now ? (t1.exports = function() {
                        return Date.now() - i;
                    }, i = Date.now()) : (t1.exports = function() {
                        return (new Date).getTime() - i;
                    }, i = (new Date).getTime());
                }).call(this);
            },
            6807: function(t1) {
                "use strict";
                t1.exports = function(t1, e1, n) {
                    var i, a, o = {};
                    if ("string" == typeof e1 && (e1 = r(e1)), Array.isArray(e1)) {
                        var s = {};
                        for(a = 0; a < e1.length; a++)s[e1[a]] = !0;
                        e1 = s;
                    }
                    for(i in e1)e1[i] = r(e1[i]);
                    var l = {};
                    for(i in e1){
                        var c = e1[i];
                        if (Array.isArray(c)) for(a = 0; a < c.length; a++){
                            var u = c[a];
                            if (n && (l[u] = !0), u in t1) {
                                if (o[i] = t1[u], n) for(var h = a; h < c.length; h++)l[c[h]] = !0;
                                break;
                            }
                        }
                        else i in t1 && (e1[i] && (o[i] = t1[i]), n && (l[i] = !0));
                    }
                    if (n) for(i in t1)l[i] || (o[i] = t1[i]);
                    return o;
                };
                var e1 = {};
                function r(t1) {
                    return e1[t1] ? e1[t1] : ("string" == typeof t1 && (t1 = e1[t1] = t1.split(/\s*,\s*|\s+/)), t1);
                }
            },
            52773: function(t1) {
                t1.exports = function(t1, e1, r, n) {
                    var i = t1[0], a = t1[1], o = !1;
                    void 0 === r && (r = 0), void 0 === n && (n = e1.length);
                    for(var s = n - r, l = 0, c = s - 1; l < s; c = l++){
                        var u = e1[l + r][0], h = e1[l + r][1], f = e1[c + r][0], p = e1[c + r][1];
                        h > a != p > a && i < (f - u) * (a - h) / (p - h) + u && (o = !o);
                    }
                    return o;
                };
            },
            11516: function(t1, e1, r) {
                var n, i = r(42391), a = r(92990), o = r(26202), s = r(22222), l = r(17527), c = r(24491), u = !1, h = a();
                function f(t1, e1, r) {
                    var i = n.segments(t1), a = n.segments(e1), o = r(n.combine(i, a));
                    return n.polygon(o);
                }
                n = {
                    buildLog: function(t1) {
                        return !0 === t1 ? u = i() : !1 === t1 && (u = !1), !1 !== u && u.list;
                    },
                    epsilon: function(t1) {
                        return h.epsilon(t1);
                    },
                    segments: function(t1) {
                        var e1 = o(!0, h, u);
                        return t1.regions.forEach(e1.addRegion), {
                            segments: e1.calculate(t1.inverted),
                            inverted: t1.inverted
                        };
                    },
                    combine: function(t1, e1) {
                        return {
                            combined: o(!1, h, u).calculate(t1.segments, t1.inverted, e1.segments, e1.inverted),
                            inverted1: t1.inverted,
                            inverted2: e1.inverted
                        };
                    },
                    selectUnion: function(t1) {
                        return {
                            segments: l.union(t1.combined, u),
                            inverted: t1.inverted1 || t1.inverted2
                        };
                    },
                    selectIntersect: function(t1) {
                        return {
                            segments: l.intersect(t1.combined, u),
                            inverted: t1.inverted1 && t1.inverted2
                        };
                    },
                    selectDifference: function(t1) {
                        return {
                            segments: l.difference(t1.combined, u),
                            inverted: t1.inverted1 && !t1.inverted2
                        };
                    },
                    selectDifferenceRev: function(t1) {
                        return {
                            segments: l.differenceRev(t1.combined, u),
                            inverted: !t1.inverted1 && t1.inverted2
                        };
                    },
                    selectXor: function(t1) {
                        return {
                            segments: l.xor(t1.combined, u),
                            inverted: t1.inverted1 !== t1.inverted2
                        };
                    },
                    polygon: function(t1) {
                        return {
                            regions: s(t1.segments, h, u),
                            inverted: t1.inverted
                        };
                    },
                    polygonFromGeoJSON: function(t1) {
                        return c.toPolygon(n, t1);
                    },
                    polygonToGeoJSON: function(t1) {
                        return c.fromPolygon(n, h, t1);
                    },
                    union: function(t1, e1) {
                        return f(t1, e1, n.selectUnion);
                    },
                    intersect: function(t1, e1) {
                        return f(t1, e1, n.selectIntersect);
                    },
                    difference: function(t1, e1) {
                        return f(t1, e1, n.selectDifference);
                    },
                    differenceRev: function(t1, e1) {
                        return f(t1, e1, n.selectDifferenceRev);
                    },
                    xor: function(t1, e1) {
                        return f(t1, e1, n.selectXor);
                    }
                }, "object" == typeof window && (window.PolyBool = n), t1.exports = n;
            },
            42391: function(t1) {
                t1.exports = function() {
                    var t1, e1 = 0, r = !1;
                    function n(e1, r) {
                        return t1.list.push({
                            type: e1,
                            data: r ? JSON.parse(JSON.stringify(r)) : void 0
                        }), t1;
                    }
                    return t1 = {
                        list: [],
                        segmentId: function() {
                            return e1++;
                        },
                        checkIntersection: function(t1, e1) {
                            return n("check", {
                                seg1: t1,
                                seg2: e1
                            });
                        },
                        segmentChop: function(t1, e1) {
                            return n("div_seg", {
                                seg: t1,
                                pt: e1
                            }), n("chop", {
                                seg: t1,
                                pt: e1
                            });
                        },
                        statusRemove: function(t1) {
                            return n("pop_seg", {
                                seg: t1
                            });
                        },
                        segmentUpdate: function(t1) {
                            return n("seg_update", {
                                seg: t1
                            });
                        },
                        segmentNew: function(t1, e1) {
                            return n("new_seg", {
                                seg: t1,
                                primary: e1
                            });
                        },
                        segmentRemove: function(t1) {
                            return n("rem_seg", {
                                seg: t1
                            });
                        },
                        tempStatus: function(t1, e1, r) {
                            return n("temp_status", {
                                seg: t1,
                                above: e1,
                                below: r
                            });
                        },
                        rewind: function(t1) {
                            return n("rewind", {
                                seg: t1
                            });
                        },
                        status: function(t1, e1, r) {
                            return n("status", {
                                seg: t1,
                                above: e1,
                                below: r
                            });
                        },
                        vert: function(e1) {
                            return e1 === r ? t1 : (r = e1, n("vert", {
                                x: e1
                            }));
                        },
                        log: function(t1) {
                            return "string" != typeof t1 && (t1 = JSON.stringify(t1, !1, "  ")), n("log", {
                                txt: t1
                            });
                        },
                        reset: function() {
                            return n("reset");
                        },
                        selected: function(t1) {
                            return n("selected", {
                                segs: t1
                            });
                        },
                        chainStart: function(t1) {
                            return n("chain_start", {
                                seg: t1
                            });
                        },
                        chainRemoveHead: function(t1, e1) {
                            return n("chain_rem_head", {
                                index: t1,
                                pt: e1
                            });
                        },
                        chainRemoveTail: function(t1, e1) {
                            return n("chain_rem_tail", {
                                index: t1,
                                pt: e1
                            });
                        },
                        chainNew: function(t1, e1) {
                            return n("chain_new", {
                                pt1: t1,
                                pt2: e1
                            });
                        },
                        chainMatch: function(t1) {
                            return n("chain_match", {
                                index: t1
                            });
                        },
                        chainClose: function(t1) {
                            return n("chain_close", {
                                index: t1
                            });
                        },
                        chainAddHead: function(t1, e1) {
                            return n("chain_add_head", {
                                index: t1,
                                pt: e1
                            });
                        },
                        chainAddTail: function(t1, e1) {
                            return n("chain_add_tail", {
                                index: t1,
                                pt: e1
                            });
                        },
                        chainConnect: function(t1, e1) {
                            return n("chain_con", {
                                index1: t1,
                                index2: e1
                            });
                        },
                        chainReverse: function(t1) {
                            return n("chain_rev", {
                                index: t1
                            });
                        },
                        chainJoin: function(t1, e1) {
                            return n("chain_join", {
                                index1: t1,
                                index2: e1
                            });
                        },
                        done: function() {
                            return n("done");
                        }
                    };
                };
            },
            92990: function(t1) {
                t1.exports = function(t1) {
                    "number" != typeof t1 && (t1 = 1e-10);
                    var e1 = {
                        epsilon: function(e1) {
                            return "number" == typeof e1 && (t1 = e1), t1;
                        },
                        pointAboveOrOnLine: function(e1, r, n) {
                            var i = r[0], a = r[1], o = n[0], s = n[1], l = e1[0];
                            return (o - i) * (e1[1] - a) - (s - a) * (l - i) >= -t1;
                        },
                        pointBetween: function(e1, r, n) {
                            var i = e1[1] - r[1], a = n[0] - r[0], o = e1[0] - r[0], s = n[1] - r[1], l = o * a + i * s;
                            return !(l < t1 || l - (a * a + s * s) > -t1);
                        },
                        pointsSameX: function(e1, r) {
                            return Math.abs(e1[0] - r[0]) < t1;
                        },
                        pointsSameY: function(e1, r) {
                            return Math.abs(e1[1] - r[1]) < t1;
                        },
                        pointsSame: function(t1, r) {
                            return e1.pointsSameX(t1, r) && e1.pointsSameY(t1, r);
                        },
                        pointsCompare: function(t1, r) {
                            return e1.pointsSameX(t1, r) ? e1.pointsSameY(t1, r) ? 0 : t1[1] < r[1] ? -1 : 1 : t1[0] < r[0] ? -1 : 1;
                        },
                        pointsCollinear: function(e1, r, n) {
                            var i = e1[0] - r[0], a = e1[1] - r[1], o = r[0] - n[0], s = r[1] - n[1];
                            return Math.abs(i * s - o * a) < t1;
                        },
                        linesIntersect: function(e1, r, n, i) {
                            var a = r[0] - e1[0], o = r[1] - e1[1], s = i[0] - n[0], l = i[1] - n[1], c = a * l - o * s;
                            if (Math.abs(c) < t1) return !1;
                            var u = e1[0] - n[0], h = e1[1] - n[1], f = (s * h - l * u) / c, p = (a * h - o * u) / c, d = {
                                alongA: 0,
                                alongB: 0,
                                pt: [
                                    e1[0] + f * a,
                                    e1[1] + f * o
                                ]
                            };
                            return d.alongA = f <= -t1 ? -2 : f < t1 ? -1 : f - 1 <= -t1 ? 0 : f - 1 < t1 ? 1 : 2, d.alongB = p <= -t1 ? -2 : p < t1 ? -1 : p - 1 <= -t1 ? 0 : p - 1 < t1 ? 1 : 2, d;
                        },
                        pointInsideRegion: function(e1, r) {
                            for(var n = e1[0], i = e1[1], a = r[r.length - 1][0], o = r[r.length - 1][1], s = !1, l = 0; l < r.length; l++){
                                var c = r[l][0], u = r[l][1];
                                u - i > t1 != o - i > t1 && (a - c) * (i - u) / (o - u) + c - n > t1 && (s = !s), a = c, o = u;
                            }
                            return s;
                        }
                    };
                    return e1;
                };
            },
            24491: function(t1) {
                var e1 = {
                    toPolygon: function(t1, e1) {
                        function r(e1) {
                            if (e1.length <= 0) return t1.segments({
                                inverted: !1,
                                regions: []
                            });
                            function r(e1) {
                                var r = e1.slice(0, e1.length - 1);
                                return t1.segments({
                                    inverted: !1,
                                    regions: [
                                        r
                                    ]
                                });
                            }
                            for(var n = r(e1[0]), i = 1; i < e1.length; i++)n = t1.selectDifference(t1.combine(n, r(e1[i])));
                            return n;
                        }
                        if ("Polygon" === e1.type) return t1.polygon(r(e1.coordinates));
                        if ("MultiPolygon" === e1.type) {
                            for(var n = t1.segments({
                                inverted: !1,
                                regions: []
                            }), i = 0; i < e1.coordinates.length; i++)n = t1.selectUnion(t1.combine(n, r(e1.coordinates[i])));
                            return t1.polygon(n);
                        }
                        throw new Error("PolyBool: Cannot convert GeoJSON object to PolyBool polygon");
                    },
                    fromPolygon: function(t1, e1, r) {
                        function n(t1, r) {
                            return e1.pointInsideRegion([
                                .5 * (t1[0][0] + t1[1][0]),
                                .5 * (t1[0][1] + t1[1][1])
                            ], r);
                        }
                        function i(t1) {
                            return {
                                region: t1,
                                children: []
                            };
                        }
                        r = t1.polygon(t1.segments(r));
                        var a = i(null);
                        function o(t1, e1) {
                            for(var r = 0; r < t1.children.length; r++)if (n(e1, (s = t1.children[r]).region)) return void o(s, e1);
                            var a = i(e1);
                            for(r = 0; r < t1.children.length; r++){
                                var s;
                                n((s = t1.children[r]).region, e1) && (a.children.push(s), t1.children.splice(r, 1), r--);
                            }
                            t1.children.push(a);
                        }
                        for(var s = 0; s < r.regions.length; s++){
                            var l = r.regions[s];
                            l.length < 3 || o(a, l);
                        }
                        function c(t1, e1) {
                            for(var r = 0, n = t1[t1.length - 1][0], i = t1[t1.length - 1][1], a = [], o = 0; o < t1.length; o++){
                                var s = t1[o][0], l = t1[o][1];
                                a.push([
                                    s,
                                    l
                                ]), r += l * n - s * i, n = s, i = l;
                            }
                            return r < 0 !== e1 && a.reverse(), a.push([
                                a[0][0],
                                a[0][1]
                            ]), a;
                        }
                        var u = [];
                        function h(t1) {
                            var e1 = [
                                c(t1.region, !1)
                            ];
                            u.push(e1);
                            for(var r = 0; r < t1.children.length; r++)e1.push(f(t1.children[r]));
                        }
                        function f(t1) {
                            for(var e1 = 0; e1 < t1.children.length; e1++)h(t1.children[e1]);
                            return c(t1.region, !0);
                        }
                        for(s = 0; s < a.children.length; s++)h(a.children[s]);
                        return u.length <= 0 ? {
                            type: "Polygon",
                            coordinates: []
                        } : 1 == u.length ? {
                            type: "Polygon",
                            coordinates: u[0]
                        } : {
                            type: "MultiPolygon",
                            coordinates: u
                        };
                    }
                };
                t1.exports = e1;
            },
            26202: function(t1, e1, r) {
                var n = r(48916);
                t1.exports = function(t1, e1, r) {
                    function i(t1, e1, n) {
                        return {
                            id: r ? r.segmentId() : -1,
                            start: t1,
                            end: e1,
                            myFill: {
                                above: n.myFill.above,
                                below: n.myFill.below
                            },
                            otherFill: null
                        };
                    }
                    var a = n.create();
                    function o(t1, r) {
                        a.insertBefore(t1, function(n) {
                            var i, a, o, s, l, c, u;
                            return i = t1.isStart, a = t1.pt, o = r, s = n.isStart, l = n.pt, c = n.other.pt, (0 !== (u = e1.pointsCompare(a, l)) ? u : e1.pointsSame(o, c) ? 0 : i !== s ? i ? 1 : -1 : e1.pointAboveOrOnLine(o, s ? l : c, s ? c : l) ? 1 : -1) < 0;
                        });
                    }
                    function s(t1, e1) {
                        var r = function(t1, e1) {
                            var r = n.node({
                                isStart: !0,
                                pt: t1.start,
                                seg: t1,
                                primary: e1,
                                other: null,
                                status: null
                            });
                            return o(r, t1.end), r;
                        }(t1, e1);
                        return function(t1, e1, r) {
                            var i = n.node({
                                isStart: !1,
                                pt: e1.end,
                                seg: e1,
                                primary: r,
                                other: t1,
                                status: null
                            });
                            t1.other = i, o(i, t1.pt);
                        }(r, t1, e1), r;
                    }
                    function l(t1, e1) {
                        var n = i(e1, t1.seg.end, t1.seg);
                        return function(t1, e1) {
                            r && r.segmentChop(t1.seg, e1), t1.other.remove(), t1.seg.end = e1, t1.other.pt = e1, o(t1.other, t1.pt);
                        }(t1, e1), s(n, t1.primary);
                    }
                    function c(i, o) {
                        var s = n.create();
                        function c(t1) {
                            return s.findTransition(function(r) {
                                var n, i, a, o, s, l;
                                return n = t1, i = r.ev, a = n.seg.start, o = n.seg.end, s = i.seg.start, l = i.seg.end, (e1.pointsCollinear(a, s, l) ? e1.pointsCollinear(o, s, l) || e1.pointAboveOrOnLine(o, s, l) ? 1 : -1 : e1.pointAboveOrOnLine(a, s, l) ? 1 : -1) > 0;
                            });
                        }
                        function u(t1, n) {
                            var i = t1.seg, a = n.seg, o = i.start, s = i.end, c = a.start, u = a.end;
                            r && r.checkIntersection(i, a);
                            var h = e1.linesIntersect(o, s, c, u);
                            if (!1 === h) {
                                if (!e1.pointsCollinear(o, s, c)) return !1;
                                if (e1.pointsSame(o, u) || e1.pointsSame(s, c)) return !1;
                                var f = e1.pointsSame(o, c), p = e1.pointsSame(s, u);
                                if (f && p) return n;
                                var d = !f && e1.pointBetween(o, c, u), m = !p && e1.pointBetween(s, c, u);
                                if (f) return m ? l(n, s) : l(t1, u), n;
                                d && (p || (m ? l(n, s) : l(t1, u)), l(n, o));
                            } else 0 === h.alongA && (-1 === h.alongB ? l(t1, c) : 0 === h.alongB ? l(t1, h.pt) : 1 === h.alongB && l(t1, u)), 0 === h.alongB && (-1 === h.alongA ? l(n, o) : 0 === h.alongA ? l(n, h.pt) : 1 === h.alongA && l(n, s));
                            return !1;
                        }
                        for(var h = []; !a.isEmpty();){
                            var f = a.getHead();
                            if (r && r.vert(f.pt[0]), f.isStart) {
                                r && r.segmentNew(f.seg, f.primary);
                                var p = c(f), d = p.before ? p.before.ev : null, m = p.after ? p.after.ev : null;
                                function g() {
                                    if (d) {
                                        var t1 = u(f, d);
                                        if (t1) return t1;
                                    }
                                    return !!m && u(f, m);
                                }
                                r && r.tempStatus(f.seg, !!d && d.seg, !!m && m.seg);
                                var y, v, x = g();
                                if (x) t1 ? (v = null === f.seg.myFill.below || f.seg.myFill.above !== f.seg.myFill.below) && (x.seg.myFill.above = !x.seg.myFill.above) : x.seg.otherFill = f.seg.myFill, r && r.segmentUpdate(x.seg), f.other.remove(), f.remove();
                                if (a.getHead() !== f) {
                                    r && r.rewind(f.seg);
                                    continue;
                                }
                                t1 ? (v = null === f.seg.myFill.below || f.seg.myFill.above !== f.seg.myFill.below, f.seg.myFill.below = m ? m.seg.myFill.above : i, f.seg.myFill.above = v ? !f.seg.myFill.below : f.seg.myFill.below) : null === f.seg.otherFill && (y = m ? f.primary === m.primary ? m.seg.otherFill.above : m.seg.myFill.above : f.primary ? o : i, f.seg.otherFill = {
                                    above: y,
                                    below: y
                                }), r && r.status(f.seg, !!d && d.seg, !!m && m.seg), f.other.status = p.insert(n.node({
                                    ev: f
                                }));
                            } else {
                                var _ = f.status;
                                if (null === _) throw new Error("PolyBool: Zero-length segment detected; your epsilon is probably too small or too large");
                                if (s.exists(_.prev) && s.exists(_.next) && u(_.prev.ev, _.next.ev), r && r.statusRemove(_.ev.seg), _.remove(), !f.primary) {
                                    var b = f.seg.myFill;
                                    f.seg.myFill = f.seg.otherFill, f.seg.otherFill = b;
                                }
                                h.push(f.seg);
                            }
                            a.getHead().remove();
                        }
                        return r && r.done(), h;
                    }
                    return t1 ? {
                        addRegion: function(t1) {
                            for(var n, i, a, o = t1[t1.length - 1], l = 0; l < t1.length; l++){
                                n = o, o = t1[l];
                                var c = e1.pointsCompare(n, o);
                                0 !== c && s((i = c < 0 ? n : o, a = c < 0 ? o : n, {
                                    id: r ? r.segmentId() : -1,
                                    start: i,
                                    end: a,
                                    myFill: {
                                        above: null,
                                        below: null
                                    },
                                    otherFill: null
                                }), !0);
                            }
                        },
                        calculate: function(t1) {
                            return c(t1, !1);
                        }
                    } : {
                        calculate: function(t1, e1, r, n) {
                            return t1.forEach(function(t1) {
                                s(i(t1.start, t1.end, t1), !0);
                            }), r.forEach(function(t1) {
                                s(i(t1.start, t1.end, t1), !1);
                            }), c(e1, n);
                        }
                    };
                };
            },
            48916: function(t1) {
                t1.exports = {
                    create: function() {
                        var t1 = {
                            root: {
                                root: !0,
                                next: null
                            },
                            exists: function(e1) {
                                return null !== e1 && e1 !== t1.root;
                            },
                            isEmpty: function() {
                                return null === t1.root.next;
                            },
                            getHead: function() {
                                return t1.root.next;
                            },
                            insertBefore: function(e1, r) {
                                for(var n = t1.root, i = t1.root.next; null !== i;){
                                    if (r(i)) return e1.prev = i.prev, e1.next = i, i.prev.next = e1, void (i.prev = e1);
                                    n = i, i = i.next;
                                }
                                n.next = e1, e1.prev = n, e1.next = null;
                            },
                            findTransition: function(e1) {
                                for(var r = t1.root, n = t1.root.next; null !== n && !e1(n);)r = n, n = n.next;
                                return {
                                    before: r === t1.root ? null : r,
                                    after: n,
                                    insert: function(t1) {
                                        return t1.prev = r, t1.next = n, r.next = t1, null !== n && (n.prev = t1), t1;
                                    }
                                };
                            }
                        };
                        return t1;
                    },
                    node: function(t1) {
                        return t1.prev = null, t1.next = null, t1.remove = function() {
                            t1.prev.next = t1.next, t1.next && (t1.next.prev = t1.prev), t1.prev = null, t1.next = null;
                        }, t1;
                    }
                };
            },
            22222: function(t1) {
                t1.exports = function(t1, e1, r) {
                    var n = [], i = [];
                    return t1.forEach(function(t1) {
                        var a = t1.start, o = t1.end;
                        if (e1.pointsSame(a, o)) console.warn("PolyBool: Warning: Zero-length segment detected; your epsilon is probably too small or too large");
                        else {
                            r && r.chainStart(t1);
                            for(var s = {
                                index: 0,
                                matches_head: !1,
                                matches_pt1: !1
                            }, l = {
                                index: 0,
                                matches_head: !1,
                                matches_pt1: !1
                            }, c = s, u = 0; u < n.length; u++){
                                var h = (g = n[u])[0], f = (g[1], g[g.length - 1]);
                                if (g[g.length - 2], e1.pointsSame(h, a)) {
                                    if (k(u, !0, !0)) break;
                                } else if (e1.pointsSame(h, o)) {
                                    if (k(u, !0, !1)) break;
                                } else if (e1.pointsSame(f, a)) {
                                    if (k(u, !1, !0)) break;
                                } else if (e1.pointsSame(f, o) && k(u, !1, !1)) break;
                            }
                            if (c === s) return n.push([
                                a,
                                o
                            ]), void (r && r.chainNew(a, o));
                            if (c === l) {
                                r && r.chainMatch(s.index);
                                var p = s.index, d = s.matches_pt1 ? o : a, m = s.matches_head, g = n[p], y = m ? g[0] : g[g.length - 1], v = m ? g[1] : g[g.length - 2], x = m ? g[g.length - 1] : g[0], _ = m ? g[g.length - 2] : g[1];
                                return e1.pointsCollinear(v, y, d) && (m ? (r && r.chainRemoveHead(s.index, d), g.shift()) : (r && r.chainRemoveTail(s.index, d), g.pop()), y = v), e1.pointsSame(x, d) ? (n.splice(p, 1), e1.pointsCollinear(_, x, y) && (m ? (r && r.chainRemoveTail(s.index, y), g.pop()) : (r && r.chainRemoveHead(s.index, y), g.shift())), r && r.chainClose(s.index), void i.push(g)) : void (m ? (r && r.chainAddHead(s.index, d), g.unshift(d)) : (r && r.chainAddTail(s.index, d), g.push(d)));
                            }
                            var b = s.index, w = l.index;
                            r && r.chainConnect(b, w);
                            var T = n[b].length < n[w].length;
                            s.matches_head ? l.matches_head ? T ? (A(b), M(b, w)) : (A(w), M(w, b)) : M(w, b) : l.matches_head ? M(b, w) : T ? (A(b), M(w, b)) : (A(w), M(b, w));
                        }
                        function k(t1, e1, r) {
                            return c.index = t1, c.matches_head = e1, c.matches_pt1 = r, c === s ? (c = l, !1) : (c = null, !0);
                        }
                        function A(t1) {
                            r && r.chainReverse(t1), n[t1].reverse();
                        }
                        function M(t1, i) {
                            var a = n[t1], o = n[i], s = a[a.length - 1], l = a[a.length - 2], c = o[0], u = o[1];
                            e1.pointsCollinear(l, s, c) && (r && r.chainRemoveTail(t1, s), a.pop(), s = l), e1.pointsCollinear(s, c, u) && (r && r.chainRemoveHead(i, c), o.shift()), r && r.chainJoin(t1, i), n[t1] = a.concat(o), n.splice(i, 1);
                        }
                    }), i;
                };
            },
            17527: function(t1) {
                function e1(t1, e1, r) {
                    var n = [];
                    return t1.forEach(function(t1) {
                        var i = (t1.myFill.above ? 8 : 0) + (t1.myFill.below ? 4 : 0) + (t1.otherFill && t1.otherFill.above ? 2 : 0) + (t1.otherFill && t1.otherFill.below ? 1 : 0);
                        0 !== e1[i] && n.push({
                            id: r ? r.segmentId() : -1,
                            start: t1.start,
                            end: t1.end,
                            myFill: {
                                above: 1 === e1[i],
                                below: 2 === e1[i]
                            },
                            otherFill: null
                        });
                    }), r && r.selected(n), n;
                }
                var r = {
                    union: function(t1, r) {
                        return e1(t1, [
                            0,
                            2,
                            1,
                            0,
                            2,
                            2,
                            0,
                            0,
                            1,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            0
                        ], r);
                    },
                    intersect: function(t1, r) {
                        return e1(t1, [
                            0,
                            0,
                            0,
                            0,
                            0,
                            2,
                            0,
                            2,
                            0,
                            0,
                            1,
                            1,
                            0,
                            2,
                            1,
                            0
                        ], r);
                    },
                    difference: function(t1, r) {
                        return e1(t1, [
                            0,
                            0,
                            0,
                            0,
                            2,
                            0,
                            2,
                            0,
                            1,
                            1,
                            0,
                            0,
                            0,
                            1,
                            2,
                            0
                        ], r);
                    },
                    differenceRev: function(t1, r) {
                        return e1(t1, [
                            0,
                            2,
                            1,
                            0,
                            0,
                            0,
                            1,
                            1,
                            0,
                            2,
                            0,
                            2,
                            0,
                            0,
                            0,
                            0
                        ], r);
                    },
                    xor: function(t1, r) {
                        return e1(t1, [
                            0,
                            2,
                            1,
                            0,
                            2,
                            0,
                            0,
                            1,
                            1,
                            0,
                            0,
                            2,
                            0,
                            1,
                            2,
                            0
                        ], r);
                    }
                };
                t1.exports = r;
            },
            3944: function(t1, e1, r) {
                "use strict";
                var n = r(90386).Transform, i = r(79743);
                function a() {
                    n.call(this, {
                        readableObjectMode: !0
                    });
                }
                function o(t1, e1, r) {
                    Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = (new Error).stack || "", this.name = this.constructor.name, this.message = t1, e1 && (this.code = e1), r && (this.statusCode = r);
                }
                a.prototype = Object.create(n.prototype), a.prototype.constructor = a, i(a.prototype), e1.rU = function(t1, e1, r) {
                    for(var n = e1, i = 0; i < r.length;)if (t1[n++] !== r[i++]) return !1;
                    return !0;
                }, e1.VG = function(t1, e1) {
                    var r = [], n = 0;
                    if (e1 && "hex" === e1) for(; n < t1.length;)r.push(parseInt(t1.slice(n, n + 2), 16)), n += 2;
                    else for(; n < t1.length; n++)r.push(255 & t1.charCodeAt(n));
                    return r;
                }, e1.$l = function(t1, e1) {
                    return t1[e1] | t1[e1 + 1] << 8;
                }, e1.bc = function(t1, e1) {
                    return t1[e1 + 1] | t1[e1] << 8;
                }, e1.tF = function(t1, e1) {
                    return t1[e1] | t1[e1 + 1] << 8 | t1[e1 + 2] << 16 | 16777216 * t1[e1 + 3];
                }, e1.bb = function(t1, e1) {
                    return t1[e1 + 3] | t1[e1 + 2] << 8 | t1[e1 + 1] << 16 | 16777216 * t1[e1];
                }, o.prototype = Object.create(Error.prototype), o.prototype.constructor = o;
            },
            19789: function(t1) {
                "use strict";
                function e1(t1, e1) {
                    var r = new Error(t1);
                    return r.code = e1, r;
                }
                function r(t1) {
                    try {
                        return decodeURIComponent(escape(t1));
                    } catch (e1) {
                        return t1;
                    }
                }
                function n(t1, r, n) {
                    this.input = t1.subarray(r, n), this.start = r;
                    var i = String.fromCharCode.apply(null, this.input.subarray(0, 4));
                    if ("II*\0" !== i && "MM\0*" !== i) throw e1("invalid TIFF signature", "EBADDATA");
                    this.big_endian = "M" === i[0];
                }
                n.prototype.each = function(t1) {
                    this.aborted = !1;
                    var e1 = this.read_uint32(4);
                    for(this.ifds_to_read = [
                        {
                            id: 0,
                            offset: e1
                        }
                    ]; this.ifds_to_read.length > 0 && !this.aborted;){
                        var r = this.ifds_to_read.shift();
                        r.offset && this.scan_ifd(r.id, r.offset, t1);
                    }
                }, n.prototype.read_uint16 = function(t1) {
                    var r = this.input;
                    if (t1 + 2 > r.length) throw e1("unexpected EOF", "EBADDATA");
                    return this.big_endian ? 256 * r[t1] + r[t1 + 1] : r[t1] + 256 * r[t1 + 1];
                }, n.prototype.read_uint32 = function(t1) {
                    var r = this.input;
                    if (t1 + 4 > r.length) throw e1("unexpected EOF", "EBADDATA");
                    return this.big_endian ? 16777216 * r[t1] + 65536 * r[t1 + 1] + 256 * r[t1 + 2] + r[t1 + 3] : r[t1] + 256 * r[t1 + 1] + 65536 * r[t1 + 2] + 16777216 * r[t1 + 3];
                }, n.prototype.is_subifd_link = function(t1, e1) {
                    return 0 === t1 && 34665 === e1 || 0 === t1 && 34853 === e1 || 34665 === t1 && 40965 === e1;
                }, n.prototype.exif_format_length = function(t1) {
                    switch(t1){
                        case 1:
                        case 2:
                        case 6:
                        case 7:
                            return 1;
                        case 3:
                        case 8:
                            return 2;
                        case 4:
                        case 9:
                        case 11:
                            return 4;
                        case 5:
                        case 10:
                        case 12:
                            return 8;
                        default:
                            return 0;
                    }
                }, n.prototype.exif_format_read = function(t1, e1) {
                    var r;
                    switch(t1){
                        case 1:
                        case 2:
                            return this.input[e1];
                        case 6:
                            return (r = this.input[e1]) | 33554430 * (128 & r);
                        case 3:
                            return this.read_uint16(e1);
                        case 8:
                            return (r = this.read_uint16(e1)) | 131070 * (32768 & r);
                        case 4:
                            return this.read_uint32(e1);
                        case 9:
                            return 0 | this.read_uint32(e1);
                        default:
                            return null;
                    }
                }, n.prototype.scan_ifd = function(t1, n, i) {
                    var a = this.read_uint16(n);
                    n += 2;
                    for(var o = 0; o < a; o++){
                        var s = this.read_uint16(n), l = this.read_uint16(n + 2), c = this.read_uint32(n + 4), u = this.exif_format_length(l), h = c * u, f = h <= 4 ? n + 8 : this.read_uint32(n + 8), p = !1;
                        if (f + h > this.input.length) throw e1("unexpected EOF", "EBADDATA");
                        for(var d = [], m = f, g = 0; g < c; g++, m += u){
                            var y = this.exif_format_read(l, m);
                            if (null === y) {
                                d = null;
                                break;
                            }
                            d.push(y);
                        }
                        if (Array.isArray(d) && 2 === l && (d = r(String.fromCharCode.apply(null, d))) && "\0" === d[d.length - 1] && (d = d.slice(0, -1)), this.is_subifd_link(t1, s) && Array.isArray(d) && Number.isInteger(d[0]) && d[0] > 0 && (this.ifds_to_read.push({
                            id: s,
                            offset: d[0]
                        }), p = !0), !1 === i({
                            is_big_endian: this.big_endian,
                            ifd: t1,
                            tag: s,
                            format: l,
                            count: c,
                            entry_offset: n + this.start,
                            data_length: h,
                            data_offset: f + this.start,
                            value: d,
                            is_subifd_link: p
                        })) return void (this.aborted = !0);
                        n += 12;
                    }
                    0 === t1 && this.ifds_to_read.push({
                        id: 1,
                        offset: this.read_uint32(n)
                    });
                }, t1.exports.ExifParser = n, t1.exports.get_orientation = function(t1) {
                    var e1 = 0;
                    try {
                        return new n(t1, 0, t1.length).each(function(t1) {
                            if (0 === t1.ifd && 274 === t1.tag && Array.isArray(t1.value)) return e1 = t1.value[0], !1;
                        }), e1;
                    } catch (t1) {
                        return -1;
                    }
                };
            },
            20186: function(t1, e1, r) {
                "use strict";
                var n = r(3944).bc, i = r(3944).bb;
                function a(t1, e1) {
                    if (t1.length < 4 + e1) return null;
                    var r = i(t1, e1);
                    return t1.length < r + e1 || r < 8 ? null : {
                        boxtype: String.fromCharCode.apply(null, t1.slice(e1 + 4, e1 + 8)),
                        data: t1.slice(e1 + 8, e1 + r),
                        end: e1 + r
                    };
                }
                function o(t1, e1) {
                    for(var r = 0;;){
                        var n = a(t1, r);
                        if (!n) break;
                        switch(n.boxtype){
                            case "ispe":
                                e1.sizes.push({
                                    width: i(n.data, 4),
                                    height: i(n.data, 8)
                                });
                                break;
                            case "irot":
                                e1.transforms.push({
                                    type: "irot",
                                    value: 3 & n.data[0]
                                });
                                break;
                            case "imir":
                                e1.transforms.push({
                                    type: "imir",
                                    value: 1 & n.data[0]
                                });
                        }
                        r = n.end;
                    }
                }
                function s(t1, e1, r) {
                    for(var n = 0, i = 0; i < r; i++)n = 256 * n + (t1[e1 + i] || 0);
                    return n;
                }
                function l(t1, e1) {
                    for(var r = t1[4] >> 4 & 15, i = 15 & t1[4], a = t1[5] >> 4 & 15, o = n(t1, 6), l = 8, c = 0; c < o; c++){
                        var u = n(t1, l), h = n(t1, l += 2), f = s(t1, l += 2, a), p = n(t1, l += a);
                        if (l += 2, 0 === h && 1 === p) {
                            var d = s(t1, l, r), m = s(t1, l + r, i);
                            e1.item_loc[u] = {
                                length: m,
                                offset: d + f
                            };
                        }
                        l += p * (r + i);
                    }
                }
                function c(t1, e1) {
                    for(var r = n(t1, 4), i = 6, o = 0; o < r; o++){
                        var s = a(t1, i);
                        if (!s) break;
                        if ("infe" === s.boxtype) {
                            for(var l = n(s.data, 4), c = "", u = 8; u < s.data.length && s.data[u]; u++)c += String.fromCharCode(s.data[u]);
                            e1.item_inf[c] = l;
                        }
                        i = s.end;
                    }
                }
                function u(t1, e1) {
                    for(var r = 0;;){
                        var n = a(t1, r);
                        if (!n) break;
                        "ipco" === n.boxtype && o(n.data, e1), r = n.end;
                    }
                }
                t1.exports.unbox = a, t1.exports.readSizeFromMeta = function(t1) {
                    var e1 = {
                        sizes: [],
                        transforms: [],
                        item_inf: {},
                        item_loc: {}
                    };
                    if (function(t1, e1) {
                        for(var r = 4;;){
                            var n = a(t1, r);
                            if (!n) break;
                            "iprp" === n.boxtype && u(n.data, e1), "iloc" === n.boxtype && l(n.data, e1), "iinf" === n.boxtype && c(n.data, e1), r = n.end;
                        }
                    }(t1, e1), e1.sizes.length) {
                        var r, n, i, o = (n = (r = e1.sizes).reduce(function(t1, e1) {
                            return t1.width > e1.width || t1.width === e1.width && t1.height > e1.height ? t1 : e1;
                        }), i = r.reduce(function(t1, e1) {
                            return t1.height > e1.height || t1.height === e1.height && t1.width > e1.width ? t1 : e1;
                        }), n.width > i.height || n.width === i.height && n.height > i.width ? n : i), s = 1;
                        e1.transforms.forEach(function(t1) {
                            var e1 = {
                                1: 6,
                                2: 5,
                                3: 8,
                                4: 7,
                                5: 4,
                                6: 3,
                                7: 2,
                                8: 1
                            }, r = {
                                1: 4,
                                2: 3,
                                3: 2,
                                4: 1,
                                5: 6,
                                6: 5,
                                7: 8,
                                8: 7
                            };
                            if ("imir" === t1.type && (s = 0 === t1.value ? r[s] : e1[s = e1[s = r[s]]]), "irot" === t1.type) for(var n = 0; n < t1.value; n++)s = e1[s];
                        });
                        var h = null;
                        return e1.item_inf.Exif && (h = e1.item_loc[e1.item_inf.Exif]), {
                            width: o.width,
                            height: o.height,
                            orientation: e1.transforms.length ? s : null,
                            variants: e1.sizes,
                            exif_location: h
                        };
                    }
                }, t1.exports.getMimeType = function(t1) {
                    var e1 = String.fromCharCode.apply(null, t1.slice(0, 4)), r = {};
                    r[e1] = !0;
                    for(var n = 8; n < t1.length; n += 4)r[String.fromCharCode.apply(null, t1.slice(n, n + 4))] = !0;
                    if (r.mif1 || r.msf1 || r.miaf) return "avif" === e1 || "avis" === e1 || "avio" === e1 ? {
                        type: "avif",
                        mime: "image/avif"
                    } : "heic" === e1 || "heix" === e1 ? {
                        type: "heic",
                        mime: "image/heic"
                    } : "hevc" === e1 || "hevx" === e1 ? {
                        type: "heic",
                        mime: "image/heic-sequence"
                    } : r.avif || r.avis ? {
                        type: "avif",
                        mime: "image/avif"
                    } : r.heic || r.heix || r.hevc || r.hevx || r.heis ? r.msf1 ? {
                        type: "heif",
                        mime: "image/heif-sequence"
                    } : {
                        type: "heif",
                        mime: "image/heif"
                    } : {
                        type: "avif",
                        mime: "image/avif"
                    };
                };
            },
            31149: function(t1, e1, r) {
                "use strict";
                var n = r(3944).VG, i = r(3944).rU, a = r(3944).bb, o = r(20186), s = r(19789), l = n("ftyp");
                t1.exports = function(t1) {
                    if (i(t1, 4, l)) {
                        var e1 = o.unbox(t1, 0);
                        if (e1) {
                            var r = o.getMimeType(e1.data);
                            if (r) {
                                for(var n, c = e1.end;;){
                                    var u = o.unbox(t1, c);
                                    if (!u) break;
                                    if (c = u.end, "mdat" === u.boxtype) return;
                                    if ("meta" === u.boxtype) {
                                        n = u.data;
                                        break;
                                    }
                                }
                                if (n) {
                                    var h = o.readSizeFromMeta(n);
                                    if (h) {
                                        var f = {
                                            width: h.width,
                                            height: h.height,
                                            type: r.type,
                                            mime: r.mime,
                                            wUnits: "px",
                                            hUnits: "px"
                                        };
                                        if (h.variants.length > 1 && (f.variants = h.variants), h.orientation && (f.orientation = h.orientation), h.exif_location && h.exif_location.offset + h.exif_location.length <= t1.length) {
                                            var p = a(t1, h.exif_location.offset), d = t1.slice(h.exif_location.offset + p + 4, h.exif_location.offset + h.exif_location.length), m = s.get_orientation(d);
                                            m > 0 && (f.orientation = m);
                                        }
                                        return f;
                                    }
                                }
                            }
                        }
                    }
                };
            },
            78218: function(t1, e1, r) {
                "use strict";
                var n = r(3944).VG, i = r(3944).rU, a = r(3944).$l, o = n("BM");
                t1.exports = function(t1) {
                    if (!(t1.length < 26) && i(t1, 0, o)) return {
                        width: a(t1, 18),
                        height: a(t1, 22),
                        type: "bmp",
                        mime: "image/bmp",
                        wUnits: "px",
                        hUnits: "px"
                    };
                };
            },
            37495: function(t1, e1, r) {
                "use strict";
                var n = r(3944).VG, i = r(3944).rU, a = r(3944).$l, o = n("GIF87a"), s = n("GIF89a");
                t1.exports = function(t1) {
                    if (!(t1.length < 10) && (i(t1, 0, o) || i(t1, 0, s))) return {
                        width: a(t1, 6),
                        height: a(t1, 8),
                        type: "gif",
                        mime: "image/gif",
                        wUnits: "px",
                        hUnits: "px"
                    };
                };
            },
            88708: function(t1, e1, r) {
                "use strict";
                var n = r(3944).$l;
                t1.exports = function(t1) {
                    var e1 = n(t1, 0), r = n(t1, 2), i = n(t1, 4);
                    if (0 === e1 && 1 === r && i) {
                        for(var a = [], o = {
                            width: 0,
                            height: 0
                        }, s = 0; s < i; s++){
                            var l = t1[6 + 16 * s] || 256, c = t1[6 + 16 * s + 1] || 256, u = {
                                width: l,
                                height: c
                            };
                            a.push(u), (l > o.width || c > o.height) && (o = u);
                        }
                        return {
                            width: o.width,
                            height: o.height,
                            variants: a,
                            type: "ico",
                            mime: "image/x-icon",
                            wUnits: "px",
                            hUnits: "px"
                        };
                    }
                };
            },
            13827: function(t1, e1, r) {
                "use strict";
                var n = r(3944).bc, i = r(3944).VG, a = r(3944).rU, o = r(19789), s = i("Exif\0\0");
                t1.exports = function(t1) {
                    if (!(t1.length < 2) && 255 === t1[0] && 216 === t1[1] && 255 === t1[2]) for(var e1 = 2;;){
                        for(;;){
                            if (t1.length - e1 < 2) return;
                            if (255 === t1[e1++]) break;
                        }
                        for(var r, i, l = t1[e1++]; 255 === l;)l = t1[e1++];
                        if (208 <= l && l <= 217 || 1 === l) r = 0;
                        else {
                            if (!(192 <= l && l <= 254)) return;
                            if (t1.length - e1 < 2) return;
                            r = n(t1, e1) - 2, e1 += 2;
                        }
                        if (217 === l || 218 === l) return;
                        if (225 === l && r >= 10 && a(t1, e1, s) && (i = o.get_orientation(t1.slice(e1 + 6, e1 + r))), r >= 5 && 192 <= l && l <= 207 && 196 !== l && 200 !== l && 204 !== l) {
                            if (t1.length - e1 < r) return;
                            var c = {
                                width: n(t1, e1 + 3),
                                height: n(t1, e1 + 1),
                                type: "jpg",
                                mime: "image/jpeg",
                                wUnits: "px",
                                hUnits: "px"
                            };
                            return i > 0 && (c.orientation = i), c;
                        }
                        e1 += r;
                    }
                };
            },
            46594: function(t1, e1, r) {
                "use strict";
                var n = r(3944).VG, i = r(3944).rU, a = r(3944).bb, o = n("\x89PNG\r\n\x1a\n"), s = n("IHDR");
                t1.exports = function(t1) {
                    if (!(t1.length < 24) && i(t1, 0, o) && i(t1, 12, s)) return {
                        width: a(t1, 16),
                        height: a(t1, 20),
                        type: "png",
                        mime: "image/png",
                        wUnits: "px",
                        hUnits: "px"
                    };
                };
            },
            13198: function(t1, e1, r) {
                "use strict";
                var n = r(3944).VG, i = r(3944).rU, a = r(3944).bb, o = n("8BPS\0\x01");
                t1.exports = function(t1) {
                    if (!(t1.length < 22) && i(t1, 0, o)) return {
                        width: a(t1, 18),
                        height: a(t1, 14),
                        type: "psd",
                        mime: "image/vnd.adobe.photoshop",
                        wUnits: "px",
                        hUnits: "px"
                    };
                };
            },
            94203: function(t1) {
                "use strict";
                function e1(t1) {
                    return "number" == typeof t1 && isFinite(t1) && t1 > 0;
                }
                var r = /<[-_.:a-zA-Z0-9][^>]*>/, n = /^<([-_.:a-zA-Z0-9]+:)?svg\s/, i = /[^-]\bwidth="([^%]+?)"|[^-]\bwidth='([^%]+?)'/, a = /\bheight="([^%]+?)"|\bheight='([^%]+?)'/, o = /\bview[bB]ox="(.+?)"|\bview[bB]ox='(.+?)'/, s = /in$|mm$|cm$|pt$|pc$|px$|em$|ex$/;
                function l(t1) {
                    return s.test(t1) ? t1.match(s)[0] : "px";
                }
                t1.exports = function(t1) {
                    if (function(t1) {
                        var e1, r = 0, n = t1.length;
                        for(239 === t1[0] && 187 === t1[1] && 191 === t1[2] && (r = 3); r < n && (32 === (e1 = t1[r]) || 9 === e1 || 13 === e1 || 10 === e1);)r++;
                        return r !== n && 60 === t1[r];
                    }(t1)) {
                        for(var s = "", c = 0; c < t1.length; c++)s += String.fromCharCode(t1[c]);
                        var u = (s.match(r) || [
                            ""
                        ])[0];
                        if (n.test(u)) {
                            var h = function(t1) {
                                var e1 = t1.match(i), r = t1.match(a), n = t1.match(o);
                                return {
                                    width: e1 && (e1[1] || e1[2]),
                                    height: r && (r[1] || r[2]),
                                    viewbox: n && (n[1] || n[2])
                                };
                            }(u), f = parseFloat(h.width), p = parseFloat(h.height);
                            if (h.width && h.height) {
                                if (!e1(f) || !e1(p)) return;
                                return {
                                    width: f,
                                    height: p,
                                    type: "svg",
                                    mime: "image/svg+xml",
                                    wUnits: l(h.width),
                                    hUnits: l(h.height)
                                };
                            }
                            var d = (h.viewbox || "").split(" "), m = {
                                width: d[2],
                                height: d[3]
                            }, g = parseFloat(m.width), y = parseFloat(m.height);
                            if (e1(g) && e1(y) && l(m.width) === l(m.height)) {
                                var v = g / y;
                                if (h.width) {
                                    if (!e1(f)) return;
                                    return {
                                        width: f,
                                        height: f / v,
                                        type: "svg",
                                        mime: "image/svg+xml",
                                        wUnits: l(h.width),
                                        hUnits: l(h.width)
                                    };
                                }
                                if (h.height) {
                                    if (!e1(p)) return;
                                    return {
                                        width: p * v,
                                        height: p,
                                        type: "svg",
                                        mime: "image/svg+xml",
                                        wUnits: l(h.height),
                                        hUnits: l(h.height)
                                    };
                                }
                                return {
                                    width: g,
                                    height: y,
                                    type: "svg",
                                    mime: "image/svg+xml",
                                    wUnits: l(m.width),
                                    hUnits: l(m.height)
                                };
                            }
                        }
                    }
                };
            },
            46966: function(t1, e1, r) {
                "use strict";
                var n = r(3944).VG, i = r(3944).rU, a = r(3944).$l, o = r(3944).bc, s = r(3944).tF, l = r(3944).bb, c = n("II*\0"), u = n("MM\0*");
                function h(t1, e1, r) {
                    return r ? o(t1, e1) : a(t1, e1);
                }
                function f(t1, e1, r) {
                    return r ? l(t1, e1) : s(t1, e1);
                }
                function p(t1, e1, r) {
                    var n = h(t1, e1 + 2, r);
                    return 1 !== f(t1, e1 + 4, r) || 3 !== n && 4 !== n ? null : 3 === n ? h(t1, e1 + 8, r) : f(t1, e1 + 8, r);
                }
                t1.exports = function(t1) {
                    if (!(t1.length < 8) && (i(t1, 0, c) || i(t1, 0, u))) {
                        var e1 = 77 === t1[0], r = f(t1, 4, e1) - 8;
                        if (!(r < 0)) {
                            var n = r + 8;
                            if (!(t1.length - n < 2)) {
                                var a = 12 * h(t1, n + 0, e1);
                                if (!(a <= 0 || (n += 2, t1.length - n < a))) {
                                    var o, s, l, d;
                                    for(o = 0; o < a; o += 12)256 === (d = h(t1, n + o, e1)) ? s = p(t1, n + o, e1) : 257 === d && (l = p(t1, n + o, e1));
                                    return s && l ? {
                                        width: s,
                                        height: l,
                                        type: "tiff",
                                        mime: "image/tiff",
                                        wUnits: "px",
                                        hUnits: "px"
                                    } : void 0;
                                }
                            }
                        }
                    }
                };
            },
            88023: function(t1, e1, r) {
                "use strict";
                var n = r(3944).VG, i = r(3944).rU, a = r(3944).$l, o = r(3944).tF, s = r(19789), l = n("RIFF"), c = n("WEBP");
                function u(t1, e1) {
                    if (157 === t1[e1 + 3] && 1 === t1[e1 + 4] && 42 === t1[e1 + 5]) return {
                        width: 16383 & a(t1, e1 + 6),
                        height: 16383 & a(t1, e1 + 8),
                        type: "webp",
                        mime: "image/webp",
                        wUnits: "px",
                        hUnits: "px"
                    };
                }
                function h(t1, e1) {
                    if (47 === t1[e1]) {
                        var r = o(t1, e1 + 1);
                        return {
                            width: 1 + (16383 & r),
                            height: 1 + (r >> 14 & 16383),
                            type: "webp",
                            mime: "image/webp",
                            wUnits: "px",
                            hUnits: "px"
                        };
                    }
                }
                function f(t1, e1) {
                    return {
                        width: 1 + (t1[e1 + 6] << 16 | t1[e1 + 5] << 8 | t1[e1 + 4]),
                        height: 1 + (t1[e1 + 9] << e1 | t1[e1 + 8] << 8 | t1[e1 + 7]),
                        type: "webp",
                        mime: "image/webp",
                        wUnits: "px",
                        hUnits: "px"
                    };
                }
                t1.exports = function(t1) {
                    if (!(t1.length < 16) && (i(t1, 0, l) || i(t1, 8, c))) {
                        var e1 = 12, r = null, n = 0, a = o(t1, 4) + 8;
                        if (!(a > t1.length)) {
                            for(; e1 + 8 < a;)if (0 !== t1[e1]) {
                                var p = String.fromCharCode.apply(null, t1.slice(e1, e1 + 4)), d = o(t1, e1 + 4);
                                "VP8 " === p && d >= 10 ? r = r || u(t1, e1 + 8) : "VP8L" === p && d >= 9 ? r = r || h(t1, e1 + 8) : "VP8X" === p && d >= 10 ? r = r || f(t1, e1 + 8) : "EXIF" === p && (n = s.get_orientation(t1.slice(e1 + 8, e1 + 8 + d)), e1 = 1 / 0), e1 += 8 + d;
                            } else e1++;
                            if (r) return n > 0 && (r.orientation = n), r;
                        }
                    }
                };
            },
            43751: function(t1, e1, r) {
                "use strict";
                t1.exports = {
                    avif: r(31149),
                    bmp: r(78218),
                    gif: r(37495),
                    ico: r(88708),
                    jpeg: r(13827),
                    png: r(46594),
                    psd: r(13198),
                    svg: r(94203),
                    tiff: r(46966),
                    webp: r(88023)
                };
            },
            19490: function(t1, e1, r) {
                "use strict";
                var n = r(43751);
                t1.exports = function(t1) {
                    return function(t1) {
                        for(var e1 = Object.keys(n), r = 0; r < e1.length; r++){
                            var i = n[e1[r]](t1);
                            if (i) return i;
                        }
                        return null;
                    }(t1);
                }, t1.exports.parsers = n;
            },
            33282: function(t1) {
                var e1, r, n = t1.exports = {};
                function i() {
                    throw new Error("setTimeout has not been defined");
                }
                function a() {
                    throw new Error("clearTimeout has not been defined");
                }
                function o(t1) {
                    if (e1 === setTimeout) return setTimeout(t1, 0);
                    if ((e1 === i || !e1) && setTimeout) return e1 = setTimeout, setTimeout(t1, 0);
                    try {
                        return e1(t1, 0);
                    } catch (r) {
                        try {
                            return e1.call(null, t1, 0);
                        } catch (r) {
                            return e1.call(this, t1, 0);
                        }
                    }
                }
                !function() {
                    try {
                        e1 = "function" == typeof setTimeout ? setTimeout : i;
                    } catch (t1) {
                        e1 = i;
                    }
                    try {
                        r = "function" == typeof clearTimeout ? clearTimeout : a;
                    } catch (t1) {
                        r = a;
                    }
                }();
                var s, l = [], c = !1, u = -1;
                function h() {
                    c && s && (c = !1, s.length ? l = s.concat(l) : u = -1, l.length && f());
                }
                function f() {
                    if (!c) {
                        var t1 = o(h);
                        c = !0;
                        for(var e1 = l.length; e1;){
                            for(s = l, l = []; ++u < e1;)s && s[u].run();
                            u = -1, e1 = l.length;
                        }
                        s = null, c = !1, function(t1) {
                            if (r === clearTimeout) return clearTimeout(t1);
                            if ((r === a || !r) && clearTimeout) return r = clearTimeout, clearTimeout(t1);
                            try {
                                return r(t1);
                            } catch (e1) {
                                try {
                                    return r.call(null, t1);
                                } catch (e1) {
                                    return r.call(this, t1);
                                }
                            }
                        }(t1);
                    }
                }
                function p(t1, e1) {
                    this.fun = t1, this.array = e1;
                }
                function d() {}
                n.nextTick = function(t1) {
                    var e1 = new Array(arguments.length - 1);
                    if (arguments.length > 1) for(var r = 1; r < arguments.length; r++)e1[r - 1] = arguments[r];
                    l.push(new p(t1, e1)), 1 !== l.length || c || o(f);
                }, p.prototype.run = function() {
                    this.fun.apply(null, this.array);
                }, n.title = "browser", n.browser = !0, n.env = {}, n.argv = [], n.version = "", n.versions = {}, n.on = d, n.addListener = d, n.once = d, n.off = d, n.removeListener = d, n.removeAllListeners = d, n.emit = d, n.prependListener = d, n.prependOnceListener = d, n.listeners = function(t1) {
                    return [];
                }, n.binding = function(t1) {
                    throw new Error("process.binding is not supported");
                }, n.cwd = function() {
                    return "/";
                }, n.chdir = function(t1) {
                    throw new Error("process.chdir is not supported");
                }, n.umask = function() {
                    return 0;
                };
            },
            16494: function(t1, e1, r) {
                for(var n = r(71879), i = "undefined" == typeof window ? r.g : window, a = [
                    "moz",
                    "webkit"
                ], o = "AnimationFrame", s = i["request" + o], l = i["cancel" + o] || i["cancelRequest" + o], c = 0; !s && c < a.length; c++)s = i[a[c] + "Request" + o], l = i[a[c] + "Cancel" + o] || i[a[c] + "CancelRequest" + o];
                if (!s || !l) {
                    var u = 0, h = 0, f = [];
                    s = function(t1) {
                        if (0 === f.length) {
                            var e1 = n(), r = Math.max(0, 16.666666666666668 - (e1 - u));
                            u = r + e1, setTimeout(function() {
                                var t1 = f.slice(0);
                                f.length = 0;
                                for(var e1 = 0; e1 < t1.length; e1++)if (!t1[e1].cancelled) try {
                                    t1[e1].callback(u);
                                } catch (t1) {
                                    setTimeout(function() {
                                        throw t1;
                                    }, 0);
                                }
                            }, Math.round(r));
                        }
                        return f.push({
                            handle: ++h,
                            callback: t1,
                            cancelled: !1
                        }), h;
                    }, l = function(t1) {
                        for(var e1 = 0; e1 < f.length; e1++)f[e1].handle === t1 && (f[e1].cancelled = !0);
                    };
                }
                t1.exports = function(t1) {
                    return s.call(i, t1);
                }, t1.exports.cancel = function() {
                    l.apply(i, arguments);
                }, t1.exports.polyfill = function(t1) {
                    t1 || (t1 = i), t1.requestAnimationFrame = s, t1.cancelAnimationFrame = l;
                };
            },
            29978: function(t1, e1, r) {
                "use strict";
                var n = r(78112), i = r(162), a = r(79788), o = r(6807), s = r(27976), l = r(83473), c = r(51498), u = c.float32, h = c.fract32;
                t1.exports = function(t1, e1) {
                    if ("function" == typeof t1 ? (e1 || (e1 = {}), e1.regl = t1) : e1 = t1, e1.length && (e1.positions = e1), !(t1 = e1.regl).hasExtension("ANGLE_instanced_arrays")) throw Error("regl-error2d: `ANGLE_instanced_arrays` extension should be enabled");
                    var r, c, p, d, m, g, y = t1._gl, v = {
                        color: "black",
                        capSize: 5,
                        lineWidth: 1,
                        opacity: 1,
                        viewport: null,
                        range: null,
                        offset: 0,
                        count: 0,
                        bounds: null,
                        positions: [],
                        errors: []
                    }, x = [];
                    return d = t1.buffer({
                        usage: "dynamic",
                        type: "uint8",
                        data: new Uint8Array(0)
                    }), c = t1.buffer({
                        usage: "dynamic",
                        type: "float",
                        data: new Uint8Array(0)
                    }), p = t1.buffer({
                        usage: "dynamic",
                        type: "float",
                        data: new Uint8Array(0)
                    }), m = t1.buffer({
                        usage: "dynamic",
                        type: "float",
                        data: new Uint8Array(0)
                    }), g = t1.buffer({
                        usage: "static",
                        type: "float",
                        data: f
                    }), T(e1), r = t1({
                        vert: "\n		precision highp float;\n\n		attribute vec2 position, positionFract;\n		attribute vec4 error;\n		attribute vec4 color;\n\n		attribute vec2 direction, lineOffset, capOffset;\n\n		uniform vec4 viewport;\n		uniform float lineWidth, capSize;\n		uniform vec2 scale, scaleFract, translate, translateFract;\n\n		varying vec4 fragColor;\n\n		void main() {\n			fragColor = color / 255.;\n\n			vec2 pixelOffset = lineWidth * lineOffset + (capSize + lineWidth) * capOffset;\n\n			vec2 dxy = -step(.5, direction.xy) * error.xz + step(direction.xy, vec2(-.5)) * error.yw;\n\n			vec2 position = position + dxy;\n\n			vec2 pos = (position + translate) * scale\n				+ (positionFract + translateFract) * scale\n				+ (position + translate) * scaleFract\n				+ (positionFract + translateFract) * scaleFract;\n\n			pos += pixelOffset / viewport.zw;\n\n			gl_Position = vec4(pos * 2. - 1., 0, 1);\n		}\n		",
                        frag: "\n		precision highp float;\n\n		varying vec4 fragColor;\n\n		uniform float opacity;\n\n		void main() {\n			gl_FragColor = fragColor;\n			gl_FragColor.a *= opacity;\n		}\n		",
                        uniforms: {
                            range: t1.prop("range"),
                            lineWidth: t1.prop("lineWidth"),
                            capSize: t1.prop("capSize"),
                            opacity: t1.prop("opacity"),
                            scale: t1.prop("scale"),
                            translate: t1.prop("translate"),
                            scaleFract: t1.prop("scaleFract"),
                            translateFract: t1.prop("translateFract"),
                            viewport: function(t1, e1) {
                                return [
                                    e1.viewport.x,
                                    e1.viewport.y,
                                    t1.viewportWidth,
                                    t1.viewportHeight
                                ];
                            }
                        },
                        attributes: {
                            color: {
                                buffer: d,
                                offset: function(t1, e1) {
                                    return 4 * e1.offset;
                                },
                                divisor: 1
                            },
                            position: {
                                buffer: c,
                                offset: function(t1, e1) {
                                    return 8 * e1.offset;
                                },
                                divisor: 1
                            },
                            positionFract: {
                                buffer: p,
                                offset: function(t1, e1) {
                                    return 8 * e1.offset;
                                },
                                divisor: 1
                            },
                            error: {
                                buffer: m,
                                offset: function(t1, e1) {
                                    return 16 * e1.offset;
                                },
                                divisor: 1
                            },
                            direction: {
                                buffer: g,
                                stride: 24,
                                offset: 0
                            },
                            lineOffset: {
                                buffer: g,
                                stride: 24,
                                offset: 8
                            },
                            capOffset: {
                                buffer: g,
                                stride: 24,
                                offset: 16
                            }
                        },
                        primitive: "triangles",
                        blend: {
                            enable: !0,
                            color: [
                                0,
                                0,
                                0,
                                0
                            ],
                            equation: {
                                rgb: "add",
                                alpha: "add"
                            },
                            func: {
                                srcRGB: "src alpha",
                                dstRGB: "one minus src alpha",
                                srcAlpha: "one minus dst alpha",
                                dstAlpha: "one"
                            }
                        },
                        depth: {
                            enable: !1
                        },
                        scissor: {
                            enable: !0,
                            box: t1.prop("viewport")
                        },
                        viewport: t1.prop("viewport"),
                        stencil: !1,
                        instances: t1.prop("count"),
                        count: f.length
                    }), s(_, {
                        update: T,
                        draw: b,
                        destroy: k,
                        regl: t1,
                        gl: y,
                        canvas: y.canvas,
                        groups: x
                    }), _;
                    function _(t1) {
                        t1 ? T(t1) : null === t1 && k(), b();
                    }
                    function b(e1) {
                        if ("number" == typeof e1) return w(e1);
                        e1 && !Array.isArray(e1) && (e1 = [
                            e1
                        ]), t1._refresh(), x.forEach(function(t1, r) {
                            t1 && (e1 && (e1[r] ? t1.draw = !0 : t1.draw = !1), t1.draw ? w(r) : t1.draw = !0);
                        });
                    }
                    function w(t1) {
                        "number" == typeof t1 && (t1 = x[t1]), null != t1 && t1 && t1.count && t1.color && t1.opacity && t1.positions && t1.positions.length > 1 && (t1.scaleRatio = [
                            t1.scale[0] * t1.viewport.width,
                            t1.scale[1] * t1.viewport.height
                        ], r(t1), t1.after && t1.after(t1));
                    }
                    function T(t1) {
                        if (t1) {
                            null != t1.length ? "number" == typeof t1[0] && (t1 = [
                                {
                                    positions: t1
                                }
                            ]) : Array.isArray(t1) || (t1 = [
                                t1
                            ]);
                            var e1 = 0, r = 0;
                            if (_.groups = x = t1.map(function(t1, c) {
                                var u = x[c];
                                return t1 ? ("function" == typeof t1 ? t1 = {
                                    after: t1
                                } : "number" == typeof t1[0] && (t1 = {
                                    positions: t1
                                }), t1 = o(t1, {
                                    color: "color colors fill",
                                    capSize: "capSize cap capsize cap-size",
                                    lineWidth: "lineWidth line-width width line thickness",
                                    opacity: "opacity alpha",
                                    range: "range dataBox",
                                    viewport: "viewport viewBox",
                                    errors: "errors error",
                                    positions: "positions position data points"
                                }), u || (x[c] = u = {
                                    id: c,
                                    scale: null,
                                    translate: null,
                                    scaleFract: null,
                                    translateFract: null,
                                    draw: !0
                                }, t1 = s({}, v, t1)), a(u, t1, [
                                    {
                                        lineWidth: function(t1) {
                                            return .5 * +t1;
                                        },
                                        capSize: function(t1) {
                                            return .5 * +t1;
                                        },
                                        opacity: parseFloat,
                                        errors: function(t1) {
                                            return t1 = l(t1), r += t1.length, t1;
                                        },
                                        positions: function(t1, r) {
                                            return t1 = l(t1, "float64"), r.count = Math.floor(t1.length / 2), r.bounds = n(t1, 2), r.offset = e1, e1 += r.count, t1;
                                        }
                                    },
                                    {
                                        color: function(t1, e1) {
                                            var r = e1.count;
                                            if (t1 || (t1 = "transparent"), !Array.isArray(t1) || "number" == typeof t1[0]) {
                                                var n = t1;
                                                t1 = Array(r);
                                                for(var a = 0; a < r; a++)t1[a] = n;
                                            }
                                            if (t1.length < r) throw Error("Not enough colors");
                                            for(var o = new Uint8Array(4 * r), s = 0; s < r; s++){
                                                var l = i(t1[s], "uint8");
                                                o.set(l, 4 * s);
                                            }
                                            return o;
                                        },
                                        range: function(t1, e1, r) {
                                            var n = e1.bounds;
                                            return t1 || (t1 = n), e1.scale = [
                                                1 / (t1[2] - t1[0]),
                                                1 / (t1[3] - t1[1])
                                            ], e1.translate = [
                                                -t1[0],
                                                -t1[1]
                                            ], e1.scaleFract = h(e1.scale), e1.translateFract = h(e1.translate), t1;
                                        },
                                        viewport: function(t1) {
                                            var e1;
                                            return Array.isArray(t1) ? e1 = {
                                                x: t1[0],
                                                y: t1[1],
                                                width: t1[2] - t1[0],
                                                height: t1[3] - t1[1]
                                            } : t1 ? (e1 = {
                                                x: t1.x || t1.left || 0,
                                                y: t1.y || t1.top || 0
                                            }, t1.right ? e1.width = t1.right - e1.x : e1.width = t1.w || t1.width || 0, t1.bottom ? e1.height = t1.bottom - e1.y : e1.height = t1.h || t1.height || 0) : e1 = {
                                                x: 0,
                                                y: 0,
                                                width: y.drawingBufferWidth,
                                                height: y.drawingBufferHeight
                                            }, e1;
                                        }
                                    }
                                ]), u) : u;
                            }), e1 || r) {
                                var f = x.reduce(function(t1, e1, r) {
                                    return t1 + (e1 ? e1.count : 0);
                                }, 0), g = new Float64Array(2 * f), b = new Uint8Array(4 * f), w = new Float32Array(4 * f);
                                x.forEach(function(t1, e1) {
                                    if (t1) {
                                        var r = t1.positions, n = t1.count, i = t1.offset, a = t1.color, o = t1.errors;
                                        n && (b.set(a, 4 * i), w.set(o, 4 * i), g.set(r, 2 * i));
                                    }
                                });
                                var T = u(g);
                                c(T);
                                var k = h(g, T);
                                p(k), d(b), m(w);
                            }
                        }
                    }
                    function k() {
                        c.destroy(), p.destroy(), d.destroy(), m.destroy(), g.destroy();
                    }
                };
                var f = [
                    [
                        1,
                        0,
                        0,
                        1,
                        0,
                        0
                    ],
                    [
                        1,
                        0,
                        0,
                        -1,
                        0,
                        0
                    ],
                    [
                        -1,
                        0,
                        0,
                        -1,
                        0,
                        0
                    ],
                    [
                        -1,
                        0,
                        0,
                        -1,
                        0,
                        0
                    ],
                    [
                        -1,
                        0,
                        0,
                        1,
                        0,
                        0
                    ],
                    [
                        1,
                        0,
                        0,
                        1,
                        0,
                        0
                    ],
                    [
                        1,
                        0,
                        -1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        -1,
                        0,
                        0,
                        -1
                    ],
                    [
                        1,
                        0,
                        1,
                        0,
                        0,
                        -1
                    ],
                    [
                        1,
                        0,
                        1,
                        0,
                        0,
                        -1
                    ],
                    [
                        1,
                        0,
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        -1,
                        0,
                        0,
                        1
                    ],
                    [
                        -1,
                        0,
                        -1,
                        0,
                        0,
                        1
                    ],
                    [
                        -1,
                        0,
                        -1,
                        0,
                        0,
                        -1
                    ],
                    [
                        -1,
                        0,
                        1,
                        0,
                        0,
                        -1
                    ],
                    [
                        -1,
                        0,
                        1,
                        0,
                        0,
                        -1
                    ],
                    [
                        -1,
                        0,
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        -1,
                        0,
                        -1,
                        0,
                        0,
                        1
                    ],
                    [
                        0,
                        1,
                        1,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        1,
                        -1,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        -1,
                        -1,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        -1,
                        -1,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        1,
                        1,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        -1,
                        1,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        1,
                        0,
                        -1,
                        1,
                        0
                    ],
                    [
                        0,
                        1,
                        0,
                        -1,
                        -1,
                        0
                    ],
                    [
                        0,
                        1,
                        0,
                        1,
                        -1,
                        0
                    ],
                    [
                        0,
                        1,
                        0,
                        1,
                        1,
                        0
                    ],
                    [
                        0,
                        1,
                        0,
                        -1,
                        1,
                        0
                    ],
                    [
                        0,
                        1,
                        0,
                        1,
                        -1,
                        0
                    ],
                    [
                        0,
                        -1,
                        0,
                        -1,
                        1,
                        0
                    ],
                    [
                        0,
                        -1,
                        0,
                        -1,
                        -1,
                        0
                    ],
                    [
                        0,
                        -1,
                        0,
                        1,
                        -1,
                        0
                    ],
                    [
                        0,
                        -1,
                        0,
                        1,
                        1,
                        0
                    ],
                    [
                        0,
                        -1,
                        0,
                        -1,
                        1,
                        0
                    ],
                    [
                        0,
                        -1,
                        0,
                        1,
                        -1,
                        0
                    ]
                ];
            },
            49478: function(t1, e1, r) {
                "use strict";
                var n = r(162), i = r(78112), a = r(27976), o = r(6807), s = r(83473), l = r(25782), c = r(90956), u = r(51498), h = u.float32, f = u.fract32, p = r(93103), d = r(5137), m = r(33055);
                function g(t1, e1) {
                    if (!(this instanceof g)) return new g(t1, e1);
                    if ("function" == typeof t1 ? (e1 || (e1 = {}), e1.regl = t1) : e1 = t1, e1.length && (e1.positions = e1), !(t1 = e1.regl).hasExtension("ANGLE_instanced_arrays")) throw Error("regl-error2d: `ANGLE_instanced_arrays` extension should be enabled");
                    this.gl = t1._gl, this.regl = t1, this.passes = [], this.shaders = g.shaders.has(t1) ? g.shaders.get(t1) : g.shaders.set(t1, g.createShaders(t1)).get(t1), this.update(e1);
                }
                t1.exports = g, g.dashMult = 2, g.maxPatternLength = 256, g.precisionThreshold = 3e6, g.maxPoints = 1e4, g.maxLines = 2048, g.shaders = new p, g.createShaders = function(t1) {
                    var e1, r = t1.buffer({
                        usage: "static",
                        type: "float",
                        data: [
                            0,
                            1,
                            0,
                            0,
                            1,
                            1,
                            1,
                            0
                        ]
                    }), n = {
                        primitive: "triangle strip",
                        instances: t1.prop("count"),
                        count: 4,
                        offset: 0,
                        uniforms: {
                            miterMode: function(t1, e1) {
                                return "round" === e1.join ? 2 : 1;
                            },
                            miterLimit: t1.prop("miterLimit"),
                            scale: t1.prop("scale"),
                            scaleFract: t1.prop("scaleFract"),
                            translateFract: t1.prop("translateFract"),
                            translate: t1.prop("translate"),
                            thickness: t1.prop("thickness"),
                            dashTexture: t1.prop("dashTexture"),
                            opacity: t1.prop("opacity"),
                            pixelRatio: t1.context("pixelRatio"),
                            id: t1.prop("id"),
                            dashLength: t1.prop("dashLength"),
                            viewport: function(t1, e1) {
                                return [
                                    e1.viewport.x,
                                    e1.viewport.y,
                                    t1.viewportWidth,
                                    t1.viewportHeight
                                ];
                            },
                            depth: t1.prop("depth")
                        },
                        blend: {
                            enable: !0,
                            color: [
                                0,
                                0,
                                0,
                                0
                            ],
                            equation: {
                                rgb: "add",
                                alpha: "add"
                            },
                            func: {
                                srcRGB: "src alpha",
                                dstRGB: "one minus src alpha",
                                srcAlpha: "one minus dst alpha",
                                dstAlpha: "one"
                            }
                        },
                        depth: {
                            enable: function(t1, e1) {
                                return !e1.overlay;
                            }
                        },
                        stencil: {
                            enable: !1
                        },
                        scissor: {
                            enable: !0,
                            box: t1.prop("viewport")
                        },
                        viewport: t1.prop("viewport")
                    }, i = t1(a({
                        vert: "\nprecision highp float;\n\nattribute vec2 aCoord, bCoord, aCoordFract, bCoordFract;\nattribute vec4 color;\nattribute float lineEnd, lineTop;\n\nuniform vec2 scale, scaleFract, translate, translateFract;\nuniform float thickness, pixelRatio, id, depth;\nuniform vec4 viewport;\n\nvarying vec4 fragColor;\nvarying vec2 tangent;\n\nvec2 project(vec2 position, vec2 positionFract, vec2 scale, vec2 scaleFract, vec2 translate, vec2 translateFract) {\n	// the order is important\n	return position * scale + translate\n       + positionFract * scale + translateFract\n       + position * scaleFract\n       + positionFract * scaleFract;\n}\n\nvoid main() {\n	float lineStart = 1. - lineEnd;\n	float lineOffset = lineTop * 2. - 1.;\n\n	vec2 diff = (bCoord + bCoordFract - aCoord - aCoordFract);\n	tangent = normalize(diff * scale * viewport.zw);\n	vec2 normal = vec2(-tangent.y, tangent.x);\n\n	vec2 position = project(aCoord, aCoordFract, scale, scaleFract, translate, translateFract) * lineStart\n		+ project(bCoord, bCoordFract, scale, scaleFract, translate, translateFract) * lineEnd\n\n		+ thickness * normal * .5 * lineOffset / viewport.zw;\n\n	gl_Position = vec4(position * 2.0 - 1.0, depth, 1);\n\n	fragColor = color / 255.;\n}\n",
                        frag: "\nprecision highp float;\n\nuniform float dashLength, pixelRatio, thickness, opacity, id;\nuniform sampler2D dashTexture;\n\nvarying vec4 fragColor;\nvarying vec2 tangent;\n\nvoid main() {\n	float alpha = 1.;\n\n	float t = fract(dot(tangent, gl_FragCoord.xy) / dashLength) * .5 + .25;\n	float dash = texture2D(dashTexture, vec2(t, .5)).r;\n\n	gl_FragColor = fragColor;\n	gl_FragColor.a *= alpha * opacity * dash;\n}\n",
                        attributes: {
                            lineEnd: {
                                buffer: r,
                                divisor: 0,
                                stride: 8,
                                offset: 0
                            },
                            lineTop: {
                                buffer: r,
                                divisor: 0,
                                stride: 8,
                                offset: 4
                            },
                            aCoord: {
                                buffer: t1.prop("positionBuffer"),
                                stride: 8,
                                offset: 8,
                                divisor: 1
                            },
                            bCoord: {
                                buffer: t1.prop("positionBuffer"),
                                stride: 8,
                                offset: 16,
                                divisor: 1
                            },
                            aCoordFract: {
                                buffer: t1.prop("positionFractBuffer"),
                                stride: 8,
                                offset: 8,
                                divisor: 1
                            },
                            bCoordFract: {
                                buffer: t1.prop("positionFractBuffer"),
                                stride: 8,
                                offset: 16,
                                divisor: 1
                            },
                            color: {
                                buffer: t1.prop("colorBuffer"),
                                stride: 4,
                                offset: 0,
                                divisor: 1
                            }
                        }
                    }, n));
                    try {
                        e1 = t1(a({
                            cull: {
                                enable: !0,
                                face: "back"
                            },
                            vert: "\nprecision highp float;\n\nattribute vec2 aCoord, bCoord, nextCoord, prevCoord;\nattribute vec4 aColor, bColor;\nattribute float lineEnd, lineTop;\n\nuniform vec2 scale, translate;\nuniform float thickness, pixelRatio, id, depth;\nuniform vec4 viewport;\nuniform float miterLimit, miterMode;\n\nvarying vec4 fragColor;\nvarying vec4 startCutoff, endCutoff;\nvarying vec2 tangent;\nvarying vec2 startCoord, endCoord;\nvarying float enableStartMiter, enableEndMiter;\n\nconst float REVERSE_THRESHOLD = -.875;\nconst float MIN_DIFF = 1e-6;\n\n// TODO: possible optimizations: avoid overcalculating all for vertices and calc just one instead\n// TODO: precalculate dot products, normalize things beforehead etc.\n// TODO: refactor to rectangular algorithm\n\nfloat distToLine(vec2 p, vec2 a, vec2 b) {\n	vec2 diff = b - a;\n	vec2 perp = normalize(vec2(-diff.y, diff.x));\n	return dot(p - a, perp);\n}\n\nbool isNaN( float val ){\n  return ( val < 0.0 || 0.0 < val || val == 0.0 ) ? false : true;\n}\n\nvoid main() {\n	vec2 aCoord = aCoord, bCoord = bCoord, prevCoord = prevCoord, nextCoord = nextCoord;\n\n  vec2 adjustedScale;\n  adjustedScale.x = (abs(scale.x) < MIN_DIFF) ? MIN_DIFF : scale.x;\n  adjustedScale.y = (abs(scale.y) < MIN_DIFF) ? MIN_DIFF : scale.y;\n\n  vec2 scaleRatio = adjustedScale * viewport.zw;\n	vec2 normalWidth = thickness / scaleRatio;\n\n	float lineStart = 1. - lineEnd;\n	float lineBot = 1. - lineTop;\n\n	fragColor = (lineStart * aColor + lineEnd * bColor) / 255.;\n\n	if (isNaN(aCoord.x) || isNaN(aCoord.y) || isNaN(bCoord.x) || isNaN(bCoord.y)) return;\n\n	if (aCoord == prevCoord) prevCoord = aCoord + normalize(bCoord - aCoord);\n	if (bCoord == nextCoord) nextCoord = bCoord - normalize(bCoord - aCoord);\n\n\n	vec2 prevDiff = aCoord - prevCoord;\n	vec2 currDiff = bCoord - aCoord;\n	vec2 nextDiff = nextCoord - bCoord;\n\n	vec2 prevTangent = normalize(prevDiff * scaleRatio);\n	vec2 currTangent = normalize(currDiff * scaleRatio);\n	vec2 nextTangent = normalize(nextDiff * scaleRatio);\n\n	vec2 prevNormal = vec2(-prevTangent.y, prevTangent.x);\n	vec2 currNormal = vec2(-currTangent.y, currTangent.x);\n	vec2 nextNormal = vec2(-nextTangent.y, nextTangent.x);\n\n	vec2 startJoinDirection = normalize(prevTangent - currTangent);\n	vec2 endJoinDirection = normalize(currTangent - nextTangent);\n\n	// collapsed/unidirectional segment cases\n	// FIXME: there should be more elegant solution\n	vec2 prevTanDiff = abs(prevTangent - currTangent);\n	vec2 nextTanDiff = abs(nextTangent - currTangent);\n	if (max(prevTanDiff.x, prevTanDiff.y) < MIN_DIFF) {\n		startJoinDirection = currNormal;\n	}\n	if (max(nextTanDiff.x, nextTanDiff.y) < MIN_DIFF) {\n		endJoinDirection = currNormal;\n	}\n	if (aCoord == bCoord) {\n		endJoinDirection = startJoinDirection;\n		currNormal = prevNormal;\n		currTangent = prevTangent;\n	}\n\n	tangent = currTangent;\n\n	//calculate join shifts relative to normals\n	float startJoinShift = dot(currNormal, startJoinDirection);\n	float endJoinShift = dot(currNormal, endJoinDirection);\n\n	float startMiterRatio = abs(1. / startJoinShift);\n	float endMiterRatio = abs(1. / endJoinShift);\n\n	vec2 startJoin = startJoinDirection * startMiterRatio;\n	vec2 endJoin = endJoinDirection * endMiterRatio;\n\n	vec2 startTopJoin, startBotJoin, endTopJoin, endBotJoin;\n	startTopJoin = sign(startJoinShift) * startJoin * .5;\n	startBotJoin = -startTopJoin;\n\n	endTopJoin = sign(endJoinShift) * endJoin * .5;\n	endBotJoin = -endTopJoin;\n\n	vec2 aTopCoord = aCoord + normalWidth * startTopJoin;\n	vec2 bTopCoord = bCoord + normalWidth * endTopJoin;\n	vec2 aBotCoord = aCoord + normalWidth * startBotJoin;\n	vec2 bBotCoord = bCoord + normalWidth * endBotJoin;\n\n	//miter anti-clipping\n	float baClipping = distToLine(bCoord, aCoord, aBotCoord) / dot(normalize(normalWidth * endBotJoin), normalize(normalWidth.yx * vec2(-startBotJoin.y, startBotJoin.x)));\n	float abClipping = distToLine(aCoord, bCoord, bTopCoord) / dot(normalize(normalWidth * startBotJoin), normalize(normalWidth.yx * vec2(-endBotJoin.y, endBotJoin.x)));\n\n	//prevent close to reverse direction switch\n	bool prevReverse = dot(currTangent, prevTangent) <= REVERSE_THRESHOLD && abs(dot(currTangent, prevNormal)) * min(length(prevDiff), length(currDiff)) <  length(normalWidth * currNormal);\n	bool nextReverse = dot(currTangent, nextTangent) <= REVERSE_THRESHOLD && abs(dot(currTangent, nextNormal)) * min(length(nextDiff), length(currDiff)) <  length(normalWidth * currNormal);\n\n	if (prevReverse) {\n		//make join rectangular\n		vec2 miterShift = normalWidth * startJoinDirection * miterLimit * .5;\n		float normalAdjust = 1. - min(miterLimit / startMiterRatio, 1.);\n		aBotCoord = aCoord + miterShift - normalAdjust * normalWidth * currNormal * .5;\n		aTopCoord = aCoord + miterShift + normalAdjust * normalWidth * currNormal * .5;\n	}\n	else if (!nextReverse && baClipping > 0. && baClipping < length(normalWidth * endBotJoin)) {\n		//handle miter clipping\n		bTopCoord -= normalWidth * endTopJoin;\n		bTopCoord += normalize(endTopJoin * normalWidth) * baClipping;\n	}\n\n	if (nextReverse) {\n		//make join rectangular\n		vec2 miterShift = normalWidth * endJoinDirection * miterLimit * .5;\n		float normalAdjust = 1. - min(miterLimit / endMiterRatio, 1.);\n		bBotCoord = bCoord + miterShift - normalAdjust * normalWidth * currNormal * .5;\n		bTopCoord = bCoord + miterShift + normalAdjust * normalWidth * currNormal * .5;\n	}\n	else if (!prevReverse && abClipping > 0. && abClipping < length(normalWidth * startBotJoin)) {\n		//handle miter clipping\n		aBotCoord -= normalWidth * startBotJoin;\n		aBotCoord += normalize(startBotJoin * normalWidth) * abClipping;\n	}\n\n	vec2 aTopPosition = (aTopCoord) * adjustedScale + translate;\n	vec2 aBotPosition = (aBotCoord) * adjustedScale + translate;\n\n	vec2 bTopPosition = (bTopCoord) * adjustedScale + translate;\n	vec2 bBotPosition = (bBotCoord) * adjustedScale + translate;\n\n	//position is normalized 0..1 coord on the screen\n	vec2 position = (aTopPosition * lineTop + aBotPosition * lineBot) * lineStart + (bTopPosition * lineTop + bBotPosition * lineBot) * lineEnd;\n\n	startCoord = aCoord * scaleRatio + translate * viewport.zw + viewport.xy;\n	endCoord = bCoord * scaleRatio + translate * viewport.zw + viewport.xy;\n\n	gl_Position = vec4(position  * 2.0 - 1.0, depth, 1);\n\n	enableStartMiter = step(dot(currTangent, prevTangent), .5);\n	enableEndMiter = step(dot(currTangent, nextTangent), .5);\n\n	//bevel miter cutoffs\n	if (miterMode == 1.) {\n		if (enableStartMiter == 1.) {\n			vec2 startMiterWidth = vec2(startJoinDirection) * thickness * miterLimit * .5;\n			startCutoff = vec4(aCoord, aCoord);\n			startCutoff.zw += vec2(-startJoinDirection.y, startJoinDirection.x) / scaleRatio;\n			startCutoff = startCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;\n			startCutoff += viewport.xyxy;\n			startCutoff += startMiterWidth.xyxy;\n		}\n\n		if (enableEndMiter == 1.) {\n			vec2 endMiterWidth = vec2(endJoinDirection) * thickness * miterLimit * .5;\n			endCutoff = vec4(bCoord, bCoord);\n			endCutoff.zw += vec2(-endJoinDirection.y, endJoinDirection.x)  / scaleRatio;\n			endCutoff = endCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;\n			endCutoff += viewport.xyxy;\n			endCutoff += endMiterWidth.xyxy;\n		}\n	}\n\n	//round miter cutoffs\n	else if (miterMode == 2.) {\n		if (enableStartMiter == 1.) {\n			vec2 startMiterWidth = vec2(startJoinDirection) * thickness * abs(dot(startJoinDirection, currNormal)) * .5;\n			startCutoff = vec4(aCoord, aCoord);\n			startCutoff.zw += vec2(-startJoinDirection.y, startJoinDirection.x) / scaleRatio;\n			startCutoff = startCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;\n			startCutoff += viewport.xyxy;\n			startCutoff += startMiterWidth.xyxy;\n		}\n\n		if (enableEndMiter == 1.) {\n			vec2 endMiterWidth = vec2(endJoinDirection) * thickness * abs(dot(endJoinDirection, currNormal)) * .5;\n			endCutoff = vec4(bCoord, bCoord);\n			endCutoff.zw += vec2(-endJoinDirection.y, endJoinDirection.x)  / scaleRatio;\n			endCutoff = endCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;\n			endCutoff += viewport.xyxy;\n			endCutoff += endMiterWidth.xyxy;\n		}\n	}\n}\n",
                            frag: "\nprecision highp float;\n\nuniform float dashLength, pixelRatio, thickness, opacity, id, miterMode;\nuniform sampler2D dashTexture;\n\nvarying vec4 fragColor;\nvarying vec2 tangent;\nvarying vec4 startCutoff, endCutoff;\nvarying vec2 startCoord, endCoord;\nvarying float enableStartMiter, enableEndMiter;\n\nfloat distToLine(vec2 p, vec2 a, vec2 b) {\n	vec2 diff = b - a;\n	vec2 perp = normalize(vec2(-diff.y, diff.x));\n	return dot(p - a, perp);\n}\n\nvoid main() {\n	float alpha = 1., distToStart, distToEnd;\n	float cutoff = thickness * .5;\n\n	//bevel miter\n	if (miterMode == 1.) {\n		if (enableStartMiter == 1.) {\n			distToStart = distToLine(gl_FragCoord.xy, startCutoff.xy, startCutoff.zw);\n			if (distToStart < -1.) {\n				discard;\n				return;\n			}\n			alpha *= min(max(distToStart + 1., 0.), 1.);\n		}\n\n		if (enableEndMiter == 1.) {\n			distToEnd = distToLine(gl_FragCoord.xy, endCutoff.xy, endCutoff.zw);\n			if (distToEnd < -1.) {\n				discard;\n				return;\n			}\n			alpha *= min(max(distToEnd + 1., 0.), 1.);\n		}\n	}\n\n	// round miter\n	else if (miterMode == 2.) {\n		if (enableStartMiter == 1.) {\n			distToStart = distToLine(gl_FragCoord.xy, startCutoff.xy, startCutoff.zw);\n			if (distToStart < 0.) {\n				float radius = length(gl_FragCoord.xy - startCoord);\n\n				if(radius > cutoff + .5) {\n					discard;\n					return;\n				}\n\n				alpha -= smoothstep(cutoff - .5, cutoff + .5, radius);\n			}\n		}\n\n		if (enableEndMiter == 1.) {\n			distToEnd = distToLine(gl_FragCoord.xy, endCutoff.xy, endCutoff.zw);\n			if (distToEnd < 0.) {\n				float radius = length(gl_FragCoord.xy - endCoord);\n\n				if(radius > cutoff + .5) {\n					discard;\n					return;\n				}\n\n				alpha -= smoothstep(cutoff - .5, cutoff + .5, radius);\n			}\n		}\n	}\n\n	float t = fract(dot(tangent, gl_FragCoord.xy) / dashLength) * .5 + .25;\n	float dash = texture2D(dashTexture, vec2(t, .5)).r;\n\n	gl_FragColor = fragColor;\n	gl_FragColor.a *= alpha * opacity * dash;\n}\n",
                            attributes: {
                                lineEnd: {
                                    buffer: r,
                                    divisor: 0,
                                    stride: 8,
                                    offset: 0
                                },
                                lineTop: {
                                    buffer: r,
                                    divisor: 0,
                                    stride: 8,
                                    offset: 4
                                },
                                aColor: {
                                    buffer: t1.prop("colorBuffer"),
                                    stride: 4,
                                    offset: 0,
                                    divisor: 1
                                },
                                bColor: {
                                    buffer: t1.prop("colorBuffer"),
                                    stride: 4,
                                    offset: 4,
                                    divisor: 1
                                },
                                prevCoord: {
                                    buffer: t1.prop("positionBuffer"),
                                    stride: 8,
                                    offset: 0,
                                    divisor: 1
                                },
                                aCoord: {
                                    buffer: t1.prop("positionBuffer"),
                                    stride: 8,
                                    offset: 8,
                                    divisor: 1
                                },
                                bCoord: {
                                    buffer: t1.prop("positionBuffer"),
                                    stride: 8,
                                    offset: 16,
                                    divisor: 1
                                },
                                nextCoord: {
                                    buffer: t1.prop("positionBuffer"),
                                    stride: 8,
                                    offset: 24,
                                    divisor: 1
                                }
                            }
                        }, n));
                    } catch (t1) {
                        e1 = i;
                    }
                    return {
                        fill: t1({
                            primitive: "triangle",
                            elements: function(t1, e1) {
                                return e1.triangles;
                            },
                            offset: 0,
                            vert: "\nprecision highp float;\n\nattribute vec2 position, positionFract;\n\nuniform vec4 color;\nuniform vec2 scale, scaleFract, translate, translateFract;\nuniform float pixelRatio, id;\nuniform vec4 viewport;\nuniform float opacity;\n\nvarying vec4 fragColor;\n\nconst float MAX_LINES = 256.;\n\nvoid main() {\n	float depth = (MAX_LINES - 4. - id) / (MAX_LINES);\n\n	vec2 position = position * scale + translate\n       + positionFract * scale + translateFract\n       + position * scaleFract\n       + positionFract * scaleFract;\n\n	gl_Position = vec4(position * 2.0 - 1.0, depth, 1);\n\n	fragColor = color / 255.;\n	fragColor.a *= opacity;\n}\n",
                            frag: "\nprecision highp float;\nvarying vec4 fragColor;\n\nvoid main() {\n	gl_FragColor = fragColor;\n}\n",
                            uniforms: {
                                scale: t1.prop("scale"),
                                color: t1.prop("fill"),
                                scaleFract: t1.prop("scaleFract"),
                                translateFract: t1.prop("translateFract"),
                                translate: t1.prop("translate"),
                                opacity: t1.prop("opacity"),
                                pixelRatio: t1.context("pixelRatio"),
                                id: t1.prop("id"),
                                viewport: function(t1, e1) {
                                    return [
                                        e1.viewport.x,
                                        e1.viewport.y,
                                        t1.viewportWidth,
                                        t1.viewportHeight
                                    ];
                                }
                            },
                            attributes: {
                                position: {
                                    buffer: t1.prop("positionBuffer"),
                                    stride: 8,
                                    offset: 8
                                },
                                positionFract: {
                                    buffer: t1.prop("positionFractBuffer"),
                                    stride: 8,
                                    offset: 8
                                }
                            },
                            blend: n.blend,
                            depth: {
                                enable: !1
                            },
                            scissor: n.scissor,
                            stencil: n.stencil,
                            viewport: n.viewport
                        }),
                        rect: i,
                        miter: e1
                    };
                }, g.defaults = {
                    dashes: null,
                    join: "miter",
                    miterLimit: 1,
                    thickness: 10,
                    cap: "square",
                    color: "black",
                    opacity: 1,
                    overlay: !1,
                    viewport: null,
                    range: null,
                    close: !1,
                    fill: null
                }, g.prototype.render = function() {
                    for(var t1, e1 = [], r = arguments.length; r--;)e1[r] = arguments[r];
                    e1.length && (t1 = this).update.apply(t1, e1), this.draw();
                }, g.prototype.draw = function() {
                    for(var t1 = this, e1 = [], r = arguments.length; r--;)e1[r] = arguments[r];
                    return (e1.length ? e1 : this.passes).forEach(function(e1, r) {
                        var n;
                        if (e1 && Array.isArray(e1)) return (n = t1).draw.apply(n, e1);
                        "number" == typeof e1 && (e1 = t1.passes[e1]), e1 && e1.count > 1 && e1.opacity && (t1.regl._refresh(), e1.fill && e1.triangles && e1.triangles.length > 2 && t1.shaders.fill(e1), e1.thickness && (e1.scale[0] * e1.viewport.width > g.precisionThreshold || e1.scale[1] * e1.viewport.height > g.precisionThreshold || "rect" === e1.join || !e1.join && (e1.thickness <= 2 || e1.count >= g.maxPoints) ? t1.shaders.rect(e1) : t1.shaders.miter(e1)));
                    }), this;
                }, g.prototype.update = function(t1) {
                    var e1 = this;
                    if (t1) {
                        null != t1.length ? "number" == typeof t1[0] && (t1 = [
                            {
                                positions: t1
                            }
                        ]) : Array.isArray(t1) || (t1 = [
                            t1
                        ]);
                        var r = this.regl, u = this.gl;
                        if (t1.forEach(function(t1, p) {
                            var y = e1.passes[p];
                            if (void 0 !== t1) {
                                if (null !== t1) {
                                    if ("number" == typeof t1[0] && (t1 = {
                                        positions: t1
                                    }), t1 = o(t1, {
                                        positions: "positions points data coords",
                                        thickness: "thickness lineWidth lineWidths line-width linewidth width stroke-width strokewidth strokeWidth",
                                        join: "lineJoin linejoin join type mode",
                                        miterLimit: "miterlimit miterLimit",
                                        dashes: "dash dashes dasharray dash-array dashArray",
                                        color: "color colour stroke colors colours stroke-color strokeColor",
                                        fill: "fill fill-color fillColor",
                                        opacity: "alpha opacity",
                                        overlay: "overlay crease overlap intersect",
                                        close: "closed close closed-path closePath",
                                        range: "range dataBox",
                                        viewport: "viewport viewBox",
                                        hole: "holes hole hollow",
                                        splitNull: "splitNull"
                                    }), y || (e1.passes[p] = y = {
                                        id: p,
                                        scale: null,
                                        scaleFract: null,
                                        translate: null,
                                        translateFract: null,
                                        count: 0,
                                        hole: [],
                                        depth: 0,
                                        dashLength: 1,
                                        dashTexture: r.texture({
                                            channels: 1,
                                            data: new Uint8Array([
                                                255
                                            ]),
                                            width: 1,
                                            height: 1,
                                            mag: "linear",
                                            min: "linear"
                                        }),
                                        colorBuffer: r.buffer({
                                            usage: "dynamic",
                                            type: "uint8",
                                            data: new Uint8Array
                                        }),
                                        positionBuffer: r.buffer({
                                            usage: "dynamic",
                                            type: "float",
                                            data: new Uint8Array
                                        }),
                                        positionFractBuffer: r.buffer({
                                            usage: "dynamic",
                                            type: "float",
                                            data: new Uint8Array
                                        })
                                    }, t1 = a({}, g.defaults, t1)), null != t1.thickness && (y.thickness = parseFloat(t1.thickness)), null != t1.opacity && (y.opacity = parseFloat(t1.opacity)), null != t1.miterLimit && (y.miterLimit = parseFloat(t1.miterLimit)), null != t1.overlay && (y.overlay = !!t1.overlay, p < g.maxLines && (y.depth = 2 * (g.maxLines - 1 - p % g.maxLines) / g.maxLines - 1)), null != t1.join && (y.join = t1.join), null != t1.hole && (y.hole = t1.hole), null != t1.fill && (y.fill = t1.fill ? n(t1.fill, "uint8") : null), null != t1.viewport && (y.viewport = d(t1.viewport)), y.viewport || (y.viewport = d([
                                        u.drawingBufferWidth,
                                        u.drawingBufferHeight
                                    ])), null != t1.close && (y.close = t1.close), null === t1.positions && (t1.positions = []), t1.positions) {
                                        var v, x;
                                        if (t1.positions.x && t1.positions.y) {
                                            var _ = t1.positions.x, b = t1.positions.y;
                                            x = y.count = Math.max(_.length, b.length), v = new Float64Array(2 * x);
                                            for(var w = 0; w < x; w++)v[2 * w] = _[w], v[2 * w + 1] = b[w];
                                        } else v = s(t1.positions, "float64"), x = y.count = Math.floor(v.length / 2);
                                        var T = y.bounds = i(v, 2);
                                        if (y.fill) {
                                            for(var k = [], A = {}, M = 0, S = 0, E = 0, C = y.count; S < C; S++){
                                                var L = v[2 * S], I = v[2 * S + 1];
                                                isNaN(L) || isNaN(I) || null == L || null == I ? (L = v[2 * M], I = v[2 * M + 1], A[S] = M) : M = S, k[E++] = L, k[E++] = I;
                                            }
                                            if (t1.splitNull) {
                                                y.count - 1 in A || (A[y.count] = y.count - 1);
                                                var P = Object.keys(A).map(Number).sort(function(t1, e1) {
                                                    return t1 - e1;
                                                }), z = [], O = 0, D = null != y.hole ? y.hole[0] : null;
                                                if (null != D) {
                                                    var R = m(P, function(t1) {
                                                        return t1 >= D;
                                                    });
                                                    (P = P.slice(0, R)).push(D);
                                                }
                                                for(var F = function(t1) {
                                                    var e1 = k.slice(2 * O, 2 * P[t1]).concat(D ? k.slice(2 * D) : []), r = (y.hole || []).map(function(e1) {
                                                        return e1 - D + (P[t1] - O);
                                                    }), n = l(e1, r);
                                                    n = n.map(function(e1) {
                                                        return e1 + O + (e1 + O < P[t1] ? 0 : D - P[t1]);
                                                    }), z.push.apply(z, n), O = P[t1] + 1;
                                                }, B = 0; B < P.length; B++)F(B);
                                                for(var N = 0, j = z.length; N < j; N++)null != A[z[N]] && (z[N] = A[z[N]]);
                                                y.triangles = z;
                                            } else {
                                                for(var U = l(k, y.hole || []), V = 0, q = U.length; V < q; V++)null != A[U[V]] && (U[V] = A[U[V]]);
                                                y.triangles = U;
                                            }
                                        }
                                        var H = new Float64Array(v);
                                        c(H, 2, T);
                                        var G = new Float64Array(2 * x + 6);
                                        y.close ? v[0] === v[2 * x - 2] && v[1] === v[2 * x - 1] ? (G[0] = H[2 * x - 4], G[1] = H[2 * x - 3]) : (G[0] = H[2 * x - 2], G[1] = H[2 * x - 1]) : (G[0] = H[0], G[1] = H[1]), G.set(H, 2), y.close ? v[0] === v[2 * x - 2] && v[1] === v[2 * x - 1] ? (G[2 * x + 2] = H[2], G[2 * x + 3] = H[3], y.count -= 1) : (G[2 * x + 2] = H[0], G[2 * x + 3] = H[1], G[2 * x + 4] = H[2], G[2 * x + 5] = H[3]) : (G[2 * x + 2] = H[2 * x - 2], G[2 * x + 3] = H[2 * x - 1], G[2 * x + 4] = H[2 * x - 2], G[2 * x + 5] = H[2 * x - 1]);
                                        var Z = h(G);
                                        y.positionBuffer(Z);
                                        var W = f(G, Z);
                                        y.positionFractBuffer(W);
                                    }
                                    if (t1.range ? y.range = t1.range : y.range || (y.range = y.bounds), (t1.range || t1.positions) && y.count) {
                                        var Y = y.bounds, X = Y[2] - Y[0], $ = Y[3] - Y[1], J = y.range[2] - y.range[0], K = y.range[3] - y.range[1];
                                        y.scale = [
                                            X / J,
                                            $ / K
                                        ], y.translate = [
                                            -y.range[0] / J + Y[0] / J || 0,
                                            -y.range[1] / K + Y[1] / K || 0
                                        ], y.scaleFract = f(y.scale), y.translateFract = f(y.translate);
                                    }
                                    if (t1.dashes) {
                                        var Q, tt = 0;
                                        if (!t1.dashes || t1.dashes.length < 2) tt = 1, Q = new Uint8Array([
                                            255,
                                            255,
                                            255,
                                            255,
                                            255,
                                            255,
                                            255,
                                            255
                                        ]);
                                        else {
                                            tt = 0;
                                            for(var et = 0; et < t1.dashes.length; ++et)tt += t1.dashes[et];
                                            Q = new Uint8Array(tt * g.dashMult);
                                            for(var rt = 0, nt = 255, it = 0; it < 2; it++)for(var at = 0; at < t1.dashes.length; ++at){
                                                for(var ot = 0, st = t1.dashes[at] * g.dashMult * .5; ot < st; ++ot)Q[rt++] = nt;
                                                nt ^= 255;
                                            }
                                        }
                                        y.dashLength = tt, y.dashTexture({
                                            channels: 1,
                                            data: Q,
                                            width: Q.length,
                                            height: 1,
                                            mag: "linear",
                                            min: "linear"
                                        }, 0, 0);
                                    }
                                    if (t1.color) {
                                        var lt = y.count, ct = t1.color;
                                        ct || (ct = "transparent");
                                        var ut = new Uint8Array(4 * lt + 4);
                                        if (Array.isArray(ct) && "number" != typeof ct[0]) {
                                            for(var ht = 0; ht < lt; ht++){
                                                var ft = n(ct[ht], "uint8");
                                                ut.set(ft, 4 * ht);
                                            }
                                            ut.set(n(ct[0], "uint8"), 4 * lt);
                                        } else for(var pt = n(ct, "uint8"), dt = 0; dt < lt + 1; dt++)ut.set(pt, 4 * dt);
                                        y.colorBuffer({
                                            usage: "dynamic",
                                            type: "uint8",
                                            data: ut
                                        });
                                    }
                                } else e1.passes[p] = null;
                            }
                        }), t1.length < this.passes.length) {
                            for(var p = t1.length; p < this.passes.length; p++){
                                var y = this.passes[p];
                                y && (y.colorBuffer.destroy(), y.positionBuffer.destroy(), y.dashTexture.destroy());
                            }
                            this.passes.length = t1.length;
                        }
                        for(var v = [], x = 0; x < this.passes.length; x++)null !== this.passes[x] && v.push(this.passes[x]);
                        return this.passes = v, this;
                    }
                }, g.prototype.destroy = function() {
                    return this.passes.forEach(function(t1) {
                        t1.colorBuffer.destroy(), t1.positionBuffer.destroy(), t1.dashTexture.destroy();
                    }), this.passes.length = 0, this;
                };
            },
            62172: function(t1, e1, r) {
                "use strict";
                function n(t1, e1) {
                    return function(t1) {
                        if (Array.isArray(t1)) return t1;
                    }(t1) || function(t1, e1) {
                        var r = null == t1 ? null : "undefined" != typeof Symbol && t1[Symbol.iterator] || t1["@@iterator"];
                        if (null != r) {
                            var n, i, a, o, s = [], l = !0, c = !1;
                            try {
                                if (a = (r = r.call(t1)).next, 0 === e1) {
                                    if (Object(r) !== r) return;
                                    l = !1;
                                } else for(; !(l = (n = a.call(r)).done) && (s.push(n.value), s.length !== e1); l = !0);
                            } catch (t1) {
                                c = !0, i = t1;
                            } finally{
                                try {
                                    if (!l && null != r.return && (o = r.return(), Object(o) !== o)) return;
                                } finally{
                                    if (c) throw i;
                                }
                            }
                            return s;
                        }
                    }(t1, e1) || i(t1, e1) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function i(t1, e1) {
                    if (t1) {
                        if ("string" == typeof t1) return a(t1, e1);
                        var r = Object.prototype.toString.call(t1).slice(8, -1);
                        return "Object" === r && t1.constructor && (r = t1.constructor.name), "Map" === r || "Set" === r ? Array.from(t1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? a(t1, e1) : void 0;
                    }
                }
                function a(t1, e1) {
                    (null == e1 || e1 > t1.length) && (e1 = t1.length);
                    for(var r = 0, n = new Array(e1); r < e1; r++)n[r] = t1[r];
                    return n;
                }
                var o = r(162), s = r(78112), l = r(46762), c = r(27549), u = r(27976), h = r(76765), f = r(6807), p = r(79788), d = r(83473), m = r(39488), g = r(51498), y = r(5137), v = x;
                function x(t1, e1) {
                    var r = this;
                    if (!(this instanceof x)) return new x(t1, e1);
                    "function" == typeof t1 ? (e1 || (e1 = {}), e1.regl = t1) : (e1 = t1, t1 = null), e1 && e1.length && (e1.positions = e1);
                    var n, i = (t1 = e1.regl)._gl, a = [];
                    this.tooManyColors = m, n = t1.texture({
                        data: new Uint8Array(1020),
                        width: 255,
                        height: 1,
                        type: "uint8",
                        format: "rgba",
                        wrapS: "clamp",
                        wrapT: "clamp",
                        mag: "nearest",
                        min: "nearest"
                    }), u(this, {
                        regl: t1,
                        gl: i,
                        groups: [],
                        markerCache: [
                            null
                        ],
                        markerTextures: [
                            null
                        ],
                        palette: a,
                        paletteIds: {},
                        paletteTexture: n,
                        maxColors: 255,
                        maxSize: 100,
                        canvas: i.canvas
                    }), this.update(e1);
                    var o = {
                        uniforms: {
                            constPointSize: !!e1.constPointSize,
                            opacity: t1.prop("opacity"),
                            paletteSize: function(t1, e1) {
                                return [
                                    r.tooManyColors ? 0 : 255,
                                    n.height
                                ];
                            },
                            pixelRatio: t1.context("pixelRatio"),
                            scale: t1.prop("scale"),
                            scaleFract: t1.prop("scaleFract"),
                            translate: t1.prop("translate"),
                            translateFract: t1.prop("translateFract"),
                            markerTexture: t1.prop("markerTexture"),
                            paletteTexture: n
                        },
                        attributes: {
                            x: function(t1, e1) {
                                return e1.xAttr || {
                                    buffer: e1.positionBuffer,
                                    stride: 8,
                                    offset: 0
                                };
                            },
                            y: function(t1, e1) {
                                return e1.yAttr || {
                                    buffer: e1.positionBuffer,
                                    stride: 8,
                                    offset: 4
                                };
                            },
                            xFract: function(t1, e1) {
                                return e1.xAttr ? {
                                    constant: [
                                        0,
                                        0
                                    ]
                                } : {
                                    buffer: e1.positionFractBuffer,
                                    stride: 8,
                                    offset: 0
                                };
                            },
                            yFract: function(t1, e1) {
                                return e1.yAttr ? {
                                    constant: [
                                        0,
                                        0
                                    ]
                                } : {
                                    buffer: e1.positionFractBuffer,
                                    stride: 8,
                                    offset: 4
                                };
                            },
                            size: function(t1, e1) {
                                return e1.size.length ? {
                                    buffer: e1.sizeBuffer,
                                    stride: 2,
                                    offset: 0
                                } : {
                                    constant: [
                                        Math.round(255 * e1.size / r.maxSize)
                                    ]
                                };
                            },
                            borderSize: function(t1, e1) {
                                return e1.borderSize.length ? {
                                    buffer: e1.sizeBuffer,
                                    stride: 2,
                                    offset: 1
                                } : {
                                    constant: [
                                        Math.round(255 * e1.borderSize / r.maxSize)
                                    ]
                                };
                            },
                            colorId: function(t1, e1) {
                                return e1.color.length ? {
                                    buffer: e1.colorBuffer,
                                    stride: r.tooManyColors ? 8 : 4,
                                    offset: 0
                                } : {
                                    constant: r.tooManyColors ? a.slice(4 * e1.color, 4 * e1.color + 4) : [
                                        e1.color
                                    ]
                                };
                            },
                            borderColorId: function(t1, e1) {
                                return e1.borderColor.length ? {
                                    buffer: e1.colorBuffer,
                                    stride: r.tooManyColors ? 8 : 4,
                                    offset: r.tooManyColors ? 4 : 2
                                } : {
                                    constant: r.tooManyColors ? a.slice(4 * e1.borderColor, 4 * e1.borderColor + 4) : [
                                        e1.borderColor
                                    ]
                                };
                            },
                            isActive: function(t1, e1) {
                                return !0 === e1.activation ? {
                                    constant: [
                                        1
                                    ]
                                } : e1.activation ? e1.activation : {
                                    constant: [
                                        0
                                    ]
                                };
                            }
                        },
                        blend: {
                            enable: !0,
                            color: [
                                0,
                                0,
                                0,
                                1
                            ],
                            func: {
                                srcRGB: "src alpha",
                                dstRGB: "one minus src alpha",
                                srcAlpha: "one minus dst alpha",
                                dstAlpha: "one"
                            }
                        },
                        scissor: {
                            enable: !0,
                            box: t1.prop("viewport")
                        },
                        viewport: t1.prop("viewport"),
                        stencil: {
                            enable: !1
                        },
                        depth: {
                            enable: !1
                        },
                        elements: t1.prop("elements"),
                        count: t1.prop("count"),
                        offset: t1.prop("offset"),
                        primitive: "points"
                    }, s = u({}, o);
                    s.frag = h([
                        "precision highp float;\n#define GLSLIFY 1\n\nuniform float opacity;\nuniform sampler2D markerTexture;\n\nvarying vec4 fragColor, fragBorderColor;\nvarying float fragWidth, fragBorderColorLevel, fragColorLevel;\n\nfloat smoothStep(float x, float y) {\n  return 1.0 / (1.0 + exp(50.0*(x - y)));\n}\n\nvoid main() {\n  float dist = texture2D(markerTexture, gl_PointCoord).r, delta = fragWidth;\n\n  // max-distance alpha\n  if (dist < 0.003) discard;\n\n  // null-border case\n  if (fragBorderColorLevel == fragColorLevel || fragBorderColor.a == 0.) {\n    float colorAmt = smoothstep(.5 - delta, .5 + delta, dist);\n    gl_FragColor = vec4(fragColor.rgb, colorAmt * fragColor.a * opacity);\n  }\n  else {\n    float borderColorAmt = smoothstep(fragBorderColorLevel - delta, fragBorderColorLevel + delta, dist);\n    float colorAmt = smoothstep(fragColorLevel - delta, fragColorLevel + delta, dist);\n\n    vec4 color = fragBorderColor;\n    color.a *= borderColorAmt;\n    color = mix(color, fragColor, colorAmt);\n    color.a *= opacity;\n\n    gl_FragColor = color;\n  }\n\n}\n"
                    ]), s.vert = h([
                        "precision highp float;\n#define GLSLIFY 1\n\nattribute float x, y, xFract, yFract;\nattribute float size, borderSize;\nattribute vec4 colorId, borderColorId;\nattribute float isActive;\n\n// `invariant` effectively turns off optimizations for the position.\n// We need this because -fast-math on M1 Macs is re-ordering\n// floating point operations in a way that causes floating point\n// precision limits to put points in the wrong locations.\ninvariant gl_Position;\n\nuniform bool constPointSize;\nuniform float pixelRatio;\nuniform vec2 scale, scaleFract, translate, translateFract, paletteSize;\nuniform sampler2D paletteTexture;\n\nconst float maxSize = 100.;\nconst float borderLevel = .5;\n\nvarying vec4 fragColor, fragBorderColor;\nvarying float fragPointSize, fragBorderRadius, fragWidth, fragBorderColorLevel, fragColorLevel;\n\nfloat pointSizeScale = (constPointSize) ? 2. : pixelRatio;\n\nbool isDirect = (paletteSize.x < 1.);\n\nvec4 getColor(vec4 id) {\n  return isDirect ? id / 255. : texture2D(paletteTexture,\n    vec2(\n      (id.x + .5) / paletteSize.x,\n      (id.y + .5) / paletteSize.y\n    )\n  );\n}\n\nvoid main() {\n  // ignore inactive points\n  if (isActive == 0.) return;\n\n  vec2 position = vec2(x, y);\n  vec2 positionFract = vec2(xFract, yFract);\n\n  vec4 color = getColor(colorId);\n  vec4 borderColor = getColor(borderColorId);\n\n  float size = size * maxSize / 255.;\n  float borderSize = borderSize * maxSize / 255.;\n\n  gl_PointSize = 2. * size * pointSizeScale;\n  fragPointSize = size * pixelRatio;\n\n  vec2 pos = (position + translate) * scale\n      + (positionFract + translateFract) * scale\n      + (position + translate) * scaleFract\n      + (positionFract + translateFract) * scaleFract;\n\n  gl_Position = vec4(pos * 2. - 1., 0., 1.);\n\n  fragColor = color;\n  fragBorderColor = borderColor;\n  fragWidth = 1. / gl_PointSize;\n\n  fragBorderColorLevel = clamp(borderLevel - borderLevel * borderSize / size, 0., 1.);\n  fragColorLevel = clamp(borderLevel + (1. - borderLevel) * borderSize / size, 0., 1.);\n}\n"
                    ]), this.drawMarker = t1(s);
                    var l = u({}, o);
                    l.frag = h([
                        "precision highp float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor, fragBorderColor;\nvarying float fragBorderRadius, fragWidth;\n\nuniform float opacity;\n\nfloat smoothStep(float edge0, float edge1, float x) {\n	float t;\n	t = clamp((x - edge0) / (edge1 - edge0), 0.0, 1.0);\n	return t * t * (3.0 - 2.0 * t);\n}\n\nvoid main() {\n	float radius, alpha = 1.0, delta = fragWidth;\n\n	radius = length(2.0 * gl_PointCoord.xy - 1.0);\n\n	if (radius > 1.0 + delta) {\n		discard;\n	}\n\n	alpha -= smoothstep(1.0 - delta, 1.0 + delta, radius);\n\n	float borderRadius = fragBorderRadius;\n	float ratio = smoothstep(borderRadius - delta, borderRadius + delta, radius);\n	vec4 color = mix(fragColor, fragBorderColor, ratio);\n	color.a *= alpha * opacity;\n	gl_FragColor = color;\n}\n"
                    ]), l.vert = h([
                        "precision highp float;\n#define GLSLIFY 1\n\nattribute float x, y, xFract, yFract;\nattribute float size, borderSize;\nattribute vec4 colorId, borderColorId;\nattribute float isActive;\n\n// `invariant` effectively turns off optimizations for the position.\n// We need this because -fast-math on M1 Macs is re-ordering\n// floating point operations in a way that causes floating point\n// precision limits to put points in the wrong locations.\ninvariant gl_Position;\n\nuniform bool constPointSize;\nuniform float pixelRatio;\nuniform vec2 paletteSize, scale, scaleFract, translate, translateFract;\nuniform sampler2D paletteTexture;\n\nconst float maxSize = 100.;\n\nvarying vec4 fragColor, fragBorderColor;\nvarying float fragBorderRadius, fragWidth;\n\nfloat pointSizeScale = (constPointSize) ? 2. : pixelRatio;\n\nbool isDirect = (paletteSize.x < 1.);\n\nvec4 getColor(vec4 id) {\n  return isDirect ? id / 255. : texture2D(paletteTexture,\n    vec2(\n      (id.x + .5) / paletteSize.x,\n      (id.y + .5) / paletteSize.y\n    )\n  );\n}\n\nvoid main() {\n  // ignore inactive points\n  if (isActive == 0.) return;\n\n  vec2 position = vec2(x, y);\n  vec2 positionFract = vec2(xFract, yFract);\n\n  vec4 color = getColor(colorId);\n  vec4 borderColor = getColor(borderColorId);\n\n  float size = size * maxSize / 255.;\n  float borderSize = borderSize * maxSize / 255.;\n\n  gl_PointSize = (size + borderSize) * pointSizeScale;\n\n  vec2 pos = (position + translate) * scale\n      + (positionFract + translateFract) * scale\n      + (position + translate) * scaleFract\n      + (positionFract + translateFract) * scaleFract;\n\n  gl_Position = vec4(pos * 2. - 1., 0., 1.);\n\n  fragBorderRadius = 1. - 2. * borderSize / (size + borderSize);\n  fragColor = color;\n  fragBorderColor = borderColor.a == 0. || borderSize == 0. ? vec4(color.rgb, 0.) : borderColor;\n  fragWidth = 1. / gl_PointSize;\n}\n"
                    ]), m && (l.frag = l.frag.replace("smoothstep", "smoothStep"), s.frag = s.frag.replace("smoothstep", "smoothStep")), this.drawCircle = t1(l);
                }
                x.defaults = {
                    color: "black",
                    borderColor: "transparent",
                    borderSize: 0,
                    size: 12,
                    opacity: 1,
                    marker: void 0,
                    viewport: null,
                    range: null,
                    pixelSize: null,
                    count: 0,
                    offset: 0,
                    bounds: null,
                    positions: [],
                    snap: 1e4
                }, x.prototype.render = function() {
                    return arguments.length && this.update.apply(this, arguments), this.draw(), this;
                }, x.prototype.draw = function() {
                    for(var t1 = this, e1 = arguments.length, r = new Array(e1), n = 0; n < e1; n++)r[n] = arguments[n];
                    var i = this.groups;
                    if (1 === r.length && Array.isArray(r[0]) && (null === r[0][0] || Array.isArray(r[0][0])) && (r = r[0]), this.regl._refresh(), r.length) for(var a = 0; a < r.length; a++)this.drawItem(a, r[a]);
                    else i.forEach(function(e1, r) {
                        t1.drawItem(r);
                    });
                    return this;
                }, x.prototype.drawItem = function(t1, e1) {
                    var r, n = this.groups, o = n[t1];
                    if ("number" == typeof e1 && (t1 = e1, o = n[e1], e1 = null), o && o.count && o.opacity) {
                        o.activation[0] && this.drawCircle(this.getMarkerDrawOptions(0, o, e1));
                        for(var s = [], l = 1; l < o.activation.length; l++)o.activation[l] && (!0 === o.activation[l] || o.activation[l].data.length) && s.push.apply(s, function(t1) {
                            if (Array.isArray(t1)) return a(t1);
                        }(r = this.getMarkerDrawOptions(l, o, e1)) || function(t1) {
                            if ("undefined" != typeof Symbol && null != t1[Symbol.iterator] || null != t1["@@iterator"]) return Array.from(t1);
                        }(r) || i(r) || function() {
                            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                        }());
                        s.length && this.drawMarker(s);
                    }
                }, x.prototype.getMarkerDrawOptions = function(t1, e1, r) {
                    var i = e1.range, a = e1.tree, o = e1.viewport, s = e1.activation, l = e1.selectionBuffer, c = e1.count;
                    if (this.regl, !a) return r ? [
                        u({}, e1, {
                            markerTexture: this.markerTextures[t1],
                            activation: s[t1],
                            count: r.length,
                            elements: r,
                            offset: 0
                        })
                    ] : [
                        u({}, e1, {
                            markerTexture: this.markerTextures[t1],
                            activation: s[t1],
                            offset: 0
                        })
                    ];
                    var h = [], f = a.range(i, {
                        lod: !0,
                        px: [
                            (i[2] - i[0]) / o.width,
                            (i[3] - i[1]) / o.height
                        ]
                    });
                    if (r) {
                        for(var p = s[t1].data, d = new Uint8Array(c), m = 0; m < r.length; m++){
                            var g = r[m];
                            d[g] = p ? p[g] : 1;
                        }
                        l.subdata(d);
                    }
                    for(var y = f.length; y--;){
                        var v = n(f[y], 2), x = v[0], _ = v[1];
                        h.push(u({}, e1, {
                            markerTexture: this.markerTextures[t1],
                            activation: r ? l : s[t1],
                            offset: x,
                            count: _ - x
                        }));
                    }
                    return h;
                }, x.prototype.update = function() {
                    for(var t1 = this, e1 = arguments.length, r = new Array(e1), n = 0; n < e1; n++)r[n] = arguments[n];
                    if (r.length) {
                        1 === r.length && Array.isArray(r[0]) && (r = r[0]);
                        var i = this.groups, a = this.gl, o = this.regl, l = this.maxSize, h = this.maxColors, m = this.palette;
                        this.groups = i = r.map(function(e1, r) {
                            var n = i[r];
                            if (void 0 === e1) return n;
                            null === e1 ? e1 = {
                                positions: null
                            } : "function" == typeof e1 ? e1 = {
                                ondraw: e1
                            } : "number" == typeof e1[0] && (e1 = {
                                positions: e1
                            }), null === (e1 = f(e1, {
                                positions: "positions data points",
                                snap: "snap cluster lod tree",
                                size: "sizes size radius",
                                borderSize: "borderSizes borderSize border-size bordersize borderWidth borderWidths border-width borderwidth stroke-width strokeWidth strokewidth outline",
                                color: "colors color fill fill-color fillColor",
                                borderColor: "borderColors borderColor stroke stroke-color strokeColor",
                                marker: "markers marker shape",
                                range: "range dataBox databox",
                                viewport: "viewport viewPort viewBox viewbox",
                                opacity: "opacity alpha transparency",
                                bounds: "bound bounds boundaries limits",
                                tooManyColors: "tooManyColors palette paletteMode optimizePalette enablePalette"
                            })).positions && (e1.positions = []), null != e1.tooManyColors && (t1.tooManyColors = e1.tooManyColors), n || (i[r] = n = {
                                id: r,
                                scale: null,
                                translate: null,
                                scaleFract: null,
                                translateFract: null,
                                activation: [],
                                selectionBuffer: o.buffer({
                                    data: new Uint8Array(0),
                                    usage: "stream",
                                    type: "uint8"
                                }),
                                sizeBuffer: o.buffer({
                                    data: new Uint8Array(0),
                                    usage: "dynamic",
                                    type: "uint8"
                                }),
                                colorBuffer: o.buffer({
                                    data: new Uint8Array(0),
                                    usage: "dynamic",
                                    type: "uint8"
                                }),
                                positionBuffer: o.buffer({
                                    data: new Uint8Array(0),
                                    usage: "dynamic",
                                    type: "float"
                                }),
                                positionFractBuffer: o.buffer({
                                    data: new Uint8Array(0),
                                    usage: "dynamic",
                                    type: "float"
                                })
                            }, e1 = u({}, x.defaults, e1)), e1.positions && !("marker" in e1) && (e1.marker = n.marker, delete n.marker), e1.marker && !("positions" in e1) && (e1.positions = n.positions, delete n.positions);
                            var v = 0, _ = 0;
                            if (p(n, e1, [
                                {
                                    snap: !0,
                                    size: function(t1, e1) {
                                        return null == t1 && (t1 = x.defaults.size), v += t1 && t1.length ? 1 : 0, t1;
                                    },
                                    borderSize: function(t1, e1) {
                                        return null == t1 && (t1 = x.defaults.borderSize), v += t1 && t1.length ? 1 : 0, t1;
                                    },
                                    opacity: parseFloat,
                                    color: function(e1, r) {
                                        return null == e1 && (e1 = x.defaults.color), e1 = t1.updateColor(e1), _++, e1;
                                    },
                                    borderColor: function(e1, r) {
                                        return null == e1 && (e1 = x.defaults.borderColor), e1 = t1.updateColor(e1), _++, e1;
                                    },
                                    bounds: function(t1, e1, r) {
                                        return "range" in r || (r.range = null), t1;
                                    },
                                    positions: function(t1, e1, r) {
                                        var n = e1.snap, i = e1.positionBuffer, a = e1.positionFractBuffer, l = e1.selectionBuffer;
                                        if (t1.x || t1.y) return t1.x.length ? e1.xAttr = {
                                            buffer: o.buffer(t1.x),
                                            offset: 0,
                                            stride: 4,
                                            count: t1.x.length
                                        } : e1.xAttr = {
                                            buffer: t1.x.buffer,
                                            offset: 4 * t1.x.offset || 0,
                                            stride: 4 * (t1.x.stride || 1),
                                            count: t1.x.count
                                        }, t1.y.length ? e1.yAttr = {
                                            buffer: o.buffer(t1.y),
                                            offset: 0,
                                            stride: 4,
                                            count: t1.y.length
                                        } : e1.yAttr = {
                                            buffer: t1.y.buffer,
                                            offset: 4 * t1.y.offset || 0,
                                            stride: 4 * (t1.y.stride || 1),
                                            count: t1.y.count
                                        }, e1.count = Math.max(e1.xAttr.count, e1.yAttr.count), t1;
                                        t1 = d(t1, "float64");
                                        var u = e1.count = Math.floor(t1.length / 2), h = e1.bounds = u ? s(t1, 2) : null;
                                        if (r.range || e1.range || (delete e1.range, r.range = h), r.marker || e1.marker || (delete e1.marker, r.marker = null), n && (!0 === n || u > n) ? e1.tree = c(t1, {
                                            bounds: h
                                        }) : n && n.length && (e1.tree = n), e1.tree) {
                                            var f = {
                                                primitive: "points",
                                                usage: "static",
                                                data: e1.tree,
                                                type: "uint32"
                                            };
                                            e1.elements ? e1.elements(f) : e1.elements = o.elements(f);
                                        }
                                        var p = g.float32(t1);
                                        return i({
                                            data: p,
                                            usage: "dynamic"
                                        }), a({
                                            data: g.fract32(t1, p),
                                            usage: "dynamic"
                                        }), l({
                                            data: new Uint8Array(u),
                                            type: "uint8",
                                            usage: "stream"
                                        }), t1;
                                    }
                                },
                                {
                                    marker: function(e1, r, n) {
                                        var i = r.activation;
                                        if (i.forEach(function(t1) {
                                            return t1 && t1.destroy && t1.destroy();
                                        }), i.length = 0, e1 && "number" != typeof e1[0]) {
                                            for(var a = [], s = 0, l = Math.min(e1.length, r.count); s < l; s++){
                                                var c = t1.addMarker(e1[s]);
                                                a[c] || (a[c] = new Uint8Array(r.count)), a[c][s] = 1;
                                            }
                                            for(var u = 0; u < a.length; u++)if (a[u]) {
                                                var h = {
                                                    data: a[u],
                                                    type: "uint8",
                                                    usage: "static"
                                                };
                                                i[u] ? i[u](h) : i[u] = o.buffer(h), i[u].data = a[u];
                                            }
                                        } else i[t1.addMarker(e1)] = !0;
                                        return e1;
                                    },
                                    range: function(t1, e1, r) {
                                        var n = e1.bounds;
                                        if (n) return t1 || (t1 = n), e1.scale = [
                                            1 / (t1[2] - t1[0]),
                                            1 / (t1[3] - t1[1])
                                        ], e1.translate = [
                                            -t1[0],
                                            -t1[1]
                                        ], e1.scaleFract = g.fract(e1.scale), e1.translateFract = g.fract(e1.translate), t1;
                                    },
                                    viewport: function(t1) {
                                        return y(t1 || [
                                            a.drawingBufferWidth,
                                            a.drawingBufferHeight
                                        ]);
                                    }
                                }
                            ]), v) {
                                var b = n, w = b.count, T = b.size, k = b.borderSize, A = b.sizeBuffer, M = new Uint8Array(2 * w);
                                if (T.length || k.length) for(var S = 0; S < w; S++)M[2 * S] = Math.round(255 * (null == T[S] ? T : T[S]) / l), M[2 * S + 1] = Math.round(255 * (null == k[S] ? k : k[S]) / l);
                                A({
                                    data: M,
                                    usage: "dynamic"
                                });
                            }
                            if (_) {
                                var E, C = n, L = C.count, I = C.color, P = C.borderColor, z = C.colorBuffer;
                                if (t1.tooManyColors) {
                                    if (I.length || P.length) {
                                        E = new Uint8Array(8 * L);
                                        for(var O = 0; O < L; O++){
                                            var D = I[O];
                                            E[8 * O] = m[4 * D], E[8 * O + 1] = m[4 * D + 1], E[8 * O + 2] = m[4 * D + 2], E[8 * O + 3] = m[4 * D + 3];
                                            var R = P[O];
                                            E[8 * O + 4] = m[4 * R], E[8 * O + 5] = m[4 * R + 1], E[8 * O + 6] = m[4 * R + 2], E[8 * O + 7] = m[4 * R + 3];
                                        }
                                    }
                                } else if (I.length || P.length) {
                                    E = new Uint8Array(4 * L + 2);
                                    for(var F = 0; F < L; F++)null != I[F] && (E[4 * F] = I[F] % h, E[4 * F + 1] = Math.floor(I[F] / h)), null != P[F] && (E[4 * F + 2] = P[F] % h, E[4 * F + 3] = Math.floor(P[F] / h));
                                }
                                z({
                                    data: E || new Uint8Array(0),
                                    type: "uint8",
                                    usage: "dynamic"
                                });
                            }
                            return n;
                        });
                    }
                }, x.prototype.addMarker = function(t1) {
                    var e1, r = this.markerTextures, n = this.regl, i = this.markerCache, a = null == t1 ? 0 : i.indexOf(t1);
                    if (a >= 0) return a;
                    if (t1 instanceof Uint8Array || t1 instanceof Uint8ClampedArray) e1 = t1;
                    else {
                        e1 = new Uint8Array(t1.length);
                        for(var o = 0, s = t1.length; o < s; o++)e1[o] = 255 * t1[o];
                    }
                    var l = Math.floor(Math.sqrt(e1.length));
                    return a = r.length, i.push(t1), r.push(n.texture({
                        channels: 1,
                        data: e1,
                        radius: l,
                        mag: "linear",
                        min: "linear"
                    })), a;
                }, x.prototype.updateColor = function(t1) {
                    var e1 = this.paletteIds, r = this.palette, n = this.maxColors;
                    Array.isArray(t1) || (t1 = [
                        t1
                    ]);
                    var i = [];
                    if ("number" == typeof t1[0]) {
                        var a = [];
                        if (Array.isArray(t1)) for(var s = 0; s < t1.length; s += 4)a.push(t1.slice(s, s + 4));
                        else for(var c = 0; c < t1.length; c += 4)a.push(t1.subarray(c, c + 4));
                        t1 = a;
                    }
                    for(var u = 0; u < t1.length; u++){
                        var h = t1[u];
                        h = o(h, "uint8");
                        var f = l(h, !1);
                        if (null == e1[f]) {
                            var p = r.length;
                            e1[f] = Math.floor(p / 4), r[p] = h[0], r[p + 1] = h[1], r[p + 2] = h[2], r[p + 3] = h[3];
                        }
                        i[u] = e1[f];
                    }
                    return !this.tooManyColors && r.length > 4 * n && (this.tooManyColors = !0), this.updatePalette(r), 1 === i.length ? i[0] : i;
                }, x.prototype.updatePalette = function(t1) {
                    if (!this.tooManyColors) {
                        var e1 = this.maxColors, r = this.paletteTexture, n = Math.ceil(.25 * t1.length / e1);
                        if (n > 1) for(var i = .25 * (t1 = t1.slice()).length % e1; i < n * e1; i++)t1.push(0, 0, 0, 0);
                        r.height < n && r.resize(e1, n), r.subimage({
                            width: Math.min(.25 * t1.length, e1),
                            height: n,
                            data: t1
                        }, 0, 0);
                    }
                }, x.prototype.destroy = function() {
                    return this.groups.forEach(function(t1) {
                        t1.sizeBuffer.destroy(), t1.positionBuffer.destroy(), t1.positionFractBuffer.destroy(), t1.colorBuffer.destroy(), t1.activation.forEach(function(t1) {
                            return t1 && t1.destroy && t1.destroy();
                        }), t1.selectionBuffer.destroy(), t1.elements && t1.elements.destroy();
                    }), this.groups.length = 0, this.paletteTexture.destroy(), this.markerTextures.forEach(function(t1) {
                        return t1 && t1.destroy && t1.destroy();
                    }), this;
                };
                var _ = r(27976);
                t1.exports = function(t1, e1) {
                    var r = new v(t1, e1), n = r.render.bind(r);
                    return _(n, {
                        render: n,
                        update: r.update.bind(r),
                        draw: r.draw.bind(r),
                        destroy: r.destroy.bind(r),
                        regl: r.regl,
                        gl: r.gl,
                        canvas: r.gl.canvas,
                        groups: r.groups,
                        markers: r.markerCache,
                        palette: r.palette
                    }), n;
                };
            },
            31239: function(t1, e1, r) {
                "use strict";
                var n = r(62172), i = r(6807), a = r(78112), o = r(16494), s = r(27902), l = r(5137), c = r(83473);
                function u(t1, e1) {
                    if (!(this instanceof u)) return new u(t1, e1);
                    this.traces = [], this.passes = {}, this.regl = t1, this.scatter = n(t1), this.canvas = this.scatter.canvas;
                }
                function h(t1, e1, r) {
                    return (null != t1.id ? t1.id : t1) << 16 | (255 & e1) << 8 | 255 & r;
                }
                function f(t1, e1, r) {
                    var n, i, a, o, s = t1[e1], l = t1[r];
                    return s.length > 2 ? (s[0], s[2], n = s[1], i = s[3]) : s.length ? (n = s[0], i = s[1]) : (s.x, n = s.y, s.x, s.width, i = s.y + s.height), l.length > 2 ? (a = l[0], o = l[2], l[1], l[3]) : l.length ? (a = l[0], o = l[1]) : (a = l.x, l.y, o = l.x + l.width, l.y, l.height), [
                        a,
                        n,
                        o,
                        i
                    ];
                }
                function p(t1) {
                    if ("number" == typeof t1) return [
                        t1,
                        t1,
                        t1,
                        t1
                    ];
                    if (2 === t1.length) return [
                        t1[0],
                        t1[1],
                        t1[0],
                        t1[1]
                    ];
                    var e1 = l(t1);
                    return [
                        e1.x,
                        e1.y,
                        e1.x + e1.width,
                        e1.y + e1.height
                    ];
                }
                t1.exports = u, u.prototype.render = function() {
                    for(var t1, e1 = this, r = [], n = arguments.length; n--;)r[n] = arguments[n];
                    return r.length && (t1 = this).update.apply(t1, r), this.regl.attributes.preserveDrawingBuffer ? this.draw() : (this.dirty ? null == this.planned && (this.planned = o(function() {
                        e1.draw(), e1.dirty = !0, e1.planned = null;
                    })) : (this.draw(), this.dirty = !0, o(function() {
                        e1.dirty = !1;
                    })), this);
                }, u.prototype.update = function() {
                    for(var t1, e1 = [], r = arguments.length; r--;)e1[r] = arguments[r];
                    if (e1.length) {
                        for(var n = 0; n < e1.length; n++)this.updateItem(n, e1[n]);
                        this.traces = this.traces.filter(Boolean);
                        for(var i = [], a = 0, o = 0; o < this.traces.length; o++){
                            for(var s = this.traces[o], l = this.traces[o].passes, c = 0; c < l.length; c++)i.push(this.passes[l[c]]);
                            s.passOffset = a, a += s.passes.length;
                        }
                        return (t1 = this.scatter).update.apply(t1, i), this;
                    }
                }, u.prototype.updateItem = function(t1, e1) {
                    var r = this.regl;
                    if (null === e1) return this.traces[t1] = null, this;
                    if (!e1) return this;
                    var n, o = i(e1, {
                        data: "data items columns rows values dimensions samples x",
                        snap: "snap cluster",
                        size: "sizes size radius",
                        color: "colors color fill fill-color fillColor",
                        opacity: "opacity alpha transparency opaque",
                        borderSize: "borderSizes borderSize border-size bordersize borderWidth borderWidths border-width borderwidth stroke-width strokeWidth strokewidth outline",
                        borderColor: "borderColors borderColor bordercolor stroke stroke-color strokeColor",
                        marker: "markers marker shape",
                        range: "range ranges databox dataBox",
                        viewport: "viewport viewBox viewbox",
                        domain: "domain domains area areas",
                        padding: "pad padding paddings pads margin margins",
                        transpose: "transpose transposed",
                        diagonal: "diagonal diag showDiagonal",
                        upper: "upper up top upperhalf upperHalf showupperhalf showUpper showUpperHalf",
                        lower: "lower low bottom lowerhalf lowerHalf showlowerhalf showLowerHalf showLower"
                    }), s = this.traces[t1] || (this.traces[t1] = {
                        id: t1,
                        buffer: r.buffer({
                            usage: "dynamic",
                            type: "float",
                            data: new Uint8Array
                        }),
                        color: "black",
                        marker: null,
                        size: 12,
                        borderColor: "transparent",
                        borderSize: 1,
                        viewport: l([
                            r._gl.drawingBufferWidth,
                            r._gl.drawingBufferHeight
                        ]),
                        padding: [
                            0,
                            0,
                            0,
                            0
                        ],
                        opacity: 1,
                        diagonal: !0,
                        upper: !0,
                        lower: !0
                    });
                    if (null != o.color && (s.color = o.color), null != o.size && (s.size = o.size), null != o.marker && (s.marker = o.marker), null != o.borderColor && (s.borderColor = o.borderColor), null != o.borderSize && (s.borderSize = o.borderSize), null != o.opacity && (s.opacity = o.opacity), o.viewport && (s.viewport = l(o.viewport)), null != o.diagonal && (s.diagonal = o.diagonal), null != o.upper && (s.upper = o.upper), null != o.lower && (s.lower = o.lower), o.data) {
                        s.buffer(c(o.data)), s.columns = o.data.length, s.count = o.data[0].length, s.bounds = [];
                        for(var u = 0; u < s.columns; u++)s.bounds[u] = a(o.data[u], 1);
                    }
                    o.range && (s.range = o.range, n = s.range && "number" != typeof s.range[0]), o.domain && (s.domain = o.domain);
                    var d = !1;
                    null != o.padding && (Array.isArray(o.padding) && o.padding.length === s.columns && "number" == typeof o.padding[o.padding.length - 1] ? (s.padding = o.padding.map(p), d = !0) : s.padding = p(o.padding));
                    var m = s.columns, g = s.count, y = s.viewport.width, v = s.viewport.height, x = s.viewport.x, _ = s.viewport.y, b = y / m, w = v / m;
                    s.passes = [];
                    for(var T = 0; T < m; T++)for(var k = 0; k < m; k++)if ((s.diagonal || k !== T) && (s.upper || !(T > k)) && (s.lower || !(T < k))) {
                        var A = h(s.id, T, k), M = this.passes[A] || (this.passes[A] = {});
                        if (o.data && (o.transpose ? M.positions = {
                            x: {
                                buffer: s.buffer,
                                offset: k,
                                count: g,
                                stride: m
                            },
                            y: {
                                buffer: s.buffer,
                                offset: T,
                                count: g,
                                stride: m
                            }
                        } : M.positions = {
                            x: {
                                buffer: s.buffer,
                                offset: k * g,
                                count: g
                            },
                            y: {
                                buffer: s.buffer,
                                offset: T * g,
                                count: g
                            }
                        }, M.bounds = f(s.bounds, T, k)), o.domain || o.viewport || o.data) {
                            var S = d ? f(s.padding, T, k) : s.padding;
                            if (s.domain) {
                                var E = f(s.domain, T, k), C = E[0], L = E[1], I = E[2], P = E[3];
                                M.viewport = [
                                    x + C * y + S[0],
                                    _ + L * v + S[1],
                                    x + I * y - S[2],
                                    _ + P * v - S[3]
                                ];
                            } else M.viewport = [
                                x + k * b + b * S[0],
                                _ + T * w + w * S[1],
                                x + (k + 1) * b - b * S[2],
                                _ + (T + 1) * w - w * S[3]
                            ];
                        }
                        o.color && (M.color = s.color), o.size && (M.size = s.size), o.marker && (M.marker = s.marker), o.borderSize && (M.borderSize = s.borderSize), o.borderColor && (M.borderColor = s.borderColor), o.opacity && (M.opacity = s.opacity), o.range && (M.range = n ? f(s.range, T, k) : s.range || M.bounds), s.passes.push(A);
                    }
                    return this;
                }, u.prototype.draw = function() {
                    for(var t1, e1 = [], r = arguments.length; r--;)e1[r] = arguments[r];
                    if (e1.length) {
                        for(var n = [], i = 0; i < e1.length; i++)if ("number" == typeof e1[i]) {
                            var a = this.traces[e1[i]], o = a.passes, l = a.passOffset;
                            n.push.apply(n, s(l, l + o.length));
                        } else if (e1[i].length) {
                            var c = e1[i], u = this.traces[i], h = u.passes, f = u.passOffset;
                            h = h.map(function(t1, e1) {
                                n[f + e1] = c;
                            });
                        }
                        (t1 = this.scatter).draw.apply(t1, n);
                    } else this.scatter.draw();
                    return this;
                }, u.prototype.destroy = function() {
                    return this.traces.forEach(function(t1) {
                        t1.buffer && t1.buffer.destroy && t1.buffer.destroy();
                    }), this.traces = null, this.passes = null, this.scatter.destroy(), this;
                };
            },
            81330: function(t1) {
                t1.exports = function() {
                    function t1(t1, e1) {
                        this.id = Z++, this.type = t1, this.data = e1;
                    }
                    function e1(t1) {
                        if (0 === t1.length) return [];
                        var r = t1.charAt(0), n = t1.charAt(t1.length - 1);
                        if (1 < t1.length && r === n && ('"' === r || "'" === r)) return [
                            '"' + t1.substr(1, t1.length - 2).replace(/\\/g, "\\\\").replace(/"/g, '\\"') + '"'
                        ];
                        if (r = /\[(false|true|null|\d+|'[^']*'|"[^"]*")\]/.exec(t1)) return e1(t1.substr(0, r.index)).concat(e1(r[1])).concat(e1(t1.substr(r.index + r[0].length)));
                        if (1 === (r = t1.split(".")).length) return [
                            '"' + t1.replace(/\\/g, "\\\\").replace(/"/g, '\\"') + '"'
                        ];
                        for(t1 = [], n = 0; n < r.length; ++n)t1 = t1.concat(e1(r[n]));
                        return t1;
                    }
                    function r(t1) {
                        return "[" + e1(t1).join("][") + "]";
                    }
                    function n(t1) {
                        return "string" == typeof t1 ? t1.split() : t1;
                    }
                    function i(t1) {
                        return "string" == typeof t1 ? document.querySelector(t1) : t1;
                    }
                    function a(t1) {
                        var e1, r, a, o, s = t1 || {};
                        t1 = {};
                        var l = [], c = [], u = "undefined" == typeof window ? 1 : window.devicePixelRatio, h = !1, f = {}, p = function(t1) {}, d = function() {};
                        if ("string" == typeof s ? e1 = document.querySelector(s) : "object" == typeof s && ("string" == typeof s.nodeName && "function" == typeof s.appendChild && "function" == typeof s.getBoundingClientRect ? e1 = s : "function" == typeof s.drawArrays || "function" == typeof s.drawElements ? a = (o = s).canvas : ("gl" in s ? o = s.gl : "canvas" in s ? a = i(s.canvas) : "container" in s && (r = i(s.container)), "attributes" in s && (t1 = s.attributes), "extensions" in s && (l = n(s.extensions)), "optionalExtensions" in s && (c = n(s.optionalExtensions)), "onDone" in s && (p = s.onDone), "profile" in s && (h = !!s.profile), "pixelRatio" in s && (u = +s.pixelRatio), "cachedCode" in s && (f = s.cachedCode))), e1 && ("canvas" === e1.nodeName.toLowerCase() ? a = e1 : r = e1), !o) {
                            if (!a) {
                                if (!(e1 = function(t1, e1, r) {
                                    function n() {
                                        var e1 = window.innerWidth, n = window.innerHeight;
                                        t1 !== document.body && (e1 = (n = a.getBoundingClientRect()).right - n.left, n = n.bottom - n.top), a.width = r * e1, a.height = r * n;
                                    }
                                    var i, a = document.createElement("canvas");
                                    return G(a.style, {
                                        border: 0,
                                        margin: 0,
                                        padding: 0,
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%"
                                    }), t1.appendChild(a), t1 === document.body && (a.style.position = "absolute", G(t1.style, {
                                        margin: 0,
                                        padding: 0
                                    })), t1 !== document.body && "function" == typeof ResizeObserver ? (i = new ResizeObserver(function() {
                                        setTimeout(n);
                                    })).observe(t1) : window.addEventListener("resize", n, !1), n(), {
                                        canvas: a,
                                        onDestroy: function() {
                                            i ? i.disconnect() : window.removeEventListener("resize", n), t1.removeChild(a);
                                        }
                                    };
                                }(r || document.body, 0, u))) return null;
                                a = e1.canvas, d = e1.onDestroy;
                            }
                            void 0 === t1.premultipliedAlpha && (t1.premultipliedAlpha = !0), o = function(t1, e1) {
                                function r(r) {
                                    try {
                                        return t1.getContext(r, e1);
                                    } catch (t1) {
                                        return null;
                                    }
                                }
                                return r("webgl") || r("experimental-webgl") || r("webgl-experimental");
                            }(a, t1);
                        }
                        return o ? {
                            gl: o,
                            canvas: a,
                            container: r,
                            extensions: l,
                            optionalExtensions: c,
                            pixelRatio: u,
                            profile: h,
                            cachedCode: f,
                            onDone: p,
                            onDestroy: d
                        } : (d(), p("webgl not supported, try upgrading your browser or graphics drivers http://get.webgl.org"), null);
                    }
                    function o(t1, e1) {
                        for(var r = Array(t1), n = 0; n < t1; ++n)r[n] = e1(n);
                        return r;
                    }
                    function s(t1) {
                        var e1, r;
                        return e1 = (65535 < t1) << 4, e1 |= r = (255 < (t1 >>>= e1)) << 3, (e1 |= r = (15 < (t1 >>>= r)) << 2) | (r = (3 < (t1 >>>= r)) << 1) | t1 >>> r >> 1;
                    }
                    function l() {
                        function t1(t1) {
                            t: {
                                for(var e1 = 16; 268435456 >= e1; e1 *= 16)if (t1 <= e1) {
                                    t1 = e1;
                                    break t;
                                }
                                t1 = 0;
                            }
                            return 0 < (e1 = r[s(t1) >> 2]).length ? e1.pop() : new ArrayBuffer(t1);
                        }
                        function e1(t1) {
                            r[s(t1.byteLength) >> 2].push(t1);
                        }
                        var r = o(8, function() {
                            return [];
                        });
                        return {
                            alloc: t1,
                            free: e1,
                            allocType: function(e1, r) {
                                var n = null;
                                switch(e1){
                                    case 5120:
                                        n = new Int8Array(t1(r), 0, r);
                                        break;
                                    case 5121:
                                        n = new Uint8Array(t1(r), 0, r);
                                        break;
                                    case 5122:
                                        n = new Int16Array(t1(2 * r), 0, r);
                                        break;
                                    case 5123:
                                        n = new Uint16Array(t1(2 * r), 0, r);
                                        break;
                                    case 5124:
                                        n = new Int32Array(t1(4 * r), 0, r);
                                        break;
                                    case 5125:
                                        n = new Uint32Array(t1(4 * r), 0, r);
                                        break;
                                    case 5126:
                                        n = new Float32Array(t1(4 * r), 0, r);
                                        break;
                                    default:
                                        return null;
                                }
                                return n.length !== r ? n.subarray(0, r) : n;
                            },
                            freeType: function(t1) {
                                e1(t1.buffer);
                            }
                        };
                    }
                    function c(t1) {
                        return !!t1 && "object" == typeof t1 && Array.isArray(t1.shape) && Array.isArray(t1.stride) && "number" == typeof t1.offset && t1.shape.length === t1.stride.length && (Array.isArray(t1.data) || K(t1.data));
                    }
                    function u(t1, e1, r, n, i, a) {
                        for(var o = 0; o < e1; ++o)for(var s = t1[o], l = 0; l < r; ++l)for(var c = s[l], u = 0; u < n; ++u)i[a++] = c[u];
                    }
                    function h(t1, e1, r, n, i) {
                        for(var a = 1, o = r + 1; o < e1.length; ++o)a *= e1[o];
                        var s = e1[r];
                        if (4 == e1.length - r) {
                            var l = e1[r + 1], c = e1[r + 2];
                            for(e1 = e1[r + 3], o = 0; o < s; ++o)u(t1[o], l, c, e1, n, i), i += a;
                        } else for(o = 0; o < s; ++o)h(t1[o], e1, r + 1, n, i), i += a;
                    }
                    function f(t1) {
                        return 0 | et[Object.prototype.toString.call(t1)];
                    }
                    function p(t1, e1) {
                        for(var r = 0; r < e1.length; ++r)t1[r] = e1[r];
                    }
                    function d(t1, e1, r, n, i, a, o) {
                        for(var s = 0, l = 0; l < r; ++l)for(var c = 0; c < n; ++c)t1[s++] = e1[i * l + a * c + o];
                    }
                    function m(t1, e1, r, n) {
                        function i(e1) {
                            this.id = l++, this.buffer = t1.createBuffer(), this.type = e1, this.usage = 35044, this.byteLength = 0, this.dimension = 1, this.dtype = 5121, this.persistentData = null, r.profile && (this.stats = {
                                size: 0
                            });
                        }
                        function a(e1, r, n) {
                            e1.byteLength = r.byteLength, t1.bufferData(e1.type, r, n);
                        }
                        function o(t1, e1, r, n, i, o) {
                            if (t1.usage = r, Array.isArray(e1)) {
                                if (t1.dtype = n || 5126, 0 < e1.length) {
                                    if (Array.isArray(e1[0])) {
                                        i = at(e1);
                                        for(var s = n = 1; s < i.length; ++s)n *= i[s];
                                        t1.dimension = n, a(t1, e1 = it(e1, i, t1.dtype), r), o ? t1.persistentData = e1 : $.freeType(e1);
                                    } else "number" == typeof e1[0] ? (t1.dimension = i, p(i = $.allocType(t1.dtype, e1.length), e1), a(t1, i, r), o ? t1.persistentData = i : $.freeType(i)) : K(e1[0]) && (t1.dimension = e1[0].length, t1.dtype = n || f(e1[0]) || 5126, a(t1, e1 = it(e1, [
                                        e1.length,
                                        e1[0].length
                                    ], t1.dtype), r), o ? t1.persistentData = e1 : $.freeType(e1));
                                }
                            } else if (K(e1)) t1.dtype = n || f(e1), t1.dimension = i, a(t1, e1, r), o && (t1.persistentData = new Uint8Array(new Uint8Array(e1.buffer)));
                            else if (c(e1)) {
                                i = e1.shape;
                                var l = e1.stride, u = (s = e1.offset, 0), h = 0, m = 0, g = 0;
                                1 === i.length ? (u = i[0], h = 1, m = l[0], g = 0) : 2 === i.length && (u = i[0], h = i[1], m = l[0], g = l[1]), t1.dtype = n || f(e1.data) || 5126, t1.dimension = h, d(i = $.allocType(t1.dtype, u * h), e1.data, u, h, m, g, s), a(t1, i, r), o ? t1.persistentData = i : $.freeType(i);
                            } else e1 instanceof ArrayBuffer && (t1.dtype = 5121, t1.dimension = i, a(t1, e1, r), o && (t1.persistentData = new Uint8Array(new Uint8Array(e1))));
                        }
                        function s(r) {
                            e1.bufferCount--, n(r), t1.deleteBuffer(r.buffer), r.buffer = null, delete u[r.id];
                        }
                        var l = 0, u = {};
                        i.prototype.bind = function() {
                            t1.bindBuffer(this.type, this.buffer);
                        }, i.prototype.destroy = function() {
                            s(this);
                        };
                        var h = [];
                        return r.profile && (e1.getTotalBufferSize = function() {
                            var t1 = 0;
                            return Object.keys(u).forEach(function(e1) {
                                t1 += u[e1].stats.size;
                            }), t1;
                        }), {
                            create: function(n, a, l, h) {
                                function m(e1) {
                                    var n = 35044, i = null, a = 0, s = 0, l = 1;
                                    return Array.isArray(e1) || K(e1) || c(e1) || e1 instanceof ArrayBuffer ? i = e1 : "number" == typeof e1 ? a = 0 | e1 : e1 && ("data" in e1 && (i = e1.data), "usage" in e1 && (n = nt[e1.usage]), "type" in e1 && (s = rt[e1.type]), "dimension" in e1 && (l = 0 | e1.dimension), "length" in e1 && (a = 0 | e1.length)), g.bind(), i ? o(g, i, n, s, l, h) : (a && t1.bufferData(g.type, a, n), g.dtype = s || 5121, g.usage = n, g.dimension = l, g.byteLength = a), r.profile && (g.stats.size = g.byteLength * ot[g.dtype]), m;
                                }
                                e1.bufferCount++;
                                var g = new i(a);
                                return u[g.id] = g, l || m(n), m._reglType = "buffer", m._buffer = g, m.subdata = function(e1, r) {
                                    var n, i = 0 | (r || 0);
                                    if (g.bind(), K(e1) || e1 instanceof ArrayBuffer) t1.bufferSubData(g.type, i, e1);
                                    else if (Array.isArray(e1)) {
                                        if (0 < e1.length) {
                                            if ("number" == typeof e1[0]) {
                                                var a = $.allocType(g.dtype, e1.length);
                                                p(a, e1), t1.bufferSubData(g.type, i, a), $.freeType(a);
                                            } else (Array.isArray(e1[0]) || K(e1[0])) && (n = at(e1), a = it(e1, n, g.dtype), t1.bufferSubData(g.type, i, a), $.freeType(a));
                                        }
                                    } else if (c(e1)) {
                                        n = e1.shape;
                                        var o = e1.stride, s = a = 0, l = 0, u = 0;
                                        1 === n.length ? (a = n[0], s = 1, l = o[0], u = 0) : 2 === n.length && (a = n[0], s = n[1], l = o[0], u = o[1]), n = Array.isArray(e1.data) ? g.dtype : f(e1.data), d(n = $.allocType(n, a * s), e1.data, a, s, l, u, e1.offset), t1.bufferSubData(g.type, i, n), $.freeType(n);
                                    }
                                    return m;
                                }, r.profile && (m.stats = g.stats), m.destroy = function() {
                                    s(g);
                                }, m;
                            },
                            createStream: function(t1, e1) {
                                var r = h.pop();
                                return r || (r = new i(t1)), r.bind(), o(r, e1, 35040, 0, 1, !1), r;
                            },
                            destroyStream: function(t1) {
                                h.push(t1);
                            },
                            clear: function() {
                                Q(u).forEach(s), h.forEach(s);
                            },
                            getBuffer: function(t1) {
                                return t1 && t1._buffer instanceof i ? t1._buffer : null;
                            },
                            restore: function() {
                                Q(u).forEach(function(e1) {
                                    e1.buffer = t1.createBuffer(), t1.bindBuffer(e1.type, e1.buffer), t1.bufferData(e1.type, e1.persistentData || e1.byteLength, e1.usage);
                                });
                            },
                            _initBuffer: o
                        };
                    }
                    function g(t1, e1, r, n) {
                        function i(t1) {
                            this.id = l++, s[this.id] = this, this.buffer = t1, this.primType = 4, this.type = this.vertCount = 0;
                        }
                        function a(n, i, a, o, s, l, u) {
                            var h;
                            if (n.buffer.bind(), i ? ((h = u) || K(i) && (!c(i) || K(i.data)) || (h = e1.oes_element_index_uint ? 5125 : 5123), r._initBuffer(n.buffer, i, a, h, 3)) : (t1.bufferData(34963, l, a), n.buffer.dtype = h || 5121, n.buffer.usage = a, n.buffer.dimension = 3, n.buffer.byteLength = l), h = u, !u) {
                                switch(n.buffer.dtype){
                                    case 5121:
                                    case 5120:
                                        h = 5121;
                                        break;
                                    case 5123:
                                    case 5122:
                                        h = 5123;
                                        break;
                                    case 5125:
                                    case 5124:
                                        h = 5125;
                                }
                                n.buffer.dtype = h;
                            }
                            n.type = h, 0 > (i = s) && (i = n.buffer.byteLength, 5123 === h ? i >>= 1 : 5125 === h && (i >>= 2)), n.vertCount = i, i = o, 0 > o && (i = 4, 1 === (o = n.buffer.dimension) && (i = 0), 2 === o && (i = 1), 3 === o && (i = 4)), n.primType = i;
                        }
                        function o(t1) {
                            n.elementsCount--, delete s[t1.id], t1.buffer.destroy(), t1.buffer = null;
                        }
                        var s = {}, l = 0, u = {
                            uint8: 5121,
                            uint16: 5123
                        };
                        e1.oes_element_index_uint && (u.uint32 = 5125), i.prototype.bind = function() {
                            this.buffer.bind();
                        };
                        var h = [];
                        return {
                            create: function(t1, e1) {
                                function s(t1) {
                                    if (t1) {
                                        if ("number" == typeof t1) l(t1), h.primType = 4, h.vertCount = 0 | t1, h.type = 5121;
                                        else {
                                            var e1 = null, r = 35044, n = -1, i = -1, o = 0, f = 0;
                                            Array.isArray(t1) || K(t1) || c(t1) ? e1 = t1 : ("data" in t1 && (e1 = t1.data), "usage" in t1 && (r = nt[t1.usage]), "primitive" in t1 && (n = st[t1.primitive]), "count" in t1 && (i = 0 | t1.count), "type" in t1 && (f = u[t1.type]), "length" in t1 ? o = 0 | t1.length : (o = i, 5123 === f || 5122 === f ? o *= 2 : 5125 !== f && 5124 !== f || (o *= 4))), a(h, e1, r, n, i, o, f);
                                        }
                                    } else l(), h.primType = 4, h.vertCount = 0, h.type = 5121;
                                    return s;
                                }
                                var l = r.create(null, 34963, !0), h = new i(l._buffer);
                                return n.elementsCount++, s(t1), s._reglType = "elements", s._elements = h, s.subdata = function(t1, e1) {
                                    return l.subdata(t1, e1), s;
                                }, s.destroy = function() {
                                    o(h);
                                }, s;
                            },
                            createStream: function(t1) {
                                var e1 = h.pop();
                                return e1 || (e1 = new i(r.create(null, 34963, !0, !1)._buffer)), a(e1, t1, 35040, -1, -1, 0, 0), e1;
                            },
                            destroyStream: function(t1) {
                                h.push(t1);
                            },
                            getElements: function(t1) {
                                return "function" == typeof t1 && t1._elements instanceof i ? t1._elements : null;
                            },
                            clear: function() {
                                Q(s).forEach(o);
                            }
                        };
                    }
                    function y(t1) {
                        for(var e1 = $.allocType(5123, t1.length), r = 0; r < t1.length; ++r)if (isNaN(t1[r])) e1[r] = 65535;
                        else if (1 / 0 === t1[r]) e1[r] = 31744;
                        else if (-1 / 0 === t1[r]) e1[r] = 64512;
                        else {
                            lt[0] = t1[r];
                            var n = (a = ct[0]) >>> 31 << 15, i = (a << 1 >>> 24) - 127, a = a >> 13 & 1023;
                            e1[r] = -24 > i ? n : -14 > i ? n + (a + 1024 >> -14 - i) : 15 < i ? n + 31744 : n + (i + 15 << 10) + a;
                        }
                        return e1;
                    }
                    function v(t1) {
                        return Array.isArray(t1) || K(t1);
                    }
                    function x(t1) {
                        return "[object " + t1 + "]";
                    }
                    function _(t1) {
                        return Array.isArray(t1) && (0 === t1.length || "number" == typeof t1[0]);
                    }
                    function b(t1) {
                        return !(!Array.isArray(t1) || 0 === t1.length || !v(t1[0]));
                    }
                    function w(t1) {
                        return Object.prototype.toString.call(t1);
                    }
                    function T(t1) {
                        if (!t1) return !1;
                        var e1 = w(t1);
                        return 0 <= xt.indexOf(e1) || _(t1) || b(t1) || c(t1);
                    }
                    function k(t1, e1) {
                        36193 === t1.type ? (t1.data = y(e1), $.freeType(e1)) : t1.data = e1;
                    }
                    function A(t1, e1, r, n, i, a) {
                        if (t1 = void 0 !== bt[t1] ? bt[t1] : ft[t1] * _t[e1], a && (t1 *= 6), i) {
                            for(n = 0; 1 <= r;)n += t1 * r * r, r /= 2;
                            return n;
                        }
                        return t1 * r * n;
                    }
                    function M(t1, e1, r, n, i, a, o) {
                        function s() {
                            this.format = this.internalformat = 6408, this.type = 5121, this.flipY = this.premultiplyAlpha = this.compressed = !1, this.unpackAlignment = 1, this.colorSpace = 37444, this.channels = this.height = this.width = 0;
                        }
                        function l(t1, e1) {
                            t1.internalformat = e1.internalformat, t1.format = e1.format, t1.type = e1.type, t1.compressed = e1.compressed, t1.premultiplyAlpha = e1.premultiplyAlpha, t1.flipY = e1.flipY, t1.unpackAlignment = e1.unpackAlignment, t1.colorSpace = e1.colorSpace, t1.width = e1.width, t1.height = e1.height, t1.channels = e1.channels;
                        }
                        function u(t1, e1) {
                            if ("object" == typeof e1 && e1) {
                                "premultiplyAlpha" in e1 && (t1.premultiplyAlpha = e1.premultiplyAlpha), "flipY" in e1 && (t1.flipY = e1.flipY), "alignment" in e1 && (t1.unpackAlignment = e1.alignment), "colorSpace" in e1 && (t1.colorSpace = V[e1.colorSpace]), "type" in e1 && (t1.type = q[e1.type]);
                                var r = t1.width, n = t1.height, i = t1.channels, a = !1;
                                "shape" in e1 ? (r = e1.shape[0], n = e1.shape[1], 3 === e1.shape.length && (i = e1.shape[2], a = !0)) : ("radius" in e1 && (r = n = e1.radius), "width" in e1 && (r = e1.width), "height" in e1 && (n = e1.height), "channels" in e1 && (i = e1.channels, a = !0)), t1.width = 0 | r, t1.height = 0 | n, t1.channels = 0 | i, r = !1, "format" in e1 && (r = e1.format, n = t1.internalformat = H[r], t1.format = at[n], r in q && !("type" in e1) && (t1.type = q[r]), r in Z && (t1.compressed = !0), r = !0), !a && r ? t1.channels = ft[t1.format] : a && !r && t1.channels !== ht[t1.format] && (t1.format = t1.internalformat = ht[t1.channels]);
                            }
                        }
                        function h(e1) {
                            t1.pixelStorei(37440, e1.flipY), t1.pixelStorei(37441, e1.premultiplyAlpha), t1.pixelStorei(37443, e1.colorSpace), t1.pixelStorei(3317, e1.unpackAlignment);
                        }
                        function f() {
                            s.call(this), this.yOffset = this.xOffset = 0, this.data = null, this.needsFree = !1, this.element = null, this.needsCopy = !1;
                        }
                        function p(t1, e1) {
                            var r = null;
                            if (T(e1) ? r = e1 : e1 && (u(t1, e1), "x" in e1 && (t1.xOffset = 0 | e1.x), "y" in e1 && (t1.yOffset = 0 | e1.y), T(e1.data) && (r = e1.data)), e1.copy) {
                                var n = i.viewportWidth, a = i.viewportHeight;
                                t1.width = t1.width || n - t1.xOffset, t1.height = t1.height || a - t1.yOffset, t1.needsCopy = !0;
                            } else if (r) {
                                if (K(r)) t1.channels = t1.channels || 4, t1.data = r, "type" in e1 || 5121 !== t1.type || (t1.type = 0 | et[Object.prototype.toString.call(r)]);
                                else if (_(r)) {
                                    switch(t1.channels = t1.channels || 4, a = (n = r).length, t1.type){
                                        case 5121:
                                        case 5123:
                                        case 5125:
                                        case 5126:
                                            (a = $.allocType(t1.type, a)).set(n), t1.data = a;
                                            break;
                                        case 36193:
                                            t1.data = y(n);
                                    }
                                    t1.alignment = 1, t1.needsFree = !0;
                                } else if (c(r)) {
                                    n = r.data, Array.isArray(n) || 5121 !== t1.type || (t1.type = 0 | et[Object.prototype.toString.call(n)]), a = r.shape;
                                    var o, s, l, h, f = r.stride;
                                    3 === a.length ? (l = a[2], h = f[2]) : h = l = 1, o = a[0], s = a[1], a = f[0], f = f[1], t1.alignment = 1, t1.width = o, t1.height = s, t1.channels = l, t1.format = t1.internalformat = ht[l], t1.needsFree = !0, o = h, r = r.offset, l = t1.width, h = t1.height, s = t1.channels;
                                    for(var p = $.allocType(36193 === t1.type ? 5126 : t1.type, l * h * s), d = 0, m = 0; m < h; ++m)for(var g = 0; g < l; ++g)for(var x = 0; x < s; ++x)p[d++] = n[a * g + f * m + o * x + r];
                                    k(t1, p);
                                } else if (w(r) === pt || w(r) === dt || w(r) === mt) w(r) === pt || w(r) === dt ? t1.element = r : t1.element = r.canvas, t1.width = t1.element.width, t1.height = t1.element.height, t1.channels = 4;
                                else if (w(r) === gt) t1.element = r, t1.width = r.width, t1.height = r.height, t1.channels = 4;
                                else if (w(r) === yt) t1.element = r, t1.width = r.naturalWidth, t1.height = r.naturalHeight, t1.channels = 4;
                                else if (w(r) === vt) t1.element = r, t1.width = r.videoWidth, t1.height = r.videoHeight, t1.channels = 4;
                                else if (b(r)) {
                                    for(n = t1.width || r[0].length, a = t1.height || r.length, f = t1.channels, f = v(r[0][0]) ? f || r[0][0].length : f || 1, o = tt.shape(r), l = 1, h = 0; h < o.length; ++h)l *= o[h];
                                    l = $.allocType(36193 === t1.type ? 5126 : t1.type, l), tt.flatten(r, o, "", l), k(t1, l), t1.alignment = 1, t1.width = n, t1.height = a, t1.channels = f, t1.format = t1.internalformat = ht[f], t1.needsFree = !0;
                                }
                            } else t1.width = t1.width || 1, t1.height = t1.height || 1, t1.channels = t1.channels || 4;
                        }
                        function d(e1, r, i, a, o) {
                            var s = e1.element, l = e1.data, c = e1.internalformat, u = e1.format, f = e1.type, p = e1.width, d = e1.height;
                            h(e1), s ? t1.texSubImage2D(r, o, i, a, u, f, s) : e1.compressed ? t1.compressedTexSubImage2D(r, o, i, a, c, p, d, l) : e1.needsCopy ? (n(), t1.copyTexSubImage2D(r, o, i, a, e1.xOffset, e1.yOffset, p, d)) : t1.texSubImage2D(r, o, i, a, p, d, u, f, l);
                        }
                        function m() {
                            return ot.pop() || new f;
                        }
                        function g(t1) {
                            t1.needsFree && $.freeType(t1.data), f.call(t1), ot.push(t1);
                        }
                        function x() {
                            s.call(this), this.genMipmaps = !1, this.mipmapHint = 4352, this.mipmask = 0, this.images = Array(16);
                        }
                        function M(t1, e1, r) {
                            var n = t1.images[0] = m();
                            t1.mipmask = 1, n.width = t1.width = e1, n.height = t1.height = r, n.channels = t1.channels = 4;
                        }
                        function S(t1, e1) {
                            var r = null;
                            if (T(e1)) l(r = t1.images[0] = m(), t1), p(r, e1), t1.mipmask = 1;
                            else if (u(t1, e1), Array.isArray(e1.mipmap)) for(var n = e1.mipmap, i = 0; i < n.length; ++i)l(r = t1.images[i] = m(), t1), r.width >>= i, r.height >>= i, p(r, n[i]), t1.mipmask |= 1 << i;
                            else l(r = t1.images[0] = m(), t1), p(r, e1), t1.mipmask = 1;
                            l(t1, t1.images[0]);
                        }
                        function E(e1, r) {
                            for(var i = e1.images, a = 0; a < i.length && i[a]; ++a){
                                var o = i[a], s = r, l = a, c = o.element, u = o.data, f = o.internalformat, p = o.format, d = o.type, m = o.width, g = o.height;
                                h(o), c ? t1.texImage2D(s, l, p, p, d, c) : o.compressed ? t1.compressedTexImage2D(s, l, f, m, g, 0, u) : o.needsCopy ? (n(), t1.copyTexImage2D(s, l, p, o.xOffset, o.yOffset, m, g, 0)) : t1.texImage2D(s, l, p, m, g, 0, p, d, u || null);
                            }
                        }
                        function C() {
                            var t1 = st.pop() || new x;
                            s.call(t1);
                            for(var e1 = t1.mipmask = 0; 16 > e1; ++e1)t1.images[e1] = null;
                            return t1;
                        }
                        function L(t1) {
                            for(var e1 = t1.images, r = 0; r < e1.length; ++r)e1[r] && g(e1[r]), e1[r] = null;
                            st.push(t1);
                        }
                        function I() {
                            this.magFilter = this.minFilter = 9728, this.wrapT = this.wrapS = 33071, this.anisotropic = 1, this.genMipmaps = !1, this.mipmapHint = 4352;
                        }
                        function P(t1, e1) {
                            "min" in e1 && (t1.minFilter = U[e1.min], 0 <= ut.indexOf(t1.minFilter) && !("faces" in e1) && (t1.genMipmaps = !0)), "mag" in e1 && (t1.magFilter = j[e1.mag]);
                            var r = t1.wrapS, n = t1.wrapT;
                            if ("wrap" in e1) {
                                var i = e1.wrap;
                                "string" == typeof i ? r = n = N[i] : Array.isArray(i) && (r = N[i[0]], n = N[i[1]]);
                            } else "wrapS" in e1 && (r = N[e1.wrapS]), "wrapT" in e1 && (n = N[e1.wrapT]);
                            if (t1.wrapS = r, t1.wrapT = n, "anisotropic" in e1 && (t1.anisotropic = e1.anisotropic), "mipmap" in e1) {
                                switch(r = !1, typeof e1.mipmap){
                                    case "string":
                                        t1.mipmapHint = B[e1.mipmap], r = t1.genMipmaps = !0;
                                        break;
                                    case "boolean":
                                        r = t1.genMipmaps = e1.mipmap;
                                        break;
                                    case "object":
                                        t1.genMipmaps = !1, r = !0;
                                }
                                !r || "min" in e1 || (t1.minFilter = 9984);
                            }
                        }
                        function z(r, n) {
                            t1.texParameteri(n, 10241, r.minFilter), t1.texParameteri(n, 10240, r.magFilter), t1.texParameteri(n, 10242, r.wrapS), t1.texParameteri(n, 10243, r.wrapT), e1.ext_texture_filter_anisotropic && t1.texParameteri(n, 34046, r.anisotropic), r.genMipmaps && (t1.hint(33170, r.mipmapHint), t1.generateMipmap(n));
                        }
                        function O(e1) {
                            s.call(this), this.mipmask = 0, this.internalformat = 6408, this.id = lt++, this.refCount = 1, this.target = e1, this.texture = t1.createTexture(), this.unit = -1, this.bindCount = 0, this.texInfo = new I, o.profile && (this.stats = {
                                size: 0
                            });
                        }
                        function D(e1) {
                            t1.activeTexture(33984), t1.bindTexture(e1.target, e1.texture);
                        }
                        function R() {
                            var e1 = _t[0];
                            e1 ? t1.bindTexture(e1.target, e1.texture) : t1.bindTexture(3553, null);
                        }
                        function F(e1) {
                            var r = e1.texture, n = e1.unit, i = e1.target;
                            0 <= n && (t1.activeTexture(33984 + n), t1.bindTexture(i, null), _t[n] = null), t1.deleteTexture(r), e1.texture = null, e1.params = null, e1.pixels = null, e1.refCount = 0, delete ct[e1.id], a.textureCount--;
                        }
                        var B = {
                            "don't care": 4352,
                            "dont care": 4352,
                            nice: 4354,
                            fast: 4353
                        }, N = {
                            repeat: 10497,
                            clamp: 33071,
                            mirror: 33648
                        }, j = {
                            nearest: 9728,
                            linear: 9729
                        }, U = G({
                            mipmap: 9987,
                            "nearest mipmap nearest": 9984,
                            "linear mipmap nearest": 9985,
                            "nearest mipmap linear": 9986,
                            "linear mipmap linear": 9987
                        }, j), V = {
                            none: 0,
                            browser: 37444
                        }, q = {
                            uint8: 5121,
                            rgba4: 32819,
                            rgb565: 33635,
                            "rgb5 a1": 32820
                        }, H = {
                            alpha: 6406,
                            luminance: 6409,
                            "luminance alpha": 6410,
                            rgb: 6407,
                            rgba: 6408,
                            rgba4: 32854,
                            "rgb5 a1": 32855,
                            rgb565: 36194
                        }, Z = {};
                        e1.ext_srgb && (H.srgb = 35904, H.srgba = 35906), e1.oes_texture_float && (q.float32 = q.float = 5126), e1.oes_texture_half_float && (q.float16 = q["half float"] = 36193), e1.webgl_depth_texture && (G(H, {
                            depth: 6402,
                            "depth stencil": 34041
                        }), G(q, {
                            uint16: 5123,
                            uint32: 5125,
                            "depth stencil": 34042
                        })), e1.webgl_compressed_texture_s3tc && G(Z, {
                            "rgb s3tc dxt1": 33776,
                            "rgba s3tc dxt1": 33777,
                            "rgba s3tc dxt3": 33778,
                            "rgba s3tc dxt5": 33779
                        }), e1.webgl_compressed_texture_atc && G(Z, {
                            "rgb atc": 35986,
                            "rgba atc explicit alpha": 35987,
                            "rgba atc interpolated alpha": 34798
                        }), e1.webgl_compressed_texture_pvrtc && G(Z, {
                            "rgb pvrtc 4bppv1": 35840,
                            "rgb pvrtc 2bppv1": 35841,
                            "rgba pvrtc 4bppv1": 35842,
                            "rgba pvrtc 2bppv1": 35843
                        }), e1.webgl_compressed_texture_etc1 && (Z["rgb etc1"] = 36196);
                        var W = Array.prototype.slice.call(t1.getParameter(34467));
                        Object.keys(Z).forEach(function(t1) {
                            var e1 = Z[t1];
                            0 <= W.indexOf(e1) && (H[t1] = e1);
                        });
                        var Y = Object.keys(H);
                        r.textureFormats = Y;
                        var X = [];
                        Object.keys(H).forEach(function(t1) {
                            X[H[t1]] = t1;
                        });
                        var J = [];
                        Object.keys(q).forEach(function(t1) {
                            J[q[t1]] = t1;
                        });
                        var rt = [];
                        Object.keys(j).forEach(function(t1) {
                            rt[j[t1]] = t1;
                        });
                        var nt = [];
                        Object.keys(U).forEach(function(t1) {
                            nt[U[t1]] = t1;
                        });
                        var it = [];
                        Object.keys(N).forEach(function(t1) {
                            it[N[t1]] = t1;
                        });
                        var at = Y.reduce(function(t1, r) {
                            var n = H[r];
                            return 6409 === n || 6406 === n || 6409 === n || 6410 === n || 6402 === n || 34041 === n || e1.ext_srgb && (35904 === n || 35906 === n) ? t1[n] = n : 32855 === n || 0 <= r.indexOf("rgba") ? t1[n] = 6408 : t1[n] = 6407, t1;
                        }, {}), ot = [], st = [], lt = 0, ct = {}, xt = r.maxTextureUnits, _t = Array(xt).map(function() {
                            return null;
                        });
                        return G(O.prototype, {
                            bind: function() {
                                this.bindCount += 1;
                                var e1 = this.unit;
                                if (0 > e1) {
                                    for(var r = 0; r < xt; ++r){
                                        var n = _t[r];
                                        if (n) {
                                            if (0 < n.bindCount) continue;
                                            n.unit = -1;
                                        }
                                        _t[r] = this, e1 = r;
                                        break;
                                    }
                                    o.profile && a.maxTextureUnits < e1 + 1 && (a.maxTextureUnits = e1 + 1), this.unit = e1, t1.activeTexture(33984 + e1), t1.bindTexture(this.target, this.texture);
                                }
                                return e1;
                            },
                            unbind: function() {
                                --this.bindCount;
                            },
                            decRef: function() {
                                0 >= --this.refCount && F(this);
                            }
                        }), o.profile && (a.getTotalTextureSize = function() {
                            var t1 = 0;
                            return Object.keys(ct).forEach(function(e1) {
                                t1 += ct[e1].stats.size;
                            }), t1;
                        }), {
                            create2D: function(e1, r) {
                                function n(t1, e1) {
                                    var r = i.texInfo;
                                    I.call(r);
                                    var a = C();
                                    return "number" == typeof t1 ? M(a, 0 | t1, "number" == typeof e1 ? 0 | e1 : 0 | t1) : t1 ? (P(r, t1), S(a, t1)) : M(a, 1, 1), r.genMipmaps && (a.mipmask = (a.width << 1) - 1), i.mipmask = a.mipmask, l(i, a), i.internalformat = a.internalformat, n.width = a.width, n.height = a.height, D(i), E(a, 3553), z(r, 3553), R(), L(a), o.profile && (i.stats.size = A(i.internalformat, i.type, a.width, a.height, r.genMipmaps, !1)), n.format = X[i.internalformat], n.type = J[i.type], n.mag = rt[r.magFilter], n.min = nt[r.minFilter], n.wrapS = it[r.wrapS], n.wrapT = it[r.wrapT], n;
                                }
                                var i = new O(3553);
                                return ct[i.id] = i, a.textureCount++, n(e1, r), n.subimage = function(t1, e1, r, a) {
                                    e1 |= 0, r |= 0, a |= 0;
                                    var o = m();
                                    return l(o, i), o.width = 0, o.height = 0, p(o, t1), o.width = o.width || (i.width >> a) - e1, o.height = o.height || (i.height >> a) - r, D(i), d(o, 3553, e1, r, a), R(), g(o), n;
                                }, n.resize = function(e1, r) {
                                    var a = 0 | e1, s = 0 | r || a;
                                    if (a === i.width && s === i.height) return n;
                                    n.width = i.width = a, n.height = i.height = s, D(i);
                                    for(var l = 0; i.mipmask >> l; ++l){
                                        var c = a >> l, u = s >> l;
                                        if (!c || !u) break;
                                        t1.texImage2D(3553, l, i.format, c, u, 0, i.format, i.type, null);
                                    }
                                    return R(), o.profile && (i.stats.size = A(i.internalformat, i.type, a, s, !1, !1)), n;
                                }, n._reglType = "texture2d", n._texture = i, o.profile && (n.stats = i.stats), n.destroy = function() {
                                    i.decRef();
                                }, n;
                            },
                            createCube: function(e1, r, n, i, s, c) {
                                function h(t1, e1, r, n, i, a) {
                                    var s, c = f.texInfo;
                                    for(I.call(c), s = 0; 6 > s; ++s)y[s] = C();
                                    if ("number" != typeof t1 && t1) {
                                        if ("object" == typeof t1) {
                                            if (e1) S(y[0], t1), S(y[1], e1), S(y[2], r), S(y[3], n), S(y[4], i), S(y[5], a);
                                            else if (P(c, t1), u(f, t1), "faces" in t1) for(t1 = t1.faces, s = 0; 6 > s; ++s)l(y[s], f), S(y[s], t1[s]);
                                            else for(s = 0; 6 > s; ++s)S(y[s], t1);
                                        }
                                    } else for(t1 = 0 | t1 || 1, s = 0; 6 > s; ++s)M(y[s], t1, t1);
                                    for(l(f, y[0]), f.mipmask = c.genMipmaps ? (y[0].width << 1) - 1 : y[0].mipmask, f.internalformat = y[0].internalformat, h.width = y[0].width, h.height = y[0].height, D(f), s = 0; 6 > s; ++s)E(y[s], 34069 + s);
                                    for(z(c, 34067), R(), o.profile && (f.stats.size = A(f.internalformat, f.type, h.width, h.height, c.genMipmaps, !0)), h.format = X[f.internalformat], h.type = J[f.type], h.mag = rt[c.magFilter], h.min = nt[c.minFilter], h.wrapS = it[c.wrapS], h.wrapT = it[c.wrapT], s = 0; 6 > s; ++s)L(y[s]);
                                    return h;
                                }
                                var f = new O(34067);
                                ct[f.id] = f, a.cubeCount++;
                                var y = Array(6);
                                return h(e1, r, n, i, s, c), h.subimage = function(t1, e1, r, n, i) {
                                    r |= 0, n |= 0, i |= 0;
                                    var a = m();
                                    return l(a, f), a.width = 0, a.height = 0, p(a, e1), a.width = a.width || (f.width >> i) - r, a.height = a.height || (f.height >> i) - n, D(f), d(a, 34069 + t1, r, n, i), R(), g(a), h;
                                }, h.resize = function(e1) {
                                    if ((e1 |= 0) !== f.width) {
                                        h.width = f.width = e1, h.height = f.height = e1, D(f);
                                        for(var r = 0; 6 > r; ++r)for(var n = 0; f.mipmask >> n; ++n)t1.texImage2D(34069 + r, n, f.format, e1 >> n, e1 >> n, 0, f.format, f.type, null);
                                        return R(), o.profile && (f.stats.size = A(f.internalformat, f.type, h.width, h.height, !1, !0)), h;
                                    }
                                }, h._reglType = "textureCube", h._texture = f, o.profile && (h.stats = f.stats), h.destroy = function() {
                                    f.decRef();
                                }, h;
                            },
                            clear: function() {
                                for(var e1 = 0; e1 < xt; ++e1)t1.activeTexture(33984 + e1), t1.bindTexture(3553, null), _t[e1] = null;
                                Q(ct).forEach(F), a.cubeCount = 0, a.textureCount = 0;
                            },
                            getTexture: function(t1) {
                                return null;
                            },
                            restore: function() {
                                for(var e1 = 0; e1 < xt; ++e1){
                                    var r = _t[e1];
                                    r && (r.bindCount = 0, r.unit = -1, _t[e1] = null);
                                }
                                Q(ct).forEach(function(e1) {
                                    e1.texture = t1.createTexture(), t1.bindTexture(e1.target, e1.texture);
                                    for(var r = 0; 32 > r; ++r)if (0 != (e1.mipmask & 1 << r)) {
                                        if (3553 === e1.target) t1.texImage2D(3553, r, e1.internalformat, e1.width >> r, e1.height >> r, 0, e1.internalformat, e1.type, null);
                                        else for(var n = 0; 6 > n; ++n)t1.texImage2D(34069 + n, r, e1.internalformat, e1.width >> r, e1.height >> r, 0, e1.internalformat, e1.type, null);
                                    }
                                    z(e1.texInfo, e1.target);
                                });
                            },
                            refresh: function() {
                                for(var e1 = 0; e1 < xt; ++e1){
                                    var r = _t[e1];
                                    r && (r.bindCount = 0, r.unit = -1, _t[e1] = null), t1.activeTexture(33984 + e1), t1.bindTexture(3553, null), t1.bindTexture(34067, null);
                                }
                            }
                        };
                    }
                    function S(t1, e1, r, n, i, a) {
                        function o(t1, e1, r) {
                            this.target = t1, this.texture = e1, this.renderbuffer = r;
                            var n = t1 = 0;
                            e1 ? (t1 = e1.width, n = e1.height) : r && (t1 = r.width, n = r.height), this.width = t1, this.height = n;
                        }
                        function s(t1) {
                            t1 && (t1.texture && t1.texture._texture.decRef(), t1.renderbuffer && t1.renderbuffer._renderbuffer.decRef());
                        }
                        function l(t1, e1, r) {
                            t1 && (t1.texture ? t1.texture._texture.refCount += 1 : t1.renderbuffer._renderbuffer.refCount += 1);
                        }
                        function c(e1, r) {
                            r && (r.texture ? t1.framebufferTexture2D(36160, e1, r.target, r.texture._texture.texture, 0) : t1.framebufferRenderbuffer(36160, e1, 36161, r.renderbuffer._renderbuffer.renderbuffer));
                        }
                        function u(t1) {
                            var e1 = 3553, r = null, n = null, i = t1;
                            return "object" == typeof t1 && (i = t1.data, "target" in t1 && (e1 = 0 | t1.target)), "texture2d" === (t1 = i._reglType) || "textureCube" === t1 ? r = i : "renderbuffer" === t1 && (n = i, e1 = 36161), new o(e1, r, n);
                        }
                        function h(t1, e1, r, a, s) {
                            return r ? ((t1 = n.create2D({
                                width: t1,
                                height: e1,
                                format: a,
                                type: s
                            }))._texture.refCount = 0, new o(3553, t1, null)) : ((t1 = i.create({
                                width: t1,
                                height: e1,
                                format: a
                            }))._renderbuffer.refCount = 0, new o(36161, null, t1));
                        }
                        function f(t1) {
                            return t1 && (t1.texture || t1.renderbuffer);
                        }
                        function p(t1, e1, r) {
                            t1 && (t1.texture ? t1.texture.resize(e1, r) : t1.renderbuffer && t1.renderbuffer.resize(e1, r), t1.width = e1, t1.height = r);
                        }
                        function d() {
                            this.id = T++, k[this.id] = this, this.framebuffer = t1.createFramebuffer(), this.height = this.width = 0, this.colorAttachments = [], this.depthStencilAttachment = this.stencilAttachment = this.depthAttachment = null;
                        }
                        function m(t1) {
                            t1.colorAttachments.forEach(s), s(t1.depthAttachment), s(t1.stencilAttachment), s(t1.depthStencilAttachment);
                        }
                        function g(e1) {
                            t1.deleteFramebuffer(e1.framebuffer), e1.framebuffer = null, a.framebufferCount--, delete k[e1.id];
                        }
                        function y(e1) {
                            var n;
                            t1.bindFramebuffer(36160, e1.framebuffer);
                            var i = e1.colorAttachments;
                            for(n = 0; n < i.length; ++n)c(36064 + n, i[n]);
                            for(n = i.length; n < r.maxColorAttachments; ++n)t1.framebufferTexture2D(36160, 36064 + n, 3553, null, 0);
                            t1.framebufferTexture2D(36160, 33306, 3553, null, 0), t1.framebufferTexture2D(36160, 36096, 3553, null, 0), t1.framebufferTexture2D(36160, 36128, 3553, null, 0), c(36096, e1.depthAttachment), c(36128, e1.stencilAttachment), c(33306, e1.depthStencilAttachment), t1.checkFramebufferStatus(36160), t1.isContextLost(), t1.bindFramebuffer(36160, x.next ? x.next.framebuffer : null), x.cur = x.next, t1.getError();
                        }
                        function v(t1, e1) {
                            function r(t1, e1) {
                                var i, a = 0, o = 0, s = !0, c = !0;
                                i = null;
                                var p = !0, d = "rgba", g = "uint8", v = 1, x = null, w = null, T = null, k = !1;
                                "number" == typeof t1 ? (a = 0 | t1, o = 0 | e1 || a) : t1 ? ("shape" in t1 ? (a = (o = t1.shape)[0], o = o[1]) : ("radius" in t1 && (a = o = t1.radius), "width" in t1 && (a = t1.width), "height" in t1 && (o = t1.height)), ("color" in t1 || "colors" in t1) && (i = t1.color || t1.colors, Array.isArray(i)), i || ("colorCount" in t1 && (v = 0 | t1.colorCount), "colorTexture" in t1 && (p = !!t1.colorTexture, d = "rgba4"), "colorType" in t1 && (g = t1.colorType, !p) && ("half float" === g || "float16" === g ? d = "rgba16f" : "float" !== g && "float32" !== g || (d = "rgba32f")), "colorFormat" in t1 && (d = t1.colorFormat, 0 <= _.indexOf(d) ? p = !0 : 0 <= b.indexOf(d) && (p = !1))), ("depthTexture" in t1 || "depthStencilTexture" in t1) && (k = !(!t1.depthTexture && !t1.depthStencilTexture)), "depth" in t1 && ("boolean" == typeof t1.depth ? s = t1.depth : (x = t1.depth, c = !1)), "stencil" in t1 && ("boolean" == typeof t1.stencil ? c = t1.stencil : (w = t1.stencil, s = !1)), "depthStencil" in t1 && ("boolean" == typeof t1.depthStencil ? s = c = t1.depthStencil : (T = t1.depthStencil, c = s = !1))) : a = o = 1;
                                var A = null, M = null, S = null, E = null;
                                if (Array.isArray(i)) A = i.map(u);
                                else if (i) A = [
                                    u(i)
                                ];
                                else for(A = Array(v), i = 0; i < v; ++i)A[i] = h(a, o, p, d, g);
                                for(a = a || A[0].width, o = o || A[0].height, x ? M = u(x) : s && !c && (M = h(a, o, k, "depth", "uint32")), w ? S = u(w) : c && !s && (S = h(a, o, !1, "stencil", "uint8")), T ? E = u(T) : !x && !w && c && s && (E = h(a, o, k, "depth stencil", "depth stencil")), s = null, i = 0; i < A.length; ++i)l(A[i]), A[i] && A[i].texture && (c = kt[A[i].texture._texture.format] * At[A[i].texture._texture.type], null === s && (s = c));
                                return l(M), l(S), l(E), m(n), n.width = a, n.height = o, n.colorAttachments = A, n.depthAttachment = M, n.stencilAttachment = S, n.depthStencilAttachment = E, r.color = A.map(f), r.depth = f(M), r.stencil = f(S), r.depthStencil = f(E), r.width = n.width, r.height = n.height, y(n), r;
                            }
                            var n = new d;
                            return a.framebufferCount++, r(t1, e1), G(r, {
                                resize: function(t1, e1) {
                                    var i = Math.max(0 | t1, 1), a = Math.max(0 | e1 || i, 1);
                                    if (i === n.width && a === n.height) return r;
                                    for(var o = n.colorAttachments, s = 0; s < o.length; ++s)p(o[s], i, a);
                                    return p(n.depthAttachment, i, a), p(n.stencilAttachment, i, a), p(n.depthStencilAttachment, i, a), n.width = r.width = i, n.height = r.height = a, y(n), r;
                                },
                                _reglType: "framebuffer",
                                _framebuffer: n,
                                destroy: function() {
                                    g(n), m(n);
                                },
                                use: function(t1) {
                                    x.setFBO({
                                        framebuffer: r
                                    }, t1);
                                }
                            });
                        }
                        var x = {
                            cur: null,
                            next: null,
                            dirty: !1,
                            setFBO: null
                        }, _ = [
                            "rgba"
                        ], b = [
                            "rgba4",
                            "rgb565",
                            "rgb5 a1"
                        ];
                        e1.ext_srgb && b.push("srgba"), e1.ext_color_buffer_half_float && b.push("rgba16f", "rgb16f"), e1.webgl_color_buffer_float && b.push("rgba32f");
                        var w = [
                            "uint8"
                        ];
                        e1.oes_texture_half_float && w.push("half float", "float16"), e1.oes_texture_float && w.push("float", "float32");
                        var T = 0, k = {};
                        return G(x, {
                            getFramebuffer: function(t1) {
                                return "function" == typeof t1 && "framebuffer" === t1._reglType && (t1 = t1._framebuffer) instanceof d ? t1 : null;
                            },
                            create: v,
                            createCube: function(t1) {
                                function e1(t1) {
                                    var i, a = {
                                        color: null
                                    }, o = 0, s = null;
                                    i = "rgba";
                                    var l = "uint8", c = 1;
                                    if ("number" == typeof t1 ? o = 0 | t1 : t1 ? ("shape" in t1 ? o = t1.shape[0] : ("radius" in t1 && (o = 0 | t1.radius), "width" in t1 ? o = 0 | t1.width : "height" in t1 && (o = 0 | t1.height)), ("color" in t1 || "colors" in t1) && (s = t1.color || t1.colors, Array.isArray(s)), s || ("colorCount" in t1 && (c = 0 | t1.colorCount), "colorType" in t1 && (l = t1.colorType), "colorFormat" in t1 && (i = t1.colorFormat)), "depth" in t1 && (a.depth = t1.depth), "stencil" in t1 && (a.stencil = t1.stencil), "depthStencil" in t1 && (a.depthStencil = t1.depthStencil)) : o = 1, s) {
                                        if (Array.isArray(s)) for(t1 = [], i = 0; i < s.length; ++i)t1[i] = s[i];
                                        else t1 = [
                                            s
                                        ];
                                    } else for(t1 = Array(c), s = {
                                        radius: o,
                                        format: i,
                                        type: l
                                    }, i = 0; i < c; ++i)t1[i] = n.createCube(s);
                                    for(a.color = Array(t1.length), i = 0; i < t1.length; ++i)c = t1[i], o = o || c.width, a.color[i] = {
                                        target: 34069,
                                        data: t1[i]
                                    };
                                    for(i = 0; 6 > i; ++i){
                                        for(c = 0; c < t1.length; ++c)a.color[c].target = 34069 + i;
                                        0 < i && (a.depth = r[0].depth, a.stencil = r[0].stencil, a.depthStencil = r[0].depthStencil), r[i] ? r[i](a) : r[i] = v(a);
                                    }
                                    return G(e1, {
                                        width: o,
                                        height: o,
                                        color: t1
                                    });
                                }
                                var r = Array(6);
                                return e1(t1), G(e1, {
                                    faces: r,
                                    resize: function(t1) {
                                        var n = 0 | t1;
                                        if (n === e1.width) return e1;
                                        var i = e1.color;
                                        for(t1 = 0; t1 < i.length; ++t1)i[t1].resize(n);
                                        for(t1 = 0; 6 > t1; ++t1)r[t1].resize(n);
                                        return e1.width = e1.height = n, e1;
                                    },
                                    _reglType: "framebufferCube",
                                    destroy: function() {
                                        r.forEach(function(t1) {
                                            t1.destroy();
                                        });
                                    }
                                });
                            },
                            clear: function() {
                                Q(k).forEach(g);
                            },
                            restore: function() {
                                x.cur = null, x.next = null, x.dirty = !0, Q(k).forEach(function(e1) {
                                    e1.framebuffer = t1.createFramebuffer(), y(e1);
                                });
                            }
                        });
                    }
                    function E() {
                        this.w = this.z = this.y = this.x = this.state = 0, this.buffer = null, this.size = 0, this.normalized = !1, this.type = 5126, this.divisor = this.stride = this.offset = 0;
                    }
                    function C(t1, e1, r, n, i, a, o) {
                        function s() {
                            this.id = ++h, this.attributes = [], this.elements = null, this.ownsElements = !1, this.offset = this.count = 0, this.instances = -1, this.primitive = 4;
                            var t1 = e1.oes_vertex_array_object;
                            this.vao = t1 ? t1.createVertexArrayOES() : null, f[this.id] = this, this.buffers = [];
                        }
                        var l = r.maxAttributes, u = Array(l);
                        for(r = 0; r < l; ++r)u[r] = new E;
                        var h = 0, f = {}, p = {
                            Record: E,
                            scope: {},
                            state: u,
                            currentVAO: null,
                            targetVAO: null,
                            restore: e1.oes_vertex_array_object ? function() {
                                e1.oes_vertex_array_object && Q(f).forEach(function(t1) {
                                    t1.refresh();
                                });
                            } : function() {},
                            createVAO: function(t1) {
                                function e1(t1) {
                                    var n;
                                    Array.isArray(t1) ? (n = t1, r.elements && r.ownsElements && r.elements.destroy(), r.elements = null, r.ownsElements = !1, r.offset = 0, r.count = 0, r.instances = -1, r.primitive = 4) : (t1.elements ? (n = t1.elements, r.ownsElements ? ("function" == typeof n && "elements" === n._reglType ? r.elements.destroy() : r.elements(n), r.ownsElements = !1) : a.getElements(t1.elements) ? (r.elements = t1.elements, r.ownsElements = !1) : (r.elements = a.create(t1.elements), r.ownsElements = !0)) : (r.elements = null, r.ownsElements = !1), n = t1.attributes, r.offset = 0, r.count = -1, r.instances = -1, r.primitive = 4, r.elements && (r.count = r.elements._elements.vertCount, r.primitive = r.elements._elements.primType), "offset" in t1 && (r.offset = 0 | t1.offset), "count" in t1 && (r.count = 0 | t1.count), "instances" in t1 && (r.instances = 0 | t1.instances), "primitive" in t1 && (r.primitive = st[t1.primitive])), t1 = {};
                                    var o = r.attributes;
                                    o.length = n.length;
                                    for(var s = 0; s < n.length; ++s){
                                        var l, u = n[s], h = o[s] = new E, f = u.data || u;
                                        Array.isArray(f) || K(f) || c(f) ? (r.buffers[s] && (l = r.buffers[s], K(f) && l._buffer.byteLength >= f.byteLength ? l.subdata(f) : (l.destroy(), r.buffers[s] = null)), r.buffers[s] || (l = r.buffers[s] = i.create(u, 34962, !1, !0)), h.buffer = i.getBuffer(l), h.size = 0 | h.buffer.dimension, h.normalized = !1, h.type = h.buffer.dtype, h.offset = 0, h.stride = 0, h.divisor = 0, h.state = 1, t1[s] = 1) : i.getBuffer(u) ? (h.buffer = i.getBuffer(u), h.size = 0 | h.buffer.dimension, h.normalized = !1, h.type = h.buffer.dtype, h.offset = 0, h.stride = 0, h.divisor = 0, h.state = 1) : i.getBuffer(u.buffer) ? (h.buffer = i.getBuffer(u.buffer), h.size = 0 | (+u.size || h.buffer.dimension), h.normalized = !!u.normalized || !1, h.type = "type" in u ? rt[u.type] : h.buffer.dtype, h.offset = 0 | (u.offset || 0), h.stride = 0 | (u.stride || 0), h.divisor = 0 | (u.divisor || 0), h.state = 1) : "x" in u && (h.x = +u.x || 0, h.y = +u.y || 0, h.z = +u.z || 0, h.w = +u.w || 0, h.state = 2);
                                    }
                                    for(l = 0; l < r.buffers.length; ++l)!t1[l] && r.buffers[l] && (r.buffers[l].destroy(), r.buffers[l] = null);
                                    return r.refresh(), e1;
                                }
                                var r = new s;
                                return n.vaoCount += 1, e1.destroy = function() {
                                    for(var t1 = 0; t1 < r.buffers.length; ++t1)r.buffers[t1] && r.buffers[t1].destroy();
                                    r.buffers.length = 0, r.ownsElements && (r.elements.destroy(), r.elements = null, r.ownsElements = !1), r.destroy();
                                }, e1._vao = r, e1._reglType = "vao", e1(t1);
                            },
                            getVAO: function(t1) {
                                return "function" == typeof t1 && t1._vao ? t1._vao : null;
                            },
                            destroyBuffer: function(e1) {
                                for(var r = 0; r < u.length; ++r){
                                    var n = u[r];
                                    n.buffer === e1 && (t1.disableVertexAttribArray(r), n.buffer = null);
                                }
                            },
                            setVAO: e1.oes_vertex_array_object ? function(t1) {
                                if (t1 !== p.currentVAO) {
                                    var r = e1.oes_vertex_array_object;
                                    t1 ? r.bindVertexArrayOES(t1.vao) : r.bindVertexArrayOES(null), p.currentVAO = t1;
                                }
                            } : function(r) {
                                if (r !== p.currentVAO) {
                                    if (r) r.bindAttrs();
                                    else {
                                        for(var n = e1.angle_instanced_arrays, i = 0; i < u.length; ++i){
                                            var a = u[i];
                                            a.buffer ? (t1.enableVertexAttribArray(i), a.buffer.bind(), t1.vertexAttribPointer(i, a.size, a.type, a.normalized, a.stride, a.offfset), n && a.divisor && n.vertexAttribDivisorANGLE(i, a.divisor)) : (t1.disableVertexAttribArray(i), t1.vertexAttrib4f(i, a.x, a.y, a.z, a.w));
                                        }
                                        o.elements ? t1.bindBuffer(34963, o.elements.buffer.buffer) : t1.bindBuffer(34963, null);
                                    }
                                    p.currentVAO = r;
                                }
                            },
                            clear: e1.oes_vertex_array_object ? function() {
                                Q(f).forEach(function(t1) {
                                    t1.destroy();
                                });
                            } : function() {}
                        };
                        return s.prototype.bindAttrs = function() {
                            for(var r = e1.angle_instanced_arrays, n = this.attributes, i = 0; i < n.length; ++i){
                                var o = n[i];
                                o.buffer ? (t1.enableVertexAttribArray(i), t1.bindBuffer(34962, o.buffer.buffer), t1.vertexAttribPointer(i, o.size, o.type, o.normalized, o.stride, o.offset), r && o.divisor && r.vertexAttribDivisorANGLE(i, o.divisor)) : (t1.disableVertexAttribArray(i), t1.vertexAttrib4f(i, o.x, o.y, o.z, o.w));
                            }
                            for(r = n.length; r < l; ++r)t1.disableVertexAttribArray(r);
                            (r = a.getElements(this.elements)) ? t1.bindBuffer(34963, r.buffer.buffer) : t1.bindBuffer(34963, null);
                        }, s.prototype.refresh = function() {
                            var t1 = e1.oes_vertex_array_object;
                            t1 && (t1.bindVertexArrayOES(this.vao), this.bindAttrs(), p.currentVAO = null, t1.bindVertexArrayOES(null));
                        }, s.prototype.destroy = function() {
                            if (this.vao) {
                                var t1 = e1.oes_vertex_array_object;
                                this === p.currentVAO && (p.currentVAO = null, t1.bindVertexArrayOES(null)), t1.deleteVertexArrayOES(this.vao), this.vao = null;
                            }
                            this.ownsElements && (this.elements.destroy(), this.elements = null, this.ownsElements = !1), f[this.id] && (delete f[this.id], --n.vaoCount);
                        }, p;
                    }
                    function L(t1, e1, r, n) {
                        function i(t1, e1, r, n) {
                            this.name = t1, this.id = e1, this.location = r, this.info = n;
                        }
                        function a(t1, e1) {
                            for(var r = 0; r < t1.length; ++r)if (t1[r].id === e1.id) return void (t1[r].location = e1.location);
                            t1.push(e1);
                        }
                        function o(r, n, i) {
                            if (!(o = (i = 35632 === r ? c : u)[n])) {
                                var a = e1.str(n), o = t1.createShader(r);
                                t1.shaderSource(o, a), t1.compileShader(o), i[n] = o;
                            }
                            return o;
                        }
                        function s(t1, e1) {
                            this.id = p++, this.fragId = t1, this.vertId = e1, this.program = null, this.uniforms = [], this.attributes = [], this.refCount = 1, n.profile && (this.stats = {
                                uniformsCount: 0,
                                attributesCount: 0
                            });
                        }
                        function l(r, s, l) {
                            var c;
                            c = o(35632, r.fragId);
                            var u = o(35633, r.vertId);
                            if (s = r.program = t1.createProgram(), t1.attachShader(s, c), t1.attachShader(s, u), l) for(c = 0; c < l.length; ++c)u = l[c], t1.bindAttribLocation(s, u[0], u[1]);
                            t1.linkProgram(s), u = t1.getProgramParameter(s, 35718), n.profile && (r.stats.uniformsCount = u);
                            var h = r.uniforms;
                            for(c = 0; c < u; ++c)if (l = t1.getActiveUniform(s, c)) {
                                if (1 < l.size) for(var f = 0; f < l.size; ++f){
                                    var p = l.name.replace("[0]", "[" + f + "]");
                                    a(h, new i(p, e1.id(p), t1.getUniformLocation(s, p), l));
                                }
                                else a(h, new i(l.name, e1.id(l.name), t1.getUniformLocation(s, l.name), l));
                            }
                            for(u = t1.getProgramParameter(s, 35721), n.profile && (r.stats.attributesCount = u), r = r.attributes, c = 0; c < u; ++c)(l = t1.getActiveAttrib(s, c)) && a(r, new i(l.name, e1.id(l.name), t1.getAttribLocation(s, l.name), l));
                        }
                        var c = {}, u = {}, h = {}, f = [], p = 0;
                        return n.profile && (r.getMaxUniformsCount = function() {
                            var t1 = 0;
                            return f.forEach(function(e1) {
                                e1.stats.uniformsCount > t1 && (t1 = e1.stats.uniformsCount);
                            }), t1;
                        }, r.getMaxAttributesCount = function() {
                            var t1 = 0;
                            return f.forEach(function(e1) {
                                e1.stats.attributesCount > t1 && (t1 = e1.stats.attributesCount);
                            }), t1;
                        }), {
                            clear: function() {
                                var e1 = t1.deleteShader.bind(t1);
                                Q(c).forEach(e1), c = {}, Q(u).forEach(e1), u = {}, f.forEach(function(e1) {
                                    t1.deleteProgram(e1.program);
                                }), f.length = 0, h = {}, r.shaderCount = 0;
                            },
                            program: function(e1, n, i, a) {
                                var o = h[n];
                                o || (o = h[n] = {});
                                var p = o[e1];
                                if (p && (p.refCount++, !a)) return p;
                                var d = new s(n, e1);
                                return r.shaderCount++, l(d, i, a), p || (o[e1] = d), f.push(d), G(d, {
                                    destroy: function() {
                                        if (d.refCount--, 0 >= d.refCount) {
                                            t1.deleteProgram(d.program);
                                            var e1 = f.indexOf(d);
                                            f.splice(e1, 1), r.shaderCount--;
                                        }
                                        0 >= o[d.vertId].refCount && (t1.deleteShader(u[d.vertId]), delete u[d.vertId], delete h[d.fragId][d.vertId]), Object.keys(h[d.fragId]).length || (t1.deleteShader(c[d.fragId]), delete c[d.fragId], delete h[d.fragId]);
                                    }
                                });
                            },
                            restore: function() {
                                c = {}, u = {};
                                for(var t1 = 0; t1 < f.length; ++t1)l(f[t1], null, f[t1].attributes.map(function(t1) {
                                    return [
                                        t1.location,
                                        t1.name
                                    ];
                                }));
                            },
                            shader: o,
                            frag: -1,
                            vert: -1
                        };
                    }
                    function I(t1, e1, r, n, i, a, o) {
                        function s(i) {
                            var a;
                            a = null === e1.next ? 5121 : e1.next.colorAttachments[0].texture._texture.type;
                            var o = 0, s = 0, l = n.framebufferWidth, c = n.framebufferHeight, u = null;
                            return K(i) ? u = i : i && (o = 0 | i.x, s = 0 | i.y, l = 0 | (i.width || n.framebufferWidth - o), c = 0 | (i.height || n.framebufferHeight - s), u = i.data || null), r(), i = l * c * 4, u || (5121 === a ? u = new Uint8Array(i) : 5126 === a && (u = u || new Float32Array(i))), t1.pixelStorei(3333, 4), t1.readPixels(o, s, l, c, 6408, a, u), u;
                        }
                        return function(t1) {
                            return t1 && "framebuffer" in t1 ? function(t1) {
                                var r;
                                return e1.setFBO({
                                    framebuffer: t1.framebuffer
                                }, function() {
                                    r = s(t1);
                                }), r;
                            }(t1) : s(t1);
                        };
                    }
                    function P(t1, e1) {
                        return t1 >>> e1 | t1 << 32 - e1;
                    }
                    function z(t1, e1) {
                        var r = (65535 & t1) + (65535 & e1);
                        return (t1 >> 16) + (e1 >> 16) + (r >> 16) << 16 | 65535 & r;
                    }
                    function O(t1) {
                        return Array.prototype.slice.call(t1);
                    }
                    function D(t1) {
                        return O(t1).join("");
                    }
                    function R(t1) {
                        function e1() {
                            var t1 = [], e1 = [];
                            return G(function() {
                                t1.push.apply(t1, O(arguments));
                            }, {
                                def: function() {
                                    var r = "v" + i++;
                                    return e1.push(r), 0 < arguments.length && (t1.push(r, "="), t1.push.apply(t1, O(arguments)), t1.push(";")), r;
                                },
                                toString: function() {
                                    return D([
                                        0 < e1.length ? "var " + e1.join(",") + ";" : "",
                                        D(t1)
                                    ]);
                                }
                            });
                        }
                        function r() {
                            function t1(t1, e1) {
                                n(t1, e1, "=", r.def(t1, e1), ";");
                            }
                            var r = e1(), n = e1(), i = r.toString, a = n.toString;
                            return G(function() {
                                r.apply(r, O(arguments));
                            }, {
                                def: r.def,
                                entry: r,
                                exit: n,
                                save: t1,
                                set: function(e1, n, i) {
                                    t1(e1, n), r(e1, n, "=", i, ";");
                                },
                                toString: function() {
                                    return i() + a();
                                }
                            });
                        }
                        var n = t1 && t1.cache, i = 0, a = [], o = [], s = [], l = e1(), c = {};
                        return {
                            global: l,
                            link: function(t1, e1) {
                                var r = e1 && e1.stable;
                                if (!r) {
                                    for(var n = 0; n < o.length; ++n)if (o[n] === t1 && !s[n]) return a[n];
                                }
                                return n = "g" + i++, a.push(n), o.push(t1), s.push(r), n;
                            },
                            block: e1,
                            proc: function(t1, e1) {
                                function n() {
                                    var t1 = "a" + i.length;
                                    return i.push(t1), t1;
                                }
                                var i = [];
                                e1 = e1 || 0;
                                for(var a = 0; a < e1; ++a)n();
                                var o = (a = r()).toString;
                                return c[t1] = G(a, {
                                    arg: n,
                                    toString: function() {
                                        return D([
                                            "function(",
                                            i.join(),
                                            "){",
                                            o(),
                                            "}"
                                        ]);
                                    }
                                });
                            },
                            scope: r,
                            cond: function() {
                                var t1 = D(arguments), e1 = r(), n = r(), i = e1.toString, a = n.toString;
                                return G(e1, {
                                    then: function() {
                                        return e1.apply(e1, O(arguments)), this;
                                    },
                                    else: function() {
                                        return n.apply(n, O(arguments)), this;
                                    },
                                    toString: function() {
                                        var e1 = a();
                                        return e1 && (e1 = "else{" + e1 + "}"), D([
                                            "if(",
                                            t1,
                                            "){",
                                            i(),
                                            "}",
                                            e1
                                        ]);
                                    }
                                });
                            },
                            compile: function() {
                                var t1 = [
                                    '"use strict";',
                                    l,
                                    "return {"
                                ];
                                Object.keys(c).forEach(function(e1) {
                                    t1.push('"', e1, '":', c[e1].toString(), ",");
                                }), t1.push("}");
                                var e1, r = D(t1).replace(/;/g, ";\n").replace(/}/g, "}\n").replace(/{/g, "{\n");
                                return n && (e1 = function(t1) {
                                    for(var e1, r = "", n = 0; n < t1.length; n++)e1 = t1.charCodeAt(n), r += "0123456789abcdef".charAt(e1 >>> 4 & 15) + "0123456789abcdef".charAt(15 & e1);
                                    return r;
                                }(function(t1) {
                                    for(var e1 = Array(t1.length >> 2), r = 0; r < e1.length; r++)e1[r] = 0;
                                    for(r = 0; r < 8 * t1.length; r += 8)e1[r >> 5] |= (255 & t1.charCodeAt(r / 8)) << 24 - r % 32;
                                    var n, i, a, o, s, l, c, u, h, f, p, d = 8 * t1.length;
                                    for(t1 = [
                                        1779033703,
                                        -1150833019,
                                        1013904242,
                                        -1521486534,
                                        1359893119,
                                        -1694144372,
                                        528734635,
                                        1541459225
                                    ], r = Array(64), e1[d >> 5] |= 128 << 24 - d % 32, e1[15 + (d + 64 >> 9 << 4)] = d, u = 0; u < e1.length; u += 16){
                                        for(d = t1[0], n = t1[1], i = t1[2], a = t1[3], o = t1[4], s = t1[5], l = t1[6], c = t1[7], h = 0; 64 > h; h++){
                                            var m;
                                            16 > h ? r[h] = e1[h + u] : (f = h, p = z(p = P(p = r[h - 2], 17) ^ P(p, 19) ^ p >>> 10, r[h - 7]), m = P(m = r[h - 15], 7) ^ P(m, 18) ^ m >>> 3, r[f] = z(z(p, m), r[h - 16])), f = z(z(z(z(c, f = P(f = o, 6) ^ P(f, 11) ^ P(f, 25)), o & s ^ ~o & l), Mt[h]), r[h]), p = z(c = P(c = d, 2) ^ P(c, 13) ^ P(c, 22), d & n ^ d & i ^ n & i), c = l, l = s, s = o, o = z(a, f), a = i, i = n, n = d, d = z(f, p);
                                        }
                                        t1[0] = z(d, t1[0]), t1[1] = z(n, t1[1]), t1[2] = z(i, t1[2]), t1[3] = z(a, t1[3]), t1[4] = z(o, t1[4]), t1[5] = z(s, t1[5]), t1[6] = z(l, t1[6]), t1[7] = z(c, t1[7]);
                                    }
                                    for(e1 = "", r = 0; r < 32 * t1.length; r += 8)e1 += String.fromCharCode(t1[r >> 5] >>> 24 - r % 32 & 255);
                                    return e1;
                                }(function(t1) {
                                    for(var e1, r, n = "", i = -1; ++i < t1.length;)e1 = t1.charCodeAt(i), r = i + 1 < t1.length ? t1.charCodeAt(i + 1) : 0, 55296 <= e1 && 56319 >= e1 && 56320 <= r && 57343 >= r && (e1 = 65536 + ((1023 & e1) << 10) + (1023 & r), i++), 127 >= e1 ? n += String.fromCharCode(e1) : 2047 >= e1 ? n += String.fromCharCode(192 | e1 >>> 6 & 31, 128 | 63 & e1) : 65535 >= e1 ? n += String.fromCharCode(224 | e1 >>> 12 & 15, 128 | e1 >>> 6 & 63, 128 | 63 & e1) : 2097151 >= e1 && (n += String.fromCharCode(240 | e1 >>> 18 & 7, 128 | e1 >>> 12 & 63, 128 | e1 >>> 6 & 63, 128 | 63 & e1));
                                    return n;
                                }(r))), n[e1]) ? n[e1].apply(null, o) : (r = Function.apply(null, a.concat(r)), n && (n[e1] = r), r.apply(null, o));
                            }
                        };
                    }
                    function F(t1) {
                        return Array.isArray(t1) || K(t1) || c(t1);
                    }
                    function B(t1) {
                        return t1.sort(function(t1, e1) {
                            return "viewport" === t1 ? -1 : "viewport" === e1 ? 1 : t1 < e1 ? -1 : 1;
                        });
                    }
                    function N(t1, e1, r, n) {
                        this.thisDep = t1, this.contextDep = e1, this.propDep = r, this.append = n;
                    }
                    function j(t1) {
                        return t1 && !(t1.thisDep || t1.contextDep || t1.propDep);
                    }
                    function U(t1) {
                        return new N(!1, !1, !1, t1);
                    }
                    function V(t1, e1) {
                        var r = t1.type;
                        if (0 === r) return new N(!0, 1 <= (r = t1.data.length), 2 <= r, e1);
                        if (4 === r) return new N((r = t1.data).thisDep, r.contextDep, r.propDep, e1);
                        if (5 === r) return new N(!1, !1, !1, e1);
                        if (6 === r) {
                            for(var n = r = !1, i = !1, a = 0; a < t1.data.length; ++a){
                                var o = t1.data[a];
                                1 === o.type ? i = !0 : 2 === o.type ? n = !0 : 3 === o.type ? r = !0 : 0 === o.type ? (r = !0, 1 <= (o = o.data) && (n = !0), 2 <= o && (i = !0)) : 4 === o.type && (r = r || o.data.thisDep, n = n || o.data.contextDep, i = i || o.data.propDep);
                            }
                            return new N(r, n, i, e1);
                        }
                        return new N(3 === r, 2 === r, 1 === r, e1);
                    }
                    function q(t1, e1, r, n, i, a, s, l, c, u, h, f, p, d, m, g) {
                        function y(t1) {
                            return t1.replace(".", "_");
                        }
                        function x(t1, e1, r) {
                            var n = y(t1);
                            at.push(t1), it[n] = nt[n] = !!r, ot[n] = e1;
                        }
                        function _(t1, e1, r) {
                            var n = y(t1);
                            at.push(t1), Array.isArray(r) ? (nt[n] = r.slice(), it[n] = r.slice()) : nt[n] = it[n] = r, lt[n] = e1;
                        }
                        function b() {
                            var t1 = R({
                                cache: m
                            }), r = t1.link, n = t1.global;
                            t1.id = ht++, t1.batchId = "0";
                            var i = r(ct), a = t1.shared = {
                                props: "a0"
                            };
                            Object.keys(ct).forEach(function(t1) {
                                a[t1] = n.def(i, ".", t1);
                            });
                            var o = t1.next = {}, s = t1.current = {};
                            Object.keys(lt).forEach(function(t1) {
                                Array.isArray(nt[t1]) && (o[t1] = n.def(a.next, ".", t1), s[t1] = n.def(a.current, ".", t1));
                            });
                            var l = t1.constants = {};
                            Object.keys(ut).forEach(function(t1) {
                                l[t1] = n.def(JSON.stringify(ut[t1]));
                            }), t1.invoke = function(e1, n) {
                                switch(n.type){
                                    case 0:
                                        var i = [
                                            "this",
                                            a.context,
                                            a.props,
                                            t1.batchId
                                        ];
                                        return e1.def(r(n.data), ".call(", i.slice(0, Math.max(n.data.length + 1, 4)), ")");
                                    case 1:
                                        return e1.def(a.props, n.data);
                                    case 2:
                                        return e1.def(a.context, n.data);
                                    case 3:
                                        return e1.def("this", n.data);
                                    case 4:
                                        return n.data.append(t1, e1), n.data.ref;
                                    case 5:
                                        return n.data.toString();
                                    case 6:
                                        return n.data.map(function(r) {
                                            return t1.invoke(e1, r);
                                        });
                                }
                            }, t1.attribCache = {};
                            var c = {};
                            return t1.scopeAttrib = function(t1) {
                                if ((t1 = e1.id(t1)) in c) return c[t1];
                                var n = u.scope[t1];
                                return n || (n = u.scope[t1] = new J), c[t1] = r(n);
                            }, t1;
                        }
                        function w(t1, e1) {
                            var r = t1.static, n = t1.dynamic;
                            if ("framebuffer" in r) {
                                var i = r.framebuffer;
                                return i ? (i = l.getFramebuffer(i), U(function(t1, e1) {
                                    var r = t1.link(i), n = t1.shared;
                                    return e1.set(n.framebuffer, ".next", r), n = n.context, e1.set(n, ".framebufferWidth", r + ".width"), e1.set(n, ".framebufferHeight", r + ".height"), r;
                                })) : U(function(t1, e1) {
                                    var r = t1.shared;
                                    return e1.set(r.framebuffer, ".next", "null"), r = r.context, e1.set(r, ".framebufferWidth", r + ".drawingBufferWidth"), e1.set(r, ".framebufferHeight", r + ".drawingBufferHeight"), "null";
                                });
                            }
                            if ("framebuffer" in n) {
                                var a = n.framebuffer;
                                return V(a, function(t1, e1) {
                                    var r = t1.invoke(e1, a), n = t1.shared, i = n.framebuffer;
                                    return r = e1.def(i, ".getFramebuffer(", r, ")"), e1.set(i, ".next", r), n = n.context, e1.set(n, ".framebufferWidth", r + "?" + r + ".width:" + n + ".drawingBufferWidth"), e1.set(n, ".framebufferHeight", r + "?" + r + ".height:" + n + ".drawingBufferHeight"), r;
                                });
                            }
                            return null;
                        }
                        function T(t1, r, n) {
                            function i(t1) {
                                if (t1 in a) {
                                    var r = e1.id(a[t1]);
                                    return (t1 = U(function() {
                                        return r;
                                    })).id = r, t1;
                                }
                                if (t1 in o) {
                                    var n = o[t1];
                                    return V(n, function(t1, e1) {
                                        var r = t1.invoke(e1, n);
                                        return e1.def(t1.shared.strings, ".id(", r, ")");
                                    });
                                }
                                return null;
                            }
                            var a = t1.static, o = t1.dynamic, s = i("frag"), l = i("vert"), c = null;
                            return j(s) && j(l) ? (c = h.program(l.id, s.id, null, n), t1 = U(function(t1, e1) {
                                return t1.link(c);
                            })) : t1 = new N(s && s.thisDep || l && l.thisDep, s && s.contextDep || l && l.contextDep, s && s.propDep || l && l.propDep, function(t1, e1) {
                                var r, n, i = t1.shared.shader;
                                return r = s ? s.append(t1, e1) : e1.def(i, ".", "frag"), n = l ? l.append(t1, e1) : e1.def(i, ".", "vert"), e1.def(i + ".program(" + n + "," + r + ")");
                            }), {
                                frag: s,
                                vert: l,
                                progVar: t1,
                                program: c
                            };
                        }
                        function k(t1, e1) {
                            function r(t1, e1) {
                                if (t1 in n) {
                                    var r = 0 | n[t1];
                                    return e1 ? o.offset = r : o.instances = r, U(function(t1, n) {
                                        return e1 && (t1.OFFSET = r), r;
                                    });
                                }
                                if (t1 in i) {
                                    var a = i[t1];
                                    return V(a, function(t1, r) {
                                        var n = t1.invoke(r, a);
                                        return e1 && (t1.OFFSET = n), n;
                                    });
                                }
                                if (e1) {
                                    if (c) return U(function(t1, e1) {
                                        return t1.OFFSET = 0;
                                    });
                                    if (s) return new N(l.thisDep, l.contextDep, l.propDep, function(t1, e1) {
                                        return e1.def(t1.shared.vao + ".currentVAO?" + t1.shared.vao + ".currentVAO.offset:0");
                                    });
                                } else if (s) return new N(l.thisDep, l.contextDep, l.propDep, function(t1, e1) {
                                    return e1.def(t1.shared.vao + ".currentVAO?" + t1.shared.vao + ".currentVAO.instances:-1");
                                });
                                return null;
                            }
                            var n = t1.static, i = t1.dynamic, o = {}, s = !1, l = function() {
                                if ("vao" in n) {
                                    var t1 = n.vao;
                                    return null !== t1 && null === u.getVAO(t1) && (t1 = u.createVAO(t1)), s = !0, o.vao = t1, U(function(e1) {
                                        var r = u.getVAO(t1);
                                        return r ? e1.link(r) : "null";
                                    });
                                }
                                if ("vao" in i) {
                                    s = !0;
                                    var e1 = i.vao;
                                    return V(e1, function(t1, r) {
                                        var n = t1.invoke(r, e1);
                                        return r.def(t1.shared.vao + ".getVAO(" + n + ")");
                                    });
                                }
                                return null;
                            }(), c = !1, h = function() {
                                if ("elements" in n) {
                                    var t1 = n.elements;
                                    if (o.elements = t1, F(t1)) {
                                        var e1 = o.elements = a.create(t1, !0);
                                        t1 = a.getElements(e1), c = !0;
                                    } else t1 && (t1 = a.getElements(t1), c = !0);
                                    return e1 = U(function(e1, r) {
                                        if (t1) {
                                            var n = e1.link(t1);
                                            return e1.ELEMENTS = n;
                                        }
                                        return e1.ELEMENTS = null;
                                    }), e1.value = t1, e1;
                                }
                                if ("elements" in i) {
                                    c = !0;
                                    var r = i.elements;
                                    return V(r, function(t1, e1) {
                                        var n = (i = t1.shared).isBufferArgs, i = i.elements, a = t1.invoke(e1, r), o = e1.def("null");
                                        return n = e1.def(n, "(", a, ")"), a = t1.cond(n).then(o, "=", i, ".createStream(", a, ");").else(o, "=", i, ".getElements(", a, ");"), e1.entry(a), e1.exit(t1.cond(n).then(i, ".destroyStream(", o, ");")), t1.ELEMENTS = o;
                                    });
                                }
                                return s ? new N(l.thisDep, l.contextDep, l.propDep, function(t1, e1) {
                                    return e1.def(t1.shared.vao + ".currentVAO?" + t1.shared.elements + ".getElements(" + t1.shared.vao + ".currentVAO.elements):null");
                                }) : null;
                            }(), f = r("offset", !0), p = function() {
                                if ("primitive" in n) {
                                    var t1 = n.primitive;
                                    return o.primitive = t1, U(function(e1, r) {
                                        return st[t1];
                                    });
                                }
                                if ("primitive" in i) {
                                    var e1 = i.primitive;
                                    return V(e1, function(t1, r) {
                                        var n = t1.constants.primTypes, i = t1.invoke(r, e1);
                                        return r.def(n, "[", i, "]");
                                    });
                                }
                                return c ? j(h) ? h.value ? U(function(t1, e1) {
                                    return e1.def(t1.ELEMENTS, ".primType");
                                }) : U(function() {
                                    return 4;
                                }) : new N(h.thisDep, h.contextDep, h.propDep, function(t1, e1) {
                                    var r = t1.ELEMENTS;
                                    return e1.def(r, "?", r, ".primType:", 4);
                                }) : s ? new N(l.thisDep, l.contextDep, l.propDep, function(t1, e1) {
                                    return e1.def(t1.shared.vao + ".currentVAO?" + t1.shared.vao + ".currentVAO.primitive:4");
                                }) : null;
                            }(), d = function() {
                                if ("count" in n) {
                                    var t1 = 0 | n.count;
                                    return o.count = t1, U(function() {
                                        return t1;
                                    });
                                }
                                if ("count" in i) {
                                    var e1 = i.count;
                                    return V(e1, function(t1, r) {
                                        return t1.invoke(r, e1);
                                    });
                                }
                                return c ? j(h) ? h ? f ? new N(f.thisDep, f.contextDep, f.propDep, function(t1, e1) {
                                    return e1.def(t1.ELEMENTS, ".vertCount-", t1.OFFSET);
                                }) : U(function(t1, e1) {
                                    return e1.def(t1.ELEMENTS, ".vertCount");
                                }) : U(function() {
                                    return -1;
                                }) : new N(h.thisDep || f.thisDep, h.contextDep || f.contextDep, h.propDep || f.propDep, function(t1, e1) {
                                    var r = t1.ELEMENTS;
                                    return t1.OFFSET ? e1.def(r, "?", r, ".vertCount-", t1.OFFSET, ":-1") : e1.def(r, "?", r, ".vertCount:-1");
                                }) : s ? new N(l.thisDep, l.contextDep, l.propDep, function(t1, e1) {
                                    return e1.def(t1.shared.vao, ".currentVAO?", t1.shared.vao, ".currentVAO.count:-1");
                                }) : null;
                            }(), m = r("instances", !1);
                            return {
                                elements: h,
                                primitive: p,
                                count: d,
                                instances: m,
                                offset: f,
                                vao: l,
                                vaoActive: s,
                                elementsActive: c,
                                static: o
                            };
                        }
                        function A(t1, r) {
                            var n = t1.static, a = t1.dynamic, o = {};
                            return Object.keys(n).forEach(function(t1) {
                                var r = n[t1], a = e1.id(t1), s = new J;
                                if (F(r)) s.state = 1, s.buffer = i.getBuffer(i.create(r, 34962, !1, !0)), s.type = 0;
                                else if (c = i.getBuffer(r)) s.state = 1, s.buffer = c, s.type = 0;
                                else if ("constant" in r) {
                                    var l = r.constant;
                                    s.buffer = "null", s.state = 2, "number" == typeof l ? s.x = l : St.forEach(function(t1, e1) {
                                        e1 < l.length && (s[t1] = l[e1]);
                                    });
                                } else {
                                    var c = F(r.buffer) ? i.getBuffer(i.create(r.buffer, 34962, !1, !0)) : i.getBuffer(r.buffer), u = 0 | r.offset, h = 0 | r.stride, f = 0 | r.size, p = !!r.normalized, d = 0;
                                    "type" in r && (d = rt[r.type]), r = 0 | r.divisor, s.buffer = c, s.state = 1, s.size = f, s.normalized = p, s.type = d || c.dtype, s.offset = u, s.stride = h, s.divisor = r;
                                }
                                o[t1] = U(function(t1, e1) {
                                    var r = t1.attribCache;
                                    if (a in r) return r[a];
                                    var n = {
                                        isStream: !1
                                    };
                                    return Object.keys(s).forEach(function(t1) {
                                        n[t1] = s[t1];
                                    }), s.buffer && (n.buffer = t1.link(s.buffer), n.type = n.type || n.buffer + ".dtype"), r[a] = n;
                                });
                            }), Object.keys(a).forEach(function(t1) {
                                var e1 = a[t1];
                                o[t1] = V(e1, function(t1, r) {
                                    function n(t1) {
                                        r(l[t1], "=", i, ".", t1, "|0;");
                                    }
                                    var i = t1.invoke(r, e1), a = t1.shared, o = t1.constants, s = a.isBufferArgs, l = (a = a.buffer, {
                                        isStream: r.def(!1)
                                    }), c = new J;
                                    c.state = 1, Object.keys(c).forEach(function(t1) {
                                        l[t1] = r.def("" + c[t1]);
                                    });
                                    var u = l.buffer, h = l.type;
                                    return r("if(", s, "(", i, ")){", l.isStream, "=true;", u, "=", a, ".createStream(", 34962, ",", i, ");", h, "=", u, ".dtype;", "}else{", u, "=", a, ".getBuffer(", i, ");", "if(", u, "){", h, "=", u, ".dtype;", '}else if("constant" in ', i, "){", l.state, "=", 2, ";", "if(typeof " + i + '.constant === "number"){', l[St[0]], "=", i, ".constant;", St.slice(1).map(function(t1) {
                                        return l[t1];
                                    }).join("="), "=0;", "}else{", St.map(function(t1, e1) {
                                        return l[t1] + "=" + i + ".constant.length>" + e1 + "?" + i + ".constant[" + e1 + "]:0;";
                                    }).join(""), "}}else{", "if(", s, "(", i, ".buffer)){", u, "=", a, ".createStream(", 34962, ",", i, ".buffer);", "}else{", u, "=", a, ".getBuffer(", i, ".buffer);", "}", h, '="type" in ', i, "?", o.glTypes, "[", i, ".type]:", u, ".dtype;", l.normalized, "=!!", i, ".normalized;"), n("size"), n("offset"), n("stride"), n("divisor"), r("}}"), r.exit("if(", l.isStream, "){", a, ".destroyStream(", u, ");", "}"), l;
                                });
                            }), o;
                        }
                        function M(t1, e1, n, i, a) {
                            function s(t1) {
                                var e1 = c[t1];
                                e1 && (f[t1] = e1);
                            }
                            var l = function(t1, e1) {
                                if ("string" == typeof (r = t1.static).frag && "string" == typeof r.vert) {
                                    if (0 < Object.keys(e1.dynamic).length) return null;
                                    var r = e1.static, n = Object.keys(r);
                                    if (0 < n.length && "number" == typeof r[n[0]]) {
                                        for(var i = [], a = 0; a < n.length; ++a)i.push([
                                            0 | r[n[a]],
                                            n[a]
                                        ]);
                                        return i;
                                    }
                                }
                                return null;
                            }(t1, e1), c = function(t1, e1, r) {
                                function n(t1) {
                                    if (t1 in i) {
                                        var r = i[t1];
                                        t1 = !0;
                                        var n, o, s = 0 | r.x, l = 0 | r.y;
                                        return "width" in r ? n = 0 | r.width : t1 = !1, "height" in r ? o = 0 | r.height : t1 = !1, new N(!t1 && e1 && e1.thisDep, !t1 && e1 && e1.contextDep, !t1 && e1 && e1.propDep, function(t1, e1) {
                                            var i = t1.shared.context, a = n;
                                            "width" in r || (a = e1.def(i, ".", "framebufferWidth", "-", s));
                                            var c = o;
                                            return "height" in r || (c = e1.def(i, ".", "framebufferHeight", "-", l)), [
                                                s,
                                                l,
                                                a,
                                                c
                                            ];
                                        });
                                    }
                                    if (t1 in a) {
                                        var c = a[t1];
                                        return t1 = V(c, function(t1, e1) {
                                            var r = t1.invoke(e1, c), n = t1.shared.context, i = e1.def(r, ".x|0"), a = e1.def(r, ".y|0");
                                            return [
                                                i,
                                                a,
                                                e1.def('"width" in ', r, "?", r, ".width|0:", "(", n, ".", "framebufferWidth", "-", i, ")"),
                                                r = e1.def('"height" in ', r, "?", r, ".height|0:", "(", n, ".", "framebufferHeight", "-", a, ")")
                                            ];
                                        }), e1 && (t1.thisDep = t1.thisDep || e1.thisDep, t1.contextDep = t1.contextDep || e1.contextDep, t1.propDep = t1.propDep || e1.propDep), t1;
                                    }
                                    return e1 ? new N(e1.thisDep, e1.contextDep, e1.propDep, function(t1, e1) {
                                        var r = t1.shared.context;
                                        return [
                                            0,
                                            0,
                                            e1.def(r, ".", "framebufferWidth"),
                                            e1.def(r, ".", "framebufferHeight")
                                        ];
                                    }) : null;
                                }
                                var i = t1.static, a = t1.dynamic;
                                if (t1 = n("viewport")) {
                                    var o = t1;
                                    t1 = new N(t1.thisDep, t1.contextDep, t1.propDep, function(t1, e1) {
                                        var r = o.append(t1, e1), n = t1.shared.context;
                                        return e1.set(n, ".viewportWidth", r[2]), e1.set(n, ".viewportHeight", r[3]), r;
                                    });
                                }
                                return {
                                    viewport: t1,
                                    scissor_box: n("scissor.box")
                                };
                            }(t1, d = w(t1)), h = k(t1), f = function(t1, e1) {
                                var r = t1.static, n = t1.dynamic, i = {};
                                return at.forEach(function(t1) {
                                    function e1(e1, o) {
                                        if (t1 in r) {
                                            var s = e1(r[t1]);
                                            i[a] = U(function() {
                                                return s;
                                            });
                                        } else if (t1 in n) {
                                            var l = n[t1];
                                            i[a] = V(l, function(t1, e1) {
                                                return o(t1, e1, t1.invoke(e1, l));
                                            });
                                        }
                                    }
                                    var a = y(t1);
                                    switch(t1){
                                        case "cull.enable":
                                        case "blend.enable":
                                        case "dither":
                                        case "stencil.enable":
                                        case "depth.enable":
                                        case "scissor.enable":
                                        case "polygonOffset.enable":
                                        case "sample.alpha":
                                        case "sample.enable":
                                        case "depth.mask":
                                        case "lineWidth":
                                            return e1(function(t1) {
                                                return t1;
                                            }, function(t1, e1, r) {
                                                return r;
                                            });
                                        case "depth.func":
                                            return e1(function(t1) {
                                                return Lt[t1];
                                            }, function(t1, e1, r) {
                                                return e1.def(t1.constants.compareFuncs, "[", r, "]");
                                            });
                                        case "depth.range":
                                            return e1(function(t1) {
                                                return t1;
                                            }, function(t1, e1, r) {
                                                return [
                                                    e1.def("+", r, "[0]"),
                                                    e1 = e1.def("+", r, "[1]")
                                                ];
                                            });
                                        case "blend.func":
                                            return e1(function(t1) {
                                                return [
                                                    Ct["srcRGB" in t1 ? t1.srcRGB : t1.src],
                                                    Ct["dstRGB" in t1 ? t1.dstRGB : t1.dst],
                                                    Ct["srcAlpha" in t1 ? t1.srcAlpha : t1.src],
                                                    Ct["dstAlpha" in t1 ? t1.dstAlpha : t1.dst]
                                                ];
                                            }, function(t1, e1, r) {
                                                function n(t1, n) {
                                                    return e1.def('"', t1, n, '" in ', r, "?", r, ".", t1, n, ":", r, ".", t1);
                                                }
                                                t1 = t1.constants.blendFuncs;
                                                var i = n("src", "RGB"), a = n("dst", "RGB"), o = (i = e1.def(t1, "[", i, "]"), e1.def(t1, "[", n("src", "Alpha"), "]"));
                                                return [
                                                    i,
                                                    a = e1.def(t1, "[", a, "]"),
                                                    o,
                                                    t1 = e1.def(t1, "[", n("dst", "Alpha"), "]")
                                                ];
                                            });
                                        case "blend.equation":
                                            return e1(function(t1) {
                                                return "string" == typeof t1 ? [
                                                    K[t1],
                                                    K[t1]
                                                ] : "object" == typeof t1 ? [
                                                    K[t1.rgb],
                                                    K[t1.alpha]
                                                ] : void 0;
                                            }, function(t1, e1, r) {
                                                var n = t1.constants.blendEquations, i = e1.def(), a = e1.def();
                                                return (t1 = t1.cond("typeof ", r, '==="string"')).then(i, "=", a, "=", n, "[", r, "];"), t1.else(i, "=", n, "[", r, ".rgb];", a, "=", n, "[", r, ".alpha];"), e1(t1), [
                                                    i,
                                                    a
                                                ];
                                            });
                                        case "blend.color":
                                            return e1(function(t1) {
                                                return o(4, function(e1) {
                                                    return +t1[e1];
                                                });
                                            }, function(t1, e1, r) {
                                                return o(4, function(t1) {
                                                    return e1.def("+", r, "[", t1, "]");
                                                });
                                            });
                                        case "stencil.mask":
                                            return e1(function(t1) {
                                                return 0 | t1;
                                            }, function(t1, e1, r) {
                                                return e1.def(r, "|0");
                                            });
                                        case "stencil.func":
                                            return e1(function(t1) {
                                                return [
                                                    Lt[t1.cmp || "keep"],
                                                    t1.ref || 0,
                                                    "mask" in t1 ? t1.mask : -1
                                                ];
                                            }, function(t1, e1, r) {
                                                return [
                                                    t1 = e1.def('"cmp" in ', r, "?", t1.constants.compareFuncs, "[", r, ".cmp]", ":", 7680),
                                                    e1.def(r, ".ref|0"),
                                                    e1 = e1.def('"mask" in ', r, "?", r, ".mask|0:-1")
                                                ];
                                            });
                                        case "stencil.opFront":
                                        case "stencil.opBack":
                                            return e1(function(e1) {
                                                return [
                                                    "stencil.opBack" === t1 ? 1029 : 1028,
                                                    It[e1.fail || "keep"],
                                                    It[e1.zfail || "keep"],
                                                    It[e1.zpass || "keep"]
                                                ];
                                            }, function(e1, r, n) {
                                                function i(t1) {
                                                    return r.def('"', t1, '" in ', n, "?", a, "[", n, ".", t1, "]:", 7680);
                                                }
                                                var a = e1.constants.stencilOps;
                                                return [
                                                    "stencil.opBack" === t1 ? 1029 : 1028,
                                                    i("fail"),
                                                    i("zfail"),
                                                    i("zpass")
                                                ];
                                            });
                                        case "polygonOffset.offset":
                                            return e1(function(t1) {
                                                return [
                                                    0 | t1.factor,
                                                    0 | t1.units
                                                ];
                                            }, function(t1, e1, r) {
                                                return [
                                                    e1.def(r, ".factor|0"),
                                                    e1 = e1.def(r, ".units|0")
                                                ];
                                            });
                                        case "cull.face":
                                            return e1(function(t1) {
                                                var e1 = 0;
                                                return "front" === t1 ? e1 = 1028 : "back" === t1 && (e1 = 1029), e1;
                                            }, function(t1, e1, r) {
                                                return e1.def(r, '==="front"?', 1028, ":", 1029);
                                            });
                                        case "frontFace":
                                            return e1(function(t1) {
                                                return Pt[t1];
                                            }, function(t1, e1, r) {
                                                return e1.def(r + '==="cw"?2304:2305');
                                            });
                                        case "colorMask":
                                            return e1(function(t1) {
                                                return t1.map(function(t1) {
                                                    return !!t1;
                                                });
                                            }, function(t1, e1, r) {
                                                return o(4, function(t1) {
                                                    return "!!" + r + "[" + t1 + "]";
                                                });
                                            });
                                        case "sample.coverage":
                                            return e1(function(t1) {
                                                return [
                                                    "value" in t1 ? t1.value : 1,
                                                    !!t1.invert
                                                ];
                                            }, function(t1, e1, r) {
                                                return [
                                                    e1.def('"value" in ', r, "?+", r, ".value:1"),
                                                    e1 = e1.def("!!", r, ".invert")
                                                ];
                                            });
                                    }
                                }), i;
                            }(t1), p = T(t1, 0, l);
                            s("viewport"), s(y("scissor.box"));
                            var d, m = 0 < Object.keys(f).length;
                            if ((d = {
                                framebuffer: d,
                                draw: h,
                                shader: p,
                                state: f,
                                dirty: m,
                                scopeVAO: null,
                                drawVAO: null,
                                useVAO: !1,
                                attributes: {}
                            }).profile = function(t1) {
                                var e1, r = t1.static;
                                if (t1 = t1.dynamic, "profile" in r) {
                                    var n = !!r.profile;
                                    (e1 = U(function(t1, e1) {
                                        return n;
                                    })).enable = n;
                                } else if ("profile" in t1) {
                                    var i = t1.profile;
                                    e1 = V(i, function(t1, e1) {
                                        return t1.invoke(e1, i);
                                    });
                                }
                                return e1;
                            }(t1), d.uniforms = function(t1, e1) {
                                var r = t1.static, n = t1.dynamic, i = {};
                                return Object.keys(r).forEach(function(t1) {
                                    var e1, n = r[t1];
                                    if ("number" == typeof n || "boolean" == typeof n) e1 = U(function() {
                                        return n;
                                    });
                                    else if ("function" == typeof n) {
                                        var a = n._reglType;
                                        "texture2d" === a || "textureCube" === a ? e1 = U(function(t1) {
                                            return t1.link(n);
                                        }) : "framebuffer" !== a && "framebufferCube" !== a || (e1 = U(function(t1) {
                                            return t1.link(n.color[0]);
                                        }));
                                    } else v(n) && (e1 = U(function(t1) {
                                        return t1.global.def("[", o(n.length, function(t1) {
                                            return n[t1];
                                        }), "]");
                                    }));
                                    e1.value = n, i[t1] = e1;
                                }), Object.keys(n).forEach(function(t1) {
                                    var e1 = n[t1];
                                    i[t1] = V(e1, function(t1, r) {
                                        return t1.invoke(r, e1);
                                    });
                                }), i;
                            }(n), d.drawVAO = d.scopeVAO = h.vao, !d.drawVAO && p.program && !l && r.angle_instanced_arrays && h.static.elements) {
                                var g = !0;
                                if (t1 = p.program.attributes.map(function(t1) {
                                    return t1 = e1.static[t1], g = g && !!t1, t1;
                                }), g && 0 < t1.length) {
                                    var x = u.getVAO(u.createVAO({
                                        attributes: t1,
                                        elements: h.static.elements
                                    }));
                                    d.drawVAO = new N(null, null, null, function(t1, e1) {
                                        return t1.link(x);
                                    }), d.useVAO = !0;
                                }
                            }
                            return l ? d.useVAO = !0 : d.attributes = A(e1), d.context = function(t1) {
                                var e1 = t1.static, r = t1.dynamic, n = {};
                                return Object.keys(e1).forEach(function(t1) {
                                    var r = e1[t1];
                                    n[t1] = U(function(t1, e1) {
                                        return "number" == typeof r || "boolean" == typeof r ? "" + r : t1.link(r);
                                    });
                                }), Object.keys(r).forEach(function(t1) {
                                    var e1 = r[t1];
                                    n[t1] = V(e1, function(t1, r) {
                                        return t1.invoke(r, e1);
                                    });
                                }), n;
                            }(i), d;
                        }
                        function S(t1, e1, r) {
                            var n = t1.shared.context, i = t1.scope();
                            Object.keys(r).forEach(function(a) {
                                e1.save(n, "." + a);
                                var o = r[a].append(t1, e1);
                                Array.isArray(o) ? i(n, ".", a, "=[", o.join(), "];") : i(n, ".", a, "=", o, ";");
                            }), e1(i);
                        }
                        function E(t1, e1, r, n) {
                            var i, a = (s = t1.shared).gl, o = s.framebuffer;
                            tt && (i = e1.def(s.extensions, ".webgl_draw_buffers"));
                            var s = (l = t1.constants).drawBuffer, l = l.backBuffer;
                            t1 = r ? r.append(t1, e1) : e1.def(o, ".next"), n || e1("if(", t1, "!==", o, ".cur){"), e1("if(", t1, "){", a, ".bindFramebuffer(", 36160, ",", t1, ".framebuffer);"), tt && e1(i, ".drawBuffersWEBGL(", s, "[", t1, ".colorAttachments.length]);"), e1("}else{", a, ".bindFramebuffer(", 36160, ",null);"), tt && e1(i, ".drawBuffersWEBGL(", l, ");"), e1("}", o, ".cur=", t1, ";"), n || e1("}");
                        }
                        function C(t1, e1, r) {
                            var n = t1.shared, i = n.gl, a = t1.current, s = t1.next, l = n.current, c = n.next, u = t1.cond(l, ".dirty");
                            at.forEach(function(e1) {
                                var n, h;
                                if (!((e1 = y(e1)) in r.state)) {
                                    if (e1 in s) {
                                        n = s[e1], h = a[e1];
                                        var f = o(nt[e1].length, function(t1) {
                                            return u.def(n, "[", t1, "]");
                                        });
                                        u(t1.cond(f.map(function(t1, e1) {
                                            return t1 + "!==" + h + "[" + e1 + "]";
                                        }).join("||")).then(i, ".", lt[e1], "(", f, ");", f.map(function(t1, e1) {
                                            return h + "[" + e1 + "]=" + t1;
                                        }).join(";"), ";"));
                                    } else n = u.def(c, ".", e1), f = t1.cond(n, "!==", l, ".", e1), u(f), e1 in ot ? f(t1.cond(n).then(i, ".enable(", ot[e1], ");").else(i, ".disable(", ot[e1], ");"), l, ".", e1, "=", n, ";") : f(i, ".", lt[e1], "(", n, ");", l, ".", e1, "=", n, ";");
                                }
                            }), 0 === Object.keys(r.state).length && u(l, ".dirty=false;"), e1(u);
                        }
                        function L(t1, e1, r, n) {
                            var i, a = t1.shared, o = t1.current, s = a.current, l = a.gl;
                            B(Object.keys(r)).forEach(function(a) {
                                var c = r[a];
                                if (!n || n(c)) {
                                    var u = c.append(t1, e1);
                                    if (ot[a]) {
                                        var h = ot[a];
                                        j(c) ? (i = t1.link(u, {
                                            stable: !0
                                        }), e1(t1.cond(i).then(l, ".enable(", h, ");").else(l, ".disable(", h, ");")), e1(s, ".", a, "=", i, ";")) : (e1(t1.cond(u).then(l, ".enable(", h, ");").else(l, ".disable(", h, ");")), e1(s, ".", a, "=", u, ";"));
                                    } else if (v(u)) {
                                        var f = o[a];
                                        e1(l, ".", lt[a], "(", u, ");", u.map(function(t1, e1) {
                                            return f + "[" + e1 + "]=" + t1;
                                        }).join(";"), ";");
                                    } else j(c) ? (i = t1.link(u, {
                                        stable: !0
                                    }), e1(l, ".", lt[a], "(", i, ");", s, ".", a, "=", i, ";")) : e1(l, ".", lt[a], "(", u, ");", s, ".", a, "=", u, ";");
                                }
                            });
                        }
                        function I(t1, e1) {
                            Q && (t1.instancing = e1.def(t1.shared.extensions, ".angle_instanced_arrays"));
                        }
                        function P(t1, e1, r, n, i) {
                            function a() {
                                return "undefined" == typeof performance ? "Date.now()" : "performance.now()";
                            }
                            function o(t1) {
                                t1(c = e1.def(), "=", a(), ";"), "string" == typeof i ? t1(f, ".count+=", i, ";") : t1(f, ".count++;"), d && (n ? t1(u = e1.def(), "=", m, ".getNumPendingQueries();") : t1(m, ".beginQuery(", f, ");"));
                            }
                            function s(t1) {
                                t1(f, ".cpuTime+=", a(), "-", c, ";"), d && (n ? t1(m, ".pushScopeStats(", u, ",", m, ".getNumPendingQueries(),", f, ");") : t1(m, ".endQuery();"));
                            }
                            function l(t1) {
                                var r = e1.def(p, ".profile");
                                e1(p, ".profile=", t1, ";"), e1.exit(p, ".profile=", r, ";");
                            }
                            var c, u, h = t1.shared, f = t1.stats, p = h.current, m = h.timer;
                            if (r = r.profile) {
                                if (j(r)) return void (r.enable ? (o(e1), s(e1.exit), l("true")) : l("false"));
                                l(r = r.append(t1, e1));
                            } else r = e1.def(p, ".profile");
                            o(h = t1.block()), e1("if(", r, "){", h, "}"), s(t1 = t1.block()), e1.exit("if(", r, "){", t1, "}");
                        }
                        function z(t1, e1, r, n, i) {
                            function a(r, n, i) {
                                function a() {
                                    e1("if(!", u, ".buffer){", l, ".enableVertexAttribArray(", c, ");}");
                                    var r, a = i.type;
                                    r = i.size ? e1.def(i.size, "||", n) : n, e1("if(", u, ".type!==", a, "||", u, ".size!==", r, "||", p.map(function(t1) {
                                        return u + "." + t1 + "!==" + i[t1];
                                    }).join("||"), "){", l, ".bindBuffer(", 34962, ",", h, ".buffer);", l, ".vertexAttribPointer(", [
                                        c,
                                        r,
                                        a,
                                        i.normalized,
                                        i.stride,
                                        i.offset
                                    ], ");", u, ".type=", a, ";", u, ".size=", r, ";", p.map(function(t1) {
                                        return u + "." + t1 + "=" + i[t1] + ";";
                                    }).join(""), "}"), Q && (a = i.divisor, e1("if(", u, ".divisor!==", a, "){", t1.instancing, ".vertexAttribDivisorANGLE(", [
                                        c,
                                        a
                                    ], ");", u, ".divisor=", a, ";}"));
                                }
                                function s() {
                                    e1("if(", u, ".buffer){", l, ".disableVertexAttribArray(", c, ");", u, ".buffer=null;", "}if(", St.map(function(t1, e1) {
                                        return u + "." + t1 + "!==" + f[e1];
                                    }).join("||"), "){", l, ".vertexAttrib4f(", c, ",", f, ");", St.map(function(t1, e1) {
                                        return u + "." + t1 + "=" + f[e1] + ";";
                                    }).join(""), "}");
                                }
                                var l = o.gl, c = e1.def(r, ".location"), u = e1.def(o.attributes, "[", c, "]");
                                r = i.state;
                                var h = i.buffer, f = [
                                    i.x,
                                    i.y,
                                    i.z,
                                    i.w
                                ], p = [
                                    "buffer",
                                    "normalized",
                                    "offset",
                                    "stride"
                                ];
                                1 === r ? a() : 2 === r ? s() : (e1("if(", r, "===", 1, "){"), a(), e1("}else{"), s(), e1("}"));
                            }
                            var o = t1.shared;
                            n.forEach(function(n) {
                                var o, s = n.name, l = r.attributes[s];
                                if (l) {
                                    if (!i(l)) return;
                                    o = l.append(t1, e1);
                                } else {
                                    if (!i(zt)) return;
                                    var c = t1.scopeAttrib(s);
                                    o = {}, Object.keys(new J).forEach(function(t1) {
                                        o[t1] = e1.def(c, ".", t1);
                                    });
                                }
                                a(t1.link(n), function(t1) {
                                    switch(t1){
                                        case 35664:
                                        case 35667:
                                        case 35671:
                                            return 2;
                                        case 35665:
                                        case 35668:
                                        case 35672:
                                            return 3;
                                        case 35666:
                                        case 35669:
                                        case 35673:
                                            return 4;
                                        default:
                                            return 1;
                                    }
                                }(n.info.type), o);
                            });
                        }
                        function O(t1, r, n, i, a, s) {
                            for(var l, c = t1.shared, u = c.gl, h = 0; h < i.length; ++h){
                                var f, p = (g = i[h]).name, d = g.info.type, m = n.uniforms[p], g = t1.link(g) + ".location";
                                if (m) {
                                    if (!a(m)) continue;
                                    if (j(m)) {
                                        if (p = m.value, 35678 === d || 35680 === d) r(u, ".uniform1i(", g, ",", (d = t1.link(p._texture || p.color[0]._texture)) + ".bind());"), r.exit(d, ".unbind();");
                                        else if (35674 === d || 35675 === d || 35676 === d) m = 2, 35675 === d ? m = 3 : 35676 === d && (m = 4), r(u, ".uniformMatrix", m, "fv(", g, ",false,", p = t1.global.def("new Float32Array([" + Array.prototype.slice.call(p) + "])"), ");");
                                        else {
                                            switch(d){
                                                case 5126:
                                                    l = "1f";
                                                    break;
                                                case 35664:
                                                    l = "2f";
                                                    break;
                                                case 35665:
                                                    l = "3f";
                                                    break;
                                                case 35666:
                                                    l = "4f";
                                                    break;
                                                case 35670:
                                                case 5124:
                                                    l = "1i";
                                                    break;
                                                case 35671:
                                                case 35667:
                                                    l = "2i";
                                                    break;
                                                case 35672:
                                                case 35668:
                                                    l = "3i";
                                                    break;
                                                case 35673:
                                                case 35669:
                                                    l = "4i";
                                            }
                                            r(u, ".uniform", l, "(", g, ",", v(p) ? Array.prototype.slice.call(p) : p, ");");
                                        }
                                        continue;
                                    }
                                    f = m.append(t1, r);
                                } else {
                                    if (!a(zt)) continue;
                                    f = r.def(c.uniforms, "[", e1.id(p), "]");
                                }
                                switch(35678 === d ? r("if(", f, "&&", f, '._reglType==="framebuffer"){', f, "=", f, ".color[0];", "}") : 35680 === d && r("if(", f, "&&", f, '._reglType==="framebufferCube"){', f, "=", f, ".color[0];", "}"), p = 1, d){
                                    case 35678:
                                    case 35680:
                                        d = r.def(f, "._texture"), r(u, ".uniform1i(", g, ",", d, ".bind());"), r.exit(d, ".unbind();");
                                        continue;
                                    case 5124:
                                    case 35670:
                                        l = "1i";
                                        break;
                                    case 35667:
                                    case 35671:
                                        l = "2i", p = 2;
                                        break;
                                    case 35668:
                                    case 35672:
                                        l = "3i", p = 3;
                                        break;
                                    case 35669:
                                    case 35673:
                                        l = "4i", p = 4;
                                        break;
                                    case 5126:
                                        l = "1f";
                                        break;
                                    case 35664:
                                        l = "2f", p = 2;
                                        break;
                                    case 35665:
                                        l = "3f", p = 3;
                                        break;
                                    case 35666:
                                        l = "4f", p = 4;
                                        break;
                                    case 35674:
                                        l = "Matrix2fv";
                                        break;
                                    case 35675:
                                        l = "Matrix3fv";
                                        break;
                                    case 35676:
                                        l = "Matrix4fv";
                                }
                                if ("M" === l.charAt(0)) {
                                    r(u, ".uniform", l, "(", g, ","), g = Math.pow(d - 35674 + 2, 2);
                                    var y = t1.global.def("new Float32Array(", g, ")");
                                    Array.isArray(f) ? r("false,(", o(g, function(t1) {
                                        return y + "[" + t1 + "]=" + f[t1];
                                    }), ",", y, ")") : r("false,(Array.isArray(", f, ")||", f, " instanceof Float32Array)?", f, ":(", o(g, function(t1) {
                                        return y + "[" + t1 + "]=" + f + "[" + t1 + "]";
                                    }), ",", y, ")"), r(");");
                                } else {
                                    if (1 < p) {
                                        d = [];
                                        var x = [];
                                        for(m = 0; m < p; ++m)Array.isArray(f) ? x.push(f[m]) : x.push(r.def(f + "[" + m + "]")), s && d.push(r.def());
                                        s && r("if(!", t1.batchId, "||", d.map(function(t1, e1) {
                                            return t1 + "!==" + x[e1];
                                        }).join("||"), "){", d.map(function(t1, e1) {
                                            return t1 + "=" + x[e1] + ";";
                                        }).join("")), r(u, ".uniform", l, "(", g, ",", x.join(","), ");");
                                    } else s && (d = r.def(), r("if(!", t1.batchId, "||", d, "!==", f, "){", d, "=", f, ";")), r(u, ".uniform", l, "(", g, ",", f, ");");
                                    s && r("}");
                                }
                            }
                        }
                        function D(t1, e1, r, n) {
                            function i(i) {
                                var a = f[i];
                                return a ? a.contextDep && n.contextDynamic || a.propDep ? a.append(t1, r) : a.append(t1, e1) : e1.def(h, ".", i);
                            }
                            function a() {
                                function t1() {
                                    r(l, ".drawElementsInstancedANGLE(", [
                                        d,
                                        g,
                                        y,
                                        m + "<<((" + y + "-5121)>>1)",
                                        s
                                    ], ");");
                                }
                                function e1() {
                                    r(l, ".drawArraysInstancedANGLE(", [
                                        d,
                                        m,
                                        g,
                                        s
                                    ], ");");
                                }
                                p && "null" !== p ? v ? t1() : (r("if(", p, "){"), t1(), r("}else{"), e1(), r("}")) : e1();
                            }
                            function o() {
                                function t1() {
                                    r(u + ".drawElements(" + [
                                        d,
                                        g,
                                        y,
                                        m + "<<((" + y + "-5121)>>1)"
                                    ] + ");");
                                }
                                function e1() {
                                    r(u + ".drawArrays(" + [
                                        d,
                                        m,
                                        g
                                    ] + ");");
                                }
                                p && "null" !== p ? v ? t1() : (r("if(", p, "){"), t1(), r("}else{"), e1(), r("}")) : e1();
                            }
                            var s, l, c = t1.shared, u = c.gl, h = c.draw, f = n.draw, p = function() {
                                var i = f.elements, a = e1;
                                return i ? ((i.contextDep && n.contextDynamic || i.propDep) && (a = r), i = i.append(t1, a), f.elementsActive && a("if(" + i + ")" + u + ".bindBuffer(34963," + i + ".buffer.buffer);")) : (i = a.def(), a(i, "=", h, ".", "elements", ";", "if(", i, "){", u, ".bindBuffer(", 34963, ",", i, ".buffer.buffer);}", "else if(", c.vao, ".currentVAO){", i, "=", t1.shared.elements + ".getElements(" + c.vao, ".currentVAO.elements);", et ? "" : "if(" + i + ")" + u + ".bindBuffer(34963," + i + ".buffer.buffer);", "}")), i;
                            }(), d = i("primitive"), m = i("offset"), g = function() {
                                var i = f.count, a = e1;
                                return i ? ((i.contextDep && n.contextDynamic || i.propDep) && (a = r), i = i.append(t1, a)) : i = a.def(h, ".", "count"), i;
                            }();
                            if ("number" == typeof g) {
                                if (0 === g) return;
                            } else r("if(", g, "){"), r.exit("}");
                            Q && (s = i("instances"), l = t1.instancing);
                            var y = p + ".type", v = f.elements && j(f.elements) && !f.vaoActive;
                            Q && ("number" != typeof s || 0 <= s) ? "string" == typeof s ? (r("if(", s, ">0){"), a(), r("}else if(", s, "<0){"), o(), r("}")) : a() : o();
                        }
                        function q(t1, e1, r, n, i) {
                            return i = (e1 = b()).proc("body", i), Q && (e1.instancing = i.def(e1.shared.extensions, ".angle_instanced_arrays")), t1(e1, i, r, n), e1.compile().body;
                        }
                        function H(t1, e1, r, n) {
                            I(t1, e1), r.useVAO ? r.drawVAO ? e1(t1.shared.vao, ".setVAO(", r.drawVAO.append(t1, e1), ");") : e1(t1.shared.vao, ".setVAO(", t1.shared.vao, ".targetVAO);") : (e1(t1.shared.vao, ".setVAO(null);"), z(t1, e1, r, n.attributes, function() {
                                return !0;
                            })), O(t1, e1, r, n.uniforms, function() {
                                return !0;
                            }, !1), D(t1, e1, e1, r);
                        }
                        function Z(t1, e1, r, n) {
                            function i() {
                                return !0;
                            }
                            t1.batchId = "a1", I(t1, e1), z(t1, e1, r, n.attributes, i), O(t1, e1, r, n.uniforms, i, !1), D(t1, e1, e1, r);
                        }
                        function Y(t1, e1, r, n) {
                            function i(t1) {
                                return t1.contextDep && o || t1.propDep;
                            }
                            function a(t1) {
                                return !i(t1);
                            }
                            I(t1, e1);
                            var o = r.contextDep, s = e1.def(), l = e1.def();
                            t1.shared.props = l, t1.batchId = s;
                            var c = t1.scope(), u = t1.scope();
                            e1(c.entry, "for(", s, "=0;", s, "<", "a1", ";++", s, "){", l, "=", "a0", "[", s, "];", u, "}", c.exit), r.needsContext && S(t1, u, r.context), r.needsFramebuffer && E(t1, u, r.framebuffer), L(t1, u, r.state, i), r.profile && i(r.profile) && P(t1, u, r, !1, !0), n ? (r.useVAO ? r.drawVAO ? i(r.drawVAO) ? u(t1.shared.vao, ".setVAO(", r.drawVAO.append(t1, u), ");") : c(t1.shared.vao, ".setVAO(", r.drawVAO.append(t1, c), ");") : c(t1.shared.vao, ".setVAO(", t1.shared.vao, ".targetVAO);") : (c(t1.shared.vao, ".setVAO(null);"), z(t1, c, r, n.attributes, a), z(t1, u, r, n.attributes, i)), O(t1, c, r, n.uniforms, a, !1), O(t1, u, r, n.uniforms, i, !0), D(t1, c, u, r)) : (e1 = t1.global.def("{}"), n = r.shader.progVar.append(t1, u), l = u.def(n, ".id"), c = u.def(e1, "[", l, "]"), u(t1.shared.gl, ".useProgram(", n, ".program);", "if(!", c, "){", c, "=", e1, "[", l, "]=", t1.link(function(e1) {
                                return q(Z, t1, r, e1, 2);
                            }), "(", n, ");}", c, ".call(this,a0[", s, "],", s, ");"));
                        }
                        function X(t1, r) {
                            function n(e1) {
                                var n = r.shader[e1];
                                n && (n = n.append(t1, i), isNaN(n) ? i.set(a.shader, "." + e1, n) : i.set(a.shader, "." + e1, t1.link(n, {
                                    stable: !0
                                })));
                            }
                            var i = t1.proc("scope", 3);
                            t1.batchId = "a2";
                            var a = t1.shared, o = a.current;
                            if (S(t1, i, r.context), r.framebuffer && r.framebuffer.append(t1, i), B(Object.keys(r.state)).forEach(function(e1) {
                                var n = r.state[e1], o = n.append(t1, i);
                                v(o) ? o.forEach(function(r, n) {
                                    isNaN(r) ? i.set(t1.next[e1], "[" + n + "]", r) : i.set(t1.next[e1], "[" + n + "]", t1.link(r, {
                                        stable: !0
                                    }));
                                }) : j(n) ? i.set(a.next, "." + e1, t1.link(o, {
                                    stable: !0
                                })) : i.set(a.next, "." + e1, o);
                            }), P(t1, i, r, !0, !0), [
                                "elements",
                                "offset",
                                "count",
                                "instances",
                                "primitive"
                            ].forEach(function(e1) {
                                var n = r.draw[e1];
                                n && (n = n.append(t1, i), isNaN(n) ? i.set(a.draw, "." + e1, n) : i.set(a.draw, "." + e1, t1.link(n), {
                                    stable: !0
                                }));
                            }), Object.keys(r.uniforms).forEach(function(n) {
                                var o = r.uniforms[n].append(t1, i);
                                Array.isArray(o) && (o = "[" + o.map(function(e1) {
                                    return isNaN(e1) ? e1 : t1.link(e1, {
                                        stable: !0
                                    });
                                }) + "]"), i.set(a.uniforms, "[" + t1.link(e1.id(n), {
                                    stable: !0
                                }) + "]", o);
                            }), Object.keys(r.attributes).forEach(function(e1) {
                                var n = r.attributes[e1].append(t1, i), a = t1.scopeAttrib(e1);
                                Object.keys(new J).forEach(function(t1) {
                                    i.set(a, "." + t1, n[t1]);
                                });
                            }), r.scopeVAO) {
                                var s = r.scopeVAO.append(t1, i);
                                isNaN(s) ? i.set(a.vao, ".targetVAO", s) : i.set(a.vao, ".targetVAO", t1.link(s, {
                                    stable: !0
                                }));
                            }
                            n("vert"), n("frag"), 0 < Object.keys(r.state).length && (i(o, ".dirty=true;"), i.exit(o, ".dirty=true;")), i("a1(", t1.shared.context, ",a0,", t1.batchId, ");");
                        }
                        function $(t1, e1, r) {
                            var n = e1.static[r];
                            if (n && function(t1) {
                                if ("object" == typeof t1 && !v(t1)) {
                                    for(var e1 = Object.keys(t1), r = 0; r < e1.length; ++r)if (W.isDynamic(t1[e1[r]])) return !0;
                                    return !1;
                                }
                            }(n)) {
                                var i = t1.global, a = Object.keys(n), o = !1, s = !1, l = !1, c = t1.global.def("{}");
                                a.forEach(function(e1) {
                                    var r = n[e1];
                                    if (W.isDynamic(r)) "function" == typeof r && (r = n[e1] = W.unbox(r)), e1 = V(r, null), o = o || e1.thisDep, l = l || e1.propDep, s = s || e1.contextDep;
                                    else {
                                        switch(i(c, ".", e1, "="), typeof r){
                                            case "number":
                                                i(r);
                                                break;
                                            case "string":
                                                i('"', r, '"');
                                                break;
                                            case "object":
                                                Array.isArray(r) && i("[", r.join(), "]");
                                                break;
                                            default:
                                                i(t1.link(r));
                                        }
                                        i(";");
                                    }
                                }), e1.dynamic[r] = new W.DynamicVariable(4, {
                                    thisDep: o,
                                    contextDep: s,
                                    propDep: l,
                                    ref: c,
                                    append: function(t1, e1) {
                                        a.forEach(function(r) {
                                            var i = n[r];
                                            W.isDynamic(i) && (i = t1.invoke(e1, i), e1(c, ".", r, "=", i, ";"));
                                        });
                                    }
                                }), delete e1.static[r];
                            }
                        }
                        var J = u.Record, K = {
                            add: 32774,
                            subtract: 32778,
                            "reverse subtract": 32779
                        };
                        r.ext_blend_minmax && (K.min = 32775, K.max = 32776);
                        var Q = r.angle_instanced_arrays, tt = r.webgl_draw_buffers, et = r.oes_vertex_array_object, nt = {
                            dirty: !0,
                            profile: g.profile
                        }, it = {}, at = [], ot = {}, lt = {};
                        x("dither", 3024), x("blend.enable", 3042), _("blend.color", "blendColor", [
                            0,
                            0,
                            0,
                            0
                        ]), _("blend.equation", "blendEquationSeparate", [
                            32774,
                            32774
                        ]), _("blend.func", "blendFuncSeparate", [
                            1,
                            0,
                            1,
                            0
                        ]), x("depth.enable", 2929, !0), _("depth.func", "depthFunc", 513), _("depth.range", "depthRange", [
                            0,
                            1
                        ]), _("depth.mask", "depthMask", !0), _("colorMask", "colorMask", [
                            !0,
                            !0,
                            !0,
                            !0
                        ]), x("cull.enable", 2884), _("cull.face", "cullFace", 1029), _("frontFace", "frontFace", 2305), _("lineWidth", "lineWidth", 1), x("polygonOffset.enable", 32823), _("polygonOffset.offset", "polygonOffset", [
                            0,
                            0
                        ]), x("sample.alpha", 32926), x("sample.enable", 32928), _("sample.coverage", "sampleCoverage", [
                            1,
                            !1
                        ]), x("stencil.enable", 2960), _("stencil.mask", "stencilMask", -1), _("stencil.func", "stencilFunc", [
                            519,
                            0,
                            -1
                        ]), _("stencil.opFront", "stencilOpSeparate", [
                            1028,
                            7680,
                            7680,
                            7680
                        ]), _("stencil.opBack", "stencilOpSeparate", [
                            1029,
                            7680,
                            7680,
                            7680
                        ]), x("scissor.enable", 3089), _("scissor.box", "scissor", [
                            0,
                            0,
                            t1.drawingBufferWidth,
                            t1.drawingBufferHeight
                        ]), _("viewport", "viewport", [
                            0,
                            0,
                            t1.drawingBufferWidth,
                            t1.drawingBufferHeight
                        ]);
                        var ct = {
                            gl: t1,
                            context: p,
                            strings: e1,
                            next: it,
                            current: nt,
                            draw: f,
                            elements: a,
                            buffer: i,
                            shader: h,
                            attributes: u.state,
                            vao: u,
                            uniforms: c,
                            framebuffer: l,
                            extensions: r,
                            timer: d,
                            isBufferArgs: F
                        }, ut = {
                            primTypes: st,
                            compareFuncs: Lt,
                            blendFuncs: Ct,
                            blendEquations: K,
                            stencilOps: It,
                            glTypes: rt,
                            orientationType: Pt
                        };
                        tt && (ut.backBuffer = [
                            1029
                        ], ut.drawBuffer = o(n.maxDrawbuffers, function(t1) {
                            return 0 === t1 ? [
                                0
                            ] : o(t1, function(t1) {
                                return 36064 + t1;
                            });
                        }));
                        var ht = 0;
                        return {
                            next: it,
                            current: nt,
                            procs: function() {
                                var t1 = b(), e1 = t1.proc("poll"), i = t1.proc("refresh"), a = t1.block();
                                e1(a), i(a);
                                var s, l = (h = t1.shared).gl, c = h.next, u = h.current;
                                a(u, ".dirty=false;"), E(t1, e1), E(t1, i, null, !0), Q && (s = t1.link(Q)), r.oes_vertex_array_object && i(t1.link(r.oes_vertex_array_object), ".bindVertexArrayOES(null);");
                                var h = i.def(h.attributes), f = i.def(0), p = t1.cond(f, ".buffer");
                                p.then(l, ".enableVertexAttribArray(i);", l, ".bindBuffer(", 34962, ",", f, ".buffer.buffer);", l, ".vertexAttribPointer(i,", f, ".size,", f, ".type,", f, ".normalized,", f, ".stride,", f, ".offset);").else(l, ".disableVertexAttribArray(i);", l, ".vertexAttrib4f(i,", f, ".x,", f, ".y,", f, ".z,", f, ".w);", f, ".buffer=null;");
                                var d = t1.link(n.maxAttributes, {
                                    stable: !0
                                });
                                return i("for(var i=0;i<", d, ";++i){", f, "=", h, "[i];", p, "}"), Q && i("for(var i=0;i<", d, ";++i){", s, ".vertexAttribDivisorANGLE(i,", h, "[i].divisor);", "}"), i(t1.shared.vao, ".currentVAO=null;", t1.shared.vao, ".setVAO(", t1.shared.vao, ".targetVAO);"), Object.keys(ot).forEach(function(r) {
                                    var n = ot[r], o = a.def(c, ".", r), s = t1.block();
                                    s("if(", o, "){", l, ".enable(", n, ")}else{", l, ".disable(", n, ")}", u, ".", r, "=", o, ";"), i(s), e1("if(", o, "!==", u, ".", r, "){", s, "}");
                                }), Object.keys(lt).forEach(function(r) {
                                    var n, s, h = lt[r], f = nt[r], p = t1.block();
                                    p(l, ".", h, "("), v(f) ? (h = f.length, n = t1.global.def(c, ".", r), s = t1.global.def(u, ".", r), p(o(h, function(t1) {
                                        return n + "[" + t1 + "]";
                                    }), ");", o(h, function(t1) {
                                        return s + "[" + t1 + "]=" + n + "[" + t1 + "];";
                                    }).join("")), e1("if(", o(h, function(t1) {
                                        return n + "[" + t1 + "]!==" + s + "[" + t1 + "]";
                                    }).join("||"), "){", p, "}")) : (n = a.def(c, ".", r), s = a.def(u, ".", r), p(n, ");", u, ".", r, "=", n, ";"), e1("if(", n, "!==", s, "){", p, "}")), i(p);
                                }), t1.compile();
                            }(),
                            compile: function(t1, e1, r, n, i) {
                                var a = b();
                                a.stats = a.link(i), Object.keys(e1.static).forEach(function(t1) {
                                    $(a, e1, t1);
                                }), Et.forEach(function(e1) {
                                    $(a, t1, e1);
                                });
                                var o = M(t1, e1, r, n);
                                return o.shader.program && (o.shader.program.attributes.sort(function(t1, e1) {
                                    return t1.name < e1.name ? -1 : 1;
                                }), o.shader.program.uniforms.sort(function(t1, e1) {
                                    return t1.name < e1.name ? -1 : 1;
                                })), function(t1, e1) {
                                    var r = t1.proc("draw", 1);
                                    I(t1, r), S(t1, r, e1.context), E(t1, r, e1.framebuffer), C(t1, r, e1), L(t1, r, e1.state), P(t1, r, e1, !1, !0);
                                    var n = e1.shader.progVar.append(t1, r);
                                    if (r(t1.shared.gl, ".useProgram(", n, ".program);"), e1.shader.program) H(t1, r, e1, e1.shader.program);
                                    else {
                                        r(t1.shared.vao, ".setVAO(null);");
                                        var i = t1.global.def("{}"), a = r.def(n, ".id"), o = r.def(i, "[", a, "]");
                                        r(t1.cond(o).then(o, ".call(this,a0);").else(o, "=", i, "[", a, "]=", t1.link(function(r) {
                                            return q(H, t1, e1, r, 1);
                                        }), "(", n, ");", o, ".call(this,a0);"));
                                    }
                                    0 < Object.keys(e1.state).length && r(t1.shared.current, ".dirty=true;"), t1.shared.vao && r(t1.shared.vao, ".setVAO(null);");
                                }(a, o), X(a, o), function(t1, e1) {
                                    function r(t1) {
                                        return t1.contextDep && i || t1.propDep;
                                    }
                                    var n = t1.proc("batch", 2);
                                    t1.batchId = "0", I(t1, n);
                                    var i = !1, a = !0;
                                    Object.keys(e1.context).forEach(function(t1) {
                                        i = i || e1.context[t1].propDep;
                                    }), i || (S(t1, n, e1.context), a = !1);
                                    var o = !1;
                                    if ((s = e1.framebuffer) ? (s.propDep ? i = o = !0 : s.contextDep && i && (o = !0), o || E(t1, n, s)) : E(t1, n, null), e1.state.viewport && e1.state.viewport.propDep && (i = !0), C(t1, n, e1), L(t1, n, e1.state, function(t1) {
                                        return !r(t1);
                                    }), e1.profile && r(e1.profile) || P(t1, n, e1, !1, "a1"), e1.contextDep = i, e1.needsContext = a, e1.needsFramebuffer = o, (a = e1.shader.progVar).contextDep && i || a.propDep) Y(t1, n, e1, null);
                                    else if (a = a.append(t1, n), n(t1.shared.gl, ".useProgram(", a, ".program);"), e1.shader.program) Y(t1, n, e1, e1.shader.program);
                                    else {
                                        n(t1.shared.vao, ".setVAO(null);");
                                        var s = t1.global.def("{}"), l = (o = n.def(a, ".id"), n.def(s, "[", o, "]"));
                                        n(t1.cond(l).then(l, ".call(this,a0,a1);").else(l, "=", s, "[", o, "]=", t1.link(function(r) {
                                            return q(Y, t1, e1, r, 2);
                                        }), "(", a, ");", l, ".call(this,a0,a1);"));
                                    }
                                    0 < Object.keys(e1.state).length && n(t1.shared.current, ".dirty=true;"), t1.shared.vao && n(t1.shared.vao, ".setVAO(null);");
                                }(a, o), G(a.compile(), {
                                    destroy: function() {
                                        o.shader.program.destroy();
                                    }
                                });
                            }
                        };
                    }
                    function H(t1, e1) {
                        for(var r = 0; r < t1.length; ++r)if (t1[r] === e1) return r;
                        return -1;
                    }
                    var G = function(t1, e1) {
                        for(var r = Object.keys(e1), n = 0; n < r.length; ++n)t1[r[n]] = e1[r[n]];
                        return t1;
                    }, Z = 0, W = {
                        DynamicVariable: t1,
                        define: function(e1, n) {
                            return new t1(e1, r(n + ""));
                        },
                        isDynamic: function(e1) {
                            return "function" == typeof e1 && !e1._reglType || e1 instanceof t1;
                        },
                        unbox: function e1(r, n) {
                            return "function" == typeof r ? new t1(0, r) : "number" == typeof r || "boolean" == typeof r ? new t1(5, r) : Array.isArray(r) ? new t1(6, r.map(function(t1, r) {
                                return e1(t1, n + "[" + r + "]");
                            })) : r instanceof t1 ? r : void 0;
                        },
                        accessor: r
                    }, Y = {
                        next: "function" == typeof requestAnimationFrame ? function(t1) {
                            return requestAnimationFrame(t1);
                        } : function(t1) {
                            return setTimeout(t1, 16);
                        },
                        cancel: "function" == typeof cancelAnimationFrame ? function(t1) {
                            return cancelAnimationFrame(t1);
                        } : clearTimeout
                    }, X = "undefined" != typeof performance && performance.now ? function() {
                        return performance.now();
                    } : function() {
                        return +new Date;
                    }, $ = l();
                    $.zero = l();
                    var J = function(t1, e1) {
                        var r = 1;
                        e1.ext_texture_filter_anisotropic && (r = t1.getParameter(34047));
                        var n = 1, i = 1;
                        e1.webgl_draw_buffers && (n = t1.getParameter(34852), i = t1.getParameter(36063));
                        var a = !!e1.oes_texture_float;
                        if (a) {
                            a = t1.createTexture(), t1.bindTexture(3553, a), t1.texImage2D(3553, 0, 6408, 1, 1, 0, 6408, 5126, null);
                            var o = t1.createFramebuffer();
                            if (t1.bindFramebuffer(36160, o), t1.framebufferTexture2D(36160, 36064, 3553, a, 0), t1.bindTexture(3553, null), 36053 !== t1.checkFramebufferStatus(36160)) a = !1;
                            else {
                                t1.viewport(0, 0, 1, 1), t1.clearColor(1, 0, 0, 1), t1.clear(16384);
                                var s = $.allocType(5126, 4);
                                t1.readPixels(0, 0, 1, 1, 6408, 5126, s), t1.getError() ? a = !1 : (t1.deleteFramebuffer(o), t1.deleteTexture(a), a = 1 === s[0]), $.freeType(s);
                            }
                        }
                        return s = !0, "undefined" != typeof navigator && (/MSIE/.test(navigator.userAgent) || /Trident\//.test(navigator.appVersion) || /Edge/.test(navigator.userAgent)) || (s = t1.createTexture(), o = $.allocType(5121, 36), t1.activeTexture(33984), t1.bindTexture(34067, s), t1.texImage2D(34069, 0, 6408, 3, 3, 0, 6408, 5121, o), $.freeType(o), t1.bindTexture(34067, null), t1.deleteTexture(s), s = !t1.getError()), {
                            colorBits: [
                                t1.getParameter(3410),
                                t1.getParameter(3411),
                                t1.getParameter(3412),
                                t1.getParameter(3413)
                            ],
                            depthBits: t1.getParameter(3414),
                            stencilBits: t1.getParameter(3415),
                            subpixelBits: t1.getParameter(3408),
                            extensions: Object.keys(e1).filter(function(t1) {
                                return !!e1[t1];
                            }),
                            maxAnisotropic: r,
                            maxDrawbuffers: n,
                            maxColorAttachments: i,
                            pointSizeDims: t1.getParameter(33901),
                            lineWidthDims: t1.getParameter(33902),
                            maxViewportDims: t1.getParameter(3386),
                            maxCombinedTextureUnits: t1.getParameter(35661),
                            maxCubeMapSize: t1.getParameter(34076),
                            maxRenderbufferSize: t1.getParameter(34024),
                            maxTextureUnits: t1.getParameter(34930),
                            maxTextureSize: t1.getParameter(3379),
                            maxAttributes: t1.getParameter(34921),
                            maxVertexUniforms: t1.getParameter(36347),
                            maxVertexTextureUnits: t1.getParameter(35660),
                            maxVaryingVectors: t1.getParameter(36348),
                            maxFragmentUniforms: t1.getParameter(36349),
                            glsl: t1.getParameter(35724),
                            renderer: t1.getParameter(7937),
                            vendor: t1.getParameter(7936),
                            version: t1.getParameter(7938),
                            readFloat: a,
                            npotTextureCube: s
                        };
                    }, K = function(t1) {
                        return t1 instanceof Uint8Array || t1 instanceof Uint16Array || t1 instanceof Uint32Array || t1 instanceof Int8Array || t1 instanceof Int16Array || t1 instanceof Int32Array || t1 instanceof Float32Array || t1 instanceof Float64Array || t1 instanceof Uint8ClampedArray;
                    }, Q = function(t1) {
                        return Object.keys(t1).map(function(e1) {
                            return t1[e1];
                        });
                    }, tt = {
                        shape: function(t1) {
                            for(var e1 = []; t1.length; t1 = t1[0])e1.push(t1.length);
                            return e1;
                        },
                        flatten: function(t1, e1, r, n) {
                            var i = 1;
                            if (e1.length) for(var a = 0; a < e1.length; ++a)i *= e1[a];
                            else i = 0;
                            switch(r = n || $.allocType(r, i), e1.length){
                                case 0:
                                    break;
                                case 1:
                                    for(n = e1[0], e1 = 0; e1 < n; ++e1)r[e1] = t1[e1];
                                    break;
                                case 2:
                                    for(n = e1[0], e1 = e1[1], a = i = 0; a < n; ++a)for(var o = t1[a], s = 0; s < e1; ++s)r[i++] = o[s];
                                    break;
                                case 3:
                                    u(t1, e1[0], e1[1], e1[2], r, 0);
                                    break;
                                default:
                                    h(t1, e1, 0, r, 0);
                            }
                            return r;
                        }
                    }, et = {
                        "[object Int8Array]": 5120,
                        "[object Int16Array]": 5122,
                        "[object Int32Array]": 5124,
                        "[object Uint8Array]": 5121,
                        "[object Uint8ClampedArray]": 5121,
                        "[object Uint16Array]": 5123,
                        "[object Uint32Array]": 5125,
                        "[object Float32Array]": 5126,
                        "[object Float64Array]": 5121,
                        "[object ArrayBuffer]": 5121
                    }, rt = {
                        int8: 5120,
                        int16: 5122,
                        int32: 5124,
                        uint8: 5121,
                        uint16: 5123,
                        uint32: 5125,
                        float: 5126,
                        float32: 5126
                    }, nt = {
                        dynamic: 35048,
                        stream: 35040,
                        static: 35044
                    }, it = tt.flatten, at = tt.shape, ot = [];
                    ot[5120] = 1, ot[5122] = 2, ot[5124] = 4, ot[5121] = 1, ot[5123] = 2, ot[5125] = 4, ot[5126] = 4;
                    var st = {
                        points: 0,
                        point: 0,
                        lines: 1,
                        line: 1,
                        triangles: 4,
                        triangle: 4,
                        "line loop": 2,
                        "line strip": 3,
                        "triangle strip": 5,
                        "triangle fan": 6
                    }, lt = new Float32Array(1), ct = new Uint32Array(lt.buffer), ut = [
                        9984,
                        9986,
                        9985,
                        9987
                    ], ht = [
                        0,
                        6409,
                        6410,
                        6407,
                        6408
                    ], ft = {};
                    ft[6409] = ft[6406] = ft[6402] = 1, ft[34041] = ft[6410] = 2, ft[6407] = ft[35904] = 3, ft[6408] = ft[35906] = 4;
                    var pt = x("HTMLCanvasElement"), dt = x("OffscreenCanvas"), mt = x("CanvasRenderingContext2D"), gt = x("ImageBitmap"), yt = x("HTMLImageElement"), vt = x("HTMLVideoElement"), xt = Object.keys(et).concat([
                        pt,
                        dt,
                        mt,
                        gt,
                        yt,
                        vt
                    ]), _t = [];
                    _t[5121] = 1, _t[5126] = 4, _t[36193] = 2, _t[5123] = 2, _t[5125] = 4;
                    var bt = [];
                    bt[32854] = 2, bt[32855] = 2, bt[36194] = 2, bt[34041] = 4, bt[33776] = .5, bt[33777] = .5, bt[33778] = 1, bt[33779] = 1, bt[35986] = .5, bt[35987] = 1, bt[34798] = 1, bt[35840] = .5, bt[35841] = .25, bt[35842] = .5, bt[35843] = .25, bt[36196] = .5;
                    var wt = [];
                    wt[32854] = 2, wt[32855] = 2, wt[36194] = 2, wt[33189] = 2, wt[36168] = 1, wt[34041] = 4, wt[35907] = 4, wt[34836] = 16, wt[34842] = 8, wt[34843] = 6;
                    var Tt = function(t1, e1, r, n, i) {
                        function a(t1) {
                            this.id = c++, this.refCount = 1, this.renderbuffer = t1, this.format = 32854, this.height = this.width = 0, i.profile && (this.stats = {
                                size: 0
                            });
                        }
                        function o(e1) {
                            var r = e1.renderbuffer;
                            t1.bindRenderbuffer(36161, null), t1.deleteRenderbuffer(r), e1.renderbuffer = null, e1.refCount = 0, delete u[e1.id], n.renderbufferCount--;
                        }
                        var s = {
                            rgba4: 32854,
                            rgb565: 36194,
                            "rgb5 a1": 32855,
                            depth: 33189,
                            stencil: 36168,
                            "depth stencil": 34041
                        };
                        e1.ext_srgb && (s.srgba = 35907), e1.ext_color_buffer_half_float && (s.rgba16f = 34842, s.rgb16f = 34843), e1.webgl_color_buffer_float && (s.rgba32f = 34836);
                        var l = [];
                        Object.keys(s).forEach(function(t1) {
                            l[s[t1]] = t1;
                        });
                        var c = 0, u = {};
                        return a.prototype.decRef = function() {
                            0 >= --this.refCount && o(this);
                        }, i.profile && (n.getTotalRenderbufferSize = function() {
                            var t1 = 0;
                            return Object.keys(u).forEach(function(e1) {
                                t1 += u[e1].stats.size;
                            }), t1;
                        }), {
                            create: function(e1, r) {
                                function o(e1, r) {
                                    var n = 0, a = 0, u = 32854;
                                    if ("object" == typeof e1 && e1 ? ("shape" in e1 ? (n = 0 | (a = e1.shape)[0], a = 0 | a[1]) : ("radius" in e1 && (n = a = 0 | e1.radius), "width" in e1 && (n = 0 | e1.width), "height" in e1 && (a = 0 | e1.height)), "format" in e1 && (u = s[e1.format])) : "number" == typeof e1 ? (n = 0 | e1, a = "number" == typeof r ? 0 | r : n) : e1 || (n = a = 1), n !== c.width || a !== c.height || u !== c.format) return o.width = c.width = n, o.height = c.height = a, c.format = u, t1.bindRenderbuffer(36161, c.renderbuffer), t1.renderbufferStorage(36161, u, n, a), i.profile && (c.stats.size = wt[c.format] * c.width * c.height), o.format = l[c.format], o;
                                }
                                var c = new a(t1.createRenderbuffer());
                                return u[c.id] = c, n.renderbufferCount++, o(e1, r), o.resize = function(e1, r) {
                                    var n = 0 | e1, a = 0 | r || n;
                                    return n === c.width && a === c.height || (o.width = c.width = n, o.height = c.height = a, t1.bindRenderbuffer(36161, c.renderbuffer), t1.renderbufferStorage(36161, c.format, n, a), i.profile && (c.stats.size = wt[c.format] * c.width * c.height)), o;
                                }, o._reglType = "renderbuffer", o._renderbuffer = c, i.profile && (o.stats = c.stats), o.destroy = function() {
                                    c.decRef();
                                }, o;
                            },
                            clear: function() {
                                Q(u).forEach(o);
                            },
                            restore: function() {
                                Q(u).forEach(function(e1) {
                                    e1.renderbuffer = t1.createRenderbuffer(), t1.bindRenderbuffer(36161, e1.renderbuffer), t1.renderbufferStorage(36161, e1.format, e1.width, e1.height);
                                }), t1.bindRenderbuffer(36161, null);
                            }
                        };
                    }, kt = [];
                    kt[6408] = 4, kt[6407] = 3;
                    var At = [];
                    At[5121] = 1, At[5126] = 4, At[36193] = 2;
                    var Mt = [
                        1116352408,
                        1899447441,
                        -1245643825,
                        -373957723,
                        961987163,
                        1508970993,
                        -1841331548,
                        -1424204075,
                        -670586216,
                        310598401,
                        607225278,
                        1426881987,
                        1925078388,
                        -2132889090,
                        -1680079193,
                        -1046744716,
                        -459576895,
                        -272742522,
                        264347078,
                        604807628,
                        770255983,
                        1249150122,
                        1555081692,
                        1996064986,
                        -1740746414,
                        -1473132947,
                        -1341970488,
                        -1084653625,
                        -958395405,
                        -710438585,
                        113926993,
                        338241895,
                        666307205,
                        773529912,
                        1294757372,
                        1396182291,
                        1695183700,
                        1986661051,
                        -2117940946,
                        -1838011259,
                        -1564481375,
                        -1474664885,
                        -1035236496,
                        -949202525,
                        -778901479,
                        -694614492,
                        -200395387,
                        275423344,
                        430227734,
                        506948616,
                        659060556,
                        883997877,
                        958139571,
                        1322822218,
                        1537002063,
                        1747873779,
                        1955562222,
                        2024104815,
                        -2067236844,
                        -1933114872,
                        -1866530822,
                        -1538233109,
                        -1090935817,
                        -965641998
                    ], St = [
                        "x",
                        "y",
                        "z",
                        "w"
                    ], Et = "blend.func blend.equation stencil.func stencil.opFront stencil.opBack sample.coverage viewport scissor.box polygonOffset.offset".split(" "), Ct = {
                        0: 0,
                        1: 1,
                        zero: 0,
                        one: 1,
                        "src color": 768,
                        "one minus src color": 769,
                        "src alpha": 770,
                        "one minus src alpha": 771,
                        "dst color": 774,
                        "one minus dst color": 775,
                        "dst alpha": 772,
                        "one minus dst alpha": 773,
                        "constant color": 32769,
                        "one minus constant color": 32770,
                        "constant alpha": 32771,
                        "one minus constant alpha": 32772,
                        "src alpha saturate": 776
                    }, Lt = {
                        never: 512,
                        less: 513,
                        "<": 513,
                        equal: 514,
                        "=": 514,
                        "==": 514,
                        "===": 514,
                        lequal: 515,
                        "<=": 515,
                        greater: 516,
                        ">": 516,
                        notequal: 517,
                        "!=": 517,
                        "!==": 517,
                        gequal: 518,
                        ">=": 518,
                        always: 519
                    }, It = {
                        0: 0,
                        zero: 0,
                        keep: 7680,
                        replace: 7681,
                        increment: 7682,
                        decrement: 7683,
                        "increment wrap": 34055,
                        "decrement wrap": 34056,
                        invert: 5386
                    }, Pt = {
                        cw: 2304,
                        ccw: 2305
                    }, zt = new N(!1, !1, !1, function() {});
                    return function(t1) {
                        function e1() {
                            if (0 === $.length) T && T.update(), et = null;
                            else {
                                et = Y.next(e1), h();
                                for(var t1 = $.length - 1; 0 <= t1; --t1){
                                    var r = $[t1];
                                    r && r(P, null, 0);
                                }
                                d.flush(), T && T.update();
                            }
                        }
                        function r() {
                            !et && 0 < $.length && (et = Y.next(e1));
                        }
                        function n() {
                            et && (Y.cancel(e1), et = null);
                        }
                        function i(t1) {
                            t1.preventDefault(), n(), K.forEach(function(t1) {
                                t1();
                            });
                        }
                        function o(t1) {
                            d.getError(), v.restore(), F.restore(), O.restore(), B.restore(), N.restore(), j.restore(), R.restore(), T && T.restore(), U.procs.refresh(), r(), Q.forEach(function(t1) {
                                t1();
                            });
                        }
                        function s(t1) {
                            function e1(t1, e1) {
                                var r = {}, n = {};
                                return Object.keys(t1).forEach(function(i) {
                                    var a = t1[i];
                                    if (W.isDynamic(a)) n[i] = W.unbox(a, i);
                                    else {
                                        if (e1 && Array.isArray(a)) {
                                            for(var o = 0; o < a.length; ++o)if (W.isDynamic(a[o])) return void (n[i] = W.unbox(a, i));
                                        }
                                        r[i] = a;
                                    }
                                }), {
                                    dynamic: n,
                                    static: r
                                };
                            }
                            var r = e1(t1.context || {}, !0), n = e1(t1.uniforms || {}, !0), i = e1(t1.attributes || {}, !1);
                            t1 = e1(function(t1) {
                                function e1(t1) {
                                    if (t1 in r) {
                                        var e1 = r[t1];
                                        delete r[t1], Object.keys(e1).forEach(function(n) {
                                            r[t1 + "." + n] = e1[n];
                                        });
                                    }
                                }
                                var r = G({}, t1);
                                return delete r.uniforms, delete r.attributes, delete r.context, delete r.vao, "stencil" in r && r.stencil.op && (r.stencil.opBack = r.stencil.opFront = r.stencil.op, delete r.stencil.op), e1("blend"), e1("depth"), e1("cull"), e1("stencil"), e1("polygonOffset"), e1("scissor"), e1("sample"), "vao" in t1 && (r.vao = t1.vao), r;
                            }(t1), !1);
                            var a = {
                                gpuTime: 0,
                                cpuTime: 0,
                                count: 0
                            }, o = U.compile(t1, i, n, r, a), s = o.draw, l = o.batch, c = o.scope, u = [];
                            return G(function(t1, e1) {
                                var r;
                                if ("function" == typeof t1) return c.call(this, null, t1, 0);
                                if ("function" == typeof e1) {
                                    if ("number" == typeof t1) for(r = 0; r < t1; ++r)c.call(this, null, e1, r);
                                    else {
                                        if (!Array.isArray(t1)) return c.call(this, t1, e1, 0);
                                        for(r = 0; r < t1.length; ++r)c.call(this, t1[r], e1, r);
                                    }
                                } else if ("number" == typeof t1) {
                                    if (0 < t1) return l.call(this, function(t1) {
                                        for(; u.length < t1;)u.push(null);
                                        return u;
                                    }(0 | t1), 0 | t1);
                                } else {
                                    if (!Array.isArray(t1)) return s.call(this, t1);
                                    if (t1.length) return l.call(this, t1, t1.length);
                                }
                            }, {
                                stats: a,
                                destroy: function() {
                                    o.destroy();
                                }
                            });
                        }
                        function l(t1, e1) {
                            var r = 0;
                            U.procs.poll();
                            var n = e1.color;
                            n && (d.clearColor(+n[0] || 0, +n[1] || 0, +n[2] || 0, +n[3] || 0), r |= 16384), "depth" in e1 && (d.clearDepth(+e1.depth), r |= 256), "stencil" in e1 && (d.clearStencil(0 | e1.stencil), r |= 1024), d.clear(r);
                        }
                        function c(t1) {
                            return $.push(t1), r(), {
                                cancel: function() {
                                    var e1 = H($, t1);
                                    $[e1] = function t1() {
                                        var e1 = H($, t1);
                                        $[e1] = $[$.length - 1], --$.length, 0 >= $.length && n();
                                    };
                                }
                            };
                        }
                        function u() {
                            var t1 = V.viewport, e1 = V.scissor_box;
                            t1[0] = t1[1] = e1[0] = e1[1] = 0, P.viewportWidth = P.framebufferWidth = P.drawingBufferWidth = t1[2] = e1[2] = d.drawingBufferWidth, P.viewportHeight = P.framebufferHeight = P.drawingBufferHeight = t1[3] = e1[3] = d.drawingBufferHeight;
                        }
                        function h() {
                            P.tick += 1, P.time = p(), u(), U.procs.poll();
                        }
                        function f() {
                            B.refresh(), u(), U.procs.refresh(), T && T.update();
                        }
                        function p() {
                            return (X() - k) / 1e3;
                        }
                        if (!(t1 = a(t1))) return null;
                        var d = t1.gl, y = d.getContextAttributes();
                        d.isContextLost();
                        var v = function(t1, e1) {
                            function r(e1) {
                                var r;
                                e1 = e1.toLowerCase();
                                try {
                                    r = n[e1] = t1.getExtension(e1);
                                } catch (t1) {}
                                return !!r;
                            }
                            for(var n = {}, i = 0; i < e1.extensions.length; ++i){
                                var a = e1.extensions[i];
                                if (!r(a)) return e1.onDestroy(), e1.onDone('"' + a + '" extension is not supported by the current WebGL context, try upgrading your system or a different browser'), null;
                            }
                            return e1.optionalExtensions.forEach(r), {
                                extensions: n,
                                restore: function() {
                                    Object.keys(n).forEach(function(t1) {
                                        if (n[t1] && !r(t1)) throw Error("(regl): error restoring extension " + t1);
                                    });
                                }
                            };
                        }(d, t1);
                        if (!v) return null;
                        var x = function() {
                            var t1 = {
                                "": 0
                            }, e1 = [
                                ""
                            ];
                            return {
                                id: function(r) {
                                    var n = t1[r];
                                    return n || (n = t1[r] = e1.length, e1.push(r), n);
                                },
                                str: function(t1) {
                                    return e1[t1];
                                }
                            };
                        }(), _ = {
                            vaoCount: 0,
                            bufferCount: 0,
                            elementsCount: 0,
                            framebufferCount: 0,
                            shaderCount: 0,
                            textureCount: 0,
                            cubeCount: 0,
                            renderbufferCount: 0,
                            maxTextureUnits: 0
                        }, b = t1.cachedCode || {}, w = v.extensions, T = function(t1, e1) {
                            function r() {
                                this.endQueryIndex = this.startQueryIndex = -1, this.sum = 0, this.stats = null;
                            }
                            function n(t1, e1, n) {
                                var i = o.pop() || new r;
                                i.startQueryIndex = t1, i.endQueryIndex = e1, i.sum = 0, i.stats = n, s.push(i);
                            }
                            if (!e1.ext_disjoint_timer_query) return null;
                            var i = [], a = [], o = [], s = [], l = [], c = [];
                            return {
                                beginQuery: function(t1) {
                                    var r = i.pop() || e1.ext_disjoint_timer_query.createQueryEXT();
                                    e1.ext_disjoint_timer_query.beginQueryEXT(35007, r), a.push(r), n(a.length - 1, a.length, t1);
                                },
                                endQuery: function() {
                                    e1.ext_disjoint_timer_query.endQueryEXT(35007);
                                },
                                pushScopeStats: n,
                                update: function() {
                                    var t1, r;
                                    if (0 !== (t1 = a.length)) {
                                        c.length = Math.max(c.length, t1 + 1), l.length = Math.max(l.length, t1 + 1), l[0] = 0;
                                        var n = c[0] = 0;
                                        for(r = t1 = 0; r < a.length; ++r){
                                            var u = a[r];
                                            e1.ext_disjoint_timer_query.getQueryObjectEXT(u, 34919) ? (n += e1.ext_disjoint_timer_query.getQueryObjectEXT(u, 34918), i.push(u)) : a[t1++] = u, l[r + 1] = n, c[r + 1] = t1;
                                        }
                                        for(a.length = t1, r = t1 = 0; r < s.length; ++r){
                                            var h = (n = s[r]).startQueryIndex;
                                            u = n.endQueryIndex, n.sum += l[u] - l[h], h = c[h], (u = c[u]) === h ? (n.stats.gpuTime += n.sum / 1e6, o.push(n)) : (n.startQueryIndex = h, n.endQueryIndex = u, s[t1++] = n);
                                        }
                                        s.length = t1;
                                    }
                                },
                                getNumPendingQueries: function() {
                                    return a.length;
                                },
                                clear: function() {
                                    i.push.apply(i, a);
                                    for(var t1 = 0; t1 < i.length; t1++)e1.ext_disjoint_timer_query.deleteQueryEXT(i[t1]);
                                    a.length = 0, i.length = 0;
                                },
                                restore: function() {
                                    a.length = 0, i.length = 0;
                                }
                            };
                        }(0, w), k = X(), A = d.drawingBufferWidth, E = d.drawingBufferHeight, P = {
                            tick: 0,
                            time: 0,
                            viewportWidth: A,
                            viewportHeight: E,
                            framebufferWidth: A,
                            framebufferHeight: E,
                            drawingBufferWidth: A,
                            drawingBufferHeight: E,
                            pixelRatio: t1.pixelRatio
                        }, z = (A = {
                            elements: null,
                            primitive: 4,
                            count: -1,
                            offset: 0,
                            instances: -1
                        }, J(d, w)), O = m(d, _, t1, function(t1) {
                            return R.destroyBuffer(t1);
                        }), D = g(d, w, O, _), R = C(d, w, z, _, O, D, A), F = L(d, x, _, t1), B = M(d, w, z, function() {
                            U.procs.poll();
                        }, P, _, t1), N = Tt(d, w, 0, _, t1), j = S(d, w, z, B, N, _), U = q(d, x, w, z, O, D, 0, j, {}, R, F, A, P, T, b, t1), V = (x = I(d, j, U.procs.poll, P), U.next), Z = d.canvas, $ = [], K = [], Q = [], tt = [
                            t1.onDestroy
                        ], et = null;
                        Z && (Z.addEventListener("webglcontextlost", i, !1), Z.addEventListener("webglcontextrestored", o, !1));
                        var rt = j.setFBO = s({
                            framebuffer: W.define.call(null, 1, "framebuffer")
                        });
                        return f(), y = G(s, {
                            clear: function(t1) {
                                if ("framebuffer" in t1) {
                                    if (t1.framebuffer && "framebufferCube" === t1.framebuffer_reglType) for(var e1 = 0; 6 > e1; ++e1)rt(G({
                                        framebuffer: t1.framebuffer.faces[e1]
                                    }, t1), l);
                                    else rt(t1, l);
                                } else l(0, t1);
                            },
                            prop: W.define.bind(null, 1),
                            context: W.define.bind(null, 2),
                            this: W.define.bind(null, 3),
                            draw: s({}),
                            buffer: function(t1) {
                                return O.create(t1, 34962, !1, !1);
                            },
                            elements: function(t1) {
                                return D.create(t1, !1);
                            },
                            texture: B.create2D,
                            cube: B.createCube,
                            renderbuffer: N.create,
                            framebuffer: j.create,
                            framebufferCube: j.createCube,
                            vao: R.createVAO,
                            attributes: y,
                            frame: c,
                            on: function(t1, e1) {
                                var r;
                                switch(t1){
                                    case "frame":
                                        return c(e1);
                                    case "lost":
                                        r = K;
                                        break;
                                    case "restore":
                                        r = Q;
                                        break;
                                    case "destroy":
                                        r = tt;
                                }
                                return r.push(e1), {
                                    cancel: function() {
                                        for(var t1 = 0; t1 < r.length; ++t1)if (r[t1] === e1) {
                                            r[t1] = r[r.length - 1], r.pop();
                                            break;
                                        }
                                    }
                                };
                            },
                            limits: z,
                            hasExtension: function(t1) {
                                return 0 <= z.extensions.indexOf(t1.toLowerCase());
                            },
                            read: x,
                            destroy: function() {
                                $.length = 0, n(), Z && (Z.removeEventListener("webglcontextlost", i), Z.removeEventListener("webglcontextrestored", o)), F.clear(), j.clear(), N.clear(), R.clear(), B.clear(), D.clear(), O.clear(), T && T.clear(), tt.forEach(function(t1) {
                                    t1();
                                });
                            },
                            _gl: d,
                            _refresh: f,
                            poll: function() {
                                h(), T && T.update();
                            },
                            now: p,
                            stats: _,
                            getCachedCode: function() {
                                return b;
                            },
                            preloadCachedCode: function(t1) {
                                Object.entries(t1).forEach(function(t1) {
                                    b[t1[0]] = t1[1];
                                });
                            }
                        }), t1.onDone(null, y), y;
                    };
                }();
            },
            41041: function(t1, e1, r) {
                var n = r(45708), i = n.Buffer;
                function a(t1, e1) {
                    for(var r in t1)e1[r] = t1[r];
                }
                function o(t1, e1, r) {
                    return i(t1, e1, r);
                }
                i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? t1.exports = n : (a(n, e1), e1.Buffer = o), o.prototype = Object.create(i.prototype), a(i, o), o.from = function(t1, e1, r) {
                    if ("number" == typeof t1) throw new TypeError("Argument must not be a number");
                    return i(t1, e1, r);
                }, o.alloc = function(t1, e1, r) {
                    if ("number" != typeof t1) throw new TypeError("Argument must be a number");
                    var n = i(t1);
                    return void 0 !== e1 ? "string" == typeof r ? n.fill(e1, r) : n.fill(e1) : n.fill(0), n;
                }, o.allocUnsafe = function(t1) {
                    if ("number" != typeof t1) throw new TypeError("Argument must be a number");
                    return i(t1);
                }, o.allocUnsafeSlow = function(t1) {
                    if ("number" != typeof t1) throw new TypeError("Argument must be a number");
                    return n.SlowBuffer(t1);
                };
            },
            73285: function(t1, e1, r) {
                "use strict";
                var n = r(71129), i = r(70973), a = r(74268)(), o = r(52991), s = r(48631), l = n("%Math.floor%");
                t1.exports = function(t1, e1) {
                    if ("function" != typeof t1) throw new s("`fn` is not a function");
                    if ("number" != typeof e1 || e1 < 0 || e1 > 4294967295 || l(e1) !== e1) throw new s("`length` must be a positive 32-bit integer");
                    var r = arguments.length > 2 && !!arguments[2], n = !0, c = !0;
                    if ("length" in t1 && o) {
                        var u = o(t1, "length");
                        u && !u.configurable && (n = !1), u && !u.writable && (c = !1);
                    }
                    return (n || c || !r) && (a ? i(t1, "length", e1, !0, !0) : i(t1, "length", e1)), t1;
                };
            },
            90386: function(t1, e1, r) {
                t1.exports = i;
                var n = r(7683).EventEmitter;
                function i() {
                    n.call(this);
                }
                r(28062)(i, n), i.Readable = r(44639), i.Writable = r(84627), i.Duplex = r(71977), i.Transform = r(40255), i.PassThrough = r(28765), i.finished = r(37165), i.pipeline = r(6772), i.Stream = i, i.prototype.pipe = function(t1, e1) {
                    var r = this;
                    function i(e1) {
                        t1.writable && !1 === t1.write(e1) && r.pause && r.pause();
                    }
                    function a() {
                        r.readable && r.resume && r.resume();
                    }
                    r.on("data", i), t1.on("drain", a), t1._isStdio || e1 && !1 === e1.end || (r.on("end", s), r.on("close", l));
                    var o = !1;
                    function s() {
                        o || (o = !0, t1.end());
                    }
                    function l() {
                        o || (o = !0, "function" == typeof t1.destroy && t1.destroy());
                    }
                    function c(t1) {
                        if (u(), 0 === n.listenerCount(this, "error")) throw t1;
                    }
                    function u() {
                        r.removeListener("data", i), t1.removeListener("drain", a), r.removeListener("end", s), r.removeListener("close", l), r.removeListener("error", c), t1.removeListener("error", c), r.removeListener("end", u), r.removeListener("close", u), t1.removeListener("close", u);
                    }
                    return r.on("error", c), t1.on("error", c), r.on("end", u), r.on("close", u), t1.on("close", u), t1.emit("pipe", r), t1;
                };
            },
            44059: function(t1) {
                "use strict";
                var e1 = {};
                function r(t1, r, n) {
                    n || (n = Error);
                    var i = function(t1) {
                        var e1, n;
                        function i(e1, n, i) {
                            return t1.call(this, function(t1, e1, n) {
                                return "string" == typeof r ? r : r(t1, e1, n);
                            }(e1, n, i)) || this;
                        }
                        return n = t1, (e1 = i).prototype = Object.create(n.prototype), e1.prototype.constructor = e1, e1.__proto__ = n, i;
                    }(n);
                    i.prototype.name = n.name, i.prototype.code = t1, e1[t1] = i;
                }
                function n(t1, e1) {
                    if (Array.isArray(t1)) {
                        var r = t1.length;
                        return t1 = t1.map(function(t1) {
                            return String(t1);
                        }), r > 2 ? "one of ".concat(e1, " ").concat(t1.slice(0, r - 1).join(", "), ", or ") + t1[r - 1] : 2 === r ? "one of ".concat(e1, " ").concat(t1[0], " or ").concat(t1[1]) : "of ".concat(e1, " ").concat(t1[0]);
                    }
                    return "of ".concat(e1, " ").concat(String(t1));
                }
                r("ERR_INVALID_OPT_VALUE", function(t1, e1) {
                    return 'The value "' + e1 + '" is invalid for option "' + t1 + '"';
                }, TypeError), r("ERR_INVALID_ARG_TYPE", function(t1, e1, r) {
                    var i, a, o, s, l;
                    if ("string" == typeof e1 && (a = "not ", e1.substr(0, 4) === a) ? (i = "must not be", e1 = e1.replace(/^not /, "")) : i = "must be", function(t1, e1, r) {
                        return (void 0 === r || r > t1.length) && (r = t1.length), t1.substring(r - 9, r) === e1;
                    }(t1, " argument")) o = "The ".concat(t1, " ").concat(i, " ").concat(n(e1, "type"));
                    else {
                        var c = ("number" != typeof l && (l = 0), l + 1 > (s = t1).length || -1 === s.indexOf(".", l) ? "argument" : "property");
                        o = 'The "'.concat(t1, '" ').concat(c, " ").concat(i, " ").concat(n(e1, "type"));
                    }
                    return o + ". Received type ".concat(typeof r);
                }, TypeError), r("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), r("ERR_METHOD_NOT_IMPLEMENTED", function(t1) {
                    return "The " + t1 + " method is not implemented";
                }), r("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), r("ERR_STREAM_DESTROYED", function(t1) {
                    return "Cannot call " + t1 + " after a stream was destroyed";
                }), r("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), r("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), r("ERR_STREAM_WRITE_AFTER_END", "write after end"), r("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), r("ERR_UNKNOWN_ENCODING", function(t1) {
                    return "Unknown encoding: " + t1;
                }, TypeError), r("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), t1.exports.F = e1;
            },
            71977: function(t1, e1, r) {
                "use strict";
                var n = r(33282), i = Object.keys || function(t1) {
                    var e1 = [];
                    for(var r in t1)e1.push(r);
                    return e1;
                };
                t1.exports = u;
                var a = r(44639), o = r(84627);
                r(28062)(u, a);
                for(var s = i(o.prototype), l = 0; l < s.length; l++){
                    var c = s[l];
                    u.prototype[c] || (u.prototype[c] = o.prototype[c]);
                }
                function u(t1) {
                    if (!(this instanceof u)) return new u(t1);
                    a.call(this, t1), o.call(this, t1), this.allowHalfOpen = !0, t1 && (!1 === t1.readable && (this.readable = !1), !1 === t1.writable && (this.writable = !1), !1 === t1.allowHalfOpen && (this.allowHalfOpen = !1, this.once("end", h)));
                }
                function h() {
                    this._writableState.ended || n.nextTick(f, this);
                }
                function f(t1) {
                    t1.end();
                }
                Object.defineProperty(u.prototype, "writableHighWaterMark", {
                    enumerable: !1,
                    get: function() {
                        return this._writableState.highWaterMark;
                    }
                }), Object.defineProperty(u.prototype, "writableBuffer", {
                    enumerable: !1,
                    get: function() {
                        return this._writableState && this._writableState.getBuffer();
                    }
                }), Object.defineProperty(u.prototype, "writableLength", {
                    enumerable: !1,
                    get: function() {
                        return this._writableState.length;
                    }
                }), Object.defineProperty(u.prototype, "destroyed", {
                    enumerable: !1,
                    get: function() {
                        return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
                    },
                    set: function(t1) {
                        void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = t1, this._writableState.destroyed = t1);
                    }
                });
            },
            28765: function(t1, e1, r) {
                "use strict";
                t1.exports = i;
                var n = r(40255);
                function i(t1) {
                    if (!(this instanceof i)) return new i(t1);
                    n.call(this, t1);
                }
                r(28062)(i, n), i.prototype._transform = function(t1, e1, r) {
                    r(null, t1);
                };
            },
            44639: function(t1, e1, r) {
                "use strict";
                var n, i = r(33282);
                t1.exports = A, A.ReadableState = k, r(7683).EventEmitter;
                var a, o = function(t1, e1) {
                    return t1.listeners(e1).length;
                }, s = r(60032), l = r(45708).Buffer, c = r.g.Uint8Array || function() {}, u = r(77199);
                a = u && u.debuglog ? u.debuglog("stream") : function() {};
                var h, f, p, d = r(29930), m = r(52023), g = r(31976).getHighWaterMark, y = r(44059).F, v = y.ERR_INVALID_ARG_TYPE, x = y.ERR_STREAM_PUSH_AFTER_EOF, _ = y.ERR_METHOD_NOT_IMPLEMENTED, b = y.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
                r(28062)(A, s);
                var w = m.errorOrDestroy, T = [
                    "error",
                    "close",
                    "destroy",
                    "pause",
                    "resume"
                ];
                function k(t1, e1, i) {
                    n = n || r(71977), t1 = t1 || {}, "boolean" != typeof i && (i = e1 instanceof n), this.objectMode = !!t1.objectMode, i && (this.objectMode = this.objectMode || !!t1.readableObjectMode), this.highWaterMark = g(this, t1, "readableHighWaterMark", i), this.buffer = new d, this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = !1 !== t1.emitClose, this.autoDestroy = !!t1.autoDestroy, this.destroyed = !1, this.defaultEncoding = t1.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, t1.encoding && (h || (h = r(54304).I), this.decoder = new h(t1.encoding), this.encoding = t1.encoding);
                }
                function A(t1) {
                    if (n = n || r(71977), !(this instanceof A)) return new A(t1);
                    var e1 = this instanceof n;
                    this._readableState = new k(t1, this, e1), this.readable = !0, t1 && ("function" == typeof t1.read && (this._read = t1.read), "function" == typeof t1.destroy && (this._destroy = t1.destroy)), s.call(this);
                }
                function M(t1, e1, r, n, i) {
                    a("readableAddChunk", e1);
                    var o, s = t1._readableState;
                    if (null === e1) s.reading = !1, function(t1, e1) {
                        if (a("onEofChunk"), !e1.ended) {
                            if (e1.decoder) {
                                var r = e1.decoder.end();
                                r && r.length && (e1.buffer.push(r), e1.length += e1.objectMode ? 1 : r.length);
                            }
                            e1.ended = !0, e1.sync ? L(t1) : (e1.needReadable = !1, e1.emittedReadable || (e1.emittedReadable = !0, I(t1)));
                        }
                    }(t1, s);
                    else if (i || (o = function(t1, e1) {
                        var r, n;
                        return n = e1, l.isBuffer(n) || n instanceof c || "string" == typeof e1 || void 0 === e1 || t1.objectMode || (r = new v("chunk", [
                            "string",
                            "Buffer",
                            "Uint8Array"
                        ], e1)), r;
                    }(s, e1)), o) w(t1, o);
                    else if (s.objectMode || e1 && e1.length > 0) {
                        if ("string" == typeof e1 || s.objectMode || Object.getPrototypeOf(e1) === l.prototype || (e1 = function(t1) {
                            return l.from(t1);
                        }(e1)), n) s.endEmitted ? w(t1, new b) : S(t1, s, e1, !0);
                        else if (s.ended) w(t1, new x);
                        else {
                            if (s.destroyed) return !1;
                            s.reading = !1, s.decoder && !r ? (e1 = s.decoder.write(e1), s.objectMode || 0 !== e1.length ? S(t1, s, e1, !1) : P(t1, s)) : S(t1, s, e1, !1);
                        }
                    } else n || (s.reading = !1, P(t1, s));
                    return !s.ended && (s.length < s.highWaterMark || 0 === s.length);
                }
                function S(t1, e1, r, n) {
                    e1.flowing && 0 === e1.length && !e1.sync ? (e1.awaitDrain = 0, t1.emit("data", r)) : (e1.length += e1.objectMode ? 1 : r.length, n ? e1.buffer.unshift(r) : e1.buffer.push(r), e1.needReadable && L(t1)), P(t1, e1);
                }
                Object.defineProperty(A.prototype, "destroyed", {
                    enumerable: !1,
                    get: function() {
                        return void 0 !== this._readableState && this._readableState.destroyed;
                    },
                    set: function(t1) {
                        this._readableState && (this._readableState.destroyed = t1);
                    }
                }), A.prototype.destroy = m.destroy, A.prototype._undestroy = m.undestroy, A.prototype._destroy = function(t1, e1) {
                    e1(t1);
                }, A.prototype.push = function(t1, e1) {
                    var r, n = this._readableState;
                    return n.objectMode ? r = !0 : "string" == typeof t1 && ((e1 = e1 || n.defaultEncoding) !== n.encoding && (t1 = l.from(t1, e1), e1 = ""), r = !0), M(this, t1, e1, !1, r);
                }, A.prototype.unshift = function(t1) {
                    return M(this, t1, null, !0, !1);
                }, A.prototype.isPaused = function() {
                    return !1 === this._readableState.flowing;
                }, A.prototype.setEncoding = function(t1) {
                    h || (h = r(54304).I);
                    var e1 = new h(t1);
                    this._readableState.decoder = e1, this._readableState.encoding = this._readableState.decoder.encoding;
                    for(var n = this._readableState.buffer.head, i = ""; null !== n;)i += e1.write(n.data), n = n.next;
                    return this._readableState.buffer.clear(), "" !== i && this._readableState.buffer.push(i), this._readableState.length = i.length, this;
                };
                var E = 1073741824;
                function C(t1, e1) {
                    return t1 <= 0 || 0 === e1.length && e1.ended ? 0 : e1.objectMode ? 1 : t1 != t1 ? e1.flowing && e1.length ? e1.buffer.head.data.length : e1.length : (t1 > e1.highWaterMark && (e1.highWaterMark = function(t1) {
                        return t1 >= E ? t1 = E : (t1--, t1 |= t1 >>> 1, t1 |= t1 >>> 2, t1 |= t1 >>> 4, t1 |= t1 >>> 8, t1 |= t1 >>> 16, t1++), t1;
                    }(t1)), t1 <= e1.length ? t1 : e1.ended ? e1.length : (e1.needReadable = !0, 0));
                }
                function L(t1) {
                    var e1 = t1._readableState;
                    a("emitReadable", e1.needReadable, e1.emittedReadable), e1.needReadable = !1, e1.emittedReadable || (a("emitReadable", e1.flowing), e1.emittedReadable = !0, i.nextTick(I, t1));
                }
                function I(t1) {
                    var e1 = t1._readableState;
                    a("emitReadable_", e1.destroyed, e1.length, e1.ended), e1.destroyed || !e1.length && !e1.ended || (t1.emit("readable"), e1.emittedReadable = !1), e1.needReadable = !e1.flowing && !e1.ended && e1.length <= e1.highWaterMark, F(t1);
                }
                function P(t1, e1) {
                    e1.readingMore || (e1.readingMore = !0, i.nextTick(z, t1, e1));
                }
                function z(t1, e1) {
                    for(; !e1.reading && !e1.ended && (e1.length < e1.highWaterMark || e1.flowing && 0 === e1.length);){
                        var r = e1.length;
                        if (a("maybeReadMore read 0"), t1.read(0), r === e1.length) break;
                    }
                    e1.readingMore = !1;
                }
                function O(t1) {
                    var e1 = t1._readableState;
                    e1.readableListening = t1.listenerCount("readable") > 0, e1.resumeScheduled && !e1.paused ? e1.flowing = !0 : t1.listenerCount("data") > 0 && t1.resume();
                }
                function D(t1) {
                    a("readable nexttick read 0"), t1.read(0);
                }
                function R(t1, e1) {
                    a("resume", e1.reading), e1.reading || t1.read(0), e1.resumeScheduled = !1, t1.emit("resume"), F(t1), e1.flowing && !e1.reading && t1.read(0);
                }
                function F(t1) {
                    var e1 = t1._readableState;
                    for(a("flow", e1.flowing); e1.flowing && null !== t1.read(););
                }
                function B(t1, e1) {
                    var r;
                    return 0 === e1.length ? null : (e1.objectMode ? r = e1.buffer.shift() : !t1 || t1 >= e1.length ? (r = e1.decoder ? e1.buffer.join("") : 1 === e1.buffer.length ? e1.buffer.first() : e1.buffer.concat(e1.length), e1.buffer.clear()) : r = e1.buffer.consume(t1, e1.decoder), r);
                }
                function N(t1) {
                    var e1 = t1._readableState;
                    a("endReadable", e1.endEmitted), e1.endEmitted || (e1.ended = !0, i.nextTick(j, e1, t1));
                }
                function j(t1, e1) {
                    if (a("endReadableNT", t1.endEmitted, t1.length), !t1.endEmitted && 0 === t1.length && (t1.endEmitted = !0, e1.readable = !1, e1.emit("end"), t1.autoDestroy)) {
                        var r = e1._writableState;
                        (!r || r.autoDestroy && r.finished) && e1.destroy();
                    }
                }
                function U(t1, e1) {
                    for(var r = 0, n = t1.length; r < n; r++)if (t1[r] === e1) return r;
                    return -1;
                }
                A.prototype.read = function(t1) {
                    a("read", t1), t1 = parseInt(t1, 10);
                    var e1 = this._readableState, r = t1;
                    if (0 !== t1 && (e1.emittedReadable = !1), 0 === t1 && e1.needReadable && ((0 !== e1.highWaterMark ? e1.length >= e1.highWaterMark : e1.length > 0) || e1.ended)) return a("read: emitReadable", e1.length, e1.ended), 0 === e1.length && e1.ended ? N(this) : L(this), null;
                    if (0 === (t1 = C(t1, e1)) && e1.ended) return 0 === e1.length && N(this), null;
                    var n, i = e1.needReadable;
                    return a("need readable", i), (0 === e1.length || e1.length - t1 < e1.highWaterMark) && a("length less than watermark", i = !0), e1.ended || e1.reading ? a("reading or ended", i = !1) : i && (a("do read"), e1.reading = !0, e1.sync = !0, 0 === e1.length && (e1.needReadable = !0), this._read(e1.highWaterMark), e1.sync = !1, e1.reading || (t1 = C(r, e1))), null === (n = t1 > 0 ? B(t1, e1) : null) ? (e1.needReadable = e1.length <= e1.highWaterMark, t1 = 0) : (e1.length -= t1, e1.awaitDrain = 0), 0 === e1.length && (e1.ended || (e1.needReadable = !0), r !== t1 && e1.ended && N(this)), null !== n && this.emit("data", n), n;
                }, A.prototype._read = function(t1) {
                    w(this, new _("_read()"));
                }, A.prototype.pipe = function(t1, e1) {
                    var r = this, n = this._readableState;
                    switch(n.pipesCount){
                        case 0:
                            n.pipes = t1;
                            break;
                        case 1:
                            n.pipes = [
                                n.pipes,
                                t1
                            ];
                            break;
                        default:
                            n.pipes.push(t1);
                    }
                    n.pipesCount += 1, a("pipe count=%d opts=%j", n.pipesCount, e1);
                    var s = e1 && !1 === e1.end || t1 === i.stdout || t1 === i.stderr ? m : l;
                    function l() {
                        a("onend"), t1.end();
                    }
                    n.endEmitted ? i.nextTick(s) : r.once("end", s), t1.on("unpipe", function e1(i, o) {
                        a("onunpipe"), i === r && o && !1 === o.hasUnpiped && (o.hasUnpiped = !0, a("cleanup"), t1.removeListener("close", p), t1.removeListener("finish", d), t1.removeListener("drain", c), t1.removeListener("error", f), t1.removeListener("unpipe", e1), r.removeListener("end", l), r.removeListener("end", m), r.removeListener("data", h), u = !0, !n.awaitDrain || t1._writableState && !t1._writableState.needDrain || c());
                    });
                    var c = function(t1) {
                        return function() {
                            var e1 = t1._readableState;
                            a("pipeOnDrain", e1.awaitDrain), e1.awaitDrain && e1.awaitDrain--, 0 === e1.awaitDrain && o(t1, "data") && (e1.flowing = !0, F(t1));
                        };
                    }(r);
                    t1.on("drain", c);
                    var u = !1;
                    function h(e1) {
                        a("ondata");
                        var i = t1.write(e1);
                        a("dest.write", i), !1 === i && ((1 === n.pipesCount && n.pipes === t1 || n.pipesCount > 1 && -1 !== U(n.pipes, t1)) && !u && (a("false write response, pause", n.awaitDrain), n.awaitDrain++), r.pause());
                    }
                    function f(e1) {
                        a("onerror", e1), m(), t1.removeListener("error", f), 0 === o(t1, "error") && w(t1, e1);
                    }
                    function p() {
                        t1.removeListener("finish", d), m();
                    }
                    function d() {
                        a("onfinish"), t1.removeListener("close", p), m();
                    }
                    function m() {
                        a("unpipe"), r.unpipe(t1);
                    }
                    return r.on("data", h), function(t1, e1, r) {
                        if ("function" == typeof t1.prependListener) return t1.prependListener(e1, r);
                        t1._events && t1._events[e1] ? Array.isArray(t1._events[e1]) ? t1._events[e1].unshift(r) : t1._events[e1] = [
                            r,
                            t1._events[e1]
                        ] : t1.on(e1, r);
                    }(t1, "error", f), t1.once("close", p), t1.once("finish", d), t1.emit("pipe", r), n.flowing || (a("pipe resume"), r.resume()), t1;
                }, A.prototype.unpipe = function(t1) {
                    var e1 = this._readableState, r = {
                        hasUnpiped: !1
                    };
                    if (0 === e1.pipesCount) return this;
                    if (1 === e1.pipesCount) return t1 && t1 !== e1.pipes || (t1 || (t1 = e1.pipes), e1.pipes = null, e1.pipesCount = 0, e1.flowing = !1, t1 && t1.emit("unpipe", this, r)), this;
                    if (!t1) {
                        var n = e1.pipes, i = e1.pipesCount;
                        e1.pipes = null, e1.pipesCount = 0, e1.flowing = !1;
                        for(var a = 0; a < i; a++)n[a].emit("unpipe", this, {
                            hasUnpiped: !1
                        });
                        return this;
                    }
                    var o = U(e1.pipes, t1);
                    return -1 === o || (e1.pipes.splice(o, 1), e1.pipesCount -= 1, 1 === e1.pipesCount && (e1.pipes = e1.pipes[0]), t1.emit("unpipe", this, r)), this;
                }, A.prototype.on = function(t1, e1) {
                    var r = s.prototype.on.call(this, t1, e1), n = this._readableState;
                    return "data" === t1 ? (n.readableListening = this.listenerCount("readable") > 0, !1 !== n.flowing && this.resume()) : "readable" === t1 && (n.endEmitted || n.readableListening || (n.readableListening = n.needReadable = !0, n.flowing = !1, n.emittedReadable = !1, a("on readable", n.length, n.reading), n.length ? L(this) : n.reading || i.nextTick(D, this))), r;
                }, A.prototype.addListener = A.prototype.on, A.prototype.removeListener = function(t1, e1) {
                    var r = s.prototype.removeListener.call(this, t1, e1);
                    return "readable" === t1 && i.nextTick(O, this), r;
                }, A.prototype.removeAllListeners = function(t1) {
                    var e1 = s.prototype.removeAllListeners.apply(this, arguments);
                    return "readable" !== t1 && void 0 !== t1 || i.nextTick(O, this), e1;
                }, A.prototype.resume = function() {
                    var t1 = this._readableState;
                    return t1.flowing || (a("resume"), t1.flowing = !t1.readableListening, function(t1, e1) {
                        e1.resumeScheduled || (e1.resumeScheduled = !0, i.nextTick(R, t1, e1));
                    }(this, t1)), t1.paused = !1, this;
                }, A.prototype.pause = function() {
                    return a("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (a("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
                }, A.prototype.wrap = function(t1) {
                    var e1 = this, r = this._readableState, n = !1;
                    for(var i in t1.on("end", function() {
                        if (a("wrapped end"), r.decoder && !r.ended) {
                            var t1 = r.decoder.end();
                            t1 && t1.length && e1.push(t1);
                        }
                        e1.push(null);
                    }), t1.on("data", function(i) {
                        a("wrapped data"), r.decoder && (i = r.decoder.write(i)), r.objectMode && null == i || (r.objectMode || i && i.length) && (e1.push(i) || (n = !0, t1.pause()));
                    }), t1)void 0 === this[i] && "function" == typeof t1[i] && (this[i] = function(e1) {
                        return function() {
                            return t1[e1].apply(t1, arguments);
                        };
                    }(i));
                    for(var o = 0; o < T.length; o++)t1.on(T[o], this.emit.bind(this, T[o]));
                    return this._read = function(e1) {
                        a("wrapped _read", e1), n && (n = !1, t1.resume());
                    }, this;
                }, "function" == typeof Symbol && (A.prototype[Symbol.asyncIterator] = function() {
                    return void 0 === f && (f = r(73726)), f(this);
                }), Object.defineProperty(A.prototype, "readableHighWaterMark", {
                    enumerable: !1,
                    get: function() {
                        return this._readableState.highWaterMark;
                    }
                }), Object.defineProperty(A.prototype, "readableBuffer", {
                    enumerable: !1,
                    get: function() {
                        return this._readableState && this._readableState.buffer;
                    }
                }), Object.defineProperty(A.prototype, "readableFlowing", {
                    enumerable: !1,
                    get: function() {
                        return this._readableState.flowing;
                    },
                    set: function(t1) {
                        this._readableState && (this._readableState.flowing = t1);
                    }
                }), A._fromList = B, Object.defineProperty(A.prototype, "readableLength", {
                    enumerable: !1,
                    get: function() {
                        return this._readableState.length;
                    }
                }), "function" == typeof Symbol && (A.from = function(t1, e1) {
                    return void 0 === p && (p = r(37108)), p(A, t1, e1);
                });
            },
            40255: function(t1, e1, r) {
                "use strict";
                t1.exports = u;
                var n = r(44059).F, i = n.ERR_METHOD_NOT_IMPLEMENTED, a = n.ERR_MULTIPLE_CALLBACK, o = n.ERR_TRANSFORM_ALREADY_TRANSFORMING, s = n.ERR_TRANSFORM_WITH_LENGTH_0, l = r(71977);
                function c(t1, e1) {
                    var r = this._transformState;
                    r.transforming = !1;
                    var n = r.writecb;
                    if (null === n) return this.emit("error", new a);
                    r.writechunk = null, r.writecb = null, null != e1 && this.push(e1), n(t1);
                    var i = this._readableState;
                    i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                }
                function u(t1) {
                    if (!(this instanceof u)) return new u(t1);
                    l.call(this, t1), this._transformState = {
                        afterTransform: c.bind(this),
                        needTransform: !1,
                        transforming: !1,
                        writecb: null,
                        writechunk: null,
                        writeencoding: null
                    }, this._readableState.needReadable = !0, this._readableState.sync = !1, t1 && ("function" == typeof t1.transform && (this._transform = t1.transform), "function" == typeof t1.flush && (this._flush = t1.flush)), this.on("prefinish", h);
                }
                function h() {
                    var t1 = this;
                    "function" != typeof this._flush || this._readableState.destroyed ? f(this, null, null) : this._flush(function(e1, r) {
                        f(t1, e1, r);
                    });
                }
                function f(t1, e1, r) {
                    if (e1) return t1.emit("error", e1);
                    if (null != r && t1.push(r), t1._writableState.length) throw new s;
                    if (t1._transformState.transforming) throw new o;
                    return t1.push(null);
                }
                r(28062)(u, l), u.prototype.push = function(t1, e1) {
                    return this._transformState.needTransform = !1, l.prototype.push.call(this, t1, e1);
                }, u.prototype._transform = function(t1, e1, r) {
                    r(new i("_transform()"));
                }, u.prototype._write = function(t1, e1, r) {
                    var n = this._transformState;
                    if (n.writecb = r, n.writechunk = t1, n.writeencoding = e1, !n.transforming) {
                        var i = this._readableState;
                        (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                    }
                }, u.prototype._read = function(t1) {
                    var e1 = this._transformState;
                    null === e1.writechunk || e1.transforming ? e1.needTransform = !0 : (e1.transforming = !0, this._transform(e1.writechunk, e1.writeencoding, e1.afterTransform));
                }, u.prototype._destroy = function(t1, e1) {
                    l.prototype._destroy.call(this, t1, function(t1) {
                        e1(t1);
                    });
                };
            },
            84627: function(t1, e1, r) {
                "use strict";
                var n, i = r(33282);
                function a(t1) {
                    var e1 = this;
                    this.next = null, this.entry = null, this.finish = function() {
                        !function(t1, e1, r) {
                            var n = t1.entry;
                            for(t1.entry = null; n;){
                                var i = n.callback;
                                e1.pendingcb--, i(undefined), n = n.next;
                            }
                            e1.corkedRequestsFree.next = t1;
                        }(e1, t1);
                    };
                }
                t1.exports = A, A.WritableState = k;
                var o, s = {
                    deprecate: r(71103)
                }, l = r(60032), c = r(45708).Buffer, u = r.g.Uint8Array || function() {}, h = r(52023), f = r(31976).getHighWaterMark, p = r(44059).F, d = p.ERR_INVALID_ARG_TYPE, m = p.ERR_METHOD_NOT_IMPLEMENTED, g = p.ERR_MULTIPLE_CALLBACK, y = p.ERR_STREAM_CANNOT_PIPE, v = p.ERR_STREAM_DESTROYED, x = p.ERR_STREAM_NULL_VALUES, _ = p.ERR_STREAM_WRITE_AFTER_END, b = p.ERR_UNKNOWN_ENCODING, w = h.errorOrDestroy;
                function T() {}
                function k(t1, e1, o) {
                    n = n || r(71977), t1 = t1 || {}, "boolean" != typeof o && (o = e1 instanceof n), this.objectMode = !!t1.objectMode, o && (this.objectMode = this.objectMode || !!t1.writableObjectMode), this.highWaterMark = f(this, t1, "writableHighWaterMark", o), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
                    var s = !1 === t1.decodeStrings;
                    this.decodeStrings = !s, this.defaultEncoding = t1.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(t1) {
                        !function(t1, e1) {
                            var r = t1._writableState, n = r.sync, a = r.writecb;
                            if ("function" != typeof a) throw new g;
                            if (function(t1) {
                                t1.writing = !1, t1.writecb = null, t1.length -= t1.writelen, t1.writelen = 0;
                            }(r), e1) !function(t1, e1, r, n, a) {
                                --e1.pendingcb, r ? (i.nextTick(a, n), i.nextTick(I, t1, e1), t1._writableState.errorEmitted = !0, w(t1, n)) : (a(n), t1._writableState.errorEmitted = !0, w(t1, n), I(t1, e1));
                            }(t1, r, n, e1, a);
                            else {
                                var o = C(r) || t1.destroyed;
                                o || r.corked || r.bufferProcessing || !r.bufferedRequest || E(t1, r), n ? i.nextTick(S, t1, r, o, a) : S(t1, r, o, a);
                            }
                        }(e1, t1);
                    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = !1 !== t1.emitClose, this.autoDestroy = !!t1.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new a(this);
                }
                function A(t1) {
                    var e1 = this instanceof (n = n || r(71977));
                    if (!e1 && !o.call(A, this)) return new A(t1);
                    this._writableState = new k(t1, this, e1), this.writable = !0, t1 && ("function" == typeof t1.write && (this._write = t1.write), "function" == typeof t1.writev && (this._writev = t1.writev), "function" == typeof t1.destroy && (this._destroy = t1.destroy), "function" == typeof t1.final && (this._final = t1.final)), l.call(this);
                }
                function M(t1, e1, r, n, i, a, o) {
                    e1.writelen = n, e1.writecb = o, e1.writing = !0, e1.sync = !0, e1.destroyed ? e1.onwrite(new v("write")) : r ? t1._writev(i, e1.onwrite) : t1._write(i, a, e1.onwrite), e1.sync = !1;
                }
                function S(t1, e1, r, n) {
                    r || function(t1, e1) {
                        0 === e1.length && e1.needDrain && (e1.needDrain = !1, t1.emit("drain"));
                    }(t1, e1), e1.pendingcb--, n(), I(t1, e1);
                }
                function E(t1, e1) {
                    e1.bufferProcessing = !0;
                    var r = e1.bufferedRequest;
                    if (t1._writev && r && r.next) {
                        var n = e1.bufferedRequestCount, i = new Array(n), o = e1.corkedRequestsFree;
                        o.entry = r;
                        for(var s = 0, l = !0; r;)i[s] = r, r.isBuf || (l = !1), r = r.next, s += 1;
                        i.allBuffers = l, M(t1, e1, !0, e1.length, i, "", o.finish), e1.pendingcb++, e1.lastBufferedRequest = null, o.next ? (e1.corkedRequestsFree = o.next, o.next = null) : e1.corkedRequestsFree = new a(e1), e1.bufferedRequestCount = 0;
                    } else {
                        for(; r;){
                            var c = r.chunk, u = r.encoding, h = r.callback;
                            if (M(t1, e1, !1, e1.objectMode ? 1 : c.length, c, u, h), r = r.next, e1.bufferedRequestCount--, e1.writing) break;
                        }
                        null === r && (e1.lastBufferedRequest = null);
                    }
                    e1.bufferedRequest = r, e1.bufferProcessing = !1;
                }
                function C(t1) {
                    return t1.ending && 0 === t1.length && null === t1.bufferedRequest && !t1.finished && !t1.writing;
                }
                function L(t1, e1) {
                    t1._final(function(r) {
                        e1.pendingcb--, r && w(t1, r), e1.prefinished = !0, t1.emit("prefinish"), I(t1, e1);
                    });
                }
                function I(t1, e1) {
                    var r = C(e1);
                    if (r && (function(t1, e1) {
                        e1.prefinished || e1.finalCalled || ("function" != typeof t1._final || e1.destroyed ? (e1.prefinished = !0, t1.emit("prefinish")) : (e1.pendingcb++, e1.finalCalled = !0, i.nextTick(L, t1, e1)));
                    }(t1, e1), 0 === e1.pendingcb && (e1.finished = !0, t1.emit("finish"), e1.autoDestroy))) {
                        var n = t1._readableState;
                        (!n || n.autoDestroy && n.endEmitted) && t1.destroy();
                    }
                    return r;
                }
                r(28062)(A, l), k.prototype.getBuffer = function() {
                    for(var t1 = this.bufferedRequest, e1 = []; t1;)e1.push(t1), t1 = t1.next;
                    return e1;
                }, function() {
                    try {
                        Object.defineProperty(k.prototype, "buffer", {
                            get: s.deprecate(function() {
                                return this.getBuffer();
                            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
                        });
                    } catch (t1) {}
                }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (o = Function.prototype[Symbol.hasInstance], Object.defineProperty(A, Symbol.hasInstance, {
                    value: function(t1) {
                        return !!o.call(this, t1) || this === A && t1 && t1._writableState instanceof k;
                    }
                })) : o = function(t1) {
                    return t1 instanceof this;
                }, A.prototype.pipe = function() {
                    w(this, new y);
                }, A.prototype.write = function(t1, e1, r) {
                    var n, a = this._writableState, o = !1, s = !a.objectMode && (n = t1, c.isBuffer(n) || n instanceof u);
                    return s && !c.isBuffer(t1) && (t1 = function(t1) {
                        return c.from(t1);
                    }(t1)), "function" == typeof e1 && (r = e1, e1 = null), s ? e1 = "buffer" : e1 || (e1 = a.defaultEncoding), "function" != typeof r && (r = T), a.ending ? function(t1, e1) {
                        var r = new _;
                        w(t1, r), i.nextTick(e1, r);
                    }(this, r) : (s || function(t1, e1, r, n) {
                        var a;
                        return null === r ? a = new x : "string" == typeof r || e1.objectMode || (a = new d("chunk", [
                            "string",
                            "Buffer"
                        ], r)), !a || (w(t1, a), i.nextTick(n, a), !1);
                    }(this, a, t1, r)) && (a.pendingcb++, o = function(t1, e1, r, n, i, a) {
                        if (!r) {
                            var o = function(t1, e1, r) {
                                return t1.objectMode || !1 === t1.decodeStrings || "string" != typeof e1 || (e1 = c.from(e1, r)), e1;
                            }(e1, n, i);
                            n !== o && (r = !0, i = "buffer", n = o);
                        }
                        var s = e1.objectMode ? 1 : n.length;
                        e1.length += s;
                        var l = e1.length < e1.highWaterMark;
                        if (l || (e1.needDrain = !0), e1.writing || e1.corked) {
                            var u = e1.lastBufferedRequest;
                            e1.lastBufferedRequest = {
                                chunk: n,
                                encoding: i,
                                isBuf: r,
                                callback: a,
                                next: null
                            }, u ? u.next = e1.lastBufferedRequest : e1.bufferedRequest = e1.lastBufferedRequest, e1.bufferedRequestCount += 1;
                        } else M(t1, e1, !1, s, n, i, a);
                        return l;
                    }(this, a, s, t1, e1, r)), o;
                }, A.prototype.cork = function() {
                    this._writableState.corked++;
                }, A.prototype.uncork = function() {
                    var t1 = this._writableState;
                    t1.corked && (t1.corked--, t1.writing || t1.corked || t1.bufferProcessing || !t1.bufferedRequest || E(this, t1));
                }, A.prototype.setDefaultEncoding = function(t1) {
                    if ("string" == typeof t1 && (t1 = t1.toLowerCase()), !([
                        "hex",
                        "utf8",
                        "utf-8",
                        "ascii",
                        "binary",
                        "base64",
                        "ucs2",
                        "ucs-2",
                        "utf16le",
                        "utf-16le",
                        "raw"
                    ].indexOf((t1 + "").toLowerCase()) > -1)) throw new b(t1);
                    return this._writableState.defaultEncoding = t1, this;
                }, Object.defineProperty(A.prototype, "writableBuffer", {
                    enumerable: !1,
                    get: function() {
                        return this._writableState && this._writableState.getBuffer();
                    }
                }), Object.defineProperty(A.prototype, "writableHighWaterMark", {
                    enumerable: !1,
                    get: function() {
                        return this._writableState.highWaterMark;
                    }
                }), A.prototype._write = function(t1, e1, r) {
                    r(new m("_write()"));
                }, A.prototype._writev = null, A.prototype.end = function(t1, e1, r) {
                    var n = this._writableState;
                    return "function" == typeof t1 ? (r = t1, t1 = null, e1 = null) : "function" == typeof e1 && (r = e1, e1 = null), null != t1 && this.write(t1, e1), n.corked && (n.corked = 1, this.uncork()), n.ending || function(t1, e1, r) {
                        e1.ending = !0, I(t1, e1), r && (e1.finished ? i.nextTick(r) : t1.once("finish", r)), e1.ended = !0, t1.writable = !1;
                    }(this, n, r), this;
                }, Object.defineProperty(A.prototype, "writableLength", {
                    enumerable: !1,
                    get: function() {
                        return this._writableState.length;
                    }
                }), Object.defineProperty(A.prototype, "destroyed", {
                    enumerable: !1,
                    get: function() {
                        return void 0 !== this._writableState && this._writableState.destroyed;
                    },
                    set: function(t1) {
                        this._writableState && (this._writableState.destroyed = t1);
                    }
                }), A.prototype.destroy = h.destroy, A.prototype._undestroy = h.undestroy, A.prototype._destroy = function(t1, e1) {
                    e1(t1);
                };
            },
            73726: function(t1, e1, r) {
                "use strict";
                var n, i = r(33282);
                function a(t1, e1, r) {
                    return e1 in t1 ? Object.defineProperty(t1, e1, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : t1[e1] = r, t1;
                }
                var o = r(37165), s = Symbol("lastResolve"), l = Symbol("lastReject"), c = Symbol("error"), u = Symbol("ended"), h = Symbol("lastPromise"), f = Symbol("handlePromise"), p = Symbol("stream");
                function d(t1, e1) {
                    return {
                        value: t1,
                        done: e1
                    };
                }
                function m(t1) {
                    var e1 = t1[s];
                    if (null !== e1) {
                        var r = t1[p].read();
                        null !== r && (t1[h] = null, t1[s] = null, t1[l] = null, e1(d(r, !1)));
                    }
                }
                function g(t1) {
                    i.nextTick(m, t1);
                }
                var y = Object.getPrototypeOf(function() {}), v = Object.setPrototypeOf((a(n = {
                    get stream () {
                        return this[p];
                    },
                    next: function() {
                        var t1 = this, e1 = this[c];
                        if (null !== e1) return Promise.reject(e1);
                        if (this[u]) return Promise.resolve(d(void 0, !0));
                        if (this[p].destroyed) return new Promise(function(e1, r) {
                            i.nextTick(function() {
                                t1[c] ? r(t1[c]) : e1(d(void 0, !0));
                            });
                        });
                        var r, n = this[h];
                        if (n) r = new Promise(function(t1, e1) {
                            return function(r, n) {
                                t1.then(function() {
                                    e1[u] ? r(d(void 0, !0)) : e1[f](r, n);
                                }, n);
                            };
                        }(n, this));
                        else {
                            var a = this[p].read();
                            if (null !== a) return Promise.resolve(d(a, !1));
                            r = new Promise(this[f]);
                        }
                        return this[h] = r, r;
                    }
                }, Symbol.asyncIterator, function() {
                    return this;
                }), a(n, "return", function() {
                    var t1 = this;
                    return new Promise(function(e1, r) {
                        t1[p].destroy(null, function(t1) {
                            t1 ? r(t1) : e1(d(void 0, !0));
                        });
                    });
                }), n), y);
                t1.exports = function(t1) {
                    var e1, r = Object.create(v, (a(e1 = {}, p, {
                        value: t1,
                        writable: !0
                    }), a(e1, s, {
                        value: null,
                        writable: !0
                    }), a(e1, l, {
                        value: null,
                        writable: !0
                    }), a(e1, c, {
                        value: null,
                        writable: !0
                    }), a(e1, u, {
                        value: t1._readableState.endEmitted,
                        writable: !0
                    }), a(e1, f, {
                        value: function(t1, e1) {
                            var n = r[p].read();
                            n ? (r[h] = null, r[s] = null, r[l] = null, t1(d(n, !1))) : (r[s] = t1, r[l] = e1);
                        },
                        writable: !0
                    }), e1));
                    return r[h] = null, o(t1, function(t1) {
                        if (t1 && "ERR_STREAM_PREMATURE_CLOSE" !== t1.code) {
                            var e1 = r[l];
                            return null !== e1 && (r[h] = null, r[s] = null, r[l] = null, e1(t1)), void (r[c] = t1);
                        }
                        var n = r[s];
                        null !== n && (r[h] = null, r[s] = null, r[l] = null, n(d(void 0, !0))), r[u] = !0;
                    }), t1.on("readable", g.bind(null, r)), r;
                };
            },
            29930: function(t1, e1, r) {
                "use strict";
                function n(t1, e1) {
                    var r = Object.keys(t1);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(t1);
                        e1 && (n = n.filter(function(e1) {
                            return Object.getOwnPropertyDescriptor(t1, e1).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function i(t1, e1, r) {
                    return e1 in t1 ? Object.defineProperty(t1, e1, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : t1[e1] = r, t1;
                }
                function a(t1, e1) {
                    for(var r = 0; r < e1.length; r++){
                        var n = e1[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t1, n.key, n);
                    }
                }
                var o = r(45708).Buffer, s = r(63779).inspect, l = s && s.custom || "inspect";
                t1.exports = function() {
                    function t1() {
                        !function(t1, e1) {
                            if (!(t1 instanceof e1)) throw new TypeError("Cannot call a class as a function");
                        }(this, t1), this.head = null, this.tail = null, this.length = 0;
                    }
                    var e1, r;
                    return e1 = t1, r = [
                        {
                            key: "push",
                            value: function(t1) {
                                var e1 = {
                                    data: t1,
                                    next: null
                                };
                                this.length > 0 ? this.tail.next = e1 : this.head = e1, this.tail = e1, ++this.length;
                            }
                        },
                        {
                            key: "unshift",
                            value: function(t1) {
                                var e1 = {
                                    data: t1,
                                    next: this.head
                                };
                                0 === this.length && (this.tail = e1), this.head = e1, ++this.length;
                            }
                        },
                        {
                            key: "shift",
                            value: function() {
                                if (0 !== this.length) {
                                    var t1 = this.head.data;
                                    return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, t1;
                                }
                            }
                        },
                        {
                            key: "clear",
                            value: function() {
                                this.head = this.tail = null, this.length = 0;
                            }
                        },
                        {
                            key: "join",
                            value: function(t1) {
                                if (0 === this.length) return "";
                                for(var e1 = this.head, r = "" + e1.data; e1 = e1.next;)r += t1 + e1.data;
                                return r;
                            }
                        },
                        {
                            key: "concat",
                            value: function(t1) {
                                if (0 === this.length) return o.alloc(0);
                                for(var e1, r, n, i = o.allocUnsafe(t1 >>> 0), a = this.head, s = 0; a;)e1 = a.data, r = i, n = s, o.prototype.copy.call(e1, r, n), s += a.data.length, a = a.next;
                                return i;
                            }
                        },
                        {
                            key: "consume",
                            value: function(t1, e1) {
                                var r;
                                return t1 < this.head.data.length ? (r = this.head.data.slice(0, t1), this.head.data = this.head.data.slice(t1)) : r = t1 === this.head.data.length ? this.shift() : e1 ? this._getString(t1) : this._getBuffer(t1), r;
                            }
                        },
                        {
                            key: "first",
                            value: function() {
                                return this.head.data;
                            }
                        },
                        {
                            key: "_getString",
                            value: function(t1) {
                                var e1 = this.head, r = 1, n = e1.data;
                                for(t1 -= n.length; e1 = e1.next;){
                                    var i = e1.data, a = t1 > i.length ? i.length : t1;
                                    if (a === i.length ? n += i : n += i.slice(0, t1), 0 == (t1 -= a)) {
                                        a === i.length ? (++r, e1.next ? this.head = e1.next : this.head = this.tail = null) : (this.head = e1, e1.data = i.slice(a));
                                        break;
                                    }
                                    ++r;
                                }
                                return this.length -= r, n;
                            }
                        },
                        {
                            key: "_getBuffer",
                            value: function(t1) {
                                var e1 = o.allocUnsafe(t1), r = this.head, n = 1;
                                for(r.data.copy(e1), t1 -= r.data.length; r = r.next;){
                                    var i = r.data, a = t1 > i.length ? i.length : t1;
                                    if (i.copy(e1, e1.length - t1, 0, a), 0 == (t1 -= a)) {
                                        a === i.length ? (++n, r.next ? this.head = r.next : this.head = this.tail = null) : (this.head = r, r.data = i.slice(a));
                                        break;
                                    }
                                    ++n;
                                }
                                return this.length -= n, e1;
                            }
                        },
                        {
                            key: l,
                            value: function(t1, e1) {
                                return s(this, function(t1) {
                                    for(var e1 = 1; e1 < arguments.length; e1++){
                                        var r = null != arguments[e1] ? arguments[e1] : {};
                                        e1 % 2 ? n(Object(r), !0).forEach(function(e1) {
                                            i(t1, e1, r[e1]);
                                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t1, Object.getOwnPropertyDescriptors(r)) : n(Object(r)).forEach(function(e1) {
                                            Object.defineProperty(t1, e1, Object.getOwnPropertyDescriptor(r, e1));
                                        });
                                    }
                                    return t1;
                                }({}, e1, {
                                    depth: 0,
                                    customInspect: !1
                                }));
                            }
                        }
                    ], r && a(e1.prototype, r), t1;
                }();
            },
            52023: function(t1, e1, r) {
                "use strict";
                var n = r(33282);
                function i(t1, e1) {
                    o(t1, e1), a(t1);
                }
                function a(t1) {
                    t1._writableState && !t1._writableState.emitClose || t1._readableState && !t1._readableState.emitClose || t1.emit("close");
                }
                function o(t1, e1) {
                    t1.emit("error", e1);
                }
                t1.exports = {
                    destroy: function(t1, e1) {
                        var r = this, s = this._readableState && this._readableState.destroyed, l = this._writableState && this._writableState.destroyed;
                        return s || l ? (e1 ? e1(t1) : t1 && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, n.nextTick(o, this, t1)) : n.nextTick(o, this, t1)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(t1 || null, function(t1) {
                            !e1 && t1 ? r._writableState ? r._writableState.errorEmitted ? n.nextTick(a, r) : (r._writableState.errorEmitted = !0, n.nextTick(i, r, t1)) : n.nextTick(i, r, t1) : e1 ? (n.nextTick(a, r), e1(t1)) : n.nextTick(a, r);
                        }), this);
                    },
                    undestroy: function() {
                        this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
                    },
                    errorOrDestroy: function(t1, e1) {
                        var r = t1._readableState, n = t1._writableState;
                        r && r.autoDestroy || n && n.autoDestroy ? t1.destroy(e1) : t1.emit("error", e1);
                    }
                };
            },
            37165: function(t1, e1, r) {
                "use strict";
                var n = r(44059).F.ERR_STREAM_PREMATURE_CLOSE;
                function i() {}
                t1.exports = function t1(e1, r, a) {
                    if ("function" == typeof r) return t1(e1, null, r);
                    r || (r = {}), a = function(t1) {
                        var e1 = !1;
                        return function() {
                            if (!e1) {
                                e1 = !0;
                                for(var r = arguments.length, n = new Array(r), i = 0; i < r; i++)n[i] = arguments[i];
                                t1.apply(this, n);
                            }
                        };
                    }(a || i);
                    var o = r.readable || !1 !== r.readable && e1.readable, s = r.writable || !1 !== r.writable && e1.writable, l = function() {
                        e1.writable || u();
                    }, c = e1._writableState && e1._writableState.finished, u = function() {
                        s = !1, c = !0, o || a.call(e1);
                    }, h = e1._readableState && e1._readableState.endEmitted, f = function() {
                        o = !1, h = !0, s || a.call(e1);
                    }, p = function(t1) {
                        a.call(e1, t1);
                    }, d = function() {
                        var t1;
                        return o && !h ? (e1._readableState && e1._readableState.ended || (t1 = new n), a.call(e1, t1)) : s && !c ? (e1._writableState && e1._writableState.ended || (t1 = new n), a.call(e1, t1)) : void 0;
                    }, m = function() {
                        e1.req.on("finish", u);
                    };
                    return function(t1) {
                        return t1.setHeader && "function" == typeof t1.abort;
                    }(e1) ? (e1.on("complete", u), e1.on("abort", d), e1.req ? m() : e1.on("request", m)) : s && !e1._writableState && (e1.on("end", l), e1.on("close", l)), e1.on("end", f), e1.on("finish", u), !1 !== r.error && e1.on("error", p), e1.on("close", d), function() {
                        e1.removeListener("complete", u), e1.removeListener("abort", d), e1.removeListener("request", m), e1.req && e1.req.removeListener("finish", u), e1.removeListener("end", l), e1.removeListener("close", l), e1.removeListener("finish", u), e1.removeListener("end", f), e1.removeListener("error", p), e1.removeListener("close", d);
                    };
                };
            },
            37108: function(t1) {
                t1.exports = function() {
                    throw new Error("Readable.from is not available in the browser");
                };
            },
            6772: function(t1, e1, r) {
                "use strict";
                var n, i = r(44059).F, a = i.ERR_MISSING_ARGS, o = i.ERR_STREAM_DESTROYED;
                function s(t1) {
                    if (t1) throw t1;
                }
                function l(t1) {
                    t1();
                }
                function c(t1, e1) {
                    return t1.pipe(e1);
                }
                t1.exports = function() {
                    for(var t1 = arguments.length, e1 = new Array(t1), i = 0; i < t1; i++)e1[i] = arguments[i];
                    var u, h = function(t1) {
                        return t1.length ? "function" != typeof t1[t1.length - 1] ? s : t1.pop() : s;
                    }(e1);
                    if (Array.isArray(e1[0]) && (e1 = e1[0]), e1.length < 2) throw new a("streams");
                    var f = e1.map(function(t1, i) {
                        var a = i < e1.length - 1;
                        return function(t1, e1, i, a) {
                            a = function(t1) {
                                var e1 = !1;
                                return function() {
                                    e1 || (e1 = !0, t1.apply(void 0, arguments));
                                };
                            }(a);
                            var s = !1;
                            t1.on("close", function() {
                                s = !0;
                            }), void 0 === n && (n = r(37165)), n(t1, {
                                readable: e1,
                                writable: i
                            }, function(t1) {
                                if (t1) return a(t1);
                                s = !0, a();
                            });
                            var l = !1;
                            return function(e1) {
                                if (!s && !l) return l = !0, function(t1) {
                                    return t1.setHeader && "function" == typeof t1.abort;
                                }(t1) ? t1.abort() : "function" == typeof t1.destroy ? t1.destroy() : void a(e1 || new o("pipe"));
                            };
                        }(t1, a, i > 0, function(t1) {
                            u || (u = t1), t1 && f.forEach(l), a || (f.forEach(l), h(u));
                        });
                    });
                    return e1.reduce(c);
                };
            },
            31976: function(t1, e1, r) {
                "use strict";
                var n = r(44059).F.ERR_INVALID_OPT_VALUE;
                t1.exports = {
                    getHighWaterMark: function(t1, e1, r, i) {
                        var a = function(t1, e1, r) {
                            return null != t1.highWaterMark ? t1.highWaterMark : e1 ? t1[r] : null;
                        }(e1, i, r);
                        if (null != a) {
                            if (!isFinite(a) || Math.floor(a) !== a || a < 0) throw new n(i ? r : "highWaterMark", a);
                            return Math.floor(a);
                        }
                        return t1.objectMode ? 16 : 16384;
                    }
                };
            },
            60032: function(t1, e1, r) {
                t1.exports = r(7683).EventEmitter;
            },
            54304: function(t1, e1, r) {
                "use strict";
                var n = r(41041).Buffer, i = n.isEncoding || function(t1) {
                    switch((t1 = "" + t1) && t1.toLowerCase()){
                        case "hex":
                        case "utf8":
                        case "utf-8":
                        case "ascii":
                        case "binary":
                        case "base64":
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                        case "raw":
                            return !0;
                        default:
                            return !1;
                    }
                };
                function a(t1) {
                    var e1;
                    switch(this.encoding = function(t1) {
                        var e1 = function(t1) {
                            if (!t1) return "utf8";
                            for(var e1;;)switch(t1){
                                case "utf8":
                                case "utf-8":
                                    return "utf8";
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return "utf16le";
                                case "latin1":
                                case "binary":
                                    return "latin1";
                                case "base64":
                                case "ascii":
                                case "hex":
                                    return t1;
                                default:
                                    if (e1) return;
                                    t1 = ("" + t1).toLowerCase(), e1 = !0;
                            }
                        }(t1);
                        if ("string" != typeof e1 && (n.isEncoding === i || !i(t1))) throw new Error("Unknown encoding: " + t1);
                        return e1 || t1;
                    }(t1), this.encoding){
                        case "utf16le":
                            this.text = l, this.end = c, e1 = 4;
                            break;
                        case "utf8":
                            this.fillLast = s, e1 = 4;
                            break;
                        case "base64":
                            this.text = u, this.end = h, e1 = 3;
                            break;
                        default:
                            return this.write = f, void (this.end = p);
                    }
                    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = n.allocUnsafe(e1);
                }
                function o(t1) {
                    return t1 <= 127 ? 0 : t1 >> 5 == 6 ? 2 : t1 >> 4 == 14 ? 3 : t1 >> 3 == 30 ? 4 : t1 >> 6 == 2 ? -1 : -2;
                }
                function s(t1) {
                    var e1 = this.lastTotal - this.lastNeed, r = function(t1, e1, r) {
                        if (128 != (192 & e1[0])) return t1.lastNeed = 0, "\uFFFD";
                        if (t1.lastNeed > 1 && e1.length > 1) {
                            if (128 != (192 & e1[1])) return t1.lastNeed = 1, "\uFFFD";
                            if (t1.lastNeed > 2 && e1.length > 2 && 128 != (192 & e1[2])) return t1.lastNeed = 2, "\uFFFD";
                        }
                    }(this, t1);
                    return void 0 !== r ? r : this.lastNeed <= t1.length ? (t1.copy(this.lastChar, e1, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (t1.copy(this.lastChar, e1, 0, t1.length), void (this.lastNeed -= t1.length));
                }
                function l(t1, e1) {
                    if ((t1.length - e1) % 2 == 0) {
                        var r = t1.toString("utf16le", e1);
                        if (r) {
                            var n = r.charCodeAt(r.length - 1);
                            if (n >= 55296 && n <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = t1[t1.length - 2], this.lastChar[1] = t1[t1.length - 1], r.slice(0, -1);
                        }
                        return r;
                    }
                    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = t1[t1.length - 1], t1.toString("utf16le", e1, t1.length - 1);
                }
                function c(t1) {
                    var e1 = t1 && t1.length ? this.write(t1) : "";
                    if (this.lastNeed) {
                        var r = this.lastTotal - this.lastNeed;
                        return e1 + this.lastChar.toString("utf16le", 0, r);
                    }
                    return e1;
                }
                function u(t1, e1) {
                    var r = (t1.length - e1) % 3;
                    return 0 === r ? t1.toString("base64", e1) : (this.lastNeed = 3 - r, this.lastTotal = 3, 1 === r ? this.lastChar[0] = t1[t1.length - 1] : (this.lastChar[0] = t1[t1.length - 2], this.lastChar[1] = t1[t1.length - 1]), t1.toString("base64", e1, t1.length - r));
                }
                function h(t1) {
                    var e1 = t1 && t1.length ? this.write(t1) : "";
                    return this.lastNeed ? e1 + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : e1;
                }
                function f(t1) {
                    return t1.toString(this.encoding);
                }
                function p(t1) {
                    return t1 && t1.length ? this.write(t1) : "";
                }
                e1.I = a, a.prototype.write = function(t1) {
                    if (0 === t1.length) return "";
                    var e1, r;
                    if (this.lastNeed) {
                        if (void 0 === (e1 = this.fillLast(t1))) return "";
                        r = this.lastNeed, this.lastNeed = 0;
                    } else r = 0;
                    return r < t1.length ? e1 ? e1 + this.text(t1, r) : this.text(t1, r) : e1 || "";
                }, a.prototype.end = function(t1) {
                    var e1 = t1 && t1.length ? this.write(t1) : "";
                    return this.lastNeed ? e1 + "\uFFFD" : e1;
                }, a.prototype.text = function(t1, e1) {
                    var r = function(t1, e1, r) {
                        var n = e1.length - 1;
                        if (n < r) return 0;
                        var i = o(e1[n]);
                        return i >= 0 ? (i > 0 && (t1.lastNeed = i - 1), i) : --n < r || -2 === i ? 0 : (i = o(e1[n])) >= 0 ? (i > 0 && (t1.lastNeed = i - 2), i) : --n < r || -2 === i ? 0 : (i = o(e1[n])) >= 0 ? (i > 0 && (2 === i ? i = 0 : t1.lastNeed = i - 3), i) : 0;
                    }(this, t1, e1);
                    if (!this.lastNeed) return t1.toString("utf8", e1);
                    this.lastTotal = r;
                    var n = t1.length - (r - this.lastNeed);
                    return t1.copy(this.lastChar, 0, n), t1.toString("utf8", e1, n);
                }, a.prototype.fillLast = function(t1) {
                    if (this.lastNeed <= t1.length) return t1.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
                    t1.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, t1.length), this.lastNeed -= t1.length;
                };
            },
            79743: function(t1, e1, r) {
                var n = r(45708).Buffer, i = r(85672), a = r(79399)("stream-parser");
                t1.exports = function(t1) {
                    var e1 = t1 && "function" == typeof t1._transform, r = t1 && "function" == typeof t1._write;
                    if (!e1 && !r) throw new Error("must pass a Writable or Transform stream in");
                    a("extending Parser into stream"), t1._bytes = h, t1._skipBytes = f, e1 && (t1._passthrough = p), e1 ? t1._transform = m : t1._write = d;
                };
                var o = -1, s = 0, l = 1, c = 2;
                function u(t1) {
                    a("initializing parser stream"), t1._parserBytesLeft = 0, t1._parserBuffers = [], t1._parserBuffered = 0, t1._parserState = o, t1._parserCallback = null, "function" == typeof t1.push && (t1._parserOutput = t1.push.bind(t1)), t1._parserInit = !0;
                }
                function h(t1, e1) {
                    i(!this._parserCallback, 'there is already a "callback" set!'), i(isFinite(t1) && t1 > 0, 'can only buffer a finite number of bytes > 0, got "' + t1 + '"'), this._parserInit || u(this), a("buffering %o bytes", t1), this._parserBytesLeft = t1, this._parserCallback = e1, this._parserState = s;
                }
                function f(t1, e1) {
                    i(!this._parserCallback, 'there is already a "callback" set!'), i(t1 > 0, 'can only skip > 0 bytes, got "' + t1 + '"'), this._parserInit || u(this), a("skipping %o bytes", t1), this._parserBytesLeft = t1, this._parserCallback = e1, this._parserState = l;
                }
                function p(t1, e1) {
                    i(!this._parserCallback, 'There is already a "callback" set!'), i(t1 > 0, 'can only pass through > 0 bytes, got "' + t1 + '"'), this._parserInit || u(this), a("passing through %o bytes", t1), this._parserBytesLeft = t1, this._parserCallback = e1, this._parserState = c;
                }
                function d(t1, e1, r) {
                    this._parserInit || u(this), a("write(%o bytes)", t1.length), "function" == typeof e1 && (r = e1), y(this, t1, null, r);
                }
                function m(t1, e1, r) {
                    this._parserInit || u(this), a("transform(%o bytes)", t1.length), "function" != typeof e1 && (e1 = this._parserOutput), y(this, t1, e1, r);
                }
                function g(t1, e1, r, i) {
                    if (t1._parserBytesLeft -= e1.length, a("%o bytes left for stream piece", t1._parserBytesLeft), t1._parserState === s ? (t1._parserBuffers.push(e1), t1._parserBuffered += e1.length) : t1._parserState === c && r(e1), 0 !== t1._parserBytesLeft) return i;
                    var l = t1._parserCallback;
                    if (l && t1._parserState === s && t1._parserBuffers.length > 1 && (e1 = n.concat(t1._parserBuffers, t1._parserBuffered)), t1._parserState !== s && (e1 = null), t1._parserCallback = null, t1._parserBuffered = 0, t1._parserState = o, t1._parserBuffers.splice(0), l) {
                        var u = [];
                        e1 && u.push(e1), r && u.push(r);
                        var h = l.length > u.length;
                        h && u.push(v(i));
                        var f = l.apply(t1, u);
                        if (!h || i === f) return i;
                    }
                }
                var y = v(function t1(e1, r, n, i) {
                    return e1._parserBytesLeft <= 0 ? i(new Error("got data but not currently parsing anything")) : r.length <= e1._parserBytesLeft ? function() {
                        return g(e1, r, n, i);
                    } : function() {
                        var a = r.slice(0, e1._parserBytesLeft);
                        return g(e1, a, n, function(o) {
                            return o ? i(o) : r.length > a.length ? function() {
                                return t1(e1, r.slice(a.length), n, i);
                            } : void 0;
                        });
                    };
                });
                function v(t1) {
                    return function() {
                        for(var e1 = t1.apply(this, arguments); "function" == typeof e1;)e1 = e1();
                        return e1;
                    };
                }
            },
            79399: function(t1, e1, r) {
                var n = r(33282);
                function i() {
                    var t1;
                    try {
                        t1 = e1.storage.debug;
                    } catch (t1) {}
                    return !t1 && void 0 !== n && "env" in n && (t1 = n.env.DEBUG), t1;
                }
                (e1 = t1.exports = r(43228)).log = function() {
                    return "object" == typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
                }, e1.formatArgs = function(t1) {
                    var r = this.useColors;
                    if (t1[0] = (r ? "%c" : "") + this.namespace + (r ? " %c" : " ") + t1[0] + (r ? "%c " : " ") + "+" + e1.humanize(this.diff), r) {
                        var n = "color: " + this.color;
                        t1.splice(1, 0, n, "color: inherit");
                        var i = 0, a = 0;
                        t1[0].replace(/%[a-zA-Z%]/g, function(t1) {
                            "%%" !== t1 && (i++, "%c" === t1 && (a = i));
                        }), t1.splice(a, 0, n);
                    }
                }, e1.save = function(t1) {
                    try {
                        null == t1 ? e1.storage.removeItem("debug") : e1.storage.debug = t1;
                    } catch (t1) {}
                }, e1.load = i, e1.useColors = function() {
                    return !("undefined" == typeof window || !window.process || "renderer" !== window.process.type) || "undefined" != typeof document && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || "undefined" != typeof window && window.console && (window.console.firebug || window.console.exception && window.console.table) || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
                }, e1.storage = "undefined" != typeof chrome && void 0 !== chrome.storage ? chrome.storage.local : function() {
                    try {
                        return window.localStorage;
                    } catch (t1) {}
                }(), e1.colors = [
                    "lightseagreen",
                    "forestgreen",
                    "goldenrod",
                    "dodgerblue",
                    "darkorchid",
                    "crimson"
                ], e1.formatters.j = function(t1) {
                    try {
                        return JSON.stringify(t1);
                    } catch (t1) {
                        return "[UnexpectedJSONParseError]: " + t1.message;
                    }
                }, e1.enable(i());
            },
            43228: function(t1, e1, r) {
                var n;
                function i(t1) {
                    function r() {
                        if (r.enabled) {
                            var t1 = r, i = +new Date, a = i - (n || i);
                            t1.diff = a, t1.prev = n, t1.curr = i, n = i;
                            for(var o = new Array(arguments.length), s = 0; s < o.length; s++)o[s] = arguments[s];
                            o[0] = e1.coerce(o[0]), "string" != typeof o[0] && o.unshift("%O");
                            var l = 0;
                            o[0] = o[0].replace(/%([a-zA-Z%])/g, function(r, n) {
                                if ("%%" === r) return r;
                                l++;
                                var i = e1.formatters[n];
                                if ("function" == typeof i) {
                                    var a = o[l];
                                    r = i.call(t1, a), o.splice(l, 1), l--;
                                }
                                return r;
                            }), e1.formatArgs.call(t1, o), (r.log || e1.log || console.log.bind(console)).apply(t1, o);
                        }
                    }
                    return r.namespace = t1, r.enabled = e1.enabled(t1), r.useColors = e1.useColors(), r.color = function(t1) {
                        var r, n = 0;
                        for(r in t1)n = (n << 5) - n + t1.charCodeAt(r), n |= 0;
                        return e1.colors[Math.abs(n) % e1.colors.length];
                    }(t1), "function" == typeof e1.init && e1.init(r), r;
                }
                (e1 = t1.exports = i.debug = i.default = i).coerce = function(t1) {
                    return t1 instanceof Error ? t1.stack || t1.message : t1;
                }, e1.disable = function() {
                    e1.enable("");
                }, e1.enable = function(t1) {
                    e1.save(t1), e1.names = [], e1.skips = [];
                    for(var r = ("string" == typeof t1 ? t1 : "").split(/[\s,]+/), n = r.length, i = 0; i < n; i++)r[i] && ("-" === (t1 = r[i].replace(/\*/g, ".*?"))[0] ? e1.skips.push(new RegExp("^" + t1.substr(1) + "$")) : e1.names.push(new RegExp("^" + t1 + "$")));
                }, e1.enabled = function(t1) {
                    var r, n;
                    for(r = 0, n = e1.skips.length; r < n; r++)if (e1.skips[r].test(t1)) return !1;
                    for(r = 0, n = e1.names.length; r < n; r++)if (e1.names[r].test(t1)) return !0;
                    return !1;
                }, e1.humanize = r(13883), e1.names = [], e1.skips = [], e1.formatters = {};
            },
            13883: function(t1) {
                var e1 = 1e3, r = 60 * e1, n = 60 * r, i = 24 * n;
                function a(t1, e1, r) {
                    if (!(t1 < e1)) return t1 < 1.5 * e1 ? Math.floor(t1 / e1) + " " + r : Math.ceil(t1 / e1) + " " + r + "s";
                }
                t1.exports = function(t1, o) {
                    o = o || {};
                    var s, l = typeof t1;
                    if ("string" === l && t1.length > 0) return function(t1) {
                        if (!((t1 = String(t1)).length > 100)) {
                            var a = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(t1);
                            if (a) {
                                var o = parseFloat(a[1]);
                                switch((a[2] || "ms").toLowerCase()){
                                    case "years":
                                    case "year":
                                    case "yrs":
                                    case "yr":
                                    case "y":
                                        return 315576e5 * o;
                                    case "days":
                                    case "day":
                                    case "d":
                                        return o * i;
                                    case "hours":
                                    case "hour":
                                    case "hrs":
                                    case "hr":
                                    case "h":
                                        return o * n;
                                    case "minutes":
                                    case "minute":
                                    case "mins":
                                    case "min":
                                    case "m":
                                        return o * r;
                                    case "seconds":
                                    case "second":
                                    case "secs":
                                    case "sec":
                                    case "s":
                                        return o * e1;
                                    case "milliseconds":
                                    case "millisecond":
                                    case "msecs":
                                    case "msec":
                                    case "ms":
                                        return o;
                                    default:
                                        return;
                                }
                            }
                        }
                    }(t1);
                    if ("number" === l && !1 === isNaN(t1)) return o.long ? a(s = t1, i, "day") || a(s, n, "hour") || a(s, r, "minute") || a(s, e1, "second") || s + " ms" : function(t1) {
                        return t1 >= i ? Math.round(t1 / i) + "d" : t1 >= n ? Math.round(t1 / n) + "h" : t1 >= r ? Math.round(t1 / r) + "m" : t1 >= e1 ? Math.round(t1 / e1) + "s" : t1 + "ms";
                    }(t1);
                    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(t1));
                };
            },
            28089: function(t1, e1, r) {
                "use strict";
                var n = r(59811);
                t1.exports = function(t1, e1, r) {
                    if (null == t1) throw Error("First argument should be a string");
                    if (null == e1) throw Error("Separator should be a string or a RegExp");
                    r ? ("string" == typeof r || Array.isArray(r)) && (r = {
                        ignore: r
                    }) : r = {}, null == r.escape && (r.escape = !0), null == r.ignore ? r.ignore = [
                        "[]",
                        "()",
                        "{}",
                        "<>",
                        '""',
                        "''",
                        "``",
                        "\u201C\u201D",
                        "\xab\xbb"
                    ] : ("string" == typeof r.ignore && (r.ignore = [
                        r.ignore
                    ]), r.ignore = r.ignore.map(function(t1) {
                        return 1 === t1.length && (t1 += t1), t1;
                    }));
                    var i = n.parse(t1, {
                        flat: !0,
                        brackets: r.ignore
                    }), a = i[0].split(e1);
                    if (r.escape) {
                        for(var o = [], s = 0; s < a.length; s++){
                            var l = a[s], c = a[s + 1];
                            "\\" === l[l.length - 1] && "\\" !== l[l.length - 2] ? (o.push(l + e1 + c), s++) : o.push(l);
                        }
                        a = o;
                    }
                    for(s = 0; s < a.length; s++)i[0] = a[s], a[s] = n.stringify(i, {
                        flat: !0
                    });
                    return a;
                };
            },
            26381: function(t1) {
                "use strict";
                t1.exports = function(t1) {
                    for(var e1 = t1.length, r = new Array(e1), n = new Array(e1), i = new Array(e1), a = new Array(e1), o = new Array(e1), s = new Array(e1), l = 0; l < e1; ++l)r[l] = -1, n[l] = 0, i[l] = !1, a[l] = 0, o[l] = -1, s[l] = [];
                    var c, u = 0, h = [], f = [];
                    function p(e1) {
                        var l = [
                            e1
                        ], c = [
                            e1
                        ];
                        for(r[e1] = n[e1] = u, i[e1] = !0, u += 1; c.length > 0;){
                            e1 = c[c.length - 1];
                            var p = t1[e1];
                            if (a[e1] < p.length) {
                                for(var d = a[e1]; d < p.length; ++d){
                                    var m = p[d];
                                    if (r[m] < 0) {
                                        r[m] = n[m] = u, i[m] = !0, u += 1, l.push(m), c.push(m);
                                        break;
                                    }
                                    i[m] && (n[e1] = 0 | Math.min(n[e1], n[m])), o[m] >= 0 && s[e1].push(o[m]);
                                }
                                a[e1] = d;
                            } else {
                                if (n[e1] === r[e1]) {
                                    var g = [], y = [], v = 0;
                                    for(d = l.length - 1; d >= 0; --d){
                                        var x = l[d];
                                        if (i[x] = !1, g.push(x), y.push(s[x]), v += s[x].length, o[x] = h.length, x === e1) {
                                            l.length = d;
                                            break;
                                        }
                                    }
                                    h.push(g);
                                    var _ = new Array(v);
                                    for(d = 0; d < y.length; d++)for(var b = 0; b < y[d].length; b++)_[--v] = y[d][b];
                                    f.push(_);
                                }
                                c.pop();
                            }
                        }
                    }
                    for(l = 0; l < e1; ++l)r[l] < 0 && p(l);
                    for(l = 0; l < f.length; l++){
                        var d = f[l];
                        if (0 !== d.length) {
                            d.sort(function(t1, e1) {
                                return t1 - e1;
                            }), c = [
                                d[0]
                            ];
                            for(var m = 1; m < d.length; m++)d[m] !== d[m - 1] && c.push(d[m]);
                            f[l] = c;
                        }
                    }
                    return {
                        components: h,
                        adjacencyList: f
                    };
                };
            },
            13193: function(t1, e1, r) {
                "use strict";
                r.r(e1);
                var n = 2 * Math.PI, i = function(t1, e1, r, n, i, a, o) {
                    var s = t1.x, l = t1.y;
                    return {
                        x: n * (s *= e1) - i * (l *= r) + a,
                        y: i * s + n * l + o
                    };
                }, a = function(t1, e1) {
                    var r = 1.5707963267948966 === e1 ? .551915024494 : -1.5707963267948966 === e1 ? -0.551915024494 : 4 / 3 * Math.tan(e1 / 4), n = Math.cos(t1), i = Math.sin(t1), a = Math.cos(t1 + e1), o = Math.sin(t1 + e1);
                    return [
                        {
                            x: n - i * r,
                            y: i + n * r
                        },
                        {
                            x: a + o * r,
                            y: o - a * r
                        },
                        {
                            x: a,
                            y: o
                        }
                    ];
                }, o = function(t1, e1, r, n) {
                    var i = t1 * r + e1 * n;
                    return i > 1 && (i = 1), i < -1 && (i = -1), (t1 * n - e1 * r < 0 ? -1 : 1) * Math.acos(i);
                };
                e1.default = function(t1) {
                    var e1 = t1.px, r = t1.py, s = t1.cx, l = t1.cy, c = t1.rx, u = t1.ry, h = t1.xAxisRotation, f = void 0 === h ? 0 : h, p = t1.largeArcFlag, d = void 0 === p ? 0 : p, m = t1.sweepFlag, g = void 0 === m ? 0 : m, y = [];
                    if (0 === c || 0 === u) return [];
                    var v = Math.sin(f * n / 360), x = Math.cos(f * n / 360), _ = x * (e1 - s) / 2 + v * (r - l) / 2, b = -v * (e1 - s) / 2 + x * (r - l) / 2;
                    if (0 === _ && 0 === b) return [];
                    c = Math.abs(c), u = Math.abs(u);
                    var w = Math.pow(_, 2) / Math.pow(c, 2) + Math.pow(b, 2) / Math.pow(u, 2);
                    w > 1 && (c *= Math.sqrt(w), u *= Math.sqrt(w));
                    var T = function(t1, e1, r, i, a, s, l, c, u, h, f, p) {
                        var d = Math.pow(a, 2), m = Math.pow(s, 2), g = Math.pow(f, 2), y = Math.pow(p, 2), v = d * m - d * y - m * g;
                        v < 0 && (v = 0), v /= d * y + m * g;
                        var x = (v = Math.sqrt(v) * (l === c ? -1 : 1)) * a / s * p, _ = v * -s / a * f, b = h * x - u * _ + (t1 + r) / 2, w = u * x + h * _ + (e1 + i) / 2, T = (f - x) / a, k = (p - _) / s, A = (-f - x) / a, M = (-p - _) / s, S = o(1, 0, T, k), E = o(T, k, A, M);
                        return 0 === c && E > 0 && (E -= n), 1 === c && E < 0 && (E += n), [
                            b,
                            w,
                            S,
                            E
                        ];
                    }(e1, r, s, l, c, u, d, g, v, x, _, b), k = function(t1, e1) {
                        if (Array.isArray(t1)) return t1;
                        if (Symbol.iterator in Object(t1)) return function(t1, e1) {
                            var r = [], n = !0, i = !1, a = void 0;
                            try {
                                for(var o, s = t1[Symbol.iterator](); !(n = (o = s.next()).done) && (r.push(o.value), !e1 || r.length !== e1); n = !0);
                            } catch (t1) {
                                i = !0, a = t1;
                            } finally{
                                try {
                                    !n && s.return && s.return();
                                } finally{
                                    if (i) throw a;
                                }
                            }
                            return r;
                        }(t1, e1);
                        throw new TypeError("Invalid attempt to destructure non-iterable instance");
                    }(T, 4), A = k[0], M = k[1], S = k[2], E = k[3], C = Math.abs(E) / (n / 4);
                    Math.abs(1 - C) < 1e-7 && (C = 1);
                    var L = Math.max(Math.ceil(C), 1);
                    E /= L;
                    for(var I = 0; I < L; I++)y.push(a(S, E)), S += E;
                    return y.map(function(t1) {
                        var e1 = i(t1[0], c, u, x, v, A, M), r = e1.x, n = e1.y, a = i(t1[1], c, u, x, v, A, M), o = a.x, s = a.y, l = i(t1[2], c, u, x, v, A, M);
                        return {
                            x1: r,
                            y1: n,
                            x2: o,
                            y2: s,
                            x: l.x,
                            y: l.y
                        };
                    });
                };
            },
            97251: function(t1, e1, r) {
                "use strict";
                var n = r(26953), i = r(16844), a = r(41883), o = r(13986), s = r(85672);
                t1.exports = function(t1) {
                    if (Array.isArray(t1) && 1 === t1.length && "string" == typeof t1[0] && (t1 = t1[0]), "string" == typeof t1 && (s(o(t1), "String is not an SVG path."), t1 = n(t1)), s(Array.isArray(t1), "Argument should be a string or an array of path segments."), t1 = i(t1), !(t1 = a(t1)).length) return [
                        0,
                        0,
                        0,
                        0
                    ];
                    for(var e1 = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ], r = 0, l = t1.length; r < l; r++)for(var c = t1[r].slice(1), u = 0; u < c.length; u += 2)c[u + 0] < e1[0] && (e1[0] = c[u + 0]), c[u + 1] < e1[1] && (e1[1] = c[u + 1]), c[u + 0] > e1[2] && (e1[2] = c[u + 0]), c[u + 1] > e1[3] && (e1[3] = c[u + 1]);
                    return e1;
                };
            },
            41883: function(t1, e1, r) {
                "use strict";
                t1.exports = function(t1) {
                    for(var e1, r = [], o = 0, s = 0, l = 0, c = 0, u = null, h = null, f = 0, p = 0, d = 0, m = t1.length; d < m; d++){
                        var g = t1[d], y = g[0];
                        switch(y){
                            case "M":
                                l = g[1], c = g[2];
                                break;
                            case "A":
                                var v = n({
                                    px: f,
                                    py: p,
                                    cx: g[6],
                                    cy: g[7],
                                    rx: g[1],
                                    ry: g[2],
                                    xAxisRotation: g[3],
                                    largeArcFlag: g[4],
                                    sweepFlag: g[5]
                                });
                                if (!v.length) continue;
                                for(var x, _ = 0; _ < v.length; _++)g = [
                                    "C",
                                    (x = v[_]).x1,
                                    x.y1,
                                    x.x2,
                                    x.y2,
                                    x.x,
                                    x.y
                                ], _ < v.length - 1 && r.push(g);
                                break;
                            case "S":
                                var b = f, w = p;
                                "C" != e1 && "S" != e1 || (b += b - o, w += w - s), g = [
                                    "C",
                                    b,
                                    w,
                                    g[1],
                                    g[2],
                                    g[3],
                                    g[4]
                                ];
                                break;
                            case "T":
                                "Q" == e1 || "T" == e1 ? (u = 2 * f - u, h = 2 * p - h) : (u = f, h = p), g = a(f, p, u, h, g[1], g[2]);
                                break;
                            case "Q":
                                u = g[1], h = g[2], g = a(f, p, g[1], g[2], g[3], g[4]);
                                break;
                            case "L":
                                g = i(f, p, g[1], g[2]);
                                break;
                            case "H":
                                g = i(f, p, g[1], p);
                                break;
                            case "V":
                                g = i(f, p, f, g[1]);
                                break;
                            case "Z":
                                g = i(f, p, l, c);
                        }
                        e1 = y, f = g[g.length - 2], p = g[g.length - 1], g.length > 4 ? (o = g[g.length - 4], s = g[g.length - 3]) : (o = f, s = p), r.push(g);
                    }
                    return r;
                };
                var n = r(13193);
                function i(t1, e1, r, n) {
                    return [
                        "C",
                        t1,
                        e1,
                        r,
                        n,
                        r,
                        n
                    ];
                }
                function a(t1, e1, r, n, i, a) {
                    return [
                        "C",
                        t1 / 3 + 2 / 3 * r,
                        e1 / 3 + 2 / 3 * n,
                        i / 3 + 2 / 3 * r,
                        a / 3 + 2 / 3 * n,
                        i,
                        a
                    ];
                }
            },
            96021: function(t1, e1, r) {
                "use strict";
                var n, i = r(97251), a = r(26953), o = r(95620), s = r(13986), l = r(88772), c = document.createElement("canvas"), u = c.getContext("2d");
                t1.exports = function(t1, e1) {
                    if (!s(t1)) throw Error("Argument should be valid svg path string");
                    var r, h;
                    e1 || (e1 = {}), e1.shape ? (r = e1.shape[0], h = e1.shape[1]) : (r = c.width = e1.w || e1.width || 200, h = c.height = e1.h || e1.height || 200);
                    var f = Math.min(r, h), p = e1.stroke || 0, d = e1.viewbox || e1.viewBox || i(t1), m = [
                        r / (d[2] - d[0]),
                        h / (d[3] - d[1])
                    ], g = Math.min(m[0] || 0, m[1] || 0) / 2;
                    if (u.fillStyle = "black", u.fillRect(0, 0, r, h), u.fillStyle = "white", p && ("number" != typeof p && (p = 1), u.strokeStyle = p > 0 ? "white" : "black", u.lineWidth = Math.abs(p)), u.translate(.5 * r, .5 * h), u.scale(g, g), function() {
                        if (null != n) return n;
                        var t1 = document.createElement("canvas").getContext("2d");
                        if (t1.canvas.width = t1.canvas.height = 1, !window.Path2D) return n = !1;
                        var e1 = new Path2D("M0,0h1v1h-1v-1Z");
                        t1.fillStyle = "black", t1.fill(e1);
                        var r = t1.getImageData(0, 0, 1, 1);
                        return n = r && r.data && 255 === r.data[3];
                    }()) {
                        var y = new Path2D(t1);
                        u.fill(y), p && u.stroke(y);
                    } else {
                        var v = a(t1);
                        o(u, v), u.fill(), p && u.stroke();
                    }
                    return u.setTransform(1, 0, 0, 1, 0, 0), l(u, {
                        cutoff: null != e1.cutoff ? e1.cutoff : .5,
                        radius: null != e1.radius ? e1.radius : .5 * f
                    });
                };
            },
            65657: function(t1, e1, r) {
                var n;
                !function(i) {
                    var a = /^\s+/, o = /\s+$/, s = 0, l = i.round, c = i.min, u = i.max, h = i.random;
                    function f(t1, e1) {
                        if (e1 = e1 || {}, (t1 = t1 || "") instanceof f) return t1;
                        if (!(this instanceof f)) return new f(t1, e1);
                        var r = function(t1) {
                            var e1, r, n, s = {
                                r: 0,
                                g: 0,
                                b: 0
                            }, l = 1, h = null, f = null, p = null, d = !1, m = !1;
                            return "string" == typeof t1 && (t1 = function(t1) {
                                t1 = t1.replace(a, "").replace(o, "").toLowerCase();
                                var e1, r = !1;
                                if (L[t1]) t1 = L[t1], r = !0;
                                else if ("transparent" == t1) return {
                                    r: 0,
                                    g: 0,
                                    b: 0,
                                    a: 0,
                                    format: "name"
                                };
                                return (e1 = q.rgb.exec(t1)) ? {
                                    r: e1[1],
                                    g: e1[2],
                                    b: e1[3]
                                } : (e1 = q.rgba.exec(t1)) ? {
                                    r: e1[1],
                                    g: e1[2],
                                    b: e1[3],
                                    a: e1[4]
                                } : (e1 = q.hsl.exec(t1)) ? {
                                    h: e1[1],
                                    s: e1[2],
                                    l: e1[3]
                                } : (e1 = q.hsla.exec(t1)) ? {
                                    h: e1[1],
                                    s: e1[2],
                                    l: e1[3],
                                    a: e1[4]
                                } : (e1 = q.hsv.exec(t1)) ? {
                                    h: e1[1],
                                    s: e1[2],
                                    v: e1[3]
                                } : (e1 = q.hsva.exec(t1)) ? {
                                    h: e1[1],
                                    s: e1[2],
                                    v: e1[3],
                                    a: e1[4]
                                } : (e1 = q.hex8.exec(t1)) ? {
                                    r: D(e1[1]),
                                    g: D(e1[2]),
                                    b: D(e1[3]),
                                    a: N(e1[4]),
                                    format: r ? "name" : "hex8"
                                } : (e1 = q.hex6.exec(t1)) ? {
                                    r: D(e1[1]),
                                    g: D(e1[2]),
                                    b: D(e1[3]),
                                    format: r ? "name" : "hex"
                                } : (e1 = q.hex4.exec(t1)) ? {
                                    r: D(e1[1] + "" + e1[1]),
                                    g: D(e1[2] + "" + e1[2]),
                                    b: D(e1[3] + "" + e1[3]),
                                    a: N(e1[4] + "" + e1[4]),
                                    format: r ? "name" : "hex8"
                                } : !!(e1 = q.hex3.exec(t1)) && {
                                    r: D(e1[1] + "" + e1[1]),
                                    g: D(e1[2] + "" + e1[2]),
                                    b: D(e1[3] + "" + e1[3]),
                                    format: r ? "name" : "hex"
                                };
                            }(t1)), "object" == typeof t1 && (H(t1.r) && H(t1.g) && H(t1.b) ? (e1 = t1.r, r = t1.g, n = t1.b, s = {
                                r: 255 * z(e1, 255),
                                g: 255 * z(r, 255),
                                b: 255 * z(n, 255)
                            }, d = !0, m = "%" === String(t1.r).substr(-1) ? "prgb" : "rgb") : H(t1.h) && H(t1.s) && H(t1.v) ? (h = F(t1.s), f = F(t1.v), s = function(t1, e1, r) {
                                t1 = 6 * z(t1, 360), e1 = z(e1, 100), r = z(r, 100);
                                var n = i.floor(t1), a = t1 - n, o = r * (1 - e1), s = r * (1 - a * e1), l = r * (1 - (1 - a) * e1), c = n % 6;
                                return {
                                    r: 255 * [
                                        r,
                                        s,
                                        o,
                                        o,
                                        l,
                                        r
                                    ][c],
                                    g: 255 * [
                                        l,
                                        r,
                                        r,
                                        s,
                                        o,
                                        o
                                    ][c],
                                    b: 255 * [
                                        o,
                                        o,
                                        l,
                                        r,
                                        r,
                                        s
                                    ][c]
                                };
                            }(t1.h, h, f), d = !0, m = "hsv") : H(t1.h) && H(t1.s) && H(t1.l) && (h = F(t1.s), p = F(t1.l), s = function(t1, e1, r) {
                                var n, i, a;
                                function o(t1, e1, r) {
                                    return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? t1 + 6 * (e1 - t1) * r : r < .5 ? e1 : r < 2 / 3 ? t1 + (e1 - t1) * (2 / 3 - r) * 6 : t1;
                                }
                                if (t1 = z(t1, 360), e1 = z(e1, 100), r = z(r, 100), 0 === e1) n = i = a = r;
                                else {
                                    var s = r < .5 ? r * (1 + e1) : r + e1 - r * e1, l = 2 * r - s;
                                    n = o(l, s, t1 + 1 / 3), i = o(l, s, t1), a = o(l, s, t1 - 1 / 3);
                                }
                                return {
                                    r: 255 * n,
                                    g: 255 * i,
                                    b: 255 * a
                                };
                            }(t1.h, h, p), d = !0, m = "hsl"), t1.hasOwnProperty("a") && (l = t1.a)), l = P(l), {
                                ok: d,
                                format: t1.format || m,
                                r: c(255, u(s.r, 0)),
                                g: c(255, u(s.g, 0)),
                                b: c(255, u(s.b, 0)),
                                a: l
                            };
                        }(t1);
                        this._originalInput = t1, this._r = r.r, this._g = r.g, this._b = r.b, this._a = r.a, this._roundA = l(100 * this._a) / 100, this._format = e1.format || r.format, this._gradientType = e1.gradientType, this._r < 1 && (this._r = l(this._r)), this._g < 1 && (this._g = l(this._g)), this._b < 1 && (this._b = l(this._b)), this._ok = r.ok, this._tc_id = s++;
                    }
                    function p(t1, e1, r) {
                        t1 = z(t1, 255), e1 = z(e1, 255), r = z(r, 255);
                        var n, i, a = u(t1, e1, r), o = c(t1, e1, r), s = (a + o) / 2;
                        if (a == o) n = i = 0;
                        else {
                            var l = a - o;
                            switch(i = s > .5 ? l / (2 - a - o) : l / (a + o), a){
                                case t1:
                                    n = (e1 - r) / l + (e1 < r ? 6 : 0);
                                    break;
                                case e1:
                                    n = (r - t1) / l + 2;
                                    break;
                                case r:
                                    n = (t1 - e1) / l + 4;
                            }
                            n /= 6;
                        }
                        return {
                            h: n,
                            s: i,
                            l: s
                        };
                    }
                    function d(t1, e1, r) {
                        t1 = z(t1, 255), e1 = z(e1, 255), r = z(r, 255);
                        var n, i, a = u(t1, e1, r), o = c(t1, e1, r), s = a, l = a - o;
                        if (i = 0 === a ? 0 : l / a, a == o) n = 0;
                        else {
                            switch(a){
                                case t1:
                                    n = (e1 - r) / l + (e1 < r ? 6 : 0);
                                    break;
                                case e1:
                                    n = (r - t1) / l + 2;
                                    break;
                                case r:
                                    n = (t1 - e1) / l + 4;
                            }
                            n /= 6;
                        }
                        return {
                            h: n,
                            s: i,
                            v: s
                        };
                    }
                    function m(t1, e1, r, n) {
                        var i = [
                            R(l(t1).toString(16)),
                            R(l(e1).toString(16)),
                            R(l(r).toString(16))
                        ];
                        return n && i[0].charAt(0) == i[0].charAt(1) && i[1].charAt(0) == i[1].charAt(1) && i[2].charAt(0) == i[2].charAt(1) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) : i.join("");
                    }
                    function g(t1, e1, r, n) {
                        return [
                            R(B(n)),
                            R(l(t1).toString(16)),
                            R(l(e1).toString(16)),
                            R(l(r).toString(16))
                        ].join("");
                    }
                    function y(t1, e1) {
                        e1 = 0 === e1 ? 0 : e1 || 10;
                        var r = f(t1).toHsl();
                        return r.s -= e1 / 100, r.s = O(r.s), f(r);
                    }
                    function v(t1, e1) {
                        e1 = 0 === e1 ? 0 : e1 || 10;
                        var r = f(t1).toHsl();
                        return r.s += e1 / 100, r.s = O(r.s), f(r);
                    }
                    function x(t1) {
                        return f(t1).desaturate(100);
                    }
                    function _(t1, e1) {
                        e1 = 0 === e1 ? 0 : e1 || 10;
                        var r = f(t1).toHsl();
                        return r.l += e1 / 100, r.l = O(r.l), f(r);
                    }
                    function b(t1, e1) {
                        e1 = 0 === e1 ? 0 : e1 || 10;
                        var r = f(t1).toRgb();
                        return r.r = u(0, c(255, r.r - l(-e1 / 100 * 255))), r.g = u(0, c(255, r.g - l(-e1 / 100 * 255))), r.b = u(0, c(255, r.b - l(-e1 / 100 * 255))), f(r);
                    }
                    function w(t1, e1) {
                        e1 = 0 === e1 ? 0 : e1 || 10;
                        var r = f(t1).toHsl();
                        return r.l -= e1 / 100, r.l = O(r.l), f(r);
                    }
                    function T(t1, e1) {
                        var r = f(t1).toHsl(), n = (r.h + e1) % 360;
                        return r.h = n < 0 ? 360 + n : n, f(r);
                    }
                    function k(t1) {
                        var e1 = f(t1).toHsl();
                        return e1.h = (e1.h + 180) % 360, f(e1);
                    }
                    function A(t1) {
                        var e1 = f(t1).toHsl(), r = e1.h;
                        return [
                            f(t1),
                            f({
                                h: (r + 120) % 360,
                                s: e1.s,
                                l: e1.l
                            }),
                            f({
                                h: (r + 240) % 360,
                                s: e1.s,
                                l: e1.l
                            })
                        ];
                    }
                    function M(t1) {
                        var e1 = f(t1).toHsl(), r = e1.h;
                        return [
                            f(t1),
                            f({
                                h: (r + 90) % 360,
                                s: e1.s,
                                l: e1.l
                            }),
                            f({
                                h: (r + 180) % 360,
                                s: e1.s,
                                l: e1.l
                            }),
                            f({
                                h: (r + 270) % 360,
                                s: e1.s,
                                l: e1.l
                            })
                        ];
                    }
                    function S(t1) {
                        var e1 = f(t1).toHsl(), r = e1.h;
                        return [
                            f(t1),
                            f({
                                h: (r + 72) % 360,
                                s: e1.s,
                                l: e1.l
                            }),
                            f({
                                h: (r + 216) % 360,
                                s: e1.s,
                                l: e1.l
                            })
                        ];
                    }
                    function E(t1, e1, r) {
                        e1 = e1 || 6, r = r || 30;
                        var n = f(t1).toHsl(), i = 360 / r, a = [
                            f(t1)
                        ];
                        for(n.h = (n.h - (i * e1 >> 1) + 720) % 360; --e1;)n.h = (n.h + i) % 360, a.push(f(n));
                        return a;
                    }
                    function C(t1, e1) {
                        e1 = e1 || 6;
                        for(var r = f(t1).toHsv(), n = r.h, i = r.s, a = r.v, o = [], s = 1 / e1; e1--;)o.push(f({
                            h: n,
                            s: i,
                            v: a
                        })), a = (a + s) % 1;
                        return o;
                    }
                    f.prototype = {
                        isDark: function() {
                            return this.getBrightness() < 128;
                        },
                        isLight: function() {
                            return !this.isDark();
                        },
                        isValid: function() {
                            return this._ok;
                        },
                        getOriginalInput: function() {
                            return this._originalInput;
                        },
                        getFormat: function() {
                            return this._format;
                        },
                        getAlpha: function() {
                            return this._a;
                        },
                        getBrightness: function() {
                            var t1 = this.toRgb();
                            return (299 * t1.r + 587 * t1.g + 114 * t1.b) / 1e3;
                        },
                        getLuminance: function() {
                            var t1, e1, r, n = this.toRgb();
                            return t1 = n.r / 255, e1 = n.g / 255, r = n.b / 255, .2126 * (t1 <= .03928 ? t1 / 12.92 : i.pow((t1 + .055) / 1.055, 2.4)) + .7152 * (e1 <= .03928 ? e1 / 12.92 : i.pow((e1 + .055) / 1.055, 2.4)) + .0722 * (r <= .03928 ? r / 12.92 : i.pow((r + .055) / 1.055, 2.4));
                        },
                        setAlpha: function(t1) {
                            return this._a = P(t1), this._roundA = l(100 * this._a) / 100, this;
                        },
                        toHsv: function() {
                            var t1 = d(this._r, this._g, this._b);
                            return {
                                h: 360 * t1.h,
                                s: t1.s,
                                v: t1.v,
                                a: this._a
                            };
                        },
                        toHsvString: function() {
                            var t1 = d(this._r, this._g, this._b), e1 = l(360 * t1.h), r = l(100 * t1.s), n = l(100 * t1.v);
                            return 1 == this._a ? "hsv(" + e1 + ", " + r + "%, " + n + "%)" : "hsva(" + e1 + ", " + r + "%, " + n + "%, " + this._roundA + ")";
                        },
                        toHsl: function() {
                            var t1 = p(this._r, this._g, this._b);
                            return {
                                h: 360 * t1.h,
                                s: t1.s,
                                l: t1.l,
                                a: this._a
                            };
                        },
                        toHslString: function() {
                            var t1 = p(this._r, this._g, this._b), e1 = l(360 * t1.h), r = l(100 * t1.s), n = l(100 * t1.l);
                            return 1 == this._a ? "hsl(" + e1 + ", " + r + "%, " + n + "%)" : "hsla(" + e1 + ", " + r + "%, " + n + "%, " + this._roundA + ")";
                        },
                        toHex: function(t1) {
                            return m(this._r, this._g, this._b, t1);
                        },
                        toHexString: function(t1) {
                            return "#" + this.toHex(t1);
                        },
                        toHex8: function(t1) {
                            return function(t1, e1, r, n, i) {
                                var a = [
                                    R(l(t1).toString(16)),
                                    R(l(e1).toString(16)),
                                    R(l(r).toString(16)),
                                    R(B(n))
                                ];
                                return i && a[0].charAt(0) == a[0].charAt(1) && a[1].charAt(0) == a[1].charAt(1) && a[2].charAt(0) == a[2].charAt(1) && a[3].charAt(0) == a[3].charAt(1) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) + a[3].charAt(0) : a.join("");
                            }(this._r, this._g, this._b, this._a, t1);
                        },
                        toHex8String: function(t1) {
                            return "#" + this.toHex8(t1);
                        },
                        toRgb: function() {
                            return {
                                r: l(this._r),
                                g: l(this._g),
                                b: l(this._b),
                                a: this._a
                            };
                        },
                        toRgbString: function() {
                            return 1 == this._a ? "rgb(" + l(this._r) + ", " + l(this._g) + ", " + l(this._b) + ")" : "rgba(" + l(this._r) + ", " + l(this._g) + ", " + l(this._b) + ", " + this._roundA + ")";
                        },
                        toPercentageRgb: function() {
                            return {
                                r: l(100 * z(this._r, 255)) + "%",
                                g: l(100 * z(this._g, 255)) + "%",
                                b: l(100 * z(this._b, 255)) + "%",
                                a: this._a
                            };
                        },
                        toPercentageRgbString: function() {
                            return 1 == this._a ? "rgb(" + l(100 * z(this._r, 255)) + "%, " + l(100 * z(this._g, 255)) + "%, " + l(100 * z(this._b, 255)) + "%)" : "rgba(" + l(100 * z(this._r, 255)) + "%, " + l(100 * z(this._g, 255)) + "%, " + l(100 * z(this._b, 255)) + "%, " + this._roundA + ")";
                        },
                        toName: function() {
                            return 0 === this._a ? "transparent" : !(this._a < 1) && (I[m(this._r, this._g, this._b, !0)] || !1);
                        },
                        toFilter: function(t1) {
                            var e1 = "#" + g(this._r, this._g, this._b, this._a), r = e1, n = this._gradientType ? "GradientType = 1, " : "";
                            if (t1) {
                                var i = f(t1);
                                r = "#" + g(i._r, i._g, i._b, i._a);
                            }
                            return "progid:DXImageTransform.Microsoft.gradient(" + n + "startColorstr=" + e1 + ",endColorstr=" + r + ")";
                        },
                        toString: function(t1) {
                            var e1 = !!t1;
                            t1 = t1 || this._format;
                            var r = !1, n = this._a < 1 && this._a >= 0;
                            return e1 || !n || "hex" !== t1 && "hex6" !== t1 && "hex3" !== t1 && "hex4" !== t1 && "hex8" !== t1 && "name" !== t1 ? ("rgb" === t1 && (r = this.toRgbString()), "prgb" === t1 && (r = this.toPercentageRgbString()), "hex" !== t1 && "hex6" !== t1 || (r = this.toHexString()), "hex3" === t1 && (r = this.toHexString(!0)), "hex4" === t1 && (r = this.toHex8String(!0)), "hex8" === t1 && (r = this.toHex8String()), "name" === t1 && (r = this.toName()), "hsl" === t1 && (r = this.toHslString()), "hsv" === t1 && (r = this.toHsvString()), r || this.toHexString()) : "name" === t1 && 0 === this._a ? this.toName() : this.toRgbString();
                        },
                        clone: function() {
                            return f(this.toString());
                        },
                        _applyModification: function(t1, e1) {
                            var r = t1.apply(null, [
                                this
                            ].concat([].slice.call(e1)));
                            return this._r = r._r, this._g = r._g, this._b = r._b, this.setAlpha(r._a), this;
                        },
                        lighten: function() {
                            return this._applyModification(_, arguments);
                        },
                        brighten: function() {
                            return this._applyModification(b, arguments);
                        },
                        darken: function() {
                            return this._applyModification(w, arguments);
                        },
                        desaturate: function() {
                            return this._applyModification(y, arguments);
                        },
                        saturate: function() {
                            return this._applyModification(v, arguments);
                        },
                        greyscale: function() {
                            return this._applyModification(x, arguments);
                        },
                        spin: function() {
                            return this._applyModification(T, arguments);
                        },
                        _applyCombination: function(t1, e1) {
                            return t1.apply(null, [
                                this
                            ].concat([].slice.call(e1)));
                        },
                        analogous: function() {
                            return this._applyCombination(E, arguments);
                        },
                        complement: function() {
                            return this._applyCombination(k, arguments);
                        },
                        monochromatic: function() {
                            return this._applyCombination(C, arguments);
                        },
                        splitcomplement: function() {
                            return this._applyCombination(S, arguments);
                        },
                        triad: function() {
                            return this._applyCombination(A, arguments);
                        },
                        tetrad: function() {
                            return this._applyCombination(M, arguments);
                        }
                    }, f.fromRatio = function(t1, e1) {
                        if ("object" == typeof t1) {
                            var r = {};
                            for(var n in t1)t1.hasOwnProperty(n) && (r[n] = "a" === n ? t1[n] : F(t1[n]));
                            t1 = r;
                        }
                        return f(t1, e1);
                    }, f.equals = function(t1, e1) {
                        return !(!t1 || !e1) && f(t1).toRgbString() == f(e1).toRgbString();
                    }, f.random = function() {
                        return f.fromRatio({
                            r: h(),
                            g: h(),
                            b: h()
                        });
                    }, f.mix = function(t1, e1, r) {
                        r = 0 === r ? 0 : r || 50;
                        var n = f(t1).toRgb(), i = f(e1).toRgb(), a = r / 100;
                        return f({
                            r: (i.r - n.r) * a + n.r,
                            g: (i.g - n.g) * a + n.g,
                            b: (i.b - n.b) * a + n.b,
                            a: (i.a - n.a) * a + n.a
                        });
                    }, f.readability = function(t1, e1) {
                        var r = f(t1), n = f(e1);
                        return (i.max(r.getLuminance(), n.getLuminance()) + .05) / (i.min(r.getLuminance(), n.getLuminance()) + .05);
                    }, f.isReadable = function(t1, e1, r) {
                        var n, i, a, o, s, l = f.readability(t1, e1);
                        switch(i = !1, (a = r, "AA" !== (o = ((a = a || {
                            level: "AA",
                            size: "small"
                        }).level || "AA").toUpperCase()) && "AAA" !== o && (o = "AA"), "small" !== (s = (a.size || "small").toLowerCase()) && "large" !== s && (s = "small"), n = {
                            level: o,
                            size: s
                        }).level + n.size){
                            case "AAsmall":
                            case "AAAlarge":
                                i = l >= 4.5;
                                break;
                            case "AAlarge":
                                i = l >= 3;
                                break;
                            case "AAAsmall":
                                i = l >= 7;
                        }
                        return i;
                    }, f.mostReadable = function(t1, e1, r) {
                        var n, i, a, o, s = null, l = 0;
                        i = (r = r || {}).includeFallbackColors, a = r.level, o = r.size;
                        for(var c = 0; c < e1.length; c++)(n = f.readability(t1, e1[c])) > l && (l = n, s = f(e1[c]));
                        return f.isReadable(t1, s, {
                            level: a,
                            size: o
                        }) || !i ? s : (r.includeFallbackColors = !1, f.mostReadable(t1, [
                            "#fff",
                            "#000"
                        ], r));
                    };
                    var L = f.names = {
                        aliceblue: "f0f8ff",
                        antiquewhite: "faebd7",
                        aqua: "0ff",
                        aquamarine: "7fffd4",
                        azure: "f0ffff",
                        beige: "f5f5dc",
                        bisque: "ffe4c4",
                        black: "000",
                        blanchedalmond: "ffebcd",
                        blue: "00f",
                        blueviolet: "8a2be2",
                        brown: "a52a2a",
                        burlywood: "deb887",
                        burntsienna: "ea7e5d",
                        cadetblue: "5f9ea0",
                        chartreuse: "7fff00",
                        chocolate: "d2691e",
                        coral: "ff7f50",
                        cornflowerblue: "6495ed",
                        cornsilk: "fff8dc",
                        crimson: "dc143c",
                        cyan: "0ff",
                        darkblue: "00008b",
                        darkcyan: "008b8b",
                        darkgoldenrod: "b8860b",
                        darkgray: "a9a9a9",
                        darkgreen: "006400",
                        darkgrey: "a9a9a9",
                        darkkhaki: "bdb76b",
                        darkmagenta: "8b008b",
                        darkolivegreen: "556b2f",
                        darkorange: "ff8c00",
                        darkorchid: "9932cc",
                        darkred: "8b0000",
                        darksalmon: "e9967a",
                        darkseagreen: "8fbc8f",
                        darkslateblue: "483d8b",
                        darkslategray: "2f4f4f",
                        darkslategrey: "2f4f4f",
                        darkturquoise: "00ced1",
                        darkviolet: "9400d3",
                        deeppink: "ff1493",
                        deepskyblue: "00bfff",
                        dimgray: "696969",
                        dimgrey: "696969",
                        dodgerblue: "1e90ff",
                        firebrick: "b22222",
                        floralwhite: "fffaf0",
                        forestgreen: "228b22",
                        fuchsia: "f0f",
                        gainsboro: "dcdcdc",
                        ghostwhite: "f8f8ff",
                        gold: "ffd700",
                        goldenrod: "daa520",
                        gray: "808080",
                        green: "008000",
                        greenyellow: "adff2f",
                        grey: "808080",
                        honeydew: "f0fff0",
                        hotpink: "ff69b4",
                        indianred: "cd5c5c",
                        indigo: "4b0082",
                        ivory: "fffff0",
                        khaki: "f0e68c",
                        lavender: "e6e6fa",
                        lavenderblush: "fff0f5",
                        lawngreen: "7cfc00",
                        lemonchiffon: "fffacd",
                        lightblue: "add8e6",
                        lightcoral: "f08080",
                        lightcyan: "e0ffff",
                        lightgoldenrodyellow: "fafad2",
                        lightgray: "d3d3d3",
                        lightgreen: "90ee90",
                        lightgrey: "d3d3d3",
                        lightpink: "ffb6c1",
                        lightsalmon: "ffa07a",
                        lightseagreen: "20b2aa",
                        lightskyblue: "87cefa",
                        lightslategray: "789",
                        lightslategrey: "789",
                        lightsteelblue: "b0c4de",
                        lightyellow: "ffffe0",
                        lime: "0f0",
                        limegreen: "32cd32",
                        linen: "faf0e6",
                        magenta: "f0f",
                        maroon: "800000",
                        mediumaquamarine: "66cdaa",
                        mediumblue: "0000cd",
                        mediumorchid: "ba55d3",
                        mediumpurple: "9370db",
                        mediumseagreen: "3cb371",
                        mediumslateblue: "7b68ee",
                        mediumspringgreen: "00fa9a",
                        mediumturquoise: "48d1cc",
                        mediumvioletred: "c71585",
                        midnightblue: "191970",
                        mintcream: "f5fffa",
                        mistyrose: "ffe4e1",
                        moccasin: "ffe4b5",
                        navajowhite: "ffdead",
                        navy: "000080",
                        oldlace: "fdf5e6",
                        olive: "808000",
                        olivedrab: "6b8e23",
                        orange: "ffa500",
                        orangered: "ff4500",
                        orchid: "da70d6",
                        palegoldenrod: "eee8aa",
                        palegreen: "98fb98",
                        paleturquoise: "afeeee",
                        palevioletred: "db7093",
                        papayawhip: "ffefd5",
                        peachpuff: "ffdab9",
                        peru: "cd853f",
                        pink: "ffc0cb",
                        plum: "dda0dd",
                        powderblue: "b0e0e6",
                        purple: "800080",
                        rebeccapurple: "663399",
                        red: "f00",
                        rosybrown: "bc8f8f",
                        royalblue: "4169e1",
                        saddlebrown: "8b4513",
                        salmon: "fa8072",
                        sandybrown: "f4a460",
                        seagreen: "2e8b57",
                        seashell: "fff5ee",
                        sienna: "a0522d",
                        silver: "c0c0c0",
                        skyblue: "87ceeb",
                        slateblue: "6a5acd",
                        slategray: "708090",
                        slategrey: "708090",
                        snow: "fffafa",
                        springgreen: "00ff7f",
                        steelblue: "4682b4",
                        tan: "d2b48c",
                        teal: "008080",
                        thistle: "d8bfd8",
                        tomato: "ff6347",
                        turquoise: "40e0d0",
                        violet: "ee82ee",
                        wheat: "f5deb3",
                        white: "fff",
                        whitesmoke: "f5f5f5",
                        yellow: "ff0",
                        yellowgreen: "9acd32"
                    }, I = f.hexNames = function(t1) {
                        var e1 = {};
                        for(var r in t1)t1.hasOwnProperty(r) && (e1[t1[r]] = r);
                        return e1;
                    }(L);
                    function P(t1) {
                        return t1 = parseFloat(t1), (isNaN(t1) || t1 < 0 || t1 > 1) && (t1 = 1), t1;
                    }
                    function z(t1, e1) {
                        (function(t1) {
                            return "string" == typeof t1 && -1 != t1.indexOf(".") && 1 === parseFloat(t1);
                        })(t1) && (t1 = "100%");
                        var r = function(t1) {
                            return "string" == typeof t1 && -1 != t1.indexOf("%");
                        }(t1);
                        return t1 = c(e1, u(0, parseFloat(t1))), r && (t1 = parseInt(t1 * e1, 10) / 100), i.abs(t1 - e1) < 1e-6 ? 1 : t1 % e1 / parseFloat(e1);
                    }
                    function O(t1) {
                        return c(1, u(0, t1));
                    }
                    function D(t1) {
                        return parseInt(t1, 16);
                    }
                    function R(t1) {
                        return 1 == t1.length ? "0" + t1 : "" + t1;
                    }
                    function F(t1) {
                        return t1 <= 1 && (t1 = 100 * t1 + "%"), t1;
                    }
                    function B(t1) {
                        return i.round(255 * parseFloat(t1)).toString(16);
                    }
                    function N(t1) {
                        return D(t1) / 255;
                    }
                    var j, U, V, q = (U = "[\\s|\\(]+(" + (j = "(?:[-\\+]?\\d*\\.\\d+%?)|(?:[-\\+]?\\d+%?)") + ")[,|\\s]+(" + j + ")[,|\\s]+(" + j + ")\\s*\\)?", V = "[\\s|\\(]+(" + j + ")[,|\\s]+(" + j + ")[,|\\s]+(" + j + ")[,|\\s]+(" + j + ")\\s*\\)?", {
                        CSS_UNIT: new RegExp(j),
                        rgb: new RegExp("rgb" + U),
                        rgba: new RegExp("rgba" + V),
                        hsl: new RegExp("hsl" + U),
                        hsla: new RegExp("hsla" + V),
                        hsv: new RegExp("hsv" + U),
                        hsva: new RegExp("hsva" + V),
                        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
                        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
                        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
                        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
                    });
                    function H(t1) {
                        return !!q.CSS_UNIT.exec(t1);
                    }
                    t1.exports ? t1.exports = f : void 0 === (n = (function() {
                        return f;
                    }).call(e1, r, e1, t1)) || (t1.exports = n);
                }(Math);
            },
            51498: function(t1) {
                "use strict";
                t1.exports = r, t1.exports.float32 = t1.exports.float = r, t1.exports.fract32 = t1.exports.fract = function(t1, e1) {
                    if (t1.length) {
                        if (t1 instanceof Float32Array) return new Float32Array(t1.length);
                        e1 instanceof Float32Array || (e1 = r(t1));
                        for(var n = 0, i = e1.length; n < i; n++)e1[n] = t1[n] - e1[n];
                        return e1;
                    }
                    return r(t1 - r(t1));
                };
                var e1 = new Float32Array(1);
                function r(t1) {
                    return t1.length ? t1 instanceof Float32Array ? t1 : new Float32Array(t1) : (e1[0] = t1, e1[0]);
                }
            },
            44626: function(t1, e1, r) {
                "use strict";
                var n = r(4957);
                t1.exports = o;
                var i = 96;
                function a(t1, e1) {
                    var r = n(getComputedStyle(t1).getPropertyValue(e1));
                    return r[0] * o(r[1], t1);
                }
                function o(t1, e1) {
                    switch(e1 = e1 || document.body, t1 = (t1 || "px").trim().toLowerCase(), e1 !== window && e1 !== document || (e1 = document.body), t1){
                        case "%":
                            return e1.clientHeight / 100;
                        case "ch":
                        case "ex":
                            return function(t1, e1) {
                                var r = document.createElement("div");
                                r.style["font-size"] = "128" + t1, e1.appendChild(r);
                                var n = a(r, "font-size") / 128;
                                return e1.removeChild(r), n;
                            }(t1, e1);
                        case "em":
                            return a(e1, "font-size");
                        case "rem":
                            return a(document.body, "font-size");
                        case "vw":
                            return window.innerWidth / 100;
                        case "vh":
                            return window.innerHeight / 100;
                        case "vmin":
                            return Math.min(window.innerWidth, window.innerHeight) / 100;
                        case "vmax":
                            return Math.max(window.innerWidth, window.innerHeight) / 100;
                        case "in":
                            return i;
                        case "cm":
                            return i / 2.54;
                        case "mm":
                            return i / 25.4;
                        case "pt":
                            return i / 72;
                        case "pc":
                            return i / 6;
                    }
                    return 1;
                }
            },
            48640: function(t1, e1, r) {
                "use strict";
                function n(t1) {
                    return t1;
                }
                function i(t1, e1) {
                    return "string" == typeof e1 && (e1 = t1.objects[e1]), "GeometryCollection" === e1.type ? {
                        type: "FeatureCollection",
                        features: e1.geometries.map(function(e1) {
                            return a(t1, e1);
                        })
                    } : a(t1, e1);
                }
                function a(t1, e1) {
                    var r = e1.id, i = e1.bbox, a = null == e1.properties ? {} : e1.properties, o = function(t1, e1) {
                        var r = function(t1) {
                            if (null == t1) return n;
                            var e1, r, i = t1.scale[0], a = t1.scale[1], o = t1.translate[0], s = t1.translate[1];
                            return function(t1, n) {
                                n || (e1 = r = 0);
                                var l = 2, c = t1.length, u = new Array(c);
                                for(u[0] = (e1 += t1[0]) * i + o, u[1] = (r += t1[1]) * a + s; l < c;)u[l] = t1[l], ++l;
                                return u;
                            };
                        }(t1.transform), i = t1.arcs;
                        function a(t1, e1) {
                            e1.length && e1.pop();
                            for(var n = i[t1 < 0 ? ~t1 : t1], a = 0, o = n.length; a < o; ++a)e1.push(r(n[a], a));
                            t1 < 0 && function(t1, e1) {
                                for(var r, n = t1.length, i = n - e1; i < --n;)r = t1[i], t1[i++] = t1[n], t1[n] = r;
                            }(e1, o);
                        }
                        function o(t1) {
                            return r(t1);
                        }
                        function s(t1) {
                            for(var e1 = [], r = 0, n = t1.length; r < n; ++r)a(t1[r], e1);
                            return e1.length < 2 && e1.push(e1[0]), e1;
                        }
                        function l(t1) {
                            for(var e1 = s(t1); e1.length < 4;)e1.push(e1[0]);
                            return e1;
                        }
                        function c(t1) {
                            return t1.map(l);
                        }
                        return function t1(e1) {
                            var r, n = e1.type;
                            switch(n){
                                case "GeometryCollection":
                                    return {
                                        type: n,
                                        geometries: e1.geometries.map(t1)
                                    };
                                case "Point":
                                    r = o(e1.coordinates);
                                    break;
                                case "MultiPoint":
                                    r = e1.coordinates.map(o);
                                    break;
                                case "LineString":
                                    r = s(e1.arcs);
                                    break;
                                case "MultiLineString":
                                    r = e1.arcs.map(s);
                                    break;
                                case "Polygon":
                                    r = c(e1.arcs);
                                    break;
                                case "MultiPolygon":
                                    r = e1.arcs.map(c);
                                    break;
                                default:
                                    return null;
                            }
                            return {
                                type: n,
                                coordinates: r
                            };
                        }(e1);
                    }(t1, e1);
                    return null == r && null == i ? {
                        type: "Feature",
                        properties: a,
                        geometry: o
                    } : null == i ? {
                        type: "Feature",
                        id: r,
                        properties: a,
                        geometry: o
                    } : {
                        type: "Feature",
                        id: r,
                        bbox: i,
                        properties: a,
                        geometry: o
                    };
                }
                r.d(e1, {
                    N4: function() {
                        return i;
                    }
                });
            },
            64276: function(t1, e1, r) {
                "use strict";
                var n = r(31350);
                t1.exports = function(t1) {
                    if ("function" != typeof t1) return !1;
                    if (!hasOwnProperty.call(t1, "length")) return !1;
                    try {
                        if ("number" != typeof t1.length) return !1;
                        if ("function" != typeof t1.call) return !1;
                        if ("function" != typeof t1.apply) return !1;
                    } catch (t1) {
                        return !1;
                    }
                    return !n(t1);
                };
            },
            99497: function(t1, e1, r) {
                "use strict";
                var n = r(80299), i = r(76481), a = r(58698), o = r(60461), s = function(t1, e1) {
                    return t1.replace("%v", o(e1));
                };
                t1.exports = function(t1, e1, r) {
                    if (!i(r)) throw new TypeError(s(e1, t1));
                    if (!n(t1)) {
                        if ("default" in r) return r.default;
                        if (r.isOptional) return null;
                    }
                    var o = a(r.errorMessage);
                    throw n(o) || (o = e1), new TypeError(s(o, t1));
                };
            },
            78696: function(t1) {
                "use strict";
                t1.exports = function(t1) {
                    try {
                        return t1.toString();
                    } catch (e1) {
                        try {
                            return String(t1);
                        } catch (t1) {
                            return null;
                        }
                    }
                };
            },
            60461: function(t1, e1, r) {
                "use strict";
                var n = r(78696), i = /[\n\r\u2028\u2029]/g;
                t1.exports = function(t1) {
                    var e1 = n(t1);
                    return null === e1 ? "<Non-coercible to string value>" : (e1.length > 100 && (e1 = e1.slice(0, 99) + "\u2026"), e1 = e1.replace(i, function(t1) {
                        switch(t1){
                            case "\n":
                                return "\\n";
                            case "\r":
                                return "\\r";
                            case "\u2028":
                                return "\\u2028";
                            case "\u2029":
                                return "\\u2029";
                            default:
                                throw new Error("Unexpected character");
                        }
                    }));
                };
            },
            76481: function(t1, e1, r) {
                "use strict";
                var n = r(80299), i = {
                    object: !0,
                    function: !0,
                    undefined: !0
                };
                t1.exports = function(t1) {
                    return !!n(t1) && hasOwnProperty.call(i, typeof t1);
                };
            },
            6887: function(t1, e1, r) {
                "use strict";
                var n = r(99497), i = r(63461);
                t1.exports = function(t1) {
                    return i(t1) ? t1 : n(t1, "%v is not a plain function", arguments[1]);
                };
            },
            63461: function(t1, e1, r) {
                "use strict";
                var n = r(64276), i = /^\s*class[\s{/}]/, a = Function.prototype.toString;
                t1.exports = function(t1) {
                    return !!n(t1) && !i.test(a.call(t1));
                };
            },
            31350: function(t1, e1, r) {
                "use strict";
                var n = r(76481);
                t1.exports = function(t1) {
                    if (!n(t1)) return !1;
                    try {
                        return !!t1.constructor && t1.constructor.prototype === t1;
                    } catch (t1) {
                        return !1;
                    }
                };
            },
            58698: function(t1, e1, r) {
                "use strict";
                var n = r(80299), i = r(76481), a = Object.prototype.toString;
                t1.exports = function(t1) {
                    if (!n(t1)) return null;
                    if (i(t1)) {
                        var e1 = t1.toString;
                        if ("function" != typeof e1) return null;
                        if (e1 === a) return null;
                    }
                    try {
                        return "" + t1;
                    } catch (t1) {
                        return null;
                    }
                };
            },
            9557: function(t1, e1, r) {
                "use strict";
                var n = r(99497), i = r(80299);
                t1.exports = function(t1) {
                    return i(t1) ? t1 : n(t1, "Cannot use %v", arguments[1]);
                };
            },
            80299: function(t1) {
                "use strict";
                t1.exports = function(t1) {
                    return null != t1;
                };
            },
            66127: function(t1, e1, r) {
                "use strict";
                var n = r(54689), i = r(49523), a = r(45708).Buffer;
                r.g.__TYPEDARRAY_POOL || (r.g.__TYPEDARRAY_POOL = {
                    UINT8: i([
                        32,
                        0
                    ]),
                    UINT16: i([
                        32,
                        0
                    ]),
                    UINT32: i([
                        32,
                        0
                    ]),
                    BIGUINT64: i([
                        32,
                        0
                    ]),
                    INT8: i([
                        32,
                        0
                    ]),
                    INT16: i([
                        32,
                        0
                    ]),
                    INT32: i([
                        32,
                        0
                    ]),
                    BIGINT64: i([
                        32,
                        0
                    ]),
                    FLOAT: i([
                        32,
                        0
                    ]),
                    DOUBLE: i([
                        32,
                        0
                    ]),
                    DATA: i([
                        32,
                        0
                    ]),
                    UINT8C: i([
                        32,
                        0
                    ]),
                    BUFFER: i([
                        32,
                        0
                    ])
                });
                var o = "undefined" != typeof Uint8ClampedArray, s = "undefined" != typeof BigUint64Array, l = "undefined" != typeof BigInt64Array, c = r.g.__TYPEDARRAY_POOL;
                c.UINT8C || (c.UINT8C = i([
                    32,
                    0
                ])), c.BIGUINT64 || (c.BIGUINT64 = i([
                    32,
                    0
                ])), c.BIGINT64 || (c.BIGINT64 = i([
                    32,
                    0
                ])), c.BUFFER || (c.BUFFER = i([
                    32,
                    0
                ]));
                var u = c.DATA, h = c.BUFFER;
                function f(t1) {
                    if (t1) {
                        var e1 = t1.length || t1.byteLength, r = n.log2(e1);
                        u[r].push(t1);
                    }
                }
                function p(t1) {
                    t1 = n.nextPow2(t1);
                    var e1 = n.log2(t1), r = u[e1];
                    return r.length > 0 ? r.pop() : new ArrayBuffer(t1);
                }
                function d(t1) {
                    return new Uint8Array(p(t1), 0, t1);
                }
                function m(t1) {
                    return new Uint16Array(p(2 * t1), 0, t1);
                }
                function g(t1) {
                    return new Uint32Array(p(4 * t1), 0, t1);
                }
                function y(t1) {
                    return new Int8Array(p(t1), 0, t1);
                }
                function v(t1) {
                    return new Int16Array(p(2 * t1), 0, t1);
                }
                function x(t1) {
                    return new Int32Array(p(4 * t1), 0, t1);
                }
                function _(t1) {
                    return new Float32Array(p(4 * t1), 0, t1);
                }
                function b(t1) {
                    return new Float64Array(p(8 * t1), 0, t1);
                }
                function w(t1) {
                    return o ? new Uint8ClampedArray(p(t1), 0, t1) : d(t1);
                }
                function T(t1) {
                    return s ? new BigUint64Array(p(8 * t1), 0, t1) : null;
                }
                function k(t1) {
                    return l ? new BigInt64Array(p(8 * t1), 0, t1) : null;
                }
                function A(t1) {
                    return new DataView(p(t1), 0, t1);
                }
                function M(t1) {
                    t1 = n.nextPow2(t1);
                    var e1 = n.log2(t1), r = h[e1];
                    return r.length > 0 ? r.pop() : new a(t1);
                }
                e1.free = function(t1) {
                    if (a.isBuffer(t1)) h[n.log2(t1.length)].push(t1);
                    else {
                        if ("[object ArrayBuffer]" !== Object.prototype.toString.call(t1) && (t1 = t1.buffer), !t1) return;
                        var e1 = t1.length || t1.byteLength, r = 0 | n.log2(e1);
                        u[r].push(t1);
                    }
                }, e1.freeUint8 = e1.freeUint16 = e1.freeUint32 = e1.freeBigUint64 = e1.freeInt8 = e1.freeInt16 = e1.freeInt32 = e1.freeBigInt64 = e1.freeFloat32 = e1.freeFloat = e1.freeFloat64 = e1.freeDouble = e1.freeUint8Clamped = e1.freeDataView = function(t1) {
                    f(t1.buffer);
                }, e1.freeArrayBuffer = f, e1.freeBuffer = function(t1) {
                    h[n.log2(t1.length)].push(t1);
                }, e1.malloc = function(t1, e1) {
                    if (void 0 === e1 || "arraybuffer" === e1) return p(t1);
                    switch(e1){
                        case "uint8":
                            return d(t1);
                        case "uint16":
                            return m(t1);
                        case "uint32":
                            return g(t1);
                        case "int8":
                            return y(t1);
                        case "int16":
                            return v(t1);
                        case "int32":
                            return x(t1);
                        case "float":
                        case "float32":
                            return _(t1);
                        case "double":
                        case "float64":
                            return b(t1);
                        case "uint8_clamped":
                            return w(t1);
                        case "bigint64":
                            return k(t1);
                        case "biguint64":
                            return T(t1);
                        case "buffer":
                            return M(t1);
                        case "data":
                        case "dataview":
                            return A(t1);
                        default:
                            return null;
                    }
                    return null;
                }, e1.mallocArrayBuffer = p, e1.mallocUint8 = d, e1.mallocUint16 = m, e1.mallocUint32 = g, e1.mallocInt8 = y, e1.mallocInt16 = v, e1.mallocInt32 = x, e1.mallocFloat32 = e1.mallocFloat = _, e1.mallocFloat64 = e1.mallocDouble = b, e1.mallocUint8Clamped = w, e1.mallocBigUint64 = T, e1.mallocBigInt64 = k, e1.mallocDataView = A, e1.mallocBuffer = M, e1.clearCache = function() {
                    for(var t1 = 0; t1 < 32; ++t1)c.UINT8[t1].length = 0, c.UINT16[t1].length = 0, c.UINT32[t1].length = 0, c.INT8[t1].length = 0, c.INT16[t1].length = 0, c.INT32[t1].length = 0, c.FLOAT[t1].length = 0, c.DOUBLE[t1].length = 0, c.BIGUINT64[t1].length = 0, c.BIGINT64[t1].length = 0, c.UINT8C[t1].length = 0, u[t1].length = 0, h[t1].length = 0;
                };
            },
            80886: function(t1) {
                var e1 = /[\'\"]/;
                t1.exports = function(t1) {
                    return t1 ? (e1.test(t1.charAt(0)) && (t1 = t1.substr(1)), e1.test(t1.charAt(t1.length - 1)) && (t1 = t1.substr(0, t1.length - 1)), t1) : "";
                };
            },
            79788: function(t1) {
                "use strict";
                t1.exports = function(t1, e1, r) {
                    Array.isArray(r) || (r = [].slice.call(arguments, 2));
                    for(var n = 0, i = r.length; n < i; n++){
                        var a = r[n];
                        for(var o in a)if ((void 0 === e1[o] || Array.isArray(e1[o]) || t1[o] !== e1[o]) && o in e1) {
                            var s;
                            if (!0 === a[o]) s = e1[o];
                            else {
                                if (!1 === a[o]) continue;
                                if ("function" == typeof a[o] && void 0 === (s = a[o](e1[o], t1, e1))) continue;
                            }
                            t1[o] = s;
                        }
                    }
                    return t1;
                };
            },
            71103: function(t1, e1, r) {
                function n(t1) {
                    try {
                        if (!r.g.localStorage) return !1;
                    } catch (t1) {
                        return !1;
                    }
                    var e1 = r.g.localStorage[t1];
                    return null != e1 && "true" === String(e1).toLowerCase();
                }
                t1.exports = function(t1, e1) {
                    if (n("noDeprecation")) return t1;
                    var r = !1;
                    return function() {
                        if (!r) {
                            if (n("throwDeprecation")) throw new Error(e1);
                            n("traceDeprecation") ? console.trace(e1) : console.warn(e1), r = !0;
                        }
                        return t1.apply(this, arguments);
                    };
                };
            },
            44123: function(t1) {
                t1.exports = function(t1) {
                    return t1 && "object" == typeof t1 && "function" == typeof t1.copy && "function" == typeof t1.fill && "function" == typeof t1.readUInt8;
                };
            },
            15724: function(t1, e1, r) {
                "use strict";
                var n = r(40280), i = r(80340), a = r(96835), o = r(15628);
                function s(t1) {
                    return t1.call.bind(t1);
                }
                var l = "undefined" != typeof BigInt, c = "undefined" != typeof Symbol, u = s(Object.prototype.toString), h = s(Number.prototype.valueOf), f = s(String.prototype.valueOf), p = s(Boolean.prototype.valueOf);
                if (l) var d = s(BigInt.prototype.valueOf);
                if (c) var m = s(Symbol.prototype.valueOf);
                function g(t1, e1) {
                    if ("object" != typeof t1) return !1;
                    try {
                        return e1(t1), !0;
                    } catch (t1) {
                        return !1;
                    }
                }
                function y(t1) {
                    return "[object Map]" === u(t1);
                }
                function v(t1) {
                    return "[object Set]" === u(t1);
                }
                function x(t1) {
                    return "[object WeakMap]" === u(t1);
                }
                function _(t1) {
                    return "[object WeakSet]" === u(t1);
                }
                function b(t1) {
                    return "[object ArrayBuffer]" === u(t1);
                }
                function w(t1) {
                    return "undefined" != typeof ArrayBuffer && (b.working ? b(t1) : t1 instanceof ArrayBuffer);
                }
                function T(t1) {
                    return "[object DataView]" === u(t1);
                }
                function k(t1) {
                    return "undefined" != typeof DataView && (T.working ? T(t1) : t1 instanceof DataView);
                }
                e1.isArgumentsObject = n, e1.isGeneratorFunction = i, e1.isTypedArray = o, e1.isPromise = function(t1) {
                    return "undefined" != typeof Promise && t1 instanceof Promise || null !== t1 && "object" == typeof t1 && "function" == typeof t1.then && "function" == typeof t1.catch;
                }, e1.isArrayBufferView = function(t1) {
                    return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(t1) : o(t1) || k(t1);
                }, e1.isUint8Array = function(t1) {
                    return "Uint8Array" === a(t1);
                }, e1.isUint8ClampedArray = function(t1) {
                    return "Uint8ClampedArray" === a(t1);
                }, e1.isUint16Array = function(t1) {
                    return "Uint16Array" === a(t1);
                }, e1.isUint32Array = function(t1) {
                    return "Uint32Array" === a(t1);
                }, e1.isInt8Array = function(t1) {
                    return "Int8Array" === a(t1);
                }, e1.isInt16Array = function(t1) {
                    return "Int16Array" === a(t1);
                }, e1.isInt32Array = function(t1) {
                    return "Int32Array" === a(t1);
                }, e1.isFloat32Array = function(t1) {
                    return "Float32Array" === a(t1);
                }, e1.isFloat64Array = function(t1) {
                    return "Float64Array" === a(t1);
                }, e1.isBigInt64Array = function(t1) {
                    return "BigInt64Array" === a(t1);
                }, e1.isBigUint64Array = function(t1) {
                    return "BigUint64Array" === a(t1);
                }, y.working = "undefined" != typeof Map && y(new Map), e1.isMap = function(t1) {
                    return "undefined" != typeof Map && (y.working ? y(t1) : t1 instanceof Map);
                }, v.working = "undefined" != typeof Set && v(new Set), e1.isSet = function(t1) {
                    return "undefined" != typeof Set && (v.working ? v(t1) : t1 instanceof Set);
                }, x.working = "undefined" != typeof WeakMap && x(new WeakMap), e1.isWeakMap = function(t1) {
                    return "undefined" != typeof WeakMap && (x.working ? x(t1) : t1 instanceof WeakMap);
                }, _.working = "undefined" != typeof WeakSet && _(new WeakSet), e1.isWeakSet = function(t1) {
                    return _(t1);
                }, b.working = "undefined" != typeof ArrayBuffer && b(new ArrayBuffer), e1.isArrayBuffer = w, T.working = "undefined" != typeof ArrayBuffer && "undefined" != typeof DataView && T(new DataView(new ArrayBuffer(1), 0, 1)), e1.isDataView = k;
                var A = "undefined" != typeof SharedArrayBuffer ? SharedArrayBuffer : void 0;
                function M(t1) {
                    return "[object SharedArrayBuffer]" === u(t1);
                }
                function S(t1) {
                    return void 0 !== A && (void 0 === M.working && (M.working = M(new A)), M.working ? M(t1) : t1 instanceof A);
                }
                function E(t1) {
                    return g(t1, h);
                }
                function C(t1) {
                    return g(t1, f);
                }
                function L(t1) {
                    return g(t1, p);
                }
                function I(t1) {
                    return l && g(t1, d);
                }
                function P(t1) {
                    return c && g(t1, m);
                }
                e1.isSharedArrayBuffer = S, e1.isAsyncFunction = function(t1) {
                    return "[object AsyncFunction]" === u(t1);
                }, e1.isMapIterator = function(t1) {
                    return "[object Map Iterator]" === u(t1);
                }, e1.isSetIterator = function(t1) {
                    return "[object Set Iterator]" === u(t1);
                }, e1.isGeneratorObject = function(t1) {
                    return "[object Generator]" === u(t1);
                }, e1.isWebAssemblyCompiledModule = function(t1) {
                    return "[object WebAssembly.Module]" === u(t1);
                }, e1.isNumberObject = E, e1.isStringObject = C, e1.isBooleanObject = L, e1.isBigIntObject = I, e1.isSymbolObject = P, e1.isBoxedPrimitive = function(t1) {
                    return E(t1) || C(t1) || L(t1) || I(t1) || P(t1);
                }, e1.isAnyArrayBuffer = function(t1) {
                    return "undefined" != typeof Uint8Array && (w(t1) || S(t1));
                }, [
                    "isProxy",
                    "isExternal",
                    "isModuleNamespaceObject"
                ].forEach(function(t1) {
                    Object.defineProperty(e1, t1, {
                        enumerable: !1,
                        value: function() {
                            throw new Error(t1 + " is not supported in userland");
                        }
                    });
                });
            },
            56557: function(t1, e1, r) {
                var n = r(33282), i = Object.getOwnPropertyDescriptors || function(t1) {
                    for(var e1 = Object.keys(t1), r = {}, n = 0; n < e1.length; n++)r[e1[n]] = Object.getOwnPropertyDescriptor(t1, e1[n]);
                    return r;
                }, a = /%[sdj%]/g;
                e1.format = function(t1) {
                    if (!x(t1)) {
                        for(var e1 = [], r = 0; r < arguments.length; r++)e1.push(c(arguments[r]));
                        return e1.join(" ");
                    }
                    r = 1;
                    for(var n = arguments, i = n.length, o = String(t1).replace(a, function(t1) {
                        if ("%%" === t1) return "%";
                        if (r >= i) return t1;
                        switch(t1){
                            case "%s":
                                return String(n[r++]);
                            case "%d":
                                return Number(n[r++]);
                            case "%j":
                                try {
                                    return JSON.stringify(n[r++]);
                                } catch (t1) {
                                    return "[Circular]";
                                }
                            default:
                                return t1;
                        }
                    }), s = n[r]; r < i; s = n[++r])y(s) || !w(s) ? o += " " + s : o += " " + c(s);
                    return o;
                }, e1.deprecate = function(t1, r) {
                    if (void 0 !== n && !0 === n.noDeprecation) return t1;
                    if (void 0 === n) return function() {
                        return e1.deprecate(t1, r).apply(this, arguments);
                    };
                    var i = !1;
                    return function() {
                        if (!i) {
                            if (n.throwDeprecation) throw new Error(r);
                            n.traceDeprecation ? console.trace(r) : console.error(r), i = !0;
                        }
                        return t1.apply(this, arguments);
                    };
                };
                var o = {}, s = /^$/;
                if (n.env.NODE_DEBUG) {
                    var l = n.env.NODE_DEBUG;
                    l = l.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), s = new RegExp("^" + l + "$", "i");
                }
                function c(t1, r) {
                    var n = {
                        seen: [],
                        stylize: h
                    };
                    return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), g(r) ? n.showHidden = r : r && e1._extend(n, r), _(n.showHidden) && (n.showHidden = !1), _(n.depth) && (n.depth = 2), _(n.colors) && (n.colors = !1), _(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = u), f(n, t1, n.depth);
                }
                function u(t1, e1) {
                    var r = c.styles[e1];
                    return r ? "\x1b[" + c.colors[r][0] + "m" + t1 + "\x1b[" + c.colors[r][1] + "m" : t1;
                }
                function h(t1, e1) {
                    return t1;
                }
                function f(t1, r, n) {
                    if (t1.customInspect && r && A(r.inspect) && r.inspect !== e1.inspect && (!r.constructor || r.constructor.prototype !== r)) {
                        var i = r.inspect(n, t1);
                        return x(i) || (i = f(t1, i, n)), i;
                    }
                    var a = function(t1, e1) {
                        if (_(e1)) return t1.stylize("undefined", "undefined");
                        if (x(e1)) {
                            var r = "'" + JSON.stringify(e1).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
                            return t1.stylize(r, "string");
                        }
                        return v(e1) ? t1.stylize("" + e1, "number") : g(e1) ? t1.stylize("" + e1, "boolean") : y(e1) ? t1.stylize("null", "null") : void 0;
                    }(t1, r);
                    if (a) return a;
                    var o = Object.keys(r), s = function(t1) {
                        var e1 = {};
                        return t1.forEach(function(t1, r) {
                            e1[t1] = !0;
                        }), e1;
                    }(o);
                    if (t1.showHidden && (o = Object.getOwnPropertyNames(r)), k(r) && (o.indexOf("message") >= 0 || o.indexOf("description") >= 0)) return p(r);
                    if (0 === o.length) {
                        if (A(r)) {
                            var l = r.name ? ": " + r.name : "";
                            return t1.stylize("[Function" + l + "]", "special");
                        }
                        if (b(r)) return t1.stylize(RegExp.prototype.toString.call(r), "regexp");
                        if (T(r)) return t1.stylize(Date.prototype.toString.call(r), "date");
                        if (k(r)) return p(r);
                    }
                    var c, u = "", h = !1, w = [
                        "{",
                        "}"
                    ];
                    return m(r) && (h = !0, w = [
                        "[",
                        "]"
                    ]), A(r) && (u = " [Function" + (r.name ? ": " + r.name : "") + "]"), b(r) && (u = " " + RegExp.prototype.toString.call(r)), T(r) && (u = " " + Date.prototype.toUTCString.call(r)), k(r) && (u = " " + p(r)), 0 !== o.length || h && 0 != r.length ? n < 0 ? b(r) ? t1.stylize(RegExp.prototype.toString.call(r), "regexp") : t1.stylize("[Object]", "special") : (t1.seen.push(r), c = h ? function(t1, e1, r, n, i) {
                        for(var a = [], o = 0, s = e1.length; o < s; ++o)C(e1, String(o)) ? a.push(d(t1, e1, r, n, String(o), !0)) : a.push("");
                        return i.forEach(function(i) {
                            i.match(/^\d+$/) || a.push(d(t1, e1, r, n, i, !0));
                        }), a;
                    }(t1, r, n, s, o) : o.map(function(e1) {
                        return d(t1, r, n, s, e1, h);
                    }), t1.seen.pop(), function(t1, e1, r) {
                        return t1.reduce(function(t1, e1) {
                            return e1.indexOf("\n"), t1 + e1.replace(/\u001b\[\d\d?m/g, "").length + 1;
                        }, 0) > 60 ? r[0] + ("" === e1 ? "" : e1 + "\n ") + " " + t1.join(",\n  ") + " " + r[1] : r[0] + e1 + " " + t1.join(", ") + " " + r[1];
                    }(c, u, w)) : w[0] + u + w[1];
                }
                function p(t1) {
                    return "[" + Error.prototype.toString.call(t1) + "]";
                }
                function d(t1, e1, r, n, i, a) {
                    var o, s, l;
                    if ((l = Object.getOwnPropertyDescriptor(e1, i) || {
                        value: e1[i]
                    }).get ? s = l.set ? t1.stylize("[Getter/Setter]", "special") : t1.stylize("[Getter]", "special") : l.set && (s = t1.stylize("[Setter]", "special")), C(n, i) || (o = "[" + i + "]"), s || (t1.seen.indexOf(l.value) < 0 ? (s = y(r) ? f(t1, l.value, null) : f(t1, l.value, r - 1)).indexOf("\n") > -1 && (s = a ? s.split("\n").map(function(t1) {
                        return "  " + t1;
                    }).join("\n").slice(2) : "\n" + s.split("\n").map(function(t1) {
                        return "   " + t1;
                    }).join("\n")) : s = t1.stylize("[Circular]", "special")), _(o)) {
                        if (a && i.match(/^\d+$/)) return s;
                        (o = JSON.stringify("" + i)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (o = o.slice(1, -1), o = t1.stylize(o, "name")) : (o = o.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), o = t1.stylize(o, "string"));
                    }
                    return o + ": " + s;
                }
                function m(t1) {
                    return Array.isArray(t1);
                }
                function g(t1) {
                    return "boolean" == typeof t1;
                }
                function y(t1) {
                    return null === t1;
                }
                function v(t1) {
                    return "number" == typeof t1;
                }
                function x(t1) {
                    return "string" == typeof t1;
                }
                function _(t1) {
                    return void 0 === t1;
                }
                function b(t1) {
                    return w(t1) && "[object RegExp]" === M(t1);
                }
                function w(t1) {
                    return "object" == typeof t1 && null !== t1;
                }
                function T(t1) {
                    return w(t1) && "[object Date]" === M(t1);
                }
                function k(t1) {
                    return w(t1) && ("[object Error]" === M(t1) || t1 instanceof Error);
                }
                function A(t1) {
                    return "function" == typeof t1;
                }
                function M(t1) {
                    return Object.prototype.toString.call(t1);
                }
                function S(t1) {
                    return t1 < 10 ? "0" + t1.toString(10) : t1.toString(10);
                }
                e1.debuglog = function(t1) {
                    if (t1 = t1.toUpperCase(), !o[t1]) {
                        if (s.test(t1)) {
                            var r = n.pid;
                            o[t1] = function() {
                                var n = e1.format.apply(e1, arguments);
                                console.error("%s %d: %s", t1, r, n);
                            };
                        } else o[t1] = function() {};
                    }
                    return o[t1];
                }, e1.inspect = c, c.colors = {
                    bold: [
                        1,
                        22
                    ],
                    italic: [
                        3,
                        23
                    ],
                    underline: [
                        4,
                        24
                    ],
                    inverse: [
                        7,
                        27
                    ],
                    white: [
                        37,
                        39
                    ],
                    grey: [
                        90,
                        39
                    ],
                    black: [
                        30,
                        39
                    ],
                    blue: [
                        34,
                        39
                    ],
                    cyan: [
                        36,
                        39
                    ],
                    green: [
                        32,
                        39
                    ],
                    magenta: [
                        35,
                        39
                    ],
                    red: [
                        31,
                        39
                    ],
                    yellow: [
                        33,
                        39
                    ]
                }, c.styles = {
                    special: "cyan",
                    number: "yellow",
                    boolean: "yellow",
                    undefined: "grey",
                    null: "bold",
                    string: "green",
                    date: "magenta",
                    regexp: "red"
                }, e1.types = r(15724), e1.isArray = m, e1.isBoolean = g, e1.isNull = y, e1.isNullOrUndefined = function(t1) {
                    return null == t1;
                }, e1.isNumber = v, e1.isString = x, e1.isSymbol = function(t1) {
                    return "symbol" == typeof t1;
                }, e1.isUndefined = _, e1.isRegExp = b, e1.types.isRegExp = b, e1.isObject = w, e1.isDate = T, e1.types.isDate = T, e1.isError = k, e1.types.isNativeError = k, e1.isFunction = A, e1.isPrimitive = function(t1) {
                    return null === t1 || "boolean" == typeof t1 || "number" == typeof t1 || "string" == typeof t1 || "symbol" == typeof t1 || void 0 === t1;
                }, e1.isBuffer = r(44123);
                var E = [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec"
                ];
                function C(t1, e1) {
                    return Object.prototype.hasOwnProperty.call(t1, e1);
                }
                e1.log = function() {
                    var t1, r;
                    console.log("%s - %s", (r = [
                        S((t1 = new Date).getHours()),
                        S(t1.getMinutes()),
                        S(t1.getSeconds())
                    ].join(":"), [
                        t1.getDate(),
                        E[t1.getMonth()],
                        r
                    ].join(" ")), e1.format.apply(e1, arguments));
                }, e1.inherits = r(28062), e1._extend = function(t1, e1) {
                    if (!e1 || !w(e1)) return t1;
                    for(var r = Object.keys(e1), n = r.length; n--;)t1[r[n]] = e1[r[n]];
                    return t1;
                };
                var L = "undefined" != typeof Symbol ? Symbol("util.promisify.custom") : void 0;
                function I(t1, e1) {
                    if (!t1) {
                        var r = new Error("Promise was rejected with a falsy value");
                        r.reason = t1, t1 = r;
                    }
                    return e1(t1);
                }
                e1.promisify = function(t1) {
                    if ("function" != typeof t1) throw new TypeError('The "original" argument must be of type Function');
                    if (L && t1[L]) {
                        var e1;
                        if ("function" != typeof (e1 = t1[L])) throw new TypeError('The "util.promisify.custom" argument must be of type Function');
                        return Object.defineProperty(e1, L, {
                            value: e1,
                            enumerable: !1,
                            writable: !1,
                            configurable: !0
                        }), e1;
                    }
                    function e1() {
                        for(var e1, r, n = new Promise(function(t1, n) {
                            e1 = t1, r = n;
                        }), i = [], a = 0; a < arguments.length; a++)i.push(arguments[a]);
                        i.push(function(t1, n) {
                            t1 ? r(t1) : e1(n);
                        });
                        try {
                            t1.apply(this, i);
                        } catch (t1) {
                            r(t1);
                        }
                        return n;
                    }
                    return Object.setPrototypeOf(e1, Object.getPrototypeOf(t1)), L && Object.defineProperty(e1, L, {
                        value: e1,
                        enumerable: !1,
                        writable: !1,
                        configurable: !0
                    }), Object.defineProperties(e1, i(t1));
                }, e1.promisify.custom = L, e1.callbackify = function(t1) {
                    if ("function" != typeof t1) throw new TypeError('The "original" argument must be of type Function');
                    function e1() {
                        for(var e1 = [], r = 0; r < arguments.length; r++)e1.push(arguments[r]);
                        var i = e1.pop();
                        if ("function" != typeof i) throw new TypeError("The last argument must be of type Function");
                        var a = this, o = function() {
                            return i.apply(a, arguments);
                        };
                        t1.apply(this, e1).then(function(t1) {
                            n.nextTick(o.bind(null, null, t1));
                        }, function(t1) {
                            n.nextTick(I.bind(null, t1, o));
                        });
                    }
                    return Object.setPrototypeOf(e1, Object.getPrototypeOf(t1)), Object.defineProperties(e1, i(t1)), e1;
                };
            },
            22248: function(t1, e1, r) {
                var n = r(72880);
                t1.exports = function(t1) {
                    return n("webgl", t1);
                };
            },
            96835: function(t1, e1, r) {
                "use strict";
                var n = r(61262), i = r(70085), a = r(87227), o = r(63063), s = r(52991), l = o("Object.prototype.toString"), c = r(36912)(), u = "undefined" == typeof globalThis ? r.g : globalThis, h = i(), f = o("String.prototype.slice"), p = Object.getPrototypeOf, d = o("Array.prototype.indexOf", !0) || function(t1, e1) {
                    for(var r = 0; r < t1.length; r += 1)if (t1[r] === e1) return r;
                    return -1;
                }, m = {
                    __proto__: null
                };
                n(h, c && s && p ? function(t1) {
                    var e1 = new u[t1];
                    if (Symbol.toStringTag in e1) {
                        var r = p(e1), n = s(r, Symbol.toStringTag);
                        if (!n) {
                            var i = p(r);
                            n = s(i, Symbol.toStringTag);
                        }
                        m["$" + t1] = a(n.get);
                    }
                } : function(t1) {
                    var e1 = new u[t1], r = e1.slice || e1.set;
                    r && (m["$" + t1] = a(r));
                }), t1.exports = function(t1) {
                    if (!t1 || "object" != typeof t1) return !1;
                    if (!c) {
                        var e1 = f(l(t1), 8, -1);
                        return d(h, e1) > -1 ? e1 : "Object" === e1 && function(t1) {
                            var e1 = !1;
                            return n(m, function(r, n) {
                                if (!e1) try {
                                    r(t1), e1 = f(n, 1);
                                } catch (t1) {}
                            }), e1;
                        }(t1);
                    }
                    return s ? function(t1) {
                        var e1 = !1;
                        return n(m, function(r, n) {
                            if (!e1) try {
                                "$" + r(t1) === n && (e1 = f(n, 1));
                            } catch (t1) {}
                        }), e1;
                    }(t1) : null;
                };
            },
            1401: function(t1, e1, r) {
                var n = r(24453), i = r(27976), a = n.instance();
                function o(t1) {
                    this.local = this.regionalOptions[t1 || ""] || this.regionalOptions[""];
                }
                o.prototype = new n.baseCalendar, i(o.prototype, {
                    name: "Chinese",
                    jdEpoch: 1721425.5,
                    hasYearZero: !1,
                    minMonth: 0,
                    firstMonth: 0,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Chinese",
                            epochs: [
                                "BEC",
                                "EC"
                            ],
                            monthNumbers: function(t1, e1) {
                                if ("string" == typeof t1) {
                                    var r = t1.match(l);
                                    return r ? r[0] : "";
                                }
                                var n = this._validateYear(t1), i = t1.month(), a = "" + this.toChineseMonth(n, i);
                                return e1 && a.length < 2 && (a = "0" + a), this.isIntercalaryMonth(n, i) && (a += "i"), a;
                            },
                            monthNames: function(t1) {
                                if ("string" == typeof t1) {
                                    var e1 = t1.match(c);
                                    return e1 ? e1[0] : "";
                                }
                                var r = this._validateYear(t1), n = t1.month(), i = [
                                    "\u4E00\u6708",
                                    "\u4E8C\u6708",
                                    "\u4E09\u6708",
                                    "\u56DB\u6708",
                                    "\u4E94\u6708",
                                    "\u516D\u6708",
                                    "\u4E03\u6708",
                                    "\u516B\u6708",
                                    "\u4E5D\u6708",
                                    "\u5341\u6708",
                                    "\u5341\u4E00\u6708",
                                    "\u5341\u4E8C\u6708"
                                ][this.toChineseMonth(r, n) - 1];
                                return this.isIntercalaryMonth(r, n) && (i = "\u95F0" + i), i;
                            },
                            monthNamesShort: function(t1) {
                                if ("string" == typeof t1) {
                                    var e1 = t1.match(u);
                                    return e1 ? e1[0] : "";
                                }
                                var r = this._validateYear(t1), n = t1.month(), i = [
                                    "\u4E00",
                                    "\u4E8C",
                                    "\u4E09",
                                    "\u56DB",
                                    "\u4E94",
                                    "\u516D",
                                    "\u4E03",
                                    "\u516B",
                                    "\u4E5D",
                                    "\u5341",
                                    "\u5341\u4E00",
                                    "\u5341\u4E8C"
                                ][this.toChineseMonth(r, n) - 1];
                                return this.isIntercalaryMonth(r, n) && (i = "\u95F0" + i), i;
                            },
                            parseMonth: function(t1, e1) {
                                t1 = this._validateYear(t1);
                                var r, n = parseInt(e1);
                                if (isNaN(n)) "\u95F0" === e1[0] && (r = !0, e1 = e1.substring(1)), "\u6708" === e1[e1.length - 1] && (e1 = e1.substring(0, e1.length - 1)), n = 1 + [
                                    "\u4E00",
                                    "\u4E8C",
                                    "\u4E09",
                                    "\u56DB",
                                    "\u4E94",
                                    "\u516D",
                                    "\u4E03",
                                    "\u516B",
                                    "\u4E5D",
                                    "\u5341",
                                    "\u5341\u4E00",
                                    "\u5341\u4E8C"
                                ].indexOf(e1);
                                else {
                                    var i = e1[e1.length - 1];
                                    r = "i" === i || "I" === i;
                                }
                                return this.toMonthIndex(t1, n, r);
                            },
                            dayNames: [
                                "Sunday",
                                "Monday",
                                "Tuesday",
                                "Wednesday",
                                "Thursday",
                                "Friday",
                                "Saturday"
                            ],
                            dayNamesShort: [
                                "Sun",
                                "Mon",
                                "Tue",
                                "Wed",
                                "Thu",
                                "Fri",
                                "Sat"
                            ],
                            dayNamesMin: [
                                "Su",
                                "Mo",
                                "Tu",
                                "We",
                                "Th",
                                "Fr",
                                "Sa"
                            ],
                            digits: null,
                            dateFormat: "yyyy/mm/dd",
                            firstDay: 1,
                            isRTL: !1
                        }
                    },
                    _validateYear: function(t1, e1) {
                        if (t1.year && (t1 = t1.year()), "number" != typeof t1 || t1 < 1888 || t1 > 2111) throw e1.replace(/\{0\}/, this.local.name);
                        return t1;
                    },
                    toMonthIndex: function(t1, e1, r) {
                        var i = this.intercalaryMonth(t1);
                        if (r && e1 !== i || e1 < 1 || e1 > 12) throw n.local.invalidMonth.replace(/\{0\}/, this.local.name);
                        return i ? !r && e1 <= i ? e1 - 1 : e1 : e1 - 1;
                    },
                    toChineseMonth: function(t1, e1) {
                        t1.year && (e1 = (t1 = t1.year()).month());
                        var r = this.intercalaryMonth(t1);
                        if (e1 < 0 || e1 > (r ? 12 : 11)) throw n.local.invalidMonth.replace(/\{0\}/, this.local.name);
                        return r ? e1 < r ? e1 + 1 : e1 : e1 + 1;
                    },
                    intercalaryMonth: function(t1) {
                        return t1 = this._validateYear(t1), h[t1 - h[0]] >> 13;
                    },
                    isIntercalaryMonth: function(t1, e1) {
                        t1.year && (e1 = (t1 = t1.year()).month());
                        var r = this.intercalaryMonth(t1);
                        return !!r && r === e1;
                    },
                    leapYear: function(t1) {
                        return 0 !== this.intercalaryMonth(t1);
                    },
                    weekOfYear: function(t1, e1, r) {
                        var i, o = this._validateYear(t1, n.local.invalidyear), s = f[o - f[0]], l = s >> 9 & 4095, c = s >> 5 & 15, u = 31 & s;
                        (i = a.newDate(l, c, u)).add(4 - (i.dayOfWeek() || 7), "d");
                        var h = this.toJD(t1, e1, r) - i.toJD();
                        return 1 + Math.floor(h / 7);
                    },
                    monthsInYear: function(t1) {
                        return this.leapYear(t1) ? 13 : 12;
                    },
                    daysInMonth: function(t1, e1) {
                        t1.year && (e1 = t1.month(), t1 = t1.year()), t1 = this._validateYear(t1);
                        var r = h[t1 - h[0]];
                        if (e1 > (r >> 13 ? 12 : 11)) throw n.local.invalidMonth.replace(/\{0\}/, this.local.name);
                        return r & 1 << 12 - e1 ? 30 : 29;
                    },
                    weekDay: function(t1, e1, r) {
                        return (this.dayOfWeek(t1, e1, r) || 7) < 6;
                    },
                    toJD: function(t1, e1, r) {
                        var i = this._validate(t1, s, r, n.local.invalidDate);
                        t1 = this._validateYear(i.year()), e1 = i.month(), r = i.day();
                        var o = this.isIntercalaryMonth(t1, e1), s = this.toChineseMonth(t1, e1), l = function(t1, e1, r, n, i) {
                            var a, o, s;
                            if ("object" == typeof t1) o = t1, a = e1 || {};
                            else {
                                var l;
                                if (!("number" == typeof t1 && t1 >= 1888 && t1 <= 2111)) throw new Error("Lunar year outside range 1888-2111");
                                if (!("number" == typeof e1 && e1 >= 1 && e1 <= 12)) throw new Error("Lunar month outside range 1 - 12");
                                if (!("number" == typeof r && r >= 1 && r <= 30)) throw new Error("Lunar day outside range 1 - 30");
                                "object" == typeof n ? (l = !1, a = n) : (l = !!n, a = {}), o = {
                                    year: t1,
                                    month: e1,
                                    day: r,
                                    isIntercalary: l
                                };
                            }
                            s = o.day - 1;
                            var c, u = h[o.year - h[0]], p = u >> 13;
                            c = p && (o.month > p || o.isIntercalary) ? o.month : o.month - 1;
                            for(var d = 0; d < c; d++)s += u & 1 << 12 - d ? 30 : 29;
                            var m = f[o.year - f[0]], g = new Date(m >> 9 & 4095, (m >> 5 & 15) - 1, (31 & m) + s);
                            return a.year = g.getFullYear(), a.month = 1 + g.getMonth(), a.day = g.getDate(), a;
                        }(t1, s, r, o);
                        return a.toJD(l.year, l.month, l.day);
                    },
                    fromJD: function(t1) {
                        var e1 = a.fromJD(t1), r = function(t1, e1, r, n) {
                            var i, a;
                            if ("object" == typeof t1) i = t1, a = e1 || {};
                            else {
                                if (!("number" == typeof t1 && t1 >= 1888 && t1 <= 2111)) throw new Error("Solar year outside range 1888-2111");
                                if (!("number" == typeof e1 && e1 >= 1 && e1 <= 12)) throw new Error("Solar month outside range 1 - 12");
                                if (!("number" == typeof r && r >= 1 && r <= 31)) throw new Error("Solar day outside range 1 - 31");
                                i = {
                                    year: t1,
                                    month: e1,
                                    day: r
                                }, a = {};
                            }
                            var o = f[i.year - f[0]], s = i.year << 9 | i.month << 5 | i.day;
                            a.year = s >= o ? i.year : i.year - 1, o = f[a.year - f[0]];
                            var l, c = new Date(o >> 9 & 4095, (o >> 5 & 15) - 1, 31 & o), u = new Date(i.year, i.month - 1, i.day);
                            l = Math.round((u - c) / 864e5);
                            var p, d = h[a.year - h[0]];
                            for(p = 0; p < 13; p++){
                                var m = d & 1 << 12 - p ? 30 : 29;
                                if (l < m) break;
                                l -= m;
                            }
                            var g = d >> 13;
                            return !g || p < g ? (a.isIntercalary = !1, a.month = 1 + p) : p === g ? (a.isIntercalary = !0, a.month = p) : (a.isIntercalary = !1, a.month = p), a.day = 1 + l, a;
                        }(e1.year(), e1.month(), e1.day()), n = this.toMonthIndex(r.year, r.month, r.isIntercalary);
                        return this.newDate(r.year, n, r.day);
                    },
                    fromString: function(t1) {
                        var e1 = t1.match(s), r = this._validateYear(+e1[1]), n = +e1[2], i = !!e1[3], a = this.toMonthIndex(r, n, i), o = +e1[4];
                        return this.newDate(r, a, o);
                    },
                    add: function(t1, e1, r) {
                        var n = t1.year(), i = t1.month(), a = this.isIntercalaryMonth(n, i), s = this.toChineseMonth(n, i), l = Object.getPrototypeOf(o.prototype).add.call(this, t1, e1, r);
                        if ("y" === r) {
                            var c = l.year(), u = l.month(), h = this.isIntercalaryMonth(c, s), f = a && h ? this.toMonthIndex(c, s, !0) : this.toMonthIndex(c, s, !1);
                            f !== u && l.month(f);
                        }
                        return l;
                    }
                });
                var s = /^\s*(-?\d\d\d\d|\d\d)[-/](\d?\d)([iI]?)[-/](\d?\d)/m, l = /^\d?\d[iI]?/m, c = /^闰?十?[一二三四五六七八九]?月/m, u = /^闰?十?[一二三四五六七八九]?/m;
                n.calendars.chinese = o;
                var h = [
                    1887,
                    5780,
                    5802,
                    19157,
                    2742,
                    50359,
                    1198,
                    2646,
                    46378,
                    7466,
                    3412,
                    30122,
                    5482,
                    67949,
                    2396,
                    5294,
                    43597,
                    6732,
                    6954,
                    36181,
                    2772,
                    4954,
                    18781,
                    2396,
                    54427,
                    5274,
                    6730,
                    47781,
                    5800,
                    6868,
                    21210,
                    4790,
                    59703,
                    2350,
                    5270,
                    46667,
                    3402,
                    3496,
                    38325,
                    1388,
                    4782,
                    18735,
                    2350,
                    52374,
                    6804,
                    7498,
                    44457,
                    2906,
                    1388,
                    29294,
                    4700,
                    63789,
                    6442,
                    6804,
                    56138,
                    5802,
                    2772,
                    38235,
                    1210,
                    4698,
                    22827,
                    5418,
                    63125,
                    3476,
                    5802,
                    43701,
                    2484,
                    5302,
                    27223,
                    2646,
                    70954,
                    7466,
                    3412,
                    54698,
                    5482,
                    2412,
                    38062,
                    5294,
                    2636,
                    32038,
                    6954,
                    60245,
                    2772,
                    4826,
                    43357,
                    2394,
                    5274,
                    39501,
                    6730,
                    72357,
                    5800,
                    5844,
                    53978,
                    4790,
                    2358,
                    38039,
                    5270,
                    87627,
                    3402,
                    3496,
                    54708,
                    5484,
                    4782,
                    43311,
                    2350,
                    3222,
                    27978,
                    7498,
                    68965,
                    2904,
                    5484,
                    45677,
                    4700,
                    6444,
                    39573,
                    6804,
                    6986,
                    19285,
                    2772,
                    62811,
                    1210,
                    4698,
                    47403,
                    5418,
                    5780,
                    38570,
                    5546,
                    76469,
                    2420,
                    5302,
                    51799,
                    2646,
                    5414,
                    36501,
                    3412,
                    5546,
                    18869,
                    2412,
                    54446,
                    5276,
                    6732,
                    48422,
                    6822,
                    2900,
                    28010,
                    4826,
                    92509,
                    2394,
                    5274,
                    55883,
                    6730,
                    6820,
                    47956,
                    5812,
                    2778,
                    18779,
                    2358,
                    62615,
                    5270,
                    5450,
                    46757,
                    3492,
                    5556,
                    27318,
                    4718,
                    67887,
                    2350,
                    3222,
                    52554,
                    7498,
                    3428,
                    38252,
                    5468,
                    4700,
                    31022,
                    6444,
                    64149,
                    6804,
                    6986,
                    43861,
                    2772,
                    5338,
                    35421,
                    2650,
                    70955,
                    5418,
                    5780,
                    54954,
                    5546,
                    2740,
                    38074,
                    5302,
                    2646,
                    29991,
                    3366,
                    61011,
                    3412,
                    5546,
                    43445,
                    2412,
                    5294,
                    35406,
                    6732,
                    72998,
                    6820,
                    6996,
                    52586,
                    2778,
                    2396,
                    38045,
                    5274,
                    6698,
                    23333,
                    6820,
                    64338,
                    5812,
                    2746,
                    43355,
                    2358,
                    5270,
                    39499,
                    5450,
                    79525,
                    3492,
                    5548
                ], f = [
                    1887,
                    966732,
                    967231,
                    967733,
                    968265,
                    968766,
                    969297,
                    969798,
                    970298,
                    970829,
                    971330,
                    971830,
                    972362,
                    972863,
                    973395,
                    973896,
                    974397,
                    974928,
                    975428,
                    975929,
                    976461,
                    976962,
                    977462,
                    977994,
                    978494,
                    979026,
                    979526,
                    980026,
                    980558,
                    981059,
                    981559,
                    982091,
                    982593,
                    983124,
                    983624,
                    984124,
                    984656,
                    985157,
                    985656,
                    986189,
                    986690,
                    987191,
                    987722,
                    988222,
                    988753,
                    989254,
                    989754,
                    990286,
                    990788,
                    991288,
                    991819,
                    992319,
                    992851,
                    993352,
                    993851,
                    994383,
                    994885,
                    995385,
                    995917,
                    996418,
                    996918,
                    997450,
                    997949,
                    998481,
                    998982,
                    999483,
                    1000014,
                    1000515,
                    1001016,
                    1001548,
                    1002047,
                    1002578,
                    1003080,
                    1003580,
                    1004111,
                    1004613,
                    1005113,
                    1005645,
                    1006146,
                    1006645,
                    1007177,
                    1007678,
                    1008209,
                    1008710,
                    1009211,
                    1009743,
                    1010243,
                    1010743,
                    1011275,
                    1011775,
                    1012306,
                    1012807,
                    1013308,
                    1013840,
                    1014341,
                    1014841,
                    1015373,
                    1015874,
                    1016404,
                    1016905,
                    1017405,
                    1017937,
                    1018438,
                    1018939,
                    1019471,
                    1019972,
                    1020471,
                    1021002,
                    1021503,
                    1022035,
                    1022535,
                    1023036,
                    1023568,
                    1024069,
                    1024568,
                    1025100,
                    1025601,
                    1026102,
                    1026633,
                    1027133,
                    1027666,
                    1028167,
                    1028666,
                    1029198,
                    1029699,
                    1030199,
                    1030730,
                    1031231,
                    1031763,
                    1032264,
                    1032764,
                    1033296,
                    1033797,
                    1034297,
                    1034828,
                    1035329,
                    1035830,
                    1036362,
                    1036861,
                    1037393,
                    1037894,
                    1038394,
                    1038925,
                    1039427,
                    1039927,
                    1040459,
                    1040959,
                    1041491,
                    1041992,
                    1042492,
                    1043023,
                    1043524,
                    1044024,
                    1044556,
                    1045057,
                    1045558,
                    1046090,
                    1046590,
                    1047121,
                    1047622,
                    1048122,
                    1048654,
                    1049154,
                    1049655,
                    1050187,
                    1050689,
                    1051219,
                    1051720,
                    1052220,
                    1052751,
                    1053252,
                    1053752,
                    1054284,
                    1054786,
                    1055285,
                    1055817,
                    1056317,
                    1056849,
                    1057349,
                    1057850,
                    1058382,
                    1058883,
                    1059383,
                    1059915,
                    1060415,
                    1060947,
                    1061447,
                    1061947,
                    1062479,
                    1062981,
                    1063480,
                    1064012,
                    1064514,
                    1065014,
                    1065545,
                    1066045,
                    1066577,
                    1067078,
                    1067578,
                    1068110,
                    1068611,
                    1069112,
                    1069642,
                    1070142,
                    1070674,
                    1071175,
                    1071675,
                    1072207,
                    1072709,
                    1073209,
                    1073740,
                    1074241,
                    1074741,
                    1075273,
                    1075773,
                    1076305,
                    1076807,
                    1077308,
                    1077839,
                    1078340,
                    1078840,
                    1079372,
                    1079871,
                    1080403,
                    1080904
                ];
            },
            72210: function(t1, e1, r) {
                var n = r(24453), i = r(27976);
                function a(t1) {
                    this.local = this.regionalOptions[t1 || ""] || this.regionalOptions[""];
                }
                a.prototype = new n.baseCalendar, i(a.prototype, {
                    name: "Coptic",
                    jdEpoch: 1825029.5,
                    daysPerMonth: [
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        5
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Coptic",
                            epochs: [
                                "BAM",
                                "AM"
                            ],
                            monthNames: [
                                "Thout",
                                "Paopi",
                                "Hathor",
                                "Koiak",
                                "Tobi",
                                "Meshir",
                                "Paremhat",
                                "Paremoude",
                                "Pashons",
                                "Paoni",
                                "Epip",
                                "Mesori",
                                "Pi Kogi Enavot"
                            ],
                            monthNamesShort: [
                                "Tho",
                                "Pao",
                                "Hath",
                                "Koi",
                                "Tob",
                                "Mesh",
                                "Pat",
                                "Pad",
                                "Pash",
                                "Pao",
                                "Epi",
                                "Meso",
                                "PiK"
                            ],
                            dayNames: [
                                "Tkyriaka",
                                "Pesnau",
                                "Pshoment",
                                "Peftoou",
                                "Ptiou",
                                "Psoou",
                                "Psabbaton"
                            ],
                            dayNamesShort: [
                                "Tky",
                                "Pes",
                                "Psh",
                                "Pef",
                                "Pti",
                                "Pso",
                                "Psa"
                            ],
                            dayNamesMin: [
                                "Tk",
                                "Pes",
                                "Psh",
                                "Pef",
                                "Pt",
                                "Pso",
                                "Psa"
                            ],
                            digits: null,
                            dateFormat: "dd/mm/yyyy",
                            firstDay: 0,
                            isRTL: !1
                        }
                    },
                    leapYear: function(t1) {
                        var e1 = this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear);
                        return (t1 = e1.year() + (e1.year() < 0 ? 1 : 0)) % 4 == 3 || t1 % 4 == -1;
                    },
                    monthsInYear: function(t1) {
                        return this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear || n.regionalOptions[""].invalidYear), 13;
                    },
                    weekOfYear: function(t1, e1, r) {
                        var n = this.newDate(t1, e1, r);
                        return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                    },
                    daysInMonth: function(t1, e1) {
                        var r = this._validate(t1, e1, this.minDay, n.local.invalidMonth);
                        return this.daysPerMonth[r.month() - 1] + (13 === r.month() && this.leapYear(r.year()) ? 1 : 0);
                    },
                    weekDay: function(t1, e1, r) {
                        return (this.dayOfWeek(t1, e1, r) || 7) < 6;
                    },
                    toJD: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidDate);
                        return (t1 = i.year()) < 0 && t1++, i.day() + 30 * (i.month() - 1) + 365 * (t1 - 1) + Math.floor(t1 / 4) + this.jdEpoch - 1;
                    },
                    fromJD: function(t1) {
                        var e1 = Math.floor(t1) + .5 - this.jdEpoch, r = Math.floor((e1 - Math.floor((e1 + 366) / 1461)) / 365) + 1;
                        r <= 0 && r--, e1 = Math.floor(t1) + .5 - this.newDate(r, 1, 1).toJD();
                        var n = Math.floor(e1 / 30) + 1, i = e1 - 30 * (n - 1) + 1;
                        return this.newDate(r, n, i);
                    }
                }), n.calendars.coptic = a;
            },
            28569: function(t1, e1, r) {
                var n = r(24453), i = r(27976);
                function a(t1) {
                    this.local = this.regionalOptions[t1 || ""] || this.regionalOptions[""];
                }
                a.prototype = new n.baseCalendar, i(a.prototype, {
                    name: "Discworld",
                    jdEpoch: 1721425.5,
                    daysPerMonth: [
                        16,
                        32,
                        32,
                        32,
                        32,
                        32,
                        32,
                        32,
                        32,
                        32,
                        32,
                        32,
                        32
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Discworld",
                            epochs: [
                                "BUC",
                                "UC"
                            ],
                            monthNames: [
                                "Ick",
                                "Offle",
                                "February",
                                "March",
                                "April",
                                "May",
                                "June",
                                "Grune",
                                "August",
                                "Spune",
                                "Sektober",
                                "Ember",
                                "December"
                            ],
                            monthNamesShort: [
                                "Ick",
                                "Off",
                                "Feb",
                                "Mar",
                                "Apr",
                                "May",
                                "Jun",
                                "Gru",
                                "Aug",
                                "Spu",
                                "Sek",
                                "Emb",
                                "Dec"
                            ],
                            dayNames: [
                                "Sunday",
                                "Octeday",
                                "Monday",
                                "Tuesday",
                                "Wednesday",
                                "Thursday",
                                "Friday",
                                "Saturday"
                            ],
                            dayNamesShort: [
                                "Sun",
                                "Oct",
                                "Mon",
                                "Tue",
                                "Wed",
                                "Thu",
                                "Fri",
                                "Sat"
                            ],
                            dayNamesMin: [
                                "Su",
                                "Oc",
                                "Mo",
                                "Tu",
                                "We",
                                "Th",
                                "Fr",
                                "Sa"
                            ],
                            digits: null,
                            dateFormat: "yyyy/mm/dd",
                            firstDay: 2,
                            isRTL: !1
                        }
                    },
                    leapYear: function(t1) {
                        return this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear), !1;
                    },
                    monthsInYear: function(t1) {
                        return this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear), 13;
                    },
                    daysInYear: function(t1) {
                        return this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear), 400;
                    },
                    weekOfYear: function(t1, e1, r) {
                        var n = this.newDate(t1, e1, r);
                        return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 8) + 1;
                    },
                    daysInMonth: function(t1, e1) {
                        var r = this._validate(t1, e1, this.minDay, n.local.invalidMonth);
                        return this.daysPerMonth[r.month() - 1];
                    },
                    daysInWeek: function() {
                        return 8;
                    },
                    dayOfWeek: function(t1, e1, r) {
                        return (this._validate(t1, e1, r, n.local.invalidDate).day() + 1) % 8;
                    },
                    weekDay: function(t1, e1, r) {
                        var n = this.dayOfWeek(t1, e1, r);
                        return n >= 2 && n <= 6;
                    },
                    extraInfo: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidDate);
                        return {
                            century: o[Math.floor((i.year() - 1) / 100) + 1] || ""
                        };
                    },
                    toJD: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidDate);
                        return t1 = i.year() + (i.year() < 0 ? 1 : 0), e1 = i.month(), (r = i.day()) + (e1 > 1 ? 16 : 0) + (e1 > 2 ? 32 * (e1 - 2) : 0) + 400 * (t1 - 1) + this.jdEpoch - 1;
                    },
                    fromJD: function(t1) {
                        t1 = Math.floor(t1 + .5) - Math.floor(this.jdEpoch) - 1;
                        var e1 = Math.floor(t1 / 400) + 1;
                        t1 -= 400 * (e1 - 1), t1 += t1 > 15 ? 16 : 0;
                        var r = Math.floor(t1 / 32) + 1, n = t1 - 32 * (r - 1) + 1;
                        return this.newDate(e1 <= 0 ? e1 - 1 : e1, r, n);
                    }
                });
                var o = {
                    20: "Fruitbat",
                    21: "Anchovy"
                };
                n.calendars.discworld = a;
            },
            81133: function(t1, e1, r) {
                var n = r(24453), i = r(27976);
                function a(t1) {
                    this.local = this.regionalOptions[t1 || ""] || this.regionalOptions[""];
                }
                a.prototype = new n.baseCalendar, i(a.prototype, {
                    name: "Ethiopian",
                    jdEpoch: 1724220.5,
                    daysPerMonth: [
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        5
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Ethiopian",
                            epochs: [
                                "BEE",
                                "EE"
                            ],
                            monthNames: [
                                "Meskerem",
                                "Tikemet",
                                "Hidar",
                                "Tahesas",
                                "Tir",
                                "Yekatit",
                                "Megabit",
                                "Miazia",
                                "Genbot",
                                "Sene",
                                "Hamle",
                                "Nehase",
                                "Pagume"
                            ],
                            monthNamesShort: [
                                "Mes",
                                "Tik",
                                "Hid",
                                "Tah",
                                "Tir",
                                "Yek",
                                "Meg",
                                "Mia",
                                "Gen",
                                "Sen",
                                "Ham",
                                "Neh",
                                "Pag"
                            ],
                            dayNames: [
                                "Ehud",
                                "Segno",
                                "Maksegno",
                                "Irob",
                                "Hamus",
                                "Arb",
                                "Kidame"
                            ],
                            dayNamesShort: [
                                "Ehu",
                                "Seg",
                                "Mak",
                                "Iro",
                                "Ham",
                                "Arb",
                                "Kid"
                            ],
                            dayNamesMin: [
                                "Eh",
                                "Se",
                                "Ma",
                                "Ir",
                                "Ha",
                                "Ar",
                                "Ki"
                            ],
                            digits: null,
                            dateFormat: "dd/mm/yyyy",
                            firstDay: 0,
                            isRTL: !1
                        }
                    },
                    leapYear: function(t1) {
                        var e1 = this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear);
                        return (t1 = e1.year() + (e1.year() < 0 ? 1 : 0)) % 4 == 3 || t1 % 4 == -1;
                    },
                    monthsInYear: function(t1) {
                        return this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear || n.regionalOptions[""].invalidYear), 13;
                    },
                    weekOfYear: function(t1, e1, r) {
                        var n = this.newDate(t1, e1, r);
                        return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                    },
                    daysInMonth: function(t1, e1) {
                        var r = this._validate(t1, e1, this.minDay, n.local.invalidMonth);
                        return this.daysPerMonth[r.month() - 1] + (13 === r.month() && this.leapYear(r.year()) ? 1 : 0);
                    },
                    weekDay: function(t1, e1, r) {
                        return (this.dayOfWeek(t1, e1, r) || 7) < 6;
                    },
                    toJD: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidDate);
                        return (t1 = i.year()) < 0 && t1++, i.day() + 30 * (i.month() - 1) + 365 * (t1 - 1) + Math.floor(t1 / 4) + this.jdEpoch - 1;
                    },
                    fromJD: function(t1) {
                        var e1 = Math.floor(t1) + .5 - this.jdEpoch, r = Math.floor((e1 - Math.floor((e1 + 366) / 1461)) / 365) + 1;
                        r <= 0 && r--, e1 = Math.floor(t1) + .5 - this.newDate(r, 1, 1).toJD();
                        var n = Math.floor(e1 / 30) + 1, i = e1 - 30 * (n - 1) + 1;
                        return this.newDate(r, n, i);
                    }
                }), n.calendars.ethiopian = a;
            },
            78295: function(t1, e1, r) {
                var n = r(24453), i = r(27976);
                function a(t1) {
                    this.local = this.regionalOptions[t1 || ""] || this.regionalOptions[""];
                }
                function o(t1, e1) {
                    return t1 - e1 * Math.floor(t1 / e1);
                }
                a.prototype = new n.baseCalendar, i(a.prototype, {
                    name: "Hebrew",
                    jdEpoch: 347995.5,
                    daysPerMonth: [
                        30,
                        29,
                        30,
                        29,
                        30,
                        29,
                        30,
                        29,
                        30,
                        29,
                        30,
                        29,
                        29
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 7,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Hebrew",
                            epochs: [
                                "BAM",
                                "AM"
                            ],
                            monthNames: [
                                "Nisan",
                                "Iyar",
                                "Sivan",
                                "Tammuz",
                                "Av",
                                "Elul",
                                "Tishrei",
                                "Cheshvan",
                                "Kislev",
                                "Tevet",
                                "Shevat",
                                "Adar",
                                "Adar II"
                            ],
                            monthNamesShort: [
                                "Nis",
                                "Iya",
                                "Siv",
                                "Tam",
                                "Av",
                                "Elu",
                                "Tis",
                                "Che",
                                "Kis",
                                "Tev",
                                "She",
                                "Ada",
                                "Ad2"
                            ],
                            dayNames: [
                                "Yom Rishon",
                                "Yom Sheni",
                                "Yom Shlishi",
                                "Yom Revi'i",
                                "Yom Chamishi",
                                "Yom Shishi",
                                "Yom Shabbat"
                            ],
                            dayNamesShort: [
                                "Ris",
                                "She",
                                "Shl",
                                "Rev",
                                "Cha",
                                "Shi",
                                "Sha"
                            ],
                            dayNamesMin: [
                                "Ri",
                                "She",
                                "Shl",
                                "Re",
                                "Ch",
                                "Shi",
                                "Sha"
                            ],
                            digits: null,
                            dateFormat: "dd/mm/yyyy",
                            firstDay: 0,
                            isRTL: !1
                        }
                    },
                    leapYear: function(t1) {
                        var e1 = this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear);
                        return this._leapYear(e1.year());
                    },
                    _leapYear: function(t1) {
                        return o(7 * (t1 = t1 < 0 ? t1 + 1 : t1) + 1, 19) < 7;
                    },
                    monthsInYear: function(t1) {
                        return this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear), this._leapYear(t1.year ? t1.year() : t1) ? 13 : 12;
                    },
                    weekOfYear: function(t1, e1, r) {
                        var n = this.newDate(t1, e1, r);
                        return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                    },
                    daysInYear: function(t1) {
                        return t1 = this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear).year(), this.toJD(-1 === t1 ? 1 : t1 + 1, 7, 1) - this.toJD(t1, 7, 1);
                    },
                    daysInMonth: function(t1, e1) {
                        return t1.year && (e1 = t1.month(), t1 = t1.year()), this._validate(t1, e1, this.minDay, n.local.invalidMonth), 12 === e1 && this.leapYear(t1) || 8 === e1 && 5 === o(this.daysInYear(t1), 10) ? 30 : 9 === e1 && 3 === o(this.daysInYear(t1), 10) ? 29 : this.daysPerMonth[e1 - 1];
                    },
                    weekDay: function(t1, e1, r) {
                        return 6 !== this.dayOfWeek(t1, e1, r);
                    },
                    extraInfo: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidDate);
                        return {
                            yearType: (this.leapYear(i) ? "embolismic" : "common") + " " + [
                                "deficient",
                                "regular",
                                "complete"
                            ][this.daysInYear(i) % 10 - 3]
                        };
                    },
                    toJD: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidDate);
                        t1 = i.year(), e1 = i.month(), r = i.day();
                        var a = t1 <= 0 ? t1 + 1 : t1, o = this.jdEpoch + this._delay1(a) + this._delay2(a) + r + 1;
                        if (e1 < 7) {
                            for(var s = 7; s <= this.monthsInYear(t1); s++)o += this.daysInMonth(t1, s);
                            for(s = 1; s < e1; s++)o += this.daysInMonth(t1, s);
                        } else for(s = 7; s < e1; s++)o += this.daysInMonth(t1, s);
                        return o;
                    },
                    _delay1: function(t1) {
                        var e1 = Math.floor((235 * t1 - 234) / 19), r = 12084 + 13753 * e1, n = 29 * e1 + Math.floor(r / 25920);
                        return o(3 * (n + 1), 7) < 3 && n++, n;
                    },
                    _delay2: function(t1) {
                        var e1 = this._delay1(t1 - 1), r = this._delay1(t1);
                        return this._delay1(t1 + 1) - r == 356 ? 2 : r - e1 == 382 ? 1 : 0;
                    },
                    fromJD: function(t1) {
                        t1 = Math.floor(t1) + .5;
                        for(var e1 = Math.floor(98496 * (t1 - this.jdEpoch) / 35975351) - 1; t1 >= this.toJD(-1 === e1 ? 1 : e1 + 1, 7, 1);)e1++;
                        for(var r = t1 < this.toJD(e1, 1, 1) ? 7 : 1; t1 > this.toJD(e1, r, this.daysInMonth(e1, r));)r++;
                        var n = t1 - this.toJD(e1, r, 1) + 1;
                        return this.newDate(e1, r, n);
                    }
                }), n.calendars.hebrew = a;
            },
            25512: function(t1, e1, r) {
                var n = r(24453), i = r(27976);
                function a(t1) {
                    this.local = this.regionalOptions[t1 || ""] || this.regionalOptions[""];
                }
                a.prototype = new n.baseCalendar, i(a.prototype, {
                    name: "Islamic",
                    jdEpoch: 1948439.5,
                    daysPerMonth: [
                        30,
                        29,
                        30,
                        29,
                        30,
                        29,
                        30,
                        29,
                        30,
                        29,
                        30,
                        29
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Islamic",
                            epochs: [
                                "BH",
                                "AH"
                            ],
                            monthNames: [
                                "Muharram",
                                "Safar",
                                "Rabi' al-awwal",
                                "Rabi' al-thani",
                                "Jumada al-awwal",
                                "Jumada al-thani",
                                "Rajab",
                                "Sha'aban",
                                "Ramadan",
                                "Shawwal",
                                "Dhu al-Qi'dah",
                                "Dhu al-Hijjah"
                            ],
                            monthNamesShort: [
                                "Muh",
                                "Saf",
                                "Rab1",
                                "Rab2",
                                "Jum1",
                                "Jum2",
                                "Raj",
                                "Sha'",
                                "Ram",
                                "Shaw",
                                "DhuQ",
                                "DhuH"
                            ],
                            dayNames: [
                                "Yawm al-ahad",
                                "Yawm al-ithnayn",
                                "Yawm ath-thulaathaa'",
                                "Yawm al-arbi'aa'",
                                "Yawm al-kham\u012Bs",
                                "Yawm al-jum'a",
                                "Yawm as-sabt"
                            ],
                            dayNamesShort: [
                                "Aha",
                                "Ith",
                                "Thu",
                                "Arb",
                                "Kha",
                                "Jum",
                                "Sab"
                            ],
                            dayNamesMin: [
                                "Ah",
                                "It",
                                "Th",
                                "Ar",
                                "Kh",
                                "Ju",
                                "Sa"
                            ],
                            digits: null,
                            dateFormat: "yyyy/mm/dd",
                            firstDay: 6,
                            isRTL: !1
                        }
                    },
                    leapYear: function(t1) {
                        return (11 * this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear).year() + 14) % 30 < 11;
                    },
                    weekOfYear: function(t1, e1, r) {
                        var n = this.newDate(t1, e1, r);
                        return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                    },
                    daysInYear: function(t1) {
                        return this.leapYear(t1) ? 355 : 354;
                    },
                    daysInMonth: function(t1, e1) {
                        var r = this._validate(t1, e1, this.minDay, n.local.invalidMonth);
                        return this.daysPerMonth[r.month() - 1] + (12 === r.month() && this.leapYear(r.year()) ? 1 : 0);
                    },
                    weekDay: function(t1, e1, r) {
                        return 5 !== this.dayOfWeek(t1, e1, r);
                    },
                    toJD: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidDate);
                        return t1 = i.year(), e1 = i.month(), t1 = t1 <= 0 ? t1 + 1 : t1, (r = i.day()) + Math.ceil(29.5 * (e1 - 1)) + 354 * (t1 - 1) + Math.floor((3 + 11 * t1) / 30) + this.jdEpoch - 1;
                    },
                    fromJD: function(t1) {
                        t1 = Math.floor(t1) + .5;
                        var e1 = Math.floor((30 * (t1 - this.jdEpoch) + 10646) / 10631);
                        e1 = e1 <= 0 ? e1 - 1 : e1;
                        var r = Math.min(12, Math.ceil((t1 - 29 - this.toJD(e1, 1, 1)) / 29.5) + 1), n = t1 - this.toJD(e1, r, 1) + 1;
                        return this.newDate(e1, r, n);
                    }
                }), n.calendars.islamic = a;
            },
            42645: function(t1, e1, r) {
                var n = r(24453), i = r(27976);
                function a(t1) {
                    this.local = this.regionalOptions[t1 || ""] || this.regionalOptions[""];
                }
                a.prototype = new n.baseCalendar, i(a.prototype, {
                    name: "Julian",
                    jdEpoch: 1721423.5,
                    daysPerMonth: [
                        31,
                        28,
                        31,
                        30,
                        31,
                        30,
                        31,
                        31,
                        30,
                        31,
                        30,
                        31
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Julian",
                            epochs: [
                                "BC",
                                "AD"
                            ],
                            monthNames: [
                                "January",
                                "February",
                                "March",
                                "April",
                                "May",
                                "June",
                                "July",
                                "August",
                                "September",
                                "October",
                                "November",
                                "December"
                            ],
                            monthNamesShort: [
                                "Jan",
                                "Feb",
                                "Mar",
                                "Apr",
                                "May",
                                "Jun",
                                "Jul",
                                "Aug",
                                "Sep",
                                "Oct",
                                "Nov",
                                "Dec"
                            ],
                            dayNames: [
                                "Sunday",
                                "Monday",
                                "Tuesday",
                                "Wednesday",
                                "Thursday",
                                "Friday",
                                "Saturday"
                            ],
                            dayNamesShort: [
                                "Sun",
                                "Mon",
                                "Tue",
                                "Wed",
                                "Thu",
                                "Fri",
                                "Sat"
                            ],
                            dayNamesMin: [
                                "Su",
                                "Mo",
                                "Tu",
                                "We",
                                "Th",
                                "Fr",
                                "Sa"
                            ],
                            digits: null,
                            dateFormat: "mm/dd/yyyy",
                            firstDay: 0,
                            isRTL: !1
                        }
                    },
                    leapYear: function(t1) {
                        var e1 = this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear);
                        return (t1 = e1.year() < 0 ? e1.year() + 1 : e1.year()) % 4 == 0;
                    },
                    weekOfYear: function(t1, e1, r) {
                        var n = this.newDate(t1, e1, r);
                        return n.add(4 - (n.dayOfWeek() || 7), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                    },
                    daysInMonth: function(t1, e1) {
                        var r = this._validate(t1, e1, this.minDay, n.local.invalidMonth);
                        return this.daysPerMonth[r.month() - 1] + (2 === r.month() && this.leapYear(r.year()) ? 1 : 0);
                    },
                    weekDay: function(t1, e1, r) {
                        return (this.dayOfWeek(t1, e1, r) || 7) < 6;
                    },
                    toJD: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidDate);
                        return t1 = i.year(), e1 = i.month(), r = i.day(), t1 < 0 && t1++, e1 <= 2 && (t1--, e1 += 12), Math.floor(365.25 * (t1 + 4716)) + Math.floor(30.6001 * (e1 + 1)) + r - 1524.5;
                    },
                    fromJD: function(t1) {
                        var e1 = Math.floor(t1 + .5) + 1524, r = Math.floor((e1 - 122.1) / 365.25), n = Math.floor(365.25 * r), i = Math.floor((e1 - n) / 30.6001), a = i - Math.floor(i < 14 ? 1 : 13), o = r - Math.floor(a > 2 ? 4716 : 4715), s = e1 - n - Math.floor(30.6001 * i);
                        return o <= 0 && o--, this.newDate(o, a, s);
                    }
                }), n.calendars.julian = a;
            },
            62324: function(t1, e1, r) {
                var n = r(24453), i = r(27976);
                function a(t1) {
                    this.local = this.regionalOptions[t1 || ""] || this.regionalOptions[""];
                }
                function o(t1, e1) {
                    return t1 - e1 * Math.floor(t1 / e1);
                }
                function s(t1, e1) {
                    return o(t1 - 1, e1) + 1;
                }
                a.prototype = new n.baseCalendar, i(a.prototype, {
                    name: "Mayan",
                    jdEpoch: 584282.5,
                    hasYearZero: !0,
                    minMonth: 0,
                    firstMonth: 0,
                    minDay: 0,
                    regionalOptions: {
                        "": {
                            name: "Mayan",
                            epochs: [
                                "",
                                ""
                            ],
                            monthNames: [
                                "0",
                                "1",
                                "2",
                                "3",
                                "4",
                                "5",
                                "6",
                                "7",
                                "8",
                                "9",
                                "10",
                                "11",
                                "12",
                                "13",
                                "14",
                                "15",
                                "16",
                                "17"
                            ],
                            monthNamesShort: [
                                "0",
                                "1",
                                "2",
                                "3",
                                "4",
                                "5",
                                "6",
                                "7",
                                "8",
                                "9",
                                "10",
                                "11",
                                "12",
                                "13",
                                "14",
                                "15",
                                "16",
                                "17"
                            ],
                            dayNames: [
                                "0",
                                "1",
                                "2",
                                "3",
                                "4",
                                "5",
                                "6",
                                "7",
                                "8",
                                "9",
                                "10",
                                "11",
                                "12",
                                "13",
                                "14",
                                "15",
                                "16",
                                "17",
                                "18",
                                "19"
                            ],
                            dayNamesShort: [
                                "0",
                                "1",
                                "2",
                                "3",
                                "4",
                                "5",
                                "6",
                                "7",
                                "8",
                                "9",
                                "10",
                                "11",
                                "12",
                                "13",
                                "14",
                                "15",
                                "16",
                                "17",
                                "18",
                                "19"
                            ],
                            dayNamesMin: [
                                "0",
                                "1",
                                "2",
                                "3",
                                "4",
                                "5",
                                "6",
                                "7",
                                "8",
                                "9",
                                "10",
                                "11",
                                "12",
                                "13",
                                "14",
                                "15",
                                "16",
                                "17",
                                "18",
                                "19"
                            ],
                            digits: null,
                            dateFormat: "YYYY.m.d",
                            firstDay: 0,
                            isRTL: !1,
                            haabMonths: [
                                "Pop",
                                "Uo",
                                "Zip",
                                "Zotz",
                                "Tzec",
                                "Xul",
                                "Yaxkin",
                                "Mol",
                                "Chen",
                                "Yax",
                                "Zac",
                                "Ceh",
                                "Mac",
                                "Kankin",
                                "Muan",
                                "Pax",
                                "Kayab",
                                "Cumku",
                                "Uayeb"
                            ],
                            tzolkinMonths: [
                                "Imix",
                                "Ik",
                                "Akbal",
                                "Kan",
                                "Chicchan",
                                "Cimi",
                                "Manik",
                                "Lamat",
                                "Muluc",
                                "Oc",
                                "Chuen",
                                "Eb",
                                "Ben",
                                "Ix",
                                "Men",
                                "Cib",
                                "Caban",
                                "Etznab",
                                "Cauac",
                                "Ahau"
                            ]
                        }
                    },
                    leapYear: function(t1) {
                        return this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear), !1;
                    },
                    formatYear: function(t1) {
                        t1 = this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear).year();
                        var e1 = Math.floor(t1 / 400);
                        return t1 %= 400, t1 += t1 < 0 ? 400 : 0, e1 + "." + Math.floor(t1 / 20) + "." + t1 % 20;
                    },
                    forYear: function(t1) {
                        if ((t1 = t1.split(".")).length < 3) throw "Invalid Mayan year";
                        for(var e1 = 0, r = 0; r < t1.length; r++){
                            var n = parseInt(t1[r], 10);
                            if (Math.abs(n) > 19 || r > 0 && n < 0) throw "Invalid Mayan year";
                            e1 = 20 * e1 + n;
                        }
                        return e1;
                    },
                    monthsInYear: function(t1) {
                        return this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear), 18;
                    },
                    weekOfYear: function(t1, e1, r) {
                        return this._validate(t1, e1, r, n.local.invalidDate), 0;
                    },
                    daysInYear: function(t1) {
                        return this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear), 360;
                    },
                    daysInMonth: function(t1, e1) {
                        return this._validate(t1, e1, this.minDay, n.local.invalidMonth), 20;
                    },
                    daysInWeek: function() {
                        return 5;
                    },
                    dayOfWeek: function(t1, e1, r) {
                        return this._validate(t1, e1, r, n.local.invalidDate).day();
                    },
                    weekDay: function(t1, e1, r) {
                        return this._validate(t1, e1, r, n.local.invalidDate), !0;
                    },
                    extraInfo: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidDate).toJD(), a = this._toHaab(i), o = this._toTzolkin(i);
                        return {
                            haabMonthName: this.local.haabMonths[a[0] - 1],
                            haabMonth: a[0],
                            haabDay: a[1],
                            tzolkinDayName: this.local.tzolkinMonths[o[0] - 1],
                            tzolkinDay: o[0],
                            tzolkinTrecena: o[1]
                        };
                    },
                    _toHaab: function(t1) {
                        var e1 = o(8 + (t1 -= this.jdEpoch) + 340, 365);
                        return [
                            Math.floor(e1 / 20) + 1,
                            o(e1, 20)
                        ];
                    },
                    _toTzolkin: function(t1) {
                        return [
                            s(20 + (t1 -= this.jdEpoch), 20),
                            s(t1 + 4, 13)
                        ];
                    },
                    toJD: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidDate);
                        return i.day() + 20 * i.month() + 360 * i.year() + this.jdEpoch;
                    },
                    fromJD: function(t1) {
                        t1 = Math.floor(t1) + .5 - this.jdEpoch;
                        var e1 = Math.floor(t1 / 360);
                        t1 %= 360, t1 += t1 < 0 ? 360 : 0;
                        var r = Math.floor(t1 / 20), n = t1 % 20;
                        return this.newDate(e1, r, n);
                    }
                }), n.calendars.mayan = a;
            },
            91662: function(t1, e1, r) {
                var n = r(24453), i = r(27976);
                function a(t1) {
                    this.local = this.regionalOptions[t1 || ""] || this.regionalOptions[""];
                }
                a.prototype = new n.baseCalendar;
                var o = n.instance("gregorian");
                i(a.prototype, {
                    name: "Nanakshahi",
                    jdEpoch: 2257673.5,
                    daysPerMonth: [
                        31,
                        31,
                        31,
                        31,
                        31,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Nanakshahi",
                            epochs: [
                                "BN",
                                "AN"
                            ],
                            monthNames: [
                                "Chet",
                                "Vaisakh",
                                "Jeth",
                                "Harh",
                                "Sawan",
                                "Bhadon",
                                "Assu",
                                "Katak",
                                "Maghar",
                                "Poh",
                                "Magh",
                                "Phagun"
                            ],
                            monthNamesShort: [
                                "Che",
                                "Vai",
                                "Jet",
                                "Har",
                                "Saw",
                                "Bha",
                                "Ass",
                                "Kat",
                                "Mgr",
                                "Poh",
                                "Mgh",
                                "Pha"
                            ],
                            dayNames: [
                                "Somvaar",
                                "Mangalvar",
                                "Budhvaar",
                                "Veervaar",
                                "Shukarvaar",
                                "Sanicharvaar",
                                "Etvaar"
                            ],
                            dayNamesShort: [
                                "Som",
                                "Mangal",
                                "Budh",
                                "Veer",
                                "Shukar",
                                "Sanichar",
                                "Et"
                            ],
                            dayNamesMin: [
                                "So",
                                "Ma",
                                "Bu",
                                "Ve",
                                "Sh",
                                "Sa",
                                "Et"
                            ],
                            digits: null,
                            dateFormat: "dd-mm-yyyy",
                            firstDay: 0,
                            isRTL: !1
                        }
                    },
                    leapYear: function(t1) {
                        var e1 = this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear || n.regionalOptions[""].invalidYear);
                        return o.leapYear(e1.year() + (e1.year() < 1 ? 1 : 0) + 1469);
                    },
                    weekOfYear: function(t1, e1, r) {
                        var n = this.newDate(t1, e1, r);
                        return n.add(1 - (n.dayOfWeek() || 7), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                    },
                    daysInMonth: function(t1, e1) {
                        var r = this._validate(t1, e1, this.minDay, n.local.invalidMonth);
                        return this.daysPerMonth[r.month() - 1] + (12 === r.month() && this.leapYear(r.year()) ? 1 : 0);
                    },
                    weekDay: function(t1, e1, r) {
                        return (this.dayOfWeek(t1, e1, r) || 7) < 6;
                    },
                    toJD: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidMonth);
                        (t1 = i.year()) < 0 && t1++;
                        for(var a = i.day(), s = 1; s < i.month(); s++)a += this.daysPerMonth[s - 1];
                        return a + o.toJD(t1 + 1468, 3, 13);
                    },
                    fromJD: function(t1) {
                        t1 = Math.floor(t1 + .5);
                        for(var e1 = Math.floor((t1 - (this.jdEpoch - 1)) / 366); t1 >= this.toJD(e1 + 1, 1, 1);)e1++;
                        for(var r = t1 - Math.floor(this.toJD(e1, 1, 1) + .5) + 1, n = 1; r > this.daysInMonth(e1, n);)r -= this.daysInMonth(e1, n), n++;
                        return this.newDate(e1, n, r);
                    }
                }), n.calendars.nanakshahi = a;
            },
            66445: function(t1, e1, r) {
                var n = r(24453), i = r(27976);
                function a(t1) {
                    this.local = this.regionalOptions[t1 || ""] || this.regionalOptions[""];
                }
                a.prototype = new n.baseCalendar, i(a.prototype, {
                    name: "Nepali",
                    jdEpoch: 1700709.5,
                    daysPerMonth: [
                        31,
                        31,
                        32,
                        32,
                        31,
                        30,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    daysPerYear: 365,
                    regionalOptions: {
                        "": {
                            name: "Nepali",
                            epochs: [
                                "BBS",
                                "ABS"
                            ],
                            monthNames: [
                                "Baisakh",
                                "Jestha",
                                "Ashadh",
                                "Shrawan",
                                "Bhadra",
                                "Ashwin",
                                "Kartik",
                                "Mangsir",
                                "Paush",
                                "Mangh",
                                "Falgun",
                                "Chaitra"
                            ],
                            monthNamesShort: [
                                "Bai",
                                "Je",
                                "As",
                                "Shra",
                                "Bha",
                                "Ash",
                                "Kar",
                                "Mang",
                                "Pau",
                                "Ma",
                                "Fal",
                                "Chai"
                            ],
                            dayNames: [
                                "Aaitabaar",
                                "Sombaar",
                                "Manglbaar",
                                "Budhabaar",
                                "Bihibaar",
                                "Shukrabaar",
                                "Shanibaar"
                            ],
                            dayNamesShort: [
                                "Aaita",
                                "Som",
                                "Mangl",
                                "Budha",
                                "Bihi",
                                "Shukra",
                                "Shani"
                            ],
                            dayNamesMin: [
                                "Aai",
                                "So",
                                "Man",
                                "Bu",
                                "Bi",
                                "Shu",
                                "Sha"
                            ],
                            digits: null,
                            dateFormat: "dd/mm/yyyy",
                            firstDay: 1,
                            isRTL: !1
                        }
                    },
                    leapYear: function(t1) {
                        return this.daysInYear(t1) !== this.daysPerYear;
                    },
                    weekOfYear: function(t1, e1, r) {
                        var n = this.newDate(t1, e1, r);
                        return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                    },
                    daysInYear: function(t1) {
                        if (t1 = this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear).year(), void 0 === this.NEPALI_CALENDAR_DATA[t1]) return this.daysPerYear;
                        for(var e1 = 0, r = this.minMonth; r <= 12; r++)e1 += this.NEPALI_CALENDAR_DATA[t1][r];
                        return e1;
                    },
                    daysInMonth: function(t1, e1) {
                        return t1.year && (e1 = t1.month(), t1 = t1.year()), this._validate(t1, e1, this.minDay, n.local.invalidMonth), void 0 === this.NEPALI_CALENDAR_DATA[t1] ? this.daysPerMonth[e1 - 1] : this.NEPALI_CALENDAR_DATA[t1][e1];
                    },
                    weekDay: function(t1, e1, r) {
                        return 6 !== this.dayOfWeek(t1, e1, r);
                    },
                    toJD: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidDate);
                        t1 = i.year(), e1 = i.month(), r = i.day();
                        var a = n.instance(), o = 0, s = e1, l = t1;
                        this._createMissingCalendarData(t1);
                        var c = t1 - (s > 9 || 9 === s && r >= this.NEPALI_CALENDAR_DATA[l][0] ? 56 : 57);
                        for(9 !== e1 && (o = r, s--); 9 !== s;)s <= 0 && (s = 12, l--), o += this.NEPALI_CALENDAR_DATA[l][s], s--;
                        return 9 === e1 ? (o += r - this.NEPALI_CALENDAR_DATA[l][0]) < 0 && (o += a.daysInYear(c)) : o += this.NEPALI_CALENDAR_DATA[l][9] - this.NEPALI_CALENDAR_DATA[l][0], a.newDate(c, 1, 1).add(o, "d").toJD();
                    },
                    fromJD: function(t1) {
                        var e1 = n.instance().fromJD(t1), r = e1.year(), i = e1.dayOfYear(), a = r + 56;
                        this._createMissingCalendarData(a);
                        for(var o = 9, s = this.NEPALI_CALENDAR_DATA[a][0], l = this.NEPALI_CALENDAR_DATA[a][o] - s + 1; i > l;)++o > 12 && (o = 1, a++), l += this.NEPALI_CALENDAR_DATA[a][o];
                        var c = this.NEPALI_CALENDAR_DATA[a][o] - (l - i);
                        return this.newDate(a, o, c);
                    },
                    _createMissingCalendarData: function(t1) {
                        var e1 = this.daysPerMonth.slice(0);
                        e1.unshift(17);
                        for(var r = t1 - 1; r < t1 + 2; r++)void 0 === this.NEPALI_CALENDAR_DATA[r] && (this.NEPALI_CALENDAR_DATA[r] = e1);
                    },
                    NEPALI_CALENDAR_DATA: {
                        1970: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1971: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            32,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1972: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            30
                        ],
                        1973: [
                            19,
                            30,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        1974: [
                            19,
                            31,
                            31,
                            32,
                            30,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1975: [
                            18,
                            31,
                            31,
                            32,
                            32,
                            30,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1976: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        1977: [
                            18,
                            31,
                            32,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        1978: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1979: [
                            18,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1980: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        1981: [
                            18,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            30,
                            29,
                            30,
                            30
                        ],
                        1982: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1983: [
                            18,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1984: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        1985: [
                            18,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            30,
                            29,
                            30,
                            30
                        ],
                        1986: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1987: [
                            18,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1988: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        1989: [
                            18,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1990: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1991: [
                            18,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1992: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        1993: [
                            18,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1994: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1995: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            30
                        ],
                        1996: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        1997: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1998: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1999: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2e3: [
                            17,
                            30,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        2001: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2002: [
                            18,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2003: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2004: [
                            17,
                            30,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        2005: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2006: [
                            18,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2007: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2008: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            30,
                            29,
                            29,
                            31
                        ],
                        2009: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2010: [
                            18,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2011: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2012: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            30,
                            29,
                            30,
                            30
                        ],
                        2013: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2014: [
                            18,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2015: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2016: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            30,
                            29,
                            30,
                            30
                        ],
                        2017: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2018: [
                            18,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2019: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        2020: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2021: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2022: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            30
                        ],
                        2023: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        2024: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2025: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2026: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2027: [
                            17,
                            30,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        2028: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2029: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            32,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2030: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            30,
                            30,
                            30,
                            31
                        ],
                        2031: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            31,
                            31,
                            31,
                            31,
                            31,
                            31,
                            31
                        ],
                        2032: [
                            17,
                            32,
                            32,
                            32,
                            32,
                            32,
                            32,
                            32,
                            32,
                            32,
                            32,
                            32,
                            32
                        ],
                        2033: [
                            18,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2034: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2035: [
                            17,
                            30,
                            32,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            30,
                            29,
                            29,
                            31
                        ],
                        2036: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2037: [
                            18,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2038: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2039: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            30,
                            29,
                            30,
                            30
                        ],
                        2040: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2041: [
                            18,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2042: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2043: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            30,
                            29,
                            30,
                            30
                        ],
                        2044: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2045: [
                            18,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2046: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2047: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2048: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2049: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            30
                        ],
                        2050: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        2051: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2052: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2053: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            30
                        ],
                        2054: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        2055: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            30,
                            29,
                            30
                        ],
                        2056: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            32,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2057: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2058: [
                            17,
                            30,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        2059: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2060: [
                            17,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2061: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2062: [
                            17,
                            30,
                            32,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        2063: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2064: [
                            17,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2065: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2066: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            30,
                            29,
                            29,
                            31
                        ],
                        2067: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2068: [
                            17,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2069: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2070: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            30,
                            29,
                            30,
                            30
                        ],
                        2071: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2072: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2073: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2074: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2075: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2076: [
                            16,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            30
                        ],
                        2077: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        2078: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2079: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2080: [
                            16,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            30
                        ],
                        2081: [
                            17,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2082: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2083: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2084: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2085: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            31,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2086: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2087: [
                            16,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2088: [
                            16,
                            30,
                            31,
                            32,
                            32,
                            30,
                            31,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2089: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2090: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2091: [
                            16,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2092: [
                            16,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2093: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2094: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2095: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            30,
                            30,
                            30
                        ],
                        2096: [
                            17,
                            30,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2097: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2098: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            29,
                            30,
                            29,
                            30,
                            30,
                            31
                        ],
                        2099: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            29,
                            30,
                            30,
                            30
                        ],
                        2100: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            30,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ]
                    }
                }), n.calendars.nepali = a;
            },
            50506: function(t1, e1, r) {
                var n = r(24453), i = r(27976);
                function a(t1) {
                    this.local = this.regionalOptions[t1 || ""] || this.regionalOptions[""];
                }
                function o(t1, e1) {
                    return t1 - e1 * Math.floor(t1 / e1);
                }
                a.prototype = new n.baseCalendar, i(a.prototype, {
                    name: "Persian",
                    jdEpoch: 1948320.5,
                    daysPerMonth: [
                        31,
                        31,
                        31,
                        31,
                        31,
                        31,
                        30,
                        30,
                        30,
                        30,
                        30,
                        29
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Persian",
                            epochs: [
                                "BP",
                                "AP"
                            ],
                            monthNames: [
                                "Farvardin",
                                "Ordibehesht",
                                "Khordad",
                                "Tir",
                                "Mordad",
                                "Shahrivar",
                                "Mehr",
                                "Aban",
                                "Azar",
                                "Day",
                                "Bahman",
                                "Esfand"
                            ],
                            monthNamesShort: [
                                "Far",
                                "Ord",
                                "Kho",
                                "Tir",
                                "Mor",
                                "Sha",
                                "Meh",
                                "Aba",
                                "Aza",
                                "Day",
                                "Bah",
                                "Esf"
                            ],
                            dayNames: [
                                "Yekshambe",
                                "Doshambe",
                                "Seshambe",
                                "Ch\xe6harshambe",
                                "Panjshambe",
                                "Jom'e",
                                "Shambe"
                            ],
                            dayNamesShort: [
                                "Yek",
                                "Do",
                                "Se",
                                "Ch\xe6",
                                "Panj",
                                "Jom",
                                "Sha"
                            ],
                            dayNamesMin: [
                                "Ye",
                                "Do",
                                "Se",
                                "Ch",
                                "Pa",
                                "Jo",
                                "Sh"
                            ],
                            digits: null,
                            dateFormat: "yyyy/mm/dd",
                            firstDay: 6,
                            isRTL: !1
                        }
                    },
                    leapYear: function(t1) {
                        var e1 = this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear);
                        return 682 * ((e1.year() - (e1.year() > 0 ? 474 : 473)) % 2820 + 474 + 38) % 2816 < 682;
                    },
                    weekOfYear: function(t1, e1, r) {
                        var n = this.newDate(t1, e1, r);
                        return n.add(-(n.dayOfWeek() + 1) % 7, "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                    },
                    daysInMonth: function(t1, e1) {
                        var r = this._validate(t1, e1, this.minDay, n.local.invalidMonth);
                        return this.daysPerMonth[r.month() - 1] + (12 === r.month() && this.leapYear(r.year()) ? 1 : 0);
                    },
                    weekDay: function(t1, e1, r) {
                        return 5 !== this.dayOfWeek(t1, e1, r);
                    },
                    toJD: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidDate);
                        t1 = i.year(), e1 = i.month(), r = i.day();
                        var a = t1 - (t1 >= 0 ? 474 : 473), s = 474 + o(a, 2820);
                        return r + (e1 <= 7 ? 31 * (e1 - 1) : 30 * (e1 - 1) + 6) + Math.floor((682 * s - 110) / 2816) + 365 * (s - 1) + 1029983 * Math.floor(a / 2820) + this.jdEpoch - 1;
                    },
                    fromJD: function(t1) {
                        var e1 = (t1 = Math.floor(t1) + .5) - this.toJD(475, 1, 1), r = Math.floor(e1 / 1029983), n = o(e1, 1029983), i = 2820;
                        if (1029982 !== n) {
                            var a = Math.floor(n / 366), s = o(n, 366);
                            i = Math.floor((2134 * a + 2816 * s + 2815) / 1028522) + a + 1;
                        }
                        var l = i + 2820 * r + 474;
                        l = l <= 0 ? l - 1 : l;
                        var c = t1 - this.toJD(l, 1, 1) + 1, u = c <= 186 ? Math.ceil(c / 31) : Math.ceil((c - 6) / 30), h = t1 - this.toJD(l, u, 1) + 1;
                        return this.newDate(l, u, h);
                    }
                }), n.calendars.persian = a, n.calendars.jalali = a;
            },
            84756: function(t1, e1, r) {
                var n = r(24453), i = r(27976), a = n.instance();
                function o(t1) {
                    this.local = this.regionalOptions[t1 || ""] || this.regionalOptions[""];
                }
                o.prototype = new n.baseCalendar, i(o.prototype, {
                    name: "Taiwan",
                    jdEpoch: 2419402.5,
                    yearsOffset: 1911,
                    daysPerMonth: [
                        31,
                        28,
                        31,
                        30,
                        31,
                        30,
                        31,
                        31,
                        30,
                        31,
                        30,
                        31
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Taiwan",
                            epochs: [
                                "BROC",
                                "ROC"
                            ],
                            monthNames: [
                                "January",
                                "February",
                                "March",
                                "April",
                                "May",
                                "June",
                                "July",
                                "August",
                                "September",
                                "October",
                                "November",
                                "December"
                            ],
                            monthNamesShort: [
                                "Jan",
                                "Feb",
                                "Mar",
                                "Apr",
                                "May",
                                "Jun",
                                "Jul",
                                "Aug",
                                "Sep",
                                "Oct",
                                "Nov",
                                "Dec"
                            ],
                            dayNames: [
                                "Sunday",
                                "Monday",
                                "Tuesday",
                                "Wednesday",
                                "Thursday",
                                "Friday",
                                "Saturday"
                            ],
                            dayNamesShort: [
                                "Sun",
                                "Mon",
                                "Tue",
                                "Wed",
                                "Thu",
                                "Fri",
                                "Sat"
                            ],
                            dayNamesMin: [
                                "Su",
                                "Mo",
                                "Tu",
                                "We",
                                "Th",
                                "Fr",
                                "Sa"
                            ],
                            digits: null,
                            dateFormat: "yyyy/mm/dd",
                            firstDay: 1,
                            isRTL: !1
                        }
                    },
                    leapYear: function(t1) {
                        var e1 = this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear);
                        return t1 = this._t2gYear(e1.year()), a.leapYear(t1);
                    },
                    weekOfYear: function(t1, e1, r) {
                        var i = this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear);
                        return t1 = this._t2gYear(i.year()), a.weekOfYear(t1, i.month(), i.day());
                    },
                    daysInMonth: function(t1, e1) {
                        var r = this._validate(t1, e1, this.minDay, n.local.invalidMonth);
                        return this.daysPerMonth[r.month() - 1] + (2 === r.month() && this.leapYear(r.year()) ? 1 : 0);
                    },
                    weekDay: function(t1, e1, r) {
                        return (this.dayOfWeek(t1, e1, r) || 7) < 6;
                    },
                    toJD: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidDate);
                        return t1 = this._t2gYear(i.year()), a.toJD(t1, i.month(), i.day());
                    },
                    fromJD: function(t1) {
                        var e1 = a.fromJD(t1), r = this._g2tYear(e1.year());
                        return this.newDate(r, e1.month(), e1.day());
                    },
                    _t2gYear: function(t1) {
                        return t1 + this.yearsOffset + (t1 >= -this.yearsOffset && t1 <= -1 ? 1 : 0);
                    },
                    _g2tYear: function(t1) {
                        return t1 - this.yearsOffset - (t1 >= 1 && t1 <= this.yearsOffset ? 1 : 0);
                    }
                }), n.calendars.taiwan = o;
            },
            41858: function(t1, e1, r) {
                var n = r(24453), i = r(27976), a = n.instance();
                function o(t1) {
                    this.local = this.regionalOptions[t1 || ""] || this.regionalOptions[""];
                }
                o.prototype = new n.baseCalendar, i(o.prototype, {
                    name: "Thai",
                    jdEpoch: 1523098.5,
                    yearsOffset: 543,
                    daysPerMonth: [
                        31,
                        28,
                        31,
                        30,
                        31,
                        30,
                        31,
                        31,
                        30,
                        31,
                        30,
                        31
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Thai",
                            epochs: [
                                "BBE",
                                "BE"
                            ],
                            monthNames: [
                                "January",
                                "February",
                                "March",
                                "April",
                                "May",
                                "June",
                                "July",
                                "August",
                                "September",
                                "October",
                                "November",
                                "December"
                            ],
                            monthNamesShort: [
                                "Jan",
                                "Feb",
                                "Mar",
                                "Apr",
                                "May",
                                "Jun",
                                "Jul",
                                "Aug",
                                "Sep",
                                "Oct",
                                "Nov",
                                "Dec"
                            ],
                            dayNames: [
                                "Sunday",
                                "Monday",
                                "Tuesday",
                                "Wednesday",
                                "Thursday",
                                "Friday",
                                "Saturday"
                            ],
                            dayNamesShort: [
                                "Sun",
                                "Mon",
                                "Tue",
                                "Wed",
                                "Thu",
                                "Fri",
                                "Sat"
                            ],
                            dayNamesMin: [
                                "Su",
                                "Mo",
                                "Tu",
                                "We",
                                "Th",
                                "Fr",
                                "Sa"
                            ],
                            digits: null,
                            dateFormat: "dd/mm/yyyy",
                            firstDay: 0,
                            isRTL: !1
                        }
                    },
                    leapYear: function(t1) {
                        var e1 = this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear);
                        return t1 = this._t2gYear(e1.year()), a.leapYear(t1);
                    },
                    weekOfYear: function(t1, e1, r) {
                        var i = this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear);
                        return t1 = this._t2gYear(i.year()), a.weekOfYear(t1, i.month(), i.day());
                    },
                    daysInMonth: function(t1, e1) {
                        var r = this._validate(t1, e1, this.minDay, n.local.invalidMonth);
                        return this.daysPerMonth[r.month() - 1] + (2 === r.month() && this.leapYear(r.year()) ? 1 : 0);
                    },
                    weekDay: function(t1, e1, r) {
                        return (this.dayOfWeek(t1, e1, r) || 7) < 6;
                    },
                    toJD: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidDate);
                        return t1 = this._t2gYear(i.year()), a.toJD(t1, i.month(), i.day());
                    },
                    fromJD: function(t1) {
                        var e1 = a.fromJD(t1), r = this._g2tYear(e1.year());
                        return this.newDate(r, e1.month(), e1.day());
                    },
                    _t2gYear: function(t1) {
                        return t1 - this.yearsOffset - (t1 >= 1 && t1 <= this.yearsOffset ? 1 : 0);
                    },
                    _g2tYear: function(t1) {
                        return t1 + this.yearsOffset + (t1 >= -this.yearsOffset && t1 <= -1 ? 1 : 0);
                    }
                }), n.calendars.thai = o;
            },
            57985: function(t1, e1, r) {
                var n = r(24453), i = r(27976);
                function a(t1) {
                    this.local = this.regionalOptions[t1 || ""] || this.regionalOptions[""];
                }
                a.prototype = new n.baseCalendar, i(a.prototype, {
                    name: "UmmAlQura",
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Umm al-Qura",
                            epochs: [
                                "BH",
                                "AH"
                            ],
                            monthNames: [
                                "Al-Muharram",
                                "Safar",
                                "Rabi' al-awwal",
                                "Rabi' Al-Thani",
                                "Jumada Al-Awwal",
                                "Jumada Al-Thani",
                                "Rajab",
                                "Sha'aban",
                                "Ramadan",
                                "Shawwal",
                                "Dhu al-Qi'dah",
                                "Dhu al-Hijjah"
                            ],
                            monthNamesShort: [
                                "Muh",
                                "Saf",
                                "Rab1",
                                "Rab2",
                                "Jum1",
                                "Jum2",
                                "Raj",
                                "Sha'",
                                "Ram",
                                "Shaw",
                                "DhuQ",
                                "DhuH"
                            ],
                            dayNames: [
                                "Yawm al-Ahad",
                                "Yawm al-Ithnain",
                                "Yawm al-Thal\u0101th\u0101\u2019",
                                "Yawm al-Arba\u2018\u0101\u2019",
                                "Yawm al-Kham\u012Bs",
                                "Yawm al-Jum\u2018a",
                                "Yawm al-Sabt"
                            ],
                            dayNamesMin: [
                                "Ah",
                                "Ith",
                                "Th",
                                "Ar",
                                "Kh",
                                "Ju",
                                "Sa"
                            ],
                            digits: null,
                            dateFormat: "yyyy/mm/dd",
                            firstDay: 6,
                            isRTL: !0
                        }
                    },
                    leapYear: function(t1) {
                        var e1 = this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear);
                        return 355 === this.daysInYear(e1.year());
                    },
                    weekOfYear: function(t1, e1, r) {
                        var n = this.newDate(t1, e1, r);
                        return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                    },
                    daysInYear: function(t1) {
                        for(var e1 = 0, r = 1; r <= 12; r++)e1 += this.daysInMonth(t1, r);
                        return e1;
                    },
                    daysInMonth: function(t1, e1) {
                        for(var r = this._validate(t1, e1, this.minDay, n.local.invalidMonth).toJD() - 24e5 + .5, i = 0, a = 0; a < o.length; a++){
                            if (o[a] > r) return o[i] - o[i - 1];
                            i++;
                        }
                        return 30;
                    },
                    weekDay: function(t1, e1, r) {
                        return 5 !== this.dayOfWeek(t1, e1, r);
                    },
                    toJD: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidDate), a = 12 * (i.year() - 1) + i.month() - 15292;
                        return i.day() + o[a - 1] - 1 + 24e5 - .5;
                    },
                    fromJD: function(t1) {
                        for(var e1 = t1 - 24e5 + .5, r = 0, n = 0; n < o.length && !(o[n] > e1); n++)r++;
                        var i = r + 15292, a = Math.floor((i - 1) / 12), s = a + 1, l = i - 12 * a, c = e1 - o[r - 1] + 1;
                        return this.newDate(s, l, c);
                    },
                    isValid: function(t1, e1, r) {
                        var i = n.baseCalendar.prototype.isValid.apply(this, arguments);
                        return i && (i = (t1 = null != t1.year ? t1.year : t1) >= 1276 && t1 <= 1500), i;
                    },
                    _validate: function(t1, e1, r, i) {
                        var a = n.baseCalendar.prototype._validate.apply(this, arguments);
                        if (a.year < 1276 || a.year > 1500) throw i.replace(/\{0\}/, this.local.name);
                        return a;
                    }
                }), n.calendars.ummalqura = a;
                var o = [
                    20,
                    50,
                    79,
                    109,
                    138,
                    168,
                    197,
                    227,
                    256,
                    286,
                    315,
                    345,
                    374,
                    404,
                    433,
                    463,
                    492,
                    522,
                    551,
                    581,
                    611,
                    641,
                    670,
                    700,
                    729,
                    759,
                    788,
                    818,
                    847,
                    877,
                    906,
                    936,
                    965,
                    995,
                    1024,
                    1054,
                    1083,
                    1113,
                    1142,
                    1172,
                    1201,
                    1231,
                    1260,
                    1290,
                    1320,
                    1350,
                    1379,
                    1409,
                    1438,
                    1468,
                    1497,
                    1527,
                    1556,
                    1586,
                    1615,
                    1645,
                    1674,
                    1704,
                    1733,
                    1763,
                    1792,
                    1822,
                    1851,
                    1881,
                    1910,
                    1940,
                    1969,
                    1999,
                    2028,
                    2058,
                    2087,
                    2117,
                    2146,
                    2176,
                    2205,
                    2235,
                    2264,
                    2294,
                    2323,
                    2353,
                    2383,
                    2413,
                    2442,
                    2472,
                    2501,
                    2531,
                    2560,
                    2590,
                    2619,
                    2649,
                    2678,
                    2708,
                    2737,
                    2767,
                    2796,
                    2826,
                    2855,
                    2885,
                    2914,
                    2944,
                    2973,
                    3003,
                    3032,
                    3062,
                    3091,
                    3121,
                    3150,
                    3180,
                    3209,
                    3239,
                    3268,
                    3298,
                    3327,
                    3357,
                    3386,
                    3416,
                    3446,
                    3476,
                    3505,
                    3535,
                    3564,
                    3594,
                    3623,
                    3653,
                    3682,
                    3712,
                    3741,
                    3771,
                    3800,
                    3830,
                    3859,
                    3889,
                    3918,
                    3948,
                    3977,
                    4007,
                    4036,
                    4066,
                    4095,
                    4125,
                    4155,
                    4185,
                    4214,
                    4244,
                    4273,
                    4303,
                    4332,
                    4362,
                    4391,
                    4421,
                    4450,
                    4480,
                    4509,
                    4539,
                    4568,
                    4598,
                    4627,
                    4657,
                    4686,
                    4716,
                    4745,
                    4775,
                    4804,
                    4834,
                    4863,
                    4893,
                    4922,
                    4952,
                    4981,
                    5011,
                    5040,
                    5070,
                    5099,
                    5129,
                    5158,
                    5188,
                    5218,
                    5248,
                    5277,
                    5307,
                    5336,
                    5366,
                    5395,
                    5425,
                    5454,
                    5484,
                    5513,
                    5543,
                    5572,
                    5602,
                    5631,
                    5661,
                    5690,
                    5720,
                    5749,
                    5779,
                    5808,
                    5838,
                    5867,
                    5897,
                    5926,
                    5956,
                    5985,
                    6015,
                    6044,
                    6074,
                    6103,
                    6133,
                    6162,
                    6192,
                    6221,
                    6251,
                    6281,
                    6311,
                    6340,
                    6370,
                    6399,
                    6429,
                    6458,
                    6488,
                    6517,
                    6547,
                    6576,
                    6606,
                    6635,
                    6665,
                    6694,
                    6724,
                    6753,
                    6783,
                    6812,
                    6842,
                    6871,
                    6901,
                    6930,
                    6960,
                    6989,
                    7019,
                    7048,
                    7078,
                    7107,
                    7137,
                    7166,
                    7196,
                    7225,
                    7255,
                    7284,
                    7314,
                    7344,
                    7374,
                    7403,
                    7433,
                    7462,
                    7492,
                    7521,
                    7551,
                    7580,
                    7610,
                    7639,
                    7669,
                    7698,
                    7728,
                    7757,
                    7787,
                    7816,
                    7846,
                    7875,
                    7905,
                    7934,
                    7964,
                    7993,
                    8023,
                    8053,
                    8083,
                    8112,
                    8142,
                    8171,
                    8201,
                    8230,
                    8260,
                    8289,
                    8319,
                    8348,
                    8378,
                    8407,
                    8437,
                    8466,
                    8496,
                    8525,
                    8555,
                    8584,
                    8614,
                    8643,
                    8673,
                    8702,
                    8732,
                    8761,
                    8791,
                    8821,
                    8850,
                    8880,
                    8909,
                    8938,
                    8968,
                    8997,
                    9027,
                    9056,
                    9086,
                    9115,
                    9145,
                    9175,
                    9205,
                    9234,
                    9264,
                    9293,
                    9322,
                    9352,
                    9381,
                    9410,
                    9440,
                    9470,
                    9499,
                    9529,
                    9559,
                    9589,
                    9618,
                    9648,
                    9677,
                    9706,
                    9736,
                    9765,
                    9794,
                    9824,
                    9853,
                    9883,
                    9913,
                    9943,
                    9972,
                    10002,
                    10032,
                    10061,
                    10090,
                    10120,
                    10149,
                    10178,
                    10208,
                    10237,
                    10267,
                    10297,
                    10326,
                    10356,
                    10386,
                    10415,
                    10445,
                    10474,
                    10504,
                    10533,
                    10562,
                    10592,
                    10621,
                    10651,
                    10680,
                    10710,
                    10740,
                    10770,
                    10799,
                    10829,
                    10858,
                    10888,
                    10917,
                    10947,
                    10976,
                    11005,
                    11035,
                    11064,
                    11094,
                    11124,
                    11153,
                    11183,
                    11213,
                    11242,
                    11272,
                    11301,
                    11331,
                    11360,
                    11389,
                    11419,
                    11448,
                    11478,
                    11507,
                    11537,
                    11567,
                    11596,
                    11626,
                    11655,
                    11685,
                    11715,
                    11744,
                    11774,
                    11803,
                    11832,
                    11862,
                    11891,
                    11921,
                    11950,
                    11980,
                    12010,
                    12039,
                    12069,
                    12099,
                    12128,
                    12158,
                    12187,
                    12216,
                    12246,
                    12275,
                    12304,
                    12334,
                    12364,
                    12393,
                    12423,
                    12453,
                    12483,
                    12512,
                    12542,
                    12571,
                    12600,
                    12630,
                    12659,
                    12688,
                    12718,
                    12747,
                    12777,
                    12807,
                    12837,
                    12866,
                    12896,
                    12926,
                    12955,
                    12984,
                    13014,
                    13043,
                    13072,
                    13102,
                    13131,
                    13161,
                    13191,
                    13220,
                    13250,
                    13280,
                    13310,
                    13339,
                    13368,
                    13398,
                    13427,
                    13456,
                    13486,
                    13515,
                    13545,
                    13574,
                    13604,
                    13634,
                    13664,
                    13693,
                    13723,
                    13752,
                    13782,
                    13811,
                    13840,
                    13870,
                    13899,
                    13929,
                    13958,
                    13988,
                    14018,
                    14047,
                    14077,
                    14107,
                    14136,
                    14166,
                    14195,
                    14224,
                    14254,
                    14283,
                    14313,
                    14342,
                    14372,
                    14401,
                    14431,
                    14461,
                    14490,
                    14520,
                    14550,
                    14579,
                    14609,
                    14638,
                    14667,
                    14697,
                    14726,
                    14756,
                    14785,
                    14815,
                    14844,
                    14874,
                    14904,
                    14933,
                    14963,
                    14993,
                    15021,
                    15051,
                    15081,
                    15110,
                    15140,
                    15169,
                    15199,
                    15228,
                    15258,
                    15287,
                    15317,
                    15347,
                    15377,
                    15406,
                    15436,
                    15465,
                    15494,
                    15524,
                    15553,
                    15582,
                    15612,
                    15641,
                    15671,
                    15701,
                    15731,
                    15760,
                    15790,
                    15820,
                    15849,
                    15878,
                    15908,
                    15937,
                    15966,
                    15996,
                    16025,
                    16055,
                    16085,
                    16114,
                    16144,
                    16174,
                    16204,
                    16233,
                    16262,
                    16292,
                    16321,
                    16350,
                    16380,
                    16409,
                    16439,
                    16468,
                    16498,
                    16528,
                    16558,
                    16587,
                    16617,
                    16646,
                    16676,
                    16705,
                    16734,
                    16764,
                    16793,
                    16823,
                    16852,
                    16882,
                    16912,
                    16941,
                    16971,
                    17001,
                    17030,
                    17060,
                    17089,
                    17118,
                    17148,
                    17177,
                    17207,
                    17236,
                    17266,
                    17295,
                    17325,
                    17355,
                    17384,
                    17414,
                    17444,
                    17473,
                    17502,
                    17532,
                    17561,
                    17591,
                    17620,
                    17650,
                    17679,
                    17709,
                    17738,
                    17768,
                    17798,
                    17827,
                    17857,
                    17886,
                    17916,
                    17945,
                    17975,
                    18004,
                    18034,
                    18063,
                    18093,
                    18122,
                    18152,
                    18181,
                    18211,
                    18241,
                    18270,
                    18300,
                    18330,
                    18359,
                    18388,
                    18418,
                    18447,
                    18476,
                    18506,
                    18535,
                    18565,
                    18595,
                    18625,
                    18654,
                    18684,
                    18714,
                    18743,
                    18772,
                    18802,
                    18831,
                    18860,
                    18890,
                    18919,
                    18949,
                    18979,
                    19008,
                    19038,
                    19068,
                    19098,
                    19127,
                    19156,
                    19186,
                    19215,
                    19244,
                    19274,
                    19303,
                    19333,
                    19362,
                    19392,
                    19422,
                    19452,
                    19481,
                    19511,
                    19540,
                    19570,
                    19599,
                    19628,
                    19658,
                    19687,
                    19717,
                    19746,
                    19776,
                    19806,
                    19836,
                    19865,
                    19895,
                    19924,
                    19954,
                    19983,
                    20012,
                    20042,
                    20071,
                    20101,
                    20130,
                    20160,
                    20190,
                    20219,
                    20249,
                    20279,
                    20308,
                    20338,
                    20367,
                    20396,
                    20426,
                    20455,
                    20485,
                    20514,
                    20544,
                    20573,
                    20603,
                    20633,
                    20662,
                    20692,
                    20721,
                    20751,
                    20780,
                    20810,
                    20839,
                    20869,
                    20898,
                    20928,
                    20957,
                    20987,
                    21016,
                    21046,
                    21076,
                    21105,
                    21135,
                    21164,
                    21194,
                    21223,
                    21253,
                    21282,
                    21312,
                    21341,
                    21371,
                    21400,
                    21430,
                    21459,
                    21489,
                    21519,
                    21548,
                    21578,
                    21607,
                    21637,
                    21666,
                    21696,
                    21725,
                    21754,
                    21784,
                    21813,
                    21843,
                    21873,
                    21902,
                    21932,
                    21962,
                    21991,
                    22021,
                    22050,
                    22080,
                    22109,
                    22138,
                    22168,
                    22197,
                    22227,
                    22256,
                    22286,
                    22316,
                    22346,
                    22375,
                    22405,
                    22434,
                    22464,
                    22493,
                    22522,
                    22552,
                    22581,
                    22611,
                    22640,
                    22670,
                    22700,
                    22730,
                    22759,
                    22789,
                    22818,
                    22848,
                    22877,
                    22906,
                    22936,
                    22965,
                    22994,
                    23024,
                    23054,
                    23083,
                    23113,
                    23143,
                    23173,
                    23202,
                    23232,
                    23261,
                    23290,
                    23320,
                    23349,
                    23379,
                    23408,
                    23438,
                    23467,
                    23497,
                    23527,
                    23556,
                    23586,
                    23616,
                    23645,
                    23674,
                    23704,
                    23733,
                    23763,
                    23792,
                    23822,
                    23851,
                    23881,
                    23910,
                    23940,
                    23970,
                    23999,
                    24029,
                    24058,
                    24088,
                    24117,
                    24147,
                    24176,
                    24206,
                    24235,
                    24265,
                    24294,
                    24324,
                    24353,
                    24383,
                    24413,
                    24442,
                    24472,
                    24501,
                    24531,
                    24560,
                    24590,
                    24619,
                    24648,
                    24678,
                    24707,
                    24737,
                    24767,
                    24796,
                    24826,
                    24856,
                    24885,
                    24915,
                    24944,
                    24974,
                    25003,
                    25032,
                    25062,
                    25091,
                    25121,
                    25150,
                    25180,
                    25210,
                    25240,
                    25269,
                    25299,
                    25328,
                    25358,
                    25387,
                    25416,
                    25446,
                    25475,
                    25505,
                    25534,
                    25564,
                    25594,
                    25624,
                    25653,
                    25683,
                    25712,
                    25742,
                    25771,
                    25800,
                    25830,
                    25859,
                    25888,
                    25918,
                    25948,
                    25977,
                    26007,
                    26037,
                    26067,
                    26096,
                    26126,
                    26155,
                    26184,
                    26214,
                    26243,
                    26272,
                    26302,
                    26332,
                    26361,
                    26391,
                    26421,
                    26451,
                    26480,
                    26510,
                    26539,
                    26568,
                    26598,
                    26627,
                    26656,
                    26686,
                    26715,
                    26745,
                    26775,
                    26805,
                    26834,
                    26864,
                    26893,
                    26923,
                    26952,
                    26982,
                    27011,
                    27041,
                    27070,
                    27099,
                    27129,
                    27159,
                    27188,
                    27218,
                    27248,
                    27277,
                    27307,
                    27336,
                    27366,
                    27395,
                    27425,
                    27454,
                    27484,
                    27513,
                    27542,
                    27572,
                    27602,
                    27631,
                    27661,
                    27691,
                    27720,
                    27750,
                    27779,
                    27809,
                    27838,
                    27868,
                    27897,
                    27926,
                    27956,
                    27985,
                    28015,
                    28045,
                    28074,
                    28104,
                    28134,
                    28163,
                    28193,
                    28222,
                    28252,
                    28281,
                    28310,
                    28340,
                    28369,
                    28399,
                    28428,
                    28458,
                    28488,
                    28517,
                    28547,
                    28577,
                    28607,
                    28636,
                    28665,
                    28695,
                    28724,
                    28754,
                    28783,
                    28813,
                    28843,
                    28872,
                    28901,
                    28931,
                    28960,
                    28990,
                    29019,
                    29049,
                    29078,
                    29108,
                    29137,
                    29167,
                    29196,
                    29226,
                    29255,
                    29285,
                    29315,
                    29345,
                    29375,
                    29404,
                    29434,
                    29463,
                    29492,
                    29522,
                    29551,
                    29580,
                    29610,
                    29640,
                    29669,
                    29699,
                    29729,
                    29759,
                    29788,
                    29818,
                    29847,
                    29876,
                    29906,
                    29935,
                    29964,
                    29994,
                    30023,
                    30053,
                    30082,
                    30112,
                    30141,
                    30171,
                    30200,
                    30230,
                    30259,
                    30289,
                    30318,
                    30348,
                    30378,
                    30408,
                    30437,
                    30467,
                    30496,
                    30526,
                    30555,
                    30585,
                    30614,
                    30644,
                    30673,
                    30703,
                    30732,
                    30762,
                    30791,
                    30821,
                    30850,
                    30880,
                    30909,
                    30939,
                    30968,
                    30998,
                    31027,
                    31057,
                    31086,
                    31116,
                    31145,
                    31175,
                    31204,
                    31234,
                    31263,
                    31293,
                    31322,
                    31352,
                    31381,
                    31411,
                    31441,
                    31471,
                    31500,
                    31530,
                    31559,
                    31589,
                    31618,
                    31648,
                    31676,
                    31706,
                    31736,
                    31766,
                    31795,
                    31825,
                    31854,
                    31884,
                    31913,
                    31943,
                    31972,
                    32002,
                    32031,
                    32061,
                    32090,
                    32120,
                    32150,
                    32180,
                    32209,
                    32239,
                    32268,
                    32298,
                    32327,
                    32357,
                    32386,
                    32416,
                    32445,
                    32475,
                    32504,
                    32534,
                    32563,
                    32593,
                    32622,
                    32652,
                    32681,
                    32711,
                    32740,
                    32770,
                    32799,
                    32829,
                    32858,
                    32888,
                    32917,
                    32947,
                    32976,
                    33006,
                    33035,
                    33065,
                    33094,
                    33124,
                    33153,
                    33183,
                    33213,
                    33243,
                    33272,
                    33302,
                    33331,
                    33361,
                    33390,
                    33420,
                    33450,
                    33479,
                    33509,
                    33539,
                    33568,
                    33598,
                    33627,
                    33657,
                    33686,
                    33716,
                    33745,
                    33775,
                    33804,
                    33834,
                    33863,
                    33893,
                    33922,
                    33952,
                    33981,
                    34011,
                    34040,
                    34069,
                    34099,
                    34128,
                    34158,
                    34187,
                    34217,
                    34247,
                    34277,
                    34306,
                    34336,
                    34365,
                    34395,
                    34424,
                    34454,
                    34483,
                    34512,
                    34542,
                    34571,
                    34601,
                    34631,
                    34660,
                    34690,
                    34719,
                    34749,
                    34778,
                    34808,
                    34837,
                    34867,
                    34896,
                    34926,
                    34955,
                    34985,
                    35015,
                    35044,
                    35074,
                    35103,
                    35133,
                    35162,
                    35192,
                    35222,
                    35251,
                    35280,
                    35310,
                    35340,
                    35370,
                    35399,
                    35429,
                    35458,
                    35488,
                    35517,
                    35547,
                    35576,
                    35605,
                    35635,
                    35665,
                    35694,
                    35723,
                    35753,
                    35782,
                    35811,
                    35841,
                    35871,
                    35901,
                    35930,
                    35960,
                    35989,
                    36019,
                    36048,
                    36078,
                    36107,
                    36136,
                    36166,
                    36195,
                    36225,
                    36254,
                    36284,
                    36314,
                    36343,
                    36373,
                    36403,
                    36433,
                    36462,
                    36492,
                    36521,
                    36551,
                    36580,
                    36610,
                    36639,
                    36669,
                    36698,
                    36728,
                    36757,
                    36786,
                    36816,
                    36845,
                    36875,
                    36904,
                    36934,
                    36963,
                    36993,
                    37022,
                    37052,
                    37081,
                    37111,
                    37141,
                    37170,
                    37200,
                    37229,
                    37259,
                    37288,
                    37318,
                    37347,
                    37377,
                    37406,
                    37436,
                    37465,
                    37495,
                    37524,
                    37554,
                    37584,
                    37613,
                    37643,
                    37672,
                    37701,
                    37731,
                    37760,
                    37790,
                    37819,
                    37849,
                    37878,
                    37908,
                    37938,
                    37967,
                    37997,
                    38027,
                    38056,
                    38085,
                    38115,
                    38144,
                    38174,
                    38203,
                    38233,
                    38262,
                    38292,
                    38322,
                    38351,
                    38381,
                    38410,
                    38440,
                    38469,
                    38499,
                    38528,
                    38558,
                    38587,
                    38617,
                    38646,
                    38676,
                    38705,
                    38735,
                    38764,
                    38794,
                    38823,
                    38853,
                    38882,
                    38912,
                    38941,
                    38971,
                    39001,
                    39030,
                    39059,
                    39089,
                    39118,
                    39148,
                    39178,
                    39208,
                    39237,
                    39267,
                    39297,
                    39326,
                    39355,
                    39385,
                    39414,
                    39444,
                    39473,
                    39503,
                    39532,
                    39562,
                    39592,
                    39621,
                    39650,
                    39680,
                    39709,
                    39739,
                    39768,
                    39798,
                    39827,
                    39857,
                    39886,
                    39916,
                    39946,
                    39975,
                    40005,
                    40035,
                    40064,
                    40094,
                    40123,
                    40153,
                    40182,
                    40212,
                    40241,
                    40271,
                    40300,
                    40330,
                    40359,
                    40389,
                    40418,
                    40448,
                    40477,
                    40507,
                    40536,
                    40566,
                    40595,
                    40625,
                    40655,
                    40685,
                    40714,
                    40744,
                    40773,
                    40803,
                    40832,
                    40862,
                    40892,
                    40921,
                    40951,
                    40980,
                    41009,
                    41039,
                    41068,
                    41098,
                    41127,
                    41157,
                    41186,
                    41216,
                    41245,
                    41275,
                    41304,
                    41334,
                    41364,
                    41393,
                    41422,
                    41452,
                    41481,
                    41511,
                    41540,
                    41570,
                    41599,
                    41629,
                    41658,
                    41688,
                    41718,
                    41748,
                    41777,
                    41807,
                    41836,
                    41865,
                    41894,
                    41924,
                    41953,
                    41983,
                    42012,
                    42042,
                    42072,
                    42102,
                    42131,
                    42161,
                    42190,
                    42220,
                    42249,
                    42279,
                    42308,
                    42337,
                    42367,
                    42397,
                    42426,
                    42456,
                    42485,
                    42515,
                    42545,
                    42574,
                    42604,
                    42633,
                    42662,
                    42692,
                    42721,
                    42751,
                    42780,
                    42810,
                    42839,
                    42869,
                    42899,
                    42929,
                    42958,
                    42988,
                    43017,
                    43046,
                    43076,
                    43105,
                    43135,
                    43164,
                    43194,
                    43223,
                    43253,
                    43283,
                    43312,
                    43342,
                    43371,
                    43401,
                    43430,
                    43460,
                    43489,
                    43519,
                    43548,
                    43578,
                    43607,
                    43637,
                    43666,
                    43696,
                    43726,
                    43755,
                    43785,
                    43814,
                    43844,
                    43873,
                    43903,
                    43932,
                    43962,
                    43991,
                    44021,
                    44050,
                    44080,
                    44109,
                    44139,
                    44169,
                    44198,
                    44228,
                    44258,
                    44287,
                    44317,
                    44346,
                    44375,
                    44405,
                    44434,
                    44464,
                    44493,
                    44523,
                    44553,
                    44582,
                    44612,
                    44641,
                    44671,
                    44700,
                    44730,
                    44759,
                    44788,
                    44818,
                    44847,
                    44877,
                    44906,
                    44936,
                    44966,
                    44996,
                    45025,
                    45055,
                    45084,
                    45114,
                    45143,
                    45172,
                    45202,
                    45231,
                    45261,
                    45290,
                    45320,
                    45350,
                    45380,
                    45409,
                    45439,
                    45468,
                    45498,
                    45527,
                    45556,
                    45586,
                    45615,
                    45644,
                    45674,
                    45704,
                    45733,
                    45763,
                    45793,
                    45823,
                    45852,
                    45882,
                    45911,
                    45940,
                    45970,
                    45999,
                    46028,
                    46058,
                    46088,
                    46117,
                    46147,
                    46177,
                    46206,
                    46236,
                    46265,
                    46295,
                    46324,
                    46354,
                    46383,
                    46413,
                    46442,
                    46472,
                    46501,
                    46531,
                    46560,
                    46590,
                    46620,
                    46649,
                    46679,
                    46708,
                    46738,
                    46767,
                    46797,
                    46826,
                    46856,
                    46885,
                    46915,
                    46944,
                    46974,
                    47003,
                    47033,
                    47063,
                    47092,
                    47122,
                    47151,
                    47181,
                    47210,
                    47240,
                    47269,
                    47298,
                    47328,
                    47357,
                    47387,
                    47417,
                    47446,
                    47476,
                    47506,
                    47535,
                    47565,
                    47594,
                    47624,
                    47653,
                    47682,
                    47712,
                    47741,
                    47771,
                    47800,
                    47830,
                    47860,
                    47890,
                    47919,
                    47949,
                    47978,
                    48008,
                    48037,
                    48066,
                    48096,
                    48125,
                    48155,
                    48184,
                    48214,
                    48244,
                    48273,
                    48303,
                    48333,
                    48362,
                    48392,
                    48421,
                    48450,
                    48480,
                    48509,
                    48538,
                    48568,
                    48598,
                    48627,
                    48657,
                    48687,
                    48717,
                    48746,
                    48776,
                    48805,
                    48834,
                    48864,
                    48893,
                    48922,
                    48952,
                    48982,
                    49011,
                    49041,
                    49071,
                    49100,
                    49130,
                    49160,
                    49189,
                    49218,
                    49248,
                    49277,
                    49306,
                    49336,
                    49365,
                    49395,
                    49425,
                    49455,
                    49484,
                    49514,
                    49543,
                    49573,
                    49602,
                    49632,
                    49661,
                    49690,
                    49720,
                    49749,
                    49779,
                    49809,
                    49838,
                    49868,
                    49898,
                    49927,
                    49957,
                    49986,
                    50016,
                    50045,
                    50075,
                    50104,
                    50133,
                    50163,
                    50192,
                    50222,
                    50252,
                    50281,
                    50311,
                    50340,
                    50370,
                    50400,
                    50429,
                    50459,
                    50488,
                    50518,
                    50547,
                    50576,
                    50606,
                    50635,
                    50665,
                    50694,
                    50724,
                    50754,
                    50784,
                    50813,
                    50843,
                    50872,
                    50902,
                    50931,
                    50960,
                    50990,
                    51019,
                    51049,
                    51078,
                    51108,
                    51138,
                    51167,
                    51197,
                    51227,
                    51256,
                    51286,
                    51315,
                    51345,
                    51374,
                    51403,
                    51433,
                    51462,
                    51492,
                    51522,
                    51552,
                    51582,
                    51611,
                    51641,
                    51670,
                    51699,
                    51729,
                    51758,
                    51787,
                    51816,
                    51846,
                    51876,
                    51906,
                    51936,
                    51965,
                    51995,
                    52025,
                    52054,
                    52083,
                    52113,
                    52142,
                    52171,
                    52200,
                    52230,
                    52260,
                    52290,
                    52319,
                    52349,
                    52379,
                    52408,
                    52438,
                    52467,
                    52497,
                    52526,
                    52555,
                    52585,
                    52614,
                    52644,
                    52673,
                    52703,
                    52733,
                    52762,
                    52792,
                    52822,
                    52851,
                    52881,
                    52910,
                    52939,
                    52969,
                    52998,
                    53028,
                    53057,
                    53087,
                    53116,
                    53146,
                    53176,
                    53205,
                    53235,
                    53264,
                    53294,
                    53324,
                    53353,
                    53383,
                    53412,
                    53441,
                    53471,
                    53500,
                    53530,
                    53559,
                    53589,
                    53619,
                    53648,
                    53678,
                    53708,
                    53737,
                    53767,
                    53796,
                    53825,
                    53855,
                    53884,
                    53913,
                    53943,
                    53973,
                    54003,
                    54032,
                    54062,
                    54092,
                    54121,
                    54151,
                    54180,
                    54209,
                    54239,
                    54268,
                    54297,
                    54327,
                    54357,
                    54387,
                    54416,
                    54446,
                    54476,
                    54505,
                    54535,
                    54564,
                    54593,
                    54623,
                    54652,
                    54681,
                    54711,
                    54741,
                    54770,
                    54800,
                    54830,
                    54859,
                    54889,
                    54919,
                    54948,
                    54977,
                    55007,
                    55036,
                    55066,
                    55095,
                    55125,
                    55154,
                    55184,
                    55213,
                    55243,
                    55273,
                    55302,
                    55332,
                    55361,
                    55391,
                    55420,
                    55450,
                    55479,
                    55508,
                    55538,
                    55567,
                    55597,
                    55627,
                    55657,
                    55686,
                    55716,
                    55745,
                    55775,
                    55804,
                    55834,
                    55863,
                    55892,
                    55922,
                    55951,
                    55981,
                    56011,
                    56040,
                    56070,
                    56100,
                    56129,
                    56159,
                    56188,
                    56218,
                    56247,
                    56276,
                    56306,
                    56335,
                    56365,
                    56394,
                    56424,
                    56454,
                    56483,
                    56513,
                    56543,
                    56572,
                    56601,
                    56631,
                    56660,
                    56690,
                    56719,
                    56749,
                    56778,
                    56808,
                    56837,
                    56867,
                    56897,
                    56926,
                    56956,
                    56985,
                    57015,
                    57044,
                    57074,
                    57103,
                    57133,
                    57162,
                    57192,
                    57221,
                    57251,
                    57280,
                    57310,
                    57340,
                    57369,
                    57399,
                    57429,
                    57458,
                    57487,
                    57517,
                    57546,
                    57576,
                    57605,
                    57634,
                    57664,
                    57694,
                    57723,
                    57753,
                    57783,
                    57813,
                    57842,
                    57871,
                    57901,
                    57930,
                    57959,
                    57989,
                    58018,
                    58048,
                    58077,
                    58107,
                    58137,
                    58167,
                    58196,
                    58226,
                    58255,
                    58285,
                    58314,
                    58343,
                    58373,
                    58402,
                    58432,
                    58461,
                    58491,
                    58521,
                    58551,
                    58580,
                    58610,
                    58639,
                    58669,
                    58698,
                    58727,
                    58757,
                    58786,
                    58816,
                    58845,
                    58875,
                    58905,
                    58934,
                    58964,
                    58994,
                    59023,
                    59053,
                    59082,
                    59111,
                    59141,
                    59170,
                    59200,
                    59229,
                    59259,
                    59288,
                    59318,
                    59348,
                    59377,
                    59407,
                    59436,
                    59466,
                    59495,
                    59525,
                    59554,
                    59584,
                    59613,
                    59643,
                    59672,
                    59702,
                    59731,
                    59761,
                    59791,
                    59820,
                    59850,
                    59879,
                    59909,
                    59939,
                    59968,
                    59997,
                    60027,
                    60056,
                    60086,
                    60115,
                    60145,
                    60174,
                    60204,
                    60234,
                    60264,
                    60293,
                    60323,
                    60352,
                    60381,
                    60411,
                    60440,
                    60469,
                    60499,
                    60528,
                    60558,
                    60588,
                    60618,
                    60648,
                    60677,
                    60707,
                    60736,
                    60765,
                    60795,
                    60824,
                    60853,
                    60883,
                    60912,
                    60942,
                    60972,
                    61002,
                    61031,
                    61061,
                    61090,
                    61120,
                    61149,
                    61179,
                    61208,
                    61237,
                    61267,
                    61296,
                    61326,
                    61356,
                    61385,
                    61415,
                    61445,
                    61474,
                    61504,
                    61533,
                    61563,
                    61592,
                    61621,
                    61651,
                    61680,
                    61710,
                    61739,
                    61769,
                    61799,
                    61828,
                    61858,
                    61888,
                    61917,
                    61947,
                    61976,
                    62006,
                    62035,
                    62064,
                    62094,
                    62123,
                    62153,
                    62182,
                    62212,
                    62242,
                    62271,
                    62301,
                    62331,
                    62360,
                    62390,
                    62419,
                    62448,
                    62478,
                    62507,
                    62537,
                    62566,
                    62596,
                    62625,
                    62655,
                    62685,
                    62715,
                    62744,
                    62774,
                    62803,
                    62832,
                    62862,
                    62891,
                    62921,
                    62950,
                    62980,
                    63009,
                    63039,
                    63069,
                    63099,
                    63128,
                    63157,
                    63187,
                    63216,
                    63246,
                    63275,
                    63305,
                    63334,
                    63363,
                    63393,
                    63423,
                    63453,
                    63482,
                    63512,
                    63541,
                    63571,
                    63600,
                    63630,
                    63659,
                    63689,
                    63718,
                    63747,
                    63777,
                    63807,
                    63836,
                    63866,
                    63895,
                    63925,
                    63955,
                    63984,
                    64014,
                    64043,
                    64073,
                    64102,
                    64131,
                    64161,
                    64190,
                    64220,
                    64249,
                    64279,
                    64309,
                    64339,
                    64368,
                    64398,
                    64427,
                    64457,
                    64486,
                    64515,
                    64545,
                    64574,
                    64603,
                    64633,
                    64663,
                    64692,
                    64722,
                    64752,
                    64782,
                    64811,
                    64841,
                    64870,
                    64899,
                    64929,
                    64958,
                    64987,
                    65017,
                    65047,
                    65076,
                    65106,
                    65136,
                    65166,
                    65195,
                    65225,
                    65254,
                    65283,
                    65313,
                    65342,
                    65371,
                    65401,
                    65431,
                    65460,
                    65490,
                    65520,
                    65549,
                    65579,
                    65608,
                    65638,
                    65667,
                    65697,
                    65726,
                    65755,
                    65785,
                    65815,
                    65844,
                    65874,
                    65903,
                    65933,
                    65963,
                    65992,
                    66022,
                    66051,
                    66081,
                    66110,
                    66140,
                    66169,
                    66199,
                    66228,
                    66258,
                    66287,
                    66317,
                    66346,
                    66376,
                    66405,
                    66435,
                    66465,
                    66494,
                    66524,
                    66553,
                    66583,
                    66612,
                    66641,
                    66671,
                    66700,
                    66730,
                    66760,
                    66789,
                    66819,
                    66849,
                    66878,
                    66908,
                    66937,
                    66967,
                    66996,
                    67025,
                    67055,
                    67084,
                    67114,
                    67143,
                    67173,
                    67203,
                    67233,
                    67262,
                    67292,
                    67321,
                    67351,
                    67380,
                    67409,
                    67439,
                    67468,
                    67497,
                    67527,
                    67557,
                    67587,
                    67617,
                    67646,
                    67676,
                    67705,
                    67735,
                    67764,
                    67793,
                    67823,
                    67852,
                    67882,
                    67911,
                    67941,
                    67971,
                    68e3,
                    68030,
                    68060,
                    68089,
                    68119,
                    68148,
                    68177,
                    68207,
                    68236,
                    68266,
                    68295,
                    68325,
                    68354,
                    68384,
                    68414,
                    68443,
                    68473,
                    68502,
                    68532,
                    68561,
                    68591,
                    68620,
                    68650,
                    68679,
                    68708,
                    68738,
                    68768,
                    68797,
                    68827,
                    68857,
                    68886,
                    68916,
                    68946,
                    68975,
                    69004,
                    69034,
                    69063,
                    69092,
                    69122,
                    69152,
                    69181,
                    69211,
                    69240,
                    69270,
                    69300,
                    69330,
                    69359,
                    69388,
                    69418,
                    69447,
                    69476,
                    69506,
                    69535,
                    69565,
                    69595,
                    69624,
                    69654,
                    69684,
                    69713,
                    69743,
                    69772,
                    69802,
                    69831,
                    69861,
                    69890,
                    69919,
                    69949,
                    69978,
                    70008,
                    70038,
                    70067,
                    70097,
                    70126,
                    70156,
                    70186,
                    70215,
                    70245,
                    70274,
                    70303,
                    70333,
                    70362,
                    70392,
                    70421,
                    70451,
                    70481,
                    70510,
                    70540,
                    70570,
                    70599,
                    70629,
                    70658,
                    70687,
                    70717,
                    70746,
                    70776,
                    70805,
                    70835,
                    70864,
                    70894,
                    70924,
                    70954,
                    70983,
                    71013,
                    71042,
                    71071,
                    71101,
                    71130,
                    71159,
                    71189,
                    71218,
                    71248,
                    71278,
                    71308,
                    71337,
                    71367,
                    71397,
                    71426,
                    71455,
                    71485,
                    71514,
                    71543,
                    71573,
                    71602,
                    71632,
                    71662,
                    71691,
                    71721,
                    71751,
                    71781,
                    71810,
                    71839,
                    71869,
                    71898,
                    71927,
                    71957,
                    71986,
                    72016,
                    72046,
                    72075,
                    72105,
                    72135,
                    72164,
                    72194,
                    72223,
                    72253,
                    72282,
                    72311,
                    72341,
                    72370,
                    72400,
                    72429,
                    72459,
                    72489,
                    72518,
                    72548,
                    72577,
                    72607,
                    72637,
                    72666,
                    72695,
                    72725,
                    72754,
                    72784,
                    72813,
                    72843,
                    72872,
                    72902,
                    72931,
                    72961,
                    72991,
                    73020,
                    73050,
                    73080,
                    73109,
                    73139,
                    73168,
                    73197,
                    73227,
                    73256,
                    73286,
                    73315,
                    73345,
                    73375,
                    73404,
                    73434,
                    73464,
                    73493,
                    73523,
                    73552,
                    73581,
                    73611,
                    73640,
                    73669,
                    73699,
                    73729,
                    73758,
                    73788,
                    73818,
                    73848,
                    73877,
                    73907,
                    73936,
                    73965,
                    73995,
                    74024,
                    74053,
                    74083,
                    74113,
                    74142,
                    74172,
                    74202,
                    74231,
                    74261,
                    74291,
                    74320,
                    74349,
                    74379,
                    74408,
                    74437,
                    74467,
                    74497,
                    74526,
                    74556,
                    74586,
                    74615,
                    74645,
                    74675,
                    74704,
                    74733,
                    74763,
                    74792,
                    74822,
                    74851,
                    74881,
                    74910,
                    74940,
                    74969,
                    74999,
                    75029,
                    75058,
                    75088,
                    75117,
                    75147,
                    75176,
                    75206,
                    75235,
                    75264,
                    75294,
                    75323,
                    75353,
                    75383,
                    75412,
                    75442,
                    75472,
                    75501,
                    75531,
                    75560,
                    75590,
                    75619,
                    75648,
                    75678,
                    75707,
                    75737,
                    75766,
                    75796,
                    75826,
                    75856,
                    75885,
                    75915,
                    75944,
                    75974,
                    76003,
                    76032,
                    76062,
                    76091,
                    76121,
                    76150,
                    76180,
                    76210,
                    76239,
                    76269,
                    76299,
                    76328,
                    76358,
                    76387,
                    76416,
                    76446,
                    76475,
                    76505,
                    76534,
                    76564,
                    76593,
                    76623,
                    76653,
                    76682,
                    76712,
                    76741,
                    76771,
                    76801,
                    76830,
                    76859,
                    76889,
                    76918,
                    76948,
                    76977,
                    77007,
                    77036,
                    77066,
                    77096,
                    77125,
                    77155,
                    77185,
                    77214,
                    77243,
                    77273,
                    77302,
                    77332,
                    77361,
                    77390,
                    77420,
                    77450,
                    77479,
                    77509,
                    77539,
                    77569,
                    77598,
                    77627,
                    77657,
                    77686,
                    77715,
                    77745,
                    77774,
                    77804,
                    77833,
                    77863,
                    77893,
                    77923,
                    77952,
                    77982,
                    78011,
                    78041,
                    78070,
                    78099,
                    78129,
                    78158,
                    78188,
                    78217,
                    78247,
                    78277,
                    78307,
                    78336,
                    78366,
                    78395,
                    78425,
                    78454,
                    78483,
                    78513,
                    78542,
                    78572,
                    78601,
                    78631,
                    78661,
                    78690,
                    78720,
                    78750,
                    78779,
                    78808,
                    78838,
                    78867,
                    78897,
                    78926,
                    78956,
                    78985,
                    79015,
                    79044,
                    79074,
                    79104,
                    79133,
                    79163,
                    79192,
                    79222,
                    79251,
                    79281,
                    79310,
                    79340,
                    79369,
                    79399,
                    79428,
                    79458,
                    79487,
                    79517,
                    79546,
                    79576,
                    79606,
                    79635,
                    79665,
                    79695,
                    79724,
                    79753,
                    79783,
                    79812,
                    79841,
                    79871,
                    79900,
                    79930,
                    79960,
                    79990
                ];
            },
            24453: function(t1, e1, r) {
                var n = r(27976);
                function i() {
                    this.regionalOptions = [], this.regionalOptions[""] = {
                        invalidCalendar: "Calendar {0} not found",
                        invalidDate: "Invalid {0} date",
                        invalidMonth: "Invalid {0} month",
                        invalidYear: "Invalid {0} year",
                        differentCalendars: "Cannot mix {0} and {1} dates"
                    }, this.local = this.regionalOptions[""], this.calendars = {}, this._localCals = {};
                }
                function a(t1, e1, r, n) {
                    if (this._calendar = t1, this._year = e1, this._month = r, this._day = n, 0 === this._calendar._validateLevel && !this._calendar.isValid(this._year, this._month, this._day)) throw (c.local.invalidDate || c.regionalOptions[""].invalidDate).replace(/\{0\}/, this._calendar.local.name);
                }
                function o(t1, e1) {
                    return "000000".substring(0, e1 - (t1 = "" + t1).length) + t1;
                }
                function s() {
                    this.shortYearCutoff = "+10";
                }
                function l(t1) {
                    this.local = this.regionalOptions[t1] || this.regionalOptions[""];
                }
                n(i.prototype, {
                    instance: function(t1, e1) {
                        t1 = (t1 || "gregorian").toLowerCase(), e1 = e1 || "";
                        var r = this._localCals[t1 + "-" + e1];
                        if (!r && this.calendars[t1] && (r = new this.calendars[t1](e1), this._localCals[t1 + "-" + e1] = r), !r) throw (this.local.invalidCalendar || this.regionalOptions[""].invalidCalendar).replace(/\{0\}/, t1);
                        return r;
                    },
                    newDate: function(t1, e1, r, n, i) {
                        return (n = (null != t1 && t1.year ? t1.calendar() : "string" == typeof n ? this.instance(n, i) : n) || this.instance()).newDate(t1, e1, r);
                    },
                    substituteDigits: function(t1) {
                        return function(e1) {
                            return (e1 + "").replace(/[0-9]/g, function(e1) {
                                return t1[e1];
                            });
                        };
                    },
                    substituteChineseDigits: function(t1, e1) {
                        return function(r) {
                            for(var n = "", i = 0; r > 0;){
                                var a = r % 10;
                                n = (0 === a ? "" : t1[a] + e1[i]) + n, i++, r = Math.floor(r / 10);
                            }
                            return 0 === n.indexOf(t1[1] + e1[1]) && (n = n.substr(1)), n || t1[0];
                        };
                    }
                }), n(a.prototype, {
                    newDate: function(t1, e1, r) {
                        return this._calendar.newDate(null == t1 ? this : t1, e1, r);
                    },
                    year: function(t1) {
                        return 0 === arguments.length ? this._year : this.set(t1, "y");
                    },
                    month: function(t1) {
                        return 0 === arguments.length ? this._month : this.set(t1, "m");
                    },
                    day: function(t1) {
                        return 0 === arguments.length ? this._day : this.set(t1, "d");
                    },
                    date: function(t1, e1, r) {
                        if (!this._calendar.isValid(t1, e1, r)) throw (c.local.invalidDate || c.regionalOptions[""].invalidDate).replace(/\{0\}/, this._calendar.local.name);
                        return this._year = t1, this._month = e1, this._day = r, this;
                    },
                    leapYear: function() {
                        return this._calendar.leapYear(this);
                    },
                    epoch: function() {
                        return this._calendar.epoch(this);
                    },
                    formatYear: function() {
                        return this._calendar.formatYear(this);
                    },
                    monthOfYear: function() {
                        return this._calendar.monthOfYear(this);
                    },
                    weekOfYear: function() {
                        return this._calendar.weekOfYear(this);
                    },
                    daysInYear: function() {
                        return this._calendar.daysInYear(this);
                    },
                    dayOfYear: function() {
                        return this._calendar.dayOfYear(this);
                    },
                    daysInMonth: function() {
                        return this._calendar.daysInMonth(this);
                    },
                    dayOfWeek: function() {
                        return this._calendar.dayOfWeek(this);
                    },
                    weekDay: function() {
                        return this._calendar.weekDay(this);
                    },
                    extraInfo: function() {
                        return this._calendar.extraInfo(this);
                    },
                    add: function(t1, e1) {
                        return this._calendar.add(this, t1, e1);
                    },
                    set: function(t1, e1) {
                        return this._calendar.set(this, t1, e1);
                    },
                    compareTo: function(t1) {
                        if (this._calendar.name !== t1._calendar.name) throw (c.local.differentCalendars || c.regionalOptions[""].differentCalendars).replace(/\{0\}/, this._calendar.local.name).replace(/\{1\}/, t1._calendar.local.name);
                        var e1 = this._year !== t1._year ? this._year - t1._year : this._month !== t1._month ? this.monthOfYear() - t1.monthOfYear() : this._day - t1._day;
                        return 0 === e1 ? 0 : e1 < 0 ? -1 : 1;
                    },
                    calendar: function() {
                        return this._calendar;
                    },
                    toJD: function() {
                        return this._calendar.toJD(this);
                    },
                    fromJD: function(t1) {
                        return this._calendar.fromJD(t1);
                    },
                    toJSDate: function() {
                        return this._calendar.toJSDate(this);
                    },
                    fromJSDate: function(t1) {
                        return this._calendar.fromJSDate(t1);
                    },
                    toString: function() {
                        return (this.year() < 0 ? "-" : "") + o(Math.abs(this.year()), 4) + "-" + o(this.month(), 2) + "-" + o(this.day(), 2);
                    }
                }), n(s.prototype, {
                    _validateLevel: 0,
                    newDate: function(t1, e1, r) {
                        return null == t1 ? this.today() : (t1.year && (this._validate(t1, e1, r, c.local.invalidDate || c.regionalOptions[""].invalidDate), r = t1.day(), e1 = t1.month(), t1 = t1.year()), new a(this, t1, e1, r));
                    },
                    today: function() {
                        return this.fromJSDate(new Date);
                    },
                    epoch: function(t1) {
                        return this._validate(t1, this.minMonth, this.minDay, c.local.invalidYear || c.regionalOptions[""].invalidYear).year() < 0 ? this.local.epochs[0] : this.local.epochs[1];
                    },
                    formatYear: function(t1) {
                        var e1 = this._validate(t1, this.minMonth, this.minDay, c.local.invalidYear || c.regionalOptions[""].invalidYear);
                        return (e1.year() < 0 ? "-" : "") + o(Math.abs(e1.year()), 4);
                    },
                    monthsInYear: function(t1) {
                        return this._validate(t1, this.minMonth, this.minDay, c.local.invalidYear || c.regionalOptions[""].invalidYear), 12;
                    },
                    monthOfYear: function(t1, e1) {
                        var r = this._validate(t1, e1, this.minDay, c.local.invalidMonth || c.regionalOptions[""].invalidMonth);
                        return (r.month() + this.monthsInYear(r) - this.firstMonth) % this.monthsInYear(r) + this.minMonth;
                    },
                    fromMonthOfYear: function(t1, e1) {
                        var r = (e1 + this.firstMonth - 2 * this.minMonth) % this.monthsInYear(t1) + this.minMonth;
                        return this._validate(t1, r, this.minDay, c.local.invalidMonth || c.regionalOptions[""].invalidMonth), r;
                    },
                    daysInYear: function(t1) {
                        var e1 = this._validate(t1, this.minMonth, this.minDay, c.local.invalidYear || c.regionalOptions[""].invalidYear);
                        return this.leapYear(e1) ? 366 : 365;
                    },
                    dayOfYear: function(t1, e1, r) {
                        var n = this._validate(t1, e1, r, c.local.invalidDate || c.regionalOptions[""].invalidDate);
                        return n.toJD() - this.newDate(n.year(), this.fromMonthOfYear(n.year(), this.minMonth), this.minDay).toJD() + 1;
                    },
                    daysInWeek: function() {
                        return 7;
                    },
                    dayOfWeek: function(t1, e1, r) {
                        var n = this._validate(t1, e1, r, c.local.invalidDate || c.regionalOptions[""].invalidDate);
                        return (Math.floor(this.toJD(n)) + 2) % this.daysInWeek();
                    },
                    extraInfo: function(t1, e1, r) {
                        return this._validate(t1, e1, r, c.local.invalidDate || c.regionalOptions[""].invalidDate), {};
                    },
                    add: function(t1, e1, r) {
                        return this._validate(t1, this.minMonth, this.minDay, c.local.invalidDate || c.regionalOptions[""].invalidDate), this._correctAdd(t1, this._add(t1, e1, r), e1, r);
                    },
                    _add: function(t1, e1, r) {
                        if (this._validateLevel++, "d" === r || "w" === r) {
                            var n = t1.toJD() + e1 * ("w" === r ? this.daysInWeek() : 1), i = t1.calendar().fromJD(n);
                            return this._validateLevel--, [
                                i.year(),
                                i.month(),
                                i.day()
                            ];
                        }
                        try {
                            var a = t1.year() + ("y" === r ? e1 : 0), o = t1.monthOfYear() + ("m" === r ? e1 : 0);
                            i = t1.day(), "y" === r ? (t1.month() !== this.fromMonthOfYear(a, o) && (o = this.newDate(a, t1.month(), this.minDay).monthOfYear()), o = Math.min(o, this.monthsInYear(a)), i = Math.min(i, this.daysInMonth(a, this.fromMonthOfYear(a, o)))) : "m" === r && (function(t1) {
                                for(; o < t1.minMonth;)a--, o += t1.monthsInYear(a);
                                for(var e1 = t1.monthsInYear(a); o > e1 - 1 + t1.minMonth;)a++, o -= e1, e1 = t1.monthsInYear(a);
                            }(this), i = Math.min(i, this.daysInMonth(a, this.fromMonthOfYear(a, o))));
                            var s = [
                                a,
                                this.fromMonthOfYear(a, o),
                                i
                            ];
                            return this._validateLevel--, s;
                        } catch (t1) {
                            throw this._validateLevel--, t1;
                        }
                    },
                    _correctAdd: function(t1, e1, r, n) {
                        if (!(this.hasYearZero || "y" !== n && "m" !== n || 0 !== e1[0] && t1.year() > 0 == e1[0] > 0)) {
                            var i = {
                                y: [
                                    1,
                                    1,
                                    "y"
                                ],
                                m: [
                                    1,
                                    this.monthsInYear(-1),
                                    "m"
                                ],
                                w: [
                                    this.daysInWeek(),
                                    this.daysInYear(-1),
                                    "d"
                                ],
                                d: [
                                    1,
                                    this.daysInYear(-1),
                                    "d"
                                ]
                            }[n], a = r < 0 ? -1 : 1;
                            e1 = this._add(t1, r * i[0] + a * i[1], i[2]);
                        }
                        return t1.date(e1[0], e1[1], e1[2]);
                    },
                    set: function(t1, e1, r) {
                        this._validate(t1, this.minMonth, this.minDay, c.local.invalidDate || c.regionalOptions[""].invalidDate);
                        var n = "y" === r ? e1 : t1.year(), i = "m" === r ? e1 : t1.month(), a = "d" === r ? e1 : t1.day();
                        return "y" !== r && "m" !== r || (a = Math.min(a, this.daysInMonth(n, i))), t1.date(n, i, a);
                    },
                    isValid: function(t1, e1, r) {
                        this._validateLevel++;
                        var n = this.hasYearZero || 0 !== t1;
                        if (n) {
                            var i = this.newDate(t1, e1, this.minDay);
                            n = e1 >= this.minMonth && e1 - this.minMonth < this.monthsInYear(i) && r >= this.minDay && r - this.minDay < this.daysInMonth(i);
                        }
                        return this._validateLevel--, n;
                    },
                    toJSDate: function(t1, e1, r) {
                        var n = this._validate(t1, e1, r, c.local.invalidDate || c.regionalOptions[""].invalidDate);
                        return c.instance().fromJD(this.toJD(n)).toJSDate();
                    },
                    fromJSDate: function(t1) {
                        return this.fromJD(c.instance().fromJSDate(t1).toJD());
                    },
                    _validate: function(t1, e1, r, n) {
                        if (t1.year) {
                            if (0 === this._validateLevel && this.name !== t1.calendar().name) throw (c.local.differentCalendars || c.regionalOptions[""].differentCalendars).replace(/\{0\}/, this.local.name).replace(/\{1\}/, t1.calendar().local.name);
                            return t1;
                        }
                        try {
                            if (this._validateLevel++, 1 === this._validateLevel && !this.isValid(t1, e1, r)) throw n.replace(/\{0\}/, this.local.name);
                            var i = this.newDate(t1, e1, r);
                            return this._validateLevel--, i;
                        } catch (t1) {
                            throw this._validateLevel--, t1;
                        }
                    }
                }), l.prototype = new s, n(l.prototype, {
                    name: "Gregorian",
                    jdEpoch: 1721425.5,
                    daysPerMonth: [
                        31,
                        28,
                        31,
                        30,
                        31,
                        30,
                        31,
                        31,
                        30,
                        31,
                        30,
                        31
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Gregorian",
                            epochs: [
                                "BCE",
                                "CE"
                            ],
                            monthNames: [
                                "January",
                                "February",
                                "March",
                                "April",
                                "May",
                                "June",
                                "July",
                                "August",
                                "September",
                                "October",
                                "November",
                                "December"
                            ],
                            monthNamesShort: [
                                "Jan",
                                "Feb",
                                "Mar",
                                "Apr",
                                "May",
                                "Jun",
                                "Jul",
                                "Aug",
                                "Sep",
                                "Oct",
                                "Nov",
                                "Dec"
                            ],
                            dayNames: [
                                "Sunday",
                                "Monday",
                                "Tuesday",
                                "Wednesday",
                                "Thursday",
                                "Friday",
                                "Saturday"
                            ],
                            dayNamesShort: [
                                "Sun",
                                "Mon",
                                "Tue",
                                "Wed",
                                "Thu",
                                "Fri",
                                "Sat"
                            ],
                            dayNamesMin: [
                                "Su",
                                "Mo",
                                "Tu",
                                "We",
                                "Th",
                                "Fr",
                                "Sa"
                            ],
                            digits: null,
                            dateFormat: "mm/dd/yyyy",
                            firstDay: 0,
                            isRTL: !1
                        }
                    },
                    leapYear: function(t1) {
                        var e1 = this._validate(t1, this.minMonth, this.minDay, c.local.invalidYear || c.regionalOptions[""].invalidYear);
                        return (t1 = e1.year() + (e1.year() < 0 ? 1 : 0)) % 4 == 0 && (t1 % 100 != 0 || t1 % 400 == 0);
                    },
                    weekOfYear: function(t1, e1, r) {
                        var n = this.newDate(t1, e1, r);
                        return n.add(4 - (n.dayOfWeek() || 7), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                    },
                    daysInMonth: function(t1, e1) {
                        var r = this._validate(t1, e1, this.minDay, c.local.invalidMonth || c.regionalOptions[""].invalidMonth);
                        return this.daysPerMonth[r.month() - 1] + (2 === r.month() && this.leapYear(r.year()) ? 1 : 0);
                    },
                    weekDay: function(t1, e1, r) {
                        return (this.dayOfWeek(t1, e1, r) || 7) < 6;
                    },
                    toJD: function(t1, e1, r) {
                        var n = this._validate(t1, e1, r, c.local.invalidDate || c.regionalOptions[""].invalidDate);
                        t1 = n.year(), e1 = n.month(), r = n.day(), t1 < 0 && t1++, e1 < 3 && (e1 += 12, t1--);
                        var i = Math.floor(t1 / 100), a = 2 - i + Math.floor(i / 4);
                        return Math.floor(365.25 * (t1 + 4716)) + Math.floor(30.6001 * (e1 + 1)) + r + a - 1524.5;
                    },
                    fromJD: function(t1) {
                        var e1 = Math.floor(t1 + .5), r = Math.floor((e1 - 1867216.25) / 36524.25), n = 1524 + (r = e1 + 1 + r - Math.floor(r / 4)), i = Math.floor((n - 122.1) / 365.25), a = Math.floor(365.25 * i), o = Math.floor((n - a) / 30.6001), s = n - a - Math.floor(30.6001 * o), l = o - (o > 13.5 ? 13 : 1), c = i - (l > 2.5 ? 4716 : 4715);
                        return c <= 0 && c--, this.newDate(c, l, s);
                    },
                    toJSDate: function(t1, e1, r) {
                        var n = this._validate(t1, e1, r, c.local.invalidDate || c.regionalOptions[""].invalidDate), i = new Date(n.year(), n.month() - 1, n.day());
                        return i.setHours(0), i.setMinutes(0), i.setSeconds(0), i.setMilliseconds(0), i.setHours(i.getHours() > 12 ? i.getHours() + 2 : 0), i;
                    },
                    fromJSDate: function(t1) {
                        return this.newDate(t1.getFullYear(), t1.getMonth() + 1, t1.getDate());
                    }
                });
                var c = t1.exports = new i;
                c.cdate = a, c.baseCalendar = s, c.calendars.gregorian = l;
            },
            23428: function(t1, e1, r) {
                var n = r(27976), i = r(24453);
                n(i.regionalOptions[""], {
                    invalidArguments: "Invalid arguments",
                    invalidFormat: "Cannot format a date from another calendar",
                    missingNumberAt: "Missing number at position {0}",
                    unknownNameAt: "Unknown name at position {0}",
                    unexpectedLiteralAt: "Unexpected literal at position {0}",
                    unexpectedText: "Additional text found at end"
                }), i.local = i.regionalOptions[""], n(i.cdate.prototype, {
                    formatDate: function(t1, e1) {
                        return "string" != typeof t1 && (e1 = t1, t1 = ""), this._calendar.formatDate(t1 || "", this, e1);
                    }
                }), n(i.baseCalendar.prototype, {
                    UNIX_EPOCH: i.instance().newDate(1970, 1, 1).toJD(),
                    SECS_PER_DAY: 86400,
                    TICKS_EPOCH: i.instance().jdEpoch,
                    TICKS_PER_DAY: 864e9,
                    ATOM: "yyyy-mm-dd",
                    COOKIE: "D, dd M yyyy",
                    FULL: "DD, MM d, yyyy",
                    ISO_8601: "yyyy-mm-dd",
                    JULIAN: "J",
                    RFC_822: "D, d M yy",
                    RFC_850: "DD, dd-M-yy",
                    RFC_1036: "D, d M yy",
                    RFC_1123: "D, d M yyyy",
                    RFC_2822: "D, d M yyyy",
                    RSS: "D, d M yy",
                    TICKS: "!",
                    TIMESTAMP: "@",
                    W3C: "yyyy-mm-dd",
                    formatDate: function(t1, e1, r) {
                        if ("string" != typeof t1 && (r = e1, e1 = t1, t1 = ""), !e1) return "";
                        if (e1.calendar() !== this) throw i.local.invalidFormat || i.regionalOptions[""].invalidFormat;
                        t1 = t1 || this.local.dateFormat;
                        for(var n, a, o, s = (r = r || {}).dayNamesShort || this.local.dayNamesShort, l = r.dayNames || this.local.dayNames, c = r.monthNumbers || this.local.monthNumbers, u = r.monthNamesShort || this.local.monthNamesShort, h = r.monthNames || this.local.monthNames, f = (r.calculateWeek || this.local.calculateWeek, function(e1, r) {
                            for(var n = 1; b + n < t1.length && t1.charAt(b + n) === e1;)n++;
                            return b += n - 1, Math.floor(n / (r || 1)) > 1;
                        }), p = function(t1, e1, r, n) {
                            var i = "" + e1;
                            if (f(t1, n)) for(; i.length < r;)i = "0" + i;
                            return i;
                        }, d = this, m = function(t1) {
                            return "function" == typeof c ? c.call(d, t1, f("m")) : v(p("m", t1.month(), 2));
                        }, g = function(t1, e1) {
                            return e1 ? "function" == typeof h ? h.call(d, t1) : h[t1.month() - d.minMonth] : "function" == typeof u ? u.call(d, t1) : u[t1.month() - d.minMonth];
                        }, y = this.local.digits, v = function(t1) {
                            return r.localNumbers && y ? y(t1) : t1;
                        }, x = "", _ = !1, b = 0; b < t1.length; b++)if (_) "'" !== t1.charAt(b) || f("'") ? x += t1.charAt(b) : _ = !1;
                        else switch(t1.charAt(b)){
                            case "d":
                                x += v(p("d", e1.day(), 2));
                                break;
                            case "D":
                                x += (n = e1.dayOfWeek(), a = s, o = l, f("D") ? o[n] : a[n]);
                                break;
                            case "o":
                                x += p("o", e1.dayOfYear(), 3);
                                break;
                            case "w":
                                x += p("w", e1.weekOfYear(), 2);
                                break;
                            case "m":
                                x += m(e1);
                                break;
                            case "M":
                                x += g(e1, f("M"));
                                break;
                            case "y":
                                x += f("y", 2) ? e1.year() : (e1.year() % 100 < 10 ? "0" : "") + e1.year() % 100;
                                break;
                            case "Y":
                                f("Y", 2), x += e1.formatYear();
                                break;
                            case "J":
                                x += e1.toJD();
                                break;
                            case "@":
                                x += (e1.toJD() - this.UNIX_EPOCH) * this.SECS_PER_DAY;
                                break;
                            case "!":
                                x += (e1.toJD() - this.TICKS_EPOCH) * this.TICKS_PER_DAY;
                                break;
                            case "'":
                                f("'") ? x += "'" : _ = !0;
                                break;
                            default:
                                x += t1.charAt(b);
                        }
                        return x;
                    },
                    parseDate: function(t1, e1, r) {
                        if (null == e1) throw i.local.invalidArguments || i.regionalOptions[""].invalidArguments;
                        if ("" === (e1 = "object" == typeof e1 ? e1.toString() : e1 + "")) return null;
                        t1 = t1 || this.local.dateFormat;
                        var n = (r = r || {}).shortYearCutoff || this.shortYearCutoff;
                        n = "string" != typeof n ? n : this.today().year() % 100 + parseInt(n, 10);
                        for(var a = r.dayNamesShort || this.local.dayNamesShort, o = r.dayNames || this.local.dayNames, s = r.parseMonth || this.local.parseMonth, l = r.monthNumbers || this.local.monthNumbers, c = r.monthNamesShort || this.local.monthNamesShort, u = r.monthNames || this.local.monthNames, h = -1, f = -1, p = -1, d = -1, m = -1, g = !1, y = !1, v = function(e1, r) {
                            for(var n = 1; M + n < t1.length && t1.charAt(M + n) === e1;)n++;
                            return M += n - 1, Math.floor(n / (r || 1)) > 1;
                        }, x = function(t1, r) {
                            var n = v(t1, r), a = [
                                2,
                                3,
                                n ? 4 : 2,
                                n ? 4 : 2,
                                10,
                                11,
                                20
                            ]["oyYJ@!".indexOf(t1) + 1], o = new RegExp("^-?\\d{1," + a + "}"), s = e1.substring(A).match(o);
                            if (!s) throw (i.local.missingNumberAt || i.regionalOptions[""].missingNumberAt).replace(/\{0\}/, A);
                            return A += s[0].length, parseInt(s[0], 10);
                        }, _ = this, b = function() {
                            if ("function" == typeof l) {
                                v("m");
                                var t1 = l.call(_, e1.substring(A));
                                return A += t1.length, t1;
                            }
                            return x("m");
                        }, w = function(t1, r, n, a) {
                            for(var o = v(t1, a) ? n : r, s = 0; s < o.length; s++)if (e1.substr(A, o[s].length).toLowerCase() === o[s].toLowerCase()) return A += o[s].length, s + _.minMonth;
                            throw (i.local.unknownNameAt || i.regionalOptions[""].unknownNameAt).replace(/\{0\}/, A);
                        }, T = function() {
                            if ("function" == typeof u) {
                                var t1 = v("M") ? u.call(_, e1.substring(A)) : c.call(_, e1.substring(A));
                                return A += t1.length, t1;
                            }
                            return w("M", c, u);
                        }, k = function() {
                            if (e1.charAt(A) !== t1.charAt(M)) throw (i.local.unexpectedLiteralAt || i.regionalOptions[""].unexpectedLiteralAt).replace(/\{0\}/, A);
                            A++;
                        }, A = 0, M = 0; M < t1.length; M++)if (y) "'" !== t1.charAt(M) || v("'") ? k() : y = !1;
                        else switch(t1.charAt(M)){
                            case "d":
                                d = x("d");
                                break;
                            case "D":
                                w("D", a, o);
                                break;
                            case "o":
                                m = x("o");
                                break;
                            case "w":
                                x("w");
                                break;
                            case "m":
                                p = b();
                                break;
                            case "M":
                                p = T();
                                break;
                            case "y":
                                var S = M;
                                g = !v("y", 2), M = S, f = x("y", 2);
                                break;
                            case "Y":
                                f = x("Y", 2);
                                break;
                            case "J":
                                h = x("J") + .5, "." === e1.charAt(A) && (A++, x("J"));
                                break;
                            case "@":
                                h = x("@") / this.SECS_PER_DAY + this.UNIX_EPOCH;
                                break;
                            case "!":
                                h = x("!") / this.TICKS_PER_DAY + this.TICKS_EPOCH;
                                break;
                            case "*":
                                A = e1.length;
                                break;
                            case "'":
                                v("'") ? k() : y = !0;
                                break;
                            default:
                                k();
                        }
                        if (A < e1.length) throw i.local.unexpectedText || i.regionalOptions[""].unexpectedText;
                        if (-1 === f ? f = this.today().year() : f < 100 && g && (f += -1 === n ? 1900 : this.today().year() - this.today().year() % 100 - (f <= n ? 0 : 100)), "string" == typeof p && (p = s.call(this, f, p)), m > -1) {
                            p = 1, d = m;
                            for(var E = this.daysInMonth(f, p); d > E; E = this.daysInMonth(f, p))p++, d -= E;
                        }
                        return h > -1 ? this.fromJD(h) : this.newDate(f, p, d);
                    },
                    determineDate: function(t1, e1, r, n, i) {
                        r && "object" != typeof r && (i = n, n = r, r = null), "string" != typeof n && (i = n, n = "");
                        var a = this;
                        return e1 = e1 ? e1.newDate() : null, null == t1 ? e1 : "string" == typeof t1 ? function(t1) {
                            try {
                                return a.parseDate(n, t1, i);
                            } catch (t1) {}
                            for(var e1 = ((t1 = t1.toLowerCase()).match(/^c/) && r ? r.newDate() : null) || a.today(), o = /([+-]?[0-9]+)\s*(d|w|m|y)?/g, s = o.exec(t1); s;)e1.add(parseInt(s[1], 10), s[2] || "d"), s = o.exec(t1);
                            return e1;
                        }(t1) : "number" == typeof t1 ? isNaN(t1) || t1 === 1 / 0 || t1 === -1 / 0 ? e1 : a.today().add(t1, "d") : a.newDate(t1);
                    }
                });
            },
            96144: function(t1, e1, r) {
                "use strict";
                r.r(e1);
                var n = r(85072), i = r.n(n), a = r(97825), o = r.n(a), s = r(77659), l = r.n(s), c = r(55056), u = r.n(c), h = r(10540), f = r.n(h), p = r(41113), d = r.n(p), m = r(5955), g = {};
                g.styleTagTransform = d(), g.setAttributes = u(), g.insert = l().bind(null, "head"), g.domAPI = o(), g.insertStyleElement = f(), i()(m.A, g), e1.default = m.A && m.A.locals ? m.A.locals : void 0;
            },
            85072: function(t1) {
                "use strict";
                var e1 = [];
                function r(t1) {
                    for(var r = -1, n = 0; n < e1.length; n++)if (e1[n].identifier === t1) {
                        r = n;
                        break;
                    }
                    return r;
                }
                function n(t1, n) {
                    for(var a = {}, o = [], s = 0; s < t1.length; s++){
                        var l = t1[s], c = n.base ? l[0] + n.base : l[0], u = a[c] || 0, h = "".concat(c, " ").concat(u);
                        a[c] = u + 1;
                        var f = r(h), p = {
                            css: l[1],
                            media: l[2],
                            sourceMap: l[3],
                            supports: l[4],
                            layer: l[5]
                        };
                        if (-1 !== f) e1[f].references++, e1[f].updater(p);
                        else {
                            var d = i(p, n);
                            n.byIndex = s, e1.splice(s, 0, {
                                identifier: h,
                                updater: d,
                                references: 1
                            });
                        }
                        o.push(h);
                    }
                    return o;
                }
                function i(t1, e1) {
                    var r = e1.domAPI(e1);
                    return r.update(t1), function(e1) {
                        if (e1) {
                            if (e1.css === t1.css && e1.media === t1.media && e1.sourceMap === t1.sourceMap && e1.supports === t1.supports && e1.layer === t1.layer) return;
                            r.update(t1 = e1);
                        } else r.remove();
                    };
                }
                t1.exports = function(t1, i) {
                    var a = n(t1 = t1 || [], i = i || {});
                    return function(t1) {
                        t1 = t1 || [];
                        for(var o = 0; o < a.length; o++){
                            var s = r(a[o]);
                            e1[s].references--;
                        }
                        for(var l = n(t1, i), c = 0; c < a.length; c++){
                            var u = r(a[c]);
                            0 === e1[u].references && (e1[u].updater(), e1.splice(u, 1));
                        }
                        a = l;
                    };
                };
            },
            77659: function(t1) {
                "use strict";
                var e1 = {};
                t1.exports = function(t1, r) {
                    var n = function(t1) {
                        if (void 0 === e1[t1]) {
                            var r = document.querySelector(t1);
                            if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
                                r = r.contentDocument.head;
                            } catch (t1) {
                                r = null;
                            }
                            e1[t1] = r;
                        }
                        return e1[t1];
                    }(t1);
                    if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
                    n.appendChild(r);
                };
            },
            10540: function(t1) {
                "use strict";
                t1.exports = function(t1) {
                    var e1 = document.createElement("style");
                    return t1.setAttributes(e1, t1.attributes), t1.insert(e1, t1.options), e1;
                };
            },
            55056: function(t1, e1, r) {
                "use strict";
                t1.exports = function(t1) {
                    var e1 = r.nc;
                    e1 && t1.setAttribute("nonce", e1);
                };
            },
            97825: function(t1) {
                "use strict";
                t1.exports = function(t1) {
                    if ("undefined" == typeof document) return {
                        update: function() {},
                        remove: function() {}
                    };
                    var e1 = t1.insertStyleElement(t1);
                    return {
                        update: function(r) {
                            !function(t1, e1, r) {
                                var n = "";
                                r.supports && (n += "@supports (".concat(r.supports, ") {")), r.media && (n += "@media ".concat(r.media, " {"));
                                var i = void 0 !== r.layer;
                                i && (n += "@layer".concat(r.layer.length > 0 ? " ".concat(r.layer) : "", " {")), n += r.css, i && (n += "}"), r.media && (n += "}"), r.supports && (n += "}");
                                var a = r.sourceMap;
                                a && "undefined" != typeof btoa && (n += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(a)))), " */")), e1.styleTagTransform(n, t1, e1.options);
                            }(e1, t1, r);
                        },
                        remove: function() {
                            !function(t1) {
                                if (null === t1.parentNode) return !1;
                                t1.parentNode.removeChild(t1);
                            }(e1);
                        }
                    };
                };
            },
            41113: function(t1) {
                "use strict";
                t1.exports = function(t1, e1) {
                    if (e1.styleSheet) e1.styleSheet.cssText = t1;
                    else {
                        for(; e1.firstChild;)e1.removeChild(e1.firstChild);
                        e1.appendChild(document.createTextNode(t1));
                    }
                };
            },
            25446: function(t1) {
                "use strict";
                t1.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2722%27 height=%2722%27 fill=%27%23333%27 viewBox=%270 0 22 22%27%3E%3Cpath d=%27m1.754 13.406 4.453-4.851 3.09 3.09 3.281 3.277.969-.969-3.309-3.312 3.844-4.121 6.148 6.886h1.082v-.855l-7.207-8.07-4.84 5.187L6.169 6.57l-5.48 5.965v.871ZM.688 16.844h20.625v1.375H.688Zm0 0%27/%3E%3C/svg%3E";
            },
            56694: function(t1) {
                "use strict";
                t1.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2722%27 height=%2722%27 fill=%27%2333b5e5%27 viewBox=%270 0 22 22%27%3E%3Cpath d=%27m1.754 13.406 4.453-4.851 3.09 3.09 3.281 3.277.969-.969-3.309-3.312 3.844-4.121 6.148 6.886h1.082v-.855l-7.207-8.07-4.84 5.187L6.169 6.57l-5.48 5.965v.871ZM.688 16.844h20.625v1.375H.688Zm0 0%27/%3E%3C/svg%3E";
            },
            26117: function(t1) {
                "use strict";
                t1.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 fill-rule=%27evenodd%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M4 10a6 6 0 1 0 12 0 6 6 0 1 0-12 0m5-3a1 1 0 1 0 2 0 1 1 0 1 0-2 0m0 3a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0%27/%3E%3C/svg%3E";
            },
            66311: function(t1) {
                "use strict";
                t1.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 fill=%27%23fff%27 fill-rule=%27evenodd%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M4 10a6 6 0 1 0 12 0 6 6 0 1 0-12 0m5-3a1 1 0 1 0 2 0 1 1 0 1 0-2 0m0 3a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0%27/%3E%3C/svg%3E";
            },
            24420: function(t1) {
                "use strict";
                t1.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23333%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7%27/%3E%3Ccircle cx=%2710%27 cy=%2710%27 r=%272%27/%3E%3C/svg%3E";
            },
            77035: function(t1) {
                "use strict";
                t1.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23333%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M10 13c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h9c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13z%27/%3E%3C/svg%3E";
            },
            43470: function(t1) {
                "use strict";
                t1.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23333%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M14.5 8.5c-.75 0-1.5.75-1.5 1.5v3h-3c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h3v3c0 .75.75 1.5 1.5 1.5S16 19.75 16 19v-3h3c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13h-3v-3c0-.75-.75-1.5-1.5-1.5%27/%3E%3C/svg%3E";
            },
            13490: function(t1) {
                "use strict";
                t1.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23333%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M24 16v5.5c0 1.75-.75 2.5-2.5 2.5H16v-1l3-1.5-4-5.5 1-1 5.5 4 1.5-3zM6 16l1.5 3 5.5-4 1 1-4 5.5 3 1.5v1H7.5C5.75 24 5 23.25 5 21.5V16zm7-11v1l-3 1.5 4 5.5-1 1-5.5-4L6 13H5V7.5C5 5.75 5.75 5 7.5 5zm11 2.5c0-1.75-.75-2.5-2.5-2.5H16v1l3 1.5-4 5.5 1 1 5.5-4 1.5 3h1z%27/%3E%3C/svg%3E";
            },
            80216: function(t1) {
                "use strict";
                t1.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23333%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27m10.5 14 4-8 4 8z%27/%3E%3Cpath fill=%27%23ccc%27 d=%27m10.5 16 4 8 4-8z%27/%3E%3C/svg%3E";
            },
            47695: function(t1) {
                "use strict";
                t1.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%2333b5e5%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7%27/%3E%3C/svg%3E";
            },
            92228: function(t1) {
                "use strict";
                t1.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%2333b5e5%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7%27/%3E%3Ccircle cx=%2710%27 cy=%2710%27 r=%272%27/%3E%3C/svg%3E";
            },
            43737: function(t1) {
                "use strict";
                t1.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23666%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7%27/%3E%3Ccircle cx=%2710%27 cy=%2710%27 r=%272%27/%3E%3Cpath fill=%27red%27 d=%27m14 5 1 1-9 9-1-1z%27/%3E%3C/svg%3E";
            },
            48460: function(t1) {
                "use strict";
                t1.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23999%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7%27/%3E%3Ccircle cx=%2710%27 cy=%2710%27 r=%272%27/%3E%3Cpath fill=%27red%27 d=%27m14 5 1 1-9 9-1-1z%27/%3E%3C/svg%3E";
            },
            75796: function(t1) {
                "use strict";
                t1.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23aaa%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7%27/%3E%3Ccircle cx=%2710%27 cy=%2710%27 r=%272%27/%3E%3Cpath fill=%27red%27 d=%27m14 5 1 1-9 9-1-1z%27/%3E%3C/svg%3E";
            },
            28869: function(t1) {
                "use strict";
                t1.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23e54e33%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7%27/%3E%3C/svg%3E";
            },
            9819: function(t1) {
                "use strict";
                t1.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23e58978%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7%27/%3E%3Ccircle cx=%2710%27 cy=%2710%27 r=%272%27/%3E%3C/svg%3E";
            },
            30557: function(t1) {
                "use strict";
                t1.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23fff%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7%27/%3E%3Ccircle cx=%2710%27 cy=%2710%27 r=%272%27/%3E%3C/svg%3E";
            },
            68164: function(t1) {
                "use strict";
                t1.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23fff%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M10 13c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h9c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13z%27/%3E%3C/svg%3E";
            },
            64665: function(t1) {
                "use strict";
                t1.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23fff%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M14.5 8.5c-.75 0-1.5.75-1.5 1.5v3h-3c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h3v3c0 .75.75 1.5 1.5 1.5S16 19.75 16 19v-3h3c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13h-3v-3c0-.75-.75-1.5-1.5-1.5%27/%3E%3C/svg%3E";
            },
            91413: function(t1) {
                "use strict";
                t1.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23fff%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M18.5 16c-1.75 0-2.5.75-2.5 2.5V24h1l1.5-3 5.5 4 1-1-4-5.5 3-1.5v-1zM13 18.5c0-1.75-.75-2.5-2.5-2.5H5v1l3 1.5L4 24l1 1 5.5-4 1.5 3h1zm3-8c0 1.75.75 2.5 2.5 2.5H24v-1l-3-1.5L25 5l-1-1-5.5 4L17 5h-1zM10.5 13c1.75 0 2.5-.75 2.5-2.5V5h-1l-1.5 3L5 4 4 5l4 5.5L5 12v1z%27/%3E%3C/svg%3E";
            },
            13913: function(t1) {
                "use strict";
                t1.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23fff%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M24 16v5.5c0 1.75-.75 2.5-2.5 2.5H16v-1l3-1.5-4-5.5 1-1 5.5 4 1.5-3zM6 16l1.5 3 5.5-4 1 1-4 5.5 3 1.5v1H7.5C5.75 24 5 23.25 5 21.5V16zm7-11v1l-3 1.5 4 5.5-1 1-5.5-4L6 13H5V7.5C5 5.75 5.75 5 7.5 5zm11 2.5c0-1.75-.75-2.5-2.5-2.5H16v1l3 1.5-4 5.5 1 1 5.5-4 1.5 3h1z%27/%3E%3C/svg%3E";
            },
            61907: function(t1) {
                "use strict";
                t1.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 fill=%27%23fff%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27m10.5 14 4-8 4 8z%27/%3E%3Cpath fill=%27%23ccc%27 d=%27m10.5 16 4 8 4-8z%27/%3E%3C/svg%3E";
            },
            56539: function(t1) {
                "use strict";
                t1.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 viewBox=%270 0 20 20%27%3E%3Cpath d=%27M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7%27/%3E%3Ccircle cx=%2710%27 cy=%2710%27 r=%272%27/%3E%3C/svg%3E";
            },
            4890: function(t1) {
                "use strict";
                t1.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M10 13c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h9c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13z%27/%3E%3C/svg%3E";
            },
            13363: function(t1) {
                "use strict";
                t1.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M14.5 8.5c-.75 0-1.5.75-1.5 1.5v3h-3c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h3v3c0 .75.75 1.5 1.5 1.5S16 19.75 16 19v-3h3c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13h-3v-3c0-.75-.75-1.5-1.5-1.5%27/%3E%3C/svg%3E";
            },
            47603: function(t1) {
                "use strict";
                t1.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M18.5 16c-1.75 0-2.5.75-2.5 2.5V24h1l1.5-3 5.5 4 1-1-4-5.5 3-1.5v-1zM13 18.5c0-1.75-.75-2.5-2.5-2.5H5v1l3 1.5L4 24l1 1 5.5-4 1.5 3h1zm3-8c0 1.75.75 2.5 2.5 2.5H24v-1l-3-1.5L25 5l-1-1-5.5 4L17 5h-1zM10.5 13c1.75 0 2.5-.75 2.5-2.5V5h-1l-1.5 3L5 4 4 5l4 5.5L5 12v1z%27/%3E%3C/svg%3E";
            },
            64643: function(t1) {
                "use strict";
                t1.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27M24 16v5.5c0 1.75-.75 2.5-2.5 2.5H16v-1l3-1.5-4-5.5 1-1 5.5 4 1.5-3zM6 16l1.5 3 5.5-4 1 1-4 5.5 3 1.5v1H7.5C5.75 24 5 23.25 5 21.5V16zm7-11v1l-3 1.5 4 5.5-1 1-5.5-4L6 13H5V7.5C5 5.75 5.75 5 7.5 5zm11 2.5c0-1.75-.75-2.5-2.5-2.5H16v1l3 1.5-4 5.5 1 1 5.5-4 1.5 3h1z%27/%3E%3C/svg%3E";
            },
            68605: function(t1) {
                "use strict";
                t1.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2729%27 height=%2729%27 viewBox=%270 0 29 29%27%3E%3Cpath d=%27m10.5 14 4-8 4 8z%27/%3E%3Cpath fill=%27%23ccc%27 d=%27m10.5 16 4 8 4-8z%27/%3E%3C/svg%3E";
            },
            47914: function(t1) {
                "use strict";
                t1.exports = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2788%27 height=%2723%27 fill=%27none%27%3E%3Cpath fill=%27%23000%27 fill-opacity=%27.4%27 fill-rule=%27evenodd%27 d=%27M17.408 16.796h-1.827l2.501-12.095h.198l3.324 6.533.988 2.19.988-2.19 3.258-6.533h.181l2.6 12.095h-1.81l-1.218-5.644-.362-1.71-.658 1.71-2.929 5.644h-.098l-2.914-5.644-.757-1.71-.345 1.71zm1.958-3.42-.726 3.663a1.255 1.255 0 0 1-1.232 1.011h-1.827a1.255 1.255 0 0 1-1.229-1.509l2.501-12.095a1.255 1.255 0 0 1 1.23-1.001h.197a1.25 1.25 0 0 1 1.12.685l3.19 6.273 3.125-6.263a1.25 1.25 0 0 1 1.123-.695h.181a1.255 1.255 0 0 1 1.227.991l1.443 6.71a5 5 0 0 1 .314-.787l.009-.016a4.6 4.6 0 0 1 1.777-1.887c.782-.46 1.668-.667 2.611-.667a4.6 4.6 0 0 1 1.7.32l.306.134c.21-.16.474-.256.759-.256h1.694a1.255 1.255 0 0 1 1.212.925 1.255 1.255 0 0 1 1.212-.925h1.711c.284 0 .545.094.755.252.613-.3 1.312-.45 2.075-.45 1.356 0 2.557.445 3.482 1.4q.47.48.763 1.064V4.701a1.255 1.255 0 0 1 1.255-1.255h1.86A1.255 1.255 0 0 1 54.44 4.7v9.194h2.217c.19 0 .37.043.532.118v-4.77c0-.356.147-.678.385-.906a2.42 2.42 0 0 1-.682-1.71c0-.665.267-1.253.735-1.7a2.45 2.45 0 0 1 1.722-.674 2.43 2.43 0 0 1 1.705.675q.318.302.504.683V4.7a1.255 1.255 0 0 1 1.255-1.255h1.744A1.255 1.255 0 0 1 65.812 4.7v3.335a4.8 4.8 0 0 1 1.526-.246c.938 0 1.817.214 2.59.69a4.47 4.47 0 0 1 1.67 1.743v-.98a1.255 1.255 0 0 1 1.256-1.256h1.777c.233 0 .451.064.639.174a3.4 3.4 0 0 1 1.567-.372c.346 0 .861.02 1.285.232a1.25 1.25 0 0 1 .689 1.004 4.7 4.7 0 0 1 .853-.588c.795-.44 1.675-.647 2.61-.647 1.385 0 2.65.39 3.525 1.396.836.938 1.168 2.173 1.168 3.528q-.001.515-.056 1.051a1.255 1.255 0 0 1-.947 1.09l.408.952a1.255 1.255 0 0 1-.477 1.552c-.418.268-.92.463-1.458.612-.613.171-1.304.244-2.049.244-1.06 0-2.043-.207-2.886-.698l-.015-.008c-.798-.48-1.419-1.135-1.818-1.963l-.004-.008a5.8 5.8 0 0 1-.548-2.512q0-.429.053-.843a1.3 1.3 0 0 1-.333-.086l-.166-.004c-.223 0-.426.062-.643.228-.03.024-.142.139-.142.59v3.883a1.255 1.255 0 0 1-1.256 1.256h-1.777a1.255 1.255 0 0 1-1.256-1.256V15.69l-.032.057a4.8 4.8 0 0 1-1.86 1.833 5.04 5.04 0 0 1-2.484.634 4.5 4.5 0 0 1-1.935-.424 1.25 1.25 0 0 1-.764.258h-1.71a1.255 1.255 0 0 1-1.256-1.255V7.687a2.4 2.4 0 0 1-.428.625c.253.23.412.561.412.93v7.553a1.255 1.255 0 0 1-1.256 1.255h-1.843a1.25 1.25 0 0 1-.894-.373c-.228.23-.544.373-.894.373H51.32a1.255 1.255 0 0 1-1.256-1.255v-1.251l-.061.117a4.7 4.7 0 0 1-1.782 1.884 4.77 4.77 0 0 1-2.485.67 5.6 5.6 0 0 1-1.485-.188l.009 2.764a1.255 1.255 0 0 1-1.255 1.259h-1.729a1.255 1.255 0 0 1-1.255-1.255v-3.537a1.255 1.255 0 0 1-1.167.793h-1.679a1.25 1.25 0 0 1-.77-.263 4.5 4.5 0 0 1-1.945.429c-.885 0-1.724-.21-2.495-.632l-.017-.01a5 5 0 0 1-1.081-.836 1.255 1.255 0 0 1-1.254 1.312h-1.81a1.255 1.255 0 0 1-1.228-.99l-.782-3.625-2.044 3.939a1.25 1.25 0 0 1-1.115.676h-.098a1.25 1.25 0 0 1-1.116-.68l-2.061-3.994zM35.92 16.63l.207-.114.223-.15q.493-.356.735-.785l.061-.118.033 1.332h1.678V9.242h-1.694l-.033 1.267q-.133-.329-.526-.658l-.032-.028a3.2 3.2 0 0 0-.668-.428l-.27-.12a3.3 3.3 0 0 0-1.235-.23q-1.136-.001-1.974.493a3.36 3.36 0 0 0-1.3 1.382q-.445.89-.444 2.074 0 1.2.51 2.107a3.8 3.8 0 0 0 1.382 1.381 3.9 3.9 0 0 0 1.893.477q.795 0 1.455-.33zm-2.789-5.38q-.576.675-.575 1.762 0 1.102.559 1.794.576.675 1.645.675a2.25 2.25 0 0 0 .934-.19 2.2 2.2 0 0 0 .468-.29l.178-.161a2.2 2.2 0 0 0 .397-.561q.244-.5.244-1.15v-.115q0-.708-.296-1.267l-.043-.077a2.2 2.2 0 0 0-.633-.709l-.13-.086-.047-.028a2.1 2.1 0 0 0-1.073-.285q-1.052 0-1.629.692zm2.316 2.706c.163-.17.28-.407.28-.83v-.114c0-.292-.06-.508-.15-.68a.96.96 0 0 0-.353-.389.85.85 0 0 0-.464-.127c-.4 0-.56.114-.664.239l-.01.012c-.148.174-.275.45-.275.945 0 .506.122.801.27.99.097.11.266.224.68.224.303 0 .504-.09.687-.269zm7.545 1.705a2.6 2.6 0 0 0 .331.423q.319.33.755.548l.173.074q.65.255 1.49.255 1.02 0 1.844-.493a3.45 3.45 0 0 0 1.316-1.4q.493-.904.493-2.089 0-1.909-.988-2.913-.988-1.02-2.584-1.02-.898 0-1.575.347a3 3 0 0 0-.415.262l-.199.166a3.4 3.4 0 0 0-.64.82V9.242h-1.712v11.553h1.729l-.017-5.134zm.53-1.138q.206.29.48.5l.155.11.053.034q.51.296 1.119.297 1.07 0 1.645-.675.577-.69.576-1.762 0-1.119-.576-1.777-.558-.675-1.645-.675-.435 0-.835.16a2 2 0 0 0-.284.136 2 2 0 0 0-.363.254 2.2 2.2 0 0 0-.46.569l-.082.162a2.6 2.6 0 0 0-.213 1.072v.115q0 .707.296 1.267l.135.211zm.964-.818a1.1 1.1 0 0 0 .367.385.94.94 0 0 0 .476.118c.423 0 .59-.117.687-.23.159-.194.28-.478.28-.95 0-.53-.133-.8-.266-.952l-.021-.025c-.078-.094-.231-.221-.68-.221a1 1 0 0 0-.503.135l-.012.007a.86.86 0 0 0-.335.343c-.073.133-.132.324-.132.614v.115a1.4 1.4 0 0 0 .14.66zm15.7-6.222q.347-.346.346-.856a1.05 1.05 0 0 0-.345-.79 1.18 1.18 0 0 0-.84-.329q-.51 0-.855.33a1.05 1.05 0 0 0-.346.79q0 .51.346.855.345.346.856.346.51 0 .839-.346zm4.337 9.314.033-1.332q.191.403.59.747l.098.081a4 4 0 0 0 .316.224l.223.122a3.2 3.2 0 0 0 1.44.322 3.8 3.8 0 0 0 1.875-.477 3.5 3.5 0 0 0 1.382-1.366q.527-.89.526-2.09 0-1.184-.444-2.073a3.24 3.24 0 0 0-1.283-1.399q-.823-.51-1.942-.51a3.5 3.5 0 0 0-1.527.344l-.086.043-.165.09a3 3 0 0 0-.33.214q-.432.315-.656.707a2 2 0 0 0-.099.198l.082-1.283V4.701h-1.744v12.095zm.473-2.509a2.5 2.5 0 0 0 .566.7q.117.098.245.18l.144.08a2.1 2.1 0 0 0 .975.232q1.07 0 1.645-.675.576-.69.576-1.778 0-1.102-.576-1.777-.56-.691-1.645-.692a2.2 2.2 0 0 0-1.015.235q-.22.113-.415.282l-.15.142a2.1 2.1 0 0 0-.42.594q-.223.479-.223 1.1v.115q0 .705.293 1.26zm2.616-.293c.157-.191.28-.479.28-.967 0-.51-.13-.79-.276-.961l-.021-.026c-.082-.1-.232-.225-.67-.225a.87.87 0 0 0-.681.279l-.012.011c-.154.155-.274.38-.274.807v.115c0 .285.057.499.144.669a1.1 1.1 0 0 0 .367.405c.137.082.28.123.455.123.423 0 .59-.118.686-.23zm8.266-3.013q.345-.13.724-.14l.069-.002q.493 0 .642.099l.247-1.794q-.196-.099-.717-.099a2.3 2.3 0 0 0-.545.063 2 2 0 0 0-.411.148 2.2 2.2 0 0 0-.4.249 2.5 2.5 0 0 0-.485.499 2.7 2.7 0 0 0-.32.581l-.05.137v-1.48h-1.778v7.553h1.777v-3.884q0-.546.159-.943a1.5 1.5 0 0 1 .466-.636 2.5 2.5 0 0 1 .399-.253 2 2 0 0 1 .224-.099zm9.784 2.656.05-.922q0-1.743-.856-2.698-.838-.97-2.584-.97-1.119-.001-2.007.493a3.46 3.46 0 0 0-1.4 1.382q-.493.906-.493 2.106 0 1.07.428 1.975.428.89 1.332 1.432.906.526 2.255.526.973 0 1.668-.185l.044-.012.135-.04q.613-.184.984-.421l-.542-1.267q-.3.162-.642.274l-.297.087q-.51.131-1.3.131-.954 0-1.497-.444a1.6 1.6 0 0 1-.192-.193q-.366-.44-.512-1.234l-.004-.021zm-5.427-1.256-.003.022h3.752v-.138q-.011-.727-.288-1.118a1 1 0 0 0-.156-.176q-.46-.428-1.316-.428-.986 0-1.494.604-.379.45-.494 1.234zm-27.053 2.77V4.7h-1.86v12.095h5.333V15.15zm7.103-5.908v7.553h-1.843V9.242h1.843z%27/%3E%3Cpath fill=%27%23fff%27 d=%27m19.63 11.151-.757-1.71-.345 1.71-1.12 5.644h-1.827L18.083 4.7h.197l3.325 6.533.988 2.19.988-2.19L26.839 4.7h.181l2.6 12.095h-1.81l-1.218-5.644-.362-1.71-.658 1.71-2.93 5.644h-.098l-2.913-5.644zm14.836 5.81q-1.02 0-1.893-.478a3.8 3.8 0 0 1-1.381-1.382q-.51-.906-.51-2.106 0-1.185.444-2.074a3.36 3.36 0 0 1 1.3-1.382q.839-.494 1.974-.494a3.3 3.3 0 0 1 1.234.231 3.3 3.3 0 0 1 .97.575q.396.33.527.659l.033-1.267h1.694v7.553H37.18l-.033-1.332q-.279.593-1.02 1.053a3.17 3.17 0 0 1-1.662.444zm.296-1.482q.938 0 1.58-.642.642-.66.642-1.711v-.115q0-.708-.296-1.267a2.2 2.2 0 0 0-.807-.872 2.1 2.1 0 0 0-1.119-.313q-1.053 0-1.629.692-.575.675-.575 1.76 0 1.103.559 1.795.577.675 1.645.675zm6.521-6.237h1.711v1.4q.906-1.597 2.83-1.597 1.596 0 2.584 1.02.988 1.005.988 2.914 0 1.185-.493 2.09a3.46 3.46 0 0 1-1.316 1.399 3.5 3.5 0 0 1-1.844.493q-.954 0-1.662-.329a2.67 2.67 0 0 1-1.086-.97l.017 5.134h-1.728zm4.048 6.22q1.07 0 1.645-.674.577-.69.576-1.762 0-1.119-.576-1.777-.558-.675-1.645-.675-.592 0-1.12.296-.51.28-.822.823-.296.527-.296 1.234v.115q0 .708.296 1.267.313.543.823.855.51.296 1.119.297z%27/%3E%3Cpath fill=%27%23e1e3e9%27 d=%27M51.325 4.7h1.86v10.45h3.473v1.646h-5.333zm7.12 4.542h1.843v7.553h-1.843zm.905-1.415a1.16 1.16 0 0 1-.856-.346 1.17 1.17 0 0 1-.346-.856 1.05 1.05 0 0 1 .346-.79q.346-.329.856-.329.494 0 .839.33a1.05 1.05 0 0 1 .345.79 1.16 1.16 0 0 1-.345.855q-.33.346-.84.346zm7.875 9.133a3.17 3.17 0 0 1-1.662-.444q-.723-.46-1.004-1.053l-.033 1.332h-1.71V4.701h1.743v4.657l-.082 1.283q.279-.658 1.086-1.119a3.5 3.5 0 0 1 1.778-.477q1.119 0 1.942.51a3.24 3.24 0 0 1 1.283 1.4q.445.888.444 2.072 0 1.201-.526 2.09a3.5 3.5 0 0 1-1.382 1.366 3.8 3.8 0 0 1-1.876.477zm-.296-1.481q1.069 0 1.645-.675.577-.69.577-1.778 0-1.102-.577-1.776-.56-.691-1.645-.692a2.12 2.12 0 0 0-1.58.659q-.642.641-.642 1.694v.115q0 .71.296 1.267a2.4 2.4 0 0 0 .807.872 2.1 2.1 0 0 0 1.119.313zm5.927-6.237h1.777v1.481q.263-.757.856-1.217a2.14 2.14 0 0 1 1.349-.46q.527 0 .724.098l-.247 1.794q-.149-.099-.642-.099-.774 0-1.416.494-.626.493-.626 1.58v3.883h-1.777V9.242zm9.534 7.718q-1.35 0-2.255-.526-.904-.543-1.332-1.432a4.6 4.6 0 0 1-.428-1.975q0-1.2.493-2.106a3.46 3.46 0 0 1 1.4-1.382q.889-.495 2.007-.494 1.744 0 2.584.97.855.956.856 2.7 0 .444-.05.92h-5.43q.18 1.005.708 1.45.542.443 1.497.443.79 0 1.3-.131a4 4 0 0 0 .938-.362l.542 1.267q-.411.263-1.119.46-.708.198-1.711.197zm1.596-4.558q.016-1.02-.444-1.432-.46-.428-1.316-.428-1.728 0-1.991 1.86z%27/%3E%3Cpath d=%27M5.074 15.948a.484.657 0 0 0-.486.659v1.84a.484.657 0 0 0 .486.659h4.101a.484.657 0 0 0 .486-.659v-1.84a.484.657 0 0 0-.486-.659zm3.56 1.16H5.617v.838h3.017z%27 style=%27fill:%23fff;fill-rule:evenodd;stroke-width:1.03600001%27/%3E%3Cg style=%27stroke-width:1.12603545%27%3E%3Cpath d=%27M-9.408-1.416c-3.833-.025-7.056 2.912-7.08 6.615-.02 3.08 1.653 4.832 3.107 6.268.903.892 1.721 1.74 2.32 2.902l-.525-.004c-.543-.003-.992.304-1.24.639a1.87 1.87 0 0 0-.362 1.121l-.011 1.877c-.003.402.104.787.347 1.125.244.338.688.653 1.23.656l4.142.028c.542.003.99-.306 1.238-.641a1.87 1.87 0 0 0 .363-1.121l.012-1.875a1.87 1.87 0 0 0-.348-1.127c-.243-.338-.688-.653-1.23-.656l-.518-.004c.597-1.145 1.425-1.983 2.348-2.87 1.473-1.414 3.18-3.149 3.2-6.226-.016-3.59-2.923-6.684-6.993-6.707m-.006 1.1v.002c3.274.02 5.92 2.532 5.9 5.6-.017 2.706-1.39 4.026-2.863 5.44-1.034.994-2.118 2.033-2.814 3.633-.018.041-.052.055-.075.065q-.013.004-.02.01a.34.34 0 0 1-.226.084.34.34 0 0 1-.224-.086l-.092-.077c-.699-1.615-1.768-2.669-2.781-3.67-1.454-1.435-2.797-2.762-2.78-5.478.02-3.067 2.7-5.545 5.975-5.523m-.02 2.826c-1.62-.01-2.944 1.315-2.955 2.96-.01 1.646 1.295 2.988 2.916 2.999h.002c1.621.01 2.943-1.316 2.953-2.961.011-1.646-1.294-2.988-2.916-2.998m-.005 1.1c1.017.006 1.829.83 1.822 1.89s-.83 1.874-1.848 1.867c-1.018-.006-1.829-.83-1.822-1.89s.83-1.874 1.848-1.868m-2.155 11.857 4.14.025c.271.002.49.305.487.676l-.013 1.875c-.003.37-.224.67-.495.668l-4.14-.025c-.27-.002-.487-.306-.485-.676l.012-1.875c.003-.37.224-.67.494-.668%27 style=%27color:%23000;font-style:normal;font-variant:normal;font-weight:400;font-stretch:normal;font-size:medium;line-height:normal;font-family:sans-serif;font-variant-ligatures:normal;font-variant-position:normal;font-variant-caps:normal;font-variant-numeric:normal;font-variant-alternates:normal;font-feature-settings:normal;text-indent:0;text-align:start;text-decoration:none;text-decoration-line:none;text-decoration-style:solid;text-decoration-color:%23000;letter-spacing:normal;word-spacing:normal;text-transform:none;writing-mode:lr-tb;direction:ltr;text-orientation:mixed;dominant-baseline:auto;baseline-shift:baseline;text-anchor:start;white-space:normal;shape-padding:0;clip-rule:evenodd;display:inline;overflow:visible;visibility:visible;opacity:1;isolation:auto;mix-blend-mode:normal;color-interpolation:sRGB;color-interpolation-filters:linearRGB;solid-color:%23000;solid-opacity:1;vector-effect:none;fill:%23000;fill-opacity:.4;fill-rule:evenodd;stroke:none;stroke-width:2.47727823;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;color-rendering:auto;image-rendering:auto;shape-rendering:auto;text-rendering:auto%27 transform=%27translate%2815.553 2.85%29scale%28.88807%29%27/%3E%3Cpath d=%27M-9.415-.316C-12.69-.338-15.37 2.14-15.39 5.207c-.017 2.716 1.326 4.041 2.78 5.477 1.013 1 2.081 2.055 2.78 3.67l.092.076a.34.34 0 0 0 .225.086.34.34 0 0 0 .227-.083l.019-.01c.022-.009.057-.024.074-.064.697-1.6 1.78-2.64 2.814-3.634 1.473-1.414 2.847-2.733 2.864-5.44.02-3.067-2.627-5.58-5.901-5.601m-.057 8.784c1.621.011 2.944-1.315 2.955-2.96.01-1.646-1.295-2.988-2.916-2.999-1.622-.01-2.945 1.315-2.955 2.96s1.295 2.989 2.916 3%27 style=%27clip-rule:evenodd;fill:%23e1e3e9;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:2.47727823;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:.4%27 transform=%27translate%2815.553 2.85%29scale%28.88807%29%27/%3E%3Cpath d=%27M-11.594 15.465c-.27-.002-.492.297-.494.668l-.012 1.876c-.003.371.214.673.485.675l4.14.027c.271.002.492-.298.495-.668l.012-1.877c.003-.37-.215-.672-.485-.674z%27 style=%27clip-rule:evenodd;fill:%23fff;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:2.47727823;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:.4%27 transform=%27translate%2815.553 2.85%29scale%28.88807%29%27/%3E%3C/g%3E%3C/svg%3E";
            },
            63779: function() {},
            77199: function() {},
            61990: function(t1, e1, r) {
                "use strict";
                Object.defineProperty(e1, "__esModule", {
                    value: !0
                });
                var n = r(85846), i = r(66030);
                function a(t1) {
                    return i.geomReduce.call(void 0, t1, (t1, e1)=>t1 + function(t1) {
                            let e1, r = 0;
                            switch(t1.type){
                                case "Polygon":
                                    return o(t1.coordinates);
                                case "MultiPolygon":
                                    for(e1 = 0; e1 < t1.coordinates.length; e1++)r += o(t1.coordinates[e1]);
                                    return r;
                                case "Point":
                                case "MultiPoint":
                                case "LineString":
                                case "MultiLineString":
                                    return 0;
                            }
                            return 0;
                        }(e1), 0);
                }
                function o(t1) {
                    let e1 = 0;
                    if (t1 && t1.length > 0) {
                        e1 += Math.abs(c(t1[0]));
                        for(let r = 1; r < t1.length; r++)e1 -= Math.abs(c(t1[r]));
                    }
                    return e1;
                }
                var s = n.earthRadius * n.earthRadius / 2, l = Math.PI / 180;
                function c(t1) {
                    const e1 = t1.length - 1;
                    if (e1 <= 2) return 0;
                    let r = 0, n = 0;
                    for(; n < e1;){
                        const i = t1[n], a = t1[n + 1 === e1 ? 0 : n + 1], o = t1[n + 2 >= e1 ? (n + 2) % e1 : n + 2], s = i[0] * l, c = a[1] * l;
                        r += (o[0] * l - s) * Math.sin(c), n++;
                    }
                    return r * s;
                }
                var u = a;
                e1.area = a, e1.default = u;
            },
            25368: function(t1, e1, r) {
                "use strict";
                Object.defineProperty(e1, "__esModule", {
                    value: !0
                });
                var n = r(66030);
                function i(t1, e1 = {}) {
                    if (null != t1.bbox && !0 !== e1.recompute) return t1.bbox;
                    const r = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ];
                    return n.coordEach.call(void 0, t1, (t1)=>{
                        r[0] > t1[0] && (r[0] = t1[0]), r[1] > t1[1] && (r[1] = t1[1]), r[2] < t1[0] && (r[2] = t1[0]), r[3] < t1[1] && (r[3] = t1[1]);
                    }), r;
                }
                var a = i;
                e1.bbox = i, e1.default = a;
            },
            30035: function(t1, e1, r) {
                "use strict";
                Object.defineProperty(e1, "__esModule", {
                    value: !0
                });
                var n = r(85846), i = r(66030);
                function a(t1, e1 = {}) {
                    let r = 0, a = 0, o = 0;
                    return i.coordEach.call(void 0, t1, function(t1) {
                        r += t1[0], a += t1[1], o++;
                    }, !0), n.point.call(void 0, [
                        r / o,
                        a / o
                    ], e1.properties);
                }
                var o = a;
                e1.centroid = a, e1.default = o;
            },
            85846: function(t1, e1) {
                "use strict";
                Object.defineProperty(e1, "__esModule", {
                    value: !0
                });
                var r = 6371008.8, n = {
                    centimeters: 637100880,
                    centimetres: 637100880,
                    degrees: 360 / (2 * Math.PI),
                    feet: 20902260.511392,
                    inches: 39.37 * r,
                    kilometers: 6371.0088,
                    kilometres: 6371.0088,
                    meters: r,
                    metres: r,
                    miles: 3958.761333810546,
                    millimeters: 6371008800,
                    millimetres: 6371008800,
                    nauticalmiles: r / 1852,
                    radians: 1,
                    yards: 6967335.223679999
                }, i = {
                    acres: 247105e-9,
                    centimeters: 1e4,
                    centimetres: 1e4,
                    feet: 10.763910417,
                    hectares: 1e-4,
                    inches: 1550.003100006,
                    kilometers: 1e-6,
                    kilometres: 1e-6,
                    meters: 1,
                    metres: 1,
                    miles: 386e-9,
                    nauticalmiles: 2.9155334959812285e-7,
                    millimeters: 1e6,
                    millimetres: 1e6,
                    yards: 1.195990046
                };
                function a(t1, e1, r = {}) {
                    const n = {
                        type: "Feature"
                    };
                    return (0 === r.id || r.id) && (n.id = r.id), r.bbox && (n.bbox = r.bbox), n.properties = e1 || {}, n.geometry = t1, n;
                }
                function o(t1, e1, r = {}) {
                    if (!t1) throw new Error("coordinates is required");
                    if (!Array.isArray(t1)) throw new Error("coordinates must be an Array");
                    if (t1.length < 2) throw new Error("coordinates must be at least 2 numbers long");
                    if (!g(t1[0]) || !g(t1[1])) throw new Error("coordinates must contain numbers");
                    return a({
                        type: "Point",
                        coordinates: t1
                    }, e1, r);
                }
                function s(t1, e1, r = {}) {
                    for (const e1 of t1){
                        if (e1.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
                        if (e1[e1.length - 1].length !== e1[0].length) throw new Error("First and last Position are not equivalent.");
                        for(let t1 = 0; t1 < e1[e1.length - 1].length; t1++)if (e1[e1.length - 1][t1] !== e1[0][t1]) throw new Error("First and last Position are not equivalent.");
                    }
                    return a({
                        type: "Polygon",
                        coordinates: t1
                    }, e1, r);
                }
                function l(t1, e1, r = {}) {
                    if (t1.length < 2) throw new Error("coordinates must be an array of two or more positions");
                    return a({
                        type: "LineString",
                        coordinates: t1
                    }, e1, r);
                }
                function c(t1, e1 = {}) {
                    const r = {
                        type: "FeatureCollection"
                    };
                    return e1.id && (r.id = e1.id), e1.bbox && (r.bbox = e1.bbox), r.features = t1, r;
                }
                function u(t1, e1, r = {}) {
                    return a({
                        type: "MultiLineString",
                        coordinates: t1
                    }, e1, r);
                }
                function h(t1, e1, r = {}) {
                    return a({
                        type: "MultiPoint",
                        coordinates: t1
                    }, e1, r);
                }
                function f(t1, e1, r = {}) {
                    return a({
                        type: "MultiPolygon",
                        coordinates: t1
                    }, e1, r);
                }
                function p(t1, e1 = "kilometers") {
                    const r = n[e1];
                    if (!r) throw new Error(e1 + " units is invalid");
                    return t1 * r;
                }
                function d(t1, e1 = "kilometers") {
                    const r = n[e1];
                    if (!r) throw new Error(e1 + " units is invalid");
                    return t1 / r;
                }
                function m(t1) {
                    return t1 % (2 * Math.PI) * 180 / Math.PI;
                }
                function g(t1) {
                    return !isNaN(t1) && null !== t1 && !Array.isArray(t1);
                }
                e1.areaFactors = i, e1.azimuthToBearing = function(t1) {
                    return (t1 %= 360) > 0 ? t1 > 180 ? t1 - 360 : t1 : t1 < -180 ? t1 + 360 : t1;
                }, e1.bearingToAzimuth = function(t1) {
                    let e1 = t1 % 360;
                    return e1 < 0 && (e1 += 360), e1;
                }, e1.convertArea = function(t1, e1 = "meters", r = "kilometers") {
                    if (!(t1 >= 0)) throw new Error("area must be a positive number");
                    const n = i[e1];
                    if (!n) throw new Error("invalid original units");
                    const a = i[r];
                    if (!a) throw new Error("invalid final units");
                    return t1 / n * a;
                }, e1.convertLength = function(t1, e1 = "kilometers", r = "kilometers") {
                    if (!(t1 >= 0)) throw new Error("length must be a positive number");
                    return p(d(t1, e1), r);
                }, e1.degreesToRadians = function(t1) {
                    return t1 % 360 * Math.PI / 180;
                }, e1.earthRadius = r, e1.factors = n, e1.feature = a, e1.featureCollection = c, e1.geometry = function(t1, e1, r = {}) {
                    switch(t1){
                        case "Point":
                            return o(e1).geometry;
                        case "LineString":
                            return l(e1).geometry;
                        case "Polygon":
                            return s(e1).geometry;
                        case "MultiPoint":
                            return h(e1).geometry;
                        case "MultiLineString":
                            return u(e1).geometry;
                        case "MultiPolygon":
                            return f(e1).geometry;
                        default:
                            throw new Error(t1 + " is invalid");
                    }
                }, e1.geometryCollection = function(t1, e1, r = {}) {
                    return a({
                        type: "GeometryCollection",
                        geometries: t1
                    }, e1, r);
                }, e1.isNumber = g, e1.isObject = function(t1) {
                    return null !== t1 && "object" == typeof t1 && !Array.isArray(t1);
                }, e1.lengthToDegrees = function(t1, e1) {
                    return m(d(t1, e1));
                }, e1.lengthToRadians = d, e1.lineString = l, e1.lineStrings = function(t1, e1, r = {}) {
                    return c(t1.map((t1)=>l(t1, e1)), r);
                }, e1.multiLineString = u, e1.multiPoint = h, e1.multiPolygon = f, e1.point = o, e1.points = function(t1, e1, r = {}) {
                    return c(t1.map((t1)=>o(t1, e1)), r);
                }, e1.polygon = s, e1.polygons = function(t1, e1, r = {}) {
                    return c(t1.map((t1)=>s(t1, e1)), r);
                }, e1.radiansToDegrees = m, e1.radiansToLength = p, e1.round = function(t1, e1 = 0) {
                    if (e1 && !(e1 >= 0)) throw new Error("precision must be a positive number");
                    const r = Math.pow(10, e1 || 0);
                    return Math.round(t1 * r) / r;
                }, e1.validateBBox = function(t1) {
                    if (!t1) throw new Error("bbox is required");
                    if (!Array.isArray(t1)) throw new Error("bbox must be an Array");
                    if (4 !== t1.length && 6 !== t1.length) throw new Error("bbox must be an Array of 4 or 6 numbers");
                    t1.forEach((t1)=>{
                        if (!g(t1)) throw new Error("bbox must only contain numbers");
                    });
                }, e1.validateId = function(t1) {
                    if (!t1) throw new Error("id is required");
                    if (-1 === [
                        "string",
                        "number"
                    ].indexOf(typeof t1)) throw new Error("id must be a number or a string");
                };
            },
            66030: function(t1, e1, r) {
                "use strict";
                Object.defineProperty(e1, "__esModule", {
                    value: !0
                });
                var n = r(85846);
                function i(t1, e1, r) {
                    if (null !== t1) for(var n, a, o, s, l, c, u, h, f = 0, p = 0, d = t1.type, m = "FeatureCollection" === d, g = "Feature" === d, y = m ? t1.features.length : 1, v = 0; v < y; v++){
                        l = (h = !!(u = m ? t1.features[v].geometry : g ? t1.geometry : t1) && "GeometryCollection" === u.type) ? u.geometries.length : 1;
                        for(var x = 0; x < l; x++){
                            var _ = 0, b = 0;
                            if (null !== (s = h ? u.geometries[x] : u)) {
                                c = s.coordinates;
                                var w = s.type;
                                switch(f = !r || "Polygon" !== w && "MultiPolygon" !== w ? 0 : 1, w){
                                    case null:
                                        break;
                                    case "Point":
                                        if (!1 === e1(c, p, v, _, b)) return !1;
                                        p++, _++;
                                        break;
                                    case "LineString":
                                    case "MultiPoint":
                                        for(n = 0; n < c.length; n++){
                                            if (!1 === e1(c[n], p, v, _, b)) return !1;
                                            p++, "MultiPoint" === w && _++;
                                        }
                                        "LineString" === w && _++;
                                        break;
                                    case "Polygon":
                                    case "MultiLineString":
                                        for(n = 0; n < c.length; n++){
                                            for(a = 0; a < c[n].length - f; a++){
                                                if (!1 === e1(c[n][a], p, v, _, b)) return !1;
                                                p++;
                                            }
                                            "MultiLineString" === w && _++, "Polygon" === w && b++;
                                        }
                                        "Polygon" === w && _++;
                                        break;
                                    case "MultiPolygon":
                                        for(n = 0; n < c.length; n++){
                                            for(b = 0, a = 0; a < c[n].length; a++){
                                                for(o = 0; o < c[n][a].length - f; o++){
                                                    if (!1 === e1(c[n][a][o], p, v, _, b)) return !1;
                                                    p++;
                                                }
                                                b++;
                                            }
                                            _++;
                                        }
                                        break;
                                    case "GeometryCollection":
                                        for(n = 0; n < s.geometries.length; n++)if (!1 === i(s.geometries[n], e1, r)) return !1;
                                        break;
                                    default:
                                        throw new Error("Unknown Geometry Type");
                                }
                            }
                        }
                    }
                }
                function a(t1, e1) {
                    var r;
                    switch(t1.type){
                        case "FeatureCollection":
                            for(r = 0; r < t1.features.length && !1 !== e1(t1.features[r].properties, r); r++);
                            break;
                        case "Feature":
                            e1(t1.properties, 0);
                    }
                }
                function o(t1, e1) {
                    if ("Feature" === t1.type) e1(t1, 0);
                    else if ("FeatureCollection" === t1.type) for(var r = 0; r < t1.features.length && !1 !== e1(t1.features[r], r); r++);
                }
                function s(t1, e1) {
                    var r, n, i, a, o, s, l, c, u, h, f = 0, p = "FeatureCollection" === t1.type, d = "Feature" === t1.type, m = p ? t1.features.length : 1;
                    for(r = 0; r < m; r++){
                        for(s = p ? t1.features[r].geometry : d ? t1.geometry : t1, c = p ? t1.features[r].properties : d ? t1.properties : {}, u = p ? t1.features[r].bbox : d ? t1.bbox : void 0, h = p ? t1.features[r].id : d ? t1.id : void 0, o = (l = !!s && "GeometryCollection" === s.type) ? s.geometries.length : 1, i = 0; i < o; i++)if (null !== (a = l ? s.geometries[i] : s)) switch(a.type){
                            case "Point":
                            case "LineString":
                            case "MultiPoint":
                            case "Polygon":
                            case "MultiLineString":
                            case "MultiPolygon":
                                if (!1 === e1(a, f, c, u, h)) return !1;
                                break;
                            case "GeometryCollection":
                                for(n = 0; n < a.geometries.length; n++)if (!1 === e1(a.geometries[n], f, c, u, h)) return !1;
                                break;
                            default:
                                throw new Error("Unknown Geometry Type");
                        }
                        else if (!1 === e1(null, f, c, u, h)) return !1;
                        f++;
                    }
                }
                function l(t1, e1) {
                    s(t1, function(t1, r, i, a, o) {
                        var s, l = null === t1 ? null : t1.type;
                        switch(l){
                            case null:
                            case "Point":
                            case "LineString":
                            case "Polygon":
                                return !1 !== e1(n.feature.call(void 0, t1, i, {
                                    bbox: a,
                                    id: o
                                }), r, 0) && void 0;
                        }
                        switch(l){
                            case "MultiPoint":
                                s = "Point";
                                break;
                            case "MultiLineString":
                                s = "LineString";
                                break;
                            case "MultiPolygon":
                                s = "Polygon";
                        }
                        for(var c = 0; c < t1.coordinates.length; c++){
                            var u = {
                                type: s,
                                coordinates: t1.coordinates[c]
                            };
                            if (!1 === e1(n.feature.call(void 0, u, i), r, c)) return !1;
                        }
                    });
                }
                function c(t1, e1) {
                    l(t1, function(t1, r, a) {
                        var o = 0;
                        if (t1.geometry) {
                            var s = t1.geometry.type;
                            if ("Point" !== s && "MultiPoint" !== s) {
                                var l, c = 0, u = 0, h = 0;
                                return !1 !== i(t1, function(i, s, f, p, d) {
                                    if (void 0 === l || r > c || p > u || d > h) return l = i, c = r, u = p, h = d, void (o = 0);
                                    var m = n.lineString.call(void 0, [
                                        l,
                                        i
                                    ], t1.properties);
                                    if (!1 === e1(m, r, a, d, o)) return !1;
                                    o++, l = i;
                                }) && void 0;
                            }
                        }
                    });
                }
                function u(t1, e1) {
                    if (!t1) throw new Error("geojson is required");
                    l(t1, function(t1, r, i) {
                        if (null !== t1.geometry) {
                            var a = t1.geometry.type, o = t1.geometry.coordinates;
                            switch(a){
                                case "LineString":
                                    if (!1 === e1(t1, r, i, 0, 0)) return !1;
                                    break;
                                case "Polygon":
                                    for(var s = 0; s < o.length; s++)if (!1 === e1(n.lineString.call(void 0, o[s], t1.properties), r, i, s)) return !1;
                            }
                        }
                    });
                }
                e1.coordAll = function(t1) {
                    var e1 = [];
                    return i(t1, function(t1) {
                        e1.push(t1);
                    }), e1;
                }, e1.coordEach = i, e1.coordReduce = function(t1, e1, r, n) {
                    var a = r;
                    return i(t1, function(t1, n, i, o, s) {
                        a = 0 === n && void 0 === r ? t1 : e1(a, t1, n, i, o, s);
                    }, n), a;
                }, e1.featureEach = o, e1.featureReduce = function(t1, e1, r) {
                    var n = r;
                    return o(t1, function(t1, i) {
                        n = 0 === i && void 0 === r ? t1 : e1(n, t1, i);
                    }), n;
                }, e1.findPoint = function(t1, e1) {
                    if (e1 = e1 || {}, !n.isObject.call(void 0, e1)) throw new Error("options is invalid");
                    var r, i = e1.featureIndex || 0, a = e1.multiFeatureIndex || 0, o = e1.geometryIndex || 0, s = e1.coordIndex || 0, l = e1.properties;
                    switch(t1.type){
                        case "FeatureCollection":
                            i < 0 && (i = t1.features.length + i), l = l || t1.features[i].properties, r = t1.features[i].geometry;
                            break;
                        case "Feature":
                            l = l || t1.properties, r = t1.geometry;
                            break;
                        case "Point":
                        case "MultiPoint":
                            return null;
                        case "LineString":
                        case "Polygon":
                        case "MultiLineString":
                        case "MultiPolygon":
                            r = t1;
                            break;
                        default:
                            throw new Error("geojson is invalid");
                    }
                    if (null === r) return null;
                    var c = r.coordinates;
                    switch(r.type){
                        case "Point":
                            return n.point.call(void 0, c, l, e1);
                        case "MultiPoint":
                            return a < 0 && (a = c.length + a), n.point.call(void 0, c[a], l, e1);
                        case "LineString":
                            return s < 0 && (s = c.length + s), n.point.call(void 0, c[s], l, e1);
                        case "Polygon":
                            return o < 0 && (o = c.length + o), s < 0 && (s = c[o].length + s), n.point.call(void 0, c[o][s], l, e1);
                        case "MultiLineString":
                            return a < 0 && (a = c.length + a), s < 0 && (s = c[a].length + s), n.point.call(void 0, c[a][s], l, e1);
                        case "MultiPolygon":
                            return a < 0 && (a = c.length + a), o < 0 && (o = c[a].length + o), s < 0 && (s = c[a][o].length - s), n.point.call(void 0, c[a][o][s], l, e1);
                    }
                    throw new Error("geojson is invalid");
                }, e1.findSegment = function(t1, e1) {
                    if (e1 = e1 || {}, !n.isObject.call(void 0, e1)) throw new Error("options is invalid");
                    var r, i = e1.featureIndex || 0, a = e1.multiFeatureIndex || 0, o = e1.geometryIndex || 0, s = e1.segmentIndex || 0, l = e1.properties;
                    switch(t1.type){
                        case "FeatureCollection":
                            i < 0 && (i = t1.features.length + i), l = l || t1.features[i].properties, r = t1.features[i].geometry;
                            break;
                        case "Feature":
                            l = l || t1.properties, r = t1.geometry;
                            break;
                        case "Point":
                        case "MultiPoint":
                            return null;
                        case "LineString":
                        case "Polygon":
                        case "MultiLineString":
                        case "MultiPolygon":
                            r = t1;
                            break;
                        default:
                            throw new Error("geojson is invalid");
                    }
                    if (null === r) return null;
                    var c = r.coordinates;
                    switch(r.type){
                        case "Point":
                        case "MultiPoint":
                            return null;
                        case "LineString":
                            return s < 0 && (s = c.length + s - 1), n.lineString.call(void 0, [
                                c[s],
                                c[s + 1]
                            ], l, e1);
                        case "Polygon":
                            return o < 0 && (o = c.length + o), s < 0 && (s = c[o].length + s - 1), n.lineString.call(void 0, [
                                c[o][s],
                                c[o][s + 1]
                            ], l, e1);
                        case "MultiLineString":
                            return a < 0 && (a = c.length + a), s < 0 && (s = c[a].length + s - 1), n.lineString.call(void 0, [
                                c[a][s],
                                c[a][s + 1]
                            ], l, e1);
                        case "MultiPolygon":
                            return a < 0 && (a = c.length + a), o < 0 && (o = c[a].length + o), s < 0 && (s = c[a][o].length - s - 1), n.lineString.call(void 0, [
                                c[a][o][s],
                                c[a][o][s + 1]
                            ], l, e1);
                    }
                    throw new Error("geojson is invalid");
                }, e1.flattenEach = l, e1.flattenReduce = function(t1, e1, r) {
                    var n = r;
                    return l(t1, function(t1, i, a) {
                        n = 0 === i && 0 === a && void 0 === r ? t1 : e1(n, t1, i, a);
                    }), n;
                }, e1.geomEach = s, e1.geomReduce = function(t1, e1, r) {
                    var n = r;
                    return s(t1, function(t1, i, a, o, s) {
                        n = 0 === i && void 0 === r ? t1 : e1(n, t1, i, a, o, s);
                    }), n;
                }, e1.lineEach = u, e1.lineReduce = function(t1, e1, r) {
                    var n = r;
                    return u(t1, function(t1, i, a, o) {
                        n = 0 === i && void 0 === r ? t1 : e1(n, t1, i, a, o);
                    }), n;
                }, e1.propEach = a, e1.propReduce = function(t1, e1, r) {
                    var n = r;
                    return a(t1, function(t1, i) {
                        n = 0 === i && void 0 === r ? t1 : e1(n, t1, i);
                    }), n;
                }, e1.segmentEach = c, e1.segmentReduce = function(t1, e1, r) {
                    var n = r, i = !1;
                    return c(t1, function(t1, a, o, s, l) {
                        n = !1 === i && void 0 === r ? t1 : e1(n, t1, a, o, s, l), i = !0;
                    }), n;
                };
            },
            70085: function(t1, e1, r) {
                "use strict";
                var n = [
                    "BigInt64Array",
                    "BigUint64Array",
                    "Float32Array",
                    "Float64Array",
                    "Int16Array",
                    "Int32Array",
                    "Int8Array",
                    "Uint16Array",
                    "Uint32Array",
                    "Uint8Array",
                    "Uint8ClampedArray"
                ], i = "undefined" == typeof globalThis ? r.g : globalThis;
                t1.exports = function() {
                    for(var t1 = [], e1 = 0; e1 < n.length; e1++)"function" == typeof i[n[e1]] && (t1[t1.length] = n[e1]);
                    return t1;
                };
            },
            89380: function(t1) {
                t1.exports = function() {
                    "use strict";
                    var t1 = {}, e1 = {};
                    function r(r, n, i) {
                        if (e1[r] = i, "index" === r) {
                            var a = "var sharedModule = {}; (" + e1.shared + ")(sharedModule); (" + e1.worker + ")(sharedModule);", o = {};
                            return e1.shared(o), e1.index(t1, o), "undefined" != typeof window && t1.setWorkerUrl(window.URL.createObjectURL(new Blob([
                                a
                            ], {
                                type: "text/javascript"
                            }))), t1;
                        }
                    }
                    return r("shared", 0, function(t1) {
                        function e1(t1, e1, r, n) {
                            return new (r || (r = Promise))(function(i, a) {
                                function o(t1) {
                                    try {
                                        l(n.next(t1));
                                    } catch (t1) {
                                        a(t1);
                                    }
                                }
                                function s(t1) {
                                    try {
                                        l(n.throw(t1));
                                    } catch (t1) {
                                        a(t1);
                                    }
                                }
                                function l(t1) {
                                    var e1;
                                    t1.done ? i(t1.value) : (e1 = t1.value, e1 instanceof r ? e1 : new r(function(t1) {
                                        t1(e1);
                                    })).then(o, s);
                                }
                                l((n = n.apply(t1, e1 || [])).next());
                            });
                        }
                        function r(t1) {
                            return t1 && t1.__esModule && Object.prototype.hasOwnProperty.call(t1, "default") ? t1.default : t1;
                        }
                        "function" == typeof SuppressedError && SuppressedError;
                        var n = i;
                        function i(t1, e1) {
                            this.x = t1, this.y = e1;
                        }
                        i.prototype = {
                            clone: function() {
                                return new i(this.x, this.y);
                            },
                            add: function(t1) {
                                return this.clone()._add(t1);
                            },
                            sub: function(t1) {
                                return this.clone()._sub(t1);
                            },
                            multByPoint: function(t1) {
                                return this.clone()._multByPoint(t1);
                            },
                            divByPoint: function(t1) {
                                return this.clone()._divByPoint(t1);
                            },
                            mult: function(t1) {
                                return this.clone()._mult(t1);
                            },
                            div: function(t1) {
                                return this.clone()._div(t1);
                            },
                            rotate: function(t1) {
                                return this.clone()._rotate(t1);
                            },
                            rotateAround: function(t1, e1) {
                                return this.clone()._rotateAround(t1, e1);
                            },
                            matMult: function(t1) {
                                return this.clone()._matMult(t1);
                            },
                            unit: function() {
                                return this.clone()._unit();
                            },
                            perp: function() {
                                return this.clone()._perp();
                            },
                            round: function() {
                                return this.clone()._round();
                            },
                            mag: function() {
                                return Math.sqrt(this.x * this.x + this.y * this.y);
                            },
                            equals: function(t1) {
                                return this.x === t1.x && this.y === t1.y;
                            },
                            dist: function(t1) {
                                return Math.sqrt(this.distSqr(t1));
                            },
                            distSqr: function(t1) {
                                var e1 = t1.x - this.x, r = t1.y - this.y;
                                return e1 * e1 + r * r;
                            },
                            angle: function() {
                                return Math.atan2(this.y, this.x);
                            },
                            angleTo: function(t1) {
                                return Math.atan2(this.y - t1.y, this.x - t1.x);
                            },
                            angleWith: function(t1) {
                                return this.angleWithSep(t1.x, t1.y);
                            },
                            angleWithSep: function(t1, e1) {
                                return Math.atan2(this.x * e1 - this.y * t1, this.x * t1 + this.y * e1);
                            },
                            _matMult: function(t1) {
                                var e1 = t1[0] * this.x + t1[1] * this.y, r = t1[2] * this.x + t1[3] * this.y;
                                return this.x = e1, this.y = r, this;
                            },
                            _add: function(t1) {
                                return this.x += t1.x, this.y += t1.y, this;
                            },
                            _sub: function(t1) {
                                return this.x -= t1.x, this.y -= t1.y, this;
                            },
                            _mult: function(t1) {
                                return this.x *= t1, this.y *= t1, this;
                            },
                            _div: function(t1) {
                                return this.x /= t1, this.y /= t1, this;
                            },
                            _multByPoint: function(t1) {
                                return this.x *= t1.x, this.y *= t1.y, this;
                            },
                            _divByPoint: function(t1) {
                                return this.x /= t1.x, this.y /= t1.y, this;
                            },
                            _unit: function() {
                                return this._div(this.mag()), this;
                            },
                            _perp: function() {
                                var t1 = this.y;
                                return this.y = this.x, this.x = -t1, this;
                            },
                            _rotate: function(t1) {
                                var e1 = Math.cos(t1), r = Math.sin(t1), n = e1 * this.x - r * this.y, i = r * this.x + e1 * this.y;
                                return this.x = n, this.y = i, this;
                            },
                            _rotateAround: function(t1, e1) {
                                var r = Math.cos(t1), n = Math.sin(t1), i = e1.x + r * (this.x - e1.x) - n * (this.y - e1.y), a = e1.y + n * (this.x - e1.x) + r * (this.y - e1.y);
                                return this.x = i, this.y = a, this;
                            },
                            _round: function() {
                                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
                            }
                        }, i.convert = function(t1) {
                            return t1 instanceof i ? t1 : Array.isArray(t1) ? new i(t1[0], t1[1]) : t1;
                        };
                        var a = r(n), o = s;
                        function s(t1, e1, r, n) {
                            this.cx = 3 * t1, this.bx = 3 * (r - t1) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * e1, this.by = 3 * (n - e1) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = t1, this.p1y = e1, this.p2x = r, this.p2y = n;
                        }
                        s.prototype = {
                            sampleCurveX: function(t1) {
                                return ((this.ax * t1 + this.bx) * t1 + this.cx) * t1;
                            },
                            sampleCurveY: function(t1) {
                                return ((this.ay * t1 + this.by) * t1 + this.cy) * t1;
                            },
                            sampleCurveDerivativeX: function(t1) {
                                return (3 * this.ax * t1 + 2 * this.bx) * t1 + this.cx;
                            },
                            solveCurveX: function(t1, e1) {
                                if (void 0 === e1 && (e1 = 1e-6), t1 < 0) return 0;
                                if (t1 > 1) return 1;
                                for(var r = t1, n = 0; n < 8; n++){
                                    var i = this.sampleCurveX(r) - t1;
                                    if (Math.abs(i) < e1) return r;
                                    var a = this.sampleCurveDerivativeX(r);
                                    if (Math.abs(a) < 1e-6) break;
                                    r -= i / a;
                                }
                                var o = 0, s = 1;
                                for(r = t1, n = 0; n < 20 && (i = this.sampleCurveX(r), !(Math.abs(i - t1) < e1)); n++)t1 > i ? o = r : s = r, r = .5 * (s - o) + o;
                                return r;
                            },
                            solve: function(t1, e1) {
                                return this.sampleCurveY(this.solveCurveX(t1, e1));
                            }
                        };
                        var l = r(o);
                        let c, u;
                        function h() {
                            return null == c && (c = "undefined" != typeof OffscreenCanvas && new OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof createImageBitmap), c;
                        }
                        function f() {
                            if (null == u && (u = !1, h())) {
                                const t1 = 5, e1 = new OffscreenCanvas(t1, t1).getContext("2d", {
                                    willReadFrequently: !0
                                });
                                if (e1) {
                                    for(let r = 0; r < t1 * t1; r++){
                                        const n = 4 * r;
                                        e1.fillStyle = `rgb(${n},${n + 1},${n + 2})`, e1.fillRect(r % t1, Math.floor(r / t1), 1, 1);
                                    }
                                    const r = e1.getImageData(0, 0, t1, t1).data;
                                    for(let e1 = 0; e1 < t1 * t1 * 4; e1++)if (e1 % 4 != 3 && r[e1] !== e1) {
                                        u = !0;
                                        break;
                                    }
                                }
                            }
                            return u || !1;
                        }
                        function p(t1, e1, r, n) {
                            const i = new l(t1, e1, r, n);
                            return (t1)=>i.solve(t1);
                        }
                        const d = p(.25, .1, .25, 1);
                        function m(t1, e1, r) {
                            return Math.min(r, Math.max(e1, t1));
                        }
                        function g(t1, e1, r) {
                            const n = r - e1, i = ((t1 - e1) % n + n) % n + e1;
                            return i === e1 ? r : i;
                        }
                        function y(t1, ...e1) {
                            for (const r of e1)for(const e1 in r)t1[e1] = r[e1];
                            return t1;
                        }
                        let v = 1;
                        function x(t1, e1, r) {
                            const n = {};
                            for(const r in t1)n[r] = e1.call(this, t1[r], r, t1);
                            return n;
                        }
                        function _(t1, e1, r) {
                            const n = {};
                            for(const r in t1)e1.call(this, t1[r], r, t1) && (n[r] = t1[r]);
                            return n;
                        }
                        function b(t1) {
                            return Array.isArray(t1) ? t1.map(b) : "object" == typeof t1 && t1 ? x(t1, b) : t1;
                        }
                        const w = {};
                        function T(t1) {
                            w[t1] || ("undefined" != typeof console && console.warn(t1), w[t1] = !0);
                        }
                        function k(t1, e1, r) {
                            return (r.y - t1.y) * (e1.x - t1.x) > (e1.y - t1.y) * (r.x - t1.x);
                        }
                        function A(t1) {
                            return "undefined" != typeof WorkerGlobalScope && void 0 !== t1 && t1 instanceof WorkerGlobalScope;
                        }
                        let M = null;
                        function S(t1) {
                            return "undefined" != typeof ImageBitmap && t1 instanceof ImageBitmap;
                        }
                        const E = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
                        function C(t1, r, n, i, a) {
                            return e1(this, void 0, void 0, function*() {
                                if ("undefined" == typeof VideoFrame) throw new Error("VideoFrame not supported");
                                const e1 = new VideoFrame(t1, {
                                    timestamp: 0
                                });
                                try {
                                    const o = null == e1 ? void 0 : e1.format;
                                    if (!o || !o.startsWith("BGR") && !o.startsWith("RGB")) throw new Error(`Unrecognized format ${o}`);
                                    const s = o.startsWith("BGR"), l = new Uint8ClampedArray(i * a * 4);
                                    if (yield e1.copyTo(l, function(t1, e1, r, n, i) {
                                        const a = 4 * Math.max(-e1, 0), o = (Math.max(0, r) - r) * n * 4 + a, s = 4 * n, l = Math.max(0, e1), c = Math.max(0, r);
                                        return {
                                            rect: {
                                                x: l,
                                                y: c,
                                                width: Math.min(t1.width, e1 + n) - l,
                                                height: Math.min(t1.height, r + i) - c
                                            },
                                            layout: [
                                                {
                                                    offset: o,
                                                    stride: s
                                                }
                                            ]
                                        };
                                    }(t1, r, n, i, a)), s) for(let t1 = 0; t1 < l.length; t1 += 4){
                                        const e1 = l[t1];
                                        l[t1] = l[t1 + 2], l[t1 + 2] = e1;
                                    }
                                    return l;
                                } finally{
                                    e1.close();
                                }
                            });
                        }
                        let L, I;
                        const P = "AbortError";
                        function z() {
                            return new Error(P);
                        }
                        const O = {
                            MAX_PARALLEL_IMAGE_REQUESTS: 16,
                            MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME: 8,
                            MAX_TILE_CACHE_ZOOM_LEVELS: 5,
                            REGISTERED_PROTOCOLS: {},
                            WORKER_URL: ""
                        };
                        function D(t1) {
                            return O.REGISTERED_PROTOCOLS[t1.substring(0, t1.indexOf("://"))];
                        }
                        const R = "global-dispatcher";
                        class F extends Error {
                            constructor(t1, e1, r, n){
                                super(`AJAXError: ${e1} (${t1}): ${r}`), this.status = t1, this.statusText = e1, this.url = r, this.body = n;
                            }
                        }
                        const B = ()=>A(self) ? self.worker && self.worker.referrer : ("blob:" === window.location.protocol ? window.parent : window).location.href;
                        const N = function(t1, r) {
                            if (/:\/\//.test(t1.url) && !/^https?:|^file:/.test(t1.url)) {
                                const e1 = D(t1.url);
                                if (e1) return e1(t1, r);
                                if (A(self) && self.worker && self.worker.actor) return self.worker.actor.sendAsync({
                                    type: "GR",
                                    data: t1,
                                    targetMapId: R
                                }, r);
                            }
                            if (n = t1.url, !(/^file:/.test(n) || /^file:/.test(B()) && !/^\w+:/.test(n))) {
                                if (fetch && Request && AbortController && Object.prototype.hasOwnProperty.call(Request.prototype, "signal")) return function(t1, r) {
                                    return e1(this, void 0, void 0, function*() {
                                        const e1 = new Request(t1.url, {
                                            method: t1.method || "GET",
                                            body: t1.body,
                                            credentials: t1.credentials,
                                            headers: t1.headers,
                                            cache: t1.cache,
                                            referrer: B(),
                                            signal: r.signal
                                        });
                                        "json" !== t1.type || e1.headers.has("Accept") || e1.headers.set("Accept", "application/json");
                                        const n = yield fetch(e1);
                                        if (!n.ok) {
                                            const e1 = yield n.blob();
                                            throw new F(n.status, n.statusText, t1.url, e1);
                                        }
                                        let i;
                                        i = "arrayBuffer" === t1.type || "image" === t1.type ? n.arrayBuffer() : "json" === t1.type ? n.json() : n.text();
                                        const a = yield i;
                                        if (r.signal.aborted) throw z();
                                        return {
                                            data: a,
                                            cacheControl: n.headers.get("Cache-Control"),
                                            expires: n.headers.get("Expires")
                                        };
                                    });
                                }(t1, r);
                                if (A(self) && self.worker && self.worker.actor) return self.worker.actor.sendAsync({
                                    type: "GR",
                                    data: t1,
                                    mustQueue: !0,
                                    targetMapId: R
                                }, r);
                            }
                            var n;
                            return function(t1, e1) {
                                return new Promise((r, n)=>{
                                    var i;
                                    const a = new XMLHttpRequest;
                                    a.open(t1.method || "GET", t1.url, !0), "arrayBuffer" !== t1.type && "image" !== t1.type || (a.responseType = "arraybuffer");
                                    for(const e1 in t1.headers)a.setRequestHeader(e1, t1.headers[e1]);
                                    "json" === t1.type && (a.responseType = "text", (null === (i = t1.headers) || void 0 === i ? void 0 : i.Accept) || a.setRequestHeader("Accept", "application/json")), a.withCredentials = "include" === t1.credentials, a.onerror = ()=>{
                                        n(new Error(a.statusText));
                                    }, a.onload = ()=>{
                                        if (!e1.signal.aborted) {
                                            if ((a.status >= 200 && a.status < 300 || 0 === a.status) && null !== a.response) {
                                                let e1 = a.response;
                                                if ("json" === t1.type) try {
                                                    e1 = JSON.parse(a.response);
                                                } catch (t1) {
                                                    return void n(t1);
                                                }
                                                r({
                                                    data: e1,
                                                    cacheControl: a.getResponseHeader("Cache-Control"),
                                                    expires: a.getResponseHeader("Expires")
                                                });
                                            } else {
                                                const e1 = new Blob([
                                                    a.response
                                                ], {
                                                    type: a.getResponseHeader("Content-Type")
                                                });
                                                n(new F(a.status, a.statusText, t1.url, e1));
                                            }
                                        }
                                    }, e1.signal.addEventListener("abort", ()=>{
                                        a.abort(), n(z());
                                    }), a.send(t1.body);
                                });
                            }(t1, r);
                        };
                        function j(t1) {
                            if (!t1 || t1.indexOf("://") <= 0 || 0 === t1.indexOf("data:image/") || 0 === t1.indexOf("blob:")) return !0;
                            const e1 = new URL(t1), r = window.location;
                            return e1.protocol === r.protocol && e1.host === r.host;
                        }
                        function U(t1, e1, r) {
                            r[t1] && -1 !== r[t1].indexOf(e1) || (r[t1] = r[t1] || [], r[t1].push(e1));
                        }
                        function V(t1, e1, r) {
                            if (r && r[t1]) {
                                const n = r[t1].indexOf(e1);
                                -1 !== n && r[t1].splice(n, 1);
                            }
                        }
                        class q {
                            constructor(t1, e1 = {}){
                                y(this, e1), this.type = t1;
                            }
                        }
                        class H extends q {
                            constructor(t1, e1 = {}){
                                super("error", y({
                                    error: t1
                                }, e1));
                            }
                        }
                        class G {
                            on(t1, e1) {
                                return this._listeners = this._listeners || {}, U(t1, e1, this._listeners), this;
                            }
                            off(t1, e1) {
                                return V(t1, e1, this._listeners), V(t1, e1, this._oneTimeListeners), this;
                            }
                            once(t1, e1) {
                                return e1 ? (this._oneTimeListeners = this._oneTimeListeners || {}, U(t1, e1, this._oneTimeListeners), this) : new Promise((e1)=>this.once(t1, e1));
                            }
                            fire(t1, e1) {
                                "string" == typeof t1 && (t1 = new q(t1, e1 || {}));
                                const r = t1.type;
                                if (this.listens(r)) {
                                    t1.target = this;
                                    const e1 = this._listeners && this._listeners[r] ? this._listeners[r].slice() : [];
                                    for (const r of e1)r.call(this, t1);
                                    const n = this._oneTimeListeners && this._oneTimeListeners[r] ? this._oneTimeListeners[r].slice() : [];
                                    for (const e1 of n)V(r, e1, this._oneTimeListeners), e1.call(this, t1);
                                    const i = this._eventedParent;
                                    i && (y(t1, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), i.fire(t1));
                                } else t1 instanceof H && console.error(t1.error);
                                return this;
                            }
                            listens(t1) {
                                return this._listeners && this._listeners[t1] && this._listeners[t1].length > 0 || this._oneTimeListeners && this._oneTimeListeners[t1] && this._oneTimeListeners[t1].length > 0 || this._eventedParent && this._eventedParent.listens(t1);
                            }
                            setEventedParent(t1, e1) {
                                return this._eventedParent = t1, this._eventedParentData = e1, this;
                            }
                        }
                        var Z = {
                            $version: 8,
                            $root: {
                                version: {
                                    required: !0,
                                    type: "enum",
                                    values: [
                                        8
                                    ]
                                },
                                name: {
                                    type: "string"
                                },
                                metadata: {
                                    type: "*"
                                },
                                center: {
                                    type: "array",
                                    value: "number"
                                },
                                zoom: {
                                    type: "number"
                                },
                                bearing: {
                                    type: "number",
                                    default: 0,
                                    period: 360,
                                    units: "degrees"
                                },
                                pitch: {
                                    type: "number",
                                    default: 0,
                                    units: "degrees"
                                },
                                light: {
                                    type: "light"
                                },
                                sky: {
                                    type: "sky"
                                },
                                projection: {
                                    type: "projection"
                                },
                                terrain: {
                                    type: "terrain"
                                },
                                sources: {
                                    required: !0,
                                    type: "sources"
                                },
                                sprite: {
                                    type: "sprite"
                                },
                                glyphs: {
                                    type: "string"
                                },
                                transition: {
                                    type: "transition"
                                },
                                layers: {
                                    required: !0,
                                    type: "array",
                                    value: "layer"
                                }
                            },
                            sources: {
                                "*": {
                                    type: "source"
                                }
                            },
                            source: [
                                "source_vector",
                                "source_raster",
                                "source_raster_dem",
                                "source_geojson",
                                "source_video",
                                "source_image"
                            ],
                            source_vector: {
                                type: {
                                    required: !0,
                                    type: "enum",
                                    values: {
                                        vector: {}
                                    }
                                },
                                url: {
                                    type: "string"
                                },
                                tiles: {
                                    type: "array",
                                    value: "string"
                                },
                                bounds: {
                                    type: "array",
                                    value: "number",
                                    length: 4,
                                    default: [
                                        -180,
                                        -85.051129,
                                        180,
                                        85.051129
                                    ]
                                },
                                scheme: {
                                    type: "enum",
                                    values: {
                                        xyz: {},
                                        tms: {}
                                    },
                                    default: "xyz"
                                },
                                minzoom: {
                                    type: "number",
                                    default: 0
                                },
                                maxzoom: {
                                    type: "number",
                                    default: 22
                                },
                                attribution: {
                                    type: "string"
                                },
                                promoteId: {
                                    type: "promoteId"
                                },
                                volatile: {
                                    type: "boolean",
                                    default: !1
                                },
                                "*": {
                                    type: "*"
                                }
                            },
                            source_raster: {
                                type: {
                                    required: !0,
                                    type: "enum",
                                    values: {
                                        raster: {}
                                    }
                                },
                                url: {
                                    type: "string"
                                },
                                tiles: {
                                    type: "array",
                                    value: "string"
                                },
                                bounds: {
                                    type: "array",
                                    value: "number",
                                    length: 4,
                                    default: [
                                        -180,
                                        -85.051129,
                                        180,
                                        85.051129
                                    ]
                                },
                                minzoom: {
                                    type: "number",
                                    default: 0
                                },
                                maxzoom: {
                                    type: "number",
                                    default: 22
                                },
                                tileSize: {
                                    type: "number",
                                    default: 512,
                                    units: "pixels"
                                },
                                scheme: {
                                    type: "enum",
                                    values: {
                                        xyz: {},
                                        tms: {}
                                    },
                                    default: "xyz"
                                },
                                attribution: {
                                    type: "string"
                                },
                                volatile: {
                                    type: "boolean",
                                    default: !1
                                },
                                "*": {
                                    type: "*"
                                }
                            },
                            source_raster_dem: {
                                type: {
                                    required: !0,
                                    type: "enum",
                                    values: {
                                        "raster-dem": {}
                                    }
                                },
                                url: {
                                    type: "string"
                                },
                                tiles: {
                                    type: "array",
                                    value: "string"
                                },
                                bounds: {
                                    type: "array",
                                    value: "number",
                                    length: 4,
                                    default: [
                                        -180,
                                        -85.051129,
                                        180,
                                        85.051129
                                    ]
                                },
                                minzoom: {
                                    type: "number",
                                    default: 0
                                },
                                maxzoom: {
                                    type: "number",
                                    default: 22
                                },
                                tileSize: {
                                    type: "number",
                                    default: 512,
                                    units: "pixels"
                                },
                                attribution: {
                                    type: "string"
                                },
                                encoding: {
                                    type: "enum",
                                    values: {
                                        terrarium: {},
                                        mapbox: {},
                                        custom: {}
                                    },
                                    default: "mapbox"
                                },
                                redFactor: {
                                    type: "number",
                                    default: 1
                                },
                                blueFactor: {
                                    type: "number",
                                    default: 1
                                },
                                greenFactor: {
                                    type: "number",
                                    default: 1
                                },
                                baseShift: {
                                    type: "number",
                                    default: 0
                                },
                                volatile: {
                                    type: "boolean",
                                    default: !1
                                },
                                "*": {
                                    type: "*"
                                }
                            },
                            source_geojson: {
                                type: {
                                    required: !0,
                                    type: "enum",
                                    values: {
                                        geojson: {}
                                    }
                                },
                                data: {
                                    required: !0,
                                    type: "*"
                                },
                                maxzoom: {
                                    type: "number",
                                    default: 18
                                },
                                attribution: {
                                    type: "string"
                                },
                                buffer: {
                                    type: "number",
                                    default: 128,
                                    maximum: 512,
                                    minimum: 0
                                },
                                filter: {
                                    type: "*"
                                },
                                tolerance: {
                                    type: "number",
                                    default: .375
                                },
                                cluster: {
                                    type: "boolean",
                                    default: !1
                                },
                                clusterRadius: {
                                    type: "number",
                                    default: 50,
                                    minimum: 0
                                },
                                clusterMaxZoom: {
                                    type: "number"
                                },
                                clusterMinPoints: {
                                    type: "number"
                                },
                                clusterProperties: {
                                    type: "*"
                                },
                                lineMetrics: {
                                    type: "boolean",
                                    default: !1
                                },
                                generateId: {
                                    type: "boolean",
                                    default: !1
                                },
                                promoteId: {
                                    type: "promoteId"
                                }
                            },
                            source_video: {
                                type: {
                                    required: !0,
                                    type: "enum",
                                    values: {
                                        video: {}
                                    }
                                },
                                urls: {
                                    required: !0,
                                    type: "array",
                                    value: "string"
                                },
                                coordinates: {
                                    required: !0,
                                    type: "array",
                                    length: 4,
                                    value: {
                                        type: "array",
                                        length: 2,
                                        value: "number"
                                    }
                                }
                            },
                            source_image: {
                                type: {
                                    required: !0,
                                    type: "enum",
                                    values: {
                                        image: {}
                                    }
                                },
                                url: {
                                    required: !0,
                                    type: "string"
                                },
                                coordinates: {
                                    required: !0,
                                    type: "array",
                                    length: 4,
                                    value: {
                                        type: "array",
                                        length: 2,
                                        value: "number"
                                    }
                                }
                            },
                            layer: {
                                id: {
                                    type: "string",
                                    required: !0
                                },
                                type: {
                                    type: "enum",
                                    values: {
                                        fill: {},
                                        line: {},
                                        symbol: {},
                                        circle: {},
                                        heatmap: {},
                                        "fill-extrusion": {},
                                        raster: {},
                                        hillshade: {},
                                        background: {}
                                    },
                                    required: !0
                                },
                                metadata: {
                                    type: "*"
                                },
                                source: {
                                    type: "string"
                                },
                                "source-layer": {
                                    type: "string"
                                },
                                minzoom: {
                                    type: "number",
                                    minimum: 0,
                                    maximum: 24
                                },
                                maxzoom: {
                                    type: "number",
                                    minimum: 0,
                                    maximum: 24
                                },
                                filter: {
                                    type: "filter"
                                },
                                layout: {
                                    type: "layout"
                                },
                                paint: {
                                    type: "paint"
                                }
                            },
                            layout: [
                                "layout_fill",
                                "layout_line",
                                "layout_circle",
                                "layout_heatmap",
                                "layout_fill-extrusion",
                                "layout_symbol",
                                "layout_raster",
                                "layout_hillshade",
                                "layout_background"
                            ],
                            layout_background: {
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            layout_fill: {
                                "fill-sort-key": {
                                    type: "number",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            layout_circle: {
                                "circle-sort-key": {
                                    type: "number",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            layout_heatmap: {
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            "layout_fill-extrusion": {
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            layout_line: {
                                "line-cap": {
                                    type: "enum",
                                    values: {
                                        butt: {},
                                        round: {},
                                        square: {}
                                    },
                                    default: "butt",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "line-join": {
                                    type: "enum",
                                    values: {
                                        bevel: {},
                                        round: {},
                                        miter: {}
                                    },
                                    default: "miter",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-miter-limit": {
                                    type: "number",
                                    default: 2,
                                    requires: [
                                        {
                                            "line-join": "miter"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "line-round-limit": {
                                    type: "number",
                                    default: 1.05,
                                    requires: [
                                        {
                                            "line-join": "round"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "line-sort-key": {
                                    type: "number",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            layout_symbol: {
                                "symbol-placement": {
                                    type: "enum",
                                    values: {
                                        point: {},
                                        line: {},
                                        "line-center": {}
                                    },
                                    default: "point",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "symbol-spacing": {
                                    type: "number",
                                    default: 250,
                                    minimum: 1,
                                    units: "pixels",
                                    requires: [
                                        {
                                            "symbol-placement": "line"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "symbol-avoid-edges": {
                                    type: "boolean",
                                    default: !1,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "symbol-sort-key": {
                                    type: "number",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "symbol-z-order": {
                                    type: "enum",
                                    values: {
                                        auto: {},
                                        "viewport-y": {},
                                        source: {}
                                    },
                                    default: "auto",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-allow-overlap": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "icon-image",
                                        {
                                            "!": "icon-overlap"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-overlap": {
                                    type: "enum",
                                    values: {
                                        never: {},
                                        always: {},
                                        cooperative: {}
                                    },
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-ignore-placement": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-optional": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "icon-image",
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-rotation-alignment": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {},
                                        auto: {}
                                    },
                                    default: "auto",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-size": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    units: "factor of the original icon size",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-text-fit": {
                                    type: "enum",
                                    values: {
                                        none: {},
                                        width: {},
                                        height: {},
                                        both: {}
                                    },
                                    default: "none",
                                    requires: [
                                        "icon-image",
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-text-fit-padding": {
                                    type: "array",
                                    value: "number",
                                    length: 4,
                                    default: [
                                        0,
                                        0,
                                        0,
                                        0
                                    ],
                                    units: "pixels",
                                    requires: [
                                        "icon-image",
                                        "text-field",
                                        {
                                            "icon-text-fit": [
                                                "both",
                                                "width",
                                                "height"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-image": {
                                    type: "resolvedImage",
                                    tokens: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-rotate": {
                                    type: "number",
                                    default: 0,
                                    period: 360,
                                    units: "degrees",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-padding": {
                                    type: "padding",
                                    default: [
                                        2
                                    ],
                                    units: "pixels",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-keep-upright": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "icon-image",
                                        {
                                            "icon-rotation-alignment": "map"
                                        },
                                        {
                                            "symbol-placement": [
                                                "line",
                                                "line-center"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-offset": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-anchor": {
                                    type: "enum",
                                    values: {
                                        center: {},
                                        left: {},
                                        right: {},
                                        top: {},
                                        bottom: {},
                                        "top-left": {},
                                        "top-right": {},
                                        "bottom-left": {},
                                        "bottom-right": {}
                                    },
                                    default: "center",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-pitch-alignment": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {},
                                        auto: {}
                                    },
                                    default: "auto",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-pitch-alignment": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {},
                                        auto: {}
                                    },
                                    default: "auto",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-rotation-alignment": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {},
                                        "viewport-glyph": {},
                                        auto: {}
                                    },
                                    default: "auto",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-field": {
                                    type: "formatted",
                                    default: "",
                                    tokens: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-font": {
                                    type: "array",
                                    value: "string",
                                    default: [
                                        "Open Sans Regular",
                                        "Arial Unicode MS Regular"
                                    ],
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-size": {
                                    type: "number",
                                    default: 16,
                                    minimum: 0,
                                    units: "pixels",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-max-width": {
                                    type: "number",
                                    default: 10,
                                    minimum: 0,
                                    units: "ems",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-line-height": {
                                    type: "number",
                                    default: 1.2,
                                    units: "ems",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-letter-spacing": {
                                    type: "number",
                                    default: 0,
                                    units: "ems",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-justify": {
                                    type: "enum",
                                    values: {
                                        auto: {},
                                        left: {},
                                        center: {},
                                        right: {}
                                    },
                                    default: "center",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-radial-offset": {
                                    type: "number",
                                    units: "ems",
                                    default: 0,
                                    requires: [
                                        "text-field"
                                    ],
                                    "property-type": "data-driven",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    }
                                },
                                "text-variable-anchor": {
                                    type: "array",
                                    value: "enum",
                                    values: {
                                        center: {},
                                        left: {},
                                        right: {},
                                        top: {},
                                        bottom: {},
                                        "top-left": {},
                                        "top-right": {},
                                        "bottom-left": {},
                                        "bottom-right": {}
                                    },
                                    requires: [
                                        "text-field",
                                        {
                                            "symbol-placement": [
                                                "point"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-variable-anchor-offset": {
                                    type: "variableAnchorOffsetCollection",
                                    requires: [
                                        "text-field",
                                        {
                                            "symbol-placement": [
                                                "point"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-anchor": {
                                    type: "enum",
                                    values: {
                                        center: {},
                                        left: {},
                                        right: {},
                                        top: {},
                                        bottom: {},
                                        "top-left": {},
                                        "top-right": {},
                                        "bottom-left": {},
                                        "bottom-right": {}
                                    },
                                    default: "center",
                                    requires: [
                                        "text-field",
                                        {
                                            "!": "text-variable-anchor"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-max-angle": {
                                    type: "number",
                                    default: 45,
                                    units: "degrees",
                                    requires: [
                                        "text-field",
                                        {
                                            "symbol-placement": [
                                                "line",
                                                "line-center"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-writing-mode": {
                                    type: "array",
                                    value: "enum",
                                    values: {
                                        horizontal: {},
                                        vertical: {}
                                    },
                                    requires: [
                                        "text-field",
                                        {
                                            "symbol-placement": [
                                                "point"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-rotate": {
                                    type: "number",
                                    default: 0,
                                    period: 360,
                                    units: "degrees",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-padding": {
                                    type: "number",
                                    default: 2,
                                    minimum: 0,
                                    units: "pixels",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-keep-upright": {
                                    type: "boolean",
                                    default: !0,
                                    requires: [
                                        "text-field",
                                        {
                                            "text-rotation-alignment": "map"
                                        },
                                        {
                                            "symbol-placement": [
                                                "line",
                                                "line-center"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-transform": {
                                    type: "enum",
                                    values: {
                                        none: {},
                                        uppercase: {},
                                        lowercase: {}
                                    },
                                    default: "none",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-offset": {
                                    type: "array",
                                    value: "number",
                                    units: "ems",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    requires: [
                                        "text-field",
                                        {
                                            "!": "text-radial-offset"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-allow-overlap": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "text-field",
                                        {
                                            "!": "text-overlap"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-overlap": {
                                    type: "enum",
                                    values: {
                                        never: {},
                                        always: {},
                                        cooperative: {}
                                    },
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-ignore-placement": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-optional": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "text-field",
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            layout_raster: {
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            layout_hillshade: {
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            filter: {
                                type: "array",
                                value: "*"
                            },
                            filter_operator: {
                                type: "enum",
                                values: {
                                    "==": {},
                                    "!=": {},
                                    ">": {},
                                    ">=": {},
                                    "<": {},
                                    "<=": {},
                                    in: {},
                                    "!in": {},
                                    all: {},
                                    any: {},
                                    none: {},
                                    has: {},
                                    "!has": {}
                                }
                            },
                            geometry_type: {
                                type: "enum",
                                values: {
                                    Point: {},
                                    LineString: {},
                                    Polygon: {}
                                }
                            },
                            function: {
                                expression: {
                                    type: "expression"
                                },
                                stops: {
                                    type: "array",
                                    value: "function_stop"
                                },
                                base: {
                                    type: "number",
                                    default: 1,
                                    minimum: 0
                                },
                                property: {
                                    type: "string",
                                    default: "$zoom"
                                },
                                type: {
                                    type: "enum",
                                    values: {
                                        identity: {},
                                        exponential: {},
                                        interval: {},
                                        categorical: {}
                                    },
                                    default: "exponential"
                                },
                                colorSpace: {
                                    type: "enum",
                                    values: {
                                        rgb: {},
                                        lab: {},
                                        hcl: {}
                                    },
                                    default: "rgb"
                                },
                                default: {
                                    type: "*",
                                    required: !1
                                }
                            },
                            function_stop: {
                                type: "array",
                                minimum: 0,
                                maximum: 24,
                                value: [
                                    "number",
                                    "color"
                                ],
                                length: 2
                            },
                            expression: {
                                type: "array",
                                value: "*",
                                minimum: 1
                            },
                            light: {
                                anchor: {
                                    type: "enum",
                                    default: "viewport",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    "property-type": "data-constant",
                                    transition: !1,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    }
                                },
                                position: {
                                    type: "array",
                                    default: [
                                        1.15,
                                        210,
                                        30
                                    ],
                                    length: 3,
                                    value: "number",
                                    "property-type": "data-constant",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    }
                                },
                                color: {
                                    type: "color",
                                    "property-type": "data-constant",
                                    default: "#ffffff",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    transition: !0
                                },
                                intensity: {
                                    type: "number",
                                    "property-type": "data-constant",
                                    default: .5,
                                    minimum: 0,
                                    maximum: 1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    transition: !0
                                }
                            },
                            sky: {
                                "sky-color": {
                                    type: "color",
                                    "property-type": "data-constant",
                                    default: "#88C6FC",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    transition: !0
                                },
                                "horizon-color": {
                                    type: "color",
                                    "property-type": "data-constant",
                                    default: "#ffffff",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    transition: !0
                                },
                                "fog-color": {
                                    type: "color",
                                    "property-type": "data-constant",
                                    default: "#ffffff",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    transition: !0
                                },
                                "fog-ground-blend": {
                                    type: "number",
                                    "property-type": "data-constant",
                                    default: .5,
                                    minimum: 0,
                                    maximum: 1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    transition: !0
                                },
                                "horizon-fog-blend": {
                                    type: "number",
                                    "property-type": "data-constant",
                                    default: .8,
                                    minimum: 0,
                                    maximum: 1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    transition: !0
                                },
                                "sky-horizon-blend": {
                                    type: "number",
                                    "property-type": "data-constant",
                                    default: .8,
                                    minimum: 0,
                                    maximum: 1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    transition: !0
                                },
                                "atmosphere-blend": {
                                    type: "number",
                                    "property-type": "data-constant",
                                    default: .8,
                                    minimum: 0,
                                    maximum: 1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    transition: !0
                                }
                            },
                            terrain: {
                                source: {
                                    type: "string",
                                    required: !0
                                },
                                exaggeration: {
                                    type: "number",
                                    minimum: 0,
                                    default: 1
                                }
                            },
                            projection: {
                                type: {
                                    type: "enum",
                                    default: "mercator",
                                    values: {
                                        mercator: {},
                                        globe: {}
                                    }
                                }
                            },
                            paint: [
                                "paint_fill",
                                "paint_line",
                                "paint_circle",
                                "paint_heatmap",
                                "paint_fill-extrusion",
                                "paint_symbol",
                                "paint_raster",
                                "paint_hillshade",
                                "paint_background"
                            ],
                            paint_fill: {
                                "fill-antialias": {
                                    type: "boolean",
                                    default: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "fill-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "fill-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    requires: [
                                        {
                                            "!": "fill-pattern"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "fill-outline-color": {
                                    type: "color",
                                    transition: !0,
                                    requires: [
                                        {
                                            "!": "fill-pattern"
                                        },
                                        {
                                            "fill-antialias": !0
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "fill-translate": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "fill-translate-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    requires: [
                                        "fill-translate"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "fill-pattern": {
                                    type: "resolvedImage",
                                    transition: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "cross-faded-data-driven"
                                }
                            },
                            "paint_fill-extrusion": {
                                "fill-extrusion-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "fill-extrusion-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    requires: [
                                        {
                                            "!": "fill-extrusion-pattern"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "fill-extrusion-translate": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "fill-extrusion-translate-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    requires: [
                                        "fill-extrusion-translate"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "fill-extrusion-pattern": {
                                    type: "resolvedImage",
                                    transition: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "cross-faded-data-driven"
                                },
                                "fill-extrusion-height": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    units: "meters",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "fill-extrusion-base": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    units: "meters",
                                    transition: !0,
                                    requires: [
                                        "fill-extrusion-height"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "fill-extrusion-vertical-gradient": {
                                    type: "boolean",
                                    default: !0,
                                    transition: !1,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            paint_line: {
                                "line-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    requires: [
                                        {
                                            "!": "line-pattern"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-translate": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "line-translate-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    requires: [
                                        "line-translate"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "line-width": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-gap-width": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-offset": {
                                    type: "number",
                                    default: 0,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-blur": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-dasharray": {
                                    type: "array",
                                    value: "number",
                                    minimum: 0,
                                    transition: !0,
                                    units: "line widths",
                                    requires: [
                                        {
                                            "!": "line-pattern"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "cross-faded"
                                },
                                "line-pattern": {
                                    type: "resolvedImage",
                                    transition: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "cross-faded-data-driven"
                                },
                                "line-gradient": {
                                    type: "color",
                                    transition: !1,
                                    requires: [
                                        {
                                            "!": "line-dasharray"
                                        },
                                        {
                                            "!": "line-pattern"
                                        },
                                        {
                                            source: "geojson",
                                            has: {
                                                lineMetrics: !0
                                            }
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "line-progress"
                                        ]
                                    },
                                    "property-type": "color-ramp"
                                }
                            },
                            paint_circle: {
                                "circle-radius": {
                                    type: "number",
                                    default: 5,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "circle-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "circle-blur": {
                                    type: "number",
                                    default: 0,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "circle-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "circle-translate": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "circle-translate-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    requires: [
                                        "circle-translate"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "circle-pitch-scale": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "circle-pitch-alignment": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "viewport",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "circle-stroke-width": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "circle-stroke-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "circle-stroke-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                }
                            },
                            paint_heatmap: {
                                "heatmap-radius": {
                                    type: "number",
                                    default: 30,
                                    minimum: 1,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "heatmap-weight": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    transition: !1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "heatmap-intensity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "heatmap-color": {
                                    type: "color",
                                    default: [
                                        "interpolate",
                                        [
                                            "linear"
                                        ],
                                        [
                                            "heatmap-density"
                                        ],
                                        0,
                                        "rgba(0, 0, 255, 0)",
                                        .1,
                                        "royalblue",
                                        .3,
                                        "cyan",
                                        .5,
                                        "lime",
                                        .7,
                                        "yellow",
                                        1,
                                        "red"
                                    ],
                                    transition: !1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "heatmap-density"
                                        ]
                                    },
                                    "property-type": "color-ramp"
                                },
                                "heatmap-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            paint_symbol: {
                                "icon-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-halo-color": {
                                    type: "color",
                                    default: "rgba(0, 0, 0, 0)",
                                    transition: !0,
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-halo-width": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-halo-blur": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-translate": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    transition: !0,
                                    units: "pixels",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-translate-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    requires: [
                                        "icon-image",
                                        "icon-translate"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    overridable: !0,
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-halo-color": {
                                    type: "color",
                                    default: "rgba(0, 0, 0, 0)",
                                    transition: !0,
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-halo-width": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-halo-blur": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-translate": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    transition: !0,
                                    units: "pixels",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-translate-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    requires: [
                                        "text-field",
                                        "text-translate"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            paint_raster: {
                                "raster-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-hue-rotate": {
                                    type: "number",
                                    default: 0,
                                    period: 360,
                                    transition: !0,
                                    units: "degrees",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-brightness-min": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-brightness-max": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-saturation": {
                                    type: "number",
                                    default: 0,
                                    minimum: -1,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-contrast": {
                                    type: "number",
                                    default: 0,
                                    minimum: -1,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-resampling": {
                                    type: "enum",
                                    values: {
                                        linear: {},
                                        nearest: {}
                                    },
                                    default: "linear",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-fade-duration": {
                                    type: "number",
                                    default: 300,
                                    minimum: 0,
                                    transition: !1,
                                    units: "milliseconds",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            paint_hillshade: {
                                "hillshade-illumination-direction": {
                                    type: "number",
                                    default: 335,
                                    minimum: 0,
                                    maximum: 359,
                                    transition: !1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "hillshade-illumination-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "viewport",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "hillshade-exaggeration": {
                                    type: "number",
                                    default: .5,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "hillshade-shadow-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "hillshade-highlight-color": {
                                    type: "color",
                                    default: "#FFFFFF",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "hillshade-accent-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            paint_background: {
                                "background-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    requires: [
                                        {
                                            "!": "background-pattern"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "background-pattern": {
                                    type: "resolvedImage",
                                    transition: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "cross-faded"
                                },
                                "background-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            transition: {
                                duration: {
                                    type: "number",
                                    default: 300,
                                    minimum: 0,
                                    units: "milliseconds"
                                },
                                delay: {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    units: "milliseconds"
                                }
                            },
                            "property-type": {
                                "data-driven": {
                                    type: "property-type"
                                },
                                "cross-faded": {
                                    type: "property-type"
                                },
                                "cross-faded-data-driven": {
                                    type: "property-type"
                                },
                                "color-ramp": {
                                    type: "property-type"
                                },
                                "data-constant": {
                                    type: "property-type"
                                },
                                constant: {
                                    type: "property-type"
                                }
                            },
                            promoteId: {
                                "*": {
                                    type: "string"
                                }
                            }
                        };
                        const W = [
                            "type",
                            "source",
                            "source-layer",
                            "minzoom",
                            "maxzoom",
                            "filter",
                            "layout"
                        ];
                        function Y(t1, e1) {
                            const r = {};
                            for(const e1 in t1)"ref" !== e1 && (r[e1] = t1[e1]);
                            return W.forEach((t1)=>{
                                t1 in e1 && (r[t1] = e1[t1]);
                            }), r;
                        }
                        function X(t1, e1) {
                            if (Array.isArray(t1)) {
                                if (!Array.isArray(e1) || t1.length !== e1.length) return !1;
                                for(let r = 0; r < t1.length; r++)if (!X(t1[r], e1[r])) return !1;
                                return !0;
                            }
                            if ("object" == typeof t1 && null !== t1 && null !== e1) {
                                if ("object" != typeof e1) return !1;
                                if (Object.keys(t1).length !== Object.keys(e1).length) return !1;
                                for(const r in t1)if (!X(t1[r], e1[r])) return !1;
                                return !0;
                            }
                            return t1 === e1;
                        }
                        function $(t1, e1) {
                            t1.push(e1);
                        }
                        function J(t1, e1, r) {
                            $(r, {
                                command: "addSource",
                                args: [
                                    t1,
                                    e1[t1]
                                ]
                            });
                        }
                        function K(t1, e1, r) {
                            $(e1, {
                                command: "removeSource",
                                args: [
                                    t1
                                ]
                            }), r[t1] = !0;
                        }
                        function Q(t1, e1, r, n) {
                            K(t1, r, n), J(t1, e1, r);
                        }
                        function tt(t1, e1, r) {
                            let n;
                            for(n in t1[r])if (Object.prototype.hasOwnProperty.call(t1[r], n) && "data" !== n && !X(t1[r][n], e1[r][n])) return !1;
                            for(n in e1[r])if (Object.prototype.hasOwnProperty.call(e1[r], n) && "data" !== n && !X(t1[r][n], e1[r][n])) return !1;
                            return !0;
                        }
                        function et(t1, e1, r, n, i, a) {
                            t1 = t1 || {}, e1 = e1 || {};
                            for(const o in t1)Object.prototype.hasOwnProperty.call(t1, o) && (X(t1[o], e1[o]) || r.push({
                                command: a,
                                args: [
                                    n,
                                    o,
                                    e1[o],
                                    i
                                ]
                            }));
                            for(const o in e1)Object.prototype.hasOwnProperty.call(e1, o) && !Object.prototype.hasOwnProperty.call(t1, o) && (X(t1[o], e1[o]) || r.push({
                                command: a,
                                args: [
                                    n,
                                    o,
                                    e1[o],
                                    i
                                ]
                            }));
                        }
                        function rt(t1) {
                            return t1.id;
                        }
                        function nt(t1, e1) {
                            return t1[e1.id] = e1, t1;
                        }
                        class it {
                            constructor(t1, e1, r, n){
                                this.message = (t1 ? `${t1}: ` : "") + r, n && (this.identifier = n), null != e1 && e1.__line__ && (this.line = e1.__line__);
                            }
                        }
                        function at(t1, ...e1) {
                            for (const r of e1)for(const e1 in r)t1[e1] = r[e1];
                            return t1;
                        }
                        class ot extends Error {
                            constructor(t1, e1){
                                super(e1), this.message = e1, this.key = t1;
                            }
                        }
                        class st {
                            constructor(t1, e1 = []){
                                this.parent = t1, this.bindings = {};
                                for (const [t1, r] of e1)this.bindings[t1] = r;
                            }
                            concat(t1) {
                                return new st(this, t1);
                            }
                            get(t1) {
                                if (this.bindings[t1]) return this.bindings[t1];
                                if (this.parent) return this.parent.get(t1);
                                throw new Error(`${t1} not found in scope.`);
                            }
                            has(t1) {
                                return !!this.bindings[t1] || !!this.parent && this.parent.has(t1);
                            }
                        }
                        const lt = {
                            kind: "null"
                        }, ct = {
                            kind: "number"
                        }, ut = {
                            kind: "string"
                        }, ht = {
                            kind: "boolean"
                        }, ft = {
                            kind: "color"
                        }, pt = {
                            kind: "object"
                        }, dt = {
                            kind: "value"
                        }, mt = {
                            kind: "collator"
                        }, gt = {
                            kind: "formatted"
                        }, yt = {
                            kind: "padding"
                        }, vt = {
                            kind: "resolvedImage"
                        }, xt = {
                            kind: "variableAnchorOffsetCollection"
                        };
                        function _t(t1, e1) {
                            return {
                                kind: "array",
                                itemType: t1,
                                N: e1
                            };
                        }
                        function bt(t1) {
                            if ("array" === t1.kind) {
                                const e1 = bt(t1.itemType);
                                return "number" == typeof t1.N ? `array<${e1}, ${t1.N}>` : "value" === t1.itemType.kind ? "array" : `array<${e1}>`;
                            }
                            return t1.kind;
                        }
                        const wt = [
                            lt,
                            ct,
                            ut,
                            ht,
                            ft,
                            gt,
                            pt,
                            _t(dt),
                            yt,
                            vt,
                            xt
                        ];
                        function Tt(t1, e1) {
                            if ("error" === e1.kind) return null;
                            if ("array" === t1.kind) {
                                if ("array" === e1.kind && (0 === e1.N && "value" === e1.itemType.kind || !Tt(t1.itemType, e1.itemType)) && ("number" != typeof t1.N || t1.N === e1.N)) return null;
                            } else {
                                if (t1.kind === e1.kind) return null;
                                if ("value" === t1.kind) {
                                    for (const t1 of wt)if (!Tt(t1, e1)) return null;
                                }
                            }
                            return `Expected ${bt(t1)} but found ${bt(e1)} instead.`;
                        }
                        function kt(t1, e1) {
                            return e1.some((e1)=>e1.kind === t1.kind);
                        }
                        function At(t1, e1) {
                            return e1.some((e1)=>"null" === e1 ? null === t1 : "array" === e1 ? Array.isArray(t1) : "object" === e1 ? t1 && !Array.isArray(t1) && "object" == typeof t1 : e1 === typeof t1);
                        }
                        function Mt(t1, e1) {
                            return "array" === t1.kind && "array" === e1.kind ? t1.itemType.kind === e1.itemType.kind && "number" == typeof t1.N : t1.kind === e1.kind;
                        }
                        const St = .96422, Et = 1, Ct = .82521, Lt = 4 / 29, It = 6 / 29, Pt = 3 * It * It, zt = It * It * It, Ot = Math.PI / 180, Dt = 180 / Math.PI;
                        function Rt(t1) {
                            return (t1 %= 360) < 0 && (t1 += 360), t1;
                        }
                        function Ft([t1, e1, r, n]) {
                            let i, a;
                            const o = Nt((.2225045 * (t1 = Bt(t1)) + .7168786 * (e1 = Bt(e1)) + .0606169 * (r = Bt(r))) / Et);
                            t1 === e1 && e1 === r ? i = a = o : (i = Nt((.4360747 * t1 + .3850649 * e1 + .1430804 * r) / St), a = Nt((.0139322 * t1 + .0971045 * e1 + .7141733 * r) / Ct));
                            const s = 116 * o - 16;
                            return [
                                s < 0 ? 0 : s,
                                500 * (i - o),
                                200 * (o - a),
                                n
                            ];
                        }
                        function Bt(t1) {
                            return t1 <= .04045 ? t1 / 12.92 : Math.pow((t1 + .055) / 1.055, 2.4);
                        }
                        function Nt(t1) {
                            return t1 > zt ? Math.pow(t1, 1 / 3) : t1 / Pt + Lt;
                        }
                        function jt([t1, e1, r, n]) {
                            let i = (t1 + 16) / 116, a = isNaN(e1) ? i : i + e1 / 500, o = isNaN(r) ? i : i - r / 200;
                            return i = Et * Vt(i), a = St * Vt(a), o = Ct * Vt(o), [
                                Ut(3.1338561 * a - 1.6168667 * i - .4906146 * o),
                                Ut(-0.9787684 * a + 1.9161415 * i + .033454 * o),
                                Ut(.0719453 * a - .2289914 * i + 1.4052427 * o),
                                n
                            ];
                        }
                        function Ut(t1) {
                            return (t1 = t1 <= .00304 ? 12.92 * t1 : 1.055 * Math.pow(t1, 1 / 2.4) - .055) < 0 ? 0 : t1 > 1 ? 1 : t1;
                        }
                        function Vt(t1) {
                            return t1 > It ? t1 * t1 * t1 : Pt * (t1 - Lt);
                        }
                        function qt(t1) {
                            if ("transparent" === (t1 = t1.toLowerCase().trim())) return [
                                0,
                                0,
                                0,
                                0
                            ];
                            const e1 = Yt[t1];
                            if (e1) {
                                const [t1, r, n] = e1;
                                return [
                                    t1 / 255,
                                    r / 255,
                                    n / 255,
                                    1
                                ];
                            }
                            if (t1.startsWith("#") && /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/.test(t1)) {
                                const e1 = t1.length < 6 ? 1 : 2;
                                let r = 1;
                                return [
                                    Ht(t1.slice(r, r += e1)),
                                    Ht(t1.slice(r, r += e1)),
                                    Ht(t1.slice(r, r += e1)),
                                    Ht(t1.slice(r, r + e1) || "ff")
                                ];
                            }
                            if (t1.startsWith("rgb")) {
                                const e1 = /^rgba?\(\s*([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/, r = t1.match(e1);
                                if (r) {
                                    const [t1, e1, n, i, a, o, s, l, c, u, h, f] = r, p = [
                                        i || " ",
                                        s || " ",
                                        u
                                    ].join("");
                                    if ("  " === p || "  /" === p || ",," === p || ",,," === p) {
                                        const t1 = [
                                            n,
                                            o,
                                            c
                                        ].join(""), r = "%%%" === t1 ? 100 : "" === t1 ? 255 : 0;
                                        if (r) {
                                            const t1 = [
                                                Zt(+e1 / r, 0, 1),
                                                Zt(+a / r, 0, 1),
                                                Zt(+l / r, 0, 1),
                                                h ? Gt(+h, f) : 1
                                            ];
                                            if (Wt(t1)) return t1;
                                        }
                                    }
                                    return;
                                }
                            }
                            const r = t1.match(/^hsla?\(\s*([\de.+-]+)(?:deg)?(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
                            if (r) {
                                const [t1, e1, n, i, a, o, s, l, c] = r, u = [
                                    n || " ",
                                    a || " ",
                                    s
                                ].join("");
                                if ("  " === u || "  /" === u || ",," === u || ",,," === u) {
                                    const t1 = [
                                        +e1,
                                        Zt(+i, 0, 100),
                                        Zt(+o, 0, 100),
                                        l ? Gt(+l, c) : 1
                                    ];
                                    if (Wt(t1)) return function([t1, e1, r, n]) {
                                        function i(n) {
                                            const i = (n + t1 / 30) % 12, a = e1 * Math.min(r, 1 - r);
                                            return r - a * Math.max(-1, Math.min(i - 3, 9 - i, 1));
                                        }
                                        return t1 = Rt(t1), e1 /= 100, r /= 100, [
                                            i(0),
                                            i(8),
                                            i(4),
                                            n
                                        ];
                                    }(t1);
                                }
                            }
                        }
                        function Ht(t1) {
                            return parseInt(t1.padEnd(2, t1), 16) / 255;
                        }
                        function Gt(t1, e1) {
                            return Zt(e1 ? t1 / 100 : t1, 0, 1);
                        }
                        function Zt(t1, e1, r) {
                            return Math.min(Math.max(e1, t1), r);
                        }
                        function Wt(t1) {
                            return !t1.some(Number.isNaN);
                        }
                        const Yt = {
                            aliceblue: [
                                240,
                                248,
                                255
                            ],
                            antiquewhite: [
                                250,
                                235,
                                215
                            ],
                            aqua: [
                                0,
                                255,
                                255
                            ],
                            aquamarine: [
                                127,
                                255,
                                212
                            ],
                            azure: [
                                240,
                                255,
                                255
                            ],
                            beige: [
                                245,
                                245,
                                220
                            ],
                            bisque: [
                                255,
                                228,
                                196
                            ],
                            black: [
                                0,
                                0,
                                0
                            ],
                            blanchedalmond: [
                                255,
                                235,
                                205
                            ],
                            blue: [
                                0,
                                0,
                                255
                            ],
                            blueviolet: [
                                138,
                                43,
                                226
                            ],
                            brown: [
                                165,
                                42,
                                42
                            ],
                            burlywood: [
                                222,
                                184,
                                135
                            ],
                            cadetblue: [
                                95,
                                158,
                                160
                            ],
                            chartreuse: [
                                127,
                                255,
                                0
                            ],
                            chocolate: [
                                210,
                                105,
                                30
                            ],
                            coral: [
                                255,
                                127,
                                80
                            ],
                            cornflowerblue: [
                                100,
                                149,
                                237
                            ],
                            cornsilk: [
                                255,
                                248,
                                220
                            ],
                            crimson: [
                                220,
                                20,
                                60
                            ],
                            cyan: [
                                0,
                                255,
                                255
                            ],
                            darkblue: [
                                0,
                                0,
                                139
                            ],
                            darkcyan: [
                                0,
                                139,
                                139
                            ],
                            darkgoldenrod: [
                                184,
                                134,
                                11
                            ],
                            darkgray: [
                                169,
                                169,
                                169
                            ],
                            darkgreen: [
                                0,
                                100,
                                0
                            ],
                            darkgrey: [
                                169,
                                169,
                                169
                            ],
                            darkkhaki: [
                                189,
                                183,
                                107
                            ],
                            darkmagenta: [
                                139,
                                0,
                                139
                            ],
                            darkolivegreen: [
                                85,
                                107,
                                47
                            ],
                            darkorange: [
                                255,
                                140,
                                0
                            ],
                            darkorchid: [
                                153,
                                50,
                                204
                            ],
                            darkred: [
                                139,
                                0,
                                0
                            ],
                            darksalmon: [
                                233,
                                150,
                                122
                            ],
                            darkseagreen: [
                                143,
                                188,
                                143
                            ],
                            darkslateblue: [
                                72,
                                61,
                                139
                            ],
                            darkslategray: [
                                47,
                                79,
                                79
                            ],
                            darkslategrey: [
                                47,
                                79,
                                79
                            ],
                            darkturquoise: [
                                0,
                                206,
                                209
                            ],
                            darkviolet: [
                                148,
                                0,
                                211
                            ],
                            deeppink: [
                                255,
                                20,
                                147
                            ],
                            deepskyblue: [
                                0,
                                191,
                                255
                            ],
                            dimgray: [
                                105,
                                105,
                                105
                            ],
                            dimgrey: [
                                105,
                                105,
                                105
                            ],
                            dodgerblue: [
                                30,
                                144,
                                255
                            ],
                            firebrick: [
                                178,
                                34,
                                34
                            ],
                            floralwhite: [
                                255,
                                250,
                                240
                            ],
                            forestgreen: [
                                34,
                                139,
                                34
                            ],
                            fuchsia: [
                                255,
                                0,
                                255
                            ],
                            gainsboro: [
                                220,
                                220,
                                220
                            ],
                            ghostwhite: [
                                248,
                                248,
                                255
                            ],
                            gold: [
                                255,
                                215,
                                0
                            ],
                            goldenrod: [
                                218,
                                165,
                                32
                            ],
                            gray: [
                                128,
                                128,
                                128
                            ],
                            green: [
                                0,
                                128,
                                0
                            ],
                            greenyellow: [
                                173,
                                255,
                                47
                            ],
                            grey: [
                                128,
                                128,
                                128
                            ],
                            honeydew: [
                                240,
                                255,
                                240
                            ],
                            hotpink: [
                                255,
                                105,
                                180
                            ],
                            indianred: [
                                205,
                                92,
                                92
                            ],
                            indigo: [
                                75,
                                0,
                                130
                            ],
                            ivory: [
                                255,
                                255,
                                240
                            ],
                            khaki: [
                                240,
                                230,
                                140
                            ],
                            lavender: [
                                230,
                                230,
                                250
                            ],
                            lavenderblush: [
                                255,
                                240,
                                245
                            ],
                            lawngreen: [
                                124,
                                252,
                                0
                            ],
                            lemonchiffon: [
                                255,
                                250,
                                205
                            ],
                            lightblue: [
                                173,
                                216,
                                230
                            ],
                            lightcoral: [
                                240,
                                128,
                                128
                            ],
                            lightcyan: [
                                224,
                                255,
                                255
                            ],
                            lightgoldenrodyellow: [
                                250,
                                250,
                                210
                            ],
                            lightgray: [
                                211,
                                211,
                                211
                            ],
                            lightgreen: [
                                144,
                                238,
                                144
                            ],
                            lightgrey: [
                                211,
                                211,
                                211
                            ],
                            lightpink: [
                                255,
                                182,
                                193
                            ],
                            lightsalmon: [
                                255,
                                160,
                                122
                            ],
                            lightseagreen: [
                                32,
                                178,
                                170
                            ],
                            lightskyblue: [
                                135,
                                206,
                                250
                            ],
                            lightslategray: [
                                119,
                                136,
                                153
                            ],
                            lightslategrey: [
                                119,
                                136,
                                153
                            ],
                            lightsteelblue: [
                                176,
                                196,
                                222
                            ],
                            lightyellow: [
                                255,
                                255,
                                224
                            ],
                            lime: [
                                0,
                                255,
                                0
                            ],
                            limegreen: [
                                50,
                                205,
                                50
                            ],
                            linen: [
                                250,
                                240,
                                230
                            ],
                            magenta: [
                                255,
                                0,
                                255
                            ],
                            maroon: [
                                128,
                                0,
                                0
                            ],
                            mediumaquamarine: [
                                102,
                                205,
                                170
                            ],
                            mediumblue: [
                                0,
                                0,
                                205
                            ],
                            mediumorchid: [
                                186,
                                85,
                                211
                            ],
                            mediumpurple: [
                                147,
                                112,
                                219
                            ],
                            mediumseagreen: [
                                60,
                                179,
                                113
                            ],
                            mediumslateblue: [
                                123,
                                104,
                                238
                            ],
                            mediumspringgreen: [
                                0,
                                250,
                                154
                            ],
                            mediumturquoise: [
                                72,
                                209,
                                204
                            ],
                            mediumvioletred: [
                                199,
                                21,
                                133
                            ],
                            midnightblue: [
                                25,
                                25,
                                112
                            ],
                            mintcream: [
                                245,
                                255,
                                250
                            ],
                            mistyrose: [
                                255,
                                228,
                                225
                            ],
                            moccasin: [
                                255,
                                228,
                                181
                            ],
                            navajowhite: [
                                255,
                                222,
                                173
                            ],
                            navy: [
                                0,
                                0,
                                128
                            ],
                            oldlace: [
                                253,
                                245,
                                230
                            ],
                            olive: [
                                128,
                                128,
                                0
                            ],
                            olivedrab: [
                                107,
                                142,
                                35
                            ],
                            orange: [
                                255,
                                165,
                                0
                            ],
                            orangered: [
                                255,
                                69,
                                0
                            ],
                            orchid: [
                                218,
                                112,
                                214
                            ],
                            palegoldenrod: [
                                238,
                                232,
                                170
                            ],
                            palegreen: [
                                152,
                                251,
                                152
                            ],
                            paleturquoise: [
                                175,
                                238,
                                238
                            ],
                            palevioletred: [
                                219,
                                112,
                                147
                            ],
                            papayawhip: [
                                255,
                                239,
                                213
                            ],
                            peachpuff: [
                                255,
                                218,
                                185
                            ],
                            peru: [
                                205,
                                133,
                                63
                            ],
                            pink: [
                                255,
                                192,
                                203
                            ],
                            plum: [
                                221,
                                160,
                                221
                            ],
                            powderblue: [
                                176,
                                224,
                                230
                            ],
                            purple: [
                                128,
                                0,
                                128
                            ],
                            rebeccapurple: [
                                102,
                                51,
                                153
                            ],
                            red: [
                                255,
                                0,
                                0
                            ],
                            rosybrown: [
                                188,
                                143,
                                143
                            ],
                            royalblue: [
                                65,
                                105,
                                225
                            ],
                            saddlebrown: [
                                139,
                                69,
                                19
                            ],
                            salmon: [
                                250,
                                128,
                                114
                            ],
                            sandybrown: [
                                244,
                                164,
                                96
                            ],
                            seagreen: [
                                46,
                                139,
                                87
                            ],
                            seashell: [
                                255,
                                245,
                                238
                            ],
                            sienna: [
                                160,
                                82,
                                45
                            ],
                            silver: [
                                192,
                                192,
                                192
                            ],
                            skyblue: [
                                135,
                                206,
                                235
                            ],
                            slateblue: [
                                106,
                                90,
                                205
                            ],
                            slategray: [
                                112,
                                128,
                                144
                            ],
                            slategrey: [
                                112,
                                128,
                                144
                            ],
                            snow: [
                                255,
                                250,
                                250
                            ],
                            springgreen: [
                                0,
                                255,
                                127
                            ],
                            steelblue: [
                                70,
                                130,
                                180
                            ],
                            tan: [
                                210,
                                180,
                                140
                            ],
                            teal: [
                                0,
                                128,
                                128
                            ],
                            thistle: [
                                216,
                                191,
                                216
                            ],
                            tomato: [
                                255,
                                99,
                                71
                            ],
                            turquoise: [
                                64,
                                224,
                                208
                            ],
                            violet: [
                                238,
                                130,
                                238
                            ],
                            wheat: [
                                245,
                                222,
                                179
                            ],
                            white: [
                                255,
                                255,
                                255
                            ],
                            whitesmoke: [
                                245,
                                245,
                                245
                            ],
                            yellow: [
                                255,
                                255,
                                0
                            ],
                            yellowgreen: [
                                154,
                                205,
                                50
                            ]
                        };
                        class Xt {
                            constructor(t1, e1, r, n = 1, i = !0){
                                this.r = t1, this.g = e1, this.b = r, this.a = n, i || (this.r *= n, this.g *= n, this.b *= n, n || this.overwriteGetter("rgb", [
                                    t1,
                                    e1,
                                    r,
                                    n
                                ]));
                            }
                            static parse(t1) {
                                if (t1 instanceof Xt) return t1;
                                if ("string" != typeof t1) return;
                                const e1 = qt(t1);
                                return e1 ? new Xt(...e1, !1) : void 0;
                            }
                            get rgb() {
                                const { r: t1, g: e1, b: r, a: n } = this, i = n || 1 / 0;
                                return this.overwriteGetter("rgb", [
                                    t1 / i,
                                    e1 / i,
                                    r / i,
                                    n
                                ]);
                            }
                            get hcl() {
                                return this.overwriteGetter("hcl", function(t1) {
                                    const [e1, r, n, i] = Ft(t1), a = Math.sqrt(r * r + n * n);
                                    return [
                                        Math.round(1e4 * a) ? Rt(Math.atan2(n, r) * Dt) : NaN,
                                        a,
                                        e1,
                                        i
                                    ];
                                }(this.rgb));
                            }
                            get lab() {
                                return this.overwriteGetter("lab", Ft(this.rgb));
                            }
                            overwriteGetter(t1, e1) {
                                return Object.defineProperty(this, t1, {
                                    value: e1
                                }), e1;
                            }
                            toString() {
                                const [t1, e1, r, n] = this.rgb;
                                return `rgba(${[
                                    t1,
                                    e1,
                                    r
                                ].map((t1)=>Math.round(255 * t1)).join(",")},${n})`;
                            }
                        }
                        Xt.black = new Xt(0, 0, 0, 1), Xt.white = new Xt(1, 1, 1, 1), Xt.transparent = new Xt(0, 0, 0, 0), Xt.red = new Xt(1, 0, 0, 1);
                        class $t {
                            constructor(t1, e1, r){
                                this.sensitivity = t1 ? e1 ? "variant" : "case" : e1 ? "accent" : "base", this.locale = r, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                                    sensitivity: this.sensitivity,
                                    usage: "search"
                                });
                            }
                            compare(t1, e1) {
                                return this.collator.compare(t1, e1);
                            }
                            resolvedLocale() {
                                return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
                            }
                        }
                        class Jt {
                            constructor(t1, e1, r, n, i){
                                this.text = t1, this.image = e1, this.scale = r, this.fontStack = n, this.textColor = i;
                            }
                        }
                        class Kt {
                            constructor(t1){
                                this.sections = t1;
                            }
                            static fromString(t1) {
                                return new Kt([
                                    new Jt(t1, null, null, null, null)
                                ]);
                            }
                            isEmpty() {
                                return 0 === this.sections.length || !this.sections.some((t1)=>0 !== t1.text.length || t1.image && 0 !== t1.image.name.length);
                            }
                            static factory(t1) {
                                return t1 instanceof Kt ? t1 : Kt.fromString(t1);
                            }
                            toString() {
                                return 0 === this.sections.length ? "" : this.sections.map((t1)=>t1.text).join("");
                            }
                        }
                        class Qt {
                            constructor(t1){
                                this.values = t1.slice();
                            }
                            static parse(t1) {
                                if (t1 instanceof Qt) return t1;
                                if ("number" == typeof t1) return new Qt([
                                    t1,
                                    t1,
                                    t1,
                                    t1
                                ]);
                                if (Array.isArray(t1) && !(t1.length < 1 || t1.length > 4)) {
                                    for (const e1 of t1)if ("number" != typeof e1) return;
                                    switch(t1.length){
                                        case 1:
                                            t1 = [
                                                t1[0],
                                                t1[0],
                                                t1[0],
                                                t1[0]
                                            ];
                                            break;
                                        case 2:
                                            t1 = [
                                                t1[0],
                                                t1[1],
                                                t1[0],
                                                t1[1]
                                            ];
                                            break;
                                        case 3:
                                            t1 = [
                                                t1[0],
                                                t1[1],
                                                t1[2],
                                                t1[1]
                                            ];
                                    }
                                    return new Qt(t1);
                                }
                            }
                            toString() {
                                return JSON.stringify(this.values);
                            }
                        }
                        const te = new Set([
                            "center",
                            "left",
                            "right",
                            "top",
                            "bottom",
                            "top-left",
                            "top-right",
                            "bottom-left",
                            "bottom-right"
                        ]);
                        class ee {
                            constructor(t1){
                                this.values = t1.slice();
                            }
                            static parse(t1) {
                                if (t1 instanceof ee) return t1;
                                if (Array.isArray(t1) && !(t1.length < 1) && t1.length % 2 == 0) {
                                    for(let e1 = 0; e1 < t1.length; e1 += 2){
                                        const r = t1[e1], n = t1[e1 + 1];
                                        if ("string" != typeof r || !te.has(r)) return;
                                        if (!Array.isArray(n) || 2 !== n.length || "number" != typeof n[0] || "number" != typeof n[1]) return;
                                    }
                                    return new ee(t1);
                                }
                            }
                            toString() {
                                return JSON.stringify(this.values);
                            }
                        }
                        class re {
                            constructor(t1){
                                this.name = t1.name, this.available = t1.available;
                            }
                            toString() {
                                return this.name;
                            }
                            static fromString(t1) {
                                return t1 ? new re({
                                    name: t1,
                                    available: !1
                                }) : null;
                            }
                        }
                        function ne(t1, e1, r, n) {
                            return "number" == typeof t1 && t1 >= 0 && t1 <= 255 && "number" == typeof e1 && e1 >= 0 && e1 <= 255 && "number" == typeof r && r >= 0 && r <= 255 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : `Invalid rgba value [${[
                                t1,
                                e1,
                                r,
                                n
                            ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${("number" == typeof n ? [
                                t1,
                                e1,
                                r,
                                n
                            ] : [
                                t1,
                                e1,
                                r
                            ]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
                        }
                        function ie(t1) {
                            if (null === t1 || "string" == typeof t1 || "boolean" == typeof t1 || "number" == typeof t1 || t1 instanceof Xt || t1 instanceof $t || t1 instanceof Kt || t1 instanceof Qt || t1 instanceof ee || t1 instanceof re) return !0;
                            if (Array.isArray(t1)) {
                                for (const e1 of t1)if (!ie(e1)) return !1;
                                return !0;
                            }
                            if ("object" == typeof t1) {
                                for(const e1 in t1)if (!ie(t1[e1])) return !1;
                                return !0;
                            }
                            return !1;
                        }
                        function ae(t1) {
                            if (null === t1) return lt;
                            if ("string" == typeof t1) return ut;
                            if ("boolean" == typeof t1) return ht;
                            if ("number" == typeof t1) return ct;
                            if (t1 instanceof Xt) return ft;
                            if (t1 instanceof $t) return mt;
                            if (t1 instanceof Kt) return gt;
                            if (t1 instanceof Qt) return yt;
                            if (t1 instanceof ee) return xt;
                            if (t1 instanceof re) return vt;
                            if (Array.isArray(t1)) {
                                const e1 = t1.length;
                                let r;
                                for (const e1 of t1){
                                    const t1 = ae(e1);
                                    if (r) {
                                        if (r === t1) continue;
                                        r = dt;
                                        break;
                                    }
                                    r = t1;
                                }
                                return _t(r || dt, e1);
                            }
                            return pt;
                        }
                        function oe(t1) {
                            const e1 = typeof t1;
                            return null === t1 ? "" : "string" === e1 || "number" === e1 || "boolean" === e1 ? String(t1) : t1 instanceof Xt || t1 instanceof Kt || t1 instanceof Qt || t1 instanceof ee || t1 instanceof re ? t1.toString() : JSON.stringify(t1);
                        }
                        class se {
                            constructor(t1, e1){
                                this.type = t1, this.value = e1;
                            }
                            static parse(t1, e1) {
                                if (2 !== t1.length) return e1.error(`'literal' expression requires exactly one argument, but found ${t1.length - 1} instead.`);
                                if (!ie(t1[1])) return e1.error("invalid value");
                                const r = t1[1];
                                let n = ae(r);
                                const i = e1.expectedType;
                                return "array" !== n.kind || 0 !== n.N || !i || "array" !== i.kind || "number" == typeof i.N && 0 !== i.N || (n = i), new se(n, r);
                            }
                            evaluate() {
                                return this.value;
                            }
                            eachChild() {}
                            outputDefined() {
                                return !0;
                            }
                        }
                        class le {
                            constructor(t1){
                                this.name = "ExpressionEvaluationError", this.message = t1;
                            }
                            toJSON() {
                                return this.message;
                            }
                        }
                        const ce = {
                            string: ut,
                            number: ct,
                            boolean: ht,
                            object: pt
                        };
                        class ue {
                            constructor(t1, e1){
                                this.type = t1, this.args = e1;
                            }
                            static parse(t1, e1) {
                                if (t1.length < 2) return e1.error("Expected at least one argument.");
                                let r, n = 1;
                                const i = t1[0];
                                if ("array" === i) {
                                    let i, a;
                                    if (t1.length > 2) {
                                        const r = t1[1];
                                        if ("string" != typeof r || !(r in ce) || "object" === r) return e1.error('The item type argument of "array" must be one of string, number, boolean', 1);
                                        i = ce[r], n++;
                                    } else i = dt;
                                    if (t1.length > 3) {
                                        if (null !== t1[2] && ("number" != typeof t1[2] || t1[2] < 0 || t1[2] !== Math.floor(t1[2]))) return e1.error('The length argument to "array" must be a positive integer literal', 2);
                                        a = t1[2], n++;
                                    }
                                    r = _t(i, a);
                                } else {
                                    if (!ce[i]) throw new Error(`Types doesn't contain name = ${i}`);
                                    r = ce[i];
                                }
                                const a = [];
                                for(; n < t1.length; n++){
                                    const r = e1.parse(t1[n], n, dt);
                                    if (!r) return null;
                                    a.push(r);
                                }
                                return new ue(r, a);
                            }
                            evaluate(t1) {
                                for(let e1 = 0; e1 < this.args.length; e1++){
                                    const r = this.args[e1].evaluate(t1);
                                    if (!Tt(this.type, ae(r))) return r;
                                    if (e1 === this.args.length - 1) throw new le(`Expected value to be of type ${bt(this.type)}, but found ${bt(ae(r))} instead.`);
                                }
                                throw new Error;
                            }
                            eachChild(t1) {
                                this.args.forEach(t1);
                            }
                            outputDefined() {
                                return this.args.every((t1)=>t1.outputDefined());
                            }
                        }
                        const he = {
                            "to-boolean": ht,
                            "to-color": ft,
                            "to-number": ct,
                            "to-string": ut
                        };
                        class fe {
                            constructor(t1, e1){
                                this.type = t1, this.args = e1;
                            }
                            static parse(t1, e1) {
                                if (t1.length < 2) return e1.error("Expected at least one argument.");
                                const r = t1[0];
                                if (!he[r]) throw new Error(`Can't parse ${r} as it is not part of the known types`);
                                if (("to-boolean" === r || "to-string" === r) && 2 !== t1.length) return e1.error("Expected one argument.");
                                const n = he[r], i = [];
                                for(let r = 1; r < t1.length; r++){
                                    const n = e1.parse(t1[r], r, dt);
                                    if (!n) return null;
                                    i.push(n);
                                }
                                return new fe(n, i);
                            }
                            evaluate(t1) {
                                switch(this.type.kind){
                                    case "boolean":
                                        return Boolean(this.args[0].evaluate(t1));
                                    case "color":
                                        {
                                            let e1, r;
                                            for (const n of this.args){
                                                if (e1 = n.evaluate(t1), r = null, e1 instanceof Xt) return e1;
                                                if ("string" == typeof e1) {
                                                    const r = t1.parseColor(e1);
                                                    if (r) return r;
                                                } else if (Array.isArray(e1) && (r = e1.length < 3 || e1.length > 4 ? `Invalid rbga value ${JSON.stringify(e1)}: expected an array containing either three or four numeric values.` : ne(e1[0], e1[1], e1[2], e1[3]), !r)) return new Xt(e1[0] / 255, e1[1] / 255, e1[2] / 255, e1[3]);
                                            }
                                            throw new le(r || `Could not parse color from value '${"string" == typeof e1 ? e1 : JSON.stringify(e1)}'`);
                                        }
                                    case "padding":
                                        {
                                            let e1;
                                            for (const r of this.args){
                                                e1 = r.evaluate(t1);
                                                const n = Qt.parse(e1);
                                                if (n) return n;
                                            }
                                            throw new le(`Could not parse padding from value '${"string" == typeof e1 ? e1 : JSON.stringify(e1)}'`);
                                        }
                                    case "variableAnchorOffsetCollection":
                                        {
                                            let e1;
                                            for (const r of this.args){
                                                e1 = r.evaluate(t1);
                                                const n = ee.parse(e1);
                                                if (n) return n;
                                            }
                                            throw new le(`Could not parse variableAnchorOffsetCollection from value '${"string" == typeof e1 ? e1 : JSON.stringify(e1)}'`);
                                        }
                                    case "number":
                                        {
                                            let e1 = null;
                                            for (const r of this.args){
                                                if (e1 = r.evaluate(t1), null === e1) return 0;
                                                const n = Number(e1);
                                                if (!isNaN(n)) return n;
                                            }
                                            throw new le(`Could not convert ${JSON.stringify(e1)} to number.`);
                                        }
                                    case "formatted":
                                        return Kt.fromString(oe(this.args[0].evaluate(t1)));
                                    case "resolvedImage":
                                        return re.fromString(oe(this.args[0].evaluate(t1)));
                                    default:
                                        return oe(this.args[0].evaluate(t1));
                                }
                            }
                            eachChild(t1) {
                                this.args.forEach(t1);
                            }
                            outputDefined() {
                                return this.args.every((t1)=>t1.outputDefined());
                            }
                        }
                        const pe = [
                            "Unknown",
                            "Point",
                            "LineString",
                            "Polygon"
                        ];
                        class de {
                            constructor(){
                                this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null;
                            }
                            id() {
                                return this.feature && "id" in this.feature ? this.feature.id : null;
                            }
                            geometryType() {
                                return this.feature ? "number" == typeof this.feature.type ? pe[this.feature.type] : this.feature.type : null;
                            }
                            geometry() {
                                return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
                            }
                            canonicalID() {
                                return this.canonical;
                            }
                            properties() {
                                return this.feature && this.feature.properties || {};
                            }
                            parseColor(t1) {
                                let e1 = this._parseColorCache[t1];
                                return e1 || (e1 = this._parseColorCache[t1] = Xt.parse(t1)), e1;
                            }
                        }
                        class me {
                            constructor(t1, e1, r = [], n, i = new st, a = []){
                                this.registry = t1, this.path = r, this.key = r.map((t1)=>`[${t1}]`).join(""), this.scope = i, this.errors = a, this.expectedType = n, this._isConstant = e1;
                            }
                            parse(t1, e1, r, n, i = {}) {
                                return e1 ? this.concat(e1, r, n)._parse(t1, i) : this._parse(t1, i);
                            }
                            _parse(t1, e1) {
                                function r(t1, e1, r) {
                                    return "assert" === r ? new ue(e1, [
                                        t1
                                    ]) : "coerce" === r ? new fe(e1, [
                                        t1
                                    ]) : t1;
                                }
                                if (null !== t1 && "string" != typeof t1 && "boolean" != typeof t1 && "number" != typeof t1 || (t1 = [
                                    "literal",
                                    t1
                                ]), Array.isArray(t1)) {
                                    if (0 === t1.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                                    const n = t1[0];
                                    if ("string" != typeof n) return this.error(`Expression name must be a string, but found ${typeof n} instead. If you wanted a literal array, use ["literal", [...]].`, 0), null;
                                    const i = this.registry[n];
                                    if (i) {
                                        let n = i.parse(t1, this);
                                        if (!n) return null;
                                        if (this.expectedType) {
                                            const t1 = this.expectedType, i = n.type;
                                            if ("string" !== t1.kind && "number" !== t1.kind && "boolean" !== t1.kind && "object" !== t1.kind && "array" !== t1.kind || "value" !== i.kind) {
                                                if ("color" !== t1.kind && "formatted" !== t1.kind && "resolvedImage" !== t1.kind || "value" !== i.kind && "string" !== i.kind) {
                                                    if ("padding" !== t1.kind || "value" !== i.kind && "number" !== i.kind && "array" !== i.kind) {
                                                        if ("variableAnchorOffsetCollection" !== t1.kind || "value" !== i.kind && "array" !== i.kind) {
                                                            if (this.checkSubtype(t1, i)) return null;
                                                        } else n = r(n, t1, e1.typeAnnotation || "coerce");
                                                    } else n = r(n, t1, e1.typeAnnotation || "coerce");
                                                } else n = r(n, t1, e1.typeAnnotation || "coerce");
                                            } else n = r(n, t1, e1.typeAnnotation || "assert");
                                        }
                                        if (!(n instanceof se) && "resolvedImage" !== n.type.kind && this._isConstant(n)) {
                                            const t1 = new de;
                                            try {
                                                n = new se(n.type, n.evaluate(t1));
                                            } catch (t1) {
                                                return this.error(t1.message), null;
                                            }
                                        }
                                        return n;
                                    }
                                    return this.error(`Unknown expression "${n}". If you wanted a literal array, use ["literal", [...]].`, 0);
                                }
                                return void 0 === t1 ? this.error("'undefined' value invalid. Use null instead.") : "object" == typeof t1 ? this.error('Bare objects invalid. Use ["literal", {...}] instead.') : this.error(`Expected an array, but found ${typeof t1} instead.`);
                            }
                            concat(t1, e1, r) {
                                const n = "number" == typeof t1 ? this.path.concat(t1) : this.path, i = r ? this.scope.concat(r) : this.scope;
                                return new me(this.registry, this._isConstant, n, e1 || null, i, this.errors);
                            }
                            error(t1, ...e1) {
                                const r = `${this.key}${e1.map((t1)=>`[${t1}]`).join("")}`;
                                this.errors.push(new ot(r, t1));
                            }
                            checkSubtype(t1, e1) {
                                const r = Tt(t1, e1);
                                return r && this.error(r), r;
                            }
                        }
                        class ge {
                            constructor(t1, e1){
                                this.type = e1.type, this.bindings = [].concat(t1), this.result = e1;
                            }
                            evaluate(t1) {
                                return this.result.evaluate(t1);
                            }
                            eachChild(t1) {
                                for (const e1 of this.bindings)t1(e1[1]);
                                t1(this.result);
                            }
                            static parse(t1, e1) {
                                if (t1.length < 4) return e1.error(`Expected at least 3 arguments, but found ${t1.length - 1} instead.`);
                                const r = [];
                                for(let n = 1; n < t1.length - 1; n += 2){
                                    const i = t1[n];
                                    if ("string" != typeof i) return e1.error(`Expected string, but found ${typeof i} instead.`, n);
                                    if (/[^a-zA-Z0-9_]/.test(i)) return e1.error("Variable names must contain only alphanumeric characters or '_'.", n);
                                    const a = e1.parse(t1[n + 1], n + 1);
                                    if (!a) return null;
                                    r.push([
                                        i,
                                        a
                                    ]);
                                }
                                const n = e1.parse(t1[t1.length - 1], t1.length - 1, e1.expectedType, r);
                                return n ? new ge(r, n) : null;
                            }
                            outputDefined() {
                                return this.result.outputDefined();
                            }
                        }
                        class ye {
                            constructor(t1, e1){
                                this.type = e1.type, this.name = t1, this.boundExpression = e1;
                            }
                            static parse(t1, e1) {
                                if (2 !== t1.length || "string" != typeof t1[1]) return e1.error("'var' expression requires exactly one string literal argument.");
                                const r = t1[1];
                                return e1.scope.has(r) ? new ye(r, e1.scope.get(r)) : e1.error(`Unknown variable "${r}". Make sure "${r}" has been bound in an enclosing "let" expression before using it.`, 1);
                            }
                            evaluate(t1) {
                                return this.boundExpression.evaluate(t1);
                            }
                            eachChild() {}
                            outputDefined() {
                                return !1;
                            }
                        }
                        class ve {
                            constructor(t1, e1, r){
                                this.type = t1, this.index = e1, this.input = r;
                            }
                            static parse(t1, e1) {
                                if (3 !== t1.length) return e1.error(`Expected 2 arguments, but found ${t1.length - 1} instead.`);
                                const r = e1.parse(t1[1], 1, ct), n = e1.parse(t1[2], 2, _t(e1.expectedType || dt));
                                if (!r || !n) return null;
                                const i = n.type;
                                return new ve(i.itemType, r, n);
                            }
                            evaluate(t1) {
                                const e1 = this.index.evaluate(t1), r = this.input.evaluate(t1);
                                if (e1 < 0) throw new le(`Array index out of bounds: ${e1} < 0.`);
                                if (e1 >= r.length) throw new le(`Array index out of bounds: ${e1} > ${r.length - 1}.`);
                                if (e1 !== Math.floor(e1)) throw new le(`Array index must be an integer, but found ${e1} instead.`);
                                return r[e1];
                            }
                            eachChild(t1) {
                                t1(this.index), t1(this.input);
                            }
                            outputDefined() {
                                return !1;
                            }
                        }
                        class xe {
                            constructor(t1, e1){
                                this.type = ht, this.needle = t1, this.haystack = e1;
                            }
                            static parse(t1, e1) {
                                if (3 !== t1.length) return e1.error(`Expected 2 arguments, but found ${t1.length - 1} instead.`);
                                const r = e1.parse(t1[1], 1, dt), n = e1.parse(t1[2], 2, dt);
                                return r && n ? kt(r.type, [
                                    ht,
                                    ut,
                                    ct,
                                    lt,
                                    dt
                                ]) ? new xe(r, n) : e1.error(`Expected first argument to be of type boolean, string, number or null, but found ${bt(r.type)} instead`) : null;
                            }
                            evaluate(t1) {
                                const e1 = this.needle.evaluate(t1), r = this.haystack.evaluate(t1);
                                if (!r) return !1;
                                if (!At(e1, [
                                    "boolean",
                                    "string",
                                    "number",
                                    "null"
                                ])) throw new le(`Expected first argument to be of type boolean, string, number or null, but found ${bt(ae(e1))} instead.`);
                                if (!At(r, [
                                    "string",
                                    "array"
                                ])) throw new le(`Expected second argument to be of type array or string, but found ${bt(ae(r))} instead.`);
                                return r.indexOf(e1) >= 0;
                            }
                            eachChild(t1) {
                                t1(this.needle), t1(this.haystack);
                            }
                            outputDefined() {
                                return !0;
                            }
                        }
                        class _e {
                            constructor(t1, e1, r){
                                this.type = ct, this.needle = t1, this.haystack = e1, this.fromIndex = r;
                            }
                            static parse(t1, e1) {
                                if (t1.length <= 2 || t1.length >= 5) return e1.error(`Expected 3 or 4 arguments, but found ${t1.length - 1} instead.`);
                                const r = e1.parse(t1[1], 1, dt), n = e1.parse(t1[2], 2, dt);
                                if (!r || !n) return null;
                                if (!kt(r.type, [
                                    ht,
                                    ut,
                                    ct,
                                    lt,
                                    dt
                                ])) return e1.error(`Expected first argument to be of type boolean, string, number or null, but found ${bt(r.type)} instead`);
                                if (4 === t1.length) {
                                    const i = e1.parse(t1[3], 3, ct);
                                    return i ? new _e(r, n, i) : null;
                                }
                                return new _e(r, n);
                            }
                            evaluate(t1) {
                                const e1 = this.needle.evaluate(t1), r = this.haystack.evaluate(t1);
                                if (!At(e1, [
                                    "boolean",
                                    "string",
                                    "number",
                                    "null"
                                ])) throw new le(`Expected first argument to be of type boolean, string, number or null, but found ${bt(ae(e1))} instead.`);
                                if (!At(r, [
                                    "string",
                                    "array"
                                ])) throw new le(`Expected second argument to be of type array or string, but found ${bt(ae(r))} instead.`);
                                if (this.fromIndex) {
                                    const n = this.fromIndex.evaluate(t1);
                                    return r.indexOf(e1, n);
                                }
                                return r.indexOf(e1);
                            }
                            eachChild(t1) {
                                t1(this.needle), t1(this.haystack), this.fromIndex && t1(this.fromIndex);
                            }
                            outputDefined() {
                                return !1;
                            }
                        }
                        class be {
                            constructor(t1, e1, r, n, i, a){
                                this.inputType = t1, this.type = e1, this.input = r, this.cases = n, this.outputs = i, this.otherwise = a;
                            }
                            static parse(t1, e1) {
                                if (t1.length < 5) return e1.error(`Expected at least 4 arguments, but found only ${t1.length - 1}.`);
                                if (t1.length % 2 != 1) return e1.error("Expected an even number of arguments.");
                                let r, n;
                                e1.expectedType && "value" !== e1.expectedType.kind && (n = e1.expectedType);
                                const i = {}, a = [];
                                for(let o = 2; o < t1.length - 1; o += 2){
                                    let s = t1[o];
                                    const l = t1[o + 1];
                                    Array.isArray(s) || (s = [
                                        s
                                    ]);
                                    const c = e1.concat(o);
                                    if (0 === s.length) return c.error("Expected at least one branch label.");
                                    for (const t1 of s){
                                        if ("number" != typeof t1 && "string" != typeof t1) return c.error("Branch labels must be numbers or strings.");
                                        if ("number" == typeof t1 && Math.abs(t1) > Number.MAX_SAFE_INTEGER) return c.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
                                        if ("number" == typeof t1 && Math.floor(t1) !== t1) return c.error("Numeric branch labels must be integer values.");
                                        if (r) {
                                            if (c.checkSubtype(r, ae(t1))) return null;
                                        } else r = ae(t1);
                                        if (void 0 !== i[String(t1)]) return c.error("Branch labels must be unique.");
                                        i[String(t1)] = a.length;
                                    }
                                    const u = e1.parse(l, o, n);
                                    if (!u) return null;
                                    n = n || u.type, a.push(u);
                                }
                                const o = e1.parse(t1[1], 1, dt);
                                if (!o) return null;
                                const s = e1.parse(t1[t1.length - 1], t1.length - 1, n);
                                return s ? "value" !== o.type.kind && e1.concat(1).checkSubtype(r, o.type) ? null : new be(r, n, o, i, a, s) : null;
                            }
                            evaluate(t1) {
                                const e1 = this.input.evaluate(t1);
                                return (ae(e1) === this.inputType && this.outputs[this.cases[e1]] || this.otherwise).evaluate(t1);
                            }
                            eachChild(t1) {
                                t1(this.input), this.outputs.forEach(t1), t1(this.otherwise);
                            }
                            outputDefined() {
                                return this.outputs.every((t1)=>t1.outputDefined()) && this.otherwise.outputDefined();
                            }
                        }
                        class we {
                            constructor(t1, e1, r){
                                this.type = t1, this.branches = e1, this.otherwise = r;
                            }
                            static parse(t1, e1) {
                                if (t1.length < 4) return e1.error(`Expected at least 3 arguments, but found only ${t1.length - 1}.`);
                                if (t1.length % 2 != 0) return e1.error("Expected an odd number of arguments.");
                                let r;
                                e1.expectedType && "value" !== e1.expectedType.kind && (r = e1.expectedType);
                                const n = [];
                                for(let i = 1; i < t1.length - 1; i += 2){
                                    const a = e1.parse(t1[i], i, ht);
                                    if (!a) return null;
                                    const o = e1.parse(t1[i + 1], i + 1, r);
                                    if (!o) return null;
                                    n.push([
                                        a,
                                        o
                                    ]), r = r || o.type;
                                }
                                const i = e1.parse(t1[t1.length - 1], t1.length - 1, r);
                                if (!i) return null;
                                if (!r) throw new Error("Can't infer output type");
                                return new we(r, n, i);
                            }
                            evaluate(t1) {
                                for (const [e1, r] of this.branches)if (e1.evaluate(t1)) return r.evaluate(t1);
                                return this.otherwise.evaluate(t1);
                            }
                            eachChild(t1) {
                                for (const [e1, r] of this.branches)t1(e1), t1(r);
                                t1(this.otherwise);
                            }
                            outputDefined() {
                                return this.branches.every(([t1, e1])=>e1.outputDefined()) && this.otherwise.outputDefined();
                            }
                        }
                        class Te {
                            constructor(t1, e1, r, n){
                                this.type = t1, this.input = e1, this.beginIndex = r, this.endIndex = n;
                            }
                            static parse(t1, e1) {
                                if (t1.length <= 2 || t1.length >= 5) return e1.error(`Expected 3 or 4 arguments, but found ${t1.length - 1} instead.`);
                                const r = e1.parse(t1[1], 1, dt), n = e1.parse(t1[2], 2, ct);
                                if (!r || !n) return null;
                                if (!kt(r.type, [
                                    _t(dt),
                                    ut,
                                    dt
                                ])) return e1.error(`Expected first argument to be of type array or string, but found ${bt(r.type)} instead`);
                                if (4 === t1.length) {
                                    const i = e1.parse(t1[3], 3, ct);
                                    return i ? new Te(r.type, r, n, i) : null;
                                }
                                return new Te(r.type, r, n);
                            }
                            evaluate(t1) {
                                const e1 = this.input.evaluate(t1), r = this.beginIndex.evaluate(t1);
                                if (!At(e1, [
                                    "string",
                                    "array"
                                ])) throw new le(`Expected first argument to be of type array or string, but found ${bt(ae(e1))} instead.`);
                                if (this.endIndex) {
                                    const n = this.endIndex.evaluate(t1);
                                    return e1.slice(r, n);
                                }
                                return e1.slice(r);
                            }
                            eachChild(t1) {
                                t1(this.input), t1(this.beginIndex), this.endIndex && t1(this.endIndex);
                            }
                            outputDefined() {
                                return !1;
                            }
                        }
                        function ke(t1, e1) {
                            const r = t1.length - 1;
                            let n, i, a = 0, o = r, s = 0;
                            for(; a <= o;)if (s = Math.floor((a + o) / 2), n = t1[s], i = t1[s + 1], n <= e1) {
                                if (s === r || e1 < i) return s;
                                a = s + 1;
                            } else {
                                if (!(n > e1)) throw new le("Input is not a number.");
                                o = s - 1;
                            }
                            return 0;
                        }
                        class Ae {
                            constructor(t1, e1, r){
                                this.type = t1, this.input = e1, this.labels = [], this.outputs = [];
                                for (const [t1, e1] of r)this.labels.push(t1), this.outputs.push(e1);
                            }
                            static parse(t1, e1) {
                                if (t1.length - 1 < 4) return e1.error(`Expected at least 4 arguments, but found only ${t1.length - 1}.`);
                                if ((t1.length - 1) % 2 != 0) return e1.error("Expected an even number of arguments.");
                                const r = e1.parse(t1[1], 1, ct);
                                if (!r) return null;
                                const n = [];
                                let i = null;
                                e1.expectedType && "value" !== e1.expectedType.kind && (i = e1.expectedType);
                                for(let r = 1; r < t1.length; r += 2){
                                    const a = 1 === r ? -1 / 0 : t1[r], o = t1[r + 1], s = r, l = r + 1;
                                    if ("number" != typeof a) return e1.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', s);
                                    if (n.length && n[n.length - 1][0] >= a) return e1.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', s);
                                    const c = e1.parse(o, l, i);
                                    if (!c) return null;
                                    i = i || c.type, n.push([
                                        a,
                                        c
                                    ]);
                                }
                                return new Ae(i, r, n);
                            }
                            evaluate(t1) {
                                const e1 = this.labels, r = this.outputs;
                                if (1 === e1.length) return r[0].evaluate(t1);
                                const n = this.input.evaluate(t1);
                                if (n <= e1[0]) return r[0].evaluate(t1);
                                const i = e1.length;
                                return n >= e1[i - 1] ? r[i - 1].evaluate(t1) : r[ke(e1, n)].evaluate(t1);
                            }
                            eachChild(t1) {
                                t1(this.input);
                                for (const e1 of this.outputs)t1(e1);
                            }
                            outputDefined() {
                                return this.outputs.every((t1)=>t1.outputDefined());
                            }
                        }
                        function Me(t1) {
                            return t1 && t1.__esModule && Object.prototype.hasOwnProperty.call(t1, "default") ? t1.default : t1;
                        }
                        var Se = Ee;
                        function Ee(t1, e1, r, n) {
                            this.cx = 3 * t1, this.bx = 3 * (r - t1) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * e1, this.by = 3 * (n - e1) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = t1, this.p1y = e1, this.p2x = r, this.p2y = n;
                        }
                        Ee.prototype = {
                            sampleCurveX: function(t1) {
                                return ((this.ax * t1 + this.bx) * t1 + this.cx) * t1;
                            },
                            sampleCurveY: function(t1) {
                                return ((this.ay * t1 + this.by) * t1 + this.cy) * t1;
                            },
                            sampleCurveDerivativeX: function(t1) {
                                return (3 * this.ax * t1 + 2 * this.bx) * t1 + this.cx;
                            },
                            solveCurveX: function(t1, e1) {
                                if (void 0 === e1 && (e1 = 1e-6), t1 < 0) return 0;
                                if (t1 > 1) return 1;
                                for(var r = t1, n = 0; n < 8; n++){
                                    var i = this.sampleCurveX(r) - t1;
                                    if (Math.abs(i) < e1) return r;
                                    var a = this.sampleCurveDerivativeX(r);
                                    if (Math.abs(a) < 1e-6) break;
                                    r -= i / a;
                                }
                                var o = 0, s = 1;
                                for(r = t1, n = 0; n < 20 && (i = this.sampleCurveX(r), !(Math.abs(i - t1) < e1)); n++)t1 > i ? o = r : s = r, r = .5 * (s - o) + o;
                                return r;
                            },
                            solve: function(t1, e1) {
                                return this.sampleCurveY(this.solveCurveX(t1, e1));
                            }
                        };
                        var Ce = Me(Se);
                        function Le(t1, e1, r) {
                            return t1 + r * (e1 - t1);
                        }
                        function Ie(t1, e1, r) {
                            return t1.map((t1, n)=>Le(t1, e1[n], r));
                        }
                        const Pe = {
                            number: Le,
                            color: function(t1, e1, r, n = "rgb") {
                                switch(n){
                                    case "rgb":
                                        {
                                            const [n, i, a, o] = Ie(t1.rgb, e1.rgb, r);
                                            return new Xt(n, i, a, o, !1);
                                        }
                                    case "hcl":
                                        {
                                            const [n, i, a, o] = t1.hcl, [s, l, c, u] = e1.hcl;
                                            let h, f;
                                            if (isNaN(n) || isNaN(s)) isNaN(n) ? isNaN(s) ? h = NaN : (h = s, 1 !== a && 0 !== a || (f = l)) : (h = n, 1 !== c && 0 !== c || (f = i));
                                            else {
                                                let t1 = s - n;
                                                s > n && t1 > 180 ? t1 -= 360 : s < n && n - s > 180 && (t1 += 360), h = n + r * t1;
                                            }
                                            const [p, d, m, g] = function([t1, e1, r, n]) {
                                                return t1 = isNaN(t1) ? 0 : t1 * Ot, jt([
                                                    r,
                                                    Math.cos(t1) * e1,
                                                    Math.sin(t1) * e1,
                                                    n
                                                ]);
                                            }([
                                                h,
                                                null != f ? f : Le(i, l, r),
                                                Le(a, c, r),
                                                Le(o, u, r)
                                            ]);
                                            return new Xt(p, d, m, g, !1);
                                        }
                                    case "lab":
                                        {
                                            const [n, i, a, o] = jt(Ie(t1.lab, e1.lab, r));
                                            return new Xt(n, i, a, o, !1);
                                        }
                                }
                            },
                            array: Ie,
                            padding: function(t1, e1, r) {
                                return new Qt(Ie(t1.values, e1.values, r));
                            },
                            variableAnchorOffsetCollection: function(t1, e1, r) {
                                const n = t1.values, i = e1.values;
                                if (n.length !== i.length) throw new le(`Cannot interpolate values of different length. from: ${t1.toString()}, to: ${e1.toString()}`);
                                const a = [];
                                for(let t1 = 0; t1 < n.length; t1 += 2){
                                    if (n[t1] !== i[t1]) throw new le(`Cannot interpolate values containing mismatched anchors. from[${t1}]: ${n[t1]}, to[${t1}]: ${i[t1]}`);
                                    a.push(n[t1]);
                                    const [e1, o] = n[t1 + 1], [s, l] = i[t1 + 1];
                                    a.push([
                                        Le(e1, s, r),
                                        Le(o, l, r)
                                    ]);
                                }
                                return new ee(a);
                            }
                        };
                        class ze {
                            constructor(t1, e1, r, n, i){
                                this.type = t1, this.operator = e1, this.interpolation = r, this.input = n, this.labels = [], this.outputs = [];
                                for (const [t1, e1] of i)this.labels.push(t1), this.outputs.push(e1);
                            }
                            static interpolationFactor(t1, e1, r, n) {
                                let i = 0;
                                if ("exponential" === t1.name) i = Oe(e1, t1.base, r, n);
                                else if ("linear" === t1.name) i = Oe(e1, 1, r, n);
                                else if ("cubic-bezier" === t1.name) {
                                    const a = t1.controlPoints;
                                    i = new Ce(a[0], a[1], a[2], a[3]).solve(Oe(e1, 1, r, n));
                                }
                                return i;
                            }
                            static parse(t1, e1) {
                                let [r, n, i, ...a] = t1;
                                if (!Array.isArray(n) || 0 === n.length) return e1.error("Expected an interpolation type expression.", 1);
                                if ("linear" === n[0]) n = {
                                    name: "linear"
                                };
                                else if ("exponential" === n[0]) {
                                    const t1 = n[1];
                                    if ("number" != typeof t1) return e1.error("Exponential interpolation requires a numeric base.", 1, 1);
                                    n = {
                                        name: "exponential",
                                        base: t1
                                    };
                                } else {
                                    if ("cubic-bezier" !== n[0]) return e1.error(`Unknown interpolation type ${String(n[0])}`, 1, 0);
                                    {
                                        const t1 = n.slice(1);
                                        if (4 !== t1.length || t1.some((t1)=>"number" != typeof t1 || t1 < 0 || t1 > 1)) return e1.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                                        n = {
                                            name: "cubic-bezier",
                                            controlPoints: t1
                                        };
                                    }
                                }
                                if (t1.length - 1 < 4) return e1.error(`Expected at least 4 arguments, but found only ${t1.length - 1}.`);
                                if ((t1.length - 1) % 2 != 0) return e1.error("Expected an even number of arguments.");
                                if (i = e1.parse(i, 2, ct), !i) return null;
                                const o = [];
                                let s = null;
                                "interpolate-hcl" === r || "interpolate-lab" === r ? s = ft : e1.expectedType && "value" !== e1.expectedType.kind && (s = e1.expectedType);
                                for(let t1 = 0; t1 < a.length; t1 += 2){
                                    const r = a[t1], n = a[t1 + 1], i = t1 + 3, l = t1 + 4;
                                    if ("number" != typeof r) return e1.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', i);
                                    if (o.length && o[o.length - 1][0] >= r) return e1.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', i);
                                    const c = e1.parse(n, l, s);
                                    if (!c) return null;
                                    s = s || c.type, o.push([
                                        r,
                                        c
                                    ]);
                                }
                                return Mt(s, ct) || Mt(s, ft) || Mt(s, yt) || Mt(s, xt) || Mt(s, _t(ct)) ? new ze(s, r, n, i, o) : e1.error(`Type ${bt(s)} is not interpolatable.`);
                            }
                            evaluate(t1) {
                                const e1 = this.labels, r = this.outputs;
                                if (1 === e1.length) return r[0].evaluate(t1);
                                const n = this.input.evaluate(t1);
                                if (n <= e1[0]) return r[0].evaluate(t1);
                                const i = e1.length;
                                if (n >= e1[i - 1]) return r[i - 1].evaluate(t1);
                                const a = ke(e1, n), o = e1[a], s = e1[a + 1], l = ze.interpolationFactor(this.interpolation, n, o, s), c = r[a].evaluate(t1), u = r[a + 1].evaluate(t1);
                                switch(this.operator){
                                    case "interpolate":
                                        return Pe[this.type.kind](c, u, l);
                                    case "interpolate-hcl":
                                        return Pe.color(c, u, l, "hcl");
                                    case "interpolate-lab":
                                        return Pe.color(c, u, l, "lab");
                                }
                            }
                            eachChild(t1) {
                                t1(this.input);
                                for (const e1 of this.outputs)t1(e1);
                            }
                            outputDefined() {
                                return this.outputs.every((t1)=>t1.outputDefined());
                            }
                        }
                        function Oe(t1, e1, r, n) {
                            const i = n - r, a = t1 - r;
                            return 0 === i ? 0 : 1 === e1 ? a / i : (Math.pow(e1, a) - 1) / (Math.pow(e1, i) - 1);
                        }
                        class De {
                            constructor(t1, e1){
                                this.type = t1, this.args = e1;
                            }
                            static parse(t1, e1) {
                                if (t1.length < 2) return e1.error("Expectected at least one argument.");
                                let r = null;
                                const n = e1.expectedType;
                                n && "value" !== n.kind && (r = n);
                                const i = [];
                                for (const n of t1.slice(1)){
                                    const t1 = e1.parse(n, 1 + i.length, r, void 0, {
                                        typeAnnotation: "omit"
                                    });
                                    if (!t1) return null;
                                    r = r || t1.type, i.push(t1);
                                }
                                if (!r) throw new Error("No output type");
                                const a = n && i.some((t1)=>Tt(n, t1.type));
                                return new De(a ? dt : r, i);
                            }
                            evaluate(t1) {
                                let e1, r = null, n = 0;
                                for (const i of this.args)if (n++, r = i.evaluate(t1), r && r instanceof re && !r.available && (e1 || (e1 = r.name), r = null, n === this.args.length && (r = e1)), null !== r) break;
                                return r;
                            }
                            eachChild(t1) {
                                this.args.forEach(t1);
                            }
                            outputDefined() {
                                return this.args.every((t1)=>t1.outputDefined());
                            }
                        }
                        function Re(t1, e1) {
                            return "==" === t1 || "!=" === t1 ? "boolean" === e1.kind || "string" === e1.kind || "number" === e1.kind || "null" === e1.kind || "value" === e1.kind : "string" === e1.kind || "number" === e1.kind || "value" === e1.kind;
                        }
                        function Fe(t1, e1, r, n) {
                            return 0 === n.compare(e1, r);
                        }
                        function Be(t1, e1, r) {
                            const n = "==" !== t1 && "!=" !== t1;
                            return class i {
                                constructor(t1, e1, r){
                                    this.type = ht, this.lhs = t1, this.rhs = e1, this.collator = r, this.hasUntypedArgument = "value" === t1.type.kind || "value" === e1.type.kind;
                                }
                                static parse(t1, e1) {
                                    if (3 !== t1.length && 4 !== t1.length) return e1.error("Expected two or three arguments.");
                                    const r = t1[0];
                                    let a = e1.parse(t1[1], 1, dt);
                                    if (!a) return null;
                                    if (!Re(r, a.type)) return e1.concat(1).error(`"${r}" comparisons are not supported for type '${bt(a.type)}'.`);
                                    let o = e1.parse(t1[2], 2, dt);
                                    if (!o) return null;
                                    if (!Re(r, o.type)) return e1.concat(2).error(`"${r}" comparisons are not supported for type '${bt(o.type)}'.`);
                                    if (a.type.kind !== o.type.kind && "value" !== a.type.kind && "value" !== o.type.kind) return e1.error(`Cannot compare types '${bt(a.type)}' and '${bt(o.type)}'.`);
                                    n && ("value" === a.type.kind && "value" !== o.type.kind ? a = new ue(o.type, [
                                        a
                                    ]) : "value" !== a.type.kind && "value" === o.type.kind && (o = new ue(a.type, [
                                        o
                                    ])));
                                    let s = null;
                                    if (4 === t1.length) {
                                        if ("string" !== a.type.kind && "string" !== o.type.kind && "value" !== a.type.kind && "value" !== o.type.kind) return e1.error("Cannot use collator to compare non-string types.");
                                        if (s = e1.parse(t1[3], 3, mt), !s) return null;
                                    }
                                    return new i(a, o, s);
                                }
                                evaluate(i) {
                                    const a = this.lhs.evaluate(i), o = this.rhs.evaluate(i);
                                    if (n && this.hasUntypedArgument) {
                                        const e1 = ae(a), r = ae(o);
                                        if (e1.kind !== r.kind || "string" !== e1.kind && "number" !== e1.kind) throw new le(`Expected arguments for "${t1}" to be (string, string) or (number, number), but found (${e1.kind}, ${r.kind}) instead.`);
                                    }
                                    if (this.collator && !n && this.hasUntypedArgument) {
                                        const t1 = ae(a), r = ae(o);
                                        if ("string" !== t1.kind || "string" !== r.kind) return e1(i, a, o);
                                    }
                                    return this.collator ? r(i, a, o, this.collator.evaluate(i)) : e1(i, a, o);
                                }
                                eachChild(t1) {
                                    t1(this.lhs), t1(this.rhs), this.collator && t1(this.collator);
                                }
                                outputDefined() {
                                    return !0;
                                }
                            };
                        }
                        const Ne = Be("==", function(t1, e1, r) {
                            return e1 === r;
                        }, Fe), je = Be("!=", function(t1, e1, r) {
                            return e1 !== r;
                        }, function(t1, e1, r, n) {
                            return !Fe(0, e1, r, n);
                        }), Ue = Be("<", function(t1, e1, r) {
                            return e1 < r;
                        }, function(t1, e1, r, n) {
                            return n.compare(e1, r) < 0;
                        }), Ve = Be(">", function(t1, e1, r) {
                            return e1 > r;
                        }, function(t1, e1, r, n) {
                            return n.compare(e1, r) > 0;
                        }), qe = Be("<=", function(t1, e1, r) {
                            return e1 <= r;
                        }, function(t1, e1, r, n) {
                            return n.compare(e1, r) <= 0;
                        }), He = Be(">=", function(t1, e1, r) {
                            return e1 >= r;
                        }, function(t1, e1, r, n) {
                            return n.compare(e1, r) >= 0;
                        });
                        class Ge {
                            constructor(t1, e1, r){
                                this.type = mt, this.locale = r, this.caseSensitive = t1, this.diacriticSensitive = e1;
                            }
                            static parse(t1, e1) {
                                if (2 !== t1.length) return e1.error("Expected one argument.");
                                const r = t1[1];
                                if ("object" != typeof r || Array.isArray(r)) return e1.error("Collator options argument must be an object.");
                                const n = e1.parse(void 0 !== r["case-sensitive"] && r["case-sensitive"], 1, ht);
                                if (!n) return null;
                                const i = e1.parse(void 0 !== r["diacritic-sensitive"] && r["diacritic-sensitive"], 1, ht);
                                if (!i) return null;
                                let a = null;
                                return r.locale && (a = e1.parse(r.locale, 1, ut), !a) ? null : new Ge(n, i, a);
                            }
                            evaluate(t1) {
                                return new $t(this.caseSensitive.evaluate(t1), this.diacriticSensitive.evaluate(t1), this.locale ? this.locale.evaluate(t1) : null);
                            }
                            eachChild(t1) {
                                t1(this.caseSensitive), t1(this.diacriticSensitive), this.locale && t1(this.locale);
                            }
                            outputDefined() {
                                return !1;
                            }
                        }
                        class Ze {
                            constructor(t1, e1, r, n, i){
                                this.type = ut, this.number = t1, this.locale = e1, this.currency = r, this.minFractionDigits = n, this.maxFractionDigits = i;
                            }
                            static parse(t1, e1) {
                                if (3 !== t1.length) return e1.error("Expected two arguments.");
                                const r = e1.parse(t1[1], 1, ct);
                                if (!r) return null;
                                const n = t1[2];
                                if ("object" != typeof n || Array.isArray(n)) return e1.error("NumberFormat options argument must be an object.");
                                let i = null;
                                if (n.locale && (i = e1.parse(n.locale, 1, ut), !i)) return null;
                                let a = null;
                                if (n.currency && (a = e1.parse(n.currency, 1, ut), !a)) return null;
                                let o = null;
                                if (n["min-fraction-digits"] && (o = e1.parse(n["min-fraction-digits"], 1, ct), !o)) return null;
                                let s = null;
                                return n["max-fraction-digits"] && (s = e1.parse(n["max-fraction-digits"], 1, ct), !s) ? null : new Ze(r, i, a, o, s);
                            }
                            evaluate(t1) {
                                return new Intl.NumberFormat(this.locale ? this.locale.evaluate(t1) : [], {
                                    style: this.currency ? "currency" : "decimal",
                                    currency: this.currency ? this.currency.evaluate(t1) : void 0,
                                    minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(t1) : void 0,
                                    maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(t1) : void 0
                                }).format(this.number.evaluate(t1));
                            }
                            eachChild(t1) {
                                t1(this.number), this.locale && t1(this.locale), this.currency && t1(this.currency), this.minFractionDigits && t1(this.minFractionDigits), this.maxFractionDigits && t1(this.maxFractionDigits);
                            }
                            outputDefined() {
                                return !1;
                            }
                        }
                        class We {
                            constructor(t1){
                                this.type = gt, this.sections = t1;
                            }
                            static parse(t1, e1) {
                                if (t1.length < 2) return e1.error("Expected at least one argument.");
                                const r = t1[1];
                                if (!Array.isArray(r) && "object" == typeof r) return e1.error("First argument must be an image or text section.");
                                const n = [];
                                let i = !1;
                                for(let r = 1; r <= t1.length - 1; ++r){
                                    const a = t1[r];
                                    if (i && "object" == typeof a && !Array.isArray(a)) {
                                        i = !1;
                                        let t1 = null;
                                        if (a["font-scale"] && (t1 = e1.parse(a["font-scale"], 1, ct), !t1)) return null;
                                        let r = null;
                                        if (a["text-font"] && (r = e1.parse(a["text-font"], 1, _t(ut)), !r)) return null;
                                        let o = null;
                                        if (a["text-color"] && (o = e1.parse(a["text-color"], 1, ft), !o)) return null;
                                        const s = n[n.length - 1];
                                        s.scale = t1, s.font = r, s.textColor = o;
                                    } else {
                                        const a = e1.parse(t1[r], 1, dt);
                                        if (!a) return null;
                                        const o = a.type.kind;
                                        if ("string" !== o && "value" !== o && "null" !== o && "resolvedImage" !== o) return e1.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                                        i = !0, n.push({
                                            content: a,
                                            scale: null,
                                            font: null,
                                            textColor: null
                                        });
                                    }
                                }
                                return new We(n);
                            }
                            evaluate(t1) {
                                return new Kt(this.sections.map((e1)=>{
                                    const r = e1.content.evaluate(t1);
                                    return ae(r) === vt ? new Jt("", r, null, null, null) : new Jt(oe(r), null, e1.scale ? e1.scale.evaluate(t1) : null, e1.font ? e1.font.evaluate(t1).join(",") : null, e1.textColor ? e1.textColor.evaluate(t1) : null);
                                }));
                            }
                            eachChild(t1) {
                                for (const e1 of this.sections)t1(e1.content), e1.scale && t1(e1.scale), e1.font && t1(e1.font), e1.textColor && t1(e1.textColor);
                            }
                            outputDefined() {
                                return !1;
                            }
                        }
                        class Ye {
                            constructor(t1){
                                this.type = vt, this.input = t1;
                            }
                            static parse(t1, e1) {
                                if (2 !== t1.length) return e1.error("Expected two arguments.");
                                const r = e1.parse(t1[1], 1, ut);
                                return r ? new Ye(r) : e1.error("No image name provided.");
                            }
                            evaluate(t1) {
                                const e1 = this.input.evaluate(t1), r = re.fromString(e1);
                                return r && t1.availableImages && (r.available = t1.availableImages.indexOf(e1) > -1), r;
                            }
                            eachChild(t1) {
                                t1(this.input);
                            }
                            outputDefined() {
                                return !1;
                            }
                        }
                        class Xe {
                            constructor(t1){
                                this.type = ct, this.input = t1;
                            }
                            static parse(t1, e1) {
                                if (2 !== t1.length) return e1.error(`Expected 1 argument, but found ${t1.length - 1} instead.`);
                                const r = e1.parse(t1[1], 1);
                                return r ? "array" !== r.type.kind && "string" !== r.type.kind && "value" !== r.type.kind ? e1.error(`Expected argument of type string or array, but found ${bt(r.type)} instead.`) : new Xe(r) : null;
                            }
                            evaluate(t1) {
                                const e1 = this.input.evaluate(t1);
                                if ("string" == typeof e1) return e1.length;
                                if (Array.isArray(e1)) return e1.length;
                                throw new le(`Expected value to be of type string or array, but found ${bt(ae(e1))} instead.`);
                            }
                            eachChild(t1) {
                                t1(this.input);
                            }
                            outputDefined() {
                                return !1;
                            }
                        }
                        const $e = 8192;
                        function Je(t1, e1) {
                            const r = (180 + t1[0]) / 360, n = (a = t1[1], (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + a * Math.PI / 360))) / 360), i = Math.pow(2, e1.z);
                            var a;
                            return [
                                Math.round(r * i * $e),
                                Math.round(n * i * $e)
                            ];
                        }
                        function Ke(t1, e1) {
                            const r = Math.pow(2, e1.z), n = (t1[0] / $e + e1.x) / r, i = (t1[1] / $e + e1.y) / r;
                            var a, o;
                            return [
                                (o = n, 360 * o - 180),
                                (a = i, 360 / Math.PI * Math.atan(Math.exp((180 - 360 * a) * Math.PI / 180)) - 90)
                            ];
                        }
                        function Qe(t1, e1) {
                            t1[0] = Math.min(t1[0], e1[0]), t1[1] = Math.min(t1[1], e1[1]), t1[2] = Math.max(t1[2], e1[0]), t1[3] = Math.max(t1[3], e1[1]);
                        }
                        function tr(t1, e1) {
                            return !(t1[0] <= e1[0] || t1[2] >= e1[2] || t1[1] <= e1[1] || t1[3] >= e1[3]);
                        }
                        function er(t1, e1, r) {
                            const n = t1[0] - e1[0], i = t1[1] - e1[1], a = t1[0] - r[0], o = t1[1] - r[1];
                            return n * o - a * i == 0 && n * a <= 0 && i * o <= 0;
                        }
                        function rr(t1, e1, r, n) {
                            const i = [
                                e1[0] - t1[0],
                                e1[1] - t1[1]
                            ];
                            var a, o;
                            return 0 != (a = [
                                n[0] - r[0],
                                n[1] - r[1]
                            ], o = i, a[0] * o[1] - a[1] * o[0]) && !(!lr(t1, e1, r, n) || !lr(r, n, t1, e1));
                        }
                        function nr(t1, e1, r) {
                            for (const n of r)for(let r = 0; r < n.length - 1; ++r)if (rr(t1, e1, n[r], n[r + 1])) return !0;
                            return !1;
                        }
                        function ir(t1, e1, r = !1) {
                            let n = !1;
                            for (const s of e1)for(let e1 = 0; e1 < s.length - 1; e1++){
                                if (er(t1, s[e1], s[e1 + 1])) return r;
                                i = t1, a = s[e1], o = s[e1 + 1], a[1] > i[1] != o[1] > i[1] && i[0] < (o[0] - a[0]) * (i[1] - a[1]) / (o[1] - a[1]) + a[0] && (n = !n);
                            }
                            var i, a, o;
                            return n;
                        }
                        function ar(t1, e1) {
                            for (const r of e1)if (ir(t1, r)) return !0;
                            return !1;
                        }
                        function or(t1, e1) {
                            for (const r of t1)if (!ir(r, e1)) return !1;
                            for(let r = 0; r < t1.length - 1; ++r)if (nr(t1[r], t1[r + 1], e1)) return !1;
                            return !0;
                        }
                        function sr(t1, e1) {
                            for (const r of e1)if (or(t1, r)) return !0;
                            return !1;
                        }
                        function lr(t1, e1, r, n) {
                            const i = t1[0] - r[0], a = t1[1] - r[1], o = e1[0] - r[0], s = e1[1] - r[1], l = n[0] - r[0], c = n[1] - r[1], u = i * c - l * a, h = o * c - l * s;
                            return u > 0 && h < 0 || u < 0 && h > 0;
                        }
                        function cr(t1, e1, r) {
                            const n = [];
                            for(let i = 0; i < t1.length; i++){
                                const a = [];
                                for(let n = 0; n < t1[i].length; n++){
                                    const o = Je(t1[i][n], r);
                                    Qe(e1, o), a.push(o);
                                }
                                n.push(a);
                            }
                            return n;
                        }
                        function ur(t1, e1, r) {
                            const n = [];
                            for(let i = 0; i < t1.length; i++){
                                const a = cr(t1[i], e1, r);
                                n.push(a);
                            }
                            return n;
                        }
                        function hr(t1, e1, r, n) {
                            if (t1[0] < r[0] || t1[0] > r[2]) {
                                const e1 = .5 * n;
                                let i = t1[0] - r[0] > e1 ? -n : r[0] - t1[0] > e1 ? n : 0;
                                0 === i && (i = t1[0] - r[2] > e1 ? -n : r[2] - t1[0] > e1 ? n : 0), t1[0] += i;
                            }
                            Qe(e1, t1);
                        }
                        function fr(t1, e1, r, n) {
                            const i = Math.pow(2, n.z) * $e, a = [
                                n.x * $e,
                                n.y * $e
                            ], o = [];
                            for (const n of t1)for (const t1 of n){
                                const n = [
                                    t1.x + a[0],
                                    t1.y + a[1]
                                ];
                                hr(n, e1, r, i), o.push(n);
                            }
                            return o;
                        }
                        function pr(t1, e1, r, n) {
                            const i = Math.pow(2, n.z) * $e, a = [
                                n.x * $e,
                                n.y * $e
                            ], o = [];
                            for (const r of t1){
                                const t1 = [];
                                for (const n of r){
                                    const r = [
                                        n.x + a[0],
                                        n.y + a[1]
                                    ];
                                    Qe(e1, r), t1.push(r);
                                }
                                o.push(t1);
                            }
                            if (e1[2] - e1[0] <= i / 2) {
                                (s = e1)[0] = s[1] = 1 / 0, s[2] = s[3] = -1 / 0;
                                for (const t1 of o)for (const n of t1)hr(n, e1, r, i);
                            }
                            var s;
                            return o;
                        }
                        class dr {
                            constructor(t1, e1){
                                this.type = ht, this.geojson = t1, this.geometries = e1;
                            }
                            static parse(t1, e1) {
                                if (2 !== t1.length) return e1.error(`'within' expression requires exactly one argument, but found ${t1.length - 1} instead.`);
                                if (ie(t1[1])) {
                                    const e1 = t1[1];
                                    if ("FeatureCollection" === e1.type) {
                                        const t1 = [];
                                        for (const r of e1.features){
                                            const { type: e1, coordinates: n } = r.geometry;
                                            "Polygon" === e1 && t1.push(n), "MultiPolygon" === e1 && t1.push(...n);
                                        }
                                        if (t1.length) return new dr(e1, {
                                            type: "MultiPolygon",
                                            coordinates: t1
                                        });
                                    } else if ("Feature" === e1.type) {
                                        const t1 = e1.geometry.type;
                                        if ("Polygon" === t1 || "MultiPolygon" === t1) return new dr(e1, e1.geometry);
                                    } else if ("Polygon" === e1.type || "MultiPolygon" === e1.type) return new dr(e1, e1);
                                }
                                return e1.error("'within' expression requires valid geojson object that contains polygon geometry type.");
                            }
                            evaluate(t1) {
                                if (null != t1.geometry() && null != t1.canonicalID()) {
                                    if ("Point" === t1.geometryType()) return function(t1, e1) {
                                        const r = [
                                            1 / 0,
                                            1 / 0,
                                            -1 / 0,
                                            -1 / 0
                                        ], n = [
                                            1 / 0,
                                            1 / 0,
                                            -1 / 0,
                                            -1 / 0
                                        ], i = t1.canonicalID();
                                        if ("Polygon" === e1.type) {
                                            const a = cr(e1.coordinates, n, i), o = fr(t1.geometry(), r, n, i);
                                            if (!tr(r, n)) return !1;
                                            for (const t1 of o)if (!ir(t1, a)) return !1;
                                        }
                                        if ("MultiPolygon" === e1.type) {
                                            const a = ur(e1.coordinates, n, i), o = fr(t1.geometry(), r, n, i);
                                            if (!tr(r, n)) return !1;
                                            for (const t1 of o)if (!ar(t1, a)) return !1;
                                        }
                                        return !0;
                                    }(t1, this.geometries);
                                    if ("LineString" === t1.geometryType()) return function(t1, e1) {
                                        const r = [
                                            1 / 0,
                                            1 / 0,
                                            -1 / 0,
                                            -1 / 0
                                        ], n = [
                                            1 / 0,
                                            1 / 0,
                                            -1 / 0,
                                            -1 / 0
                                        ], i = t1.canonicalID();
                                        if ("Polygon" === e1.type) {
                                            const a = cr(e1.coordinates, n, i), o = pr(t1.geometry(), r, n, i);
                                            if (!tr(r, n)) return !1;
                                            for (const t1 of o)if (!or(t1, a)) return !1;
                                        }
                                        if ("MultiPolygon" === e1.type) {
                                            const a = ur(e1.coordinates, n, i), o = pr(t1.geometry(), r, n, i);
                                            if (!tr(r, n)) return !1;
                                            for (const t1 of o)if (!sr(t1, a)) return !1;
                                        }
                                        return !0;
                                    }(t1, this.geometries);
                                }
                                return !1;
                            }
                            eachChild() {}
                            outputDefined() {
                                return !0;
                            }
                        }
                        let mr = class {
                            constructor(t1 = [], e1 = gr){
                                if (this.data = t1, this.length = this.data.length, this.compare = e1, this.length > 0) for(let t1 = (this.length >> 1) - 1; t1 >= 0; t1--)this._down(t1);
                            }
                            push(t1) {
                                this.data.push(t1), this.length++, this._up(this.length - 1);
                            }
                            pop() {
                                if (0 === this.length) return;
                                const t1 = this.data[0], e1 = this.data.pop();
                                return this.length--, this.length > 0 && (this.data[0] = e1, this._down(0)), t1;
                            }
                            peek() {
                                return this.data[0];
                            }
                            _up(t1) {
                                const { data: e1, compare: r } = this, n = e1[t1];
                                for(; t1 > 0;){
                                    const i = t1 - 1 >> 1, a = e1[i];
                                    if (r(n, a) >= 0) break;
                                    e1[t1] = a, t1 = i;
                                }
                                e1[t1] = n;
                            }
                            _down(t1) {
                                const { data: e1, compare: r } = this, n = this.length >> 1, i = e1[t1];
                                for(; t1 < n;){
                                    let n = 1 + (t1 << 1), a = e1[n];
                                    const o = n + 1;
                                    if (o < this.length && r(e1[o], a) < 0 && (n = o, a = e1[o]), r(a, i) >= 0) break;
                                    e1[t1] = a, t1 = n;
                                }
                                e1[t1] = i;
                            }
                        };
                        function gr(t1, e1) {
                            return t1 < e1 ? -1 : t1 > e1 ? 1 : 0;
                        }
                        function yr(t1, e1, r, n, i) {
                            vr(t1, e1, r, n || t1.length - 1, i || _r);
                        }
                        function vr(t1, e1, r, n, i) {
                            for(; n > r;){
                                if (n - r > 600) {
                                    var a = n - r + 1, o = e1 - r + 1, s = Math.log(a), l = .5 * Math.exp(2 * s / 3), c = .5 * Math.sqrt(s * l * (a - l) / a) * (o - a / 2 < 0 ? -1 : 1);
                                    vr(t1, e1, Math.max(r, Math.floor(e1 - o * l / a + c)), Math.min(n, Math.floor(e1 + (a - o) * l / a + c)), i);
                                }
                                var u = t1[e1], h = r, f = n;
                                for(xr(t1, r, e1), i(t1[n], u) > 0 && xr(t1, r, n); h < f;){
                                    for(xr(t1, h, f), h++, f--; i(t1[h], u) < 0;)h++;
                                    for(; i(t1[f], u) > 0;)f--;
                                }
                                0 === i(t1[r], u) ? xr(t1, r, f) : xr(t1, ++f, n), f <= e1 && (r = f + 1), e1 <= f && (n = f - 1);
                            }
                        }
                        function xr(t1, e1, r) {
                            var n = t1[e1];
                            t1[e1] = t1[r], t1[r] = n;
                        }
                        function _r(t1, e1) {
                            return t1 < e1 ? -1 : t1 > e1 ? 1 : 0;
                        }
                        function br(t1, e1) {
                            if (t1.length <= 1) return [
                                t1
                            ];
                            const r = [];
                            let n, i;
                            for (const e1 of t1){
                                const t1 = Tr(e1);
                                0 !== t1 && (e1.area = Math.abs(t1), void 0 === i && (i = t1 < 0), i === t1 < 0 ? (n && r.push(n), n = [
                                    e1
                                ]) : n.push(e1));
                            }
                            if (n && r.push(n), e1 > 1) for(let t1 = 0; t1 < r.length; t1++)r[t1].length <= e1 || (yr(r[t1], e1, 1, r[t1].length - 1, wr), r[t1] = r[t1].slice(0, e1));
                            return r;
                        }
                        function wr(t1, e1) {
                            return e1.area - t1.area;
                        }
                        function Tr(t1) {
                            let e1 = 0;
                            for(let r, n, i = 0, a = t1.length, o = a - 1; i < a; o = i++)r = t1[i], n = t1[o], e1 += (n.x - r.x) * (r.y + n.y);
                            return e1;
                        }
                        const kr = 1 / 298.257223563, Ar = kr * (2 - kr), Mr = Math.PI / 180;
                        class Sr {
                            constructor(t1){
                                const e1 = 6378.137 * Mr * 1e3, r = Math.cos(t1 * Mr), n = 1 / (1 - Ar * (1 - r * r)), i = Math.sqrt(n);
                                this.kx = e1 * i * r, this.ky = e1 * i * n * (1 - Ar);
                            }
                            distance(t1, e1) {
                                const r = this.wrap(t1[0] - e1[0]) * this.kx, n = (t1[1] - e1[1]) * this.ky;
                                return Math.sqrt(r * r + n * n);
                            }
                            pointOnLine(t1, e1) {
                                let r, n, i, a, o = 1 / 0;
                                for(let s = 0; s < t1.length - 1; s++){
                                    let l = t1[s][0], c = t1[s][1], u = this.wrap(t1[s + 1][0] - l) * this.kx, h = (t1[s + 1][1] - c) * this.ky, f = 0;
                                    0 === u && 0 === h || (f = (this.wrap(e1[0] - l) * this.kx * u + (e1[1] - c) * this.ky * h) / (u * u + h * h), f > 1 ? (l = t1[s + 1][0], c = t1[s + 1][1]) : f > 0 && (l += u / this.kx * f, c += h / this.ky * f)), u = this.wrap(e1[0] - l) * this.kx, h = (e1[1] - c) * this.ky;
                                    const p = u * u + h * h;
                                    p < o && (o = p, r = l, n = c, i = s, a = f);
                                }
                                return {
                                    point: [
                                        r,
                                        n
                                    ],
                                    index: i,
                                    t: Math.max(0, Math.min(1, a))
                                };
                            }
                            wrap(t1) {
                                for(; t1 < -180;)t1 += 360;
                                for(; t1 > 180;)t1 -= 360;
                                return t1;
                            }
                        }
                        const Er = 100, Cr = 50;
                        function Lr(t1, e1) {
                            return e1[0] - t1[0];
                        }
                        function Ir(t1) {
                            return t1[1] - t1[0] + 1;
                        }
                        function Pr(t1, e1) {
                            return t1[1] >= t1[0] && t1[1] < e1;
                        }
                        function zr(t1, e1) {
                            if (t1[0] > t1[1]) return [
                                null,
                                null
                            ];
                            const r = Ir(t1);
                            if (e1) {
                                if (2 === r) return [
                                    t1,
                                    null
                                ];
                                const e1 = Math.floor(r / 2);
                                return [
                                    [
                                        t1[0],
                                        t1[0] + e1
                                    ],
                                    [
                                        t1[0] + e1,
                                        t1[1]
                                    ]
                                ];
                            }
                            if (1 === r) return [
                                t1,
                                null
                            ];
                            const n = Math.floor(r / 2) - 1;
                            return [
                                [
                                    t1[0],
                                    t1[0] + n
                                ],
                                [
                                    t1[0] + n + 1,
                                    t1[1]
                                ]
                            ];
                        }
                        function Or(t1, e1) {
                            if (!Pr(e1, t1.length)) return [
                                1 / 0,
                                1 / 0,
                                -1 / 0,
                                -1 / 0
                            ];
                            const r = [
                                1 / 0,
                                1 / 0,
                                -1 / 0,
                                -1 / 0
                            ];
                            for(let n = e1[0]; n <= e1[1]; ++n)Qe(r, t1[n]);
                            return r;
                        }
                        function Dr(t1) {
                            const e1 = [
                                1 / 0,
                                1 / 0,
                                -1 / 0,
                                -1 / 0
                            ];
                            for (const r of t1)for (const t1 of r)Qe(e1, t1);
                            return e1;
                        }
                        function Rr(t1) {
                            return t1[0] !== -1 / 0 && t1[1] !== -1 / 0 && t1[2] !== 1 / 0 && t1[3] !== 1 / 0;
                        }
                        function Fr(t1, e1, r) {
                            if (!Rr(t1) || !Rr(e1)) return NaN;
                            let n = 0, i = 0;
                            return t1[2] < e1[0] && (n = e1[0] - t1[2]), t1[0] > e1[2] && (n = t1[0] - e1[2]), t1[1] > e1[3] && (i = t1[1] - e1[3]), t1[3] < e1[1] && (i = e1[1] - t1[3]), r.distance([
                                0,
                                0
                            ], [
                                n,
                                i
                            ]);
                        }
                        function Br(t1, e1, r) {
                            const n = r.pointOnLine(e1, t1);
                            return r.distance(t1, n.point);
                        }
                        function Nr(t1, e1, r, n, i) {
                            const a = Math.min(Br(t1, [
                                r,
                                n
                            ], i), Br(e1, [
                                r,
                                n
                            ], i)), o = Math.min(Br(r, [
                                t1,
                                e1
                            ], i), Br(n, [
                                t1,
                                e1
                            ], i));
                            return Math.min(a, o);
                        }
                        function jr(t1, e1, r, n, i) {
                            if (!Pr(e1, t1.length) || !Pr(n, r.length)) return 1 / 0;
                            let a = 1 / 0;
                            for(let o = e1[0]; o < e1[1]; ++o){
                                const e1 = t1[o], s = t1[o + 1];
                                for(let t1 = n[0]; t1 < n[1]; ++t1){
                                    const n = r[t1], o = r[t1 + 1];
                                    if (rr(e1, s, n, o)) return 0;
                                    a = Math.min(a, Nr(e1, s, n, o, i));
                                }
                            }
                            return a;
                        }
                        function Ur(t1, e1, r, n, i) {
                            if (!Pr(e1, t1.length) || !Pr(n, r.length)) return NaN;
                            let a = 1 / 0;
                            for(let o = e1[0]; o <= e1[1]; ++o)for(let e1 = n[0]; e1 <= n[1]; ++e1)if (a = Math.min(a, i.distance(t1[o], r[e1])), 0 === a) return a;
                            return a;
                        }
                        function Vr(t1, e1, r) {
                            if (ir(t1, e1, !0)) return 0;
                            let n = 1 / 0;
                            for (const i of e1){
                                const e1 = i[0], a = i[i.length - 1];
                                if (e1 !== a && (n = Math.min(n, Br(t1, [
                                    a,
                                    e1
                                ], r)), 0 === n)) return n;
                                const o = r.pointOnLine(i, t1);
                                if (n = Math.min(n, r.distance(t1, o.point)), 0 === n) return n;
                            }
                            return n;
                        }
                        function qr(t1, e1, r, n) {
                            if (!Pr(e1, t1.length)) return NaN;
                            for(let n = e1[0]; n <= e1[1]; ++n)if (ir(t1[n], r, !0)) return 0;
                            let i = 1 / 0;
                            for(let a = e1[0]; a < e1[1]; ++a){
                                const e1 = t1[a], o = t1[a + 1];
                                for (const t1 of r)for(let r = 0, a = t1.length, s = a - 1; r < a; s = r++){
                                    const a = t1[s], l = t1[r];
                                    if (rr(e1, o, a, l)) return 0;
                                    i = Math.min(i, Nr(e1, o, a, l, n));
                                }
                            }
                            return i;
                        }
                        function Hr(t1, e1) {
                            for (const r of t1)for (const t1 of r)if (ir(t1, e1, !0)) return !0;
                            return !1;
                        }
                        function Gr(t1, e1, r, n = 1 / 0) {
                            const i = Dr(t1), a = Dr(e1);
                            if (n !== 1 / 0 && Fr(i, a, r) >= n) return n;
                            if (tr(i, a)) {
                                if (Hr(t1, e1)) return 0;
                            } else if (Hr(e1, t1)) return 0;
                            let o = 1 / 0;
                            for (const n of t1)for(let t1 = 0, i = n.length, a = i - 1; t1 < i; a = t1++){
                                const i = n[a], s = n[t1];
                                for (const t1 of e1)for(let e1 = 0, n = t1.length, a = n - 1; e1 < n; a = e1++){
                                    const n = t1[a], l = t1[e1];
                                    if (rr(i, s, n, l)) return 0;
                                    o = Math.min(o, Nr(i, s, n, l, r));
                                }
                            }
                            return o;
                        }
                        function Zr(t1, e1, r, n, i, a) {
                            if (!a) return;
                            const o = Fr(Or(n, a), i, r);
                            o < e1 && t1.push([
                                o,
                                a,
                                [
                                    0,
                                    0
                                ]
                            ]);
                        }
                        function Wr(t1, e1, r, n, i, a, o) {
                            if (!a || !o) return;
                            const s = Fr(Or(n, a), Or(i, o), r);
                            s < e1 && t1.push([
                                s,
                                a,
                                o
                            ]);
                        }
                        function Yr(t1, e1, r, n, i = 1 / 0) {
                            let a = Math.min(n.distance(t1[0], r[0][0]), i);
                            if (0 === a) return a;
                            const o = new mr([
                                [
                                    0,
                                    [
                                        0,
                                        t1.length - 1
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ]
                            ], Lr), s = Dr(r);
                            for(; o.length > 0;){
                                const i = o.pop();
                                if (i[0] >= a) continue;
                                const l = i[1], c = e1 ? Cr : Er;
                                if (Ir(l) <= c) {
                                    if (!Pr(l, t1.length)) return NaN;
                                    if (e1) {
                                        const e1 = qr(t1, l, r, n);
                                        if (isNaN(e1) || 0 === e1) return e1;
                                        a = Math.min(a, e1);
                                    } else for(let e1 = l[0]; e1 <= l[1]; ++e1){
                                        const i = Vr(t1[e1], r, n);
                                        if (a = Math.min(a, i), 0 === a) return 0;
                                    }
                                } else {
                                    const r = zr(l, e1);
                                    Zr(o, a, n, t1, s, r[0]), Zr(o, a, n, t1, s, r[1]);
                                }
                            }
                            return a;
                        }
                        function Xr(t1, e1, r, n, i, a = 1 / 0) {
                            let o = Math.min(a, i.distance(t1[0], r[0]));
                            if (0 === o) return o;
                            const s = new mr([
                                [
                                    0,
                                    [
                                        0,
                                        t1.length - 1
                                    ],
                                    [
                                        0,
                                        r.length - 1
                                    ]
                                ]
                            ], Lr);
                            for(; s.length > 0;){
                                const a = s.pop();
                                if (a[0] >= o) continue;
                                const l = a[1], c = a[2], u = e1 ? Cr : Er, h = n ? Cr : Er;
                                if (Ir(l) <= u && Ir(c) <= h) {
                                    if (!Pr(l, t1.length) && Pr(c, r.length)) return NaN;
                                    let a;
                                    if (e1 && n) a = jr(t1, l, r, c, i), o = Math.min(o, a);
                                    else if (e1 && !n) {
                                        const e1 = t1.slice(l[0], l[1] + 1);
                                        for(let t1 = c[0]; t1 <= c[1]; ++t1)if (a = Br(r[t1], e1, i), o = Math.min(o, a), 0 === o) return o;
                                    } else if (!e1 && n) {
                                        const e1 = r.slice(c[0], c[1] + 1);
                                        for(let r = l[0]; r <= l[1]; ++r)if (a = Br(t1[r], e1, i), o = Math.min(o, a), 0 === o) return o;
                                    } else a = Ur(t1, l, r, c, i), o = Math.min(o, a);
                                } else {
                                    const a = zr(l, e1), u = zr(c, n);
                                    Wr(s, o, i, t1, r, a[0], u[0]), Wr(s, o, i, t1, r, a[0], u[1]), Wr(s, o, i, t1, r, a[1], u[0]), Wr(s, o, i, t1, r, a[1], u[1]);
                                }
                            }
                            return o;
                        }
                        function $r(t1) {
                            return "MultiPolygon" === t1.type ? t1.coordinates.map((t1)=>({
                                    type: "Polygon",
                                    coordinates: t1
                                })) : "MultiLineString" === t1.type ? t1.coordinates.map((t1)=>({
                                    type: "LineString",
                                    coordinates: t1
                                })) : "MultiPoint" === t1.type ? t1.coordinates.map((t1)=>({
                                    type: "Point",
                                    coordinates: t1
                                })) : [
                                t1
                            ];
                        }
                        class Jr {
                            constructor(t1, e1){
                                this.type = ct, this.geojson = t1, this.geometries = e1;
                            }
                            static parse(t1, e1) {
                                if (2 !== t1.length) return e1.error(`'distance' expression requires exactly one argument, but found ${t1.length - 1} instead.`);
                                if (ie(t1[1])) {
                                    const e1 = t1[1];
                                    if ("FeatureCollection" === e1.type) return new Jr(e1, e1.features.map((t1)=>$r(t1.geometry)).flat());
                                    if ("Feature" === e1.type) return new Jr(e1, $r(e1.geometry));
                                    if ("type" in e1 && "coordinates" in e1) return new Jr(e1, $r(e1));
                                }
                                return e1.error("'distance' expression requires valid geojson object that contains polygon geometry type.");
                            }
                            evaluate(t1) {
                                if (null != t1.geometry() && null != t1.canonicalID()) {
                                    if ("Point" === t1.geometryType()) return function(t1, e1) {
                                        const r = t1.geometry(), n = r.flat().map((e1)=>Ke([
                                                e1.x,
                                                e1.y
                                            ], t1.canonical));
                                        if (0 === r.length) return NaN;
                                        const i = new Sr(n[0][1]);
                                        let a = 1 / 0;
                                        for (const t1 of e1){
                                            switch(t1.type){
                                                case "Point":
                                                    a = Math.min(a, Xr(n, !1, [
                                                        t1.coordinates
                                                    ], !1, i, a));
                                                    break;
                                                case "LineString":
                                                    a = Math.min(a, Xr(n, !1, t1.coordinates, !0, i, a));
                                                    break;
                                                case "Polygon":
                                                    a = Math.min(a, Yr(n, !1, t1.coordinates, i, a));
                                            }
                                            if (0 === a) return a;
                                        }
                                        return a;
                                    }(t1, this.geometries);
                                    if ("LineString" === t1.geometryType()) return function(t1, e1) {
                                        const r = t1.geometry(), n = r.flat().map((e1)=>Ke([
                                                e1.x,
                                                e1.y
                                            ], t1.canonical));
                                        if (0 === r.length) return NaN;
                                        const i = new Sr(n[0][1]);
                                        let a = 1 / 0;
                                        for (const t1 of e1){
                                            switch(t1.type){
                                                case "Point":
                                                    a = Math.min(a, Xr(n, !0, [
                                                        t1.coordinates
                                                    ], !1, i, a));
                                                    break;
                                                case "LineString":
                                                    a = Math.min(a, Xr(n, !0, t1.coordinates, !0, i, a));
                                                    break;
                                                case "Polygon":
                                                    a = Math.min(a, Yr(n, !0, t1.coordinates, i, a));
                                            }
                                            if (0 === a) return a;
                                        }
                                        return a;
                                    }(t1, this.geometries);
                                    if ("Polygon" === t1.geometryType()) return function(t1, e1) {
                                        const r = t1.geometry();
                                        if (0 === r.length || 0 === r[0].length) return NaN;
                                        const n = br(r, 0).map((e1)=>e1.map((e1)=>e1.map((e1)=>Ke([
                                                        e1.x,
                                                        e1.y
                                                    ], t1.canonical)))), i = new Sr(n[0][0][0][1]);
                                        let a = 1 / 0;
                                        for (const t1 of e1)for (const e1 of n){
                                            switch(t1.type){
                                                case "Point":
                                                    a = Math.min(a, Yr([
                                                        t1.coordinates
                                                    ], !1, e1, i, a));
                                                    break;
                                                case "LineString":
                                                    a = Math.min(a, Yr(t1.coordinates, !0, e1, i, a));
                                                    break;
                                                case "Polygon":
                                                    a = Math.min(a, Gr(e1, t1.coordinates, i, a));
                                            }
                                            if (0 === a) return a;
                                        }
                                        return a;
                                    }(t1, this.geometries);
                                }
                                return NaN;
                            }
                            eachChild() {}
                            outputDefined() {
                                return !0;
                            }
                        }
                        const Kr = {
                            "==": Ne,
                            "!=": je,
                            ">": Ve,
                            "<": Ue,
                            ">=": He,
                            "<=": qe,
                            array: ue,
                            at: ve,
                            boolean: ue,
                            case: we,
                            coalesce: De,
                            collator: Ge,
                            format: We,
                            image: Ye,
                            in: xe,
                            "index-of": _e,
                            interpolate: ze,
                            "interpolate-hcl": ze,
                            "interpolate-lab": ze,
                            length: Xe,
                            let: ge,
                            literal: se,
                            match: be,
                            number: ue,
                            "number-format": Ze,
                            object: ue,
                            slice: Te,
                            step: Ae,
                            string: ue,
                            "to-boolean": fe,
                            "to-color": fe,
                            "to-number": fe,
                            "to-string": fe,
                            var: ye,
                            within: dr,
                            distance: Jr
                        };
                        class Qr {
                            constructor(t1, e1, r, n){
                                this.name = t1, this.type = e1, this._evaluate = r, this.args = n;
                            }
                            evaluate(t1) {
                                return this._evaluate(t1, this.args);
                            }
                            eachChild(t1) {
                                this.args.forEach(t1);
                            }
                            outputDefined() {
                                return !1;
                            }
                            static parse(t1, e1) {
                                const r = t1[0], n = Qr.definitions[r];
                                if (!n) return e1.error(`Unknown expression "${r}". If you wanted a literal array, use ["literal", [...]].`, 0);
                                const i = Array.isArray(n) ? n[0] : n.type, a = Array.isArray(n) ? [
                                    [
                                        n[1],
                                        n[2]
                                    ]
                                ] : n.overloads, o = a.filter(([e1])=>!Array.isArray(e1) || e1.length === t1.length - 1);
                                let s = null;
                                for (const [n, a] of o){
                                    s = new me(e1.registry, an, e1.path, null, e1.scope);
                                    const o = [];
                                    let l = !1;
                                    for(let e1 = 1; e1 < t1.length; e1++){
                                        const r = t1[e1], i = Array.isArray(n) ? n[e1 - 1] : n.type, a = s.parse(r, 1 + o.length, i);
                                        if (!a) {
                                            l = !0;
                                            break;
                                        }
                                        o.push(a);
                                    }
                                    if (!l) {
                                        if (Array.isArray(n) && n.length !== o.length) s.error(`Expected ${n.length} arguments, but found ${o.length} instead.`);
                                        else {
                                            for(let t1 = 0; t1 < o.length; t1++){
                                                const e1 = Array.isArray(n) ? n[t1] : n.type, r = o[t1];
                                                s.concat(t1 + 1).checkSubtype(e1, r.type);
                                            }
                                            if (0 === s.errors.length) return new Qr(r, i, a, o);
                                        }
                                    }
                                }
                                if (1 === o.length) e1.errors.push(...s.errors);
                                else {
                                    const r = (o.length ? o : a).map(([t1])=>{
                                        var e1;
                                        return e1 = t1, Array.isArray(e1) ? `(${e1.map(bt).join(", ")})` : `(${bt(e1.type)}...)`;
                                    }).join(" | "), n = [];
                                    for(let r = 1; r < t1.length; r++){
                                        const i = e1.parse(t1[r], 1 + n.length);
                                        if (!i) return null;
                                        n.push(bt(i.type));
                                    }
                                    e1.error(`Expected arguments of type ${r}, but found (${n.join(", ")}) instead.`);
                                }
                                return null;
                            }
                            static register(t1, e1) {
                                Qr.definitions = e1;
                                for(const r in e1)t1[r] = Qr;
                            }
                        }
                        function tn(t1, [e1, r, n, i]) {
                            e1 = e1.evaluate(t1), r = r.evaluate(t1), n = n.evaluate(t1);
                            const a = i ? i.evaluate(t1) : 1, o = ne(e1, r, n, a);
                            if (o) throw new le(o);
                            return new Xt(e1 / 255, r / 255, n / 255, a, !1);
                        }
                        function en(t1, e1) {
                            return t1 in e1;
                        }
                        function rn(t1, e1) {
                            const r = e1[t1];
                            return void 0 === r ? null : r;
                        }
                        function nn(t1) {
                            return {
                                type: t1
                            };
                        }
                        function an(t1) {
                            if (t1 instanceof ye) return an(t1.boundExpression);
                            if (t1 instanceof Qr && "error" === t1.name) return !1;
                            if (t1 instanceof Ge) return !1;
                            if (t1 instanceof dr) return !1;
                            if (t1 instanceof Jr) return !1;
                            const e1 = t1 instanceof fe || t1 instanceof ue;
                            let r = !0;
                            return t1.eachChild((t1)=>{
                                r = e1 ? r && an(t1) : r && t1 instanceof se;
                            }), !!r && on(t1) && ln(t1, [
                                "zoom",
                                "heatmap-density",
                                "line-progress",
                                "accumulated",
                                "is-supported-script"
                            ]);
                        }
                        function on(t1) {
                            if (t1 instanceof Qr) {
                                if ("get" === t1.name && 1 === t1.args.length) return !1;
                                if ("feature-state" === t1.name) return !1;
                                if ("has" === t1.name && 1 === t1.args.length) return !1;
                                if ("properties" === t1.name || "geometry-type" === t1.name || "id" === t1.name) return !1;
                                if (/^filter-/.test(t1.name)) return !1;
                            }
                            if (t1 instanceof dr) return !1;
                            if (t1 instanceof Jr) return !1;
                            let e1 = !0;
                            return t1.eachChild((t1)=>{
                                e1 && !on(t1) && (e1 = !1);
                            }), e1;
                        }
                        function sn(t1) {
                            if (t1 instanceof Qr && "feature-state" === t1.name) return !1;
                            let e1 = !0;
                            return t1.eachChild((t1)=>{
                                e1 && !sn(t1) && (e1 = !1);
                            }), e1;
                        }
                        function ln(t1, e1) {
                            if (t1 instanceof Qr && e1.indexOf(t1.name) >= 0) return !1;
                            let r = !0;
                            return t1.eachChild((t1)=>{
                                r && !ln(t1, e1) && (r = !1);
                            }), r;
                        }
                        function cn(t1) {
                            return {
                                result: "success",
                                value: t1
                            };
                        }
                        function un(t1) {
                            return {
                                result: "error",
                                value: t1
                            };
                        }
                        function hn(t1) {
                            return "data-driven" === t1["property-type"] || "cross-faded-data-driven" === t1["property-type"];
                        }
                        function fn(t1) {
                            return !!t1.expression && t1.expression.parameters.indexOf("zoom") > -1;
                        }
                        function pn(t1) {
                            return !!t1.expression && t1.expression.interpolated;
                        }
                        function dn(t1) {
                            return t1 instanceof Number ? "number" : t1 instanceof String ? "string" : t1 instanceof Boolean ? "boolean" : Array.isArray(t1) ? "array" : null === t1 ? "null" : typeof t1;
                        }
                        function mn(t1) {
                            return "object" == typeof t1 && null !== t1 && !Array.isArray(t1);
                        }
                        function gn(t1) {
                            return t1;
                        }
                        function yn(t1, e1) {
                            const r = "color" === e1.type, n = t1.stops && "object" == typeof t1.stops[0][0], i = n || void 0 !== t1.property, a = n || !i, o = t1.type || (pn(e1) ? "exponential" : "interval");
                            if (r || "padding" === e1.type) {
                                const n = r ? Xt.parse : Qt.parse;
                                (t1 = at({}, t1)).stops && (t1.stops = t1.stops.map((t1)=>[
                                        t1[0],
                                        n(t1[1])
                                    ])), t1.default ? t1.default = n(t1.default) : t1.default = n(e1.default);
                            }
                            if (t1.colorSpace && "rgb" !== (s = t1.colorSpace) && "hcl" !== s && "lab" !== s) throw new Error(`Unknown color space: "${t1.colorSpace}"`);
                            var s;
                            let l, c, u;
                            if ("exponential" === o) l = bn;
                            else if ("interval" === o) l = _n;
                            else if ("categorical" === o) {
                                l = xn, c = Object.create(null);
                                for (const e1 of t1.stops)c[e1[0]] = e1[1];
                                u = typeof t1.stops[0][0];
                            } else {
                                if ("identity" !== o) throw new Error(`Unknown function type "${o}"`);
                                l = wn;
                            }
                            if (n) {
                                const r = {}, n = [];
                                for(let e1 = 0; e1 < t1.stops.length; e1++){
                                    const i = t1.stops[e1], a = i[0].zoom;
                                    void 0 === r[a] && (r[a] = {
                                        zoom: a,
                                        type: t1.type,
                                        property: t1.property,
                                        default: t1.default,
                                        stops: []
                                    }, n.push(a)), r[a].stops.push([
                                        i[0].value,
                                        i[1]
                                    ]);
                                }
                                const i = [];
                                for (const t1 of n)i.push([
                                    r[t1].zoom,
                                    yn(r[t1], e1)
                                ]);
                                const a = {
                                    name: "linear"
                                };
                                return {
                                    kind: "composite",
                                    interpolationType: a,
                                    interpolationFactor: ze.interpolationFactor.bind(void 0, a),
                                    zoomStops: i.map((t1)=>t1[0]),
                                    evaluate ({ zoom: r }, n) {
                                        return bn({
                                            stops: i,
                                            base: t1.base
                                        }, e1, r).evaluate(r, n);
                                    }
                                };
                            }
                            if (a) {
                                const r = "exponential" === o ? {
                                    name: "exponential",
                                    base: void 0 !== t1.base ? t1.base : 1
                                } : null;
                                return {
                                    kind: "camera",
                                    interpolationType: r,
                                    interpolationFactor: ze.interpolationFactor.bind(void 0, r),
                                    zoomStops: t1.stops.map((t1)=>t1[0]),
                                    evaluate: ({ zoom: r })=>l(t1, e1, r, c, u)
                                };
                            }
                            return {
                                kind: "source",
                                evaluate (r, n) {
                                    const i = n && n.properties ? n.properties[t1.property] : void 0;
                                    return void 0 === i ? vn(t1.default, e1.default) : l(t1, e1, i, c, u);
                                }
                            };
                        }
                        function vn(t1, e1, r) {
                            return void 0 !== t1 ? t1 : void 0 !== e1 ? e1 : void 0 !== r ? r : void 0;
                        }
                        function xn(t1, e1, r, n, i) {
                            return vn(typeof r === i ? n[r] : void 0, t1.default, e1.default);
                        }
                        function _n(t1, e1, r) {
                            if ("number" !== dn(r)) return vn(t1.default, e1.default);
                            const n = t1.stops.length;
                            if (1 === n) return t1.stops[0][1];
                            if (r <= t1.stops[0][0]) return t1.stops[0][1];
                            if (r >= t1.stops[n - 1][0]) return t1.stops[n - 1][1];
                            const i = ke(t1.stops.map((t1)=>t1[0]), r);
                            return t1.stops[i][1];
                        }
                        function bn(t1, e1, r) {
                            const n = void 0 !== t1.base ? t1.base : 1;
                            if ("number" !== dn(r)) return vn(t1.default, e1.default);
                            const i = t1.stops.length;
                            if (1 === i) return t1.stops[0][1];
                            if (r <= t1.stops[0][0]) return t1.stops[0][1];
                            if (r >= t1.stops[i - 1][0]) return t1.stops[i - 1][1];
                            const a = ke(t1.stops.map((t1)=>t1[0]), r), o = function(t1, e1, r, n) {
                                const i = n - r, a = t1 - r;
                                return 0 === i ? 0 : 1 === e1 ? a / i : (Math.pow(e1, a) - 1) / (Math.pow(e1, i) - 1);
                            }(r, n, t1.stops[a][0], t1.stops[a + 1][0]), s = t1.stops[a][1], l = t1.stops[a + 1][1], c = Pe[e1.type] || gn;
                            return "function" == typeof s.evaluate ? {
                                evaluate (...e1) {
                                    const r = s.evaluate.apply(void 0, e1), n = l.evaluate.apply(void 0, e1);
                                    if (void 0 !== r && void 0 !== n) return c(r, n, o, t1.colorSpace);
                                }
                            } : c(s, l, o, t1.colorSpace);
                        }
                        function wn(t1, e1, r) {
                            switch(e1.type){
                                case "color":
                                    r = Xt.parse(r);
                                    break;
                                case "formatted":
                                    r = Kt.fromString(r.toString());
                                    break;
                                case "resolvedImage":
                                    r = re.fromString(r.toString());
                                    break;
                                case "padding":
                                    r = Qt.parse(r);
                                    break;
                                default:
                                    dn(r) === e1.type || "enum" === e1.type && e1.values[r] || (r = void 0);
                            }
                            return vn(r, t1.default, e1.default);
                        }
                        Qr.register(Kr, {
                            error: [
                                {
                                    kind: "error"
                                },
                                [
                                    ut
                                ],
                                (t1, [e1])=>{
                                    throw new le(e1.evaluate(t1));
                                }
                            ],
                            typeof: [
                                ut,
                                [
                                    dt
                                ],
                                (t1, [e1])=>bt(ae(e1.evaluate(t1)))
                            ],
                            "to-rgba": [
                                _t(ct, 4),
                                [
                                    ft
                                ],
                                (t1, [e1])=>{
                                    const [r, n, i, a] = e1.evaluate(t1).rgb;
                                    return [
                                        255 * r,
                                        255 * n,
                                        255 * i,
                                        a
                                    ];
                                }
                            ],
                            rgb: [
                                ft,
                                [
                                    ct,
                                    ct,
                                    ct
                                ],
                                tn
                            ],
                            rgba: [
                                ft,
                                [
                                    ct,
                                    ct,
                                    ct,
                                    ct
                                ],
                                tn
                            ],
                            has: {
                                type: ht,
                                overloads: [
                                    [
                                        [
                                            ut
                                        ],
                                        (t1, [e1])=>en(e1.evaluate(t1), t1.properties())
                                    ],
                                    [
                                        [
                                            ut,
                                            pt
                                        ],
                                        (t1, [e1, r])=>en(e1.evaluate(t1), r.evaluate(t1))
                                    ]
                                ]
                            },
                            get: {
                                type: dt,
                                overloads: [
                                    [
                                        [
                                            ut
                                        ],
                                        (t1, [e1])=>rn(e1.evaluate(t1), t1.properties())
                                    ],
                                    [
                                        [
                                            ut,
                                            pt
                                        ],
                                        (t1, [e1, r])=>rn(e1.evaluate(t1), r.evaluate(t1))
                                    ]
                                ]
                            },
                            "feature-state": [
                                dt,
                                [
                                    ut
                                ],
                                (t1, [e1])=>rn(e1.evaluate(t1), t1.featureState || {})
                            ],
                            properties: [
                                pt,
                                [],
                                (t1)=>t1.properties()
                            ],
                            "geometry-type": [
                                ut,
                                [],
                                (t1)=>t1.geometryType()
                            ],
                            id: [
                                dt,
                                [],
                                (t1)=>t1.id()
                            ],
                            zoom: [
                                ct,
                                [],
                                (t1)=>t1.globals.zoom
                            ],
                            "heatmap-density": [
                                ct,
                                [],
                                (t1)=>t1.globals.heatmapDensity || 0
                            ],
                            "line-progress": [
                                ct,
                                [],
                                (t1)=>t1.globals.lineProgress || 0
                            ],
                            accumulated: [
                                dt,
                                [],
                                (t1)=>void 0 === t1.globals.accumulated ? null : t1.globals.accumulated
                            ],
                            "+": [
                                ct,
                                nn(ct),
                                (t1, e1)=>{
                                    let r = 0;
                                    for (const n of e1)r += n.evaluate(t1);
                                    return r;
                                }
                            ],
                            "*": [
                                ct,
                                nn(ct),
                                (t1, e1)=>{
                                    let r = 1;
                                    for (const n of e1)r *= n.evaluate(t1);
                                    return r;
                                }
                            ],
                            "-": {
                                type: ct,
                                overloads: [
                                    [
                                        [
                                            ct,
                                            ct
                                        ],
                                        (t1, [e1, r])=>e1.evaluate(t1) - r.evaluate(t1)
                                    ],
                                    [
                                        [
                                            ct
                                        ],
                                        (t1, [e1])=>-e1.evaluate(t1)
                                    ]
                                ]
                            },
                            "/": [
                                ct,
                                [
                                    ct,
                                    ct
                                ],
                                (t1, [e1, r])=>e1.evaluate(t1) / r.evaluate(t1)
                            ],
                            "%": [
                                ct,
                                [
                                    ct,
                                    ct
                                ],
                                (t1, [e1, r])=>e1.evaluate(t1) % r.evaluate(t1)
                            ],
                            ln2: [
                                ct,
                                [],
                                ()=>Math.LN2
                            ],
                            pi: [
                                ct,
                                [],
                                ()=>Math.PI
                            ],
                            e: [
                                ct,
                                [],
                                ()=>Math.E
                            ],
                            "^": [
                                ct,
                                [
                                    ct,
                                    ct
                                ],
                                (t1, [e1, r])=>Math.pow(e1.evaluate(t1), r.evaluate(t1))
                            ],
                            sqrt: [
                                ct,
                                [
                                    ct
                                ],
                                (t1, [e1])=>Math.sqrt(e1.evaluate(t1))
                            ],
                            log10: [
                                ct,
                                [
                                    ct
                                ],
                                (t1, [e1])=>Math.log(e1.evaluate(t1)) / Math.LN10
                            ],
                            ln: [
                                ct,
                                [
                                    ct
                                ],
                                (t1, [e1])=>Math.log(e1.evaluate(t1))
                            ],
                            log2: [
                                ct,
                                [
                                    ct
                                ],
                                (t1, [e1])=>Math.log(e1.evaluate(t1)) / Math.LN2
                            ],
                            sin: [
                                ct,
                                [
                                    ct
                                ],
                                (t1, [e1])=>Math.sin(e1.evaluate(t1))
                            ],
                            cos: [
                                ct,
                                [
                                    ct
                                ],
                                (t1, [e1])=>Math.cos(e1.evaluate(t1))
                            ],
                            tan: [
                                ct,
                                [
                                    ct
                                ],
                                (t1, [e1])=>Math.tan(e1.evaluate(t1))
                            ],
                            asin: [
                                ct,
                                [
                                    ct
                                ],
                                (t1, [e1])=>Math.asin(e1.evaluate(t1))
                            ],
                            acos: [
                                ct,
                                [
                                    ct
                                ],
                                (t1, [e1])=>Math.acos(e1.evaluate(t1))
                            ],
                            atan: [
                                ct,
                                [
                                    ct
                                ],
                                (t1, [e1])=>Math.atan(e1.evaluate(t1))
                            ],
                            min: [
                                ct,
                                nn(ct),
                                (t1, e1)=>Math.min(...e1.map((e1)=>e1.evaluate(t1)))
                            ],
                            max: [
                                ct,
                                nn(ct),
                                (t1, e1)=>Math.max(...e1.map((e1)=>e1.evaluate(t1)))
                            ],
                            abs: [
                                ct,
                                [
                                    ct
                                ],
                                (t1, [e1])=>Math.abs(e1.evaluate(t1))
                            ],
                            round: [
                                ct,
                                [
                                    ct
                                ],
                                (t1, [e1])=>{
                                    const r = e1.evaluate(t1);
                                    return r < 0 ? -Math.round(-r) : Math.round(r);
                                }
                            ],
                            floor: [
                                ct,
                                [
                                    ct
                                ],
                                (t1, [e1])=>Math.floor(e1.evaluate(t1))
                            ],
                            ceil: [
                                ct,
                                [
                                    ct
                                ],
                                (t1, [e1])=>Math.ceil(e1.evaluate(t1))
                            ],
                            "filter-==": [
                                ht,
                                [
                                    ut,
                                    dt
                                ],
                                (t1, [e1, r])=>t1.properties()[e1.value] === r.value
                            ],
                            "filter-id-==": [
                                ht,
                                [
                                    dt
                                ],
                                (t1, [e1])=>t1.id() === e1.value
                            ],
                            "filter-type-==": [
                                ht,
                                [
                                    ut
                                ],
                                (t1, [e1])=>t1.geometryType() === e1.value
                            ],
                            "filter-<": [
                                ht,
                                [
                                    ut,
                                    dt
                                ],
                                (t1, [e1, r])=>{
                                    const n = t1.properties()[e1.value], i = r.value;
                                    return typeof n == typeof i && n < i;
                                }
                            ],
                            "filter-id-<": [
                                ht,
                                [
                                    dt
                                ],
                                (t1, [e1])=>{
                                    const r = t1.id(), n = e1.value;
                                    return typeof r == typeof n && r < n;
                                }
                            ],
                            "filter->": [
                                ht,
                                [
                                    ut,
                                    dt
                                ],
                                (t1, [e1, r])=>{
                                    const n = t1.properties()[e1.value], i = r.value;
                                    return typeof n == typeof i && n > i;
                                }
                            ],
                            "filter-id->": [
                                ht,
                                [
                                    dt
                                ],
                                (t1, [e1])=>{
                                    const r = t1.id(), n = e1.value;
                                    return typeof r == typeof n && r > n;
                                }
                            ],
                            "filter-<=": [
                                ht,
                                [
                                    ut,
                                    dt
                                ],
                                (t1, [e1, r])=>{
                                    const n = t1.properties()[e1.value], i = r.value;
                                    return typeof n == typeof i && n <= i;
                                }
                            ],
                            "filter-id-<=": [
                                ht,
                                [
                                    dt
                                ],
                                (t1, [e1])=>{
                                    const r = t1.id(), n = e1.value;
                                    return typeof r == typeof n && r <= n;
                                }
                            ],
                            "filter->=": [
                                ht,
                                [
                                    ut,
                                    dt
                                ],
                                (t1, [e1, r])=>{
                                    const n = t1.properties()[e1.value], i = r.value;
                                    return typeof n == typeof i && n >= i;
                                }
                            ],
                            "filter-id->=": [
                                ht,
                                [
                                    dt
                                ],
                                (t1, [e1])=>{
                                    const r = t1.id(), n = e1.value;
                                    return typeof r == typeof n && r >= n;
                                }
                            ],
                            "filter-has": [
                                ht,
                                [
                                    dt
                                ],
                                (t1, [e1])=>e1.value in t1.properties()
                            ],
                            "filter-has-id": [
                                ht,
                                [],
                                (t1)=>null !== t1.id() && void 0 !== t1.id()
                            ],
                            "filter-type-in": [
                                ht,
                                [
                                    _t(ut)
                                ],
                                (t1, [e1])=>e1.value.indexOf(t1.geometryType()) >= 0
                            ],
                            "filter-id-in": [
                                ht,
                                [
                                    _t(dt)
                                ],
                                (t1, [e1])=>e1.value.indexOf(t1.id()) >= 0
                            ],
                            "filter-in-small": [
                                ht,
                                [
                                    ut,
                                    _t(dt)
                                ],
                                (t1, [e1, r])=>r.value.indexOf(t1.properties()[e1.value]) >= 0
                            ],
                            "filter-in-large": [
                                ht,
                                [
                                    ut,
                                    _t(dt)
                                ],
                                (t1, [e1, r])=>(function(t1, e1, r, n) {
                                        for(; r <= n;){
                                            const i = r + n >> 1;
                                            if (e1[i] === t1) return !0;
                                            e1[i] > t1 ? n = i - 1 : r = i + 1;
                                        }
                                        return !1;
                                    })(t1.properties()[e1.value], r.value, 0, r.value.length - 1)
                            ],
                            all: {
                                type: ht,
                                overloads: [
                                    [
                                        [
                                            ht,
                                            ht
                                        ],
                                        (t1, [e1, r])=>e1.evaluate(t1) && r.evaluate(t1)
                                    ],
                                    [
                                        nn(ht),
                                        (t1, e1)=>{
                                            for (const r of e1)if (!r.evaluate(t1)) return !1;
                                            return !0;
                                        }
                                    ]
                                ]
                            },
                            any: {
                                type: ht,
                                overloads: [
                                    [
                                        [
                                            ht,
                                            ht
                                        ],
                                        (t1, [e1, r])=>e1.evaluate(t1) || r.evaluate(t1)
                                    ],
                                    [
                                        nn(ht),
                                        (t1, e1)=>{
                                            for (const r of e1)if (r.evaluate(t1)) return !0;
                                            return !1;
                                        }
                                    ]
                                ]
                            },
                            "!": [
                                ht,
                                [
                                    ht
                                ],
                                (t1, [e1])=>!e1.evaluate(t1)
                            ],
                            "is-supported-script": [
                                ht,
                                [
                                    ut
                                ],
                                (t1, [e1])=>{
                                    const r = t1.globals && t1.globals.isSupportedScript;
                                    return !r || r(e1.evaluate(t1));
                                }
                            ],
                            upcase: [
                                ut,
                                [
                                    ut
                                ],
                                (t1, [e1])=>e1.evaluate(t1).toUpperCase()
                            ],
                            downcase: [
                                ut,
                                [
                                    ut
                                ],
                                (t1, [e1])=>e1.evaluate(t1).toLowerCase()
                            ],
                            concat: [
                                ut,
                                nn(dt),
                                (t1, e1)=>e1.map((e1)=>oe(e1.evaluate(t1))).join("")
                            ],
                            "resolved-locale": [
                                ut,
                                [
                                    mt
                                ],
                                (t1, [e1])=>e1.evaluate(t1).resolvedLocale()
                            ]
                        });
                        class Tn {
                            constructor(t1, e1){
                                var r;
                                this.expression = t1, this._warningHistory = {}, this._evaluator = new de, this._defaultValue = e1 ? "color" === (r = e1).type && mn(r.default) ? new Xt(0, 0, 0, 0) : "color" === r.type ? Xt.parse(r.default) || null : "padding" === r.type ? Qt.parse(r.default) || null : "variableAnchorOffsetCollection" === r.type ? ee.parse(r.default) || null : void 0 === r.default ? null : r.default : null, this._enumValues = e1 && "enum" === e1.type ? e1.values : null;
                            }
                            evaluateWithoutErrorHandling(t1, e1, r, n, i, a) {
                                return this._evaluator.globals = t1, this._evaluator.feature = e1, this._evaluator.featureState = r, this._evaluator.canonical = n, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = a, this.expression.evaluate(this._evaluator);
                            }
                            evaluate(t1, e1, r, n, i, a) {
                                this._evaluator.globals = t1, this._evaluator.feature = e1 || null, this._evaluator.featureState = r || null, this._evaluator.canonical = n, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = a || null;
                                try {
                                    const t1 = this.expression.evaluate(this._evaluator);
                                    if (null == t1 || "number" == typeof t1 && t1 != t1) return this._defaultValue;
                                    if (this._enumValues && !(t1 in this._enumValues)) throw new le(`Expected value to be one of ${Object.keys(this._enumValues).map((t1)=>JSON.stringify(t1)).join(", ")}, but found ${JSON.stringify(t1)} instead.`);
                                    return t1;
                                } catch (t1) {
                                    return this._warningHistory[t1.message] || (this._warningHistory[t1.message] = !0, "undefined" != typeof console && console.warn(t1.message)), this._defaultValue;
                                }
                            }
                        }
                        function kn(t1) {
                            return Array.isArray(t1) && t1.length > 0 && "string" == typeof t1[0] && t1[0] in Kr;
                        }
                        function An(t1, e1) {
                            const r = new me(Kr, an, [], e1 ? function(t1) {
                                const e1 = {
                                    color: ft,
                                    string: ut,
                                    number: ct,
                                    enum: ut,
                                    boolean: ht,
                                    formatted: gt,
                                    padding: yt,
                                    resolvedImage: vt,
                                    variableAnchorOffsetCollection: xt
                                };
                                return "array" === t1.type ? _t(e1[t1.value] || dt, t1.length) : e1[t1.type];
                            }(e1) : void 0), n = r.parse(t1, void 0, void 0, void 0, e1 && "string" === e1.type ? {
                                typeAnnotation: "coerce"
                            } : void 0);
                            return n ? cn(new Tn(n, e1)) : un(r.errors);
                        }
                        class Mn {
                            constructor(t1, e1){
                                this.kind = t1, this._styleExpression = e1, this.isStateDependent = "constant" !== t1 && !sn(e1.expression);
                            }
                            evaluateWithoutErrorHandling(t1, e1, r, n, i, a) {
                                return this._styleExpression.evaluateWithoutErrorHandling(t1, e1, r, n, i, a);
                            }
                            evaluate(t1, e1, r, n, i, a) {
                                return this._styleExpression.evaluate(t1, e1, r, n, i, a);
                            }
                        }
                        class Sn {
                            constructor(t1, e1, r, n){
                                this.kind = t1, this.zoomStops = r, this._styleExpression = e1, this.isStateDependent = "camera" !== t1 && !sn(e1.expression), this.interpolationType = n;
                            }
                            evaluateWithoutErrorHandling(t1, e1, r, n, i, a) {
                                return this._styleExpression.evaluateWithoutErrorHandling(t1, e1, r, n, i, a);
                            }
                            evaluate(t1, e1, r, n, i, a) {
                                return this._styleExpression.evaluate(t1, e1, r, n, i, a);
                            }
                            interpolationFactor(t1, e1, r) {
                                return this.interpolationType ? ze.interpolationFactor(this.interpolationType, t1, e1, r) : 0;
                            }
                        }
                        function En(t1, e1) {
                            const r = An(t1, e1);
                            if ("error" === r.result) return r;
                            const n = r.value.expression, i = on(n);
                            if (!i && !hn(e1)) return un([
                                new ot("", "data expressions not supported")
                            ]);
                            const a = ln(n, [
                                "zoom"
                            ]);
                            if (!a && !fn(e1)) return un([
                                new ot("", "zoom expressions not supported")
                            ]);
                            const o = Ln(n);
                            if (!o && !a) return un([
                                new ot("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')
                            ]);
                            if (o instanceof ot) return un([
                                o
                            ]);
                            if (o instanceof ze && !pn(e1)) return un([
                                new ot("", '"interpolate" expressions cannot be used with this property')
                            ]);
                            if (!o) return cn(new Mn(i ? "constant" : "source", r.value));
                            const s = o instanceof ze ? o.interpolation : void 0;
                            return cn(new Sn(i ? "camera" : "composite", r.value, o.labels, s));
                        }
                        class Cn {
                            constructor(t1, e1){
                                this._parameters = t1, this._specification = e1, at(this, yn(this._parameters, this._specification));
                            }
                            static deserialize(t1) {
                                return new Cn(t1._parameters, t1._specification);
                            }
                            static serialize(t1) {
                                return {
                                    _parameters: t1._parameters,
                                    _specification: t1._specification
                                };
                            }
                        }
                        function Ln(t1) {
                            let e1 = null;
                            if (t1 instanceof ge) e1 = Ln(t1.result);
                            else if (t1 instanceof De) {
                                for (const r of t1.args)if (e1 = Ln(r), e1) break;
                            } else (t1 instanceof Ae || t1 instanceof ze) && t1.input instanceof Qr && "zoom" === t1.input.name && (e1 = t1);
                            return e1 instanceof ot || t1.eachChild((t1)=>{
                                const r = Ln(t1);
                                r instanceof ot ? e1 = r : !e1 && r ? e1 = new ot("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.') : e1 && r && e1 !== r && (e1 = new ot("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
                            }), e1;
                        }
                        function In(t1) {
                            if (!0 === t1 || !1 === t1) return !0;
                            if (!Array.isArray(t1) || 0 === t1.length) return !1;
                            switch(t1[0]){
                                case "has":
                                    return t1.length >= 2 && "$id" !== t1[1] && "$type" !== t1[1];
                                case "in":
                                    return t1.length >= 3 && ("string" != typeof t1[1] || Array.isArray(t1[2]));
                                case "!in":
                                case "!has":
                                case "none":
                                    return !1;
                                case "==":
                                case "!=":
                                case ">":
                                case ">=":
                                case "<":
                                case "<=":
                                    return 3 !== t1.length || Array.isArray(t1[1]) || Array.isArray(t1[2]);
                                case "any":
                                case "all":
                                    for (const e1 of t1.slice(1))if (!In(e1) && "boolean" != typeof e1) return !1;
                                    return !0;
                                default:
                                    return !0;
                            }
                        }
                        const Pn = {
                            type: "boolean",
                            default: !1,
                            transition: !1,
                            "property-type": "data-driven",
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom",
                                    "feature"
                                ]
                            }
                        };
                        function zn(t1) {
                            if (null == t1) return {
                                filter: ()=>!0,
                                needGeometry: !1
                            };
                            In(t1) || (t1 = Rn(t1));
                            const e1 = An(t1, Pn);
                            if ("error" === e1.result) throw new Error(e1.value.map((t1)=>`${t1.key}: ${t1.message}`).join(", "));
                            return {
                                filter: (t1, r, n)=>e1.value.evaluate(t1, r, {}, n),
                                needGeometry: Dn(t1)
                            };
                        }
                        function On(t1, e1) {
                            return t1 < e1 ? -1 : t1 > e1 ? 1 : 0;
                        }
                        function Dn(t1) {
                            if (!Array.isArray(t1)) return !1;
                            if ("within" === t1[0] || "distance" === t1[0]) return !0;
                            for(let e1 = 1; e1 < t1.length; e1++)if (Dn(t1[e1])) return !0;
                            return !1;
                        }
                        function Rn(t1) {
                            if (!t1) return !0;
                            const e1 = t1[0];
                            var r;
                            return t1.length <= 1 ? "any" !== e1 : "==" === e1 ? Fn(t1[1], t1[2], "==") : "!=" === e1 ? jn(Fn(t1[1], t1[2], "==")) : "<" === e1 || ">" === e1 || "<=" === e1 || ">=" === e1 ? Fn(t1[1], t1[2], e1) : "any" === e1 ? (r = t1.slice(1), [
                                "any"
                            ].concat(r.map(Rn))) : "all" === e1 ? [
                                "all"
                            ].concat(t1.slice(1).map(Rn)) : "none" === e1 ? [
                                "all"
                            ].concat(t1.slice(1).map(Rn).map(jn)) : "in" === e1 ? Bn(t1[1], t1.slice(2)) : "!in" === e1 ? jn(Bn(t1[1], t1.slice(2))) : "has" === e1 ? Nn(t1[1]) : "!has" !== e1 || jn(Nn(t1[1]));
                        }
                        function Fn(t1, e1, r) {
                            switch(t1){
                                case "$type":
                                    return [
                                        `filter-type-${r}`,
                                        e1
                                    ];
                                case "$id":
                                    return [
                                        `filter-id-${r}`,
                                        e1
                                    ];
                                default:
                                    return [
                                        `filter-${r}`,
                                        t1,
                                        e1
                                    ];
                            }
                        }
                        function Bn(t1, e1) {
                            if (0 === e1.length) return !1;
                            switch(t1){
                                case "$type":
                                    return [
                                        "filter-type-in",
                                        [
                                            "literal",
                                            e1
                                        ]
                                    ];
                                case "$id":
                                    return [
                                        "filter-id-in",
                                        [
                                            "literal",
                                            e1
                                        ]
                                    ];
                                default:
                                    return e1.length > 200 && !e1.some((t1)=>typeof t1 != typeof e1[0]) ? [
                                        "filter-in-large",
                                        t1,
                                        [
                                            "literal",
                                            e1.sort(On)
                                        ]
                                    ] : [
                                        "filter-in-small",
                                        t1,
                                        [
                                            "literal",
                                            e1
                                        ]
                                    ];
                            }
                        }
                        function Nn(t1) {
                            switch(t1){
                                case "$type":
                                    return !0;
                                case "$id":
                                    return [
                                        "filter-has-id"
                                    ];
                                default:
                                    return [
                                        "filter-has",
                                        t1
                                    ];
                            }
                        }
                        function jn(t1) {
                            return [
                                "!",
                                t1
                            ];
                        }
                        function Un(t1) {
                            const e1 = typeof t1;
                            if ("number" === e1 || "boolean" === e1 || "string" === e1 || null == t1) return JSON.stringify(t1);
                            if (Array.isArray(t1)) {
                                let e1 = "[";
                                for (const r of t1)e1 += `${Un(r)},`;
                                return `${e1}]`;
                            }
                            const r = Object.keys(t1).sort();
                            let n = "{";
                            for(let e1 = 0; e1 < r.length; e1++)n += `${JSON.stringify(r[e1])}:${Un(t1[r[e1]])},`;
                            return `${n}}`;
                        }
                        function Vn(t1) {
                            let e1 = "";
                            for (const r of W)e1 += `/${Un(t1[r])}`;
                            return e1;
                        }
                        function qn(t1) {
                            const e1 = t1.key, r = t1.value;
                            return r ? [
                                new it(e1, r, "constants have been deprecated as of v8")
                            ] : [];
                        }
                        function Hn(t1) {
                            return t1 instanceof Number || t1 instanceof String || t1 instanceof Boolean ? t1.valueOf() : t1;
                        }
                        function Gn(t1) {
                            if (Array.isArray(t1)) return t1.map(Gn);
                            if (t1 instanceof Object && !(t1 instanceof Number || t1 instanceof String || t1 instanceof Boolean)) {
                                const e1 = {};
                                for(const r in t1)e1[r] = Gn(t1[r]);
                                return e1;
                            }
                            return Hn(t1);
                        }
                        function Zn(t1) {
                            const e1 = t1.key, r = t1.value, n = t1.valueSpec || {}, i = t1.objectElementValidators || {}, a = t1.style, o = t1.styleSpec, s = t1.validateSpec;
                            let l = [];
                            const c = dn(r);
                            if ("object" !== c) return [
                                new it(e1, r, `object expected, ${c} found`)
                            ];
                            for(const t1 in r){
                                const c = t1.split(".")[0], u = n[c] || n["*"];
                                let h;
                                if (i[c]) h = i[c];
                                else if (n[c]) h = s;
                                else if (i["*"]) h = i["*"];
                                else {
                                    if (!n["*"]) {
                                        l.push(new it(e1, r[t1], `unknown property "${t1}"`));
                                        continue;
                                    }
                                    h = s;
                                }
                                l = l.concat(h({
                                    key: (e1 ? `${e1}.` : e1) + t1,
                                    value: r[t1],
                                    valueSpec: u,
                                    style: a,
                                    styleSpec: o,
                                    object: r,
                                    objectKey: t1,
                                    validateSpec: s
                                }, r));
                            }
                            for(const t1 in n)i[t1] || n[t1].required && void 0 === n[t1].default && void 0 === r[t1] && l.push(new it(e1, r, `missing required property "${t1}"`));
                            return l;
                        }
                        function Wn(t1) {
                            const e1 = t1.value, r = t1.valueSpec, n = t1.validateSpec, i = t1.style, a = t1.styleSpec, o = t1.key, s = t1.arrayElementValidator || n;
                            if ("array" !== dn(e1)) return [
                                new it(o, e1, `array expected, ${dn(e1)} found`)
                            ];
                            if (r.length && e1.length !== r.length) return [
                                new it(o, e1, `array length ${r.length} expected, length ${e1.length} found`)
                            ];
                            if (r["min-length"] && e1.length < r["min-length"]) return [
                                new it(o, e1, `array length at least ${r["min-length"]} expected, length ${e1.length} found`)
                            ];
                            let l = {
                                type: r.value,
                                values: r.values
                            };
                            a.$version < 7 && (l.function = r.function), "object" === dn(r.value) && (l = r.value);
                            let c = [];
                            for(let r = 0; r < e1.length; r++)c = c.concat(s({
                                array: e1,
                                arrayIndex: r,
                                value: e1[r],
                                valueSpec: l,
                                validateSpec: t1.validateSpec,
                                style: i,
                                styleSpec: a,
                                key: `${o}[${r}]`
                            }));
                            return c;
                        }
                        function Yn(t1) {
                            const e1 = t1.key, r = t1.value, n = t1.valueSpec;
                            let i = dn(r);
                            return "number" === i && r != r && (i = "NaN"), "number" !== i ? [
                                new it(e1, r, `number expected, ${i} found`)
                            ] : "minimum" in n && r < n.minimum ? [
                                new it(e1, r, `${r} is less than the minimum value ${n.minimum}`)
                            ] : "maximum" in n && r > n.maximum ? [
                                new it(e1, r, `${r} is greater than the maximum value ${n.maximum}`)
                            ] : [];
                        }
                        function Xn(t1) {
                            const e1 = t1.valueSpec, r = Hn(t1.value.type);
                            let n, i, a, o = {};
                            const s = "categorical" !== r && void 0 === t1.value.property, l = !s, c = "array" === dn(t1.value.stops) && "array" === dn(t1.value.stops[0]) && "object" === dn(t1.value.stops[0][0]), u = Zn({
                                key: t1.key,
                                value: t1.value,
                                valueSpec: t1.styleSpec.function,
                                validateSpec: t1.validateSpec,
                                style: t1.style,
                                styleSpec: t1.styleSpec,
                                objectElementValidators: {
                                    stops: function(t1) {
                                        if ("identity" === r) return [
                                            new it(t1.key, t1.value, 'identity function may not have a "stops" property')
                                        ];
                                        let e1 = [];
                                        const n = t1.value;
                                        return e1 = e1.concat(Wn({
                                            key: t1.key,
                                            value: n,
                                            valueSpec: t1.valueSpec,
                                            validateSpec: t1.validateSpec,
                                            style: t1.style,
                                            styleSpec: t1.styleSpec,
                                            arrayElementValidator: h
                                        })), "array" === dn(n) && 0 === n.length && e1.push(new it(t1.key, n, "array must have at least one stop")), e1;
                                    },
                                    default: function(t1) {
                                        return t1.validateSpec({
                                            key: t1.key,
                                            value: t1.value,
                                            valueSpec: e1,
                                            validateSpec: t1.validateSpec,
                                            style: t1.style,
                                            styleSpec: t1.styleSpec
                                        });
                                    }
                                }
                            });
                            return "identity" === r && s && u.push(new it(t1.key, t1.value, 'missing required property "property"')), "identity" === r || t1.value.stops || u.push(new it(t1.key, t1.value, 'missing required property "stops"')), "exponential" === r && t1.valueSpec.expression && !pn(t1.valueSpec) && u.push(new it(t1.key, t1.value, "exponential functions not supported")), t1.styleSpec.$version >= 8 && (l && !hn(t1.valueSpec) ? u.push(new it(t1.key, t1.value, "property functions not supported")) : s && !fn(t1.valueSpec) && u.push(new it(t1.key, t1.value, "zoom functions not supported"))), "categorical" !== r && !c || void 0 !== t1.value.property || u.push(new it(t1.key, t1.value, '"property" property is required')), u;
                            function h(t1) {
                                let r = [];
                                const n = t1.value, s = t1.key;
                                if ("array" !== dn(n)) return [
                                    new it(s, n, `array expected, ${dn(n)} found`)
                                ];
                                if (2 !== n.length) return [
                                    new it(s, n, `array length 2 expected, length ${n.length} found`)
                                ];
                                if (c) {
                                    if ("object" !== dn(n[0])) return [
                                        new it(s, n, `object expected, ${dn(n[0])} found`)
                                    ];
                                    if (void 0 === n[0].zoom) return [
                                        new it(s, n, "object stop key must have zoom")
                                    ];
                                    if (void 0 === n[0].value) return [
                                        new it(s, n, "object stop key must have value")
                                    ];
                                    if (a && a > Hn(n[0].zoom)) return [
                                        new it(s, n[0].zoom, "stop zoom values must appear in ascending order")
                                    ];
                                    Hn(n[0].zoom) !== a && (a = Hn(n[0].zoom), i = void 0, o = {}), r = r.concat(Zn({
                                        key: `${s}[0]`,
                                        value: n[0],
                                        valueSpec: {
                                            zoom: {}
                                        },
                                        validateSpec: t1.validateSpec,
                                        style: t1.style,
                                        styleSpec: t1.styleSpec,
                                        objectElementValidators: {
                                            zoom: Yn,
                                            value: f
                                        }
                                    }));
                                } else r = r.concat(f({
                                    key: `${s}[0]`,
                                    value: n[0],
                                    valueSpec: {},
                                    validateSpec: t1.validateSpec,
                                    style: t1.style,
                                    styleSpec: t1.styleSpec
                                }, n));
                                return kn(Gn(n[1])) ? r.concat([
                                    new it(`${s}[1]`, n[1], "expressions are not allowed in function stops.")
                                ]) : r.concat(t1.validateSpec({
                                    key: `${s}[1]`,
                                    value: n[1],
                                    valueSpec: e1,
                                    validateSpec: t1.validateSpec,
                                    style: t1.style,
                                    styleSpec: t1.styleSpec
                                }));
                            }
                            function f(t1, a) {
                                const s = dn(t1.value), l = Hn(t1.value), c = null !== t1.value ? t1.value : a;
                                if (n) {
                                    if (s !== n) return [
                                        new it(t1.key, c, `${s} stop domain type must match previous stop domain type ${n}`)
                                    ];
                                } else n = s;
                                if ("number" !== s && "string" !== s && "boolean" !== s) return [
                                    new it(t1.key, c, "stop domain value must be a number, string, or boolean")
                                ];
                                if ("number" !== s && "categorical" !== r) {
                                    let n = `number expected, ${s} found`;
                                    return hn(e1) && void 0 === r && (n += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                                        new it(t1.key, c, n)
                                    ];
                                }
                                return "categorical" !== r || "number" !== s || isFinite(l) && Math.floor(l) === l ? "categorical" !== r && "number" === s && void 0 !== i && l < i ? [
                                    new it(t1.key, c, "stop domain values must appear in ascending order")
                                ] : (i = l, "categorical" === r && l in o ? [
                                    new it(t1.key, c, "stop domain values must be unique")
                                ] : (o[l] = !0, [])) : [
                                    new it(t1.key, c, `integer expected, found ${l}`)
                                ];
                            }
                        }
                        function $n(t1) {
                            const e1 = ("property" === t1.expressionContext ? En : An)(Gn(t1.value), t1.valueSpec);
                            if ("error" === e1.result) return e1.value.map((e1)=>new it(`${t1.key}${e1.key}`, t1.value, e1.message));
                            const r = e1.value.expression || e1.value._styleExpression.expression;
                            if ("property" === t1.expressionContext && "text-font" === t1.propertyKey && !r.outputDefined()) return [
                                new it(t1.key, t1.value, `Invalid data expression for "${t1.propertyKey}". Output values must be contained as literals within the expression.`)
                            ];
                            if ("property" === t1.expressionContext && "layout" === t1.propertyType && !sn(r)) return [
                                new it(t1.key, t1.value, '"feature-state" data expressions are not supported with layout properties.')
                            ];
                            if ("filter" === t1.expressionContext && !sn(r)) return [
                                new it(t1.key, t1.value, '"feature-state" data expressions are not supported with filters.')
                            ];
                            if (t1.expressionContext && 0 === t1.expressionContext.indexOf("cluster")) {
                                if (!ln(r, [
                                    "zoom",
                                    "feature-state"
                                ])) return [
                                    new it(t1.key, t1.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
                                ];
                                if ("cluster-initial" === t1.expressionContext && !on(r)) return [
                                    new it(t1.key, t1.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
                                ];
                            }
                            return [];
                        }
                        function Jn(t1) {
                            const e1 = t1.key, r = t1.value, n = t1.valueSpec, i = [];
                            return Array.isArray(n.values) ? -1 === n.values.indexOf(Hn(r)) && i.push(new it(e1, r, `expected one of [${n.values.join(", ")}], ${JSON.stringify(r)} found`)) : -1 === Object.keys(n.values).indexOf(Hn(r)) && i.push(new it(e1, r, `expected one of [${Object.keys(n.values).join(", ")}], ${JSON.stringify(r)} found`)), i;
                        }
                        function Kn(t1) {
                            return In(Gn(t1.value)) ? $n(at({}, t1, {
                                expressionContext: "filter",
                                valueSpec: {
                                    value: "boolean"
                                }
                            })) : Qn(t1);
                        }
                        function Qn(t1) {
                            const e1 = t1.value, r = t1.key;
                            if ("array" !== dn(e1)) return [
                                new it(r, e1, `array expected, ${dn(e1)} found`)
                            ];
                            const n = t1.styleSpec;
                            let i, a = [];
                            if (e1.length < 1) return [
                                new it(r, e1, "filter array must have at least 1 element")
                            ];
                            switch(a = a.concat(Jn({
                                key: `${r}[0]`,
                                value: e1[0],
                                valueSpec: n.filter_operator,
                                style: t1.style,
                                styleSpec: t1.styleSpec
                            })), Hn(e1[0])){
                                case "<":
                                case "<=":
                                case ">":
                                case ">=":
                                    e1.length >= 2 && "$type" === Hn(e1[1]) && a.push(new it(r, e1, `"$type" cannot be use with operator "${e1[0]}"`));
                                case "==":
                                case "!=":
                                    3 !== e1.length && a.push(new it(r, e1, `filter array for operator "${e1[0]}" must have 3 elements`));
                                case "in":
                                case "!in":
                                    e1.length >= 2 && (i = dn(e1[1]), "string" !== i && a.push(new it(`${r}[1]`, e1[1], `string expected, ${i} found`)));
                                    for(let o = 2; o < e1.length; o++)i = dn(e1[o]), "$type" === Hn(e1[1]) ? a = a.concat(Jn({
                                        key: `${r}[${o}]`,
                                        value: e1[o],
                                        valueSpec: n.geometry_type,
                                        style: t1.style,
                                        styleSpec: t1.styleSpec
                                    })) : "string" !== i && "number" !== i && "boolean" !== i && a.push(new it(`${r}[${o}]`, e1[o], `string, number, or boolean expected, ${i} found`));
                                    break;
                                case "any":
                                case "all":
                                case "none":
                                    for(let n = 1; n < e1.length; n++)a = a.concat(Qn({
                                        key: `${r}[${n}]`,
                                        value: e1[n],
                                        style: t1.style,
                                        styleSpec: t1.styleSpec
                                    }));
                                    break;
                                case "has":
                                case "!has":
                                    i = dn(e1[1]), 2 !== e1.length ? a.push(new it(r, e1, `filter array for "${e1[0]}" operator must have 2 elements`)) : "string" !== i && a.push(new it(`${r}[1]`, e1[1], `string expected, ${i} found`));
                            }
                            return a;
                        }
                        function ti(t1, e1) {
                            const r = t1.key, n = t1.validateSpec, i = t1.style, a = t1.styleSpec, o = t1.value, s = t1.objectKey, l = a[`${e1}_${t1.layerType}`];
                            if (!l) return [];
                            const c = s.match(/^(.*)-transition$/);
                            if ("paint" === e1 && c && l[c[1]] && l[c[1]].transition) return n({
                                key: r,
                                value: o,
                                valueSpec: a.transition,
                                style: i,
                                styleSpec: a
                            });
                            const u = t1.valueSpec || l[s];
                            if (!u) return [
                                new it(r, o, `unknown property "${s}"`)
                            ];
                            let h;
                            if ("string" === dn(o) && hn(u) && !u.tokens && (h = /^{([^}]+)}$/.exec(o))) return [
                                new it(r, o, `"${s}" does not support interpolation syntax\nUse an identity property function instead: \`{ "type": "identity", "property": ${JSON.stringify(h[1])} }\`.`)
                            ];
                            const f = [];
                            return "symbol" === t1.layerType && ("text-field" === s && i && !i.glyphs && f.push(new it(r, o, 'use of "text-field" requires a style "glyphs" property')), "text-font" === s && mn(Gn(o)) && "identity" === Hn(o.type) && f.push(new it(r, o, '"text-font" does not support identity functions'))), f.concat(n({
                                key: t1.key,
                                value: o,
                                valueSpec: u,
                                style: i,
                                styleSpec: a,
                                expressionContext: "property",
                                propertyType: e1,
                                propertyKey: s
                            }));
                        }
                        function ei(t1) {
                            return ti(t1, "paint");
                        }
                        function ri(t1) {
                            return ti(t1, "layout");
                        }
                        function ni(t1) {
                            let e1 = [];
                            const r = t1.value, n = t1.key, i = t1.style, a = t1.styleSpec;
                            r.type || r.ref || e1.push(new it(n, r, 'either "type" or "ref" is required'));
                            let o = Hn(r.type);
                            const s = Hn(r.ref);
                            if (r.id) {
                                const a = Hn(r.id);
                                for(let o = 0; o < t1.arrayIndex; o++){
                                    const t1 = i.layers[o];
                                    Hn(t1.id) === a && e1.push(new it(n, r.id, `duplicate layer id "${r.id}", previously used at line ${t1.id.__line__}`));
                                }
                            }
                            if ("ref" in r) {
                                let t1;
                                [
                                    "type",
                                    "source",
                                    "source-layer",
                                    "filter",
                                    "layout"
                                ].forEach((t1)=>{
                                    t1 in r && e1.push(new it(n, r[t1], `"${t1}" is prohibited for ref layers`));
                                }), i.layers.forEach((e1)=>{
                                    Hn(e1.id) === s && (t1 = e1);
                                }), t1 ? t1.ref ? e1.push(new it(n, r.ref, "ref cannot reference another ref layer")) : o = Hn(t1.type) : e1.push(new it(n, r.ref, `ref layer "${s}" not found`));
                            } else if ("background" !== o) {
                                if (r.source) {
                                    const t1 = i.sources && i.sources[r.source], a = t1 && Hn(t1.type);
                                    t1 ? "vector" === a && "raster" === o ? e1.push(new it(n, r.source, `layer "${r.id}" requires a raster source`)) : "raster-dem" !== a && "hillshade" === o ? e1.push(new it(n, r.source, `layer "${r.id}" requires a raster-dem source`)) : "raster" === a && "raster" !== o ? e1.push(new it(n, r.source, `layer "${r.id}" requires a vector source`)) : "vector" !== a || r["source-layer"] ? "raster-dem" === a && "hillshade" !== o ? e1.push(new it(n, r.source, "raster-dem source can only be used with layer type 'hillshade'.")) : "line" !== o || !r.paint || !r.paint["line-gradient"] || "geojson" === a && t1.lineMetrics || e1.push(new it(n, r, `layer "${r.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`)) : e1.push(new it(n, r, `layer "${r.id}" must specify a "source-layer"`)) : e1.push(new it(n, r.source, `source "${r.source}" not found`));
                                } else e1.push(new it(n, r, 'missing required property "source"'));
                            }
                            return e1 = e1.concat(Zn({
                                key: n,
                                value: r,
                                valueSpec: a.layer,
                                style: t1.style,
                                styleSpec: t1.styleSpec,
                                validateSpec: t1.validateSpec,
                                objectElementValidators: {
                                    "*" () {
                                        return [];
                                    },
                                    type () {
                                        return t1.validateSpec({
                                            key: `${n}.type`,
                                            value: r.type,
                                            valueSpec: a.layer.type,
                                            style: t1.style,
                                            styleSpec: t1.styleSpec,
                                            validateSpec: t1.validateSpec,
                                            object: r,
                                            objectKey: "type"
                                        });
                                    },
                                    filter: Kn,
                                    layout (t1) {
                                        return Zn({
                                            layer: r,
                                            key: t1.key,
                                            value: t1.value,
                                            style: t1.style,
                                            styleSpec: t1.styleSpec,
                                            validateSpec: t1.validateSpec,
                                            objectElementValidators: {
                                                "*" (t1) {
                                                    return ri(at({
                                                        layerType: o
                                                    }, t1));
                                                }
                                            }
                                        });
                                    },
                                    paint (t1) {
                                        return Zn({
                                            layer: r,
                                            key: t1.key,
                                            value: t1.value,
                                            style: t1.style,
                                            styleSpec: t1.styleSpec,
                                            validateSpec: t1.validateSpec,
                                            objectElementValidators: {
                                                "*" (t1) {
                                                    return ei(at({
                                                        layerType: o
                                                    }, t1));
                                                }
                                            }
                                        });
                                    }
                                }
                            })), e1;
                        }
                        function ii(t1) {
                            const e1 = t1.value, r = t1.key, n = dn(e1);
                            return "string" !== n ? [
                                new it(r, e1, `string expected, ${n} found`)
                            ] : [];
                        }
                        const ai = {
                            promoteId: function({ key: t1, value: e1 }) {
                                if ("string" === dn(e1)) return ii({
                                    key: t1,
                                    value: e1
                                });
                                {
                                    const r = [];
                                    for(const n in e1)r.push(...ii({
                                        key: `${t1}.${n}`,
                                        value: e1[n]
                                    }));
                                    return r;
                                }
                            }
                        };
                        function oi(t1) {
                            const e1 = t1.value, r = t1.key, n = t1.styleSpec, i = t1.style, a = t1.validateSpec;
                            if (!e1.type) return [
                                new it(r, e1, '"type" is required')
                            ];
                            const o = Hn(e1.type);
                            let s;
                            switch(o){
                                case "vector":
                                case "raster":
                                    return s = Zn({
                                        key: r,
                                        value: e1,
                                        valueSpec: n[`source_${o.replace("-", "_")}`],
                                        style: t1.style,
                                        styleSpec: n,
                                        objectElementValidators: ai,
                                        validateSpec: a
                                    }), s;
                                case "raster-dem":
                                    return s = function(t1) {
                                        var e1;
                                        const r = null !== (e1 = t1.sourceName) && void 0 !== e1 ? e1 : "", n = t1.value, i = t1.styleSpec, a = i.source_raster_dem, o = t1.style;
                                        let s = [];
                                        const l = dn(n);
                                        if (void 0 === n) return s;
                                        if ("object" !== l) return s.push(new it("source_raster_dem", n, `object expected, ${l} found`)), s;
                                        const c = "custom" === Hn(n.encoding), u = [
                                            "redFactor",
                                            "greenFactor",
                                            "blueFactor",
                                            "baseShift"
                                        ], h = t1.value.encoding ? `"${t1.value.encoding}"` : "Default";
                                        for(const e1 in n)!c && u.includes(e1) ? s.push(new it(e1, n[e1], `In "${r}": "${e1}" is only valid when "encoding" is set to "custom". ${h} encoding found`)) : a[e1] ? s = s.concat(t1.validateSpec({
                                            key: e1,
                                            value: n[e1],
                                            valueSpec: a[e1],
                                            validateSpec: t1.validateSpec,
                                            style: o,
                                            styleSpec: i
                                        })) : s.push(new it(e1, n[e1], `unknown property "${e1}"`));
                                        return s;
                                    }({
                                        sourceName: r,
                                        value: e1,
                                        style: t1.style,
                                        styleSpec: n,
                                        validateSpec: a
                                    }), s;
                                case "geojson":
                                    if (s = Zn({
                                        key: r,
                                        value: e1,
                                        valueSpec: n.source_geojson,
                                        style: i,
                                        styleSpec: n,
                                        validateSpec: a,
                                        objectElementValidators: ai
                                    }), e1.cluster) for(const t1 in e1.clusterProperties){
                                        const [n, i] = e1.clusterProperties[t1], o = "string" == typeof n ? [
                                            n,
                                            [
                                                "accumulated"
                                            ],
                                            [
                                                "get",
                                                t1
                                            ]
                                        ] : n;
                                        s.push(...$n({
                                            key: `${r}.${t1}.map`,
                                            value: i,
                                            validateSpec: a,
                                            expressionContext: "cluster-map"
                                        })), s.push(...$n({
                                            key: `${r}.${t1}.reduce`,
                                            value: o,
                                            validateSpec: a,
                                            expressionContext: "cluster-reduce"
                                        }));
                                    }
                                    return s;
                                case "video":
                                    return Zn({
                                        key: r,
                                        value: e1,
                                        valueSpec: n.source_video,
                                        style: i,
                                        validateSpec: a,
                                        styleSpec: n
                                    });
                                case "image":
                                    return Zn({
                                        key: r,
                                        value: e1,
                                        valueSpec: n.source_image,
                                        style: i,
                                        validateSpec: a,
                                        styleSpec: n
                                    });
                                case "canvas":
                                    return [
                                        new it(r, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
                                    ];
                                default:
                                    return Jn({
                                        key: `${r}.type`,
                                        value: e1.type,
                                        valueSpec: {
                                            values: [
                                                "vector",
                                                "raster",
                                                "raster-dem",
                                                "geojson",
                                                "video",
                                                "image"
                                            ]
                                        },
                                        style: i,
                                        validateSpec: a,
                                        styleSpec: n
                                    });
                            }
                        }
                        function si(t1) {
                            const e1 = t1.value, r = t1.styleSpec, n = r.light, i = t1.style;
                            let a = [];
                            const o = dn(e1);
                            if (void 0 === e1) return a;
                            if ("object" !== o) return a = a.concat([
                                new it("light", e1, `object expected, ${o} found`)
                            ]), a;
                            for(const o in e1){
                                const s = o.match(/^(.*)-transition$/);
                                a = s && n[s[1]] && n[s[1]].transition ? a.concat(t1.validateSpec({
                                    key: o,
                                    value: e1[o],
                                    valueSpec: r.transition,
                                    validateSpec: t1.validateSpec,
                                    style: i,
                                    styleSpec: r
                                })) : n[o] ? a.concat(t1.validateSpec({
                                    key: o,
                                    value: e1[o],
                                    valueSpec: n[o],
                                    validateSpec: t1.validateSpec,
                                    style: i,
                                    styleSpec: r
                                })) : a.concat([
                                    new it(o, e1[o], `unknown property "${o}"`)
                                ]);
                            }
                            return a;
                        }
                        function li(t1) {
                            const e1 = t1.value, r = t1.styleSpec, n = r.sky, i = t1.style, a = dn(e1);
                            if (void 0 === e1) return [];
                            if ("object" !== a) return [
                                new it("sky", e1, `object expected, ${a} found`)
                            ];
                            let o = [];
                            for(const a in e1)o = n[a] ? o.concat(t1.validateSpec({
                                key: a,
                                value: e1[a],
                                valueSpec: n[a],
                                style: i,
                                styleSpec: r
                            })) : o.concat([
                                new it(a, e1[a], `unknown property "${a}"`)
                            ]);
                            return o;
                        }
                        function ci(t1) {
                            const e1 = t1.value, r = t1.styleSpec, n = r.terrain, i = t1.style;
                            let a = [];
                            const o = dn(e1);
                            if (void 0 === e1) return a;
                            if ("object" !== o) return a = a.concat([
                                new it("terrain", e1, `object expected, ${o} found`)
                            ]), a;
                            for(const o in e1)a = n[o] ? a.concat(t1.validateSpec({
                                key: o,
                                value: e1[o],
                                valueSpec: n[o],
                                validateSpec: t1.validateSpec,
                                style: i,
                                styleSpec: r
                            })) : a.concat([
                                new it(o, e1[o], `unknown property "${o}"`)
                            ]);
                            return a;
                        }
                        function ui(t1) {
                            let e1 = [];
                            const r = t1.value, n = t1.key;
                            if (Array.isArray(r)) {
                                const i = [], a = [];
                                for(const o in r){
                                    r[o].id && i.includes(r[o].id) && e1.push(new it(n, r, `all the sprites' ids must be unique, but ${r[o].id} is duplicated`)), i.push(r[o].id), r[o].url && a.includes(r[o].url) && e1.push(new it(n, r, `all the sprites' URLs must be unique, but ${r[o].url} is duplicated`)), a.push(r[o].url);
                                    const s = {
                                        id: {
                                            type: "string",
                                            required: !0
                                        },
                                        url: {
                                            type: "string",
                                            required: !0
                                        }
                                    };
                                    e1 = e1.concat(Zn({
                                        key: `${n}[${o}]`,
                                        value: r[o],
                                        valueSpec: s,
                                        validateSpec: t1.validateSpec
                                    }));
                                }
                                return e1;
                            }
                            return ii({
                                key: n,
                                value: r
                            });
                        }
                        const hi = {
                            "*" () {
                                return [];
                            },
                            array: Wn,
                            boolean: function(t1) {
                                const e1 = t1.value, r = t1.key, n = dn(e1);
                                return "boolean" !== n ? [
                                    new it(r, e1, `boolean expected, ${n} found`)
                                ] : [];
                            },
                            number: Yn,
                            color: function(t1) {
                                const e1 = t1.key, r = t1.value, n = dn(r);
                                return "string" !== n ? [
                                    new it(e1, r, `color expected, ${n} found`)
                                ] : Xt.parse(String(r)) ? [] : [
                                    new it(e1, r, `color expected, "${r}" found`)
                                ];
                            },
                            constants: qn,
                            enum: Jn,
                            filter: Kn,
                            function: Xn,
                            layer: ni,
                            object: Zn,
                            source: oi,
                            light: si,
                            sky: li,
                            terrain: ci,
                            projection: function(t1) {
                                const e1 = t1.value, r = t1.styleSpec, n = r.projection, i = t1.style, a = dn(e1);
                                if (void 0 === e1) return [];
                                if ("object" !== a) return [
                                    new it("projection", e1, `object expected, ${a} found`)
                                ];
                                let o = [];
                                for(const a in e1)o = n[a] ? o.concat(t1.validateSpec({
                                    key: a,
                                    value: e1[a],
                                    valueSpec: n[a],
                                    style: i,
                                    styleSpec: r
                                })) : o.concat([
                                    new it(a, e1[a], `unknown property "${a}"`)
                                ]);
                                return o;
                            },
                            string: ii,
                            formatted: function(t1) {
                                return 0 === ii(t1).length ? [] : $n(t1);
                            },
                            resolvedImage: function(t1) {
                                return 0 === ii(t1).length ? [] : $n(t1);
                            },
                            padding: function(t1) {
                                const e1 = t1.key, r = t1.value;
                                if ("array" === dn(r)) {
                                    if (r.length < 1 || r.length > 4) return [
                                        new it(e1, r, `padding requires 1 to 4 values; ${r.length} values found`)
                                    ];
                                    const n = {
                                        type: "number"
                                    };
                                    let i = [];
                                    for(let a = 0; a < r.length; a++)i = i.concat(t1.validateSpec({
                                        key: `${e1}[${a}]`,
                                        value: r[a],
                                        validateSpec: t1.validateSpec,
                                        valueSpec: n
                                    }));
                                    return i;
                                }
                                return Yn({
                                    key: e1,
                                    value: r,
                                    valueSpec: {}
                                });
                            },
                            variableAnchorOffsetCollection: function(t1) {
                                const e1 = t1.key, r = t1.value, n = dn(r), i = t1.styleSpec;
                                if ("array" !== n || r.length < 1 || r.length % 2 != 0) return [
                                    new it(e1, r, "variableAnchorOffsetCollection requires a non-empty array of even length")
                                ];
                                let a = [];
                                for(let n = 0; n < r.length; n += 2)a = a.concat(Jn({
                                    key: `${e1}[${n}]`,
                                    value: r[n],
                                    valueSpec: i.layout_symbol["text-anchor"]
                                })), a = a.concat(Wn({
                                    key: `${e1}[${n + 1}]`,
                                    value: r[n + 1],
                                    valueSpec: {
                                        length: 2,
                                        value: "number"
                                    },
                                    validateSpec: t1.validateSpec,
                                    style: t1.style,
                                    styleSpec: i
                                }));
                                return a;
                            },
                            sprite: ui
                        };
                        function fi(t1) {
                            const e1 = t1.value, r = t1.valueSpec, n = t1.styleSpec;
                            return t1.validateSpec = fi, r.expression && mn(Hn(e1)) ? Xn(t1) : r.expression && kn(Gn(e1)) ? $n(t1) : r.type && hi[r.type] ? hi[r.type](t1) : Zn(at({}, t1, {
                                valueSpec: r.type ? n[r.type] : r
                            }));
                        }
                        function pi(t1) {
                            const e1 = t1.value, r = t1.key, n = ii(t1);
                            return n.length || (-1 === e1.indexOf("{fontstack}") && n.push(new it(r, e1, '"glyphs" url must include a "{fontstack}" token')), -1 === e1.indexOf("{range}") && n.push(new it(r, e1, '"glyphs" url must include a "{range}" token'))), n;
                        }
                        function di(t1, e1 = Z) {
                            let r = [];
                            return r = r.concat(fi({
                                key: "",
                                value: t1,
                                valueSpec: e1.$root,
                                styleSpec: e1,
                                style: t1,
                                validateSpec: fi,
                                objectElementValidators: {
                                    glyphs: pi,
                                    "*" () {
                                        return [];
                                    }
                                }
                            })), t1.constants && (r = r.concat(qn({
                                key: "constants",
                                value: t1.constants,
                                style: t1,
                                styleSpec: e1,
                                validateSpec: fi
                            }))), gi(r);
                        }
                        function mi(t1) {
                            return function(e1) {
                                return t1({
                                    ...e1,
                                    validateSpec: fi
                                });
                            };
                        }
                        function gi(t1) {
                            return [].concat(t1).sort((t1, e1)=>t1.line - e1.line);
                        }
                        function yi(t1) {
                            return function(...e1) {
                                return gi(t1.apply(this, e1));
                            };
                        }
                        di.source = yi(mi(oi)), di.sprite = yi(mi(ui)), di.glyphs = yi(mi(pi)), di.light = yi(mi(si)), di.sky = yi(mi(li)), di.terrain = yi(mi(ci)), di.layer = yi(mi(ni)), di.filter = yi(mi(Kn)), di.paintProperty = yi(mi(ei)), di.layoutProperty = yi(mi(ri));
                        const vi = di;
                        vi.source;
                        const xi = vi.light, _i = vi.sky;
                        vi.terrain, vi.filter;
                        const bi = vi.paintProperty, wi = vi.layoutProperty;
                        function Ti(t1, e1) {
                            let r = !1;
                            if (e1 && e1.length) for (const n of e1)t1.fire(new H(new Error(n.message))), r = !0;
                            return r;
                        }
                        class ki {
                            constructor(t1, e1, r){
                                const n = this.cells = [];
                                if (t1 instanceof ArrayBuffer) {
                                    this.arrayBuffer = t1;
                                    const i = new Int32Array(this.arrayBuffer);
                                    t1 = i[0], e1 = i[1], r = i[2], this.d = e1 + 2 * r;
                                    for(let t1 = 0; t1 < this.d * this.d; t1++){
                                        const e1 = i[3 + t1], r = i[3 + t1 + 1];
                                        n.push(e1 === r ? null : i.subarray(e1, r));
                                    }
                                    const a = i[3 + n.length], o = i[3 + n.length + 1];
                                    this.keys = i.subarray(a, o), this.bboxes = i.subarray(o), this.insert = this._insertReadonly;
                                } else {
                                    this.d = e1 + 2 * r;
                                    for(let t1 = 0; t1 < this.d * this.d; t1++)n.push([]);
                                    this.keys = [], this.bboxes = [];
                                }
                                this.n = e1, this.extent = t1, this.padding = r, this.scale = e1 / t1, this.uid = 0;
                                const i = r / e1 * t1;
                                this.min = -i, this.max = t1 + i;
                            }
                            insert(t1, e1, r, n, i) {
                                this._forEachCell(e1, r, n, i, this._insertCell, this.uid++, void 0, void 0), this.keys.push(t1), this.bboxes.push(e1), this.bboxes.push(r), this.bboxes.push(n), this.bboxes.push(i);
                            }
                            _insertReadonly() {
                                throw new Error("Cannot insert into a GridIndex created from an ArrayBuffer.");
                            }
                            _insertCell(t1, e1, r, n, i, a) {
                                this.cells[i].push(a);
                            }
                            query(t1, e1, r, n, i) {
                                const a = this.min, o = this.max;
                                if (t1 <= a && e1 <= a && o <= r && o <= n && !i) return Array.prototype.slice.call(this.keys);
                                {
                                    const a = [], o = {};
                                    return this._forEachCell(t1, e1, r, n, this._queryCell, a, o, i), a;
                                }
                            }
                            _queryCell(t1, e1, r, n, i, a, o, s) {
                                const l = this.cells[i];
                                if (null !== l) {
                                    const i = this.keys, c = this.bboxes;
                                    for(let u = 0; u < l.length; u++){
                                        const h = l[u];
                                        if (void 0 === o[h]) {
                                            const l = 4 * h;
                                            (s ? s(c[l + 0], c[l + 1], c[l + 2], c[l + 3]) : t1 <= c[l + 2] && e1 <= c[l + 3] && r >= c[l + 0] && n >= c[l + 1]) ? (o[h] = !0, a.push(i[h])) : o[h] = !1;
                                        }
                                    }
                                }
                            }
                            _forEachCell(t1, e1, r, n, i, a, o, s) {
                                const l = this._convertToCellCoord(t1), c = this._convertToCellCoord(e1), u = this._convertToCellCoord(r), h = this._convertToCellCoord(n);
                                for(let f = l; f <= u; f++)for(let l = c; l <= h; l++){
                                    const c = this.d * l + f;
                                    if ((!s || s(this._convertFromCellCoord(f), this._convertFromCellCoord(l), this._convertFromCellCoord(f + 1), this._convertFromCellCoord(l + 1))) && i.call(this, t1, e1, r, n, c, a, o, s)) return;
                                }
                            }
                            _convertFromCellCoord(t1) {
                                return (t1 - this.padding) / this.scale;
                            }
                            _convertToCellCoord(t1) {
                                return Math.max(0, Math.min(this.d - 1, Math.floor(t1 * this.scale) + this.padding));
                            }
                            toArrayBuffer() {
                                if (this.arrayBuffer) return this.arrayBuffer;
                                const t1 = this.cells, e1 = 3 + this.cells.length + 1 + 1;
                                let r = 0;
                                for(let t1 = 0; t1 < this.cells.length; t1++)r += this.cells[t1].length;
                                const n = new Int32Array(e1 + r + this.keys.length + this.bboxes.length);
                                n[0] = this.extent, n[1] = this.n, n[2] = this.padding;
                                let i = e1;
                                for(let e1 = 0; e1 < t1.length; e1++){
                                    const r = t1[e1];
                                    n[3 + e1] = i, n.set(r, i), i += r.length;
                                }
                                return n[3 + t1.length] = i, n.set(this.keys, i), i += this.keys.length, n[3 + t1.length + 1] = i, n.set(this.bboxes, i), i += this.bboxes.length, n.buffer;
                            }
                            static serialize(t1, e1) {
                                const r = t1.toArrayBuffer();
                                return e1 && e1.push(r), {
                                    buffer: r
                                };
                            }
                            static deserialize(t1) {
                                return new ki(t1.buffer);
                            }
                        }
                        const Ai = {};
                        function Mi(t1, e1, r = {}) {
                            if (Ai[t1]) throw new Error(`${t1} is already registered.`);
                            Object.defineProperty(e1, "_classRegistryKey", {
                                value: t1,
                                writeable: !1
                            }), Ai[t1] = {
                                klass: e1,
                                omit: r.omit || [],
                                shallow: r.shallow || []
                            };
                        }
                        Mi("Object", Object), Mi("TransferableGridIndex", ki), Mi("Color", Xt), Mi("Error", Error), Mi("AJAXError", F), Mi("ResolvedImage", re), Mi("StylePropertyFunction", Cn), Mi("StyleExpression", Tn, {
                            omit: [
                                "_evaluator"
                            ]
                        }), Mi("ZoomDependentExpression", Sn), Mi("ZoomConstantExpression", Mn), Mi("CompoundExpression", Qr, {
                            omit: [
                                "_evaluate"
                            ]
                        });
                        for(const t1 in Kr)Kr[t1]._classRegistryKey || Mi(`Expression_${t1}`, Kr[t1]);
                        function Si(t1) {
                            return t1 && "undefined" != typeof ArrayBuffer && (t1 instanceof ArrayBuffer || t1.constructor && "ArrayBuffer" === t1.constructor.name);
                        }
                        function Ei(t1) {
                            const e1 = t1.constructor;
                            return t1.$name || e1._classRegistryKey;
                        }
                        function Ci(t1) {
                            return !function(t1) {
                                if (null === t1 || "object" != typeof t1) return !1;
                                const e1 = Ei(t1);
                                return !(!e1 || "Object" === e1);
                            }(t1) && (null == t1 || "boolean" == typeof t1 || "number" == typeof t1 || "string" == typeof t1 || t1 instanceof Boolean || t1 instanceof Number || t1 instanceof String || t1 instanceof Date || t1 instanceof RegExp || t1 instanceof Blob || t1 instanceof Error || Si(t1) || S(t1) || ArrayBuffer.isView(t1) || t1 instanceof ImageData);
                        }
                        function Li(t1, e1) {
                            if (Ci(t1)) {
                                if ((Si(t1) || S(t1)) && e1 && e1.push(t1), ArrayBuffer.isView(t1)) {
                                    const r = t1;
                                    e1 && e1.push(r.buffer);
                                }
                                return t1 instanceof ImageData && e1 && e1.push(t1.data.buffer), t1;
                            }
                            if (Array.isArray(t1)) {
                                const r = [];
                                for (const n of t1)r.push(Li(n, e1));
                                return r;
                            }
                            if ("object" != typeof t1) throw new Error("can't serialize object of type " + typeof t1);
                            const r = Ei(t1);
                            if (!r) throw new Error(`can't serialize object of unregistered class ${t1.constructor.name}`);
                            if (!Ai[r]) throw new Error(`${r} is not registered.`);
                            const { klass: n } = Ai[r], i = n.serialize ? n.serialize(t1, e1) : {};
                            if (n.serialize) {
                                if (e1 && i === e1[e1.length - 1]) throw new Error("statically serialized object won't survive transfer of $name property");
                            } else {
                                for(const n in t1){
                                    if (!t1.hasOwnProperty(n)) continue;
                                    if (Ai[r].omit.indexOf(n) >= 0) continue;
                                    const a = t1[n];
                                    i[n] = Ai[r].shallow.indexOf(n) >= 0 ? a : Li(a, e1);
                                }
                                t1 instanceof Error && (i.message = t1.message);
                            }
                            if (i.$name) throw new Error("$name property is reserved for worker serialization logic.");
                            return "Object" !== r && (i.$name = r), i;
                        }
                        function Ii(t1) {
                            if (Ci(t1)) return t1;
                            if (Array.isArray(t1)) return t1.map(Ii);
                            if ("object" != typeof t1) throw new Error("can't deserialize object of type " + typeof t1);
                            const e1 = Ei(t1) || "Object";
                            if (!Ai[e1]) throw new Error(`can't deserialize unregistered class ${e1}`);
                            const { klass: r } = Ai[e1];
                            if (!r) throw new Error(`can't deserialize unregistered class ${e1}`);
                            if (r.deserialize) return r.deserialize(t1);
                            const n = Object.create(r.prototype);
                            for (const r of Object.keys(t1)){
                                if ("$name" === r) continue;
                                const i = t1[r];
                                n[r] = Ai[e1].shallow.indexOf(r) >= 0 ? i : Ii(i);
                            }
                            return n;
                        }
                        class Pi {
                            constructor(){
                                this.first = !0;
                            }
                            update(t1, e1) {
                                const r = Math.floor(t1);
                                return this.first ? (this.first = !1, this.lastIntegerZoom = r, this.lastIntegerZoomTime = 0, this.lastZoom = t1, this.lastFloorZoom = r, !0) : (this.lastFloorZoom > r ? (this.lastIntegerZoom = r + 1, this.lastIntegerZoomTime = e1) : this.lastFloorZoom < r && (this.lastIntegerZoom = r, this.lastIntegerZoomTime = e1), t1 !== this.lastZoom && (this.lastZoom = t1, this.lastFloorZoom = r, !0));
                            }
                        }
                        const zi = {
                            "Latin-1 Supplement": (t1)=>t1 >= 128 && t1 <= 255,
                            Arabic: (t1)=>t1 >= 1536 && t1 <= 1791,
                            "Arabic Supplement": (t1)=>t1 >= 1872 && t1 <= 1919,
                            "Arabic Extended-A": (t1)=>t1 >= 2208 && t1 <= 2303,
                            "Hangul Jamo": (t1)=>t1 >= 4352 && t1 <= 4607,
                            "Unified Canadian Aboriginal Syllabics": (t1)=>t1 >= 5120 && t1 <= 5759,
                            Khmer: (t1)=>t1 >= 6016 && t1 <= 6143,
                            "Unified Canadian Aboriginal Syllabics Extended": (t1)=>t1 >= 6320 && t1 <= 6399,
                            "General Punctuation": (t1)=>t1 >= 8192 && t1 <= 8303,
                            "Letterlike Symbols": (t1)=>t1 >= 8448 && t1 <= 8527,
                            "Number Forms": (t1)=>t1 >= 8528 && t1 <= 8591,
                            "Miscellaneous Technical": (t1)=>t1 >= 8960 && t1 <= 9215,
                            "Control Pictures": (t1)=>t1 >= 9216 && t1 <= 9279,
                            "Optical Character Recognition": (t1)=>t1 >= 9280 && t1 <= 9311,
                            "Enclosed Alphanumerics": (t1)=>t1 >= 9312 && t1 <= 9471,
                            "Geometric Shapes": (t1)=>t1 >= 9632 && t1 <= 9727,
                            "Miscellaneous Symbols": (t1)=>t1 >= 9728 && t1 <= 9983,
                            "Miscellaneous Symbols and Arrows": (t1)=>t1 >= 11008 && t1 <= 11263,
                            "CJK Radicals Supplement": (t1)=>t1 >= 11904 && t1 <= 12031,
                            "Kangxi Radicals": (t1)=>t1 >= 12032 && t1 <= 12255,
                            "Ideographic Description Characters": (t1)=>t1 >= 12272 && t1 <= 12287,
                            "CJK Symbols and Punctuation": (t1)=>t1 >= 12288 && t1 <= 12351,
                            Hiragana: (t1)=>t1 >= 12352 && t1 <= 12447,
                            Katakana: (t1)=>t1 >= 12448 && t1 <= 12543,
                            Bopomofo: (t1)=>t1 >= 12544 && t1 <= 12591,
                            "Hangul Compatibility Jamo": (t1)=>t1 >= 12592 && t1 <= 12687,
                            Kanbun: (t1)=>t1 >= 12688 && t1 <= 12703,
                            "Bopomofo Extended": (t1)=>t1 >= 12704 && t1 <= 12735,
                            "CJK Strokes": (t1)=>t1 >= 12736 && t1 <= 12783,
                            "Katakana Phonetic Extensions": (t1)=>t1 >= 12784 && t1 <= 12799,
                            "Enclosed CJK Letters and Months": (t1)=>t1 >= 12800 && t1 <= 13055,
                            "CJK Compatibility": (t1)=>t1 >= 13056 && t1 <= 13311,
                            "CJK Unified Ideographs Extension A": (t1)=>t1 >= 13312 && t1 <= 19903,
                            "Yijing Hexagram Symbols": (t1)=>t1 >= 19904 && t1 <= 19967,
                            "CJK Unified Ideographs": (t1)=>t1 >= 19968 && t1 <= 40959,
                            "Yi Syllables": (t1)=>t1 >= 40960 && t1 <= 42127,
                            "Yi Radicals": (t1)=>t1 >= 42128 && t1 <= 42191,
                            "Hangul Jamo Extended-A": (t1)=>t1 >= 43360 && t1 <= 43391,
                            "Hangul Syllables": (t1)=>t1 >= 44032 && t1 <= 55215,
                            "Hangul Jamo Extended-B": (t1)=>t1 >= 55216 && t1 <= 55295,
                            "Private Use Area": (t1)=>t1 >= 57344 && t1 <= 63743,
                            "CJK Compatibility Ideographs": (t1)=>t1 >= 63744 && t1 <= 64255,
                            "Arabic Presentation Forms-A": (t1)=>t1 >= 64336 && t1 <= 65023,
                            "Vertical Forms": (t1)=>t1 >= 65040 && t1 <= 65055,
                            "CJK Compatibility Forms": (t1)=>t1 >= 65072 && t1 <= 65103,
                            "Small Form Variants": (t1)=>t1 >= 65104 && t1 <= 65135,
                            "Arabic Presentation Forms-B": (t1)=>t1 >= 65136 && t1 <= 65279,
                            "Halfwidth and Fullwidth Forms": (t1)=>t1 >= 65280 && t1 <= 65519
                        };
                        function Oi(t1) {
                            for (const e1 of t1)if (Fi(e1.charCodeAt(0))) return !0;
                            return !1;
                        }
                        function Di(t1) {
                            for (const e1 of t1)if (!Ri(e1.charCodeAt(0))) return !1;
                            return !0;
                        }
                        function Ri(t1) {
                            return !(zi.Arabic(t1) || zi["Arabic Supplement"](t1) || zi["Arabic Extended-A"](t1) || zi["Arabic Presentation Forms-A"](t1) || zi["Arabic Presentation Forms-B"](t1));
                        }
                        function Fi(t1) {
                            return !(746 !== t1 && 747 !== t1 && (t1 < 4352 || !(zi["Bopomofo Extended"](t1) || zi.Bopomofo(t1) || zi["CJK Compatibility Forms"](t1) && !(t1 >= 65097 && t1 <= 65103) || zi["CJK Compatibility Ideographs"](t1) || zi["CJK Compatibility"](t1) || zi["CJK Radicals Supplement"](t1) || zi["CJK Strokes"](t1) || !(!zi["CJK Symbols and Punctuation"](t1) || t1 >= 12296 && t1 <= 12305 || t1 >= 12308 && t1 <= 12319 || 12336 === t1) || zi["CJK Unified Ideographs Extension A"](t1) || zi["CJK Unified Ideographs"](t1) || zi["Enclosed CJK Letters and Months"](t1) || zi["Hangul Compatibility Jamo"](t1) || zi["Hangul Jamo Extended-A"](t1) || zi["Hangul Jamo Extended-B"](t1) || zi["Hangul Jamo"](t1) || zi["Hangul Syllables"](t1) || zi.Hiragana(t1) || zi["Ideographic Description Characters"](t1) || zi.Kanbun(t1) || zi["Kangxi Radicals"](t1) || zi["Katakana Phonetic Extensions"](t1) || zi.Katakana(t1) && 12540 !== t1 || !(!zi["Halfwidth and Fullwidth Forms"](t1) || 65288 === t1 || 65289 === t1 || 65293 === t1 || t1 >= 65306 && t1 <= 65310 || 65339 === t1 || 65341 === t1 || 65343 === t1 || t1 >= 65371 && t1 <= 65503 || 65507 === t1 || t1 >= 65512 && t1 <= 65519) || !(!zi["Small Form Variants"](t1) || t1 >= 65112 && t1 <= 65118 || t1 >= 65123 && t1 <= 65126) || zi["Unified Canadian Aboriginal Syllabics"](t1) || zi["Unified Canadian Aboriginal Syllabics Extended"](t1) || zi["Vertical Forms"](t1) || zi["Yijing Hexagram Symbols"](t1) || zi["Yi Syllables"](t1) || zi["Yi Radicals"](t1))));
                        }
                        function Bi(t1) {
                            return !(Fi(t1) || function(t1) {
                                return !!(zi["Latin-1 Supplement"](t1) && (167 === t1 || 169 === t1 || 174 === t1 || 177 === t1 || 188 === t1 || 189 === t1 || 190 === t1 || 215 === t1 || 247 === t1) || zi["General Punctuation"](t1) && (8214 === t1 || 8224 === t1 || 8225 === t1 || 8240 === t1 || 8241 === t1 || 8251 === t1 || 8252 === t1 || 8258 === t1 || 8263 === t1 || 8264 === t1 || 8265 === t1 || 8273 === t1) || zi["Letterlike Symbols"](t1) || zi["Number Forms"](t1) || zi["Miscellaneous Technical"](t1) && (t1 >= 8960 && t1 <= 8967 || t1 >= 8972 && t1 <= 8991 || t1 >= 8996 && t1 <= 9e3 || 9003 === t1 || t1 >= 9085 && t1 <= 9114 || t1 >= 9150 && t1 <= 9165 || 9167 === t1 || t1 >= 9169 && t1 <= 9179 || t1 >= 9186 && t1 <= 9215) || zi["Control Pictures"](t1) && 9251 !== t1 || zi["Optical Character Recognition"](t1) || zi["Enclosed Alphanumerics"](t1) || zi["Geometric Shapes"](t1) || zi["Miscellaneous Symbols"](t1) && !(t1 >= 9754 && t1 <= 9759) || zi["Miscellaneous Symbols and Arrows"](t1) && (t1 >= 11026 && t1 <= 11055 || t1 >= 11088 && t1 <= 11097 || t1 >= 11192 && t1 <= 11243) || zi["CJK Symbols and Punctuation"](t1) || zi.Katakana(t1) || zi["Private Use Area"](t1) || zi["CJK Compatibility Forms"](t1) || zi["Small Form Variants"](t1) || zi["Halfwidth and Fullwidth Forms"](t1) || 8734 === t1 || 8756 === t1 || 8757 === t1 || t1 >= 9984 && t1 <= 10087 || t1 >= 10102 && t1 <= 10131 || 65532 === t1 || 65533 === t1);
                            }(t1));
                        }
                        function Ni(t1) {
                            return zi.Arabic(t1) || zi["Arabic Supplement"](t1) || zi["Arabic Extended-A"](t1) || zi["Arabic Presentation Forms-A"](t1) || zi["Arabic Presentation Forms-B"](t1);
                        }
                        function ji(t1) {
                            return t1 >= 1424 && t1 <= 2303 || zi["Arabic Presentation Forms-A"](t1) || zi["Arabic Presentation Forms-B"](t1);
                        }
                        function Ui(t1, e1) {
                            return !(!e1 && ji(t1) || t1 >= 2304 && t1 <= 3583 || t1 >= 3840 && t1 <= 4255 || zi.Khmer(t1));
                        }
                        function Vi(t1) {
                            for (const e1 of t1)if (ji(e1.charCodeAt(0))) return !0;
                            return !1;
                        }
                        const qi = new class {
                            constructor(){
                                this.applyArabicShaping = null, this.processBidirectionalText = null, this.processStyledBidirectionalText = null, this.pluginStatus = "unavailable", this.pluginURL = null;
                            }
                            setState(t1) {
                                this.pluginStatus = t1.pluginStatus, this.pluginURL = t1.pluginURL;
                            }
                            getState() {
                                return {
                                    pluginStatus: this.pluginStatus,
                                    pluginURL: this.pluginURL
                                };
                            }
                            setMethods(t1) {
                                this.applyArabicShaping = t1.applyArabicShaping, this.processBidirectionalText = t1.processBidirectionalText, this.processStyledBidirectionalText = t1.processStyledBidirectionalText;
                            }
                            isParsed() {
                                return null != this.applyArabicShaping && null != this.processBidirectionalText && null != this.processStyledBidirectionalText;
                            }
                            getPluginURL() {
                                return this.pluginURL;
                            }
                            getRTLTextPluginStatus() {
                                return this.pluginStatus;
                            }
                        };
                        class Hi {
                            constructor(t1, e1){
                                this.zoom = t1, e1 ? (this.now = e1.now, this.fadeDuration = e1.fadeDuration, this.zoomHistory = e1.zoomHistory, this.transition = e1.transition) : (this.now = 0, this.fadeDuration = 0, this.zoomHistory = new Pi, this.transition = {});
                            }
                            isSupportedScript(t1) {
                                return function(t1, e1) {
                                    for (const r of t1)if (!Ui(r.charCodeAt(0), e1)) return !1;
                                    return !0;
                                }(t1, "loaded" === qi.getRTLTextPluginStatus());
                            }
                            crossFadingFactor() {
                                return 0 === this.fadeDuration ? 1 : Math.min((this.now - this.zoomHistory.lastIntegerZoomTime) / this.fadeDuration, 1);
                            }
                            getCrossfadeParameters() {
                                const t1 = this.zoom, e1 = t1 - Math.floor(t1), r = this.crossFadingFactor();
                                return t1 > this.zoomHistory.lastIntegerZoom ? {
                                    fromScale: 2,
                                    toScale: 1,
                                    t: e1 + (1 - e1) * r
                                } : {
                                    fromScale: .5,
                                    toScale: 1,
                                    t: 1 - (1 - r) * e1
                                };
                            }
                        }
                        class Gi {
                            constructor(t1, e1){
                                this.property = t1, this.value = e1, this.expression = function(t1, e1) {
                                    if (mn(t1)) return new Cn(t1, e1);
                                    if (kn(t1)) {
                                        const r = En(t1, e1);
                                        if ("error" === r.result) throw new Error(r.value.map((t1)=>`${t1.key}: ${t1.message}`).join(", "));
                                        return r.value;
                                    }
                                    {
                                        let r = t1;
                                        return "color" === e1.type && "string" == typeof t1 ? r = Xt.parse(t1) : "padding" !== e1.type || "number" != typeof t1 && !Array.isArray(t1) ? "variableAnchorOffsetCollection" === e1.type && Array.isArray(t1) && (r = ee.parse(t1)) : r = Qt.parse(t1), {
                                            kind: "constant",
                                            evaluate: ()=>r
                                        };
                                    }
                                }(void 0 === e1 ? t1.specification.default : e1, t1.specification);
                            }
                            isDataDriven() {
                                return "source" === this.expression.kind || "composite" === this.expression.kind;
                            }
                            possiblyEvaluate(t1, e1, r) {
                                return this.property.possiblyEvaluate(this, t1, e1, r);
                            }
                        }
                        class Zi {
                            constructor(t1){
                                this.property = t1, this.value = new Gi(t1, void 0);
                            }
                            transitioned(t1, e1) {
                                return new Yi(this.property, this.value, e1, y({}, t1.transition, this.transition), t1.now);
                            }
                            untransitioned() {
                                return new Yi(this.property, this.value, null, {}, 0);
                            }
                        }
                        class Wi {
                            constructor(t1){
                                this._properties = t1, this._values = Object.create(t1.defaultTransitionablePropertyValues);
                            }
                            getValue(t1) {
                                return b(this._values[t1].value.value);
                            }
                            setValue(t1, e1) {
                                Object.prototype.hasOwnProperty.call(this._values, t1) || (this._values[t1] = new Zi(this._values[t1].property)), this._values[t1].value = new Gi(this._values[t1].property, null === e1 ? void 0 : b(e1));
                            }
                            getTransition(t1) {
                                return b(this._values[t1].transition);
                            }
                            setTransition(t1, e1) {
                                Object.prototype.hasOwnProperty.call(this._values, t1) || (this._values[t1] = new Zi(this._values[t1].property)), this._values[t1].transition = b(e1) || void 0;
                            }
                            serialize() {
                                const t1 = {};
                                for (const e1 of Object.keys(this._values)){
                                    const r = this.getValue(e1);
                                    void 0 !== r && (t1[e1] = r);
                                    const n = this.getTransition(e1);
                                    void 0 !== n && (t1[`${e1}-transition`] = n);
                                }
                                return t1;
                            }
                            transitioned(t1, e1) {
                                const r = new Xi(this._properties);
                                for (const n of Object.keys(this._values))r._values[n] = this._values[n].transitioned(t1, e1._values[n]);
                                return r;
                            }
                            untransitioned() {
                                const t1 = new Xi(this._properties);
                                for (const e1 of Object.keys(this._values))t1._values[e1] = this._values[e1].untransitioned();
                                return t1;
                            }
                        }
                        class Yi {
                            constructor(t1, e1, r, n, i){
                                this.property = t1, this.value = e1, this.begin = i + n.delay || 0, this.end = this.begin + n.duration || 0, t1.specification.transition && (n.delay || n.duration) && (this.prior = r);
                            }
                            possiblyEvaluate(t1, e1, r) {
                                const n = t1.now || 0, i = this.value.possiblyEvaluate(t1, e1, r), a = this.prior;
                                if (a) {
                                    if (n > this.end) return this.prior = null, i;
                                    if (this.value.isDataDriven()) return this.prior = null, i;
                                    if (n < this.begin) return a.possiblyEvaluate(t1, e1, r);
                                    {
                                        const o = (n - this.begin) / (this.end - this.begin);
                                        return this.property.interpolate(a.possiblyEvaluate(t1, e1, r), i, function(t1) {
                                            if (t1 <= 0) return 0;
                                            if (t1 >= 1) return 1;
                                            const e1 = t1 * t1, r = e1 * t1;
                                            return 4 * (t1 < .5 ? r : 3 * (t1 - e1) + r - .75);
                                        }(o));
                                    }
                                }
                                return i;
                            }
                        }
                        class Xi {
                            constructor(t1){
                                this._properties = t1, this._values = Object.create(t1.defaultTransitioningPropertyValues);
                            }
                            possiblyEvaluate(t1, e1, r) {
                                const n = new Ki(this._properties);
                                for (const i of Object.keys(this._values))n._values[i] = this._values[i].possiblyEvaluate(t1, e1, r);
                                return n;
                            }
                            hasTransition() {
                                for (const t1 of Object.keys(this._values))if (this._values[t1].prior) return !0;
                                return !1;
                            }
                        }
                        class $i {
                            constructor(t1){
                                this._properties = t1, this._values = Object.create(t1.defaultPropertyValues);
                            }
                            hasValue(t1) {
                                return void 0 !== this._values[t1].value;
                            }
                            getValue(t1) {
                                return b(this._values[t1].value);
                            }
                            setValue(t1, e1) {
                                this._values[t1] = new Gi(this._values[t1].property, null === e1 ? void 0 : b(e1));
                            }
                            serialize() {
                                const t1 = {};
                                for (const e1 of Object.keys(this._values)){
                                    const r = this.getValue(e1);
                                    void 0 !== r && (t1[e1] = r);
                                }
                                return t1;
                            }
                            possiblyEvaluate(t1, e1, r) {
                                const n = new Ki(this._properties);
                                for (const i of Object.keys(this._values))n._values[i] = this._values[i].possiblyEvaluate(t1, e1, r);
                                return n;
                            }
                        }
                        class Ji {
                            constructor(t1, e1, r){
                                this.property = t1, this.value = e1, this.parameters = r;
                            }
                            isConstant() {
                                return "constant" === this.value.kind;
                            }
                            constantOr(t1) {
                                return "constant" === this.value.kind ? this.value.value : t1;
                            }
                            evaluate(t1, e1, r, n) {
                                return this.property.evaluate(this.value, this.parameters, t1, e1, r, n);
                            }
                        }
                        class Ki {
                            constructor(t1){
                                this._properties = t1, this._values = Object.create(t1.defaultPossiblyEvaluatedValues);
                            }
                            get(t1) {
                                return this._values[t1];
                            }
                        }
                        class Qi {
                            constructor(t1){
                                this.specification = t1;
                            }
                            possiblyEvaluate(t1, e1) {
                                if (t1.isDataDriven()) throw new Error("Value should not be data driven");
                                return t1.expression.evaluate(e1);
                            }
                            interpolate(t1, e1, r) {
                                const n = this.specification.type, i = Pe[n];
                                return i ? i(t1, e1, r) : t1;
                            }
                        }
                        class ta {
                            constructor(t1, e1){
                                this.specification = t1, this.overrides = e1;
                            }
                            possiblyEvaluate(t1, e1, r, n) {
                                return "constant" === t1.expression.kind || "camera" === t1.expression.kind ? new Ji(this, {
                                    kind: "constant",
                                    value: t1.expression.evaluate(e1, null, {}, r, n)
                                }, e1) : new Ji(this, t1.expression, e1);
                            }
                            interpolate(t1, e1, r) {
                                if ("constant" !== t1.value.kind || "constant" !== e1.value.kind) return t1;
                                if (void 0 === t1.value.value || void 0 === e1.value.value) return new Ji(this, {
                                    kind: "constant",
                                    value: void 0
                                }, t1.parameters);
                                const n = this.specification.type, i = Pe[n];
                                if (i) {
                                    const n = i(t1.value.value, e1.value.value, r);
                                    return new Ji(this, {
                                        kind: "constant",
                                        value: n
                                    }, t1.parameters);
                                }
                                return t1;
                            }
                            evaluate(t1, e1, r, n, i, a) {
                                return "constant" === t1.kind ? t1.value : t1.evaluate(e1, r, n, i, a);
                            }
                        }
                        class ea extends ta {
                            possiblyEvaluate(t1, e1, r, n) {
                                if (void 0 === t1.value) return new Ji(this, {
                                    kind: "constant",
                                    value: void 0
                                }, e1);
                                if ("constant" === t1.expression.kind) {
                                    const i = t1.expression.evaluate(e1, null, {}, r, n), a = "resolvedImage" === t1.property.specification.type && "string" != typeof i ? i.name : i, o = this._calculate(a, a, a, e1);
                                    return new Ji(this, {
                                        kind: "constant",
                                        value: o
                                    }, e1);
                                }
                                if ("camera" === t1.expression.kind) {
                                    const r = this._calculate(t1.expression.evaluate({
                                        zoom: e1.zoom - 1
                                    }), t1.expression.evaluate({
                                        zoom: e1.zoom
                                    }), t1.expression.evaluate({
                                        zoom: e1.zoom + 1
                                    }), e1);
                                    return new Ji(this, {
                                        kind: "constant",
                                        value: r
                                    }, e1);
                                }
                                return new Ji(this, t1.expression, e1);
                            }
                            evaluate(t1, e1, r, n, i, a) {
                                if ("source" === t1.kind) {
                                    const o = t1.evaluate(e1, r, n, i, a);
                                    return this._calculate(o, o, o, e1);
                                }
                                return "composite" === t1.kind ? this._calculate(t1.evaluate({
                                    zoom: Math.floor(e1.zoom) - 1
                                }, r, n), t1.evaluate({
                                    zoom: Math.floor(e1.zoom)
                                }, r, n), t1.evaluate({
                                    zoom: Math.floor(e1.zoom) + 1
                                }, r, n), e1) : t1.value;
                            }
                            _calculate(t1, e1, r, n) {
                                return n.zoom > n.zoomHistory.lastIntegerZoom ? {
                                    from: t1,
                                    to: e1
                                } : {
                                    from: r,
                                    to: e1
                                };
                            }
                            interpolate(t1) {
                                return t1;
                            }
                        }
                        class ra {
                            constructor(t1){
                                this.specification = t1;
                            }
                            possiblyEvaluate(t1, e1, r, n) {
                                if (void 0 !== t1.value) {
                                    if ("constant" === t1.expression.kind) {
                                        const i = t1.expression.evaluate(e1, null, {}, r, n);
                                        return this._calculate(i, i, i, e1);
                                    }
                                    return this._calculate(t1.expression.evaluate(new Hi(Math.floor(e1.zoom - 1), e1)), t1.expression.evaluate(new Hi(Math.floor(e1.zoom), e1)), t1.expression.evaluate(new Hi(Math.floor(e1.zoom + 1), e1)), e1);
                                }
                            }
                            _calculate(t1, e1, r, n) {
                                return n.zoom > n.zoomHistory.lastIntegerZoom ? {
                                    from: t1,
                                    to: e1
                                } : {
                                    from: r,
                                    to: e1
                                };
                            }
                            interpolate(t1) {
                                return t1;
                            }
                        }
                        class na {
                            constructor(t1){
                                this.specification = t1;
                            }
                            possiblyEvaluate(t1, e1, r, n) {
                                return !!t1.expression.evaluate(e1, null, {}, r, n);
                            }
                            interpolate() {
                                return !1;
                            }
                        }
                        class ia {
                            constructor(t1){
                                this.properties = t1, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
                                for(const e1 in t1){
                                    const r = t1[e1];
                                    r.specification.overridable && this.overridableProperties.push(e1);
                                    const n = this.defaultPropertyValues[e1] = new Gi(r, void 0), i = this.defaultTransitionablePropertyValues[e1] = new Zi(r);
                                    this.defaultTransitioningPropertyValues[e1] = i.untransitioned(), this.defaultPossiblyEvaluatedValues[e1] = n.possiblyEvaluate({});
                                }
                            }
                        }
                        Mi("DataDrivenProperty", ta), Mi("DataConstantProperty", Qi), Mi("CrossFadedDataDrivenProperty", ea), Mi("CrossFadedProperty", ra), Mi("ColorRampProperty", na);
                        const aa = "-transition";
                        class oa extends G {
                            constructor(t1, e1){
                                if (super(), this.id = t1.id, this.type = t1.type, this._featureFilter = {
                                    filter: ()=>!0,
                                    needGeometry: !1
                                }, "custom" !== t1.type && (this.metadata = t1.metadata, this.minzoom = t1.minzoom, this.maxzoom = t1.maxzoom, "background" !== t1.type && (this.source = t1.source, this.sourceLayer = t1["source-layer"], this.filter = t1.filter), e1.layout && (this._unevaluatedLayout = new $i(e1.layout)), e1.paint)) {
                                    this._transitionablePaint = new Wi(e1.paint);
                                    for(const e1 in t1.paint)this.setPaintProperty(e1, t1.paint[e1], {
                                        validate: !1
                                    });
                                    for(const e1 in t1.layout)this.setLayoutProperty(e1, t1.layout[e1], {
                                        validate: !1
                                    });
                                    this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new Ki(e1.paint);
                                }
                            }
                            getCrossfadeParameters() {
                                return this._crossfadeParameters;
                            }
                            getLayoutProperty(t1) {
                                return "visibility" === t1 ? this.visibility : this._unevaluatedLayout.getValue(t1);
                            }
                            setLayoutProperty(t1, e1, r = {}) {
                                if (null != e1) {
                                    const n = `layers.${this.id}.layout.${t1}`;
                                    if (this._validate(wi, n, t1, e1, r)) return;
                                }
                                "visibility" !== t1 ? this._unevaluatedLayout.setValue(t1, e1) : this.visibility = e1;
                            }
                            getPaintProperty(t1) {
                                return t1.endsWith(aa) ? this._transitionablePaint.getTransition(t1.slice(0, -11)) : this._transitionablePaint.getValue(t1);
                            }
                            setPaintProperty(t1, e1, r = {}) {
                                if (null != e1) {
                                    const n = `layers.${this.id}.paint.${t1}`;
                                    if (this._validate(bi, n, t1, e1, r)) return !1;
                                }
                                if (t1.endsWith(aa)) return this._transitionablePaint.setTransition(t1.slice(0, -11), e1 || void 0), !1;
                                {
                                    const r = this._transitionablePaint._values[t1], n = "cross-faded-data-driven" === r.property.specification["property-type"], i = r.value.isDataDriven(), a = r.value;
                                    this._transitionablePaint.setValue(t1, e1), this._handleSpecialPaintPropertyUpdate(t1);
                                    const o = this._transitionablePaint._values[t1].value;
                                    return o.isDataDriven() || i || n || this._handleOverridablePaintPropertyUpdate(t1, a, o);
                                }
                            }
                            _handleSpecialPaintPropertyUpdate(t1) {}
                            _handleOverridablePaintPropertyUpdate(t1, e1, r) {
                                return !1;
                            }
                            isHidden(t1) {
                                return !!(this.minzoom && t1 < this.minzoom) || !!(this.maxzoom && t1 >= this.maxzoom) || "none" === this.visibility;
                            }
                            updateTransitions(t1) {
                                this._transitioningPaint = this._transitionablePaint.transitioned(t1, this._transitioningPaint);
                            }
                            hasTransition() {
                                return this._transitioningPaint.hasTransition();
                            }
                            recalculate(t1, e1) {
                                t1.getCrossfadeParameters && (this._crossfadeParameters = t1.getCrossfadeParameters()), this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(t1, void 0, e1)), this.paint = this._transitioningPaint.possiblyEvaluate(t1, void 0, e1);
                            }
                            serialize() {
                                const t1 = {
                                    id: this.id,
                                    type: this.type,
                                    source: this.source,
                                    "source-layer": this.sourceLayer,
                                    metadata: this.metadata,
                                    minzoom: this.minzoom,
                                    maxzoom: this.maxzoom,
                                    filter: this.filter,
                                    layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
                                    paint: this._transitionablePaint && this._transitionablePaint.serialize()
                                };
                                return this.visibility && (t1.layout = t1.layout || {}, t1.layout.visibility = this.visibility), _(t1, (t1, e1)=>!(void 0 === t1 || "layout" === e1 && !Object.keys(t1).length || "paint" === e1 && !Object.keys(t1).length));
                            }
                            _validate(t1, e1, r, n, i = {}) {
                                return (!i || !1 !== i.validate) && Ti(this, t1.call(vi, {
                                    key: e1,
                                    layerType: this.type,
                                    objectKey: r,
                                    value: n,
                                    styleSpec: Z,
                                    style: {
                                        glyphs: !0,
                                        sprite: !0
                                    }
                                }));
                            }
                            is3D() {
                                return !1;
                            }
                            isTileClipped() {
                                return !1;
                            }
                            hasOffscreenPass() {
                                return !1;
                            }
                            resize() {}
                            isStateDependent() {
                                for(const t1 in this.paint._values){
                                    const e1 = this.paint.get(t1);
                                    if (e1 instanceof Ji && hn(e1.property.specification) && ("source" === e1.value.kind || "composite" === e1.value.kind) && e1.value.isStateDependent) return !0;
                                }
                                return !1;
                            }
                        }
                        const sa = {
                            Int8: Int8Array,
                            Uint8: Uint8Array,
                            Int16: Int16Array,
                            Uint16: Uint16Array,
                            Int32: Int32Array,
                            Uint32: Uint32Array,
                            Float32: Float32Array
                        };
                        class la {
                            constructor(t1, e1){
                                this._structArray = t1, this._pos1 = e1 * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
                            }
                        }
                        class ca {
                            constructor(){
                                this.isTransferred = !1, this.capacity = -1, this.resize(0);
                            }
                            static serialize(t1, e1) {
                                return t1._trim(), e1 && (t1.isTransferred = !0, e1.push(t1.arrayBuffer)), {
                                    length: t1.length,
                                    arrayBuffer: t1.arrayBuffer
                                };
                            }
                            static deserialize(t1) {
                                const e1 = Object.create(this.prototype);
                                return e1.arrayBuffer = t1.arrayBuffer, e1.length = t1.length, e1.capacity = t1.arrayBuffer.byteLength / e1.bytesPerElement, e1._refreshViews(), e1;
                            }
                            _trim() {
                                this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
                            }
                            clear() {
                                this.length = 0;
                            }
                            resize(t1) {
                                this.reserve(t1), this.length = t1;
                            }
                            reserve(t1) {
                                if (t1 > this.capacity) {
                                    this.capacity = Math.max(t1, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                                    const e1 = this.uint8;
                                    this._refreshViews(), e1 && this.uint8.set(e1);
                                }
                            }
                            _refreshViews() {
                                throw new Error("_refreshViews() must be implemented by each concrete StructArray layout");
                            }
                        }
                        function ua(t1, e1 = 1) {
                            let r = 0, n = 0;
                            return {
                                members: t1.map((t1)=>{
                                    const i = (s = t1.type, sa[s].BYTES_PER_ELEMENT), a = r = ha(r, Math.max(e1, i)), o = t1.components || 1;
                                    var s;
                                    return n = Math.max(n, i), r += i * o, {
                                        name: t1.name,
                                        type: t1.type,
                                        components: o,
                                        offset: a
                                    };
                                }),
                                size: ha(r, Math.max(n, e1)),
                                alignment: e1
                            };
                        }
                        function ha(t1, e1) {
                            return Math.ceil(t1 / e1) * e1;
                        }
                        class fa extends ca {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }
                            emplaceBack(t1, e1) {
                                const r = this.length;
                                return this.resize(r + 1), this.emplace(r, t1, e1);
                            }
                            emplace(t1, e1, r) {
                                const n = 2 * t1;
                                return this.int16[n + 0] = e1, this.int16[n + 1] = r, t1;
                            }
                        }
                        fa.prototype.bytesPerElement = 4, Mi("StructArrayLayout2i4", fa);
                        class pa extends ca {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }
                            emplaceBack(t1, e1, r) {
                                const n = this.length;
                                return this.resize(n + 1), this.emplace(n, t1, e1, r);
                            }
                            emplace(t1, e1, r, n) {
                                const i = 3 * t1;
                                return this.int16[i + 0] = e1, this.int16[i + 1] = r, this.int16[i + 2] = n, t1;
                            }
                        }
                        pa.prototype.bytesPerElement = 6, Mi("StructArrayLayout3i6", pa);
                        class da extends ca {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }
                            emplaceBack(t1, e1, r, n) {
                                const i = this.length;
                                return this.resize(i + 1), this.emplace(i, t1, e1, r, n);
                            }
                            emplace(t1, e1, r, n, i) {
                                const a = 4 * t1;
                                return this.int16[a + 0] = e1, this.int16[a + 1] = r, this.int16[a + 2] = n, this.int16[a + 3] = i, t1;
                            }
                        }
                        da.prototype.bytesPerElement = 8, Mi("StructArrayLayout4i8", da);
                        class ma extends ca {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }
                            emplaceBack(t1, e1, r, n, i, a) {
                                const o = this.length;
                                return this.resize(o + 1), this.emplace(o, t1, e1, r, n, i, a);
                            }
                            emplace(t1, e1, r, n, i, a, o) {
                                const s = 6 * t1;
                                return this.int16[s + 0] = e1, this.int16[s + 1] = r, this.int16[s + 2] = n, this.int16[s + 3] = i, this.int16[s + 4] = a, this.int16[s + 5] = o, t1;
                            }
                        }
                        ma.prototype.bytesPerElement = 12, Mi("StructArrayLayout2i4i12", ma);
                        class ga extends ca {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }
                            emplaceBack(t1, e1, r, n, i, a) {
                                const o = this.length;
                                return this.resize(o + 1), this.emplace(o, t1, e1, r, n, i, a);
                            }
                            emplace(t1, e1, r, n, i, a, o) {
                                const s = 4 * t1, l = 8 * t1;
                                return this.int16[s + 0] = e1, this.int16[s + 1] = r, this.uint8[l + 4] = n, this.uint8[l + 5] = i, this.uint8[l + 6] = a, this.uint8[l + 7] = o, t1;
                            }
                        }
                        ga.prototype.bytesPerElement = 8, Mi("StructArrayLayout2i4ub8", ga);
                        class ya extends ca {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }
                            emplaceBack(t1, e1) {
                                const r = this.length;
                                return this.resize(r + 1), this.emplace(r, t1, e1);
                            }
                            emplace(t1, e1, r) {
                                const n = 2 * t1;
                                return this.float32[n + 0] = e1, this.float32[n + 1] = r, t1;
                            }
                        }
                        ya.prototype.bytesPerElement = 8, Mi("StructArrayLayout2f8", ya);
                        class va extends ca {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }
                            emplaceBack(t1, e1, r, n, i, a, o, s, l, c) {
                                const u = this.length;
                                return this.resize(u + 1), this.emplace(u, t1, e1, r, n, i, a, o, s, l, c);
                            }
                            emplace(t1, e1, r, n, i, a, o, s, l, c, u) {
                                const h = 10 * t1;
                                return this.uint16[h + 0] = e1, this.uint16[h + 1] = r, this.uint16[h + 2] = n, this.uint16[h + 3] = i, this.uint16[h + 4] = a, this.uint16[h + 5] = o, this.uint16[h + 6] = s, this.uint16[h + 7] = l, this.uint16[h + 8] = c, this.uint16[h + 9] = u, t1;
                            }
                        }
                        va.prototype.bytesPerElement = 20, Mi("StructArrayLayout10ui20", va);
                        class xa extends ca {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }
                            emplaceBack(t1, e1, r, n, i, a, o, s, l, c, u, h) {
                                const f = this.length;
                                return this.resize(f + 1), this.emplace(f, t1, e1, r, n, i, a, o, s, l, c, u, h);
                            }
                            emplace(t1, e1, r, n, i, a, o, s, l, c, u, h, f) {
                                const p = 12 * t1;
                                return this.int16[p + 0] = e1, this.int16[p + 1] = r, this.int16[p + 2] = n, this.int16[p + 3] = i, this.uint16[p + 4] = a, this.uint16[p + 5] = o, this.uint16[p + 6] = s, this.uint16[p + 7] = l, this.int16[p + 8] = c, this.int16[p + 9] = u, this.int16[p + 10] = h, this.int16[p + 11] = f, t1;
                            }
                        }
                        xa.prototype.bytesPerElement = 24, Mi("StructArrayLayout4i4ui4i24", xa);
                        class _a extends ca {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }
                            emplaceBack(t1, e1, r) {
                                const n = this.length;
                                return this.resize(n + 1), this.emplace(n, t1, e1, r);
                            }
                            emplace(t1, e1, r, n) {
                                const i = 3 * t1;
                                return this.float32[i + 0] = e1, this.float32[i + 1] = r, this.float32[i + 2] = n, t1;
                            }
                        }
                        _a.prototype.bytesPerElement = 12, Mi("StructArrayLayout3f12", _a);
                        class ba extends ca {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
                            }
                            emplaceBack(t1) {
                                const e1 = this.length;
                                return this.resize(e1 + 1), this.emplace(e1, t1);
                            }
                            emplace(t1, e1) {
                                const r = 1 * t1;
                                return this.uint32[r + 0] = e1, t1;
                            }
                        }
                        ba.prototype.bytesPerElement = 4, Mi("StructArrayLayout1ul4", ba);
                        class wa extends ca {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }
                            emplaceBack(t1, e1, r, n, i, a, o, s, l) {
                                const c = this.length;
                                return this.resize(c + 1), this.emplace(c, t1, e1, r, n, i, a, o, s, l);
                            }
                            emplace(t1, e1, r, n, i, a, o, s, l, c) {
                                const u = 10 * t1, h = 5 * t1;
                                return this.int16[u + 0] = e1, this.int16[u + 1] = r, this.int16[u + 2] = n, this.int16[u + 3] = i, this.int16[u + 4] = a, this.int16[u + 5] = o, this.uint32[h + 3] = s, this.uint16[u + 8] = l, this.uint16[u + 9] = c, t1;
                            }
                        }
                        wa.prototype.bytesPerElement = 20, Mi("StructArrayLayout6i1ul2ui20", wa);
                        class Ta extends ca {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }
                            emplaceBack(t1, e1, r, n, i, a) {
                                const o = this.length;
                                return this.resize(o + 1), this.emplace(o, t1, e1, r, n, i, a);
                            }
                            emplace(t1, e1, r, n, i, a, o) {
                                const s = 6 * t1;
                                return this.int16[s + 0] = e1, this.int16[s + 1] = r, this.int16[s + 2] = n, this.int16[s + 3] = i, this.int16[s + 4] = a, this.int16[s + 5] = o, t1;
                            }
                        }
                        Ta.prototype.bytesPerElement = 12, Mi("StructArrayLayout2i2i2i12", Ta);
                        class ka extends ca {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }
                            emplaceBack(t1, e1, r, n, i) {
                                const a = this.length;
                                return this.resize(a + 1), this.emplace(a, t1, e1, r, n, i);
                            }
                            emplace(t1, e1, r, n, i, a) {
                                const o = 4 * t1, s = 8 * t1;
                                return this.float32[o + 0] = e1, this.float32[o + 1] = r, this.float32[o + 2] = n, this.int16[s + 6] = i, this.int16[s + 7] = a, t1;
                            }
                        }
                        ka.prototype.bytesPerElement = 16, Mi("StructArrayLayout2f1f2i16", ka);
                        class Aa extends ca {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }
                            emplaceBack(t1, e1, r, n, i, a) {
                                const o = this.length;
                                return this.resize(o + 1), this.emplace(o, t1, e1, r, n, i, a);
                            }
                            emplace(t1, e1, r, n, i, a, o) {
                                const s = 16 * t1, l = 4 * t1, c = 8 * t1;
                                return this.uint8[s + 0] = e1, this.uint8[s + 1] = r, this.float32[l + 1] = n, this.float32[l + 2] = i, this.int16[c + 6] = a, this.int16[c + 7] = o, t1;
                            }
                        }
                        Aa.prototype.bytesPerElement = 16, Mi("StructArrayLayout2ub2f2i16", Aa);
                        class Ma extends ca {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }
                            emplaceBack(t1, e1, r) {
                                const n = this.length;
                                return this.resize(n + 1), this.emplace(n, t1, e1, r);
                            }
                            emplace(t1, e1, r, n) {
                                const i = 3 * t1;
                                return this.uint16[i + 0] = e1, this.uint16[i + 1] = r, this.uint16[i + 2] = n, t1;
                            }
                        }
                        Ma.prototype.bytesPerElement = 6, Mi("StructArrayLayout3ui6", Ma);
                        class Sa extends ca {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }
                            emplaceBack(t1, e1, r, n, i, a, o, s, l, c, u, h, f, p, d, m, g) {
                                const y = this.length;
                                return this.resize(y + 1), this.emplace(y, t1, e1, r, n, i, a, o, s, l, c, u, h, f, p, d, m, g);
                            }
                            emplace(t1, e1, r, n, i, a, o, s, l, c, u, h, f, p, d, m, g, y) {
                                const v = 24 * t1, x = 12 * t1, _ = 48 * t1;
                                return this.int16[v + 0] = e1, this.int16[v + 1] = r, this.uint16[v + 2] = n, this.uint16[v + 3] = i, this.uint32[x + 2] = a, this.uint32[x + 3] = o, this.uint32[x + 4] = s, this.uint16[v + 10] = l, this.uint16[v + 11] = c, this.uint16[v + 12] = u, this.float32[x + 7] = h, this.float32[x + 8] = f, this.uint8[_ + 36] = p, this.uint8[_ + 37] = d, this.uint8[_ + 38] = m, this.uint32[x + 10] = g, this.int16[v + 22] = y, t1;
                            }
                        }
                        Sa.prototype.bytesPerElement = 48, Mi("StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48", Sa);
                        class Ea extends ca {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }
                            emplaceBack(t1, e1, r, n, i, a, o, s, l, c, u, h, f, p, d, m, g, y, v, x, _, b, w, T, k, A, M, S) {
                                const E = this.length;
                                return this.resize(E + 1), this.emplace(E, t1, e1, r, n, i, a, o, s, l, c, u, h, f, p, d, m, g, y, v, x, _, b, w, T, k, A, M, S);
                            }
                            emplace(t1, e1, r, n, i, a, o, s, l, c, u, h, f, p, d, m, g, y, v, x, _, b, w, T, k, A, M, S, E) {
                                const C = 32 * t1, L = 16 * t1;
                                return this.int16[C + 0] = e1, this.int16[C + 1] = r, this.int16[C + 2] = n, this.int16[C + 3] = i, this.int16[C + 4] = a, this.int16[C + 5] = o, this.int16[C + 6] = s, this.int16[C + 7] = l, this.uint16[C + 8] = c, this.uint16[C + 9] = u, this.uint16[C + 10] = h, this.uint16[C + 11] = f, this.uint16[C + 12] = p, this.uint16[C + 13] = d, this.uint16[C + 14] = m, this.uint16[C + 15] = g, this.uint16[C + 16] = y, this.uint16[C + 17] = v, this.uint16[C + 18] = x, this.uint16[C + 19] = _, this.uint16[C + 20] = b, this.uint16[C + 21] = w, this.uint16[C + 22] = T, this.uint32[L + 12] = k, this.float32[L + 13] = A, this.float32[L + 14] = M, this.uint16[C + 30] = S, this.uint16[C + 31] = E, t1;
                            }
                        }
                        Ea.prototype.bytesPerElement = 64, Mi("StructArrayLayout8i15ui1ul2f2ui64", Ea);
                        class Ca extends ca {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }
                            emplaceBack(t1) {
                                const e1 = this.length;
                                return this.resize(e1 + 1), this.emplace(e1, t1);
                            }
                            emplace(t1, e1) {
                                const r = 1 * t1;
                                return this.float32[r + 0] = e1, t1;
                            }
                        }
                        Ca.prototype.bytesPerElement = 4, Mi("StructArrayLayout1f4", Ca);
                        class La extends ca {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }
                            emplaceBack(t1, e1, r) {
                                const n = this.length;
                                return this.resize(n + 1), this.emplace(n, t1, e1, r);
                            }
                            emplace(t1, e1, r, n) {
                                const i = 6 * t1, a = 3 * t1;
                                return this.uint16[i + 0] = e1, this.float32[a + 1] = r, this.float32[a + 2] = n, t1;
                            }
                        }
                        La.prototype.bytesPerElement = 12, Mi("StructArrayLayout1ui2f12", La);
                        class Ia extends ca {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }
                            emplaceBack(t1, e1, r) {
                                const n = this.length;
                                return this.resize(n + 1), this.emplace(n, t1, e1, r);
                            }
                            emplace(t1, e1, r, n) {
                                const i = 2 * t1, a = 4 * t1;
                                return this.uint32[i + 0] = e1, this.uint16[a + 2] = r, this.uint16[a + 3] = n, t1;
                            }
                        }
                        Ia.prototype.bytesPerElement = 8, Mi("StructArrayLayout1ul2ui8", Ia);
                        class Pa extends ca {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }
                            emplaceBack(t1, e1) {
                                const r = this.length;
                                return this.resize(r + 1), this.emplace(r, t1, e1);
                            }
                            emplace(t1, e1, r) {
                                const n = 2 * t1;
                                return this.uint16[n + 0] = e1, this.uint16[n + 1] = r, t1;
                            }
                        }
                        Pa.prototype.bytesPerElement = 4, Mi("StructArrayLayout2ui4", Pa);
                        class za extends ca {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }
                            emplaceBack(t1) {
                                const e1 = this.length;
                                return this.resize(e1 + 1), this.emplace(e1, t1);
                            }
                            emplace(t1, e1) {
                                const r = 1 * t1;
                                return this.uint16[r + 0] = e1, t1;
                            }
                        }
                        za.prototype.bytesPerElement = 2, Mi("StructArrayLayout1ui2", za);
                        class Oa extends ca {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }
                            emplaceBack(t1, e1, r, n) {
                                const i = this.length;
                                return this.resize(i + 1), this.emplace(i, t1, e1, r, n);
                            }
                            emplace(t1, e1, r, n, i) {
                                const a = 4 * t1;
                                return this.float32[a + 0] = e1, this.float32[a + 1] = r, this.float32[a + 2] = n, this.float32[a + 3] = i, t1;
                            }
                        }
                        Oa.prototype.bytesPerElement = 16, Mi("StructArrayLayout4f16", Oa);
                        class Da extends la {
                            get anchorPointX() {
                                return this._structArray.int16[this._pos2 + 0];
                            }
                            get anchorPointY() {
                                return this._structArray.int16[this._pos2 + 1];
                            }
                            get x1() {
                                return this._structArray.int16[this._pos2 + 2];
                            }
                            get y1() {
                                return this._structArray.int16[this._pos2 + 3];
                            }
                            get x2() {
                                return this._structArray.int16[this._pos2 + 4];
                            }
                            get y2() {
                                return this._structArray.int16[this._pos2 + 5];
                            }
                            get featureIndex() {
                                return this._structArray.uint32[this._pos4 + 3];
                            }
                            get sourceLayerIndex() {
                                return this._structArray.uint16[this._pos2 + 8];
                            }
                            get bucketIndex() {
                                return this._structArray.uint16[this._pos2 + 9];
                            }
                            get anchorPoint() {
                                return new a(this.anchorPointX, this.anchorPointY);
                            }
                        }
                        Da.prototype.size = 20;
                        class Ra extends wa {
                            get(t1) {
                                return new Da(this, t1);
                            }
                        }
                        Mi("CollisionBoxArray", Ra);
                        class Fa extends la {
                            get anchorX() {
                                return this._structArray.int16[this._pos2 + 0];
                            }
                            get anchorY() {
                                return this._structArray.int16[this._pos2 + 1];
                            }
                            get glyphStartIndex() {
                                return this._structArray.uint16[this._pos2 + 2];
                            }
                            get numGlyphs() {
                                return this._structArray.uint16[this._pos2 + 3];
                            }
                            get vertexStartIndex() {
                                return this._structArray.uint32[this._pos4 + 2];
                            }
                            get lineStartIndex() {
                                return this._structArray.uint32[this._pos4 + 3];
                            }
                            get lineLength() {
                                return this._structArray.uint32[this._pos4 + 4];
                            }
                            get segment() {
                                return this._structArray.uint16[this._pos2 + 10];
                            }
                            get lowerSize() {
                                return this._structArray.uint16[this._pos2 + 11];
                            }
                            get upperSize() {
                                return this._structArray.uint16[this._pos2 + 12];
                            }
                            get lineOffsetX() {
                                return this._structArray.float32[this._pos4 + 7];
                            }
                            get lineOffsetY() {
                                return this._structArray.float32[this._pos4 + 8];
                            }
                            get writingMode() {
                                return this._structArray.uint8[this._pos1 + 36];
                            }
                            get placedOrientation() {
                                return this._structArray.uint8[this._pos1 + 37];
                            }
                            set placedOrientation(t1) {
                                this._structArray.uint8[this._pos1 + 37] = t1;
                            }
                            get hidden() {
                                return this._structArray.uint8[this._pos1 + 38];
                            }
                            set hidden(t1) {
                                this._structArray.uint8[this._pos1 + 38] = t1;
                            }
                            get crossTileID() {
                                return this._structArray.uint32[this._pos4 + 10];
                            }
                            set crossTileID(t1) {
                                this._structArray.uint32[this._pos4 + 10] = t1;
                            }
                            get associatedIconIndex() {
                                return this._structArray.int16[this._pos2 + 22];
                            }
                        }
                        Fa.prototype.size = 48;
                        class Ba extends Sa {
                            get(t1) {
                                return new Fa(this, t1);
                            }
                        }
                        Mi("PlacedSymbolArray", Ba);
                        class Na extends la {
                            get anchorX() {
                                return this._structArray.int16[this._pos2 + 0];
                            }
                            get anchorY() {
                                return this._structArray.int16[this._pos2 + 1];
                            }
                            get rightJustifiedTextSymbolIndex() {
                                return this._structArray.int16[this._pos2 + 2];
                            }
                            get centerJustifiedTextSymbolIndex() {
                                return this._structArray.int16[this._pos2 + 3];
                            }
                            get leftJustifiedTextSymbolIndex() {
                                return this._structArray.int16[this._pos2 + 4];
                            }
                            get verticalPlacedTextSymbolIndex() {
                                return this._structArray.int16[this._pos2 + 5];
                            }
                            get placedIconSymbolIndex() {
                                return this._structArray.int16[this._pos2 + 6];
                            }
                            get verticalPlacedIconSymbolIndex() {
                                return this._structArray.int16[this._pos2 + 7];
                            }
                            get key() {
                                return this._structArray.uint16[this._pos2 + 8];
                            }
                            get textBoxStartIndex() {
                                return this._structArray.uint16[this._pos2 + 9];
                            }
                            get textBoxEndIndex() {
                                return this._structArray.uint16[this._pos2 + 10];
                            }
                            get verticalTextBoxStartIndex() {
                                return this._structArray.uint16[this._pos2 + 11];
                            }
                            get verticalTextBoxEndIndex() {
                                return this._structArray.uint16[this._pos2 + 12];
                            }
                            get iconBoxStartIndex() {
                                return this._structArray.uint16[this._pos2 + 13];
                            }
                            get iconBoxEndIndex() {
                                return this._structArray.uint16[this._pos2 + 14];
                            }
                            get verticalIconBoxStartIndex() {
                                return this._structArray.uint16[this._pos2 + 15];
                            }
                            get verticalIconBoxEndIndex() {
                                return this._structArray.uint16[this._pos2 + 16];
                            }
                            get featureIndex() {
                                return this._structArray.uint16[this._pos2 + 17];
                            }
                            get numHorizontalGlyphVertices() {
                                return this._structArray.uint16[this._pos2 + 18];
                            }
                            get numVerticalGlyphVertices() {
                                return this._structArray.uint16[this._pos2 + 19];
                            }
                            get numIconVertices() {
                                return this._structArray.uint16[this._pos2 + 20];
                            }
                            get numVerticalIconVertices() {
                                return this._structArray.uint16[this._pos2 + 21];
                            }
                            get useRuntimeCollisionCircles() {
                                return this._structArray.uint16[this._pos2 + 22];
                            }
                            get crossTileID() {
                                return this._structArray.uint32[this._pos4 + 12];
                            }
                            set crossTileID(t1) {
                                this._structArray.uint32[this._pos4 + 12] = t1;
                            }
                            get textBoxScale() {
                                return this._structArray.float32[this._pos4 + 13];
                            }
                            get collisionCircleDiameter() {
                                return this._structArray.float32[this._pos4 + 14];
                            }
                            get textAnchorOffsetStartIndex() {
                                return this._structArray.uint16[this._pos2 + 30];
                            }
                            get textAnchorOffsetEndIndex() {
                                return this._structArray.uint16[this._pos2 + 31];
                            }
                        }
                        Na.prototype.size = 64;
                        class ja extends Ea {
                            get(t1) {
                                return new Na(this, t1);
                            }
                        }
                        Mi("SymbolInstanceArray", ja);
                        class Ua extends Ca {
                            getoffsetX(t1) {
                                return this.float32[1 * t1 + 0];
                            }
                        }
                        Mi("GlyphOffsetArray", Ua);
                        class Va extends pa {
                            getx(t1) {
                                return this.int16[3 * t1 + 0];
                            }
                            gety(t1) {
                                return this.int16[3 * t1 + 1];
                            }
                            gettileUnitDistanceFromAnchor(t1) {
                                return this.int16[3 * t1 + 2];
                            }
                        }
                        Mi("SymbolLineVertexArray", Va);
                        class qa extends la {
                            get textAnchor() {
                                return this._structArray.uint16[this._pos2 + 0];
                            }
                            get textOffset0() {
                                return this._structArray.float32[this._pos4 + 1];
                            }
                            get textOffset1() {
                                return this._structArray.float32[this._pos4 + 2];
                            }
                        }
                        qa.prototype.size = 12;
                        class Ha extends La {
                            get(t1) {
                                return new qa(this, t1);
                            }
                        }
                        Mi("TextAnchorOffsetArray", Ha);
                        class Ga extends la {
                            get featureIndex() {
                                return this._structArray.uint32[this._pos4 + 0];
                            }
                            get sourceLayerIndex() {
                                return this._structArray.uint16[this._pos2 + 2];
                            }
                            get bucketIndex() {
                                return this._structArray.uint16[this._pos2 + 3];
                            }
                        }
                        Ga.prototype.size = 8;
                        class Za extends Ia {
                            get(t1) {
                                return new Ga(this, t1);
                            }
                        }
                        Mi("FeatureIndexArray", Za);
                        class Wa extends fa {
                        }
                        class Ya extends fa {
                        }
                        class Xa extends fa {
                        }
                        class $a extends ma {
                        }
                        class Ja extends ga {
                        }
                        class Ka extends ya {
                        }
                        class Qa extends va {
                        }
                        class to extends xa {
                        }
                        class eo extends _a {
                        }
                        class ro extends ba {
                        }
                        class no extends Ta {
                        }
                        class io extends Aa {
                        }
                        class ao extends Ma {
                        }
                        class oo extends Pa {
                        }
                        const so = ua([
                            {
                                name: "a_pos",
                                components: 2,
                                type: "Int16"
                            }
                        ], 4), { members: lo, size: co, alignment: uo } = so;
                        class ho {
                            constructor(t1 = []){
                                this.segments = t1;
                            }
                            prepareSegment(t1, e1, r, n) {
                                let i = this.segments[this.segments.length - 1];
                                return t1 > ho.MAX_VERTEX_ARRAY_LENGTH && T(`Max vertices per segment is ${ho.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${t1}`), (!i || i.vertexLength + t1 > ho.MAX_VERTEX_ARRAY_LENGTH || i.sortKey !== n) && (i = {
                                    vertexOffset: e1.length,
                                    primitiveOffset: r.length,
                                    vertexLength: 0,
                                    primitiveLength: 0
                                }, void 0 !== n && (i.sortKey = n), this.segments.push(i)), i;
                            }
                            get() {
                                return this.segments;
                            }
                            destroy() {
                                for (const t1 of this.segments)for(const e1 in t1.vaos)t1.vaos[e1].destroy();
                            }
                            static simpleSegment(t1, e1, r, n) {
                                return new ho([
                                    {
                                        vertexOffset: t1,
                                        primitiveOffset: e1,
                                        vertexLength: r,
                                        primitiveLength: n,
                                        vaos: {},
                                        sortKey: 0
                                    }
                                ]);
                            }
                        }
                        function fo(t1, e1) {
                            return 256 * (t1 = m(Math.floor(t1), 0, 255)) + m(Math.floor(e1), 0, 255);
                        }
                        ho.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, Mi("SegmentVector", ho);
                        const po = ua([
                            {
                                name: "a_pattern_from",
                                components: 4,
                                type: "Uint16"
                            },
                            {
                                name: "a_pattern_to",
                                components: 4,
                                type: "Uint16"
                            },
                            {
                                name: "a_pixel_ratio_from",
                                components: 1,
                                type: "Uint16"
                            },
                            {
                                name: "a_pixel_ratio_to",
                                components: 1,
                                type: "Uint16"
                            }
                        ]);
                        var mo = {
                            exports: {}
                        }, go = {
                            exports: {}
                        };
                        !function(t1) {
                            t1.exports = function(t1, e1) {
                                var r, n, i, a, o, s, l, c;
                                for(r = 3 & t1.length, n = t1.length - r, i = e1, o = 3432918353, s = 461845907, c = 0; c < n;)l = 255 & t1.charCodeAt(c) | (255 & t1.charCodeAt(++c)) << 8 | (255 & t1.charCodeAt(++c)) << 16 | (255 & t1.charCodeAt(++c)) << 24, ++c, i = 27492 + (65535 & (a = 5 * (65535 & (i = (i ^= l = (65535 & (l = (l = (65535 & l) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * s + (((l >>> 16) * s & 65535) << 16) & 4294967295) << 13 | i >>> 19)) + ((5 * (i >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (a >>> 16) & 65535) << 16);
                                switch(l = 0, r){
                                    case 3:
                                        l ^= (255 & t1.charCodeAt(c + 2)) << 16;
                                    case 2:
                                        l ^= (255 & t1.charCodeAt(c + 1)) << 8;
                                    case 1:
                                        i ^= l = (65535 & (l = (l = (65535 & (l ^= 255 & t1.charCodeAt(c))) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * s + (((l >>> 16) * s & 65535) << 16) & 4294967295;
                                }
                                return i ^= t1.length, i = 2246822507 * (65535 & (i ^= i >>> 16)) + ((2246822507 * (i >>> 16) & 65535) << 16) & 4294967295, i = 3266489909 * (65535 & (i ^= i >>> 13)) + ((3266489909 * (i >>> 16) & 65535) << 16) & 4294967295, (i ^= i >>> 16) >>> 0;
                            };
                        }(go);
                        var yo = go.exports, vo = {
                            exports: {}
                        };
                        !function(t1) {
                            t1.exports = function(t1, e1) {
                                for(var r, n = t1.length, i = e1 ^ n, a = 0; n >= 4;)r = 1540483477 * (65535 & (r = 255 & t1.charCodeAt(a) | (255 & t1.charCodeAt(++a)) << 8 | (255 & t1.charCodeAt(++a)) << 16 | (255 & t1.charCodeAt(++a)) << 24)) + ((1540483477 * (r >>> 16) & 65535) << 16), i = 1540483477 * (65535 & i) + ((1540483477 * (i >>> 16) & 65535) << 16) ^ (r = 1540483477 * (65535 & (r ^= r >>> 24)) + ((1540483477 * (r >>> 16) & 65535) << 16)), n -= 4, ++a;
                                switch(n){
                                    case 3:
                                        i ^= (255 & t1.charCodeAt(a + 2)) << 16;
                                    case 2:
                                        i ^= (255 & t1.charCodeAt(a + 1)) << 8;
                                    case 1:
                                        i = 1540483477 * (65535 & (i ^= 255 & t1.charCodeAt(a))) + ((1540483477 * (i >>> 16) & 65535) << 16);
                                }
                                return i = 1540483477 * (65535 & (i ^= i >>> 13)) + ((1540483477 * (i >>> 16) & 65535) << 16), (i ^= i >>> 15) >>> 0;
                            };
                        }(vo);
                        var xo = yo, _o = vo.exports;
                        mo.exports = xo, mo.exports.murmur3 = xo, mo.exports.murmur2 = _o;
                        var bo = r(mo.exports);
                        class wo {
                            constructor(){
                                this.ids = [], this.positions = [], this.indexed = !1;
                            }
                            add(t1, e1, r, n) {
                                this.ids.push(To(t1)), this.positions.push(e1, r, n);
                            }
                            getPositions(t1) {
                                if (!this.indexed) throw new Error("Trying to get index, but feature positions are not indexed");
                                const e1 = To(t1);
                                let r = 0, n = this.ids.length - 1;
                                for(; r < n;){
                                    const t1 = r + n >> 1;
                                    this.ids[t1] >= e1 ? n = t1 : r = t1 + 1;
                                }
                                const i = [];
                                for(; this.ids[r] === e1;){
                                    const t1 = this.positions[3 * r], e1 = this.positions[3 * r + 1], n = this.positions[3 * r + 2];
                                    i.push({
                                        index: t1,
                                        start: e1,
                                        end: n
                                    }), r++;
                                }
                                return i;
                            }
                            static serialize(t1, e1) {
                                const r = new Float64Array(t1.ids), n = new Uint32Array(t1.positions);
                                return ko(r, n, 0, r.length - 1), e1 && e1.push(r.buffer, n.buffer), {
                                    ids: r,
                                    positions: n
                                };
                            }
                            static deserialize(t1) {
                                const e1 = new wo;
                                return e1.ids = t1.ids, e1.positions = t1.positions, e1.indexed = !0, e1;
                            }
                        }
                        function To(t1) {
                            const e1 = +t1;
                            return !isNaN(e1) && e1 <= Number.MAX_SAFE_INTEGER ? e1 : bo(String(t1));
                        }
                        function ko(t1, e1, r, n) {
                            for(; r < n;){
                                const i = t1[r + n >> 1];
                                let a = r - 1, o = n + 1;
                                for(;;){
                                    do a++;
                                    while (t1[a] < i);
                                    do o--;
                                    while (t1[o] > i);
                                    if (a >= o) break;
                                    Ao(t1, a, o), Ao(e1, 3 * a, 3 * o), Ao(e1, 3 * a + 1, 3 * o + 1), Ao(e1, 3 * a + 2, 3 * o + 2);
                                }
                                o - r < n - o ? (ko(t1, e1, r, o), r = o + 1) : (ko(t1, e1, o + 1, n), n = o);
                            }
                        }
                        function Ao(t1, e1, r) {
                            const n = t1[e1];
                            t1[e1] = t1[r], t1[r] = n;
                        }
                        Mi("FeaturePositionMap", wo);
                        class Mo {
                            constructor(t1, e1){
                                this.gl = t1.gl, this.location = e1;
                            }
                        }
                        class So extends Mo {
                            constructor(t1, e1){
                                super(t1, e1), this.current = 0;
                            }
                            set(t1) {
                                this.current !== t1 && (this.current = t1, this.gl.uniform1f(this.location, t1));
                            }
                        }
                        class Eo extends Mo {
                            constructor(t1, e1){
                                super(t1, e1), this.current = [
                                    0,
                                    0,
                                    0,
                                    0
                                ];
                            }
                            set(t1) {
                                t1[0] === this.current[0] && t1[1] === this.current[1] && t1[2] === this.current[2] && t1[3] === this.current[3] || (this.current = t1, this.gl.uniform4f(this.location, t1[0], t1[1], t1[2], t1[3]));
                            }
                        }
                        class Co extends Mo {
                            constructor(t1, e1){
                                super(t1, e1), this.current = Xt.transparent;
                            }
                            set(t1) {
                                t1.r === this.current.r && t1.g === this.current.g && t1.b === this.current.b && t1.a === this.current.a || (this.current = t1, this.gl.uniform4f(this.location, t1.r, t1.g, t1.b, t1.a));
                            }
                        }
                        const Lo = new Float32Array(16);
                        function Io(t1) {
                            return [
                                fo(255 * t1.r, 255 * t1.g),
                                fo(255 * t1.b, 255 * t1.a)
                            ];
                        }
                        class Po {
                            constructor(t1, e1, r){
                                this.value = t1, this.uniformNames = e1.map((t1)=>`u_${t1}`), this.type = r;
                            }
                            setUniform(t1, e1, r) {
                                t1.set(r.constantOr(this.value));
                            }
                            getBinding(t1, e1, r) {
                                return "color" === this.type ? new Co(t1, e1) : new So(t1, e1);
                            }
                        }
                        class zo {
                            constructor(t1, e1){
                                this.uniformNames = e1.map((t1)=>`u_${t1}`), this.patternFrom = null, this.patternTo = null, this.pixelRatioFrom = 1, this.pixelRatioTo = 1;
                            }
                            setConstantPatternPositions(t1, e1) {
                                this.pixelRatioFrom = e1.pixelRatio, this.pixelRatioTo = t1.pixelRatio, this.patternFrom = e1.tlbr, this.patternTo = t1.tlbr;
                            }
                            setUniform(t1, e1, r, n) {
                                const i = "u_pattern_to" === n ? this.patternTo : "u_pattern_from" === n ? this.patternFrom : "u_pixel_ratio_to" === n ? this.pixelRatioTo : "u_pixel_ratio_from" === n ? this.pixelRatioFrom : null;
                                i && t1.set(i);
                            }
                            getBinding(t1, e1, r) {
                                return "u_pattern" === r.substr(0, 9) ? new Eo(t1, e1) : new So(t1, e1);
                            }
                        }
                        class Oo {
                            constructor(t1, e1, r, n){
                                this.expression = t1, this.type = r, this.maxValue = 0, this.paintVertexAttributes = e1.map((t1)=>({
                                        name: `a_${t1}`,
                                        type: "Float32",
                                        components: "color" === r ? 2 : 1,
                                        offset: 0
                                    })), this.paintVertexArray = new n;
                            }
                            populatePaintArray(t1, e1, r, n, i) {
                                const a = this.paintVertexArray.length, o = this.expression.evaluate(new Hi(0), e1, {}, n, [], i);
                                this.paintVertexArray.resize(t1), this._setPaintValue(a, t1, o);
                            }
                            updatePaintArray(t1, e1, r, n) {
                                const i = this.expression.evaluate({
                                    zoom: 0
                                }, r, n);
                                this._setPaintValue(t1, e1, i);
                            }
                            _setPaintValue(t1, e1, r) {
                                if ("color" === this.type) {
                                    const n = Io(r);
                                    for(let r = t1; r < e1; r++)this.paintVertexArray.emplace(r, n[0], n[1]);
                                } else {
                                    for(let n = t1; n < e1; n++)this.paintVertexArray.emplace(n, r);
                                    this.maxValue = Math.max(this.maxValue, Math.abs(r));
                                }
                            }
                            upload(t1) {
                                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
                            }
                            destroy() {
                                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
                            }
                        }
                        class Do {
                            constructor(t1, e1, r, n, i, a){
                                this.expression = t1, this.uniformNames = e1.map((t1)=>`u_${t1}_t`), this.type = r, this.useIntegerZoom = n, this.zoom = i, this.maxValue = 0, this.paintVertexAttributes = e1.map((t1)=>({
                                        name: `a_${t1}`,
                                        type: "Float32",
                                        components: "color" === r ? 4 : 2,
                                        offset: 0
                                    })), this.paintVertexArray = new a;
                            }
                            populatePaintArray(t1, e1, r, n, i) {
                                const a = this.expression.evaluate(new Hi(this.zoom), e1, {}, n, [], i), o = this.expression.evaluate(new Hi(this.zoom + 1), e1, {}, n, [], i), s = this.paintVertexArray.length;
                                this.paintVertexArray.resize(t1), this._setPaintValue(s, t1, a, o);
                            }
                            updatePaintArray(t1, e1, r, n) {
                                const i = this.expression.evaluate({
                                    zoom: this.zoom
                                }, r, n), a = this.expression.evaluate({
                                    zoom: this.zoom + 1
                                }, r, n);
                                this._setPaintValue(t1, e1, i, a);
                            }
                            _setPaintValue(t1, e1, r, n) {
                                if ("color" === this.type) {
                                    const i = Io(r), a = Io(n);
                                    for(let r = t1; r < e1; r++)this.paintVertexArray.emplace(r, i[0], i[1], a[0], a[1]);
                                } else {
                                    for(let i = t1; i < e1; i++)this.paintVertexArray.emplace(i, r, n);
                                    this.maxValue = Math.max(this.maxValue, Math.abs(r), Math.abs(n));
                                }
                            }
                            upload(t1) {
                                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
                            }
                            destroy() {
                                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
                            }
                            setUniform(t1, e1) {
                                const r = this.useIntegerZoom ? Math.floor(e1.zoom) : e1.zoom, n = m(this.expression.interpolationFactor(r, this.zoom, this.zoom + 1), 0, 1);
                                t1.set(n);
                            }
                            getBinding(t1, e1, r) {
                                return new So(t1, e1);
                            }
                        }
                        class Ro {
                            constructor(t1, e1, r, n, i, a){
                                this.expression = t1, this.type = e1, this.useIntegerZoom = r, this.zoom = n, this.layerId = a, this.zoomInPaintVertexArray = new i, this.zoomOutPaintVertexArray = new i;
                            }
                            populatePaintArray(t1, e1, r) {
                                const n = this.zoomInPaintVertexArray.length;
                                this.zoomInPaintVertexArray.resize(t1), this.zoomOutPaintVertexArray.resize(t1), this._setPaintValues(n, t1, e1.patterns && e1.patterns[this.layerId], r);
                            }
                            updatePaintArray(t1, e1, r, n, i) {
                                this._setPaintValues(t1, e1, r.patterns && r.patterns[this.layerId], i);
                            }
                            _setPaintValues(t1, e1, r, n) {
                                if (!n || !r) return;
                                const { min: i, mid: a, max: o } = r, s = n[i], l = n[a], c = n[o];
                                if (s && l && c) for(let r = t1; r < e1; r++)this.zoomInPaintVertexArray.emplace(r, l.tl[0], l.tl[1], l.br[0], l.br[1], s.tl[0], s.tl[1], s.br[0], s.br[1], l.pixelRatio, s.pixelRatio), this.zoomOutPaintVertexArray.emplace(r, l.tl[0], l.tl[1], l.br[0], l.br[1], c.tl[0], c.tl[1], c.br[0], c.br[1], l.pixelRatio, c.pixelRatio);
                            }
                            upload(t1) {
                                this.zoomInPaintVertexArray && this.zoomInPaintVertexArray.arrayBuffer && this.zoomOutPaintVertexArray && this.zoomOutPaintVertexArray.arrayBuffer && (this.zoomInPaintVertexBuffer = t1.createVertexBuffer(this.zoomInPaintVertexArray, po.members, this.expression.isStateDependent), this.zoomOutPaintVertexBuffer = t1.createVertexBuffer(this.zoomOutPaintVertexArray, po.members, this.expression.isStateDependent));
                            }
                            destroy() {
                                this.zoomOutPaintVertexBuffer && this.zoomOutPaintVertexBuffer.destroy(), this.zoomInPaintVertexBuffer && this.zoomInPaintVertexBuffer.destroy();
                            }
                        }
                        class Fo {
                            constructor(t1, e1, r){
                                this.binders = {}, this._buffers = [];
                                const n = [];
                                for(const i in t1.paint._values){
                                    if (!r(i)) continue;
                                    const a = t1.paint.get(i);
                                    if (!(a instanceof Ji && hn(a.property.specification))) continue;
                                    const o = No(i, t1.type), s = a.value, l = a.property.specification.type, c = a.property.useIntegerZoom, u = a.property.specification["property-type"], h = "cross-faded" === u || "cross-faded-data-driven" === u;
                                    if ("constant" === s.kind) this.binders[i] = h ? new zo(s.value, o) : new Po(s.value, o, l), n.push(`/u_${i}`);
                                    else if ("source" === s.kind || h) {
                                        const r = jo(i, l, "source");
                                        this.binders[i] = h ? new Ro(s, l, c, e1, r, t1.id) : new Oo(s, o, l, r), n.push(`/a_${i}`);
                                    } else {
                                        const t1 = jo(i, l, "composite");
                                        this.binders[i] = new Do(s, o, l, c, e1, t1), n.push(`/z_${i}`);
                                    }
                                }
                                this.cacheKey = n.sort().join("");
                            }
                            getMaxValue(t1) {
                                const e1 = this.binders[t1];
                                return e1 instanceof Oo || e1 instanceof Do ? e1.maxValue : 0;
                            }
                            populatePaintArrays(t1, e1, r, n, i) {
                                for(const a in this.binders){
                                    const o = this.binders[a];
                                    (o instanceof Oo || o instanceof Do || o instanceof Ro) && o.populatePaintArray(t1, e1, r, n, i);
                                }
                            }
                            setConstantPatternPositions(t1, e1) {
                                for(const r in this.binders){
                                    const n = this.binders[r];
                                    n instanceof zo && n.setConstantPatternPositions(t1, e1);
                                }
                            }
                            updatePaintArrays(t1, e1, r, n, i) {
                                let a = !1;
                                for(const o in t1){
                                    const s = e1.getPositions(o);
                                    for (const e1 of s){
                                        const s = r.feature(e1.index);
                                        for(const r in this.binders){
                                            const l = this.binders[r];
                                            if ((l instanceof Oo || l instanceof Do || l instanceof Ro) && !0 === l.expression.isStateDependent) {
                                                const c = n.paint.get(r);
                                                l.expression = c.value, l.updatePaintArray(e1.start, e1.end, s, t1[o], i), a = !0;
                                            }
                                        }
                                    }
                                }
                                return a;
                            }
                            defines() {
                                const t1 = [];
                                for(const e1 in this.binders){
                                    const r = this.binders[e1];
                                    (r instanceof Po || r instanceof zo) && t1.push(...r.uniformNames.map((t1)=>`#define HAS_UNIFORM_${t1}`));
                                }
                                return t1;
                            }
                            getBinderAttributes() {
                                const t1 = [];
                                for(const e1 in this.binders){
                                    const r = this.binders[e1];
                                    if (r instanceof Oo || r instanceof Do) for(let e1 = 0; e1 < r.paintVertexAttributes.length; e1++)t1.push(r.paintVertexAttributes[e1].name);
                                    else if (r instanceof Ro) for(let e1 = 0; e1 < po.members.length; e1++)t1.push(po.members[e1].name);
                                }
                                return t1;
                            }
                            getBinderUniforms() {
                                const t1 = [];
                                for(const e1 in this.binders){
                                    const r = this.binders[e1];
                                    if (r instanceof Po || r instanceof zo || r instanceof Do) for (const e1 of r.uniformNames)t1.push(e1);
                                }
                                return t1;
                            }
                            getPaintVertexBuffers() {
                                return this._buffers;
                            }
                            getUniforms(t1, e1) {
                                const r = [];
                                for(const n in this.binders){
                                    const i = this.binders[n];
                                    if (i instanceof Po || i instanceof zo || i instanceof Do) {
                                        for (const a of i.uniformNames)if (e1[a]) {
                                            const o = i.getBinding(t1, e1[a], a);
                                            r.push({
                                                name: a,
                                                property: n,
                                                binding: o
                                            });
                                        }
                                    }
                                }
                                return r;
                            }
                            setUniforms(t1, e1, r, n) {
                                for (const { name: t1, property: i, binding: a } of e1)this.binders[i].setUniform(a, n, r.get(i), t1);
                            }
                            updatePaintBuffers(t1) {
                                this._buffers = [];
                                for(const e1 in this.binders){
                                    const r = this.binders[e1];
                                    if (t1 && r instanceof Ro) {
                                        const e1 = 2 === t1.fromScale ? r.zoomInPaintVertexBuffer : r.zoomOutPaintVertexBuffer;
                                        e1 && this._buffers.push(e1);
                                    } else (r instanceof Oo || r instanceof Do) && r.paintVertexBuffer && this._buffers.push(r.paintVertexBuffer);
                                }
                            }
                            upload(t1) {
                                for(const e1 in this.binders){
                                    const r = this.binders[e1];
                                    (r instanceof Oo || r instanceof Do || r instanceof Ro) && r.upload(t1);
                                }
                                this.updatePaintBuffers();
                            }
                            destroy() {
                                for(const t1 in this.binders){
                                    const e1 = this.binders[t1];
                                    (e1 instanceof Oo || e1 instanceof Do || e1 instanceof Ro) && e1.destroy();
                                }
                            }
                        }
                        class Bo {
                            constructor(t1, e1, r = ()=>!0){
                                this.programConfigurations = {};
                                for (const n of t1)this.programConfigurations[n.id] = new Fo(n, e1, r);
                                this.needsUpload = !1, this._featureMap = new wo, this._bufferOffset = 0;
                            }
                            populatePaintArrays(t1, e1, r, n, i, a) {
                                for(const r in this.programConfigurations)this.programConfigurations[r].populatePaintArrays(t1, e1, n, i, a);
                                void 0 !== e1.id && this._featureMap.add(e1.id, r, this._bufferOffset, t1), this._bufferOffset = t1, this.needsUpload = !0;
                            }
                            updatePaintArrays(t1, e1, r, n) {
                                for (const i of r)this.needsUpload = this.programConfigurations[i.id].updatePaintArrays(t1, this._featureMap, e1, i, n) || this.needsUpload;
                            }
                            get(t1) {
                                return this.programConfigurations[t1];
                            }
                            upload(t1) {
                                if (this.needsUpload) {
                                    for(const e1 in this.programConfigurations)this.programConfigurations[e1].upload(t1);
                                    this.needsUpload = !1;
                                }
                            }
                            destroy() {
                                for(const t1 in this.programConfigurations)this.programConfigurations[t1].destroy();
                            }
                        }
                        function No(t1, e1) {
                            return ({
                                "text-opacity": [
                                    "opacity"
                                ],
                                "icon-opacity": [
                                    "opacity"
                                ],
                                "text-color": [
                                    "fill_color"
                                ],
                                "icon-color": [
                                    "fill_color"
                                ],
                                "text-halo-color": [
                                    "halo_color"
                                ],
                                "icon-halo-color": [
                                    "halo_color"
                                ],
                                "text-halo-blur": [
                                    "halo_blur"
                                ],
                                "icon-halo-blur": [
                                    "halo_blur"
                                ],
                                "text-halo-width": [
                                    "halo_width"
                                ],
                                "icon-halo-width": [
                                    "halo_width"
                                ],
                                "line-gap-width": [
                                    "gapwidth"
                                ],
                                "line-pattern": [
                                    "pattern_to",
                                    "pattern_from",
                                    "pixel_ratio_to",
                                    "pixel_ratio_from"
                                ],
                                "fill-pattern": [
                                    "pattern_to",
                                    "pattern_from",
                                    "pixel_ratio_to",
                                    "pixel_ratio_from"
                                ],
                                "fill-extrusion-pattern": [
                                    "pattern_to",
                                    "pattern_from",
                                    "pixel_ratio_to",
                                    "pixel_ratio_from"
                                ]
                            })[t1] || [
                                t1.replace(`${e1}-`, "").replace(/-/g, "_")
                            ];
                        }
                        function jo(t1, e1, r) {
                            const n = {
                                color: {
                                    source: ya,
                                    composite: Oa
                                },
                                number: {
                                    source: Ca,
                                    composite: ya
                                }
                            }, i = function(t1) {
                                return ({
                                    "line-pattern": {
                                        source: Qa,
                                        composite: Qa
                                    },
                                    "fill-pattern": {
                                        source: Qa,
                                        composite: Qa
                                    },
                                    "fill-extrusion-pattern": {
                                        source: Qa,
                                        composite: Qa
                                    }
                                })[t1];
                            }(t1);
                            return i && i[r] || n[e1][r];
                        }
                        Mi("ConstantBinder", Po), Mi("CrossFadedConstantBinder", zo), Mi("SourceExpressionBinder", Oo), Mi("CrossFadedCompositeBinder", Ro), Mi("CompositeExpressionBinder", Do), Mi("ProgramConfiguration", Fo, {
                            omit: [
                                "_buffers"
                            ]
                        }), Mi("ProgramConfigurationSet", Bo);
                        const Uo = 8192, Vo = Math.pow(2, 14) - 1, qo = -Vo - 1;
                        function Ho(t1) {
                            const e1 = Uo / t1.extent, r = t1.loadGeometry();
                            for(let t1 = 0; t1 < r.length; t1++){
                                const n = r[t1];
                                for(let t1 = 0; t1 < n.length; t1++){
                                    const r = n[t1], i = Math.round(r.x * e1), a = Math.round(r.y * e1);
                                    r.x = m(i, qo, Vo), r.y = m(a, qo, Vo), (i < r.x || i > r.x + 1 || a < r.y || a > r.y + 1) && T("Geometry exceeds allowed extent, reduce your vector tile buffer size");
                                }
                            }
                            return r;
                        }
                        function Go(t1, e1) {
                            return {
                                type: t1.type,
                                id: t1.id,
                                properties: t1.properties,
                                geometry: e1 ? Ho(t1) : []
                            };
                        }
                        function Zo(t1, e1, r, n, i) {
                            t1.emplaceBack(2 * e1 + (n + 1) / 2, 2 * r + (i + 1) / 2);
                        }
                        class Wo {
                            constructor(t1){
                                this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.id), this.index = t1.index, this.hasPattern = !1, this.layoutVertexArray = new Ya, this.indexArray = new ao, this.segments = new ho, this.programConfigurations = new Bo(t1.layers, t1.zoom), this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id);
                            }
                            populate(t1, e1, r) {
                                const n = this.layers[0], i = [];
                                let a = null, o = !1;
                                "circle" === n.type && (a = n.layout.get("circle-sort-key"), o = !a.isConstant());
                                for (const { feature: e1, id: n, index: s, sourceLayerIndex: l } of t1){
                                    const t1 = this.layers[0]._featureFilter.needGeometry, c = Go(e1, t1);
                                    if (!this.layers[0]._featureFilter.filter(new Hi(this.zoom), c, r)) continue;
                                    const u = o ? a.evaluate(c, {}, r) : void 0, h = {
                                        id: n,
                                        properties: e1.properties,
                                        type: e1.type,
                                        sourceLayerIndex: l,
                                        index: s,
                                        geometry: t1 ? c.geometry : Ho(e1),
                                        patterns: {},
                                        sortKey: u
                                    };
                                    i.push(h);
                                }
                                o && i.sort((t1, e1)=>t1.sortKey - e1.sortKey);
                                for (const n of i){
                                    const { geometry: i, index: a, sourceLayerIndex: o } = n, s = t1[a].feature;
                                    this.addFeature(n, i, a, r), e1.featureIndex.insert(s, i, a, o, this.index);
                                }
                            }
                            update(t1, e1, r) {
                                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r);
                            }
                            isEmpty() {
                                return 0 === this.layoutVertexArray.length;
                            }
                            uploadPending() {
                                return !this.uploaded || this.programConfigurations.needsUpload;
                            }
                            upload(t1) {
                                this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, lo), this.indexBuffer = t1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t1), this.uploaded = !0;
                            }
                            destroy() {
                                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
                            }
                            addFeature(t1, e1, r, n) {
                                for (const r of e1)for (const e1 of r){
                                    const r = e1.x, n = e1.y;
                                    if (r < 0 || r >= Uo || n < 0 || n >= Uo) continue;
                                    const i = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, t1.sortKey), a = i.vertexLength;
                                    Zo(this.layoutVertexArray, r, n, -1, -1), Zo(this.layoutVertexArray, r, n, 1, -1), Zo(this.layoutVertexArray, r, n, 1, 1), Zo(this.layoutVertexArray, r, n, -1, 1), this.indexArray.emplaceBack(a, a + 1, a + 2), this.indexArray.emplaceBack(a, a + 3, a + 2), i.vertexLength += 4, i.primitiveLength += 2;
                                }
                                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, {}, n);
                            }
                        }
                        function Yo(t1, e1) {
                            for(let r = 0; r < t1.length; r++)if (ns(e1, t1[r])) return !0;
                            for(let r = 0; r < e1.length; r++)if (ns(t1, e1[r])) return !0;
                            return !!Ko(t1, e1);
                        }
                        function Xo(t1, e1, r) {
                            return !!ns(t1, e1) || !!ts(e1, t1, r);
                        }
                        function $o(t1, e1) {
                            if (1 === t1.length) return rs(e1, t1[0]);
                            for(let r = 0; r < e1.length; r++){
                                const n = e1[r];
                                for(let e1 = 0; e1 < n.length; e1++)if (ns(t1, n[e1])) return !0;
                            }
                            for(let r = 0; r < t1.length; r++)if (rs(e1, t1[r])) return !0;
                            for(let r = 0; r < e1.length; r++)if (Ko(t1, e1[r])) return !0;
                            return !1;
                        }
                        function Jo(t1, e1, r) {
                            if (t1.length > 1) {
                                if (Ko(t1, e1)) return !0;
                                for(let n = 0; n < e1.length; n++)if (ts(e1[n], t1, r)) return !0;
                            }
                            for(let n = 0; n < t1.length; n++)if (ts(t1[n], e1, r)) return !0;
                            return !1;
                        }
                        function Ko(t1, e1) {
                            if (0 === t1.length || 0 === e1.length) return !1;
                            for(let r = 0; r < t1.length - 1; r++){
                                const n = t1[r], i = t1[r + 1];
                                for(let t1 = 0; t1 < e1.length - 1; t1++)if (Qo(n, i, e1[t1], e1[t1 + 1])) return !0;
                            }
                            return !1;
                        }
                        function Qo(t1, e1, r, n) {
                            return k(t1, r, n) !== k(e1, r, n) && k(t1, e1, r) !== k(t1, e1, n);
                        }
                        function ts(t1, e1, r) {
                            const n = r * r;
                            if (1 === e1.length) return t1.distSqr(e1[0]) < n;
                            for(let r = 1; r < e1.length; r++)if (es(t1, e1[r - 1], e1[r]) < n) return !0;
                            return !1;
                        }
                        function es(t1, e1, r) {
                            const n = e1.distSqr(r);
                            if (0 === n) return t1.distSqr(e1);
                            const i = ((t1.x - e1.x) * (r.x - e1.x) + (t1.y - e1.y) * (r.y - e1.y)) / n;
                            return i < 0 ? t1.distSqr(e1) : i > 1 ? t1.distSqr(r) : t1.distSqr(r.sub(e1)._mult(i)._add(e1));
                        }
                        function rs(t1, e1) {
                            let r, n, i, a = !1;
                            for(let o = 0; o < t1.length; o++){
                                r = t1[o];
                                for(let t1 = 0, o = r.length - 1; t1 < r.length; o = t1++)n = r[t1], i = r[o], n.y > e1.y != i.y > e1.y && e1.x < (i.x - n.x) * (e1.y - n.y) / (i.y - n.y) + n.x && (a = !a);
                            }
                            return a;
                        }
                        function ns(t1, e1) {
                            let r = !1;
                            for(let n = 0, i = t1.length - 1; n < t1.length; i = n++){
                                const a = t1[n], o = t1[i];
                                a.y > e1.y != o.y > e1.y && e1.x < (o.x - a.x) * (e1.y - a.y) / (o.y - a.y) + a.x && (r = !r);
                            }
                            return r;
                        }
                        function is(t1, e1, r) {
                            const n = r[0], i = r[2];
                            if (t1.x < n.x && e1.x < n.x || t1.x > i.x && e1.x > i.x || t1.y < n.y && e1.y < n.y || t1.y > i.y && e1.y > i.y) return !1;
                            const a = k(t1, e1, r[0]);
                            return a !== k(t1, e1, r[1]) || a !== k(t1, e1, r[2]) || a !== k(t1, e1, r[3]);
                        }
                        function as(t1, e1, r) {
                            const n = e1.paint.get(t1).value;
                            return "constant" === n.kind ? n.value : r.programConfigurations.get(e1.id).getMaxValue(t1);
                        }
                        function os(t1) {
                            return Math.sqrt(t1[0] * t1[0] + t1[1] * t1[1]);
                        }
                        function ss(t1, e1, r, n, i) {
                            if (!e1[0] && !e1[1]) return t1;
                            const o = a.convert(e1)._mult(i);
                            "viewport" === r && o._rotate(-n);
                            const s = [];
                            for(let e1 = 0; e1 < t1.length; e1++){
                                const r = t1[e1];
                                s.push(r.sub(o));
                            }
                            return s;
                        }
                        let ls;
                        Mi("CircleBucket", Wo, {
                            omit: [
                                "layers"
                            ]
                        });
                        let cs;
                        var us = {
                            get paint () {
                                return cs = cs || new ia({
                                    "circle-radius": new ta(Z.paint_circle["circle-radius"]),
                                    "circle-color": new ta(Z.paint_circle["circle-color"]),
                                    "circle-blur": new ta(Z.paint_circle["circle-blur"]),
                                    "circle-opacity": new ta(Z.paint_circle["circle-opacity"]),
                                    "circle-translate": new Qi(Z.paint_circle["circle-translate"]),
                                    "circle-translate-anchor": new Qi(Z.paint_circle["circle-translate-anchor"]),
                                    "circle-pitch-scale": new Qi(Z.paint_circle["circle-pitch-scale"]),
                                    "circle-pitch-alignment": new Qi(Z.paint_circle["circle-pitch-alignment"]),
                                    "circle-stroke-width": new ta(Z.paint_circle["circle-stroke-width"]),
                                    "circle-stroke-color": new ta(Z.paint_circle["circle-stroke-color"]),
                                    "circle-stroke-opacity": new ta(Z.paint_circle["circle-stroke-opacity"])
                                });
                            },
                            get layout () {
                                return ls = ls || new ia({
                                    "circle-sort-key": new ta(Z.layout_circle["circle-sort-key"])
                                });
                            }
                        }, hs = 1e-6, fs = "undefined" != typeof Float32Array ? Float32Array : Array;
                        function ps(t1) {
                            return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = 1, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 1, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
                        }
                        function ds(t1, e1, r) {
                            var n = e1[0], i = e1[1], a = e1[2], o = e1[3], s = e1[4], l = e1[5], c = e1[6], u = e1[7], h = e1[8], f = e1[9], p = e1[10], d = e1[11], m = e1[12], g = e1[13], y = e1[14], v = e1[15], x = r[0], _ = r[1], b = r[2], w = r[3];
                            return t1[0] = x * n + _ * s + b * h + w * m, t1[1] = x * i + _ * l + b * f + w * g, t1[2] = x * a + _ * c + b * p + w * y, t1[3] = x * o + _ * u + b * d + w * v, x = r[4], _ = r[5], b = r[6], w = r[7], t1[4] = x * n + _ * s + b * h + w * m, t1[5] = x * i + _ * l + b * f + w * g, t1[6] = x * a + _ * c + b * p + w * y, t1[7] = x * o + _ * u + b * d + w * v, x = r[8], _ = r[9], b = r[10], w = r[11], t1[8] = x * n + _ * s + b * h + w * m, t1[9] = x * i + _ * l + b * f + w * g, t1[10] = x * a + _ * c + b * p + w * y, t1[11] = x * o + _ * u + b * d + w * v, x = r[12], _ = r[13], b = r[14], w = r[15], t1[12] = x * n + _ * s + b * h + w * m, t1[13] = x * i + _ * l + b * f + w * g, t1[14] = x * a + _ * c + b * p + w * y, t1[15] = x * o + _ * u + b * d + w * v, t1;
                        }
                        Math.hypot || (Math.hypot = function() {
                            for(var t1 = 0, e1 = arguments.length; e1--;)t1 += arguments[e1] * arguments[e1];
                            return Math.sqrt(t1);
                        });
                        var ms = function(t1, e1, r, n, i) {
                            var a, o = 1 / Math.tan(e1 / 2);
                            return t1[0] = o / r, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = o, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[11] = -1, t1[12] = 0, t1[13] = 0, t1[15] = 0, null != i && i !== 1 / 0 ? (a = 1 / (n - i), t1[10] = (i + n) * a, t1[14] = 2 * i * n * a) : (t1[10] = -1, t1[14] = -2 * n), t1;
                        };
                        var gs = function(t1, e1, r, n, i, a, o) {
                            var s = 1 / (e1 - r), l = 1 / (n - i), c = 1 / (a - o);
                            return t1[0] = -2 * s, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = -2 * l, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 2 * c, t1[11] = 0, t1[12] = (e1 + r) * s, t1[13] = (i + n) * l, t1[14] = (o + a) * c, t1[15] = 1, t1;
                        };
                        var ys = ds;
                        function vs(t1, e1, r) {
                            var n = e1[0], i = e1[1], a = e1[2], o = e1[3];
                            return t1[0] = r[0] * n + r[4] * i + r[8] * a + r[12] * o, t1[1] = r[1] * n + r[5] * i + r[9] * a + r[13] * o, t1[2] = r[2] * n + r[6] * i + r[10] * a + r[14] * o, t1[3] = r[3] * n + r[7] * i + r[11] * a + r[15] * o, t1;
                        }
                        var xs, _s = function(t1, e1, r) {
                            return t1[0] = e1[0] * r[0], t1[1] = e1[1] * r[1], t1[2] = e1[2] * r[2], t1[3] = e1[3] * r[3], t1;
                        };
                        xs = new fs(4), fs != Float32Array && (xs[0] = 0, xs[1] = 0, xs[2] = 0, xs[3] = 0);
                        class bs extends oa {
                            constructor(t1){
                                super(t1, us);
                            }
                            createBucket(t1) {
                                return new Wo(t1);
                            }
                            queryRadius(t1) {
                                const e1 = t1;
                                return as("circle-radius", this, e1) + as("circle-stroke-width", this, e1) + os(this.paint.get("circle-translate"));
                            }
                            queryIntersectsFeature(t1, e1, r, n, i, a, o, s) {
                                const l = ss(t1, this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), a.angle, o), c = this.paint.get("circle-radius").evaluate(e1, r) + this.paint.get("circle-stroke-width").evaluate(e1, r), u = "map" === this.paint.get("circle-pitch-alignment"), h = u ? l : function(t1, e1) {
                                    return t1.map((t1)=>ws(t1, e1));
                                }(l, s), f = u ? c * o : c;
                                for (const t1 of n)for (const e1 of t1){
                                    const t1 = u ? e1 : ws(e1, s);
                                    let r = f;
                                    const n = vs([], [
                                        e1.x,
                                        e1.y,
                                        0,
                                        1
                                    ], s);
                                    if ("viewport" === this.paint.get("circle-pitch-scale") && "map" === this.paint.get("circle-pitch-alignment") ? r *= n[3] / a.cameraToCenterDistance : "map" === this.paint.get("circle-pitch-scale") && "viewport" === this.paint.get("circle-pitch-alignment") && (r *= a.cameraToCenterDistance / n[3]), Xo(h, t1, r)) return !0;
                                }
                                return !1;
                            }
                        }
                        function ws(t1, e1) {
                            const r = vs([], [
                                t1.x,
                                t1.y,
                                0,
                                1
                            ], e1);
                            return new a(r[0] / r[3], r[1] / r[3]);
                        }
                        class Ts extends Wo {
                        }
                        let ks;
                        Mi("HeatmapBucket", Ts, {
                            omit: [
                                "layers"
                            ]
                        });
                        var As = {
                            get paint () {
                                return ks = ks || new ia({
                                    "heatmap-radius": new ta(Z.paint_heatmap["heatmap-radius"]),
                                    "heatmap-weight": new ta(Z.paint_heatmap["heatmap-weight"]),
                                    "heatmap-intensity": new Qi(Z.paint_heatmap["heatmap-intensity"]),
                                    "heatmap-color": new na(Z.paint_heatmap["heatmap-color"]),
                                    "heatmap-opacity": new Qi(Z.paint_heatmap["heatmap-opacity"])
                                });
                            }
                        };
                        function Ms(t1, { width: e1, height: r }, n, i) {
                            if (i) {
                                if (i instanceof Uint8ClampedArray) i = new Uint8Array(i.buffer);
                                else if (i.length !== e1 * r * n) throw new RangeError(`mismatched image size. expected: ${i.length} but got: ${e1 * r * n}`);
                            } else i = new Uint8Array(e1 * r * n);
                            return t1.width = e1, t1.height = r, t1.data = i, t1;
                        }
                        function Ss(t1, { width: e1, height: r }, n) {
                            if (e1 === t1.width && r === t1.height) return;
                            const i = Ms({}, {
                                width: e1,
                                height: r
                            }, n);
                            Es(t1, i, {
                                x: 0,
                                y: 0
                            }, {
                                x: 0,
                                y: 0
                            }, {
                                width: Math.min(t1.width, e1),
                                height: Math.min(t1.height, r)
                            }, n), t1.width = e1, t1.height = r, t1.data = i.data;
                        }
                        function Es(t1, e1, r, n, i, a) {
                            if (0 === i.width || 0 === i.height) return e1;
                            if (i.width > t1.width || i.height > t1.height || r.x > t1.width - i.width || r.y > t1.height - i.height) throw new RangeError("out of range source coordinates for image copy");
                            if (i.width > e1.width || i.height > e1.height || n.x > e1.width - i.width || n.y > e1.height - i.height) throw new RangeError("out of range destination coordinates for image copy");
                            const o = t1.data, s = e1.data;
                            if (o === s) throw new Error("srcData equals dstData, so image is already copied");
                            for(let l = 0; l < i.height; l++){
                                const c = ((r.y + l) * t1.width + r.x) * a, u = ((n.y + l) * e1.width + n.x) * a;
                                for(let t1 = 0; t1 < i.width * a; t1++)s[u + t1] = o[c + t1];
                            }
                            return e1;
                        }
                        class Cs {
                            constructor(t1, e1){
                                Ms(this, t1, 1, e1);
                            }
                            resize(t1) {
                                Ss(this, t1, 1);
                            }
                            clone() {
                                return new Cs({
                                    width: this.width,
                                    height: this.height
                                }, new Uint8Array(this.data));
                            }
                            static copy(t1, e1, r, n, i) {
                                Es(t1, e1, r, n, i, 1);
                            }
                        }
                        class Ls {
                            constructor(t1, e1){
                                Ms(this, t1, 4, e1);
                            }
                            resize(t1) {
                                Ss(this, t1, 4);
                            }
                            replace(t1, e1) {
                                e1 ? this.data.set(t1) : t1 instanceof Uint8ClampedArray ? this.data = new Uint8Array(t1.buffer) : this.data = t1;
                            }
                            clone() {
                                return new Ls({
                                    width: this.width,
                                    height: this.height
                                }, new Uint8Array(this.data));
                            }
                            static copy(t1, e1, r, n, i) {
                                Es(t1, e1, r, n, i, 4);
                            }
                        }
                        function Is(t1) {
                            const e1 = {}, r = t1.resolution || 256, n = t1.clips ? t1.clips.length : 1, i = t1.image || new Ls({
                                width: r,
                                height: n
                            });
                            if (a = r, Math.log(a) / Math.LN2 % 1 != 0) throw new Error(`width is not a power of 2 - ${r}`);
                            var a;
                            const o = (r, n, a)=>{
                                e1[t1.evaluationKey] = a;
                                const o = t1.expression.evaluate(e1);
                                i.data[r + n + 0] = Math.floor(255 * o.r / o.a), i.data[r + n + 1] = Math.floor(255 * o.g / o.a), i.data[r + n + 2] = Math.floor(255 * o.b / o.a), i.data[r + n + 3] = Math.floor(255 * o.a);
                            };
                            if (t1.clips) for(let e1 = 0, i = 0; e1 < n; ++e1, i += 4 * r)for(let n = 0, a = 0; n < r; n++, a += 4){
                                const s = n / (r - 1), { start: l, end: c } = t1.clips[e1];
                                o(i, a, l * (1 - s) + c * s);
                            }
                            else for(let t1 = 0, e1 = 0; t1 < r; t1++, e1 += 4)o(0, e1, t1 / (r - 1));
                            return i;
                        }
                        Mi("AlphaImage", Cs), Mi("RGBAImage", Ls);
                        class Ps extends oa {
                            createBucket(t1) {
                                return new Ts(t1);
                            }
                            constructor(t1){
                                super(t1, As), this._updateColorRamp();
                            }
                            _handleSpecialPaintPropertyUpdate(t1) {
                                "heatmap-color" === t1 && this._updateColorRamp();
                            }
                            _updateColorRamp() {
                                const t1 = this._transitionablePaint._values["heatmap-color"].value.expression;
                                this.colorRamp = Is({
                                    expression: t1,
                                    evaluationKey: "heatmapDensity",
                                    image: this.colorRamp
                                }), this.colorRampTexture = null;
                            }
                            resize() {
                                this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null);
                            }
                            queryRadius() {
                                return 0;
                            }
                            queryIntersectsFeature() {
                                return !1;
                            }
                            hasOffscreenPass() {
                                return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility;
                            }
                        }
                        let zs;
                        var Os = {
                            get paint () {
                                return zs = zs || new ia({
                                    "hillshade-illumination-direction": new Qi(Z.paint_hillshade["hillshade-illumination-direction"]),
                                    "hillshade-illumination-anchor": new Qi(Z.paint_hillshade["hillshade-illumination-anchor"]),
                                    "hillshade-exaggeration": new Qi(Z.paint_hillshade["hillshade-exaggeration"]),
                                    "hillshade-shadow-color": new Qi(Z.paint_hillshade["hillshade-shadow-color"]),
                                    "hillshade-highlight-color": new Qi(Z.paint_hillshade["hillshade-highlight-color"]),
                                    "hillshade-accent-color": new Qi(Z.paint_hillshade["hillshade-accent-color"])
                                });
                            }
                        };
                        class Ds extends oa {
                            constructor(t1){
                                super(t1, Os);
                            }
                            hasOffscreenPass() {
                                return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility;
                            }
                        }
                        const Rs = ua([
                            {
                                name: "a_pos",
                                components: 2,
                                type: "Int16"
                            }
                        ], 4), { members: Fs, size: Bs, alignment: Ns } = Rs;
                        function js(t1, e1, r = 2) {
                            const n = e1 && e1.length, i = n ? e1[0] * r : t1.length;
                            let a = Us(t1, 0, i, r, !0);
                            const o = [];
                            if (!a || a.next === a.prev) return o;
                            let s, l, c;
                            if (n && (a = function(t1, e1, r, n) {
                                const i = [];
                                for(let r = 0, a = e1.length; r < a; r++){
                                    const o = Us(t1, e1[r] * n, r < a - 1 ? e1[r + 1] * n : t1.length, n, !1);
                                    o === o.next && (o.steiner = !0), i.push(Ks(o));
                                }
                                i.sort(Ys);
                                for(let t1 = 0; t1 < i.length; t1++)r = Xs(i[t1], r);
                                return r;
                            }(t1, e1, a, r)), t1.length > 80 * r) {
                                s = 1 / 0, l = 1 / 0;
                                let e1 = -1 / 0, n = -1 / 0;
                                for(let a = r; a < i; a += r){
                                    const r = t1[a], i = t1[a + 1];
                                    r < s && (s = r), i < l && (l = i), r > e1 && (e1 = r), i > n && (n = i);
                                }
                                c = Math.max(e1 - s, n - l), c = 0 !== c ? 32767 / c : 0;
                            }
                            return qs(a, o, r, s, l, c, 0), o;
                        }
                        function Us(t1, e1, r, n, i) {
                            let a;
                            if (i === function(t1, e1, r, n) {
                                let i = 0;
                                for(let a = e1, o = r - n; a < r; a += n)i += (t1[o] - t1[a]) * (t1[a + 1] + t1[o + 1]), o = a;
                                return i;
                            }(t1, e1, r, n) > 0) for(let i = e1; i < r; i += n)a = ll(i / n | 0, t1[i], t1[i + 1], a);
                            else for(let i = r - n; i >= e1; i -= n)a = ll(i / n | 0, t1[i], t1[i + 1], a);
                            return a && rl(a, a.next) && (cl(a), a = a.next), a;
                        }
                        function Vs(t1, e1) {
                            if (!t1) return t1;
                            e1 || (e1 = t1);
                            let r, n = t1;
                            do if (r = !1, n.steiner || !rl(n, n.next) && 0 !== el(n.prev, n, n.next)) n = n.next;
                            else {
                                if (cl(n), n = e1 = n.prev, n === n.next) break;
                                r = !0;
                            }
                            while (r || n !== e1);
                            return e1;
                        }
                        function qs(t1, e1, r, n, i, a, o) {
                            if (!t1) return;
                            !o && a && function(t1, e1, r, n) {
                                let i = t1;
                                do 0 === i.z && (i.z = Js(i.x, i.y, e1, r, n)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
                                while (i !== t1);
                                i.prevZ.nextZ = null, i.prevZ = null, function(t1) {
                                    let e1, r = 1;
                                    do {
                                        let n, i = t1;
                                        t1 = null;
                                        let a = null;
                                        for(e1 = 0; i;){
                                            e1++;
                                            let o = i, s = 0;
                                            for(let t1 = 0; t1 < r && (s++, o = o.nextZ, o); t1++);
                                            let l = r;
                                            for(; s > 0 || l > 0 && o;)0 !== s && (0 === l || !o || i.z <= o.z) ? (n = i, i = i.nextZ, s--) : (n = o, o = o.nextZ, l--), a ? a.nextZ = n : t1 = n, n.prevZ = a, a = n;
                                            i = o;
                                        }
                                        a.nextZ = null, r *= 2;
                                    }while (e1 > 1);
                                }(i);
                            }(t1, n, i, a);
                            let s = t1;
                            for(; t1.prev !== t1.next;){
                                const l = t1.prev, c = t1.next;
                                if (a ? Gs(t1, n, i, a) : Hs(t1)) e1.push(l.i, t1.i, c.i), cl(t1), t1 = c.next, s = c.next;
                                else if ((t1 = c) === s) {
                                    o ? 1 === o ? qs(t1 = Zs(Vs(t1), e1), e1, r, n, i, a, 2) : 2 === o && Ws(t1, e1, r, n, i, a) : qs(Vs(t1), e1, r, n, i, a, 1);
                                    break;
                                }
                            }
                        }
                        function Hs(t1) {
                            const e1 = t1.prev, r = t1, n = t1.next;
                            if (el(e1, r, n) >= 0) return !1;
                            const i = e1.x, a = r.x, o = n.x, s = e1.y, l = r.y, c = n.y, u = i < a ? i < o ? i : o : a < o ? a : o, h = s < l ? s < c ? s : c : l < c ? l : c, f = i > a ? i > o ? i : o : a > o ? a : o, p = s > l ? s > c ? s : c : l > c ? l : c;
                            let d = n.next;
                            for(; d !== e1;){
                                if (d.x >= u && d.x <= f && d.y >= h && d.y <= p && Qs(i, s, a, l, o, c, d.x, d.y) && el(d.prev, d, d.next) >= 0) return !1;
                                d = d.next;
                            }
                            return !0;
                        }
                        function Gs(t1, e1, r, n) {
                            const i = t1.prev, a = t1, o = t1.next;
                            if (el(i, a, o) >= 0) return !1;
                            const s = i.x, l = a.x, c = o.x, u = i.y, h = a.y, f = o.y, p = s < l ? s < c ? s : c : l < c ? l : c, d = u < h ? u < f ? u : f : h < f ? h : f, m = s > l ? s > c ? s : c : l > c ? l : c, g = u > h ? u > f ? u : f : h > f ? h : f, y = Js(p, d, e1, r, n), v = Js(m, g, e1, r, n);
                            let x = t1.prevZ, _ = t1.nextZ;
                            for(; x && x.z >= y && _ && _.z <= v;){
                                if (x.x >= p && x.x <= m && x.y >= d && x.y <= g && x !== i && x !== o && Qs(s, u, l, h, c, f, x.x, x.y) && el(x.prev, x, x.next) >= 0) return !1;
                                if (x = x.prevZ, _.x >= p && _.x <= m && _.y >= d && _.y <= g && _ !== i && _ !== o && Qs(s, u, l, h, c, f, _.x, _.y) && el(_.prev, _, _.next) >= 0) return !1;
                                _ = _.nextZ;
                            }
                            for(; x && x.z >= y;){
                                if (x.x >= p && x.x <= m && x.y >= d && x.y <= g && x !== i && x !== o && Qs(s, u, l, h, c, f, x.x, x.y) && el(x.prev, x, x.next) >= 0) return !1;
                                x = x.prevZ;
                            }
                            for(; _ && _.z <= v;){
                                if (_.x >= p && _.x <= m && _.y >= d && _.y <= g && _ !== i && _ !== o && Qs(s, u, l, h, c, f, _.x, _.y) && el(_.prev, _, _.next) >= 0) return !1;
                                _ = _.nextZ;
                            }
                            return !0;
                        }
                        function Zs(t1, e1) {
                            let r = t1;
                            do {
                                const n = r.prev, i = r.next.next;
                                !rl(n, i) && nl(n, r, r.next, i) && ol(n, i) && ol(i, n) && (e1.push(n.i, r.i, i.i), cl(r), cl(r.next), r = t1 = i), r = r.next;
                            }while (r !== t1);
                            return Vs(r);
                        }
                        function Ws(t1, e1, r, n, i, a) {
                            let o = t1;
                            do {
                                let t1 = o.next.next;
                                for(; t1 !== o.prev;){
                                    if (o.i !== t1.i && tl(o, t1)) {
                                        let s = sl(o, t1);
                                        return o = Vs(o, o.next), s = Vs(s, s.next), qs(o, e1, r, n, i, a, 0), void qs(s, e1, r, n, i, a, 0);
                                    }
                                    t1 = t1.next;
                                }
                                o = o.next;
                            }while (o !== t1);
                        }
                        function Ys(t1, e1) {
                            return t1.x - e1.x;
                        }
                        function Xs(t1, e1) {
                            const r = function(t1, e1) {
                                let r = e1;
                                const n = t1.x, i = t1.y;
                                let a, o = -1 / 0;
                                do {
                                    if (i <= r.y && i >= r.next.y && r.next.y !== r.y) {
                                        const t1 = r.x + (i - r.y) * (r.next.x - r.x) / (r.next.y - r.y);
                                        if (t1 <= n && t1 > o && (o = t1, a = r.x < r.next.x ? r : r.next, t1 === n)) return a;
                                    }
                                    r = r.next;
                                }while (r !== e1);
                                if (!a) return null;
                                const s = a, l = a.x, c = a.y;
                                let u = 1 / 0;
                                r = a;
                                do {
                                    if (n >= r.x && r.x >= l && n !== r.x && Qs(i < c ? n : o, i, l, c, i < c ? o : n, i, r.x, r.y)) {
                                        const e1 = Math.abs(i - r.y) / (n - r.x);
                                        ol(r, t1) && (e1 < u || e1 === u && (r.x > a.x || r.x === a.x && $s(a, r))) && (a = r, u = e1);
                                    }
                                    r = r.next;
                                }while (r !== s);
                                return a;
                            }(t1, e1);
                            if (!r) return e1;
                            const n = sl(r, t1);
                            return Vs(n, n.next), Vs(r, r.next);
                        }
                        function $s(t1, e1) {
                            return el(t1.prev, t1, e1.prev) < 0 && el(e1.next, t1, t1.next) < 0;
                        }
                        function Js(t1, e1, r, n, i) {
                            return (t1 = 1431655765 & ((t1 = 858993459 & ((t1 = 252645135 & ((t1 = 16711935 & ((t1 = (t1 - r) * i | 0) | t1 << 8)) | t1 << 4)) | t1 << 2)) | t1 << 1)) | (e1 = 1431655765 & ((e1 = 858993459 & ((e1 = 252645135 & ((e1 = 16711935 & ((e1 = (e1 - n) * i | 0) | e1 << 8)) | e1 << 4)) | e1 << 2)) | e1 << 1)) << 1;
                        }
                        function Ks(t1) {
                            let e1 = t1, r = t1;
                            do (e1.x < r.x || e1.x === r.x && e1.y < r.y) && (r = e1), e1 = e1.next;
                            while (e1 !== t1);
                            return r;
                        }
                        function Qs(t1, e1, r, n, i, a, o, s) {
                            return (i - o) * (e1 - s) >= (t1 - o) * (a - s) && (t1 - o) * (n - s) >= (r - o) * (e1 - s) && (r - o) * (a - s) >= (i - o) * (n - s);
                        }
                        function tl(t1, e1) {
                            return t1.next.i !== e1.i && t1.prev.i !== e1.i && !function(t1, e1) {
                                let r = t1;
                                do {
                                    if (r.i !== t1.i && r.next.i !== t1.i && r.i !== e1.i && r.next.i !== e1.i && nl(r, r.next, t1, e1)) return !0;
                                    r = r.next;
                                }while (r !== t1);
                                return !1;
                            }(t1, e1) && (ol(t1, e1) && ol(e1, t1) && function(t1, e1) {
                                let r = t1, n = !1;
                                const i = (t1.x + e1.x) / 2, a = (t1.y + e1.y) / 2;
                                do r.y > a != r.next.y > a && r.next.y !== r.y && i < (r.next.x - r.x) * (a - r.y) / (r.next.y - r.y) + r.x && (n = !n), r = r.next;
                                while (r !== t1);
                                return n;
                            }(t1, e1) && (el(t1.prev, t1, e1.prev) || el(t1, e1.prev, e1)) || rl(t1, e1) && el(t1.prev, t1, t1.next) > 0 && el(e1.prev, e1, e1.next) > 0);
                        }
                        function el(t1, e1, r) {
                            return (e1.y - t1.y) * (r.x - e1.x) - (e1.x - t1.x) * (r.y - e1.y);
                        }
                        function rl(t1, e1) {
                            return t1.x === e1.x && t1.y === e1.y;
                        }
                        function nl(t1, e1, r, n) {
                            const i = al(el(t1, e1, r)), a = al(el(t1, e1, n)), o = al(el(r, n, t1)), s = al(el(r, n, e1));
                            return i !== a && o !== s || !(0 !== i || !il(t1, r, e1)) || !(0 !== a || !il(t1, n, e1)) || !(0 !== o || !il(r, t1, n)) || !(0 !== s || !il(r, e1, n));
                        }
                        function il(t1, e1, r) {
                            return e1.x <= Math.max(t1.x, r.x) && e1.x >= Math.min(t1.x, r.x) && e1.y <= Math.max(t1.y, r.y) && e1.y >= Math.min(t1.y, r.y);
                        }
                        function al(t1) {
                            return t1 > 0 ? 1 : t1 < 0 ? -1 : 0;
                        }
                        function ol(t1, e1) {
                            return el(t1.prev, t1, t1.next) < 0 ? el(t1, e1, t1.next) >= 0 && el(t1, t1.prev, e1) >= 0 : el(t1, e1, t1.prev) < 0 || el(t1, t1.next, e1) < 0;
                        }
                        function sl(t1, e1) {
                            const r = ul(t1.i, t1.x, t1.y), n = ul(e1.i, e1.x, e1.y), i = t1.next, a = e1.prev;
                            return t1.next = e1, e1.prev = t1, r.next = i, i.prev = r, n.next = r, r.prev = n, a.next = n, n.prev = a, n;
                        }
                        function ll(t1, e1, r, n) {
                            const i = ul(t1, e1, r);
                            return n ? (i.next = n.next, i.prev = n, n.next.prev = i, n.next = i) : (i.prev = i, i.next = i), i;
                        }
                        function cl(t1) {
                            t1.next.prev = t1.prev, t1.prev.next = t1.next, t1.prevZ && (t1.prevZ.nextZ = t1.nextZ), t1.nextZ && (t1.nextZ.prevZ = t1.prevZ);
                        }
                        function ul(t1, e1, r) {
                            return {
                                i: t1,
                                x: e1,
                                y: r,
                                prev: null,
                                next: null,
                                z: 0,
                                prevZ: null,
                                nextZ: null,
                                steiner: !1
                            };
                        }
                        function hl(t1, e1, r) {
                            const n = r.patternDependencies;
                            let i = !1;
                            for (const r of e1){
                                const e1 = r.paint.get(`${t1}-pattern`);
                                e1.isConstant() || (i = !0);
                                const a = e1.constantOr(null);
                                a && (i = !0, n[a.to] = !0, n[a.from] = !0);
                            }
                            return i;
                        }
                        function fl(t1, e1, r, n, i) {
                            const a = i.patternDependencies;
                            for (const o of e1){
                                const e1 = o.paint.get(`${t1}-pattern`).value;
                                if ("constant" !== e1.kind) {
                                    let t1 = e1.evaluate({
                                        zoom: n - 1
                                    }, r, {}, i.availableImages), s = e1.evaluate({
                                        zoom: n
                                    }, r, {}, i.availableImages), l = e1.evaluate({
                                        zoom: n + 1
                                    }, r, {}, i.availableImages);
                                    t1 = t1 && t1.name ? t1.name : t1, s = s && s.name ? s.name : s, l = l && l.name ? l.name : l, a[t1] = !0, a[s] = !0, a[l] = !0, r.patterns[o.id] = {
                                        min: t1,
                                        mid: s,
                                        max: l
                                    };
                                }
                            }
                            return r;
                        }
                        class pl {
                            constructor(t1){
                                this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.id), this.index = t1.index, this.hasPattern = !1, this.patternFeatures = [], this.layoutVertexArray = new Xa, this.indexArray = new ao, this.indexArray2 = new oo, this.programConfigurations = new Bo(t1.layers, t1.zoom), this.segments = new ho, this.segments2 = new ho, this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id);
                            }
                            populate(t1, e1, r) {
                                this.hasPattern = hl("fill", this.layers, e1);
                                const n = this.layers[0].layout.get("fill-sort-key"), i = !n.isConstant(), a = [];
                                for (const { feature: o, id: s, index: l, sourceLayerIndex: c } of t1){
                                    const t1 = this.layers[0]._featureFilter.needGeometry, u = Go(o, t1);
                                    if (!this.layers[0]._featureFilter.filter(new Hi(this.zoom), u, r)) continue;
                                    const h = i ? n.evaluate(u, {}, r, e1.availableImages) : void 0, f = {
                                        id: s,
                                        properties: o.properties,
                                        type: o.type,
                                        sourceLayerIndex: c,
                                        index: l,
                                        geometry: t1 ? u.geometry : Ho(o),
                                        patterns: {},
                                        sortKey: h
                                    };
                                    a.push(f);
                                }
                                i && a.sort((t1, e1)=>t1.sortKey - e1.sortKey);
                                for (const n of a){
                                    const { geometry: i, index: a, sourceLayerIndex: o } = n;
                                    if (this.hasPattern) {
                                        const t1 = fl("fill", this.layers, n, this.zoom, e1);
                                        this.patternFeatures.push(t1);
                                    } else this.addFeature(n, i, a, r, {});
                                    const s = t1[a].feature;
                                    e1.featureIndex.insert(s, i, a, o, this.index);
                                }
                            }
                            update(t1, e1, r) {
                                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r);
                            }
                            addFeatures(t1, e1, r) {
                                for (const t1 of this.patternFeatures)this.addFeature(t1, t1.geometry, t1.index, e1, r);
                            }
                            isEmpty() {
                                return 0 === this.layoutVertexArray.length;
                            }
                            uploadPending() {
                                return !this.uploaded || this.programConfigurations.needsUpload;
                            }
                            upload(t1) {
                                this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, Fs), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.indexBuffer2 = t1.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(t1), this.uploaded = !0;
                            }
                            destroy() {
                                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
                            }
                            addFeature(t1, e1, r, n, i) {
                                for (const t1 of br(e1, 500)){
                                    let e1 = 0;
                                    for (const r of t1)e1 += r.length;
                                    const r = this.segments.prepareSegment(e1, this.layoutVertexArray, this.indexArray), n = r.vertexLength, i = [], a = [];
                                    for (const e1 of t1){
                                        if (0 === e1.length) continue;
                                        e1 !== t1[0] && a.push(i.length / 2);
                                        const r = this.segments2.prepareSegment(e1.length, this.layoutVertexArray, this.indexArray2), n = r.vertexLength;
                                        this.layoutVertexArray.emplaceBack(e1[0].x, e1[0].y), this.indexArray2.emplaceBack(n + e1.length - 1, n), i.push(e1[0].x), i.push(e1[0].y);
                                        for(let t1 = 1; t1 < e1.length; t1++)this.layoutVertexArray.emplaceBack(e1[t1].x, e1[t1].y), this.indexArray2.emplaceBack(n + t1 - 1, n + t1), i.push(e1[t1].x), i.push(e1[t1].y);
                                        r.vertexLength += e1.length, r.primitiveLength += e1.length;
                                    }
                                    const o = js(i, a);
                                    for(let t1 = 0; t1 < o.length; t1 += 3)this.indexArray.emplaceBack(n + o[t1], n + o[t1 + 1], n + o[t1 + 2]);
                                    r.vertexLength += e1, r.primitiveLength += o.length / 3;
                                }
                                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, n);
                            }
                        }
                        let dl;
                        Mi("FillBucket", pl, {
                            omit: [
                                "layers",
                                "patternFeatures"
                            ]
                        });
                        let ml;
                        var gl1 = {
                            get paint () {
                                return ml = ml || new ia({
                                    "fill-antialias": new Qi(Z.paint_fill["fill-antialias"]),
                                    "fill-opacity": new ta(Z.paint_fill["fill-opacity"]),
                                    "fill-color": new ta(Z.paint_fill["fill-color"]),
                                    "fill-outline-color": new ta(Z.paint_fill["fill-outline-color"]),
                                    "fill-translate": new Qi(Z.paint_fill["fill-translate"]),
                                    "fill-translate-anchor": new Qi(Z.paint_fill["fill-translate-anchor"]),
                                    "fill-pattern": new ea(Z.paint_fill["fill-pattern"])
                                });
                            },
                            get layout () {
                                return dl = dl || new ia({
                                    "fill-sort-key": new ta(Z.layout_fill["fill-sort-key"])
                                });
                            }
                        };
                        class yl extends oa {
                            constructor(t1){
                                super(t1, gl1);
                            }
                            recalculate(t1, e1) {
                                super.recalculate(t1, e1);
                                const r = this.paint._values["fill-outline-color"];
                                "constant" === r.value.kind && void 0 === r.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
                            }
                            createBucket(t1) {
                                return new pl(t1);
                            }
                            queryRadius() {
                                return os(this.paint.get("fill-translate"));
                            }
                            queryIntersectsFeature(t1, e1, r, n, i, a, o) {
                                return $o(ss(t1, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), a.angle, o), n);
                            }
                            isTileClipped() {
                                return !0;
                            }
                        }
                        const vl = ua([
                            {
                                name: "a_pos",
                                components: 2,
                                type: "Int16"
                            },
                            {
                                name: "a_normal_ed",
                                components: 4,
                                type: "Int16"
                            }
                        ], 4), xl = ua([
                            {
                                name: "a_centroid",
                                components: 2,
                                type: "Int16"
                            }
                        ], 4), { members: _l, size: bl, alignment: wl } = vl;
                        var Tl = {}, kl = n, Al = Ml;
                        function Ml(t1, e1, r, n, i) {
                            this.properties = {}, this.extent = r, this.type = 0, this._pbf = t1, this._geometry = -1, this._keys = n, this._values = i, t1.readFields(Sl, this, e1);
                        }
                        function Sl(t1, e1, r) {
                            1 == t1 ? e1.id = r.readVarint() : 2 == t1 ? function(t1, e1) {
                                for(var r = t1.readVarint() + t1.pos; t1.pos < r;){
                                    var n = e1._keys[t1.readVarint()], i = e1._values[t1.readVarint()];
                                    e1.properties[n] = i;
                                }
                            }(r, e1) : 3 == t1 ? e1.type = r.readVarint() : 4 == t1 && (e1._geometry = r.pos);
                        }
                        function El(t1) {
                            for(var e1, r, n = 0, i = 0, a = t1.length, o = a - 1; i < a; o = i++)e1 = t1[i], n += ((r = t1[o]).x - e1.x) * (e1.y + r.y);
                            return n;
                        }
                        Ml.types = [
                            "Unknown",
                            "Point",
                            "LineString",
                            "Polygon"
                        ], Ml.prototype.loadGeometry = function() {
                            var t1 = this._pbf;
                            t1.pos = this._geometry;
                            for(var e1, r = t1.readVarint() + t1.pos, n = 1, i = 0, a = 0, o = 0, s = []; t1.pos < r;){
                                if (i <= 0) {
                                    var l = t1.readVarint();
                                    n = 7 & l, i = l >> 3;
                                }
                                if (i--, 1 === n || 2 === n) a += t1.readSVarint(), o += t1.readSVarint(), 1 === n && (e1 && s.push(e1), e1 = []), e1.push(new kl(a, o));
                                else {
                                    if (7 !== n) throw new Error("unknown command " + n);
                                    e1 && e1.push(e1[0].clone());
                                }
                            }
                            return e1 && s.push(e1), s;
                        }, Ml.prototype.bbox = function() {
                            var t1 = this._pbf;
                            t1.pos = this._geometry;
                            for(var e1 = t1.readVarint() + t1.pos, r = 1, n = 0, i = 0, a = 0, o = 1 / 0, s = -1 / 0, l = 1 / 0, c = -1 / 0; t1.pos < e1;){
                                if (n <= 0) {
                                    var u = t1.readVarint();
                                    r = 7 & u, n = u >> 3;
                                }
                                if (n--, 1 === r || 2 === r) (i += t1.readSVarint()) < o && (o = i), i > s && (s = i), (a += t1.readSVarint()) < l && (l = a), a > c && (c = a);
                                else if (7 !== r) throw new Error("unknown command " + r);
                            }
                            return [
                                o,
                                l,
                                s,
                                c
                            ];
                        }, Ml.prototype.toGeoJSON = function(t1, e1, r) {
                            var n, i, a = this.extent * Math.pow(2, r), o = this.extent * t1, s = this.extent * e1, l = this.loadGeometry(), c = Ml.types[this.type];
                            function u(t1) {
                                for(var e1 = 0; e1 < t1.length; e1++){
                                    var r = t1[e1], n = 180 - 360 * (r.y + s) / a;
                                    t1[e1] = [
                                        360 * (r.x + o) / a - 180,
                                        360 / Math.PI * Math.atan(Math.exp(n * Math.PI / 180)) - 90
                                    ];
                                }
                            }
                            switch(this.type){
                                case 1:
                                    var h = [];
                                    for(n = 0; n < l.length; n++)h[n] = l[n][0];
                                    u(l = h);
                                    break;
                                case 2:
                                    for(n = 0; n < l.length; n++)u(l[n]);
                                    break;
                                case 3:
                                    for(l = function(t1) {
                                        var e1 = t1.length;
                                        if (e1 <= 1) return [
                                            t1
                                        ];
                                        for(var r, n, i = [], a = 0; a < e1; a++){
                                            var o = El(t1[a]);
                                            0 !== o && (void 0 === n && (n = o < 0), n === o < 0 ? (r && i.push(r), r = [
                                                t1[a]
                                            ]) : r.push(t1[a]));
                                        }
                                        return r && i.push(r), i;
                                    }(l), n = 0; n < l.length; n++)for(i = 0; i < l[n].length; i++)u(l[n][i]);
                            }
                            1 === l.length ? l = l[0] : c = "Multi" + c;
                            var f = {
                                type: "Feature",
                                geometry: {
                                    type: c,
                                    coordinates: l
                                },
                                properties: this.properties
                            };
                            return "id" in this && (f.id = this.id), f;
                        };
                        var Cl = Al, Ll = Il;
                        function Il(t1, e1) {
                            this.version = 1, this.name = null, this.extent = 4096, this.length = 0, this._pbf = t1, this._keys = [], this._values = [], this._features = [], t1.readFields(Pl, this, e1), this.length = this._features.length;
                        }
                        function Pl(t1, e1, r) {
                            15 === t1 ? e1.version = r.readVarint() : 1 === t1 ? e1.name = r.readString() : 5 === t1 ? e1.extent = r.readVarint() : 2 === t1 ? e1._features.push(r.pos) : 3 === t1 ? e1._keys.push(r.readString()) : 4 === t1 && e1._values.push(function(t1) {
                                for(var e1 = null, r = t1.readVarint() + t1.pos; t1.pos < r;){
                                    var n = t1.readVarint() >> 3;
                                    e1 = 1 === n ? t1.readString() : 2 === n ? t1.readFloat() : 3 === n ? t1.readDouble() : 4 === n ? t1.readVarint64() : 5 === n ? t1.readVarint() : 6 === n ? t1.readSVarint() : 7 === n ? t1.readBoolean() : null;
                                }
                                return e1;
                            }(r));
                        }
                        Il.prototype.feature = function(t1) {
                            if (t1 < 0 || t1 >= this._features.length) throw new Error("feature index out of bounds");
                            this._pbf.pos = this._features[t1];
                            var e1 = this._pbf.readVarint() + this._pbf.pos;
                            return new Cl(this._pbf, e1, this.extent, this._keys, this._values);
                        };
                        var zl = Ll, Ol = function(t1, e1) {
                            this.layers = t1.readFields(Dl, {}, e1);
                        };
                        function Dl(t1, e1, r) {
                            if (3 === t1) {
                                var n = new zl(r, r.readVarint() + r.pos);
                                n.length && (e1[n.name] = n);
                            }
                        }
                        Tl.VectorTile = Ol, Tl.VectorTileFeature = Al, Tl.VectorTileLayer = Ll;
                        const Rl = Tl.VectorTileFeature.types, Fl = Math.pow(2, 13);
                        function Bl(t1, e1, r, n, i, a, o, s) {
                            t1.emplaceBack(e1, r, 2 * Math.floor(n * Fl) + o, i * Fl * 2, a * Fl * 2, Math.round(s));
                        }
                        class Nl {
                            constructor(t1){
                                this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.id), this.index = t1.index, this.hasPattern = !1, this.layoutVertexArray = new $a, this.centroidVertexArray = new Wa, this.indexArray = new ao, this.programConfigurations = new Bo(t1.layers, t1.zoom), this.segments = new ho, this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id);
                            }
                            populate(t1, e1, r) {
                                this.features = [], this.hasPattern = hl("fill-extrusion", this.layers, e1);
                                for (const { feature: n, id: i, index: a, sourceLayerIndex: o } of t1){
                                    const t1 = this.layers[0]._featureFilter.needGeometry, s = Go(n, t1);
                                    if (!this.layers[0]._featureFilter.filter(new Hi(this.zoom), s, r)) continue;
                                    const l = {
                                        id: i,
                                        sourceLayerIndex: o,
                                        index: a,
                                        geometry: t1 ? s.geometry : Ho(n),
                                        properties: n.properties,
                                        type: n.type,
                                        patterns: {}
                                    };
                                    this.hasPattern ? this.features.push(fl("fill-extrusion", this.layers, l, this.zoom, e1)) : this.addFeature(l, l.geometry, a, r, {}), e1.featureIndex.insert(n, l.geometry, a, o, this.index, !0);
                                }
                            }
                            addFeatures(t1, e1, r) {
                                for (const t1 of this.features){
                                    const { geometry: n } = t1;
                                    this.addFeature(t1, n, t1.index, e1, r);
                                }
                            }
                            update(t1, e1, r) {
                                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r);
                            }
                            isEmpty() {
                                return 0 === this.layoutVertexArray.length && 0 === this.centroidVertexArray.length;
                            }
                            uploadPending() {
                                return !this.uploaded || this.programConfigurations.needsUpload;
                            }
                            upload(t1) {
                                this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, _l), this.centroidVertexBuffer = t1.createVertexBuffer(this.centroidVertexArray, xl.members, !0), this.indexBuffer = t1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t1), this.uploaded = !0;
                            }
                            destroy() {
                                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.centroidVertexBuffer.destroy());
                            }
                            addFeature(t1, e1, r, n, i) {
                                for (const r of br(e1, 500)){
                                    const e1 = {
                                        x: 0,
                                        y: 0,
                                        vertexCount: 0
                                    };
                                    let n = 0;
                                    for (const t1 of r)n += t1.length;
                                    let i = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray);
                                    for (const t1 of r){
                                        if (0 === t1.length) continue;
                                        if (Ul(t1)) continue;
                                        let r = 0;
                                        for(let n = 0; n < t1.length; n++){
                                            const a = t1[n];
                                            if (n >= 1) {
                                                const o = t1[n - 1];
                                                if (!jl(a, o)) {
                                                    i.vertexLength + 4 > ho.MAX_VERTEX_ARRAY_LENGTH && (i = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray));
                                                    const t1 = a.sub(o)._perp()._unit(), n = o.dist(a);
                                                    r + n > 32768 && (r = 0), Bl(this.layoutVertexArray, a.x, a.y, t1.x, t1.y, 0, 0, r), Bl(this.layoutVertexArray, a.x, a.y, t1.x, t1.y, 0, 1, r), e1.x += 2 * a.x, e1.y += 2 * a.y, e1.vertexCount += 2, r += n, Bl(this.layoutVertexArray, o.x, o.y, t1.x, t1.y, 0, 0, r), Bl(this.layoutVertexArray, o.x, o.y, t1.x, t1.y, 0, 1, r), e1.x += 2 * o.x, e1.y += 2 * o.y, e1.vertexCount += 2;
                                                    const s = i.vertexLength;
                                                    this.indexArray.emplaceBack(s, s + 2, s + 1), this.indexArray.emplaceBack(s + 1, s + 2, s + 3), i.vertexLength += 4, i.primitiveLength += 2;
                                                }
                                            }
                                        }
                                    }
                                    if (i.vertexLength + n > ho.MAX_VERTEX_ARRAY_LENGTH && (i = this.segments.prepareSegment(n, this.layoutVertexArray, this.indexArray)), "Polygon" !== Rl[t1.type]) continue;
                                    const a = [], o = [], s = i.vertexLength;
                                    for (const t1 of r)if (0 !== t1.length) {
                                        t1 !== r[0] && o.push(a.length / 2);
                                        for(let r = 0; r < t1.length; r++){
                                            const n = t1[r];
                                            Bl(this.layoutVertexArray, n.x, n.y, 0, 0, 1, 1, 0), e1.x += n.x, e1.y += n.y, e1.vertexCount += 1, a.push(n.x), a.push(n.y);
                                        }
                                    }
                                    const l = js(a, o);
                                    for(let t1 = 0; t1 < l.length; t1 += 3)this.indexArray.emplaceBack(s + l[t1], s + l[t1 + 2], s + l[t1 + 1]);
                                    i.primitiveLength += l.length / 3, i.vertexLength += n;
                                    for(let t1 = 0; t1 < e1.vertexCount; t1++){
                                        const t1 = Math.floor(e1.x / e1.vertexCount), r = Math.floor(e1.y / e1.vertexCount);
                                        this.centroidVertexArray.emplaceBack(t1, r);
                                    }
                                }
                                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, n);
                            }
                        }
                        function jl(t1, e1) {
                            return t1.x === e1.x && (t1.x < 0 || t1.x > Uo) || t1.y === e1.y && (t1.y < 0 || t1.y > Uo);
                        }
                        function Ul(t1) {
                            return t1.every((t1)=>t1.x < 0) || t1.every((t1)=>t1.x > Uo) || t1.every((t1)=>t1.y < 0) || t1.every((t1)=>t1.y > Uo);
                        }
                        let Vl;
                        Mi("FillExtrusionBucket", Nl, {
                            omit: [
                                "layers",
                                "features"
                            ]
                        });
                        var ql = {
                            get paint () {
                                return Vl = Vl || new ia({
                                    "fill-extrusion-opacity": new Qi(Z["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                                    "fill-extrusion-color": new ta(Z["paint_fill-extrusion"]["fill-extrusion-color"]),
                                    "fill-extrusion-translate": new Qi(Z["paint_fill-extrusion"]["fill-extrusion-translate"]),
                                    "fill-extrusion-translate-anchor": new Qi(Z["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                                    "fill-extrusion-pattern": new ea(Z["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                                    "fill-extrusion-height": new ta(Z["paint_fill-extrusion"]["fill-extrusion-height"]),
                                    "fill-extrusion-base": new ta(Z["paint_fill-extrusion"]["fill-extrusion-base"]),
                                    "fill-extrusion-vertical-gradient": new Qi(Z["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"])
                                });
                            }
                        };
                        class Hl extends oa {
                            constructor(t1){
                                super(t1, ql);
                            }
                            createBucket(t1) {
                                return new Nl(t1);
                            }
                            queryRadius() {
                                return os(this.paint.get("fill-extrusion-translate"));
                            }
                            is3D() {
                                return !0;
                            }
                            queryIntersectsFeature(t1, e1, r, n, i, o, s, l) {
                                const c = ss(t1, this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), o.angle, s), u = this.paint.get("fill-extrusion-height").evaluate(e1, r), h = this.paint.get("fill-extrusion-base").evaluate(e1, r), f = function(t1, e1, r, n) {
                                    const i = [];
                                    for (const r of t1){
                                        const t1 = [
                                            r.x,
                                            r.y,
                                            n,
                                            1
                                        ];
                                        vs(t1, t1, e1), i.push(new a(t1[0] / t1[3], t1[1] / t1[3]));
                                    }
                                    return i;
                                }(c, l, 0, 0), p = function(t1, e1, r, n) {
                                    const i = [], o = [], s = n[8] * e1, l = n[9] * e1, c = n[10] * e1, u = n[11] * e1, h = n[8] * r, f = n[9] * r, p = n[10] * r, d = n[11] * r;
                                    for (const e1 of t1){
                                        const t1 = [], r = [];
                                        for (const i of e1){
                                            const e1 = i.x, o = i.y, m = n[0] * e1 + n[4] * o + n[12], g = n[1] * e1 + n[5] * o + n[13], y = n[2] * e1 + n[6] * o + n[14], v = n[3] * e1 + n[7] * o + n[15], x = y + c, _ = v + u, b = m + h, w = g + f, T = y + p, k = v + d, A = new a((m + s) / _, (g + l) / _);
                                            A.z = x / _, t1.push(A);
                                            const M = new a(b / k, w / k);
                                            M.z = T / k, r.push(M);
                                        }
                                        i.push(t1), o.push(r);
                                    }
                                    return [
                                        i,
                                        o
                                    ];
                                }(n, h, u, l);
                                return function(t1, e1, r) {
                                    let n = 1 / 0;
                                    $o(r, e1) && (n = Zl(r, e1[0]));
                                    for(let i = 0; i < e1.length; i++){
                                        const a = e1[i], o = t1[i];
                                        for(let t1 = 0; t1 < a.length - 1; t1++){
                                            const e1 = a[t1], i = a[t1 + 1], s = o[t1], l = [
                                                e1,
                                                i,
                                                o[t1 + 1],
                                                s,
                                                e1
                                            ];
                                            Yo(r, l) && (n = Math.min(n, Zl(r, l)));
                                        }
                                    }
                                    return n !== 1 / 0 && n;
                                }(p[0], p[1], f);
                            }
                        }
                        function Gl(t1, e1) {
                            return t1.x * e1.x + t1.y * e1.y;
                        }
                        function Zl(t1, e1) {
                            if (1 === t1.length) {
                                let r = 0;
                                const n = e1[r++];
                                let i;
                                for(; !i || n.equals(i);)if (i = e1[r++], !i) return 1 / 0;
                                for(; r < e1.length; r++){
                                    const a = e1[r], o = t1[0], s = i.sub(n), l = a.sub(n), c = o.sub(n), u = Gl(s, s), h = Gl(s, l), f = Gl(l, l), p = Gl(c, s), d = Gl(c, l), m = u * f - h * h, g = (f * p - h * d) / m, y = (u * d - h * p) / m, v = 1 - g - y, x = n.z * v + i.z * g + a.z * y;
                                    if (isFinite(x)) return x;
                                }
                                return 1 / 0;
                            }
                            {
                                let t1 = 1 / 0;
                                for (const r of e1)t1 = Math.min(t1, r.z);
                                return t1;
                            }
                        }
                        const Wl = ua([
                            {
                                name: "a_pos_normal",
                                components: 2,
                                type: "Int16"
                            },
                            {
                                name: "a_data",
                                components: 4,
                                type: "Uint8"
                            }
                        ], 4), { members: Yl, size: Xl, alignment: $l } = Wl, Jl = ua([
                            {
                                name: "a_uv_x",
                                components: 1,
                                type: "Float32"
                            },
                            {
                                name: "a_split_index",
                                components: 1,
                                type: "Float32"
                            }
                        ]), { members: Kl, size: Ql, alignment: tc } = Jl, ec = Tl.VectorTileFeature.types, rc = Math.cos(Math.PI / 180 * 37.5), nc = Math.pow(2, 14) / .5;
                        class ic {
                            constructor(t1){
                                this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.id), this.index = t1.index, this.hasPattern = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach((t1)=>{
                                    this.gradients[t1.id] = {};
                                }), this.layoutVertexArray = new Ja, this.layoutVertexArray2 = new Ka, this.indexArray = new ao, this.programConfigurations = new Bo(t1.layers, t1.zoom), this.segments = new ho, this.maxLineLength = 0, this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id);
                            }
                            populate(t1, e1, r) {
                                this.hasPattern = hl("line", this.layers, e1);
                                const n = this.layers[0].layout.get("line-sort-key"), i = !n.isConstant(), a = [];
                                for (const { feature: e1, id: o, index: s, sourceLayerIndex: l } of t1){
                                    const t1 = this.layers[0]._featureFilter.needGeometry, c = Go(e1, t1);
                                    if (!this.layers[0]._featureFilter.filter(new Hi(this.zoom), c, r)) continue;
                                    const u = i ? n.evaluate(c, {}, r) : void 0, h = {
                                        id: o,
                                        properties: e1.properties,
                                        type: e1.type,
                                        sourceLayerIndex: l,
                                        index: s,
                                        geometry: t1 ? c.geometry : Ho(e1),
                                        patterns: {},
                                        sortKey: u
                                    };
                                    a.push(h);
                                }
                                i && a.sort((t1, e1)=>t1.sortKey - e1.sortKey);
                                for (const n of a){
                                    const { geometry: i, index: a, sourceLayerIndex: o } = n;
                                    if (this.hasPattern) {
                                        const t1 = fl("line", this.layers, n, this.zoom, e1);
                                        this.patternFeatures.push(t1);
                                    } else this.addFeature(n, i, a, r, {});
                                    const s = t1[a].feature;
                                    e1.featureIndex.insert(s, i, a, o, this.index);
                                }
                            }
                            update(t1, e1, r) {
                                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r);
                            }
                            addFeatures(t1, e1, r) {
                                for (const t1 of this.patternFeatures)this.addFeature(t1, t1.geometry, t1.index, e1, r);
                            }
                            isEmpty() {
                                return 0 === this.layoutVertexArray.length;
                            }
                            uploadPending() {
                                return !this.uploaded || this.programConfigurations.needsUpload;
                            }
                            upload(t1) {
                                this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = t1.createVertexBuffer(this.layoutVertexArray2, Kl)), this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, Yl), this.indexBuffer = t1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t1), this.uploaded = !0;
                            }
                            destroy() {
                                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
                            }
                            lineFeatureClips(t1) {
                                if (t1.properties && Object.prototype.hasOwnProperty.call(t1.properties, "mapbox_clip_start") && Object.prototype.hasOwnProperty.call(t1.properties, "mapbox_clip_end")) return {
                                    start: +t1.properties.mapbox_clip_start,
                                    end: +t1.properties.mapbox_clip_end
                                };
                            }
                            addFeature(t1, e1, r, n, i) {
                                const a = this.layers[0].layout, o = a.get("line-join").evaluate(t1, {}), s = a.get("line-cap"), l = a.get("line-miter-limit"), c = a.get("line-round-limit");
                                this.lineClips = this.lineFeatureClips(t1);
                                for (const r of e1)this.addLine(r, t1, o, s, l, c);
                                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, n);
                            }
                            addLine(t1, e1, r, n, i, a) {
                                if (this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, this.lineClips) {
                                    this.lineClipsArray.push(this.lineClips);
                                    for(let e1 = 0; e1 < t1.length - 1; e1++)this.totalDistance += t1[e1].dist(t1[e1 + 1]);
                                    this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
                                }
                                const o = "Polygon" === ec[e1.type];
                                let s = t1.length;
                                for(; s >= 2 && t1[s - 1].equals(t1[s - 2]);)s--;
                                let l = 0;
                                for(; l < s - 1 && t1[l].equals(t1[l + 1]);)l++;
                                if (s < (o ? 3 : 2)) return;
                                "bevel" === r && (i = 1.05);
                                const c = this.overscaling <= 16 ? 15 * Uo / (512 * this.overscaling) : 0, u = this.segments.prepareSegment(10 * s, this.layoutVertexArray, this.indexArray);
                                let h, f, p, d, m;
                                this.e1 = this.e2 = -1, o && (h = t1[s - 2], m = t1[l].sub(h)._unit()._perp());
                                for(let e1 = l; e1 < s; e1++){
                                    if (p = e1 === s - 1 ? o ? t1[l + 1] : void 0 : t1[e1 + 1], p && t1[e1].equals(p)) continue;
                                    m && (d = m), h && (f = h), h = t1[e1], m = p ? p.sub(h)._unit()._perp() : d, d = d || m;
                                    let g = d.add(m);
                                    0 === g.x && 0 === g.y || g._unit();
                                    const y = d.x * m.x + d.y * m.y, v = g.x * m.x + g.y * m.y, x = 0 !== v ? 1 / v : 1 / 0, _ = 2 * Math.sqrt(2 - 2 * v), b = v < rc && f && p, w = d.x * m.y - d.y * m.x > 0;
                                    if (b && e1 > l) {
                                        const t1 = h.dist(f);
                                        if (t1 > 2 * c) {
                                            const e1 = h.sub(h.sub(f)._mult(c / t1)._round());
                                            this.updateDistance(f, e1), this.addCurrentVertex(e1, d, 0, 0, u), f = e1;
                                        }
                                    }
                                    const T = f && p;
                                    let k = T ? r : o ? "butt" : n;
                                    if (T && "round" === k && (x < a ? k = "miter" : x <= 2 && (k = "fakeround")), "miter" === k && x > i && (k = "bevel"), "bevel" === k && (x > 2 && (k = "flipbevel"), x < i && (k = "miter")), f && this.updateDistance(f, h), "miter" === k) g._mult(x), this.addCurrentVertex(h, g, 0, 0, u);
                                    else if ("flipbevel" === k) {
                                        if (x > 100) g = m.mult(-1);
                                        else {
                                            const t1 = x * d.add(m).mag() / d.sub(m).mag();
                                            g._perp()._mult(t1 * (w ? -1 : 1));
                                        }
                                        this.addCurrentVertex(h, g, 0, 0, u), this.addCurrentVertex(h, g.mult(-1), 0, 0, u);
                                    } else if ("bevel" === k || "fakeround" === k) {
                                        const t1 = -Math.sqrt(x * x - 1), e1 = w ? t1 : 0, r = w ? 0 : t1;
                                        if (f && this.addCurrentVertex(h, d, e1, r, u), "fakeround" === k) {
                                            const t1 = Math.round(180 * _ / Math.PI / 20);
                                            for(let e1 = 1; e1 < t1; e1++){
                                                let r = e1 / t1;
                                                if (.5 !== r) {
                                                    const t1 = r - .5;
                                                    r += r * t1 * (r - 1) * ((1.0904 + y * (y * (3.55645 - 1.43519 * y) - 3.2452)) * t1 * t1 + (.848013 + y * (.215638 * y - 1.06021)));
                                                }
                                                const n = m.sub(d)._mult(r)._add(d)._unit()._mult(w ? -1 : 1);
                                                this.addHalfVertex(h, n.x, n.y, !1, w, 0, u);
                                            }
                                        }
                                        p && this.addCurrentVertex(h, m, -e1, -r, u);
                                    } else if ("butt" === k) this.addCurrentVertex(h, g, 0, 0, u);
                                    else if ("square" === k) {
                                        const t1 = f ? 1 : -1;
                                        this.addCurrentVertex(h, g, t1, t1, u);
                                    } else "round" === k && (f && (this.addCurrentVertex(h, d, 0, 0, u), this.addCurrentVertex(h, d, 1, 1, u, !0)), p && (this.addCurrentVertex(h, m, -1, -1, u, !0), this.addCurrentVertex(h, m, 0, 0, u)));
                                    if (b && e1 < s - 1) {
                                        const t1 = h.dist(p);
                                        if (t1 > 2 * c) {
                                            const e1 = h.add(p.sub(h)._mult(c / t1)._round());
                                            this.updateDistance(h, e1), this.addCurrentVertex(e1, m, 0, 0, u), h = e1;
                                        }
                                    }
                                }
                            }
                            addCurrentVertex(t1, e1, r, n, i, a = !1) {
                                const o = e1.x + e1.y * r, s = e1.y - e1.x * r, l = -e1.x + e1.y * n, c = -e1.y - e1.x * n;
                                this.addHalfVertex(t1, o, s, a, !1, r, i), this.addHalfVertex(t1, l, c, a, !0, -n, i), this.distance > nc / 2 && 0 === this.totalDistance && (this.distance = 0, this.updateScaledDistance(), this.addCurrentVertex(t1, e1, r, n, i, a));
                            }
                            addHalfVertex({ x: t1, y: e1 }, r, n, i, a, o, s) {
                                const l = .5 * (this.lineClips ? this.scaledDistance * (nc - 1) : this.scaledDistance);
                                if (this.layoutVertexArray.emplaceBack((t1 << 1) + (i ? 1 : 0), (e1 << 1) + (a ? 1 : 0), Math.round(63 * r) + 128, Math.round(63 * n) + 128, 1 + (0 === o ? 0 : o < 0 ? -1 : 1) | (63 & l) << 2, l >> 6), this.lineClips) {
                                    const t1 = (this.scaledDistance - this.lineClips.start) / (this.lineClips.end - this.lineClips.start);
                                    this.layoutVertexArray2.emplaceBack(t1, this.lineClipsArray.length);
                                }
                                const c = s.vertexLength++;
                                this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, this.e2, c), s.primitiveLength++), a ? this.e2 = c : this.e1 = c;
                            }
                            updateScaledDistance() {
                                this.scaledDistance = this.lineClips ? this.lineClips.start + (this.lineClips.end - this.lineClips.start) * this.distance / this.totalDistance : this.distance;
                            }
                            updateDistance(t1, e1) {
                                this.distance += t1.dist(e1), this.updateScaledDistance();
                            }
                        }
                        let ac;
                        Mi("LineBucket", ic, {
                            omit: [
                                "layers",
                                "patternFeatures"
                            ]
                        });
                        let oc;
                        var sc = {
                            get paint () {
                                return oc = oc || new ia({
                                    "line-opacity": new ta(Z.paint_line["line-opacity"]),
                                    "line-color": new ta(Z.paint_line["line-color"]),
                                    "line-translate": new Qi(Z.paint_line["line-translate"]),
                                    "line-translate-anchor": new Qi(Z.paint_line["line-translate-anchor"]),
                                    "line-width": new ta(Z.paint_line["line-width"]),
                                    "line-gap-width": new ta(Z.paint_line["line-gap-width"]),
                                    "line-offset": new ta(Z.paint_line["line-offset"]),
                                    "line-blur": new ta(Z.paint_line["line-blur"]),
                                    "line-dasharray": new ra(Z.paint_line["line-dasharray"]),
                                    "line-pattern": new ea(Z.paint_line["line-pattern"]),
                                    "line-gradient": new na(Z.paint_line["line-gradient"])
                                });
                            },
                            get layout () {
                                return ac = ac || new ia({
                                    "line-cap": new Qi(Z.layout_line["line-cap"]),
                                    "line-join": new ta(Z.layout_line["line-join"]),
                                    "line-miter-limit": new Qi(Z.layout_line["line-miter-limit"]),
                                    "line-round-limit": new Qi(Z.layout_line["line-round-limit"]),
                                    "line-sort-key": new ta(Z.layout_line["line-sort-key"])
                                });
                            }
                        };
                        class lc extends ta {
                            possiblyEvaluate(t1, e1) {
                                return e1 = new Hi(Math.floor(e1.zoom), {
                                    now: e1.now,
                                    fadeDuration: e1.fadeDuration,
                                    zoomHistory: e1.zoomHistory,
                                    transition: e1.transition
                                }), super.possiblyEvaluate(t1, e1);
                            }
                            evaluate(t1, e1, r, n) {
                                return e1 = y({}, e1, {
                                    zoom: Math.floor(e1.zoom)
                                }), super.evaluate(t1, e1, r, n);
                            }
                        }
                        let cc;
                        class uc extends oa {
                            constructor(t1){
                                super(t1, sc), this.gradientVersion = 0, cc || (cc = new lc(sc.paint.properties["line-width"].specification), cc.useIntegerZoom = !0);
                            }
                            _handleSpecialPaintPropertyUpdate(t1) {
                                if ("line-gradient" === t1) {
                                    const t1 = this.gradientExpression();
                                    !function(t1) {
                                        return void 0 !== t1._styleExpression;
                                    }(t1) ? this.stepInterpolant = !1 : this.stepInterpolant = t1._styleExpression.expression instanceof Ae, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
                                }
                            }
                            gradientExpression() {
                                return this._transitionablePaint._values["line-gradient"].value.expression;
                            }
                            recalculate(t1, e1) {
                                super.recalculate(t1, e1), this.paint._values["line-floorwidth"] = cc.possiblyEvaluate(this._transitioningPaint._values["line-width"].value, t1);
                            }
                            createBucket(t1) {
                                return new ic(t1);
                            }
                            queryRadius(t1) {
                                const e1 = t1, r = hc(as("line-width", this, e1), as("line-gap-width", this, e1)), n = as("line-offset", this, e1);
                                return r / 2 + Math.abs(n) + os(this.paint.get("line-translate"));
                            }
                            queryIntersectsFeature(t1, e1, r, n, i, o, s) {
                                const l = ss(t1, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), o.angle, s), c = s / 2 * hc(this.paint.get("line-width").evaluate(e1, r), this.paint.get("line-gap-width").evaluate(e1, r)), u = this.paint.get("line-offset").evaluate(e1, r);
                                return u && (n = function(t1, e1) {
                                    const r = [];
                                    for(let n = 0; n < t1.length; n++){
                                        const i = t1[n], o = [];
                                        for(let t1 = 0; t1 < i.length; t1++){
                                            const r = i[t1 - 1], n = i[t1], s = i[t1 + 1], l = 0 === t1 ? new a(0, 0) : n.sub(r)._unit()._perp(), c = t1 === i.length - 1 ? new a(0, 0) : s.sub(n)._unit()._perp(), u = l._add(c)._unit(), h = u.x * c.x + u.y * c.y;
                                            0 !== h && u._mult(1 / h), o.push(u._mult(e1)._add(n));
                                        }
                                        r.push(o);
                                    }
                                    return r;
                                }(n, u * s)), function(t1, e1, r) {
                                    for(let n = 0; n < e1.length; n++){
                                        const i = e1[n];
                                        if (t1.length >= 3) {
                                            for(let e1 = 0; e1 < i.length; e1++)if (ns(t1, i[e1])) return !0;
                                        }
                                        if (Jo(t1, i, r)) return !0;
                                    }
                                    return !1;
                                }(l, n, c);
                            }
                            isTileClipped() {
                                return !0;
                            }
                        }
                        function hc(t1, e1) {
                            return e1 > 0 ? e1 + 2 * t1 : t1;
                        }
                        const fc = ua([
                            {
                                name: "a_pos_offset",
                                components: 4,
                                type: "Int16"
                            },
                            {
                                name: "a_data",
                                components: 4,
                                type: "Uint16"
                            },
                            {
                                name: "a_pixeloffset",
                                components: 4,
                                type: "Int16"
                            }
                        ], 4), pc = ua([
                            {
                                name: "a_projected_pos",
                                components: 3,
                                type: "Float32"
                            }
                        ], 4);
                        ua([
                            {
                                name: "a_fade_opacity",
                                components: 1,
                                type: "Uint32"
                            }
                        ], 4);
                        const dc = ua([
                            {
                                name: "a_placed",
                                components: 2,
                                type: "Uint8"
                            },
                            {
                                name: "a_shift",
                                components: 2,
                                type: "Float32"
                            },
                            {
                                name: "a_box_real",
                                components: 2,
                                type: "Int16"
                            }
                        ]);
                        ua([
                            {
                                type: "Int16",
                                name: "anchorPointX"
                            },
                            {
                                type: "Int16",
                                name: "anchorPointY"
                            },
                            {
                                type: "Int16",
                                name: "x1"
                            },
                            {
                                type: "Int16",
                                name: "y1"
                            },
                            {
                                type: "Int16",
                                name: "x2"
                            },
                            {
                                type: "Int16",
                                name: "y2"
                            },
                            {
                                type: "Uint32",
                                name: "featureIndex"
                            },
                            {
                                type: "Uint16",
                                name: "sourceLayerIndex"
                            },
                            {
                                type: "Uint16",
                                name: "bucketIndex"
                            }
                        ]);
                        const mc = ua([
                            {
                                name: "a_pos",
                                components: 2,
                                type: "Int16"
                            },
                            {
                                name: "a_anchor_pos",
                                components: 2,
                                type: "Int16"
                            },
                            {
                                name: "a_extrude",
                                components: 2,
                                type: "Int16"
                            }
                        ], 4), gc = ua([
                            {
                                name: "a_pos",
                                components: 2,
                                type: "Float32"
                            },
                            {
                                name: "a_radius",
                                components: 1,
                                type: "Float32"
                            },
                            {
                                name: "a_flags",
                                components: 2,
                                type: "Int16"
                            }
                        ], 4);
                        function yc(t1, e1, r) {
                            return t1.sections.forEach((t1)=>{
                                t1.text = function(t1, e1, r) {
                                    const n = e1.layout.get("text-transform").evaluate(r, {});
                                    return "uppercase" === n ? t1 = t1.toLocaleUpperCase() : "lowercase" === n && (t1 = t1.toLocaleLowerCase()), qi.applyArabicShaping && (t1 = qi.applyArabicShaping(t1)), t1;
                                }(t1.text, e1, r);
                            }), t1;
                        }
                        ua([
                            {
                                name: "triangle",
                                components: 3,
                                type: "Uint16"
                            }
                        ]), ua([
                            {
                                type: "Int16",
                                name: "anchorX"
                            },
                            {
                                type: "Int16",
                                name: "anchorY"
                            },
                            {
                                type: "Uint16",
                                name: "glyphStartIndex"
                            },
                            {
                                type: "Uint16",
                                name: "numGlyphs"
                            },
                            {
                                type: "Uint32",
                                name: "vertexStartIndex"
                            },
                            {
                                type: "Uint32",
                                name: "lineStartIndex"
                            },
                            {
                                type: "Uint32",
                                name: "lineLength"
                            },
                            {
                                type: "Uint16",
                                name: "segment"
                            },
                            {
                                type: "Uint16",
                                name: "lowerSize"
                            },
                            {
                                type: "Uint16",
                                name: "upperSize"
                            },
                            {
                                type: "Float32",
                                name: "lineOffsetX"
                            },
                            {
                                type: "Float32",
                                name: "lineOffsetY"
                            },
                            {
                                type: "Uint8",
                                name: "writingMode"
                            },
                            {
                                type: "Uint8",
                                name: "placedOrientation"
                            },
                            {
                                type: "Uint8",
                                name: "hidden"
                            },
                            {
                                type: "Uint32",
                                name: "crossTileID"
                            },
                            {
                                type: "Int16",
                                name: "associatedIconIndex"
                            }
                        ]), ua([
                            {
                                type: "Int16",
                                name: "anchorX"
                            },
                            {
                                type: "Int16",
                                name: "anchorY"
                            },
                            {
                                type: "Int16",
                                name: "rightJustifiedTextSymbolIndex"
                            },
                            {
                                type: "Int16",
                                name: "centerJustifiedTextSymbolIndex"
                            },
                            {
                                type: "Int16",
                                name: "leftJustifiedTextSymbolIndex"
                            },
                            {
                                type: "Int16",
                                name: "verticalPlacedTextSymbolIndex"
                            },
                            {
                                type: "Int16",
                                name: "placedIconSymbolIndex"
                            },
                            {
                                type: "Int16",
                                name: "verticalPlacedIconSymbolIndex"
                            },
                            {
                                type: "Uint16",
                                name: "key"
                            },
                            {
                                type: "Uint16",
                                name: "textBoxStartIndex"
                            },
                            {
                                type: "Uint16",
                                name: "textBoxEndIndex"
                            },
                            {
                                type: "Uint16",
                                name: "verticalTextBoxStartIndex"
                            },
                            {
                                type: "Uint16",
                                name: "verticalTextBoxEndIndex"
                            },
                            {
                                type: "Uint16",
                                name: "iconBoxStartIndex"
                            },
                            {
                                type: "Uint16",
                                name: "iconBoxEndIndex"
                            },
                            {
                                type: "Uint16",
                                name: "verticalIconBoxStartIndex"
                            },
                            {
                                type: "Uint16",
                                name: "verticalIconBoxEndIndex"
                            },
                            {
                                type: "Uint16",
                                name: "featureIndex"
                            },
                            {
                                type: "Uint16",
                                name: "numHorizontalGlyphVertices"
                            },
                            {
                                type: "Uint16",
                                name: "numVerticalGlyphVertices"
                            },
                            {
                                type: "Uint16",
                                name: "numIconVertices"
                            },
                            {
                                type: "Uint16",
                                name: "numVerticalIconVertices"
                            },
                            {
                                type: "Uint16",
                                name: "useRuntimeCollisionCircles"
                            },
                            {
                                type: "Uint32",
                                name: "crossTileID"
                            },
                            {
                                type: "Float32",
                                name: "textBoxScale"
                            },
                            {
                                type: "Float32",
                                name: "collisionCircleDiameter"
                            },
                            {
                                type: "Uint16",
                                name: "textAnchorOffsetStartIndex"
                            },
                            {
                                type: "Uint16",
                                name: "textAnchorOffsetEndIndex"
                            }
                        ]), ua([
                            {
                                type: "Float32",
                                name: "offsetX"
                            }
                        ]), ua([
                            {
                                type: "Int16",
                                name: "x"
                            },
                            {
                                type: "Int16",
                                name: "y"
                            },
                            {
                                type: "Int16",
                                name: "tileUnitDistanceFromAnchor"
                            }
                        ]), ua([
                            {
                                type: "Uint16",
                                name: "textAnchor"
                            },
                            {
                                type: "Float32",
                                components: 2,
                                name: "textOffset"
                            }
                        ]);
                        const vc = {
                            "!": "\uFE15",
                            "#": "\uFF03",
                            $: "\uFF04",
                            "%": "\uFF05",
                            "&": "\uFF06",
                            "(": "\uFE35",
                            ")": "\uFE36",
                            "*": "\uFF0A",
                            "+": "\uFF0B",
                            ",": "\uFE10",
                            "-": "\uFE32",
                            ".": "\u30FB",
                            "/": "\uFF0F",
                            ":": "\uFE13",
                            ";": "\uFE14",
                            "<": "\uFE3F",
                            "=": "\uFF1D",
                            ">": "\uFE40",
                            "?": "\uFE16",
                            "@": "\uFF20",
                            "[": "\uFE47",
                            "\\": "\uFF3C",
                            "]": "\uFE48",
                            "^": "\uFF3E",
                            _: "\uFE33",
                            "`": "\uFF40",
                            "{": "\uFE37",
                            "|": "\u2015",
                            "}": "\uFE38",
                            "~": "\uFF5E",
                            "\xa2": "\uFFE0",
                            "\xa3": "\uFFE1",
                            "\xa5": "\uFFE5",
                            "\xa6": "\uFFE4",
                            "\xac": "\uFFE2",
                            "\xaf": "\uFFE3",
                            "\u2013": "\uFE32",
                            "\u2014": "\uFE31",
                            "\u2018": "\uFE43",
                            "\u2019": "\uFE44",
                            "\u201C": "\uFE41",
                            "\u201D": "\uFE42",
                            "\u2026": "\uFE19",
                            "\u2027": "\u30FB",
                            "\u20A9": "\uFFE6",
                            "\u3001": "\uFE11",
                            "\u3002": "\uFE12",
                            "\u3008": "\uFE3F",
                            "\u3009": "\uFE40",
                            "\u300A": "\uFE3D",
                            "\u300B": "\uFE3E",
                            "\u300C": "\uFE41",
                            "\u300D": "\uFE42",
                            "\u300E": "\uFE43",
                            "\u300F": "\uFE44",
                            "\u3010": "\uFE3B",
                            "\u3011": "\uFE3C",
                            "\u3014": "\uFE39",
                            "\u3015": "\uFE3A",
                            "\u3016": "\uFE17",
                            "\u3017": "\uFE18",
                            "\uFF01": "\uFE15",
                            "\uFF08": "\uFE35",
                            "\uFF09": "\uFE36",
                            "\uFF0C": "\uFE10",
                            "\uFF0D": "\uFE32",
                            "\uFF0E": "\u30FB",
                            "\uFF1A": "\uFE13",
                            "\uFF1B": "\uFE14",
                            "\uFF1C": "\uFE3F",
                            "\uFF1E": "\uFE40",
                            "\uFF1F": "\uFE16",
                            "\uFF3B": "\uFE47",
                            "\uFF3D": "\uFE48",
                            "\uFF3F": "\uFE33",
                            "\uFF5B": "\uFE37",
                            "\uFF5C": "\u2015",
                            "\uFF5D": "\uFE38",
                            "\uFF5F": "\uFE35",
                            "\uFF60": "\uFE36",
                            "\uFF61": "\uFE12",
                            "\uFF62": "\uFE41",
                            "\uFF63": "\uFE42"
                        };
                        var xc = 24, _c = wc, bc = {
                            read: function(t1, e1, r, n, i) {
                                var a, o, s = 8 * i - n - 1, l = (1 << s) - 1, c = l >> 1, u = -7, h = r ? i - 1 : 0, f = r ? -1 : 1, p = t1[e1 + h];
                                for(h += f, a = p & (1 << -u) - 1, p >>= -u, u += s; u > 0; a = 256 * a + t1[e1 + h], h += f, u -= 8);
                                for(o = a & (1 << -u) - 1, a >>= -u, u += n; u > 0; o = 256 * o + t1[e1 + h], h += f, u -= 8);
                                if (0 === a) a = 1 - c;
                                else {
                                    if (a === l) return o ? NaN : 1 / 0 * (p ? -1 : 1);
                                    o += Math.pow(2, n), a -= c;
                                }
                                return (p ? -1 : 1) * o * Math.pow(2, a - n);
                            },
                            write: function(t1, e1, r, n, i, a) {
                                var o, s, l, c = 8 * a - i - 1, u = (1 << c) - 1, h = u >> 1, f = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, p = n ? 0 : a - 1, d = n ? 1 : -1, m = e1 < 0 || 0 === e1 && 1 / e1 < 0 ? 1 : 0;
                                for(e1 = Math.abs(e1), isNaN(e1) || e1 === 1 / 0 ? (s = isNaN(e1) ? 1 : 0, o = u) : (o = Math.floor(Math.log(e1) / Math.LN2), e1 * (l = Math.pow(2, -o)) < 1 && (o--, l *= 2), (e1 += o + h >= 1 ? f / l : f * Math.pow(2, 1 - h)) * l >= 2 && (o++, l /= 2), o + h >= u ? (s = 0, o = u) : o + h >= 1 ? (s = (e1 * l - 1) * Math.pow(2, i), o += h) : (s = e1 * Math.pow(2, h - 1) * Math.pow(2, i), o = 0)); i >= 8; t1[r + p] = 255 & s, p += d, s /= 256, i -= 8);
                                for(o = o << i | s, c += i; c > 0; t1[r + p] = 255 & o, p += d, o /= 256, c -= 8);
                                t1[r + p - d] |= 128 * m;
                            }
                        };
                        function wc(t1) {
                            this.buf = ArrayBuffer.isView && ArrayBuffer.isView(t1) ? t1 : new Uint8Array(t1 || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
                        }
                        wc.Varint = 0, wc.Fixed64 = 1, wc.Bytes = 2, wc.Fixed32 = 5;
                        var Tc = 4294967296, kc = 1 / Tc, Ac = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf-8");
                        function Mc(t1) {
                            return t1.type === wc.Bytes ? t1.readVarint() + t1.pos : t1.pos + 1;
                        }
                        function Sc(t1, e1, r) {
                            return r ? 4294967296 * e1 + (t1 >>> 0) : 4294967296 * (e1 >>> 0) + (t1 >>> 0);
                        }
                        function Ec(t1, e1, r) {
                            var n = e1 <= 16383 ? 1 : e1 <= 2097151 ? 2 : e1 <= 268435455 ? 3 : Math.floor(Math.log(e1) / (7 * Math.LN2));
                            r.realloc(n);
                            for(var i = r.pos - 1; i >= t1; i--)r.buf[i + n] = r.buf[i];
                        }
                        function Cc(t1, e1) {
                            for(var r = 0; r < t1.length; r++)e1.writeVarint(t1[r]);
                        }
                        function Lc(t1, e1) {
                            for(var r = 0; r < t1.length; r++)e1.writeSVarint(t1[r]);
                        }
                        function Ic(t1, e1) {
                            for(var r = 0; r < t1.length; r++)e1.writeFloat(t1[r]);
                        }
                        function Pc(t1, e1) {
                            for(var r = 0; r < t1.length; r++)e1.writeDouble(t1[r]);
                        }
                        function zc(t1, e1) {
                            for(var r = 0; r < t1.length; r++)e1.writeBoolean(t1[r]);
                        }
                        function Oc(t1, e1) {
                            for(var r = 0; r < t1.length; r++)e1.writeFixed32(t1[r]);
                        }
                        function Dc(t1, e1) {
                            for(var r = 0; r < t1.length; r++)e1.writeSFixed32(t1[r]);
                        }
                        function Rc(t1, e1) {
                            for(var r = 0; r < t1.length; r++)e1.writeFixed64(t1[r]);
                        }
                        function Fc(t1, e1) {
                            for(var r = 0; r < t1.length; r++)e1.writeSFixed64(t1[r]);
                        }
                        function Bc(t1, e1) {
                            return (t1[e1] | t1[e1 + 1] << 8 | t1[e1 + 2] << 16) + 16777216 * t1[e1 + 3];
                        }
                        function Nc(t1, e1, r) {
                            t1[r] = e1, t1[r + 1] = e1 >>> 8, t1[r + 2] = e1 >>> 16, t1[r + 3] = e1 >>> 24;
                        }
                        function jc(t1, e1) {
                            return (t1[e1] | t1[e1 + 1] << 8 | t1[e1 + 2] << 16) + (t1[e1 + 3] << 24);
                        }
                        wc.prototype = {
                            destroy: function() {
                                this.buf = null;
                            },
                            readFields: function(t1, e1, r) {
                                for(r = r || this.length; this.pos < r;){
                                    var n = this.readVarint(), i = n >> 3, a = this.pos;
                                    this.type = 7 & n, t1(i, e1, this), this.pos === a && this.skip(n);
                                }
                                return e1;
                            },
                            readMessage: function(t1, e1) {
                                return this.readFields(t1, e1, this.readVarint() + this.pos);
                            },
                            readFixed32: function() {
                                var t1 = Bc(this.buf, this.pos);
                                return this.pos += 4, t1;
                            },
                            readSFixed32: function() {
                                var t1 = jc(this.buf, this.pos);
                                return this.pos += 4, t1;
                            },
                            readFixed64: function() {
                                var t1 = Bc(this.buf, this.pos) + Bc(this.buf, this.pos + 4) * Tc;
                                return this.pos += 8, t1;
                            },
                            readSFixed64: function() {
                                var t1 = Bc(this.buf, this.pos) + jc(this.buf, this.pos + 4) * Tc;
                                return this.pos += 8, t1;
                            },
                            readFloat: function() {
                                var t1 = bc.read(this.buf, this.pos, !0, 23, 4);
                                return this.pos += 4, t1;
                            },
                            readDouble: function() {
                                var t1 = bc.read(this.buf, this.pos, !0, 52, 8);
                                return this.pos += 8, t1;
                            },
                            readVarint: function(t1) {
                                var e1, r, n = this.buf;
                                return e1 = 127 & (r = n[this.pos++]), r < 128 ? e1 : (e1 |= (127 & (r = n[this.pos++])) << 7, r < 128 ? e1 : (e1 |= (127 & (r = n[this.pos++])) << 14, r < 128 ? e1 : (e1 |= (127 & (r = n[this.pos++])) << 21, r < 128 ? e1 : function(t1, e1, r) {
                                    var n, i, a = r.buf;
                                    if (n = (112 & (i = a[r.pos++])) >> 4, i < 128) return Sc(t1, n, e1);
                                    if (n |= (127 & (i = a[r.pos++])) << 3, i < 128) return Sc(t1, n, e1);
                                    if (n |= (127 & (i = a[r.pos++])) << 10, i < 128) return Sc(t1, n, e1);
                                    if (n |= (127 & (i = a[r.pos++])) << 17, i < 128) return Sc(t1, n, e1);
                                    if (n |= (127 & (i = a[r.pos++])) << 24, i < 128) return Sc(t1, n, e1);
                                    if (n |= (1 & (i = a[r.pos++])) << 31, i < 128) return Sc(t1, n, e1);
                                    throw new Error("Expected varint not more than 10 bytes");
                                }(e1 |= (15 & (r = n[this.pos])) << 28, t1, this))));
                            },
                            readVarint64: function() {
                                return this.readVarint(!0);
                            },
                            readSVarint: function() {
                                var t1 = this.readVarint();
                                return t1 % 2 == 1 ? (t1 + 1) / -2 : t1 / 2;
                            },
                            readBoolean: function() {
                                return Boolean(this.readVarint());
                            },
                            readString: function() {
                                var t1 = this.readVarint() + this.pos, e1 = this.pos;
                                return this.pos = t1, t1 - e1 >= 12 && Ac ? function(t1, e1, r) {
                                    return Ac.decode(t1.subarray(e1, r));
                                }(this.buf, e1, t1) : function(t1, e1, r) {
                                    for(var n = "", i = e1; i < r;){
                                        var a, o, s, l = t1[i], c = null, u = l > 239 ? 4 : l > 223 ? 3 : l > 191 ? 2 : 1;
                                        if (i + u > r) break;
                                        1 === u ? l < 128 && (c = l) : 2 === u ? 128 == (192 & (a = t1[i + 1])) && (c = (31 & l) << 6 | 63 & a) <= 127 && (c = null) : 3 === u ? (a = t1[i + 1], o = t1[i + 2], 128 == (192 & a) && 128 == (192 & o) && ((c = (15 & l) << 12 | (63 & a) << 6 | 63 & o) <= 2047 || c >= 55296 && c <= 57343) && (c = null)) : 4 === u && (a = t1[i + 1], o = t1[i + 2], s = t1[i + 3], 128 == (192 & a) && 128 == (192 & o) && 128 == (192 & s) && ((c = (15 & l) << 18 | (63 & a) << 12 | (63 & o) << 6 | 63 & s) <= 65535 || c >= 1114112) && (c = null)), null === c ? (c = 65533, u = 1) : c > 65535 && (c -= 65536, n += String.fromCharCode(c >>> 10 & 1023 | 55296), c = 56320 | 1023 & c), n += String.fromCharCode(c), i += u;
                                    }
                                    return n;
                                }(this.buf, e1, t1);
                            },
                            readBytes: function() {
                                var t1 = this.readVarint() + this.pos, e1 = this.buf.subarray(this.pos, t1);
                                return this.pos = t1, e1;
                            },
                            readPackedVarint: function(t1, e1) {
                                if (this.type !== wc.Bytes) return t1.push(this.readVarint(e1));
                                var r = Mc(this);
                                for(t1 = t1 || []; this.pos < r;)t1.push(this.readVarint(e1));
                                return t1;
                            },
                            readPackedSVarint: function(t1) {
                                if (this.type !== wc.Bytes) return t1.push(this.readSVarint());
                                var e1 = Mc(this);
                                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readSVarint());
                                return t1;
                            },
                            readPackedBoolean: function(t1) {
                                if (this.type !== wc.Bytes) return t1.push(this.readBoolean());
                                var e1 = Mc(this);
                                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readBoolean());
                                return t1;
                            },
                            readPackedFloat: function(t1) {
                                if (this.type !== wc.Bytes) return t1.push(this.readFloat());
                                var e1 = Mc(this);
                                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readFloat());
                                return t1;
                            },
                            readPackedDouble: function(t1) {
                                if (this.type !== wc.Bytes) return t1.push(this.readDouble());
                                var e1 = Mc(this);
                                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readDouble());
                                return t1;
                            },
                            readPackedFixed32: function(t1) {
                                if (this.type !== wc.Bytes) return t1.push(this.readFixed32());
                                var e1 = Mc(this);
                                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readFixed32());
                                return t1;
                            },
                            readPackedSFixed32: function(t1) {
                                if (this.type !== wc.Bytes) return t1.push(this.readSFixed32());
                                var e1 = Mc(this);
                                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readSFixed32());
                                return t1;
                            },
                            readPackedFixed64: function(t1) {
                                if (this.type !== wc.Bytes) return t1.push(this.readFixed64());
                                var e1 = Mc(this);
                                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readFixed64());
                                return t1;
                            },
                            readPackedSFixed64: function(t1) {
                                if (this.type !== wc.Bytes) return t1.push(this.readSFixed64());
                                var e1 = Mc(this);
                                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readSFixed64());
                                return t1;
                            },
                            skip: function(t1) {
                                var e1 = 7 & t1;
                                if (e1 === wc.Varint) for(; this.buf[this.pos++] > 127;);
                                else if (e1 === wc.Bytes) this.pos = this.readVarint() + this.pos;
                                else if (e1 === wc.Fixed32) this.pos += 4;
                                else {
                                    if (e1 !== wc.Fixed64) throw new Error("Unimplemented type: " + e1);
                                    this.pos += 8;
                                }
                            },
                            writeTag: function(t1, e1) {
                                this.writeVarint(t1 << 3 | e1);
                            },
                            realloc: function(t1) {
                                for(var e1 = this.length || 16; e1 < this.pos + t1;)e1 *= 2;
                                if (e1 !== this.length) {
                                    var r = new Uint8Array(e1);
                                    r.set(this.buf), this.buf = r, this.length = e1;
                                }
                            },
                            finish: function() {
                                return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
                            },
                            writeFixed32: function(t1) {
                                this.realloc(4), Nc(this.buf, t1, this.pos), this.pos += 4;
                            },
                            writeSFixed32: function(t1) {
                                this.realloc(4), Nc(this.buf, t1, this.pos), this.pos += 4;
                            },
                            writeFixed64: function(t1) {
                                this.realloc(8), Nc(this.buf, -1 & t1, this.pos), Nc(this.buf, Math.floor(t1 * kc), this.pos + 4), this.pos += 8;
                            },
                            writeSFixed64: function(t1) {
                                this.realloc(8), Nc(this.buf, -1 & t1, this.pos), Nc(this.buf, Math.floor(t1 * kc), this.pos + 4), this.pos += 8;
                            },
                            writeVarint: function(t1) {
                                (t1 = +t1 || 0) > 268435455 || t1 < 0 ? function(t1, e1) {
                                    var r, n;
                                    if (t1 >= 0 ? (r = t1 % 4294967296 | 0, n = t1 / 4294967296 | 0) : (n = ~(-t1 / 4294967296), 4294967295 ^ (r = ~(-t1 % 4294967296)) ? r = r + 1 | 0 : (r = 0, n = n + 1 | 0)), t1 >= 0x10000000000000000 || t1 < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                                    e1.realloc(10), function(t1, e1, r) {
                                        r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos] = 127 & t1;
                                    }(r, 0, e1), function(t1, e1) {
                                        var r = (7 & t1) << 4;
                                        e1.buf[e1.pos++] |= r | ((t1 >>>= 3) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e1.buf[e1.pos++] = 127 & t1)))));
                                    }(n, e1);
                                }(t1, this) : (this.realloc(4), this.buf[this.pos++] = 127 & t1 | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = 127 & (t1 >>>= 7) | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = 127 & (t1 >>>= 7) | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = t1 >>> 7 & 127))));
                            },
                            writeSVarint: function(t1) {
                                this.writeVarint(t1 < 0 ? 2 * -t1 - 1 : 2 * t1);
                            },
                            writeBoolean: function(t1) {
                                this.writeVarint(Boolean(t1));
                            },
                            writeString: function(t1) {
                                t1 = String(t1), this.realloc(4 * t1.length), this.pos++;
                                var e1 = this.pos;
                                this.pos = function(t1, e1, r) {
                                    for(var n, i, a = 0; a < e1.length; a++){
                                        if ((n = e1.charCodeAt(a)) > 55295 && n < 57344) {
                                            if (!i) {
                                                n > 56319 || a + 1 === e1.length ? (t1[r++] = 239, t1[r++] = 191, t1[r++] = 189) : i = n;
                                                continue;
                                            }
                                            if (n < 56320) {
                                                t1[r++] = 239, t1[r++] = 191, t1[r++] = 189, i = n;
                                                continue;
                                            }
                                            n = i - 55296 << 10 | n - 56320 | 65536, i = null;
                                        } else i && (t1[r++] = 239, t1[r++] = 191, t1[r++] = 189, i = null);
                                        n < 128 ? t1[r++] = n : (n < 2048 ? t1[r++] = n >> 6 | 192 : (n < 65536 ? t1[r++] = n >> 12 | 224 : (t1[r++] = n >> 18 | 240, t1[r++] = n >> 12 & 63 | 128), t1[r++] = n >> 6 & 63 | 128), t1[r++] = 63 & n | 128);
                                    }
                                    return r;
                                }(this.buf, t1, this.pos);
                                var r = this.pos - e1;
                                r >= 128 && Ec(e1, r, this), this.pos = e1 - 1, this.writeVarint(r), this.pos += r;
                            },
                            writeFloat: function(t1) {
                                this.realloc(4), bc.write(this.buf, t1, this.pos, !0, 23, 4), this.pos += 4;
                            },
                            writeDouble: function(t1) {
                                this.realloc(8), bc.write(this.buf, t1, this.pos, !0, 52, 8), this.pos += 8;
                            },
                            writeBytes: function(t1) {
                                var e1 = t1.length;
                                this.writeVarint(e1), this.realloc(e1);
                                for(var r = 0; r < e1; r++)this.buf[this.pos++] = t1[r];
                            },
                            writeRawMessage: function(t1, e1) {
                                this.pos++;
                                var r = this.pos;
                                t1(e1, this);
                                var n = this.pos - r;
                                n >= 128 && Ec(r, n, this), this.pos = r - 1, this.writeVarint(n), this.pos += n;
                            },
                            writeMessage: function(t1, e1, r) {
                                this.writeTag(t1, wc.Bytes), this.writeRawMessage(e1, r);
                            },
                            writePackedVarint: function(t1, e1) {
                                e1.length && this.writeMessage(t1, Cc, e1);
                            },
                            writePackedSVarint: function(t1, e1) {
                                e1.length && this.writeMessage(t1, Lc, e1);
                            },
                            writePackedBoolean: function(t1, e1) {
                                e1.length && this.writeMessage(t1, zc, e1);
                            },
                            writePackedFloat: function(t1, e1) {
                                e1.length && this.writeMessage(t1, Ic, e1);
                            },
                            writePackedDouble: function(t1, e1) {
                                e1.length && this.writeMessage(t1, Pc, e1);
                            },
                            writePackedFixed32: function(t1, e1) {
                                e1.length && this.writeMessage(t1, Oc, e1);
                            },
                            writePackedSFixed32: function(t1, e1) {
                                e1.length && this.writeMessage(t1, Dc, e1);
                            },
                            writePackedFixed64: function(t1, e1) {
                                e1.length && this.writeMessage(t1, Rc, e1);
                            },
                            writePackedSFixed64: function(t1, e1) {
                                e1.length && this.writeMessage(t1, Fc, e1);
                            },
                            writeBytesField: function(t1, e1) {
                                this.writeTag(t1, wc.Bytes), this.writeBytes(e1);
                            },
                            writeFixed32Field: function(t1, e1) {
                                this.writeTag(t1, wc.Fixed32), this.writeFixed32(e1);
                            },
                            writeSFixed32Field: function(t1, e1) {
                                this.writeTag(t1, wc.Fixed32), this.writeSFixed32(e1);
                            },
                            writeFixed64Field: function(t1, e1) {
                                this.writeTag(t1, wc.Fixed64), this.writeFixed64(e1);
                            },
                            writeSFixed64Field: function(t1, e1) {
                                this.writeTag(t1, wc.Fixed64), this.writeSFixed64(e1);
                            },
                            writeVarintField: function(t1, e1) {
                                this.writeTag(t1, wc.Varint), this.writeVarint(e1);
                            },
                            writeSVarintField: function(t1, e1) {
                                this.writeTag(t1, wc.Varint), this.writeSVarint(e1);
                            },
                            writeStringField: function(t1, e1) {
                                this.writeTag(t1, wc.Bytes), this.writeString(e1);
                            },
                            writeFloatField: function(t1, e1) {
                                this.writeTag(t1, wc.Fixed32), this.writeFloat(e1);
                            },
                            writeDoubleField: function(t1, e1) {
                                this.writeTag(t1, wc.Fixed64), this.writeDouble(e1);
                            },
                            writeBooleanField: function(t1, e1) {
                                this.writeVarintField(t1, Boolean(e1));
                            }
                        };
                        var Uc = r(_c);
                        const Vc = 3;
                        function qc(t1, e1, r) {
                            1 === t1 && r.readMessage(Hc, e1);
                        }
                        function Hc(t1, e1, r) {
                            if (3 === t1) {
                                const { id: t1, bitmap: n, width: i, height: a, left: o, top: s, advance: l } = r.readMessage(Gc, {});
                                e1.push({
                                    id: t1,
                                    bitmap: new Cs({
                                        width: i + 2 * Vc,
                                        height: a + 2 * Vc
                                    }, n),
                                    metrics: {
                                        width: i,
                                        height: a,
                                        left: o,
                                        top: s,
                                        advance: l
                                    }
                                });
                            }
                        }
                        function Gc(t1, e1, r) {
                            1 === t1 ? e1.id = r.readVarint() : 2 === t1 ? e1.bitmap = r.readBytes() : 3 === t1 ? e1.width = r.readVarint() : 4 === t1 ? e1.height = r.readVarint() : 5 === t1 ? e1.left = r.readSVarint() : 6 === t1 ? e1.top = r.readSVarint() : 7 === t1 && (e1.advance = r.readVarint());
                        }
                        const Zc = Vc;
                        function Wc(t1) {
                            let e1 = 0, r = 0;
                            for (const n of t1)e1 += n.w * n.h, r = Math.max(r, n.w);
                            t1.sort((t1, e1)=>e1.h - t1.h);
                            const n = [
                                {
                                    x: 0,
                                    y: 0,
                                    w: Math.max(Math.ceil(Math.sqrt(e1 / .95)), r),
                                    h: 1 / 0
                                }
                            ];
                            let i = 0, a = 0;
                            for (const e1 of t1)for(let t1 = n.length - 1; t1 >= 0; t1--){
                                const r = n[t1];
                                if (!(e1.w > r.w || e1.h > r.h)) {
                                    if (e1.x = r.x, e1.y = r.y, a = Math.max(a, e1.y + e1.h), i = Math.max(i, e1.x + e1.w), e1.w === r.w && e1.h === r.h) {
                                        const e1 = n.pop();
                                        t1 < n.length && (n[t1] = e1);
                                    } else e1.h === r.h ? (r.x += e1.w, r.w -= e1.w) : e1.w === r.w ? (r.y += e1.h, r.h -= e1.h) : (n.push({
                                        x: r.x + e1.w,
                                        y: r.y,
                                        w: r.w - e1.w,
                                        h: e1.h
                                    }), r.y += e1.h, r.h -= e1.h);
                                    break;
                                }
                            }
                            return {
                                w: i,
                                h: a,
                                fill: e1 / (i * a) || 0
                            };
                        }
                        const Yc = 1;
                        class Xc {
                            constructor(t1, { pixelRatio: e1, version: r, stretchX: n, stretchY: i, content: a, textFitWidth: o, textFitHeight: s }){
                                this.paddedRect = t1, this.pixelRatio = e1, this.stretchX = n, this.stretchY = i, this.content = a, this.version = r, this.textFitWidth = o, this.textFitHeight = s;
                            }
                            get tl() {
                                return [
                                    this.paddedRect.x + Yc,
                                    this.paddedRect.y + Yc
                                ];
                            }
                            get br() {
                                return [
                                    this.paddedRect.x + this.paddedRect.w - Yc,
                                    this.paddedRect.y + this.paddedRect.h - Yc
                                ];
                            }
                            get tlbr() {
                                return this.tl.concat(this.br);
                            }
                            get displaySize() {
                                return [
                                    (this.paddedRect.w - 2 * Yc) / this.pixelRatio,
                                    (this.paddedRect.h - 2 * Yc) / this.pixelRatio
                                ];
                            }
                        }
                        class $c {
                            constructor(t1, e1){
                                const r = {}, n = {};
                                this.haveRenderCallbacks = [];
                                const i = [];
                                this.addImages(t1, r, i), this.addImages(e1, n, i);
                                const { w: a, h: o } = Wc(i), s = new Ls({
                                    width: a || 1,
                                    height: o || 1
                                });
                                for(const e1 in t1){
                                    const n = t1[e1], i = r[e1].paddedRect;
                                    Ls.copy(n.data, s, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        x: i.x + Yc,
                                        y: i.y + Yc
                                    }, n.data);
                                }
                                for(const t1 in e1){
                                    const r = e1[t1], i = n[t1].paddedRect, a = i.x + Yc, o = i.y + Yc, l = r.data.width, c = r.data.height;
                                    Ls.copy(r.data, s, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        x: a,
                                        y: o
                                    }, r.data), Ls.copy(r.data, s, {
                                        x: 0,
                                        y: c - 1
                                    }, {
                                        x: a,
                                        y: o - 1
                                    }, {
                                        width: l,
                                        height: 1
                                    }), Ls.copy(r.data, s, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        x: a,
                                        y: o + c
                                    }, {
                                        width: l,
                                        height: 1
                                    }), Ls.copy(r.data, s, {
                                        x: l - 1,
                                        y: 0
                                    }, {
                                        x: a - 1,
                                        y: o
                                    }, {
                                        width: 1,
                                        height: c
                                    }), Ls.copy(r.data, s, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        x: a + l,
                                        y: o
                                    }, {
                                        width: 1,
                                        height: c
                                    });
                                }
                                this.image = s, this.iconPositions = r, this.patternPositions = n;
                            }
                            addImages(t1, e1, r) {
                                for(const n in t1){
                                    const i = t1[n], a = {
                                        x: 0,
                                        y: 0,
                                        w: i.data.width + 2 * Yc,
                                        h: i.data.height + 2 * Yc
                                    };
                                    r.push(a), e1[n] = new Xc(a, i), i.hasRenderCallback && this.haveRenderCallbacks.push(n);
                                }
                            }
                            patchUpdatedImages(t1, e1) {
                                t1.dispatchRenderCallbacks(this.haveRenderCallbacks);
                                for(const r in t1.updatedImages)this.patchUpdatedImage(this.iconPositions[r], t1.getImage(r), e1), this.patchUpdatedImage(this.patternPositions[r], t1.getImage(r), e1);
                            }
                            patchUpdatedImage(t1, e1, r) {
                                if (!t1 || !e1) return;
                                if (t1.version === e1.version) return;
                                t1.version = e1.version;
                                const [n, i] = t1.tl;
                                r.update(e1.data, void 0, {
                                    x: n,
                                    y: i
                                });
                            }
                        }
                        var Jc;
                        Mi("ImagePosition", Xc), Mi("ImageAtlas", $c), t1.ai = void 0, (Jc = t1.ai || (t1.ai = {}))[Jc.none = 0] = "none", Jc[Jc.horizontal = 1] = "horizontal", Jc[Jc.vertical = 2] = "vertical", Jc[Jc.horizontalOnly = 3] = "horizontalOnly";
                        const Kc = -17;
                        class Qc {
                            constructor(){
                                this.scale = 1, this.fontStack = "", this.imageName = null;
                            }
                            static forText(t1, e1) {
                                const r = new Qc;
                                return r.scale = t1 || 1, r.fontStack = e1, r;
                            }
                            static forImage(t1) {
                                const e1 = new Qc;
                                return e1.imageName = t1, e1;
                            }
                        }
                        class tu {
                            constructor(){
                                this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
                            }
                            static fromFeature(t1, e1) {
                                const r = new tu;
                                for(let n = 0; n < t1.sections.length; n++){
                                    const i = t1.sections[n];
                                    i.image ? r.addImageSection(i) : r.addTextSection(i, e1);
                                }
                                return r;
                            }
                            length() {
                                return this.text.length;
                            }
                            getSection(t1) {
                                return this.sections[this.sectionIndex[t1]];
                            }
                            getSectionIndex(t1) {
                                return this.sectionIndex[t1];
                            }
                            getCharCode(t1) {
                                return this.text.charCodeAt(t1);
                            }
                            verticalizePunctuation() {
                                this.text = function(t1) {
                                    let e1 = "";
                                    for(let r = 0; r < t1.length; r++){
                                        const n = t1.charCodeAt(r + 1) || null, i = t1.charCodeAt(r - 1) || null;
                                        n && Bi(n) && !vc[t1[r + 1]] || i && Bi(i) && !vc[t1[r - 1]] || !vc[t1[r]] ? e1 += t1[r] : e1 += vc[t1[r]];
                                    }
                                    return e1;
                                }(this.text);
                            }
                            trim() {
                                let t1 = 0;
                                for(let e1 = 0; e1 < this.text.length && ru[this.text.charCodeAt(e1)]; e1++)t1++;
                                let e1 = this.text.length;
                                for(let r = this.text.length - 1; r >= 0 && r >= t1 && ru[this.text.charCodeAt(r)]; r--)e1--;
                                this.text = this.text.substring(t1, e1), this.sectionIndex = this.sectionIndex.slice(t1, e1);
                            }
                            substring(t1, e1) {
                                const r = new tu;
                                return r.text = this.text.substring(t1, e1), r.sectionIndex = this.sectionIndex.slice(t1, e1), r.sections = this.sections, r;
                            }
                            toString() {
                                return this.text;
                            }
                            getMaxScale() {
                                return this.sectionIndex.reduce((t1, e1)=>Math.max(t1, this.sections[e1].scale), 0);
                            }
                            addTextSection(t1, e1) {
                                this.text += t1.text, this.sections.push(Qc.forText(t1.scale, t1.fontStack || e1));
                                const r = this.sections.length - 1;
                                for(let e1 = 0; e1 < t1.text.length; ++e1)this.sectionIndex.push(r);
                            }
                            addImageSection(t1) {
                                const e1 = t1.image ? t1.image.name : "";
                                if (0 === e1.length) return void T("Can't add FormattedSection with an empty image.");
                                const r = this.getNextImageSectionCharCode();
                                r ? (this.text += String.fromCharCode(r), this.sections.push(Qc.forImage(e1)), this.sectionIndex.push(this.sections.length - 1)) : T("Reached maximum number of images 6401");
                            }
                            getNextImageSectionCharCode() {
                                return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
                            }
                        }
                        function eu(e1, r, n, i, a, o, s, l, c, u, h, f, p, d, m) {
                            const g = tu.fromFeature(e1, a);
                            let y;
                            f === t1.ai.vertical && g.verticalizePunctuation();
                            const { processBidirectionalText: v, processStyledBidirectionalText: x } = qi;
                            if (v && 1 === g.sections.length) {
                                y = [];
                                const t1 = v(g.toString(), uu(g, u, o, r, i, d));
                                for (const e1 of t1){
                                    const t1 = new tu;
                                    t1.text = e1, t1.sections = g.sections;
                                    for(let r = 0; r < e1.length; r++)t1.sectionIndex.push(0);
                                    y.push(t1);
                                }
                            } else if (x) {
                                y = [];
                                const t1 = x(g.text, g.sectionIndex, uu(g, u, o, r, i, d));
                                for (const e1 of t1){
                                    const t1 = new tu;
                                    t1.text = e1[0], t1.sectionIndex = e1[1], t1.sections = g.sections, y.push(t1);
                                }
                            } else y = function(t1, e1) {
                                const r = [], n = t1.text;
                                let i = 0;
                                for (const n of e1)r.push(t1.substring(i, n)), i = n;
                                return i < n.length && r.push(t1.substring(i, n.length)), r;
                            }(g, uu(g, u, o, r, i, d));
                            const _ = [], b = {
                                positionedLines: _,
                                text: g.toString(),
                                top: h[1],
                                bottom: h[1],
                                left: h[0],
                                right: h[0],
                                writingMode: f,
                                iconsInText: !1,
                                verticalizable: !1
                            };
                            return function(e1, r, n, i, a, o, s, l, c, u, h, f) {
                                let p = 0, d = Kc, m = 0, g = 0;
                                const y = "right" === l ? 1 : "left" === l ? 0 : .5;
                                let v = 0;
                                for (const s of a){
                                    s.trim();
                                    const a = s.getMaxScale(), l = (a - 1) * xc, x = {
                                        positionedGlyphs: [],
                                        lineOffset: 0
                                    };
                                    e1.positionedLines[v] = x;
                                    const _ = x.positionedGlyphs;
                                    let b = 0;
                                    if (!s.length()) {
                                        d += o, ++v;
                                        continue;
                                    }
                                    for(let o = 0; o < s.length(); o++){
                                        const m = s.getSection(o), g = s.getSectionIndex(o), y = s.getCharCode(o);
                                        let v = 0, x = null, w = null, T = null, k = xc;
                                        const A = !(c === t1.ai.horizontal || !h && !Fi(y) || h && (ru[y] || Ni(y)));
                                        if (m.imageName) {
                                            const t1 = i[m.imageName];
                                            if (!t1) continue;
                                            T = m.imageName, e1.iconsInText = e1.iconsInText || !0, w = t1.paddedRect;
                                            const r = t1.displaySize;
                                            m.scale = m.scale * xc / f, x = {
                                                width: r[0],
                                                height: r[1],
                                                left: Yc,
                                                top: -Zc,
                                                advance: A ? r[1] : r[0]
                                            }, v = l + (xc - r[1] * m.scale), k = x.advance;
                                            const n = A ? r[0] * m.scale - xc * a : r[1] * m.scale - xc * a;
                                            n > 0 && n > b && (b = n);
                                        } else {
                                            const t1 = n[m.fontStack], e1 = t1 && t1[y];
                                            if (e1 && e1.rect) w = e1.rect, x = e1.metrics;
                                            else {
                                                const t1 = r[m.fontStack], e1 = t1 && t1[y];
                                                if (!e1) continue;
                                                x = e1.metrics;
                                            }
                                            v = (a - m.scale) * xc;
                                        }
                                        A ? (e1.verticalizable = !0, _.push({
                                            glyph: y,
                                            imageName: T,
                                            x: p,
                                            y: d + v,
                                            vertical: A,
                                            scale: m.scale,
                                            fontStack: m.fontStack,
                                            sectionIndex: g,
                                            metrics: x,
                                            rect: w
                                        }), p += k * m.scale + u) : (_.push({
                                            glyph: y,
                                            imageName: T,
                                            x: p,
                                            y: d + v,
                                            vertical: A,
                                            scale: m.scale,
                                            fontStack: m.fontStack,
                                            sectionIndex: g,
                                            metrics: x,
                                            rect: w
                                        }), p += x.advance * m.scale + u);
                                    }
                                    if (0 !== _.length) {
                                        const t1 = p - u;
                                        m = Math.max(t1, m), fu(_, 0, _.length - 1, y, b);
                                    }
                                    p = 0;
                                    const w = o * a + b;
                                    x.lineOffset = Math.max(b, l), d += w, g = Math.max(w, g), ++v;
                                }
                                const x = d - Kc, { horizontalAlign: _, verticalAlign: b } = hu(s);
                                (function(t1, e1, r, n, i, a, o, s, l) {
                                    const c = (e1 - r) * i;
                                    let u = 0;
                                    u = a !== o ? -s * n - Kc : (-n * l + .5) * o;
                                    for (const e1 of t1)for (const t1 of e1.positionedGlyphs)t1.x += c, t1.y += u;
                                })(e1.positionedLines, y, _, b, m, g, o, x, a.length), e1.top += -b * x, e1.bottom = e1.top + x, e1.left += -_ * m, e1.right = e1.left + m;
                            }(b, r, n, i, y, s, l, c, f, u, p, m), !function(t1) {
                                for (const e1 of t1)if (0 !== e1.positionedGlyphs.length) return !1;
                                return !0;
                            }(_) && b;
                        }
                        const ru = {
                            9: !0,
                            10: !0,
                            11: !0,
                            12: !0,
                            13: !0,
                            32: !0
                        }, nu = {
                            10: !0,
                            32: !0,
                            38: !0,
                            41: !0,
                            43: !0,
                            45: !0,
                            47: !0,
                            173: !0,
                            183: !0,
                            8203: !0,
                            8208: !0,
                            8211: !0,
                            8231: !0
                        }, iu = {
                            40: !0
                        };
                        function au(t1, e1, r, n, i, a) {
                            if (e1.imageName) {
                                const t1 = n[e1.imageName];
                                return t1 ? t1.displaySize[0] * e1.scale * xc / a + i : 0;
                            }
                            {
                                const n = r[e1.fontStack], a = n && n[t1];
                                return a ? a.metrics.advance * e1.scale + i : 0;
                            }
                        }
                        function ou(t1, e1, r, n) {
                            const i = Math.pow(t1 - e1, 2);
                            return n ? t1 < e1 ? i / 2 : 2 * i : i + Math.abs(r) * r;
                        }
                        function su(t1, e1, r) {
                            let n = 0;
                            return 10 === t1 && (n -= 1e4), r && (n += 150), 40 !== t1 && 65288 !== t1 || (n += 50), 41 !== e1 && 65289 !== e1 || (n += 50), n;
                        }
                        function lu(t1, e1, r, n, i, a) {
                            let o = null, s = ou(e1, r, i, a);
                            for (const t1 of n){
                                const n = ou(e1 - t1.x, r, i, a) + t1.badness;
                                n <= s && (o = t1, s = n);
                            }
                            return {
                                index: t1,
                                x: e1,
                                priorBreak: o,
                                badness: s
                            };
                        }
                        function cu(t1) {
                            return t1 ? cu(t1.priorBreak).concat(t1.index) : [];
                        }
                        function uu(t1, e1, r, n, i, a) {
                            if (!t1) return [];
                            const o = [], s = function(t1, e1, r, n, i, a) {
                                let o = 0;
                                for(let r = 0; r < t1.length(); r++){
                                    const s = t1.getSection(r);
                                    o += au(t1.getCharCode(r), s, n, i, e1, a);
                                }
                                return o / Math.max(1, Math.ceil(o / r));
                            }(t1, e1, r, n, i, a), l = t1.text.indexOf("\u200B") >= 0;
                            let c = 0;
                            for(let r = 0; r < t1.length(); r++){
                                const h = t1.getSection(r), f = t1.getCharCode(r);
                                if (ru[f] || (c += au(f, h, n, i, e1, a)), r < t1.length() - 1) {
                                    const e1 = !((u = f) < 11904 || !(zi["Bopomofo Extended"](u) || zi.Bopomofo(u) || zi["CJK Compatibility Forms"](u) || zi["CJK Compatibility Ideographs"](u) || zi["CJK Compatibility"](u) || zi["CJK Radicals Supplement"](u) || zi["CJK Strokes"](u) || zi["CJK Symbols and Punctuation"](u) || zi["CJK Unified Ideographs Extension A"](u) || zi["CJK Unified Ideographs"](u) || zi["Enclosed CJK Letters and Months"](u) || zi["Halfwidth and Fullwidth Forms"](u) || zi.Hiragana(u) || zi["Ideographic Description Characters"](u) || zi["Kangxi Radicals"](u) || zi["Katakana Phonetic Extensions"](u) || zi.Katakana(u) || zi["Vertical Forms"](u) || zi["Yi Radicals"](u) || zi["Yi Syllables"](u)));
                                    (nu[f] || e1 || h.imageName || r !== t1.length() - 2 && iu[t1.getCharCode(r + 1)]) && o.push(lu(r + 1, c, s, o, su(f, t1.getCharCode(r + 1), e1 && l), !1));
                                }
                            }
                            var u;
                            return cu(lu(t1.length(), c, s, o, 0, !0));
                        }
                        function hu(t1) {
                            let e1 = .5, r = .5;
                            switch(t1){
                                case "right":
                                case "top-right":
                                case "bottom-right":
                                    e1 = 1;
                                    break;
                                case "left":
                                case "top-left":
                                case "bottom-left":
                                    e1 = 0;
                            }
                            switch(t1){
                                case "bottom":
                                case "bottom-right":
                                case "bottom-left":
                                    r = 1;
                                    break;
                                case "top":
                                case "top-right":
                                case "top-left":
                                    r = 0;
                            }
                            return {
                                horizontalAlign: e1,
                                verticalAlign: r
                            };
                        }
                        function fu(t1, e1, r, n, i) {
                            if (!n && !i) return;
                            const a = t1[r], o = a.metrics.advance * a.scale, s = (t1[r].x + o) * n;
                            for(let n = e1; n <= r; n++)t1[n].x -= s, t1[n].y += i;
                        }
                        function pu(t1, e1, r) {
                            const { horizontalAlign: n, verticalAlign: i } = hu(r), a = e1[0], o = e1[1], s = a - t1.displaySize[0] * n, l = s + t1.displaySize[0], c = o - t1.displaySize[1] * i;
                            return {
                                image: t1,
                                top: c,
                                bottom: c + t1.displaySize[1],
                                left: s,
                                right: l
                            };
                        }
                        function du(t1) {
                            var e1, r;
                            let n = t1.left, i = t1.top, a = t1.right - n, o = t1.bottom - i;
                            const s = t1.image.content[2] - t1.image.content[0], l = t1.image.content[3] - t1.image.content[1], c = null !== (e1 = t1.image.textFitWidth) && void 0 !== e1 ? e1 : "stretchOrShrink", u = null !== (r = t1.image.textFitHeight) && void 0 !== r ? r : "stretchOrShrink", h = s / l;
                            if ("proportional" === u) {
                                if ("stretchOnly" === c && a / o < h || "proportional" === c) {
                                    const t1 = Math.ceil(o * h);
                                    n *= t1 / a, a = t1;
                                }
                            } else if ("proportional" === c && "stretchOnly" === u && 0 !== h && a / o > h) {
                                const t1 = Math.ceil(a / h);
                                i *= t1 / o, o = t1;
                            }
                            return {
                                x1: n,
                                y1: i,
                                x2: n + a,
                                y2: i + o
                            };
                        }
                        function mu(t1, e1, r, n, i, a) {
                            const o = t1.image;
                            let s;
                            if (o.content) {
                                const t1 = o.content, e1 = o.pixelRatio || 1;
                                s = [
                                    t1[0] / e1,
                                    t1[1] / e1,
                                    o.displaySize[0] - t1[2] / e1,
                                    o.displaySize[1] - t1[3] / e1
                                ];
                            }
                            const l = e1.left * a, c = e1.right * a;
                            let u, h, f, p;
                            "width" === r || "both" === r ? (p = i[0] + l - n[3], h = i[0] + c + n[1]) : (p = i[0] + (l + c - o.displaySize[0]) / 2, h = p + o.displaySize[0]);
                            const d = e1.top * a, m = e1.bottom * a;
                            return "height" === r || "both" === r ? (u = i[1] + d - n[0], f = i[1] + m + n[2]) : (u = i[1] + (d + m - o.displaySize[1]) / 2, f = u + o.displaySize[1]), {
                                image: o,
                                top: u,
                                right: h,
                                bottom: f,
                                left: p,
                                collisionPadding: s
                            };
                        }
                        const gu = 255, yu = 128, vu = gu * yu;
                        function xu(t1, e1) {
                            const { expression: r } = e1;
                            if ("constant" === r.kind) return {
                                kind: "constant",
                                layoutSize: r.evaluate(new Hi(t1 + 1))
                            };
                            if ("source" === r.kind) return {
                                kind: "source"
                            };
                            {
                                const { zoomStops: e1, interpolationType: n } = r;
                                let i = 0;
                                for(; i < e1.length && e1[i] <= t1;)i++;
                                i = Math.max(0, i - 1);
                                let a = i;
                                for(; a < e1.length && e1[a] < t1 + 1;)a++;
                                a = Math.min(e1.length - 1, a);
                                const o = e1[i], s = e1[a];
                                return "composite" === r.kind ? {
                                    kind: "composite",
                                    minZoom: o,
                                    maxZoom: s,
                                    interpolationType: n
                                } : {
                                    kind: "camera",
                                    minZoom: o,
                                    maxZoom: s,
                                    minSize: r.evaluate(new Hi(o)),
                                    maxSize: r.evaluate(new Hi(s)),
                                    interpolationType: n
                                };
                            }
                        }
                        function _u(t1, e1, r) {
                            let n = "never";
                            const i = t1.get(e1);
                            return i ? n = i : t1.get(r) && (n = "always"), n;
                        }
                        const bu = Tl.VectorTileFeature.types, wu = [
                            {
                                name: "a_fade_opacity",
                                components: 1,
                                type: "Uint8",
                                offset: 0
                            }
                        ];
                        function Tu(t1, e1, r, n, i, a, o, s, l, c, u, h, f) {
                            const p = s ? Math.min(vu, Math.round(s[0])) : 0, d = s ? Math.min(vu, Math.round(s[1])) : 0;
                            t1.emplaceBack(e1, r, Math.round(32 * n), Math.round(32 * i), a, o, (p << 1) + (l ? 1 : 0), d, 16 * c, 16 * u, 256 * h, 256 * f);
                        }
                        function ku(t1, e1, r) {
                            t1.emplaceBack(e1.x, e1.y, r), t1.emplaceBack(e1.x, e1.y, r), t1.emplaceBack(e1.x, e1.y, r), t1.emplaceBack(e1.x, e1.y, r);
                        }
                        function Au(t1) {
                            for (const e1 of t1.sections)if (Vi(e1.text)) return !0;
                            return !1;
                        }
                        class Mu {
                            constructor(t1){
                                this.layoutVertexArray = new to, this.indexArray = new ao, this.programConfigurations = t1, this.segments = new ho, this.dynamicLayoutVertexArray = new eo, this.opacityVertexArray = new ro, this.hasVisibleVertices = !1, this.placedSymbolArray = new Ba;
                            }
                            isEmpty() {
                                return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length;
                            }
                            upload(t1, e1, r, n) {
                                this.isEmpty() || (r && (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, fc.members), this.indexBuffer = t1.createIndexBuffer(this.indexArray, e1), this.dynamicLayoutVertexBuffer = t1.createVertexBuffer(this.dynamicLayoutVertexArray, pc.members, !0), this.opacityVertexBuffer = t1.createVertexBuffer(this.opacityVertexArray, wu, !0), this.opacityVertexBuffer.itemSize = 1), (r || n) && this.programConfigurations.upload(t1));
                            }
                            destroy() {
                                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy());
                            }
                        }
                        Mi("SymbolBuffers", Mu);
                        class Su {
                            constructor(t1, e1, r){
                                this.layoutVertexArray = new t1, this.layoutAttributes = e1, this.indexArray = new r, this.segments = new ho, this.collisionVertexArray = new io;
                            }
                            upload(t1) {
                                this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = t1.createVertexBuffer(this.collisionVertexArray, dc.members, !0);
                            }
                            destroy() {
                                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy());
                            }
                        }
                        Mi("CollisionBuffers", Su);
                        class Eu {
                            constructor(e1){
                                this.collisionBoxArray = e1.collisionBoxArray, this.zoom = e1.zoom, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((t1)=>t1.id), this.index = e1.index, this.pixelRatio = e1.pixelRatio, this.sourceLayerIndex = e1.sourceLayerIndex, this.hasPattern = !1, this.hasRTLText = !1, this.sortKeyRanges = [], this.collisionCircleArray = [], this.placementInvProjMatrix = ps([]), this.placementViewportMatrix = ps([]);
                                const r = this.layers[0]._unevaluatedLayout._values;
                                this.textSizeData = xu(this.zoom, r["text-size"]), this.iconSizeData = xu(this.zoom, r["icon-size"]);
                                const n = this.layers[0].layout, i = n.get("symbol-sort-key"), a = n.get("symbol-z-order");
                                this.canOverlap = "never" !== _u(n, "text-overlap", "text-allow-overlap") || "never" !== _u(n, "icon-overlap", "icon-allow-overlap") || n.get("text-ignore-placement") || n.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== a && !i.isConstant();
                                const o = "viewport-y" === a || "auto" === a && !this.sortFeaturesByKey;
                                this.sortFeaturesByY = o && this.canOverlap, "point" === n.get("symbol-placement") && (this.writingModes = n.get("text-writing-mode").map((e1)=>t1.ai[e1])), this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id), this.sourceID = e1.sourceID;
                            }
                            createArrays() {
                                this.text = new Mu(new Bo(this.layers, this.zoom, (t1)=>/^text/.test(t1))), this.icon = new Mu(new Bo(this.layers, this.zoom, (t1)=>/^icon/.test(t1))), this.glyphOffsetArray = new Ua, this.lineVertexArray = new Va, this.symbolInstances = new ja, this.textAnchorOffsets = new Ha;
                            }
                            calculateGlyphDependencies(t1, e1, r, n, i) {
                                for(let a = 0; a < t1.length; a++)if (e1[t1.charCodeAt(a)] = !0, (r || n) && i) {
                                    const r = vc[t1.charAt(a)];
                                    r && (e1[r.charCodeAt(0)] = !0);
                                }
                            }
                            populate(e1, r, n) {
                                const i = this.layers[0], a = i.layout, o = a.get("text-font"), s = a.get("text-field"), l = a.get("icon-image"), c = ("constant" !== s.value.kind || s.value.value instanceof Kt && !s.value.value.isEmpty() || s.value.value.toString().length > 0) && ("constant" !== o.value.kind || o.value.value.length > 0), u = "constant" !== l.value.kind || !!l.value.value || Object.keys(l.parameters).length > 0, h = a.get("symbol-sort-key");
                                if (this.features = [], !c && !u) return;
                                const f = r.iconDependencies, p = r.glyphDependencies, d = r.availableImages, m = new Hi(this.zoom);
                                for (const { feature: r, id: s, index: l, sourceLayerIndex: g } of e1){
                                    const e1 = i._featureFilter.needGeometry, y = Go(r, e1);
                                    if (!i._featureFilter.filter(m, y, n)) continue;
                                    let v, x;
                                    if (e1 || (y.geometry = Ho(r)), c) {
                                        const t1 = i.getValueAndResolveTokens("text-field", y, n, d), e1 = Kt.factory(t1), r = this.hasRTLText = this.hasRTLText || Au(e1);
                                        (!r || "unavailable" === qi.getRTLTextPluginStatus() || r && qi.isParsed()) && (v = yc(e1, i, y));
                                    }
                                    if (u) {
                                        const t1 = i.getValueAndResolveTokens("icon-image", y, n, d);
                                        x = t1 instanceof re ? t1 : re.fromString(t1);
                                    }
                                    if (!v && !x) continue;
                                    const _ = this.sortFeaturesByKey ? h.evaluate(y, {}, n) : void 0, b = {
                                        id: s,
                                        text: v,
                                        icon: x,
                                        index: l,
                                        sourceLayerIndex: g,
                                        geometry: y.geometry,
                                        properties: r.properties,
                                        type: bu[r.type],
                                        sortKey: _
                                    };
                                    if (this.features.push(b), x && (f[x.name] = !0), v) {
                                        const e1 = o.evaluate(y, {}, n).join(","), r = "viewport" !== a.get("text-rotation-alignment") && "point" !== a.get("symbol-placement");
                                        this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(t1.ai.vertical) >= 0;
                                        for (const t1 of v.sections)if (t1.image) f[t1.image.name] = !0;
                                        else {
                                            const n = Oi(v.toString()), i = t1.fontStack || e1, a = p[i] = p[i] || {};
                                            this.calculateGlyphDependencies(t1.text, a, r, this.allowVerticalPlacement, n);
                                        }
                                    }
                                }
                                "line" === a.get("symbol-placement") && (this.features = function(t1) {
                                    const e1 = {}, r = {}, n = [];
                                    let i = 0;
                                    function a(e1) {
                                        n.push(t1[e1]), i++;
                                    }
                                    function o(t1, e1, i) {
                                        const a = r[t1];
                                        return delete r[t1], r[e1] = a, n[a].geometry[0].pop(), n[a].geometry[0] = n[a].geometry[0].concat(i[0]), a;
                                    }
                                    function s(t1, r, i) {
                                        const a = e1[r];
                                        return delete e1[r], e1[t1] = a, n[a].geometry[0].shift(), n[a].geometry[0] = i[0].concat(n[a].geometry[0]), a;
                                    }
                                    function l(t1, e1, r) {
                                        const n = r ? e1[0][e1[0].length - 1] : e1[0][0];
                                        return `${t1}:${n.x}:${n.y}`;
                                    }
                                    for(let c = 0; c < t1.length; c++){
                                        const u = t1[c], h = u.geometry, f = u.text ? u.text.toString() : null;
                                        if (!f) {
                                            a(c);
                                            continue;
                                        }
                                        const p = l(f, h), d = l(f, h, !0);
                                        if (p in r && d in e1 && r[p] !== e1[d]) {
                                            const t1 = s(p, d, h), i = o(p, d, n[t1].geometry);
                                            delete e1[p], delete r[d], r[l(f, n[i].geometry, !0)] = i, n[t1].geometry = null;
                                        } else p in r ? o(p, d, h) : d in e1 ? s(p, d, h) : (a(c), e1[p] = i - 1, r[d] = i - 1);
                                    }
                                    return n.filter((t1)=>t1.geometry);
                                }(this.features)), this.sortFeaturesByKey && this.features.sort((t1, e1)=>t1.sortKey - e1.sortKey);
                            }
                            update(t1, e1, r) {
                                this.stateDependentLayers.length && (this.text.programConfigurations.updatePaintArrays(t1, e1, this.layers, r), this.icon.programConfigurations.updatePaintArrays(t1, e1, this.layers, r));
                            }
                            isEmpty() {
                                return 0 === this.symbolInstances.length && !this.hasRTLText;
                            }
                            uploadPending() {
                                return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
                            }
                            upload(t1) {
                                !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(t1), this.iconCollisionBox.upload(t1)), this.text.upload(t1, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload), this.icon.upload(t1, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload), this.uploaded = !0;
                            }
                            destroyDebugData() {
                                this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
                            }
                            destroy() {
                                this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
                            }
                            addToLineVertexArray(t1, e1) {
                                const r = this.lineVertexArray.length;
                                if (void 0 !== t1.segment) {
                                    let r = t1.dist(e1[t1.segment + 1]), n = t1.dist(e1[t1.segment]);
                                    const i = {};
                                    for(let n = t1.segment + 1; n < e1.length; n++)i[n] = {
                                        x: e1[n].x,
                                        y: e1[n].y,
                                        tileUnitDistanceFromAnchor: r
                                    }, n < e1.length - 1 && (r += e1[n + 1].dist(e1[n]));
                                    for(let r = t1.segment || 0; r >= 0; r--)i[r] = {
                                        x: e1[r].x,
                                        y: e1[r].y,
                                        tileUnitDistanceFromAnchor: n
                                    }, r > 0 && (n += e1[r - 1].dist(e1[r]));
                                    for(let t1 = 0; t1 < e1.length; t1++){
                                        const e1 = i[t1];
                                        this.lineVertexArray.emplaceBack(e1.x, e1.y, e1.tileUnitDistanceFromAnchor);
                                    }
                                }
                                return {
                                    lineStartIndex: r,
                                    lineLength: this.lineVertexArray.length - r
                                };
                            }
                            addSymbols(e1, r, n, i, a, o, s, l, c, u, h, f) {
                                const p = e1.indexArray, d = e1.layoutVertexArray, m = e1.segments.prepareSegment(4 * r.length, d, p, this.canOverlap ? o.sortKey : void 0), g = this.glyphOffsetArray.length, y = m.vertexLength, v = this.allowVerticalPlacement && s === t1.ai.vertical ? Math.PI / 2 : 0, x = o.text && o.text.sections;
                                for(let t1 = 0; t1 < r.length; t1++){
                                    const { tl: i, tr: a, bl: s, br: c, tex: u, pixelOffsetTL: h, pixelOffsetBR: g, minFontScaleX: y, minFontScaleY: _, glyphOffset: b, isSDF: w, sectionIndex: T } = r[t1], k = m.vertexLength, A = b[1];
                                    Tu(d, l.x, l.y, i.x, A + i.y, u.x, u.y, n, w, h.x, h.y, y, _), Tu(d, l.x, l.y, a.x, A + a.y, u.x + u.w, u.y, n, w, g.x, h.y, y, _), Tu(d, l.x, l.y, s.x, A + s.y, u.x, u.y + u.h, n, w, h.x, g.y, y, _), Tu(d, l.x, l.y, c.x, A + c.y, u.x + u.w, u.y + u.h, n, w, g.x, g.y, y, _), ku(e1.dynamicLayoutVertexArray, l, v), p.emplaceBack(k, k + 1, k + 2), p.emplaceBack(k + 1, k + 2, k + 3), m.vertexLength += 4, m.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(b[0]), t1 !== r.length - 1 && T === r[t1 + 1].sectionIndex || e1.programConfigurations.populatePaintArrays(d.length, o, o.index, {}, f, x && x[T]);
                                }
                                e1.placedSymbolArray.emplaceBack(l.x, l.y, g, this.glyphOffsetArray.length - g, y, c, u, l.segment, n ? n[0] : 0, n ? n[1] : 0, i[0], i[1], s, 0, !1, 0, h);
                            }
                            _addCollisionDebugVertex(t1, e1, r, n, i, a) {
                                return e1.emplaceBack(0, 0), t1.emplaceBack(r.x, r.y, n, i, Math.round(a.x), Math.round(a.y));
                            }
                            addCollisionDebugVertices(t1, e1, r, n, i, o, s) {
                                const l = i.segments.prepareSegment(4, i.layoutVertexArray, i.indexArray), c = l.vertexLength, u = i.layoutVertexArray, h = i.collisionVertexArray, f = s.anchorX, p = s.anchorY;
                                this._addCollisionDebugVertex(u, h, o, f, p, new a(t1, e1)), this._addCollisionDebugVertex(u, h, o, f, p, new a(r, e1)), this._addCollisionDebugVertex(u, h, o, f, p, new a(r, n)), this._addCollisionDebugVertex(u, h, o, f, p, new a(t1, n)), l.vertexLength += 4;
                                const d = i.indexArray;
                                d.emplaceBack(c, c + 1), d.emplaceBack(c + 1, c + 2), d.emplaceBack(c + 2, c + 3), d.emplaceBack(c + 3, c), l.primitiveLength += 4;
                            }
                            addDebugCollisionBoxes(t1, e1, r, n) {
                                for(let i = t1; i < e1; i++){
                                    const t1 = this.collisionBoxArray.get(i), e1 = t1.x1, a = t1.y1, o = t1.x2, s = t1.y2;
                                    this.addCollisionDebugVertices(e1, a, o, s, n ? this.textCollisionBox : this.iconCollisionBox, t1.anchorPoint, r);
                                }
                            }
                            generateCollisionDebugBuffers() {
                                this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new Su(no, mc.members, oo), this.iconCollisionBox = new Su(no, mc.members, oo);
                                for(let t1 = 0; t1 < this.symbolInstances.length; t1++){
                                    const e1 = this.symbolInstances.get(t1);
                                    this.addDebugCollisionBoxes(e1.textBoxStartIndex, e1.textBoxEndIndex, e1, !0), this.addDebugCollisionBoxes(e1.verticalTextBoxStartIndex, e1.verticalTextBoxEndIndex, e1, !0), this.addDebugCollisionBoxes(e1.iconBoxStartIndex, e1.iconBoxEndIndex, e1, !1), this.addDebugCollisionBoxes(e1.verticalIconBoxStartIndex, e1.verticalIconBoxEndIndex, e1, !1);
                                }
                            }
                            _deserializeCollisionBoxesForSymbol(t1, e1, r, n, i, a, o, s, l) {
                                const c = {};
                                for(let n = e1; n < r; n++){
                                    const e1 = t1.get(n);
                                    c.textBox = {
                                        x1: e1.x1,
                                        y1: e1.y1,
                                        x2: e1.x2,
                                        y2: e1.y2,
                                        anchorPointX: e1.anchorPointX,
                                        anchorPointY: e1.anchorPointY
                                    }, c.textFeatureIndex = e1.featureIndex;
                                    break;
                                }
                                for(let e1 = n; e1 < i; e1++){
                                    const r = t1.get(e1);
                                    c.verticalTextBox = {
                                        x1: r.x1,
                                        y1: r.y1,
                                        x2: r.x2,
                                        y2: r.y2,
                                        anchorPointX: r.anchorPointX,
                                        anchorPointY: r.anchorPointY
                                    }, c.verticalTextFeatureIndex = r.featureIndex;
                                    break;
                                }
                                for(let e1 = a; e1 < o; e1++){
                                    const r = t1.get(e1);
                                    c.iconBox = {
                                        x1: r.x1,
                                        y1: r.y1,
                                        x2: r.x2,
                                        y2: r.y2,
                                        anchorPointX: r.anchorPointX,
                                        anchorPointY: r.anchorPointY
                                    }, c.iconFeatureIndex = r.featureIndex;
                                    break;
                                }
                                for(let e1 = s; e1 < l; e1++){
                                    const r = t1.get(e1);
                                    c.verticalIconBox = {
                                        x1: r.x1,
                                        y1: r.y1,
                                        x2: r.x2,
                                        y2: r.y2,
                                        anchorPointX: r.anchorPointX,
                                        anchorPointY: r.anchorPointY
                                    }, c.verticalIconFeatureIndex = r.featureIndex;
                                    break;
                                }
                                return c;
                            }
                            deserializeCollisionBoxes(t1) {
                                this.collisionArrays = [];
                                for(let e1 = 0; e1 < this.symbolInstances.length; e1++){
                                    const r = this.symbolInstances.get(e1);
                                    this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t1, r.textBoxStartIndex, r.textBoxEndIndex, r.verticalTextBoxStartIndex, r.verticalTextBoxEndIndex, r.iconBoxStartIndex, r.iconBoxEndIndex, r.verticalIconBoxStartIndex, r.verticalIconBoxEndIndex));
                                }
                            }
                            hasTextData() {
                                return this.text.segments.get().length > 0;
                            }
                            hasIconData() {
                                return this.icon.segments.get().length > 0;
                            }
                            hasDebugData() {
                                return this.textCollisionBox && this.iconCollisionBox;
                            }
                            hasTextCollisionBoxData() {
                                return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
                            }
                            hasIconCollisionBoxData() {
                                return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
                            }
                            addIndicesForPlacedSymbol(t1, e1) {
                                const r = t1.placedSymbolArray.get(e1), n = r.vertexStartIndex + 4 * r.numGlyphs;
                                for(let e1 = r.vertexStartIndex; e1 < n; e1 += 4)t1.indexArray.emplaceBack(e1, e1 + 1, e1 + 2), t1.indexArray.emplaceBack(e1 + 1, e1 + 2, e1 + 3);
                            }
                            getSortedSymbolIndexes(t1) {
                                if (this.sortedAngle === t1 && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
                                const e1 = Math.sin(t1), r = Math.cos(t1), n = [], i = [], a = [];
                                for(let t1 = 0; t1 < this.symbolInstances.length; ++t1){
                                    a.push(t1);
                                    const o = this.symbolInstances.get(t1);
                                    n.push(0 | Math.round(e1 * o.anchorX + r * o.anchorY)), i.push(o.featureIndex);
                                }
                                return a.sort((t1, e1)=>n[t1] - n[e1] || i[e1] - i[t1]), a;
                            }
                            addToSortKeyRanges(t1, e1) {
                                const r = this.sortKeyRanges[this.sortKeyRanges.length - 1];
                                r && r.sortKey === e1 ? r.symbolInstanceEnd = t1 + 1 : this.sortKeyRanges.push({
                                    sortKey: e1,
                                    symbolInstanceStart: t1,
                                    symbolInstanceEnd: t1 + 1
                                });
                            }
                            sortFeatures(t1) {
                                if (this.sortFeaturesByY && this.sortedAngle !== t1 && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
                                    this.symbolInstanceIndexes = this.getSortedSymbolIndexes(t1), this.sortedAngle = t1, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                                    for (const t1 of this.symbolInstanceIndexes){
                                        const e1 = this.symbolInstances.get(t1);
                                        this.featureSortOrder.push(e1.featureIndex), [
                                            e1.rightJustifiedTextSymbolIndex,
                                            e1.centerJustifiedTextSymbolIndex,
                                            e1.leftJustifiedTextSymbolIndex
                                        ].forEach((t1, e1, r)=>{
                                            t1 >= 0 && r.indexOf(t1) === e1 && this.addIndicesForPlacedSymbol(this.text, t1);
                                        }), e1.verticalPlacedTextSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.text, e1.verticalPlacedTextSymbolIndex), e1.placedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, e1.placedIconSymbolIndex), e1.verticalPlacedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, e1.verticalPlacedIconSymbolIndex);
                                    }
                                    this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
                                }
                            }
                        }
                        let Cu;
                        Mi("SymbolBucket", Eu, {
                            omit: [
                                "layers",
                                "collisionBoxArray",
                                "features",
                                "compareText"
                            ]
                        }), Eu.MAX_GLYPHS = 65535, Eu.addDynamicAttributes = ku;
                        let Lu;
                        var Iu = {
                            get paint () {
                                return Lu = Lu || new ia({
                                    "icon-opacity": new ta(Z.paint_symbol["icon-opacity"]),
                                    "icon-color": new ta(Z.paint_symbol["icon-color"]),
                                    "icon-halo-color": new ta(Z.paint_symbol["icon-halo-color"]),
                                    "icon-halo-width": new ta(Z.paint_symbol["icon-halo-width"]),
                                    "icon-halo-blur": new ta(Z.paint_symbol["icon-halo-blur"]),
                                    "icon-translate": new Qi(Z.paint_symbol["icon-translate"]),
                                    "icon-translate-anchor": new Qi(Z.paint_symbol["icon-translate-anchor"]),
                                    "text-opacity": new ta(Z.paint_symbol["text-opacity"]),
                                    "text-color": new ta(Z.paint_symbol["text-color"], {
                                        runtimeType: ft,
                                        getOverride: (t1)=>t1.textColor,
                                        hasOverride: (t1)=>!!t1.textColor
                                    }),
                                    "text-halo-color": new ta(Z.paint_symbol["text-halo-color"]),
                                    "text-halo-width": new ta(Z.paint_symbol["text-halo-width"]),
                                    "text-halo-blur": new ta(Z.paint_symbol["text-halo-blur"]),
                                    "text-translate": new Qi(Z.paint_symbol["text-translate"]),
                                    "text-translate-anchor": new Qi(Z.paint_symbol["text-translate-anchor"])
                                });
                            },
                            get layout () {
                                return Cu = Cu || new ia({
                                    "symbol-placement": new Qi(Z.layout_symbol["symbol-placement"]),
                                    "symbol-spacing": new Qi(Z.layout_symbol["symbol-spacing"]),
                                    "symbol-avoid-edges": new Qi(Z.layout_symbol["symbol-avoid-edges"]),
                                    "symbol-sort-key": new ta(Z.layout_symbol["symbol-sort-key"]),
                                    "symbol-z-order": new Qi(Z.layout_symbol["symbol-z-order"]),
                                    "icon-allow-overlap": new Qi(Z.layout_symbol["icon-allow-overlap"]),
                                    "icon-overlap": new Qi(Z.layout_symbol["icon-overlap"]),
                                    "icon-ignore-placement": new Qi(Z.layout_symbol["icon-ignore-placement"]),
                                    "icon-optional": new Qi(Z.layout_symbol["icon-optional"]),
                                    "icon-rotation-alignment": new Qi(Z.layout_symbol["icon-rotation-alignment"]),
                                    "icon-size": new ta(Z.layout_symbol["icon-size"]),
                                    "icon-text-fit": new Qi(Z.layout_symbol["icon-text-fit"]),
                                    "icon-text-fit-padding": new Qi(Z.layout_symbol["icon-text-fit-padding"]),
                                    "icon-image": new ta(Z.layout_symbol["icon-image"]),
                                    "icon-rotate": new ta(Z.layout_symbol["icon-rotate"]),
                                    "icon-padding": new ta(Z.layout_symbol["icon-padding"]),
                                    "icon-keep-upright": new Qi(Z.layout_symbol["icon-keep-upright"]),
                                    "icon-offset": new ta(Z.layout_symbol["icon-offset"]),
                                    "icon-anchor": new ta(Z.layout_symbol["icon-anchor"]),
                                    "icon-pitch-alignment": new Qi(Z.layout_symbol["icon-pitch-alignment"]),
                                    "text-pitch-alignment": new Qi(Z.layout_symbol["text-pitch-alignment"]),
                                    "text-rotation-alignment": new Qi(Z.layout_symbol["text-rotation-alignment"]),
                                    "text-field": new ta(Z.layout_symbol["text-field"]),
                                    "text-font": new ta(Z.layout_symbol["text-font"]),
                                    "text-size": new ta(Z.layout_symbol["text-size"]),
                                    "text-max-width": new ta(Z.layout_symbol["text-max-width"]),
                                    "text-line-height": new Qi(Z.layout_symbol["text-line-height"]),
                                    "text-letter-spacing": new ta(Z.layout_symbol["text-letter-spacing"]),
                                    "text-justify": new ta(Z.layout_symbol["text-justify"]),
                                    "text-radial-offset": new ta(Z.layout_symbol["text-radial-offset"]),
                                    "text-variable-anchor": new Qi(Z.layout_symbol["text-variable-anchor"]),
                                    "text-variable-anchor-offset": new ta(Z.layout_symbol["text-variable-anchor-offset"]),
                                    "text-anchor": new ta(Z.layout_symbol["text-anchor"]),
                                    "text-max-angle": new Qi(Z.layout_symbol["text-max-angle"]),
                                    "text-writing-mode": new Qi(Z.layout_symbol["text-writing-mode"]),
                                    "text-rotate": new ta(Z.layout_symbol["text-rotate"]),
                                    "text-padding": new Qi(Z.layout_symbol["text-padding"]),
                                    "text-keep-upright": new Qi(Z.layout_symbol["text-keep-upright"]),
                                    "text-transform": new ta(Z.layout_symbol["text-transform"]),
                                    "text-offset": new ta(Z.layout_symbol["text-offset"]),
                                    "text-allow-overlap": new Qi(Z.layout_symbol["text-allow-overlap"]),
                                    "text-overlap": new Qi(Z.layout_symbol["text-overlap"]),
                                    "text-ignore-placement": new Qi(Z.layout_symbol["text-ignore-placement"]),
                                    "text-optional": new Qi(Z.layout_symbol["text-optional"])
                                });
                            }
                        };
                        class Pu {
                            constructor(t1){
                                if (void 0 === t1.property.overrides) throw new Error("overrides must be provided to instantiate FormatSectionOverride class");
                                this.type = t1.property.overrides ? t1.property.overrides.runtimeType : lt, this.defaultValue = t1;
                            }
                            evaluate(t1) {
                                if (t1.formattedSection) {
                                    const e1 = this.defaultValue.property.overrides;
                                    if (e1 && e1.hasOverride(t1.formattedSection)) return e1.getOverride(t1.formattedSection);
                                }
                                return t1.feature && t1.featureState ? this.defaultValue.evaluate(t1.feature, t1.featureState) : this.defaultValue.property.specification.default;
                            }
                            eachChild(t1) {
                                this.defaultValue.isConstant() || t1(this.defaultValue.value._styleExpression.expression);
                            }
                            outputDefined() {
                                return !1;
                            }
                            serialize() {
                                return null;
                            }
                        }
                        Mi("FormatSectionOverride", Pu, {
                            omit: [
                                "defaultValue"
                            ]
                        });
                        class zu extends oa {
                            constructor(t1){
                                super(t1, Iu);
                            }
                            recalculate(t1, e1) {
                                if (super.recalculate(t1, e1), "auto" === this.layout.get("icon-rotation-alignment") && ("point" !== this.layout.get("symbol-placement") ? this.layout._values["icon-rotation-alignment"] = "map" : this.layout._values["icon-rotation-alignment"] = "viewport"), "auto" === this.layout.get("text-rotation-alignment") && ("point" !== this.layout.get("symbol-placement") ? this.layout._values["text-rotation-alignment"] = "map" : this.layout._values["text-rotation-alignment"] = "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = "map" === this.layout.get("text-rotation-alignment") ? "map" : "viewport"), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment")), "point" === this.layout.get("symbol-placement")) {
                                    const t1 = this.layout.get("text-writing-mode");
                                    if (t1) {
                                        const e1 = [];
                                        for (const r of t1)e1.indexOf(r) < 0 && e1.push(r);
                                        this.layout._values["text-writing-mode"] = e1;
                                    } else this.layout._values["text-writing-mode"] = [
                                        "horizontal"
                                    ];
                                }
                                this._setPaintOverrides();
                            }
                            getValueAndResolveTokens(t1, e1, r, n) {
                                const i = this.layout.get(t1).evaluate(e1, {}, r, n), a = this._unevaluatedLayout._values[t1];
                                return a.isDataDriven() || kn(a.value) || !i ? i : function(t1, e1) {
                                    return e1.replace(/{([^{}]+)}/g, (e1, r)=>t1 && r in t1 ? String(t1[r]) : "");
                                }(e1.properties, i);
                            }
                            createBucket(t1) {
                                return new Eu(t1);
                            }
                            queryRadius() {
                                return 0;
                            }
                            queryIntersectsFeature() {
                                throw new Error("Should take a different path in FeatureIndex");
                            }
                            _setPaintOverrides() {
                                for (const t1 of Iu.paint.overridableProperties){
                                    if (!zu.hasPaintOverride(this.layout, t1)) continue;
                                    const e1 = this.paint.get(t1), r = new Pu(e1), n = new Tn(r, e1.property.specification);
                                    let i = null;
                                    i = "constant" === e1.value.kind || "source" === e1.value.kind ? new Mn("source", n) : new Sn("composite", n, e1.value.zoomStops), this.paint._values[t1] = new Ji(e1.property, i, e1.parameters);
                                }
                            }
                            _handleOverridablePaintPropertyUpdate(t1, e1, r) {
                                return !(!this.layout || e1.isDataDriven() || r.isDataDriven()) && zu.hasPaintOverride(this.layout, t1);
                            }
                            static hasPaintOverride(t1, e1) {
                                const r = t1.get("text-field"), n = Iu.paint.properties[e1];
                                let i = !1;
                                const a = (t1)=>{
                                    for (const e1 of t1)if (n.overrides && n.overrides.hasOverride(e1)) return void (i = !0);
                                };
                                if ("constant" === r.value.kind && r.value.value instanceof Kt) a(r.value.value.sections);
                                else if ("source" === r.value.kind) {
                                    const t1 = (e1)=>{
                                        if (!i) {
                                            if (e1 instanceof se && ae(e1.value) === gt) {
                                                const t1 = e1.value;
                                                a(t1.sections);
                                            } else e1 instanceof We ? a(e1.sections) : e1.eachChild(t1);
                                        }
                                    }, e1 = r.value;
                                    e1._styleExpression && t1(e1._styleExpression.expression);
                                }
                                return i;
                            }
                        }
                        let Ou;
                        var Du = {
                            get paint () {
                                return Ou = Ou || new ia({
                                    "background-color": new Qi(Z.paint_background["background-color"]),
                                    "background-pattern": new ra(Z.paint_background["background-pattern"]),
                                    "background-opacity": new Qi(Z.paint_background["background-opacity"])
                                });
                            }
                        };
                        class Ru extends oa {
                            constructor(t1){
                                super(t1, Du);
                            }
                        }
                        let Fu;
                        var Bu = {
                            get paint () {
                                return Fu = Fu || new ia({
                                    "raster-opacity": new Qi(Z.paint_raster["raster-opacity"]),
                                    "raster-hue-rotate": new Qi(Z.paint_raster["raster-hue-rotate"]),
                                    "raster-brightness-min": new Qi(Z.paint_raster["raster-brightness-min"]),
                                    "raster-brightness-max": new Qi(Z.paint_raster["raster-brightness-max"]),
                                    "raster-saturation": new Qi(Z.paint_raster["raster-saturation"]),
                                    "raster-contrast": new Qi(Z.paint_raster["raster-contrast"]),
                                    "raster-resampling": new Qi(Z.paint_raster["raster-resampling"]),
                                    "raster-fade-duration": new Qi(Z.paint_raster["raster-fade-duration"])
                                });
                            }
                        };
                        class Nu extends oa {
                            constructor(t1){
                                super(t1, Bu);
                            }
                        }
                        class ju extends oa {
                            constructor(t1){
                                super(t1, {}), this.onAdd = (t1)=>{
                                    this.implementation.onAdd && this.implementation.onAdd(t1, t1.painter.context.gl);
                                }, this.onRemove = (t1)=>{
                                    this.implementation.onRemove && this.implementation.onRemove(t1, t1.painter.context.gl);
                                }, this.implementation = t1;
                            }
                            is3D() {
                                return "3d" === this.implementation.renderingMode;
                            }
                            hasOffscreenPass() {
                                return void 0 !== this.implementation.prerender;
                            }
                            recalculate() {}
                            updateTransitions() {}
                            hasTransition() {
                                return !1;
                            }
                            serialize() {
                                throw new Error("Custom layers cannot be serialized");
                            }
                        }
                        class Uu {
                            constructor(t1){
                                this._methodToThrottle = t1, this._triggered = !1, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel, this._channel.port2.onmessage = ()=>{
                                    this._triggered = !1, this._methodToThrottle();
                                });
                            }
                            trigger() {
                                this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(()=>{
                                    this._triggered = !1, this._methodToThrottle();
                                }, 0));
                            }
                            remove() {
                                delete this._channel, this._methodToThrottle = ()=>{};
                            }
                        }
                        const Vu = 6371008.8;
                        class qu {
                            constructor(t1, e1){
                                if (isNaN(t1) || isNaN(e1)) throw new Error(`Invalid LngLat object: (${t1}, ${e1})`);
                                if (this.lng = +t1, this.lat = +e1, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
                            }
                            wrap() {
                                return new qu(g(this.lng, -180, 180), this.lat);
                            }
                            toArray() {
                                return [
                                    this.lng,
                                    this.lat
                                ];
                            }
                            toString() {
                                return `LngLat(${this.lng}, ${this.lat})`;
                            }
                            distanceTo(t1) {
                                const e1 = Math.PI / 180, r = this.lat * e1, n = t1.lat * e1, i = Math.sin(r) * Math.sin(n) + Math.cos(r) * Math.cos(n) * Math.cos((t1.lng - this.lng) * e1);
                                return Vu * Math.acos(Math.min(i, 1));
                            }
                            static convert(t1) {
                                if (t1 instanceof qu) return t1;
                                if (Array.isArray(t1) && (2 === t1.length || 3 === t1.length)) return new qu(Number(t1[0]), Number(t1[1]));
                                if (!Array.isArray(t1) && "object" == typeof t1 && null !== t1) return new qu(Number("lng" in t1 ? t1.lng : t1.lon), Number(t1.lat));
                                throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
                            }
                        }
                        const Hu = 2 * Math.PI * Vu;
                        function Gu(t1) {
                            return Hu * Math.cos(t1 * Math.PI / 180);
                        }
                        function Zu(t1) {
                            return (180 + t1) / 360;
                        }
                        function Wu(t1) {
                            return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t1 * Math.PI / 360))) / 360;
                        }
                        function Yu(t1, e1) {
                            return t1 / Gu(e1);
                        }
                        function Xu(t1) {
                            const e1 = 180 - 360 * t1;
                            return 360 / Math.PI * Math.atan(Math.exp(e1 * Math.PI / 180)) - 90;
                        }
                        class $u {
                            constructor(t1, e1, r = 0){
                                this.x = +t1, this.y = +e1, this.z = +r;
                            }
                            static fromLngLat(t1, e1 = 0) {
                                const r = qu.convert(t1);
                                return new $u(Zu(r.lng), Wu(r.lat), Yu(e1, r.lat));
                            }
                            toLngLat() {
                                return new qu(360 * this.x - 180, Xu(this.y));
                            }
                            toAltitude() {
                                var t1, e1;
                                return t1 = this.z, e1 = this.y, t1 * Gu(Xu(e1));
                            }
                            meterInMercatorCoordinateUnits() {
                                var t1;
                                return 1 / Hu * (t1 = Xu(this.y), 1 / Math.cos(t1 * Math.PI / 180));
                            }
                        }
                        function Ju(t1, e1, r) {
                            var n = 2 * Math.PI * 6378137 / 256 / Math.pow(2, r);
                            return [
                                t1 * n - 2 * Math.PI * 6378137 / 2,
                                e1 * n - 2 * Math.PI * 6378137 / 2
                            ];
                        }
                        class Ku {
                            constructor(t1, e1, r){
                                if (t1 < 0 || t1 > 25 || r < 0 || r >= Math.pow(2, t1) || e1 < 0 || e1 >= Math.pow(2, t1)) throw new Error(`x=${e1}, y=${r}, z=${t1} outside of bounds. 0<=x<${Math.pow(2, t1)}, 0<=y<${Math.pow(2, t1)} 0<=z<=25 `);
                                this.z = t1, this.x = e1, this.y = r, this.key = eh(0, t1, t1, e1, r);
                            }
                            equals(t1) {
                                return this.z === t1.z && this.x === t1.x && this.y === t1.y;
                            }
                            url(t1, e1, r) {
                                const n = (a = this.x, o = this.y, s = this.z, l = Ju(256 * a, 256 * (o = Math.pow(2, s) - o - 1), s), c = Ju(256 * (a + 1), 256 * (o + 1), s), l[0] + "," + l[1] + "," + c[0] + "," + c[1]), i = function(t1, e1, r) {
                                    let n, i = "";
                                    for(let a = t1; a > 0; a--)n = 1 << a - 1, i += (e1 & n ? 1 : 0) + (r & n ? 2 : 0);
                                    return i;
                                }(this.z, this.x, this.y);
                                var a, o, s, l, c;
                                return t1[(this.x + this.y) % t1.length].replace(/{prefix}/g, (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String("tms" === r ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace(/{ratio}/g, e1 > 1 ? "@2x" : "").replace(/{quadkey}/g, i).replace(/{bbox-epsg-3857}/g, n);
                            }
                            isChildOf(t1) {
                                const e1 = this.z - t1.z;
                                return e1 > 0 && t1.x === this.x >> e1 && t1.y === this.y >> e1;
                            }
                            getTilePoint(t1) {
                                const e1 = Math.pow(2, this.z);
                                return new a((t1.x * e1 - this.x) * Uo, (t1.y * e1 - this.y) * Uo);
                            }
                            toString() {
                                return `${this.z}/${this.x}/${this.y}`;
                            }
                        }
                        class Qu {
                            constructor(t1, e1){
                                this.wrap = t1, this.canonical = e1, this.key = eh(t1, e1.z, e1.z, e1.x, e1.y);
                            }
                        }
                        class th {
                            constructor(t1, e1, r, n, i){
                                if (t1 < r) throw new Error(`overscaledZ should be >= z; overscaledZ = ${t1}; z = ${r}`);
                                this.overscaledZ = t1, this.wrap = e1, this.canonical = new Ku(r, +n, +i), this.key = eh(e1, t1, r, n, i);
                            }
                            clone() {
                                return new th(this.overscaledZ, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y);
                            }
                            equals(t1) {
                                return this.overscaledZ === t1.overscaledZ && this.wrap === t1.wrap && this.canonical.equals(t1.canonical);
                            }
                            scaledTo(t1) {
                                if (t1 > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${t1}; overscaledZ = ${this.overscaledZ}`);
                                const e1 = this.canonical.z - t1;
                                return t1 > this.canonical.z ? new th(t1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new th(t1, this.wrap, t1, this.canonical.x >> e1, this.canonical.y >> e1);
                            }
                            calculateScaledKey(t1, e1) {
                                if (t1 > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${t1}; overscaledZ = ${this.overscaledZ}`);
                                const r = this.canonical.z - t1;
                                return t1 > this.canonical.z ? eh(this.wrap * +e1, t1, this.canonical.z, this.canonical.x, this.canonical.y) : eh(this.wrap * +e1, t1, t1, this.canonical.x >> r, this.canonical.y >> r);
                            }
                            isChildOf(t1) {
                                if (t1.wrap !== this.wrap) return !1;
                                const e1 = this.canonical.z - t1.canonical.z;
                                return 0 === t1.overscaledZ || t1.overscaledZ < this.overscaledZ && t1.canonical.x === this.canonical.x >> e1 && t1.canonical.y === this.canonical.y >> e1;
                            }
                            children(t1) {
                                if (this.overscaledZ >= t1) return [
                                    new th(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
                                ];
                                const e1 = this.canonical.z + 1, r = 2 * this.canonical.x, n = 2 * this.canonical.y;
                                return [
                                    new th(e1, this.wrap, e1, r, n),
                                    new th(e1, this.wrap, e1, r + 1, n),
                                    new th(e1, this.wrap, e1, r, n + 1),
                                    new th(e1, this.wrap, e1, r + 1, n + 1)
                                ];
                            }
                            isLessThan(t1) {
                                return this.wrap < t1.wrap || !(this.wrap > t1.wrap) && (this.overscaledZ < t1.overscaledZ || !(this.overscaledZ > t1.overscaledZ) && (this.canonical.x < t1.canonical.x || !(this.canonical.x > t1.canonical.x) && this.canonical.y < t1.canonical.y));
                            }
                            wrapped() {
                                return new th(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
                            }
                            unwrapTo(t1) {
                                return new th(this.overscaledZ, t1, this.canonical.z, this.canonical.x, this.canonical.y);
                            }
                            overscaleFactor() {
                                return Math.pow(2, this.overscaledZ - this.canonical.z);
                            }
                            toUnwrapped() {
                                return new Qu(this.wrap, this.canonical);
                            }
                            toString() {
                                return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
                            }
                            getTilePoint(t1) {
                                return this.canonical.getTilePoint(new $u(t1.x - this.wrap, t1.y));
                            }
                        }
                        function eh(t1, e1, r, n, i) {
                            (t1 *= 2) < 0 && (t1 = -1 * t1 - 1);
                            const a = 1 << r;
                            return (a * a * t1 + a * i + n).toString(36) + r.toString(36) + e1.toString(36);
                        }
                        Mi("CanonicalTileID", Ku), Mi("OverscaledTileID", th, {
                            omit: [
                                "posMatrix"
                            ]
                        });
                        class rh {
                            constructor(t1, e1, r, n = 1, i = 1, a = 1, o = 0){
                                if (this.uid = t1, e1.height !== e1.width) throw new RangeError("DEM tiles must be square");
                                if (r && ![
                                    "mapbox",
                                    "terrarium",
                                    "custom"
                                ].includes(r)) return void T(`"${r}" is not a valid encoding type. Valid types include "mapbox", "terrarium" and "custom".`);
                                this.stride = e1.height;
                                const s = this.dim = e1.height - 2;
                                switch(this.data = new Uint32Array(e1.data.buffer), r){
                                    case "terrarium":
                                        this.redFactor = 256, this.greenFactor = 1, this.blueFactor = 1 / 256, this.baseShift = 32768;
                                        break;
                                    case "custom":
                                        this.redFactor = n, this.greenFactor = i, this.blueFactor = a, this.baseShift = o;
                                        break;
                                    default:
                                        this.redFactor = 6553.6, this.greenFactor = 25.6, this.blueFactor = .1, this.baseShift = 1e4;
                                }
                                for(let t1 = 0; t1 < s; t1++)this.data[this._idx(-1, t1)] = this.data[this._idx(0, t1)], this.data[this._idx(s, t1)] = this.data[this._idx(s - 1, t1)], this.data[this._idx(t1, -1)] = this.data[this._idx(t1, 0)], this.data[this._idx(t1, s)] = this.data[this._idx(t1, s - 1)];
                                this.data[this._idx(-1, -1)] = this.data[this._idx(0, 0)], this.data[this._idx(s, -1)] = this.data[this._idx(s - 1, 0)], this.data[this._idx(-1, s)] = this.data[this._idx(0, s - 1)], this.data[this._idx(s, s)] = this.data[this._idx(s - 1, s - 1)], this.min = Number.MAX_SAFE_INTEGER, this.max = Number.MIN_SAFE_INTEGER;
                                for(let t1 = 0; t1 < s; t1++)for(let e1 = 0; e1 < s; e1++){
                                    const r = this.get(t1, e1);
                                    r > this.max && (this.max = r), r < this.min && (this.min = r);
                                }
                            }
                            get(t1, e1) {
                                const r = new Uint8Array(this.data.buffer), n = 4 * this._idx(t1, e1);
                                return this.unpack(r[n], r[n + 1], r[n + 2]);
                            }
                            getUnpackVector() {
                                return [
                                    this.redFactor,
                                    this.greenFactor,
                                    this.blueFactor,
                                    this.baseShift
                                ];
                            }
                            _idx(t1, e1) {
                                if (t1 < -1 || t1 >= this.dim + 1 || e1 < -1 || e1 >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
                                return (e1 + 1) * this.stride + (t1 + 1);
                            }
                            unpack(t1, e1, r) {
                                return t1 * this.redFactor + e1 * this.greenFactor + r * this.blueFactor - this.baseShift;
                            }
                            getPixels() {
                                return new Ls({
                                    width: this.stride,
                                    height: this.stride
                                }, new Uint8Array(this.data.buffer));
                            }
                            backfillBorder(t1, e1, r) {
                                if (this.dim !== t1.dim) throw new Error("dem dimension mismatch");
                                let n = e1 * this.dim, i = e1 * this.dim + this.dim, a = r * this.dim, o = r * this.dim + this.dim;
                                switch(e1){
                                    case -1:
                                        n = i - 1;
                                        break;
                                    case 1:
                                        i = n + 1;
                                }
                                switch(r){
                                    case -1:
                                        a = o - 1;
                                        break;
                                    case 1:
                                        o = a + 1;
                                }
                                const s = -e1 * this.dim, l = -r * this.dim;
                                for(let e1 = a; e1 < o; e1++)for(let r = n; r < i; r++)this.data[this._idx(r, e1)] = t1.data[this._idx(r + s, e1 + l)];
                            }
                        }
                        Mi("DEMData", rh);
                        class nh {
                            constructor(t1){
                                this._stringToNumber = {}, this._numberToString = [];
                                for(let e1 = 0; e1 < t1.length; e1++){
                                    const r = t1[e1];
                                    this._stringToNumber[r] = e1, this._numberToString[e1] = r;
                                }
                            }
                            encode(t1) {
                                return this._stringToNumber[t1];
                            }
                            decode(t1) {
                                if (t1 >= this._numberToString.length) throw new Error(`Out of bounds. Index requested n=${t1} can't be >= this._numberToString.length ${this._numberToString.length}`);
                                return this._numberToString[t1];
                            }
                        }
                        class ih {
                            constructor(t1, e1, r, n, i){
                                this.type = "Feature", this._vectorTileFeature = t1, t1._z = e1, t1._x = r, t1._y = n, this.properties = t1.properties, this.id = i;
                            }
                            get geometry() {
                                return void 0 === this._geometry && (this._geometry = this._vectorTileFeature.toGeoJSON(this._vectorTileFeature._x, this._vectorTileFeature._y, this._vectorTileFeature._z).geometry), this._geometry;
                            }
                            set geometry(t1) {
                                this._geometry = t1;
                            }
                            toJSON() {
                                const t1 = {
                                    geometry: this.geometry
                                };
                                for(const e1 in this)"_geometry" !== e1 && "_vectorTileFeature" !== e1 && (t1[e1] = this[e1]);
                                return t1;
                            }
                        }
                        class ah {
                            constructor(t1, e1){
                                this.tileID = t1, this.x = t1.canonical.x, this.y = t1.canonical.y, this.z = t1.canonical.z, this.grid = new ki(Uo, 16, 0), this.grid3D = new ki(Uo, 16, 0), this.featureIndexArray = new Za, this.promoteId = e1;
                            }
                            insert(t1, e1, r, n, i, a) {
                                const o = this.featureIndexArray.length;
                                this.featureIndexArray.emplaceBack(r, n, i);
                                const s = a ? this.grid3D : this.grid;
                                for(let t1 = 0; t1 < e1.length; t1++){
                                    const r = e1[t1], n = [
                                        1 / 0,
                                        1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ];
                                    for(let t1 = 0; t1 < r.length; t1++){
                                        const e1 = r[t1];
                                        n[0] = Math.min(n[0], e1.x), n[1] = Math.min(n[1], e1.y), n[2] = Math.max(n[2], e1.x), n[3] = Math.max(n[3], e1.y);
                                    }
                                    n[0] < Uo && n[1] < Uo && n[2] >= 0 && n[3] >= 0 && s.insert(o, n[0], n[1], n[2], n[3]);
                                }
                            }
                            loadVTLayers() {
                                return this.vtLayers || (this.vtLayers = new Tl.VectorTile(new Uc(this.rawTileData)).layers, this.sourceLayerCoder = new nh(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                                    "_geojsonTileLayer"
                                ])), this.vtLayers;
                            }
                            query(t1, e1, r, n) {
                                this.loadVTLayers();
                                const i = t1.params || {}, o = Uo / t1.tileSize / t1.scale, s = zn(i.filter), l = t1.queryGeometry, c = t1.queryPadding * o, u = sh(l), h = this.grid.query(u.minX - c, u.minY - c, u.maxX + c, u.maxY + c), f = sh(t1.cameraQueryGeometry), p = this.grid3D.query(f.minX - c, f.minY - c, f.maxX + c, f.maxY + c, (e1, r, n, i)=>(function(t1, e1, r, n, i) {
                                        for (const a of t1)if (e1 <= a.x && r <= a.y && n >= a.x && i >= a.y) return !0;
                                        const o = [
                                            new a(e1, r),
                                            new a(e1, i),
                                            new a(n, i),
                                            new a(n, r)
                                        ];
                                        if (t1.length > 2) {
                                            for (const e1 of o)if (ns(t1, e1)) return !0;
                                        }
                                        for(let e1 = 0; e1 < t1.length - 1; e1++)if (is(t1[e1], t1[e1 + 1], o)) return !0;
                                        return !1;
                                    })(t1.cameraQueryGeometry, e1 - c, r - c, n + c, i + c));
                                for (const t1 of p)h.push(t1);
                                h.sort(lh);
                                const d = {};
                                let m;
                                for(let a = 0; a < h.length; a++){
                                    const c = h[a];
                                    if (c === m) continue;
                                    m = c;
                                    const u = this.featureIndexArray.get(c);
                                    let f = null;
                                    this.loadMatchingFeature(d, u.bucketIndex, u.sourceLayerIndex, u.featureIndex, s, i.layers, i.availableImages, e1, r, n, (e1, r, n)=>(f || (f = Ho(e1)), r.queryIntersectsFeature(l, e1, n, f, this.z, t1.transform, o, t1.pixelPosMatrix)));
                                }
                                return d;
                            }
                            loadMatchingFeature(t1, e1, r, n, i, a, o, s, l, c, u) {
                                const h = this.bucketLayerIDs[e1];
                                if (a && !function(t1, e1) {
                                    for(let r = 0; r < t1.length; r++)if (e1.indexOf(t1[r]) >= 0) return !0;
                                    return !1;
                                }(a, h)) return;
                                const f = this.sourceLayerCoder.decode(r), p = this.vtLayers[f].feature(n);
                                if (i.needGeometry) {
                                    const t1 = Go(p, !0);
                                    if (!i.filter(new Hi(this.tileID.overscaledZ), t1, this.tileID.canonical)) return;
                                } else if (!i.filter(new Hi(this.tileID.overscaledZ), p)) return;
                                const d = this.getId(p, f);
                                for(let e1 = 0; e1 < h.length; e1++){
                                    const r = h[e1];
                                    if (a && a.indexOf(r) < 0) continue;
                                    const i = s[r];
                                    if (!i) continue;
                                    let f = {};
                                    d && c && (f = c.getState(i.sourceLayer || "_geojsonTileLayer", d));
                                    const m = y({}, l[r]);
                                    m.paint = oh(m.paint, i.paint, p, f, o), m.layout = oh(m.layout, i.layout, p, f, o);
                                    const g = !u || u(p, i, f);
                                    if (!g) continue;
                                    const v = new ih(p, this.z, this.x, this.y, d);
                                    v.layer = m;
                                    let x = t1[r];
                                    void 0 === x && (x = t1[r] = []), x.push({
                                        featureIndex: n,
                                        feature: v,
                                        intersectionZ: g
                                    });
                                }
                            }
                            lookupSymbolFeatures(t1, e1, r, n, i, a, o, s) {
                                const l = {};
                                this.loadVTLayers();
                                const c = zn(i);
                                for (const i of t1)this.loadMatchingFeature(l, r, n, i, c, a, o, s, e1);
                                return l;
                            }
                            hasLayer(t1) {
                                for (const e1 of this.bucketLayerIDs)for (const r of e1)if (t1 === r) return !0;
                                return !1;
                            }
                            getId(t1, e1) {
                                let r = t1.id;
                                if (this.promoteId) {
                                    const n = "string" == typeof this.promoteId ? this.promoteId : this.promoteId[e1];
                                    r = t1.properties[n], "boolean" == typeof r && (r = Number(r));
                                }
                                return r;
                            }
                        }
                        function oh(t1, e1, r, n, i) {
                            return x(t1, (t1, a)=>{
                                const o = e1 instanceof Ki ? e1.get(a) : null;
                                return o && o.evaluate ? o.evaluate(r, n, i) : o;
                            });
                        }
                        function sh(t1) {
                            let e1 = 1 / 0, r = 1 / 0, n = -1 / 0, i = -1 / 0;
                            for (const a of t1)e1 = Math.min(e1, a.x), r = Math.min(r, a.y), n = Math.max(n, a.x), i = Math.max(i, a.y);
                            return {
                                minX: e1,
                                minY: r,
                                maxX: n,
                                maxY: i
                            };
                        }
                        function lh(t1, e1) {
                            return e1 - t1;
                        }
                        function ch(t1, e1, r, n, i) {
                            const o = [];
                            for(let s = 0; s < t1.length; s++){
                                const l = t1[s];
                                let c;
                                for(let t1 = 0; t1 < l.length - 1; t1++){
                                    let s = l[t1], u = l[t1 + 1];
                                    s.x < e1 && u.x < e1 || (s.x < e1 ? s = new a(e1, s.y + (u.y - s.y) * ((e1 - s.x) / (u.x - s.x)))._round() : u.x < e1 && (u = new a(e1, s.y + (u.y - s.y) * ((e1 - s.x) / (u.x - s.x)))._round()), s.y < r && u.y < r || (s.y < r ? s = new a(s.x + (u.x - s.x) * ((r - s.y) / (u.y - s.y)), r)._round() : u.y < r && (u = new a(s.x + (u.x - s.x) * ((r - s.y) / (u.y - s.y)), r)._round()), s.x >= n && u.x >= n || (s.x >= n ? s = new a(n, s.y + (u.y - s.y) * ((n - s.x) / (u.x - s.x)))._round() : u.x >= n && (u = new a(n, s.y + (u.y - s.y) * ((n - s.x) / (u.x - s.x)))._round()), s.y >= i && u.y >= i || (s.y >= i ? s = new a(s.x + (u.x - s.x) * ((i - s.y) / (u.y - s.y)), i)._round() : u.y >= i && (u = new a(s.x + (u.x - s.x) * ((i - s.y) / (u.y - s.y)), i)._round()), c && s.equals(c[c.length - 1]) || (c = [
                                        s
                                    ], o.push(c)), c.push(u)))));
                                }
                            }
                            return o;
                        }
                        Mi("FeatureIndex", ah, {
                            omit: [
                                "rawTileData",
                                "sourceLayerCoder"
                            ]
                        });
                        class uh extends a {
                            constructor(t1, e1, r, n){
                                super(t1, e1), this.angle = r, void 0 !== n && (this.segment = n);
                            }
                            clone() {
                                return new uh(this.x, this.y, this.angle, this.segment);
                            }
                        }
                        function hh(t1, e1, r, n, i) {
                            if (void 0 === e1.segment || 0 === r) return !0;
                            let a = e1, o = e1.segment + 1, s = 0;
                            for(; s > -r / 2;){
                                if (o--, o < 0) return !1;
                                s -= t1[o].dist(a), a = t1[o];
                            }
                            s += t1[o].dist(t1[o + 1]), o++;
                            const l = [];
                            let c = 0;
                            for(; s < r / 2;){
                                const e1 = t1[o - 1], r = t1[o], a = t1[o + 1];
                                if (!a) return !1;
                                let u = e1.angleTo(r) - r.angleTo(a);
                                for(u = Math.abs((u + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l.push({
                                    distance: s,
                                    angleDelta: u
                                }), c += u; s - l[0].distance > n;)c -= l.shift().angleDelta;
                                if (c > i) return !1;
                                o++, s += r.dist(a);
                            }
                            return !0;
                        }
                        function fh(t1) {
                            let e1 = 0;
                            for(let r = 0; r < t1.length - 1; r++)e1 += t1[r].dist(t1[r + 1]);
                            return e1;
                        }
                        function ph(t1, e1, r) {
                            return t1 ? .6 * e1 * r : 0;
                        }
                        function dh(t1, e1) {
                            return Math.max(t1 ? t1.right - t1.left : 0, e1 ? e1.right - e1.left : 0);
                        }
                        function mh(t1, e1, r, n, i, a) {
                            const o = ph(r, i, a), s = dh(r, n) * a;
                            let l = 0;
                            const c = fh(t1) / 2;
                            for(let r = 0; r < t1.length - 1; r++){
                                const n = t1[r], i = t1[r + 1], a = n.dist(i);
                                if (l + a > c) {
                                    const u = (c - l) / a, h = Pe.number(n.x, i.x, u), f = Pe.number(n.y, i.y, u), p = new uh(h, f, i.angleTo(n), r);
                                    return p._round(), !o || hh(t1, p, s, o, e1) ? p : void 0;
                                }
                                l += a;
                            }
                        }
                        function gh(t1, e1, r, n, i, a, o, s, l) {
                            const c = ph(n, a, o), u = dh(n, i), h = u * o, f = 0 === t1[0].x || t1[0].x === l || 0 === t1[0].y || t1[0].y === l;
                            return e1 - h < e1 / 4 && (e1 = h + e1 / 4), yh(t1, f ? e1 / 2 * s % e1 : (u / 2 + 2 * a) * o * s % e1, e1, c, r, h, f, !1, l);
                        }
                        function yh(t1, e1, r, n, i, a, o, s, l) {
                            const c = a / 2, u = fh(t1);
                            let h = 0, f = e1 - r, p = [];
                            for(let e1 = 0; e1 < t1.length - 1; e1++){
                                const o = t1[e1], s = t1[e1 + 1], d = o.dist(s), m = s.angleTo(o);
                                for(; f + r < h + d;){
                                    f += r;
                                    const g = (f - h) / d, y = Pe.number(o.x, s.x, g), v = Pe.number(o.y, s.y, g);
                                    if (y >= 0 && y < l && v >= 0 && v < l && f - c >= 0 && f + c <= u) {
                                        const r = new uh(y, v, m, e1);
                                        r._round(), n && !hh(t1, r, a, n, i) || p.push(r);
                                    }
                                }
                                h += d;
                            }
                            return s || p.length || o || (p = yh(t1, h / 2, r, n, i, a, o, !0, l)), p;
                        }
                        Mi("Anchor", uh);
                        const vh = Yc;
                        function xh(t1, e1, r, n) {
                            const i = [], o = t1.image, s = o.pixelRatio, l = o.paddedRect.w - 2 * vh, c = o.paddedRect.h - 2 * vh;
                            let u = {
                                x1: t1.left,
                                y1: t1.top,
                                x2: t1.right,
                                y2: t1.bottom
                            };
                            const h = o.stretchX || [
                                [
                                    0,
                                    l
                                ]
                            ], f = o.stretchY || [
                                [
                                    0,
                                    c
                                ]
                            ], p = (t1, e1)=>t1 + e1[1] - e1[0], d = h.reduce(p, 0), m = f.reduce(p, 0), g = l - d, y = c - m;
                            let v = 0, x = d, _ = 0, b = m, w = 0, T = g, k = 0, A = y;
                            if (o.content && n) {
                                const e1 = o.content, r = e1[2] - e1[0], n = e1[3] - e1[1];
                                (o.textFitWidth || o.textFitHeight) && (u = du(t1)), v = _h(h, 0, e1[0]), _ = _h(f, 0, e1[1]), x = _h(h, e1[0], e1[2]), b = _h(f, e1[1], e1[3]), w = e1[0] - v, k = e1[1] - _, T = r - x, A = n - b;
                            }
                            const M = u.x1, S = u.y1, E = u.x2 - M, C = u.y2 - S, L = (t1, n, i, l)=>{
                                const c = wh(t1.stretch - v, x, E, M), u = Th(t1.fixed - w, T, t1.stretch, d), h = wh(n.stretch - _, b, C, S), f = Th(n.fixed - k, A, n.stretch, m), p = wh(i.stretch - v, x, E, M), g = Th(i.fixed - w, T, i.stretch, d), y = wh(l.stretch - _, b, C, S), L = Th(l.fixed - k, A, l.stretch, m), I = new a(c, h), P = new a(p, h), z = new a(p, y), O = new a(c, y), D = new a(u / s, f / s), R = new a(g / s, L / s), F = e1 * Math.PI / 180;
                                if (F) {
                                    const t1 = Math.sin(F), e1 = Math.cos(F), r = [
                                        e1,
                                        -t1,
                                        t1,
                                        e1
                                    ];
                                    I._matMult(r), P._matMult(r), O._matMult(r), z._matMult(r);
                                }
                                const B = t1.stretch + t1.fixed, N = i.stretch + i.fixed, j = n.stretch + n.fixed, U = l.stretch + l.fixed;
                                return {
                                    tl: I,
                                    tr: P,
                                    bl: O,
                                    br: z,
                                    tex: {
                                        x: o.paddedRect.x + vh + B,
                                        y: o.paddedRect.y + vh + j,
                                        w: N - B,
                                        h: U - j
                                    },
                                    writingMode: void 0,
                                    glyphOffset: [
                                        0,
                                        0
                                    ],
                                    sectionIndex: 0,
                                    pixelOffsetTL: D,
                                    pixelOffsetBR: R,
                                    minFontScaleX: T / s / E,
                                    minFontScaleY: A / s / C,
                                    isSDF: r
                                };
                            };
                            if (n && (o.stretchX || o.stretchY)) {
                                const t1 = bh(h, g, d), e1 = bh(f, y, m);
                                for(let r = 0; r < t1.length - 1; r++){
                                    const n = t1[r], a = t1[r + 1];
                                    for(let t1 = 0; t1 < e1.length - 1; t1++){
                                        const r = e1[t1], o = e1[t1 + 1];
                                        i.push(L(n, r, a, o));
                                    }
                                }
                            } else i.push(L({
                                fixed: 0,
                                stretch: -1
                            }, {
                                fixed: 0,
                                stretch: -1
                            }, {
                                fixed: 0,
                                stretch: l + 1
                            }, {
                                fixed: 0,
                                stretch: c + 1
                            }));
                            return i;
                        }
                        function _h(t1, e1, r) {
                            let n = 0;
                            for (const i of t1)n += Math.max(e1, Math.min(r, i[1])) - Math.max(e1, Math.min(r, i[0]));
                            return n;
                        }
                        function bh(t1, e1, r) {
                            const n = [
                                {
                                    fixed: -vh,
                                    stretch: 0
                                }
                            ];
                            for (const [e1, r] of t1){
                                const t1 = n[n.length - 1];
                                n.push({
                                    fixed: e1 - t1.stretch,
                                    stretch: t1.stretch
                                }), n.push({
                                    fixed: e1 - t1.stretch,
                                    stretch: t1.stretch + (r - e1)
                                });
                            }
                            return n.push({
                                fixed: e1 + vh,
                                stretch: r
                            }), n;
                        }
                        function wh(t1, e1, r, n) {
                            return t1 / e1 * r + n;
                        }
                        function Th(t1, e1, r, n) {
                            return t1 - e1 * r / n;
                        }
                        class kh {
                            constructor(t1, e1, r, n, i, o, s, l, c, u){
                                var h;
                                if (this.boxStartIndex = t1.length, c) {
                                    let t1 = o.top, e1 = o.bottom;
                                    const r = o.collisionPadding;
                                    r && (t1 -= r[1], e1 += r[3]);
                                    let n = e1 - t1;
                                    n > 0 && (n = Math.max(10, n), this.circleDiameter = n);
                                } else {
                                    const c = (null === (h = o.image) || void 0 === h ? void 0 : h.content) && (o.image.textFitWidth || o.image.textFitHeight) ? du(o) : {
                                        x1: o.left,
                                        y1: o.top,
                                        x2: o.right,
                                        y2: o.bottom
                                    };
                                    c.y1 = c.y1 * s - l[0], c.y2 = c.y2 * s + l[2], c.x1 = c.x1 * s - l[3], c.x2 = c.x2 * s + l[1];
                                    const f = o.collisionPadding;
                                    if (f && (c.x1 -= f[0] * s, c.y1 -= f[1] * s, c.x2 += f[2] * s, c.y2 += f[3] * s), u) {
                                        const t1 = new a(c.x1, c.y1), e1 = new a(c.x2, c.y1), r = new a(c.x1, c.y2), n = new a(c.x2, c.y2), i = u * Math.PI / 180;
                                        t1._rotate(i), e1._rotate(i), r._rotate(i), n._rotate(i), c.x1 = Math.min(t1.x, e1.x, r.x, n.x), c.x2 = Math.max(t1.x, e1.x, r.x, n.x), c.y1 = Math.min(t1.y, e1.y, r.y, n.y), c.y2 = Math.max(t1.y, e1.y, r.y, n.y);
                                    }
                                    t1.emplaceBack(e1.x, e1.y, c.x1, c.y1, c.x2, c.y2, r, n, i);
                                }
                                this.boxEndIndex = t1.length;
                            }
                        }
                        class Ah {
                            constructor(t1 = [], e1 = (t1, e1)=>t1 < e1 ? -1 : t1 > e1 ? 1 : 0){
                                if (this.data = t1, this.length = this.data.length, this.compare = e1, this.length > 0) for(let t1 = (this.length >> 1) - 1; t1 >= 0; t1--)this._down(t1);
                            }
                            push(t1) {
                                this.data.push(t1), this._up(this.length++);
                            }
                            pop() {
                                if (0 === this.length) return;
                                const t1 = this.data[0], e1 = this.data.pop();
                                return --this.length > 0 && (this.data[0] = e1, this._down(0)), t1;
                            }
                            peek() {
                                return this.data[0];
                            }
                            _up(t1) {
                                const { data: e1, compare: r } = this, n = e1[t1];
                                for(; t1 > 0;){
                                    const i = t1 - 1 >> 1, a = e1[i];
                                    if (r(n, a) >= 0) break;
                                    e1[t1] = a, t1 = i;
                                }
                                e1[t1] = n;
                            }
                            _down(t1) {
                                const { data: e1, compare: r } = this, n = this.length >> 1, i = e1[t1];
                                for(; t1 < n;){
                                    let n = 1 + (t1 << 1);
                                    const a = n + 1;
                                    if (a < this.length && r(e1[a], e1[n]) < 0 && (n = a), r(e1[n], i) >= 0) break;
                                    e1[t1] = e1[n], t1 = n;
                                }
                                e1[t1] = i;
                            }
                        }
                        function Mh(t1, e1 = 1, r = !1) {
                            let n = 1 / 0, i = 1 / 0, o = -1 / 0, s = -1 / 0;
                            const l = t1[0];
                            for(let t1 = 0; t1 < l.length; t1++){
                                const e1 = l[t1];
                                (!t1 || e1.x < n) && (n = e1.x), (!t1 || e1.y < i) && (i = e1.y), (!t1 || e1.x > o) && (o = e1.x), (!t1 || e1.y > s) && (s = e1.y);
                            }
                            const c = o - n, u = s - i, h = Math.min(c, u);
                            let f = h / 2;
                            const p = new Ah([], Sh);
                            if (0 === h) return new a(n, i);
                            for(let e1 = n; e1 < o; e1 += h)for(let r = i; r < s; r += h)p.push(new Eh(e1 + f, r + f, f, t1));
                            let d = function(t1) {
                                let e1 = 0, r = 0, n = 0;
                                const i = t1[0];
                                for(let t1 = 0, a = i.length, o = a - 1; t1 < a; o = t1++){
                                    const a = i[t1], s = i[o], l = a.x * s.y - s.x * a.y;
                                    r += (a.x + s.x) * l, n += (a.y + s.y) * l, e1 += 3 * l;
                                }
                                return new Eh(r / e1, n / e1, 0, t1);
                            }(t1), m = p.length;
                            for(; p.length;){
                                const n = p.pop();
                                (n.d > d.d || !d.d) && (d = n, r && console.log("found best %d after %d probes", Math.round(1e4 * n.d) / 1e4, m)), n.max - d.d <= e1 || (f = n.h / 2, p.push(new Eh(n.p.x - f, n.p.y - f, f, t1)), p.push(new Eh(n.p.x + f, n.p.y - f, f, t1)), p.push(new Eh(n.p.x - f, n.p.y + f, f, t1)), p.push(new Eh(n.p.x + f, n.p.y + f, f, t1)), m += 4);
                            }
                            return r && (console.log(`num probes: ${m}`), console.log(`best distance: ${d.d}`)), d.p;
                        }
                        function Sh(t1, e1) {
                            return e1.max - t1.max;
                        }
                        function Eh(t1, e1, r, n) {
                            this.p = new a(t1, e1), this.h = r, this.d = function(t1, e1) {
                                let r = !1, n = 1 / 0;
                                for(let i = 0; i < e1.length; i++){
                                    const a = e1[i];
                                    for(let e1 = 0, i = a.length, o = i - 1; e1 < i; o = e1++){
                                        const i = a[e1], s = a[o];
                                        i.y > t1.y != s.y > t1.y && t1.x < (s.x - i.x) * (t1.y - i.y) / (s.y - i.y) + i.x && (r = !r), n = Math.min(n, es(t1, i, s));
                                    }
                                }
                                return (r ? 1 : -1) * Math.sqrt(n);
                            }(this.p, n), this.max = this.d + this.h * Math.SQRT2;
                        }
                        var Ch;
                        t1.ar = void 0, (Ch = t1.ar || (t1.ar = {}))[Ch.center = 1] = "center", Ch[Ch.left = 2] = "left", Ch[Ch.right = 3] = "right", Ch[Ch.top = 4] = "top", Ch[Ch.bottom = 5] = "bottom", Ch[Ch["top-left"] = 6] = "top-left", Ch[Ch["top-right"] = 7] = "top-right", Ch[Ch["bottom-left"] = 8] = "bottom-left", Ch[Ch["bottom-right"] = 9] = "bottom-right";
                        const Lh = 7, Ih = Number.POSITIVE_INFINITY;
                        function Ph(t1, e1) {
                            return e1[1] !== Ih ? function(t1, e1, r) {
                                let n = 0, i = 0;
                                switch(e1 = Math.abs(e1), r = Math.abs(r), t1){
                                    case "top-right":
                                    case "top-left":
                                    case "top":
                                        i = r - Lh;
                                        break;
                                    case "bottom-right":
                                    case "bottom-left":
                                    case "bottom":
                                        i = -r + Lh;
                                }
                                switch(t1){
                                    case "top-right":
                                    case "bottom-right":
                                    case "right":
                                        n = -e1;
                                        break;
                                    case "top-left":
                                    case "bottom-left":
                                    case "left":
                                        n = e1;
                                }
                                return [
                                    n,
                                    i
                                ];
                            }(t1, e1[0], e1[1]) : function(t1, e1) {
                                let r = 0, n = 0;
                                e1 < 0 && (e1 = 0);
                                const i = e1 / Math.SQRT2;
                                switch(t1){
                                    case "top-right":
                                    case "top-left":
                                        n = i - Lh;
                                        break;
                                    case "bottom-right":
                                    case "bottom-left":
                                        n = -i + Lh;
                                        break;
                                    case "bottom":
                                        n = -e1 + Lh;
                                        break;
                                    case "top":
                                        n = e1 - Lh;
                                }
                                switch(t1){
                                    case "top-right":
                                    case "bottom-right":
                                        r = -i;
                                        break;
                                    case "top-left":
                                    case "bottom-left":
                                        r = i;
                                        break;
                                    case "left":
                                        r = e1;
                                        break;
                                    case "right":
                                        r = -e1;
                                }
                                return [
                                    r,
                                    n
                                ];
                            }(t1, e1[0]);
                        }
                        function zh(t1, e1, r) {
                            var n;
                            const i = t1.layout, a = null === (n = i.get("text-variable-anchor-offset")) || void 0 === n ? void 0 : n.evaluate(e1, {}, r);
                            if (a) {
                                const t1 = a.values, e1 = [];
                                for(let r = 0; r < t1.length; r += 2){
                                    const n = e1[r] = t1[r], i = t1[r + 1].map((t1)=>t1 * xc);
                                    n.startsWith("top") ? i[1] -= Lh : n.startsWith("bottom") && (i[1] += Lh), e1[r + 1] = i;
                                }
                                return new ee(e1);
                            }
                            const o = i.get("text-variable-anchor");
                            if (o) {
                                let n;
                                n = void 0 !== t1._unevaluatedLayout.getValue("text-radial-offset") ? [
                                    i.get("text-radial-offset").evaluate(e1, {}, r) * xc,
                                    Ih
                                ] : i.get("text-offset").evaluate(e1, {}, r).map((t1)=>t1 * xc);
                                const a = [];
                                for (const t1 of o)a.push(t1, Ph(t1, n));
                                return new ee(a);
                            }
                            return null;
                        }
                        function Oh(t1) {
                            switch(t1){
                                case "right":
                                case "top-right":
                                case "bottom-right":
                                    return "right";
                                case "left":
                                case "top-left":
                                case "bottom-left":
                                    return "left";
                            }
                            return "center";
                        }
                        function Dh(e1, r, n, i, a, o, s, l, c, u, h) {
                            let f = o.textMaxSize.evaluate(r, {});
                            void 0 === f && (f = s);
                            const p = e1.layers[0].layout, d = p.get("icon-offset").evaluate(r, {}, h), m = Fh(n.horizontal), g = s / 24, y = e1.tilePixelRatio * g, v = e1.tilePixelRatio * f / 24, x = e1.tilePixelRatio * l, _ = e1.tilePixelRatio * p.get("symbol-spacing"), b = p.get("text-padding") * e1.tilePixelRatio, w = function(t1, e1, r, n = 1) {
                                const i = t1.get("icon-padding").evaluate(e1, {}, r), a = i && i.values;
                                return [
                                    a[0] * n,
                                    a[1] * n,
                                    a[2] * n,
                                    a[3] * n
                                ];
                            }(p, r, h, e1.tilePixelRatio), k = p.get("text-max-angle") / 180 * Math.PI, A = "viewport" !== p.get("text-rotation-alignment") && "point" !== p.get("symbol-placement"), M = "map" === p.get("icon-rotation-alignment") && "point" !== p.get("symbol-placement"), S = p.get("symbol-placement"), E = _ / 2, C = p.get("icon-text-fit");
                            let L;
                            i && "none" !== C && (e1.allowVerticalPlacement && n.vertical && (L = mu(i, n.vertical, C, p.get("icon-text-fit-padding"), d, g)), m && (i = mu(i, m, C, p.get("icon-text-fit-padding"), d, g)));
                            const I = (l, f)=>{
                                f.x < 0 || f.x >= Uo || f.y < 0 || f.y >= Uo || function(e1, r, n, i, a, o, s, l, c, u, h, f, p, d, m, g, y, v, x, _, b, w, k, A, M) {
                                    const S = e1.addToLineVertexArray(r, n);
                                    let E, C, L, I, P = 0, z = 0, O = 0, D = 0, R = -1, F = -1;
                                    const B = {};
                                    let N = bo("");
                                    if (e1.allowVerticalPlacement && i.vertical) {
                                        const t1 = l.layout.get("text-rotate").evaluate(b, {}, A) + 90, e1 = i.vertical;
                                        L = new kh(c, r, u, h, f, e1, p, d, m, t1), s && (I = new kh(c, r, u, h, f, s, y, v, m, t1));
                                    }
                                    if (a) {
                                        const n = l.layout.get("icon-rotate").evaluate(b, {}), i = "none" !== l.layout.get("icon-text-fit"), o = xh(a, n, k, i), p = s ? xh(s, n, k, i) : void 0;
                                        C = new kh(c, r, u, h, f, a, y, v, !1, n), P = 4 * o.length;
                                        const d = e1.iconSizeData;
                                        let m = null;
                                        "source" === d.kind ? (m = [
                                            yu * l.layout.get("icon-size").evaluate(b, {})
                                        ], m[0] > vu && T(`${e1.layerIds[0]}: Value for "icon-size" is >= ${gu}. Reduce your "icon-size".`)) : "composite" === d.kind && (m = [
                                            yu * w.compositeIconSizes[0].evaluate(b, {}, A),
                                            yu * w.compositeIconSizes[1].evaluate(b, {}, A)
                                        ], (m[0] > vu || m[1] > vu) && T(`${e1.layerIds[0]}: Value for "icon-size" is >= ${gu}. Reduce your "icon-size".`)), e1.addSymbols(e1.icon, o, m, _, x, b, t1.ai.none, r, S.lineStartIndex, S.lineLength, -1, A), R = e1.icon.placedSymbolArray.length - 1, p && (z = 4 * p.length, e1.addSymbols(e1.icon, p, m, _, x, b, t1.ai.vertical, r, S.lineStartIndex, S.lineLength, -1, A), F = e1.icon.placedSymbolArray.length - 1);
                                    }
                                    const j = Object.keys(i.horizontal);
                                    for (const n of j){
                                        const a = i.horizontal[n];
                                        if (!E) {
                                            N = bo(a.text);
                                            const t1 = l.layout.get("text-rotate").evaluate(b, {}, A);
                                            E = new kh(c, r, u, h, f, a, p, d, m, t1);
                                        }
                                        const s = 1 === a.positionedLines.length;
                                        if (O += Rh(e1, r, a, o, l, m, b, g, S, i.vertical ? t1.ai.horizontal : t1.ai.horizontalOnly, s ? j : [
                                            n
                                        ], B, R, w, A), s) break;
                                    }
                                    i.vertical && (D += Rh(e1, r, i.vertical, o, l, m, b, g, S, t1.ai.vertical, [
                                        "vertical"
                                    ], B, F, w, A));
                                    const U = E ? E.boxStartIndex : e1.collisionBoxArray.length, V = E ? E.boxEndIndex : e1.collisionBoxArray.length, q = L ? L.boxStartIndex : e1.collisionBoxArray.length, H = L ? L.boxEndIndex : e1.collisionBoxArray.length, G = C ? C.boxStartIndex : e1.collisionBoxArray.length, Z = C ? C.boxEndIndex : e1.collisionBoxArray.length, W = I ? I.boxStartIndex : e1.collisionBoxArray.length, Y = I ? I.boxEndIndex : e1.collisionBoxArray.length;
                                    let X = -1;
                                    const $ = (t1, e1)=>t1 && t1.circleDiameter ? Math.max(t1.circleDiameter, e1) : e1;
                                    X = $(E, X), X = $(L, X), X = $(C, X), X = $(I, X);
                                    const J = X > -1 ? 1 : 0;
                                    J && (X *= M / xc), e1.glyphOffsetArray.length >= Eu.MAX_GLYPHS && T("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== b.sortKey && e1.addToSortKeyRanges(e1.symbolInstances.length, b.sortKey);
                                    const K = zh(l, b, A), [Q, tt] = function(e1, r) {
                                        const n = e1.length, i = null == r ? void 0 : r.values;
                                        if ((null == i ? void 0 : i.length) > 0) for(let r = 0; r < i.length; r += 2){
                                            const n = t1.ar[i[r]], a = i[r + 1];
                                            e1.emplaceBack(n, a[0], a[1]);
                                        }
                                        return [
                                            n,
                                            e1.length
                                        ];
                                    }(e1.textAnchorOffsets, K);
                                    e1.symbolInstances.emplaceBack(r.x, r.y, B.right >= 0 ? B.right : -1, B.center >= 0 ? B.center : -1, B.left >= 0 ? B.left : -1, B.vertical || -1, R, F, N, U, V, q, H, G, Z, W, Y, u, O, D, P, z, J, 0, p, X, Q, tt);
                                }(e1, f, l, n, i, a, L, e1.layers[0], e1.collisionBoxArray, r.index, r.sourceLayerIndex, e1.index, y, [
                                    b,
                                    b,
                                    b,
                                    b
                                ], A, c, x, w, M, d, r, o, u, h, s);
                            };
                            if ("line" === S) for (const t1 of ch(r.geometry, 0, 0, Uo, Uo)){
                                const r = gh(t1, _, k, n.vertical || m, i, 24, v, e1.overscaling, Uo);
                                for (const n of r)m && Bh(e1, m.text, E, n) || I(t1, n);
                            }
                            else if ("line-center" === S) {
                                for (const t1 of r.geometry)if (t1.length > 1) {
                                    const e1 = mh(t1, k, n.vertical || m, i, 24, v);
                                    e1 && I(t1, e1);
                                }
                            } else if ("Polygon" === r.type) for (const t1 of br(r.geometry, 0)){
                                const e1 = Mh(t1, 16);
                                I(t1[0], new uh(e1.x, e1.y, 0));
                            }
                            else if ("LineString" === r.type) for (const t1 of r.geometry)I(t1, new uh(t1[0].x, t1[0].y, 0));
                            else if ("Point" === r.type) for (const t1 of r.geometry)for (const e1 of t1)I([
                                e1
                            ], new uh(e1.x, e1.y, 0));
                        }
                        function Rh(t1, e1, r, n, i, o, s, l, c, u, h, f, p, d, m) {
                            const g = function(t1, e1, r, n, i, o, s, l) {
                                const c = n.layout.get("text-rotate").evaluate(o, {}) * Math.PI / 180, u = [];
                                for (const t1 of e1.positionedLines)for (const n of t1.positionedGlyphs){
                                    if (!n.rect) continue;
                                    const o = n.rect || {};
                                    let h = Zc + 1, f = !0, p = 1, d = 0;
                                    const m = (i || l) && n.vertical, g = n.metrics.advance * n.scale / 2;
                                    if (l && e1.verticalizable) {
                                        const e1 = (n.scale - 1) * xc, r = (xc - n.metrics.width * n.scale) / 2;
                                        d = t1.lineOffset / 2 - (n.imageName ? -r : e1);
                                    }
                                    if (n.imageName) {
                                        const t1 = s[n.imageName];
                                        f = t1.sdf, p = t1.pixelRatio, h = Yc / p;
                                    }
                                    const y = i ? [
                                        n.x + g,
                                        n.y
                                    ] : [
                                        0,
                                        0
                                    ];
                                    let v = i ? [
                                        0,
                                        0
                                    ] : [
                                        n.x + g + r[0],
                                        n.y + r[1] - d
                                    ], x = [
                                        0,
                                        0
                                    ];
                                    m && (x = v, v = [
                                        0,
                                        0
                                    ]);
                                    const _ = n.metrics.isDoubleResolution ? 2 : 1, b = (n.metrics.left - h) * n.scale - g + v[0], w = (-n.metrics.top - h) * n.scale + v[1], T = b + o.w / _ * n.scale / p, k = w + o.h / _ * n.scale / p, A = new a(b, w), M = new a(T, w), S = new a(b, k), E = new a(T, k);
                                    if (m) {
                                        const t1 = new a(-g, g - Kc), e1 = -Math.PI / 2, r = xc / 2 - g, i = n.imageName ? r : 0, o = new a(5 - Kc - r, -i), s = new a(...x);
                                        A._rotateAround(e1, t1)._add(o)._add(s), M._rotateAround(e1, t1)._add(o)._add(s), S._rotateAround(e1, t1)._add(o)._add(s), E._rotateAround(e1, t1)._add(o)._add(s);
                                    }
                                    if (c) {
                                        const t1 = Math.sin(c), e1 = Math.cos(c), r = [
                                            e1,
                                            -t1,
                                            t1,
                                            e1
                                        ];
                                        A._matMult(r), M._matMult(r), S._matMult(r), E._matMult(r);
                                    }
                                    const C = new a(0, 0), L = new a(0, 0), I = 0, P = 0;
                                    u.push({
                                        tl: A,
                                        tr: M,
                                        bl: S,
                                        br: E,
                                        tex: o,
                                        writingMode: e1.writingMode,
                                        glyphOffset: y,
                                        sectionIndex: n.sectionIndex,
                                        isSDF: f,
                                        pixelOffsetTL: C,
                                        pixelOffsetBR: L,
                                        minFontScaleX: I,
                                        minFontScaleY: P
                                    });
                                }
                                return u;
                            }(0, r, l, i, o, s, n, t1.allowVerticalPlacement), y = t1.textSizeData;
                            let v = null;
                            "source" === y.kind ? (v = [
                                yu * i.layout.get("text-size").evaluate(s, {})
                            ], v[0] > vu && T(`${t1.layerIds[0]}: Value for "text-size" is >= ${gu}. Reduce your "text-size".`)) : "composite" === y.kind && (v = [
                                yu * d.compositeTextSizes[0].evaluate(s, {}, m),
                                yu * d.compositeTextSizes[1].evaluate(s, {}, m)
                            ], (v[0] > vu || v[1] > vu) && T(`${t1.layerIds[0]}: Value for "text-size" is >= ${gu}. Reduce your "text-size".`)), t1.addSymbols(t1.text, g, v, l, o, s, u, e1, c.lineStartIndex, c.lineLength, p, m);
                            for (const e1 of h)f[e1] = t1.text.placedSymbolArray.length - 1;
                            return 4 * g.length;
                        }
                        function Fh(t1) {
                            for(const e1 in t1)return t1[e1];
                            return null;
                        }
                        function Bh(t1, e1, r, n) {
                            const i = t1.compareText;
                            if (e1 in i) {
                                const t1 = i[e1];
                                for(let e1 = t1.length - 1; e1 >= 0; e1--)if (n.dist(t1[e1]) < r) return !0;
                            } else i[e1] = [];
                            return i[e1].push(n), !1;
                        }
                        const Nh = [
                            Int8Array,
                            Uint8Array,
                            Uint8ClampedArray,
                            Int16Array,
                            Uint16Array,
                            Int32Array,
                            Uint32Array,
                            Float32Array,
                            Float64Array
                        ];
                        class jh {
                            static from(t1) {
                                if (!(t1 instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
                                const [e1, r] = new Uint8Array(t1, 0, 2);
                                if (219 !== e1) throw new Error("Data does not appear to be in a KDBush format.");
                                const n = r >> 4;
                                if (1 !== n) throw new Error(`Got v${n} data when expected v1.`);
                                const i = Nh[15 & r];
                                if (!i) throw new Error("Unrecognized array type.");
                                const [a] = new Uint16Array(t1, 2, 1), [o] = new Uint32Array(t1, 4, 1);
                                return new jh(o, a, i, t1);
                            }
                            constructor(t1, e1 = 64, r = Float64Array, n){
                                if (isNaN(t1) || t1 < 0) throw new Error(`Unpexpected numItems value: ${t1}.`);
                                this.numItems = +t1, this.nodeSize = Math.min(Math.max(+e1, 2), 65535), this.ArrayType = r, this.IndexArrayType = t1 < 65536 ? Uint16Array : Uint32Array;
                                const i = Nh.indexOf(this.ArrayType), a = 2 * t1 * this.ArrayType.BYTES_PER_ELEMENT, o = t1 * this.IndexArrayType.BYTES_PER_ELEMENT, s = (8 - o % 8) % 8;
                                if (i < 0) throw new Error(`Unexpected typed array class: ${r}.`);
                                n && n instanceof ArrayBuffer ? (this.data = n, this.ids = new this.IndexArrayType(this.data, 8, t1), this.coords = new this.ArrayType(this.data, 8 + o + s, 2 * t1), this._pos = 2 * t1, this._finished = !0) : (this.data = new ArrayBuffer(8 + a + o + s), this.ids = new this.IndexArrayType(this.data, 8, t1), this.coords = new this.ArrayType(this.data, 8 + o + s, 2 * t1), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([
                                    219,
                                    16 + i
                                ]), new Uint16Array(this.data, 2, 1)[0] = e1, new Uint32Array(this.data, 4, 1)[0] = t1);
                            }
                            add(t1, e1) {
                                const r = this._pos >> 1;
                                return this.ids[r] = r, this.coords[this._pos++] = t1, this.coords[this._pos++] = e1, r;
                            }
                            finish() {
                                const t1 = this._pos >> 1;
                                if (t1 !== this.numItems) throw new Error(`Added ${t1} items when expected ${this.numItems}.`);
                                return Uh(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
                            }
                            range(t1, e1, r, n) {
                                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                                const { ids: i, coords: a, nodeSize: o } = this, s = [
                                    0,
                                    i.length - 1,
                                    0
                                ], l = [];
                                for(; s.length;){
                                    const c = s.pop() || 0, u = s.pop() || 0, h = s.pop() || 0;
                                    if (u - h <= o) {
                                        for(let o = h; o <= u; o++){
                                            const s = a[2 * o], c = a[2 * o + 1];
                                            s >= t1 && s <= r && c >= e1 && c <= n && l.push(i[o]);
                                        }
                                        continue;
                                    }
                                    const f = h + u >> 1, p = a[2 * f], d = a[2 * f + 1];
                                    p >= t1 && p <= r && d >= e1 && d <= n && l.push(i[f]), (0 === c ? t1 <= p : e1 <= d) && (s.push(h), s.push(f - 1), s.push(1 - c)), (0 === c ? r >= p : n >= d) && (s.push(f + 1), s.push(u), s.push(1 - c));
                                }
                                return l;
                            }
                            within(t1, e1, r) {
                                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                                const { ids: n, coords: i, nodeSize: a } = this, o = [
                                    0,
                                    n.length - 1,
                                    0
                                ], s = [], l = r * r;
                                for(; o.length;){
                                    const c = o.pop() || 0, u = o.pop() || 0, h = o.pop() || 0;
                                    if (u - h <= a) {
                                        for(let r = h; r <= u; r++)Gh(i[2 * r], i[2 * r + 1], t1, e1) <= l && s.push(n[r]);
                                        continue;
                                    }
                                    const f = h + u >> 1, p = i[2 * f], d = i[2 * f + 1];
                                    Gh(p, d, t1, e1) <= l && s.push(n[f]), (0 === c ? t1 - r <= p : e1 - r <= d) && (o.push(h), o.push(f - 1), o.push(1 - c)), (0 === c ? t1 + r >= p : e1 + r >= d) && (o.push(f + 1), o.push(u), o.push(1 - c));
                                }
                                return s;
                            }
                        }
                        function Uh(t1, e1, r, n, i, a) {
                            if (i - n <= r) return;
                            const o = n + i >> 1;
                            Vh(t1, e1, o, n, i, a), Uh(t1, e1, r, n, o - 1, 1 - a), Uh(t1, e1, r, o + 1, i, 1 - a);
                        }
                        function Vh(t1, e1, r, n, i, a) {
                            for(; i > n;){
                                if (i - n > 600) {
                                    const o = i - n + 1, s = r - n + 1, l = Math.log(o), c = .5 * Math.exp(2 * l / 3), u = .5 * Math.sqrt(l * c * (o - c) / o) * (s - o / 2 < 0 ? -1 : 1);
                                    Vh(t1, e1, r, Math.max(n, Math.floor(r - s * c / o + u)), Math.min(i, Math.floor(r + (o - s) * c / o + u)), a);
                                }
                                const o = e1[2 * r + a];
                                let s = n, l = i;
                                for(qh(t1, e1, n, r), e1[2 * i + a] > o && qh(t1, e1, n, i); s < l;){
                                    for(qh(t1, e1, s, l), s++, l--; e1[2 * s + a] < o;)s++;
                                    for(; e1[2 * l + a] > o;)l--;
                                }
                                e1[2 * n + a] === o ? qh(t1, e1, n, l) : (l++, qh(t1, e1, l, i)), l <= r && (n = l + 1), r <= l && (i = l - 1);
                            }
                        }
                        function qh(t1, e1, r, n) {
                            Hh(t1, r, n), Hh(e1, 2 * r, 2 * n), Hh(e1, 2 * r + 1, 2 * n + 1);
                        }
                        function Hh(t1, e1, r) {
                            const n = t1[e1];
                            t1[e1] = t1[r], t1[r] = n;
                        }
                        function Gh(t1, e1, r, n) {
                            const i = t1 - r, a = e1 - n;
                            return i * i + a * a;
                        }
                        var Zh;
                        t1.bf = void 0, (Zh = t1.bf || (t1.bf = {})).create = "create", Zh.load = "load", Zh.fullLoad = "fullLoad";
                        let Wh = null, Yh = [];
                        const Xh = 1e3 / 60, $h = "loadTime", Jh = "fullLoadTime", Kh = {
                            mark (t1) {
                                performance.mark(t1);
                            },
                            frame (t1) {
                                const e1 = t1;
                                if (null != Wh) {
                                    const t1 = e1 - Wh;
                                    Yh.push(t1);
                                }
                                Wh = e1;
                            },
                            clearMetrics () {
                                Wh = null, Yh = [], performance.clearMeasures($h), performance.clearMeasures(Jh);
                                for(const e1 in t1.bf)performance.clearMarks(t1.bf[e1]);
                            },
                            getPerformanceMetrics () {
                                performance.measure($h, t1.bf.create, t1.bf.load), performance.measure(Jh, t1.bf.create, t1.bf.fullLoad);
                                const e1 = performance.getEntriesByName($h)[0].duration, r = performance.getEntriesByName(Jh)[0].duration, n = Yh.length, i = 1 / (Yh.reduce((t1, e1)=>t1 + e1, 0) / n / 1e3), a = Yh.filter((t1)=>t1 > Xh).reduce((t1, e1)=>t1 + (e1 - Xh) / Xh, 0);
                                return {
                                    loadTime: e1,
                                    fullLoadTime: r,
                                    fps: i,
                                    percentDroppedFrames: a / (n + a) * 100,
                                    totalFrames: n
                                };
                            }
                        };
                        t1.$ = class extends da {
                        }, t1.A = fs, t1.B = _i, t1.C = function(t1) {
                            if (null == M) {
                                const e1 = t1.navigator ? t1.navigator.userAgent : null;
                                M = !!t1.safari || !(!e1 || !(/\b(iPad|iPhone|iPod)\b/.test(e1) || e1.match("Safari") && !e1.match("Chrome")));
                            }
                            return M;
                        }, t1.D = Qi, t1.E = G, t1.F = class {
                            constructor(t1, e1){
                                this.target = t1, this.mapId = e1, this.resolveRejects = {}, this.tasks = {}, this.taskQueue = [], this.abortControllers = {}, this.messageHandlers = {}, this.invoker = new Uu(()=>this.process()), this.subscription = function(t1, e1, r, n) {
                                    return t1.addEventListener(e1, r, n), {
                                        unsubscribe: ()=>{
                                            t1.removeEventListener(e1, r, n);
                                        }
                                    };
                                }(this.target, "message", (t1)=>this.receive(t1), !1), this.globalScope = A(self) ? t1 : window;
                            }
                            registerMessageHandler(t1, e1) {
                                this.messageHandlers[t1] = e1;
                            }
                            sendAsync(t1, e1) {
                                return new Promise((r, n)=>{
                                    const i = Math.round(1e18 * Math.random()).toString(36).substring(0, 10);
                                    this.resolveRejects[i] = {
                                        resolve: r,
                                        reject: n
                                    }, e1 && e1.signal.addEventListener("abort", ()=>{
                                        delete this.resolveRejects[i];
                                        const e1 = {
                                            id: i,
                                            type: "<cancel>",
                                            origin: location.origin,
                                            targetMapId: t1.targetMapId,
                                            sourceMapId: this.mapId
                                        };
                                        this.target.postMessage(e1);
                                    }, {
                                        once: !0
                                    });
                                    const a = [], o = Object.assign(Object.assign({}, t1), {
                                        id: i,
                                        sourceMapId: this.mapId,
                                        origin: location.origin,
                                        data: Li(t1.data, a)
                                    });
                                    this.target.postMessage(o, {
                                        transfer: a
                                    });
                                });
                            }
                            receive(t1) {
                                const e1 = t1.data, r = e1.id;
                                if (!("file://" !== e1.origin && "file://" !== location.origin && "resource://android" !== e1.origin && "resource://android" !== location.origin && e1.origin !== location.origin || e1.targetMapId && this.mapId !== e1.targetMapId)) {
                                    if ("<cancel>" === e1.type) {
                                        delete this.tasks[r];
                                        const t1 = this.abortControllers[r];
                                        return delete this.abortControllers[r], void (t1 && t1.abort());
                                    }
                                    if (A(self) || e1.mustQueue) return this.tasks[r] = e1, this.taskQueue.push(r), void this.invoker.trigger();
                                    this.processTask(r, e1);
                                }
                            }
                            process() {
                                if (0 === this.taskQueue.length) return;
                                const t1 = this.taskQueue.shift(), e1 = this.tasks[t1];
                                delete this.tasks[t1], this.taskQueue.length > 0 && this.invoker.trigger(), e1 && this.processTask(t1, e1);
                            }
                            processTask(t1, r) {
                                return e1(this, void 0, void 0, function*() {
                                    if ("<response>" === r.type) {
                                        const e1 = this.resolveRejects[t1];
                                        if (delete this.resolveRejects[t1], !e1) return;
                                        return void (r.error ? e1.reject(Ii(r.error)) : e1.resolve(Ii(r.data)));
                                    }
                                    if (!this.messageHandlers[r.type]) return void this.completeTask(t1, new Error(`Could not find a registered handler for ${r.type}, map ID: ${this.mapId}, available handlers: ${Object.keys(this.messageHandlers).join(", ")}`));
                                    const e1 = Ii(r.data), n = new AbortController;
                                    this.abortControllers[t1] = n;
                                    try {
                                        const i = yield this.messageHandlers[r.type](r.sourceMapId, e1, n);
                                        this.completeTask(t1, null, i);
                                    } catch (e1) {
                                        this.completeTask(t1, e1);
                                    }
                                });
                            }
                            completeTask(t1, e1, r) {
                                const n = [];
                                delete this.abortControllers[t1];
                                const i = {
                                    id: t1,
                                    type: "<response>",
                                    sourceMapId: this.mapId,
                                    origin: location.origin,
                                    error: e1 ? Li(e1) : null,
                                    data: Li(r, n)
                                };
                                this.target.postMessage(i, {
                                    transfer: n
                                });
                            }
                            remove() {
                                this.invoker.remove(), this.subscription.unsubscribe();
                            }
                        }, t1.G = R, t1.H = function() {
                            var t1 = new fs(16);
                            return fs != Float32Array && (t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0), t1[0] = 1, t1[5] = 1, t1[10] = 1, t1[15] = 1, t1;
                        }, t1.I = Xc, t1.J = function(t1, e1, r) {
                            var n, i, a, o, s, l, c, u, h, f, p, d, m = r[0], g = r[1], y = r[2];
                            return e1 === t1 ? (t1[12] = e1[0] * m + e1[4] * g + e1[8] * y + e1[12], t1[13] = e1[1] * m + e1[5] * g + e1[9] * y + e1[13], t1[14] = e1[2] * m + e1[6] * g + e1[10] * y + e1[14], t1[15] = e1[3] * m + e1[7] * g + e1[11] * y + e1[15]) : (n = e1[0], i = e1[1], a = e1[2], o = e1[3], s = e1[4], l = e1[5], c = e1[6], u = e1[7], h = e1[8], f = e1[9], p = e1[10], d = e1[11], t1[0] = n, t1[1] = i, t1[2] = a, t1[3] = o, t1[4] = s, t1[5] = l, t1[6] = c, t1[7] = u, t1[8] = h, t1[9] = f, t1[10] = p, t1[11] = d, t1[12] = n * m + s * g + h * y + e1[12], t1[13] = i * m + l * g + f * y + e1[13], t1[14] = a * m + c * g + p * y + e1[14], t1[15] = o * m + u * g + d * y + e1[15]), t1;
                        }, t1.K = function(t1, e1, r) {
                            var n = r[0], i = r[1], a = r[2];
                            return t1[0] = e1[0] * n, t1[1] = e1[1] * n, t1[2] = e1[2] * n, t1[3] = e1[3] * n, t1[4] = e1[4] * i, t1[5] = e1[5] * i, t1[6] = e1[6] * i, t1[7] = e1[7] * i, t1[8] = e1[8] * a, t1[9] = e1[9] * a, t1[10] = e1[10] * a, t1[11] = e1[11] * a, t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15], t1;
                        }, t1.L = ds, t1.M = function(t1, e1) {
                            const r = {};
                            for(let n = 0; n < e1.length; n++){
                                const i = e1[n];
                                i in t1 && (r[i] = t1[i]);
                            }
                            return r;
                        }, t1.N = qu, t1.O = Zu, t1.P = a, t1.Q = Wu, t1.R = Ls, t1.S = th, t1.T = Wi, t1.U = h, t1.V = f, t1.W = C, t1.X = Uo, t1.Y = ua, t1.Z = $u, t1._ = e1, t1.a = O, t1.a$ = function(t1, e1) {
                            var r = t1[0], n = t1[1], i = t1[2], a = t1[3], o = t1[4], s = t1[5], l = t1[6], c = t1[7], u = t1[8], h = t1[9], f = t1[10], p = t1[11], d = t1[12], m = t1[13], g = t1[14], y = t1[15], v = e1[0], x = e1[1], _ = e1[2], b = e1[3], w = e1[4], T = e1[5], k = e1[6], A = e1[7], M = e1[8], S = e1[9], E = e1[10], C = e1[11], L = e1[12], I = e1[13], P = e1[14], z = e1[15];
                            return Math.abs(r - v) <= hs * Math.max(1, Math.abs(r), Math.abs(v)) && Math.abs(n - x) <= hs * Math.max(1, Math.abs(n), Math.abs(x)) && Math.abs(i - _) <= hs * Math.max(1, Math.abs(i), Math.abs(_)) && Math.abs(a - b) <= hs * Math.max(1, Math.abs(a), Math.abs(b)) && Math.abs(o - w) <= hs * Math.max(1, Math.abs(o), Math.abs(w)) && Math.abs(s - T) <= hs * Math.max(1, Math.abs(s), Math.abs(T)) && Math.abs(l - k) <= hs * Math.max(1, Math.abs(l), Math.abs(k)) && Math.abs(c - A) <= hs * Math.max(1, Math.abs(c), Math.abs(A)) && Math.abs(u - M) <= hs * Math.max(1, Math.abs(u), Math.abs(M)) && Math.abs(h - S) <= hs * Math.max(1, Math.abs(h), Math.abs(S)) && Math.abs(f - E) <= hs * Math.max(1, Math.abs(f), Math.abs(E)) && Math.abs(p - C) <= hs * Math.max(1, Math.abs(p), Math.abs(C)) && Math.abs(d - L) <= hs * Math.max(1, Math.abs(d), Math.abs(L)) && Math.abs(m - I) <= hs * Math.max(1, Math.abs(m), Math.abs(I)) && Math.abs(g - P) <= hs * Math.max(1, Math.abs(g), Math.abs(P)) && Math.abs(y - z) <= hs * Math.max(1, Math.abs(y), Math.abs(z));
                        }, t1.a0 = ho, t1.a1 = Ku, t1.a2 = it, t1.a3 = (t1)=>{
                            const e1 = window.document.createElement("video");
                            return e1.muted = !0, new Promise((r)=>{
                                e1.onloadstart = ()=>{
                                    r(e1);
                                };
                                for (const r of t1){
                                    const t1 = window.document.createElement("source");
                                    j(r) || (e1.crossOrigin = "Anonymous"), t1.src = r, e1.appendChild(t1);
                                }
                            });
                        }, t1.a4 = function() {
                            return v++;
                        }, t1.a5 = Ra, t1.a6 = Eu, t1.a7 = zn, t1.a8 = Go, t1.a9 = Hi, t1.aA = function(t1) {
                            t1 = t1.slice();
                            const e1 = Object.create(null);
                            for(let r = 0; r < t1.length; r++)e1[t1[r].id] = t1[r];
                            for(let r = 0; r < t1.length; r++)"ref" in t1[r] && (t1[r] = Y(t1[r], e1[t1[r].ref]));
                            return t1;
                        }, t1.aB = function(t1) {
                            if ("custom" === t1.type) return new ju(t1);
                            switch(t1.type){
                                case "background":
                                    return new Ru(t1);
                                case "circle":
                                    return new bs(t1);
                                case "fill":
                                    return new yl(t1);
                                case "fill-extrusion":
                                    return new Hl(t1);
                                case "heatmap":
                                    return new Ps(t1);
                                case "hillshade":
                                    return new Ds(t1);
                                case "line":
                                    return new uc(t1);
                                case "raster":
                                    return new Nu(t1);
                                case "symbol":
                                    return new zu(t1);
                            }
                        }, t1.aC = b, t1.aD = function(t1, e1) {
                            if (!t1) return [
                                {
                                    command: "setStyle",
                                    args: [
                                        e1
                                    ]
                                }
                            ];
                            let r = [];
                            try {
                                if (!X(t1.version, e1.version)) return [
                                    {
                                        command: "setStyle",
                                        args: [
                                            e1
                                        ]
                                    }
                                ];
                                X(t1.center, e1.center) || r.push({
                                    command: "setCenter",
                                    args: [
                                        e1.center
                                    ]
                                }), X(t1.zoom, e1.zoom) || r.push({
                                    command: "setZoom",
                                    args: [
                                        e1.zoom
                                    ]
                                }), X(t1.bearing, e1.bearing) || r.push({
                                    command: "setBearing",
                                    args: [
                                        e1.bearing
                                    ]
                                }), X(t1.pitch, e1.pitch) || r.push({
                                    command: "setPitch",
                                    args: [
                                        e1.pitch
                                    ]
                                }), X(t1.sprite, e1.sprite) || r.push({
                                    command: "setSprite",
                                    args: [
                                        e1.sprite
                                    ]
                                }), X(t1.glyphs, e1.glyphs) || r.push({
                                    command: "setGlyphs",
                                    args: [
                                        e1.glyphs
                                    ]
                                }), X(t1.transition, e1.transition) || r.push({
                                    command: "setTransition",
                                    args: [
                                        e1.transition
                                    ]
                                }), X(t1.light, e1.light) || r.push({
                                    command: "setLight",
                                    args: [
                                        e1.light
                                    ]
                                }), X(t1.terrain, e1.terrain) || r.push({
                                    command: "setTerrain",
                                    args: [
                                        e1.terrain
                                    ]
                                }), X(t1.sky, e1.sky) || r.push({
                                    command: "setSky",
                                    args: [
                                        e1.sky
                                    ]
                                }), X(t1.projection, e1.projection) || r.push({
                                    command: "setProjection",
                                    args: [
                                        e1.projection
                                    ]
                                });
                                const n = {}, i = [];
                                !function(t1, e1, r, n) {
                                    let i;
                                    for(i in e1 = e1 || {}, t1 = t1 || {})Object.prototype.hasOwnProperty.call(t1, i) && (Object.prototype.hasOwnProperty.call(e1, i) || K(i, r, n));
                                    for(i in e1)Object.prototype.hasOwnProperty.call(e1, i) && (Object.prototype.hasOwnProperty.call(t1, i) ? X(t1[i], e1[i]) || ("geojson" === t1[i].type && "geojson" === e1[i].type && tt(t1, e1, i) ? $(r, {
                                        command: "setGeoJSONSourceData",
                                        args: [
                                            i,
                                            e1[i].data
                                        ]
                                    }) : Q(i, e1, r, n)) : J(i, e1, r));
                                }(t1.sources, e1.sources, i, n);
                                const a = [];
                                t1.layers && t1.layers.forEach((t1)=>{
                                    "source" in t1 && n[t1.source] ? r.push({
                                        command: "removeLayer",
                                        args: [
                                            t1.id
                                        ]
                                    }) : a.push(t1);
                                }), r = r.concat(i), function(t1, e1, r) {
                                    e1 = e1 || [];
                                    const n = (t1 = t1 || []).map(rt), i = e1.map(rt), a = t1.reduce(nt, {}), o = e1.reduce(nt, {}), s = n.slice(), l = Object.create(null);
                                    let c, u, h, f, p;
                                    for(let t1 = 0, e1 = 0; t1 < n.length; t1++)c = n[t1], Object.prototype.hasOwnProperty.call(o, c) ? e1++ : ($(r, {
                                        command: "removeLayer",
                                        args: [
                                            c
                                        ]
                                    }), s.splice(s.indexOf(c, e1), 1));
                                    for(let t1 = 0, e1 = 0; t1 < i.length; t1++)c = i[i.length - 1 - t1], s[s.length - 1 - t1] !== c && (Object.prototype.hasOwnProperty.call(a, c) ? ($(r, {
                                        command: "removeLayer",
                                        args: [
                                            c
                                        ]
                                    }), s.splice(s.lastIndexOf(c, s.length - e1), 1)) : e1++, f = s[s.length - t1], $(r, {
                                        command: "addLayer",
                                        args: [
                                            o[c],
                                            f
                                        ]
                                    }), s.splice(s.length - t1, 0, c), l[c] = !0);
                                    for(let t1 = 0; t1 < i.length; t1++)if (c = i[t1], u = a[c], h = o[c], !l[c] && !X(u, h)) {
                                        if (X(u.source, h.source) && X(u["source-layer"], h["source-layer"]) && X(u.type, h.type)) {
                                            for(p in et(u.layout, h.layout, r, c, null, "setLayoutProperty"), et(u.paint, h.paint, r, c, null, "setPaintProperty"), X(u.filter, h.filter) || $(r, {
                                                command: "setFilter",
                                                args: [
                                                    c,
                                                    h.filter
                                                ]
                                            }), X(u.minzoom, h.minzoom) && X(u.maxzoom, h.maxzoom) || $(r, {
                                                command: "setLayerZoomRange",
                                                args: [
                                                    c,
                                                    h.minzoom,
                                                    h.maxzoom
                                                ]
                                            }), u)Object.prototype.hasOwnProperty.call(u, p) && "layout" !== p && "paint" !== p && "filter" !== p && "metadata" !== p && "minzoom" !== p && "maxzoom" !== p && (0 === p.indexOf("paint.") ? et(u[p], h[p], r, c, p.slice(6), "setPaintProperty") : X(u[p], h[p]) || $(r, {
                                                command: "setLayerProperty",
                                                args: [
                                                    c,
                                                    p,
                                                    h[p]
                                                ]
                                            }));
                                            for(p in h)Object.prototype.hasOwnProperty.call(h, p) && !Object.prototype.hasOwnProperty.call(u, p) && "layout" !== p && "paint" !== p && "filter" !== p && "metadata" !== p && "minzoom" !== p && "maxzoom" !== p && (0 === p.indexOf("paint.") ? et(u[p], h[p], r, c, p.slice(6), "setPaintProperty") : X(u[p], h[p]) || $(r, {
                                                command: "setLayerProperty",
                                                args: [
                                                    c,
                                                    p,
                                                    h[p]
                                                ]
                                            }));
                                        } else $(r, {
                                            command: "removeLayer",
                                            args: [
                                                c
                                            ]
                                        }), f = s[s.lastIndexOf(c) + 1], $(r, {
                                            command: "addLayer",
                                            args: [
                                                h,
                                                f
                                            ]
                                        });
                                    }
                                }(a, e1.layers, r);
                            } catch (t1) {
                                console.warn("Unable to compute style diff:", t1), r = [
                                    {
                                        command: "setStyle",
                                        args: [
                                            e1
                                        ]
                                    }
                                ];
                            }
                            return r;
                        }, t1.aE = function(t1) {
                            const e1 = [], r = t1.id;
                            return void 0 === r && e1.push({
                                message: `layers.${r}: missing required property "id"`
                            }), void 0 === t1.render && e1.push({
                                message: `layers.${r}: missing required method "render"`
                            }), t1.renderingMode && "2d" !== t1.renderingMode && "3d" !== t1.renderingMode && e1.push({
                                message: `layers.${r}: property "renderingMode" must be either "2d" or "3d"`
                            }), e1;
                        }, t1.aF = function t1(e1, r) {
                            if (Array.isArray(e1)) {
                                if (!Array.isArray(r) || e1.length !== r.length) return !1;
                                for(let n = 0; n < e1.length; n++)if (!t1(e1[n], r[n])) return !1;
                                return !0;
                            }
                            if ("object" == typeof e1 && null !== e1 && null !== r) {
                                if ("object" != typeof r) return !1;
                                if (Object.keys(e1).length !== Object.keys(r).length) return !1;
                                for(const n in e1)if (!t1(e1[n], r[n])) return !1;
                                return !0;
                            }
                            return e1 === r;
                        }, t1.aG = x, t1.aH = _, t1.aI = class extends Mo {
                            constructor(t1, e1){
                                super(t1, e1), this.current = 0;
                            }
                            set(t1) {
                                this.current !== t1 && (this.current = t1, this.gl.uniform1i(this.location, t1));
                            }
                        }, t1.aJ = So, t1.aK = class extends Mo {
                            constructor(t1, e1){
                                super(t1, e1), this.current = Lo;
                            }
                            set(t1) {
                                if (t1[12] !== this.current[12] || t1[0] !== this.current[0]) return this.current = t1, void this.gl.uniformMatrix4fv(this.location, !1, t1);
                                for(let e1 = 1; e1 < 16; e1++)if (t1[e1] !== this.current[e1]) {
                                    this.current = t1, this.gl.uniformMatrix4fv(this.location, !1, t1);
                                    break;
                                }
                            }
                        }, t1.aL = Eo, t1.aM = Co, t1.aN = Xt, t1.aO = class extends Mo {
                            constructor(t1, e1){
                                super(t1, e1), this.current = [
                                    0,
                                    0,
                                    0
                                ];
                            }
                            set(t1) {
                                t1[0] === this.current[0] && t1[1] === this.current[1] && t1[2] === this.current[2] || (this.current = t1, this.gl.uniform3f(this.location, t1[0], t1[1], t1[2]));
                            }
                        }, t1.aP = class extends Mo {
                            constructor(t1, e1){
                                super(t1, e1), this.current = [
                                    0,
                                    0
                                ];
                            }
                            set(t1) {
                                t1[0] === this.current[0] && t1[1] === this.current[1] || (this.current = t1, this.gl.uniform2f(this.location, t1[0], t1[1]));
                            }
                        }, t1.aQ = gs, t1.aR = ys, t1.aS = class extends ka {
                        }, t1.aT = gc, t1.aU = class extends Ma {
                        }, t1.aV = function(t1) {
                            return t1 <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(t1) / Math.LN2));
                        }, t1.aW = Is, t1.aX = Wa, t1.aY = ao, t1.aZ = class extends za {
                        }, t1.a_ = function(t1, e1) {
                            return t1[0] === e1[0] && t1[1] === e1[1] && t1[2] === e1[2] && t1[3] === e1[3] && t1[4] === e1[4] && t1[5] === e1[5] && t1[6] === e1[6] && t1[7] === e1[7] && t1[8] === e1[8] && t1[9] === e1[9] && t1[10] === e1[10] && t1[11] === e1[11] && t1[12] === e1[12] && t1[13] === e1[13] && t1[14] === e1[14] && t1[15] === e1[15];
                        }, t1.aa = ih, t1.ab = function(t1) {
                            const e1 = {};
                            if (t1.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, (t1, r, n, i)=>{
                                const a = n || i;
                                return e1[r] = !a || a.toLowerCase(), "";
                            }), e1["max-age"]) {
                                const t1 = parseInt(e1["max-age"], 10);
                                isNaN(t1) ? delete e1["max-age"] : e1["max-age"] = t1;
                            }
                            return e1;
                        }, t1.ac = function(t1, e1) {
                            const r = [];
                            for(const n in t1)n in e1 || r.push(n);
                            return r;
                        }, t1.ad = m, t1.ae = function(t1, e1, r) {
                            var n = Math.sin(r), i = Math.cos(r), a = e1[0], o = e1[1], s = e1[2], l = e1[3], c = e1[4], u = e1[5], h = e1[6], f = e1[7];
                            return e1 !== t1 && (t1[8] = e1[8], t1[9] = e1[9], t1[10] = e1[10], t1[11] = e1[11], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]), t1[0] = a * i + c * n, t1[1] = o * i + u * n, t1[2] = s * i + h * n, t1[3] = l * i + f * n, t1[4] = c * i - a * n, t1[5] = u * i - o * n, t1[6] = h * i - s * n, t1[7] = f * i - l * n, t1;
                        }, t1.af = function(t1) {
                            var e1 = new fs(16);
                            return e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1[3] = t1[3], e1[4] = t1[4], e1[5] = t1[5], e1[6] = t1[6], e1[7] = t1[7], e1[8] = t1[8], e1[9] = t1[9], e1[10] = t1[10], e1[11] = t1[11], e1[12] = t1[12], e1[13] = t1[13], e1[14] = t1[14], e1[15] = t1[15], e1;
                        }, t1.ag = vs, t1.ah = function(t1, e1) {
                            let r = 0, n = 0;
                            if ("constant" === t1.kind) n = t1.layoutSize;
                            else if ("source" !== t1.kind) {
                                const { interpolationType: i, minZoom: a, maxZoom: o } = t1, s = i ? m(ze.interpolationFactor(i, e1, a, o), 0, 1) : 0;
                                "camera" === t1.kind ? n = Pe.number(t1.minSize, t1.maxSize, s) : r = s;
                            }
                            return {
                                uSizeT: r,
                                uSize: n
                            };
                        }, t1.aj = function(t1, { uSize: e1, uSizeT: r }, { lowerSize: n, upperSize: i }) {
                            return "source" === t1.kind ? n / yu : "composite" === t1.kind ? Pe.number(n / yu, i / yu, r) : e1;
                        }, t1.ak = ku, t1.al = function(t1, e1, r, n) {
                            const i = e1.y - t1.y, o = e1.x - t1.x, s = n.y - r.y, l = n.x - r.x, c = s * o - l * i;
                            if (0 === c) return null;
                            const u = (l * (t1.y - r.y) - s * (t1.x - r.x)) / c;
                            return new a(t1.x + u * o, t1.y + u * i);
                        }, t1.am = ch, t1.an = Yo, t1.ao = ps, t1.ap = function(t1) {
                            let e1 = 1 / 0, r = 1 / 0, n = -1 / 0, i = -1 / 0;
                            for (const a of t1)e1 = Math.min(e1, a.x), r = Math.min(r, a.y), n = Math.max(n, a.x), i = Math.max(i, a.y);
                            return [
                                e1,
                                r,
                                n,
                                i
                            ];
                        }, t1.aq = xc, t1.as = _u, t1.at = function(t1, e1) {
                            var r = e1[0], n = e1[1], i = e1[2], a = e1[3], o = e1[4], s = e1[5], l = e1[6], c = e1[7], u = e1[8], h = e1[9], f = e1[10], p = e1[11], d = e1[12], m = e1[13], g = e1[14], y = e1[15], v = r * s - n * o, x = r * l - i * o, _ = r * c - a * o, b = n * l - i * s, w = n * c - a * s, T = i * c - a * l, k = u * m - h * d, A = u * g - f * d, M = u * y - p * d, S = h * g - f * m, E = h * y - p * m, C = f * y - p * g, L = v * C - x * E + _ * S + b * M - w * A + T * k;
                            return L ? (L = 1 / L, t1[0] = (s * C - l * E + c * S) * L, t1[1] = (i * E - n * C - a * S) * L, t1[2] = (m * T - g * w + y * b) * L, t1[3] = (f * w - h * T - p * b) * L, t1[4] = (l * M - o * C - c * A) * L, t1[5] = (r * C - i * M + a * A) * L, t1[6] = (g * _ - d * T - y * x) * L, t1[7] = (u * T - f * _ + p * x) * L, t1[8] = (o * E - s * M + c * k) * L, t1[9] = (n * M - r * E - a * k) * L, t1[10] = (d * w - m * _ + y * v) * L, t1[11] = (h * _ - u * w - p * v) * L, t1[12] = (s * A - o * S - l * k) * L, t1[13] = (r * S - n * A + i * k) * L, t1[14] = (m * x - d * b - g * v) * L, t1[15] = (u * b - h * x + f * v) * L, t1) : null;
                        }, t1.au = Oh, t1.av = hu, t1.aw = jh, t1.ax = function() {
                            const t1 = {}, e1 = Z.$version;
                            for(const r in Z.$root){
                                const n = Z.$root[r];
                                if (n.required) {
                                    let i = null;
                                    i = "version" === r ? e1 : "array" === n.type ? [] : {}, null != i && (t1[r] = i);
                                }
                            }
                            return t1;
                        }, t1.ay = Pi, t1.az = B, t1.b = S, t1.b0 = function(t1, e1) {
                            return t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1[3] = e1[3], t1[4] = e1[4], t1[5] = e1[5], t1[6] = e1[6], t1[7] = e1[7], t1[8] = e1[8], t1[9] = e1[9], t1[10] = e1[10], t1[11] = e1[11], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15], t1;
                        }, t1.b1 = _s, t1.b2 = function(t1, e1) {
                            return t1[0] * e1[0] + t1[1] * e1[1] + t1[2] * e1[2] + t1[3] * e1[3];
                        }, t1.b3 = g, t1.b4 = Qu, t1.b5 = Yu, t1.b6 = ms, t1.b7 = function(t1, e1, r) {
                            var n = Math.sin(r), i = Math.cos(r), a = e1[4], o = e1[5], s = e1[6], l = e1[7], c = e1[8], u = e1[9], h = e1[10], f = e1[11];
                            return e1 !== t1 && (t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1[3] = e1[3], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]), t1[4] = a * i + c * n, t1[5] = o * i + u * n, t1[6] = s * i + h * n, t1[7] = l * i + f * n, t1[8] = c * i - a * n, t1[9] = u * i - o * n, t1[10] = h * i - s * n, t1[11] = f * i - l * n, t1;
                        }, t1.b8 = p, t1.b9 = d, t1.bA = function(t1) {
                            return t1.message === P;
                        }, t1.bB = An, t1.bC = qi, t1.ba = function(t1) {
                            return t1 * Math.PI / 180;
                        }, t1.bb = function(t1, e1) {
                            return t1[0] = e1[0], t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = e1[1], t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = e1[2], t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
                        }, t1.bc = class extends pa {
                        }, t1.bd = Vu, t1.be = Kh, t1.bg = F, t1.bh = function(t1, e1) {
                            O.REGISTERED_PROTOCOLS[t1] = e1;
                        }, t1.bi = function(t1) {
                            delete O.REGISTERED_PROTOCOLS[t1];
                        }, t1.bj = function(t1, e1) {
                            const r = {};
                            for(let n = 0; n < t1.length; n++){
                                const i = e1 && e1[t1[n].id] || Vn(t1[n]);
                                e1 && (e1[t1[n].id] = i);
                                let a = r[i];
                                a || (a = r[i] = []), a.push(t1[n]);
                            }
                            const n = [];
                            for(const t1 in r)n.push(r[t1]);
                            return n;
                        }, t1.bk = Mi, t1.bl = nh, t1.bm = ah, t1.bn = $c, t1.bo = function(e1) {
                            e1.bucket.createArrays();
                            const r = 512 * e1.bucket.overscaling;
                            e1.bucket.tilePixelRatio = Uo / r, e1.bucket.compareText = {}, e1.bucket.iconsNeedLinear = !1;
                            const n = e1.bucket.layers[0], i = n.layout, a = n._unevaluatedLayout._values, o = {
                                layoutIconSize: a["icon-size"].possiblyEvaluate(new Hi(e1.bucket.zoom + 1), e1.canonical),
                                layoutTextSize: a["text-size"].possiblyEvaluate(new Hi(e1.bucket.zoom + 1), e1.canonical),
                                textMaxSize: a["text-size"].possiblyEvaluate(new Hi(18))
                            };
                            if ("composite" === e1.bucket.textSizeData.kind) {
                                const { minZoom: t1, maxZoom: r } = e1.bucket.textSizeData;
                                o.compositeTextSizes = [
                                    a["text-size"].possiblyEvaluate(new Hi(t1), e1.canonical),
                                    a["text-size"].possiblyEvaluate(new Hi(r), e1.canonical)
                                ];
                            }
                            if ("composite" === e1.bucket.iconSizeData.kind) {
                                const { minZoom: t1, maxZoom: r } = e1.bucket.iconSizeData;
                                o.compositeIconSizes = [
                                    a["icon-size"].possiblyEvaluate(new Hi(t1), e1.canonical),
                                    a["icon-size"].possiblyEvaluate(new Hi(r), e1.canonical)
                                ];
                            }
                            const s = i.get("text-line-height") * xc, l = "viewport" !== i.get("text-rotation-alignment") && "point" !== i.get("symbol-placement"), c = i.get("text-keep-upright"), u = i.get("text-size");
                            for (const r of e1.bucket.features){
                                const a = i.get("text-font").evaluate(r, {}, e1.canonical).join(","), h = u.evaluate(r, {}, e1.canonical), f = o.layoutTextSize.evaluate(r, {}, e1.canonical), p = o.layoutIconSize.evaluate(r, {}, e1.canonical), d = {
                                    horizontal: {},
                                    vertical: void 0
                                }, m = r.text;
                                let g, y = [
                                    0,
                                    0
                                ];
                                if (m) {
                                    const o = m.toString(), u = i.get("text-letter-spacing").evaluate(r, {}, e1.canonical) * xc, p = Di(o) ? u : 0, g = i.get("text-anchor").evaluate(r, {}, e1.canonical), v = zh(n, r, e1.canonical);
                                    if (!v) {
                                        const t1 = i.get("text-radial-offset").evaluate(r, {}, e1.canonical);
                                        y = t1 ? Ph(g, [
                                            t1 * xc,
                                            Ih
                                        ]) : i.get("text-offset").evaluate(r, {}, e1.canonical).map((t1)=>t1 * xc);
                                    }
                                    let x = l ? "center" : i.get("text-justify").evaluate(r, {}, e1.canonical);
                                    const _ = "point" === i.get("symbol-placement") ? i.get("text-max-width").evaluate(r, {}, e1.canonical) * xc : 1 / 0, b = ()=>{
                                        e1.bucket.allowVerticalPlacement && Oi(o) && (d.vertical = eu(m, e1.glyphMap, e1.glyphPositions, e1.imagePositions, a, _, s, g, "left", p, y, t1.ai.vertical, !0, f, h));
                                    };
                                    if (!l && v) {
                                        const r = new Set;
                                        if ("auto" === x) for(let t1 = 0; t1 < v.values.length; t1 += 2)r.add(Oh(v.values[t1]));
                                        else r.add(x);
                                        let n = !1;
                                        for (const i of r)if (!d.horizontal[i]) {
                                            if (n) d.horizontal[i] = d.horizontal[0];
                                            else {
                                                const r = eu(m, e1.glyphMap, e1.glyphPositions, e1.imagePositions, a, _, s, "center", i, p, y, t1.ai.horizontal, !1, f, h);
                                                r && (d.horizontal[i] = r, n = 1 === r.positionedLines.length);
                                            }
                                        }
                                        b();
                                    } else {
                                        "auto" === x && (x = Oh(g));
                                        const r = eu(m, e1.glyphMap, e1.glyphPositions, e1.imagePositions, a, _, s, g, x, p, y, t1.ai.horizontal, !1, f, h);
                                        r && (d.horizontal[x] = r), b(), Oi(o) && l && c && (d.vertical = eu(m, e1.glyphMap, e1.glyphPositions, e1.imagePositions, a, _, s, g, x, p, y, t1.ai.vertical, !1, f, h));
                                    }
                                }
                                let v = !1;
                                if (r.icon && r.icon.name) {
                                    const t1 = e1.imageMap[r.icon.name];
                                    t1 && (g = pu(e1.imagePositions[r.icon.name], i.get("icon-offset").evaluate(r, {}, e1.canonical), i.get("icon-anchor").evaluate(r, {}, e1.canonical)), v = !!t1.sdf, void 0 === e1.bucket.sdfIcons ? e1.bucket.sdfIcons = v : e1.bucket.sdfIcons !== v && T("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (t1.pixelRatio !== e1.bucket.pixelRatio || 0 !== i.get("icon-rotate").constantOr(1)) && (e1.bucket.iconsNeedLinear = !0));
                                }
                                const x = Fh(d.horizontal) || d.vertical;
                                e1.bucket.iconsInText = !!x && x.iconsInText, (x || g) && Dh(e1.bucket, r, d, g, e1.imageMap, o, f, p, y, v, e1.canonical);
                            }
                            e1.showCollisionBoxes && e1.bucket.generateCollisionDebugBuffers();
                        }, t1.bp = ic, t1.bq = pl, t1.br = Nl, t1.bs = Tl, t1.bt = Uc, t1.bu = class {
                            constructor(t1){
                                this._marks = {
                                    start: [
                                        t1.url,
                                        "start"
                                    ].join("#"),
                                    end: [
                                        t1.url,
                                        "end"
                                    ].join("#"),
                                    measure: t1.url.toString()
                                }, performance.mark(this._marks.start);
                            }
                            finish() {
                                performance.mark(this._marks.end);
                                let t1 = performance.getEntriesByName(this._marks.measure);
                                return 0 === t1.length && (performance.measure(this._marks.measure, this._marks.start, this._marks.end), t1 = performance.getEntriesByName(this._marks.measure), performance.clearMarks(this._marks.start), performance.clearMarks(this._marks.end), performance.clearMeasures(this._marks.measure)), t1;
                            }
                        }, t1.bv = function(t1, r, n, i, a) {
                            return e1(this, void 0, void 0, function*() {
                                if (f()) try {
                                    return yield C(t1, r, n, i, a);
                                } catch (t1) {}
                                return function(t1, e1, r, n, i) {
                                    const a = t1.width, o = t1.height;
                                    L && I || (L = new OffscreenCanvas(a, o), I = L.getContext("2d", {
                                        willReadFrequently: !0
                                    })), L.width = a, L.height = o, I.drawImage(t1, 0, 0, a, o);
                                    const s = I.getImageData(e1, r, n, i);
                                    return I.clearRect(0, 0, a, o), s.data;
                                }(t1, r, n, i, a);
                            });
                        }, t1.bw = rh, t1.bx = r, t1.by = n, t1.bz = _c, t1.c = z, t1.d = (t1)=>e1(void 0, void 0, void 0, function*() {
                                if (0 === t1.byteLength) return createImageBitmap(new ImageData(1, 1));
                                const e1 = new Blob([
                                    new Uint8Array(t1)
                                ], {
                                    type: "image/png"
                                });
                                try {
                                    return createImageBitmap(e1);
                                } catch (t1) {
                                    throw new Error(`Could not load image because of ${t1.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`);
                                }
                            }), t1.e = y, t1.f = (t1)=>new Promise((e1, r)=>{
                                const n = new Image;
                                n.onload = ()=>{
                                    e1(n), URL.revokeObjectURL(n.src), n.onload = null, window.requestAnimationFrame(()=>{
                                        n.src = E;
                                    });
                                }, n.onerror = ()=>r(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                                const i = new Blob([
                                    new Uint8Array(t1)
                                ], {
                                    type: "image/png"
                                });
                                n.src = t1.byteLength ? URL.createObjectURL(i) : E;
                            }), t1.g = D, t1.h = (t1, e1)=>N(y(t1, {
                                type: "json"
                            }), e1), t1.i = A, t1.j = H, t1.k = q, t1.l = (t1, e1)=>N(y(t1, {
                                type: "arrayBuffer"
                            }), e1), t1.m = N, t1.n = function(t1) {
                            return new Uc(t1).readFields(qc, []);
                        }, t1.o = Cs, t1.p = Wc, t1.q = ia, t1.r = xi, t1.s = j, t1.t = Ti, t1.u = zi, t1.v = Z, t1.w = T, t1.x = vi, t1.y = function([t1, e1, r]) {
                            return e1 += 90, e1 *= Math.PI / 180, r *= Math.PI / 180, {
                                x: t1 * Math.cos(e1) * Math.sin(r),
                                y: t1 * Math.sin(e1) * Math.sin(r),
                                z: t1 * Math.cos(r)
                            };
                        }, t1.z = Pe;
                    }), r("worker", 0, function(t1) {
                        class e1 {
                            constructor(t1){
                                this.keyCache = {}, t1 && this.replace(t1);
                            }
                            replace(t1) {
                                this._layerConfigs = {}, this._layers = {}, this.update(t1, []);
                            }
                            update(e1, r) {
                                for (const r of e1){
                                    this._layerConfigs[r.id] = r;
                                    const e1 = this._layers[r.id] = t1.aB(r);
                                    e1._featureFilter = t1.a7(e1.filter), this.keyCache[r.id] && delete this.keyCache[r.id];
                                }
                                for (const t1 of r)delete this.keyCache[t1], delete this._layerConfigs[t1], delete this._layers[t1];
                                this.familiesBySource = {};
                                const n = t1.bj(Object.values(this._layerConfigs), this.keyCache);
                                for (const t1 of n){
                                    const e1 = t1.map((t1)=>this._layers[t1.id]), r = e1[0];
                                    if ("none" === r.visibility) continue;
                                    const n = r.source || "";
                                    let i = this.familiesBySource[n];
                                    i || (i = this.familiesBySource[n] = {});
                                    const a = r.sourceLayer || "_geojsonTileLayer";
                                    let o = i[a];
                                    o || (o = i[a] = []), o.push(e1);
                                }
                            }
                        }
                        class r {
                            constructor(e1){
                                const r = {}, n = [];
                                for(const t1 in e1){
                                    const i = e1[t1], a = r[t1] = {};
                                    for(const t1 in i){
                                        const e1 = i[+t1];
                                        if (!e1 || 0 === e1.bitmap.width || 0 === e1.bitmap.height) continue;
                                        const r = {
                                            x: 0,
                                            y: 0,
                                            w: e1.bitmap.width + 2,
                                            h: e1.bitmap.height + 2
                                        };
                                        n.push(r), a[t1] = {
                                            rect: r,
                                            metrics: e1.metrics
                                        };
                                    }
                                }
                                const { w: i, h: a } = t1.p(n), o = new t1.o({
                                    width: i || 1,
                                    height: a || 1
                                });
                                for(const n in e1){
                                    const i = e1[n];
                                    for(const e1 in i){
                                        const a = i[+e1];
                                        if (!a || 0 === a.bitmap.width || 0 === a.bitmap.height) continue;
                                        const s = r[n][e1].rect;
                                        t1.o.copy(a.bitmap, o, {
                                            x: 0,
                                            y: 0
                                        }, {
                                            x: s.x + 1,
                                            y: s.y + 1
                                        }, a.bitmap);
                                    }
                                }
                                this.image = o, this.positions = r;
                            }
                        }
                        t1.bk("GlyphAtlas", r);
                        class n {
                            constructor(e1){
                                this.tileID = new t1.S(e1.tileID.overscaledZ, e1.tileID.wrap, e1.tileID.canonical.z, e1.tileID.canonical.x, e1.tileID.canonical.y), this.uid = e1.uid, this.zoom = e1.zoom, this.pixelRatio = e1.pixelRatio, this.tileSize = e1.tileSize, this.source = e1.source, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = e1.showCollisionBoxes, this.collectResourceTiming = !!e1.collectResourceTiming, this.returnDependencies = !!e1.returnDependencies, this.promoteId = e1.promoteId, this.inFlightDependencies = [];
                            }
                            parse(e1, n, a, o) {
                                return t1._(this, void 0, void 0, function*() {
                                    this.status = "parsing", this.data = e1, this.collisionBoxArray = new t1.a5;
                                    const s = new t1.bl(Object.keys(e1.layers).sort()), l = new t1.bm(this.tileID, this.promoteId);
                                    l.bucketLayerIDs = [];
                                    const c = {}, u = {
                                        featureIndex: l,
                                        iconDependencies: {},
                                        patternDependencies: {},
                                        glyphDependencies: {},
                                        availableImages: a
                                    }, h = n.familiesBySource[this.source];
                                    for(const r in h){
                                        const n = e1.layers[r];
                                        if (!n) continue;
                                        1 === n.version && t1.w(`Vector tile source "${this.source}" layer "${r}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
                                        const o = s.encode(r), f = [];
                                        for(let t1 = 0; t1 < n.length; t1++){
                                            const e1 = n.feature(t1), i = l.getId(e1, r);
                                            f.push({
                                                feature: e1,
                                                id: i,
                                                index: t1,
                                                sourceLayerIndex: o
                                            });
                                        }
                                        for (const e1 of h[r]){
                                            const r = e1[0];
                                            r.source !== this.source && t1.w(`layer.source = ${r.source} does not equal this.source = ${this.source}`), r.minzoom && this.zoom < Math.floor(r.minzoom) || r.maxzoom && this.zoom >= r.maxzoom || "none" !== r.visibility && (i(e1, this.zoom, a), (c[r.id] = r.createBucket({
                                                index: l.bucketLayerIDs.length,
                                                layers: e1,
                                                zoom: this.zoom,
                                                pixelRatio: this.pixelRatio,
                                                overscaling: this.overscaling,
                                                collisionBoxArray: this.collisionBoxArray,
                                                sourceLayerIndex: o,
                                                sourceID: this.source
                                            })).populate(f, u, this.tileID.canonical), l.bucketLayerIDs.push(e1.map((t1)=>t1.id)));
                                        }
                                    }
                                    const f = t1.aG(u.glyphDependencies, (t1)=>Object.keys(t1).map(Number));
                                    this.inFlightDependencies.forEach((t1)=>null == t1 ? void 0 : t1.abort()), this.inFlightDependencies = [];
                                    let p = Promise.resolve({});
                                    if (Object.keys(f).length) {
                                        const t1 = new AbortController;
                                        this.inFlightDependencies.push(t1), p = o.sendAsync({
                                            type: "GG",
                                            data: {
                                                stacks: f,
                                                source: this.source,
                                                tileID: this.tileID,
                                                type: "glyphs"
                                            }
                                        }, t1);
                                    }
                                    const d = Object.keys(u.iconDependencies);
                                    let m = Promise.resolve({});
                                    if (d.length) {
                                        const t1 = new AbortController;
                                        this.inFlightDependencies.push(t1), m = o.sendAsync({
                                            type: "GI",
                                            data: {
                                                icons: d,
                                                source: this.source,
                                                tileID: this.tileID,
                                                type: "icons"
                                            }
                                        }, t1);
                                    }
                                    const g = Object.keys(u.patternDependencies);
                                    let y = Promise.resolve({});
                                    if (g.length) {
                                        const t1 = new AbortController;
                                        this.inFlightDependencies.push(t1), y = o.sendAsync({
                                            type: "GI",
                                            data: {
                                                icons: g,
                                                source: this.source,
                                                tileID: this.tileID,
                                                type: "patterns"
                                            }
                                        }, t1);
                                    }
                                    const [v, x, _] = yield Promise.all([
                                        p,
                                        m,
                                        y
                                    ]), b = new r(v), w = new t1.bn(x, _);
                                    for(const e1 in c){
                                        const r = c[e1];
                                        r instanceof t1.a6 ? (i(r.layers, this.zoom, a), t1.bo({
                                            bucket: r,
                                            glyphMap: v,
                                            glyphPositions: b.positions,
                                            imageMap: x,
                                            imagePositions: w.iconPositions,
                                            showCollisionBoxes: this.showCollisionBoxes,
                                            canonical: this.tileID.canonical
                                        })) : r.hasPattern && (r instanceof t1.bp || r instanceof t1.bq || r instanceof t1.br) && (i(r.layers, this.zoom, a), r.addFeatures(u, this.tileID.canonical, w.patternPositions));
                                    }
                                    return this.status = "done", {
                                        buckets: Object.values(c).filter((t1)=>!t1.isEmpty()),
                                        featureIndex: l,
                                        collisionBoxArray: this.collisionBoxArray,
                                        glyphAtlasImage: b.image,
                                        imageAtlas: w,
                                        glyphMap: this.returnDependencies ? v : null,
                                        iconMap: this.returnDependencies ? x : null,
                                        glyphPositions: this.returnDependencies ? b.positions : null
                                    };
                                });
                            }
                        }
                        function i(e1, r, n) {
                            const i = new t1.a9(r);
                            for (const t1 of e1)t1.recalculate(i, n);
                        }
                        class a {
                            constructor(t1, e1, r){
                                this.actor = t1, this.layerIndex = e1, this.availableImages = r, this.fetching = {}, this.loading = {}, this.loaded = {};
                            }
                            loadVectorTile(e1, r) {
                                return t1._(this, void 0, void 0, function*() {
                                    const n = yield t1.l(e1.request, r);
                                    try {
                                        return {
                                            vectorTile: new t1.bs.VectorTile(new t1.bt(n.data)),
                                            rawData: n.data,
                                            cacheControl: n.cacheControl,
                                            expires: n.expires
                                        };
                                    } catch (t1) {
                                        const r = new Uint8Array(n.data), i = 31 === r[0] && 139 === r[1];
                                        let a = `Unable to parse the tile at ${e1.request.url}, `;
                                        throw a += i ? "please make sure the data is not gzipped and that you have configured the relevant header in the server" : `got error: ${t1.message}`, new Error(a);
                                    }
                                });
                            }
                            loadTile(e1) {
                                return t1._(this, void 0, void 0, function*() {
                                    const r = e1.uid, i = !!(e1 && e1.request && e1.request.collectResourceTiming) && new t1.bu(e1.request), a = new n(e1);
                                    this.loading[r] = a;
                                    const o = new AbortController;
                                    a.abort = o;
                                    try {
                                        const n = yield this.loadVectorTile(e1, o);
                                        if (delete this.loading[r], !n) return null;
                                        const s = n.rawData, l = {};
                                        n.expires && (l.expires = n.expires), n.cacheControl && (l.cacheControl = n.cacheControl);
                                        const c = {};
                                        if (i) {
                                            const t1 = i.finish();
                                            t1 && (c.resourceTiming = JSON.parse(JSON.stringify(t1)));
                                        }
                                        a.vectorTile = n.vectorTile;
                                        const u = a.parse(n.vectorTile, this.layerIndex, this.availableImages, this.actor);
                                        this.loaded[r] = a, this.fetching[r] = {
                                            rawTileData: s,
                                            cacheControl: l,
                                            resourceTiming: c
                                        };
                                        try {
                                            const e1 = yield u;
                                            return t1.e({
                                                rawTileData: s.slice(0)
                                            }, e1, l, c);
                                        } finally{
                                            delete this.fetching[r];
                                        }
                                    } catch (t1) {
                                        throw delete this.loading[r], a.status = "done", this.loaded[r] = a, t1;
                                    }
                                });
                            }
                            reloadTile(e1) {
                                return t1._(this, void 0, void 0, function*() {
                                    const r = e1.uid;
                                    if (!this.loaded || !this.loaded[r]) throw new Error("Should not be trying to reload a tile that was never loaded or has been removed");
                                    const n = this.loaded[r];
                                    if (n.showCollisionBoxes = e1.showCollisionBoxes, "parsing" === n.status) {
                                        const e1 = yield n.parse(n.vectorTile, this.layerIndex, this.availableImages, this.actor);
                                        let i;
                                        if (this.fetching[r]) {
                                            const { rawTileData: n, cacheControl: a, resourceTiming: o } = this.fetching[r];
                                            delete this.fetching[r], i = t1.e({
                                                rawTileData: n.slice(0)
                                            }, e1, a, o);
                                        } else i = e1;
                                        return i;
                                    }
                                    if ("done" === n.status && n.vectorTile) return n.parse(n.vectorTile, this.layerIndex, this.availableImages, this.actor);
                                });
                            }
                            abortTile(e1) {
                                return t1._(this, void 0, void 0, function*() {
                                    const t1 = this.loading, r = e1.uid;
                                    t1 && t1[r] && t1[r].abort && (t1[r].abort.abort(), delete t1[r]);
                                });
                            }
                            removeTile(e1) {
                                return t1._(this, void 0, void 0, function*() {
                                    this.loaded && this.loaded[e1.uid] && delete this.loaded[e1.uid];
                                });
                            }
                        }
                        class o {
                            constructor(){
                                this.loaded = {};
                            }
                            loadTile(e1) {
                                return t1._(this, void 0, void 0, function*() {
                                    const { uid: r, encoding: n, rawImageData: i, redFactor: a, greenFactor: o, blueFactor: s, baseShift: l } = e1, c = i.width + 2, u = i.height + 2, h = t1.b(i) ? new t1.R({
                                        width: c,
                                        height: u
                                    }, (yield t1.bv(i, -1, -1, c, u))) : i, f = new t1.bw(r, h, n, a, o, s, l);
                                    return this.loaded = this.loaded || {}, this.loaded[r] = f, f;
                                });
                            }
                            removeTile(t1) {
                                const e1 = this.loaded, r = t1.uid;
                                e1 && e1[r] && delete e1[r];
                            }
                        }
                        var s = function t1(e1, r) {
                            var n, i = e1 && e1.type;
                            if ("FeatureCollection" === i) for(n = 0; n < e1.features.length; n++)t1(e1.features[n], r);
                            else if ("GeometryCollection" === i) for(n = 0; n < e1.geometries.length; n++)t1(e1.geometries[n], r);
                            else if ("Feature" === i) t1(e1.geometry, r);
                            else if ("Polygon" === i) l(e1.coordinates, r);
                            else if ("MultiPolygon" === i) for(n = 0; n < e1.coordinates.length; n++)l(e1.coordinates[n], r);
                            return e1;
                        };
                        function l(t1, e1) {
                            if (0 !== t1.length) {
                                c(t1[0], e1);
                                for(var r = 1; r < t1.length; r++)c(t1[r], !e1);
                            }
                        }
                        function c(t1, e1) {
                            for(var r = 0, n = 0, i = 0, a = t1.length, o = a - 1; i < a; o = i++){
                                var s = (t1[i][0] - t1[o][0]) * (t1[o][1] + t1[i][1]), l = r + s;
                                n += Math.abs(r) >= Math.abs(s) ? r - l + s : s - l + r, r = l;
                            }
                            r + n >= 0 != !!e1 && t1.reverse();
                        }
                        var u = t1.bx(s);
                        const h = t1.bs.VectorTileFeature.prototype.toGeoJSON;
                        let f = class {
                            constructor(e1){
                                this._feature = e1, this.extent = t1.X, this.type = e1.type, this.properties = e1.tags, "id" in e1 && !isNaN(e1.id) && (this.id = parseInt(e1.id, 10));
                            }
                            loadGeometry() {
                                if (1 === this._feature.type) {
                                    const e1 = [];
                                    for (const r of this._feature.geometry)e1.push([
                                        new t1.P(r[0], r[1])
                                    ]);
                                    return e1;
                                }
                                {
                                    const e1 = [];
                                    for (const r of this._feature.geometry){
                                        const n = [];
                                        for (const e1 of r)n.push(new t1.P(e1[0], e1[1]));
                                        e1.push(n);
                                    }
                                    return e1;
                                }
                            }
                            toGeoJSON(t1, e1, r) {
                                return h.call(this, t1, e1, r);
                            }
                        }, p = class {
                            constructor(e1){
                                this.layers = {
                                    _geojsonTileLayer: this
                                }, this.name = "_geojsonTileLayer", this.extent = t1.X, this.length = e1.length, this._features = e1;
                            }
                            feature(t1) {
                                return new f(this._features[t1]);
                            }
                        };
                        var d = {
                            exports: {}
                        }, m = t1.by, g = t1.bs.VectorTileFeature, y = v;
                        function v(t1, e1) {
                            this.options = e1 || {}, this.features = t1, this.length = t1.length;
                        }
                        function x(t1, e1) {
                            this.id = "number" == typeof t1.id ? t1.id : void 0, this.type = t1.type, this.rawGeometry = 1 === t1.type ? [
                                t1.geometry
                            ] : t1.geometry, this.properties = t1.tags, this.extent = e1 || 4096;
                        }
                        v.prototype.feature = function(t1) {
                            return new x(this.features[t1], this.options.extent);
                        }, x.prototype.loadGeometry = function() {
                            var t1 = this.rawGeometry;
                            this.geometry = [];
                            for(var e1 = 0; e1 < t1.length; e1++){
                                for(var r = t1[e1], n = [], i = 0; i < r.length; i++)n.push(new m(r[i][0], r[i][1]));
                                this.geometry.push(n);
                            }
                            return this.geometry;
                        }, x.prototype.bbox = function() {
                            this.geometry || this.loadGeometry();
                            for(var t1 = this.geometry, e1 = 1 / 0, r = -1 / 0, n = 1 / 0, i = -1 / 0, a = 0; a < t1.length; a++)for(var o = t1[a], s = 0; s < o.length; s++){
                                var l = o[s];
                                e1 = Math.min(e1, l.x), r = Math.max(r, l.x), n = Math.min(n, l.y), i = Math.max(i, l.y);
                            }
                            return [
                                e1,
                                n,
                                r,
                                i
                            ];
                        }, x.prototype.toGeoJSON = g.prototype.toGeoJSON;
                        var _ = t1.bz, b = y;
                        function w(t1) {
                            var e1 = new _;
                            return function(t1, e1) {
                                for(var r in t1.layers)e1.writeMessage(3, T, t1.layers[r]);
                            }(t1, e1), e1.finish();
                        }
                        function T(t1, e1) {
                            var r;
                            e1.writeVarintField(15, t1.version || 1), e1.writeStringField(1, t1.name || ""), e1.writeVarintField(5, t1.extent || 4096);
                            var n = {
                                keys: [],
                                values: [],
                                keycache: {},
                                valuecache: {}
                            };
                            for(r = 0; r < t1.length; r++)n.feature = t1.feature(r), e1.writeMessage(2, k, n);
                            var i = n.keys;
                            for(r = 0; r < i.length; r++)e1.writeStringField(3, i[r]);
                            var a = n.values;
                            for(r = 0; r < a.length; r++)e1.writeMessage(4, C, a[r]);
                        }
                        function k(t1, e1) {
                            var r = t1.feature;
                            void 0 !== r.id && e1.writeVarintField(1, r.id), e1.writeMessage(2, A, t1), e1.writeVarintField(3, r.type), e1.writeMessage(4, E, r);
                        }
                        function A(t1, e1) {
                            var r = t1.feature, n = t1.keys, i = t1.values, a = t1.keycache, o = t1.valuecache;
                            for(var s in r.properties){
                                var l = r.properties[s], c = a[s];
                                if (null !== l) {
                                    void 0 === c && (n.push(s), c = n.length - 1, a[s] = c), e1.writeVarint(c);
                                    var u = typeof l;
                                    "string" !== u && "boolean" !== u && "number" !== u && (l = JSON.stringify(l));
                                    var h = u + ":" + l, f = o[h];
                                    void 0 === f && (i.push(l), f = i.length - 1, o[h] = f), e1.writeVarint(f);
                                }
                            }
                        }
                        function M(t1, e1) {
                            return (e1 << 3) + (7 & t1);
                        }
                        function S(t1) {
                            return t1 << 1 ^ t1 >> 31;
                        }
                        function E(t1, e1) {
                            for(var r = t1.loadGeometry(), n = t1.type, i = 0, a = 0, o = r.length, s = 0; s < o; s++){
                                var l = r[s], c = 1;
                                1 === n && (c = l.length), e1.writeVarint(M(1, c));
                                for(var u = 3 === n ? l.length - 1 : l.length, h = 0; h < u; h++){
                                    1 === h && 1 !== n && e1.writeVarint(M(2, u - 1));
                                    var f = l[h].x - i, p = l[h].y - a;
                                    e1.writeVarint(S(f)), e1.writeVarint(S(p)), i += f, a += p;
                                }
                                3 === n && e1.writeVarint(M(7, 1));
                            }
                        }
                        function C(t1, e1) {
                            var r = typeof t1;
                            "string" === r ? e1.writeStringField(1, t1) : "boolean" === r ? e1.writeBooleanField(7, t1) : "number" === r && (t1 % 1 != 0 ? e1.writeDoubleField(3, t1) : t1 < 0 ? e1.writeSVarintField(6, t1) : e1.writeVarintField(5, t1));
                        }
                        d.exports = w, d.exports.fromVectorTileJs = w, d.exports.fromGeojsonVt = function(t1, e1) {
                            e1 = e1 || {};
                            var r = {};
                            for(var n in t1)r[n] = new b(t1[n].features, e1), r[n].name = n, r[n].version = e1.version, r[n].extent = e1.extent;
                            return w({
                                layers: r
                            });
                        }, d.exports.GeoJSONWrapper = b;
                        var L = d.exports, I = t1.bx(L);
                        const P = {
                            minZoom: 0,
                            maxZoom: 16,
                            minPoints: 2,
                            radius: 40,
                            extent: 512,
                            nodeSize: 64,
                            log: !1,
                            generateId: !1,
                            reduce: null,
                            map: (t1)=>t1
                        }, z = Math.fround || (O = new Float32Array(1), (t1)=>(O[0] = +t1, O[0]));
                        var O;
                        const D = 3, R = 5, F = 6;
                        class B {
                            constructor(t1){
                                this.options = Object.assign(Object.create(P), t1), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
                            }
                            load(t1) {
                                const { log: e1, minZoom: r, maxZoom: n } = this.options;
                                e1 && console.time("total time");
                                const i = `prepare ${t1.length} points`;
                                e1 && console.time(i), this.points = t1;
                                const a = [];
                                for(let e1 = 0; e1 < t1.length; e1++){
                                    const r = t1[e1];
                                    if (!r.geometry) continue;
                                    const [n, i] = r.geometry.coordinates, o = z(U(n)), s = z(V(i));
                                    a.push(o, s, 1 / 0, e1, -1, 1), this.options.reduce && a.push(0);
                                }
                                let o = this.trees[n + 1] = this._createTree(a);
                                e1 && console.timeEnd(i);
                                for(let t1 = n; t1 >= r; t1--){
                                    const r = +Date.now();
                                    o = this.trees[t1] = this._createTree(this._cluster(o, t1)), e1 && console.log("z%d: %d clusters in %dms", t1, o.numItems, +Date.now() - r);
                                }
                                return e1 && console.timeEnd("total time"), this;
                            }
                            getClusters(t1, e1) {
                                let r = ((t1[0] + 180) % 360 + 360) % 360 - 180;
                                const n = Math.max(-90, Math.min(90, t1[1]));
                                let i = 180 === t1[2] ? 180 : ((t1[2] + 180) % 360 + 360) % 360 - 180;
                                const a = Math.max(-90, Math.min(90, t1[3]));
                                if (t1[2] - t1[0] >= 360) r = -180, i = 180;
                                else if (r > i) {
                                    const t1 = this.getClusters([
                                        r,
                                        n,
                                        180,
                                        a
                                    ], e1), o = this.getClusters([
                                        -180,
                                        n,
                                        i,
                                        a
                                    ], e1);
                                    return t1.concat(o);
                                }
                                const o = this.trees[this._limitZoom(e1)], s = o.range(U(r), V(a), U(i), V(n)), l = o.data, c = [];
                                for (const t1 of s){
                                    const e1 = this.stride * t1;
                                    c.push(l[e1 + R] > 1 ? N(l, e1, this.clusterProps) : this.points[l[e1 + D]]);
                                }
                                return c;
                            }
                            getChildren(t1) {
                                const e1 = this._getOriginId(t1), r = this._getOriginZoom(t1), n = "No cluster with the specified id.", i = this.trees[r];
                                if (!i) throw new Error(n);
                                const a = i.data;
                                if (e1 * this.stride >= a.length) throw new Error(n);
                                const o = this.options.radius / (this.options.extent * Math.pow(2, r - 1)), s = a[e1 * this.stride], l = a[e1 * this.stride + 1], c = i.within(s, l, o), u = [];
                                for (const e1 of c){
                                    const r = e1 * this.stride;
                                    a[r + 4] === t1 && u.push(a[r + R] > 1 ? N(a, r, this.clusterProps) : this.points[a[r + D]]);
                                }
                                if (0 === u.length) throw new Error(n);
                                return u;
                            }
                            getLeaves(t1, e1, r) {
                                e1 = e1 || 10, r = r || 0;
                                const n = [];
                                return this._appendLeaves(n, t1, e1, r, 0), n;
                            }
                            getTile(t1, e1, r) {
                                const n = this.trees[this._limitZoom(t1)], i = Math.pow(2, t1), { extent: a, radius: o } = this.options, s = o / a, l = (r - s) / i, c = (r + 1 + s) / i, u = {
                                    features: []
                                };
                                return this._addTileFeatures(n.range((e1 - s) / i, l, (e1 + 1 + s) / i, c), n.data, e1, r, i, u), 0 === e1 && this._addTileFeatures(n.range(1 - s / i, l, 1, c), n.data, i, r, i, u), e1 === i - 1 && this._addTileFeatures(n.range(0, l, s / i, c), n.data, -1, r, i, u), u.features.length ? u : null;
                            }
                            getClusterExpansionZoom(t1) {
                                let e1 = this._getOriginZoom(t1) - 1;
                                for(; e1 <= this.options.maxZoom;){
                                    const r = this.getChildren(t1);
                                    if (e1++, 1 !== r.length) break;
                                    t1 = r[0].properties.cluster_id;
                                }
                                return e1;
                            }
                            _appendLeaves(t1, e1, r, n, i) {
                                const a = this.getChildren(e1);
                                for (const e1 of a){
                                    const a = e1.properties;
                                    if (a && a.cluster ? i + a.point_count <= n ? i += a.point_count : i = this._appendLeaves(t1, a.cluster_id, r, n, i) : i < n ? i++ : t1.push(e1), t1.length === r) break;
                                }
                                return i;
                            }
                            _createTree(e1) {
                                const r = new t1.aw(e1.length / this.stride | 0, this.options.nodeSize, Float32Array);
                                for(let t1 = 0; t1 < e1.length; t1 += this.stride)r.add(e1[t1], e1[t1 + 1]);
                                return r.finish(), r.data = e1, r;
                            }
                            _addTileFeatures(t1, e1, r, n, i, a) {
                                for (const o of t1){
                                    const t1 = o * this.stride, s = e1[t1 + R] > 1;
                                    let l, c, u;
                                    if (s) l = j(e1, t1, this.clusterProps), c = e1[t1], u = e1[t1 + 1];
                                    else {
                                        const r = this.points[e1[t1 + D]];
                                        l = r.properties;
                                        const [n, i] = r.geometry.coordinates;
                                        c = U(n), u = V(i);
                                    }
                                    const h = {
                                        type: 1,
                                        geometry: [
                                            [
                                                Math.round(this.options.extent * (c * i - r)),
                                                Math.round(this.options.extent * (u * i - n))
                                            ]
                                        ],
                                        tags: l
                                    };
                                    let f;
                                    f = s || this.options.generateId ? e1[t1 + D] : this.points[e1[t1 + D]].id, void 0 !== f && (h.id = f), a.features.push(h);
                                }
                            }
                            _limitZoom(t1) {
                                return Math.max(this.options.minZoom, Math.min(Math.floor(+t1), this.options.maxZoom + 1));
                            }
                            _cluster(t1, e1) {
                                const { radius: r, extent: n, reduce: i, minPoints: a } = this.options, o = r / (n * Math.pow(2, e1)), s = t1.data, l = [], c = this.stride;
                                for(let r = 0; r < s.length; r += c){
                                    if (s[r + 2] <= e1) continue;
                                    s[r + 2] = e1;
                                    const n = s[r], u = s[r + 1], h = t1.within(s[r], s[r + 1], o), f = s[r + R];
                                    let p = f;
                                    for (const t1 of h){
                                        const r = t1 * c;
                                        s[r + 2] > e1 && (p += s[r + R]);
                                    }
                                    if (p > f && p >= a) {
                                        let t1, a = n * f, o = u * f, d = -1;
                                        const m = ((r / c | 0) << 5) + (e1 + 1) + this.points.length;
                                        for (const n of h){
                                            const l = n * c;
                                            if (s[l + 2] <= e1) continue;
                                            s[l + 2] = e1;
                                            const u = s[l + R];
                                            a += s[l] * u, o += s[l + 1] * u, s[l + 4] = m, i && (t1 || (t1 = this._map(s, r, !0), d = this.clusterProps.length, this.clusterProps.push(t1)), i(t1, this._map(s, l)));
                                        }
                                        s[r + 4] = m, l.push(a / p, o / p, 1 / 0, m, -1, p), i && l.push(d);
                                    } else {
                                        for(let t1 = 0; t1 < c; t1++)l.push(s[r + t1]);
                                        if (p > 1) for (const t1 of h){
                                            const r = t1 * c;
                                            if (!(s[r + 2] <= e1)) {
                                                s[r + 2] = e1;
                                                for(let t1 = 0; t1 < c; t1++)l.push(s[r + t1]);
                                            }
                                        }
                                    }
                                }
                                return l;
                            }
                            _getOriginId(t1) {
                                return t1 - this.points.length >> 5;
                            }
                            _getOriginZoom(t1) {
                                return (t1 - this.points.length) % 32;
                            }
                            _map(t1, e1, r) {
                                if (t1[e1 + R] > 1) {
                                    const n = this.clusterProps[t1[e1 + F]];
                                    return r ? Object.assign({}, n) : n;
                                }
                                const n = this.points[t1[e1 + D]].properties, i = this.options.map(n);
                                return r && i === n ? Object.assign({}, i) : i;
                            }
                        }
                        function N(t1, e1, r) {
                            var n;
                            return {
                                type: "Feature",
                                id: t1[e1 + D],
                                properties: j(t1, e1, r),
                                geometry: {
                                    type: "Point",
                                    coordinates: [
                                        (n = t1[e1], 360 * (n - .5)),
                                        q(t1[e1 + 1])
                                    ]
                                }
                            };
                        }
                        function j(t1, e1, r) {
                            const n = t1[e1 + R], i = n >= 1e4 ? `${Math.round(n / 1e3)}k` : n >= 1e3 ? Math.round(n / 100) / 10 + "k" : n, a = t1[e1 + F], o = -1 === a ? {} : Object.assign({}, r[a]);
                            return Object.assign(o, {
                                cluster: !0,
                                cluster_id: t1[e1 + D],
                                point_count: n,
                                point_count_abbreviated: i
                            });
                        }
                        function U(t1) {
                            return t1 / 360 + .5;
                        }
                        function V(t1) {
                            const e1 = Math.sin(t1 * Math.PI / 180), r = .5 - .25 * Math.log((1 + e1) / (1 - e1)) / Math.PI;
                            return r < 0 ? 0 : r > 1 ? 1 : r;
                        }
                        function q(t1) {
                            const e1 = (180 - 360 * t1) * Math.PI / 180;
                            return 360 * Math.atan(Math.exp(e1)) / Math.PI - 90;
                        }
                        function H(t1, e1, r, n) {
                            let i = n;
                            const a = e1 + (r - e1 >> 1);
                            let o, s = r - e1;
                            const l = t1[e1], c = t1[e1 + 1], u = t1[r], h = t1[r + 1];
                            for(let n = e1 + 3; n < r; n += 3){
                                const e1 = G(t1[n], t1[n + 1], l, c, u, h);
                                if (e1 > i) o = n, i = e1;
                                else if (e1 === i) {
                                    const t1 = Math.abs(n - a);
                                    t1 < s && (o = n, s = t1);
                                }
                            }
                            i > n && (o - e1 > 3 && H(t1, e1, o, n), t1[o + 2] = i, r - o > 3 && H(t1, o, r, n));
                        }
                        function G(t1, e1, r, n, i, a) {
                            let o = i - r, s = a - n;
                            if (0 !== o || 0 !== s) {
                                const l = ((t1 - r) * o + (e1 - n) * s) / (o * o + s * s);
                                l > 1 ? (r = i, n = a) : l > 0 && (r += o * l, n += s * l);
                            }
                            return o = t1 - r, s = e1 - n, o * o + s * s;
                        }
                        function Z(t1, e1, r, n) {
                            const i = {
                                id: null == t1 ? null : t1,
                                type: e1,
                                geometry: r,
                                tags: n,
                                minX: 1 / 0,
                                minY: 1 / 0,
                                maxX: -1 / 0,
                                maxY: -1 / 0
                            };
                            if ("Point" === e1 || "MultiPoint" === e1 || "LineString" === e1) W(i, r);
                            else if ("Polygon" === e1) W(i, r[0]);
                            else if ("MultiLineString" === e1) for (const t1 of r)W(i, t1);
                            else if ("MultiPolygon" === e1) for (const t1 of r)W(i, t1[0]);
                            return i;
                        }
                        function W(t1, e1) {
                            for(let r = 0; r < e1.length; r += 3)t1.minX = Math.min(t1.minX, e1[r]), t1.minY = Math.min(t1.minY, e1[r + 1]), t1.maxX = Math.max(t1.maxX, e1[r]), t1.maxY = Math.max(t1.maxY, e1[r + 1]);
                        }
                        function Y(t1, e1, r, n) {
                            if (!e1.geometry) return;
                            const i = e1.geometry.coordinates;
                            if (i && 0 === i.length) return;
                            const a = e1.geometry.type, o = Math.pow(r.tolerance / ((1 << r.maxZoom) * r.extent), 2);
                            let s = [], l = e1.id;
                            if (r.promoteId ? l = e1.properties[r.promoteId] : r.generateId && (l = n || 0), "Point" === a) X(i, s);
                            else if ("MultiPoint" === a) for (const t1 of i)X(t1, s);
                            else if ("LineString" === a) $(i, s, o, !1);
                            else if ("MultiLineString" === a) {
                                if (r.lineMetrics) {
                                    for (const r of i)s = [], $(r, s, o, !1), t1.push(Z(l, "LineString", s, e1.properties));
                                    return;
                                }
                                J(i, s, o, !1);
                            } else if ("Polygon" === a) J(i, s, o, !0);
                            else {
                                if ("MultiPolygon" !== a) {
                                    if ("GeometryCollection" === a) {
                                        for (const i of e1.geometry.geometries)Y(t1, {
                                            id: l,
                                            geometry: i,
                                            properties: e1.properties
                                        }, r, n);
                                        return;
                                    }
                                    throw new Error("Input data is not a valid GeoJSON object.");
                                }
                                for (const t1 of i){
                                    const e1 = [];
                                    J(t1, e1, o, !0), s.push(e1);
                                }
                            }
                            t1.push(Z(l, a, s, e1.properties));
                        }
                        function X(t1, e1) {
                            e1.push(K(t1[0]), Q(t1[1]), 0);
                        }
                        function $(t1, e1, r, n) {
                            let i, a, o = 0;
                            for(let r = 0; r < t1.length; r++){
                                const s = K(t1[r][0]), l = Q(t1[r][1]);
                                e1.push(s, l, 0), r > 0 && (o += n ? (i * l - s * a) / 2 : Math.sqrt(Math.pow(s - i, 2) + Math.pow(l - a, 2))), i = s, a = l;
                            }
                            const s = e1.length - 3;
                            e1[2] = 1, H(e1, 0, s, r), e1[s + 2] = 1, e1.size = Math.abs(o), e1.start = 0, e1.end = e1.size;
                        }
                        function J(t1, e1, r, n) {
                            for(let i = 0; i < t1.length; i++){
                                const a = [];
                                $(t1[i], a, r, n), e1.push(a);
                            }
                        }
                        function K(t1) {
                            return t1 / 360 + .5;
                        }
                        function Q(t1) {
                            const e1 = Math.sin(t1 * Math.PI / 180), r = .5 - .25 * Math.log((1 + e1) / (1 - e1)) / Math.PI;
                            return r < 0 ? 0 : r > 1 ? 1 : r;
                        }
                        function tt(t1, e1, r, n, i, a, o, s) {
                            if (n /= e1, a >= (r /= e1) && o < n) return t1;
                            if (o < r || a >= n) return null;
                            const l = [];
                            for (const e1 of t1){
                                const t1 = e1.geometry;
                                let a = e1.type;
                                const o = 0 === i ? e1.minX : e1.minY, c = 0 === i ? e1.maxX : e1.maxY;
                                if (o >= r && c < n) {
                                    l.push(e1);
                                    continue;
                                }
                                if (c < r || o >= n) continue;
                                let u = [];
                                if ("Point" === a || "MultiPoint" === a) et(t1, u, r, n, i);
                                else if ("LineString" === a) rt(t1, u, r, n, i, !1, s.lineMetrics);
                                else if ("MultiLineString" === a) it(t1, u, r, n, i, !1);
                                else if ("Polygon" === a) it(t1, u, r, n, i, !0);
                                else if ("MultiPolygon" === a) for (const e1 of t1){
                                    const t1 = [];
                                    it(e1, t1, r, n, i, !0), t1.length && u.push(t1);
                                }
                                if (u.length) {
                                    if (s.lineMetrics && "LineString" === a) {
                                        for (const t1 of u)l.push(Z(e1.id, a, t1, e1.tags));
                                        continue;
                                    }
                                    "LineString" !== a && "MultiLineString" !== a || (1 === u.length ? (a = "LineString", u = u[0]) : a = "MultiLineString"), "Point" !== a && "MultiPoint" !== a || (a = 3 === u.length ? "Point" : "MultiPoint"), l.push(Z(e1.id, a, u, e1.tags));
                                }
                            }
                            return l.length ? l : null;
                        }
                        function et(t1, e1, r, n, i) {
                            for(let a = 0; a < t1.length; a += 3){
                                const o = t1[a + i];
                                o >= r && o <= n && at(e1, t1[a], t1[a + 1], t1[a + 2]);
                            }
                        }
                        function rt(t1, e1, r, n, i, a, o) {
                            let s = nt(t1);
                            const l = 0 === i ? ot : st;
                            let c, u, h = t1.start;
                            for(let f = 0; f < t1.length - 3; f += 3){
                                const p = t1[f], d = t1[f + 1], m = t1[f + 2], g = t1[f + 3], y = t1[f + 4], v = 0 === i ? p : d, x = 0 === i ? g : y;
                                let _ = !1;
                                o && (c = Math.sqrt(Math.pow(p - g, 2) + Math.pow(d - y, 2))), v < r ? x > r && (u = l(s, p, d, g, y, r), o && (s.start = h + c * u)) : v > n ? x < n && (u = l(s, p, d, g, y, n), o && (s.start = h + c * u)) : at(s, p, d, m), x < r && v >= r && (u = l(s, p, d, g, y, r), _ = !0), x > n && v <= n && (u = l(s, p, d, g, y, n), _ = !0), !a && _ && (o && (s.end = h + c * u), e1.push(s), s = nt(t1)), o && (h += c);
                            }
                            let f = t1.length - 3;
                            const p = t1[f], d = t1[f + 1], m = t1[f + 2], g = 0 === i ? p : d;
                            g >= r && g <= n && at(s, p, d, m), f = s.length - 3, a && f >= 3 && (s[f] !== s[0] || s[f + 1] !== s[1]) && at(s, s[0], s[1], s[2]), s.length && e1.push(s);
                        }
                        function nt(t1) {
                            const e1 = [];
                            return e1.size = t1.size, e1.start = t1.start, e1.end = t1.end, e1;
                        }
                        function it(t1, e1, r, n, i, a) {
                            for (const o of t1)rt(o, e1, r, n, i, a, !1);
                        }
                        function at(t1, e1, r, n) {
                            t1.push(e1, r, n);
                        }
                        function ot(t1, e1, r, n, i, a) {
                            const o = (a - e1) / (n - e1);
                            return at(t1, a, r + (i - r) * o, 1), o;
                        }
                        function st(t1, e1, r, n, i, a) {
                            const o = (a - r) / (i - r);
                            return at(t1, e1 + (n - e1) * o, a, 1), o;
                        }
                        function lt(t1, e1) {
                            const r = [];
                            for(let n = 0; n < t1.length; n++){
                                const i = t1[n], a = i.type;
                                let o;
                                if ("Point" === a || "MultiPoint" === a || "LineString" === a) o = ct(i.geometry, e1);
                                else if ("MultiLineString" === a || "Polygon" === a) {
                                    o = [];
                                    for (const t1 of i.geometry)o.push(ct(t1, e1));
                                } else if ("MultiPolygon" === a) {
                                    o = [];
                                    for (const t1 of i.geometry){
                                        const r = [];
                                        for (const n of t1)r.push(ct(n, e1));
                                        o.push(r);
                                    }
                                }
                                r.push(Z(i.id, a, o, i.tags));
                            }
                            return r;
                        }
                        function ct(t1, e1) {
                            const r = [];
                            r.size = t1.size, void 0 !== t1.start && (r.start = t1.start, r.end = t1.end);
                            for(let n = 0; n < t1.length; n += 3)r.push(t1[n] + e1, t1[n + 1], t1[n + 2]);
                            return r;
                        }
                        function ut(t1, e1) {
                            if (t1.transformed) return t1;
                            const r = 1 << t1.z, n = t1.x, i = t1.y;
                            for (const a of t1.features){
                                const t1 = a.geometry, o = a.type;
                                if (a.geometry = [], 1 === o) for(let o = 0; o < t1.length; o += 2)a.geometry.push(ht(t1[o], t1[o + 1], e1, r, n, i));
                                else for(let o = 0; o < t1.length; o++){
                                    const s = [];
                                    for(let a = 0; a < t1[o].length; a += 2)s.push(ht(t1[o][a], t1[o][a + 1], e1, r, n, i));
                                    a.geometry.push(s);
                                }
                            }
                            return t1.transformed = !0, t1;
                        }
                        function ht(t1, e1, r, n, i, a) {
                            return [
                                Math.round(r * (t1 * n - i)),
                                Math.round(r * (e1 * n - a))
                            ];
                        }
                        function ft(t1, e1, r, n, i) {
                            const a = e1 === i.maxZoom ? 0 : i.tolerance / ((1 << e1) * i.extent), o = {
                                features: [],
                                numPoints: 0,
                                numSimplified: 0,
                                numFeatures: t1.length,
                                source: null,
                                x: r,
                                y: n,
                                z: e1,
                                transformed: !1,
                                minX: 2,
                                minY: 1,
                                maxX: -1,
                                maxY: 0
                            };
                            for (const e1 of t1)pt(o, e1, a, i);
                            return o;
                        }
                        function pt(t1, e1, r, n) {
                            const i = e1.geometry, a = e1.type, o = [];
                            if (t1.minX = Math.min(t1.minX, e1.minX), t1.minY = Math.min(t1.minY, e1.minY), t1.maxX = Math.max(t1.maxX, e1.maxX), t1.maxY = Math.max(t1.maxY, e1.maxY), "Point" === a || "MultiPoint" === a) for(let e1 = 0; e1 < i.length; e1 += 3)o.push(i[e1], i[e1 + 1]), t1.numPoints++, t1.numSimplified++;
                            else if ("LineString" === a) dt(o, i, t1, r, !1, !1);
                            else if ("MultiLineString" === a || "Polygon" === a) for(let e1 = 0; e1 < i.length; e1++)dt(o, i[e1], t1, r, "Polygon" === a, 0 === e1);
                            else if ("MultiPolygon" === a) for(let e1 = 0; e1 < i.length; e1++){
                                const n = i[e1];
                                for(let e1 = 0; e1 < n.length; e1++)dt(o, n[e1], t1, r, !0, 0 === e1);
                            }
                            if (o.length) {
                                let r = e1.tags || null;
                                if ("LineString" === a && n.lineMetrics) {
                                    r = {};
                                    for(const t1 in e1.tags)r[t1] = e1.tags[t1];
                                    r.mapbox_clip_start = i.start / i.size, r.mapbox_clip_end = i.end / i.size;
                                }
                                const s = {
                                    geometry: o,
                                    type: "Polygon" === a || "MultiPolygon" === a ? 3 : "LineString" === a || "MultiLineString" === a ? 2 : 1,
                                    tags: r
                                };
                                null !== e1.id && (s.id = e1.id), t1.features.push(s);
                            }
                        }
                        function dt(t1, e1, r, n, i, a) {
                            const o = n * n;
                            if (n > 0 && e1.size < (i ? o : n)) return void (r.numPoints += e1.length / 3);
                            const s = [];
                            for(let t1 = 0; t1 < e1.length; t1 += 3)(0 === n || e1[t1 + 2] > o) && (r.numSimplified++, s.push(e1[t1], e1[t1 + 1])), r.numPoints++;
                            i && function(t1, e1) {
                                let r = 0;
                                for(let e1 = 0, n = t1.length, i = n - 2; e1 < n; i = e1, e1 += 2)r += (t1[e1] - t1[i]) * (t1[e1 + 1] + t1[i + 1]);
                                if (r > 0 === e1) for(let e1 = 0, r = t1.length; e1 < r / 2; e1 += 2){
                                    const n = t1[e1], i = t1[e1 + 1];
                                    t1[e1] = t1[r - 2 - e1], t1[e1 + 1] = t1[r - 1 - e1], t1[r - 2 - e1] = n, t1[r - 1 - e1] = i;
                                }
                            }(s, a), t1.push(s);
                        }
                        const mt = {
                            maxZoom: 14,
                            indexMaxZoom: 5,
                            indexMaxPoints: 1e5,
                            tolerance: 3,
                            extent: 4096,
                            buffer: 64,
                            lineMetrics: !1,
                            promoteId: null,
                            generateId: !1,
                            debug: 0
                        };
                        class gt {
                            constructor(t1, e1){
                                const r = (e1 = this.options = function(t1, e1) {
                                    for(const r in e1)t1[r] = e1[r];
                                    return t1;
                                }(Object.create(mt), e1)).debug;
                                if (r && console.time("preprocess data"), e1.maxZoom < 0 || e1.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
                                if (e1.promoteId && e1.generateId) throw new Error("promoteId and generateId cannot be used together.");
                                let n = function(t1, e1) {
                                    const r = [];
                                    if ("FeatureCollection" === t1.type) for(let n = 0; n < t1.features.length; n++)Y(r, t1.features[n], e1, n);
                                    else "Feature" === t1.type ? Y(r, t1, e1) : Y(r, {
                                        geometry: t1
                                    }, e1);
                                    return r;
                                }(t1, e1);
                                this.tiles = {}, this.tileCoords = [], r && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", e1.indexMaxZoom, e1.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), n = function(t1, e1) {
                                    const r = e1.buffer / e1.extent;
                                    let n = t1;
                                    const i = tt(t1, 1, -1 - r, r, 0, -1, 2, e1), a = tt(t1, 1, 1 - r, 2 + r, 0, -1, 2, e1);
                                    return (i || a) && (n = tt(t1, 1, -r, 1 + r, 0, -1, 2, e1) || [], i && (n = lt(i, 1).concat(n)), a && (n = n.concat(lt(a, -1)))), n;
                                }(n, e1), n.length && this.splitTile(n, 0, 0, 0), r && (n.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
                            }
                            splitTile(t1, e1, r, n, i, a, o) {
                                const s = [
                                    t1,
                                    e1,
                                    r,
                                    n
                                ], l = this.options, c = l.debug;
                                for(; s.length;){
                                    n = s.pop(), r = s.pop(), e1 = s.pop(), t1 = s.pop();
                                    const u = 1 << e1, h = yt(e1, r, n);
                                    let f = this.tiles[h];
                                    if (!f && (c > 1 && console.time("creation"), f = this.tiles[h] = ft(t1, e1, r, n, l), this.tileCoords.push({
                                        z: e1,
                                        x: r,
                                        y: n
                                    }), c)) {
                                        c > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", e1, r, n, f.numFeatures, f.numPoints, f.numSimplified), console.timeEnd("creation"));
                                        const t1 = `z${e1}`;
                                        this.stats[t1] = (this.stats[t1] || 0) + 1, this.total++;
                                    }
                                    if (f.source = t1, null == i) {
                                        if (e1 === l.indexMaxZoom || f.numPoints <= l.indexMaxPoints) continue;
                                    } else {
                                        if (e1 === l.maxZoom || e1 === i) continue;
                                        if (null != i) {
                                            const t1 = i - e1;
                                            if (r !== a >> t1 || n !== o >> t1) continue;
                                        }
                                    }
                                    if (f.source = null, 0 === t1.length) continue;
                                    c > 1 && console.time("clipping");
                                    const p = .5 * l.buffer / l.extent, d = .5 - p, m = .5 + p, g = 1 + p;
                                    let y = null, v = null, x = null, _ = null, b = tt(t1, u, r - p, r + m, 0, f.minX, f.maxX, l), w = tt(t1, u, r + d, r + g, 0, f.minX, f.maxX, l);
                                    t1 = null, b && (y = tt(b, u, n - p, n + m, 1, f.minY, f.maxY, l), v = tt(b, u, n + d, n + g, 1, f.minY, f.maxY, l), b = null), w && (x = tt(w, u, n - p, n + m, 1, f.minY, f.maxY, l), _ = tt(w, u, n + d, n + g, 1, f.minY, f.maxY, l), w = null), c > 1 && console.timeEnd("clipping"), s.push(y || [], e1 + 1, 2 * r, 2 * n), s.push(v || [], e1 + 1, 2 * r, 2 * n + 1), s.push(x || [], e1 + 1, 2 * r + 1, 2 * n), s.push(_ || [], e1 + 1, 2 * r + 1, 2 * n + 1);
                                }
                            }
                            getTile(t1, e1, r) {
                                t1 = +t1, e1 = +e1, r = +r;
                                const n = this.options, { extent: i, debug: a } = n;
                                if (t1 < 0 || t1 > 24) return null;
                                const o = 1 << t1, s = yt(t1, e1 = e1 + o & o - 1, r);
                                if (this.tiles[s]) return ut(this.tiles[s], i);
                                a > 1 && console.log("drilling down to z%d-%d-%d", t1, e1, r);
                                let l, c = t1, u = e1, h = r;
                                for(; !l && c > 0;)c--, u >>= 1, h >>= 1, l = this.tiles[yt(c, u, h)];
                                return l && l.source ? (a > 1 && (console.log("found parent tile z%d-%d-%d", c, u, h), console.time("drilling down")), this.splitTile(l.source, c, u, h, t1, e1, r), a > 1 && console.timeEnd("drilling down"), this.tiles[s] ? ut(this.tiles[s], i) : null) : null;
                            }
                        }
                        function yt(t1, e1, r) {
                            return 32 * ((1 << t1) * r + e1) + t1;
                        }
                        function vt(t1, e1) {
                            return e1 ? t1.properties[e1] : t1.id;
                        }
                        function xt(t1, e1) {
                            if (null == t1) return !0;
                            if ("Feature" === t1.type) return null != vt(t1, e1);
                            if ("FeatureCollection" === t1.type) {
                                const r = new Set;
                                for (const n of t1.features){
                                    const t1 = vt(n, e1);
                                    if (null == t1) return !1;
                                    if (r.has(t1)) return !1;
                                    r.add(t1);
                                }
                                return !0;
                            }
                            return !1;
                        }
                        function _t(t1, e1) {
                            const r = new Map;
                            if (null == t1) ;
                            else if ("Feature" === t1.type) r.set(vt(t1, e1), t1);
                            else for (const n of t1.features)r.set(vt(n, e1), n);
                            return r;
                        }
                        class bt extends a {
                            constructor(){
                                super(...arguments), this._dataUpdateable = new Map;
                            }
                            loadVectorTile(e1, r) {
                                return t1._(this, void 0, void 0, function*() {
                                    const t1 = e1.tileID.canonical;
                                    if (!this._geoJSONIndex) throw new Error("Unable to parse the data into a cluster or geojson");
                                    const r = this._geoJSONIndex.getTile(t1.z, t1.x, t1.y);
                                    if (!r) return null;
                                    const n = new p(r.features);
                                    let i = I(n);
                                    return 0 === i.byteOffset && i.byteLength === i.buffer.byteLength || (i = new Uint8Array(i)), {
                                        vectorTile: n,
                                        rawData: i.buffer
                                    };
                                });
                            }
                            loadData(e1) {
                                return t1._(this, void 0, void 0, function*() {
                                    var r;
                                    null === (r = this._pendingRequest) || void 0 === r || r.abort();
                                    const n = !!(e1 && e1.request && e1.request.collectResourceTiming) && new t1.bu(e1.request);
                                    this._pendingRequest = new AbortController;
                                    try {
                                        this._pendingData = this.loadAndProcessGeoJSON(e1, this._pendingRequest), this._geoJSONIndex = e1.cluster ? new B(function({ superclusterOptions: e1, clusterProperties: r }) {
                                            if (!r || !e1) return e1;
                                            const n = {}, i = {}, a = {
                                                accumulated: null,
                                                zoom: 0
                                            }, o = {
                                                properties: null
                                            }, s = Object.keys(r);
                                            for (const e1 of s){
                                                const [a, o] = r[e1], s = t1.bB(o), l = t1.bB("string" == typeof a ? [
                                                    a,
                                                    [
                                                        "accumulated"
                                                    ],
                                                    [
                                                        "get",
                                                        e1
                                                    ]
                                                ] : a);
                                                n[e1] = s.value, i[e1] = l.value;
                                            }
                                            return e1.map = (t1)=>{
                                                o.properties = t1;
                                                const e1 = {};
                                                for (const t1 of s)e1[t1] = n[t1].evaluate(a, o);
                                                return e1;
                                            }, e1.reduce = (t1, e1)=>{
                                                o.properties = e1;
                                                for (const e1 of s)a.accumulated = t1[e1], t1[e1] = i[e1].evaluate(a, o);
                                            }, e1;
                                        }(e1)).load((yield this._pendingData).features) : (i = yield this._pendingData, a = e1.geojsonVtOptions, new gt(i, a)), this.loaded = {};
                                        const r = {};
                                        if (n) {
                                            const t1 = n.finish();
                                            t1 && (r.resourceTiming = {}, r.resourceTiming[e1.source] = JSON.parse(JSON.stringify(t1)));
                                        }
                                        return r;
                                    } catch (e1) {
                                        if (delete this._pendingRequest, t1.bA(e1)) return {
                                            abandoned: !0
                                        };
                                        throw e1;
                                    }
                                    var i, a;
                                });
                            }
                            getData() {
                                return t1._(this, void 0, void 0, function*() {
                                    return this._pendingData;
                                });
                            }
                            reloadTile(t1) {
                                const e1 = this.loaded, r = t1.uid;
                                return e1 && e1[r] ? super.reloadTile(t1) : this.loadTile(t1);
                            }
                            loadAndProcessGeoJSON(e1, r) {
                                return t1._(this, void 0, void 0, function*() {
                                    let n = yield this.loadGeoJSON(e1, r);
                                    if (delete this._pendingRequest, "object" != typeof n) throw new Error(`Input data given to '${e1.source}' is not a valid GeoJSON object.`);
                                    if (u(n, !0), e1.filter) {
                                        const r = t1.bB(e1.filter, {
                                            type: "boolean",
                                            "property-type": "data-driven",
                                            overridable: !1,
                                            transition: !1
                                        });
                                        if ("error" === r.result) throw new Error(r.value.map((t1)=>`${t1.key}: ${t1.message}`).join(", "));
                                        const i = n.features.filter((t1)=>r.value.evaluate({
                                                zoom: 0
                                            }, t1));
                                        n = {
                                            type: "FeatureCollection",
                                            features: i
                                        };
                                    }
                                    return n;
                                });
                            }
                            loadGeoJSON(e1, r) {
                                return t1._(this, void 0, void 0, function*() {
                                    const { promoteId: n } = e1;
                                    if (e1.request) {
                                        const i = yield t1.h(e1.request, r);
                                        return this._dataUpdateable = xt(i.data, n) ? _t(i.data, n) : void 0, i.data;
                                    }
                                    if ("string" == typeof e1.data) try {
                                        const t1 = JSON.parse(e1.data);
                                        return this._dataUpdateable = xt(t1, n) ? _t(t1, n) : void 0, t1;
                                    } catch (t1) {
                                        throw new Error(`Input data given to '${e1.source}' is not a valid GeoJSON object.`);
                                    }
                                    if (!e1.dataDiff) throw new Error(`Input data given to '${e1.source}' is not a valid GeoJSON object.`);
                                    if (!this._dataUpdateable) throw new Error(`Cannot update existing geojson data in ${e1.source}`);
                                    return function(t1, e1, r) {
                                        var n, i, a, o;
                                        if (e1.removeAll && t1.clear(), e1.remove) for (const r of e1.remove)t1.delete(r);
                                        if (e1.add) for (const n of e1.add){
                                            const e1 = vt(n, r);
                                            null != e1 && t1.set(e1, n);
                                        }
                                        if (e1.update) for (const r of e1.update){
                                            let e1 = t1.get(r.id);
                                            if (null == e1) continue;
                                            const s = r.newGeometry || r.removeAllProperties, l = !r.removeAllProperties && ((null === (n = r.removeProperties) || void 0 === n ? void 0 : n.length) > 0 || (null === (i = r.addOrUpdateProperties) || void 0 === i ? void 0 : i.length) > 0);
                                            if ((s || l) && (e1 = Object.assign({}, e1), t1.set(r.id, e1), l && (e1.properties = Object.assign({}, e1.properties))), r.newGeometry && (e1.geometry = r.newGeometry), r.removeAllProperties) e1.properties = {};
                                            else if ((null === (a = r.removeProperties) || void 0 === a ? void 0 : a.length) > 0) for (const t1 of r.removeProperties)Object.prototype.hasOwnProperty.call(e1.properties, t1) && delete e1.properties[t1];
                                            if ((null === (o = r.addOrUpdateProperties) || void 0 === o ? void 0 : o.length) > 0) for (const { key: t1, value: n } of r.addOrUpdateProperties)e1.properties[t1] = n;
                                        }
                                    }(this._dataUpdateable, e1.dataDiff, n), {
                                        type: "FeatureCollection",
                                        features: Array.from(this._dataUpdateable.values())
                                    };
                                });
                            }
                            removeSource(e1) {
                                return t1._(this, void 0, void 0, function*() {
                                    this._pendingRequest && this._pendingRequest.abort();
                                });
                            }
                            getClusterExpansionZoom(t1) {
                                return this._geoJSONIndex.getClusterExpansionZoom(t1.clusterId);
                            }
                            getClusterChildren(t1) {
                                return this._geoJSONIndex.getChildren(t1.clusterId);
                            }
                            getClusterLeaves(t1) {
                                return this._geoJSONIndex.getLeaves(t1.clusterId, t1.limit, t1.offset);
                            }
                        }
                        class wt {
                            constructor(e1){
                                this.self = e1, this.actor = new t1.F(e1), this.layerIndexes = {}, this.availableImages = {}, this.workerSources = {}, this.demWorkerSources = {}, this.externalWorkerSourceTypes = {}, this.self.registerWorkerSource = (t1, e1)=>{
                                    if (this.externalWorkerSourceTypes[t1]) throw new Error(`Worker source with name "${t1}" already registered.`);
                                    this.externalWorkerSourceTypes[t1] = e1;
                                }, this.self.addProtocol = t1.bh, this.self.removeProtocol = t1.bi, this.self.registerRTLTextPlugin = (e1)=>{
                                    if (t1.bC.isParsed()) throw new Error("RTL text plugin already registered.");
                                    t1.bC.setMethods(e1);
                                }, this.actor.registerMessageHandler("LDT", (t1, e1)=>this._getDEMWorkerSource(t1, e1.source).loadTile(e1)), this.actor.registerMessageHandler("RDT", (e1, r)=>t1._(this, void 0, void 0, function*() {
                                        this._getDEMWorkerSource(e1, r.source).removeTile(r);
                                    })), this.actor.registerMessageHandler("GCEZ", (e1, r)=>t1._(this, void 0, void 0, function*() {
                                        return this._getWorkerSource(e1, r.type, r.source).getClusterExpansionZoom(r);
                                    })), this.actor.registerMessageHandler("GCC", (e1, r)=>t1._(this, void 0, void 0, function*() {
                                        return this._getWorkerSource(e1, r.type, r.source).getClusterChildren(r);
                                    })), this.actor.registerMessageHandler("GCL", (e1, r)=>t1._(this, void 0, void 0, function*() {
                                        return this._getWorkerSource(e1, r.type, r.source).getClusterLeaves(r);
                                    })), this.actor.registerMessageHandler("LD", (t1, e1)=>this._getWorkerSource(t1, e1.type, e1.source).loadData(e1)), this.actor.registerMessageHandler("GD", (t1, e1)=>this._getWorkerSource(t1, e1.type, e1.source).getData()), this.actor.registerMessageHandler("LT", (t1, e1)=>this._getWorkerSource(t1, e1.type, e1.source).loadTile(e1)), this.actor.registerMessageHandler("RT", (t1, e1)=>this._getWorkerSource(t1, e1.type, e1.source).reloadTile(e1)), this.actor.registerMessageHandler("AT", (t1, e1)=>this._getWorkerSource(t1, e1.type, e1.source).abortTile(e1)), this.actor.registerMessageHandler("RMT", (t1, e1)=>this._getWorkerSource(t1, e1.type, e1.source).removeTile(e1)), this.actor.registerMessageHandler("RS", (e1, r)=>t1._(this, void 0, void 0, function*() {
                                        if (!this.workerSources[e1] || !this.workerSources[e1][r.type] || !this.workerSources[e1][r.type][r.source]) return;
                                        const t1 = this.workerSources[e1][r.type][r.source];
                                        delete this.workerSources[e1][r.type][r.source], void 0 !== t1.removeSource && t1.removeSource(r);
                                    })), this.actor.registerMessageHandler("RM", (e1)=>t1._(this, void 0, void 0, function*() {
                                        delete this.layerIndexes[e1], delete this.availableImages[e1], delete this.workerSources[e1], delete this.demWorkerSources[e1];
                                    })), this.actor.registerMessageHandler("SR", (e1, r)=>t1._(this, void 0, void 0, function*() {
                                        this.referrer = r;
                                    })), this.actor.registerMessageHandler("SRPS", (t1, e1)=>this._syncRTLPluginState(t1, e1)), this.actor.registerMessageHandler("IS", (e1, r)=>t1._(this, void 0, void 0, function*() {
                                        this.self.importScripts(r);
                                    })), this.actor.registerMessageHandler("SI", (t1, e1)=>this._setImages(t1, e1)), this.actor.registerMessageHandler("UL", (e1, r)=>t1._(this, void 0, void 0, function*() {
                                        this._getLayerIndex(e1).update(r.layers, r.removedIds);
                                    })), this.actor.registerMessageHandler("SL", (e1, r)=>t1._(this, void 0, void 0, function*() {
                                        this._getLayerIndex(e1).replace(r);
                                    }));
                            }
                            _setImages(e1, r) {
                                return t1._(this, void 0, void 0, function*() {
                                    this.availableImages[e1] = r;
                                    for(const t1 in this.workerSources[e1]){
                                        const n = this.workerSources[e1][t1];
                                        for(const t1 in n)n[t1].availableImages = r;
                                    }
                                });
                            }
                            _syncRTLPluginState(e1, r) {
                                return t1._(this, void 0, void 0, function*() {
                                    if (t1.bC.isParsed()) return t1.bC.getState();
                                    if ("loading" !== r.pluginStatus) return t1.bC.setState(r), r;
                                    const e1 = r.pluginURL;
                                    if (this.self.importScripts(e1), t1.bC.isParsed()) {
                                        const r = {
                                            pluginStatus: "loaded",
                                            pluginURL: e1
                                        };
                                        return t1.bC.setState(r), r;
                                    }
                                    throw t1.bC.setState({
                                        pluginStatus: "error",
                                        pluginURL: ""
                                    }), new Error(`RTL Text Plugin failed to import scripts from ${e1}`);
                                });
                            }
                            _getAvailableImages(t1) {
                                let e1 = this.availableImages[t1];
                                return e1 || (e1 = []), e1;
                            }
                            _getLayerIndex(t1) {
                                let r = this.layerIndexes[t1];
                                return r || (r = this.layerIndexes[t1] = new e1), r;
                            }
                            _getWorkerSource(t1, e1, r) {
                                if (this.workerSources[t1] || (this.workerSources[t1] = {}), this.workerSources[t1][e1] || (this.workerSources[t1][e1] = {}), !this.workerSources[t1][e1][r]) {
                                    const n = {
                                        sendAsync: (e1, r)=>(e1.targetMapId = t1, this.actor.sendAsync(e1, r))
                                    };
                                    switch(e1){
                                        case "vector":
                                            this.workerSources[t1][e1][r] = new a(n, this._getLayerIndex(t1), this._getAvailableImages(t1));
                                            break;
                                        case "geojson":
                                            this.workerSources[t1][e1][r] = new bt(n, this._getLayerIndex(t1), this._getAvailableImages(t1));
                                            break;
                                        default:
                                            this.workerSources[t1][e1][r] = new this.externalWorkerSourceTypes[e1](n, this._getLayerIndex(t1), this._getAvailableImages(t1));
                                    }
                                }
                                return this.workerSources[t1][e1][r];
                            }
                            _getDEMWorkerSource(t1, e1) {
                                return this.demWorkerSources[t1] || (this.demWorkerSources[t1] = {}), this.demWorkerSources[t1][e1] || (this.demWorkerSources[t1][e1] = new o), this.demWorkerSources[t1][e1];
                            }
                        }
                        return t1.i(self) && (self.worker = new wt(self)), wt;
                    }), r("index", 0, function(t1, e1) {
                        var r = "4.5.2";
                        let n, i;
                        const a = {
                            now: "undefined" != typeof performance && performance && performance.now ? performance.now.bind(performance) : Date.now.bind(Date),
                            frameAsync (t1) {
                                return new Promise((r, n)=>{
                                    const i = requestAnimationFrame(r);
                                    t1.signal.addEventListener("abort", ()=>{
                                        cancelAnimationFrame(i), n(e1.c());
                                    });
                                });
                            },
                            getImageData (t1, e1 = 0) {
                                return this.getImageCanvasContext(t1).getImageData(-e1, -e1, t1.width + 2 * e1, t1.height + 2 * e1);
                            },
                            getImageCanvasContext (t1) {
                                const e1 = window.document.createElement("canvas"), r = e1.getContext("2d", {
                                    willReadFrequently: !0
                                });
                                if (!r) throw new Error("failed to create canvas 2d context");
                                return e1.width = t1.width, e1.height = t1.height, r.drawImage(t1, 0, 0, t1.width, t1.height), r;
                            },
                            resolveURL (t1) {
                                return n || (n = document.createElement("a")), n.href = t1, n.href;
                            },
                            hardwareConcurrency: "undefined" != typeof navigator && navigator.hardwareConcurrency || 4,
                            get prefersReducedMotion () {
                                return !!matchMedia && (null == i && (i = matchMedia("(prefers-reduced-motion: reduce)")), i.matches);
                            }
                        };
                        class o {
                            static testProp(t1) {
                                if (!o.docStyle) return t1[0];
                                for(let e1 = 0; e1 < t1.length; e1++)if (t1[e1] in o.docStyle) return t1[e1];
                                return t1[0];
                            }
                            static create(t1, e1, r) {
                                const n = window.document.createElement(t1);
                                return void 0 !== e1 && (n.className = e1), r && r.appendChild(n), n;
                            }
                            static createNS(t1, e1) {
                                return window.document.createElementNS(t1, e1);
                            }
                            static disableDrag() {
                                o.docStyle && o.selectProp && (o.userSelect = o.docStyle[o.selectProp], o.docStyle[o.selectProp] = "none");
                            }
                            static enableDrag() {
                                o.docStyle && o.selectProp && (o.docStyle[o.selectProp] = o.userSelect);
                            }
                            static setTransform(t1, e1) {
                                t1.style[o.transformProp] = e1;
                            }
                            static addEventListener(t1, e1, r, n = {}) {
                                "passive" in n ? t1.addEventListener(e1, r, n) : t1.addEventListener(e1, r, n.capture);
                            }
                            static removeEventListener(t1, e1, r, n = {}) {
                                "passive" in n ? t1.removeEventListener(e1, r, n) : t1.removeEventListener(e1, r, n.capture);
                            }
                            static suppressClickInternal(t1) {
                                t1.preventDefault(), t1.stopPropagation(), window.removeEventListener("click", o.suppressClickInternal, !0);
                            }
                            static suppressClick() {
                                window.addEventListener("click", o.suppressClickInternal, !0), window.setTimeout(()=>{
                                    window.removeEventListener("click", o.suppressClickInternal, !0);
                                }, 0);
                            }
                            static getScale(t1) {
                                const e1 = t1.getBoundingClientRect();
                                return {
                                    x: e1.width / t1.offsetWidth || 1,
                                    y: e1.height / t1.offsetHeight || 1,
                                    boundingClientRect: e1
                                };
                            }
                            static getPoint(t1, r, n) {
                                const i = r.boundingClientRect;
                                return new e1.P((n.clientX - i.left) / r.x - t1.clientLeft, (n.clientY - i.top) / r.y - t1.clientTop);
                            }
                            static mousePos(t1, e1) {
                                const r = o.getScale(t1);
                                return o.getPoint(t1, r, e1);
                            }
                            static touchPos(t1, e1) {
                                const r = [], n = o.getScale(t1);
                                for(let i = 0; i < e1.length; i++)r.push(o.getPoint(t1, n, e1[i]));
                                return r;
                            }
                            static mouseButton(t1) {
                                return t1.button;
                            }
                            static remove(t1) {
                                t1.parentNode && t1.parentNode.removeChild(t1);
                            }
                        }
                        o.docStyle = "undefined" != typeof window && window.document && window.document.documentElement.style, o.selectProp = o.testProp([
                            "userSelect",
                            "MozUserSelect",
                            "WebkitUserSelect",
                            "msUserSelect"
                        ]), o.transformProp = o.testProp([
                            "transform",
                            "WebkitTransform"
                        ]);
                        const s = {
                            supported: !1,
                            testSupport: function(t1) {
                                !u && c && (h ? f(t1) : l = t1);
                            }
                        };
                        let l, c, u = !1, h = !1;
                        function f(t1) {
                            const e1 = t1.createTexture();
                            t1.bindTexture(t1.TEXTURE_2D, e1);
                            try {
                                if (t1.texImage2D(t1.TEXTURE_2D, 0, t1.RGBA, t1.RGBA, t1.UNSIGNED_BYTE, c), t1.isContextLost()) return;
                                s.supported = !0;
                            } catch (t1) {}
                            t1.deleteTexture(e1), u = !0;
                        }
                        var p;
                        "undefined" != typeof document && (c = document.createElement("img"), c.onload = ()=>{
                            l && f(l), l = null, h = !0;
                        }, c.onerror = ()=>{
                            u = !0, l = null;
                        }, c.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA="), function(t1) {
                            let r, n, i, a;
                            t1.resetRequestQueue = ()=>{
                                r = [], n = 0, i = 0, a = {};
                            }, t1.addThrottleControl = (t1)=>{
                                const e1 = i++;
                                return a[e1] = t1, e1;
                            }, t1.removeThrottleControl = (t1)=>{
                                delete a[t1], l();
                            };
                            t1.getImage = (t1, n, i = !0)=>new Promise((a, o)=>{
                                    s.supported && (t1.headers || (t1.headers = {}), t1.headers.accept = "image/webp,*/*"), e1.e(t1, {
                                        type: "image"
                                    });
                                    const c = {
                                        abortController: n,
                                        requestParameters: t1,
                                        supportImageRefresh: i,
                                        state: "queued",
                                        onError: (t1)=>{
                                            o(t1);
                                        },
                                        onSuccess: (t1)=>{
                                            a(t1);
                                        }
                                    };
                                    r.push(c), l();
                                });
                            const o = (t1)=>e1._(this, void 0, void 0, function*() {
                                    t1.state = "running";
                                    const { requestParameters: r, supportImageRefresh: i, onError: a, onSuccess: o, abortController: s } = t1, u = !1 === i && !e1.i(self) && !e1.g(r.url) && (!r.headers || Object.keys(r.headers).reduce((t1, e1)=>t1 && "accept" === e1, !0));
                                    n++;
                                    const h = u ? c(r, s) : e1.m(r, s);
                                    try {
                                        const r = yield h;
                                        delete t1.abortController, t1.state = "completed", r.data instanceof HTMLImageElement || e1.b(r.data) ? o(r) : r.data && o({
                                            data: yield (f = r.data, "function" == typeof createImageBitmap ? e1.d(f) : e1.f(f)),
                                            cacheControl: r.cacheControl,
                                            expires: r.expires
                                        });
                                    } catch (e1) {
                                        delete t1.abortController, a(e1);
                                    } finally{
                                        n--, l();
                                    }
                                    var f;
                                }), l = ()=>{
                                const t1 = (()=>{
                                    for (const t1 of Object.keys(a))if (a[t1]()) return !0;
                                    return !1;
                                })() ? e1.a.MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME : e1.a.MAX_PARALLEL_IMAGE_REQUESTS;
                                for(let e1 = n; e1 < t1 && r.length > 0; e1++){
                                    const t1 = r.shift();
                                    t1.abortController.signal.aborted ? e1-- : o(t1);
                                }
                            }, c = (t1, r)=>new Promise((n, i)=>{
                                    const a = new Image, o = t1.url, s = t1.credentials;
                                    s && "include" === s ? a.crossOrigin = "use-credentials" : (s && "same-origin" === s || !e1.s(o)) && (a.crossOrigin = "anonymous"), r.signal.addEventListener("abort", ()=>{
                                        a.src = "", i(e1.c());
                                    }), a.fetchPriority = "high", a.onload = ()=>{
                                        a.onerror = a.onload = null, n({
                                            data: a
                                        });
                                    }, a.onerror = ()=>{
                                        a.onerror = a.onload = null, r.signal.aborted || i(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                                    }, a.src = o;
                                });
                        }(p || (p = {})), p.resetRequestQueue();
                        class d {
                            constructor(t1){
                                this._transformRequestFn = t1;
                            }
                            transformRequest(t1, e1) {
                                return this._transformRequestFn && this._transformRequestFn(t1, e1) || {
                                    url: t1
                                };
                            }
                            setTransformRequest(t1) {
                                this._transformRequestFn = t1;
                            }
                        }
                        function m(t1) {
                            var r = new e1.A(3);
                            return r[0] = t1[0], r[1] = t1[1], r[2] = t1[2], r;
                        }
                        var g, y = function(t1, e1, r) {
                            return t1[0] = e1[0] - r[0], t1[1] = e1[1] - r[1], t1[2] = e1[2] - r[2], t1;
                        };
                        g = new e1.A(3), e1.A != Float32Array && (g[0] = 0, g[1] = 0, g[2] = 0);
                        var v = function(t1) {
                            var e1 = t1[0], r = t1[1];
                            return e1 * e1 + r * r;
                        };
                        function x(t1) {
                            const e1 = [];
                            if ("string" == typeof t1) e1.push({
                                id: "default",
                                url: t1
                            });
                            else if (t1 && t1.length > 0) {
                                const r = [];
                                for (const { id: n, url: i } of t1){
                                    const t1 = `${n}${i}`;
                                    -1 === r.indexOf(t1) && (r.push(t1), e1.push({
                                        id: n,
                                        url: i
                                    }));
                                }
                            }
                            return e1;
                        }
                        function _(t1, e1, r) {
                            const n = t1.split("?");
                            return n[0] += `${e1}${r}`, n.join("?");
                        }
                        function b(t1, r, n, i) {
                            return e1._(this, void 0, void 0, function*() {
                                const o = x(t1), s = n > 1 ? "@2x" : "", l = {}, c = {};
                                for (const { id: t1, url: n } of o){
                                    const a = r.transformRequest(_(n, s, ".json"), "SpriteJSON");
                                    l[t1] = e1.h(a, i);
                                    const o = r.transformRequest(_(n, s, ".png"), "SpriteImage");
                                    c[t1] = p.getImage(o, i);
                                }
                                return yield Promise.all([
                                    ...Object.values(l),
                                    ...Object.values(c)
                                ]), function(t1, r) {
                                    return e1._(this, void 0, void 0, function*() {
                                        const e1 = {};
                                        for(const n in t1){
                                            e1[n] = {};
                                            const i = a.getImageCanvasContext((yield r[n]).data), o = (yield t1[n]).data;
                                            for(const t1 in o){
                                                const { width: r, height: a, x: s, y: l, sdf: c, pixelRatio: u, stretchX: h, stretchY: f, content: p, textFitWidth: d, textFitHeight: m } = o[t1], g = {
                                                    width: r,
                                                    height: a,
                                                    x: s,
                                                    y: l,
                                                    context: i
                                                };
                                                e1[n][t1] = {
                                                    data: null,
                                                    pixelRatio: u,
                                                    sdf: c,
                                                    stretchX: h,
                                                    stretchY: f,
                                                    content: p,
                                                    textFitWidth: d,
                                                    textFitHeight: m,
                                                    spriteData: g
                                                };
                                            }
                                        }
                                        return e1;
                                    });
                                }(l, c);
                            });
                        }
                        !function() {
                            var t1 = new e1.A(2);
                            e1.A != Float32Array && (t1[0] = 0, t1[1] = 0);
                        }();
                        class w {
                            constructor(t1, e1, r, n){
                                this.context = t1, this.format = r, this.texture = t1.gl.createTexture(), this.update(e1, n);
                            }
                            update(t1, r, n) {
                                const { width: i, height: a } = t1, o = !(this.size && this.size[0] === i && this.size[1] === a || n), { context: s } = this, { gl: l } = s;
                                if (this.useMipmap = Boolean(r && r.useMipmap), l.bindTexture(l.TEXTURE_2D, this.texture), s.pixelStoreUnpackFlipY.set(!1), s.pixelStoreUnpack.set(1), s.pixelStoreUnpackPremultiplyAlpha.set(this.format === l.RGBA && (!r || !1 !== r.premultiply)), o) this.size = [
                                    i,
                                    a
                                ], t1 instanceof HTMLImageElement || t1 instanceof HTMLCanvasElement || t1 instanceof HTMLVideoElement || t1 instanceof ImageData || e1.b(t1) ? l.texImage2D(l.TEXTURE_2D, 0, this.format, this.format, l.UNSIGNED_BYTE, t1) : l.texImage2D(l.TEXTURE_2D, 0, this.format, i, a, 0, this.format, l.UNSIGNED_BYTE, t1.data);
                                else {
                                    const { x: r, y: o } = n || {
                                        x: 0,
                                        y: 0
                                    };
                                    t1 instanceof HTMLImageElement || t1 instanceof HTMLCanvasElement || t1 instanceof HTMLVideoElement || t1 instanceof ImageData || e1.b(t1) ? l.texSubImage2D(l.TEXTURE_2D, 0, r, o, l.RGBA, l.UNSIGNED_BYTE, t1) : l.texSubImage2D(l.TEXTURE_2D, 0, r, o, i, a, l.RGBA, l.UNSIGNED_BYTE, t1.data);
                                }
                                this.useMipmap && this.isSizePowerOfTwo() && l.generateMipmap(l.TEXTURE_2D);
                            }
                            bind(t1, e1, r) {
                                const { context: n } = this, { gl: i } = n;
                                i.bindTexture(i.TEXTURE_2D, this.texture), r !== i.LINEAR_MIPMAP_NEAREST || this.isSizePowerOfTwo() || (r = i.LINEAR), t1 !== this.filter && (i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MAG_FILTER, t1), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MIN_FILTER, r || t1), this.filter = t1), e1 !== this.wrap && (i.texParameteri(i.TEXTURE_2D, i.TEXTURE_WRAP_S, e1), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_WRAP_T, e1), this.wrap = e1);
                            }
                            isSizePowerOfTwo() {
                                return this.size[0] === this.size[1] && Math.log(this.size[0]) / Math.LN2 % 1 == 0;
                            }
                            destroy() {
                                const { gl: t1 } = this.context;
                                t1.deleteTexture(this.texture), this.texture = null;
                            }
                        }
                        function T(t1) {
                            const { userImage: e1 } = t1;
                            return !!(e1 && e1.render && e1.render()) && (t1.data.replace(new Uint8Array(e1.data.buffer)), !0);
                        }
                        class k extends e1.E {
                            constructor(){
                                super(), this.images = {}, this.updatedImages = {}, this.callbackDispatchedThisFrame = {}, this.loaded = !1, this.requestors = [], this.patterns = {}, this.atlasImage = new e1.R({
                                    width: 1,
                                    height: 1
                                }), this.dirty = !0;
                            }
                            isLoaded() {
                                return this.loaded;
                            }
                            setLoaded(t1) {
                                if (this.loaded !== t1 && (this.loaded = t1, t1)) {
                                    for (const { ids: t1, promiseResolve: e1 } of this.requestors)e1(this._getImagesForIds(t1));
                                    this.requestors = [];
                                }
                            }
                            getImage(t1) {
                                const r = this.images[t1];
                                if (r && !r.data && r.spriteData) {
                                    const t1 = r.spriteData;
                                    r.data = new e1.R({
                                        width: t1.width,
                                        height: t1.height
                                    }, t1.context.getImageData(t1.x, t1.y, t1.width, t1.height).data), r.spriteData = null;
                                }
                                return r;
                            }
                            addImage(t1, e1) {
                                if (this.images[t1]) throw new Error(`Image id ${t1} already exist, use updateImage instead`);
                                this._validate(t1, e1) && (this.images[t1] = e1);
                            }
                            _validate(t1, r) {
                                let n = !0;
                                const i = r.data || r.spriteData;
                                return this._validateStretch(r.stretchX, i && i.width) || (this.fire(new e1.j(new Error(`Image "${t1}" has invalid "stretchX" value`))), n = !1), this._validateStretch(r.stretchY, i && i.height) || (this.fire(new e1.j(new Error(`Image "${t1}" has invalid "stretchY" value`))), n = !1), this._validateContent(r.content, r) || (this.fire(new e1.j(new Error(`Image "${t1}" has invalid "content" value`))), n = !1), n;
                            }
                            _validateStretch(t1, e1) {
                                if (!t1) return !0;
                                let r = 0;
                                for (const n of t1){
                                    if (n[0] < r || n[1] < n[0] || e1 < n[1]) return !1;
                                    r = n[1];
                                }
                                return !0;
                            }
                            _validateContent(t1, e1) {
                                if (!t1) return !0;
                                if (4 !== t1.length) return !1;
                                const r = e1.spriteData, n = r && r.width || e1.data.width, i = r && r.height || e1.data.height;
                                return !(t1[0] < 0 || n < t1[0] || t1[1] < 0 || i < t1[1] || t1[2] < 0 || n < t1[2] || t1[3] < 0 || i < t1[3] || t1[2] < t1[0] || t1[3] < t1[1]);
                            }
                            updateImage(t1, e1, r = !0) {
                                const n = this.getImage(t1);
                                if (r && (n.data.width !== e1.data.width || n.data.height !== e1.data.height)) throw new Error(`size mismatch between old image (${n.data.width}x${n.data.height}) and new image (${e1.data.width}x${e1.data.height}).`);
                                e1.version = n.version + 1, this.images[t1] = e1, this.updatedImages[t1] = !0;
                            }
                            removeImage(t1) {
                                const e1 = this.images[t1];
                                delete this.images[t1], delete this.patterns[t1], e1.userImage && e1.userImage.onRemove && e1.userImage.onRemove();
                            }
                            listImages() {
                                return Object.keys(this.images);
                            }
                            getImages(t1) {
                                return new Promise((e1, r)=>{
                                    let n = !0;
                                    if (!this.isLoaded()) for (const e1 of t1)this.images[e1] || (n = !1);
                                    this.isLoaded() || n ? e1(this._getImagesForIds(t1)) : this.requestors.push({
                                        ids: t1,
                                        promiseResolve: e1
                                    });
                                });
                            }
                            _getImagesForIds(t1) {
                                const r = {};
                                for (const n of t1){
                                    let t1 = this.getImage(n);
                                    t1 || (this.fire(new e1.k("styleimagemissing", {
                                        id: n
                                    })), t1 = this.getImage(n)), t1 ? r[n] = {
                                        data: t1.data.clone(),
                                        pixelRatio: t1.pixelRatio,
                                        sdf: t1.sdf,
                                        version: t1.version,
                                        stretchX: t1.stretchX,
                                        stretchY: t1.stretchY,
                                        content: t1.content,
                                        textFitWidth: t1.textFitWidth,
                                        textFitHeight: t1.textFitHeight,
                                        hasRenderCallback: Boolean(t1.userImage && t1.userImage.render)
                                    } : e1.w(`Image "${n}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);
                                }
                                return r;
                            }
                            getPixelSize() {
                                const { width: t1, height: e1 } = this.atlasImage;
                                return {
                                    width: t1,
                                    height: e1
                                };
                            }
                            getPattern(t1) {
                                const r = this.patterns[t1], n = this.getImage(t1);
                                if (!n) return null;
                                if (r && r.position.version === n.version) return r.position;
                                if (r) r.position.version = n.version;
                                else {
                                    const r = {
                                        w: n.data.width + 2,
                                        h: n.data.height + 2,
                                        x: 0,
                                        y: 0
                                    }, i = new e1.I(r, n);
                                    this.patterns[t1] = {
                                        bin: r,
                                        position: i
                                    };
                                }
                                return this._updatePatternAtlas(), this.patterns[t1].position;
                            }
                            bind(t1) {
                                const e1 = t1.gl;
                                this.atlasTexture ? this.dirty && (this.atlasTexture.update(this.atlasImage), this.dirty = !1) : this.atlasTexture = new w(t1, this.atlasImage, e1.RGBA), this.atlasTexture.bind(e1.LINEAR, e1.CLAMP_TO_EDGE);
                            }
                            _updatePatternAtlas() {
                                const t1 = [];
                                for(const e1 in this.patterns)t1.push(this.patterns[e1].bin);
                                const { w: r, h: n } = e1.p(t1), i = this.atlasImage;
                                i.resize({
                                    width: r || 1,
                                    height: n || 1
                                });
                                for(const t1 in this.patterns){
                                    const { bin: r } = this.patterns[t1], n = r.x + 1, a = r.y + 1, o = this.getImage(t1).data, s = o.width, l = o.height;
                                    e1.R.copy(o, i, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        x: n,
                                        y: a
                                    }, {
                                        width: s,
                                        height: l
                                    }), e1.R.copy(o, i, {
                                        x: 0,
                                        y: l - 1
                                    }, {
                                        x: n,
                                        y: a - 1
                                    }, {
                                        width: s,
                                        height: 1
                                    }), e1.R.copy(o, i, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        x: n,
                                        y: a + l
                                    }, {
                                        width: s,
                                        height: 1
                                    }), e1.R.copy(o, i, {
                                        x: s - 1,
                                        y: 0
                                    }, {
                                        x: n - 1,
                                        y: a
                                    }, {
                                        width: 1,
                                        height: l
                                    }), e1.R.copy(o, i, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        x: n + s,
                                        y: a
                                    }, {
                                        width: 1,
                                        height: l
                                    });
                                }
                                this.dirty = !0;
                            }
                            beginFrame() {
                                this.callbackDispatchedThisFrame = {};
                            }
                            dispatchRenderCallbacks(t1) {
                                for (const r of t1){
                                    if (this.callbackDispatchedThisFrame[r]) continue;
                                    this.callbackDispatchedThisFrame[r] = !0;
                                    const t1 = this.getImage(r);
                                    t1 || e1.w(`Image with ID: "${r}" was not found`), T(t1) && this.updateImage(r, t1);
                                }
                            }
                        }
                        const A = 1e20;
                        function M(t1, e1, r, n, i, a, o, s, l) {
                            for(let c = e1; c < e1 + n; c++)S(t1, r * a + c, a, i, o, s, l);
                            for(let c = r; c < r + i; c++)S(t1, c * a + e1, 1, n, o, s, l);
                        }
                        function S(t1, e1, r, n, i, a, o) {
                            a[0] = 0, o[0] = -A, o[1] = A, i[0] = t1[e1];
                            for(let s = 1, l = 0, c = 0; s < n; s++){
                                i[s] = t1[e1 + s * r];
                                const n = s * s;
                                do {
                                    const t1 = a[l];
                                    c = (i[s] - i[t1] + n - t1 * t1) / (s - t1) / 2;
                                }while (c <= o[l] && --l > -1);
                                l++, a[l] = s, o[l] = c, o[l + 1] = A;
                            }
                            for(let s = 0, l = 0; s < n; s++){
                                for(; o[l + 1] < s;)l++;
                                const n = a[l], c = s - n;
                                t1[e1 + s * r] = i[n] + c * c;
                            }
                        }
                        class E {
                            constructor(t1, e1){
                                this.requestManager = t1, this.localIdeographFontFamily = e1, this.entries = {};
                            }
                            setURL(t1) {
                                this.url = t1;
                            }
                            getGlyphs(t1) {
                                return e1._(this, void 0, void 0, function*() {
                                    const e1 = [];
                                    for(const r in t1)for (const n of t1[r])e1.push(this._getAndCacheGlyphsPromise(r, n));
                                    const r = yield Promise.all(e1), n = {};
                                    for (const { stack: t1, id: e1, glyph: i } of r)n[t1] || (n[t1] = {}), n[t1][e1] = i && {
                                        id: i.id,
                                        bitmap: i.bitmap.clone(),
                                        metrics: i.metrics
                                    };
                                    return n;
                                });
                            }
                            _getAndCacheGlyphsPromise(t1, r) {
                                return e1._(this, void 0, void 0, function*() {
                                    let e1 = this.entries[t1];
                                    e1 || (e1 = this.entries[t1] = {
                                        glyphs: {},
                                        requests: {},
                                        ranges: {}
                                    });
                                    let n = e1.glyphs[r];
                                    if (void 0 !== n) return {
                                        stack: t1,
                                        id: r,
                                        glyph: n
                                    };
                                    if (n = this._tinySDF(e1, t1, r), n) return e1.glyphs[r] = n, {
                                        stack: t1,
                                        id: r,
                                        glyph: n
                                    };
                                    const i = Math.floor(r / 256);
                                    if (256 * i > 65535) throw new Error("glyphs > 65535 not supported");
                                    if (e1.ranges[i]) return {
                                        stack: t1,
                                        id: r,
                                        glyph: n
                                    };
                                    if (!this.url) throw new Error("glyphsUrl is not set");
                                    if (!e1.requests[i]) {
                                        const r = E.loadGlyphRange(t1, i, this.url, this.requestManager);
                                        e1.requests[i] = r;
                                    }
                                    const a = yield e1.requests[i];
                                    for(const t1 in a)this._doesCharSupportLocalGlyph(+t1) || (e1.glyphs[+t1] = a[+t1]);
                                    return e1.ranges[i] = !0, {
                                        stack: t1,
                                        id: r,
                                        glyph: a[r] || null
                                    };
                                });
                            }
                            _doesCharSupportLocalGlyph(t1) {
                                return !!this.localIdeographFontFamily && (e1.u["CJK Unified Ideographs"](t1) || e1.u["Hangul Syllables"](t1) || e1.u.Hiragana(t1) || e1.u.Katakana(t1));
                            }
                            _tinySDF(t1, r, n) {
                                const i = this.localIdeographFontFamily;
                                if (!i) return;
                                if (!this._doesCharSupportLocalGlyph(n)) return;
                                let a = t1.tinySDF;
                                if (!a) {
                                    let e1 = "400";
                                    /bold/i.test(r) ? e1 = "900" : /medium/i.test(r) ? e1 = "500" : /light/i.test(r) && (e1 = "200"), a = t1.tinySDF = new E.TinySDF({
                                        fontSize: 48,
                                        buffer: 6,
                                        radius: 16,
                                        cutoff: .25,
                                        fontFamily: i,
                                        fontWeight: e1
                                    });
                                }
                                const o = a.draw(String.fromCharCode(n));
                                return {
                                    id: n,
                                    bitmap: new e1.o({
                                        width: o.width || 60,
                                        height: o.height || 60
                                    }, o.data),
                                    metrics: {
                                        width: o.glyphWidth / 2 || 24,
                                        height: o.glyphHeight / 2 || 24,
                                        left: o.glyphLeft / 2 + .5 || 0,
                                        top: o.glyphTop / 2 - 27.5 || -8,
                                        advance: o.glyphAdvance / 2 || 24,
                                        isDoubleResolution: !0
                                    }
                                };
                            }
                        }
                        E.loadGlyphRange = function(t1, r, n, i) {
                            return e1._(this, void 0, void 0, function*() {
                                const a = 256 * r, o = a + 255, s = i.transformRequest(n.replace("{fontstack}", t1).replace("{range}", `${a}-${o}`), "Glyphs"), l = yield e1.l(s, new AbortController);
                                if (!l || !l.data) throw new Error(`Could not load glyph range. range: ${r}, ${a}-${o}`);
                                const c = {};
                                for (const t1 of e1.n(l.data))c[t1.id] = t1;
                                return c;
                            });
                        }, E.TinySDF = class {
                            constructor({ fontSize: t1 = 24, buffer: e1 = 3, radius: r = 8, cutoff: n = .25, fontFamily: i = "sans-serif", fontWeight: a = "normal", fontStyle: o = "normal" } = {}){
                                this.buffer = e1, this.cutoff = n, this.radius = r;
                                const s = this.size = t1 + 4 * e1, l = this._createCanvas(s), c = this.ctx = l.getContext("2d", {
                                    willReadFrequently: !0
                                });
                                c.font = `${o} ${a} ${t1}px ${i}`, c.textBaseline = "alphabetic", c.textAlign = "left", c.fillStyle = "black", this.gridOuter = new Float64Array(s * s), this.gridInner = new Float64Array(s * s), this.f = new Float64Array(s), this.z = new Float64Array(s + 1), this.v = new Uint16Array(s);
                            }
                            _createCanvas(t1) {
                                const e1 = document.createElement("canvas");
                                return e1.width = e1.height = t1, e1;
                            }
                            draw(t1) {
                                const { width: e1, actualBoundingBoxAscent: r, actualBoundingBoxDescent: n, actualBoundingBoxLeft: i, actualBoundingBoxRight: a } = this.ctx.measureText(t1), o = Math.ceil(r), s = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(a - i))), l = Math.min(this.size - this.buffer, o + Math.ceil(n)), c = s + 2 * this.buffer, u = l + 2 * this.buffer, h = Math.max(c * u, 0), f = new Uint8ClampedArray(h), p = {
                                    data: f,
                                    width: c,
                                    height: u,
                                    glyphWidth: s,
                                    glyphHeight: l,
                                    glyphTop: o,
                                    glyphLeft: 0,
                                    glyphAdvance: e1
                                };
                                if (0 === s || 0 === l) return p;
                                const { ctx: d, buffer: m, gridInner: g, gridOuter: y } = this;
                                d.clearRect(m, m, s, l), d.fillText(t1, m, m + o);
                                const v = d.getImageData(m, m, s, l);
                                y.fill(A, 0, h), g.fill(0, 0, h);
                                for(let t1 = 0; t1 < l; t1++)for(let e1 = 0; e1 < s; e1++){
                                    const r = v.data[4 * (t1 * s + e1) + 3] / 255;
                                    if (0 === r) continue;
                                    const n = (t1 + m) * c + e1 + m;
                                    if (1 === r) y[n] = 0, g[n] = A;
                                    else {
                                        const t1 = .5 - r;
                                        y[n] = t1 > 0 ? t1 * t1 : 0, g[n] = t1 < 0 ? t1 * t1 : 0;
                                    }
                                }
                                M(y, 0, 0, c, u, c, this.f, this.v, this.z), M(g, m, m, s, l, c, this.f, this.v, this.z);
                                for(let t1 = 0; t1 < h; t1++){
                                    const e1 = Math.sqrt(y[t1]) - Math.sqrt(g[t1]);
                                    f[t1] = Math.round(255 - 255 * (e1 / this.radius + this.cutoff));
                                }
                                return p;
                            }
                        };
                        class C {
                            constructor(){
                                this.specification = e1.v.light.position;
                            }
                            possiblyEvaluate(t1, r) {
                                return e1.y(t1.expression.evaluate(r));
                            }
                            interpolate(t1, r, n) {
                                return {
                                    x: e1.z.number(t1.x, r.x, n),
                                    y: e1.z.number(t1.y, r.y, n),
                                    z: e1.z.number(t1.z, r.z, n)
                                };
                            }
                        }
                        const L = "-transition";
                        let I;
                        class P extends e1.E {
                            constructor(t1){
                                super(), I = I || new e1.q({
                                    anchor: new e1.D(e1.v.light.anchor),
                                    position: new C,
                                    color: new e1.D(e1.v.light.color),
                                    intensity: new e1.D(e1.v.light.intensity)
                                }), this._transitionable = new e1.T(I), this.setLight(t1), this._transitioning = this._transitionable.untransitioned();
                            }
                            getLight() {
                                return this._transitionable.serialize();
                            }
                            setLight(t1, r = {}) {
                                if (!this._validate(e1.r, t1, r)) for(const e1 in t1){
                                    const r = t1[e1];
                                    e1.endsWith(L) ? this._transitionable.setTransition(e1.slice(0, -11), r) : this._transitionable.setValue(e1, r);
                                }
                            }
                            updateTransitions(t1) {
                                this._transitioning = this._transitionable.transitioned(t1, this._transitioning);
                            }
                            hasTransition() {
                                return this._transitioning.hasTransition();
                            }
                            recalculate(t1) {
                                this.properties = this._transitioning.possiblyEvaluate(t1);
                            }
                            _validate(t1, r, n) {
                                return (!n || !1 !== n.validate) && e1.t(this, t1.call(e1.x, {
                                    value: r,
                                    style: {
                                        glyphs: !0,
                                        sprite: !0
                                    },
                                    styleSpec: e1.v
                                }));
                            }
                        }
                        const z = new e1.q({
                            "sky-color": new e1.D(e1.v.sky["sky-color"]),
                            "horizon-color": new e1.D(e1.v.sky["horizon-color"]),
                            "fog-color": new e1.D(e1.v.sky["fog-color"]),
                            "fog-ground-blend": new e1.D(e1.v.sky["fog-ground-blend"]),
                            "horizon-fog-blend": new e1.D(e1.v.sky["horizon-fog-blend"]),
                            "sky-horizon-blend": new e1.D(e1.v.sky["sky-horizon-blend"]),
                            "atmosphere-blend": new e1.D(e1.v.sky["atmosphere-blend"])
                        }), O = "-transition";
                        class D extends e1.E {
                            constructor(t1){
                                super(), this._transitionable = new e1.T(z), this.setSky(t1), this._transitioning = this._transitionable.untransitioned();
                            }
                            setSky(t1, r = {}) {
                                if (!this._validate(e1.B, t1, r)) for(const e1 in t1){
                                    const r = t1[e1];
                                    e1.endsWith(O) ? this._transitionable.setTransition(e1.slice(0, -11), r) : this._transitionable.setValue(e1, r);
                                }
                            }
                            getSky() {
                                return this._transitionable.serialize();
                            }
                            updateTransitions(t1) {
                                this._transitioning = this._transitionable.transitioned(t1, this._transitioning);
                            }
                            hasTransition() {
                                return this._transitioning.hasTransition();
                            }
                            recalculate(t1) {
                                this.properties = this._transitioning.possiblyEvaluate(t1);
                            }
                            _validate(t1, r, n = {}) {
                                return !1 !== (null == n ? void 0 : n.validate) && e1.t(this, t1.call(e1.x, e1.e({
                                    value: r,
                                    style: {
                                        glyphs: !0,
                                        sprite: !0
                                    },
                                    styleSpec: e1.v
                                })));
                            }
                            calculateFogBlendOpacity(t1) {
                                return t1 < 60 ? 0 : t1 < 70 ? (t1 - 60) / 10 : 1;
                            }
                        }
                        class R {
                            constructor(t1, e1){
                                this.width = t1, this.height = e1, this.nextRow = 0, this.data = new Uint8Array(this.width * this.height), this.dashEntry = {};
                            }
                            getDash(t1, e1) {
                                const r = t1.join(",") + String(e1);
                                return this.dashEntry[r] || (this.dashEntry[r] = this.addDash(t1, e1)), this.dashEntry[r];
                            }
                            getDashRanges(t1, e1, r) {
                                const n = [];
                                let i = t1.length % 2 == 1 ? -t1[t1.length - 1] * r : 0, a = t1[0] * r, o = !0;
                                n.push({
                                    left: i,
                                    right: a,
                                    isDash: o,
                                    zeroLength: 0 === t1[0]
                                });
                                let s = t1[0];
                                for(let e1 = 1; e1 < t1.length; e1++){
                                    o = !o;
                                    const l = t1[e1];
                                    i = s * r, s += l, a = s * r, n.push({
                                        left: i,
                                        right: a,
                                        isDash: o,
                                        zeroLength: 0 === l
                                    });
                                }
                                return n;
                            }
                            addRoundDash(t1, e1, r) {
                                const n = e1 / 2;
                                for(let e1 = -r; e1 <= r; e1++){
                                    const i = this.nextRow + r + e1, a = this.width * i;
                                    let o = 0, s = t1[o];
                                    for(let i = 0; i < this.width; i++){
                                        i / s.right > 1 && (s = t1[++o]);
                                        const l = Math.abs(i - s.left), c = Math.abs(i - s.right), u = Math.min(l, c);
                                        let h;
                                        const f = e1 / r * (n + 1);
                                        if (s.isDash) {
                                            const t1 = n - Math.abs(f);
                                            h = Math.sqrt(u * u + t1 * t1);
                                        } else h = n - Math.sqrt(u * u + f * f);
                                        this.data[a + i] = Math.max(0, Math.min(255, h + 128));
                                    }
                                }
                            }
                            addRegularDash(t1) {
                                for(let e1 = t1.length - 1; e1 >= 0; --e1){
                                    const r = t1[e1], n = t1[e1 + 1];
                                    r.zeroLength ? t1.splice(e1, 1) : n && n.isDash === r.isDash && (n.left = r.left, t1.splice(e1, 1));
                                }
                                const e1 = t1[0], r = t1[t1.length - 1];
                                e1.isDash === r.isDash && (e1.left = r.left - this.width, r.right = e1.right + this.width);
                                const n = this.width * this.nextRow;
                                let i = 0, a = t1[i];
                                for(let e1 = 0; e1 < this.width; e1++){
                                    e1 / a.right > 1 && (a = t1[++i]);
                                    const r = Math.abs(e1 - a.left), o = Math.abs(e1 - a.right), s = Math.min(r, o), l = a.isDash ? s : -s;
                                    this.data[n + e1] = Math.max(0, Math.min(255, l + 128));
                                }
                            }
                            addDash(t1, r) {
                                const n = r ? 7 : 0, i = 2 * n + 1;
                                if (this.nextRow + i > this.height) return e1.w("LineAtlas out of space"), null;
                                let a = 0;
                                for(let e1 = 0; e1 < t1.length; e1++)a += t1[e1];
                                if (0 !== a) {
                                    const e1 = this.width / a, i = this.getDashRanges(t1, this.width, e1);
                                    r ? this.addRoundDash(i, e1, n) : this.addRegularDash(i);
                                }
                                const o = {
                                    y: (this.nextRow + n + .5) / this.height,
                                    height: 2 * n / this.height,
                                    width: a
                                };
                                return this.nextRow += i, this.dirty = !0, o;
                            }
                            bind(t1) {
                                const e1 = t1.gl;
                                this.texture ? (e1.bindTexture(e1.TEXTURE_2D, this.texture), this.dirty && (this.dirty = !1, e1.texSubImage2D(e1.TEXTURE_2D, 0, 0, 0, this.width, this.height, e1.ALPHA, e1.UNSIGNED_BYTE, this.data))) : (this.texture = e1.createTexture(), e1.bindTexture(e1.TEXTURE_2D, this.texture), e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_WRAP_S, e1.REPEAT), e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_WRAP_T, e1.REPEAT), e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_MIN_FILTER, e1.LINEAR), e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_MAG_FILTER, e1.LINEAR), e1.texImage2D(e1.TEXTURE_2D, 0, e1.ALPHA, this.width, this.height, 0, e1.ALPHA, e1.UNSIGNED_BYTE, this.data));
                            }
                        }
                        const F = "maplibre_preloaded_worker_pool";
                        class B {
                            constructor(){
                                this.active = {};
                            }
                            acquire(t1) {
                                if (!this.workers) for(this.workers = []; this.workers.length < B.workerCount;)this.workers.push(new Worker(e1.a.WORKER_URL));
                                return this.active[t1] = !0, this.workers.slice();
                            }
                            release(t1) {
                                delete this.active[t1], 0 === this.numActive() && (this.workers.forEach((t1)=>{
                                    t1.terminate();
                                }), this.workers = null);
                            }
                            isPreloaded() {
                                return !!this.active[F];
                            }
                            numActive() {
                                return Object.keys(this.active).length;
                            }
                        }
                        const N = Math.floor(a.hardwareConcurrency / 2);
                        let j, U;
                        function V() {
                            return j || (j = new B), j;
                        }
                        B.workerCount = e1.C(globalThis) ? Math.max(Math.min(N, 3), 1) : 1;
                        class q {
                            constructor(t1, r){
                                this.workerPool = t1, this.actors = [], this.currentActor = 0, this.id = r;
                                const n = this.workerPool.acquire(r);
                                for(let t1 = 0; t1 < n.length; t1++){
                                    const i = n[t1], a = new e1.F(i, r);
                                    a.name = `Worker ${t1}`, this.actors.push(a);
                                }
                                if (!this.actors.length) throw new Error("No actors found");
                            }
                            broadcast(t1, e1) {
                                const r = [];
                                for (const n of this.actors)r.push(n.sendAsync({
                                    type: t1,
                                    data: e1
                                }));
                                return Promise.all(r);
                            }
                            getActor() {
                                return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
                            }
                            remove(t1 = !0) {
                                this.actors.forEach((t1)=>{
                                    t1.remove();
                                }), this.actors = [], t1 && this.workerPool.release(this.id);
                            }
                            registerMessageHandler(t1, e1) {
                                for (const r of this.actors)r.registerMessageHandler(t1, e1);
                            }
                        }
                        function H() {
                            return U || (U = new q(V(), e1.G), U.registerMessageHandler("GR", (t1, r, n)=>e1.m(r, n))), U;
                        }
                        function G(t1, r) {
                            const n = e1.H();
                            return e1.J(n, n, [
                                1,
                                1,
                                0
                            ]), e1.K(n, n, [
                                .5 * t1.width,
                                .5 * t1.height,
                                1
                            ]), e1.L(n, n, t1.calculatePosMatrix(r.toUnwrapped()));
                        }
                        function Z(t1, e1, r, n, i, a) {
                            const o = function(t1, e1, r) {
                                if (t1) for (const n of t1){
                                    const t1 = e1[n];
                                    if (t1 && t1.source === r && "fill-extrusion" === t1.type) return !0;
                                }
                                else for(const t1 in e1){
                                    const n = e1[t1];
                                    if (n.source === r && "fill-extrusion" === n.type) return !0;
                                }
                                return !1;
                            }(i && i.layers, e1, t1.id), s = a.maxPitchScaleFactor(), l = t1.tilesIn(n, s, o);
                            l.sort(W);
                            const c = [];
                            for (const n of l)c.push({
                                wrappedTileID: n.tileID.wrapped().key,
                                queryResults: n.tile.queryRenderedFeatures(e1, r, t1._state, n.queryGeometry, n.cameraQueryGeometry, n.scale, i, a, s, G(t1.transform, n.tileID))
                            });
                            const u = function(t1) {
                                const e1 = {}, r = {};
                                for (const n of t1){
                                    const t1 = n.queryResults, i = n.wrappedTileID, a = r[i] = r[i] || {};
                                    for(const r in t1){
                                        const n = t1[r], i = a[r] = a[r] || {}, o = e1[r] = e1[r] || [];
                                        for (const t1 of n)i[t1.featureIndex] || (i[t1.featureIndex] = !0, o.push(t1));
                                    }
                                }
                                return e1;
                            }(c);
                            for(const e1 in u)u[e1].forEach((e1)=>{
                                const r = e1.feature, n = t1.getFeatureState(r.layer["source-layer"], r.id);
                                r.source = r.layer.source, r.layer["source-layer"] && (r.sourceLayer = r.layer["source-layer"]), r.state = n;
                            });
                            return u;
                        }
                        function W(t1, e1) {
                            const r = t1.tileID, n = e1.tileID;
                            return r.overscaledZ - n.overscaledZ || r.canonical.y - n.canonical.y || r.wrap - n.wrap || r.canonical.x - n.canonical.x;
                        }
                        function Y(t1, r, n) {
                            return e1._(this, void 0, void 0, function*() {
                                let i = t1;
                                if (t1.url ? i = (yield e1.h(r.transformRequest(t1.url, "Source"), n)).data : yield a.frameAsync(n), !i) return null;
                                const o = e1.M(e1.e(i, t1), [
                                    "tiles",
                                    "minzoom",
                                    "maxzoom",
                                    "attribution",
                                    "bounds",
                                    "scheme",
                                    "tileSize",
                                    "encoding"
                                ]);
                                return "vector_layers" in i && i.vector_layers && (o.vectorLayerIds = i.vector_layers.map((t1)=>t1.id)), o;
                            });
                        }
                        class X {
                            constructor(t1, e1){
                                t1 && (e1 ? this.setSouthWest(t1).setNorthEast(e1) : Array.isArray(t1) && (4 === t1.length ? this.setSouthWest([
                                    t1[0],
                                    t1[1]
                                ]).setNorthEast([
                                    t1[2],
                                    t1[3]
                                ]) : this.setSouthWest(t1[0]).setNorthEast(t1[1])));
                            }
                            setNorthEast(t1) {
                                return this._ne = t1 instanceof e1.N ? new e1.N(t1.lng, t1.lat) : e1.N.convert(t1), this;
                            }
                            setSouthWest(t1) {
                                return this._sw = t1 instanceof e1.N ? new e1.N(t1.lng, t1.lat) : e1.N.convert(t1), this;
                            }
                            extend(t1) {
                                const r = this._sw, n = this._ne;
                                let i, a;
                                if (t1 instanceof e1.N) i = t1, a = t1;
                                else {
                                    if (!(t1 instanceof X)) {
                                        if (Array.isArray(t1)) {
                                            if (4 === t1.length || t1.every(Array.isArray)) {
                                                const e1 = t1;
                                                return this.extend(X.convert(e1));
                                            }
                                            {
                                                const r = t1;
                                                return this.extend(e1.N.convert(r));
                                            }
                                        }
                                        return t1 && ("lng" in t1 || "lon" in t1) && "lat" in t1 ? this.extend(e1.N.convert(t1)) : this;
                                    }
                                    if (i = t1._sw, a = t1._ne, !i || !a) return this;
                                }
                                return r || n ? (r.lng = Math.min(i.lng, r.lng), r.lat = Math.min(i.lat, r.lat), n.lng = Math.max(a.lng, n.lng), n.lat = Math.max(a.lat, n.lat)) : (this._sw = new e1.N(i.lng, i.lat), this._ne = new e1.N(a.lng, a.lat)), this;
                            }
                            getCenter() {
                                return new e1.N((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
                            }
                            getSouthWest() {
                                return this._sw;
                            }
                            getNorthEast() {
                                return this._ne;
                            }
                            getNorthWest() {
                                return new e1.N(this.getWest(), this.getNorth());
                            }
                            getSouthEast() {
                                return new e1.N(this.getEast(), this.getSouth());
                            }
                            getWest() {
                                return this._sw.lng;
                            }
                            getSouth() {
                                return this._sw.lat;
                            }
                            getEast() {
                                return this._ne.lng;
                            }
                            getNorth() {
                                return this._ne.lat;
                            }
                            toArray() {
                                return [
                                    this._sw.toArray(),
                                    this._ne.toArray()
                                ];
                            }
                            toString() {
                                return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
                            }
                            isEmpty() {
                                return !(this._sw && this._ne);
                            }
                            contains(t1) {
                                const { lng: r, lat: n } = e1.N.convert(t1), i = this._sw.lat <= n && n <= this._ne.lat;
                                let a = this._sw.lng <= r && r <= this._ne.lng;
                                return this._sw.lng > this._ne.lng && (a = this._sw.lng >= r && r >= this._ne.lng), i && a;
                            }
                            static convert(t1) {
                                return t1 instanceof X ? t1 : t1 ? new X(t1) : t1;
                            }
                            static fromLngLat(t1, r = 0) {
                                const n = 360 * r / 40075017, i = n / Math.cos(Math.PI / 180 * t1.lat);
                                return new X(new e1.N(t1.lng - i, t1.lat - n), new e1.N(t1.lng + i, t1.lat + n));
                            }
                        }
                        class $ {
                            constructor(t1, e1, r){
                                this.bounds = X.convert(this.validateBounds(t1)), this.minzoom = e1 || 0, this.maxzoom = r || 24;
                            }
                            validateBounds(t1) {
                                return Array.isArray(t1) && 4 === t1.length ? [
                                    Math.max(-180, t1[0]),
                                    Math.max(-90, t1[1]),
                                    Math.min(180, t1[2]),
                                    Math.min(90, t1[3])
                                ] : [
                                    -180,
                                    -90,
                                    180,
                                    90
                                ];
                            }
                            contains(t1) {
                                const r = Math.pow(2, t1.z), n = Math.floor(e1.O(this.bounds.getWest()) * r), i = Math.floor(e1.Q(this.bounds.getNorth()) * r), a = Math.ceil(e1.O(this.bounds.getEast()) * r), o = Math.ceil(e1.Q(this.bounds.getSouth()) * r);
                                return t1.x >= n && t1.x < a && t1.y >= i && t1.y < o;
                            }
                        }
                        class J extends e1.E {
                            constructor(t1, r, n, i){
                                if (super(), this.id = t1, this.dispatcher = n, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, e1.e(this, e1.M(r, [
                                    "url",
                                    "scheme",
                                    "tileSize",
                                    "promoteId"
                                ])), this._options = e1.e({
                                    type: "vector"
                                }, r), this._collectResourceTiming = r.collectResourceTiming, 512 !== this.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
                                this.setEventedParent(i);
                            }
                            load() {
                                return e1._(this, void 0, void 0, function*() {
                                    this._loaded = !1, this.fire(new e1.k("dataloading", {
                                        dataType: "source"
                                    })), this._tileJSONRequest = new AbortController;
                                    try {
                                        const t1 = yield Y(this._options, this.map._requestManager, this._tileJSONRequest);
                                        this._tileJSONRequest = null, this._loaded = !0, this.map.style.sourceCaches[this.id].clearTiles(), t1 && (e1.e(this, t1), t1.bounds && (this.tileBounds = new $(t1.bounds, this.minzoom, this.maxzoom)), this.fire(new e1.k("data", {
                                            dataType: "source",
                                            sourceDataType: "metadata"
                                        })), this.fire(new e1.k("data", {
                                            dataType: "source",
                                            sourceDataType: "content"
                                        })));
                                    } catch (t1) {
                                        this._tileJSONRequest = null, this.fire(new e1.j(t1));
                                    }
                                });
                            }
                            loaded() {
                                return this._loaded;
                            }
                            hasTile(t1) {
                                return !this.tileBounds || this.tileBounds.contains(t1.canonical);
                            }
                            onAdd(t1) {
                                this.map = t1, this.load();
                            }
                            setSourceProperty(t1) {
                                this._tileJSONRequest && this._tileJSONRequest.abort(), t1(), this.load();
                            }
                            setTiles(t1) {
                                return this.setSourceProperty(()=>{
                                    this._options.tiles = t1;
                                }), this;
                            }
                            setUrl(t1) {
                                return this.setSourceProperty(()=>{
                                    this.url = t1, this._options.url = t1;
                                }), this;
                            }
                            onRemove() {
                                this._tileJSONRequest && (this._tileJSONRequest.abort(), this._tileJSONRequest = null);
                            }
                            serialize() {
                                return e1.e({}, this._options);
                            }
                            loadTile(t1) {
                                return e1._(this, void 0, void 0, function*() {
                                    const e1 = t1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), r = {
                                        request: this.map._requestManager.transformRequest(e1, "Tile"),
                                        uid: t1.uid,
                                        tileID: t1.tileID,
                                        zoom: t1.tileID.overscaledZ,
                                        tileSize: this.tileSize * t1.tileID.overscaleFactor(),
                                        type: this.type,
                                        source: this.id,
                                        pixelRatio: this.map.getPixelRatio(),
                                        showCollisionBoxes: this.map.showCollisionBoxes,
                                        promoteId: this.promoteId
                                    };
                                    r.request.collectResourceTiming = this._collectResourceTiming;
                                    let n = "RT";
                                    if (t1.actor && "expired" !== t1.state) {
                                        if ("loading" === t1.state) return new Promise((e1, r)=>{
                                            t1.reloadPromise = {
                                                resolve: e1,
                                                reject: r
                                            };
                                        });
                                    } else t1.actor = this.dispatcher.getActor(), n = "LT";
                                    t1.abortController = new AbortController;
                                    try {
                                        const e1 = yield t1.actor.sendAsync({
                                            type: n,
                                            data: r
                                        }, t1.abortController);
                                        if (delete t1.abortController, t1.aborted) return;
                                        this._afterTileLoadWorkerResponse(t1, e1);
                                    } catch (e1) {
                                        if (delete t1.abortController, t1.aborted) return;
                                        if (e1 && 404 !== e1.status) throw e1;
                                        this._afterTileLoadWorkerResponse(t1, null);
                                    }
                                });
                            }
                            _afterTileLoadWorkerResponse(t1, e1) {
                                if (e1 && e1.resourceTiming && (t1.resourceTiming = e1.resourceTiming), e1 && this.map._refreshExpiredTiles && t1.setExpiryData(e1), t1.loadVectorData(e1, this.map.painter), t1.reloadPromise) {
                                    const e1 = t1.reloadPromise;
                                    t1.reloadPromise = null, this.loadTile(t1).then(e1.resolve).catch(e1.reject);
                                }
                            }
                            abortTile(t1) {
                                return e1._(this, void 0, void 0, function*() {
                                    t1.abortController && (t1.abortController.abort(), delete t1.abortController), t1.actor && (yield t1.actor.sendAsync({
                                        type: "AT",
                                        data: {
                                            uid: t1.uid,
                                            type: this.type,
                                            source: this.id
                                        }
                                    }));
                                });
                            }
                            unloadTile(t1) {
                                return e1._(this, void 0, void 0, function*() {
                                    t1.unloadVectorData(), t1.actor && (yield t1.actor.sendAsync({
                                        type: "RMT",
                                        data: {
                                            uid: t1.uid,
                                            type: this.type,
                                            source: this.id
                                        }
                                    }));
                                });
                            }
                            hasTransition() {
                                return !1;
                            }
                        }
                        class K extends e1.E {
                            constructor(t1, r, n, i){
                                super(), this.id = t1, this.dispatcher = n, this.setEventedParent(i), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._options = e1.e({
                                    type: "raster"
                                }, r), e1.e(this, e1.M(r, [
                                    "url",
                                    "scheme",
                                    "tileSize"
                                ]));
                            }
                            load() {
                                return e1._(this, void 0, void 0, function*() {
                                    this._loaded = !1, this.fire(new e1.k("dataloading", {
                                        dataType: "source"
                                    })), this._tileJSONRequest = new AbortController;
                                    try {
                                        const t1 = yield Y(this._options, this.map._requestManager, this._tileJSONRequest);
                                        this._tileJSONRequest = null, this._loaded = !0, t1 && (e1.e(this, t1), t1.bounds && (this.tileBounds = new $(t1.bounds, this.minzoom, this.maxzoom)), this.fire(new e1.k("data", {
                                            dataType: "source",
                                            sourceDataType: "metadata"
                                        })), this.fire(new e1.k("data", {
                                            dataType: "source",
                                            sourceDataType: "content"
                                        })));
                                    } catch (t1) {
                                        this._tileJSONRequest = null, this.fire(new e1.j(t1));
                                    }
                                });
                            }
                            loaded() {
                                return this._loaded;
                            }
                            onAdd(t1) {
                                this.map = t1, this.load();
                            }
                            onRemove() {
                                this._tileJSONRequest && (this._tileJSONRequest.abort(), this._tileJSONRequest = null);
                            }
                            setSourceProperty(t1) {
                                this._tileJSONRequest && (this._tileJSONRequest.abort(), this._tileJSONRequest = null), t1(), this.load();
                            }
                            setTiles(t1) {
                                return this.setSourceProperty(()=>{
                                    this._options.tiles = t1;
                                }), this;
                            }
                            setUrl(t1) {
                                return this.setSourceProperty(()=>{
                                    this.url = t1, this._options.url = t1;
                                }), this;
                            }
                            serialize() {
                                return e1.e({}, this._options);
                            }
                            hasTile(t1) {
                                return !this.tileBounds || this.tileBounds.contains(t1.canonical);
                            }
                            loadTile(t1) {
                                return e1._(this, void 0, void 0, function*() {
                                    const e1 = t1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme);
                                    t1.abortController = new AbortController;
                                    try {
                                        const r = yield p.getImage(this.map._requestManager.transformRequest(e1, "Tile"), t1.abortController, this.map._refreshExpiredTiles);
                                        if (delete t1.abortController, t1.aborted) return void (t1.state = "unloaded");
                                        if (r && r.data) {
                                            this.map._refreshExpiredTiles && r.cacheControl && r.expires && t1.setExpiryData({
                                                cacheControl: r.cacheControl,
                                                expires: r.expires
                                            });
                                            const e1 = this.map.painter.context, n = e1.gl, i = r.data;
                                            t1.texture = this.map.painter.getTileTexture(i.width), t1.texture ? t1.texture.update(i, {
                                                useMipmap: !0
                                            }) : (t1.texture = new w(e1, i, n.RGBA, {
                                                useMipmap: !0
                                            }), t1.texture.bind(n.LINEAR, n.CLAMP_TO_EDGE, n.LINEAR_MIPMAP_NEAREST)), t1.state = "loaded";
                                        }
                                    } catch (e1) {
                                        if (delete t1.abortController, t1.aborted) t1.state = "unloaded";
                                        else if (e1) throw t1.state = "errored", e1;
                                    }
                                });
                            }
                            abortTile(t1) {
                                return e1._(this, void 0, void 0, function*() {
                                    t1.abortController && (t1.abortController.abort(), delete t1.abortController);
                                });
                            }
                            unloadTile(t1) {
                                return e1._(this, void 0, void 0, function*() {
                                    t1.texture && this.map.painter.saveTileTexture(t1.texture);
                                });
                            }
                            hasTransition() {
                                return !1;
                            }
                        }
                        class Q extends K {
                            constructor(t1, r, n, i){
                                super(t1, r, n, i), this.type = "raster-dem", this.maxzoom = 22, this._options = e1.e({
                                    type: "raster-dem"
                                }, r), this.encoding = r.encoding || "mapbox", this.redFactor = r.redFactor, this.greenFactor = r.greenFactor, this.blueFactor = r.blueFactor, this.baseShift = r.baseShift;
                            }
                            loadTile(t1) {
                                return e1._(this, void 0, void 0, function*() {
                                    const r = t1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), n = this.map._requestManager.transformRequest(r, "Tile");
                                    t1.neighboringTiles = this._getNeighboringTiles(t1.tileID), t1.abortController = new AbortController;
                                    try {
                                        const r = yield p.getImage(n, t1.abortController, this.map._refreshExpiredTiles);
                                        if (delete t1.abortController, t1.aborted) return void (t1.state = "unloaded");
                                        if (r && r.data) {
                                            const n = r.data;
                                            this.map._refreshExpiredTiles && r.cacheControl && r.expires && t1.setExpiryData({
                                                cacheControl: r.cacheControl,
                                                expires: r.expires
                                            });
                                            const i = e1.b(n) && e1.U() ? n : yield this.readImageNow(n), a = {
                                                type: this.type,
                                                uid: t1.uid,
                                                source: this.id,
                                                rawImageData: i,
                                                encoding: this.encoding,
                                                redFactor: this.redFactor,
                                                greenFactor: this.greenFactor,
                                                blueFactor: this.blueFactor,
                                                baseShift: this.baseShift
                                            };
                                            if (!t1.actor || "expired" === t1.state) {
                                                t1.actor = this.dispatcher.getActor();
                                                const e1 = yield t1.actor.sendAsync({
                                                    type: "LDT",
                                                    data: a
                                                });
                                                t1.dem = e1, t1.needsHillshadePrepare = !0, t1.needsTerrainPrepare = !0, t1.state = "loaded";
                                            }
                                        }
                                    } catch (e1) {
                                        if (delete t1.abortController, t1.aborted) t1.state = "unloaded";
                                        else if (e1) throw t1.state = "errored", e1;
                                    }
                                });
                            }
                            readImageNow(t1) {
                                return e1._(this, void 0, void 0, function*() {
                                    if ("undefined" != typeof VideoFrame && e1.V()) {
                                        const r = t1.width + 2, n = t1.height + 2;
                                        try {
                                            return new e1.R({
                                                width: r,
                                                height: n
                                            }, (yield e1.W(t1, -1, -1, r, n)));
                                        } catch (t1) {}
                                    }
                                    return a.getImageData(t1, 1);
                                });
                            }
                            _getNeighboringTiles(t1) {
                                const r = t1.canonical, n = Math.pow(2, r.z), i = (r.x - 1 + n) % n, a = 0 === r.x ? t1.wrap - 1 : t1.wrap, o = (r.x + 1 + n) % n, s = r.x + 1 === n ? t1.wrap + 1 : t1.wrap, l = {};
                                return l[new e1.S(t1.overscaledZ, a, r.z, i, r.y).key] = {
                                    backfilled: !1
                                }, l[new e1.S(t1.overscaledZ, s, r.z, o, r.y).key] = {
                                    backfilled: !1
                                }, r.y > 0 && (l[new e1.S(t1.overscaledZ, a, r.z, i, r.y - 1).key] = {
                                    backfilled: !1
                                }, l[new e1.S(t1.overscaledZ, t1.wrap, r.z, r.x, r.y - 1).key] = {
                                    backfilled: !1
                                }, l[new e1.S(t1.overscaledZ, s, r.z, o, r.y - 1).key] = {
                                    backfilled: !1
                                }), r.y + 1 < n && (l[new e1.S(t1.overscaledZ, a, r.z, i, r.y + 1).key] = {
                                    backfilled: !1
                                }, l[new e1.S(t1.overscaledZ, t1.wrap, r.z, r.x, r.y + 1).key] = {
                                    backfilled: !1
                                }, l[new e1.S(t1.overscaledZ, s, r.z, o, r.y + 1).key] = {
                                    backfilled: !1
                                }), l;
                            }
                            unloadTile(t1) {
                                return e1._(this, void 0, void 0, function*() {
                                    t1.demTexture && this.map.painter.saveTileTexture(t1.demTexture), t1.fbo && (t1.fbo.destroy(), delete t1.fbo), t1.dem && delete t1.dem, delete t1.neighboringTiles, t1.state = "unloaded", t1.actor && (yield t1.actor.sendAsync({
                                        type: "RDT",
                                        data: {
                                            type: this.type,
                                            uid: t1.uid,
                                            source: this.id
                                        }
                                    }));
                                });
                            }
                        }
                        class tt extends e1.E {
                            constructor(t1, r, n, i){
                                super(), this.id = t1, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._removed = !1, this._pendingLoads = 0, this.actor = n.getActor(), this.setEventedParent(i), this._data = r.data, this._options = e1.e({}, r), this._collectResourceTiming = r.collectResourceTiming, void 0 !== r.maxzoom && (this.maxzoom = r.maxzoom), r.type && (this.type = r.type), r.attribution && (this.attribution = r.attribution), this.promoteId = r.promoteId;
                                const a = e1.X / this.tileSize;
                                this.workerOptions = e1.e({
                                    source: this.id,
                                    cluster: r.cluster || !1,
                                    geojsonVtOptions: {
                                        buffer: (void 0 !== r.buffer ? r.buffer : 128) * a,
                                        tolerance: (void 0 !== r.tolerance ? r.tolerance : .375) * a,
                                        extent: e1.X,
                                        maxZoom: this.maxzoom,
                                        lineMetrics: r.lineMetrics || !1,
                                        generateId: r.generateId || !1
                                    },
                                    superclusterOptions: {
                                        maxZoom: void 0 !== r.clusterMaxZoom ? r.clusterMaxZoom : this.maxzoom - 1,
                                        minPoints: Math.max(2, r.clusterMinPoints || 2),
                                        extent: e1.X,
                                        radius: (r.clusterRadius || 50) * a,
                                        log: !1,
                                        generateId: r.generateId || !1
                                    },
                                    clusterProperties: r.clusterProperties,
                                    filter: r.filter
                                }, r.workerOptions), "string" == typeof this.promoteId && (this.workerOptions.promoteId = this.promoteId);
                            }
                            load() {
                                return e1._(this, void 0, void 0, function*() {
                                    yield this._updateWorkerData();
                                });
                            }
                            onAdd(t1) {
                                this.map = t1, this.load();
                            }
                            setData(t1) {
                                return this._data = t1, this._updateWorkerData(), this;
                            }
                            updateData(t1) {
                                return this._updateWorkerData(t1), this;
                            }
                            getData() {
                                return e1._(this, void 0, void 0, function*() {
                                    const t1 = e1.e({
                                        type: this.type
                                    }, this.workerOptions);
                                    return this.actor.sendAsync({
                                        type: "GD",
                                        data: t1
                                    });
                                });
                            }
                            setClusterOptions(t1) {
                                return this.workerOptions.cluster = t1.cluster, t1 && (void 0 !== t1.clusterRadius && (this.workerOptions.superclusterOptions.radius = t1.clusterRadius), void 0 !== t1.clusterMaxZoom && (this.workerOptions.superclusterOptions.maxZoom = t1.clusterMaxZoom)), this._updateWorkerData(), this;
                            }
                            getClusterExpansionZoom(t1) {
                                return this.actor.sendAsync({
                                    type: "GCEZ",
                                    data: {
                                        type: this.type,
                                        clusterId: t1,
                                        source: this.id
                                    }
                                });
                            }
                            getClusterChildren(t1) {
                                return this.actor.sendAsync({
                                    type: "GCC",
                                    data: {
                                        type: this.type,
                                        clusterId: t1,
                                        source: this.id
                                    }
                                });
                            }
                            getClusterLeaves(t1, e1, r) {
                                return this.actor.sendAsync({
                                    type: "GCL",
                                    data: {
                                        type: this.type,
                                        source: this.id,
                                        clusterId: t1,
                                        limit: e1,
                                        offset: r
                                    }
                                });
                            }
                            _updateWorkerData(t1) {
                                return e1._(this, void 0, void 0, function*() {
                                    const r = e1.e({
                                        type: this.type
                                    }, this.workerOptions);
                                    t1 ? r.dataDiff = t1 : "string" == typeof this._data ? (r.request = this.map._requestManager.transformRequest(a.resolveURL(this._data), "Source"), r.request.collectResourceTiming = this._collectResourceTiming) : r.data = JSON.stringify(this._data), this._pendingLoads++, this.fire(new e1.k("dataloading", {
                                        dataType: "source"
                                    }));
                                    try {
                                        const t1 = yield this.actor.sendAsync({
                                            type: "LD",
                                            data: r
                                        });
                                        if (this._pendingLoads--, this._removed || t1.abandoned) return void this.fire(new e1.k("dataabort", {
                                            dataType: "source"
                                        }));
                                        let n = null;
                                        t1.resourceTiming && t1.resourceTiming[this.id] && (n = t1.resourceTiming[this.id].slice(0));
                                        const i = {
                                            dataType: "source"
                                        };
                                        this._collectResourceTiming && n && n.length > 0 && e1.e(i, {
                                            resourceTiming: n
                                        }), this.fire(new e1.k("data", Object.assign(Object.assign({}, i), {
                                            sourceDataType: "metadata"
                                        }))), this.fire(new e1.k("data", Object.assign(Object.assign({}, i), {
                                            sourceDataType: "content"
                                        })));
                                    } catch (t1) {
                                        if (this._pendingLoads--, this._removed) return void this.fire(new e1.k("dataabort", {
                                            dataType: "source"
                                        }));
                                        this.fire(new e1.j(t1));
                                    }
                                });
                            }
                            loaded() {
                                return 0 === this._pendingLoads;
                            }
                            loadTile(t1) {
                                return e1._(this, void 0, void 0, function*() {
                                    const e1 = t1.actor ? "RT" : "LT";
                                    t1.actor = this.actor;
                                    const r = {
                                        type: this.type,
                                        uid: t1.uid,
                                        tileID: t1.tileID,
                                        zoom: t1.tileID.overscaledZ,
                                        maxZoom: this.maxzoom,
                                        tileSize: this.tileSize,
                                        source: this.id,
                                        pixelRatio: this.map.getPixelRatio(),
                                        showCollisionBoxes: this.map.showCollisionBoxes,
                                        promoteId: this.promoteId
                                    };
                                    t1.abortController = new AbortController;
                                    const n = yield this.actor.sendAsync({
                                        type: e1,
                                        data: r
                                    }, t1.abortController);
                                    delete t1.abortController, t1.unloadVectorData(), t1.aborted || t1.loadVectorData(n, this.map.painter, "RT" === e1);
                                });
                            }
                            abortTile(t1) {
                                return e1._(this, void 0, void 0, function*() {
                                    t1.abortController && (t1.abortController.abort(), delete t1.abortController), t1.aborted = !0;
                                });
                            }
                            unloadTile(t1) {
                                return e1._(this, void 0, void 0, function*() {
                                    t1.unloadVectorData(), yield this.actor.sendAsync({
                                        type: "RMT",
                                        data: {
                                            uid: t1.uid,
                                            type: this.type,
                                            source: this.id
                                        }
                                    });
                                });
                            }
                            onRemove() {
                                this._removed = !0, this.actor.sendAsync({
                                    type: "RS",
                                    data: {
                                        type: this.type,
                                        source: this.id
                                    }
                                });
                            }
                            serialize() {
                                return e1.e({}, this._options, {
                                    type: this.type,
                                    data: this._data
                                });
                            }
                            hasTransition() {
                                return !1;
                            }
                        }
                        var et = e1.Y([
                            {
                                name: "a_pos",
                                type: "Int16",
                                components: 2
                            },
                            {
                                name: "a_texture_pos",
                                type: "Int16",
                                components: 2
                            }
                        ]);
                        class rt extends e1.E {
                            constructor(t1, e1, r, n){
                                super(), this.id = t1, this.dispatcher = r, this.coordinates = e1.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.setEventedParent(n), this.options = e1;
                            }
                            load(t1) {
                                return e1._(this, void 0, void 0, function*() {
                                    this._loaded = !1, this.fire(new e1.k("dataloading", {
                                        dataType: "source"
                                    })), this.url = this.options.url, this._request = new AbortController;
                                    try {
                                        const e1 = yield p.getImage(this.map._requestManager.transformRequest(this.url, "Image"), this._request);
                                        this._request = null, this._loaded = !0, e1 && e1.data && (this.image = e1.data, t1 && (this.coordinates = t1), this._finishLoading());
                                    } catch (t1) {
                                        this._request = null, this._loaded = !0, this.fire(new e1.j(t1));
                                    }
                                });
                            }
                            loaded() {
                                return this._loaded;
                            }
                            updateImage(t1) {
                                return t1.url ? (this._request && (this._request.abort(), this._request = null), this.options.url = t1.url, this.load(t1.coordinates).finally(()=>{
                                    this.texture = null;
                                }), this) : this;
                            }
                            _finishLoading() {
                                this.map && (this.setCoordinates(this.coordinates), this.fire(new e1.k("data", {
                                    dataType: "source",
                                    sourceDataType: "metadata"
                                })));
                            }
                            onAdd(t1) {
                                this.map = t1, this.load();
                            }
                            onRemove() {
                                this._request && (this._request.abort(), this._request = null);
                            }
                            setCoordinates(t1) {
                                this.coordinates = t1;
                                const r = t1.map(e1.Z.fromLngLat);
                                this.tileID = function(t1) {
                                    let r = 1 / 0, n = 1 / 0, i = -1 / 0, a = -1 / 0;
                                    for (const e1 of t1)r = Math.min(r, e1.x), n = Math.min(n, e1.y), i = Math.max(i, e1.x), a = Math.max(a, e1.y);
                                    const o = i - r, s = a - n, l = Math.max(o, s), c = Math.max(0, Math.floor(-Math.log(l) / Math.LN2)), u = Math.pow(2, c);
                                    return new e1.a1(c, Math.floor((r + i) / 2 * u), Math.floor((n + a) / 2 * u));
                                }(r), this.minzoom = this.maxzoom = this.tileID.z;
                                const n = r.map((t1)=>this.tileID.getTilePoint(t1)._round());
                                return this._boundsArray = new e1.$, this._boundsArray.emplaceBack(n[0].x, n[0].y, 0, 0), this._boundsArray.emplaceBack(n[1].x, n[1].y, e1.X, 0), this._boundsArray.emplaceBack(n[3].x, n[3].y, 0, e1.X), this._boundsArray.emplaceBack(n[2].x, n[2].y, e1.X, e1.X), this.boundsBuffer && (this.boundsBuffer.destroy(), delete this.boundsBuffer), this.fire(new e1.k("data", {
                                    dataType: "source",
                                    sourceDataType: "content"
                                })), this;
                            }
                            prepare() {
                                if (0 === Object.keys(this.tiles).length || !this.image) return;
                                const t1 = this.map.painter.context, r = t1.gl;
                                this.boundsBuffer || (this.boundsBuffer = t1.createVertexBuffer(this._boundsArray, et.members)), this.boundsSegments || (this.boundsSegments = e1.a0.simpleSegment(0, 0, 4, 2)), this.texture || (this.texture = new w(t1, this.image, r.RGBA), this.texture.bind(r.LINEAR, r.CLAMP_TO_EDGE));
                                let n = !1;
                                for(const t1 in this.tiles){
                                    const e1 = this.tiles[t1];
                                    "loaded" !== e1.state && (e1.state = "loaded", e1.texture = this.texture, n = !0);
                                }
                                n && this.fire(new e1.k("data", {
                                    dataType: "source",
                                    sourceDataType: "idle",
                                    sourceId: this.id
                                }));
                            }
                            loadTile(t1) {
                                return e1._(this, void 0, void 0, function*() {
                                    this.tileID && this.tileID.equals(t1.tileID.canonical) ? (this.tiles[String(t1.tileID.wrap)] = t1, t1.buckets = {}) : t1.state = "errored";
                                });
                            }
                            serialize() {
                                return {
                                    type: "image",
                                    url: this.options.url,
                                    coordinates: this.coordinates
                                };
                            }
                            hasTransition() {
                                return !1;
                            }
                        }
                        class nt extends rt {
                            constructor(t1, e1, r, n){
                                super(t1, e1, r, n), this.roundZoom = !0, this.type = "video", this.options = e1;
                            }
                            load() {
                                return e1._(this, void 0, void 0, function*() {
                                    this._loaded = !1;
                                    const t1 = this.options;
                                    this.urls = [];
                                    for (const e1 of t1.urls)this.urls.push(this.map._requestManager.transformRequest(e1, "Source").url);
                                    try {
                                        const t1 = yield e1.a3(this.urls);
                                        if (this._loaded = !0, !t1) return;
                                        this.video = t1, this.video.loop = !0, this.video.addEventListener("playing", ()=>{
                                            this.map.triggerRepaint();
                                        }), this.map && this.video.play(), this._finishLoading();
                                    } catch (t1) {
                                        this.fire(new e1.j(t1));
                                    }
                                });
                            }
                            pause() {
                                this.video && this.video.pause();
                            }
                            play() {
                                this.video && this.video.play();
                            }
                            seek(t1) {
                                if (this.video) {
                                    const r = this.video.seekable;
                                    t1 < r.start(0) || t1 > r.end(0) ? this.fire(new e1.j(new e1.a2(`sources.${this.id}`, null, `Playback for this video can be set only between the ${r.start(0)} and ${r.end(0)}-second mark.`))) : this.video.currentTime = t1;
                                }
                            }
                            getVideo() {
                                return this.video;
                            }
                            onAdd(t1) {
                                this.map || (this.map = t1, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
                            }
                            prepare() {
                                if (0 === Object.keys(this.tiles).length || this.video.readyState < 2) return;
                                const t1 = this.map.painter.context, r = t1.gl;
                                this.boundsBuffer || (this.boundsBuffer = t1.createVertexBuffer(this._boundsArray, et.members)), this.boundsSegments || (this.boundsSegments = e1.a0.simpleSegment(0, 0, 4, 2)), this.texture ? this.video.paused || (this.texture.bind(r.LINEAR, r.CLAMP_TO_EDGE), r.texSubImage2D(r.TEXTURE_2D, 0, 0, 0, r.RGBA, r.UNSIGNED_BYTE, this.video)) : (this.texture = new w(t1, this.video, r.RGBA), this.texture.bind(r.LINEAR, r.CLAMP_TO_EDGE));
                                let n = !1;
                                for(const t1 in this.tiles){
                                    const e1 = this.tiles[t1];
                                    "loaded" !== e1.state && (e1.state = "loaded", e1.texture = this.texture, n = !0);
                                }
                                n && this.fire(new e1.k("data", {
                                    dataType: "source",
                                    sourceDataType: "idle",
                                    sourceId: this.id
                                }));
                            }
                            serialize() {
                                return {
                                    type: "video",
                                    urls: this.urls,
                                    coordinates: this.coordinates
                                };
                            }
                            hasTransition() {
                                return this.video && !this.video.paused;
                            }
                        }
                        class it extends rt {
                            constructor(t1, r, n, i){
                                super(t1, r, n, i), r.coordinates ? Array.isArray(r.coordinates) && 4 === r.coordinates.length && !r.coordinates.some((t1)=>!Array.isArray(t1) || 2 !== t1.length || t1.some((t1)=>"number" != typeof t1)) || this.fire(new e1.j(new e1.a2(`sources.${t1}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new e1.j(new e1.a2(`sources.${t1}`, null, 'missing required property "coordinates"'))), r.animate && "boolean" != typeof r.animate && this.fire(new e1.j(new e1.a2(`sources.${t1}`, null, 'optional "animate" property must be a boolean value'))), r.canvas ? "string" == typeof r.canvas || r.canvas instanceof HTMLCanvasElement || this.fire(new e1.j(new e1.a2(`sources.${t1}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new e1.j(new e1.a2(`sources.${t1}`, null, 'missing required property "canvas"'))), this.options = r, this.animate = void 0 === r.animate || r.animate;
                            }
                            load() {
                                return e1._(this, void 0, void 0, function*() {
                                    this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof HTMLCanvasElement ? this.options.canvas : document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new e1.j(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
                                        this._playing = !0, this.map.triggerRepaint();
                                    }, this.pause = function() {
                                        this._playing && (this.prepare(), this._playing = !1);
                                    }, this._finishLoading());
                                });
                            }
                            getCanvas() {
                                return this.canvas;
                            }
                            onAdd(t1) {
                                this.map = t1, this.load(), this.canvas && this.animate && this.play();
                            }
                            onRemove() {
                                this.pause();
                            }
                            prepare() {
                                let t1 = !1;
                                if (this.canvas.width !== this.width && (this.width = this.canvas.width, t1 = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, t1 = !0), this._hasInvalidDimensions()) return;
                                if (0 === Object.keys(this.tiles).length) return;
                                const r = this.map.painter.context, n = r.gl;
                                this.boundsBuffer || (this.boundsBuffer = r.createVertexBuffer(this._boundsArray, et.members)), this.boundsSegments || (this.boundsSegments = e1.a0.simpleSegment(0, 0, 4, 2)), this.texture ? (t1 || this._playing) && this.texture.update(this.canvas, {
                                    premultiply: !0
                                }) : this.texture = new w(r, this.canvas, n.RGBA, {
                                    premultiply: !0
                                });
                                let i = !1;
                                for(const t1 in this.tiles){
                                    const e1 = this.tiles[t1];
                                    "loaded" !== e1.state && (e1.state = "loaded", e1.texture = this.texture, i = !0);
                                }
                                i && this.fire(new e1.k("data", {
                                    dataType: "source",
                                    sourceDataType: "idle",
                                    sourceId: this.id
                                }));
                            }
                            serialize() {
                                return {
                                    type: "canvas",
                                    coordinates: this.coordinates
                                };
                            }
                            hasTransition() {
                                return this._playing;
                            }
                            _hasInvalidDimensions() {
                                for (const t1 of [
                                    this.canvas.width,
                                    this.canvas.height
                                ])if (isNaN(t1) || t1 <= 0) return !0;
                                return !1;
                            }
                        }
                        const at = {}, ot = (t1)=>{
                            switch(t1){
                                case "geojson":
                                    return tt;
                                case "image":
                                    return rt;
                                case "raster":
                                    return K;
                                case "raster-dem":
                                    return Q;
                                case "vector":
                                    return J;
                                case "video":
                                    return nt;
                                case "canvas":
                                    return it;
                            }
                            return at[t1];
                        };
                        const st = "RTLPluginLoaded";
                        class lt extends e1.E {
                            constructor(){
                                super(...arguments), this.status = "unavailable", this.url = null, this.dispatcher = H();
                            }
                            _syncState(t1) {
                                return this.status = t1, this.dispatcher.broadcast("SRPS", {
                                    pluginStatus: t1,
                                    pluginURL: this.url
                                }).catch((t1)=>{
                                    throw this.status = "error", t1;
                                });
                            }
                            getRTLTextPluginStatus() {
                                return this.status;
                            }
                            clearRTLTextPlugin() {
                                this.status = "unavailable", this.url = null;
                            }
                            setRTLTextPlugin(t1) {
                                return e1._(this, arguments, void 0, function*(t1, e1 = !1) {
                                    if (this.url) throw new Error("setRTLTextPlugin cannot be called multiple times.");
                                    if (this.url = a.resolveURL(t1), !this.url) throw new Error(`requested url ${t1} is invalid`);
                                    if ("unavailable" === this.status) {
                                        if (!e1) return this._requestImport();
                                        this.status = "deferred", this._syncState(this.status);
                                    } else if ("requested" === this.status) return this._requestImport();
                                });
                            }
                            _requestImport() {
                                return e1._(this, void 0, void 0, function*() {
                                    yield this._syncState("loading"), this.status = "loaded", this.fire(new e1.k(st));
                                });
                            }
                            lazyLoad() {
                                "unavailable" === this.status ? this.status = "requested" : "deferred" === this.status && this._requestImport();
                            }
                        }
                        let ct = null;
                        function ut() {
                            return ct || (ct = new lt), ct;
                        }
                        class ht {
                            constructor(t1, r){
                                this.timeAdded = 0, this.fadeEndTime = 0, this.tileID = t1, this.uid = e1.a4(), this.uses = 0, this.tileSize = r, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.rtt = [], this.rttCoords = {}, this.expiredRequestCount = 0, this.state = "loading";
                            }
                            registerFadeDuration(t1) {
                                const e1 = t1 + this.timeAdded;
                                e1 < this.fadeEndTime || (this.fadeEndTime = e1);
                            }
                            wasRequested() {
                                return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
                            }
                            clearTextures(t1) {
                                this.demTexture && t1.saveTileTexture(this.demTexture), this.demTexture = null;
                            }
                            loadVectorData(t1, r, n) {
                                if (this.hasData() && this.unloadVectorData(), this.state = "loaded", t1) {
                                    t1.featureIndex && (this.latestFeatureIndex = t1.featureIndex, t1.rawTileData ? (this.latestRawTileData = t1.rawTileData, this.latestFeatureIndex.rawTileData = t1.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = t1.collisionBoxArray, this.buckets = function(t1, e1) {
                                        const r = {};
                                        if (!e1) return r;
                                        for (const n of t1){
                                            const t1 = n.layerIds.map((t1)=>e1.getLayer(t1)).filter(Boolean);
                                            if (0 !== t1.length) {
                                                n.layers = t1, n.stateDependentLayerIds && (n.stateDependentLayers = n.stateDependentLayerIds.map((e1)=>t1.filter((t1)=>t1.id === e1)[0]));
                                                for (const e1 of t1)r[e1.id] = n;
                                            }
                                        }
                                        return r;
                                    }(t1.buckets, r.style), this.hasSymbolBuckets = !1;
                                    for(const t1 in this.buckets){
                                        const r = this.buckets[t1];
                                        if (r instanceof e1.a6) {
                                            if (this.hasSymbolBuckets = !0, !n) break;
                                            r.justReloaded = !0;
                                        }
                                    }
                                    if (this.hasRTLText = !1, this.hasSymbolBuckets) for(const t1 in this.buckets){
                                        const r = this.buckets[t1];
                                        if (r instanceof e1.a6 && r.hasRTLText) {
                                            this.hasRTLText = !0, ut().lazyLoad();
                                            break;
                                        }
                                    }
                                    this.queryPadding = 0;
                                    for(const t1 in this.buckets){
                                        const e1 = this.buckets[t1];
                                        this.queryPadding = Math.max(this.queryPadding, r.style.getLayer(t1).queryRadius(e1));
                                    }
                                    t1.imageAtlas && (this.imageAtlas = t1.imageAtlas), t1.glyphAtlasImage && (this.glyphAtlasImage = t1.glyphAtlasImage);
                                } else this.collisionBoxArray = new e1.a5;
                            }
                            unloadVectorData() {
                                for(const t1 in this.buckets)this.buckets[t1].destroy();
                                this.buckets = {}, this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.imageAtlas && (this.imageAtlas = null), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.latestFeatureIndex = null, this.state = "unloaded";
                            }
                            getBucket(t1) {
                                return this.buckets[t1.id];
                            }
                            upload(t1) {
                                for(const e1 in this.buckets){
                                    const r = this.buckets[e1];
                                    r.uploadPending() && r.upload(t1);
                                }
                                const e1 = t1.gl;
                                this.imageAtlas && !this.imageAtlas.uploaded && (this.imageAtlasTexture = new w(t1, this.imageAtlas.image, e1.RGBA), this.imageAtlas.uploaded = !0), this.glyphAtlasImage && (this.glyphAtlasTexture = new w(t1, this.glyphAtlasImage, e1.ALPHA), this.glyphAtlasImage = null);
                            }
                            prepare(t1) {
                                this.imageAtlas && this.imageAtlas.patchUpdatedImages(t1, this.imageAtlasTexture);
                            }
                            queryRenderedFeatures(t1, e1, r, n, i, a, o, s, l, c) {
                                return this.latestFeatureIndex && this.latestFeatureIndex.rawTileData ? this.latestFeatureIndex.query({
                                    queryGeometry: n,
                                    cameraQueryGeometry: i,
                                    scale: a,
                                    tileSize: this.tileSize,
                                    pixelPosMatrix: c,
                                    transform: s,
                                    params: o,
                                    queryPadding: this.queryPadding * l
                                }, t1, e1, r) : {};
                            }
                            querySourceFeatures(t1, r) {
                                const n = this.latestFeatureIndex;
                                if (!n || !n.rawTileData) return;
                                const i = n.loadVTLayers(), a = r && r.sourceLayer ? r.sourceLayer : "", o = i._geojsonTileLayer || i[a];
                                if (!o) return;
                                const s = e1.a7(r && r.filter), { z: l, x: c, y: u } = this.tileID.canonical, h = {
                                    z: l,
                                    x: c,
                                    y: u
                                };
                                for(let r = 0; r < o.length; r++){
                                    const i = o.feature(r);
                                    if (s.needGeometry) {
                                        const t1 = e1.a8(i, !0);
                                        if (!s.filter(new e1.a9(this.tileID.overscaledZ), t1, this.tileID.canonical)) continue;
                                    } else if (!s.filter(new e1.a9(this.tileID.overscaledZ), i)) continue;
                                    const f = n.getId(i, a), p = new e1.aa(i, l, c, u, f);
                                    p.tile = h, t1.push(p);
                                }
                            }
                            hasData() {
                                return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
                            }
                            patternsLoaded() {
                                return this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
                            }
                            setExpiryData(t1) {
                                const r = this.expirationTime;
                                if (t1.cacheControl) {
                                    const r = e1.ab(t1.cacheControl);
                                    r["max-age"] && (this.expirationTime = Date.now() + 1e3 * r["max-age"]);
                                } else t1.expires && (this.expirationTime = new Date(t1.expires).getTime());
                                if (this.expirationTime) {
                                    const t1 = Date.now();
                                    let e1 = !1;
                                    if (this.expirationTime > t1) e1 = !1;
                                    else if (r) {
                                        if (this.expirationTime < r) e1 = !0;
                                        else {
                                            const n = this.expirationTime - r;
                                            n ? this.expirationTime = t1 + Math.max(n, 3e4) : e1 = !0;
                                        }
                                    } else e1 = !0;
                                    e1 ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
                                }
                            }
                            getExpiryTimeout() {
                                if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (new Date).getTime(), Math.pow(2, 31) - 1);
                            }
                            setFeatureState(t1, e1) {
                                if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData || 0 === Object.keys(t1).length) return;
                                const r = this.latestFeatureIndex.loadVTLayers();
                                for(const n in this.buckets){
                                    if (!e1.style.hasLayer(n)) continue;
                                    const i = this.buckets[n], a = i.layers[0].sourceLayer || "_geojsonTileLayer", o = r[a], s = t1[a];
                                    if (!o || !s || 0 === Object.keys(s).length) continue;
                                    i.update(s, o, this.imageAtlas && this.imageAtlas.patternPositions || {});
                                    const l = e1 && e1.style && e1.style.getLayer(n);
                                    l && (this.queryPadding = Math.max(this.queryPadding, l.queryRadius(i)));
                                }
                            }
                            holdingForFade() {
                                return void 0 !== this.symbolFadeHoldUntil;
                            }
                            symbolFadeFinished() {
                                return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < a.now();
                            }
                            clearFadeHold() {
                                this.symbolFadeHoldUntil = void 0;
                            }
                            setHoldDuration(t1) {
                                this.symbolFadeHoldUntil = a.now() + t1;
                            }
                            setDependencies(t1, e1) {
                                const r = {};
                                for (const t1 of e1)r[t1] = !0;
                                this.dependencies[t1] = r;
                            }
                            hasDependency(t1, e1) {
                                for (const r of t1){
                                    const t1 = this.dependencies[r];
                                    if (t1) {
                                        for (const r of e1)if (t1[r]) return !0;
                                    }
                                }
                                return !1;
                            }
                        }
                        class ft {
                            constructor(t1, e1){
                                this.max = t1, this.onRemove = e1, this.reset();
                            }
                            reset() {
                                for(const t1 in this.data)for (const e1 of this.data[t1])e1.timeout && clearTimeout(e1.timeout), this.onRemove(e1.value);
                                return this.data = {}, this.order = [], this;
                            }
                            add(t1, e1, r) {
                                const n = t1.wrapped().key;
                                void 0 === this.data[n] && (this.data[n] = []);
                                const i = {
                                    value: e1,
                                    timeout: void 0
                                };
                                if (void 0 !== r && (i.timeout = setTimeout(()=>{
                                    this.remove(t1, i);
                                }, r)), this.data[n].push(i), this.order.push(n), this.order.length > this.max) {
                                    const t1 = this._getAndRemoveByKey(this.order[0]);
                                    t1 && this.onRemove(t1);
                                }
                                return this;
                            }
                            has(t1) {
                                return t1.wrapped().key in this.data;
                            }
                            getAndRemove(t1) {
                                return this.has(t1) ? this._getAndRemoveByKey(t1.wrapped().key) : null;
                            }
                            _getAndRemoveByKey(t1) {
                                const e1 = this.data[t1].shift();
                                return e1.timeout && clearTimeout(e1.timeout), 0 === this.data[t1].length && delete this.data[t1], this.order.splice(this.order.indexOf(t1), 1), e1.value;
                            }
                            getByKey(t1) {
                                const e1 = this.data[t1];
                                return e1 ? e1[0].value : null;
                            }
                            get(t1) {
                                return this.has(t1) ? this.data[t1.wrapped().key][0].value : null;
                            }
                            remove(t1, e1) {
                                if (!this.has(t1)) return this;
                                const r = t1.wrapped().key, n = void 0 === e1 ? 0 : this.data[r].indexOf(e1), i = this.data[r][n];
                                return this.data[r].splice(n, 1), i.timeout && clearTimeout(i.timeout), 0 === this.data[r].length && delete this.data[r], this.onRemove(i.value), this.order.splice(this.order.indexOf(r), 1), this;
                            }
                            setMaxSize(t1) {
                                for(this.max = t1; this.order.length > this.max;){
                                    const t1 = this._getAndRemoveByKey(this.order[0]);
                                    t1 && this.onRemove(t1);
                                }
                                return this;
                            }
                            filter(t1) {
                                const e1 = [];
                                for(const r in this.data)for (const n of this.data[r])t1(n.value) || e1.push(n);
                                for (const t1 of e1)this.remove(t1.value.tileID, t1);
                            }
                        }
                        class pt {
                            constructor(){
                                this.state = {}, this.stateChanges = {}, this.deletedStates = {};
                            }
                            updateState(t1, r, n) {
                                const i = String(r);
                                if (this.stateChanges[t1] = this.stateChanges[t1] || {}, this.stateChanges[t1][i] = this.stateChanges[t1][i] || {}, e1.e(this.stateChanges[t1][i], n), null === this.deletedStates[t1]) {
                                    this.deletedStates[t1] = {};
                                    for(const e1 in this.state[t1])e1 !== i && (this.deletedStates[t1][e1] = null);
                                } else if (this.deletedStates[t1] && null === this.deletedStates[t1][i]) {
                                    this.deletedStates[t1][i] = {};
                                    for(const e1 in this.state[t1][i])n[e1] || (this.deletedStates[t1][i][e1] = null);
                                } else for(const e1 in n)this.deletedStates[t1] && this.deletedStates[t1][i] && null === this.deletedStates[t1][i][e1] && delete this.deletedStates[t1][i][e1];
                            }
                            removeFeatureState(t1, e1, r) {
                                if (null === this.deletedStates[t1]) return;
                                const n = String(e1);
                                if (this.deletedStates[t1] = this.deletedStates[t1] || {}, r && void 0 !== e1) null !== this.deletedStates[t1][n] && (this.deletedStates[t1][n] = this.deletedStates[t1][n] || {}, this.deletedStates[t1][n][r] = null);
                                else if (void 0 !== e1) {
                                    if (this.stateChanges[t1] && this.stateChanges[t1][n]) for(r in this.deletedStates[t1][n] = {}, this.stateChanges[t1][n])this.deletedStates[t1][n][r] = null;
                                    else this.deletedStates[t1][n] = null;
                                } else this.deletedStates[t1] = null;
                            }
                            getState(t1, r) {
                                const n = String(r), i = this.state[t1] || {}, a = this.stateChanges[t1] || {}, o = e1.e({}, i[n], a[n]);
                                if (null === this.deletedStates[t1]) return {};
                                if (this.deletedStates[t1]) {
                                    const e1 = this.deletedStates[t1][r];
                                    if (null === e1) return {};
                                    for(const t1 in e1)delete o[t1];
                                }
                                return o;
                            }
                            initializeTileState(t1, e1) {
                                t1.setFeatureState(this.state, e1);
                            }
                            coalesceChanges(t1, r) {
                                const n = {};
                                for(const t1 in this.stateChanges){
                                    this.state[t1] = this.state[t1] || {};
                                    const r = {};
                                    for(const n in this.stateChanges[t1])this.state[t1][n] || (this.state[t1][n] = {}), e1.e(this.state[t1][n], this.stateChanges[t1][n]), r[n] = this.state[t1][n];
                                    n[t1] = r;
                                }
                                for(const t1 in this.deletedStates){
                                    this.state[t1] = this.state[t1] || {};
                                    const r = {};
                                    if (null === this.deletedStates[t1]) for(const e1 in this.state[t1])r[e1] = {}, this.state[t1][e1] = {};
                                    else for(const e1 in this.deletedStates[t1]){
                                        if (null === this.deletedStates[t1][e1]) this.state[t1][e1] = {};
                                        else for (const r of Object.keys(this.deletedStates[t1][e1]))delete this.state[t1][e1][r];
                                        r[e1] = this.state[t1][e1];
                                    }
                                    n[t1] = n[t1] || {}, e1.e(n[t1], r);
                                }
                                if (this.stateChanges = {}, this.deletedStates = {}, 0 !== Object.keys(n).length) for(const e1 in t1)t1[e1].setFeatureState(n, r);
                            }
                        }
                        class dt extends e1.E {
                            constructor(t1, e1, r){
                                super(), this.id = t1, this.dispatcher = r, this.on("data", (t1)=>this._dataHandler(t1)), this.on("dataloading", ()=>{
                                    this._sourceErrored = !1;
                                }), this.on("error", ()=>{
                                    this._sourceErrored = this._source.loaded();
                                }), this._source = ((t1, e1, r, n)=>{
                                    const i = new (ot(e1.type))(t1, e1, r, n);
                                    if (i.id !== t1) throw new Error(`Expected Source id to be ${t1} instead of ${i.id}`);
                                    return i;
                                })(t1, e1, r, this), this._tiles = {}, this._cache = new ft(0, (t1)=>this._unloadTile(t1)), this._timers = {}, this._cacheTimers = {}, this._maxTileCacheSize = null, this._maxTileCacheZoomLevels = null, this._loadedParentTiles = {}, this._coveredTiles = {}, this._state = new pt, this._didEmitContent = !1, this._updated = !1;
                            }
                            onAdd(t1) {
                                this.map = t1, this._maxTileCacheSize = t1 ? t1._maxTileCacheSize : null, this._maxTileCacheZoomLevels = t1 ? t1._maxTileCacheZoomLevels : null, this._source && this._source.onAdd && this._source.onAdd(t1);
                            }
                            onRemove(t1) {
                                this.clearTiles(), this._source && this._source.onRemove && this._source.onRemove(t1);
                            }
                            loaded() {
                                if (this._sourceErrored) return !0;
                                if (!this._sourceLoaded) return !1;
                                if (!this._source.loaded()) return !1;
                                if (!(void 0 === this.used && void 0 === this.usedForTerrain || this.used || this.usedForTerrain)) return !0;
                                if (!this._updated) return !1;
                                for(const t1 in this._tiles){
                                    const e1 = this._tiles[t1];
                                    if ("loaded" !== e1.state && "errored" !== e1.state) return !1;
                                }
                                return !0;
                            }
                            getSource() {
                                return this._source;
                            }
                            pause() {
                                this._paused = !0;
                            }
                            resume() {
                                if (!this._paused) return;
                                const t1 = this._shouldReloadOnResume;
                                this._paused = !1, this._shouldReloadOnResume = !1, t1 && this.reload(), this.transform && this.update(this.transform, this.terrain);
                            }
                            _loadTile(t1, r, n) {
                                return e1._(this, void 0, void 0, function*() {
                                    try {
                                        yield this._source.loadTile(t1), this._tileLoaded(t1, r, n);
                                    } catch (r) {
                                        t1.state = "errored", 404 !== r.status ? this._source.fire(new e1.j(r, {
                                            tile: t1
                                        })) : this.update(this.transform, this.terrain);
                                    }
                                });
                            }
                            _unloadTile(t1) {
                                this._source.unloadTile && this._source.unloadTile(t1);
                            }
                            _abortTile(t1) {
                                this._source.abortTile && this._source.abortTile(t1), this._source.fire(new e1.k("dataabort", {
                                    tile: t1,
                                    coord: t1.tileID,
                                    dataType: "source"
                                }));
                            }
                            serialize() {
                                return this._source.serialize();
                            }
                            prepare(t1) {
                                this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null);
                                for(const e1 in this._tiles){
                                    const r = this._tiles[e1];
                                    r.upload(t1), r.prepare(this.map.style.imageManager);
                                }
                            }
                            getIds() {
                                return Object.values(this._tiles).map((t1)=>t1.tileID).sort(mt).map((t1)=>t1.key);
                            }
                            getRenderableIds(t1) {
                                const r = [];
                                for(const e1 in this._tiles)this._isIdRenderable(e1, t1) && r.push(this._tiles[e1]);
                                return t1 ? r.sort((t1, r)=>{
                                    const n = t1.tileID, i = r.tileID, a = new e1.P(n.canonical.x, n.canonical.y)._rotate(this.transform.angle), o = new e1.P(i.canonical.x, i.canonical.y)._rotate(this.transform.angle);
                                    return n.overscaledZ - i.overscaledZ || o.y - a.y || o.x - a.x;
                                }).map((t1)=>t1.tileID.key) : r.map((t1)=>t1.tileID).sort(mt).map((t1)=>t1.key);
                            }
                            hasRenderableParent(t1) {
                                const e1 = this.findLoadedParent(t1, 0);
                                return !!e1 && this._isIdRenderable(e1.tileID.key);
                            }
                            _isIdRenderable(t1, e1) {
                                return this._tiles[t1] && this._tiles[t1].hasData() && !this._coveredTiles[t1] && (e1 || !this._tiles[t1].holdingForFade());
                            }
                            reload() {
                                if (this._paused) this._shouldReloadOnResume = !0;
                                else {
                                    this._cache.reset();
                                    for(const t1 in this._tiles)"errored" !== this._tiles[t1].state && this._reloadTile(t1, "reloading");
                                }
                            }
                            _reloadTile(t1, r) {
                                return e1._(this, void 0, void 0, function*() {
                                    const e1 = this._tiles[t1];
                                    e1 && ("loading" !== e1.state && (e1.state = r), yield this._loadTile(e1, t1, r));
                                });
                            }
                            _tileLoaded(t1, r, n) {
                                t1.timeAdded = a.now(), "expired" === n && (t1.refreshedUponExpiration = !0), this._setTileReloadTimer(r, t1), "raster-dem" === this.getSource().type && t1.dem && this._backfillDEM(t1), this._state.initializeTileState(t1, this.map ? this.map.painter : null), t1.aborted || this._source.fire(new e1.k("data", {
                                    dataType: "source",
                                    tile: t1,
                                    coord: t1.tileID
                                }));
                            }
                            _backfillDEM(t1) {
                                const e1 = this.getRenderableIds();
                                for(let n = 0; n < e1.length; n++){
                                    const i = e1[n];
                                    if (t1.neighboringTiles && t1.neighboringTiles[i]) {
                                        const e1 = this.getTileByID(i);
                                        r(t1, e1), r(e1, t1);
                                    }
                                }
                                function r(t1, e1) {
                                    t1.needsHillshadePrepare = !0, t1.needsTerrainPrepare = !0;
                                    let r = e1.tileID.canonical.x - t1.tileID.canonical.x;
                                    const n = e1.tileID.canonical.y - t1.tileID.canonical.y, i = Math.pow(2, t1.tileID.canonical.z), a = e1.tileID.key;
                                    0 === r && 0 === n || Math.abs(n) > 1 || (Math.abs(r) > 1 && (1 === Math.abs(r + i) ? r += i : 1 === Math.abs(r - i) && (r -= i)), e1.dem && t1.dem && (t1.dem.backfillBorder(e1.dem, r, n), t1.neighboringTiles && t1.neighboringTiles[a] && (t1.neighboringTiles[a].backfilled = !0)));
                                }
                            }
                            getTile(t1) {
                                return this.getTileByID(t1.key);
                            }
                            getTileByID(t1) {
                                return this._tiles[t1];
                            }
                            _retainLoadedChildren(t1, e1, r, n) {
                                for(const i in this._tiles){
                                    let a = this._tiles[i];
                                    if (n[i] || !a.hasData() || a.tileID.overscaledZ <= e1 || a.tileID.overscaledZ > r) continue;
                                    let o = a.tileID;
                                    for(; a && a.tileID.overscaledZ > e1 + 1;){
                                        const t1 = a.tileID.scaledTo(a.tileID.overscaledZ - 1);
                                        a = this._tiles[t1.key], a && a.hasData() && (o = t1);
                                    }
                                    let s = o;
                                    for(; s.overscaledZ > e1;)if (s = s.scaledTo(s.overscaledZ - 1), t1[s.key]) {
                                        n[o.key] = o;
                                        break;
                                    }
                                }
                            }
                            findLoadedParent(t1, e1) {
                                if (t1.key in this._loadedParentTiles) {
                                    const r = this._loadedParentTiles[t1.key];
                                    return r && r.tileID.overscaledZ >= e1 ? r : null;
                                }
                                for(let r = t1.overscaledZ - 1; r >= e1; r--){
                                    const e1 = t1.scaledTo(r), n = this._getLoadedTile(e1);
                                    if (n) return n;
                                }
                            }
                            findLoadedSibling(t1) {
                                return this._getLoadedTile(t1);
                            }
                            _getLoadedTile(t1) {
                                const e1 = this._tiles[t1.key];
                                return e1 && e1.hasData() ? e1 : this._cache.getByKey(t1.wrapped().key);
                            }
                            updateCacheSize(t1) {
                                const r = (Math.ceil(t1.width / this._source.tileSize) + 1) * (Math.ceil(t1.height / this._source.tileSize) + 1), n = null === this._maxTileCacheZoomLevels ? e1.a.MAX_TILE_CACHE_ZOOM_LEVELS : this._maxTileCacheZoomLevels, i = Math.floor(r * n), a = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, i) : i;
                                this._cache.setMaxSize(a);
                            }
                            handleWrapJump(t1) {
                                const e1 = (t1 - (void 0 === this._prevLng ? t1 : this._prevLng)) / 360, r = Math.round(e1);
                                if (this._prevLng = t1, r) {
                                    const t1 = {};
                                    for(const e1 in this._tiles){
                                        const n = this._tiles[e1];
                                        n.tileID = n.tileID.unwrapTo(n.tileID.wrap + r), t1[n.tileID.key] = n;
                                    }
                                    this._tiles = t1;
                                    for(const t1 in this._timers)clearTimeout(this._timers[t1]), delete this._timers[t1];
                                    for(const t1 in this._tiles){
                                        const e1 = this._tiles[t1];
                                        this._setTileReloadTimer(t1, e1);
                                    }
                                }
                            }
                            _updateCoveredAndRetainedTiles(t1, e1, r, n, i, o) {
                                const s = {}, l = {}, c = Object.keys(t1), u = a.now();
                                for (const r of c){
                                    const n = t1[r], i = this._tiles[r];
                                    if (!i || 0 !== i.fadeEndTime && i.fadeEndTime <= u) continue;
                                    const a = this.findLoadedParent(n, e1), o = this.findLoadedSibling(n), c = a || o || null;
                                    c && (this._addTile(c.tileID), s[c.tileID.key] = c.tileID), l[r] = n;
                                }
                                this._retainLoadedChildren(l, n, r, t1);
                                for(const e1 in s)t1[e1] || (this._coveredTiles[e1] = !0, t1[e1] = s[e1]);
                                if (o) {
                                    const e1 = {}, r = {};
                                    for (const t1 of i)this._tiles[t1.key].hasData() ? e1[t1.key] = t1 : r[t1.key] = t1;
                                    for(const n in r){
                                        const i = r[n].children(this._source.maxzoom);
                                        this._tiles[i[0].key] && this._tiles[i[1].key] && this._tiles[i[2].key] && this._tiles[i[3].key] && (e1[i[0].key] = t1[i[0].key] = i[0], e1[i[1].key] = t1[i[1].key] = i[1], e1[i[2].key] = t1[i[2].key] = i[2], e1[i[3].key] = t1[i[3].key] = i[3], delete r[n]);
                                    }
                                    for(const n in r){
                                        const i = r[n], a = this.findLoadedParent(i, this._source.minzoom), o = this.findLoadedSibling(i), s = a || o || null;
                                        if (s) {
                                            e1[s.tileID.key] = t1[s.tileID.key] = s.tileID;
                                            for(const t1 in e1)e1[t1].isChildOf(s.tileID) && delete e1[t1];
                                        }
                                    }
                                    for(const t1 in this._tiles)e1[t1] || (this._coveredTiles[t1] = !0);
                                }
                            }
                            update(t1, r) {
                                if (!this._sourceLoaded || this._paused) return;
                                let n;
                                this.transform = t1, this.terrain = r, this.updateCacheSize(t1), this.handleWrapJump(this.transform.center.lng), this._coveredTiles = {}, this.used || this.usedForTerrain ? this._source.tileID ? n = t1.getVisibleUnwrappedCoordinates(this._source.tileID).map((t1)=>new e1.S(t1.canonical.z, t1.wrap, t1.canonical.z, t1.canonical.x, t1.canonical.y)) : (n = t1.coveringTiles({
                                    tileSize: this.usedForTerrain ? this.tileSize : this._source.tileSize,
                                    minzoom: this._source.minzoom,
                                    maxzoom: this._source.maxzoom,
                                    roundZoom: !this.usedForTerrain && this._source.roundZoom,
                                    reparseOverscaled: this._source.reparseOverscaled,
                                    terrain: r
                                }), this._source.hasTile && (n = n.filter((t1)=>this._source.hasTile(t1)))) : n = [];
                                const i = t1.coveringZoomLevel(this._source), a = Math.max(i - dt.maxOverzooming, this._source.minzoom), o = Math.max(i + dt.maxUnderzooming, this._source.minzoom);
                                if (this.usedForTerrain) {
                                    const t1 = {};
                                    for (const e1 of n)if (e1.canonical.z > this._source.minzoom) {
                                        const r = e1.scaledTo(e1.canonical.z - 1);
                                        t1[r.key] = r;
                                        const n = e1.scaledTo(Math.max(this._source.minzoom, Math.min(e1.canonical.z, 5)));
                                        t1[n.key] = n;
                                    }
                                    n = n.concat(Object.values(t1));
                                }
                                const s = 0 === n.length && !this._updated && this._didEmitContent;
                                this._updated = !0, s && this.fire(new e1.k("data", {
                                    sourceDataType: "idle",
                                    dataType: "source",
                                    sourceId: this.id
                                }));
                                const l = this._updateRetainedTiles(n, i);
                                gt(this._source.type) && this._updateCoveredAndRetainedTiles(l, a, o, i, n, r);
                                for(const t1 in l)this._tiles[t1].clearFadeHold();
                                const c = e1.ac(this._tiles, l);
                                for (const t1 of c){
                                    const e1 = this._tiles[t1];
                                    e1.hasSymbolBuckets && !e1.holdingForFade() ? e1.setHoldDuration(this.map._fadeDuration) : e1.hasSymbolBuckets && !e1.symbolFadeFinished() || this._removeTile(t1);
                                }
                                this._updateLoadedParentTileCache(), this._updateLoadedSiblingTileCache();
                            }
                            releaseSymbolFadeTiles() {
                                for(const t1 in this._tiles)this._tiles[t1].holdingForFade() && this._removeTile(t1);
                            }
                            _updateRetainedTiles(t1, e1) {
                                var r;
                                const n = {}, i = {}, a = Math.max(e1 - dt.maxOverzooming, this._source.minzoom), o = Math.max(e1 + dt.maxUnderzooming, this._source.minzoom), s = {};
                                for (const r of t1){
                                    const t1 = this._addTile(r);
                                    n[r.key] = r, t1.hasData() || e1 < this._source.maxzoom && (s[r.key] = r);
                                }
                                this._retainLoadedChildren(s, e1, o, n);
                                for (const o of t1){
                                    let t1 = this._tiles[o.key];
                                    if (t1.hasData()) continue;
                                    if (e1 + 1 > this._source.maxzoom) {
                                        const t1 = o.children(this._source.maxzoom)[0], e1 = this.getTile(t1);
                                        if (e1 && e1.hasData()) {
                                            n[t1.key] = t1;
                                            continue;
                                        }
                                    } else {
                                        const t1 = o.children(this._source.maxzoom);
                                        if (n[t1[0].key] && n[t1[1].key] && n[t1[2].key] && n[t1[3].key]) continue;
                                    }
                                    let s = t1.wasRequested();
                                    for(let e1 = o.overscaledZ - 1; e1 >= a; --e1){
                                        const a = o.scaledTo(e1);
                                        if (i[a.key]) break;
                                        if (i[a.key] = !0, t1 = this.getTile(a), !t1 && s && (t1 = this._addTile(a)), t1) {
                                            const e1 = t1.hasData();
                                            if ((e1 || !(null === (r = this.map) || void 0 === r ? void 0 : r.cancelPendingTileRequestsWhileZooming) || s) && (n[a.key] = a), s = t1.wasRequested(), e1) break;
                                        }
                                    }
                                }
                                return n;
                            }
                            _updateLoadedParentTileCache() {
                                this._loadedParentTiles = {};
                                for(const t1 in this._tiles){
                                    const e1 = [];
                                    let r, n = this._tiles[t1].tileID;
                                    for(; n.overscaledZ > 0;){
                                        if (n.key in this._loadedParentTiles) {
                                            r = this._loadedParentTiles[n.key];
                                            break;
                                        }
                                        e1.push(n.key);
                                        const t1 = n.scaledTo(n.overscaledZ - 1);
                                        if (r = this._getLoadedTile(t1), r) break;
                                        n = t1;
                                    }
                                    for (const t1 of e1)this._loadedParentTiles[t1] = r;
                                }
                            }
                            _updateLoadedSiblingTileCache() {
                                this._loadedSiblingTiles = {};
                                for(const t1 in this._tiles){
                                    const e1 = this._tiles[t1].tileID, r = this._getLoadedTile(e1);
                                    this._loadedSiblingTiles[e1.key] = r;
                                }
                            }
                            _addTile(t1) {
                                let r = this._tiles[t1.key];
                                if (r) return r;
                                r = this._cache.getAndRemove(t1), r && (this._setTileReloadTimer(t1.key, r), r.tileID = t1, this._state.initializeTileState(r, this.map ? this.map.painter : null), this._cacheTimers[t1.key] && (clearTimeout(this._cacheTimers[t1.key]), delete this._cacheTimers[t1.key], this._setTileReloadTimer(t1.key, r)));
                                const n = r;
                                return r || (r = new ht(t1, this._source.tileSize * t1.overscaleFactor()), this._loadTile(r, t1.key, r.state)), r.uses++, this._tiles[t1.key] = r, n || this._source.fire(new e1.k("dataloading", {
                                    tile: r,
                                    coord: r.tileID,
                                    dataType: "source"
                                })), r;
                            }
                            _setTileReloadTimer(t1, e1) {
                                t1 in this._timers && (clearTimeout(this._timers[t1]), delete this._timers[t1]);
                                const r = e1.getExpiryTimeout();
                                r && (this._timers[t1] = setTimeout(()=>{
                                    this._reloadTile(t1, "expired"), delete this._timers[t1];
                                }, r));
                            }
                            _removeTile(t1) {
                                const e1 = this._tiles[t1];
                                e1 && (e1.uses--, delete this._tiles[t1], this._timers[t1] && (clearTimeout(this._timers[t1]), delete this._timers[t1]), e1.uses > 0 || (e1.hasData() && "reloading" !== e1.state ? this._cache.add(e1.tileID, e1, e1.getExpiryTimeout()) : (e1.aborted = !0, this._abortTile(e1), this._unloadTile(e1))));
                            }
                            _dataHandler(t1) {
                                const e1 = t1.sourceDataType;
                                "source" === t1.dataType && "metadata" === e1 && (this._sourceLoaded = !0), this._sourceLoaded && !this._paused && "source" === t1.dataType && "content" === e1 && (this.reload(), this.transform && this.update(this.transform, this.terrain), this._didEmitContent = !0);
                            }
                            clearTiles() {
                                this._shouldReloadOnResume = !1, this._paused = !1;
                                for(const t1 in this._tiles)this._removeTile(t1);
                                this._cache.reset();
                            }
                            tilesIn(t1, r, n) {
                                const i = [], a = this.transform;
                                if (!a) return i;
                                const o = n ? a.getCameraQueryGeometry(t1) : t1, s = t1.map((t1)=>a.pointCoordinate(t1, this.terrain)), l = o.map((t1)=>a.pointCoordinate(t1, this.terrain)), c = this.getIds();
                                let u = 1 / 0, h = 1 / 0, f = -1 / 0, p = -1 / 0;
                                for (const t1 of l)u = Math.min(u, t1.x), h = Math.min(h, t1.y), f = Math.max(f, t1.x), p = Math.max(p, t1.y);
                                for(let t1 = 0; t1 < c.length; t1++){
                                    const n = this._tiles[c[t1]];
                                    if (n.holdingForFade()) continue;
                                    const o = n.tileID, d = Math.pow(2, a.zoom - n.tileID.overscaledZ), m = r * n.queryPadding * e1.X / n.tileSize / d, g = [
                                        o.getTilePoint(new e1.Z(u, h)),
                                        o.getTilePoint(new e1.Z(f, p))
                                    ];
                                    if (g[0].x - m < e1.X && g[0].y - m < e1.X && g[1].x + m >= 0 && g[1].y + m >= 0) {
                                        const t1 = s.map((t1)=>o.getTilePoint(t1)), e1 = l.map((t1)=>o.getTilePoint(t1));
                                        i.push({
                                            tile: n,
                                            tileID: o,
                                            queryGeometry: t1,
                                            cameraQueryGeometry: e1,
                                            scale: d
                                        });
                                    }
                                }
                                return i;
                            }
                            getVisibleCoordinates(t1) {
                                const e1 = this.getRenderableIds(t1).map((t1)=>this._tiles[t1].tileID);
                                for (const t1 of e1)t1.posMatrix = this.transform.calculatePosMatrix(t1.toUnwrapped());
                                return e1;
                            }
                            hasTransition() {
                                if (this._source.hasTransition()) return !0;
                                if (gt(this._source.type)) {
                                    const t1 = a.now();
                                    for(const e1 in this._tiles)if (this._tiles[e1].fadeEndTime >= t1) return !0;
                                }
                                return !1;
                            }
                            setFeatureState(t1, e1, r) {
                                t1 = t1 || "_geojsonTileLayer", this._state.updateState(t1, e1, r);
                            }
                            removeFeatureState(t1, e1, r) {
                                t1 = t1 || "_geojsonTileLayer", this._state.removeFeatureState(t1, e1, r);
                            }
                            getFeatureState(t1, e1) {
                                return t1 = t1 || "_geojsonTileLayer", this._state.getState(t1, e1);
                            }
                            setDependencies(t1, e1, r) {
                                const n = this._tiles[t1];
                                n && n.setDependencies(e1, r);
                            }
                            reloadTilesForDependencies(t1, e1) {
                                for(const r in this._tiles)this._tiles[r].hasDependency(t1, e1) && this._reloadTile(r, "reloading");
                                this._cache.filter((r)=>!r.hasDependency(t1, e1));
                            }
                        }
                        function mt(t1, e1) {
                            const r = Math.abs(2 * t1.wrap) - +(t1.wrap < 0), n = Math.abs(2 * e1.wrap) - +(e1.wrap < 0);
                            return t1.overscaledZ - e1.overscaledZ || n - r || e1.canonical.y - t1.canonical.y || e1.canonical.x - t1.canonical.x;
                        }
                        function gt(t1) {
                            return "raster" === t1 || "image" === t1 || "video" === t1;
                        }
                        dt.maxOverzooming = 10, dt.maxUnderzooming = 3;
                        class yt {
                            constructor(t1, e1){
                                this.reset(t1, e1);
                            }
                            reset(t1, e1) {
                                this.points = t1 || [], this._distances = [
                                    0
                                ];
                                for(let t1 = 1; t1 < this.points.length; t1++)this._distances[t1] = this._distances[t1 - 1] + this.points[t1].dist(this.points[t1 - 1]);
                                this.length = this._distances[this._distances.length - 1], this.padding = Math.min(e1 || 0, .5 * this.length), this.paddedLength = this.length - 2 * this.padding;
                            }
                            lerp(t1) {
                                if (1 === this.points.length) return this.points[0];
                                t1 = e1.ad(t1, 0, 1);
                                let r = 1, n = this._distances[r];
                                const i = t1 * this.paddedLength + this.padding;
                                for(; n < i && r < this._distances.length;)n = this._distances[++r];
                                const a = r - 1, o = this._distances[a], s = n - o, l = s > 0 ? (i - o) / s : 0;
                                return this.points[a].mult(1 - l).add(this.points[r].mult(l));
                            }
                        }
                        function vt(t1, e1) {
                            let r = !0;
                            return "always" === t1 || "never" !== t1 && "never" !== e1 || (r = !1), r;
                        }
                        class xt {
                            constructor(t1, e1, r){
                                const n = this.boxCells = [], i = this.circleCells = [];
                                this.xCellCount = Math.ceil(t1 / r), this.yCellCount = Math.ceil(e1 / r);
                                for(let t1 = 0; t1 < this.xCellCount * this.yCellCount; t1++)n.push([]), i.push([]);
                                this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = t1, this.height = e1, this.xScale = this.xCellCount / t1, this.yScale = this.yCellCount / e1, this.boxUid = 0, this.circleUid = 0;
                            }
                            keysLength() {
                                return this.boxKeys.length + this.circleKeys.length;
                            }
                            insert(t1, e1, r, n, i) {
                                this._forEachCell(e1, r, n, i, this._insertBoxCell, this.boxUid++), this.boxKeys.push(t1), this.bboxes.push(e1), this.bboxes.push(r), this.bboxes.push(n), this.bboxes.push(i);
                            }
                            insertCircle(t1, e1, r, n) {
                                this._forEachCell(e1 - n, r - n, e1 + n, r + n, this._insertCircleCell, this.circleUid++), this.circleKeys.push(t1), this.circles.push(e1), this.circles.push(r), this.circles.push(n);
                            }
                            _insertBoxCell(t1, e1, r, n, i, a) {
                                this.boxCells[i].push(a);
                            }
                            _insertCircleCell(t1, e1, r, n, i, a) {
                                this.circleCells[i].push(a);
                            }
                            _query(t1, e1, r, n, i, a, o) {
                                if (r < 0 || t1 > this.width || n < 0 || e1 > this.height) return [];
                                const s = [];
                                if (t1 <= 0 && e1 <= 0 && this.width <= r && this.height <= n) {
                                    if (i) return [
                                        {
                                            key: null,
                                            x1: t1,
                                            y1: e1,
                                            x2: r,
                                            y2: n
                                        }
                                    ];
                                    for(let t1 = 0; t1 < this.boxKeys.length; t1++)s.push({
                                        key: this.boxKeys[t1],
                                        x1: this.bboxes[4 * t1],
                                        y1: this.bboxes[4 * t1 + 1],
                                        x2: this.bboxes[4 * t1 + 2],
                                        y2: this.bboxes[4 * t1 + 3]
                                    });
                                    for(let t1 = 0; t1 < this.circleKeys.length; t1++){
                                        const e1 = this.circles[3 * t1], r = this.circles[3 * t1 + 1], n = this.circles[3 * t1 + 2];
                                        s.push({
                                            key: this.circleKeys[t1],
                                            x1: e1 - n,
                                            y1: r - n,
                                            x2: e1 + n,
                                            y2: r + n
                                        });
                                    }
                                } else {
                                    const l = {
                                        hitTest: i,
                                        overlapMode: a,
                                        seenUids: {
                                            box: {},
                                            circle: {}
                                        }
                                    };
                                    this._forEachCell(t1, e1, r, n, this._queryCell, s, l, o);
                                }
                                return s;
                            }
                            query(t1, e1, r, n) {
                                return this._query(t1, e1, r, n, !1, null);
                            }
                            hitTest(t1, e1, r, n, i, a) {
                                return this._query(t1, e1, r, n, !0, i, a).length > 0;
                            }
                            hitTestCircle(t1, e1, r, n, i) {
                                const a = t1 - r, o = t1 + r, s = e1 - r, l = e1 + r;
                                if (o < 0 || a > this.width || l < 0 || s > this.height) return !1;
                                const c = [], u = {
                                    hitTest: !0,
                                    overlapMode: n,
                                    circle: {
                                        x: t1,
                                        y: e1,
                                        radius: r
                                    },
                                    seenUids: {
                                        box: {},
                                        circle: {}
                                    }
                                };
                                return this._forEachCell(a, s, o, l, this._queryCellCircle, c, u, i), c.length > 0;
                            }
                            _queryCell(t1, e1, r, n, i, a, o, s) {
                                const { seenUids: l, hitTest: c, overlapMode: u } = o, h = this.boxCells[i];
                                if (null !== h) {
                                    const i = this.bboxes;
                                    for (const o of h)if (!l.box[o]) {
                                        l.box[o] = !0;
                                        const h = 4 * o, f = this.boxKeys[o];
                                        if (t1 <= i[h + 2] && e1 <= i[h + 3] && r >= i[h + 0] && n >= i[h + 1] && (!s || s(f)) && (!c || !vt(u, f.overlapMode)) && (a.push({
                                            key: f,
                                            x1: i[h],
                                            y1: i[h + 1],
                                            x2: i[h + 2],
                                            y2: i[h + 3]
                                        }), c)) return !0;
                                    }
                                }
                                const f = this.circleCells[i];
                                if (null !== f) {
                                    const i = this.circles;
                                    for (const o of f)if (!l.circle[o]) {
                                        l.circle[o] = !0;
                                        const h = 3 * o, f = this.circleKeys[o];
                                        if (this._circleAndRectCollide(i[h], i[h + 1], i[h + 2], t1, e1, r, n) && (!s || s(f)) && (!c || !vt(u, f.overlapMode))) {
                                            const t1 = i[h], e1 = i[h + 1], r = i[h + 2];
                                            if (a.push({
                                                key: f,
                                                x1: t1 - r,
                                                y1: e1 - r,
                                                x2: t1 + r,
                                                y2: e1 + r
                                            }), c) return !0;
                                        }
                                    }
                                }
                                return !1;
                            }
                            _queryCellCircle(t1, e1, r, n, i, a, o, s) {
                                const { circle: l, seenUids: c, overlapMode: u } = o, h = this.boxCells[i];
                                if (null !== h) {
                                    const t1 = this.bboxes;
                                    for (const e1 of h)if (!c.box[e1]) {
                                        c.box[e1] = !0;
                                        const r = 4 * e1, n = this.boxKeys[e1];
                                        if (this._circleAndRectCollide(l.x, l.y, l.radius, t1[r + 0], t1[r + 1], t1[r + 2], t1[r + 3]) && (!s || s(n)) && !vt(u, n.overlapMode)) return a.push(!0), !0;
                                    }
                                }
                                const f = this.circleCells[i];
                                if (null !== f) {
                                    const t1 = this.circles;
                                    for (const e1 of f)if (!c.circle[e1]) {
                                        c.circle[e1] = !0;
                                        const r = 3 * e1, n = this.circleKeys[e1];
                                        if (this._circlesCollide(t1[r], t1[r + 1], t1[r + 2], l.x, l.y, l.radius) && (!s || s(n)) && !vt(u, n.overlapMode)) return a.push(!0), !0;
                                    }
                                }
                            }
                            _forEachCell(t1, e1, r, n, i, a, o, s) {
                                const l = this._convertToXCellCoord(t1), c = this._convertToYCellCoord(e1), u = this._convertToXCellCoord(r), h = this._convertToYCellCoord(n);
                                for(let f = l; f <= u; f++)for(let l = c; l <= h; l++){
                                    const c = this.xCellCount * l + f;
                                    if (i.call(this, t1, e1, r, n, c, a, o, s)) return;
                                }
                            }
                            _convertToXCellCoord(t1) {
                                return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(t1 * this.xScale)));
                            }
                            _convertToYCellCoord(t1) {
                                return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(t1 * this.yScale)));
                            }
                            _circlesCollide(t1, e1, r, n, i, a) {
                                const o = n - t1, s = i - e1, l = r + a;
                                return l * l > o * o + s * s;
                            }
                            _circleAndRectCollide(t1, e1, r, n, i, a, o) {
                                const s = (a - n) / 2, l = Math.abs(t1 - (n + s));
                                if (l > s + r) return !1;
                                const c = (o - i) / 2, u = Math.abs(e1 - (i + c));
                                if (u > c + r) return !1;
                                if (l <= s || u <= c) return !0;
                                const h = l - s, f = u - c;
                                return h * h + f * f <= r * r;
                            }
                        }
                        function _t(t1, r, n, i, a) {
                            const o = e1.H();
                            return r ? (e1.K(o, o, [
                                1 / a,
                                1 / a,
                                1
                            ]), n || e1.ae(o, o, i.angle)) : e1.L(o, i.labelPlaneMatrix, t1), o;
                        }
                        function bt(t1, r, n, i, a) {
                            if (r) {
                                const r = e1.af(t1);
                                return e1.K(r, r, [
                                    a,
                                    a,
                                    1
                                ]), n || e1.ae(r, r, -i.angle), r;
                            }
                            return i.glCoordMatrix;
                        }
                        function wt(t1, r, n) {
                            let i;
                            n ? (i = [
                                t1.x,
                                t1.y,
                                n(t1.x, t1.y),
                                1
                            ], e1.ag(i, i, r)) : (i = [
                                t1.x,
                                t1.y,
                                0,
                                1
                            ], function(t1, e1, r) {
                                const n = e1[0], i = e1[1];
                                t1[0] = r[0] * n + r[4] * i + r[12], t1[1] = r[1] * n + r[5] * i + r[13], t1[3] = r[3] * n + r[7] * i + r[15];
                            }(i, i, r));
                            const a = i[3];
                            return {
                                point: new e1.P(i[0] / a, i[1] / a),
                                signedDistanceFromCamera: a,
                                isOccluded: !1
                            };
                        }
                        function Tt(t1, e1) {
                            return .5 + t1 / e1 * .5;
                        }
                        function kt(t1, e1) {
                            return t1.x >= -e1[0] && t1.x <= e1[0] && t1.y >= -e1[1] && t1.y <= e1[1];
                        }
                        function At(t1, r, n, i, a, o, s, l, c, u, h, f, p, d, m) {
                            const g = i ? t1.textSizeData : t1.iconSizeData, y = e1.ah(g, n.transform.zoom), v = [
                                256 / n.width * 2 + 1,
                                256 / n.height * 2 + 1
                            ], x = i ? t1.text.dynamicLayoutVertexArray : t1.icon.dynamicLayoutVertexArray;
                            x.clear();
                            const _ = t1.lineVertexArray, b = i ? t1.text.placedSymbolArray : t1.icon.placedSymbolArray, w = n.transform.width / n.transform.height;
                            let T = !1;
                            for(let i = 0; i < b.length; i++){
                                const k = b.get(i);
                                if (k.hidden || k.writingMode === e1.ai.vertical && !T) {
                                    Rt(k.numGlyphs, x);
                                    continue;
                                }
                                T = !1;
                                const A = wt(new e1.P(k.anchorX, k.anchorY), r, m);
                                if (!kt(A.point, v)) {
                                    Rt(k.numGlyphs, x);
                                    continue;
                                }
                                const M = A.signedDistanceFromCamera, S = Tt(n.transform.cameraToCenterDistance, M), E = e1.aj(g, y, k), C = s ? E / S : E * S, L = {
                                    getElevation: m,
                                    labelPlaneMatrix: a,
                                    lineVertexArray: _,
                                    pitchWithMap: s,
                                    projectionCache: {
                                        projections: {},
                                        offsets: {},
                                        cachedAnchorPoint: void 0,
                                        anyProjectionOccluded: !1
                                    },
                                    projection: u,
                                    tileAnchorPoint: new e1.P(k.anchorX, k.anchorY),
                                    unwrappedTileID: h,
                                    width: f,
                                    height: p,
                                    translation: d
                                }, I = Et(L, k, C, !1, l, r, o, t1.glyphOffsetArray, x, w, c);
                                T = I.useVertical, (I.notEnoughRoom || T || I.needsFlipping && Et(L, k, C, !0, l, r, o, t1.glyphOffsetArray, x, w, c).notEnoughRoom) && Rt(k.numGlyphs, x);
                            }
                            i ? t1.text.dynamicLayoutVertexBuffer.updateData(x) : t1.icon.dynamicLayoutVertexBuffer.updateData(x);
                        }
                        function Mt(t1, e1, r, n, i, a, o, s) {
                            const l = a.glyphStartIndex + a.numGlyphs, c = a.lineStartIndex, u = a.lineStartIndex + a.lineLength, h = e1.getoffsetX(a.glyphStartIndex), f = e1.getoffsetX(l - 1), p = Ot(t1 * h, r, n, i, a.segment, c, u, s, o);
                            if (!p) return null;
                            const d = Ot(t1 * f, r, n, i, a.segment, c, u, s, o);
                            return d ? s.projectionCache.anyProjectionOccluded ? null : {
                                first: p,
                                last: d
                            } : null;
                        }
                        function St(t1, r, n, i) {
                            return t1 === e1.ai.horizontal && Math.abs(n.y - r.y) > Math.abs(n.x - r.x) * i ? {
                                useVertical: !0
                            } : (t1 === e1.ai.vertical ? r.y < n.y : r.x > n.x) ? {
                                needsFlipping: !0
                            } : null;
                        }
                        function Et(t1, r, n, i, a, o, s, l, c, u, h) {
                            const f = n / 24, p = r.lineOffsetX * f, d = r.lineOffsetY * f;
                            let m;
                            if (r.numGlyphs > 1) {
                                const e1 = r.glyphStartIndex + r.numGlyphs, n = r.lineStartIndex, o = r.lineStartIndex + r.lineLength, c = Mt(f, l, p, d, i, r, h, t1);
                                if (!c) return {
                                    notEnoughRoom: !0
                                };
                                const g = wt(c.first.point, s, t1.getElevation).point, y = wt(c.last.point, s, t1.getElevation).point;
                                if (a && !i) {
                                    const t1 = St(r.writingMode, g, y, u);
                                    if (t1) return t1;
                                }
                                m = [
                                    c.first
                                ];
                                for(let a = r.glyphStartIndex + 1; a < e1 - 1; a++)m.push(Ot(f * l.getoffsetX(a), p, d, i, r.segment, n, o, t1, h));
                                m.push(c.last);
                            } else {
                                if (a && !i) {
                                    const n = wt(t1.tileAnchorPoint, o, t1.getElevation).point, i = r.lineStartIndex + r.segment + 1, a = new e1.P(t1.lineVertexArray.getx(i), t1.lineVertexArray.gety(i)), s = wt(a, o, t1.getElevation), l = s.signedDistanceFromCamera > 0 ? s.point : function(t1, e1, r, n, i, a) {
                                        return Ct(t1, e1, r, n, i, a);
                                    }(t1.tileAnchorPoint, a, n, 1, o, t1), c = St(r.writingMode, n, l, u);
                                    if (c) return c;
                                }
                                const n = Ot(f * l.getoffsetX(r.glyphStartIndex), p, d, i, r.segment, r.lineStartIndex, r.lineStartIndex + r.lineLength, t1, h);
                                if (!n || t1.projectionCache.anyProjectionOccluded) return {
                                    notEnoughRoom: !0
                                };
                                m = [
                                    n
                                ];
                            }
                            for (const t1 of m)e1.ak(c, t1.point, t1.angle);
                            return {};
                        }
                        function Ct(t1, e1, r, n, i, a) {
                            const o = t1.add(t1.sub(e1)._unit()), s = void 0 !== i ? wt(o, i, a.getElevation).point : It(o.x, o.y, a).point, l = r.sub(s);
                            return r.add(l._mult(n / l.mag()));
                        }
                        function Lt(t1, r, n) {
                            const i = r.projectionCache;
                            if (i.projections[t1]) return i.projections[t1];
                            const a = new e1.P(r.lineVertexArray.getx(t1), r.lineVertexArray.gety(t1)), o = It(a.x, a.y, r);
                            if (o.signedDistanceFromCamera > 0) return i.projections[t1] = o.point, i.anyProjectionOccluded = i.anyProjectionOccluded || o.isOccluded, o.point;
                            const s = t1 - n.direction, l = 0 === n.distanceFromAnchor ? r.tileAnchorPoint : new e1.P(r.lineVertexArray.getx(s), r.lineVertexArray.gety(s)), c = n.absOffsetX - n.distanceFromAnchor + 1;
                            return function(t1, e1, r, n, i) {
                                return Ct(t1, e1, r, n, void 0, i);
                            }(l, a, n.previousVertex, c, r);
                        }
                        function It(t1, r, n) {
                            const i = t1 + n.translation[0], a = r + n.translation[1];
                            let o;
                            return !n.pitchWithMap && n.projection.useSpecialProjectionForSymbols ? (o = n.projection.projectTileCoordinates(i, a, n.unwrappedTileID, n.getElevation), o.point.x = (.5 * o.point.x + .5) * n.width, o.point.y = (.5 * -o.point.y + .5) * n.height) : (o = wt(new e1.P(i, a), n.labelPlaneMatrix, n.getElevation), o.isOccluded = !1), o;
                        }
                        function Pt(t1, e1, r) {
                            return t1._unit()._perp()._mult(e1 * r);
                        }
                        function zt(t1, r, n, i, a, o, s, l, c) {
                            if (l.projectionCache.offsets[t1]) return l.projectionCache.offsets[t1];
                            const u = n.add(r);
                            if (t1 + c.direction < i || t1 + c.direction >= a) return l.projectionCache.offsets[t1] = u, u;
                            const h = Lt(t1 + c.direction, l, c), f = Pt(h.sub(n), s, c.direction), p = n.add(f), d = h.add(f);
                            return l.projectionCache.offsets[t1] = e1.al(o, u, p, d) || u, l.projectionCache.offsets[t1];
                        }
                        function Ot(t1, e1, r, n, i, a, o, s, l) {
                            const c = n ? t1 - e1 : t1 + e1;
                            let u = c > 0 ? 1 : -1, h = 0;
                            n && (u *= -1, h = Math.PI), u < 0 && (h += Math.PI);
                            let f, p = u > 0 ? a + i : a + i + 1;
                            s.projectionCache.cachedAnchorPoint ? f = s.projectionCache.cachedAnchorPoint : (f = It(s.tileAnchorPoint.x, s.tileAnchorPoint.y, s).point, s.projectionCache.cachedAnchorPoint = f);
                            let d, m, g = f, y = f, v = 0, x = 0;
                            const _ = Math.abs(c), b = [];
                            let w;
                            for(; v + x <= _;){
                                if (p += u, p < a || p >= o) return null;
                                v += x, y = g, m = d;
                                const t1 = {
                                    absOffsetX: _,
                                    direction: u,
                                    distanceFromAnchor: v,
                                    previousVertex: y
                                };
                                if (g = Lt(p, s, t1), 0 === r) b.push(y), w = g.sub(y);
                                else {
                                    let e1;
                                    const n = g.sub(y);
                                    e1 = 0 === n.mag() ? Pt(Lt(p + u, s, t1).sub(g), r, u) : Pt(n, r, u), m || (m = y.add(e1)), d = zt(p, e1, g, a, o, m, r, s, t1), b.push(m), w = d.sub(m);
                                }
                                x = w.mag();
                            }
                            const T = (_ - v) / x, k = w._mult(T)._add(m || y), A = h + Math.atan2(g.y - y.y, g.x - y.x);
                            return b.push(k), {
                                point: k,
                                angle: l ? A : 0,
                                path: b
                            };
                        }
                        const Dt = new Float32Array([
                            -1 / 0,
                            -1 / 0,
                            0,
                            -1 / 0,
                            -1 / 0,
                            0,
                            -1 / 0,
                            -1 / 0,
                            0,
                            -1 / 0,
                            -1 / 0,
                            0
                        ]);
                        function Rt(t1, e1) {
                            for(let r = 0; r < t1; r++){
                                const t1 = e1.length;
                                e1.resize(t1 + 4), e1.float32.set(Dt, 3 * t1);
                            }
                        }
                        const Ft = 100;
                        class Bt {
                            constructor(t1, e1, r = new xt(t1.width + 200, t1.height + 200, 25), n = new xt(t1.width + 200, t1.height + 200, 25)){
                                this.transform = t1, this.mapProjection = e1, this.grid = r, this.ignoredGrid = n, this.pitchFactor = Math.cos(t1._pitch) * t1.cameraToCenterDistance, this.screenRightBoundary = t1.width + Ft, this.screenBottomBoundary = t1.height + Ft, this.gridRightBoundary = t1.width + 200, this.gridBottomBoundary = t1.height + 200, this.perspectiveRatioCutoff = .6;
                            }
                            placeCollisionBox(t1, e1, r, n, i, a, o, s, l, c, u) {
                                const h = t1.anchorPointX + s[0], f = t1.anchorPointY + s[1], p = this.projectAndGetPerspectiveRatio(n, h, f, i, c), d = this._projectCollisionBox(t1, r, n, i, a, o, s, p, c, u), [m, g, y, v] = d.box;
                                return this.mapProjection.useSpecialProjectionForSymbols && (a ? d.allPointsOccluded : this.mapProjection.isOccluded(h, f, i)) || p.perspectiveRatio < this.perspectiveRatioCutoff || !this.isInsideGrid(m, g, y, v) || "always" !== e1 && this.grid.hitTest(m, g, y, v, e1, l) ? {
                                    box: [
                                        m,
                                        g,
                                        y,
                                        v
                                    ],
                                    placeable: !1,
                                    offscreen: !1
                                } : {
                                    box: [
                                        m,
                                        g,
                                        y,
                                        v
                                    ],
                                    placeable: !0,
                                    offscreen: this.isOffscreen(m, g, y, v)
                                };
                            }
                            placeCollisionCircles(t1, r, n, i, a, o, s, l, c, u, h, f, p, d, m, g) {
                                const y = [], v = new e1.P(r.anchorX, r.anchorY), x = this.getPerspectiveRatio(o, v.x, v.y, s, g), _ = (h ? a / x : a * x) / e1.aq, b = r.lineOffsetX * _, w = r.lineOffsetY * _, T = {
                                    getElevation: g,
                                    labelPlaneMatrix: l,
                                    lineVertexArray: n,
                                    pitchWithMap: h,
                                    projectionCache: {
                                        projections: {},
                                        offsets: {},
                                        cachedAnchorPoint: void 0,
                                        anyProjectionOccluded: !1
                                    },
                                    projection: this.mapProjection,
                                    tileAnchorPoint: v,
                                    unwrappedTileID: s,
                                    width: this.transform.width,
                                    height: this.transform.height,
                                    translation: m
                                }, k = Mt(_, i, b, w, !1, r, !1, T);
                                let A = !1, M = !1, S = !0;
                                if (k) {
                                    const r = .5 * p * x + d, n = new e1.P(-100, -100), i = new e1.P(this.screenRightBoundary, this.screenBottomBoundary), a = new yt, o = k.first, s = k.last;
                                    let l = [];
                                    for(let t1 = o.path.length - 1; t1 >= 1; t1--)l.push(o.path[t1]);
                                    for(let t1 = 1; t1 < s.path.length; t1++)l.push(s.path[t1]);
                                    const h = 2.5 * r;
                                    if (c) {
                                        const t1 = this.projectPathToScreenSpace(l, T, c);
                                        l = t1.some((t1)=>t1.signedDistanceFromCamera <= 0) ? [] : t1.map((t1)=>t1.point);
                                    }
                                    let m = [];
                                    if (l.length > 0) {
                                        const t1 = l[0].clone(), r = l[0].clone();
                                        for(let e1 = 1; e1 < l.length; e1++)t1.x = Math.min(t1.x, l[e1].x), t1.y = Math.min(t1.y, l[e1].y), r.x = Math.max(r.x, l[e1].x), r.y = Math.max(r.y, l[e1].y);
                                        m = t1.x >= n.x && r.x <= i.x && t1.y >= n.y && r.y <= i.y ? [
                                            l
                                        ] : r.x < n.x || t1.x > i.x || r.y < n.y || t1.y > i.y ? [] : e1.am([
                                            l
                                        ], n.x, n.y, i.x, i.y);
                                    }
                                    for (const e1 of m){
                                        a.reset(e1, .25 * r);
                                        let n = 0;
                                        n = a.length <= .5 * r ? 1 : Math.ceil(a.paddedLength / h) + 1;
                                        for(let e1 = 0; e1 < n; e1++){
                                            const i = e1 / Math.max(n - 1, 1), o = a.lerp(i), s = o.x + Ft, l = o.y + Ft;
                                            y.push(s, l, r, 0);
                                            const c = s - r, h = l - r, p = s + r, d = l + r;
                                            if (S = S && this.isOffscreen(c, h, p, d), M = M || this.isInsideGrid(c, h, p, d), "always" !== t1 && this.grid.hitTestCircle(s, l, r, t1, f) && (A = !0, !u)) return {
                                                circles: [],
                                                offscreen: !1,
                                                collisionDetected: A
                                            };
                                        }
                                    }
                                }
                                return {
                                    circles: !u && A || !M || x < this.perspectiveRatioCutoff ? [] : y,
                                    offscreen: S,
                                    collisionDetected: A
                                };
                            }
                            projectPathToScreenSpace(t1, e1, r) {
                                return t1.map((t1)=>wt(t1, r, e1.getElevation));
                            }
                            queryRenderedSymbols(t1) {
                                if (0 === t1.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
                                const r = [];
                                let n = 1 / 0, i = 1 / 0, a = -1 / 0, o = -1 / 0;
                                for (const s of t1){
                                    const t1 = new e1.P(s.x + Ft, s.y + Ft);
                                    n = Math.min(n, t1.x), i = Math.min(i, t1.y), a = Math.max(a, t1.x), o = Math.max(o, t1.y), r.push(t1);
                                }
                                const s = this.grid.query(n, i, a, o).concat(this.ignoredGrid.query(n, i, a, o)), l = {}, c = {};
                                for (const t1 of s){
                                    const n = t1.key;
                                    if (void 0 === l[n.bucketInstanceId] && (l[n.bucketInstanceId] = {}), l[n.bucketInstanceId][n.featureIndex]) continue;
                                    const i = [
                                        new e1.P(t1.x1, t1.y1),
                                        new e1.P(t1.x2, t1.y1),
                                        new e1.P(t1.x2, t1.y2),
                                        new e1.P(t1.x1, t1.y2)
                                    ];
                                    e1.an(r, i) && (l[n.bucketInstanceId][n.featureIndex] = !0, void 0 === c[n.bucketInstanceId] && (c[n.bucketInstanceId] = []), c[n.bucketInstanceId].push(n.featureIndex));
                                }
                                return c;
                            }
                            insertCollisionBox(t1, e1, r, n, i, a) {
                                const o = {
                                    bucketInstanceId: n,
                                    featureIndex: i,
                                    collisionGroupID: a,
                                    overlapMode: e1
                                };
                                (r ? this.ignoredGrid : this.grid).insert(o, t1[0], t1[1], t1[2], t1[3]);
                            }
                            insertCollisionCircles(t1, e1, r, n, i, a) {
                                const o = r ? this.ignoredGrid : this.grid, s = {
                                    bucketInstanceId: n,
                                    featureIndex: i,
                                    collisionGroupID: a,
                                    overlapMode: e1
                                };
                                for(let e1 = 0; e1 < t1.length; e1 += 4)o.insertCircle(s, t1[e1], t1[e1 + 1], t1[e1 + 2]);
                            }
                            projectAndGetPerspectiveRatio(t1, r, n, i, a) {
                                const o = this.mapProjection.useSpecialProjectionForSymbols ? this.mapProjection.projectTileCoordinates(r, n, i, a) : wt(new e1.P(r, n), t1, a);
                                return {
                                    point: new e1.P((o.point.x + 1) / 2 * this.transform.width + Ft, (1 - o.point.y) / 2 * this.transform.height + Ft),
                                    perspectiveRatio: .5 + this.transform.cameraToCenterDistance / o.signedDistanceFromCamera * .5,
                                    isOccluded: o.isOccluded,
                                    signedDistanceFromCamera: o.signedDistanceFromCamera
                                };
                            }
                            getPerspectiveRatio(t1, r, n, i, a) {
                                const o = this.mapProjection.useSpecialProjectionForSymbols ? this.mapProjection.projectTileCoordinates(r, n, i, a) : wt(new e1.P(r, n), t1, a);
                                return .5 + this.transform.cameraToCenterDistance / o.signedDistanceFromCamera * .5;
                            }
                            isOffscreen(t1, e1, r, n) {
                                return r < Ft || t1 >= this.screenRightBoundary || n < Ft || e1 > this.screenBottomBoundary;
                            }
                            isInsideGrid(t1, e1, r, n) {
                                return r >= 0 && t1 < this.gridRightBoundary && n >= 0 && e1 < this.gridBottomBoundary;
                            }
                            getViewportMatrix() {
                                const t1 = e1.ao([]);
                                return e1.J(t1, t1, [
                                    -100,
                                    -100,
                                    0
                                ]), t1;
                            }
                            _projectCollisionBox(t1, r, n, i, a, o, s, l, c, u) {
                                const h = r * l.perspectiveRatio;
                                let f = new e1.P(1, 0), p = new e1.P(0, 1);
                                const d = new e1.P(t1.anchorPointX + s[0], t1.anchorPointY + s[1]);
                                if (o && !a) {
                                    const t1 = this.projectAndGetPerspectiveRatio(n, d.x + 1, d.y, i, c).point.sub(l.point).unit(), r = Math.atan(t1.y / t1.x) + (t1.x < 0 ? Math.PI : 0), a = Math.sin(r), o = Math.cos(r);
                                    f = new e1.P(o, a), p = new e1.P(-a, o);
                                } else if (!o && a) {
                                    const t1 = -this.transform.angle, r = Math.sin(t1), n = Math.cos(t1);
                                    f = new e1.P(n, r), p = new e1.P(-r, n);
                                }
                                let m = l.point, g = h;
                                if (a) {
                                    m = d;
                                    const t1 = this.transform.zoom - Math.floor(this.transform.zoom);
                                    if (g = Math.pow(2, -t1), g *= this.mapProjection.getPitchedTextCorrection(this.transform, d, i), !u) {
                                        const t1 = l.signedDistanceFromCamera / this.transform.cameraToCenterDistance;
                                        g *= e1.ad(.5 + .5 * t1, 0, 4);
                                    }
                                }
                                u && (m = m.add(f.mult(u.x * g)).add(p.mult(u.y * g)));
                                const y = t1.x1 * g, v = t1.x2 * g, x = (y + v) / 2, _ = t1.y1 * g, b = t1.y2 * g, w = (_ + b) / 2, T = [
                                    {
                                        offsetX: y,
                                        offsetY: _
                                    },
                                    {
                                        offsetX: x,
                                        offsetY: _
                                    },
                                    {
                                        offsetX: v,
                                        offsetY: _
                                    },
                                    {
                                        offsetX: v,
                                        offsetY: w
                                    },
                                    {
                                        offsetX: v,
                                        offsetY: b
                                    },
                                    {
                                        offsetX: x,
                                        offsetY: b
                                    },
                                    {
                                        offsetX: y,
                                        offsetY: b
                                    },
                                    {
                                        offsetX: y,
                                        offsetY: w
                                    }
                                ];
                                let k = [];
                                for (const { offsetX: t1, offsetY: r } of T)k.push(new e1.P(m.x + f.x * t1 + p.x * r, m.y + f.y * t1 + p.y * r));
                                let A = !1;
                                if (a) {
                                    const t1 = k.map((t1)=>this.projectAndGetPerspectiveRatio(n, t1.x, t1.y, i, c));
                                    A = t1.some((t1)=>!t1.isOccluded), k = t1.map((t1)=>t1.point);
                                } else A = !0;
                                return {
                                    box: e1.ap(k),
                                    allPointsOccluded: !A
                                };
                            }
                        }
                        function Nt(t1, r, n) {
                            return r * (e1.X / (t1.tileSize * Math.pow(2, n - t1.tileID.overscaledZ)));
                        }
                        class jt {
                            constructor(t1, e1, r, n){
                                this.opacity = t1 ? Math.max(0, Math.min(1, t1.opacity + (t1.placed ? e1 : -e1))) : n && r ? 1 : 0, this.placed = r;
                            }
                            isHidden() {
                                return 0 === this.opacity && !this.placed;
                            }
                        }
                        class Ut {
                            constructor(t1, e1, r, n, i){
                                this.text = new jt(t1 ? t1.text : null, e1, r, i), this.icon = new jt(t1 ? t1.icon : null, e1, n, i);
                            }
                            isHidden() {
                                return this.text.isHidden() && this.icon.isHidden();
                            }
                        }
                        class Vt {
                            constructor(t1, e1, r){
                                this.text = t1, this.icon = e1, this.skipFade = r;
                            }
                        }
                        class qt {
                            constructor(){
                                this.invProjMatrix = e1.H(), this.viewportMatrix = e1.H(), this.circles = [];
                            }
                        }
                        class Ht {
                            constructor(t1, e1, r, n, i){
                                this.bucketInstanceId = t1, this.featureIndex = e1, this.sourceLayerIndex = r, this.bucketIndex = n, this.tileID = i;
                            }
                        }
                        class Gt {
                            constructor(t1){
                                this.crossSourceCollisions = t1, this.maxGroupID = 0, this.collisionGroups = {};
                            }
                            get(t1) {
                                if (this.crossSourceCollisions) return {
                                    ID: 0,
                                    predicate: null
                                };
                                if (!this.collisionGroups[t1]) {
                                    const e1 = ++this.maxGroupID;
                                    this.collisionGroups[t1] = {
                                        ID: e1,
                                        predicate: (t1)=>t1.collisionGroupID === e1
                                    };
                                }
                                return this.collisionGroups[t1];
                            }
                        }
                        function Zt(t1, r, n, i, a) {
                            const { horizontalAlign: o, verticalAlign: s } = e1.av(t1), l = -(o - .5) * r, c = -(s - .5) * n;
                            return new e1.P(l + i[0] * a, c + i[1] * a);
                        }
                        class Wt {
                            constructor(t1, e1, r, n, i, a){
                                this.transform = t1.clone(), this.terrain = r, this.collisionIndex = new Bt(this.transform, e1), this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = n, this.retainedQueryData = {}, this.collisionGroups = new Gt(i), this.collisionCircleArrays = {}, this.collisionBoxArrays = new Map, this.prevPlacement = a, a && (a.prevPlacement = void 0), this.placedOrientations = {};
                            }
                            _getTerrainElevationFunc(t1) {
                                const e1 = this.terrain;
                                return e1 ? (r, n)=>e1.getElevation(t1, r, n) : null;
                            }
                            getBucketParts(t1, r, n, i) {
                                const a = n.getBucket(r), o = n.latestFeatureIndex;
                                if (!a || !o || r.id !== a.layerIds[0]) return;
                                const s = n.collisionBoxArray, l = a.layers[0].layout, c = a.layers[0].paint, u = Math.pow(2, this.transform.zoom - n.tileID.overscaledZ), h = n.tileSize / e1.X, f = n.tileID.toUnwrapped(), p = this.transform.calculatePosMatrix(f), d = "map" === l.get("text-pitch-alignment"), m = "map" === l.get("text-rotation-alignment"), g = Nt(n, 1, this.transform.zoom), y = this.collisionIndex.mapProjection.translatePosition(this.transform, n, c.get("text-translate"), c.get("text-translate-anchor")), v = this.collisionIndex.mapProjection.translatePosition(this.transform, n, c.get("icon-translate"), c.get("icon-translate-anchor")), x = _t(p, d, m, this.transform, g);
                                let _ = null;
                                if (d) {
                                    const t1 = bt(p, d, m, this.transform, g);
                                    _ = e1.L([], this.transform.labelPlaneMatrix, t1);
                                }
                                this.retainedQueryData[a.bucketInstanceId] = new Ht(a.bucketInstanceId, o, a.sourceLayerIndex, a.index, n.tileID);
                                const b = {
                                    bucket: a,
                                    layout: l,
                                    translationText: y,
                                    translationIcon: v,
                                    posMatrix: p,
                                    unwrappedTileID: f,
                                    textLabelPlaneMatrix: x,
                                    labelToScreenMatrix: _,
                                    scale: u,
                                    textPixelRatio: h,
                                    holdingForFade: n.holdingForFade(),
                                    collisionBoxArray: s,
                                    partiallyEvaluatedTextSize: e1.ah(a.textSizeData, this.transform.zoom),
                                    collisionGroup: this.collisionGroups.get(a.sourceID)
                                };
                                if (i) for (const e1 of a.sortKeyRanges){
                                    const { sortKey: r, symbolInstanceStart: n, symbolInstanceEnd: i } = e1;
                                    t1.push({
                                        sortKey: r,
                                        symbolInstanceStart: n,
                                        symbolInstanceEnd: i,
                                        parameters: b
                                    });
                                }
                                else t1.push({
                                    symbolInstanceStart: 0,
                                    symbolInstanceEnd: a.symbolInstances.length,
                                    parameters: b
                                });
                            }
                            attemptAnchorPlacement(t1, r, n, i, a, o, s, l, c, u, h, f, p, d, m, g, y, v, x) {
                                const _ = e1.ar[t1.textAnchor], b = [
                                    t1.textOffset0,
                                    t1.textOffset1
                                ], w = Zt(_, n, i, b, a), T = this.collisionIndex.placeCollisionBox(r, f, l, c, u, s, o, g, h.predicate, x, w);
                                if ((!v || this.collisionIndex.placeCollisionBox(v, f, l, c, u, s, o, y, h.predicate, x, w).placeable) && T.placeable) {
                                    let t1;
                                    if (this.prevPlacement && this.prevPlacement.variableOffsets[p.crossTileID] && this.prevPlacement.placements[p.crossTileID] && this.prevPlacement.placements[p.crossTileID].text && (t1 = this.prevPlacement.variableOffsets[p.crossTileID].anchor), 0 === p.crossTileID) throw new Error("symbolInstance.crossTileID can't be 0");
                                    return this.variableOffsets[p.crossTileID] = {
                                        textOffset: b,
                                        width: n,
                                        height: i,
                                        anchor: _,
                                        textBoxScale: a,
                                        prevAnchor: t1
                                    }, this.markUsedJustification(d, _, p, m), d.allowVerticalPlacement && (this.markUsedOrientation(d, m, p), this.placedOrientations[p.crossTileID] = m), {
                                        shift: w,
                                        placedGlyphBoxes: T
                                    };
                                }
                            }
                            placeLayerBucketPart(t1, r, n) {
                                const { bucket: i, layout: a, translationText: o, translationIcon: s, posMatrix: l, unwrappedTileID: c, textLabelPlaneMatrix: u, labelToScreenMatrix: h, textPixelRatio: f, holdingForFade: p, collisionBoxArray: d, partiallyEvaluatedTextSize: m, collisionGroup: g } = t1.parameters, y = a.get("text-optional"), v = a.get("icon-optional"), x = e1.as(a, "text-overlap", "text-allow-overlap"), _ = "always" === x, b = e1.as(a, "icon-overlap", "icon-allow-overlap"), w = "always" === b, T = "map" === a.get("text-rotation-alignment"), k = "map" === a.get("text-pitch-alignment"), A = "none" !== a.get("icon-text-fit"), M = "viewport-y" === a.get("symbol-z-order"), S = _ && (w || !i.hasIconData() || v), E = w && (_ || !i.hasTextData() || y);
                                !i.collisionArrays && d && i.deserializeCollisionBoxes(d);
                                const C = this.retainedQueryData[i.bucketInstanceId].tileID, L = this._getTerrainElevationFunc(C), I = (t1, d, w)=>{
                                    var M, C;
                                    if (r[t1.crossTileID]) return;
                                    if (p) return void (this.placements[t1.crossTileID] = new Vt(!1, !1, !1));
                                    let I = !1, P = !1, z = !0, O = null, D = {
                                        box: null,
                                        placeable: !1,
                                        offscreen: null
                                    }, R = {
                                        box: null,
                                        placeable: !1,
                                        offscreen: null
                                    }, F = null, B = null, N = null, j = 0, U = 0, V = 0;
                                    d.textFeatureIndex ? j = d.textFeatureIndex : t1.useRuntimeCollisionCircles && (j = t1.featureIndex), d.verticalTextFeatureIndex && (U = d.verticalTextFeatureIndex);
                                    const q = d.textBox;
                                    if (q) {
                                        const r = (r)=>{
                                            let n = e1.ai.horizontal;
                                            if (i.allowVerticalPlacement && !r && this.prevPlacement) {
                                                const e1 = this.prevPlacement.placedOrientations[t1.crossTileID];
                                                e1 && (this.placedOrientations[t1.crossTileID] = e1, n = e1, this.markUsedOrientation(i, n, t1));
                                            }
                                            return n;
                                        }, a = (r, n)=>{
                                            if (i.allowVerticalPlacement && t1.numVerticalGlyphVertices > 0 && d.verticalTextBox) {
                                                for (const t1 of i.writingModes)if (t1 === e1.ai.vertical ? (D = n(), R = D) : D = r(), D && D.placeable) break;
                                            } else D = r();
                                        }, u = t1.textAnchorOffsetStartIndex, h = t1.textAnchorOffsetEndIndex;
                                        if (h === u) {
                                            const n = (e1, r)=>{
                                                const n = this.collisionIndex.placeCollisionBox(e1, x, f, l, c, k, T, o, g.predicate, L);
                                                return n && n.placeable && (this.markUsedOrientation(i, r, t1), this.placedOrientations[t1.crossTileID] = r), n;
                                            };
                                            a(()=>n(q, e1.ai.horizontal), ()=>{
                                                const r = d.verticalTextBox;
                                                return i.allowVerticalPlacement && t1.numVerticalGlyphVertices > 0 && r ? n(r, e1.ai.vertical) : {
                                                    box: null,
                                                    offscreen: null
                                                };
                                            }), r(D && D.placeable);
                                        } else {
                                            let p = e1.ar[null === (C = null === (M = this.prevPlacement) || void 0 === M ? void 0 : M.variableOffsets[t1.crossTileID]) || void 0 === C ? void 0 : C.anchor];
                                            const m = (r, a, d)=>{
                                                const m = r.x2 - r.x1, y = r.y2 - r.y1, v = t1.textBoxScale, _ = A && "never" === b ? a : null;
                                                let w = null, M = "never" === x ? 1 : 2, S = "never";
                                                p && M++;
                                                for(let e1 = 0; e1 < M; e1++){
                                                    for(let e1 = u; e1 < h; e1++){
                                                        const n = i.textAnchorOffsets.get(e1);
                                                        if (p && n.textAnchor !== p) continue;
                                                        const a = this.attemptAnchorPlacement(n, r, m, y, v, T, k, f, l, c, g, S, t1, i, d, o, s, _, L);
                                                        if (a && (w = a.placedGlyphBoxes, w && w.placeable)) return I = !0, O = a.shift, w;
                                                    }
                                                    p ? p = null : S = x;
                                                }
                                                return n && !w && (w = {
                                                    box: this.collisionIndex.placeCollisionBox(q, "always", f, l, c, k, T, o, g.predicate, L, new e1.P(0, 0)).box,
                                                    offscreen: !1,
                                                    placeable: !1
                                                }), w;
                                            };
                                            a(()=>m(q, d.iconBox, e1.ai.horizontal), ()=>{
                                                const r = d.verticalTextBox, n = D && D.placeable;
                                                return i.allowVerticalPlacement && !n && t1.numVerticalGlyphVertices > 0 && r ? m(r, d.verticalIconBox, e1.ai.vertical) : {
                                                    box: null,
                                                    occluded: !0,
                                                    offscreen: null
                                                };
                                            }), D && (I = D.placeable, z = D.offscreen);
                                            const y = r(D && D.placeable);
                                            if (!I && this.prevPlacement) {
                                                const e1 = this.prevPlacement.variableOffsets[t1.crossTileID];
                                                e1 && (this.variableOffsets[t1.crossTileID] = e1, this.markUsedJustification(i, e1.anchor, t1, y));
                                            }
                                        }
                                    }
                                    if (F = D, I = F && F.placeable, z = F && F.offscreen, t1.useRuntimeCollisionCircles) {
                                        const r = i.text.placedSymbolArray.get(t1.centerJustifiedTextSymbolIndex), s = e1.aj(i.textSizeData, m, r), f = a.get("text-padding"), p = t1.collisionCircleDiameter;
                                        B = this.collisionIndex.placeCollisionCircles(x, r, i.lineVertexArray, i.glyphOffsetArray, s, l, c, u, h, n, k, g.predicate, p, f, o, L), B.circles.length && B.collisionDetected && !n && e1.w("Collisions detected, but collision boxes are not shown"), I = _ || B.circles.length > 0 && !B.collisionDetected, z = z && B.offscreen;
                                    }
                                    if (d.iconFeatureIndex && (V = d.iconFeatureIndex), d.iconBox) {
                                        const t1 = (t1)=>this.collisionIndex.placeCollisionBox(t1, b, f, l, c, k, T, s, g.predicate, L, A && O ? O : void 0);
                                        R && R.placeable && d.verticalIconBox ? (N = t1(d.verticalIconBox), P = N.placeable) : (N = t1(d.iconBox), P = N.placeable), z = z && N.offscreen;
                                    }
                                    const H = y || 0 === t1.numHorizontalGlyphVertices && 0 === t1.numVerticalGlyphVertices, G = v || 0 === t1.numIconVertices;
                                    H || G ? G ? H || (P = P && I) : I = P && I : P = I = P && I;
                                    const Z = I && F.placeable, W = P && N.placeable;
                                    if (Z && (R && R.placeable && U ? this.collisionIndex.insertCollisionBox(F.box, x, a.get("text-ignore-placement"), i.bucketInstanceId, U, g.ID) : this.collisionIndex.insertCollisionBox(F.box, x, a.get("text-ignore-placement"), i.bucketInstanceId, j, g.ID)), W && this.collisionIndex.insertCollisionBox(N.box, b, a.get("icon-ignore-placement"), i.bucketInstanceId, V, g.ID), B && I && this.collisionIndex.insertCollisionCircles(B.circles, x, a.get("text-ignore-placement"), i.bucketInstanceId, j, g.ID), n && this.storeCollisionData(i.bucketInstanceId, w, d, F, N, B), 0 === t1.crossTileID) throw new Error("symbolInstance.crossTileID can't be 0");
                                    if (0 === i.bucketInstanceId) throw new Error("bucket.bucketInstanceId can't be 0");
                                    this.placements[t1.crossTileID] = new Vt(I || S, P || E, z || i.justReloaded), r[t1.crossTileID] = !0;
                                };
                                if (M) {
                                    if (0 !== t1.symbolInstanceStart) throw new Error("bucket.bucketInstanceId should be 0");
                                    const e1 = i.getSortedSymbolIndexes(this.transform.angle);
                                    for(let t1 = e1.length - 1; t1 >= 0; --t1){
                                        const r = e1[t1];
                                        I(i.symbolInstances.get(r), i.collisionArrays[r], r);
                                    }
                                } else for(let e1 = t1.symbolInstanceStart; e1 < t1.symbolInstanceEnd; e1++)I(i.symbolInstances.get(e1), i.collisionArrays[e1], e1);
                                if (n && i.bucketInstanceId in this.collisionCircleArrays) {
                                    const t1 = this.collisionCircleArrays[i.bucketInstanceId];
                                    e1.at(t1.invProjMatrix, l), t1.viewportMatrix = this.collisionIndex.getViewportMatrix();
                                }
                                i.justReloaded = !1;
                            }
                            storeCollisionData(t1, e1, r, n, i, a) {
                                if (r.textBox || r.iconBox) {
                                    let a, o;
                                    this.collisionBoxArrays.has(t1) ? a = this.collisionBoxArrays.get(t1) : (a = new Map, this.collisionBoxArrays.set(t1, a)), a.has(e1) ? o = a.get(e1) : (o = {
                                        text: null,
                                        icon: null
                                    }, a.set(e1, o)), r.textBox && (o.text = n.box), r.iconBox && (o.icon = i.box);
                                }
                                if (a) {
                                    let e1 = this.collisionCircleArrays[t1];
                                    void 0 === e1 && (e1 = this.collisionCircleArrays[t1] = new qt);
                                    for(let t1 = 0; t1 < a.circles.length; t1 += 4)e1.circles.push(a.circles[t1 + 0]), e1.circles.push(a.circles[t1 + 1]), e1.circles.push(a.circles[t1 + 2]), e1.circles.push(a.collisionDetected ? 1 : 0);
                                }
                            }
                            markUsedJustification(t1, r, n, i) {
                                const a = {
                                    left: n.leftJustifiedTextSymbolIndex,
                                    center: n.centerJustifiedTextSymbolIndex,
                                    right: n.rightJustifiedTextSymbolIndex
                                };
                                let o;
                                o = i === e1.ai.vertical ? n.verticalPlacedTextSymbolIndex : a[e1.au(r)];
                                const s = [
                                    n.leftJustifiedTextSymbolIndex,
                                    n.centerJustifiedTextSymbolIndex,
                                    n.rightJustifiedTextSymbolIndex,
                                    n.verticalPlacedTextSymbolIndex
                                ];
                                for (const e1 of s)e1 >= 0 && (t1.text.placedSymbolArray.get(e1).crossTileID = o >= 0 && e1 !== o ? 0 : n.crossTileID);
                            }
                            markUsedOrientation(t1, r, n) {
                                const i = r === e1.ai.horizontal || r === e1.ai.horizontalOnly ? r : 0, a = r === e1.ai.vertical ? r : 0, o = [
                                    n.leftJustifiedTextSymbolIndex,
                                    n.centerJustifiedTextSymbolIndex,
                                    n.rightJustifiedTextSymbolIndex
                                ];
                                for (const e1 of o)t1.text.placedSymbolArray.get(e1).placedOrientation = i;
                                n.verticalPlacedTextSymbolIndex && (t1.text.placedSymbolArray.get(n.verticalPlacedTextSymbolIndex).placedOrientation = a);
                            }
                            commit(t1) {
                                this.commitTime = t1, this.zoomAtLastRecencyCheck = this.transform.zoom;
                                const e1 = this.prevPlacement;
                                let r = !1;
                                this.prevZoomAdjustment = e1 ? e1.zoomAdjustment(this.transform.zoom) : 0;
                                const n = e1 ? e1.symbolFadeChange(t1) : 1, i = e1 ? e1.opacities : {}, a = e1 ? e1.variableOffsets : {}, o = e1 ? e1.placedOrientations : {};
                                for(const t1 in this.placements){
                                    const e1 = this.placements[t1], a = i[t1];
                                    a ? (this.opacities[t1] = new Ut(a, n, e1.text, e1.icon), r = r || e1.text !== a.text.placed || e1.icon !== a.icon.placed) : (this.opacities[t1] = new Ut(null, n, e1.text, e1.icon, e1.skipFade), r = r || e1.text || e1.icon);
                                }
                                for(const t1 in i){
                                    const e1 = i[t1];
                                    if (!this.opacities[t1]) {
                                        const i = new Ut(e1, n, !1, !1);
                                        i.isHidden() || (this.opacities[t1] = i, r = r || e1.text.placed || e1.icon.placed);
                                    }
                                }
                                for(const t1 in a)this.variableOffsets[t1] || !this.opacities[t1] || this.opacities[t1].isHidden() || (this.variableOffsets[t1] = a[t1]);
                                for(const t1 in o)this.placedOrientations[t1] || !this.opacities[t1] || this.opacities[t1].isHidden() || (this.placedOrientations[t1] = o[t1]);
                                if (e1 && void 0 === e1.lastPlacementChangeTime) throw new Error("Last placement time for previous placement is not defined");
                                r ? this.lastPlacementChangeTime = t1 : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = e1 ? e1.lastPlacementChangeTime : t1);
                            }
                            updateLayerOpacities(t1, e1) {
                                const r = {};
                                for (const n of e1){
                                    const e1 = n.getBucket(t1);
                                    e1 && n.latestFeatureIndex && t1.id === e1.layerIds[0] && this.updateBucketOpacities(e1, n.tileID, r, n.collisionBoxArray);
                                }
                            }
                            updateBucketOpacities(t1, r, n, i) {
                                t1.hasTextData() && (t1.text.opacityVertexArray.clear(), t1.text.hasVisibleVertices = !1), t1.hasIconData() && (t1.icon.opacityVertexArray.clear(), t1.icon.hasVisibleVertices = !1), t1.hasIconCollisionBoxData() && t1.iconCollisionBox.collisionVertexArray.clear(), t1.hasTextCollisionBoxData() && t1.textCollisionBox.collisionVertexArray.clear();
                                const a = t1.layers[0], o = a.layout, s = new Ut(null, 0, !1, !1, !0), l = o.get("text-allow-overlap"), c = o.get("icon-allow-overlap"), u = a._unevaluatedLayout.hasValue("text-variable-anchor") || a._unevaluatedLayout.hasValue("text-variable-anchor-offset"), h = "map" === o.get("text-rotation-alignment"), f = "map" === o.get("text-pitch-alignment"), p = "none" !== o.get("icon-text-fit"), d = new Ut(null, 0, l && (c || !t1.hasIconData() || o.get("icon-optional")), c && (l || !t1.hasTextData() || o.get("text-optional")), !0);
                                !t1.collisionArrays && i && (t1.hasIconCollisionBoxData() || t1.hasTextCollisionBoxData()) && t1.deserializeCollisionBoxes(i);
                                const m = (t1, e1, r)=>{
                                    for(let n = 0; n < e1 / 4; n++)t1.opacityVertexArray.emplaceBack(r);
                                    t1.hasVisibleVertices = t1.hasVisibleVertices || r !== ne;
                                }, g = this.collisionBoxArrays.get(t1.bucketInstanceId);
                                for(let r = 0; r < t1.symbolInstances.length; r++){
                                    const i = t1.symbolInstances.get(r), { numHorizontalGlyphVertices: a, numVerticalGlyphVertices: o, crossTileID: l } = i, c = n[l];
                                    let y = this.opacities[l];
                                    c ? y = s : y || (y = d, this.opacities[l] = y), n[l] = !0;
                                    const v = a > 0 || o > 0, x = i.numIconVertices > 0, _ = this.placedOrientations[i.crossTileID], b = _ === e1.ai.vertical, w = _ === e1.ai.horizontal || _ === e1.ai.horizontalOnly;
                                    if (v) {
                                        const e1 = re(y.text), r = b ? ne : e1;
                                        m(t1.text, a, r);
                                        const n = w ? ne : e1;
                                        m(t1.text, o, n);
                                        const s = y.text.isHidden();
                                        [
                                            i.rightJustifiedTextSymbolIndex,
                                            i.centerJustifiedTextSymbolIndex,
                                            i.leftJustifiedTextSymbolIndex
                                        ].forEach((e1)=>{
                                            e1 >= 0 && (t1.text.placedSymbolArray.get(e1).hidden = s || b ? 1 : 0);
                                        }), i.verticalPlacedTextSymbolIndex >= 0 && (t1.text.placedSymbolArray.get(i.verticalPlacedTextSymbolIndex).hidden = s || w ? 1 : 0);
                                        const l = this.variableOffsets[i.crossTileID];
                                        l && this.markUsedJustification(t1, l.anchor, i, _);
                                        const c = this.placedOrientations[i.crossTileID];
                                        c && (this.markUsedJustification(t1, "left", i, c), this.markUsedOrientation(t1, c, i));
                                    }
                                    if (x) {
                                        const e1 = re(y.icon), r = !(p && i.verticalPlacedIconSymbolIndex && b);
                                        if (i.placedIconSymbolIndex >= 0) {
                                            const n = r ? e1 : ne;
                                            m(t1.icon, i.numIconVertices, n), t1.icon.placedSymbolArray.get(i.placedIconSymbolIndex).hidden = y.icon.isHidden();
                                        }
                                        if (i.verticalPlacedIconSymbolIndex >= 0) {
                                            const n = r ? ne : e1;
                                            m(t1.icon, i.numVerticalIconVertices, n), t1.icon.placedSymbolArray.get(i.verticalPlacedIconSymbolIndex).hidden = y.icon.isHidden();
                                        }
                                    }
                                    const T = g && g.has(r) ? g.get(r) : {
                                        text: null,
                                        icon: null
                                    };
                                    if (t1.hasIconCollisionBoxData() || t1.hasTextCollisionBoxData()) {
                                        const n = t1.collisionArrays[r];
                                        if (n) {
                                            let r = new e1.P(0, 0);
                                            if (n.textBox || n.verticalTextBox) {
                                                let e1 = !0;
                                                if (u) {
                                                    const t1 = this.variableOffsets[l];
                                                    t1 ? (r = Zt(t1.anchor, t1.width, t1.height, t1.textOffset, t1.textBoxScale), h && r._rotate(f ? this.transform.angle : -this.transform.angle)) : e1 = !1;
                                                }
                                                if (n.textBox || n.verticalTextBox) {
                                                    let i;
                                                    n.textBox && (i = b), n.verticalTextBox && (i = w), Yt(t1.textCollisionBox.collisionVertexArray, y.text.placed, !e1 || i, T.text, r.x, r.y);
                                                }
                                            }
                                            if (n.iconBox || n.verticalIconBox) {
                                                const e1 = Boolean(!w && n.verticalIconBox);
                                                let i;
                                                n.iconBox && (i = e1), n.verticalIconBox && (i = !e1), Yt(t1.iconCollisionBox.collisionVertexArray, y.icon.placed, i, T.icon, p ? r.x : 0, p ? r.y : 0);
                                            }
                                        }
                                    }
                                }
                                if (t1.sortFeatures(this.transform.angle), this.retainedQueryData[t1.bucketInstanceId] && (this.retainedQueryData[t1.bucketInstanceId].featureSortOrder = t1.featureSortOrder), t1.hasTextData() && t1.text.opacityVertexBuffer && t1.text.opacityVertexBuffer.updateData(t1.text.opacityVertexArray), t1.hasIconData() && t1.icon.opacityVertexBuffer && t1.icon.opacityVertexBuffer.updateData(t1.icon.opacityVertexArray), t1.hasIconCollisionBoxData() && t1.iconCollisionBox.collisionVertexBuffer && t1.iconCollisionBox.collisionVertexBuffer.updateData(t1.iconCollisionBox.collisionVertexArray), t1.hasTextCollisionBoxData() && t1.textCollisionBox.collisionVertexBuffer && t1.textCollisionBox.collisionVertexBuffer.updateData(t1.textCollisionBox.collisionVertexArray), t1.text.opacityVertexArray.length !== t1.text.layoutVertexArray.length / 4) throw new Error(`bucket.text.opacityVertexArray.length (= ${t1.text.opacityVertexArray.length}) !== bucket.text.layoutVertexArray.length (= ${t1.text.layoutVertexArray.length}) / 4`);
                                if (t1.icon.opacityVertexArray.length !== t1.icon.layoutVertexArray.length / 4) throw new Error(`bucket.icon.opacityVertexArray.length (= ${t1.icon.opacityVertexArray.length}) !== bucket.icon.layoutVertexArray.length (= ${t1.icon.layoutVertexArray.length}) / 4`);
                                if (t1.bucketInstanceId in this.collisionCircleArrays) {
                                    const e1 = this.collisionCircleArrays[t1.bucketInstanceId];
                                    t1.placementInvProjMatrix = e1.invProjMatrix, t1.placementViewportMatrix = e1.viewportMatrix, t1.collisionCircleArray = e1.circles, delete this.collisionCircleArrays[t1.bucketInstanceId];
                                }
                            }
                            symbolFadeChange(t1) {
                                return 0 === this.fadeDuration ? 1 : (t1 - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
                            }
                            zoomAdjustment(t1) {
                                return Math.max(0, (this.transform.zoom - t1) / 1.5);
                            }
                            hasTransitions(t1) {
                                return this.stale || t1 - this.lastPlacementChangeTime < this.fadeDuration;
                            }
                            stillRecent(t1, e1) {
                                const r = this.zoomAtLastRecencyCheck === e1 ? 1 - this.zoomAdjustment(e1) : 1;
                                return this.zoomAtLastRecencyCheck = e1, this.commitTime + this.fadeDuration * r > t1;
                            }
                            setStale() {
                                this.stale = !0;
                            }
                        }
                        function Yt(t1, e1, r, n, i, a) {
                            n && 0 !== n.length || (n = [
                                0,
                                0,
                                0,
                                0
                            ]);
                            const o = n[0] - Ft, s = n[1] - Ft, l = n[2] - Ft, c = n[3] - Ft;
                            t1.emplaceBack(e1 ? 1 : 0, r ? 1 : 0, i || 0, a || 0, o, s), t1.emplaceBack(e1 ? 1 : 0, r ? 1 : 0, i || 0, a || 0, l, s), t1.emplaceBack(e1 ? 1 : 0, r ? 1 : 0, i || 0, a || 0, l, c), t1.emplaceBack(e1 ? 1 : 0, r ? 1 : 0, i || 0, a || 0, o, c);
                        }
                        const Xt = Math.pow(2, 25), $t = Math.pow(2, 24), Jt = Math.pow(2, 17), Kt = Math.pow(2, 16), Qt = Math.pow(2, 9), te = Math.pow(2, 8), ee = Math.pow(2, 1);
                        function re(t1) {
                            if (0 === t1.opacity && !t1.placed) return 0;
                            if (1 === t1.opacity && t1.placed) return 4294967295;
                            const e1 = t1.placed ? 1 : 0, r = Math.floor(127 * t1.opacity);
                            return r * Xt + e1 * $t + r * Jt + e1 * Kt + r * Qt + e1 * te + r * ee + e1;
                        }
                        const ne = 0;
                        function ie() {
                            return {
                                isOccluded (t1, e1, r) {
                                    return !1;
                                },
                                getPitchedTextCorrection (t1, e1, r) {
                                    return 1;
                                },
                                get useSpecialProjectionForSymbols () {
                                    return !1;
                                },
                                projectTileCoordinates (t1, e1, r, n) {
                                    throw new Error("Not implemented.");
                                },
                                translatePosition (t1, e1, r, n) {
                                    return function(t1, e1, r, n, i = !1) {
                                        if (!r[0] && !r[1]) return [
                                            0,
                                            0
                                        ];
                                        const a = i ? "map" === n ? t1.angle : 0 : "viewport" === n ? -t1.angle : 0;
                                        if (a) {
                                            const t1 = Math.sin(a), e1 = Math.cos(a);
                                            r = [
                                                r[0] * e1 - r[1] * t1,
                                                r[0] * t1 + r[1] * e1
                                            ];
                                        }
                                        return [
                                            i ? r[0] : Nt(e1, r[0], t1.zoom),
                                            i ? r[1] : Nt(e1, r[1], t1.zoom)
                                        ];
                                    }(t1, e1, r, n);
                                },
                                getCircleRadiusCorrection (t1) {
                                    return 1;
                                }
                            };
                        }
                        class ae {
                            constructor(t1){
                                this._sortAcrossTiles = "viewport-y" !== t1.layout.get("symbol-z-order") && !t1.layout.get("symbol-sort-key").isConstant(), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = {}, this._bucketParts = [];
                            }
                            continuePlacement(t1, e1, r, n, i) {
                                const a = this._bucketParts;
                                for(; this._currentTileIndex < t1.length;){
                                    const r = t1[this._currentTileIndex];
                                    if (e1.getBucketParts(a, n, r, this._sortAcrossTiles), this._currentTileIndex++, i()) return !0;
                                }
                                for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, a.sort((t1, e1)=>t1.sortKey - e1.sortKey)); this._currentPartIndex < a.length;){
                                    const t1 = a[this._currentPartIndex];
                                    if (e1.placeLayerBucketPart(t1, this._seenCrossTileIDs, r), this._currentPartIndex++, i()) return !0;
                                }
                                return !1;
                            }
                        }
                        class oe {
                            constructor(t1, e1, r, n, i, a, o, s){
                                this.placement = new Wt(t1, ie(), e1, a, o, s), this._currentPlacementIndex = r.length - 1, this._forceFullPlacement = n, this._showCollisionBoxes = i, this._done = !1;
                            }
                            isDone() {
                                return this._done;
                            }
                            continuePlacement(t1, e1, r) {
                                const n = a.now(), i = ()=>!this._forceFullPlacement && a.now() - n > 2;
                                for(; this._currentPlacementIndex >= 0;){
                                    const n = e1[t1[this._currentPlacementIndex]], a = this.placement.collisionIndex.transform.zoom;
                                    if ("symbol" === n.type && (!n.minzoom || n.minzoom <= a) && (!n.maxzoom || n.maxzoom > a)) {
                                        if (this._inProgressLayer || (this._inProgressLayer = new ae(n)), this._inProgressLayer.continuePlacement(r[n.source], this.placement, this._showCollisionBoxes, n, i)) return;
                                        delete this._inProgressLayer;
                                    }
                                    this._currentPlacementIndex--;
                                }
                                this._done = !0;
                            }
                            commit(t1) {
                                return this.placement.commit(t1), this.placement;
                            }
                        }
                        const se = 512 / e1.X / 2;
                        class le {
                            constructor(t1, r, n){
                                this.tileID = t1, this.bucketInstanceId = n, this._symbolsByKey = {};
                                const i = new Map;
                                for(let t1 = 0; t1 < r.length; t1++){
                                    const e1 = r.get(t1), n = e1.key, a = i.get(n);
                                    a ? a.push(e1) : i.set(n, [
                                        e1
                                    ]);
                                }
                                for (const [t1, r] of i){
                                    const n = {
                                        positions: r.map((t1)=>({
                                                x: Math.floor(t1.anchorX * se),
                                                y: Math.floor(t1.anchorY * se)
                                            })),
                                        crossTileIDs: r.map((t1)=>t1.crossTileID)
                                    };
                                    if (n.positions.length > 128) {
                                        const t1 = new e1.aw(n.positions.length, 16, Uint16Array);
                                        for (const { x: e1, y: r } of n.positions)t1.add(e1, r);
                                        t1.finish(), delete n.positions, n.index = t1;
                                    }
                                    this._symbolsByKey[t1] = n;
                                }
                            }
                            getScaledCoordinates(t1, r) {
                                const { x: n, y: i, z: a } = this.tileID.canonical, { x: o, y: s, z: l } = r.canonical, c = l - a, u = se / Math.pow(2, c), h = (o * e1.X + t1.anchorX) * u, f = (s * e1.X + t1.anchorY) * u, p = n * e1.X * se, d = i * e1.X * se;
                                return {
                                    x: Math.floor(h - p),
                                    y: Math.floor(f - d)
                                };
                            }
                            findMatches(t1, e1, r) {
                                const n = this.tileID.canonical.z < e1.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - e1.canonical.z);
                                for(let i = 0; i < t1.length; i++){
                                    const a = t1.get(i);
                                    if (a.crossTileID) continue;
                                    const o = this._symbolsByKey[a.key];
                                    if (!o) continue;
                                    const s = this.getScaledCoordinates(a, e1);
                                    if (o.index) {
                                        const t1 = o.index.range(s.x - n, s.y - n, s.x + n, s.y + n).sort();
                                        for (const e1 of t1){
                                            const t1 = o.crossTileIDs[e1];
                                            if (!r[t1]) {
                                                r[t1] = !0, a.crossTileID = t1;
                                                break;
                                            }
                                        }
                                    } else if (o.positions) for(let t1 = 0; t1 < o.positions.length; t1++){
                                        const e1 = o.positions[t1], i = o.crossTileIDs[t1];
                                        if (Math.abs(e1.x - s.x) <= n && Math.abs(e1.y - s.y) <= n && !r[i]) {
                                            r[i] = !0, a.crossTileID = i;
                                            break;
                                        }
                                    }
                                }
                            }
                            getCrossTileIDsLists() {
                                return Object.values(this._symbolsByKey).map(({ crossTileIDs: t1 })=>t1);
                            }
                        }
                        class ce {
                            constructor(){
                                this.maxCrossTileID = 0;
                            }
                            generate() {
                                return ++this.maxCrossTileID;
                            }
                        }
                        class ue {
                            constructor(){
                                this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
                            }
                            handleWrapJump(t1) {
                                const e1 = Math.round((t1 - this.lng) / 360);
                                if (0 !== e1) for(const t1 in this.indexes){
                                    const r = this.indexes[t1], n = {};
                                    for(const t1 in r){
                                        const i = r[t1];
                                        i.tileID = i.tileID.unwrapTo(i.tileID.wrap + e1), n[i.tileID.key] = i;
                                    }
                                    this.indexes[t1] = n;
                                }
                                this.lng = t1;
                            }
                            addBucket(t1, e1, r) {
                                if (this.indexes[t1.overscaledZ] && this.indexes[t1.overscaledZ][t1.key]) {
                                    if (this.indexes[t1.overscaledZ][t1.key].bucketInstanceId === e1.bucketInstanceId) return !1;
                                    this.removeBucketCrossTileIDs(t1.overscaledZ, this.indexes[t1.overscaledZ][t1.key]);
                                }
                                for(let t1 = 0; t1 < e1.symbolInstances.length; t1++)e1.symbolInstances.get(t1).crossTileID = 0;
                                this.usedCrossTileIDs[t1.overscaledZ] || (this.usedCrossTileIDs[t1.overscaledZ] = {});
                                const n = this.usedCrossTileIDs[t1.overscaledZ];
                                for(const r in this.indexes){
                                    const i = this.indexes[r];
                                    if (Number(r) > t1.overscaledZ) for(const r in i){
                                        const a = i[r];
                                        a.tileID.isChildOf(t1) && a.findMatches(e1.symbolInstances, t1, n);
                                    }
                                    else {
                                        const a = i[t1.scaledTo(Number(r)).key];
                                        a && a.findMatches(e1.symbolInstances, t1, n);
                                    }
                                }
                                for(let t1 = 0; t1 < e1.symbolInstances.length; t1++){
                                    const i = e1.symbolInstances.get(t1);
                                    i.crossTileID || (i.crossTileID = r.generate(), n[i.crossTileID] = !0);
                                }
                                return void 0 === this.indexes[t1.overscaledZ] && (this.indexes[t1.overscaledZ] = {}), this.indexes[t1.overscaledZ][t1.key] = new le(t1, e1.symbolInstances, e1.bucketInstanceId), !0;
                            }
                            removeBucketCrossTileIDs(t1, e1) {
                                for (const r of e1.getCrossTileIDsLists())for (const e1 of r)delete this.usedCrossTileIDs[t1][e1];
                            }
                            removeStaleBuckets(t1) {
                                let e1 = !1;
                                for(const r in this.indexes){
                                    const n = this.indexes[r];
                                    for(const i in n)t1[n[i].bucketInstanceId] || (this.removeBucketCrossTileIDs(r, n[i]), delete n[i], e1 = !0);
                                }
                                return e1;
                            }
                        }
                        class he {
                            constructor(){
                                this.layerIndexes = {}, this.crossTileIDs = new ce, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
                            }
                            addLayer(t1, e1, r) {
                                let n = this.layerIndexes[t1.id];
                                void 0 === n && (n = this.layerIndexes[t1.id] = new ue);
                                let i = !1;
                                const a = {};
                                n.handleWrapJump(r);
                                for (const r of e1){
                                    const e1 = r.getBucket(t1);
                                    e1 && t1.id === e1.layerIds[0] && (e1.bucketInstanceId || (e1.bucketInstanceId = ++this.maxBucketInstanceId), n.addBucket(r.tileID, e1, this.crossTileIDs) && (i = !0), a[e1.bucketInstanceId] = !0);
                                }
                                return n.removeStaleBuckets(a) && (i = !0), i;
                            }
                            pruneUnusedLayers(t1) {
                                const e1 = {};
                                t1.forEach((t1)=>{
                                    e1[t1] = !0;
                                });
                                for(const t1 in this.layerIndexes)e1[t1] || delete this.layerIndexes[t1];
                            }
                        }
                        const fe = (t1, r)=>e1.t(t1, r && r.filter((t1)=>"source.canvas" !== t1.identifier)), pe = e1.ax();
                        class de extends e1.E {
                            constructor(t1, r = {}){
                                super(), this._rtlPluginLoaded = ()=>{
                                    for(const t1 in this.sourceCaches){
                                        const e1 = this.sourceCaches[t1].getSource().type;
                                        "vector" !== e1 && "geojson" !== e1 || this.sourceCaches[t1].reload();
                                    }
                                }, this.map = t1, this.dispatcher = new q(V(), t1._getMapId()), this.dispatcher.registerMessageHandler("GG", (t1, e1)=>this.getGlyphs(t1, e1)), this.dispatcher.registerMessageHandler("GI", (t1, e1)=>this.getImages(t1, e1)), this.imageManager = new k, this.imageManager.setEventedParent(this), this.glyphManager = new E(t1._requestManager, r.localIdeographFontFamily), this.lineAtlas = new R(256, 512), this.crossTileSymbolIndex = new he, this._spritesImagesIds = {}, this._layers = {}, this._order = [], this.sourceCaches = {}, this.zoomHistory = new e1.ay, this._loaded = !1, this._availableImages = [], this._resetUpdates(), this.dispatcher.broadcast("SR", e1.az()), ut().on(st, this._rtlPluginLoaded), this.on("data", (t1)=>{
                                    if ("source" !== t1.dataType || "metadata" !== t1.sourceDataType) return;
                                    const e1 = this.sourceCaches[t1.sourceId];
                                    if (!e1) return;
                                    const r = e1.getSource();
                                    if (r && r.vectorLayerIds) for(const t1 in this._layers){
                                        const e1 = this._layers[t1];
                                        e1.source === r.id && this._validateLayer(e1);
                                    }
                                });
                            }
                            loadURL(t1, r = {}, n) {
                                this.fire(new e1.k("dataloading", {
                                    dataType: "style"
                                })), r.validate = "boolean" != typeof r.validate || r.validate;
                                const i = this.map._requestManager.transformRequest(t1, "Style");
                                this._loadStyleRequest = new AbortController;
                                const a = this._loadStyleRequest;
                                e1.h(i, this._loadStyleRequest).then((t1)=>{
                                    this._loadStyleRequest = null, this._load(t1.data, r, n);
                                }).catch((t1)=>{
                                    this._loadStyleRequest = null, t1 && !a.signal.aborted && this.fire(new e1.j(t1));
                                });
                            }
                            loadJSON(t1, r = {}, n) {
                                this.fire(new e1.k("dataloading", {
                                    dataType: "style"
                                })), this._frameRequest = new AbortController, a.frameAsync(this._frameRequest).then(()=>{
                                    this._frameRequest = null, r.validate = !1 !== r.validate, this._load(t1, r, n);
                                }).catch(()=>{});
                            }
                            loadEmpty() {
                                this.fire(new e1.k("dataloading", {
                                    dataType: "style"
                                })), this._load(pe, {
                                    validate: !1
                                });
                            }
                            _load(t1, r, n) {
                                var i;
                                const a = r.transformStyle ? r.transformStyle(n, t1) : t1;
                                if (!r.validate || !fe(this, e1.x(a))) {
                                    this._loaded = !0, this.stylesheet = a;
                                    for(const t1 in a.sources)this.addSource(t1, a.sources[t1], {
                                        validate: !1
                                    });
                                    a.sprite ? this._loadSprite(a.sprite) : this.imageManager.setLoaded(!0), this.glyphManager.setURL(a.glyphs), this._createLayers(), this.light = new P(this.stylesheet.light), this.sky = new D(this.stylesheet.sky), this.map.setTerrain(null !== (i = this.stylesheet.terrain) && void 0 !== i ? i : null), this.fire(new e1.k("data", {
                                        dataType: "style"
                                    })), this.fire(new e1.k("style.load"));
                                }
                            }
                            _createLayers() {
                                const t1 = e1.aA(this.stylesheet.layers);
                                this.dispatcher.broadcast("SL", t1), this._order = t1.map((t1)=>t1.id), this._layers = {}, this._serializedLayers = null;
                                for (const r of t1){
                                    const t1 = e1.aB(r);
                                    t1.setEventedParent(this, {
                                        layer: {
                                            id: r.id
                                        }
                                    }), this._layers[r.id] = t1;
                                }
                            }
                            _loadSprite(t1, r = !1, n) {
                                let i;
                                this.imageManager.setLoaded(!1), this._spriteRequest = new AbortController, b(t1, this.map._requestManager, this.map.getPixelRatio(), this._spriteRequest).then((t1)=>{
                                    if (this._spriteRequest = null, t1) for(const e1 in t1){
                                        this._spritesImagesIds[e1] = [];
                                        const n = this._spritesImagesIds[e1] ? this._spritesImagesIds[e1].filter((e1)=>!(e1 in t1)) : [];
                                        for (const t1 of n)this.imageManager.removeImage(t1), this._changedImages[t1] = !0;
                                        for(const n in t1[e1]){
                                            const i = "default" === e1 ? n : `${e1}:${n}`;
                                            this._spritesImagesIds[e1].push(i), i in this.imageManager.images ? this.imageManager.updateImage(i, t1[e1][n], !1) : this.imageManager.addImage(i, t1[e1][n]), r && (this._changedImages[i] = !0);
                                        }
                                    }
                                }).catch((t1)=>{
                                    this._spriteRequest = null, i = t1, this.fire(new e1.j(i));
                                }).finally(()=>{
                                    this.imageManager.setLoaded(!0), this._availableImages = this.imageManager.listImages(), r && (this._changed = !0), this.dispatcher.broadcast("SI", this._availableImages), this.fire(new e1.k("data", {
                                        dataType: "style"
                                    })), n && n(i);
                                });
                            }
                            _unloadSprite() {
                                for (const t1 of Object.values(this._spritesImagesIds).flat())this.imageManager.removeImage(t1), this._changedImages[t1] = !0;
                                this._spritesImagesIds = {}, this._availableImages = this.imageManager.listImages(), this._changed = !0, this.dispatcher.broadcast("SI", this._availableImages), this.fire(new e1.k("data", {
                                    dataType: "style"
                                }));
                            }
                            _validateLayer(t1) {
                                const r = this.sourceCaches[t1.source];
                                if (!r) return;
                                const n = t1.sourceLayer;
                                if (!n) return;
                                const i = r.getSource();
                                ("geojson" === i.type || i.vectorLayerIds && -1 === i.vectorLayerIds.indexOf(n)) && this.fire(new e1.j(new Error(`Source layer "${n}" does not exist on source "${i.id}" as specified by style layer "${t1.id}".`)));
                            }
                            loaded() {
                                if (!this._loaded) return !1;
                                if (Object.keys(this._updatedSources).length) return !1;
                                for(const t1 in this.sourceCaches)if (!this.sourceCaches[t1].loaded()) return !1;
                                return !!this.imageManager.isLoaded();
                            }
                            _serializeByIds(t1) {
                                const e1 = this._serializedAllLayers();
                                if (!t1 || 0 === t1.length) return Object.values(e1);
                                const r = [];
                                for (const n of t1)e1[n] && r.push(e1[n]);
                                return r;
                            }
                            _serializedAllLayers() {
                                let t1 = this._serializedLayers;
                                if (t1) return t1;
                                t1 = this._serializedLayers = {};
                                const e1 = Object.keys(this._layers);
                                for (const r of e1){
                                    const e1 = this._layers[r];
                                    "custom" !== e1.type && (t1[r] = e1.serialize());
                                }
                                return t1;
                            }
                            hasTransitions() {
                                if (this.light && this.light.hasTransition()) return !0;
                                if (this.sky && this.sky.hasTransition()) return !0;
                                for(const t1 in this.sourceCaches)if (this.sourceCaches[t1].hasTransition()) return !0;
                                for(const t1 in this._layers)if (this._layers[t1].hasTransition()) return !0;
                                return !1;
                            }
                            _checkLoaded() {
                                if (!this._loaded) throw new Error("Style is not done loading.");
                            }
                            update(t1) {
                                if (!this._loaded) return;
                                const r = this._changed;
                                if (r) {
                                    const e1 = Object.keys(this._updatedLayers), r = Object.keys(this._removedLayers);
                                    (e1.length || r.length) && this._updateWorkerLayers(e1, r);
                                    for(const t1 in this._updatedSources){
                                        const e1 = this._updatedSources[t1];
                                        if ("reload" === e1) this._reloadSource(t1);
                                        else {
                                            if ("clear" !== e1) throw new Error(`Invalid action ${e1}`);
                                            this._clearSource(t1);
                                        }
                                    }
                                    this._updateTilesForChangedImages(), this._updateTilesForChangedGlyphs();
                                    for(const e1 in this._updatedPaintProps)this._layers[e1].updateTransitions(t1);
                                    this.light.updateTransitions(t1), this.sky.updateTransitions(t1), this._resetUpdates();
                                }
                                const n = {};
                                for(const t1 in this.sourceCaches){
                                    const e1 = this.sourceCaches[t1];
                                    n[t1] = e1.used, e1.used = !1;
                                }
                                for (const e1 of this._order){
                                    const r = this._layers[e1];
                                    r.recalculate(t1, this._availableImages), !r.isHidden(t1.zoom) && r.source && (this.sourceCaches[r.source].used = !0);
                                }
                                for(const t1 in n){
                                    const r = this.sourceCaches[t1];
                                    !!n[t1] != !!r.used && r.fire(new e1.k("data", {
                                        sourceDataType: "visibility",
                                        dataType: "source",
                                        sourceId: t1
                                    }));
                                }
                                this.light.recalculate(t1), this.sky.recalculate(t1), this.z = t1.zoom, r && this.fire(new e1.k("data", {
                                    dataType: "style"
                                }));
                            }
                            _updateTilesForChangedImages() {
                                const t1 = Object.keys(this._changedImages);
                                if (t1.length) {
                                    for(const e1 in this.sourceCaches)this.sourceCaches[e1].reloadTilesForDependencies([
                                        "icons",
                                        "patterns"
                                    ], t1);
                                    this._changedImages = {};
                                }
                            }
                            _updateTilesForChangedGlyphs() {
                                if (this._glyphsDidChange) {
                                    for(const t1 in this.sourceCaches)this.sourceCaches[t1].reloadTilesForDependencies([
                                        "glyphs"
                                    ], [
                                        ""
                                    ]);
                                    this._glyphsDidChange = !1;
                                }
                            }
                            _updateWorkerLayers(t1, e1) {
                                this.dispatcher.broadcast("UL", {
                                    layers: this._serializeByIds(t1),
                                    removedIds: e1
                                });
                            }
                            _resetUpdates() {
                                this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSources = {}, this._updatedPaintProps = {}, this._changedImages = {}, this._glyphsDidChange = !1;
                            }
                            setState(t1, r = {}) {
                                var n;
                                this._checkLoaded();
                                const i = this.serialize();
                                if (t1 = r.transformStyle ? r.transformStyle(i, t1) : t1, (null === (n = r.validate) || void 0 === n || n) && fe(this, e1.x(t1))) return !1;
                                (t1 = e1.aC(t1)).layers = e1.aA(t1.layers);
                                const a = e1.aD(i, t1), o = this._getOperationsToPerform(a);
                                if (o.unimplemented.length > 0) throw new Error(`Unimplemented: ${o.unimplemented.join(", ")}.`);
                                if (0 === o.operations.length) return !1;
                                for (const t1 of o.operations)t1();
                                return this.stylesheet = t1, this._serializedLayers = null, !0;
                            }
                            _getOperationsToPerform(t1) {
                                const e1 = [], r = [];
                                for (const n of t1)switch(n.command){
                                    case "setCenter":
                                    case "setZoom":
                                    case "setBearing":
                                    case "setPitch":
                                        continue;
                                    case "addLayer":
                                        e1.push(()=>this.addLayer.apply(this, n.args));
                                        break;
                                    case "removeLayer":
                                        e1.push(()=>this.removeLayer.apply(this, n.args));
                                        break;
                                    case "setPaintProperty":
                                        e1.push(()=>this.setPaintProperty.apply(this, n.args));
                                        break;
                                    case "setLayoutProperty":
                                        e1.push(()=>this.setLayoutProperty.apply(this, n.args));
                                        break;
                                    case "setFilter":
                                        e1.push(()=>this.setFilter.apply(this, n.args));
                                        break;
                                    case "addSource":
                                        e1.push(()=>this.addSource.apply(this, n.args));
                                        break;
                                    case "removeSource":
                                        e1.push(()=>this.removeSource.apply(this, n.args));
                                        break;
                                    case "setLayerZoomRange":
                                        e1.push(()=>this.setLayerZoomRange.apply(this, n.args));
                                        break;
                                    case "setLight":
                                        e1.push(()=>this.setLight.apply(this, n.args));
                                        break;
                                    case "setGeoJSONSourceData":
                                        e1.push(()=>this.setGeoJSONSourceData.apply(this, n.args));
                                        break;
                                    case "setGlyphs":
                                        e1.push(()=>this.setGlyphs.apply(this, n.args));
                                        break;
                                    case "setSprite":
                                        e1.push(()=>this.setSprite.apply(this, n.args));
                                        break;
                                    case "setSky":
                                        e1.push(()=>this.setSky.apply(this, n.args));
                                        break;
                                    case "setTerrain":
                                        e1.push(()=>this.map.setTerrain.apply(this, n.args));
                                        break;
                                    case "setTransition":
                                        e1.push(()=>{});
                                        break;
                                    default:
                                        r.push(n.command);
                                }
                                return {
                                    operations: e1,
                                    unimplemented: r
                                };
                            }
                            addImage(t1, r) {
                                if (this.getImage(t1)) return this.fire(new e1.j(new Error(`An image named "${t1}" already exists.`)));
                                this.imageManager.addImage(t1, r), this._afterImageUpdated(t1);
                            }
                            updateImage(t1, e1) {
                                this.imageManager.updateImage(t1, e1);
                            }
                            getImage(t1) {
                                return this.imageManager.getImage(t1);
                            }
                            removeImage(t1) {
                                if (!this.getImage(t1)) return this.fire(new e1.j(new Error(`An image named "${t1}" does not exist.`)));
                                this.imageManager.removeImage(t1), this._afterImageUpdated(t1);
                            }
                            _afterImageUpdated(t1) {
                                this._availableImages = this.imageManager.listImages(), this._changedImages[t1] = !0, this._changed = !0, this.dispatcher.broadcast("SI", this._availableImages), this.fire(new e1.k("data", {
                                    dataType: "style"
                                }));
                            }
                            listImages() {
                                return this._checkLoaded(), this.imageManager.listImages();
                            }
                            addSource(t1, r, n = {}) {
                                if (this._checkLoaded(), void 0 !== this.sourceCaches[t1]) throw new Error(`Source "${t1}" already exists.`);
                                if (!r.type) throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(r).join(", ")}.`);
                                if ([
                                    "vector",
                                    "raster",
                                    "geojson",
                                    "video",
                                    "image"
                                ].indexOf(r.type) >= 0 && this._validate(e1.x.source, `sources.${t1}`, r, null, n)) return;
                                this.map && this.map._collectResourceTiming && (r.collectResourceTiming = !0);
                                const i = this.sourceCaches[t1] = new dt(t1, r, this.dispatcher);
                                i.style = this, i.setEventedParent(this, ()=>({
                                        isSourceLoaded: i.loaded(),
                                        source: i.serialize(),
                                        sourceId: t1
                                    })), i.onAdd(this.map), this._changed = !0;
                            }
                            removeSource(t1) {
                                if (this._checkLoaded(), void 0 === this.sourceCaches[t1]) throw new Error("There is no source with this ID");
                                for(const r in this._layers)if (this._layers[r].source === t1) return this.fire(new e1.j(new Error(`Source "${t1}" cannot be removed while layer "${r}" is using it.`)));
                                const r = this.sourceCaches[t1];
                                delete this.sourceCaches[t1], delete this._updatedSources[t1], r.fire(new e1.k("data", {
                                    sourceDataType: "metadata",
                                    dataType: "source",
                                    sourceId: t1
                                })), r.setEventedParent(null), r.onRemove(this.map), this._changed = !0;
                            }
                            setGeoJSONSourceData(t1, e1) {
                                if (this._checkLoaded(), void 0 === this.sourceCaches[t1]) throw new Error(`There is no source with this ID=${t1}`);
                                const r = this.sourceCaches[t1].getSource();
                                if ("geojson" !== r.type) throw new Error(`geojsonSource.type is ${r.type}, which is !== 'geojson`);
                                r.setData(e1), this._changed = !0;
                            }
                            getSource(t1) {
                                return this.sourceCaches[t1] && this.sourceCaches[t1].getSource();
                            }
                            addLayer(t1, r, n = {}) {
                                this._checkLoaded();
                                const i = t1.id;
                                if (this.getLayer(i)) return void this.fire(new e1.j(new Error(`Layer "${i}" already exists on this map.`)));
                                let a;
                                if ("custom" === t1.type) {
                                    if (fe(this, e1.aE(t1))) return;
                                    a = e1.aB(t1);
                                } else {
                                    if ("source" in t1 && "object" == typeof t1.source && (this.addSource(i, t1.source), t1 = e1.aC(t1), t1 = e1.e(t1, {
                                        source: i
                                    })), this._validate(e1.x.layer, `layers.${i}`, t1, {
                                        arrayIndex: -1
                                    }, n)) return;
                                    a = e1.aB(t1), this._validateLayer(a), a.setEventedParent(this, {
                                        layer: {
                                            id: i
                                        }
                                    });
                                }
                                const o = r ? this._order.indexOf(r) : this._order.length;
                                if (r && -1 === o) this.fire(new e1.j(new Error(`Cannot add layer "${i}" before non-existing layer "${r}".`)));
                                else {
                                    if (this._order.splice(o, 0, i), this._layerOrderChanged = !0, this._layers[i] = a, this._removedLayers[i] && a.source && "custom" !== a.type) {
                                        const t1 = this._removedLayers[i];
                                        delete this._removedLayers[i], t1.type !== a.type ? this._updatedSources[a.source] = "clear" : (this._updatedSources[a.source] = "reload", this.sourceCaches[a.source].pause());
                                    }
                                    this._updateLayer(a), a.onAdd && a.onAdd(this.map);
                                }
                            }
                            moveLayer(t1, r) {
                                if (this._checkLoaded(), this._changed = !0, !this._layers[t1]) return void this.fire(new e1.j(new Error(`The layer '${t1}' does not exist in the map's style and cannot be moved.`)));
                                if (t1 === r) return;
                                const n = this._order.indexOf(t1);
                                this._order.splice(n, 1);
                                const i = r ? this._order.indexOf(r) : this._order.length;
                                r && -1 === i ? this.fire(new e1.j(new Error(`Cannot move layer "${t1}" before non-existing layer "${r}".`))) : (this._order.splice(i, 0, t1), this._layerOrderChanged = !0);
                            }
                            removeLayer(t1) {
                                this._checkLoaded();
                                const r = this._layers[t1];
                                if (!r) return void this.fire(new e1.j(new Error(`Cannot remove non-existing layer "${t1}".`)));
                                r.setEventedParent(null);
                                const n = this._order.indexOf(t1);
                                this._order.splice(n, 1), this._layerOrderChanged = !0, this._changed = !0, this._removedLayers[t1] = r, delete this._layers[t1], this._serializedLayers && delete this._serializedLayers[t1], delete this._updatedLayers[t1], delete this._updatedPaintProps[t1], r.onRemove && r.onRemove(this.map);
                            }
                            getLayer(t1) {
                                return this._layers[t1];
                            }
                            getLayersOrder() {
                                return [
                                    ...this._order
                                ];
                            }
                            hasLayer(t1) {
                                return t1 in this._layers;
                            }
                            setLayerZoomRange(t1, r, n) {
                                this._checkLoaded();
                                const i = this.getLayer(t1);
                                i ? i.minzoom === r && i.maxzoom === n || (null != r && (i.minzoom = r), null != n && (i.maxzoom = n), this._updateLayer(i)) : this.fire(new e1.j(new Error(`Cannot set the zoom range of non-existing layer "${t1}".`)));
                            }
                            setFilter(t1, r, n = {}) {
                                this._checkLoaded();
                                const i = this.getLayer(t1);
                                if (i) {
                                    if (!e1.aF(i.filter, r)) return null == r ? (i.filter = void 0, void this._updateLayer(i)) : void (this._validate(e1.x.filter, `layers.${i.id}.filter`, r, null, n) || (i.filter = e1.aC(r), this._updateLayer(i)));
                                } else this.fire(new e1.j(new Error(`Cannot filter non-existing layer "${t1}".`)));
                            }
                            getFilter(t1) {
                                return e1.aC(this.getLayer(t1).filter);
                            }
                            setLayoutProperty(t1, r, n, i = {}) {
                                this._checkLoaded();
                                const a = this.getLayer(t1);
                                a ? e1.aF(a.getLayoutProperty(r), n) || (a.setLayoutProperty(r, n, i), this._updateLayer(a)) : this.fire(new e1.j(new Error(`Cannot style non-existing layer "${t1}".`)));
                            }
                            getLayoutProperty(t1, r) {
                                const n = this.getLayer(t1);
                                if (n) return n.getLayoutProperty(r);
                                this.fire(new e1.j(new Error(`Cannot get style of non-existing layer "${t1}".`)));
                            }
                            setPaintProperty(t1, r, n, i = {}) {
                                this._checkLoaded();
                                const a = this.getLayer(t1);
                                a ? e1.aF(a.getPaintProperty(r), n) || (a.setPaintProperty(r, n, i) && this._updateLayer(a), this._changed = !0, this._updatedPaintProps[t1] = !0, this._serializedLayers = null) : this.fire(new e1.j(new Error(`Cannot style non-existing layer "${t1}".`)));
                            }
                            getPaintProperty(t1, e1) {
                                return this.getLayer(t1).getPaintProperty(e1);
                            }
                            setFeatureState(t1, r) {
                                this._checkLoaded();
                                const n = t1.source, i = t1.sourceLayer, a = this.sourceCaches[n];
                                if (void 0 === a) return void this.fire(new e1.j(new Error(`The source '${n}' does not exist in the map's style.`)));
                                const o = a.getSource().type;
                                "geojson" === o && i ? this.fire(new e1.j(new Error("GeoJSON sources cannot have a sourceLayer parameter."))) : "vector" !== o || i ? (void 0 === t1.id && this.fire(new e1.j(new Error("The feature id parameter must be provided."))), a.setFeatureState(i, t1.id, r)) : this.fire(new e1.j(new Error("The sourceLayer parameter must be provided for vector source types.")));
                            }
                            removeFeatureState(t1, r) {
                                this._checkLoaded();
                                const n = t1.source, i = this.sourceCaches[n];
                                if (void 0 === i) return void this.fire(new e1.j(new Error(`The source '${n}' does not exist in the map's style.`)));
                                const a = i.getSource().type, o = "vector" === a ? t1.sourceLayer : void 0;
                                "vector" !== a || o ? r && "string" != typeof t1.id && "number" != typeof t1.id ? this.fire(new e1.j(new Error("A feature id is required to remove its specific state property."))) : i.removeFeatureState(o, t1.id, r) : this.fire(new e1.j(new Error("The sourceLayer parameter must be provided for vector source types.")));
                            }
                            getFeatureState(t1) {
                                this._checkLoaded();
                                const r = t1.source, n = t1.sourceLayer, i = this.sourceCaches[r];
                                if (void 0 !== i) return "vector" !== i.getSource().type || n ? (void 0 === t1.id && this.fire(new e1.j(new Error("The feature id parameter must be provided."))), i.getFeatureState(n, t1.id)) : void this.fire(new e1.j(new Error("The sourceLayer parameter must be provided for vector source types.")));
                                this.fire(new e1.j(new Error(`The source '${r}' does not exist in the map's style.`)));
                            }
                            getTransition() {
                                return e1.e({
                                    duration: 300,
                                    delay: 0
                                }, this.stylesheet && this.stylesheet.transition);
                            }
                            serialize() {
                                if (!this._loaded) return;
                                const t1 = e1.aG(this.sourceCaches, (t1)=>t1.serialize()), r = this._serializeByIds(this._order), n = this.map.getTerrain() || void 0, i = this.stylesheet;
                                return e1.aH({
                                    version: i.version,
                                    name: i.name,
                                    metadata: i.metadata,
                                    light: i.light,
                                    sky: i.sky,
                                    center: i.center,
                                    zoom: i.zoom,
                                    bearing: i.bearing,
                                    pitch: i.pitch,
                                    sprite: i.sprite,
                                    glyphs: i.glyphs,
                                    transition: i.transition,
                                    sources: t1,
                                    layers: r,
                                    terrain: n
                                }, (t1)=>void 0 !== t1);
                            }
                            _updateLayer(t1) {
                                this._updatedLayers[t1.id] = !0, t1.source && !this._updatedSources[t1.source] && "raster" !== this.sourceCaches[t1.source].getSource().type && (this._updatedSources[t1.source] = "reload", this.sourceCaches[t1.source].pause()), this._serializedLayers = null, this._changed = !0;
                            }
                            _flattenAndSortRenderedFeatures(t1) {
                                const e1 = (t1)=>"fill-extrusion" === this._layers[t1].type, r = {}, n = [];
                                for(let i = this._order.length - 1; i >= 0; i--){
                                    const a = this._order[i];
                                    if (e1(a)) {
                                        r[a] = i;
                                        for (const e1 of t1){
                                            const t1 = e1[a];
                                            if (t1) for (const e1 of t1)n.push(e1);
                                        }
                                    }
                                }
                                n.sort((t1, e1)=>e1.intersectionZ - t1.intersectionZ);
                                const i = [];
                                for(let a = this._order.length - 1; a >= 0; a--){
                                    const o = this._order[a];
                                    if (e1(o)) for(let t1 = n.length - 1; t1 >= 0; t1--){
                                        const e1 = n[t1].feature;
                                        if (r[e1.layer.id] < a) break;
                                        i.push(e1), n.pop();
                                    }
                                    else for (const e1 of t1){
                                        const t1 = e1[o];
                                        if (t1) for (const e1 of t1)i.push(e1.feature);
                                    }
                                }
                                return i;
                            }
                            queryRenderedFeatures(t1, r, n) {
                                r && r.filter && this._validate(e1.x.filter, "queryRenderedFeatures.filter", r.filter, null, r);
                                const i = {};
                                if (r && r.layers) {
                                    if (!Array.isArray(r.layers)) return this.fire(new e1.j(new Error("parameters.layers must be an Array."))), [];
                                    for (const t1 of r.layers){
                                        const r = this._layers[t1];
                                        if (!r) return this.fire(new e1.j(new Error(`The layer '${t1}' does not exist in the map's style and cannot be queried for features.`))), [];
                                        i[r.source] = !0;
                                    }
                                }
                                const a = [];
                                r.availableImages = this._availableImages;
                                const o = this._serializedAllLayers();
                                for(const e1 in this.sourceCaches)r.layers && !i[e1] || a.push(Z(this.sourceCaches[e1], this._layers, o, t1, r, n));
                                return this.placement && a.push(function(t1, e1, r, n, i, a, o) {
                                    const s = {}, l = a.queryRenderedSymbols(n), c = [];
                                    for (const t1 of Object.keys(l).map(Number))c.push(o[t1]);
                                    c.sort(W);
                                    for (const r of c){
                                        const n = r.featureIndex.lookupSymbolFeatures(l[r.bucketInstanceId], e1, r.bucketIndex, r.sourceLayerIndex, i.filter, i.layers, i.availableImages, t1);
                                        for(const t1 in n){
                                            const e1 = s[t1] = s[t1] || [], i = n[t1];
                                            i.sort((t1, e1)=>{
                                                const n = r.featureSortOrder;
                                                if (n) {
                                                    const r = n.indexOf(t1.featureIndex);
                                                    return n.indexOf(e1.featureIndex) - r;
                                                }
                                                return e1.featureIndex - t1.featureIndex;
                                            });
                                            for (const t1 of i)e1.push(t1);
                                        }
                                    }
                                    for(const e1 in s)s[e1].forEach((n)=>{
                                        const i = n.feature, a = t1[e1], o = r[a.source].getFeatureState(i.layer["source-layer"], i.id);
                                        i.source = i.layer.source, i.layer["source-layer"] && (i.sourceLayer = i.layer["source-layer"]), i.state = o;
                                    });
                                    return s;
                                }(this._layers, o, this.sourceCaches, t1, r, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(a);
                            }
                            querySourceFeatures(t1, r) {
                                r && r.filter && this._validate(e1.x.filter, "querySourceFeatures.filter", r.filter, null, r);
                                const n = this.sourceCaches[t1];
                                return n ? function(t1, e1) {
                                    const r = t1.getRenderableIds().map((e1)=>t1.getTileByID(e1)), n = [], i = {};
                                    for(let t1 = 0; t1 < r.length; t1++){
                                        const a = r[t1], o = a.tileID.canonical.key;
                                        i[o] || (i[o] = !0, a.querySourceFeatures(n, e1));
                                    }
                                    return n;
                                }(n, r) : [];
                            }
                            getLight() {
                                return this.light.getLight();
                            }
                            setLight(t1, r = {}) {
                                this._checkLoaded();
                                const n = this.light.getLight();
                                let i = !1;
                                for(const r in t1)if (!e1.aF(t1[r], n[r])) {
                                    i = !0;
                                    break;
                                }
                                if (!i) return;
                                const o = {
                                    now: a.now(),
                                    transition: e1.e({
                                        duration: 300,
                                        delay: 0
                                    }, this.stylesheet.transition)
                                };
                                this.light.setLight(t1, r), this.light.updateTransitions(o);
                            }
                            getSky() {
                                var t1;
                                return null === (t1 = this.stylesheet) || void 0 === t1 ? void 0 : t1.sky;
                            }
                            setSky(t1, r = {}) {
                                const n = this.sky.getSky();
                                let i = !1;
                                t1 || n && (i = !0);
                                for(const r in t1)if (!e1.aF(t1[r], n[r])) {
                                    i = !0;
                                    break;
                                }
                                if (!i) return;
                                const o = {
                                    now: a.now(),
                                    transition: e1.e({
                                        duration: 300,
                                        delay: 0
                                    }, this.stylesheet.transition)
                                };
                                this.stylesheet.sky = t1, this.sky.setSky(t1, r), this.sky.updateTransitions(o);
                            }
                            _validate(t1, r, n, i, a = {}) {
                                return (!a || !1 !== a.validate) && fe(this, t1.call(e1.x, e1.e({
                                    key: r,
                                    style: this.serialize(),
                                    value: n,
                                    styleSpec: e1.v
                                }, i)));
                            }
                            _remove(t1 = !0) {
                                this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._loadStyleRequest && (this._loadStyleRequest.abort(), this._loadStyleRequest = null), this._spriteRequest && (this._spriteRequest.abort(), this._spriteRequest = null), ut().off(st, this._rtlPluginLoaded);
                                for(const t1 in this._layers)this._layers[t1].setEventedParent(null);
                                for(const t1 in this.sourceCaches){
                                    const e1 = this.sourceCaches[t1];
                                    e1.setEventedParent(null), e1.onRemove(this.map);
                                }
                                this.imageManager.setEventedParent(null), this.setEventedParent(null), t1 && this.dispatcher.broadcast("RM", void 0), this.dispatcher.remove(t1);
                            }
                            _clearSource(t1) {
                                this.sourceCaches[t1].clearTiles();
                            }
                            _reloadSource(t1) {
                                this.sourceCaches[t1].resume(), this.sourceCaches[t1].reload();
                            }
                            _updateSources(t1) {
                                for(const e1 in this.sourceCaches)this.sourceCaches[e1].update(t1, this.map.terrain);
                            }
                            _generateCollisionBoxes() {
                                for(const t1 in this.sourceCaches)this._reloadSource(t1);
                            }
                            _updatePlacement(t1, e1, r, n, i = !1) {
                                let o = !1, s = !1;
                                const l = {};
                                for (const e1 of this._order){
                                    const r = this._layers[e1];
                                    if ("symbol" !== r.type) continue;
                                    if (!l[r.source]) {
                                        const t1 = this.sourceCaches[r.source];
                                        l[r.source] = t1.getRenderableIds(!0).map((e1)=>t1.getTileByID(e1)).sort((t1, e1)=>e1.tileID.overscaledZ - t1.tileID.overscaledZ || (t1.tileID.isLessThan(e1.tileID) ? -1 : 1));
                                    }
                                    const n = this.crossTileSymbolIndex.addLayer(r, l[r.source], t1.center.lng);
                                    o = o || n;
                                }
                                if (this.crossTileSymbolIndex.pruneUnusedLayers(this._order), ((i = i || this._layerOrderChanged || 0 === r) || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(a.now(), t1.zoom)) && (this.pauseablePlacement = new oe(t1, this.map.terrain, this._order, i, e1, r, n, this.placement), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._order, this._layers, l), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(a.now()), s = !0), o && this.pauseablePlacement.placement.setStale()), s || o) for (const t1 of this._order){
                                    const e1 = this._layers[t1];
                                    "symbol" === e1.type && this.placement.updateLayerOpacities(e1, l[e1.source]);
                                }
                                return !this.pauseablePlacement.isDone() || this.placement.hasTransitions(a.now());
                            }
                            _releaseSymbolFadeTiles() {
                                for(const t1 in this.sourceCaches)this.sourceCaches[t1].releaseSymbolFadeTiles();
                            }
                            getImages(t1, r) {
                                return e1._(this, void 0, void 0, function*() {
                                    const t1 = yield this.imageManager.getImages(r.icons);
                                    this._updateTilesForChangedImages();
                                    const e1 = this.sourceCaches[r.source];
                                    return e1 && e1.setDependencies(r.tileID.key, r.type, r.icons), t1;
                                });
                            }
                            getGlyphs(t1, r) {
                                return e1._(this, void 0, void 0, function*() {
                                    const t1 = yield this.glyphManager.getGlyphs(r.stacks), e1 = this.sourceCaches[r.source];
                                    return e1 && e1.setDependencies(r.tileID.key, r.type, [
                                        ""
                                    ]), t1;
                                });
                            }
                            getGlyphsUrl() {
                                return this.stylesheet.glyphs || null;
                            }
                            setGlyphs(t1, r = {}) {
                                this._checkLoaded(), t1 && this._validate(e1.x.glyphs, "glyphs", t1, null, r) || (this._glyphsDidChange = !0, this.stylesheet.glyphs = t1, this.glyphManager.entries = {}, this.glyphManager.setURL(t1));
                            }
                            addSprite(t1, r, n = {}, i) {
                                this._checkLoaded();
                                const a = [
                                    {
                                        id: t1,
                                        url: r
                                    }
                                ], o = [
                                    ...x(this.stylesheet.sprite),
                                    ...a
                                ];
                                this._validate(e1.x.sprite, "sprite", o, null, n) || (this.stylesheet.sprite = o, this._loadSprite(a, !0, i));
                            }
                            removeSprite(t1) {
                                this._checkLoaded();
                                const r = x(this.stylesheet.sprite);
                                if (r.find((e1)=>e1.id === t1)) {
                                    if (this._spritesImagesIds[t1]) for (const e1 of this._spritesImagesIds[t1])this.imageManager.removeImage(e1), this._changedImages[e1] = !0;
                                    r.splice(r.findIndex((e1)=>e1.id === t1), 1), this.stylesheet.sprite = r.length > 0 ? r : void 0, delete this._spritesImagesIds[t1], this._availableImages = this.imageManager.listImages(), this._changed = !0, this.dispatcher.broadcast("SI", this._availableImages), this.fire(new e1.k("data", {
                                        dataType: "style"
                                    }));
                                } else this.fire(new e1.j(new Error(`Sprite "${t1}" doesn't exists on this map.`)));
                            }
                            getSprite() {
                                return x(this.stylesheet.sprite);
                            }
                            setSprite(t1, r = {}, n) {
                                this._checkLoaded(), t1 && this._validate(e1.x.sprite, "sprite", t1, null, r) || (this.stylesheet.sprite = t1, t1 ? this._loadSprite(t1, !0, n) : (this._unloadSprite(), n && n(null)));
                            }
                        }
                        var me = e1.Y([
                            {
                                name: "a_pos",
                                type: "Int16",
                                components: 2
                            }
                        ]);
                        const ge = {
                            prelude: ye("#ifdef GL_ES\nprecision mediump float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\n", "#ifdef GL_ES\nprecision highp float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}\n#ifdef TERRAIN3D\nuniform sampler2D u_terrain;uniform float u_terrain_dim;uniform mat4 u_terrain_matrix;uniform vec4 u_terrain_unpack;uniform float u_terrain_exaggeration;uniform highp sampler2D u_depth;\n#endif\nconst highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitShifts=vec4(1.)/bitSh;highp float unpack(highp vec4 color) {return dot(color,bitShifts);}highp float depthOpacity(vec3 frag) {\n#ifdef TERRAIN3D\nhighp float d=unpack(texture2D(u_depth,frag.xy*0.5+0.5))+0.0001-frag.z;return 1.0-max(0.0,min(1.0,-d*500.0));\n#else\nreturn 1.0;\n#endif\n}float calculate_visibility(vec4 pos) {\n#ifdef TERRAIN3D\nvec3 frag=pos.xyz/pos.w;highp float d=depthOpacity(frag);if (d > 0.95) return 1.0;return (d+depthOpacity(frag+vec3(0.0,0.01,0.0)))/2.0;\n#else\nreturn 1.0;\n#endif\n}float ele(vec2 pos) {\n#ifdef TERRAIN3D\nvec4 rgb=(texture2D(u_terrain,pos)*255.0)*u_terrain_unpack;return rgb.r+rgb.g+rgb.b-u_terrain_unpack.a;\n#else\nreturn 0.0;\n#endif\n}float get_elevation(vec2 pos) {\n#ifdef TERRAIN3D\nvec2 coord=(u_terrain_matrix*vec4(pos,0.0,1.0)).xy*u_terrain_dim+1.0;vec2 f=fract(coord);vec2 c=(floor(coord)+0.5)/(u_terrain_dim+2.0);float d=1.0/(u_terrain_dim+2.0);float tl=ele(c);float tr=ele(c+vec2(d,0.0));float bl=ele(c+vec2(0.0,d));float br=ele(c+vec2(d,d));float elevation=mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);return elevation*u_terrain_exaggeration;\n#else\nreturn 0.0;\n#endif\n}"),
                            background: ye("uniform vec4 u_color;uniform float u_opacity;void main() {gl_FragColor=u_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),
                            backgroundPattern: ye("uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_mix)*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}"),
                            circle: ye("varying vec3 v_data;varying float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);lowp float antialiasblur=v_data.z;float antialiased_blur=-max(blur,antialiasblur);float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));gl_FragColor=v_visibility*opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;attribute vec2 a_pos;varying vec3 v_data;varying float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);float ele=get_elevation(circle_center);v_visibility=calculate_visibility(u_matrix*vec4(circle_center,ele,1.0));if (u_pitch_with_map) {vec2 corner_position=circle_center;if (u_scale_with_map) {corner_position+=extrude*(radius+stroke_width)*u_extrude_scale;} else {vec4 projected_center=u_matrix*vec4(circle_center,0,1);corner_position+=extrude*(radius+stroke_width)*u_extrude_scale*(projected_center.w/u_camera_to_center_distance);}gl_Position=u_matrix*vec4(corner_position,ele,1);} else {gl_Position=u_matrix*vec4(circle_center,ele,1);if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);}"),
                            clippingMask: ye("void main() {gl_FragColor=vec4(1.0);}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),
                            heatmap: ye("uniform highp float u_intensity;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);gl_FragColor=vec4(val,1.0,1.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;attribute vec2 a_pos;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec4 pos=vec4(floor(a_pos*0.5)+extrude,0,1);gl_Position=u_matrix*pos;}"),
                            heatmapTexture: ye("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;varying vec2 v_pos;void main() {float t=texture2D(u_image,v_pos).r;vec4 color=texture2D(u_color_ramp,vec2(t,0.5));gl_FragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(0.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}"),
                            collisionBox: ye("varying float v_placed;varying float v_notUsed;void main() {float alpha=0.5;gl_FragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {gl_FragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {gl_FragColor*=.1;}}", "attribute vec2 a_anchor_pos;attribute vec2 a_placed;attribute vec2 a_box_real;uniform mat4 u_matrix;uniform vec2 u_pixel_extrude_scale;varying float v_placed;varying float v_notUsed;vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return u_matrix*vec4(posInTile,elevation,1.0);}void main() {gl_Position=projectTileWithElevation(a_anchor_pos,get_elevation(a_anchor_pos));gl_Position.xy=((a_box_real+0.5)*u_pixel_extrude_scale*2.0-1.0)*vec2(1.0,-1.0)*gl_Position.w;if (gl_Position.z/gl_Position.w < 1.1) {gl_Position.z=0.5;}v_placed=a_placed.x;v_notUsed=a_placed.y;}"),
                            collisionCircle: ye("varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);gl_FragColor=color*alpha*opacity_t;}", "attribute vec2 a_pos;attribute float a_radius;attribute vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(mix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"),
                            debug: ye("uniform highp vec4 u_color;uniform sampler2D u_overlay;varying vec2 v_uv;void main() {vec4 overlay_color=texture2D(u_overlay,v_uv);gl_FragColor=mix(u_color,overlay_color,overlay_color.a);}", "attribute vec2 a_pos;varying vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {v_uv=a_pos/8192.0;gl_Position=u_matrix*vec4(a_pos*u_overlay_scale,get_elevation(a_pos),1);}"),
                            fill: ye("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_FragColor=color*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);}"),
                            fillOutline: ye("varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=outline_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"),
                            fillOutlinePattern: ye("uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=mix(color1,color2,u_fade)*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"),
                            fillPattern: ye("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_fade)*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}"),
                            fillExtrusion: ye("varying vec4 v_color;void main() {gl_FragColor=v_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;attribute vec2 a_pos;attribute vec4 a_normal_ed;\n#ifdef TERRAIN3D\nattribute vec2 a_centroid;\n#endif\nvarying vec4 v_color;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec3 normal=a_normal_ed.xyz;\n#ifdef TERRAIN3D\nfloat height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);\n#else\nfloat height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;\n#endif\nbase=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);gl_Position=u_matrix*vec4(a_pos,t > 0.0 ? height : base,1);float colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;float directional=clamp(dot(normal/16384.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}"),
                            fillExtrusionPattern: ye("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);gl_FragColor=mixedColor*v_lighting;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;attribute vec2 a_pos;attribute vec4 a_normal_ed;\n#ifdef TERRAIN3D\nattribute vec2 a_centroid;\n#endif\nvarying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec3 normal=a_normal_ed.xyz;float edgedistance=a_normal_ed.w;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;\n#ifdef TERRAIN3D\nfloat height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);\n#else\nfloat height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;\n#endif\nbase=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);float z=t > 0.0 ? height : base;gl_Position=u_matrix*vec4(a_pos,z,1);vec2 pos=normal.x==1.0 && normal.y==0.0 && normal.z==16384.0\n? a_pos\n: vec2(edgedistance,z*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}"),
                            hillshadePrepare: ye("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform vec4 u_unpack;float getElevation(vec2 coord,float bias) {vec4 data=texture2D(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack)/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y),0.0);float b=getElevation(v_pos+vec2(0,-epsilon.y),0.0);float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y),0.0);float d=getElevation(v_pos+vec2(-epsilon.x,0),0.0);float e=getElevation(v_pos,0.0);float f=getElevation(v_pos+vec2(epsilon.x,0),0.0);float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y),0.0);float h=getElevation(v_pos+vec2(0,epsilon.y),0.0);float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y),0.0);float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))/pow(2.0,exaggeration+(19.2562-u_zoom));gl_FragColor=clamp(vec4(deriv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_dimension;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"),
                            hillshade: ye("uniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;\n#define PI 3.141592653589793\nvoid main() {vec4 pixel=texture2D(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);gl_FragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;}"),
                            line: ye("uniform lowp float u_device_pixel_ratio;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp float v_linesofar;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_width2=vec2(outset,inset);}"),
                            lineGradient: ye("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;varying highp vec2 v_uv;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture2D(u_image,v_uv);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;attribute float a_uv_x;attribute float a_split_index;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_image_height;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp vec2 v_uv;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;highp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_width2=vec2(outset,inset);}"),
                            linePattern: ye("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture2D(u_image,pos_a),texture2D(u_image,pos_b),u_fade);gl_FragColor=color*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform vec2 u_units_to_pixels;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;}"),
                            lineSDF: ye("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;uniform float u_sdfgamma;uniform float u_mix;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture2D(u_image,v_tex_a).a;float sdfdist_b=texture2D(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);alpha*=smoothstep(0.5-u_sdfgamma/floorwidth,0.5+u_sdfgamma/floorwidth,sdfdist);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_patternscale_a;uniform float u_tex_y_a;uniform vec2 u_patternscale_b;uniform float u_tex_y_b;uniform vec2 u_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_tex_a=vec2(a_linesofar*u_patternscale_a.x/floorwidth,normal.y*u_patternscale_a.y+u_tex_y_a);v_tex_b=vec2(a_linesofar*u_patternscale_b.x/floorwidth,normal.y*u_patternscale_b.y+u_tex_y_b);v_width2=vec2(outset,inset);}"),
                            raster: ye("uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;varying vec2 v_pos0;varying vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture2D(u_image0,v_pos0);vec4 color1=texture2D(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);gl_FragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos0;varying vec2 v_pos1;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos0=(((a_texture_pos/8192.0)-0.5)/u_buffer_scale )+0.5;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}"),
                            symbolIcon: ye("uniform sampler2D u_texture;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nlowp float alpha=opacity*v_fade_opacity;gl_FragColor=texture2D(u_texture,v_tex)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform vec2 u_translation;uniform float u_pitched_scale;varying vec2 v_tex;varying float v_fade_opacity;vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return u_matrix*vec4(posInTile,elevation,1.0);}\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;vec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}gl_Position=finalPos;v_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float visibility=calculate_visibility(projectedPoint);v_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));}"),
                            symbolSDF: ye("#define SDF_PX 8.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float inner_edge=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);inner_edge=inner_edge+gamma*gamma_scale;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(inner_edge-gamma_scaled,inner_edge+gamma_scaled,dist);if (u_is_halo) {lowp float halo_edge=(6.0-halo_width/fontScale)/SDF_PX;alpha=min(smoothstep(halo_edge-gamma_scaled,halo_edge+gamma_scaled,dist),1.0-alpha);}gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_translation;uniform float u_pitched_scale;varying vec2 v_data0;varying vec3 v_data1;vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return u_matrix*vec4(posInTile,elevation,1.0);}\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;vec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}float gamma_scale=finalPos.w;gl_Position=finalPos;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,interpolated_fade_opacity);}"),
                            symbolTextAndIcon: ye("#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;gl_FragColor=texture2D(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform vec2 u_translation;uniform float u_pitched_scale;varying vec4 v_data0;varying vec4 v_data1;vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return u_matrix*vec4(posInTile,elevation,1.0);}\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;vec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}float gamma_scale=finalPos.w;gl_Position=finalPos;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,interpolated_fade_opacity,is_sdf);}"),
                            terrain: ye("uniform sampler2D u_texture;uniform vec4 u_fog_color;uniform vec4 u_horizon_color;uniform float u_fog_ground_blend;uniform float u_fog_ground_blend_opacity;uniform float u_horizon_fog_blend;varying vec2 v_texture_pos;varying float v_fog_depth;const float gamma=2.2;vec4 gammaToLinear(vec4 color) {return pow(color,vec4(gamma));}vec4 linearToGamma(vec4 color) {return pow(color,vec4(1.0/gamma));}void main() {vec4 surface_color=texture2D(u_texture,v_texture_pos);if (v_fog_depth > u_fog_ground_blend) {vec4 surface_color_linear=gammaToLinear(surface_color);float blend_color=smoothstep(0.0,1.0,max((v_fog_depth-u_horizon_fog_blend)/(1.0-u_horizon_fog_blend),0.0));vec4 fog_horizon_color_linear=mix(gammaToLinear(u_fog_color),gammaToLinear(u_horizon_color),blend_color);float factor_fog=max(v_fog_depth-u_fog_ground_blend,0.0)/(1.0-u_fog_ground_blend);gl_FragColor=linearToGamma(mix(surface_color_linear,fog_horizon_color_linear,pow(factor_fog,2.0)*u_fog_ground_blend_opacity));} else {gl_FragColor=surface_color;}}", "attribute vec3 a_pos3d;uniform mat4 u_matrix;uniform mat4 u_fog_matrix;uniform float u_ele_delta;varying vec2 v_texture_pos;varying float v_fog_depth;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;v_texture_pos=a_pos3d.xy/8192.0;gl_Position=u_matrix*vec4(a_pos3d.xy,ele-ele_delta,1.0);vec4 pos=u_fog_matrix*vec4(a_pos3d.xy,ele,1.0);v_fog_depth=pos.z/pos.w*0.5+0.5;}"),
                            terrainDepth: ye("varying float v_depth;const highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitMsk=vec4(0.,vec3(1./256.0));highp vec4 pack(highp float value) {highp vec4 comp=fract(value*bitSh);comp-=comp.xxyz*bitMsk;return comp;}void main() {gl_FragColor=pack(v_depth);}", "attribute vec3 a_pos3d;uniform mat4 u_matrix;uniform float u_ele_delta;varying float v_depth;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;gl_Position=u_matrix*vec4(a_pos3d.xy,ele-ele_delta,1.0);v_depth=gl_Position.z/gl_Position.w;}"),
                            terrainCoords: ye("precision mediump float;uniform sampler2D u_texture;uniform float u_terrain_coords_id;varying vec2 v_texture_pos;void main() {vec4 rgba=texture2D(u_texture,v_texture_pos);gl_FragColor=vec4(rgba.r,rgba.g,rgba.b,u_terrain_coords_id);}", "attribute vec3 a_pos3d;uniform mat4 u_matrix;uniform float u_ele_delta;varying vec2 v_texture_pos;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;v_texture_pos=a_pos3d.xy/8192.0;gl_Position=u_matrix*vec4(a_pos3d.xy,ele-ele_delta,1.0);}"),
                            sky: ye("uniform vec4 u_sky_color;uniform vec4 u_horizon_color;uniform float u_horizon;uniform float u_sky_horizon_blend;void main() {float y=gl_FragCoord.y;if (y > u_horizon) {float blend=y-u_horizon;if (blend < u_sky_horizon_blend) {gl_FragColor=mix(u_sky_color,u_horizon_color,pow(1.0-blend/u_sky_horizon_blend,2.0));} else {gl_FragColor=u_sky_color;}}}", "attribute vec2 a_pos;void main() {gl_Position=vec4(a_pos,1.0,1.0);}")
                        };
                        function ye(t1, e1) {
                            const r = /#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g, n = e1.match(/attribute ([\w]+) ([\w]+)/g), i = t1.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), a = e1.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), o = a ? a.concat(i) : i, s = {};
                            return {
                                fragmentSource: t1 = t1.replace(r, (t1, e1, r, n, i)=>(s[i] = !0, "define" === e1 ? `\n#ifndef HAS_UNIFORM_u_${i}\nvarying ${r} ${n} ${i};\n#else\nuniform ${r} ${n} u_${i};\n#endif\n` : `\n#ifdef HAS_UNIFORM_u_${i}\n    ${r} ${n} ${i} = u_${i};\n#endif\n`)),
                                vertexSource: e1 = e1.replace(r, (t1, e1, r, n, i)=>{
                                    const a = "float" === n ? "vec2" : "vec4", o = i.match(/color/) ? "color" : a;
                                    return s[i] ? "define" === e1 ? `\n#ifndef HAS_UNIFORM_u_${i}\nuniform lowp float u_${i}_t;\nattribute ${r} ${a} a_${i};\nvarying ${r} ${n} ${i};\n#else\nuniform ${r} ${n} u_${i};\n#endif\n` : "vec4" === o ? `\n#ifndef HAS_UNIFORM_u_${i}\n    ${i} = a_${i};\n#else\n    ${r} ${n} ${i} = u_${i};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${i}\n    ${i} = unpack_mix_${o}(a_${i}, u_${i}_t);\n#else\n    ${r} ${n} ${i} = u_${i};\n#endif\n` : "define" === e1 ? `\n#ifndef HAS_UNIFORM_u_${i}\nuniform lowp float u_${i}_t;\nattribute ${r} ${a} a_${i};\n#else\nuniform ${r} ${n} u_${i};\n#endif\n` : "vec4" === o ? `\n#ifndef HAS_UNIFORM_u_${i}\n    ${r} ${n} ${i} = a_${i};\n#else\n    ${r} ${n} ${i} = u_${i};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${i}\n    ${r} ${n} ${i} = unpack_mix_${o}(a_${i}, u_${i}_t);\n#else\n    ${r} ${n} ${i} = u_${i};\n#endif\n`;
                                }),
                                staticAttributes: n,
                                staticUniforms: o
                            };
                        }
                        class ve {
                            constructor(){
                                this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffer = null, this.vao = null;
                            }
                            bind(t1, e1, r, n, i, a, o, s, l) {
                                this.context = t1;
                                let c = this.boundPaintVertexBuffers.length !== n.length;
                                for(let t1 = 0; !c && t1 < n.length; t1++)this.boundPaintVertexBuffers[t1] !== n[t1] && (c = !0);
                                !this.vao || this.boundProgram !== e1 || this.boundLayoutVertexBuffer !== r || c || this.boundIndexBuffer !== i || this.boundVertexOffset !== a || this.boundDynamicVertexBuffer !== o || this.boundDynamicVertexBuffer2 !== s || this.boundDynamicVertexBuffer3 !== l ? this.freshBind(e1, r, n, i, a, o, s, l) : (t1.bindVertexArray.set(this.vao), o && o.bind(), i && i.dynamicDraw && i.bind(), s && s.bind(), l && l.bind());
                            }
                            freshBind(t1, e1, r, n, i, a, o, s) {
                                const l = t1.numAttributes, c = this.context, u = c.gl;
                                this.vao && this.destroy(), this.vao = c.createVertexArray(), c.bindVertexArray.set(this.vao), this.boundProgram = t1, this.boundLayoutVertexBuffer = e1, this.boundPaintVertexBuffers = r, this.boundIndexBuffer = n, this.boundVertexOffset = i, this.boundDynamicVertexBuffer = a, this.boundDynamicVertexBuffer2 = o, this.boundDynamicVertexBuffer3 = s, e1.enableAttributes(u, t1);
                                for (const e1 of r)e1.enableAttributes(u, t1);
                                a && a.enableAttributes(u, t1), o && o.enableAttributes(u, t1), s && s.enableAttributes(u, t1), e1.bind(), e1.setVertexAttribPointers(u, t1, i);
                                for (const e1 of r)e1.bind(), e1.setVertexAttribPointers(u, t1, i);
                                a && (a.bind(), a.setVertexAttribPointers(u, t1, i)), n && n.bind(), o && (o.bind(), o.setVertexAttribPointers(u, t1, i)), s && (s.bind(), s.setVertexAttribPointers(u, t1, i)), c.currentNumAttributes = l;
                            }
                            destroy() {
                                this.vao && (this.context.deleteVertexArray(this.vao), this.vao = null);
                            }
                        }
                        const xe = (t1, r, n, i, a)=>({
                                u_matrix: t1,
                                u_texture: 0,
                                u_ele_delta: r,
                                u_fog_matrix: n,
                                u_fog_color: i ? i.properties.get("fog-color") : e1.aN.white,
                                u_fog_ground_blend: i ? i.properties.get("fog-ground-blend") : 1,
                                u_fog_ground_blend_opacity: i ? i.calculateFogBlendOpacity(a) : 0,
                                u_horizon_color: i ? i.properties.get("horizon-color") : e1.aN.white,
                                u_horizon_fog_blend: i ? i.properties.get("horizon-fog-blend") : 1
                            });
                        function _e(t1) {
                            const e1 = [];
                            for(let r = 0; r < t1.length; r++){
                                if (null === t1[r]) continue;
                                const n = t1[r].split(" ");
                                e1.push(n.pop());
                            }
                            return e1;
                        }
                        class be {
                            constructor(t1, r, n, i, a, o){
                                const s = t1.gl;
                                this.program = s.createProgram();
                                const l = _e(r.staticAttributes), c = n ? n.getBinderAttributes() : [], u = l.concat(c), h = ge.prelude.staticUniforms ? _e(ge.prelude.staticUniforms) : [], f = r.staticUniforms ? _e(r.staticUniforms) : [], p = n ? n.getBinderUniforms() : [], d = h.concat(f).concat(p), m = [];
                                for (const t1 of d)m.indexOf(t1) < 0 && m.push(t1);
                                const g = n ? n.defines() : [];
                                a && g.push("#define OVERDRAW_INSPECTOR;"), o && g.push("#define TERRAIN3D;");
                                const y = g.concat(ge.prelude.fragmentSource, r.fragmentSource).join("\n"), v = g.concat(ge.prelude.vertexSource, r.vertexSource).join("\n"), x = s.createShader(s.FRAGMENT_SHADER);
                                if (s.isContextLost()) return void (this.failedToCreate = !0);
                                if (s.shaderSource(x, y), s.compileShader(x), !s.getShaderParameter(x, s.COMPILE_STATUS)) throw new Error(`Could not compile fragment shader: ${s.getShaderInfoLog(x)}`);
                                s.attachShader(this.program, x);
                                const _ = s.createShader(s.VERTEX_SHADER);
                                if (s.isContextLost()) return void (this.failedToCreate = !0);
                                if (s.shaderSource(_, v), s.compileShader(_), !s.getShaderParameter(_, s.COMPILE_STATUS)) throw new Error(`Could not compile vertex shader: ${s.getShaderInfoLog(_)}`);
                                s.attachShader(this.program, _), this.attributes = {};
                                const b = {};
                                this.numAttributes = u.length;
                                for(let t1 = 0; t1 < this.numAttributes; t1++)u[t1] && (s.bindAttribLocation(this.program, t1, u[t1]), this.attributes[u[t1]] = t1);
                                if (s.linkProgram(this.program), !s.getProgramParameter(this.program, s.LINK_STATUS)) throw new Error(`Program failed to link: ${s.getProgramInfoLog(this.program)}`);
                                s.deleteShader(_), s.deleteShader(x);
                                for(let t1 = 0; t1 < m.length; t1++){
                                    const e1 = m[t1];
                                    if (e1 && !b[e1]) {
                                        const t1 = s.getUniformLocation(this.program, e1);
                                        t1 && (b[e1] = t1);
                                    }
                                }
                                this.fixedUniforms = i(t1, b), this.terrainUniforms = ((t1, r)=>({
                                        u_depth: new e1.aI(t1, r.u_depth),
                                        u_terrain: new e1.aI(t1, r.u_terrain),
                                        u_terrain_dim: new e1.aJ(t1, r.u_terrain_dim),
                                        u_terrain_matrix: new e1.aK(t1, r.u_terrain_matrix),
                                        u_terrain_unpack: new e1.aL(t1, r.u_terrain_unpack),
                                        u_terrain_exaggeration: new e1.aJ(t1, r.u_terrain_exaggeration)
                                    }))(t1, b), this.binderUniforms = n ? n.getUniforms(t1, b) : [];
                            }
                            draw(t1, e1, r, n, i, a, o, s, l, c, u, h, f, p, d, m, g, y) {
                                const v = t1.gl;
                                if (this.failedToCreate) return;
                                if (t1.program.set(this.program), t1.setDepthMode(r), t1.setStencilMode(n), t1.setColorMode(i), t1.setCullFace(a), s) {
                                    t1.activeTexture.set(v.TEXTURE2), v.bindTexture(v.TEXTURE_2D, s.depthTexture), t1.activeTexture.set(v.TEXTURE3), v.bindTexture(v.TEXTURE_2D, s.texture);
                                    for(const t1 in this.terrainUniforms)this.terrainUniforms[t1].set(s[t1]);
                                }
                                for(const t1 in this.fixedUniforms)this.fixedUniforms[t1].set(o[t1]);
                                d && d.setUniforms(t1, this.binderUniforms, f, {
                                    zoom: p
                                });
                                let x = 0;
                                switch(e1){
                                    case v.LINES:
                                        x = 2;
                                        break;
                                    case v.TRIANGLES:
                                        x = 3;
                                        break;
                                    case v.LINE_STRIP:
                                        x = 1;
                                }
                                for (const r of h.get()){
                                    const n = r.vaos || (r.vaos = {});
                                    (n[l] || (n[l] = new ve)).bind(t1, this, c, d ? d.getPaintVertexBuffers() : [], u, r.vertexOffset, m, g, y), v.drawElements(e1, r.primitiveLength * x, v.UNSIGNED_SHORT, r.primitiveOffset * x * 2);
                                }
                            }
                        }
                        function we(t1, e1, r) {
                            const n = 1 / Nt(r, 1, e1.transform.tileZoom), i = Math.pow(2, r.tileID.overscaledZ), a = r.tileSize * Math.pow(2, e1.transform.tileZoom) / i, o = a * (r.tileID.canonical.x + r.tileID.wrap * i), s = a * r.tileID.canonical.y;
                            return {
                                u_image: 0,
                                u_texsize: r.imageAtlasTexture.size,
                                u_scale: [
                                    n,
                                    t1.fromScale,
                                    t1.toScale
                                ],
                                u_fade: t1.t,
                                u_pixel_coord_upper: [
                                    o >> 16,
                                    s >> 16
                                ],
                                u_pixel_coord_lower: [
                                    65535 & o,
                                    65535 & s
                                ]
                            };
                        }
                        const Te = (t1, r, n, i)=>{
                            const a = r.style.light, o = a.properties.get("position"), s = [
                                o.x,
                                o.y,
                                o.z
                            ], l = function() {
                                var t1 = new e1.A(9);
                                return e1.A != Float32Array && (t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[5] = 0, t1[6] = 0, t1[7] = 0), t1[0] = 1, t1[4] = 1, t1[8] = 1, t1;
                            }();
                            "viewport" === a.properties.get("anchor") && function(t1, e1) {
                                var r = Math.sin(e1), n = Math.cos(e1);
                                t1[0] = n, t1[1] = r, t1[2] = 0, t1[3] = -r, t1[4] = n, t1[5] = 0, t1[6] = 0, t1[7] = 0, t1[8] = 1;
                            }(l, -r.transform.angle), function(t1, e1, r) {
                                var n = e1[0], i = e1[1], a = e1[2];
                                t1[0] = n * r[0] + i * r[3] + a * r[6], t1[1] = n * r[1] + i * r[4] + a * r[7], t1[2] = n * r[2] + i * r[5] + a * r[8];
                            }(s, s, l);
                            const c = a.properties.get("color");
                            return {
                                u_matrix: t1,
                                u_lightpos: s,
                                u_lightintensity: a.properties.get("intensity"),
                                u_lightcolor: [
                                    c.r,
                                    c.g,
                                    c.b
                                ],
                                u_vertical_gradient: +n,
                                u_opacity: i
                            };
                        }, ke = (t1, r, n, i, a, o, s)=>e1.e(Te(t1, r, n, i), we(o, r, s), {
                                u_height_factor: -Math.pow(2, a.overscaledZ) / s.tileSize / 8
                            }), Ae = (t1)=>({
                                u_matrix: t1
                            }), Me = (t1, r, n, i)=>e1.e(Ae(t1), we(n, r, i)), Se = (t1, e1)=>({
                                u_matrix: t1,
                                u_world: e1
                            }), Ee = (t1, r, n, i, a)=>e1.e(Me(t1, r, n, i), {
                                u_world: a
                            }), Ce = (t1, e1, r, n)=>{
                            const i = t1.transform;
                            let a, o;
                            if ("map" === n.paint.get("circle-pitch-alignment")) {
                                const t1 = Nt(r, 1, i.zoom);
                                a = !0, o = [
                                    t1,
                                    t1
                                ];
                            } else a = !1, o = i.pixelsToGLUnits;
                            return {
                                u_camera_to_center_distance: i.cameraToCenterDistance,
                                u_scale_with_map: +("map" === n.paint.get("circle-pitch-scale")),
                                u_matrix: t1.translatePosMatrix(e1.posMatrix, r, n.paint.get("circle-translate"), n.paint.get("circle-translate-anchor")),
                                u_pitch_with_map: +a,
                                u_device_pixel_ratio: t1.pixelRatio,
                                u_extrude_scale: o
                            };
                        }, Le = (t1, e1)=>({
                                u_matrix: e1,
                                u_pixel_extrude_scale: [
                                    1 / t1.width,
                                    1 / t1.height
                                ]
                            }), Ie = (t1, e1, r)=>({
                                u_matrix: t1,
                                u_inv_matrix: e1,
                                u_camera_to_center_distance: r.cameraToCenterDistance,
                                u_viewport_size: [
                                    r.width,
                                    r.height
                                ]
                            }), Pe = (t1, e1, r = 1)=>({
                                u_matrix: t1,
                                u_color: e1,
                                u_overlay: 0,
                                u_overlay_scale: r
                            }), ze = (t1)=>({
                                u_matrix: t1
                            }), Oe = (t1, e1, r, n)=>({
                                u_matrix: t1,
                                u_extrude_scale: Nt(e1, 1, r),
                                u_intensity: n
                            }), De = (t1, r, n, i)=>{
                            const a = e1.H();
                            e1.aQ(a, 0, t1.width, t1.height, 0, 0, 1);
                            const o = t1.context.gl;
                            return {
                                u_matrix: a,
                                u_world: [
                                    o.drawingBufferWidth,
                                    o.drawingBufferHeight
                                ],
                                u_image: n,
                                u_color_ramp: i,
                                u_opacity: r.paint.get("heatmap-opacity")
                            };
                        }, Re = (t1, e1, r, n)=>{
                            const i = r.paint.get("hillshade-shadow-color"), a = r.paint.get("hillshade-highlight-color"), o = r.paint.get("hillshade-accent-color");
                            let s = r.paint.get("hillshade-illumination-direction") * (Math.PI / 180);
                            "viewport" === r.paint.get("hillshade-illumination-anchor") && (s -= t1.transform.angle);
                            const l = !t1.options.moving;
                            return {
                                u_matrix: n ? n.posMatrix : t1.transform.calculatePosMatrix(e1.tileID.toUnwrapped(), l),
                                u_image: 0,
                                u_latrange: Be(0, e1.tileID),
                                u_light: [
                                    r.paint.get("hillshade-exaggeration"),
                                    s
                                ],
                                u_shadow: i,
                                u_highlight: a,
                                u_accent: o
                            };
                        }, Fe = (t1, r)=>{
                            const n = r.stride, i = e1.H();
                            return e1.aQ(i, 0, e1.X, -e1.X, 0, 0, 1), e1.J(i, i, [
                                0,
                                -e1.X,
                                0
                            ]), {
                                u_matrix: i,
                                u_image: 1,
                                u_dimension: [
                                    n,
                                    n
                                ],
                                u_zoom: t1.overscaledZ,
                                u_unpack: r.getUnpackVector()
                            };
                        };
                        function Be(t1, r) {
                            const n = Math.pow(2, r.canonical.z), i = r.canonical.y;
                            return [
                                new e1.Z(0, i / n).toLngLat().lat,
                                new e1.Z(0, (i + 1) / n).toLngLat().lat
                            ];
                        }
                        const Ne = (t1, e1, r, n)=>{
                            const i = t1.transform;
                            return {
                                u_matrix: He(t1, e1, r, n),
                                u_ratio: 1 / Nt(e1, 1, i.zoom),
                                u_device_pixel_ratio: t1.pixelRatio,
                                u_units_to_pixels: [
                                    1 / i.pixelsToGLUnits[0],
                                    1 / i.pixelsToGLUnits[1]
                                ]
                            };
                        }, je = (t1, r, n, i, a)=>e1.e(Ne(t1, r, n, a), {
                                u_image: 0,
                                u_image_height: i
                            }), Ue = (t1, e1, r, n, i)=>{
                            const a = t1.transform, o = qe(e1, a);
                            return {
                                u_matrix: He(t1, e1, r, i),
                                u_texsize: e1.imageAtlasTexture.size,
                                u_ratio: 1 / Nt(e1, 1, a.zoom),
                                u_device_pixel_ratio: t1.pixelRatio,
                                u_image: 0,
                                u_scale: [
                                    o,
                                    n.fromScale,
                                    n.toScale
                                ],
                                u_fade: n.t,
                                u_units_to_pixels: [
                                    1 / a.pixelsToGLUnits[0],
                                    1 / a.pixelsToGLUnits[1]
                                ]
                            };
                        }, Ve = (t1, r, n, i, a, o)=>{
                            const s = t1.transform, l = t1.lineAtlas, c = qe(r, s), u = "round" === n.layout.get("line-cap"), h = l.getDash(i.from, u), f = l.getDash(i.to, u), p = h.width * a.fromScale, d = f.width * a.toScale;
                            return e1.e(Ne(t1, r, n, o), {
                                u_patternscale_a: [
                                    c / p,
                                    -h.height / 2
                                ],
                                u_patternscale_b: [
                                    c / d,
                                    -f.height / 2
                                ],
                                u_sdfgamma: l.width / (256 * Math.min(p, d) * t1.pixelRatio) / 2,
                                u_image: 0,
                                u_tex_y_a: h.y,
                                u_tex_y_b: f.y,
                                u_mix: a.t
                            });
                        };
                        function qe(t1, e1) {
                            return 1 / Nt(t1, 1, e1.tileZoom);
                        }
                        function He(t1, e1, r, n) {
                            return t1.translatePosMatrix(n ? n.posMatrix : e1.tileID.posMatrix, e1, r.paint.get("line-translate"), r.paint.get("line-translate-anchor"));
                        }
                        const Ge = (t1, e1, r, n, i)=>{
                            var a, o;
                            return {
                                u_matrix: t1,
                                u_tl_parent: e1,
                                u_scale_parent: r,
                                u_buffer_scale: 1,
                                u_fade_t: n.mix,
                                u_opacity: n.opacity * i.paint.get("raster-opacity"),
                                u_image0: 0,
                                u_image1: 1,
                                u_brightness_low: i.paint.get("raster-brightness-min"),
                                u_brightness_high: i.paint.get("raster-brightness-max"),
                                u_saturation_factor: (o = i.paint.get("raster-saturation"), o > 0 ? 1 - 1 / (1.001 - o) : -o),
                                u_contrast_factor: (a = i.paint.get("raster-contrast"), a > 0 ? 1 / (1 - a) : 1 + a),
                                u_spin_weights: Ze(i.paint.get("raster-hue-rotate"))
                            };
                        };
                        function Ze(t1) {
                            t1 *= Math.PI / 180;
                            const e1 = Math.sin(t1), r = Math.cos(t1);
                            return [
                                (2 * r + 1) / 3,
                                (-Math.sqrt(3) * e1 - r + 1) / 3,
                                (Math.sqrt(3) * e1 - r + 1) / 3
                            ];
                        }
                        const We = (t1, e1, r, n, i, a, o, s, l, c, u, h, f, p)=>{
                            const d = o.transform;
                            return {
                                u_is_size_zoom_constant: +("constant" === t1 || "source" === t1),
                                u_is_size_feature_constant: +("constant" === t1 || "camera" === t1),
                                u_size_t: e1 ? e1.uSizeT : 0,
                                u_size: e1 ? e1.uSize : 0,
                                u_camera_to_center_distance: d.cameraToCenterDistance,
                                u_pitch: d.pitch / 360 * 2 * Math.PI,
                                u_rotate_symbol: +r,
                                u_aspect_ratio: d.width / d.height,
                                u_fade_change: o.options.fadeDuration ? o.symbolFadeChange : 1,
                                u_matrix: s,
                                u_label_plane_matrix: l,
                                u_coord_matrix: c,
                                u_is_text: +h,
                                u_pitch_with_map: +n,
                                u_is_along_line: i,
                                u_is_variable_anchor: a,
                                u_texsize: f,
                                u_texture: 0,
                                u_translation: u,
                                u_pitched_scale: p
                            };
                        }, Ye = (t1, r, n, i, a, o, s, l, c, u, h, f, p, d, m)=>{
                            const g = s.transform;
                            return e1.e(We(t1, r, n, i, a, o, s, l, c, u, h, f, p, m), {
                                u_gamma_scale: i ? Math.cos(g._pitch) * g.cameraToCenterDistance : 1,
                                u_device_pixel_ratio: s.pixelRatio,
                                u_is_halo: +d
                            });
                        }, Xe = (t1, r, n, i, a, o, s, l, c, u, h, f, p, d)=>e1.e(Ye(t1, r, n, i, a, o, s, l, c, u, h, !0, f, !0, d), {
                                u_texsize_icon: p,
                                u_texture_icon: 1
                            }), $e = (t1, e1, r)=>({
                                u_matrix: t1,
                                u_opacity: e1,
                                u_color: r
                            }), Je = (t1, r, n, i, a, o)=>e1.e(function(t1, e1, r, n) {
                                const i = r.imageManager.getPattern(t1.from.toString()), a = r.imageManager.getPattern(t1.to.toString()), { width: o, height: s } = r.imageManager.getPixelSize(), l = Math.pow(2, n.tileID.overscaledZ), c = n.tileSize * Math.pow(2, r.transform.tileZoom) / l, u = c * (n.tileID.canonical.x + n.tileID.wrap * l), h = c * n.tileID.canonical.y;
                                return {
                                    u_image: 0,
                                    u_pattern_tl_a: i.tl,
                                    u_pattern_br_a: i.br,
                                    u_pattern_tl_b: a.tl,
                                    u_pattern_br_b: a.br,
                                    u_texsize: [
                                        o,
                                        s
                                    ],
                                    u_mix: e1.t,
                                    u_pattern_size_a: i.displaySize,
                                    u_pattern_size_b: a.displaySize,
                                    u_scale_a: e1.fromScale,
                                    u_scale_b: e1.toScale,
                                    u_tile_units_to_pixels: 1 / Nt(n, 1, r.transform.tileZoom),
                                    u_pixel_coord_upper: [
                                        u >> 16,
                                        h >> 16
                                    ],
                                    u_pixel_coord_lower: [
                                        65535 & u,
                                        65535 & h
                                    ]
                                };
                            }(i, o, n, a), {
                                u_matrix: t1,
                                u_opacity: r
                            }), Ke = {
                            fillExtrusion: (t1, r)=>({
                                    u_matrix: new e1.aK(t1, r.u_matrix),
                                    u_lightpos: new e1.aO(t1, r.u_lightpos),
                                    u_lightintensity: new e1.aJ(t1, r.u_lightintensity),
                                    u_lightcolor: new e1.aO(t1, r.u_lightcolor),
                                    u_vertical_gradient: new e1.aJ(t1, r.u_vertical_gradient),
                                    u_opacity: new e1.aJ(t1, r.u_opacity)
                                }),
                            fillExtrusionPattern: (t1, r)=>({
                                    u_matrix: new e1.aK(t1, r.u_matrix),
                                    u_lightpos: new e1.aO(t1, r.u_lightpos),
                                    u_lightintensity: new e1.aJ(t1, r.u_lightintensity),
                                    u_lightcolor: new e1.aO(t1, r.u_lightcolor),
                                    u_vertical_gradient: new e1.aJ(t1, r.u_vertical_gradient),
                                    u_height_factor: new e1.aJ(t1, r.u_height_factor),
                                    u_image: new e1.aI(t1, r.u_image),
                                    u_texsize: new e1.aP(t1, r.u_texsize),
                                    u_pixel_coord_upper: new e1.aP(t1, r.u_pixel_coord_upper),
                                    u_pixel_coord_lower: new e1.aP(t1, r.u_pixel_coord_lower),
                                    u_scale: new e1.aO(t1, r.u_scale),
                                    u_fade: new e1.aJ(t1, r.u_fade),
                                    u_opacity: new e1.aJ(t1, r.u_opacity)
                                }),
                            fill: (t1, r)=>({
                                    u_matrix: new e1.aK(t1, r.u_matrix)
                                }),
                            fillPattern: (t1, r)=>({
                                    u_matrix: new e1.aK(t1, r.u_matrix),
                                    u_image: new e1.aI(t1, r.u_image),
                                    u_texsize: new e1.aP(t1, r.u_texsize),
                                    u_pixel_coord_upper: new e1.aP(t1, r.u_pixel_coord_upper),
                                    u_pixel_coord_lower: new e1.aP(t1, r.u_pixel_coord_lower),
                                    u_scale: new e1.aO(t1, r.u_scale),
                                    u_fade: new e1.aJ(t1, r.u_fade)
                                }),
                            fillOutline: (t1, r)=>({
                                    u_matrix: new e1.aK(t1, r.u_matrix),
                                    u_world: new e1.aP(t1, r.u_world)
                                }),
                            fillOutlinePattern: (t1, r)=>({
                                    u_matrix: new e1.aK(t1, r.u_matrix),
                                    u_world: new e1.aP(t1, r.u_world),
                                    u_image: new e1.aI(t1, r.u_image),
                                    u_texsize: new e1.aP(t1, r.u_texsize),
                                    u_pixel_coord_upper: new e1.aP(t1, r.u_pixel_coord_upper),
                                    u_pixel_coord_lower: new e1.aP(t1, r.u_pixel_coord_lower),
                                    u_scale: new e1.aO(t1, r.u_scale),
                                    u_fade: new e1.aJ(t1, r.u_fade)
                                }),
                            circle: (t1, r)=>({
                                    u_camera_to_center_distance: new e1.aJ(t1, r.u_camera_to_center_distance),
                                    u_scale_with_map: new e1.aI(t1, r.u_scale_with_map),
                                    u_pitch_with_map: new e1.aI(t1, r.u_pitch_with_map),
                                    u_extrude_scale: new e1.aP(t1, r.u_extrude_scale),
                                    u_device_pixel_ratio: new e1.aJ(t1, r.u_device_pixel_ratio),
                                    u_matrix: new e1.aK(t1, r.u_matrix)
                                }),
                            collisionBox: (t1, r)=>({
                                    u_matrix: new e1.aK(t1, r.u_matrix),
                                    u_pixel_extrude_scale: new e1.aP(t1, r.u_pixel_extrude_scale)
                                }),
                            collisionCircle: (t1, r)=>({
                                    u_matrix: new e1.aK(t1, r.u_matrix),
                                    u_inv_matrix: new e1.aK(t1, r.u_inv_matrix),
                                    u_camera_to_center_distance: new e1.aJ(t1, r.u_camera_to_center_distance),
                                    u_viewport_size: new e1.aP(t1, r.u_viewport_size)
                                }),
                            debug: (t1, r)=>({
                                    u_color: new e1.aM(t1, r.u_color),
                                    u_matrix: new e1.aK(t1, r.u_matrix),
                                    u_overlay: new e1.aI(t1, r.u_overlay),
                                    u_overlay_scale: new e1.aJ(t1, r.u_overlay_scale)
                                }),
                            clippingMask: (t1, r)=>({
                                    u_matrix: new e1.aK(t1, r.u_matrix)
                                }),
                            heatmap: (t1, r)=>({
                                    u_extrude_scale: new e1.aJ(t1, r.u_extrude_scale),
                                    u_intensity: new e1.aJ(t1, r.u_intensity),
                                    u_matrix: new e1.aK(t1, r.u_matrix)
                                }),
                            heatmapTexture: (t1, r)=>({
                                    u_matrix: new e1.aK(t1, r.u_matrix),
                                    u_world: new e1.aP(t1, r.u_world),
                                    u_image: new e1.aI(t1, r.u_image),
                                    u_color_ramp: new e1.aI(t1, r.u_color_ramp),
                                    u_opacity: new e1.aJ(t1, r.u_opacity)
                                }),
                            hillshade: (t1, r)=>({
                                    u_matrix: new e1.aK(t1, r.u_matrix),
                                    u_image: new e1.aI(t1, r.u_image),
                                    u_latrange: new e1.aP(t1, r.u_latrange),
                                    u_light: new e1.aP(t1, r.u_light),
                                    u_shadow: new e1.aM(t1, r.u_shadow),
                                    u_highlight: new e1.aM(t1, r.u_highlight),
                                    u_accent: new e1.aM(t1, r.u_accent)
                                }),
                            hillshadePrepare: (t1, r)=>({
                                    u_matrix: new e1.aK(t1, r.u_matrix),
                                    u_image: new e1.aI(t1, r.u_image),
                                    u_dimension: new e1.aP(t1, r.u_dimension),
                                    u_zoom: new e1.aJ(t1, r.u_zoom),
                                    u_unpack: new e1.aL(t1, r.u_unpack)
                                }),
                            line: (t1, r)=>({
                                    u_matrix: new e1.aK(t1, r.u_matrix),
                                    u_ratio: new e1.aJ(t1, r.u_ratio),
                                    u_device_pixel_ratio: new e1.aJ(t1, r.u_device_pixel_ratio),
                                    u_units_to_pixels: new e1.aP(t1, r.u_units_to_pixels)
                                }),
                            lineGradient: (t1, r)=>({
                                    u_matrix: new e1.aK(t1, r.u_matrix),
                                    u_ratio: new e1.aJ(t1, r.u_ratio),
                                    u_device_pixel_ratio: new e1.aJ(t1, r.u_device_pixel_ratio),
                                    u_units_to_pixels: new e1.aP(t1, r.u_units_to_pixels),
                                    u_image: new e1.aI(t1, r.u_image),
                                    u_image_height: new e1.aJ(t1, r.u_image_height)
                                }),
                            linePattern: (t1, r)=>({
                                    u_matrix: new e1.aK(t1, r.u_matrix),
                                    u_texsize: new e1.aP(t1, r.u_texsize),
                                    u_ratio: new e1.aJ(t1, r.u_ratio),
                                    u_device_pixel_ratio: new e1.aJ(t1, r.u_device_pixel_ratio),
                                    u_image: new e1.aI(t1, r.u_image),
                                    u_units_to_pixels: new e1.aP(t1, r.u_units_to_pixels),
                                    u_scale: new e1.aO(t1, r.u_scale),
                                    u_fade: new e1.aJ(t1, r.u_fade)
                                }),
                            lineSDF: (t1, r)=>({
                                    u_matrix: new e1.aK(t1, r.u_matrix),
                                    u_ratio: new e1.aJ(t1, r.u_ratio),
                                    u_device_pixel_ratio: new e1.aJ(t1, r.u_device_pixel_ratio),
                                    u_units_to_pixels: new e1.aP(t1, r.u_units_to_pixels),
                                    u_patternscale_a: new e1.aP(t1, r.u_patternscale_a),
                                    u_patternscale_b: new e1.aP(t1, r.u_patternscale_b),
                                    u_sdfgamma: new e1.aJ(t1, r.u_sdfgamma),
                                    u_image: new e1.aI(t1, r.u_image),
                                    u_tex_y_a: new e1.aJ(t1, r.u_tex_y_a),
                                    u_tex_y_b: new e1.aJ(t1, r.u_tex_y_b),
                                    u_mix: new e1.aJ(t1, r.u_mix)
                                }),
                            raster: (t1, r)=>({
                                    u_matrix: new e1.aK(t1, r.u_matrix),
                                    u_tl_parent: new e1.aP(t1, r.u_tl_parent),
                                    u_scale_parent: new e1.aJ(t1, r.u_scale_parent),
                                    u_buffer_scale: new e1.aJ(t1, r.u_buffer_scale),
                                    u_fade_t: new e1.aJ(t1, r.u_fade_t),
                                    u_opacity: new e1.aJ(t1, r.u_opacity),
                                    u_image0: new e1.aI(t1, r.u_image0),
                                    u_image1: new e1.aI(t1, r.u_image1),
                                    u_brightness_low: new e1.aJ(t1, r.u_brightness_low),
                                    u_brightness_high: new e1.aJ(t1, r.u_brightness_high),
                                    u_saturation_factor: new e1.aJ(t1, r.u_saturation_factor),
                                    u_contrast_factor: new e1.aJ(t1, r.u_contrast_factor),
                                    u_spin_weights: new e1.aO(t1, r.u_spin_weights)
                                }),
                            symbolIcon: (t1, r)=>({
                                    u_is_size_zoom_constant: new e1.aI(t1, r.u_is_size_zoom_constant),
                                    u_is_size_feature_constant: new e1.aI(t1, r.u_is_size_feature_constant),
                                    u_size_t: new e1.aJ(t1, r.u_size_t),
                                    u_size: new e1.aJ(t1, r.u_size),
                                    u_camera_to_center_distance: new e1.aJ(t1, r.u_camera_to_center_distance),
                                    u_pitch: new e1.aJ(t1, r.u_pitch),
                                    u_rotate_symbol: new e1.aI(t1, r.u_rotate_symbol),
                                    u_aspect_ratio: new e1.aJ(t1, r.u_aspect_ratio),
                                    u_fade_change: new e1.aJ(t1, r.u_fade_change),
                                    u_matrix: new e1.aK(t1, r.u_matrix),
                                    u_label_plane_matrix: new e1.aK(t1, r.u_label_plane_matrix),
                                    u_coord_matrix: new e1.aK(t1, r.u_coord_matrix),
                                    u_is_text: new e1.aI(t1, r.u_is_text),
                                    u_pitch_with_map: new e1.aI(t1, r.u_pitch_with_map),
                                    u_is_along_line: new e1.aI(t1, r.u_is_along_line),
                                    u_is_variable_anchor: new e1.aI(t1, r.u_is_variable_anchor),
                                    u_texsize: new e1.aP(t1, r.u_texsize),
                                    u_texture: new e1.aI(t1, r.u_texture),
                                    u_translation: new e1.aP(t1, r.u_translation),
                                    u_pitched_scale: new e1.aJ(t1, r.u_pitched_scale)
                                }),
                            symbolSDF: (t1, r)=>({
                                    u_is_size_zoom_constant: new e1.aI(t1, r.u_is_size_zoom_constant),
                                    u_is_size_feature_constant: new e1.aI(t1, r.u_is_size_feature_constant),
                                    u_size_t: new e1.aJ(t1, r.u_size_t),
                                    u_size: new e1.aJ(t1, r.u_size),
                                    u_camera_to_center_distance: new e1.aJ(t1, r.u_camera_to_center_distance),
                                    u_pitch: new e1.aJ(t1, r.u_pitch),
                                    u_rotate_symbol: new e1.aI(t1, r.u_rotate_symbol),
                                    u_aspect_ratio: new e1.aJ(t1, r.u_aspect_ratio),
                                    u_fade_change: new e1.aJ(t1, r.u_fade_change),
                                    u_matrix: new e1.aK(t1, r.u_matrix),
                                    u_label_plane_matrix: new e1.aK(t1, r.u_label_plane_matrix),
                                    u_coord_matrix: new e1.aK(t1, r.u_coord_matrix),
                                    u_is_text: new e1.aI(t1, r.u_is_text),
                                    u_pitch_with_map: new e1.aI(t1, r.u_pitch_with_map),
                                    u_is_along_line: new e1.aI(t1, r.u_is_along_line),
                                    u_is_variable_anchor: new e1.aI(t1, r.u_is_variable_anchor),
                                    u_texsize: new e1.aP(t1, r.u_texsize),
                                    u_texture: new e1.aI(t1, r.u_texture),
                                    u_gamma_scale: new e1.aJ(t1, r.u_gamma_scale),
                                    u_device_pixel_ratio: new e1.aJ(t1, r.u_device_pixel_ratio),
                                    u_is_halo: new e1.aI(t1, r.u_is_halo),
                                    u_translation: new e1.aP(t1, r.u_translation),
                                    u_pitched_scale: new e1.aJ(t1, r.u_pitched_scale)
                                }),
                            symbolTextAndIcon: (t1, r)=>({
                                    u_is_size_zoom_constant: new e1.aI(t1, r.u_is_size_zoom_constant),
                                    u_is_size_feature_constant: new e1.aI(t1, r.u_is_size_feature_constant),
                                    u_size_t: new e1.aJ(t1, r.u_size_t),
                                    u_size: new e1.aJ(t1, r.u_size),
                                    u_camera_to_center_distance: new e1.aJ(t1, r.u_camera_to_center_distance),
                                    u_pitch: new e1.aJ(t1, r.u_pitch),
                                    u_rotate_symbol: new e1.aI(t1, r.u_rotate_symbol),
                                    u_aspect_ratio: new e1.aJ(t1, r.u_aspect_ratio),
                                    u_fade_change: new e1.aJ(t1, r.u_fade_change),
                                    u_matrix: new e1.aK(t1, r.u_matrix),
                                    u_label_plane_matrix: new e1.aK(t1, r.u_label_plane_matrix),
                                    u_coord_matrix: new e1.aK(t1, r.u_coord_matrix),
                                    u_is_text: new e1.aI(t1, r.u_is_text),
                                    u_pitch_with_map: new e1.aI(t1, r.u_pitch_with_map),
                                    u_is_along_line: new e1.aI(t1, r.u_is_along_line),
                                    u_is_variable_anchor: new e1.aI(t1, r.u_is_variable_anchor),
                                    u_texsize: new e1.aP(t1, r.u_texsize),
                                    u_texsize_icon: new e1.aP(t1, r.u_texsize_icon),
                                    u_texture: new e1.aI(t1, r.u_texture),
                                    u_texture_icon: new e1.aI(t1, r.u_texture_icon),
                                    u_gamma_scale: new e1.aJ(t1, r.u_gamma_scale),
                                    u_device_pixel_ratio: new e1.aJ(t1, r.u_device_pixel_ratio),
                                    u_is_halo: new e1.aI(t1, r.u_is_halo),
                                    u_translation: new e1.aP(t1, r.u_translation),
                                    u_pitched_scale: new e1.aJ(t1, r.u_pitched_scale)
                                }),
                            background: (t1, r)=>({
                                    u_matrix: new e1.aK(t1, r.u_matrix),
                                    u_opacity: new e1.aJ(t1, r.u_opacity),
                                    u_color: new e1.aM(t1, r.u_color)
                                }),
                            backgroundPattern: (t1, r)=>({
                                    u_matrix: new e1.aK(t1, r.u_matrix),
                                    u_opacity: new e1.aJ(t1, r.u_opacity),
                                    u_image: new e1.aI(t1, r.u_image),
                                    u_pattern_tl_a: new e1.aP(t1, r.u_pattern_tl_a),
                                    u_pattern_br_a: new e1.aP(t1, r.u_pattern_br_a),
                                    u_pattern_tl_b: new e1.aP(t1, r.u_pattern_tl_b),
                                    u_pattern_br_b: new e1.aP(t1, r.u_pattern_br_b),
                                    u_texsize: new e1.aP(t1, r.u_texsize),
                                    u_mix: new e1.aJ(t1, r.u_mix),
                                    u_pattern_size_a: new e1.aP(t1, r.u_pattern_size_a),
                                    u_pattern_size_b: new e1.aP(t1, r.u_pattern_size_b),
                                    u_scale_a: new e1.aJ(t1, r.u_scale_a),
                                    u_scale_b: new e1.aJ(t1, r.u_scale_b),
                                    u_pixel_coord_upper: new e1.aP(t1, r.u_pixel_coord_upper),
                                    u_pixel_coord_lower: new e1.aP(t1, r.u_pixel_coord_lower),
                                    u_tile_units_to_pixels: new e1.aJ(t1, r.u_tile_units_to_pixels)
                                }),
                            terrain: (t1, r)=>({
                                    u_matrix: new e1.aK(t1, r.u_matrix),
                                    u_texture: new e1.aI(t1, r.u_texture),
                                    u_ele_delta: new e1.aJ(t1, r.u_ele_delta),
                                    u_fog_matrix: new e1.aK(t1, r.u_fog_matrix),
                                    u_fog_color: new e1.aM(t1, r.u_fog_color),
                                    u_fog_ground_blend: new e1.aJ(t1, r.u_fog_ground_blend),
                                    u_fog_ground_blend_opacity: new e1.aJ(t1, r.u_fog_ground_blend_opacity),
                                    u_horizon_color: new e1.aM(t1, r.u_horizon_color),
                                    u_horizon_fog_blend: new e1.aJ(t1, r.u_horizon_fog_blend)
                                }),
                            terrainDepth: (t1, r)=>({
                                    u_matrix: new e1.aK(t1, r.u_matrix),
                                    u_ele_delta: new e1.aJ(t1, r.u_ele_delta)
                                }),
                            terrainCoords: (t1, r)=>({
                                    u_matrix: new e1.aK(t1, r.u_matrix),
                                    u_texture: new e1.aI(t1, r.u_texture),
                                    u_terrain_coords_id: new e1.aJ(t1, r.u_terrain_coords_id),
                                    u_ele_delta: new e1.aJ(t1, r.u_ele_delta)
                                }),
                            sky: (t1, r)=>({
                                    u_sky_color: new e1.aM(t1, r.u_sky_color),
                                    u_horizon_color: new e1.aM(t1, r.u_horizon_color),
                                    u_horizon: new e1.aJ(t1, r.u_horizon),
                                    u_sky_horizon_blend: new e1.aJ(t1, r.u_sky_horizon_blend)
                                })
                        };
                        class Qe {
                            constructor(t1, e1, r){
                                this.context = t1;
                                const n = t1.gl;
                                this.buffer = n.createBuffer(), this.dynamicDraw = Boolean(r), this.context.unbindVAO(), t1.bindElementBuffer.set(this.buffer), n.bufferData(n.ELEMENT_ARRAY_BUFFER, e1.arrayBuffer, this.dynamicDraw ? n.DYNAMIC_DRAW : n.STATIC_DRAW), this.dynamicDraw || delete e1.arrayBuffer;
                            }
                            bind() {
                                this.context.bindElementBuffer.set(this.buffer);
                            }
                            updateData(t1) {
                                const e1 = this.context.gl;
                                if (!this.dynamicDraw) throw new Error("Attempted to update data while not in dynamic mode.");
                                this.context.unbindVAO(), this.bind(), e1.bufferSubData(e1.ELEMENT_ARRAY_BUFFER, 0, t1.arrayBuffer);
                            }
                            destroy() {
                                const t1 = this.context.gl;
                                this.buffer && (t1.deleteBuffer(this.buffer), delete this.buffer);
                            }
                        }
                        const tr = {
                            Int8: "BYTE",
                            Uint8: "UNSIGNED_BYTE",
                            Int16: "SHORT",
                            Uint16: "UNSIGNED_SHORT",
                            Int32: "INT",
                            Uint32: "UNSIGNED_INT",
                            Float32: "FLOAT"
                        };
                        class er {
                            constructor(t1, e1, r, n){
                                this.length = e1.length, this.attributes = r, this.itemSize = e1.bytesPerElement, this.dynamicDraw = n, this.context = t1;
                                const i = t1.gl;
                                this.buffer = i.createBuffer(), t1.bindVertexBuffer.set(this.buffer), i.bufferData(i.ARRAY_BUFFER, e1.arrayBuffer, this.dynamicDraw ? i.DYNAMIC_DRAW : i.STATIC_DRAW), this.dynamicDraw || delete e1.arrayBuffer;
                            }
                            bind() {
                                this.context.bindVertexBuffer.set(this.buffer);
                            }
                            updateData(t1) {
                                if (t1.length !== this.length) throw new Error(`Length of new data is ${t1.length}, which doesn't match current length of ${this.length}`);
                                const e1 = this.context.gl;
                                this.bind(), e1.bufferSubData(e1.ARRAY_BUFFER, 0, t1.arrayBuffer);
                            }
                            enableAttributes(t1, e1) {
                                for(let r = 0; r < this.attributes.length; r++){
                                    const n = this.attributes[r], i = e1.attributes[n.name];
                                    void 0 !== i && t1.enableVertexAttribArray(i);
                                }
                            }
                            setVertexAttribPointers(t1, e1, r) {
                                for(let n = 0; n < this.attributes.length; n++){
                                    const i = this.attributes[n], a = e1.attributes[i.name];
                                    void 0 !== a && t1.vertexAttribPointer(a, i.components, t1[tr[i.type]], !1, this.itemSize, i.offset + this.itemSize * (r || 0));
                                }
                            }
                            destroy() {
                                const t1 = this.context.gl;
                                this.buffer && (t1.deleteBuffer(this.buffer), delete this.buffer);
                            }
                        }
                        const rr = new WeakMap;
                        function nr(t1) {
                            var e1;
                            if (rr.has(t1)) return rr.get(t1);
                            {
                                const r = null === (e1 = t1.getParameter(t1.VERSION)) || void 0 === e1 ? void 0 : e1.startsWith("WebGL 2.0");
                                return rr.set(t1, r), r;
                            }
                        }
                        class ir {
                            constructor(t1){
                                this.gl = t1.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
                            }
                            get() {
                                return this.current;
                            }
                            set(t1) {}
                            getDefault() {
                                return this.default;
                            }
                            setDefault() {
                                this.set(this.default);
                            }
                        }
                        class ar extends ir {
                            getDefault() {
                                return e1.aN.transparent;
                            }
                            set(t1) {
                                const e1 = this.current;
                                (t1.r !== e1.r || t1.g !== e1.g || t1.b !== e1.b || t1.a !== e1.a || this.dirty) && (this.gl.clearColor(t1.r, t1.g, t1.b, t1.a), this.current = t1, this.dirty = !1);
                            }
                        }
                        class or extends ir {
                            getDefault() {
                                return 1;
                            }
                            set(t1) {
                                (t1 !== this.current || this.dirty) && (this.gl.clearDepth(t1), this.current = t1, this.dirty = !1);
                            }
                        }
                        class sr extends ir {
                            getDefault() {
                                return 0;
                            }
                            set(t1) {
                                (t1 !== this.current || this.dirty) && (this.gl.clearStencil(t1), this.current = t1, this.dirty = !1);
                            }
                        }
                        class lr extends ir {
                            getDefault() {
                                return [
                                    !0,
                                    !0,
                                    !0,
                                    !0
                                ];
                            }
                            set(t1) {
                                const e1 = this.current;
                                (t1[0] !== e1[0] || t1[1] !== e1[1] || t1[2] !== e1[2] || t1[3] !== e1[3] || this.dirty) && (this.gl.colorMask(t1[0], t1[1], t1[2], t1[3]), this.current = t1, this.dirty = !1);
                            }
                        }
                        class cr extends ir {
                            getDefault() {
                                return !0;
                            }
                            set(t1) {
                                (t1 !== this.current || this.dirty) && (this.gl.depthMask(t1), this.current = t1, this.dirty = !1);
                            }
                        }
                        class ur extends ir {
                            getDefault() {
                                return 255;
                            }
                            set(t1) {
                                (t1 !== this.current || this.dirty) && (this.gl.stencilMask(t1), this.current = t1, this.dirty = !1);
                            }
                        }
                        class hr extends ir {
                            getDefault() {
                                return {
                                    func: this.gl.ALWAYS,
                                    ref: 0,
                                    mask: 255
                                };
                            }
                            set(t1) {
                                const e1 = this.current;
                                (t1.func !== e1.func || t1.ref !== e1.ref || t1.mask !== e1.mask || this.dirty) && (this.gl.stencilFunc(t1.func, t1.ref, t1.mask), this.current = t1, this.dirty = !1);
                            }
                        }
                        class fr extends ir {
                            getDefault() {
                                const t1 = this.gl;
                                return [
                                    t1.KEEP,
                                    t1.KEEP,
                                    t1.KEEP
                                ];
                            }
                            set(t1) {
                                const e1 = this.current;
                                (t1[0] !== e1[0] || t1[1] !== e1[1] || t1[2] !== e1[2] || this.dirty) && (this.gl.stencilOp(t1[0], t1[1], t1[2]), this.current = t1, this.dirty = !1);
                            }
                        }
                        class pr extends ir {
                            getDefault() {
                                return !1;
                            }
                            set(t1) {
                                if (t1 === this.current && !this.dirty) return;
                                const e1 = this.gl;
                                t1 ? e1.enable(e1.STENCIL_TEST) : e1.disable(e1.STENCIL_TEST), this.current = t1, this.dirty = !1;
                            }
                        }
                        class dr extends ir {
                            getDefault() {
                                return [
                                    0,
                                    1
                                ];
                            }
                            set(t1) {
                                const e1 = this.current;
                                (t1[0] !== e1[0] || t1[1] !== e1[1] || this.dirty) && (this.gl.depthRange(t1[0], t1[1]), this.current = t1, this.dirty = !1);
                            }
                        }
                        class mr extends ir {
                            getDefault() {
                                return !1;
                            }
                            set(t1) {
                                if (t1 === this.current && !this.dirty) return;
                                const e1 = this.gl;
                                t1 ? e1.enable(e1.DEPTH_TEST) : e1.disable(e1.DEPTH_TEST), this.current = t1, this.dirty = !1;
                            }
                        }
                        class gr extends ir {
                            getDefault() {
                                return this.gl.LESS;
                            }
                            set(t1) {
                                (t1 !== this.current || this.dirty) && (this.gl.depthFunc(t1), this.current = t1, this.dirty = !1);
                            }
                        }
                        class yr extends ir {
                            getDefault() {
                                return !1;
                            }
                            set(t1) {
                                if (t1 === this.current && !this.dirty) return;
                                const e1 = this.gl;
                                t1 ? e1.enable(e1.BLEND) : e1.disable(e1.BLEND), this.current = t1, this.dirty = !1;
                            }
                        }
                        class vr extends ir {
                            getDefault() {
                                const t1 = this.gl;
                                return [
                                    t1.ONE,
                                    t1.ZERO
                                ];
                            }
                            set(t1) {
                                const e1 = this.current;
                                (t1[0] !== e1[0] || t1[1] !== e1[1] || this.dirty) && (this.gl.blendFunc(t1[0], t1[1]), this.current = t1, this.dirty = !1);
                            }
                        }
                        class xr extends ir {
                            getDefault() {
                                return e1.aN.transparent;
                            }
                            set(t1) {
                                const e1 = this.current;
                                (t1.r !== e1.r || t1.g !== e1.g || t1.b !== e1.b || t1.a !== e1.a || this.dirty) && (this.gl.blendColor(t1.r, t1.g, t1.b, t1.a), this.current = t1, this.dirty = !1);
                            }
                        }
                        class _r extends ir {
                            getDefault() {
                                return this.gl.FUNC_ADD;
                            }
                            set(t1) {
                                (t1 !== this.current || this.dirty) && (this.gl.blendEquation(t1), this.current = t1, this.dirty = !1);
                            }
                        }
                        class br extends ir {
                            getDefault() {
                                return !1;
                            }
                            set(t1) {
                                if (t1 === this.current && !this.dirty) return;
                                const e1 = this.gl;
                                t1 ? e1.enable(e1.CULL_FACE) : e1.disable(e1.CULL_FACE), this.current = t1, this.dirty = !1;
                            }
                        }
                        class wr extends ir {
                            getDefault() {
                                return this.gl.BACK;
                            }
                            set(t1) {
                                (t1 !== this.current || this.dirty) && (this.gl.cullFace(t1), this.current = t1, this.dirty = !1);
                            }
                        }
                        class Tr extends ir {
                            getDefault() {
                                return this.gl.CCW;
                            }
                            set(t1) {
                                (t1 !== this.current || this.dirty) && (this.gl.frontFace(t1), this.current = t1, this.dirty = !1);
                            }
                        }
                        class kr extends ir {
                            getDefault() {
                                return null;
                            }
                            set(t1) {
                                (t1 !== this.current || this.dirty) && (this.gl.useProgram(t1), this.current = t1, this.dirty = !1);
                            }
                        }
                        class Ar extends ir {
                            getDefault() {
                                return this.gl.TEXTURE0;
                            }
                            set(t1) {
                                (t1 !== this.current || this.dirty) && (this.gl.activeTexture(t1), this.current = t1, this.dirty = !1);
                            }
                        }
                        class Mr extends ir {
                            getDefault() {
                                const t1 = this.gl;
                                return [
                                    0,
                                    0,
                                    t1.drawingBufferWidth,
                                    t1.drawingBufferHeight
                                ];
                            }
                            set(t1) {
                                const e1 = this.current;
                                (t1[0] !== e1[0] || t1[1] !== e1[1] || t1[2] !== e1[2] || t1[3] !== e1[3] || this.dirty) && (this.gl.viewport(t1[0], t1[1], t1[2], t1[3]), this.current = t1, this.dirty = !1);
                            }
                        }
                        class Sr extends ir {
                            getDefault() {
                                return null;
                            }
                            set(t1) {
                                if (t1 === this.current && !this.dirty) return;
                                const e1 = this.gl;
                                e1.bindFramebuffer(e1.FRAMEBUFFER, t1), this.current = t1, this.dirty = !1;
                            }
                        }
                        class Er extends ir {
                            getDefault() {
                                return null;
                            }
                            set(t1) {
                                if (t1 === this.current && !this.dirty) return;
                                const e1 = this.gl;
                                e1.bindRenderbuffer(e1.RENDERBUFFER, t1), this.current = t1, this.dirty = !1;
                            }
                        }
                        class Cr extends ir {
                            getDefault() {
                                return null;
                            }
                            set(t1) {
                                if (t1 === this.current && !this.dirty) return;
                                const e1 = this.gl;
                                e1.bindTexture(e1.TEXTURE_2D, t1), this.current = t1, this.dirty = !1;
                            }
                        }
                        class Lr extends ir {
                            getDefault() {
                                return null;
                            }
                            set(t1) {
                                if (t1 === this.current && !this.dirty) return;
                                const e1 = this.gl;
                                e1.bindBuffer(e1.ARRAY_BUFFER, t1), this.current = t1, this.dirty = !1;
                            }
                        }
                        class Ir extends ir {
                            getDefault() {
                                return null;
                            }
                            set(t1) {
                                const e1 = this.gl;
                                e1.bindBuffer(e1.ELEMENT_ARRAY_BUFFER, t1), this.current = t1, this.dirty = !1;
                            }
                        }
                        class Pr extends ir {
                            getDefault() {
                                return null;
                            }
                            set(t1) {
                                var e1;
                                if (t1 === this.current && !this.dirty) return;
                                const r = this.gl;
                                nr(r) ? r.bindVertexArray(t1) : null === (e1 = r.getExtension("OES_vertex_array_object")) || void 0 === e1 || e1.bindVertexArrayOES(t1), this.current = t1, this.dirty = !1;
                            }
                        }
                        class zr extends ir {
                            getDefault() {
                                return 4;
                            }
                            set(t1) {
                                if (t1 === this.current && !this.dirty) return;
                                const e1 = this.gl;
                                e1.pixelStorei(e1.UNPACK_ALIGNMENT, t1), this.current = t1, this.dirty = !1;
                            }
                        }
                        class Or extends ir {
                            getDefault() {
                                return !1;
                            }
                            set(t1) {
                                if (t1 === this.current && !this.dirty) return;
                                const e1 = this.gl;
                                e1.pixelStorei(e1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, t1), this.current = t1, this.dirty = !1;
                            }
                        }
                        class Dr extends ir {
                            getDefault() {
                                return !1;
                            }
                            set(t1) {
                                if (t1 === this.current && !this.dirty) return;
                                const e1 = this.gl;
                                e1.pixelStorei(e1.UNPACK_FLIP_Y_WEBGL, t1), this.current = t1, this.dirty = !1;
                            }
                        }
                        class Rr extends ir {
                            constructor(t1, e1){
                                super(t1), this.context = t1, this.parent = e1;
                            }
                            getDefault() {
                                return null;
                            }
                        }
                        class Fr extends Rr {
                            setDirty() {
                                this.dirty = !0;
                            }
                            set(t1) {
                                if (t1 === this.current && !this.dirty) return;
                                this.context.bindFramebuffer.set(this.parent);
                                const e1 = this.gl;
                                e1.framebufferTexture2D(e1.FRAMEBUFFER, e1.COLOR_ATTACHMENT0, e1.TEXTURE_2D, t1, 0), this.current = t1, this.dirty = !1;
                            }
                        }
                        class Br extends Rr {
                            set(t1) {
                                if (t1 === this.current && !this.dirty) return;
                                this.context.bindFramebuffer.set(this.parent);
                                const e1 = this.gl;
                                e1.framebufferRenderbuffer(e1.FRAMEBUFFER, e1.DEPTH_ATTACHMENT, e1.RENDERBUFFER, t1), this.current = t1, this.dirty = !1;
                            }
                        }
                        class Nr extends Rr {
                            set(t1) {
                                if (t1 === this.current && !this.dirty) return;
                                this.context.bindFramebuffer.set(this.parent);
                                const e1 = this.gl;
                                e1.framebufferRenderbuffer(e1.FRAMEBUFFER, e1.DEPTH_STENCIL_ATTACHMENT, e1.RENDERBUFFER, t1), this.current = t1, this.dirty = !1;
                            }
                        }
                        class jr {
                            constructor(t1, e1, r, n, i){
                                this.context = t1, this.width = e1, this.height = r;
                                const a = t1.gl, o = this.framebuffer = a.createFramebuffer();
                                if (this.colorAttachment = new Fr(t1, o), n) this.depthAttachment = i ? new Nr(t1, o) : new Br(t1, o);
                                else if (i) throw new Error("Stencil cannot be set without depth");
                                if (a.checkFramebufferStatus(a.FRAMEBUFFER) !== a.FRAMEBUFFER_COMPLETE) throw new Error("Framebuffer is not complete");
                            }
                            destroy() {
                                const t1 = this.context.gl, e1 = this.colorAttachment.get();
                                if (e1 && t1.deleteTexture(e1), this.depthAttachment) {
                                    const e1 = this.depthAttachment.get();
                                    e1 && t1.deleteRenderbuffer(e1);
                                }
                                t1.deleteFramebuffer(this.framebuffer);
                            }
                        }
                        class Ur {
                            constructor(t1, e1, r){
                                this.blendFunction = t1, this.blendColor = e1, this.mask = r;
                            }
                        }
                        Ur.Replace = [
                            1,
                            0
                        ], Ur.disabled = new Ur(Ur.Replace, e1.aN.transparent, [
                            !1,
                            !1,
                            !1,
                            !1
                        ]), Ur.unblended = new Ur(Ur.Replace, e1.aN.transparent, [
                            !0,
                            !0,
                            !0,
                            !0
                        ]), Ur.alphaBlended = new Ur([
                            1,
                            771
                        ], e1.aN.transparent, [
                            !0,
                            !0,
                            !0,
                            !0
                        ]);
                        class Vr {
                            constructor(t1){
                                var e1, r;
                                if (this.gl = t1, this.clearColor = new ar(this), this.clearDepth = new or(this), this.clearStencil = new sr(this), this.colorMask = new lr(this), this.depthMask = new cr(this), this.stencilMask = new ur(this), this.stencilFunc = new hr(this), this.stencilOp = new fr(this), this.stencilTest = new pr(this), this.depthRange = new dr(this), this.depthTest = new mr(this), this.depthFunc = new gr(this), this.blend = new yr(this), this.blendFunc = new vr(this), this.blendColor = new xr(this), this.blendEquation = new _r(this), this.cullFace = new br(this), this.cullFaceSide = new wr(this), this.frontFace = new Tr(this), this.program = new kr(this), this.activeTexture = new Ar(this), this.viewport = new Mr(this), this.bindFramebuffer = new Sr(this), this.bindRenderbuffer = new Er(this), this.bindTexture = new Cr(this), this.bindVertexBuffer = new Lr(this), this.bindElementBuffer = new Ir(this), this.bindVertexArray = new Pr(this), this.pixelStoreUnpack = new zr(this), this.pixelStoreUnpackPremultiplyAlpha = new Or(this), this.pixelStoreUnpackFlipY = new Dr(this), this.extTextureFilterAnisotropic = t1.getExtension("EXT_texture_filter_anisotropic") || t1.getExtension("MOZ_EXT_texture_filter_anisotropic") || t1.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = t1.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)), this.maxTextureSize = t1.getParameter(t1.MAX_TEXTURE_SIZE), nr(t1)) {
                                    this.HALF_FLOAT = t1.HALF_FLOAT;
                                    const n = t1.getExtension("EXT_color_buffer_half_float");
                                    this.RGBA16F = null !== (e1 = t1.RGBA16F) && void 0 !== e1 ? e1 : null == n ? void 0 : n.RGBA16F_EXT, this.RGB16F = null !== (r = t1.RGB16F) && void 0 !== r ? r : null == n ? void 0 : n.RGB16F_EXT, t1.getExtension("EXT_color_buffer_float");
                                } else {
                                    t1.getExtension("EXT_color_buffer_half_float"), t1.getExtension("OES_texture_half_float_linear");
                                    const e1 = t1.getExtension("OES_texture_half_float");
                                    this.HALF_FLOAT = null == e1 ? void 0 : e1.HALF_FLOAT_OES;
                                }
                            }
                            setDefault() {
                                this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
                            }
                            setDirty() {
                                this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.bindVertexArray.dirty = !0, this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
                            }
                            createIndexBuffer(t1, e1) {
                                return new Qe(this, t1, e1);
                            }
                            createVertexBuffer(t1, e1, r) {
                                return new er(this, t1, e1, r);
                            }
                            createRenderbuffer(t1, e1, r) {
                                const n = this.gl, i = n.createRenderbuffer();
                                return this.bindRenderbuffer.set(i), n.renderbufferStorage(n.RENDERBUFFER, t1, e1, r), this.bindRenderbuffer.set(null), i;
                            }
                            createFramebuffer(t1, e1, r, n) {
                                return new jr(this, t1, e1, r, n);
                            }
                            clear({ color: t1, depth: e1, stencil: r }) {
                                const n = this.gl;
                                let i = 0;
                                t1 && (i |= n.COLOR_BUFFER_BIT, this.clearColor.set(t1), this.colorMask.set([
                                    !0,
                                    !0,
                                    !0,
                                    !0
                                ])), void 0 !== e1 && (i |= n.DEPTH_BUFFER_BIT, this.depthRange.set([
                                    0,
                                    1
                                ]), this.clearDepth.set(e1), this.depthMask.set(!0)), void 0 !== r && (i |= n.STENCIL_BUFFER_BIT, this.clearStencil.set(r), this.stencilMask.set(255)), n.clear(i);
                            }
                            setCullFace(t1) {
                                !1 === t1.enable ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(t1.mode), this.frontFace.set(t1.frontFace));
                            }
                            setDepthMode(t1) {
                                t1.func !== this.gl.ALWAYS || t1.mask ? (this.depthTest.set(!0), this.depthFunc.set(t1.func), this.depthMask.set(t1.mask), this.depthRange.set(t1.range)) : this.depthTest.set(!1);
                            }
                            setStencilMode(t1) {
                                t1.test.func !== this.gl.ALWAYS || t1.mask ? (this.stencilTest.set(!0), this.stencilMask.set(t1.mask), this.stencilOp.set([
                                    t1.fail,
                                    t1.depthFail,
                                    t1.pass
                                ]), this.stencilFunc.set({
                                    func: t1.test.func,
                                    ref: t1.ref,
                                    mask: t1.test.mask
                                })) : this.stencilTest.set(!1);
                            }
                            setColorMode(t1) {
                                e1.aF(t1.blendFunction, Ur.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(t1.blendFunction), this.blendColor.set(t1.blendColor)), this.colorMask.set(t1.mask);
                            }
                            createVertexArray() {
                                var t1;
                                return nr(this.gl) ? this.gl.createVertexArray() : null === (t1 = this.gl.getExtension("OES_vertex_array_object")) || void 0 === t1 ? void 0 : t1.createVertexArrayOES();
                            }
                            deleteVertexArray(t1) {
                                var e1;
                                return nr(this.gl) ? this.gl.deleteVertexArray(t1) : null === (e1 = this.gl.getExtension("OES_vertex_array_object")) || void 0 === e1 ? void 0 : e1.deleteVertexArrayOES(t1);
                            }
                            unbindVAO() {
                                this.bindVertexArray.set(null);
                            }
                        }
                        class qr {
                            constructor(t1, e1, r){
                                this.func = t1, this.mask = e1, this.range = r;
                            }
                        }
                        qr.ReadOnly = !1, qr.ReadWrite = !0, qr.disabled = new qr(519, qr.ReadOnly, [
                            0,
                            1
                        ]);
                        const Hr = 7680;
                        class Gr {
                            constructor(t1, e1, r, n, i, a){
                                this.test = t1, this.ref = e1, this.mask = r, this.fail = n, this.depthFail = i, this.pass = a;
                            }
                        }
                        Gr.disabled = new Gr({
                            func: 519,
                            mask: 0
                        }, 0, 0, Hr, Hr, Hr);
                        class Zr {
                            constructor(t1, e1, r){
                                this.enable = t1, this.mode = e1, this.frontFace = r;
                            }
                        }
                        let Wr;
                        function Yr(t1, r, n, i, a) {
                            const o = t1.context, s = o.gl, l = t1.useProgram("collisionBox"), c = [];
                            let u = 0, h = 0;
                            for(let f = 0; f < i.length; f++){
                                const p = i[f], d = r.getTile(p).getBucket(n);
                                if (!d) continue;
                                const m = a ? d.textCollisionBox : d.iconCollisionBox, g = d.collisionCircleArray;
                                if (g.length > 0) {
                                    const r = e1.H();
                                    e1.aR(r, d.placementInvProjMatrix, t1.transform.glCoordMatrix), e1.aR(r, r, d.placementViewportMatrix), c.push({
                                        circleArray: g,
                                        circleOffset: h,
                                        transform: p.posMatrix,
                                        invTransform: r,
                                        coord: p
                                    }), u += g.length / 4, h = u;
                                }
                                m && l.draw(o, s.LINES, qr.disabled, Gr.disabled, t1.colorModeForRenderPass(), Zr.disabled, Le(t1.transform, p.posMatrix), t1.style.map.terrain && t1.style.map.terrain.getTerrainData(p), n.id, m.layoutVertexBuffer, m.indexBuffer, m.segments, null, t1.transform.zoom, null, null, m.collisionVertexBuffer);
                            }
                            if (!a || !c.length) return;
                            const f = t1.useProgram("collisionCircle"), p = new e1.aS;
                            p.resize(4 * u), p._trim();
                            let d = 0;
                            for (const t1 of c)for(let e1 = 0; e1 < t1.circleArray.length / 4; e1++){
                                const r = 4 * e1, n = t1.circleArray[r + 0], i = t1.circleArray[r + 1], a = t1.circleArray[r + 2], o = t1.circleArray[r + 3];
                                p.emplace(d++, n, i, a, o, 0), p.emplace(d++, n, i, a, o, 1), p.emplace(d++, n, i, a, o, 2), p.emplace(d++, n, i, a, o, 3);
                            }
                            (!Wr || Wr.length < 2 * u) && (Wr = function(t1) {
                                const r = 2 * t1, n = new e1.aU;
                                n.resize(r), n._trim();
                                for(let t1 = 0; t1 < r; t1++){
                                    const e1 = 6 * t1;
                                    n.uint16[e1 + 0] = 4 * t1 + 0, n.uint16[e1 + 1] = 4 * t1 + 1, n.uint16[e1 + 2] = 4 * t1 + 2, n.uint16[e1 + 3] = 4 * t1 + 2, n.uint16[e1 + 4] = 4 * t1 + 3, n.uint16[e1 + 5] = 4 * t1 + 0;
                                }
                                return n;
                            }(u));
                            const m = o.createIndexBuffer(Wr, !0), g = o.createVertexBuffer(p, e1.aT.members, !0);
                            for (const r of c){
                                const i = Ie(r.transform, r.invTransform, t1.transform);
                                f.draw(o, s.TRIANGLES, qr.disabled, Gr.disabled, t1.colorModeForRenderPass(), Zr.disabled, i, t1.style.map.terrain && t1.style.map.terrain.getTerrainData(r.coord), n.id, g, m, e1.a0.simpleSegment(0, 2 * r.circleOffset, r.circleArray.length, r.circleArray.length / 2), null, t1.transform.zoom, null, null, null);
                            }
                            g.destroy(), m.destroy();
                        }
                        Zr.disabled = new Zr(!1, 1029, 2305), Zr.backCCW = new Zr(!0, 1029, 2305);
                        const Xr = e1.ao(new Float32Array(16));
                        function $r(t1, r, n, i, a) {
                            if ("translucent" !== t1.renderPass) return;
                            const o = Gr.disabled, s = t1.colorModeForRenderPass();
                            (n._unevaluatedLayout.hasValue("text-variable-anchor") || n._unevaluatedLayout.hasValue("text-variable-anchor-offset")) && function(t1, r, n, i, a, o, s, l, c) {
                                const u = r.transform, h = ie(), f = "map" === a, p = "map" === o;
                                for (const a of t1){
                                    const t1 = i.getTile(a), o = t1.getBucket(n);
                                    if (!o || !o.text || !o.text.segments.get().length) continue;
                                    const d = o.textSizeData, m = e1.ah(d, u.zoom), g = Nt(t1, 1, r.transform.zoom), y = _t(a.posMatrix, p, f, r.transform, g), v = "none" !== n.layout.get("icon-text-fit") && o.hasIconData();
                                    if (m) {
                                        const e1 = Math.pow(2, u.zoom - t1.tileID.overscaledZ), n = r.style.map.terrain ? (t1, e1)=>r.style.map.terrain.getElevation(a, t1, e1) : null, i = h.translatePosition(u, t1, s, l);
                                        Qr(o, f, p, c, u, y, a.posMatrix, e1, m, v, h, i, a.toUnwrapped(), n);
                                    }
                                }
                            }(i, t1, n, r, n.layout.get("text-rotation-alignment"), n.layout.get("text-pitch-alignment"), n.paint.get("text-translate"), n.paint.get("text-translate-anchor"), a), 0 !== n.paint.get("icon-opacity").constantOr(1) && en(t1, r, n, i, !1, n.paint.get("icon-translate"), n.paint.get("icon-translate-anchor"), n.layout.get("icon-rotation-alignment"), n.layout.get("icon-pitch-alignment"), n.layout.get("icon-keep-upright"), o, s), 0 !== n.paint.get("text-opacity").constantOr(1) && en(t1, r, n, i, !0, n.paint.get("text-translate"), n.paint.get("text-translate-anchor"), n.layout.get("text-rotation-alignment"), n.layout.get("text-pitch-alignment"), n.layout.get("text-keep-upright"), o, s), r.map.showCollisionBoxes && (Yr(t1, r, n, i, !0), Yr(t1, r, n, i, !1));
                        }
                        function Jr(t1, r, n, i, a, o) {
                            const { horizontalAlign: s, verticalAlign: l } = e1.av(t1), c = -(s - .5) * r, u = -(l - .5) * n;
                            return new e1.P((c / a + i[0]) * o, (u / a + i[1]) * o);
                        }
                        function Kr(t1, r, n, i, a, o) {
                            const s = r.tileAnchorPoint.add(new e1.P(r.translation[0], r.translation[1]));
                            if (r.pitchWithMap) {
                                let t1 = i.mult(o);
                                return n || (t1 = t1.rotate(-a)), wt(s.add(t1), r.labelPlaneMatrix, r.getElevation).point;
                            }
                            if (n) {
                                const e1 = It(r.tileAnchorPoint.x + 1, r.tileAnchorPoint.y, r).point.sub(t1), n = Math.atan(e1.y / e1.x) + (e1.x < 0 ? Math.PI : 0);
                                return t1.add(i.rotate(n));
                            }
                            return t1.add(i);
                        }
                        function Qr(t1, r, n, i, a, o, s, l, c, u, h, f, p, d) {
                            const m = t1.text.placedSymbolArray, g = t1.text.dynamicLayoutVertexArray, y = t1.icon.dynamicLayoutVertexArray, v = {};
                            g.clear();
                            for(let y = 0; y < m.length; y++){
                                const x = m.get(y), _ = t1.allowVerticalPlacement && !x.placedOrientation, b = x.hidden || !x.crossTileID || _ ? null : i[x.crossTileID];
                                if (b) {
                                    const i = new e1.P(x.anchorX, x.anchorY), m = {
                                        getElevation: d,
                                        width: a.width,
                                        height: a.height,
                                        labelPlaneMatrix: o,
                                        lineVertexArray: null,
                                        pitchWithMap: n,
                                        projection: h,
                                        projectionCache: null,
                                        tileAnchorPoint: i,
                                        translation: f,
                                        unwrappedTileID: p
                                    }, y = n ? wt(i, s, d) : It(i.x, i.y, m), _ = Tt(a.cameraToCenterDistance, y.signedDistanceFromCamera);
                                    let w = e1.aj(t1.textSizeData, c, x) * _ / e1.aq;
                                    n && (w *= t1.tilePixelRatio / l);
                                    const { width: T, height: k, anchor: A, textOffset: M, textBoxScale: S } = b, E = Jr(A, T, k, M, S, w), C = h.getPitchedTextCorrection(a, i.add(new e1.P(f[0], f[1])), p), L = Kr(y.point, m, r, E, a.angle, C), I = t1.allowVerticalPlacement && x.placedOrientation === e1.ai.vertical ? Math.PI / 2 : 0;
                                    for(let t1 = 0; t1 < x.numGlyphs; t1++)e1.ak(g, L, I);
                                    u && x.associatedIconIndex >= 0 && (v[x.associatedIconIndex] = {
                                        shiftedAnchor: L,
                                        angle: I
                                    });
                                } else Rt(x.numGlyphs, g);
                            }
                            if (u) {
                                y.clear();
                                const r = t1.icon.placedSymbolArray;
                                for(let t1 = 0; t1 < r.length; t1++){
                                    const n = r.get(t1);
                                    if (n.hidden) Rt(n.numGlyphs, y);
                                    else {
                                        const r = v[t1];
                                        if (r) for(let t1 = 0; t1 < n.numGlyphs; t1++)e1.ak(y, r.shiftedAnchor, r.angle);
                                        else Rt(n.numGlyphs, y);
                                    }
                                }
                                t1.icon.dynamicLayoutVertexBuffer.updateData(y);
                            }
                            t1.text.dynamicLayoutVertexBuffer.updateData(g);
                        }
                        function tn(t1, e1, r) {
                            return r.iconsInText && e1 ? "symbolTextAndIcon" : t1 ? "symbolSDF" : "symbolIcon";
                        }
                        function en(t1, r, n, i, a, o, s, l, c, u, h, f) {
                            const p = t1.context, d = p.gl, m = t1.transform, g = ie(), y = "map" === l, v = "map" === c, x = "viewport" !== l && "point" !== n.layout.get("symbol-placement"), _ = y && !v && !x, b = !v && x, w = !n.layout.get("symbol-sort-key").isConstant();
                            let T = !1;
                            const k = t1.depthModeForSublayer(0, qr.ReadOnly), A = n._unevaluatedLayout.hasValue("text-variable-anchor") || n._unevaluatedLayout.hasValue("text-variable-anchor-offset"), M = [], S = g.getCircleRadiusCorrection(m);
                            for (const l of i){
                                const i = r.getTile(l), c = i.getBucket(n);
                                if (!c) continue;
                                const h = a ? c.text : c.icon;
                                if (!h || !h.segments.get().length || !h.hasVisibleVertices) continue;
                                const f = h.programConfigurations.get(n.id), p = a || c.sdfIcons, k = a ? c.textSizeData : c.iconSizeData, E = v || 0 !== m.pitch, C = t1.useProgram(tn(p, a, c), f), L = e1.ah(k, m.zoom), I = t1.style.map.terrain && t1.style.map.terrain.getTerrainData(l);
                                let P, z, O, D, R = [
                                    0,
                                    0
                                ], F = null;
                                if (a) {
                                    if (z = i.glyphAtlasTexture, O = d.LINEAR, P = i.glyphAtlasTexture.size, c.iconsInText) {
                                        R = i.imageAtlasTexture.size, F = i.imageAtlasTexture;
                                        const e1 = "composite" === k.kind || "camera" === k.kind;
                                        D = E || t1.options.rotating || t1.options.zooming || e1 ? d.LINEAR : d.NEAREST;
                                    }
                                } else {
                                    const e1 = 1 !== n.layout.get("icon-size").constantOr(0) || c.iconsNeedLinear;
                                    z = i.imageAtlasTexture, O = p || t1.options.rotating || t1.options.zooming || e1 || E ? d.LINEAR : d.NEAREST, P = i.imageAtlasTexture.size;
                                }
                                const B = Nt(i, 1, t1.transform.zoom), N = b ? l.posMatrix : Xr, j = _t(N, v, y, t1.transform, B), U = bt(N, v, y, t1.transform, B), V = bt(l.posMatrix, v, y, t1.transform, B), q = g.translatePosition(t1.transform, i, o, s), H = A && c.hasTextData(), G = "none" !== n.layout.get("icon-text-fit") && H && c.hasIconData();
                                if (x) {
                                    const e1 = t1.style.map.terrain ? (e1, r)=>t1.style.map.terrain.getElevation(l, e1, r) : null, r = "map" === n.layout.get("text-rotation-alignment");
                                    At(c, l.posMatrix, t1, a, j, V, v, u, r, g, l.toUnwrapped(), m.width, m.height, q, e1);
                                }
                                const Z = l.posMatrix, W = a && A || G, Y = x || W ? Xr : j, X = U, $ = p && 0 !== n.paint.get(a ? "text-halo-width" : "icon-halo-width").constantOr(1);
                                let J;
                                J = p ? c.iconsInText ? Xe(k.kind, L, _, v, x, W, t1, Z, Y, X, q, P, R, S) : Ye(k.kind, L, _, v, x, W, t1, Z, Y, X, q, a, P, !0, S) : We(k.kind, L, _, v, x, W, t1, Z, Y, X, q, a, P, S);
                                const K = {
                                    program: C,
                                    buffers: h,
                                    uniformValues: J,
                                    atlasTexture: z,
                                    atlasTextureIcon: F,
                                    atlasInterpolation: O,
                                    atlasInterpolationIcon: D,
                                    isSDF: p,
                                    hasHalo: $
                                };
                                if (w && c.canOverlap) {
                                    T = !0;
                                    const t1 = h.segments.get();
                                    for (const r of t1)M.push({
                                        segments: new e1.a0([
                                            r
                                        ]),
                                        sortKey: r.sortKey,
                                        state: K,
                                        terrainData: I
                                    });
                                } else M.push({
                                    segments: h.segments,
                                    sortKey: 0,
                                    state: K,
                                    terrainData: I
                                });
                            }
                            T && M.sort((t1, e1)=>t1.sortKey - e1.sortKey);
                            for (const e1 of M){
                                const r = e1.state;
                                if (p.activeTexture.set(d.TEXTURE0), r.atlasTexture.bind(r.atlasInterpolation, d.CLAMP_TO_EDGE), r.atlasTextureIcon && (p.activeTexture.set(d.TEXTURE1), r.atlasTextureIcon && r.atlasTextureIcon.bind(r.atlasInterpolationIcon, d.CLAMP_TO_EDGE)), r.isSDF) {
                                    const i = r.uniformValues;
                                    r.hasHalo && (i.u_is_halo = 1, rn(r.buffers, e1.segments, n, t1, r.program, k, h, f, i, e1.terrainData)), i.u_is_halo = 0;
                                }
                                rn(r.buffers, e1.segments, n, t1, r.program, k, h, f, r.uniformValues, e1.terrainData);
                            }
                        }
                        function rn(t1, e1, r, n, i, a, o, s, l, c) {
                            const u = n.context, h = u.gl;
                            i.draw(u, h.TRIANGLES, a, o, s, Zr.disabled, l, c, r.id, t1.layoutVertexBuffer, t1.indexBuffer, e1, r.paint, n.transform.zoom, t1.programConfigurations.get(r.id), t1.dynamicLayoutVertexBuffer, t1.opacityVertexBuffer);
                        }
                        function nn(t1, r, n, i) {
                            if (0 !== n.paint.get("heatmap-opacity")) {
                                if ("offscreen" === t1.renderPass) {
                                    const a = t1.context, o = a.gl, s = Gr.disabled, l = new Ur([
                                        o.ONE,
                                        o.ONE
                                    ], e1.aN.transparent, [
                                        !0,
                                        !0,
                                        !0,
                                        !0
                                    ]);
                                    (function(t1, e1, r) {
                                        const n = t1.gl;
                                        t1.activeTexture.set(n.TEXTURE1), t1.viewport.set([
                                            0,
                                            0,
                                            e1.width / 4,
                                            e1.height / 4
                                        ]);
                                        let i = r.heatmapFbo;
                                        if (i) n.bindTexture(n.TEXTURE_2D, i.colorAttachment.get()), t1.bindFramebuffer.set(i.framebuffer);
                                        else {
                                            const a = n.createTexture();
                                            n.bindTexture(n.TEXTURE_2D, a), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_S, n.CLAMP_TO_EDGE), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_T, n.CLAMP_TO_EDGE), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, n.LINEAR), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MAG_FILTER, n.LINEAR), i = r.heatmapFbo = t1.createFramebuffer(e1.width / 4, e1.height / 4, !1, !1), function(t1, e1, r, n) {
                                                var i, a;
                                                const o = t1.gl, s = null !== (i = t1.HALF_FLOAT) && void 0 !== i ? i : o.UNSIGNED_BYTE, l = null !== (a = t1.RGBA16F) && void 0 !== a ? a : o.RGBA;
                                                o.texImage2D(o.TEXTURE_2D, 0, l, e1.width / 4, e1.height / 4, 0, o.RGBA, s, null), n.colorAttachment.set(r);
                                            }(t1, e1, a, i);
                                        }
                                    })(a, t1, n), a.clear({
                                        color: e1.aN.transparent
                                    });
                                    for(let e1 = 0; e1 < i.length; e1++){
                                        const c = i[e1];
                                        if (r.hasRenderableParent(c)) continue;
                                        const u = r.getTile(c), h = u.getBucket(n);
                                        if (!h) continue;
                                        const f = h.programConfigurations.get(n.id), p = t1.useProgram("heatmap", f), { zoom: d } = t1.transform;
                                        p.draw(a, o.TRIANGLES, qr.disabled, s, l, Zr.disabled, Oe(c.posMatrix, u, d, n.paint.get("heatmap-intensity")), null, n.id, h.layoutVertexBuffer, h.indexBuffer, h.segments, n.paint, t1.transform.zoom, f);
                                    }
                                    a.viewport.set([
                                        0,
                                        0,
                                        t1.width,
                                        t1.height
                                    ]);
                                } else "translucent" === t1.renderPass && (t1.context.setColorMode(t1.colorModeForRenderPass()), function(t1, e1) {
                                    const r = t1.context, n = r.gl, i = e1.heatmapFbo;
                                    if (!i) return;
                                    r.activeTexture.set(n.TEXTURE0), n.bindTexture(n.TEXTURE_2D, i.colorAttachment.get()), r.activeTexture.set(n.TEXTURE1);
                                    let a = e1.colorRampTexture;
                                    a || (a = e1.colorRampTexture = new w(r, e1.colorRamp, n.RGBA)), a.bind(n.LINEAR, n.CLAMP_TO_EDGE), t1.useProgram("heatmapTexture").draw(r, n.TRIANGLES, qr.disabled, Gr.disabled, t1.colorModeForRenderPass(), Zr.disabled, De(t1, e1, 0, 1), null, e1.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments, e1.paint, t1.transform.zoom);
                                }(t1, n));
                            }
                        }
                        function an(t1, e1, r, n, i) {
                            if (!r || !n || !n.imageAtlas) return;
                            const a = n.imageAtlas.patternPositions;
                            let o = a[r.to.toString()], s = a[r.from.toString()];
                            if (!o && s && (o = s), !s && o && (s = o), !o || !s) {
                                const t1 = i.getPaintProperty(e1);
                                o = a[t1], s = a[t1];
                            }
                            o && s && t1.setConstantPatternPositions(o, s);
                        }
                        function on(t1, e1, r, n, i, a, o) {
                            const s = t1.context.gl, l = "fill-pattern", c = r.paint.get(l), u = c && c.constantOr(1), h = r.getCrossfadeParameters();
                            let f, p, d, m, g;
                            o ? (p = u && !r.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", f = s.LINES) : (p = u ? "fillPattern" : "fill", f = s.TRIANGLES);
                            const y = c.constantOr(null);
                            for (const c of n){
                                const n = e1.getTile(c);
                                if (u && !n.patternsLoaded()) continue;
                                const v = n.getBucket(r);
                                if (!v) continue;
                                const x = v.programConfigurations.get(r.id), _ = t1.useProgram(p, x), b = t1.style.map.terrain && t1.style.map.terrain.getTerrainData(c);
                                u && (t1.context.activeTexture.set(s.TEXTURE0), n.imageAtlasTexture.bind(s.LINEAR, s.CLAMP_TO_EDGE), x.updatePaintBuffers(h)), an(x, l, y, n, r);
                                const w = b ? c : null, T = w ? w.posMatrix : c.posMatrix, k = t1.translatePosMatrix(T, n, r.paint.get("fill-translate"), r.paint.get("fill-translate-anchor"));
                                if (o) {
                                    m = v.indexBuffer2, g = v.segments2;
                                    const e1 = [
                                        s.drawingBufferWidth,
                                        s.drawingBufferHeight
                                    ];
                                    d = "fillOutlinePattern" === p && u ? Ee(k, t1, h, n, e1) : Se(k, e1);
                                } else m = v.indexBuffer, g = v.segments, d = u ? Me(k, t1, h, n) : Ae(k);
                                _.draw(t1.context, f, i, t1.stencilModeForClipping(c), a, Zr.disabled, d, b, r.id, v.layoutVertexBuffer, m, g, r.paint, t1.transform.zoom, x);
                            }
                        }
                        function sn(t1, e1, r, n, i, a, o) {
                            const s = t1.context, l = s.gl, c = "fill-extrusion-pattern", u = r.paint.get(c), h = u.constantOr(1), f = r.getCrossfadeParameters(), p = r.paint.get("fill-extrusion-opacity"), d = u.constantOr(null);
                            for (const u of n){
                                const n = e1.getTile(u), m = n.getBucket(r);
                                if (!m) continue;
                                const g = t1.style.map.terrain && t1.style.map.terrain.getTerrainData(u), y = m.programConfigurations.get(r.id), v = t1.useProgram(h ? "fillExtrusionPattern" : "fillExtrusion", y);
                                h && (t1.context.activeTexture.set(l.TEXTURE0), n.imageAtlasTexture.bind(l.LINEAR, l.CLAMP_TO_EDGE), y.updatePaintBuffers(f)), an(y, c, d, n, r);
                                const x = t1.translatePosMatrix(u.posMatrix, n, r.paint.get("fill-extrusion-translate"), r.paint.get("fill-extrusion-translate-anchor")), _ = r.paint.get("fill-extrusion-vertical-gradient"), b = h ? ke(x, t1, _, p, u, f, n) : Te(x, t1, _, p);
                                v.draw(s, s.gl.TRIANGLES, i, a, o, Zr.backCCW, b, g, r.id, m.layoutVertexBuffer, m.indexBuffer, m.segments, r.paint, t1.transform.zoom, y, t1.style.map.terrain && m.centroidVertexBuffer);
                            }
                        }
                        function ln(t1, e1, r, n, i, a, o) {
                            const s = t1.context, l = s.gl, c = r.fbo;
                            if (!c) return;
                            const u = t1.useProgram("hillshade"), h = t1.style.map.terrain && t1.style.map.terrain.getTerrainData(e1);
                            s.activeTexture.set(l.TEXTURE0), l.bindTexture(l.TEXTURE_2D, c.colorAttachment.get());
                            const f = h ? e1 : null;
                            u.draw(s, l.TRIANGLES, i, a, o, Zr.disabled, Re(t1, r, n, f), h, n.id, t1.rasterBoundsBuffer, t1.quadTriangleIndexBuffer, t1.rasterBoundsSegments);
                        }
                        function cn(t1, e1, r, n, i, a) {
                            const o = t1.context, s = o.gl, l = e1.dem;
                            if (l && l.data) {
                                const c = l.dim, u = l.stride, h = l.getPixels();
                                if (o.activeTexture.set(s.TEXTURE1), o.pixelStoreUnpackPremultiplyAlpha.set(!1), e1.demTexture = e1.demTexture || t1.getTileTexture(u), e1.demTexture) {
                                    const t1 = e1.demTexture;
                                    t1.update(h, {
                                        premultiply: !1
                                    }), t1.bind(s.NEAREST, s.CLAMP_TO_EDGE);
                                } else e1.demTexture = new w(o, h, s.RGBA, {
                                    premultiply: !1
                                }), e1.demTexture.bind(s.NEAREST, s.CLAMP_TO_EDGE);
                                o.activeTexture.set(s.TEXTURE0);
                                let f = e1.fbo;
                                if (!f) {
                                    const t1 = new w(o, {
                                        width: c,
                                        height: c,
                                        data: null
                                    }, s.RGBA);
                                    t1.bind(s.LINEAR, s.CLAMP_TO_EDGE), f = e1.fbo = o.createFramebuffer(c, c, !0, !1), f.colorAttachment.set(t1.texture);
                                }
                                o.bindFramebuffer.set(f.framebuffer), o.viewport.set([
                                    0,
                                    0,
                                    c,
                                    c
                                ]), t1.useProgram("hillshadePrepare").draw(o, s.TRIANGLES, n, i, a, Zr.disabled, Fe(e1.tileID, l), null, r.id, t1.rasterBoundsBuffer, t1.quadTriangleIndexBuffer, t1.rasterBoundsSegments), e1.needsHillshadePrepare = !1;
                            }
                        }
                        function un(t1, r, n, i, o, s) {
                            const l = i.paint.get("raster-fade-duration");
                            if (!s && l > 0) {
                                const i = a.now(), s = (i - t1.timeAdded) / l, c = r ? (i - r.timeAdded) / l : -1, u = n.getSource(), h = o.coveringZoomLevel({
                                    tileSize: u.tileSize,
                                    roundZoom: u.roundZoom
                                }), f = !r || Math.abs(r.tileID.overscaledZ - h) > Math.abs(t1.tileID.overscaledZ - h), p = f && t1.refreshedUponExpiration ? 1 : e1.ad(f ? s : 1 - c, 0, 1);
                                return t1.refreshedUponExpiration && s >= 1 && (t1.refreshedUponExpiration = !1), r ? {
                                    opacity: 1,
                                    mix: 1 - p
                                } : {
                                    opacity: p,
                                    mix: 0
                                };
                            }
                            return {
                                opacity: 1,
                                mix: 0
                            };
                        }
                        const hn = new e1.aN(1, 0, 0, 1), fn = new e1.aN(0, 1, 0, 1), pn = new e1.aN(0, 0, 1, 1), dn = new e1.aN(1, 0, 1, 1), mn = new e1.aN(0, 1, 1, 1);
                        function gn(t1) {
                            const e1 = t1.transform.padding;
                            yn(t1, t1.transform.height - (e1.top || 0), 3, hn), yn(t1, e1.bottom || 0, 3, fn), vn(t1, e1.left || 0, 3, pn), vn(t1, t1.transform.width - (e1.right || 0), 3, dn);
                            const r = t1.transform.centerPoint;
                            !function(t1, e1, r, n) {
                                const i = 20, a = 2;
                                xn(t1, e1 - a / 2, r - i / 2, a, i, n), xn(t1, e1 - i / 2, r - a / 2, i, a, n);
                            }(t1, r.x, t1.transform.height - r.y, mn);
                        }
                        function yn(t1, e1, r, n) {
                            xn(t1, 0, e1 + r / 2, t1.transform.width, r, n);
                        }
                        function vn(t1, e1, r, n) {
                            xn(t1, e1 - r / 2, 0, r, t1.transform.height, n);
                        }
                        function xn(t1, e1, r, n, i, a) {
                            const o = t1.context, s = o.gl;
                            s.enable(s.SCISSOR_TEST), s.scissor(e1 * t1.pixelRatio, r * t1.pixelRatio, n * t1.pixelRatio, i * t1.pixelRatio), o.clear({
                                color: a
                            }), s.disable(s.SCISSOR_TEST);
                        }
                        function _n(t1, r, n) {
                            const i = t1.context, a = i.gl, o = n.posMatrix, s = t1.useProgram("debug"), l = qr.disabled, c = Gr.disabled, u = t1.colorModeForRenderPass(), h = "$debug", f = t1.style.map.terrain && t1.style.map.terrain.getTerrainData(n);
                            i.activeTexture.set(a.TEXTURE0);
                            const p = r.getTileByID(n.key).latestRawTileData, d = p && p.byteLength || 0, m = Math.floor(d / 1024), g = r.getTile(n).tileSize, y = 512 / Math.min(g, 512) * (n.overscaledZ / t1.transform.zoom) * .5;
                            let v = n.canonical.toString();
                            n.overscaledZ !== n.canonical.z && (v += ` => ${n.overscaledZ}`), function(t1, e1) {
                                t1.initDebugOverlayCanvas();
                                const r = t1.debugOverlayCanvas, n = t1.context.gl, i = t1.debugOverlayCanvas.getContext("2d");
                                i.clearRect(0, 0, r.width, r.height), i.shadowColor = "white", i.shadowBlur = 2, i.lineWidth = 1.5, i.strokeStyle = "white", i.textBaseline = "top", i.font = "bold 36px Open Sans, sans-serif", i.fillText(e1, 5, 5), i.strokeText(e1, 5, 5), t1.debugOverlayTexture.update(r), t1.debugOverlayTexture.bind(n.LINEAR, n.CLAMP_TO_EDGE);
                            }(t1, `${v} ${m}kB`), s.draw(i, a.TRIANGLES, l, c, Ur.alphaBlended, Zr.disabled, Pe(o, e1.aN.transparent, y), null, h, t1.debugBuffer, t1.quadTriangleIndexBuffer, t1.debugSegments), s.draw(i, a.LINE_STRIP, l, c, u, Zr.disabled, Pe(o, e1.aN.red), f, h, t1.debugBuffer, t1.tileBorderIndexBuffer, t1.debugSegments);
                        }
                        function bn(t1, e1, r) {
                            const n = t1.context, i = n.gl, a = t1.colorModeForRenderPass(), o = new qr(i.LEQUAL, qr.ReadWrite, t1.depthRangeFor3D), s = t1.useProgram("terrain"), l = e1.getTerrainMesh();
                            n.bindFramebuffer.set(null), n.viewport.set([
                                0,
                                0,
                                t1.width,
                                t1.height
                            ]);
                            for (const c of r){
                                const r = t1.renderToTexture.getTexture(c), u = e1.getTerrainData(c.tileID);
                                n.activeTexture.set(i.TEXTURE0), i.bindTexture(i.TEXTURE_2D, r.texture);
                                const h = t1.transform.calculatePosMatrix(c.tileID.toUnwrapped()), f = e1.getMeshFrameDelta(t1.transform.zoom), p = t1.transform.calculateFogMatrix(c.tileID.toUnwrapped()), d = xe(h, f, p, t1.style.sky, t1.transform.pitch);
                                s.draw(n, i.TRIANGLES, o, Gr.disabled, a, Zr.backCCW, d, u, "terrain", l.vertexBuffer, l.indexBuffer, l.segments);
                            }
                        }
                        class wn {
                            constructor(t1, e1, r){
                                this.vertexBuffer = t1, this.indexBuffer = e1, this.segments = r;
                            }
                            destroy() {
                                this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.vertexBuffer = null, this.indexBuffer = null, this.segments = null;
                            }
                        }
                        class Tn {
                            constructor(t1, r){
                                this.context = new Vr(t1), this.transform = r, this._tileTextures = {}, this.terrainFacilitator = {
                                    dirty: !0,
                                    matrix: e1.ao(new Float64Array(16)),
                                    renderTime: 0
                                }, this.setup(), this.numSublayers = dt.maxUnderzooming + dt.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.crossTileSymbolIndex = new he;
                            }
                            resize(t1, e1, r) {
                                if (this.width = Math.floor(t1 * r), this.height = Math.floor(e1 * r), this.pixelRatio = r, this.context.viewport.set([
                                    0,
                                    0,
                                    this.width,
                                    this.height
                                ]), this.style) for (const t1 of this.style._order)this.style._layers[t1].resize();
                            }
                            setup() {
                                const t1 = this.context, r = new e1.aX;
                                r.emplaceBack(0, 0), r.emplaceBack(e1.X, 0), r.emplaceBack(0, e1.X), r.emplaceBack(e1.X, e1.X), this.tileExtentBuffer = t1.createVertexBuffer(r, me.members), this.tileExtentSegments = e1.a0.simpleSegment(0, 0, 4, 2);
                                const n = new e1.aX;
                                n.emplaceBack(0, 0), n.emplaceBack(e1.X, 0), n.emplaceBack(0, e1.X), n.emplaceBack(e1.X, e1.X), this.debugBuffer = t1.createVertexBuffer(n, me.members), this.debugSegments = e1.a0.simpleSegment(0, 0, 4, 5);
                                const i = new e1.$;
                                i.emplaceBack(0, 0, 0, 0), i.emplaceBack(e1.X, 0, e1.X, 0), i.emplaceBack(0, e1.X, 0, e1.X), i.emplaceBack(e1.X, e1.X, e1.X, e1.X), this.rasterBoundsBuffer = t1.createVertexBuffer(i, et.members), this.rasterBoundsSegments = e1.a0.simpleSegment(0, 0, 4, 2);
                                const a = new e1.aX;
                                a.emplaceBack(0, 0), a.emplaceBack(1, 0), a.emplaceBack(0, 1), a.emplaceBack(1, 1), this.viewportBuffer = t1.createVertexBuffer(a, me.members), this.viewportSegments = e1.a0.simpleSegment(0, 0, 4, 2);
                                const o = new e1.aZ;
                                o.emplaceBack(0), o.emplaceBack(1), o.emplaceBack(3), o.emplaceBack(2), o.emplaceBack(0), this.tileBorderIndexBuffer = t1.createIndexBuffer(o);
                                const s = new e1.aY;
                                s.emplaceBack(0, 1, 2), s.emplaceBack(2, 1, 3), this.quadTriangleIndexBuffer = t1.createIndexBuffer(s);
                                const l = this.context.gl;
                                this.stencilClearMode = new Gr({
                                    func: l.ALWAYS,
                                    mask: 0
                                }, 0, 255, l.ZERO, l.ZERO, l.ZERO);
                            }
                            clearStencil() {
                                const t1 = this.context, r = t1.gl;
                                this.nextStencilID = 1, this.currentStencilSource = void 0;
                                const n = e1.H();
                                e1.aQ(n, 0, this.width, this.height, 0, 0, 1), e1.K(n, n, [
                                    r.drawingBufferWidth,
                                    r.drawingBufferHeight,
                                    0
                                ]), this.useProgram("clippingMask").draw(t1, r.TRIANGLES, qr.disabled, this.stencilClearMode, Ur.disabled, Zr.disabled, ze(n), null, "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
                            }
                            _renderTileClippingMasks(t1, e1) {
                                if (this.currentStencilSource === t1.source || !t1.isTileClipped() || !e1 || !e1.length) return;
                                this.currentStencilSource = t1.source;
                                const r = this.context, n = r.gl;
                                this.nextStencilID + e1.length > 256 && this.clearStencil(), r.setColorMode(Ur.disabled), r.setDepthMode(qr.disabled);
                                const i = this.useProgram("clippingMask");
                                this._tileClippingMaskIDs = {};
                                for (const t1 of e1){
                                    const e1 = this._tileClippingMaskIDs[t1.key] = this.nextStencilID++, a = this.style.map.terrain && this.style.map.terrain.getTerrainData(t1);
                                    i.draw(r, n.TRIANGLES, qr.disabled, new Gr({
                                        func: n.ALWAYS,
                                        mask: 0
                                    }, e1, 255, n.KEEP, n.KEEP, n.REPLACE), Ur.disabled, Zr.disabled, ze(t1.posMatrix), a, "$clipping", this.tileExtentBuffer, this.quadTriangleIndexBuffer, this.tileExtentSegments);
                                }
                            }
                            stencilModeFor3D() {
                                this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
                                const t1 = this.nextStencilID++, e1 = this.context.gl;
                                return new Gr({
                                    func: e1.NOTEQUAL,
                                    mask: 255
                                }, t1, 255, e1.KEEP, e1.KEEP, e1.REPLACE);
                            }
                            stencilModeForClipping(t1) {
                                const e1 = this.context.gl;
                                return new Gr({
                                    func: e1.EQUAL,
                                    mask: 255
                                }, this._tileClippingMaskIDs[t1.key], 0, e1.KEEP, e1.KEEP, e1.REPLACE);
                            }
                            stencilConfigForOverlap(t1) {
                                const e1 = this.context.gl, r = t1.sort((t1, e1)=>e1.overscaledZ - t1.overscaledZ), n = r[r.length - 1].overscaledZ, i = r[0].overscaledZ - n + 1;
                                if (i > 1) {
                                    this.currentStencilSource = void 0, this.nextStencilID + i > 256 && this.clearStencil();
                                    const t1 = {};
                                    for(let r = 0; r < i; r++)t1[r + n] = new Gr({
                                        func: e1.GEQUAL,
                                        mask: 255
                                    }, r + this.nextStencilID, 255, e1.KEEP, e1.KEEP, e1.REPLACE);
                                    return this.nextStencilID += i, [
                                        t1,
                                        r
                                    ];
                                }
                                return [
                                    {
                                        [n]: Gr.disabled
                                    },
                                    r
                                ];
                            }
                            colorModeForRenderPass() {
                                const t1 = this.context.gl;
                                if (this._showOverdrawInspector) {
                                    const r = 1 / 8;
                                    return new Ur([
                                        t1.CONSTANT_COLOR,
                                        t1.ONE
                                    ], new e1.aN(r, r, r, 0), [
                                        !0,
                                        !0,
                                        !0,
                                        !0
                                    ]);
                                }
                                return "opaque" === this.renderPass ? Ur.unblended : Ur.alphaBlended;
                            }
                            depthModeForSublayer(t1, e1, r) {
                                if (!this.opaquePassEnabledForLayer()) return qr.disabled;
                                const n = 1 - ((1 + this.currentLayer) * this.numSublayers + t1) * this.depthEpsilon;
                                return new qr(r || this.context.gl.LEQUAL, e1, [
                                    n,
                                    n
                                ]);
                            }
                            opaquePassEnabledForLayer() {
                                return this.currentLayer < this.opaquePassCutoff;
                            }
                            render(t1, r) {
                                var n;
                                this.style = t1, this.options = r, this.lineAtlas = t1.lineAtlas, this.imageManager = t1.imageManager, this.glyphManager = t1.glyphManager, this.symbolFadeChange = t1.placement.symbolFadeChange(a.now()), this.imageManager.beginFrame();
                                const i = this.style._order, o = this.style.sourceCaches, s = {}, l = {}, c = {};
                                for(const t1 in o){
                                    const e1 = o[t1];
                                    e1.used && e1.prepare(this.context), s[t1] = e1.getVisibleCoordinates(), l[t1] = s[t1].slice().reverse(), c[t1] = e1.getVisibleCoordinates(!0).reverse();
                                }
                                this.opaquePassCutoff = 1 / 0;
                                for(let t1 = 0; t1 < i.length; t1++){
                                    const e1 = i[t1];
                                    if (this.style._layers[e1].is3D()) {
                                        this.opaquePassCutoff = t1;
                                        break;
                                    }
                                }
                                this.maybeDrawDepthAndCoords(!1), this.renderToTexture && (this.renderToTexture.prepareForRender(this.style, this.transform.zoom), this.opaquePassCutoff = 0), this.renderPass = "offscreen";
                                for (const t1 of i){
                                    const e1 = this.style._layers[t1];
                                    if (!e1.hasOffscreenPass() || e1.isHidden(this.transform.zoom)) continue;
                                    const r = l[e1.source];
                                    ("custom" === e1.type || r.length) && this.renderLayer(this, o[e1.source], e1, r);
                                }
                                if (this.context.bindFramebuffer.set(null), this.context.clear({
                                    color: r.showOverdrawInspector ? e1.aN.black : e1.aN.transparent,
                                    depth: 1
                                }), this.clearStencil(), (null === (n = this.style.stylesheet) || void 0 === n ? void 0 : n.sky) && function(t1, r) {
                                    const n = t1.context, i = n.gl, a = ((t1, e1, r)=>({
                                            u_sky_color: t1.properties.get("sky-color"),
                                            u_horizon_color: t1.properties.get("horizon-color"),
                                            u_horizon: (e1.height / 2 + e1.getHorizon()) * r,
                                            u_sky_horizon_blend: t1.properties.get("sky-horizon-blend") * e1.height / 2 * r
                                        }))(r, t1.style.map.transform, t1.pixelRatio), o = new qr(i.LEQUAL, qr.ReadWrite, [
                                        0,
                                        1
                                    ]), s = Gr.disabled, l = t1.colorModeForRenderPass(), c = t1.useProgram("sky");
                                    if (!r.mesh) {
                                        const t1 = new e1.aX;
                                        t1.emplaceBack(-1, -1), t1.emplaceBack(1, -1), t1.emplaceBack(1, 1), t1.emplaceBack(-1, 1);
                                        const i = new e1.aY;
                                        i.emplaceBack(0, 1, 2), i.emplaceBack(0, 2, 3), r.mesh = new wn(n.createVertexBuffer(t1, me.members), n.createIndexBuffer(i), e1.a0.simpleSegment(0, 0, t1.length, i.length));
                                    }
                                    c.draw(n, i.TRIANGLES, o, s, l, Zr.disabled, a, void 0, "sky", r.mesh.vertexBuffer, r.mesh.indexBuffer, r.mesh.segments);
                                }(this, this.style.sky), this._showOverdrawInspector = r.showOverdrawInspector, this.depthRangeFor3D = [
                                    0,
                                    1 - (t1._order.length + 2) * this.numSublayers * this.depthEpsilon
                                ], !this.renderToTexture) for(this.renderPass = "opaque", this.currentLayer = i.length - 1; this.currentLayer >= 0; this.currentLayer--){
                                    const t1 = this.style._layers[i[this.currentLayer]], e1 = o[t1.source], r = s[t1.source];
                                    this._renderTileClippingMasks(t1, r), this.renderLayer(this, e1, t1, r);
                                }
                                for(this.renderPass = "translucent", this.currentLayer = 0; this.currentLayer < i.length; this.currentLayer++){
                                    const t1 = this.style._layers[i[this.currentLayer]], e1 = o[t1.source];
                                    if (this.renderToTexture && this.renderToTexture.renderLayer(t1)) continue;
                                    const r = ("symbol" === t1.type ? c : l)[t1.source];
                                    this._renderTileClippingMasks(t1, s[t1.source]), this.renderLayer(this, e1, t1, r);
                                }
                                if (this.options.showTileBoundaries) {
                                    const t1 = function(t1, e1) {
                                        let r = null;
                                        const n = Object.values(t1._layers).flatMap((r)=>r.source && !r.isHidden(e1) ? [
                                                t1.sourceCaches[r.source]
                                            ] : []), i = n.filter((t1)=>"vector" === t1.getSource().type), a = n.filter((t1)=>"vector" !== t1.getSource().type), o = (t1)=>{
                                            (!r || r.getSource().maxzoom < t1.getSource().maxzoom) && (r = t1);
                                        };
                                        return i.forEach((t1)=>o(t1)), r || a.forEach((t1)=>o(t1)), r;
                                    }(this.style, this.transform.zoom);
                                    t1 && function(t1, e1, r) {
                                        for(let n = 0; n < r.length; n++)_n(t1, e1, r[n]);
                                    }(this, t1, t1.getVisibleCoordinates());
                                }
                                this.options.showPadding && gn(this), this.context.setDefault();
                            }
                            maybeDrawDepthAndCoords(t1) {
                                if (!this.style || !this.style.map || !this.style.map.terrain) return;
                                const r = this.terrainFacilitator.matrix, n = this.transform.modelViewProjectionMatrix;
                                let i = this.terrainFacilitator.dirty;
                                i || (i = t1 ? !e1.a_(r, n) : !e1.a$(r, n)), i || (i = this.style.map.terrain.sourceCache.tilesAfterTime(this.terrainFacilitator.renderTime).length > 0), i && (e1.b0(r, n), this.terrainFacilitator.renderTime = Date.now(), this.terrainFacilitator.dirty = !1, function(t1, r) {
                                    const n = t1.context, i = n.gl, a = Ur.unblended, o = new qr(i.LEQUAL, qr.ReadWrite, [
                                        0,
                                        1
                                    ]), s = r.getTerrainMesh(), l = r.sourceCache.getRenderableTiles(), c = t1.useProgram("terrainDepth");
                                    n.bindFramebuffer.set(r.getFramebuffer("depth").framebuffer), n.viewport.set([
                                        0,
                                        0,
                                        t1.width / devicePixelRatio,
                                        t1.height / devicePixelRatio
                                    ]), n.clear({
                                        color: e1.aN.transparent,
                                        depth: 1
                                    });
                                    for (const e1 of l){
                                        const l = r.getTerrainData(e1.tileID), u = {
                                            u_matrix: t1.transform.calculatePosMatrix(e1.tileID.toUnwrapped()),
                                            u_ele_delta: r.getMeshFrameDelta(t1.transform.zoom)
                                        };
                                        c.draw(n, i.TRIANGLES, o, Gr.disabled, a, Zr.backCCW, u, l, "terrain", s.vertexBuffer, s.indexBuffer, s.segments);
                                    }
                                    n.bindFramebuffer.set(null), n.viewport.set([
                                        0,
                                        0,
                                        t1.width,
                                        t1.height
                                    ]);
                                }(this, this.style.map.terrain), function(t1, r) {
                                    const n = t1.context, i = n.gl, a = Ur.unblended, o = new qr(i.LEQUAL, qr.ReadWrite, [
                                        0,
                                        1
                                    ]), s = r.getTerrainMesh(), l = r.getCoordsTexture(), c = r.sourceCache.getRenderableTiles(), u = t1.useProgram("terrainCoords");
                                    n.bindFramebuffer.set(r.getFramebuffer("coords").framebuffer), n.viewport.set([
                                        0,
                                        0,
                                        t1.width / devicePixelRatio,
                                        t1.height / devicePixelRatio
                                    ]), n.clear({
                                        color: e1.aN.transparent,
                                        depth: 1
                                    }), r.coordsIndex = [];
                                    for (const e1 of c){
                                        const c = r.getTerrainData(e1.tileID);
                                        n.activeTexture.set(i.TEXTURE0), i.bindTexture(i.TEXTURE_2D, l.texture);
                                        const h = {
                                            u_matrix: t1.transform.calculatePosMatrix(e1.tileID.toUnwrapped()),
                                            u_terrain_coords_id: (255 - r.coordsIndex.length) / 255,
                                            u_texture: 0,
                                            u_ele_delta: r.getMeshFrameDelta(t1.transform.zoom)
                                        };
                                        u.draw(n, i.TRIANGLES, o, Gr.disabled, a, Zr.backCCW, h, c, "terrain", s.vertexBuffer, s.indexBuffer, s.segments), r.coordsIndex.push(e1.tileID.key);
                                    }
                                    n.bindFramebuffer.set(null), n.viewport.set([
                                        0,
                                        0,
                                        t1.width,
                                        t1.height
                                    ]);
                                }(this, this.style.map.terrain));
                            }
                            renderLayer(t1, r, n, i) {
                                if (!n.isHidden(this.transform.zoom) && ("background" === n.type || "custom" === n.type || (i || []).length)) switch(this.id = n.id, n.type){
                                    case "symbol":
                                        $r(t1, r, n, i, this.style.placement.variableOffsets);
                                        break;
                                    case "circle":
                                        !function(t1, r, n, i) {
                                            if ("translucent" !== t1.renderPass) return;
                                            const a = n.paint.get("circle-opacity"), o = n.paint.get("circle-stroke-width"), s = n.paint.get("circle-stroke-opacity"), l = !n.layout.get("circle-sort-key").isConstant();
                                            if (0 === a.constantOr(1) && (0 === o.constantOr(1) || 0 === s.constantOr(1))) return;
                                            const c = t1.context, u = c.gl, h = t1.depthModeForSublayer(0, qr.ReadOnly), f = Gr.disabled, p = t1.colorModeForRenderPass(), d = [];
                                            for(let a = 0; a < i.length; a++){
                                                const o = i[a], s = r.getTile(o), c = s.getBucket(n);
                                                if (!c) continue;
                                                const u = c.programConfigurations.get(n.id), h = t1.useProgram("circle", u), f = c.layoutVertexBuffer, p = c.indexBuffer, m = t1.style.map.terrain && t1.style.map.terrain.getTerrainData(o), g = {
                                                    programConfiguration: u,
                                                    program: h,
                                                    layoutVertexBuffer: f,
                                                    indexBuffer: p,
                                                    uniformValues: Ce(t1, o, s, n),
                                                    terrainData: m
                                                };
                                                if (l) {
                                                    const t1 = c.segments.get();
                                                    for (const r of t1)d.push({
                                                        segments: new e1.a0([
                                                            r
                                                        ]),
                                                        sortKey: r.sortKey,
                                                        state: g
                                                    });
                                                } else d.push({
                                                    segments: c.segments,
                                                    sortKey: 0,
                                                    state: g
                                                });
                                            }
                                            l && d.sort((t1, e1)=>t1.sortKey - e1.sortKey);
                                            for (const e1 of d){
                                                const { programConfiguration: r, program: i, layoutVertexBuffer: a, indexBuffer: o, uniformValues: s, terrainData: l } = e1.state, d = e1.segments;
                                                i.draw(c, u.TRIANGLES, h, f, p, Zr.disabled, s, l, n.id, a, o, d, n.paint, t1.transform.zoom, r);
                                            }
                                        }(t1, r, n, i);
                                        break;
                                    case "heatmap":
                                        nn(t1, r, n, i);
                                        break;
                                    case "line":
                                        !function(t1, r, n, i) {
                                            if ("translucent" !== t1.renderPass) return;
                                            const a = n.paint.get("line-opacity"), o = n.paint.get("line-width");
                                            if (0 === a.constantOr(1) || 0 === o.constantOr(1)) return;
                                            const s = t1.depthModeForSublayer(0, qr.ReadOnly), l = t1.colorModeForRenderPass(), c = n.paint.get("line-dasharray"), u = n.paint.get("line-pattern"), h = u.constantOr(1), f = n.paint.get("line-gradient"), p = n.getCrossfadeParameters(), d = h ? "linePattern" : c ? "lineSDF" : f ? "lineGradient" : "line", m = t1.context, g = m.gl;
                                            let y = !0;
                                            for (const a of i){
                                                const i = r.getTile(a);
                                                if (h && !i.patternsLoaded()) continue;
                                                const o = i.getBucket(n);
                                                if (!o) continue;
                                                const v = o.programConfigurations.get(n.id), x = t1.context.program.get(), _ = t1.useProgram(d, v), b = y || _.program !== x, T = t1.style.map.terrain && t1.style.map.terrain.getTerrainData(a), k = u.constantOr(null);
                                                if (k && i.imageAtlas) {
                                                    const t1 = i.imageAtlas, e1 = t1.patternPositions[k.to.toString()], r = t1.patternPositions[k.from.toString()];
                                                    e1 && r && v.setConstantPatternPositions(e1, r);
                                                }
                                                const A = T ? a : null, M = h ? Ue(t1, i, n, p, A) : c ? Ve(t1, i, n, c, p, A) : f ? je(t1, i, n, o.lineClipsArray.length, A) : Ne(t1, i, n, A);
                                                if (h) m.activeTexture.set(g.TEXTURE0), i.imageAtlasTexture.bind(g.LINEAR, g.CLAMP_TO_EDGE), v.updatePaintBuffers(p);
                                                else if (c && (b || t1.lineAtlas.dirty)) m.activeTexture.set(g.TEXTURE0), t1.lineAtlas.bind(m);
                                                else if (f) {
                                                    const i = o.gradients[n.id];
                                                    let s = i.texture;
                                                    if (n.gradientVersion !== i.version) {
                                                        let l = 256;
                                                        if (n.stepInterpolant) {
                                                            const n = r.getSource().maxzoom, i = a.canonical.z === n ? Math.ceil(1 << t1.transform.maxZoom - a.canonical.z) : 1, s = o.maxLineLength / e1.X * 1024 * i;
                                                            l = e1.ad(e1.aV(s), 256, m.maxTextureSize);
                                                        }
                                                        i.gradient = e1.aW({
                                                            expression: n.gradientExpression(),
                                                            evaluationKey: "lineProgress",
                                                            resolution: l,
                                                            image: i.gradient || void 0,
                                                            clips: o.lineClipsArray
                                                        }), i.texture ? i.texture.update(i.gradient) : i.texture = new w(m, i.gradient, g.RGBA), i.version = n.gradientVersion, s = i.texture;
                                                    }
                                                    m.activeTexture.set(g.TEXTURE0), s.bind(n.stepInterpolant ? g.NEAREST : g.LINEAR, g.CLAMP_TO_EDGE);
                                                }
                                                _.draw(m, g.TRIANGLES, s, t1.stencilModeForClipping(a), l, Zr.disabled, M, T, n.id, o.layoutVertexBuffer, o.indexBuffer, o.segments, n.paint, t1.transform.zoom, v, o.layoutVertexBuffer2), y = !1;
                                            }
                                        }(t1, r, n, i);
                                        break;
                                    case "fill":
                                        !function(t1, r, n, i) {
                                            const a = n.paint.get("fill-color"), o = n.paint.get("fill-opacity");
                                            if (0 === o.constantOr(1)) return;
                                            const s = t1.colorModeForRenderPass(), l = n.paint.get("fill-pattern"), c = t1.opaquePassEnabledForLayer() && !l.constantOr(1) && 1 === a.constantOr(e1.aN.transparent).a && 1 === o.constantOr(0) ? "opaque" : "translucent";
                                            if (t1.renderPass === c) {
                                                const e1 = t1.depthModeForSublayer(1, "opaque" === t1.renderPass ? qr.ReadWrite : qr.ReadOnly);
                                                on(t1, r, n, i, e1, s, !1);
                                            }
                                            if ("translucent" === t1.renderPass && n.paint.get("fill-antialias")) {
                                                const e1 = t1.depthModeForSublayer(n.getPaintProperty("fill-outline-color") ? 2 : 0, qr.ReadOnly);
                                                on(t1, r, n, i, e1, s, !0);
                                            }
                                        }(t1, r, n, i);
                                        break;
                                    case "fill-extrusion":
                                        !function(t1, e1, r, n) {
                                            const i = r.paint.get("fill-extrusion-opacity");
                                            if (0 !== i && "translucent" === t1.renderPass) {
                                                const a = new qr(t1.context.gl.LEQUAL, qr.ReadWrite, t1.depthRangeFor3D);
                                                if (1 !== i || r.paint.get("fill-extrusion-pattern").constantOr(1)) sn(t1, e1, r, n, a, Gr.disabled, Ur.disabled), sn(t1, e1, r, n, a, t1.stencilModeFor3D(), t1.colorModeForRenderPass());
                                                else {
                                                    const i = t1.colorModeForRenderPass();
                                                    sn(t1, e1, r, n, a, Gr.disabled, i);
                                                }
                                            }
                                        }(t1, r, n, i);
                                        break;
                                    case "hillshade":
                                        !function(t1, e1, r, n) {
                                            if ("offscreen" !== t1.renderPass && "translucent" !== t1.renderPass) return;
                                            const i = t1.context, a = t1.depthModeForSublayer(0, qr.ReadOnly), o = t1.colorModeForRenderPass(), [s, l] = "translucent" === t1.renderPass ? t1.stencilConfigForOverlap(n) : [
                                                {},
                                                n
                                            ];
                                            for (const n of l){
                                                const i = e1.getTile(n);
                                                void 0 !== i.needsHillshadePrepare && i.needsHillshadePrepare && "offscreen" === t1.renderPass ? cn(t1, i, r, a, Gr.disabled, o) : "translucent" === t1.renderPass && ln(t1, n, i, r, a, s[n.overscaledZ], o);
                                            }
                                            i.viewport.set([
                                                0,
                                                0,
                                                t1.width,
                                                t1.height
                                            ]);
                                        }(t1, r, n, i);
                                        break;
                                    case "raster":
                                        !function(t1, e1, r, n) {
                                            if ("translucent" !== t1.renderPass) return;
                                            if (0 === r.paint.get("raster-opacity")) return;
                                            if (!n.length) return;
                                            const i = t1.context, a = i.gl, o = e1.getSource(), s = t1.useProgram("raster"), l = t1.colorModeForRenderPass(), [c, u] = o instanceof rt ? [
                                                {},
                                                n
                                            ] : t1.stencilConfigForOverlap(n), h = u[u.length - 1].overscaledZ, f = !t1.options.moving;
                                            for (const n of u){
                                                const u = t1.depthModeForSublayer(n.overscaledZ - h, 1 === r.paint.get("raster-opacity") ? qr.ReadWrite : qr.ReadOnly, a.LESS), p = e1.getTile(n);
                                                p.registerFadeDuration(r.paint.get("raster-fade-duration"));
                                                const d = e1.findLoadedParent(n, 0), m = e1.findLoadedSibling(n), g = un(p, d || m || null, e1, r, t1.transform, t1.style.map.terrain);
                                                let y, v;
                                                const x = "nearest" === r.paint.get("raster-resampling") ? a.NEAREST : a.LINEAR;
                                                i.activeTexture.set(a.TEXTURE0), p.texture.bind(x, a.CLAMP_TO_EDGE, a.LINEAR_MIPMAP_NEAREST), i.activeTexture.set(a.TEXTURE1), d ? (d.texture.bind(x, a.CLAMP_TO_EDGE, a.LINEAR_MIPMAP_NEAREST), y = Math.pow(2, d.tileID.overscaledZ - p.tileID.overscaledZ), v = [
                                                    p.tileID.canonical.x * y % 1,
                                                    p.tileID.canonical.y * y % 1
                                                ]) : p.texture.bind(x, a.CLAMP_TO_EDGE, a.LINEAR_MIPMAP_NEAREST), p.texture.useMipmap && i.extTextureFilterAnisotropic && t1.transform.pitch > 20 && a.texParameterf(a.TEXTURE_2D, i.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, i.extTextureFilterAnisotropicMax);
                                                const _ = t1.style.map.terrain && t1.style.map.terrain.getTerrainData(n), b = _ ? n : null, w = b ? b.posMatrix : t1.transform.calculatePosMatrix(n.toUnwrapped(), f), T = Ge(w, v || [
                                                    0,
                                                    0
                                                ], y || 1, g, r);
                                                o instanceof rt ? s.draw(i, a.TRIANGLES, u, Gr.disabled, l, Zr.disabled, T, _, r.id, o.boundsBuffer, t1.quadTriangleIndexBuffer, o.boundsSegments) : s.draw(i, a.TRIANGLES, u, c[n.overscaledZ], l, Zr.disabled, T, _, r.id, t1.rasterBoundsBuffer, t1.quadTriangleIndexBuffer, t1.rasterBoundsSegments);
                                            }
                                        }(t1, r, n, i);
                                        break;
                                    case "background":
                                        !function(t1, e1, r, n) {
                                            const i = r.paint.get("background-color"), a = r.paint.get("background-opacity");
                                            if (0 === a) return;
                                            const o = t1.context, s = o.gl, l = t1.transform, c = l.tileSize, u = r.paint.get("background-pattern");
                                            if (t1.isPatternMissing(u)) return;
                                            const h = !u && 1 === i.a && 1 === a && t1.opaquePassEnabledForLayer() ? "opaque" : "translucent";
                                            if (t1.renderPass !== h) return;
                                            const f = Gr.disabled, p = t1.depthModeForSublayer(0, "opaque" === h ? qr.ReadWrite : qr.ReadOnly), d = t1.colorModeForRenderPass(), m = t1.useProgram(u ? "backgroundPattern" : "background"), g = n || l.coveringTiles({
                                                tileSize: c,
                                                terrain: t1.style.map.terrain
                                            });
                                            u && (o.activeTexture.set(s.TEXTURE0), t1.imageManager.bind(t1.context));
                                            const y = r.getCrossfadeParameters();
                                            for (const e1 of g){
                                                const l = n ? e1.posMatrix : t1.transform.calculatePosMatrix(e1.toUnwrapped()), h = u ? Je(l, a, t1, u, {
                                                    tileID: e1,
                                                    tileSize: c
                                                }, y) : $e(l, a, i), g = t1.style.map.terrain && t1.style.map.terrain.getTerrainData(e1);
                                                m.draw(o, s.TRIANGLES, p, f, d, Zr.disabled, h, g, r.id, t1.tileExtentBuffer, t1.quadTriangleIndexBuffer, t1.tileExtentSegments);
                                            }
                                        }(t1, 0, n, i);
                                        break;
                                    case "custom":
                                        !function(t1, e1, r) {
                                            const n = t1.context, i = r.implementation;
                                            if ("offscreen" === t1.renderPass) {
                                                const e1 = i.prerender;
                                                e1 && (t1.setCustomLayerDefaults(), n.setColorMode(t1.colorModeForRenderPass()), e1.call(i, n.gl, t1.transform.customLayerMatrix()), n.setDirty(), t1.setBaseState());
                                            } else if ("translucent" === t1.renderPass) {
                                                t1.setCustomLayerDefaults(), n.setColorMode(t1.colorModeForRenderPass()), n.setStencilMode(Gr.disabled);
                                                const e1 = "3d" === i.renderingMode ? new qr(t1.context.gl.LEQUAL, qr.ReadWrite, t1.depthRangeFor3D) : t1.depthModeForSublayer(0, qr.ReadOnly);
                                                n.setDepthMode(e1), i.render(n.gl, t1.transform.customLayerMatrix(), {
                                                    farZ: t1.transform.farZ,
                                                    nearZ: t1.transform.nearZ,
                                                    fov: t1.transform._fov,
                                                    modelViewProjectionMatrix: t1.transform.modelViewProjectionMatrix,
                                                    projectionMatrix: t1.transform.projectionMatrix
                                                }), n.setDirty(), t1.setBaseState(), n.bindFramebuffer.set(null);
                                            }
                                        }(t1, 0, n);
                                }
                            }
                            translatePosMatrix(t1, r, n, i, a) {
                                if (!n[0] && !n[1]) return t1;
                                const o = a ? "map" === i ? this.transform.angle : 0 : "viewport" === i ? -this.transform.angle : 0;
                                if (o) {
                                    const t1 = Math.sin(o), e1 = Math.cos(o);
                                    n = [
                                        n[0] * e1 - n[1] * t1,
                                        n[0] * t1 + n[1] * e1
                                    ];
                                }
                                const s = [
                                    a ? n[0] : Nt(r, n[0], this.transform.zoom),
                                    a ? n[1] : Nt(r, n[1], this.transform.zoom),
                                    0
                                ], l = new Float32Array(16);
                                return e1.J(l, t1, s), l;
                            }
                            saveTileTexture(t1) {
                                const e1 = this._tileTextures[t1.size[0]];
                                e1 ? e1.push(t1) : this._tileTextures[t1.size[0]] = [
                                    t1
                                ];
                            }
                            getTileTexture(t1) {
                                const e1 = this._tileTextures[t1];
                                return e1 && e1.length > 0 ? e1.pop() : null;
                            }
                            isPatternMissing(t1) {
                                if (!t1) return !1;
                                if (!t1.from || !t1.to) return !0;
                                const e1 = this.imageManager.getPattern(t1.from.toString()), r = this.imageManager.getPattern(t1.to.toString());
                                return !e1 || !r;
                            }
                            useProgram(t1, e1) {
                                this.cache = this.cache || {};
                                const r = t1 + (e1 ? e1.cacheKey : "") + (this._showOverdrawInspector ? "/overdraw" : "") + (this.style.map.terrain ? "/terrain" : "");
                                return this.cache[r] || (this.cache[r] = new be(this.context, ge[t1], e1, Ke[t1], this._showOverdrawInspector, this.style.map.terrain)), this.cache[r];
                            }
                            setCustomLayerDefaults() {
                                this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
                            }
                            setBaseState() {
                                const t1 = this.context.gl;
                                this.context.cullFace.set(!1), this.context.viewport.set([
                                    0,
                                    0,
                                    this.width,
                                    this.height
                                ]), this.context.blendEquation.set(t1.FUNC_ADD);
                            }
                            initDebugOverlayCanvas() {
                                if (null == this.debugOverlayCanvas) {
                                    this.debugOverlayCanvas = document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512;
                                    const t1 = this.context.gl;
                                    this.debugOverlayTexture = new w(this.context, this.debugOverlayCanvas, t1.RGBA);
                                }
                            }
                            destroy() {
                                this.debugOverlayTexture && this.debugOverlayTexture.destroy();
                            }
                            overLimit() {
                                const { drawingBufferWidth: t1, drawingBufferHeight: e1 } = this.context.gl;
                                return this.width !== t1 || this.height !== e1;
                            }
                        }
                        class kn {
                            constructor(t1, e1){
                                this.points = t1, this.planes = e1;
                            }
                            static fromInvProjectionMatrix(t1, r, n) {
                                const i = Math.pow(2, n), a = [
                                    [
                                        -1,
                                        1,
                                        -1,
                                        1
                                    ],
                                    [
                                        1,
                                        1,
                                        -1,
                                        1
                                    ],
                                    [
                                        1,
                                        -1,
                                        -1,
                                        1
                                    ],
                                    [
                                        -1,
                                        -1,
                                        -1,
                                        1
                                    ],
                                    [
                                        -1,
                                        1,
                                        1,
                                        1
                                    ],
                                    [
                                        1,
                                        1,
                                        1,
                                        1
                                    ],
                                    [
                                        1,
                                        -1,
                                        1,
                                        1
                                    ],
                                    [
                                        -1,
                                        -1,
                                        1,
                                        1
                                    ]
                                ].map((n)=>{
                                    const a = 1 / (n = e1.ag([], n, t1))[3] / r * i;
                                    return e1.b1(n, n, [
                                        a,
                                        a,
                                        1 / n[3],
                                        a
                                    ]);
                                }), o = [
                                    [
                                        0,
                                        1,
                                        2
                                    ],
                                    [
                                        6,
                                        5,
                                        4
                                    ],
                                    [
                                        0,
                                        3,
                                        7
                                    ],
                                    [
                                        2,
                                        1,
                                        5
                                    ],
                                    [
                                        3,
                                        2,
                                        6
                                    ],
                                    [
                                        0,
                                        4,
                                        5
                                    ]
                                ].map((t1)=>{
                                    const e1 = function(t1, e1) {
                                        var r = e1[0], n = e1[1], i = e1[2], a = r * r + n * n + i * i;
                                        return a > 0 && (a = 1 / Math.sqrt(a)), t1[0] = e1[0] * a, t1[1] = e1[1] * a, t1[2] = e1[2] * a, t1;
                                    }([], function(t1, e1, r) {
                                        var n = e1[0], i = e1[1], a = e1[2], o = r[0], s = r[1], l = r[2];
                                        return t1[0] = i * l - a * s, t1[1] = a * o - n * l, t1[2] = n * s - i * o, t1;
                                    }([], y([], a[t1[0]], a[t1[1]]), y([], a[t1[2]], a[t1[1]]))), r = (n = e1, i = a[t1[1]], -(n[0] * i[0] + n[1] * i[1] + n[2] * i[2]));
                                    var n, i;
                                    return e1.concat(r);
                                });
                                return new kn(a, o);
                            }
                        }
                        class An {
                            constructor(t1, e1){
                                this.min = t1, this.max = e1, this.center = function(t1, e1, r) {
                                    return t1[0] = e1[0] * r, t1[1] = e1[1] * r, t1[2] = e1[2] * r, t1;
                                }([], function(t1, e1, r) {
                                    return t1[0] = e1[0] + r[0], t1[1] = e1[1] + r[1], t1[2] = e1[2] + r[2], t1;
                                }([], this.min, this.max), .5);
                            }
                            quadrant(t1) {
                                const e1 = [
                                    t1 % 2 == 0,
                                    t1 < 2
                                ], r = m(this.min), n = m(this.max);
                                for(let t1 = 0; t1 < e1.length; t1++)r[t1] = e1[t1] ? this.min[t1] : this.center[t1], n[t1] = e1[t1] ? this.center[t1] : this.max[t1];
                                return n[2] = this.max[2], new An(r, n);
                            }
                            distanceX(t1) {
                                return Math.max(Math.min(this.max[0], t1[0]), this.min[0]) - t1[0];
                            }
                            distanceY(t1) {
                                return Math.max(Math.min(this.max[1], t1[1]), this.min[1]) - t1[1];
                            }
                            intersects(t1) {
                                const r = [
                                    [
                                        this.min[0],
                                        this.min[1],
                                        this.min[2],
                                        1
                                    ],
                                    [
                                        this.max[0],
                                        this.min[1],
                                        this.min[2],
                                        1
                                    ],
                                    [
                                        this.max[0],
                                        this.max[1],
                                        this.min[2],
                                        1
                                    ],
                                    [
                                        this.min[0],
                                        this.max[1],
                                        this.min[2],
                                        1
                                    ],
                                    [
                                        this.min[0],
                                        this.min[1],
                                        this.max[2],
                                        1
                                    ],
                                    [
                                        this.max[0],
                                        this.min[1],
                                        this.max[2],
                                        1
                                    ],
                                    [
                                        this.max[0],
                                        this.max[1],
                                        this.max[2],
                                        1
                                    ],
                                    [
                                        this.min[0],
                                        this.max[1],
                                        this.max[2],
                                        1
                                    ]
                                ];
                                let n = !0;
                                for(let i = 0; i < t1.planes.length; i++){
                                    const a = t1.planes[i];
                                    let o = 0;
                                    for(let t1 = 0; t1 < r.length; t1++)e1.b2(a, r[t1]) >= 0 && o++;
                                    if (0 === o) return 0;
                                    o !== r.length && (n = !1);
                                }
                                if (n) return 2;
                                for(let e1 = 0; e1 < 3; e1++){
                                    let r = Number.MAX_VALUE, n = -Number.MAX_VALUE;
                                    for(let i = 0; i < t1.points.length; i++){
                                        const a = t1.points[i][e1] - this.min[e1];
                                        r = Math.min(r, a), n = Math.max(n, a);
                                    }
                                    if (n < 0 || r > this.max[e1] - this.min[e1]) return 0;
                                }
                                return 1;
                            }
                        }
                        class Mn {
                            constructor(t1 = 0, e1 = 0, r = 0, n = 0){
                                if (isNaN(t1) || t1 < 0 || isNaN(e1) || e1 < 0 || isNaN(r) || r < 0 || isNaN(n) || n < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
                                this.top = t1, this.bottom = e1, this.left = r, this.right = n;
                            }
                            interpolate(t1, r, n) {
                                return null != r.top && null != t1.top && (this.top = e1.z.number(t1.top, r.top, n)), null != r.bottom && null != t1.bottom && (this.bottom = e1.z.number(t1.bottom, r.bottom, n)), null != r.left && null != t1.left && (this.left = e1.z.number(t1.left, r.left, n)), null != r.right && null != t1.right && (this.right = e1.z.number(t1.right, r.right, n)), this;
                            }
                            getCenter(t1, r) {
                                const n = e1.ad((this.left + t1 - this.right) / 2, 0, t1), i = e1.ad((this.top + r - this.bottom) / 2, 0, r);
                                return new e1.P(n, i);
                            }
                            equals(t1) {
                                return this.top === t1.top && this.bottom === t1.bottom && this.left === t1.left && this.right === t1.right;
                            }
                            clone() {
                                return new Mn(this.top, this.bottom, this.left, this.right);
                            }
                            toJSON() {
                                return {
                                    top: this.top,
                                    bottom: this.bottom,
                                    left: this.left,
                                    right: this.right
                                };
                            }
                        }
                        const Sn = 85.051129;
                        class En {
                            constructor(t1, r, n, i, a){
                                this.tileSize = 512, this._renderWorldCopies = void 0 === a || !!a, this._minZoom = t1 || 0, this._maxZoom = r || 22, this._minPitch = null == n ? 0 : n, this._maxPitch = null == i ? 60 : i, this.setMaxBounds(), this.width = 0, this.height = 0, this._center = new e1.N(0, 0), this._elevation = 0, this.zoom = 0, this.angle = 0, this._fov = .6435011087932844, this._pitch = 0, this._unmodified = !0, this._edgeInsets = new Mn, this._posMatrixCache = {}, this._alignedPosMatrixCache = {}, this._fogMatrixCache = {}, this.minElevationForCurrentTile = 0;
                            }
                            clone() {
                                const t1 = new En(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies);
                                return t1.apply(this), t1;
                            }
                            apply(t1) {
                                this.tileSize = t1.tileSize, this.latRange = t1.latRange, this.width = t1.width, this.height = t1.height, this._center = t1._center, this._elevation = t1._elevation, this.minElevationForCurrentTile = t1.minElevationForCurrentTile, this.zoom = t1.zoom, this.angle = t1.angle, this._fov = t1._fov, this._pitch = t1._pitch, this._unmodified = t1._unmodified, this._edgeInsets = t1._edgeInsets.clone(), this._calcMatrices();
                            }
                            get minZoom() {
                                return this._minZoom;
                            }
                            set minZoom(t1) {
                                this._minZoom !== t1 && (this._minZoom = t1, this.zoom = Math.max(this.zoom, t1));
                            }
                            get maxZoom() {
                                return this._maxZoom;
                            }
                            set maxZoom(t1) {
                                this._maxZoom !== t1 && (this._maxZoom = t1, this.zoom = Math.min(this.zoom, t1));
                            }
                            get minPitch() {
                                return this._minPitch;
                            }
                            set minPitch(t1) {
                                this._minPitch !== t1 && (this._minPitch = t1, this.pitch = Math.max(this.pitch, t1));
                            }
                            get maxPitch() {
                                return this._maxPitch;
                            }
                            set maxPitch(t1) {
                                this._maxPitch !== t1 && (this._maxPitch = t1, this.pitch = Math.min(this.pitch, t1));
                            }
                            get renderWorldCopies() {
                                return this._renderWorldCopies;
                            }
                            set renderWorldCopies(t1) {
                                void 0 === t1 ? t1 = !0 : null === t1 && (t1 = !1), this._renderWorldCopies = t1;
                            }
                            get worldSize() {
                                return this.tileSize * this.scale;
                            }
                            get centerOffset() {
                                return this.centerPoint._sub(this.size._div(2));
                            }
                            get size() {
                                return new e1.P(this.width, this.height);
                            }
                            get bearing() {
                                return -this.angle / Math.PI * 180;
                            }
                            set bearing(t1) {
                                const r = -e1.b3(t1, -180, 180) * Math.PI / 180;
                                this.angle !== r && (this._unmodified = !1, this.angle = r, this._calcMatrices(), this.rotationMatrix = function() {
                                    var t1 = new e1.A(4);
                                    return e1.A != Float32Array && (t1[1] = 0, t1[2] = 0), t1[0] = 1, t1[3] = 1, t1;
                                }(), function(t1, e1, r) {
                                    var n = e1[0], i = e1[1], a = e1[2], o = e1[3], s = Math.sin(r), l = Math.cos(r);
                                    t1[0] = n * l + a * s, t1[1] = i * l + o * s, t1[2] = n * -s + a * l, t1[3] = i * -s + o * l;
                                }(this.rotationMatrix, this.rotationMatrix, this.angle));
                            }
                            get pitch() {
                                return this._pitch / Math.PI * 180;
                            }
                            set pitch(t1) {
                                const r = e1.ad(t1, this.minPitch, this.maxPitch) / 180 * Math.PI;
                                this._pitch !== r && (this._unmodified = !1, this._pitch = r, this._calcMatrices());
                            }
                            get fov() {
                                return this._fov / Math.PI * 180;
                            }
                            set fov(t1) {
                                t1 = Math.max(.01, Math.min(60, t1)), this._fov !== t1 && (this._unmodified = !1, this._fov = t1 / 180 * Math.PI, this._calcMatrices());
                            }
                            get zoom() {
                                return this._zoom;
                            }
                            set zoom(t1) {
                                const e1 = Math.min(Math.max(t1, this.minZoom), this.maxZoom);
                                this._zoom !== e1 && (this._unmodified = !1, this._zoom = e1, this.tileZoom = Math.max(0, Math.floor(e1)), this.scale = this.zoomScale(e1), this._constrain(), this._calcMatrices());
                            }
                            get center() {
                                return this._center;
                            }
                            set center(t1) {
                                t1.lat === this._center.lat && t1.lng === this._center.lng || (this._unmodified = !1, this._center = t1, this._constrain(), this._calcMatrices());
                            }
                            get elevation() {
                                return this._elevation;
                            }
                            set elevation(t1) {
                                t1 !== this._elevation && (this._elevation = t1, this._constrain(), this._calcMatrices());
                            }
                            get padding() {
                                return this._edgeInsets.toJSON();
                            }
                            set padding(t1) {
                                this._edgeInsets.equals(t1) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, t1, 1), this._calcMatrices());
                            }
                            get centerPoint() {
                                return this._edgeInsets.getCenter(this.width, this.height);
                            }
                            isPaddingEqual(t1) {
                                return this._edgeInsets.equals(t1);
                            }
                            interpolatePadding(t1, e1, r) {
                                this._unmodified = !1, this._edgeInsets.interpolate(t1, e1, r), this._constrain(), this._calcMatrices();
                            }
                            coveringZoomLevel(t1) {
                                const e1 = (t1.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / t1.tileSize));
                                return Math.max(0, e1);
                            }
                            getVisibleUnwrappedCoordinates(t1) {
                                const r = [
                                    new e1.b4(0, t1)
                                ];
                                if (this._renderWorldCopies) {
                                    const n = this.pointCoordinate(new e1.P(0, 0)), i = this.pointCoordinate(new e1.P(this.width, 0)), a = this.pointCoordinate(new e1.P(this.width, this.height)), o = this.pointCoordinate(new e1.P(0, this.height)), s = Math.floor(Math.min(n.x, i.x, a.x, o.x)), l = Math.floor(Math.max(n.x, i.x, a.x, o.x)), c = 1;
                                    for(let n = s - c; n <= l + c; n++)0 !== n && r.push(new e1.b4(n, t1));
                                }
                                return r;
                            }
                            coveringTiles(t1) {
                                var r, n;
                                let i = this.coveringZoomLevel(t1);
                                const a = i;
                                if (void 0 !== t1.minzoom && i < t1.minzoom) return [];
                                void 0 !== t1.maxzoom && i > t1.maxzoom && (i = t1.maxzoom);
                                const o = this.pointCoordinate(this.getCameraPoint()), s = e1.Z.fromLngLat(this.center), l = Math.pow(2, i), c = [
                                    l * o.x,
                                    l * o.y,
                                    0
                                ], u = [
                                    l * s.x,
                                    l * s.y,
                                    0
                                ], h = kn.fromInvProjectionMatrix(this.invModelViewProjectionMatrix, this.worldSize, i);
                                let f = t1.minzoom || 0;
                                !t1.terrain && this.pitch <= 60 && this._edgeInsets.top < .1 && (f = i);
                                const p = t1.terrain ? 2 / Math.min(this.tileSize, t1.tileSize) * this.tileSize : 3, d = (t1)=>({
                                        aabb: new An([
                                            t1 * l,
                                            0,
                                            0
                                        ], [
                                            (t1 + 1) * l,
                                            l,
                                            0
                                        ]),
                                        zoom: 0,
                                        x: 0,
                                        y: 0,
                                        wrap: t1,
                                        fullyVisible: !1
                                    }), m = [], g = [], y = i, x = t1.reparseOverscaled ? a : i;
                                if (this._renderWorldCopies) for(let t1 = 1; t1 <= 3; t1++)m.push(d(-t1)), m.push(d(t1));
                                for(m.push(d(0)); m.length > 0;){
                                    const i = m.pop(), a = i.x, o = i.y;
                                    let s = i.fullyVisible;
                                    if (!s) {
                                        const t1 = i.aabb.intersects(h);
                                        if (0 === t1) continue;
                                        s = 2 === t1;
                                    }
                                    const l = t1.terrain ? c : u, d = i.aabb.distanceX(l), _ = i.aabb.distanceY(l), b = Math.max(Math.abs(d), Math.abs(_)), w = p + (1 << y - i.zoom) - 2;
                                    if (i.zoom === y || b > w && i.zoom >= f) {
                                        const t1 = y - i.zoom, r = c[0] - .5 - (a << t1), n = c[1] - .5 - (o << t1);
                                        g.push({
                                            tileID: new e1.S(i.zoom === y ? x : i.zoom, i.wrap, i.zoom, a, o),
                                            distanceSq: v([
                                                u[0] - .5 - a,
                                                u[1] - .5 - o
                                            ]),
                                            tileDistanceToCamera: Math.sqrt(r * r + n * n)
                                        });
                                    } else for(let l = 0; l < 4; l++){
                                        const c = (a << 1) + l % 2, u = (o << 1) + (l >> 1), h = i.zoom + 1;
                                        let f = i.aabb.quadrant(l);
                                        if (t1.terrain) {
                                            const a = new e1.S(h, i.wrap, h, c, u), o = t1.terrain.getMinMaxElevation(a), s = null !== (r = o.minElevation) && void 0 !== r ? r : this.elevation, l = null !== (n = o.maxElevation) && void 0 !== n ? n : this.elevation;
                                            f = new An([
                                                f.min[0],
                                                f.min[1],
                                                s
                                            ], [
                                                f.max[0],
                                                f.max[1],
                                                l
                                            ]);
                                        }
                                        m.push({
                                            aabb: f,
                                            zoom: h,
                                            x: c,
                                            y: u,
                                            wrap: i.wrap,
                                            fullyVisible: s
                                        });
                                    }
                                }
                                return g.sort((t1, e1)=>t1.distanceSq - e1.distanceSq).map((t1)=>t1.tileID);
                            }
                            resize(t1, e1) {
                                this.width = t1, this.height = e1, this.pixelsToGLUnits = [
                                    2 / t1,
                                    -2 / e1
                                ], this._constrain(), this._calcMatrices();
                            }
                            get unmodified() {
                                return this._unmodified;
                            }
                            zoomScale(t1) {
                                return Math.pow(2, t1);
                            }
                            scaleZoom(t1) {
                                return Math.log(t1) / Math.LN2;
                            }
                            project(t1) {
                                const r = e1.ad(t1.lat, -85.051129, Sn);
                                return new e1.P(e1.O(t1.lng) * this.worldSize, e1.Q(r) * this.worldSize);
                            }
                            unproject(t1) {
                                return new e1.Z(t1.x / this.worldSize, t1.y / this.worldSize).toLngLat();
                            }
                            get point() {
                                return this.project(this.center);
                            }
                            getCameraPosition() {
                                return {
                                    lngLat: this.pointLocation(this.getCameraPoint()),
                                    altitude: Math.cos(this._pitch) * this.cameraToCenterDistance / this._pixelPerMeter + this.elevation
                                };
                            }
                            recalculateZoom(t1) {
                                const r = this.elevation, n = Math.cos(this._pitch) * this.cameraToCenterDistance / this._pixelPerMeter, i = this.pointLocation(this.centerPoint, t1), a = t1.getElevationForLngLatZoom(i, this.tileZoom);
                                if (!(this.elevation - a)) return;
                                const o = n + r - a, s = Math.cos(this._pitch) * this.cameraToCenterDistance / o / e1.b5(1, i.lat) / this.tileSize, l = this.scaleZoom(s);
                                this._elevation = a, this._center = i, this.zoom = l;
                            }
                            setLocationAtPoint(t1, r) {
                                const n = this.pointCoordinate(r), i = this.pointCoordinate(this.centerPoint), a = this.locationCoordinate(t1), o = new e1.Z(a.x - (n.x - i.x), a.y - (n.y - i.y));
                                this.center = this.coordinateLocation(o), this._renderWorldCopies && (this.center = this.center.wrap());
                            }
                            locationPoint(t1, e1) {
                                return e1 ? this.coordinatePoint(this.locationCoordinate(t1), e1.getElevationForLngLatZoom(t1, this.tileZoom), this.pixelMatrix3D) : this.coordinatePoint(this.locationCoordinate(t1));
                            }
                            pointLocation(t1, e1) {
                                return this.coordinateLocation(this.pointCoordinate(t1, e1));
                            }
                            locationCoordinate(t1) {
                                return e1.Z.fromLngLat(t1);
                            }
                            coordinateLocation(t1) {
                                return t1 && t1.toLngLat();
                            }
                            pointCoordinate(t1, r) {
                                if (r) {
                                    const e1 = r.pointCoordinate(t1);
                                    if (null != e1) return e1;
                                }
                                const n = [
                                    t1.x,
                                    t1.y,
                                    0,
                                    1
                                ], i = [
                                    t1.x,
                                    t1.y,
                                    1,
                                    1
                                ];
                                e1.ag(n, n, this.pixelMatrixInverse), e1.ag(i, i, this.pixelMatrixInverse);
                                const a = n[3], o = i[3], s = n[0] / a, l = i[0] / o, c = n[1] / a, u = i[1] / o, h = n[2] / a, f = i[2] / o, p = h === f ? 0 : (0 - h) / (f - h);
                                return new e1.Z(e1.z.number(s, l, p) / this.worldSize, e1.z.number(c, u, p) / this.worldSize);
                            }
                            coordinatePoint(t1, r = 0, n = this.pixelMatrix) {
                                const i = [
                                    t1.x * this.worldSize,
                                    t1.y * this.worldSize,
                                    r,
                                    1
                                ];
                                return e1.ag(i, i, n), new e1.P(i[0] / i[3], i[1] / i[3]);
                            }
                            getBounds() {
                                const t1 = Math.max(0, this.height / 2 - this.getHorizon());
                                return (new X).extend(this.pointLocation(new e1.P(0, t1))).extend(this.pointLocation(new e1.P(this.width, t1))).extend(this.pointLocation(new e1.P(this.width, this.height))).extend(this.pointLocation(new e1.P(0, this.height)));
                            }
                            getMaxBounds() {
                                return this.latRange && 2 === this.latRange.length && this.lngRange && 2 === this.lngRange.length ? new X([
                                    this.lngRange[0],
                                    this.latRange[0]
                                ], [
                                    this.lngRange[1],
                                    this.latRange[1]
                                ]) : null;
                            }
                            getHorizon() {
                                return Math.tan(Math.PI / 2 - this._pitch) * this.cameraToCenterDistance * .85;
                            }
                            setMaxBounds(t1) {
                                t1 ? (this.lngRange = [
                                    t1.getWest(),
                                    t1.getEast()
                                ], this.latRange = [
                                    t1.getSouth(),
                                    t1.getNorth()
                                ], this._constrain()) : (this.lngRange = null, this.latRange = [
                                    -85.051129,
                                    Sn
                                ]);
                            }
                            calculateTileMatrix(t1) {
                                const r = t1.canonical, n = this.worldSize / this.zoomScale(r.z), i = r.x + Math.pow(2, r.z) * t1.wrap, a = e1.ao(new Float64Array(16));
                                return e1.J(a, a, [
                                    i * n,
                                    r.y * n,
                                    0
                                ]), e1.K(a, a, [
                                    n / e1.X,
                                    n / e1.X,
                                    1
                                ]), a;
                            }
                            calculatePosMatrix(t1, r = !1) {
                                const n = t1.key, i = r ? this._alignedPosMatrixCache : this._posMatrixCache;
                                if (i[n]) return i[n];
                                const a = this.calculateTileMatrix(t1);
                                return e1.L(a, r ? this.alignedModelViewProjectionMatrix : this.modelViewProjectionMatrix, a), i[n] = new Float32Array(a), i[n];
                            }
                            calculateFogMatrix(t1) {
                                const r = t1.key, n = this._fogMatrixCache;
                                if (n[r]) return n[r];
                                const i = this.calculateTileMatrix(t1);
                                return e1.L(i, this.fogMatrix, i), n[r] = new Float32Array(i), n[r];
                            }
                            customLayerMatrix() {
                                return this.mercatorMatrix.slice();
                            }
                            getConstrained(t1, r) {
                                r = e1.ad(+r, this.minZoom, this.maxZoom);
                                const n = {
                                    center: new e1.N(t1.lng, t1.lat),
                                    zoom: r
                                };
                                let i = this.lngRange;
                                if (!this._renderWorldCopies && null === i) {
                                    const t1 = 180 - 1e-10;
                                    i = [
                                        -t1,
                                        t1
                                    ];
                                }
                                const a = this.tileSize * this.zoomScale(n.zoom);
                                let o = 0, s = a, l = 0, c = a, u = 0, h = 0;
                                const { x: f, y: p } = this.size;
                                if (this.latRange) {
                                    const t1 = this.latRange;
                                    o = e1.Q(t1[1]) * a, s = e1.Q(t1[0]) * a, s - o < p && (u = p / (s - o));
                                }
                                i && (l = e1.b3(e1.O(i[0]) * a, 0, a), c = e1.b3(e1.O(i[1]) * a, 0, a), c < l && (c += a), c - l < f && (h = f / (c - l)));
                                const { x: d, y: m } = this.project.call({
                                    worldSize: a
                                }, t1);
                                let g, y;
                                const v = Math.max(h || 0, u || 0);
                                if (v) {
                                    const t1 = new e1.P(h ? (c + l) / 2 : d, u ? (s + o) / 2 : m);
                                    return n.center = this.unproject.call({
                                        worldSize: a
                                    }, t1).wrap(), n.zoom += this.scaleZoom(v), n;
                                }
                                if (this.latRange) {
                                    const t1 = p / 2;
                                    m - t1 < o && (y = o + t1), m + t1 > s && (y = s - t1);
                                }
                                if (i) {
                                    const t1 = (l + c) / 2;
                                    let r = d;
                                    this._renderWorldCopies && (r = e1.b3(d, t1 - a / 2, t1 + a / 2));
                                    const n = f / 2;
                                    r - n < l && (g = l + n), r + n > c && (g = c - n);
                                }
                                if (void 0 !== g || void 0 !== y) {
                                    const t1 = new e1.P(null != g ? g : d, null != y ? y : m);
                                    n.center = this.unproject.call({
                                        worldSize: a
                                    }, t1).wrap();
                                }
                                return n;
                            }
                            _constrain() {
                                if (!this.center || !this.width || !this.height || this._constraining) return;
                                this._constraining = !0;
                                const t1 = this._unmodified, { center: e1, zoom: r } = this.getConstrained(this.center, this.zoom);
                                this.center = e1, this.zoom = r, this._unmodified = t1, this._constraining = !1;
                            }
                            _calcMatrices() {
                                if (!this.height) return;
                                const t1 = this._fov / 2, r = this.centerOffset, n = this.point.x, i = this.point.y;
                                this.cameraToCenterDistance = .5 / Math.tan(t1) * this.height, this._pixelPerMeter = e1.b5(1, this.center.lat) * this.worldSize;
                                let a = e1.ao(new Float64Array(16));
                                e1.K(a, a, [
                                    this.width / 2,
                                    -this.height / 2,
                                    1
                                ]), e1.J(a, a, [
                                    1,
                                    -1,
                                    0
                                ]), this.labelPlaneMatrix = a, a = e1.ao(new Float64Array(16)), e1.K(a, a, [
                                    1,
                                    -1,
                                    1
                                ]), e1.J(a, a, [
                                    -1,
                                    -1,
                                    0
                                ]), e1.K(a, a, [
                                    2 / this.width,
                                    2 / this.height,
                                    1
                                ]), this.glCoordMatrix = a;
                                const o = this.cameraToCenterDistance + this._elevation * this._pixelPerMeter / Math.cos(this._pitch), s = Math.min(this.elevation, this.minElevationForCurrentTile), l = o - s * this._pixelPerMeter / Math.cos(this._pitch), c = s < 0 ? l : o, u = Math.PI / 2 + this._pitch, h = this._fov * (.5 + r.y / this.height), f = Math.sin(h) * c / Math.sin(e1.ad(Math.PI - u - h, .01, Math.PI - .01)), p = this.getHorizon(), d = 2 * Math.atan(p / this.cameraToCenterDistance) * (.5 + r.y / (2 * p)), m = Math.sin(d) * c / Math.sin(e1.ad(Math.PI - u - d, .01, Math.PI - .01)), g = Math.min(f, m);
                                this.farZ = 1.01 * (Math.cos(Math.PI / 2 - this._pitch) * g + c), this.nearZ = this.height / 50, a = new Float64Array(16), e1.b6(a, this._fov, this.width / this.height, this.nearZ, this.farZ), a[8] = 2 * -r.x / this.width, a[9] = 2 * r.y / this.height, this.projectionMatrix = e1.af(a), e1.K(a, a, [
                                    1,
                                    -1,
                                    1
                                ]), e1.J(a, a, [
                                    0,
                                    0,
                                    -this.cameraToCenterDistance
                                ]), e1.b7(a, a, this._pitch), e1.ae(a, a, this.angle), e1.J(a, a, [
                                    -n,
                                    -i,
                                    0
                                ]), this.mercatorMatrix = e1.K([], a, [
                                    this.worldSize,
                                    this.worldSize,
                                    this.worldSize
                                ]), e1.K(a, a, [
                                    1,
                                    1,
                                    this._pixelPerMeter
                                ]), this.pixelMatrix = e1.L(new Float64Array(16), this.labelPlaneMatrix, a), e1.J(a, a, [
                                    0,
                                    0,
                                    -this.elevation
                                ]), this.modelViewProjectionMatrix = a, this.invModelViewProjectionMatrix = e1.at([], a), this.fogMatrix = new Float64Array(16), e1.b6(this.fogMatrix, this._fov, this.width / this.height, o, this.farZ), this.fogMatrix[8] = 2 * -r.x / this.width, this.fogMatrix[9] = 2 * r.y / this.height, e1.K(this.fogMatrix, this.fogMatrix, [
                                    1,
                                    -1,
                                    1
                                ]), e1.J(this.fogMatrix, this.fogMatrix, [
                                    0,
                                    0,
                                    -this.cameraToCenterDistance
                                ]), e1.b7(this.fogMatrix, this.fogMatrix, this._pitch), e1.ae(this.fogMatrix, this.fogMatrix, this.angle), e1.J(this.fogMatrix, this.fogMatrix, [
                                    -n,
                                    -i,
                                    0
                                ]), e1.K(this.fogMatrix, this.fogMatrix, [
                                    1,
                                    1,
                                    this._pixelPerMeter
                                ]), e1.J(this.fogMatrix, this.fogMatrix, [
                                    0,
                                    0,
                                    -this.elevation
                                ]), this.pixelMatrix3D = e1.L(new Float64Array(16), this.labelPlaneMatrix, a);
                                const y = this.width % 2 / 2, v = this.height % 2 / 2, x = Math.cos(this.angle), _ = Math.sin(this.angle), b = n - Math.round(n) + x * y + _ * v, w = i - Math.round(i) + x * v + _ * y, T = new Float64Array(a);
                                if (e1.J(T, T, [
                                    b > .5 ? b - 1 : b,
                                    w > .5 ? w - 1 : w,
                                    0
                                ]), this.alignedModelViewProjectionMatrix = T, a = e1.at(new Float64Array(16), this.pixelMatrix), !a) throw new Error("failed to invert matrix");
                                this.pixelMatrixInverse = a, this._posMatrixCache = {}, this._alignedPosMatrixCache = {}, this._fogMatrixCache = {};
                            }
                            maxPitchScaleFactor() {
                                if (!this.pixelMatrixInverse) return 1;
                                const t1 = this.pointCoordinate(new e1.P(0, 0)), r = [
                                    t1.x * this.worldSize,
                                    t1.y * this.worldSize,
                                    0,
                                    1
                                ];
                                return e1.ag(r, r, this.pixelMatrix)[3] / this.cameraToCenterDistance;
                            }
                            getCameraPoint() {
                                const t1 = this._pitch, r = Math.tan(t1) * (this.cameraToCenterDistance || 1);
                                return this.centerPoint.add(new e1.P(0, r));
                            }
                            getCameraQueryGeometry(t1) {
                                const r = this.getCameraPoint();
                                if (1 === t1.length) return [
                                    t1[0],
                                    r
                                ];
                                {
                                    let n = r.x, i = r.y, a = r.x, o = r.y;
                                    for (const e1 of t1)n = Math.min(n, e1.x), i = Math.min(i, e1.y), a = Math.max(a, e1.x), o = Math.max(o, e1.y);
                                    return [
                                        new e1.P(n, i),
                                        new e1.P(a, i),
                                        new e1.P(a, o),
                                        new e1.P(n, o),
                                        new e1.P(n, i)
                                    ];
                                }
                            }
                            lngLatToCameraDepth(t1, r) {
                                const n = this.locationCoordinate(t1), i = [
                                    n.x * this.worldSize,
                                    n.y * this.worldSize,
                                    r,
                                    1
                                ];
                                return e1.ag(i, i, this.modelViewProjectionMatrix), i[2] / i[3];
                            }
                        }
                        function Cn(t1, e1) {
                            let r, n = !1, i = null, a = null;
                            const o = ()=>{
                                i = null, n && (t1.apply(a, r), i = setTimeout(o, e1), n = !1);
                            };
                            return (...t1)=>(n = !0, a = this, r = t1, i || o(), i);
                        }
                        class Ln {
                            constructor(t1){
                                this._getCurrentHash = ()=>{
                                    const t1 = window.location.hash.replace("#", "");
                                    if (this._hashName) {
                                        let e1;
                                        return t1.split("&").map((t1)=>t1.split("=")).forEach((t1)=>{
                                            t1[0] === this._hashName && (e1 = t1);
                                        }), (e1 && e1[1] || "").split("/");
                                    }
                                    return t1.split("/");
                                }, this._onHashChange = ()=>{
                                    const t1 = this._getCurrentHash();
                                    if (t1.length >= 3 && !t1.some((t1)=>isNaN(t1))) {
                                        const e1 = this._map.dragRotate.isEnabled() && this._map.touchZoomRotate.isEnabled() ? +(t1[3] || 0) : this._map.getBearing();
                                        return this._map.jumpTo({
                                            center: [
                                                +t1[2],
                                                +t1[1]
                                            ],
                                            zoom: +t1[0],
                                            bearing: e1,
                                            pitch: +(t1[4] || 0)
                                        }), !0;
                                    }
                                    return !1;
                                }, this._updateHashUnthrottled = ()=>{
                                    const t1 = window.location.href.replace(/(#.+)?$/, this.getHashString());
                                    window.history.replaceState(window.history.state, null, t1);
                                }, this._removeHash = ()=>{
                                    const t1 = this._getCurrentHash();
                                    if (0 === t1.length) return;
                                    const e1 = t1.join("/");
                                    let r = e1;
                                    r.split("&").length > 0 && (r = r.split("&")[0]), this._hashName && (r = `${this._hashName}=${e1}`);
                                    let n = window.location.hash.replace(r, "");
                                    n.startsWith("#&") ? n = n.slice(0, 1) + n.slice(2) : "#" === n && (n = "");
                                    let i = window.location.href.replace(/(#.+)?$/, n);
                                    i = i.replace("&&", "&"), window.history.replaceState(window.history.state, null, i);
                                }, this._updateHash = Cn(this._updateHashUnthrottled, 300), this._hashName = t1 && encodeURIComponent(t1);
                            }
                            addTo(t1) {
                                return this._map = t1, addEventListener("hashchange", this._onHashChange, !1), this._map.on("moveend", this._updateHash), this;
                            }
                            remove() {
                                return removeEventListener("hashchange", this._onHashChange, !1), this._map.off("moveend", this._updateHash), clearTimeout(this._updateHash()), this._removeHash(), delete this._map, this;
                            }
                            getHashString(t1) {
                                const e1 = this._map.getCenter(), r = Math.round(100 * this._map.getZoom()) / 100, n = Math.ceil((r * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), i = Math.pow(10, n), a = Math.round(e1.lng * i) / i, o = Math.round(e1.lat * i) / i, s = this._map.getBearing(), l = this._map.getPitch();
                                let c = "";
                                if (c += t1 ? `/${a}/${o}/${r}` : `${r}/${o}/${a}`, (s || l) && (c += "/" + Math.round(10 * s) / 10), l && (c += `/${Math.round(l)}`), this._hashName) {
                                    const t1 = this._hashName;
                                    let e1 = !1;
                                    const r = window.location.hash.slice(1).split("&").map((r)=>{
                                        const n = r.split("=")[0];
                                        return n === t1 ? (e1 = !0, `${n}=${c}`) : r;
                                    }).filter((t1)=>t1);
                                    return e1 || r.push(`${t1}=${c}`), `#${r.join("&")}`;
                                }
                                return `#${c}`;
                            }
                        }
                        const In = {
                            linearity: .3,
                            easing: e1.b8(0, 0, .3, 1)
                        }, Pn = e1.e({
                            deceleration: 2500,
                            maxSpeed: 1400
                        }, In), zn = e1.e({
                            deceleration: 20,
                            maxSpeed: 1400
                        }, In), On = e1.e({
                            deceleration: 1e3,
                            maxSpeed: 360
                        }, In), Dn = e1.e({
                            deceleration: 1e3,
                            maxSpeed: 90
                        }, In);
                        class Rn {
                            constructor(t1){
                                this._map = t1, this.clear();
                            }
                            clear() {
                                this._inertiaBuffer = [];
                            }
                            record(t1) {
                                this._drainInertiaBuffer(), this._inertiaBuffer.push({
                                    time: a.now(),
                                    settings: t1
                                });
                            }
                            _drainInertiaBuffer() {
                                const t1 = this._inertiaBuffer, e1 = a.now();
                                for(; t1.length > 0 && e1 - t1[0].time > 160;)t1.shift();
                            }
                            _onMoveEnd(t1) {
                                if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2) return;
                                const r = {
                                    zoom: 0,
                                    bearing: 0,
                                    pitch: 0,
                                    pan: new e1.P(0, 0),
                                    pinchAround: void 0,
                                    around: void 0
                                };
                                for (const { settings: t1 } of this._inertiaBuffer)r.zoom += t1.zoomDelta || 0, r.bearing += t1.bearingDelta || 0, r.pitch += t1.pitchDelta || 0, t1.panDelta && r.pan._add(t1.panDelta), t1.around && (r.around = t1.around), t1.pinchAround && (r.pinchAround = t1.pinchAround);
                                const n = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, i = {};
                                if (r.pan.mag()) {
                                    const a = Bn(r.pan.mag(), n, e1.e({}, Pn, t1 || {}));
                                    i.offset = r.pan.mult(a.amount / r.pan.mag()), i.center = this._map.transform.center, Fn(i, a);
                                }
                                if (r.zoom) {
                                    const t1 = Bn(r.zoom, n, zn);
                                    i.zoom = this._map.transform.zoom + t1.amount, Fn(i, t1);
                                }
                                if (r.bearing) {
                                    const t1 = Bn(r.bearing, n, On);
                                    i.bearing = this._map.transform.bearing + e1.ad(t1.amount, -179, 179), Fn(i, t1);
                                }
                                if (r.pitch) {
                                    const t1 = Bn(r.pitch, n, Dn);
                                    i.pitch = this._map.transform.pitch + t1.amount, Fn(i, t1);
                                }
                                if (i.zoom || i.bearing) {
                                    const t1 = void 0 === r.pinchAround ? r.around : r.pinchAround;
                                    i.around = t1 ? this._map.unproject(t1) : this._map.getCenter();
                                }
                                return this.clear(), e1.e(i, {
                                    noMoveStart: !0
                                });
                            }
                        }
                        function Fn(t1, e1) {
                            (!t1.duration || t1.duration < e1.duration) && (t1.duration = e1.duration, t1.easing = e1.easing);
                        }
                        function Bn(t1, r, n) {
                            const { maxSpeed: i, linearity: a, deceleration: o } = n, s = e1.ad(t1 * a / (r / 1e3), -i, i), l = Math.abs(s) / (o * a);
                            return {
                                easing: n.easing,
                                duration: 1e3 * l,
                                amount: s * (l / 2)
                            };
                        }
                        class Nn extends e1.k {
                            preventDefault() {
                                this._defaultPrevented = !0;
                            }
                            get defaultPrevented() {
                                return this._defaultPrevented;
                            }
                            constructor(t1, r, n, i = {}){
                                const a = o.mousePos(r.getCanvas(), n), s = r.unproject(a);
                                super(t1, e1.e({
                                    point: a,
                                    lngLat: s,
                                    originalEvent: n
                                }, i)), this._defaultPrevented = !1, this.target = r;
                            }
                        }
                        class jn extends e1.k {
                            preventDefault() {
                                this._defaultPrevented = !0;
                            }
                            get defaultPrevented() {
                                return this._defaultPrevented;
                            }
                            constructor(t1, r, n){
                                const i = "touchend" === t1 ? n.changedTouches : n.touches, a = o.touchPos(r.getCanvasContainer(), i), s = a.map((t1)=>r.unproject(t1)), l = a.reduce((t1, e1, r, n)=>t1.add(e1.div(n.length)), new e1.P(0, 0));
                                super(t1, {
                                    points: a,
                                    point: l,
                                    lngLats: s,
                                    lngLat: r.unproject(l),
                                    originalEvent: n
                                }), this._defaultPrevented = !1;
                            }
                        }
                        class Un extends e1.k {
                            preventDefault() {
                                this._defaultPrevented = !0;
                            }
                            get defaultPrevented() {
                                return this._defaultPrevented;
                            }
                            constructor(t1, e1, r){
                                super(t1, {
                                    originalEvent: r
                                }), this._defaultPrevented = !1;
                            }
                        }
                        class Vn {
                            constructor(t1, e1){
                                this._map = t1, this._clickTolerance = e1.clickTolerance;
                            }
                            reset() {
                                delete this._mousedownPos;
                            }
                            wheel(t1) {
                                return this._firePreventable(new Un(t1.type, this._map, t1));
                            }
                            mousedown(t1, e1) {
                                return this._mousedownPos = e1, this._firePreventable(new Nn(t1.type, this._map, t1));
                            }
                            mouseup(t1) {
                                this._map.fire(new Nn(t1.type, this._map, t1));
                            }
                            click(t1, e1) {
                                this._mousedownPos && this._mousedownPos.dist(e1) >= this._clickTolerance || this._map.fire(new Nn(t1.type, this._map, t1));
                            }
                            dblclick(t1) {
                                return this._firePreventable(new Nn(t1.type, this._map, t1));
                            }
                            mouseover(t1) {
                                this._map.fire(new Nn(t1.type, this._map, t1));
                            }
                            mouseout(t1) {
                                this._map.fire(new Nn(t1.type, this._map, t1));
                            }
                            touchstart(t1) {
                                return this._firePreventable(new jn(t1.type, this._map, t1));
                            }
                            touchmove(t1) {
                                this._map.fire(new jn(t1.type, this._map, t1));
                            }
                            touchend(t1) {
                                this._map.fire(new jn(t1.type, this._map, t1));
                            }
                            touchcancel(t1) {
                                this._map.fire(new jn(t1.type, this._map, t1));
                            }
                            _firePreventable(t1) {
                                if (this._map.fire(t1), t1.defaultPrevented) return {};
                            }
                            isEnabled() {
                                return !0;
                            }
                            isActive() {
                                return !1;
                            }
                            enable() {}
                            disable() {}
                        }
                        class qn {
                            constructor(t1){
                                this._map = t1;
                            }
                            reset() {
                                this._delayContextMenu = !1, this._ignoreContextMenu = !0, delete this._contextMenuEvent;
                            }
                            mousemove(t1) {
                                this._map.fire(new Nn(t1.type, this._map, t1));
                            }
                            mousedown() {
                                this._delayContextMenu = !0, this._ignoreContextMenu = !1;
                            }
                            mouseup() {
                                this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new Nn("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
                            }
                            contextmenu(t1) {
                                this._delayContextMenu ? this._contextMenuEvent = t1 : this._ignoreContextMenu || this._map.fire(new Nn(t1.type, this._map, t1)), this._map.listens("contextmenu") && t1.preventDefault();
                            }
                            isEnabled() {
                                return !0;
                            }
                            isActive() {
                                return !1;
                            }
                            enable() {}
                            disable() {}
                        }
                        class Hn {
                            constructor(t1){
                                this._map = t1;
                            }
                            get transform() {
                                return this._map._requestedCameraState || this._map.transform;
                            }
                            get center() {
                                return {
                                    lng: this.transform.center.lng,
                                    lat: this.transform.center.lat
                                };
                            }
                            get zoom() {
                                return this.transform.zoom;
                            }
                            get pitch() {
                                return this.transform.pitch;
                            }
                            get bearing() {
                                return this.transform.bearing;
                            }
                            unproject(t1) {
                                return this.transform.pointLocation(e1.P.convert(t1), this._map.terrain);
                            }
                        }
                        class Gn {
                            constructor(t1, e1){
                                this._map = t1, this._tr = new Hn(t1), this._el = t1.getCanvasContainer(), this._container = t1.getContainer(), this._clickTolerance = e1.clickTolerance || 1;
                            }
                            isEnabled() {
                                return !!this._enabled;
                            }
                            isActive() {
                                return !!this._active;
                            }
                            enable() {
                                this.isEnabled() || (this._enabled = !0);
                            }
                            disable() {
                                this.isEnabled() && (this._enabled = !1);
                            }
                            mousedown(t1, e1) {
                                this.isEnabled() && t1.shiftKey && 0 === t1.button && (o.disableDrag(), this._startPos = this._lastPos = e1, this._active = !0);
                            }
                            mousemoveWindow(t1, e1) {
                                if (!this._active) return;
                                const r = e1;
                                if (this._lastPos.equals(r) || !this._box && r.dist(this._startPos) < this._clickTolerance) return;
                                const n = this._startPos;
                                this._lastPos = r, this._box || (this._box = o.create("div", "maplibregl-boxzoom", this._container), this._container.classList.add("maplibregl-crosshair"), this._fireEvent("boxzoomstart", t1));
                                const i = Math.min(n.x, r.x), a = Math.max(n.x, r.x), s = Math.min(n.y, r.y), l = Math.max(n.y, r.y);
                                o.setTransform(this._box, `translate(${i}px,${s}px)`), this._box.style.width = a - i + "px", this._box.style.height = l - s + "px";
                            }
                            mouseupWindow(t1, r) {
                                if (!this._active) return;
                                if (0 !== t1.button) return;
                                const n = this._startPos, i = r;
                                if (this.reset(), o.suppressClick(), n.x !== i.x || n.y !== i.y) return this._map.fire(new e1.k("boxzoomend", {
                                    originalEvent: t1
                                })), {
                                    cameraAnimation: (t1)=>t1.fitScreenCoordinates(n, i, this._tr.bearing, {
                                            linear: !0
                                        })
                                };
                                this._fireEvent("boxzoomcancel", t1);
                            }
                            keydown(t1) {
                                this._active && 27 === t1.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", t1));
                            }
                            reset() {
                                this._active = !1, this._container.classList.remove("maplibregl-crosshair"), this._box && (o.remove(this._box), this._box = null), o.enableDrag(), delete this._startPos, delete this._lastPos;
                            }
                            _fireEvent(t1, r) {
                                return this._map.fire(new e1.k(t1, {
                                    originalEvent: r
                                }));
                            }
                        }
                        function Zn(t1, e1) {
                            if (t1.length !== e1.length) throw new Error(`The number of touches and points are not equal - touches ${t1.length}, points ${e1.length}`);
                            const r = {};
                            for(let n = 0; n < t1.length; n++)r[t1[n].identifier] = e1[n];
                            return r;
                        }
                        class Wn {
                            constructor(t1){
                                this.reset(), this.numTouches = t1.numTouches;
                            }
                            reset() {
                                delete this.centroid, delete this.startTime, delete this.touches, this.aborted = !1;
                            }
                            touchstart(t1, r, n) {
                                (this.centroid || n.length > this.numTouches) && (this.aborted = !0), this.aborted || (void 0 === this.startTime && (this.startTime = t1.timeStamp), n.length === this.numTouches && (this.centroid = function(t1) {
                                    const r = new e1.P(0, 0);
                                    for (const e1 of t1)r._add(e1);
                                    return r.div(t1.length);
                                }(r), this.touches = Zn(n, r)));
                            }
                            touchmove(t1, e1, r) {
                                if (this.aborted || !this.centroid) return;
                                const n = Zn(r, e1);
                                for(const t1 in this.touches){
                                    const e1 = this.touches[t1], r = n[t1];
                                    (!r || r.dist(e1) > 30) && (this.aborted = !0);
                                }
                            }
                            touchend(t1, e1, r) {
                                if ((!this.centroid || t1.timeStamp - this.startTime > 500) && (this.aborted = !0), 0 === r.length) {
                                    const t1 = !this.aborted && this.centroid;
                                    if (this.reset(), t1) return t1;
                                }
                            }
                        }
                        class Yn {
                            constructor(t1){
                                this.singleTap = new Wn(t1), this.numTaps = t1.numTaps, this.reset();
                            }
                            reset() {
                                this.lastTime = 1 / 0, delete this.lastTap, this.count = 0, this.singleTap.reset();
                            }
                            touchstart(t1, e1, r) {
                                this.singleTap.touchstart(t1, e1, r);
                            }
                            touchmove(t1, e1, r) {
                                this.singleTap.touchmove(t1, e1, r);
                            }
                            touchend(t1, e1, r) {
                                const n = this.singleTap.touchend(t1, e1, r);
                                if (n) {
                                    const e1 = t1.timeStamp - this.lastTime < 500, r = !this.lastTap || this.lastTap.dist(n) < 30;
                                    if (e1 && r || this.reset(), this.count++, this.lastTime = t1.timeStamp, this.lastTap = n, this.count === this.numTaps) return this.reset(), n;
                                }
                            }
                        }
                        class Xn {
                            constructor(t1){
                                this._tr = new Hn(t1), this._zoomIn = new Yn({
                                    numTouches: 1,
                                    numTaps: 2
                                }), this._zoomOut = new Yn({
                                    numTouches: 2,
                                    numTaps: 1
                                }), this.reset();
                            }
                            reset() {
                                this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
                            }
                            touchstart(t1, e1, r) {
                                this._zoomIn.touchstart(t1, e1, r), this._zoomOut.touchstart(t1, e1, r);
                            }
                            touchmove(t1, e1, r) {
                                this._zoomIn.touchmove(t1, e1, r), this._zoomOut.touchmove(t1, e1, r);
                            }
                            touchend(t1, e1, r) {
                                const n = this._zoomIn.touchend(t1, e1, r), i = this._zoomOut.touchend(t1, e1, r), a = this._tr;
                                return n ? (this._active = !0, t1.preventDefault(), setTimeout(()=>this.reset(), 0), {
                                    cameraAnimation: (e1)=>e1.easeTo({
                                            duration: 300,
                                            zoom: a.zoom + 1,
                                            around: a.unproject(n)
                                        }, {
                                            originalEvent: t1
                                        })
                                }) : i ? (this._active = !0, t1.preventDefault(), setTimeout(()=>this.reset(), 0), {
                                    cameraAnimation: (e1)=>e1.easeTo({
                                            duration: 300,
                                            zoom: a.zoom - 1,
                                            around: a.unproject(i)
                                        }, {
                                            originalEvent: t1
                                        })
                                }) : void 0;
                            }
                            touchcancel() {
                                this.reset();
                            }
                            enable() {
                                this._enabled = !0;
                            }
                            disable() {
                                this._enabled = !1, this.reset();
                            }
                            isEnabled() {
                                return this._enabled;
                            }
                            isActive() {
                                return this._active;
                            }
                        }
                        class $n {
                            constructor(t1){
                                this._enabled = !!t1.enable, this._moveStateManager = t1.moveStateManager, this._clickTolerance = t1.clickTolerance || 1, this._moveFunction = t1.move, this._activateOnStart = !!t1.activateOnStart, t1.assignEvents(this), this.reset();
                            }
                            reset(t1) {
                                this._active = !1, this._moved = !1, delete this._lastPoint, this._moveStateManager.endMove(t1);
                            }
                            _move(...t1) {
                                const e1 = this._moveFunction(...t1);
                                if (e1.bearingDelta || e1.pitchDelta || e1.around || e1.panDelta) return this._active = !0, e1;
                            }
                            dragStart(t1, e1) {
                                this.isEnabled() && !this._lastPoint && this._moveStateManager.isValidStartEvent(t1) && (this._moveStateManager.startMove(t1), this._lastPoint = e1.length ? e1[0] : e1, this._activateOnStart && this._lastPoint && (this._active = !0));
                            }
                            dragMove(t1, e1) {
                                if (!this.isEnabled()) return;
                                const r = this._lastPoint;
                                if (!r) return;
                                if (t1.preventDefault(), !this._moveStateManager.isValidMoveEvent(t1)) return void this.reset(t1);
                                const n = e1.length ? e1[0] : e1;
                                return !this._moved && n.dist(r) < this._clickTolerance ? void 0 : (this._moved = !0, this._lastPoint = n, this._move(r, n));
                            }
                            dragEnd(t1) {
                                this.isEnabled() && this._lastPoint && this._moveStateManager.isValidEndEvent(t1) && (this._moved && o.suppressClick(), this.reset(t1));
                            }
                            enable() {
                                this._enabled = !0;
                            }
                            disable() {
                                this._enabled = !1, this.reset();
                            }
                            isEnabled() {
                                return this._enabled;
                            }
                            isActive() {
                                return this._active;
                            }
                            getClickTolerance() {
                                return this._clickTolerance;
                            }
                        }
                        const Jn = {
                            0: 1,
                            2: 2
                        };
                        class Kn {
                            constructor(t1){
                                this._correctEvent = t1.checkCorrectEvent;
                            }
                            startMove(t1) {
                                const e1 = o.mouseButton(t1);
                                this._eventButton = e1;
                            }
                            endMove(t1) {
                                delete this._eventButton;
                            }
                            isValidStartEvent(t1) {
                                return this._correctEvent(t1);
                            }
                            isValidMoveEvent(t1) {
                                return !function(t1, e1) {
                                    const r = Jn[e1];
                                    return void 0 === t1.buttons || (t1.buttons & r) !== r;
                                }(t1, this._eventButton);
                            }
                            isValidEndEvent(t1) {
                                return o.mouseButton(t1) === this._eventButton;
                            }
                        }
                        class Qn {
                            constructor(){
                                this._firstTouch = void 0;
                            }
                            _isOneFingerTouch(t1) {
                                return 1 === t1.targetTouches.length;
                            }
                            _isSameTouchEvent(t1) {
                                return t1.targetTouches[0].identifier === this._firstTouch;
                            }
                            startMove(t1) {
                                const e1 = t1.targetTouches[0].identifier;
                                this._firstTouch = e1;
                            }
                            endMove(t1) {
                                delete this._firstTouch;
                            }
                            isValidStartEvent(t1) {
                                return this._isOneFingerTouch(t1);
                            }
                            isValidMoveEvent(t1) {
                                return this._isOneFingerTouch(t1) && this._isSameTouchEvent(t1);
                            }
                            isValidEndEvent(t1) {
                                return this._isOneFingerTouch(t1) && this._isSameTouchEvent(t1);
                            }
                        }
                        const ti = (t1)=>{
                            t1.mousedown = t1.dragStart, t1.mousemoveWindow = t1.dragMove, t1.mouseup = t1.dragEnd, t1.contextmenu = (t1)=>{
                                t1.preventDefault();
                            };
                        }, ei = ({ enable: t1, clickTolerance: e1, bearingDegreesPerPixelMoved: r = .8 })=>{
                            const n = new Kn({
                                checkCorrectEvent: (t1)=>0 === o.mouseButton(t1) && t1.ctrlKey || 2 === o.mouseButton(t1)
                            });
                            return new $n({
                                clickTolerance: e1,
                                move: (t1, e1)=>({
                                        bearingDelta: (e1.x - t1.x) * r
                                    }),
                                moveStateManager: n,
                                enable: t1,
                                assignEvents: ti
                            });
                        }, ri = ({ enable: t1, clickTolerance: e1, pitchDegreesPerPixelMoved: r = -0.5 })=>{
                            const n = new Kn({
                                checkCorrectEvent: (t1)=>0 === o.mouseButton(t1) && t1.ctrlKey || 2 === o.mouseButton(t1)
                            });
                            return new $n({
                                clickTolerance: e1,
                                move: (t1, e1)=>({
                                        pitchDelta: (e1.y - t1.y) * r
                                    }),
                                moveStateManager: n,
                                enable: t1,
                                assignEvents: ti
                            });
                        };
                        class ni {
                            constructor(t1, e1){
                                this._clickTolerance = t1.clickTolerance || 1, this._map = e1, this.reset();
                            }
                            reset() {
                                this._active = !1, this._touches = {}, this._sum = new e1.P(0, 0);
                            }
                            _shouldBePrevented(t1) {
                                return t1 < (this._map.cooperativeGestures.isEnabled() ? 2 : 1);
                            }
                            touchstart(t1, e1, r) {
                                return this._calculateTransform(t1, e1, r);
                            }
                            touchmove(t1, e1, r) {
                                if (this._active) {
                                    if (!this._shouldBePrevented(r.length)) return t1.preventDefault(), this._calculateTransform(t1, e1, r);
                                    this._map.cooperativeGestures.notifyGestureBlocked("touch_pan", t1);
                                }
                            }
                            touchend(t1, e1, r) {
                                this._calculateTransform(t1, e1, r), this._active && this._shouldBePrevented(r.length) && this.reset();
                            }
                            touchcancel() {
                                this.reset();
                            }
                            _calculateTransform(t1, r, n) {
                                n.length > 0 && (this._active = !0);
                                const i = Zn(n, r), a = new e1.P(0, 0), o = new e1.P(0, 0);
                                let s = 0;
                                for(const t1 in i){
                                    const e1 = i[t1], r = this._touches[t1];
                                    r && (a._add(e1), o._add(e1.sub(r)), s++, i[t1] = e1);
                                }
                                if (this._touches = i, this._shouldBePrevented(s) || !o.mag()) return;
                                const l = o.div(s);
                                return this._sum._add(l), this._sum.mag() < this._clickTolerance ? void 0 : {
                                    around: a.div(s),
                                    panDelta: l
                                };
                            }
                            enable() {
                                this._enabled = !0;
                            }
                            disable() {
                                this._enabled = !1, this.reset();
                            }
                            isEnabled() {
                                return this._enabled;
                            }
                            isActive() {
                                return this._active;
                            }
                        }
                        class ii {
                            constructor(){
                                this.reset();
                            }
                            reset() {
                                this._active = !1, delete this._firstTwoTouches;
                            }
                            touchstart(t1, e1, r) {
                                this._firstTwoTouches || r.length < 2 || (this._firstTwoTouches = [
                                    r[0].identifier,
                                    r[1].identifier
                                ], this._start([
                                    e1[0],
                                    e1[1]
                                ]));
                            }
                            touchmove(t1, e1, r) {
                                if (!this._firstTwoTouches) return;
                                t1.preventDefault();
                                const [n, i] = this._firstTwoTouches, a = ai(r, e1, n), o = ai(r, e1, i);
                                if (!a || !o) return;
                                const s = this._aroundCenter ? null : a.add(o).div(2);
                                return this._move([
                                    a,
                                    o
                                ], s, t1);
                            }
                            touchend(t1, e1, r) {
                                if (!this._firstTwoTouches) return;
                                const [n, i] = this._firstTwoTouches, a = ai(r, e1, n), s = ai(r, e1, i);
                                a && s || (this._active && o.suppressClick(), this.reset());
                            }
                            touchcancel() {
                                this.reset();
                            }
                            enable(t1) {
                                this._enabled = !0, this._aroundCenter = !!t1 && "center" === t1.around;
                            }
                            disable() {
                                this._enabled = !1, this.reset();
                            }
                            isEnabled() {
                                return !!this._enabled;
                            }
                            isActive() {
                                return !!this._active;
                            }
                        }
                        function ai(t1, e1, r) {
                            for(let n = 0; n < t1.length; n++)if (t1[n].identifier === r) return e1[n];
                        }
                        function oi(t1, e1) {
                            return Math.log(t1 / e1) / Math.LN2;
                        }
                        class si extends ii {
                            reset() {
                                super.reset(), delete this._distance, delete this._startDistance;
                            }
                            _start(t1) {
                                this._startDistance = this._distance = t1[0].dist(t1[1]);
                            }
                            _move(t1, e1) {
                                const r = this._distance;
                                if (this._distance = t1[0].dist(t1[1]), this._active || !(Math.abs(oi(this._distance, this._startDistance)) < .1)) return this._active = !0, {
                                    zoomDelta: oi(this._distance, r),
                                    pinchAround: e1
                                };
                            }
                        }
                        function li(t1, e1) {
                            return 180 * t1.angleWith(e1) / Math.PI;
                        }
                        class ci extends ii {
                            reset() {
                                super.reset(), delete this._minDiameter, delete this._startVector, delete this._vector;
                            }
                            _start(t1) {
                                this._startVector = this._vector = t1[0].sub(t1[1]), this._minDiameter = t1[0].dist(t1[1]);
                            }
                            _move(t1, e1, r) {
                                const n = this._vector;
                                if (this._vector = t1[0].sub(t1[1]), this._active || !this._isBelowThreshold(this._vector)) return this._active = !0, {
                                    bearingDelta: li(this._vector, n),
                                    pinchAround: e1
                                };
                            }
                            _isBelowThreshold(t1) {
                                this._minDiameter = Math.min(this._minDiameter, t1.mag());
                                const e1 = 25 / (Math.PI * this._minDiameter) * 360, r = li(t1, this._startVector);
                                return Math.abs(r) < e1;
                            }
                        }
                        function ui(t1) {
                            return Math.abs(t1.y) > Math.abs(t1.x);
                        }
                        class hi extends ii {
                            constructor(t1){
                                super(), this._currentTouchCount = 0, this._map = t1;
                            }
                            reset() {
                                super.reset(), this._valid = void 0, delete this._firstMove, delete this._lastPoints;
                            }
                            touchstart(t1, e1, r) {
                                super.touchstart(t1, e1, r), this._currentTouchCount = r.length;
                            }
                            _start(t1) {
                                this._lastPoints = t1, ui(t1[0].sub(t1[1])) && (this._valid = !1);
                            }
                            _move(t1, e1, r) {
                                if (this._map.cooperativeGestures.isEnabled() && this._currentTouchCount < 3) return;
                                const n = t1[0].sub(this._lastPoints[0]), i = t1[1].sub(this._lastPoints[1]);
                                return this._valid = this.gestureBeginsVertically(n, i, r.timeStamp), this._valid ? (this._lastPoints = t1, this._active = !0, {
                                    pitchDelta: (n.y + i.y) / 2 * -0.5
                                }) : void 0;
                            }
                            gestureBeginsVertically(t1, e1, r) {
                                if (void 0 !== this._valid) return this._valid;
                                const n = t1.mag() >= 2, i = e1.mag() >= 2;
                                if (!n && !i) return;
                                if (!n || !i) return void 0 === this._firstMove && (this._firstMove = r), r - this._firstMove < 100 && void 0;
                                const a = t1.y > 0 == e1.y > 0;
                                return ui(t1) && ui(e1) && a;
                            }
                        }
                        const fi = {
                            panStep: 100,
                            bearingStep: 15,
                            pitchStep: 10
                        };
                        class pi {
                            constructor(t1){
                                this._tr = new Hn(t1);
                                const e1 = fi;
                                this._panStep = e1.panStep, this._bearingStep = e1.bearingStep, this._pitchStep = e1.pitchStep, this._rotationDisabled = !1;
                            }
                            reset() {
                                this._active = !1;
                            }
                            keydown(t1) {
                                if (t1.altKey || t1.ctrlKey || t1.metaKey) return;
                                let e1 = 0, r = 0, n = 0, i = 0, a = 0;
                                switch(t1.keyCode){
                                    case 61:
                                    case 107:
                                    case 171:
                                    case 187:
                                        e1 = 1;
                                        break;
                                    case 189:
                                    case 109:
                                    case 173:
                                        e1 = -1;
                                        break;
                                    case 37:
                                        t1.shiftKey ? r = -1 : (t1.preventDefault(), i = -1);
                                        break;
                                    case 39:
                                        t1.shiftKey ? r = 1 : (t1.preventDefault(), i = 1);
                                        break;
                                    case 38:
                                        t1.shiftKey ? n = 1 : (t1.preventDefault(), a = -1);
                                        break;
                                    case 40:
                                        t1.shiftKey ? n = -1 : (t1.preventDefault(), a = 1);
                                        break;
                                    default:
                                        return;
                                }
                                return this._rotationDisabled && (r = 0, n = 0), {
                                    cameraAnimation: (o)=>{
                                        const s = this._tr;
                                        o.easeTo({
                                            duration: 300,
                                            easeId: "keyboardHandler",
                                            easing: di,
                                            zoom: e1 ? Math.round(s.zoom) + e1 * (t1.shiftKey ? 2 : 1) : s.zoom,
                                            bearing: s.bearing + r * this._bearingStep,
                                            pitch: s.pitch + n * this._pitchStep,
                                            offset: [
                                                -i * this._panStep,
                                                -a * this._panStep
                                            ],
                                            center: s.center
                                        }, {
                                            originalEvent: t1
                                        });
                                    }
                                };
                            }
                            enable() {
                                this._enabled = !0;
                            }
                            disable() {
                                this._enabled = !1, this.reset();
                            }
                            isEnabled() {
                                return this._enabled;
                            }
                            isActive() {
                                return this._active;
                            }
                            disableRotation() {
                                this._rotationDisabled = !0;
                            }
                            enableRotation() {
                                this._rotationDisabled = !1;
                            }
                        }
                        function di(t1) {
                            return t1 * (2 - t1);
                        }
                        const mi = 4.000244140625;
                        class gi {
                            constructor(t1, e1){
                                this._onTimeout = (t1)=>{
                                    this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(t1);
                                }, this._map = t1, this._tr = new Hn(t1), this._triggerRenderFrame = e1, this._delta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = .0022222222222222222;
                            }
                            setZoomRate(t1) {
                                this._defaultZoomRate = t1;
                            }
                            setWheelZoomRate(t1) {
                                this._wheelZoomRate = t1;
                            }
                            isEnabled() {
                                return !!this._enabled;
                            }
                            isActive() {
                                return !!this._active || void 0 !== this._finishTimeout;
                            }
                            isZooming() {
                                return !!this._zooming;
                            }
                            enable(t1) {
                                this.isEnabled() || (this._enabled = !0, this._aroundCenter = !!t1 && "center" === t1.around);
                            }
                            disable() {
                                this.isEnabled() && (this._enabled = !1);
                            }
                            _shouldBePrevented(t1) {
                                return !!this._map.cooperativeGestures.isEnabled() && !(t1.ctrlKey || this._map.cooperativeGestures.isBypassed(t1));
                            }
                            wheel(t1) {
                                if (!this.isEnabled()) return;
                                if (this._shouldBePrevented(t1)) return void this._map.cooperativeGestures.notifyGestureBlocked("wheel_zoom", t1);
                                let e1 = t1.deltaMode === WheelEvent.DOM_DELTA_LINE ? 40 * t1.deltaY : t1.deltaY;
                                const r = a.now(), n = r - (this._lastWheelEventTime || 0);
                                this._lastWheelEventTime = r, 0 !== e1 && e1 % mi == 0 ? this._type = "wheel" : 0 !== e1 && Math.abs(e1) < 4 ? this._type = "trackpad" : n > 400 ? (this._type = null, this._lastValue = e1, this._timeout = setTimeout(this._onTimeout, 40, t1)) : this._type || (this._type = Math.abs(n * e1) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, e1 += this._lastValue)), t1.shiftKey && e1 && (e1 /= 4), this._type && (this._lastWheelEvent = t1, this._delta -= e1, this._active || this._start(t1)), t1.preventDefault();
                            }
                            _start(t1) {
                                if (!this._delta) return;
                                this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                                const r = o.mousePos(this._map.getCanvas(), t1), n = this._tr;
                                r.y > n.transform.height / 2 - n.transform.getHorizon() ? this._around = e1.N.convert(this._aroundCenter ? n.center : n.unproject(r)) : this._around = e1.N.convert(n.center), this._aroundPoint = n.transform.locationPoint(this._around), this._frameId || (this._frameId = !0, this._triggerRenderFrame());
                            }
                            renderFrame() {
                                if (!this._frameId) return;
                                if (this._frameId = null, !this.isActive()) return;
                                const t1 = this._tr.transform;
                                if (0 !== this._delta) {
                                    const e1 = "wheel" === this._type && Math.abs(this._delta) > mi ? this._wheelZoomRate : this._defaultZoomRate;
                                    let r = 2 / (1 + Math.exp(-Math.abs(this._delta * e1)));
                                    this._delta < 0 && 0 !== r && (r = 1 / r);
                                    const n = "number" == typeof this._targetZoom ? t1.zoomScale(this._targetZoom) : t1.scale;
                                    this._targetZoom = Math.min(t1.maxZoom, Math.max(t1.minZoom, t1.scaleZoom(n * r))), "wheel" === this._type && (this._startZoom = t1.zoom, this._easing = this._smoothOutEasing(200)), this._delta = 0;
                                }
                                const r = "number" == typeof this._targetZoom ? this._targetZoom : t1.zoom, n = this._startZoom, i = this._easing;
                                let o, s = !1;
                                const l = a.now() - this._lastWheelEventTime;
                                if ("wheel" === this._type && n && i && l) {
                                    const t1 = Math.min(l / 200, 1), a = i(t1);
                                    o = e1.z.number(n, r, a), t1 < 1 ? this._frameId || (this._frameId = !0) : s = !0;
                                } else o = r, s = !0;
                                return this._active = !0, s && (this._active = !1, this._finishTimeout = setTimeout(()=>{
                                    this._zooming = !1, this._triggerRenderFrame(), delete this._targetZoom, delete this._finishTimeout;
                                }, 200)), {
                                    noInertia: !0,
                                    needsRenderFrame: !s,
                                    zoomDelta: o - t1.zoom,
                                    around: this._aroundPoint,
                                    originalEvent: this._lastWheelEvent
                                };
                            }
                            _smoothOutEasing(t1) {
                                let r = e1.b9;
                                if (this._prevEase) {
                                    const t1 = this._prevEase, n = (a.now() - t1.start) / t1.duration, i = t1.easing(n + .01) - t1.easing(n), o = .27 / Math.sqrt(i * i + 1e-4) * .01, s = Math.sqrt(.0729 - o * o);
                                    r = e1.b8(o, s, .25, 1);
                                }
                                return this._prevEase = {
                                    start: a.now(),
                                    duration: t1,
                                    easing: r
                                }, r;
                            }
                            reset() {
                                this._active = !1, this._zooming = !1, delete this._targetZoom, this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                            }
                        }
                        class yi {
                            constructor(t1, e1){
                                this._clickZoom = t1, this._tapZoom = e1;
                            }
                            enable() {
                                this._clickZoom.enable(), this._tapZoom.enable();
                            }
                            disable() {
                                this._clickZoom.disable(), this._tapZoom.disable();
                            }
                            isEnabled() {
                                return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
                            }
                            isActive() {
                                return this._clickZoom.isActive() || this._tapZoom.isActive();
                            }
                        }
                        class vi {
                            constructor(t1){
                                this._tr = new Hn(t1), this.reset();
                            }
                            reset() {
                                this._active = !1;
                            }
                            dblclick(t1, e1) {
                                return t1.preventDefault(), {
                                    cameraAnimation: (r)=>{
                                        r.easeTo({
                                            duration: 300,
                                            zoom: this._tr.zoom + (t1.shiftKey ? -1 : 1),
                                            around: this._tr.unproject(e1)
                                        }, {
                                            originalEvent: t1
                                        });
                                    }
                                };
                            }
                            enable() {
                                this._enabled = !0;
                            }
                            disable() {
                                this._enabled = !1, this.reset();
                            }
                            isEnabled() {
                                return this._enabled;
                            }
                            isActive() {
                                return this._active;
                            }
                        }
                        class xi {
                            constructor(){
                                this._tap = new Yn({
                                    numTouches: 1,
                                    numTaps: 1
                                }), this.reset();
                            }
                            reset() {
                                this._active = !1, delete this._swipePoint, delete this._swipeTouch, delete this._tapTime, delete this._tapPoint, this._tap.reset();
                            }
                            touchstart(t1, e1, r) {
                                if (!this._swipePoint) {
                                    if (this._tapTime) {
                                        const n = e1[0], i = t1.timeStamp - this._tapTime < 500, a = this._tapPoint.dist(n) < 30;
                                        i && a ? r.length > 0 && (this._swipePoint = n, this._swipeTouch = r[0].identifier) : this.reset();
                                    } else this._tap.touchstart(t1, e1, r);
                                }
                            }
                            touchmove(t1, e1, r) {
                                if (this._tapTime) {
                                    if (this._swipePoint) {
                                        if (r[0].identifier !== this._swipeTouch) return;
                                        const n = e1[0], i = n.y - this._swipePoint.y;
                                        return this._swipePoint = n, t1.preventDefault(), this._active = !0, {
                                            zoomDelta: i / 128
                                        };
                                    }
                                } else this._tap.touchmove(t1, e1, r);
                            }
                            touchend(t1, e1, r) {
                                if (this._tapTime) this._swipePoint && 0 === r.length && this.reset();
                                else {
                                    const n = this._tap.touchend(t1, e1, r);
                                    n && (this._tapTime = t1.timeStamp, this._tapPoint = n);
                                }
                            }
                            touchcancel() {
                                this.reset();
                            }
                            enable() {
                                this._enabled = !0;
                            }
                            disable() {
                                this._enabled = !1, this.reset();
                            }
                            isEnabled() {
                                return this._enabled;
                            }
                            isActive() {
                                return this._active;
                            }
                        }
                        class _i {
                            constructor(t1, e1, r){
                                this._el = t1, this._mousePan = e1, this._touchPan = r;
                            }
                            enable(t1) {
                                this._inertiaOptions = t1 || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("maplibregl-touch-drag-pan");
                            }
                            disable() {
                                this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("maplibregl-touch-drag-pan");
                            }
                            isEnabled() {
                                return this._mousePan.isEnabled() && this._touchPan.isEnabled();
                            }
                            isActive() {
                                return this._mousePan.isActive() || this._touchPan.isActive();
                            }
                        }
                        class bi {
                            constructor(t1, e1, r){
                                this._pitchWithRotate = t1.pitchWithRotate, this._mouseRotate = e1, this._mousePitch = r;
                            }
                            enable() {
                                this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable();
                            }
                            disable() {
                                this._mouseRotate.disable(), this._mousePitch.disable();
                            }
                            isEnabled() {
                                return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
                            }
                            isActive() {
                                return this._mouseRotate.isActive() || this._mousePitch.isActive();
                            }
                        }
                        class wi {
                            constructor(t1, e1, r, n){
                                this._el = t1, this._touchZoom = e1, this._touchRotate = r, this._tapDragZoom = n, this._rotationDisabled = !1, this._enabled = !0;
                            }
                            enable(t1) {
                                this._touchZoom.enable(t1), this._rotationDisabled || this._touchRotate.enable(t1), this._tapDragZoom.enable(), this._el.classList.add("maplibregl-touch-zoom-rotate");
                            }
                            disable() {
                                this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("maplibregl-touch-zoom-rotate");
                            }
                            isEnabled() {
                                return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
                            }
                            isActive() {
                                return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
                            }
                            disableRotation() {
                                this._rotationDisabled = !0, this._touchRotate.disable();
                            }
                            enableRotation() {
                                this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
                            }
                        }
                        class Ti {
                            constructor(t1, e1){
                                this._bypassKey = -1 !== navigator.userAgent.indexOf("Mac") ? "metaKey" : "ctrlKey", this._map = t1, this._options = e1, this._enabled = !1;
                            }
                            isActive() {
                                return !1;
                            }
                            reset() {}
                            _setupUI() {
                                if (this._container) return;
                                const t1 = this._map.getCanvasContainer();
                                t1.classList.add("maplibregl-cooperative-gestures"), this._container = o.create("div", "maplibregl-cooperative-gesture-screen", t1);
                                let e1 = this._map._getUIString("CooperativeGesturesHandler.WindowsHelpText");
                                "metaKey" === this._bypassKey && (e1 = this._map._getUIString("CooperativeGesturesHandler.MacHelpText"));
                                const r = this._map._getUIString("CooperativeGesturesHandler.MobileHelpText"), n = document.createElement("div");
                                n.className = "maplibregl-desktop-message", n.textContent = e1, this._container.appendChild(n);
                                const i = document.createElement("div");
                                i.className = "maplibregl-mobile-message", i.textContent = r, this._container.appendChild(i), this._container.setAttribute("aria-hidden", "true");
                            }
                            _destroyUI() {
                                this._container && (o.remove(this._container), this._map.getCanvasContainer().classList.remove("maplibregl-cooperative-gestures")), delete this._container;
                            }
                            enable() {
                                this._setupUI(), this._enabled = !0;
                            }
                            disable() {
                                this._enabled = !1, this._destroyUI();
                            }
                            isEnabled() {
                                return this._enabled;
                            }
                            isBypassed(t1) {
                                return t1[this._bypassKey];
                            }
                            notifyGestureBlocked(t1, r) {
                                this._enabled && (this._map.fire(new e1.k("cooperativegestureprevented", {
                                    gestureType: t1,
                                    originalEvent: r
                                })), this._container.classList.add("maplibregl-show"), setTimeout(()=>{
                                    this._container.classList.remove("maplibregl-show");
                                }, 100));
                            }
                        }
                        const ki = (t1)=>t1.zoom || t1.drag || t1.pitch || t1.rotate;
                        class Ai extends e1.k {
                        }
                        function Mi(t1) {
                            return t1.panDelta && t1.panDelta.mag() || t1.zoomDelta || t1.bearingDelta || t1.pitchDelta;
                        }
                        class Si {
                            constructor(t1, e1){
                                this.handleWindowEvent = (t1)=>{
                                    this.handleEvent(t1, `${t1.type}Window`);
                                }, this.handleEvent = (t1, e1)=>{
                                    if ("blur" === t1.type) return void this.stop(!0);
                                    this._updatingCamera = !0;
                                    const r = "renderFrame" === t1.type ? void 0 : t1, n = {
                                        needsRenderFrame: !1
                                    }, i = {}, a = {}, s = t1.touches, l = s ? this._getMapTouches(s) : void 0, c = l ? o.touchPos(this._map.getCanvas(), l) : o.mousePos(this._map.getCanvas(), t1);
                                    for (const { handlerName: o, handler: s, allowed: u } of this._handlers){
                                        if (!s.isEnabled()) continue;
                                        let h;
                                        this._blockedByActive(a, u, o) ? s.reset() : s[e1 || t1.type] && (h = s[e1 || t1.type](t1, c, l), this.mergeHandlerResult(n, i, h, o, r), h && h.needsRenderFrame && this._triggerRenderFrame()), (h || s.isActive()) && (a[o] = s);
                                    }
                                    const u = {};
                                    for(const t1 in this._previousActiveHandlers)a[t1] || (u[t1] = r);
                                    this._previousActiveHandlers = a, (Object.keys(u).length || Mi(n)) && (this._changes.push([
                                        n,
                                        i,
                                        u
                                    ]), this._triggerRenderFrame()), (Object.keys(a).length || Mi(n)) && this._map._stop(!0), this._updatingCamera = !1;
                                    const { cameraAnimation: h } = n;
                                    h && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], h(this._map));
                                }, this._map = t1, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new Rn(t1), this._bearingSnap = e1.bearingSnap, this._previousActiveHandlers = {}, this._eventsInProgress = {}, this._addDefaultHandlers(e1);
                                const r = this._el;
                                this._listeners = [
                                    [
                                        r,
                                        "touchstart",
                                        {
                                            passive: !0
                                        }
                                    ],
                                    [
                                        r,
                                        "touchmove",
                                        {
                                            passive: !1
                                        }
                                    ],
                                    [
                                        r,
                                        "touchend",
                                        void 0
                                    ],
                                    [
                                        r,
                                        "touchcancel",
                                        void 0
                                    ],
                                    [
                                        r,
                                        "mousedown",
                                        void 0
                                    ],
                                    [
                                        r,
                                        "mousemove",
                                        void 0
                                    ],
                                    [
                                        r,
                                        "mouseup",
                                        void 0
                                    ],
                                    [
                                        document,
                                        "mousemove",
                                        {
                                            capture: !0
                                        }
                                    ],
                                    [
                                        document,
                                        "mouseup",
                                        void 0
                                    ],
                                    [
                                        r,
                                        "mouseover",
                                        void 0
                                    ],
                                    [
                                        r,
                                        "mouseout",
                                        void 0
                                    ],
                                    [
                                        r,
                                        "dblclick",
                                        void 0
                                    ],
                                    [
                                        r,
                                        "click",
                                        void 0
                                    ],
                                    [
                                        r,
                                        "keydown",
                                        {
                                            capture: !1
                                        }
                                    ],
                                    [
                                        r,
                                        "keyup",
                                        void 0
                                    ],
                                    [
                                        r,
                                        "wheel",
                                        {
                                            passive: !1
                                        }
                                    ],
                                    [
                                        r,
                                        "contextmenu",
                                        void 0
                                    ],
                                    [
                                        window,
                                        "blur",
                                        void 0
                                    ]
                                ];
                                for (const [t1, e1, r] of this._listeners)o.addEventListener(t1, e1, t1 === document ? this.handleWindowEvent : this.handleEvent, r);
                            }
                            destroy() {
                                for (const [t1, e1, r] of this._listeners)o.removeEventListener(t1, e1, t1 === document ? this.handleWindowEvent : this.handleEvent, r);
                            }
                            _addDefaultHandlers(t1) {
                                const e1 = this._map, r = e1.getCanvasContainer();
                                this._add("mapEvent", new Vn(e1, t1));
                                const n = e1.boxZoom = new Gn(e1, t1);
                                this._add("boxZoom", n), t1.interactive && t1.boxZoom && n.enable();
                                const i = e1.cooperativeGestures = new Ti(e1, t1.cooperativeGestures);
                                this._add("cooperativeGestures", i), t1.cooperativeGestures && i.enable();
                                const a = new Xn(e1), s = new vi(e1);
                                e1.doubleClickZoom = new yi(s, a), this._add("tapZoom", a), this._add("clickZoom", s), t1.interactive && t1.doubleClickZoom && e1.doubleClickZoom.enable();
                                const l = new xi;
                                this._add("tapDragZoom", l);
                                const c = e1.touchPitch = new hi(e1);
                                this._add("touchPitch", c), t1.interactive && t1.touchPitch && e1.touchPitch.enable(t1.touchPitch);
                                const u = ei(t1), h = ri(t1);
                                e1.dragRotate = new bi(t1, u, h), this._add("mouseRotate", u, [
                                    "mousePitch"
                                ]), this._add("mousePitch", h, [
                                    "mouseRotate"
                                ]), t1.interactive && t1.dragRotate && e1.dragRotate.enable();
                                const f = (({ enable: t1, clickTolerance: e1 })=>{
                                    const r = new Kn({
                                        checkCorrectEvent: (t1)=>0 === o.mouseButton(t1) && !t1.ctrlKey
                                    });
                                    return new $n({
                                        clickTolerance: e1,
                                        move: (t1, e1)=>({
                                                around: e1,
                                                panDelta: e1.sub(t1)
                                            }),
                                        activateOnStart: !0,
                                        moveStateManager: r,
                                        enable: t1,
                                        assignEvents: ti
                                    });
                                })(t1), p = new ni(t1, e1);
                                e1.dragPan = new _i(r, f, p), this._add("mousePan", f), this._add("touchPan", p, [
                                    "touchZoom",
                                    "touchRotate"
                                ]), t1.interactive && t1.dragPan && e1.dragPan.enable(t1.dragPan);
                                const d = new ci, m = new si;
                                e1.touchZoomRotate = new wi(r, m, d, l), this._add("touchRotate", d, [
                                    "touchPan",
                                    "touchZoom"
                                ]), this._add("touchZoom", m, [
                                    "touchPan",
                                    "touchRotate"
                                ]), t1.interactive && t1.touchZoomRotate && e1.touchZoomRotate.enable(t1.touchZoomRotate);
                                const g = e1.scrollZoom = new gi(e1, ()=>this._triggerRenderFrame());
                                this._add("scrollZoom", g, [
                                    "mousePan"
                                ]), t1.interactive && t1.scrollZoom && e1.scrollZoom.enable(t1.scrollZoom);
                                const y = e1.keyboard = new pi(e1);
                                this._add("keyboard", y), t1.interactive && t1.keyboard && e1.keyboard.enable(), this._add("blockableMapEvent", new qn(e1));
                            }
                            _add(t1, e1, r) {
                                this._handlers.push({
                                    handlerName: t1,
                                    handler: e1,
                                    allowed: r
                                }), this._handlersById[t1] = e1;
                            }
                            stop(t1) {
                                if (!this._updatingCamera) {
                                    for (const { handler: t1 } of this._handlers)t1.reset();
                                    this._inertia.clear(), this._fireEvents({}, {}, t1), this._changes = [];
                                }
                            }
                            isActive() {
                                for (const { handler: t1 } of this._handlers)if (t1.isActive()) return !0;
                                return !1;
                            }
                            isZooming() {
                                return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
                            }
                            isRotating() {
                                return !!this._eventsInProgress.rotate;
                            }
                            isMoving() {
                                return Boolean(ki(this._eventsInProgress)) || this.isZooming();
                            }
                            _blockedByActive(t1, e1, r) {
                                for(const n in t1)if (n !== r && (!e1 || e1.indexOf(n) < 0)) return !0;
                                return !1;
                            }
                            _getMapTouches(t1) {
                                const e1 = [];
                                for (const r of t1){
                                    const t1 = r.target;
                                    this._el.contains(t1) && e1.push(r);
                                }
                                return e1;
                            }
                            mergeHandlerResult(t1, r, n, i, a) {
                                if (!n) return;
                                e1.e(t1, n);
                                const o = {
                                    handlerName: i,
                                    originalEvent: n.originalEvent || a
                                };
                                void 0 !== n.zoomDelta && (r.zoom = o), void 0 !== n.panDelta && (r.drag = o), void 0 !== n.pitchDelta && (r.pitch = o), void 0 !== n.bearingDelta && (r.rotate = o);
                            }
                            _applyChanges() {
                                const t1 = {}, r = {}, n = {};
                                for (const [i, a, o] of this._changes)i.panDelta && (t1.panDelta = (t1.panDelta || new e1.P(0, 0))._add(i.panDelta)), i.zoomDelta && (t1.zoomDelta = (t1.zoomDelta || 0) + i.zoomDelta), i.bearingDelta && (t1.bearingDelta = (t1.bearingDelta || 0) + i.bearingDelta), i.pitchDelta && (t1.pitchDelta = (t1.pitchDelta || 0) + i.pitchDelta), void 0 !== i.around && (t1.around = i.around), void 0 !== i.pinchAround && (t1.pinchAround = i.pinchAround), i.noInertia && (t1.noInertia = i.noInertia), e1.e(r, a), e1.e(n, o);
                                this._updateMapTransform(t1, r, n), this._changes = [];
                            }
                            _updateMapTransform(t1, e1, r) {
                                const n = this._map, i = n._getTransformForUpdate(), a = n.terrain;
                                if (!(Mi(t1) || a && this._terrainMovement)) return this._fireEvents(e1, r, !0);
                                let { panDelta: o, zoomDelta: s, bearingDelta: l, pitchDelta: c, around: u, pinchAround: h } = t1;
                                void 0 !== h && (u = h), n._stop(!0), u = u || n.transform.centerPoint;
                                const f = i.pointLocation(o ? u.sub(o) : u);
                                l && (i.bearing += l), c && (i.pitch += c), s && (i.zoom += s), a ? this._terrainMovement || !e1.drag && !e1.zoom ? e1.drag && this._terrainMovement ? i.center = i.pointLocation(i.centerPoint.sub(o)) : i.setLocationAtPoint(f, u) : (this._terrainMovement = !0, this._map._elevationFreeze = !0, i.setLocationAtPoint(f, u)) : i.setLocationAtPoint(f, u), n._applyUpdatedTransform(i), this._map._update(), t1.noInertia || this._inertia.record(t1), this._fireEvents(e1, r, !0);
                            }
                            _fireEvents(t1, r, n) {
                                const i = ki(this._eventsInProgress), o = ki(t1), s = {};
                                for(const e1 in t1){
                                    const { originalEvent: r } = t1[e1];
                                    this._eventsInProgress[e1] || (s[`${e1}start`] = r), this._eventsInProgress[e1] = t1[e1];
                                }
                                !i && o && this._fireEvent("movestart", o.originalEvent);
                                for(const t1 in s)this._fireEvent(t1, s[t1]);
                                o && this._fireEvent("move", o.originalEvent);
                                for(const e1 in t1){
                                    const { originalEvent: r } = t1[e1];
                                    this._fireEvent(e1, r);
                                }
                                const l = {};
                                let c;
                                for(const t1 in this._eventsInProgress){
                                    const { handlerName: e1, originalEvent: n } = this._eventsInProgress[t1];
                                    this._handlersById[e1].isActive() || (delete this._eventsInProgress[t1], c = r[e1] || n, l[`${t1}end`] = c);
                                }
                                for(const t1 in l)this._fireEvent(t1, l[t1]);
                                const u = ki(this._eventsInProgress), h = (i || o) && !u;
                                if (h && this._terrainMovement) {
                                    this._map._elevationFreeze = !1, this._terrainMovement = !1;
                                    const t1 = this._map._getTransformForUpdate();
                                    t1.recalculateZoom(this._map.terrain), this._map._applyUpdatedTransform(t1);
                                }
                                if (n && h) {
                                    this._updatingCamera = !0;
                                    const t1 = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), r = (t1)=>0 !== t1 && -this._bearingSnap < t1 && t1 < this._bearingSnap;
                                    !t1 || !t1.essential && a.prefersReducedMotion ? (this._map.fire(new e1.k("moveend", {
                                        originalEvent: c
                                    })), r(this._map.getBearing()) && this._map.resetNorth()) : (r(t1.bearing || this._map.getBearing()) && (t1.bearing = 0), t1.freezeElevation = !0, this._map.easeTo(t1, {
                                        originalEvent: c
                                    })), this._updatingCamera = !1;
                                }
                            }
                            _fireEvent(t1, r) {
                                this._map.fire(new e1.k(t1, r ? {
                                    originalEvent: r
                                } : {}));
                            }
                            _requestFrame() {
                                return this._map.triggerRepaint(), this._map._renderTaskQueue.add((t1)=>{
                                    delete this._frameId, this.handleEvent(new Ai("renderFrame", {
                                        timeStamp: t1
                                    })), this._applyChanges();
                                });
                            }
                            _triggerRenderFrame() {
                                void 0 === this._frameId && (this._frameId = this._requestFrame());
                            }
                        }
                        class Ei extends e1.E {
                            constructor(t1, e1){
                                super(), this._renderFrameCallback = ()=>{
                                    const t1 = Math.min((a.now() - this._easeStart) / this._easeOptions.duration, 1);
                                    this._onEaseFrame(this._easeOptions.easing(t1)), t1 < 1 && this._easeFrameId ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
                                }, this._moving = !1, this._zooming = !1, this.transform = t1, this._bearingSnap = e1.bearingSnap, this.on("moveend", ()=>{
                                    delete this._requestedCameraState;
                                });
                            }
                            getCenter() {
                                return new e1.N(this.transform.center.lng, this.transform.center.lat);
                            }
                            setCenter(t1, e1) {
                                return this.jumpTo({
                                    center: t1
                                }, e1);
                            }
                            panBy(t1, r, n) {
                                return t1 = e1.P.convert(t1).mult(-1), this.panTo(this.transform.center, e1.e({
                                    offset: t1
                                }, r), n);
                            }
                            panTo(t1, r, n) {
                                return this.easeTo(e1.e({
                                    center: t1
                                }, r), n);
                            }
                            getZoom() {
                                return this.transform.zoom;
                            }
                            setZoom(t1, e1) {
                                return this.jumpTo({
                                    zoom: t1
                                }, e1), this;
                            }
                            zoomTo(t1, r, n) {
                                return this.easeTo(e1.e({
                                    zoom: t1
                                }, r), n);
                            }
                            zoomIn(t1, e1) {
                                return this.zoomTo(this.getZoom() + 1, t1, e1), this;
                            }
                            zoomOut(t1, e1) {
                                return this.zoomTo(this.getZoom() - 1, t1, e1), this;
                            }
                            getBearing() {
                                return this.transform.bearing;
                            }
                            setBearing(t1, e1) {
                                return this.jumpTo({
                                    bearing: t1
                                }, e1), this;
                            }
                            getPadding() {
                                return this.transform.padding;
                            }
                            setPadding(t1, e1) {
                                return this.jumpTo({
                                    padding: t1
                                }, e1), this;
                            }
                            rotateTo(t1, r, n) {
                                return this.easeTo(e1.e({
                                    bearing: t1
                                }, r), n);
                            }
                            resetNorth(t1, r) {
                                return this.rotateTo(0, e1.e({
                                    duration: 1e3
                                }, t1), r), this;
                            }
                            resetNorthPitch(t1, r) {
                                return this.easeTo(e1.e({
                                    bearing: 0,
                                    pitch: 0,
                                    duration: 1e3
                                }, t1), r), this;
                            }
                            snapToNorth(t1, e1) {
                                return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(t1, e1) : this;
                            }
                            getPitch() {
                                return this.transform.pitch;
                            }
                            setPitch(t1, e1) {
                                return this.jumpTo({
                                    pitch: t1
                                }, e1), this;
                            }
                            cameraForBounds(t1, e1) {
                                t1 = X.convert(t1);
                                const r = e1 && e1.bearing || 0;
                                return this._cameraForBoxAndBearing(t1.getNorthWest(), t1.getSouthEast(), r, e1);
                            }
                            _cameraForBoxAndBearing(t1, r, n, i) {
                                const a = {
                                    top: 0,
                                    bottom: 0,
                                    right: 0,
                                    left: 0
                                };
                                if ("number" == typeof (i = e1.e({
                                    padding: a,
                                    offset: [
                                        0,
                                        0
                                    ],
                                    maxZoom: this.transform.maxZoom
                                }, i)).padding) {
                                    const t1 = i.padding;
                                    i.padding = {
                                        top: t1,
                                        bottom: t1,
                                        right: t1,
                                        left: t1
                                    };
                                }
                                i.padding = e1.e(a, i.padding);
                                const o = this.transform, s = o.padding, l = new X(t1, r), c = o.project(l.getNorthWest()), u = o.project(l.getNorthEast()), h = o.project(l.getSouthEast()), f = o.project(l.getSouthWest()), p = e1.ba(-n), d = c.rotate(p), m = u.rotate(p), g = h.rotate(p), y = f.rotate(p), v = new e1.P(Math.max(d.x, m.x, y.x, g.x), Math.max(d.y, m.y, y.y, g.y)), x = new e1.P(Math.min(d.x, m.x, y.x, g.x), Math.min(d.y, m.y, y.y, g.y)), _ = v.sub(x), b = (o.width - (s.left + s.right + i.padding.left + i.padding.right)) / _.x, w = (o.height - (s.top + s.bottom + i.padding.top + i.padding.bottom)) / _.y;
                                if (w < 0 || b < 0) return void e1.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
                                const T = Math.min(o.scaleZoom(o.scale * Math.min(b, w)), i.maxZoom), k = e1.P.convert(i.offset), A = (i.padding.left - i.padding.right) / 2, M = (i.padding.top - i.padding.bottom) / 2, S = new e1.P(A, M).rotate(e1.ba(n)), E = k.add(S).mult(o.scale / o.zoomScale(T));
                                return {
                                    center: o.unproject(c.add(h).div(2).sub(E)),
                                    zoom: T,
                                    bearing: n
                                };
                            }
                            fitBounds(t1, e1, r) {
                                return this._fitInternal(this.cameraForBounds(t1, e1), e1, r);
                            }
                            fitScreenCoordinates(t1, r, n, i, a) {
                                return this._fitInternal(this._cameraForBoxAndBearing(this.transform.pointLocation(e1.P.convert(t1)), this.transform.pointLocation(e1.P.convert(r)), n, i), i, a);
                            }
                            _fitInternal(t1, r, n) {
                                return t1 ? (delete (r = e1.e(t1, r)).padding, r.linear ? this.easeTo(r, n) : this.flyTo(r, n)) : this;
                            }
                            jumpTo(t1, r) {
                                this.stop();
                                const n = this._getTransformForUpdate();
                                let i = !1, a = !1, o = !1;
                                return "zoom" in t1 && n.zoom !== +t1.zoom && (i = !0, n.zoom = +t1.zoom), void 0 !== t1.center && (n.center = e1.N.convert(t1.center)), "bearing" in t1 && n.bearing !== +t1.bearing && (a = !0, n.bearing = +t1.bearing), "pitch" in t1 && n.pitch !== +t1.pitch && (o = !0, n.pitch = +t1.pitch), null == t1.padding || n.isPaddingEqual(t1.padding) || (n.padding = t1.padding), this._applyUpdatedTransform(n), this.fire(new e1.k("movestart", r)).fire(new e1.k("move", r)), i && this.fire(new e1.k("zoomstart", r)).fire(new e1.k("zoom", r)).fire(new e1.k("zoomend", r)), a && this.fire(new e1.k("rotatestart", r)).fire(new e1.k("rotate", r)).fire(new e1.k("rotateend", r)), o && this.fire(new e1.k("pitchstart", r)).fire(new e1.k("pitch", r)).fire(new e1.k("pitchend", r)), this.fire(new e1.k("moveend", r));
                            }
                            calculateCameraOptionsFromTo(t1, r, n, i = 0) {
                                const a = e1.Z.fromLngLat(t1, r), o = e1.Z.fromLngLat(n, i), s = o.x - a.x, l = o.y - a.y, c = o.z - a.z, u = Math.hypot(s, l, c);
                                if (0 === u) throw new Error("Can't calculate camera options with same From and To");
                                const h = Math.hypot(s, l), f = this.transform.scaleZoom(this.transform.cameraToCenterDistance / u / this.transform.tileSize), p = 180 * Math.atan2(s, -l) / Math.PI;
                                let d = 180 * Math.acos(h / u) / Math.PI;
                                return d = c < 0 ? 90 - d : 90 + d, {
                                    center: o.toLngLat(),
                                    zoom: f,
                                    pitch: d,
                                    bearing: p
                                };
                            }
                            easeTo(t1, r) {
                                var n;
                                this._stop(!1, t1.easeId), (!1 === (t1 = e1.e({
                                    offset: [
                                        0,
                                        0
                                    ],
                                    duration: 500,
                                    easing: e1.b9
                                }, t1)).animate || !t1.essential && a.prefersReducedMotion) && (t1.duration = 0);
                                const i = this._getTransformForUpdate(), o = i.zoom, s = i.bearing, l = i.pitch, c = i.padding, u = "bearing" in t1 ? this._normalizeBearing(t1.bearing, s) : s, h = "pitch" in t1 ? +t1.pitch : l, f = "padding" in t1 ? t1.padding : i.padding, p = e1.P.convert(t1.offset);
                                let d = i.centerPoint.add(p);
                                const m = i.pointLocation(d), { center: g, zoom: y } = i.getConstrained(e1.N.convert(t1.center || m), null !== (n = t1.zoom) && void 0 !== n ? n : o);
                                this._normalizeCenter(g, i);
                                const v = i.project(m), x = i.project(g).sub(v), _ = i.zoomScale(y - o);
                                let b, w;
                                t1.around && (b = e1.N.convert(t1.around), w = i.locationPoint(b));
                                const T = {
                                    moving: this._moving,
                                    zooming: this._zooming,
                                    rotating: this._rotating,
                                    pitching: this._pitching
                                };
                                return this._zooming = this._zooming || y !== o, this._rotating = this._rotating || s !== u, this._pitching = this._pitching || h !== l, this._padding = !i.isPaddingEqual(f), this._easeId = t1.easeId, this._prepareEase(r, t1.noMoveStart, T), this.terrain && this._prepareElevation(g), this._ease((n)=>{
                                    if (this._zooming && (i.zoom = e1.z.number(o, y, n)), this._rotating && (i.bearing = e1.z.number(s, u, n)), this._pitching && (i.pitch = e1.z.number(l, h, n)), this._padding && (i.interpolatePadding(c, f, n), d = i.centerPoint.add(p)), this.terrain && !t1.freezeElevation && this._updateElevation(n), b) i.setLocationAtPoint(b, w);
                                    else {
                                        const t1 = i.zoomScale(i.zoom - o), e1 = y > o ? Math.min(2, _) : Math.max(.5, _), r = Math.pow(e1, 1 - n), a = i.unproject(v.add(x.mult(n * r)).mult(t1));
                                        i.setLocationAtPoint(i.renderWorldCopies ? a.wrap() : a, d);
                                    }
                                    this._applyUpdatedTransform(i), this._fireMoveEvents(r);
                                }, (e1)=>{
                                    this.terrain && t1.freezeElevation && this._finalizeElevation(), this._afterEase(r, e1);
                                }, t1), this;
                            }
                            _prepareEase(t1, r, n = {}) {
                                this._moving = !0, r || n.moving || this.fire(new e1.k("movestart", t1)), this._zooming && !n.zooming && this.fire(new e1.k("zoomstart", t1)), this._rotating && !n.rotating && this.fire(new e1.k("rotatestart", t1)), this._pitching && !n.pitching && this.fire(new e1.k("pitchstart", t1));
                            }
                            _prepareElevation(t1) {
                                this._elevationCenter = t1, this._elevationStart = this.transform.elevation, this._elevationTarget = this.terrain.getElevationForLngLatZoom(t1, this.transform.tileZoom), this._elevationFreeze = !0;
                            }
                            _updateElevation(t1) {
                                this.transform.minElevationForCurrentTile = this.terrain.getMinTileElevationForLngLatZoom(this._elevationCenter, this.transform.tileZoom);
                                const r = this.terrain.getElevationForLngLatZoom(this._elevationCenter, this.transform.tileZoom);
                                if (t1 < 1 && r !== this._elevationTarget) {
                                    const e1 = this._elevationTarget - this._elevationStart, n = (r - (e1 * t1 + this._elevationStart)) / (1 - t1);
                                    this._elevationStart += t1 * (e1 - n), this._elevationTarget = r;
                                }
                                this.transform.elevation = e1.z.number(this._elevationStart, this._elevationTarget, t1);
                            }
                            _finalizeElevation() {
                                this._elevationFreeze = !1, this.transform.recalculateZoom(this.terrain);
                            }
                            _getTransformForUpdate() {
                                return this.transformCameraUpdate || this.terrain ? (this._requestedCameraState || (this._requestedCameraState = this.transform.clone()), this._requestedCameraState) : this.transform;
                            }
                            _elevateCameraIfInsideTerrain(t1) {
                                const e1 = t1.getCameraPosition(), r = this.terrain.getElevationForLngLatZoom(e1.lngLat, t1.zoom);
                                if (e1.altitude < r) {
                                    const n = this.calculateCameraOptionsFromTo(e1.lngLat, r, t1.center, t1.elevation);
                                    return {
                                        pitch: n.pitch,
                                        zoom: n.zoom
                                    };
                                }
                                return {};
                            }
                            _applyUpdatedTransform(t1) {
                                const e1 = [];
                                if (this.terrain && e1.push((t1)=>this._elevateCameraIfInsideTerrain(t1)), this.transformCameraUpdate && e1.push((t1)=>this.transformCameraUpdate(t1)), !e1.length) return;
                                const r = t1.clone();
                                for (const t1 of e1){
                                    const e1 = r.clone(), { center: n, zoom: i, pitch: a, bearing: o, elevation: s } = t1(e1);
                                    n && (e1.center = n), void 0 !== i && (e1.zoom = i), void 0 !== a && (e1.pitch = a), void 0 !== o && (e1.bearing = o), void 0 !== s && (e1.elevation = s), r.apply(e1);
                                }
                                this.transform.apply(r);
                            }
                            _fireMoveEvents(t1) {
                                this.fire(new e1.k("move", t1)), this._zooming && this.fire(new e1.k("zoom", t1)), this._rotating && this.fire(new e1.k("rotate", t1)), this._pitching && this.fire(new e1.k("pitch", t1));
                            }
                            _afterEase(t1, r) {
                                if (this._easeId && r && this._easeId === r) return;
                                delete this._easeId;
                                const n = this._zooming, i = this._rotating, a = this._pitching;
                                this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._padding = !1, n && this.fire(new e1.k("zoomend", t1)), i && this.fire(new e1.k("rotateend", t1)), a && this.fire(new e1.k("pitchend", t1)), this.fire(new e1.k("moveend", t1));
                            }
                            flyTo(t1, r) {
                                var n;
                                if (!t1.essential && a.prefersReducedMotion) {
                                    const n = e1.M(t1, [
                                        "center",
                                        "zoom",
                                        "bearing",
                                        "pitch",
                                        "around"
                                    ]);
                                    return this.jumpTo(n, r);
                                }
                                this.stop(), t1 = e1.e({
                                    offset: [
                                        0,
                                        0
                                    ],
                                    speed: 1.2,
                                    curve: 1.42,
                                    easing: e1.b9
                                }, t1);
                                const i = this._getTransformForUpdate(), o = i.zoom, s = i.bearing, l = i.pitch, c = i.padding, u = "bearing" in t1 ? this._normalizeBearing(t1.bearing, s) : s, h = "pitch" in t1 ? +t1.pitch : l, f = "padding" in t1 ? t1.padding : i.padding, p = e1.P.convert(t1.offset);
                                let d = i.centerPoint.add(p);
                                const m = i.pointLocation(d), { center: g, zoom: y } = i.getConstrained(e1.N.convert(t1.center || m), null !== (n = t1.zoom) && void 0 !== n ? n : o);
                                this._normalizeCenter(g, i);
                                const v = i.zoomScale(y - o), x = i.project(m), _ = i.project(g).sub(x);
                                let b = t1.curve;
                                const w = Math.max(i.width, i.height), T = w / v, k = _.mag();
                                if ("minZoom" in t1) {
                                    const r = e1.ad(Math.min(t1.minZoom, o, y), i.minZoom, i.maxZoom), n = w / i.zoomScale(r - o);
                                    b = Math.sqrt(n / k * 2);
                                }
                                const A = b * b;
                                function M(t1) {
                                    const e1 = (T * T - w * w + (t1 ? -1 : 1) * A * A * k * k) / (2 * (t1 ? T : w) * A * k);
                                    return Math.log(Math.sqrt(e1 * e1 + 1) - e1);
                                }
                                function S(t1) {
                                    return (Math.exp(t1) - Math.exp(-t1)) / 2;
                                }
                                function E(t1) {
                                    return (Math.exp(t1) + Math.exp(-t1)) / 2;
                                }
                                const C = M(!1);
                                let L = function(t1) {
                                    return E(C) / E(C + b * t1);
                                }, I = function(t1) {
                                    var e1;
                                    return w * ((E(C) * (S(e1 = C + b * t1) / E(e1)) - S(C)) / A) / k;
                                }, P = (M(!0) - C) / b;
                                if (Math.abs(k) < 1e-6 || !isFinite(P)) {
                                    if (Math.abs(w - T) < 1e-6) return this.easeTo(t1, r);
                                    const e1 = T < w ? -1 : 1;
                                    P = Math.abs(Math.log(T / w)) / b, I = ()=>0, L = (t1)=>Math.exp(e1 * b * t1);
                                }
                                if ("duration" in t1) t1.duration = +t1.duration;
                                else {
                                    const e1 = "screenSpeed" in t1 ? +t1.screenSpeed / b : +t1.speed;
                                    t1.duration = 1e3 * P / e1;
                                }
                                return t1.maxDuration && t1.duration > t1.maxDuration && (t1.duration = 0), this._zooming = !0, this._rotating = s !== u, this._pitching = h !== l, this._padding = !i.isPaddingEqual(f), this._prepareEase(r, !1), this.terrain && this._prepareElevation(g), this._ease((n)=>{
                                    const a = n * P, m = 1 / L(a);
                                    i.zoom = 1 === n ? y : o + i.scaleZoom(m), this._rotating && (i.bearing = e1.z.number(s, u, n)), this._pitching && (i.pitch = e1.z.number(l, h, n)), this._padding && (i.interpolatePadding(c, f, n), d = i.centerPoint.add(p)), this.terrain && !t1.freezeElevation && this._updateElevation(n);
                                    const v = 1 === n ? g : i.unproject(x.add(_.mult(I(a))).mult(m));
                                    i.setLocationAtPoint(i.renderWorldCopies ? v.wrap() : v, d), this._applyUpdatedTransform(i), this._fireMoveEvents(r);
                                }, ()=>{
                                    this.terrain && t1.freezeElevation && this._finalizeElevation(), this._afterEase(r);
                                }, t1), this;
                            }
                            isEasing() {
                                return !!this._easeFrameId;
                            }
                            stop() {
                                return this._stop();
                            }
                            _stop(t1, e1) {
                                var r;
                                if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), delete this._easeFrameId, delete this._onEaseFrame), this._onEaseEnd) {
                                    const t1 = this._onEaseEnd;
                                    delete this._onEaseEnd, t1.call(this, e1);
                                }
                                return t1 || null === (r = this.handlers) || void 0 === r || r.stop(!1), this;
                            }
                            _ease(t1, e1, r) {
                                !1 === r.animate || 0 === r.duration ? (t1(1), e1()) : (this._easeStart = a.now(), this._easeOptions = r, this._onEaseFrame = t1, this._onEaseEnd = e1, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
                            }
                            _normalizeBearing(t1, r) {
                                t1 = e1.b3(t1, -180, 180);
                                const n = Math.abs(t1 - r);
                                return Math.abs(t1 - 360 - r) < n && (t1 -= 360), Math.abs(t1 + 360 - r) < n && (t1 += 360), t1;
                            }
                            _normalizeCenter(t1, e1) {
                                if (!e1.renderWorldCopies || e1.lngRange) return;
                                const r = t1.lng - e1.center.lng;
                                t1.lng += r > 180 ? -360 : r < -180 ? 360 : 0;
                            }
                            queryTerrainElevation(t1) {
                                return this.terrain ? this.terrain.getElevationForLngLatZoom(e1.N.convert(t1), this.transform.tileZoom) - this.transform.elevation : null;
                            }
                        }
                        const Ci = {
                            compact: !0,
                            customAttribution: '<a href="https://maplibre.org/" target="_blank">MapLibre</a>'
                        };
                        class Li {
                            constructor(t1 = Ci){
                                this._toggleAttribution = ()=>{
                                    this._container.classList.contains("maplibregl-compact") && (this._container.classList.contains("maplibregl-compact-show") ? (this._container.setAttribute("open", ""), this._container.classList.remove("maplibregl-compact-show")) : (this._container.classList.add("maplibregl-compact-show"), this._container.removeAttribute("open")));
                                }, this._updateData = (t1)=>{
                                    !t1 || "metadata" !== t1.sourceDataType && "visibility" !== t1.sourceDataType && "style" !== t1.dataType && "terrain" !== t1.type || this._updateAttributions();
                                }, this._updateCompact = ()=>{
                                    this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? !1 === this._compact ? this._container.setAttribute("open", "") : this._container.classList.contains("maplibregl-compact") || this._container.classList.contains("maplibregl-attrib-empty") || (this._container.setAttribute("open", ""), this._container.classList.add("maplibregl-compact", "maplibregl-compact-show")) : (this._container.setAttribute("open", ""), this._container.classList.contains("maplibregl-compact") && this._container.classList.remove("maplibregl-compact", "maplibregl-compact-show"));
                                }, this._updateCompactMinimize = ()=>{
                                    this._container.classList.contains("maplibregl-compact") && this._container.classList.contains("maplibregl-compact-show") && this._container.classList.remove("maplibregl-compact-show");
                                }, this.options = t1;
                            }
                            getDefaultPosition() {
                                return "bottom-right";
                            }
                            onAdd(t1) {
                                return this._map = t1, this._compact = this.options.compact, this._container = o.create("details", "maplibregl-ctrl maplibregl-ctrl-attrib"), this._compactButton = o.create("summary", "maplibregl-ctrl-attrib-button", this._container), this._compactButton.addEventListener("click", this._toggleAttribution), this._setElementTitle(this._compactButton, "ToggleAttribution"), this._innerContainer = o.create("div", "maplibregl-ctrl-attrib-inner", this._container), this._updateAttributions(), this._updateCompact(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("terrain", this._updateData), this._map.on("resize", this._updateCompact), this._map.on("drag", this._updateCompactMinimize), this._container;
                            }
                            onRemove() {
                                o.remove(this._container), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("terrain", this._updateData), this._map.off("resize", this._updateCompact), this._map.off("drag", this._updateCompactMinimize), this._map = void 0, this._compact = void 0, this._attribHTML = void 0;
                            }
                            _setElementTitle(t1, e1) {
                                const r = this._map._getUIString(`AttributionControl.${e1}`);
                                t1.title = r, t1.setAttribute("aria-label", r);
                            }
                            _updateAttributions() {
                                if (!this._map.style) return;
                                let t1 = [];
                                if (this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? t1 = t1.concat(this.options.customAttribution.map((t1)=>"string" != typeof t1 ? "" : t1)) : "string" == typeof this.options.customAttribution && t1.push(this.options.customAttribution)), this._map.style.stylesheet) {
                                    const t1 = this._map.style.stylesheet;
                                    this.styleOwner = t1.owner, this.styleId = t1.id;
                                }
                                const e1 = this._map.style.sourceCaches;
                                for(const r in e1){
                                    const n = e1[r];
                                    if (n.used || n.usedForTerrain) {
                                        const e1 = n.getSource();
                                        e1.attribution && t1.indexOf(e1.attribution) < 0 && t1.push(e1.attribution);
                                    }
                                }
                                t1 = t1.filter((t1)=>String(t1).trim()), t1.sort((t1, e1)=>t1.length - e1.length), t1 = t1.filter((e1, r)=>{
                                    for(let n = r + 1; n < t1.length; n++)if (t1[n].indexOf(e1) >= 0) return !1;
                                    return !0;
                                });
                                const r = t1.join(" | ");
                                r !== this._attribHTML && (this._attribHTML = r, t1.length ? (this._innerContainer.innerHTML = r, this._container.classList.remove("maplibregl-attrib-empty")) : this._container.classList.add("maplibregl-attrib-empty"), this._updateCompact(), this._editLink = null);
                            }
                        }
                        class Ii {
                            constructor(t1 = {}){
                                this._updateCompact = ()=>{
                                    const t1 = this._container.children;
                                    if (t1.length) {
                                        const e1 = t1[0];
                                        this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? !1 !== this._compact && e1.classList.add("maplibregl-compact") : e1.classList.remove("maplibregl-compact");
                                    }
                                }, this.options = t1;
                            }
                            getDefaultPosition() {
                                return "bottom-left";
                            }
                            onAdd(t1) {
                                this._map = t1, this._compact = this.options && this.options.compact, this._container = o.create("div", "maplibregl-ctrl");
                                const e1 = o.create("a", "maplibregl-ctrl-logo");
                                return e1.target = "_blank", e1.rel = "noopener nofollow", e1.href = "https://maplibre.org/", e1.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), e1.setAttribute("rel", "noopener nofollow"), this._container.appendChild(e1), this._container.style.display = "block", this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
                            }
                            onRemove() {
                                o.remove(this._container), this._map.off("resize", this._updateCompact), this._map = void 0, this._compact = void 0;
                            }
                        }
                        class Pi {
                            constructor(){
                                this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
                            }
                            add(t1) {
                                const e1 = ++this._id;
                                return this._queue.push({
                                    callback: t1,
                                    id: e1,
                                    cancelled: !1
                                }), e1;
                            }
                            remove(t1) {
                                const e1 = this._currentlyRunning, r = e1 ? this._queue.concat(e1) : this._queue;
                                for (const e1 of r)if (e1.id === t1) return void (e1.cancelled = !0);
                            }
                            run(t1 = 0) {
                                if (this._currentlyRunning) throw new Error("Attempting to run(), but is already running.");
                                const e1 = this._currentlyRunning = this._queue;
                                this._queue = [];
                                for (const r of e1)if (!r.cancelled && (r.callback(t1), this._cleared)) break;
                                this._cleared = !1, this._currentlyRunning = !1;
                            }
                            clear() {
                                this._currentlyRunning && (this._cleared = !0), this._queue = [];
                            }
                        }
                        var zi = e1.Y([
                            {
                                name: "a_pos3d",
                                type: "Int16",
                                components: 3
                            }
                        ]);
                        class Oi extends e1.E {
                            constructor(t1){
                                super(), this.sourceCache = t1, this._tiles = {}, this._renderableTilesKeys = [], this._sourceTileCache = {}, this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.deltaZoom = 1, t1.usedForTerrain = !0, t1.tileSize = this.tileSize * 2 ** this.deltaZoom;
                            }
                            destruct() {
                                this.sourceCache.usedForTerrain = !1, this.sourceCache.tileSize = null;
                            }
                            update(t1, r) {
                                this.sourceCache.update(t1, r), this._renderableTilesKeys = [];
                                const n = {};
                                for (const i of t1.coveringTiles({
                                    tileSize: this.tileSize,
                                    minzoom: this.minzoom,
                                    maxzoom: this.maxzoom,
                                    reparseOverscaled: !1,
                                    terrain: r
                                }))n[i.key] = !0, this._renderableTilesKeys.push(i.key), this._tiles[i.key] || (i.posMatrix = new Float64Array(16), e1.aQ(i.posMatrix, 0, e1.X, 0, e1.X, 0, 1), this._tiles[i.key] = new ht(i, this.tileSize));
                                for(const t1 in this._tiles)n[t1] || delete this._tiles[t1];
                            }
                            freeRtt(t1) {
                                for(const e1 in this._tiles){
                                    const r = this._tiles[e1];
                                    (!t1 || r.tileID.equals(t1) || r.tileID.isChildOf(t1) || t1.isChildOf(r.tileID)) && (r.rtt = []);
                                }
                            }
                            getRenderableTiles() {
                                return this._renderableTilesKeys.map((t1)=>this.getTileByID(t1));
                            }
                            getTileByID(t1) {
                                return this._tiles[t1];
                            }
                            getTerrainCoords(t1) {
                                const r = {};
                                for (const n of this._renderableTilesKeys){
                                    const i = this._tiles[n].tileID;
                                    if (i.canonical.equals(t1.canonical)) {
                                        const i = t1.clone();
                                        i.posMatrix = new Float64Array(16), e1.aQ(i.posMatrix, 0, e1.X, 0, e1.X, 0, 1), r[n] = i;
                                    } else if (i.canonical.isChildOf(t1.canonical)) {
                                        const a = t1.clone();
                                        a.posMatrix = new Float64Array(16);
                                        const o = i.canonical.z - t1.canonical.z, s = i.canonical.x - (i.canonical.x >> o << o), l = i.canonical.y - (i.canonical.y >> o << o), c = e1.X >> o;
                                        e1.aQ(a.posMatrix, 0, c, 0, c, 0, 1), e1.J(a.posMatrix, a.posMatrix, [
                                            -s * c,
                                            -l * c,
                                            0
                                        ]), r[n] = a;
                                    } else if (t1.canonical.isChildOf(i.canonical)) {
                                        const a = t1.clone();
                                        a.posMatrix = new Float64Array(16);
                                        const o = t1.canonical.z - i.canonical.z, s = t1.canonical.x - (t1.canonical.x >> o << o), l = t1.canonical.y - (t1.canonical.y >> o << o), c = e1.X >> o;
                                        e1.aQ(a.posMatrix, 0, e1.X, 0, e1.X, 0, 1), e1.J(a.posMatrix, a.posMatrix, [
                                            s * c,
                                            l * c,
                                            0
                                        ]), e1.K(a.posMatrix, a.posMatrix, [
                                            1 / 2 ** o,
                                            1 / 2 ** o,
                                            0
                                        ]), r[n] = a;
                                    }
                                }
                                return r;
                            }
                            getSourceTile(t1, e1) {
                                const r = this.sourceCache._source;
                                let n = t1.overscaledZ - this.deltaZoom;
                                if (n > r.maxzoom && (n = r.maxzoom), n < r.minzoom) return null;
                                this._sourceTileCache[t1.key] || (this._sourceTileCache[t1.key] = t1.scaledTo(n).key);
                                let i = this.sourceCache.getTileByID(this._sourceTileCache[t1.key]);
                                if ((!i || !i.dem) && e1) for(; n >= r.minzoom && (!i || !i.dem);)i = this.sourceCache.getTileByID(t1.scaledTo(n--).key);
                                return i;
                            }
                            tilesAfterTime(t1 = Date.now()) {
                                return Object.values(this._tiles).filter((e1)=>e1.timeAdded >= t1);
                            }
                        }
                        class Di {
                            constructor(t1, e1, r){
                                this.painter = t1, this.sourceCache = new Oi(e1), this.options = r, this.exaggeration = "number" == typeof r.exaggeration ? r.exaggeration : 1, this.qualityFactor = 2, this.meshSize = 128, this._demMatrixCache = {}, this.coordsIndex = [], this._coordsTextureSize = 1024;
                            }
                            getDEMElevation(t1, r, n, i = e1.X) {
                                var a;
                                if (!(r >= 0 && r < i && n >= 0 && n < i)) return 0;
                                const o = this.getTerrainData(t1), s = null === (a = o.tile) || void 0 === a ? void 0 : a.dem;
                                if (!s) return 0;
                                const l = function(t1, e1, r) {
                                    var n = e1[0], i = e1[1];
                                    return t1[0] = r[0] * n + r[4] * i + r[12], t1[1] = r[1] * n + r[5] * i + r[13], t1;
                                }([], [
                                    r / i * e1.X,
                                    n / i * e1.X
                                ], o.u_terrain_matrix), c = [
                                    l[0] * s.dim,
                                    l[1] * s.dim
                                ], u = Math.floor(c[0]), h = Math.floor(c[1]), f = c[0] - u, p = c[1] - h;
                                return s.get(u, h) * (1 - f) * (1 - p) + s.get(u + 1, h) * f * (1 - p) + s.get(u, h + 1) * (1 - f) * p + s.get(u + 1, h + 1) * f * p;
                            }
                            getElevationForLngLatZoom(t1, r) {
                                const { tileID: n, mercatorX: i, mercatorY: a } = this._getOverscaledTileIDFromLngLatZoom(t1, r);
                                return this.getElevation(n, i % e1.X, a % e1.X, e1.X);
                            }
                            getElevation(t1, r, n, i = e1.X) {
                                return this.getDEMElevation(t1, r, n, i) * this.exaggeration;
                            }
                            getTerrainData(t1) {
                                if (!this._emptyDemTexture) {
                                    const t1 = this.painter.context, r = new e1.R({
                                        width: 1,
                                        height: 1
                                    }, new Uint8Array(4));
                                    this._emptyDepthTexture = new w(t1, r, t1.gl.RGBA, {
                                        premultiply: !1
                                    }), this._emptyDemUnpack = [
                                        0,
                                        0,
                                        0,
                                        0
                                    ], this._emptyDemTexture = new w(t1, new e1.R({
                                        width: 1,
                                        height: 1
                                    }), t1.gl.RGBA, {
                                        premultiply: !1
                                    }), this._emptyDemTexture.bind(t1.gl.NEAREST, t1.gl.CLAMP_TO_EDGE), this._emptyDemMatrix = e1.ao([]);
                                }
                                const r = this.sourceCache.getSourceTile(t1, !0);
                                if (r && r.dem && (!r.demTexture || r.needsTerrainPrepare)) {
                                    const t1 = this.painter.context;
                                    r.demTexture = this.painter.getTileTexture(r.dem.stride), r.demTexture ? r.demTexture.update(r.dem.getPixels(), {
                                        premultiply: !1
                                    }) : r.demTexture = new w(t1, r.dem.getPixels(), t1.gl.RGBA, {
                                        premultiply: !1
                                    }), r.demTexture.bind(t1.gl.NEAREST, t1.gl.CLAMP_TO_EDGE), r.needsTerrainPrepare = !1;
                                }
                                const n = r && r + r.tileID.key + t1.key;
                                if (n && !this._demMatrixCache[n]) {
                                    const n = this.sourceCache.sourceCache._source.maxzoom;
                                    let i = t1.canonical.z - r.tileID.canonical.z;
                                    t1.overscaledZ > t1.canonical.z && (t1.canonical.z >= n ? i = t1.canonical.z - n : e1.w("cannot calculate elevation if elevation maxzoom > source.maxzoom"));
                                    const a = t1.canonical.x - (t1.canonical.x >> i << i), o = t1.canonical.y - (t1.canonical.y >> i << i), s = e1.bb(new Float64Array(16), [
                                        1 / (e1.X << i),
                                        1 / (e1.X << i),
                                        0
                                    ]);
                                    e1.J(s, s, [
                                        a * e1.X,
                                        o * e1.X,
                                        0
                                    ]), this._demMatrixCache[t1.key] = {
                                        matrix: s,
                                        coord: t1
                                    };
                                }
                                return {
                                    u_depth: 2,
                                    u_terrain: 3,
                                    u_terrain_dim: r && r.dem && r.dem.dim || 1,
                                    u_terrain_matrix: n ? this._demMatrixCache[t1.key].matrix : this._emptyDemMatrix,
                                    u_terrain_unpack: r && r.dem && r.dem.getUnpackVector() || this._emptyDemUnpack,
                                    u_terrain_exaggeration: this.exaggeration,
                                    texture: (r && r.demTexture || this._emptyDemTexture).texture,
                                    depthTexture: (this._fboDepthTexture || this._emptyDepthTexture).texture,
                                    tile: r
                                };
                            }
                            getFramebuffer(t1) {
                                const e1 = this.painter, r = e1.width / devicePixelRatio, n = e1.height / devicePixelRatio;
                                return !this._fbo || this._fbo.width === r && this._fbo.height === n || (this._fbo.destroy(), this._fboCoordsTexture.destroy(), this._fboDepthTexture.destroy(), delete this._fbo, delete this._fboDepthTexture, delete this._fboCoordsTexture), this._fboCoordsTexture || (this._fboCoordsTexture = new w(e1.context, {
                                    width: r,
                                    height: n,
                                    data: null
                                }, e1.context.gl.RGBA, {
                                    premultiply: !1
                                }), this._fboCoordsTexture.bind(e1.context.gl.NEAREST, e1.context.gl.CLAMP_TO_EDGE)), this._fboDepthTexture || (this._fboDepthTexture = new w(e1.context, {
                                    width: r,
                                    height: n,
                                    data: null
                                }, e1.context.gl.RGBA, {
                                    premultiply: !1
                                }), this._fboDepthTexture.bind(e1.context.gl.NEAREST, e1.context.gl.CLAMP_TO_EDGE)), this._fbo || (this._fbo = e1.context.createFramebuffer(r, n, !0, !1), this._fbo.depthAttachment.set(e1.context.createRenderbuffer(e1.context.gl.DEPTH_COMPONENT16, r, n))), this._fbo.colorAttachment.set("coords" === t1 ? this._fboCoordsTexture.texture : this._fboDepthTexture.texture), this._fbo;
                            }
                            getCoordsTexture() {
                                const t1 = this.painter.context;
                                if (this._coordsTexture) return this._coordsTexture;
                                const r = new Uint8Array(this._coordsTextureSize * this._coordsTextureSize * 4);
                                for(let t1 = 0, e1 = 0; t1 < this._coordsTextureSize; t1++)for(let n = 0; n < this._coordsTextureSize; n++, e1 += 4)r[e1 + 0] = 255 & n, r[e1 + 1] = 255 & t1, r[e1 + 2] = n >> 8 << 4 | t1 >> 8, r[e1 + 3] = 0;
                                const n = new e1.R({
                                    width: this._coordsTextureSize,
                                    height: this._coordsTextureSize
                                }, new Uint8Array(r.buffer)), i = new w(t1, n, t1.gl.RGBA, {
                                    premultiply: !1
                                });
                                return i.bind(t1.gl.NEAREST, t1.gl.CLAMP_TO_EDGE), this._coordsTexture = i, i;
                            }
                            pointCoordinate(t1) {
                                this.painter.maybeDrawDepthAndCoords(!0);
                                const r = new Uint8Array(4), n = this.painter.context, i = n.gl, a = Math.round(t1.x * this.painter.pixelRatio / devicePixelRatio), o = Math.round(t1.y * this.painter.pixelRatio / devicePixelRatio), s = Math.round(this.painter.height / devicePixelRatio);
                                n.bindFramebuffer.set(this.getFramebuffer("coords").framebuffer), i.readPixels(a, s - o - 1, 1, 1, i.RGBA, i.UNSIGNED_BYTE, r), n.bindFramebuffer.set(null);
                                const l = r[0] + (r[2] >> 4 << 8), c = r[1] + ((15 & r[2]) << 8), u = this.coordsIndex[255 - r[3]], h = u && this.sourceCache.getTileByID(u);
                                if (!h) return null;
                                const f = this._coordsTextureSize, p = (1 << h.tileID.canonical.z) * f;
                                return new e1.Z((h.tileID.canonical.x * f + l) / p + h.tileID.wrap, (h.tileID.canonical.y * f + c) / p, this.getElevation(h.tileID, l, c, f));
                            }
                            depthAtPoint(t1) {
                                const e1 = new Uint8Array(4), r = this.painter.context, n = r.gl;
                                return r.bindFramebuffer.set(this.getFramebuffer("depth").framebuffer), n.readPixels(t1.x, this.painter.height / devicePixelRatio - t1.y - 1, 1, 1, n.RGBA, n.UNSIGNED_BYTE, e1), r.bindFramebuffer.set(null), (e1[0] / 16777216 + e1[1] / 65536 + e1[2] / 256 + e1[3]) / 256;
                            }
                            getTerrainMesh() {
                                if (this._mesh) return this._mesh;
                                const t1 = this.painter.context, r = new e1.bc, n = new e1.aY, i = this.meshSize, a = e1.X / i, o = i * i;
                                for(let t1 = 0; t1 <= i; t1++)for(let e1 = 0; e1 <= i; e1++)r.emplaceBack(e1 * a, t1 * a, 0);
                                for(let t1 = 0; t1 < o; t1 += i + 1)for(let e1 = 0; e1 < i; e1++)n.emplaceBack(e1 + t1, i + e1 + t1 + 1, i + e1 + t1 + 2), n.emplaceBack(e1 + t1, i + e1 + t1 + 2, e1 + t1 + 1);
                                const s = r.length, l = s + 2 * (i + 1);
                                for (const t1 of [
                                    0,
                                    1
                                ])for(let n = 0; n <= i; n++)for (const i of [
                                    0,
                                    1
                                ])r.emplaceBack(n * a, t1 * e1.X, i);
                                for(let t1 = 0; t1 < 2 * i; t1 += 2)n.emplaceBack(l + t1, l + t1 + 1, l + t1 + 3), n.emplaceBack(l + t1, l + t1 + 3, l + t1 + 2), n.emplaceBack(s + t1, s + t1 + 3, s + t1 + 1), n.emplaceBack(s + t1, s + t1 + 2, s + t1 + 3);
                                const c = r.length, u = c + 2 * (i + 1);
                                for (const t1 of [
                                    0,
                                    1
                                ])for(let n = 0; n <= i; n++)for (const i of [
                                    0,
                                    1
                                ])r.emplaceBack(t1 * e1.X, n * a, i);
                                for(let t1 = 0; t1 < 2 * i; t1 += 2)n.emplaceBack(c + t1, c + t1 + 1, c + t1 + 3), n.emplaceBack(c + t1, c + t1 + 3, c + t1 + 2), n.emplaceBack(u + t1, u + t1 + 3, u + t1 + 1), n.emplaceBack(u + t1, u + t1 + 2, u + t1 + 3);
                                return this._mesh = new wn(t1.createVertexBuffer(r, zi.members), t1.createIndexBuffer(n), e1.a0.simpleSegment(0, 0, r.length, n.length)), this._mesh;
                            }
                            getMeshFrameDelta(t1) {
                                return 2 * Math.PI * e1.bd / Math.pow(2, t1) / 5;
                            }
                            getMinTileElevationForLngLatZoom(t1, e1) {
                                var r;
                                const { tileID: n } = this._getOverscaledTileIDFromLngLatZoom(t1, e1);
                                return null !== (r = this.getMinMaxElevation(n).minElevation) && void 0 !== r ? r : 0;
                            }
                            getMinMaxElevation(t1) {
                                const e1 = this.getTerrainData(t1).tile, r = {
                                    minElevation: null,
                                    maxElevation: null
                                };
                                return e1 && e1.dem && (r.minElevation = e1.dem.min * this.exaggeration, r.maxElevation = e1.dem.max * this.exaggeration), r;
                            }
                            _getOverscaledTileIDFromLngLatZoom(t1, r) {
                                const n = e1.Z.fromLngLat(t1.wrap()), i = (1 << r) * e1.X, a = n.x * i, o = n.y * i, s = Math.floor(a / e1.X), l = Math.floor(o / e1.X);
                                return {
                                    tileID: new e1.S(r, 0, r, s, l),
                                    mercatorX: a,
                                    mercatorY: o
                                };
                            }
                        }
                        class Ri {
                            constructor(t1, e1, r){
                                this._context = t1, this._size = e1, this._tileSize = r, this._objects = [], this._recentlyUsed = [], this._stamp = 0;
                            }
                            destruct() {
                                for (const t1 of this._objects)t1.texture.destroy(), t1.fbo.destroy();
                            }
                            _createObject(t1) {
                                const e1 = this._context.createFramebuffer(this._tileSize, this._tileSize, !0, !0), r = new w(this._context, {
                                    width: this._tileSize,
                                    height: this._tileSize,
                                    data: null
                                }, this._context.gl.RGBA);
                                return r.bind(this._context.gl.LINEAR, this._context.gl.CLAMP_TO_EDGE), e1.depthAttachment.set(this._context.createRenderbuffer(this._context.gl.DEPTH_STENCIL, this._tileSize, this._tileSize)), e1.colorAttachment.set(r.texture), {
                                    id: t1,
                                    fbo: e1,
                                    texture: r,
                                    stamp: -1,
                                    inUse: !1
                                };
                            }
                            getObjectForId(t1) {
                                return this._objects[t1];
                            }
                            useObject(t1) {
                                t1.inUse = !0, this._recentlyUsed = this._recentlyUsed.filter((e1)=>t1.id !== e1), this._recentlyUsed.push(t1.id);
                            }
                            stampObject(t1) {
                                t1.stamp = ++this._stamp;
                            }
                            getOrCreateFreeObject() {
                                for (const t1 of this._recentlyUsed)if (!this._objects[t1].inUse) return this._objects[t1];
                                if (this._objects.length >= this._size) throw new Error("No free RenderPool available, call freeAllObjects() required!");
                                const t1 = this._createObject(this._objects.length);
                                return this._objects.push(t1), t1;
                            }
                            freeObject(t1) {
                                t1.inUse = !1;
                            }
                            freeAllObjects() {
                                for (const t1 of this._objects)this.freeObject(t1);
                            }
                            isFull() {
                                return !(this._objects.length < this._size) && !1 === this._objects.some((t1)=>!t1.inUse);
                            }
                        }
                        const Fi = {
                            background: !0,
                            fill: !0,
                            line: !0,
                            raster: !0,
                            hillshade: !0
                        };
                        class Bi {
                            constructor(t1, e1){
                                this.painter = t1, this.terrain = e1, this.pool = new Ri(t1.context, 30, e1.sourceCache.tileSize * e1.qualityFactor);
                            }
                            destruct() {
                                this.pool.destruct();
                            }
                            getTexture(t1) {
                                return this.pool.getObjectForId(t1.rtt[this._stacks.length - 1].id).texture;
                            }
                            prepareForRender(t1, e1) {
                                this._stacks = [], this._prevType = null, this._rttTiles = [], this._renderableTiles = this.terrain.sourceCache.getRenderableTiles(), this._renderableLayerIds = t1._order.filter((r)=>!t1._layers[r].isHidden(e1)), this._coordsDescendingInv = {};
                                for(const e1 in t1.sourceCaches){
                                    this._coordsDescendingInv[e1] = {};
                                    const r = t1.sourceCaches[e1].getVisibleCoordinates();
                                    for (const t1 of r){
                                        const r = this.terrain.sourceCache.getTerrainCoords(t1);
                                        for(const t1 in r)this._coordsDescendingInv[e1][t1] || (this._coordsDescendingInv[e1][t1] = []), this._coordsDescendingInv[e1][t1].push(r[t1]);
                                    }
                                }
                                this._coordsDescendingInvStr = {};
                                for (const e1 of t1._order){
                                    const r = t1._layers[e1], n = r.source;
                                    if (Fi[r.type] && !this._coordsDescendingInvStr[n]) {
                                        this._coordsDescendingInvStr[n] = {};
                                        for(const t1 in this._coordsDescendingInv[n])this._coordsDescendingInvStr[n][t1] = this._coordsDescendingInv[n][t1].map((t1)=>t1.key).sort().join();
                                    }
                                }
                                for (const t1 of this._renderableTiles)for(const e1 in this._coordsDescendingInvStr){
                                    const r = this._coordsDescendingInvStr[e1][t1.tileID.key];
                                    r && r !== t1.rttCoords[e1] && (t1.rtt = []);
                                }
                            }
                            renderLayer(t1) {
                                if (t1.isHidden(this.painter.transform.zoom)) return !1;
                                const r = t1.type, n = this.painter, i = this._renderableLayerIds[this._renderableLayerIds.length - 1] === t1.id;
                                if (Fi[r] && (this._prevType && Fi[this._prevType] || this._stacks.push([]), this._prevType = r, this._stacks[this._stacks.length - 1].push(t1.id), !i)) return !0;
                                if (Fi[this._prevType] || Fi[r] && i) {
                                    this._prevType = r;
                                    const t1 = this._stacks.length - 1, i = this._stacks[t1] || [];
                                    for (const r of this._renderableTiles){
                                        if (this.pool.isFull() && (bn(this.painter, this.terrain, this._rttTiles), this._rttTiles = [], this.pool.freeAllObjects()), this._rttTiles.push(r), r.rtt[t1]) {
                                            const e1 = this.pool.getObjectForId(r.rtt[t1].id);
                                            if (e1.stamp === r.rtt[t1].stamp) {
                                                this.pool.useObject(e1);
                                                continue;
                                            }
                                        }
                                        const a = this.pool.getOrCreateFreeObject();
                                        this.pool.useObject(a), this.pool.stampObject(a), r.rtt[t1] = {
                                            id: a.id,
                                            stamp: a.stamp
                                        }, n.context.bindFramebuffer.set(a.fbo.framebuffer), n.context.clear({
                                            color: e1.aN.transparent,
                                            stencil: 0
                                        }), n.currentStencilSource = void 0;
                                        for(let t1 = 0; t1 < i.length; t1++){
                                            const e1 = n.style._layers[i[t1]], o = e1.source ? this._coordsDescendingInv[e1.source][r.tileID.key] : [
                                                r.tileID
                                            ];
                                            n.context.viewport.set([
                                                0,
                                                0,
                                                a.fbo.width,
                                                a.fbo.height
                                            ]), n._renderTileClippingMasks(e1, o), n.renderLayer(n, n.style.sourceCaches[e1.source], e1, o), e1.source && (r.rttCoords[e1.source] = this._coordsDescendingInvStr[e1.source][r.tileID.key]);
                                        }
                                    }
                                    return bn(this.painter, this.terrain, this._rttTiles), this._rttTiles = [], this.pool.freeAllObjects(), Fi[r];
                                }
                                return !1;
                            }
                        }
                        const Ni = {
                            "AttributionControl.ToggleAttribution": "Toggle attribution",
                            "AttributionControl.MapFeedback": "Map feedback",
                            "FullscreenControl.Enter": "Enter fullscreen",
                            "FullscreenControl.Exit": "Exit fullscreen",
                            "GeolocateControl.FindMyLocation": "Find my location",
                            "GeolocateControl.LocationNotAvailable": "Location not available",
                            "LogoControl.Title": "MapLibre logo",
                            "Map.Title": "Map",
                            "Marker.Title": "Map marker",
                            "NavigationControl.ResetBearing": "Reset bearing to north",
                            "NavigationControl.ZoomIn": "Zoom in",
                            "NavigationControl.ZoomOut": "Zoom out",
                            "Popup.Close": "Close popup",
                            "ScaleControl.Feet": "ft",
                            "ScaleControl.Meters": "m",
                            "ScaleControl.Kilometers": "km",
                            "ScaleControl.Miles": "mi",
                            "ScaleControl.NauticalMiles": "nm",
                            "TerrainControl.Enable": "Enable terrain",
                            "TerrainControl.Disable": "Disable terrain",
                            "CooperativeGesturesHandler.WindowsHelpText": "Use Ctrl + scroll to zoom the map",
                            "CooperativeGesturesHandler.MacHelpText": "Use \u2318 + scroll to zoom the map",
                            "CooperativeGesturesHandler.MobileHelpText": "Use two fingers to move the map"
                        }, ji = r, Ui = {
                            hash: !1,
                            interactive: !0,
                            bearingSnap: 7,
                            attributionControl: Ci,
                            maplibreLogo: !1,
                            failIfMajorPerformanceCaveat: !1,
                            preserveDrawingBuffer: !1,
                            refreshExpiredTiles: !0,
                            scrollZoom: !0,
                            minZoom: -2,
                            maxZoom: 22,
                            minPitch: 0,
                            maxPitch: 60,
                            boxZoom: !0,
                            dragRotate: !0,
                            dragPan: !0,
                            keyboard: !0,
                            doubleClickZoom: !0,
                            touchZoomRotate: !0,
                            touchPitch: !0,
                            cooperativeGestures: !1,
                            trackResize: !0,
                            center: [
                                0,
                                0
                            ],
                            zoom: 0,
                            bearing: 0,
                            pitch: 0,
                            renderWorldCopies: !0,
                            maxTileCacheSize: null,
                            maxTileCacheZoomLevels: e1.a.MAX_TILE_CACHE_ZOOM_LEVELS,
                            transformRequest: null,
                            transformCameraUpdate: null,
                            fadeDuration: 300,
                            crossSourceCollisions: !0,
                            clickTolerance: 3,
                            localIdeographFontFamily: "sans-serif",
                            pitchWithRotate: !0,
                            validateStyle: !0,
                            maxCanvasSize: [
                                4096,
                                4096
                            ],
                            cancelPendingTileRequestsWhileZooming: !0
                        };
                        const Vi = (t1)=>{
                            t1.touchstart = t1.dragStart, t1.touchmoveWindow = t1.dragMove, t1.touchend = t1.dragEnd;
                        }, qi = {
                            showCompass: !0,
                            showZoom: !0,
                            visualizePitch: !1
                        };
                        class Hi {
                            constructor(t1, r, n = !1){
                                this.mousedown = (t1)=>{
                                    this.startMouse(e1.e({}, t1, {
                                        ctrlKey: !0,
                                        preventDefault: ()=>t1.preventDefault()
                                    }), o.mousePos(this.element, t1)), o.addEventListener(window, "mousemove", this.mousemove), o.addEventListener(window, "mouseup", this.mouseup);
                                }, this.mousemove = (t1)=>{
                                    this.moveMouse(t1, o.mousePos(this.element, t1));
                                }, this.mouseup = (t1)=>{
                                    this.mouseRotate.dragEnd(t1), this.mousePitch && this.mousePitch.dragEnd(t1), this.offTemp();
                                }, this.touchstart = (t1)=>{
                                    1 !== t1.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = o.touchPos(this.element, t1.targetTouches)[0], this.startTouch(t1, this._startPos), o.addEventListener(window, "touchmove", this.touchmove, {
                                        passive: !1
                                    }), o.addEventListener(window, "touchend", this.touchend));
                                }, this.touchmove = (t1)=>{
                                    1 !== t1.targetTouches.length ? this.reset() : (this._lastPos = o.touchPos(this.element, t1.targetTouches)[0], this.moveTouch(t1, this._lastPos));
                                }, this.touchend = (t1)=>{
                                    0 === t1.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), delete this._startPos, delete this._lastPos, this.offTemp();
                                }, this.reset = ()=>{
                                    this.mouseRotate.reset(), this.mousePitch && this.mousePitch.reset(), this.touchRotate.reset(), this.touchPitch && this.touchPitch.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
                                }, this._clickTolerance = 10;
                                const i = t1.dragRotate._mouseRotate.getClickTolerance(), a = t1.dragRotate._mousePitch.getClickTolerance();
                                this.element = r, this.mouseRotate = ei({
                                    clickTolerance: i,
                                    enable: !0
                                }), this.touchRotate = (({ enable: t1, clickTolerance: e1, bearingDegreesPerPixelMoved: r = .8 })=>{
                                    const n = new Qn;
                                    return new $n({
                                        clickTolerance: e1,
                                        move: (t1, e1)=>({
                                                bearingDelta: (e1.x - t1.x) * r
                                            }),
                                        moveStateManager: n,
                                        enable: t1,
                                        assignEvents: Vi
                                    });
                                })({
                                    clickTolerance: i,
                                    enable: !0
                                }), this.map = t1, n && (this.mousePitch = ri({
                                    clickTolerance: a,
                                    enable: !0
                                }), this.touchPitch = (({ enable: t1, clickTolerance: e1, pitchDegreesPerPixelMoved: r = -0.5 })=>{
                                    const n = new Qn;
                                    return new $n({
                                        clickTolerance: e1,
                                        move: (t1, e1)=>({
                                                pitchDelta: (e1.y - t1.y) * r
                                            }),
                                        moveStateManager: n,
                                        enable: t1,
                                        assignEvents: Vi
                                    });
                                })({
                                    clickTolerance: a,
                                    enable: !0
                                })), o.addEventListener(r, "mousedown", this.mousedown), o.addEventListener(r, "touchstart", this.touchstart, {
                                    passive: !1
                                }), o.addEventListener(r, "touchcancel", this.reset);
                            }
                            startMouse(t1, e1) {
                                this.mouseRotate.dragStart(t1, e1), this.mousePitch && this.mousePitch.dragStart(t1, e1), o.disableDrag();
                            }
                            startTouch(t1, e1) {
                                this.touchRotate.dragStart(t1, e1), this.touchPitch && this.touchPitch.dragStart(t1, e1), o.disableDrag();
                            }
                            moveMouse(t1, e1) {
                                const r = this.map, { bearingDelta: n } = this.mouseRotate.dragMove(t1, e1) || {};
                                if (n && r.setBearing(r.getBearing() + n), this.mousePitch) {
                                    const { pitchDelta: n } = this.mousePitch.dragMove(t1, e1) || {};
                                    n && r.setPitch(r.getPitch() + n);
                                }
                            }
                            moveTouch(t1, e1) {
                                const r = this.map, { bearingDelta: n } = this.touchRotate.dragMove(t1, e1) || {};
                                if (n && r.setBearing(r.getBearing() + n), this.touchPitch) {
                                    const { pitchDelta: n } = this.touchPitch.dragMove(t1, e1) || {};
                                    n && r.setPitch(r.getPitch() + n);
                                }
                            }
                            off() {
                                const t1 = this.element;
                                o.removeEventListener(t1, "mousedown", this.mousedown), o.removeEventListener(t1, "touchstart", this.touchstart, {
                                    passive: !1
                                }), o.removeEventListener(window, "touchmove", this.touchmove, {
                                    passive: !1
                                }), o.removeEventListener(window, "touchend", this.touchend), o.removeEventListener(t1, "touchcancel", this.reset), this.offTemp();
                            }
                            offTemp() {
                                o.enableDrag(), o.removeEventListener(window, "mousemove", this.mousemove), o.removeEventListener(window, "mouseup", this.mouseup), o.removeEventListener(window, "touchmove", this.touchmove, {
                                    passive: !1
                                }), o.removeEventListener(window, "touchend", this.touchend);
                            }
                        }
                        let Gi;
                        function Zi(t1, r, n) {
                            const i = new e1.N(t1.lng, t1.lat);
                            if (t1 = new e1.N(t1.lng, t1.lat), r) {
                                const i = new e1.N(t1.lng - 360, t1.lat), a = new e1.N(t1.lng + 360, t1.lat), o = n.locationPoint(t1).distSqr(r);
                                n.locationPoint(i).distSqr(r) < o ? t1 = i : n.locationPoint(a).distSqr(r) < o && (t1 = a);
                            }
                            for(; Math.abs(t1.lng - n.center.lng) > 180;){
                                const e1 = n.locationPoint(t1);
                                if (e1.x >= 0 && e1.y >= 0 && e1.x <= n.width && e1.y <= n.height) break;
                                t1.lng > n.center.lng ? t1.lng -= 360 : t1.lng += 360;
                            }
                            return t1.lng !== i.lng && n.locationPoint(t1).y > n.height / 2 - n.getHorizon() ? t1 : i;
                        }
                        const Wi = {
                            center: "translate(-50%,-50%)",
                            top: "translate(-50%,0)",
                            "top-left": "translate(0,0)",
                            "top-right": "translate(-100%,0)",
                            bottom: "translate(-50%,-100%)",
                            "bottom-left": "translate(0,-100%)",
                            "bottom-right": "translate(-100%,-100%)",
                            left: "translate(0,-50%)",
                            right: "translate(-100%,-50%)"
                        };
                        function Yi(t1, e1, r) {
                            const n = t1.classList;
                            for(const t1 in Wi)n.remove(`maplibregl-${r}-anchor-${t1}`);
                            n.add(`maplibregl-${r}-anchor-${e1}`);
                        }
                        class Xi extends e1.E {
                            constructor(t1){
                                if (super(), this._onKeyPress = (t1)=>{
                                    const e1 = t1.code, r = t1.charCode || t1.keyCode;
                                    "Space" !== e1 && "Enter" !== e1 && 32 !== r && 13 !== r || this.togglePopup();
                                }, this._onMapClick = (t1)=>{
                                    const e1 = t1.originalEvent.target, r = this._element;
                                    this._popup && (e1 === r || r.contains(e1)) && this.togglePopup();
                                }, this._update = (t1)=>{
                                    var e1;
                                    if (!this._map) return;
                                    const r = this._map.loaded() && !this._map.isMoving();
                                    ("terrain" === (null == t1 ? void 0 : t1.type) || "render" === (null == t1 ? void 0 : t1.type) && !r) && this._map.once("render", this._update), this._map.transform.renderWorldCopies ? this._lngLat = Zi(this._lngLat, this._flatPos, this._map.transform) : this._lngLat = null === (e1 = this._lngLat) || void 0 === e1 ? void 0 : e1.wrap(), this._flatPos = this._pos = this._map.project(this._lngLat)._add(this._offset), this._map.terrain && (this._flatPos = this._map.transform.locationPoint(this._lngLat)._add(this._offset));
                                    let n = "";
                                    "viewport" === this._rotationAlignment || "auto" === this._rotationAlignment ? n = `rotateZ(${this._rotation}deg)` : "map" === this._rotationAlignment && (n = `rotateZ(${this._rotation - this._map.getBearing()}deg)`);
                                    let i = "";
                                    "viewport" === this._pitchAlignment || "auto" === this._pitchAlignment ? i = "rotateX(0deg)" : "map" === this._pitchAlignment && (i = `rotateX(${this._map.getPitch()}deg)`), this._subpixelPositioning || t1 && "moveend" !== t1.type || (this._pos = this._pos.round()), o.setTransform(this._element, `${Wi[this._anchor]} translate(${this._pos.x}px, ${this._pos.y}px) ${i} ${n}`), a.frameAsync(new AbortController).then(()=>{
                                        this._updateOpacity(t1 && "moveend" === t1.type);
                                    }).catch(()=>{});
                                }, this._onMove = (t1)=>{
                                    if (!this._isDragging) {
                                        const e1 = this._clickTolerance || this._map._clickTolerance;
                                        this._isDragging = t1.point.dist(this._pointerdownPos) >= e1;
                                    }
                                    this._isDragging && (this._pos = t1.point.sub(this._positionDelta), this._lngLat = this._map.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new e1.k("dragstart"))), this.fire(new e1.k("drag")));
                                }, this._onUp = ()=>{
                                    this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1, this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), "active" === this._state && this.fire(new e1.k("dragend")), this._state = "inactive";
                                }, this._addDragHandler = (t1)=>{
                                    this._element.contains(t1.originalEvent.target) && (t1.preventDefault(), this._positionDelta = t1.point.sub(this._pos).add(this._offset), this._pointerdownPos = t1.point, this._state = "pending", this._map.on("mousemove", this._onMove), this._map.on("touchmove", this._onMove), this._map.once("mouseup", this._onUp), this._map.once("touchend", this._onUp));
                                }, this._anchor = t1 && t1.anchor || "center", this._color = t1 && t1.color || "#3FB1CE", this._scale = t1 && t1.scale || 1, this._draggable = t1 && t1.draggable || !1, this._clickTolerance = t1 && t1.clickTolerance || 0, this._subpixelPositioning = t1 && t1.subpixelPositioning || !1, this._isDragging = !1, this._state = "inactive", this._rotation = t1 && t1.rotation || 0, this._rotationAlignment = t1 && t1.rotationAlignment || "auto", this._pitchAlignment = t1 && t1.pitchAlignment && "auto" !== t1.pitchAlignment ? t1.pitchAlignment : this._rotationAlignment, this.setOpacity(), this.setOpacity(null == t1 ? void 0 : t1.opacity, null == t1 ? void 0 : t1.opacityWhenCovered), t1 && t1.element) this._element = t1.element, this._offset = e1.P.convert(t1 && t1.offset || [
                                    0,
                                    0
                                ]);
                                else {
                                    this._defaultMarker = !0, this._element = o.create("div");
                                    const r = o.createNS("http://www.w3.org/2000/svg", "svg"), n = 41, i = 27;
                                    r.setAttributeNS(null, "display", "block"), r.setAttributeNS(null, "height", `${n}px`), r.setAttributeNS(null, "width", `${i}px`), r.setAttributeNS(null, "viewBox", `0 0 ${i} ${n}`);
                                    const a = o.createNS("http://www.w3.org/2000/svg", "g");
                                    a.setAttributeNS(null, "stroke", "none"), a.setAttributeNS(null, "stroke-width", "1"), a.setAttributeNS(null, "fill", "none"), a.setAttributeNS(null, "fill-rule", "evenodd");
                                    const s = o.createNS("http://www.w3.org/2000/svg", "g");
                                    s.setAttributeNS(null, "fill-rule", "nonzero");
                                    const l = o.createNS("http://www.w3.org/2000/svg", "g");
                                    l.setAttributeNS(null, "transform", "translate(3.0, 29.0)"), l.setAttributeNS(null, "fill", "#000000");
                                    const c = [
                                        {
                                            rx: "10.5",
                                            ry: "5.25002273"
                                        },
                                        {
                                            rx: "10.5",
                                            ry: "5.25002273"
                                        },
                                        {
                                            rx: "9.5",
                                            ry: "4.77275007"
                                        },
                                        {
                                            rx: "8.5",
                                            ry: "4.29549936"
                                        },
                                        {
                                            rx: "7.5",
                                            ry: "3.81822308"
                                        },
                                        {
                                            rx: "6.5",
                                            ry: "3.34094679"
                                        },
                                        {
                                            rx: "5.5",
                                            ry: "2.86367051"
                                        },
                                        {
                                            rx: "4.5",
                                            ry: "2.38636864"
                                        }
                                    ];
                                    for (const t1 of c){
                                        const e1 = o.createNS("http://www.w3.org/2000/svg", "ellipse");
                                        e1.setAttributeNS(null, "opacity", "0.04"), e1.setAttributeNS(null, "cx", "10.5"), e1.setAttributeNS(null, "cy", "5.80029008"), e1.setAttributeNS(null, "rx", t1.rx), e1.setAttributeNS(null, "ry", t1.ry), l.appendChild(e1);
                                    }
                                    const u = o.createNS("http://www.w3.org/2000/svg", "g");
                                    u.setAttributeNS(null, "fill", this._color);
                                    const h = o.createNS("http://www.w3.org/2000/svg", "path");
                                    h.setAttributeNS(null, "d", "M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"), u.appendChild(h);
                                    const f = o.createNS("http://www.w3.org/2000/svg", "g");
                                    f.setAttributeNS(null, "opacity", "0.25"), f.setAttributeNS(null, "fill", "#000000");
                                    const p = o.createNS("http://www.w3.org/2000/svg", "path");
                                    p.setAttributeNS(null, "d", "M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"), f.appendChild(p);
                                    const d = o.createNS("http://www.w3.org/2000/svg", "g");
                                    d.setAttributeNS(null, "transform", "translate(6.0, 7.0)"), d.setAttributeNS(null, "fill", "#FFFFFF");
                                    const m = o.createNS("http://www.w3.org/2000/svg", "g");
                                    m.setAttributeNS(null, "transform", "translate(8.0, 8.0)");
                                    const g = o.createNS("http://www.w3.org/2000/svg", "circle");
                                    g.setAttributeNS(null, "fill", "#000000"), g.setAttributeNS(null, "opacity", "0.25"), g.setAttributeNS(null, "cx", "5.5"), g.setAttributeNS(null, "cy", "5.5"), g.setAttributeNS(null, "r", "5.4999962");
                                    const y = o.createNS("http://www.w3.org/2000/svg", "circle");
                                    y.setAttributeNS(null, "fill", "#FFFFFF"), y.setAttributeNS(null, "cx", "5.5"), y.setAttributeNS(null, "cy", "5.5"), y.setAttributeNS(null, "r", "5.4999962"), m.appendChild(g), m.appendChild(y), s.appendChild(l), s.appendChild(u), s.appendChild(f), s.appendChild(d), s.appendChild(m), r.appendChild(s), r.setAttributeNS(null, "height", n * this._scale + "px"), r.setAttributeNS(null, "width", i * this._scale + "px"), this._element.appendChild(r), this._offset = e1.P.convert(t1 && t1.offset || [
                                        0,
                                        -14
                                    ]);
                                }
                                if (this._element.classList.add("maplibregl-marker"), this._element.addEventListener("dragstart", (t1)=>{
                                    t1.preventDefault();
                                }), this._element.addEventListener("mousedown", (t1)=>{
                                    t1.preventDefault();
                                }), Yi(this._element, this._anchor, "marker"), t1 && t1.className) for (const e1 of t1.className.split(" "))this._element.classList.add(e1);
                                this._popup = null;
                            }
                            addTo(t1) {
                                return this.remove(), this._map = t1, this._element.setAttribute("aria-label", t1._getUIString("Marker.Title")), t1.getCanvasContainer().appendChild(this._element), t1.on("move", this._update), t1.on("moveend", this._update), t1.on("terrain", this._update), this.setDraggable(this._draggable), this._update(), this._map.on("click", this._onMapClick), this;
                            }
                            remove() {
                                return this._opacityTimeout && (clearTimeout(this._opacityTimeout), delete this._opacityTimeout), this._map && (this._map.off("click", this._onMapClick), this._map.off("move", this._update), this._map.off("moveend", this._update), this._map.off("terrain", this._update), this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler), this._map.off("mouseup", this._onUp), this._map.off("touchend", this._onUp), this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), delete this._map), o.remove(this._element), this._popup && this._popup.remove(), this;
                            }
                            getLngLat() {
                                return this._lngLat;
                            }
                            setLngLat(t1) {
                                return this._lngLat = e1.N.convert(t1), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(), this;
                            }
                            getElement() {
                                return this._element;
                            }
                            setPopup(t1) {
                                if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), t1) {
                                    if (!("offset" in t1.options)) {
                                        const e1 = 38.1, r = 13.5, n = Math.abs(r) / Math.SQRT2;
                                        t1.options.offset = this._defaultMarker ? {
                                            top: [
                                                0,
                                                0
                                            ],
                                            "top-left": [
                                                0,
                                                0
                                            ],
                                            "top-right": [
                                                0,
                                                0
                                            ],
                                            bottom: [
                                                0,
                                                -e1
                                            ],
                                            "bottom-left": [
                                                n,
                                                -1 * (e1 - r + n)
                                            ],
                                            "bottom-right": [
                                                -n,
                                                -1 * (e1 - r + n)
                                            ],
                                            left: [
                                                r,
                                                -1 * (e1 - r)
                                            ],
                                            right: [
                                                -r,
                                                -1 * (e1 - r)
                                            ]
                                        } : this._offset;
                                    }
                                    this._popup = t1, this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress);
                                }
                                return this;
                            }
                            setSubpixelPositioning(t1) {
                                return this._subpixelPositioning = t1, this;
                            }
                            getPopup() {
                                return this._popup;
                            }
                            togglePopup() {
                                const t1 = this._popup;
                                return this._element.style.opacity === this._opacityWhenCovered ? this : t1 ? (t1.isOpen() ? t1.remove() : (t1.setLngLat(this._lngLat), t1.addTo(this._map)), this) : this;
                            }
                            _updateOpacity(t1 = !1) {
                                var r, n;
                                if (!(null === (r = this._map) || void 0 === r ? void 0 : r.terrain)) return void (this._element.style.opacity !== this._opacity && (this._element.style.opacity = this._opacity));
                                if (t1) this._opacityTimeout = null;
                                else {
                                    if (this._opacityTimeout) return;
                                    this._opacityTimeout = setTimeout(()=>{
                                        this._opacityTimeout = null;
                                    }, 100);
                                }
                                const i = this._map, a = i.terrain.depthAtPoint(this._pos), o = i.terrain.getElevationForLngLatZoom(this._lngLat, i.transform.tileZoom);
                                if (i.transform.lngLatToCameraDepth(this._lngLat, o) - a < .006) return void (this._element.style.opacity = this._opacity);
                                const s = -this._offset.y / i.transform._pixelPerMeter, l = Math.sin(i.getPitch() * Math.PI / 180) * s, c = i.terrain.depthAtPoint(new e1.P(this._pos.x, this._pos.y - this._offset.y)), u = i.transform.lngLatToCameraDepth(this._lngLat, o + l) - c > .006;
                                (null === (n = this._popup) || void 0 === n ? void 0 : n.isOpen()) && u && this._popup.remove(), this._element.style.opacity = u ? this._opacityWhenCovered : this._opacity;
                            }
                            getOffset() {
                                return this._offset;
                            }
                            setOffset(t1) {
                                return this._offset = e1.P.convert(t1), this._update(), this;
                            }
                            addClassName(t1) {
                                this._element.classList.add(t1);
                            }
                            removeClassName(t1) {
                                this._element.classList.remove(t1);
                            }
                            toggleClassName(t1) {
                                return this._element.classList.toggle(t1);
                            }
                            setDraggable(t1) {
                                return this._draggable = !!t1, this._map && (t1 ? (this._map.on("mousedown", this._addDragHandler), this._map.on("touchstart", this._addDragHandler)) : (this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler))), this;
                            }
                            isDraggable() {
                                return this._draggable;
                            }
                            setRotation(t1) {
                                return this._rotation = t1 || 0, this._update(), this;
                            }
                            getRotation() {
                                return this._rotation;
                            }
                            setRotationAlignment(t1) {
                                return this._rotationAlignment = t1 || "auto", this._update(), this;
                            }
                            getRotationAlignment() {
                                return this._rotationAlignment;
                            }
                            setPitchAlignment(t1) {
                                return this._pitchAlignment = t1 && "auto" !== t1 ? t1 : this._rotationAlignment, this._update(), this;
                            }
                            getPitchAlignment() {
                                return this._pitchAlignment;
                            }
                            setOpacity(t1, e1) {
                                return void 0 === t1 && void 0 === e1 && (this._opacity = "1", this._opacityWhenCovered = "0.2"), void 0 !== t1 && (this._opacity = t1), void 0 !== e1 && (this._opacityWhenCovered = e1), this._map && this._updateOpacity(!0), this;
                            }
                        }
                        const $i = {
                            positionOptions: {
                                enableHighAccuracy: !1,
                                maximumAge: 0,
                                timeout: 6e3
                            },
                            fitBoundsOptions: {
                                maxZoom: 15
                            },
                            trackUserLocation: !1,
                            showAccuracyCircle: !0,
                            showUserLocation: !0
                        };
                        let Ji = 0, Ki = !1;
                        class Qi extends e1.E {
                            constructor(t1){
                                super(), this._onSuccess = (t1)=>{
                                    if (this._map) {
                                        if (this._isOutOfMapMaxBounds(t1)) return this._setErrorState(), this.fire(new e1.k("outofmaxbounds", t1)), this._updateMarker(), void this._finish();
                                        if (this.options.trackUserLocation) switch(this._lastKnownPosition = t1, this._watchState){
                                            case "WAITING_ACTIVE":
                                            case "ACTIVE_LOCK":
                                            case "ACTIVE_ERROR":
                                                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                                                break;
                                            case "BACKGROUND":
                                            case "BACKGROUND_ERROR":
                                                this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background");
                                                break;
                                            default:
                                                throw new Error(`Unexpected watchState ${this._watchState}`);
                                        }
                                        this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(t1), this.options.trackUserLocation && "ACTIVE_LOCK" !== this._watchState || this._updateCamera(t1), this.options.showUserLocation && this._dotElement.classList.remove("maplibregl-user-location-dot-stale"), this.fire(new e1.k("geolocate", t1)), this._finish();
                                    }
                                }, this._updateCamera = (t1)=>{
                                    const r = new e1.N(t1.coords.longitude, t1.coords.latitude), n = t1.coords.accuracy, i = this._map.getBearing(), a = e1.e({
                                        bearing: i
                                    }, this.options.fitBoundsOptions), o = X.fromLngLat(r, n);
                                    this._map.fitBounds(o, a, {
                                        geolocateSource: !0
                                    });
                                }, this._updateMarker = (t1)=>{
                                    if (t1) {
                                        const r = new e1.N(t1.coords.longitude, t1.coords.latitude);
                                        this._accuracyCircleMarker.setLngLat(r).addTo(this._map), this._userLocationDotMarker.setLngLat(r).addTo(this._map), this._accuracy = t1.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                                    } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
                                }, this._onZoom = ()=>{
                                    this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                                }, this._onError = (t1)=>{
                                    if (this._map) {
                                        if (this.options.trackUserLocation) {
                                            if (1 === t1.code) {
                                                this._watchState = "OFF", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = !0;
                                                const t1 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                                                this._geolocateButton.title = t1, this._geolocateButton.setAttribute("aria-label", t1), void 0 !== this._geolocationWatchID && this._clearWatch();
                                            } else {
                                                if (3 === t1.code && Ki) return;
                                                this._setErrorState();
                                            }
                                        }
                                        "OFF" !== this._watchState && this.options.showUserLocation && this._dotElement.classList.add("maplibregl-user-location-dot-stale"), this.fire(new e1.k("error", t1)), this._finish();
                                    }
                                }, this._finish = ()=>{
                                    this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
                                }, this._setupUI = ()=>{
                                    this._map && (this._container.addEventListener("contextmenu", (t1)=>t1.preventDefault()), this._geolocateButton = o.create("button", "maplibregl-ctrl-geolocate", this._container), o.create("span", "maplibregl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", "true"), this._geolocateButton.type = "button", this._geolocateButton.disabled = !0);
                                }, this._finishSetupUI = (t1)=>{
                                    if (this._map) {
                                        if (!1 === t1) {
                                            e1.w("Geolocation support is not available so the GeolocateControl will be disabled.");
                                            const t1 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                                            this._geolocateButton.disabled = !0, this._geolocateButton.title = t1, this._geolocateButton.setAttribute("aria-label", t1);
                                        } else {
                                            const t1 = this._map._getUIString("GeolocateControl.FindMyLocation");
                                            this._geolocateButton.disabled = !1, this._geolocateButton.title = t1, this._geolocateButton.setAttribute("aria-label", t1);
                                        }
                                        this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = o.create("div", "maplibregl-user-location-dot"), this._userLocationDotMarker = new Xi({
                                            element: this._dotElement
                                        }), this._circleElement = o.create("div", "maplibregl-user-location-accuracy-circle"), this._accuracyCircleMarker = new Xi({
                                            element: this._circleElement,
                                            pitchAlignment: "map"
                                        }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", ()=>this.trigger()), this._setup = !0, this.options.trackUserLocation && this._map.on("movestart", (t1)=>{
                                            const r = t1.originalEvent && "resize" === t1.originalEvent.type;
                                            t1.geolocateSource || "ACTIVE_LOCK" !== this._watchState || r || (this._watchState = "BACKGROUND", this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this.fire(new e1.k("trackuserlocationend")), this.fire(new e1.k("userlocationlostfocus")));
                                        });
                                    }
                                }, this.options = e1.e({}, $i, t1);
                            }
                            onAdd(t1) {
                                return this._map = t1, this._container = o.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._setupUI(), (function() {
                                    return e1._(this, arguments, void 0, function*(t1 = !1) {
                                        if (void 0 !== Gi && !t1) return Gi;
                                        if (void 0 === window.navigator.permissions) return Gi = !!window.navigator.geolocation, Gi;
                                        try {
                                            const t1 = yield window.navigator.permissions.query({
                                                name: "geolocation"
                                            });
                                            Gi = "denied" !== t1.state;
                                        } catch (t1) {
                                            Gi = !!window.navigator.geolocation;
                                        }
                                        return Gi;
                                    });
                                })().then((t1)=>this._finishSetupUI(t1)), this._container;
                            }
                            onRemove() {
                                void 0 !== this._geolocationWatchID && (window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), o.remove(this._container), this._map.off("zoom", this._onZoom), this._map = void 0, Ji = 0, Ki = !1;
                            }
                            _isOutOfMapMaxBounds(t1) {
                                const e1 = this._map.getMaxBounds(), r = t1.coords;
                                return e1 && (r.longitude < e1.getWest() || r.longitude > e1.getEast() || r.latitude < e1.getSouth() || r.latitude > e1.getNorth());
                            }
                            _setErrorState() {
                                switch(this._watchState){
                                    case "WAITING_ACTIVE":
                                        this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error");
                                        break;
                                    case "ACTIVE_LOCK":
                                        this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting");
                                        break;
                                    case "BACKGROUND":
                                        this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting");
                                        break;
                                    case "ACTIVE_ERROR":
                                        break;
                                    default:
                                        throw new Error(`Unexpected watchState ${this._watchState}`);
                                }
                            }
                            _updateCircleRadius() {
                                const t1 = this._map.getBounds(), e1 = t1.getSouthEast(), r = t1.getNorthEast(), n = e1.distanceTo(r), i = this._map._container.clientHeight, a = Math.ceil(this._accuracy / (n / i) * 2);
                                this._circleElement.style.width = `${a}px`, this._circleElement.style.height = `${a}px`;
                            }
                            trigger() {
                                if (!this._setup) return e1.w("Geolocate control triggered before added to a map"), !1;
                                if (this.options.trackUserLocation) {
                                    switch(this._watchState){
                                        case "OFF":
                                            this._watchState = "WAITING_ACTIVE", this.fire(new e1.k("trackuserlocationstart"));
                                            break;
                                        case "WAITING_ACTIVE":
                                        case "ACTIVE_LOCK":
                                        case "ACTIVE_ERROR":
                                        case "BACKGROUND_ERROR":
                                            Ji--, Ki = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this.fire(new e1.k("trackuserlocationend"));
                                            break;
                                        case "BACKGROUND":
                                            this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new e1.k("trackuserlocationstart")), this.fire(new e1.k("userlocationfocus"));
                                            break;
                                        default:
                                            throw new Error(`Unexpected watchState ${this._watchState}`);
                                    }
                                    switch(this._watchState){
                                        case "WAITING_ACTIVE":
                                            this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                                            break;
                                        case "ACTIVE_LOCK":
                                            this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                                            break;
                                        case "OFF":
                                            break;
                                        default:
                                            throw new Error(`Unexpected watchState ${this._watchState}`);
                                    }
                                    if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();
                                    else if (void 0 === this._geolocationWatchID) {
                                        let t1;
                                        this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), Ji++, Ji > 1 ? (t1 = {
                                            maximumAge: 6e5,
                                            timeout: 0
                                        }, Ki = !0) : (t1 = this.options.positionOptions, Ki = !1), this._geolocationWatchID = window.navigator.geolocation.watchPosition(this._onSuccess, this._onError, t1);
                                    }
                                } else window.navigator.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = setTimeout(this._finish, 1e4);
                                return !0;
                            }
                            _clearWatch() {
                                window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
                            }
                        }
                        const ta = {
                            maxWidth: 100,
                            unit: "metric"
                        };
                        function ea(t1, e1, r) {
                            const n = r && r.maxWidth || 100, i = t1._container.clientHeight / 2, a = t1.unproject([
                                0,
                                i
                            ]), o = t1.unproject([
                                n,
                                i
                            ]), s = a.distanceTo(o);
                            if (r && "imperial" === r.unit) {
                                const r = 3.2808 * s;
                                r > 5280 ? ra(e1, n, r / 5280, t1._getUIString("ScaleControl.Miles")) : ra(e1, n, r, t1._getUIString("ScaleControl.Feet"));
                            } else r && "nautical" === r.unit ? ra(e1, n, s / 1852, t1._getUIString("ScaleControl.NauticalMiles")) : s >= 1e3 ? ra(e1, n, s / 1e3, t1._getUIString("ScaleControl.Kilometers")) : ra(e1, n, s, t1._getUIString("ScaleControl.Meters"));
                        }
                        function ra(t1, e1, r, n) {
                            const i = function(t1) {
                                const e1 = Math.pow(10, `${Math.floor(t1)}`.length - 1);
                                let r = t1 / e1;
                                return r = r >= 10 ? 10 : r >= 5 ? 5 : r >= 3 ? 3 : r >= 2 ? 2 : r >= 1 ? 1 : function(t1) {
                                    const e1 = Math.pow(10, Math.ceil(-Math.log(t1) / Math.LN10));
                                    return Math.round(t1 * e1) / e1;
                                }(r), e1 * r;
                            }(r), a = i / r;
                            t1.style.width = e1 * a + "px", t1.innerHTML = `${i}&nbsp;${n}`;
                        }
                        class na extends e1.E {
                            constructor(t1 = {}){
                                super(), this._onFullscreenChange = ()=>{
                                    var t1;
                                    let e1 = window.document.fullscreenElement || window.document.mozFullScreenElement || window.document.webkitFullscreenElement || window.document.msFullscreenElement;
                                    for(; null === (t1 = null == e1 ? void 0 : e1.shadowRoot) || void 0 === t1 ? void 0 : t1.fullscreenElement;)e1 = e1.shadowRoot.fullscreenElement;
                                    e1 === this._container !== this._fullscreen && this._handleFullscreenChange();
                                }, this._onClickFullscreen = ()=>{
                                    this._isFullscreen() ? this._exitFullscreen() : this._requestFullscreen();
                                }, this._fullscreen = !1, t1 && t1.container && (t1.container instanceof HTMLElement ? this._container = t1.container : e1.w("Full screen control 'container' must be a DOM element.")), "onfullscreenchange" in document ? this._fullscreenchange = "fullscreenchange" : "onmozfullscreenchange" in document ? this._fullscreenchange = "mozfullscreenchange" : "onwebkitfullscreenchange" in document ? this._fullscreenchange = "webkitfullscreenchange" : "onmsfullscreenchange" in document && (this._fullscreenchange = "MSFullscreenChange");
                            }
                            onAdd(t1) {
                                return this._map = t1, this._container || (this._container = this._map.getContainer()), this._controlContainer = o.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._setupUI(), this._controlContainer;
                            }
                            onRemove() {
                                o.remove(this._controlContainer), this._map = null, window.document.removeEventListener(this._fullscreenchange, this._onFullscreenChange);
                            }
                            _setupUI() {
                                const t1 = this._fullscreenButton = o.create("button", "maplibregl-ctrl-fullscreen", this._controlContainer);
                                o.create("span", "maplibregl-ctrl-icon", t1).setAttribute("aria-hidden", "true"), t1.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), window.document.addEventListener(this._fullscreenchange, this._onFullscreenChange);
                            }
                            _updateTitle() {
                                const t1 = this._getTitle();
                                this._fullscreenButton.setAttribute("aria-label", t1), this._fullscreenButton.title = t1;
                            }
                            _getTitle() {
                                return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
                            }
                            _isFullscreen() {
                                return this._fullscreen;
                            }
                            _handleFullscreenChange() {
                                this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("maplibregl-ctrl-shrink"), this._fullscreenButton.classList.toggle("maplibregl-ctrl-fullscreen"), this._updateTitle(), this._fullscreen ? (this.fire(new e1.k("fullscreenstart")), this._prevCooperativeGesturesEnabled = this._map.cooperativeGestures.isEnabled(), this._map.cooperativeGestures.disable()) : (this.fire(new e1.k("fullscreenend")), this._prevCooperativeGesturesEnabled && this._map.cooperativeGestures.enable());
                            }
                            _exitFullscreen() {
                                window.document.exitFullscreen ? window.document.exitFullscreen() : window.document.mozCancelFullScreen ? window.document.mozCancelFullScreen() : window.document.msExitFullscreen ? window.document.msExitFullscreen() : window.document.webkitCancelFullScreen ? window.document.webkitCancelFullScreen() : this._togglePseudoFullScreen();
                            }
                            _requestFullscreen() {
                                this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.mozRequestFullScreen ? this._container.mozRequestFullScreen() : this._container.msRequestFullscreen ? this._container.msRequestFullscreen() : this._container.webkitRequestFullscreen ? this._container.webkitRequestFullscreen() : this._togglePseudoFullScreen();
                            }
                            _togglePseudoFullScreen() {
                                this._container.classList.toggle("maplibregl-pseudo-fullscreen"), this._handleFullscreenChange(), this._map.resize();
                            }
                        }
                        const ia = {
                            closeButton: !0,
                            closeOnClick: !0,
                            focusAfterOpen: !0,
                            className: "",
                            maxWidth: "240px",
                            subpixelPositioning: !1
                        }, aa = [
                            "a[href]",
                            "[tabindex]:not([tabindex='-1'])",
                            "[contenteditable]:not([contenteditable='false'])",
                            "button:not([disabled])",
                            "input:not([disabled])",
                            "select:not([disabled])",
                            "textarea:not([disabled])"
                        ].join(", ");
                        class oa extends e1.E {
                            constructor(t1){
                                super(), this.remove = ()=>(this._content && o.remove(this._content), this._container && (o.remove(this._container), delete this._container), this._map && (this._map.off("move", this._update), this._map.off("move", this._onClose), this._map.off("click", this._onClose), this._map.off("remove", this.remove), this._map.off("mousemove", this._onMouseMove), this._map.off("mouseup", this._onMouseUp), this._map.off("drag", this._onDrag), this._map._canvasContainer.classList.remove("maplibregl-track-pointer"), delete this._map, this.fire(new e1.k("close"))), this), this._onMouseUp = (t1)=>{
                                    this._update(t1.point);
                                }, this._onMouseMove = (t1)=>{
                                    this._update(t1.point);
                                }, this._onDrag = (t1)=>{
                                    this._update(t1.point);
                                }, this._update = (t1)=>{
                                    var e1;
                                    const r = this._lngLat || this._trackPointer;
                                    if (!this._map || !r || !this._content) return;
                                    if (!this._container) {
                                        if (this._container = o.create("div", "maplibregl-popup", this._map.getContainer()), this._tip = o.create("div", "maplibregl-popup-tip", this._container), this._container.appendChild(this._content), this.options.className) for (const t1 of this.options.className.split(" "))this._container.classList.add(t1);
                                        this._closeButton && this._closeButton.setAttribute("aria-label", this._map._getUIString("Popup.Close")), this._trackPointer && this._container.classList.add("maplibregl-popup-track-pointer");
                                    }
                                    if (this.options.maxWidth && this._container.style.maxWidth !== this.options.maxWidth && (this._container.style.maxWidth = this.options.maxWidth), this._map.transform.renderWorldCopies && !this._trackPointer ? this._lngLat = Zi(this._lngLat, this._flatPos, this._map.transform) : this._lngLat = null === (e1 = this._lngLat) || void 0 === e1 ? void 0 : e1.wrap(), this._trackPointer && !t1) return;
                                    const n = this._flatPos = this._pos = this._trackPointer && t1 ? t1 : this._map.project(this._lngLat);
                                    this._map.terrain && (this._flatPos = this._trackPointer && t1 ? t1 : this._map.transform.locationPoint(this._lngLat));
                                    let i = this.options.anchor;
                                    const a = sa(this.options.offset);
                                    if (!i) {
                                        const t1 = this._container.offsetWidth, e1 = this._container.offsetHeight;
                                        let r;
                                        r = n.y + a.bottom.y < e1 ? [
                                            "top"
                                        ] : n.y > this._map.transform.height - e1 ? [
                                            "bottom"
                                        ] : [], n.x < t1 / 2 ? r.push("left") : n.x > this._map.transform.width - t1 / 2 && r.push("right"), i = 0 === r.length ? "bottom" : r.join("-");
                                    }
                                    let s = n.add(a[i]);
                                    this.options.subpixelPositioning || (s = s.round()), o.setTransform(this._container, `${Wi[i]} translate(${s.x}px,${s.y}px)`), Yi(this._container, i, "popup");
                                }, this._onClose = ()=>{
                                    this.remove();
                                }, this.options = e1.e(Object.create(ia), t1);
                            }
                            addTo(t1) {
                                return this._map && this.remove(), this._map = t1, this.options.closeOnClick && this._map.on("click", this._onClose), this.options.closeOnMove && this._map.on("move", this._onClose), this._map.on("remove", this.remove), this._update(), this._focusFirstElement(), this._trackPointer ? (this._map.on("mousemove", this._onMouseMove), this._map.on("mouseup", this._onMouseUp), this._container && this._container.classList.add("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer")) : this._map.on("move", this._update), this.fire(new e1.k("open")), this;
                            }
                            isOpen() {
                                return !!this._map;
                            }
                            getLngLat() {
                                return this._lngLat;
                            }
                            setLngLat(t1) {
                                return this._lngLat = e1.N.convert(t1), this._pos = null, this._flatPos = null, this._trackPointer = !1, this._update(), this._map && (this._map.on("move", this._update), this._map.off("mousemove", this._onMouseMove), this._container && this._container.classList.remove("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.remove("maplibregl-track-pointer")), this;
                            }
                            trackPointer() {
                                return this._trackPointer = !0, this._pos = null, this._flatPos = null, this._update(), this._map && (this._map.off("move", this._update), this._map.on("mousemove", this._onMouseMove), this._map.on("drag", this._onDrag), this._container && this._container.classList.add("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer")), this;
                            }
                            getElement() {
                                return this._container;
                            }
                            setText(t1) {
                                return this.setDOMContent(document.createTextNode(t1));
                            }
                            setHTML(t1) {
                                const e1 = document.createDocumentFragment(), r = document.createElement("body");
                                let n;
                                for(r.innerHTML = t1; n = r.firstChild, n;)e1.appendChild(n);
                                return this.setDOMContent(e1);
                            }
                            getMaxWidth() {
                                var t1;
                                return null === (t1 = this._container) || void 0 === t1 ? void 0 : t1.style.maxWidth;
                            }
                            setMaxWidth(t1) {
                                return this.options.maxWidth = t1, this._update(), this;
                            }
                            setDOMContent(t1) {
                                if (this._content) for(; this._content.hasChildNodes();)this._content.firstChild && this._content.removeChild(this._content.firstChild);
                                else this._content = o.create("div", "maplibregl-popup-content", this._container);
                                return this._content.appendChild(t1), this._createCloseButton(), this._update(), this._focusFirstElement(), this;
                            }
                            addClassName(t1) {
                                return this._container && this._container.classList.add(t1), this;
                            }
                            removeClassName(t1) {
                                return this._container && this._container.classList.remove(t1), this;
                            }
                            setOffset(t1) {
                                return this.options.offset = t1, this._update(), this;
                            }
                            toggleClassName(t1) {
                                if (this._container) return this._container.classList.toggle(t1);
                            }
                            setSubpixelPositioning(t1) {
                                this.options.subpixelPositioning = t1;
                            }
                            _createCloseButton() {
                                this.options.closeButton && (this._closeButton = o.create("button", "maplibregl-popup-close-button", this._content), this._closeButton.type = "button", this._closeButton.innerHTML = "&#215;", this._closeButton.addEventListener("click", this._onClose));
                            }
                            _focusFirstElement() {
                                if (!this.options.focusAfterOpen || !this._container) return;
                                const t1 = this._container.querySelector(aa);
                                t1 && t1.focus();
                            }
                        }
                        function sa(t1) {
                            if (t1) {
                                if ("number" == typeof t1) {
                                    const r = Math.round(Math.abs(t1) / Math.SQRT2);
                                    return {
                                        center: new e1.P(0, 0),
                                        top: new e1.P(0, t1),
                                        "top-left": new e1.P(r, r),
                                        "top-right": new e1.P(-r, r),
                                        bottom: new e1.P(0, -t1),
                                        "bottom-left": new e1.P(r, -r),
                                        "bottom-right": new e1.P(-r, -r),
                                        left: new e1.P(t1, 0),
                                        right: new e1.P(-t1, 0)
                                    };
                                }
                                if (t1 instanceof e1.P || Array.isArray(t1)) {
                                    const r = e1.P.convert(t1);
                                    return {
                                        center: r,
                                        top: r,
                                        "top-left": r,
                                        "top-right": r,
                                        bottom: r,
                                        "bottom-left": r,
                                        "bottom-right": r,
                                        left: r,
                                        right: r
                                    };
                                }
                                return {
                                    center: e1.P.convert(t1.center || [
                                        0,
                                        0
                                    ]),
                                    top: e1.P.convert(t1.top || [
                                        0,
                                        0
                                    ]),
                                    "top-left": e1.P.convert(t1["top-left"] || [
                                        0,
                                        0
                                    ]),
                                    "top-right": e1.P.convert(t1["top-right"] || [
                                        0,
                                        0
                                    ]),
                                    bottom: e1.P.convert(t1.bottom || [
                                        0,
                                        0
                                    ]),
                                    "bottom-left": e1.P.convert(t1["bottom-left"] || [
                                        0,
                                        0
                                    ]),
                                    "bottom-right": e1.P.convert(t1["bottom-right"] || [
                                        0,
                                        0
                                    ]),
                                    left: e1.P.convert(t1.left || [
                                        0,
                                        0
                                    ]),
                                    right: e1.P.convert(t1.right || [
                                        0,
                                        0
                                    ])
                                };
                            }
                            return sa(new e1.P(0, 0));
                        }
                        const la = r;
                        t1.AJAXError = e1.bg, t1.Evented = e1.E, t1.LngLat = e1.N, t1.MercatorCoordinate = e1.Z, t1.Point = e1.P, t1.addProtocol = e1.bh, t1.config = e1.a, t1.removeProtocol = e1.bi, t1.AttributionControl = Li, t1.BoxZoomHandler = Gn, t1.CanvasSource = it, t1.CooperativeGesturesHandler = Ti, t1.DoubleClickZoomHandler = yi, t1.DragPanHandler = _i, t1.DragRotateHandler = bi, t1.EdgeInsets = Mn, t1.FullscreenControl = na, t1.GeoJSONSource = tt, t1.GeolocateControl = Qi, t1.Hash = Ln, t1.ImageSource = rt, t1.KeyboardHandler = pi, t1.LngLatBounds = X, t1.LogoControl = Ii, t1.Map = class extends Ei {
                            constructor(t1){
                                e1.be.mark(e1.bf.create);
                                const r = Object.assign(Object.assign({}, Ui), t1);
                                if (null != r.minZoom && null != r.maxZoom && r.minZoom > r.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
                                if (null != r.minPitch && null != r.maxPitch && r.minPitch > r.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
                                if (null != r.minPitch && r.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
                                if (null != r.maxPitch && r.maxPitch > 85) throw new Error("maxPitch must be less than or equal to 85");
                                if (super(new En(r.minZoom, r.maxZoom, r.minPitch, r.maxPitch, r.renderWorldCopies), {
                                    bearingSnap: r.bearingSnap
                                }), this._idleTriggered = !1, this._crossFadingFactor = 1, this._renderTaskQueue = new Pi, this._controls = [], this._mapId = e1.a4(), this._contextLost = (t1)=>{
                                    t1.preventDefault(), this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this.fire(new e1.k("webglcontextlost", {
                                        originalEvent: t1
                                    }));
                                }, this._contextRestored = (t1)=>{
                                    this._setupPainter(), this.resize(), this._update(), this.fire(new e1.k("webglcontextrestored", {
                                        originalEvent: t1
                                    }));
                                }, this._onMapScroll = (t1)=>{
                                    if (t1.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
                                }, this._onWindowOnline = ()=>{
                                    this._update();
                                }, this._interactive = r.interactive, this._maxTileCacheSize = r.maxTileCacheSize, this._maxTileCacheZoomLevels = r.maxTileCacheZoomLevels, this._failIfMajorPerformanceCaveat = !0 === r.failIfMajorPerformanceCaveat, this._preserveDrawingBuffer = !0 === r.preserveDrawingBuffer, this._antialias = !0 === r.antialias, this._trackResize = !0 === r.trackResize, this._bearingSnap = r.bearingSnap, this._refreshExpiredTiles = !0 === r.refreshExpiredTiles, this._fadeDuration = r.fadeDuration, this._crossSourceCollisions = !0 === r.crossSourceCollisions, this._collectResourceTiming = !0 === r.collectResourceTiming, this._locale = Object.assign(Object.assign({}, Ni), r.locale), this._clickTolerance = r.clickTolerance, this._overridePixelRatio = r.pixelRatio, this._maxCanvasSize = r.maxCanvasSize, this.transformCameraUpdate = r.transformCameraUpdate, this.cancelPendingTileRequestsWhileZooming = !0 === r.cancelPendingTileRequestsWhileZooming, this._imageQueueHandle = p.addThrottleControl(()=>this.isMoving()), this._requestManager = new d(r.transformRequest), "string" == typeof r.container) {
                                    if (this._container = document.getElementById(r.container), !this._container) throw new Error(`Container '${r.container}' not found.`);
                                } else {
                                    if (!(r.container instanceof HTMLElement)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
                                    this._container = r.container;
                                }
                                if (r.maxBounds && this.setMaxBounds(r.maxBounds), this._setupContainer(), this._setupPainter(), this.on("move", ()=>this._update(!1)).on("moveend", ()=>this._update(!1)).on("zoom", ()=>this._update(!0)).on("terrain", ()=>{
                                    this.painter.terrainFacilitator.dirty = !0, this._update(!0);
                                }).once("idle", ()=>{
                                    this._idleTriggered = !0;
                                }), "undefined" != typeof window) {
                                    addEventListener("online", this._onWindowOnline, !1);
                                    let t1 = !1;
                                    const e1 = Cn((t1)=>{
                                        this._trackResize && !this._removed && this.resize(t1)._update();
                                    }, 50);
                                    this._resizeObserver = new ResizeObserver((r)=>{
                                        t1 ? e1(r) : t1 = !0;
                                    }), this._resizeObserver.observe(this._container);
                                }
                                this.handlers = new Si(this, r);
                                const n = "string" == typeof r.hash && r.hash || void 0;
                                this._hash = r.hash && new Ln(n).addTo(this), this._hash && this._hash._onHashChange() || (this.jumpTo({
                                    center: r.center,
                                    zoom: r.zoom,
                                    bearing: r.bearing,
                                    pitch: r.pitch
                                }), r.bounds && (this.resize(), this.fitBounds(r.bounds, e1.e({}, r.fitBoundsOptions, {
                                    duration: 0
                                })))), this.resize(), this._localIdeographFontFamily = r.localIdeographFontFamily, this._validateStyle = r.validateStyle, r.style && this.setStyle(r.style, {
                                    localIdeographFontFamily: r.localIdeographFontFamily
                                }), r.attributionControl && this.addControl(new Li("boolean" == typeof r.attributionControl ? void 0 : r.attributionControl)), r.maplibreLogo && this.addControl(new Ii, r.logoPosition), this.on("style.load", ()=>{
                                    this.transform.unmodified && this.jumpTo(this.style.stylesheet);
                                }), this.on("data", (t1)=>{
                                    this._update("style" === t1.dataType), this.fire(new e1.k(`${t1.dataType}data`, t1));
                                }), this.on("dataloading", (t1)=>{
                                    this.fire(new e1.k(`${t1.dataType}dataloading`, t1));
                                }), this.on("dataabort", (t1)=>{
                                    this.fire(new e1.k("sourcedataabort", t1));
                                });
                            }
                            _getMapId() {
                                return this._mapId;
                            }
                            addControl(t1, r) {
                                if (void 0 === r && (r = t1.getDefaultPosition ? t1.getDefaultPosition() : "top-right"), !t1 || !t1.onAdd) return this.fire(new e1.j(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
                                const n = t1.onAdd(this);
                                this._controls.push(t1);
                                const i = this._controlPositions[r];
                                return -1 !== r.indexOf("bottom") ? i.insertBefore(n, i.firstChild) : i.appendChild(n), this;
                            }
                            removeControl(t1) {
                                if (!t1 || !t1.onRemove) return this.fire(new e1.j(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
                                const r = this._controls.indexOf(t1);
                                return r > -1 && this._controls.splice(r, 1), t1.onRemove(this), this;
                            }
                            hasControl(t1) {
                                return this._controls.indexOf(t1) > -1;
                            }
                            calculateCameraOptionsFromTo(t1, e1, r, n) {
                                return null == n && this.terrain && (n = this.terrain.getElevationForLngLatZoom(r, this.transform.tileZoom)), super.calculateCameraOptionsFromTo(t1, e1, r, n);
                            }
                            resize(t1) {
                                var r;
                                const n = this._containerDimensions(), i = n[0], a = n[1], o = this._getClampedPixelRatio(i, a);
                                if (this._resizeCanvas(i, a, o), this.painter.resize(i, a, o), this.painter.overLimit()) {
                                    const t1 = this.painter.context.gl;
                                    this._maxCanvasSize = [
                                        t1.drawingBufferWidth,
                                        t1.drawingBufferHeight
                                    ];
                                    const e1 = this._getClampedPixelRatio(i, a);
                                    this._resizeCanvas(i, a, e1), this.painter.resize(i, a, e1);
                                }
                                this.transform.resize(i, a), null === (r = this._requestedCameraState) || void 0 === r || r.resize(i, a);
                                const s = !this._moving;
                                return s && (this.stop(), this.fire(new e1.k("movestart", t1)).fire(new e1.k("move", t1))), this.fire(new e1.k("resize", t1)), s && this.fire(new e1.k("moveend", t1)), this;
                            }
                            _getClampedPixelRatio(t1, e1) {
                                const { 0: r, 1: n } = this._maxCanvasSize, i = this.getPixelRatio(), a = t1 * i, o = e1 * i, s = a > r ? r / a : 1, l = o > n ? n / o : 1;
                                return Math.min(s, l) * i;
                            }
                            getPixelRatio() {
                                var t1;
                                return null !== (t1 = this._overridePixelRatio) && void 0 !== t1 ? t1 : devicePixelRatio;
                            }
                            setPixelRatio(t1) {
                                this._overridePixelRatio = t1, this.resize();
                            }
                            getBounds() {
                                return this.transform.getBounds();
                            }
                            getMaxBounds() {
                                return this.transform.getMaxBounds();
                            }
                            setMaxBounds(t1) {
                                return this.transform.setMaxBounds(X.convert(t1)), this._update();
                            }
                            setMinZoom(t1) {
                                if ((t1 = null == t1 ? -2 : t1) >= -2 && t1 <= this.transform.maxZoom) return this.transform.minZoom = t1, this._update(), this.getZoom() < t1 && this.setZoom(t1), this;
                                throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
                            }
                            getMinZoom() {
                                return this.transform.minZoom;
                            }
                            setMaxZoom(t1) {
                                if ((t1 = null == t1 ? 22 : t1) >= this.transform.minZoom) return this.transform.maxZoom = t1, this._update(), this.getZoom() > t1 && this.setZoom(t1), this;
                                throw new Error("maxZoom must be greater than the current minZoom");
                            }
                            getMaxZoom() {
                                return this.transform.maxZoom;
                            }
                            setMinPitch(t1) {
                                if ((t1 = null == t1 ? 0 : t1) < 0) throw new Error("minPitch must be greater than or equal to 0");
                                if (t1 >= 0 && t1 <= this.transform.maxPitch) return this.transform.minPitch = t1, this._update(), this.getPitch() < t1 && this.setPitch(t1), this;
                                throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
                            }
                            getMinPitch() {
                                return this.transform.minPitch;
                            }
                            setMaxPitch(t1) {
                                if ((t1 = null == t1 ? 60 : t1) > 85) throw new Error("maxPitch must be less than or equal to 85");
                                if (t1 >= this.transform.minPitch) return this.transform.maxPitch = t1, this._update(), this.getPitch() > t1 && this.setPitch(t1), this;
                                throw new Error("maxPitch must be greater than the current minPitch");
                            }
                            getMaxPitch() {
                                return this.transform.maxPitch;
                            }
                            getRenderWorldCopies() {
                                return this.transform.renderWorldCopies;
                            }
                            setRenderWorldCopies(t1) {
                                return this.transform.renderWorldCopies = t1, this._update();
                            }
                            project(t1) {
                                return this.transform.locationPoint(e1.N.convert(t1), this.style && this.terrain);
                            }
                            unproject(t1) {
                                return this.transform.pointLocation(e1.P.convert(t1), this.terrain);
                            }
                            isMoving() {
                                var t1;
                                return this._moving || (null === (t1 = this.handlers) || void 0 === t1 ? void 0 : t1.isMoving());
                            }
                            isZooming() {
                                var t1;
                                return this._zooming || (null === (t1 = this.handlers) || void 0 === t1 ? void 0 : t1.isZooming());
                            }
                            isRotating() {
                                var t1;
                                return this._rotating || (null === (t1 = this.handlers) || void 0 === t1 ? void 0 : t1.isRotating());
                            }
                            _createDelegatedListener(t1, e1, r) {
                                if ("mouseenter" === t1 || "mouseover" === t1) {
                                    let n = !1;
                                    const i = (i)=>{
                                        const a = this.getLayer(e1) ? this.queryRenderedFeatures(i.point, {
                                            layers: [
                                                e1
                                            ]
                                        }) : [];
                                        a.length ? n || (n = !0, r.call(this, new Nn(t1, this, i.originalEvent, {
                                            features: a
                                        }))) : n = !1;
                                    };
                                    return {
                                        layer: e1,
                                        listener: r,
                                        delegates: {
                                            mousemove: i,
                                            mouseout: ()=>{
                                                n = !1;
                                            }
                                        }
                                    };
                                }
                                if ("mouseleave" === t1 || "mouseout" === t1) {
                                    let n = !1;
                                    const i = (i)=>{
                                        (this.getLayer(e1) ? this.queryRenderedFeatures(i.point, {
                                            layers: [
                                                e1
                                            ]
                                        }) : []).length ? n = !0 : n && (n = !1, r.call(this, new Nn(t1, this, i.originalEvent)));
                                    }, a = (e1)=>{
                                        n && (n = !1, r.call(this, new Nn(t1, this, e1.originalEvent)));
                                    };
                                    return {
                                        layer: e1,
                                        listener: r,
                                        delegates: {
                                            mousemove: i,
                                            mouseout: a
                                        }
                                    };
                                }
                                {
                                    const n = (t1)=>{
                                        const n = this.getLayer(e1) ? this.queryRenderedFeatures(t1.point, {
                                            layers: [
                                                e1
                                            ]
                                        }) : [];
                                        n.length && (t1.features = n, r.call(this, t1), delete t1.features);
                                    };
                                    return {
                                        layer: e1,
                                        listener: r,
                                        delegates: {
                                            [t1]: n
                                        }
                                    };
                                }
                            }
                            on(t1, e1, r) {
                                if (void 0 === r) return super.on(t1, e1);
                                const n = this._createDelegatedListener(t1, e1, r);
                                this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[t1] = this._delegatedListeners[t1] || [], this._delegatedListeners[t1].push(n);
                                for(const t1 in n.delegates)this.on(t1, n.delegates[t1]);
                                return this;
                            }
                            once(t1, e1, r) {
                                if (void 0 === r) return super.once(t1, e1);
                                const n = this._createDelegatedListener(t1, e1, r);
                                for(const t1 in n.delegates)this.once(t1, n.delegates[t1]);
                                return this;
                            }
                            off(t1, e1, r) {
                                if (void 0 === r) return super.off(t1, e1);
                                return this._delegatedListeners && this._delegatedListeners[t1] && ((n)=>{
                                    const i = n[t1];
                                    for(let t1 = 0; t1 < i.length; t1++){
                                        const n = i[t1];
                                        if (n.layer === e1 && n.listener === r) {
                                            for(const t1 in n.delegates)this.off(t1, n.delegates[t1]);
                                            return i.splice(t1, 1), this;
                                        }
                                    }
                                })(this._delegatedListeners), this;
                            }
                            queryRenderedFeatures(t1, r) {
                                if (!this.style) return [];
                                let n;
                                const i = t1 instanceof e1.P || Array.isArray(t1), a = i ? t1 : [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        this.transform.width,
                                        this.transform.height
                                    ]
                                ];
                                if (r = r || (i ? {} : t1) || {}, a instanceof e1.P || "number" == typeof a[0]) n = [
                                    e1.P.convert(a)
                                ];
                                else {
                                    const t1 = e1.P.convert(a[0]), r = e1.P.convert(a[1]);
                                    n = [
                                        t1,
                                        new e1.P(r.x, t1.y),
                                        r,
                                        new e1.P(t1.x, r.y),
                                        t1
                                    ];
                                }
                                return this.style.queryRenderedFeatures(n, r, this.transform);
                            }
                            querySourceFeatures(t1, e1) {
                                return this.style.querySourceFeatures(t1, e1);
                            }
                            setStyle(t1, r) {
                                return !1 !== (r = e1.e({}, {
                                    localIdeographFontFamily: this._localIdeographFontFamily,
                                    validate: this._validateStyle
                                }, r)).diff && r.localIdeographFontFamily === this._localIdeographFontFamily && this.style && t1 ? (this._diffStyle(t1, r), this) : (this._localIdeographFontFamily = r.localIdeographFontFamily, this._updateStyle(t1, r));
                            }
                            setTransformRequest(t1) {
                                return this._requestManager.setTransformRequest(t1), this;
                            }
                            _getUIString(t1) {
                                const e1 = this._locale[t1];
                                if (null == e1) throw new Error(`Missing UI string '${t1}'`);
                                return e1;
                            }
                            _updateStyle(t1, e1) {
                                if (e1.transformStyle && this.style && !this.style._loaded) return void this.style.once("style.load", ()=>this._updateStyle(t1, e1));
                                const r = this.style && e1.transformStyle ? this.style.serialize() : void 0;
                                return this.style && (this.style.setEventedParent(null), this.style._remove(!t1)), t1 ? (this.style = new de(this, e1 || {}), this.style.setEventedParent(this, {
                                    style: this.style
                                }), "string" == typeof t1 ? this.style.loadURL(t1, e1, r) : this.style.loadJSON(t1, e1, r), this) : (delete this.style, this);
                            }
                            _lazyInitEmptyStyle() {
                                this.style || (this.style = new de(this, {}), this.style.setEventedParent(this, {
                                    style: this.style
                                }), this.style.loadEmpty());
                            }
                            _diffStyle(t1, r) {
                                if ("string" == typeof t1) {
                                    const n = t1, i = this._requestManager.transformRequest(n, "Style");
                                    e1.h(i, new AbortController).then((t1)=>{
                                        this._updateDiff(t1.data, r);
                                    }).catch((t1)=>{
                                        t1 && this.fire(new e1.j(t1));
                                    });
                                } else "object" == typeof t1 && this._updateDiff(t1, r);
                            }
                            _updateDiff(t1, r) {
                                try {
                                    this.style.setState(t1, r) && this._update(!0);
                                } catch (n) {
                                    e1.w(`Unable to perform style diff: ${n.message || n.error || n}.  Rebuilding the style from scratch.`), this._updateStyle(t1, r);
                                }
                            }
                            getStyle() {
                                if (this.style) return this.style.serialize();
                            }
                            isStyleLoaded() {
                                return this.style ? this.style.loaded() : e1.w("There is no style added to the map.");
                            }
                            addSource(t1, e1) {
                                return this._lazyInitEmptyStyle(), this.style.addSource(t1, e1), this._update(!0);
                            }
                            isSourceLoaded(t1) {
                                const r = this.style && this.style.sourceCaches[t1];
                                if (void 0 !== r) return r.loaded();
                                this.fire(new e1.j(new Error(`There is no source with ID '${t1}'`)));
                            }
                            setTerrain(t1) {
                                if (this.style._checkLoaded(), this._terrainDataCallback && this.style.off("data", this._terrainDataCallback), t1) {
                                    const r = this.style.sourceCaches[t1.source];
                                    if (!r) throw new Error(`cannot load terrain, because there exists no source with ID: ${t1.source}`);
                                    null === this.terrain && r.reload();
                                    for(const r in this.style._layers){
                                        const n = this.style._layers[r];
                                        "hillshade" === n.type && n.source === t1.source && e1.w("You are using the same source for a hillshade layer and for 3D terrain. Please consider using two separate sources to improve rendering quality.");
                                    }
                                    this.terrain = new Di(this.painter, r, t1), this.painter.renderToTexture = new Bi(this.painter, this.terrain), this.transform.minElevationForCurrentTile = this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom), this.transform.elevation = this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom), this._terrainDataCallback = (e1)=>{
                                        "style" === e1.dataType ? this.terrain.sourceCache.freeRtt() : "source" === e1.dataType && e1.tile && (e1.sourceId !== t1.source || this._elevationFreeze || (this.transform.minElevationForCurrentTile = this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom), this.transform.elevation = this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), this.terrain.sourceCache.freeRtt(e1.tile.tileID));
                                    }, this.style.on("data", this._terrainDataCallback);
                                } else this.terrain && this.terrain.sourceCache.destruct(), this.terrain = null, this.painter.renderToTexture && this.painter.renderToTexture.destruct(), this.painter.renderToTexture = null, this.transform.minElevationForCurrentTile = 0, this.transform.elevation = 0;
                                return this.fire(new e1.k("terrain", {
                                    terrain: t1
                                })), this;
                            }
                            getTerrain() {
                                var t1, e1;
                                return null !== (e1 = null === (t1 = this.terrain) || void 0 === t1 ? void 0 : t1.options) && void 0 !== e1 ? e1 : null;
                            }
                            areTilesLoaded() {
                                const t1 = this.style && this.style.sourceCaches;
                                for(const e1 in t1){
                                    const r = t1[e1]._tiles;
                                    for(const t1 in r){
                                        const e1 = r[t1];
                                        if ("loaded" !== e1.state && "errored" !== e1.state) return !1;
                                    }
                                }
                                return !0;
                            }
                            removeSource(t1) {
                                return this.style.removeSource(t1), this._update(!0);
                            }
                            getSource(t1) {
                                return this.style.getSource(t1);
                            }
                            addImage(t1, r, n = {}) {
                                const { pixelRatio: i = 1, sdf: o = !1, stretchX: s, stretchY: l, content: c, textFitWidth: u, textFitHeight: h } = n;
                                this._lazyInitEmptyStyle();
                                if (!(r instanceof HTMLImageElement || e1.b(r))) {
                                    if (void 0 === r.width || void 0 === r.height) return this.fire(new e1.j(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                                    {
                                        const { width: n, height: a, data: f } = r, p = r;
                                        return this.style.addImage(t1, {
                                            data: new e1.R({
                                                width: n,
                                                height: a
                                            }, new Uint8Array(f)),
                                            pixelRatio: i,
                                            stretchX: s,
                                            stretchY: l,
                                            content: c,
                                            textFitWidth: u,
                                            textFitHeight: h,
                                            sdf: o,
                                            version: 0,
                                            userImage: p
                                        }), p.onAdd && p.onAdd(this, t1), this;
                                    }
                                }
                                {
                                    const { width: n, height: f, data: p } = a.getImageData(r);
                                    this.style.addImage(t1, {
                                        data: new e1.R({
                                            width: n,
                                            height: f
                                        }, p),
                                        pixelRatio: i,
                                        stretchX: s,
                                        stretchY: l,
                                        content: c,
                                        textFitWidth: u,
                                        textFitHeight: h,
                                        sdf: o,
                                        version: 0
                                    });
                                }
                            }
                            updateImage(t1, r) {
                                const n = this.style.getImage(t1);
                                if (!n) return this.fire(new e1.j(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
                                const i = r instanceof HTMLImageElement || e1.b(r) ? a.getImageData(r) : r, { width: o, height: s, data: l } = i;
                                if (void 0 === o || void 0 === s) return this.fire(new e1.j(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                                if (o !== n.data.width || s !== n.data.height) return this.fire(new e1.j(new Error("The width and height of the updated image must be that same as the previous version of the image")));
                                const c = !(r instanceof HTMLImageElement || e1.b(r));
                                return n.data.replace(l, c), this.style.updateImage(t1, n), this;
                            }
                            getImage(t1) {
                                return this.style.getImage(t1);
                            }
                            hasImage(t1) {
                                return t1 ? !!this.style.getImage(t1) : (this.fire(new e1.j(new Error("Missing required image id"))), !1);
                            }
                            removeImage(t1) {
                                this.style.removeImage(t1);
                            }
                            loadImage(t1) {
                                return p.getImage(this._requestManager.transformRequest(t1, "Image"), new AbortController);
                            }
                            listImages() {
                                return this.style.listImages();
                            }
                            addLayer(t1, e1) {
                                return this._lazyInitEmptyStyle(), this.style.addLayer(t1, e1), this._update(!0);
                            }
                            moveLayer(t1, e1) {
                                return this.style.moveLayer(t1, e1), this._update(!0);
                            }
                            removeLayer(t1) {
                                return this.style.removeLayer(t1), this._update(!0);
                            }
                            getLayer(t1) {
                                return this.style.getLayer(t1);
                            }
                            getLayersOrder() {
                                return this.style.getLayersOrder();
                            }
                            setLayerZoomRange(t1, e1, r) {
                                return this.style.setLayerZoomRange(t1, e1, r), this._update(!0);
                            }
                            setFilter(t1, e1, r = {}) {
                                return this.style.setFilter(t1, e1, r), this._update(!0);
                            }
                            getFilter(t1) {
                                return this.style.getFilter(t1);
                            }
                            setPaintProperty(t1, e1, r, n = {}) {
                                return this.style.setPaintProperty(t1, e1, r, n), this._update(!0);
                            }
                            getPaintProperty(t1, e1) {
                                return this.style.getPaintProperty(t1, e1);
                            }
                            setLayoutProperty(t1, e1, r, n = {}) {
                                return this.style.setLayoutProperty(t1, e1, r, n), this._update(!0);
                            }
                            getLayoutProperty(t1, e1) {
                                return this.style.getLayoutProperty(t1, e1);
                            }
                            setGlyphs(t1, e1 = {}) {
                                return this._lazyInitEmptyStyle(), this.style.setGlyphs(t1, e1), this._update(!0);
                            }
                            getGlyphs() {
                                return this.style.getGlyphsUrl();
                            }
                            addSprite(t1, e1, r = {}) {
                                return this._lazyInitEmptyStyle(), this.style.addSprite(t1, e1, r, (t1)=>{
                                    t1 || this._update(!0);
                                }), this;
                            }
                            removeSprite(t1) {
                                return this._lazyInitEmptyStyle(), this.style.removeSprite(t1), this._update(!0);
                            }
                            getSprite() {
                                return this.style.getSprite();
                            }
                            setSprite(t1, e1 = {}) {
                                return this._lazyInitEmptyStyle(), this.style.setSprite(t1, e1, (t1)=>{
                                    t1 || this._update(!0);
                                }), this;
                            }
                            setLight(t1, e1 = {}) {
                                return this._lazyInitEmptyStyle(), this.style.setLight(t1, e1), this._update(!0);
                            }
                            getLight() {
                                return this.style.getLight();
                            }
                            setSky(t1) {
                                return this._lazyInitEmptyStyle(), this.style.setSky(t1), this._update(!0);
                            }
                            getSky() {
                                return this.style.getSky();
                            }
                            setFeatureState(t1, e1) {
                                return this.style.setFeatureState(t1, e1), this._update();
                            }
                            removeFeatureState(t1, e1) {
                                return this.style.removeFeatureState(t1, e1), this._update();
                            }
                            getFeatureState(t1) {
                                return this.style.getFeatureState(t1);
                            }
                            getContainer() {
                                return this._container;
                            }
                            getCanvasContainer() {
                                return this._canvasContainer;
                            }
                            getCanvas() {
                                return this._canvas;
                            }
                            _containerDimensions() {
                                let t1 = 0, e1 = 0;
                                return this._container && (t1 = this._container.clientWidth || 400, e1 = this._container.clientHeight || 300), [
                                    t1,
                                    e1
                                ];
                            }
                            _setupContainer() {
                                const t1 = this._container;
                                t1.classList.add("maplibregl-map");
                                const e1 = this._canvasContainer = o.create("div", "maplibregl-canvas-container", t1);
                                this._interactive && e1.classList.add("maplibregl-interactive"), this._canvas = o.create("canvas", "maplibregl-canvas", e1), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("tabindex", this._interactive ? "0" : "-1"), this._canvas.setAttribute("aria-label", this._getUIString("Map.Title")), this._canvas.setAttribute("role", "region");
                                const r = this._containerDimensions(), n = this._getClampedPixelRatio(r[0], r[1]);
                                this._resizeCanvas(r[0], r[1], n);
                                const i = this._controlContainer = o.create("div", "maplibregl-control-container", t1), a = this._controlPositions = {};
                                [
                                    "top-left",
                                    "top-right",
                                    "bottom-left",
                                    "bottom-right"
                                ].forEach((t1)=>{
                                    a[t1] = o.create("div", `maplibregl-ctrl-${t1} `, i);
                                }), this._container.addEventListener("scroll", this._onMapScroll, !1);
                            }
                            _resizeCanvas(t1, e1, r) {
                                this._canvas.width = Math.floor(r * t1), this._canvas.height = Math.floor(r * e1), this._canvas.style.width = `${t1}px`, this._canvas.style.height = `${e1}px`;
                            }
                            _setupPainter() {
                                const t1 = {
                                    alpha: !0,
                                    stencil: !0,
                                    depth: !0,
                                    failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat,
                                    preserveDrawingBuffer: this._preserveDrawingBuffer,
                                    antialias: this._antialias || !1
                                };
                                let e1 = null;
                                this._canvas.addEventListener("webglcontextcreationerror", (r)=>{
                                    e1 = {
                                        requestedAttributes: t1
                                    }, r && (e1.statusMessage = r.statusMessage, e1.type = r.type);
                                }, {
                                    once: !0
                                });
                                const r = this._canvas.getContext("webgl2", t1) || this._canvas.getContext("webgl", t1);
                                if (!r) {
                                    const t1 = "Failed to initialize WebGL";
                                    throw e1 ? (e1.message = t1, new Error(JSON.stringify(e1))) : new Error(t1);
                                }
                                this.painter = new Tn(r, this.transform), s.testSupport(r);
                            }
                            loaded() {
                                return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
                            }
                            _update(t1) {
                                return this.style && this.style._loaded ? (this._styleDirty = this._styleDirty || t1, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
                            }
                            _requestRenderFrame(t1) {
                                return this._update(), this._renderTaskQueue.add(t1);
                            }
                            _cancelRenderFrame(t1) {
                                this._renderTaskQueue.remove(t1);
                            }
                            _render(t1) {
                                const r = this._idleTriggered ? this._fadeDuration : 0;
                                if (this.painter.context.setDirty(), this.painter.setBaseState(), this._renderTaskQueue.run(t1), this._removed) return;
                                let n = !1;
                                if (this.style && this._styleDirty) {
                                    this._styleDirty = !1;
                                    const t1 = this.transform.zoom, i = a.now();
                                    this.style.zoomHistory.update(t1, i);
                                    const o = new e1.a9(t1, {
                                        now: i,
                                        fadeDuration: r,
                                        zoomHistory: this.style.zoomHistory,
                                        transition: this.style.getTransition()
                                    }), s = o.crossFadingFactor();
                                    1 === s && s === this._crossFadingFactor || (n = !0, this._crossFadingFactor = s), this.style.update(o);
                                }
                                this.style && this._sourcesDirty && (this._sourcesDirty = !1, this.style._updateSources(this.transform)), this.terrain ? (this.terrain.sourceCache.update(this.transform, this.terrain), this.transform.minElevationForCurrentTile = this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom), this._elevationFreeze || (this.transform.elevation = this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom))) : (this.transform.minElevationForCurrentTile = 0, this.transform.elevation = 0), this._placementDirty = this.style && this.style._updatePlacement(this.painter.transform, this.showCollisionBoxes, r, this._crossSourceCollisions), this.painter.render(this.style, {
                                    showTileBoundaries: this.showTileBoundaries,
                                    showOverdrawInspector: this._showOverdrawInspector,
                                    rotating: this.isRotating(),
                                    zooming: this.isZooming(),
                                    moving: this.isMoving(),
                                    fadeDuration: r,
                                    showPadding: this.showPadding
                                }), this.fire(new e1.k("render")), this.loaded() && !this._loaded && (this._loaded = !0, e1.be.mark(e1.bf.load), this.fire(new e1.k("load"))), this.style && (this.style.hasTransitions() || n) && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles();
                                const i = this._sourcesDirty || this._styleDirty || this._placementDirty;
                                return i || this._repaint ? this.triggerRepaint() : !this.isMoving() && this.loaded() && this.fire(new e1.k("idle")), !this._loaded || this._fullyLoaded || i || (this._fullyLoaded = !0, e1.be.mark(e1.bf.fullLoad)), this;
                            }
                            redraw() {
                                return this.style && (this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._render(0)), this;
                            }
                            remove() {
                                var t1;
                                this._hash && this._hash.remove();
                                for (const t1 of this._controls)t1.onRemove(this);
                                this._controls = [], this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._renderTaskQueue.clear(), this.painter.destroy(), this.handlers.destroy(), delete this.handlers, this.setStyle(null), "undefined" != typeof window && removeEventListener("online", this._onWindowOnline, !1), p.removeThrottleControl(this._imageQueueHandle), null === (t1 = this._resizeObserver) || void 0 === t1 || t1.disconnect();
                                const r = this.painter.context.gl.getExtension("WEBGL_lose_context");
                                (null == r ? void 0 : r.loseContext) && r.loseContext(), this._canvas.removeEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.removeEventListener("webglcontextlost", this._contextLost, !1), o.remove(this._canvasContainer), o.remove(this._controlContainer), this._container.classList.remove("maplibregl-map"), e1.be.clearMetrics(), this._removed = !0, this.fire(new e1.k("remove"));
                            }
                            triggerRepaint() {
                                this.style && !this._frameRequest && (this._frameRequest = new AbortController, a.frameAsync(this._frameRequest).then((t1)=>{
                                    e1.be.frame(t1), this._frameRequest = null, this._render(t1);
                                }).catch(()=>{}));
                            }
                            get showTileBoundaries() {
                                return !!this._showTileBoundaries;
                            }
                            set showTileBoundaries(t1) {
                                this._showTileBoundaries !== t1 && (this._showTileBoundaries = t1, this._update());
                            }
                            get showPadding() {
                                return !!this._showPadding;
                            }
                            set showPadding(t1) {
                                this._showPadding !== t1 && (this._showPadding = t1, this._update());
                            }
                            get showCollisionBoxes() {
                                return !!this._showCollisionBoxes;
                            }
                            set showCollisionBoxes(t1) {
                                this._showCollisionBoxes !== t1 && (this._showCollisionBoxes = t1, t1 ? this.style._generateCollisionBoxes() : this._update());
                            }
                            get showOverdrawInspector() {
                                return !!this._showOverdrawInspector;
                            }
                            set showOverdrawInspector(t1) {
                                this._showOverdrawInspector !== t1 && (this._showOverdrawInspector = t1, this._update());
                            }
                            get repaint() {
                                return !!this._repaint;
                            }
                            set repaint(t1) {
                                this._repaint !== t1 && (this._repaint = t1, this.triggerRepaint());
                            }
                            get vertices() {
                                return !!this._vertices;
                            }
                            set vertices(t1) {
                                this._vertices = t1, this._update();
                            }
                            get version() {
                                return ji;
                            }
                            getCameraTargetElevation() {
                                return this.transform.elevation;
                            }
                        }, t1.MapMouseEvent = Nn, t1.MapTouchEvent = jn, t1.MapWheelEvent = Un, t1.Marker = Xi, t1.NavigationControl = class {
                            constructor(t1){
                                this._updateZoomButtons = ()=>{
                                    const t1 = this._map.getZoom(), e1 = t1 === this._map.getMaxZoom(), r = t1 === this._map.getMinZoom();
                                    this._zoomInButton.disabled = e1, this._zoomOutButton.disabled = r, this._zoomInButton.setAttribute("aria-disabled", e1.toString()), this._zoomOutButton.setAttribute("aria-disabled", r.toString());
                                }, this._rotateCompassArrow = ()=>{
                                    const t1 = this.options.visualizePitch ? `scale(${1 / Math.pow(Math.cos(this._map.transform.pitch * (Math.PI / 180)), .5)}) rotateX(${this._map.transform.pitch}deg) rotateZ(${this._map.transform.angle * (180 / Math.PI)}deg)` : `rotate(${this._map.transform.angle * (180 / Math.PI)}deg)`;
                                    this._compassIcon.style.transform = t1;
                                }, this._setButtonTitle = (t1, e1)=>{
                                    const r = this._map._getUIString(`NavigationControl.${e1}`);
                                    t1.title = r, t1.setAttribute("aria-label", r);
                                }, this.options = e1.e({}, qi, t1), this._container = o.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._container.addEventListener("contextmenu", (t1)=>t1.preventDefault()), this.options.showZoom && (this._zoomInButton = this._createButton("maplibregl-ctrl-zoom-in", (t1)=>this._map.zoomIn({}, {
                                        originalEvent: t1
                                    })), o.create("span", "maplibregl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("maplibregl-ctrl-zoom-out", (t1)=>this._map.zoomOut({}, {
                                        originalEvent: t1
                                    })), o.create("span", "maplibregl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (this._compass = this._createButton("maplibregl-ctrl-compass", (t1)=>{
                                    this.options.visualizePitch ? this._map.resetNorthPitch({}, {
                                        originalEvent: t1
                                    }) : this._map.resetNorth({}, {
                                        originalEvent: t1
                                    });
                                }), this._compassIcon = o.create("span", "maplibregl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
                            }
                            onAdd(t1) {
                                return this._map = t1, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), this._map.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && this._map.on("pitch", this._rotateCompassArrow), this._map.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new Hi(this._map, this._compass, this.options.visualizePitch)), this._container;
                            }
                            onRemove() {
                                o.remove(this._container), this.options.showZoom && this._map.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && this._map.off("pitch", this._rotateCompassArrow), this._map.off("rotate", this._rotateCompassArrow), this._handler.off(), delete this._handler), delete this._map;
                            }
                            _createButton(t1, e1) {
                                const r = o.create("button", t1, this._container);
                                return r.type = "button", r.addEventListener("click", e1), r;
                            }
                        }, t1.Popup = oa, t1.RasterDEMTileSource = Q, t1.RasterTileSource = K, t1.ScaleControl = class {
                            constructor(t1){
                                this._onMove = ()=>{
                                    ea(this._map, this._container, this.options);
                                }, this.setUnit = (t1)=>{
                                    this.options.unit = t1, ea(this._map, this._container, this.options);
                                }, this.options = Object.assign(Object.assign({}, ta), t1);
                            }
                            getDefaultPosition() {
                                return "bottom-left";
                            }
                            onAdd(t1) {
                                return this._map = t1, this._container = o.create("div", "maplibregl-ctrl maplibregl-ctrl-scale", t1.getContainer()), this._map.on("move", this._onMove), this._onMove(), this._container;
                            }
                            onRemove() {
                                o.remove(this._container), this._map.off("move", this._onMove), this._map = void 0;
                            }
                        }, t1.ScrollZoomHandler = gi, t1.Style = de, t1.TerrainControl = class {
                            constructor(t1){
                                this._toggleTerrain = ()=>{
                                    this._map.getTerrain() ? this._map.setTerrain(null) : this._map.setTerrain(this.options), this._updateTerrainIcon();
                                }, this._updateTerrainIcon = ()=>{
                                    this._terrainButton.classList.remove("maplibregl-ctrl-terrain"), this._terrainButton.classList.remove("maplibregl-ctrl-terrain-enabled"), this._map.terrain ? (this._terrainButton.classList.add("maplibregl-ctrl-terrain-enabled"), this._terrainButton.title = this._map._getUIString("TerrainControl.Disable")) : (this._terrainButton.classList.add("maplibregl-ctrl-terrain"), this._terrainButton.title = this._map._getUIString("TerrainControl.Enable"));
                                }, this.options = t1;
                            }
                            onAdd(t1) {
                                return this._map = t1, this._container = o.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._terrainButton = o.create("button", "maplibregl-ctrl-terrain", this._container), o.create("span", "maplibregl-ctrl-icon", this._terrainButton).setAttribute("aria-hidden", "true"), this._terrainButton.type = "button", this._terrainButton.addEventListener("click", this._toggleTerrain), this._updateTerrainIcon(), this._map.on("terrain", this._updateTerrainIcon), this._container;
                            }
                            onRemove() {
                                o.remove(this._container), this._map.off("terrain", this._updateTerrainIcon), this._map = void 0;
                            }
                        }, t1.TwoFingersTouchPitchHandler = hi, t1.TwoFingersTouchRotateHandler = ci, t1.TwoFingersTouchZoomHandler = si, t1.TwoFingersTouchZoomRotateHandler = wi, t1.VectorTileSource = J, t1.VideoSource = nt, t1.addSourceType = (t1, r)=>e1._(void 0, void 0, void 0, function*() {
                                if (ot(t1)) throw new Error(`A source type called "${t1}" already exists.`);
                                ((t1, e1)=>{
                                    at[t1] = e1;
                                })(t1, r);
                            }), t1.clearPrewarmedResources = function() {
                            const t1 = j;
                            t1 && (t1.isPreloaded() && 1 === t1.numActive() ? (t1.release(F), j = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
                        }, t1.getMaxParallelImageRequests = function() {
                            return e1.a.MAX_PARALLEL_IMAGE_REQUESTS;
                        }, t1.getRTLTextPluginStatus = function() {
                            return ut().getRTLTextPluginStatus();
                        }, t1.getVersion = function() {
                            return la;
                        }, t1.getWorkerCount = function() {
                            return B.workerCount;
                        }, t1.getWorkerUrl = function() {
                            return e1.a.WORKER_URL;
                        }, t1.importScriptInWorkers = function(t1) {
                            return H().broadcast("IS", t1);
                        }, t1.prewarm = function() {
                            V().acquire(F);
                        }, t1.setMaxParallelImageRequests = function(t1) {
                            e1.a.MAX_PARALLEL_IMAGE_REQUESTS = t1;
                        }, t1.setRTLTextPlugin = function(t1, e1) {
                            return ut().setRTLTextPlugin(t1, e1);
                        }, t1.setWorkerCount = function(t1) {
                            B.workerCount = t1;
                        }, t1.setWorkerUrl = function(t1) {
                            e1.a.WORKER_URL = t1;
                        };
                    }), t1;
                }();
            },
            88640: function(t1, e1, r) {
                "use strict";
                function n(t1, e1, r) {
                    t1.prototype = e1.prototype = r, r.constructor = t1;
                }
                function i(t1, e1) {
                    var r = Object.create(t1.prototype);
                    for(var n in e1)r[n] = e1[n];
                    return r;
                }
                function a() {}
                r.d(e1, {
                    GW: function() {
                        return K;
                    },
                    Dj: function() {
                        return H;
                    }
                });
                var o = .7, s = 1 / o, l = "\\s*([+-]?\\d+)\\s*", c = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", u = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", h = /^#([0-9a-f]{3,8})$/, f = new RegExp("^rgb\\(".concat(l, ",").concat(l, ",").concat(l, "\\)$")), p = new RegExp("^rgb\\(".concat(u, ",").concat(u, ",").concat(u, "\\)$")), d = new RegExp("^rgba\\(".concat(l, ",").concat(l, ",").concat(l, ",").concat(c, "\\)$")), m = new RegExp("^rgba\\(".concat(u, ",").concat(u, ",").concat(u, ",").concat(c, "\\)$")), g = new RegExp("^hsl\\(".concat(c, ",").concat(u, ",").concat(u, "\\)$")), y = new RegExp("^hsla\\(".concat(c, ",").concat(u, ",").concat(u, ",").concat(c, "\\)$")), v = {
                    aliceblue: 15792383,
                    antiquewhite: 16444375,
                    aqua: 65535,
                    aquamarine: 8388564,
                    azure: 15794175,
                    beige: 16119260,
                    bisque: 16770244,
                    black: 0,
                    blanchedalmond: 16772045,
                    blue: 255,
                    blueviolet: 9055202,
                    brown: 10824234,
                    burlywood: 14596231,
                    cadetblue: 6266528,
                    chartreuse: 8388352,
                    chocolate: 13789470,
                    coral: 16744272,
                    cornflowerblue: 6591981,
                    cornsilk: 16775388,
                    crimson: 14423100,
                    cyan: 65535,
                    darkblue: 139,
                    darkcyan: 35723,
                    darkgoldenrod: 12092939,
                    darkgray: 11119017,
                    darkgreen: 25600,
                    darkgrey: 11119017,
                    darkkhaki: 12433259,
                    darkmagenta: 9109643,
                    darkolivegreen: 5597999,
                    darkorange: 16747520,
                    darkorchid: 10040012,
                    darkred: 9109504,
                    darksalmon: 15308410,
                    darkseagreen: 9419919,
                    darkslateblue: 4734347,
                    darkslategray: 3100495,
                    darkslategrey: 3100495,
                    darkturquoise: 52945,
                    darkviolet: 9699539,
                    deeppink: 16716947,
                    deepskyblue: 49151,
                    dimgray: 6908265,
                    dimgrey: 6908265,
                    dodgerblue: 2003199,
                    firebrick: 11674146,
                    floralwhite: 16775920,
                    forestgreen: 2263842,
                    fuchsia: 16711935,
                    gainsboro: 14474460,
                    ghostwhite: 16316671,
                    gold: 16766720,
                    goldenrod: 14329120,
                    gray: 8421504,
                    green: 32768,
                    greenyellow: 11403055,
                    grey: 8421504,
                    honeydew: 15794160,
                    hotpink: 16738740,
                    indianred: 13458524,
                    indigo: 4915330,
                    ivory: 16777200,
                    khaki: 15787660,
                    lavender: 15132410,
                    lavenderblush: 16773365,
                    lawngreen: 8190976,
                    lemonchiffon: 16775885,
                    lightblue: 11393254,
                    lightcoral: 15761536,
                    lightcyan: 14745599,
                    lightgoldenrodyellow: 16448210,
                    lightgray: 13882323,
                    lightgreen: 9498256,
                    lightgrey: 13882323,
                    lightpink: 16758465,
                    lightsalmon: 16752762,
                    lightseagreen: 2142890,
                    lightskyblue: 8900346,
                    lightslategray: 7833753,
                    lightslategrey: 7833753,
                    lightsteelblue: 11584734,
                    lightyellow: 16777184,
                    lime: 65280,
                    limegreen: 3329330,
                    linen: 16445670,
                    magenta: 16711935,
                    maroon: 8388608,
                    mediumaquamarine: 6737322,
                    mediumblue: 205,
                    mediumorchid: 12211667,
                    mediumpurple: 9662683,
                    mediumseagreen: 3978097,
                    mediumslateblue: 8087790,
                    mediumspringgreen: 64154,
                    mediumturquoise: 4772300,
                    mediumvioletred: 13047173,
                    midnightblue: 1644912,
                    mintcream: 16121850,
                    mistyrose: 16770273,
                    moccasin: 16770229,
                    navajowhite: 16768685,
                    navy: 128,
                    oldlace: 16643558,
                    olive: 8421376,
                    olivedrab: 7048739,
                    orange: 16753920,
                    orangered: 16729344,
                    orchid: 14315734,
                    palegoldenrod: 15657130,
                    palegreen: 10025880,
                    paleturquoise: 11529966,
                    palevioletred: 14381203,
                    papayawhip: 16773077,
                    peachpuff: 16767673,
                    peru: 13468991,
                    pink: 16761035,
                    plum: 14524637,
                    powderblue: 11591910,
                    purple: 8388736,
                    rebeccapurple: 6697881,
                    red: 16711680,
                    rosybrown: 12357519,
                    royalblue: 4286945,
                    saddlebrown: 9127187,
                    salmon: 16416882,
                    sandybrown: 16032864,
                    seagreen: 3050327,
                    seashell: 16774638,
                    sienna: 10506797,
                    silver: 12632256,
                    skyblue: 8900331,
                    slateblue: 6970061,
                    slategray: 7372944,
                    slategrey: 7372944,
                    snow: 16775930,
                    springgreen: 65407,
                    steelblue: 4620980,
                    tan: 13808780,
                    teal: 32896,
                    thistle: 14204888,
                    tomato: 16737095,
                    turquoise: 4251856,
                    violet: 15631086,
                    wheat: 16113331,
                    white: 16777215,
                    whitesmoke: 16119285,
                    yellow: 16776960,
                    yellowgreen: 10145074
                };
                function x() {
                    return this.rgb().formatHex();
                }
                function _() {
                    return this.rgb().formatRgb();
                }
                function b(t1) {
                    var e1, r;
                    return t1 = (t1 + "").trim().toLowerCase(), (e1 = h.exec(t1)) ? (r = e1[1].length, e1 = parseInt(e1[1], 16), 6 === r ? w(e1) : 3 === r ? new A(e1 >> 8 & 15 | e1 >> 4 & 240, e1 >> 4 & 15 | 240 & e1, (15 & e1) << 4 | 15 & e1, 1) : 8 === r ? T(e1 >> 24 & 255, e1 >> 16 & 255, e1 >> 8 & 255, (255 & e1) / 255) : 4 === r ? T(e1 >> 12 & 15 | e1 >> 8 & 240, e1 >> 8 & 15 | e1 >> 4 & 240, e1 >> 4 & 15 | 240 & e1, ((15 & e1) << 4 | 15 & e1) / 255) : null) : (e1 = f.exec(t1)) ? new A(e1[1], e1[2], e1[3], 1) : (e1 = p.exec(t1)) ? new A(255 * e1[1] / 100, 255 * e1[2] / 100, 255 * e1[3] / 100, 1) : (e1 = d.exec(t1)) ? T(e1[1], e1[2], e1[3], e1[4]) : (e1 = m.exec(t1)) ? T(255 * e1[1] / 100, 255 * e1[2] / 100, 255 * e1[3] / 100, e1[4]) : (e1 = g.exec(t1)) ? I(e1[1], e1[2] / 100, e1[3] / 100, 1) : (e1 = y.exec(t1)) ? I(e1[1], e1[2] / 100, e1[3] / 100, e1[4]) : v.hasOwnProperty(t1) ? w(v[t1]) : "transparent" === t1 ? new A(NaN, NaN, NaN, 0) : null;
                }
                function w(t1) {
                    return new A(t1 >> 16 & 255, t1 >> 8 & 255, 255 & t1, 1);
                }
                function T(t1, e1, r, n) {
                    return n <= 0 && (t1 = e1 = r = NaN), new A(t1, e1, r, n);
                }
                function k(t1, e1, r, n) {
                    var i;
                    return 1 === arguments.length ? ((i = t1) instanceof a || (i = b(i)), i ? new A((i = i.rgb()).r, i.g, i.b, i.opacity) : new A) : new A(t1, e1, r, null == n ? 1 : n);
                }
                function A(t1, e1, r, n) {
                    this.r = +t1, this.g = +e1, this.b = +r, this.opacity = +n;
                }
                function M() {
                    return "#".concat(L(this.r)).concat(L(this.g)).concat(L(this.b));
                }
                function S() {
                    var t1 = E(this.opacity);
                    return "".concat(1 === t1 ? "rgb(" : "rgba(").concat(C(this.r), ", ").concat(C(this.g), ", ").concat(C(this.b)).concat(1 === t1 ? ")" : ", ".concat(t1, ")"));
                }
                function E(t1) {
                    return isNaN(t1) ? 1 : Math.max(0, Math.min(1, t1));
                }
                function C(t1) {
                    return Math.max(0, Math.min(255, Math.round(t1) || 0));
                }
                function L(t1) {
                    return ((t1 = C(t1)) < 16 ? "0" : "") + t1.toString(16);
                }
                function I(t1, e1, r, n) {
                    return n <= 0 ? t1 = e1 = r = NaN : r <= 0 || r >= 1 ? t1 = e1 = NaN : e1 <= 0 && (t1 = NaN), new z(t1, e1, r, n);
                }
                function P(t1) {
                    if (t1 instanceof z) return new z(t1.h, t1.s, t1.l, t1.opacity);
                    if (t1 instanceof a || (t1 = b(t1)), !t1) return new z;
                    if (t1 instanceof z) return t1;
                    var e1 = (t1 = t1.rgb()).r / 255, r = t1.g / 255, n = t1.b / 255, i = Math.min(e1, r, n), o = Math.max(e1, r, n), s = NaN, l = o - i, c = (o + i) / 2;
                    return l ? (s = e1 === o ? (r - n) / l + 6 * (r < n) : r === o ? (n - e1) / l + 2 : (e1 - r) / l + 4, l /= c < .5 ? o + i : 2 - o - i, s *= 60) : l = c > 0 && c < 1 ? 0 : s, new z(s, l, c, t1.opacity);
                }
                function z(t1, e1, r, n) {
                    this.h = +t1, this.s = +e1, this.l = +r, this.opacity = +n;
                }
                function O(t1) {
                    return (t1 = (t1 || 0) % 360) < 0 ? t1 + 360 : t1;
                }
                function D(t1) {
                    return Math.max(0, Math.min(1, t1 || 0));
                }
                function R(t1, e1, r) {
                    return 255 * (t1 < 60 ? e1 + (r - e1) * t1 / 60 : t1 < 180 ? r : t1 < 240 ? e1 + (r - e1) * (240 - t1) / 60 : e1);
                }
                function F(t1, e1, r, n, i) {
                    var a = t1 * t1, o = a * t1;
                    return ((1 - 3 * t1 + 3 * a - o) * e1 + (4 - 6 * a + 3 * o) * r + (1 + 3 * t1 + 3 * a - 3 * o) * n + o * i) / 6;
                }
                n(a, b, {
                    copy: function(t1) {
                        return Object.assign(new this.constructor, this, t1);
                    },
                    displayable: function() {
                        return this.rgb().displayable();
                    },
                    hex: x,
                    formatHex: x,
                    formatHex8: function() {
                        return this.rgb().formatHex8();
                    },
                    formatHsl: function() {
                        return P(this).formatHsl();
                    },
                    formatRgb: _,
                    toString: _
                }), n(A, k, i(a, {
                    brighter: function(t1) {
                        return t1 = null == t1 ? s : Math.pow(s, t1), new A(this.r * t1, this.g * t1, this.b * t1, this.opacity);
                    },
                    darker: function(t1) {
                        return t1 = null == t1 ? o : Math.pow(o, t1), new A(this.r * t1, this.g * t1, this.b * t1, this.opacity);
                    },
                    rgb: function() {
                        return this;
                    },
                    clamp: function() {
                        return new A(C(this.r), C(this.g), C(this.b), E(this.opacity));
                    },
                    displayable: function() {
                        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
                    },
                    hex: M,
                    formatHex: M,
                    formatHex8: function() {
                        return "#".concat(L(this.r)).concat(L(this.g)).concat(L(this.b)).concat(L(255 * (isNaN(this.opacity) ? 1 : this.opacity)));
                    },
                    formatRgb: S,
                    toString: S
                })), n(z, function(t1, e1, r, n) {
                    return 1 === arguments.length ? P(t1) : new z(t1, e1, r, null == n ? 1 : n);
                }, i(a, {
                    brighter: function(t1) {
                        return t1 = null == t1 ? s : Math.pow(s, t1), new z(this.h, this.s, this.l * t1, this.opacity);
                    },
                    darker: function(t1) {
                        return t1 = null == t1 ? o : Math.pow(o, t1), new z(this.h, this.s, this.l * t1, this.opacity);
                    },
                    rgb: function() {
                        var t1 = this.h % 360 + 360 * (this.h < 0), e1 = isNaN(t1) || isNaN(this.s) ? 0 : this.s, r = this.l, n = r + (r < .5 ? r : 1 - r) * e1, i = 2 * r - n;
                        return new A(R(t1 >= 240 ? t1 - 240 : t1 + 120, i, n), R(t1, i, n), R(t1 < 120 ? t1 + 240 : t1 - 120, i, n), this.opacity);
                    },
                    clamp: function() {
                        return new z(O(this.h), D(this.s), D(this.l), E(this.opacity));
                    },
                    displayable: function() {
                        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
                    },
                    formatHsl: function() {
                        var t1 = E(this.opacity);
                        return "".concat(1 === t1 ? "hsl(" : "hsla(").concat(O(this.h), ", ").concat(100 * D(this.s), "%, ").concat(100 * D(this.l), "%").concat(1 === t1 ? ")" : ", ".concat(t1, ")"));
                    }
                }));
                var B = function(t1) {
                    return function() {
                        return t1;
                    };
                };
                function N(t1, e1) {
                    var r = e1 - t1;
                    return r ? function(t1, e1) {
                        return function(r) {
                            return t1 + r * e1;
                        };
                    }(t1, r) : B(isNaN(t1) ? e1 : t1);
                }
                var j = function t1(e1) {
                    var r = function(t1) {
                        return 1 == (t1 = +t1) ? N : function(e1, r) {
                            return r - e1 ? function(t1, e1, r) {
                                return t1 = Math.pow(t1, r), e1 = Math.pow(e1, r) - t1, r = 1 / r, function(n) {
                                    return Math.pow(t1 + n * e1, r);
                                };
                            }(e1, r, t1) : B(isNaN(e1) ? r : e1);
                        };
                    }(e1);
                    function n(t1, e1) {
                        var n = r((t1 = k(t1)).r, (e1 = k(e1)).r), i = r(t1.g, e1.g), a = r(t1.b, e1.b), o = N(t1.opacity, e1.opacity);
                        return function(e1) {
                            return t1.r = n(e1), t1.g = i(e1), t1.b = a(e1), t1.opacity = o(e1), t1 + "";
                        };
                    }
                    return n.gamma = t1, n;
                }(1);
                function U(t1) {
                    return function(e1) {
                        var r, n, i = e1.length, a = new Array(i), o = new Array(i), s = new Array(i);
                        for(r = 0; r < i; ++r)n = k(e1[r]), a[r] = n.r || 0, o[r] = n.g || 0, s[r] = n.b || 0;
                        return a = t1(a), o = t1(o), s = t1(s), n.opacity = 1, function(t1) {
                            return n.r = a(t1), n.g = o(t1), n.b = s(t1), n + "";
                        };
                    };
                }
                function V(t1, e1) {
                    var r, n = e1 ? e1.length : 0, i = t1 ? Math.min(n, t1.length) : 0, a = new Array(i), o = new Array(n);
                    for(r = 0; r < i; ++r)a[r] = K(t1[r], e1[r]);
                    for(; r < n; ++r)o[r] = e1[r];
                    return function(t1) {
                        for(r = 0; r < i; ++r)o[r] = a[r](t1);
                        return o;
                    };
                }
                function q(t1, e1) {
                    var r = new Date;
                    return t1 = +t1, e1 = +e1, function(n) {
                        return r.setTime(t1 * (1 - n) + e1 * n), r;
                    };
                }
                function H(t1, e1) {
                    return t1 = +t1, e1 = +e1, function(r) {
                        return t1 * (1 - r) + e1 * r;
                    };
                }
                function G(t1) {
                    return G = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                        return typeof t1;
                    } : function(t1) {
                        return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                    }, G(t1);
                }
                function Z(t1, e1) {
                    var r, n = {}, i = {};
                    for(r in null !== t1 && "object" === G(t1) || (t1 = {}), null !== e1 && "object" === G(e1) || (e1 = {}), e1)r in t1 ? n[r] = K(t1[r], e1[r]) : i[r] = e1[r];
                    return function(t1) {
                        for(r in n)i[r] = n[r](t1);
                        return i;
                    };
                }
                U(function(t1) {
                    var e1 = t1.length - 1;
                    return function(r) {
                        var n = r <= 0 ? r = 0 : r >= 1 ? (r = 1, e1 - 1) : Math.floor(r * e1), i = t1[n], a = t1[n + 1], o = n > 0 ? t1[n - 1] : 2 * i - a, s = n < e1 - 1 ? t1[n + 2] : 2 * a - i;
                        return F((r - n / e1) * e1, o, i, a, s);
                    };
                }), U(function(t1) {
                    var e1 = t1.length;
                    return function(r) {
                        var n = Math.floor(((r %= 1) < 0 ? ++r : r) * e1), i = t1[(n + e1 - 1) % e1], a = t1[n % e1], o = t1[(n + 1) % e1], s = t1[(n + 2) % e1];
                        return F((r - n / e1) * e1, i, a, o, s);
                    };
                });
                var W = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, Y = new RegExp(W.source, "g");
                function X(t1, e1) {
                    var r, n, i, a = W.lastIndex = Y.lastIndex = 0, o = -1, s = [], l = [];
                    for(t1 += "", e1 += ""; (r = W.exec(t1)) && (n = Y.exec(e1));)(i = n.index) > a && (i = e1.slice(a, i), s[o] ? s[o] += i : s[++o] = i), (r = r[0]) === (n = n[0]) ? s[o] ? s[o] += n : s[++o] = n : (s[++o] = null, l.push({
                        i: o,
                        x: H(r, n)
                    })), a = Y.lastIndex;
                    return a < e1.length && (i = e1.slice(a), s[o] ? s[o] += i : s[++o] = i), s.length < 2 ? l[0] ? function(t1) {
                        return function(e1) {
                            return t1(e1) + "";
                        };
                    }(l[0].x) : function(t1) {
                        return function() {
                            return t1;
                        };
                    }(e1) : (e1 = l.length, function(t1) {
                        for(var r, n = 0; n < e1; ++n)s[(r = l[n]).i] = r.x(t1);
                        return s.join("");
                    });
                }
                function $(t1, e1) {
                    e1 || (e1 = []);
                    var r, n = t1 ? Math.min(e1.length, t1.length) : 0, i = e1.slice();
                    return function(a) {
                        for(r = 0; r < n; ++r)i[r] = t1[r] * (1 - a) + e1[r] * a;
                        return i;
                    };
                }
                function J(t1) {
                    return J = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                        return typeof t1;
                    } : function(t1) {
                        return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                    }, J(t1);
                }
                function K(t1, e1) {
                    var r, n, i = J(e1);
                    return null == e1 || "boolean" === i ? B(e1) : ("number" === i ? H : "string" === i ? (r = b(e1)) ? (e1 = r, j) : X : e1 instanceof b ? j : e1 instanceof Date ? q : (n = e1, !ArrayBuffer.isView(n) || n instanceof DataView ? Array.isArray(e1) ? V : "function" != typeof e1.valueOf && "function" != typeof e1.toString || isNaN(e1) ? Z : H : $))(t1, e1);
                }
            },
            23648: function(t1) {
                "use strict";
                t1.exports = JSON.parse('["xx-small","x-small","small","medium","large","x-large","xx-large","larger","smaller"]');
            },
            2362: function(t1) {
                "use strict";
                t1.exports = JSON.parse('["normal","condensed","semi-condensed","extra-condensed","ultra-condensed","expanded","semi-expanded","extra-expanded","ultra-expanded"]');
            },
            87486: function(t1) {
                "use strict";
                t1.exports = JSON.parse('["normal","italic","oblique"]');
            },
            99803: function(t1) {
                "use strict";
                t1.exports = JSON.parse('["normal","bold","bolder","lighter","100","200","300","400","500","600","700","800","900"]');
            },
            54324: function(t1) {
                "use strict";
                t1.exports = JSON.parse('["inherit","initial","unset"]');
            },
            94316: function(t1) {
                "use strict";
                t1.exports = JSON.parse('["caption","icon","menu","message-box","small-caption","status-bar"]');
            },
            37071: function(t1) {
                "use strict";
                t1.exports = JSON.parse('{"version":8,"name":"orto","metadata":{"maputnik:renderer":"mlgljs"},"center":[1.537786,41.837539],"zoom":12,"bearing":0,"pitch":0,"light":{"anchor":"viewport","color":"white","intensity":0.4,"position":[1.15,45,30]},"sources":{"ortoEsri":{"type":"raster","tiles":["https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"],"tileSize":256,"maxzoom":18,"attribution":"ESRI &copy; <a href=\'http://www.esri.com\'>ESRI</a>"},"ortoInstaMaps":{"type":"raster","tiles":["https://tilemaps.icgc.cat/mapfactory/wmts/orto_8_12/CAT3857/{z}/{x}/{y}.png"],"tileSize":256,"maxzoom":13},"ortoICGC":{"type":"raster","tiles":["https://geoserveis.icgc.cat/icc_mapesmultibase/noutm/wmts/orto/GRID3857/{z}/{x}/{y}.jpeg"],"tileSize":256,"minzoom":13.1,"maxzoom":20},"openmaptiles":{"type":"vector","url":"https://geoserveis.icgc.cat/contextmaps/basemap.json"}},"sprite":"https://geoserveis.icgc.cat/contextmaps/sprites/sprite@1","glyphs":"https://geoserveis.icgc.cat/contextmaps/glyphs/{fontstack}/{range}.pbf","layers":[{"id":"background","type":"background","paint":{"background-color":"#F4F9F4"}},{"id":"ortoEsri","type":"raster","source":"ortoEsri","maxzoom":16,"layout":{"visibility":"visible"}},{"id":"ortoICGC","type":"raster","source":"ortoICGC","minzoom":13.1,"maxzoom":19,"layout":{"visibility":"visible"}},{"id":"ortoInstaMaps","type":"raster","source":"ortoInstaMaps","maxzoom":13,"layout":{"visibility":"visible"}},{"id":"waterway_tunnel","type":"line","source":"openmaptiles","source-layer":"waterway","minzoom":14,"filter":["all",["in","class","river","stream","canal"],["==","brunnel","tunnel"]],"layout":{"line-cap":"round"},"paint":{"line-color":"#a0c8f0","line-width":{"base":1.3,"stops":[[13,0.5],[20,6]]},"line-dasharray":[2,4]}},{"id":"waterway-other","type":"line","metadata":{"mapbox:group":"1444849382550.77"},"source":"openmaptiles","source-layer":"waterway","filter":["!in","class","canal","river","stream"],"layout":{"line-cap":"round"},"paint":{"line-color":"#a0c8f0","line-width":{"base":1.3,"stops":[[13,0.5],[20,2]]}}},{"id":"waterway-stream-canal","type":"line","metadata":{"mapbox:group":"1444849382550.77"},"source":"openmaptiles","source-layer":"waterway","filter":["all",["in","class","canal","stream"],["!=","brunnel","tunnel"]],"layout":{"line-cap":"round"},"paint":{"line-color":"#a0c8f0","line-width":{"base":1.3,"stops":[[13,0.5],[20,6]]}}},{"id":"waterway-river","type":"line","metadata":{"mapbox:group":"1444849382550.77"},"source":"openmaptiles","source-layer":"waterway","filter":["all",["==","class","river"],["!=","brunnel","tunnel"]],"layout":{"line-cap":"round"},"paint":{"line-color":"#a0c8f0","line-width":{"base":1.2,"stops":[[10,0.8],[20,4]]},"line-opacity":0.5}},{"id":"water-offset","type":"fill","metadata":{"mapbox:group":"1444849382550.77"},"source":"openmaptiles","source-layer":"water","maxzoom":8,"filter":["==","$type","Polygon"],"layout":{"visibility":"visible"},"paint":{"fill-opacity":0,"fill-color":"#a0c8f0","fill-translate":{"base":1,"stops":[[6,[2,0]],[8,[0,0]]]}}},{"id":"water","type":"fill","metadata":{"mapbox:group":"1444849382550.77"},"source":"openmaptiles","source-layer":"water","layout":{"visibility":"visible"},"paint":{"fill-color":"hsl(210, 67%, 85%)","fill-opacity":0}},{"id":"water-pattern","type":"fill","metadata":{"mapbox:group":"1444849382550.77"},"source":"openmaptiles","source-layer":"water","layout":{"visibility":"visible"},"paint":{"fill-translate":[0,2.5],"fill-pattern":"wave","fill-opacity":1}},{"id":"landcover-ice-shelf","type":"fill","metadata":{"mapbox:group":"1444849382550.77"},"source":"openmaptiles","source-layer":"landcover","filter":["==","subclass","ice_shelf"],"layout":{"visibility":"visible"},"paint":{"fill-color":"#fff","fill-opacity":{"base":1,"stops":[[0,0.9],[10,0.3]]}}},{"id":"tunnel-service-track-casing","type":"line","metadata":{"mapbox:group":"1444849354174.1904"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","tunnel"],["in","class","service","track"]],"layout":{"line-join":"round"},"paint":{"line-color":"#cfcdca","line-dasharray":[0.5,0.25],"line-width":{"base":1.2,"stops":[[15,1],[16,4],[20,11]]}}},{"id":"tunnel-minor-casing","type":"line","metadata":{"mapbox:group":"1444849354174.1904"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","tunnel"],["==","class","minor"]],"layout":{"line-join":"round"},"paint":{"line-color":"#cfcdca","line-opacity":{"stops":[[12,0],[12.5,1]]},"line-width":{"base":1.2,"stops":[[12,0.5],[13,1],[14,4],[20,15]]}}},{"id":"tunnel-secondary-tertiary-casing","type":"line","metadata":{"mapbox:group":"1444849354174.1904"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","tunnel"],["in","class","secondary","tertiary"]],"layout":{"line-join":"round"},"paint":{"line-color":"#e9ac77","line-opacity":1,"line-width":{"base":1.2,"stops":[[8,1.5],[20,17]]}}},{"id":"tunnel-trunk-primary-casing","type":"line","metadata":{"mapbox:group":"1444849354174.1904"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","tunnel"],["in","class","primary","trunk"]],"layout":{"line-join":"round"},"paint":{"line-color":"#e9ac77","line-width":{"base":1.2,"stops":[[5,0.4],[6,0.6],[7,1.5],[20,22]]},"line-opacity":0.7}},{"id":"tunnel-motorway-casing","type":"line","metadata":{"mapbox:group":"1444849354174.1904"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","tunnel"],["==","class","motorway"]],"layout":{"line-join":"round","visibility":"visible"},"paint":{"line-color":"#e9ac77","line-dasharray":[0.5,0.25],"line-width":{"base":1.2,"stops":[[5,0.4],[6,0.6],[7,1.5],[20,22]]},"line-opacity":0.5}},{"id":"tunnel-path","type":"line","metadata":{"mapbox:group":"1444849354174.1904"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","$type","LineString"],["all",["==","brunnel","tunnel"],["==","class","path"]]],"paint":{"line-color":"#cba","line-dasharray":[1.5,0.75],"line-width":{"base":1.2,"stops":[[15,1.2],[20,4]]}}},{"id":"tunnel-service-track","type":"line","metadata":{"mapbox:group":"1444849354174.1904"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","tunnel"],["in","class","service","track"]],"layout":{"line-join":"round"},"paint":{"line-color":"#fff","line-width":{"base":1.2,"stops":[[15.5,0],[16,2],[20,7.5]]}}},{"id":"tunnel-minor","type":"line","metadata":{"mapbox:group":"1444849354174.1904"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","tunnel"],["==","class","minor_road"]],"layout":{"line-join":"round"},"paint":{"line-color":"#fff","line-opacity":1,"line-width":{"base":1.2,"stops":[[13.5,0],[14,2.5],[20,11.5]]}}},{"id":"tunnel-secondary-tertiary","type":"line","metadata":{"mapbox:group":"1444849354174.1904"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","tunnel"],["in","class","secondary","tertiary"]],"layout":{"line-join":"round"},"paint":{"line-color":"#fff4c6","line-width":{"base":1.2,"stops":[[6.5,0],[7,0.5],[20,10]]}}},{"id":"tunnel-trunk-primary","type":"line","metadata":{"mapbox:group":"1444849354174.1904"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","tunnel"],["in","class","primary","trunk"]],"layout":{"line-join":"round"},"paint":{"line-color":"#fff4c6","line-width":{"base":1.2,"stops":[[6.5,0],[7,0.5],[20,18]]},"line-opacity":0.5}},{"id":"tunnel-motorway","type":"line","metadata":{"mapbox:group":"1444849354174.1904"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","tunnel"],["==","class","motorway"]],"layout":{"line-join":"round","visibility":"visible"},"paint":{"line-color":"#ffdaa6","line-width":{"base":1.2,"stops":[[6.5,0],[7,0.5],[20,18]]},"line-opacity":0.5}},{"id":"tunnel-railway","type":"line","metadata":{"mapbox:group":"1444849354174.1904"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","tunnel"],["==","class","rail"]],"paint":{"line-color":"#bbb","line-width":{"base":1.4,"stops":[[14,0.4],[15,0.75],[20,2]]},"line-dasharray":[2,2]}},{"id":"ferry","type":"line","source":"openmaptiles","source-layer":"transportation","filter":["all",["in","class","ferry"]],"layout":{"line-join":"round","visibility":"visible"},"paint":{"line-color":"rgba(108, 159, 182, 1)","line-width":1.1,"line-dasharray":[2,2]}},{"id":"aeroway-taxiway-casing","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"aeroway","minzoom":12,"filter":["all",["in","class","taxiway"]],"layout":{"line-cap":"round","line-join":"round","visibility":"visible"},"paint":{"line-color":"rgba(153, 153, 153, 1)","line-width":{"base":1.5,"stops":[[11,2],[17,12]]},"line-opacity":1}},{"id":"aeroway-runway-casing","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"aeroway","minzoom":12,"filter":["all",["in","class","runway"]],"layout":{"line-cap":"round","line-join":"round","visibility":"visible"},"paint":{"line-color":"rgba(153, 153, 153, 1)","line-width":{"base":1.5,"stops":[[11,5],[17,55]]},"line-opacity":1}},{"id":"aeroway-taxiway","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"aeroway","minzoom":4,"filter":["all",["in","class","taxiway"],["==","$type","LineString"]],"layout":{"line-cap":"round","line-join":"round","visibility":"visible"},"paint":{"line-color":"rgba(255, 255, 255, 1)","line-width":{"base":1.5,"stops":[[11,1],[17,10]]},"line-opacity":{"base":1,"stops":[[11,0],[12,1]]}}},{"id":"aeroway-runway","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"aeroway","minzoom":4,"filter":["all",["in","class","runway"],["==","$type","LineString"]],"layout":{"line-cap":"round","line-join":"round","visibility":"visible"},"paint":{"line-color":"rgba(255, 255, 255, 1)","line-width":{"base":1.5,"stops":[[11,4],[17,50]]},"line-opacity":{"base":1,"stops":[[11,0],[12,1]]}}},{"id":"highway-motorway-link-casing","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","minzoom":12,"filter":["all",["!in","brunnel","bridge","tunnel"],["==","class","motorway_link"]],"layout":{"line-cap":"round","line-join":"round"},"paint":{"line-color":"#e9ac77","line-opacity":1,"line-width":{"base":1.2,"stops":[[12,1],[13,3],[14,4],[20,15]]}}},{"id":"highway-link-casing","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","minzoom":13,"filter":["all",["!in","brunnel","bridge","tunnel"],["in","class","primary_link","secondary_link","tertiary_link","trunk_link"]],"layout":{"line-cap":"round","line-join":"round","visibility":"visible"},"paint":{"line-color":"#e9ac77","line-opacity":1,"line-width":{"base":1.2,"stops":[[12,1],[13,3],[14,4],[20,15]]}}},{"id":"highway-minor-casing","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","$type","LineString"],["all",["!=","brunnel","tunnel"],["in","class","minor","service","track"]]],"layout":{"line-cap":"round","line-join":"round"},"paint":{"line-color":"#cfcdca","line-opacity":{"stops":[[12,0],[12.5,0]]},"line-width":{"base":1.2,"stops":[[12,0.5],[13,1],[14,4],[20,15]]}}},{"id":"highway-secondary-tertiary-casing","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["!in","brunnel","bridge","tunnel"],["in","class","secondary","tertiary"]],"layout":{"line-cap":"butt","line-join":"round","visibility":"visible"},"paint":{"line-color":"#e9ac77","line-opacity":0.5,"line-width":{"base":1.2,"stops":[[8,1.5],[20,17]]}}},{"id":"highway-primary-casing","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","minzoom":5,"filter":["all",["!in","brunnel","bridge","tunnel"],["in","class","primary"]],"layout":{"line-cap":"butt","line-join":"round","visibility":"visible"},"paint":{"line-color":"#e9ac77","line-opacity":{"stops":[[7,0],[8,0.6]]},"line-width":{"base":1.2,"stops":[[7,0],[8,0.6],[9,1.5],[20,22]]}}},{"id":"highway-trunk-casing","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","minzoom":5,"filter":["all",["!in","brunnel","bridge","tunnel"],["in","class","trunk"]],"layout":{"line-cap":"butt","line-join":"round","visibility":"visible"},"paint":{"line-color":"#e9ac77","line-opacity":{"stops":[[5,0],[6,0.5]]},"line-width":{"base":1.2,"stops":[[5,0],[6,0.6],[7,1.5],[20,22]]}}},{"id":"highway-motorway-casing","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","minzoom":4,"filter":["all",["!in","brunnel","bridge","tunnel"],["==","class","motorway"]],"layout":{"line-cap":"butt","line-join":"round","visibility":"visible"},"paint":{"line-color":"#e9ac77","line-width":{"base":1.2,"stops":[[4,0],[5,0.4],[6,0.6],[7,1.5],[20,22]]},"line-opacity":{"stops":[[4,0],[5,0.5]]}}},{"id":"highway-path","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","$type","LineString"],["all",["!in","brunnel","bridge","tunnel"],["==","class","path"]]],"paint":{"line-color":"#cba","line-dasharray":[1.5,0.75],"line-width":{"base":1.2,"stops":[[15,1.2],[20,4]]}}},{"id":"highway-motorway-link","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","minzoom":12,"filter":["all",["!in","brunnel","bridge","tunnel"],["==","class","motorway_link"]],"layout":{"line-cap":"round","line-join":"round"},"paint":{"line-color":"#fc8","line-width":{"base":1.2,"stops":[[12.5,0],[13,1.5],[14,2.5],[20,11.5]]}}},{"id":"highway-link","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","minzoom":13,"filter":["all",["!in","brunnel","bridge","tunnel"],["in","class","primary_link","secondary_link","tertiary_link","trunk_link"]],"layout":{"line-cap":"round","line-join":"round","visibility":"visible"},"paint":{"line-color":"#fea","line-width":{"base":1.2,"stops":[[12.5,0],[13,1.5],[14,2.5],[20,11.5]]}}},{"id":"highway-minor","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","$type","LineString"],["all",["!=","brunnel","tunnel"],["in","class","minor","service","track"]]],"layout":{"line-cap":"round","line-join":"round"},"paint":{"line-color":"#fff","line-opacity":0.5,"line-width":{"base":1.2,"stops":[[13.5,0],[14,2.5],[20,11.5]]}}},{"id":"highway-secondary-tertiary","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["!in","brunnel","bridge","tunnel"],["in","class","secondary","tertiary"]],"layout":{"line-cap":"round","line-join":"round","visibility":"visible"},"paint":{"line-color":"#fea","line-width":{"base":1.2,"stops":[[6.5,0],[8,0.5],[20,13]]},"line-opacity":0.5}},{"id":"highway-primary","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","$type","LineString"],["all",["!in","brunnel","bridge","tunnel"],["in","class","primary"]]],"layout":{"line-cap":"round","line-join":"round","visibility":"visible"},"paint":{"line-color":"#fea","line-width":{"base":1.2,"stops":[[8.5,0],[9,0.5],[20,18]]},"line-opacity":0}},{"id":"highway-trunk","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","$type","LineString"],["all",["!in","brunnel","bridge","tunnel"],["in","class","trunk"]]],"layout":{"line-cap":"round","line-join":"round","visibility":"visible"},"paint":{"line-color":"#fea","line-width":{"base":1.2,"stops":[[6.5,0],[7,0.5],[20,18]]},"line-opacity":0.5}},{"id":"highway-motorway","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","minzoom":5,"filter":["all",["==","$type","LineString"],["all",["!in","brunnel","bridge","tunnel"],["==","class","motorway"]]],"layout":{"line-cap":"round","line-join":"round","visibility":"visible"},"paint":{"line-color":"#fc8","line-width":{"base":1.2,"stops":[[6.5,0],[7,0.5],[20,18]]},"line-opacity":0.5}},{"id":"railway-transit","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","$type","LineString"],["all",["==","class","transit"],["!in","brunnel","tunnel"]]],"layout":{"visibility":"visible"},"paint":{"line-color":"hsla(0, 0%, 73%, 0.77)","line-width":{"base":1.4,"stops":[[14,0.4],[20,1]]}}},{"id":"railway-transit-hatching","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","$type","LineString"],["all",["==","class","transit"],["!in","brunnel","tunnel"]]],"layout":{"visibility":"visible"},"paint":{"line-color":"hsla(0, 0%, 73%, 0.68)","line-dasharray":[0.2,8],"line-width":{"base":1.4,"stops":[[14.5,0],[15,2],[20,6]]}}},{"id":"railway-service","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","$type","LineString"],["all",["==","class","rail"],["has","service"]]],"paint":{"line-color":"hsla(0, 0%, 73%, 0.77)","line-width":{"base":1.4,"stops":[[14,0.4],[20,1]]}}},{"id":"railway-service-hatching","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","$type","LineString"],["all",["==","class","rail"],["has","service"]]],"layout":{"visibility":"visible"},"paint":{"line-color":"hsla(0, 0%, 73%, 0.68)","line-dasharray":[0.2,8],"line-width":{"base":1.4,"stops":[[14.5,0],[15,2],[20,6]]}}},{"id":"railway","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","$type","LineString"],["all",["!has","service"],["!in","brunnel","bridge","tunnel"],["==","class","rail"]]],"paint":{"line-color":"#bbb","line-width":{"base":1.4,"stops":[[14,0.4],[15,0.75],[20,2]]}}},{"id":"railway-hatching","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","$type","LineString"],["all",["!has","service"],["!in","brunnel","bridge","tunnel"],["==","class","rail"]]],"paint":{"line-color":"#bbb","line-dasharray":[0.2,8],"line-width":{"base":1.4,"stops":[[14.5,0],[15,3],[20,8]]}}},{"id":"bridge-motorway-link-casing","type":"line","metadata":{"mapbox:group":"1444849334699.1902"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","bridge"],["==","class","motorway_link"]],"layout":{"line-join":"round"},"paint":{"line-color":"#e9ac77","line-opacity":1,"line-width":{"base":1.2,"stops":[[12,1],[13,3],[14,4],[20,15]]}}},{"id":"bridge-link-casing","type":"line","metadata":{"mapbox:group":"1444849334699.1902"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","bridge"],["in","class","primary_link","secondary_link","tertiary_link","trunk_link"]],"layout":{"line-join":"round"},"paint":{"line-color":"#e9ac77","line-opacity":1,"line-width":{"base":1.2,"stops":[[12,1],[13,3],[14,4],[20,15]]}}},{"id":"bridge-secondary-tertiary-casing","type":"line","metadata":{"mapbox:group":"1444849334699.1902"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","bridge"],["in","class","secondary","tertiary"]],"layout":{"line-join":"round"},"paint":{"line-color":"#e9ac77","line-opacity":1,"line-width":{"base":1.2,"stops":[[8,1.5],[20,28]]}}},{"id":"bridge-trunk-primary-casing","type":"line","metadata":{"mapbox:group":"1444849334699.1902"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","bridge"],["in","class","primary","trunk"]],"layout":{"line-join":"round"},"paint":{"line-color":"hsl(28, 76%, 67%)","line-width":{"base":1.2,"stops":[[5,0.4],[6,0.6],[7,1.5],[20,26]]}}},{"id":"bridge-motorway-casing","type":"line","metadata":{"mapbox:group":"1444849334699.1902"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","bridge"],["==","class","motorway"]],"layout":{"line-join":"round"},"paint":{"line-color":"#e9ac77","line-width":{"base":1.2,"stops":[[5,0.4],[6,0.6],[7,1.5],[20,22]]},"line-opacity":0.5}},{"id":"bridge-path-casing","type":"line","metadata":{"mapbox:group":"1444849334699.1902"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","$type","LineString"],["all",["==","brunnel","bridge"],["==","class","path"]]],"paint":{"line-color":"#f8f4f0","line-width":{"base":1.2,"stops":[[15,1.2],[20,18]]}}},{"id":"bridge-path","type":"line","metadata":{"mapbox:group":"1444849334699.1902"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","$type","LineString"],["all",["==","brunnel","bridge"],["==","class","path"]]],"paint":{"line-color":"#cba","line-width":{"base":1.2,"stops":[[15,1.2],[20,4]]},"line-dasharray":[1.5,0.75]}},{"id":"bridge-motorway-link","type":"line","metadata":{"mapbox:group":"1444849334699.1902"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","bridge"],["==","class","motorway_link"]],"layout":{"line-join":"round"},"paint":{"line-color":"#fc8","line-width":{"base":1.2,"stops":[[12.5,0],[13,1.5],[14,2.5],[20,11.5]]}}},{"id":"bridge-link","type":"line","metadata":{"mapbox:group":"1444849334699.1902"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","bridge"],["in","class","primary_link","secondary_link","tertiary_link","trunk_link"]],"layout":{"line-join":"round"},"paint":{"line-color":"#fea","line-width":{"base":1.2,"stops":[[12.5,0],[13,1.5],[14,2.5],[20,11.5]]}}},{"id":"bridge-secondary-tertiary","type":"line","metadata":{"mapbox:group":"1444849334699.1902"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","bridge"],["in","class","secondary","tertiary"]],"layout":{"line-join":"round"},"paint":{"line-color":"#fea","line-width":{"base":1.2,"stops":[[6.5,0],[7,0.5],[20,20]]}}},{"id":"bridge-trunk-primary","type":"line","metadata":{"mapbox:group":"1444849334699.1902"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","bridge"],["in","class","primary","trunk"]],"layout":{"line-join":"round"},"paint":{"line-color":"#fea","line-width":{"base":1.2,"stops":[[6.5,0],[7,0.5],[20,18]]}}},{"id":"bridge-motorway","type":"line","metadata":{"mapbox:group":"1444849334699.1902"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","bridge"],["==","class","motorway"]],"layout":{"line-join":"round"},"paint":{"line-color":"#fc8","line-width":{"base":1.2,"stops":[[6.5,0],[7,0.5],[20,18]]},"line-opacity":0.5}},{"id":"bridge-railway","type":"line","metadata":{"mapbox:group":"1444849334699.1902"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","bridge"],["==","class","rail"]],"paint":{"line-color":"#bbb","line-width":{"base":1.4,"stops":[[14,0.4],[15,0.75],[20,2]]}}},{"id":"bridge-railway-hatching","type":"line","metadata":{"mapbox:group":"1444849334699.1902"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","brunnel","bridge"],["==","class","rail"]],"paint":{"line-color":"#bbb","line-dasharray":[0.2,8],"line-width":{"base":1.4,"stops":[[14.5,0],[15,3],[20,8]]}}},{"id":"cablecar","type":"line","source":"openmaptiles","source-layer":"transportation","minzoom":13,"filter":["==","class","cable_car"],"layout":{"visibility":"visible","line-cap":"round"},"paint":{"line-color":"hsl(0, 0%, 70%)","line-width":{"base":1,"stops":[[11,1],[19,2.5]]}}},{"id":"cablecar-dash","type":"line","source":"openmaptiles","source-layer":"transportation","minzoom":13,"filter":["==","class","cable_car"],"layout":{"visibility":"visible","line-cap":"round"},"paint":{"line-color":"hsl(0, 0%, 70%)","line-width":{"base":1,"stops":[[11,3],[19,5.5]]},"line-dasharray":[2,3]}},{"id":"boundary-land-level-4","type":"line","source":"openmaptiles","source-layer":"boundary","filter":["all",[">=","admin_level",4],["<=","admin_level",8],["!=","maritime",1]],"layout":{"line-join":"round"},"paint":{"line-color":"#9e9cab","line-dasharray":[3,1,1,1],"line-width":{"base":1.4,"stops":[[4,0.4],[5,1],[12,3]]},"line-opacity":0.6}},{"id":"boundary-land-level-2","type":"line","source":"openmaptiles","source-layer":"boundary","filter":["all",["==","admin_level",2],["!=","maritime",1],["!=","disputed",1]],"layout":{"line-cap":"round","line-join":"round"},"paint":{"line-color":"hsl(248, 7%, 66%)","line-width":{"base":1,"stops":[[0,0.6],[4,1.4],[5,2],[12,2]]}}},{"id":"boundary-land-disputed","type":"line","source":"openmaptiles","source-layer":"boundary","filter":["all",["!=","maritime",1],["==","disputed",1]],"layout":{"line-cap":"round","line-join":"round"},"paint":{"line-color":"hsl(248, 7%, 70%)","line-dasharray":[1,3],"line-width":{"base":1,"stops":[[0,0.6],[4,1.4],[5,2],[12,8]]}}},{"id":"boundary-water","type":"line","source":"openmaptiles","source-layer":"boundary","filter":["all",["in","admin_level",2,4],["==","maritime",1]],"layout":{"line-cap":"round","line-join":"round"},"paint":{"line-color":"rgba(154, 189, 214, 1)","line-width":{"base":1,"stops":[[0,0.6],[4,1],[5,1],[12,1]]},"line-opacity":{"stops":[[6,0],[10,0]]}}},{"id":"waterway-name","type":"symbol","source":"openmaptiles","source-layer":"waterway","minzoom":13,"filter":["all",["==","$type","LineString"],["has","name"]],"layout":{"text-font":["Noto Sans Italic"],"text-size":14,"text-field":"{name:latin} {name:nonlatin}","text-max-width":5,"text-rotation-alignment":"map","symbol-placement":"line","text-letter-spacing":0.2,"symbol-spacing":350},"paint":{"text-color":"#74aee9","text-halo-width":1.5,"text-halo-color":"rgba(255,255,255,0.7)"}},{"id":"water-name-lakeline","type":"symbol","source":"openmaptiles","source-layer":"water_name","filter":["==","$type","LineString"],"layout":{"text-font":["Noto Sans Italic"],"text-size":14,"text-field":"{name:latin}\\n{name:nonlatin}","text-max-width":5,"text-rotation-alignment":"map","symbol-placement":"line","symbol-spacing":350,"text-letter-spacing":0.2},"paint":{"text-color":"#74aee9","text-halo-width":1.5,"text-halo-color":"rgba(255,255,255,0.7)"}},{"id":"water-name-ocean","type":"symbol","source":"openmaptiles","source-layer":"water_name","filter":["all",["==","$type","Point"],["==","class","ocean"]],"layout":{"text-font":["Noto Sans Italic"],"text-size":14,"text-field":"{name:latin}","text-max-width":5,"text-rotation-alignment":"map","symbol-placement":"point","symbol-spacing":350,"text-letter-spacing":0.2},"paint":{"text-color":"#74aee9","text-halo-width":1.5,"text-halo-color":"rgba(255,255,255,0.7)"}},{"id":"water-name-other","type":"symbol","source":"openmaptiles","source-layer":"water_name","filter":["all",["==","$type","Point"],["!in","class","ocean"]],"layout":{"text-font":["Noto Sans Italic"],"text-size":{"stops":[[0,10],[6,14]]},"text-field":"{name:latin}\\n{name:nonlatin}","text-max-width":5,"text-rotation-alignment":"map","symbol-placement":"point","symbol-spacing":350,"text-letter-spacing":0.2,"visibility":"visible"},"paint":{"text-color":"#74aee9","text-halo-width":1.5,"text-halo-color":"rgba(255,255,255,0.7)"}},{"id":"poi-level-3","type":"symbol","source":"openmaptiles","source-layer":"poi","minzoom":16,"filter":["all",["==","$type","Point"],[">=","rank",25]],"layout":{"text-padding":2,"text-font":["Noto Sans Regular"],"text-anchor":"top","icon-image":"{class}_11","text-field":"{name:latin}\\n{name:nonlatin}","text-offset":[0,0.6],"text-size":12,"text-max-width":9},"paint":{"text-halo-blur":0.5,"text-color":"#666","text-halo-width":1,"text-halo-color":"#ffffff"}},{"id":"poi-level-2","type":"symbol","source":"openmaptiles","source-layer":"poi","minzoom":15,"filter":["all",["==","$type","Point"],["<=","rank",24],[">=","rank",15]],"layout":{"text-padding":2,"text-font":["Noto Sans Regular"],"text-anchor":"top","icon-image":"{class}_11","text-field":"{name:latin}\\n{name:nonlatin}","text-offset":[0,0.6],"text-size":12,"text-max-width":9},"paint":{"text-halo-blur":0.5,"text-color":"#666","text-halo-width":1,"text-halo-color":"#ffffff"}},{"id":"poi-level-1","type":"symbol","source":"openmaptiles","source-layer":"poi","minzoom":14,"filter":["all",["==","$type","Point"],["<=","rank",14],["has","name"]],"layout":{"text-padding":2,"text-font":["Noto Sans Regular"],"text-anchor":"top","icon-image":"{class}_11","text-field":"{name:latin}\\n{name:nonlatin}","text-offset":[0,0.6],"text-size":11,"text-max-width":9},"paint":{"text-halo-blur":0.5,"text-color":"rgba(191, 228, 172, 1)","text-halo-width":1,"text-halo-color":"rgba(30, 29, 29, 1)"}},{"id":"poi-railway","type":"symbol","source":"openmaptiles","source-layer":"poi","minzoom":13,"filter":["all",["==","$type","Point"],["has","name"],["==","class","railway"],["==","subclass","station"]],"layout":{"text-padding":2,"text-font":["Noto Sans Regular"],"text-anchor":"top","icon-image":"{class}_11","text-field":"{name:latin}\\n{name:nonlatin}","text-offset":[0,0.6],"text-size":12,"text-max-width":9,"icon-optional":false,"icon-ignore-placement":false,"icon-allow-overlap":false,"text-ignore-placement":false,"text-allow-overlap":false,"text-optional":true},"paint":{"text-halo-blur":0.5,"text-color":"#666","text-halo-width":1,"text-halo-color":"#ffffff"}},{"id":"road_oneway","type":"symbol","source":"openmaptiles","source-layer":"transportation","minzoom":15,"filter":["all",["==","oneway",1],["in","class","motorway","trunk","primary","secondary","tertiary","minor","service"]],"layout":{"symbol-placement":"line","icon-image":"oneway","symbol-spacing":75,"icon-padding":2,"icon-rotation-alignment":"map","icon-rotate":90,"icon-size":{"stops":[[15,0.5],[19,1]]}},"paint":{"icon-opacity":0.5}},{"id":"road_oneway_opposite","type":"symbol","source":"openmaptiles","source-layer":"transportation","minzoom":15,"filter":["all",["==","oneway",-1],["in","class","motorway","trunk","primary","secondary","tertiary","minor","service"]],"layout":{"symbol-placement":"line","icon-image":"oneway","symbol-spacing":75,"icon-padding":2,"icon-rotation-alignment":"map","icon-rotate":-90,"icon-size":{"stops":[[15,0.5],[19,1]]}},"paint":{"icon-opacity":0.5}},{"id":"highway-name-path","type":"symbol","source":"openmaptiles","source-layer":"transportation_name","minzoom":15.5,"filter":["==","class","path"],"layout":{"text-size":{"base":1,"stops":[[13,12],[14,13]]},"text-font":["Noto Sans Regular"],"text-field":"{name:latin} {name:nonlatin}","symbol-placement":"line","text-rotation-alignment":"map"},"paint":{"text-halo-color":"#f8f4f0","text-color":"hsl(30, 23%, 62%)","text-halo-width":0.5}},{"id":"highway-name-minor","type":"symbol","source":"openmaptiles","source-layer":"transportation_name","minzoom":15,"filter":["all",["==","$type","LineString"],["in","class","minor","service","track"]],"layout":{"text-size":{"base":1,"stops":[[13,12],[14,13]]},"text-font":["Noto Sans Regular"],"text-field":"{name:latin} {name:nonlatin}","symbol-placement":"line","text-rotation-alignment":"map"},"paint":{"text-halo-blur":0.5,"text-color":"#765","text-halo-width":1}},{"id":"highway-name-major","type":"symbol","source":"openmaptiles","source-layer":"transportation_name","minzoom":12.2,"filter":["in","class","primary","secondary","tertiary","trunk"],"layout":{"text-size":{"base":1,"stops":[[13,12],[14,13]]},"text-font":["Noto Sans Regular"],"text-field":"{name:latin} {name:nonlatin}","symbol-placement":"line","text-rotation-alignment":"map"},"paint":{"text-halo-blur":0.5,"text-color":"#765","text-halo-width":1}},{"id":"highway-shield","type":"symbol","source":"openmaptiles","source-layer":"transportation_name","minzoom":8,"filter":["all",["<=","ref_length",6],["==","$type","LineString"],["!in","network","us-interstate","us-highway","us-state"]],"layout":{"text-size":10,"icon-image":"road_{ref_length}","icon-rotation-alignment":"viewport","symbol-spacing":200,"text-font":["Noto Sans Regular"],"symbol-placement":{"base":1,"stops":[[10,"point"],[11,"line"]]},"text-rotation-alignment":"viewport","icon-size":1,"text-field":"{ref}"},"paint":{"text-opacity":1,"text-color":"rgba(20, 19, 19, 1)","text-halo-color":"rgba(230, 221, 221, 0)","text-halo-width":2,"icon-color":"rgba(183, 18, 18, 1)","icon-opacity":0.3,"icon-halo-color":"rgba(183, 55, 55, 0)"}},{"id":"highway-shield-us-interstate","type":"symbol","source":"openmaptiles","source-layer":"transportation_name","minzoom":7,"filter":["all",["<=","ref_length",6],["==","$type","LineString"],["in","network","us-interstate"]],"layout":{"text-size":10,"icon-image":"{network}_{ref_length}","icon-rotation-alignment":"viewport","symbol-spacing":200,"text-font":["Noto Sans Regular"],"symbol-placement":{"base":1,"stops":[[7,"point"],[7,"line"],[8,"line"]]},"text-rotation-alignment":"viewport","icon-size":1,"text-field":"{ref}"},"paint":{"text-color":"rgba(0, 0, 0, 1)"}},{"id":"highway-shield-us-other","type":"symbol","source":"openmaptiles","source-layer":"transportation_name","minzoom":9,"filter":["all",["<=","ref_length",6],["==","$type","LineString"],["in","network","us-highway","us-state"]],"layout":{"text-size":10,"icon-image":"{network}_{ref_length}","icon-rotation-alignment":"viewport","symbol-spacing":200,"text-font":["Noto Sans Regular"],"symbol-placement":{"base":1,"stops":[[10,"point"],[11,"line"]]},"text-rotation-alignment":"viewport","icon-size":1,"text-field":"{ref}"},"paint":{"text-color":"rgba(0, 0, 0, 1)"}},{"id":"place-other","type":"symbol","metadata":{"mapbox:group":"1444849242106.713"},"source":"openmaptiles","source-layer":"place","minzoom":12,"filter":["!in","class","city","town","village","country","continent"],"layout":{"text-letter-spacing":0.1,"text-size":{"base":1.2,"stops":[[12,10],[15,14]]},"text-font":["Noto Sans Bold"],"text-field":"{name:latin}\\n{name:nonlatin}","text-transform":"uppercase","text-max-width":9,"visibility":"visible"},"paint":{"text-color":"rgba(255,255,255,1)","text-halo-width":1.2,"text-halo-color":"rgba(57, 28, 28, 1)"}},{"id":"place-village","type":"symbol","metadata":{"mapbox:group":"1444849242106.713"},"source":"openmaptiles","source-layer":"place","minzoom":10,"filter":["==","class","village"],"layout":{"text-font":["Noto Sans Regular"],"text-size":{"base":1.2,"stops":[[10,12],[15,16]]},"text-field":"{name:latin}\\n{name:nonlatin}","text-max-width":8,"visibility":"visible"},"paint":{"text-color":"rgba(255, 255, 255, 1)","text-halo-width":1.2,"text-halo-color":"rgba(10, 9, 9, 0.8)"}},{"id":"place-town","type":"symbol","metadata":{"mapbox:group":"1444849242106.713"},"source":"openmaptiles","source-layer":"place","filter":["==","class","town"],"layout":{"text-font":["Noto Sans Regular"],"text-size":{"base":1.2,"stops":[[10,14],[15,24]]},"text-field":"{name:latin}\\n{name:nonlatin}","text-max-width":8,"visibility":"visible"},"paint":{"text-color":"rgba(255, 255, 255, 1)","text-halo-width":1.2,"text-halo-color":"rgba(22, 22, 22, 0.8)"}},{"id":"place-city","type":"symbol","metadata":{"mapbox:group":"1444849242106.713"},"source":"openmaptiles","source-layer":"place","filter":["all",["!=","capital",2],["==","class","city"]],"layout":{"text-font":["Noto Sans Regular"],"text-size":{"base":1.2,"stops":[[7,14],[11,24]]},"text-field":"{name:latin}\\n{name:nonlatin}","text-max-width":8,"visibility":"visible"},"paint":{"text-color":"rgba(0, 0, 0, 1)","text-halo-width":1.2,"text-halo-color":"rgba(255,255,255,0.8)"}},{"id":"place-city-capital","type":"symbol","metadata":{"mapbox:group":"1444849242106.713"},"source":"openmaptiles","source-layer":"place","filter":["all",["==","capital",2],["==","class","city"]],"layout":{"text-font":["Noto Sans Regular"],"text-size":{"base":1.2,"stops":[[7,14],[11,24]]},"text-field":"{name:latin}\\n{name:nonlatin}","text-max-width":8,"icon-image":"star_11","text-offset":[0.4,0],"icon-size":0.8,"text-anchor":"left","visibility":"visible"},"paint":{"text-color":"#333","text-halo-width":1.2,"text-halo-color":"rgba(255,255,255,0.8)"}},{"id":"place-country-other","type":"symbol","metadata":{"mapbox:group":"1444849242106.713"},"source":"openmaptiles","source-layer":"place","filter":["all",["==","class","country"],[">=","rank",3],["!has","iso_a2"]],"layout":{"text-font":["Noto Sans Italic"],"text-field":"{name:latin}","text-size":{"stops":[[3,11],[7,17]]},"text-transform":"uppercase","text-max-width":6.25,"visibility":"visible"},"paint":{"text-halo-blur":1,"text-color":"#334","text-halo-width":2,"text-halo-color":"rgba(255,255,255,0.8)"}},{"id":"place-country-3","type":"symbol","metadata":{"mapbox:group":"1444849242106.713"},"source":"openmaptiles","source-layer":"place","filter":["all",["==","class","country"],[">=","rank",3],["has","iso_a2"]],"layout":{"text-font":["Noto Sans Bold"],"text-field":"{name:latin}","text-size":{"stops":[[3,11],[7,17]]},"text-transform":"uppercase","text-max-width":6.25,"visibility":"visible"},"paint":{"text-halo-blur":1,"text-color":"#334","text-halo-width":2,"text-halo-color":"rgba(255,255,255,0.8)"}},{"id":"place-country-2","type":"symbol","metadata":{"mapbox:group":"1444849242106.713"},"source":"openmaptiles","source-layer":"place","filter":["all",["==","class","country"],["==","rank",2],["has","iso_a2"]],"layout":{"text-font":["Noto Sans Bold"],"text-field":"{name:latin}","text-size":{"stops":[[2,11],[5,17]]},"text-transform":"uppercase","text-max-width":6.25,"visibility":"visible"},"paint":{"text-halo-blur":1,"text-color":"#334","text-halo-width":2,"text-halo-color":"rgba(255,255,255,0.8)"}},{"id":"place-country-1","type":"symbol","metadata":{"mapbox:group":"1444849242106.713"},"source":"openmaptiles","source-layer":"place","filter":["all",["==","class","country"],["==","rank",1],["has","iso_a2"]],"layout":{"text-font":["Noto Sans Bold"],"text-field":"{name:latin}","text-size":{"stops":[[1,11],[4,17]]},"text-transform":"uppercase","text-max-width":6.25,"visibility":"visible"},"paint":{"text-halo-blur":1,"text-color":"#334","text-halo-width":2,"text-halo-color":"rgba(255,255,255,0.8)"}},{"id":"place-continent","type":"symbol","metadata":{"mapbox:group":"1444849242106.713"},"source":"openmaptiles","source-layer":"place","maxzoom":1,"filter":["==","class","continent"],"layout":{"text-font":["Noto Sans Bold"],"text-field":"{name:latin}","text-size":14,"text-max-width":6.25,"text-transform":"uppercase","visibility":"visible"},"paint":{"text-halo-blur":1,"text-color":"#334","text-halo-width":2,"text-halo-color":"rgba(255,255,255,0.8)"}}],"id":"qebnlkra6"}');
            },
            51962: function(t1) {
                "use strict";
                t1.exports = JSON.parse('{"version":8,"name":"orto","metadata":{},"center":[1.537786,41.837539],"zoom":12,"bearing":0,"pitch":0,"light":{"anchor":"viewport","color":"white","intensity":0.4,"position":[1.15,45,30]},"sources":{"ortoEsri":{"type":"raster","tiles":["https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"],"tileSize":256,"maxzoom":18,"attribution":"ESRI &copy; <a href=\'http://www.esri.com\'>ESRI</a>"},"ortoInstaMaps":{"type":"raster","tiles":["https://tilemaps.icgc.cat/mapfactory/wmts/orto_8_12/CAT3857/{z}/{x}/{y}.png"],"tileSize":256,"maxzoom":13},"ortoICGC":{"type":"raster","tiles":["https://geoserveis.icgc.cat/icc_mapesmultibase/noutm/wmts/orto/GRID3857/{z}/{x}/{y}.jpeg"],"tileSize":256,"minzoom":13.1,"maxzoom":20},"openmaptiles":{"type":"vector","url":"https://geoserveis.icgc.cat/contextmaps/basemap.json"}},"sprite":"https://geoserveis.icgc.cat/contextmaps/sprites/sprite@1","glyphs":"https://geoserveis.icgc.cat/contextmaps/glyphs/{fontstack}/{range}.pbf","layers":[{"id":"background","type":"background","paint":{"background-color":"#F4F9F4"}},{"id":"ortoEsri","type":"raster","source":"ortoEsri","maxzoom":16,"layout":{"visibility":"visible"}},{"id":"ortoICGC","type":"raster","source":"ortoICGC","minzoom":13.1,"maxzoom":19,"layout":{"visibility":"visible"}},{"id":"ortoInstaMaps","type":"raster","source":"ortoInstaMaps","maxzoom":13,"layout":{"visibility":"visible"}}]}');
            }
        }, e1 = {};
        function r(n) {
            var i = e1[n];
            if (void 0 !== i) return i.exports;
            var a = e1[n] = {
                id: n,
                exports: {}
            };
            return t1[n].call(a.exports, a, a.exports, r), a.exports;
        }
        return r.m = t1, r.n = function(t1) {
            var e1 = t1 && t1.__esModule ? function() {
                return t1.default;
            } : function() {
                return t1;
            };
            return r.d(e1, {
                a: e1
            }), e1;
        }, r.d = function(t1, e1) {
            for(var n in e1)r.o(e1, n) && !r.o(t1, n) && Object.defineProperty(t1, n, {
                enumerable: !0,
                get: e1[n]
            });
        }, r.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (t1) {
                if ("object" == typeof window) return window;
            }
        }(), r.o = function(t1, e1) {
            return Object.prototype.hasOwnProperty.call(t1, e1);
        }, r.r = function(t1) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t1, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t1, "__esModule", {
                value: !0
            });
        }, r.b = document.baseURI || self.location.href, r.nc = void 0, r(20260);
    }();
});

});


parcelRegister("cxrLj", function(module, exports) {

$parcel$export(module.exports, "render", () => $920e1a1a4390f041$export$b3890eb0ae9dca99);
parcelRequire("giao7");
var $4mYx6 = parcelRequire("4mYx6");
var $a5gC8 = parcelRequire("a5gC8");
var $5on3n = parcelRequire("5on3n");
const $920e1a1a4390f041$var$_hoisted_1 = {
    key: 0
};
const $920e1a1a4390f041$var$_hoisted_2 = {
    key: 1
};
const $920e1a1a4390f041$var$_hoisted_3 = {
    class: "field is-grouped is-grouped-multiline"
};
const $920e1a1a4390f041$var$_hoisted_4 = {
    class: "field"
};
const $920e1a1a4390f041$var$_hoisted_5 = {
    class: "control"
};
const $920e1a1a4390f041$var$_hoisted_6 = {
    class: "select"
};
const $920e1a1a4390f041$var$_hoisted_7 = {
    class: "field"
};
const $920e1a1a4390f041$var$_hoisted_8 = {
    class: "control"
};
const $920e1a1a4390f041$var$_hoisted_9 = {
    class: "select"
};
const $920e1a1a4390f041$var$_hoisted_10 = {
    class: "field"
};
const $920e1a1a4390f041$var$_hoisted_11 = {
    class: "select"
};
const $920e1a1a4390f041$var$_hoisted_12 = {
    ref: "chartContainer"
};
function $920e1a1a4390f041$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $4mYx6.openBlock)(), (0, $4mYx6.createElementBlock)((0, $4mYx6.Fragment), null, [
        _cache[8] || (_cache[8] = (0, $4mYx6.createElementVNode)("h3", {
            class: "title is-4"
        }, "Heatmap", -1)),
        $setup.props.timeSeriesCollection.getAllParameters().length === 0 ? ((0, $4mYx6.openBlock)(), (0, $4mYx6.createElementBlock)("p", $920e1a1a4390f041$var$_hoisted_1, _cache[3] || (_cache[3] = [
            (0, $4mYx6.createTextVNode)(" To display a heatmap for your parameters, make sure that at least one parameter is present. To do so, name the columns in your CSV file accordingly (e.g. "),
            (0, $4mYx6.createElementVNode)("code", null, "param1=4, param2=2.4", -1),
            (0, $4mYx6.createTextVNode)("). ")
        ]))) : ((0, $4mYx6.openBlock)(), (0, $4mYx6.createElementBlock)("div", $920e1a1a4390f041$var$_hoisted_2, [
            (0, $4mYx6.createElementVNode)("div", $920e1a1a4390f041$var$_hoisted_3, [
                (0, $4mYx6.createElementVNode)("div", $920e1a1a4390f041$var$_hoisted_4, [
                    _cache[4] || (_cache[4] = (0, $4mYx6.createElementVNode)("div", {
                        class: "label"
                    }, "x Axis", -1)),
                    (0, $4mYx6.createElementVNode)("div", $920e1a1a4390f041$var$_hoisted_5, [
                        (0, $4mYx6.createElementVNode)("div", $920e1a1a4390f041$var$_hoisted_6, [
                            (0, $4mYx6.withDirectives)((0, $4mYx6.createElementVNode)("select", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.xAxisParameter = $event)
                            }, [
                                ((0, $4mYx6.openBlock)(true), (0, $4mYx6.createElementBlock)((0, $4mYx6.Fragment), null, (0, $4mYx6.renderList)($setup.props.timeSeriesCollection.getAllParameters(), (parameter)=>{
                                    return (0, $4mYx6.openBlock)(), (0, $4mYx6.createElementBlock)("option", {
                                        key: parameter
                                    }, (0, $a5gC8.toDisplayString)(parameter), 1);
                                }), 128))
                            ], 512), [
                                [
                                    (0, $5on3n.vModelSelect),
                                    $setup.xAxisParameter
                                ]
                            ])
                        ])
                    ])
                ]),
                (0, $4mYx6.createElementVNode)("div", $920e1a1a4390f041$var$_hoisted_7, [
                    _cache[5] || (_cache[5] = (0, $4mYx6.createElementVNode)("div", {
                        class: "label"
                    }, "y Axis", -1)),
                    (0, $4mYx6.createElementVNode)("div", $920e1a1a4390f041$var$_hoisted_8, [
                        (0, $4mYx6.createElementVNode)("div", $920e1a1a4390f041$var$_hoisted_9, [
                            (0, $4mYx6.withDirectives)((0, $4mYx6.createElementVNode)("select", {
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.yAxisParameter = $event)
                            }, [
                                ((0, $4mYx6.openBlock)(true), (0, $4mYx6.createElementBlock)((0, $4mYx6.Fragment), null, (0, $4mYx6.renderList)($setup.props.timeSeriesCollection.getAllParameters(), (parameter)=>{
                                    return (0, $4mYx6.openBlock)(), (0, $4mYx6.createElementBlock)("option", {
                                        key: parameter
                                    }, (0, $a5gC8.toDisplayString)(parameter), 1);
                                }), 128))
                            ], 512), [
                                [
                                    (0, $5on3n.vModelSelect),
                                    $setup.yAxisParameter
                                ]
                            ])
                        ])
                    ])
                ]),
                (0, $4mYx6.createElementVNode)("div", $920e1a1a4390f041$var$_hoisted_10, [
                    _cache[7] || (_cache[7] = (0, $4mYx6.createElementVNode)("div", {
                        class: "label"
                    }, "Color", -1)),
                    (0, $4mYx6.createElementVNode)("div", $920e1a1a4390f041$var$_hoisted_11, [
                        (0, $4mYx6.withDirectives)((0, $4mYx6.createElementVNode)("select", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.color = $event)
                        }, _cache[6] || (_cache[6] = [
                            (0, $4mYx6.createElementVNode)("option", {
                                value: "robustRatio"
                            }, " Robust Ratio ", -1),
                            (0, $4mYx6.createElementVNode)("option", {
                                value: "linRegCAGR"
                            }, " Linear Regression CAGR ", -1),
                            (0, $4mYx6.createElementVNode)("option", {
                                value: "maxDD"
                            }, " Max. Drawdown ", -1),
                            (0, $4mYx6.createElementVNode)("option", {
                                value: "cagr"
                            }, " CAGR ", -1)
                        ]), 512), [
                            [
                                (0, $5on3n.vModelSelect),
                                $setup.color
                            ]
                        ])
                    ])
                ])
            ]),
            (0, $4mYx6.createElementVNode)("div", $920e1a1a4390f041$var$_hoisted_12, null, 512)
        ]))
    ], 64);
}

});

parcelRegister("cqqID", function(module, exports) {

$parcel$export(module.exports, "default", () => $90bca393d7ba10a7$export$2e2bcd8739ae039);
let $90bca393d7ba10a7$var$NOOP = ()=>{};
var $90bca393d7ba10a7$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("3EL52", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a99a0b2753b84cd$export$2e2bcd8739ae039);
let $2a99a0b2753b84cd$var$script;


let $2a99a0b2753b84cd$var$initialize = ()=>{
    $2a99a0b2753b84cd$var$script = (parcelRequire("5Zu4j"));
    if ($2a99a0b2753b84cd$var$script.__esModule) $2a99a0b2753b84cd$var$script = $2a99a0b2753b84cd$var$script.default;
    (parcelRequire("5rtfe")).default($2a99a0b2753b84cd$var$script);
    $2a99a0b2753b84cd$var$script.__scopeId = "data-v-e276bb";
    $2a99a0b2753b84cd$var$script.__file = "DataFetcher.vue";
};
$2a99a0b2753b84cd$var$initialize();
var $2a99a0b2753b84cd$export$2e2bcd8739ae039 = $2a99a0b2753b84cd$var$script;

});
parcelRegister("5Zu4j", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $45c9f9432fdf2201$export$2e2bcd8739ae039);
parcelRequire("giao7");
var $9K9BQ = parcelRequire("9K9BQ");
var $4mYx6 = parcelRequire("4mYx6");
const $45c9f9432fdf2201$var$__default__ = (0, $4mYx6.defineComponent)({
    render: ()=>null
});
var $45c9f9432fdf2201$export$2e2bcd8739ae039 = /*@__PURE__*/ Object.assign($45c9f9432fdf2201$var$__default__, {
    __name: "DataFetcher",
    props: {
        timeSeriesCollection: {
            type: Object,
            required: true
        },
        fileUrls: {
            type: Array,
            required: true
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const notifications = (0, $4mYx6.inject)("notifications");
        const props = __props;
        const fetchData = (urls)=>{
            urls.forEach(async (url)=>{
                try {
                    const response = await fetch(url);
                    if (!response.ok) throw new Error(`Could not load CSV file from URL ${url}: Invalid status ${response.status}.`);
                    const text = await response.text();
                    notifications.add(`Successfully loaded file from ${url}`);
                    props.timeSeriesCollection.addFromCSV(text);
                } catch (err) {
                    notifications.add(`Could not load CSV file from URL ${url}: ${err}.`, "error");
                }
            });
        };
        // Ha. https://stackoverflow.com/questions/62729380/vue-watch-outputs-same-oldvalue-and-newvalue
        const fileURLsToWatch = (0, $9K9BQ.computed)(()=>[
                ...props.fileUrls
            ]);
        (0, $9K9BQ.watch)(fileURLsToWatch, (newURLs, oldURLs = [])=>{
            const addedURLs = newURLs.filter((url)=>!oldURLs.includes(url));
            fetchData(addedURLs);
        }, {
            immediate: true
        });
        const __returned__ = {
            notifications: notifications,
            props: props,
            fetchData: fetchData,
            fileURLsToWatch: fileURLsToWatch,
            inject: $4mYx6.inject,
            defineComponent: $4mYx6.defineComponent,
            watch: $9K9BQ.watch,
            computed: $9K9BQ.computed
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});

parcelRegister("5rtfe", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f6628bf211278f5$export$2e2bcd8739ae039);
let $3f6628bf211278f5$var$NOOP = ()=>{};
var $3f6628bf211278f5$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("9PMCX", function(module, exports) {

$parcel$export(module.exports, "default", () => $728e98da20fba8dd$export$2e2bcd8739ae039);
let $728e98da20fba8dd$var$script;



let $728e98da20fba8dd$var$initialize = ()=>{
    $728e98da20fba8dd$var$script = (parcelRequire("hnOid"));
    if ($728e98da20fba8dd$var$script.__esModule) $728e98da20fba8dd$var$script = $728e98da20fba8dd$var$script.default;
    $728e98da20fba8dd$var$script.render = (parcelRequire("cYa9X")).render;
    (parcelRequire("l0zgy")).default($728e98da20fba8dd$var$script);
    $728e98da20fba8dd$var$script.__scopeId = "data-v-41b922";
    $728e98da20fba8dd$var$script.__file = "TimeSeriesList.vue";
};
$728e98da20fba8dd$var$initialize();
var $728e98da20fba8dd$export$2e2bcd8739ae039 = $728e98da20fba8dd$var$script;

});
parcelRegister("hnOid", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ca7b98c2cd92b0f9$export$2e2bcd8739ae039);
parcelRequire("giao7");
var $9K9BQ = parcelRequire("9K9BQ");

var $28UQG = parcelRequire("28UQG");
var $ca7b98c2cd92b0f9$export$2e2bcd8739ae039 = {
    __name: "TimeSeriesList",
    props: {
        timeSeries: {
            type: Array,
            required: true
        },
        isAddSeriesBoxVisible: Boolean,
        fromDate: {
            type: String,
            default: null
        },
        toDate: {
            type: String,
            default: null
        }
    },
    emits: [
        "changeAddSeriesBoxVisibility",
        "update:toDate",
        "update:fromDate"
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const emit = __emit;
        const doDatesOverlap = (0, $9K9BQ.computed)(()=>props.fromDate && props.toDate && new Date(props.fromDate).getTime() >= new Date(props.toDate).getTime());
        const updateVisibilityOfAllTimeSeries = (value)=>{
            props.timeSeries.forEach((series)=>{
                series.visible = value;
            });
        };
        const __returned__ = {
            props: props,
            emit: emit,
            doDatesOverlap: doDatesOverlap,
            updateVisibilityOfAllTimeSeries: updateVisibilityOfAllTimeSeries,
            computed: $9K9BQ.computed,
            get formatName () {
                return 0, $28UQG.default;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("28UQG", function(module, exports) {

$parcel$export(module.exports, "default", () => $18f86d190e920720$export$2e2bcd8739ae039);
/**
 * Parameters of a backtest are a map (see parseParameters); stringify it and use <br> between
 * the params to make them better comparable
 * @param {Map} parameters
 * @param {String} divider
 * @returns {String}
 */ const $18f86d190e920720$var$stringifyParameters = (parameters, divider)=>[
        ...parameters
    ].map(([name, value])=>`${name}: ${value}`).join(divider);
var /**
 * Return the best matching name for a backtest: If parameters exist, use them; if not, return
 * the backtest's name.
 * @param {Object} entry The backtest entry; valid keys are 'name' and 'parameters'
 * @param {String} divider The divider between the parameters
 * @returns {String}
 */ $18f86d190e920720$export$2e2bcd8739ae039 = (entry, divider = " ")=>entry.parameters.size ? $18f86d190e920720$var$stringifyParameters(entry.parameters, divider) : entry.name;

});


parcelRegister("cYa9X", function(module, exports) {

$parcel$export(module.exports, "render", () => $9712f81b7046d9a9$export$b3890eb0ae9dca99);
parcelRequire("giao7");
var $4mYx6 = parcelRequire("4mYx6");
var $a5gC8 = parcelRequire("a5gC8");
var $5on3n = parcelRequire("5on3n");
const $9712f81b7046d9a9$var$_hoisted_1 = {
    class: "field"
};
const $9712f81b7046d9a9$var$_hoisted_2 = {
    class: "checkbox is-family-monospace has-text-weight-semibold"
};
const $9712f81b7046d9a9$var$_hoisted_3 = [
    "onUpdate:modelValue"
];
const $9712f81b7046d9a9$var$_hoisted_4 = {
    class: "field mt-6"
};
const $9712f81b7046d9a9$var$_hoisted_5 = [
    "value"
];
const $9712f81b7046d9a9$var$_hoisted_6 = {
    class: "field"
};
const $9712f81b7046d9a9$var$_hoisted_7 = [
    "value"
];
const $9712f81b7046d9a9$var$_hoisted_8 = {
    key: 0,
    class: "notification is-danger"
};
function $9712f81b7046d9a9$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $4mYx6.openBlock)(), (0, $4mYx6.createElementBlock)((0, $4mYx6.Fragment), null, [
        _cache[7] || (_cache[7] = (0, $4mYx6.createElementVNode)("h2", {
            class: "title is-5"
        }, " Instruments ", -1)),
        (0, $4mYx6.createElementVNode)("div", $9712f81b7046d9a9$var$_hoisted_1, [
            ((0, $4mYx6.openBlock)(true), (0, $4mYx6.createElementBlock)((0, $4mYx6.Fragment), null, (0, $4mYx6.renderList)($props.timeSeries, (series)=>{
                return (0, $4mYx6.openBlock)(), (0, $4mYx6.createElementBlock)("div", {
                    key: series.id,
                    class: "field"
                }, [
                    (0, $4mYx6.createElementVNode)("label", $9712f81b7046d9a9$var$_hoisted_2, [
                        (0, $4mYx6.withDirectives)((0, $4mYx6.createElementVNode)("input", {
                            "onUpdate:modelValue": ($event)=>series.visible = $event,
                            type: "checkbox"
                        }, null, 8, $9712f81b7046d9a9$var$_hoisted_3), [
                            [
                                (0, $5on3n.vModelCheckbox),
                                series.visible
                            ]
                        ]),
                        (0, $4mYx6.createTextVNode)(" " + (0, $a5gC8.toDisplayString)($setup.formatName(series, " \xb7 ")), 1)
                    ])
                ]);
            }), 128))
        ]),
        (0, $4mYx6.createElementVNode)("button", {
            class: "button is-ghost",
            onClick: _cache[0] || (_cache[0] = ($event)=>$setup.updateVisibilityOfAllTimeSeries(false))
        }, "Select none"),
        (0, $4mYx6.createElementVNode)("button", {
            class: "button is-ghost",
            onClick: _cache[1] || (_cache[1] = ($event)=>$setup.updateVisibilityOfAllTimeSeries(true))
        }, "Select all"),
        (0, $4mYx6.createElementVNode)("div", $9712f81b7046d9a9$var$_hoisted_4, [
            _cache[5] || (_cache[5] = (0, $4mYx6.createElementVNode)("label", {
                class: "label"
            }, "From:", -1)),
            (0, $4mYx6.createElementVNode)("input", {
                class: "input",
                type: "date",
                value: $props.fromDate,
                onInput: _cache[2] || (_cache[2] = ($event)=>$setup.emit("update:fromDate", $event.target.value))
            }, null, 40, $9712f81b7046d9a9$var$_hoisted_5)
        ]),
        (0, $4mYx6.createElementVNode)("div", $9712f81b7046d9a9$var$_hoisted_6, [
            _cache[6] || (_cache[6] = (0, $4mYx6.createElementVNode)("label", {
                class: "label"
            }, "To:", -1)),
            (0, $4mYx6.createElementVNode)("input", {
                class: "input",
                type: "date",
                value: $props.toDate,
                onInput: _cache[3] || (_cache[3] = ($event)=>$setup.emit("update:toDate", $event.target.value))
            }, null, 40, $9712f81b7046d9a9$var$_hoisted_7)
        ]),
        $setup.doDatesOverlap ? ((0, $4mYx6.openBlock)(), (0, $4mYx6.createElementBlock)("div", $9712f81b7046d9a9$var$_hoisted_8, " To date must be greater than from date. ")) : (0, $4mYx6.createCommentVNode)("", true),
        (0, $4mYx6.createElementVNode)("button", {
            class: "button mt-6",
            onClick: _cache[4] || (_cache[4] = ($event)=>_ctx.$emit("changeAddSeriesBoxVisibility", true))
        }, " Add series \u2026 ")
    ], 64);
}

});

parcelRegister("l0zgy", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4b4f428a60eca48$export$2e2bcd8739ae039);
let $f4b4f428a60eca48$var$NOOP = ()=>{};
var $f4b4f428a60eca48$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("gP4YB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3f544f808623f2d$export$2e2bcd8739ae039);
let $c3f544f808623f2d$var$script;



let $c3f544f808623f2d$var$initialize = ()=>{
    $c3f544f808623f2d$var$script = (parcelRequire("gJUx2"));
    if ($c3f544f808623f2d$var$script.__esModule) $c3f544f808623f2d$var$script = $c3f544f808623f2d$var$script.default;
    $c3f544f808623f2d$var$script.render = (parcelRequire("jLCz5")).render;
    (parcelRequire("9vfG2")).default($c3f544f808623f2d$var$script);
    $c3f544f808623f2d$var$script.__scopeId = "data-v-84fee4";
    $c3f544f808623f2d$var$script.__file = "PerformanceChart.vue";
};
$c3f544f808623f2d$var$initialize();
var $c3f544f808623f2d$export$2e2bcd8739ae039 = $c3f544f808623f2d$var$script;

});
parcelRegister("gJUx2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c2fcb3569768a363$export$2e2bcd8739ae039);
parcelRequire("giao7");
var $9K9BQ = parcelRequire("9K9BQ");
var $4mYx6 = parcelRequire("4mYx6");

var $6YCFf = parcelRequire("6YCFf");

var $ilYCa = parcelRequire("ilYCa");
var $c2fcb3569768a363$export$2e2bcd8739ae039 = {
    __name: "PerformanceChart",
    props: {
        timeSeries: {
            type: Array,
            required: true
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        // Don't use chart.js because it does not support subplots.
        let chart;
        let Plotly;
        const getChartConfig = ({ data: data, name: name, color: color })=>({
                name: name,
                x: data.map((item)=>item.date),
                type: "line",
                line: {
                    color: color,
                    width: 2
                }
            });
        /**
     * Normalizes a timeSeries' performance and converts it for plotly
     * @param {{x: Date, y: Number}[]} data 
     * @param {string} name 
     * @returns {type: string, x: Date[], y: Number[]}
     */ const getPlotlyPerformance = ({ data: data, name: name, color: color })=>{
            const normalized = (0, $ilYCa.getNormalizedAsSeries)(data.map((item)=>item.value));
            return {
                ...getChartConfig({
                    data: data,
                    name: name,
                    color: color
                }),
                y: normalized
            };
        };
        /**
     * Gets relative drawodowns for a series and formats them for Plotly
     * @param {{x: Date, y: Number}[]} data
     * @param {string} name 
     * @returns {type: string, x: Date[], y: Number[]}
     */ const getPlotlyDrawdowns = ({ data: data, name: name, color: color })=>{
            const drawdowns = (0, $ilYCa.getRelativeDrawdownAsSeries)(data.map((item)=>item.value));
            return {
                ...getChartConfig({
                    data: data,
                    name: name,
                    color: color
                }),
                yaxis: "y2",
                y: drawdowns
            };
        };
        const props = __props;
        const chartContainer = (0, $9K9BQ.ref)(null);
        // When container is ready, create the chart
        (0, $4mYx6.watchEffect)(async ()=>{
            if (chart) Plotly.purge(chart);
            const container = (0, $9K9BQ.unref)(chartContainer);
            if (container === null) {
                console.log("Chart container not ready");
                return;
            }
            console.log("Update chart for %d timeSeries in %o", props.timeSeries.length, container);
            const visibleTimeSeries = props.timeSeries.filter((item)=>item.visible);
            const performances = visibleTimeSeries.map((series)=>getPlotlyPerformance(series));
            const dradowns = visibleTimeSeries.map((series)=>getPlotlyDrawdowns(series));
            const dataForCharts = [
                ...performances,
                ...dradowns
            ];
            const chartResult = (0, $6YCFf.default)({
                container: container,
                data: dataForCharts
            });
            Plotly = chartResult.plotly;
            chart = await chartResult.chart;
        });
        window.addEventListener("resize", ()=>{
            // Woohoo: This seems to be the only working solution: First, set height/width to 0 in
            // order to enable a size *reduction* (offsetWidth will always at least be the plot's
            // previous size), only then manually measure out the container and use those sizes
            // for Plotly
            const container = (0, $9K9BQ.unref)(chartContainer);
            if (!container) return;
            Plotly.relayout(container, {
                height: 0,
                width: 0
            });
            Plotly.relayout(container, {
                height: container.offsetHeight,
                width: container.offsetWidth
            });
        });
        const __returned__ = {
            get chart () {
                return chart;
            },
            set chart (v){
                chart = v;
            },
            get Plotly () {
                return Plotly;
            },
            set Plotly (v){
                Plotly = v;
            },
            getChartConfig: getChartConfig,
            getPlotlyPerformance: getPlotlyPerformance,
            getPlotlyDrawdowns: getPlotlyDrawdowns,
            props: props,
            chartContainer: chartContainer,
            watchEffect: $4mYx6.watchEffect,
            ref: $9K9BQ.ref,
            unref: $9K9BQ.unref,
            get createChart () {
                return 0, $6YCFf.default;
            },
            get getNormalizedAsSeries () {
                return 0, $ilYCa.getNormalizedAsSeries;
            },
            get getRelativeDrawdownAsSeries () {
                return 0, $ilYCa.getRelativeDrawdownAsSeries;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("6YCFf", function(module, exports) {

$parcel$export(module.exports, "default", () => $514656983b72c4f4$export$2e2bcd8739ae039);
// Don't use chart.js because it does not support subplots.

var $2cr21 = parcelRequire("2cr21");
var $514656983b72c4f4$var$layout = {
    showlegend: false,
    dragmode: "pan",
    height: Math.max(window.innerHeight * 0.75, 600),
    xaxis: {},
    yaxis: {
        // https://stackoverflow.com/questions/42043633/format-y-axis-as-percent-in-plot-ly
        // https://d3js.org/d3-format
        domain: [
            0.33,
            1
        ]
    },
    yaxis2: {
        domain: [
            0,
            0.33
        ],
        title: "Drawdowns",
        // See yaxis 1
        tickformat: ".1%"
    }
};
var $514656983b72c4f4$export$2e2bcd8739ae039 = ({ data: data, container: container } = {})=>{
    return {
        // Also return Plotly reference to use e.g. relayout from the outside
        plotly: (0, (/*@__PURE__*/$parcel$interopDefault($2cr21))),
        chart: (0, (/*@__PURE__*/$parcel$interopDefault($2cr21))).newPlot(container, data, $514656983b72c4f4$var$layout, {
            scrollZoom: true
        })
    };
};

});


parcelRegister("jLCz5", function(module, exports) {

$parcel$export(module.exports, "render", () => $e640524ef072c77f$export$b3890eb0ae9dca99);
parcelRequire("giao7");
var $4mYx6 = parcelRequire("4mYx6");
const $e640524ef072c77f$var$_hoisted_1 = {
    ref: "chartContainer"
};
function $e640524ef072c77f$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $4mYx6.openBlock)(), (0, $4mYx6.createElementBlock)("div", $e640524ef072c77f$var$_hoisted_1, null, 512);
}

});

parcelRegister("9vfG2", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eb32b76df087dfb$export$2e2bcd8739ae039);
let $6eb32b76df087dfb$var$NOOP = ()=>{};
var $6eb32b76df087dfb$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("aif9a", function(module, exports) {

$parcel$export(module.exports, "default", () => $77e755a7b61aaf0d$export$2e2bcd8739ae039);
let $77e755a7b61aaf0d$var$script;



let $77e755a7b61aaf0d$var$initialize = ()=>{
    $77e755a7b61aaf0d$var$script = (parcelRequire("fvW6F"));
    if ($77e755a7b61aaf0d$var$script.__esModule) $77e755a7b61aaf0d$var$script = $77e755a7b61aaf0d$var$script.default;
    $77e755a7b61aaf0d$var$script.render = (parcelRequire("2VIlt")).render;
    (parcelRequire("339Pe")).default($77e755a7b61aaf0d$var$script);
    $77e755a7b61aaf0d$var$script.__scopeId = "data-v-92ce44";
    $77e755a7b61aaf0d$var$script.__file = "PerformanceTable.vue";
};
$77e755a7b61aaf0d$var$initialize();
var $77e755a7b61aaf0d$export$2e2bcd8739ae039 = $77e755a7b61aaf0d$var$script;

});
parcelRegister("fvW6F", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b4b6d30422382ef4$export$2e2bcd8739ae039);
parcelRequire("giao7");
var $9K9BQ = parcelRequire("9K9BQ");

var $7Lrhv = parcelRequire("7Lrhv");

var $28UQG = parcelRequire("28UQG");
var $b4b6d30422382ef4$export$2e2bcd8739ae039 = {
    __name: "PerformanceTable",
    props: {
        timeSeries: {
            type: Array,
            required: true
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const visibleTimeSeries = (0, $9K9BQ.computed)(()=>{
            return props.timeSeries.filter((entry)=>entry.visible);
        });
        const indicators = [
            {
                indicator: "linRegCAGR",
                name: "CAGR based on linear regression",
                abbreviation: "LinReg CAGR",
                size: "large",
                format: (value)=>`${(value * 100).toFixed(1)}%`
            },
            {
                indicator: "maxDD",
                name: "Maximum Drawdown",
                abbreviation: "Max. DD",
                size: "large",
                format: (value)=>`${(value * 100).toFixed(1)}%`
            },
            {
                indicator: "robustRatio",
                name: "Robust Ratio (LinReg CAGR * (1 - max. DD))",
                abbreviation: "Robust",
                size: "large",
                format: (value)=>`${(value * 100).toFixed(1)}`
            },
            {
                indicator: "cumulativeReturn",
                name: "Cumulative Return",
                abbreviation: "Cum Return",
                format: (value)=>`${(value * 100).toFixed(1)}%`
            },
            {
                indicator: "cagr",
                name: "Compound Annual Growth Rate",
                abbreviation: "CAGR",
                format: (value)=>`${(value * 100).toFixed(1)}%`
            },
            {
                indicator: "calmar",
                abbreviation: "Calmar",
                name: "Calmar (CAGR 1 yr / Max. DD)",
                format: (value)=>value.toFixed(1)
            },
            {
                indicator: "sortino",
                name: "Sortino",
                format: (value)=>value.toFixed(1)
            },
            {
                indicator: "stdDev",
                name: "Standard Deviation",
                abbreviation: "Std Dev",
                format: (value)=>value.toFixed(1)
            },
            {
                indicator: "sharpe",
                name: "Sharpe",
                format: (value)=>value.toFixed(1)
            },
            {
                indicator: "relativeTimeInMarket",
                name: "Relative Time in Market (not in market = unchanged bars)",
                abbreviation: "In Market (approx.)",
                format: (value)=>`${(value * 100).toFixed(0)}%`
            }
        ];
        const __returned__ = {
            props: props,
            visibleTimeSeries: visibleTimeSeries,
            indicators: indicators,
            computed: $9K9BQ.computed,
            PerformanceTableRow: $7Lrhv.default,
            get formatName () {
                return 0, $28UQG.default;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("7Lrhv", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a7215af925cc409$export$2e2bcd8739ae039);
let $5a7215af925cc409$var$script;



let $5a7215af925cc409$var$initialize = ()=>{
    $5a7215af925cc409$var$script = (parcelRequire("8vBP9"));
    if ($5a7215af925cc409$var$script.__esModule) $5a7215af925cc409$var$script = $5a7215af925cc409$var$script.default;
    $5a7215af925cc409$var$script.render = (parcelRequire("6Zi3u")).render;
    (parcelRequire("6UfnH")).default($5a7215af925cc409$var$script);
    $5a7215af925cc409$var$script.__scopeId = "data-v-53a84c";
    $5a7215af925cc409$var$script.__file = "PerformanceTableRow.vue";
};
$5a7215af925cc409$var$initialize();
var $5a7215af925cc409$export$2e2bcd8739ae039 = $5a7215af925cc409$var$script;

});
parcelRegister("8vBP9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $631e8f0cdb1cfe1d$export$2e2bcd8739ae039);
parcelRequire("giao7");
var $9K9BQ = parcelRequire("9K9BQ");
var $631e8f0cdb1cfe1d$export$2e2bcd8739ae039 = {
    __name: "PerformanceTableRow",
    props: {
        values: {
            type: Object,
            required: true
        },
        size: {
            type: String,
            // Valid are 'large' and 'regular'
            default: "regular"
        },
        indicator: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        format: {
            type: Function,
            default: (value)=>value
        },
        abbreviation: {
            type: String,
            default: ""
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const isLarge = (0, $9K9BQ.computed)(()=>{
            return props.size === "large";
        });
        const __returned__ = {
            props: props,
            isLarge: isLarge,
            computed: $9K9BQ.computed
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("6Zi3u", function(module, exports) {

$parcel$export(module.exports, "render", () => $5166720209413ef5$export$b3890eb0ae9dca99);
parcelRequire("giao7");
var $4mYx6 = parcelRequire("4mYx6");
var $a5gC8 = parcelRequire("a5gC8");
const $5166720209413ef5$var$_hoisted_1 = {
    class: "{ }"
};
const $5166720209413ef5$var$_hoisted_2 = [
    "title"
];
const $5166720209413ef5$var$_hoisted_3 = {
    key: 1
};
function $5166720209413ef5$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $4mYx6.openBlock)(), (0, $4mYx6.createElementBlock)("tr", $5166720209413ef5$var$_hoisted_1, [
        (0, $4mYx6.createElementVNode)("td", {
            class: (0, $a5gC8.normalizeClass)({
                "is-size-5 is-sticky-table-head has-text-weight-semibold has-background-white	": $setup.isLarge,
                "is-sticky-table-head has-background-white	": !$setup.isLarge
            })
        }, [
            $setup.props.abbreviation ? ((0, $4mYx6.openBlock)(), (0, $4mYx6.createElementBlock)("abbr", {
                key: 0,
                title: $setup.props.name
            }, (0, $a5gC8.toDisplayString)($setup.props.abbreviation), 9, $5166720209413ef5$var$_hoisted_2)) : (0, $4mYx6.createCommentVNode)("", true),
            !$setup.props.abbreviation ? ((0, $4mYx6.openBlock)(), (0, $4mYx6.createElementBlock)("span", $5166720209413ef5$var$_hoisted_3, (0, $a5gC8.toDisplayString)($setup.props.name), 1)) : (0, $4mYx6.createCommentVNode)("", true)
        ], 2),
        ((0, $4mYx6.openBlock)(true), (0, $4mYx6.createElementBlock)((0, $4mYx6.Fragment), null, (0, $4mYx6.renderList)($props.values, (entry)=>{
            return (0, $4mYx6.openBlock)(), (0, $4mYx6.createElementBlock)("td", {
                class: (0, $a5gC8.normalizeClass)({
                    "is-size-5 has-text-weight-semibold is-family-monospace has-text-right has-background-white	": $setup.isLarge,
                    "is-family-monospace pl-4 has-text-right has-background-white	": !$setup.isLarge
                })
            }, (0, $a5gC8.toDisplayString)($props.format(entry[$props.indicator])), 3);
        }), 256))
    ]);
}

});

parcelRegister("6UfnH", function(module, exports) {

$parcel$export(module.exports, "default", () => $5073e771eb5061dc$export$2e2bcd8739ae039);
let $5073e771eb5061dc$var$NOOP = ()=>{};
var $5073e771eb5061dc$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("2VIlt", function(module, exports) {

$parcel$export(module.exports, "render", () => $22234db76d666e85$export$b3890eb0ae9dca99);
parcelRequire("giao7");
var $4mYx6 = parcelRequire("4mYx6");
const $22234db76d666e85$var$_hoisted_1 = {
    class: "table is-hoverable"
};
const $22234db76d666e85$var$_hoisted_2 = [
    "innerHTML"
];
function $22234db76d666e85$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $4mYx6.openBlock)(), (0, $4mYx6.createElementBlock)("table", $22234db76d666e85$var$_hoisted_1, [
        (0, $4mYx6.createElementVNode)("thead", null, [
            (0, $4mYx6.createElementVNode)("tr", null, [
                _cache[0] || (_cache[0] = (0, $4mYx6.createElementVNode)("th", {
                    class: "is-sticky-table-head"
                }, null, -1)),
                ((0, $4mYx6.openBlock)(true), (0, $4mYx6.createElementBlock)((0, $4mYx6.Fragment), null, (0, $4mYx6.renderList)($setup.visibleTimeSeries, (entry)=>{
                    return (0, $4mYx6.openBlock)(), (0, $4mYx6.createElementBlock)("th", {
                        key: entry.id,
                        innerHTML: $setup.formatName(entry, "<br/>")
                    }, null, 8, $22234db76d666e85$var$_hoisted_2);
                }), 128))
            ])
        ]),
        (0, $4mYx6.createElementVNode)("tbody", null, [
            ((0, $4mYx6.openBlock)(), (0, $4mYx6.createElementBlock)((0, $4mYx6.Fragment), null, (0, $4mYx6.renderList)($setup.indicators, (indicator)=>{
                return (0, $4mYx6.createVNode)($setup["PerformanceTableRow"], (0, $4mYx6.mergeProps)({
                    ref_for: true
                }, indicator, {
                    values: $setup.visibleTimeSeries
                }), null, 16, [
                    "values"
                ]);
            }), 64))
        ])
    ]);
}

});

parcelRegister("339Pe", function(module, exports) {

$parcel$export(module.exports, "default", () => $238946035a39ab48$export$2e2bcd8739ae039);
let $238946035a39ab48$var$NOOP = ()=>{};
var $238946035a39ab48$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("4srbL", function(module, exports) {

$parcel$export(module.exports, "default", () => $33eede156d04a3c3$export$2e2bcd8739ae039);
/**
 * @param {String} name
 * @returns {String[]}
 */ var $33eede156d04a3c3$export$2e2bcd8739ae039 = (name)=>new URLSearchParams(window.location.search).getAll(name);

});


parcelRegister("4bIoP", function(module, exports) {

$parcel$export(module.exports, "render", () => $30caa14f07857e05$export$b3890eb0ae9dca99);
parcelRequire("giao7");
var $4mYx6 = parcelRequire("4mYx6");
const $30caa14f07857e05$var$_hoisted_1 = {
    key: 2,
    class: "section"
};
const $30caa14f07857e05$var$_hoisted_2 = {
    class: "container"
};
const $30caa14f07857e05$var$_hoisted_3 = {
    key: 3,
    class: "section"
};
const $30caa14f07857e05$var$_hoisted_4 = {
    class: "columns"
};
const $30caa14f07857e05$var$_hoisted_5 = {
    class: "column is-narrow"
};
const $30caa14f07857e05$var$_hoisted_6 = {
    class: "scroll-container mr-6"
};
const $30caa14f07857e05$var$_hoisted_7 = {
    class: "is-sticky"
};
const $30caa14f07857e05$var$_hoisted_8 = {
    class: "column performance-container"
};
const $30caa14f07857e05$var$_hoisted_9 = {
    class: "box mb-6"
};
const $30caa14f07857e05$var$_hoisted_10 = {
    class: "box performance-table-container"
};
const $30caa14f07857e05$var$_hoisted_11 = {
    class: "box"
};
const $30caa14f07857e05$var$_hoisted_12 = {
    class: "section"
};
const $30caa14f07857e05$var$_hoisted_13 = {
    class: "container"
};
function $30caa14f07857e05$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $4mYx6.openBlock)(), (0, $4mYx6.createBlock)($setup["FileDropHandler"], {
        "time-series-collection": $setup.timeSeriesCollection,
        onFileUploaded: _cache[3] || (_cache[3] = ($event)=>$setup.updateAddSeriesBoxVisibility(false))
    }, {
        default: (0, $4mYx6.withCtx)(()=>[
                $setup.currentModalContent === "disclaimer" ? ((0, $4mYx6.openBlock)(), (0, $4mYx6.createBlock)($setup["Disclaimer"], {
                    key: 0,
                    onCloseOverlay: _cache[0] || (_cache[0] = ($event)=>$setup.setModalContent(null))
                })) : (0, $4mYx6.createCommentVNode)("", true),
                $setup.notifications.getAll().length > 0 ? ((0, $4mYx6.openBlock)(), (0, $4mYx6.createBlock)($setup["Notifications"], {
                    key: 1
                })) : (0, $4mYx6.createCommentVNode)("", true),
                (0, $4mYx6.createVNode)($setup["DataFetcher"], {
                    "time-series-collection": $setup.timeSeriesCollection,
                    "file-urls": $setup.fileURLs
                }, null, 8, [
                    "time-series-collection",
                    "file-urls"
                ]),
                $setup.isAddSeriesBoxVisible ? ((0, $4mYx6.openBlock)(), (0, $4mYx6.createElementBlock)("div", $30caa14f07857e05$var$_hoisted_1, [
                    (0, $4mYx6.createElementVNode)("div", $30caa14f07857e05$var$_hoisted_2, [
                        (0, $4mYx6.createVNode)($setup["AddSeriesBox"], {
                            "time-series-collection": $setup.timeSeriesCollection,
                            "is-add-series-box-visible": $setup.isAddSeriesBoxVisible,
                            onFileUrlAdded: $setup.handleFileURLAdded,
                            onFileUploaded: _cache[1] || (_cache[1] = ($event)=>$setup.updateAddSeriesBoxVisibility(false)),
                            onChangeAddSeriesBoxVisibility: $setup.updateAddSeriesBoxVisibility
                        }, null, 8, [
                            "time-series-collection",
                            "is-add-series-box-visible"
                        ])
                    ])
                ])) : (0, $4mYx6.createCommentVNode)("", true),
                $setup.timeSeriesCollection.timeSeries.length > 0 ? ((0, $4mYx6.openBlock)(), (0, $4mYx6.createElementBlock)("div", $30caa14f07857e05$var$_hoisted_3, [
                    (0, $4mYx6.createElementVNode)("div", $30caa14f07857e05$var$_hoisted_4, [
                        (0, $4mYx6.createElementVNode)("div", $30caa14f07857e05$var$_hoisted_5, [
                            (0, $4mYx6.createElementVNode)("div", $30caa14f07857e05$var$_hoisted_6, [
                                (0, $4mYx6.createElementVNode)("div", $30caa14f07857e05$var$_hoisted_7, [
                                    _cache[4] || (_cache[4] = (0, $4mYx6.createElementVNode)("h1", {
                                        class: "title"
                                    }, " \xa0 ", -1)),
                                    (0, $4mYx6.createVNode)($setup["TimeSeriesList"], {
                                        "time-series": $setup.timeSeriesCollection.timeSeries,
                                        "is-add-series-box-visible": $setup.isAddSeriesBoxVisible,
                                        "from-date": $setup.fromDate,
                                        "to-date": $setup.toDate,
                                        "onUpdate:fromDate": $setup.handleUpdateFromDate,
                                        "onUpdate:toDate": $setup.handleUpdateToDate,
                                        onChangeAddSeriesBoxVisibility: $setup.updateAddSeriesBoxVisibility
                                    }, null, 8, [
                                        "time-series",
                                        "is-add-series-box-visible",
                                        "from-date",
                                        "to-date"
                                    ])
                                ])
                            ])
                        ]),
                        (0, $4mYx6.createElementVNode)("div", $30caa14f07857e05$var$_hoisted_8, [
                            _cache[5] || (_cache[5] = (0, $4mYx6.createElementVNode)("h1", {
                                class: "title"
                            }, " Tear Sheet ", -1)),
                            (0, $4mYx6.createElementVNode)("div", $30caa14f07857e05$var$_hoisted_9, [
                                (0, $4mYx6.createVNode)($setup["PerformanceChart"], {
                                    "time-series": $setup.timeSeriesCollection.timeSeries
                                }, null, 8, [
                                    "time-series"
                                ])
                            ]),
                            (0, $4mYx6.createElementVNode)("div", $30caa14f07857e05$var$_hoisted_10, [
                                (0, $4mYx6.createVNode)($setup["PerformanceTable"], {
                                    "time-series": $setup.timeSeriesCollection.timeSeries
                                }, null, 8, [
                                    "time-series"
                                ])
                            ]),
                            (0, $4mYx6.createElementVNode)("div", $30caa14f07857e05$var$_hoisted_11, [
                                (0, $4mYx6.createVNode)($setup["HeatMap"], {
                                    "time-series-collection": $setup.timeSeriesCollection
                                }, null, 8, [
                                    "time-series-collection"
                                ])
                            ])
                        ])
                    ])
                ])) : (0, $4mYx6.createCommentVNode)("", true),
                (0, $4mYx6.createElementVNode)("div", $30caa14f07857e05$var$_hoisted_12, [
                    (0, $4mYx6.createElementVNode)("div", $30caa14f07857e05$var$_hoisted_13, [
                        (0, $4mYx6.createElementVNode)("button", {
                            class: "button",
                            onClick: _cache[2] || (_cache[2] = ($event)=>$setup.setModalContent("disclaimer"))
                        }, " Disclaimer ")
                    ])
                ])
            ]),
        _: 1
    }, 8, [
        "time-series-collection"
    ]);
}

});

parcelRegister("gtCvB", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfed39d05ddec883$export$2e2bcd8739ae039);
let $bfed39d05ddec883$var$NOOP = ()=>{};
var $bfed39d05ddec883$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire("giao7");
var $5on3n = parcelRequire("5on3n");
let $f1c5bfbbdf19d8f8$var$script;



let $f1c5bfbbdf19d8f8$var$initialize = ()=>{
    $f1c5bfbbdf19d8f8$var$script = (parcelRequire("6G2cC"));
    if ($f1c5bfbbdf19d8f8$var$script.__esModule) $f1c5bfbbdf19d8f8$var$script = $f1c5bfbbdf19d8f8$var$script.default;
    $f1c5bfbbdf19d8f8$var$script.render = (parcelRequire("4bIoP")).render;
    (parcelRequire("gtCvB")).default($f1c5bfbbdf19d8f8$var$script);
    $f1c5bfbbdf19d8f8$var$script.__scopeId = "data-v-e32fde";
    $f1c5bfbbdf19d8f8$var$script.__file = "App.vue";
};
$f1c5bfbbdf19d8f8$var$initialize();
var $f1c5bfbbdf19d8f8$export$2e2bcd8739ae039 = $f1c5bfbbdf19d8f8$var$script;


// WTF: https://github.com/parcel-bundler/parcel/issues/6628
globalThis.__VUE_OPTIONS_API__ = false;
globalThis.__VUE_PROD_DEVTOOLS__ = false;
globalThis.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
const $cce441f391c24306$var$app = (0, $5on3n.createApp)((0, $f1c5bfbbdf19d8f8$export$2e2bcd8739ae039));
$cce441f391c24306$var$app.config.errorHandler = (err, instance, info)=>{
    console.error("Global error:", err);
    console.error("Vue instance:", instance);
    console.error("Error info:", info);
};
$cce441f391c24306$var$app.mount("#app");


//# sourceMappingURL=index.fac77d66.js.map
